(function(
	userConfig,
	defaultConfig
){
	// summary:
	//		This is the "source loader" and is the entry point for Dojo during development. You may also load Dojo with
	//		any AMD-compliant loader via the package main module dojo/main.
	// description:
	//		This is the "source loader" for Dojo. It provides an AMD-compliant loader that can be configured
	//		to operate in either synchronous or asynchronous modes. After the loader is defined, dojo is loaded
	//		IAW the package main module dojo/main. In the event you wish to use a foreign loader, you may load dojo as a package
	//		via the package main module dojo/main and this loader is not required; see dojo/package.json for details.
	//
	//		In order to keep compatibility with the v1.x line, this loader includes additional machinery that enables
	//		the dojo.provide, dojo.require et al API. This machinery is loaded by default, but may be dynamically removed
	//		via the has.js API and statically removed via the build system.
	//
	//		This loader includes sniffing machinery to determine the environment; the following environments are supported:
	//
	//		- browser
	//		- node.js
	//		- rhino
	//
	//		This is the so-called "source loader". As such, it includes many optional features that may be discarded by
	//		building a customized version with the build system.

	// Design and Implementation Notes
	//
	// This is a dojo-specific adaption of bdLoad, donated to the dojo foundation by Altoviso LLC.
	//
	// This function defines an AMD-compliant (http://wiki.commonjs.org/wiki/Modules/AsynchronousDefinition)
	// loader that can be configured to operate in either synchronous or asynchronous modes.
	//
	// Since this machinery implements a loader, it does not have the luxury of using a load system and/or
	// leveraging a utility library. This results in an unpleasantly long file; here is a road map of the contents:
	//
	//	 1. Small library for use implementing the loader.
	//	 2. Define the has.js API; this is used throughout the loader to bracket features.
	//	 3. Define the node.js and rhino sniffs and sniff.
	//	 4. Define the loader's data.
	//	 5. Define the configuration machinery.
	//	 6. Define the script element sniffing machinery and sniff for configuration data.
	//	 7. Configure the loader IAW the provided user, default, and sniffing data.
	//	 8. Define the global require function.
	//	 9. Define the module resolution machinery.
	//	10. Define the module and plugin module definition machinery
	//	11. Define the script injection machinery.
	//	12. Define the window load detection.
	//	13. Define the logging API.
	//	14. Define the tracing API.
	//	16. Define the AMD define function.
	//	17. Define the dojo v1.x provide/require machinery--so called "legacy" modes.
	//	18. Publish global variables.
	//
	// Language and Acronyms and Idioms
	//
	// moduleId: a CJS module identifier, (used for public APIs)
	// mid: moduleId (used internally)
	// packageId: a package identifier (used for public APIs)
	// pid: packageId (used internally); the implied system or default package has pid===""
	// pack: package is used internally to reference a package object (since javascript has reserved words including "package")
	// prid: plugin resource identifier
	// The integer constant 1 is used in place of true and 0 in place of false.
	//
	// The "foreign-loader" has condition is defined if another loader is being used (e.g. webpack) and this code is only
	// needed for resolving module identifiers based on the config.  In this case, only the functions require.toUrl and 
	// require.toAbsMid are supported.  The require and define functions are not supported.

	// define global
	var globalObject = (function(){
		if (typeof global !== 'undefined' && typeof global !== 'function') {
			// global spec defines a reference to the global object called 'global'
			// https://github.com/tc39/proposal-global
			// `global` is also defined in NodeJS
			return global;
		}
		else if (typeof window !== 'undefined') {
			// window is defined in browsers
			return window;
		}
		else if (typeof self !== 'undefined') {
			// self is defined in WebWorkers
			return self;
		}
		return this;
	})();

	// define a minimal library to help build the loader
	var noop = function(){
		},

		isEmpty = function(it){
			for(var p in it){
				return 0;
			}
			return 1;
		},

		toString = {}.toString,

		isFunction = function(it){
			return toString.call(it) == "[object Function]";
		},

		isString = function(it){
			return toString.call(it) == "[object String]";
		},

		isArray = function(it){
			return toString.call(it) == "[object Array]";
		},

		forEach = function(vector, callback){
			if(vector){
				for(var i = 0; i < vector.length;){
					callback(vector[i++]);
				}
			}
		},

		mix = function(dest, src){
			for(var p in src){
				dest[p] = src[p];
			}
			return dest;
		},

		makeError = function(error, info){
			return mix(new Error(error), {src:"dojoLoader", info:info});
		},

		uidSeed = 1,

		uid = function(){
			// Returns a unique identifier (within the lifetime of the document) of the form /_d+/.
			return "_" + uidSeed++;
		},

		// FIXME: how to doc window.require() api

		// this will be the global require function; define it immediately so we can start hanging things off of it
		req = function(
			config,		  //(object, optional) hash of configuration properties
			dependencies, //(array of commonjs.moduleId, optional) list of modules to be loaded before applying callback
			callback	  //(function, optional) lambda expression to apply to module values implied by dependencies
		){
			return contextRequire(config, dependencies, callback, 0, req);
		},

		// the loader uses the has.js API to control feature inclusion/exclusion; define then use throughout
		global = globalObject,

		doc = global.document,

		element = doc && doc.createElement("DiV"),

		has = req.has = function(name){
			return isFunction(hasCache[name]) ? (hasCache[name] = hasCache[name](global, doc, element)) : hasCache[name];
		},

		hasCache = has.cache = defaultConfig.hasCache;

	if (isFunction(userConfig)) {
		userConfig = userConfig(globalObject);
	}

	has.add = function(name, test, now, force){
		(hasCache[name]===undefined || force) && (hasCache[name] = test);
		return now && has(name);
	};

	 0 && has.add("host-node", userConfig.has && "host-node" in userConfig.has ?
		userConfig.has["host-node"] :
		(typeof process == "object" && process.versions && process.versions.node && process.versions.v8));
	if( 0 ){
		// fixup the default config for node.js environment
		require("./_base/configNode.js").config(defaultConfig);
		// remember node's require (with respect to baseUrl==dojo's root)
		defaultConfig.loaderPatch.nodeRequire = require;
	}

	 0 && has.add("host-rhino", userConfig.has && "host-rhino" in userConfig.has ?
		userConfig.has["host-rhino"] :
		(typeof load == "function" && (typeof Packages == "function" || typeof Packages == "object")));
	if( 0 ){
		// owing to rhino's lame feature that hides the source of the script, give the user a way to specify the baseUrl...
		for(var baseUrl = userConfig.baseUrl || ".", arg, rhinoArgs = this.arguments, i = 0; i < rhinoArgs.length;){
			arg = (rhinoArgs[i++] + "").split("=");
			if(arg[0] == "baseUrl"){
				baseUrl = arg[1];
				break;
			}
		}
		load(baseUrl + "/_base/configRhino.js");
		rhinoDojoConfig(defaultConfig, baseUrl, rhinoArgs);
	}

	has.add("host-webworker", ((typeof WorkerGlobalScope !== 'undefined') && (self instanceof WorkerGlobalScope)));
	if(has("host-webworker")){
		mix(defaultConfig.hasCache, {
			"host-browser": 0,
			"dom": 0,
			"dojo-dom-ready-api": 0,
			"dojo-sniff": 0,
			"dojo-inject-api": 1,
			"host-webworker": 1,
			"dojo-guarantee-console": 0 // console is immutable in FF30+, see https://bugs.dojotoolkit.org/ticket/18100
		});

		defaultConfig.loaderPatch = {
			injectUrl: function(url, callback){
				// TODO:
				//		This is not async, nor can it be in Webworkers.  It could be made better by passing
				//		the entire require array into importScripts at.  This way the scripts are loaded in
				//		async mode; even if the callbacks are ran in sync.  It is not a major issue as webworkers
				//		tend to be long running where initial startup is not a major factor.

				try{
					importScripts(url);
					callback();
				}catch(e){
					console.info("failed to load resource (" + url + ")");
					console.error(e);
				}
			}
		};
	}

	// userConfig has tests override defaultConfig has tests; do this after the environment detection because
	// the environment detection usually sets some has feature values in the hasCache.
	for(var p in userConfig.has){
		has.add(p, userConfig.has[p], 0, 1);
	}

	//
	// define the loader data
	//

	// the loader will use these like symbols if the loader has the traceApi; otherwise
	// define magic numbers so that modules can be provided as part of defaultConfig
	var requested = 1,
		arrived = 2,
		nonmodule = 3,
		executing = 4,
		executed = 5;

	if( 0 ){
		// these make debugging nice; but using strings for symbols is a gross rookie error; don't do it for production code
		requested = "requested";
		arrived = "arrived";
		nonmodule = "not-a-module";
		executing = "executing";
		executed = "executed";
	}

	var legacyMode = 0,
		sync = "sync",
		xd = "xd",
		syncExecStack = [],
		dojoRequirePlugin = 0,
		checkDojoRequirePlugin = noop,
		transformToAmd = noop,
		getXhr;
	if( 0 ){
		req.isXdUrl = noop;

		req.initSyncLoader = function(dojoRequirePlugin_, checkDojoRequirePlugin_, transformToAmd_){
			// the first dojo/_base/loader loaded gets to define these variables; they are designed to work
			// in the presence of zero to many mapped dojo/_base/loaders
			if(!dojoRequirePlugin){
				dojoRequirePlugin = dojoRequirePlugin_;
				checkDojoRequirePlugin = checkDojoRequirePlugin_;
				transformToAmd = transformToAmd_;
			}

			return {
				sync:sync,
				requested:requested,
				arrived:arrived,
				nonmodule:nonmodule,
				executing:executing,
				executed:executed,
				syncExecStack:syncExecStack,
				modules:modules,
				execQ:execQ,
				getModule:getModule,
				injectModule:injectModule,
				setArrived:setArrived,
				signal:signal,
				finishExec:finishExec,
				execModule:execModule,
				dojoRequirePlugin:dojoRequirePlugin,
				getLegacyMode:function(){return legacyMode;},
				guardCheckComplete:guardCheckComplete
			};
		};

		if( 1  || has("host-webworker")){
			// in legacy sync mode, the loader needs a minimal XHR library

			var locationProtocol = location.protocol,
				locationHost = location.host;
			req.isXdUrl = function(url){
				if(/^\./.test(url)){
					// begins with a dot is always relative to page URL; therefore not xdomain
					return false;
				}
				if(/^\/\//.test(url)){
					// for v1.6- backcompat, url starting with // indicates xdomain
					return true;
				}
				// get protocol and host
				// \/+ takes care of the typical file protocol that looks like file:///drive/path/to/file
				// locationHost is falsy if file protocol => if locationProtocol matches and is "file:", || will return false
				var match = url.match(/^([^\/\:]+\:)\/+([^\/]+)/);
				return match && (match[1] != locationProtocol || (locationHost && match[2] != locationHost));
			};


			// note: to get the file:// protocol to work in FF, you must set security.fileuri.strict_origin_policy to false in about:config
			 1 || has.add("dojo-xhr-factory", 1);
			has.add("dojo-force-activex-xhr",  1  && !doc.addEventListener && window.location.protocol == "file:");
			has.add("native-xhr", typeof XMLHttpRequest != "undefined");
			if(has("native-xhr") && !has("dojo-force-activex-xhr")){
				getXhr = function(){
					return new XMLHttpRequest();
				};
			}else{
				// if in the browser an old IE; find an xhr
				for(var XMLHTTP_PROGIDS = ['Msxml2.XMLHTTP', 'Microsoft.XMLHTTP', 'Msxml2.XMLHTTP.4.0'], progid, i = 0; i < 3;){
					try{
						progid = XMLHTTP_PROGIDS[i++];
						if(new ActiveXObject(progid)){
							// this progid works; therefore, use it from now on
							break;
						}
					}catch(e){
						// squelch; we're just trying to find a good ActiveX progid
						// if they all fail, then progid ends up as the last attempt and that will signal the error
						// the first time the client actually tries to exec an xhr
					}
				}
				getXhr = function(){
					return new ActiveXObject(progid);
				};
			}
			req.getXhr = getXhr;

			has.add("dojo-gettext-api", 1);
			req.getText = function(url, async, onLoad){
				var xhr = getXhr();
				xhr.open('GET', fixupUrl(url), false);
				xhr.send(null);
				if(xhr.status == 200 || (!location.host && !xhr.status)){
					if(onLoad){
						onLoad(xhr.responseText, async);
					}
				}else{
					throw makeError("xhrFailed", xhr.status);
				}
				return xhr.responseText;
			};
		}
	}else{
		req.async = 1;
	}

	//
	// loader eval
	//
	var eval_ =  has("csp-restrictions") ?
		// noop eval if there are csp restrictions
		function(){} :
		// use the function constructor so our eval is scoped close to (but not in) in the global space with minimal pollution
		new Function('return eval(arguments[0]);');

	req.eval =
		function(text, hint){
			return eval_(text + "\r\n//# sourceURL=" + hint);
		};

	//
	// loader micro events API
	//
	var listenerQueues = {},
		error = "error",
		signal = req.signal = function(type, args){
			var queue = listenerQueues[type];
			// notice we run a copy of the queue; this allows listeners to add/remove
			// other listeners without affecting this particular signal
			forEach(queue && queue.slice(0), function(listener){
				listener.apply(null, isArray(args) ? args : [args]);
			});
		},
		on = req.on = function(type, listener){
			// notice a queue is not created until a client actually connects
			var queue = listenerQueues[type] || (listenerQueues[type] = []);
			queue.push(listener);
			return {
				remove:function(){
					for(var i = 0; i<queue.length; i++){
						if(queue[i]===listener){
							queue.splice(i, 1);
							return;
						}
					}
				}
			};
		};

	// configuration machinery; with an optimized/built defaultConfig, all configuration machinery can be discarded
	// lexical variables hold key loader data structures to help with minification; these may be completely,
	// one-time initialized by defaultConfig for optimized/built versions
	var
		aliases
			// a vector of pairs of [regexs or string, replacement] => (alias, actual)
			= [],

		paths
			// CommonJS paths
			= {},

		pathsMapProg
			// list of (from-path, to-path, regex, length) derived from paths;
			// a "program" to apply paths; see computeMapProg
			= [],

		packs
			// a map from packageId to package configuration object; see fixupPackageInfo
			= {},

		map = req.map
			// AMD map config variable; dojo/_base/kernel needs req.map to figure out the scope map
			= {},

		mapProgs
			// vector of quads as described by computeMapProg; map-key is AMD map key, map-value is AMD map value
			= [],

		modules
			// A hash:(mid) --> (module-object) the module namespace
			//
			// pid: the package identifier to which the module belongs (e.g., "dojo"); "" indicates the system or default package
			// mid: the fully-resolved (i.e., mappings have been applied) module identifier without the package identifier (e.g., "dojo/io/script")
			// url: the URL from which the module was retrieved
			// pack: the package object of the package to which the module belongs
			// executed: 0 => not executed; executing => in the process of traversing deps and running factory; executed => factory has been executed
			// deps: the dependency vector for this module (vector of modules objects)
			// def: the factory for this module
			// result: the result of the running the factory for this module
			// injected: (0 | requested | arrived) the status of the module; nonmodule means the resource did not call define
			// load: plugin load function; applicable only for plugins
			//
			// Modules go through several phases in creation:
			//
			// 1. Requested: some other module's definition or a require application contained the requested module in
			//	  its dependency vector or executing code explicitly demands a module via req.require.
			//
			// 2. Injected: a script element has been appended to the insert-point element demanding the resource implied by the URL
			//
			// 3. Loaded: the resource injected in [2] has been evaluated.
			//
			// 4. Defined: the resource contained a define statement that advised the loader about the module. Notice that some
			//	  resources may just contain a bundle of code and never formally define a module via define
			//
			// 5. Evaluated: the module was defined via define and the loader has evaluated the factory and computed a result.
			= {},

		cacheBust
			// query string to append to module URLs to bust browser cache
			= "",

		cache
			// hash:(mid | url)-->(function | string)
			//
			// A cache of resources. The resources arrive via a config.cache object, which is a hash from either mid --> function or
			// url --> string. The url key is distinguished from the mid key by always containing the prefix "url:". url keys as provided
			// by config.cache always have a string value that represents the contents of the resource at the given url. mid keys as provided
			// by configl.cache always have a function value that causes the same code to execute as if the module was script injected.
			//
			// Both kinds of key-value pairs are entered into cache via the function consumePendingCache, which may relocate keys as given
			// by any mappings *iff* the config.cache was received as part of a module resource request.
			//
			// Further, for mid keys, the implied url is computed and the value is entered into that key as well. This allows mapped modules
			// to retrieve cached items that may have arrived consequent to another namespace.
			//
			 = {},

		urlKeyPrefix
			// the prefix to prepend to a URL key in the cache.
			= "url:",

		pendingCacheInsert
			// hash:(mid)-->(function)
			//
			// Gives a set of cache modules pending entry into cache. When cached modules are published to the loader, they are
			// entered into pendingCacheInsert; modules are then pressed into cache upon (1) AMD define or (2) upon receiving another
			// independent set of cached modules. (1) is the usual case, and this case allows normalizing mids given in the pending
			// cache for the local configuration, possibly relocating modules.
			 = {},

		dojoSniffConfig
			// map of configuration variables
			// give the data-dojo-config as sniffed from the document (if any)
			= {},

		insertPointSibling
			// the nodes used to locate where scripts are injected into the document
			= 0;

	if( 1 ){
		if (!has("foreign-loader")) {
			var consumePendingCacheInsert = function(referenceModule, clear){
					clear = clear !== false;
					var p, item, match, now, m;
					for(p in pendingCacheInsert){
						item = pendingCacheInsert[p];
						match = p.match(/^url\:(.+)/);
						if(match){
							cache[urlKeyPrefix + toUrl(match[1], referenceModule)] =  item;
						}else if(p=="*now"){
							now = item;
						}else if(p!="*noref"){
							m = getModuleInfo(p, referenceModule, true);
							cache[m.mid] = cache[urlKeyPrefix + m.url] = item;
						}
					}
					if(now){
						now(createRequire(referenceModule));
					}
					if(clear){
						pendingCacheInsert = {};
					}
				};
		}
		var escapeString = function(s){
				return s.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, function(c){ return "\\" + c; });
			},

			computeMapProg = function(map, dest){
				// This routine takes a map as represented by a JavaScript object and initializes dest, a vector of
				// quads of (map-key, map-value, refex-for-map-key, length-of-map-key), sorted decreasing by length-
				// of-map-key. The regex looks for the map-key followed by either "/" or end-of-string at the beginning
				// of a the search source. Notice the map-value is irrelevant to the algorithm
				dest.splice(0, dest.length);
				for(var p in map){
					dest.push([
						p,
						map[p],
						new RegExp("^" + escapeString(p) + "(\/|$)"),
						p.length]);
				}
				dest.sort(function(lhs, rhs){ return rhs[3] - lhs[3]; });
				return dest;
			},

			computeAliases = function(config, dest){
				forEach(config, function(pair){
					// take a fixed-up copy...
					dest.push([isString(pair[0]) ? new RegExp("^" + escapeString(pair[0]) + "$") : pair[0], pair[1]]);
				});
			},


			fixupPackageInfo = function(packageInfo){
				// calculate the precise (name, location, main, mappings) for a package
				var name = packageInfo.name;
				if(!name){
					// packageInfo must be a string that gives the name
					name = packageInfo;
					packageInfo = {name:name};
				}
				packageInfo = mix({main:"main"}, packageInfo);
				packageInfo.location = packageInfo.location ? packageInfo.location : name;

				// packageMap is deprecated in favor of AMD map
				if(packageInfo.packageMap){
					map[name] = packageInfo.packageMap;
				}

				if(!packageInfo.main.indexOf("./")){
					packageInfo.main = packageInfo.main.substring(2);
				}

				// now that we've got a fully-resolved package object, push it into the configuration
				packs[name] = packageInfo;
			},

			delayedModuleConfig
				// module config cannot be consumed until the loader is completely initialized; therefore, all
				// module config detected during booting is memorized and applied at the end of loader initialization
				// TODO: this is a bit of a kludge; all config should be moved to end of loader initialization, but
				// we'll delay this chore and do it with a final loader 1.x cleanup after the 2.x loader prototyping is complete
				= [],


			config = function(config, booting, referenceModule){
				for(var p in config){
					if(p=="waitSeconds"){
						req.waitms = (config[p] || 0) * 1000;
					}
					if(p=="cacheBust"){
						cacheBust = config[p] ? (isString(config[p]) ? config[p] : (new Date()).getTime() + "") : "";
					}
					if(p=="baseUrl" || p=="combo"){
						req[p] = config[p];
					}
					if( 0  && p=="async"){
						// falsy or "sync" => legacy sync loader
						// "xd" => sync but loading xdomain tree and therefore loading asynchronously (not configurable, set automatically by the loader)
						// "legacyAsync" => permanently in "xd" by choice
						// "debugAtAllCosts" => trying to load everything via script injection (not implemented)
						// otherwise, must be truthy => AMD
						// legacyMode: sync | legacyAsync | xd | false
						var mode = config[p];
						req.legacyMode = legacyMode = (isString(mode) && /sync|legacyAsync/.test(mode) ? mode : (!mode ? sync : false));
						req.async = !legacyMode;
					}
					if(config[p]!==hasCache){
						// accumulate raw config info for client apps which can use this to pass their own config
						req.rawConfig[p] = config[p];
						p!="has" && has.add("config-"+p, config[p], 0, booting);
					}
				}

				// make sure baseUrl exists
				if(!req.baseUrl){
					req.baseUrl = "./";
				}
				// make sure baseUrl ends with a slash
				if(!/\/$/.test(req.baseUrl)){
					req.baseUrl += "/";
				}

				// now do the special work for has, packages, packagePaths, paths, aliases, and cache

				for(p in config.has){
					has.add(p, config.has[p], 0, booting);
				}

				// for each package found in any packages config item, augment the packs map owned by the loader
				forEach(config.packages, fixupPackageInfo);

				// for each packagePath found in any packagePaths config item, augment the packageConfig
				// packagePaths is deprecated; remove in 2.0
				for(var baseUrl in config.packagePaths){
					forEach(config.packagePaths[baseUrl], function(packageInfo){
						var location = baseUrl + "/" + packageInfo;
						if(isString(packageInfo)){
							packageInfo = {name:packageInfo};
						}
						packageInfo.location = location;
						fixupPackageInfo(packageInfo);
					});
				}

				// notice that computeMapProg treats the dest as a reference; therefore, if/when that variable
				// is published (see dojo-publish-privates), the published variable will always hold a valid value.

				// this must come after all package processing since package processing may mutate map
				computeMapProg(mix(map, config.map), mapProgs);
				forEach(mapProgs, function(item){
					item[1] = computeMapProg(item[1], []);
					if(item[0]=="*"){
						mapProgs.star = item;
					}
				});

				// push in any paths and recompute the internal pathmap
				computeMapProg(mix(paths, config.paths), pathsMapProg);

				// aliases
				computeAliases(config.aliases, aliases);

				if (!has("foreign-loader")) {
					if(booting){
						delayedModuleConfig.push({config:config.config});
					}else{
						for(p in config.config){
							var module = getModule(p, referenceModule);
							module.config = mix(module.config || {}, config.config[p]);
						}
					}

					// push in any new cache values
					if(config.cache){
						consumePendingCacheInsert();
						pendingCacheInsert = config.cache;
						//inject now all depencies so cache is available for mapped module
						consumePendingCacheInsert(0, !!config.cache["*noref"]);
					}
				}
				signal("config", [config, req.rawConfig]);
			};

		//
		// execute the various sniffs; userConfig can override and value
		//

		if(has("dojo-cdn") ||  1 ){
			// the sniff regex looks for a src attribute ending in dojo.js, optionally preceded with a path.
			// match[3] returns the path to dojo.js (if any) without the trailing slash. This is used for the
			// dojo location on CDN deployments and baseUrl when either/both of these are not provided
			// explicitly in the config data; this is the 1.6- behavior.

			var scripts = doc.getElementsByTagName("script"),
				i = 0,
				script, dojoDir, src, match;
			while(i < scripts.length){
				script = scripts[i++];
				if((src = script.getAttribute("src")) && (match = src.match(/(((.*)\/)|^)dojo\.js(\W|$)/i))){
					// sniff dojoDir and baseUrl
					dojoDir = match[3] || "";
					defaultConfig.baseUrl = defaultConfig.baseUrl || dojoDir;

					// remember an insertPointSibling
					insertPointSibling = script;
				}

				// sniff configuration on attribute in script element
				if((src = (script.getAttribute("data-dojo-config") || script.getAttribute("djConfig")))){
					dojoSniffConfig = req.eval("({ " + src + " })", "data-dojo-config");

					// remember an insertPointSibling
					insertPointSibling = script;
				}

				// sniff requirejs attribute
				if( 0 ){
					if((src = script.getAttribute("data-main"))){
						dojoSniffConfig.deps = dojoSniffConfig.deps || [src];
					}
				}
			}
		}

		if( 0 ){
			// pass down doh.testConfig from parent as if it were a data-dojo-config
			try{
				if(window.parent != window && window.parent.require){
					var doh = window.parent.require("doh");
					doh && mix(dojoSniffConfig, doh.testConfig);
				}
			}catch(e){}
		}

		// configure the loader; let the user override defaults
		req.rawConfig = {};
		config(defaultConfig, 1);

		// do this before setting userConfig/sniffConfig to allow userConfig/sniff overrides
		if(has("dojo-cdn")){
			packs.dojo.location = dojoDir;
			if(dojoDir){
				dojoDir += "/";
			}
			packs.dijit.location = dojoDir + "../dijit/";
			packs.dojox.location = dojoDir + "../dojox/";
		}

		config(userConfig, 1);
		config(dojoSniffConfig, 1);

	}else{
		// no config API, assume defaultConfig has everything the loader needs...for the entire lifetime of the application
		paths = defaultConfig.paths;
		pathsMapProg = defaultConfig.pathsMapProg;
		packs = defaultConfig.packs;
		aliases = defaultConfig.aliases;
		mapProgs = defaultConfig.mapProgs;
		modules = defaultConfig.modules;
		cache = defaultConfig.cache;
		cacheBust = defaultConfig.cacheBust;

		// remember the default config for other processes (e.g., dojo/config)
		req.rawConfig = defaultConfig;
	}


	if (!has("foreign-loader")) {
		if( 0 ){
			req.combo = req.combo || {add:noop};
			var comboPending = 0,
				combosPending = [],
				comboPendingTimer = null;
		}
		

		// build the loader machinery iaw configuration, including has feature tests
		var injectDependencies = function(module){
				// checkComplete!=0 holds the idle signal; we're not idle if we're injecting dependencies
				guardCheckComplete(function(){
					forEach(module.deps, injectModule);
					if( 0  && comboPending && !comboPendingTimer){
						comboPendingTimer = setTimeout(function() {
							comboPending = 0;
							comboPendingTimer = null;
							req.combo.done(function(mids, url) {
								var onLoadCallback= function(){
									// defQ is a vector of module definitions 1-to-1, onto mids
									runDefQ(0, mids);
									checkComplete();
								};
								combosPending.push(mids);
								injectingModule = mids;
								req.injectUrl(url, onLoadCallback, mids);
								injectingModule = 0;
							}, req);
						}, 0);
					}
				});
			},

			contextRequire = function(a1, a2, a3, referenceModule, contextRequire){
				var module, syntheticMid;
				if(isString(a1)){
					// signature is (moduleId)
					module = getModule(a1, referenceModule, true);
					if(module && module.executed){
						return module.result;
					}
					throw makeError("undefinedModule", a1);
				}
				if(!isArray(a1)){
					// a1 is a configuration
					config(a1, 0, referenceModule);

					// juggle args; (a2, a3) may be (dependencies, callback)
					a1 = a2;
					a2 = a3;
				}
				if(isArray(a1)){
					// signature is (requestList [,callback])
					if(!a1.length){
						a2 && a2();
					}else{
						syntheticMid = "require*" + uid();

						// resolve the request list with respect to the reference module
						for(var mid, deps = [], i = 0; i < a1.length;){
							mid = a1[i++];
							deps.push(getModule(mid, referenceModule));
						}

						// construct a synthetic module to control execution of the requestList, and, optionally, callback
						module = mix(makeModuleInfo("", syntheticMid, 0, ""), {
							injected: arrived,
							deps: deps,
							def: a2 || noop,
							require: referenceModule ? referenceModule.require : req,
							gc: 1 //garbage collect
						});
						modules[module.mid] = module;

						// checkComplete!=0 holds the idle signal; we're not idle if we're injecting dependencies
						injectDependencies(module);

						// try to immediately execute
						// if already traversing a factory tree, then strict causes circular dependency to abort the execution; maybe
						// it's possible to execute this require later after the current traversal completes and avoid the circular dependency.
						// ...but *always* insist on immediate in synch mode
						var strict = checkCompleteGuard && legacyMode!=sync;
						guardCheckComplete(function(){
							execModule(module, strict);
						});
						if(!module.executed){
							// some deps weren't on board or circular dependency detected and strict; therefore, push into the execQ
							execQ.push(module);
						}
						checkComplete();
					}
				}
				return contextRequire;
			},

			createRequire = function(module){
				if(!module){
					return req;
				}
				var result = module.require;
				if(!result){
					result = function(a1, a2, a3){
						return contextRequire(a1, a2, a3, module, result);
					};
					module.require = mix(result, req);
					result.module = module;
					result.toUrl = function(name){
						return toUrl(name, module);
					};
					result.toAbsMid = function(mid){
						return toAbsMid(mid, module);
					};
					if( 0 ){
						result.undef = function(mid){
							req.undef(mid, module);
						};
					}
					if( 0 ){
						result.syncLoadNls = function(mid){
							var nlsModuleInfo = getModuleInfo(mid, module),
								nlsModule = modules[nlsModuleInfo.mid];
							if(!nlsModule || !nlsModule.executed){
								cached = cache[nlsModuleInfo.mid] || cache[urlKeyPrefix + nlsModuleInfo.url];
								if(cached){
									evalModuleText(cached);
									nlsModule = modules[nlsModuleInfo.mid];
								}
							}
							return nlsModule && nlsModule.executed && nlsModule.result;
						};
					}

				}
				return result;
			},

		  execQ =
				// The list of modules that need to be evaluated.
				[],

			defQ =
				// The queue of define arguments sent to loader.
				[],

			waiting =
				// The set of modules upon which the loader is waiting for definition to arrive
				{},

			setRequested = function(module){
				module.injected = requested;
				waiting[module.mid] = 1;
				if(module.url){
					waiting[module.url] = module.pack || 1;
				}
				startTimer();
			},

			setArrived = function(module){
				module.injected = arrived;
				delete waiting[module.mid];
				if(module.url){
					delete waiting[module.url];
				}
				if(isEmpty(waiting)){
					clearTimer();
					 0  && legacyMode==xd && (legacyMode = sync);
				}
			},

			execComplete = req.idle =
				// says the loader has completed (or not) its work
				function(){
					return !defQ.length && isEmpty(waiting) && !execQ.length && !checkCompleteGuard;
				};
	}

	var runMapProg = function(targetMid, map){
			// search for targetMid in map; return the map item if found; falsy otherwise
			if(map){
			for(var i = 0; i < map.length; i++){
				if(map[i][2].test(targetMid)){
					return map[i];
				}
			}
			}
			return 0;
		},

		compactPath = function(path){
			var result = [],
				segment, lastSegment;
			path = path.replace(/\\/g, '/').split('/');
			while(path.length){
				segment = path.shift();
				if(segment==".." && result.length && lastSegment!=".."){
					result.pop();
					lastSegment = result[result.length - 1];
				}else if(segment!="."){
					result.push(lastSegment= segment);
				} // else ignore "."
			}
			return result.join("/");
		},

		makeModuleInfo = function(pid, mid, pack, url){
			if( 0 ){
				var xd= req.isXdUrl(url);
				return {pid:pid, mid:mid, pack:pack, url:url, executed:0, def:0, isXd:xd, isAmd:!!(xd || (packs[pid] && packs[pid].isAmd))};
			}else{
				return {pid:pid, mid:mid, pack:pack, url:url, executed:0, def:0};
			}
		},

		getModuleInfo_ = function(mid, referenceModule, packs, modules, baseUrl, mapProgs, pathsMapProg, aliases, alwaysCreate, fromPendingCache){
			// arguments are passed instead of using lexical variables so that this function my be used independent of the loader (e.g., the builder)
			// alwaysCreate is useful in this case so that getModuleInfo never returns references to real modules owned by the loader
			var pid, pack, midInPackage, mapItem, url, result, isRelative, requestedMid;
			requestedMid = mid;
			isRelative = /^\./.test(mid);
			if(/(^\/)|(\:)|(\.js$)/.test(mid) || (isRelative && !referenceModule)){
				// absolute path or protocol of .js filetype, or relative path but no reference module and therefore relative to page
				// whatever it is, it's not a module but just a URL of some sort
				// note: pid===0 indicates the routine is returning an unmodified mid

				return makeModuleInfo(0, mid, 0, mid);
			}else{
				// relative module ids are relative to the referenceModule; get rid of any dots
				mid = compactPath(isRelative ? (referenceModule.mid + "/../" + mid) : mid);
				if(/^\./.test(mid)){
					throw makeError("irrationalPath", mid);
				}
				// at this point, mid is an absolute mid

				// map the mid
				if(!fromPendingCache && !isRelative && mapProgs.star){
					mapItem = runMapProg(mid, mapProgs.star[1]);
				}
				if(!mapItem && referenceModule){
					mapItem = runMapProg(referenceModule.mid, mapProgs);
					mapItem = mapItem && runMapProg(mid, mapItem[1]);
				}

				if(mapItem){
					mid = mapItem[1] + mid.substring(mapItem[3]);
					}

				match = mid.match(/^([^\/]+)(\/(.+))?$/);
				pid = match ? match[1] : "";
				if((pack = packs[pid])){
					mid = pid + "/" + (midInPackage = (match[3] || pack.main));
				}else{
					pid = "";
				}

				// search aliases
				var candidateLength = 0,
					candidate = 0;
				forEach(aliases, function(pair){
					var match = mid.match(pair[0]);
					if(match && match.length>candidateLength){
						candidate = isFunction(pair[1]) ? mid.replace(pair[0], pair[1]) : pair[1];
					}
				});
				if(candidate){
					return getModuleInfo_(candidate, 0, packs, modules, baseUrl, mapProgs, pathsMapProg, aliases, alwaysCreate);
				}

				result = modules[mid];
				if(result){
					return alwaysCreate ? makeModuleInfo(result.pid, result.mid, result.pack, result.url) : modules[mid];
				}
			}
			// get here iff the sought-after module does not yet exist; therefore, we need to compute the URL given the
			// fully resolved (i.e., all relative indicators and package mapping resolved) module id

			// note: pid!==0 indicates the routine is returning a url that has .js appended unmodified mid
			mapItem = runMapProg(mid, pathsMapProg);
			if(mapItem){
				url = mapItem[1] + mid.substring(mapItem[3]);
			}else if(pid){
				url = (pack.location.slice(-1) === '/' ? pack.location.slice(0, -1) : pack.location) + "/" + midInPackage;
			}else if( 0 ){
				url = "../" + mid;
			}else{
				url = mid;
			}
			// if result is not absolute, add baseUrl
			if(!(/(^\/)|(\:)/.test(url))){
				url = baseUrl + url;
			}
			url += ".js";
			return makeModuleInfo(pid, mid, pack, compactPath(url));
		},

		getModuleInfo = function(mid, referenceModule, fromPendingCache){
			return getModuleInfo_(mid, referenceModule, packs, modules, req.baseUrl, mapProgs, pathsMapProg, aliases, undefined, fromPendingCache);
		};

	if (!has("foreign-loader")) {
		var resolvePluginResourceId = function(plugin, prid, referenceModule){
				return plugin.normalize ? plugin.normalize(prid, function(mid){return toAbsMid(mid, referenceModule);}) : toAbsMid(prid, referenceModule);
			},

			dynamicPluginUidGenerator = 0,

			getModule = function(mid, referenceModule, immediate){
				// compute and optionally construct (if necessary) the module implied by the mid with respect to referenceModule
				var match, plugin, prid, result;
				match = mid.match(/^(.+?)\!(.*)$/);
				if(match){
					// name was <plugin-module>!<plugin-resource-id>
					plugin = getModule(match[1], referenceModule, immediate);

					if( 0  && legacyMode == sync && !plugin.executed){
						injectModule(plugin);
						if(plugin.injected===arrived && !plugin.executed){
							guardCheckComplete(function(){
								execModule(plugin);
							});
						}
						if(plugin.executed){
							promoteModuleToPlugin(plugin);
						}else{
							// we are in xdomain mode for some reason
							execQ.unshift(plugin);
						}
					}



					if(plugin.executed === executed && !plugin.load){
						// executed the module not knowing it was a plugin
						promoteModuleToPlugin(plugin);
					}

					// if the plugin has not been loaded, then can't resolve the prid and  must assume this plugin is dynamic until we find out otherwise
					if(plugin.load){
						prid = resolvePluginResourceId(plugin, match[2], referenceModule);
						mid = (plugin.mid + "!" + (plugin.dynamic ? ++dynamicPluginUidGenerator + "!" : "") + prid);
					}else{
						prid = match[2];
						mid = plugin.mid + "!" + (++dynamicPluginUidGenerator) + "!waitingForPlugin";
					}
					result = {plugin:plugin, mid:mid, req:createRequire(referenceModule), prid:prid};
				}else{
					result = getModuleInfo(mid, referenceModule);
				}
				return modules[result.mid] || (!immediate && (modules[result.mid] = result));
			};
	}

	var toAbsMid = req.toAbsMid = function(mid, referenceModule){
			return getModuleInfo(mid, referenceModule).mid;
		},

		toUrl = req.toUrl = function(name, referenceModule){
			var moduleInfo = getModuleInfo(name+"/x", referenceModule),
				url= moduleInfo.url;
			return fixupUrl(moduleInfo.pid===0 ?
				// if pid===0, then name had a protocol or absolute path; either way, toUrl is the identify function in such cases
				name :
				// "/x.js" since getModuleInfo automatically appends ".js" and we appended "/x" to make name look like a module id
				url.substring(0, url.length-5)
			);
		};

	if (!has("foreign-loader")) {
		var nonModuleProps = {
				injected: arrived,
				executed: executed,
				def: nonmodule,
				result: nonmodule
			},

			makeCjs = function(mid){
				return modules[mid] = mix({mid:mid}, nonModuleProps);
			},

			cjsRequireModule = makeCjs("require"),
			cjsExportsModule = makeCjs("exports"),
			cjsModuleModule = makeCjs("module"),

			runFactory = function(module, args){
				req.trace("loader-run-factory", [module.mid]);
				var factory = module.def,
					result;
				 0  && syncExecStack.unshift(module);
				if( 0 ){
					try{
						result= isFunction(factory) ? factory.apply(null, args) : factory;
					}catch(e){
						signal(error, module.result = makeError("factoryThrew", [module, e]));
					}
				}else{
					result= isFunction(factory) ? factory.apply(null, args) : factory;
				}
				module.result = result===undefined && module.cjs ? module.cjs.exports : result;
				 0  && syncExecStack.shift(module);
			},

			abortExec = {},

			defOrder = 0,

			promoteModuleToPlugin = function(pluginModule){
				var plugin = pluginModule.result;
				pluginModule.dynamic = plugin.dynamic;
				pluginModule.normalize = plugin.normalize;
				pluginModule.load = plugin.load;
				return pluginModule;
			},

			resolvePluginLoadQ = function(plugin){
				// plugins is a newly executed module that has a loadQ waiting to run

				// step 1: traverse the loadQ and fixup the mid and prid; remember the map from original mid to new mid
				// recall the original mid was created before the plugin was on board and therefore it was impossible to
				// compute the final mid; accordingly, prid may or may not change, but the mid will definitely change
				var map = {};
				forEach(plugin.loadQ, function(pseudoPluginResource){
					// manufacture and insert the real module in modules
					var prid = resolvePluginResourceId(plugin, pseudoPluginResource.prid, pseudoPluginResource.req.module),
						mid = plugin.dynamic ? pseudoPluginResource.mid.replace(/waitingForPlugin$/, prid) : (plugin.mid + "!" + prid),
						pluginResource = mix(mix({}, pseudoPluginResource), {mid:mid, prid:prid, injected:0});
					if(!modules[mid] || !modules[mid].injected /*for require.undef*/){
						// create a new (the real) plugin resource and inject it normally now that the plugin is on board
						injectPlugin(modules[mid] = pluginResource);
					} // else this was a duplicate request for the same (plugin, rid) for a nondynamic plugin

					// pluginResource is really just a placeholder with the wrong mid (because we couldn't calculate it until the plugin was on board)
					// mark is as arrived and delete it from modules; the real module was requested above
					map[pseudoPluginResource.mid] = modules[mid];
					setArrived(pseudoPluginResource);
					delete modules[pseudoPluginResource.mid];
				});
				plugin.loadQ = 0;

				// step2: replace all references to any placeholder modules with real modules
				var substituteModules = function(module){
					for(var replacement, deps = module.deps || [], i = 0; i<deps.length; i++){
						replacement = map[deps[i].mid];
						if(replacement){
							deps[i] = replacement;
						}
					}
				};
				for(var p in modules){
					substituteModules(modules[p]);
				}
				forEach(execQ, substituteModules);
			},

			finishExec = function(module){
				req.trace("loader-finish-exec", [module.mid]);
				module.executed = executed;
				module.defOrder = defOrder++;
				 0  && forEach(module.provides, function(cb){ cb(); });
				if(module.loadQ){
					// the module was a plugin
					promoteModuleToPlugin(module);
					resolvePluginLoadQ(module);
				}
				// remove all occurrences of this module from the execQ
				for(i = 0; i < execQ.length;){
					if(execQ[i] === module){
						execQ.splice(i, 1);
					}else{
						i++;
					}
				}
				// delete references to synthetic modules
				if (/^require\*/.test(module.mid)) {
					delete modules[module.mid];
				}
			},

			circleTrace = [],

			execModule = function(module, strict){
				// run the dependency vector, then run the factory for module
				if(module.executed === executing){
					req.trace("loader-circular-dependency", [circleTrace.concat(module.mid).join("->")]);
					return (!module.def || strict) ? abortExec :  (module.cjs && module.cjs.exports);
				}
				// at this point the module is either not executed or fully executed


				if(!module.executed){
					if(!module.def){
						return abortExec;
					}
					var mid = module.mid,
						deps = module.deps || [],
						arg, argResult,
						args = [],
						i = 0;

					if( 0 ){
						circleTrace.push(mid);
						req.trace("loader-exec-module", ["exec", circleTrace.length, mid]);
					}

					// for circular dependencies, assume the first module encountered was executed OK
					// modules that circularly depend on a module that has not run its factory will get
					// the pre-made cjs.exports===module.result. They can take a reference to this object and/or
					// add properties to it. When the module finally runs its factory, the factory can
					// read/write/replace this object. Notice that so long as the object isn't replaced, any
					// reference taken earlier while walking the deps list is still valid.
					module.executed = executing;
					while((arg = deps[i++])){
						argResult = ((arg === cjsRequireModule) ? createRequire(module) :
										((arg === cjsExportsModule) ? module.cjs.exports :
											((arg === cjsModuleModule) ? module.cjs :
												execModule(arg, strict))));
						if(argResult === abortExec){
							module.executed = 0;
							req.trace("loader-exec-module", ["abort", mid]);
							 0  && circleTrace.pop();
							return abortExec;
						}
						args.push(argResult);
					}
					runFactory(module, args);
					finishExec(module);
					 0  && circleTrace.pop();
				}
				// at this point the module is guaranteed fully executed

				return module.result;
			},


			checkCompleteGuard = 0,

			guardCheckComplete = function(proc){
				try{
					checkCompleteGuard++;
					proc();
				}catch(e){
					// https://bugs.dojotoolkit.org/ticket/16617
					throw e;
				}finally{
					checkCompleteGuard--;
				}
				if(execComplete()){
					signal("idle", []);
				}
			},

			checkComplete = function(){
				// keep going through the execQ as long as at least one factory is executed
				// plugins, recursion, cached modules all make for many execution path possibilities
				if(checkCompleteGuard){
					return;
				}
				guardCheckComplete(function(){
					checkDojoRequirePlugin();
					for(var currentDefOrder, module, i = 0; i < execQ.length;){
						currentDefOrder = defOrder;
						module = execQ[i];
						execModule(module);
						if(currentDefOrder!=defOrder){
							// defOrder was bumped one or more times indicating something was executed (note, this indicates
							// the execQ was modified, maybe a lot (for example a later module causes an earlier module to execute)
							checkDojoRequirePlugin();
							i = 0;
						}else{
							// nothing happened; check the next module in the exec queue
							i++;
						}
					}
				});
			};
	}

	var fixupUrl= typeof userConfig.fixupUrl == "function" ? userConfig.fixupUrl : function(url){
			url += ""; // make sure url is a Javascript string (some paths may be a Java string)
			return url + (cacheBust ? ((/\?/.test(url) ? "&" : "?") + cacheBust) : "");
		};



	if( 0 ){
		req.undef = function(moduleId, referenceModule){
			// In order to reload a module, it must be undefined (this routine) and then re-requested.
			// This is useful for testing frameworks (at least).
			var module = getModule(moduleId, referenceModule);
			setArrived(module);
			mix(module, {def:0, executed:0, injected:0, node:0, load:0});
		};
	}

	if( 1 ){
		if(has("dojo-loader-eval-hint-url")===undefined){
			has.add("dojo-loader-eval-hint-url", 1);
		}

		var injectPlugin = function(
				module
			){
				// injects the plugin module given by module; may have to inject the plugin itself
				var plugin = module.plugin;

				if(plugin.executed === executed && !plugin.load){
					// executed the module not knowing it was a plugin
					promoteModuleToPlugin(plugin);
				}

				var onLoad = function(def){
						module.result = def;
						setArrived(module);
						finishExec(module);
						checkComplete();
					};

				if(plugin.load){
					plugin.load(module.prid, module.req, onLoad);
				}else if(plugin.loadQ){
					plugin.loadQ.push(module);
				}else{
					// the unshift instead of push is important: we don't want plugins to execute as
					// dependencies of some other module because this may cause circles when the plugin
					// loadQ is run; also, generally, we want plugins to run early since they may load
					// several other modules and therefore can potentially unblock many modules
					plugin.loadQ = [module];
					execQ.unshift(plugin);
					injectModule(plugin);
				}
			},

			// for IE, injecting a module may result in a recursive execution if the module is in the cache

			cached = 0,

			injectingModule = 0,

			injectingCachedModule = 0,

			evalModuleText = function(text, module){
				// see def() for the injectingCachedModule bracket; it simply causes a short, safe circuit
				if(has("config-stripStrict")){
					text = text.replace(/(["'])use strict\1/g, '');
				}
				injectingCachedModule = 1;
				if( 0 ){
					try{
						if(text===cached){
							cached.call(null);
						}else{
							req.eval(text, has("dojo-loader-eval-hint-url") ? module.url : module.mid);
						}
					}catch(e){
						signal(error, makeError("evalModuleThrew", module));
					}
				}else{
					if(text===cached){
						cached.call(null);
					}else{
						req.eval(text, has("dojo-loader-eval-hint-url") ? module.url : module.mid);
					}
				}
				injectingCachedModule = 0;
			},

			injectModule = function(module){
				// Inject the module. In the browser environment, this means appending a script element into
				// the document; in other environments, it means loading a file.
				//
				// If in synchronous mode, then get the module synchronously if it's not xdomainLoading.

				var mid = module.mid,
					url = module.url;
				if(module.executed || module.injected || waiting[mid] || (module.url && ((module.pack && waiting[module.url]===module.pack) || waiting[module.url]==1))){
					return;
				}
				setRequested(module);

				if( 0 ){
					var viaCombo = 0;
					if(module.plugin && module.plugin.isCombo){
						// a combo plugin; therefore, must be handled by combo service
						// the prid should have already been converted to a URL (if required by the plugin) during
						// the normalize process; in any event, there is no way for the loader to know how to
						// to the conversion; therefore the third argument is zero
						req.combo.add(module.plugin.mid, module.prid, 0, req);
						viaCombo = 1;
					}else if(!module.plugin){
						viaCombo = req.combo.add(0, module.mid, module.url, req);
					}
					if(viaCombo){
						comboPending= 1;
						return;
					}
				}

				if(module.plugin){
					injectPlugin(module);
					return;
				} // else a normal module (not a plugin)


				var onLoadCallback = function(){
					runDefQ(module);
					if(module.injected !== arrived){
						// the script that contained the module arrived and has been executed yet
						// nothing was added to the defQ (so it wasn't an AMD module) and the module
						// wasn't marked as arrived by dojo.provide (so it wasn't a v1.6- module);
						// therefore, it must not have been a module; adjust state accordingly
						if(has("dojo-enforceDefine")){
							signal(error, makeError("noDefine", module));
							return;
						}
						setArrived(module);
						mix(module, nonModuleProps);
						req.trace("loader-define-nonmodule", [module.url]);
					}

					if( 0  && legacyMode){
						// must call checkComplete even in for sync loader because we may be in xdomainLoading mode;
						// but, if xd loading, then don't call checkComplete until out of the current sync traversal
						// in order to preserve order of execution of the dojo.required modules
						!syncExecStack.length && checkComplete();
					}else{
						checkComplete();
					}
				};
				cached = cache[mid] || cache[urlKeyPrefix + module.url];
				if(cached){
					req.trace("loader-inject", ["cache", module.mid, url]);
					evalModuleText(cached, module);
					onLoadCallback();
					return;
				}
				if( 0  && legacyMode){
					if(module.isXd){
						// switch to async mode temporarily; if current legacyMode!=sync, then is must be one of {legacyAsync, xd, false}
						legacyMode==sync && (legacyMode = xd);
						// fall through and load via script injection
					}else if(module.isAmd && legacyMode!=sync){
						// fall through and load via script injection
					}else{
						// mode may be sync, xd/legacyAsync, or async; module may be AMD or legacy; but module is always located on the same domain
						var xhrCallback = function(text){
							if(legacyMode==sync){
								// the top of syncExecStack gives the current synchronously executing module; the loader needs
								// to know this if it has to switch to async loading in the middle of evaluating a legacy module
								// this happens when a modules dojo.require's a module that must be loaded async because it's xdomain
								// (using unshift/shift because there is no back() methods for Javascript arrays)
								syncExecStack.unshift(module);
								evalModuleText(text, module);
								syncExecStack.shift();

								// maybe the module was an AMD module
								runDefQ(module);

								// legacy modules never get to defineModule() => cjs and injected never set; also evaluation implies executing
								if(!module.cjs){
									setArrived(module);
									finishExec(module);
								}

								if(module.finish){
									// while synchronously evaluating this module, dojo.require was applied referencing a module
									// that had to be loaded async; therefore, the loader stopped answering all dojo.require
									// requests so they could be answered completely in the correct sequence; module.finish gives
									// the list of dojo.requires that must be re-applied once all target modules are available;
									// make a synthetic module to execute the dojo.require's in the correct order

									// compute a guaranteed-unique mid for the synthetic finish module; remember the finish vector; remove it from the reference module
									// TODO: can we just leave the module.finish...what's it hurting?
									var finishMid = mid + "*finish",
										finish = module.finish;
									delete module.finish;

									def(finishMid, ["dojo", ("dojo/require!" + finish.join(",")).replace(/\./g, "/")], function(dojo){
										forEach(finish, function(mid){ dojo.require(mid); });
									});
									// unshift, not push, which causes the current traversal to be reattempted from the top
									execQ.unshift(getModule(finishMid));
								}
								onLoadCallback();
							}else{
								text = transformToAmd(module, text);
								if(text){
									evalModuleText(text, module);
									onLoadCallback();
								}else{
									// if transformToAmd returned falsy, then the module was already AMD and it can be script-injected
									// do so to improve debugability(even though it means another download...which probably won't happen with a good browser cache)
									injectingModule = module;
									req.injectUrl(fixupUrl(url), onLoadCallback, module);
									injectingModule = 0;
								}
							}
						};

						req.trace("loader-inject", ["xhr", module.mid, url, legacyMode!=sync]);
						if( 0 ){
							try{
								req.getText(url, legacyMode!=sync, xhrCallback);
							}catch(e){
								signal(error, makeError("xhrInjectFailed", [module, e]));
							}
						}else{
							req.getText(url, legacyMode!=sync, xhrCallback);
						}
						return;
					}
				} // else async mode or fell through in xdomain loading mode; either way, load by script injection
				req.trace("loader-inject", ["script", module.mid, url]);
				injectingModule = module;
				req.injectUrl(fixupUrl(url), onLoadCallback, module);
				injectingModule = 0;
			},

			defineModule = function(module, deps, def){
				req.trace("loader-define-module", [module.mid, deps]);

				if( 0  && module.plugin && module.plugin.isCombo){
					// the module is a plugin resource loaded by the combo service
					// note: check for module.plugin should be enough since normal plugin resources should
					// not follow this path; module.plugin.isCombo is future-proofing belt and suspenders
					module.result = isFunction(def) ? def() : def;
					setArrived(module);
					finishExec(module);
					return module;
				}

				var mid = module.mid;
				if(module.injected === arrived){
					signal(error, makeError("multipleDefine", module));
					return module;
				}
				mix(module, {
					deps: deps,
					def: def,
					cjs: {
						id: module.mid,
						uri: module.url,
						exports: (module.result = {}),
						setExports: function(exports){
							module.cjs.exports = exports;
						},
						config:function(){
							return module.config;
						}
					}
				});

				// resolve deps with respect to this module
				for(var i = 0; deps[i]; i++){
					deps[i] = getModule(deps[i], module);
				}

				if( 0  && legacyMode && !waiting[mid]){
					// the module showed up without being asked for; it was probably in a <script> element
					injectDependencies(module);
					execQ.push(module);
					checkComplete();
				}
				setArrived(module);

				if(!isFunction(def) && !deps.length){
					module.result = def;
					finishExec(module);
				}

				return module;
			},

			runDefQ = function(referenceModule, mids){
				// defQ is an array of [id, dependencies, factory]
				// mids (if any) is a vector of mids given by a combo service
				var definedModules = [],
					module, args;
				while(defQ.length){
					args = defQ.shift();
					mids && (args[0]= mids.shift());
					// explicit define indicates possible multiple modules in a single file; delay injecting dependencies until defQ fully
					// processed since modules earlier in the queue depend on already-arrived modules that are later in the queue
					// TODO: what if no args[0] and no referenceModule
					module = (args[0] && getModule(args[0])) || referenceModule;
					definedModules.push([module, args[1], args[2]]);
				}
				consumePendingCacheInsert(referenceModule);
				forEach(definedModules, function(args){
					injectDependencies(defineModule.apply(null, args));
				});
			};
	}

	var timerId = 0,
		clearTimer = noop,
		startTimer = noop;
	if( 0 ){
		// Timer machinery that monitors how long the loader is waiting and signals an error when the timer runs out.
		clearTimer = function(){
			timerId && clearTimeout(timerId);
			timerId = 0;
		};

		startTimer = function(){
			clearTimer();
			if(req.waitms){
				timerId = global.setTimeout(function(){
					clearTimer();
					signal(error, makeError("timeout", waiting));
				}, req.waitms);
			}
		};
	}

	if ( 1 ) {
		// Test for IE's different way of signaling when scripts finish loading.  Note that according to
		// http://bugs.dojotoolkit.org/ticket/15096#comment:14, IE9 also needs to follow the
		// IE specific code path even though it has an addEventListener() method.
		// Unknown if special path needed on IE10+, which also has a document.attachEvent() method.
		// Should evaluate to false for Opera and Windows 8 apps, even though they document.attachEvent()
		//  is defined in both those environments.
		has.add("ie-event-behavior", doc.attachEvent && typeof Windows === "undefined" &&
			(typeof opera === "undefined" || opera.toString() != "[object Opera]"));
	}

	if( 1  && ( 1  ||  1 )){
		var domOn = function(node, eventName, ieEventName, handler){
				// Add an event listener to a DOM node using the API appropriate for the current browser;
				// return a function that will disconnect the listener.
				if(!has("ie-event-behavior")){
					node.addEventListener(eventName, handler, false);
					return function(){
						node.removeEventListener(eventName, handler, false);
					};
				}else{
					node.attachEvent(ieEventName, handler);
					return function(){
						node.detachEvent(ieEventName, handler);
					};
				}
			},
			windowOnLoadListener = domOn(window, "load", "onload", function(){
				req.pageLoaded = 1;
				// https://bugs.dojotoolkit.org/ticket/16248
				try{
					doc.readyState!="complete" && (doc.readyState = "complete");
				}catch(e){
				}
				windowOnLoadListener();
			});

		if( 1 ){
			// if the loader is on the page, there must be at least one script element
			// getting its parent and then doing insertBefore solves the "Operation Aborted"
			// error in IE from appending to a node that isn't properly closed; see
			// dojo/tests/_base/loader/requirejs/simple-badbase.html for an example
			// don't use scripts with type dojo/... since these may be removed; see #15809
			// prefer to use the insertPoint computed during the config sniff in case a script is removed; see #16958
			var scripts = doc.getElementsByTagName("script"),
				i = 0,
				script;
			while(!insertPointSibling){
				if(!/^dojo/.test((script = scripts[i++]) && script.type)){
					insertPointSibling= script;
				}
			}

			req.injectUrl = function(url, callback, owner){
				// insert a script element to the insert-point element with src=url;
				// apply callback upon detecting the script has loaded.

				var node = owner.node = doc.createElement("script"),
					onLoad = function(e){
						e = e || window.event;
						var node = e.target || e.srcElement;
						if(e.type === "load" || /complete|loaded/.test(node.readyState)){
							loadDisconnector();
							errorDisconnector();
							callback && callback();
						}
					},
					loadDisconnector = domOn(node, "load", "onreadystatechange", onLoad),
					errorDisconnector = domOn(node, "error", "onerror", function(e){
						loadDisconnector();
						errorDisconnector();
						signal(error, makeError("scriptError: " + url, [url, e]));
					});

				node.type = "text/javascript";
				node.charset = "utf-8";
				node.src = url;
				insertPointSibling.parentNode.insertBefore(node, insertPointSibling);
				return node;
			};
		}
	}

	if( 0 ){
		req.log = function(){
			try{
				for(var i = 0; i < arguments.length; i++){
					console.log(arguments[i]);
				}
			}catch(e){}
		};
	}else{
		req.log = noop;
	}

	if( 0 ){
		var trace = req.trace = function(
			group,	// the trace group to which this application belongs
			args	// the contents of the trace
		){
			///
			// Tracing interface by group.
			//
			// Sends the contents of args to the console iff (req.trace.on && req.trace[group])

			if(trace.on && trace.group[group]){
				signal("trace", [group, args]);
				for(var arg, dump = [], text= "trace:" + group + (args.length ? (":" + args[0]) : ""), i= 1; i<args.length;){
					arg = args[i++];
					if(isString(arg)){
						text += ", " + arg;
					}else{
						dump.push(arg);
					}
				}
				req.log(text);
				dump.length && dump.push(".");
				req.log.apply(req, dump);
			}
		};
		mix(trace, {
			on:1,
			group:{},
			set:function(group, value){
				if(isString(group)){
					trace.group[group]= value;
				}else{
					mix(trace.group, group);
				}
			}
		});
		trace.set(mix(mix(mix({}, defaultConfig.trace), userConfig.trace), dojoSniffConfig.trace));
		on("config", function(config){
			config.trace && trace.set(config.trace);
		});
	}else{
		req.trace = noop;
	}
	if (!has("foreign-loader")) {
		var def = function(
			mid,		  //(commonjs.moduleId, optional)
			dependencies, //(array of commonjs.moduleId, optional) list of modules to be loaded before running factory
			factory		  //(any)
		){
			///
			// Advises the loader of a module factory. //Implements http://wiki.commonjs.org/wiki/Modules/AsynchronousDefinition.
			///
			//note
			// CommonJS factory scan courtesy of http://requirejs.org

			var arity = arguments.length,
				defaultDeps = ["require", "exports", "module"],
				// the predominate signature...
				args = [0, mid, dependencies];
			if(arity==1){
				args = [0, (isFunction(mid) ? defaultDeps : []), mid];
			}else if(arity==2 && isString(mid)){
				args = [mid, (isFunction(dependencies) ? defaultDeps : []), dependencies];
			}else if(arity==3){
				args = [mid, dependencies, factory];
			}

			if( 0  && args[1]===defaultDeps){
				args[2].toString()
					.replace(/(\/\*([\s\S]*?)\*\/|\/\/(.*)$)/mg, "")
					.replace(/require\(["']([\w\!\-_\.\/]+)["']\)/g, function(match, dep){
					args[1].push(dep);
				});
			}

			req.trace("loader-define", args.slice(0, 2));
			var targetModule = args[0] && getModule(args[0]),
				module;
			if(targetModule && !waiting[targetModule.mid]){
				// given a mid that hasn't been requested; therefore, defined through means other than injecting
				// consequent to a require() or define() application; examples include defining modules on-the-fly
				// due to some code path or including a module in a script element. In any case,
				// there is no callback waiting to finish processing and nothing to trigger the defQ and the
				// dependencies are never requested; therefore, do it here.
				injectDependencies(defineModule(targetModule, args[1], args[2]));
			}else if(!has("ie-event-behavior") || ! 1  || injectingCachedModule){
				// not IE path: anonymous module and therefore must have been injected; therefore, onLoad will fire immediately
				// after script finishes being evaluated and the defQ can be run from that callback to detect the module id
				defQ.push(args);
			}else{
				// IE path: possibly anonymous module and therefore injected; therefore, cannot depend on 1-to-1,
				// in-order exec of onLoad with script eval (since it's IE) and must manually detect here
				targetModule = targetModule || injectingModule;
				if(!targetModule){
					for(mid in waiting){
						module = modules[mid];
						if(module && module.node && module.node.readyState === 'interactive'){
							targetModule = module;
							break;
						}
					}
					if( 0  && !targetModule){
						for(var i = 0; i<combosPending.length; i++){
							targetModule = combosPending[i];
							if(targetModule.node && targetModule.node.readyState === 'interactive'){
								break;
							}
							targetModule= 0;
						}
					}
				}
				if( 0  && isArray(targetModule)){
					injectDependencies(defineModule(getModule(targetModule.shift()), args[1], args[2]));
					if(!targetModule.length){
						combosPending.splice(i, 1);
					}
				}else if(targetModule){
					consumePendingCacheInsert(targetModule);
					injectDependencies(defineModule(targetModule, args[1], args[2]));
				}else{
					signal(error, makeError("ieDefineFailed", args[0]));
				}
				checkComplete();
			}
		};
		def.amd = {
			vendor:"dojotoolkit.org"
		};

		if( 0 ){
			req.def = def;
		}
	} else {
		var def = noop;
	}
	// allow config to override default implementation of named functions; this is useful for
	// non-browser environments, e.g., overriding injectUrl, getText, log, etc. in node.js, Rhino, etc.
	// also useful for testing and monkey patching loader
	mix(mix(req, defaultConfig.loaderPatch), userConfig.loaderPatch);

	// now that req is fully initialized and won't change, we can hook it up to the error signal
	on(error, function(arg){
		try{
			console.error(arg);
			if(arg instanceof Error){
				for(var p in arg){
					console.log(p + ":", arg[p]);
				}
				console.log(".");
			}
		}catch(e){}
	});

	// always publish these
	mix(req, {
		uid:uid,
		cache:cache,
		packs:packs
	});


	if( 0 ){
		mix(req, {
			// these may be interesting to look at when debugging
			paths:paths,
			aliases:aliases,
			modules:modules,
			legacyMode:legacyMode,
			execQ:execQ,
			defQ:defQ,
			waiting:waiting,

			// these are used for testing
			// TODO: move testing infrastructure to a different has feature
			packs:packs,
			mapProgs:mapProgs,
			pathsMapProg:pathsMapProg,
			listenerQueues:listenerQueues,

			// these are used by the builder (at least)
			computeMapProg:computeMapProg,
			computeAliases:computeAliases,
			runMapProg:runMapProg,
			compactPath:compactPath,
			getModuleInfo:getModuleInfo_
		});
	}

	// the loader can be defined exactly once; look for global define which is the symbol AMD loaders are
	// *required* to define (as opposed to require, which is optional)
	if(global.define){
		if( 0 ){
			signal(error, makeError("defineAlreadyDefined", 0));
		}
		return;
	}else{
		global.define = def;
		global.require = req;
		if( 0 ){
			require = req;
		}
	}

	if( 0  && req.combo && req.combo.plugins){
		var plugins = req.combo.plugins,
			pluginName;
		for(pluginName in plugins){
			mix(mix(getModule(pluginName), plugins[pluginName]), {isCombo:1, executed:"executed", load:1});
		}
	}

	if( 1  && !has("foreign-loader")){
		forEach(delayedModuleConfig, function(c){ config(c); });
		var bootDeps = dojoSniffConfig.deps ||	userConfig.deps || defaultConfig.deps,
			bootCallback = dojoSniffConfig.callback || userConfig.callback || defaultConfig.callback;
		req.boot = (bootDeps || bootCallback) ? [bootDeps || [], bootCallback] : 0;
	}
	if(! 1 ){
		!req.async && req(["dojo"]);
		req.boot && req.apply(null, req.boot);
	}
})
(function(global){ return global.dojoConfig || global.djConfig || global.require || {}; }, {
		async:1,
		hasCache:{
				'config-selectorEngine':"lite",
				'config-tlmSiblingOfDojo':1,
				'dojo-built':1,
				'dojo-loader':1,
				dom:1,
				'host-browser':1
		},
		packages:[
				{
					 location:".",
					 name:"dojo"
				},
				{
					 location:"../dijit",
					 name:"dijit"
				},
				{
					 location:"../dojox",
					 name:"dojox"
				},
				{
					 location:"../lodash",
					 main:"lodash",
					 name:"lodash"
				},
				{
					 location:"../backbone",
					 main:"backbone",
					 name:"backbone"
				},
				{
					 location:"../dagre",
					 main:"dagre",
					 name:"dagre"
				},
				{
					 location:"../jointjs",
					 name:"jointjs"
				},
				{
					 location:"../springy",
					 name:"springy"
				},
				{
					 location:"../jquery",
					 main:"jquery",
					 name:"jquery"
				},
				{
					 location:"../jquery-ui",
					 main:"jquery-ui",
					 name:"jquery-ui"
				},
				{
					 location:"../featherlight",
					 name:"featherlight"
				},
				{
					 location:"../animejs",
					 name:"animejs"
				},
				{
					 location:"../gridx",
					 main:"Grid",
					 name:"gridx"
				},
				{
					 location:"../dbootstrap",
					 name:"dbootstrap"
				},
				{
					 location:"../xstyle",
					 name:"xstyle"
				},
				{
					 location:"../preview",
					 name:"preview"
				},
				{
					 location:"../put-selector",
					 main:"put",
					 name:"put-selector"
				},
				{
					 location:"../jshint",
					 name:"jshint"
				},
				{
					 location:"../csslint",
					 name:"csslint"
				},
				{
					 location:"../handlebars",
					 name:"handlebars"
				},
				{
					 location:"../handlebars4",
					 name:"handlebars4"
				},
				{
					 location:"../highlight",
					 name:"highlight"
				},
				{
					 location:"../robust-websocket",
					 name:"robust-websocket"
				},
				{
					 location:"../chartjs",
					 name:"chartjs"
				},
				{
					 location:"../timescheduler",
					 name:"timescheduler"
				},
				{
					 location:"../mjml",
					 name:"mjml"
				},
				{
					 location:"../moment",
					 main:"moment",
					 name:"moment"
				},
				{
					 location:"../moment-timezone",
					 main:"moment-timezone",
					 name:"moment-timezone"
				},
				{
					 location:"../moment-timezone-utils",
					 main:"moment-timezone-utils",
					 name:"moment-timezone-utils"
				},
				{
					 location:"../sheetjs",
					 name:"sheetjs"
				},
				{
					 location:"../papaparse",
					 name:"papaparse"
				},
				{
					 location:"../clndr",
					 name:"clndr"
				},
				{
					 location:"../loadimage",
					 name:"loadimage"
				},
				{
					 location:"../vue",
					 name:"vue"
				},
				{
					 location:"../jsignature",
					 name:"jsignature"
				},
				{
					 location:"../select2",
					 name:"select2"
				},
				{
					 location:"../tom-select",
					 name:"tom-select"
				},
				{
					 location:"../fullcalendar",
					 name:"fullcalendar"
				},
				{
					 location:"../holydate",
					 name:"holydate"
				},
				{
					 location:"../appivo",
					 name:"appivo"
				},
				{
					 location:"../loader",
					 name:"loader"
				},
				{
					 location:"../summernote",
					 name:"summernote"
				},
				{
					 location:"../summernote-cleaner",
					 name:"summernote-cleaner"
				},
				{
					 location:"../jsonlint",
					 name:"jsonlint"
				},
				{
					 location:"../fuse",
					 name:"fuse"
				},
				{
					 location:"../datetimepicker",
					 name:"datetimepicker"
				},
				{
					 location:"../blockly",
					 name:"blockly"
				},
				{
					 location:"../domoutline",
					 name:"domoutline"
				},
				{
					 location:"../fiduswriter",
					 name:"fiduswriter"
				},
				{
					 location:"../jquery-sortable",
					 name:"jquery-sortable"
				},
				{
					 location:"../jquery-contextmenu",
					 name:"jquery-contextmenu"
				},
				{
					 location:"../timeme",
					 name:"timeme"
				},
				{
					 location:"../splitpane",
					 name:"splitpane"
				},
				{
					 location:"../cropper",
					 name:"cropper"
				},
				{
					 location:"../slick",
					 name:"slick"
				},
				{
					 location:"../countdown",
					 name:"countdown"
				},
				{
					 location:"../leaflet",
					 name:"leaflet"
				},
				{
					 location:"../bootstrap-colorpicker",
					 name:"bootstrap-colorpicker"
				},
				{
					 location:"../popmotion",
					 name:"popmotion"
				},
				{
					 location:"../shepherd",
					 name:"shepherd"
				},
				{
					 location:"../flatted",
					 name:"flatted"
				},
				{
					 location:"../instafeed",
					 name:"instafeed"
				},
				{
					 location:"../codebird",
					 name:"codebird"
				},
				{
					 location:"../fancytree",
					 name:"fancytree"
				},
				{
					 location:"../workbox-window",
					 name:"workbox-window"
				},
				{
					 location:"../core-js",
					 name:"core-js"
				},
				{
					 location:"../fabric",
					 name:"fabric"
				},
				{
					 location:"../webfontloader",
					 name:"webfontloader"
				},
				{
					 location:"../tinycolor",
					 name:"tinycolor"
				},
				{
					 location:"../jsonpath",
					 main:"dist/index-umd.js",
					 name:"jsonpath"
				},
				{
					 location:"../ionic",
					 main:"ionic",
					 name:"ionic"
				},
				{
					 location:"../OverlayScrollbars",
					 main:"js/OverlayScrollbars.js",
					 name:"OverlayScrollbars"
				},
				{
					 location:"../stacktrace",
					 name:"stacktrace"
				},
				{
					 location:"../tabulator",
					 name:"tabulator"
				},
				{
					 location:"../fuzzyset",
					 name:"fuzzyset"
				},
				{
					 location:"../sanitize-html",
					 name:"sanitize-html"
				},
				{
					 location:"../popper",
					 main:"popper",
					 name:"popper"
				}
		]
});require({cache:{
'core-js/shim':function(){
/**
 * core-js 2.6.1
 * https://github.com/zloirock/core-js
 * License: http://rock.mit-license.org
 * © 2018 Denis Pushkarev
 */
!function(__e, __g, undefined){
'use strict';
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 129);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var core = __webpack_require__(26);
var hide = __webpack_require__(11);
var redefine = __webpack_require__(12);
var ctx = __webpack_require__(18);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(51)('wks');
var uid = __webpack_require__(33);
var Symbol = __webpack_require__(2).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(20);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(3)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(1);
var IE8_DOM_DEFINE = __webpack_require__(93);
var toPrimitive = __webpack_require__(22);
var dP = Object.defineProperty;

exports.f = __webpack_require__(7) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(23);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(8);
var createDesc = __webpack_require__(32);
module.exports = __webpack_require__(7) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var hide = __webpack_require__(11);
var has = __webpack_require__(14);
var SRC = __webpack_require__(33)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(26).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var fails = __webpack_require__(3);
var defined = __webpack_require__(23);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(47);
var defined = __webpack_require__(23);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(48);
var createDesc = __webpack_require__(32);
var toIObject = __webpack_require__(15);
var toPrimitive = __webpack_require__(22);
var has = __webpack_require__(14);
var IE8_DOM_DEFINE = __webpack_require__(93);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(7) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(14);
var toObject = __webpack_require__(9);
var IE_PROTO = __webpack_require__(68)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(10);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 19 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(3);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(4);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(0);
var core = __webpack_require__(26);
var fails = __webpack_require__(3);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(18);
var IObject = __webpack_require__(47);
var toObject = __webpack_require__(9);
var toLength = __webpack_require__(6);
var asc = __webpack_require__(84);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 26 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(7)) {
  var LIBRARY = __webpack_require__(30);
  var global = __webpack_require__(2);
  var fails = __webpack_require__(3);
  var $export = __webpack_require__(0);
  var $typed = __webpack_require__(62);
  var $buffer = __webpack_require__(92);
  var ctx = __webpack_require__(18);
  var anInstance = __webpack_require__(39);
  var propertyDesc = __webpack_require__(32);
  var hide = __webpack_require__(11);
  var redefineAll = __webpack_require__(41);
  var toInteger = __webpack_require__(20);
  var toLength = __webpack_require__(6);
  var toIndex = __webpack_require__(122);
  var toAbsoluteIndex = __webpack_require__(35);
  var toPrimitive = __webpack_require__(22);
  var has = __webpack_require__(14);
  var classof = __webpack_require__(43);
  var isObject = __webpack_require__(4);
  var toObject = __webpack_require__(9);
  var isArrayIter = __webpack_require__(81);
  var create = __webpack_require__(36);
  var getPrototypeOf = __webpack_require__(17);
  var gOPN = __webpack_require__(37).f;
  var getIterFn = __webpack_require__(83);
  var uid = __webpack_require__(33);
  var wks = __webpack_require__(5);
  var createArrayMethod = __webpack_require__(25);
  var createArrayIncludes = __webpack_require__(52);
  var speciesConstructor = __webpack_require__(50);
  var ArrayIterators = __webpack_require__(86);
  var Iterators = __webpack_require__(45);
  var $iterDetect = __webpack_require__(57);
  var setSpecies = __webpack_require__(38);
  var arrayFill = __webpack_require__(85);
  var arrayCopyWithin = __webpack_require__(110);
  var $DP = __webpack_require__(8);
  var $GOPD = __webpack_require__(16);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(116);
var $export = __webpack_require__(0);
var shared = __webpack_require__(51)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(119))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(33)('meta');
var isObject = __webpack_require__(4);
var has = __webpack_require__(14);
var setDesc = __webpack_require__(8).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(3)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(5)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(11)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 33 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(95);
var enumBugKeys = __webpack_require__(69);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(20);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(1);
var dPs = __webpack_require__(96);
var enumBugKeys = __webpack_require__(69);
var IE_PROTO = __webpack_require__(68)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(66)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(70).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(95);
var hiddenKeys = __webpack_require__(69).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(2);
var dP = __webpack_require__(8);
var DESCRIPTORS = __webpack_require__(7);
var SPECIES = __webpack_require__(5)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(18);
var call = __webpack_require__(108);
var isArrayIter = __webpack_require__(81);
var anObject = __webpack_require__(1);
var toLength = __webpack_require__(6);
var getIterFn = __webpack_require__(83);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(12);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(8).f;
var has = __webpack_require__(14);
var TAG = __webpack_require__(5)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(19);
var TAG = __webpack_require__(5)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var defined = __webpack_require__(23);
var fails = __webpack_require__(3);
var spaces = __webpack_require__(73);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(19);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 48 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(1);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(1);
var aFunction = __webpack_require__(10);
var SPECIES = __webpack_require__(5)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(26);
var global = __webpack_require__(2);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(30) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(15);
var toLength = __webpack_require__(6);
var toAbsoluteIndex = __webpack_require__(35);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 53 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(19);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(20);
var defined = __webpack_require__(23);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(4);
var cof = __webpack_require__(19);
var MATCH = __webpack_require__(5)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(5)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(43);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(112);
var redefine = __webpack_require__(12);
var hide = __webpack_require__(11);
var fails = __webpack_require__(3);
var defined = __webpack_require__(23);
var wks = __webpack_require__(5);
var regexpExec = __webpack_require__(87);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(2);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(12);
var redefineAll = __webpack_require__(41);
var meta = __webpack_require__(29);
var forOf = __webpack_require__(40);
var anInstance = __webpack_require__(39);
var isObject = __webpack_require__(4);
var fails = __webpack_require__(3);
var $iterDetect = __webpack_require__(57);
var setToStringTag = __webpack_require__(42);
var inheritIfRequired = __webpack_require__(72);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var hide = __webpack_require__(11);
var uid = __webpack_require__(33);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(30) || !__webpack_require__(3)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(2)[K];
});


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(10);
var ctx = __webpack_require__(18);
var forOf = __webpack_require__(40);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4);
var document = __webpack_require__(2).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var core = __webpack_require__(26);
var LIBRARY = __webpack_require__(30);
var wksExt = __webpack_require__(94);
var defineProperty = __webpack_require__(8).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(51)('keys');
var uid = __webpack_require__(33);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 69 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(2).document;
module.exports = document && document.documentElement;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(4);
var anObject = __webpack_require__(1);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(18)(Function.call, __webpack_require__(16).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4);
var setPrototypeOf = __webpack_require__(71).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(20);
var defined = __webpack_require__(23);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 75 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 76 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(56);
var defined = __webpack_require__(23);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(5)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(30);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(12);
var hide = __webpack_require__(11);
var Iterators = __webpack_require__(45);
var $iterCreate = __webpack_require__(80);
var setToStringTag = __webpack_require__(42);
var getPrototypeOf = __webpack_require__(17);
var ITERATOR = __webpack_require__(5)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(36);
var descriptor = __webpack_require__(32);
var setToStringTag = __webpack_require__(42);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(11)(IteratorPrototype, __webpack_require__(5)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(45);
var ITERATOR = __webpack_require__(5)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(8);
var createDesc = __webpack_require__(32);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(43);
var ITERATOR = __webpack_require__(5)('iterator');
var Iterators = __webpack_require__(45);
module.exports = __webpack_require__(26).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(212);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(9);
var toAbsoluteIndex = __webpack_require__(35);
var toLength = __webpack_require__(6);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(31);
var step = __webpack_require__(111);
var Iterators = __webpack_require__(45);
var toIObject = __webpack_require__(15);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(79)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(49);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(55)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(18);
var invoke = __webpack_require__(101);
var html = __webpack_require__(70);
var cel = __webpack_require__(66);
var global = __webpack_require__(2);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(19)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var macrotask = __webpack_require__(89).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(19)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(10);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(2);
var DESCRIPTORS = __webpack_require__(7);
var LIBRARY = __webpack_require__(30);
var $typed = __webpack_require__(62);
var hide = __webpack_require__(11);
var redefineAll = __webpack_require__(41);
var fails = __webpack_require__(3);
var anInstance = __webpack_require__(39);
var toInteger = __webpack_require__(20);
var toLength = __webpack_require__(6);
var toIndex = __webpack_require__(122);
var gOPN = __webpack_require__(37).f;
var dP = __webpack_require__(8).f;
var arrayFill = __webpack_require__(85);
var setToStringTag = __webpack_require__(42);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(7) && !__webpack_require__(3)(function () {
  return Object.defineProperty(__webpack_require__(66)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(5);


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(14);
var toIObject = __webpack_require__(15);
var arrayIndexOf = __webpack_require__(52)(false);
var IE_PROTO = __webpack_require__(68)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(8);
var anObject = __webpack_require__(1);
var getKeys = __webpack_require__(34);

module.exports = __webpack_require__(7) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(15);
var gOPN = __webpack_require__(37).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(34);
var gOPS = __webpack_require__(53);
var pIE = __webpack_require__(48);
var toObject = __webpack_require__(9);
var IObject = __webpack_require__(47);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(3)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 99 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(10);
var isObject = __webpack_require__(4);
var invoke = __webpack_require__(101);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 101 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(19);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(4);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(2).parseFloat;
var $trim = __webpack_require__(44).trim;

module.exports = 1 / $parseFloat(__webpack_require__(73) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(2).parseInt;
var $trim = __webpack_require__(44).trim;
var ws = __webpack_require__(73);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 106 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(75);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(1);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(10);
var toObject = __webpack_require__(9);
var IObject = __webpack_require__(47);
var toLength = __webpack_require__(6);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(9);
var toAbsoluteIndex = __webpack_require__(35);
var toLength = __webpack_require__(6);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(87);
__webpack_require__(0)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(7) && /./g.flags != 'g') __webpack_require__(8).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(49)
});


/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(1);
var isObject = __webpack_require__(4);
var newPromiseCapability = __webpack_require__(91);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(117);
var validate = __webpack_require__(46);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(61)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(8).f;
var create = __webpack_require__(36);
var redefineAll = __webpack_require__(41);
var ctx = __webpack_require__(18);
var anInstance = __webpack_require__(39);
var forOf = __webpack_require__(40);
var $iterDefine = __webpack_require__(79);
var step = __webpack_require__(111);
var setSpecies = __webpack_require__(38);
var DESCRIPTORS = __webpack_require__(7);
var fastKey = __webpack_require__(29).fastKey;
var validate = __webpack_require__(46);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(117);
var validate = __webpack_require__(46);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(61)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__(25)(0);
var redefine = __webpack_require__(12);
var meta = __webpack_require__(29);
var assign = __webpack_require__(98);
var weak = __webpack_require__(120);
var isObject = __webpack_require__(4);
var fails = __webpack_require__(3);
var validate = __webpack_require__(46);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(61)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(41);
var getWeak = __webpack_require__(29).getWeak;
var anObject = __webpack_require__(1);
var isObject = __webpack_require__(4);
var anInstance = __webpack_require__(39);
var forOf = __webpack_require__(40);
var createArrayMethod = __webpack_require__(25);
var $has = __webpack_require__(14);
var validate = __webpack_require__(46);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(37);
var gOPS = __webpack_require__(53);
var anObject = __webpack_require__(1);
var Reflect = __webpack_require__(2).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(20);
var toLength = __webpack_require__(6);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(54);
var isObject = __webpack_require__(4);
var toLength = __webpack_require__(6);
var ctx = __webpack_require__(18);
var IS_CONCAT_SPREADABLE = __webpack_require__(5)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(6);
var repeat = __webpack_require__(74);
var defined = __webpack_require__(23);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(34);
var toIObject = __webpack_require__(15);
var isEnum = __webpack_require__(48).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(43);
var from = __webpack_require__(127);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(40);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 128 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(130);
__webpack_require__(132);
__webpack_require__(133);
__webpack_require__(134);
__webpack_require__(135);
__webpack_require__(136);
__webpack_require__(137);
__webpack_require__(138);
__webpack_require__(139);
__webpack_require__(140);
__webpack_require__(141);
__webpack_require__(142);
__webpack_require__(143);
__webpack_require__(144);
__webpack_require__(145);
__webpack_require__(146);
__webpack_require__(147);
__webpack_require__(148);
__webpack_require__(149);
__webpack_require__(150);
__webpack_require__(151);
__webpack_require__(152);
__webpack_require__(153);
__webpack_require__(154);
__webpack_require__(155);
__webpack_require__(156);
__webpack_require__(157);
__webpack_require__(158);
__webpack_require__(159);
__webpack_require__(160);
__webpack_require__(161);
__webpack_require__(162);
__webpack_require__(163);
__webpack_require__(164);
__webpack_require__(165);
__webpack_require__(166);
__webpack_require__(167);
__webpack_require__(168);
__webpack_require__(169);
__webpack_require__(170);
__webpack_require__(171);
__webpack_require__(172);
__webpack_require__(173);
__webpack_require__(174);
__webpack_require__(175);
__webpack_require__(176);
__webpack_require__(177);
__webpack_require__(178);
__webpack_require__(179);
__webpack_require__(180);
__webpack_require__(181);
__webpack_require__(182);
__webpack_require__(183);
__webpack_require__(184);
__webpack_require__(185);
__webpack_require__(186);
__webpack_require__(187);
__webpack_require__(188);
__webpack_require__(189);
__webpack_require__(190);
__webpack_require__(191);
__webpack_require__(192);
__webpack_require__(193);
__webpack_require__(194);
__webpack_require__(195);
__webpack_require__(196);
__webpack_require__(197);
__webpack_require__(198);
__webpack_require__(199);
__webpack_require__(200);
__webpack_require__(201);
__webpack_require__(202);
__webpack_require__(203);
__webpack_require__(204);
__webpack_require__(205);
__webpack_require__(206);
__webpack_require__(207);
__webpack_require__(208);
__webpack_require__(209);
__webpack_require__(210);
__webpack_require__(211);
__webpack_require__(213);
__webpack_require__(214);
__webpack_require__(215);
__webpack_require__(216);
__webpack_require__(217);
__webpack_require__(218);
__webpack_require__(219);
__webpack_require__(220);
__webpack_require__(221);
__webpack_require__(222);
__webpack_require__(223);
__webpack_require__(224);
__webpack_require__(86);
__webpack_require__(225);
__webpack_require__(226);
__webpack_require__(112);
__webpack_require__(227);
__webpack_require__(113);
__webpack_require__(228);
__webpack_require__(229);
__webpack_require__(230);
__webpack_require__(231);
__webpack_require__(232);
__webpack_require__(116);
__webpack_require__(118);
__webpack_require__(119);
__webpack_require__(233);
__webpack_require__(234);
__webpack_require__(235);
__webpack_require__(236);
__webpack_require__(237);
__webpack_require__(238);
__webpack_require__(239);
__webpack_require__(240);
__webpack_require__(241);
__webpack_require__(242);
__webpack_require__(243);
__webpack_require__(244);
__webpack_require__(245);
__webpack_require__(246);
__webpack_require__(247);
__webpack_require__(248);
__webpack_require__(249);
__webpack_require__(250);
__webpack_require__(252);
__webpack_require__(253);
__webpack_require__(255);
__webpack_require__(256);
__webpack_require__(257);
__webpack_require__(258);
__webpack_require__(259);
__webpack_require__(260);
__webpack_require__(261);
__webpack_require__(262);
__webpack_require__(263);
__webpack_require__(264);
__webpack_require__(265);
__webpack_require__(266);
__webpack_require__(267);
__webpack_require__(268);
__webpack_require__(269);
__webpack_require__(270);
__webpack_require__(271);
__webpack_require__(272);
__webpack_require__(273);
__webpack_require__(274);
__webpack_require__(275);
__webpack_require__(276);
__webpack_require__(277);
__webpack_require__(278);
__webpack_require__(279);
__webpack_require__(280);
__webpack_require__(281);
__webpack_require__(282);
__webpack_require__(283);
__webpack_require__(284);
__webpack_require__(285);
__webpack_require__(286);
__webpack_require__(287);
__webpack_require__(288);
__webpack_require__(289);
__webpack_require__(290);
__webpack_require__(291);
__webpack_require__(292);
__webpack_require__(293);
__webpack_require__(294);
__webpack_require__(295);
__webpack_require__(296);
__webpack_require__(297);
__webpack_require__(298);
__webpack_require__(299);
__webpack_require__(300);
__webpack_require__(301);
__webpack_require__(302);
__webpack_require__(303);
__webpack_require__(304);
__webpack_require__(305);
__webpack_require__(306);
__webpack_require__(307);
__webpack_require__(308);
__webpack_require__(309);
__webpack_require__(310);
__webpack_require__(311);
__webpack_require__(312);
__webpack_require__(313);
__webpack_require__(314);
__webpack_require__(315);
__webpack_require__(316);
__webpack_require__(317);
__webpack_require__(318);
__webpack_require__(319);
__webpack_require__(320);
__webpack_require__(321);
__webpack_require__(322);
__webpack_require__(323);
module.exports = __webpack_require__(324);


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(2);
var has = __webpack_require__(14);
var DESCRIPTORS = __webpack_require__(7);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(12);
var META = __webpack_require__(29).KEY;
var $fails = __webpack_require__(3);
var shared = __webpack_require__(51);
var setToStringTag = __webpack_require__(42);
var uid = __webpack_require__(33);
var wks = __webpack_require__(5);
var wksExt = __webpack_require__(94);
var wksDefine = __webpack_require__(67);
var enumKeys = __webpack_require__(131);
var isArray = __webpack_require__(54);
var anObject = __webpack_require__(1);
var isObject = __webpack_require__(4);
var toIObject = __webpack_require__(15);
var toPrimitive = __webpack_require__(22);
var createDesc = __webpack_require__(32);
var _create = __webpack_require__(36);
var gOPNExt = __webpack_require__(97);
var $GOPD = __webpack_require__(16);
var $DP = __webpack_require__(8);
var $keys = __webpack_require__(34);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(37).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(48).f = $propertyIsEnumerable;
  __webpack_require__(53).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(30)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(11)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(34);
var gOPS = __webpack_require__(53);
var pIE = __webpack_require__(48);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(7), 'Object', { defineProperty: __webpack_require__(8).f });


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(7), 'Object', { defineProperties: __webpack_require__(96) });


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(15);
var $getOwnPropertyDescriptor = __webpack_require__(16).f;

__webpack_require__(24)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(36) });


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(9);
var $getPrototypeOf = __webpack_require__(17);

__webpack_require__(24)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(9);
var $keys = __webpack_require__(34);

__webpack_require__(24)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(24)('getOwnPropertyNames', function () {
  return __webpack_require__(97).f;
});


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(4);
var meta = __webpack_require__(29).onFreeze;

__webpack_require__(24)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(4);
var meta = __webpack_require__(29).onFreeze;

__webpack_require__(24)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(4);
var meta = __webpack_require__(29).onFreeze;

__webpack_require__(24)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(4);

__webpack_require__(24)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(4);

__webpack_require__(24)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(4);

__webpack_require__(24)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(0);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(98) });


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { is: __webpack_require__(99) });


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(71).set });


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(43);
var test = {};
test[__webpack_require__(5)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(12)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(0);

$export($export.P, 'Function', { bind: __webpack_require__(100) });


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(8).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(7) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(4);
var getPrototypeOf = __webpack_require__(17);
var HAS_INSTANCE = __webpack_require__(5)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(8).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(2);
var has = __webpack_require__(14);
var cof = __webpack_require__(19);
var inheritIfRequired = __webpack_require__(72);
var toPrimitive = __webpack_require__(22);
var fails = __webpack_require__(3);
var gOPN = __webpack_require__(37).f;
var gOPD = __webpack_require__(16).f;
var dP = __webpack_require__(8).f;
var $trim = __webpack_require__(44).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(36)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(7) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(12)(global, NUMBER, $Number);
}


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toInteger = __webpack_require__(20);
var aNumberValue = __webpack_require__(102);
var repeat = __webpack_require__(74);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(3)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $fails = __webpack_require__(3);
var aNumberValue = __webpack_require__(102);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(0);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(0);
var _isFinite = __webpack_require__(2).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', { isInteger: __webpack_require__(103) });


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(0);
var isInteger = __webpack_require__(103);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(104);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(105);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(105);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(104);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(0);
var log1p = __webpack_require__(106);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(0);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(0);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(0);
var sign = __webpack_require__(75);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(0);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(0);
var $expm1 = __webpack_require__(76);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { fround: __webpack_require__(107) });


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(0);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(0);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(3)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { log1p: __webpack_require__(106) });


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { sign: __webpack_require__(75) });


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(76);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(3)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(76);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toAbsoluteIndex = __webpack_require__(35);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(15);
var toLength = __webpack_require__(6);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(44)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $at = __webpack_require__(55)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(6);
var context = __webpack_require__(77);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(78)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(0);
var context = __webpack_require__(77);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(78)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(74)
});


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(6);
var context = __webpack_require__(77);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(78)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(55)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(79)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(13)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(13)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(13)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(13)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(13)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(13)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(13)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(13)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(13)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(13)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(13)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(13)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(13)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(0);

$export($export.S, 'Array', { isArray: __webpack_require__(54) });


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(18);
var $export = __webpack_require__(0);
var toObject = __webpack_require__(9);
var call = __webpack_require__(108);
var isArrayIter = __webpack_require__(81);
var toLength = __webpack_require__(6);
var createProperty = __webpack_require__(82);
var getIterFn = __webpack_require__(83);

$export($export.S + $export.F * !__webpack_require__(57)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var createProperty = __webpack_require__(82);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(3)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(0);
var toIObject = __webpack_require__(15);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(47) != Object || !__webpack_require__(21)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var html = __webpack_require__(70);
var cof = __webpack_require__(19);
var toAbsoluteIndex = __webpack_require__(35);
var toLength = __webpack_require__(6);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(3)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var aFunction = __webpack_require__(10);
var toObject = __webpack_require__(9);
var fails = __webpack_require__(3);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(21)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $forEach = __webpack_require__(25)(0);
var STRICT = __webpack_require__(21)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4);
var isArray = __webpack_require__(54);
var SPECIES = __webpack_require__(5)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $map = __webpack_require__(25)(1);

$export($export.P + $export.F * !__webpack_require__(21)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $filter = __webpack_require__(25)(2);

$export($export.P + $export.F * !__webpack_require__(21)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $some = __webpack_require__(25)(3);

$export($export.P + $export.F * !__webpack_require__(21)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $every = __webpack_require__(25)(4);

$export($export.P + $export.F * !__webpack_require__(21)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(109);

$export($export.P + $export.F * !__webpack_require__(21)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(109);

$export($export.P + $export.F * !__webpack_require__(21)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $indexOf = __webpack_require__(52)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(21)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(15);
var toInteger = __webpack_require__(20);
var toLength = __webpack_require__(6);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(21)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { copyWithin: __webpack_require__(110) });

__webpack_require__(31)('copyWithin');


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { fill: __webpack_require__(85) });

__webpack_require__(31)('fill');


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(25)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(31)(KEY);


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(25)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(31)(KEY);


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(38)('Array');


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var inheritIfRequired = __webpack_require__(72);
var dP = __webpack_require__(8).f;
var gOPN = __webpack_require__(37).f;
var isRegExp = __webpack_require__(56);
var $flags = __webpack_require__(49);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(7) && (!CORRECT_NEW || __webpack_require__(3)(function () {
  re2[__webpack_require__(5)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(12)(global, 'RegExp', $RegExp);
}

__webpack_require__(38)('RegExp');


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(113);
var anObject = __webpack_require__(1);
var $flags = __webpack_require__(49);
var DESCRIPTORS = __webpack_require__(7);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(12)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(3)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(1);
var toLength = __webpack_require__(6);
var advanceStringIndex = __webpack_require__(88);
var regExpExec = __webpack_require__(58);

// @@match logic
__webpack_require__(59)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(1);
var toObject = __webpack_require__(9);
var toLength = __webpack_require__(6);
var toInteger = __webpack_require__(20);
var advanceStringIndex = __webpack_require__(88);
var regExpExec = __webpack_require__(58);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(59)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return ch;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return ch;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return ch;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(1);
var sameValue = __webpack_require__(99);
var regExpExec = __webpack_require__(58);

// @@search logic
__webpack_require__(59)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(56);
var anObject = __webpack_require__(1);
var speciesConstructor = __webpack_require__(50);
var advanceStringIndex = __webpack_require__(88);
var toLength = __webpack_require__(6);
var callRegExpExec = __webpack_require__(58);
var regexpExec = __webpack_require__(87);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';

// eslint-disable-next-line no-empty
var SUPPORTS_Y = !!(function () { try { return new RegExp('x', 'y'); } catch (e) {} })();

// @@split logic
__webpack_require__(59)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                    (rx.multiline ? 'm' : '') +
                    (rx.unicode ? 'u' : '') +
                    (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? 0xffffffff : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(30);
var global = __webpack_require__(2);
var ctx = __webpack_require__(18);
var classof = __webpack_require__(43);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(4);
var aFunction = __webpack_require__(10);
var anInstance = __webpack_require__(39);
var forOf = __webpack_require__(40);
var speciesConstructor = __webpack_require__(50);
var task = __webpack_require__(89).set;
var microtask = __webpack_require__(90)();
var newPromiseCapabilityModule = __webpack_require__(91);
var perform = __webpack_require__(114);
var userAgent = __webpack_require__(60);
var promiseResolve = __webpack_require__(115);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(5)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(41)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(42)($Promise, PROMISE);
__webpack_require__(38)(PROMISE);
Wrapper = __webpack_require__(26)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(57)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(120);
var validate = __webpack_require__(46);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(61)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(10);
var anObject = __webpack_require__(1);
var rApply = (__webpack_require__(2).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(3)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(0);
var create = __webpack_require__(36);
var aFunction = __webpack_require__(10);
var anObject = __webpack_require__(1);
var isObject = __webpack_require__(4);
var fails = __webpack_require__(3);
var bind = __webpack_require__(100);
var rConstruct = (__webpack_require__(2).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(8);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(1);
var toPrimitive = __webpack_require__(22);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(3)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(0);
var gOPD = __webpack_require__(16).f;
var anObject = __webpack_require__(1);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(1);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(80)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(16);
var getPrototypeOf = __webpack_require__(17);
var has = __webpack_require__(14);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(4);
var anObject = __webpack_require__(1);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(16);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(1);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(0);
var getProto = __webpack_require__(17);
var anObject = __webpack_require__(1);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(1);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(121) });


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(1);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(8);
var gOPD = __webpack_require__(16);
var getPrototypeOf = __webpack_require__(17);
var has = __webpack_require__(14);
var $export = __webpack_require__(0);
var createDesc = __webpack_require__(32);
var anObject = __webpack_require__(1);
var isObject = __webpack_require__(4);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(0);
var setProto = __webpack_require__(71);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(0);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(9);
var toPrimitive = __webpack_require__(22);

$export($export.P + $export.F * __webpack_require__(3)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(0);
var toISOString = __webpack_require__(251);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(3);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(12)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(5)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(11)(proto, TO_PRIMITIVE, __webpack_require__(254));


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(1);
var toPrimitive = __webpack_require__(22);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $typed = __webpack_require__(62);
var buffer = __webpack_require__(92);
var anObject = __webpack_require__(1);
var toAbsoluteIndex = __webpack_require__(35);
var toLength = __webpack_require__(6);
var isObject = __webpack_require__(4);
var ArrayBuffer = __webpack_require__(2).ArrayBuffer;
var speciesConstructor = __webpack_require__(50);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(3)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(38)(ARRAY_BUFFER);


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
$export($export.G + $export.W + $export.F * !__webpack_require__(62).ABV, {
  DataView: __webpack_require__(92).DataView
});


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(27)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(27)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(27)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(27)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(27)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(27)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(27)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(27)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(27)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(0);
var $includes = __webpack_require__(52)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(31)('includes');


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(123);
var toObject = __webpack_require__(9);
var toLength = __webpack_require__(6);
var aFunction = __webpack_require__(10);
var arraySpeciesCreate = __webpack_require__(84);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(31)('flatMap');


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(123);
var toObject = __webpack_require__(9);
var toLength = __webpack_require__(6);
var toInteger = __webpack_require__(20);
var arraySpeciesCreate = __webpack_require__(84);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(31)('flatten');


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(0);
var $at = __webpack_require__(55)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(124);
var userAgent = __webpack_require__(60);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(124);
var userAgent = __webpack_require__(60);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(44)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(44)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(0);
var defined = __webpack_require__(23);
var toLength = __webpack_require__(6);
var isRegExp = __webpack_require__(56);
var getFlags = __webpack_require__(49);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(80)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(67)('asyncIterator');


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(67)('observable');


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(0);
var ownKeys = __webpack_require__(121);
var toIObject = __webpack_require__(15);
var gOPD = __webpack_require__(16);
var createProperty = __webpack_require__(82);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $values = __webpack_require__(125)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $entries = __webpack_require__(125)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(9);
var aFunction = __webpack_require__(10);
var $defineProperty = __webpack_require__(8);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(7) && $export($export.P + __webpack_require__(63), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(9);
var aFunction = __webpack_require__(10);
var $defineProperty = __webpack_require__(8);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(7) && $export($export.P + __webpack_require__(63), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(9);
var toPrimitive = __webpack_require__(22);
var getPrototypeOf = __webpack_require__(17);
var getOwnPropertyDescriptor = __webpack_require__(16).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(7) && $export($export.P + __webpack_require__(63), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(9);
var toPrimitive = __webpack_require__(22);
var getPrototypeOf = __webpack_require__(17);
var getOwnPropertyDescriptor = __webpack_require__(16).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(7) && $export($export.P + __webpack_require__(63), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(126)('Map') });


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(126)('Set') });


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(64)('Map');


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(64)('Set');


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(64)('WeakMap');


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(64)('WeakSet');


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(65)('Map');


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(65)('Set');


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(65)('WeakMap');


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(65)('WeakSet');


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.G, { global: __webpack_require__(2) });


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.S, 'System', { global: __webpack_require__(2) });


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(0);
var cof = __webpack_require__(19);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var scale = __webpack_require__(128);
var fround = __webpack_require__(107);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { scale: __webpack_require__(128) });


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(0);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(0);
var core = __webpack_require__(26);
var global = __webpack_require__(2);
var speciesConstructor = __webpack_require__(50);
var promiseResolve = __webpack_require__(115);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(0);
var newPromiseCapability = __webpack_require__(91);
var perform = __webpack_require__(114);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(28);
var anObject = __webpack_require__(1);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(28);
var anObject = __webpack_require__(1);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(28);
var anObject = __webpack_require__(1);
var getPrototypeOf = __webpack_require__(17);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(118);
var from = __webpack_require__(127);
var metadata = __webpack_require__(28);
var anObject = __webpack_require__(1);
var getPrototypeOf = __webpack_require__(17);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(28);
var anObject = __webpack_require__(1);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(28);
var anObject = __webpack_require__(1);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(28);
var anObject = __webpack_require__(1);
var getPrototypeOf = __webpack_require__(17);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(28);
var anObject = __webpack_require__(1);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(28);
var anObject = __webpack_require__(1);
var aFunction = __webpack_require__(10);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(0);
var microtask = __webpack_require__(90)();
var process = __webpack_require__(2).process;
var isNode = __webpack_require__(19)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(0);
var global = __webpack_require__(2);
var core = __webpack_require__(26);
var microtask = __webpack_require__(90)();
var OBSERVABLE = __webpack_require__(5)('observable');
var aFunction = __webpack_require__(10);
var anObject = __webpack_require__(1);
var anInstance = __webpack_require__(39);
var redefineAll = __webpack_require__(41);
var hide = __webpack_require__(11);
var forOf = __webpack_require__(40);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(38)('Observable');


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $task = __webpack_require__(89);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(86);
var getKeys = __webpack_require__(34);
var redefine = __webpack_require__(12);
var global = __webpack_require__(2);
var hide = __webpack_require__(11);
var Iterators = __webpack_require__(45);
var wks = __webpack_require__(5);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(2);
var $export = __webpack_require__(0);
var userAgent = __webpack_require__(60);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ })
/******/ ]);
// CommonJS export
if (typeof module != 'undefined' && module.exports) module.exports = __e;
// RequireJS export
else if (typeof define == 'function' && define.amd) define(function () { return __e; });
// Export to global object
else __g.core = __e;
}(1, 1);
},
'jquery-ui/jquery-ui':function(){
/*! jQuery UI - v1.14.1 - 2024-10-30
* https://jqueryui.com
* Includes: widget.js, position.js, data.js, disable-selection.js, effect.js, effects/effect-blind.js, effects/effect-bounce.js, effects/effect-clip.js, effects/effect-drop.js, effects/effect-explode.js, effects/effect-fade.js, effects/effect-fold.js, effects/effect-highlight.js, effects/effect-puff.js, effects/effect-pulsate.js, effects/effect-scale.js, effects/effect-shake.js, effects/effect-size.js, effects/effect-slide.js, effects/effect-transfer.js, focusable.js, form-reset-mixin.js, jquery-patch.js, keycode.js, labels.js, scroll-parent.js, tabbable.js, unique-id.js, widgets/accordion.js, widgets/autocomplete.js, widgets/button.js, widgets/checkboxradio.js, widgets/controlgroup.js, widgets/datepicker.js, widgets/dialog.js, widgets/draggable.js, widgets/droppable.js, widgets/menu.js, widgets/mouse.js, widgets/progressbar.js, widgets/resizable.js, widgets/selectable.js, widgets/selectmenu.js, widgets/slider.js, widgets/sortable.js, widgets/spinner.js, widgets/tabs.js, widgets/tooltip.js
* Copyright OpenJS Foundation and other contributors; Licensed MIT */

( function( factory ) {
	"use strict";

	if ( typeof define === "function" && define.amd ) {

		// AMD. Register as an anonymous module.
		define( [ "jquery" ], factory );
	} else {

		// Browser globals
		factory( jQuery );
	}
} )( function( $ ) {
"use strict";

$.ui = $.ui || {};

var version = $.ui.version = "1.14.1";


/*!
 * jQuery UI Widget 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Widget
//>>group: Core
//>>description: Provides a factory for creating stateful widgets with a common API.
//>>docs: https://api.jqueryui.com/jQuery.widget/
//>>demos: https://jqueryui.com/widget/


var widgetUuid = 0;
var widgetHasOwnProperty = Array.prototype.hasOwnProperty;
var widgetSlice = Array.prototype.slice;

$.cleanData = ( function( orig ) {
	return function( elems ) {
		var events, elem, i;
		for ( i = 0; ( elem = elems[ i ] ) != null; i++ ) {

			// Only trigger remove when necessary to save time
			events = $._data( elem, "events" );
			if ( events && events.remove ) {
				$( elem ).triggerHandler( "remove" );
			}
		}
		orig( elems );
	};
} )( $.cleanData );

$.widget = function( name, base, prototype ) {
	var existingConstructor, constructor, basePrototype;

	// ProxiedPrototype allows the provided prototype to remain unmodified
	// so that it can be used as a mixin for multiple widgets (#8876)
	var proxiedPrototype = {};

	var namespace = name.split( "." )[ 0 ];
	name = name.split( "." )[ 1 ];
	if ( name === "__proto__" || name === "constructor" ) {
		return $.error( "Invalid widget name: " + name );
	}
	var fullName = namespace + "-" + name;

	if ( !prototype ) {
		prototype = base;
		base = $.Widget;
	}

	if ( Array.isArray( prototype ) ) {
		prototype = $.extend.apply( null, [ {} ].concat( prototype ) );
	}

	// Create selector for plugin
	$.expr.pseudos[ fullName.toLowerCase() ] = function( elem ) {
		return !!$.data( elem, fullName );
	};

	$[ namespace ] = $[ namespace ] || {};
	existingConstructor = $[ namespace ][ name ];
	constructor = $[ namespace ][ name ] = function( options, element ) {

		// Allow instantiation without "new" keyword
		if ( !this || !this._createWidget ) {
			return new constructor( options, element );
		}

		// Allow instantiation without initializing for simple inheritance
		// must use "new" keyword (the code above always passes args)
		if ( arguments.length ) {
			this._createWidget( options, element );
		}
	};

	// Extend with the existing constructor to carry over any static properties
	$.extend( constructor, existingConstructor, {
		version: prototype.version,

		// Copy the object used to create the prototype in case we need to
		// redefine the widget later
		_proto: $.extend( {}, prototype ),

		// Track widgets that inherit from this widget in case this widget is
		// redefined after a widget inherits from it
		_childConstructors: []
	} );

	basePrototype = new base();

	// We need to make the options hash a property directly on the new instance
	// otherwise we'll modify the options hash on the prototype that we're
	// inheriting from
	basePrototype.options = $.widget.extend( {}, basePrototype.options );
	$.each( prototype, function( prop, value ) {
		if ( typeof value !== "function" ) {
			proxiedPrototype[ prop ] = value;
			return;
		}
		proxiedPrototype[ prop ] = ( function() {
			function _super() {
				return base.prototype[ prop ].apply( this, arguments );
			}

			function _superApply( args ) {
				return base.prototype[ prop ].apply( this, args );
			}

			return function() {
				var __super = this._super;
				var __superApply = this._superApply;
				var returnValue;

				this._super = _super;
				this._superApply = _superApply;

				returnValue = value.apply( this, arguments );

				this._super = __super;
				this._superApply = __superApply;

				return returnValue;
			};
		} )();
	} );
	constructor.prototype = $.widget.extend( basePrototype, {

		// TODO: remove support for widgetEventPrefix
		// always use the name + a colon as the prefix, e.g., draggable:start
		// don't prefix for widgets that aren't DOM-based
		widgetEventPrefix: existingConstructor ? ( basePrototype.widgetEventPrefix || name ) : name
	}, proxiedPrototype, {
		constructor: constructor,
		namespace: namespace,
		widgetName: name,
		widgetFullName: fullName
	} );

	// If this widget is being redefined then we need to find all widgets that
	// are inheriting from it and redefine all of them so that they inherit from
	// the new version of this widget. We're essentially trying to replace one
	// level in the prototype chain.
	if ( existingConstructor ) {
		$.each( existingConstructor._childConstructors, function( i, child ) {
			var childPrototype = child.prototype;

			// Redefine the child widget using the same prototype that was
			// originally used, but inherit from the new version of the base
			$.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor,
				child._proto );
		} );

		// Remove the list of existing child constructors from the old constructor
		// so the old child constructors can be garbage collected
		delete existingConstructor._childConstructors;
	} else {
		base._childConstructors.push( constructor );
	}

	$.widget.bridge( name, constructor );

	return constructor;
};

$.widget.extend = function( target ) {
	var input = widgetSlice.call( arguments, 1 );
	var inputIndex = 0;
	var inputLength = input.length;
	var key;
	var value;

	for ( ; inputIndex < inputLength; inputIndex++ ) {
		for ( key in input[ inputIndex ] ) {
			value = input[ inputIndex ][ key ];
			if ( widgetHasOwnProperty.call( input[ inputIndex ], key ) && value !== undefined ) {

				// Clone objects
				if ( $.isPlainObject( value ) ) {
					target[ key ] = $.isPlainObject( target[ key ] ) ?
						$.widget.extend( {}, target[ key ], value ) :

						// Don't extend strings, arrays, etc. with objects
						$.widget.extend( {}, value );

				// Copy everything else by reference
				} else {
					target[ key ] = value;
				}
			}
		}
	}
	return target;
};

$.widget.bridge = function( name, object ) {
	var fullName = object.prototype.widgetFullName || name;
	$.fn[ name ] = function( options ) {
		var isMethodCall = typeof options === "string";
		var args = widgetSlice.call( arguments, 1 );
		var returnValue = this;

		if ( isMethodCall ) {

			// If this is an empty collection, we need to have the instance method
			// return undefined instead of the jQuery instance
			if ( !this.length && options === "instance" ) {
				returnValue = undefined;
			} else {
				this.each( function() {
					var methodValue;
					var instance = $.data( this, fullName );

					if ( options === "instance" ) {
						returnValue = instance;
						return false;
					}

					if ( !instance ) {
						return $.error( "cannot call methods on " + name +
							" prior to initialization; " +
							"attempted to call method '" + options + "'" );
					}

					if ( typeof instance[ options ] !== "function" ||
						options.charAt( 0 ) === "_" ) {
						return $.error( "no such method '" + options + "' for " + name +
							" widget instance" );
					}

					methodValue = instance[ options ].apply( instance, args );

					if ( methodValue !== instance && methodValue !== undefined ) {
						returnValue = methodValue && methodValue.jquery ?
							returnValue.pushStack( methodValue.get() ) :
							methodValue;
						return false;
					}
				} );
			}
		} else {

			// Allow multiple hashes to be passed on init
			if ( args.length ) {
				options = $.widget.extend.apply( null, [ options ].concat( args ) );
			}

			this.each( function() {
				var instance = $.data( this, fullName );
				if ( instance ) {
					instance.option( options || {} );
					if ( instance._init ) {
						instance._init();
					}
				} else {
					$.data( this, fullName, new object( options, this ) );
				}
			} );
		}

		return returnValue;
	};
};

$.Widget = function( /* options, element */ ) {};
$.Widget._childConstructors = [];

$.Widget.prototype = {
	widgetName: "widget",
	widgetEventPrefix: "",
	defaultElement: "<div>",

	options: {
		classes: {},
		disabled: false,

		// Callbacks
		create: null
	},

	_createWidget: function( options, element ) {
		element = $( element || this.defaultElement || this )[ 0 ];
		this.element = $( element );
		this.uuid = widgetUuid++;
		this.eventNamespace = "." + this.widgetName + this.uuid;

		this.bindings = $();
		this.hoverable = $();
		this.focusable = $();
		this.classesElementLookup = {};

		if ( element !== this ) {
			$.data( element, this.widgetFullName, this );
			this._on( true, this.element, {
				remove: function( event ) {
					if ( event.target === element ) {
						this.destroy();
					}
				}
			} );
			this.document = $( element.style ?

				// Element within the document
				element.ownerDocument :

				// Element is window or document
				element.document || element );
			this.window = $( this.document[ 0 ].defaultView || this.document[ 0 ].parentWindow );
		}

		this.options = $.widget.extend( {},
			this.options,
			this._getCreateOptions(),
			options );

		this._create();

		if ( this.options.disabled ) {
			this._setOptionDisabled( this.options.disabled );
		}

		this._trigger( "create", null, this._getCreateEventData() );
		this._init();
	},

	_getCreateOptions: function() {
		return {};
	},

	_getCreateEventData: $.noop,

	_create: $.noop,

	_init: $.noop,

	destroy: function() {
		var that = this;

		this._destroy();
		$.each( this.classesElementLookup, function( key, value ) {
			that._removeClass( value, key );
		} );

		// We can probably remove the unbind calls in 2.0
		// all event bindings should go through this._on()
		this.element
			.off( this.eventNamespace )
			.removeData( this.widgetFullName );
		this.widget()
			.off( this.eventNamespace )
			.removeAttr( "aria-disabled" );

		// Clean up events and states
		this.bindings.off( this.eventNamespace );
	},

	_destroy: $.noop,

	widget: function() {
		return this.element;
	},

	option: function( key, value ) {
		var options = key;
		var parts;
		var curOption;
		var i;

		if ( arguments.length === 0 ) {

			// Don't return a reference to the internal hash
			return $.widget.extend( {}, this.options );
		}

		if ( typeof key === "string" ) {

			// Handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
			options = {};
			parts = key.split( "." );
			key = parts.shift();
			if ( parts.length ) {
				curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
				for ( i = 0; i < parts.length - 1; i++ ) {
					curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
					curOption = curOption[ parts[ i ] ];
				}
				key = parts.pop();
				if ( arguments.length === 1 ) {
					return curOption[ key ] === undefined ? null : curOption[ key ];
				}
				curOption[ key ] = value;
			} else {
				if ( arguments.length === 1 ) {
					return this.options[ key ] === undefined ? null : this.options[ key ];
				}
				options[ key ] = value;
			}
		}

		this._setOptions( options );

		return this;
	},

	_setOptions: function( options ) {
		var key;

		for ( key in options ) {
			this._setOption( key, options[ key ] );
		}

		return this;
	},

	_setOption: function( key, value ) {
		if ( key === "classes" ) {
			this._setOptionClasses( value );
		}

		this.options[ key ] = value;

		if ( key === "disabled" ) {
			this._setOptionDisabled( value );
		}

		return this;
	},

	_setOptionClasses: function( value ) {
		var classKey, elements, currentElements;

		for ( classKey in value ) {
			currentElements = this.classesElementLookup[ classKey ];
			if ( value[ classKey ] === this.options.classes[ classKey ] ||
					!currentElements ||
					!currentElements.length ) {
				continue;
			}

			// We are doing this to create a new jQuery object because the _removeClass() call
			// on the next line is going to destroy the reference to the current elements being
			// tracked. We need to save a copy of this collection so that we can add the new classes
			// below.
			elements = $( currentElements.get() );
			this._removeClass( currentElements, classKey );

			// We don't use _addClass() here, because that uses this.options.classes
			// for generating the string of classes. We want to use the value passed in from
			// _setOption(), this is the new value of the classes option which was passed to
			// _setOption(). We pass this value directly to _classes().
			elements.addClass( this._classes( {
				element: elements,
				keys: classKey,
				classes: value,
				add: true
			} ) );
		}
	},

	_setOptionDisabled: function( value ) {
		this._toggleClass( this.widget(), this.widgetFullName + "-disabled", null, !!value );

		// If the widget is becoming disabled, then nothing is interactive
		if ( value ) {
			this._removeClass( this.hoverable, null, "ui-state-hover" );
			this._removeClass( this.focusable, null, "ui-state-focus" );
		}
	},

	enable: function() {
		return this._setOptions( { disabled: false } );
	},

	disable: function() {
		return this._setOptions( { disabled: true } );
	},

	_classes: function( options ) {
		var full = [];
		var that = this;

		options = $.extend( {
			element: this.element,
			classes: this.options.classes || {}
		}, options );

		function bindRemoveEvent() {
			var nodesToBind = [];

			options.element.each( function( _, element ) {
				var isTracked = $.map( that.classesElementLookup, function( elements ) {
					return elements;
				} )
					.some( function( elements ) {
						return elements.is( element );
					} );

				if ( !isTracked ) {
					nodesToBind.push( element );
				}
			} );

			that._on( $( nodesToBind ), {
				remove: "_untrackClassesElement"
			} );
		}

		function processClassString( classes, checkOption ) {
			var current, i;
			for ( i = 0; i < classes.length; i++ ) {
				current = that.classesElementLookup[ classes[ i ] ] || $();
				if ( options.add ) {
					bindRemoveEvent();
					current = $( $.uniqueSort( current.get().concat( options.element.get() ) ) );
				} else {
					current = $( current.not( options.element ).get() );
				}
				that.classesElementLookup[ classes[ i ] ] = current;
				full.push( classes[ i ] );
				if ( checkOption && options.classes[ classes[ i ] ] ) {
					full.push( options.classes[ classes[ i ] ] );
				}
			}
		}

		if ( options.keys ) {
			processClassString( options.keys.match( /\S+/g ) || [], true );
		}
		if ( options.extra ) {
			processClassString( options.extra.match( /\S+/g ) || [] );
		}

		return full.join( " " );
	},

	_untrackClassesElement: function( event ) {
		var that = this;
		$.each( that.classesElementLookup, function( key, value ) {
			if ( $.inArray( event.target, value ) !== -1 ) {
				that.classesElementLookup[ key ] = $( value.not( event.target ).get() );
			}
		} );

		this._off( $( event.target ) );
	},

	_removeClass: function( element, keys, extra ) {
		return this._toggleClass( element, keys, extra, false );
	},

	_addClass: function( element, keys, extra ) {
		return this._toggleClass( element, keys, extra, true );
	},

	_toggleClass: function( element, keys, extra, add ) {
		add = ( typeof add === "boolean" ) ? add : extra;
		var shift = ( typeof element === "string" || element === null ),
			options = {
				extra: shift ? keys : extra,
				keys: shift ? element : keys,
				element: shift ? this.element : element,
				add: add
			};
		options.element.toggleClass( this._classes( options ), add );
		return this;
	},

	_on: function( suppressDisabledCheck, element, handlers ) {
		var delegateElement;
		var instance = this;

		// No suppressDisabledCheck flag, shuffle arguments
		if ( typeof suppressDisabledCheck !== "boolean" ) {
			handlers = element;
			element = suppressDisabledCheck;
			suppressDisabledCheck = false;
		}

		// No element argument, shuffle and use this.element
		if ( !handlers ) {
			handlers = element;
			element = this.element;
			delegateElement = this.widget();
		} else {
			element = delegateElement = $( element );
			this.bindings = this.bindings.add( element );
		}

		$.each( handlers, function( event, handler ) {
			function handlerProxy() {

				// Allow widgets to customize the disabled handling
				// - disabled as an array instead of boolean
				// - disabled class as method for disabling individual parts
				if ( !suppressDisabledCheck &&
						( instance.options.disabled === true ||
						$( this ).hasClass( "ui-state-disabled" ) ) ) {
					return;
				}
				return ( typeof handler === "string" ? instance[ handler ] : handler )
					.apply( instance, arguments );
			}

			// Copy the guid so direct unbinding works
			if ( typeof handler !== "string" ) {
				handlerProxy.guid = handler.guid =
					handler.guid || handlerProxy.guid || $.guid++;
			}

			var match = event.match( /^([\w:-]*)\s*(.*)$/ );
			var eventName = match[ 1 ] + instance.eventNamespace;
			var selector = match[ 2 ];

			if ( selector ) {
				delegateElement.on( eventName, selector, handlerProxy );
			} else {
				element.on( eventName, handlerProxy );
			}
		} );
	},

	_off: function( element, eventName ) {
		eventName = ( eventName || "" ).split( " " ).join( this.eventNamespace + " " ) +
			this.eventNamespace;
		element.off( eventName );

		// Clear the stack to avoid memory leaks (#10056)
		this.bindings = $( this.bindings.not( element ).get() );
		this.focusable = $( this.focusable.not( element ).get() );
		this.hoverable = $( this.hoverable.not( element ).get() );
	},

	_delay: function( handler, delay ) {
		function handlerProxy() {
			return ( typeof handler === "string" ? instance[ handler ] : handler )
				.apply( instance, arguments );
		}
		var instance = this;
		return setTimeout( handlerProxy, delay || 0 );
	},

	_hoverable: function( element ) {
		this.hoverable = this.hoverable.add( element );
		this._on( element, {
			mouseenter: function( event ) {
				this._addClass( $( event.currentTarget ), null, "ui-state-hover" );
			},
			mouseleave: function( event ) {
				this._removeClass( $( event.currentTarget ), null, "ui-state-hover" );
			}
		} );
	},

	_focusable: function( element ) {
		this.focusable = this.focusable.add( element );
		this._on( element, {
			focusin: function( event ) {
				this._addClass( $( event.currentTarget ), null, "ui-state-focus" );
			},
			focusout: function( event ) {
				this._removeClass( $( event.currentTarget ), null, "ui-state-focus" );
			}
		} );
	},

	_trigger: function( type, event, data ) {
		var prop, orig;
		var callback = this.options[ type ];

		data = data || {};
		event = $.Event( event );
		event.type = ( type === this.widgetEventPrefix ?
			type :
			this.widgetEventPrefix + type ).toLowerCase();

		// The original event may come from any element
		// so we need to reset the target on the new event
		event.target = this.element[ 0 ];

		// Copy original event properties over to the new event
		orig = event.originalEvent;
		if ( orig ) {
			for ( prop in orig ) {
				if ( !( prop in event ) ) {
					event[ prop ] = orig[ prop ];
				}
			}
		}

		this.element.trigger( event, data );
		return !( typeof callback === "function" &&
			callback.apply( this.element[ 0 ], [ event ].concat( data ) ) === false ||
			event.isDefaultPrevented() );
	}
};

$.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
	$.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
		if ( typeof options === "string" ) {
			options = { effect: options };
		}

		var hasOptions;
		var effectName = !options ?
			method :
			options === true || typeof options === "number" ?
				defaultEffect :
				options.effect || defaultEffect;

		options = options || {};
		if ( typeof options === "number" ) {
			options = { duration: options };
		} else if ( options === true ) {
			options = {};
		}

		hasOptions = !$.isEmptyObject( options );
		options.complete = callback;

		if ( options.delay ) {
			element.delay( options.delay );
		}

		if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
			element[ method ]( options );
		} else if ( effectName !== method && element[ effectName ] ) {
			element[ effectName ]( options.duration, options.easing, callback );
		} else {
			element.queue( function( next ) {
				$( this )[ method ]();
				if ( callback ) {
					callback.call( element[ 0 ] );
				}
				next();
			} );
		}
	};
} );

var widget = $.widget;


/*!
 * jQuery UI Position 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 *
 * https://api.jqueryui.com/position/
 */

//>>label: Position
//>>group: Core
//>>description: Positions elements relative to other elements.
//>>docs: https://api.jqueryui.com/position/
//>>demos: https://jqueryui.com/position/


( function() {
var cachedScrollbarWidth,
	max = Math.max,
	abs = Math.abs,
	rhorizontal = /left|center|right/,
	rvertical = /top|center|bottom/,
	roffset = /[\+\-]\d+(\.[\d]+)?%?/,
	rposition = /^\w+/,
	rpercent = /%$/,
	_position = $.fn.position;

function getOffsets( offsets, width, height ) {
	return [
		parseFloat( offsets[ 0 ] ) * ( rpercent.test( offsets[ 0 ] ) ? width / 100 : 1 ),
		parseFloat( offsets[ 1 ] ) * ( rpercent.test( offsets[ 1 ] ) ? height / 100 : 1 )
	];
}

function parseCss( element, property ) {
	return parseInt( $.css( element, property ), 10 ) || 0;
}

function isWindow( obj ) {
	return obj != null && obj === obj.window;
}

function getDimensions( elem ) {
	var raw = elem[ 0 ];
	if ( raw.nodeType === 9 ) {
		return {
			width: elem.width(),
			height: elem.height(),
			offset: { top: 0, left: 0 }
		};
	}
	if ( isWindow( raw ) ) {
		return {
			width: elem.width(),
			height: elem.height(),
			offset: { top: elem.scrollTop(), left: elem.scrollLeft() }
		};
	}
	if ( raw.preventDefault ) {
		return {
			width: 0,
			height: 0,
			offset: { top: raw.pageY, left: raw.pageX }
		};
	}
	return {
		width: elem.outerWidth(),
		height: elem.outerHeight(),
		offset: elem.offset()
	};
}

$.position = {
	scrollbarWidth: function() {
		if ( cachedScrollbarWidth !== undefined ) {
			return cachedScrollbarWidth;
		}
		var w1, w2,
			div = $( "<div style=" +
				"'display:block;position:absolute;width:200px;height:200px;overflow:hidden;'>" +
				"<div style='height:300px;width:auto;'></div></div>" ),
			innerDiv = div.children()[ 0 ];

		$( "body" ).append( div );
		w1 = innerDiv.offsetWidth;
		div.css( "overflow", "scroll" );

		w2 = innerDiv.offsetWidth;

		if ( w1 === w2 ) {
			w2 = div[ 0 ].clientWidth;
		}

		div.remove();

		return ( cachedScrollbarWidth = w1 - w2 );
	},
	getScrollInfo: function( within ) {
		var overflowX = within.isWindow || within.isDocument ? "" :
				within.element.css( "overflow-x" ),
			overflowY = within.isWindow || within.isDocument ? "" :
				within.element.css( "overflow-y" ),
			hasOverflowX = overflowX === "scroll" ||
				( overflowX === "auto" && within.width < within.element[ 0 ].scrollWidth ),
			hasOverflowY = overflowY === "scroll" ||
				( overflowY === "auto" && within.height < within.element[ 0 ].scrollHeight );
		return {
			width: hasOverflowY ? $.position.scrollbarWidth() : 0,
			height: hasOverflowX ? $.position.scrollbarWidth() : 0
		};
	},
	getWithinInfo: function( element ) {
		var withinElement = $( element || window ),
			isElemWindow = isWindow( withinElement[ 0 ] ),
			isDocument = !!withinElement[ 0 ] && withinElement[ 0 ].nodeType === 9,
			hasOffset = !isElemWindow && !isDocument;
		return {
			element: withinElement,
			isWindow: isElemWindow,
			isDocument: isDocument,
			offset: hasOffset ? $( element ).offset() : { left: 0, top: 0 },
			scrollLeft: withinElement.scrollLeft(),
			scrollTop: withinElement.scrollTop(),
			width: withinElement.outerWidth(),
			height: withinElement.outerHeight()
		};
	}
};

$.fn.position = function( options ) {
	if ( !options || !options.of ) {
		return _position.apply( this, arguments );
	}

	// Make a copy, we don't want to modify arguments
	options = $.extend( {}, options );

	var atOffset, targetWidth, targetHeight, targetOffset, basePosition, dimensions,

		// Make sure string options are treated as CSS selectors
		target = typeof options.of === "string" ?
			$( document ).find( options.of ) :
			$( options.of ),

		within = $.position.getWithinInfo( options.within ),
		scrollInfo = $.position.getScrollInfo( within ),
		collision = ( options.collision || "flip" ).split( " " ),
		offsets = {};

	dimensions = getDimensions( target );
	if ( target[ 0 ].preventDefault ) {

		// Force left top to allow flipping
		options.at = "left top";
	}
	targetWidth = dimensions.width;
	targetHeight = dimensions.height;
	targetOffset = dimensions.offset;

	// Clone to reuse original targetOffset later
	basePosition = $.extend( {}, targetOffset );

	// Force my and at to have valid horizontal and vertical positions
	// if a value is missing or invalid, it will be converted to center
	$.each( [ "my", "at" ], function() {
		var pos = ( options[ this ] || "" ).split( " " ),
			horizontalOffset,
			verticalOffset;

		if ( pos.length === 1 ) {
			pos = rhorizontal.test( pos[ 0 ] ) ?
				pos.concat( [ "center" ] ) :
				rvertical.test( pos[ 0 ] ) ?
					[ "center" ].concat( pos ) :
					[ "center", "center" ];
		}
		pos[ 0 ] = rhorizontal.test( pos[ 0 ] ) ? pos[ 0 ] : "center";
		pos[ 1 ] = rvertical.test( pos[ 1 ] ) ? pos[ 1 ] : "center";

		// Calculate offsets
		horizontalOffset = roffset.exec( pos[ 0 ] );
		verticalOffset = roffset.exec( pos[ 1 ] );
		offsets[ this ] = [
			horizontalOffset ? horizontalOffset[ 0 ] : 0,
			verticalOffset ? verticalOffset[ 0 ] : 0
		];

		// Reduce to just the positions without the offsets
		options[ this ] = [
			rposition.exec( pos[ 0 ] )[ 0 ],
			rposition.exec( pos[ 1 ] )[ 0 ]
		];
	} );

	// Normalize collision option
	if ( collision.length === 1 ) {
		collision[ 1 ] = collision[ 0 ];
	}

	if ( options.at[ 0 ] === "right" ) {
		basePosition.left += targetWidth;
	} else if ( options.at[ 0 ] === "center" ) {
		basePosition.left += targetWidth / 2;
	}

	if ( options.at[ 1 ] === "bottom" ) {
		basePosition.top += targetHeight;
	} else if ( options.at[ 1 ] === "center" ) {
		basePosition.top += targetHeight / 2;
	}

	atOffset = getOffsets( offsets.at, targetWidth, targetHeight );
	basePosition.left += atOffset[ 0 ];
	basePosition.top += atOffset[ 1 ];

	return this.each( function() {
		var collisionPosition, using,
			elem = $( this ),
			elemWidth = elem.outerWidth(),
			elemHeight = elem.outerHeight(),
			marginLeft = parseCss( this, "marginLeft" ),
			marginTop = parseCss( this, "marginTop" ),
			collisionWidth = elemWidth + marginLeft + parseCss( this, "marginRight" ) +
				scrollInfo.width,
			collisionHeight = elemHeight + marginTop + parseCss( this, "marginBottom" ) +
				scrollInfo.height,
			position = $.extend( {}, basePosition ),
			myOffset = getOffsets( offsets.my, elem.outerWidth(), elem.outerHeight() );

		if ( options.my[ 0 ] === "right" ) {
			position.left -= elemWidth;
		} else if ( options.my[ 0 ] === "center" ) {
			position.left -= elemWidth / 2;
		}

		if ( options.my[ 1 ] === "bottom" ) {
			position.top -= elemHeight;
		} else if ( options.my[ 1 ] === "center" ) {
			position.top -= elemHeight / 2;
		}

		position.left += myOffset[ 0 ];
		position.top += myOffset[ 1 ];

		collisionPosition = {
			marginLeft: marginLeft,
			marginTop: marginTop
		};

		$.each( [ "left", "top" ], function( i, dir ) {
			if ( $.ui.position[ collision[ i ] ] ) {
				$.ui.position[ collision[ i ] ][ dir ]( position, {
					targetWidth: targetWidth,
					targetHeight: targetHeight,
					elemWidth: elemWidth,
					elemHeight: elemHeight,
					collisionPosition: collisionPosition,
					collisionWidth: collisionWidth,
					collisionHeight: collisionHeight,
					offset: [ atOffset[ 0 ] + myOffset[ 0 ], atOffset [ 1 ] + myOffset[ 1 ] ],
					my: options.my,
					at: options.at,
					within: within,
					elem: elem
				} );
			}
		} );

		if ( options.using ) {

			// Adds feedback as second argument to using callback, if present
			using = function( props ) {
				var left = targetOffset.left - position.left,
					right = left + targetWidth - elemWidth,
					top = targetOffset.top - position.top,
					bottom = top + targetHeight - elemHeight,
					feedback = {
						target: {
							element: target,
							left: targetOffset.left,
							top: targetOffset.top,
							width: targetWidth,
							height: targetHeight
						},
						element: {
							element: elem,
							left: position.left,
							top: position.top,
							width: elemWidth,
							height: elemHeight
						},
						horizontal: right < 0 ? "left" : left > 0 ? "right" : "center",
						vertical: bottom < 0 ? "top" : top > 0 ? "bottom" : "middle"
					};
				if ( targetWidth < elemWidth && abs( left + right ) < targetWidth ) {
					feedback.horizontal = "center";
				}
				if ( targetHeight < elemHeight && abs( top + bottom ) < targetHeight ) {
					feedback.vertical = "middle";
				}
				if ( max( abs( left ), abs( right ) ) > max( abs( top ), abs( bottom ) ) ) {
					feedback.important = "horizontal";
				} else {
					feedback.important = "vertical";
				}
				options.using.call( this, props, feedback );
			};
		}

		elem.offset( $.extend( position, { using: using } ) );
	} );
};

$.ui.position = {
	fit: {
		left: function( position, data ) {
			var within = data.within,
				withinOffset = within.isWindow ? within.scrollLeft : within.offset.left,
				outerWidth = within.width,
				collisionPosLeft = position.left - data.collisionPosition.marginLeft,
				overLeft = withinOffset - collisionPosLeft,
				overRight = collisionPosLeft + data.collisionWidth - outerWidth - withinOffset,
				newOverRight;

			// Element is wider than within
			if ( data.collisionWidth > outerWidth ) {

				// Element is initially over the left side of within
				if ( overLeft > 0 && overRight <= 0 ) {
					newOverRight = position.left + overLeft + data.collisionWidth - outerWidth -
						withinOffset;
					position.left += overLeft - newOverRight;

				// Element is initially over right side of within
				} else if ( overRight > 0 && overLeft <= 0 ) {
					position.left = withinOffset;

				// Element is initially over both left and right sides of within
				} else {
					if ( overLeft > overRight ) {
						position.left = withinOffset + outerWidth - data.collisionWidth;
					} else {
						position.left = withinOffset;
					}
				}

			// Too far left -> align with left edge
			} else if ( overLeft > 0 ) {
				position.left += overLeft;

			// Too far right -> align with right edge
			} else if ( overRight > 0 ) {
				position.left -= overRight;

			// Adjust based on position and margin
			} else {
				position.left = max( position.left - collisionPosLeft, position.left );
			}
		},
		top: function( position, data ) {
			var within = data.within,
				withinOffset = within.isWindow ? within.scrollTop : within.offset.top,
				outerHeight = data.within.height,
				collisionPosTop = position.top - data.collisionPosition.marginTop,
				overTop = withinOffset - collisionPosTop,
				overBottom = collisionPosTop + data.collisionHeight - outerHeight - withinOffset,
				newOverBottom;

			// Element is taller than within
			if ( data.collisionHeight > outerHeight ) {

				// Element is initially over the top of within
				if ( overTop > 0 && overBottom <= 0 ) {
					newOverBottom = position.top + overTop + data.collisionHeight - outerHeight -
						withinOffset;
					position.top += overTop - newOverBottom;

				// Element is initially over bottom of within
				} else if ( overBottom > 0 && overTop <= 0 ) {
					position.top = withinOffset;

				// Element is initially over both top and bottom of within
				} else {
					if ( overTop > overBottom ) {
						position.top = withinOffset + outerHeight - data.collisionHeight;
					} else {
						position.top = withinOffset;
					}
				}

			// Too far up -> align with top
			} else if ( overTop > 0 ) {
				position.top += overTop;

			// Too far down -> align with bottom edge
			} else if ( overBottom > 0 ) {
				position.top -= overBottom;

			// Adjust based on position and margin
			} else {
				position.top = max( position.top - collisionPosTop, position.top );
			}
		}
	},
	flip: {
		left: function( position, data ) {
			var within = data.within,
				withinOffset = within.offset.left + within.scrollLeft,
				outerWidth = within.width,
				offsetLeft = within.isWindow ? within.scrollLeft : within.offset.left,
				collisionPosLeft = position.left - data.collisionPosition.marginLeft,
				overLeft = collisionPosLeft - offsetLeft,
				overRight = collisionPosLeft + data.collisionWidth - outerWidth - offsetLeft,
				myOffset = data.my[ 0 ] === "left" ?
					-data.elemWidth :
					data.my[ 0 ] === "right" ?
						data.elemWidth :
						0,
				atOffset = data.at[ 0 ] === "left" ?
					data.targetWidth :
					data.at[ 0 ] === "right" ?
						-data.targetWidth :
						0,
				offset = -2 * data.offset[ 0 ],
				newOverRight,
				newOverLeft;

			if ( overLeft < 0 ) {
				newOverRight = position.left + myOffset + atOffset + offset + data.collisionWidth -
					outerWidth - withinOffset;
				if ( newOverRight < 0 || newOverRight < abs( overLeft ) ) {
					position.left += myOffset + atOffset + offset;
				}
			} else if ( overRight > 0 ) {
				newOverLeft = position.left - data.collisionPosition.marginLeft + myOffset +
					atOffset + offset - offsetLeft;
				if ( newOverLeft > 0 || abs( newOverLeft ) < overRight ) {
					position.left += myOffset + atOffset + offset;
				}
			}
		},
		top: function( position, data ) {
			var within = data.within,
				withinOffset = within.offset.top + within.scrollTop,
				outerHeight = within.height,
				offsetTop = within.isWindow ? within.scrollTop : within.offset.top,
				collisionPosTop = position.top - data.collisionPosition.marginTop,
				overTop = collisionPosTop - offsetTop,
				overBottom = collisionPosTop + data.collisionHeight - outerHeight - offsetTop,
				top = data.my[ 1 ] === "top",
				myOffset = top ?
					-data.elemHeight :
					data.my[ 1 ] === "bottom" ?
						data.elemHeight :
						0,
				atOffset = data.at[ 1 ] === "top" ?
					data.targetHeight :
					data.at[ 1 ] === "bottom" ?
						-data.targetHeight :
						0,
				offset = -2 * data.offset[ 1 ],
				newOverTop,
				newOverBottom;
			if ( overTop < 0 ) {
				newOverBottom = position.top + myOffset + atOffset + offset + data.collisionHeight -
					outerHeight - withinOffset;
				if ( newOverBottom < 0 || newOverBottom < abs( overTop ) ) {
					position.top += myOffset + atOffset + offset;
				}
			} else if ( overBottom > 0 ) {
				newOverTop = position.top - data.collisionPosition.marginTop + myOffset + atOffset +
					offset - offsetTop;
				if ( newOverTop > 0 || abs( newOverTop ) < overBottom ) {
					position.top += myOffset + atOffset + offset;
				}
			}
		}
	},
	flipfit: {
		left: function() {
			$.ui.position.flip.left.apply( this, arguments );
			$.ui.position.fit.left.apply( this, arguments );
		},
		top: function() {
			$.ui.position.flip.top.apply( this, arguments );
			$.ui.position.fit.top.apply( this, arguments );
		}
	}
};

} )();

var position = $.ui.position;


/*!
 * jQuery UI :data 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: :data Selector
//>>group: Core
//>>description: Selects elements which have data stored under the specified key.
//>>docs: https://api.jqueryui.com/data-selector/


var data = $.extend( $.expr.pseudos, {
	data: $.expr.createPseudo( function( dataName ) {
		return function( elem ) {
			return !!$.data( elem, dataName );
		};
	} )
} );

/*!
 * jQuery UI Disable Selection 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: disableSelection
//>>group: Core
//>>description: Disable selection of text content within the set of matched elements.
//>>docs: https://api.jqueryui.com/disableSelection/

// This file is deprecated

var disableSelection = $.fn.extend( {
	disableSelection: ( function() {
		var eventType = "onselectstart" in document.createElement( "div" ) ?
			"selectstart" :
			"mousedown";

		return function() {
			return this.on( eventType + ".ui-disableSelection", function( event ) {
				event.preventDefault();
			} );
		};
	} )(),

	enableSelection: function() {
		return this.off( ".ui-disableSelection" );
	}
} );



// Create a local jQuery because jQuery Color relies on it and the
// global may not exist with AMD and a custom build (#10199).
// This module is a noop if used as a regular AMD module.
// eslint-disable-next-line no-unused-vars
var jQuery = $;


/*!
 * jQuery Color Animations v3.0.0
 * https://github.com/jquery/jquery-color
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 *
 * Date: Wed May 15 16:49:44 2024 +0200
 */


	var stepHooks = "backgroundColor borderBottomColor borderLeftColor borderRightColor " +
		"borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor",

	class2type = {},
	toString = class2type.toString,

	// plusequals test for += 100 -= 100
	rplusequals = /^([\-+])=\s*(\d+\.?\d*)/,

	// a set of RE's that can match strings and generate color tuples.
	stringParsers = [ {
			re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
			parse: function( execResult ) {
				return [
					execResult[ 1 ],
					execResult[ 2 ],
					execResult[ 3 ],
					execResult[ 4 ]
				];
			}
		}, {
			re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
			parse: function( execResult ) {
				return [
					execResult[ 1 ] * 2.55,
					execResult[ 2 ] * 2.55,
					execResult[ 3 ] * 2.55,
					execResult[ 4 ]
				];
			}
		}, {

			// this regex ignores A-F because it's compared against an already lowercased string
			re: /#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})?/,
			parse: function( execResult ) {
				return [
					parseInt( execResult[ 1 ], 16 ),
					parseInt( execResult[ 2 ], 16 ),
					parseInt( execResult[ 3 ], 16 ),
					execResult[ 4 ] ?
						( parseInt( execResult[ 4 ], 16 ) / 255 ).toFixed( 2 ) :
						1
				];
			}
		}, {

			// this regex ignores A-F because it's compared against an already lowercased string
			re: /#([a-f0-9])([a-f0-9])([a-f0-9])([a-f0-9])?/,
			parse: function( execResult ) {
				return [
					parseInt( execResult[ 1 ] + execResult[ 1 ], 16 ),
					parseInt( execResult[ 2 ] + execResult[ 2 ], 16 ),
					parseInt( execResult[ 3 ] + execResult[ 3 ], 16 ),
					execResult[ 4 ] ?
						( parseInt( execResult[ 4 ] + execResult[ 4 ], 16 ) / 255 )
							.toFixed( 2 ) :
						1
				];
			}
		}, {
			re: /hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
			space: "hsla",
			parse: function( execResult ) {
				return [
					execResult[ 1 ],
					execResult[ 2 ] / 100,
					execResult[ 3 ] / 100,
					execResult[ 4 ]
				];
			}
		} ],

	// jQuery.Color( )
	color = jQuery.Color = function( color, green, blue, alpha ) {
		return new jQuery.Color.fn.parse( color, green, blue, alpha );
	},
	spaces = {
		rgba: {
			props: {
				red: {
					idx: 0,
					type: "byte"
				},
				green: {
					idx: 1,
					type: "byte"
				},
				blue: {
					idx: 2,
					type: "byte"
				}
			}
		},

		hsla: {
			props: {
				hue: {
					idx: 0,
					type: "degrees"
				},
				saturation: {
					idx: 1,
					type: "percent"
				},
				lightness: {
					idx: 2,
					type: "percent"
				}
			}
		}
	},
	propTypes = {
		"byte": {
			floor: true,
			max: 255
		},
		"percent": {
			max: 1
		},
		"degrees": {
			mod: 360,
			floor: true
		}
	},

	// colors = jQuery.Color.names
	colors,

	// local aliases of functions called often
	each = jQuery.each;

// define cache name and alpha properties
// for rgba and hsla spaces
each( spaces, function( spaceName, space ) {
	space.cache = "_" + spaceName;
	space.props.alpha = {
		idx: 3,
		type: "percent",
		def: 1
	};
} );

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function getType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	return typeof obj === "object" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}

function clamp( value, prop, allowEmpty ) {
	var type = propTypes[ prop.type ] || {};

	if ( value == null ) {
		return ( allowEmpty || !prop.def ) ? null : prop.def;
	}

	// ~~ is an short way of doing floor for positive numbers
	value = type.floor ? ~~value : parseFloat( value );

	if ( type.mod ) {

		// we add mod before modding to make sure that negatives values
		// get converted properly: -10 -> 350
		return ( value + type.mod ) % type.mod;
	}

	// for now all property types without mod have min and max
	return Math.min( type.max, Math.max( 0, value ) );
}

function stringParse( string ) {
	var inst = color(),
		rgba = inst._rgba = [];

	string = string.toLowerCase();

	each( stringParsers, function( _i, parser ) {
		var parsed,
			match = parser.re.exec( string ),
			values = match && parser.parse( match ),
			spaceName = parser.space || "rgba";

		if ( values ) {
			parsed = inst[ spaceName ]( values );

			// if this was an rgba parse the assignment might happen twice
			// oh well....
			inst[ spaces[ spaceName ].cache ] = parsed[ spaces[ spaceName ].cache ];
			rgba = inst._rgba = parsed._rgba;

			// exit each( stringParsers ) here because we matched
			return false;
		}
	} );

	// Found a stringParser that handled it
	if ( rgba.length ) {

		// if this came from a parsed string, force "transparent" when alpha is 0
		// chrome, (and maybe others) return "transparent" as rgba(0,0,0,0)
		if ( rgba.join() === "0,0,0,0" ) {
			jQuery.extend( rgba, colors.transparent );
		}
		return inst;
	}

	// named colors
	return colors[ string ];
}

color.fn = jQuery.extend( color.prototype, {
	parse: function( red, green, blue, alpha ) {
		if ( red === undefined ) {
			this._rgba = [ null, null, null, null ];
			return this;
		}
		if ( red.jquery || red.nodeType ) {
			red = jQuery( red ).css( green );
			green = undefined;
		}

		var inst = this,
			type = getType( red ),
			rgba = this._rgba = [];

		// more than 1 argument specified - assume ( red, green, blue, alpha )
		if ( green !== undefined ) {
			red = [ red, green, blue, alpha ];
			type = "array";
		}

		if ( type === "string" ) {
			return this.parse( stringParse( red ) || colors._default );
		}

		if ( type === "array" ) {
			each( spaces.rgba.props, function( _key, prop ) {
				rgba[ prop.idx ] = clamp( red[ prop.idx ], prop );
			} );
			return this;
		}

		if ( type === "object" ) {
			if ( red instanceof color ) {
				each( spaces, function( _spaceName, space ) {
					if ( red[ space.cache ] ) {
						inst[ space.cache ] = red[ space.cache ].slice();
					}
				} );
			} else {
				each( spaces, function( _spaceName, space ) {
					var cache = space.cache;
					each( space.props, function( key, prop ) {

						// if the cache doesn't exist, and we know how to convert
						if ( !inst[ cache ] && space.to ) {

							// if the value was null, we don't need to copy it
							// if the key was alpha, we don't need to copy it either
							if ( key === "alpha" || red[ key ] == null ) {
								return;
							}
							inst[ cache ] = space.to( inst._rgba );
						}

						// this is the only case where we allow nulls for ALL properties.
						// call clamp with alwaysAllowEmpty
						inst[ cache ][ prop.idx ] = clamp( red[ key ], prop, true );
					} );

					// everything defined but alpha?
					if ( inst[ cache ] && jQuery.inArray(
						null,
						inst[ cache ].slice( 0, 3 )
					) < 0 ) {

						// use the default of 1
						if ( inst[ cache ][ 3 ] == null ) {
							inst[ cache ][ 3 ] = 1;
						}

						if ( space.from ) {
							inst._rgba = space.from( inst[ cache ] );
						}
					}
				} );
			}
			return this;
		}
	},
	is: function( compare ) {
		var is = color( compare ),
			same = true,
			inst = this;

		each( spaces, function( _, space ) {
			var localCache,
				isCache = is[ space.cache ];
			if ( isCache ) {
				localCache = inst[ space.cache ] || space.to && space.to( inst._rgba ) || [];
				each( space.props, function( _, prop ) {
					if ( isCache[ prop.idx ] != null ) {
						same = ( isCache[ prop.idx ] === localCache[ prop.idx ] );
						return same;
					}
				} );
			}
			return same;
		} );
		return same;
	},
	_space: function() {
		var used = [],
			inst = this;
		each( spaces, function( spaceName, space ) {
			if ( inst[ space.cache ] ) {
				used.push( spaceName );
			}
		} );
		return used.pop();
	},
	transition: function( other, distance ) {
		var end = color( other ),
			spaceName = end._space(),
			space = spaces[ spaceName ],
			startColor = this.alpha() === 0 ? color( "transparent" ) : this,
			start = startColor[ space.cache ] || space.to( startColor._rgba ),
			result = start.slice();

		end = end[ space.cache ];
		each( space.props, function( _key, prop ) {
			var index = prop.idx,
				startValue = start[ index ],
				endValue = end[ index ],
				type = propTypes[ prop.type ] || {};

			// if null, don't override start value
			if ( endValue === null ) {
				return;
			}

			// if null - use end
			if ( startValue === null ) {
				result[ index ] = endValue;
			} else {
				if ( type.mod ) {
					if ( endValue - startValue > type.mod / 2 ) {
						startValue += type.mod;
					} else if ( startValue - endValue > type.mod / 2 ) {
						startValue -= type.mod;
					}
				}
				result[ index ] = clamp( ( endValue - startValue ) * distance + startValue, prop );
			}
		} );
		return this[ spaceName ]( result );
	},
	blend: function( opaque ) {

		// if we are already opaque - return ourself
		if ( this._rgba[ 3 ] === 1 ) {
			return this;
		}

		var rgb = this._rgba.slice(),
			a = rgb.pop(),
			blend = color( opaque )._rgba;

		return color( jQuery.map( rgb, function( v, i ) {
			return ( 1 - a ) * blend[ i ] + a * v;
		} ) );
	},
	toRgbaString: function() {
		var prefix = "rgba(",
			rgba = jQuery.map( this._rgba, function( v, i ) {
				if ( v != null ) {
					return v;
				}
				return i > 2 ? 1 : 0;
			} );

		if ( rgba[ 3 ] === 1 ) {
			rgba.pop();
			prefix = "rgb(";
		}

		return prefix + rgba.join( ", " ) + ")";
	},
	toHslaString: function() {
		var prefix = "hsla(",
			hsla = jQuery.map( this.hsla(), function( v, i ) {
				if ( v == null ) {
					v = i > 2 ? 1 : 0;
				}

				// catch 1 and 2
				if ( i && i < 3 ) {
					v = Math.round( v * 100 ) + "%";
				}
				return v;
			} );

		if ( hsla[ 3 ] === 1 ) {
			hsla.pop();
			prefix = "hsl(";
		}
		return prefix + hsla.join( ", " ) + ")";
	},
	toHexString: function( includeAlpha ) {
		var rgba = this._rgba.slice(),
			alpha = rgba.pop();

		if ( includeAlpha ) {
			rgba.push( ~~( alpha * 255 ) );
		}

		return "#" + jQuery.map( rgba, function( v ) {

			// default to 0 when nulls exist
			return ( "0" + ( v || 0 ).toString( 16 ) ).substr( -2 );
		} ).join( "" );
	},
	toString: function() {
		return this.toRgbaString();
	}
} );
color.fn.parse.prototype = color.fn;

// hsla conversions adapted from:
// https://code.google.com/p/maashaack/source/browse/packages/graphics/trunk/src/graphics/colors/HUE2RGB.as?r=5021

function hue2rgb( p, q, h ) {
	h = ( h + 1 ) % 1;
	if ( h * 6 < 1 ) {
		return p + ( q - p ) * h * 6;
	}
	if ( h * 2 < 1 ) {
		return q;
	}
	if ( h * 3 < 2 ) {
		return p + ( q - p ) * ( ( 2 / 3 ) - h ) * 6;
	}
	return p;
}

spaces.hsla.to = function( rgba ) {
	if ( rgba[ 0 ] == null || rgba[ 1 ] == null || rgba[ 2 ] == null ) {
		return [ null, null, null, rgba[ 3 ] ];
	}
	var r = rgba[ 0 ] / 255,
		g = rgba[ 1 ] / 255,
		b = rgba[ 2 ] / 255,
		a = rgba[ 3 ],
		max = Math.max( r, g, b ),
		min = Math.min( r, g, b ),
		diff = max - min,
		add = max + min,
		l = add * 0.5,
		h, s;

	if ( min === max ) {
		h = 0;
	} else if ( r === max ) {
		h = ( 60 * ( g - b ) / diff ) + 360;
	} else if ( g === max ) {
		h = ( 60 * ( b - r ) / diff ) + 120;
	} else {
		h = ( 60 * ( r - g ) / diff ) + 240;
	}

	// chroma (diff) == 0 means greyscale which, by definition, saturation = 0%
	// otherwise, saturation is based on the ratio of chroma (diff) to lightness (add)
	if ( diff === 0 ) {
		s = 0;
	} else if ( l <= 0.5 ) {
		s = diff / add;
	} else {
		s = diff / ( 2 - add );
	}
	return [ Math.round( h ) % 360, s, l, a == null ? 1 : a ];
};

spaces.hsla.from = function( hsla ) {
	if ( hsla[ 0 ] == null || hsla[ 1 ] == null || hsla[ 2 ] == null ) {
		return [ null, null, null, hsla[ 3 ] ];
	}
	var h = hsla[ 0 ] / 360,
		s = hsla[ 1 ],
		l = hsla[ 2 ],
		a = hsla[ 3 ],
		q = l <= 0.5 ? l * ( 1 + s ) : l + s - l * s,
		p = 2 * l - q;

	return [
		Math.round( hue2rgb( p, q, h + ( 1 / 3 ) ) * 255 ),
		Math.round( hue2rgb( p, q, h ) * 255 ),
		Math.round( hue2rgb( p, q, h - ( 1 / 3 ) ) * 255 ),
		a
	];
};


each( spaces, function( spaceName, space ) {
	var props = space.props,
		cache = space.cache,
		to = space.to,
		from = space.from;

	// makes rgba() and hsla()
	color.fn[ spaceName ] = function( value ) {

		// generate a cache for this space if it doesn't exist
		if ( to && !this[ cache ] ) {
			this[ cache ] = to( this._rgba );
		}
		if ( value === undefined ) {
			return this[ cache ].slice();
		}

		var ret,
			type = getType( value ),
			arr = ( type === "array" || type === "object" ) ? value : arguments,
			local = this[ cache ].slice();

		each( props, function( key, prop ) {
			var val = arr[ type === "object" ? key : prop.idx ];
			if ( val == null ) {
				val = local[ prop.idx ];
			}
			local[ prop.idx ] = clamp( val, prop );
		} );

		if ( from ) {
			ret = color( from( local ) );
			ret[ cache ] = local;
			return ret;
		} else {
			return color( local );
		}
	};

	// makes red() green() blue() alpha() hue() saturation() lightness()
	each( props, function( key, prop ) {

		// alpha is included in more than one space
		if ( color.fn[ key ] ) {
			return;
		}
		color.fn[ key ] = function( value ) {
			var local, cur, match, fn,
				vtype = getType( value );

			if ( key === "alpha" ) {
				fn = this._hsla ? "hsla" : "rgba";
			} else {
				fn = spaceName;
			}
			local = this[ fn ]();
			cur = local[ prop.idx ];

			if ( vtype === "undefined" ) {
				return cur;
			}

			if ( vtype === "function" ) {
				value = value.call( this, cur );
				vtype = getType( value );
			}
			if ( value == null && prop.empty ) {
				return this;
			}
			if ( vtype === "string" ) {
				match = rplusequals.exec( value );
				if ( match ) {
					value = cur + parseFloat( match[ 2 ] ) * ( match[ 1 ] === "+" ? 1 : -1 );
				}
			}
			local[ prop.idx ] = value;
			return this[ fn ]( local );
		};
	} );
} );

// add cssHook and .fx.step function for each named hook.
// accept a space separated string of properties
color.hook = function( hook ) {
	var hooks = hook.split( " " );
	each( hooks, function( _i, hook ) {
		jQuery.cssHooks[ hook ] = {
			set: function( elem, value ) {
				var parsed;

				if ( value !== "transparent" &&
					( getType( value ) !== "string" ||
						( parsed = stringParse( value ) ) ) ) {
					value = color( parsed || value );
					value = value.toRgbaString();
				}
				elem.style[ hook ] = value;
			}
		};
		jQuery.fx.step[ hook ] = function( fx ) {
			if ( !fx.colorInit ) {
				fx.start = color( fx.elem, hook );
				fx.end = color( fx.end );
				fx.colorInit = true;
			}
			jQuery.cssHooks[ hook ].set( fx.elem, fx.start.transition( fx.end, fx.pos ) );
		};
	} );

};

color.hook( stepHooks );

jQuery.cssHooks.borderColor = {
	expand: function( value ) {
		var expanded = {};

		each( [ "Top", "Right", "Bottom", "Left" ], function( _i, part ) {
			expanded[ "border" + part + "Color" ] = value;
		} );
		return expanded;
	}
};

// Basic color names only.
// Usage of any of the other color names requires adding yourself or including
// jquery.color.svg-names.js.
colors = jQuery.Color.names = {

	// 4.1. Basic color keywords
	aqua: "#00ffff",
	black: "#000000",
	blue: "#0000ff",
	fuchsia: "#ff00ff",
	gray: "#808080",
	green: "#008000",
	lime: "#00ff00",
	maroon: "#800000",
	navy: "#000080",
	olive: "#808000",
	purple: "#800080",
	red: "#ff0000",
	silver: "#c0c0c0",
	teal: "#008080",
	white: "#ffffff",
	yellow: "#ffff00",

	// 4.2.3. "transparent" color keyword
	transparent: [ null, null, null, 0 ],

	_default: "#ffffff"
};


/*!
 * jQuery UI Effects 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Effects Core
//>>group: Effects
/* eslint-disable max-len */
//>>description: Extends the internal jQuery effects. Includes morphing and easing. Required by all other effects.
/* eslint-enable max-len */
//>>docs: https://api.jqueryui.com/category/effects-core/
//>>demos: https://jqueryui.com/effect/


var dataSpace = "ui-effects-",
	dataSpaceStyle = "ui-effects-style",
	dataSpaceAnimated = "ui-effects-animated";

$.effects = {
	effect: {}
};

/******************************************************************************/
/****************************** CLASS ANIMATIONS ******************************/
/******************************************************************************/
( function() {

var classAnimationActions = [ "add", "remove", "toggle" ],
	shorthandStyles = {
		border: 1,
		borderBottom: 1,
		borderColor: 1,
		borderLeft: 1,
		borderRight: 1,
		borderTop: 1,
		borderWidth: 1,
		margin: 1,
		padding: 1
	};

$.each(
	[ "borderLeftStyle", "borderRightStyle", "borderBottomStyle", "borderTopStyle" ],
	function( _, prop ) {
		$.fx.step[ prop ] = function( fx ) {
			if ( fx.end !== "none" && !fx.setAttr || fx.pos === 1 && !fx.setAttr ) {
				jQuery.style( fx.elem, prop, fx.end );
				fx.setAttr = true;
			}
		};
	}
);

function camelCase( string ) {
	return string.replace( /-([\da-z])/gi, function( all, letter ) {
		return letter.toUpperCase();
	} );
}

function getElementStyles( elem ) {
	var key, len,
		style = elem.ownerDocument.defaultView.getComputedStyle( elem ),
		styles = {};

	len = style.length;
	while ( len-- ) {
		key = style[ len ];
		if ( typeof style[ key ] === "string" ) {
			styles[ camelCase( key ) ] = style[ key ];
		}
	}

	return styles;
}

function styleDifference( oldStyle, newStyle ) {
	var diff = {},
		name, value;

	for ( name in newStyle ) {
		value = newStyle[ name ];
		if ( oldStyle[ name ] !== value ) {
			if ( !shorthandStyles[ name ] ) {
				if ( $.fx.step[ name ] || !isNaN( parseFloat( value ) ) ) {
					diff[ name ] = value;
				}
			}
		}
	}

	return diff;
}

$.effects.animateClass = function( value, duration, easing, callback ) {
	var o = $.speed( duration, easing, callback );

	return this.queue( function() {
		var animated = $( this ),
			baseClass = animated.attr( "class" ) || "",
			applyClassChange,
			allAnimations = o.children ? animated.find( "*" ).addBack() : animated;

		// Map the animated objects to store the original styles.
		allAnimations = allAnimations.map( function() {
			var el = $( this );
			return {
				el: el,
				start: getElementStyles( this )
			};
		} );

		// Apply class change
		applyClassChange = function() {
			$.each( classAnimationActions, function( i, action ) {
				if ( value[ action ] ) {
					animated[ action + "Class" ]( value[ action ] );
				}
			} );
		};
		applyClassChange();

		// Map all animated objects again - calculate new styles and diff
		allAnimations = allAnimations.map( function() {
			this.end = getElementStyles( this.el[ 0 ] );
			this.diff = styleDifference( this.start, this.end );
			return this;
		} );

		// Apply original class
		animated.attr( "class", baseClass );

		// Map all animated objects again - this time collecting a promise
		allAnimations = allAnimations.map( function() {
			var styleInfo = this,
				dfd = $.Deferred(),
				opts = $.extend( {}, o, {
					queue: false,
					complete: function() {
						dfd.resolve( styleInfo );
					}
				} );

			this.el.animate( this.diff, opts );
			return dfd.promise();
		} );

		// Once all animations have completed:
		$.when.apply( $, allAnimations.get() ).done( function() {

			// Set the final class
			applyClassChange();

			// For each animated element,
			// clear all css properties that were animated
			$.each( arguments, function() {
				var el = this.el;
				$.each( this.diff, function( key ) {
					el.css( key, "" );
				} );
			} );

			// This is guarnteed to be there if you use jQuery.speed()
			// it also handles dequeuing the next anim...
			o.complete.call( animated[ 0 ] );
		} );
	} );
};

$.fn.extend( {
	addClass: ( function( orig ) {
		return function( classNames, speed, easing, callback ) {
			return speed ?
				$.effects.animateClass.call( this,
					{ add: classNames }, speed, easing, callback ) :
				orig.apply( this, arguments );
		};
	} )( $.fn.addClass ),

	removeClass: ( function( orig ) {
		return function( classNames, speed, easing, callback ) {
			return arguments.length > 1 ?
				$.effects.animateClass.call( this,
					{ remove: classNames }, speed, easing, callback ) :
				orig.apply( this, arguments );
		};
	} )( $.fn.removeClass ),

	toggleClass: ( function( orig ) {
		return function( classNames, force, speed, easing, callback ) {
			if ( typeof force === "boolean" || force === undefined ) {
				if ( !speed ) {

					// Without speed parameter
					return orig.apply( this, arguments );
				} else {
					return $.effects.animateClass.call( this,
						( force ? { add: classNames } : { remove: classNames } ),
						speed, easing, callback );
				}
			} else {

				// Without force parameter
				return $.effects.animateClass.call( this,
					{ toggle: classNames }, force, speed, easing );
			}
		};
	} )( $.fn.toggleClass ),

	switchClass: function( remove, add, speed, easing, callback ) {
		return $.effects.animateClass.call( this, {
			add: add,
			remove: remove
		}, speed, easing, callback );
	}
} );

} )();

/******************************************************************************/
/*********************************** EFFECTS **********************************/
/******************************************************************************/

( function() {

if ( $.expr && $.expr.pseudos && $.expr.pseudos.animated ) {
	$.expr.pseudos.animated = ( function( orig ) {
		return function( elem ) {
			return !!$( elem ).data( dataSpaceAnimated ) || orig( elem );
		};
	} )( $.expr.pseudos.animated );
}

if ( $.uiBackCompat === true ) {
	$.extend( $.effects, {

		// Saves a set of properties in a data storage
		save: function( element, set ) {
			var i = 0, length = set.length;
			for ( ; i < length; i++ ) {
				if ( set[ i ] !== null ) {
					element.data( dataSpace + set[ i ], element[ 0 ].style[ set[ i ] ] );
				}
			}
		},

		// Restores a set of previously saved properties from a data storage
		restore: function( element, set ) {
			var val, i = 0, length = set.length;
			for ( ; i < length; i++ ) {
				if ( set[ i ] !== null ) {
					val = element.data( dataSpace + set[ i ] );
					element.css( set[ i ], val );
				}
			}
		},

		setMode: function( el, mode ) {
			if ( mode === "toggle" ) {
				mode = el.is( ":hidden" ) ? "show" : "hide";
			}
			return mode;
		},

		// Wraps the element around a wrapper that copies position properties
		createWrapper: function( element ) {

			// If the element is already wrapped, return it
			if ( element.parent().is( ".ui-effects-wrapper" ) ) {
				return element.parent();
			}

			// Wrap the element
			var props = {
					width: element.outerWidth( true ),
					height: element.outerHeight( true ),
					"float": element.css( "float" )
				},
				wrapper = $( "<div></div>" )
					.addClass( "ui-effects-wrapper" )
					.css( {
						fontSize: "100%",
						background: "transparent",
						border: "none",
						margin: 0,
						padding: 0
					} ),

				// Store the size in case width/height are defined in % - Fixes #5245
				size = {
					width: element.width(),
					height: element.height()
				},
				active = document.activeElement;

			// Support: Firefox
			// Firefox incorrectly exposes anonymous content
			// https://bugzilla.mozilla.org/show_bug.cgi?id=561664
			try {
				// eslint-disable-next-line no-unused-expressions
				active.id;
			} catch ( e ) {
				active = document.body;
			}

			element.wrap( wrapper );

			// Fixes #7595 - Elements lose focus when wrapped.
			if ( element[ 0 ] === active || $.contains( element[ 0 ], active ) ) {
				$( active ).trigger( "focus" );
			}

			// Hotfix for jQuery 1.4 since some change in wrap() seems to actually
			// lose the reference to the wrapped element
			wrapper = element.parent();

			// Transfer positioning properties to the wrapper
			if ( element.css( "position" ) === "static" ) {
				wrapper.css( { position: "relative" } );
				element.css( { position: "relative" } );
			} else {
				$.extend( props, {
					position: element.css( "position" ),
					zIndex: element.css( "z-index" )
				} );
				$.each( [ "top", "left", "bottom", "right" ], function( i, pos ) {
					props[ pos ] = element.css( pos );
					if ( isNaN( parseInt( props[ pos ], 10 ) ) ) {
						props[ pos ] = "auto";
					}
				} );
				element.css( {
					position: "relative",
					top: 0,
					left: 0,
					right: "auto",
					bottom: "auto"
				} );
			}
			element.css( size );

			return wrapper.css( props ).show();
		},

		removeWrapper: function( element ) {
			var active = document.activeElement;

			if ( element.parent().is( ".ui-effects-wrapper" ) ) {
				element.parent().replaceWith( element );

				// Fixes #7595 - Elements lose focus when wrapped.
				if ( element[ 0 ] === active || $.contains( element[ 0 ], active ) ) {
					$( active ).trigger( "focus" );
				}
			}

			return element;
		}
	} );
}

$.extend( $.effects, {
	version: "1.14.1",

	define: function( name, mode, effect ) {
		if ( !effect ) {
			effect = mode;
			mode = "effect";
		}

		$.effects.effect[ name ] = effect;
		$.effects.effect[ name ].mode = mode;

		return effect;
	},

	scaledDimensions: function( element, percent, direction ) {
		if ( percent === 0 ) {
			return {
				height: 0,
				width: 0,
				outerHeight: 0,
				outerWidth: 0
			};
		}

		var x = direction !== "horizontal" ? ( ( percent || 100 ) / 100 ) : 1,
			y = direction !== "vertical" ? ( ( percent || 100 ) / 100 ) : 1;

		return {
			height: element.height() * y,
			width: element.width() * x,
			outerHeight: element.outerHeight() * y,
			outerWidth: element.outerWidth() * x
		};

	},

	clipToBox: function( animation ) {
		return {
			width: animation.clip.right - animation.clip.left,
			height: animation.clip.bottom - animation.clip.top,
			left: animation.clip.left,
			top: animation.clip.top
		};
	},

	// Injects recently queued functions to be first in line (after "inprogress")
	unshift: function( element, queueLength, count ) {
		var queue = element.queue();

		if ( queueLength > 1 ) {
			queue.splice.apply( queue,
				[ 1, 0 ].concat( queue.splice( queueLength, count ) ) );
		}
		element.dequeue();
	},

	saveStyle: function( element ) {
		element.data( dataSpaceStyle, element[ 0 ].style.cssText );
	},

	restoreStyle: function( element ) {
		element[ 0 ].style.cssText = element.data( dataSpaceStyle ) || "";
		element.removeData( dataSpaceStyle );
	},

	mode: function( element, mode ) {
		var hidden = element.is( ":hidden" );

		if ( mode === "toggle" ) {
			mode = hidden ? "show" : "hide";
		}
		if ( hidden ? mode === "hide" : mode === "show" ) {
			mode = "none";
		}
		return mode;
	},

	// Translates a [top,left] array into a baseline value
	getBaseline: function( origin, original ) {
		var y, x;

		switch ( origin[ 0 ] ) {
		case "top":
			y = 0;
			break;
		case "middle":
			y = 0.5;
			break;
		case "bottom":
			y = 1;
			break;
		default:
			y = origin[ 0 ] / original.height;
		}

		switch ( origin[ 1 ] ) {
		case "left":
			x = 0;
			break;
		case "center":
			x = 0.5;
			break;
		case "right":
			x = 1;
			break;
		default:
			x = origin[ 1 ] / original.width;
		}

		return {
			x: x,
			y: y
		};
	},

	// Creates a placeholder element so that the original element can be made absolute
	createPlaceholder: function( element ) {
		var placeholder,
			cssPosition = element.css( "position" ),
			position = element.position();

		// Lock in margins first to account for form elements, which
		// will change margin if you explicitly set height
		// see: https://jsfiddle.net/JZSMt/3/ https://bugs.webkit.org/show_bug.cgi?id=107380
		// Support: Safari
		element.css( {
			marginTop: element.css( "marginTop" ),
			marginBottom: element.css( "marginBottom" ),
			marginLeft: element.css( "marginLeft" ),
			marginRight: element.css( "marginRight" )
		} )
		.outerWidth( element.outerWidth() )
		.outerHeight( element.outerHeight() );

		if ( /^(static|relative)/.test( cssPosition ) ) {
			cssPosition = "absolute";

			placeholder = $( "<" + element[ 0 ].nodeName + ">" ).insertAfter( element ).css( {

				// Convert inline to inline block to account for inline elements
				// that turn to inline block based on content (like img)
				display: /^(inline|ruby)/.test( element.css( "display" ) ) ?
					"inline-block" :
					"block",
				visibility: "hidden",

				// Margins need to be set to account for margin collapse
				marginTop: element.css( "marginTop" ),
				marginBottom: element.css( "marginBottom" ),
				marginLeft: element.css( "marginLeft" ),
				marginRight: element.css( "marginRight" ),
				"float": element.css( "float" )
			} )
			.outerWidth( element.outerWidth() )
			.outerHeight( element.outerHeight() )
			.addClass( "ui-effects-placeholder" );

			element.data( dataSpace + "placeholder", placeholder );
		}

		element.css( {
			position: cssPosition,
			left: position.left,
			top: position.top
		} );

		return placeholder;
	},

	removePlaceholder: function( element ) {
		var dataKey = dataSpace + "placeholder",
				placeholder = element.data( dataKey );

		if ( placeholder ) {
			placeholder.remove();
			element.removeData( dataKey );
		}
	},

	// Removes a placeholder if it exists and restores
	// properties that were modified during placeholder creation
	cleanUp: function( element ) {
		$.effects.restoreStyle( element );
		$.effects.removePlaceholder( element );
	},

	setTransition: function( element, list, factor, value ) {
		value = value || {};
		$.each( list, function( i, x ) {
			var unit = element.cssUnit( x );
			if ( unit[ 0 ] > 0 ) {
				value[ x ] = unit[ 0 ] * factor + unit[ 1 ];
			}
		} );
		return value;
	}
} );

// Return an effect options object for the given parameters:
function _normalizeArguments( effect, options, speed, callback ) {

	// Allow passing all options as the first parameter
	if ( $.isPlainObject( effect ) ) {
		options = effect;
		effect = effect.effect;
	}

	// Convert to an object
	effect = { effect: effect };

	// Catch (effect, null, ...)
	if ( options == null ) {
		options = {};
	}

	// Catch (effect, callback)
	if ( typeof options === "function" ) {
		callback = options;
		speed = null;
		options = {};
	}

	// Catch (effect, speed, ?)
	if ( typeof options === "number" || $.fx.speeds[ options ] ) {
		callback = speed;
		speed = options;
		options = {};
	}

	// Catch (effect, options, callback)
	if ( typeof speed === "function" ) {
		callback = speed;
		speed = null;
	}

	// Add options to effect
	if ( options ) {
		$.extend( effect, options );
	}

	speed = speed || options.duration;
	effect.duration = $.fx.off ? 0 :
		typeof speed === "number" ? speed :
		speed in $.fx.speeds ? $.fx.speeds[ speed ] :
		$.fx.speeds._default;

	effect.complete = callback || options.complete;

	return effect;
}

function standardAnimationOption( option ) {

	// Valid standard speeds (nothing, number, named speed)
	if ( !option || typeof option === "number" || $.fx.speeds[ option ] ) {
		return true;
	}

	// Invalid strings - treat as "normal" speed
	if ( typeof option === "string" && !$.effects.effect[ option ] ) {
		return true;
	}

	// Complete callback
	if ( typeof option === "function" ) {
		return true;
	}

	// Options hash (but not naming an effect)
	if ( typeof option === "object" && !option.effect ) {
		return true;
	}

	// Didn't match any standard API
	return false;
}

$.fn.extend( {
	effect: function( /* effect, options, speed, callback */ ) {
		var args = _normalizeArguments.apply( this, arguments ),
			effectMethod = $.effects.effect[ args.effect ],
			defaultMode = effectMethod.mode,
			queue = args.queue,
			queueName = queue || "fx",
			complete = args.complete,
			mode = args.mode,
			modes = [],
			prefilter = function( next ) {
				var el = $( this ),
					normalizedMode = $.effects.mode( el, mode ) || defaultMode;

				// Sentinel for duck-punching the :animated pseudo-selector
				el.data( dataSpaceAnimated, true );

				// Save effect mode for later use,
				// we can't just call $.effects.mode again later,
				// as the .show() below destroys the initial state
				modes.push( normalizedMode );

				// See $.uiBackCompat inside of run() for removal of defaultMode in 1.14
				if ( defaultMode && ( normalizedMode === "show" ||
						( normalizedMode === defaultMode && normalizedMode === "hide" ) ) ) {
					el.show();
				}

				if ( !defaultMode || normalizedMode !== "none" ) {
					$.effects.saveStyle( el );
				}

				if ( typeof next === "function" ) {
					next();
				}
			};

		if ( $.fx.off || !effectMethod ) {

			// Delegate to the original method (e.g., .show()) if possible
			if ( mode ) {
				return this[ mode ]( args.duration, complete );
			} else {
				return this.each( function() {
					if ( complete ) {
						complete.call( this );
					}
				} );
			}
		}

		function run( next ) {
			var elem = $( this );

			function cleanup() {
				elem.removeData( dataSpaceAnimated );

				$.effects.cleanUp( elem );

				if ( args.mode === "hide" ) {
					elem.hide();
				}

				done();
			}

			function done() {
				if ( typeof complete === "function" ) {
					complete.call( elem[ 0 ] );
				}

				if ( typeof next === "function" ) {
					next();
				}
			}

			// Override mode option on a per element basis,
			// as toggle can be either show or hide depending on element state
			args.mode = modes.shift();

			if ( $.uiBackCompat === true && !defaultMode ) {
				if ( elem.is( ":hidden" ) ? mode === "hide" : mode === "show" ) {

					// Call the core method to track "olddisplay" properly
					elem[ mode ]();
					done();
				} else {
					effectMethod.call( elem[ 0 ], args, done );
				}
			} else {
				if ( args.mode === "none" ) {

					// Call the core method to track "olddisplay" properly
					elem[ mode ]();
					done();
				} else {
					effectMethod.call( elem[ 0 ], args, cleanup );
				}
			}
		}

		// Run prefilter on all elements first to ensure that
		// any showing or hiding happens before placeholder creation,
		// which ensures that any layout changes are correctly captured.
		return queue === false ?
			this.each( prefilter ).each( run ) :
			this.queue( queueName, prefilter ).queue( queueName, run );
	},

	show: ( function( orig ) {
		return function( option ) {
			if ( standardAnimationOption( option ) ) {
				return orig.apply( this, arguments );
			} else {
				var args = _normalizeArguments.apply( this, arguments );
				args.mode = "show";
				return this.effect.call( this, args );
			}
		};
	} )( $.fn.show ),

	hide: ( function( orig ) {
		return function( option ) {
			if ( standardAnimationOption( option ) ) {
				return orig.apply( this, arguments );
			} else {
				var args = _normalizeArguments.apply( this, arguments );
				args.mode = "hide";
				return this.effect.call( this, args );
			}
		};
	} )( $.fn.hide ),

	toggle: ( function( orig ) {
		return function( option ) {
			if ( standardAnimationOption( option ) || typeof option === "boolean" ) {
				return orig.apply( this, arguments );
			} else {
				var args = _normalizeArguments.apply( this, arguments );
				args.mode = "toggle";
				return this.effect.call( this, args );
			}
		};
	} )( $.fn.toggle ),

	cssUnit: function( key ) {
		var style = this.css( key ),
			val = [];

		$.each( [ "em", "px", "%", "pt" ], function( i, unit ) {
			if ( style.indexOf( unit ) > 0 ) {
				val = [ parseFloat( style ), unit ];
			}
		} );
		return val;
	},

	cssClip: function( clipObj ) {
		if ( clipObj ) {
			return this.css( "clip", "rect(" + clipObj.top + "px " + clipObj.right + "px " +
				clipObj.bottom + "px " + clipObj.left + "px)" );
		}
		return parseClip( this.css( "clip" ), this );
	},

	transfer: function( options, done ) {
		var element = $( this ),
			target = $( options.to ),
			targetFixed = target.css( "position" ) === "fixed",
			body = $( "body" ),
			fixTop = targetFixed ? body.scrollTop() : 0,
			fixLeft = targetFixed ? body.scrollLeft() : 0,
			endPosition = target.offset(),
			animation = {
				top: endPosition.top - fixTop,
				left: endPosition.left - fixLeft,
				height: target.innerHeight(),
				width: target.innerWidth()
			},
			startPosition = element.offset(),
			transfer = $( "<div class='ui-effects-transfer'></div>" );

		transfer
			.appendTo( "body" )
			.addClass( options.className )
			.css( {
				top: startPosition.top - fixTop,
				left: startPosition.left - fixLeft,
				height: element.innerHeight(),
				width: element.innerWidth(),
				position: targetFixed ? "fixed" : "absolute"
			} )
			.animate( animation, options.duration, options.easing, function() {
				transfer.remove();
				if ( typeof done === "function" ) {
					done();
				}
			} );
	}
} );

function parseClip( str, element ) {
		var outerWidth = element.outerWidth(),
			outerHeight = element.outerHeight(),
			clipRegex = /^rect\((-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto)\)$/,
			values = clipRegex.exec( str ) || [ "", 0, outerWidth, outerHeight, 0 ];

		return {
			top: parseFloat( values[ 1 ] ) || 0,
			right: values[ 2 ] === "auto" ? outerWidth : parseFloat( values[ 2 ] ),
			bottom: values[ 3 ] === "auto" ? outerHeight : parseFloat( values[ 3 ] ),
			left: parseFloat( values[ 4 ] ) || 0
		};
}

$.fx.step.clip = function( fx ) {
	if ( !fx.clipInit ) {
		fx.start = $( fx.elem ).cssClip();
		if ( typeof fx.end === "string" ) {
			fx.end = parseClip( fx.end, fx.elem );
		}
		fx.clipInit = true;
	}

	$( fx.elem ).cssClip( {
		top: fx.pos * ( fx.end.top - fx.start.top ) + fx.start.top,
		right: fx.pos * ( fx.end.right - fx.start.right ) + fx.start.right,
		bottom: fx.pos * ( fx.end.bottom - fx.start.bottom ) + fx.start.bottom,
		left: fx.pos * ( fx.end.left - fx.start.left ) + fx.start.left
	} );
};

} )();

/******************************************************************************/
/*********************************** EASING ***********************************/
/******************************************************************************/

( function() {

// Based on easing equations from Robert Penner (http://robertpenner.com/easing)

var baseEasings = {};

$.each( [ "Quad", "Cubic", "Quart", "Quint", "Expo" ], function( i, name ) {
	baseEasings[ name ] = function( p ) {
		return Math.pow( p, i + 2 );
	};
} );

$.extend( baseEasings, {
	Sine: function( p ) {
		return 1 - Math.cos( p * Math.PI / 2 );
	},
	Circ: function( p ) {
		return 1 - Math.sqrt( 1 - p * p );
	},
	Elastic: function( p ) {
		return p === 0 || p === 1 ? p :
			-Math.pow( 2, 8 * ( p - 1 ) ) * Math.sin( ( ( p - 1 ) * 80 - 7.5 ) * Math.PI / 15 );
	},
	Back: function( p ) {
		return p * p * ( 3 * p - 2 );
	},
	Bounce: function( p ) {
		var pow2,
			bounce = 4;

		while ( p < ( ( pow2 = Math.pow( 2, --bounce ) ) - 1 ) / 11 ) {}
		return 1 / Math.pow( 4, 3 - bounce ) - 7.5625 * Math.pow( ( pow2 * 3 - 2 ) / 22 - p, 2 );
	}
} );

$.each( baseEasings, function( name, easeIn ) {
	$.easing[ "easeIn" + name ] = easeIn;
	$.easing[ "easeOut" + name ] = function( p ) {
		return 1 - easeIn( 1 - p );
	};
	$.easing[ "easeInOut" + name ] = function( p ) {
		return p < 0.5 ?
			easeIn( p * 2 ) / 2 :
			1 - easeIn( p * -2 + 2 ) / 2;
	};
} );

} )();

var effect = $.effects;


/*!
 * jQuery UI Effects Blind 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Blind Effect
//>>group: Effects
//>>description: Blinds the element.
//>>docs: https://api.jqueryui.com/blind-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectBlind = $.effects.define( "blind", "hide", function( options, done ) {
	var map = {
			up: [ "bottom", "top" ],
			vertical: [ "bottom", "top" ],
			down: [ "top", "bottom" ],
			left: [ "right", "left" ],
			horizontal: [ "right", "left" ],
			right: [ "left", "right" ]
		},
		element = $( this ),
		direction = options.direction || "up",
		start = element.cssClip(),
		animate = { clip: $.extend( {}, start ) },
		placeholder = $.effects.createPlaceholder( element );

	animate.clip[ map[ direction ][ 0 ] ] = animate.clip[ map[ direction ][ 1 ] ];

	if ( options.mode === "show" ) {
		element.cssClip( animate.clip );
		if ( placeholder ) {
			placeholder.css( $.effects.clipToBox( animate ) );
		}

		animate.clip = start;
	}

	if ( placeholder ) {
		placeholder.animate( $.effects.clipToBox( animate ), options.duration, options.easing );
	}

	element.animate( animate, {
		queue: false,
		duration: options.duration,
		easing: options.easing,
		complete: done
	} );
} );


/*!
 * jQuery UI Effects Bounce 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Bounce Effect
//>>group: Effects
//>>description: Bounces an element horizontally or vertically n times.
//>>docs: https://api.jqueryui.com/bounce-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectBounce = $.effects.define( "bounce", function( options, done ) {
	var upAnim, downAnim, refValue,
		element = $( this ),

		// Defaults:
		mode = options.mode,
		hide = mode === "hide",
		show = mode === "show",
		direction = options.direction || "up",
		distance = options.distance,
		times = options.times || 5,

		// Number of internal animations
		anims = times * 2 + ( show || hide ? 1 : 0 ),
		speed = options.duration / anims,
		easing = options.easing,

		// Utility:
		ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
		motion = ( direction === "up" || direction === "left" ),
		i = 0,

		queuelen = element.queue().length;

	$.effects.createPlaceholder( element );

	refValue = element.css( ref );

	// Default distance for the BIGGEST bounce is the outer Distance / 3
	if ( !distance ) {
		distance = element[ ref === "top" ? "outerHeight" : "outerWidth" ]() / 3;
	}

	if ( show ) {
		downAnim = { opacity: 1 };
		downAnim[ ref ] = refValue;

		// If we are showing, force opacity 0 and set the initial position
		// then do the "first" animation
		element
			.css( "opacity", 0 )
			.css( ref, motion ? -distance * 2 : distance * 2 )
			.animate( downAnim, speed, easing );
	}

	// Start at the smallest distance if we are hiding
	if ( hide ) {
		distance = distance / Math.pow( 2, times - 1 );
	}

	downAnim = {};
	downAnim[ ref ] = refValue;

	// Bounces up/down/left/right then back to 0 -- times * 2 animations happen here
	for ( ; i < times; i++ ) {
		upAnim = {};
		upAnim[ ref ] = ( motion ? "-=" : "+=" ) + distance;

		element
			.animate( upAnim, speed, easing )
			.animate( downAnim, speed, easing );

		distance = hide ? distance * 2 : distance / 2;
	}

	// Last Bounce when Hiding
	if ( hide ) {
		upAnim = { opacity: 0 };
		upAnim[ ref ] = ( motion ? "-=" : "+=" ) + distance;

		element.animate( upAnim, speed, easing );
	}

	element.queue( done );

	$.effects.unshift( element, queuelen, anims + 1 );
} );


/*!
 * jQuery UI Effects Clip 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Clip Effect
//>>group: Effects
//>>description: Clips the element on and off like an old TV.
//>>docs: https://api.jqueryui.com/clip-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectClip = $.effects.define( "clip", "hide", function( options, done ) {
	var start,
		animate = {},
		element = $( this ),
		direction = options.direction || "vertical",
		both = direction === "both",
		horizontal = both || direction === "horizontal",
		vertical = both || direction === "vertical";

	start = element.cssClip();
	animate.clip = {
		top: vertical ? ( start.bottom - start.top ) / 2 : start.top,
		right: horizontal ? ( start.right - start.left ) / 2 : start.right,
		bottom: vertical ? ( start.bottom - start.top ) / 2 : start.bottom,
		left: horizontal ? ( start.right - start.left ) / 2 : start.left
	};

	$.effects.createPlaceholder( element );

	if ( options.mode === "show" ) {
		element.cssClip( animate.clip );
		animate.clip = start;
	}

	element.animate( animate, {
		queue: false,
		duration: options.duration,
		easing: options.easing,
		complete: done
	} );

} );


/*!
 * jQuery UI Effects Drop 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Drop Effect
//>>group: Effects
//>>description: Moves an element in one direction and hides it at the same time.
//>>docs: https://api.jqueryui.com/drop-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectDrop = $.effects.define( "drop", "hide", function( options, done ) {

	var distance,
		element = $( this ),
		mode = options.mode,
		show = mode === "show",
		direction = options.direction || "left",
		ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
		motion = ( direction === "up" || direction === "left" ) ? "-=" : "+=",
		oppositeMotion = ( motion === "+=" ) ? "-=" : "+=",
		animation = {
			opacity: 0
		};

	$.effects.createPlaceholder( element );

	distance = options.distance ||
		element[ ref === "top" ? "outerHeight" : "outerWidth" ]( true ) / 2;

	animation[ ref ] = motion + distance;

	if ( show ) {
		element.css( animation );

		animation[ ref ] = oppositeMotion + distance;
		animation.opacity = 1;
	}

	// Animate
	element.animate( animation, {
		queue: false,
		duration: options.duration,
		easing: options.easing,
		complete: done
	} );
} );


/*!
 * jQuery UI Effects Explode 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Explode Effect
//>>group: Effects
/* eslint-disable max-len */
//>>description: Explodes an element in all directions into n pieces. Implodes an element to its original wholeness.
/* eslint-enable max-len */
//>>docs: https://api.jqueryui.com/explode-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectExplode = $.effects.define( "explode", "hide", function( options, done ) {

	var i, j, left, top, mx, my,
		rows = options.pieces ? Math.round( Math.sqrt( options.pieces ) ) : 3,
		cells = rows,
		element = $( this ),
		mode = options.mode,
		show = mode === "show",

		// Show and then visibility:hidden the element before calculating offset
		offset = element.show().css( "visibility", "hidden" ).offset(),

		// Width and height of a piece
		width = Math.ceil( element.outerWidth() / cells ),
		height = Math.ceil( element.outerHeight() / rows ),
		pieces = [];

	// Children animate complete:
	function childComplete() {
		pieces.push( this );
		if ( pieces.length === rows * cells ) {
			animComplete();
		}
	}

	// Clone the element for each row and cell.
	for ( i = 0; i < rows; i++ ) { // ===>
		top = offset.top + i * height;
		my = i - ( rows - 1 ) / 2;

		for ( j = 0; j < cells; j++ ) { // |||
			left = offset.left + j * width;
			mx = j - ( cells - 1 ) / 2;

			// Create a clone of the now hidden main element that will be absolute positioned
			// within a wrapper div off the -left and -top equal to size of our pieces
			element
				.clone()
				.appendTo( "body" )
				.wrap( "<div></div>" )
				.css( {
					position: "absolute",
					visibility: "visible",
					left: -j * width,
					top: -i * height
				} )

				// Select the wrapper - make it overflow: hidden and absolute positioned based on
				// where the original was located +left and +top equal to the size of pieces
				.parent()
					.addClass( "ui-effects-explode" )
					.css( {
						position: "absolute",
						overflow: "hidden",
						width: width,
						height: height,
						left: left + ( show ? mx * width : 0 ),
						top: top + ( show ? my * height : 0 ),
						opacity: show ? 0 : 1
					} )
					.animate( {
						left: left + ( show ? 0 : mx * width ),
						top: top + ( show ? 0 : my * height ),
						opacity: show ? 1 : 0
					}, options.duration || 500, options.easing, childComplete );
		}
	}

	function animComplete() {
		element.css( {
			visibility: "visible"
		} );
		$( pieces ).remove();
		done();
	}
} );


/*!
 * jQuery UI Effects Fade 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Fade Effect
//>>group: Effects
//>>description: Fades the element.
//>>docs: https://api.jqueryui.com/fade-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectFade = $.effects.define( "fade", "toggle", function( options, done ) {
	var show = options.mode === "show";

	$( this )
		.css( "opacity", show ? 0 : 1 )
		.animate( {
			opacity: show ? 1 : 0
		}, {
			queue: false,
			duration: options.duration,
			easing: options.easing,
			complete: done
		} );
} );


/*!
 * jQuery UI Effects Fold 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Fold Effect
//>>group: Effects
//>>description: Folds an element first horizontally and then vertically.
//>>docs: https://api.jqueryui.com/fold-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectFold = $.effects.define( "fold", "hide", function( options, done ) {

	// Create element
	var element = $( this ),
		mode = options.mode,
		show = mode === "show",
		hide = mode === "hide",
		size = options.size || 15,
		percent = /([0-9]+)%/.exec( size ),
		horizFirst = !!options.horizFirst,
		ref = horizFirst ? [ "right", "bottom" ] : [ "bottom", "right" ],
		duration = options.duration / 2,

		placeholder = $.effects.createPlaceholder( element ),

		start = element.cssClip(),
		animation1 = { clip: $.extend( {}, start ) },
		animation2 = { clip: $.extend( {}, start ) },

		distance = [ start[ ref[ 0 ] ], start[ ref[ 1 ] ] ],

		queuelen = element.queue().length;

	if ( percent ) {
		size = parseInt( percent[ 1 ], 10 ) / 100 * distance[ hide ? 0 : 1 ];
	}
	animation1.clip[ ref[ 0 ] ] = size;
	animation2.clip[ ref[ 0 ] ] = size;
	animation2.clip[ ref[ 1 ] ] = 0;

	if ( show ) {
		element.cssClip( animation2.clip );
		if ( placeholder ) {
			placeholder.css( $.effects.clipToBox( animation2 ) );
		}

		animation2.clip = start;
	}

	// Animate
	element
		.queue( function( next ) {
			if ( placeholder ) {
				placeholder
					.animate( $.effects.clipToBox( animation1 ), duration, options.easing )
					.animate( $.effects.clipToBox( animation2 ), duration, options.easing );
			}

			next();
		} )
		.animate( animation1, duration, options.easing )
		.animate( animation2, duration, options.easing )
		.queue( done );

	$.effects.unshift( element, queuelen, 4 );
} );


/*!
 * jQuery UI Effects Highlight 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Highlight Effect
//>>group: Effects
//>>description: Highlights the background of an element in a defined color for a custom duration.
//>>docs: https://api.jqueryui.com/highlight-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectHighlight = $.effects.define( "highlight", "show", function( options, done ) {
	var element = $( this ),
		animation = {
			backgroundColor: element.css( "backgroundColor" )
		};

	if ( options.mode === "hide" ) {
		animation.opacity = 0;
	}

	$.effects.saveStyle( element );

	element
		.css( {
			backgroundImage: "none",
			backgroundColor: options.color || "#ffff99"
		} )
		.animate( animation, {
			queue: false,
			duration: options.duration,
			easing: options.easing,
			complete: done
		} );
} );


/*!
 * jQuery UI Effects Size 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Size Effect
//>>group: Effects
//>>description: Resize an element to a specified width and height.
//>>docs: https://api.jqueryui.com/size-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectSize = $.effects.define( "size", function( options, done ) {

	// Create element
	var baseline, factor, temp,
		element = $( this ),

		// Copy for children
		cProps = [ "fontSize" ],
		vProps = [ "borderTopWidth", "borderBottomWidth", "paddingTop", "paddingBottom" ],
		hProps = [ "borderLeftWidth", "borderRightWidth", "paddingLeft", "paddingRight" ],

		// Set options
		mode = options.mode,
		restore = mode !== "effect",
		scale = options.scale || "both",
		origin = options.origin || [ "middle", "center" ],
		position = element.css( "position" ),
		pos = element.position(),
		original = $.effects.scaledDimensions( element ),
		from = options.from || original,
		to = options.to || $.effects.scaledDimensions( element, 0 );

	$.effects.createPlaceholder( element );

	if ( mode === "show" ) {
		temp = from;
		from = to;
		to = temp;
	}

	// Set scaling factor
	factor = {
		from: {
			y: from.height / original.height,
			x: from.width / original.width
		},
		to: {
			y: to.height / original.height,
			x: to.width / original.width
		}
	};

	// Scale the css box
	if ( scale === "box" || scale === "both" ) {

		// Vertical props scaling
		if ( factor.from.y !== factor.to.y ) {
			from = $.effects.setTransition( element, vProps, factor.from.y, from );
			to = $.effects.setTransition( element, vProps, factor.to.y, to );
		}

		// Horizontal props scaling
		if ( factor.from.x !== factor.to.x ) {
			from = $.effects.setTransition( element, hProps, factor.from.x, from );
			to = $.effects.setTransition( element, hProps, factor.to.x, to );
		}
	}

	// Scale the content
	if ( scale === "content" || scale === "both" ) {

		// Vertical props scaling
		if ( factor.from.y !== factor.to.y ) {
			from = $.effects.setTransition( element, cProps, factor.from.y, from );
			to = $.effects.setTransition( element, cProps, factor.to.y, to );
		}
	}

	// Adjust the position properties based on the provided origin points
	if ( origin ) {
		baseline = $.effects.getBaseline( origin, original );
		from.top = ( original.outerHeight - from.outerHeight ) * baseline.y + pos.top;
		from.left = ( original.outerWidth - from.outerWidth ) * baseline.x + pos.left;
		to.top = ( original.outerHeight - to.outerHeight ) * baseline.y + pos.top;
		to.left = ( original.outerWidth - to.outerWidth ) * baseline.x + pos.left;
	}
	delete from.outerHeight;
	delete from.outerWidth;
	element.css( from );

	// Animate the children if desired
	if ( scale === "content" || scale === "both" ) {

		vProps = vProps.concat( [ "marginTop", "marginBottom" ] ).concat( cProps );
		hProps = hProps.concat( [ "marginLeft", "marginRight" ] );

		// Only animate children with width attributes specified
		// TODO: is this right? should we include anything with css width specified as well
		element.find( "*[width]" ).each( function() {
			var child = $( this ),
				childOriginal = $.effects.scaledDimensions( child ),
				childFrom = {
					height: childOriginal.height * factor.from.y,
					width: childOriginal.width * factor.from.x,
					outerHeight: childOriginal.outerHeight * factor.from.y,
					outerWidth: childOriginal.outerWidth * factor.from.x
				},
				childTo = {
					height: childOriginal.height * factor.to.y,
					width: childOriginal.width * factor.to.x,
					outerHeight: childOriginal.height * factor.to.y,
					outerWidth: childOriginal.width * factor.to.x
				};

			// Vertical props scaling
			if ( factor.from.y !== factor.to.y ) {
				childFrom = $.effects.setTransition( child, vProps, factor.from.y, childFrom );
				childTo = $.effects.setTransition( child, vProps, factor.to.y, childTo );
			}

			// Horizontal props scaling
			if ( factor.from.x !== factor.to.x ) {
				childFrom = $.effects.setTransition( child, hProps, factor.from.x, childFrom );
				childTo = $.effects.setTransition( child, hProps, factor.to.x, childTo );
			}

			if ( restore ) {
				$.effects.saveStyle( child );
			}

			// Animate children
			child.css( childFrom );
			child.animate( childTo, options.duration, options.easing, function() {

				// Restore children
				if ( restore ) {
					$.effects.restoreStyle( child );
				}
			} );
		} );
	}

	// Animate
	element.animate( to, {
		queue: false,
		duration: options.duration,
		easing: options.easing,
		complete: function() {

			var offset = element.offset();

			if ( to.opacity === 0 ) {
				element.css( "opacity", from.opacity );
			}

			if ( !restore ) {
				element
					.css( "position", position === "static" ? "relative" : position )
					.offset( offset );

				// Need to save style here so that automatic style restoration
				// doesn't restore to the original styles from before the animation.
				$.effects.saveStyle( element );
			}

			done();
		}
	} );

} );


/*!
 * jQuery UI Effects Scale 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Scale Effect
//>>group: Effects
//>>description: Grows or shrinks an element and its content.
//>>docs: https://api.jqueryui.com/scale-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectScale = $.effects.define( "scale", function( options, done ) {

	// Create element
	var el = $( this ),
		mode = options.mode,
		percent = parseInt( options.percent, 10 ) ||
			( parseInt( options.percent, 10 ) === 0 ? 0 : ( mode !== "effect" ? 0 : 100 ) ),

		newOptions = $.extend( true, {
			from: $.effects.scaledDimensions( el ),
			to: $.effects.scaledDimensions( el, percent, options.direction || "both" ),
			origin: options.origin || [ "middle", "center" ]
		}, options );

	// Fade option to support puff
	if ( options.fade ) {
		newOptions.from.opacity = 1;
		newOptions.to.opacity = 0;
	}

	$.effects.effect.size.call( this, newOptions, done );
} );


/*!
 * jQuery UI Effects Puff 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Puff Effect
//>>group: Effects
//>>description: Creates a puff effect by scaling the element up and hiding it at the same time.
//>>docs: https://api.jqueryui.com/puff-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectPuff = $.effects.define( "puff", "hide", function( options, done ) {
	var newOptions = $.extend( true, {}, options, {
		fade: true,
		percent: parseInt( options.percent, 10 ) || 150
	} );

	$.effects.effect.scale.call( this, newOptions, done );
} );


/*!
 * jQuery UI Effects Pulsate 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Pulsate Effect
//>>group: Effects
//>>description: Pulsates an element n times by changing the opacity to zero and back.
//>>docs: https://api.jqueryui.com/pulsate-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectPulsate = $.effects.define( "pulsate", "show", function( options, done ) {
	var element = $( this ),
		mode = options.mode,
		show = mode === "show",
		hide = mode === "hide",
		showhide = show || hide,

		// Showing or hiding leaves off the "last" animation
		anims = ( ( options.times || 5 ) * 2 ) + ( showhide ? 1 : 0 ),
		duration = options.duration / anims,
		animateTo = 0,
		i = 1,
		queuelen = element.queue().length;

	if ( show || !element.is( ":visible" ) ) {
		element.css( "opacity", 0 ).show();
		animateTo = 1;
	}

	// Anims - 1 opacity "toggles"
	for ( ; i < anims; i++ ) {
		element.animate( { opacity: animateTo }, duration, options.easing );
		animateTo = 1 - animateTo;
	}

	element.animate( { opacity: animateTo }, duration, options.easing );

	element.queue( done );

	$.effects.unshift( element, queuelen, anims + 1 );
} );


/*!
 * jQuery UI Effects Shake 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Shake Effect
//>>group: Effects
//>>description: Shakes an element horizontally or vertically n times.
//>>docs: https://api.jqueryui.com/shake-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectShake = $.effects.define( "shake", function( options, done ) {

	var i = 1,
		element = $( this ),
		direction = options.direction || "left",
		distance = options.distance || 20,
		times = options.times || 3,
		anims = times * 2 + 1,
		speed = Math.round( options.duration / anims ),
		ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
		positiveMotion = ( direction === "up" || direction === "left" ),
		animation = {},
		animation1 = {},
		animation2 = {},

		queuelen = element.queue().length;

	$.effects.createPlaceholder( element );

	// Animation
	animation[ ref ] = ( positiveMotion ? "-=" : "+=" ) + distance;
	animation1[ ref ] = ( positiveMotion ? "+=" : "-=" ) + distance * 2;
	animation2[ ref ] = ( positiveMotion ? "-=" : "+=" ) + distance * 2;

	// Animate
	element.animate( animation, speed, options.easing );

	// Shakes
	for ( ; i < times; i++ ) {
		element
			.animate( animation1, speed, options.easing )
			.animate( animation2, speed, options.easing );
	}

	element
		.animate( animation1, speed, options.easing )
		.animate( animation, speed / 2, options.easing )
		.queue( done );

	$.effects.unshift( element, queuelen, anims + 1 );
} );


/*!
 * jQuery UI Effects Slide 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Slide Effect
//>>group: Effects
//>>description: Slides an element in and out of the viewport.
//>>docs: https://api.jqueryui.com/slide-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectSlide = $.effects.define( "slide", "show", function( options, done ) {
	var startClip, startRef,
		element = $( this ),
		map = {
			up: [ "bottom", "top" ],
			down: [ "top", "bottom" ],
			left: [ "right", "left" ],
			right: [ "left", "right" ]
		},
		mode = options.mode,
		direction = options.direction || "left",
		ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
		positiveMotion = ( direction === "up" || direction === "left" ),
		distance = options.distance ||
			element[ ref === "top" ? "outerHeight" : "outerWidth" ]( true ),
		animation = {};

	$.effects.createPlaceholder( element );

	startClip = element.cssClip();
	startRef = element.position()[ ref ];

	// Define hide animation
	animation[ ref ] = ( positiveMotion ? -1 : 1 ) * distance + startRef;
	animation.clip = element.cssClip();
	animation.clip[ map[ direction ][ 1 ] ] = animation.clip[ map[ direction ][ 0 ] ];

	// Reverse the animation if we're showing
	if ( mode === "show" ) {
		element.cssClip( animation.clip );
		element.css( ref, animation[ ref ] );
		animation.clip = startClip;
		animation[ ref ] = startRef;
	}

	// Actually animate
	element.animate( animation, {
		queue: false,
		duration: options.duration,
		easing: options.easing,
		complete: done
	} );
} );


/*!
 * jQuery UI Effects Transfer 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Transfer Effect
//>>group: Effects
//>>description: Displays a transfer effect from one element to another.
//>>docs: https://api.jqueryui.com/transfer-effect/
//>>demos: https://jqueryui.com/effect/


var effect;
if ( $.uiBackCompat === true ) {
	effect = $.effects.define( "transfer", function( options, done ) {
		$( this ).transfer( options, done );
	} );
}
var effectsEffectTransfer = effect;


/*!
 * jQuery UI Focusable 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: :focusable Selector
//>>group: Core
//>>description: Selects elements which can be focused.
//>>docs: https://api.jqueryui.com/focusable-selector/


// Selectors
$.ui.focusable = function( element, hasTabindex ) {
	var map, mapName, img, focusableIfVisible, fieldset,
		nodeName = element.nodeName.toLowerCase();

	if ( "area" === nodeName ) {
		map = element.parentNode;
		mapName = map.name;
		if ( !element.href || !mapName || map.nodeName.toLowerCase() !== "map" ) {
			return false;
		}
		img = $( "img[usemap='#" + mapName + "']" );
		return img.length > 0 && img.is( ":visible" );
	}

	if ( /^(input|select|textarea|button|object)$/.test( nodeName ) ) {
		focusableIfVisible = !element.disabled;

		if ( focusableIfVisible ) {

			// Form controls within a disabled fieldset are disabled.
			// However, controls within the fieldset's legend do not get disabled.
			// Since controls generally aren't placed inside legends, we skip
			// this portion of the check.
			fieldset = $( element ).closest( "fieldset" )[ 0 ];
			if ( fieldset ) {
				focusableIfVisible = !fieldset.disabled;
			}
		}
	} else if ( "a" === nodeName ) {
		focusableIfVisible = element.href || hasTabindex;
	} else {
		focusableIfVisible = hasTabindex;
	}

	return focusableIfVisible && $( element ).is( ":visible" ) &&
		$( element ).css( "visibility" ) === "visible";
};

$.extend( $.expr.pseudos, {
	focusable: function( element ) {
		return $.ui.focusable( element, $.attr( element, "tabindex" ) != null );
	}
} );

var focusable = $.ui.focusable;


/*!
 * jQuery UI Form Reset Mixin 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Form Reset Mixin
//>>group: Core
//>>description: Refresh input widgets when their form is reset
//>>docs: https://api.jqueryui.com/form-reset-mixin/


var formResetMixin = $.ui.formResetMixin = {
	_formResetHandler: function() {
		var form = $( this );

		// Wait for the form reset to actually happen before refreshing
		setTimeout( function() {
			var instances = form.data( "ui-form-reset-instances" );
			$.each( instances, function() {
				this.refresh();
			} );
		} );
	},

	_bindFormResetHandler: function() {
		this.form = $( this.element.prop( "form" ) );
		if ( !this.form.length ) {
			return;
		}

		var instances = this.form.data( "ui-form-reset-instances" ) || [];
		if ( !instances.length ) {

			// We don't use _on() here because we use a single event handler per form
			this.form.on( "reset.ui-form-reset", this._formResetHandler );
		}
		instances.push( this );
		this.form.data( "ui-form-reset-instances", instances );
	},

	_unbindFormResetHandler: function() {
		if ( !this.form.length ) {
			return;
		}

		var instances = this.form.data( "ui-form-reset-instances" );
		instances.splice( $.inArray( this, instances ), 1 );
		if ( instances.length ) {
			this.form.data( "ui-form-reset-instances", instances );
		} else {
			this.form
				.removeData( "ui-form-reset-instances" )
				.off( "reset.ui-form-reset" );
		}
	}
};


/*!
 * jQuery UI Legacy jQuery Core patches 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 *
 */

//>>label: Legacy jQuery Core patches
//>>group: Core
//>>description: Backport `.even()`, `.odd()` and `$.escapeSelector` to older jQuery Core versions (deprecated)


// Support: jQuery 2.2.x or older.
// This method has been defined in jQuery 3.0.0.
// Code from https://github.com/jquery/jquery/blob/e539bac79e666bba95bba86d690b4e609dca2286/src/selector/escapeSelector.js
if ( !$.escapeSelector ) {
	$.escapeSelector = function( id ) {
		return CSS.escape( id + "" );
	};
}

// Support: jQuery 3.4.x or older
// These methods have been defined in jQuery 3.5.0.
if ( !$.fn.even || !$.fn.odd ) {
	$.fn.extend( {
		even: function() {
			return this.filter( function( i ) {
				return i % 2 === 0;
			} );
		},
		odd: function() {
			return this.filter( function( i ) {
				return i % 2 === 1;
			} );
		}
	} );
}

;
/*!
 * jQuery UI Keycode 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Keycode
//>>group: Core
//>>description: Provide keycodes as keynames
//>>docs: https://api.jqueryui.com/jQuery.ui.keyCode/


var keycode = $.ui.keyCode = {
	BACKSPACE: 8,
	COMMA: 188,
	DELETE: 46,
	DOWN: 40,
	END: 35,
	ENTER: 13,
	ESCAPE: 27,
	HOME: 36,
	LEFT: 37,
	PAGE_DOWN: 34,
	PAGE_UP: 33,
	PERIOD: 190,
	RIGHT: 39,
	SPACE: 32,
	TAB: 9,
	UP: 38
};


/*!
 * jQuery UI Labels 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: labels
//>>group: Core
//>>description: Find all the labels associated with a given input
//>>docs: https://api.jqueryui.com/labels/


var labels = $.fn.labels = function() {
	var ancestor, selector, id, labels, ancestors;

	if ( !this.length ) {
		return this.pushStack( [] );
	}

	// Check control.labels first
	if ( this[ 0 ].labels && this[ 0 ].labels.length ) {
		return this.pushStack( this[ 0 ].labels );
	}

	// If `control.labels` is empty - e.g. inside of document fragments - find
	// the labels manually
	labels = this.eq( 0 ).parents( "label" );

	// Look for the label based on the id
	id = this.attr( "id" );
	if ( id ) {

		// We don't search against the document in case the element
		// is disconnected from the DOM
		ancestor = this.eq( 0 ).parents().last();

		// Get a full set of top level ancestors
		ancestors = ancestor.add( ancestor.length ? ancestor.siblings() : this.siblings() );

		// Create a selector for the label based on the id
		selector = "label[for='" + CSS.escape( id ) + "']";

		labels = labels.add( ancestors.find( selector ).addBack( selector ) );

	}

	// Return whatever we have found for labels
	return this.pushStack( labels );
};


/*!
 * jQuery UI Scroll Parent 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: scrollParent
//>>group: Core
//>>description: Get the closest ancestor element that is scrollable.
//>>docs: https://api.jqueryui.com/scrollParent/


var scrollParent = $.fn.scrollParent = function( includeHidden ) {
	var position = this.css( "position" ),
		excludeStaticParent = position === "absolute",
		overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
		scrollParent = this.parents().filter( function() {
			var parent = $( this );
			if ( excludeStaticParent && parent.css( "position" ) === "static" ) {
				return false;
			}
			return overflowRegex.test( parent.css( "overflow" ) + parent.css( "overflow-y" ) +
				parent.css( "overflow-x" ) );
		} ).eq( 0 );

	return position === "fixed" || !scrollParent.length ?
		$( this[ 0 ].ownerDocument || document ) :
		scrollParent;
};


/*!
 * jQuery UI Tabbable 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: :tabbable Selector
//>>group: Core
//>>description: Selects elements which can be tabbed to.
//>>docs: https://api.jqueryui.com/tabbable-selector/


var tabbable = $.extend( $.expr.pseudos, {
	tabbable: function( element ) {
		var tabIndex = $.attr( element, "tabindex" ),
			hasTabindex = tabIndex != null;
		return ( !hasTabindex || tabIndex >= 0 ) && $.ui.focusable( element, hasTabindex );
	}
} );


/*!
 * jQuery UI Unique ID 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: uniqueId
//>>group: Core
//>>description: Functions to generate and remove uniqueId's
//>>docs: https://api.jqueryui.com/uniqueId/


var uniqueId = $.fn.extend( {
	uniqueId: ( function() {
		var uuid = 0;

		return function() {
			return this.each( function() {
				if ( !this.id ) {
					this.id = "ui-id-" + ( ++uuid );
				}
			} );
		};
	} )(),

	removeUniqueId: function() {
		return this.each( function() {
			if ( /^ui-id-\d+$/.test( this.id ) ) {
				$( this ).removeAttr( "id" );
			}
		} );
	}
} );


/*!
 * jQuery UI Accordion 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Accordion
//>>group: Widgets
/* eslint-disable max-len */
//>>description: Displays collapsible content panels for presenting information in a limited amount of space.
/* eslint-enable max-len */
//>>docs: https://api.jqueryui.com/accordion/
//>>demos: https://jqueryui.com/accordion/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/accordion.css
//>>css.theme: ../../themes/base/theme.css


var widgetsAccordion = $.widget( "ui.accordion", {
	version: "1.14.1",
	options: {
		active: 0,
		animate: {},
		classes: {
			"ui-accordion-header": "ui-corner-top",
			"ui-accordion-header-collapsed": "ui-corner-all",
			"ui-accordion-content": "ui-corner-bottom"
		},
		collapsible: false,
		event: "click",
		header: function( elem ) {
			return elem
				.find( "> li > :first-child" )
				.add(
					elem.find( "> :not(li)" )

						// Support: jQuery <3.5 only
						// We could use `.even()` but that's unavailable in older jQuery.
						.filter( function( i ) {
							return i % 2 === 0;
						} )
				);
		},
		heightStyle: "auto",
		icons: {
			activeHeader: "ui-icon-triangle-1-s",
			header: "ui-icon-triangle-1-e"
		},

		// Callbacks
		activate: null,
		beforeActivate: null
	},

	hideProps: {
		borderTopWidth: "hide",
		borderBottomWidth: "hide",
		paddingTop: "hide",
		paddingBottom: "hide",
		height: "hide"
	},

	showProps: {
		borderTopWidth: "show",
		borderBottomWidth: "show",
		paddingTop: "show",
		paddingBottom: "show",
		height: "show"
	},

	_create: function() {
		var options = this.options;

		this.prevShow = this.prevHide = $();
		this._addClass( "ui-accordion", "ui-widget ui-helper-reset" );
		this.element.attr( "role", "tablist" );

		// Don't allow collapsible: false and active: false / null
		if ( !options.collapsible && ( options.active === false || options.active == null ) ) {
			options.active = 0;
		}

		this._processPanels();

		// handle negative values
		if ( options.active < 0 ) {
			options.active += this.headers.length;
		}
		this._refresh();
	},

	_getCreateEventData: function() {
		return {
			header: this.active,
			panel: !this.active.length ? $() : this.active.next()
		};
	},

	_createIcons: function() {
		var icon, children,
			icons = this.options.icons;

		if ( icons ) {
			icon = $( "<span>" );
			this._addClass( icon, "ui-accordion-header-icon", "ui-icon " + icons.header );
			icon.prependTo( this.headers );
			children = this.active.children( ".ui-accordion-header-icon" );
			this._removeClass( children, icons.header )
				._addClass( children, null, icons.activeHeader )
				._addClass( this.headers, "ui-accordion-icons" );
		}
	},

	_destroyIcons: function() {
		this._removeClass( this.headers, "ui-accordion-icons" );
		this.headers.children( ".ui-accordion-header-icon" ).remove();
	},

	_destroy: function() {
		var contents;

		// Clean up main element
		this.element.removeAttr( "role" );

		// Clean up headers
		this.headers
			.removeAttr( "role aria-expanded aria-selected aria-controls tabIndex" )
			.removeUniqueId();

		this._destroyIcons();

		// Clean up content panels
		contents = this.headers.next()
			.css( "display", "" )
			.removeAttr( "role aria-hidden aria-labelledby" )
			.removeUniqueId();

		if ( this.options.heightStyle !== "content" ) {
			contents.css( "height", "" );
		}
	},

	_setOption: function( key, value ) {
		if ( key === "active" ) {

			// _activate() will handle invalid values and update this.options
			this._activate( value );
			return;
		}

		if ( key === "event" ) {
			if ( this.options.event ) {
				this._off( this.headers, this.options.event );
			}
			this._setupEvents( value );
		}

		this._super( key, value );

		// Setting collapsible: false while collapsed; open first panel
		if ( key === "collapsible" && !value && this.options.active === false ) {
			this._activate( 0 );
		}

		if ( key === "icons" ) {
			this._destroyIcons();
			if ( value ) {
				this._createIcons();
			}
		}
	},

	_setOptionDisabled: function( value ) {
		this._super( value );

		this.element.attr( "aria-disabled", value );
		this._toggleClass( null, "ui-state-disabled", !!value );
	},

	_keydown: function( event ) {
		if ( event.altKey || event.ctrlKey ) {
			return;
		}

		var keyCode = $.ui.keyCode,
			length = this.headers.length,
			currentIndex = this.headers.index( event.target ),
			toFocus = false;

		switch ( event.keyCode ) {
		case keyCode.RIGHT:
		case keyCode.DOWN:
			toFocus = this.headers[ ( currentIndex + 1 ) % length ];
			break;
		case keyCode.LEFT:
		case keyCode.UP:
			toFocus = this.headers[ ( currentIndex - 1 + length ) % length ];
			break;
		case keyCode.SPACE:
		case keyCode.ENTER:
			this._eventHandler( event );
			break;
		case keyCode.HOME:
			toFocus = this.headers[ 0 ];
			break;
		case keyCode.END:
			toFocus = this.headers[ length - 1 ];
			break;
		}

		if ( toFocus ) {
			$( event.target ).attr( "tabIndex", -1 );
			$( toFocus ).attr( "tabIndex", 0 );
			$( toFocus ).trigger( "focus" );
			event.preventDefault();
		}
	},

	_panelKeyDown: function( event ) {
		if ( event.keyCode === $.ui.keyCode.UP && event.ctrlKey ) {
			$( event.currentTarget ).prev().trigger( "focus" );
		}
	},

	refresh: function() {
		var options = this.options;
		this._processPanels();

		// Was collapsed or no panel
		if ( ( options.active === false && options.collapsible === true ) ||
				!this.headers.length ) {
			options.active = false;
			this.active = $();

		// active false only when collapsible is true
		} else if ( options.active === false ) {
			this._activate( 0 );

		// was active, but active panel is gone
		} else if ( this.active.length && !$.contains( this.element[ 0 ], this.active[ 0 ] ) ) {

			// all remaining panel are disabled
			if ( this.headers.length === this.headers.find( ".ui-state-disabled" ).length ) {
				options.active = false;
				this.active = $();

			// activate previous panel
			} else {
				this._activate( Math.max( 0, options.active - 1 ) );
			}

		// was active, active panel still exists
		} else {

			// make sure active index is correct
			options.active = this.headers.index( this.active );
		}

		this._destroyIcons();

		this._refresh();
	},

	_processPanels: function() {
		var prevHeaders = this.headers,
			prevPanels = this.panels;

		if ( typeof this.options.header === "function" ) {
			this.headers = this.options.header( this.element );
		} else {
			this.headers = this.element.find( this.options.header );
		}
		this._addClass( this.headers, "ui-accordion-header ui-accordion-header-collapsed",
			"ui-state-default" );

		this.panels = this.headers.next().filter( ":not(.ui-accordion-content-active)" ).hide();
		this._addClass( this.panels, "ui-accordion-content", "ui-helper-reset ui-widget-content" );

		// Avoid memory leaks (#10056)
		if ( prevPanels ) {
			this._off( prevHeaders.not( this.headers ) );
			this._off( prevPanels.not( this.panels ) );
		}
	},

	_refresh: function() {
		var maxHeight,
			options = this.options,
			heightStyle = options.heightStyle,
			parent = this.element.parent();

		this.active = this._findActive( options.active );
		this._addClass( this.active, "ui-accordion-header-active", "ui-state-active" )
			._removeClass( this.active, "ui-accordion-header-collapsed" );
		this._addClass( this.active.next(), "ui-accordion-content-active" );
		this.active.next().show();

		this.headers
			.attr( "role", "tab" )
			.each( function() {
				var header = $( this ),
					headerId = header.uniqueId().attr( "id" ),
					panel = header.next(),
					panelId = panel.uniqueId().attr( "id" );
				header.attr( "aria-controls", panelId );
				panel.attr( "aria-labelledby", headerId );
			} )
			.next()
				.attr( "role", "tabpanel" );

		this.headers
			.not( this.active )
				.attr( {
					"aria-selected": "false",
					"aria-expanded": "false",
					tabIndex: -1
				} )
				.next()
					.attr( {
						"aria-hidden": "true"
					} )
					.hide();

		// Make sure at least one header is in the tab order
		if ( !this.active.length ) {
			this.headers.eq( 0 ).attr( "tabIndex", 0 );
		} else {
			this.active.attr( {
				"aria-selected": "true",
				"aria-expanded": "true",
				tabIndex: 0
			} )
				.next()
					.attr( {
						"aria-hidden": "false"
					} );
		}

		this._createIcons();

		this._setupEvents( options.event );

		if ( heightStyle === "fill" ) {
			maxHeight = parent.height();
			this.element.siblings( ":visible" ).each( function() {
				var elem = $( this ),
					position = elem.css( "position" );

				if ( position === "absolute" || position === "fixed" ) {
					return;
				}
				maxHeight -= elem.outerHeight( true );
			} );

			this.headers.each( function() {
				maxHeight -= $( this ).outerHeight( true );
			} );

			this.headers.next()
				.each( function() {
					$( this ).height( Math.max( 0, maxHeight -
						$( this ).innerHeight() + $( this ).height() ) );
				} )
				.css( "overflow", "auto" );
		} else if ( heightStyle === "auto" ) {
			maxHeight = 0;
			this.headers.next()
				.each( function() {
					var isVisible = $( this ).is( ":visible" );
					if ( !isVisible ) {
						$( this ).show();
					}
					maxHeight = Math.max( maxHeight, $( this ).css( "height", "" ).height() );
					if ( !isVisible ) {
						$( this ).hide();
					}
				} )
				.height( maxHeight );
		}
	},

	_activate: function( index ) {
		var active = this._findActive( index )[ 0 ];

		// Trying to activate the already active panel
		if ( active === this.active[ 0 ] ) {
			return;
		}

		// Trying to collapse, simulate a click on the currently active header
		active = active || this.active[ 0 ];

		this._eventHandler( {
			target: active,
			currentTarget: active,
			preventDefault: $.noop
		} );
	},

	_findActive: function( selector ) {
		return typeof selector === "number" ? this.headers.eq( selector ) : $();
	},

	_setupEvents: function( event ) {
		var events = {
			keydown: "_keydown"
		};
		if ( event ) {
			$.each( event.split( " " ), function( index, eventName ) {
				events[ eventName ] = "_eventHandler";
			} );
		}

		this._off( this.headers.add( this.headers.next() ) );
		this._on( this.headers, events );
		this._on( this.headers.next(), { keydown: "_panelKeyDown" } );
		this._hoverable( this.headers );
		this._focusable( this.headers );
	},

	_eventHandler: function( event ) {
		var activeChildren, clickedChildren,
			options = this.options,
			active = this.active,
			clicked = $( event.currentTarget ),
			clickedIsActive = clicked[ 0 ] === active[ 0 ],
			collapsing = clickedIsActive && options.collapsible,
			toShow = collapsing ? $() : clicked.next(),
			toHide = active.next(),
			eventData = {
				oldHeader: active,
				oldPanel: toHide,
				newHeader: collapsing ? $() : clicked,
				newPanel: toShow
			};

		event.preventDefault();

		if (

				// click on active header, but not collapsible
				( clickedIsActive && !options.collapsible ) ||

				// allow canceling activation
				( this._trigger( "beforeActivate", event, eventData ) === false ) ) {
			return;
		}

		options.active = collapsing ? false : this.headers.index( clicked );

		// When the call to ._toggle() comes after the class changes
		// it causes a very odd bug in IE 8 (see #6720)
		this.active = clickedIsActive ? $() : clicked;
		this._toggle( eventData );

		// Switch classes
		// corner classes on the previously active header stay after the animation
		this._removeClass( active, "ui-accordion-header-active", "ui-state-active" );
		if ( options.icons ) {
			activeChildren = active.children( ".ui-accordion-header-icon" );
			this._removeClass( activeChildren, null, options.icons.activeHeader )
				._addClass( activeChildren, null, options.icons.header );
		}

		if ( !clickedIsActive ) {
			this._removeClass( clicked, "ui-accordion-header-collapsed" )
				._addClass( clicked, "ui-accordion-header-active", "ui-state-active" );
			if ( options.icons ) {
				clickedChildren = clicked.children( ".ui-accordion-header-icon" );
				this._removeClass( clickedChildren, null, options.icons.header )
					._addClass( clickedChildren, null, options.icons.activeHeader );
			}

			this._addClass( clicked.next(), "ui-accordion-content-active" );
		}
	},

	_toggle: function( data ) {
		var toShow = data.newPanel,
			toHide = this.prevShow.length ? this.prevShow : data.oldPanel;

		// Handle activating a panel during the animation for another activation
		this.prevShow.add( this.prevHide ).stop( true, true );
		this.prevShow = toShow;
		this.prevHide = toHide;

		if ( this.options.animate ) {
			this._animate( toShow, toHide, data );
		} else {
			toHide.hide();
			toShow.show();
			this._toggleComplete( data );
		}

		toHide.attr( {
			"aria-hidden": "true"
		} );
		toHide.prev().attr( {
			"aria-selected": "false",
			"aria-expanded": "false"
		} );

		// if we're switching panels, remove the old header from the tab order
		// if we're opening from collapsed state, remove the previous header from the tab order
		// if we're collapsing, then keep the collapsing header in the tab order
		if ( toShow.length && toHide.length ) {
			toHide.prev().attr( {
				"tabIndex": -1,
				"aria-expanded": "false"
			} );
		} else if ( toShow.length ) {
			this.headers.filter( function() {
				return parseInt( $( this ).attr( "tabIndex" ), 10 ) === 0;
			} )
				.attr( "tabIndex", -1 );
		}

		toShow
			.attr( "aria-hidden", "false" )
			.prev()
				.attr( {
					"aria-selected": "true",
					"aria-expanded": "true",
					tabIndex: 0
				} );
	},

	_animate: function( toShow, toHide, data ) {
		var total, easing, duration,
			that = this,
			adjust = 0,
			boxSizing = toShow.css( "box-sizing" ),
			down = toShow.length &&
				( !toHide.length || ( toShow.index() < toHide.index() ) ),
			animate = this.options.animate || {},
			options = down && animate.down || animate,
			complete = function() {
				that._toggleComplete( data );
			};

		if ( typeof options === "number" ) {
			duration = options;
		}
		if ( typeof options === "string" ) {
			easing = options;
		}

		// fall back from options to animation in case of partial down settings
		easing = easing || options.easing || animate.easing;
		duration = duration || options.duration || animate.duration;

		if ( !toHide.length ) {
			return toShow.animate( this.showProps, duration, easing, complete );
		}
		if ( !toShow.length ) {
			return toHide.animate( this.hideProps, duration, easing, complete );
		}

		total = toShow.show().outerHeight();
		toHide.animate( this.hideProps, {
			duration: duration,
			easing: easing,
			step: function( now, fx ) {
				fx.now = Math.round( now );
			}
		} );
		toShow
			.hide()
			.animate( this.showProps, {
				duration: duration,
				easing: easing,
				complete: complete,
				step: function( now, fx ) {
					fx.now = Math.round( now );
					if ( fx.prop !== "height" ) {
						if ( boxSizing === "content-box" ) {
							adjust += fx.now;
						}
					} else if ( that.options.heightStyle !== "content" ) {
						fx.now = Math.round( total - toHide.outerHeight() - adjust );
						adjust = 0;
					}
				}
			} );
	},

	_toggleComplete: function( data ) {
		var toHide = data.oldPanel,
			prev = toHide.prev();

		this._removeClass( toHide, "ui-accordion-content-active" );
		this._removeClass( prev, "ui-accordion-header-active" )
			._addClass( prev, "ui-accordion-header-collapsed" );

		this._trigger( "activate", null, data );
	}
} );


/*!
 * jQuery UI Menu 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Menu
//>>group: Widgets
//>>description: Creates nestable menus.
//>>docs: https://api.jqueryui.com/menu/
//>>demos: https://jqueryui.com/menu/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/menu.css
//>>css.theme: ../../themes/base/theme.css


var widgetsMenu = $.widget( "ui.menu", {
	version: "1.14.1",
	defaultElement: "<ul>",
	delay: 300,
	options: {
		icons: {
			submenu: "ui-icon-caret-1-e"
		},
		items: "> *",
		menus: "ul",
		position: {
			my: "left top",
			at: "right top"
		},
		role: "menu",

		// Callbacks
		blur: null,
		focus: null,
		select: null
	},

	_create: function() {
		this.activeMenu = this.element;

		// Flag used to prevent firing of the click handler
		// as the event bubbles up through nested menus
		this.mouseHandled = false;
		this.lastMousePosition = { x: null, y: null };
		this.element
			.uniqueId()
			.attr( {
				role: this.options.role,
				tabIndex: 0
			} );

		this._addClass( "ui-menu", "ui-widget ui-widget-content" );
		this._on( {

			// Prevent focus from sticking to links inside menu after clicking
			// them (focus should always stay on UL during navigation).
			"mousedown .ui-menu-item": function( event ) {
				event.preventDefault();

				this._activateItem( event );
			},
			"click .ui-menu-item": function( event ) {
				var target = $( event.target );
				var active = $( this.document[ 0 ].activeElement );
				if ( !this.mouseHandled && target.not( ".ui-state-disabled" ).length ) {
					this.select( event );

					// Only set the mouseHandled flag if the event will bubble, see #9469.
					if ( !event.isPropagationStopped() ) {
						this.mouseHandled = true;
					}

					// Open submenu on click
					if ( target.has( ".ui-menu" ).length ) {
						this.expand( event );
					} else if ( !this.element.is( ":focus" ) &&
							active.closest( ".ui-menu" ).length ) {

						// Redirect focus to the menu
						this.element.trigger( "focus", [ true ] );

						// If the active item is on the top level, let it stay active.
						// Otherwise, blur the active item since it is no longer visible.
						if ( this.active && this.active.parents( ".ui-menu" ).length === 1 ) {
							clearTimeout( this.timer );
						}
					}
				}
			},
			"mouseenter .ui-menu-item": "_activateItem",
			"mousemove .ui-menu-item": "_activateItem",
			mouseleave: "collapseAll",
			"mouseleave .ui-menu": "collapseAll",
			focus: function( event, keepActiveItem ) {

				// If there's already an active item, keep it active
				// If not, activate the first item
				var item = this.active || this._menuItems().first();

				if ( !keepActiveItem ) {
					this.focus( event, item );
				}
			},
			blur: function( event ) {
				this._delay( function() {
					var notContained = !$.contains(
						this.element[ 0 ],
						this.document[ 0 ].activeElement
					);
					if ( notContained ) {
						this.collapseAll( event );
					}
				} );
			},
			keydown: "_keydown"
		} );

		this.refresh();

		// Clicks outside of a menu collapse any open menus
		this._on( this.document, {
			click: function( event ) {
				if ( this._closeOnDocumentClick( event ) ) {
					this.collapseAll( event, true );
				}

				// Reset the mouseHandled flag
				this.mouseHandled = false;
			}
		} );
	},

	_activateItem: function( event ) {

		// Ignore mouse events while typeahead is active, see #10458.
		// Prevents focusing the wrong item when typeahead causes a scroll while the mouse
		// is over an item in the menu
		if ( this.previousFilter ) {
			return;
		}

		// If the mouse didn't actually move, but the page was scrolled, ignore the event (#9356)
		if ( event.clientX === this.lastMousePosition.x &&
				event.clientY === this.lastMousePosition.y ) {
			return;
		}

		this.lastMousePosition = {
			x: event.clientX,
			y: event.clientY
		};

		var actualTarget = $( event.target ).closest( ".ui-menu-item" ),
			target = $( event.currentTarget );

		// Ignore bubbled events on parent items, see #11641
		if ( actualTarget[ 0 ] !== target[ 0 ] ) {
			return;
		}

		// If the item is already active, there's nothing to do
		if ( target.is( ".ui-state-active" ) ) {
			return;
		}

		// Remove ui-state-active class from siblings of the newly focused menu item
		// to avoid a jump caused by adjacent elements both having a class with a border
		this._removeClass( target.siblings().children( ".ui-state-active" ),
			null, "ui-state-active" );
		this.focus( event, target );
	},

	_destroy: function() {
		var items = this.element.find( ".ui-menu-item" )
				.removeAttr( "role aria-disabled" ),
			submenus = items.children( ".ui-menu-item-wrapper" )
				.removeUniqueId()
				.removeAttr( "tabIndex role aria-haspopup" );

		// Destroy (sub)menus
		this.element
			.removeAttr( "aria-activedescendant" )
			.find( ".ui-menu" ).addBack()
				.removeAttr( "role aria-labelledby aria-expanded aria-hidden aria-disabled " +
					"tabIndex" )
				.removeUniqueId()
				.show();

		submenus.children().each( function() {
			var elem = $( this );
			if ( elem.data( "ui-menu-submenu-caret" ) ) {
				elem.remove();
			}
		} );
	},

	_keydown: function( event ) {
		var match, prev, character, skip,
			preventDefault = true;

		switch ( event.keyCode ) {
		case $.ui.keyCode.PAGE_UP:
			this.previousPage( event );
			break;
		case $.ui.keyCode.PAGE_DOWN:
			this.nextPage( event );
			break;
		case $.ui.keyCode.HOME:
			this._move( "first", "first", event );
			break;
		case $.ui.keyCode.END:
			this._move( "last", "last", event );
			break;
		case $.ui.keyCode.UP:
			this.previous( event );
			break;
		case $.ui.keyCode.DOWN:
			this.next( event );
			break;
		case $.ui.keyCode.LEFT:
			this.collapse( event );
			break;
		case $.ui.keyCode.RIGHT:
			if ( this.active && !this.active.is( ".ui-state-disabled" ) ) {
				this.expand( event );
			}
			break;
		case $.ui.keyCode.ENTER:
		case $.ui.keyCode.SPACE:
			this._activate( event );
			break;
		case $.ui.keyCode.ESCAPE:
			this.collapse( event );
			break;
		default:
			preventDefault = false;
			prev = this.previousFilter || "";
			skip = false;

			// Support number pad values
			character = event.keyCode >= 96 && event.keyCode <= 105 ?
				( event.keyCode - 96 ).toString() : String.fromCharCode( event.keyCode );

			clearTimeout( this.filterTimer );

			if ( character === prev ) {
				skip = true;
			} else {
				character = prev + character;
			}

			match = this._filterMenuItems( character );
			match = skip && match.index( this.active.next() ) !== -1 ?
				this.active.nextAll( ".ui-menu-item" ) :
				match;

			// If no matches on the current filter, reset to the last character pressed
			// to move down the menu to the first item that starts with that character
			if ( !match.length ) {
				character = String.fromCharCode( event.keyCode );
				match = this._filterMenuItems( character );
			}

			if ( match.length ) {
				this.focus( event, match );
				this.previousFilter = character;
				this.filterTimer = this._delay( function() {
					delete this.previousFilter;
				}, 1000 );
			} else {
				delete this.previousFilter;
			}
		}

		if ( preventDefault ) {
			event.preventDefault();
		}
	},

	_activate: function( event ) {
		if ( this.active && !this.active.is( ".ui-state-disabled" ) ) {
			if ( this.active.children( "[aria-haspopup='true']" ).length ) {
				this.expand( event );
			} else {
				this.select( event );
			}
		}
	},

	refresh: function() {
		var menus, items, newSubmenus, newItems, newWrappers,
			that = this,
			icon = this.options.icons.submenu,
			submenus = this.element.find( this.options.menus );

		this._toggleClass( "ui-menu-icons", null, !!this.element.find( ".ui-icon" ).length );

		// Initialize nested menus
		newSubmenus = submenus.filter( ":not(.ui-menu)" )
			.hide()
			.attr( {
				role: this.options.role,
				"aria-hidden": "true",
				"aria-expanded": "false"
			} )
			.each( function() {
				var menu = $( this ),
					item = menu.prev(),
					submenuCaret = $( "<span>" ).data( "ui-menu-submenu-caret", true );

				that._addClass( submenuCaret, "ui-menu-icon", "ui-icon " + icon );
				item
					.attr( "aria-haspopup", "true" )
					.prepend( submenuCaret );
				menu.attr( "aria-labelledby", item.attr( "id" ) );
			} );

		this._addClass( newSubmenus, "ui-menu", "ui-widget ui-widget-content ui-front" );

		menus = submenus.add( this.element );
		items = menus.find( this.options.items );

		// Initialize menu-items containing spaces and/or dashes only as dividers
		items.not( ".ui-menu-item" ).each( function() {
			var item = $( this );
			if ( that._isDivider( item ) ) {
				that._addClass( item, "ui-menu-divider", "ui-widget-content" );
			}
		} );

		// Don't refresh list items that are already adapted
		newItems = items.not( ".ui-menu-item, .ui-menu-divider" );
		newWrappers = newItems.children()
			.not( ".ui-menu" )
				.uniqueId()
				.attr( {
					tabIndex: -1,
					role: this._itemRole()
				} );
		this._addClass( newItems, "ui-menu-item" )
			._addClass( newWrappers, "ui-menu-item-wrapper" );

		// Add aria-disabled attribute to any disabled menu item
		items.filter( ".ui-state-disabled" ).attr( "aria-disabled", "true" );

		// If the active item has been removed, blur the menu
		if ( this.active && !$.contains( this.element[ 0 ], this.active[ 0 ] ) ) {
			this.blur();
		}
	},

	_itemRole: function() {
		return {
			menu: "menuitem",
			listbox: "option"
		}[ this.options.role ];
	},

	_setOption: function( key, value ) {
		if ( key === "icons" ) {
			var icons = this.element.find( ".ui-menu-icon" );
			this._removeClass( icons, null, this.options.icons.submenu )
				._addClass( icons, null, value.submenu );
		}
		this._super( key, value );
	},

	_setOptionDisabled: function( value ) {
		this._super( value );

		this.element.attr( "aria-disabled", String( value ) );
		this._toggleClass( null, "ui-state-disabled", !!value );
	},

	focus: function( event, item ) {
		var nested, focused, activeParent;
		this.blur( event, event && event.type === "focus" );

		this._scrollIntoView( item );

		this.active = item.first();

		focused = this.active.children( ".ui-menu-item-wrapper" );
		this._addClass( focused, null, "ui-state-active" );

		// Only update aria-activedescendant if there's a role
		// otherwise we assume focus is managed elsewhere
		if ( this.options.role ) {
			this.element.attr( "aria-activedescendant", focused.attr( "id" ) );
		}

		// Highlight active parent menu item, if any
		activeParent = this.active
			.parent()
				.closest( ".ui-menu-item" )
					.children( ".ui-menu-item-wrapper" );
		this._addClass( activeParent, null, "ui-state-active" );

		if ( event && event.type === "keydown" ) {
			this._close();
		} else {
			this.timer = this._delay( function() {
				this._close();
			}, this.delay );
		}

		nested = item.children( ".ui-menu" );
		if ( nested.length && event && ( /^mouse/.test( event.type ) ) ) {
			this._startOpening( nested );
		}
		this.activeMenu = item.parent();

		this._trigger( "focus", event, { item: item } );
	},

	_scrollIntoView: function( item ) {
		var borderTop, paddingTop, offset, scroll, elementHeight, itemHeight;
		if ( this._hasScroll() ) {
			borderTop = parseFloat( $.css( this.activeMenu[ 0 ], "borderTopWidth" ) ) || 0;
			paddingTop = parseFloat( $.css( this.activeMenu[ 0 ], "paddingTop" ) ) || 0;
			offset = item.offset().top - this.activeMenu.offset().top - borderTop - paddingTop;
			scroll = this.activeMenu.scrollTop();
			elementHeight = this.activeMenu.height();
			itemHeight = item.outerHeight();

			if ( offset < 0 ) {
				this.activeMenu.scrollTop( scroll + offset );
			} else if ( offset + itemHeight > elementHeight ) {
				this.activeMenu.scrollTop( scroll + offset - elementHeight + itemHeight );
			}
		}
	},

	blur: function( event, fromFocus ) {
		if ( !fromFocus ) {
			clearTimeout( this.timer );
		}

		if ( !this.active ) {
			return;
		}

		this._removeClass( this.active.children( ".ui-menu-item-wrapper" ),
			null, "ui-state-active" );

		this._trigger( "blur", event, { item: this.active } );
		this.active = null;
	},

	_startOpening: function( submenu ) {
		clearTimeout( this.timer );

		// Don't open if already open fixes a Firefox bug that caused a .5 pixel
		// shift in the submenu position when mousing over the caret icon
		if ( submenu.attr( "aria-hidden" ) !== "true" ) {
			return;
		}

		this.timer = this._delay( function() {
			this._close();
			this._open( submenu );
		}, this.delay );
	},

	_open: function( submenu ) {
		var position = $.extend( {
			of: this.active
		}, this.options.position );

		clearTimeout( this.timer );
		this.element.find( ".ui-menu" ).not( submenu.parents( ".ui-menu" ) )
			.hide()
			.attr( "aria-hidden", "true" );

		submenu
			.show()
			.removeAttr( "aria-hidden" )
			.attr( "aria-expanded", "true" )
			.position( position );
	},

	collapseAll: function( event, all ) {
		clearTimeout( this.timer );
		this.timer = this._delay( function() {

			// If we were passed an event, look for the submenu that contains the event
			var currentMenu = all ? this.element :
				$( event && event.target ).closest( this.element.find( ".ui-menu" ) );

			// If we found no valid submenu ancestor, use the main menu to close all
			// sub menus anyway
			if ( !currentMenu.length ) {
				currentMenu = this.element;
			}

			this._close( currentMenu );

			this.blur( event );

			// Work around active item staying active after menu is blurred
			this._removeClass( currentMenu.find( ".ui-state-active" ), null, "ui-state-active" );

			this.activeMenu = currentMenu;
		}, all ? 0 : this.delay );
	},

	// With no arguments, closes the currently active menu - if nothing is active
	// it closes all menus.  If passed an argument, it will search for menus BELOW
	_close: function( startMenu ) {
		if ( !startMenu ) {
			startMenu = this.active ? this.active.parent() : this.element;
		}

		startMenu.find( ".ui-menu" )
			.hide()
			.attr( "aria-hidden", "true" )
			.attr( "aria-expanded", "false" );
	},

	_closeOnDocumentClick: function( event ) {
		return !$( event.target ).closest( ".ui-menu" ).length;
	},

	_isDivider: function( item ) {

		// Match hyphen, em dash, en dash
		return !/[^\-\u2014\u2013\s]/.test( item.text() );
	},

	collapse: function( event ) {
		var newItem = this.active &&
			this.active.parent().closest( ".ui-menu-item", this.element );
		if ( newItem && newItem.length ) {
			this._close();
			this.focus( event, newItem );
		}
	},

	expand: function( event ) {
		var newItem = this.active && this._menuItems( this.active.children( ".ui-menu" ) ).first();

		if ( newItem && newItem.length ) {
			this._open( newItem.parent() );

			// Delay so Firefox will not hide activedescendant change in expanding submenu from AT
			this._delay( function() {
				this.focus( event, newItem );
			} );
		}
	},

	next: function( event ) {
		this._move( "next", "first", event );
	},

	previous: function( event ) {
		this._move( "prev", "last", event );
	},

	isFirstItem: function() {
		return this.active && !this.active.prevAll( ".ui-menu-item" ).length;
	},

	isLastItem: function() {
		return this.active && !this.active.nextAll( ".ui-menu-item" ).length;
	},

	_menuItems: function( menu ) {
		return ( menu || this.element )
			.find( this.options.items )
			.filter( ".ui-menu-item" );
	},

	_move: function( direction, filter, event ) {
		var next;
		if ( this.active ) {
			if ( direction === "first" || direction === "last" ) {
				next = this.active
					[ direction === "first" ? "prevAll" : "nextAll" ]( ".ui-menu-item" )
					.last();
			} else {
				next = this.active
					[ direction + "All" ]( ".ui-menu-item" )
					.first();
			}
		}
		if ( !next || !next.length || !this.active ) {
			next = this._menuItems( this.activeMenu )[ filter ]();
		}

		this.focus( event, next );
	},

	nextPage: function( event ) {
		var item, base, height;

		if ( !this.active ) {
			this.next( event );
			return;
		}
		if ( this.isLastItem() ) {
			return;
		}
		if ( this._hasScroll() ) {
			base = this.active.offset().top;
			height = this.element.innerHeight();

			// jQuery 3.2 doesn't include scrollbars in innerHeight, add it back.
			if ( $.fn.jquery.indexOf( "3.2." ) === 0 ) {
				height += this.element[ 0 ].offsetHeight - this.element.outerHeight();
			}

			this.active.nextAll( ".ui-menu-item" ).each( function() {
				item = $( this );
				return item.offset().top - base - height < 0;
			} );

			this.focus( event, item );
		} else {
			this.focus( event, this._menuItems( this.activeMenu )
				[ !this.active ? "first" : "last" ]() );
		}
	},

	previousPage: function( event ) {
		var item, base, height;
		if ( !this.active ) {
			this.next( event );
			return;
		}
		if ( this.isFirstItem() ) {
			return;
		}
		if ( this._hasScroll() ) {
			base = this.active.offset().top;
			height = this.element.innerHeight();

			// jQuery 3.2 doesn't include scrollbars in innerHeight, add it back.
			if ( $.fn.jquery.indexOf( "3.2." ) === 0 ) {
				height += this.element[ 0 ].offsetHeight - this.element.outerHeight();
			}

			this.active.prevAll( ".ui-menu-item" ).each( function() {
				item = $( this );
				return item.offset().top - base + height > 0;
			} );

			this.focus( event, item );
		} else {
			this.focus( event, this._menuItems( this.activeMenu ).first() );
		}
	},

	_hasScroll: function() {
		return this.element.outerHeight() < this.element.prop( "scrollHeight" );
	},

	select: function( event ) {

		// TODO: It should never be possible to not have an active item at this
		// point, but the tests don't trigger mouseenter before click.
		this.active = this.active || $( event.target ).closest( ".ui-menu-item" );
		var ui = { item: this.active };
		if ( !this.active.has( ".ui-menu" ).length ) {
			this.collapseAll( event, true );
		}
		this._trigger( "select", event, ui );
	},

	_filterMenuItems: function( character ) {
		var escapedCharacter = character.replace( /[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&" ),
			regex = new RegExp( "^" + escapedCharacter, "i" );

		return this.activeMenu
			.find( this.options.items )

				// Only match on items, not dividers or other content (#10571)
				.filter( ".ui-menu-item" )
					.filter( function() {
						return regex.test(
							String.prototype.trim.call(
								$( this ).children( ".ui-menu-item-wrapper" ).text() ) );
					} );
	}
} );


/*!
 * jQuery UI Autocomplete 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Autocomplete
//>>group: Widgets
//>>description: Lists suggested words as the user is typing.
//>>docs: https://api.jqueryui.com/autocomplete/
//>>demos: https://jqueryui.com/autocomplete/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/autocomplete.css
//>>css.theme: ../../themes/base/theme.css


$.widget( "ui.autocomplete", {
	version: "1.14.1",
	defaultElement: "<input>",
	options: {
		appendTo: null,
		autoFocus: false,
		delay: 300,
		minLength: 1,
		position: {
			my: "left top",
			at: "left bottom",
			collision: "none"
		},
		source: null,

		// Callbacks
		change: null,
		close: null,
		focus: null,
		open: null,
		response: null,
		search: null,
		select: null
	},

	requestIndex: 0,
	pending: 0,
	liveRegionTimer: null,

	_create: function() {

		// Some browsers only repeat keydown events, not keypress events,
		// so we use the suppressKeyPress flag to determine if we've already
		// handled the keydown event. #7269
		// Unfortunately the code for & in keypress is the same as the up arrow,
		// so we use the suppressKeyPressRepeat flag to avoid handling keypress
		// events when we know the keydown event was used to modify the
		// search term. #7799
		var suppressKeyPress, suppressKeyPressRepeat, suppressInput,
			nodeName = this.element[ 0 ].nodeName.toLowerCase(),
			isTextarea = nodeName === "textarea",
			isInput = nodeName === "input";

		// Textareas are always multi-line
		// Inputs are always single-line, even if inside a contentEditable element
		// All other element types are determined by whether they're contentEditable
		this.isMultiLine = isTextarea ||
			!isInput && this.element.prop( "contentEditable" ) === "true";

		this.valueMethod = this.element[ isTextarea || isInput ? "val" : "text" ];
		this.isNewMenu = true;

		this._addClass( "ui-autocomplete-input" );
		this.element.attr( "autocomplete", "off" );

		this._on( this.element, {
			keydown: function( event ) {
				if ( this.element.prop( "readOnly" ) ) {
					suppressKeyPress = true;
					suppressInput = true;
					suppressKeyPressRepeat = true;
					return;
				}

				suppressKeyPress = false;
				suppressInput = false;
				suppressKeyPressRepeat = false;
				var keyCode = $.ui.keyCode;
				switch ( event.keyCode ) {
				case keyCode.PAGE_UP:
					suppressKeyPress = true;
					this._move( "previousPage", event );
					break;
				case keyCode.PAGE_DOWN:
					suppressKeyPress = true;
					this._move( "nextPage", event );
					break;
				case keyCode.UP:
					suppressKeyPress = true;
					this._keyEvent( "previous", event );
					break;
				case keyCode.DOWN:
					suppressKeyPress = true;
					this._keyEvent( "next", event );
					break;
				case keyCode.ENTER:

					// when menu is open and has focus
					if ( this.menu.active ) {

						// #6055 - Opera still allows the keypress to occur
						// which causes forms to submit
						suppressKeyPress = true;
						event.preventDefault();
						this.menu.select( event );
					}
					break;
				case keyCode.TAB:
					if ( this.menu.active ) {
						this.menu.select( event );
					}
					break;
				case keyCode.ESCAPE:
					if ( this.menu.element.is( ":visible" ) ) {
						if ( !this.isMultiLine ) {
							this._value( this.term );
						}
						this.close( event );

						// Different browsers have different default behavior for escape
						// Single press can mean undo or clear
						event.preventDefault();
					}
					break;
				default:
					suppressKeyPressRepeat = true;

					// search timeout should be triggered before the input value is changed
					this._searchTimeout( event );
					break;
				}
			},
			keypress: function( event ) {
				if ( suppressKeyPress ) {
					suppressKeyPress = false;
					if ( !this.isMultiLine || this.menu.element.is( ":visible" ) ) {
						event.preventDefault();
					}
					return;
				}
				if ( suppressKeyPressRepeat ) {
					return;
				}

				// Replicate some key handlers to allow them to repeat in Firefox and Opera
				var keyCode = $.ui.keyCode;
				switch ( event.keyCode ) {
				case keyCode.PAGE_UP:
					this._move( "previousPage", event );
					break;
				case keyCode.PAGE_DOWN:
					this._move( "nextPage", event );
					break;
				case keyCode.UP:
					this._keyEvent( "previous", event );
					break;
				case keyCode.DOWN:
					this._keyEvent( "next", event );
					break;
				}
			},
			input: function( event ) {
				if ( suppressInput ) {
					suppressInput = false;
					event.preventDefault();
					return;
				}
				this._searchTimeout( event );
			},
			focus: function() {
				this.selectedItem = null;
				this.previous = this._value();
			},
			blur: function( event ) {
				clearTimeout( this.searching );
				this.close( event );
				this._change( event );
			}
		} );

		this._initSource();
		this.menu = $( "<ul>" )
			.appendTo( this._appendTo() )
			.menu( {

				// disable ARIA support, the live region takes care of that
				role: null
			} )
			.hide()
			.menu( "instance" );

		this._addClass( this.menu.element, "ui-autocomplete", "ui-front" );
		this._on( this.menu.element, {
			mousedown: function( event ) {

				// Prevent moving focus out of the text field
				event.preventDefault();
			},
			menufocus: function( event, ui ) {
				var label, item;

				// Support: Firefox
				// Prevent accidental activation of menu items in Firefox (#7024 #9118)
				if ( this.isNewMenu ) {
					this.isNewMenu = false;
					if ( event.originalEvent && /^mouse/.test( event.originalEvent.type ) ) {
						this.menu.blur();

						this.document.one( "mousemove", function() {
							$( event.target ).trigger( event.originalEvent );
						} );

						return;
					}
				}

				item = ui.item.data( "ui-autocomplete-item" );
				if ( false !== this._trigger( "focus", event, { item: item } ) ) {

					// use value to match what will end up in the input, if it was a key event
					if ( event.originalEvent && /^key/.test( event.originalEvent.type ) ) {
						this._value( item.value );
					}
				}

				// Announce the value in the liveRegion
				label = ui.item.attr( "aria-label" ) || item.value;
				if ( label && String.prototype.trim.call( label ).length ) {
					clearTimeout( this.liveRegionTimer );
					this.liveRegionTimer = this._delay( function() {
						this.liveRegion.html( $( "<div>" ).text( label ) );
					}, 100 );
				}
			},
			menuselect: function( event, ui ) {
				var item = ui.item.data( "ui-autocomplete-item" ),
					previous = this.previous;

				// Only trigger when focus was lost (click on menu)
				if ( this.element[ 0 ] !== this.document[ 0 ].activeElement ) {
					this.element.trigger( "focus" );
					this.previous = previous;
				}

				if ( false !== this._trigger( "select", event, { item: item } ) ) {
					this._value( item.value );
				}

				// reset the term after the select event
				// this allows custom select handling to work properly
				this.term = this._value();

				this.close( event );
				this.selectedItem = item;
			}
		} );

		this.liveRegion = $( "<div>", {
			role: "status",
			"aria-live": "assertive",
			"aria-relevant": "additions"
		} )
			.appendTo( this.document[ 0 ].body );

		this._addClass( this.liveRegion, null, "ui-helper-hidden-accessible" );

		// Turning off autocomplete prevents the browser from remembering the
		// value when navigating through history, so we re-enable autocomplete
		// if the page is unloaded before the widget is destroyed. #7790
		this._on( this.window, {
			beforeunload: function() {
				this.element.removeAttr( "autocomplete" );
			}
		} );
	},

	_destroy: function() {
		clearTimeout( this.searching );
		this.element.removeAttr( "autocomplete" );
		this.menu.element.remove();
		this.liveRegion.remove();
	},

	_setOption: function( key, value ) {
		this._super( key, value );
		if ( key === "source" ) {
			this._initSource();
		}
		if ( key === "appendTo" ) {
			this.menu.element.appendTo( this._appendTo() );
		}
		if ( key === "disabled" && value && this.xhr ) {
			this.xhr.abort();
		}
	},

	_isEventTargetInWidget: function( event ) {
		var menuElement = this.menu.element[ 0 ];

		return event.target === this.element[ 0 ] ||
			event.target === menuElement ||
			$.contains( menuElement, event.target );
	},

	_closeOnClickOutside: function( event ) {
		if ( !this._isEventTargetInWidget( event ) ) {
			this.close();
		}
	},

	_appendTo: function() {
		var element = this.options.appendTo;

		if ( element ) {
			element = element.jquery || element.nodeType ?
				$( element ) :
				this.document.find( element ).eq( 0 );
		}

		if ( !element || !element[ 0 ] ) {
			element = this.element.closest( ".ui-front, dialog" );
		}

		if ( !element.length ) {
			element = this.document[ 0 ].body;
		}

		return element;
	},

	_initSource: function() {
		var array, url,
			that = this;
		if ( Array.isArray( this.options.source ) ) {
			array = this.options.source;
			this.source = function( request, response ) {
				response( $.ui.autocomplete.filter( array, request.term ) );
			};
		} else if ( typeof this.options.source === "string" ) {
			url = this.options.source;
			this.source = function( request, response ) {
				if ( that.xhr ) {
					that.xhr.abort();
				}
				that.xhr = $.ajax( {
					url: url,
					data: request,
					dataType: "json",
					success: function( data ) {
						response( data );
					},
					error: function() {
						response( [] );
					}
				} );
			};
		} else {
			this.source = this.options.source;
		}
	},

	_searchTimeout: function( event ) {
		clearTimeout( this.searching );
		this.searching = this._delay( function() {

			// Search if the value has changed, or if the user retypes the same value (see #7434)
			var equalValues = this.term === this._value(),
				menuVisible = this.menu.element.is( ":visible" ),
				modifierKey = event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;

			if ( !equalValues || ( equalValues && !menuVisible && !modifierKey ) ) {
				this.selectedItem = null;
				this.search( null, event );
			}
		}, this.options.delay );
	},

	search: function( value, event ) {
		value = value != null ? value : this._value();

		// Always save the actual value, not the one passed as an argument
		this.term = this._value();

		if ( value.length < this.options.minLength ) {
			return this.close( event );
		}

		if ( this._trigger( "search", event ) === false ) {
			return;
		}

		return this._search( value );
	},

	_search: function( value ) {
		this.pending++;
		this._addClass( "ui-autocomplete-loading" );
		this.cancelSearch = false;

		this.source( { term: value }, this._response() );
	},

	_response: function() {
		var index = ++this.requestIndex;

		return function( content ) {
			if ( index === this.requestIndex ) {
				this.__response( content );
			}

			this.pending--;
			if ( !this.pending ) {
				this._removeClass( "ui-autocomplete-loading" );
			}
		}.bind( this );
	},

	__response: function( content ) {
		if ( content ) {
			content = this._normalize( content );
		}
		this._trigger( "response", null, { content: content } );
		if ( !this.options.disabled && content && content.length && !this.cancelSearch ) {
			this._suggest( content );
			this._trigger( "open" );
		} else {

			// use ._close() instead of .close() so we don't cancel future searches
			this._close();
		}
	},

	close: function( event ) {
		this.cancelSearch = true;
		this._close( event );
	},

	_close: function( event ) {

		// Remove the handler that closes the menu on outside clicks
		this._off( this.document, "mousedown" );

		if ( this.menu.element.is( ":visible" ) ) {
			this.menu.element.hide();
			this.menu.blur();
			this.isNewMenu = true;
			this._trigger( "close", event );
		}
	},

	_change: function( event ) {
		if ( this.previous !== this._value() ) {
			this._trigger( "change", event, { item: this.selectedItem } );
		}
	},

	_normalize: function( items ) {

		// assume all items have the right format when the first item is complete
		if ( items.length && items[ 0 ].label && items[ 0 ].value ) {
			return items;
		}
		return $.map( items, function( item ) {
			if ( typeof item === "string" ) {
				return {
					label: item,
					value: item
				};
			}
			return $.extend( {}, item, {
				label: item.label || item.value,
				value: item.value || item.label
			} );
		} );
	},

	_suggest: function( items ) {
		var ul = this.menu.element.empty();
		this._renderMenu( ul, items );
		this.isNewMenu = true;
		this.menu.refresh();

		// Size and position menu
		ul.show();
		this._resizeMenu();
		ul.position( $.extend( {
			of: this.element
		}, this.options.position ) );

		if ( this.options.autoFocus ) {
			this.menu.next();
		}

		// Listen for interactions outside of the widget (#6642)
		this._on( this.document, {
			mousedown: "_closeOnClickOutside"
		} );
	},

	_resizeMenu: function() {
		var ul = this.menu.element;
		ul.outerWidth( Math.max(

			// Firefox wraps long text (possibly a rounding bug)
			// so we add 1px to avoid the wrapping (#7513)
			ul.width( "" ).outerWidth() + 1,
			this.element.outerWidth()
		) );
	},

	_renderMenu: function( ul, items ) {
		var that = this;
		$.each( items, function( index, item ) {
			that._renderItemData( ul, item );
		} );
	},

	_renderItemData: function( ul, item ) {
		return this._renderItem( ul, item ).data( "ui-autocomplete-item", item );
	},

	_renderItem: function( ul, item ) {
		return $( "<li>" )
			.append( $( "<div>" ).text( item.label ) )
			.appendTo( ul );
	},

	_move: function( direction, event ) {
		if ( !this.menu.element.is( ":visible" ) ) {
			this.search( null, event );
			return;
		}
		if ( this.menu.isFirstItem() && /^previous/.test( direction ) ||
				this.menu.isLastItem() && /^next/.test( direction ) ) {

			if ( !this.isMultiLine ) {
				this._value( this.term );
			}

			this.menu.blur();
			return;
		}
		this.menu[ direction ]( event );
	},

	widget: function() {
		return this.menu.element;
	},

	_value: function() {
		return this.valueMethod.apply( this.element, arguments );
	},

	_keyEvent: function( keyEvent, event ) {
		if ( !this.isMultiLine || this.menu.element.is( ":visible" ) ) {
			this._move( keyEvent, event );

			// Prevents moving cursor to beginning/end of the text field in some browsers
			event.preventDefault();
		}
	}
} );

$.extend( $.ui.autocomplete, {
	escapeRegex: function( value ) {
		return value.replace( /[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&" );
	},
	filter: function( array, term ) {
		var matcher = new RegExp( $.ui.autocomplete.escapeRegex( term ), "i" );
		return $.grep( array, function( value ) {
			return matcher.test( value.label || value.value || value );
		} );
	}
} );

// Live region extension, adding a `messages` option
// NOTE: This is an experimental API. We are still investigating
// a full solution for string manipulation and internationalization.
$.widget( "ui.autocomplete", $.ui.autocomplete, {
	options: {
		messages: {
			noResults: "No search results.",
			results: function( amount ) {
				return amount + ( amount > 1 ? " results are" : " result is" ) +
					" available, use up and down arrow keys to navigate.";
			}
		}
	},

	__response: function( content ) {
		var message;
		this._superApply( arguments );
		if ( this.options.disabled || this.cancelSearch ) {
			return;
		}
		if ( content && content.length ) {
			message = this.options.messages.results( content.length );
		} else {
			message = this.options.messages.noResults;
		}
		clearTimeout( this.liveRegionTimer );
		this.liveRegionTimer = this._delay( function() {
			this.liveRegion.html( $( "<div>" ).text( message ) );
		}, 100 );
	}
} );

var widgetsAutocomplete = $.ui.autocomplete;


/*!
 * jQuery UI Controlgroup 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Controlgroup
//>>group: Widgets
//>>description: Visually groups form control widgets
//>>docs: https://api.jqueryui.com/controlgroup/
//>>demos: https://jqueryui.com/controlgroup/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/controlgroup.css
//>>css.theme: ../../themes/base/theme.css


var controlgroupCornerRegex = /ui-corner-([a-z]){2,6}/g;

var widgetsControlgroup = $.widget( "ui.controlgroup", {
	version: "1.14.1",
	defaultElement: "<div>",
	options: {
		direction: "horizontal",
		disabled: null,
		onlyVisible: true,
		items: {
			"button": "input[type=button], input[type=submit], input[type=reset], button, a",
			"controlgroupLabel": ".ui-controlgroup-label",
			"checkboxradio": "input[type='checkbox'], input[type='radio']",
			"selectmenu": "select",
			"spinner": ".ui-spinner-input"
		}
	},

	_create: function() {
		this._enhance();
	},

	// To support the enhanced option in jQuery Mobile, we isolate DOM manipulation
	_enhance: function() {
		this.element.attr( "role", "toolbar" );
		this.refresh();
	},

	_destroy: function() {
		this._callChildMethod( "destroy" );
		this.childWidgets.removeData( "ui-controlgroup-data" );
		this.element.removeAttr( "role" );
		if ( this.options.items.controlgroupLabel ) {
			this.element
				.find( this.options.items.controlgroupLabel )
				.find( ".ui-controlgroup-label-contents" )
				.contents().unwrap();
		}
	},

	_initWidgets: function() {
		var that = this,
			childWidgets = [];

		// First we iterate over each of the items options
		$.each( this.options.items, function( widget, selector ) {
			var labels;
			var options = {};

			// Make sure the widget has a selector set
			if ( !selector ) {
				return;
			}

			if ( widget === "controlgroupLabel" ) {
				labels = that.element.find( selector );
				labels.each( function() {
					var element = $( this );

					if ( element.children( ".ui-controlgroup-label-contents" ).length ) {
						return;
					}
					element.contents()
						.wrapAll( "<span class='ui-controlgroup-label-contents'></span>" );
				} );
				that._addClass( labels, null, "ui-widget ui-widget-content ui-state-default" );
				childWidgets = childWidgets.concat( labels.get() );
				return;
			}

			// Make sure the widget actually exists
			if ( !$.fn[ widget ] ) {
				return;
			}

			// We assume everything is in the middle to start because we can't determine
			// first / last elements until all enhancments are done.
			if ( that[ "_" + widget + "Options" ] ) {
				options = that[ "_" + widget + "Options" ]( "middle" );
			} else {
				options = { classes: {} };
			}

			// Find instances of this widget inside controlgroup and init them
			that.element
				.find( selector )
				.each( function() {
					var element = $( this );
					var instance = element[ widget ]( "instance" );

					// We need to clone the default options for this type of widget to avoid
					// polluting the variable options which has a wider scope than a single widget.
					var instanceOptions = $.widget.extend( {}, options );

					// If the button is the child of a spinner ignore it
					// TODO: Find a more generic solution
					if ( widget === "button" && element.parent( ".ui-spinner" ).length ) {
						return;
					}

					// Create the widget if it doesn't exist
					if ( !instance ) {
						instance = element[ widget ]()[ widget ]( "instance" );
					}
					if ( instance ) {
						instanceOptions.classes =
							that._resolveClassesValues( instanceOptions.classes, instance );
					}
					element[ widget ]( instanceOptions );

					// Store an instance of the controlgroup to be able to reference
					// from the outermost element for changing options and refresh
					var widgetElement = element[ widget ]( "widget" );
					$.data( widgetElement[ 0 ], "ui-controlgroup-data",
						instance ? instance : element[ widget ]( "instance" ) );

					childWidgets.push( widgetElement[ 0 ] );
				} );
		} );

		this.childWidgets = $( $.uniqueSort( childWidgets ) );
		this._addClass( this.childWidgets, "ui-controlgroup-item" );
	},

	_callChildMethod: function( method ) {
		this.childWidgets.each( function() {
			var element = $( this ),
				data = element.data( "ui-controlgroup-data" );
			if ( data && data[ method ] ) {
				data[ method ]();
			}
		} );
	},

	_updateCornerClass: function( element, position ) {
		var remove = "ui-corner-top ui-corner-bottom ui-corner-left ui-corner-right ui-corner-all";
		var add = this._buildSimpleOptions( position, "label" ).classes.label;

		this._removeClass( element, null, remove );
		this._addClass( element, null, add );
	},

	_buildSimpleOptions: function( position, key ) {
		var direction = this.options.direction === "vertical";
		var result = {
			classes: {}
		};
		result.classes[ key ] = {
			"middle": "",
			"first": "ui-corner-" + ( direction ? "top" : "left" ),
			"last": "ui-corner-" + ( direction ? "bottom" : "right" ),
			"only": "ui-corner-all"
		}[ position ];

		return result;
	},

	_spinnerOptions: function( position ) {
		var options = this._buildSimpleOptions( position, "ui-spinner" );

		options.classes[ "ui-spinner-up" ] = "";
		options.classes[ "ui-spinner-down" ] = "";

		return options;
	},

	_buttonOptions: function( position ) {
		return this._buildSimpleOptions( position, "ui-button" );
	},

	_checkboxradioOptions: function( position ) {
		return this._buildSimpleOptions( position, "ui-checkboxradio-label" );
	},

	_selectmenuOptions: function( position ) {
		var direction = this.options.direction === "vertical";
		return {
			width: direction ? "auto" : false,
			classes: {
				middle: {
					"ui-selectmenu-button-open": "",
					"ui-selectmenu-button-closed": ""
				},
				first: {
					"ui-selectmenu-button-open": "ui-corner-" + ( direction ? "top" : "tl" ),
					"ui-selectmenu-button-closed": "ui-corner-" + ( direction ? "top" : "left" )
				},
				last: {
					"ui-selectmenu-button-open": direction ? "" : "ui-corner-tr",
					"ui-selectmenu-button-closed": "ui-corner-" + ( direction ? "bottom" : "right" )
				},
				only: {
					"ui-selectmenu-button-open": "ui-corner-top",
					"ui-selectmenu-button-closed": "ui-corner-all"
				}

			}[ position ]
		};
	},

	_resolveClassesValues: function( classes, instance ) {
		var result = {};
		$.each( classes, function( key ) {
			var current = instance.options.classes[ key ] || "";
			current = String.prototype.trim.call( current.replace( controlgroupCornerRegex, "" ) );
			result[ key ] = ( current + " " + classes[ key ] ).replace( /\s+/g, " " );
		} );
		return result;
	},

	_setOption: function( key, value ) {
		if ( key === "direction" ) {
			this._removeClass( "ui-controlgroup-" + this.options.direction );
		}

		this._super( key, value );
		if ( key === "disabled" ) {
			this._callChildMethod( value ? "disable" : "enable" );
			return;
		}

		this.refresh();
	},

	refresh: function() {
		var children,
			that = this;

		this._addClass( "ui-controlgroup ui-controlgroup-" + this.options.direction );

		if ( this.options.direction === "horizontal" ) {
			this._addClass( null, "ui-helper-clearfix" );
		}
		this._initWidgets();

		children = this.childWidgets;

		// We filter here because we need to track all childWidgets not just the visible ones
		if ( this.options.onlyVisible ) {
			children = children.filter( ":visible" );
		}

		if ( children.length ) {

			// We do this last because we need to make sure all enhancment is done
			// before determining first and last
			$.each( [ "first", "last" ], function( index, value ) {
				var instance = children[ value ]().data( "ui-controlgroup-data" );

				if ( instance && that[ "_" + instance.widgetName + "Options" ] ) {
					var options = that[ "_" + instance.widgetName + "Options" ](
						children.length === 1 ? "only" : value
					);
					options.classes = that._resolveClassesValues( options.classes, instance );
					instance.element[ instance.widgetName ]( options );
				} else {
					that._updateCornerClass( children[ value ](), value );
				}
			} );

			// Finally call the refresh method on each of the child widgets.
			this._callChildMethod( "refresh" );
		}
	}
} );

/*!
 * jQuery UI Checkboxradio 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Checkboxradio
//>>group: Widgets
//>>description: Enhances a form with multiple themeable checkboxes or radio buttons.
//>>docs: https://api.jqueryui.com/checkboxradio/
//>>demos: https://jqueryui.com/checkboxradio/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/button.css
//>>css.structure: ../../themes/base/checkboxradio.css
//>>css.theme: ../../themes/base/theme.css


$.widget( "ui.checkboxradio", [ $.ui.formResetMixin, {
	version: "1.14.1",
	options: {
		disabled: null,
		label: null,
		icon: true,
		classes: {
			"ui-checkboxradio-label": "ui-corner-all",
			"ui-checkboxradio-icon": "ui-corner-all"
		}
	},

	_getCreateOptions: function() {
		var disabled, labels, labelContents;
		var options = this._super() || {};

		// We read the type here, because it makes more sense to throw a element type error first,
		// rather then the error for lack of a label. Often if its the wrong type, it
		// won't have a label (e.g. calling on a div, btn, etc)
		this._readType();

		labels = this.element.labels();

		// If there are multiple labels, use the last one
		this.label = $( labels[ labels.length - 1 ] );
		if ( !this.label.length ) {
			$.error( "No label found for checkboxradio widget" );
		}

		this.originalLabel = "";

		// We need to get the label text but this may also need to make sure it does not contain the
		// input itself.
		// The label contents could be text, html, or a mix. We wrap all elements
		// and read the wrapper's `innerHTML` to get a string representation of
		// the label, without the input as part of it.
		labelContents = this.label.contents().not( this.element[ 0 ] );

		if ( labelContents.length ) {
			this.originalLabel += labelContents
				.clone()
				.wrapAll( "<div></div>" )
				.parent()
				.html();
		}

		// Set the label option if we found label text
		if ( this.originalLabel ) {
			options.label = this.originalLabel;
		}

		disabled = this.element[ 0 ].disabled;
		if ( disabled != null ) {
			options.disabled = disabled;
		}
		return options;
	},

	_create: function() {
		var checked = this.element[ 0 ].checked;

		this._bindFormResetHandler();

		if ( this.options.disabled == null ) {
			this.options.disabled = this.element[ 0 ].disabled;
		}

		this._setOption( "disabled", this.options.disabled );
		this._addClass( "ui-checkboxradio", "ui-helper-hidden-accessible" );
		this._addClass( this.label, "ui-checkboxradio-label", "ui-button ui-widget" );

		if ( this.type === "radio" ) {
			this._addClass( this.label, "ui-checkboxradio-radio-label" );
		}

		if ( this.options.label && this.options.label !== this.originalLabel ) {
			this._updateLabel();
		} else if ( this.originalLabel ) {
			this.options.label = this.originalLabel;
		}

		this._enhance();

		if ( checked ) {
			this._addClass( this.label, "ui-checkboxradio-checked", "ui-state-active" );
		}

		this._on( {
			change: "_toggleClasses",
			focus: function() {
				this._addClass( this.label, null, "ui-state-focus ui-visual-focus" );
			},
			blur: function() {
				this._removeClass( this.label, null, "ui-state-focus ui-visual-focus" );
			}
		} );
	},

	_readType: function() {
		var nodeName = this.element[ 0 ].nodeName.toLowerCase();
		this.type = this.element[ 0 ].type;
		if ( nodeName !== "input" || !/radio|checkbox/.test( this.type ) ) {
			$.error( "Can't create checkboxradio on element.nodeName=" + nodeName +
				" and element.type=" + this.type );
		}
	},

	// Support jQuery Mobile enhanced option
	_enhance: function() {
		this._updateIcon( this.element[ 0 ].checked );
	},

	widget: function() {
		return this.label;
	},

	_getRadioGroup: function() {
		var group;
		var name = this.element[ 0 ].name;
		var nameSelector = "input[name='" + CSS.escape( name ) + "']";

		if ( !name ) {
			return $( [] );
		}

		if ( this.form.length ) {
			group = $( this.form[ 0 ].elements ).filter( nameSelector );
		} else {

			// Not inside a form, check all inputs that also are not inside a form
			group = $( nameSelector ).filter( function() {
				return $( $( this ).prop( "form" ) ).length === 0;
			} );
		}

		return group.not( this.element );
	},

	_toggleClasses: function() {
		var checked = this.element[ 0 ].checked;
		this._toggleClass( this.label, "ui-checkboxradio-checked", "ui-state-active", checked );

		if ( this.options.icon && this.type === "checkbox" ) {
			this._toggleClass( this.icon, null, "ui-icon-check ui-state-checked", checked )
				._toggleClass( this.icon, null, "ui-icon-blank", !checked );
		}

		if ( this.type === "radio" ) {
			this._getRadioGroup()
				.each( function() {
					var instance = $( this ).checkboxradio( "instance" );

					if ( instance ) {
						instance._removeClass( instance.label,
							"ui-checkboxradio-checked", "ui-state-active" );
					}
				} );
		}
	},

	_destroy: function() {
		this._unbindFormResetHandler();

		if ( this.icon ) {
			this.icon.remove();
			this.iconSpace.remove();
		}
	},

	_setOption: function( key, value ) {

		// We don't allow the value to be set to nothing
		if ( key === "label" && !value ) {
			return;
		}

		this._super( key, value );

		if ( key === "disabled" ) {
			this._toggleClass( this.label, null, "ui-state-disabled", value );
			this.element[ 0 ].disabled = value;

			// Don't refresh when setting disabled
			return;
		}
		this.refresh();
	},

	_updateIcon: function( checked ) {
		var toAdd = "ui-icon ui-icon-background ";

		if ( this.options.icon ) {
			if ( !this.icon ) {
				this.icon = $( "<span>" );
				this.iconSpace = $( "<span> </span>" );
				this._addClass( this.iconSpace, "ui-checkboxradio-icon-space" );
			}

			if ( this.type === "checkbox" ) {
				toAdd += checked ? "ui-icon-check ui-state-checked" : "ui-icon-blank";
				this._removeClass( this.icon, null, checked ? "ui-icon-blank" : "ui-icon-check" );
			} else {
				toAdd += "ui-icon-blank";
			}
			this._addClass( this.icon, "ui-checkboxradio-icon", toAdd );
			if ( !checked ) {
				this._removeClass( this.icon, null, "ui-icon-check ui-state-checked" );
			}
			this.icon.prependTo( this.label ).after( this.iconSpace );
		} else if ( this.icon !== undefined ) {
			this.icon.remove();
			this.iconSpace.remove();
			delete this.icon;
		}
	},

	_updateLabel: function() {

		// Remove the contents of the label ( minus the icon, icon space, and input )
		var contents = this.label.contents().not( this.element[ 0 ] );
		if ( this.icon ) {
			contents = contents.not( this.icon[ 0 ] );
		}
		if ( this.iconSpace ) {
			contents = contents.not( this.iconSpace[ 0 ] );
		}
		contents.remove();

		this.label.append( this.options.label );
	},

	refresh: function() {
		var checked = this.element[ 0 ].checked,
			isDisabled = this.element[ 0 ].disabled;

		this._updateIcon( checked );
		this._toggleClass( this.label, "ui-checkboxradio-checked", "ui-state-active", checked );
		if ( this.options.label !== null ) {
			this._updateLabel();
		}

		if ( isDisabled !== this.options.disabled ) {
			this._setOptions( { "disabled": isDisabled } );
		}
	}

} ] );

var widgetsCheckboxradio = $.ui.checkboxradio;


/*!
 * jQuery UI Button 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Button
//>>group: Widgets
//>>description: Enhances a form with themeable buttons.
//>>docs: https://api.jqueryui.com/button/
//>>demos: https://jqueryui.com/button/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/button.css
//>>css.theme: ../../themes/base/theme.css


$.widget( "ui.button", {
	version: "1.14.1",
	defaultElement: "<button>",
	options: {
		classes: {
			"ui-button": "ui-corner-all"
		},
		disabled: null,
		icon: null,
		iconPosition: "beginning",
		label: null,
		showLabel: true
	},

	_getCreateOptions: function() {
		var disabled,

			// This is to support cases like in jQuery Mobile where the base widget does have
			// an implementation of _getCreateOptions
			options = this._super() || {};

		this.isInput = this.element.is( "input" );

		disabled = this.element[ 0 ].disabled;
		if ( disabled != null ) {
			options.disabled = disabled;
		}

		this.originalLabel = this.isInput ? this.element.val() : this.element.html();
		if ( this.originalLabel ) {
			options.label = this.originalLabel;
		}

		return options;
	},

	_create: function() {
		if ( !this.option.showLabel & !this.options.icon ) {
			this.options.showLabel = true;
		}

		// We have to check the option again here even though we did in _getCreateOptions,
		// because null may have been passed on init which would override what was set in
		// _getCreateOptions
		if ( this.options.disabled == null ) {
			this.options.disabled = this.element[ 0 ].disabled || false;
		}

		this.hasTitle = !!this.element.attr( "title" );

		// Check to see if the label needs to be set or if its already correct
		if ( this.options.label && this.options.label !== this.originalLabel ) {
			if ( this.isInput ) {
				this.element.val( this.options.label );
			} else {
				this.element.html( this.options.label );
			}
		}
		this._addClass( "ui-button", "ui-widget" );
		this._setOption( "disabled", this.options.disabled );
		this._enhance();

		if ( this.element.is( "a" ) ) {
			this._on( {
				"keyup": function( event ) {
					if ( event.keyCode === $.ui.keyCode.SPACE ) {
						event.preventDefault();

						// If a native click is available use it, so we
						// actually cause navigation. Otherwise, just trigger
						// a click event.
						if ( this.element[ 0 ].click ) {
							this.element[ 0 ].click();
						} else {
							this.element.trigger( "click" );
						}
					}
				}
			} );
		}
	},

	_enhance: function() {
		if ( !this.element.is( "button" ) ) {
			this.element.attr( "role", "button" );
		}

		if ( this.options.icon ) {
			this._updateIcon( "icon", this.options.icon );
			this._updateTooltip();
		}
	},

	_updateTooltip: function() {
		this.title = this.element.attr( "title" );

		if ( !this.options.showLabel && !this.title ) {
			this.element.attr( "title", this.options.label );
		}
	},

	_updateIcon: function( option, value ) {
		var icon = option !== "iconPosition",
			position = icon ? this.options.iconPosition : value,
			displayBlock = position === "top" || position === "bottom";

		// Create icon
		if ( !this.icon ) {
			this.icon = $( "<span>" );

			this._addClass( this.icon, "ui-button-icon", "ui-icon" );

			if ( !this.options.showLabel ) {
				this._addClass( "ui-button-icon-only" );
			}
		} else if ( icon ) {

			// If we are updating the icon remove the old icon class
			this._removeClass( this.icon, null, this.options.icon );
		}

		// If we are updating the icon add the new icon class
		if ( icon ) {
			this._addClass( this.icon, null, value );
		}

		this._attachIcon( position );

		// If the icon is on top or bottom we need to add the ui-widget-icon-block class and remove
		// the iconSpace if there is one.
		if ( displayBlock ) {
			this._addClass( this.icon, null, "ui-widget-icon-block" );
			if ( this.iconSpace ) {
				this.iconSpace.remove();
			}
		} else {

			// Position is beginning or end so remove the ui-widget-icon-block class and add the
			// space if it does not exist
			if ( !this.iconSpace ) {
				this.iconSpace = $( "<span> </span>" );
				this._addClass( this.iconSpace, "ui-button-icon-space" );
			}
			this._removeClass( this.icon, null, "ui-wiget-icon-block" );
			this._attachIconSpace( position );
		}
	},

	_destroy: function() {
		this.element.removeAttr( "role" );

		if ( this.icon ) {
			this.icon.remove();
		}
		if ( this.iconSpace ) {
			this.iconSpace.remove();
		}
		if ( !this.hasTitle ) {
			this.element.removeAttr( "title" );
		}
	},

	_attachIconSpace: function( iconPosition ) {
		this.icon[ /^(?:end|bottom)/.test( iconPosition ) ? "before" : "after" ]( this.iconSpace );
	},

	_attachIcon: function( iconPosition ) {
		this.element[ /^(?:end|bottom)/.test( iconPosition ) ? "append" : "prepend" ]( this.icon );
	},

	_setOptions: function( options ) {
		var newShowLabel = options.showLabel === undefined ?
				this.options.showLabel :
				options.showLabel,
			newIcon = options.icon === undefined ? this.options.icon : options.icon;

		if ( !newShowLabel && !newIcon ) {
			options.showLabel = true;
		}
		this._super( options );
	},

	_setOption: function( key, value ) {
		if ( key === "icon" ) {
			if ( value ) {
				this._updateIcon( key, value );
			} else if ( this.icon ) {
				this.icon.remove();
				if ( this.iconSpace ) {
					this.iconSpace.remove();
				}
			}
		}

		if ( key === "iconPosition" ) {
			this._updateIcon( key, value );
		}

		// Make sure we can't end up with a button that has neither text nor icon
		if ( key === "showLabel" ) {
				this._toggleClass( "ui-button-icon-only", null, !value );
				this._updateTooltip();
		}

		if ( key === "label" ) {
			if ( this.isInput ) {
				this.element.val( value );
			} else {

				// If there is an icon, append it, else nothing then append the value
				// this avoids removal of the icon when setting label text
				this.element.html( value );
				if ( this.icon ) {
					this._attachIcon( this.options.iconPosition );
					this._attachIconSpace( this.options.iconPosition );
				}
			}
		}

		this._super( key, value );

		if ( key === "disabled" ) {
			this._toggleClass( null, "ui-state-disabled", value );
			this.element[ 0 ].disabled = value;
			if ( value ) {
				this.element.trigger( "blur" );
			}
		}
	},

	refresh: function() {

		// Make sure to only check disabled if its an element that supports this otherwise
		// check for the disabled class to determine state
		var isDisabled = this.element.is( "input, button" ) ?
			this.element[ 0 ].disabled : this.element.hasClass( "ui-button-disabled" );

		if ( isDisabled !== this.options.disabled ) {
			this._setOptions( { disabled: isDisabled } );
		}

		this._updateTooltip();
	}
} );

// DEPRECATED
if ( $.uiBackCompat === true ) {

	// Text and Icons options
	$.widget( "ui.button", $.ui.button, {
		options: {
			text: true,
			icons: {
				primary: null,
				secondary: null
			}
		},

		_create: function() {
			if ( this.options.showLabel && !this.options.text ) {
				this.options.showLabel = this.options.text;
			}
			if ( !this.options.showLabel && this.options.text ) {
				this.options.text = this.options.showLabel;
			}
			if ( !this.options.icon && ( this.options.icons.primary ||
					this.options.icons.secondary ) ) {
				if ( this.options.icons.primary ) {
					this.options.icon = this.options.icons.primary;
				} else {
					this.options.icon = this.options.icons.secondary;
					this.options.iconPosition = "end";
				}
			} else if ( this.options.icon ) {
				this.options.icons.primary = this.options.icon;
			}
			this._super();
		},

		_setOption: function( key, value ) {
			if ( key === "text" ) {
				this._super( "showLabel", value );
				return;
			}
			if ( key === "showLabel" ) {
				this.options.text = value;
			}
			if ( key === "icon" ) {
				this.options.icons.primary = value;
			}
			if ( key === "icons" ) {
				if ( value.primary ) {
					this._super( "icon", value.primary );
					this._super( "iconPosition", "beginning" );
				} else if ( value.secondary ) {
					this._super( "icon", value.secondary );
					this._super( "iconPosition", "end" );
				}
			}
			this._superApply( arguments );
		}
	} );

	$.fn.button = ( function( orig ) {
		return function( options ) {
			var isMethodCall = typeof options === "string";
			var args = Array.prototype.slice.call( arguments, 1 );
			var returnValue = this;

			if ( isMethodCall ) {

				// If this is an empty collection, we need to have the instance method
				// return undefined instead of the jQuery instance
				if ( !this.length && options === "instance" ) {
					returnValue = undefined;
				} else {
					this.each( function() {
						var methodValue;
						var type = $( this ).attr( "type" );
						var name = type !== "checkbox" && type !== "radio" ?
							"button" :
							"checkboxradio";
						var instance = $.data( this, "ui-" + name );

						if ( options === "instance" ) {
							returnValue = instance;
							return false;
						}

						if ( !instance ) {
							return $.error( "cannot call methods on button" +
								" prior to initialization; " +
								"attempted to call method '" + options + "'" );
						}

						if ( typeof instance[ options ] !== "function" ||
							options.charAt( 0 ) === "_" ) {
							return $.error( "no such method '" + options + "' for button" +
								" widget instance" );
						}

						methodValue = instance[ options ].apply( instance, args );

						if ( methodValue !== instance && methodValue !== undefined ) {
							returnValue = methodValue && methodValue.jquery ?
								returnValue.pushStack( methodValue.get() ) :
								methodValue;
							return false;
						}
					} );
				}
			} else {

				// Allow multiple hashes to be passed on init
				if ( args.length ) {
					options = $.widget.extend.apply( null, [ options ].concat( args ) );
				}

				this.each( function() {
					var type = $( this ).attr( "type" );
					var name = type !== "checkbox" && type !== "radio" ? "button" : "checkboxradio";
					var instance = $.data( this, "ui-" + name );

					if ( instance ) {
						instance.option( options || {} );
						if ( instance._init ) {
							instance._init();
						}
					} else {
						if ( name === "button" ) {
							orig.call( $( this ), options );
							return;
						}

						$( this ).checkboxradio( $.extend( { icon: false }, options ) );
					}
				} );
			}

			return returnValue;
		};
	} )( $.fn.button );

	$.fn.buttonset = function() {
		if ( !$.ui.controlgroup ) {
			$.error( "Controlgroup widget missing" );
		}
		if ( arguments[ 0 ] === "option" && arguments[ 1 ] === "items" && arguments[ 2 ] ) {
			return this.controlgroup.apply( this,
				[ arguments[ 0 ], "items.button", arguments[ 2 ] ] );
		}
		if ( arguments[ 0 ] === "option" && arguments[ 1 ] === "items" ) {
			return this.controlgroup.apply( this, [ arguments[ 0 ], "items.button" ] );
		}
		if ( typeof arguments[ 0 ] === "object" && arguments[ 0 ].items ) {
			arguments[ 0 ].items = {
				button: arguments[ 0 ].items
			};
		}
		return this.controlgroup.apply( this, arguments );
	};
}

var widgetsButton = $.ui.button;


/* eslint-disable max-len, camelcase */
/*!
 * jQuery UI Datepicker 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Datepicker
//>>group: Widgets
//>>description: Displays a calendar from an input or inline for selecting dates.
//>>docs: https://api.jqueryui.com/datepicker/
//>>demos: https://jqueryui.com/datepicker/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/datepicker.css
//>>css.theme: ../../themes/base/theme.css


$.extend( $.ui, { datepicker: { version: "1.14.1" } } );

var datepicker_instActive;

function datepicker_getZindex( elem ) {
	var position, value;
	while ( elem.length && elem[ 0 ] !== document ) {

		// Ignore z-index if position is set to a value where z-index is ignored by the browser
		// This makes behavior of this function consistent across browsers
		// WebKit always returns auto if the element is positioned
		position = elem.css( "position" );
		if ( position === "absolute" || position === "relative" || position === "fixed" ) {

			// IE returns 0 when zIndex is not specified
			// other browsers return a string
			// we ignore the case of nested elements with an explicit value of 0
			// <div style="z-index: -10;"><div style="z-index: 0;"></div></div>
			value = parseInt( elem.css( "zIndex" ), 10 );
			if ( !isNaN( value ) && value !== 0 ) {
				return value;
			}
		}
		elem = elem.parent();
	}

	return 0;
}

/* Date picker manager.
   Use the singleton instance of this class, $.datepicker, to interact with the date picker.
   Settings for (groups of) date pickers are maintained in an instance object,
   allowing multiple different settings on the same page. */

function Datepicker() {
	this._curInst = null; // The current instance in use
	this._keyEvent = false; // If the last event was a key event
	this._disabledInputs = []; // List of date picker inputs that have been disabled
	this._datepickerShowing = false; // True if the popup picker is showing , false if not
	this._inDialog = false; // True if showing within a "dialog", false if not
	this._mainDivId = "ui-datepicker-div"; // The ID of the main datepicker division
	this._inlineClass = "ui-datepicker-inline"; // The name of the inline marker class
	this._appendClass = "ui-datepicker-append"; // The name of the append marker class
	this._triggerClass = "ui-datepicker-trigger"; // The name of the trigger marker class
	this._dialogClass = "ui-datepicker-dialog"; // The name of the dialog marker class
	this._disableClass = "ui-datepicker-disabled"; // The name of the disabled covering marker class
	this._unselectableClass = "ui-datepicker-unselectable"; // The name of the unselectable cell marker class
	this._currentClass = "ui-datepicker-current-day"; // The name of the current day marker class
	this._dayOverClass = "ui-datepicker-days-cell-over"; // The name of the day hover marker class
	this.regional = []; // Available regional settings, indexed by language code
	this.regional[ "" ] = { // Default regional settings
		closeText: "Done", // Display text for close link
		prevText: "Prev", // Display text for previous month link
		nextText: "Next", // Display text for next month link
		currentText: "Today", // Display text for current month link
		monthNames: [ "January", "February", "March", "April", "May", "June",
			"July", "August", "September", "October", "November", "December" ], // Names of months for drop-down and formatting
		monthNamesShort: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ], // For formatting
		dayNames: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ], // For formatting
		dayNamesShort: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ], // For formatting
		dayNamesMin: [ "Su", "Mo", "Tu", "We", "Th", "Fr", "Sa" ], // Column headings for days starting at Sunday
		weekHeader: "Wk", // Column header for week of the year
		dateFormat: "mm/dd/yy", // See format options on parseDate
		firstDay: 0, // The first day of the week, Sun = 0, Mon = 1, ...
		isRTL: false, // True if right-to-left language, false if left-to-right
		showMonthAfterYear: false, // True if the year select precedes month, false for month then year
		yearSuffix: "", // Additional text to append to the year in the month headers,
		selectMonthLabel: "Select month", // Invisible label for month selector
		selectYearLabel: "Select year" // Invisible label for year selector
	};
	this._defaults = { // Global defaults for all the date picker instances
		showOn: "focus", // "focus" for popup on focus,
			// "button" for trigger button, or "both" for either
		showAnim: "fadeIn", // Name of jQuery animation for popup
		showOptions: {}, // Options for enhanced animations
		defaultDate: null, // Used when field is blank: actual date,
			// +/-number for offset from today, null for today
		appendText: "", // Display text following the input box, e.g. showing the format
		buttonText: "...", // Text for trigger button
		buttonImage: "", // URL for trigger button image
		buttonImageOnly: false, // True if the image appears alone, false if it appears on a button
		hideIfNoPrevNext: false, // True to hide next/previous month links
			// if not applicable, false to just disable them
		navigationAsDateFormat: false, // True if date formatting applied to prev/today/next links
		gotoCurrent: false, // True if today link goes back to current selection instead
		changeMonth: false, // True if month can be selected directly, false if only prev/next
		changeYear: false, // True if year can be selected directly, false if only prev/next
		yearRange: "c-10:c+10", // Range of years to display in drop-down,
			// either relative to today's year (-nn:+nn), relative to currently displayed year
			// (c-nn:c+nn), absolute (nnnn:nnnn), or a combination of the above (nnnn:-n)
		showOtherMonths: false, // True to show dates in other months, false to leave blank
		selectOtherMonths: false, // True to allow selection of dates in other months, false for unselectable
		showWeek: false, // True to show week of the year, false to not show it
		calculateWeek: this.iso8601Week, // How to calculate the week of the year,
			// takes a Date and returns the number of the week for it
		shortYearCutoff: "+10", // Short year values < this are in the current century,
			// > this are in the previous century,
			// string value starting with "+" for current year + value
		minDate: null, // The earliest selectable date, or null for no limit
		maxDate: null, // The latest selectable date, or null for no limit
		duration: "fast", // Duration of display/closure
		beforeShowDay: null, // Function that takes a date and returns an array with
			// [0] = true if selectable, false if not, [1] = custom CSS class name(s) or "",
			// [2] = cell title (optional), e.g. $.datepicker.noWeekends
		beforeShow: null, // Function that takes an input field and
			// returns a set of custom settings for the date picker
		onSelect: null, // Define a callback function when a date is selected
		onChangeMonthYear: null, // Define a callback function when the month or year is changed
		onClose: null, // Define a callback function when the datepicker is closed
		onUpdateDatepicker: null, // Define a callback function when the datepicker is updated
		numberOfMonths: 1, // Number of months to show at a time
		showCurrentAtPos: 0, // The position in multipe months at which to show the current month (starting at 0)
		stepMonths: 1, // Number of months to step back/forward
		stepBigMonths: 12, // Number of months to step back/forward for the big links
		altField: "", // Selector for an alternate field to store selected dates into
		altFormat: "", // The date format to use for the alternate field
		constrainInput: true, // The input is constrained by the current date format
		showButtonPanel: false, // True to show button panel, false to not show it
		autoSize: false, // True to size the input for the date format, false to leave as is
		disabled: false // The initial disabled state
	};
	$.extend( this._defaults, this.regional[ "" ] );
	this.regional.en = $.extend( true, {}, this.regional[ "" ] );
	this.regional[ "en-US" ] = $.extend( true, {}, this.regional.en );
	this.dpDiv = datepicker_bindHover( $( "<div id='" + this._mainDivId + "' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>" ) );
}

$.extend( Datepicker.prototype, {

	/* Class name added to elements to indicate already configured with a date picker. */
	markerClassName: "hasDatepicker",

	//Keep track of the maximum number of rows displayed (see #7043)
	maxRows: 4,

	// TODO rename to "widget" when switching to widget factory
	_widgetDatepicker: function() {
		return this.dpDiv;
	},

	/* Override the default settings for all instances of the date picker.
	 * @param  settings  object - the new settings to use as defaults (anonymous object)
	 * @return the manager object
	 */
	setDefaults: function( settings ) {
		datepicker_extendRemove( this._defaults, settings || {} );
		return this;
	},

	/* Attach the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 * @param  settings  object - the new settings to use for this date picker instance (anonymous)
	 */
	_attachDatepicker: function( target, settings ) {
		var nodeName, inline, inst;
		nodeName = target.nodeName.toLowerCase();
		inline = ( nodeName === "div" || nodeName === "span" );
		if ( !target.id ) {
			this.uuid += 1;
			target.id = "dp" + this.uuid;
		}
		inst = this._newInst( $( target ), inline );
		inst.settings = $.extend( {}, settings || {} );
		if ( nodeName === "input" ) {
			this._connectDatepicker( target, inst );
		} else if ( inline ) {
			this._inlineDatepicker( target, inst );
		}
	},

	/* Create a new instance object. */
	_newInst: function( target, inline ) {
		var id = target[ 0 ].id.replace( /([^A-Za-z0-9_\-])/g, "\\\\$1" ); // escape jQuery meta chars
		return { id: id, input: target, // associated target
			selectedDay: 0, selectedMonth: 0, selectedYear: 0, // current selection
			drawMonth: 0, drawYear: 0, // month being drawn
			inline: inline, // is datepicker inline or not
			dpDiv: ( !inline ? this.dpDiv : // presentation div
			datepicker_bindHover( $( "<div class='" + this._inlineClass + " ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>" ) ) ) };
	},

	/* Attach the date picker to an input field. */
	_connectDatepicker: function( target, inst ) {
		var input = $( target );
		inst.append = $( [] );
		inst.trigger = $( [] );
		if ( input.hasClass( this.markerClassName ) ) {
			return;
		}
		this._attachments( input, inst );
		input.addClass( this.markerClassName ).on( "keydown", this._doKeyDown ).
			on( "keypress", this._doKeyPress ).on( "keyup", this._doKeyUp );
		this._autoSize( inst );
		$.data( target, "datepicker", inst );

		//If disabled option is true, disable the datepicker once it has been attached to the input (see ticket #5665)
		if ( inst.settings.disabled ) {
			this._disableDatepicker( target );
		}
	},

	/* Make attachments based on settings. */
	_attachments: function( input, inst ) {
		var showOn, buttonText, buttonImage,
			appendText = this._get( inst, "appendText" ),
			isRTL = this._get( inst, "isRTL" );

		if ( inst.append ) {
			inst.append.remove();
		}
		if ( appendText ) {
			inst.append = $( "<span>" )
				.addClass( this._appendClass )
				.text( appendText );
			input[ isRTL ? "before" : "after" ]( inst.append );
		}

		input.off( "focus", this._showDatepicker );

		if ( inst.trigger ) {
			inst.trigger.remove();
		}

		showOn = this._get( inst, "showOn" );
		if ( showOn === "focus" || showOn === "both" ) { // pop-up date picker when in the marked field
			input.on( "focus", this._showDatepicker );
		}
		if ( showOn === "button" || showOn === "both" ) { // pop-up date picker when button clicked
			buttonText = this._get( inst, "buttonText" );
			buttonImage = this._get( inst, "buttonImage" );

			if ( this._get( inst, "buttonImageOnly" ) ) {
				inst.trigger = $( "<img>" )
					.addClass( this._triggerClass )
					.attr( {
						src: buttonImage,
						alt: buttonText,
						title: buttonText
					} );
			} else {
				inst.trigger = $( "<button type='button'>" )
					.addClass( this._triggerClass );
				if ( buttonImage ) {
					inst.trigger.html(
						$( "<img>" )
							.attr( {
								src: buttonImage,
								alt: buttonText,
								title: buttonText
							} )
					);
				} else {
					inst.trigger.text( buttonText );
				}
			}

			input[ isRTL ? "before" : "after" ]( inst.trigger );
			inst.trigger.on( "click", function() {
				if ( $.datepicker._datepickerShowing && $.datepicker._lastInput === input[ 0 ] ) {
					$.datepicker._hideDatepicker();
				} else if ( $.datepicker._datepickerShowing && $.datepicker._lastInput !== input[ 0 ] ) {
					$.datepicker._hideDatepicker();
					$.datepicker._showDatepicker( input[ 0 ] );
				} else {
					$.datepicker._showDatepicker( input[ 0 ] );
				}
				return false;
			} );
		}
	},

	/* Apply the maximum length for the date format. */
	_autoSize: function( inst ) {
		if ( this._get( inst, "autoSize" ) && !inst.inline ) {
			var findMax, max, maxI, i,
				date = new Date( 2009, 12 - 1, 20 ), // Ensure double digits
				dateFormat = this._get( inst, "dateFormat" );

			if ( dateFormat.match( /[DM]/ ) ) {
				findMax = function( names ) {
					max = 0;
					maxI = 0;
					for ( i = 0; i < names.length; i++ ) {
						if ( names[ i ].length > max ) {
							max = names[ i ].length;
							maxI = i;
						}
					}
					return maxI;
				};
				date.setMonth( findMax( this._get( inst, ( dateFormat.match( /MM/ ) ?
					"monthNames" : "monthNamesShort" ) ) ) );
				date.setDate( findMax( this._get( inst, ( dateFormat.match( /DD/ ) ?
					"dayNames" : "dayNamesShort" ) ) ) + 20 - date.getDay() );
			}
			inst.input.attr( "size", this._formatDate( inst, date ).length );
		}
	},

	/* Attach an inline date picker to a div. */
	_inlineDatepicker: function( target, inst ) {
		var divSpan = $( target );
		if ( divSpan.hasClass( this.markerClassName ) ) {
			return;
		}
		divSpan.addClass( this.markerClassName ).append( inst.dpDiv );
		$.data( target, "datepicker", inst );
		this._setDate( inst, this._getDefaultDate( inst ), true );
		this._updateDatepicker( inst );
		this._updateAlternate( inst );

		//If disabled option is true, disable the datepicker before showing it (see ticket #5665)
		if ( inst.settings.disabled ) {
			this._disableDatepicker( target );
		}

		// Set display:block in place of inst.dpDiv.show() which won't work on disconnected elements
		// https://bugs.jqueryui.com/ticket/7552 - A Datepicker created on a detached div has zero height
		inst.dpDiv.css( "display", "block" );
	},

	/* Pop-up the date picker in a "dialog" box.
	 * @param  input element - ignored
	 * @param  date	string or Date - the initial date to display
	 * @param  onSelect  function - the function to call when a date is selected
	 * @param  settings  object - update the dialog date picker instance's settings (anonymous object)
	 * @param  pos int[2] - coordinates for the dialog's position within the screen or
	 *					event - with x/y coordinates or
	 *					leave empty for default (screen centre)
	 * @return the manager object
	 */
	_dialogDatepicker: function( input, date, onSelect, settings, pos ) {
		var id, browserWidth, browserHeight, scrollX, scrollY,
			inst = this._dialogInst; // internal instance

		if ( !inst ) {
			this.uuid += 1;
			id = "dp" + this.uuid;
			this._dialogInput = $( "<input type='text' id='" + id +
				"' style='position: absolute; top: -100px; width: 0px;'/>" );
			this._dialogInput.on( "keydown", this._doKeyDown );
			$( "body" ).append( this._dialogInput );
			inst = this._dialogInst = this._newInst( this._dialogInput, false );
			inst.settings = {};
			$.data( this._dialogInput[ 0 ], "datepicker", inst );
		}
		datepicker_extendRemove( inst.settings, settings || {} );
		date = ( date && date.constructor === Date ? this._formatDate( inst, date ) : date );
		this._dialogInput.val( date );

		this._pos = ( pos ? ( pos.length ? pos : [ pos.pageX, pos.pageY ] ) : null );
		if ( !this._pos ) {
			browserWidth = document.documentElement.clientWidth;
			browserHeight = document.documentElement.clientHeight;
			scrollX = document.documentElement.scrollLeft || document.body.scrollLeft;
			scrollY = document.documentElement.scrollTop || document.body.scrollTop;
			this._pos = // should use actual width/height below
				[ ( browserWidth / 2 ) - 100 + scrollX, ( browserHeight / 2 ) - 150 + scrollY ];
		}

		// Move input on screen for focus, but hidden behind dialog
		this._dialogInput.css( "left", ( this._pos[ 0 ] + 20 ) + "px" ).css( "top", this._pos[ 1 ] + "px" );
		inst.settings.onSelect = onSelect;
		this._inDialog = true;
		this.dpDiv.addClass( this._dialogClass );
		this._showDatepicker( this._dialogInput[ 0 ] );
		if ( $.blockUI ) {
			$.blockUI( this.dpDiv );
		}
		$.data( this._dialogInput[ 0 ], "datepicker", inst );
		return this;
	},

	/* Detach a datepicker from its control.
	 * @param  target	element - the target input field or division or span
	 */
	_destroyDatepicker: function( target ) {
		var nodeName,
			$target = $( target ),
			inst = $.data( target, "datepicker" );

		if ( !$target.hasClass( this.markerClassName ) ) {
			return;
		}

		nodeName = target.nodeName.toLowerCase();
		$.removeData( target, "datepicker" );
		if ( nodeName === "input" ) {
			inst.append.remove();
			inst.trigger.remove();
			$target.removeClass( this.markerClassName ).
				off( "focus", this._showDatepicker ).
				off( "keydown", this._doKeyDown ).
				off( "keypress", this._doKeyPress ).
				off( "keyup", this._doKeyUp );
		} else if ( nodeName === "div" || nodeName === "span" ) {
			$target.removeClass( this.markerClassName ).empty();
		}

		$.datepicker._hideDatepicker();
		if ( datepicker_instActive === inst ) {
			datepicker_instActive = null;
			this._curInst = null;
		}
	},

	/* Enable the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 */
	_enableDatepicker: function( target ) {
		var nodeName, inline,
			$target = $( target ),
			inst = $.data( target, "datepicker" );

		if ( !$target.hasClass( this.markerClassName ) ) {
			return;
		}

		nodeName = target.nodeName.toLowerCase();
		if ( nodeName === "input" ) {
			target.disabled = false;
			inst.trigger.filter( "button" ).
				each( function() {
					this.disabled = false;
				} ).end().
				filter( "img" ).css( { opacity: "1.0", cursor: "" } );
		} else if ( nodeName === "div" || nodeName === "span" ) {
			inline = $target.children( "." + this._inlineClass );
			inline.children().removeClass( "ui-state-disabled" );
			inline.find( "select.ui-datepicker-month, select.ui-datepicker-year" ).
				prop( "disabled", false );
		}
		this._disabledInputs = $.map( this._disabledInputs,

			// Delete entry
			function( value ) {
				return ( value === target ? null : value );
			} );
	},

	/* Disable the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 */
	_disableDatepicker: function( target ) {
		var nodeName, inline,
			$target = $( target ),
			inst = $.data( target, "datepicker" );

		if ( !$target.hasClass( this.markerClassName ) ) {
			return;
		}

		nodeName = target.nodeName.toLowerCase();
		if ( nodeName === "input" ) {
			target.disabled = true;
			inst.trigger.filter( "button" ).
				each( function() {
					this.disabled = true;
				} ).end().
				filter( "img" ).css( { opacity: "0.5", cursor: "default" } );
		} else if ( nodeName === "div" || nodeName === "span" ) {
			inline = $target.children( "." + this._inlineClass );
			inline.children().addClass( "ui-state-disabled" );
			inline.find( "select.ui-datepicker-month, select.ui-datepicker-year" ).
				prop( "disabled", true );
		}
		this._disabledInputs = $.map( this._disabledInputs,

			// Delete entry
			function( value ) {
				return ( value === target ? null : value );
			} );
		this._disabledInputs[ this._disabledInputs.length ] = target;
	},

	/* Is the first field in a jQuery collection disabled as a datepicker?
	 * @param  target	element - the target input field or division or span
	 * @return boolean - true if disabled, false if enabled
	 */
	_isDisabledDatepicker: function( target ) {
		if ( !target ) {
			return false;
		}
		for ( var i = 0; i < this._disabledInputs.length; i++ ) {
			if ( this._disabledInputs[ i ] === target ) {
				return true;
			}
		}
		return false;
	},

	/* Retrieve the instance data for the target control.
	 * @param  target  element - the target input field or division or span
	 * @return  object - the associated instance data
	 * @throws  error if a jQuery problem getting data
	 */
	_getInst: function( target ) {
		try {
			return $.data( target, "datepicker" );
		} catch ( err ) {
			throw "Missing instance data for this datepicker";
		}
	},

	/* Update or retrieve the settings for a date picker attached to an input field or division.
	 * @param  target  element - the target input field or division or span
	 * @param  name	object - the new settings to update or
	 *				string - the name of the setting to change or retrieve,
	 *				when retrieving also "all" for all instance settings or
	 *				"defaults" for all global defaults
	 * @param  value   any - the new value for the setting
	 *				(omit if above is an object or to retrieve a value)
	 */
	_optionDatepicker: function( target, name, value ) {
		var settings, date, minDate, maxDate,
			inst = this._getInst( target );

		if ( arguments.length === 2 && typeof name === "string" ) {
			return ( name === "defaults" ? $.extend( {}, $.datepicker._defaults ) :
				( inst ? ( name === "all" ? $.extend( {}, inst.settings ) :
				this._get( inst, name ) ) : null ) );
		}

		settings = name || {};
		if ( typeof name === "string" ) {
			settings = {};
			settings[ name ] = value;
		}

		if ( inst ) {
			if ( this._curInst === inst ) {
				this._hideDatepicker();
			}

			date = this._getDateDatepicker( target, true );
			minDate = this._getMinMaxDate( inst, "min" );
			maxDate = this._getMinMaxDate( inst, "max" );
			datepicker_extendRemove( inst.settings, settings );

			// reformat the old minDate/maxDate values if dateFormat changes and a new minDate/maxDate isn't provided
			if ( minDate !== null && settings.dateFormat !== undefined && settings.minDate === undefined ) {
				inst.settings.minDate = this._formatDate( inst, minDate );
			}
			if ( maxDate !== null && settings.dateFormat !== undefined && settings.maxDate === undefined ) {
				inst.settings.maxDate = this._formatDate( inst, maxDate );
			}
			if ( "disabled" in settings ) {
				if ( settings.disabled ) {
					this._disableDatepicker( target );
				} else {
					this._enableDatepicker( target );
				}
			}
			this._attachments( $( target ), inst );
			this._autoSize( inst );
			this._setDate( inst, date );
			this._updateAlternate( inst );
			this._updateDatepicker( inst );
		}
	},

	// Change method deprecated
	_changeDatepicker: function( target, name, value ) {
		this._optionDatepicker( target, name, value );
	},

	/* Redraw the date picker attached to an input field or division.
	 * @param  target  element - the target input field or division or span
	 */
	_refreshDatepicker: function( target ) {
		var inst = this._getInst( target );
		if ( inst ) {
			this._updateDatepicker( inst );
		}
	},

	/* Set the dates for a jQuery selection.
	 * @param  target element - the target input field or division or span
	 * @param  date	Date - the new date
	 */
	_setDateDatepicker: function( target, date ) {
		var inst = this._getInst( target );
		if ( inst ) {
			this._setDate( inst, date );
			this._updateDatepicker( inst );
			this._updateAlternate( inst );
		}
	},

	/* Get the date(s) for the first entry in a jQuery selection.
	 * @param  target element - the target input field or division or span
	 * @param  noDefault boolean - true if no default date is to be used
	 * @return Date - the current date
	 */
	_getDateDatepicker: function( target, noDefault ) {
		var inst = this._getInst( target );
		if ( inst && !inst.inline ) {
			this._setDateFromField( inst, noDefault );
		}
		return ( inst ? this._getDate( inst ) : null );
	},

	/* Handle keystrokes. */
	_doKeyDown: function( event ) {
		var onSelect, dateStr, sel,
			inst = $.datepicker._getInst( event.target ),
			handled = true,
			isRTL = inst.dpDiv.is( ".ui-datepicker-rtl" );

		inst._keyEvent = true;
		if ( $.datepicker._datepickerShowing ) {
			switch ( event.keyCode ) {
				case 9: $.datepicker._hideDatepicker();
						handled = false;
						break; // hide on tab out
				case 13: sel = $( "td." + $.datepicker._dayOverClass + ":not(." +
									$.datepicker._currentClass + ")", inst.dpDiv );
						if ( sel[ 0 ] ) {
							$.datepicker._selectDay( event.target, inst.selectedMonth, inst.selectedYear, sel[ 0 ] );
						}

						onSelect = $.datepicker._get( inst, "onSelect" );
						if ( onSelect ) {
							dateStr = $.datepicker._formatDate( inst );

							// Trigger custom callback
							onSelect.apply( ( inst.input ? inst.input[ 0 ] : null ), [ dateStr, inst ] );
						} else {
							$.datepicker._hideDatepicker();
						}

						return false; // don't submit the form
				case 27: $.datepicker._hideDatepicker();
						break; // hide on escape
				case 33: $.datepicker._adjustDate( event.target, ( event.ctrlKey ?
							-$.datepicker._get( inst, "stepBigMonths" ) :
							-$.datepicker._get( inst, "stepMonths" ) ), "M" );
						break; // previous month/year on page up/+ ctrl
				case 34: $.datepicker._adjustDate( event.target, ( event.ctrlKey ?
							+$.datepicker._get( inst, "stepBigMonths" ) :
							+$.datepicker._get( inst, "stepMonths" ) ), "M" );
						break; // next month/year on page down/+ ctrl
				case 35: if ( event.ctrlKey || event.metaKey ) {
							$.datepicker._clearDate( event.target );
						}
						handled = event.ctrlKey || event.metaKey;
						break; // clear on ctrl or command +end
				case 36: if ( event.ctrlKey || event.metaKey ) {
							$.datepicker._gotoToday( event.target );
						}
						handled = event.ctrlKey || event.metaKey;
						break; // current on ctrl or command +home
				case 37: if ( event.ctrlKey || event.metaKey ) {
							$.datepicker._adjustDate( event.target, ( isRTL ? +1 : -1 ), "D" );
						}
						handled = event.ctrlKey || event.metaKey;

						// -1 day on ctrl or command +left
						if ( event.originalEvent.altKey ) {
							$.datepicker._adjustDate( event.target, ( event.ctrlKey ?
								-$.datepicker._get( inst, "stepBigMonths" ) :
								-$.datepicker._get( inst, "stepMonths" ) ), "M" );
						}

						// next month/year on alt +left on Mac
						break;
				case 38: if ( event.ctrlKey || event.metaKey ) {
							$.datepicker._adjustDate( event.target, -7, "D" );
						}
						handled = event.ctrlKey || event.metaKey;
						break; // -1 week on ctrl or command +up
				case 39: if ( event.ctrlKey || event.metaKey ) {
							$.datepicker._adjustDate( event.target, ( isRTL ? -1 : +1 ), "D" );
						}
						handled = event.ctrlKey || event.metaKey;

						// +1 day on ctrl or command +right
						if ( event.originalEvent.altKey ) {
							$.datepicker._adjustDate( event.target, ( event.ctrlKey ?
								+$.datepicker._get( inst, "stepBigMonths" ) :
								+$.datepicker._get( inst, "stepMonths" ) ), "M" );
						}

						// next month/year on alt +right
						break;
				case 40: if ( event.ctrlKey || event.metaKey ) {
							$.datepicker._adjustDate( event.target, +7, "D" );
						}
						handled = event.ctrlKey || event.metaKey;
						break; // +1 week on ctrl or command +down
				default: handled = false;
			}
		} else if ( event.keyCode === 36 && event.ctrlKey ) { // display the date picker on ctrl+home
			$.datepicker._showDatepicker( this );
		} else {
			handled = false;
		}

		if ( handled ) {
			event.preventDefault();
			event.stopPropagation();
		}
	},

	/* Filter entered characters - based on date format. */
	_doKeyPress: function( event ) {
		var chars, chr,
			inst = $.datepicker._getInst( event.target );

		if ( $.datepicker._get( inst, "constrainInput" ) ) {
			chars = $.datepicker._possibleChars( $.datepicker._get( inst, "dateFormat" ) );
			chr = String.fromCharCode( event.charCode == null ? event.keyCode : event.charCode );
			return event.ctrlKey || event.metaKey || ( chr < " " || !chars || chars.indexOf( chr ) > -1 );
		}
	},

	/* Synchronise manual entry and field/alternate field. */
	_doKeyUp: function( event ) {
		var date,
			inst = $.datepicker._getInst( event.target );

		if ( inst.input.val() !== inst.lastVal ) {
			try {
				date = $.datepicker.parseDate( $.datepicker._get( inst, "dateFormat" ),
					( inst.input ? inst.input.val() : null ),
					$.datepicker._getFormatConfig( inst ) );

				if ( date ) { // only if valid
					$.datepicker._setDateFromField( inst );
					$.datepicker._updateAlternate( inst );
					$.datepicker._updateDatepicker( inst );
				}
			} catch ( err ) {
			}
		}
		return true;
	},

	/* Pop-up the date picker for a given input field.
	 * If false returned from beforeShow event handler do not show.
	 * @param  input  element - the input field attached to the date picker or
	 *					event - if triggered by focus
	 */
	_showDatepicker: function( input ) {
		input = input.target || input;
		if ( input.nodeName.toLowerCase() !== "input" ) { // find from button/image trigger
			input = $( "input", input.parentNode )[ 0 ];
		}

		if ( $.datepicker._isDisabledDatepicker( input ) || $.datepicker._lastInput === input ) { // already here
			return;
		}

		var inst, beforeShow, beforeShowSettings, isFixed,
			offset, showAnim, duration;

		inst = $.datepicker._getInst( input );
		if ( $.datepicker._curInst && $.datepicker._curInst !== inst ) {
			$.datepicker._curInst.dpDiv.stop( true, true );
			if ( inst && $.datepicker._datepickerShowing ) {
				$.datepicker._hideDatepicker( $.datepicker._curInst.input[ 0 ] );
			}
		}

		beforeShow = $.datepicker._get( inst, "beforeShow" );
		beforeShowSettings = beforeShow ? beforeShow.apply( input, [ input, inst ] ) : {};
		if ( beforeShowSettings === false ) {
			return;
		}
		datepicker_extendRemove( inst.settings, beforeShowSettings );

		inst.lastVal = null;
		$.datepicker._lastInput = input;
		$.datepicker._setDateFromField( inst );

		if ( $.datepicker._inDialog ) { // hide cursor
			input.value = "";
		}
		if ( !$.datepicker._pos ) { // position below input
			$.datepicker._pos = $.datepicker._findPos( input );
			$.datepicker._pos[ 1 ] += input.offsetHeight; // add the height
		}

		isFixed = false;
		$( input ).parents().each( function() {
			isFixed |= $( this ).css( "position" ) === "fixed";
			return !isFixed;
		} );

		offset = { left: $.datepicker._pos[ 0 ], top: $.datepicker._pos[ 1 ] };
		$.datepicker._pos = null;

		//to avoid flashes on Firefox
		inst.dpDiv.empty();

		// determine sizing offscreen
		inst.dpDiv.css( { position: "absolute", display: "block", top: "-1000px" } );
		$.datepicker._updateDatepicker( inst );

		// fix width for dynamic number of date pickers
		// and adjust position before showing
		offset = $.datepicker._checkOffset( inst, offset, isFixed );
		inst.dpDiv.css( { position: ( $.datepicker._inDialog && $.blockUI ?
			"static" : ( isFixed ? "fixed" : "absolute" ) ), display: "none",
			left: offset.left + "px", top: offset.top + "px" } );

		if ( !inst.inline ) {
			showAnim = $.datepicker._get( inst, "showAnim" );
			duration = $.datepicker._get( inst, "duration" );
			inst.dpDiv.css( "z-index", datepicker_getZindex( $( input ) ) + 1 );
			$.datepicker._datepickerShowing = true;

			if ( $.effects && $.effects.effect[ showAnim ] ) {
				inst.dpDiv.show( showAnim, $.datepicker._get( inst, "showOptions" ), duration );
			} else {
				inst.dpDiv[ showAnim || "show" ]( showAnim ? duration : null );
			}

			if ( $.datepicker._shouldFocusInput( inst ) ) {
				inst.input.trigger( "focus" );
			}

			$.datepicker._curInst = inst;
		}
	},

	/* Generate the date picker content. */
	_updateDatepicker: function( inst ) {
		this.maxRows = 4; //Reset the max number of rows being displayed (see #7043)
		datepicker_instActive = inst; // for delegate hover events
		inst.dpDiv.empty().append( this._generateHTML( inst ) );
		this._attachHandlers( inst );

		var origyearshtml,
			numMonths = this._getNumberOfMonths( inst ),
			cols = numMonths[ 1 ],
			width = 17,
			activeCell = inst.dpDiv.find( "." + this._dayOverClass + " a" ),
			onUpdateDatepicker = $.datepicker._get( inst, "onUpdateDatepicker" );

		if ( activeCell.length > 0 ) {
			datepicker_handleMouseover.apply( activeCell.get( 0 ) );
		}

		inst.dpDiv.removeClass( "ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4" ).width( "" );
		if ( cols > 1 ) {
			inst.dpDiv.addClass( "ui-datepicker-multi-" + cols ).css( "width", ( width * cols ) + "em" );
		}
		inst.dpDiv[ ( numMonths[ 0 ] !== 1 || numMonths[ 1 ] !== 1 ? "add" : "remove" ) +
			"Class" ]( "ui-datepicker-multi" );
		inst.dpDiv[ ( this._get( inst, "isRTL" ) ? "add" : "remove" ) +
			"Class" ]( "ui-datepicker-rtl" );

		if ( inst === $.datepicker._curInst && $.datepicker._datepickerShowing && $.datepicker._shouldFocusInput( inst ) ) {
			inst.input.trigger( "focus" );
		}

		// Deffered render of the years select (to avoid flashes on Firefox)
		if ( inst.yearshtml ) {
			origyearshtml = inst.yearshtml;
			setTimeout( function() {

				//assure that inst.yearshtml didn't change.
				if ( origyearshtml === inst.yearshtml && inst.yearshtml ) {
					inst.dpDiv.find( "select.ui-datepicker-year" ).first().replaceWith( inst.yearshtml );
				}
				origyearshtml = inst.yearshtml = null;
			}, 0 );
		}

		if ( onUpdateDatepicker ) {
			onUpdateDatepicker.apply( ( inst.input ? inst.input[ 0 ] : null ), [ inst ] );
		}
	},

	_shouldFocusInput: function( inst ) {
		return inst.input && inst.input.is( ":visible" ) && !inst.input.is( ":disabled" );
	},

	/* Check positioning to remain on screen. */
	_checkOffset: function( inst, offset, isFixed ) {
		var dpWidth = inst.dpDiv.outerWidth(),
			dpHeight = inst.dpDiv.outerHeight(),
			inputWidth = inst.input ? inst.input.outerWidth() : 0,
			inputHeight = inst.input ? inst.input.outerHeight() : 0,
			viewWidth = document.documentElement.clientWidth + ( isFixed ? 0 : $( document ).scrollLeft() ),
			viewHeight = document.documentElement.clientHeight + ( isFixed ? 0 : $( document ).scrollTop() );

		offset.left -= ( this._get( inst, "isRTL" ) ? ( dpWidth - inputWidth ) : 0 );
		offset.left -= ( isFixed && offset.left === inst.input.offset().left ) ? $( document ).scrollLeft() : 0;
		offset.top -= ( isFixed && offset.top === ( inst.input.offset().top + inputHeight ) ) ? $( document ).scrollTop() : 0;

		// Now check if datepicker is showing outside window viewport - move to a better place if so.
		offset.left -= Math.min( offset.left, ( offset.left + dpWidth > viewWidth && viewWidth > dpWidth ) ?
			Math.abs( offset.left + dpWidth - viewWidth ) : 0 );
		offset.top -= Math.min( offset.top, ( offset.top + dpHeight > viewHeight && viewHeight > dpHeight ) ?
			Math.abs( dpHeight + inputHeight ) : 0 );

		return offset;
	},

	/* Find an object's position on the screen. */
	_findPos: function( obj ) {
		var position,
			inst = this._getInst( obj ),
			isRTL = this._get( inst, "isRTL" );

		while ( obj && ( obj.type === "hidden" || obj.nodeType !== 1 || $.expr.pseudos.hidden( obj ) ) ) {
			obj = obj[ isRTL ? "previousSibling" : "nextSibling" ];
		}

		position = $( obj ).offset();
		return [ position.left, position.top ];
	},

	/* Hide the date picker from view.
	 * @param  input  element - the input field attached to the date picker
	 */
	_hideDatepicker: function( input ) {
		var showAnim, duration, postProcess, onClose,
			inst = this._curInst;

		if ( !inst || ( input && inst !== $.data( input, "datepicker" ) ) ) {
			return;
		}

		if ( this._datepickerShowing ) {
			showAnim = this._get( inst, "showAnim" );
			duration = this._get( inst, "duration" );
			postProcess = function() {
				$.datepicker._tidyDialog( inst );
			};

			if ( $.effects && ( $.effects.effect[ showAnim ] ) ) {
				inst.dpDiv.hide( showAnim, $.datepicker._get( inst, "showOptions" ), duration, postProcess );
			} else {
				inst.dpDiv[ ( showAnim === "slideDown" ? "slideUp" :
					( showAnim === "fadeIn" ? "fadeOut" : "hide" ) ) ]( ( showAnim ? duration : null ), postProcess );
			}

			if ( !showAnim ) {
				postProcess();
			}
			this._datepickerShowing = false;

			onClose = this._get( inst, "onClose" );
			if ( onClose ) {
				onClose.apply( ( inst.input ? inst.input[ 0 ] : null ), [ ( inst.input ? inst.input.val() : "" ), inst ] );
			}

			this._lastInput = null;
			if ( this._inDialog ) {
				this._dialogInput.css( { position: "absolute", left: "0", top: "-100px" } );
				if ( $.blockUI ) {
					$.unblockUI();
					$( "body" ).append( this.dpDiv );
				}
			}
			this._inDialog = false;
		}
	},

	/* Tidy up after a dialog display. */
	_tidyDialog: function( inst ) {
		inst.dpDiv.removeClass( this._dialogClass ).off( ".ui-datepicker-calendar" );
	},

	/* Close date picker if clicked elsewhere. */
	_checkExternalClick: function( event ) {
		if ( !$.datepicker._curInst ) {
			return;
		}

		var $target = $( event.target ),
			inst = $.datepicker._getInst( $target[ 0 ] );

		if ( ( ( $target[ 0 ].id !== $.datepicker._mainDivId &&
				$target.parents( "#" + $.datepicker._mainDivId ).length === 0 &&
				!$target.hasClass( $.datepicker.markerClassName ) &&
				!$target.closest( "." + $.datepicker._triggerClass ).length &&
				$.datepicker._datepickerShowing && !( $.datepicker._inDialog && $.blockUI ) ) ) ||
			( $target.hasClass( $.datepicker.markerClassName ) && $.datepicker._curInst !== inst ) ) {
				$.datepicker._hideDatepicker();
		}
	},

	/* Adjust one of the date sub-fields. */
	_adjustDate: function( id, offset, period ) {
		var target = $( id ),
			inst = this._getInst( target[ 0 ] );

		if ( this._isDisabledDatepicker( target[ 0 ] ) ) {
			return;
		}
		this._adjustInstDate( inst, offset, period );
		this._updateDatepicker( inst );
	},

	/* Action for current link. */
	_gotoToday: function( id ) {
		var date,
			target = $( id ),
			inst = this._getInst( target[ 0 ] );

		if ( this._get( inst, "gotoCurrent" ) && inst.currentDay ) {
			inst.selectedDay = inst.currentDay;
			inst.drawMonth = inst.selectedMonth = inst.currentMonth;
			inst.drawYear = inst.selectedYear = inst.currentYear;
		} else {
			date = new Date();
			inst.selectedDay = date.getDate();
			inst.drawMonth = inst.selectedMonth = date.getMonth();
			inst.drawYear = inst.selectedYear = date.getFullYear();
		}
		this._notifyChange( inst );
		this._adjustDate( target );
	},

	/* Action for selecting a new month/year. */
	_selectMonthYear: function( id, select, period ) {
		var target = $( id ),
			inst = this._getInst( target[ 0 ] );

		inst[ "selected" + ( period === "M" ? "Month" : "Year" ) ] =
		inst[ "draw" + ( period === "M" ? "Month" : "Year" ) ] =
			parseInt( select.options[ select.selectedIndex ].value, 10 );

		this._notifyChange( inst );
		this._adjustDate( target );
	},

	/* Action for selecting a day. */
	_selectDay: function( id, month, year, td ) {
		var inst,
			target = $( id );

		if ( $( td ).hasClass( this._unselectableClass ) || this._isDisabledDatepicker( target[ 0 ] ) ) {
			return;
		}

		inst = this._getInst( target[ 0 ] );
		inst.selectedDay = inst.currentDay = parseInt( $( "a", td ).attr( "data-date" ) );
		inst.selectedMonth = inst.currentMonth = month;
		inst.selectedYear = inst.currentYear = year;
		this._selectDate( id, this._formatDate( inst,
			inst.currentDay, inst.currentMonth, inst.currentYear ) );
	},

	/* Erase the input field and hide the date picker. */
	_clearDate: function( id ) {
		var target = $( id );
		this._selectDate( target, "" );
	},

	/* Update the input field with the selected date. */
	_selectDate: function( id, dateStr ) {
		var onSelect,
			target = $( id ),
			inst = this._getInst( target[ 0 ] );

		dateStr = ( dateStr != null ? dateStr : this._formatDate( inst ) );
		if ( inst.input ) {
			inst.input.val( dateStr );
		}
		this._updateAlternate( inst );

		onSelect = this._get( inst, "onSelect" );
		if ( onSelect ) {
			onSelect.apply( ( inst.input ? inst.input[ 0 ] : null ), [ dateStr, inst ] );  // trigger custom callback
		} else if ( inst.input ) {
			inst.input.trigger( "change" ); // fire the change event
		}

		if ( inst.inline ) {
			this._updateDatepicker( inst );
		} else {
			this._hideDatepicker();
			this._lastInput = inst.input[ 0 ];
			if ( typeof( inst.input[ 0 ] ) !== "object" ) {
				inst.input.trigger( "focus" ); // restore focus
			}
			this._lastInput = null;
		}
	},

	/* Update any alternate field to synchronise with the main field. */
	_updateAlternate: function( inst ) {
		var altFormat, date, dateStr,
			altField = this._get( inst, "altField" );

		if ( altField ) { // update alternate field too
			altFormat = this._get( inst, "altFormat" ) || this._get( inst, "dateFormat" );
			date = this._getDate( inst );
			dateStr = this.formatDate( altFormat, date, this._getFormatConfig( inst ) );
			$( document ).find( altField ).val( dateStr );
		}
	},

	/* Set as beforeShowDay function to prevent selection of weekends.
	 * @param  date  Date - the date to customise
	 * @return [boolean, string] - is this date selectable?, what is its CSS class?
	 */
	noWeekends: function( date ) {
		var day = date.getDay();
		return [ ( day > 0 && day < 6 ), "" ];
	},

	/* Set as calculateWeek to determine the week of the year based on the ISO 8601 definition.
	 * @param  date  Date - the date to get the week for
	 * @return  number - the number of the week within the year that contains this date
	 */
	iso8601Week: function( date ) {
		var time,
			checkDate = new Date( date.getTime() );

		// Find Thursday of this week starting on Monday
		checkDate.setDate( checkDate.getDate() + 4 - ( checkDate.getDay() || 7 ) );

		time = checkDate.getTime();
		checkDate.setMonth( 0 ); // Compare with Jan 1
		checkDate.setDate( 1 );
		return Math.floor( Math.round( ( time - checkDate ) / 86400000 ) / 7 ) + 1;
	},

	/* Parse a string value into a date object.
	 * See formatDate below for the possible formats.
	 *
	 * @param  format string - the expected format of the date
	 * @param  value string - the date in the above format
	 * @param  settings Object - attributes include:
	 *					shortYearCutoff  number - the cutoff year for determining the century (optional)
	 *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
	 *					dayNames		string[7] - names of the days from Sunday (optional)
	 *					monthNamesShort string[12] - abbreviated names of the months (optional)
	 *					monthNames		string[12] - names of the months (optional)
	 * @return  Date - the extracted date value or null if value is blank
	 */
	parseDate: function( format, value, settings ) {
		if ( format == null || value == null ) {
			throw "Invalid arguments";
		}

		value = ( typeof value === "object" ? value.toString() : value + "" );
		if ( value === "" ) {
			return null;
		}

		var iFormat, dim, extra,
			iValue = 0,
			shortYearCutoffTemp = ( settings ? settings.shortYearCutoff : null ) || this._defaults.shortYearCutoff,
			shortYearCutoff = ( typeof shortYearCutoffTemp !== "string" ? shortYearCutoffTemp :
				new Date().getFullYear() % 100 + parseInt( shortYearCutoffTemp, 10 ) ),
			dayNamesShort = ( settings ? settings.dayNamesShort : null ) || this._defaults.dayNamesShort,
			dayNames = ( settings ? settings.dayNames : null ) || this._defaults.dayNames,
			monthNamesShort = ( settings ? settings.monthNamesShort : null ) || this._defaults.monthNamesShort,
			monthNames = ( settings ? settings.monthNames : null ) || this._defaults.monthNames,
			year = -1,
			month = -1,
			day = -1,
			doy = -1,
			literal = false,
			date,

			// Check whether a format character is doubled
			lookAhead = function( match ) {
				var matches = ( iFormat + 1 < format.length && format.charAt( iFormat + 1 ) === match );
				if ( matches ) {
					iFormat++;
				}
				return matches;
			},

			// Extract a number from the string value
			getNumber = function( match ) {
				var isDoubled = lookAhead( match ),
					size = ( match === "@" ? 14 : ( match === "!" ? 20 :
					( match === "y" && isDoubled ? 4 : ( match === "o" ? 3 : 2 ) ) ) ),
					minSize = ( match === "y" ? size : 1 ),
					digits = new RegExp( "^\\d{" + minSize + "," + size + "}" ),
					num = value.substring( iValue ).match( digits );
				if ( !num ) {
					throw "Missing number at position " + iValue;
				}
				iValue += num[ 0 ].length;
				return parseInt( num[ 0 ], 10 );
			},

			// Extract a name from the string value and convert to an index
			getName = function( match, shortNames, longNames ) {
				var index = -1,
					names = $.map( lookAhead( match ) ? longNames : shortNames, function( v, k ) {
						return [ [ k, v ] ];
					} ).sort( function( a, b ) {
						return -( a[ 1 ].length - b[ 1 ].length );
					} );

				$.each( names, function( i, pair ) {
					var name = pair[ 1 ];
					if ( value.substr( iValue, name.length ).toLowerCase() === name.toLowerCase() ) {
						index = pair[ 0 ];
						iValue += name.length;
						return false;
					}
				} );
				if ( index !== -1 ) {
					return index + 1;
				} else {
					throw "Unknown name at position " + iValue;
				}
			},

			// Confirm that a literal character matches the string value
			checkLiteral = function() {
				if ( value.charAt( iValue ) !== format.charAt( iFormat ) ) {
					throw "Unexpected literal at position " + iValue;
				}
				iValue++;
			};

		for ( iFormat = 0; iFormat < format.length; iFormat++ ) {
			if ( literal ) {
				if ( format.charAt( iFormat ) === "'" && !lookAhead( "'" ) ) {
					literal = false;
				} else {
					checkLiteral();
				}
			} else {
				switch ( format.charAt( iFormat ) ) {
					case "d":
						day = getNumber( "d" );
						break;
					case "D":
						getName( "D", dayNamesShort, dayNames );
						break;
					case "o":
						doy = getNumber( "o" );
						break;
					case "m":
						month = getNumber( "m" );
						break;
					case "M":
						month = getName( "M", monthNamesShort, monthNames );
						break;
					case "y":
						year = getNumber( "y" );
						break;
					case "@":
						date = new Date( getNumber( "@" ) );
						year = date.getFullYear();
						month = date.getMonth() + 1;
						day = date.getDate();
						break;
					case "!":
						date = new Date( ( getNumber( "!" ) - this._ticksTo1970 ) / 10000 );
						year = date.getFullYear();
						month = date.getMonth() + 1;
						day = date.getDate();
						break;
					case "'":
						if ( lookAhead( "'" ) ) {
							checkLiteral();
						} else {
							literal = true;
						}
						break;
					default:
						checkLiteral();
				}
			}
		}

		if ( iValue < value.length ) {
			extra = value.substr( iValue );
			if ( !/^\s+/.test( extra ) ) {
				throw "Extra/unparsed characters found in date: " + extra;
			}
		}

		if ( year === -1 ) {
			year = new Date().getFullYear();
		} else if ( year < 100 ) {
			year += new Date().getFullYear() - new Date().getFullYear() % 100 +
				( year <= shortYearCutoff ? 0 : -100 );
		}

		if ( doy > -1 ) {
			month = 1;
			day = doy;
			do {
				dim = this._getDaysInMonth( year, month - 1 );
				if ( day <= dim ) {
					break;
				}
				month++;
				day -= dim;
			} while ( true );
		}

		date = this._daylightSavingAdjust( new Date( year, month - 1, day ) );
		if ( date.getFullYear() !== year || date.getMonth() + 1 !== month || date.getDate() !== day ) {
			throw "Invalid date"; // E.g. 31/02/00
		}
		return date;
	},

	/* Standard date formats. */
	ATOM: "yy-mm-dd", // RFC 3339 (ISO 8601)
	COOKIE: "D, dd M yy",
	ISO_8601: "yy-mm-dd",
	RFC_822: "D, d M y",
	RFC_850: "DD, dd-M-y",
	RFC_1036: "D, d M y",
	RFC_1123: "D, d M yy",
	RFC_2822: "D, d M yy",
	RSS: "D, d M y", // RFC 822
	TICKS: "!",
	TIMESTAMP: "@",
	W3C: "yy-mm-dd", // ISO 8601

	_ticksTo1970: ( ( ( 1970 - 1 ) * 365 + Math.floor( 1970 / 4 ) - Math.floor( 1970 / 100 ) +
		Math.floor( 1970 / 400 ) ) * 24 * 60 * 60 * 10000000 ),

	/* Format a date object into a string value.
	 * The format can be combinations of the following:
	 * d  - day of month (no leading zero)
	 * dd - day of month (two digit)
	 * o  - day of year (no leading zeros)
	 * oo - day of year (three digit)
	 * D  - day name short
	 * DD - day name long
	 * m  - month of year (no leading zero)
	 * mm - month of year (two digit)
	 * M  - month name short
	 * MM - month name long
	 * y  - year (two digit)
	 * yy - year (four digit)
	 * @ - Unix timestamp (ms since 01/01/1970)
	 * ! - Windows ticks (100ns since 01/01/0001)
	 * "..." - literal text
	 * '' - single quote
	 *
	 * @param  format string - the desired format of the date
	 * @param  date Date - the date value to format
	 * @param  settings Object - attributes include:
	 *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
	 *					dayNames		string[7] - names of the days from Sunday (optional)
	 *					monthNamesShort string[12] - abbreviated names of the months (optional)
	 *					monthNames		string[12] - names of the months (optional)
	 * @return  string - the date in the above format
	 */
	formatDate: function( format, date, settings ) {
		if ( !date ) {
			return "";
		}

		var iFormat,
			dayNamesShort = ( settings ? settings.dayNamesShort : null ) || this._defaults.dayNamesShort,
			dayNames = ( settings ? settings.dayNames : null ) || this._defaults.dayNames,
			monthNamesShort = ( settings ? settings.monthNamesShort : null ) || this._defaults.monthNamesShort,
			monthNames = ( settings ? settings.monthNames : null ) || this._defaults.monthNames,

			// Check whether a format character is doubled
			lookAhead = function( match ) {
				var matches = ( iFormat + 1 < format.length && format.charAt( iFormat + 1 ) === match );
				if ( matches ) {
					iFormat++;
				}
				return matches;
			},

			// Format a number, with leading zero if necessary
			formatNumber = function( match, value, len ) {
				var num = "" + value;
				if ( lookAhead( match ) ) {
					while ( num.length < len ) {
						num = "0" + num;
					}
				}
				return num;
			},

			// Format a name, short or long as requested
			formatName = function( match, value, shortNames, longNames ) {
				return ( lookAhead( match ) ? longNames[ value ] : shortNames[ value ] );
			},
			output = "",
			literal = false;

		if ( date ) {
			for ( iFormat = 0; iFormat < format.length; iFormat++ ) {
				if ( literal ) {
					if ( format.charAt( iFormat ) === "'" && !lookAhead( "'" ) ) {
						literal = false;
					} else {
						output += format.charAt( iFormat );
					}
				} else {
					switch ( format.charAt( iFormat ) ) {
						case "d":
							output += formatNumber( "d", date.getDate(), 2 );
							break;
						case "D":
							output += formatName( "D", date.getDay(), dayNamesShort, dayNames );
							break;
						case "o":
							output += formatNumber( "o",
								Math.round( ( new Date( date.getFullYear(), date.getMonth(), date.getDate() ).getTime() - new Date( date.getFullYear(), 0, 0 ).getTime() ) / 86400000 ), 3 );
							break;
						case "m":
							output += formatNumber( "m", date.getMonth() + 1, 2 );
							break;
						case "M":
							output += formatName( "M", date.getMonth(), monthNamesShort, monthNames );
							break;
						case "y":
							output += ( lookAhead( "y" ) ? date.getFullYear() :
								( date.getFullYear() % 100 < 10 ? "0" : "" ) + date.getFullYear() % 100 );
							break;
						case "@":
							output += date.getTime();
							break;
						case "!":
							output += date.getTime() * 10000 + this._ticksTo1970;
							break;
						case "'":
							if ( lookAhead( "'" ) ) {
								output += "'";
							} else {
								literal = true;
							}
							break;
						default:
							output += format.charAt( iFormat );
					}
				}
			}
		}
		return output;
	},

	/* Extract all possible characters from the date format. */
	_possibleChars: function( format ) {
		var iFormat,
			chars = "",
			literal = false,

			// Check whether a format character is doubled
			lookAhead = function( match ) {
				var matches = ( iFormat + 1 < format.length && format.charAt( iFormat + 1 ) === match );
				if ( matches ) {
					iFormat++;
				}
				return matches;
			};

		for ( iFormat = 0; iFormat < format.length; iFormat++ ) {
			if ( literal ) {
				if ( format.charAt( iFormat ) === "'" && !lookAhead( "'" ) ) {
					literal = false;
				} else {
					chars += format.charAt( iFormat );
				}
			} else {
				switch ( format.charAt( iFormat ) ) {
					case "d": case "m": case "y": case "@":
						chars += "0123456789";
						break;
					case "D": case "M":
						return null; // Accept anything
					case "'":
						if ( lookAhead( "'" ) ) {
							chars += "'";
						} else {
							literal = true;
						}
						break;
					default:
						chars += format.charAt( iFormat );
				}
			}
		}
		return chars;
	},

	/* Get a setting value, defaulting if necessary. */
	_get: function( inst, name ) {
		return inst.settings[ name ] !== undefined ?
			inst.settings[ name ] : this._defaults[ name ];
	},

	/* Parse existing date and initialise date picker. */
	_setDateFromField: function( inst, noDefault ) {
		if ( inst.input.val() === inst.lastVal ) {
			return;
		}

		var dateFormat = this._get( inst, "dateFormat" ),
			dates = inst.lastVal = inst.input ? inst.input.val() : null,
			defaultDate = this._getDefaultDate( inst ),
			date = defaultDate,
			settings = this._getFormatConfig( inst );

		try {
			date = this.parseDate( dateFormat, dates, settings ) || defaultDate;
		} catch ( event ) {
			dates = ( noDefault ? "" : dates );
		}
		inst.selectedDay = date.getDate();
		inst.drawMonth = inst.selectedMonth = date.getMonth();
		inst.drawYear = inst.selectedYear = date.getFullYear();
		inst.currentDay = ( dates ? date.getDate() : 0 );
		inst.currentMonth = ( dates ? date.getMonth() : 0 );
		inst.currentYear = ( dates ? date.getFullYear() : 0 );
		this._adjustInstDate( inst );
	},

	/* Retrieve the default date shown on opening. */
	_getDefaultDate: function( inst ) {
		return this._restrictMinMax( inst,
			this._determineDate( inst, this._get( inst, "defaultDate" ), new Date() ) );
	},

	/* A date may be specified as an exact value or a relative one. */
	_determineDate: function( inst, date, defaultDate ) {
		var offsetNumeric = function( offset ) {
				var date = new Date();
				date.setDate( date.getDate() + offset );
				return date;
			},
			offsetString = function( offset ) {
				try {
					return $.datepicker.parseDate( $.datepicker._get( inst, "dateFormat" ),
						offset, $.datepicker._getFormatConfig( inst ) );
				} catch ( e ) {

					// Ignore
				}

				var date = ( offset.toLowerCase().match( /^c/ ) ?
					$.datepicker._getDate( inst ) : null ) || new Date(),
					year = date.getFullYear(),
					month = date.getMonth(),
					day = date.getDate(),
					pattern = /([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g,
					matches = pattern.exec( offset );

				while ( matches ) {
					switch ( matches[ 2 ] || "d" ) {
						case "d" : case "D" :
							day += parseInt( matches[ 1 ], 10 ); break;
						case "w" : case "W" :
							day += parseInt( matches[ 1 ], 10 ) * 7; break;
						case "m" : case "M" :
							month += parseInt( matches[ 1 ], 10 );
							day = Math.min( day, $.datepicker._getDaysInMonth( year, month ) );
							break;
						case "y": case "Y" :
							year += parseInt( matches[ 1 ], 10 );
							day = Math.min( day, $.datepicker._getDaysInMonth( year, month ) );
							break;
					}
					matches = pattern.exec( offset );
				}
				return new Date( year, month, day );
			},
			newDate = ( date == null || date === "" ? defaultDate : ( typeof date === "string" ? offsetString( date ) :
				( typeof date === "number" ? ( isNaN( date ) ? defaultDate : offsetNumeric( date ) ) : new Date( date.getTime() ) ) ) );

		newDate = ( newDate && newDate.toString() === "Invalid Date" ? defaultDate : newDate );
		if ( newDate ) {
			newDate.setHours( 0 );
			newDate.setMinutes( 0 );
			newDate.setSeconds( 0 );
			newDate.setMilliseconds( 0 );
		}
		return this._daylightSavingAdjust( newDate );
	},

	/* Handle switch to/from daylight saving.
	 * Hours may be non-zero on daylight saving cut-over:
	 * > 12 when midnight changeover, but then cannot generate
	 * midnight datetime, so jump to 1AM, otherwise reset.
	 * @param  date  (Date) the date to check
	 * @return  (Date) the corrected date
	 */
	_daylightSavingAdjust: function( date ) {
		if ( !date ) {
			return null;
		}
		date.setHours( date.getHours() > 12 ? date.getHours() + 2 : 0 );
		return date;
	},

	/* Set the date(s) directly. */
	_setDate: function( inst, date, noChange ) {
		var clear = !date,
			origMonth = inst.selectedMonth,
			origYear = inst.selectedYear,
			newDate = this._restrictMinMax( inst, this._determineDate( inst, date, new Date() ) );

		inst.selectedDay = inst.currentDay = newDate.getDate();
		inst.drawMonth = inst.selectedMonth = inst.currentMonth = newDate.getMonth();
		inst.drawYear = inst.selectedYear = inst.currentYear = newDate.getFullYear();
		if ( ( origMonth !== inst.selectedMonth || origYear !== inst.selectedYear ) && !noChange ) {
			this._notifyChange( inst );
		}
		this._adjustInstDate( inst );
		if ( inst.input ) {
			inst.input.val( clear ? "" : this._formatDate( inst ) );
		}
	},

	/* Retrieve the date(s) directly. */
	_getDate: function( inst ) {
		var startDate = ( !inst.currentYear || ( inst.input && inst.input.val() === "" ) ? null :
			this._daylightSavingAdjust( new Date(
			inst.currentYear, inst.currentMonth, inst.currentDay ) ) );
			return startDate;
	},

	/* Attach the onxxx handlers.  These are declared statically so
	 * they work with static code transformers like Caja.
	 */
	_attachHandlers: function( inst ) {
		var stepMonths = this._get( inst, "stepMonths" ),
			id = "#" + inst.id.replace( /\\\\/g, "\\" );
		inst.dpDiv.find( "[data-handler]" ).map( function() {
			var handler = {
				prev: function() {
					$.datepicker._adjustDate( id, -stepMonths, "M" );
				},
				next: function() {
					$.datepicker._adjustDate( id, +stepMonths, "M" );
				},
				hide: function() {
					$.datepicker._hideDatepicker();
				},
				today: function() {
					$.datepicker._gotoToday( id );
				},
				selectDay: function() {
					$.datepicker._selectDay( id, +this.getAttribute( "data-month" ), +this.getAttribute( "data-year" ), this );
					return false;
				},
				selectMonth: function() {
					$.datepicker._selectMonthYear( id, this, "M" );
					return false;
				},
				selectYear: function() {
					$.datepicker._selectMonthYear( id, this, "Y" );
					return false;
				}
			};
			$( this ).on( this.getAttribute( "data-event" ), handler[ this.getAttribute( "data-handler" ) ] );
		} );
	},

	/* Generate the HTML for the current state of the date picker. */
	_generateHTML: function( inst ) {
		var maxDraw, prevText, prev, nextText, next, currentText, gotoDate,
			controls, buttonPanel, firstDay, showWeek, dayNames, dayNamesMin,
			monthNames, monthNamesShort, beforeShowDay, showOtherMonths,
			selectOtherMonths, defaultDate, html, dow, row, group, col, selectedDate,
			cornerClass, calender, thead, day, daysInMonth, leadDays, curRows, numRows,
			printDate, dRow, tbody, daySettings, otherMonth, unselectable,
			tempDate = new Date(),
			today = this._daylightSavingAdjust(
				new Date( tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate() ) ), // clear time
			isRTL = this._get( inst, "isRTL" ),
			showButtonPanel = this._get( inst, "showButtonPanel" ),
			hideIfNoPrevNext = this._get( inst, "hideIfNoPrevNext" ),
			navigationAsDateFormat = this._get( inst, "navigationAsDateFormat" ),
			numMonths = this._getNumberOfMonths( inst ),
			showCurrentAtPos = this._get( inst, "showCurrentAtPos" ),
			stepMonths = this._get( inst, "stepMonths" ),
			isMultiMonth = ( numMonths[ 0 ] !== 1 || numMonths[ 1 ] !== 1 ),
			currentDate = this._daylightSavingAdjust( ( !inst.currentDay ? new Date( 9999, 9, 9 ) :
				new Date( inst.currentYear, inst.currentMonth, inst.currentDay ) ) ),
			minDate = this._getMinMaxDate( inst, "min" ),
			maxDate = this._getMinMaxDate( inst, "max" ),
			drawMonth = inst.drawMonth - showCurrentAtPos,
			drawYear = inst.drawYear;

		if ( drawMonth < 0 ) {
			drawMonth += 12;
			drawYear--;
		}
		if ( maxDate ) {
			maxDraw = this._daylightSavingAdjust( new Date( maxDate.getFullYear(),
				maxDate.getMonth() - ( numMonths[ 0 ] * numMonths[ 1 ] ) + 1, maxDate.getDate() ) );
			maxDraw = ( minDate && maxDraw < minDate ? minDate : maxDraw );
			while ( this._daylightSavingAdjust( new Date( drawYear, drawMonth, 1 ) ) > maxDraw ) {
				drawMonth--;
				if ( drawMonth < 0 ) {
					drawMonth = 11;
					drawYear--;
				}
			}
		}
		inst.drawMonth = drawMonth;
		inst.drawYear = drawYear;

		prevText = this._get( inst, "prevText" );
		prevText = ( !navigationAsDateFormat ? prevText : this.formatDate( prevText,
			this._daylightSavingAdjust( new Date( drawYear, drawMonth - stepMonths, 1 ) ),
			this._getFormatConfig( inst ) ) );

		if ( this._canAdjustMonth( inst, -1, drawYear, drawMonth ) ) {
			prev = $( "<a>" )
				.attr( {
					"class": "ui-datepicker-prev ui-corner-all",
					"data-handler": "prev",
					"data-event": "click",
					title: prevText
				} )
				.append(
					$( "<span>" )
						.addClass( "ui-icon ui-icon-circle-triangle-" +
							( isRTL ? "e" : "w" ) )
						.text( prevText )
				)[ 0 ].outerHTML;
		} else if ( hideIfNoPrevNext ) {
			prev = "";
		} else {
			prev = $( "<a>" )
				.attr( {
					"class": "ui-datepicker-prev ui-corner-all ui-state-disabled",
					title: prevText
				} )
				.append(
					$( "<span>" )
						.addClass( "ui-icon ui-icon-circle-triangle-" +
							( isRTL ? "e" : "w" ) )
						.text( prevText )
				)[ 0 ].outerHTML;
		}

		nextText = this._get( inst, "nextText" );
		nextText = ( !navigationAsDateFormat ? nextText : this.formatDate( nextText,
			this._daylightSavingAdjust( new Date( drawYear, drawMonth + stepMonths, 1 ) ),
			this._getFormatConfig( inst ) ) );

		if ( this._canAdjustMonth( inst, +1, drawYear, drawMonth ) ) {
			next = $( "<a>" )
				.attr( {
					"class": "ui-datepicker-next ui-corner-all",
					"data-handler": "next",
					"data-event": "click",
					title: nextText
				} )
				.append(
					$( "<span>" )
						.addClass( "ui-icon ui-icon-circle-triangle-" +
							( isRTL ? "w" : "e" ) )
						.text( nextText )
				)[ 0 ].outerHTML;
		} else if ( hideIfNoPrevNext ) {
			next = "";
		} else {
			next = $( "<a>" )
				.attr( {
					"class": "ui-datepicker-next ui-corner-all ui-state-disabled",
					title: nextText
				} )
				.append(
					$( "<span>" )
						.attr( "class", "ui-icon ui-icon-circle-triangle-" +
							( isRTL ? "w" : "e" ) )
						.text( nextText )
				)[ 0 ].outerHTML;
		}

		currentText = this._get( inst, "currentText" );
		gotoDate = ( this._get( inst, "gotoCurrent" ) && inst.currentDay ? currentDate : today );
		currentText = ( !navigationAsDateFormat ? currentText :
			this.formatDate( currentText, gotoDate, this._getFormatConfig( inst ) ) );

		controls = "";
		if ( !inst.inline ) {
			controls = $( "<button>" )
				.attr( {
					type: "button",
					"class": "ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all",
					"data-handler": "hide",
					"data-event": "click"
				} )
				.text( this._get( inst, "closeText" ) )[ 0 ].outerHTML;
		}

		buttonPanel = "";
		if ( showButtonPanel ) {
			buttonPanel = $( "<div class='ui-datepicker-buttonpane ui-widget-content'>" )
				.append( isRTL ? controls : "" )
				.append( this._isInRange( inst, gotoDate ) ?
					$( "<button>" )
						.attr( {
							type: "button",
							"class": "ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all",
							"data-handler": "today",
							"data-event": "click"
						} )
						.text( currentText ) :
					"" )
				.append( isRTL ? "" : controls )[ 0 ].outerHTML;
		}

		firstDay = parseInt( this._get( inst, "firstDay" ), 10 );
		firstDay = ( isNaN( firstDay ) ? 0 : firstDay );

		showWeek = this._get( inst, "showWeek" );
		dayNames = this._get( inst, "dayNames" );
		dayNamesMin = this._get( inst, "dayNamesMin" );
		monthNames = this._get( inst, "monthNames" );
		monthNamesShort = this._get( inst, "monthNamesShort" );
		beforeShowDay = this._get( inst, "beforeShowDay" );
		showOtherMonths = this._get( inst, "showOtherMonths" );
		selectOtherMonths = this._get( inst, "selectOtherMonths" );
		defaultDate = this._getDefaultDate( inst );
		html = "";

		for ( row = 0; row < numMonths[ 0 ]; row++ ) {
			group = "";
			this.maxRows = 4;
			for ( col = 0; col < numMonths[ 1 ]; col++ ) {
				selectedDate = this._daylightSavingAdjust( new Date( drawYear, drawMonth, inst.selectedDay ) );
				cornerClass = " ui-corner-all";
				calender = "";
				if ( isMultiMonth ) {
					calender += "<div class='ui-datepicker-group";
					if ( numMonths[ 1 ] > 1 ) {
						switch ( col ) {
							case 0: calender += " ui-datepicker-group-first";
								cornerClass = " ui-corner-" + ( isRTL ? "right" : "left" ); break;
							case numMonths[ 1 ] - 1: calender += " ui-datepicker-group-last";
								cornerClass = " ui-corner-" + ( isRTL ? "left" : "right" ); break;
							default: calender += " ui-datepicker-group-middle"; cornerClass = ""; break;
						}
					}
					calender += "'>";
				}
				calender += "<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix" + cornerClass + "'>" +
					( /all|left/.test( cornerClass ) && row === 0 ? ( isRTL ? next : prev ) : "" ) +
					( /all|right/.test( cornerClass ) && row === 0 ? ( isRTL ? prev : next ) : "" ) +
					this._generateMonthYearHeader( inst, drawMonth, drawYear, minDate, maxDate,
					row > 0 || col > 0, monthNames, monthNamesShort ) + // draw month headers
					"</div><table class='ui-datepicker-calendar'><thead>" +
					"<tr>";
				thead = ( showWeek ? "<th class='ui-datepicker-week-col'>" + this._get( inst, "weekHeader" ) + "</th>" : "" );
				for ( dow = 0; dow < 7; dow++ ) { // days of the week
					day = ( dow + firstDay ) % 7;
					thead += "<th scope='col'" + ( ( dow + firstDay + 6 ) % 7 >= 5 ? " class='ui-datepicker-week-end'" : "" ) + ">" +
						"<span title='" + dayNames[ day ] + "'>" + dayNamesMin[ day ] + "</span></th>";
				}
				calender += thead + "</tr></thead><tbody>";
				daysInMonth = this._getDaysInMonth( drawYear, drawMonth );
				if ( drawYear === inst.selectedYear && drawMonth === inst.selectedMonth ) {
					inst.selectedDay = Math.min( inst.selectedDay, daysInMonth );
				}
				leadDays = ( this._getFirstDayOfMonth( drawYear, drawMonth ) - firstDay + 7 ) % 7;
				curRows = Math.ceil( ( leadDays + daysInMonth ) / 7 ); // calculate the number of rows to generate
				numRows = ( isMultiMonth ? this.maxRows > curRows ? this.maxRows : curRows : curRows ); //If multiple months, use the higher number of rows (see #7043)
				this.maxRows = numRows;
				printDate = this._daylightSavingAdjust( new Date( drawYear, drawMonth, 1 - leadDays ) );
				for ( dRow = 0; dRow < numRows; dRow++ ) { // create date picker rows
					calender += "<tr>";
					tbody = ( !showWeek ? "" : "<td class='ui-datepicker-week-col'>" +
						this._get( inst, "calculateWeek" )( printDate ) + "</td>" );
					for ( dow = 0; dow < 7; dow++ ) { // create date picker days
						daySettings = ( beforeShowDay ?
							beforeShowDay.apply( ( inst.input ? inst.input[ 0 ] : null ), [ printDate ] ) : [ true, "" ] );
						otherMonth = ( printDate.getMonth() !== drawMonth );
						unselectable = ( otherMonth && !selectOtherMonths ) || !daySettings[ 0 ] ||
							( minDate && printDate < minDate ) || ( maxDate && printDate > maxDate );
						tbody += "<td class='" +
							( ( dow + firstDay + 6 ) % 7 >= 5 ? " ui-datepicker-week-end" : "" ) + // highlight weekends
							( otherMonth ? " ui-datepicker-other-month" : "" ) + // highlight days from other months
							( ( printDate.getTime() === selectedDate.getTime() && drawMonth === inst.selectedMonth && inst._keyEvent ) || // user pressed key
							( defaultDate.getTime() === printDate.getTime() && defaultDate.getTime() === selectedDate.getTime() ) ?

							// or defaultDate is current printedDate and defaultDate is selectedDate
							" " + this._dayOverClass : "" ) + // highlight selected day
							( unselectable ? " " + this._unselectableClass + " ui-state-disabled" : "" ) +  // highlight unselectable days
							( otherMonth && !showOtherMonths ? "" : " " + daySettings[ 1 ] + // highlight custom dates
							( printDate.getTime() === currentDate.getTime() ? " " + this._currentClass : "" ) + // highlight selected day
							( printDate.getTime() === today.getTime() ? " ui-datepicker-today" : "" ) ) + "'" + // highlight today (if different)
							( ( !otherMonth || showOtherMonths ) && daySettings[ 2 ] ? " title='" + daySettings[ 2 ].replace( /'/g, "&#39;" ) + "'" : "" ) + // cell title
							( unselectable ? "" : " data-handler='selectDay' data-event='click' data-month='" + printDate.getMonth() + "' data-year='" + printDate.getFullYear() + "'" ) + ">" + // actions
							( otherMonth && !showOtherMonths ? "&#xa0;" : // display for other months
							( unselectable ? "<span class='ui-state-default'>" + printDate.getDate() + "</span>" : "<a class='ui-state-default" +
							( printDate.getTime() === today.getTime() ? " ui-state-highlight" : "" ) +
							( printDate.getTime() === currentDate.getTime() ? " ui-state-active" : "" ) + // highlight selected day
							( otherMonth ? " ui-priority-secondary" : "" ) + // distinguish dates from other months
							"' href='#' aria-current='" + ( printDate.getTime() === currentDate.getTime() ? "true" : "false" ) + // mark date as selected for screen reader
							"' data-date='" + printDate.getDate() + // store date as data
							"'>" + printDate.getDate() + "</a>" ) ) + "</td>"; // display selectable date
						printDate.setDate( printDate.getDate() + 1 );
						printDate = this._daylightSavingAdjust( printDate );
					}
					calender += tbody + "</tr>";
				}
				drawMonth++;
				if ( drawMonth > 11 ) {
					drawMonth = 0;
					drawYear++;
				}
				calender += "</tbody></table>" + ( isMultiMonth ? "</div>" +
							( ( numMonths[ 0 ] > 0 && col === numMonths[ 1 ] - 1 ) ? "<div class='ui-datepicker-row-break'></div>" : "" ) : "" );
				group += calender;
			}
			html += group;
		}
		html += buttonPanel;
		inst._keyEvent = false;
		return html;
	},

	/* Generate the month and year header. */
	_generateMonthYearHeader: function( inst, drawMonth, drawYear, minDate, maxDate,
			secondary, monthNames, monthNamesShort ) {

		var inMinYear, inMaxYear, month, years, thisYear, determineYear, year, endYear,
			changeMonth = this._get( inst, "changeMonth" ),
			changeYear = this._get( inst, "changeYear" ),
			showMonthAfterYear = this._get( inst, "showMonthAfterYear" ),
			selectMonthLabel = this._get( inst, "selectMonthLabel" ),
			selectYearLabel = this._get( inst, "selectYearLabel" ),
			html = "<div class='ui-datepicker-title'>",
			monthHtml = "";

		// Month selection
		if ( secondary || !changeMonth ) {
			monthHtml += "<span class='ui-datepicker-month'>" + monthNames[ drawMonth ] + "</span>";
		} else {
			inMinYear = ( minDate && minDate.getFullYear() === drawYear );
			inMaxYear = ( maxDate && maxDate.getFullYear() === drawYear );
			monthHtml += "<select class='ui-datepicker-month' aria-label='" + selectMonthLabel + "' data-handler='selectMonth' data-event='change'>";
			for ( month = 0; month < 12; month++ ) {
				if ( ( !inMinYear || month >= minDate.getMonth() ) && ( !inMaxYear || month <= maxDate.getMonth() ) ) {
					monthHtml += "<option value='" + month + "'" +
						( month === drawMonth ? " selected='selected'" : "" ) +
						">" + monthNamesShort[ month ] + "</option>";
				}
			}
			monthHtml += "</select>";
		}

		if ( !showMonthAfterYear ) {
			html += monthHtml + ( secondary || !( changeMonth && changeYear ) ? "&#xa0;" : "" );
		}

		// Year selection
		if ( !inst.yearshtml ) {
			inst.yearshtml = "";
			if ( secondary || !changeYear ) {
				html += "<span class='ui-datepicker-year'>" + drawYear + "</span>";
			} else {

				// determine range of years to display
				years = this._get( inst, "yearRange" ).split( ":" );
				thisYear = new Date().getFullYear();
				determineYear = function( value ) {
					var year = ( value.match( /c[+\-].*/ ) ? drawYear + parseInt( value.substring( 1 ), 10 ) :
						( value.match( /[+\-].*/ ) ? thisYear + parseInt( value, 10 ) :
						parseInt( value, 10 ) ) );
					return ( isNaN( year ) ? thisYear : year );
				};
				year = determineYear( years[ 0 ] );
				endYear = Math.max( year, determineYear( years[ 1 ] || "" ) );
				year = ( minDate ? Math.max( year, minDate.getFullYear() ) : year );
				endYear = ( maxDate ? Math.min( endYear, maxDate.getFullYear() ) : endYear );
				inst.yearshtml += "<select class='ui-datepicker-year' aria-label='" + selectYearLabel + "' data-handler='selectYear' data-event='change'>";
				for ( ; year <= endYear; year++ ) {
					inst.yearshtml += "<option value='" + year + "'" +
						( year === drawYear ? " selected='selected'" : "" ) +
						">" + year + "</option>";
				}
				inst.yearshtml += "</select>";

				html += inst.yearshtml;
				inst.yearshtml = null;
			}
		}

		html += this._get( inst, "yearSuffix" );
		if ( showMonthAfterYear ) {
			html += ( secondary || !( changeMonth && changeYear ) ? "&#xa0;" : "" ) + monthHtml;
		}
		html += "</div>"; // Close datepicker_header
		return html;
	},

	/* Adjust one of the date sub-fields. */
	_adjustInstDate: function( inst, offset, period ) {
		var year = inst.selectedYear + ( period === "Y" ? offset : 0 ),
			month = inst.selectedMonth + ( period === "M" ? offset : 0 ),
			day = Math.min( inst.selectedDay, this._getDaysInMonth( year, month ) ) + ( period === "D" ? offset : 0 ),
			date = this._restrictMinMax( inst, this._daylightSavingAdjust( new Date( year, month, day ) ) );

		inst.selectedDay = date.getDate();
		inst.drawMonth = inst.selectedMonth = date.getMonth();
		inst.drawYear = inst.selectedYear = date.getFullYear();
		if ( period === "M" || period === "Y" ) {
			this._notifyChange( inst );
		}
	},

	/* Ensure a date is within any min/max bounds. */
	_restrictMinMax: function( inst, date ) {
		var minDate = this._getMinMaxDate( inst, "min" ),
			maxDate = this._getMinMaxDate( inst, "max" ),
			newDate = ( minDate && date < minDate ? minDate : date );
		return ( maxDate && newDate > maxDate ? maxDate : newDate );
	},

	/* Notify change of month/year. */
	_notifyChange: function( inst ) {
		var onChange = this._get( inst, "onChangeMonthYear" );
		if ( onChange ) {
			onChange.apply( ( inst.input ? inst.input[ 0 ] : null ),
				[ inst.selectedYear, inst.selectedMonth + 1, inst ] );
		}
	},

	/* Determine the number of months to show. */
	_getNumberOfMonths: function( inst ) {
		var numMonths = this._get( inst, "numberOfMonths" );
		return ( numMonths == null ? [ 1, 1 ] : ( typeof numMonths === "number" ? [ 1, numMonths ] : numMonths ) );
	},

	/* Determine the current maximum date - ensure no time components are set. */
	_getMinMaxDate: function( inst, minMax ) {
		return this._determineDate( inst, this._get( inst, minMax + "Date" ), null );
	},

	/* Find the number of days in a given month. */
	_getDaysInMonth: function( year, month ) {
		return 32 - this._daylightSavingAdjust( new Date( year, month, 32 ) ).getDate();
	},

	/* Find the day of the week of the first of a month. */
	_getFirstDayOfMonth: function( year, month ) {
		return new Date( year, month, 1 ).getDay();
	},

	/* Determines if we should allow a "next/prev" month display change. */
	_canAdjustMonth: function( inst, offset, curYear, curMonth ) {
		var numMonths = this._getNumberOfMonths( inst ),
			date = this._daylightSavingAdjust( new Date( curYear,
			curMonth + ( offset < 0 ? offset : numMonths[ 0 ] * numMonths[ 1 ] ), 1 ) );

		if ( offset < 0 ) {
			date.setDate( this._getDaysInMonth( date.getFullYear(), date.getMonth() ) );
		}
		return this._isInRange( inst, date );
	},

	/* Is the given date in the accepted range? */
	_isInRange: function( inst, date ) {
		var yearSplit, currentYear,
			minDate = this._getMinMaxDate( inst, "min" ),
			maxDate = this._getMinMaxDate( inst, "max" ),
			minYear = null,
			maxYear = null,
			years = this._get( inst, "yearRange" );
			if ( years ) {
				yearSplit = years.split( ":" );
				currentYear = new Date().getFullYear();
				minYear = parseInt( yearSplit[ 0 ], 10 );
				maxYear = parseInt( yearSplit[ 1 ], 10 );
				if ( yearSplit[ 0 ].match( /[+\-].*/ ) ) {
					minYear += currentYear;
				}
				if ( yearSplit[ 1 ].match( /[+\-].*/ ) ) {
					maxYear += currentYear;
				}
			}

		return ( ( !minDate || date.getTime() >= minDate.getTime() ) &&
			( !maxDate || date.getTime() <= maxDate.getTime() ) &&
			( !minYear || date.getFullYear() >= minYear ) &&
			( !maxYear || date.getFullYear() <= maxYear ) );
	},

	/* Provide the configuration settings for formatting/parsing. */
	_getFormatConfig: function( inst ) {
		var shortYearCutoff = this._get( inst, "shortYearCutoff" );
		shortYearCutoff = ( typeof shortYearCutoff !== "string" ? shortYearCutoff :
			new Date().getFullYear() % 100 + parseInt( shortYearCutoff, 10 ) );
		return { shortYearCutoff: shortYearCutoff,
			dayNamesShort: this._get( inst, "dayNamesShort" ), dayNames: this._get( inst, "dayNames" ),
			monthNamesShort: this._get( inst, "monthNamesShort" ), monthNames: this._get( inst, "monthNames" ) };
	},

	/* Format the given date for display. */
	_formatDate: function( inst, day, month, year ) {
		if ( !day ) {
			inst.currentDay = inst.selectedDay;
			inst.currentMonth = inst.selectedMonth;
			inst.currentYear = inst.selectedYear;
		}
		var date = ( day ? ( typeof day === "object" ? day :
			this._daylightSavingAdjust( new Date( year, month, day ) ) ) :
			this._daylightSavingAdjust( new Date( inst.currentYear, inst.currentMonth, inst.currentDay ) ) );
		return this.formatDate( this._get( inst, "dateFormat" ), date, this._getFormatConfig( inst ) );
	}
} );

/*
 * Bind hover events for datepicker elements.
 * Done via delegate so the binding only occurs once in the lifetime of the parent div.
 * Global datepicker_instActive, set by _updateDatepicker allows the handlers to find their way back to the active picker.
 */
function datepicker_bindHover( dpDiv ) {
	var selector = "button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";
	return dpDiv.on( "mouseout", selector, function() {
			$( this ).removeClass( "ui-state-hover" );
			if ( this.className.indexOf( "ui-datepicker-prev" ) !== -1 ) {
				$( this ).removeClass( "ui-datepicker-prev-hover" );
			}
			if ( this.className.indexOf( "ui-datepicker-next" ) !== -1 ) {
				$( this ).removeClass( "ui-datepicker-next-hover" );
			}
		} )
		.on( "mouseover", selector, datepicker_handleMouseover );
}

function datepicker_handleMouseover() {
	if ( !$.datepicker._isDisabledDatepicker( datepicker_instActive.inline ? datepicker_instActive.dpDiv.parent()[ 0 ] : datepicker_instActive.input[ 0 ] ) ) {
		$( this ).parents( ".ui-datepicker-calendar" ).find( "a" ).removeClass( "ui-state-hover" );
		$( this ).addClass( "ui-state-hover" );
		if ( this.className.indexOf( "ui-datepicker-prev" ) !== -1 ) {
			$( this ).addClass( "ui-datepicker-prev-hover" );
		}
		if ( this.className.indexOf( "ui-datepicker-next" ) !== -1 ) {
			$( this ).addClass( "ui-datepicker-next-hover" );
		}
	}
}

/* jQuery extend now ignores nulls! */
function datepicker_extendRemove( target, props ) {
	$.extend( target, props );
	for ( var name in props ) {
		if ( props[ name ] == null ) {
			target[ name ] = props[ name ];
		}
	}
	return target;
}

/* Invoke the datepicker functionality.
   @param  options  string - a command, optionally followed by additional parameters or
					Object - settings for attaching new datepicker functionality
   @return  jQuery object */
$.fn.datepicker = function( options ) {

	/* Verify an empty collection wasn't passed - Fixes #6976 */
	if ( !this.length ) {
		return this;
	}

	/* Initialise the date picker. */
	if ( !$.datepicker.initialized ) {
		$( document ).on( "mousedown", $.datepicker._checkExternalClick );
		$.datepicker.initialized = true;
	}

	/* Append datepicker main container to body if not exist. */
	if ( $( "#" + $.datepicker._mainDivId ).length === 0 ) {
		$( "body" ).append( $.datepicker.dpDiv );
	}

	var otherArgs = Array.prototype.slice.call( arguments, 1 );
	if ( typeof options === "string" && ( options === "isDisabled" || options === "getDate" || options === "widget" ) ) {
		return $.datepicker[ "_" + options + "Datepicker" ].
			apply( $.datepicker, [ this[ 0 ] ].concat( otherArgs ) );
	}
	if ( options === "option" && arguments.length === 2 && typeof arguments[ 1 ] === "string" ) {
		return $.datepicker[ "_" + options + "Datepicker" ].
			apply( $.datepicker, [ this[ 0 ] ].concat( otherArgs ) );
	}
	return this.each( function() {
		if ( typeof options === "string" ) {
			$.datepicker[ "_" + options + "Datepicker" ]
				.apply( $.datepicker, [ this ].concat( otherArgs ) );
		} else {
			$.datepicker._attachDatepicker( this, options );
		}
	} );
};

$.datepicker = new Datepicker(); // singleton instance
$.datepicker.initialized = false;
$.datepicker.uuid = new Date().getTime();
$.datepicker.version = "1.14.1";

var widgetsDatepicker = $.datepicker;


/*!
 * jQuery UI Mouse 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Mouse
//>>group: Widgets
//>>description: Abstracts mouse-based interactions to assist in creating certain widgets.
//>>docs: https://api.jqueryui.com/mouse/


var mouseHandled = false;
$( document ).on( "mouseup", function() {
	mouseHandled = false;
} );

var widgetsMouse = $.widget( "ui.mouse", {
	version: "1.14.1",
	options: {
		cancel: "input, textarea, button, select, option",
		distance: 1,
		delay: 0
	},
	_mouseInit: function() {
		var that = this;

		this.element
			.on( "mousedown." + this.widgetName, function( event ) {
				return that._mouseDown( event );
			} )
			.on( "click." + this.widgetName, function( event ) {
				if ( true === $.data( event.target, that.widgetName + ".preventClickEvent" ) ) {
					$.removeData( event.target, that.widgetName + ".preventClickEvent" );
					event.stopImmediatePropagation();
					return false;
				}
			} );

		this.started = false;
	},

	// TODO: make sure destroying one instance of mouse doesn't mess with
	// other instances of mouse
	_mouseDestroy: function() {
		this.element.off( "." + this.widgetName );
		if ( this._mouseMoveDelegate ) {
			this.document
				.off( "mousemove." + this.widgetName, this._mouseMoveDelegate )
				.off( "mouseup." + this.widgetName, this._mouseUpDelegate );
		}
	},

	_mouseDown: function( event ) {

		// don't let more than one widget handle mouseStart
		if ( mouseHandled ) {
			return;
		}

		this._mouseMoved = false;

		// We may have missed mouseup (out of window)
		if ( this._mouseStarted ) {
			this._mouseUp( event );
		}

		this._mouseDownEvent = event;

		var that = this,
			btnIsLeft = event.which === 1,
			elIsCancel = typeof this.options.cancel === "string" ?
				$( event.target ).closest( this.options.cancel ).length :
				false;
		if ( !btnIsLeft || elIsCancel || !this._mouseCapture( event ) ) {
			return true;
		}

		this.mouseDelayMet = !this.options.delay;
		if ( !this.mouseDelayMet ) {
			this._mouseDelayTimer = setTimeout( function() {
				that.mouseDelayMet = true;
			}, this.options.delay );
		}

		if ( this._mouseDistanceMet( event ) && this._mouseDelayMet( event ) ) {
			this._mouseStarted = ( this._mouseStart( event ) !== false );
			if ( !this._mouseStarted ) {
				event.preventDefault();
				return true;
			}
		}

		// Click event may never have fired (Gecko & Opera)
		if ( true === $.data( event.target, this.widgetName + ".preventClickEvent" ) ) {
			$.removeData( event.target, this.widgetName + ".preventClickEvent" );
		}

		// These delegates are required to keep context
		this._mouseMoveDelegate = function( event ) {
			return that._mouseMove( event );
		};
		this._mouseUpDelegate = function( event ) {
			return that._mouseUp( event );
		};

		this.document
			.on( "mousemove." + this.widgetName, this._mouseMoveDelegate )
			.on( "mouseup." + this.widgetName, this._mouseUpDelegate );

		event.preventDefault();

		mouseHandled = true;
		return true;
	},

	_mouseMove: function( event ) {

		// Only check for mouseups outside the document if you've moved inside the document
		// at least once.
		if ( this._mouseMoved && !event.which ) {

			// Support: Safari <=8 - 9
			// Safari sets which to 0 if you press any of the following keys
			// during a drag (#14461)
			if ( event.originalEvent.altKey || event.originalEvent.ctrlKey ||
					event.originalEvent.metaKey || event.originalEvent.shiftKey ) {
				this.ignoreMissingWhich = true;
			} else if ( !this.ignoreMissingWhich ) {
				return this._mouseUp( event );
			}
		}

		if ( event.which || event.button ) {
			this._mouseMoved = true;
		}

		if ( this._mouseStarted ) {
			this._mouseDrag( event );
			return event.preventDefault();
		}

		if ( this._mouseDistanceMet( event ) && this._mouseDelayMet( event ) ) {
			this._mouseStarted =
				( this._mouseStart( this._mouseDownEvent, event ) !== false );
			if ( this._mouseStarted ) {
				this._mouseDrag( event );
			} else {
				this._mouseUp( event );
			}
		}

		return !this._mouseStarted;
	},

	_mouseUp: function( event ) {
		this.document
			.off( "mousemove." + this.widgetName, this._mouseMoveDelegate )
			.off( "mouseup." + this.widgetName, this._mouseUpDelegate );

		if ( this._mouseStarted ) {
			this._mouseStarted = false;

			if ( event.target === this._mouseDownEvent.target ) {
				$.data( event.target, this.widgetName + ".preventClickEvent", true );
			}

			this._mouseStop( event );
		}

		if ( this._mouseDelayTimer ) {
			clearTimeout( this._mouseDelayTimer );
			delete this._mouseDelayTimer;
		}

		this.ignoreMissingWhich = false;
		mouseHandled = false;
		event.preventDefault();
	},

	_mouseDistanceMet: function( event ) {
		return ( Math.max(
				Math.abs( this._mouseDownEvent.pageX - event.pageX ),
				Math.abs( this._mouseDownEvent.pageY - event.pageY )
			) >= this.options.distance
		);
	},

	_mouseDelayMet: function( /* event */ ) {
		return this.mouseDelayMet;
	},

	// These are placeholder methods, to be overriden by extending plugin
	_mouseStart: function( /* event */ ) {},
	_mouseDrag: function( /* event */ ) {},
	_mouseStop: function( /* event */ ) {},
	_mouseCapture: function( /* event */ ) {
		return true;
	}
} );



// $.ui.plugin is deprecated. Use $.widget() extensions instead.
var plugin = $.ui.plugin = {
	add: function( module, option, set ) {
		var i,
			proto = $.ui[ module ].prototype;
		for ( i in set ) {
			proto.plugins[ i ] = proto.plugins[ i ] || [];
			proto.plugins[ i ].push( [ option, set[ i ] ] );
		}
	},
	call: function( instance, name, args, allowDisconnected ) {
		var i,
			set = instance.plugins[ name ];

		if ( !set ) {
			return;
		}

		if ( !allowDisconnected && ( !instance.element[ 0 ].parentNode ||
				instance.element[ 0 ].parentNode.nodeType === 11 ) ) {
			return;
		}

		for ( i = 0; i < set.length; i++ ) {
			if ( instance.options[ set[ i ][ 0 ] ] ) {
				set[ i ][ 1 ].apply( instance.element, args );
			}
		}
	}
};


/*!
 * jQuery UI Draggable 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Draggable
//>>group: Interactions
//>>description: Enables dragging functionality for any element.
//>>docs: https://api.jqueryui.com/draggable/
//>>demos: https://jqueryui.com/draggable/
//>>css.structure: ../../themes/base/draggable.css


$.widget( "ui.draggable", $.ui.mouse, {
	version: "1.14.1",
	widgetEventPrefix: "drag",
	options: {
		addClasses: true,
		appendTo: "parent",
		axis: false,
		connectToSortable: false,
		containment: false,
		cursor: "auto",
		cursorAt: false,
		grid: false,
		handle: false,
		helper: "original",
		iframeFix: false,
		opacity: false,
		refreshPositions: false,
		revert: false,
		revertDuration: 500,
		scope: "default",
		scroll: true,
		scrollSensitivity: 20,
		scrollSpeed: 20,
		snap: false,
		snapMode: "both",
		snapTolerance: 20,
		stack: false,
		zIndex: false,

		// Callbacks
		drag: null,
		start: null,
		stop: null
	},
	_create: function() {

		if ( this.options.helper === "original" ) {
			this._setPositionRelative();
		}
		if ( this.options.addClasses ) {
			this._addClass( "ui-draggable" );
		}
		this._setHandleClassName();

		this._mouseInit();
	},

	_setOption: function( key, value ) {
		this._super( key, value );
		if ( key === "handle" ) {
			this._removeHandleClassName();
			this._setHandleClassName();
		}
	},

	_destroy: function() {
		if ( ( this.helper || this.element ).is( ".ui-draggable-dragging" ) ) {
			this.destroyOnClear = true;
			return;
		}
		this._removeHandleClassName();
		this._mouseDestroy();
	},

	_mouseCapture: function( event ) {
		var o = this.options;

		// Among others, prevent a drag on a resizable-handle
		if ( this.helper || o.disabled ||
				$( event.target ).closest( ".ui-resizable-handle" ).length > 0 ) {
			return false;
		}

		//Quit if we're not on a valid handle
		this.handle = this._getHandle( event );
		if ( !this.handle ) {
			return false;
		}

		this._blurActiveElement( event );

		this._blockFrames( o.iframeFix === true ? "iframe" : o.iframeFix );

		return true;

	},

	_blockFrames: function( selector ) {
		this.iframeBlocks = this.document.find( selector ).map( function() {
			var iframe = $( this );

			return $( "<div>" )
				.css( "position", "absolute" )
				.appendTo( iframe.parent() )
				.outerWidth( iframe.outerWidth() )
				.outerHeight( iframe.outerHeight() )
				.offset( iframe.offset() )[ 0 ];
		} );
	},

	_unblockFrames: function() {
		if ( this.iframeBlocks ) {
			this.iframeBlocks.remove();
			delete this.iframeBlocks;
		}
	},

	_blurActiveElement: function( event ) {
		var activeElement = this.document[ 0 ].activeElement,
			target = $( event.target );

		// Don't blur if the event occurred on an element that is within
		// the currently focused element
		// See #10527, #12472
		if ( target.closest( activeElement ).length ) {
			return;
		}

		// Blur any element that currently has focus, see #4261
		$( activeElement ).trigger( "blur" );
	},

	_mouseStart: function( event ) {

		var o = this.options;

		//Create and append the visible helper
		this.helper = this._createHelper( event );

		this._addClass( this.helper, "ui-draggable-dragging" );

		//Cache the helper size
		this._cacheHelperProportions();

		//If ddmanager is used for droppables, set the global draggable
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.current = this;
		}

		/*
		 * - Position generation -
		 * This block generates everything position related - it's the core of draggables.
		 */

		//Cache the margins of the original element
		this._cacheMargins();

		//Store the helper's css position
		this.cssPosition = this.helper.css( "position" );
		this.scrollParent = this.helper.scrollParent( true );
		this.offsetParent = this.helper.offsetParent();
		this.hasFixedAncestor = this.helper.parents().filter( function() {
				return $( this ).css( "position" ) === "fixed";
			} ).length > 0;

		//The element's absolute position on the page minus margins
		this.positionAbs = this.element.offset();
		this._refreshOffsets( event );

		//Generate the original position
		this.originalPosition = this.position = this._generatePosition( event, false );
		this.originalPageX = event.pageX;
		this.originalPageY = event.pageY;

		//Adjust the mouse offset relative to the helper if "cursorAt" is supplied
		if ( o.cursorAt ) {
			this._adjustOffsetFromHelper( o.cursorAt );
		}

		//Set a containment if given in the options
		this._setContainment();

		//Trigger event + callbacks
		if ( this._trigger( "start", event ) === false ) {
			this._clear();
			return false;
		}

		//Recache the helper size
		this._cacheHelperProportions();

		//Prepare the droppable offsets
		if ( $.ui.ddmanager && !o.dropBehaviour ) {
			$.ui.ddmanager.prepareOffsets( this, event );
		}

		// Execute the drag once - this causes the helper not to be visible before getting its
		// correct position
		this._mouseDrag( event, true );

		// If the ddmanager is used for droppables, inform the manager that dragging has started
		// (see #5003)
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.dragStart( this, event );
		}

		return true;
	},

	_refreshOffsets: function( event ) {
		this.offset = {
			top: this.positionAbs.top - this.margins.top,
			left: this.positionAbs.left - this.margins.left,
			scroll: false,
			parent: this._getParentOffset(),
			relative: this._getRelativeOffset()
		};

		this.offset.click = {
			left: event.pageX - this.offset.left,
			top: event.pageY - this.offset.top
		};
	},

	_mouseDrag: function( event, noPropagation ) {

		// reset any necessary cached properties (see #5009)
		if ( this.hasFixedAncestor ) {
			this.offset.parent = this._getParentOffset();
		}

		//Compute the helpers position
		this.position = this._generatePosition( event, true );
		this.positionAbs = this._convertPositionTo( "absolute" );

		//Call plugins and callbacks and use the resulting position if something is returned
		if ( !noPropagation ) {
			var ui = this._uiHash();
			if ( this._trigger( "drag", event, ui ) === false ) {
				this._mouseUp( new $.Event( "mouseup", event ) );
				return false;
			}
			this.position = ui.position;
		}

		this.helper[ 0 ].style.left = this.position.left + "px";
		this.helper[ 0 ].style.top = this.position.top + "px";

		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.drag( this, event );
		}

		return false;
	},

	_mouseStop: function( event ) {

		//If we are using droppables, inform the manager about the drop
		var that = this,
			dropped = false;
		if ( $.ui.ddmanager && !this.options.dropBehaviour ) {
			dropped = $.ui.ddmanager.drop( this, event );
		}

		//if a drop comes from outside (a sortable)
		if ( this.dropped ) {
			dropped = this.dropped;
			this.dropped = false;
		}

		if ( ( this.options.revert === "invalid" && !dropped ) ||
				( this.options.revert === "valid" && dropped ) ||
				this.options.revert === true || ( typeof this.options.revert === "function" &&
				this.options.revert.call( this.element, dropped ) )
		) {
			$( this.helper ).animate(
				this.originalPosition,
				parseInt( this.options.revertDuration, 10 ),
				function() {
					if ( that._trigger( "stop", event ) !== false ) {
						that._clear();
					}
				}
			);
		} else {
			if ( this._trigger( "stop", event ) !== false ) {
				this._clear();
			}
		}

		return false;
	},

	_mouseUp: function( event ) {
		this._unblockFrames();

		// If the ddmanager is used for droppables, inform the manager that dragging has stopped
		// (see #5003)
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.dragStop( this, event );
		}

		// Only need to focus if the event occurred on the draggable itself, see #10527
		if ( this.handleElement.is( event.target ) ) {

			// The interaction is over; whether or not the click resulted in a drag,
			// focus the element
			this.element.trigger( "focus" );
		}

		return $.ui.mouse.prototype._mouseUp.call( this, event );
	},

	cancel: function() {

		if ( this.helper.is( ".ui-draggable-dragging" ) ) {
			this._mouseUp( new $.Event( "mouseup", { target: this.element[ 0 ] } ) );
		} else {
			this._clear();
		}

		return this;

	},

	_getHandle: function( event ) {
		return this.options.handle ?
			!!$( event.target ).closest( this.element.find( this.options.handle ) ).length :
			true;
	},

	_setHandleClassName: function() {
		this.handleElement = this.options.handle ?
			this.element.find( this.options.handle ) : this.element;
		this._addClass( this.handleElement, "ui-draggable-handle" );
	},

	_removeHandleClassName: function() {
		this._removeClass( this.handleElement, "ui-draggable-handle" );
	},

	_createHelper: function( event ) {

		var o = this.options,
			helperIsFunction = typeof o.helper === "function",
			helper = helperIsFunction ?
				$( o.helper.apply( this.element[ 0 ], [ event ] ) ) :
				( o.helper === "clone" ?
					this.element.clone().removeAttr( "id" ) :
					this.element );

		if ( !helper.parents( "body" ).length ) {
			helper.appendTo( ( o.appendTo === "parent" ?
				this.element[ 0 ].parentNode :
				o.appendTo ) );
		}

		// https://bugs.jqueryui.com/ticket/9446
		// a helper function can return the original element
		// which wouldn't have been set to relative in _create
		if ( helperIsFunction && helper[ 0 ] === this.element[ 0 ] ) {
			this._setPositionRelative();
		}

		if ( helper[ 0 ] !== this.element[ 0 ] &&
				!( /(fixed|absolute)/ ).test( helper.css( "position" ) ) ) {
			helper.css( "position", "absolute" );
		}

		return helper;

	},

	_setPositionRelative: function() {
		if ( !( /^(?:r|a|f)/ ).test( this.element.css( "position" ) ) ) {
			this.element[ 0 ].style.position = "relative";
		}
	},

	_adjustOffsetFromHelper: function( obj ) {
		if ( typeof obj === "string" ) {
			obj = obj.split( " " );
		}
		if ( Array.isArray( obj ) ) {
			obj = { left: +obj[ 0 ], top: +obj[ 1 ] || 0 };
		}
		if ( "left" in obj ) {
			this.offset.click.left = obj.left + this.margins.left;
		}
		if ( "right" in obj ) {
			this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
		}
		if ( "top" in obj ) {
			this.offset.click.top = obj.top + this.margins.top;
		}
		if ( "bottom" in obj ) {
			this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
		}
	},

	_isRootNode: function( element ) {
		return ( /(html|body)/i ).test( element.tagName ) || element === this.document[ 0 ];
	},

	_getParentOffset: function() {

		//Get the offsetParent and cache its position
		var po = this.offsetParent.offset(),
			document = this.document[ 0 ];

		// This is a special case where we need to modify a offset calculated on start, since the
		// following happened:
		// 1. The position of the helper is absolute, so it's position is calculated based on the
		// next positioned parent
		// 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't
		// the document, which means that the scroll is included in the initial calculation of the
		// offset of the parent, and never recalculated upon drag
		if ( this.cssPosition === "absolute" && this.scrollParent[ 0 ] !== document &&
				$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) {
			po.left += this.scrollParent.scrollLeft();
			po.top += this.scrollParent.scrollTop();
		}

		if ( this._isRootNode( this.offsetParent[ 0 ] ) ) {
			po = { top: 0, left: 0 };
		}

		return {
			top: po.top + ( parseInt( this.offsetParent.css( "borderTopWidth" ), 10 ) || 0 ),
			left: po.left + ( parseInt( this.offsetParent.css( "borderLeftWidth" ), 10 ) || 0 )
		};

	},

	_getRelativeOffset: function() {
		if ( this.cssPosition !== "relative" ) {
			return { top: 0, left: 0 };
		}

		var p = this.element.position(),
			scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] );

		return {
			top: p.top - ( parseInt( this.helper.css( "top" ), 10 ) || 0 ) +
				( !scrollIsRootNode ? this.scrollParent.scrollTop() : 0 ),
			left: p.left - ( parseInt( this.helper.css( "left" ), 10 ) || 0 ) +
				( !scrollIsRootNode ? this.scrollParent.scrollLeft() : 0 )
		};

	},

	_cacheMargins: function() {
		this.margins = {
			left: ( parseInt( this.element.css( "marginLeft" ), 10 ) || 0 ),
			top: ( parseInt( this.element.css( "marginTop" ), 10 ) || 0 ),
			right: ( parseInt( this.element.css( "marginRight" ), 10 ) || 0 ),
			bottom: ( parseInt( this.element.css( "marginBottom" ), 10 ) || 0 )
		};
	},

	_cacheHelperProportions: function() {
		this.helperProportions = {
			width: this.helper.outerWidth(),
			height: this.helper.outerHeight()
		};
	},

	_setContainment: function() {

		var isUserScrollable, c, ce,
			o = this.options,
			document = this.document[ 0 ];

		this.relativeContainer = null;

		if ( !o.containment ) {
			this.containment = null;
			return;
		}

		if ( o.containment === "window" ) {
			this.containment = [
				$( window ).scrollLeft() - this.offset.relative.left - this.offset.parent.left,
				$( window ).scrollTop() - this.offset.relative.top - this.offset.parent.top,
				$( window ).scrollLeft() + $( window ).width() -
					this.helperProportions.width - this.margins.left,
				$( window ).scrollTop() +
					( $( window ).height() || document.body.parentNode.scrollHeight ) -
					this.helperProportions.height - this.margins.top
			];
			return;
		}

		if ( o.containment === "document" ) {
			this.containment = [
				0,
				0,
				$( document ).width() - this.helperProportions.width - this.margins.left,
				( $( document ).height() || document.body.parentNode.scrollHeight ) -
					this.helperProportions.height - this.margins.top
			];
			return;
		}

		if ( o.containment.constructor === Array ) {
			this.containment = o.containment;
			return;
		}

		if ( o.containment === "parent" ) {
			o.containment = this.helper[ 0 ].parentNode;
		}

		c = $( o.containment );
		ce = c[ 0 ];

		if ( !ce ) {
			return;
		}

		isUserScrollable = /(scroll|auto)/.test( c.css( "overflow" ) );

		this.containment = [
			( parseInt( c.css( "borderLeftWidth" ), 10 ) || 0 ) +
				( parseInt( c.css( "paddingLeft" ), 10 ) || 0 ),
			( parseInt( c.css( "borderTopWidth" ), 10 ) || 0 ) +
				( parseInt( c.css( "paddingTop" ), 10 ) || 0 ),
			( isUserScrollable ? Math.max( ce.scrollWidth, ce.offsetWidth ) : ce.offsetWidth ) -
				( parseInt( c.css( "borderRightWidth" ), 10 ) || 0 ) -
				( parseInt( c.css( "paddingRight" ), 10 ) || 0 ) -
				this.helperProportions.width -
				this.margins.left -
				this.margins.right,
			( isUserScrollable ? Math.max( ce.scrollHeight, ce.offsetHeight ) : ce.offsetHeight ) -
				( parseInt( c.css( "borderBottomWidth" ), 10 ) || 0 ) -
				( parseInt( c.css( "paddingBottom" ), 10 ) || 0 ) -
				this.helperProportions.height -
				this.margins.top -
				this.margins.bottom
		];
		this.relativeContainer = c;
	},

	_convertPositionTo: function( d, pos ) {

		if ( !pos ) {
			pos = this.position;
		}

		var mod = d === "absolute" ? 1 : -1,
			scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] );

		return {
			top: (

				// The absolute mouse position
				pos.top	+

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.top * mod +

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.top * mod -
				( ( this.cssPosition === "fixed" ?
					-this.offset.scroll.top :
					( scrollIsRootNode ? 0 : this.offset.scroll.top ) ) * mod )
			),
			left: (

				// The absolute mouse position
				pos.left +

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.left * mod +

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.left * mod	-
				( ( this.cssPosition === "fixed" ?
					-this.offset.scroll.left :
					( scrollIsRootNode ? 0 : this.offset.scroll.left ) ) * mod )
			)
		};

	},

	_generatePosition: function( event, constrainPosition ) {

		var containment, co, top, left,
			o = this.options,
			scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] ),
			pageX = event.pageX,
			pageY = event.pageY;

		// Cache the scroll
		if ( !scrollIsRootNode || !this.offset.scroll ) {
			this.offset.scroll = {
				top: this.scrollParent.scrollTop(),
				left: this.scrollParent.scrollLeft()
			};
		}

		/*
		 * - Position constraining -
		 * Constrain the position to a mix of grid, containment.
		 */

		// If we are not dragging yet, we won't check for options
		if ( constrainPosition ) {
			if ( this.containment ) {
				if ( this.relativeContainer ) {
					co = this.relativeContainer.offset();
					containment = [
						this.containment[ 0 ] + co.left,
						this.containment[ 1 ] + co.top,
						this.containment[ 2 ] + co.left,
						this.containment[ 3 ] + co.top
					];
				} else {
					containment = this.containment;
				}

				if ( event.pageX - this.offset.click.left < containment[ 0 ] ) {
					pageX = containment[ 0 ] + this.offset.click.left;
				}
				if ( event.pageY - this.offset.click.top < containment[ 1 ] ) {
					pageY = containment[ 1 ] + this.offset.click.top;
				}
				if ( event.pageX - this.offset.click.left > containment[ 2 ] ) {
					pageX = containment[ 2 ] + this.offset.click.left;
				}
				if ( event.pageY - this.offset.click.top > containment[ 3 ] ) {
					pageY = containment[ 3 ] + this.offset.click.top;
				}
			}

			if ( o.grid ) {

				//Check for grid elements set to 0 to prevent divide by 0 error causing invalid
				// argument errors in IE (see ticket #6950)
				top = o.grid[ 1 ] ? this.originalPageY + Math.round( ( pageY -
					this.originalPageY ) / o.grid[ 1 ] ) * o.grid[ 1 ] : this.originalPageY;
				pageY = containment ? ( ( top - this.offset.click.top >= containment[ 1 ] ||
					top - this.offset.click.top > containment[ 3 ] ) ?
						top :
						( ( top - this.offset.click.top >= containment[ 1 ] ) ?
							top - o.grid[ 1 ] : top + o.grid[ 1 ] ) ) : top;

				left = o.grid[ 0 ] ? this.originalPageX +
					Math.round( ( pageX - this.originalPageX ) / o.grid[ 0 ] ) * o.grid[ 0 ] :
					this.originalPageX;
				pageX = containment ? ( ( left - this.offset.click.left >= containment[ 0 ] ||
					left - this.offset.click.left > containment[ 2 ] ) ?
						left :
						( ( left - this.offset.click.left >= containment[ 0 ] ) ?
							left - o.grid[ 0 ] : left + o.grid[ 0 ] ) ) : left;
			}

			if ( o.axis === "y" ) {
				pageX = this.originalPageX;
			}

			if ( o.axis === "x" ) {
				pageY = this.originalPageY;
			}
		}

		return {
			top: (

				// The absolute mouse position
				pageY -

				// Click offset (relative to the element)
				this.offset.click.top -

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.top -

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.top +
				( this.cssPosition === "fixed" ?
					-this.offset.scroll.top :
					( scrollIsRootNode ? 0 : this.offset.scroll.top ) )
			),
			left: (

				// The absolute mouse position
				pageX -

				// Click offset (relative to the element)
				this.offset.click.left -

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.left -

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.left +
				( this.cssPosition === "fixed" ?
					-this.offset.scroll.left :
					( scrollIsRootNode ? 0 : this.offset.scroll.left ) )
			)
		};

	},

	_clear: function() {
		this._removeClass( this.helper, "ui-draggable-dragging" );
		if ( this.helper[ 0 ] !== this.element[ 0 ] && !this.cancelHelperRemoval ) {
			this.helper.remove();
		}
		this.helper = null;
		this.cancelHelperRemoval = false;
		if ( this.destroyOnClear ) {
			this.destroy();
		}
	},

	// From now on bulk stuff - mainly helpers

	_trigger: function( type, event, ui ) {
		ui = ui || this._uiHash();
		$.ui.plugin.call( this, type, [ event, ui, this ], true );

		// Absolute position and offset (see #6884 ) have to be recalculated after plugins
		if ( /^(drag|start|stop)/.test( type ) ) {
			this.positionAbs = this._convertPositionTo( "absolute" );
			ui.offset = this.positionAbs;
		}
		return $.Widget.prototype._trigger.call( this, type, event, ui );
	},

	plugins: {},

	_uiHash: function() {
		return {
			helper: this.helper,
			position: this.position,
			originalPosition: this.originalPosition,
			offset: this.positionAbs
		};
	}

} );

$.ui.plugin.add( "draggable", "connectToSortable", {
	start: function( event, ui, draggable ) {
		var uiSortable = $.extend( {}, ui, {
			item: draggable.element
		} );

		draggable.sortables = [];
		$( draggable.options.connectToSortable ).each( function() {
			var sortable = $( this ).sortable( "instance" );

			if ( sortable && !sortable.options.disabled ) {
				draggable.sortables.push( sortable );

				// RefreshPositions is called at drag start to refresh the containerCache
				// which is used in drag. This ensures it's initialized and synchronized
				// with any changes that might have happened on the page since initialization.
				sortable.refreshPositions();
				sortable._trigger( "activate", event, uiSortable );
			}
		} );
	},
	stop: function( event, ui, draggable ) {
		var uiSortable = $.extend( {}, ui, {
			item: draggable.element
		} );

		draggable.cancelHelperRemoval = false;

		$.each( draggable.sortables, function() {
			var sortable = this;

			if ( sortable.isOver ) {
				sortable.isOver = 0;

				// Allow this sortable to handle removing the helper
				draggable.cancelHelperRemoval = true;
				sortable.cancelHelperRemoval = false;

				// Use _storedCSS To restore properties in the sortable,
				// as this also handles revert (#9675) since the draggable
				// may have modified them in unexpected ways (#8809)
				sortable._storedCSS = {
					position: sortable.placeholder.css( "position" ),
					top: sortable.placeholder.css( "top" ),
					left: sortable.placeholder.css( "left" )
				};

				sortable._mouseStop( event );

				// Once drag has ended, the sortable should return to using
				// its original helper, not the shared helper from draggable
				sortable.options.helper = sortable.options._helper;
			} else {

				// Prevent this Sortable from removing the helper.
				// However, don't set the draggable to remove the helper
				// either as another connected Sortable may yet handle the removal.
				sortable.cancelHelperRemoval = true;

				sortable._trigger( "deactivate", event, uiSortable );
			}
		} );
	},
	drag: function( event, ui, draggable ) {
		$.each( draggable.sortables, function() {
			var innermostIntersecting = false,
				sortable = this;

			// Copy over variables that sortable's _intersectsWith uses
			sortable.positionAbs = draggable.positionAbs;
			sortable.helperProportions = draggable.helperProportions;
			sortable.offset.click = draggable.offset.click;

			if ( sortable._intersectsWith( sortable.containerCache ) ) {
				innermostIntersecting = true;

				$.each( draggable.sortables, function() {

					// Copy over variables that sortable's _intersectsWith uses
					this.positionAbs = draggable.positionAbs;
					this.helperProportions = draggable.helperProportions;
					this.offset.click = draggable.offset.click;

					if ( this !== sortable &&
							this._intersectsWith( this.containerCache ) &&
							$.contains( sortable.element[ 0 ], this.element[ 0 ] ) ) {
						innermostIntersecting = false;
					}

					return innermostIntersecting;
				} );
			}

			if ( innermostIntersecting ) {

				// If it intersects, we use a little isOver variable and set it once,
				// so that the move-in stuff gets fired only once.
				if ( !sortable.isOver ) {
					sortable.isOver = 1;

					// Store draggable's parent in case we need to reappend to it later.
					draggable._parent = ui.helper.parent();

					sortable.currentItem = ui.helper
						.appendTo( sortable.element )
						.data( "ui-sortable-item", true );

					// Store helper option to later restore it
					sortable.options._helper = sortable.options.helper;

					sortable.options.helper = function() {
						return ui.helper[ 0 ];
					};

					// Fire the start events of the sortable with our passed browser event,
					// and our own helper (so it doesn't create a new one)
					event.target = sortable.currentItem[ 0 ];
					sortable._mouseCapture( event, true );
					sortable._mouseStart( event, true, true );

					// Because the browser event is way off the new appended portlet,
					// modify necessary variables to reflect the changes
					sortable.offset.click.top = draggable.offset.click.top;
					sortable.offset.click.left = draggable.offset.click.left;
					sortable.offset.parent.left -= draggable.offset.parent.left -
						sortable.offset.parent.left;
					sortable.offset.parent.top -= draggable.offset.parent.top -
						sortable.offset.parent.top;

					draggable._trigger( "toSortable", event );

					// Inform draggable that the helper is in a valid drop zone,
					// used solely in the revert option to handle "valid/invalid".
					draggable.dropped = sortable.element;

					// Need to refreshPositions of all sortables in the case that
					// adding to one sortable changes the location of the other sortables (#9675)
					$.each( draggable.sortables, function() {
						this.refreshPositions();
					} );

					// Hack so receive/update callbacks work (mostly)
					draggable.currentItem = draggable.element;
					sortable.fromOutside = draggable;
				}

				if ( sortable.currentItem ) {
					sortable._mouseDrag( event );

					// Copy the sortable's position because the draggable's can potentially reflect
					// a relative position, while sortable is always absolute, which the dragged
					// element has now become. (#8809)
					ui.position = sortable.position;
				}
			} else {

				// If it doesn't intersect with the sortable, and it intersected before,
				// we fake the drag stop of the sortable, but make sure it doesn't remove
				// the helper by using cancelHelperRemoval.
				if ( sortable.isOver ) {

					sortable.isOver = 0;
					sortable.cancelHelperRemoval = true;

					// Calling sortable's mouseStop would trigger a revert,
					// so revert must be temporarily false until after mouseStop is called.
					sortable.options._revert = sortable.options.revert;
					sortable.options.revert = false;

					sortable._trigger( "out", event, sortable._uiHash( sortable ) );
					sortable._mouseStop( event, true );

					// Restore sortable behaviors that were modfied
					// when the draggable entered the sortable area (#9481)
					sortable.options.revert = sortable.options._revert;
					sortable.options.helper = sortable.options._helper;

					if ( sortable.placeholder ) {
						sortable.placeholder.remove();
					}

					// Restore and recalculate the draggable's offset considering the sortable
					// may have modified them in unexpected ways. (#8809, #10669)
					ui.helper.appendTo( draggable._parent );
					draggable._refreshOffsets( event );
					ui.position = draggable._generatePosition( event, true );

					draggable._trigger( "fromSortable", event );

					// Inform draggable that the helper is no longer in a valid drop zone
					draggable.dropped = false;

					// Need to refreshPositions of all sortables just in case removing
					// from one sortable changes the location of other sortables (#9675)
					$.each( draggable.sortables, function() {
						this.refreshPositions();
					} );
				}
			}
		} );
	}
} );

$.ui.plugin.add( "draggable", "cursor", {
	start: function( event, ui, instance ) {
		var t = $( "body" ),
			o = instance.options;

		if ( t.css( "cursor" ) ) {
			o._cursor = t.css( "cursor" );
		}
		t.css( "cursor", o.cursor );
	},
	stop: function( event, ui, instance ) {
		var o = instance.options;
		if ( o._cursor ) {
			$( "body" ).css( "cursor", o._cursor );
		}
	}
} );

$.ui.plugin.add( "draggable", "opacity", {
	start: function( event, ui, instance ) {
		var t = $( ui.helper ),
			o = instance.options;
		if ( t.css( "opacity" ) ) {
			o._opacity = t.css( "opacity" );
		}
		t.css( "opacity", o.opacity );
	},
	stop: function( event, ui, instance ) {
		var o = instance.options;
		if ( o._opacity ) {
			$( ui.helper ).css( "opacity", o._opacity );
		}
	}
} );

$.ui.plugin.add( "draggable", "scroll", {
	start: function( event, ui, i ) {
		if ( !i.scrollParentNotHidden ) {
			i.scrollParentNotHidden = i.helper.scrollParent( false );
		}

		if ( i.scrollParentNotHidden[ 0 ] !== i.document[ 0 ] &&
				i.scrollParentNotHidden[ 0 ].tagName !== "HTML" ) {
			i.overflowOffset = i.scrollParentNotHidden.offset();
		}
	},
	drag: function( event, ui, i  ) {

		var o = i.options,
			scrolled = false,
			scrollParent = i.scrollParentNotHidden[ 0 ],
			document = i.document[ 0 ];

		if ( scrollParent !== document && scrollParent.tagName !== "HTML" ) {
			if ( !o.axis || o.axis !== "x" ) {
				if ( ( i.overflowOffset.top + scrollParent.offsetHeight ) - event.pageY <
						o.scrollSensitivity ) {
					scrollParent.scrollTop = scrolled = scrollParent.scrollTop + o.scrollSpeed;
				} else if ( event.pageY - i.overflowOffset.top < o.scrollSensitivity ) {
					scrollParent.scrollTop = scrolled = scrollParent.scrollTop - o.scrollSpeed;
				}
			}

			if ( !o.axis || o.axis !== "y" ) {
				if ( ( i.overflowOffset.left + scrollParent.offsetWidth ) - event.pageX <
						o.scrollSensitivity ) {
					scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft + o.scrollSpeed;
				} else if ( event.pageX - i.overflowOffset.left < o.scrollSensitivity ) {
					scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft - o.scrollSpeed;
				}
			}

		} else {

			if ( !o.axis || o.axis !== "x" ) {
				if ( event.pageY - $( document ).scrollTop() < o.scrollSensitivity ) {
					scrolled = $( document ).scrollTop( $( document ).scrollTop() - o.scrollSpeed );
				} else if ( $( window ).height() - ( event.pageY - $( document ).scrollTop() ) <
						o.scrollSensitivity ) {
					scrolled = $( document ).scrollTop( $( document ).scrollTop() + o.scrollSpeed );
				}
			}

			if ( !o.axis || o.axis !== "y" ) {
				if ( event.pageX - $( document ).scrollLeft() < o.scrollSensitivity ) {
					scrolled = $( document ).scrollLeft(
						$( document ).scrollLeft() - o.scrollSpeed
					);
				} else if ( $( window ).width() - ( event.pageX - $( document ).scrollLeft() ) <
						o.scrollSensitivity ) {
					scrolled = $( document ).scrollLeft(
						$( document ).scrollLeft() + o.scrollSpeed
					);
				}
			}

		}

		if ( scrolled !== false && $.ui.ddmanager && !o.dropBehaviour ) {
			$.ui.ddmanager.prepareOffsets( i, event );
		}

	}
} );

$.ui.plugin.add( "draggable", "snap", {
	start: function( event, ui, i ) {

		var o = i.options;

		i.snapElements = [];

		$( o.snap.constructor !== String ? ( o.snap.items || ":data(ui-draggable)" ) : o.snap )
			.each( function() {
				var $t = $( this ),
					$o = $t.offset();
				if ( this !== i.element[ 0 ] ) {
					i.snapElements.push( {
						item: this,
						width: $t.outerWidth(), height: $t.outerHeight(),
						top: $o.top, left: $o.left
					} );
				}
			} );

	},
	drag: function( event, ui, inst ) {

		var ts, bs, ls, rs, l, r, t, b, i, first,
			o = inst.options,
			d = o.snapTolerance,
			x1 = ui.offset.left, x2 = x1 + inst.helperProportions.width,
			y1 = ui.offset.top, y2 = y1 + inst.helperProportions.height;

		for ( i = inst.snapElements.length - 1; i >= 0; i-- ) {

			l = inst.snapElements[ i ].left - inst.margins.left;
			r = l + inst.snapElements[ i ].width;
			t = inst.snapElements[ i ].top - inst.margins.top;
			b = t + inst.snapElements[ i ].height;

			if ( x2 < l - d || x1 > r + d || y2 < t - d || y1 > b + d ||
					!$.contains( inst.snapElements[ i ].item.ownerDocument,
					inst.snapElements[ i ].item ) ) {
				if ( inst.snapElements[ i ].snapping ) {
					if ( inst.options.snap.release ) {
						inst.options.snap.release.call(
							inst.element,
							event,
							$.extend( inst._uiHash(), { snapItem: inst.snapElements[ i ].item } )
						);
					}
				}
				inst.snapElements[ i ].snapping = false;
				continue;
			}

			if ( o.snapMode !== "inner" ) {
				ts = Math.abs( t - y2 ) <= d;
				bs = Math.abs( b - y1 ) <= d;
				ls = Math.abs( l - x2 ) <= d;
				rs = Math.abs( r - x1 ) <= d;
				if ( ts ) {
					ui.position.top = inst._convertPositionTo( "relative", {
						top: t - inst.helperProportions.height,
						left: 0
					} ).top;
				}
				if ( bs ) {
					ui.position.top = inst._convertPositionTo( "relative", {
						top: b,
						left: 0
					} ).top;
				}
				if ( ls ) {
					ui.position.left = inst._convertPositionTo( "relative", {
						top: 0,
						left: l - inst.helperProportions.width
					} ).left;
				}
				if ( rs ) {
					ui.position.left = inst._convertPositionTo( "relative", {
						top: 0,
						left: r
					} ).left;
				}
			}

			first = ( ts || bs || ls || rs );

			if ( o.snapMode !== "outer" ) {
				ts = Math.abs( t - y1 ) <= d;
				bs = Math.abs( b - y2 ) <= d;
				ls = Math.abs( l - x1 ) <= d;
				rs = Math.abs( r - x2 ) <= d;
				if ( ts ) {
					ui.position.top = inst._convertPositionTo( "relative", {
						top: t,
						left: 0
					} ).top;
				}
				if ( bs ) {
					ui.position.top = inst._convertPositionTo( "relative", {
						top: b - inst.helperProportions.height,
						left: 0
					} ).top;
				}
				if ( ls ) {
					ui.position.left = inst._convertPositionTo( "relative", {
						top: 0,
						left: l
					} ).left;
				}
				if ( rs ) {
					ui.position.left = inst._convertPositionTo( "relative", {
						top: 0,
						left: r - inst.helperProportions.width
					} ).left;
				}
			}

			if ( !inst.snapElements[ i ].snapping && ( ts || bs || ls || rs || first ) ) {
				if ( inst.options.snap.snap ) {
					inst.options.snap.snap.call(
						inst.element,
						event,
						$.extend( inst._uiHash(), {
							snapItem: inst.snapElements[ i ].item
						} ) );
				}
			}
			inst.snapElements[ i ].snapping = ( ts || bs || ls || rs || first );

		}

	}
} );

$.ui.plugin.add( "draggable", "stack", {
	start: function( event, ui, instance ) {
		var min,
			o = instance.options,
			group = $.makeArray( $( o.stack ) ).sort( function( a, b ) {
				return ( parseInt( $( a ).css( "zIndex" ), 10 ) || 0 ) -
					( parseInt( $( b ).css( "zIndex" ), 10 ) || 0 );
			} );

		if ( !group.length ) {
			return;
		}

		min = parseInt( $( group[ 0 ] ).css( "zIndex" ), 10 ) || 0;
		$( group ).each( function( i ) {
			$( this ).css( "zIndex", min + i );
		} );
		this.css( "zIndex", ( min + group.length ) );
	}
} );

$.ui.plugin.add( "draggable", "zIndex", {
	start: function( event, ui, instance ) {
		var t = $( ui.helper ),
			o = instance.options;

		if ( t.css( "zIndex" ) ) {
			o._zIndex = t.css( "zIndex" );
		}
		t.css( "zIndex", o.zIndex );
	},
	stop: function( event, ui, instance ) {
		var o = instance.options;

		if ( o._zIndex ) {
			$( ui.helper ).css( "zIndex", o._zIndex );
		}
	}
} );

var widgetsDraggable = $.ui.draggable;


/*!
 * jQuery UI Resizable 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Resizable
//>>group: Interactions
//>>description: Enables resize functionality for any element.
//>>docs: https://api.jqueryui.com/resizable/
//>>demos: https://jqueryui.com/resizable/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/resizable.css
//>>css.theme: ../../themes/base/theme.css


$.widget( "ui.resizable", $.ui.mouse, {
	version: "1.14.1",
	widgetEventPrefix: "resize",
	options: {
		alsoResize: false,
		animate: false,
		animateDuration: "slow",
		animateEasing: "swing",
		aspectRatio: false,
		autoHide: false,
		classes: {
			"ui-resizable-se": "ui-icon ui-icon-gripsmall-diagonal-se"
		},
		containment: false,
		ghost: false,
		grid: false,
		handles: "e,s,se",
		helper: false,
		maxHeight: null,
		maxWidth: null,
		minHeight: 10,
		minWidth: 10,

		// See #7960
		zIndex: 90,

		// Callbacks
		resize: null,
		start: null,
		stop: null
	},

	_num: function( value ) {
		return parseFloat( value ) || 0;
	},

	_isNumber: function( value ) {
		return !isNaN( parseFloat( value ) );
	},

	_hasScroll: function( el, a ) {

		var scroll,
			has = false,
			overflow = $( el ).css( "overflow" );

		if ( overflow === "hidden" ) {
			return false;
		}
		if ( overflow === "scroll" ) {
			return true;
		}

		scroll = ( a && a === "left" ) ? "scrollLeft" : "scrollTop";

		if ( el[ scroll ] > 0 ) {
			return true;
		}

		// TODO: determine which cases actually cause this to happen
		// if the element doesn't have the scroll set, see if it's possible to
		// set the scroll
		try {
			el[ scroll ] = 1;
			has = ( el[ scroll ] > 0 );
			el[ scroll ] = 0;
		} catch ( e ) {

			// `el` might be a string, then setting `scroll` will throw
			// an error in strict mode; ignore it.
		}
		return has;
	},

	_create: function() {

		var margins,
			o = this.options,
			that = this;
		this._addClass( "ui-resizable" );

		$.extend( this, {
			_aspectRatio: !!( o.aspectRatio ),
			aspectRatio: o.aspectRatio,
			originalElement: this.element,
			_proportionallyResizeElements: [],
			_helper: o.helper || o.ghost || o.animate ? o.helper || "ui-resizable-helper" : null
		} );

		// Wrap the element if it cannot hold child nodes
		if ( this.element[ 0 ].nodeName.match( /^(canvas|textarea|input|select|button|img)$/i ) ) {

			this.element.wrap(
				$( "<div class='ui-wrapper'></div>" ).css( {
					overflow: "hidden",
					position: this.element.css( "position" ),
					width: this.element.outerWidth(),
					height: this.element.outerHeight(),
					top: this.element.css( "top" ),
					left: this.element.css( "left" )
				} )
			);

			this.element = this.element.parent().data(
				"ui-resizable", this.element.resizable( "instance" )
			);

			this.elementIsWrapper = true;

			margins = {
				marginTop: this.originalElement.css( "marginTop" ),
				marginRight: this.originalElement.css( "marginRight" ),
				marginBottom: this.originalElement.css( "marginBottom" ),
				marginLeft: this.originalElement.css( "marginLeft" )
			};

			this.element.css( margins );

			// Support: Safari
			// Prevent Safari textarea resize
			this.originalResizeStyle = this.originalElement.css( "resize" );
			this.originalElement.css( "resize", "none" );

			this._proportionallyResizeElements.push( this.originalElement.css( {
				position: "static",
				zoom: 1,
				display: "block"
			} ) );

			this._proportionallyResize();
		}

		this._setupHandles();

		if ( o.autoHide ) {
			$( this.element )
				.on( "mouseenter", function() {
					if ( o.disabled ) {
						return;
					}
					that._removeClass( "ui-resizable-autohide" );
					that._handles.show();
				} )
				.on( "mouseleave", function() {
					if ( o.disabled ) {
						return;
					}
					if ( !that.resizing ) {
						that._addClass( "ui-resizable-autohide" );
						that._handles.hide();
					}
				} );
		}

		this._mouseInit();
	},

	_destroy: function() {

		this._mouseDestroy();
		this._addedHandles.remove();

		var wrapper,
			_destroy = function( exp ) {
				$( exp )
					.removeData( "resizable" )
					.removeData( "ui-resizable" )
					.off( ".resizable" );
			};

		// TODO: Unwrap at same DOM position
		if ( this.elementIsWrapper ) {
			_destroy( this.element );
			wrapper = this.element;
			this.originalElement.css( {
				position: wrapper.css( "position" ),
				width: wrapper.outerWidth(),
				height: wrapper.outerHeight(),
				top: wrapper.css( "top" ),
				left: wrapper.css( "left" )
			} ).insertAfter( wrapper );
			wrapper.remove();
		}

		this.originalElement.css( "resize", this.originalResizeStyle );
		_destroy( this.originalElement );

		return this;
	},

	_setOption: function( key, value ) {
		this._super( key, value );

		switch ( key ) {
		case "handles":
			this._removeHandles();
			this._setupHandles();
			break;
		case "aspectRatio":
			this._aspectRatio = !!value;
			break;
		default:
			break;
		}
	},

	_setupHandles: function() {
		var o = this.options, handle, i, n, hname, axis, that = this;
		this.handles = o.handles ||
			( !$( ".ui-resizable-handle", this.element ).length ?
				"e,s,se" : {
					n: ".ui-resizable-n",
					e: ".ui-resizable-e",
					s: ".ui-resizable-s",
					w: ".ui-resizable-w",
					se: ".ui-resizable-se",
					sw: ".ui-resizable-sw",
					ne: ".ui-resizable-ne",
					nw: ".ui-resizable-nw"
				} );

		this._handles = $();
		this._addedHandles = $();
		if ( this.handles.constructor === String ) {

			if ( this.handles === "all" ) {
				this.handles = "n,e,s,w,se,sw,ne,nw";
			}

			n = this.handles.split( "," );
			this.handles = {};

			for ( i = 0; i < n.length; i++ ) {

				handle = String.prototype.trim.call( n[ i ] );
				hname = "ui-resizable-" + handle;
				axis = $( "<div>" );
				this._addClass( axis, "ui-resizable-handle " + hname );

				axis.css( { zIndex: o.zIndex } );

				this.handles[ handle ] = ".ui-resizable-" + handle;
				if ( !this.element.children( this.handles[ handle ] ).length ) {
					this.element.append( axis );
					this._addedHandles = this._addedHandles.add( axis );
				}
			}

		}

		this._renderAxis = function( target ) {

			var i, axis, padPos, padWrapper;

			target = target || this.element;

			for ( i in this.handles ) {

				if ( this.handles[ i ].constructor === String ) {
					this.handles[ i ] = this.element.children( this.handles[ i ] ).first().show();
				} else if ( this.handles[ i ].jquery || this.handles[ i ].nodeType ) {
					this.handles[ i ] = $( this.handles[ i ] );
					this._on( this.handles[ i ], { "mousedown": that._mouseDown } );
				}

				if ( this.elementIsWrapper &&
						this.originalElement[ 0 ]
							.nodeName
							.match( /^(textarea|input|select|button)$/i ) ) {
					axis = $( this.handles[ i ], this.element );

					padWrapper = /sw|ne|nw|se|n|s/.test( i ) ?
						axis.outerHeight() :
						axis.outerWidth();

					padPos = [ "padding",
						/ne|nw|n/.test( i ) ? "Top" :
						/se|sw|s/.test( i ) ? "Bottom" :
						/^e$/.test( i ) ? "Right" : "Left" ].join( "" );

					target.css( padPos, padWrapper );

					this._proportionallyResize();
				}

				this._handles = this._handles.add( this.handles[ i ] );
			}
		};

		// TODO: make renderAxis a prototype function
		this._renderAxis( this.element );

		this._handles = this._handles.add( this.element.find( ".ui-resizable-handle" ) );
		this._handles.disableSelection();

		this._handles.on( "mouseover", function() {
			if ( !that.resizing ) {
				if ( this.className ) {
					axis = this.className.match( /ui-resizable-(se|sw|ne|nw|n|e|s|w)/i );
				}
				that.axis = axis && axis[ 1 ] ? axis[ 1 ] : "se";
			}
		} );

		if ( o.autoHide ) {
			this._handles.hide();
			this._addClass( "ui-resizable-autohide" );
		}
	},

	_removeHandles: function() {
		this._addedHandles.remove();
	},

	_mouseCapture: function( event ) {
		var i, handle,
			capture = false;

		for ( i in this.handles ) {
			handle = $( this.handles[ i ] )[ 0 ];
			if ( handle === event.target || $.contains( handle, event.target ) ) {
				capture = true;
			}
		}

		return !this.options.disabled && capture;
	},

	_mouseStart: function( event ) {

		var curleft, curtop, cursor, calculatedSize,
			o = this.options,
			el = this.element;

		this.resizing = true;

		this._renderProxy();

		curleft = this._num( this.helper.css( "left" ) );
		curtop = this._num( this.helper.css( "top" ) );

		if ( o.containment ) {
			curleft += $( o.containment ).scrollLeft() || 0;
			curtop += $( o.containment ).scrollTop() || 0;
		}

		this.offset = this.helper.offset();
		this.position = { left: curleft, top: curtop };

		if ( !this._helper ) {
			calculatedSize = this._calculateAdjustedElementDimensions( el );
		}

		this.size = this._helper ? {
				width: this.helper.width(),
				height: this.helper.height()
			} : {
				width: calculatedSize.width,
				height: calculatedSize.height
			};

		this.originalSize = this._helper ? {
				width: el.outerWidth(),
				height: el.outerHeight()
			} : {
				width: calculatedSize.width,
				height: calculatedSize.height
			};

		this.sizeDiff = {
			width: el.outerWidth() - el.width(),
			height: el.outerHeight() - el.height()
		};

		this.originalPosition = { left: curleft, top: curtop };
		this.originalMousePosition = { left: event.pageX, top: event.pageY };

		this.aspectRatio = ( typeof o.aspectRatio === "number" ) ?
			o.aspectRatio :
			( ( this.originalSize.width / this.originalSize.height ) || 1 );

		cursor = $( ".ui-resizable-" + this.axis ).css( "cursor" );
		$( "body" ).css( "cursor", cursor === "auto" ? this.axis + "-resize" : cursor );

		this._addClass( "ui-resizable-resizing" );
		this._propagate( "start", event );
		return true;
	},

	_mouseDrag: function( event ) {

		var data, props,
			smp = this.originalMousePosition,
			a = this.axis,
			dx = ( event.pageX - smp.left ) || 0,
			dy = ( event.pageY - smp.top ) || 0,
			trigger = this._change[ a ];

		this._updatePrevProperties();

		if ( !trigger ) {
			return false;
		}

		data = trigger.apply( this, [ event, dx, dy ] );

		this._updateVirtualBoundaries( event.shiftKey );
		if ( this._aspectRatio || event.shiftKey ) {
			data = this._updateRatio( data, event );
		}

		data = this._respectSize( data, event );

		this._updateCache( data );

		this._propagate( "resize", event );

		props = this._applyChanges();

		if ( !this._helper && this._proportionallyResizeElements.length ) {
			this._proportionallyResize();
		}

		if ( !$.isEmptyObject( props ) ) {
			this._updatePrevProperties();
			this._trigger( "resize", event, this.ui() );
			this._applyChanges();
		}

		return false;
	},

	_mouseStop: function( event ) {

		this.resizing = false;
		var pr, ista, soffseth, soffsetw, s, left, top,
			o = this.options, that = this;

		if ( this._helper ) {

			pr = this._proportionallyResizeElements;
			ista = pr.length && ( /textarea/i ).test( pr[ 0 ].nodeName );
			soffseth = ista && this._hasScroll( pr[ 0 ], "left" ) ? 0 : that.sizeDiff.height;
			soffsetw = ista ? 0 : that.sizeDiff.width;

			s = {
				width: ( that.helper.width()  - soffsetw ),
				height: ( that.helper.height() - soffseth )
			};
			left = ( parseFloat( that.element.css( "left" ) ) +
				( that.position.left - that.originalPosition.left ) ) || null;
			top = ( parseFloat( that.element.css( "top" ) ) +
				( that.position.top - that.originalPosition.top ) ) || null;

			if ( !o.animate ) {
				this.element.css( $.extend( s, { top: top, left: left } ) );
			}

			that.helper.height( that.size.height );
			that.helper.width( that.size.width );

			if ( this._helper && !o.animate ) {
				this._proportionallyResize();
			}
		}

		$( "body" ).css( "cursor", "auto" );

		this._removeClass( "ui-resizable-resizing" );

		this._propagate( "stop", event );

		if ( this._helper ) {
			this.helper.remove();
		}

		return false;

	},

	_updatePrevProperties: function() {
		this.prevPosition = {
			top: this.position.top,
			left: this.position.left
		};
		this.prevSize = {
			width: this.size.width,
			height: this.size.height
		};
	},

	_applyChanges: function() {
		var props = {};

		if ( this.position.top !== this.prevPosition.top ) {
			props.top = this.position.top + "px";
		}
		if ( this.position.left !== this.prevPosition.left ) {
			props.left = this.position.left + "px";
		}

		this.helper.css( props );

		if ( this.size.width !== this.prevSize.width ) {
			props.width = this.size.width + "px";
			this.helper.width( props.width );
		}
		if ( this.size.height !== this.prevSize.height ) {
			props.height = this.size.height + "px";
			this.helper.height( props.height );
		}

		return props;
	},

	_updateVirtualBoundaries: function( forceAspectRatio ) {
		var pMinWidth, pMaxWidth, pMinHeight, pMaxHeight, b,
			o = this.options;

		b = {
			minWidth: this._isNumber( o.minWidth ) ? o.minWidth : 0,
			maxWidth: this._isNumber( o.maxWidth ) ? o.maxWidth : Infinity,
			minHeight: this._isNumber( o.minHeight ) ? o.minHeight : 0,
			maxHeight: this._isNumber( o.maxHeight ) ? o.maxHeight : Infinity
		};

		if ( this._aspectRatio || forceAspectRatio ) {
			pMinWidth = b.minHeight * this.aspectRatio;
			pMinHeight = b.minWidth / this.aspectRatio;
			pMaxWidth = b.maxHeight * this.aspectRatio;
			pMaxHeight = b.maxWidth / this.aspectRatio;

			if ( pMinWidth > b.minWidth ) {
				b.minWidth = pMinWidth;
			}
			if ( pMinHeight > b.minHeight ) {
				b.minHeight = pMinHeight;
			}
			if ( pMaxWidth < b.maxWidth ) {
				b.maxWidth = pMaxWidth;
			}
			if ( pMaxHeight < b.maxHeight ) {
				b.maxHeight = pMaxHeight;
			}
		}
		this._vBoundaries = b;
	},

	_updateCache: function( data ) {
		this.offset = this.helper.offset();
		if ( this._isNumber( data.left ) ) {
			this.position.left = data.left;
		}
		if ( this._isNumber( data.top ) ) {
			this.position.top = data.top;
		}
		if ( this._isNumber( data.height ) ) {
			this.size.height = data.height;
		}
		if ( this._isNumber( data.width ) ) {
			this.size.width = data.width;
		}
	},

	_updateRatio: function( data ) {

		var cpos = this.position,
			csize = this.size,
			a = this.axis;

		if ( this._isNumber( data.height ) ) {
			data.width = ( data.height * this.aspectRatio );
		} else if ( this._isNumber( data.width ) ) {
			data.height = ( data.width / this.aspectRatio );
		}

		if ( a === "sw" ) {
			data.left = cpos.left + ( csize.width - data.width );
			data.top = null;
		}
		if ( a === "nw" ) {
			data.top = cpos.top + ( csize.height - data.height );
			data.left = cpos.left + ( csize.width - data.width );
		}

		return data;
	},

	_respectSize: function( data ) {

		var o = this._vBoundaries,
			a = this.axis,
			ismaxw = this._isNumber( data.width ) && o.maxWidth && ( o.maxWidth < data.width ),
			ismaxh = this._isNumber( data.height ) && o.maxHeight && ( o.maxHeight < data.height ),
			isminw = this._isNumber( data.width ) && o.minWidth && ( o.minWidth > data.width ),
			isminh = this._isNumber( data.height ) && o.minHeight && ( o.minHeight > data.height ),
			dw = this.originalPosition.left + this.originalSize.width,
			dh = this.originalPosition.top + this.originalSize.height,
			cw = /sw|nw|w/.test( a ), ch = /nw|ne|n/.test( a );
		if ( isminw ) {
			data.width = o.minWidth;
		}
		if ( isminh ) {
			data.height = o.minHeight;
		}
		if ( ismaxw ) {
			data.width = o.maxWidth;
		}
		if ( ismaxh ) {
			data.height = o.maxHeight;
		}

		if ( isminw && cw ) {
			data.left = dw - o.minWidth;
		}
		if ( ismaxw && cw ) {
			data.left = dw - o.maxWidth;
		}
		if ( isminh && ch ) {
			data.top = dh - o.minHeight;
		}
		if ( ismaxh && ch ) {
			data.top = dh - o.maxHeight;
		}

		// Fixing jump error on top/left - bug #2330
		if ( !data.width && !data.height && !data.left && data.top ) {
			data.top = null;
		} else if ( !data.width && !data.height && !data.top && data.left ) {
			data.left = null;
		}

		return data;
	},

	_getPaddingPlusBorderDimensions: function( element ) {
		var i = 0,
			widths = [],
			borders = [
				element.css( "borderTopWidth" ),
				element.css( "borderRightWidth" ),
				element.css( "borderBottomWidth" ),
				element.css( "borderLeftWidth" )
			],
			paddings = [
				element.css( "paddingTop" ),
				element.css( "paddingRight" ),
				element.css( "paddingBottom" ),
				element.css( "paddingLeft" )
			];

		for ( ; i < 4; i++ ) {
			widths[ i ] = ( parseFloat( borders[ i ] ) || 0 );
			widths[ i ] += ( parseFloat( paddings[ i ] ) || 0 );
		}

		return {
			height: widths[ 0 ] + widths[ 2 ],
			width: widths[ 1 ] + widths[ 3 ]
		};
	},

	_calculateAdjustedElementDimensions: function( element ) {
		var elWidth, elHeight, paddingBorder,
			ce = element.get( 0 );

		if ( element.css( "box-sizing" ) !== "content-box" ||
			( !this._hasScroll( ce ) && !this._hasScroll( ce, "left" ) ) ) {
				return {
					height: parseFloat( element.css( "height" ) ),
					width: parseFloat( element.css( "width" ) )
				};
		}

		// Check if CSS inline styles are set and use those (usually from previous resizes)
		elWidth = parseFloat( ce.style.width );
		elHeight = parseFloat( ce.style.height );

		paddingBorder = this._getPaddingPlusBorderDimensions( element );
		elWidth = isNaN( elWidth ) ?
			this._getElementTheoreticalSize( element, paddingBorder, "width" ) :
			elWidth;
		elHeight = isNaN( elHeight ) ?
			this._getElementTheoreticalSize( element, paddingBorder, "height" ) :
			elHeight;

		return {
			height: elHeight,
			width: elWidth
		};
	},

	_getElementTheoreticalSize: function( element, extraSize, dimension ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		var size = Math.max( 0, Math.ceil(
			element.get( 0 )[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			extraSize[ dimension ] -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine theoretical size.
		// Use an explicit zero to avoid NaN.
		// See https://github.com/jquery/jquery/issues/3964
		) ) || 0;

		return size;
	},

	_proportionallyResize: function() {

		if ( !this._proportionallyResizeElements.length ) {
			return;
		}

		var prel,
			i = 0,
			element = this.helper || this.element;

		for ( ; i < this._proportionallyResizeElements.length; i++ ) {

			prel = this._proportionallyResizeElements[ i ];

			// TODO: Seems like a bug to cache this.outerDimensions
			// considering that we are in a loop.
			if ( !this.outerDimensions ) {
				this.outerDimensions = this._getPaddingPlusBorderDimensions( prel );
			}

			prel.css( {
				height: ( element.height() - this.outerDimensions.height ) || 0,
				width: ( element.width() - this.outerDimensions.width ) || 0
			} );

		}

	},

	_renderProxy: function() {

		var el = this.element, o = this.options;
		this.elementOffset = el.offset();

		if ( this._helper ) {

			this.helper = this.helper || $( "<div></div>" ).css( { overflow: "hidden" } );

			this._addClass( this.helper, this._helper );
			this.helper.css( {
				width: this.element.outerWidth(),
				height: this.element.outerHeight(),
				position: "absolute",
				left: this.elementOffset.left + "px",
				top: this.elementOffset.top + "px",
				zIndex: ++o.zIndex //TODO: Don't modify option
			} );

			this.helper
				.appendTo( "body" )
				.disableSelection();

		} else {
			this.helper = this.element;
		}

	},

	_change: {
		e: function( event, dx ) {
			return { width: this.originalSize.width + dx };
		},
		w: function( event, dx ) {
			var cs = this.originalSize, sp = this.originalPosition;
			return { left: sp.left + dx, width: cs.width - dx };
		},
		n: function( event, dx, dy ) {
			var cs = this.originalSize, sp = this.originalPosition;
			return { top: sp.top + dy, height: cs.height - dy };
		},
		s: function( event, dx, dy ) {
			return { height: this.originalSize.height + dy };
		},
		se: function( event, dx, dy ) {
			return $.extend( this._change.s.apply( this, arguments ),
				this._change.e.apply( this, [ event, dx, dy ] ) );
		},
		sw: function( event, dx, dy ) {
			return $.extend( this._change.s.apply( this, arguments ),
				this._change.w.apply( this, [ event, dx, dy ] ) );
		},
		ne: function( event, dx, dy ) {
			return $.extend( this._change.n.apply( this, arguments ),
				this._change.e.apply( this, [ event, dx, dy ] ) );
		},
		nw: function( event, dx, dy ) {
			return $.extend( this._change.n.apply( this, arguments ),
				this._change.w.apply( this, [ event, dx, dy ] ) );
		}
	},

	_propagate: function( n, event ) {
		$.ui.plugin.call( this, n, [ event, this.ui() ] );
		if ( n !== "resize" ) {
			this._trigger( n, event, this.ui() );
		}
	},

	plugins: {},

	ui: function() {
		return {
			originalElement: this.originalElement,
			element: this.element,
			helper: this.helper,
			position: this.position,
			size: this.size,
			originalSize: this.originalSize,
			originalPosition: this.originalPosition
		};
	}

} );

/*
 * Resizable Extensions
 */

$.ui.plugin.add( "resizable", "animate", {

	stop: function( event ) {
		var that = $( this ).resizable( "instance" ),
			o = that.options,
			pr = that._proportionallyResizeElements,
			ista = pr.length && ( /textarea/i ).test( pr[ 0 ].nodeName ),
			soffseth = ista && that._hasScroll( pr[ 0 ], "left" ) ? 0 : that.sizeDiff.height,
			soffsetw = ista ? 0 : that.sizeDiff.width,
			style = {
				width: ( that.size.width - soffsetw ),
				height: ( that.size.height - soffseth )
			},
			left = ( parseFloat( that.element.css( "left" ) ) +
				( that.position.left - that.originalPosition.left ) ) || null,
			top = ( parseFloat( that.element.css( "top" ) ) +
				( that.position.top - that.originalPosition.top ) ) || null;

		that.element.animate(
			$.extend( style, top && left ? { top: top, left: left } : {} ), {
				duration: o.animateDuration,
				easing: o.animateEasing,
				step: function() {

					var data = {
						width: parseFloat( that.element.css( "width" ) ),
						height: parseFloat( that.element.css( "height" ) ),
						top: parseFloat( that.element.css( "top" ) ),
						left: parseFloat( that.element.css( "left" ) )
					};

					if ( pr && pr.length ) {
						$( pr[ 0 ] ).css( { width: data.width, height: data.height } );
					}

					// Propagating resize, and updating values for each animation step
					that._updateCache( data );
					that._propagate( "resize", event );

				}
			}
		);
	}

} );

$.ui.plugin.add( "resizable", "containment", {

	start: function() {
		var element, p, co, ch, cw, width, height,
			that = $( this ).resizable( "instance" ),
			o = that.options,
			el = that.element,
			oc = o.containment,
			ce = ( oc instanceof $ ) ?
				oc.get( 0 ) :
				( /parent/.test( oc ) ) ? el.parent().get( 0 ) : oc;

		if ( !ce ) {
			return;
		}

		that.containerElement = $( ce );

		if ( /document/.test( oc ) || oc === document ) {
			that.containerOffset = {
				left: 0,
				top: 0
			};
			that.containerPosition = {
				left: 0,
				top: 0
			};

			that.parentData = {
				element: $( document ),
				left: 0,
				top: 0,
				width: $( document ).width(),
				height: $( document ).height() || document.body.parentNode.scrollHeight
			};
		} else {
			element = $( ce );
			p = [];
			$( [ "Top", "Right", "Left", "Bottom" ] ).each( function( i, name ) {
				p[ i ] = that._num( element.css( "padding" + name ) );
			} );

			that.containerOffset = element.offset();
			that.containerPosition = element.position();
			that.containerSize = {
				height: ( element.innerHeight() - p[ 3 ] ),
				width: ( element.innerWidth() - p[ 1 ] )
			};

			co = that.containerOffset;
			ch = that.containerSize.height;
			cw = that.containerSize.width;
			width = ( that._hasScroll( ce, "left" ) ? ce.scrollWidth : cw );
			height = ( that._hasScroll( ce ) ? ce.scrollHeight : ch );

			that.parentData = {
				element: ce,
				left: co.left,
				top: co.top,
				width: width,
				height: height
			};
		}
	},

	resize: function( event ) {
		var woset, hoset, isParent, isOffsetRelative,
			that = $( this ).resizable( "instance" ),
			o = that.options,
			co = that.containerOffset,
			cp = that.position,
			pRatio = that._aspectRatio || event.shiftKey,
			cop = {
				top: 0,
				left: 0
			},
			ce = that.containerElement,
			continueResize = true;

		if ( ce[ 0 ] !== document && ( /static/ ).test( ce.css( "position" ) ) ) {
			cop = co;
		}

		if ( cp.left < ( that._helper ? co.left : 0 ) ) {
			that.size.width = that.size.width +
				( that._helper ?
					( that.position.left - co.left ) :
					( that.position.left - cop.left ) );

			if ( pRatio ) {
				that.size.height = that.size.width / that.aspectRatio;
				continueResize = false;
			}
			that.position.left = o.helper ? co.left : 0;
		}

		if ( cp.top < ( that._helper ? co.top : 0 ) ) {
			that.size.height = that.size.height +
				( that._helper ?
					( that.position.top - co.top ) :
					that.position.top );

			if ( pRatio ) {
				that.size.width = that.size.height * that.aspectRatio;
				continueResize = false;
			}
			that.position.top = that._helper ? co.top : 0;
		}

		isParent = that.containerElement.get( 0 ) === that.element.parent().get( 0 );
		isOffsetRelative = /relative|absolute/.test( that.containerElement.css( "position" ) );

		if ( isParent && isOffsetRelative ) {
			that.offset.left = that.parentData.left + that.position.left;
			that.offset.top = that.parentData.top + that.position.top;
		} else {
			that.offset.left = that.element.offset().left;
			that.offset.top = that.element.offset().top;
		}

		woset = Math.abs( that.sizeDiff.width +
			( that._helper ?
				that.offset.left - cop.left :
				( that.offset.left - co.left ) ) );

		hoset = Math.abs( that.sizeDiff.height +
			( that._helper ?
				that.offset.top - cop.top :
				( that.offset.top - co.top ) ) );

		if ( woset + that.size.width >= that.parentData.width ) {
			that.size.width = that.parentData.width - woset;
			if ( pRatio ) {
				that.size.height = that.size.width / that.aspectRatio;
				continueResize = false;
			}
		}

		if ( hoset + that.size.height >= that.parentData.height ) {
			that.size.height = that.parentData.height - hoset;
			if ( pRatio ) {
				that.size.width = that.size.height * that.aspectRatio;
				continueResize = false;
			}
		}

		if ( !continueResize ) {
			that.position.left = that.prevPosition.left;
			that.position.top = that.prevPosition.top;
			that.size.width = that.prevSize.width;
			that.size.height = that.prevSize.height;
		}
	},

	stop: function() {
		var that = $( this ).resizable( "instance" ),
			o = that.options,
			co = that.containerOffset,
			cop = that.containerPosition,
			ce = that.containerElement,
			helper = $( that.helper ),
			ho = helper.offset(),
			w = helper.outerWidth() - that.sizeDiff.width,
			h = helper.outerHeight() - that.sizeDiff.height;

		if ( that._helper && !o.animate && ( /relative/ ).test( ce.css( "position" ) ) ) {
			$( this ).css( {
				left: ho.left - cop.left - co.left,
				width: w,
				height: h
			} );
		}

		if ( that._helper && !o.animate && ( /static/ ).test( ce.css( "position" ) ) ) {
			$( this ).css( {
				left: ho.left - cop.left - co.left,
				width: w,
				height: h
			} );
		}
	}
} );

$.ui.plugin.add( "resizable", "alsoResize", {

	start: function() {
		var that = $( this ).resizable( "instance" ),
			o = that.options;

		$( o.alsoResize ).each( function() {
			var el = $( this ),
				elSize = that._calculateAdjustedElementDimensions( el );

			el.data( "ui-resizable-alsoresize", {
				width: elSize.width, height: elSize.height,
				left: parseFloat( el.css( "left" ) ), top: parseFloat( el.css( "top" ) )
			} );
		} );
	},

	resize: function( event, ui ) {
		var that = $( this ).resizable( "instance" ),
			o = that.options,
			os = that.originalSize,
			op = that.originalPosition,
			delta = {
				height: ( that.size.height - os.height ) || 0,
				width: ( that.size.width - os.width ) || 0,
				top: ( that.position.top - op.top ) || 0,
				left: ( that.position.left - op.left ) || 0
			};

			$( o.alsoResize ).each( function() {
				var el = $( this ), start = $( this ).data( "ui-resizable-alsoresize" ), style = {},
					css = el.parents( ui.originalElement[ 0 ] ).length ?
							[ "width", "height" ] :
							[ "width", "height", "top", "left" ];

				$.each( css, function( i, prop ) {
					var sum = ( start[ prop ] || 0 ) + ( delta[ prop ] || 0 );
					if ( sum && sum >= 0 ) {
						style[ prop ] = sum || null;
					}
				} );

				el.css( style );
			} );
	},

	stop: function() {
		$( this ).removeData( "ui-resizable-alsoresize" );
	}
} );

$.ui.plugin.add( "resizable", "ghost", {

	start: function() {

		var that = $( this ).resizable( "instance" ), cs = that.size;

		that.ghost = that.originalElement.clone();
		that.ghost.css( {
			opacity: 0.25,
			display: "block",
			position: "relative",
			height: cs.height,
			width: cs.width,
			margin: 0,
			left: 0,
			top: 0
		} );

		that._addClass( that.ghost, "ui-resizable-ghost" );

		// DEPRECATED
		// TODO: remove after 1.12
		if ( $.uiBackCompat === true && typeof that.options.ghost === "string" ) {

			// Ghost option
			that.ghost.addClass( this.options.ghost );
		}

		that.ghost.appendTo( that.helper );

	},

	resize: function() {
		var that = $( this ).resizable( "instance" );
		if ( that.ghost ) {
			that.ghost.css( {
				position: "relative",
				height: that.size.height,
				width: that.size.width
			} );
		}
	},

	stop: function() {
		var that = $( this ).resizable( "instance" );
		if ( that.ghost && that.helper ) {
			that.helper.get( 0 ).removeChild( that.ghost.get( 0 ) );
		}
	}

} );

$.ui.plugin.add( "resizable", "grid", {

	resize: function() {
		var outerDimensions,
			that = $( this ).resizable( "instance" ),
			o = that.options,
			cs = that.size,
			os = that.originalSize,
			op = that.originalPosition,
			a = that.axis,
			grid = typeof o.grid === "number" ? [ o.grid, o.grid ] : o.grid,
			gridX = ( grid[ 0 ] || 1 ),
			gridY = ( grid[ 1 ] || 1 ),
			ox = Math.round( ( cs.width - os.width ) / gridX ) * gridX,
			oy = Math.round( ( cs.height - os.height ) / gridY ) * gridY,
			newWidth = os.width + ox,
			newHeight = os.height + oy,
			isMaxWidth = o.maxWidth && ( o.maxWidth < newWidth ),
			isMaxHeight = o.maxHeight && ( o.maxHeight < newHeight ),
			isMinWidth = o.minWidth && ( o.minWidth > newWidth ),
			isMinHeight = o.minHeight && ( o.minHeight > newHeight );

		o.grid = grid;

		if ( isMinWidth ) {
			newWidth += gridX;
		}
		if ( isMinHeight ) {
			newHeight += gridY;
		}
		if ( isMaxWidth ) {
			newWidth -= gridX;
		}
		if ( isMaxHeight ) {
			newHeight -= gridY;
		}

		if ( /^(se|s|e)$/.test( a ) ) {
			that.size.width = newWidth;
			that.size.height = newHeight;
		} else if ( /^(ne)$/.test( a ) ) {
			that.size.width = newWidth;
			that.size.height = newHeight;
			that.position.top = op.top - oy;
		} else if ( /^(sw)$/.test( a ) ) {
			that.size.width = newWidth;
			that.size.height = newHeight;
			that.position.left = op.left - ox;
		} else {
			if ( newHeight - gridY <= 0 || newWidth - gridX <= 0 ) {
				outerDimensions = that._getPaddingPlusBorderDimensions( this );
			}

			if ( newHeight - gridY > 0 ) {
				that.size.height = newHeight;
				that.position.top = op.top - oy;
			} else {
				newHeight = gridY - outerDimensions.height;
				that.size.height = newHeight;
				that.position.top = op.top + os.height - newHeight;
			}
			if ( newWidth - gridX > 0 ) {
				that.size.width = newWidth;
				that.position.left = op.left - ox;
			} else {
				newWidth = gridX - outerDimensions.width;
				that.size.width = newWidth;
				that.position.left = op.left + os.width - newWidth;
			}
		}
	}

} );

var widgetsResizable = $.ui.resizable;


/*!
 * jQuery UI Dialog 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Dialog
//>>group: Widgets
//>>description: Displays customizable dialog windows.
//>>docs: https://api.jqueryui.com/dialog/
//>>demos: https://jqueryui.com/dialog/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/dialog.css
//>>css.theme: ../../themes/base/theme.css


$.widget( "ui.dialog", {
	version: "1.14.1",
	options: {
		appendTo: "body",
		autoOpen: true,
		buttons: [],
		classes: {
			"ui-dialog": "ui-corner-all",
			"ui-dialog-titlebar": "ui-corner-all"
		},
		closeOnEscape: true,
		closeText: "Close",
		draggable: true,
		hide: null,
		height: "auto",
		maxHeight: null,
		maxWidth: null,
		minHeight: 150,
		minWidth: 150,
		modal: false,
		position: {
			my: "center",
			at: "center",
			of: window,
			collision: "fit",

			// Ensure the titlebar is always visible
			using: function( pos ) {
				var topOffset = $( this ).css( pos ).offset().top;
				if ( topOffset < 0 ) {
					$( this ).css( "top", pos.top - topOffset );
				}
			}
		},
		resizable: true,
		show: null,
		title: null,
		uiDialogTitleHeadingLevel: 0,
		width: 300,

		// Callbacks
		beforeClose: null,
		close: null,
		drag: null,
		dragStart: null,
		dragStop: null,
		focus: null,
		open: null,
		resize: null,
		resizeStart: null,
		resizeStop: null
	},

	sizeRelatedOptions: {
		buttons: true,
		height: true,
		maxHeight: true,
		maxWidth: true,
		minHeight: true,
		minWidth: true,
		width: true
	},

	resizableRelatedOptions: {
		maxHeight: true,
		maxWidth: true,
		minHeight: true,
		minWidth: true
	},

	_create: function() {
		this.originalCss = {
			display: this.element[ 0 ].style.display,
			width: this.element[ 0 ].style.width,
			minHeight: this.element[ 0 ].style.minHeight,
			maxHeight: this.element[ 0 ].style.maxHeight,
			height: this.element[ 0 ].style.height
		};
		this.originalPosition = {
			parent: this.element.parent(),
			index: this.element.parent().children().index( this.element )
		};
		this.originalTitle = this.element.attr( "title" );
		if ( this.options.title == null && this.originalTitle != null ) {
			this.options.title = this.originalTitle;
		}

		// Dialogs can't be disabled
		if ( this.options.disabled ) {
			this.options.disabled = false;
		}

		this._createWrapper();

		this.element
			.show()
			.removeAttr( "title" )
			.appendTo( this.uiDialog );

		this._addClass( "ui-dialog-content", "ui-widget-content" );

		this._createTitlebar();
		this._createButtonPane();

		if ( this.options.draggable && $.fn.draggable ) {
			this._makeDraggable();
		}
		if ( this.options.resizable && $.fn.resizable ) {
			this._makeResizable();
		}

		this._isOpen = false;

		this._trackFocus();
	},

	_init: function() {
		if ( this.options.autoOpen ) {
			this.open();
		}
	},

	_appendTo: function() {
		var element = this.options.appendTo;
		if ( element && ( element.jquery || element.nodeType ) ) {
			return $( element );
		}
		return this.document.find( element || "body" ).eq( 0 );
	},

	_destroy: function() {
		var next,
			originalPosition = this.originalPosition;

		this._untrackInstance();
		this._destroyOverlay();

		this.element
			.removeUniqueId()
			.css( this.originalCss )

			// Without detaching first, the following becomes really slow
			.detach();

		this.uiDialog.remove();

		if ( this.originalTitle ) {
			this.element.attr( "title", this.originalTitle );
		}

		next = originalPosition.parent.children().eq( originalPosition.index );

		// Don't try to place the dialog next to itself (#8613)
		if ( next.length && next[ 0 ] !== this.element[ 0 ] ) {
			next.before( this.element );
		} else {
			originalPosition.parent.append( this.element );
		}
	},

	widget: function() {
		return this.uiDialog;
	},

	disable: $.noop,
	enable: $.noop,

	close: function( event ) {
		var that = this;

		if ( !this._isOpen || this._trigger( "beforeClose", event ) === false ) {
			return;
		}

		this._isOpen = false;
		this._focusedElement = null;
		this._destroyOverlay();
		this._untrackInstance();

		if ( !this.opener.filter( ":focusable" ).trigger( "focus" ).length ) {

			// Hiding a focused element doesn't trigger blur in WebKit
			// so in case we have nothing to focus on, explicitly blur the active element
			// https://bugs.webkit.org/show_bug.cgi?id=47182
			$( this.document[ 0 ].activeElement ).trigger( "blur" );
		}

		this._hide( this.uiDialog, this.options.hide, function() {
			that._trigger( "close", event );
		} );
	},

	isOpen: function() {
		return this._isOpen;
	},

	moveToTop: function() {
		this._moveToTop();
	},

	_moveToTop: function( event, silent ) {
		var moved = false,
			zIndices = this.uiDialog.siblings( ".ui-front:visible" ).map( function() {
				return +$( this ).css( "z-index" );
			} ).get(),
			zIndexMax = Math.max.apply( null, zIndices );

		if ( zIndexMax >= +this.uiDialog.css( "z-index" ) ) {
			this.uiDialog.css( "z-index", zIndexMax + 1 );
			moved = true;
		}

		if ( moved && !silent ) {
			this._trigger( "focus", event );
		}
		return moved;
	},

	open: function() {
		var that = this;
		if ( this._isOpen ) {
			if ( this._moveToTop() ) {
				this._focusTabbable();
			}
			return;
		}

		this._isOpen = true;
		this.opener = $( this.document[ 0 ].activeElement );

		this._size();
		this._position();
		this._createOverlay();
		this._moveToTop( null, true );

		// Ensure the overlay is moved to the top with the dialog, but only when
		// opening. The overlay shouldn't move after the dialog is open so that
		// modeless dialogs opened after the modal dialog stack properly.
		if ( this.overlay ) {
			this.overlay.css( "z-index", this.uiDialog.css( "z-index" ) - 1 );
		}

		this._show( this.uiDialog, this.options.show, function() {
			that._focusTabbable();
			that._trigger( "focus" );
		} );

		// Track the dialog immediately upon opening in case a focus event
		// somehow occurs outside of the dialog before an element inside the
		// dialog is focused (#10152)
		this._makeFocusTarget();

		this._trigger( "open" );
	},

	_focusTabbable: function() {

		// Set focus to the first match:
		// 1. An element that was focused previously
		// 2. First element inside the dialog matching [autofocus]
		// 3. Tabbable element inside the content element
		// 4. Tabbable element inside the buttonpane
		// 5. The close button
		// 6. The dialog itself
		var hasFocus = this._focusedElement;
		if ( !hasFocus ) {
			hasFocus = this.element.find( "[autofocus]" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.element.find( ":tabbable" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.uiDialogButtonPane.find( ":tabbable" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.uiDialogTitlebarClose.filter( ":tabbable" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.uiDialog;
		}
		hasFocus.eq( 0 ).trigger( "focus" );
	},

	_restoreTabbableFocus: function() {
		var activeElement = this.document[ 0 ].activeElement,
			isActive = this.uiDialog[ 0 ] === activeElement ||
				$.contains( this.uiDialog[ 0 ], activeElement );
		if ( !isActive ) {
			this._focusTabbable();
		}
	},

	_keepFocus: function( event ) {
		event.preventDefault();
		this._restoreTabbableFocus();
	},

	_createWrapper: function() {
		this.uiDialog = $( "<div>" )
			.hide()
			.attr( {

				// Setting tabIndex makes the div focusable
				tabIndex: -1,
				role: "dialog",
				"aria-modal": this.options.modal ? "true" : null
			} )
			.appendTo( this._appendTo() );

		this._addClass( this.uiDialog, "ui-dialog", "ui-widget ui-widget-content ui-front" );
		this._on( this.uiDialog, {
			keydown: function( event ) {
				if ( this.options.closeOnEscape && !event.isDefaultPrevented() && event.keyCode &&
						event.keyCode === $.ui.keyCode.ESCAPE ) {
					event.preventDefault();
					this.close( event );
					return;
				}

				// Prevent tabbing out of dialogs
				if ( event.keyCode !== $.ui.keyCode.TAB || event.isDefaultPrevented() ) {
					return;
				}
				var tabbables = this.uiDialog.find( ":tabbable" ),
					first = tabbables.first(),
					last = tabbables.last();

				if ( ( event.target === last[ 0 ] || event.target === this.uiDialog[ 0 ] ) &&
						!event.shiftKey ) {
					this._delay( function() {
						first.trigger( "focus" );
					} );
					event.preventDefault();
				} else if ( ( event.target === first[ 0 ] ||
						event.target === this.uiDialog[ 0 ] ) && event.shiftKey ) {
					this._delay( function() {
						last.trigger( "focus" );
					} );
					event.preventDefault();
				}
			},
			mousedown: function( event ) {
				if ( this._moveToTop( event ) ) {
					this._focusTabbable();
				}
			}
		} );

		// We assume that any existing aria-describedby attribute means
		// that the dialog content is marked up properly
		// otherwise we brute force the content as the description
		if ( !this.element.find( "[aria-describedby]" ).length ) {
			this.uiDialog.attr( {
				"aria-describedby": this.element.uniqueId().attr( "id" )
			} );
		}
	},

	_createTitlebar: function() {
		var uiDialogTitle;

		this.uiDialogTitlebar = $( "<div>" );
		this._addClass( this.uiDialogTitlebar,
			"ui-dialog-titlebar", "ui-widget-header ui-helper-clearfix" );
		this._on( this.uiDialogTitlebar, {
			mousedown: function( event ) {

				// Don't prevent click on close button (#8838)
				// Focusing a dialog that is partially scrolled out of view
				// causes the browser to scroll it into view, preventing the click event
				if ( !$( event.target ).closest( ".ui-dialog-titlebar-close" ) ) {

					// Dialog isn't getting focus when dragging (#8063)
					this.uiDialog.trigger( "focus" );
				}
			}
		} );

		this.uiDialogTitlebarClose = $( "<button type='button'></button>" )
			.button( {
				label: $( "<a>" ).text( this.options.closeText ).html(),
				icon: "ui-icon-closethick",
				showLabel: false
			} )
			.appendTo( this.uiDialogTitlebar );

		this._addClass( this.uiDialogTitlebarClose, "ui-dialog-titlebar-close" );
		this._on( this.uiDialogTitlebarClose, {
			click: function( event ) {
				event.preventDefault();
				this.close( event );
			}
		} );

		var uiDialogHeadingLevel = Number.isInteger( this.options.uiDialogTitleHeadingLevel ) &&
			this.options.uiDialogTitleHeadingLevel > 0 &&
			this.options.uiDialogTitleHeadingLevel <= 6 ?
			"h" + this.options.uiDialogTitleHeadingLevel : "span";

		uiDialogTitle = $( "<" + uiDialogHeadingLevel + ">" )
			.uniqueId().prependTo( this.uiDialogTitlebar );
		this._addClass( uiDialogTitle, "ui-dialog-title" );
		this._title( uiDialogTitle );

		this.uiDialogTitlebar.prependTo( this.uiDialog );

		this.uiDialog.attr( {
			"aria-labelledby": uiDialogTitle.attr( "id" )
		} );
	},

	_title: function( title ) {
		if ( this.options.title ) {
			title.text( this.options.title );
		} else {
			title.html( "&#160;" );
		}
	},

	_createButtonPane: function() {
		this.uiDialogButtonPane = $( "<div>" );
		this._addClass( this.uiDialogButtonPane, "ui-dialog-buttonpane",
			"ui-widget-content ui-helper-clearfix" );

		this.uiButtonSet = $( "<div>" )
			.appendTo( this.uiDialogButtonPane );
		this._addClass( this.uiButtonSet, "ui-dialog-buttonset" );

		this._createButtons();
	},

	_createButtons: function() {
		var that = this,
			buttons = this.options.buttons;

		// If we already have a button pane, remove it
		this.uiDialogButtonPane.remove();
		this.uiButtonSet.empty();

		if ( $.isEmptyObject( buttons ) || ( Array.isArray( buttons ) && !buttons.length ) ) {
			this._removeClass( this.uiDialog, "ui-dialog-buttons" );
			return;
		}

		$.each( buttons, function( name, props ) {
			var click, buttonOptions;
			props = typeof props === "function" ?
				{ click: props, text: name } :
				props;

			// Default to a non-submitting button
			props = $.extend( { type: "button" }, props );

			// Change the context for the click callback to be the main element
			click = props.click;
			buttonOptions = {
				icon: props.icon,
				iconPosition: props.iconPosition,
				showLabel: props.showLabel,

				// Deprecated options
				icons: props.icons,
				text: props.text
			};

			delete props.click;
			delete props.icon;
			delete props.iconPosition;
			delete props.showLabel;

			// Deprecated options
			delete props.icons;
			if ( typeof props.text === "boolean" ) {
				delete props.text;
			}

			$( "<button></button>", props )
				.button( buttonOptions )
				.appendTo( that.uiButtonSet )
				.on( "click", function() {
					click.apply( that.element[ 0 ], arguments );
				} );
		} );
		this._addClass( this.uiDialog, "ui-dialog-buttons" );
		this.uiDialogButtonPane.appendTo( this.uiDialog );
	},

	_makeDraggable: function() {
		var that = this,
			options = this.options;

		function filteredUi( ui ) {
			return {
				position: ui.position,
				offset: ui.offset
			};
		}

		this.uiDialog.draggable( {
			cancel: ".ui-dialog-content, .ui-dialog-titlebar-close",
			handle: ".ui-dialog-titlebar",
			containment: "document",
			start: function( event, ui ) {
				that._addClass( $( this ), "ui-dialog-dragging" );
				that._blockFrames();
				that._trigger( "dragStart", event, filteredUi( ui ) );
			},
			drag: function( event, ui ) {
				that._trigger( "drag", event, filteredUi( ui ) );
			},
			stop: function( event, ui ) {
				var left = ui.offset.left - that.document.scrollLeft(),
					top = ui.offset.top - that.document.scrollTop();

				options.position = {
					my: "left top",
					at: "left" + ( left >= 0 ? "+" : "" ) + left + " " +
						"top" + ( top >= 0 ? "+" : "" ) + top,
					of: that.window
				};
				that._removeClass( $( this ), "ui-dialog-dragging" );
				that._unblockFrames();
				that._trigger( "dragStop", event, filteredUi( ui ) );
			}
		} );
	},

	_makeResizable: function() {
		var that = this,
			options = this.options,
			handles = options.resizable,

			// .ui-resizable has position: relative defined in the stylesheet
			// but dialogs have to use absolute or fixed positioning
			position = this.uiDialog.css( "position" ),
			resizeHandles = typeof handles === "string" ?
				handles :
				"n,e,s,w,se,sw,ne,nw";

		function filteredUi( ui ) {
			return {
				originalPosition: ui.originalPosition,
				originalSize: ui.originalSize,
				position: ui.position,
				size: ui.size
			};
		}

		this.uiDialog.resizable( {
			cancel: ".ui-dialog-content",
			containment: "document",
			alsoResize: this.element,
			maxWidth: options.maxWidth,
			maxHeight: options.maxHeight,
			minWidth: options.minWidth,
			minHeight: this._minHeight(),
			handles: resizeHandles,
			start: function( event, ui ) {
				that._addClass( $( this ), "ui-dialog-resizing" );
				that._blockFrames();
				that._trigger( "resizeStart", event, filteredUi( ui ) );
			},
			resize: function( event, ui ) {
				that._trigger( "resize", event, filteredUi( ui ) );
			},
			stop: function( event, ui ) {
				var offset = that.uiDialog.offset(),
					left = offset.left - that.document.scrollLeft(),
					top = offset.top - that.document.scrollTop();

				options.height = that.uiDialog.height();
				options.width = that.uiDialog.width();
				options.position = {
					my: "left top",
					at: "left" + ( left >= 0 ? "+" : "" ) + left + " " +
						"top" + ( top >= 0 ? "+" : "" ) + top,
					of: that.window
				};
				that._removeClass( $( this ), "ui-dialog-resizing" );
				that._unblockFrames();
				that._trigger( "resizeStop", event, filteredUi( ui ) );
			}
		} )
			.css( "position", position );
	},

	_trackFocus: function() {
		this._on( this.widget(), {
			focusin: function( event ) {
				this._makeFocusTarget();
				this._focusedElement = $( event.target );
			}
		} );
	},

	_makeFocusTarget: function() {
		this._untrackInstance();
		this._trackingInstances().unshift( this );
	},

	_untrackInstance: function() {
		var instances = this._trackingInstances(),
			exists = $.inArray( this, instances );
		if ( exists !== -1 ) {
			instances.splice( exists, 1 );
		}
	},

	_trackingInstances: function() {
		var instances = this.document.data( "ui-dialog-instances" );
		if ( !instances ) {
			instances = [];
			this.document.data( "ui-dialog-instances", instances );
		}
		return instances;
	},

	_minHeight: function() {
		var options = this.options;

		return options.height === "auto" ?
			options.minHeight :
			Math.min( options.minHeight, options.height );
	},

	_position: function() {

		// Need to show the dialog to get the actual offset in the position plugin
		var isVisible = this.uiDialog.is( ":visible" );
		if ( !isVisible ) {
			this.uiDialog.show();
		}
		this.uiDialog.position( this.options.position );
		if ( !isVisible ) {
			this.uiDialog.hide();
		}
	},

	_setOptions: function( options ) {
		var that = this,
			resize = false,
			resizableOptions = {};

		$.each( options, function( key, value ) {
			that._setOption( key, value );

			if ( key in that.sizeRelatedOptions ) {
				resize = true;
			}
			if ( key in that.resizableRelatedOptions ) {
				resizableOptions[ key ] = value;
			}
		} );

		if ( resize ) {
			this._size();
			this._position();
		}
		if ( this.uiDialog.is( ":data(ui-resizable)" ) ) {
			this.uiDialog.resizable( "option", resizableOptions );
		}
	},

	_setOption: function( key, value ) {
		var isDraggable, isResizable,
			uiDialog = this.uiDialog;

		if ( key === "disabled" ) {
			return;
		}

		this._super( key, value );

		if ( key === "appendTo" ) {
			this.uiDialog.appendTo( this._appendTo() );
		}

		if ( key === "buttons" ) {
			this._createButtons();
		}

		if ( key === "closeText" ) {
			this.uiDialogTitlebarClose.button( {

				// Ensure that we always pass a string
				label: $( "<a>" ).text( "" + this.options.closeText ).html()
			} );
		}

		if ( key === "draggable" ) {
			isDraggable = uiDialog.is( ":data(ui-draggable)" );
			if ( isDraggable && !value ) {
				uiDialog.draggable( "destroy" );
			}

			if ( !isDraggable && value ) {
				this._makeDraggable();
			}
		}

		if ( key === "position" ) {
			this._position();
		}

		if ( key === "resizable" ) {

			// currently resizable, becoming non-resizable
			isResizable = uiDialog.is( ":data(ui-resizable)" );
			if ( isResizable && !value ) {
				uiDialog.resizable( "destroy" );
			}

			// Currently resizable, changing handles
			if ( isResizable && typeof value === "string" ) {
				uiDialog.resizable( "option", "handles", value );
			}

			// Currently non-resizable, becoming resizable
			if ( !isResizable && value !== false ) {
				this._makeResizable();
			}
		}

		if ( key === "title" ) {
			this._title( this.uiDialogTitlebar.find( ".ui-dialog-title" ) );
		}

		if ( key === "modal" ) {
			uiDialog.attr( "aria-modal", value ? "true" : null );
		}
	},

	_size: function() {

		// If the user has resized the dialog, the .ui-dialog and .ui-dialog-content
		// divs will both have width and height set, so we need to reset them
		var nonContentHeight, minContentHeight, maxContentHeight,
			options = this.options;

		// Reset content sizing
		this.element.show().css( {
			width: "auto",
			minHeight: 0,
			maxHeight: "none",
			height: 0
		} );

		if ( options.minWidth > options.width ) {
			options.width = options.minWidth;
		}

		// Reset wrapper sizing
		// determine the height of all the non-content elements
		nonContentHeight = this.uiDialog.css( {
			height: "auto",
			width: options.width
		} )
			.outerHeight();
		minContentHeight = Math.max( 0, options.minHeight - nonContentHeight );
		maxContentHeight = typeof options.maxHeight === "number" ?
			Math.max( 0, options.maxHeight - nonContentHeight ) :
			"none";

		if ( options.height === "auto" ) {
			this.element.css( {
				minHeight: minContentHeight,
				maxHeight: maxContentHeight,
				height: "auto"
			} );
		} else {
			this.element.height( Math.max( 0, options.height - nonContentHeight ) );
		}

		if ( this.uiDialog.is( ":data(ui-resizable)" ) ) {
			this.uiDialog.resizable( "option", "minHeight", this._minHeight() );
		}
	},

	_blockFrames: function() {
		this.iframeBlocks = this.document.find( "iframe" ).map( function() {
			var iframe = $( this );

			return $( "<div>" )
				.css( {
					position: "absolute",
					width: iframe.outerWidth(),
					height: iframe.outerHeight()
				} )
				.appendTo( iframe.parent() )
				.offset( iframe.offset() )[ 0 ];
		} );
	},

	_unblockFrames: function() {
		if ( this.iframeBlocks ) {
			this.iframeBlocks.remove();
			delete this.iframeBlocks;
		}
	},

	_allowInteraction: function( event ) {
		if ( $( event.target ).closest( ".ui-dialog" ).length ) {
			return true;
		}

		// TODO: Remove hack when datepicker implements
		// the .ui-front logic (#8989)
		return !!$( event.target ).closest( ".ui-datepicker" ).length;
	},

	_createOverlay: function() {
		if ( !this.options.modal ) {
			return;
		}

		// We use a delay in case the overlay is created from an
		// event that we're going to be cancelling (#2804)
		var isOpening = true;
		this._delay( function() {
			isOpening = false;
		} );

		if ( !this.document.data( "ui-dialog-overlays" ) ) {

			// Prevent use of anchors and inputs
			// This doesn't use `_on()` because it is a shared event handler
			// across all open modal dialogs.
			this.document.on( "focusin.ui-dialog", function( event ) {
				if ( isOpening ) {
					return;
				}

				var instance = this._trackingInstances()[ 0 ];
				if ( !instance._allowInteraction( event ) ) {
					event.preventDefault();
					instance._focusTabbable();
				}
			}.bind( this ) );
		}

		this.overlay = $( "<div>" )
			.appendTo( this._appendTo() );

		this._addClass( this.overlay, null, "ui-widget-overlay ui-front" );
		this._on( this.overlay, {
			mousedown: "_keepFocus"
		} );
		this.document.data( "ui-dialog-overlays",
			( this.document.data( "ui-dialog-overlays" ) || 0 ) + 1 );
	},

	_destroyOverlay: function() {
		if ( !this.options.modal ) {
			return;
		}

		if ( this.overlay ) {
			var overlays = this.document.data( "ui-dialog-overlays" ) - 1;

			if ( !overlays ) {
				this.document.off( "focusin.ui-dialog" );
				this.document.removeData( "ui-dialog-overlays" );
			} else {
				this.document.data( "ui-dialog-overlays", overlays );
			}

			this.overlay.remove();
			this.overlay = null;
		}
	}
} );

// DEPRECATED
// TODO: switch return back to widget declaration at top of file when this is removed
if ( $.uiBackCompat === true ) {

	// Backcompat for dialogClass option
	$.widget( "ui.dialog", $.ui.dialog, {
		options: {
			dialogClass: ""
		},
		_createWrapper: function() {
			this._super();
			this.uiDialog.addClass( this.options.dialogClass );
		},
		_setOption: function( key, value ) {
			if ( key === "dialogClass" ) {
				this.uiDialog
					.removeClass( this.options.dialogClass )
					.addClass( value );
			}
			this._superApply( arguments );
		}
	} );
}

var widgetsDialog = $.ui.dialog;


/*!
 * jQuery UI Droppable 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Droppable
//>>group: Interactions
//>>description: Enables drop targets for draggable elements.
//>>docs: https://api.jqueryui.com/droppable/
//>>demos: https://jqueryui.com/droppable/


$.widget( "ui.droppable", {
	version: "1.14.1",
	widgetEventPrefix: "drop",
	options: {
		accept: "*",
		addClasses: true,
		greedy: false,
		scope: "default",
		tolerance: "intersect",

		// Callbacks
		activate: null,
		deactivate: null,
		drop: null,
		out: null,
		over: null
	},
	_create: function() {

		var proportions,
			o = this.options,
			accept = o.accept;

		this.isover = false;
		this.isout = true;

		this.accept = typeof accept === "function" ? accept : function( d ) {
			return d.is( accept );
		};

		this.proportions = function( /* valueToWrite */ ) {
			if ( arguments.length ) {

				// Store the droppable's proportions
				proportions = arguments[ 0 ];
			} else {

				// Retrieve or derive the droppable's proportions
				return proportions ?
					proportions :
					proportions = {
						width: this.element[ 0 ].offsetWidth,
						height: this.element[ 0 ].offsetHeight
					};
			}
		};

		this._addToManager( o.scope );

		if ( o.addClasses ) {
			this._addClass( "ui-droppable" );
		}

	},

	_addToManager: function( scope ) {

		// Add the reference and positions to the manager
		$.ui.ddmanager.droppables[ scope ] = $.ui.ddmanager.droppables[ scope ] || [];
		$.ui.ddmanager.droppables[ scope ].push( this );
	},

	_splice: function( drop ) {
		var i = 0;
		for ( ; i < drop.length; i++ ) {
			if ( drop[ i ] === this ) {
				drop.splice( i, 1 );
			}
		}
	},

	_destroy: function() {
		var drop = $.ui.ddmanager.droppables[ this.options.scope ];

		this._splice( drop );
	},

	_setOption: function( key, value ) {

		if ( key === "accept" ) {
			this.accept = typeof value === "function" ? value : function( d ) {
				return d.is( value );
			};
		} else if ( key === "scope" ) {
			var drop = $.ui.ddmanager.droppables[ this.options.scope ];

			this._splice( drop );
			this._addToManager( value );
		}

		this._super( key, value );
	},

	_activate: function( event ) {
		var draggable = $.ui.ddmanager.current;

		this._addActiveClass();
		if ( draggable ) {
			this._trigger( "activate", event, this.ui( draggable ) );
		}
	},

	_deactivate: function( event ) {
		var draggable = $.ui.ddmanager.current;

		this._removeActiveClass();
		if ( draggable ) {
			this._trigger( "deactivate", event, this.ui( draggable ) );
		}
	},

	_over: function( event ) {

		var draggable = $.ui.ddmanager.current;

		// Bail if draggable and droppable are same element
		if ( !draggable || ( draggable.currentItem ||
				draggable.element )[ 0 ] === this.element[ 0 ] ) {
			return;
		}

		if ( this.accept.call( this.element[ 0 ], ( draggable.currentItem ||
				draggable.element ) ) ) {
			this._addHoverClass();
			this._trigger( "over", event, this.ui( draggable ) );
		}

	},

	_out: function( event ) {

		var draggable = $.ui.ddmanager.current;

		// Bail if draggable and droppable are same element
		if ( !draggable || ( draggable.currentItem ||
				draggable.element )[ 0 ] === this.element[ 0 ] ) {
			return;
		}

		if ( this.accept.call( this.element[ 0 ], ( draggable.currentItem ||
				draggable.element ) ) ) {
			this._removeHoverClass();
			this._trigger( "out", event, this.ui( draggable ) );
		}

	},

	_drop: function( event, custom ) {

		var draggable = custom || $.ui.ddmanager.current,
			childrenIntersection = false;

		// Bail if draggable and droppable are same element
		if ( !draggable || ( draggable.currentItem ||
				draggable.element )[ 0 ] === this.element[ 0 ] ) {
			return false;
		}

		this.element
			.find( ":data(ui-droppable)" )
			.not( ".ui-draggable-dragging" )
			.each( function() {
				var inst = $( this ).droppable( "instance" );
				if (
					inst.options.greedy &&
					!inst.options.disabled &&
					inst.options.scope === draggable.options.scope &&
					inst.accept.call(
						inst.element[ 0 ], ( draggable.currentItem || draggable.element )
					) &&
					$.ui.intersect(
						draggable,
						$.extend( inst, { offset: inst.element.offset() } ),
						inst.options.tolerance, event
					)
				) {
					childrenIntersection = true;
					return false;
				}
			} );
		if ( childrenIntersection ) {
			return false;
		}

		if ( this.accept.call( this.element[ 0 ],
				( draggable.currentItem || draggable.element ) ) ) {
			this._removeActiveClass();
			this._removeHoverClass();

			this._trigger( "drop", event, this.ui( draggable ) );
			return this.element;
		}

		return false;

	},

	ui: function( c ) {
		return {
			draggable: ( c.currentItem || c.element ),
			helper: c.helper,
			position: c.position,
			offset: c.positionAbs
		};
	},

	// Extension points just to make backcompat sane and avoid duplicating logic
	// TODO: Remove in 1.14 along with call to it below
	_addHoverClass: function() {
		this._addClass( "ui-droppable-hover" );
	},

	_removeHoverClass: function() {
		this._removeClass( "ui-droppable-hover" );
	},

	_addActiveClass: function() {
		this._addClass( "ui-droppable-active" );
	},

	_removeActiveClass: function() {
		this._removeClass( "ui-droppable-active" );
	}
} );

$.ui.intersect = ( function() {
	function isOverAxis( x, reference, size ) {
		return ( x >= reference ) && ( x < ( reference + size ) );
	}

	return function( draggable, droppable, toleranceMode, event ) {

		if ( !droppable.offset ) {
			return false;
		}

		var x1 = ( draggable.positionAbs ||
				draggable.position.absolute ).left + draggable.margins.left,
			y1 = ( draggable.positionAbs ||
				draggable.position.absolute ).top + draggable.margins.top,
			x2 = x1 + draggable.helperProportions.width,
			y2 = y1 + draggable.helperProportions.height,
			l = droppable.offset.left,
			t = droppable.offset.top,
			r = l + droppable.proportions().width,
			b = t + droppable.proportions().height;

		switch ( toleranceMode ) {
		case "fit":
			return ( l <= x1 && x2 <= r && t <= y1 && y2 <= b );
		case "intersect":
			return ( l < x1 + ( draggable.helperProportions.width / 2 ) && // Right Half
				x2 - ( draggable.helperProportions.width / 2 ) < r && // Left Half
				t < y1 + ( draggable.helperProportions.height / 2 ) && // Bottom Half
				y2 - ( draggable.helperProportions.height / 2 ) < b ); // Top Half
		case "pointer":
			return isOverAxis( event.pageY, t, droppable.proportions().height ) &&
				isOverAxis( event.pageX, l, droppable.proportions().width );
		case "touch":
			return (
				( y1 >= t && y1 <= b ) || // Top edge touching
				( y2 >= t && y2 <= b ) || // Bottom edge touching
				( y1 < t && y2 > b ) // Surrounded vertically
			) && (
				( x1 >= l && x1 <= r ) || // Left edge touching
				( x2 >= l && x2 <= r ) || // Right edge touching
				( x1 < l && x2 > r ) // Surrounded horizontally
			);
		default:
			return false;
		}
	};
} )();

/*
	This manager tracks offsets of draggables and droppables
*/
$.ui.ddmanager = {
	current: null,
	droppables: { "default": [] },
	prepareOffsets: function( t, event ) {

		var i, j,
			m = $.ui.ddmanager.droppables[ t.options.scope ] || [],
			type = event ? event.type : null, // workaround for #2317
			list = ( t.currentItem || t.element ).find( ":data(ui-droppable)" ).addBack();

		droppablesLoop: for ( i = 0; i < m.length; i++ ) {

			// No disabled and non-accepted
			if ( m[ i ].options.disabled || ( t && !m[ i ].accept.call( m[ i ].element[ 0 ],
					( t.currentItem || t.element ) ) ) ) {
				continue;
			}

			// Filter out elements in the current dragged item
			for ( j = 0; j < list.length; j++ ) {
				if ( list[ j ] === m[ i ].element[ 0 ] ) {
					m[ i ].proportions().height = 0;
					continue droppablesLoop;
				}
			}

			m[ i ].visible = m[ i ].element.css( "display" ) !== "none";
			if ( !m[ i ].visible ) {
				continue;
			}

			// Activate the droppable if used directly from draggables
			if ( type === "mousedown" ) {
				m[ i ]._activate.call( m[ i ], event );
			}

			m[ i ].offset = m[ i ].element.offset();
			m[ i ].proportions( {
				width: m[ i ].element[ 0 ].offsetWidth,
				height: m[ i ].element[ 0 ].offsetHeight
			} );

		}

	},
	drop: function( draggable, event ) {

		var dropped = false;

		// Create a copy of the droppables in case the list changes during the drop (#9116)
		$.each( ( $.ui.ddmanager.droppables[ draggable.options.scope ] || [] ).slice(), function() {

			if ( !this.options ) {
				return;
			}
			if ( !this.options.disabled && this.visible &&
					$.ui.intersect( draggable, this, this.options.tolerance, event ) ) {
				dropped = this._drop.call( this, event ) || dropped;
			}

			if ( !this.options.disabled && this.visible && this.accept.call( this.element[ 0 ],
					( draggable.currentItem || draggable.element ) ) ) {
				this.isout = true;
				this.isover = false;
				this._deactivate.call( this, event );
			}

		} );
		return dropped;

	},
	dragStart: function( draggable, event ) {

		// Listen for scrolling so that if the dragging causes scrolling the position of the
		// droppables can be recalculated (see #5003)
		draggable.element.parentsUntil( "body" ).on( "scroll.droppable", function() {
			if ( !draggable.options.refreshPositions ) {
				$.ui.ddmanager.prepareOffsets( draggable, event );
			}
		} );
	},
	drag: function( draggable, event ) {

		// If you have a highly dynamic page, you might try this option. It renders positions
		// every time you move the mouse.
		if ( draggable.options.refreshPositions ) {
			$.ui.ddmanager.prepareOffsets( draggable, event );
		}

		// Run through all droppables and check their positions based on specific tolerance options
		$.each( $.ui.ddmanager.droppables[ draggable.options.scope ] || [], function() {

			if ( this.options.disabled || this.greedyChild || !this.visible ) {
				return;
			}

			var parentInstance, scope, parent,
				intersects = $.ui.intersect( draggable, this, this.options.tolerance, event ),
				c = !intersects && this.isover ?
					"isout" :
					( intersects && !this.isover ? "isover" : null );
			if ( !c ) {
				return;
			}

			if ( this.options.greedy ) {

				// find droppable parents with same scope
				scope = this.options.scope;
				parent = this.element.parents( ":data(ui-droppable)" ).filter( function() {
					return $( this ).droppable( "instance" ).options.scope === scope;
				} );

				if ( parent.length ) {
					parentInstance = $( parent[ 0 ] ).droppable( "instance" );
					parentInstance.greedyChild = ( c === "isover" );
				}
			}

			// We just moved into a greedy child
			if ( parentInstance && c === "isover" ) {
				parentInstance.isover = false;
				parentInstance.isout = true;
				parentInstance._out.call( parentInstance, event );
			}

			this[ c ] = true;
			this[ c === "isout" ? "isover" : "isout" ] = false;
			this[ c === "isover" ? "_over" : "_out" ].call( this, event );

			// We just moved out of a greedy child
			if ( parentInstance && c === "isout" ) {
				parentInstance.isout = false;
				parentInstance.isover = true;
				parentInstance._over.call( parentInstance, event );
			}
		} );

	},
	dragStop: function( draggable, event ) {
		draggable.element.parentsUntil( "body" ).off( "scroll.droppable" );

		// Call prepareOffsets one final time since IE does not fire return scroll events when
		// overflow was caused by drag (see #5003)
		if ( !draggable.options.refreshPositions ) {
			$.ui.ddmanager.prepareOffsets( draggable, event );
		}
	}
};

// DEPRECATED
// TODO: switch return back to widget declaration at top of file when this is removed
if ( $.uiBackCompat === true ) {

	// Backcompat for activeClass and hoverClass options
	$.widget( "ui.droppable", $.ui.droppable, {
		options: {
			hoverClass: false,
			activeClass: false
		},
		_addActiveClass: function() {
			this._super();
			if ( this.options.activeClass ) {
				this.element.addClass( this.options.activeClass );
			}
		},
		_removeActiveClass: function() {
			this._super();
			if ( this.options.activeClass ) {
				this.element.removeClass( this.options.activeClass );
			}
		},
		_addHoverClass: function() {
			this._super();
			if ( this.options.hoverClass ) {
				this.element.addClass( this.options.hoverClass );
			}
		},
		_removeHoverClass: function() {
			this._super();
			if ( this.options.hoverClass ) {
				this.element.removeClass( this.options.hoverClass );
			}
		}
	} );
}

var widgetsDroppable = $.ui.droppable;


/*!
 * jQuery UI Progressbar 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Progressbar
//>>group: Widgets
/* eslint-disable max-len */
//>>description: Displays a status indicator for loading state, standard percentage, and other progress indicators.
/* eslint-enable max-len */
//>>docs: https://api.jqueryui.com/progressbar/
//>>demos: https://jqueryui.com/progressbar/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/progressbar.css
//>>css.theme: ../../themes/base/theme.css


var widgetsProgressbar = $.widget( "ui.progressbar", {
	version: "1.14.1",
	options: {
		classes: {
			"ui-progressbar": "ui-corner-all",
			"ui-progressbar-value": "ui-corner-left",
			"ui-progressbar-complete": "ui-corner-right"
		},
		max: 100,
		value: 0,

		change: null,
		complete: null
	},

	min: 0,

	_create: function() {

		// Constrain initial value
		this.oldValue = this.options.value = this._constrainedValue();

		this.element.attr( {

			// Only set static values; aria-valuenow and aria-valuemax are
			// set inside _refreshValue()
			role: "progressbar",
			"aria-valuemin": this.min
		} );
		this._addClass( "ui-progressbar", "ui-widget ui-widget-content" );

		this.valueDiv = $( "<div>" ).appendTo( this.element );
		this._addClass( this.valueDiv, "ui-progressbar-value", "ui-widget-header" );
		this._refreshValue();
	},

	_destroy: function() {
		this.element.removeAttr( "role aria-valuemin aria-valuemax aria-valuenow" );

		this.valueDiv.remove();
	},

	value: function( newValue ) {
		if ( newValue === undefined ) {
			return this.options.value;
		}

		this.options.value = this._constrainedValue( newValue );
		this._refreshValue();
	},

	_constrainedValue: function( newValue ) {
		if ( newValue === undefined ) {
			newValue = this.options.value;
		}

		this.indeterminate = newValue === false;

		// Sanitize value
		if ( typeof newValue !== "number" ) {
			newValue = 0;
		}

		return this.indeterminate ? false :
			Math.min( this.options.max, Math.max( this.min, newValue ) );
	},

	_setOptions: function( options ) {

		// Ensure "value" option is set after other values (like max)
		var value = options.value;
		delete options.value;

		this._super( options );

		this.options.value = this._constrainedValue( value );
		this._refreshValue();
	},

	_setOption: function( key, value ) {
		if ( key === "max" ) {

			// Don't allow a max less than min
			value = Math.max( this.min, value );
		}
		this._super( key, value );
	},

	_setOptionDisabled: function( value ) {
		this._super( value );

		this.element.attr( "aria-disabled", value );
		this._toggleClass( null, "ui-state-disabled", !!value );
	},

	_percentage: function() {
		return this.indeterminate ?
			100 :
			100 * ( this.options.value - this.min ) / ( this.options.max - this.min );
	},

	_refreshValue: function() {
		var value = this.options.value,
			percentage = this._percentage();

		this.valueDiv
			.toggle( this.indeterminate || value > this.min )
			.width( percentage.toFixed( 0 ) + "%" );

		this
			._toggleClass( this.valueDiv, "ui-progressbar-complete", null,
				value === this.options.max )
			._toggleClass( "ui-progressbar-indeterminate", null, this.indeterminate );

		if ( this.indeterminate ) {
			this.element.removeAttr( "aria-valuenow" );
			if ( !this.overlayDiv ) {
				this.overlayDiv = $( "<div>" ).appendTo( this.valueDiv );
				this._addClass( this.overlayDiv, "ui-progressbar-overlay" );
			}
		} else {
			this.element.attr( {
				"aria-valuemax": this.options.max,
				"aria-valuenow": value
			} );
			if ( this.overlayDiv ) {
				this.overlayDiv.remove();
				this.overlayDiv = null;
			}
		}

		if ( this.oldValue !== value ) {
			this.oldValue = value;
			this._trigger( "change" );
		}
		if ( value === this.options.max ) {
			this._trigger( "complete" );
		}
	}
} );


/*!
 * jQuery UI Selectable 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Selectable
//>>group: Interactions
//>>description: Allows groups of elements to be selected with the mouse.
//>>docs: https://api.jqueryui.com/selectable/
//>>demos: https://jqueryui.com/selectable/
//>>css.structure: ../../themes/base/selectable.css


var widgetsSelectable = $.widget( "ui.selectable", $.ui.mouse, {
	version: "1.14.1",
	options: {
		appendTo: "body",
		autoRefresh: true,
		distance: 0,
		filter: "*",
		tolerance: "touch",

		// Callbacks
		selected: null,
		selecting: null,
		start: null,
		stop: null,
		unselected: null,
		unselecting: null
	},
	_create: function() {
		var that = this;

		this._addClass( "ui-selectable" );

		this.dragged = false;

		// Cache selectee children based on filter
		this.refresh = function() {
			that.elementPos = $( that.element[ 0 ] ).offset();
			that.selectees = $( that.options.filter, that.element[ 0 ] );
			that._addClass( that.selectees, "ui-selectee" );
			that.selectees.each( function() {
				var $this = $( this ),
					selecteeOffset = $this.offset(),
					pos = {
						left: selecteeOffset.left - that.elementPos.left,
						top: selecteeOffset.top - that.elementPos.top
					};
				$.data( this, "selectable-item", {
					element: this,
					$element: $this,
					left: pos.left,
					top: pos.top,
					right: pos.left + $this.outerWidth(),
					bottom: pos.top + $this.outerHeight(),
					startselected: false,
					selected: $this.hasClass( "ui-selected" ),
					selecting: $this.hasClass( "ui-selecting" ),
					unselecting: $this.hasClass( "ui-unselecting" )
				} );
			} );
		};
		this.refresh();

		this._mouseInit();

		this.helper = $( "<div>" );
		this._addClass( this.helper, "ui-selectable-helper" );
	},

	_destroy: function() {
		this.selectees.removeData( "selectable-item" );
		this._mouseDestroy();
	},

	_mouseStart: function( event ) {
		var that = this,
			options = this.options;

		this.opos = [ event.pageX, event.pageY ];
		this.elementPos = $( this.element[ 0 ] ).offset();

		if ( this.options.disabled ) {
			return;
		}

		this.selectees = $( options.filter, this.element[ 0 ] );

		this._trigger( "start", event );

		$( options.appendTo ).append( this.helper );

		// position helper (lasso)
		this.helper.css( {
			"left": event.pageX,
			"top": event.pageY,
			"width": 0,
			"height": 0
		} );

		if ( options.autoRefresh ) {
			this.refresh();
		}

		this.selectees.filter( ".ui-selected" ).each( function() {
			var selectee = $.data( this, "selectable-item" );
			selectee.startselected = true;
			if ( !event.metaKey && !event.ctrlKey ) {
				that._removeClass( selectee.$element, "ui-selected" );
				selectee.selected = false;
				that._addClass( selectee.$element, "ui-unselecting" );
				selectee.unselecting = true;

				// selectable UNSELECTING callback
				that._trigger( "unselecting", event, {
					unselecting: selectee.element
				} );
			}
		} );

		$( event.target ).parents().addBack().each( function() {
			var doSelect,
				selectee = $.data( this, "selectable-item" );
			if ( selectee ) {
				doSelect = ( !event.metaKey && !event.ctrlKey ) ||
					!selectee.$element.hasClass( "ui-selected" );
				that._removeClass( selectee.$element, doSelect ? "ui-unselecting" : "ui-selected" )
					._addClass( selectee.$element, doSelect ? "ui-selecting" : "ui-unselecting" );
				selectee.unselecting = !doSelect;
				selectee.selecting = doSelect;
				selectee.selected = doSelect;

				// selectable (UN)SELECTING callback
				if ( doSelect ) {
					that._trigger( "selecting", event, {
						selecting: selectee.element
					} );
				} else {
					that._trigger( "unselecting", event, {
						unselecting: selectee.element
					} );
				}
				return false;
			}
		} );

	},

	_mouseDrag: function( event ) {

		this.dragged = true;

		if ( this.options.disabled ) {
			return;
		}

		var tmp,
			that = this,
			options = this.options,
			x1 = this.opos[ 0 ],
			y1 = this.opos[ 1 ],
			x2 = event.pageX,
			y2 = event.pageY;

		if ( x1 > x2 ) {
			tmp = x2; x2 = x1; x1 = tmp;
		}
		if ( y1 > y2 ) {
			tmp = y2; y2 = y1; y1 = tmp;
		}
		this.helper.css( { left: x1, top: y1, width: x2 - x1, height: y2 - y1 } );

		this.selectees.each( function() {
			var selectee = $.data( this, "selectable-item" ),
				hit = false,
				offset = {};

			//prevent helper from being selected if appendTo: selectable
			if ( !selectee || selectee.element === that.element[ 0 ] ) {
				return;
			}

			offset.left   = selectee.left   + that.elementPos.left;
			offset.right  = selectee.right  + that.elementPos.left;
			offset.top    = selectee.top    + that.elementPos.top;
			offset.bottom = selectee.bottom + that.elementPos.top;

			if ( options.tolerance === "touch" ) {
				hit = ( !( offset.left > x2 || offset.right < x1 || offset.top > y2 ||
                    offset.bottom < y1 ) );
			} else if ( options.tolerance === "fit" ) {
				hit = ( offset.left > x1 && offset.right < x2 && offset.top > y1 &&
                    offset.bottom < y2 );
			}

			if ( hit ) {

				// SELECT
				if ( selectee.selected ) {
					that._removeClass( selectee.$element, "ui-selected" );
					selectee.selected = false;
				}
				if ( selectee.unselecting ) {
					that._removeClass( selectee.$element, "ui-unselecting" );
					selectee.unselecting = false;
				}
				if ( !selectee.selecting ) {
					that._addClass( selectee.$element, "ui-selecting" );
					selectee.selecting = true;

					// selectable SELECTING callback
					that._trigger( "selecting", event, {
						selecting: selectee.element
					} );
				}
			} else {

				// UNSELECT
				if ( selectee.selecting ) {
					if ( ( event.metaKey || event.ctrlKey ) && selectee.startselected ) {
						that._removeClass( selectee.$element, "ui-selecting" );
						selectee.selecting = false;
						that._addClass( selectee.$element, "ui-selected" );
						selectee.selected = true;
					} else {
						that._removeClass( selectee.$element, "ui-selecting" );
						selectee.selecting = false;
						if ( selectee.startselected ) {
							that._addClass( selectee.$element, "ui-unselecting" );
							selectee.unselecting = true;
						}

						// selectable UNSELECTING callback
						that._trigger( "unselecting", event, {
							unselecting: selectee.element
						} );
					}
				}
				if ( selectee.selected ) {
					if ( !event.metaKey && !event.ctrlKey && !selectee.startselected ) {
						that._removeClass( selectee.$element, "ui-selected" );
						selectee.selected = false;

						that._addClass( selectee.$element, "ui-unselecting" );
						selectee.unselecting = true;

						// selectable UNSELECTING callback
						that._trigger( "unselecting", event, {
							unselecting: selectee.element
						} );
					}
				}
			}
		} );

		return false;
	},

	_mouseStop: function( event ) {
		var that = this;

		this.dragged = false;

		$( ".ui-unselecting", this.element[ 0 ] ).each( function() {
			var selectee = $.data( this, "selectable-item" );
			that._removeClass( selectee.$element, "ui-unselecting" );
			selectee.unselecting = false;
			selectee.startselected = false;
			that._trigger( "unselected", event, {
				unselected: selectee.element
			} );
		} );
		$( ".ui-selecting", this.element[ 0 ] ).each( function() {
			var selectee = $.data( this, "selectable-item" );
			that._removeClass( selectee.$element, "ui-selecting" )
				._addClass( selectee.$element, "ui-selected" );
			selectee.selecting = false;
			selectee.selected = true;
			selectee.startselected = true;
			that._trigger( "selected", event, {
				selected: selectee.element
			} );
		} );
		this._trigger( "stop", event );

		this.helper.remove();

		return false;
	}

} );


/*!
 * jQuery UI Selectmenu 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Selectmenu
//>>group: Widgets
/* eslint-disable max-len */
//>>description: Duplicates and extends the functionality of a native HTML select element, allowing it to be customizable in behavior and appearance far beyond the limitations of a native select.
/* eslint-enable max-len */
//>>docs: https://api.jqueryui.com/selectmenu/
//>>demos: https://jqueryui.com/selectmenu/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/selectmenu.css, ../../themes/base/button.css
//>>css.theme: ../../themes/base/theme.css


var widgetsSelectmenu = $.widget( "ui.selectmenu", [ $.ui.formResetMixin, {
	version: "1.14.1",
	defaultElement: "<select>",
	options: {
		appendTo: null,
		classes: {
			"ui-selectmenu-button-open": "ui-corner-top",
			"ui-selectmenu-button-closed": "ui-corner-all"
		},
		disabled: null,
		icons: {
			button: "ui-icon-triangle-1-s"
		},
		position: {
			my: "left top",
			at: "left bottom",
			collision: "none"
		},
		width: false,

		// Callbacks
		change: null,
		close: null,
		focus: null,
		open: null,
		select: null
	},

	_create: function() {
		var selectmenuId = this.element.uniqueId().attr( "id" );
		this.ids = {
			element: selectmenuId,
			button: selectmenuId + "-button",
			menu: selectmenuId + "-menu"
		};

		this._drawButton();
		this._drawMenu();
		this._bindFormResetHandler();

		this._rendered = false;
		this.menuItems = $();
	},

	_drawButton: function() {
		var icon,
			that = this,
			item = this._parseOption(
				this.element.find( "option:selected" ),
				this.element[ 0 ].selectedIndex
			);

		// Associate existing label with the new button
		this.labels = this.element.labels().attr( "for", this.ids.button );
		this._on( this.labels, {
			click: function( event ) {
				this.button.trigger( "focus" );
				event.preventDefault();
			}
		} );

		// Hide original select element
		this.element.hide();

		// Create button
		this.button = $( "<span>", {
			tabindex: this.options.disabled ? -1 : 0,
			id: this.ids.button,
			role: "combobox",
			"aria-expanded": "false",
			"aria-autocomplete": "list",
			"aria-owns": this.ids.menu,
			"aria-haspopup": "true",
			title: this.element.attr( "title" )
		} )
			.insertAfter( this.element );

		this._addClass( this.button, "ui-selectmenu-button ui-selectmenu-button-closed",
			"ui-button ui-widget" );

		icon = $( "<span>" ).appendTo( this.button );
		this._addClass( icon, "ui-selectmenu-icon", "ui-icon " + this.options.icons.button );
		this.buttonItem = this._renderButtonItem( item )
			.appendTo( this.button );

		if ( this.options.width !== false ) {
			this._resizeButton();
		}

		this._on( this.button, this._buttonEvents );
		this.button.one( "focusin", function() {

			// Delay rendering the menu items until the button receives focus.
			// The menu may have already been rendered via a programmatic open.
			if ( !that._rendered ) {
				that._refreshMenu();
			}
		} );
	},

	_drawMenu: function() {
		var that = this;

		// Create menu
		this.menu = $( "<ul>", {
			"aria-hidden": "true",
			"aria-labelledby": this.ids.button,
			id: this.ids.menu
		} );

		// Wrap menu
		this.menuWrap = $( "<div>" ).append( this.menu );
		this._addClass( this.menuWrap, "ui-selectmenu-menu", "ui-front" );
		this.menuWrap.appendTo( this._appendTo() );

		// Initialize menu widget
		this.menuInstance = this.menu
			.menu( {
				classes: {
					"ui-menu": "ui-corner-bottom"
				},
				role: "listbox",
				select: function( event, ui ) {
					event.preventDefault();
					that._select( ui.item.data( "ui-selectmenu-item" ), event );
				},
				focus: function( event, ui ) {
					var item = ui.item.data( "ui-selectmenu-item" );

					// Prevent inital focus from firing and check if its a newly focused item
					if ( that.focusIndex != null && item.index !== that.focusIndex ) {
						that._trigger( "focus", event, { item: item } );
						if ( !that.isOpen ) {
							that._select( item, event );
						}
					}
					that.focusIndex = item.index;

					that.button.attr( "aria-activedescendant",
						that.menuItems.eq( item.index ).attr( "id" ) );
				}
			} )
			.menu( "instance" );

		// Don't close the menu on mouseleave
		this.menuInstance._off( this.menu, "mouseleave" );

		// Cancel the menu's collapseAll on document click
		this.menuInstance._closeOnDocumentClick = function() {
			return false;
		};

		// Selects often contain empty items, but never contain dividers
		this.menuInstance._isDivider = function() {
			return false;
		};
	},

	refresh: function() {
		this._refreshMenu();
		this.buttonItem.replaceWith(
			this.buttonItem = this._renderButtonItem(

				// Fall back to an empty object in case there are no options
				this._getSelectedItem().data( "ui-selectmenu-item" ) || {}
			)
		);
		if ( this.options.width === null ) {
			this._resizeButton();
		}
	},

	_refreshMenu: function() {
		var item,
			options = this.element.find( "option" );

		this.menu.empty();

		this._parseOptions( options );
		this._renderMenu( this.menu, this.items );

		this.menuInstance.refresh();
		this.menuItems = this.menu.find( "li" )
			.not( ".ui-selectmenu-optgroup" )
				.find( ".ui-menu-item-wrapper" );

		this._rendered = true;

		if ( !options.length ) {
			return;
		}

		item = this._getSelectedItem();

		// Update the menu to have the correct item focused
		this.menuInstance.focus( null, item );
		this._setAria( item.data( "ui-selectmenu-item" ) );

		// Set disabled state
		this._setOption( "disabled", this.element.prop( "disabled" ) );
	},

	open: function( event ) {
		if ( this.options.disabled ) {
			return;
		}

		// If this is the first time the menu is being opened, render the items
		if ( !this._rendered ) {
			this._refreshMenu();
		} else {

			// Menu clears focus on close, reset focus to selected item
			this._removeClass( this.menu.find( ".ui-state-active" ), null, "ui-state-active" );
			this.menuInstance.focus( null, this._getSelectedItem() );
		}

		// If there are no options, don't open the menu
		if ( !this.menuItems.length ) {
			return;
		}

		this.isOpen = true;
		this._toggleAttr();
		this._resizeMenu();
		this._position();

		this._on( this.document, this._documentClick );

		this._trigger( "open", event );
	},

	_position: function() {
		this.menuWrap.position( $.extend( { of: this.button }, this.options.position ) );
	},

	close: function( event ) {
		if ( !this.isOpen ) {
			return;
		}

		this.isOpen = false;
		this._toggleAttr();

		this.range = null;
		this._off( this.document );

		this._trigger( "close", event );
	},

	widget: function() {
		return this.button;
	},

	menuWidget: function() {
		return this.menu;
	},

	_renderButtonItem: function( item ) {
		var buttonItem = $( "<span>" );

		this._setText( buttonItem, item.label );
		this._addClass( buttonItem, "ui-selectmenu-text" );

		return buttonItem;
	},

	_renderMenu: function( ul, items ) {
		var that = this,
			currentOptgroup = "";

		$.each( items, function( index, item ) {
			var li;

			if ( item.optgroup !== currentOptgroup ) {
				li = $( "<li>", {
					text: item.optgroup
				} );
				that._addClass( li, "ui-selectmenu-optgroup", "ui-menu-divider" +
					( item.element.parent( "optgroup" ).prop( "disabled" ) ?
						" ui-state-disabled" :
						"" ) );

				li.appendTo( ul );

				currentOptgroup = item.optgroup;
			}

			that._renderItemData( ul, item );
		} );
	},

	_renderItemData: function( ul, item ) {
		return this._renderItem( ul, item ).data( "ui-selectmenu-item", item );
	},

	_renderItem: function( ul, item ) {
		var li = $( "<li>" ),
			wrapper = $( "<div>", {
				title: item.element.attr( "title" )
			} );

		if ( item.disabled ) {
			this._addClass( li, null, "ui-state-disabled" );
		}

		if ( item.hidden ) {
			li.prop( "hidden", true );
		} else {
			this._setText( wrapper, item.label );
		}

		return li.append( wrapper ).appendTo( ul );
	},

	_setText: function( element, value ) {
		if ( value ) {
			element.text( value );
		} else {
			element.html( "&#160;" );
		}
	},

	_move: function( direction, event ) {
		var item, next,
			filter = ".ui-menu-item";

		if ( this.isOpen ) {
			item = this.menuItems.eq( this.focusIndex ).parent( "li" );
		} else {
			item = this.menuItems.eq( this.element[ 0 ].selectedIndex ).parent( "li" );
			filter += ":not(.ui-state-disabled)";
		}

		if ( direction === "first" || direction === "last" ) {
			next = item[ direction === "first" ? "prevAll" : "nextAll" ]( filter ).eq( -1 );
		} else {
			next = item[ direction + "All" ]( filter ).eq( 0 );
		}

		if ( next.length ) {
			this.menuInstance.focus( event, next );
		}
	},

	_getSelectedItem: function() {
		return this.menuItems.eq( this.element[ 0 ].selectedIndex ).parent( "li" );
	},

	_toggle: function( event ) {
		this[ this.isOpen ? "close" : "open" ]( event );
	},

	_setSelection: function() {
		var selection;

		if ( !this.range ) {
			return;
		}

		selection = window.getSelection();
		selection.removeAllRanges();
		selection.addRange( this.range );
	},

	_documentClick: {
		mousedown: function( event ) {
			if ( !this.isOpen ) {
				return;
			}

			if ( !$( event.target ).closest( ".ui-selectmenu-menu, #" +
				CSS.escape( this.ids.button ) ).length ) {
				this.close( event );
			}
		}
	},

	_buttonEvents: {

		// Prevent text selection from being reset when interacting with the selectmenu (#10144)
		mousedown: function() {
			var selection = window.getSelection();
			if ( selection.rangeCount ) {
				this.range = selection.getRangeAt( 0 );
			}
		},

		click: function( event ) {
			this._setSelection();
			this._toggle( event );
		},

		keydown: function( event ) {
			var preventDefault = true;
			switch ( event.keyCode ) {
			case $.ui.keyCode.TAB:
			case $.ui.keyCode.ESCAPE:
				this.close( event );
				preventDefault = false;
				break;
			case $.ui.keyCode.ENTER:
				if ( this.isOpen ) {
					this._selectFocusedItem( event );
				}
				break;
			case $.ui.keyCode.UP:
				if ( event.altKey ) {
					this._toggle( event );
				} else {
					this._move( "prev", event );
				}
				break;
			case $.ui.keyCode.DOWN:
				if ( event.altKey ) {
					this._toggle( event );
				} else {
					this._move( "next", event );
				}
				break;
			case $.ui.keyCode.SPACE:
				if ( this.isOpen ) {
					this._selectFocusedItem( event );
				} else {
					this._toggle( event );
				}
				break;
			case $.ui.keyCode.LEFT:
				this._move( "prev", event );
				break;
			case $.ui.keyCode.RIGHT:
				this._move( "next", event );
				break;
			case $.ui.keyCode.HOME:
			case $.ui.keyCode.PAGE_UP:
				this._move( "first", event );
				break;
			case $.ui.keyCode.END:
			case $.ui.keyCode.PAGE_DOWN:
				this._move( "last", event );
				break;
			default:
				this.menu.trigger( event );
				preventDefault = false;
			}

			if ( preventDefault ) {
				event.preventDefault();
			}
		}
	},

	_selectFocusedItem: function( event ) {
		var item = this.menuItems.eq( this.focusIndex ).parent( "li" );
		if ( !item.hasClass( "ui-state-disabled" ) ) {
			this._select( item.data( "ui-selectmenu-item" ), event );
		}
	},

	_select: function( item, event ) {
		var oldIndex = this.element[ 0 ].selectedIndex;

		// Change native select element
		this.element[ 0 ].selectedIndex = item.index;
		this.buttonItem.replaceWith( this.buttonItem = this._renderButtonItem( item ) );
		this._setAria( item );
		this._trigger( "select", event, { item: item } );

		if ( item.index !== oldIndex ) {
			this._trigger( "change", event, { item: item } );
		}

		this.close( event );
	},

	_setAria: function( item ) {
		var id = this.menuItems.eq( item.index ).attr( "id" );

		this.button.attr( {
			"aria-labelledby": id,
			"aria-activedescendant": id
		} );
		this.menu.attr( "aria-activedescendant", id );
	},

	_setOption: function( key, value ) {
		if ( key === "icons" ) {
			var icon = this.button.find( "span.ui-icon" );
			this._removeClass( icon, null, this.options.icons.button )
				._addClass( icon, null, value.button );
		}

		this._super( key, value );

		if ( key === "appendTo" ) {
			this.menuWrap.appendTo( this._appendTo() );
		}

		if ( key === "width" ) {
			this._resizeButton();
		}
	},

	_setOptionDisabled: function( value ) {
		this._super( value );

		this.menuInstance.option( "disabled", value );
		this.button.attr( "aria-disabled", value );
		this._toggleClass( this.button, null, "ui-state-disabled", value );

		this.element.prop( "disabled", value );
		if ( value ) {
			this.button.attr( "tabindex", -1 );
			this.close();
		} else {
			this.button.attr( "tabindex", 0 );
		}
	},

	_appendTo: function() {
		var element = this.options.appendTo;

		if ( element ) {
			element = element.jquery || element.nodeType ?
				$( element ) :
				this.document.find( element ).eq( 0 );
		}

		if ( !element || !element[ 0 ] ) {
			element = this.element.closest( ".ui-front, dialog" );
		}

		if ( !element.length ) {
			element = this.document[ 0 ].body;
		}

		return element;
	},

	_toggleAttr: function() {
		this.button.attr( "aria-expanded", this.isOpen );

		// We can't use two _toggleClass() calls here, because we need to make sure
		// we always remove classes first and add them second, otherwise if both classes have the
		// same theme class, it will be removed after we add it.
		this._removeClass( this.button, "ui-selectmenu-button-" +
			( this.isOpen ? "closed" : "open" ) )
			._addClass( this.button, "ui-selectmenu-button-" +
				( this.isOpen ? "open" : "closed" ) )
			._toggleClass( this.menuWrap, "ui-selectmenu-open", null, this.isOpen );

		this.menu.attr( "aria-hidden", !this.isOpen );
	},

	_resizeButton: function() {
		var width = this.options.width;

		// For `width: false`, just remove inline style and stop
		if ( width === false ) {
			this.button.css( "width", "" );
			return;
		}

		// For `width: null`, match the width of the original element
		if ( width === null ) {
			width = this.element.show().outerWidth();
			this.element.hide();
		}

		this.button.outerWidth( width );
	},

	_resizeMenu: function() {
		this.menu.outerWidth( Math.max(
			this.button.outerWidth(),
			this.menu.width( "" ).outerWidth()
		) );
	},

	_getCreateOptions: function() {
		var options = this._super();

		options.disabled = this.element.prop( "disabled" );

		return options;
	},

	_parseOptions: function( options ) {
		var that = this,
			data = [];
		options.each( function( index, item ) {
			data.push( that._parseOption( $( item ), index ) );
		} );
		this.items = data;
	},

	_parseOption: function( option, index ) {
		var optgroup = option.parent( "optgroup" );

		return {
			element: option,
			index: index,
			value: option.val(),
			label: option.text(),
			hidden: optgroup.prop( "hidden" ) || option.prop( "hidden" ),
			optgroup: optgroup.attr( "label" ) || "",
			disabled: optgroup.prop( "disabled" ) || option.prop( "disabled" )
		};
	},

	_destroy: function() {
		this._unbindFormResetHandler();
		this.menuWrap.remove();
		this.button.remove();
		this.element.show();
		this.element.removeUniqueId();
		this.labels.attr( "for", this.ids.element );
	}
} ] );


/*!
 * jQuery UI Slider 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Slider
//>>group: Widgets
//>>description: Displays a flexible slider with ranges and accessibility via keyboard.
//>>docs: https://api.jqueryui.com/slider/
//>>demos: https://jqueryui.com/slider/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/slider.css
//>>css.theme: ../../themes/base/theme.css


var widgetsSlider = $.widget( "ui.slider", $.ui.mouse, {
	version: "1.14.1",
	widgetEventPrefix: "slide",

	options: {
		animate: false,
		classes: {
			"ui-slider": "ui-corner-all",
			"ui-slider-handle": "ui-corner-all",

			// Note: ui-widget-header isn't the most fittingly semantic framework class for this
			// element, but worked best visually with a variety of themes
			"ui-slider-range": "ui-corner-all ui-widget-header"
		},
		distance: 0,
		max: 100,
		min: 0,
		orientation: "horizontal",
		range: false,
		step: 1,
		value: 0,
		values: null,

		// Callbacks
		change: null,
		slide: null,
		start: null,
		stop: null
	},

	// Number of pages in a slider
	// (how many times can you page up/down to go through the whole range)
	numPages: 5,

	_create: function() {
		this._keySliding = false;
		this._mouseSliding = false;
		this._animateOff = true;
		this._handleIndex = null;
		this._detectOrientation();
		this._mouseInit();
		this._calculateNewMax();

		this._addClass( "ui-slider ui-slider-" + this.orientation,
			"ui-widget ui-widget-content" );

		this._refresh();

		this._animateOff = false;
	},

	_refresh: function() {
		this._createRange();
		this._createHandles();
		this._setupEvents();
		this._refreshValue();
	},

	_createHandles: function() {
		var i, handleCount,
			options = this.options,
			existingHandles = this.element.find( ".ui-slider-handle" ),
			handle = "<span tabindex='0'></span>",
			handles = [];

		handleCount = ( options.values && options.values.length ) || 1;

		if ( existingHandles.length > handleCount ) {
			existingHandles.slice( handleCount ).remove();
			existingHandles = existingHandles.slice( 0, handleCount );
		}

		for ( i = existingHandles.length; i < handleCount; i++ ) {
			handles.push( handle );
		}

		this.handles = existingHandles.add( $( handles.join( "" ) ).appendTo( this.element ) );

		this._addClass( this.handles, "ui-slider-handle", "ui-state-default" );

		this.handle = this.handles.eq( 0 );

		this.handles.each( function( i ) {
			$( this )
				.data( "ui-slider-handle-index", i )
				.attr( "tabIndex", 0 );
		} );
	},

	_createRange: function() {
		var options = this.options;

		if ( options.range ) {
			if ( options.range === true ) {
				if ( !options.values ) {
					options.values = [ this._valueMin(), this._valueMin() ];
				} else if ( options.values.length && options.values.length !== 2 ) {
					options.values = [ options.values[ 0 ], options.values[ 0 ] ];
				} else if ( Array.isArray( options.values ) ) {
					options.values = options.values.slice( 0 );
				}
			}

			if ( !this.range || !this.range.length ) {
				this.range = $( "<div>" )
					.appendTo( this.element );

				this._addClass( this.range, "ui-slider-range" );
			} else {
				this._removeClass( this.range, "ui-slider-range-min ui-slider-range-max" );

				// Handle range switching from true to min/max
				this.range.css( {
					"left": "",
					"bottom": ""
				} );
			}
			if ( options.range === "min" || options.range === "max" ) {
				this._addClass( this.range, "ui-slider-range-" + options.range );
			}
		} else {
			if ( this.range ) {
				this.range.remove();
			}
			this.range = null;
		}
	},

	_setupEvents: function() {
		this._off( this.handles );
		this._on( this.handles, this._handleEvents );
		this._hoverable( this.handles );
		this._focusable( this.handles );
	},

	_destroy: function() {
		this.handles.remove();
		if ( this.range ) {
			this.range.remove();
		}

		this._mouseDestroy();
	},

	_mouseCapture: function( event ) {
		var position, normValue, distance, closestHandle, index, allowed, offset, mouseOverHandle,
			that = this,
			o = this.options;

		if ( o.disabled ) {
			return false;
		}

		this.elementSize = {
			width: this.element.outerWidth(),
			height: this.element.outerHeight()
		};
		this.elementOffset = this.element.offset();

		position = { x: event.pageX, y: event.pageY };
		normValue = this._normValueFromMouse( position );
		distance = this._valueMax() - this._valueMin() + 1;
		this.handles.each( function( i ) {
			var thisDistance = Math.abs( normValue - that.values( i ) );
			if ( ( distance > thisDistance ) ||
				( distance === thisDistance &&
					( i === that._lastChangedValue || that.values( i ) === o.min ) ) ) {
				distance = thisDistance;
				closestHandle = $( this );
				index = i;
			}
		} );

		allowed = this._start( event, index );
		if ( allowed === false ) {
			return false;
		}
		this._mouseSliding = true;

		this._handleIndex = index;

		this._addClass( closestHandle, null, "ui-state-active" );
		closestHandle.trigger( "focus" );

		offset = closestHandle.offset();
		mouseOverHandle = !$( event.target ).parents().addBack().is( ".ui-slider-handle" );
		this._clickOffset = mouseOverHandle ? { left: 0, top: 0 } : {
			left: event.pageX - offset.left - ( closestHandle.width() / 2 ),
			top: event.pageY - offset.top -
				( closestHandle.height() / 2 ) -
				( parseInt( closestHandle.css( "borderTopWidth" ), 10 ) || 0 ) -
				( parseInt( closestHandle.css( "borderBottomWidth" ), 10 ) || 0 ) +
				( parseInt( closestHandle.css( "marginTop" ), 10 ) || 0 )
		};

		if ( !this.handles.hasClass( "ui-state-hover" ) ) {
			this._slide( event, index, normValue );
		}
		this._animateOff = true;
		return true;
	},

	_mouseStart: function() {
		return true;
	},

	_mouseDrag: function( event ) {
		var position = { x: event.pageX, y: event.pageY },
			normValue = this._normValueFromMouse( position );

		this._slide( event, this._handleIndex, normValue );

		return false;
	},

	_mouseStop: function( event ) {
		this._removeClass( this.handles, null, "ui-state-active" );
		this._mouseSliding = false;

		this._stop( event, this._handleIndex );
		this._change( event, this._handleIndex );

		this._handleIndex = null;
		this._clickOffset = null;
		this._animateOff = false;

		return false;
	},

	_detectOrientation: function() {
		this.orientation = ( this.options.orientation === "vertical" ) ? "vertical" : "horizontal";
	},

	_normValueFromMouse: function( position ) {
		var pixelTotal,
			pixelMouse,
			percentMouse,
			valueTotal,
			valueMouse;

		if ( this.orientation === "horizontal" ) {
			pixelTotal = this.elementSize.width;
			pixelMouse = position.x - this.elementOffset.left -
				( this._clickOffset ? this._clickOffset.left : 0 );
		} else {
			pixelTotal = this.elementSize.height;
			pixelMouse = position.y - this.elementOffset.top -
				( this._clickOffset ? this._clickOffset.top : 0 );
		}

		percentMouse = ( pixelMouse / pixelTotal );
		if ( percentMouse > 1 ) {
			percentMouse = 1;
		}
		if ( percentMouse < 0 ) {
			percentMouse = 0;
		}
		if ( this.orientation === "vertical" ) {
			percentMouse = 1 - percentMouse;
		}

		valueTotal = this._valueMax() - this._valueMin();
		valueMouse = this._valueMin() + percentMouse * valueTotal;

		return this._trimAlignValue( valueMouse );
	},

	_uiHash: function( index, value, values ) {
		var uiHash = {
			handle: this.handles[ index ],
			handleIndex: index,
			value: value !== undefined ? value : this.value()
		};

		if ( this._hasMultipleValues() ) {
			uiHash.value = value !== undefined ? value : this.values( index );
			uiHash.values = values || this.values();
		}

		return uiHash;
	},

	_hasMultipleValues: function() {
		return this.options.values && this.options.values.length;
	},

	_start: function( event, index ) {
		return this._trigger( "start", event, this._uiHash( index ) );
	},

	_slide: function( event, index, newVal ) {
		var allowed, otherVal,
			currentValue = this.value(),
			newValues = this.values();

		if ( this._hasMultipleValues() ) {
			otherVal = this.values( index ? 0 : 1 );
			currentValue = this.values( index );

			if ( this.options.values.length === 2 && this.options.range === true ) {
				newVal =  index === 0 ? Math.min( otherVal, newVal ) : Math.max( otherVal, newVal );
			}

			newValues[ index ] = newVal;
		}

		if ( newVal === currentValue ) {
			return;
		}

		allowed = this._trigger( "slide", event, this._uiHash( index, newVal, newValues ) );

		// A slide can be canceled by returning false from the slide callback
		if ( allowed === false ) {
			return;
		}

		if ( this._hasMultipleValues() ) {
			this.values( index, newVal );
		} else {
			this.value( newVal );
		}
	},

	_stop: function( event, index ) {
		this._trigger( "stop", event, this._uiHash( index ) );
	},

	_change: function( event, index ) {
		if ( !this._keySliding && !this._mouseSliding ) {

			//store the last changed value index for reference when handles overlap
			this._lastChangedValue = index;
			this._trigger( "change", event, this._uiHash( index ) );
		}
	},

	value: function( newValue ) {
		if ( arguments.length ) {
			this.options.value = this._trimAlignValue( newValue );
			this._refreshValue();
			this._change( null, 0 );
			return;
		}

		return this._value();
	},

	values: function( index, newValue ) {
		var vals,
			newValues,
			i;

		if ( arguments.length > 1 ) {
			this.options.values[ index ] = this._trimAlignValue( newValue );
			this._refreshValue();
			this._change( null, index );
			return;
		}

		if ( arguments.length ) {
			if ( Array.isArray( arguments[ 0 ] ) ) {
				vals = this.options.values;
				newValues = arguments[ 0 ];
				for ( i = 0; i < vals.length; i += 1 ) {
					vals[ i ] = this._trimAlignValue( newValues[ i ] );
					this._change( null, i );
				}
				this._refreshValue();
			} else {
				if ( this._hasMultipleValues() ) {
					return this._values( index );
				} else {
					return this.value();
				}
			}
		} else {
			return this._values();
		}
	},

	_setOption: function( key, value ) {
		var i,
			valsLength = 0;

		if ( key === "range" && this.options.range === true ) {
			if ( value === "min" ) {
				this.options.value = this._values( 0 );
				this.options.values = null;
			} else if ( value === "max" ) {
				this.options.value = this._values( this.options.values.length - 1 );
				this.options.values = null;
			}
		}

		if ( Array.isArray( this.options.values ) ) {
			valsLength = this.options.values.length;
		}

		this._super( key, value );

		switch ( key ) {
			case "orientation":
				this._detectOrientation();
				this._removeClass( "ui-slider-horizontal ui-slider-vertical" )
					._addClass( "ui-slider-" + this.orientation );
				this._refreshValue();
				if ( this.options.range ) {
					this._refreshRange( value );
				}

				// Reset positioning from previous orientation
				this.handles.css( value === "horizontal" ? "bottom" : "left", "" );
				break;
			case "value":
				this._animateOff = true;
				this._refreshValue();
				this._change( null, 0 );
				this._animateOff = false;
				break;
			case "values":
				this._animateOff = true;
				this._refreshValue();

				// Start from the last handle to prevent unreachable handles (#9046)
				for ( i = valsLength - 1; i >= 0; i-- ) {
					this._change( null, i );
				}
				this._animateOff = false;
				break;
			case "step":
			case "min":
			case "max":
				this._animateOff = true;
				this._calculateNewMax();
				this._refreshValue();
				this._animateOff = false;
				break;
			case "range":
				this._animateOff = true;
				this._refresh();
				this._animateOff = false;
				break;
		}
	},

	_setOptionDisabled: function( value ) {
		this._super( value );

		this._toggleClass( null, "ui-state-disabled", !!value );
	},

	//internal value getter
	// _value() returns value trimmed by min and max, aligned by step
	_value: function() {
		var val = this.options.value;
		val = this._trimAlignValue( val );

		return val;
	},

	//internal values getter
	// _values() returns array of values trimmed by min and max, aligned by step
	// _values( index ) returns single value trimmed by min and max, aligned by step
	_values: function( index ) {
		var val,
			vals,
			i;

		if ( arguments.length ) {
			val = this.options.values[ index ];
			val = this._trimAlignValue( val );

			return val;
		} else if ( this._hasMultipleValues() ) {

			// .slice() creates a copy of the array
			// this copy gets trimmed by min and max and then returned
			vals = this.options.values.slice();
			for ( i = 0; i < vals.length; i += 1 ) {
				vals[ i ] = this._trimAlignValue( vals[ i ] );
			}

			return vals;
		} else {
			return [];
		}
	},

	// Returns the step-aligned value that val is closest to, between (inclusive) min and max
	_trimAlignValue: function( val ) {
		if ( val <= this._valueMin() ) {
			return this._valueMin();
		}
		if ( val >= this._valueMax() ) {
			return this._valueMax();
		}
		var step = ( this.options.step > 0 ) ? this.options.step : 1,
			valModStep = ( val - this._valueMin() ) % step,
			alignValue = val - valModStep;

		if ( Math.abs( valModStep ) * 2 >= step ) {
			alignValue += ( valModStep > 0 ) ? step : ( -step );
		}

		// Since JavaScript has problems with large floats, round
		// the final value to 5 digits after the decimal point (see #4124)
		return parseFloat( alignValue.toFixed( 5 ) );
	},

	_calculateNewMax: function() {
		var max = this.options.max,
			min = this._valueMin(),
			step = this.options.step,
			aboveMin = Math.round( ( max - min ) / step ) * step;
		max = aboveMin + min;
		if ( max > this.options.max ) {

			//If max is not divisible by step, rounding off may increase its value
			max -= step;
		}
		this.max = parseFloat( max.toFixed( this._precision() ) );
	},

	_precision: function() {
		var precision = this._precisionOf( this.options.step );
		if ( this.options.min !== null ) {
			precision = Math.max( precision, this._precisionOf( this.options.min ) );
		}
		return precision;
	},

	_precisionOf: function( num ) {
		var str = num.toString(),
			decimal = str.indexOf( "." );
		return decimal === -1 ? 0 : str.length - decimal - 1;
	},

	_valueMin: function() {
		return this.options.min;
	},

	_valueMax: function() {
		return this.max;
	},

	_refreshRange: function( orientation ) {
		if ( orientation === "vertical" ) {
			this.range.css( { "width": "", "left": "" } );
		}
		if ( orientation === "horizontal" ) {
			this.range.css( { "height": "", "bottom": "" } );
		}
	},

	_refreshValue: function() {
		var lastValPercent, valPercent, value, valueMin, valueMax,
			oRange = this.options.range,
			o = this.options,
			that = this,
			animate = ( !this._animateOff ) ? o.animate : false,
			_set = {};

		if ( this._hasMultipleValues() ) {
			this.handles.each( function( i ) {
				valPercent = ( that.values( i ) - that._valueMin() ) / ( that._valueMax() -
					that._valueMin() ) * 100;
				_set[ that.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
				$( this ).stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );
				if ( that.options.range === true ) {
					if ( that.orientation === "horizontal" ) {
						if ( i === 0 ) {
							that.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
								left: valPercent + "%"
							}, o.animate );
						}
						if ( i === 1 ) {
							that.range[ animate ? "animate" : "css" ]( {
								width: ( valPercent - lastValPercent ) + "%"
							}, {
								queue: false,
								duration: o.animate
							} );
						}
					} else {
						if ( i === 0 ) {
							that.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
								bottom: ( valPercent ) + "%"
							}, o.animate );
						}
						if ( i === 1 ) {
							that.range[ animate ? "animate" : "css" ]( {
								height: ( valPercent - lastValPercent ) + "%"
							}, {
								queue: false,
								duration: o.animate
							} );
						}
					}
				}
				lastValPercent = valPercent;
			} );
		} else {
			value = this.value();
			valueMin = this._valueMin();
			valueMax = this._valueMax();
			valPercent = ( valueMax !== valueMin ) ?
					( value - valueMin ) / ( valueMax - valueMin ) * 100 :
					0;
			_set[ this.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
			this.handle.stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );

			if ( oRange === "min" && this.orientation === "horizontal" ) {
				this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
					width: valPercent + "%"
				}, o.animate );
			}
			if ( oRange === "max" && this.orientation === "horizontal" ) {
				this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
					width: ( 100 - valPercent ) + "%"
				}, o.animate );
			}
			if ( oRange === "min" && this.orientation === "vertical" ) {
				this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
					height: valPercent + "%"
				}, o.animate );
			}
			if ( oRange === "max" && this.orientation === "vertical" ) {
				this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
					height: ( 100 - valPercent ) + "%"
				}, o.animate );
			}
		}
	},

	_handleEvents: {
		keydown: function( event ) {
			var allowed, curVal, newVal, step,
				index = $( event.target ).data( "ui-slider-handle-index" );

			switch ( event.keyCode ) {
				case $.ui.keyCode.HOME:
				case $.ui.keyCode.END:
				case $.ui.keyCode.PAGE_UP:
				case $.ui.keyCode.PAGE_DOWN:
				case $.ui.keyCode.UP:
				case $.ui.keyCode.RIGHT:
				case $.ui.keyCode.DOWN:
				case $.ui.keyCode.LEFT:
					event.preventDefault();
					if ( !this._keySliding ) {
						this._keySliding = true;
						this._addClass( $( event.target ), null, "ui-state-active" );
						allowed = this._start( event, index );
						if ( allowed === false ) {
							return;
						}
					}
					break;
			}

			step = this.options.step;
			if ( this._hasMultipleValues() ) {
				curVal = newVal = this.values( index );
			} else {
				curVal = newVal = this.value();
			}

			switch ( event.keyCode ) {
				case $.ui.keyCode.HOME:
					newVal = this._valueMin();
					break;
				case $.ui.keyCode.END:
					newVal = this._valueMax();
					break;
				case $.ui.keyCode.PAGE_UP:
					newVal = this._trimAlignValue(
						curVal + ( ( this._valueMax() - this._valueMin() ) / this.numPages )
					);
					break;
				case $.ui.keyCode.PAGE_DOWN:
					newVal = this._trimAlignValue(
						curVal - ( ( this._valueMax() - this._valueMin() ) / this.numPages ) );
					break;
				case $.ui.keyCode.UP:
				case $.ui.keyCode.RIGHT:
					if ( curVal === this._valueMax() ) {
						return;
					}
					newVal = this._trimAlignValue( curVal + step );
					break;
				case $.ui.keyCode.DOWN:
				case $.ui.keyCode.LEFT:
					if ( curVal === this._valueMin() ) {
						return;
					}
					newVal = this._trimAlignValue( curVal - step );
					break;
			}

			this._slide( event, index, newVal );
		},
		keyup: function( event ) {
			var index = $( event.target ).data( "ui-slider-handle-index" );

			if ( this._keySliding ) {
				this._keySliding = false;
				this._stop( event, index );
				this._change( event, index );
				this._removeClass( $( event.target ), null, "ui-state-active" );
			}
		}
	}
} );


/*!
 * jQuery UI Sortable 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Sortable
//>>group: Interactions
//>>description: Enables items in a list to be sorted using the mouse.
//>>docs: https://api.jqueryui.com/sortable/
//>>demos: https://jqueryui.com/sortable/
//>>css.structure: ../../themes/base/sortable.css


var widgetsSortable = $.widget( "ui.sortable", $.ui.mouse, {
	version: "1.14.1",
	widgetEventPrefix: "sort",
	ready: false,
	options: {
		appendTo: "parent",
		axis: false,
		connectWith: false,
		containment: false,
		cursor: "auto",
		cursorAt: false,
		dropOnEmpty: true,
		forcePlaceholderSize: false,
		forceHelperSize: false,
		grid: false,
		handle: false,
		helper: "original",
		items: "> *",
		opacity: false,
		placeholder: false,
		revert: false,
		scroll: true,
		scrollSensitivity: 20,
		scrollSpeed: 20,
		scope: "default",
		tolerance: "intersect",
		zIndex: 1000,

		// Callbacks
		activate: null,
		beforeStop: null,
		change: null,
		deactivate: null,
		out: null,
		over: null,
		receive: null,
		remove: null,
		sort: null,
		start: null,
		stop: null,
		update: null
	},

	_isOverAxis: function( x, reference, size ) {
		return ( x >= reference ) && ( x < ( reference + size ) );
	},

	_isFloating: function( item ) {
		return ( /left|right/ ).test( item.css( "float" ) ) ||
			( /inline|table-cell/ ).test( item.css( "display" ) );
	},

	_create: function() {
		this.containerCache = {};
		this._addClass( "ui-sortable" );

		//Get the items
		this.refresh();

		//Let's determine the parent's offset
		this.offset = this.element.offset();

		//Initialize mouse events for interaction
		this._mouseInit();

		this._setHandleClassName();

		//We're ready to go
		this.ready = true;

	},

	_setOption: function( key, value ) {
		this._super( key, value );

		if ( key === "handle" ) {
			this._setHandleClassName();
		}
	},

	_setHandleClassName: function() {
		var that = this;
		this._removeClass( this.element.find( ".ui-sortable-handle" ), "ui-sortable-handle" );
		$.each( this.items, function() {
			that._addClass(
				this.instance.options.handle ?
					this.item.find( this.instance.options.handle ) :
					this.item,
				"ui-sortable-handle"
			);
		} );
	},

	_destroy: function() {
		this._mouseDestroy();

		for ( var i = this.items.length - 1; i >= 0; i-- ) {
			this.items[ i ].item.removeData( this.widgetName + "-item" );
		}

		return this;
	},

	_mouseCapture: function( event, overrideHandle ) {
		var currentItem = null,
			validHandle = false,
			that = this;

		if ( this.reverting ) {
			return false;
		}

		if ( this.options.disabled || this.options.type === "static" ) {
			return false;
		}

		//We have to refresh the items data once first
		this._refreshItems( event );

		//Find out if the clicked node (or one of its parents) is a actual item in this.items
		$( event.target ).parents().each( function() {
			if ( $.data( this, that.widgetName + "-item" ) === that ) {
				currentItem = $( this );
				return false;
			}
		} );
		if ( $.data( event.target, that.widgetName + "-item" ) === that ) {
			currentItem = $( event.target );
		}

		if ( !currentItem ) {
			return false;
		}
		if ( this.options.handle && !overrideHandle ) {
			$( this.options.handle, currentItem ).find( "*" ).addBack().each( function() {
				if ( this === event.target ) {
					validHandle = true;
				}
			} );
			if ( !validHandle ) {
				return false;
			}
		}

		this.currentItem = currentItem;
		this._removeCurrentsFromItems();
		return true;

	},

	_mouseStart: function( event, overrideHandle, noActivation ) {

		var i, body,
			o = this.options;

		this.currentContainer = this;

		//We only need to call refreshPositions, because the refreshItems call has been moved to
		// mouseCapture
		this.refreshPositions();

		//Prepare the dragged items parent
		this.appendTo = $( o.appendTo !== "parent" ?
				o.appendTo :
				this.currentItem.parent() );

		//Create and append the visible helper
		this.helper = this._createHelper( event );

		//Cache the helper size
		this._cacheHelperProportions();

		/*
		 * - Position generation -
		 * This block generates everything position related - it's the core of draggables.
		 */

		//Cache the margins of the original element
		this._cacheMargins();

		//The element's absolute position on the page minus margins
		this.offset = this.currentItem.offset();
		this.offset = {
			top: this.offset.top - this.margins.top,
			left: this.offset.left - this.margins.left
		};

		$.extend( this.offset, {
			click: { //Where the click happened, relative to the element
				left: event.pageX - this.offset.left,
				top: event.pageY - this.offset.top
			},

			// This is a relative to absolute position minus the actual position calculation -
			// only used for relative positioned helper
			relative: this._getRelativeOffset()
		} );

		// After we get the helper offset, but before we get the parent offset we can
		// change the helper's position to absolute
		// TODO: Still need to figure out a way to make relative sorting possible
		this.helper.css( "position", "absolute" );
		this.cssPosition = this.helper.css( "position" );

		//Adjust the mouse offset relative to the helper if "cursorAt" is supplied
		if ( o.cursorAt ) {
			this._adjustOffsetFromHelper( o.cursorAt );
		}

		//Cache the former DOM position
		this.domPosition = {
			prev: this.currentItem.prev()[ 0 ],
			parent: this.currentItem.parent()[ 0 ]
		};

		// If the helper is not the original, hide the original so it's not playing any role during
		// the drag, won't cause anything bad this way
		if ( this.helper[ 0 ] !== this.currentItem[ 0 ] ) {
			this.currentItem.hide();
		}

		//Create the placeholder
		this._createPlaceholder();

		//Get the next scrolling parent
		this.scrollParent = this.placeholder.scrollParent();

		$.extend( this.offset, {
			parent: this._getParentOffset()
		} );

		//Set a containment if given in the options
		if ( o.containment ) {
			this._setContainment();
		}

		if ( o.cursor && o.cursor !== "auto" ) { // cursor option
			body = this.document.find( "body" );

			this._storedStylesheet =
				$( "<style>*{ cursor: " + o.cursor + " !important; }</style>" ).appendTo( body );
		}

		// We need to make sure to grab the zIndex before setting the
		// opacity, because setting the opacity to anything lower than 1
		// causes the zIndex to change from "auto" to 0.
		if ( o.zIndex ) { // zIndex option
			if ( this.helper.css( "zIndex" ) ) {
				this._storedZIndex = this.helper.css( "zIndex" );
			}
			this.helper.css( "zIndex", o.zIndex );
		}

		if ( o.opacity ) { // opacity option
			if ( this.helper.css( "opacity" ) ) {
				this._storedOpacity = this.helper.css( "opacity" );
			}
			this.helper.css( "opacity", o.opacity );
		}

		//Prepare scrolling
		if ( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				this.scrollParent[ 0 ].tagName !== "HTML" ) {
			this.overflowOffset = this.scrollParent.offset();
		}

		//Call callbacks
		this._trigger( "start", event, this._uiHash() );

		//Recache the helper size
		if ( !this._preserveHelperProportions ) {
			this._cacheHelperProportions();
		}

		//Post "activate" events to possible containers
		if ( !noActivation ) {
			for ( i = this.containers.length - 1; i >= 0; i-- ) {
				this.containers[ i ]._trigger( "activate", event, this._uiHash( this ) );
			}
		}

		//Prepare possible droppables
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.current = this;
		}

		if ( $.ui.ddmanager && !o.dropBehaviour ) {
			$.ui.ddmanager.prepareOffsets( this, event );
		}

		this.dragging = true;

		this._addClass( this.helper, "ui-sortable-helper" );

		//Move the helper, if needed
		if ( !this.helper.parent().is( this.appendTo ) ) {
			this.helper.detach().appendTo( this.appendTo );

			//Update position
			this.offset.parent = this._getParentOffset();
		}

		//Generate the original position
		this.position = this.originalPosition = this._generatePosition( event );
		this.originalPageX = event.pageX;
		this.originalPageY = event.pageY;
		this.lastPositionAbs = this.positionAbs = this._convertPositionTo( "absolute" );

		this._mouseDrag( event );

		return true;

	},

	_scroll: function( event ) {
		var o = this.options,
			scrolled = false;

		if ( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				this.scrollParent[ 0 ].tagName !== "HTML" ) {

			if ( ( this.overflowOffset.top + this.scrollParent[ 0 ].offsetHeight ) -
					event.pageY < o.scrollSensitivity ) {
				this.scrollParent[ 0 ].scrollTop =
					scrolled = this.scrollParent[ 0 ].scrollTop + o.scrollSpeed;
			} else if ( event.pageY - this.overflowOffset.top < o.scrollSensitivity ) {
				this.scrollParent[ 0 ].scrollTop =
					scrolled = this.scrollParent[ 0 ].scrollTop - o.scrollSpeed;
			}

			if ( ( this.overflowOffset.left + this.scrollParent[ 0 ].offsetWidth ) -
					event.pageX < o.scrollSensitivity ) {
				this.scrollParent[ 0 ].scrollLeft = scrolled =
					this.scrollParent[ 0 ].scrollLeft + o.scrollSpeed;
			} else if ( event.pageX - this.overflowOffset.left < o.scrollSensitivity ) {
				this.scrollParent[ 0 ].scrollLeft = scrolled =
					this.scrollParent[ 0 ].scrollLeft - o.scrollSpeed;
			}

		} else {

			if ( event.pageY - this.document.scrollTop() < o.scrollSensitivity ) {
				scrolled = this.document.scrollTop( this.document.scrollTop() - o.scrollSpeed );
			} else if ( this.window.height() - ( event.pageY - this.document.scrollTop() ) <
					o.scrollSensitivity ) {
				scrolled = this.document.scrollTop( this.document.scrollTop() + o.scrollSpeed );
			}

			if ( event.pageX - this.document.scrollLeft() < o.scrollSensitivity ) {
				scrolled = this.document.scrollLeft(
					this.document.scrollLeft() - o.scrollSpeed
				);
			} else if ( this.window.width() - ( event.pageX - this.document.scrollLeft() ) <
					o.scrollSensitivity ) {
				scrolled = this.document.scrollLeft(
					this.document.scrollLeft() + o.scrollSpeed
				);
			}

		}

		return scrolled;
	},

	_mouseDrag: function( event ) {
		var i, item, itemElement, intersection,
			o = this.options;

		//Compute the helpers position
		this.position = this._generatePosition( event );
		this.positionAbs = this._convertPositionTo( "absolute" );

		//Set the helper position
		if ( !this.options.axis || this.options.axis !== "y" ) {
			this.helper[ 0 ].style.left = this.position.left + "px";
		}
		if ( !this.options.axis || this.options.axis !== "x" ) {
			this.helper[ 0 ].style.top = this.position.top + "px";
		}

		//Do scrolling
		if ( o.scroll ) {
			if ( this._scroll( event ) !== false ) {

				//Update item positions used in position checks
				this._refreshItemPositions( true );

				if ( $.ui.ddmanager && !o.dropBehaviour ) {
					$.ui.ddmanager.prepareOffsets( this, event );
				}
			}
		}

		this.dragDirection = {
			vertical: this._getDragVerticalDirection(),
			horizontal: this._getDragHorizontalDirection()
		};

		//Rearrange
		for ( i = this.items.length - 1; i >= 0; i-- ) {

			//Cache variables and intersection, continue if no intersection
			item = this.items[ i ];
			itemElement = item.item[ 0 ];
			intersection = this._intersectsWithPointer( item );
			if ( !intersection ) {
				continue;
			}

			// Only put the placeholder inside the current Container, skip all
			// items from other containers. This works because when moving
			// an item from one container to another the
			// currentContainer is switched before the placeholder is moved.
			//
			// Without this, moving items in "sub-sortables" can cause
			// the placeholder to jitter between the outer and inner container.
			if ( item.instance !== this.currentContainer ) {
				continue;
			}

			// Cannot intersect with itself
			// no useless actions that have been done before
			// no action if the item moved is the parent of the item checked
			if ( itemElement !== this.currentItem[ 0 ] &&
				this.placeholder[ intersection === 1 ?
				"next" : "prev" ]()[ 0 ] !== itemElement &&
				!$.contains( this.placeholder[ 0 ], itemElement ) &&
				( this.options.type === "semi-dynamic" ?
					!$.contains( this.element[ 0 ], itemElement ) :
					true
				)
			) {

				this.direction = intersection === 1 ? "down" : "up";

				if ( this.options.tolerance === "pointer" ||
						this._intersectsWithSides( item ) ) {
					this._rearrange( event, item );
				} else {
					break;
				}

				this._trigger( "change", event, this._uiHash() );
				break;
			}
		}

		//Post events to containers
		this._contactContainers( event );

		//Interconnect with droppables
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.drag( this, event );
		}

		//Call callbacks
		this._trigger( "sort", event, this._uiHash() );

		this.lastPositionAbs = this.positionAbs;
		return false;

	},

	_mouseStop: function( event, noPropagation ) {

		if ( !event ) {
			return;
		}

		//If we are using droppables, inform the manager about the drop
		if ( $.ui.ddmanager && !this.options.dropBehaviour ) {
			$.ui.ddmanager.drop( this, event );
		}

		if ( this.options.revert ) {
			var that = this,
				cur = this.placeholder.offset(),
				axis = this.options.axis,
				animation = {};

			if ( !axis || axis === "x" ) {
				animation.left = cur.left - this.offset.parent.left - this.margins.left +
					( this.offsetParent[ 0 ] === this.document[ 0 ].body ?
						0 :
						this.offsetParent[ 0 ].scrollLeft
					);
			}
			if ( !axis || axis === "y" ) {
				animation.top = cur.top - this.offset.parent.top - this.margins.top +
					( this.offsetParent[ 0 ] === this.document[ 0 ].body ?
						0 :
						this.offsetParent[ 0 ].scrollTop
					);
			}
			this.reverting = true;
			$( this.helper ).animate(
				animation,
				parseInt( this.options.revert, 10 ) || 500,
				function() {
					that._clear( event );
				}
			);
		} else {
			this._clear( event, noPropagation );
		}

		return false;

	},

	cancel: function() {

		if ( this.dragging ) {

			this._mouseUp( new $.Event( "mouseup", { target: null } ) );

			if ( this.options.helper === "original" ) {
				this.currentItem.css( this._storedCSS );
				this._removeClass( this.currentItem, "ui-sortable-helper" );
			} else {
				this.currentItem.show();
			}

			//Post deactivating events to containers
			for ( var i = this.containers.length - 1; i >= 0; i-- ) {
				this.containers[ i ]._trigger( "deactivate", null, this._uiHash( this ) );
				if ( this.containers[ i ].containerCache.over ) {
					this.containers[ i ]._trigger( "out", null, this._uiHash( this ) );
					this.containers[ i ].containerCache.over = 0;
				}
			}

		}

		if ( this.placeholder ) {

			//$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately,
			// it unbinds ALL events from the original node!
			if ( this.placeholder[ 0 ].parentNode ) {
				this.placeholder[ 0 ].parentNode.removeChild( this.placeholder[ 0 ] );
			}
			if ( this.options.helper !== "original" && this.helper &&
					this.helper[ 0 ].parentNode ) {
				this.helper.remove();
			}

			$.extend( this, {
				helper: null,
				dragging: false,
				reverting: false,
				_noFinalSort: null
			} );

			if ( this.domPosition.prev ) {
				$( this.domPosition.prev ).after( this.currentItem );
			} else {
				$( this.domPosition.parent ).prepend( this.currentItem );
			}
		}

		return this;

	},

	serialize: function( o ) {

		var items = this._getItemsAsjQuery( o && o.connected ),
			str = [];
		o = o || {};

		$( items ).each( function() {
			var res = ( $( o.item || this ).attr( o.attribute || "id" ) || "" )
				.match( o.expression || ( /(.+)[\-=_](.+)/ ) );
			if ( res ) {
				str.push(
					( o.key || res[ 1 ] + "[]" ) +
					"=" + ( o.key && o.expression ? res[ 1 ] : res[ 2 ] ) );
			}
		} );

		if ( !str.length && o.key ) {
			str.push( o.key + "=" );
		}

		return str.join( "&" );

	},

	toArray: function( o ) {

		var items = this._getItemsAsjQuery( o && o.connected ),
			ret = [];

		o = o || {};

		items.each( function() {
			ret.push( $( o.item || this ).attr( o.attribute || "id" ) || "" );
		} );
		return ret;

	},

	/* Be careful with the following core functions */
	_intersectsWith: function( item ) {

		var x1 = this.positionAbs.left,
			x2 = x1 + this.helperProportions.width,
			y1 = this.positionAbs.top,
			y2 = y1 + this.helperProportions.height,
			l = item.left,
			r = l + item.width,
			t = item.top,
			b = t + item.height,
			dyClick = this.offset.click.top,
			dxClick = this.offset.click.left,
			isOverElementHeight = ( this.options.axis === "x" ) || ( ( y1 + dyClick ) > t &&
				( y1 + dyClick ) < b ),
			isOverElementWidth = ( this.options.axis === "y" ) || ( ( x1 + dxClick ) > l &&
				( x1 + dxClick ) < r ),
			isOverElement = isOverElementHeight && isOverElementWidth;

		if ( this.options.tolerance === "pointer" ||
			this.options.forcePointerForContainers ||
			( this.options.tolerance !== "pointer" &&
				this.helperProportions[ this.floating ? "width" : "height" ] >
				item[ this.floating ? "width" : "height" ] )
		) {
			return isOverElement;
		} else {

			return ( l < x1 + ( this.helperProportions.width / 2 ) && // Right Half
				x2 - ( this.helperProportions.width / 2 ) < r && // Left Half
				t < y1 + ( this.helperProportions.height / 2 ) && // Bottom Half
				y2 - ( this.helperProportions.height / 2 ) < b ); // Top Half

		}
	},

	_intersectsWithPointer: function( item ) {
		var verticalDirection, horizontalDirection,
			isOverElementHeight = ( this.options.axis === "x" ) ||
				this._isOverAxis(
					this.positionAbs.top + this.offset.click.top, item.top, item.height ),
			isOverElementWidth = ( this.options.axis === "y" ) ||
				this._isOverAxis(
					this.positionAbs.left + this.offset.click.left, item.left, item.width ),
			isOverElement = isOverElementHeight && isOverElementWidth;

		if ( !isOverElement ) {
			return false;
		}

		verticalDirection = this.dragDirection.vertical;
		horizontalDirection = this.dragDirection.horizontal;

		return this.floating ?
			( ( horizontalDirection === "right" || verticalDirection === "down" ) ? 2 : 1 ) :
			( verticalDirection && ( verticalDirection === "down" ? 2 : 1 ) );

	},

	_intersectsWithSides: function( item ) {

		var isOverBottomHalf = this._isOverAxis( this.positionAbs.top +
				this.offset.click.top, item.top + ( item.height / 2 ), item.height ),
			isOverRightHalf = this._isOverAxis( this.positionAbs.left +
				this.offset.click.left, item.left + ( item.width / 2 ), item.width ),
			verticalDirection = this.dragDirection.vertical,
			horizontalDirection = this.dragDirection.horizontal;

		if ( this.floating && horizontalDirection ) {
			return ( ( horizontalDirection === "right" && isOverRightHalf ) ||
				( horizontalDirection === "left" && !isOverRightHalf ) );
		} else {
			return verticalDirection && ( ( verticalDirection === "down" && isOverBottomHalf ) ||
				( verticalDirection === "up" && !isOverBottomHalf ) );
		}

	},

	_getDragVerticalDirection: function() {
		var delta = this.positionAbs.top - this.lastPositionAbs.top;
		return delta !== 0 && ( delta > 0 ? "down" : "up" );
	},

	_getDragHorizontalDirection: function() {
		var delta = this.positionAbs.left - this.lastPositionAbs.left;
		return delta !== 0 && ( delta > 0 ? "right" : "left" );
	},

	refresh: function( event ) {
		this._refreshItems( event );
		this._setHandleClassName();
		this.refreshPositions();
		return this;
	},

	_connectWith: function() {
		var options = this.options;
		return options.connectWith.constructor === String ?
			[ options.connectWith ] :
			options.connectWith;
	},

	_getItemsAsjQuery: function( connected ) {

		var i, j, cur, inst,
			items = [],
			queries = [],
			connectWith = this._connectWith();

		if ( connectWith && connected ) {
			for ( i = connectWith.length - 1; i >= 0; i-- ) {
				cur = $( connectWith[ i ], this.document[ 0 ] );
				for ( j = cur.length - 1; j >= 0; j-- ) {
					inst = $.data( cur[ j ], this.widgetFullName );
					if ( inst && inst !== this && !inst.options.disabled ) {
						queries.push( [ typeof inst.options.items === "function" ?
							inst.options.items.call( inst.element ) :
							$( inst.options.items, inst.element )
								.not( ".ui-sortable-helper" )
								.not( ".ui-sortable-placeholder" ), inst ] );
					}
				}
			}
		}

		queries.push( [ typeof this.options.items === "function" ?
			this.options.items
				.call( this.element, null, { options: this.options, item: this.currentItem } ) :
			$( this.options.items, this.element )
				.not( ".ui-sortable-helper" )
				.not( ".ui-sortable-placeholder" ), this ] );

		function addItems() {
			items.push( this );
		}
		for ( i = queries.length - 1; i >= 0; i-- ) {
			queries[ i ][ 0 ].each( addItems );
		}

		return $( items );

	},

	_removeCurrentsFromItems: function() {

		var list = this.currentItem.find( ":data(" + this.widgetName + "-item)" );

		this.items = $.grep( this.items, function( item ) {
			for ( var j = 0; j < list.length; j++ ) {
				if ( list[ j ] === item.item[ 0 ] ) {
					return false;
				}
			}
			return true;
		} );

	},

	_refreshItems: function( event ) {

		this.items = [];
		this.containers = [ this ];

		var i, j, cur, inst, targetData, _queries, item, queriesLength,
			items = this.items,
			queries = [ [ typeof this.options.items === "function" ?
				this.options.items.call( this.element[ 0 ], event, { item: this.currentItem } ) :
				$( this.options.items, this.element ), this ] ],
			connectWith = this._connectWith();

		//Shouldn't be run the first time through due to massive slow-down
		if ( connectWith && this.ready ) {
			for ( i = connectWith.length - 1; i >= 0; i-- ) {
				cur = $( connectWith[ i ], this.document[ 0 ] );
				for ( j = cur.length - 1; j >= 0; j-- ) {
					inst = $.data( cur[ j ], this.widgetFullName );
					if ( inst && inst !== this && !inst.options.disabled ) {
						queries.push( [ typeof inst.options.items === "function" ?
							inst.options.items
								.call( inst.element[ 0 ], event, { item: this.currentItem } ) :
							$( inst.options.items, inst.element ), inst ] );
						this.containers.push( inst );
					}
				}
			}
		}

		for ( i = queries.length - 1; i >= 0; i-- ) {
			targetData = queries[ i ][ 1 ];
			_queries = queries[ i ][ 0 ];

			for ( j = 0, queriesLength = _queries.length; j < queriesLength; j++ ) {
				item = $( _queries[ j ] );

				// Data for target checking (mouse manager)
				item.data( this.widgetName + "-item", targetData );

				items.push( {
					item: item,
					instance: targetData,
					width: 0, height: 0,
					left: 0, top: 0
				} );
			}
		}

	},

	_refreshItemPositions: function( fast ) {
		var i, item, t, p;

		for ( i = this.items.length - 1; i >= 0; i-- ) {
			item = this.items[ i ];

			//We ignore calculating positions of all connected containers when we're not over them
			if ( this.currentContainer && item.instance !== this.currentContainer &&
					item.item[ 0 ] !== this.currentItem[ 0 ] ) {
				continue;
			}

			t = this.options.toleranceElement ?
				$( this.options.toleranceElement, item.item ) :
				item.item;

			if ( !fast ) {
				item.width = t.outerWidth();
				item.height = t.outerHeight();
			}

			p = t.offset();
			item.left = p.left;
			item.top = p.top;
		}
	},

	refreshPositions: function( fast ) {

		// Determine whether items are being displayed horizontally
		this.floating = this.items.length ?
			this.options.axis === "x" || this._isFloating( this.items[ 0 ].item ) :
			false;

		// This has to be redone because due to the item being moved out/into the offsetParent,
		// the offsetParent's position will change
		if ( this.offsetParent && this.helper ) {
			this.offset.parent = this._getParentOffset();
		}

		this._refreshItemPositions( fast );

		var i, p;

		if ( this.options.custom && this.options.custom.refreshContainers ) {
			this.options.custom.refreshContainers.call( this );
		} else {
			for ( i = this.containers.length - 1; i >= 0; i-- ) {
				p = this.containers[ i ].element.offset();
				this.containers[ i ].containerCache.left = p.left;
				this.containers[ i ].containerCache.top = p.top;
				this.containers[ i ].containerCache.width =
					this.containers[ i ].element.outerWidth();
				this.containers[ i ].containerCache.height =
					this.containers[ i ].element.outerHeight();
			}
		}

		return this;
	},

	_createPlaceholder: function( that ) {
		that = that || this;
		var className, nodeName,
			o = that.options;

		if ( !o.placeholder || o.placeholder.constructor === String ) {
			className = o.placeholder;
			nodeName = that.currentItem[ 0 ].nodeName.toLowerCase();
			o.placeholder = {
				element: function() {

					var element = $( "<" + nodeName + ">", that.document[ 0 ] );

					that._addClass( element, "ui-sortable-placeholder",
							className || that.currentItem[ 0 ].className )
						._removeClass( element, "ui-sortable-helper" );

					if ( nodeName === "tbody" ) {
						that._createTrPlaceholder(
							that.currentItem.find( "tr" ).eq( 0 ),
							$( "<tr>", that.document[ 0 ] ).appendTo( element )
						);
					} else if ( nodeName === "tr" ) {
						that._createTrPlaceholder( that.currentItem, element );
					} else if ( nodeName === "img" ) {
						element.attr( "src", that.currentItem.attr( "src" ) );
					}

					if ( !className ) {
						element.css( "visibility", "hidden" );
					}

					return element;
				},
				update: function( container, p ) {

					// 1. If a className is set as 'placeholder option, we don't force sizes -
					// the class is responsible for that
					// 2. The option 'forcePlaceholderSize can be enabled to force it even if a
					// class name is specified
					if ( className && !o.forcePlaceholderSize ) {
						return;
					}

					// If the element doesn't have a actual height or width by itself (without
					// styles coming from a stylesheet), it receives the inline height and width
					// from the dragged item. Or, if it's a tbody or tr, it's going to have a height
					// anyway since we're populating them with <td>s above, but they're unlikely to
					// be the correct height on their own if the row heights are dynamic, so we'll
					// always assign the height of the dragged item given forcePlaceholderSize
					// is true.
					if ( !p.height() || ( o.forcePlaceholderSize &&
							( nodeName === "tbody" || nodeName === "tr" ) ) ) {
						p.height(
							that.currentItem.innerHeight() -
							parseInt( that.currentItem.css( "paddingTop" ) || 0, 10 ) -
							parseInt( that.currentItem.css( "paddingBottom" ) || 0, 10 ) );
					}
					if ( !p.width() ) {
						p.width(
							that.currentItem.innerWidth() -
							parseInt( that.currentItem.css( "paddingLeft" ) || 0, 10 ) -
							parseInt( that.currentItem.css( "paddingRight" ) || 0, 10 ) );
					}
				}
			};
		}

		//Create the placeholder
		that.placeholder = $( o.placeholder.element.call( that.element, that.currentItem ) );

		//Append it after the actual current item
		that.currentItem.after( that.placeholder );

		//Update the size of the placeholder (TODO: Logic to fuzzy, see line 316/317)
		o.placeholder.update( that, that.placeholder );

	},

	_createTrPlaceholder: function( sourceTr, targetTr ) {
		var that = this;

		sourceTr.children().each( function() {
			$( "<td>&#160;</td>", that.document[ 0 ] )
				.attr( "colspan", $( this ).attr( "colspan" ) || 1 )
				.appendTo( targetTr );
		} );
	},

	_contactContainers: function( event ) {
		var i, j, dist, itemWithLeastDistance, posProperty, sizeProperty, cur, nearBottom,
			floating, axis,
			innermostContainer = null,
			innermostIndex = null;

		// Get innermost container that intersects with item
		for ( i = this.containers.length - 1; i >= 0; i-- ) {

			// Never consider a container that's located within the item itself
			if ( $.contains( this.currentItem[ 0 ], this.containers[ i ].element[ 0 ] ) ) {
				continue;
			}

			if ( this._intersectsWith( this.containers[ i ].containerCache ) ) {

				// If we've already found a container and it's more "inner" than this, then continue
				if ( innermostContainer &&
						$.contains(
							this.containers[ i ].element[ 0 ],
							innermostContainer.element[ 0 ] ) ) {
					continue;
				}

				innermostContainer = this.containers[ i ];
				innermostIndex = i;

			} else {

				// container doesn't intersect. trigger "out" event if necessary
				if ( this.containers[ i ].containerCache.over ) {
					this.containers[ i ]._trigger( "out", event, this._uiHash( this ) );
					this.containers[ i ].containerCache.over = 0;
				}
			}

		}

		// If no intersecting containers found, return
		if ( !innermostContainer ) {
			return;
		}

		// Move the item into the container if it's not there already
		if ( this.containers.length === 1 ) {
			if ( !this.containers[ innermostIndex ].containerCache.over ) {
				this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash( this ) );
				this.containers[ innermostIndex ].containerCache.over = 1;
			}
		} else {

			// When entering a new container, we will find the item with the least distance and
			// append our item near it
			dist = 10000;
			itemWithLeastDistance = null;
			floating = innermostContainer.floating || this._isFloating( this.currentItem );
			posProperty = floating ? "left" : "top";
			sizeProperty = floating ? "width" : "height";
			axis = floating ? "pageX" : "pageY";

			for ( j = this.items.length - 1; j >= 0; j-- ) {
				if ( !$.contains(
						this.containers[ innermostIndex ].element[ 0 ], this.items[ j ].item[ 0 ] )
				) {
					continue;
				}
				if ( this.items[ j ].item[ 0 ] === this.currentItem[ 0 ] ) {
					continue;
				}

				cur = this.items[ j ].item.offset()[ posProperty ];
				nearBottom = false;
				if ( event[ axis ] - cur > this.items[ j ][ sizeProperty ] / 2 ) {
					nearBottom = true;
				}

				if ( Math.abs( event[ axis ] - cur ) < dist ) {
					dist = Math.abs( event[ axis ] - cur );
					itemWithLeastDistance = this.items[ j ];
					this.direction = nearBottom ? "up" : "down";
				}
			}

			//Check if dropOnEmpty is enabled
			if ( !itemWithLeastDistance && !this.options.dropOnEmpty ) {
				return;
			}

			if ( this.currentContainer === this.containers[ innermostIndex ] ) {
				if ( !this.currentContainer.containerCache.over ) {
					this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash() );
					this.currentContainer.containerCache.over = 1;
				}
				return;
			}

			if ( itemWithLeastDistance ) {
				this._rearrange( event, itemWithLeastDistance, null, true );
			} else {
				this._rearrange( event, null, this.containers[ innermostIndex ].element, true );
			}
			this._trigger( "change", event, this._uiHash() );
			this.containers[ innermostIndex ]._trigger( "change", event, this._uiHash( this ) );
			this.currentContainer = this.containers[ innermostIndex ];

			//Update the placeholder
			this.options.placeholder.update( this.currentContainer, this.placeholder );

			//Update scrollParent
			this.scrollParent = this.placeholder.scrollParent();

			//Update overflowOffset
			if ( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
					this.scrollParent[ 0 ].tagName !== "HTML" ) {
				this.overflowOffset = this.scrollParent.offset();
			}

			this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash( this ) );
			this.containers[ innermostIndex ].containerCache.over = 1;
		}

	},

	_createHelper: function( event ) {

		var o = this.options,
			helper = typeof o.helper === "function" ?
				$( o.helper.apply( this.element[ 0 ], [ event, this.currentItem ] ) ) :
				( o.helper === "clone" ? this.currentItem.clone() : this.currentItem );

		//Add the helper to the DOM if that didn't happen already
		if ( !helper.parents( "body" ).length ) {
			this.appendTo[ 0 ].appendChild( helper[ 0 ] );
		}

		if ( helper[ 0 ] === this.currentItem[ 0 ] ) {
			this._storedCSS = {
				width: this.currentItem[ 0 ].style.width,
				height: this.currentItem[ 0 ].style.height,
				position: this.currentItem.css( "position" ),
				top: this.currentItem.css( "top" ),
				left: this.currentItem.css( "left" )
			};
		}

		if ( !helper[ 0 ].style.width || o.forceHelperSize ) {
			helper.width( this.currentItem.width() );
		}
		if ( !helper[ 0 ].style.height || o.forceHelperSize ) {
			helper.height( this.currentItem.height() );
		}

		return helper;

	},

	_adjustOffsetFromHelper: function( obj ) {
		if ( typeof obj === "string" ) {
			obj = obj.split( " " );
		}
		if ( Array.isArray( obj ) ) {
			obj = { left: +obj[ 0 ], top: +obj[ 1 ] || 0 };
		}
		if ( "left" in obj ) {
			this.offset.click.left = obj.left + this.margins.left;
		}
		if ( "right" in obj ) {
			this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
		}
		if ( "top" in obj ) {
			this.offset.click.top = obj.top + this.margins.top;
		}
		if ( "bottom" in obj ) {
			this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
		}
	},

	_getParentOffset: function() {

		//Get the offsetParent and cache its position
		this.offsetParent = this.helper.offsetParent();
		var po = this.offsetParent.offset();

		// This is a special case where we need to modify a offset calculated on start, since the
		// following happened:
		// 1. The position of the helper is absolute, so it's position is calculated based on the
		// next positioned parent
		// 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't
		// the document, which means that the scroll is included in the initial calculation of the
		// offset of the parent, and never recalculated upon drag
		if ( this.cssPosition === "absolute" && this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) {
			po.left += this.scrollParent.scrollLeft();
			po.top += this.scrollParent.scrollTop();
		}

		// This needs to be actually done for all browsers, since pageX/pageY includes
		// this information.
		if ( this.offsetParent[ 0 ] === this.document[ 0 ].body ) {
			po = { top: 0, left: 0 };
		}

		return {
			top: po.top + ( parseInt( this.offsetParent.css( "borderTopWidth" ), 10 ) || 0 ),
			left: po.left + ( parseInt( this.offsetParent.css( "borderLeftWidth" ), 10 ) || 0 )
		};

	},

	_getRelativeOffset: function() {

		if ( this.cssPosition === "relative" ) {
			var p = this.currentItem.position();
			return {
				top: p.top - ( parseInt( this.helper.css( "top" ), 10 ) || 0 ) +
					this.scrollParent.scrollTop(),
				left: p.left - ( parseInt( this.helper.css( "left" ), 10 ) || 0 ) +
					this.scrollParent.scrollLeft()
			};
		} else {
			return { top: 0, left: 0 };
		}

	},

	_cacheMargins: function() {
		this.margins = {
			left: ( parseInt( this.currentItem.css( "marginLeft" ), 10 ) || 0 ),
			top: ( parseInt( this.currentItem.css( "marginTop" ), 10 ) || 0 )
		};
	},

	_cacheHelperProportions: function() {
		this.helperProportions = {
			width: this.helper.outerWidth(),
			height: this.helper.outerHeight()
		};
	},

	_setContainment: function() {

		var ce, co, over,
			o = this.options;
		if ( o.containment === "parent" ) {
			o.containment = this.helper[ 0 ].parentNode;
		}
		if ( o.containment === "document" || o.containment === "window" ) {
			this.containment = [
				0 - this.offset.relative.left - this.offset.parent.left,
				0 - this.offset.relative.top - this.offset.parent.top,
				o.containment === "document" ?
					this.document.width() :
					this.window.width() - this.helperProportions.width - this.margins.left,
				( o.containment === "document" ?
					( this.document.height() || document.body.parentNode.scrollHeight ) :
					this.window.height() || this.document[ 0 ].body.parentNode.scrollHeight
				) - this.helperProportions.height - this.margins.top
			];
		}

		if ( !( /^(document|window|parent)$/ ).test( o.containment ) ) {
			ce = $( o.containment )[ 0 ];
			co = $( o.containment ).offset();
			over = ( $( ce ).css( "overflow" ) !== "hidden" );

			this.containment = [
				co.left + ( parseInt( $( ce ).css( "borderLeftWidth" ), 10 ) || 0 ) +
					( parseInt( $( ce ).css( "paddingLeft" ), 10 ) || 0 ) - this.margins.left,
				co.top + ( parseInt( $( ce ).css( "borderTopWidth" ), 10 ) || 0 ) +
					( parseInt( $( ce ).css( "paddingTop" ), 10 ) || 0 ) - this.margins.top,
				co.left + ( over ? Math.max( ce.scrollWidth, ce.offsetWidth ) : ce.offsetWidth ) -
					( parseInt( $( ce ).css( "borderLeftWidth" ), 10 ) || 0 ) -
					( parseInt( $( ce ).css( "paddingRight" ), 10 ) || 0 ) -
					this.helperProportions.width - this.margins.left,
				co.top + ( over ? Math.max( ce.scrollHeight, ce.offsetHeight ) : ce.offsetHeight ) -
					( parseInt( $( ce ).css( "borderTopWidth" ), 10 ) || 0 ) -
					( parseInt( $( ce ).css( "paddingBottom" ), 10 ) || 0 ) -
					this.helperProportions.height - this.margins.top
			];
		}

	},

	_convertPositionTo: function( d, pos ) {

		if ( !pos ) {
			pos = this.position;
		}
		var mod = d === "absolute" ? 1 : -1,
			scroll = this.cssPosition === "absolute" &&
				!( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) ?
					this.offsetParent :
					this.scrollParent,
			scrollIsRootNode = ( /(html|body)/i ).test( scroll[ 0 ].tagName );

		return {
			top: (

				// The absolute mouse position
				pos.top	+

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.top * mod +

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.top * mod -
				( ( this.cssPosition === "fixed" ?
					-this.scrollParent.scrollTop() :
					( scrollIsRootNode ? 0 : scroll.scrollTop() ) ) * mod )
			),
			left: (

				// The absolute mouse position
				pos.left +

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.left * mod +

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.left * mod	-
				( ( this.cssPosition === "fixed" ?
					-this.scrollParent.scrollLeft() : scrollIsRootNode ? 0 :
					scroll.scrollLeft() ) * mod )
			)
		};

	},

	_generatePosition: function( event ) {

		var top, left,
			o = this.options,
			pageX = event.pageX,
			pageY = event.pageY,
			scroll = this.cssPosition === "absolute" &&
				!( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) ?
					this.offsetParent :
					this.scrollParent,
				scrollIsRootNode = ( /(html|body)/i ).test( scroll[ 0 ].tagName );

		// This is another very weird special case that only happens for relative elements:
		// 1. If the css position is relative
		// 2. and the scroll parent is the document or similar to the offset parent
		// we have to refresh the relative offset during the scroll so there are no jumps
		if ( this.cssPosition === "relative" && !( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				this.scrollParent[ 0 ] !== this.offsetParent[ 0 ] ) ) {
			this.offset.relative = this._getRelativeOffset();
		}

		/*
		 * - Position constraining -
		 * Constrain the position to a mix of grid, containment.
		 */

		if ( this.originalPosition ) { //If we are not dragging yet, we won't check for options

			if ( this.containment ) {
				if ( event.pageX - this.offset.click.left < this.containment[ 0 ] ) {
					pageX = this.containment[ 0 ] + this.offset.click.left;
				}
				if ( event.pageY - this.offset.click.top < this.containment[ 1 ] ) {
					pageY = this.containment[ 1 ] + this.offset.click.top;
				}
				if ( event.pageX - this.offset.click.left > this.containment[ 2 ] ) {
					pageX = this.containment[ 2 ] + this.offset.click.left;
				}
				if ( event.pageY - this.offset.click.top > this.containment[ 3 ] ) {
					pageY = this.containment[ 3 ] + this.offset.click.top;
				}
			}

			if ( o.grid ) {
				top = this.originalPageY + Math.round( ( pageY - this.originalPageY ) /
					o.grid[ 1 ] ) * o.grid[ 1 ];
				pageY = this.containment ?
					( ( top - this.offset.click.top >= this.containment[ 1 ] &&
						top - this.offset.click.top <= this.containment[ 3 ] ) ?
							top :
							( ( top - this.offset.click.top >= this.containment[ 1 ] ) ?
								top - o.grid[ 1 ] : top + o.grid[ 1 ] ) ) :
								top;

				left = this.originalPageX + Math.round( ( pageX - this.originalPageX ) /
					o.grid[ 0 ] ) * o.grid[ 0 ];
				pageX = this.containment ?
					( ( left - this.offset.click.left >= this.containment[ 0 ] &&
						left - this.offset.click.left <= this.containment[ 2 ] ) ?
							left :
							( ( left - this.offset.click.left >= this.containment[ 0 ] ) ?
								left - o.grid[ 0 ] : left + o.grid[ 0 ] ) ) :
								left;
			}

		}

		return {
			top: (

				// The absolute mouse position
				pageY -

				// Click offset (relative to the element)
				this.offset.click.top -

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.top -

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.top +
				( ( this.cssPosition === "fixed" ?
					-this.scrollParent.scrollTop() :
					( scrollIsRootNode ? 0 : scroll.scrollTop() ) ) )
			),
			left: (

				// The absolute mouse position
				pageX -

				// Click offset (relative to the element)
				this.offset.click.left -

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.left -

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.left +
				( ( this.cssPosition === "fixed" ?
					-this.scrollParent.scrollLeft() :
					scrollIsRootNode ? 0 : scroll.scrollLeft() ) )
			)
		};

	},

	_rearrange: function( event, i, a, hardRefresh ) {

		if ( a ) {
			a[ 0 ].appendChild( this.placeholder[ 0 ] );
		} else {
			i.item[ 0 ].parentNode.insertBefore( this.placeholder[ 0 ],
				( this.direction === "down" ? i.item[ 0 ] : i.item[ 0 ].nextSibling ) );
		}

		//Various things done here to improve the performance:
		// 1. we create a setTimeout, that calls refreshPositions
		// 2. on the instance, we have a counter variable, that get's higher after every append
		// 3. on the local scope, we copy the counter variable, and check in the timeout,
		// if it's still the same
		// 4. this lets only the last addition to the timeout stack through
		this.counter = this.counter ? ++this.counter : 1;
		var counter = this.counter;

		this._delay( function() {
			if ( counter === this.counter ) {

				//Precompute after each DOM insertion, NOT on mousemove
				this.refreshPositions( !hardRefresh );
			}
		} );

	},

	_clear: function( event, noPropagation ) {

		this.reverting = false;

		// We delay all events that have to be triggered to after the point where the placeholder
		// has been removed and everything else normalized again
		var i,
			delayedTriggers = [];

		// We first have to update the dom position of the actual currentItem
		// Note: don't do it if the current item is already removed (by a user), or it gets
		// reappended (see #4088)
		if ( !this._noFinalSort && this.currentItem.parent().length ) {
			this.placeholder.before( this.currentItem );
		}
		this._noFinalSort = null;

		if ( this.helper[ 0 ] === this.currentItem[ 0 ] ) {
			for ( i in this._storedCSS ) {
				if ( this._storedCSS[ i ] === "auto" || this._storedCSS[ i ] === "static" ) {
					this._storedCSS[ i ] = "";
				}
			}
			this.currentItem.css( this._storedCSS );
			this._removeClass( this.currentItem, "ui-sortable-helper" );
		} else {
			this.currentItem.show();
		}

		if ( this.fromOutside && !noPropagation ) {
			delayedTriggers.push( function( event ) {
				this._trigger( "receive", event, this._uiHash( this.fromOutside ) );
			} );
		}
		if ( ( this.fromOutside ||
				this.domPosition.prev !==
				this.currentItem.prev().not( ".ui-sortable-helper" )[ 0 ] ||
				this.domPosition.parent !== this.currentItem.parent()[ 0 ] ) && !noPropagation ) {

			// Trigger update callback if the DOM position has changed
			delayedTriggers.push( function( event ) {
				this._trigger( "update", event, this._uiHash() );
			} );
		}

		// Check if the items Container has Changed and trigger appropriate
		// events.
		if ( this !== this.currentContainer ) {
			if ( !noPropagation ) {
				delayedTriggers.push( function( event ) {
					this._trigger( "remove", event, this._uiHash() );
				} );
				delayedTriggers.push( ( function( c ) {
					return function( event ) {
						c._trigger( "receive", event, this._uiHash( this ) );
					};
				} ).call( this, this.currentContainer ) );
				delayedTriggers.push( ( function( c ) {
					return function( event ) {
						c._trigger( "update", event, this._uiHash( this ) );
					};
				} ).call( this, this.currentContainer ) );
			}
		}

		//Post events to containers
		function delayEvent( type, instance, container ) {
			return function( event ) {
				container._trigger( type, event, instance._uiHash( instance ) );
			};
		}
		for ( i = this.containers.length - 1; i >= 0; i-- ) {
			if ( !noPropagation ) {
				delayedTriggers.push( delayEvent( "deactivate", this, this.containers[ i ] ) );
			}
			if ( this.containers[ i ].containerCache.over ) {
				delayedTriggers.push( delayEvent( "out", this, this.containers[ i ] ) );
				this.containers[ i ].containerCache.over = 0;
			}
		}

		//Do what was originally in plugins
		if ( this._storedStylesheet ) {
			this._storedStylesheet.remove();
			this._storedStylesheet = null;
		}
		if ( this._storedOpacity ) {
			this.helper.css( "opacity", this._storedOpacity );
		}
		if ( this._storedZIndex ) {
			this.helper.css( "zIndex", this._storedZIndex === "auto" ? "" : this._storedZIndex );
		}

		this.dragging = false;

		if ( !noPropagation ) {
			this._trigger( "beforeStop", event, this._uiHash() );
		}

		//$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately,
		// it unbinds ALL events from the original node!
		this.placeholder[ 0 ].parentNode.removeChild( this.placeholder[ 0 ] );

		if ( !this.cancelHelperRemoval ) {
			if ( this.helper[ 0 ] !== this.currentItem[ 0 ] ) {
				this.helper.remove();
			}
			this.helper = null;
		}

		if ( !noPropagation ) {
			for ( i = 0; i < delayedTriggers.length; i++ ) {

				// Trigger all delayed events
				delayedTriggers[ i ].call( this, event );
			}
			this._trigger( "stop", event, this._uiHash() );
		}

		this.fromOutside = false;
		return !this.cancelHelperRemoval;

	},

	_trigger: function() {
		if ( $.Widget.prototype._trigger.apply( this, arguments ) === false ) {
			this.cancel();
		}
	},

	_uiHash: function( _inst ) {
		var inst = _inst || this;
		return {
			helper: inst.helper,
			placeholder: inst.placeholder || $( [] ),
			position: inst.position,
			originalPosition: inst.originalPosition,
			offset: inst.positionAbs,
			item: inst.currentItem,
			sender: _inst ? _inst.element : null
		};
	}

} );


/*!
 * jQuery UI Spinner 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Spinner
//>>group: Widgets
//>>description: Displays buttons to easily input numbers via the keyboard or mouse.
//>>docs: https://api.jqueryui.com/spinner/
//>>demos: https://jqueryui.com/spinner/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/spinner.css
//>>css.theme: ../../themes/base/theme.css


function spinnerModifier( fn ) {
	return function() {
		var previous = this.element.val();
		fn.apply( this, arguments );
		this._refresh();
		if ( previous !== this.element.val() ) {
			this._trigger( "change" );
		}
	};
}

$.widget( "ui.spinner", {
	version: "1.14.1",
	defaultElement: "<input>",
	widgetEventPrefix: "spin",
	options: {
		classes: {
			"ui-spinner": "ui-corner-all",
			"ui-spinner-down": "ui-corner-br",
			"ui-spinner-up": "ui-corner-tr"
		},
		culture: null,
		icons: {
			down: "ui-icon-triangle-1-s",
			up: "ui-icon-triangle-1-n"
		},
		incremental: true,
		max: null,
		min: null,
		numberFormat: null,
		page: 10,
		step: 1,

		change: null,
		spin: null,
		start: null,
		stop: null
	},

	_create: function() {

		// handle string values that need to be parsed
		this._setOption( "max", this.options.max );
		this._setOption( "min", this.options.min );
		this._setOption( "step", this.options.step );

		// Only format if there is a value, prevents the field from being marked
		// as invalid in Firefox, see #9573.
		if ( this.value() !== "" ) {

			// Format the value, but don't constrain.
			this._value( this.element.val(), true );
		}

		this._draw();
		this._on( this._events );
		this._refresh();

		// Turning off autocomplete prevents the browser from remembering the
		// value when navigating through history, so we re-enable autocomplete
		// if the page is unloaded before the widget is destroyed. #7790
		this._on( this.window, {
			beforeunload: function() {
				this.element.removeAttr( "autocomplete" );
			}
		} );
	},

	_getCreateOptions: function() {
		var options = this._super();
		var element = this.element;

		$.each( [ "min", "max", "step" ], function( i, option ) {
			var value = element.attr( option );
			if ( value != null && value.length ) {
				options[ option ] = value;
			}
		} );

		return options;
	},

	_events: {
		keydown: function( event ) {
			if ( this._start( event ) && this._keydown( event ) ) {
				event.preventDefault();
			}
		},
		keyup: "_stop",
		focus: function() {
			this.previous = this.element.val();
		},
		blur: function( event ) {
			this._stop();
			this._refresh();
			if ( this.previous !== this.element.val() ) {
				this._trigger( "change", event );
			}
		},
		mousewheel: function( event, delta ) {
			var activeElement = this.document[ 0 ].activeElement;
			var isActive = this.element[ 0 ] === activeElement;

			if ( !isActive || !delta ) {
				return;
			}

			if ( !this.spinning && !this._start( event ) ) {
				return false;
			}

			this._spin( ( delta > 0 ? 1 : -1 ) * this.options.step, event );
			clearTimeout( this.mousewheelTimer );
			this.mousewheelTimer = this._delay( function() {
				if ( this.spinning ) {
					this._stop( event );
				}
			}, 100 );
			event.preventDefault();
		},
		"mousedown .ui-spinner-button": function( event ) {
			var previous;

			// We never want the buttons to have focus; whenever the user is
			// interacting with the spinner, the focus should be on the input.
			// If the input is focused then this.previous is properly set from
			// when the input first received focus. If the input is not focused
			// then we need to set this.previous based on the value before spinning.
			previous = this.element[ 0 ] === this.document[ 0 ].activeElement ?
				this.previous : this.element.val();
			function checkFocus() {
				var isActive = this.element[ 0 ] === this.document[ 0 ].activeElement;
				if ( !isActive ) {
					this.element.trigger( "focus" );
					this.previous = previous;
				}
			}

			// Ensure focus is on (or stays on) the text field
			event.preventDefault();
			checkFocus.call( this );

			if ( this._start( event ) === false ) {
				return;
			}

			this._repeat( null, $( event.currentTarget )
				.hasClass( "ui-spinner-up" ) ? 1 : -1, event );
		},
		"mouseup .ui-spinner-button": "_stop",
		"mouseenter .ui-spinner-button": function( event ) {

			// button will add ui-state-active if mouse was down while mouseleave and kept down
			if ( !$( event.currentTarget ).hasClass( "ui-state-active" ) ) {
				return;
			}

			if ( this._start( event ) === false ) {
				return false;
			}
			this._repeat( null, $( event.currentTarget )
				.hasClass( "ui-spinner-up" ) ? 1 : -1, event );
		},

		// TODO: do we really want to consider this a stop?
		// shouldn't we just stop the repeater and wait until mouseup before
		// we trigger the stop event?
		"mouseleave .ui-spinner-button": "_stop"
	},

	// Support mobile enhanced option and make backcompat more sane
	_enhance: function() {
		this.uiSpinner = this.element
			.attr( "autocomplete", "off" )
			.wrap( "<span>" )
			.parent()

				// Add buttons
				.append(
					"<a></a><a></a>"
				);
	},

	_draw: function() {
		this._enhance();

		this._addClass( this.uiSpinner, "ui-spinner", "ui-widget ui-widget-content" );
		this._addClass( "ui-spinner-input" );

		this.element.attr( "role", "spinbutton" );

		// Button bindings
		this.buttons = this.uiSpinner.children( "a" )
			.attr( "tabIndex", -1 )
			.attr( "aria-hidden", true )
			.button( {
				classes: {
					"ui-button": ""
				}
			} );

		// TODO: Right now button does not support classes this is already updated in button PR
		this._removeClass( this.buttons, "ui-corner-all" );

		this._addClass( this.buttons.first(), "ui-spinner-button ui-spinner-up" );
		this._addClass( this.buttons.last(), "ui-spinner-button ui-spinner-down" );
		this.buttons.first().button( {
			"icon": this.options.icons.up,
			"showLabel": false
		} );
		this.buttons.last().button( {
			"icon": this.options.icons.down,
			"showLabel": false
		} );

		// IE 6 doesn't understand height: 50% for the buttons
		// unless the wrapper has an explicit height
		if ( this.buttons.height() > Math.ceil( this.uiSpinner.height() * 0.5 ) &&
				this.uiSpinner.height() > 0 ) {
			this.uiSpinner.height( this.uiSpinner.height() );
		}
	},

	_keydown: function( event ) {
		var options = this.options,
			keyCode = $.ui.keyCode;

		switch ( event.keyCode ) {
		case keyCode.UP:
			this._repeat( null, 1, event );
			return true;
		case keyCode.DOWN:
			this._repeat( null, -1, event );
			return true;
		case keyCode.PAGE_UP:
			this._repeat( null, options.page, event );
			return true;
		case keyCode.PAGE_DOWN:
			this._repeat( null, -options.page, event );
			return true;
		}

		return false;
	},

	_start: function( event ) {
		if ( !this.spinning && this._trigger( "start", event ) === false ) {
			return false;
		}

		if ( !this.counter ) {
			this.counter = 1;
		}
		this.spinning = true;
		return true;
	},

	_repeat: function( i, steps, event ) {
		i = i || 500;

		clearTimeout( this.timer );
		this.timer = this._delay( function() {
			this._repeat( 40, steps, event );
		}, i );

		this._spin( steps * this.options.step, event );
	},

	_spin: function( step, event ) {
		var value = this.value() || 0;

		if ( !this.counter ) {
			this.counter = 1;
		}

		value = this._adjustValue( value + step * this._increment( this.counter ) );

		if ( !this.spinning || this._trigger( "spin", event, { value: value } ) !== false ) {
			this._value( value );
			this.counter++;
		}
	},

	_increment: function( i ) {
		var incremental = this.options.incremental;

		if ( incremental ) {
			return typeof incremental === "function" ?
				incremental( i ) :
				Math.floor( i * i * i / 50000 - i * i / 500 + 17 * i / 200 + 1 );
		}

		return 1;
	},

	_precision: function() {
		var precision = this._precisionOf( this.options.step );
		if ( this.options.min !== null ) {
			precision = Math.max( precision, this._precisionOf( this.options.min ) );
		}
		return precision;
	},

	_precisionOf: function( num ) {
		var str = num.toString(),
			decimal = str.indexOf( "." );
		return decimal === -1 ? 0 : str.length - decimal - 1;
	},

	_adjustValue: function( value ) {
		var base, aboveMin,
			options = this.options;

		// Make sure we're at a valid step
		// - find out where we are relative to the base (min or 0)
		base = options.min !== null ? options.min : 0;
		aboveMin = value - base;

		// - round to the nearest step
		aboveMin = Math.round( aboveMin / options.step ) * options.step;

		// - rounding is based on 0, so adjust back to our base
		value = base + aboveMin;

		// Fix precision from bad JS floating point math
		value = parseFloat( value.toFixed( this._precision() ) );

		// Clamp the value
		if ( options.max !== null && value > options.max ) {
			return options.max;
		}
		if ( options.min !== null && value < options.min ) {
			return options.min;
		}

		return value;
	},

	_stop: function( event ) {
		if ( !this.spinning ) {
			return;
		}

		clearTimeout( this.timer );
		clearTimeout( this.mousewheelTimer );
		this.counter = 0;
		this.spinning = false;
		this._trigger( "stop", event );
	},

	_setOption: function( key, value ) {
		var prevValue, first, last;

		if ( key === "culture" || key === "numberFormat" ) {
			prevValue = this._parse( this.element.val() );
			this.options[ key ] = value;
			this.element.val( this._format( prevValue ) );
			return;
		}

		if ( key === "max" || key === "min" || key === "step" ) {
			if ( typeof value === "string" ) {
				value = this._parse( value );
			}
		}
		if ( key === "icons" ) {
			first = this.buttons.first().find( ".ui-icon" );
			this._removeClass( first, null, this.options.icons.up );
			this._addClass( first, null, value.up );
			last = this.buttons.last().find( ".ui-icon" );
			this._removeClass( last, null, this.options.icons.down );
			this._addClass( last, null, value.down );
		}

		this._super( key, value );
	},

	_setOptionDisabled: function( value ) {
		this._super( value );

		this._toggleClass( this.uiSpinner, null, "ui-state-disabled", !!value );
		this.element.prop( "disabled", !!value );
		this.buttons.button( value ? "disable" : "enable" );
	},

	_setOptions: spinnerModifier( function( options ) {
		this._super( options );
	} ),

	_parse: function( val ) {
		if ( typeof val === "string" && val !== "" ) {
			val = window.Globalize && this.options.numberFormat ?
				Globalize.parseFloat( val, 10, this.options.culture ) : +val;
		}
		return val === "" || isNaN( val ) ? null : val;
	},

	_format: function( value ) {
		if ( value === "" ) {
			return "";
		}
		return window.Globalize && this.options.numberFormat ?
			Globalize.format( value, this.options.numberFormat, this.options.culture ) :
			value;
	},

	_refresh: function() {
		this.element.attr( {
			"aria-valuemin": this.options.min,
			"aria-valuemax": this.options.max,

			// TODO: what should we do with values that can't be parsed?
			"aria-valuenow": this._parse( this.element.val() )
		} );
	},

	isValid: function() {
		var value = this.value();

		// Null is invalid
		if ( value === null ) {
			return false;
		}

		// If value gets adjusted, it's invalid
		return value === this._adjustValue( value );
	},

	// Update the value without triggering change
	_value: function( value, allowAny ) {
		var parsed;
		if ( value !== "" ) {
			parsed = this._parse( value );
			if ( parsed !== null ) {
				if ( !allowAny ) {
					parsed = this._adjustValue( parsed );
				}
				value = this._format( parsed );
			}
		}
		this.element.val( value );
		this._refresh();
	},

	_destroy: function() {
		this.element
			.prop( "disabled", false )
			.removeAttr( "autocomplete role aria-valuemin aria-valuemax aria-valuenow" );

		this.uiSpinner.replaceWith( this.element );
	},

	stepUp: spinnerModifier( function( steps ) {
		this._stepUp( steps );
	} ),
	_stepUp: function( steps ) {
		if ( this._start() ) {
			this._spin( ( steps || 1 ) * this.options.step );
			this._stop();
		}
	},

	stepDown: spinnerModifier( function( steps ) {
		this._stepDown( steps );
	} ),
	_stepDown: function( steps ) {
		if ( this._start() ) {
			this._spin( ( steps || 1 ) * -this.options.step );
			this._stop();
		}
	},

	pageUp: spinnerModifier( function( pages ) {
		this._stepUp( ( pages || 1 ) * this.options.page );
	} ),

	pageDown: spinnerModifier( function( pages ) {
		this._stepDown( ( pages || 1 ) * this.options.page );
	} ),

	value: function( newVal ) {
		if ( !arguments.length ) {
			return this._parse( this.element.val() );
		}
		spinnerModifier( this._value ).call( this, newVal );
	},

	widget: function() {
		return this.uiSpinner;
	}
} );

// DEPRECATED
// TODO: switch return back to widget declaration at top of file when this is removed
if ( $.uiBackCompat === true ) {

	// Backcompat for spinner html extension points
	$.widget( "ui.spinner", $.ui.spinner, {
		_enhance: function() {
			this.uiSpinner = this.element
				.attr( "autocomplete", "off" )
				.wrap( this._uiSpinnerHtml() )
				.parent()

					// Add buttons
					.append( this._buttonHtml() );
		},
		_uiSpinnerHtml: function() {
			return "<span>";
		},

		_buttonHtml: function() {
			return "<a></a><a></a>";
		}
	} );
}

var widgetsSpinner = $.ui.spinner;


/*!
 * jQuery UI Tabs 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Tabs
//>>group: Widgets
//>>description: Transforms a set of container elements into a tab structure.
//>>docs: https://api.jqueryui.com/tabs/
//>>demos: https://jqueryui.com/tabs/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/tabs.css
//>>css.theme: ../../themes/base/theme.css


$.widget( "ui.tabs", {
	version: "1.14.1",
	delay: 300,
	options: {
		active: null,
		classes: {
			"ui-tabs": "ui-corner-all",
			"ui-tabs-nav": "ui-corner-all",
			"ui-tabs-panel": "ui-corner-bottom",
			"ui-tabs-tab": "ui-corner-top"
		},
		collapsible: false,
		event: "click",
		heightStyle: "content",
		hide: null,
		show: null,

		// Callbacks
		activate: null,
		beforeActivate: null,
		beforeLoad: null,
		load: null
	},

	_isLocal: ( function() {
		var rhash = /#.*$/;

		return function( anchor ) {
			var anchorUrl, locationUrl;

			anchorUrl = anchor.href.replace( rhash, "" );
			locationUrl = location.href.replace( rhash, "" );

			// Decoding may throw an error if the URL isn't UTF-8 (#9518)
			try {
				anchorUrl = decodeURIComponent( anchorUrl );
			} catch ( error ) {}
			try {
				locationUrl = decodeURIComponent( locationUrl );
			} catch ( error ) {}

			return anchor.hash.length > 1 && anchorUrl === locationUrl;
		};
	} )(),

	_create: function() {
		var that = this,
			options = this.options;

		this.running = false;

		this._addClass( "ui-tabs", "ui-widget ui-widget-content" );
		this._toggleClass( "ui-tabs-collapsible", null, options.collapsible );

		this._processTabs();
		options.active = this._initialActive();

		// Take disabling tabs via class attribute from HTML
		// into account and update option properly.
		if ( Array.isArray( options.disabled ) ) {
			options.disabled = $.uniqueSort( options.disabled.concat(
				$.map( this.tabs.filter( ".ui-state-disabled" ), function( li ) {
					return that.tabs.index( li );
				} )
			) ).sort();
		}

		// Check for length avoids error when initializing empty list
		if ( this.options.active !== false && this.anchors.length ) {
			this.active = this._findActive( options.active );
		} else {
			this.active = $();
		}

		this._refresh();

		if ( this.active.length ) {
			this.load( options.active );
		}
	},

	_initialActive: function() {
		var active = this.options.active,
			collapsible = this.options.collapsible,
			locationHashDecoded = decodeURIComponent( location.hash.substring( 1 ) );

		if ( active === null ) {

			// check the fragment identifier in the URL
			if ( locationHashDecoded ) {
				this.tabs.each( function( i, tab ) {
					if ( $( tab ).attr( "aria-controls" ) === locationHashDecoded ) {
						active = i;
						return false;
					}
				} );
			}

			// Check for a tab marked active via a class
			if ( active === null ) {
				active = this.tabs.index( this.tabs.filter( ".ui-tabs-active" ) );
			}

			// No active tab, set to false
			if ( active === null || active === -1 ) {
				active = this.tabs.length ? 0 : false;
			}
		}

		// Handle numbers: negative, out of range
		if ( active !== false ) {
			active = this.tabs.index( this.tabs.eq( active ) );
			if ( active === -1 ) {
				active = collapsible ? false : 0;
			}
		}

		// Don't allow collapsible: false and active: false
		if ( !collapsible && active === false && this.anchors.length ) {
			active = 0;
		}

		return active;
	},

	_getCreateEventData: function() {
		return {
			tab: this.active,
			panel: !this.active.length ? $() : this._getPanelForTab( this.active )
		};
	},

	_tabKeydown: function( event ) {
		var focusedTab = $( this.document[ 0 ].activeElement ).closest( "li" ),
			selectedIndex = this.tabs.index( focusedTab ),
			goingForward = true;

		if ( this._handlePageNav( event ) ) {
			return;
		}

		switch ( event.keyCode ) {
		case $.ui.keyCode.RIGHT:
		case $.ui.keyCode.DOWN:
			selectedIndex++;
			break;
		case $.ui.keyCode.UP:
		case $.ui.keyCode.LEFT:
			goingForward = false;
			selectedIndex--;
			break;
		case $.ui.keyCode.END:
			selectedIndex = this.anchors.length - 1;
			break;
		case $.ui.keyCode.HOME:
			selectedIndex = 0;
			break;
		case $.ui.keyCode.SPACE:

			// Activate only, no collapsing
			event.preventDefault();
			clearTimeout( this.activating );
			this._activate( selectedIndex );
			return;
		case $.ui.keyCode.ENTER:

			// Toggle (cancel delayed activation, allow collapsing)
			event.preventDefault();
			clearTimeout( this.activating );

			// Determine if we should collapse or activate
			this._activate( selectedIndex === this.options.active ? false : selectedIndex );
			return;
		default:
			return;
		}

		// Focus the appropriate tab, based on which key was pressed
		event.preventDefault();
		clearTimeout( this.activating );
		selectedIndex = this._focusNextTab( selectedIndex, goingForward );

		// Navigating with control/command key will prevent automatic activation
		if ( !event.ctrlKey && !event.metaKey ) {

			// Update aria-selected immediately so that AT think the tab is already selected.
			// Otherwise AT may confuse the user by stating that they need to activate the tab,
			// but the tab will already be activated by the time the announcement finishes.
			focusedTab.attr( "aria-selected", "false" );
			this.tabs.eq( selectedIndex ).attr( "aria-selected", "true" );

			this.activating = this._delay( function() {
				this.option( "active", selectedIndex );
			}, this.delay );
		}
	},

	_panelKeydown: function( event ) {
		if ( this._handlePageNav( event ) ) {
			return;
		}

		// Ctrl+up moves focus to the current tab
		if ( event.ctrlKey && event.keyCode === $.ui.keyCode.UP ) {
			event.preventDefault();
			this.active.trigger( "focus" );
		}
	},

	// Alt+page up/down moves focus to the previous/next tab (and activates)
	_handlePageNav: function( event ) {
		if ( event.altKey && event.keyCode === $.ui.keyCode.PAGE_UP ) {
			this._activate( this._focusNextTab( this.options.active - 1, false ) );
			return true;
		}
		if ( event.altKey && event.keyCode === $.ui.keyCode.PAGE_DOWN ) {
			this._activate( this._focusNextTab( this.options.active + 1, true ) );
			return true;
		}
	},

	_findNextTab: function( index, goingForward ) {
		var lastTabIndex = this.tabs.length - 1;

		function constrain() {
			if ( index > lastTabIndex ) {
				index = 0;
			}
			if ( index < 0 ) {
				index = lastTabIndex;
			}
			return index;
		}

		while ( $.inArray( constrain(), this.options.disabled ) !== -1 ) {
			index = goingForward ? index + 1 : index - 1;
		}

		return index;
	},

	_focusNextTab: function( index, goingForward ) {
		index = this._findNextTab( index, goingForward );
		this.tabs.eq( index ).trigger( "focus" );
		return index;
	},

	_setOption: function( key, value ) {
		if ( key === "active" ) {

			// _activate() will handle invalid values and update this.options
			this._activate( value );
			return;
		}

		this._super( key, value );

		if ( key === "collapsible" ) {
			this._toggleClass( "ui-tabs-collapsible", null, value );

			// Setting collapsible: false while collapsed; open first panel
			if ( !value && this.options.active === false ) {
				this._activate( 0 );
			}
		}

		if ( key === "event" ) {
			this._setupEvents( value );
		}

		if ( key === "heightStyle" ) {
			this._setupHeightStyle( value );
		}
	},

	refresh: function() {
		var options = this.options,
			lis = this.tablist.children( ":has(a[href])" );

		// Get disabled tabs from class attribute from HTML
		// this will get converted to a boolean if needed in _refresh()
		options.disabled = $.map( lis.filter( ".ui-state-disabled" ), function( tab ) {
			return lis.index( tab );
		} );

		this._processTabs();

		// Was collapsed or no tabs
		if ( options.active === false || !this.anchors.length ) {
			options.active = false;
			this.active = $();

		// was active, but active tab is gone
		} else if ( this.active.length && !$.contains( this.tablist[ 0 ], this.active[ 0 ] ) ) {

			// all remaining tabs are disabled
			if ( this.tabs.length === options.disabled.length ) {
				options.active = false;
				this.active = $();

			// activate previous tab
			} else {
				this._activate( this._findNextTab( Math.max( 0, options.active - 1 ), false ) );
			}

		// was active, active tab still exists
		} else {

			// make sure active index is correct
			options.active = this.tabs.index( this.active );
		}

		this._refresh();
	},

	_refresh: function() {
		this._setOptionDisabled( this.options.disabled );
		this._setupEvents( this.options.event );
		this._setupHeightStyle( this.options.heightStyle );

		this.tabs.not( this.active ).attr( {
			"aria-selected": "false",
			"aria-expanded": "false",
			tabIndex: -1
		} );
		this.panels.not( this._getPanelForTab( this.active ) )
			.hide()
			.attr( {
				"aria-hidden": "true"
			} );

		// Make sure one tab is in the tab order
		if ( !this.active.length ) {
			this.tabs.eq( 0 ).attr( "tabIndex", 0 );
		} else {
			this.active
				.attr( {
					"aria-selected": "true",
					"aria-expanded": "true",
					tabIndex: 0
				} );
			this._addClass( this.active, "ui-tabs-active", "ui-state-active" );
			this._getPanelForTab( this.active )
				.show()
				.attr( {
					"aria-hidden": "false"
				} );
		}
	},

	_processTabs: function() {
		var that = this,
			prevTabs = this.tabs,
			prevAnchors = this.anchors,
			prevPanels = this.panels;

		this.tablist = this._getList().attr( "role", "tablist" );
		this._addClass( this.tablist, "ui-tabs-nav",
			"ui-helper-reset ui-helper-clearfix ui-widget-header" );

		// Prevent users from focusing disabled tabs via click
		this.tablist
			.on( "mousedown" + this.eventNamespace, "> li", function( event ) {
				if ( $( this ).is( ".ui-state-disabled" ) ) {
					event.preventDefault();
				}
			} );

		this.tabs = this.tablist.find( "> li:has(a[href])" )
			.attr( {
				role: "tab",
				tabIndex: -1
			} );
		this._addClass( this.tabs, "ui-tabs-tab", "ui-state-default" );

		this.anchors = this.tabs.map( function() {
			return $( "a", this )[ 0 ];
		} )
			.attr( {
				tabIndex: -1
			} );
		this._addClass( this.anchors, "ui-tabs-anchor" );

		this.panels = $();

		this.anchors.each( function( i, anchor ) {
			var selector, panel, panelId,
				anchorId = $( anchor ).uniqueId().attr( "id" ),
				tab = $( anchor ).closest( "li" ),
				originalAriaControls = tab.attr( "aria-controls" );

			// Inline tab
			if ( that._isLocal( anchor ) ) {
				selector = decodeURIComponent( anchor.hash );
				panelId = selector.substring( 1 );
				panel = that.element.find( "#" + CSS.escape( panelId ) );

			// remote tab
			} else {

				// If the tab doesn't already have aria-controls,
				// generate an id by using a throw-away element
				panelId = tab.attr( "aria-controls" ) || $( {} ).uniqueId()[ 0 ].id;
				selector = "#" + panelId;
				panel = that.element.find( selector );
				if ( !panel.length ) {
					panel = that._createPanel( panelId );
					panel.insertAfter( that.panels[ i - 1 ] || that.tablist );
				}
				panel.attr( "aria-live", "polite" );
			}

			if ( panel.length ) {
				that.panels = that.panels.add( panel );
			}
			if ( originalAriaControls ) {
				tab.data( "ui-tabs-aria-controls", originalAriaControls );
			}
			tab.attr( {
				"aria-controls": panelId,
				"aria-labelledby": anchorId
			} );
			panel.attr( "aria-labelledby", anchorId );
		} );

		this.panels.attr( "role", "tabpanel" );
		this._addClass( this.panels, "ui-tabs-panel", "ui-widget-content" );

		// Avoid memory leaks (#10056)
		if ( prevTabs ) {
			this._off( prevTabs.not( this.tabs ) );
			this._off( prevAnchors.not( this.anchors ) );
			this._off( prevPanels.not( this.panels ) );
		}
	},

	// Allow overriding how to find the list for rare usage scenarios (#7715)
	_getList: function() {
		return this.tablist || this.element.find( "ol, ul" ).eq( 0 );
	},

	_createPanel: function( id ) {
		return $( "<div>" )
			.attr( "id", id )
			.data( "ui-tabs-destroy", true );
	},

	_setOptionDisabled: function( disabled ) {
		var currentItem, li, i;

		if ( Array.isArray( disabled ) ) {
			if ( !disabled.length ) {
				disabled = false;
			} else if ( disabled.length === this.anchors.length ) {
				disabled = true;
			}
		}

		// Disable tabs
		for ( i = 0; ( li = this.tabs[ i ] ); i++ ) {
			currentItem = $( li );
			if ( disabled === true || $.inArray( i, disabled ) !== -1 ) {
				currentItem.attr( "aria-disabled", "true" );
				this._addClass( currentItem, null, "ui-state-disabled" );
			} else {
				currentItem.removeAttr( "aria-disabled" );
				this._removeClass( currentItem, null, "ui-state-disabled" );
			}
		}

		this.options.disabled = disabled;

		this._toggleClass( this.widget(), this.widgetFullName + "-disabled", null,
			disabled === true );
	},

	_setupEvents: function( event ) {
		var events = {};
		if ( event ) {
			$.each( event.split( " " ), function( index, eventName ) {
				events[ eventName ] = "_eventHandler";
			} );
		}

		this._off( this.anchors.add( this.tabs ).add( this.panels ) );

		// Always prevent the default action, even when disabled
		this._on( true, this.anchors, {
			click: function( event ) {
				event.preventDefault();
			}
		} );
		this._on( this.anchors, events );
		this._on( this.tabs, { keydown: "_tabKeydown" } );
		this._on( this.panels, { keydown: "_panelKeydown" } );

		this._focusable( this.tabs );
		this._hoverable( this.tabs );
	},

	_setupHeightStyle: function( heightStyle ) {
		var maxHeight,
			parent = this.element.parent();

		if ( heightStyle === "fill" ) {
			maxHeight = parent.height();
			maxHeight -= this.element.outerHeight() - this.element.height();

			this.element.siblings( ":visible" ).each( function() {
				var elem = $( this ),
					position = elem.css( "position" );

				if ( position === "absolute" || position === "fixed" ) {
					return;
				}
				maxHeight -= elem.outerHeight( true );
			} );

			this.element.children().not( this.panels ).each( function() {
				maxHeight -= $( this ).outerHeight( true );
			} );

			this.panels.each( function() {
				$( this ).height( Math.max( 0, maxHeight -
					$( this ).innerHeight() + $( this ).height() ) );
			} )
				.css( "overflow", "auto" );
		} else if ( heightStyle === "auto" ) {
			maxHeight = 0;
			this.panels.each( function() {
				maxHeight = Math.max( maxHeight, $( this ).height( "" ).height() );
			} ).height( maxHeight );
		}
	},

	_eventHandler: function( event ) {
		var options = this.options,
			active = this.active,
			anchor = $( event.currentTarget ),
			tab = anchor.closest( "li" ),
			clickedIsActive = tab[ 0 ] === active[ 0 ],
			collapsing = clickedIsActive && options.collapsible,
			toShow = collapsing ? $() : this._getPanelForTab( tab ),
			toHide = !active.length ? $() : this._getPanelForTab( active ),
			eventData = {
				oldTab: active,
				oldPanel: toHide,
				newTab: collapsing ? $() : tab,
				newPanel: toShow
			};

		event.preventDefault();

		if ( tab.hasClass( "ui-state-disabled" ) ||

				// tab is already loading
				tab.hasClass( "ui-tabs-loading" ) ||

				// can't switch durning an animation
				this.running ||

				// click on active header, but not collapsible
				( clickedIsActive && !options.collapsible ) ||

				// allow canceling activation
				( this._trigger( "beforeActivate", event, eventData ) === false ) ) {
			return;
		}

		options.active = collapsing ? false : this.tabs.index( tab );

		this.active = clickedIsActive ? $() : tab;
		if ( this.xhr ) {
			this.xhr.abort();
		}

		if ( !toHide.length && !toShow.length ) {
			$.error( "jQuery UI Tabs: Mismatching fragment identifier." );
		}

		if ( toShow.length ) {
			this.load( this.tabs.index( tab ), event );
		}
		this._toggle( event, eventData );
	},

	// Handles show/hide for selecting tabs
	_toggle: function( event, eventData ) {
		var that = this,
			toShow = eventData.newPanel,
			toHide = eventData.oldPanel;

		this.running = true;

		function complete() {
			that.running = false;
			that._trigger( "activate", event, eventData );
		}

		function show() {
			that._addClass( eventData.newTab.closest( "li" ), "ui-tabs-active", "ui-state-active" );

			if ( toShow.length && that.options.show ) {
				that._show( toShow, that.options.show, complete );
			} else {
				toShow.show();
				complete();
			}
		}

		// Start out by hiding, then showing, then completing
		if ( toHide.length && this.options.hide ) {
			this._hide( toHide, this.options.hide, function() {
				that._removeClass( eventData.oldTab.closest( "li" ),
					"ui-tabs-active", "ui-state-active" );
				show();
			} );
		} else {
			this._removeClass( eventData.oldTab.closest( "li" ),
				"ui-tabs-active", "ui-state-active" );
			toHide.hide();
			show();
		}

		toHide.attr( "aria-hidden", "true" );
		eventData.oldTab.attr( {
			"aria-selected": "false",
			"aria-expanded": "false"
		} );

		// If we're switching tabs, remove the old tab from the tab order.
		// If we're opening from collapsed state, remove the previous tab from the tab order.
		// If we're collapsing, then keep the collapsing tab in the tab order.
		if ( toShow.length && toHide.length ) {
			eventData.oldTab.attr( "tabIndex", -1 );
		} else if ( toShow.length ) {
			this.tabs.filter( function() {
				return $( this ).attr( "tabIndex" ) === 0;
			} )
				.attr( "tabIndex", -1 );
		}

		toShow.attr( "aria-hidden", "false" );
		eventData.newTab.attr( {
			"aria-selected": "true",
			"aria-expanded": "true",
			tabIndex: 0
		} );
	},

	_activate: function( index ) {
		var anchor,
			active = this._findActive( index );

		// Trying to activate the already active panel
		if ( active[ 0 ] === this.active[ 0 ] ) {
			return;
		}

		// Trying to collapse, simulate a click on the current active header
		if ( !active.length ) {
			active = this.active;
		}

		anchor = active.find( ".ui-tabs-anchor" )[ 0 ];
		this._eventHandler( {
			target: anchor,
			currentTarget: anchor,
			preventDefault: $.noop
		} );
	},

	_findActive: function( index ) {
		return index === false ? $() : this.tabs.eq( index );
	},

	_getIndex: function( index ) {

		// meta-function to give users option to provide a href string instead of a numerical index.
		if ( typeof index === "string" ) {
			index = this.anchors.index( this.anchors.filter( "[href$='" +
				CSS.escape( index ) + "']" ) );
		}

		return index;
	},

	_destroy: function() {
		if ( this.xhr ) {
			this.xhr.abort();
		}

		this.tablist
			.removeAttr( "role" )
			.off( this.eventNamespace );

		this.anchors
			.removeAttr( "role tabIndex" )
			.removeUniqueId();

		this.tabs.add( this.panels ).each( function() {
			if ( $.data( this, "ui-tabs-destroy" ) ) {
				$( this ).remove();
			} else {
				$( this ).removeAttr( "role tabIndex " +
					"aria-live aria-busy aria-selected aria-labelledby aria-hidden aria-expanded" );
			}
		} );

		this.tabs.each( function() {
			var li = $( this ),
				prev = li.data( "ui-tabs-aria-controls" );
			if ( prev ) {
				li
					.attr( "aria-controls", prev )
					.removeData( "ui-tabs-aria-controls" );
			} else {
				li.removeAttr( "aria-controls" );
			}
		} );

		this.panels.show();

		if ( this.options.heightStyle !== "content" ) {
			this.panels.css( "height", "" );
		}
	},

	enable: function( index ) {
		var disabled = this.options.disabled;
		if ( disabled === false ) {
			return;
		}

		if ( index === undefined ) {
			disabled = false;
		} else {
			index = this._getIndex( index );
			if ( Array.isArray( disabled ) ) {
				disabled = $.map( disabled, function( num ) {
					return num !== index ? num : null;
				} );
			} else {
				disabled = $.map( this.tabs, function( li, num ) {
					return num !== index ? num : null;
				} );
			}
		}
		this._setOptionDisabled( disabled );
	},

	disable: function( index ) {
		var disabled = this.options.disabled;
		if ( disabled === true ) {
			return;
		}

		if ( index === undefined ) {
			disabled = true;
		} else {
			index = this._getIndex( index );
			if ( $.inArray( index, disabled ) !== -1 ) {
				return;
			}
			if ( Array.isArray( disabled ) ) {
				disabled = $.merge( [ index ], disabled ).sort();
			} else {
				disabled = [ index ];
			}
		}
		this._setOptionDisabled( disabled );
	},

	load: function( index, event ) {
		index = this._getIndex( index );
		var that = this,
			tab = this.tabs.eq( index ),
			anchor = tab.find( ".ui-tabs-anchor" ),
			panel = this._getPanelForTab( tab ),
			eventData = {
				tab: tab,
				panel: panel
			},
			complete = function( jqXHR, status ) {
				if ( status === "abort" ) {
					that.panels.stop( false, true );
				}

				that._removeClass( tab, "ui-tabs-loading" );
				panel.removeAttr( "aria-busy" );

				if ( jqXHR === that.xhr ) {
					delete that.xhr;
				}
			};

		// Not remote
		if ( this._isLocal( anchor[ 0 ] ) ) {
			return;
		}

		this.xhr = $.ajax( this._ajaxSettings( anchor, event, eventData ) );

		if ( this.xhr.statusText !== "canceled" ) {
			this._addClass( tab, "ui-tabs-loading" );
			panel.attr( "aria-busy", "true" );

			this.xhr
				.done( function( response, status, jqXHR ) {
					panel.html( response );
					that._trigger( "load", event, eventData );

					complete( jqXHR, status );
				} )
				.fail( function( jqXHR, status ) {
					complete( jqXHR, status );
				} );
		}
	},

	_ajaxSettings: function( anchor, event, eventData ) {
		var that = this;
		return {
			url: anchor.attr( "href" ),
			beforeSend: function( jqXHR, settings ) {
				return that._trigger( "beforeLoad", event,
					$.extend( { jqXHR: jqXHR, ajaxSettings: settings }, eventData ) );
			}
		};
	},

	_getPanelForTab: function( tab ) {
		var id = $( tab ).attr( "aria-controls" );
		return this.element.find( "#" + CSS.escape( id ) );
	}
} );

// DEPRECATED
// TODO: Switch return back to widget declaration at top of file when this is removed
if ( $.uiBackCompat === true ) {

	// Backcompat for ui-tab class (now ui-tabs-tab)
	$.widget( "ui.tabs", $.ui.tabs, {
		_processTabs: function() {
			this._superApply( arguments );
			this._addClass( this.tabs, "ui-tab" );
		}
	} );
}

var widgetsTabs = $.ui.tabs;


/*!
 * jQuery UI Tooltip 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Tooltip
//>>group: Widgets
//>>description: Shows additional information for any element on hover or focus.
//>>docs: https://api.jqueryui.com/tooltip/
//>>demos: https://jqueryui.com/tooltip/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/tooltip.css
//>>css.theme: ../../themes/base/theme.css


$.widget( "ui.tooltip", {
	version: "1.14.1",
	options: {
		classes: {
			"ui-tooltip": "ui-corner-all ui-widget-shadow"
		},
		content: function() {
			var title = $( this ).attr( "title" );

			// Escape title, since we're going from an attribute to raw HTML
			return $( "<a>" ).text( title ).html();
		},
		hide: true,

		// Disabled elements have inconsistent behavior across browsers (#8661)
		items: "[title]:not([disabled])",
		position: {
			my: "left top+15",
			at: "left bottom",
			collision: "flipfit flip"
		},
		show: true,
		track: false,

		// Callbacks
		close: null,
		open: null
	},

	_addDescribedBy: function( elem, id ) {
		var describedby = ( elem.attr( "aria-describedby" ) || "" ).split( /\s+/ );
		describedby.push( id );
		elem
			.data( "ui-tooltip-id", id )
			.attr( "aria-describedby", String.prototype.trim.call( describedby.join( " " ) ) );
	},

	_removeDescribedBy: function( elem ) {
		var id = elem.data( "ui-tooltip-id" ),
			describedby = ( elem.attr( "aria-describedby" ) || "" ).split( /\s+/ ),
			index = $.inArray( id, describedby );

		if ( index !== -1 ) {
			describedby.splice( index, 1 );
		}

		elem.removeData( "ui-tooltip-id" );
		describedby = String.prototype.trim.call( describedby.join( " " ) );
		if ( describedby ) {
			elem.attr( "aria-describedby", describedby );
		} else {
			elem.removeAttr( "aria-describedby" );
		}
	},

	_create: function() {
		this._on( {
			mouseover: "open",
			focusin: "open"
		} );

		// IDs of generated tooltips, needed for destroy
		this.tooltips = {};

		// IDs of parent tooltips where we removed the title attribute
		this.parents = {};

		// Append the aria-live region so tooltips announce correctly
		this.liveRegion = $( "<div>" )
			.attr( {
				role: "log",
				"aria-live": "assertive",
				"aria-relevant": "additions"
			} )
			.appendTo( this.document[ 0 ].body );
		this._addClass( this.liveRegion, null, "ui-helper-hidden-accessible" );

		this.disabledTitles = $( [] );
	},

	_setOption: function( key, value ) {
		var that = this;

		this._super( key, value );

		if ( key === "content" ) {
			$.each( this.tooltips, function( id, tooltipData ) {
				that._updateContent( tooltipData.element );
			} );
		}
	},

	_setOptionDisabled: function( value ) {
		this[ value ? "_disable" : "_enable" ]();
	},

	_disable: function() {
		var that = this;

		// Close open tooltips
		$.each( this.tooltips, function( id, tooltipData ) {
			var event = $.Event( "blur" );
			event.target = event.currentTarget = tooltipData.element[ 0 ];
			that.close( event, true );
		} );

		// Remove title attributes to prevent native tooltips
		this.disabledTitles = this.disabledTitles.add(
			this.element.find( this.options.items ).addBack()
				.filter( function() {
					var element = $( this );
					if ( element.is( "[title]" ) ) {
						return element
							.data( "ui-tooltip-title", element.attr( "title" ) )
							.removeAttr( "title" );
					}
				} )
		);
	},

	_enable: function() {

		// restore title attributes
		this.disabledTitles.each( function() {
			var element = $( this );
			if ( element.data( "ui-tooltip-title" ) ) {
				element.attr( "title", element.data( "ui-tooltip-title" ) );
			}
		} );
		this.disabledTitles = $( [] );
	},

	open: function( event ) {
		var that = this,
			target = $( event ? event.target : this.element )

				// we need closest here due to mouseover bubbling,
				// but always pointing at the same event target
				.closest( this.options.items );

		// No element to show a tooltip for or the tooltip is already open
		if ( !target.length || target.data( "ui-tooltip-id" ) ) {
			return;
		}

		if ( target.attr( "title" ) ) {
			target.data( "ui-tooltip-title", target.attr( "title" ) );
		}

		target.data( "ui-tooltip-open", true );

		// Kill parent tooltips, custom or native, for hover
		if ( event && event.type === "mouseover" ) {
			target.parents().each( function() {
				var parent = $( this ),
					blurEvent;
				if ( parent.data( "ui-tooltip-open" ) ) {
					blurEvent = $.Event( "blur" );
					blurEvent.target = blurEvent.currentTarget = this;
					that.close( blurEvent, true );
				}
				if ( parent.attr( "title" ) ) {
					parent.uniqueId();
					that.parents[ this.id ] = {
						element: this,
						title: parent.attr( "title" )
					};
					parent.attr( "title", "" );
				}
			} );
		}

		this._registerCloseHandlers( event, target );
		this._updateContent( target, event );
	},

	_updateContent: function( target, event ) {
		var content,
			contentOption = this.options.content,
			that = this,
			eventType = event ? event.type : null;

		if ( typeof contentOption === "string" || contentOption.nodeType ||
				contentOption.jquery ) {
			return this._open( event, target, contentOption );
		}

		content = contentOption.call( target[ 0 ], function( response ) {

			// Ignore async response if tooltip was closed already
			if ( !target.data( "ui-tooltip-open" ) ) {
				return;
			}

			// JQuery creates a special event for focusin when it doesn't
			// exist natively. To improve performance, the native event
			// object is reused and the type is changed. Therefore, we can't
			// rely on the type being correct after the event finished
			// bubbling, so we set it back to the previous value. (#8740)
			if ( event ) {
				event.type = eventType;
			}
			that._open( event, target, response );
		} );
		if ( content ) {
			this._open( event, target, content );
		}
	},

	_open: function( event, target, content ) {
		var tooltipData, tooltip, delayedShow, a11yContent,
			positionOption = $.extend( {}, this.options.position );

		if ( !content ) {
			return;
		}

		// Content can be updated multiple times. If the tooltip already
		// exists, then just update the content and bail.
		tooltipData = this._find( target );
		if ( tooltipData ) {
			tooltipData.tooltip.find( ".ui-tooltip-content" ).html( content );
			return;
		}

		// If we have a title, clear it to prevent the native tooltip
		// we have to check first to avoid defining a title if none exists
		// (we don't want to cause an element to start matching [title])
		//
		// We use removeAttr only for key events, to allow IE to export the correct
		// accessible attributes. For mouse events, set to empty string to avoid
		// native tooltip showing up (happens only when removing inside mouseover).
		if ( target.is( "[title]" ) ) {
			if ( event && event.type === "mouseover" ) {
				target.attr( "title", "" );
			} else {
				target.removeAttr( "title" );
			}
		}

		tooltipData = this._tooltip( target );
		tooltip = tooltipData.tooltip;
		this._addDescribedBy( target, tooltip.attr( "id" ) );
		tooltip.find( ".ui-tooltip-content" ).html( content );

		// Support: Voiceover on OS X, JAWS on IE <= 9
		// JAWS announces deletions even when aria-relevant="additions"
		// Voiceover will sometimes re-read the entire log region's contents from the beginning
		this.liveRegion.children().hide();
		a11yContent = $( "<div>" ).html( tooltip.find( ".ui-tooltip-content" ).html() );
		a11yContent.removeAttr( "name" ).find( "[name]" ).removeAttr( "name" );
		a11yContent.removeAttr( "id" ).find( "[id]" ).removeAttr( "id" );
		a11yContent.appendTo( this.liveRegion );

		function position( event ) {
			positionOption.of = event;
			if ( tooltip.is( ":hidden" ) ) {
				return;
			}
			tooltip.position( positionOption );
		}
		if ( this.options.track && event && /^mouse/.test( event.type ) ) {
			this._on( this.document, {
				mousemove: position
			} );

			// trigger once to override element-relative positioning
			position( event );
		} else {
			tooltip.position( $.extend( {
				of: target
			}, this.options.position ) );
		}

		tooltip.hide();

		this._show( tooltip, this.options.show );

		// Handle tracking tooltips that are shown with a delay (#8644). As soon
		// as the tooltip is visible, position the tooltip using the most recent
		// event.
		// Adds the check to add the timers only when both delay and track options are set (#14682)
		if ( this.options.track && this.options.show && this.options.show.delay ) {
			delayedShow = this.delayedShow = setInterval( function() {
				if ( tooltip.is( ":visible" ) ) {
					position( positionOption.of );
					clearInterval( delayedShow );
				}
			}, 13 );
		}

		this._trigger( "open", event, { tooltip: tooltip } );
	},

	_registerCloseHandlers: function( event, target ) {
		var events = {
			keyup: function( event ) {
				if ( event.keyCode === $.ui.keyCode.ESCAPE ) {
					var fakeEvent = $.Event( event );
					fakeEvent.currentTarget = target[ 0 ];
					this.close( fakeEvent, true );
				}
			}
		};

		// Only bind remove handler for delegated targets. Non-delegated
		// tooltips will handle this in destroy.
		if ( target[ 0 ] !== this.element[ 0 ] ) {
			events.remove = function() {
				var targetElement = this._find( target );
				if ( targetElement ) {
					this._removeTooltip( targetElement.tooltip );
				}
			};
		}

		if ( !event || event.type === "mouseover" ) {
			events.mouseleave = "close";
		}
		if ( !event || event.type === "focusin" ) {
			events.focusout = "close";
		}
		this._on( true, target, events );
	},

	close: function( event ) {
		var tooltip,
			that = this,
			target = $( event ? event.currentTarget : this.element ),
			tooltipData = this._find( target );

		// The tooltip may already be closed
		if ( !tooltipData ) {

			// We set ui-tooltip-open immediately upon open (in open()), but only set the
			// additional data once there's actually content to show (in _open()). So even if the
			// tooltip doesn't have full data, we always remove ui-tooltip-open in case we're in
			// the period between open() and _open().
			target.removeData( "ui-tooltip-open" );
			return;
		}

		tooltip = tooltipData.tooltip;

		// Disabling closes the tooltip, so we need to track when we're closing
		// to avoid an infinite loop in case the tooltip becomes disabled on close
		if ( tooltipData.closing ) {
			return;
		}

		// Clear the interval for delayed tracking tooltips
		clearInterval( this.delayedShow );

		// Only set title if we had one before (see comment in _open())
		// If the title attribute has changed since open(), don't restore
		if ( target.data( "ui-tooltip-title" ) && !target.attr( "title" ) ) {
			target.attr( "title", target.data( "ui-tooltip-title" ) );
		}

		this._removeDescribedBy( target );

		tooltipData.hiding = true;
		tooltip.stop( true );
		this._hide( tooltip, this.options.hide, function() {
			that._removeTooltip( $( this ) );
		} );

		target.removeData( "ui-tooltip-open" );
		this._off( target, "mouseleave focusout keyup" );

		// Remove 'remove' binding only on delegated targets
		if ( target[ 0 ] !== this.element[ 0 ] ) {
			this._off( target, "remove" );
		}
		this._off( this.document, "mousemove" );

		if ( event && event.type === "mouseleave" ) {
			$.each( this.parents, function( id, parent ) {
				$( parent.element ).attr( "title", parent.title );
				delete that.parents[ id ];
			} );
		}

		tooltipData.closing = true;
		this._trigger( "close", event, { tooltip: tooltip } );
		if ( !tooltipData.hiding ) {
			tooltipData.closing = false;
		}
	},

	_tooltip: function( element ) {
		var tooltip = $( "<div>" ).attr( "role", "tooltip" ),
			content = $( "<div>" ).appendTo( tooltip ),
			id = tooltip.uniqueId().attr( "id" );

		this._addClass( content, "ui-tooltip-content" );
		this._addClass( tooltip, "ui-tooltip", "ui-widget ui-widget-content" );

		tooltip.appendTo( this._appendTo( element ) );

		return this.tooltips[ id ] = {
			element: element,
			tooltip: tooltip
		};
	},

	_find: function( target ) {
		var id = target.data( "ui-tooltip-id" );
		return id ? this.tooltips[ id ] : null;
	},

	_removeTooltip: function( tooltip ) {

		// Clear the interval for delayed tracking tooltips
		clearInterval( this.delayedShow );

		tooltip.remove();
		delete this.tooltips[ tooltip.attr( "id" ) ];
	},

	_appendTo: function( target ) {
		var element = target.closest( ".ui-front, dialog" );

		if ( !element.length ) {
			element = this.document[ 0 ].body;
		}

		return element;
	},

	_destroy: function() {
		var that = this;

		// Close open tooltips
		$.each( this.tooltips, function( id, tooltipData ) {

			// Delegate to close method to handle common cleanup
			var event = $.Event( "blur" ),
				element = tooltipData.element;
			event.target = event.currentTarget = element[ 0 ];
			that.close( event, true );

			// Remove immediately; destroying an open tooltip doesn't use the
			// hide animation
			$( "#" + id ).remove();

			// Restore the title
			if ( element.data( "ui-tooltip-title" ) ) {

				// If the title attribute has changed since open(), don't restore
				if ( !element.attr( "title" ) ) {
					element.attr( "title", element.data( "ui-tooltip-title" ) );
				}
				element.removeData( "ui-tooltip-title" );
			}
		} );
		this.liveRegion.remove();
	}
} );

// DEPRECATED
// TODO: Switch return back to widget declaration at top of file when this is removed
if ( $.uiBackCompat === true ) {

	// Backcompat for tooltipClass option
	$.widget( "ui.tooltip", $.ui.tooltip, {
		options: {
			tooltipClass: null
		},
		_tooltip: function() {
			var tooltipData = this._superApply( arguments );
			if ( this.options.tooltipClass ) {
				tooltipData.tooltip.addClass( this.options.tooltipClass );
			}
			return tooltipData;
		}
	} );
}

var widgetsTooltip = $.ui.tooltip;




} );
},
'jquery/jquery':function(){
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket trac-14549 for more info.
		module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
	"use strict";

	var arr = [];

	var getProto = Object.getPrototypeOf;

	var slice = arr.slice;

	var flat = arr.flat ? function( array ) {
		return arr.flat.call( array );
	} : function( array ) {
		return arr.concat.apply( [], array );
	};


	var push = arr.push;

	var indexOf = arr.indexOf;

	var class2type = {};

	var toString = class2type.toString;

	var hasOwn = class2type.hasOwnProperty;

	var fnToString = hasOwn.toString;

	var ObjectFunctionString = fnToString.call( Object );

	var support = {};

	var isFunction = function isFunction( obj ) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
		// Plus for old WebKit, typeof returns "function" for HTML collections
		// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
		return typeof obj === "function" && typeof obj.nodeType !== "number" &&
				typeof obj.item !== "function";
	};


	var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


	var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
				script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}

		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call( obj ) ] || "object" :
				typeof obj;
	}
	/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



	var version = "3.7.1",

			rhtmlSuffix = /HTML$/i,

			// Define a local copy of jQuery
			jQuery = function( selector, context ) {

				// The jQuery object is actually just the init constructor 'enhanced'
				// Need init if jQuery is called (just allow error to be thrown if not included)
				return new jQuery.fn.init( selector, context );
			};

	jQuery.fn = jQuery.prototype = {

		// The current version of jQuery being used
		jquery: version,

		constructor: jQuery,

		// The default length of a jQuery object is 0
		length: 0,

		toArray: function() {
			return slice.call( this );
		},

		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {

			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}

			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},

		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {

			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );

			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;

			// Return the newly-formed element set
			return ret;
		},

		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},

		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},

		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},

		first: function() {
			return this.eq( 0 );
		},

		last: function() {
			return this.eq( -1 );
		},

		even: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return ( i + 1 ) % 2;
			} ) );
		},

		odd: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return i % 2;
			} ) );
		},

		eq: function( i ) {
			var len = this.length,
					j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},

		end: function() {
			return this.prevObject || this.constructor();
		},

		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};

	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
				target = arguments[ 0 ] || {},
				i = 1,
				length = arguments.length,
				deep = false;

		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;

			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}

		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}

		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}

		for ( ; i < length; i++ ) {

			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {

				// Extend the base object
				for ( name in options ) {
					copy = options[ name ];

					// Prevent Object.prototype pollution
					// Prevent never-ending loop
					if ( name === "__proto__" || target === copy ) {
						continue;
					}

					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
							( copyIsArray = Array.isArray( copy ) ) ) ) {
						src = target[ name ];

						// Ensure proper type for the source value
						if ( copyIsArray && !Array.isArray( src ) ) {
							clone = [];
						} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
							clone = {};
						} else {
							clone = src;
						}
						copyIsArray = false;

						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );

						// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}

		// Return the modified object
		return target;
	};

	jQuery.extend( {

		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

		// Assume jQuery is ready without the ready module
		isReady: true,

		error: function( msg ) {
			throw new Error( msg );
		},

		noop: function() {},

		isPlainObject: function( obj ) {
			var proto, Ctor;

			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}

			proto = getProto( obj );

			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}

			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},

		isEmptyObject: function( obj ) {
			var name;

			for ( name in obj ) {
				return false;
			}
			return true;
		},

		// Evaluates a script in a provided context; falls back to the global one
		// if not specified.
		globalEval: function( code, options, doc ) {
			DOMEval( code, { nonce: options && options.nonce }, doc );
		},

		each: function( obj, callback ) {
			var length, i = 0;

			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}

			return obj;
		},


		// Retrieve the text value of an array of DOM nodes
		text: function( elem ) {
			var node,
					ret = "",
					i = 0,
					nodeType = elem.nodeType;

			if ( !nodeType ) {

				// If no nodeType, this is expected to be an array
				while ( ( node = elem[ i++ ] ) ) {

					// Do not traverse comment nodes
					ret += jQuery.text( node );
				}
			}
			if ( nodeType === 1 || nodeType === 11 ) {
				return elem.textContent;
			}
			if ( nodeType === 9 ) {
				return elem.documentElement.textContent;
			}
			if ( nodeType === 3 || nodeType === 4 ) {
				return elem.nodeValue;
			}

			// Do not include comment or processing instruction nodes

			return ret;
		},

		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];

			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
							typeof arr === "string" ?
									[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}

			return ret;
		},

		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},

		isXMLDoc: function( elem ) {
			var namespace = elem && elem.namespaceURI,
					docElem = elem && ( elem.ownerDocument || elem ).documentElement;

			// Assume HTML when documentElement doesn't yet exist, such as inside
			// document fragments.
			return !rhtmlSuffix.test( namespace || docElem && docElem.nodeName || "HTML" );
		},

		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
					j = 0,
					i = first.length;

			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}

			first.length = i;

			return first;
		},

		grep: function( elems, callback, invert ) {
			var callbackInverse,
					matches = [],
					i = 0,
					length = elems.length,
					callbackExpect = !invert;

			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}

			return matches;
		},

		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
					i = 0,
					ret = [];

			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );

					if ( value != null ) {
						ret.push( value );
					}
				}

				// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );

					if ( value != null ) {
						ret.push( value );
					}
				}
			}

			// Flatten any nested arrays
			return flat( ret );
		},

		// A global GUID counter for objects
		guid: 1,

		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );

	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}

// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
			function( _i, name ) {
				class2type[ "[object " + name + "]" ] = name.toLowerCase();
			} );

	function isArrayLike( obj ) {

		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
				type = toType( obj );

		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}

		return type === "array" || length === 0 ||
				typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}


	function nodeName( elem, name ) {

		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

	}
	var pop = arr.pop;


	var sort = arr.sort;


	var splice = arr.splice;


	var whitespace = "[\\x20\\t\\r\\n\\f]";


	var rtrimCSS = new RegExp(
			"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
			"g"
	);




// Note: an element does not contain itself
	jQuery.contains = function( a, b ) {
		var bup = b && b.parentNode;

		return a === bup || !!( bup && bup.nodeType === 1 && (

				// Support: IE 9 - 11+
				// IE doesn't have `contains` on SVG.
				a.contains ?
						a.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
		) );
	};




// CSS string/identifier serialization
// https://drafts.csswg.org/cssom/#common-serializing-idioms
	var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;

	function fcssescape( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	}

	jQuery.escapeSelector = function( sel ) {
		return ( sel + "" ).replace( rcssescape, fcssescape );
	};




	var preferredDoc = document,
			pushNative = push;

	( function() {

		var i,
				Expr,
				outermostContext,
				sortInput,
				hasDuplicate,
				push = pushNative,

				// Local document vars
				document,
				documentElement,
				documentIsHTML,
				rbuggyQSA,
				matches,

				// Instance-specific data
				expando = jQuery.expando,
				dirruns = 0,
				done = 0,
				classCache = createCache(),
				tokenCache = createCache(),
				compilerCache = createCache(),
				nonnativeSelectorCache = createCache(),
				sortOrder = function( a, b ) {
					if ( a === b ) {
						hasDuplicate = true;
					}
					return 0;
				},

				booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|" +
						"loop|multiple|open|readonly|required|scoped",

				// Regular expressions

				// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
				identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
						"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

				// Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
				attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

						// Operator (capture 2)
						"*([*^$|!~]?=)" + whitespace +

						// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
						"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
						whitespace + "*\\]",

				pseudos = ":(" + identifier + ")(?:\\((" +

						// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
						// 1. quoted (capture 3; capture 4 or capture 5)
						"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

						// 2. simple (capture 6)
						"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

						// 3. anything else (capture 2)
						".*" +
						")\\)|)",

				// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
				rwhitespace = new RegExp( whitespace + "+", "g" ),

				rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
				rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" +
						whitespace + "*" ),
				rdescend = new RegExp( whitespace + "|>" ),

				rpseudo = new RegExp( pseudos ),
				ridentifier = new RegExp( "^" + identifier + "$" ),

				matchExpr = {
					ID: new RegExp( "^#(" + identifier + ")" ),
					CLASS: new RegExp( "^\\.(" + identifier + ")" ),
					TAG: new RegExp( "^(" + identifier + "|[*])" ),
					ATTR: new RegExp( "^" + attributes ),
					PSEUDO: new RegExp( "^" + pseudos ),
					CHILD: new RegExp(
							"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
							whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
							whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
					bool: new RegExp( "^(?:" + booleans + ")$", "i" ),

					// For use in libraries implementing .is()
					// We use this for POS matching in `select`
					needsContext: new RegExp( "^" + whitespace +
							"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
							"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
				},

				rinputs = /^(?:input|select|textarea|button)$/i,
				rheader = /^h\d$/i,

				// Easily-parseable/retrievable ID or TAG or CLASS selectors
				rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

				rsibling = /[+~]/,

				// CSS escapes
				// https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
				runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace +
						"?|\\\\([^\\r\\n\\f])", "g" ),
				funescape = function( escape, nonHex ) {
					var high = "0x" + escape.slice( 1 ) - 0x10000;

					if ( nonHex ) {

						// Strip the backslash prefix from a non-hex escape sequence
						return nonHex;
					}

					// Replace a hexadecimal escape sequence with the encoded Unicode code point
					// Support: IE <=11+
					// For values outside the Basic Multilingual Plane (BMP), manually construct a
					// surrogate pair
					return high < 0 ?
							String.fromCharCode( high + 0x10000 ) :
							String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
				},

				// Used for iframes; see `setDocument`.
				// Support: IE 9 - 11+, Edge 12 - 18+
				// Removing the function wrapper causes a "Permission Denied"
				// error in IE/Edge.
				unloadHandler = function() {
					setDocument();
				},

				inDisabledFieldset = addCombinator(
						function( elem ) {
							return elem.disabled === true && nodeName( elem, "fieldset" );
						},
						{ dir: "parentNode", next: "legend" }
				);

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
		function safeActiveElement() {
			try {
				return document.activeElement;
			} catch ( err ) { }
		}

// Optimize for push.apply( _, NodeList )
		try {
			push.apply(
					( arr = slice.call( preferredDoc.childNodes ) ),
					preferredDoc.childNodes
			);

			// Support: Android <=4.0
			// Detect silently failing push.apply
			// eslint-disable-next-line no-unused-expressions
			arr[ preferredDoc.childNodes.length ].nodeType;
		} catch ( e ) {
			push = {
				apply: function( target, els ) {
					pushNative.apply( target, slice.call( els ) );
				},
				call: function( target ) {
					pushNative.apply( target, slice.call( arguments, 1 ) );
				}
			};
		}

		function find( selector, context, results, seed ) {
			var m, i, elem, nid, match, groups, newSelector,
					newContext = context && context.ownerDocument,

					// nodeType defaults to 9, since context defaults to document
					nodeType = context ? context.nodeType : 9;

			results = results || [];

			// Return early from calls with invalid selector or context
			if ( typeof selector !== "string" || !selector ||
					nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

				return results;
			}

			// Try to shortcut find operations (as opposed to filters) in HTML documents
			if ( !seed ) {
				setDocument( context );
				context = context || document;

				if ( documentIsHTML ) {

					// If the selector is sufficiently simple, try using a "get*By*" DOM method
					// (excepting DocumentFragment context, where the methods don't exist)
					if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

						// ID selector
						if ( ( m = match[ 1 ] ) ) {

							// Document context
							if ( nodeType === 9 ) {
								if ( ( elem = context.getElementById( m ) ) ) {

									// Support: IE 9 only
									// getElementById can match elements by name instead of ID
									if ( elem.id === m ) {
										push.call( results, elem );
										return results;
									}
								} else {
									return results;
								}

								// Element context
							} else {

								// Support: IE 9 only
								// getElementById can match elements by name instead of ID
								if ( newContext && ( elem = newContext.getElementById( m ) ) &&
										find.contains( context, elem ) &&
										elem.id === m ) {

									push.call( results, elem );
									return results;
								}
							}

							// Type selector
						} else if ( match[ 2 ] ) {
							push.apply( results, context.getElementsByTagName( selector ) );
							return results;

							// Class selector
						} else if ( ( m = match[ 3 ] ) && context.getElementsByClassName ) {
							push.apply( results, context.getElementsByClassName( m ) );
							return results;
						}
					}

					// Take advantage of querySelectorAll
					if ( !nonnativeSelectorCache[ selector + " " ] &&
							( !rbuggyQSA || !rbuggyQSA.test( selector ) ) ) {

						newSelector = selector;
						newContext = context;

						// qSA considers elements outside a scoping root when evaluating child or
						// descendant combinators, which is not what we want.
						// In such cases, we work around the behavior by prefixing every selector in the
						// list with an ID selector referencing the scope context.
						// The technique has to be used as well when a leading combinator is used
						// as such selectors are not recognized by querySelectorAll.
						// Thanks to Andrew Dupont for this technique.
						if ( nodeType === 1 &&
								( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {

							// Expand context for sibling selectors
							newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
									context;

							// We can use :scope instead of the ID hack if the browser
							// supports it & if we're not changing the context.
							// Support: IE 11+, Edge 17 - 18+
							// IE/Edge sometimes throw a "Permission denied" error when
							// strict-comparing two documents; shallow comparisons work.
							// eslint-disable-next-line eqeqeq
							if ( newContext != context || !support.scope ) {

								// Capture the context ID, setting it first if necessary
								if ( ( nid = context.getAttribute( "id" ) ) ) {
									nid = jQuery.escapeSelector( nid );
								} else {
									context.setAttribute( "id", ( nid = expando ) );
								}
							}

							// Prefix every selector in the list
							groups = tokenize( selector );
							i = groups.length;
							while ( i-- ) {
								groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
										toSelector( groups[ i ] );
							}
							newSelector = groups.join( "," );
						}

						try {
							push.apply( results,
									newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
							nonnativeSelectorCache( selector, true );
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}

			// All others
			return select( selector.replace( rtrimCSS, "$1" ), context, results, seed );
		}

		/**
		 * Create key-value caches of limited size
		 * @returns {function(string, object)} Returns the Object data after storing it on itself with
		 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
		 *	deleting the oldest entry
		 */
		function createCache() {
			var keys = [];

			function cache( key, value ) {

				// Use (key + " ") to avoid collision with native prototype properties
				// (see https://github.com/jquery/sizzle/issues/157)
				if ( keys.push( key + " " ) > Expr.cacheLength ) {

					// Only keep the most recent entries
					delete cache[ keys.shift() ];
				}
				return ( cache[ key + " " ] = value );
			}
			return cache;
		}

		/**
		 * Mark a function for special use by jQuery selector module
		 * @param {Function} fn The function to mark
		 */
		function markFunction( fn ) {
			fn[ expando ] = true;
			return fn;
		}

		/**
		 * Support testing using an element
		 * @param {Function} fn Passed the created element and returns a boolean result
		 */
		function assert( fn ) {
			var el = document.createElement( "fieldset" );

			try {
				return !!fn( el );
			} catch ( e ) {
				return false;
			} finally {

				// Remove from its parent by default
				if ( el.parentNode ) {
					el.parentNode.removeChild( el );
				}

				// release memory in IE
				el = null;
			}
		}

		/**
		 * Returns a function to use in pseudos for input types
		 * @param {String} type
		 */
		function createInputPseudo( type ) {
			return function( elem ) {
				return nodeName( elem, "input" ) && elem.type === type;
			};
		}

		/**
		 * Returns a function to use in pseudos for buttons
		 * @param {String} type
		 */
		function createButtonPseudo( type ) {
			return function( elem ) {
				return ( nodeName( elem, "input" ) || nodeName( elem, "button" ) ) &&
						elem.type === type;
			};
		}

		/**
		 * Returns a function to use in pseudos for :enabled/:disabled
		 * @param {Boolean} disabled true for :disabled; false for :enabled
		 */
		function createDisabledPseudo( disabled ) {

			// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
			return function( elem ) {

				// Only certain elements can match :enabled or :disabled
				// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
				// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
				if ( "form" in elem ) {

					// Check for inherited disabledness on relevant non-disabled elements:
					// * listed form-associated elements in a disabled fieldset
					//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
					//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
					// * option elements in a disabled optgroup
					//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
					// All such elements have a "form" property.
					if ( elem.parentNode && elem.disabled === false ) {

						// Option elements defer to a parent optgroup if present
						if ( "label" in elem ) {
							if ( "label" in elem.parentNode ) {
								return elem.parentNode.disabled === disabled;
							} else {
								return elem.disabled === disabled;
							}
						}

						// Support: IE 6 - 11+
						// Use the isDisabled shortcut property to check for disabled fieldset ancestors
						return elem.isDisabled === disabled ||

								// Where there is no isDisabled, check manually
								elem.isDisabled !== !disabled &&
								inDisabledFieldset( elem ) === disabled;
					}

					return elem.disabled === disabled;

					// Try to winnow out elements that can't be disabled before trusting the disabled property.
					// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
					// even exist on them, let alone have a boolean value.
				} else if ( "label" in elem ) {
					return elem.disabled === disabled;
				}

				// Remaining elements are neither :enabled nor :disabled
				return false;
			};
		}

		/**
		 * Returns a function to use in pseudos for positionals
		 * @param {Function} fn
		 */
		function createPositionalPseudo( fn ) {
			return markFunction( function( argument ) {
				argument = +argument;
				return markFunction( function( seed, matches ) {
					var j,
							matchIndexes = fn( [], seed.length, argument ),
							i = matchIndexes.length;

					// Match elements found at the specified indexes
					while ( i-- ) {
						if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
							seed[ j ] = !( matches[ j ] = seed[ j ] );
						}
					}
				} );
			} );
		}

		/**
		 * Checks a node for validity as a jQuery selector context
		 * @param {Element|Object=} context
		 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
		 */
		function testContext( context ) {
			return context && typeof context.getElementsByTagName !== "undefined" && context;
		}

		/**
		 * Sets document-related variables once based on the current document
		 * @param {Element|Object} [node] An element or document object to use to set the document
		 * @returns {Object} Returns the current document
		 */
		function setDocument( node ) {
			var subWindow,
					doc = node ? node.ownerDocument || node : preferredDoc;

			// Return early if doc is invalid or already selected
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
				return document;
			}

			// Update global variables
			document = doc;
			documentElement = document.documentElement;
			documentIsHTML = !jQuery.isXMLDoc( document );

			// Support: iOS 7 only, IE 9 - 11+
			// Older browsers didn't support unprefixed `matches`.
			matches = documentElement.matches ||
					documentElement.webkitMatchesSelector ||
					documentElement.msMatchesSelector;

			// Support: IE 9 - 11+, Edge 12 - 18+
			// Accessing iframe documents after unload throws "permission denied" errors
			// (see trac-13936).
			// Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
			// all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
			if ( documentElement.msMatchesSelector &&

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					preferredDoc != document &&
					( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

				// Support: IE 9 - 11+, Edge 12 - 18+
				subWindow.addEventListener( "unload", unloadHandler );
			}

			// Support: IE <10
			// Check if getElementById returns elements by name
			// The broken getElementById methods don't pick up programmatically-set names,
			// so use a roundabout getElementsByName test
			support.getById = assert( function( el ) {
				documentElement.appendChild( el ).id = jQuery.expando;
				return !document.getElementsByName ||
						!document.getElementsByName( jQuery.expando ).length;
			} );

			// Support: IE 9 only
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node.
			support.disconnectedMatch = assert( function( el ) {
				return matches.call( el, "*" );
			} );

			// Support: IE 9 - 11+, Edge 12 - 18+
			// IE/Edge don't support the :scope pseudo-class.
			support.scope = assert( function() {
				return document.querySelectorAll( ":scope" );
			} );

			// Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
			// Make sure the `:has()` argument is parsed unforgivingly.
			// We include `*` in the test to detect buggy implementations that are
			// _selectively_ forgiving (specifically when the list includes at least
			// one valid selector).
			// Note that we treat complete lack of support for `:has()` as if it were
			// spec-compliant support, which is fine because use of `:has()` in such
			// environments will fail in the qSA path and fall back to jQuery traversal
			// anyway.
			support.cssHas = assert( function() {
				try {
					document.querySelector( ":has(*,:jqfake)" );
					return false;
				} catch ( e ) {
					return true;
				}
			} );

			// ID filter and find
			if ( support.getById ) {
				Expr.filter.ID = function( id ) {
					var attrId = id.replace( runescape, funescape );
					return function( elem ) {
						return elem.getAttribute( "id" ) === attrId;
					};
				};
				Expr.find.ID = function( id, context ) {
					if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
						var elem = context.getElementById( id );
						return elem ? [ elem ] : [];
					}
				};
			} else {
				Expr.filter.ID =  function( id ) {
					var attrId = id.replace( runescape, funescape );
					return function( elem ) {
						var node = typeof elem.getAttributeNode !== "undefined" &&
								elem.getAttributeNode( "id" );
						return node && node.value === attrId;
					};
				};

				// Support: IE 6 - 7 only
				// getElementById is not reliable as a find shortcut
				Expr.find.ID = function( id, context ) {
					if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
						var node, i, elems,
								elem = context.getElementById( id );

						if ( elem ) {

							// Verify the id attribute
							node = elem.getAttributeNode( "id" );
							if ( node && node.value === id ) {
								return [ elem ];
							}

							// Fall back on getElementsByName
							elems = context.getElementsByName( id );
							i = 0;
							while ( ( elem = elems[ i++ ] ) ) {
								node = elem.getAttributeNode( "id" );
								if ( node && node.value === id ) {
									return [ elem ];
								}
							}
						}

						return [];
					}
				};
			}

			// Tag
			Expr.find.TAG = function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );

					// DocumentFragment nodes don't have gEBTN
				} else {
					return context.querySelectorAll( tag );
				}
			};

			// Class
			Expr.find.CLASS = function( className, context ) {
				if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
					return context.getElementsByClassName( className );
				}
			};

			/* QSA/matchesSelector
	---------------------------------------------------------------------- */

			// QSA and matchesSelector support

			rbuggyQSA = [];

			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert( function( el ) {

				var input;

				documentElement.appendChild( el ).innerHTML =
						"<a id='" + expando + "' href='' disabled='disabled'></a>" +
						"<select id='" + expando + "-\r\\' disabled='disabled'>" +
						"<option selected=''></option></select>";

				// Support: iOS <=7 - 8 only
				// Boolean attributes and "value" are not treated correctly in some XML documents
				if ( !el.querySelectorAll( "[selected]" ).length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}

				// Support: iOS <=7 - 8 only
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push( "~=" );
				}

				// Support: iOS 8 only
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push( ".#.+[+~]" );
				}

				// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
				// In some of the document kinds, these selectors wouldn't work natively.
				// This is probably OK but for backwards compatibility we want to maintain
				// handling them through jQuery traversal in jQuery 3.x.
				if ( !el.querySelectorAll( ":checked" ).length ) {
					rbuggyQSA.push( ":checked" );
				}

				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				input = document.createElement( "input" );
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );

				// Support: IE 9 - 11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
				// In some of the document kinds, these selectors wouldn't work natively.
				// This is probably OK but for backwards compatibility we want to maintain
				// handling them through jQuery traversal in jQuery 3.x.
				documentElement.appendChild( el ).disabled = true;
				if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}

				// Support: IE 11+, Edge 15 - 18+
				// IE 11/Edge don't find elements on a `[name='']` query in some cases.
				// Adding a temporary attribute to the document before the selection works
				// around the issue.
				// Interestingly, IE 10 & older don't seem to have the issue.
				input = document.createElement( "input" );
				input.setAttribute( "name", "" );
				el.appendChild( input );
				if ( !el.querySelectorAll( "[name='']" ).length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
							whitespace + "*(?:''|\"\")" );
				}
			} );

			if ( !support.cssHas ) {

				// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
				// Our regular `try-catch` mechanism fails to detect natively-unsupported
				// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
				// in browsers that parse the `:has()` argument as a forgiving selector list.
				// https://drafts.csswg.org/selectors/#relational now requires the argument
				// to be parsed unforgivingly, but browsers have not yet fully adjusted.
				rbuggyQSA.push( ":has" );
			}

			rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );

			/* Sorting
	---------------------------------------------------------------------- */

			// Document order sorting
			sortOrder = function( a, b ) {

				// Flag for duplicate removal
				if ( a === b ) {
					hasDuplicate = true;
					return 0;
				}

				// Sort on method existence if only one input has compareDocumentPosition
				var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
				if ( compare ) {
					return compare;
				}

				// Calculate position if both inputs belong to the same document
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
						a.compareDocumentPosition( b ) :

						// Otherwise we know they are disconnected
						1;

				// Disconnected nodes
				if ( compare & 1 ||
						( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

					// Choose the first element that is related to our preferred document
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( a === document || a.ownerDocument == preferredDoc &&
							find.contains( preferredDoc, a ) ) {
						return -1;
					}

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( b === document || b.ownerDocument == preferredDoc &&
							find.contains( preferredDoc, b ) ) {
						return 1;
					}

					// Maintain original order
					return sortInput ?
							( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
							0;
				}

				return compare & 4 ? -1 : 1;
			};

			return document;
		}

		find.matches = function( expr, elements ) {
			return find( expr, null, null, elements );
		};

		find.matchesSelector = function( elem, expr ) {
			setDocument( elem );

			if ( documentIsHTML &&
					!nonnativeSelectorCache[ expr + " " ] &&
					( !rbuggyQSA || !rbuggyQSA.test( expr ) ) ) {

				try {
					var ret = matches.call( elem, expr );

					// IE 9's matchesSelector returns false on disconnected nodes
					if ( ret || support.disconnectedMatch ||

							// As well, disconnected nodes are said to be in a document
							// fragment in IE 9
							elem.document && elem.document.nodeType !== 11 ) {
						return ret;
					}
				} catch ( e ) {
					nonnativeSelectorCache( expr, true );
				}
			}

			return find( expr, document, null, [ elem ] ).length > 0;
		};

		find.contains = function( context, elem ) {

			// Set document vars if needed
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( ( context.ownerDocument || context ) != document ) {
				setDocument( context );
			}
			return jQuery.contains( context, elem );
		};


		find.attr = function( elem, name ) {

			// Set document vars if needed
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( ( elem.ownerDocument || elem ) != document ) {
				setDocument( elem );
			}

			var fn = Expr.attrHandle[ name.toLowerCase() ],

					// Don't get fooled by Object.prototype properties (see trac-13807)
					val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
							fn( elem, name, !documentIsHTML ) :
							undefined;

			if ( val !== undefined ) {
				return val;
			}

			return elem.getAttribute( name );
		};

		find.error = function( msg ) {
			throw new Error( "Syntax error, unrecognized expression: " + msg );
		};

		/**
		 * Document sorting and removing duplicates
		 * @param {ArrayLike} results
		 */
		jQuery.uniqueSort = function( results ) {
			var elem,
					duplicates = [],
					j = 0,
					i = 0;

			// Unless we *know* we can detect duplicates, assume their presence
			//
			// Support: Android <=4.0+
			// Testing for detecting duplicates is unpredictable so instead assume we can't
			// depend on duplicate detection in all browsers without a stable sort.
			hasDuplicate = !support.sortStable;
			sortInput = !support.sortStable && slice.call( results, 0 );
			sort.call( results, sortOrder );

			if ( hasDuplicate ) {
				while ( ( elem = results[ i++ ] ) ) {
					if ( elem === results[ i ] ) {
						j = duplicates.push( i );
					}
				}
				while ( j-- ) {
					splice.call( results, duplicates[ j ], 1 );
				}
			}

			// Clear input after sorting to release objects
			// See https://github.com/jquery/sizzle/pull/225
			sortInput = null;

			return results;
		};

		jQuery.fn.uniqueSort = function() {
			return this.pushStack( jQuery.uniqueSort( slice.apply( this ) ) );
		};

		Expr = jQuery.expr = {

			// Can be adjusted by the user
			cacheLength: 50,

			createPseudo: markFunction,

			match: matchExpr,

			attrHandle: {},

			find: {},

			relative: {
				">": { dir: "parentNode", first: true },
				" ": { dir: "parentNode" },
				"+": { dir: "previousSibling", first: true },
				"~": { dir: "previousSibling" }
			},

			preFilter: {
				ATTR: function( match ) {
					match[ 1 ] = match[ 1 ].replace( runescape, funescape );

					// Move the given value to match[3] whether quoted or unquoted
					match[ 3 ] = ( match[ 3 ] || match[ 4 ] || match[ 5 ] || "" )
							.replace( runescape, funescape );

					if ( match[ 2 ] === "~=" ) {
						match[ 3 ] = " " + match[ 3 ] + " ";
					}

					return match.slice( 0, 4 );
				},

				CHILD: function( match ) {

					/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
					match[ 1 ] = match[ 1 ].toLowerCase();

					if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

						// nth-* requires argument
						if ( !match[ 3 ] ) {
							find.error( match[ 0 ] );
						}

						// numeric x and y parameters for Expr.filter.CHILD
						// remember that false/true cast respectively to 0/1
						match[ 4 ] = +( match[ 4 ] ?
										match[ 5 ] + ( match[ 6 ] || 1 ) :
										2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" )
						);
						match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

						// other types prohibit arguments
					} else if ( match[ 3 ] ) {
						find.error( match[ 0 ] );
					}

					return match;
				},

				PSEUDO: function( match ) {
					var excess,
							unquoted = !match[ 6 ] && match[ 2 ];

					if ( matchExpr.CHILD.test( match[ 0 ] ) ) {
						return null;
					}

					// Accept quoted arguments as-is
					if ( match[ 3 ] ) {
						match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

						// Strip excess characters from unquoted arguments
					} else if ( unquoted && rpseudo.test( unquoted ) &&

							// Get excess from tokenize (recursively)
							( excess = tokenize( unquoted, true ) ) &&

							// advance to the next closing parenthesis
							( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

						// excess is a negative index
						match[ 0 ] = match[ 0 ].slice( 0, excess );
						match[ 2 ] = unquoted.slice( 0, excess );
					}

					// Return only captures needed by the pseudo filter method (type and argument)
					return match.slice( 0, 3 );
				}
			},

			filter: {

				TAG: function( nodeNameSelector ) {
					var expectedNodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
					return nodeNameSelector === "*" ?
							function() {
								return true;
							} :
							function( elem ) {
								return nodeName( elem, expectedNodeName );
							};
				},

				CLASS: function( className ) {
					var pattern = classCache[ className + " " ];

					return pattern ||
							( pattern = new RegExp( "(^|" + whitespace + ")" + className +
									"(" + whitespace + "|$)" ) ) &&
							classCache( className, function( elem ) {
								return pattern.test(
										typeof elem.className === "string" && elem.className ||
										typeof elem.getAttribute !== "undefined" &&
										elem.getAttribute( "class" ) ||
										""
								);
							} );
				},

				ATTR: function( name, operator, check ) {
					return function( elem ) {
						var result = find.attr( elem, name );

						if ( result == null ) {
							return operator === "!=";
						}
						if ( !operator ) {
							return true;
						}

						result += "";

						if ( operator === "=" ) {
							return result === check;
						}
						if ( operator === "!=" ) {
							return result !== check;
						}
						if ( operator === "^=" ) {
							return check && result.indexOf( check ) === 0;
						}
						if ( operator === "*=" ) {
							return check && result.indexOf( check ) > -1;
						}
						if ( operator === "$=" ) {
							return check && result.slice( -check.length ) === check;
						}
						if ( operator === "~=" ) {
							return ( " " + result.replace( rwhitespace, " " ) + " " )
									.indexOf( check ) > -1;
						}
						if ( operator === "|=" ) {
							return result === check || result.slice( 0, check.length + 1 ) === check + "-";
						}

						return false;
					};
				},

				CHILD: function( type, what, _argument, first, last ) {
					var simple = type.slice( 0, 3 ) !== "nth",
							forward = type.slice( -4 ) !== "last",
							ofType = what === "of-type";

					return first === 1 && last === 0 ?

							// Shortcut for :nth-*(n)
							function( elem ) {
								return !!elem.parentNode;
							} :

							function( elem, _context, xml ) {
								var cache, outerCache, node, nodeIndex, start,
										dir = simple !== forward ? "nextSibling" : "previousSibling",
										parent = elem.parentNode,
										name = ofType && elem.nodeName.toLowerCase(),
										useCache = !xml && !ofType,
										diff = false;

								if ( parent ) {

									// :(first|last|only)-(child|of-type)
									if ( simple ) {
										while ( dir ) {
											node = elem;
											while ( ( node = node[ dir ] ) ) {
												if ( ofType ?
														nodeName( node, name ) :
														node.nodeType === 1 ) {

													return false;
												}
											}

											// Reverse direction for :only-* (if we haven't yet done so)
											start = dir = type === "only" && !start && "nextSibling";
										}
										return true;
									}

									start = [ forward ? parent.firstChild : parent.lastChild ];

									// non-xml :nth-child(...) stores cache data on `parent`
									if ( forward && useCache ) {

										// Seek `elem` from a previously-cached index
										outerCache = parent[ expando ] || ( parent[ expando ] = {} );
										cache = outerCache[ type ] || [];
										nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
										diff = nodeIndex && cache[ 2 ];
										node = nodeIndex && parent.childNodes[ nodeIndex ];

										while ( ( node = ++nodeIndex && node && node[ dir ] ||

												// Fallback to seeking `elem` from the start
												( diff = nodeIndex = 0 ) || start.pop() ) ) {

											// When found, cache indexes on `parent` and break
											if ( node.nodeType === 1 && ++diff && node === elem ) {
												outerCache[ type ] = [ dirruns, nodeIndex, diff ];
												break;
											}
										}

									} else {

										// Use previously-cached element index if available
										if ( useCache ) {
											outerCache = elem[ expando ] || ( elem[ expando ] = {} );
											cache = outerCache[ type ] || [];
											nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
											diff = nodeIndex;
										}

										// xml :nth-child(...)
										// or :nth-last-child(...) or :nth(-last)?-of-type(...)
										if ( diff === false ) {

											// Use the same loop as above to seek `elem` from the start
											while ( ( node = ++nodeIndex && node && node[ dir ] ||
													( diff = nodeIndex = 0 ) || start.pop() ) ) {

												if ( ( ofType ?
																nodeName( node, name ) :
																node.nodeType === 1 ) &&
														++diff ) {

													// Cache the index of each encountered element
													if ( useCache ) {
														outerCache = node[ expando ] ||
																( node[ expando ] = {} );
														outerCache[ type ] = [ dirruns, diff ];
													}

													if ( node === elem ) {
														break;
													}
												}
											}
										}
									}

									// Incorporate the offset, then check against cycle size
									diff -= last;
									return diff === first || ( diff % first === 0 && diff / first >= 0 );
								}
							};
				},

				PSEUDO: function( pseudo, argument ) {

					// pseudo-class names are case-insensitive
					// https://www.w3.org/TR/selectors/#pseudo-classes
					// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
					// Remember that setFilters inherits from pseudos
					var args,
							fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
									find.error( "unsupported pseudo: " + pseudo );

					// The user may use createPseudo to indicate that
					// arguments are needed to create the filter function
					// just as jQuery does
					if ( fn[ expando ] ) {
						return fn( argument );
					}

					// But maintain support for old signatures
					if ( fn.length > 1 ) {
						args = [ pseudo, pseudo, "", argument ];
						return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
								markFunction( function( seed, matches ) {
									var idx,
											matched = fn( seed, argument ),
											i = matched.length;
									while ( i-- ) {
										idx = indexOf.call( seed, matched[ i ] );
										seed[ idx ] = !( matches[ idx ] = matched[ i ] );
									}
								} ) :
								function( elem ) {
									return fn( elem, 0, args );
								};
					}

					return fn;
				}
			},

			pseudos: {

				// Potentially complex pseudos
				not: markFunction( function( selector ) {

					// Trim the selector passed to compile
					// to avoid treating leading and trailing
					// spaces as combinators
					var input = [],
							results = [],
							matcher = compile( selector.replace( rtrimCSS, "$1" ) );

					return matcher[ expando ] ?
							markFunction( function( seed, matches, _context, xml ) {
								var elem,
										unmatched = matcher( seed, null, xml, [] ),
										i = seed.length;

								// Match elements unmatched by `matcher`
								while ( i-- ) {
									if ( ( elem = unmatched[ i ] ) ) {
										seed[ i ] = !( matches[ i ] = elem );
									}
								}
							} ) :
							function( elem, _context, xml ) {
								input[ 0 ] = elem;
								matcher( input, null, xml, results );

								// Don't keep the element
								// (see https://github.com/jquery/sizzle/issues/299)
								input[ 0 ] = null;
								return !results.pop();
							};
				} ),

				has: markFunction( function( selector ) {
					return function( elem ) {
						return find( selector, elem ).length > 0;
					};
				} ),

				contains: markFunction( function( text ) {
					text = text.replace( runescape, funescape );
					return function( elem ) {
						return ( elem.textContent || jQuery.text( elem ) ).indexOf( text ) > -1;
					};
				} ),

				// "Whether an element is represented by a :lang() selector
				// is based solely on the element's language value
				// being equal to the identifier C,
				// or beginning with the identifier C immediately followed by "-".
				// The matching of C against the element's language value is performed case-insensitively.
				// The identifier C does not have to be a valid language name."
				// https://www.w3.org/TR/selectors/#lang-pseudo
				lang: markFunction( function( lang ) {

					// lang value must be a valid identifier
					if ( !ridentifier.test( lang || "" ) ) {
						find.error( "unsupported lang: " + lang );
					}
					lang = lang.replace( runescape, funescape ).toLowerCase();
					return function( elem ) {
						var elemLang;
						do {
							if ( ( elemLang = documentIsHTML ?
									elem.lang :
									elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

								elemLang = elemLang.toLowerCase();
								return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
							}
						} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
						return false;
					};
				} ),

				// Miscellaneous
				target: function( elem ) {
					var hash = window.location && window.location.hash;
					return hash && hash.slice( 1 ) === elem.id;
				},

				root: function( elem ) {
					return elem === documentElement;
				},

				focus: function( elem ) {
					return elem === safeActiveElement() &&
							document.hasFocus() &&
							!!( elem.type || elem.href || ~elem.tabIndex );
				},

				// Boolean properties
				enabled: createDisabledPseudo( false ),
				disabled: createDisabledPseudo( true ),

				checked: function( elem ) {

					// In CSS3, :checked should return both checked and selected elements
					// https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
					return ( nodeName( elem, "input" ) && !!elem.checked ) ||
							( nodeName( elem, "option" ) && !!elem.selected );
				},

				selected: function( elem ) {

					// Support: IE <=11+
					// Accessing the selectedIndex property
					// forces the browser to treat the default option as
					// selected when in an optgroup.
					if ( elem.parentNode ) {
						// eslint-disable-next-line no-unused-expressions
						elem.parentNode.selectedIndex;
					}

					return elem.selected === true;
				},

				// Contents
				empty: function( elem ) {

					// https://www.w3.org/TR/selectors/#empty-pseudo
					// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
					//   but not by others (comment: 8; processing instruction: 7; etc.)
					// nodeType < 6 works because attributes (2) do not appear as children
					for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
						if ( elem.nodeType < 6 ) {
							return false;
						}
					}
					return true;
				},

				parent: function( elem ) {
					return !Expr.pseudos.empty( elem );
				},

				// Element/input types
				header: function( elem ) {
					return rheader.test( elem.nodeName );
				},

				input: function( elem ) {
					return rinputs.test( elem.nodeName );
				},

				button: function( elem ) {
					return nodeName( elem, "input" ) && elem.type === "button" ||
							nodeName( elem, "button" );
				},

				text: function( elem ) {
					var attr;
					return nodeName( elem, "input" ) && elem.type === "text" &&

							// Support: IE <10 only
							// New HTML5 attribute values (e.g., "search") appear
							// with elem.type === "text"
							( ( attr = elem.getAttribute( "type" ) ) == null ||
									attr.toLowerCase() === "text" );
				},

				// Position-in-collection
				first: createPositionalPseudo( function() {
					return [ 0 ];
				} ),

				last: createPositionalPseudo( function( _matchIndexes, length ) {
					return [ length - 1 ];
				} ),

				eq: createPositionalPseudo( function( _matchIndexes, length, argument ) {
					return [ argument < 0 ? argument + length : argument ];
				} ),

				even: createPositionalPseudo( function( matchIndexes, length ) {
					var i = 0;
					for ( ; i < length; i += 2 ) {
						matchIndexes.push( i );
					}
					return matchIndexes;
				} ),

				odd: createPositionalPseudo( function( matchIndexes, length ) {
					var i = 1;
					for ( ; i < length; i += 2 ) {
						matchIndexes.push( i );
					}
					return matchIndexes;
				} ),

				lt: createPositionalPseudo( function( matchIndexes, length, argument ) {
					var i;

					if ( argument < 0 ) {
						i = argument + length;
					} else if ( argument > length ) {
						i = length;
					} else {
						i = argument;
					}

					for ( ; --i >= 0; ) {
						matchIndexes.push( i );
					}
					return matchIndexes;
				} ),

				gt: createPositionalPseudo( function( matchIndexes, length, argument ) {
					var i = argument < 0 ? argument + length : argument;
					for ( ; ++i < length; ) {
						matchIndexes.push( i );
					}
					return matchIndexes;
				} )
			}
		};

		Expr.pseudos.nth = Expr.pseudos.eq;

// Add button/input type pseudos
		for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
			Expr.pseudos[ i ] = createInputPseudo( i );
		}
		for ( i in { submit: true, reset: true } ) {
			Expr.pseudos[ i ] = createButtonPseudo( i );
		}

// Easy API for creating new setFilters
		function setFilters() {}
		setFilters.prototype = Expr.filters = Expr.pseudos;
		Expr.setFilters = new setFilters();

		function tokenize( selector, parseOnly ) {
			var matched, match, tokens, type,
					soFar, groups, preFilters,
					cached = tokenCache[ selector + " " ];

			if ( cached ) {
				return parseOnly ? 0 : cached.slice( 0 );
			}

			soFar = selector;
			groups = [];
			preFilters = Expr.preFilter;

			while ( soFar ) {

				// Comma and first run
				if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
					if ( match ) {

						// Don't consume trailing commas as valid
						soFar = soFar.slice( match[ 0 ].length ) || soFar;
					}
					groups.push( ( tokens = [] ) );
				}

				matched = false;

				// Combinators
				if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
					matched = match.shift();
					tokens.push( {
						value: matched,

						// Cast descendant combinators to space
						type: match[ 0 ].replace( rtrimCSS, " " )
					} );
					soFar = soFar.slice( matched.length );
				}

				// Filters
				for ( type in Expr.filter ) {
					if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
							( match = preFilters[ type ]( match ) ) ) ) {
						matched = match.shift();
						tokens.push( {
							value: matched,
							type: type,
							matches: match
						} );
						soFar = soFar.slice( matched.length );
					}
				}

				if ( !matched ) {
					break;
				}
			}

			// Return the length of the invalid excess
			// if we're just parsing
			// Otherwise, throw an error or return tokens
			if ( parseOnly ) {
				return soFar.length;
			}

			return soFar ?
					find.error( selector ) :

					// Cache the tokens
					tokenCache( selector, groups ).slice( 0 );
		}

		function toSelector( tokens ) {
			var i = 0,
					len = tokens.length,
					selector = "";
			for ( ; i < len; i++ ) {
				selector += tokens[ i ].value;
			}
			return selector;
		}

		function addCombinator( matcher, combinator, base ) {
			var dir = combinator.dir,
					skip = combinator.next,
					key = skip || dir,
					checkNonElements = base && key === "parentNode",
					doneName = done++;

			return combinator.first ?

					// Check against closest ancestor/preceding element
					function( elem, context, xml ) {
						while ( ( elem = elem[ dir ] ) ) {
							if ( elem.nodeType === 1 || checkNonElements ) {
								return matcher( elem, context, xml );
							}
						}
						return false;
					} :

					// Check against all ancestor/preceding elements
					function( elem, context, xml ) {
						var oldCache, outerCache,
								newCache = [ dirruns, doneName ];

						// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
						if ( xml ) {
							while ( ( elem = elem[ dir ] ) ) {
								if ( elem.nodeType === 1 || checkNonElements ) {
									if ( matcher( elem, context, xml ) ) {
										return true;
									}
								}
							}
						} else {
							while ( ( elem = elem[ dir ] ) ) {
								if ( elem.nodeType === 1 || checkNonElements ) {
									outerCache = elem[ expando ] || ( elem[ expando ] = {} );

									if ( skip && nodeName( elem, skip ) ) {
										elem = elem[ dir ] || elem;
									} else if ( ( oldCache = outerCache[ key ] ) &&
											oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

										// Assign to newCache so results back-propagate to previous elements
										return ( newCache[ 2 ] = oldCache[ 2 ] );
									} else {

										// Reuse newcache so results back-propagate to previous elements
										outerCache[ key ] = newCache;

										// A match means we're done; a fail means we have to keep checking
										if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
											return true;
										}
									}
								}
							}
						}
						return false;
					};
		}

		function elementMatcher( matchers ) {
			return matchers.length > 1 ?
					function( elem, context, xml ) {
						var i = matchers.length;
						while ( i-- ) {
							if ( !matchers[ i ]( elem, context, xml ) ) {
								return false;
							}
						}
						return true;
					} :
					matchers[ 0 ];
		}

		function multipleContexts( selector, contexts, results ) {
			var i = 0,
					len = contexts.length;
			for ( ; i < len; i++ ) {
				find( selector, contexts[ i ], results );
			}
			return results;
		}

		function condense( unmatched, map, filter, context, xml ) {
			var elem,
					newUnmatched = [],
					i = 0,
					len = unmatched.length,
					mapped = map != null;

			for ( ; i < len; i++ ) {
				if ( ( elem = unmatched[ i ] ) ) {
					if ( !filter || filter( elem, context, xml ) ) {
						newUnmatched.push( elem );
						if ( mapped ) {
							map.push( i );
						}
					}
				}
			}

			return newUnmatched;
		}

		function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
			if ( postFilter && !postFilter[ expando ] ) {
				postFilter = setMatcher( postFilter );
			}
			if ( postFinder && !postFinder[ expando ] ) {
				postFinder = setMatcher( postFinder, postSelector );
			}
			return markFunction( function( seed, results, context, xml ) {
				var temp, i, elem, matcherOut,
						preMap = [],
						postMap = [],
						preexisting = results.length,

						// Get initial elements from seed or context
						elems = seed ||
								multipleContexts( selector || "*",
										context.nodeType ? [ context ] : context, [] ),

						// Prefilter to get matcher input, preserving a map for seed-results synchronization
						matcherIn = preFilter && ( seed || !selector ) ?
								condense( elems, preMap, preFilter, context, xml ) :
								elems;

				if ( matcher ) {

					// If we have a postFinder, or filtered seed, or non-seed postFilter
					// or preexisting results,
					matcherOut = postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

							// ...intermediate processing is necessary
							[] :

							// ...otherwise use results directly
							results;

					// Find primary matches
					matcher( matcherIn, matcherOut, context, xml );
				} else {
					matcherOut = matcherIn;
				}

				// Apply postFilter
				if ( postFilter ) {
					temp = condense( matcherOut, postMap );
					postFilter( temp, [], context, xml );

					// Un-match failing elements by moving them back to matcherIn
					i = temp.length;
					while ( i-- ) {
						if ( ( elem = temp[ i ] ) ) {
							matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
						}
					}
				}

				if ( seed ) {
					if ( postFinder || preFilter ) {
						if ( postFinder ) {

							// Get the final matcherOut by condensing this intermediate into postFinder contexts
							temp = [];
							i = matcherOut.length;
							while ( i-- ) {
								if ( ( elem = matcherOut[ i ] ) ) {

									// Restore matcherIn since elem is not yet a final match
									temp.push( ( matcherIn[ i ] = elem ) );
								}
							}
							postFinder( null, ( matcherOut = [] ), temp, xml );
						}

						// Move matched elements from seed to results to keep them synchronized
						i = matcherOut.length;
						while ( i-- ) {
							if ( ( elem = matcherOut[ i ] ) &&
									( temp = postFinder ? indexOf.call( seed, elem ) : preMap[ i ] ) > -1 ) {

								seed[ temp ] = !( results[ temp ] = elem );
							}
						}
					}

					// Add elements to results, through postFinder if defined
				} else {
					matcherOut = condense(
							matcherOut === results ?
									matcherOut.splice( preexisting, matcherOut.length ) :
									matcherOut
					);
					if ( postFinder ) {
						postFinder( null, results, matcherOut, xml );
					} else {
						push.apply( results, matcherOut );
					}
				}
			} );
		}

		function matcherFromTokens( tokens ) {
			var checkContext, matcher, j,
					len = tokens.length,
					leadingRelative = Expr.relative[ tokens[ 0 ].type ],
					implicitRelative = leadingRelative || Expr.relative[ " " ],
					i = leadingRelative ? 1 : 0,

					// The foundational matcher ensures that elements are reachable from top-level context(s)
					matchContext = addCombinator( function( elem ) {
						return elem === checkContext;
					}, implicitRelative, true ),
					matchAnyContext = addCombinator( function( elem ) {
						return indexOf.call( checkContext, elem ) > -1;
					}, implicitRelative, true ),
					matchers = [ function( elem, context, xml ) {

						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						var ret = ( !leadingRelative && ( xml || context != outermostContext ) ) || (
								( checkContext = context ).nodeType ?
										matchContext( elem, context, xml ) :
										matchAnyContext( elem, context, xml ) );

						// Avoid hanging onto element
						// (see https://github.com/jquery/sizzle/issues/299)
						checkContext = null;
						return ret;
					} ];

			for ( ; i < len; i++ ) {
				if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
					matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
				} else {
					matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

					// Return special upon seeing a positional matcher
					if ( matcher[ expando ] ) {

						// Find the next relative operator (if any) for proper handling
						j = ++i;
						for ( ; j < len; j++ ) {
							if ( Expr.relative[ tokens[ j ].type ] ) {
								break;
							}
						}
						return setMatcher(
								i > 1 && elementMatcher( matchers ),
								i > 1 && toSelector(

										// If the preceding token was a descendant combinator, insert an implicit any-element `*`
										tokens.slice( 0, i - 1 )
												.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
								).replace( rtrimCSS, "$1" ),
								matcher,
								i < j && matcherFromTokens( tokens.slice( i, j ) ),
								j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
								j < len && toSelector( tokens )
						);
					}
					matchers.push( matcher );
				}
			}

			return elementMatcher( matchers );
		}

		function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
			var bySet = setMatchers.length > 0,
					byElement = elementMatchers.length > 0,
					superMatcher = function( seed, context, xml, results, outermost ) {
						var elem, j, matcher,
								matchedCount = 0,
								i = "0",
								unmatched = seed && [],
								setMatched = [],
								contextBackup = outermostContext,

								// We must always have either seed elements or outermost context
								elems = seed || byElement && Expr.find.TAG( "*", outermost ),

								// Use integer dirruns iff this is the outermost matcher
								dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
								len = elems.length;

						if ( outermost ) {

							// Support: IE 11+, Edge 17 - 18+
							// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
							// two documents; shallow comparisons work.
							// eslint-disable-next-line eqeqeq
							outermostContext = context == document || context || outermost;
						}

						// Add elements passing elementMatchers directly to results
						// Support: iOS <=7 - 9 only
						// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
						// elements by id. (see trac-14142)
						for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
							if ( byElement && elem ) {
								j = 0;

								// Support: IE 11+, Edge 17 - 18+
								// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
								// two documents; shallow comparisons work.
								// eslint-disable-next-line eqeqeq
								if ( !context && elem.ownerDocument != document ) {
									setDocument( elem );
									xml = !documentIsHTML;
								}
								while ( ( matcher = elementMatchers[ j++ ] ) ) {
									if ( matcher( elem, context || document, xml ) ) {
										push.call( results, elem );
										break;
									}
								}
								if ( outermost ) {
									dirruns = dirrunsUnique;
								}
							}

							// Track unmatched elements for set filters
							if ( bySet ) {

								// They will have gone through all possible matchers
								if ( ( elem = !matcher && elem ) ) {
									matchedCount--;
								}

								// Lengthen the array for every element, matched or not
								if ( seed ) {
									unmatched.push( elem );
								}
							}
						}

						// `i` is now the count of elements visited above, and adding it to `matchedCount`
						// makes the latter nonnegative.
						matchedCount += i;

						// Apply set filters to unmatched elements
						// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
						// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
						// no element matchers and no seed.
						// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
						// case, which will result in a "00" `matchedCount` that differs from `i` but is also
						// numerically zero.
						if ( bySet && i !== matchedCount ) {
							j = 0;
							while ( ( matcher = setMatchers[ j++ ] ) ) {
								matcher( unmatched, setMatched, context, xml );
							}

							if ( seed ) {

								// Reintegrate element matches to eliminate the need for sorting
								if ( matchedCount > 0 ) {
									while ( i-- ) {
										if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
											setMatched[ i ] = pop.call( results );
										}
									}
								}

								// Discard index placeholder values to get only actual matches
								setMatched = condense( setMatched );
							}

							// Add matches to results
							push.apply( results, setMatched );

							// Seedless set matches succeeding multiple successful matchers stipulate sorting
							if ( outermost && !seed && setMatched.length > 0 &&
									( matchedCount + setMatchers.length ) > 1 ) {

								jQuery.uniqueSort( results );
							}
						}

						// Override manipulation of globals by nested matchers
						if ( outermost ) {
							dirruns = dirrunsUnique;
							outermostContext = contextBackup;
						}

						return unmatched;
					};

			return bySet ?
					markFunction( superMatcher ) :
					superMatcher;
		}

		function compile( selector, match /* Internal Use Only */ ) {
			var i,
					setMatchers = [],
					elementMatchers = [],
					cached = compilerCache[ selector + " " ];

			if ( !cached ) {

				// Generate a function of recursive functions that can be used to check each element
				if ( !match ) {
					match = tokenize( selector );
				}
				i = match.length;
				while ( i-- ) {
					cached = matcherFromTokens( match[ i ] );
					if ( cached[ expando ] ) {
						setMatchers.push( cached );
					} else {
						elementMatchers.push( cached );
					}
				}

				// Cache the compiled function
				cached = compilerCache( selector,
						matcherFromGroupMatchers( elementMatchers, setMatchers ) );

				// Save selector and tokenization
				cached.selector = selector;
			}
			return cached;
		}

		/**
		 * A low-level selection function that works with jQuery's compiled
		 *  selector functions
		 * @param {String|Function} selector A selector or a pre-compiled
		 *  selector function built with jQuery selector compile
		 * @param {Element} context
		 * @param {Array} [results]
		 * @param {Array} [seed] A set of elements to match against
		 */
		function select( selector, context, results, seed ) {
			var i, tokens, token, type, find,
					compiled = typeof selector === "function" && selector,
					match = !seed && tokenize( ( selector = compiled.selector || selector ) );

			results = results || [];

			// Try to minimize operations if there is only one selector in the list and no seed
			// (the latter of which guarantees us context)
			if ( match.length === 1 ) {

				// Reduce context if the leading compound selector is an ID
				tokens = match[ 0 ] = match[ 0 ].slice( 0 );
				if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
						context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

					context = ( Expr.find.ID(
							token.matches[ 0 ].replace( runescape, funescape ),
							context
					) || [] )[ 0 ];
					if ( !context ) {
						return results;

						// Precompiled matchers will still verify ancestry, so step up a level
					} else if ( compiled ) {
						context = context.parentNode;
					}

					selector = selector.slice( tokens.shift().value.length );
				}

				// Fetch a seed set for right-to-left matching
				i = matchExpr.needsContext.test( selector ) ? 0 : tokens.length;
				while ( i-- ) {
					token = tokens[ i ];

					// Abort if we hit a combinator
					if ( Expr.relative[ ( type = token.type ) ] ) {
						break;
					}
					if ( ( find = Expr.find[ type ] ) ) {

						// Search, expanding context for leading sibling combinators
						if ( ( seed = find(
								token.matches[ 0 ].replace( runescape, funescape ),
								rsibling.test( tokens[ 0 ].type ) &&
								testContext( context.parentNode ) || context
						) ) ) {

							// If seed is empty or no tokens remain, we can return early
							tokens.splice( i, 1 );
							selector = seed.length && toSelector( tokens );
							if ( !selector ) {
								push.apply( results, seed );
								return results;
							}

							break;
						}
					}
				}
			}

			// Compile and execute a filtering function if one is not provided
			// Provide `match` to avoid retokenization if we modified the selector above
			( compiled || compile( selector, match ) )(
					seed,
					context,
					!documentIsHTML,
					results,
					!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
			);
			return results;
		}

// One-time assignments

// Support: Android <=4.0 - 4.1+
// Sort stability
		support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Initialize against the default document
		setDocument();

// Support: Android <=4.0 - 4.1+
// Detached nodes confoundingly follow *each other*
		support.sortDetached = assert( function( el ) {

			// Should return 1, but returns 4 (following)
			return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
		} );

		jQuery.find = find;

// Deprecated
		jQuery.expr[ ":" ] = jQuery.expr.pseudos;
		jQuery.unique = jQuery.uniqueSort;

// These have always been private, but they used to be documented as part of
// Sizzle so let's maintain them for now for backwards compatibility purposes.
		find.compile = compile;
		find.select = select;
		find.setDocument = setDocument;
		find.tokenize = tokenize;

		find.escape = jQuery.escapeSelector;
		find.getText = jQuery.text;
		find.isXML = jQuery.isXMLDoc;
		find.selectors = jQuery.expr;
		find.support = jQuery.support;
		find.uniqueSort = jQuery.uniqueSort;

		/* eslint-enable */

	} )();


	var dir = function( elem, dir, until ) {
		var matched = [],
				truncate = until !== undefined;

		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};


	var siblings = function( n, elem ) {
		var matched = [];

		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}

		return matched;
	};


	var rneedsContext = jQuery.expr.match.needsContext;

	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}

		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}

		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}

		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}

	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];

		if ( not ) {
			expr = ":not(" + expr + ")";
		}

		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}

		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};

	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
					len = this.length,
					self = this;

			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}

			ret = this.pushStack( [] );

			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}

			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
					this,

					// If this is a positional/relative selector, check membership in the returned set
					// so $("p:first").is("p:last") won't return true for a doc with two "p".
					typeof selector === "string" && rneedsContext.test( selector ) ?
							jQuery( selector ) :
							selector || [],
					false
			).length;
		}
	} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
	var rootjQuery,

			// A simple way to check for HTML strings
			// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
			// Strict HTML recognition (trac-11290: must start with <)
			// Shortcut simple #id case for speed
			rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

			init = jQuery.fn.init = function( selector, context, root ) {
				var match, elem;

				// HANDLE: $(""), $(null), $(undefined), $(false)
				if ( !selector ) {
					return this;
				}

				// Method init() accepts an alternate rootjQuery
				// so migrate can support jQuery.sub (gh-2101)
				root = root || rootjQuery;

				// Handle HTML strings
				if ( typeof selector === "string" ) {
					if ( selector[ 0 ] === "<" &&
							selector[ selector.length - 1 ] === ">" &&
							selector.length >= 3 ) {

						// Assume that strings that start and end with <> are HTML and skip the regex check
						match = [ null, selector, null ];

					} else {
						match = rquickExpr.exec( selector );
					}

					// Match html or make sure no context is specified for #id
					if ( match && ( match[ 1 ] || !context ) ) {

						// HANDLE: $(html) -> $(array)
						if ( match[ 1 ] ) {
							context = context instanceof jQuery ? context[ 0 ] : context;

							// Option to run scripts is true for back-compat
							// Intentionally let the error be thrown if parseHTML is not present
							jQuery.merge( this, jQuery.parseHTML(
									match[ 1 ],
									context && context.nodeType ? context.ownerDocument || context : document,
									true
							) );

							// HANDLE: $(html, props)
							if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
								for ( match in context ) {

									// Properties of context are called as methods if possible
									if ( isFunction( this[ match ] ) ) {
										this[ match ]( context[ match ] );

										// ...and otherwise set as attributes
									} else {
										this.attr( match, context[ match ] );
									}
								}
							}

							return this;

							// HANDLE: $(#id)
						} else {
							elem = document.getElementById( match[ 2 ] );

							if ( elem ) {

								// Inject the element directly into the jQuery object
								this[ 0 ] = elem;
								this.length = 1;
							}
							return this;
						}

						// HANDLE: $(expr, $(...))
					} else if ( !context || context.jquery ) {
						return ( context || root ).find( selector );

						// HANDLE: $(expr, context)
						// (which is just equivalent to: $(context).find(expr)
					} else {
						return this.constructor( context ).find( selector );
					}

					// HANDLE: $(DOMElement)
				} else if ( selector.nodeType ) {
					this[ 0 ] = selector;
					this.length = 1;
					return this;

					// HANDLE: $(function)
					// Shortcut for document ready
				} else if ( isFunction( selector ) ) {
					return root.ready !== undefined ?
							root.ready( selector ) :

							// Execute immediately if ready is not present
							selector( jQuery );
				}

				return jQuery.makeArray( selector, this );
			};

// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;

// Initialize central reference
	rootjQuery = jQuery( document );


	var rparentsprev = /^(?:parents|prev(?:Until|All))/,

			// Methods guaranteed to produce a unique set when starting from a unique set
			guaranteedUnique = {
				children: true,
				contents: true,
				next: true,
				prev: true
			};

	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
					l = targets.length;

			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},

		closest: function( selectors, context ) {
			var cur,
					i = 0,
					l = this.length,
					matched = [],
					targets = typeof selectors !== "string" && jQuery( selectors );

			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
								targets.index( cur ) > -1 :

								// Don't pass non-elements to jQuery#find
								cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {

							matched.push( cur );
							break;
						}
					}
				}
			}

			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},

		// Determine the position of an element within the set
		index: function( elem ) {

			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}

			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}

			// Locate the position of the desired element
			return indexOf.call( this,

					// If it receives a jQuery object, the first element is used
					elem.jquery ? elem[ 0 ] : elem
			);
		},

		add: function( selector, context ) {
			return this.pushStack(
					jQuery.uniqueSort(
							jQuery.merge( this.get(), jQuery( selector, context ) )
					)
			);
		},

		addBack: function( selector ) {
			return this.add( selector == null ?
					this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );

	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}

	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, _i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, _i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, _i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			if ( elem.contentDocument != null &&

					// Support: IE 11+
					// <object> elements with no `data` attribute has an object
					// `contentDocument` with a `null` prototype.
					getProto( elem.contentDocument ) ) {

				return elem.contentDocument;
			}

			// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
			// Treat the template element as a regular one in browsers that
			// don't support it.
			if ( nodeName( elem, "template" ) ) {
				elem = elem.content || elem;
			}

			return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );

			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}

			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}

			if ( this.length > 1 ) {

				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}

				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}

			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}

	/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
	jQuery.Callbacks = function( options ) {

		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
				createOptions( options ) :
				jQuery.extend( {}, options );

		var // Flag to know if list is currently firing
				firing,

				// Last fire value for non-forgettable lists
				memory,

				// Flag to know if list was already fired
				fired,

				// Flag to prevent firing
				locked,

				// Actual callback list
				list = [],

				// Queue of execution data for repeatable lists
				queue = [],

				// Index of currently firing callback (modified by add/remove as needed)
				firingIndex = -1,

				// Fire callbacks
				fire = function() {

					// Enforce single-firing
					locked = locked || options.once;

					// Execute callbacks for all pending executions,
					// respecting firingIndex overrides and runtime changes
					fired = firing = true;
					for ( ; queue.length; firingIndex = -1 ) {
						memory = queue.shift();
						while ( ++firingIndex < list.length ) {

							// Run callback and check for early termination
							if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
									options.stopOnFalse ) {

								// Jump to end and forget the data so .add doesn't re-fire
								firingIndex = list.length;
								memory = false;
							}
						}
					}

					// Forget the data if we're done with it
					if ( !options.memory ) {
						memory = false;
					}

					firing = false;

					// Clean up if we're done firing for good
					if ( locked ) {

						// Keep an empty list if we have data for future add calls
						if ( memory ) {
							list = [];

							// Otherwise, this object is spent
						} else {
							list = "";
						}
					}
				},

				// Actual Callbacks object
				self = {

					// Add a callback or a collection of callbacks to the list
					add: function() {
						if ( list ) {

							// If we have memory from a past run, we should fire after adding
							if ( memory && !firing ) {
								firingIndex = list.length - 1;
								queue.push( memory );
							}

							( function add( args ) {
								jQuery.each( args, function( _, arg ) {
									if ( isFunction( arg ) ) {
										if ( !options.unique || !self.has( arg ) ) {
											list.push( arg );
										}
									} else if ( arg && arg.length && toType( arg ) !== "string" ) {

										// Inspect recursively
										add( arg );
									}
								} );
							} )( arguments );

							if ( memory && !firing ) {
								fire();
							}
						}
						return this;
					},

					// Remove a callback from the list
					remove: function() {
						jQuery.each( arguments, function( _, arg ) {
							var index;
							while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
								list.splice( index, 1 );

								// Handle firing indexes
								if ( index <= firingIndex ) {
									firingIndex--;
								}
							}
						} );
						return this;
					},

					// Check if a given callback is in the list.
					// If no argument is given, return whether or not list has callbacks attached.
					has: function( fn ) {
						return fn ?
								jQuery.inArray( fn, list ) > -1 :
								list.length > 0;
					},

					// Remove all callbacks from the list
					empty: function() {
						if ( list ) {
							list = [];
						}
						return this;
					},

					// Disable .fire and .add
					// Abort any current/pending executions
					// Clear all callbacks and values
					disable: function() {
						locked = queue = [];
						list = memory = "";
						return this;
					},
					disabled: function() {
						return !list;
					},

					// Disable .fire
					// Also disable .add unless we have memory (since it would have no effect)
					// Abort any pending executions
					lock: function() {
						locked = queue = [];
						if ( !memory && !firing ) {
							list = memory = "";
						}
						return this;
					},
					locked: function() {
						return !!locked;
					},

					// Call all callbacks with the given context and arguments
					fireWith: function( context, args ) {
						if ( !locked ) {
							args = args || [];
							args = [ context, args.slice ? args.slice() : args ];
							queue.push( args );
							if ( !firing ) {
								fire();
							}
						}
						return this;
					},

					// Call all the callbacks with the given arguments
					fire: function() {
						self.fireWith( this, arguments );
						return this;
					},

					// To know if the callbacks have already been called at least once
					fired: function() {
						return !!fired;
					}
				};

		return self;
	};


	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}

	function adoptValue( value, resolve, reject, noValue ) {
		var method;

		try {

			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );

				// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );

				// Other non-thenables
			} else {

				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}

			// For Promises/A+, convert exceptions into rejections
			// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
			// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {

			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}

	jQuery.extend( {

		Deferred: function( func ) {
			var tuples = [

						// action, add listener, callbacks,
						// ... .then handlers, argument index, [final state]
						[ "notify", "progress", jQuery.Callbacks( "memory" ),
							jQuery.Callbacks( "memory" ), 2 ],
						[ "resolve", "done", jQuery.Callbacks( "once memory" ),
							jQuery.Callbacks( "once memory" ), 0, "resolved" ],
						[ "reject", "fail", jQuery.Callbacks( "once memory" ),
							jQuery.Callbacks( "once memory" ), 1, "rejected" ]
					],
					state = "pending",
					promise = {
						state: function() {
							return state;
						},
						always: function() {
							deferred.done( arguments ).fail( arguments );
							return this;
						},
						"catch": function( fn ) {
							return promise.then( null, fn );
						},

						// Keep pipe for back-compat
						pipe: function( /* fnDone, fnFail, fnProgress */ ) {
							var fns = arguments;

							return jQuery.Deferred( function( newDefer ) {
								jQuery.each( tuples, function( _i, tuple ) {

									// Map tuples (progress, done, fail) to arguments (done, fail, progress)
									var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

									// deferred.progress(function() { bind to newDefer or newDefer.notify })
									// deferred.done(function() { bind to newDefer or newDefer.resolve })
									// deferred.fail(function() { bind to newDefer or newDefer.reject })
									deferred[ tuple[ 1 ] ]( function() {
										var returned = fn && fn.apply( this, arguments );
										if ( returned && isFunction( returned.promise ) ) {
											returned.promise()
													.progress( newDefer.notify )
													.done( newDefer.resolve )
													.fail( newDefer.reject );
										} else {
											newDefer[ tuple[ 0 ] + "With" ](
													this,
													fn ? [ returned ] : arguments
											);
										}
									} );
								} );
								fns = null;
							} ).promise();
						},
						then: function( onFulfilled, onRejected, onProgress ) {
							var maxDepth = 0;
							function resolve( depth, deferred, handler, special ) {
								return function() {
									var that = this,
											args = arguments,
											mightThrow = function() {
												var returned, then;

												// Support: Promises/A+ section 2.3.3.3.3
												// https://promisesaplus.com/#point-59
												// Ignore double-resolution attempts
												if ( depth < maxDepth ) {
													return;
												}

												returned = handler.apply( that, args );

												// Support: Promises/A+ section 2.3.1
												// https://promisesaplus.com/#point-48
												if ( returned === deferred.promise() ) {
													throw new TypeError( "Thenable self-resolution" );
												}

												// Support: Promises/A+ sections 2.3.3.1, 3.5
												// https://promisesaplus.com/#point-54
												// https://promisesaplus.com/#point-75
												// Retrieve `then` only once
												then = returned &&

														// Support: Promises/A+ section 2.3.4
														// https://promisesaplus.com/#point-64
														// Only check objects and functions for thenability
														( typeof returned === "object" ||
																typeof returned === "function" ) &&
														returned.then;

												// Handle a returned thenable
												if ( isFunction( then ) ) {

													// Special processors (notify) just wait for resolution
													if ( special ) {
														then.call(
																returned,
																resolve( maxDepth, deferred, Identity, special ),
																resolve( maxDepth, deferred, Thrower, special )
														);

														// Normal processors (resolve) also hook into progress
													} else {

														// ...and disregard older resolution values
														maxDepth++;

														then.call(
																returned,
																resolve( maxDepth, deferred, Identity, special ),
																resolve( maxDepth, deferred, Thrower, special ),
																resolve( maxDepth, deferred, Identity,
																		deferred.notifyWith )
														);
													}

													// Handle all other returned values
												} else {

													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Identity ) {
														that = undefined;
														args = [ returned ];
													}

													// Process the value(s)
													// Default process is resolve
													( special || deferred.resolveWith )( that, args );
												}
											},

											// Only normal processors (resolve) catch and reject exceptions
											process = special ?
													mightThrow :
													function() {
														try {
															mightThrow();
														} catch ( e ) {

															if ( jQuery.Deferred.exceptionHook ) {
																jQuery.Deferred.exceptionHook( e,
																		process.error );
															}

															// Support: Promises/A+ section 2.3.3.3.4.1
															// https://promisesaplus.com/#point-61
															// Ignore post-resolution exceptions
															if ( depth + 1 >= maxDepth ) {

																// Only substitute handlers pass on context
																// and multiple values (non-spec behavior)
																if ( handler !== Thrower ) {
																	that = undefined;
																	args = [ e ];
																}

																deferred.rejectWith( that, args );
															}
														}
													};

									// Support: Promises/A+ section 2.3.3.3.1
									// https://promisesaplus.com/#point-57
									// Re-resolve promises immediately to dodge false rejection from
									// subsequent errors
									if ( depth ) {
										process();
									} else {

										// Call an optional hook to record the error, in case of exception
										// since it's otherwise lost when execution goes async
										if ( jQuery.Deferred.getErrorHook ) {
											process.error = jQuery.Deferred.getErrorHook();

											// The deprecated alias of the above. While the name suggests
											// returning the stack, not an error instance, jQuery just passes
											// it directly to `console.warn` so both will work; an instance
											// just better cooperates with source maps.
										} else if ( jQuery.Deferred.getStackHook ) {
											process.error = jQuery.Deferred.getStackHook();
										}
										window.setTimeout( process );
									}
								};
							}

							return jQuery.Deferred( function( newDefer ) {

								// progress_handlers.add( ... )
								tuples[ 0 ][ 3 ].add(
										resolve(
												0,
												newDefer,
												isFunction( onProgress ) ?
														onProgress :
														Identity,
												newDefer.notifyWith
										)
								);

								// fulfilled_handlers.add( ... )
								tuples[ 1 ][ 3 ].add(
										resolve(
												0,
												newDefer,
												isFunction( onFulfilled ) ?
														onFulfilled :
														Identity
										)
								);

								// rejected_handlers.add( ... )
								tuples[ 2 ][ 3 ].add(
										resolve(
												0,
												newDefer,
												isFunction( onRejected ) ?
														onRejected :
														Thrower
										)
								);
							} ).promise();
						},

						// Get a promise for this deferred
						// If obj is provided, the promise aspect is added to the object
						promise: function( obj ) {
							return obj != null ? jQuery.extend( obj, promise ) : promise;
						}
					},
					deferred = {};

			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
						stateString = tuple[ 5 ];

				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;

				// Handle state
				if ( stateString ) {
					list.add(
							function() {

								// state = "resolved" (i.e., fulfilled)
								// state = "rejected"
								state = stateString;
							},

							// rejected_callbacks.disable
							// fulfilled_callbacks.disable
							tuples[ 3 - i ][ 2 ].disable,

							// rejected_handlers.disable
							// fulfilled_handlers.disable
							tuples[ 3 - i ][ 3 ].disable,

							// progress_callbacks.lock
							tuples[ 0 ][ 2 ].lock,

							// progress_handlers.lock
							tuples[ 0 ][ 3 ].lock
					);
				}

				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );

				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};

				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );

			// Make the deferred a promise
			promise.promise( deferred );

			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}

			// All done!
			return deferred;
		},

		// Deferred helper
		when: function( singleValue ) {
			var

					// count of uncompleted subordinates
					remaining = arguments.length,

					// count of unprocessed arguments
					i = remaining,

					// subordinate fulfillment data
					resolveContexts = Array( i ),
					resolveValues = slice.call( arguments ),

					// the primary Deferred
					primary = jQuery.Deferred(),

					// subordinate callback factory
					updateFunc = function( i ) {
						return function( value ) {
							resolveContexts[ i ] = this;
							resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
							if ( !( --remaining ) ) {
								primary.resolveWith( resolveContexts, resolveValues );
							}
						};
					};

			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
						!remaining );

				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( primary.state() === "pending" ||
						isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

					return primary.then();
				}
			}

			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
			}

			return primary.promise();
		}
	} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

// If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
// captured before the async barrier to get the original error cause
// which may otherwise be hidden.
	jQuery.Deferred.exceptionHook = function( error, asyncError ) {

		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message,
					error.stack, asyncError );
		}
	};




	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};




// The deferred used on DOM ready
	var readyList = jQuery.Deferred();

	jQuery.fn.ready = function( fn ) {

		readyList
				.then( fn )

				// Wrap jQuery.readyException in a function so that the lookup
				// happens at the time of error handling instead of callback
				// registration.
				.catch( function( error ) {
					jQuery.readyException( error );
				} );

		return this;
	};

	jQuery.extend( {

		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,

		// A counter to track how many items to wait for before
		// the ready event fires. See trac-6781
		readyWait: 1,

		// Handle when the DOM is ready
		ready: function( wait ) {

			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}

			// Remember that the DOM is ready
			jQuery.isReady = true;

			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}

			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );

	jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
			( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );

	} else {

		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );

		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
				len = elems.length,
				bulk = key == null;

		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}

			// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;

			if ( !isFunction( value ) ) {
				raw = true;
			}

			if ( bulk ) {

				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;

					// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, _key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}

			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
							elems[ i ], key, raw ?
									value :
									value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}

		if ( chainable ) {
			return elems;
		}

		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}

		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};


// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
			rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
	function fcamelCase( _all, letter ) {
		return letter.toUpperCase();
	}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (trac-9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {

		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};




	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}

	Data.uid = 1;

	Data.prototype = {

		cache: function( owner ) {

			// Check if the owner object already has a cache
			var value = owner[ this.expando ];

			// If not, create one
			if ( !value ) {
				value = {};

				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see trac-8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {

					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;

						// Otherwise secure it in a non-enumerable property
						// configurable must be true to allow the property to be
						// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}

			return value;
		},
		set: function( owner, data, value ) {
			var prop,
					cache = this.cache( owner );

			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;

				// Handle: [ owner, { properties } ] args
			} else {

				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
					this.cache( owner ) :

					// Always use camelCase key (gh-2257)
					owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {

			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {

				return this.get( owner, key );
			}

			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );

			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
					cache = owner[ this.expando ];

			if ( cache === undefined ) {
				return;
			}

			if ( key !== undefined ) {

				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {

					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );

					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
							[ key ] :
							( key.match( rnothtmlwhite ) || [] );
				}

				i = key.length;

				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}

			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();

	var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
			rmultiDash = /[A-Z]/g;

	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}

		if ( data === "false" ) {
			return false;
		}

		if ( data === "null" ) {
			return null;
		}

		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}

		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}

		return data;
	}

	function dataAttr( elem, key, data ) {
		var name;

		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );

			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}

				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}

	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},

		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},

		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},

		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},

		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );

	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
					elem = this[ 0 ],
					attrs = elem && elem.attributes;

			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );

					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {

							// Support: IE 11 only
							// The attrs elements can be null (trac-14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}

				return data;
			}

			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}

			return access( this, function( value ) {
				var data;

				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {

					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}

					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}

					// We tried really hard, but the data doesn't exist.
					return;
				}

				// Set the data...
				this.each( function() {

					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},

		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );


	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;

			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );

				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},

		dequeue: function( elem, type ) {
			type = type || "fx";

			var queue = jQuery.queue( elem, type ),
					startLength = queue.length,
					fn = queue.shift(),
					hooks = jQuery._queueHooks( elem, type ),
					next = function() {
						jQuery.dequeue( elem, type );
					};

			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}

			if ( fn ) {

				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}

				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}

			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},

		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );

	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;

			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}

			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}

			return data === undefined ?
					this :
					this.each( function() {
						var queue = jQuery.queue( this, type, data );

						// Ensure a hooks for this queue
						jQuery._queueHooks( this, type );

						if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
							jQuery.dequeue( this, type );
						}
					} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},

		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
					count = 1,
					defer = jQuery.Deferred(),
					elements = this,
					i = this.length,
					resolve = function() {
						if ( !( --count ) ) {
							defer.resolveWith( elements, [ elements ] );
						}
					};

			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";

			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

	var documentElement = document.documentElement;



	var isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem );
			},
			composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
					elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
	var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
				elem.style.display === "" &&

				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				isAttached( elem ) &&

				jQuery.css( elem, "display" ) === "none";
	};



	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
				maxIterations = 20,
				currentValue = tween ?
						function() {
							return tween.cur();
						} :
						function() {
							return jQuery.css( elem, prop, "" );
						},
				initial = currentValue(),
				unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

				// Starting value computation is required for potential unit mismatches
				initialInUnit = elem.nodeType &&
						( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
						rcssNum.exec( jQuery.css( elem, prop ) );

		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;

			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];

			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;

			while ( maxIterations-- ) {

				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;

			}

			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );

			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}

		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;

			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
					initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
					+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}


	var defaultDisplayMap = {};

	function getDefaultDisplay( elem ) {
		var temp,
				doc = elem.ownerDocument,
				nodeName = elem.nodeName,
				display = defaultDisplayMap[ nodeName ];

		if ( display ) {
			return display;
		}

		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );

		temp.parentNode.removeChild( temp );

		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;

		return display;
	}

	function showHide( elements, show ) {
		var display, elem,
				values = [],
				index = 0,
				length = elements.length;

		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}

			display = elem.style.display;
			if ( show ) {

				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";

					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}

		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}

		return elements;
	}

	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}

			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );

	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



	( function() {
		var fragment = document.createDocumentFragment(),
				div = fragment.appendChild( document.createElement( "div" ) ),
				input = document.createElement( "input" );

		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (trac-11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (trac-14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );

		div.appendChild( input );

		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

		// Support: IE <=9 only
		// IE <=9 replaces <option> tags with their contents when inserted outside of
		// the select element.
		div.innerHTML = "<option></option>";
		support.option = !!div.lastChild;
	} )();


// We have to close these tags to support XHTML (trac-13200)
	var wrapMap = {

		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

		_default: [ 0, "", "" ]
	};

	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;

// Support: IE <=9 only
	if ( !support.option ) {
		wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
	}


	function getAll( context, tag ) {

		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
		var ret;

		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );

		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );

		} else {
			ret = [];
		}

		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}

		return ret;
	}


// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
				l = elems.length;

		for ( ; i < l; i++ ) {
			dataPriv.set(
					elems[ i ],
					"globalEval",
					!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}


	var rhtml = /<|&#?\w+;/;

	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, attached, j,
				fragment = context.createDocumentFragment(),
				nodes = [],
				i = 0,
				l = elems.length;

		for ( ; i < l; i++ ) {
			elem = elems[ i ];

			if ( elem || elem === 0 ) {

				// Add nodes directly
				if ( toType( elem ) === "object" ) {

					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

					// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );

					// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}

					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );

					// Remember the top-level container
					tmp = fragment.firstChild;

					// Ensure the created nodes are orphaned (trac-12392)
					tmp.textContent = "";
				}
			}
		}

		// Remove wrapper from fragment
		fragment.textContent = "";

		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {

			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}

			attached = isAttached( elem );

			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );

			// Preserve script evaluation history
			if ( attached ) {
				setGlobalEval( tmp );
			}

			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}

		return fragment;
	}


	var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

	function returnTrue() {
		return true;
	}

	function returnFalse() {
		return false;
	}

	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;

		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {

			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {

				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}

		if ( data == null && fn == null ) {

			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {

				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {

				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}

		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {

				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};

			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}

	/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
	jQuery.event = {

		global: {},

		add: function( elem, types, handler, data, selector ) {

			var handleObjIn, eventHandle, tmp,
					events, t, handleObj,
					special, handlers, type, namespaces, origType,
					elemData = dataPriv.get( elem );

			// Only attach events to objects that accept data
			if ( !acceptData( elem ) ) {
				return;
			}

			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}

			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}

			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}

			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = Object.create( null );
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {

					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
							jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}

			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}

				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};

				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;

				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};

				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );

				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;

					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
							special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}

				if ( special.add ) {
					special.add.call( elem, handleObj );

					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}

				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}

				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}

		},

		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {

			var j, origCount, tmp,
					events, t, handleObj,
					special, handlers, type, namespaces, origType,
					elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}

			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}

				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
						new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];

					if ( ( mappedTypes || origType === handleObj.origType ) &&
							( !handler || handler.guid === handleObj.guid ) &&
							( !tmp || tmp.test( handleObj.namespace ) ) &&
							( !selector || selector === handleObj.selector ||
									selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );

						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}

				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
							special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

						jQuery.removeEvent( elem, type, elemData.handle );
					}

					delete events[ type ];
				}
			}

			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},

		dispatch: function( nativeEvent ) {

			var i, j, ret, matched, handleObj, handlerQueue,
					args = new Array( arguments.length ),

					// Make a writable jQuery.Event from the native event object
					event = jQuery.event.fix( nativeEvent ),

					handlers = (
							dataPriv.get( this, "events" ) || Object.create( null )
					)[ event.type ] || [],
					special = jQuery.event.special[ event.type ] || {};

			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;

			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}

			event.delegateTarget = this;

			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}

			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );

			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;

				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

					// If the event is namespaced, then each handler is only invoked if it is
					// specially universal or its namespaces are a superset of the event's.
					if ( !event.rnamespace || handleObj.namespace === false ||
							event.rnamespace.test( handleObj.namespace ) ) {

						event.handleObj = handleObj;
						event.data = handleObj.data;

						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
								handleObj.handler ).apply( matched.elem, args );

						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}

			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}

			return event.result;
		},

		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
					handlerQueue = [],
					delegateCount = handlers.delegateCount,
					cur = event.target;

			// Find delegate handlers
			if ( delegateCount &&

					// Support: IE <=9
					// Black-hole SVG <use> instance trees (trac-13180)
					cur.nodeType &&

					// Support: Firefox <=42
					// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
					// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
					// Support: IE 11 only
					// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
					!( event.type === "click" && event.button >= 1 ) ) {

				for ( ; cur !== this; cur = cur.parentNode || this ) {

					// Don't check non-elements (trac-13208)
					// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];

							// Don't conflict with Object.prototype properties (trac-13203)
							sel = handleObj.selector + " ";

							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
										jQuery( sel, this ).index( cur ) > -1 :
										jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}

			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}

			return handlerQueue;
		},

		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,

				get: isFunction( hook ) ?
						function() {
							if ( this.originalEvent ) {
								return hook( this.originalEvent );
							}
						} :
						function() {
							if ( this.originalEvent ) {
								return this.originalEvent[ name ];
							}
						},

				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},

		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
					originalEvent :
					new jQuery.Event( originalEvent );
		},

		special: {
			load: {

				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			click: {

				// Utilize native event to ensure correct state for checkable inputs
				setup: function( data ) {

					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;

					// Claim the first handler
					if ( rcheckableType.test( el.type ) &&
							el.click && nodeName( el, "input" ) ) {

						// dataPriv.set( el, "click", ... )
						leverageNative( el, "click", true );
					}

					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function( data ) {

					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;

					// Force setup before triggering a click
					if ( rcheckableType.test( el.type ) &&
							el.click && nodeName( el, "input" ) ) {

						leverageNative( el, "click" );
					}

					// Return non-false to allow normal event-path propagation
					return true;
				},

				// For cross-browser consistency, suppress native .click() on links
				// Also prevent it if we're currently inside a leveraged native-event stack
				_default: function( event ) {
					var target = event.target;
					return rcheckableType.test( target.type ) &&
							target.click && nodeName( target, "input" ) &&
							dataPriv.get( target, "click" ) ||
							nodeName( target, "a" );
				}
			},

			beforeunload: {
				postDispatch: function( event ) {

					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
	function leverageNative( el, type, isSetup ) {

		// Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
		if ( !isSetup ) {
			if ( dataPriv.get( el, type ) === undefined ) {
				jQuery.event.add( el, type, returnTrue );
			}
			return;
		}

		// Register the controller as a special universal handler for all event namespaces
		dataPriv.set( el, type, false );
		jQuery.event.add( el, type, {
			namespace: false,
			handler: function( event ) {
				var result,
						saved = dataPriv.get( this, type );

				if ( ( event.isTrigger & 1 ) && this[ type ] ) {

					// Interrupt processing of the outer synthetic .trigger()ed event
					if ( !saved ) {

						// Store arguments for use when handling the inner native event
						// There will always be at least one argument (an event object), so this array
						// will not be confused with a leftover capture object.
						saved = slice.call( arguments );
						dataPriv.set( this, type, saved );

						// Trigger the native event and capture its result
						this[ type ]();
						result = dataPriv.get( this, type );
						dataPriv.set( this, type, false );

						if ( saved !== result ) {

							// Cancel the outer synthetic event
							event.stopImmediatePropagation();
							event.preventDefault();

							return result;
						}

						// If this is an inner synthetic event for an event with a bubbling surrogate
						// (focus or blur), assume that the surrogate already propagated from triggering
						// the native event and prevent that from happening again here.
						// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
						// bubbling surrogate propagates *after* the non-bubbling base), but that seems
						// less bad than duplication.
					} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
						event.stopPropagation();
					}

					// If this is a native event triggered above, everything is now in order
					// Fire an inner synthetic event with the original arguments
				} else if ( saved ) {

					// ...and capture the result
					dataPriv.set( this, type, jQuery.event.trigger(
							saved[ 0 ],
							saved.slice( 1 ),
							this
					) );

					// Abort handling of the native event by all jQuery handlers while allowing
					// native handlers on the same element to run. On target, this is achieved
					// by stopping immediate propagation just on the jQuery event. However,
					// the native event is re-wrapped by a jQuery one on each level of the
					// propagation so the only way to stop it for jQuery is to stop it for
					// everyone via native `stopPropagation()`. This is not a problem for
					// focus/blur which don't bubble, but it does also stop click on checkboxes
					// and radios. We accept this limitation.
					event.stopPropagation();
					event.isImmediatePropagationStopped = returnTrue;
				}
			}
		} );
	}

	jQuery.removeEvent = function( elem, type, handle ) {

		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};

	jQuery.Event = function( src, props ) {

		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}

		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;

			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
			src.defaultPrevented === undefined &&

			// Support: Android <=2.3 only
			src.returnValue === false ?
					returnTrue :
					returnFalse;

			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (trac-504, trac-13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
					src.target.parentNode :
					src.target;

			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;

			// Event type
		} else {
			this.type = src;
		}

		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}

		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();

		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,

		preventDefault: function() {
			var e = this.originalEvent;

			this.isDefaultPrevented = returnTrue;

			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;

			this.isPropagationStopped = returnTrue;

			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;

			this.isImmediatePropagationStopped = returnTrue;

			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}

			this.stopPropagation();
		}
	};

// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		code: true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
		which: true
	}, jQuery.event.addProp );

	jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {

		function focusMappedHandler( nativeEvent ) {
			if ( document.documentMode ) {

				// Support: IE 11+
				// Attach a single focusin/focusout handler on the document while someone wants
				// focus/blur. This is because the former are synchronous in IE while the latter
				// are async. In other browsers, all those handlers are invoked synchronously.

				// `handle` from private data would already wrap the event, but we need
				// to change the `type` here.
				var handle = dataPriv.get( this, "handle" ),
						event = jQuery.event.fix( nativeEvent );
				event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
				event.isSimulated = true;

				// First, handle focusin/focusout
				handle( nativeEvent );

				// ...then, handle focus/blur
				//
				// focus/blur don't bubble while focusin/focusout do; simulate the former by only
				// invoking the handler at the lower level.
				if ( event.target === event.currentTarget ) {

					// The setup part calls `leverageNative`, which, in turn, calls
					// `jQuery.event.add`, so event handle will already have been set
					// by this point.
					handle( event );
				}
			} else {

				// For non-IE browsers, attach a single capturing handler on the document
				// while someone wants focusin/focusout.
				jQuery.event.simulate( delegateType, nativeEvent.target,
						jQuery.event.fix( nativeEvent ) );
			}
		}

		jQuery.event.special[ type ] = {

			// Utilize native event if possible so blur/focus sequence is correct
			setup: function() {

				var attaches;

				// Claim the first handler
				// dataPriv.set( this, "focus", ... )
				// dataPriv.set( this, "blur", ... )
				leverageNative( this, type, true );

				if ( document.documentMode ) {

					// Support: IE 9 - 11+
					// We use the same native handler for focusin & focus (and focusout & blur)
					// so we need to coordinate setup & teardown parts between those events.
					// Use `delegateType` as the key as `type` is already used by `leverageNative`.
					attaches = dataPriv.get( this, delegateType );
					if ( !attaches ) {
						this.addEventListener( delegateType, focusMappedHandler );
					}
					dataPriv.set( this, delegateType, ( attaches || 0 ) + 1 );
				} else {

					// Return false to allow normal processing in the caller
					return false;
				}
			},
			trigger: function() {

				// Force setup before trigger
				leverageNative( this, type );

				// Return non-false to allow normal event-path propagation
				return true;
			},

			teardown: function() {
				var attaches;

				if ( document.documentMode ) {
					attaches = dataPriv.get( this, delegateType ) - 1;
					if ( !attaches ) {
						this.removeEventListener( delegateType, focusMappedHandler );
						dataPriv.remove( this, delegateType );
					} else {
						dataPriv.set( this, delegateType, attaches );
					}
				} else {

					// Return false to indicate standard teardown should be applied
					return false;
				}
			},

			// Suppress native focus or blur if we're currently inside
			// a leveraged native-event stack
			_default: function( event ) {
				return dataPriv.get( event.target, type );
			},

			delegateType: delegateType
		};

		// Support: Firefox <=44
		// Firefox doesn't have focus(in | out) events
		// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
		//
		// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
		// focus(in | out) events fire after focus & blur events,
		// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
		// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
		//
		// Support: IE 9 - 11+
		// To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
		// attach a single handler for both events in IE.
		jQuery.event.special[ delegateType ] = {
			setup: function() {

				// Handle: regular nodes (via `this.ownerDocument`), window
				// (via `this.document`) & document (via `this`).
				var doc = this.ownerDocument || this.document || this,
						dataHolder = document.documentMode ? this : doc,
						attaches = dataPriv.get( dataHolder, delegateType );

				// Support: IE 9 - 11+
				// We use the same native handler for focusin & focus (and focusout & blur)
				// so we need to coordinate setup & teardown parts between those events.
				// Use `delegateType` as the key as `type` is already used by `leverageNative`.
				if ( !attaches ) {
					if ( document.documentMode ) {
						this.addEventListener( delegateType, focusMappedHandler );
					} else {
						doc.addEventListener( type, focusMappedHandler, true );
					}
				}
				dataPriv.set( dataHolder, delegateType, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this.document || this,
						dataHolder = document.documentMode ? this : doc,
						attaches = dataPriv.get( dataHolder, delegateType ) - 1;

				if ( !attaches ) {
					if ( document.documentMode ) {
						this.removeEventListener( delegateType, focusMappedHandler );
					} else {
						doc.removeEventListener( type, focusMappedHandler, true );
					}
					dataPriv.remove( dataHolder, delegateType );
				} else {
					dataPriv.set( dataHolder, delegateType, attaches );
				}
			}
		};
	} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,

			handle: function( event ) {
				var ret,
						target = this,
						related = event.relatedTarget,
						handleObj = event.handleObj;

				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );

	jQuery.fn.extend( {

		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {

				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
						handleObj.namespace ?
								handleObj.origType + "." + handleObj.namespace :
								handleObj.origType,
						handleObj.selector,
						handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {

				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {

				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );


	var

			// Support: IE <=10 - 11, Edge 12 - 13 only
			// In IE/Edge using regex groups here causes severe slowdowns.
			// See https://connect.microsoft.com/IE/feedback/details/1736512/
			rnoInnerhtml = /<script|<style|<link/i,

			// checked="checked" or checked
			rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,

			rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
				nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}

		return elem;
	}

// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}

		return elem;
	}

	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, udataOld, udataCur, events;

		if ( dest.nodeType !== 1 ) {
			return;
		}

		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.get( src );
			events = pdataOld.events;

			if ( events ) {
				dataPriv.remove( dest, "handle events" );

				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}

		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );

			dataUser.set( dest, udataCur );
		}
	}

// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();

		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;

			// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}

	function domManip( collection, args, callback, ignored ) {

		// Flatten any nested arrays
		args = flat( args );

		var fragment, first, scripts, hasScripts, node, doc,
				i = 0,
				l = collection.length,
				iNoClone = l - 1,
				value = args[ 0 ],
				valueIsFunction = isFunction( value );

		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
						!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}

		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;

			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}

			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;

				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (trac-8070).
				for ( ; i < l; i++ ) {
					node = fragment;

					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );

						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {

							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}

					callback.call( collection[ i ], node, i );
				}

				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;

					// Re-enable scripts
					jQuery.map( scripts, restoreScript );

					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
								!dataPriv.access( node, "globalEval" ) &&
								jQuery.contains( doc, node ) ) {

							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl && !node.noModule ) {
									jQuery._evalUrl( node.src, {
										nonce: node.nonce || node.getAttribute( "nonce" )
									}, doc );
								}
							} else {

								// Unwrap a CDATA section containing script contents. This shouldn't be
								// needed as in XML documents they're already not visible when
								// inspecting element contents and in HTML documents they have no
								// meaning but we're preserving that logic for backwards compatibility.
								// This will be removed completely in 4.0. See gh-4904.
								DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
							}
						}
					}
				}
			}
		}

		return collection;
	}

	function remove( elem, selector, keepData ) {
		var node,
				nodes = selector ? jQuery.filter( selector, elem ) : elem,
				i = 0;

		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}

			if ( node.parentNode ) {
				if ( keepData && isAttached( node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}

		return elem;
	}

	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html;
		},

		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
					clone = elem.cloneNode( true ),
					inPage = isAttached( elem );

			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {

				// We eschew jQuery#find here for performance reasons:
				// https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}

			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );

					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}

			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}

			// Return the cloned set
			return clone;
		},

		cleanData: function( elems ) {
			var data, elem, type,
					special = jQuery.event.special,
					i = 0;

			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );

									// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}

						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {

						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );

	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},

		remove: function( selector ) {
			return remove( this, selector );
		},

		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
						jQuery.text( this ) :
						this.empty().each( function() {
							if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
								this.textContent = value;
							}
						} );
			}, null, value, arguments.length );
		},

		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},

		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},

		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},

		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},

		empty: function() {
			var elem,
					i = 0;

			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {

					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );

					// Remove any remaining nodes
					elem.textContent = "";
				}
			}

			return this;
		},

		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},

		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
						i = 0,
						l = this.length;

				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}

				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
						!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

					value = jQuery.htmlPrefilter( value );

					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};

							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}

						elem = 0;

						// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}

				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},

		replaceWith: function() {
			var ignored = [];

			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;

				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}

				// Force callback invocation
			}, ignored );
		}
	} );

	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
					ret = [],
					insert = jQuery( selector ),
					last = insert.length - 1,
					i = 0;

			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );

				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}

			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

	var rcustomProp = /^--/;


	var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

	var swap = function( elem, options, callback ) {
		var ret, name,
				old = {};

		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}

		ret = callback.call( elem );

		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}

		return ret;
	};


	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



	( function() {

		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {

			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}

			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
					"margin-top:1px;padding:0;border:0";
			div.style.cssText =
					"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
					"margin:auto;border:1px;padding:1px;" +
					"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );

			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";

			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			// Support: Chrome <=64
			// Don't get tricked when zoom affects offsetWidth (gh-4029)
			div.style.position = "absolute";
			scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

			documentElement.removeChild( container );

			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}

		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}

		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
				reliableTrDimensionsVal, reliableMarginLeftVal,
				container = document.createElement( "div" ),
				div = document.createElement( "div" );

		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}

		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (trac-8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";

		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			},

			// Support: IE 9 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Behavior in IE 9 is more subtle than in newer versions & it passes
			// some versions of this test; make sure not to make it pass there!
			//
			// Support: Firefox 70+
			// Only Firefox includes border widths
			// in computed dimensions. (gh-4529)
			reliableTrDimensions: function() {
				var table, tr, trChild, trStyle;
				if ( reliableTrDimensionsVal == null ) {
					table = document.createElement( "table" );
					tr = document.createElement( "tr" );
					trChild = document.createElement( "div" );

					table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
					tr.style.cssText = "box-sizing:content-box;border:1px solid";

					// Support: Chrome 86+
					// Height set through cssText does not get applied.
					// Computed height then comes back as 0.
					tr.style.height = "1px";
					trChild.style.height = "9px";

					// Support: Android 8 Chrome 86+
					// In our bodyBackground.html iframe,
					// display for all div elements is set to "inline",
					// which causes a problem only in Android 8 Chrome 86.
					// Ensuring the div is `display: block`
					// gets around this issue.
					trChild.style.display = "block";

					documentElement
							.appendChild( table )
							.appendChild( tr )
							.appendChild( trChild );

					trStyle = window.getComputedStyle( tr );
					reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
							parseInt( trStyle.borderTopWidth, 10 ) +
							parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

					documentElement.removeChild( table );
				}
				return reliableTrDimensionsVal;
			}
		} );
	} )();


	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
				isCustomProp = rcustomProp.test( name ),

				// Support: Firefox 51+
				// Retrieving style before computed somehow
				// fixes an issue with getting wrong values
				// on detached elements
				style = elem.style;

		computed = computed || getStyles( elem );

		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, trac-12537)
		//   .css('--customProperty) (gh-3144)
		if ( computed ) {

			// Support: IE <=9 - 11+
			// IE only supports `"float"` in `getPropertyValue`; in computed styles
			// it's only available as `"cssFloat"`. We no longer modify properties
			// sent to `.css()` apart from camelCasing, so we need to check both.
			// Normally, this would create difference in behavior: if
			// `getPropertyValue` returns an empty string, the value returned
			// by `.css()` would be `undefined`. This is usually the case for
			// disconnected elements. However, in IE even disconnected elements
			// with no styles return `"none"` for `getPropertyValue( "float" )`
			ret = computed.getPropertyValue( name ) || computed[ name ];

			if ( isCustomProp && ret ) {

				// Support: Firefox 105+, Chrome <=105+
				// Spec requires trimming whitespace for custom properties (gh-4926).
				// Firefox only trims leading whitespace. Chrome just collapses
				// both leading & trailing whitespace to a single space.
				//
				// Fall back to `undefined` if empty string returned.
				// This collapses a missing definition with property defined
				// and set to an empty string but there's no standard API
				// allowing us to differentiate them without a performance penalty
				// and returning `undefined` aligns with older jQuery.
				//
				// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
				// as whitespace while CSS does not, but this is not a problem
				// because CSS preprocessing replaces them with U+000A LINE FEED
				// (which *is* CSS whitespace)
				// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
				ret = ret.replace( rtrimCSS, "$1" ) || undefined;
			}

			if ( ret === "" && !isAttached( elem ) ) {
				ret = jQuery.style( elem, name );
			}

			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;

				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;

				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}

		return ret !== undefined ?

				// Support: IE <=9 - 11 only
				// IE returns zIndex value as an integer.
				ret + "" :
				ret;
	}


	function addGetHookIf( conditionFn, hookFn ) {

		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {

					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}

				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}


	var cssPrefixes = [ "Webkit", "Moz", "ms" ],
			emptyStyle = document.createElement( "div" ).style,
			vendorProps = {};

// Return a vendor-prefixed property or undefined
	function vendorPropName( name ) {

		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
				i = cssPrefixes.length;

		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
	function finalPropName( name ) {
		var final = jQuery.cssProps[ name ] || vendorProps[ name ];

		if ( final ) {
			return final;
		}
		if ( name in emptyStyle ) {
			return name;
		}
		return vendorProps[ name ] = vendorPropName( name ) || name;
	}


	var

			// Swappable if display is none or starts with table
			// except "table", "table-cell", or "table-caption"
			// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
			rdisplayswap = /^(none|table(?!-c[ea]).+)/,
			cssShow = { position: "absolute", visibility: "hidden", display: "block" },
			cssNormalTransform = {
				letterSpacing: "0",
				fontWeight: "400"
			};

	function setPositiveNumber( _elem, value, subtract ) {

		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?

				// Guard against undefined "subtract", e.g., when used as in cssHooks
				Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
				value;
	}

	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
				extra = 0,
				delta = 0,
				marginDelta = 0;

		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}

		for ( ; i < 4; i += 2 ) {

			// Both box models exclude margin
			// Count margin delta separately to only add it after scroll gutter adjustment.
			// This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
			if ( box === "margin" ) {
				marginDelta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}

			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {

				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

					// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}

				// If we get here with a border-box (content + padding + border), we're seeking "content" or
				// "padding" or "margin"
			} else {

				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}

				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}

		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {

			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					computedVal -
					delta -
					extra -
					0.5

					// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
					// Use an explicit zero to avoid NaN (gh-3964)
			) ) || 0;
		}

		return delta + marginDelta;
	}

	function getWidthOrHeight( elem, dimension, extra ) {

		// Start with computed style
		var styles = getStyles( elem ),

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
				// Fake content-box until we know it's needed to know the true value.
				boxSizingNeeded = !support.boxSizingReliable() || extra,
				isBorderBox = boxSizingNeeded &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				valueIsBorderBox = isBorderBox,

				val = curCSS( elem, dimension, styles ),
				offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}


		// Support: IE 9 - 11 only
		// Use offsetWidth/offsetHeight for when box sizing is unreliable.
		// In those cases, the computed value can be trusted to be border-box.
		if ( ( !support.boxSizingReliable() && isBorderBox ||

						// Support: IE 10 - 11+, Edge 15 - 18+
						// IE/Edge misreport `getComputedStyle` of table rows with width/height
						// set in CSS while `offset*` properties report correct values.
						// Interestingly, in some cases IE 9 doesn't suffer from this issue.
						!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

						// Fall back to offsetWidth/offsetHeight when value is "auto"
						// This happens for inline elements with no explicit setting (gh-3571)
						val === "auto" ||

						// Support: Android <=4.1 - 4.3 only
						// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
						!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

				// Make sure the element is visible & connected
				elem.getClientRects().length ) {

			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

			// Where available, offsetWidth/offsetHeight approximate border box dimensions.
			// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
			// retrieved value as a content box dimension.
			valueIsBorderBox = offsetProp in elem;
			if ( valueIsBorderBox ) {
				val = elem[ offsetProp ];
			}
		}

		// Normalize "" and auto
		val = parseFloat( val ) || 0;

		// Adjust for the element's box model
		return ( val +
				boxModelAdjustment(
						elem,
						dimension,
						extra || ( isBorderBox ? "border" : "content" ),
						valueIsBorderBox,
						styles,

						// Provide the current computed size to request scroll gutter calculation (gh-3589)
						val
				)
		) + "px";
	}

	jQuery.extend( {

		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {

						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},

		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			animationIterationCount: true,
			aspectRatio: true,
			borderImageSlice: true,
			columnCount: true,
			flexGrow: true,
			flexShrink: true,
			fontWeight: true,
			gridArea: true,
			gridColumn: true,
			gridColumnEnd: true,
			gridColumnStart: true,
			gridRow: true,
			gridRowEnd: true,
			gridRowStart: true,
			lineHeight: true,
			opacity: true,
			order: true,
			orphans: true,
			scale: true,
			widows: true,
			zIndex: true,
			zoom: true,

			// SVG-related
			fillOpacity: true,
			floodOpacity: true,
			stopOpacity: true,
			strokeMiterlimit: true,
			strokeOpacity: true
		},

		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},

		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {

			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}

			// Make sure that we're working with the right name
			var ret, type, hooks,
					origName = camelCase( name ),
					isCustomProp = rcustomProp.test( name ),
					style = elem.style;

			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}

			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;

				// Convert "+=" or "-=" to relative numbers (trac-7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );

					// Fixes bug trac-9237
					type = "number";
				}

				// Make sure that null and NaN values aren't set (trac-7116)
				if ( value == null || value !== value ) {
					return;
				}

				// If a number was passed in, add the unit (except for certain CSS properties)
				// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
				// "px" to a few hardcoded values.
				if ( type === "number" && !isCustomProp ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}

				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}

				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
						( value = hooks.set( elem, value, extra ) ) !== undefined ) {

					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}

			} else {

				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
						( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

					return ret;
				}

				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},

		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
					origName = camelCase( name ),
					isCustomProp = rcustomProp.test( name );

			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}

			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}

			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}

			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}

			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}

			return val;
		}
	} );

	jQuery.each( [ "height", "width" ], function( _i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {

					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, dimension, extra );
							} ) :
							getWidthOrHeight( elem, dimension, extra );
				}
			},

			set: function( elem, value, extra ) {
				var matches,
						styles = getStyles( elem ),

						// Only read styles.position if the test has a chance to fail
						// to avoid forcing a reflow.
						scrollboxSizeBuggy = !support.scrollboxSize() &&
								styles.position === "absolute",

						// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
						boxSizingNeeded = scrollboxSizeBuggy || extra,
						isBorderBox = boxSizingNeeded &&
								jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						subtract = extra ?
								boxModelAdjustment(
										elem,
										dimension,
										extra,
										isBorderBox,
										styles
								) :
								0;

				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && scrollboxSizeBuggy ) {
					subtract -= Math.ceil(
							elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
							parseFloat( styles[ dimension ] ) -
							boxModelAdjustment( elem, dimension, "border", false, styles ) -
							0.5
					);
				}

				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
						( matches[ 3 ] || "px" ) !== "px" ) {

					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}

				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );

	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
			function( elem, computed ) {
				if ( computed ) {
					return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
							elem.getBoundingClientRect().left -
							swap( elem, { marginLeft: 0 }, function() {
								return elem.getBoundingClientRect().left;
							} )
					) + "px";
				}
			}
	);

// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
						expanded = {},

						// Assumes a single number if not a string
						parts = typeof value === "string" ? value.split( " " ) : [ value ];

				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
							parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}

				return expanded;
			}
		};

		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );

	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
						map = {},
						i = 0;

				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;

					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}

					return map;
				}

				return value !== undefined ?
						jQuery.style( elem, name, value ) :
						jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );


	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;

	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];

			return hooks && hooks.get ?
					hooks.get( this ) :
					Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
					hooks = Tween.propHooks[ this.prop ];

			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
						percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;

			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}

			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};

	Tween.prototype.init.prototype = Tween.prototype;

	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;

				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
						tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}

				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );

				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {

				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 && (
						jQuery.cssHooks[ tween.prop ] ||
						tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};

	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};

	jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
	jQuery.fx.step = {};




	var
			fxNow, inProgress,
			rfxtypes = /^(?:toggle|show|hide)$/,
			rrun = /queueHooks$/;

	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}

			jQuery.fx.tick();
		}
	}

// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}

// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
				i = 0,
				attrs = { height: type };

		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}

		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}

		return attrs;
	}

	function createTween( value, prop, animation ) {
		var tween,
				collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
				index = 0,
				length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

				// We're done with this property
				return tween;
			}
		}
	}

	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
				isBox = "width" in props || "height" in props,
				anim = this,
				orig = {},
				style = elem.style,
				hidden = elem.nodeType && isHiddenWithinTree( elem ),
				dataShow = dataPriv.get( elem, "fxshow" );

		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;

			anim.always( function() {

				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}

		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {

					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;

						// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}

		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}

		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {

			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {

					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}

			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {

					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}

		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}

		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {

			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}

				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}

				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}

				/* eslint-disable no-loop-func */

				anim.done( function() {

					/* eslint-enable no-loop-func */

					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}

			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}

	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;

		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}

			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}

			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];

				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}

	function Animation( elem, properties, options ) {
		var result,
				stopped,
				index = 0,
				length = Animation.prefilters.length,
				deferred = jQuery.Deferred().always( function() {

					// Don't match elem in the :animated selector
					delete tick.elem;
				} ),
				tick = function() {
					if ( stopped ) {
						return false;
					}
					var currentTime = fxNow || createFxNow(),
							remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

							// Support: Android 2.3 only
							// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
							temp = remaining / animation.duration || 0,
							percent = 1 - temp,
							index = 0,
							length = animation.tweens.length;

					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( percent );
					}

					deferred.notifyWith( elem, [ animation, percent, remaining ] );

					// If there's more to do, yield
					if ( percent < 1 && length ) {
						return remaining;
					}

					// If this was an empty animation, synthesize a final progress notification
					if ( !length ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
					}

					// Resolve the animation and report its conclusion
					deferred.resolveWith( elem, [ animation ] );
					return false;
				},
				animation = deferred.promise( {
					elem: elem,
					props: jQuery.extend( {}, properties ),
					opts: jQuery.extend( true, {
						specialEasing: {},
						easing: jQuery.easing._default
					}, options ),
					originalProperties: properties,
					originalOptions: options,
					startTime: fxNow || createFxNow(),
					duration: options.duration,
					tweens: [],
					createTween: function( prop, end ) {
						var tween = jQuery.Tween( elem, animation.opts, prop, end,
								animation.opts.specialEasing[ prop ] || animation.opts.easing );
						animation.tweens.push( tween );
						return tween;
					},
					stop: function( gotoEnd ) {
						var index = 0,

								// If we are going to the end, we want to run all the tweens
								// otherwise we skip this part
								length = gotoEnd ? animation.tweens.length : 0;
						if ( stopped ) {
							return this;
						}
						stopped = true;
						for ( ; index < length; index++ ) {
							animation.tweens[ index ].run( 1 );
						}

						// Resolve when we played the last frame; otherwise, reject
						if ( gotoEnd ) {
							deferred.notifyWith( elem, [ animation, 1, 0 ] );
							deferred.resolveWith( elem, [ animation, gotoEnd ] );
						} else {
							deferred.rejectWith( elem, [ animation, gotoEnd ] );
						}
						return this;
					}
				} ),
				props = animation.props;

		propFilter( props, animation.opts.specialEasing );

		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
							result.stop.bind( result );
				}
				return result;
			}
		}

		jQuery.map( props, createTween, animation );

		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}

		// Attach callbacks from options
		animation
				.progress( animation.opts.progress )
				.done( animation.opts.done, animation.opts.complete )
				.fail( animation.opts.fail )
				.always( animation.opts.always );

		jQuery.fx.timer(
				jQuery.extend( tick, {
					elem: elem,
					anim: animation,
					queue: animation.opts.queue
				} )
		);

		return animation;
	}

	jQuery.Animation = jQuery.extend( Animation, {

		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},

		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}

			var prop,
					index = 0,
					length = props.length;

			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},

		prefilters: [ defaultPrefilter ],

		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );

	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
					isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};

		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;

		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];

				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}

		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}

		// Queueing
		opt.old = opt.complete;

		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}

			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};

		return opt;
	};

	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {

			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

					// Animate to the value specified
					.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
					optall = jQuery.speed( speed, easing, callback ),
					doAnimation = function() {

						// Operate on a copy of prop so per-property easing won't be lost
						var anim = Animation( this, jQuery.extend( {}, prop ), optall );

						// Empty animations, or finishing resolves immediately
						if ( empty || dataPriv.get( this, "finish" ) ) {
							anim.stop( true );
						}
					};

			doAnimation.finish = doAnimation;

			return empty || optall.queue === false ?
					this.each( doAnimation ) :
					this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};

			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue ) {
				this.queue( type || "fx", [] );
			}

			return this.each( function() {
				var dequeue = true,
						index = type != null && type + "queueHooks",
						timers = jQuery.timers,
						data = dataPriv.get( this );

				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}

				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
							( type == null || timers[ index ].queue === type ) ) {

						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}

				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
						data = dataPriv.get( this ),
						queue = data[ type + "queue" ],
						hooks = data[ type + "queueHooks" ],
						timers = jQuery.timers,
						length = queue ? queue.length : 0;

				// Enable finishing flag on private data
				data.finish = true;

				// Empty the queue first
				jQuery.queue( this, type, [] );

				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}

				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}

				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}

				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );

	jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
					cssFn.apply( this, arguments ) :
					this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );

// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );

	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
				i = 0,
				timers = jQuery.timers;

		fxNow = Date.now();

		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];

			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}

		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};

	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};

	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}

		inProgress = true;
		schedule();
	};

	jQuery.fx.stop = function() {
		inProgress = null;
	};

	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,

		// Default speed
		_default: 400
	};


// Based off of the plugin by Clint Helfers, with permission.
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";

		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};


	( function() {
		var input = document.createElement( "input" ),
				select = document.createElement( "select" ),
				opt = select.appendChild( document.createElement( "option" ) );

		input.type = "checkbox";

		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";

		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;

		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();


	var boolHook,
			attrHandle = jQuery.expr.attrHandle;

	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},

		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );

	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
					nType = elem.nodeType;

			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}

			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}

			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
						( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}

			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}

				if ( hooks && "set" in hooks &&
						( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}

				elem.setAttribute( name, value + "" );
				return value;
			}

			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}

			ret = jQuery.find.attr( elem, name );

			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},

		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
							nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},

		removeAttr: function( elem, value ) {
			var name,
					i = 0,

					// Attribute names can contain non-HTML whitespace characters
					// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
					attrNames = value && value.match( rnothtmlwhite );

			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );

// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {

				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};

	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;

		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
					lowercaseName = name.toLowerCase();

			if ( !isXML ) {

				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
						lowercaseName :
						null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );




	var rfocusable = /^(?:input|select|textarea|button)$/i,
			rclickable = /^(?:a|area)$/i;

	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},

		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );

	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
					nType = elem.nodeType;

			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}

			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}

			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
						( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}

				return ( elem[ name ] = value );
			}

			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}

			return elem[ name ];
		},

		propHooks: {
			tabIndex: {
				get: function( elem ) {

					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// Use proper attribute retrieval (trac-12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );

					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}

					if (
							rfocusable.test( elem.nodeName ) ||
							rclickable.test( elem.nodeName ) &&
							elem.href
					) {
						return 0;
					}

					return -1;
				}
			}
		},

		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {

				/* eslint no-unused-expressions: "off" */

				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {

				/* eslint no-unused-expressions: "off" */

				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;

					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}

	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}

	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}

	jQuery.fn.extend( {
		addClass: function( value ) {
			var classNames, cur, curValue, className, i, finalValue;

			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}

			classNames = classesToArray( value );

			if ( classNames.length ) {
				return this.each( function() {
					curValue = getClass( this );
					cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

					if ( cur ) {
						for ( i = 0; i < classNames.length; i++ ) {
							className = classNames[ i ];
							if ( cur.indexOf( " " + className + " " ) < 0 ) {
								cur += className + " ";
							}
						}

						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							this.setAttribute( "class", finalValue );
						}
					}
				} );
			}

			return this;
		},

		removeClass: function( value ) {
			var classNames, cur, curValue, className, i, finalValue;

			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}

			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}

			classNames = classesToArray( value );

			if ( classNames.length ) {
				return this.each( function() {
					curValue = getClass( this );

					// This expression is here for better compressibility (see addClass)
					cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

					if ( cur ) {
						for ( i = 0; i < classNames.length; i++ ) {
							className = classNames[ i ];

							// Remove *all* instances
							while ( cur.indexOf( " " + className + " " ) > -1 ) {
								cur = cur.replace( " " + className + " ", " " );
							}
						}

						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							this.setAttribute( "class", finalValue );
						}
					}
				} );
			}

			return this;
		},

		toggleClass: function( value, stateVal ) {
			var classNames, className, i, self,
					type = typeof value,
					isValidValue = type === "string" || Array.isArray( value );

			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
							value.call( this, i, getClass( this ), stateVal ),
							stateVal
					);
				} );
			}

			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}

			classNames = classesToArray( value );

			return this.each( function() {
				if ( isValidValue ) {

					// Toggle individual class names
					self = jQuery( this );

					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];

						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}

					// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {

						// Store className if set
						dataPriv.set( this, "__className__", className );
					}

					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
								className || value === false ?
										"" :
										dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},

		hasClass: function( selector ) {
			var className, elem,
					i = 0;

			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
						( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
				}
			}

			return false;
		}
	} );




	var rreturn = /\r/g;

	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
					elem = this[ 0 ];

			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
							jQuery.valHooks[ elem.nodeName.toLowerCase() ];

					if ( hooks &&
							"get" in hooks &&
							( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}

					ret = elem.value;

					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}

					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}

				return;
			}

			valueIsFunction = isFunction( value );

			return this.each( function( i ) {
				var val;

				if ( this.nodeType !== 1 ) {
					return;
				}

				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}

				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";

				} else if ( typeof val === "number" ) {
					val += "";

				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}

				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );

	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {

					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
							val :

							// Support: IE <=10 - 11 only
							// option.text throws exceptions (trac-14686, trac-14858)
							// Strip and collapse whitespace
							// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
							stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
							options = elem.options,
							index = elem.selectedIndex,
							one = elem.type === "select-one",
							values = one ? null : [],
							max = one ? index + 1 : options.length;

					if ( index < 0 ) {
						i = max;

					} else {
						i = one ? index : 0;
					}

					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];

						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (trac-2551)
						if ( ( option.selected || i === index ) &&

								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
										!nodeName( option.parentNode, "optgroup" ) ) ) {

							// Get the specific value for the option
							value = jQuery( option ).val();

							// We don't need an array for one selects
							if ( one ) {
								return value;
							}

							// Multi-Selects return an array
							values.push( value );
						}
					}

					return values;
				},

				set: function( elem, value ) {
					var optionSet, option,
							options = elem.options,
							values = jQuery.makeArray( value ),
							i = options.length;

					while ( i-- ) {
						option = options[ i ];

						/* eslint-disable no-cond-assign */

						if ( option.selected =
								jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}

						/* eslint-enable no-cond-assign */
					}

					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );

// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );




// Return jQuery for attributes-only inclusion
	var location = window.location;

	var nonce = { guid: Date.now() };

	var rquery = ( /\?/ );



// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml, parserErrorElem;
		if ( !data || typeof data !== "string" ) {
			return null;
		}

		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {}

		parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
		if ( !xml || parserErrorElem ) {
			jQuery.error( "Invalid XML: " + (
					parserErrorElem ?
							jQuery.map( parserErrorElem.childNodes, function( el ) {
								return el.textContent;
							} ).join( "\n" ) :
							data
			) );
		}
		return xml;
	};


	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
			stopPropagationCallback = function( e ) {
				e.stopPropagation();
			};

	jQuery.extend( jQuery.event, {

		trigger: function( event, data, elem, onlyHandlers ) {

			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
					eventPath = [ elem || document ],
					type = hasOwn.call( event, "type" ) ? event.type : event,
					namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

			cur = lastElement = tmp = elem = elem || document;

			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}

			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}

			if ( type.indexOf( "." ) > -1 ) {

				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;

			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
					event :
					new jQuery.Event( type, typeof event === "object" && event );

			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
					null;

			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}

			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
					[ event ] :
					jQuery.makeArray( data, [ event ] );

			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}

			// Determine event propagation path in advance, per W3C events spec (trac-9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}

				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}

			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
						bubbleType :
						special.bindType || type;

				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
						dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}

				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;

			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {

				if ( ( !special._default ||
								special._default.apply( eventPath.pop(), data ) === false ) &&
						acceptData( elem ) ) {

					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (trac-6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];

						if ( tmp ) {
							elem[ ontype ] = null;
						}

						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;

						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}

						elem[ type ]();

						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}

						jQuery.event.triggered = undefined;

						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}

			return event.result;
		},

		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
					new jQuery.Event(),
					event,
					{
						type: type,
						isSimulated: true
					}
			);

			jQuery.event.trigger( e, null, elem );
		}

	} );

	jQuery.fn.extend( {

		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );


	var
			rbracket = /\[\]$/,
			rCRLF = /\r?\n/g,
			rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
			rsubmittable = /^(?:input|select|textarea|keygen)/i;

	function buildParams( prefix, obj, traditional, add ) {
		var name;

		if ( Array.isArray( obj ) ) {

			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {

					// Treat each array item as a scalar.
					add( prefix, v );

				} else {

					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
							prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
							v,
							traditional,
							add
					);
				}
			} );

		} else if ( !traditional && toType( obj ) === "object" ) {

			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}

		} else {

			// Serialize scalar item.
			add( prefix, obj );
		}
	}

// Serialize an array of form elements or a set of
// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
				s = [],
				add = function( key, valueOrFunction ) {

					// If value is a function, invoke it and use its return value
					var value = isFunction( valueOrFunction ) ?
							valueOrFunction() :
							valueOrFunction;

					s[ s.length ] = encodeURIComponent( key ) + "=" +
							encodeURIComponent( value == null ? "" : value );
				};

		if ( a == null ) {
			return "";
		}

		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );

		} else {

			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}

		// Return the resulting serialization
		return s.join( "&" );
	};

	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {

				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} ).filter( function() {
				var type = this.type;

				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
						rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
						( this.checked || !rcheckableType.test( type ) );
			} ).map( function( _i, elem ) {
				var val = jQuery( this ).val();

				if ( val == null ) {
					return null;
				}

				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}

				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );


	var
			r20 = /%20/g,
			rhash = /#.*$/,
			rantiCache = /([?&])_=[^&]*/,
			rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

			// trac-7653, trac-8125, trac-8152: local protocol detection
			rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
			rnoContent = /^(?:GET|HEAD)$/,
			rprotocol = /^\/\//,

			/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
			prefilters = {},

			/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
			transports = {},

			// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
			allTypes = "*/".concat( "*" ),

			// Anchor tag for parsing the document origin
			originAnchor = document.createElement( "a" );

	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {

		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {

			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}

			var dataType,
					i = 0,
					dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

			if ( isFunction( func ) ) {

				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {

					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

						// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}

// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

		var inspected = {},
				seekingTransport = ( structure === transports );

		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
						!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}

		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes trac-9887
	function ajaxExtend( target, src ) {
		var key, deep,
				flatOptions = jQuery.ajaxSettings.flatOptions || {};

		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}

		return target;
	}

	/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
	function ajaxHandleResponses( s, jqXHR, responses ) {

		var ct, type, finalDataType, firstDataType,
				contents = s.contents,
				dataTypes = s.dataTypes;

		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}

		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}

		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {

			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}

			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}

		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}

	/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
				converters = {},

				// Work with a copy of dataTypes in case we need to modify it for conversion
				dataTypes = s.dataTypes.slice();

		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}

		current = dataTypes.shift();

		// Convert to each sequential dataType
		while ( current ) {

			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}

			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}

			prev = current;
			current = dataTypes.shift();

			if ( current ) {

				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {

					current = prev;

					// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {

					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];

					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {

							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {

								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
										converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {

									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];

										// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}

					// Apply converter (if not an equivalence)
					if ( conv !== true ) {

						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}

		return { state: "success", data: response };
	}

	jQuery.extend( {

		// Counter for holding the number of active queries
		active: 0,

		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},

		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",

			/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},

			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},

			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},

			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {

				// Convert anything to text
				"* text": String,

				// Text to html (true = no transformation)
				"text html": true,

				// Evaluate text as a json expression
				"text json": JSON.parse,

				// Parse text as xml
				"text xml": jQuery.parseXML
			},

			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},

		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?

					// Building a settings object
					ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

					// Extending ajaxSettings
					ajaxExtend( jQuery.ajaxSettings, target );
		},

		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),

		// Main method
		ajax: function( url, options ) {

			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}

			// Force options to be an object
			options = options || {};

			var transport,

					// URL without anti-cache param
					cacheURL,

					// Response headers
					responseHeadersString,
					responseHeaders,

					// timeout handle
					timeoutTimer,

					// Url cleanup var
					urlAnchor,

					// Request state (becomes false upon send and true upon completion)
					completed,

					// To know if global events are to be dispatched
					fireGlobals,

					// Loop variable
					i,

					// uncached part of the url
					uncached,

					// Create the final options object
					s = jQuery.ajaxSetup( {}, options ),

					// Callbacks context
					callbackContext = s.context || s,

					// Context for global events is callbackContext if it is a DOM node or jQuery collection
					globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
							jQuery( callbackContext ) :
							jQuery.event,

					// Deferreds
					deferred = jQuery.Deferred(),
					completeDeferred = jQuery.Callbacks( "once memory" ),

					// Status-dependent callbacks
					statusCode = s.statusCode || {},

					// Headers (they are sent all at once)
					requestHeaders = {},
					requestHeadersNames = {},

					// Default abort message
					strAbort = "canceled",

					// Fake xhr
					jqXHR = {
						readyState: 0,

						// Builds headers hashtable if needed
						getResponseHeader: function( key ) {
							var match;
							if ( completed ) {
								if ( !responseHeaders ) {
									responseHeaders = {};
									while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
										responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
												( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
														.concat( match[ 2 ] );
									}
								}
								match = responseHeaders[ key.toLowerCase() + " " ];
							}
							return match == null ? null : match.join( ", " );
						},

						// Raw string
						getAllResponseHeaders: function() {
							return completed ? responseHeadersString : null;
						},

						// Caches the header
						setRequestHeader: function( name, value ) {
							if ( completed == null ) {
								name = requestHeadersNames[ name.toLowerCase() ] =
										requestHeadersNames[ name.toLowerCase() ] || name;
								requestHeaders[ name ] = value;
							}
							return this;
						},

						// Overrides response content-type header
						overrideMimeType: function( type ) {
							if ( completed == null ) {
								s.mimeType = type;
							}
							return this;
						},

						// Status-dependent callbacks
						statusCode: function( map ) {
							var code;
							if ( map ) {
								if ( completed ) {

									// Execute the appropriate callbacks
									jqXHR.always( map[ jqXHR.status ] );
								} else {

									// Lazy-add the new callbacks in a way that preserves old ones
									for ( code in map ) {
										statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
									}
								}
							}
							return this;
						},

						// Cancel the request
						abort: function( statusText ) {
							var finalText = statusText || strAbort;
							if ( transport ) {
								transport.abort( finalText );
							}
							done( 0, finalText );
							return this;
						}
					};

			// Attach deferreds
			deferred.promise( jqXHR );

			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (trac-10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
					.replace( rprotocol, location.protocol + "//" );

			// Alias method option to type as per ticket trac-12004
			s.type = options.method || options.type || s.method || s.type;

			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );

				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;

					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
							urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {

					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}

			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}

			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}

			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
			fireGlobals = jQuery.event && s.global;

			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}

			// Uppercase the type
			s.type = s.type.toUpperCase();

			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );

			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );

			// More options handling for requests with no content
			if ( !s.hasContent ) {

				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );

				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

					// trac-9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}

				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
							uncached;
				}

				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;

				// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
					( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}

			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}

			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}

			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
					"Accept",
					s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
							s.accepts[ s.dataTypes[ 0 ] ] +
							( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
							s.accepts[ "*" ]
			);

			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}

			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
					( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

				// Abort if not done already and return
				return jqXHR.abort();
			}

			// Aborting is no longer a cancellation
			strAbort = "abort";

			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );

			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;

				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}

				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}

				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}

				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {

					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}

					// Propagate others as results
					done( -1, e );
				}
			}

			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
						statusText = nativeStatusText;

				// Ignore repeat invocations
				if ( completed ) {
					return;
				}

				completed = true;

				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}

				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;

				// Cache response headers
				responseHeadersString = headers || "";

				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;

				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;

				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}

				// Use a noop converter for missing script but not if jsonp
				if ( !isSuccess &&
						jQuery.inArray( "script", s.dataTypes ) > -1 &&
						jQuery.inArray( "json", s.dataTypes ) < 0 ) {
					s.converters[ "text script" ] = function() {};
				}

				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );

				// If successful, handle type chaining
				if ( isSuccess ) {

					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}

					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";

						// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";

						// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {

					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}

				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";

				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}

				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;

				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
							[ jqXHR, s, isSuccess ? success : error ] );
				}

				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}

			return jqXHR;
		},

		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},

		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );

	jQuery.each( [ "get", "post" ], function( _i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {

			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}

			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );

	jQuery.ajaxPrefilter( function( s ) {
		var i;
		for ( i in s.headers ) {
			if ( i.toLowerCase() === "content-type" ) {
				s.contentType = s.headers[ i ] || "";
			}
		}
	} );


	jQuery._evalUrl = function( url, options, doc ) {
		return jQuery.ajax( {
			url: url,

			// Make this explicit, since user can override this through ajaxSetup (trac-11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,

			// Only evaluate the response if it is successful (gh-4126)
			// dataFilter is not invoked for failure responses, so using it instead
			// of the default converter is kludgy but it works.
			converters: {
				"text script": function() {}
			},
			dataFilter: function( response ) {
				jQuery.globalEval( response, options, doc );
			}
		} );
	};


	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;

			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}

				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}

				wrap.map( function() {
					var elem = this;

					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}

					return elem;
				} ).append( this );
			}

			return this;
		},

		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}

			return this.each( function() {
				var self = jQuery( this ),
						contents = self.contents();

				if ( contents.length ) {
					contents.wrapAll( html );

				} else {
					self.append( html );
				}
			} );
		},

		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );

			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},

		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );


	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};




	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};

	var xhrSuccessStatus = {

				// File protocol always yields status code 0, assume 200
				0: 200,

				// Support: IE <=9 only
				// trac-1450: sometimes IE returns 1223 when it should be 204
				1223: 204
			},
			xhrSupported = jQuery.ajaxSettings.xhr();

	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;

	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;

		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
							xhr = options.xhr();

					xhr.open(
							options.type,
							options.url,
							options.async,
							options.username,
							options.password
					);

					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}

					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}

					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}

					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}

					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
										xhr.onerror = xhr.onabort = xhr.ontimeout =
												xhr.onreadystatechange = null;

								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {

									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(

												// File: protocol always yields status 0; see trac-8605, trac-14207
												xhr.status,
												xhr.statusText
										);
									}
								} else {
									complete(
											xhrSuccessStatus[ xhr.status ] || xhr.status,
											xhr.statusText,

											// Support: IE <=9 only
											// IE9 has no XHR2 but throws on binary (trac-11426)
											// For XHR2 non-text, let the caller handle it (gh-2498)
											( xhr.responseType || "text" ) !== "text"  ||
											typeof xhr.responseText !== "string" ?
													{ binary: xhr.response } :
													{ text: xhr.responseText },
											xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};

					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {

							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {

								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}

					// Create the abort callback
					callback = callback( "abort" );

					try {

						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {

						// trac-14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},

				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );

// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
					"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );

// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );

// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {

		// This transport only deals with cross domain or forced-by-attrs requests
		if ( s.crossDomain || s.scriptAttrs ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" )
							.attr( s.scriptAttrs || {} )
							.prop( { charset: s.scriptCharset, src: s.url } )
							.on( "load error", callback = function( evt ) {
								script.remove();
								callback = null;
								if ( evt ) {
									complete( evt.type === "error" ? 404 : 200, evt.type );
								}
							} );

					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );




	var oldCallbacks = [],
			rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );

// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

		var callbackName, overwritten, responseContainer,
				jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
								"url" :
								typeof s.data === "string" &&
								( s.contentType || "" )
										.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
								rjsonp.test( s.data ) && "data"
				);

		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
					s.jsonpCallback() :
					s.jsonpCallback;

			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}

			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};

			// Force json dataType
			s.dataTypes[ 0 ] = "json";

			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};

			// Clean-up function (fires after converters)
			jqXHR.always( function() {

				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );

					// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}

				// Save back as free
				if ( s[ callbackName ] ) {

					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;

					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}

				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}

				responseContainer = overwritten = undefined;
			} );

			// Delegate to script
			return "script";
		}
	} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}

		var base, parsed, scripts;

		if ( !context ) {

			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );

				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}

		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];

		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}

		parsed = buildFragment( [ data ], context, scripts );

		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}

		return jQuery.merge( [], parsed.childNodes );
	};


	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
				self = this,
				off = url.indexOf( " " );

		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}

		// If it's a function
		if ( isFunction( params ) ) {

			// We assume that it's the callback
			callback = params;
			params = undefined;

			// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}

		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,

				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {

				// Save response for use in complete callback
				response = arguments;

				self.html( selector ?

						// If a selector was specified, locate the right elements in a dummy div
						// Exclude scripts to avoid IE 'Permission Denied' errors
						jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

						// Otherwise use the full result
						responseText );

				// If the request succeeds, this function gets "data", "status", "jqXHR"
				// but they are ignored because response was set above.
				// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}

		return this;
	};




	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};




	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
					position = jQuery.css( elem, "position" ),
					curElem = jQuery( elem ),
					props = {};

			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}

			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
					( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;

			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}

			if ( isFunction( options ) ) {

				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}

			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}

			if ( "using" in options ) {
				options.using.call( elem, props );

			} else {
				curElem.css( props );
			}
		}
	};

	jQuery.fn.extend( {

		// offset() relates an element's border box to the document origin
		offset: function( options ) {

			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
						this :
						this.each( function( i ) {
							jQuery.offset.setOffset( this, options, i );
						} );
			}

			var rect, win,
					elem = this[ 0 ];

			if ( !elem ) {
				return;
			}

			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}

			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},

		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}

			var offsetParent, offset, doc,
					elem = this[ 0 ],
					parentOffset = { top: 0, left: 0 };

			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {

				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();

			} else {
				offset = this.offset();

				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}

			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},

		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;

				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}

				return offsetParent || documentElement;
			} );
		}
	} );

// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;

		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {

				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}

				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}

				if ( win ) {
					win.scrollTo(
							!top ? val : win.pageXOffset,
							top ? val : win.pageYOffset
					);

				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( _i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
				function( elem, computed ) {
					if ( computed ) {
						computed = curCSS( elem, prop );

						// If curCSS returns percentage, fallback to offset
						return rnumnonpx.test( computed ) ?
								jQuery( elem ).position()[ prop ] + "px" :
								computed;
					}
				}
		);
	} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( {
			padding: "inner" + name,
			content: type,
			"": "outer" + name
		}, function( defaultExtra, funcName ) {

			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
						extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

				return access( this, function( elem, type, value ) {
					var doc;

					if ( isWindow( elem ) ) {

						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
								elem[ "inner" + name ] :
								elem.document.documentElement[ "client" + name ];
					}

					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;

						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
								elem.body[ "scroll" + name ], doc[ "scroll" + name ],
								elem.body[ "offset" + name ], doc[ "offset" + name ],
								doc[ "client" + name ]
						);
					}

					return value === undefined ?

							// Get width or height on the element, requesting but not forcing parseFloat
							jQuery.css( elem, type, extra ) :

							// Set width or height on the element
							jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );


	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( _i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );




	jQuery.fn.extend( {

		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},

		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {

			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
					this.off( selector, "**" ) :
					this.off( types, selector || "**", fn );
		},

		hover: function( fnOver, fnOut ) {
			return this
					.on( "mouseenter", fnOver )
					.on( "mouseleave", fnOut || fnOver );
		}
	} );

	jQuery.each(
			( "blur focus focusin focusout resize scroll click dblclick " +
					"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
					"change select submit keydown keypress keyup contextmenu" ).split( " " ),
			function( _i, name ) {

				// Handle event binding
				jQuery.fn[ name ] = function( data, fn ) {
					return arguments.length > 0 ?
							this.on( name, null, data, fn ) :
							this.trigger( name );
				};
			}
	);




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
// Require that the "whitespace run" starts from a non-whitespace
// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
	var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	};

	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;

	jQuery.now = Date.now;

	jQuery.isNumeric = function( obj ) {

		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&

				// parseFloat NaNs numeric-cast false positives ("")
				// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
				// subtraction forces infinities to NaN
				!isNaN( obj - parseFloat( obj ) );
	};

	jQuery.trim = function( text ) {
		return text == null ?
				"" :
				( text + "" ).replace( rtrim, "$1" );
	};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

	if ( typeof define === "function" && define.amd ) {
		define( "jquery", [], function() {
			return jQuery;
		} );
	}




	var

			// Map over jQuery in case of overwrite
			_jQuery = window.jQuery,

			// Map over the $ in case of overwrite
			_$ = window.$;

	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}

		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}

		return jQuery;
	};

// Expose jQuery and $ identifiers, even in AMD
// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (trac-13566)
	if ( typeof noGlobal === "undefined" ) {
		window.jQuery = window.$ = jQuery;
	}

	return jQuery;
} );
},
'featherlight/featherlight':function(){
/**
 * Featherlight - ultra slim jQuery lightbox
 * Version 1.7.14-UMD - http://noelboss.github.io/featherlight/
 *
 * Copyright 2019, Noël Raoul Bossart (http://www.noelboss.com)
 * MIT Licensed.
**/
(function (factory) {
	if (typeof define === 'function' && define.amd) {
		// AMD. Register as an anonymous module.
		define(['jquery'], factory);
	} else if (typeof module === 'object' && module.exports) {
		// Node/CommonJS
		module.exports = function (root, jQuery) {
			if (jQuery === undefined) {
				// require('jQuery') returns a factory that requires window to
				// build a jQuery instance, we normalize how we use modules
				// that require this pattern but the window provided is a noop
				// if it's defined (how jquery works)
				if (typeof window !== 'undefined') {
					jQuery = require('jquery');
				} else {
					jQuery = require('jquery')(root);
				}
			}
			factory(jQuery);
			return jQuery;
		};
	} else {
		// Browser globals
		factory(jQuery);
	}
})(function($) {
	"use strict";

	if('undefined' === typeof $) {
		if('console' in window){ window.console.info('Too much lightness, Featherlight needs jQuery.'); }
		return;
	}
	if($.fn.jquery.match(/-ajax/)) {
		if('console' in window){ window.console.info('Featherlight needs regular jQuery, not the slim version.'); }
		return;
	}
	/* Featherlight is exported as $.featherlight.
	   It is a function used to open a featherlight lightbox.

	   [tech]
	   Featherlight uses prototype inheritance.
	   Each opened lightbox will have a corresponding object.
	   That object may have some attributes that override the
	   prototype's.
	   Extensions created with Featherlight.extend will have their
	   own prototype that inherits from Featherlight's prototype,
	   thus attributes can be overriden either at the object level,
	   or at the extension level.
	   To create callbacks that chain themselves instead of overriding,
	   use chainCallbacks.
	   For those familiar with CoffeeScript, this correspond to
	   Featherlight being a class and the Gallery being a class
	   extending Featherlight.
	   The chainCallbacks is used since we don't have access to
	   CoffeeScript's `super`.
	*/

	function Featherlight($content, config) {
		if(this instanceof Featherlight) {  /* called with new */
			this.id = Featherlight.id++;
			this.setup($content, config);
			this.chainCallbacks(Featherlight._callbackChain);
		} else {
			var fl = new Featherlight($content, config);
			fl.open();
			return fl;
		}
	}

	var opened = [],
		pruneOpened = function(remove) {
			opened = $.grep(opened, function(fl) {
				return fl !== remove && fl.$instance.closest('body').length > 0;
			} );
			return opened;
		};

	// Removes keys of `set` from `obj` and returns the removed key/values.
	function slice(obj, set) {
		var r = {};
		for (var key in obj) {
			if (key in set) {
				r[key] = obj[key];
				delete obj[key];
			}
		}
		return r;
	}

	// NOTE: List of available [iframe attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe).
	var iFrameAttributeSet = {
		allow: 1, allowfullscreen: 1, frameborder: 1, height: 1, longdesc: 1, marginheight: 1, marginwidth: 1,
		mozallowfullscreen: 1, name: 1, referrerpolicy: 1, sandbox: 1, scrolling: 1, src: 1, srcdoc: 1, style: 1,
		webkitallowfullscreen: 1, width: 1
	};

	// Converts camelCased attributes to dasherized versions for given prefix:
	//   parseAttrs({hello: 1, hellFrozeOver: 2}, 'hell') => {froze-over: 2}
	function parseAttrs(obj, prefix) {
		var attrs = {},
			regex = new RegExp('^' + prefix + '([A-Z])(.*)');
		for (var key in obj) {
			var match = key.match(regex);
			if (match) {
				var dasherized = (match[1] + match[2].replace(/([A-Z])/g, '-$1')).toLowerCase();
				attrs[dasherized] = obj[key];
			}
		}
		return attrs;
	}

	/* document wide key handler */
	var eventMap = { keyup: 'onKeyUp', resize: 'onResize' };

	var globalEventHandler = function(event) {
		$.each(Featherlight.opened().reverse(), function() {
			if (!event.isDefaultPrevented()) {
				if (false === this[eventMap[event.type]](event)) {
					event.preventDefault(); event.stopPropagation(); return false;
			  }
			}
		});
	};

	var toggleGlobalEvents = function(set) {
			if(set !== Featherlight._globalHandlerInstalled) {
				Featherlight._globalHandlerInstalled = set;
				var events = $.map(eventMap, function(_, name) { return name+'.'+Featherlight.prototype.namespace; } ).join(' ');
				$(window)[set ? 'on' : 'off'](events, globalEventHandler);
			}
		};

	Featherlight.prototype = {
		constructor: Featherlight,
		/*** defaults ***/
		/* extend featherlight with defaults and methods */
		namespace:      'featherlight',        /* Name of the events and css class prefix */
		targetAttr:     'data-featherlight',   /* Attribute of the triggered element that contains the selector to the lightbox content */
		variant:        null,                  /* Class that will be added to change look of the lightbox */
		resetCss:       false,                 /* Reset all css */
		background:     null,                  /* Custom DOM for the background, wrapper and the closebutton */
		openTrigger:    'click',               /* Event that triggers the lightbox */
		closeTrigger:   'click',               /* Event that triggers the closing of the lightbox */
		filter:         null,                  /* Selector to filter events. Think $(...).on('click', filter, eventHandler) */
		root:           'body',                /* Where to append featherlights */
		openSpeed:      250,                   /* Duration of opening animation */
		closeSpeed:     250,                   /* Duration of closing animation */
		closeOnClick:   'background',          /* Close lightbox on click ('background', 'anywhere' or false) */
		closeOnEsc:     true,                  /* Close lightbox when pressing esc */
		closeIcon:      '&#10005;',            /* Close icon */
		loading:        '',                    /* Content to show while initial content is loading */
		persist:        false,                 /* If set, the content will persist and will be shown again when opened again. 'shared' is a special value when binding multiple elements for them to share the same content */
		otherClose:     null,                  /* Selector for alternate close buttons (e.g. "a.close") */
		beforeOpen:     $.noop,                /* Called before open. can return false to prevent opening of lightbox. Gets event as parameter, this contains all data */
		beforeContent:  $.noop,                /* Called when content is loaded. Gets event as parameter, this contains all data */
		beforeClose:    $.noop,                /* Called before close. can return false to prevent closing of lightbox. Gets event as parameter, this contains all data */
		afterOpen:      $.noop,                /* Called after open. Gets event as parameter, this contains all data */
		afterContent:   $.noop,                /* Called after content is ready and has been set. Gets event as parameter, this contains all data */
		afterClose:     $.noop,                /* Called after close. Gets event as parameter, this contains all data */
		onKeyUp:        $.noop,                /* Called on key up for the frontmost featherlight */
		onResize:       $.noop,                /* Called after new content and when a window is resized */
		type:           null,                  /* Specify type of lightbox. If unset, it will check for the targetAttrs value. */
		contentFilters: ['jquery', 'image', 'html', 'ajax', 'iframe', 'text'], /* List of content filters to use to determine the content */

		/*** methods ***/
		/* setup iterates over a single instance of featherlight and prepares the background and binds the events */
		setup: function(target, config){
			/* all arguments are optional */
			if (typeof target === 'object' && target instanceof $ === false && !config) {
				config = target;
				target = undefined;
			}

			var self = $.extend(this, config, {target: target}),
				css = !self.resetCss ? self.namespace : self.namespace+'-reset', /* by adding -reset to the classname, we reset all the default css */
				$background = $(self.background || [
					'<div class="'+css+'-loading '+css+'">',
						'<div class="'+css+'-content">',
							'<button class="'+css+'-close-icon '+ self.namespace + '-close" aria-label="Close">',
								self.closeIcon,
							'</button>',
							'<div class="'+self.namespace+'-inner">' + self.loading + '</div>',
						'</div>',
					'</div>'].join('')),
				closeButtonSelector = '.'+self.namespace+'-close' + (self.otherClose ? ',' + self.otherClose : '');

			self.$instance = $background.clone().addClass(self.variant); /* clone DOM for the background, wrapper and the close button */

			/* close when click on background/anywhere/null or closebox */
			self.$instance.on(self.closeTrigger+'.'+self.namespace, function(event) {
				if(event.isDefaultPrevented()) {
					return;
				}
				var $target = $(event.target);
				if( ('background' === self.closeOnClick  && $target.is('.'+self.namespace))
					|| 'anywhere' === self.closeOnClick
					|| $target.closest(closeButtonSelector).length ){
					self.close(event);
					event.preventDefault();
				}
			});

			return this;
		},

		/* this method prepares the content and converts it into a jQuery object or a promise */
		getContent: function(){
			if(this.persist !== false && this.$content) {
				return this.$content;
			}
			var self = this,
				filters = this.constructor.contentFilters,
				readTargetAttr = function(name){ return self.$currentTarget && self.$currentTarget.attr(name); },
				targetValue = readTargetAttr(self.targetAttr),
				data = self.target || targetValue || '';

			/* Find which filter applies */
			var filter = filters[self.type]; /* check explicit type like {type: 'image'} */

			/* check explicit type like data-featherlight="image" */
			if(!filter && data in filters) {
				filter = filters[data];
				data = self.target && targetValue;
			}
			data = data || readTargetAttr('href') || '';

			/* check explicity type & content like {image: 'photo.jpg'} */
			if(!filter) {
				for(var filterName in filters) {
					if(self[filterName]) {
						filter = filters[filterName];
						data = self[filterName];
					}
				}
			}

			/* otherwise it's implicit, run checks */
			if(!filter) {
				var target = data;
				data = null;
				$.each(self.contentFilters, function() {
					filter = filters[this];
					if(filter.test)  {
						data = filter.test(target);
					}
					if(!data && filter.regex && target.match && target.match(filter.regex)) {
						data = target;
					}
					return !data;
				});
				if(!data) {
					if('console' in window){ window.console.error('Featherlight: no content filter found ' + (target ? ' for "' + target + '"' : ' (no target specified)')); }
					return false;
				}
			}
			/* Process it */
			return filter.process.call(self, data);
		},

		/* sets the content of $instance to $content */
		setContent: function($content){
      this.$instance.removeClass(this.namespace+'-loading');

      /* we need a special class for the iframe */
      this.$instance.toggleClass(this.namespace+'-iframe', $content.is('iframe'));

      /* replace content by appending to existing one before it is removed
         this insures that featherlight-inner remain at the same relative
         position to any other items added to featherlight-content */
      this.$instance.find('.'+this.namespace+'-inner')
        .not($content)                /* excluded new content, important if persisted */
        .slice(1).remove().end()      /* In the unexpected event where there are many inner elements, remove all but the first one */
        .replaceWith($.contains(this.$instance[0], $content[0]) ? '' : $content);

      this.$content = $content.addClass(this.namespace+'-inner');

      return this;
		},

		/* opens the lightbox. "this" contains $instance with the lightbox, and with the config.
			Returns a promise that is resolved after is successfully opened. */
		open: function(event){
			var self = this;
			self.$instance.hide().appendTo(self.root);
			if((!event || !event.isDefaultPrevented())
				&& self.beforeOpen(event) !== false) {

				if(event){
					event.preventDefault();
				}
				var $content = self.getContent();

				if($content) {
					opened.push(self);

					toggleGlobalEvents(true);

					self.$instance.fadeIn(self.openSpeed);
					self.beforeContent(event);

					/* Set content and show */
					return $.when($content)
						.always(function($openendContent){
							if($openendContent) {
								self.setContent($openendContent);
								self.afterContent(event);
							}
						})
						.then(self.$instance.promise())
						/* Call afterOpen after fadeIn is done */
						.done(function(){ self.afterOpen(event); });
				}
			}
			self.$instance.detach();
			return $.Deferred().reject().promise();
		},

		/* closes the lightbox. "this" contains $instance with the lightbox, and with the config
			returns a promise, resolved after the lightbox is successfully closed. */
		close: function(event){
			var self = this,
				deferred = $.Deferred();

			if(self.beforeClose(event) === false) {
				deferred.reject();
			} else {

				if (0 === pruneOpened(self).length) {
					toggleGlobalEvents(false);
				}

				self.$instance.fadeOut(self.closeSpeed,function(){
					self.$instance.detach();
					self.afterClose(event);
					deferred.resolve();
				});
			}
			return deferred.promise();
		},

		/* resizes the content so it fits in visible area and keeps the same aspect ratio.
				Does nothing if either the width or the height is not specified.
				Called automatically on window resize.
				Override if you want different behavior. */
		resize: function(w, h) {
			if (w && h) {
				/* Reset apparent image size first so container grows */
				this.$content.css('width', '').css('height', '');
				/* Calculate the worst ratio so that dimensions fit */
				 /* Note: -1 to avoid rounding errors */
				var ratio = Math.max(
					w  / (this.$content.parent().width()-1),
					h / (this.$content.parent().height()-1));
				/* Resize content */
				if (ratio > 1) {
					ratio = h / Math.floor(h / ratio); /* Round ratio down so height calc works */
					this.$content.css('width', '' + w / ratio + 'px').css('height', '' + h / ratio + 'px');
				}
			}
		},

		/* Utility function to chain callbacks
		   [Warning: guru-level]
		   Used be extensions that want to let users specify callbacks but
		   also need themselves to use the callbacks.
		   The argument 'chain' has callback names as keys and function(super, event)
		   as values. That function is meant to call `super` at some point.
		*/
		chainCallbacks: function(chain) {
			for (var name in chain) {
				this[name] = $.proxy(chain[name], this, $.proxy(this[name], this));
			}
		}
	};

	$.extend(Featherlight, {
		id: 0,                                    /* Used to id single featherlight instances */
		autoBind:       '[data-featherlight]',    /* Will automatically bind elements matching this selector. Clear or set before onReady */
		defaults:       Featherlight.prototype,   /* You can access and override all defaults using $.featherlight.defaults, which is just a synonym for $.featherlight.prototype */
		/* Contains the logic to determine content */
		contentFilters: {
			jquery: {
				regex: /^[#.]\w/,         /* Anything that starts with a class name or identifiers */
				test: function(elem)    { return elem instanceof $ && elem; },
				process: function(elem) { return this.persist !== false ? $(elem) : $(elem).clone(true); }
			},
			image: {
				regex: /\.(png|jpg|jpeg|gif|tiff?|bmp|svg|webp)(\?\S*)?$/i,
				process: function(url)  {
					var self = this,
						deferred = $.Deferred(),
						img = new Image(),
						$img = $('<img src="'+url+'" alt="" class="'+self.namespace+'-image" />');
					img.onload  = function() {
						/* Store naturalWidth & height for IE8 */
						$img.naturalWidth = img.width; $img.naturalHeight = img.height;
						deferred.resolve( $img );
					};
					img.onerror = function() { deferred.reject($img); };
					img.src = url;
					return deferred.promise();
				}
			},
			html: {
				regex: /^\s*<[\w!][^<]*>/, /* Anything that starts with some kind of valid tag */
				process: function(html) { return $(html); }
			},
			ajax: {
				regex: /./,            /* At this point, any content is assumed to be an URL */
				process: function(url)  {
					var self = this,
						deferred = $.Deferred();
					/* we are using load so one can specify a target with: url.html #targetelement */
					var $container = $('<div></div>').load(url, function(response, status){
						if ( status !== "error" ) {
							deferred.resolve($container.contents());
						}
						deferred.reject();
					});
					return deferred.promise();
				}
			},
			iframe: {
				process: function(url) {
					var deferred = new $.Deferred();
					var $content = $('<iframe/>');
					var css = parseAttrs(this, 'iframe');
					var attrs = slice(css, iFrameAttributeSet);
					$content.hide()
						.attr('src', url)
						.attr(attrs)
						.css(css)
						.on('load', function() { deferred.resolve($content.show()); })
						// We can't move an <iframe> and avoid reloading it,
						// so let's put it in place ourselves right now:
						.appendTo(this.$instance.find('.' + this.namespace + '-content'));
					return deferred.promise();
				}
			},
			text: {
				process: function(text) { return $('<div>', {text: text}); }
			}
		},

		functionAttributes: ['beforeOpen', 'afterOpen', 'beforeContent', 'afterContent', 'beforeClose', 'afterClose'],

		/*** class methods ***/
		/* read element's attributes starting with data-featherlight- */
		readElementConfig: function(element, namespace) {
			var Klass = this,
				regexp = new RegExp('^data-' + namespace + '-(.*)'),
				config = {};
			if (element && element.attributes) {
				$.each(element.attributes, function(){
					var match = this.name.match(regexp);
					if (match) {
						var val = this.value,
							name = $.camelCase(match[1]);
						if ($.inArray(name, Klass.functionAttributes) >= 0) {  /* jshint -W054 */
							val = new Function(val);                           /* jshint +W054 */
						} else {
							try { val = JSON.parse(val); }
							catch(e) {}
						}
						config[name] = val;
					}
				});
			}
			return config;
		},

		/* Used to create a Featherlight extension
		   [Warning: guru-level]
		   Creates the extension's prototype that in turn
		   inherits Featherlight's prototype.
		   Could be used to extend an extension too...
		   This is pretty high level wizardy, it comes pretty much straight
		   from CoffeeScript and won't teach you anything about Featherlight
		   as it's not really specific to this library.
		   My suggestion: move along and keep your sanity.
		*/
		extend: function(child, defaults) {
			/* Setup class hierarchy, adapted from CoffeeScript */
			var Ctor = function(){ this.constructor = child; };
			Ctor.prototype = this.prototype;
			child.prototype = new Ctor();
			child.__super__ = this.prototype;
			/* Copy class methods & attributes */
			$.extend(child, this, defaults);
			child.defaults = child.prototype;
			return child;
		},

		attach: function($source, $content, config) {
			var Klass = this;
			if (typeof $content === 'object' && $content instanceof $ === false && !config) {
				config = $content;
				$content = undefined;
			}
			/* make a copy */
			config = $.extend({}, config);

			/* Only for openTrigger, filter & namespace... */
			var namespace = config.namespace || Klass.defaults.namespace,
				tempConfig = $.extend({}, Klass.defaults, Klass.readElementConfig($source[0], namespace), config),
				sharedPersist;
			var handler = function(event) {
				var $target = $(event.currentTarget);
				/* ... since we might as well compute the config on the actual target */
				var elemConfig = $.extend(
					{$source: $source, $currentTarget: $target},
					Klass.readElementConfig($source[0], tempConfig.namespace),
					Klass.readElementConfig(event.currentTarget, tempConfig.namespace),
					config);
				var fl = sharedPersist || $target.data('featherlight-persisted') || new Klass($content, elemConfig);
				if(fl.persist === 'shared') {
					sharedPersist = fl;
				} else if(fl.persist !== false) {
					$target.data('featherlight-persisted', fl);
				}
				if (elemConfig.$currentTarget.blur) {
					elemConfig.$currentTarget.blur(); // Otherwise 'enter' key might trigger the dialog again
				}
				fl.open(event);
			};

			$source.on(tempConfig.openTrigger+'.'+tempConfig.namespace, tempConfig.filter, handler);

			return {filter: tempConfig.filter, handler: handler};
		},

		current: function() {
			var all = this.opened();
			return all[all.length - 1] || null;
		},

		opened: function() {
			var klass = this;
			pruneOpened();
			return $.grep(opened, function(fl) { return fl instanceof klass; } );
		},

		close: function(event) {
			var cur = this.current();
			if(cur) { return cur.close(event); }
		},

		/* Does the auto binding on startup.
		   Meant only to be used by Featherlight and its extensions
		*/
		_onReady: function() {
			var Klass = this;
			if(Klass.autoBind){
				var $autobound = $(Klass.autoBind);
				/* Bind existing elements */
				$autobound.each(function(){
					Klass.attach($(this));
				});
				/* If a click propagates to the document level, then we have an item that was added later on */
				$(document).on('click', Klass.autoBind, function(evt) {
					if (evt.isDefaultPrevented()) {
						return;
					}
					var $cur = $(evt.currentTarget);
					var len = $autobound.length;
					$autobound = $autobound.add($cur);
					if(len === $autobound.length) {
						return; /* already bound */
					}
					/* Bind featherlight */
					var data = Klass.attach($cur);
					/* Dispatch event directly */
					if (!data.filter || $(evt.target).parentsUntil($cur, data.filter).length > 0) {
						data.handler(evt);
					}
				});
			}
		},

		/* Featherlight uses the onKeyUp callback to intercept the escape key.
		   Private to Featherlight.
		*/
		_callbackChain: {
			onKeyUp: function(_super, event){
				if(27 === event.keyCode) {
					if (this.closeOnEsc) {
						$.featherlight.close(event);
					}
					return false;
				} else {
					return _super(event);
				}
			},

			beforeOpen: function(_super, event) {
				// Used to disable scrolling
				$(document.documentElement).addClass('with-featherlight');

				// Remember focus:
				this._previouslyActive = document.activeElement;

				// Disable tabbing:
				// See http://stackoverflow.com/questions/1599660/which-html-elements-can-receive-focus
				this._$previouslyTabbable = $("a, input, select, textarea, iframe, button, iframe, [contentEditable=true]")
					.not('[tabindex]')
					.not(this.$instance.find('button'));

				this._$previouslyWithTabIndex = $('[tabindex]').not('[tabindex="-1"]');
				this._previousWithTabIndices = this._$previouslyWithTabIndex.map(function(_i, elem) {
					return $(elem).attr('tabindex');
				});

				this._$previouslyWithTabIndex.add(this._$previouslyTabbable).attr('tabindex', -1);

				if (document.activeElement.blur) {
					document.activeElement.blur();
				}
				return _super(event);
			},

			afterClose: function(_super, event) {
				var r = _super(event);
				// Restore focus
				var self = this;
				this._$previouslyTabbable.removeAttr('tabindex');
				this._$previouslyWithTabIndex.each(function(i, elem) {
					$(elem).attr('tabindex', self._previousWithTabIndices[i]);
				});
				this._previouslyActive.focus();
				// Restore scroll
				if(Featherlight.opened().length === 0) {
					$(document.documentElement).removeClass('with-featherlight');
				}
				return r;
			},

			onResize: function(_super, event){
				this.resize(this.$content.naturalWidth, this.$content.naturalHeight);
				return _super(event);
			},

			afterContent: function(_super, event){
				var r = _super(event);
				this.$instance.find('[autofocus]:not([disabled])').focus();
				this.onResize(event);
				return r;
			}
		}
	});

	$.featherlight = Featherlight;

	/* bind jQuery elements to trigger featherlight */
	$.fn.featherlight = function($content, config) {
		Featherlight.attach(this, $content, config);
		return this;
	};

	/* bind featherlight on ready if config autoBind is set */
	$(document).ready(function(){ Featherlight._onReady(); });
});

},
'vue/vue':function(){
/*!
 * Vue.js v1.0.28
 * (c) 2016 Evan You
 * Released under the MIT License.
 */
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.Vue = factory());
}(this, (function () { 'use strict';

function set(obj, key, val) {
  if (hasOwn(obj, key)) {
    obj[key] = val;
    return;
  }
  if (obj._isVue) {
    set(obj._data, key, val);
    return;
  }
  var ob = obj.__ob__;
  if (!ob) {
    obj[key] = val;
    return;
  }
  ob.convert(key, val);
  ob.dep.notify();
  if (ob.vms) {
    var i = ob.vms.length;
    while (i--) {
      var vm = ob.vms[i];
      vm._proxy(key);
      vm._digest();
    }
  }
  return val;
}

/**
 * Delete a property and trigger change if necessary.
 *
 * @param {Object} obj
 * @param {String} key
 */

function del(obj, key) {
  if (!hasOwn(obj, key)) {
    return;
  }
  delete obj[key];
  var ob = obj.__ob__;
  if (!ob) {
    if (obj._isVue) {
      delete obj._data[key];
      obj._digest();
    }
    return;
  }
  ob.dep.notify();
  if (ob.vms) {
    var i = ob.vms.length;
    while (i--) {
      var vm = ob.vms[i];
      vm._unproxy(key);
      vm._digest();
    }
  }
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
/**
 * Check whether the object has the property.
 *
 * @param {Object} obj
 * @param {String} key
 * @return {Boolean}
 */

function hasOwn(obj, key) {
  return hasOwnProperty.call(obj, key);
}

/**
 * Check if an expression is a literal value.
 *
 * @param {String} exp
 * @return {Boolean}
 */

var literalValueRE = /^\s?(true|false|-?[\d\.]+|'[^']*'|"[^"]*")\s?$/;

function isLiteral(exp) {
  return literalValueRE.test(exp);
}

/**
 * Check if a string starts with $ or _
 *
 * @param {String} str
 * @return {Boolean}
 */

function isReserved(str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F;
}

/**
 * Guard text output, make sure undefined outputs
 * empty string
 *
 * @param {*} value
 * @return {String}
 */

function _toString(value) {
  return value == null ? '' : value.toString();
}

/**
 * Check and convert possible numeric strings to numbers
 * before setting back to data
 *
 * @param {*} value
 * @return {*|Number}
 */

function toNumber(value) {
  if (typeof value !== 'string') {
    return value;
  } else {
    var parsed = Number(value);
    return isNaN(parsed) ? value : parsed;
  }
}

/**
 * Convert string boolean literals into real booleans.
 *
 * @param {*} value
 * @return {*|Boolean}
 */

function toBoolean(value) {
  return value === 'true' ? true : value === 'false' ? false : value;
}

/**
 * Strip quotes from a string
 *
 * @param {String} str
 * @return {String | false}
 */

function stripQuotes(str) {
  var a = str.charCodeAt(0);
  var b = str.charCodeAt(str.length - 1);
  return a === b && (a === 0x22 || a === 0x27) ? str.slice(1, -1) : str;
}

/**
 * Camelize a hyphen-delimited string.
 *
 * @param {String} str
 * @return {String}
 */

var camelizeRE = /-(\w)/g;

function camelize(str) {
  return str.replace(camelizeRE, toUpper);
}

function toUpper(_, c) {
  return c ? c.toUpperCase() : '';
}

/**
 * Hyphenate a camelCase string.
 *
 * @param {String} str
 * @return {String}
 */

var hyphenateRE = /([^-])([A-Z])/g;

function hyphenate(str) {
  return str.replace(hyphenateRE, '$1-$2').replace(hyphenateRE, '$1-$2').toLowerCase();
}

/**
 * Converts hyphen/underscore/slash delimitered names into
 * camelized classNames.
 *
 * e.g. my-component => MyComponent
 *      some_else    => SomeElse
 *      some/comp    => SomeComp
 *
 * @param {String} str
 * @return {String}
 */

var classifyRE = /(?:^|[-_\/])(\w)/g;

function classify(str) {
  return str.replace(classifyRE, toUpper);
}

/**
 * Simple bind, faster than native
 *
 * @param {Function} fn
 * @param {Object} ctx
 * @return {Function}
 */

function bind(fn, ctx) {
  return function (a) {
    var l = arguments.length;
    return l ? l > 1 ? fn.apply(ctx, arguments) : fn.call(ctx, a) : fn.call(ctx);
  };
}

/**
 * Convert an Array-like object to a real Array.
 *
 * @param {Array-like} list
 * @param {Number} [start] - start index
 * @return {Array}
 */

function toArray(list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret;
}

/**
 * Mix properties into target object.
 *
 * @param {Object} to
 * @param {Object} from
 */

function extend(to, from) {
  var keys = Object.keys(from);
  var i = keys.length;
  while (i--) {
    to[keys[i]] = from[keys[i]];
  }
  return to;
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 *
 * @param {*} obj
 * @return {Boolean}
 */

function isObject(obj) {
  return obj !== null && typeof obj === 'object';
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 *
 * @param {*} obj
 * @return {Boolean}
 */

var toString = Object.prototype.toString;
var OBJECT_STRING = '[object Object]';

function isPlainObject(obj) {
  return toString.call(obj) === OBJECT_STRING;
}

/**
 * Array type check.
 *
 * @param {*} obj
 * @return {Boolean}
 */

var isArray = Array.isArray;

/**
 * Define a property.
 *
 * @param {Object} obj
 * @param {String} key
 * @param {*} val
 * @param {Boolean} [enumerable]
 */

function def(obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Debounce a function so it only gets called after the
 * input stops arriving after the given wait period.
 *
 * @param {Function} func
 * @param {Number} wait
 * @return {Function} - the debounced function
 */

function _debounce(func, wait) {
  var timeout, args, context, timestamp, result;
  var later = function later() {
    var last = Date.now() - timestamp;
    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    }
  };
  return function () {
    context = this;
    args = arguments;
    timestamp = Date.now();
    if (!timeout) {
      timeout = setTimeout(later, wait);
    }
    return result;
  };
}

/**
 * Manual indexOf because it's slightly faster than
 * native.
 *
 * @param {Array} arr
 * @param {*} obj
 */

function indexOf(arr, obj) {
  var i = arr.length;
  while (i--) {
    if (arr[i] === obj) return i;
  }
  return -1;
}

/**
 * Make a cancellable version of an async callback.
 *
 * @param {Function} fn
 * @return {Function}
 */

function cancellable(fn) {
  var cb = function cb() {
    if (!cb.cancelled) {
      return fn.apply(this, arguments);
    }
  };
  cb.cancel = function () {
    cb.cancelled = true;
  };
  return cb;
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 *
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 */

function looseEqual(a, b) {
  /* eslint-disable eqeqeq */
  return a == b || (isObject(a) && isObject(b) ? JSON.stringify(a) === JSON.stringify(b) : false);
  /* eslint-enable eqeqeq */
}

var hasProto = ('__proto__' in {});

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined' && Object.prototype.toString.call(window) !== '[object Object]';

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

// UA sniffing for working around browser-specific quirks
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && UA.indexOf('trident') > 0;
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isAndroid = UA && UA.indexOf('android') > 0;
var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA);

var transitionProp = undefined;
var transitionEndEvent = undefined;
var animationProp = undefined;
var animationEndEvent = undefined;

// Transition property/event sniffing
if (inBrowser && !isIE9) {
  var isWebkitTrans = window.ontransitionend === undefined && window.onwebkittransitionend !== undefined;
  var isWebkitAnim = window.onanimationend === undefined && window.onwebkitanimationend !== undefined;
  transitionProp = isWebkitTrans ? 'WebkitTransition' : 'transition';
  transitionEndEvent = isWebkitTrans ? 'webkitTransitionEnd' : 'transitionend';
  animationProp = isWebkitAnim ? 'WebkitAnimation' : 'animation';
  animationEndEvent = isWebkitAnim ? 'webkitAnimationEnd' : 'animationend';
}

/* istanbul ignore next */
function isNative(Ctor) {
  return (/native code/.test(Ctor.toString())
  );
}

/**
 * Defer a task to execute it asynchronously. Ideally this
 * should be executed as a microtask, so we leverage
 * MutationObserver if it's available, and fallback to
 * setTimeout(0).
 *
 * @param {Function} cb
 * @param {Object} ctx
 */

var nextTick = (function () {
  var callbacks = [];
  var pending = false;
  var timerFunc = undefined;

  function nextTickHandler() {
    pending = false;
    var copies = callbacks.slice(0);
    callbacks.length = 0;
    for (var i = 0; i < copies.length; i++) {
      copies[i]();
    }
  }

  // the nextTick behavior leverages the microtask queue, which can be accessed
  // via either native Promise.then or MutationObserver.
  // MutationObserver has wider support, however it is seriously bugged in
  // UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
  // completely stops working after triggering a few times... so, if native
  // Promise is available, we will use it:
  /* istanbul ignore if */
  if (typeof Promise !== 'undefined' && isNative(Promise)) {
    var p = Promise.resolve();
    var noop = function noop() {};
    timerFunc = function () {
      p.then(nextTickHandler);
      // in problematic UIWebViews, Promise.then doesn't completely break, but
      // it can get stuck in a weird state where callbacks are pushed into the
      // microtask queue but the queue isn't being flushed, until the browser
      // needs to do some other work, e.g. handle a timer. Therefore we can
      // "force" the microtask queue to be flushed by adding an empty timer.
      if (isIOS) setTimeout(noop);
    };
  } else if (typeof MutationObserver !== 'undefined') {
    // use MutationObserver where native Promise is not available,
    // e.g. IE11, iOS7, Android 4.4
    var counter = 1;
    var observer = new MutationObserver(nextTickHandler);
    var textNode = document.createTextNode(String(counter));
    observer.observe(textNode, {
      characterData: true
    });
    timerFunc = function () {
      counter = (counter + 1) % 2;
      textNode.data = String(counter);
    };
  } else {
    // fallback to setTimeout
    /* istanbul ignore next */
    timerFunc = setTimeout;
  }

  return function (cb, ctx) {
    var func = ctx ? function () {
      cb.call(ctx);
    } : cb;
    callbacks.push(func);
    if (pending) return;
    pending = true;
    timerFunc(nextTickHandler, 0);
  };
})();

var _Set = undefined;
/* istanbul ignore if */
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = function () {
    this.set = Object.create(null);
  };
  _Set.prototype.has = function (key) {
    return this.set[key] !== undefined;
  };
  _Set.prototype.add = function (key) {
    this.set[key] = 1;
  };
  _Set.prototype.clear = function () {
    this.set = Object.create(null);
  };
}

function Cache(limit) {
  this.size = 0;
  this.limit = limit;
  this.head = this.tail = undefined;
  this._keymap = Object.create(null);
}

var p = Cache.prototype;

/**
 * Put <value> into the cache associated with <key>.
 * Returns the entry which was removed to make room for
 * the new entry. Otherwise undefined is returned.
 * (i.e. if there was enough room already).
 *
 * @param {String} key
 * @param {*} value
 * @return {Entry|undefined}
 */

p.put = function (key, value) {
  var removed;

  var entry = this.get(key, true);
  if (!entry) {
    if (this.size === this.limit) {
      removed = this.shift();
    }
    entry = {
      key: key
    };
    this._keymap[key] = entry;
    if (this.tail) {
      this.tail.newer = entry;
      entry.older = this.tail;
    } else {
      this.head = entry;
    }
    this.tail = entry;
    this.size++;
  }
  entry.value = value;

  return removed;
};

/**
 * Purge the least recently used (oldest) entry from the
 * cache. Returns the removed entry or undefined if the
 * cache was empty.
 */

p.shift = function () {
  var entry = this.head;
  if (entry) {
    this.head = this.head.newer;
    this.head.older = undefined;
    entry.newer = entry.older = undefined;
    this._keymap[entry.key] = undefined;
    this.size--;
  }
  return entry;
};

/**
 * Get and register recent use of <key>. Returns the value
 * associated with <key> or undefined if not in cache.
 *
 * @param {String} key
 * @param {Boolean} returnEntry
 * @return {Entry|*}
 */

p.get = function (key, returnEntry) {
  var entry = this._keymap[key];
  if (entry === undefined) return;
  if (entry === this.tail) {
    return returnEntry ? entry : entry.value;
  }
  // HEAD--------------TAIL
  //   <.older   .newer>
  //  <--- add direction --
  //   A  B  C  <D>  E
  if (entry.newer) {
    if (entry === this.head) {
      this.head = entry.newer;
    }
    entry.newer.older = entry.older; // C <-- E.
  }
  if (entry.older) {
    entry.older.newer = entry.newer; // C. --> E
  }
  entry.newer = undefined; // D --x
  entry.older = this.tail; // D. --> E
  if (this.tail) {
    this.tail.newer = entry; // E. <-- D
  }
  this.tail = entry;
  return returnEntry ? entry : entry.value;
};

var cache$1 = new Cache(1000);
var reservedArgRE = /^in$|^-?\d+/;

/**
 * Parser state
 */

var str;
var dir;
var len;
var index;
var chr;
var state;
var startState = 0;
var filterState = 1;
var filterNameState = 2;
var filterArgState = 3;

var doubleChr = 0x22;
var singleChr = 0x27;
var pipeChr = 0x7C;
var escapeChr = 0x5C;
var spaceChr = 0x20;

var expStartChr = { 0x5B: 1, 0x7B: 1, 0x28: 1 };
var expChrPair = { 0x5B: 0x5D, 0x7B: 0x7D, 0x28: 0x29 };

function peek() {
  return str.charCodeAt(index + 1);
}

function next() {
  return str.charCodeAt(++index);
}

function eof() {
  return index >= len;
}

function eatSpace() {
  while (peek() === spaceChr) {
    next();
  }
}

function isStringStart(chr) {
  return chr === doubleChr || chr === singleChr;
}

function isExpStart(chr) {
  return expStartChr[chr];
}

function isExpEnd(start, chr) {
  return expChrPair[start] === chr;
}

function parseString() {
  var stringQuote = next();
  var chr;
  while (!eof()) {
    chr = next();
    // escape char
    if (chr === escapeChr) {
      next();
    } else if (chr === stringQuote) {
      break;
    }
  }
}

function parseSpecialExp(chr) {
  var inExp = 0;
  var startChr = chr;

  while (!eof()) {
    chr = peek();
    if (isStringStart(chr)) {
      parseString();
      continue;
    }

    if (startChr === chr) {
      inExp++;
    }
    if (isExpEnd(startChr, chr)) {
      inExp--;
    }

    next();

    if (inExp === 0) {
      break;
    }
  }
}

/**
 * syntax:
 * expression | filterName  [arg  arg [| filterName arg arg]]
 */

function parseExpression() {
  var start = index;
  while (!eof()) {
    chr = peek();
    if (isStringStart(chr)) {
      parseString();
    } else if (isExpStart(chr)) {
      parseSpecialExp(chr);
    } else if (chr === pipeChr) {
      next();
      chr = peek();
      if (chr === pipeChr) {
        next();
      } else {
        if (state === startState || state === filterArgState) {
          state = filterState;
        }
        break;
      }
    } else if (chr === spaceChr && (state === filterNameState || state === filterArgState)) {
      eatSpace();
      break;
    } else {
      if (state === filterState) {
        state = filterNameState;
      }
      next();
    }
  }

  return str.slice(start + 1, index) || null;
}

function parseFilterList() {
  var filters = [];
  while (!eof()) {
    filters.push(parseFilter());
  }
  return filters;
}

function parseFilter() {
  var filter = {};
  var args;

  state = filterState;
  filter.name = parseExpression().trim();

  state = filterArgState;
  args = parseFilterArguments();

  if (args.length) {
    filter.args = args;
  }
  return filter;
}

function parseFilterArguments() {
  var args = [];
  while (!eof() && state !== filterState) {
    var arg = parseExpression();
    if (!arg) {
      break;
    }
    args.push(processFilterArg(arg));
  }

  return args;
}

/**
 * Check if an argument is dynamic and strip quotes.
 *
 * @param {String} arg
 * @return {Object}
 */

function processFilterArg(arg) {
  if (reservedArgRE.test(arg)) {
    return {
      value: toNumber(arg),
      dynamic: false
    };
  } else {
    var stripped = stripQuotes(arg);
    var dynamic = stripped === arg;
    return {
      value: dynamic ? arg : stripped,
      dynamic: dynamic
    };
  }
}

/**
 * Parse a directive value and extract the expression
 * and its filters into a descriptor.
 *
 * Example:
 *
 * "a + 1 | uppercase" will yield:
 * {
 *   expression: 'a + 1',
 *   filters: [
 *     { name: 'uppercase', args: null }
 *   ]
 * }
 *
 * @param {String} s
 * @return {Object}
 */

function parseDirective(s) {
  var hit = cache$1.get(s);
  if (hit) {
    return hit;
  }

  // reset parser state
  str = s;
  dir = {};
  len = str.length;
  index = -1;
  chr = '';
  state = startState;

  var filters;

  if (str.indexOf('|') < 0) {
    dir.expression = str.trim();
  } else {
    dir.expression = parseExpression().trim();
    filters = parseFilterList();
    if (filters.length) {
      dir.filters = filters;
    }
  }

  cache$1.put(s, dir);
  return dir;
}

var directive = Object.freeze({
  parseDirective: parseDirective
});

var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;
var cache = undefined;
var tagRE = undefined;
var htmlRE = undefined;
/**
 * Escape a string so it can be used in a RegExp
 * constructor.
 *
 * @param {String} str
 */

function escapeRegex(str) {
  return str.replace(regexEscapeRE, '\\$&');
}

function compileRegex() {
  var open = escapeRegex(config.delimiters[0]);
  var close = escapeRegex(config.delimiters[1]);
  var unsafeOpen = escapeRegex(config.unsafeDelimiters[0]);
  var unsafeClose = escapeRegex(config.unsafeDelimiters[1]);
  tagRE = new RegExp(unsafeOpen + '((?:.|\\n)+?)' + unsafeClose + '|' + open + '((?:.|\\n)+?)' + close, 'g');
  htmlRE = new RegExp('^' + unsafeOpen + '((?:.|\\n)+?)' + unsafeClose + '$');
  // reset cache
  cache = new Cache(1000);
}

/**
 * Parse a template text string into an array of tokens.
 *
 * @param {String} text
 * @return {Array<Object> | null}
 *               - {String} type
 *               - {String} value
 *               - {Boolean} [html]
 *               - {Boolean} [oneTime]
 */

function parseText(text) {
  if (!cache) {
    compileRegex();
  }
  var hit = cache.get(text);
  if (hit) {
    return hit;
  }
  if (!tagRE.test(text)) {
    return null;
  }
  var tokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, html, value, first, oneTime;
  /* eslint-disable no-cond-assign */
  while (match = tagRE.exec(text)) {
    /* eslint-enable no-cond-assign */
    index = match.index;
    // push text token
    if (index > lastIndex) {
      tokens.push({
        value: text.slice(lastIndex, index)
      });
    }
    // tag token
    html = htmlRE.test(match[0]);
    value = html ? match[1] : match[2];
    first = value.charCodeAt(0);
    oneTime = first === 42; // *
    value = oneTime ? value.slice(1) : value;
    tokens.push({
      tag: true,
      value: value.trim(),
      html: html,
      oneTime: oneTime
    });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    tokens.push({
      value: text.slice(lastIndex)
    });
  }
  cache.put(text, tokens);
  return tokens;
}

/**
 * Format a list of tokens into an expression.
 * e.g. tokens parsed from 'a {{b}} c' can be serialized
 * into one single expression as '"a " + b + " c"'.
 *
 * @param {Array} tokens
 * @param {Vue} [vm]
 * @return {String}
 */

function tokensToExp(tokens, vm) {
  if (tokens.length > 1) {
    return tokens.map(function (token) {
      return formatToken(token, vm);
    }).join('+');
  } else {
    return formatToken(tokens[0], vm, true);
  }
}

/**
 * Format a single token.
 *
 * @param {Object} token
 * @param {Vue} [vm]
 * @param {Boolean} [single]
 * @return {String}
 */

function formatToken(token, vm, single) {
  return token.tag ? token.oneTime && vm ? '"' + vm.$eval(token.value) + '"' : inlineFilters(token.value, single) : '"' + token.value + '"';
}

/**
 * For an attribute with multiple interpolation tags,
 * e.g. attr="some-{{thing | filter}}", in order to combine
 * the whole thing into a single watchable expression, we
 * have to inline those filters. This function does exactly
 * that. This is a bit hacky but it avoids heavy changes
 * to directive parser and watcher mechanism.
 *
 * @param {String} exp
 * @param {Boolean} single
 * @return {String}
 */

var filterRE = /[^|]\|[^|]/;
function inlineFilters(exp, single) {
  if (!filterRE.test(exp)) {
    return single ? exp : '(' + exp + ')';
  } else {
    var dir = parseDirective(exp);
    if (!dir.filters) {
      return '(' + exp + ')';
    } else {
      return 'this._applyFilters(' + dir.expression + // value
      ',null,' + // oldValue (null for read)
      JSON.stringify(dir.filters) + // filter descriptors
      ',false)'; // write?
    }
  }
}

var text = Object.freeze({
  compileRegex: compileRegex,
  parseText: parseText,
  tokensToExp: tokensToExp
});

var delimiters = ['{{', '}}'];
var unsafeDelimiters = ['{{{', '}}}'];

var config = Object.defineProperties({

  /**
   * Whether to print debug messages.
   * Also enables stack trace for warnings.
   *
   * @type {Boolean}
   */

  debug: false,

  /**
   * Whether to suppress warnings.
   *
   * @type {Boolean}
   */

  silent: false,

  /**
   * Whether to use async rendering.
   */

  async: true,

  /**
   * Whether to warn against errors caught when evaluating
   * expressions.
   */

  warnExpressionErrors: true,

  /**
   * Whether to allow devtools inspection.
   * Disabled by default in production builds.
   */

  devtools: 'development' !== 'production',

  /**
   * Internal flag to indicate the delimiters have been
   * changed.
   *
   * @type {Boolean}
   */

  _delimitersChanged: true,

  /**
   * List of asset types that a component can own.
   *
   * @type {Array}
   */

  _assetTypes: ['component', 'directive', 'elementDirective', 'filter', 'transition', 'partial'],

  /**
   * prop binding modes
   */

  _propBindingModes: {
    ONE_WAY: 0,
    TWO_WAY: 1,
    ONE_TIME: 2
  },

  /**
   * Max circular updates allowed in a batcher flush cycle.
   */

  _maxUpdateCount: 100

}, {
  delimiters: { /**
                 * Interpolation delimiters. Changing these would trigger
                 * the text parser to re-compile the regular expressions.
                 *
                 * @type {Array<String>}
                 */

    get: function get() {
      return delimiters;
    },
    set: function set(val) {
      delimiters = val;
      compileRegex();
    },
    configurable: true,
    enumerable: true
  },
  unsafeDelimiters: {
    get: function get() {
      return unsafeDelimiters;
    },
    set: function set(val) {
      unsafeDelimiters = val;
      compileRegex();
    },
    configurable: true,
    enumerable: true
  }
});

var warn = undefined;
var formatComponentName = undefined;

if ('development' !== 'production') {
  (function () {
    var hasConsole = typeof console !== 'undefined';

    warn = function (msg, vm) {
      if (hasConsole && !config.silent) {
        console.error('[Vue warn]: ' + msg + (vm ? formatComponentName(vm) : ''));
      }
    };

    formatComponentName = function (vm) {
      var name = vm._isVue ? vm.$options.name : vm.name;
      return name ? ' (found in component: <' + hyphenate(name) + '>)' : '';
    };
  })();
}

/**
 * Append with transition.
 *
 * @param {Element} el
 * @param {Element} target
 * @param {Vue} vm
 * @param {Function} [cb]
 */

function appendWithTransition(el, target, vm, cb) {
  applyTransition(el, 1, function () {
    target.appendChild(el);
  }, vm, cb);
}

/**
 * InsertBefore with transition.
 *
 * @param {Element} el
 * @param {Element} target
 * @param {Vue} vm
 * @param {Function} [cb]
 */

function beforeWithTransition(el, target, vm, cb) {
  applyTransition(el, 1, function () {
    before(el, target);
  }, vm, cb);
}

/**
 * Remove with transition.
 *
 * @param {Element} el
 * @param {Vue} vm
 * @param {Function} [cb]
 */

function removeWithTransition(el, vm, cb) {
  applyTransition(el, -1, function () {
    remove(el);
  }, vm, cb);
}

/**
 * Apply transitions with an operation callback.
 *
 * @param {Element} el
 * @param {Number} direction
 *                  1: enter
 *                 -1: leave
 * @param {Function} op - the actual DOM operation
 * @param {Vue} vm
 * @param {Function} [cb]
 */

function applyTransition(el, direction, op, vm, cb) {
  var transition = el.__v_trans;
  if (!transition ||
  // skip if there are no js hooks and CSS transition is
  // not supported
  !transition.hooks && !transitionEndEvent ||
  // skip transitions for initial compile
  !vm._isCompiled ||
  // if the vm is being manipulated by a parent directive
  // during the parent's compilation phase, skip the
  // animation.
  vm.$parent && !vm.$parent._isCompiled) {
    op();
    if (cb) cb();
    return;
  }
  var action = direction > 0 ? 'enter' : 'leave';
  transition[action](op, cb);
}

var transition = Object.freeze({
  appendWithTransition: appendWithTransition,
  beforeWithTransition: beforeWithTransition,
  removeWithTransition: removeWithTransition,
  applyTransition: applyTransition
});

/**
 * Query an element selector if it's not an element already.
 *
 * @param {String|Element} el
 * @return {Element}
 */

function query(el) {
  if (typeof el === 'string') {
    var selector = el;
    el = document.querySelector(el);
    if (!el) {
      'development' !== 'production' && warn('Cannot find element: ' + selector);
    }
  }
  return el;
}

/**
 * Check if a node is in the document.
 * Note: document.documentElement.contains should work here
 * but always returns false for comment nodes in phantomjs,
 * making unit tests difficult. This is fixed by doing the
 * contains() check on the node's parentNode instead of
 * the node itself.
 *
 * @param {Node} node
 * @return {Boolean}
 */

function inDoc(node) {
  if (!node) return false;
  var doc = node.ownerDocument.documentElement;
  var parent = node.parentNode;
  return doc === node || doc === parent || !!(parent && parent.nodeType === 1 && doc.contains(parent));
}

/**
 * Get and remove an attribute from a node.
 *
 * @param {Node} node
 * @param {String} _attr
 */

function getAttr(node, _attr) {
  var val = node.getAttribute(_attr);
  if (val !== null) {
    node.removeAttribute(_attr);
  }
  return val;
}

/**
 * Get an attribute with colon or v-bind: prefix.
 *
 * @param {Node} node
 * @param {String} name
 * @return {String|null}
 */

function getBindAttr(node, name) {
  var val = getAttr(node, ':' + name);
  if (val === null) {
    val = getAttr(node, 'v-bind:' + name);
  }
  return val;
}

/**
 * Check the presence of a bind attribute.
 *
 * @param {Node} node
 * @param {String} name
 * @return {Boolean}
 */

function hasBindAttr(node, name) {
  return node.hasAttribute(name) || node.hasAttribute(':' + name) || node.hasAttribute('v-bind:' + name);
}

/**
 * Insert el before target
 *
 * @param {Element} el
 * @param {Element} target
 */

function before(el, target) {
  target.parentNode.insertBefore(el, target);
}

/**
 * Insert el after target
 *
 * @param {Element} el
 * @param {Element} target
 */

function after(el, target) {
  if (target.nextSibling) {
    before(el, target.nextSibling);
  } else {
    target.parentNode.appendChild(el);
  }
}

/**
 * Remove el from DOM
 *
 * @param {Element} el
 */

function remove(el) {
  el.parentNode.removeChild(el);
}

/**
 * Prepend el to target
 *
 * @param {Element} el
 * @param {Element} target
 */

function prepend(el, target) {
  if (target.firstChild) {
    before(el, target.firstChild);
  } else {
    target.appendChild(el);
  }
}

/**
 * Replace target with el
 *
 * @param {Element} target
 * @param {Element} el
 */

function replace(target, el) {
  var parent = target.parentNode;
  if (parent) {
    parent.replaceChild(el, target);
  }
}

/**
 * Add event listener shorthand.
 *
 * @param {Element} el
 * @param {String} event
 * @param {Function} cb
 * @param {Boolean} [useCapture]
 */

function on(el, event, cb, useCapture) {
  el.addEventListener(event, cb, useCapture);
}

/**
 * Remove event listener shorthand.
 *
 * @param {Element} el
 * @param {String} event
 * @param {Function} cb
 */

function off(el, event, cb) {
  el.removeEventListener(event, cb);
}

/**
 * For IE9 compat: when both class and :class are present
 * getAttribute('class') returns wrong value...
 *
 * @param {Element} el
 * @return {String}
 */

function getClass(el) {
  var classname = el.className;
  if (typeof classname === 'object') {
    classname = classname.baseVal || '';
  }
  return classname;
}

/**
 * In IE9, setAttribute('class') will result in empty class
 * if the element also has the :class attribute; However in
 * PhantomJS, setting `className` does not work on SVG elements...
 * So we have to do a conditional check here.
 *
 * @param {Element} el
 * @param {String} cls
 */

function setClass(el, cls) {
  /* istanbul ignore if */
  if (isIE9 && !/svg$/.test(el.namespaceURI)) {
    el.className = cls;
  } else {
    el.setAttribute('class', cls);
  }
}

/**
 * Add class with compatibility for IE & SVG
 *
 * @param {Element} el
 * @param {String} cls
 */

function addClass(el, cls) {
  if (el.classList) {
    el.classList.add(cls);
  } else {
    var cur = ' ' + getClass(el) + ' ';
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      setClass(el, (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for IE & SVG
 *
 * @param {Element} el
 * @param {String} cls
 */

function removeClass(el, cls) {
  if (el.classList) {
    el.classList.remove(cls);
  } else {
    var cur = ' ' + getClass(el) + ' ';
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    setClass(el, cur.trim());
  }
  if (!el.className) {
    el.removeAttribute('class');
  }
}

/**
 * Extract raw content inside an element into a temporary
 * container div
 *
 * @param {Element} el
 * @param {Boolean} asFragment
 * @return {Element|DocumentFragment}
 */

function extractContent(el, asFragment) {
  var child;
  var rawContent;
  /* istanbul ignore if */
  if (isTemplate(el) && isFragment(el.content)) {
    el = el.content;
  }
  if (el.hasChildNodes()) {
    trimNode(el);
    rawContent = asFragment ? document.createDocumentFragment() : document.createElement('div');
    /* eslint-disable no-cond-assign */
    while (child = el.firstChild) {
      /* eslint-enable no-cond-assign */
      rawContent.appendChild(child);
    }
  }
  return rawContent;
}

/**
 * Trim possible empty head/tail text and comment
 * nodes inside a parent.
 *
 * @param {Node} node
 */

function trimNode(node) {
  var child;
  /* eslint-disable no-sequences */
  while ((child = node.firstChild, isTrimmable(child))) {
    node.removeChild(child);
  }
  while ((child = node.lastChild, isTrimmable(child))) {
    node.removeChild(child);
  }
  /* eslint-enable no-sequences */
}

function isTrimmable(node) {
  return node && (node.nodeType === 3 && !node.data.trim() || node.nodeType === 8);
}

/**
 * Check if an element is a template tag.
 * Note if the template appears inside an SVG its tagName
 * will be in lowercase.
 *
 * @param {Element} el
 */

function isTemplate(el) {
  return el.tagName && el.tagName.toLowerCase() === 'template';
}

/**
 * Create an "anchor" for performing dom insertion/removals.
 * This is used in a number of scenarios:
 * - fragment instance
 * - v-html
 * - v-if
 * - v-for
 * - component
 *
 * @param {String} content
 * @param {Boolean} persist - IE trashes empty textNodes on
 *                            cloneNode(true), so in certain
 *                            cases the anchor needs to be
 *                            non-empty to be persisted in
 *                            templates.
 * @return {Comment|Text}
 */

function createAnchor(content, persist) {
  var anchor = config.debug ? document.createComment(content) : document.createTextNode(persist ? ' ' : '');
  anchor.__v_anchor = true;
  return anchor;
}

/**
 * Find a component ref attribute that starts with $.
 *
 * @param {Element} node
 * @return {String|undefined}
 */

var refRE = /^v-ref:/;

function findRef(node) {
  if (node.hasAttributes()) {
    var attrs = node.attributes;
    for (var i = 0, l = attrs.length; i < l; i++) {
      var name = attrs[i].name;
      if (refRE.test(name)) {
        return camelize(name.replace(refRE, ''));
      }
    }
  }
}

/**
 * Map a function to a range of nodes .
 *
 * @param {Node} node
 * @param {Node} end
 * @param {Function} op
 */

function mapNodeRange(node, end, op) {
  var next;
  while (node !== end) {
    next = node.nextSibling;
    op(node);
    node = next;
  }
  op(end);
}

/**
 * Remove a range of nodes with transition, store
 * the nodes in a fragment with correct ordering,
 * and call callback when done.
 *
 * @param {Node} start
 * @param {Node} end
 * @param {Vue} vm
 * @param {DocumentFragment} frag
 * @param {Function} cb
 */

function removeNodeRange(start, end, vm, frag, cb) {
  var done = false;
  var removed = 0;
  var nodes = [];
  mapNodeRange(start, end, function (node) {
    if (node === end) done = true;
    nodes.push(node);
    removeWithTransition(node, vm, onRemoved);
  });
  function onRemoved() {
    removed++;
    if (done && removed >= nodes.length) {
      for (var i = 0; i < nodes.length; i++) {
        frag.appendChild(nodes[i]);
      }
      cb && cb();
    }
  }
}

/**
 * Check if a node is a DocumentFragment.
 *
 * @param {Node} node
 * @return {Boolean}
 */

function isFragment(node) {
  return node && node.nodeType === 11;
}

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 *
 * @param {Element} el
 * @return {String}
 */

function getOuterHTML(el) {
  if (el.outerHTML) {
    return el.outerHTML;
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML;
  }
}

var commonTagRE = /^(div|p|span|img|a|b|i|br|ul|ol|li|h1|h2|h3|h4|h5|h6|code|pre|table|th|td|tr|form|label|input|select|option|nav|article|section|header|footer)$/i;
var reservedTagRE = /^(slot|partial|component)$/i;

var isUnknownElement = undefined;
if ('development' !== 'production') {
  isUnknownElement = function (el, tag) {
    if (tag.indexOf('-') > -1) {
      // http://stackoverflow.com/a/28210364/1070244
      return el.constructor === window.HTMLUnknownElement || el.constructor === window.HTMLElement;
    } else {
      return (/HTMLUnknownElement/.test(el.toString()) &&
        // Chrome returns unknown for several HTML5 elements.
        // https://code.google.com/p/chromium/issues/detail?id=540526
        // Firefox returns unknown for some "Interactive elements."
        !/^(data|time|rtc|rb|details|dialog|summary)$/.test(tag)
      );
    }
  };
}

/**
 * Check if an element is a component, if yes return its
 * component id.
 *
 * @param {Element} el
 * @param {Object} options
 * @return {Object|undefined}
 */

function checkComponentAttr(el, options) {
  var tag = el.tagName.toLowerCase();
  var hasAttrs = el.hasAttributes();
  if (!commonTagRE.test(tag) && !reservedTagRE.test(tag)) {
    if (resolveAsset(options, 'components', tag)) {
      return { id: tag };
    } else {
      var is = hasAttrs && getIsBinding(el, options);
      if (is) {
        return is;
      } else if ('development' !== 'production') {
        var expectedTag = options._componentNameMap && options._componentNameMap[tag];
        if (expectedTag) {
          warn('Unknown custom element: <' + tag + '> - ' + 'did you mean <' + expectedTag + '>? ' + 'HTML is case-insensitive, remember to use kebab-case in templates.');
        } else if (isUnknownElement(el, tag)) {
          warn('Unknown custom element: <' + tag + '> - did you ' + 'register the component correctly? For recursive components, ' + 'make sure to provide the "name" option.');
        }
      }
    }
  } else if (hasAttrs) {
    return getIsBinding(el, options);
  }
}

/**
 * Get "is" binding from an element.
 *
 * @param {Element} el
 * @param {Object} options
 * @return {Object|undefined}
 */

function getIsBinding(el, options) {
  // dynamic syntax
  var exp = el.getAttribute('is');
  if (exp != null) {
    if (resolveAsset(options, 'components', exp)) {
      el.removeAttribute('is');
      return { id: exp };
    }
  } else {
    exp = getBindAttr(el, 'is');
    if (exp != null) {
      return { id: exp, dynamic: true };
    }
  }
}

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 *
 * All strategy functions follow the same signature:
 *
 * @param {*} parentVal
 * @param {*} childVal
 * @param {Vue} [vm]
 */

var strats = config.optionMergeStrategies = Object.create(null);

/**
 * Helper that recursively merges two data objects together.
 */

function mergeData(to, from) {
  var key, toVal, fromVal;
  for (key in from) {
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (isObject(toVal) && isObject(fromVal)) {
      mergeData(toVal, fromVal);
    }
  }
  return to;
}

/**
 * Data
 */

strats.data = function (parentVal, childVal, vm) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal;
    }
    if (typeof childVal !== 'function') {
      'development' !== 'production' && warn('The "data" option should be a function ' + 'that returns a per-instance value in component ' + 'definitions.', vm);
      return parentVal;
    }
    if (!parentVal) {
      return childVal;
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn() {
      return mergeData(childVal.call(this), parentVal.call(this));
    };
  } else if (parentVal || childVal) {
    return function mergedInstanceDataFn() {
      // instance merge
      var instanceData = typeof childVal === 'function' ? childVal.call(vm) : childVal;
      var defaultData = typeof parentVal === 'function' ? parentVal.call(vm) : undefined;
      if (instanceData) {
        return mergeData(instanceData, defaultData);
      } else {
        return defaultData;
      }
    };
  }
};

/**
 * El
 */

strats.el = function (parentVal, childVal, vm) {
  if (!vm && childVal && typeof childVal !== 'function') {
    'development' !== 'production' && warn('The "el" option should be a function ' + 'that returns a per-instance value in component ' + 'definitions.', vm);
    return;
  }
  var ret = childVal || parentVal;
  // invoke the element factory if this is instance merge
  return vm && typeof ret === 'function' ? ret.call(vm) : ret;
};

/**
 * Hooks and param attributes are merged as arrays.
 */

strats.init = strats.created = strats.ready = strats.attached = strats.detached = strats.beforeCompile = strats.compiled = strats.beforeDestroy = strats.destroyed = strats.activate = function (parentVal, childVal) {
  return childVal ? parentVal ? parentVal.concat(childVal) : isArray(childVal) ? childVal : [childVal] : parentVal;
};

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */

function mergeAssets(parentVal, childVal) {
  var res = Object.create(parentVal || null);
  return childVal ? extend(res, guardArrayAssets(childVal)) : res;
}

config._assetTypes.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Events & Watchers.
 *
 * Events & watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */

strats.watch = strats.events = function (parentVal, childVal) {
  if (!childVal) return parentVal;
  if (!parentVal) return childVal;
  var ret = {};
  extend(ret, parentVal);
  for (var key in childVal) {
    var parent = ret[key];
    var child = childVal[key];
    if (parent && !isArray(parent)) {
      parent = [parent];
    }
    ret[key] = parent ? parent.concat(child) : [child];
  }
  return ret;
};

/**
 * Other object hashes.
 */

strats.props = strats.methods = strats.computed = function (parentVal, childVal) {
  if (!childVal) return parentVal;
  if (!parentVal) return childVal;
  var ret = Object.create(null);
  extend(ret, parentVal);
  extend(ret, childVal);
  return ret;
};

/**
 * Default strategy.
 */

var defaultStrat = function defaultStrat(parentVal, childVal) {
  return childVal === undefined ? parentVal : childVal;
};

/**
 * Make sure component options get converted to actual
 * constructors.
 *
 * @param {Object} options
 */

function guardComponents(options) {
  if (options.components) {
    var components = options.components = guardArrayAssets(options.components);
    var ids = Object.keys(components);
    var def;
    if ('development' !== 'production') {
      var map = options._componentNameMap = {};
    }
    for (var i = 0, l = ids.length; i < l; i++) {
      var key = ids[i];
      if (commonTagRE.test(key) || reservedTagRE.test(key)) {
        'development' !== 'production' && warn('Do not use built-in or reserved HTML elements as component ' + 'id: ' + key);
        continue;
      }
      // record a all lowercase <-> kebab-case mapping for
      // possible custom element case error warning
      if ('development' !== 'production') {
        map[key.replace(/-/g, '').toLowerCase()] = hyphenate(key);
      }
      def = components[key];
      if (isPlainObject(def)) {
        components[key] = Vue.extend(def);
      }
    }
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 *
 * @param {Object} options
 */

function guardProps(options) {
  var props = options.props;
  var i, val;
  if (isArray(props)) {
    options.props = {};
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        options.props[val] = null;
      } else if (val.name) {
        options.props[val.name] = val;
      }
    }
  } else if (isPlainObject(props)) {
    var keys = Object.keys(props);
    i = keys.length;
    while (i--) {
      val = props[keys[i]];
      if (typeof val === 'function') {
        props[keys[i]] = { type: val };
      }
    }
  }
}

/**
 * Guard an Array-format assets option and converted it
 * into the key-value Object format.
 *
 * @param {Object|Array} assets
 * @return {Object}
 */

function guardArrayAssets(assets) {
  if (isArray(assets)) {
    var res = {};
    var i = assets.length;
    var asset;
    while (i--) {
      asset = assets[i];
      var id = typeof asset === 'function' ? asset.options && asset.options.name || asset.id : asset.name || asset.id;
      if (!id) {
        'development' !== 'production' && warn('Array-syntax assets must provide a "name" or "id" field.');
      } else {
        res[id] = asset;
      }
    }
    return res;
  }
  return assets;
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 *
 * @param {Object} parent
 * @param {Object} child
 * @param {Vue} [vm] - if vm is present, indicates this is
 *                     an instantiation merge.
 */

function mergeOptions(parent, child, vm) {
  guardComponents(child);
  guardProps(child);
  if ('development' !== 'production') {
    if (child.propsData && !vm) {
      warn('propsData can only be used as an instantiation option.');
    }
  }
  var options = {};
  var key;
  if (child['extends']) {
    parent = typeof child['extends'] === 'function' ? mergeOptions(parent, child['extends'].options, vm) : mergeOptions(parent, child['extends'], vm);
  }
  if (child.mixins) {
    for (var i = 0, l = child.mixins.length; i < l; i++) {
      var mixin = child.mixins[i];
      var mixinOptions = mixin.prototype instanceof Vue ? mixin.options : mixin;
      parent = mergeOptions(parent, mixinOptions, vm);
    }
  }
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField(key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options;
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 *
 * @param {Object} options
 * @param {String} type
 * @param {String} id
 * @param {Boolean} warnMissing
 * @return {Object|Function}
 */

function resolveAsset(options, type, id, warnMissing) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return;
  }
  var assets = options[type];
  var camelizedId;
  var res = assets[id] ||
  // camelCase ID
  assets[camelizedId = camelize(id)] ||
  // Pascal Case ID
  assets[camelizedId.charAt(0).toUpperCase() + camelizedId.slice(1)];
  if ('development' !== 'production' && warnMissing && !res) {
    warn('Failed to resolve ' + type.slice(0, -1) + ': ' + id, options);
  }
  return res;
}

var uid$1 = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 *
 * @constructor
 */
function Dep() {
  this.id = uid$1++;
  this.subs = [];
}

// the current target watcher being evaluated.
// this is globally unique because there could be only one
// watcher being evaluated at any time.
Dep.target = null;

/**
 * Add a directive subscriber.
 *
 * @param {Directive} sub
 */

Dep.prototype.addSub = function (sub) {
  this.subs.push(sub);
};

/**
 * Remove a directive subscriber.
 *
 * @param {Directive} sub
 */

Dep.prototype.removeSub = function (sub) {
  this.subs.$remove(sub);
};

/**
 * Add self as a dependency to the target watcher.
 */

Dep.prototype.depend = function () {
  Dep.target.addDep(this);
};

/**
 * Notify all subscribers of a new value.
 */

Dep.prototype.notify = function () {
  // stablize the subscriber list first
  var subs = toArray(this.subs);
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto)

/**
 * Intercept mutating methods and emit events
 */

;['push', 'pop', 'shift', 'unshift', 'splice', 'sort', 'reverse'].forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator() {
    // avoid leaking arguments:
    // http://jsperf.com/closure-with-arguments
    var i = arguments.length;
    var args = new Array(i);
    while (i--) {
      args[i] = arguments[i];
    }
    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
        inserted = args;
        break;
      case 'unshift':
        inserted = args;
        break;
      case 'splice':
        inserted = args.slice(2);
        break;
    }
    if (inserted) ob.observeArray(inserted);
    // notify change
    ob.dep.notify();
    return result;
  });
});

/**
 * Swap the element at the given index with a new value
 * and emits corresponding event.
 *
 * @param {Number} index
 * @param {*} val
 * @return {*} - replaced element
 */

def(arrayProto, '$set', function $set(index, val) {
  if (index >= this.length) {
    this.length = Number(index) + 1;
  }
  return this.splice(index, 1, val)[0];
});

/**
 * Convenience method to remove the element at given index or target element reference.
 *
 * @param {*} item
 */

def(arrayProto, '$remove', function $remove(item) {
  /* istanbul ignore if */
  if (!this.length) return;
  var index = indexOf(this, item);
  if (index > -1) {
    return this.splice(index, 1);
  }
});

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * By default, when a reactive property is set, the new value is
 * also converted to become reactive. However in certain cases, e.g.
 * v-for scope alias and props, we don't want to force conversion
 * because the value may be a nested value under a frozen data structure.
 *
 * So whenever we want to set a reactive property without forcing
 * conversion on the new value, we wrap that call inside this function.
 */

var shouldConvert = true;

function withoutConversion(fn) {
  shouldConvert = false;
  fn();
  shouldConvert = true;
}

/**
 * Observer class that are attached to each observed
 * object. Once attached, the observer converts target
 * object's property keys into getter/setters that
 * collect dependencies and dispatches updates.
 *
 * @param {Array|Object} value
 * @constructor
 */

function Observer(value) {
  this.value = value;
  this.dep = new Dep();
  def(value, '__ob__', this);
  if (isArray(value)) {
    var augment = hasProto ? protoAugment : copyAugment;
    augment(value, arrayMethods, arrayKeys);
    this.observeArray(value);
  } else {
    this.walk(value);
  }
}

// Instance methods

/**
 * Walk through each property and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 *
 * @param {Object} obj
 */

Observer.prototype.walk = function (obj) {
  var keys = Object.keys(obj);
  for (var i = 0, l = keys.length; i < l; i++) {
    this.convert(keys[i], obj[keys[i]]);
  }
};

/**
 * Observe a list of Array items.
 *
 * @param {Array} items
 */

Observer.prototype.observeArray = function (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

/**
 * Convert a property into getter/setter so we can emit
 * the events when the property is accessed/changed.
 *
 * @param {String} key
 * @param {*} val
 */

Observer.prototype.convert = function (key, val) {
  defineReactive(this.value, key, val);
};

/**
 * Add an owner vm, so that when $set/$delete mutations
 * happen we can notify owner vms to proxy the keys and
 * digest the watchers. This is only called when the object
 * is observed as an instance's root $data.
 *
 * @param {Vue} vm
 */

Observer.prototype.addVm = function (vm) {
  (this.vms || (this.vms = [])).push(vm);
};

/**
 * Remove an owner vm. This is called when the object is
 * swapped out as an instance's $data object.
 *
 * @param {Vue} vm
 */

Observer.prototype.removeVm = function (vm) {
  this.vms.$remove(vm);
};

// helpers

/**
 * Augment an target Object or Array by intercepting
 * the prototype chain using __proto__
 *
 * @param {Object|Array} target
 * @param {Object} src
 */

function protoAugment(target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment an target Object or Array by defining
 * hidden properties.
 *
 * @param {Object|Array} target
 * @param {Object} proto
 */

function copyAugment(target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 *
 * @param {*} value
 * @param {Vue} [vm]
 * @return {Observer|undefined}
 * @static
 */

function observe(value, vm) {
  if (!value || typeof value !== 'object') {
    return;
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (shouldConvert && (isArray(value) || isPlainObject(value)) && Object.isExtensible(value) && !value._isVue) {
    ob = new Observer(value);
  }
  if (ob && vm) {
    ob.addVm(vm);
  }
  return ob;
}

/**
 * Define a reactive property on an Object.
 *
 * @param {Object} obj
 * @param {String} key
 * @param {*} val
 */

function defineReactive(obj, key, val) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return;
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;

  var childOb = observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter() {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
        }
        if (isArray(value)) {
          for (var e, i = 0, l = value.length; i < l; i++) {
            e = value[i];
            e && e.__ob__ && e.__ob__.dep.depend();
          }
        }
      }
      return value;
    },
    set: function reactiveSetter(newVal) {
      var value = getter ? getter.call(obj) : val;
      if (newVal === value) {
        return;
      }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = observe(newVal);
      dep.notify();
    }
  });
}



var util = Object.freeze({
	defineReactive: defineReactive,
	set: set,
	del: del,
	hasOwn: hasOwn,
	isLiteral: isLiteral,
	isReserved: isReserved,
	_toString: _toString,
	toNumber: toNumber,
	toBoolean: toBoolean,
	stripQuotes: stripQuotes,
	camelize: camelize,
	hyphenate: hyphenate,
	classify: classify,
	bind: bind,
	toArray: toArray,
	extend: extend,
	isObject: isObject,
	isPlainObject: isPlainObject,
	def: def,
	debounce: _debounce,
	indexOf: indexOf,
	cancellable: cancellable,
	looseEqual: looseEqual,
	isArray: isArray,
	hasProto: hasProto,
	inBrowser: inBrowser,
	devtools: devtools,
	isIE: isIE,
	isIE9: isIE9,
	isAndroid: isAndroid,
	isIOS: isIOS,
	get transitionProp () { return transitionProp; },
	get transitionEndEvent () { return transitionEndEvent; },
	get animationProp () { return animationProp; },
	get animationEndEvent () { return animationEndEvent; },
	nextTick: nextTick,
	get _Set () { return _Set; },
	query: query,
	inDoc: inDoc,
	getAttr: getAttr,
	getBindAttr: getBindAttr,
	hasBindAttr: hasBindAttr,
	before: before,
	after: after,
	remove: remove,
	prepend: prepend,
	replace: replace,
	on: on,
	off: off,
	setClass: setClass,
	addClass: addClass,
	removeClass: removeClass,
	extractContent: extractContent,
	trimNode: trimNode,
	isTemplate: isTemplate,
	createAnchor: createAnchor,
	findRef: findRef,
	mapNodeRange: mapNodeRange,
	removeNodeRange: removeNodeRange,
	isFragment: isFragment,
	getOuterHTML: getOuterHTML,
	mergeOptions: mergeOptions,
	resolveAsset: resolveAsset,
	checkComponentAttr: checkComponentAttr,
	commonTagRE: commonTagRE,
	reservedTagRE: reservedTagRE,
	get warn () { return warn; }
});

var uid = 0;

function initMixin (Vue) {
  /**
   * The main init sequence. This is called for every
   * instance, including ones that are created from extended
   * constructors.
   *
   * @param {Object} options - this options object should be
   *                           the result of merging class
   *                           options and the options passed
   *                           in to the constructor.
   */

  Vue.prototype._init = function (options) {
    options = options || {};

    this.$el = null;
    this.$parent = options.parent;
    this.$root = this.$parent ? this.$parent.$root : this;
    this.$children = [];
    this.$refs = {}; // child vm references
    this.$els = {}; // element references
    this._watchers = []; // all watchers as an array
    this._directives = []; // all directives

    // a uid
    this._uid = uid++;

    // a flag to avoid this being observed
    this._isVue = true;

    // events bookkeeping
    this._events = {}; // registered callbacks
    this._eventsCount = {}; // for $broadcast optimization

    // fragment instance properties
    this._isFragment = false;
    this._fragment = // @type {DocumentFragment}
    this._fragmentStart = // @type {Text|Comment}
    this._fragmentEnd = null; // @type {Text|Comment}

    // lifecycle state
    this._isCompiled = this._isDestroyed = this._isReady = this._isAttached = this._isBeingDestroyed = this._vForRemoving = false;
    this._unlinkFn = null;

    // context:
    // if this is a transcluded component, context
    // will be the common parent vm of this instance
    // and its host.
    this._context = options._context || this.$parent;

    // scope:
    // if this is inside an inline v-for, the scope
    // will be the intermediate scope created for this
    // repeat fragment. this is used for linking props
    // and container directives.
    this._scope = options._scope;

    // fragment:
    // if this instance is compiled inside a Fragment, it
    // needs to register itself as a child of that fragment
    // for attach/detach to work properly.
    this._frag = options._frag;
    if (this._frag) {
      this._frag.children.push(this);
    }

    // push self into parent / transclusion host
    if (this.$parent) {
      this.$parent.$children.push(this);
    }

    // merge options.
    options = this.$options = mergeOptions(this.constructor.options, options, this);

    // set ref
    this._updateRef();

    // initialize data as empty object.
    // it will be filled up in _initData().
    this._data = {};

    // call init hook
    this._callHook('init');

    // initialize data observation and scope inheritance.
    this._initState();

    // setup event system and option events.
    this._initEvents();

    // call created hook
    this._callHook('created');

    // if `el` option is passed, start compilation.
    if (options.el) {
      this.$mount(options.el);
    }
  };
}

var pathCache = new Cache(1000);

// actions
var APPEND = 0;
var PUSH = 1;
var INC_SUB_PATH_DEPTH = 2;
var PUSH_SUB_PATH = 3;

// states
var BEFORE_PATH = 0;
var IN_PATH = 1;
var BEFORE_IDENT = 2;
var IN_IDENT = 3;
var IN_SUB_PATH = 4;
var IN_SINGLE_QUOTE = 5;
var IN_DOUBLE_QUOTE = 6;
var AFTER_PATH = 7;
var ERROR = 8;

var pathStateMachine = [];

pathStateMachine[BEFORE_PATH] = {
  'ws': [BEFORE_PATH],
  'ident': [IN_IDENT, APPEND],
  '[': [IN_SUB_PATH],
  'eof': [AFTER_PATH]
};

pathStateMachine[IN_PATH] = {
  'ws': [IN_PATH],
  '.': [BEFORE_IDENT],
  '[': [IN_SUB_PATH],
  'eof': [AFTER_PATH]
};

pathStateMachine[BEFORE_IDENT] = {
  'ws': [BEFORE_IDENT],
  'ident': [IN_IDENT, APPEND]
};

pathStateMachine[IN_IDENT] = {
  'ident': [IN_IDENT, APPEND],
  '0': [IN_IDENT, APPEND],
  'number': [IN_IDENT, APPEND],
  'ws': [IN_PATH, PUSH],
  '.': [BEFORE_IDENT, PUSH],
  '[': [IN_SUB_PATH, PUSH],
  'eof': [AFTER_PATH, PUSH]
};

pathStateMachine[IN_SUB_PATH] = {
  "'": [IN_SINGLE_QUOTE, APPEND],
  '"': [IN_DOUBLE_QUOTE, APPEND],
  '[': [IN_SUB_PATH, INC_SUB_PATH_DEPTH],
  ']': [IN_PATH, PUSH_SUB_PATH],
  'eof': ERROR,
  'else': [IN_SUB_PATH, APPEND]
};

pathStateMachine[IN_SINGLE_QUOTE] = {
  "'": [IN_SUB_PATH, APPEND],
  'eof': ERROR,
  'else': [IN_SINGLE_QUOTE, APPEND]
};

pathStateMachine[IN_DOUBLE_QUOTE] = {
  '"': [IN_SUB_PATH, APPEND],
  'eof': ERROR,
  'else': [IN_DOUBLE_QUOTE, APPEND]
};

/**
 * Determine the type of a character in a keypath.
 *
 * @param {Char} ch
 * @return {String} type
 */

function getPathCharType(ch) {
  if (ch === undefined) {
    return 'eof';
  }

  var code = ch.charCodeAt(0);

  switch (code) {
    case 0x5B: // [
    case 0x5D: // ]
    case 0x2E: // .
    case 0x22: // "
    case 0x27: // '
    case 0x30:
      // 0
      return ch;

    case 0x5F: // _
    case 0x24:
      // $
      return 'ident';

    case 0x20: // Space
    case 0x09: // Tab
    case 0x0A: // Newline
    case 0x0D: // Return
    case 0xA0: // No-break space
    case 0xFEFF: // Byte Order Mark
    case 0x2028: // Line Separator
    case 0x2029:
      // Paragraph Separator
      return 'ws';
  }

  // a-z, A-Z
  if (code >= 0x61 && code <= 0x7A || code >= 0x41 && code <= 0x5A) {
    return 'ident';
  }

  // 1-9
  if (code >= 0x31 && code <= 0x39) {
    return 'number';
  }

  return 'else';
}

/**
 * Format a subPath, return its plain form if it is
 * a literal string or number. Otherwise prepend the
 * dynamic indicator (*).
 *
 * @param {String} path
 * @return {String}
 */

function formatSubPath(path) {
  var trimmed = path.trim();
  // invalid leading 0
  if (path.charAt(0) === '0' && isNaN(path)) {
    return false;
  }
  return isLiteral(trimmed) ? stripQuotes(trimmed) : '*' + trimmed;
}

/**
 * Parse a string path into an array of segments
 *
 * @param {String} path
 * @return {Array|undefined}
 */

function parse(path) {
  var keys = [];
  var index = -1;
  var mode = BEFORE_PATH;
  var subPathDepth = 0;
  var c, newChar, key, type, transition, action, typeMap;

  var actions = [];

  actions[PUSH] = function () {
    if (key !== undefined) {
      keys.push(key);
      key = undefined;
    }
  };

  actions[APPEND] = function () {
    if (key === undefined) {
      key = newChar;
    } else {
      key += newChar;
    }
  };

  actions[INC_SUB_PATH_DEPTH] = function () {
    actions[APPEND]();
    subPathDepth++;
  };

  actions[PUSH_SUB_PATH] = function () {
    if (subPathDepth > 0) {
      subPathDepth--;
      mode = IN_SUB_PATH;
      actions[APPEND]();
    } else {
      subPathDepth = 0;
      key = formatSubPath(key);
      if (key === false) {
        return false;
      } else {
        actions[PUSH]();
      }
    }
  };

  function maybeUnescapeQuote() {
    var nextChar = path[index + 1];
    if (mode === IN_SINGLE_QUOTE && nextChar === "'" || mode === IN_DOUBLE_QUOTE && nextChar === '"') {
      index++;
      newChar = '\\' + nextChar;
      actions[APPEND]();
      return true;
    }
  }

  while (mode != null) {
    index++;
    c = path[index];

    if (c === '\\' && maybeUnescapeQuote()) {
      continue;
    }

    type = getPathCharType(c);
    typeMap = pathStateMachine[mode];
    transition = typeMap[type] || typeMap['else'] || ERROR;

    if (transition === ERROR) {
      return; // parse error
    }

    mode = transition[0];
    action = actions[transition[1]];
    if (action) {
      newChar = transition[2];
      newChar = newChar === undefined ? c : newChar;
      if (action() === false) {
        return;
      }
    }

    if (mode === AFTER_PATH) {
      keys.raw = path;
      return keys;
    }
  }
}

/**
 * External parse that check for a cache hit first
 *
 * @param {String} path
 * @return {Array|undefined}
 */

function parsePath(path) {
  var hit = pathCache.get(path);
  if (!hit) {
    hit = parse(path);
    if (hit) {
      pathCache.put(path, hit);
    }
  }
  return hit;
}

/**
 * Get from an object from a path string
 *
 * @param {Object} obj
 * @param {String} path
 */

function getPath(obj, path) {
  return parseExpression$1(path).get(obj);
}

/**
 * Warn against setting non-existent root path on a vm.
 */

var warnNonExistent;
if ('development' !== 'production') {
  warnNonExistent = function (path, vm) {
    warn('You are setting a non-existent path "' + path.raw + '" ' + 'on a vm instance. Consider pre-initializing the property ' + 'with the "data" option for more reliable reactivity ' + 'and better performance.', vm);
  };
}

/**
 * Set on an object from a path
 *
 * @param {Object} obj
 * @param {String | Array} path
 * @param {*} val
 */

function setPath(obj, path, val) {
  var original = obj;
  if (typeof path === 'string') {
    path = parse(path);
  }
  if (!path || !isObject(obj)) {
    return false;
  }
  var last, key;
  for (var i = 0, l = path.length; i < l; i++) {
    last = obj;
    key = path[i];
    if (key.charAt(0) === '*') {
      key = parseExpression$1(key.slice(1)).get.call(original, original);
    }
    if (i < l - 1) {
      obj = obj[key];
      if (!isObject(obj)) {
        obj = {};
        if ('development' !== 'production' && last._isVue) {
          warnNonExistent(path, last);
        }
        set(last, key, obj);
      }
    } else {
      if (isArray(obj)) {
        obj.$set(key, val);
      } else if (key in obj) {
        obj[key] = val;
      } else {
        if ('development' !== 'production' && obj._isVue) {
          warnNonExistent(path, obj);
        }
        set(obj, key, val);
      }
    }
  }
  return true;
}

var path = Object.freeze({
  parsePath: parsePath,
  getPath: getPath,
  setPath: setPath
});

var expressionCache = new Cache(1000);

var allowedKeywords = 'Math,Date,this,true,false,null,undefined,Infinity,NaN,' + 'isNaN,isFinite,decodeURI,decodeURIComponent,encodeURI,' + 'encodeURIComponent,parseInt,parseFloat';
var allowedKeywordsRE = new RegExp('^(' + allowedKeywords.replace(/,/g, '\\b|') + '\\b)');

// keywords that don't make sense inside expressions
var improperKeywords = 'break,case,class,catch,const,continue,debugger,default,' + 'delete,do,else,export,extends,finally,for,function,if,' + 'import,in,instanceof,let,return,super,switch,throw,try,' + 'var,while,with,yield,enum,await,implements,package,' + 'protected,static,interface,private,public';
var improperKeywordsRE = new RegExp('^(' + improperKeywords.replace(/,/g, '\\b|') + '\\b)');

var wsRE = /\s/g;
var newlineRE = /\n/g;
var saveRE = /[\{,]\s*[\w\$_]+\s*:|('(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\"']|\\.)*`|`(?:[^`\\]|\\.)*`)|new |typeof |void /g;
var restoreRE = /"(\d+)"/g;
var pathTestRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['.*?'\]|\[".*?"\]|\[\d+\]|\[[A-Za-z_$][\w$]*\])*$/;
var identRE = /[^\w$\.](?:[A-Za-z_$][\w$]*)/g;
var literalValueRE$1 = /^(?:true|false|null|undefined|Infinity|NaN)$/;

function noop() {}

/**
 * Save / Rewrite / Restore
 *
 * When rewriting paths found in an expression, it is
 * possible for the same letter sequences to be found in
 * strings and Object literal property keys. Therefore we
 * remove and store these parts in a temporary array, and
 * restore them after the path rewrite.
 */

var saved = [];

/**
 * Save replacer
 *
 * The save regex can match two possible cases:
 * 1. An opening object literal
 * 2. A string
 * If matched as a plain string, we need to escape its
 * newlines, since the string needs to be preserved when
 * generating the function body.
 *
 * @param {String} str
 * @param {String} isString - str if matched as a string
 * @return {String} - placeholder with index
 */

function save(str, isString) {
  var i = saved.length;
  saved[i] = isString ? str.replace(newlineRE, '\\n') : str;
  return '"' + i + '"';
}

/**
 * Path rewrite replacer
 *
 * @param {String} raw
 * @return {String}
 */

function rewrite(raw) {
  var c = raw.charAt(0);
  var path = raw.slice(1);
  if (allowedKeywordsRE.test(path)) {
    return raw;
  } else {
    path = path.indexOf('"') > -1 ? path.replace(restoreRE, restore) : path;
    return c + 'scope.' + path;
  }
}

/**
 * Restore replacer
 *
 * @param {String} str
 * @param {String} i - matched save index
 * @return {String}
 */

function restore(str, i) {
  return saved[i];
}

/**
 * Rewrite an expression, prefixing all path accessors with
 * `scope.` and generate getter/setter functions.
 *
 * @param {String} exp
 * @return {Function}
 */

function compileGetter(exp) {
  if (improperKeywordsRE.test(exp)) {
    'development' !== 'production' && warn('Avoid using reserved keywords in expression: ' + exp);
  }
  // reset state
  saved.length = 0;
  // save strings and object literal keys
  var body = exp.replace(saveRE, save).replace(wsRE, '');
  // rewrite all paths
  // pad 1 space here because the regex matches 1 extra char
  body = (' ' + body).replace(identRE, rewrite).replace(restoreRE, restore);
  return makeGetterFn(body);
}

/**
 * Build a getter function. Requires eval.
 *
 * We isolate the try/catch so it doesn't affect the
 * optimization of the parse function when it is not called.
 *
 * @param {String} body
 * @return {Function|undefined}
 */

function makeGetterFn(body) {
  try {
    /* eslint-disable no-new-func */
    return new Function('scope', 'return ' + body + ';');
    /* eslint-enable no-new-func */
  } catch (e) {
    if ('development' !== 'production') {
      /* istanbul ignore if */
      if (e.toString().match(/unsafe-eval|CSP/)) {
        warn('It seems you are using the default build of Vue.js in an environment ' + 'with Content Security Policy that prohibits unsafe-eval. ' + 'Use the CSP-compliant build instead: ' + 'http://vuejs.org/guide/installation.html#CSP-compliant-build');
      } else {
        warn('Invalid expression. ' + 'Generated function body: ' + body);
      }
    }
    return noop;
  }
}

/**
 * Compile a setter function for the expression.
 *
 * @param {String} exp
 * @return {Function|undefined}
 */

function compileSetter(exp) {
  var path = parsePath(exp);
  if (path) {
    return function (scope, val) {
      setPath(scope, path, val);
    };
  } else {
    'development' !== 'production' && warn('Invalid setter expression: ' + exp);
  }
}

/**
 * Parse an expression into re-written getter/setters.
 *
 * @param {String} exp
 * @param {Boolean} needSet
 * @return {Function}
 */

function parseExpression$1(exp, needSet) {
  exp = exp.trim();
  // try cache
  var hit = expressionCache.get(exp);
  if (hit) {
    if (needSet && !hit.set) {
      hit.set = compileSetter(hit.exp);
    }
    return hit;
  }
  var res = { exp: exp };
  res.get = isSimplePath(exp) && exp.indexOf('[') < 0
  // optimized super simple getter
  ? makeGetterFn('scope.' + exp)
  // dynamic getter
  : compileGetter(exp);
  if (needSet) {
    res.set = compileSetter(exp);
  }
  expressionCache.put(exp, res);
  return res;
}

/**
 * Check if an expression is a simple path.
 *
 * @param {String} exp
 * @return {Boolean}
 */

function isSimplePath(exp) {
  return pathTestRE.test(exp) &&
  // don't treat literal values as paths
  !literalValueRE$1.test(exp) &&
  // Math constants e.g. Math.PI, Math.E etc.
  exp.slice(0, 5) !== 'Math.';
}

var expression = Object.freeze({
  parseExpression: parseExpression$1,
  isSimplePath: isSimplePath
});

// we have two separate queues: one for directive updates
// and one for user watcher registered via $watch().
// we want to guarantee directive updates to be called
// before user watchers so that when user watchers are
// triggered, the DOM would have already been in updated
// state.

var queue = [];
var userQueue = [];
var has = {};
var circular = {};
var waiting = false;

/**
 * Reset the batcher's state.
 */

function resetBatcherState() {
  queue.length = 0;
  userQueue.length = 0;
  has = {};
  circular = {};
  waiting = false;
}

/**
 * Flush both queues and run the watchers.
 */

function flushBatcherQueue() {
  var _again = true;

  _function: while (_again) {
    _again = false;

    runBatcherQueue(queue);
    runBatcherQueue(userQueue);
    // user watchers triggered more watchers,
    // keep flushing until it depletes
    if (queue.length) {
      _again = true;
      continue _function;
    }
    // dev tool hook
    /* istanbul ignore if */
    if (devtools && config.devtools) {
      devtools.emit('flush');
    }
    resetBatcherState();
  }
}

/**
 * Run the watchers in a single queue.
 *
 * @param {Array} queue
 */

function runBatcherQueue(queue) {
  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (var i = 0; i < queue.length; i++) {
    var watcher = queue[i];
    var id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if ('development' !== 'production' && has[id] != null) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > config._maxUpdateCount) {
        warn('You may have an infinite update loop for watcher ' + 'with expression "' + watcher.expression + '"', watcher.vm);
        break;
      }
    }
  }
  queue.length = 0;
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 *
 * @param {Watcher} watcher
 *   properties:
 *   - {Number} id
 *   - {Function} run
 */

function pushWatcher(watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    // push watcher into appropriate queue
    var q = watcher.user ? userQueue : queue;
    has[id] = q.length;
    q.push(watcher);
    // queue the flush
    if (!waiting) {
      waiting = true;
      nextTick(flushBatcherQueue);
    }
  }
}

var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 *
 * @param {Vue} vm
 * @param {String|Function} expOrFn
 * @param {Function} cb
 * @param {Object} options
 *                 - {Array} filters
 *                 - {Boolean} twoWay
 *                 - {Boolean} deep
 *                 - {Boolean} user
 *                 - {Boolean} sync
 *                 - {Boolean} lazy
 *                 - {Function} [preProcess]
 *                 - {Function} [postProcess]
 * @constructor
 */
function Watcher(vm, expOrFn, cb, options) {
  // mix in options
  if (options) {
    extend(this, options);
  }
  var isFn = typeof expOrFn === 'function';
  this.vm = vm;
  vm._watchers.push(this);
  this.expression = expOrFn;
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.prevError = null; // for async error stacks
  // parse expression for getter/setter
  if (isFn) {
    this.getter = expOrFn;
    this.setter = undefined;
  } else {
    var res = parseExpression$1(expOrFn, this.twoWay);
    this.getter = res.get;
    this.setter = res.set;
  }
  this.value = this.lazy ? undefined : this.get();
  // state for avoiding false triggers for deep and Array
  // watchers during vm._digest()
  this.queued = this.shallow = false;
}

/**
 * Evaluate the getter, and re-collect dependencies.
 */

Watcher.prototype.get = function () {
  this.beforeGet();
  var scope = this.scope || this.vm;
  var value;
  try {
    value = this.getter.call(scope, scope);
  } catch (e) {
    if ('development' !== 'production' && config.warnExpressionErrors) {
      warn('Error when evaluating expression ' + '"' + this.expression + '": ' + e.toString(), this.vm);
    }
  }
  // "touch" every property so they are all tracked as
  // dependencies for deep watching
  if (this.deep) {
    traverse(value);
  }
  if (this.preProcess) {
    value = this.preProcess(value);
  }
  if (this.filters) {
    value = scope._applyFilters(value, null, this.filters, false);
  }
  if (this.postProcess) {
    value = this.postProcess(value);
  }
  this.afterGet();
  return value;
};

/**
 * Set the corresponding value with the setter.
 *
 * @param {*} value
 */

Watcher.prototype.set = function (value) {
  var scope = this.scope || this.vm;
  if (this.filters) {
    value = scope._applyFilters(value, this.value, this.filters, true);
  }
  try {
    this.setter.call(scope, scope, value);
  } catch (e) {
    if ('development' !== 'production' && config.warnExpressionErrors) {
      warn('Error when evaluating setter ' + '"' + this.expression + '": ' + e.toString(), this.vm);
    }
  }
  // two-way sync for v-for alias
  var forContext = scope.$forContext;
  if (forContext && forContext.alias === this.expression) {
    if (forContext.filters) {
      'development' !== 'production' && warn('It seems you are using two-way binding on ' + 'a v-for alias (' + this.expression + '), and the ' + 'v-for has filters. This will not work properly. ' + 'Either remove the filters or use an array of ' + 'objects and bind to object properties instead.', this.vm);
      return;
    }
    forContext._withLock(function () {
      if (scope.$key) {
        // original is an object
        forContext.rawValue[scope.$key] = value;
      } else {
        forContext.rawValue.$set(scope.$index, value);
      }
    });
  }
};

/**
 * Prepare for dependency collection.
 */

Watcher.prototype.beforeGet = function () {
  Dep.target = this;
};

/**
 * Add a dependency to this directive.
 *
 * @param {Dep} dep
 */

Watcher.prototype.addDep = function (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */

Watcher.prototype.afterGet = function () {
  Dep.target = null;
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 *
 * @param {Boolean} shallow
 */

Watcher.prototype.update = function (shallow) {
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync || !config.async) {
    this.run();
  } else {
    // if queued, only overwrite shallow with non-shallow,
    // but not the other way around.
    this.shallow = this.queued ? shallow ? this.shallow : false : !!shallow;
    this.queued = true;
    // record before-push error stack in debug mode
    /* istanbul ignore if */
    if ('development' !== 'production' && config.debug) {
      this.prevError = new Error('[vue] async stack trace');
    }
    pushWatcher(this);
  }
};

/**
 * Batcher job interface.
 * Will be called by the batcher.
 */

Watcher.prototype.run = function () {
  if (this.active) {
    var value = this.get();
    if (value !== this.value ||
    // Deep watchers and watchers on Object/Arrays should fire even
    // when the value is the same, because the value may
    // have mutated; but only do so if this is a
    // non-shallow update (caused by a vm digest).
    (isObject(value) || this.deep) && !this.shallow) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      // in debug + async mode, when a watcher callbacks
      // throws, we also throw the saved before-push error
      // so the full cross-tick stack trace is available.
      var prevError = this.prevError;
      /* istanbul ignore if */
      if ('development' !== 'production' && config.debug && prevError) {
        this.prevError = null;
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          nextTick(function () {
            throw prevError;
          }, 0);
          throw e;
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
    this.queued = this.shallow = false;
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */

Watcher.prototype.evaluate = function () {
  // avoid overwriting another watcher that is being
  // collected.
  var current = Dep.target;
  this.value = this.get();
  this.dirty = false;
  Dep.target = current;
};

/**
 * Depend on all deps collected by this watcher.
 */

Watcher.prototype.depend = function () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subcriber list.
 */

Watcher.prototype.teardown = function () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed or is performing a v-for
    // re-render (the watcher list is then filtered by v-for).
    if (!this.vm._isBeingDestroyed && !this.vm._vForRemoving) {
      this.vm._watchers.$remove(this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
    this.vm = this.cb = this.value = null;
  }
};

/**
 * Recrusively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 *
 * @param {*} val
 */

var seenObjects = new _Set();
function traverse(val, seen) {
  var i = undefined,
      keys = undefined;
  if (!seen) {
    seen = seenObjects;
    seen.clear();
  }
  var isA = isArray(val);
  var isO = isObject(val);
  if ((isA || isO) && Object.isExtensible(val)) {
    if (val.__ob__) {
      var depId = val.__ob__.dep.id;
      if (seen.has(depId)) {
        return;
      } else {
        seen.add(depId);
      }
    }
    if (isA) {
      i = val.length;
      while (i--) traverse(val[i], seen);
    } else if (isO) {
      keys = Object.keys(val);
      i = keys.length;
      while (i--) traverse(val[keys[i]], seen);
    }
  }
}

var text$1 = {

  bind: function bind() {
    this.attr = this.el.nodeType === 3 ? 'data' : 'textContent';
  },

  update: function update(value) {
    this.el[this.attr] = _toString(value);
  }
};

var templateCache = new Cache(1000);
var idSelectorCache = new Cache(1000);

var map = {
  efault: [0, '', ''],
  legend: [1, '<fieldset>', '</fieldset>'],
  tr: [2, '<table><tbody>', '</tbody></table>'],
  col: [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>']
};

map.td = map.th = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

map.option = map.optgroup = [1, '<select multiple="multiple">', '</select>'];

map.thead = map.tbody = map.colgroup = map.caption = map.tfoot = [1, '<table>', '</table>'];

map.g = map.defs = map.symbol = map.use = map.image = map.text = map.circle = map.ellipse = map.line = map.path = map.polygon = map.polyline = map.rect = [1, '<svg ' + 'xmlns="http://www.w3.org/2000/svg" ' + 'xmlns:xlink="http://www.w3.org/1999/xlink" ' + 'xmlns:ev="http://www.w3.org/2001/xml-events"' + 'version="1.1">', '</svg>'];

/**
 * Check if a node is a supported template node with a
 * DocumentFragment content.
 *
 * @param {Node} node
 * @return {Boolean}
 */

function isRealTemplate(node) {
  return isTemplate(node) && isFragment(node.content);
}

var tagRE$1 = /<([\w:-]+)/;
var entityRE = /&#?\w+?;/;
var commentRE = /<!--/;

/**
 * Convert a string template to a DocumentFragment.
 * Determines correct wrapping by tag types. Wrapping
 * strategy found in jQuery & component/domify.
 *
 * @param {String} templateString
 * @param {Boolean} raw
 * @return {DocumentFragment}
 */

function stringToFragment(templateString, raw) {
  // try a cache hit first
  var cacheKey = raw ? templateString : templateString.trim();
  var hit = templateCache.get(cacheKey);
  if (hit) {
    return hit;
  }

  var frag = document.createDocumentFragment();
  var tagMatch = templateString.match(tagRE$1);
  var entityMatch = entityRE.test(templateString);
  var commentMatch = commentRE.test(templateString);

  if (!tagMatch && !entityMatch && !commentMatch) {
    // text only, return a single text node.
    frag.appendChild(document.createTextNode(templateString));
  } else {
    var tag = tagMatch && tagMatch[1];
    var wrap = map[tag] || map.efault;
    var depth = wrap[0];
    var prefix = wrap[1];
    var suffix = wrap[2];
    var node = document.createElement('div');

    node.innerHTML = prefix + templateString + suffix;
    while (depth--) {
      node = node.lastChild;
    }

    var child;
    /* eslint-disable no-cond-assign */
    while (child = node.firstChild) {
      /* eslint-enable no-cond-assign */
      frag.appendChild(child);
    }
  }
  if (!raw) {
    trimNode(frag);
  }
  templateCache.put(cacheKey, frag);
  return frag;
}

/**
 * Convert a template node to a DocumentFragment.
 *
 * @param {Node} node
 * @return {DocumentFragment}
 */

function nodeToFragment(node) {
  // if its a template tag and the browser supports it,
  // its content is already a document fragment. However, iOS Safari has
  // bug when using directly cloned template content with touch
  // events and can cause crashes when the nodes are removed from DOM, so we
  // have to treat template elements as string templates. (#2805)
  /* istanbul ignore if */
  if (isRealTemplate(node)) {
    return stringToFragment(node.innerHTML);
  }
  // script template
  if (node.tagName === 'SCRIPT') {
    return stringToFragment(node.textContent);
  }
  // normal node, clone it to avoid mutating the original
  var clonedNode = cloneNode(node);
  var frag = document.createDocumentFragment();
  var child;
  /* eslint-disable no-cond-assign */
  while (child = clonedNode.firstChild) {
    /* eslint-enable no-cond-assign */
    frag.appendChild(child);
  }
  trimNode(frag);
  return frag;
}

// Test for the presence of the Safari template cloning bug
// https://bugs.webkit.org/showug.cgi?id=137755
var hasBrokenTemplate = (function () {
  /* istanbul ignore else */
  if (inBrowser) {
    var a = document.createElement('div');
    a.innerHTML = '<template>1</template>';
    return !a.cloneNode(true).firstChild.innerHTML;
  } else {
    return false;
  }
})();

// Test for IE10/11 textarea placeholder clone bug
var hasTextareaCloneBug = (function () {
  /* istanbul ignore else */
  if (inBrowser) {
    var t = document.createElement('textarea');
    t.placeholder = 't';
    return t.cloneNode(true).value === 't';
  } else {
    return false;
  }
})();

/**
 * 1. Deal with Safari cloning nested <template> bug by
 *    manually cloning all template instances.
 * 2. Deal with IE10/11 textarea placeholder bug by setting
 *    the correct value after cloning.
 *
 * @param {Element|DocumentFragment} node
 * @return {Element|DocumentFragment}
 */

function cloneNode(node) {
  /* istanbul ignore if */
  if (!node.querySelectorAll) {
    return node.cloneNode();
  }
  var res = node.cloneNode(true);
  var i, original, cloned;
  /* istanbul ignore if */
  if (hasBrokenTemplate) {
    var tempClone = res;
    if (isRealTemplate(node)) {
      node = node.content;
      tempClone = res.content;
    }
    original = node.querySelectorAll('template');
    if (original.length) {
      cloned = tempClone.querySelectorAll('template');
      i = cloned.length;
      while (i--) {
        cloned[i].parentNode.replaceChild(cloneNode(original[i]), cloned[i]);
      }
    }
  }
  /* istanbul ignore if */
  if (hasTextareaCloneBug) {
    if (node.tagName === 'TEXTAREA') {
      res.value = node.value;
    } else {
      original = node.querySelectorAll('textarea');
      if (original.length) {
        cloned = res.querySelectorAll('textarea');
        i = cloned.length;
        while (i--) {
          cloned[i].value = original[i].value;
        }
      }
    }
  }
  return res;
}

/**
 * Process the template option and normalizes it into a
 * a DocumentFragment that can be used as a partial or a
 * instance template.
 *
 * @param {*} template
 *        Possible values include:
 *        - DocumentFragment object
 *        - Node object of type Template
 *        - id selector: '#some-template-id'
 *        - template string: '<div><span>{{msg}}</span></div>'
 * @param {Boolean} shouldClone
 * @param {Boolean} raw
 *        inline HTML interpolation. Do not check for id
 *        selector and keep whitespace in the string.
 * @return {DocumentFragment|undefined}
 */

function parseTemplate(template, shouldClone, raw) {
  var node, frag;

  // if the template is already a document fragment,
  // do nothing
  if (isFragment(template)) {
    trimNode(template);
    return shouldClone ? cloneNode(template) : template;
  }

  if (typeof template === 'string') {
    // id selector
    if (!raw && template.charAt(0) === '#') {
      // id selector can be cached too
      frag = idSelectorCache.get(template);
      if (!frag) {
        node = document.getElementById(template.slice(1));
        if (node) {
          frag = nodeToFragment(node);
          // save selector to cache
          idSelectorCache.put(template, frag);
        }
      }
    } else {
      // normal string template
      frag = stringToFragment(template, raw);
    }
  } else if (template.nodeType) {
    // a direct node
    frag = nodeToFragment(template);
  }

  return frag && shouldClone ? cloneNode(frag) : frag;
}

var template = Object.freeze({
  cloneNode: cloneNode,
  parseTemplate: parseTemplate
});

var html = {

  bind: function bind() {
    // a comment node means this is a binding for
    // {{{ inline unescaped html }}}
    if (this.el.nodeType === 8) {
      // hold nodes
      this.nodes = [];
      // replace the placeholder with proper anchor
      this.anchor = createAnchor('v-html');
      replace(this.el, this.anchor);
    }
  },

  update: function update(value) {
    value = _toString(value);
    if (this.nodes) {
      this.swap(value);
    } else {
      this.el.innerHTML = value;
    }
  },

  swap: function swap(value) {
    // remove old nodes
    var i = this.nodes.length;
    while (i--) {
      remove(this.nodes[i]);
    }
    // convert new value to a fragment
    // do not attempt to retrieve from id selector
    var frag = parseTemplate(value, true, true);
    // save a reference to these nodes so we can remove later
    this.nodes = toArray(frag.childNodes);
    before(frag, this.anchor);
  }
};

/**
 * Abstraction for a partially-compiled fragment.
 * Can optionally compile content with a child scope.
 *
 * @param {Function} linker
 * @param {Vue} vm
 * @param {DocumentFragment} frag
 * @param {Vue} [host]
 * @param {Object} [scope]
 * @param {Fragment} [parentFrag]
 */
function Fragment(linker, vm, frag, host, scope, parentFrag) {
  this.children = [];
  this.childFrags = [];
  this.vm = vm;
  this.scope = scope;
  this.inserted = false;
  this.parentFrag = parentFrag;
  if (parentFrag) {
    parentFrag.childFrags.push(this);
  }
  this.unlink = linker(vm, frag, host, scope, this);
  var single = this.single = frag.childNodes.length === 1 &&
  // do not go single mode if the only node is an anchor
  !frag.childNodes[0].__v_anchor;
  if (single) {
    this.node = frag.childNodes[0];
    this.before = singleBefore;
    this.remove = singleRemove;
  } else {
    this.node = createAnchor('fragment-start');
    this.end = createAnchor('fragment-end');
    this.frag = frag;
    prepend(this.node, frag);
    frag.appendChild(this.end);
    this.before = multiBefore;
    this.remove = multiRemove;
  }
  this.node.__v_frag = this;
}

/**
 * Call attach/detach for all components contained within
 * this fragment. Also do so recursively for all child
 * fragments.
 *
 * @param {Function} hook
 */

Fragment.prototype.callHook = function (hook) {
  var i, l;
  for (i = 0, l = this.childFrags.length; i < l; i++) {
    this.childFrags[i].callHook(hook);
  }
  for (i = 0, l = this.children.length; i < l; i++) {
    hook(this.children[i]);
  }
};

/**
 * Insert fragment before target, single node version
 *
 * @param {Node} target
 * @param {Boolean} withTransition
 */

function singleBefore(target, withTransition) {
  this.inserted = true;
  var method = withTransition !== false ? beforeWithTransition : before;
  method(this.node, target, this.vm);
  if (inDoc(this.node)) {
    this.callHook(attach);
  }
}

/**
 * Remove fragment, single node version
 */

function singleRemove() {
  this.inserted = false;
  var shouldCallRemove = inDoc(this.node);
  var self = this;
  this.beforeRemove();
  removeWithTransition(this.node, this.vm, function () {
    if (shouldCallRemove) {
      self.callHook(detach);
    }
    self.destroy();
  });
}

/**
 * Insert fragment before target, multi-nodes version
 *
 * @param {Node} target
 * @param {Boolean} withTransition
 */

function multiBefore(target, withTransition) {
  this.inserted = true;
  var vm = this.vm;
  var method = withTransition !== false ? beforeWithTransition : before;
  mapNodeRange(this.node, this.end, function (node) {
    method(node, target, vm);
  });
  if (inDoc(this.node)) {
    this.callHook(attach);
  }
}

/**
 * Remove fragment, multi-nodes version
 */

function multiRemove() {
  this.inserted = false;
  var self = this;
  var shouldCallRemove = inDoc(this.node);
  this.beforeRemove();
  removeNodeRange(this.node, this.end, this.vm, this.frag, function () {
    if (shouldCallRemove) {
      self.callHook(detach);
    }
    self.destroy();
  });
}

/**
 * Prepare the fragment for removal.
 */

Fragment.prototype.beforeRemove = function () {
  var i, l;
  for (i = 0, l = this.childFrags.length; i < l; i++) {
    // call the same method recursively on child
    // fragments, depth-first
    this.childFrags[i].beforeRemove(false);
  }
  for (i = 0, l = this.children.length; i < l; i++) {
    // Call destroy for all contained instances,
    // with remove:false and defer:true.
    // Defer is necessary because we need to
    // keep the children to call detach hooks
    // on them.
    this.children[i].$destroy(false, true);
  }
  var dirs = this.unlink.dirs;
  for (i = 0, l = dirs.length; i < l; i++) {
    // disable the watchers on all the directives
    // so that the rendered content stays the same
    // during removal.
    dirs[i]._watcher && dirs[i]._watcher.teardown();
  }
};

/**
 * Destroy the fragment.
 */

Fragment.prototype.destroy = function () {
  if (this.parentFrag) {
    this.parentFrag.childFrags.$remove(this);
  }
  this.node.__v_frag = null;
  this.unlink();
};

/**
 * Call attach hook for a Vue instance.
 *
 * @param {Vue} child
 */

function attach(child) {
  if (!child._isAttached && inDoc(child.$el)) {
    child._callHook('attached');
  }
}

/**
 * Call detach hook for a Vue instance.
 *
 * @param {Vue} child
 */

function detach(child) {
  if (child._isAttached && !inDoc(child.$el)) {
    child._callHook('detached');
  }
}

var linkerCache = new Cache(5000);

/**
 * A factory that can be used to create instances of a
 * fragment. Caches the compiled linker if possible.
 *
 * @param {Vue} vm
 * @param {Element|String} el
 */
function FragmentFactory(vm, el) {
  this.vm = vm;
  var template;
  var isString = typeof el === 'string';
  if (isString || isTemplate(el) && !el.hasAttribute('v-if')) {
    template = parseTemplate(el, true);
  } else {
    template = document.createDocumentFragment();
    template.appendChild(el);
  }
  this.template = template;
  // linker can be cached, but only for components
  var linker;
  var cid = vm.constructor.cid;
  if (cid > 0) {
    var cacheId = cid + (isString ? el : getOuterHTML(el));
    linker = linkerCache.get(cacheId);
    if (!linker) {
      linker = compile(template, vm.$options, true);
      linkerCache.put(cacheId, linker);
    }
  } else {
    linker = compile(template, vm.$options, true);
  }
  this.linker = linker;
}

/**
 * Create a fragment instance with given host and scope.
 *
 * @param {Vue} host
 * @param {Object} scope
 * @param {Fragment} parentFrag
 */

FragmentFactory.prototype.create = function (host, scope, parentFrag) {
  var frag = cloneNode(this.template);
  return new Fragment(this.linker, this.vm, frag, host, scope, parentFrag);
};

var ON = 700;
var MODEL = 800;
var BIND = 850;
var TRANSITION = 1100;
var EL = 1500;
var COMPONENT = 1500;
var PARTIAL = 1750;
var IF = 2100;
var FOR = 2200;
var SLOT = 2300;

var uid$3 = 0;

var vFor = {

  priority: FOR,
  terminal: true,

  params: ['track-by', 'stagger', 'enter-stagger', 'leave-stagger'],

  bind: function bind() {
    if ('development' !== 'production' && this.el.hasAttribute('v-if')) {
      warn('<' + this.el.tagName.toLowerCase() + ' v-for="' + this.expression + '" v-if="' + this.el.getAttribute('v-if') + '">: ' + 'Using v-if and v-for on the same element is not recommended - ' + 'consider filtering the source Array instead.', this.vm);
    }

    // support "item in/of items" syntax
    var inMatch = this.expression.match(/(.*) (?:in|of) (.*)/);
    if (inMatch) {
      var itMatch = inMatch[1].match(/\((.*),(.*)\)/);
      if (itMatch) {
        this.iterator = itMatch[1].trim();
        this.alias = itMatch[2].trim();
      } else {
        this.alias = inMatch[1].trim();
      }
      this.expression = inMatch[2];
    }

    if (!this.alias) {
      'development' !== 'production' && warn('Invalid v-for expression "' + this.descriptor.raw + '": ' + 'alias is required.', this.vm);
      return;
    }

    // uid as a cache identifier
    this.id = '__v-for__' + ++uid$3;

    // check if this is an option list,
    // so that we know if we need to update the <select>'s
    // v-model when the option list has changed.
    // because v-model has a lower priority than v-for,
    // the v-model is not bound here yet, so we have to
    // retrive it in the actual updateModel() function.
    var tag = this.el.tagName;
    this.isOption = (tag === 'OPTION' || tag === 'OPTGROUP') && this.el.parentNode.tagName === 'SELECT';

    // setup anchor nodes
    this.start = createAnchor('v-for-start');
    this.end = createAnchor('v-for-end');
    replace(this.el, this.end);
    before(this.start, this.end);

    // cache
    this.cache = Object.create(null);

    // fragment factory
    this.factory = new FragmentFactory(this.vm, this.el);
  },

  update: function update(data) {
    this.diff(data);
    this.updateRef();
    this.updateModel();
  },

  /**
   * Diff, based on new data and old data, determine the
   * minimum amount of DOM manipulations needed to make the
   * DOM reflect the new data Array.
   *
   * The algorithm diffs the new data Array by storing a
   * hidden reference to an owner vm instance on previously
   * seen data. This allows us to achieve O(n) which is
   * better than a levenshtein distance based algorithm,
   * which is O(m * n).
   *
   * @param {Array} data
   */

  diff: function diff(data) {
    // check if the Array was converted from an Object
    var item = data[0];
    var convertedFromObject = this.fromObject = isObject(item) && hasOwn(item, '$key') && hasOwn(item, '$value');

    var trackByKey = this.params.trackBy;
    var oldFrags = this.frags;
    var frags = this.frags = new Array(data.length);
    var alias = this.alias;
    var iterator = this.iterator;
    var start = this.start;
    var end = this.end;
    var inDocument = inDoc(start);
    var init = !oldFrags;
    var i, l, frag, key, value, primitive;

    // First pass, go through the new Array and fill up
    // the new frags array. If a piece of data has a cached
    // instance for it, we reuse it. Otherwise build a new
    // instance.
    for (i = 0, l = data.length; i < l; i++) {
      item = data[i];
      key = convertedFromObject ? item.$key : null;
      value = convertedFromObject ? item.$value : item;
      primitive = !isObject(value);
      frag = !init && this.getCachedFrag(value, i, key);
      if (frag) {
        // reusable fragment
        frag.reused = true;
        // update $index
        frag.scope.$index = i;
        // update $key
        if (key) {
          frag.scope.$key = key;
        }
        // update iterator
        if (iterator) {
          frag.scope[iterator] = key !== null ? key : i;
        }
        // update data for track-by, object repeat &
        // primitive values.
        if (trackByKey || convertedFromObject || primitive) {
          withoutConversion(function () {
            frag.scope[alias] = value;
          });
        }
      } else {
        // new instance
        frag = this.create(value, alias, i, key);
        frag.fresh = !init;
      }
      frags[i] = frag;
      if (init) {
        frag.before(end);
      }
    }

    // we're done for the initial render.
    if (init) {
      return;
    }

    // Second pass, go through the old fragments and
    // destroy those who are not reused (and remove them
    // from cache)
    var removalIndex = 0;
    var totalRemoved = oldFrags.length - frags.length;
    // when removing a large number of fragments, watcher removal
    // turns out to be a perf bottleneck, so we batch the watcher
    // removals into a single filter call!
    this.vm._vForRemoving = true;
    for (i = 0, l = oldFrags.length; i < l; i++) {
      frag = oldFrags[i];
      if (!frag.reused) {
        this.deleteCachedFrag(frag);
        this.remove(frag, removalIndex++, totalRemoved, inDocument);
      }
    }
    this.vm._vForRemoving = false;
    if (removalIndex) {
      this.vm._watchers = this.vm._watchers.filter(function (w) {
        return w.active;
      });
    }

    // Final pass, move/insert new fragments into the
    // right place.
    var targetPrev, prevEl, currentPrev;
    var insertionIndex = 0;
    for (i = 0, l = frags.length; i < l; i++) {
      frag = frags[i];
      // this is the frag that we should be after
      targetPrev = frags[i - 1];
      prevEl = targetPrev ? targetPrev.staggerCb ? targetPrev.staggerAnchor : targetPrev.end || targetPrev.node : start;
      if (frag.reused && !frag.staggerCb) {
        currentPrev = findPrevFrag(frag, start, this.id);
        if (currentPrev !== targetPrev && (!currentPrev ||
        // optimization for moving a single item.
        // thanks to suggestions by @livoras in #1807
        findPrevFrag(currentPrev, start, this.id) !== targetPrev)) {
          this.move(frag, prevEl);
        }
      } else {
        // new instance, or still in stagger.
        // insert with updated stagger index.
        this.insert(frag, insertionIndex++, prevEl, inDocument);
      }
      frag.reused = frag.fresh = false;
    }
  },

  /**
   * Create a new fragment instance.
   *
   * @param {*} value
   * @param {String} alias
   * @param {Number} index
   * @param {String} [key]
   * @return {Fragment}
   */

  create: function create(value, alias, index, key) {
    var host = this._host;
    // create iteration scope
    var parentScope = this._scope || this.vm;
    var scope = Object.create(parentScope);
    // ref holder for the scope
    scope.$refs = Object.create(parentScope.$refs);
    scope.$els = Object.create(parentScope.$els);
    // make sure point $parent to parent scope
    scope.$parent = parentScope;
    // for two-way binding on alias
    scope.$forContext = this;
    // define scope properties
    // important: define the scope alias without forced conversion
    // so that frozen data structures remain non-reactive.
    withoutConversion(function () {
      defineReactive(scope, alias, value);
    });
    defineReactive(scope, '$index', index);
    if (key) {
      defineReactive(scope, '$key', key);
    } else if (scope.$key) {
      // avoid accidental fallback
      def(scope, '$key', null);
    }
    if (this.iterator) {
      defineReactive(scope, this.iterator, key !== null ? key : index);
    }
    var frag = this.factory.create(host, scope, this._frag);
    frag.forId = this.id;
    this.cacheFrag(value, frag, index, key);
    return frag;
  },

  /**
   * Update the v-ref on owner vm.
   */

  updateRef: function updateRef() {
    var ref = this.descriptor.ref;
    if (!ref) return;
    var hash = (this._scope || this.vm).$refs;
    var refs;
    if (!this.fromObject) {
      refs = this.frags.map(findVmFromFrag);
    } else {
      refs = {};
      this.frags.forEach(function (frag) {
        refs[frag.scope.$key] = findVmFromFrag(frag);
      });
    }
    hash[ref] = refs;
  },

  /**
   * For option lists, update the containing v-model on
   * parent <select>.
   */

  updateModel: function updateModel() {
    if (this.isOption) {
      var parent = this.start.parentNode;
      var model = parent && parent.__v_model;
      if (model) {
        model.forceUpdate();
      }
    }
  },

  /**
   * Insert a fragment. Handles staggering.
   *
   * @param {Fragment} frag
   * @param {Number} index
   * @param {Node} prevEl
   * @param {Boolean} inDocument
   */

  insert: function insert(frag, index, prevEl, inDocument) {
    if (frag.staggerCb) {
      frag.staggerCb.cancel();
      frag.staggerCb = null;
    }
    var staggerAmount = this.getStagger(frag, index, null, 'enter');
    if (inDocument && staggerAmount) {
      // create an anchor and insert it synchronously,
      // so that we can resolve the correct order without
      // worrying about some elements not inserted yet
      var anchor = frag.staggerAnchor;
      if (!anchor) {
        anchor = frag.staggerAnchor = createAnchor('stagger-anchor');
        anchor.__v_frag = frag;
      }
      after(anchor, prevEl);
      var op = frag.staggerCb = cancellable(function () {
        frag.staggerCb = null;
        frag.before(anchor);
        remove(anchor);
      });
      setTimeout(op, staggerAmount);
    } else {
      var target = prevEl.nextSibling;
      /* istanbul ignore if */
      if (!target) {
        // reset end anchor position in case the position was messed up
        // by an external drag-n-drop library.
        after(this.end, prevEl);
        target = this.end;
      }
      frag.before(target);
    }
  },

  /**
   * Remove a fragment. Handles staggering.
   *
   * @param {Fragment} frag
   * @param {Number} index
   * @param {Number} total
   * @param {Boolean} inDocument
   */

  remove: function remove(frag, index, total, inDocument) {
    if (frag.staggerCb) {
      frag.staggerCb.cancel();
      frag.staggerCb = null;
      // it's not possible for the same frag to be removed
      // twice, so if we have a pending stagger callback,
      // it means this frag is queued for enter but removed
      // before its transition started. Since it is already
      // destroyed, we can just leave it in detached state.
      return;
    }
    var staggerAmount = this.getStagger(frag, index, total, 'leave');
    if (inDocument && staggerAmount) {
      var op = frag.staggerCb = cancellable(function () {
        frag.staggerCb = null;
        frag.remove();
      });
      setTimeout(op, staggerAmount);
    } else {
      frag.remove();
    }
  },

  /**
   * Move a fragment to a new position.
   * Force no transition.
   *
   * @param {Fragment} frag
   * @param {Node} prevEl
   */

  move: function move(frag, prevEl) {
    // fix a common issue with Sortable:
    // if prevEl doesn't have nextSibling, this means it's
    // been dragged after the end anchor. Just re-position
    // the end anchor to the end of the container.
    /* istanbul ignore if */
    if (!prevEl.nextSibling) {
      this.end.parentNode.appendChild(this.end);
    }
    frag.before(prevEl.nextSibling, false);
  },

  /**
   * Cache a fragment using track-by or the object key.
   *
   * @param {*} value
   * @param {Fragment} frag
   * @param {Number} index
   * @param {String} [key]
   */

  cacheFrag: function cacheFrag(value, frag, index, key) {
    var trackByKey = this.params.trackBy;
    var cache = this.cache;
    var primitive = !isObject(value);
    var id;
    if (key || trackByKey || primitive) {
      id = getTrackByKey(index, key, value, trackByKey);
      if (!cache[id]) {
        cache[id] = frag;
      } else if (trackByKey !== '$index') {
        'development' !== 'production' && this.warnDuplicate(value);
      }
    } else {
      id = this.id;
      if (hasOwn(value, id)) {
        if (value[id] === null) {
          value[id] = frag;
        } else {
          'development' !== 'production' && this.warnDuplicate(value);
        }
      } else if (Object.isExtensible(value)) {
        def(value, id, frag);
      } else if ('development' !== 'production') {
        warn('Frozen v-for objects cannot be automatically tracked, make sure to ' + 'provide a track-by key.');
      }
    }
    frag.raw = value;
  },

  /**
   * Get a cached fragment from the value/index/key
   *
   * @param {*} value
   * @param {Number} index
   * @param {String} key
   * @return {Fragment}
   */

  getCachedFrag: function getCachedFrag(value, index, key) {
    var trackByKey = this.params.trackBy;
    var primitive = !isObject(value);
    var frag;
    if (key || trackByKey || primitive) {
      var id = getTrackByKey(index, key, value, trackByKey);
      frag = this.cache[id];
    } else {
      frag = value[this.id];
    }
    if (frag && (frag.reused || frag.fresh)) {
      'development' !== 'production' && this.warnDuplicate(value);
    }
    return frag;
  },

  /**
   * Delete a fragment from cache.
   *
   * @param {Fragment} frag
   */

  deleteCachedFrag: function deleteCachedFrag(frag) {
    var value = frag.raw;
    var trackByKey = this.params.trackBy;
    var scope = frag.scope;
    var index = scope.$index;
    // fix #948: avoid accidentally fall through to
    // a parent repeater which happens to have $key.
    var key = hasOwn(scope, '$key') && scope.$key;
    var primitive = !isObject(value);
    if (trackByKey || key || primitive) {
      var id = getTrackByKey(index, key, value, trackByKey);
      this.cache[id] = null;
    } else {
      value[this.id] = null;
      frag.raw = null;
    }
  },

  /**
   * Get the stagger amount for an insertion/removal.
   *
   * @param {Fragment} frag
   * @param {Number} index
   * @param {Number} total
   * @param {String} type
   */

  getStagger: function getStagger(frag, index, total, type) {
    type = type + 'Stagger';
    var trans = frag.node.__v_trans;
    var hooks = trans && trans.hooks;
    var hook = hooks && (hooks[type] || hooks.stagger);
    return hook ? hook.call(frag, index, total) : index * parseInt(this.params[type] || this.params.stagger, 10);
  },

  /**
   * Pre-process the value before piping it through the
   * filters. This is passed to and called by the watcher.
   */

  _preProcess: function _preProcess(value) {
    // regardless of type, store the un-filtered raw value.
    this.rawValue = value;
    return value;
  },

  /**
   * Post-process the value after it has been piped through
   * the filters. This is passed to and called by the watcher.
   *
   * It is necessary for this to be called during the
   * watcher's dependency collection phase because we want
   * the v-for to update when the source Object is mutated.
   */

  _postProcess: function _postProcess(value) {
    if (isArray(value)) {
      return value;
    } else if (isPlainObject(value)) {
      // convert plain object to array.
      var keys = Object.keys(value);
      var i = keys.length;
      var res = new Array(i);
      var key;
      while (i--) {
        key = keys[i];
        res[i] = {
          $key: key,
          $value: value[key]
        };
      }
      return res;
    } else {
      if (typeof value === 'number' && !isNaN(value)) {
        value = range(value);
      }
      return value || [];
    }
  },

  unbind: function unbind() {
    if (this.descriptor.ref) {
      (this._scope || this.vm).$refs[this.descriptor.ref] = null;
    }
    if (this.frags) {
      var i = this.frags.length;
      var frag;
      while (i--) {
        frag = this.frags[i];
        this.deleteCachedFrag(frag);
        frag.destroy();
      }
    }
  }
};

/**
 * Helper to find the previous element that is a fragment
 * anchor. This is necessary because a destroyed frag's
 * element could still be lingering in the DOM before its
 * leaving transition finishes, but its inserted flag
 * should have been set to false so we can skip them.
 *
 * If this is a block repeat, we want to make sure we only
 * return frag that is bound to this v-for. (see #929)
 *
 * @param {Fragment} frag
 * @param {Comment|Text} anchor
 * @param {String} id
 * @return {Fragment}
 */

function findPrevFrag(frag, anchor, id) {
  var el = frag.node.previousSibling;
  /* istanbul ignore if */
  if (!el) return;
  frag = el.__v_frag;
  while ((!frag || frag.forId !== id || !frag.inserted) && el !== anchor) {
    el = el.previousSibling;
    /* istanbul ignore if */
    if (!el) return;
    frag = el.__v_frag;
  }
  return frag;
}

/**
 * Create a range array from given number.
 *
 * @param {Number} n
 * @return {Array}
 */

function range(n) {
  var i = -1;
  var ret = new Array(Math.floor(n));
  while (++i < n) {
    ret[i] = i;
  }
  return ret;
}

/**
 * Get the track by key for an item.
 *
 * @param {Number} index
 * @param {String} key
 * @param {*} value
 * @param {String} [trackByKey]
 */

function getTrackByKey(index, key, value, trackByKey) {
  return trackByKey ? trackByKey === '$index' ? index : trackByKey.charAt(0).match(/\w/) ? getPath(value, trackByKey) : value[trackByKey] : key || value;
}

if ('development' !== 'production') {
  vFor.warnDuplicate = function (value) {
    warn('Duplicate value found in v-for="' + this.descriptor.raw + '": ' + JSON.stringify(value) + '. Use track-by="$index" if ' + 'you are expecting duplicate values.', this.vm);
  };
}

/**
 * Find a vm from a fragment.
 *
 * @param {Fragment} frag
 * @return {Vue|undefined}
 */

function findVmFromFrag(frag) {
  var node = frag.node;
  // handle multi-node frag
  if (frag.end) {
    while (!node.__vue__ && node !== frag.end && node.nextSibling) {
      node = node.nextSibling;
    }
  }
  return node.__vue__;
}

var vIf = {

  priority: IF,
  terminal: true,

  bind: function bind() {
    var el = this.el;
    if (!el.__vue__) {
      // check else block
      var next = el.nextElementSibling;
      if (next && getAttr(next, 'v-else') !== null) {
        remove(next);
        this.elseEl = next;
      }
      // check main block
      this.anchor = createAnchor('v-if');
      replace(el, this.anchor);
    } else {
      'development' !== 'production' && warn('v-if="' + this.expression + '" cannot be ' + 'used on an instance root element.', this.vm);
      this.invalid = true;
    }
  },

  update: function update(value) {
    if (this.invalid) return;
    if (value) {
      if (!this.frag) {
        this.insert();
      }
    } else {
      this.remove();
    }
  },

  insert: function insert() {
    if (this.elseFrag) {
      this.elseFrag.remove();
      this.elseFrag = null;
    }
    // lazy init factory
    if (!this.factory) {
      this.factory = new FragmentFactory(this.vm, this.el);
    }
    this.frag = this.factory.create(this._host, this._scope, this._frag);
    this.frag.before(this.anchor);
  },

  remove: function remove() {
    if (this.frag) {
      this.frag.remove();
      this.frag = null;
    }
    if (this.elseEl && !this.elseFrag) {
      if (!this.elseFactory) {
        this.elseFactory = new FragmentFactory(this.elseEl._context || this.vm, this.elseEl);
      }
      this.elseFrag = this.elseFactory.create(this._host, this._scope, this._frag);
      this.elseFrag.before(this.anchor);
    }
  },

  unbind: function unbind() {
    if (this.frag) {
      this.frag.destroy();
    }
    if (this.elseFrag) {
      this.elseFrag.destroy();
    }
  }
};

var show = {

  bind: function bind() {
    // check else block
    var next = this.el.nextElementSibling;
    if (next && getAttr(next, 'v-else') !== null) {
      this.elseEl = next;
    }
  },

  update: function update(value) {
    this.apply(this.el, value);
    if (this.elseEl) {
      this.apply(this.elseEl, !value);
    }
  },

  apply: function apply(el, value) {
    if (inDoc(el)) {
      applyTransition(el, value ? 1 : -1, toggle, this.vm);
    } else {
      toggle();
    }
    function toggle() {
      el.style.display = value ? '' : 'none';
    }
  }
};

var text$2 = {

  bind: function bind() {
    var self = this;
    var el = this.el;
    var isRange = el.type === 'range';
    var lazy = this.params.lazy;
    var number = this.params.number;
    var debounce = this.params.debounce;

    // handle composition events.
    //   http://blog.evanyou.me/2014/01/03/composition-event/
    // skip this for Android because it handles composition
    // events quite differently. Android doesn't trigger
    // composition events for language input methods e.g.
    // Chinese, but instead triggers them for spelling
    // suggestions... (see Discussion/#162)
    var composing = false;
    if (!isAndroid && !isRange) {
      this.on('compositionstart', function () {
        composing = true;
      });
      this.on('compositionend', function () {
        composing = false;
        // in IE11 the "compositionend" event fires AFTER
        // the "input" event, so the input handler is blocked
        // at the end... have to call it here.
        //
        // #1327: in lazy mode this is unecessary.
        if (!lazy) {
          self.listener();
        }
      });
    }

    // prevent messing with the input when user is typing,
    // and force update on blur.
    this.focused = false;
    if (!isRange && !lazy) {
      this.on('focus', function () {
        self.focused = true;
      });
      this.on('blur', function () {
        self.focused = false;
        // do not sync value after fragment removal (#2017)
        if (!self._frag || self._frag.inserted) {
          self.rawListener();
        }
      });
    }

    // Now attach the main listener
    this.listener = this.rawListener = function () {
      if (composing || !self._bound) {
        return;
      }
      var val = number || isRange ? toNumber(el.value) : el.value;
      self.set(val);
      // force update on next tick to avoid lock & same value
      // also only update when user is not typing
      nextTick(function () {
        if (self._bound && !self.focused) {
          self.update(self._watcher.value);
        }
      });
    };

    // apply debounce
    if (debounce) {
      this.listener = _debounce(this.listener, debounce);
    }

    // Support jQuery events, since jQuery.trigger() doesn't
    // trigger native events in some cases and some plugins
    // rely on $.trigger()
    //
    // We want to make sure if a listener is attached using
    // jQuery, it is also removed with jQuery, that's why
    // we do the check for each directive instance and
    // store that check result on itself. This also allows
    // easier test coverage control by unsetting the global
    // jQuery variable in tests.
    this.hasjQuery = typeof jQuery === 'function';
    if (this.hasjQuery) {
      var method = jQuery.fn.on ? 'on' : 'bind';
      jQuery(el)[method]('change', this.rawListener);
      if (!lazy) {
        jQuery(el)[method]('input', this.listener);
      }
    } else {
      this.on('change', this.rawListener);
      if (!lazy) {
        this.on('input', this.listener);
      }
    }

    // IE9 doesn't fire input event on backspace/del/cut
    if (!lazy && isIE9) {
      this.on('cut', function () {
        nextTick(self.listener);
      });
      this.on('keyup', function (e) {
        if (e.keyCode === 46 || e.keyCode === 8) {
          self.listener();
        }
      });
    }

    // set initial value if present
    if (el.hasAttribute('value') || el.tagName === 'TEXTAREA' && el.value.trim()) {
      this.afterBind = this.listener;
    }
  },

  update: function update(value) {
    // #3029 only update when the value changes. This prevent
    // browsers from overwriting values like selectionStart
    value = _toString(value);
    if (value !== this.el.value) this.el.value = value;
  },

  unbind: function unbind() {
    var el = this.el;
    if (this.hasjQuery) {
      var method = jQuery.fn.off ? 'off' : 'unbind';
      jQuery(el)[method]('change', this.listener);
      jQuery(el)[method]('input', this.listener);
    }
  }
};

var radio = {

  bind: function bind() {
    var self = this;
    var el = this.el;

    this.getValue = function () {
      // value overwrite via v-bind:value
      if (el.hasOwnProperty('_value')) {
        return el._value;
      }
      var val = el.value;
      if (self.params.number) {
        val = toNumber(val);
      }
      return val;
    };

    this.listener = function () {
      self.set(self.getValue());
    };
    this.on('change', this.listener);

    if (el.hasAttribute('checked')) {
      this.afterBind = this.listener;
    }
  },

  update: function update(value) {
    this.el.checked = looseEqual(value, this.getValue());
  }
};

var select = {

  bind: function bind() {
    var _this = this;

    var self = this;
    var el = this.el;

    // method to force update DOM using latest value.
    this.forceUpdate = function () {
      if (self._watcher) {
        self.update(self._watcher.get());
      }
    };

    // check if this is a multiple select
    var multiple = this.multiple = el.hasAttribute('multiple');

    // attach listener
    this.listener = function () {
      var value = getValue(el, multiple);
      value = self.params.number ? isArray(value) ? value.map(toNumber) : toNumber(value) : value;
      self.set(value);
    };
    this.on('change', this.listener);

    // if has initial value, set afterBind
    var initValue = getValue(el, multiple, true);
    if (multiple && initValue.length || !multiple && initValue !== null) {
      this.afterBind = this.listener;
    }

    // All major browsers except Firefox resets
    // selectedIndex with value -1 to 0 when the element
    // is appended to a new parent, therefore we have to
    // force a DOM update whenever that happens...
    this.vm.$on('hook:attached', function () {
      nextTick(_this.forceUpdate);
    });
    if (!inDoc(el)) {
      nextTick(this.forceUpdate);
    }
  },

  update: function update(value) {
    var el = this.el;
    el.selectedIndex = -1;
    var multi = this.multiple && isArray(value);
    var options = el.options;
    var i = options.length;
    var op, val;
    while (i--) {
      op = options[i];
      val = op.hasOwnProperty('_value') ? op._value : op.value;
      /* eslint-disable eqeqeq */
      op.selected = multi ? indexOf$1(value, val) > -1 : looseEqual(value, val);
      /* eslint-enable eqeqeq */
    }
  },

  unbind: function unbind() {
    /* istanbul ignore next */
    this.vm.$off('hook:attached', this.forceUpdate);
  }
};

/**
 * Get select value
 *
 * @param {SelectElement} el
 * @param {Boolean} multi
 * @param {Boolean} init
 * @return {Array|*}
 */

function getValue(el, multi, init) {
  var res = multi ? [] : null;
  var op, val, selected;
  for (var i = 0, l = el.options.length; i < l; i++) {
    op = el.options[i];
    selected = init ? op.hasAttribute('selected') : op.selected;
    if (selected) {
      val = op.hasOwnProperty('_value') ? op._value : op.value;
      if (multi) {
        res.push(val);
      } else {
        return val;
      }
    }
  }
  return res;
}

/**
 * Native Array.indexOf uses strict equal, but in this
 * case we need to match string/numbers with custom equal.
 *
 * @param {Array} arr
 * @param {*} val
 */

function indexOf$1(arr, val) {
  var i = arr.length;
  while (i--) {
    if (looseEqual(arr[i], val)) {
      return i;
    }
  }
  return -1;
}

var checkbox = {

  bind: function bind() {
    var self = this;
    var el = this.el;

    this.getValue = function () {
      return el.hasOwnProperty('_value') ? el._value : self.params.number ? toNumber(el.value) : el.value;
    };

    function getBooleanValue() {
      var val = el.checked;
      if (val && el.hasOwnProperty('_trueValue')) {
        return el._trueValue;
      }
      if (!val && el.hasOwnProperty('_falseValue')) {
        return el._falseValue;
      }
      return val;
    }

    this.listener = function () {
      var model = self._watcher.get();
      if (isArray(model)) {
        var val = self.getValue();
        var i = indexOf(model, val);
        if (el.checked) {
          if (i < 0) {
            self.set(model.concat(val));
          }
        } else if (i > -1) {
          self.set(model.slice(0, i).concat(model.slice(i + 1)));
        }
      } else {
        self.set(getBooleanValue());
      }
    };

    this.on('change', this.listener);
    if (el.hasAttribute('checked')) {
      this.afterBind = this.listener;
    }
  },

  update: function update(value) {
    var el = this.el;
    if (isArray(value)) {
      el.checked = indexOf(value, this.getValue()) > -1;
    } else {
      if (el.hasOwnProperty('_trueValue')) {
        el.checked = looseEqual(value, el._trueValue);
      } else {
        el.checked = !!value;
      }
    }
  }
};

var handlers = {
  text: text$2,
  radio: radio,
  select: select,
  checkbox: checkbox
};

var model = {

  priority: MODEL,
  twoWay: true,
  handlers: handlers,
  params: ['lazy', 'number', 'debounce'],

  /**
   * Possible elements:
   *   <select>
   *   <textarea>
   *   <input type="*">
   *     - text
   *     - checkbox
   *     - radio
   *     - number
   */

  bind: function bind() {
    // friendly warning...
    this.checkFilters();
    if (this.hasRead && !this.hasWrite) {
      'development' !== 'production' && warn('It seems you are using a read-only filter with ' + 'v-model="' + this.descriptor.raw + '". ' + 'You might want to use a two-way filter to ensure correct behavior.', this.vm);
    }
    var el = this.el;
    var tag = el.tagName;
    var handler;
    if (tag === 'INPUT') {
      handler = handlers[el.type] || handlers.text;
    } else if (tag === 'SELECT') {
      handler = handlers.select;
    } else if (tag === 'TEXTAREA') {
      handler = handlers.text;
    } else {
      'development' !== 'production' && warn('v-model does not support element type: ' + tag, this.vm);
      return;
    }
    el.__v_model = this;
    handler.bind.call(this);
    this.update = handler.update;
    this._unbind = handler.unbind;
  },

  /**
   * Check read/write filter stats.
   */

  checkFilters: function checkFilters() {
    var filters = this.filters;
    if (!filters) return;
    var i = filters.length;
    while (i--) {
      var filter = resolveAsset(this.vm.$options, 'filters', filters[i].name);
      if (typeof filter === 'function' || filter.read) {
        this.hasRead = true;
      }
      if (filter.write) {
        this.hasWrite = true;
      }
    }
  },

  unbind: function unbind() {
    this.el.__v_model = null;
    this._unbind && this._unbind();
  }
};

// keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  'delete': [8, 46],
  up: 38,
  left: 37,
  right: 39,
  down: 40
};

function keyFilter(handler, keys) {
  var codes = keys.map(function (key) {
    var charCode = key.charCodeAt(0);
    if (charCode > 47 && charCode < 58) {
      return parseInt(key, 10);
    }
    if (key.length === 1) {
      charCode = key.toUpperCase().charCodeAt(0);
      if (charCode > 64 && charCode < 91) {
        return charCode;
      }
    }
    return keyCodes[key];
  });
  codes = [].concat.apply([], codes);
  return function keyHandler(e) {
    if (codes.indexOf(e.keyCode) > -1) {
      return handler.call(this, e);
    }
  };
}

function stopFilter(handler) {
  return function stopHandler(e) {
    e.stopPropagation();
    return handler.call(this, e);
  };
}

function preventFilter(handler) {
  return function preventHandler(e) {
    e.preventDefault();
    return handler.call(this, e);
  };
}

function selfFilter(handler) {
  return function selfHandler(e) {
    if (e.target === e.currentTarget) {
      return handler.call(this, e);
    }
  };
}

var on$1 = {

  priority: ON,
  acceptStatement: true,
  keyCodes: keyCodes,

  bind: function bind() {
    // deal with iframes
    if (this.el.tagName === 'IFRAME' && this.arg !== 'load') {
      var self = this;
      this.iframeBind = function () {
        on(self.el.contentWindow, self.arg, self.handler, self.modifiers.capture);
      };
      this.on('load', this.iframeBind);
    }
  },

  update: function update(handler) {
    // stub a noop for v-on with no value,
    // e.g. @mousedown.prevent
    if (!this.descriptor.raw) {
      handler = function () {};
    }

    if (typeof handler !== 'function') {
      'development' !== 'production' && warn('v-on:' + this.arg + '="' + this.expression + '" expects a function value, ' + 'got ' + handler, this.vm);
      return;
    }

    // apply modifiers
    if (this.modifiers.stop) {
      handler = stopFilter(handler);
    }
    if (this.modifiers.prevent) {
      handler = preventFilter(handler);
    }
    if (this.modifiers.self) {
      handler = selfFilter(handler);
    }
    // key filter
    var keys = Object.keys(this.modifiers).filter(function (key) {
      return key !== 'stop' && key !== 'prevent' && key !== 'self' && key !== 'capture';
    });
    if (keys.length) {
      handler = keyFilter(handler, keys);
    }

    this.reset();
    this.handler = handler;

    if (this.iframeBind) {
      this.iframeBind();
    } else {
      on(this.el, this.arg, this.handler, this.modifiers.capture);
    }
  },

  reset: function reset() {
    var el = this.iframeBind ? this.el.contentWindow : this.el;
    if (this.handler) {
      off(el, this.arg, this.handler);
    }
  },

  unbind: function unbind() {
    this.reset();
  }
};

var prefixes = ['-webkit-', '-moz-', '-ms-'];
var camelPrefixes = ['Webkit', 'Moz', 'ms'];
var importantRE = /!important;?$/;
var propCache = Object.create(null);

var testEl = null;

var style = {

  deep: true,

  update: function update(value) {
    if (typeof value === 'string') {
      this.el.style.cssText = value;
    } else if (isArray(value)) {
      this.handleObject(value.reduce(extend, {}));
    } else {
      this.handleObject(value || {});
    }
  },

  handleObject: function handleObject(value) {
    // cache object styles so that only changed props
    // are actually updated.
    var cache = this.cache || (this.cache = {});
    var name, val;
    for (name in cache) {
      if (!(name in value)) {
        this.handleSingle(name, null);
        delete cache[name];
      }
    }
    for (name in value) {
      val = value[name];
      if (val !== cache[name]) {
        cache[name] = val;
        this.handleSingle(name, val);
      }
    }
  },

  handleSingle: function handleSingle(prop, value) {
    prop = normalize(prop);
    if (!prop) return; // unsupported prop
    // cast possible numbers/booleans into strings
    if (value != null) value += '';
    if (value) {
      var isImportant = importantRE.test(value) ? 'important' : '';
      if (isImportant) {
        /* istanbul ignore if */
        if ('development' !== 'production') {
          warn('It\'s probably a bad idea to use !important with inline rules. ' + 'This feature will be deprecated in a future version of Vue.');
        }
        value = value.replace(importantRE, '').trim();
        this.el.style.setProperty(prop.kebab, value, isImportant);
      } else {
        this.el.style[prop.camel] = value;
      }
    } else {
      this.el.style[prop.camel] = '';
    }
  }

};

/**
 * Normalize a CSS property name.
 * - cache result
 * - auto prefix
 * - camelCase -> dash-case
 *
 * @param {String} prop
 * @return {String}
 */

function normalize(prop) {
  if (propCache[prop]) {
    return propCache[prop];
  }
  var res = prefix(prop);
  propCache[prop] = propCache[res] = res;
  return res;
}

/**
 * Auto detect the appropriate prefix for a CSS property.
 * https://gist.github.com/paulirish/523692
 *
 * @param {String} prop
 * @return {String}
 */

function prefix(prop) {
  prop = hyphenate(prop);
  var camel = camelize(prop);
  var upper = camel.charAt(0).toUpperCase() + camel.slice(1);
  if (!testEl) {
    testEl = document.createElement('div');
  }
  var i = prefixes.length;
  var prefixed;
  if (camel !== 'filter' && camel in testEl.style) {
    return {
      kebab: prop,
      camel: camel
    };
  }
  while (i--) {
    prefixed = camelPrefixes[i] + upper;
    if (prefixed in testEl.style) {
      return {
        kebab: prefixes[i] + prop,
        camel: prefixed
      };
    }
  }
}

// xlink
var xlinkNS = 'http://www.w3.org/1999/xlink';
var xlinkRE = /^xlink:/;

// check for attributes that prohibit interpolations
var disallowedInterpAttrRE = /^v-|^:|^@|^(?:is|transition|transition-mode|debounce|track-by|stagger|enter-stagger|leave-stagger)$/;
// these attributes should also set their corresponding properties
// because they only affect the initial state of the element
var attrWithPropsRE = /^(?:value|checked|selected|muted)$/;
// these attributes expect enumrated values of "true" or "false"
// but are not boolean attributes
var enumeratedAttrRE = /^(?:draggable|contenteditable|spellcheck)$/;

// these attributes should set a hidden property for
// binding v-model to object values
var modelProps = {
  value: '_value',
  'true-value': '_trueValue',
  'false-value': '_falseValue'
};

var bind$1 = {

  priority: BIND,

  bind: function bind() {
    var attr = this.arg;
    var tag = this.el.tagName;
    // should be deep watch on object mode
    if (!attr) {
      this.deep = true;
    }
    // handle interpolation bindings
    var descriptor = this.descriptor;
    var tokens = descriptor.interp;
    if (tokens) {
      // handle interpolations with one-time tokens
      if (descriptor.hasOneTime) {
        this.expression = tokensToExp(tokens, this._scope || this.vm);
      }

      // only allow binding on native attributes
      if (disallowedInterpAttrRE.test(attr) || attr === 'name' && (tag === 'PARTIAL' || tag === 'SLOT')) {
        'development' !== 'production' && warn(attr + '="' + descriptor.raw + '": ' + 'attribute interpolation is not allowed in Vue.js ' + 'directives and special attributes.', this.vm);
        this.el.removeAttribute(attr);
        this.invalid = true;
      }

      /* istanbul ignore if */
      if ('development' !== 'production') {
        var raw = attr + '="' + descriptor.raw + '": ';
        // warn src
        if (attr === 'src') {
          warn(raw + 'interpolation in "src" attribute will cause ' + 'a 404 request. Use v-bind:src instead.', this.vm);
        }

        // warn style
        if (attr === 'style') {
          warn(raw + 'interpolation in "style" attribute will cause ' + 'the attribute to be discarded in Internet Explorer. ' + 'Use v-bind:style instead.', this.vm);
        }
      }
    }
  },

  update: function update(value) {
    if (this.invalid) {
      return;
    }
    var attr = this.arg;
    if (this.arg) {
      this.handleSingle(attr, value);
    } else {
      this.handleObject(value || {});
    }
  },

  // share object handler with v-bind:class
  handleObject: style.handleObject,

  handleSingle: function handleSingle(attr, value) {
    var el = this.el;
    var interp = this.descriptor.interp;
    if (this.modifiers.camel) {
      attr = camelize(attr);
    }
    if (!interp && attrWithPropsRE.test(attr) && attr in el) {
      var attrValue = attr === 'value' ? value == null // IE9 will set input.value to "null" for null...
      ? '' : value : value;

      if (el[attr] !== attrValue) {
        el[attr] = attrValue;
      }
    }
    // set model props
    var modelProp = modelProps[attr];
    if (!interp && modelProp) {
      el[modelProp] = value;
      // update v-model if present
      var model = el.__v_model;
      if (model) {
        model.listener();
      }
    }
    // do not set value attribute for textarea
    if (attr === 'value' && el.tagName === 'TEXTAREA') {
      el.removeAttribute(attr);
      return;
    }
    // update attribute
    if (enumeratedAttrRE.test(attr)) {
      el.setAttribute(attr, value ? 'true' : 'false');
    } else if (value != null && value !== false) {
      if (attr === 'class') {
        // handle edge case #1960:
        // class interpolation should not overwrite Vue transition class
        if (el.__v_trans) {
          value += ' ' + el.__v_trans.id + '-transition';
        }
        setClass(el, value);
      } else if (xlinkRE.test(attr)) {
        el.setAttributeNS(xlinkNS, attr, value === true ? '' : value);
      } else {
        el.setAttribute(attr, value === true ? '' : value);
      }
    } else {
      el.removeAttribute(attr);
    }
  }
};

var el = {

  priority: EL,

  bind: function bind() {
    /* istanbul ignore if */
    if (!this.arg) {
      return;
    }
    var id = this.id = camelize(this.arg);
    var refs = (this._scope || this.vm).$els;
    if (hasOwn(refs, id)) {
      refs[id] = this.el;
    } else {
      defineReactive(refs, id, this.el);
    }
  },

  unbind: function unbind() {
    var refs = (this._scope || this.vm).$els;
    if (refs[this.id] === this.el) {
      refs[this.id] = null;
    }
  }
};

var ref = {
  bind: function bind() {
    'development' !== 'production' && warn('v-ref:' + this.arg + ' must be used on a child ' + 'component. Found on <' + this.el.tagName.toLowerCase() + '>.', this.vm);
  }
};

var cloak = {
  bind: function bind() {
    var el = this.el;
    this.vm.$once('pre-hook:compiled', function () {
      el.removeAttribute('v-cloak');
    });
  }
};

// logic control
// two-way binding
// event handling
// attributes
// ref & el
// cloak
// must export plain object
var directives = {
  text: text$1,
  html: html,
  'for': vFor,
  'if': vIf,
  show: show,
  model: model,
  on: on$1,
  bind: bind$1,
  el: el,
  ref: ref,
  cloak: cloak
};

var vClass = {

  deep: true,

  update: function update(value) {
    if (!value) {
      this.cleanup();
    } else if (typeof value === 'string') {
      this.setClass(value.trim().split(/\s+/));
    } else {
      this.setClass(normalize$1(value));
    }
  },

  setClass: function setClass(value) {
    this.cleanup(value);
    for (var i = 0, l = value.length; i < l; i++) {
      var val = value[i];
      if (val) {
        apply(this.el, val, addClass);
      }
    }
    this.prevKeys = value;
  },

  cleanup: function cleanup(value) {
    var prevKeys = this.prevKeys;
    if (!prevKeys) return;
    var i = prevKeys.length;
    while (i--) {
      var key = prevKeys[i];
      if (!value || value.indexOf(key) < 0) {
        apply(this.el, key, removeClass);
      }
    }
  }
};

/**
 * Normalize objects and arrays (potentially containing objects)
 * into array of strings.
 *
 * @param {Object|Array<String|Object>} value
 * @return {Array<String>}
 */

function normalize$1(value) {
  var res = [];
  if (isArray(value)) {
    for (var i = 0, l = value.length; i < l; i++) {
      var _key = value[i];
      if (_key) {
        if (typeof _key === 'string') {
          res.push(_key);
        } else {
          for (var k in _key) {
            if (_key[k]) res.push(k);
          }
        }
      }
    }
  } else if (isObject(value)) {
    for (var key in value) {
      if (value[key]) res.push(key);
    }
  }
  return res;
}

/**
 * Add or remove a class/classes on an element
 *
 * @param {Element} el
 * @param {String} key The class name. This may or may not
 *                     contain a space character, in such a
 *                     case we'll deal with multiple class
 *                     names at once.
 * @param {Function} fn
 */

function apply(el, key, fn) {
  key = key.trim();
  if (key.indexOf(' ') === -1) {
    fn(el, key);
    return;
  }
  // The key contains one or more space characters.
  // Since a class name doesn't accept such characters, we
  // treat it as multiple classes.
  var keys = key.split(/\s+/);
  for (var i = 0, l = keys.length; i < l; i++) {
    fn(el, keys[i]);
  }
}

var component = {

  priority: COMPONENT,

  params: ['keep-alive', 'transition-mode', 'inline-template'],

  /**
   * Setup. Two possible usages:
   *
   * - static:
   *   <comp> or <div v-component="comp">
   *
   * - dynamic:
   *   <component :is="view">
   */

  bind: function bind() {
    if (!this.el.__vue__) {
      // keep-alive cache
      this.keepAlive = this.params.keepAlive;
      if (this.keepAlive) {
        this.cache = {};
      }
      // check inline-template
      if (this.params.inlineTemplate) {
        // extract inline template as a DocumentFragment
        this.inlineTemplate = extractContent(this.el, true);
      }
      // component resolution related state
      this.pendingComponentCb = this.Component = null;
      // transition related state
      this.pendingRemovals = 0;
      this.pendingRemovalCb = null;
      // create a ref anchor
      this.anchor = createAnchor('v-component');
      replace(this.el, this.anchor);
      // remove is attribute.
      // this is removed during compilation, but because compilation is
      // cached, when the component is used elsewhere this attribute
      // will remain at link time.
      this.el.removeAttribute('is');
      this.el.removeAttribute(':is');
      // remove ref, same as above
      if (this.descriptor.ref) {
        this.el.removeAttribute('v-ref:' + hyphenate(this.descriptor.ref));
      }
      // if static, build right now.
      if (this.literal) {
        this.setComponent(this.expression);
      }
    } else {
      'development' !== 'production' && warn('cannot mount component "' + this.expression + '" ' + 'on already mounted element: ' + this.el);
    }
  },

  /**
   * Public update, called by the watcher in the dynamic
   * literal scenario, e.g. <component :is="view">
   */

  update: function update(value) {
    if (!this.literal) {
      this.setComponent(value);
    }
  },

  /**
   * Switch dynamic components. May resolve the component
   * asynchronously, and perform transition based on
   * specified transition mode. Accepts a few additional
   * arguments specifically for vue-router.
   *
   * The callback is called when the full transition is
   * finished.
   *
   * @param {String} value
   * @param {Function} [cb]
   */

  setComponent: function setComponent(value, cb) {
    this.invalidatePending();
    if (!value) {
      // just remove current
      this.unbuild(true);
      this.remove(this.childVM, cb);
      this.childVM = null;
    } else {
      var self = this;
      this.resolveComponent(value, function () {
        self.mountComponent(cb);
      });
    }
  },

  /**
   * Resolve the component constructor to use when creating
   * the child vm.
   *
   * @param {String|Function} value
   * @param {Function} cb
   */

  resolveComponent: function resolveComponent(value, cb) {
    var self = this;
    this.pendingComponentCb = cancellable(function (Component) {
      self.ComponentName = Component.options.name || (typeof value === 'string' ? value : null);
      self.Component = Component;
      cb();
    });
    this.vm._resolveComponent(value, this.pendingComponentCb);
  },

  /**
   * Create a new instance using the current constructor and
   * replace the existing instance. This method doesn't care
   * whether the new component and the old one are actually
   * the same.
   *
   * @param {Function} [cb]
   */

  mountComponent: function mountComponent(cb) {
    // actual mount
    this.unbuild(true);
    var self = this;
    var activateHooks = this.Component.options.activate;
    var cached = this.getCached();
    var newComponent = this.build();
    if (activateHooks && !cached) {
      this.waitingFor = newComponent;
      callActivateHooks(activateHooks, newComponent, function () {
        if (self.waitingFor !== newComponent) {
          return;
        }
        self.waitingFor = null;
        self.transition(newComponent, cb);
      });
    } else {
      // update ref for kept-alive component
      if (cached) {
        newComponent._updateRef();
      }
      this.transition(newComponent, cb);
    }
  },

  /**
   * When the component changes or unbinds before an async
   * constructor is resolved, we need to invalidate its
   * pending callback.
   */

  invalidatePending: function invalidatePending() {
    if (this.pendingComponentCb) {
      this.pendingComponentCb.cancel();
      this.pendingComponentCb = null;
    }
  },

  /**
   * Instantiate/insert a new child vm.
   * If keep alive and has cached instance, insert that
   * instance; otherwise build a new one and cache it.
   *
   * @param {Object} [extraOptions]
   * @return {Vue} - the created instance
   */

  build: function build(extraOptions) {
    var cached = this.getCached();
    if (cached) {
      return cached;
    }
    if (this.Component) {
      // default options
      var options = {
        name: this.ComponentName,
        el: cloneNode(this.el),
        template: this.inlineTemplate,
        // make sure to add the child with correct parent
        // if this is a transcluded component, its parent
        // should be the transclusion host.
        parent: this._host || this.vm,
        // if no inline-template, then the compiled
        // linker can be cached for better performance.
        _linkerCachable: !this.inlineTemplate,
        _ref: this.descriptor.ref,
        _asComponent: true,
        _isRouterView: this._isRouterView,
        // if this is a transcluded component, context
        // will be the common parent vm of this instance
        // and its host.
        _context: this.vm,
        // if this is inside an inline v-for, the scope
        // will be the intermediate scope created for this
        // repeat fragment. this is used for linking props
        // and container directives.
        _scope: this._scope,
        // pass in the owner fragment of this component.
        // this is necessary so that the fragment can keep
        // track of its contained components in order to
        // call attach/detach hooks for them.
        _frag: this._frag
      };
      // extra options
      // in 1.0.0 this is used by vue-router only
      /* istanbul ignore if */
      if (extraOptions) {
        extend(options, extraOptions);
      }
      var child = new this.Component(options);
      if (this.keepAlive) {
        this.cache[this.Component.cid] = child;
      }
      /* istanbul ignore if */
      if ('development' !== 'production' && this.el.hasAttribute('transition') && child._isFragment) {
        warn('Transitions will not work on a fragment instance. ' + 'Template: ' + child.$options.template, child);
      }
      return child;
    }
  },

  /**
   * Try to get a cached instance of the current component.
   *
   * @return {Vue|undefined}
   */

  getCached: function getCached() {
    return this.keepAlive && this.cache[this.Component.cid];
  },

  /**
   * Teardown the current child, but defers cleanup so
   * that we can separate the destroy and removal steps.
   *
   * @param {Boolean} defer
   */

  unbuild: function unbuild(defer) {
    if (this.waitingFor) {
      if (!this.keepAlive) {
        this.waitingFor.$destroy();
      }
      this.waitingFor = null;
    }
    var child = this.childVM;
    if (!child || this.keepAlive) {
      if (child) {
        // remove ref
        child._inactive = true;
        child._updateRef(true);
      }
      return;
    }
    // the sole purpose of `deferCleanup` is so that we can
    // "deactivate" the vm right now and perform DOM removal
    // later.
    child.$destroy(false, defer);
  },

  /**
   * Remove current destroyed child and manually do
   * the cleanup after removal.
   *
   * @param {Function} cb
   */

  remove: function remove(child, cb) {
    var keepAlive = this.keepAlive;
    if (child) {
      // we may have a component switch when a previous
      // component is still being transitioned out.
      // we want to trigger only one lastest insertion cb
      // when the existing transition finishes. (#1119)
      this.pendingRemovals++;
      this.pendingRemovalCb = cb;
      var self = this;
      child.$remove(function () {
        self.pendingRemovals--;
        if (!keepAlive) child._cleanup();
        if (!self.pendingRemovals && self.pendingRemovalCb) {
          self.pendingRemovalCb();
          self.pendingRemovalCb = null;
        }
      });
    } else if (cb) {
      cb();
    }
  },

  /**
   * Actually swap the components, depending on the
   * transition mode. Defaults to simultaneous.
   *
   * @param {Vue} target
   * @param {Function} [cb]
   */

  transition: function transition(target, cb) {
    var self = this;
    var current = this.childVM;
    // for devtool inspection
    if (current) current._inactive = true;
    target._inactive = false;
    this.childVM = target;
    switch (self.params.transitionMode) {
      case 'in-out':
        target.$before(self.anchor, function () {
          self.remove(current, cb);
        });
        break;
      case 'out-in':
        self.remove(current, function () {
          target.$before(self.anchor, cb);
        });
        break;
      default:
        self.remove(current);
        target.$before(self.anchor, cb);
    }
  },

  /**
   * Unbind.
   */

  unbind: function unbind() {
    this.invalidatePending();
    // Do not defer cleanup when unbinding
    this.unbuild();
    // destroy all keep-alive cached instances
    if (this.cache) {
      for (var key in this.cache) {
        this.cache[key].$destroy();
      }
      this.cache = null;
    }
  }
};

/**
 * Call activate hooks in order (asynchronous)
 *
 * @param {Array} hooks
 * @param {Vue} vm
 * @param {Function} cb
 */

function callActivateHooks(hooks, vm, cb) {
  var total = hooks.length;
  var called = 0;
  hooks[0].call(vm, next);
  function next() {
    if (++called >= total) {
      cb();
    } else {
      hooks[called].call(vm, next);
    }
  }
}

var propBindingModes = config._propBindingModes;
var empty = {};

// regexes
var identRE$1 = /^[$_a-zA-Z]+[\w$]*$/;
var settablePathRE = /^[A-Za-z_$][\w$]*(\.[A-Za-z_$][\w$]*|\[[^\[\]]+\])*$/;

/**
 * Compile props on a root element and return
 * a props link function.
 *
 * @param {Element|DocumentFragment} el
 * @param {Array} propOptions
 * @param {Vue} vm
 * @return {Function} propsLinkFn
 */

function compileProps(el, propOptions, vm) {
  var props = [];
  var propsData = vm.$options.propsData;
  var names = Object.keys(propOptions);
  var i = names.length;
  var options, name, attr, value, path, parsed, prop;
  while (i--) {
    name = names[i];
    options = propOptions[name] || empty;

    if ('development' !== 'production' && name === '$data') {
      warn('Do not use $data as prop.', vm);
      continue;
    }

    // props could contain dashes, which will be
    // interpreted as minus calculations by the parser
    // so we need to camelize the path here
    path = camelize(name);
    if (!identRE$1.test(path)) {
      'development' !== 'production' && warn('Invalid prop key: "' + name + '". Prop keys ' + 'must be valid identifiers.', vm);
      continue;
    }

    prop = {
      name: name,
      path: path,
      options: options,
      mode: propBindingModes.ONE_WAY,
      raw: null
    };

    attr = hyphenate(name);
    // first check dynamic version
    if ((value = getBindAttr(el, attr)) === null) {
      if ((value = getBindAttr(el, attr + '.sync')) !== null) {
        prop.mode = propBindingModes.TWO_WAY;
      } else if ((value = getBindAttr(el, attr + '.once')) !== null) {
        prop.mode = propBindingModes.ONE_TIME;
      }
    }
    if (value !== null) {
      // has dynamic binding!
      prop.raw = value;
      parsed = parseDirective(value);
      value = parsed.expression;
      prop.filters = parsed.filters;
      // check binding type
      if (isLiteral(value) && !parsed.filters) {
        // for expressions containing literal numbers and
        // booleans, there's no need to setup a prop binding,
        // so we can optimize them as a one-time set.
        prop.optimizedLiteral = true;
      } else {
        prop.dynamic = true;
        // check non-settable path for two-way bindings
        if ('development' !== 'production' && prop.mode === propBindingModes.TWO_WAY && !settablePathRE.test(value)) {
          prop.mode = propBindingModes.ONE_WAY;
          warn('Cannot bind two-way prop with non-settable ' + 'parent path: ' + value, vm);
        }
      }
      prop.parentPath = value;

      // warn required two-way
      if ('development' !== 'production' && options.twoWay && prop.mode !== propBindingModes.TWO_WAY) {
        warn('Prop "' + name + '" expects a two-way binding type.', vm);
      }
    } else if ((value = getAttr(el, attr)) !== null) {
      // has literal binding!
      prop.raw = value;
    } else if (propsData && (value = propsData[name] || propsData[path]) !== null) {
      // has propsData
      prop.raw = value;
    } else if ('development' !== 'production') {
      // check possible camelCase prop usage
      var lowerCaseName = path.toLowerCase();
      value = /[A-Z\-]/.test(name) && (el.getAttribute(lowerCaseName) || el.getAttribute(':' + lowerCaseName) || el.getAttribute('v-bind:' + lowerCaseName) || el.getAttribute(':' + lowerCaseName + '.once') || el.getAttribute('v-bind:' + lowerCaseName + '.once') || el.getAttribute(':' + lowerCaseName + '.sync') || el.getAttribute('v-bind:' + lowerCaseName + '.sync'));
      if (value) {
        warn('Possible usage error for prop `' + lowerCaseName + '` - ' + 'did you mean `' + attr + '`? HTML is case-insensitive, remember to use ' + 'kebab-case for props in templates.', vm);
      } else if (options.required && (!propsData || !(name in propsData) && !(path in propsData))) {
        // warn missing required
        warn('Missing required prop: ' + name, vm);
      }
    }
    // push prop
    props.push(prop);
  }
  return makePropsLinkFn(props);
}

/**
 * Build a function that applies props to a vm.
 *
 * @param {Array} props
 * @return {Function} propsLinkFn
 */

function makePropsLinkFn(props) {
  return function propsLinkFn(vm, scope) {
    // store resolved props info
    vm._props = {};
    var inlineProps = vm.$options.propsData;
    var i = props.length;
    var prop, path, options, value, raw;
    while (i--) {
      prop = props[i];
      raw = prop.raw;
      path = prop.path;
      options = prop.options;
      vm._props[path] = prop;
      if (inlineProps && hasOwn(inlineProps, path)) {
        initProp(vm, prop, inlineProps[path]);
      }if (raw === null) {
        // initialize absent prop
        initProp(vm, prop, undefined);
      } else if (prop.dynamic) {
        // dynamic prop
        if (prop.mode === propBindingModes.ONE_TIME) {
          // one time binding
          value = (scope || vm._context || vm).$get(prop.parentPath);
          initProp(vm, prop, value);
        } else {
          if (vm._context) {
            // dynamic binding
            vm._bindDir({
              name: 'prop',
              def: propDef,
              prop: prop
            }, null, null, scope); // el, host, scope
          } else {
              // root instance
              initProp(vm, prop, vm.$get(prop.parentPath));
            }
        }
      } else if (prop.optimizedLiteral) {
        // optimized literal, cast it and just set once
        var stripped = stripQuotes(raw);
        value = stripped === raw ? toBoolean(toNumber(raw)) : stripped;
        initProp(vm, prop, value);
      } else {
        // string literal, but we need to cater for
        // Boolean props with no value, or with same
        // literal value (e.g. disabled="disabled")
        // see https://github.com/vuejs/vue-loader/issues/182
        value = options.type === Boolean && (raw === '' || raw === hyphenate(prop.name)) ? true : raw;
        initProp(vm, prop, value);
      }
    }
  };
}

/**
 * Process a prop with a rawValue, applying necessary coersions,
 * default values & assertions and call the given callback with
 * processed value.
 *
 * @param {Vue} vm
 * @param {Object} prop
 * @param {*} rawValue
 * @param {Function} fn
 */

function processPropValue(vm, prop, rawValue, fn) {
  var isSimple = prop.dynamic && isSimplePath(prop.parentPath);
  var value = rawValue;
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop);
  }
  value = coerceProp(prop, value, vm);
  var coerced = value !== rawValue;
  if (!assertProp(prop, value, vm)) {
    value = undefined;
  }
  if (isSimple && !coerced) {
    withoutConversion(function () {
      fn(value);
    });
  } else {
    fn(value);
  }
}

/**
 * Set a prop's initial value on a vm and its data object.
 *
 * @param {Vue} vm
 * @param {Object} prop
 * @param {*} value
 */

function initProp(vm, prop, value) {
  processPropValue(vm, prop, value, function (value) {
    defineReactive(vm, prop.path, value);
  });
}

/**
 * Update a prop's value on a vm.
 *
 * @param {Vue} vm
 * @param {Object} prop
 * @param {*} value
 */

function updateProp(vm, prop, value) {
  processPropValue(vm, prop, value, function (value) {
    vm[prop.path] = value;
  });
}

/**
 * Get the default value of a prop.
 *
 * @param {Vue} vm
 * @param {Object} prop
 * @return {*}
 */

function getPropDefaultValue(vm, prop) {
  // no default, return undefined
  var options = prop.options;
  if (!hasOwn(options, 'default')) {
    // absent boolean value defaults to false
    return options.type === Boolean ? false : undefined;
  }
  var def = options['default'];
  // warn against non-factory defaults for Object & Array
  if (isObject(def)) {
    'development' !== 'production' && warn('Invalid default value for prop "' + prop.name + '": ' + 'Props with type Object/Array must use a factory function ' + 'to return the default value.', vm);
  }
  // call factory function for non-Function types
  return typeof def === 'function' && options.type !== Function ? def.call(vm) : def;
}

/**
 * Assert whether a prop is valid.
 *
 * @param {Object} prop
 * @param {*} value
 * @param {Vue} vm
 */

function assertProp(prop, value, vm) {
  if (!prop.options.required && ( // non-required
  prop.raw === null || // abscent
  value == null) // null or undefined
  ) {
      return true;
    }
  var options = prop.options;
  var type = options.type;
  var valid = !type;
  var expectedTypes = [];
  if (type) {
    if (!isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType);
      valid = assertedType.valid;
    }
  }
  if (!valid) {
    if ('development' !== 'production') {
      warn('Invalid prop: type check failed for prop "' + prop.name + '".' + ' Expected ' + expectedTypes.map(formatType).join(', ') + ', got ' + formatValue(value) + '.', vm);
    }
    return false;
  }
  var validator = options.validator;
  if (validator) {
    if (!validator(value)) {
      'development' !== 'production' && warn('Invalid prop: custom validator check failed for prop "' + prop.name + '".', vm);
      return false;
    }
  }
  return true;
}

/**
 * Force parsing value with coerce option.
 *
 * @param {*} value
 * @param {Object} options
 * @return {*}
 */

function coerceProp(prop, value, vm) {
  var coerce = prop.options.coerce;
  if (!coerce) {
    return value;
  }
  if (typeof coerce === 'function') {
    return coerce(value);
  } else {
    'development' !== 'production' && warn('Invalid coerce for prop "' + prop.name + '": expected function, got ' + typeof coerce + '.', vm);
    return value;
  }
}

/**
 * Assert the type of a value
 *
 * @param {*} value
 * @param {Function} type
 * @return {Object}
 */

function assertType(value, type) {
  var valid;
  var expectedType;
  if (type === String) {
    expectedType = 'string';
    valid = typeof value === expectedType;
  } else if (type === Number) {
    expectedType = 'number';
    valid = typeof value === expectedType;
  } else if (type === Boolean) {
    expectedType = 'boolean';
    valid = typeof value === expectedType;
  } else if (type === Function) {
    expectedType = 'function';
    valid = typeof value === expectedType;
  } else if (type === Object) {
    expectedType = 'object';
    valid = isPlainObject(value);
  } else if (type === Array) {
    expectedType = 'array';
    valid = isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  };
}

/**
 * Format type for output
 *
 * @param {String} type
 * @return {String}
 */

function formatType(type) {
  return type ? type.charAt(0).toUpperCase() + type.slice(1) : 'custom type';
}

/**
 * Format value
 *
 * @param {*} value
 * @return {String}
 */

function formatValue(val) {
  return Object.prototype.toString.call(val).slice(8, -1);
}

var bindingModes = config._propBindingModes;

var propDef = {

  bind: function bind() {
    var child = this.vm;
    var parent = child._context;
    // passed in from compiler directly
    var prop = this.descriptor.prop;
    var childKey = prop.path;
    var parentKey = prop.parentPath;
    var twoWay = prop.mode === bindingModes.TWO_WAY;

    var parentWatcher = this.parentWatcher = new Watcher(parent, parentKey, function (val) {
      updateProp(child, prop, val);
    }, {
      twoWay: twoWay,
      filters: prop.filters,
      // important: props need to be observed on the
      // v-for scope if present
      scope: this._scope
    });

    // set the child initial value.
    initProp(child, prop, parentWatcher.value);

    // setup two-way binding
    if (twoWay) {
      // important: defer the child watcher creation until
      // the created hook (after data observation)
      var self = this;
      child.$once('pre-hook:created', function () {
        self.childWatcher = new Watcher(child, childKey, function (val) {
          parentWatcher.set(val);
        }, {
          // ensure sync upward before parent sync down.
          // this is necessary in cases e.g. the child
          // mutates a prop array, then replaces it. (#1683)
          sync: true
        });
      });
    }
  },

  unbind: function unbind() {
    this.parentWatcher.teardown();
    if (this.childWatcher) {
      this.childWatcher.teardown();
    }
  }
};

var queue$1 = [];
var queued = false;

/**
 * Push a job into the queue.
 *
 * @param {Function} job
 */

function pushJob(job) {
  queue$1.push(job);
  if (!queued) {
    queued = true;
    nextTick(flush);
  }
}

/**
 * Flush the queue, and do one forced reflow before
 * triggering transitions.
 */

function flush() {
  // Force layout
  var f = document.documentElement.offsetHeight;
  for (var i = 0; i < queue$1.length; i++) {
    queue$1[i]();
  }
  queue$1 = [];
  queued = false;
  // dummy return, so js linters don't complain about
  // unused variable f
  return f;
}

var TYPE_TRANSITION = 'transition';
var TYPE_ANIMATION = 'animation';
var transDurationProp = transitionProp + 'Duration';
var animDurationProp = animationProp + 'Duration';

/**
 * If a just-entered element is applied the
 * leave class while its enter transition hasn't started yet,
 * and the transitioned property has the same value for both
 * enter/leave, then the leave transition will be skipped and
 * the transitionend event never fires. This function ensures
 * its callback to be called after a transition has started
 * by waiting for double raf.
 *
 * It falls back to setTimeout on devices that support CSS
 * transitions but not raf (e.g. Android 4.2 browser) - since
 * these environments are usually slow, we are giving it a
 * relatively large timeout.
 */

var raf = inBrowser && window.requestAnimationFrame;
var waitForTransitionStart = raf
/* istanbul ignore next */
? function (fn) {
  raf(function () {
    raf(fn);
  });
} : function (fn) {
  setTimeout(fn, 50);
};

/**
 * A Transition object that encapsulates the state and logic
 * of the transition.
 *
 * @param {Element} el
 * @param {String} id
 * @param {Object} hooks
 * @param {Vue} vm
 */
function Transition(el, id, hooks, vm) {
  this.id = id;
  this.el = el;
  this.enterClass = hooks && hooks.enterClass || id + '-enter';
  this.leaveClass = hooks && hooks.leaveClass || id + '-leave';
  this.hooks = hooks;
  this.vm = vm;
  // async state
  this.pendingCssEvent = this.pendingCssCb = this.cancel = this.pendingJsCb = this.op = this.cb = null;
  this.justEntered = false;
  this.entered = this.left = false;
  this.typeCache = {};
  // check css transition type
  this.type = hooks && hooks.type;
  /* istanbul ignore if */
  if ('development' !== 'production') {
    if (this.type && this.type !== TYPE_TRANSITION && this.type !== TYPE_ANIMATION) {
      warn('invalid CSS transition type for transition="' + this.id + '": ' + this.type, vm);
    }
  }
  // bind
  var self = this;['enterNextTick', 'enterDone', 'leaveNextTick', 'leaveDone'].forEach(function (m) {
    self[m] = bind(self[m], self);
  });
}

var p$1 = Transition.prototype;

/**
 * Start an entering transition.
 *
 * 1. enter transition triggered
 * 2. call beforeEnter hook
 * 3. add enter class
 * 4. insert/show element
 * 5. call enter hook (with possible explicit js callback)
 * 6. reflow
 * 7. based on transition type:
 *    - transition:
 *        remove class now, wait for transitionend,
 *        then done if there's no explicit js callback.
 *    - animation:
 *        wait for animationend, remove class,
 *        then done if there's no explicit js callback.
 *    - no css transition:
 *        done now if there's no explicit js callback.
 * 8. wait for either done or js callback, then call
 *    afterEnter hook.
 *
 * @param {Function} op - insert/show the element
 * @param {Function} [cb]
 */

p$1.enter = function (op, cb) {
  this.cancelPending();
  this.callHook('beforeEnter');
  this.cb = cb;
  addClass(this.el, this.enterClass);
  op();
  this.entered = false;
  this.callHookWithCb('enter');
  if (this.entered) {
    return; // user called done synchronously.
  }
  this.cancel = this.hooks && this.hooks.enterCancelled;
  pushJob(this.enterNextTick);
};

/**
 * The "nextTick" phase of an entering transition, which is
 * to be pushed into a queue and executed after a reflow so
 * that removing the class can trigger a CSS transition.
 */

p$1.enterNextTick = function () {
  var _this = this;

  // prevent transition skipping
  this.justEntered = true;
  waitForTransitionStart(function () {
    _this.justEntered = false;
  });
  var enterDone = this.enterDone;
  var type = this.getCssTransitionType(this.enterClass);
  if (!this.pendingJsCb) {
    if (type === TYPE_TRANSITION) {
      // trigger transition by removing enter class now
      removeClass(this.el, this.enterClass);
      this.setupCssCb(transitionEndEvent, enterDone);
    } else if (type === TYPE_ANIMATION) {
      this.setupCssCb(animationEndEvent, enterDone);
    } else {
      enterDone();
    }
  } else if (type === TYPE_TRANSITION) {
    removeClass(this.el, this.enterClass);
  }
};

/**
 * The "cleanup" phase of an entering transition.
 */

p$1.enterDone = function () {
  this.entered = true;
  this.cancel = this.pendingJsCb = null;
  removeClass(this.el, this.enterClass);
  this.callHook('afterEnter');
  if (this.cb) this.cb();
};

/**
 * Start a leaving transition.
 *
 * 1. leave transition triggered.
 * 2. call beforeLeave hook
 * 3. add leave class (trigger css transition)
 * 4. call leave hook (with possible explicit js callback)
 * 5. reflow if no explicit js callback is provided
 * 6. based on transition type:
 *    - transition or animation:
 *        wait for end event, remove class, then done if
 *        there's no explicit js callback.
 *    - no css transition:
 *        done if there's no explicit js callback.
 * 7. wait for either done or js callback, then call
 *    afterLeave hook.
 *
 * @param {Function} op - remove/hide the element
 * @param {Function} [cb]
 */

p$1.leave = function (op, cb) {
  this.cancelPending();
  this.callHook('beforeLeave');
  this.op = op;
  this.cb = cb;
  addClass(this.el, this.leaveClass);
  this.left = false;
  this.callHookWithCb('leave');
  if (this.left) {
    return; // user called done synchronously.
  }
  this.cancel = this.hooks && this.hooks.leaveCancelled;
  // only need to handle leaveDone if
  // 1. the transition is already done (synchronously called
  //    by the user, which causes this.op set to null)
  // 2. there's no explicit js callback
  if (this.op && !this.pendingJsCb) {
    // if a CSS transition leaves immediately after enter,
    // the transitionend event never fires. therefore we
    // detect such cases and end the leave immediately.
    if (this.justEntered) {
      this.leaveDone();
    } else {
      pushJob(this.leaveNextTick);
    }
  }
};

/**
 * The "nextTick" phase of a leaving transition.
 */

p$1.leaveNextTick = function () {
  var type = this.getCssTransitionType(this.leaveClass);
  if (type) {
    var event = type === TYPE_TRANSITION ? transitionEndEvent : animationEndEvent;
    this.setupCssCb(event, this.leaveDone);
  } else {
    this.leaveDone();
  }
};

/**
 * The "cleanup" phase of a leaving transition.
 */

p$1.leaveDone = function () {
  this.left = true;
  this.cancel = this.pendingJsCb = null;
  this.op();
  removeClass(this.el, this.leaveClass);
  this.callHook('afterLeave');
  if (this.cb) this.cb();
  this.op = null;
};

/**
 * Cancel any pending callbacks from a previously running
 * but not finished transition.
 */

p$1.cancelPending = function () {
  this.op = this.cb = null;
  var hasPending = false;
  if (this.pendingCssCb) {
    hasPending = true;
    off(this.el, this.pendingCssEvent, this.pendingCssCb);
    this.pendingCssEvent = this.pendingCssCb = null;
  }
  if (this.pendingJsCb) {
    hasPending = true;
    this.pendingJsCb.cancel();
    this.pendingJsCb = null;
  }
  if (hasPending) {
    removeClass(this.el, this.enterClass);
    removeClass(this.el, this.leaveClass);
  }
  if (this.cancel) {
    this.cancel.call(this.vm, this.el);
    this.cancel = null;
  }
};

/**
 * Call a user-provided synchronous hook function.
 *
 * @param {String} type
 */

p$1.callHook = function (type) {
  if (this.hooks && this.hooks[type]) {
    this.hooks[type].call(this.vm, this.el);
  }
};

/**
 * Call a user-provided, potentially-async hook function.
 * We check for the length of arguments to see if the hook
 * expects a `done` callback. If true, the transition's end
 * will be determined by when the user calls that callback;
 * otherwise, the end is determined by the CSS transition or
 * animation.
 *
 * @param {String} type
 */

p$1.callHookWithCb = function (type) {
  var hook = this.hooks && this.hooks[type];
  if (hook) {
    if (hook.length > 1) {
      this.pendingJsCb = cancellable(this[type + 'Done']);
    }
    hook.call(this.vm, this.el, this.pendingJsCb);
  }
};

/**
 * Get an element's transition type based on the
 * calculated styles.
 *
 * @param {String} className
 * @return {Number}
 */

p$1.getCssTransitionType = function (className) {
  /* istanbul ignore if */
  if (!transitionEndEvent ||
  // skip CSS transitions if page is not visible -
  // this solves the issue of transitionend events not
  // firing until the page is visible again.
  // pageVisibility API is supported in IE10+, same as
  // CSS transitions.
  document.hidden ||
  // explicit js-only transition
  this.hooks && this.hooks.css === false ||
  // element is hidden
  isHidden(this.el)) {
    return;
  }
  var type = this.type || this.typeCache[className];
  if (type) return type;
  var inlineStyles = this.el.style;
  var computedStyles = window.getComputedStyle(this.el);
  var transDuration = inlineStyles[transDurationProp] || computedStyles[transDurationProp];
  if (transDuration && transDuration !== '0s') {
    type = TYPE_TRANSITION;
  } else {
    var animDuration = inlineStyles[animDurationProp] || computedStyles[animDurationProp];
    if (animDuration && animDuration !== '0s') {
      type = TYPE_ANIMATION;
    }
  }
  if (type) {
    this.typeCache[className] = type;
  }
  return type;
};

/**
 * Setup a CSS transitionend/animationend callback.
 *
 * @param {String} event
 * @param {Function} cb
 */

p$1.setupCssCb = function (event, cb) {
  this.pendingCssEvent = event;
  var self = this;
  var el = this.el;
  var onEnd = this.pendingCssCb = function (e) {
    if (e.target === el) {
      off(el, event, onEnd);
      self.pendingCssEvent = self.pendingCssCb = null;
      if (!self.pendingJsCb && cb) {
        cb();
      }
    }
  };
  on(el, event, onEnd);
};

/**
 * Check if an element is hidden - in that case we can just
 * skip the transition alltogether.
 *
 * @param {Element} el
 * @return {Boolean}
 */

function isHidden(el) {
  if (/svg$/.test(el.namespaceURI)) {
    // SVG elements do not have offset(Width|Height)
    // so we need to check the client rect
    var rect = el.getBoundingClientRect();
    return !(rect.width || rect.height);
  } else {
    return !(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }
}

var transition$1 = {

  priority: TRANSITION,

  update: function update(id, oldId) {
    var el = this.el;
    // resolve on owner vm
    var hooks = resolveAsset(this.vm.$options, 'transitions', id);
    id = id || 'v';
    oldId = oldId || 'v';
    el.__v_trans = new Transition(el, id, hooks, this.vm);
    removeClass(el, oldId + '-transition');
    addClass(el, id + '-transition');
  }
};

var internalDirectives = {
  style: style,
  'class': vClass,
  component: component,
  prop: propDef,
  transition: transition$1
};

// special binding prefixes
var bindRE = /^v-bind:|^:/;
var onRE = /^v-on:|^@/;
var dirAttrRE = /^v-([^:]+)(?:$|:(.*)$)/;
var modifierRE = /\.[^\.]+/g;
var transitionRE = /^(v-bind:|:)?transition$/;

// default directive priority
var DEFAULT_PRIORITY = 1000;
var DEFAULT_TERMINAL_PRIORITY = 2000;

/**
 * Compile a template and return a reusable composite link
 * function, which recursively contains more link functions
 * inside. This top level compile function would normally
 * be called on instance root nodes, but can also be used
 * for partial compilation if the partial argument is true.
 *
 * The returned composite link function, when called, will
 * return an unlink function that tearsdown all directives
 * created during the linking phase.
 *
 * @param {Element|DocumentFragment} el
 * @param {Object} options
 * @param {Boolean} partial
 * @return {Function}
 */

function compile(el, options, partial) {
  // link function for the node itself.
  var nodeLinkFn = partial || !options._asComponent ? compileNode(el, options) : null;
  // link function for the childNodes
  var childLinkFn = !(nodeLinkFn && nodeLinkFn.terminal) && !isScript(el) && el.hasChildNodes() ? compileNodeList(el.childNodes, options) : null;

  /**
   * A composite linker function to be called on a already
   * compiled piece of DOM, which instantiates all directive
   * instances.
   *
   * @param {Vue} vm
   * @param {Element|DocumentFragment} el
   * @param {Vue} [host] - host vm of transcluded content
   * @param {Object} [scope] - v-for scope
   * @param {Fragment} [frag] - link context fragment
   * @return {Function|undefined}
   */

  return function compositeLinkFn(vm, el, host, scope, frag) {
    // cache childNodes before linking parent, fix #657
    var childNodes = toArray(el.childNodes);
    // link
    var dirs = linkAndCapture(function compositeLinkCapturer() {
      if (nodeLinkFn) nodeLinkFn(vm, el, host, scope, frag);
      if (childLinkFn) childLinkFn(vm, childNodes, host, scope, frag);
    }, vm);
    return makeUnlinkFn(vm, dirs);
  };
}

/**
 * Apply a linker to a vm/element pair and capture the
 * directives created during the process.
 *
 * @param {Function} linker
 * @param {Vue} vm
 */

function linkAndCapture(linker, vm) {
  /* istanbul ignore if */
  if ('development' === 'production') {}
  var originalDirCount = vm._directives.length;
  linker();
  var dirs = vm._directives.slice(originalDirCount);
  sortDirectives(dirs);
  for (var i = 0, l = dirs.length; i < l; i++) {
    dirs[i]._bind();
  }
  return dirs;
}

/**
 * sort directives by priority (stable sort)
 *
 * @param {Array} dirs
 */
function sortDirectives(dirs) {
  if (dirs.length === 0) return;

  var groupedMap = {};
  var i, j, k, l;
  var index = 0;
  var priorities = [];
  for (i = 0, j = dirs.length; i < j; i++) {
    var dir = dirs[i];
    var priority = dir.descriptor.def.priority || DEFAULT_PRIORITY;
    var array = groupedMap[priority];
    if (!array) {
      array = groupedMap[priority] = [];
      priorities.push(priority);
    }
    array.push(dir);
  }

  priorities.sort(function (a, b) {
    return a > b ? -1 : a === b ? 0 : 1;
  });
  for (i = 0, j = priorities.length; i < j; i++) {
    var group = groupedMap[priorities[i]];
    for (k = 0, l = group.length; k < l; k++) {
      dirs[index++] = group[k];
    }
  }
}

/**
 * Linker functions return an unlink function that
 * tearsdown all directives instances generated during
 * the process.
 *
 * We create unlink functions with only the necessary
 * information to avoid retaining additional closures.
 *
 * @param {Vue} vm
 * @param {Array} dirs
 * @param {Vue} [context]
 * @param {Array} [contextDirs]
 * @return {Function}
 */

function makeUnlinkFn(vm, dirs, context, contextDirs) {
  function unlink(destroying) {
    teardownDirs(vm, dirs, destroying);
    if (context && contextDirs) {
      teardownDirs(context, contextDirs);
    }
  }
  // expose linked directives
  unlink.dirs = dirs;
  return unlink;
}

/**
 * Teardown partial linked directives.
 *
 * @param {Vue} vm
 * @param {Array} dirs
 * @param {Boolean} destroying
 */

function teardownDirs(vm, dirs, destroying) {
  var i = dirs.length;
  while (i--) {
    dirs[i]._teardown();
    if ('development' !== 'production' && !destroying) {
      vm._directives.$remove(dirs[i]);
    }
  }
}

/**
 * Compile link props on an instance.
 *
 * @param {Vue} vm
 * @param {Element} el
 * @param {Object} props
 * @param {Object} [scope]
 * @return {Function}
 */

function compileAndLinkProps(vm, el, props, scope) {
  var propsLinkFn = compileProps(el, props, vm);
  var propDirs = linkAndCapture(function () {
    propsLinkFn(vm, scope);
  }, vm);
  return makeUnlinkFn(vm, propDirs);
}

/**
 * Compile the root element of an instance.
 *
 * 1. attrs on context container (context scope)
 * 2. attrs on the component template root node, if
 *    replace:true (child scope)
 *
 * If this is a fragment instance, we only need to compile 1.
 *
 * @param {Element} el
 * @param {Object} options
 * @param {Object} contextOptions
 * @return {Function}
 */

function compileRoot(el, options, contextOptions) {
  var containerAttrs = options._containerAttrs;
  var replacerAttrs = options._replacerAttrs;
  var contextLinkFn, replacerLinkFn;

  // only need to compile other attributes for
  // non-fragment instances
  if (el.nodeType !== 11) {
    // for components, container and replacer need to be
    // compiled separately and linked in different scopes.
    if (options._asComponent) {
      // 2. container attributes
      if (containerAttrs && contextOptions) {
        contextLinkFn = compileDirectives(containerAttrs, contextOptions);
      }
      if (replacerAttrs) {
        // 3. replacer attributes
        replacerLinkFn = compileDirectives(replacerAttrs, options);
      }
    } else {
      // non-component, just compile as a normal element.
      replacerLinkFn = compileDirectives(el.attributes, options);
    }
  } else if ('development' !== 'production' && containerAttrs) {
    // warn container directives for fragment instances
    var names = containerAttrs.filter(function (attr) {
      // allow vue-loader/vueify scoped css attributes
      return attr.name.indexOf('_v-') < 0 &&
      // allow event listeners
      !onRE.test(attr.name) &&
      // allow slots
      attr.name !== 'slot';
    }).map(function (attr) {
      return '"' + attr.name + '"';
    });
    if (names.length) {
      var plural = names.length > 1;

      var componentName = options.el.tagName.toLowerCase();
      if (componentName === 'component' && options.name) {
        componentName += ':' + options.name;
      }

      warn('Attribute' + (plural ? 's ' : ' ') + names.join(', ') + (plural ? ' are' : ' is') + ' ignored on component ' + '<' + componentName + '> because ' + 'the component is a fragment instance: ' + 'http://vuejs.org/guide/components.html#Fragment-Instance');
    }
  }

  options._containerAttrs = options._replacerAttrs = null;
  return function rootLinkFn(vm, el, scope) {
    // link context scope dirs
    var context = vm._context;
    var contextDirs;
    if (context && contextLinkFn) {
      contextDirs = linkAndCapture(function () {
        contextLinkFn(context, el, null, scope);
      }, context);
    }

    // link self
    var selfDirs = linkAndCapture(function () {
      if (replacerLinkFn) replacerLinkFn(vm, el);
    }, vm);

    // return the unlink function that tearsdown context
    // container directives.
    return makeUnlinkFn(vm, selfDirs, context, contextDirs);
  };
}

/**
 * Compile a node and return a nodeLinkFn based on the
 * node type.
 *
 * @param {Node} node
 * @param {Object} options
 * @return {Function|null}
 */

function compileNode(node, options) {
  var type = node.nodeType;
  if (type === 1 && !isScript(node)) {
    return compileElement(node, options);
  } else if (type === 3 && node.data.trim()) {
    return compileTextNode(node, options);
  } else {
    return null;
  }
}

/**
 * Compile an element and return a nodeLinkFn.
 *
 * @param {Element} el
 * @param {Object} options
 * @return {Function|null}
 */

function compileElement(el, options) {
  // preprocess textareas.
  // textarea treats its text content as the initial value.
  // just bind it as an attr directive for value.
  if (el.tagName === 'TEXTAREA') {
    // a textarea which has v-pre attr should skip complie.
    if (getAttr(el, 'v-pre') !== null) {
      return skip;
    }
    var tokens = parseText(el.value);
    if (tokens) {
      el.setAttribute(':value', tokensToExp(tokens));
      el.value = '';
    }
  }
  var linkFn;
  var hasAttrs = el.hasAttributes();
  var attrs = hasAttrs && toArray(el.attributes);
  // check terminal directives (for & if)
  if (hasAttrs) {
    linkFn = checkTerminalDirectives(el, attrs, options);
  }
  // check element directives
  if (!linkFn) {
    linkFn = checkElementDirectives(el, options);
  }
  // check component
  if (!linkFn) {
    linkFn = checkComponent(el, options);
  }
  // normal directives
  if (!linkFn && hasAttrs) {
    linkFn = compileDirectives(attrs, options);
  }
  return linkFn;
}

/**
 * Compile a textNode and return a nodeLinkFn.
 *
 * @param {TextNode} node
 * @param {Object} options
 * @return {Function|null} textNodeLinkFn
 */

function compileTextNode(node, options) {
  // skip marked text nodes
  if (node._skip) {
    return removeText;
  }

  var tokens = parseText(node.wholeText);
  if (!tokens) {
    return null;
  }

  // mark adjacent text nodes as skipped,
  // because we are using node.wholeText to compile
  // all adjacent text nodes together. This fixes
  // issues in IE where sometimes it splits up a single
  // text node into multiple ones.
  var next = node.nextSibling;
  while (next && next.nodeType === 3) {
    next._skip = true;
    next = next.nextSibling;
  }

  var frag = document.createDocumentFragment();
  var el, token;
  for (var i = 0, l = tokens.length; i < l; i++) {
    token = tokens[i];
    el = token.tag ? processTextToken(token, options) : document.createTextNode(token.value);
    frag.appendChild(el);
  }
  return makeTextNodeLinkFn(tokens, frag, options);
}

/**
 * Linker for an skipped text node.
 *
 * @param {Vue} vm
 * @param {Text} node
 */

function removeText(vm, node) {
  remove(node);
}

/**
 * Process a single text token.
 *
 * @param {Object} token
 * @param {Object} options
 * @return {Node}
 */

function processTextToken(token, options) {
  var el;
  if (token.oneTime) {
    el = document.createTextNode(token.value);
  } else {
    if (token.html) {
      el = document.createComment('v-html');
      setTokenType('html');
    } else {
      // IE will clean up empty textNodes during
      // frag.cloneNode(true), so we have to give it
      // something here...
      el = document.createTextNode(' ');
      setTokenType('text');
    }
  }
  function setTokenType(type) {
    if (token.descriptor) return;
    var parsed = parseDirective(token.value);
    token.descriptor = {
      name: type,
      def: directives[type],
      expression: parsed.expression,
      filters: parsed.filters
    };
  }
  return el;
}

/**
 * Build a function that processes a textNode.
 *
 * @param {Array<Object>} tokens
 * @param {DocumentFragment} frag
 */

function makeTextNodeLinkFn(tokens, frag) {
  return function textNodeLinkFn(vm, el, host, scope) {
    var fragClone = frag.cloneNode(true);
    var childNodes = toArray(fragClone.childNodes);
    var token, value, node;
    for (var i = 0, l = tokens.length; i < l; i++) {
      token = tokens[i];
      value = token.value;
      if (token.tag) {
        node = childNodes[i];
        if (token.oneTime) {
          value = (scope || vm).$eval(value);
          if (token.html) {
            replace(node, parseTemplate(value, true));
          } else {
            node.data = _toString(value);
          }
        } else {
          vm._bindDir(token.descriptor, node, host, scope);
        }
      }
    }
    replace(el, fragClone);
  };
}

/**
 * Compile a node list and return a childLinkFn.
 *
 * @param {NodeList} nodeList
 * @param {Object} options
 * @return {Function|undefined}
 */

function compileNodeList(nodeList, options) {
  var linkFns = [];
  var nodeLinkFn, childLinkFn, node;
  for (var i = 0, l = nodeList.length; i < l; i++) {
    node = nodeList[i];
    nodeLinkFn = compileNode(node, options);
    childLinkFn = !(nodeLinkFn && nodeLinkFn.terminal) && node.tagName !== 'SCRIPT' && node.hasChildNodes() ? compileNodeList(node.childNodes, options) : null;
    linkFns.push(nodeLinkFn, childLinkFn);
  }
  return linkFns.length ? makeChildLinkFn(linkFns) : null;
}

/**
 * Make a child link function for a node's childNodes.
 *
 * @param {Array<Function>} linkFns
 * @return {Function} childLinkFn
 */

function makeChildLinkFn(linkFns) {
  return function childLinkFn(vm, nodes, host, scope, frag) {
    var node, nodeLinkFn, childrenLinkFn;
    for (var i = 0, n = 0, l = linkFns.length; i < l; n++) {
      node = nodes[n];
      nodeLinkFn = linkFns[i++];
      childrenLinkFn = linkFns[i++];
      // cache childNodes before linking parent, fix #657
      var childNodes = toArray(node.childNodes);
      if (nodeLinkFn) {
        nodeLinkFn(vm, node, host, scope, frag);
      }
      if (childrenLinkFn) {
        childrenLinkFn(vm, childNodes, host, scope, frag);
      }
    }
  };
}

/**
 * Check for element directives (custom elements that should
 * be resovled as terminal directives).
 *
 * @param {Element} el
 * @param {Object} options
 */

function checkElementDirectives(el, options) {
  var tag = el.tagName.toLowerCase();
  if (commonTagRE.test(tag)) {
    return;
  }
  var def = resolveAsset(options, 'elementDirectives', tag);
  if (def) {
    return makeTerminalNodeLinkFn(el, tag, '', options, def);
  }
}

/**
 * Check if an element is a component. If yes, return
 * a component link function.
 *
 * @param {Element} el
 * @param {Object} options
 * @return {Function|undefined}
 */

function checkComponent(el, options) {
  var component = checkComponentAttr(el, options);
  if (component) {
    var ref = findRef(el);
    var descriptor = {
      name: 'component',
      ref: ref,
      expression: component.id,
      def: internalDirectives.component,
      modifiers: {
        literal: !component.dynamic
      }
    };
    var componentLinkFn = function componentLinkFn(vm, el, host, scope, frag) {
      if (ref) {
        defineReactive((scope || vm).$refs, ref, null);
      }
      vm._bindDir(descriptor, el, host, scope, frag);
    };
    componentLinkFn.terminal = true;
    return componentLinkFn;
  }
}

/**
 * Check an element for terminal directives in fixed order.
 * If it finds one, return a terminal link function.
 *
 * @param {Element} el
 * @param {Array} attrs
 * @param {Object} options
 * @return {Function} terminalLinkFn
 */

function checkTerminalDirectives(el, attrs, options) {
  // skip v-pre
  if (getAttr(el, 'v-pre') !== null) {
    return skip;
  }
  // skip v-else block, but only if following v-if
  if (el.hasAttribute('v-else')) {
    var prev = el.previousElementSibling;
    if (prev && prev.hasAttribute('v-if')) {
      return skip;
    }
  }

  var attr, name, value, modifiers, matched, dirName, rawName, arg, def, termDef;
  for (var i = 0, j = attrs.length; i < j; i++) {
    attr = attrs[i];
    name = attr.name.replace(modifierRE, '');
    if (matched = name.match(dirAttrRE)) {
      def = resolveAsset(options, 'directives', matched[1]);
      if (def && def.terminal) {
        if (!termDef || (def.priority || DEFAULT_TERMINAL_PRIORITY) > termDef.priority) {
          termDef = def;
          rawName = attr.name;
          modifiers = parseModifiers(attr.name);
          value = attr.value;
          dirName = matched[1];
          arg = matched[2];
        }
      }
    }
  }

  if (termDef) {
    return makeTerminalNodeLinkFn(el, dirName, value, options, termDef, rawName, arg, modifiers);
  }
}

function skip() {}
skip.terminal = true;

/**
 * Build a node link function for a terminal directive.
 * A terminal link function terminates the current
 * compilation recursion and handles compilation of the
 * subtree in the directive.
 *
 * @param {Element} el
 * @param {String} dirName
 * @param {String} value
 * @param {Object} options
 * @param {Object} def
 * @param {String} [rawName]
 * @param {String} [arg]
 * @param {Object} [modifiers]
 * @return {Function} terminalLinkFn
 */

function makeTerminalNodeLinkFn(el, dirName, value, options, def, rawName, arg, modifiers) {
  var parsed = parseDirective(value);
  var descriptor = {
    name: dirName,
    arg: arg,
    expression: parsed.expression,
    filters: parsed.filters,
    raw: value,
    attr: rawName,
    modifiers: modifiers,
    def: def
  };
  // check ref for v-for, v-if and router-view
  if (dirName === 'for' || dirName === 'router-view') {
    descriptor.ref = findRef(el);
  }
  var fn = function terminalNodeLinkFn(vm, el, host, scope, frag) {
    if (descriptor.ref) {
      defineReactive((scope || vm).$refs, descriptor.ref, null);
    }
    vm._bindDir(descriptor, el, host, scope, frag);
  };
  fn.terminal = true;
  return fn;
}

/**
 * Compile the directives on an element and return a linker.
 *
 * @param {Array|NamedNodeMap} attrs
 * @param {Object} options
 * @return {Function}
 */

function compileDirectives(attrs, options) {
  var i = attrs.length;
  var dirs = [];
  var attr, name, value, rawName, rawValue, dirName, arg, modifiers, dirDef, tokens, matched;
  while (i--) {
    attr = attrs[i];
    name = rawName = attr.name;
    value = rawValue = attr.value;
    tokens = parseText(value);
    // reset arg
    arg = null;
    // check modifiers
    modifiers = parseModifiers(name);
    name = name.replace(modifierRE, '');

    // attribute interpolations
    if (tokens) {
      value = tokensToExp(tokens);
      arg = name;
      pushDir('bind', directives.bind, tokens);
      // warn against mixing mustaches with v-bind
      if ('development' !== 'production') {
        if (name === 'class' && Array.prototype.some.call(attrs, function (attr) {
          return attr.name === ':class' || attr.name === 'v-bind:class';
        })) {
          warn('class="' + rawValue + '": Do not mix mustache interpolation ' + 'and v-bind for "class" on the same element. Use one or the other.', options);
        }
      }
    } else

      // special attribute: transition
      if (transitionRE.test(name)) {
        modifiers.literal = !bindRE.test(name);
        pushDir('transition', internalDirectives.transition);
      } else

        // event handlers
        if (onRE.test(name)) {
          arg = name.replace(onRE, '');
          pushDir('on', directives.on);
        } else

          // attribute bindings
          if (bindRE.test(name)) {
            dirName = name.replace(bindRE, '');
            if (dirName === 'style' || dirName === 'class') {
              pushDir(dirName, internalDirectives[dirName]);
            } else {
              arg = dirName;
              pushDir('bind', directives.bind);
            }
          } else

            // normal directives
            if (matched = name.match(dirAttrRE)) {
              dirName = matched[1];
              arg = matched[2];

              // skip v-else (when used with v-show)
              if (dirName === 'else') {
                continue;
              }

              dirDef = resolveAsset(options, 'directives', dirName, true);
              if (dirDef) {
                pushDir(dirName, dirDef);
              }
            }
  }

  /**
   * Push a directive.
   *
   * @param {String} dirName
   * @param {Object|Function} def
   * @param {Array} [interpTokens]
   */

  function pushDir(dirName, def, interpTokens) {
    var hasOneTimeToken = interpTokens && hasOneTime(interpTokens);
    var parsed = !hasOneTimeToken && parseDirective(value);
    dirs.push({
      name: dirName,
      attr: rawName,
      raw: rawValue,
      def: def,
      arg: arg,
      modifiers: modifiers,
      // conversion from interpolation strings with one-time token
      // to expression is differed until directive bind time so that we
      // have access to the actual vm context for one-time bindings.
      expression: parsed && parsed.expression,
      filters: parsed && parsed.filters,
      interp: interpTokens,
      hasOneTime: hasOneTimeToken
    });
  }

  if (dirs.length) {
    return makeNodeLinkFn(dirs);
  }
}

/**
 * Parse modifiers from directive attribute name.
 *
 * @param {String} name
 * @return {Object}
 */

function parseModifiers(name) {
  var res = Object.create(null);
  var match = name.match(modifierRE);
  if (match) {
    var i = match.length;
    while (i--) {
      res[match[i].slice(1)] = true;
    }
  }
  return res;
}

/**
 * Build a link function for all directives on a single node.
 *
 * @param {Array} directives
 * @return {Function} directivesLinkFn
 */

function makeNodeLinkFn(directives) {
  return function nodeLinkFn(vm, el, host, scope, frag) {
    // reverse apply because it's sorted low to high
    var i = directives.length;
    while (i--) {
      vm._bindDir(directives[i], el, host, scope, frag);
    }
  };
}

/**
 * Check if an interpolation string contains one-time tokens.
 *
 * @param {Array} tokens
 * @return {Boolean}
 */

function hasOneTime(tokens) {
  var i = tokens.length;
  while (i--) {
    if (tokens[i].oneTime) return true;
  }
}

function isScript(el) {
  return el.tagName === 'SCRIPT' && (!el.hasAttribute('type') || el.getAttribute('type') === 'text/javascript');
}

var specialCharRE = /[^\w\-:\.]/;

/**
 * Process an element or a DocumentFragment based on a
 * instance option object. This allows us to transclude
 * a template node/fragment before the instance is created,
 * so the processed fragment can then be cloned and reused
 * in v-for.
 *
 * @param {Element} el
 * @param {Object} options
 * @return {Element|DocumentFragment}
 */

function transclude(el, options) {
  // extract container attributes to pass them down
  // to compiler, because they need to be compiled in
  // parent scope. we are mutating the options object here
  // assuming the same object will be used for compile
  // right after this.
  if (options) {
    options._containerAttrs = extractAttrs(el);
  }
  // for template tags, what we want is its content as
  // a documentFragment (for fragment instances)
  if (isTemplate(el)) {
    el = parseTemplate(el);
  }
  if (options) {
    if (options._asComponent && !options.template) {
      options.template = '<slot></slot>';
    }
    if (options.template) {
      options._content = extractContent(el);
      el = transcludeTemplate(el, options);
    }
  }
  if (isFragment(el)) {
    // anchors for fragment instance
    // passing in `persist: true` to avoid them being
    // discarded by IE during template cloning
    prepend(createAnchor('v-start', true), el);
    el.appendChild(createAnchor('v-end', true));
  }
  return el;
}

/**
 * Process the template option.
 * If the replace option is true this will swap the $el.
 *
 * @param {Element} el
 * @param {Object} options
 * @return {Element|DocumentFragment}
 */

function transcludeTemplate(el, options) {
  var template = options.template;
  var frag = parseTemplate(template, true);
  if (frag) {
    var replacer = frag.firstChild;
    if (!replacer) {
      return frag;
    }
    var tag = replacer.tagName && replacer.tagName.toLowerCase();
    if (options.replace) {
      /* istanbul ignore if */
      if (el === document.body) {
        'development' !== 'production' && warn('You are mounting an instance with a template to ' + '<body>. This will replace <body> entirely. You ' + 'should probably use `replace: false` here.');
      }
      // there are many cases where the instance must
      // become a fragment instance: basically anything that
      // can create more than 1 root nodes.
      if (
      // multi-children template
      frag.childNodes.length > 1 ||
      // non-element template
      replacer.nodeType !== 1 ||
      // single nested component
      tag === 'component' || resolveAsset(options, 'components', tag) || hasBindAttr(replacer, 'is') ||
      // element directive
      resolveAsset(options, 'elementDirectives', tag) ||
      // for block
      replacer.hasAttribute('v-for') ||
      // if block
      replacer.hasAttribute('v-if')) {
        return frag;
      } else {
        options._replacerAttrs = extractAttrs(replacer);
        mergeAttrs(el, replacer);
        return replacer;
      }
    } else {
      el.appendChild(frag);
      return el;
    }
  } else {
    'development' !== 'production' && warn('Invalid template option: ' + template);
  }
}

/**
 * Helper to extract a component container's attributes
 * into a plain object array.
 *
 * @param {Element} el
 * @return {Array}
 */

function extractAttrs(el) {
  if (el.nodeType === 1 && el.hasAttributes()) {
    return toArray(el.attributes);
  }
}

/**
 * Merge the attributes of two elements, and make sure
 * the class names are merged properly.
 *
 * @param {Element} from
 * @param {Element} to
 */

function mergeAttrs(from, to) {
  var attrs = from.attributes;
  var i = attrs.length;
  var name, value;
  while (i--) {
    name = attrs[i].name;
    value = attrs[i].value;
    if (!to.hasAttribute(name) && !specialCharRE.test(name)) {
      to.setAttribute(name, value);
    } else if (name === 'class' && !parseText(value) && (value = value.trim())) {
      value.split(/\s+/).forEach(function (cls) {
        addClass(to, cls);
      });
    }
  }
}

/**
 * Scan and determine slot content distribution.
 * We do this during transclusion instead at compile time so that
 * the distribution is decoupled from the compilation order of
 * the slots.
 *
 * @param {Element|DocumentFragment} template
 * @param {Element} content
 * @param {Vue} vm
 */

function resolveSlots(vm, content) {
  if (!content) {
    return;
  }
  var contents = vm._slotContents = Object.create(null);
  var el, name;
  for (var i = 0, l = content.children.length; i < l; i++) {
    el = content.children[i];
    /* eslint-disable no-cond-assign */
    if (name = el.getAttribute('slot')) {
      (contents[name] || (contents[name] = [])).push(el);
    }
    /* eslint-enable no-cond-assign */
    if ('development' !== 'production' && getBindAttr(el, 'slot')) {
      warn('The "slot" attribute must be static.', vm.$parent);
    }
  }
  for (name in contents) {
    contents[name] = extractFragment(contents[name], content);
  }
  if (content.hasChildNodes()) {
    var nodes = content.childNodes;
    if (nodes.length === 1 && nodes[0].nodeType === 3 && !nodes[0].data.trim()) {
      return;
    }
    contents['default'] = extractFragment(content.childNodes, content);
  }
}

/**
 * Extract qualified content nodes from a node list.
 *
 * @param {NodeList} nodes
 * @return {DocumentFragment}
 */

function extractFragment(nodes, parent) {
  var frag = document.createDocumentFragment();
  nodes = toArray(nodes);
  for (var i = 0, l = nodes.length; i < l; i++) {
    var node = nodes[i];
    if (isTemplate(node) && !node.hasAttribute('v-if') && !node.hasAttribute('v-for')) {
      parent.removeChild(node);
      node = parseTemplate(node, true);
    }
    frag.appendChild(node);
  }
  return frag;
}



var compiler = Object.freeze({
	compile: compile,
	compileAndLinkProps: compileAndLinkProps,
	compileRoot: compileRoot,
	transclude: transclude,
	resolveSlots: resolveSlots
});

function stateMixin (Vue) {
  /**
   * Accessor for `$data` property, since setting $data
   * requires observing the new object and updating
   * proxied properties.
   */

  Object.defineProperty(Vue.prototype, '$data', {
    get: function get() {
      return this._data;
    },
    set: function set(newData) {
      if (newData !== this._data) {
        this._setData(newData);
      }
    }
  });

  /**
   * Setup the scope of an instance, which contains:
   * - observed data
   * - computed properties
   * - user methods
   * - meta properties
   */

  Vue.prototype._initState = function () {
    this._initProps();
    this._initMeta();
    this._initMethods();
    this._initData();
    this._initComputed();
  };

  /**
   * Initialize props.
   */

  Vue.prototype._initProps = function () {
    var options = this.$options;
    var el = options.el;
    var props = options.props;
    if (props && !el) {
      'development' !== 'production' && warn('Props will not be compiled if no `el` option is ' + 'provided at instantiation.', this);
    }
    // make sure to convert string selectors into element now
    el = options.el = query(el);
    this._propsUnlinkFn = el && el.nodeType === 1 && props
    // props must be linked in proper scope if inside v-for
    ? compileAndLinkProps(this, el, props, this._scope) : null;
  };

  /**
   * Initialize the data.
   */

  Vue.prototype._initData = function () {
    var dataFn = this.$options.data;
    var data = this._data = dataFn ? dataFn() : {};
    if (!isPlainObject(data)) {
      data = {};
      'development' !== 'production' && warn('data functions should return an object.', this);
    }
    var props = this._props;
    // proxy data on instance
    var keys = Object.keys(data);
    var i, key;
    i = keys.length;
    while (i--) {
      key = keys[i];
      // there are two scenarios where we can proxy a data key:
      // 1. it's not already defined as a prop
      // 2. it's provided via a instantiation option AND there are no
      //    template prop present
      if (!props || !hasOwn(props, key)) {
        this._proxy(key);
      } else if ('development' !== 'production') {
        warn('Data field "' + key + '" is already defined ' + 'as a prop. To provide default value for a prop, use the "default" ' + 'prop option; if you want to pass prop values to an instantiation ' + 'call, use the "propsData" option.', this);
      }
    }
    // observe data
    observe(data, this);
  };

  /**
   * Swap the instance's $data. Called in $data's setter.
   *
   * @param {Object} newData
   */

  Vue.prototype._setData = function (newData) {
    newData = newData || {};
    var oldData = this._data;
    this._data = newData;
    var keys, key, i;
    // unproxy keys not present in new data
    keys = Object.keys(oldData);
    i = keys.length;
    while (i--) {
      key = keys[i];
      if (!(key in newData)) {
        this._unproxy(key);
      }
    }
    // proxy keys not already proxied,
    // and trigger change for changed values
    keys = Object.keys(newData);
    i = keys.length;
    while (i--) {
      key = keys[i];
      if (!hasOwn(this, key)) {
        // new property
        this._proxy(key);
      }
    }
    oldData.__ob__.removeVm(this);
    observe(newData, this);
    this._digest();
  };

  /**
   * Proxy a property, so that
   * vm.prop === vm._data.prop
   *
   * @param {String} key
   */

  Vue.prototype._proxy = function (key) {
    if (!isReserved(key)) {
      // need to store ref to self here
      // because these getter/setters might
      // be called by child scopes via
      // prototype inheritance.
      var self = this;
      Object.defineProperty(self, key, {
        configurable: true,
        enumerable: true,
        get: function proxyGetter() {
          return self._data[key];
        },
        set: function proxySetter(val) {
          self._data[key] = val;
        }
      });
    }
  };

  /**
   * Unproxy a property.
   *
   * @param {String} key
   */

  Vue.prototype._unproxy = function (key) {
    if (!isReserved(key)) {
      delete this[key];
    }
  };

  /**
   * Force update on every watcher in scope.
   */

  Vue.prototype._digest = function () {
    for (var i = 0, l = this._watchers.length; i < l; i++) {
      this._watchers[i].update(true); // shallow updates
    }
  };

  /**
   * Setup computed properties. They are essentially
   * special getter/setters
   */

  function noop() {}
  Vue.prototype._initComputed = function () {
    var computed = this.$options.computed;
    if (computed) {
      for (var key in computed) {
        var userDef = computed[key];
        var def = {
          enumerable: true,
          configurable: true
        };
        if (typeof userDef === 'function') {
          def.get = makeComputedGetter(userDef, this);
          def.set = noop;
        } else {
          def.get = userDef.get ? userDef.cache !== false ? makeComputedGetter(userDef.get, this) : bind(userDef.get, this) : noop;
          def.set = userDef.set ? bind(userDef.set, this) : noop;
        }
        Object.defineProperty(this, key, def);
      }
    }
  };

  function makeComputedGetter(getter, owner) {
    var watcher = new Watcher(owner, getter, null, {
      lazy: true
    });
    return function computedGetter() {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value;
    };
  }

  /**
   * Setup instance methods. Methods must be bound to the
   * instance since they might be passed down as a prop to
   * child components.
   */

  Vue.prototype._initMethods = function () {
    var methods = this.$options.methods;
    if (methods) {
      for (var key in methods) {
        this[key] = bind(methods[key], this);
      }
    }
  };

  /**
   * Initialize meta information like $index, $key & $value.
   */

  Vue.prototype._initMeta = function () {
    var metas = this.$options._meta;
    if (metas) {
      for (var key in metas) {
        defineReactive(this, key, metas[key]);
      }
    }
  };
}

var eventRE = /^v-on:|^@/;

function eventsMixin (Vue) {
  /**
   * Setup the instance's option events & watchers.
   * If the value is a string, we pull it from the
   * instance's methods by name.
   */

  Vue.prototype._initEvents = function () {
    var options = this.$options;
    if (options._asComponent) {
      registerComponentEvents(this, options.el);
    }
    registerCallbacks(this, '$on', options.events);
    registerCallbacks(this, '$watch', options.watch);
  };

  /**
   * Register v-on events on a child component
   *
   * @param {Vue} vm
   * @param {Element} el
   */

  function registerComponentEvents(vm, el) {
    var attrs = el.attributes;
    var name, value, handler;
    for (var i = 0, l = attrs.length; i < l; i++) {
      name = attrs[i].name;
      if (eventRE.test(name)) {
        name = name.replace(eventRE, '');
        // force the expression into a statement so that
        // it always dynamically resolves the method to call (#2670)
        // kinda ugly hack, but does the job.
        value = attrs[i].value;
        if (isSimplePath(value)) {
          value += '.apply(this, $arguments)';
        }
        handler = (vm._scope || vm._context).$eval(value, true);
        handler._fromParent = true;
        vm.$on(name.replace(eventRE), handler);
      }
    }
  }

  /**
   * Register callbacks for option events and watchers.
   *
   * @param {Vue} vm
   * @param {String} action
   * @param {Object} hash
   */

  function registerCallbacks(vm, action, hash) {
    if (!hash) return;
    var handlers, key, i, j;
    for (key in hash) {
      handlers = hash[key];
      if (isArray(handlers)) {
        for (i = 0, j = handlers.length; i < j; i++) {
          register(vm, action, key, handlers[i]);
        }
      } else {
        register(vm, action, key, handlers);
      }
    }
  }

  /**
   * Helper to register an event/watch callback.
   *
   * @param {Vue} vm
   * @param {String} action
   * @param {String} key
   * @param {Function|String|Object} handler
   * @param {Object} [options]
   */

  function register(vm, action, key, handler, options) {
    var type = typeof handler;
    if (type === 'function') {
      vm[action](key, handler, options);
    } else if (type === 'string') {
      var methods = vm.$options.methods;
      var method = methods && methods[handler];
      if (method) {
        vm[action](key, method, options);
      } else {
        'development' !== 'production' && warn('Unknown method: "' + handler + '" when ' + 'registering callback for ' + action + ': "' + key + '".', vm);
      }
    } else if (handler && type === 'object') {
      register(vm, action, key, handler.handler, handler);
    }
  }

  /**
   * Setup recursive attached/detached calls
   */

  Vue.prototype._initDOMHooks = function () {
    this.$on('hook:attached', onAttached);
    this.$on('hook:detached', onDetached);
  };

  /**
   * Callback to recursively call attached hook on children
   */

  function onAttached() {
    if (!this._isAttached) {
      this._isAttached = true;
      this.$children.forEach(callAttach);
    }
  }

  /**
   * Iterator to call attached hook
   *
   * @param {Vue} child
   */

  function callAttach(child) {
    if (!child._isAttached && inDoc(child.$el)) {
      child._callHook('attached');
    }
  }

  /**
   * Callback to recursively call detached hook on children
   */

  function onDetached() {
    if (this._isAttached) {
      this._isAttached = false;
      this.$children.forEach(callDetach);
    }
  }

  /**
   * Iterator to call detached hook
   *
   * @param {Vue} child
   */

  function callDetach(child) {
    if (child._isAttached && !inDoc(child.$el)) {
      child._callHook('detached');
    }
  }

  /**
   * Trigger all handlers for a hook
   *
   * @param {String} hook
   */

  Vue.prototype._callHook = function (hook) {
    this.$emit('pre-hook:' + hook);
    var handlers = this.$options[hook];
    if (handlers) {
      for (var i = 0, j = handlers.length; i < j; i++) {
        handlers[i].call(this);
      }
    }
    this.$emit('hook:' + hook);
  };
}

function noop$1() {}

/**
 * A directive links a DOM element with a piece of data,
 * which is the result of evaluating an expression.
 * It registers a watcher with the expression and calls
 * the DOM update function when a change is triggered.
 *
 * @param {Object} descriptor
 *                 - {String} name
 *                 - {Object} def
 *                 - {String} expression
 *                 - {Array<Object>} [filters]
 *                 - {Object} [modifiers]
 *                 - {Boolean} literal
 *                 - {String} attr
 *                 - {String} arg
 *                 - {String} raw
 *                 - {String} [ref]
 *                 - {Array<Object>} [interp]
 *                 - {Boolean} [hasOneTime]
 * @param {Vue} vm
 * @param {Node} el
 * @param {Vue} [host] - transclusion host component
 * @param {Object} [scope] - v-for scope
 * @param {Fragment} [frag] - owner fragment
 * @constructor
 */
function Directive(descriptor, vm, el, host, scope, frag) {
  this.vm = vm;
  this.el = el;
  // copy descriptor properties
  this.descriptor = descriptor;
  this.name = descriptor.name;
  this.expression = descriptor.expression;
  this.arg = descriptor.arg;
  this.modifiers = descriptor.modifiers;
  this.filters = descriptor.filters;
  this.literal = this.modifiers && this.modifiers.literal;
  // private
  this._locked = false;
  this._bound = false;
  this._listeners = null;
  // link context
  this._host = host;
  this._scope = scope;
  this._frag = frag;
  // store directives on node in dev mode
  if ('development' !== 'production' && this.el) {
    this.el._vue_directives = this.el._vue_directives || [];
    this.el._vue_directives.push(this);
  }
}

/**
 * Initialize the directive, mixin definition properties,
 * setup the watcher, call definition bind() and update()
 * if present.
 */

Directive.prototype._bind = function () {
  var name = this.name;
  var descriptor = this.descriptor;

  // remove attribute
  if ((name !== 'cloak' || this.vm._isCompiled) && this.el && this.el.removeAttribute) {
    var attr = descriptor.attr || 'v-' + name;
    this.el.removeAttribute(attr);
  }

  // copy def properties
  var def = descriptor.def;
  if (typeof def === 'function') {
    this.update = def;
  } else {
    extend(this, def);
  }

  // setup directive params
  this._setupParams();

  // initial bind
  if (this.bind) {
    this.bind();
  }
  this._bound = true;

  if (this.literal) {
    this.update && this.update(descriptor.raw);
  } else if ((this.expression || this.modifiers) && (this.update || this.twoWay) && !this._checkStatement()) {
    // wrapped updater for context
    var dir = this;
    if (this.update) {
      this._update = function (val, oldVal) {
        if (!dir._locked) {
          dir.update(val, oldVal);
        }
      };
    } else {
      this._update = noop$1;
    }
    var preProcess = this._preProcess ? bind(this._preProcess, this) : null;
    var postProcess = this._postProcess ? bind(this._postProcess, this) : null;
    var watcher = this._watcher = new Watcher(this.vm, this.expression, this._update, // callback
    {
      filters: this.filters,
      twoWay: this.twoWay,
      deep: this.deep,
      preProcess: preProcess,
      postProcess: postProcess,
      scope: this._scope
    });
    // v-model with inital inline value need to sync back to
    // model instead of update to DOM on init. They would
    // set the afterBind hook to indicate that.
    if (this.afterBind) {
      this.afterBind();
    } else if (this.update) {
      this.update(watcher.value);
    }
  }
};

/**
 * Setup all param attributes, e.g. track-by,
 * transition-mode, etc...
 */

Directive.prototype._setupParams = function () {
  if (!this.params) {
    return;
  }
  var params = this.params;
  // swap the params array with a fresh object.
  this.params = Object.create(null);
  var i = params.length;
  var key, val, mappedKey;
  while (i--) {
    key = hyphenate(params[i]);
    mappedKey = camelize(key);
    val = getBindAttr(this.el, key);
    if (val != null) {
      // dynamic
      this._setupParamWatcher(mappedKey, val);
    } else {
      // static
      val = getAttr(this.el, key);
      if (val != null) {
        this.params[mappedKey] = val === '' ? true : val;
      }
    }
  }
};

/**
 * Setup a watcher for a dynamic param.
 *
 * @param {String} key
 * @param {String} expression
 */

Directive.prototype._setupParamWatcher = function (key, expression) {
  var self = this;
  var called = false;
  var unwatch = (this._scope || this.vm).$watch(expression, function (val, oldVal) {
    self.params[key] = val;
    // since we are in immediate mode,
    // only call the param change callbacks if this is not the first update.
    if (called) {
      var cb = self.paramWatchers && self.paramWatchers[key];
      if (cb) {
        cb.call(self, val, oldVal);
      }
    } else {
      called = true;
    }
  }, {
    immediate: true,
    user: false
  });(this._paramUnwatchFns || (this._paramUnwatchFns = [])).push(unwatch);
};

/**
 * Check if the directive is a function caller
 * and if the expression is a callable one. If both true,
 * we wrap up the expression and use it as the event
 * handler.
 *
 * e.g. on-click="a++"
 *
 * @return {Boolean}
 */

Directive.prototype._checkStatement = function () {
  var expression = this.expression;
  if (expression && this.acceptStatement && !isSimplePath(expression)) {
    var fn = parseExpression$1(expression).get;
    var scope = this._scope || this.vm;
    var handler = function handler(e) {
      scope.$event = e;
      fn.call(scope, scope);
      scope.$event = null;
    };
    if (this.filters) {
      handler = scope._applyFilters(handler, null, this.filters);
    }
    this.update(handler);
    return true;
  }
};

/**
 * Set the corresponding value with the setter.
 * This should only be used in two-way directives
 * e.g. v-model.
 *
 * @param {*} value
 * @public
 */

Directive.prototype.set = function (value) {
  /* istanbul ignore else */
  if (this.twoWay) {
    this._withLock(function () {
      this._watcher.set(value);
    });
  } else if ('development' !== 'production') {
    warn('Directive.set() can only be used inside twoWay' + 'directives.');
  }
};

/**
 * Execute a function while preventing that function from
 * triggering updates on this directive instance.
 *
 * @param {Function} fn
 */

Directive.prototype._withLock = function (fn) {
  var self = this;
  self._locked = true;
  fn.call(self);
  nextTick(function () {
    self._locked = false;
  });
};

/**
 * Convenience method that attaches a DOM event listener
 * to the directive element and autometically tears it down
 * during unbind.
 *
 * @param {String} event
 * @param {Function} handler
 * @param {Boolean} [useCapture]
 */

Directive.prototype.on = function (event, handler, useCapture) {
  on(this.el, event, handler, useCapture);(this._listeners || (this._listeners = [])).push([event, handler]);
};

/**
 * Teardown the watcher and call unbind.
 */

Directive.prototype._teardown = function () {
  if (this._bound) {
    this._bound = false;
    if (this.unbind) {
      this.unbind();
    }
    if (this._watcher) {
      this._watcher.teardown();
    }
    var listeners = this._listeners;
    var i;
    if (listeners) {
      i = listeners.length;
      while (i--) {
        off(this.el, listeners[i][0], listeners[i][1]);
      }
    }
    var unwatchFns = this._paramUnwatchFns;
    if (unwatchFns) {
      i = unwatchFns.length;
      while (i--) {
        unwatchFns[i]();
      }
    }
    if ('development' !== 'production' && this.el) {
      this.el._vue_directives.$remove(this);
    }
    this.vm = this.el = this._watcher = this._listeners = null;
  }
};

function lifecycleMixin (Vue) {
  /**
   * Update v-ref for component.
   *
   * @param {Boolean} remove
   */

  Vue.prototype._updateRef = function (remove) {
    var ref = this.$options._ref;
    if (ref) {
      var refs = (this._scope || this._context).$refs;
      if (remove) {
        if (refs[ref] === this) {
          refs[ref] = null;
        }
      } else {
        refs[ref] = this;
      }
    }
  };

  /**
   * Transclude, compile and link element.
   *
   * If a pre-compiled linker is available, that means the
   * passed in element will be pre-transcluded and compiled
   * as well - all we need to do is to call the linker.
   *
   * Otherwise we need to call transclude/compile/link here.
   *
   * @param {Element} el
   */

  Vue.prototype._compile = function (el) {
    var options = this.$options;

    // transclude and init element
    // transclude can potentially replace original
    // so we need to keep reference; this step also injects
    // the template and caches the original attributes
    // on the container node and replacer node.
    var original = el;
    el = transclude(el, options);
    this._initElement(el);

    // handle v-pre on root node (#2026)
    if (el.nodeType === 1 && getAttr(el, 'v-pre') !== null) {
      return;
    }

    // root is always compiled per-instance, because
    // container attrs and props can be different every time.
    var contextOptions = this._context && this._context.$options;
    var rootLinker = compileRoot(el, options, contextOptions);

    // resolve slot distribution
    resolveSlots(this, options._content);

    // compile and link the rest
    var contentLinkFn;
    var ctor = this.constructor;
    // component compilation can be cached
    // as long as it's not using inline-template
    if (options._linkerCachable) {
      contentLinkFn = ctor.linker;
      if (!contentLinkFn) {
        contentLinkFn = ctor.linker = compile(el, options);
      }
    }

    // link phase
    // make sure to link root with prop scope!
    var rootUnlinkFn = rootLinker(this, el, this._scope);
    var contentUnlinkFn = contentLinkFn ? contentLinkFn(this, el) : compile(el, options)(this, el);

    // register composite unlink function
    // to be called during instance destruction
    this._unlinkFn = function () {
      rootUnlinkFn();
      // passing destroying: true to avoid searching and
      // splicing the directives
      contentUnlinkFn(true);
    };

    // finally replace original
    if (options.replace) {
      replace(original, el);
    }

    this._isCompiled = true;
    this._callHook('compiled');
  };

  /**
   * Initialize instance element. Called in the public
   * $mount() method.
   *
   * @param {Element} el
   */

  Vue.prototype._initElement = function (el) {
    if (isFragment(el)) {
      this._isFragment = true;
      this.$el = this._fragmentStart = el.firstChild;
      this._fragmentEnd = el.lastChild;
      // set persisted text anchors to empty
      if (this._fragmentStart.nodeType === 3) {
        this._fragmentStart.data = this._fragmentEnd.data = '';
      }
      this._fragment = el;
    } else {
      this.$el = el;
    }
    this.$el.__vue__ = this;
    this._callHook('beforeCompile');
  };

  /**
   * Create and bind a directive to an element.
   *
   * @param {Object} descriptor - parsed directive descriptor
   * @param {Node} node   - target node
   * @param {Vue} [host] - transclusion host component
   * @param {Object} [scope] - v-for scope
   * @param {Fragment} [frag] - owner fragment
   */

  Vue.prototype._bindDir = function (descriptor, node, host, scope, frag) {
    this._directives.push(new Directive(descriptor, this, node, host, scope, frag));
  };

  /**
   * Teardown an instance, unobserves the data, unbind all the
   * directives, turn off all the event listeners, etc.
   *
   * @param {Boolean} remove - whether to remove the DOM node.
   * @param {Boolean} deferCleanup - if true, defer cleanup to
   *                                 be called later
   */

  Vue.prototype._destroy = function (remove, deferCleanup) {
    if (this._isBeingDestroyed) {
      if (!deferCleanup) {
        this._cleanup();
      }
      return;
    }

    var destroyReady;
    var pendingRemoval;

    var self = this;
    // Cleanup should be called either synchronously or asynchronoysly as
    // callback of this.$remove(), or if remove and deferCleanup are false.
    // In any case it should be called after all other removing, unbinding and
    // turning of is done
    var cleanupIfPossible = function cleanupIfPossible() {
      if (destroyReady && !pendingRemoval && !deferCleanup) {
        self._cleanup();
      }
    };

    // remove DOM element
    if (remove && this.$el) {
      pendingRemoval = true;
      this.$remove(function () {
        pendingRemoval = false;
        cleanupIfPossible();
      });
    }

    this._callHook('beforeDestroy');
    this._isBeingDestroyed = true;
    var i;
    // remove self from parent. only necessary
    // if parent is not being destroyed as well.
    var parent = this.$parent;
    if (parent && !parent._isBeingDestroyed) {
      parent.$children.$remove(this);
      // unregister ref (remove: true)
      this._updateRef(true);
    }
    // destroy all children.
    i = this.$children.length;
    while (i--) {
      this.$children[i].$destroy();
    }
    // teardown props
    if (this._propsUnlinkFn) {
      this._propsUnlinkFn();
    }
    // teardown all directives. this also tearsdown all
    // directive-owned watchers.
    if (this._unlinkFn) {
      this._unlinkFn();
    }
    i = this._watchers.length;
    while (i--) {
      this._watchers[i].teardown();
    }
    // remove reference to self on $el
    if (this.$el) {
      this.$el.__vue__ = null;
    }

    destroyReady = true;
    cleanupIfPossible();
  };

  /**
   * Clean up to ensure garbage collection.
   * This is called after the leave transition if there
   * is any.
   */

  Vue.prototype._cleanup = function () {
    if (this._isDestroyed) {
      return;
    }
    // remove self from owner fragment
    // do it in cleanup so that we can call $destroy with
    // defer right when a fragment is about to be removed.
    if (this._frag) {
      this._frag.children.$remove(this);
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (this._data && this._data.__ob__) {
      this._data.__ob__.removeVm(this);
    }
    // Clean up references to private properties and other
    // instances. preserve reference to _data so that proxy
    // accessors still work. The only potential side effect
    // here is that mutating the instance after it's destroyed
    // may affect the state of other components that are still
    // observing the same object, but that seems to be a
    // reasonable responsibility for the user rather than
    // always throwing an error on them.
    this.$el = this.$parent = this.$root = this.$children = this._watchers = this._context = this._scope = this._directives = null;
    // call the last hook...
    this._isDestroyed = true;
    this._callHook('destroyed');
    // turn off all instance listeners.
    this.$off();
  };
}

function miscMixin (Vue) {
  /**
   * Apply a list of filter (descriptors) to a value.
   * Using plain for loops here because this will be called in
   * the getter of any watcher with filters so it is very
   * performance sensitive.
   *
   * @param {*} value
   * @param {*} [oldValue]
   * @param {Array} filters
   * @param {Boolean} write
   * @return {*}
   */

  Vue.prototype._applyFilters = function (value, oldValue, filters, write) {
    var filter, fn, args, arg, offset, i, l, j, k;
    for (i = 0, l = filters.length; i < l; i++) {
      filter = filters[write ? l - i - 1 : i];
      fn = resolveAsset(this.$options, 'filters', filter.name, true);
      if (!fn) continue;
      fn = write ? fn.write : fn.read || fn;
      if (typeof fn !== 'function') continue;
      args = write ? [value, oldValue] : [value];
      offset = write ? 2 : 1;
      if (filter.args) {
        for (j = 0, k = filter.args.length; j < k; j++) {
          arg = filter.args[j];
          args[j + offset] = arg.dynamic ? this.$get(arg.value) : arg.value;
        }
      }
      value = fn.apply(this, args);
    }
    return value;
  };

  /**
   * Resolve a component, depending on whether the component
   * is defined normally or using an async factory function.
   * Resolves synchronously if already resolved, otherwise
   * resolves asynchronously and caches the resolved
   * constructor on the factory.
   *
   * @param {String|Function} value
   * @param {Function} cb
   */

  Vue.prototype._resolveComponent = function (value, cb) {
    var factory;
    if (typeof value === 'function') {
      factory = value;
    } else {
      factory = resolveAsset(this.$options, 'components', value, true);
    }
    /* istanbul ignore if */
    if (!factory) {
      return;
    }
    // async component factory
    if (!factory.options) {
      if (factory.resolved) {
        // cached
        cb(factory.resolved);
      } else if (factory.requested) {
        // pool callbacks
        factory.pendingCallbacks.push(cb);
      } else {
        factory.requested = true;
        var cbs = factory.pendingCallbacks = [cb];
        factory.call(this, function resolve(res) {
          if (isPlainObject(res)) {
            res = Vue.extend(res);
          }
          // cache resolved
          factory.resolved = res;
          // invoke callbacks
          for (var i = 0, l = cbs.length; i < l; i++) {
            cbs[i](res);
          }
        }, function reject(reason) {
          'development' !== 'production' && warn('Failed to resolve async component' + (typeof value === 'string' ? ': ' + value : '') + '. ' + (reason ? '\nReason: ' + reason : ''));
        });
      }
    } else {
      // normal component
      cb(factory);
    }
  };
}

var filterRE$1 = /[^|]\|[^|]/;

function dataAPI (Vue) {
  /**
   * Get the value from an expression on this vm.
   *
   * @param {String} exp
   * @param {Boolean} [asStatement]
   * @return {*}
   */

  Vue.prototype.$get = function (exp, asStatement) {
    var res = parseExpression$1(exp);
    if (res) {
      if (asStatement) {
        var self = this;
        return function statementHandler() {
          self.$arguments = toArray(arguments);
          var result = res.get.call(self, self);
          self.$arguments = null;
          return result;
        };
      } else {
        try {
          return res.get.call(this, this);
        } catch (e) {}
      }
    }
  };

  /**
   * Set the value from an expression on this vm.
   * The expression must be a valid left-hand
   * expression in an assignment.
   *
   * @param {String} exp
   * @param {*} val
   */

  Vue.prototype.$set = function (exp, val) {
    var res = parseExpression$1(exp, true);
    if (res && res.set) {
      res.set.call(this, this, val);
    }
  };

  /**
   * Delete a property on the VM
   *
   * @param {String} key
   */

  Vue.prototype.$delete = function (key) {
    del(this._data, key);
  };

  /**
   * Watch an expression, trigger callback when its
   * value changes.
   *
   * @param {String|Function} expOrFn
   * @param {Function} cb
   * @param {Object} [options]
   *                 - {Boolean} deep
   *                 - {Boolean} immediate
   * @return {Function} - unwatchFn
   */

  Vue.prototype.$watch = function (expOrFn, cb, options) {
    var vm = this;
    var parsed;
    if (typeof expOrFn === 'string') {
      parsed = parseDirective(expOrFn);
      expOrFn = parsed.expression;
    }
    var watcher = new Watcher(vm, expOrFn, cb, {
      deep: options && options.deep,
      sync: options && options.sync,
      filters: parsed && parsed.filters,
      user: !options || options.user !== false
    });
    if (options && options.immediate) {
      cb.call(vm, watcher.value);
    }
    return function unwatchFn() {
      watcher.teardown();
    };
  };

  /**
   * Evaluate a text directive, including filters.
   *
   * @param {String} text
   * @param {Boolean} [asStatement]
   * @return {String}
   */

  Vue.prototype.$eval = function (text, asStatement) {
    // check for filters.
    if (filterRE$1.test(text)) {
      var dir = parseDirective(text);
      // the filter regex check might give false positive
      // for pipes inside strings, so it's possible that
      // we don't get any filters here
      var val = this.$get(dir.expression, asStatement);
      return dir.filters ? this._applyFilters(val, null, dir.filters) : val;
    } else {
      // no filter
      return this.$get(text, asStatement);
    }
  };

  /**
   * Interpolate a piece of template text.
   *
   * @param {String} text
   * @return {String}
   */

  Vue.prototype.$interpolate = function (text) {
    var tokens = parseText(text);
    var vm = this;
    if (tokens) {
      if (tokens.length === 1) {
        return vm.$eval(tokens[0].value) + '';
      } else {
        return tokens.map(function (token) {
          return token.tag ? vm.$eval(token.value) : token.value;
        }).join('');
      }
    } else {
      return text;
    }
  };

  /**
   * Log instance data as a plain JS object
   * so that it is easier to inspect in console.
   * This method assumes console is available.
   *
   * @param {String} [path]
   */

  Vue.prototype.$log = function (path) {
    var data = path ? getPath(this._data, path) : this._data;
    if (data) {
      data = clean(data);
    }
    // include computed fields
    if (!path) {
      var key;
      for (key in this.$options.computed) {
        data[key] = clean(this[key]);
      }
      if (this._props) {
        for (key in this._props) {
          data[key] = clean(this[key]);
        }
      }
    }
    console.log(data);
  };

  /**
   * "clean" a getter/setter converted object into a plain
   * object copy.
   *
   * @param {Object} - obj
   * @return {Object}
   */

  function clean(obj) {
    return JSON.parse(JSON.stringify(obj));
  }
}

function domAPI (Vue) {
  /**
   * Convenience on-instance nextTick. The callback is
   * auto-bound to the instance, and this avoids component
   * modules having to rely on the global Vue.
   *
   * @param {Function} fn
   */

  Vue.prototype.$nextTick = function (fn) {
    nextTick(fn, this);
  };

  /**
   * Append instance to target
   *
   * @param {Node} target
   * @param {Function} [cb]
   * @param {Boolean} [withTransition] - defaults to true
   */

  Vue.prototype.$appendTo = function (target, cb, withTransition) {
    return insert(this, target, cb, withTransition, append, appendWithTransition);
  };

  /**
   * Prepend instance to target
   *
   * @param {Node} target
   * @param {Function} [cb]
   * @param {Boolean} [withTransition] - defaults to true
   */

  Vue.prototype.$prependTo = function (target, cb, withTransition) {
    target = query(target);
    if (target.hasChildNodes()) {
      this.$before(target.firstChild, cb, withTransition);
    } else {
      this.$appendTo(target, cb, withTransition);
    }
    return this;
  };

  /**
   * Insert instance before target
   *
   * @param {Node} target
   * @param {Function} [cb]
   * @param {Boolean} [withTransition] - defaults to true
   */

  Vue.prototype.$before = function (target, cb, withTransition) {
    return insert(this, target, cb, withTransition, beforeWithCb, beforeWithTransition);
  };

  /**
   * Insert instance after target
   *
   * @param {Node} target
   * @param {Function} [cb]
   * @param {Boolean} [withTransition] - defaults to true
   */

  Vue.prototype.$after = function (target, cb, withTransition) {
    target = query(target);
    if (target.nextSibling) {
      this.$before(target.nextSibling, cb, withTransition);
    } else {
      this.$appendTo(target.parentNode, cb, withTransition);
    }
    return this;
  };

  /**
   * Remove instance from DOM
   *
   * @param {Function} [cb]
   * @param {Boolean} [withTransition] - defaults to true
   */

  Vue.prototype.$remove = function (cb, withTransition) {
    if (!this.$el.parentNode) {
      return cb && cb();
    }
    var inDocument = this._isAttached && inDoc(this.$el);
    // if we are not in document, no need to check
    // for transitions
    if (!inDocument) withTransition = false;
    var self = this;
    var realCb = function realCb() {
      if (inDocument) self._callHook('detached');
      if (cb) cb();
    };
    if (this._isFragment) {
      removeNodeRange(this._fragmentStart, this._fragmentEnd, this, this._fragment, realCb);
    } else {
      var op = withTransition === false ? removeWithCb : removeWithTransition;
      op(this.$el, this, realCb);
    }
    return this;
  };

  /**
   * Shared DOM insertion function.
   *
   * @param {Vue} vm
   * @param {Element} target
   * @param {Function} [cb]
   * @param {Boolean} [withTransition]
   * @param {Function} op1 - op for non-transition insert
   * @param {Function} op2 - op for transition insert
   * @return vm
   */

  function insert(vm, target, cb, withTransition, op1, op2) {
    target = query(target);
    var targetIsDetached = !inDoc(target);
    var op = withTransition === false || targetIsDetached ? op1 : op2;
    var shouldCallHook = !targetIsDetached && !vm._isAttached && !inDoc(vm.$el);
    if (vm._isFragment) {
      mapNodeRange(vm._fragmentStart, vm._fragmentEnd, function (node) {
        op(node, target, vm);
      });
      cb && cb();
    } else {
      op(vm.$el, target, vm, cb);
    }
    if (shouldCallHook) {
      vm._callHook('attached');
    }
    return vm;
  }

  /**
   * Check for selectors
   *
   * @param {String|Element} el
   */

  function query(el) {
    return typeof el === 'string' ? document.querySelector(el) : el;
  }

  /**
   * Append operation that takes a callback.
   *
   * @param {Node} el
   * @param {Node} target
   * @param {Vue} vm - unused
   * @param {Function} [cb]
   */

  function append(el, target, vm, cb) {
    target.appendChild(el);
    if (cb) cb();
  }

  /**
   * InsertBefore operation that takes a callback.
   *
   * @param {Node} el
   * @param {Node} target
   * @param {Vue} vm - unused
   * @param {Function} [cb]
   */

  function beforeWithCb(el, target, vm, cb) {
    before(el, target);
    if (cb) cb();
  }

  /**
   * Remove operation that takes a callback.
   *
   * @param {Node} el
   * @param {Vue} vm - unused
   * @param {Function} [cb]
   */

  function removeWithCb(el, vm, cb) {
    remove(el);
    if (cb) cb();
  }
}

function eventsAPI (Vue) {
  /**
   * Listen on the given `event` with `fn`.
   *
   * @param {String} event
   * @param {Function} fn
   */

  Vue.prototype.$on = function (event, fn) {
    (this._events[event] || (this._events[event] = [])).push(fn);
    modifyListenerCount(this, event, 1);
    return this;
  };

  /**
   * Adds an `event` listener that will be invoked a single
   * time then automatically removed.
   *
   * @param {String} event
   * @param {Function} fn
   */

  Vue.prototype.$once = function (event, fn) {
    var self = this;
    function on() {
      self.$off(event, on);
      fn.apply(this, arguments);
    }
    on.fn = fn;
    this.$on(event, on);
    return this;
  };

  /**
   * Remove the given callback for `event` or all
   * registered callbacks.
   *
   * @param {String} event
   * @param {Function} fn
   */

  Vue.prototype.$off = function (event, fn) {
    var cbs;
    // all
    if (!arguments.length) {
      if (this.$parent) {
        for (event in this._events) {
          cbs = this._events[event];
          if (cbs) {
            modifyListenerCount(this, event, -cbs.length);
          }
        }
      }
      this._events = {};
      return this;
    }
    // specific event
    cbs = this._events[event];
    if (!cbs) {
      return this;
    }
    if (arguments.length === 1) {
      modifyListenerCount(this, event, -cbs.length);
      this._events[event] = null;
      return this;
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        modifyListenerCount(this, event, -1);
        cbs.splice(i, 1);
        break;
      }
    }
    return this;
  };

  /**
   * Trigger an event on self.
   *
   * @param {String|Object} event
   * @return {Boolean} shouldPropagate
   */

  Vue.prototype.$emit = function (event) {
    var isSource = typeof event === 'string';
    event = isSource ? event : event.name;
    var cbs = this._events[event];
    var shouldPropagate = isSource || !cbs;
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      // this is a somewhat hacky solution to the question raised
      // in #2102: for an inline component listener like <comp @test="doThis">,
      // the propagation handling is somewhat broken. Therefore we
      // need to treat these inline callbacks differently.
      var hasParentCbs = isSource && cbs.some(function (cb) {
        return cb._fromParent;
      });
      if (hasParentCbs) {
        shouldPropagate = false;
      }
      var args = toArray(arguments, 1);
      for (var i = 0, l = cbs.length; i < l; i++) {
        var cb = cbs[i];
        var res = cb.apply(this, args);
        if (res === true && (!hasParentCbs || cb._fromParent)) {
          shouldPropagate = true;
        }
      }
    }
    return shouldPropagate;
  };

  /**
   * Recursively broadcast an event to all children instances.
   *
   * @param {String|Object} event
   * @param {...*} additional arguments
   */

  Vue.prototype.$broadcast = function (event) {
    var isSource = typeof event === 'string';
    event = isSource ? event : event.name;
    // if no child has registered for this event,
    // then there's no need to broadcast.
    if (!this._eventsCount[event]) return;
    var children = this.$children;
    var args = toArray(arguments);
    if (isSource) {
      // use object event to indicate non-source emit
      // on children
      args[0] = { name: event, source: this };
    }
    for (var i = 0, l = children.length; i < l; i++) {
      var child = children[i];
      var shouldPropagate = child.$emit.apply(child, args);
      if (shouldPropagate) {
        child.$broadcast.apply(child, args);
      }
    }
    return this;
  };

  /**
   * Recursively propagate an event up the parent chain.
   *
   * @param {String} event
   * @param {...*} additional arguments
   */

  Vue.prototype.$dispatch = function (event) {
    var shouldPropagate = this.$emit.apply(this, arguments);
    if (!shouldPropagate) return;
    var parent = this.$parent;
    var args = toArray(arguments);
    // use object event to indicate non-source emit
    // on parents
    args[0] = { name: event, source: this };
    while (parent) {
      shouldPropagate = parent.$emit.apply(parent, args);
      parent = shouldPropagate ? parent.$parent : null;
    }
    return this;
  };

  /**
   * Modify the listener counts on all parents.
   * This bookkeeping allows $broadcast to return early when
   * no child has listened to a certain event.
   *
   * @param {Vue} vm
   * @param {String} event
   * @param {Number} count
   */

  var hookRE = /^hook:/;
  function modifyListenerCount(vm, event, count) {
    var parent = vm.$parent;
    // hooks do not get broadcasted so no need
    // to do bookkeeping for them
    if (!parent || !count || hookRE.test(event)) return;
    while (parent) {
      parent._eventsCount[event] = (parent._eventsCount[event] || 0) + count;
      parent = parent.$parent;
    }
  }
}

function lifecycleAPI (Vue) {
  /**
   * Set instance target element and kick off the compilation
   * process. The passed in `el` can be a selector string, an
   * existing Element, or a DocumentFragment (for block
   * instances).
   *
   * @param {Element|DocumentFragment|string} el
   * @public
   */

  Vue.prototype.$mount = function (el) {
    if (this._isCompiled) {
      'development' !== 'production' && warn('$mount() should be called only once.', this);
      return;
    }
    el = query(el);
    if (!el) {
      el = document.createElement('div');
    }
    this._compile(el);
    this._initDOMHooks();
    if (inDoc(this.$el)) {
      this._callHook('attached');
      ready.call(this);
    } else {
      this.$once('hook:attached', ready);
    }
    return this;
  };

  /**
   * Mark an instance as ready.
   */

  function ready() {
    this._isAttached = true;
    this._isReady = true;
    this._callHook('ready');
  }

  /**
   * Teardown the instance, simply delegate to the internal
   * _destroy.
   *
   * @param {Boolean} remove
   * @param {Boolean} deferCleanup
   */

  Vue.prototype.$destroy = function (remove, deferCleanup) {
    this._destroy(remove, deferCleanup);
  };

  /**
   * Partially compile a piece of DOM and return a
   * decompile function.
   *
   * @param {Element|DocumentFragment} el
   * @param {Vue} [host]
   * @param {Object} [scope]
   * @param {Fragment} [frag]
   * @return {Function}
   */

  Vue.prototype.$compile = function (el, host, scope, frag) {
    return compile(el, this.$options, true)(this, el, host, scope, frag);
  };
}

/**
 * The exposed Vue constructor.
 *
 * API conventions:
 * - public API methods/properties are prefixed with `$`
 * - internal methods/properties are prefixed with `_`
 * - non-prefixed properties are assumed to be proxied user
 *   data.
 *
 * @constructor
 * @param {Object} [options]
 * @public
 */

function Vue(options) {
  this._init(options);
}

// install internals
initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
miscMixin(Vue);

// install instance APIs
dataAPI(Vue);
domAPI(Vue);
eventsAPI(Vue);
lifecycleAPI(Vue);

var slot = {

  priority: SLOT,
  params: ['name'],

  bind: function bind() {
    // this was resolved during component transclusion
    var name = this.params.name || 'default';
    var content = this.vm._slotContents && this.vm._slotContents[name];
    if (!content || !content.hasChildNodes()) {
      this.fallback();
    } else {
      this.compile(content.cloneNode(true), this.vm._context, this.vm);
    }
  },

  compile: function compile(content, context, host) {
    if (content && context) {
      if (this.el.hasChildNodes() && content.childNodes.length === 1 && content.childNodes[0].nodeType === 1 && content.childNodes[0].hasAttribute('v-if')) {
        // if the inserted slot has v-if
        // inject fallback content as the v-else
        var elseBlock = document.createElement('template');
        elseBlock.setAttribute('v-else', '');
        elseBlock.innerHTML = this.el.innerHTML;
        // the else block should be compiled in child scope
        elseBlock._context = this.vm;
        content.appendChild(elseBlock);
      }
      var scope = host ? host._scope : this._scope;
      this.unlink = context.$compile(content, host, scope, this._frag);
    }
    if (content) {
      replace(this.el, content);
    } else {
      remove(this.el);
    }
  },

  fallback: function fallback() {
    this.compile(extractContent(this.el, true), this.vm);
  },

  unbind: function unbind() {
    if (this.unlink) {
      this.unlink();
    }
  }
};

var partial = {

  priority: PARTIAL,

  params: ['name'],

  // watch changes to name for dynamic partials
  paramWatchers: {
    name: function name(value) {
      vIf.remove.call(this);
      if (value) {
        this.insert(value);
      }
    }
  },

  bind: function bind() {
    this.anchor = createAnchor('v-partial');
    replace(this.el, this.anchor);
    this.insert(this.params.name);
  },

  insert: function insert(id) {
    var partial = resolveAsset(this.vm.$options, 'partials', id, true);
    if (partial) {
      this.factory = new FragmentFactory(this.vm, partial);
      vIf.insert.call(this);
    }
  },

  unbind: function unbind() {
    if (this.frag) {
      this.frag.destroy();
    }
  }
};

var elementDirectives = {
  slot: slot,
  partial: partial
};

var convertArray = vFor._postProcess;

/**
 * Limit filter for arrays
 *
 * @param {Number} n
 * @param {Number} offset (Decimal expected)
 */

function limitBy(arr, n, offset) {
  offset = offset ? parseInt(offset, 10) : 0;
  n = toNumber(n);
  return typeof n === 'number' ? arr.slice(offset, offset + n) : arr;
}

/**
 * Filter filter for arrays
 *
 * @param {String} search
 * @param {String} [delimiter]
 * @param {String} ...dataKeys
 */

function filterBy(arr, search, delimiter) {
  arr = convertArray(arr);
  if (search == null) {
    return arr;
  }
  if (typeof search === 'function') {
    return arr.filter(search);
  }
  // cast to lowercase string
  search = ('' + search).toLowerCase();
  // allow optional `in` delimiter
  // because why not
  var n = delimiter === 'in' ? 3 : 2;
  // extract and flatten keys
  var keys = Array.prototype.concat.apply([], toArray(arguments, n));
  var res = [];
  var item, key, val, j;
  for (var i = 0, l = arr.length; i < l; i++) {
    item = arr[i];
    val = item && item.$value || item;
    j = keys.length;
    if (j) {
      while (j--) {
        key = keys[j];
        if (key === '$key' && contains(item.$key, search) || contains(getPath(val, key), search)) {
          res.push(item);
          break;
        }
      }
    } else if (contains(item, search)) {
      res.push(item);
    }
  }
  return res;
}

/**
 * Order filter for arrays
 *
 * @param {String|Array<String>|Function} ...sortKeys
 * @param {Number} [order]
 */

function orderBy(arr) {
  var comparator = null;
  var sortKeys = undefined;
  arr = convertArray(arr);

  // determine order (last argument)
  var args = toArray(arguments, 1);
  var order = args[args.length - 1];
  if (typeof order === 'number') {
    order = order < 0 ? -1 : 1;
    args = args.length > 1 ? args.slice(0, -1) : args;
  } else {
    order = 1;
  }

  // determine sortKeys & comparator
  var firstArg = args[0];
  if (!firstArg) {
    return arr;
  } else if (typeof firstArg === 'function') {
    // custom comparator
    comparator = function (a, b) {
      return firstArg(a, b) * order;
    };
  } else {
    // string keys. flatten first
    sortKeys = Array.prototype.concat.apply([], args);
    comparator = function (a, b, i) {
      i = i || 0;
      return i >= sortKeys.length - 1 ? baseCompare(a, b, i) : baseCompare(a, b, i) || comparator(a, b, i + 1);
    };
  }

  function baseCompare(a, b, sortKeyIndex) {
    var sortKey = sortKeys[sortKeyIndex];
    if (sortKey) {
      if (sortKey !== '$key') {
        if (isObject(a) && '$value' in a) a = a.$value;
        if (isObject(b) && '$value' in b) b = b.$value;
      }
      a = isObject(a) ? getPath(a, sortKey) : a;
      b = isObject(b) ? getPath(b, sortKey) : b;
    }
    return a === b ? 0 : a > b ? order : -order;
  }

  // sort on a copy to avoid mutating original array
  return arr.slice().sort(comparator);
}

/**
 * String contain helper
 *
 * @param {*} val
 * @param {String} search
 */

function contains(val, search) {
  var i;
  if (isPlainObject(val)) {
    var keys = Object.keys(val);
    i = keys.length;
    while (i--) {
      if (contains(val[keys[i]], search)) {
        return true;
      }
    }
  } else if (isArray(val)) {
    i = val.length;
    while (i--) {
      if (contains(val[i], search)) {
        return true;
      }
    }
  } else if (val != null) {
    return val.toString().toLowerCase().indexOf(search) > -1;
  }
}

var digitsRE = /(\d{3})(?=\d)/g;

// asset collections must be a plain object.
var filters = {

  orderBy: orderBy,
  filterBy: filterBy,
  limitBy: limitBy,

  /**
   * Stringify value.
   *
   * @param {Number} indent
   */

  json: {
    read: function read(value, indent) {
      return typeof value === 'string' ? value : JSON.stringify(value, null, arguments.length > 1 ? indent : 2);
    },
    write: function write(value) {
      try {
        return JSON.parse(value);
      } catch (e) {
        return value;
      }
    }
  },

  /**
   * 'abc' => 'Abc'
   */

  capitalize: function capitalize(value) {
    if (!value && value !== 0) return '';
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
  },

  /**
   * 'abc' => 'ABC'
   */

  uppercase: function uppercase(value) {
    return value || value === 0 ? value.toString().toUpperCase() : '';
  },

  /**
   * 'AbC' => 'abc'
   */

  lowercase: function lowercase(value) {
    return value || value === 0 ? value.toString().toLowerCase() : '';
  },

  /**
   * 12345 => $12,345.00
   *
   * @param {String} sign
   * @param {Number} decimals Decimal places
   */

  currency: function currency(value, _currency, decimals) {
    value = parseFloat(value);
    if (!isFinite(value) || !value && value !== 0) return '';
    _currency = _currency != null ? _currency : '$';
    decimals = decimals != null ? decimals : 2;
    var stringified = Math.abs(value).toFixed(decimals);
    var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
    var i = _int.length % 3;
    var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : '';
    var _float = decimals ? stringified.slice(-1 - decimals) : '';
    var sign = value < 0 ? '-' : '';
    return sign + _currency + head + _int.slice(i).replace(digitsRE, '$1,') + _float;
  },

  /**
   * 'item' => 'items'
   *
   * @params
   *  an array of strings corresponding to
   *  the single, double, triple ... forms of the word to
   *  be pluralized. When the number to be pluralized
   *  exceeds the length of the args, it will use the last
   *  entry in the array.
   *
   *  e.g. ['single', 'double', 'triple', 'multiple']
   */

  pluralize: function pluralize(value) {
    var args = toArray(arguments, 1);
    var length = args.length;
    if (length > 1) {
      var index = value % 10 - 1;
      return index in args ? args[index] : args[length - 1];
    } else {
      return args[0] + (value === 1 ? '' : 's');
    }
  },

  /**
   * Debounce a handler function.
   *
   * @param {Function} handler
   * @param {Number} delay = 300
   * @return {Function}
   */

  debounce: function debounce(handler, delay) {
    if (!handler) return;
    if (!delay) {
      delay = 300;
    }
    return _debounce(handler, delay);
  }
};

function installGlobalAPI (Vue) {
  /**
   * Vue and every constructor that extends Vue has an
   * associated options object, which can be accessed during
   * compilation steps as `this.constructor.options`.
   *
   * These can be seen as the default options of every
   * Vue instance.
   */

  Vue.options = {
    directives: directives,
    elementDirectives: elementDirectives,
    filters: filters,
    transitions: {},
    components: {},
    partials: {},
    replace: true
  };

  /**
   * Expose useful internals
   */

  Vue.util = util;
  Vue.config = config;
  Vue.set = set;
  Vue['delete'] = del;
  Vue.nextTick = nextTick;

  /**
   * The following are exposed for advanced usage / plugins
   */

  Vue.compiler = compiler;
  Vue.FragmentFactory = FragmentFactory;
  Vue.internalDirectives = internalDirectives;
  Vue.parsers = {
    path: path,
    text: text,
    template: template,
    directive: directive,
    expression: expression
  };

  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */

  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   *
   * @param {Object} extendOptions
   */

  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var isFirstExtend = Super.cid === 0;
    if (isFirstExtend && extendOptions._Ctor) {
      return extendOptions._Ctor;
    }
    var name = extendOptions.name || Super.options.name;
    if ('development' !== 'production') {
      if (!/^[a-zA-Z][\w-]*$/.test(name)) {
        warn('Invalid component name: "' + name + '". Component names ' + 'can only contain alphanumeric characaters and the hyphen.');
        name = null;
      }
    }
    var Sub = createClass(name || 'VueComponent');
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(Super.options, extendOptions);
    Sub['super'] = Super;
    // allow further extension
    Sub.extend = Super.extend;
    // create asset registers, so extended classes
    // can have their private assets too.
    config._assetTypes.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }
    // cache constructor
    if (isFirstExtend) {
      extendOptions._Ctor = Sub;
    }
    return Sub;
  };

  /**
   * A function that returns a sub-class constructor with the
   * given name. This gives us much nicer output when
   * logging instances in the console.
   *
   * @param {String} name
   * @return {Function}
   */

  function createClass(name) {
    /* eslint-disable no-new-func */
    return new Function('return function ' + classify(name) + ' (options) { this._init(options) }')();
    /* eslint-enable no-new-func */
  }

  /**
   * Plugin system
   *
   * @param {Object} plugin
   */

  Vue.use = function (plugin) {
    /* istanbul ignore if */
    if (plugin.installed) {
      return;
    }
    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else {
      plugin.apply(null, args);
    }
    plugin.installed = true;
    return this;
  };

  /**
   * Apply a global mixin by merging it into the default
   * options.
   */

  Vue.mixin = function (mixin) {
    Vue.options = mergeOptions(Vue.options, mixin);
  };

  /**
   * Create asset registration methods with the following
   * signature:
   *
   * @param {String} id
   * @param {*} definition
   */

  config._assetTypes.forEach(function (type) {
    Vue[type] = function (id, definition) {
      if (!definition) {
        return this.options[type + 's'][id];
      } else {
        /* istanbul ignore if */
        if ('development' !== 'production') {
          if (type === 'component' && (commonTagRE.test(id) || reservedTagRE.test(id))) {
            warn('Do not use built-in or reserved HTML elements as component ' + 'id: ' + id);
          }
        }
        if (type === 'component' && isPlainObject(definition)) {
          if (!definition.name) {
            definition.name = id;
          }
          definition = Vue.extend(definition);
        }
        this.options[type + 's'][id] = definition;
        return definition;
      }
    };
  });

  // expose internal transition API
  extend(Vue.transition, transition);
}

installGlobalAPI(Vue);

Vue.version = '1.0.28';

// devtools global hook
/* istanbul ignore next */
setTimeout(function () {
  if (config.devtools) {
    if (devtools) {
      devtools.emit('init', Vue);
    } else if ('development' !== 'production' && inBrowser && /Chrome\/\d+/.test(window.navigator.userAgent)) {
      console.log('Download the Vue Devtools for a better development experience:\n' + 'https://github.com/vuejs/vue-devtools');
    }
  }
}, 0);

return Vue;

})));
},
'vue/vue-strap':function(){
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["VueStrap"] = factory();
	else
		root["VueStrap"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Alert = __webpack_require__(23);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _Carousel = __webpack_require__(31);
	
	var _Carousel2 = _interopRequireDefault(_Carousel);
	
	var _Slider = __webpack_require__(75);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	var _Accordion = __webpack_require__(78);
	
	var _Accordion2 = _interopRequireDefault(_Accordion);
	
	var _Affix = __webpack_require__(81);
	
	var _Affix2 = _interopRequireDefault(_Affix);
	
	var _Aside = __webpack_require__(86);
	
	var _Aside2 = _interopRequireDefault(_Aside);
	
	var _checkboxGroup = __webpack_require__(92);
	
	var _checkboxGroup2 = _interopRequireDefault(_checkboxGroup);
	
	var _checkboxBtn = __webpack_require__(95);
	
	var _checkboxBtn2 = _interopRequireDefault(_checkboxBtn);
	
	var _Datepicker = __webpack_require__(98);
	
	var _Datepicker2 = _interopRequireDefault(_Datepicker);
	
	var _Dropdown = __webpack_require__(105);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _Modal = __webpack_require__(108);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Option = __webpack_require__(117);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _Panel = __webpack_require__(122);
	
	var _Panel2 = _interopRequireDefault(_Panel);
	
	var _Popover = __webpack_require__(127);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _Progressbar = __webpack_require__(133);
	
	var _Progressbar2 = _interopRequireDefault(_Progressbar);
	
	var _radioBtn = __webpack_require__(136);
	
	var _radioBtn2 = _interopRequireDefault(_radioBtn);
	
	var _radioGroup = __webpack_require__(139);
	
	var _radioGroup2 = _interopRequireDefault(_radioGroup);
	
	var _Select = __webpack_require__(142);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Tab = __webpack_require__(147);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _Tabset = __webpack_require__(152);
	
	var _Tabset2 = _interopRequireDefault(_Tabset);
	
	var _Tooltip = __webpack_require__(157);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Typeahead = __webpack_require__(162);
	
	var _Typeahead2 = _interopRequireDefault(_Typeahead);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VueStrap = {
	  alert: _Alert2.default,
	  carousel: _Carousel2.default,
	  slider: _Slider2.default,
	  accordion: _Accordion2.default,
	  affix: _Affix2.default,
	  aside: _Aside2.default,
	  checkboxBtn: _checkboxBtn2.default,
	  checkboxGroup: _checkboxGroup2.default,
	  datepicker: _Datepicker2.default,
	  dropdown: _Dropdown2.default,
	  modal: _Modal2.default,
	  option: _Option2.default,
	  panel: _Panel2.default,
	  popover: _Popover2.default,
	  progressbar: _Progressbar2.default,
	  radioGroup: _radioGroup2.default,
	  radioBtn: _radioBtn2.default,
	  select: _Select2.default,
	  tab: _Tab2.default,
	  tabset: _Tabset2.default,
	  tooltip: _Tooltip2.default,
	  typeahead: _Typeahead2.default
	};
	
	module.exports = VueStrap;

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(24)
	module.exports = __webpack_require__(28)
	
	if (module.exports.__esModule) module.exports = module.exports.default
	;(typeof module.exports === "function" ? module.exports.options : module.exports).template = __webpack_require__(30)
	if (false) {
	(function () {
	var hotAPI = require("vue-hot-reload-api")
	hotAPI.install(require("vue"))
	if (!hotAPI.compatible) return
	var id = "-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Alert.vue"
	hotAPI.createRecord(id, module.exports)
	module.hot.accept(["-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Alert.vue","-!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Alert.vue"], function () {
	var newOptions = require("-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Alert.vue")
	if (newOptions && newOptions.__esModule) newOptions = newOptions.default
	var newTemplate = require("-!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Alert.vue")
	hotAPI.update(id, newOptions, newTemplate)
	})
	})()
	}

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(25);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./../node_modules/vue-loader/lib/style-rewriter.js?id=_v-3ac938d8&file=Alert.vue!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Alert.vue", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./../node_modules/vue-loader/lib/style-rewriter.js?id=_v-3ac938d8&file=Alert.vue!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Alert.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(26)();
	// imports
	
	
	// module
	exports.push([module.id, ".fade-transition {\n  -webkit-transition: opacity .3s ease;\n  transition: opacity .3s ease;\n}\n.fade-enter,\n.fade-leave {\n  height: 0;\n  opacity: 0;\n}\n.alert.top {\n  position: fixed;\n  top: 30px;\n  margin: 0 auto;\n  left: 0;\n  right: 0;\n  z-index: 2;\n}\n.alert.top-right {\n  position: fixed;\n  top: 30px;\n  right: 50px;\n  z-index: 2;\n}", ""]);
	
	// exports


/***/ },
/* 26 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _coerceBoolean = __webpack_require__(29);
	
	var _coerceBoolean2 = _interopRequireDefault(_coerceBoolean);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    type: {
	      type: String
	    },
	    dismissable: {
	      type: Boolean,
	      coerce: _coerceBoolean2.default,
	      default: false
	    },
	    show: {
	      type: Boolean,
	      coerce: _coerceBoolean2.default,
	      default: true,
	      twoWay: true
	    },
	    duration: {
	      type: Number,
	      default: 0
	    },
	    width: {
	      type: String
	    },
	    placement: {
	      type: String
	    }
	  },
	  watch: {
	    show: function show(val) {
	      var _this = this;
	
	      if (this._timeout) clearTimeout(this._timeout);
	      if (val && Boolean(this.duration)) {
	        this._timeout = setTimeout(function () {
	          return _this.show = false;
	        }, this.duration);
	      }
	    }
	  }
	};
	// </script>

	// <style>
	// .fade-transition {
	//   transition: opacity .3s ease;
	// }
	// .fade-enter,
	// .fade-leave {
	//   height: 0;
	//   opacity: 0;
	// }
	// .alert.top {
	//   position: fixed;
	//   top: 30px;
	//   margin: 0 auto;
	//   left: 0;
	//   right: 0;
	//   z-index: 2;
	// }
	// .alert.top-right {
	//   position: fixed;
	//   top: 30px;
	//   right: 50px;
	//   z-index: 2;
	// }
	// </style>
	// <template>
	//   <div
	//     v-show="show"
	//     v-bind:class="{
	//       'alert':		true,
	//       'alert-success':(type == 'success'),
	//       'alert-warning':(type == 'warning'),
	//       'alert-info':	(type == 'info'),
	//       'alert-danger':	(type == 'danger'),
	//       'top': 			(placement === 'top'),
	//       'top-right': 	(placement === 'top-right')
	//     }"
	//     transition="fade"
	//     v-bind:style="{width:width}"
	//     role="alert">
	//     <button v-show="dismissable" type="button" class="close"
	//       @click="show = false">
	//       <span>&times;</span>
	//     </button>
	//     <slot></slot>
	//   </div>
	// </template>

	// <script>

/***/ },
/* 29 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Attempt to convert a string value to a Boolean. Otherwise, return the value
	// without modification so Vue can throw a warning.
	
	exports.default = function (val) {
	  return typeof val !== "string" ? val : val === "true" ? true : val === "false" ? false : val === "null" ? false : val === "undefined" ? false : val;
	};

/***/ },
/* 30 */
/***/ function(module, exports) {

	module.exports = "<div\n    v-show=\"show\"\n    v-bind:class=\"{\n      'alert':\t\ttrue,\n      'alert-success':(type == 'success'),\n      'alert-warning':(type == 'warning'),\n      'alert-info':\t(type == 'info'),\n      'alert-danger':\t(type == 'danger'),\n      'top': \t\t\t(placement === 'top'),\n      'top-right': \t(placement === 'top-right')\n    }\"\n    transition=\"fade\"\n    v-bind:style=\"{width:width}\"\n    role=\"alert\">\n    <button v-show=\"dismissable\" type=\"button\" class=\"close\"\n      @click=\"show = false\">\n      <span>&times;</span>\n    </button>\n    <slot></slot>\n  </div>";

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(32)
	module.exports = __webpack_require__(34)
	
	if (module.exports.__esModule) module.exports = module.exports.default
	;(typeof module.exports === "function" ? module.exports.options : module.exports).template = __webpack_require__(74)
	if (false) {
	(function () {
	var hotAPI = require("vue-hot-reload-api")
	hotAPI.install(require("vue"))
	if (!hotAPI.compatible) return
	var id = "-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Carousel.vue"
	hotAPI.createRecord(id, module.exports)
	module.hot.accept(["-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Carousel.vue","-!vue-html-loader!./../node_modules/vue-loader/lib/template-rewriter.js?id=_v-619cca58&file=Carousel.vue!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Carousel.vue"], function () {
	var newOptions = require("-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Carousel.vue")
	if (newOptions && newOptions.__esModule) newOptions = newOptions.default
	var newTemplate = require("-!vue-html-loader!./../node_modules/vue-loader/lib/template-rewriter.js?id=_v-619cca58&file=Carousel.vue!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Carousel.vue")
	hotAPI.update(id, newOptions, newTemplate)
	})
	})()
	}

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(33);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./../node_modules/vue-loader/lib/style-rewriter.js?id=_v-619cca58&file=Carousel.vue&scoped=true!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Carousel.vue", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./../node_modules/vue-loader/lib/style-rewriter.js?id=_v-619cca58&file=Carousel.vue&scoped=true!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Carousel.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(26)();
	// imports
	
	
	// module
	exports.push([module.id, ".carousel-control[_v-619cca58] {\n    cursor: pointer;\n  }", ""]);
	
	// exports


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(35);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _EventListener = __webpack_require__(73);
	
	var _EventListener2 = _interopRequireDefault(_EventListener);
	
	var _coerceBoolean = __webpack_require__(29);
	
	var _coerceBoolean2 = _interopRequireDefault(_coerceBoolean);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// <template>
	// <div class="carousel slide" data-ride="carousel">
	//   <!-- Indicators -->
	//   <ol class="carousel-indicators" v-show="indicators">
	//     <indicator></indicator>
	//   </ol>
	//   <!-- Wrapper for slides -->
	//   <div class="carousel-inner" role="listbox">
	//     <slot></slot>
	//   </div>
	//   <!-- Controls -->
	//   <a v-show="controls" class="left carousel-control" @click="prevClick">
	//     <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
	//     <span class="sr-only">Previous</span>
	//   </a>
	//   <a v-show="controls" class="right carousel-control" @click="nextClick">
	//     <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
	//     <span class="sr-only">Next</span>
	//   </a>
	// </div>
	// </template>
	
	// <script>
	exports.default = {
	  props: {
	    indicators: {
	      type: Boolean,
	      coerce: _coerceBoolean2.default,
	      default: true
	    },
	    controls: {
	      type: Boolean,
	      coerce: _coerceBoolean2.default,
	      default: true
	    },
	    interval: {
	      type: Number,
	      default: 5000
	    }
	  },
	  components: {
	    'indicator': {
	      inherit: true,
	      template: '<li v-for="i in indicator" @click="handleIndicatorClick($index)" v-bind:class="{\'active\':$index === activeIndex}"</li>',
	      methods: {
	        handleIndicatorClick: function handleIndicatorClick(index) {
	          if (this.isAnimating) return false;
	          this.isAnimating = true;
	          this.activeIndex = index;
	        }
	      }
	    }
	  },
	  data: function data() {
	    return {
	      indicator: [],
	      activeIndex: 0,
	      isAnimating: false
	    };
	  },
	
	  computed: {
	    slider: function slider() {
	      return this.$el.querySelectorAll('.item');
	    }
	  },
	  watch: {
	    activeIndex: function activeIndex(newVal, oldVal) {
	      newVal > oldVal ? this.slide('left', newVal, oldVal) : this.slide('right', newVal, oldVal);
	    }
	  },
	  methods: {
	    slide: function slide(direction, selected, prev) {
	      var _this = this;
	
	      if (this._prevSelectedEvent) this._prevSelectedEvent.remove();
	      if (this._selectedEvent) this._selectedEvent.remove();
	
	      var prevSelectedEl = this.slider[prev];
	      var selectedEl = this.slider[selected];
	      var transitionendFn = function transitionendFn() {
	        [].concat((0, _toConsumableArray3.default)(_this.slider)).forEach(function (el) {
	          return el.className = 'item';
	        });
	        selectedEl.classList.add('active');
	        _this.isAnimating = false;
	      };
	
	      direction === 'left' ? selectedEl.classList.add('next') : selectedEl.classList.add('prev');
	      // request property that requires layout to force a layout
	      var x = selectedEl.clientHeight;
	      this._prevSelectedEvent = _EventListener2.default.listen(prevSelectedEl, 'transitionend', transitionendFn);
	      this._selectedEvent = _EventListener2.default.listen(selectedEl, 'transitionend', transitionendFn);
	      prevSelectedEl.classList.add(direction);
	      selectedEl.classList.add(direction);
	    },
	    nextClick: function nextClick() {
	      if (this.isAnimating) return false;
	      this.isAnimating = true;
	      this.activeIndex + 1 < this.slider.length ? this.activeIndex += 1 : this.activeIndex = 0;
	    },
	    prevClick: function prevClick() {
	      if (this.isAnimating) return false;
	      this.isAnimating = true;
	      this.activeIndex === 0 ? this.activeIndex = this.slider.length - 1 : this.activeIndex -= 1;
	    }
	  },
	  ready: function ready() {
	    var _this2 = this;
	
	    var intervalID = null;
	    var el = this.$el;
	    function intervalManager(flag, func, time) {
	      flag ? intervalID = setInterval(func, time) : clearInterval(intervalID);
	    }
	    if (!!this.interval) {
	      intervalManager(true, this.nextClick, this.interval);
	      el.addEventListener('mouseenter', function () {
	        return intervalManager(false);
	      });
	      el.addEventListener('mouseleave', function () {
	        return intervalManager(true, _this2.nextClick, _this2.interval);
	      });
	    }
	  }
	};
	// </script>

	// <style scoped>
	//   .carousel-control {
	//     cursor: pointer;
	//   }
	// </style>

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _from = __webpack_require__(36);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};
	
	exports.__esModule = true;

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(37), __esModule: true };

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(38);
	__webpack_require__(62);
	module.exports = __webpack_require__(46).Array.from;

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(39)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(42)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(40)
	  , defined   = __webpack_require__(41);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },
/* 40 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 41 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(43)
	  , $export        = __webpack_require__(44)
	  , redefine       = __webpack_require__(49)
	  , hide           = __webpack_require__(50)
	  , has            = __webpack_require__(55)
	  , Iterators      = __webpack_require__(56)
	  , $iterCreate    = __webpack_require__(57)
	  , setToStringTag = __webpack_require__(58)
	  , getProto       = __webpack_require__(51).getProto
	  , ITERATOR       = __webpack_require__(59)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , methods, key;
	  // Fix native
	  if($native){
	    var IteratorPrototype = getProto($default.call(new Base));
	    // Set @@toStringTag to native iterators
	    setToStringTag(IteratorPrototype, TAG, true);
	    // FF fix
	    if(!LIBRARY && has(proto, FF_ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    // fix Array#{values, @@iterator}.name in V8 / FF
	    if(DEF_VALUES && $native.name !== VALUES){
	      VALUES_BUG = true;
	      $default = function values(){ return $native.call(this); };
	    }
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES  ? $default : getMethod(VALUES),
	      keys:    IS_SET      ? $default : getMethod(KEYS),
	      entries: !DEF_VALUES ? $default : getMethod('entries')
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ },
/* 43 */
/***/ function(module, exports) {

	module.exports = true;

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(45)
	  , core      = __webpack_require__(46)
	  , ctx       = __webpack_require__(47)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && key in target;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(param){
	        return this instanceof C ? new C(param) : C(param);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    if(IS_PROTO)(exports[PROTOTYPE] || (exports[PROTOTYPE] = {}))[key] = out;
	  }
	};
	// type bitmap
	$export.F = 1;  // forced
	$export.G = 2;  // global
	$export.S = 4;  // static
	$export.P = 8;  // proto
	$export.B = 16; // bind
	$export.W = 32; // wrap
	module.exports = $export;

/***/ },
/* 45 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 46 */
/***/ function(module, exports) {

	var core = module.exports = {version: '1.2.6'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(48);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 48 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(50);

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	var $          = __webpack_require__(51)
	  , createDesc = __webpack_require__(52);
	module.exports = __webpack_require__(53) ? function(object, key, value){
	  return $.setDesc(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 51 */
/***/ function(module, exports) {

	var $Object = Object;
	module.exports = {
	  create:     $Object.create,
	  getProto:   $Object.getPrototypeOf,
	  isEnum:     {}.propertyIsEnumerable,
	  getDesc:    $Object.getOwnPropertyDescriptor,
	  setDesc:    $Object.defineProperty,
	  setDescs:   $Object.defineProperties,
	  getKeys:    $Object.keys,
	  getNames:   $Object.getOwnPropertyNames,
	  getSymbols: $Object.getOwnPropertySymbols,
	  each:       [].forEach
	};

/***/ },
/* 52 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(54)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 54 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 55 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 56 */
/***/ function(module, exports) {

	module.exports = {};

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $              = __webpack_require__(51)
	  , descriptor     = __webpack_require__(52)
	  , setToStringTag = __webpack_require__(58)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(50)(IteratorPrototype, __webpack_require__(59)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = $.create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(51).setDesc
	  , has = __webpack_require__(55)
	  , TAG = __webpack_require__(59)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	var store  = __webpack_require__(60)('wks')
	  , uid    = __webpack_require__(61)
	  , Symbol = __webpack_require__(45).Symbol;
	module.exports = function(name){
	  return store[name] || (store[name] =
	    Symbol && Symbol[name] || (Symbol || uid)('Symbol.' + name));
	};

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(45)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 61 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx         = __webpack_require__(47)
	  , $export     = __webpack_require__(44)
	  , toObject    = __webpack_require__(63)
	  , call        = __webpack_require__(64)
	  , isArrayIter = __webpack_require__(67)
	  , toLength    = __webpack_require__(68)
	  , getIterFn   = __webpack_require__(69);
	$export($export.S + $export.F * !__webpack_require__(72)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , $$      = arguments
	      , $$len   = $$.length
	      , mapfn   = $$len > 1 ? $$[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, $$len > 2 ? $$[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        result[index] = mapping ? call(iterator, mapfn, [step.value, index], true) : step.value;
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        result[index] = mapping ? mapfn(O[index], index) : O[index];
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(41);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(65);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(66);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 66 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(56)
	  , ITERATOR   = __webpack_require__(59)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(40)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(70)
	  , ITERATOR  = __webpack_require__(59)('iterator')
	  , Iterators = __webpack_require__(56);
	module.exports = __webpack_require__(46).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(71)
	  , TAG = __webpack_require__(59)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = (O = Object(it))[TAG]) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ },
/* 71 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR     = __webpack_require__(59)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ safe = true; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ },
/* 73 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  }
	};
	
	exports.default = EventListener;

/***/ },
/* 74 */
/***/ function(module, exports) {

	module.exports = "<div class=\"carousel slide\" data-ride=\"carousel\" _v-619cca58=\"\">\n  <!-- Indicators -->\n  <ol class=\"carousel-indicators\" v-show=\"indicators\" _v-619cca58=\"\">\n    <indicator _v-619cca58=\"\"></indicator>\n  </ol>\n  <!-- Wrapper for slides -->\n  <div class=\"carousel-inner\" role=\"listbox\" _v-619cca58=\"\">\n    <slot _v-619cca58=\"\"></slot>\n  </div>\n  <!-- Controls -->\n  <a v-show=\"controls\" class=\"left carousel-control\" @click=\"prevClick\" _v-619cca58=\"\">\n    <span class=\"glyphicon glyphicon-chevron-left\" aria-hidden=\"true\" _v-619cca58=\"\"></span>\n    <span class=\"sr-only\" _v-619cca58=\"\">Previous</span>\n  </a>\n  <a v-show=\"controls\" class=\"right carousel-control\" @click=\"nextClick\" _v-619cca58=\"\">\n    <span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\" _v-619cca58=\"\"></span>\n    <span class=\"sr-only\" _v-619cca58=\"\">Next</span>\n  </a>\n</div>";

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(76)
	
	if (module.exports.__esModule) module.exports = module.exports.default
	;(typeof module.exports === "function" ? module.exports.options : module.exports).template = __webpack_require__(77)
	if (false) {
	(function () {
	var hotAPI = require("vue-hot-reload-api")
	hotAPI.install(require("vue"))
	if (!hotAPI.compatible) return
	var id = "-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Slider.vue"
	hotAPI.createRecord(id, module.exports)
	module.hot.accept(["-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Slider.vue","-!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Slider.vue"], function () {
	var newOptions = require("-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Slider.vue")
	if (newOptions && newOptions.__esModule) newOptions = newOptions.default
	var newTemplate = require("-!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Slider.vue")
	hotAPI.update(id, newOptions, newTemplate)
	})
	})()
	}

/***/ },
/* 76 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// <template>
	//   <div class="item">
	//     <slot></slot>
	//   </div>
	// </template>
	
	// <script>
	exports.default = {
	  data: function data() {
	    return {
	      index: 0,
	      show: false
	    };
	  },
	
	  computed: {
	    show: function show() {
	      return this.$parent.activeIndex === this.index;
	    }
	  },
	  ready: function ready() {
	    for (var c in this.$parent.$children) {
	      if (this.$parent.$children[c].$el == this.$el) {
	        this.index = parseInt(c, 10);
	        break;
	      }
	    }
	    //this.index = [...this.$el.parentNode.children].indexOf(this.$el)
	    this.$parent.indicator.push(this.index);
	    if (this.index === 0) {
	      this.$el.classList.add('active');
	    }
	  }
	};
	// </script>

/***/ },
/* 77 */
/***/ function(module, exports) {

	module.exports = "<div class=\"item\">\n    <slot></slot>\n  </div>";

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(79)
	
	if (module.exports.__esModule) module.exports = module.exports.default
	;(typeof module.exports === "function" ? module.exports.options : module.exports).template = __webpack_require__(80)
	if (false) {
	(function () {
	var hotAPI = require("vue-hot-reload-api")
	hotAPI.install(require("vue"))
	if (!hotAPI.compatible) return
	var id = "-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Accordion.vue"
	hotAPI.createRecord(id, module.exports)
	module.hot.accept(["-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Accordion.vue","-!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Accordion.vue"], function () {
	var newOptions = require("-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Accordion.vue")
	if (newOptions && newOptions.__esModule) newOptions = newOptions.default
	var newTemplate = require("-!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Accordion.vue")
	hotAPI.update(id, newOptions, newTemplate)
	})
	})()
	}

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _coerceBoolean = __webpack_require__(29);
	
	var _coerceBoolean2 = _interopRequireDefault(_coerceBoolean);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    oneAtATime: {
	      type: Boolean,
	      coerce: _coerceBoolean2.default,
	      default: false
	    }
	  },
	  created: function created() {
	    var _this = this;
	
	    this.$on('isOpenEvent', function (child) {
	      if (_this.oneAtATime) {
	        _this.$children.forEach(function (item) {
	          if (child !== item) {
	            item.isOpen = false;
	          }
	        });
	      }
	    });
	  }
	};
	// </script>
	// <template>
	//   <div class="panel-group">
	//     <slot></slot>
	//   </div>
	// </template>

	// <script>

/***/ },
/* 80 */
/***/ function(module, exports) {

	module.exports = "<div class=\"panel-group\">\n    <slot></slot>\n  </div>";

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(82)
	module.exports = __webpack_require__(84)
	
	if (module.exports.__esModule) module.exports = module.exports.default
	;(typeof module.exports === "function" ? module.exports.options : module.exports).template = __webpack_require__(85)
	if (false) {
	(function () {
	var hotAPI = require("vue-hot-reload-api")
	hotAPI.install(require("vue"))
	if (!hotAPI.compatible) return
	var id = "-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Affix.vue"
	hotAPI.createRecord(id, module.exports)
	module.hot.accept(["-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Affix.vue","-!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Affix.vue"], function () {
	var newOptions = require("-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Affix.vue")
	if (newOptions && newOptions.__esModule) newOptions = newOptions.default
	var newTemplate = require("-!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Affix.vue")
	hotAPI.update(id, newOptions, newTemplate)
	})
	})()
	}

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(83);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./../node_modules/vue-loader/lib/style-rewriter.js?id=_v-cdd15bf0&file=Affix.vue!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Affix.vue", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./../node_modules/vue-loader/lib/style-rewriter.js?id=_v-cdd15bf0&file=Affix.vue!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Affix.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(26)();
	// imports
	
	
	// module
	exports.push([module.id, ".vue-affix {\n    position: fixed;\n  }", ""]);
	
	// exports


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _EventListener = __webpack_require__(73);
	
	var _EventListener2 = _interopRequireDefault(_EventListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    offset: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      affixed: false,
	      styles: {}
	    };
	  },
	
	  methods: {
	    scrolling: function scrolling() {
	      var scrollTop = this.getScroll(window, true);
	      var elementOffset = this.getOffset(this.$el);
	      if (!this.affixed && scrollTop > elementOffset.top) {
	        this.affixed = true;
	        this.styles = {
	          top: this.offset + 'px',
	          left: elementOffset.left + 'px',
	          width: this.$el.offsetWidth + 'px'
	        };
	      }
	      if (this.affixed && scrollTop < elementOffset.top) {
	        this.affixed = false;
	        this.styles = {};
	      }
	    },
	
	    // from https://github.com/ant-design/ant-design/blob/master/components/affix/index.jsx#L20
	    getScroll: function getScroll(w, top) {
	      var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
	      var method = 'scroll' + (top ? 'Top' : 'Left');
	      if (typeof ret !== 'number') {
	        var d = w.document;
	        // ie6,7,8 standard mode
	        ret = d.documentElement[method];
	        if (typeof ret !== 'number') {
	          // quirks mode
	          ret = d.body[method];
	        }
	      }
	      return ret;
	    },
	    getOffset: function getOffset(element) {
	      var rect = element.getBoundingClientRect();
	      var body = document.body;
	      var clientTop = element.clientTop || body.clientTop || 0;
	      var clientLeft = element.clientLeft || body.clientLeft || 0;
	      var scrollTop = this.getScroll(window, true);
	      var scrollLeft = this.getScroll(window);
	      return {
	        top: rect.top + scrollTop - clientTop,
	        left: rect.left + scrollLeft - clientLeft
	      };
	    }
	  },
	  ready: function ready() {
	    this._scrollEvent = _EventListener2.default.listen(window, 'scroll', this.scrolling);
	    this._resizeEvent = _EventListener2.default.listen(window, 'resize', this.scrolling);
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this._scrollEvent) {
	      this._scrollEvent.remove();
	    }
	    if (this._resizeEvent) {
	      this._resizeEvent.remove();
	    }
	  }
	};
	// </script>

	// <style>
	//   .vue-affix {
	//     position: fixed;
	//   }
	// </style>
	// <template>
	// <div>
	// <div v-bind:class="{'vue-affix': affixed}"
	//   v-bind:style="styles">
	//   <slot></slot>
	// </div>
	// </div>
	// </template>

	// <script>

/***/ },
/* 85 */
/***/ function(module, exports) {

	module.exports = "<div>\n<div v-bind:class=\"{'vue-affix': affixed}\"\n  v-bind:style=\"styles\">\n  <slot></slot>\n</div>\n</div>";

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(87)
	module.exports = __webpack_require__(89)
	
	if (module.exports.__esModule) module.exports = module.exports.default
	;(typeof module.exports === "function" ? module.exports.options : module.exports).template = __webpack_require__(91)
	if (false) {
	(function () {
	var hotAPI = require("vue-hot-reload-api")
	hotAPI.install(require("vue"))
	if (!hotAPI.compatible) return
	var id = "-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Aside.vue"
	hotAPI.createRecord(id, module.exports)
	module.hot.accept(["-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Aside.vue","-!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Aside.vue"], function () {
	var newOptions = require("-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Aside.vue")
	if (newOptions && newOptions.__esModule) newOptions = newOptions.default
	var newTemplate = require("-!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Aside.vue")
	hotAPI.update(id, newOptions, newTemplate)
	})
	})()
	}

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(88);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./../node_modules/vue-loader/lib/style-rewriter.js?id=_v-74a55170&file=Aside.vue!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Aside.vue", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./../node_modules/vue-loader/lib/style-rewriter.js?id=_v-74a55170&file=Aside.vue!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Aside.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(26)();
	// imports
	
	
	// module
	exports.push([module.id, ".aside-open {\n    -webkit-transition: -webkit-transform 0.3s;\n    transition: -webkit-transform 0.3s;\n    transition: transform 0.3s;\n    transition: transform 0.3s, -webkit-transform 0.3s;\n  }\n  .aside-open.has-push-right {\n    -webkit-transform: translateX(-300px);\n            transform: translateX(-300px);\n  }\n  .aside {\n      position: fixed;\n      top: 0;\n      bottom: 0;\n      z-index: 1049;\n      overflow: auto;\n      background: #fff;\n  }\n  .aside.left {\n    left: 0;\n    right: auto;\n  }\n  .aside.right {\n    left: auto;\n    right: 0;\n  }\n\n  .slideleft-enter {\n    -webkit-animation:slideleft-in .3s;\n            animation:slideleft-in .3s;\n  }\n  .slideleft-leave {\n    -webkit-animation:slideleft-out .3s;\n            animation:slideleft-out .3s;\n  }\n  @-webkit-keyframes slideleft-in {\n    0% {\n      -webkit-transform: translateX(-100%);\n              transform: translateX(-100%);\n      opacity: 0;\n    }\n    100% {\n      -webkit-transform: translateX(0);\n              transform: translateX(0);\n      opacity: 1;\n    }\n  }\n  @keyframes slideleft-in {\n    0% {\n      -webkit-transform: translateX(-100%);\n              transform: translateX(-100%);\n      opacity: 0;\n    }\n    100% {\n      -webkit-transform: translateX(0);\n              transform: translateX(0);\n      opacity: 1;\n    }\n  }\n  @-webkit-keyframes slideleft-out {\n    0% {\n      -webkit-transform: translateX(0);\n              transform: translateX(0);\n      opacity: 1;\n    }\n    100% {\n      -webkit-transform: translateX(-100%);\n              transform: translateX(-100%);\n      opacity: 0;\n    }\n  }\n  @keyframes slideleft-out {\n    0% {\n      -webkit-transform: translateX(0);\n              transform: translateX(0);\n      opacity: 1;\n    }\n    100% {\n      -webkit-transform: translateX(-100%);\n              transform: translateX(-100%);\n      opacity: 0;\n    }\n  }\n  .slideright-enter {\n    -webkit-animation:slideright-in .3s;\n            animation:slideright-in .3s;\n  }\n  .slideright-leave {\n    -webkit-animation:slideright-out .3s;\n            animation:slideright-out .3s;\n  }\n  @-webkit-keyframes slideright-in {\n    0% {\n      -webkit-transform: translateX(100%);\n              transform: translateX(100%);\n      opacity: 0;\n    }\n    100% {\n      -webkit-transform: translateX(0);\n              transform: translateX(0);\n      opacity: 1;\n    }\n  }\n  @keyframes slideright-in {\n    0% {\n      -webkit-transform: translateX(100%);\n              transform: translateX(100%);\n      opacity: 0;\n    }\n    100% {\n      -webkit-transform: translateX(0);\n              transform: translateX(0);\n      opacity: 1;\n    }\n  }\n  @-webkit-keyframes slideright-out {\n    0% {\n      -webkit-transform: translateX(0);\n              transform: translateX(0);\n      opacity: 1;\n    }\n    100% {\n      -webkit-transform: translateX(100%);\n              transform: translateX(100%);\n      opacity: 0;\n    }\n  }\n  @keyframes slideright-out {\n    0% {\n      -webkit-transform: translateX(0);\n              transform: translateX(0);\n      opacity: 1;\n    }\n    100% {\n      -webkit-transform: translateX(100%);\n              transform: translateX(100%);\n      opacity: 0;\n    }\n  }\n\n  .aside:focus {\n      outline: 0\n  }\n\n  @media (max-width: 991px) {\n      .aside {\n          min-width:240px\n      }\n  }\n\n  .aside.left {\n      right: auto;\n      left: 0\n  }\n\n  .aside.right {\n      right: 0;\n      left: auto\n  }\n\n  .aside .aside-dialog .aside-header {\n      border-bottom: 1px solid #e5e5e5;\n      min-height: 16.43px;\n      padding: 6px 15px;\n      background: #337ab7;\n      color: #fff\n  }\n\n  .aside .aside-dialog .aside-header .close {\n      margin-right: -8px;\n      padding: 4px 8px;\n      color: #fff;\n      font-size: 25px;\n      opacity: .8\n  }\n\n  .aside .aside-dialog .aside-body {\n      position: relative;\n      padding: 15px\n  }\n\n  .aside .aside-dialog .aside-footer {\n      padding: 15px;\n      text-align: right;\n      border-top: 1px solid #e5e5e5\n  }\n\n  .aside .aside-dialog .aside-footer .btn+.btn {\n      margin-left: 5px;\n      margin-bottom: 0\n  }\n\n  .aside .aside-dialog .aside-footer .btn-group .btn+.btn {\n      margin-left: -1px\n  }\n\n  .aside .aside-dialog .aside-footer .btn-block+.btn-block {\n      margin-left: 0\n  }\n\n  .aside-backdrop {\n      position: fixed;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      z-index: 1040;\n      opacity: 0;\n      -webkit-transition: opacity .3s ease;\n      transition: opacity .3s ease;\n      background-color: #000\n  }\n\n\n  .aside-backdrop.in {\n      opacity: .5;\n      filter: alpha(opacity=50)\n  }", ""]);
	
	// exports


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _EventListener = __webpack_require__(73);
	
	var _EventListener2 = _interopRequireDefault(_EventListener);
	
	var _getScrollBarWidth = __webpack_require__(90);
	
	var _getScrollBarWidth2 = _interopRequireDefault(_getScrollBarWidth);
	
	var _coerceBoolean = __webpack_require__(29);
	
	var _coerceBoolean2 = _interopRequireDefault(_coerceBoolean);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    show: {
	      type: Boolean,
	      coerce: _coerceBoolean2.default,
	      require: true,
	      twoWay: true
	    },
	    placement: {
	      type: String,
	      default: 'right'
	    },
	    header: {
	      type: String
	    },
	    width: {
	      type: Number,
	      default: '320'
	    }
	  },
	  watch: {
	    show: function show(val) {
	      var backdrop = document.createElement('div');
	      var body = document.body;
	      backdrop.className = 'aside-backdrop';
	      var scrollBarWidth = (0, _getScrollBarWidth2.default)();
	      if (val) {
	        body.appendChild(backdrop);
	        body.classList.add('modal-open');
	        if (scrollBarWidth !== 0) {
	          body.style.paddingRight = scrollBarWidth + 'px';
	        }
	        // request property that requires layout to force a layout
	        var x = backdrop.clientHeight;
	        backdrop.className += ' in';
	        this._clickEvent = _EventListener2.default.listen(backdrop, 'click', this.close);
	      } else {
	        if (this._clickEvent) this._clickEvent.remove();
	        backdrop = document.querySelector('.aside-backdrop');
	        try {
	          backdrop.className = 'aside-backdrop';
	          body.classList.remove('modal-open');
	          body.style.paddingRight = '0';
	          body.removeChild(backdrop);
	        } catch (e) {}
	      }
	    }
	  },
	  methods: {
	    close: function close() {
	      this.show = false;
	    }
	  }
	};
	// </script>

	// <style>
	//   .aside-open {
	//     transition: transform 0.3s;
	//   }
	//   .aside-open.has-push-right {
	//     transform: translateX(-300px);
	//   }
	//   .aside {
	//       position: fixed;
	//       top: 0;
	//       bottom: 0;
	//       z-index: 1049;
	//       overflow: auto;
	//       background: #fff;
	//   }
	//   .aside.left {
	//     left: 0;
	//     right: auto;
	//   }
	//   .aside.right {
	//     left: auto;
	//     right: 0;
	//   }

	//   .slideleft-enter {
	//     animation:slideleft-in .3s;
	//   }
	//   .slideleft-leave {
	//     animation:slideleft-out .3s;
	//   }
	//   @keyframes slideleft-in {
	//     0% {
	//       transform: translateX(-100%);
	//       opacity: 0;
	//     }
	//     100% {
	//       transform: translateX(0);
	//       opacity: 1;
	//     }
	//   }
	//   @keyframes slideleft-out {
	//     0% {
	//       transform: translateX(0);
	//       opacity: 1;
	//     }
	//     100% {
	//       transform: translateX(-100%);
	//       opacity: 0;
	//     }
	//   }
	//   .slideright-enter {
	//     animation:slideright-in .3s;
	//   }
	//   .slideright-leave {
	//     animation:slideright-out .3s;
	//   }
	//   @keyframes slideright-in {
	//     0% {
	//       transform: translateX(100%);
	//       opacity: 0;
	//     }
	//     100% {
	//       transform: translateX(0);
	//       opacity: 1;
	//     }
	//   }
	//   @keyframes slideright-out {
	//     0% {
	//       transform: translateX(0);
	//       opacity: 1;
	//     }
	//     100% {
	//       transform: translateX(100%);
	//       opacity: 0;
	//     }
	//   }

	//   .aside:focus {
	//       outline: 0
	//   }

	//   @media (max-width: 991px) {
	//       .aside {
	//           min-width:240px
	//       }
	//   }

	//   .aside.left {
	//       right: auto;
	//       left: 0
	//   }

	//   .aside.right {
	//       right: 0;
	//       left: auto
	//   }

	//   .aside .aside-dialog .aside-header {
	//       border-bottom: 1px solid #e5e5e5;
	//       min-height: 16.43px;
	//       padding: 6px 15px;
	//       background: #337ab7;
	//       color: #fff
	//   }

	//   .aside .aside-dialog .aside-header .close {
	//       margin-right: -8px;
	//       padding: 4px 8px;
	//       color: #fff;
	//       font-size: 25px;
	//       opacity: .8
	//   }

	//   .aside .aside-dialog .aside-body {
	//       position: relative;
	//       padding: 15px
	//   }

	//   .aside .aside-dialog .aside-footer {
	//       padding: 15px;
	//       text-align: right;
	//       border-top: 1px solid #e5e5e5
	//   }

	//   .aside .aside-dialog .aside-footer .btn+.btn {
	//       margin-left: 5px;
	//       margin-bottom: 0
	//   }

	//   .aside .aside-dialog .aside-footer .btn-group .btn+.btn {
	//       margin-left: -1px
	//   }

	//   .aside .aside-dialog .aside-footer .btn-block+.btn-block {
	//       margin-left: 0
	//   }

	//   .aside-backdrop {
	//       position: fixed;
	//       top: 0;
	//       right: 0;
	//       bottom: 0;
	//       left: 0;
	//       z-index: 1040;
	//       opacity: 0;
	//       transition: opacity .3s ease;
	//       background-color: #000
	//   }

	//   .aside-backdrop.in {
	//       opacity: .5;
	//       filter: alpha(opacity=50)
	//   }
	// </style>
	// <template>
	//   <div class="aside"
	//     v-bind:style="{width:width + 'px'}"
	//     v-bind:class="{
	//     left:placement === 'left',
	//     right:placement === 'right'
	//     }"
	//     v-show="show"
	//     :transition="(this.placement === 'left') ? 'slideleft' : 'slideright'">
	//     <div class="aside-dialog">
	//       <div class="aside-content">
	//         <div class="aside-header">
	//           <button type="button" class="close" @click='close'><span>&times;</span></button>
	//           <h4 class="aside-title">{{header}}</h4>
	//         </div>
	//         <div class="aside-body">
	//           <slot></slot>
	//         </div>
	//       </div>
	//     </div>
	//   </div>
	// </template>

	// <script>

/***/ },
/* 90 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  if (document.documentElement.scrollHeight <= document.documentElement.clientHeight) {
	    return 0;
	  }
	  var inner = document.createElement('p');
	  inner.style.width = '100%';
	  inner.style.height = '200px';
	
	  var outer = document.createElement('div');
	  outer.style.position = 'absolute';
	  outer.style.top = '0px';
	  outer.style.left = '0px';
	  outer.style.visibility = 'hidden';
	  outer.style.width = '200px';
	  outer.style.height = '150px';
	  outer.style.overflow = 'hidden';
	  outer.appendChild(inner);
	
	  document.body.appendChild(outer);
	  var w1 = inner.offsetWidth;
	  outer.style.overflow = 'scroll';
	  var w2 = inner.offsetWidth;
	  if (w1 === w2) w2 = outer.clientWidth;
	
	  document.body.removeChild(outer);
	
	  return w1 - w2;
	};

/***/ },
/* 91 */
/***/ function(module, exports) {

	module.exports = "<div class=\"aside\"\n    v-bind:style=\"{width:width + 'px'}\"\n    v-bind:class=\"{\n    left:placement === 'left',\n    right:placement === 'right'\n    }\"\n    v-show=\"show\"\n    :transition=\"(this.placement === 'left') ? 'slideleft' : 'slideright'\">\n    <div class=\"aside-dialog\">\n      <div class=\"aside-content\">\n        <div class=\"aside-header\">\n          <button type=\"button\" class=\"close\" @click='close'><span>&times;</span></button>\n          <h4 class=\"aside-title\">{{header}}</h4>\n        </div>\n        <div class=\"aside-body\">\n          <slot></slot>\n        </div>\n      </div>\n    </div>\n  </div>";

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(93)
	
	if (module.exports.__esModule) module.exports = module.exports.default
	;(typeof module.exports === "function" ? module.exports.options : module.exports).template = __webpack_require__(94)
	if (false) {
	(function () {
	var hotAPI = require("vue-hot-reload-api")
	hotAPI.install(require("vue"))
	if (!hotAPI.compatible) return
	var id = "-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./checkboxGroup.vue"
	hotAPI.createRecord(id, module.exports)
	module.hot.accept(["-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./checkboxGroup.vue","-!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./checkboxGroup.vue"], function () {
	var newOptions = require("-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./checkboxGroup.vue")
	if (newOptions && newOptions.__esModule) newOptions = newOptions.default
	var newTemplate = require("-!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./checkboxGroup.vue")
	hotAPI.update(id, newOptions, newTemplate)
	})
	})()
	}

/***/ },
/* 93 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// <template>
	//   <div class="btn-group" data-toggle="buttons">
	//     <slot></slot>
	//   </div>
	// </template>
	
	// <script>
	exports.default = {
	  props: {
	    value: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    type: {
	      type: String,
	      default: 'default'
	    }
	  }
	};
	// </script>

/***/ },
/* 94 */
/***/ function(module, exports) {

	module.exports = "<div class=\"btn-group\" data-toggle=\"buttons\">\n    <slot></slot>\n  </div>";

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(96)
	
	if (module.exports.__esModule) module.exports = module.exports.default
	;(typeof module.exports === "function" ? module.exports.options : module.exports).template = __webpack_require__(97)
	if (false) {
	(function () {
	var hotAPI = require("vue-hot-reload-api")
	hotAPI.install(require("vue"))
	if (!hotAPI.compatible) return
	var id = "-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./checkboxBtn.vue"
	hotAPI.createRecord(id, module.exports)
	module.hot.accept(["-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./checkboxBtn.vue","-!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./checkboxBtn.vue"], function () {
	var newOptions = require("-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./checkboxBtn.vue")
	if (newOptions && newOptions.__esModule) newOptions = newOptions.default
	var newTemplate = require("-!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./checkboxBtn.vue")
	hotAPI.update(id, newOptions, newTemplate)
	})
	})()
	}

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _coerceBoolean = __webpack_require__(29);
	
	var _coerceBoolean2 = _interopRequireDefault(_coerceBoolean);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    value: {
	      type: String
	    },
	    checked: {
	      type: Boolean,
	      coerce: _coerceBoolean2.default,
	      default: false
	    }
	  },
	  computed: {
	    type: function type() {
	      return this.$parent.type;
	    }
	  },
	  methods: {
	    handleClick: function handleClick() {
	      var parent = this.$parent;
	      var index = parent.value.indexOf(this.value);
	      index === -1 ? parent.value.push(this.value) : parent.value.splice(index, 1);
	      this.checked = !this.checked;
	    }
	  },
	  created: function created() {
	    if (this.$parent.value.length) {
	      this.checked = this.$parent.value.indexOf(this.value) > -1;
	    } else if (this.checked) {
	      this.$parent.value.push(this.value);
	    }
	  }
	};
	// </script>
	// <template>
	//   <label class="btn"
	//   v-bind:class="{
	//     'active':checked,
	//     'btn-success':type == 'success',
	//     'btn-warning':type == 'warning',
	//     'btn-info':type == 'info',
	//     'btn-danger':type == 'danger',
	//     'btn-default':type == 'default',
	//     'btn-primary':type == 'primary'
	//   }">

	//     <input type="checkbox" autocomplete="off"
	//     :checked="checked"
	//     @click="handleClick"
	//     />

	//     <slot></slot>
	//   </label>
	// </template>

	// <script>

/***/ },
/* 97 */
/***/ function(module, exports) {

	module.exports = "<label class=\"btn\"\n  v-bind:class=\"{\n    'active':checked,\n    'btn-success':type == 'success',\n    'btn-warning':type == 'warning',\n    'btn-info':type == 'info',\n    'btn-danger':type == 'danger',\n    'btn-default':type == 'default',\n    'btn-primary':type == 'primary'\n  }\">\n\n    <input type=\"checkbox\" autocomplete=\"off\"\n    :checked=\"checked\"\n    @click=\"handleClick\"\n    />\n\n    <slot></slot>\n  </label>";

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(99)
	__webpack_require__(101)
	module.exports = __webpack_require__(103)
	
	if (module.exports.__esModule) module.exports = module.exports.default
	;(typeof module.exports === "function" ? module.exports.options : module.exports).template = __webpack_require__(104)
	if (false) {
	(function () {
	var hotAPI = require("vue-hot-reload-api")
	hotAPI.install(require("vue"))
	if (!hotAPI.compatible) return
	var id = "-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Datepicker.vue"
	hotAPI.createRecord(id, module.exports)
	module.hot.accept(["-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Datepicker.vue","-!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Datepicker.vue"], function () {
	var newOptions = require("-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Datepicker.vue")
	if (newOptions && newOptions.__esModule) newOptions = newOptions.default
	var newTemplate = require("-!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Datepicker.vue")
	hotAPI.update(id, newOptions, newTemplate)
	})
	})()
	}

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(100);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./../node_modules/vue-loader/lib/style-rewriter.js?id=_v-56a3c0b4&file=Datepicker.vue!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Datepicker.vue", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./../node_modules/vue-loader/lib/style-rewriter.js?id=_v-56a3c0b4&file=Datepicker.vue!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Datepicker.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(26)();
	// imports
	
	
	// module
	exports.push([module.id, "input.datepicker-input.with-reset-button {\n    padding-right: 25px;\n  }\n\n  div.datepicker > button.close {\n    position: absolute;\n    top: calc(50% - 13px);\n    right: 10px;\n  }\n\n  div.datepicker > button.close {\n    outline: none;\n    z-index: 2;\n  }\n\n  div.datepicker > button.close:focus {\n    opacity: .2;\n  }", ""]);
	
	// exports


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(102);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./../node_modules/vue-loader/lib/style-rewriter.js?id=_v-56a3c0b4&file=Datepicker.vue!./../node_modules/vue-loader/lib/selector.js?type=style&index=1!./Datepicker.vue", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./../node_modules/vue-loader/lib/style-rewriter.js?id=_v-56a3c0b4&file=Datepicker.vue!./../node_modules/vue-loader/lib/selector.js?type=style&index=1!./Datepicker.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(26)();
	// imports
	
	
	// module
	exports.push([module.id, ".datepicker{\n    position: relative;\n    display: inline-block;\n}\n\n.datepicker-popup{\n    position: absolute;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    background: #fff;\n    margin-top: 2px;\n    z-index: 1000;\n    box-shadow: 0 6px 12px rgba(0,0,0,0.175);\n}\n.datepicker-inner{\n    width: 218px;\n\n}\n.datepicker-body{\n    padding: 10px 10px;\n}\n.datepicker-ctrl p,\n.datepicker-ctrl span,\n.datepicker-body span{\n    display: inline-block;\n    width: 28px;\n    line-height: 28px;\n    height: 28px;\n    border-radius: 4px;\n}\n.datepicker-ctrl p {\n    width: 65%;\n}\n.datepicker-ctrl span {\n  position: absolute;\n}\n.datepicker-body span {\n  text-align: center;\n}\n.datepicker-monthRange span{\n  width: 48px;\n  height: 50px;\n  line-height: 45px;\n}\n.datepicker-item-disable {\n  background-color: white!important;\n  cursor: not-allowed!important;\n}\n.decadeRange span:first-child,\n.decadeRange span:last-child,\n.datepicker-item-disable,\n.datepicker-item-gray{\n    color: #999;\n}\n\n.datepicker-dateRange-item-active:hover,\n.datepicker-dateRange-item-active {\n    background: rgb(50, 118, 177)!important;\n    color: white!important;\n}\n.datepicker-monthRange {\n  margin-top: 10px\n}\n.datepicker-monthRange span,\n.datepicker-ctrl span,\n.datepicker-ctrl p,\n.datepicker-dateRange span {\n  cursor: pointer;\n}\n.datepicker-monthRange span:hover,\n.datepicker-ctrl p:hover,\n.datepicker-ctrl i:hover,\n.datepicker-dateRange span:hover,\n.datepicker-dateRange-item-hover {\n    background-color : #eeeeee;\n}\n\n.datepicker-weekRange span{\n    font-weight: bold;\n}\n.datepicker-label{\n    background-color: #f8f8f8;\n    font-weight: 700;\n    padding: 7px 0;\n    text-align: center;\n}\n.datepicker-ctrl{\n    position: relative;\n    height: 30px;\n    line-height: 30px;\n    font-weight: bold;\n    text-align: center;\n}\n.month-btn{\n  font-weight: bold;\n  -webkit-user-select:none;\n    -moz-user-select:none;\n    -ms-user-select:none;\n    user-select:none;\n}\n.datepicker-preBtn{\n    left: 2px;\n}\n.datepicker-nextBtn{\n    right: 2px;\n}", ""]);
	
	// exports


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _EventListener = __webpack_require__(73);
	
	var _EventListener2 = _interopRequireDefault(_EventListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    value: {
	      type: String,
	      twoWay: true
	    },
	    format: {
	      default: 'MMMM/dd/yyyy'
	    },
	    disabledDaysOfWeek: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    width: {
	      type: String,
	      default: '200px'
	    },
	    showResetButton: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      weekRange: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
	      dateRange: [],
	      decadeRange: [],
	      currDate: new Date(),
	      displayDayView: false,
	      displayMonthView: false,
	      displayYearView: false,
	      monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
	    };
	  },
	
	  watch: {
	    currDate: function currDate() {
	      this.getDateRange();
	    }
	  },
	  methods: {
	    close: function close() {
	      this.displayDayView = this.displayMonthView = this.displayMonthView = false;
	    },
	    inputClick: function inputClick() {
	      if (this.displayMonthView || this.displayYearView) {
	        this.displayDayView = false;
	      } else {
	        this.displayDayView = !this.displayDayView;
	      }
	    },
	    preNextDecadeClick: function preNextDecadeClick(flag) {
	      var year = this.currDate.getFullYear();
	      var months = this.currDate.getMonth();
	      var date = this.currDate.getDate();
	
	      if (flag === 0) {
	        this.currDate = new Date(year - 10, months, date);
	      } else {
	        this.currDate = new Date(year + 10, months, date);
	      }
	    },
	    preNextMonthClick: function preNextMonthClick(flag) {
	      var year = this.currDate.getFullYear();
	      var month = this.currDate.getMonth();
	      var date = this.currDate.getDate();
	
	      if (flag === 0) {
	        var preMonth = this.getYearMonth(year, month - 1);
	        this.currDate = new Date(preMonth.year, preMonth.month, date);
	      } else {
	        var nextMonth = this.getYearMonth(year, month + 1);
	        this.currDate = new Date(nextMonth.year, nextMonth.month, date);
	      }
	    },
	    preNextYearClick: function preNextYearClick(flag) {
	      var year = this.currDate.getFullYear();
	      var months = this.currDate.getMonth();
	      var date = this.currDate.getDate();
	
	      if (flag === 0) {
	        this.currDate = new Date(year - 1, months, date);
	      } else {
	        this.currDate = new Date(year + 1, months, date);
	      }
	    },
	    yearSelect: function yearSelect(year) {
	      this.displayYearView = false;
	      this.displayMonthView = true;
	      this.currDate = new Date(year, this.currDate.getMonth(), this.currDate.getDate());
	    },
	    daySelect: function daySelect(date, el) {
	      if (el.$el.classList[0] === 'datepicker-item-disable') {
	        return false;
	      } else {
	        this.currDate = date;
	        this.value = this.stringify(this.currDate);
	        this.displayDayView = false;
	      }
	    },
	    switchMonthView: function switchMonthView() {
	      this.displayDayView = false;
	      this.displayMonthView = true;
	    },
	    switchDecadeView: function switchDecadeView() {
	      this.displayMonthView = false;
	      this.displayYearView = true;
	    },
	    monthSelect: function monthSelect(index) {
	      this.displayMonthView = false;
	      this.displayDayView = true;
	      this.currDate = new Date(this.currDate.getFullYear(), index, this.currDate.getDate());
	    },
	    getYearMonth: function getYearMonth(year, month) {
	      if (month > 11) {
	        year++;
	        month = 0;
	      } else if (month < 0) {
	        year--;
	        month = 11;
	      }
	      return { year: year, month: month };
	    },
	    stringifyDecadeHeader: function stringifyDecadeHeader(date) {
	      var yearStr = date.getFullYear().toString();
	      var firstYearOfDecade = yearStr.substring(0, yearStr.length - 1) + 0;
	      var lastYearOfDecade = parseInt(firstYearOfDecade, 10) + 10;
	      return firstYearOfDecade + '-' + lastYearOfDecade;
	    },
	    stringifyDayHeader: function stringifyDayHeader(date) {
	      return this.monthNames[date.getMonth()] + ' ' + date.getFullYear();
	    },
	    parseMonth: function parseMonth(date) {
	      return this.monthNames[date.getMonth()];
	    },
	    stringifyYearHeader: function stringifyYearHeader(date) {
	      return date.getFullYear();
	    },
	    stringify: function stringify(date) {
	      var format = arguments.length <= 1 || arguments[1] === undefined ? this.format : arguments[1];
	
	      var year = date.getFullYear();
	      var month = date.getMonth() + 1;
	      var day = date.getDate();
	      var monthName = this.parseMonth(date);
	
	      return format.replace(/yyyy/g, year).replace(/MMMM/g, monthName).replace(/MMM/g, monthName.substring(0, 3)).replace(/MM/g, ('0' + month).slice(-2)).replace(/dd/g, ('0' + day).slice(-2)).replace(/yy/g, year).replace(/M(?!a)/g, month).replace(/d/g, day);
	    },
	    parse: function parse(str) {
	      var date = new Date(str);
	      return isNaN(date.getFullYear()) ? null : date;
	    },
	    getDayCount: function getDayCount(year, month) {
	      var dict = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	
	      if (month === 1) {
	        if (year % 400 === 0 || year % 4 === 0 && year % 100 !== 0) {
	          return 29;
	        }
	        return 28;
	      }
	
	      return dict[month];
	    },
	    getDateRange: function getDateRange() {
	      var _this = this;
	
	      this.dateRange = [];
	      this.decadeRange = [];
	      var time = {
	        year: this.currDate.getFullYear(),
	        month: this.currDate.getMonth(),
	        day: this.currDate.getDate()
	      };
	      var yearStr = time.year.toString();
	      var firstYearOfDecade = yearStr.substring(0, yearStr.length - 1) + 0 - 1;
	      for (var i = 0; i < 12; i++) {
	        this.decadeRange.push({
	          text: firstYearOfDecade + i
	        });
	      }
	
	      var currMonthFirstDay = new Date(time.year, time.month, 1);
	      var firstDayWeek = currMonthFirstDay.getDay() + 1;
	      if (firstDayWeek === 0) {
	        firstDayWeek = 7;
	      }
	      var dayCount = this.getDayCount(time.year, time.month);
	      if (firstDayWeek > 1) {
	        var preMonth = this.getYearMonth(time.year, time.month - 1);
	        var prevMonthDayCount = this.getDayCount(preMonth.year, preMonth.month);
	        for (var i = 1; i < firstDayWeek; i++) {
	          var dayText = prevMonthDayCount - firstDayWeek + i + 1;
	          this.dateRange.push({
	            text: dayText,
	            date: new Date(preMonth.year, preMonth.month, dayText),
	            sclass: 'datepicker-item-gray'
	          });
	        }
	      }
	
	      var _loop = function _loop(i) {
	        var date = new Date(time.year, time.month, i);
	        var week = date.getDay();
	        var sclass = '';
	        _this.disabledDaysOfWeek.forEach(function (el) {
	          if (week === parseInt(el, 10)) sclass = 'datepicker-item-disable';
	        });
	
	        if (i === time.day) {
	          if (_this.value) {
	            var valueDate = _this.parse(_this.value);
	            if (valueDate) {
	              if (valueDate.getFullYear() === time.year && valueDate.getMonth() === time.month) {
	                sclass = 'datepicker-dateRange-item-active';
	              }
	            }
	          }
	        }
	        _this.dateRange.push({
	          text: i,
	          date: date,
	          sclass: sclass
	        });
	      };
	
	      for (var i = 1; i <= dayCount; i++) {
	        _loop(i);
	      }
	
	      if (this.dateRange.length < 42) {
	        var nextMonthNeed = 42 - this.dateRange.length;
	        var nextMonth = this.getYearMonth(time.year, time.month + 1);
	
	        for (var i = 1; i <= nextMonthNeed; i++) {
	          this.dateRange.push({
	            text: i,
	            date: new Date(nextMonth.year, nextMonth.month, i),
	            sclass: 'datepicker-item-gray'
	          });
	        }
	      }
	    }
	  },
	  ready: function ready() {
	    var _this2 = this;
	
	    this.$dispatch('child-created', this);
	    this.currDate = this.parse(this.value) || this.parse(new Date());
	    this._closeEvent = _EventListener2.default.listen(window, 'click', function (e) {
	      if (!_this2.$el.contains(e.target)) _this2.close();
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this._closeEvent) this._closeEvent.remove();
	  }
	};
	// </script>

	// <style>
	// .datepicker{
	//     position: relative;
	//     display: inline-block;
	// }

	// .datepicker-popup{
	//     position: absolute;
	//     border: 1px solid #ccc;
	//     border-radius: 5px;
	//     background: #fff;
	//     margin-top: 2px;
	//     z-index: 1000;
	//     box-shadow: 0 6px 12px rgba(0,0,0,0.175);
	// }
	// .datepicker-inner{
	//     width: 218px;

	// }
	// .datepicker-body{
	//     padding: 10px 10px;
	// }
	// .datepicker-ctrl p,
	// .datepicker-ctrl span,
	// .datepicker-body span{
	//     display: inline-block;
	//     width: 28px;
	//     line-height: 28px;
	//     height: 28px;
	//     border-radius: 4px;
	// }
	// .datepicker-ctrl p {
	//     width: 65%;
	// }
	// .datepicker-ctrl span {
	//   position: absolute;
	// }
	// .datepicker-body span {
	//   text-align: center;
	// }
	// .datepicker-monthRange span{
	//   width: 48px;
	//   height: 50px;
	//   line-height: 45px;
	// }
	// .datepicker-item-disable {
	//   background-color: white!important;
	//   cursor: not-allowed!important;
	// }
	// .decadeRange span:first-child,
	// .decadeRange span:last-child,
	// .datepicker-item-disable,
	// .datepicker-item-gray{
	//     color: #999;
	// }

	// .datepicker-dateRange-item-active:hover,
	// .datepicker-dateRange-item-active {
	//     background: rgb(50, 118, 177)!important;
	//     color: white!important;
	// }
	// .datepicker-monthRange {
	//   margin-top: 10px
	// }
	// .datepicker-monthRange span,
	// .datepicker-ctrl span,
	// .datepicker-ctrl p,
	// .datepicker-dateRange span {
	//   cursor: pointer;
	// }
	// .datepicker-monthRange span:hover,
	// .datepicker-ctrl p:hover,
	// .datepicker-ctrl i:hover,
	// .datepicker-dateRange span:hover,
	// .datepicker-dateRange-item-hover {
	//     background-color : #eeeeee;
	// }

	// .datepicker-weekRange span{
	//     font-weight: bold;
	// }
	// .datepicker-label{
	//     background-color: #f8f8f8;
	//     font-weight: 700;
	//     padding: 7px 0;
	//     text-align: center;
	// }
	// .datepicker-ctrl{
	//     position: relative;
	//     height: 30px;
	//     line-height: 30px;
	//     font-weight: bold;
	//     text-align: center;
	// }
	// .month-btn{
	//   font-weight: bold;
	//   -webkit-user-select:none;
	//     -moz-user-select:none;
	//     -ms-user-select:none;
	//     user-select:none;
	// }
	// .datepicker-preBtn{
	//     left: 2px;
	// }
	// .datepicker-nextBtn{
	//     right: 2px;
	// }
	// </style>
	// <style>
	//   input.datepicker-input.with-reset-button {
	//     padding-right: 25px;
	//   }

	//   div.datepicker > button.close {
	//     position: absolute;
	//     top: calc(50% - 13px);
	//     right: 10px;
	//   }

	//   div.datepicker > button.close {
	//     outline: none;
	//     z-index: 2;
	//   }

	//   div.datepicker > button.close:focus {
	//     opacity: .2;
	//   }
	// </style>

	// <template>
	//   <div class="datepicker">
	//     <input class="form-control datepicker-input" :class="{'with-reset-button': showResetButton}" type="text"
	//         v-bind:style="{width:width}"
	//         @click="inputClick"
	//         v-model="value"/>
	//     <button v-if="showResetButton" type="button" class="close" @click="value = ''">
	//       <span>&times;</span>
	//     </button>
	//     <div class="datepicker-popup" v-show="displayDayView">
	//       <div class="datepicker-inner">
	//         <div class="datepicker-body">
	//           <div class="datepicker-ctrl">
	//             <span class="month-btn datepicker-preBtn" @click="preNextMonthClick(0)">&lt;</span>
	//             <span class="month-btn datepicker-nextBtn" @click="preNextMonthClick(1)">&gt;</span>
	//             <p @click="switchMonthView">{{stringifyDayHeader(currDate)}}</p>
	//           </div>
	//           <div class="datepicker-weekRange">
	//             <span v-for="w in weekRange">{{w}}</span>
	//           </div>
	//           <div class="datepicker-dateRange">
	//             <span v-for="d in dateRange" v-bind:class="d.sclass" @click="daySelect(d.date,this)">{{d.text}}</span>
	//           </div>
	//         </div>
	//       </div>
	//     </div>
	//     <div class="datepicker-popup" v-show="displayMonthView">
	//       <div class="datepicker-inner">
	//         <div class="datepicker-body">
	//           <div class="datepicker-ctrl">
	//             <span class="month-btn datepicker-preBtn" @click="preNextYearClick(0)">&lt;</span>
	//             <span class="month-btn datepicker-nextBtn" @click="preNextYearClick(1)">&gt;</span>
	//             <p @click="switchDecadeView">{{stringifyYearHeader(currDate)}}</p>
	//           </div>
	//           <div class="datepicker-monthRange">
	//             <template v-for="m in monthNames">
	//               <span   v-bind:class="{'datepicker-dateRange-item-active':
	//                   (this.monthNames[this.parse(this.value).getMonth()]  === m) &&
	//                   this.currDate.getFullYear() === this.parse(this.value).getFullYear()}"
	//                   @click="monthSelect($index)"
	//                 >{{m.substr(0,3)}}</span>
	//             </template>
	//           </div>
	//         </div>
	//       </div>
	//     </div>
	//     <div class="datepicker-popup" v-show="displayYearView">
	//       <div class="datepicker-inner">
	//         <div class="datepicker-body">
	//           <div class="datepicker-ctrl">
	//             <span class="month-btn datepicker-preBtn" @click="preNextDecadeClick(0)">&lt;</span>
	//             <span class="month-btn datepicker-nextBtn" @click="preNextDecadeClick(1)">&gt;</span>
	//             <p>{{stringifyDecadeHeader(currDate)}}</p>
	//           </div>
	//           <div class="datepicker-monthRange decadeRange">
	//             <template v-for="decade in decadeRange">
	//               <span v-bind:class="{'datepicker-dateRange-item-active':
	//                   this.parse(this.value).getFullYear() === decade.text}"
	//                   @click.stop="yearSelect(decade.text)"
	//                 >{{decade.text}}</span>
	//             </template>
	//           </div>
	//         </div>
	//       </div>
	//     </div>
	//   </div>
	// </template>

	// <script>

/***/ },
/* 104 */
/***/ function(module, exports) {

	module.exports = "<div class=\"datepicker\">\n    <input class=\"form-control datepicker-input\" :class=\"{'with-reset-button': showResetButton}\" type=\"text\"\n        v-bind:style=\"{width:width}\"\n        @click=\"inputClick\"\n        v-model=\"value\"/>\n    <button v-if=\"showResetButton\" type=\"button\" class=\"close\" @click=\"value = ''\">\n      <span>&times;</span>\n    </button>\n    <div class=\"datepicker-popup\" v-show=\"displayDayView\">\n      <div class=\"datepicker-inner\">\n        <div class=\"datepicker-body\">\n          <div class=\"datepicker-ctrl\">\n            <span class=\"month-btn datepicker-preBtn\" @click=\"preNextMonthClick(0)\">&lt;</span>\n            <span class=\"month-btn datepicker-nextBtn\" @click=\"preNextMonthClick(1)\">&gt;</span>\n            <p @click=\"switchMonthView\">{{stringifyDayHeader(currDate)}}</p>\n          </div>\n          <div class=\"datepicker-weekRange\">\n            <span v-for=\"w in weekRange\">{{w}}</span>\n          </div>\n          <div class=\"datepicker-dateRange\">\n            <span v-for=\"d in dateRange\" v-bind:class=\"d.sclass\" @click=\"daySelect(d.date,this)\">{{d.text}}</span>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"datepicker-popup\" v-show=\"displayMonthView\">\n      <div class=\"datepicker-inner\">\n        <div class=\"datepicker-body\">\n          <div class=\"datepicker-ctrl\">\n            <span class=\"month-btn datepicker-preBtn\" @click=\"preNextYearClick(0)\">&lt;</span>\n            <span class=\"month-btn datepicker-nextBtn\" @click=\"preNextYearClick(1)\">&gt;</span>\n            <p @click=\"switchDecadeView\">{{stringifyYearHeader(currDate)}}</p>\n          </div>\n          <div class=\"datepicker-monthRange\">\n            <template v-for=\"m in monthNames\">\n              <span   v-bind:class=\"{'datepicker-dateRange-item-active':\n                  (this.monthNames[this.parse(this.value).getMonth()]  === m) &&\n                  this.currDate.getFullYear() === this.parse(this.value).getFullYear()}\"\n                  @click=\"monthSelect($index)\"\n                >{{m.substr(0,3)}}</span>\n            </template>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"datepicker-popup\" v-show=\"displayYearView\">\n      <div class=\"datepicker-inner\">\n        <div class=\"datepicker-body\">\n          <div class=\"datepicker-ctrl\">\n            <span class=\"month-btn datepicker-preBtn\" @click=\"preNextDecadeClick(0)\">&lt;</span>\n            <span class=\"month-btn datepicker-nextBtn\" @click=\"preNextDecadeClick(1)\">&gt;</span>\n            <p>{{stringifyDecadeHeader(currDate)}}</p>\n          </div>\n          <div class=\"datepicker-monthRange decadeRange\">\n            <template v-for=\"decade in decadeRange\">\n              <span v-bind:class=\"{'datepicker-dateRange-item-active':\n                  this.parse(this.value).getFullYear() === decade.text}\"\n                  @click.stop=\"yearSelect(decade.text)\"\n                >{{decade.text}}</span>\n            </template>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>";

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(106)
	
	if (module.exports.__esModule) module.exports = module.exports.default
	;(typeof module.exports === "function" ? module.exports.options : module.exports).template = __webpack_require__(107)
	if (false) {
	(function () {
	var hotAPI = require("vue-hot-reload-api")
	hotAPI.install(require("vue"))
	if (!hotAPI.compatible) return
	var id = "-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Dropdown.vue"
	hotAPI.createRecord(id, module.exports)
	module.hot.accept(["-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Dropdown.vue","-!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Dropdown.vue"], function () {
	var newOptions = require("-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Dropdown.vue")
	if (newOptions && newOptions.__esModule) newOptions = newOptions.default
	var newTemplate = require("-!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Dropdown.vue")
	hotAPI.update(id, newOptions, newTemplate)
	})
	})()
	}

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _EventListener = __webpack_require__(73);
	
	var _EventListener2 = _interopRequireDefault(_EventListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  methods: {
	    toggleDropdown: function toggleDropdown(e) {
	      e.preventDefault();
	      this.$el.classList.toggle('open');
	    }
	  },
	  ready: function ready() {
	    var el = this.$el;
	    var toggle = el.querySelector('[data-toggle="dropdown"]');
	    if (toggle) {
	      toggle.style.borderRadius = '4px';
	      toggle.addEventListener('click', this.toggleDropdown);
	    }
	    this._closeEvent = _EventListener2.default.listen(window, 'click', function (e) {
	      if (!el.contains(e.target)) el.classList.remove('open');
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this._closeEvent) this._closeEvent.remove();
	  }
	};
	// </script>
	// <template>
	//   <div class="btn-group">
	//     <slot></slot>
	//     <slot name="dropdown-menu"></slot>
	//   </div>
	// </template>
	// <script>

/***/ },
/* 107 */
/***/ function(module, exports) {

	module.exports = "<div class=\"btn-group\">\n    <slot></slot>\n    <slot name=\"dropdown-menu\"></slot>\n  </div>";

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(109)
	module.exports = __webpack_require__(111)
	
	if (module.exports.__esModule) module.exports = module.exports.default
	;(typeof module.exports === "function" ? module.exports.options : module.exports).template = __webpack_require__(116)
	if (false) {
	(function () {
	var hotAPI = require("vue-hot-reload-api")
	hotAPI.install(require("vue"))
	if (!hotAPI.compatible) return
	var id = "-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Modal.vue"
	hotAPI.createRecord(id, module.exports)
	module.hot.accept(["-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Modal.vue","-!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Modal.vue"], function () {
	var newOptions = require("-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Modal.vue")
	if (newOptions && newOptions.__esModule) newOptions = newOptions.default
	var newTemplate = require("-!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Modal.vue")
	hotAPI.update(id, newOptions, newTemplate)
	})
	})()
	}

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(110);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./../node_modules/vue-loader/lib/style-rewriter.js?id=_v-89ca7736&file=Modal.vue!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Modal.vue", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./../node_modules/vue-loader/lib/style-rewriter.js?id=_v-89ca7736&file=Modal.vue!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Modal.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(26)();
	// imports
	
	
	// module
	exports.push([module.id, ".modal {\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n.modal.in {\n  background-color: rgba(0,0,0,0.5);\n}\n.modal.zoom .modal-dialog {\n    -webkit-transform: scale(0.1);\n    transform: scale(0.1);\n    top: 300px;\n    opacity: 0;\n    -webkit-transition: all 0.3s;\n    transition: all 0.3s;\n}\n.modal.zoom.in .modal-dialog {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n    -webkit-transform: translate3d(0, -300px, 0);\n    transform: translate3d(0, -300px, 0);\n    opacity: 1;\n}", ""]);
	
	// exports


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isInteger = __webpack_require__(112);
	
	var _isInteger2 = _interopRequireDefault(_isInteger);
	
	var _getScrollBarWidth = __webpack_require__(90);
	
	var _getScrollBarWidth2 = _interopRequireDefault(_getScrollBarWidth);
	
	var _EventListener = __webpack_require__(73);
	
	var _EventListener2 = _interopRequireDefault(_EventListener);
	
	var _coerceBoolean = __webpack_require__(29);
	
	var _coerceBoolean2 = _interopRequireDefault(_coerceBoolean);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    title: {
	      type: String,
	      default: ''
	    },
	    show: {
	      require: true,
	      type: Boolean,
	      coerce: _coerceBoolean2.default,
	      twoWay: true
	    },
	    width: {
	      default: null
	    },
	    callback: {
	      type: Function,
	      default: function _default() {}
	    },
	    effect: {
	      type: String,
	      default: null
	    },
	    backdrop: {
	      type: Boolean,
	      coerce: _coerceBoolean2.default,
	      default: true
	    },
	    large: {
	      type: Boolean,
	      coerce: _coerceBoolean2.default,
	      default: false
	    },
	    small: {
	      type: Boolean,
	      coerce: _coerceBoolean2.default,
	      default: false
	    }
	  },
	  ready: function ready() {
	    var _this = this;
	
	    this.$watch('show', function (val) {
	      var el = _this.$el;
	      var body = document.body;
	      var scrollBarWidth = (0, _getScrollBarWidth2.default)();
	      if (val) {
	        el.querySelector('.modal-content').focus();
	        el.style.display = 'block';
	        setTimeout(function () {
	          return el.classList.add('in');
	        }, 0);
	        body.classList.add('modal-open');
	        if (scrollBarWidth !== 0) {
	          body.style.paddingRight = scrollBarWidth + 'px';
	        }
	        if (_this.backdrop) {
	          _this._blurModalContentEvent = _EventListener2.default.listen(_this.$el, 'click', function (e) {
	            if (e.target === el) _this.show = false;
	          });
	        }
	      } else {
	        if (_this._blurModalContentEvent) _this._blurModalContentEvent.remove();
	        el.classList.remove('in');
	        setTimeout(function () {
	          el.style.display = 'none';
	          body.classList.remove('modal-open');
	          body.style.paddingRight = '0';
	        }, 300);
	      }
	    }, { immediate: true });
	  },
	
	  computed: {
	    optionalWidth: function optionalWidth() {
	      if (this.width === null) {
	        return null;
	      } else if ((0, _isInteger2.default)(this.width)) {
	        return this.width + "px";
	      }
	      return this.width;
	    }
	  },
	  methods: {
	    close: function close() {
	      this.show = false;
	    }
	  }
	};
	// </script>
	// <style>
	// .modal {
	//   transition: all 0.3s ease;
	// }
	// .modal.in {
	//   background-color: rgba(0,0,0,0.5);
	// }
	// .modal.zoom .modal-dialog {
	//     -webkit-transform: scale(0.1);
	//     -moz-transform: scale(0.1);
	//     -ms-transform: scale(0.1);
	//     transform: scale(0.1);
	//     top: 300px;
	//     opacity: 0;
	//     -webkit-transition: all 0.3s;
	//     -moz-transition: all 0.3s;
	//     transition: all 0.3s;
	// }
	// .modal.zoom.in .modal-dialog {
	//     -webkit-transform: scale(1);
	//     -moz-transform: scale(1);
	//     -ms-transform: scale(1);
	//     transform: scale(1);
	//     -webkit-transform: translate3d(0, -300px, 0);
	//     transform: translate3d(0, -300px, 0);
	//     opacity: 1;
	// }
	// </style>
	// <template>
	//   <div role="dialog"
	//     v-bind:class="{
	//     'modal':true,
	//     'fade':effect === 'fade',
	//     'zoom':effect === 'zoom'
	//     }"
	//     >
	//     <div v-bind:class="{'modal-dialog':true,'modal-lg':large,'modal-sm':small}" role="document"
	//       v-bind:style="{width: optionalWidth}">
	//       <div class="modal-content">
	//         <slot name="modal-header">
	//           <div class="modal-header">
	//             <button type="button" class="close" @click="close"><span>&times;</span></button>
	//             <h4 class="modal-title" >{{title}}</h4>
	//           </div>
	//         </slot>
	//         <slot name="modal-body">
	//           <div class="modal-body"></div>
	//         </slot>
	//         <slot name="modal-footer">
	//           <div class="modal-footer">
	//             <button type="button" class="btn btn-default" @click="close">Close</button>
	//             <button type="button" class="btn btn-primary" @click="callback">Save changes</button>
	//           </div>
	//         </slot>
	//       </div>
	//     </div>
	//   </div>
	// </template>

	// <script>

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(113), __esModule: true };

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(114);
	module.exports = __webpack_require__(46).Number.isInteger;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(44);
	
	$export($export.S, 'Number', {isInteger: __webpack_require__(115)});

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(66)
	  , floor    = Math.floor;
	module.exports = function isInteger(it){
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};

/***/ },
/* 116 */
/***/ function(module, exports) {

	module.exports = "<div role=\"dialog\"\n    v-bind:class=\"{\n    'modal':true,\n    'fade':effect === 'fade',\n    'zoom':effect === 'zoom'\n    }\"\n    >\n    <div v-bind:class=\"{'modal-dialog':true,'modal-lg':large,'modal-sm':small}\" role=\"document\"\n      v-bind:style=\"{width: optionalWidth}\">\n      <div class=\"modal-content\">\n        <slot name=\"modal-header\">\n          <div class=\"modal-header\">\n            <button type=\"button\" class=\"close\" @click=\"close\"><span>&times;</span></button>\n            <h4 class=\"modal-title\" >{{title}}</h4>\n          </div>\n        </slot>\n        <slot name=\"modal-body\">\n          <div class=\"modal-body\"></div>\n        </slot>\n        <slot name=\"modal-footer\">\n          <div class=\"modal-footer\">\n            <button type=\"button\" class=\"btn btn-default\" @click=\"close\">Close</button>\n            <button type=\"button\" class=\"btn btn-primary\" @click=\"callback\">Save changes</button>\n          </div>\n        </slot>\n      </div>\n    </div>\n  </div>";

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(118)
	module.exports = __webpack_require__(120)
	
	if (module.exports.__esModule) module.exports = module.exports.default
	;(typeof module.exports === "function" ? module.exports.options : module.exports).template = __webpack_require__(121)
	if (false) {
	(function () {
	var hotAPI = require("vue-hot-reload-api")
	hotAPI.install(require("vue"))
	if (!hotAPI.compatible) return
	var id = "-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Option.vue"
	hotAPI.createRecord(id, module.exports)
	module.hot.accept(["-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Option.vue","-!vue-html-loader!./../node_modules/vue-loader/lib/template-rewriter.js?id=_v-52dd76ed&file=Option.vue!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Option.vue"], function () {
	var newOptions = require("-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Option.vue")
	if (newOptions && newOptions.__esModule) newOptions = newOptions.default
	var newTemplate = require("-!vue-html-loader!./../node_modules/vue-loader/lib/template-rewriter.js?id=_v-52dd76ed&file=Option.vue!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Option.vue")
	hotAPI.update(id, newOptions, newTemplate)
	})
	})()
	}

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(119);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./../node_modules/vue-loader/lib/style-rewriter.js?id=_v-52dd76ed&file=Option.vue&scoped=true!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Option.vue", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./../node_modules/vue-loader/lib/style-rewriter.js?id=_v-52dd76ed&file=Option.vue&scoped=true!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Option.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(26)();
	// imports
	
	
	// module
	exports.push([module.id, "a span.check-mark[_v-52dd76ed] {\n    position: absolute;\n    display: inline-block;\n    right: 15px;\n    margin-top: 5px;\n  }", ""]);
	
	// exports


/***/ },
/* 120 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// <template>
	//   <li style="position:relative">
	//     <a @mousedown.prevent="handleClick" style="cursor:pointer">
	//       <span v-el:v><slot></slot></span>
	//       <span class="glyphicon glyphicon-ok check-mark" v-show="chosen"></span>
	//     </a>
	//   </li>
	// </template>
	
	// <script>
	exports.default = {
	  props: {
	    value: {
	      type: String
	    }
	  },
	  data: function data() {
	    return {
	      chosen: false
	    };
	  },
	
	  computed: {
	    chosen: function chosen() {
	      return this.$parent.value.indexOf(this.value) !== -1;
	    }
	  },
	  methods: {
	    handleClick: function handleClick() {
	      var parent = this.$parent;
	      if (parent.multiple) {
	        var index = parent.value.indexOf(this.value);
	        index === -1 ? parent.value.push(this.value) : parent.value.splice(index, 1);
	      } else {
	        parent.value = [this.value];
	        parent.show = false;
	      }
	    }
	  }
	};
	// </script>

	// <style scoped>
	//   a span.check-mark {
	//     position: absolute;
	//     display: inline-block;
	//     right: 15px;
	//     margin-top: 5px;
	//   }
	// </style>

/***/ },
/* 121 */
/***/ function(module, exports) {

	module.exports = "<li style=\"position:relative\" _v-52dd76ed=\"\">\n    <a @mousedown.prevent=\"handleClick\" style=\"cursor:pointer\" _v-52dd76ed=\"\">\n      <span v-el:v=\"\" _v-52dd76ed=\"\"><slot _v-52dd76ed=\"\"></slot></span>\n      <span class=\"glyphicon glyphicon-ok check-mark\" v-show=\"chosen\" _v-52dd76ed=\"\"></span>\n    </a>\n  </li>";

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(123)
	module.exports = __webpack_require__(125)
	
	if (module.exports.__esModule) module.exports = module.exports.default
	;(typeof module.exports === "function" ? module.exports.options : module.exports).template = __webpack_require__(126)
	if (false) {
	(function () {
	var hotAPI = require("vue-hot-reload-api")
	hotAPI.install(require("vue"))
	if (!hotAPI.compatible) return
	var id = "-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Panel.vue"
	hotAPI.createRecord(id, module.exports)
	module.hot.accept(["-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Panel.vue","-!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Panel.vue"], function () {
	var newOptions = require("-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Panel.vue")
	if (newOptions && newOptions.__esModule) newOptions = newOptions.default
	var newTemplate = require("-!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Panel.vue")
	hotAPI.update(id, newOptions, newTemplate)
	})
	})()
	}

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(124);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./../node_modules/vue-loader/lib/style-rewriter.js?id=_v-3d2d5f88&file=Panel.vue!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Panel.vue", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./../node_modules/vue-loader/lib/style-rewriter.js?id=_v-3d2d5f88&file=Panel.vue!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Panel.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(26)();
	// imports
	
	
	// module
	exports.push([module.id, ".accordion-toggle {\n  cursor: pointer;\n}\n\n.collapse-transition {\n-webkit-transition: max-height .5s ease;\ntransition: max-height .5s ease;\noverflow: hidden;\n}\n\n.collapse-enter, .collapse-leave {\n  max-height: 0!important;\n}", ""]);
	
	// exports


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _coerceBoolean = __webpack_require__(29);
	
	var _coerceBoolean2 = _interopRequireDefault(_coerceBoolean);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    isOpen: {
	      type: Boolean,
	      coerce: _coerceBoolean2.default,
	      default: false
	    },
	    header: {
	      type: String
	    }
	  },
	  data: function data() {
	    return {
	      height: 0
	    };
	  },
	
	  methods: {
	    toggleIsOpen: function toggleIsOpen() {
	      this.isOpen = !this.isOpen;
	      this.$dispatch('isOpenEvent', this);
	    }
	  },
	  ready: function ready() {
	    var panel = this.$els.panel;
	    panel.style.display = 'block';
	    this.height = panel.offsetHeight;
	    panel.style.maxHeight = this.height + 'px';
	    if (!this.isOpen) panel.style.display = 'none';
	  }
	};
	// </script>

	// <style>
	// .accordion-toggle {
	//   cursor: pointer;
	// }

	// .collapse-transition {
	// transition: max-height .5s ease;
	// overflow: hidden;
	// }

	// .collapse-enter, .collapse-leave {
	//   max-height: 0!important;
	// }

	// </style>
	// <template>
	// <div class="panel panel-default">
	//     <div class="panel-heading">
	//       <h4 class="panel-title">
	//         <a class="accordion-toggle"
	//           @click="toggleIsOpen()">
	//            {{ header }}
	//         </a>
	//       </h4>
	//     </div>
	//     <div class="panel-collapse"
	//       v-el:panel
	//       v-show="isOpen"
	//       transition="collapse"
	//     >
	//       <div class="panel-body">
	//         <slot></slot>
	//       </div>
	//     </div>
	//   </div>
	// </template>

	// <script>

/***/ },
/* 126 */
/***/ function(module, exports) {

	module.exports = "<div class=\"panel panel-default\">\n    <div class=\"panel-heading\">\n      <h4 class=\"panel-title\">\n        <a class=\"accordion-toggle\"\n          @click=\"toggleIsOpen()\">\n           {{ header }}\n        </a>\n      </h4>\n    </div>\n    <div class=\"panel-collapse\"\n      v-el:panel\n      v-show=\"isOpen\"\n      transition=\"collapse\"\n    >\n      <div class=\"panel-body\">\n        <slot></slot>\n      </div>\n    </div>\n  </div>";

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(128)
	module.exports = __webpack_require__(130)
	
	if (module.exports.__esModule) module.exports = module.exports.default
	;(typeof module.exports === "function" ? module.exports.options : module.exports).template = __webpack_require__(132)
	if (false) {
	(function () {
	var hotAPI = require("vue-hot-reload-api")
	hotAPI.install(require("vue"))
	if (!hotAPI.compatible) return
	var id = "-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Popover.vue"
	hotAPI.createRecord(id, module.exports)
	module.hot.accept(["-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Popover.vue","-!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Popover.vue"], function () {
	var newOptions = require("-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Popover.vue")
	if (newOptions && newOptions.__esModule) newOptions = newOptions.default
	var newTemplate = require("-!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Popover.vue")
	hotAPI.update(id, newOptions, newTemplate)
	})
	})()
	}

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(129);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./../node_modules/vue-loader/lib/style-rewriter.js?id=_v-2e2f845d&file=Popover.vue!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Popover.vue", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./../node_modules/vue-loader/lib/style-rewriter.js?id=_v-2e2f845d&file=Popover.vue!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Popover.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(26)();
	// imports
	
	
	// module
	exports.push([module.id, ".scale-transition,\n.fade-transition {\n  display: block;\n}\n.scale-enter {\n  -webkit-animation:scale-in 0.15s ease-in;\n          animation:scale-in 0.15s ease-in;\n}\n.scale-leave {\n  -webkit-animation:scale-out 0.15s ease-out;\n          animation:scale-out 0.15s ease-out;\n}\n@-webkit-keyframes scale-in {\n  0% {\n    -webkit-transform: scale(0);\n            transform: scale(0);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 1;\n  }\n}\n@keyframes scale-in {\n  0% {\n    -webkit-transform: scale(0);\n            transform: scale(0);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 1;\n  }\n}\n@-webkit-keyframes scale-out {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: scale(0);\n            transform: scale(0);\n    opacity: 0;\n  }\n}\n@keyframes scale-out {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: scale(0);\n            transform: scale(0);\n    opacity: 0;\n  }\n}", ""]);
	
	// exports


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _popoverMixins = __webpack_require__(131);
	
	var _popoverMixins2 = _interopRequireDefault(_popoverMixins);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_popoverMixins2.default]
	};
	// </script>
	// <style>
	// .scale-transition,
	// .fade-transition {
	//   display: block;
	// }
	// .scale-enter {
	//   animation:scale-in 0.15s ease-in;
	// }
	// .scale-leave {
	//   animation:scale-out 0.15s ease-out;
	// }
	// @keyframes scale-in {
	//   0% {
	//     transform: scale(0);
	//     opacity: 0;
	//   }
	//   100% {
	//     transform: scale(1);
	//     opacity: 1;
	//   }
	// }
	// @keyframes scale-out {
	//   0% {
	//     transform: scale(1);
	//     opacity: 1;
	//   }
	//   100% {
	//     transform: scale(0);
	//     opacity: 0;
	//   }
	// }

	// </style>
	// <template>
	//   <span v-el:trigger>
	//     <slot>
	//     </slot>
	//   </span>
	//   <div class="popover"
	//     v-bind:class="{
	//     'top':placement === 'top',
	//     'left':placement === 'left',
	//     'right':placement === 'right',
	//     'bottom':placement === 'bottom'
	//     }"
	//     v-el:popover
	//     v-show="show"
	//     :transition="effect">
	//       <div class="arrow"></div>
	//       <h3 class="popover-title" v-show="title">{{title}}</h3>
	//       <div class="popover-content">
	//         {{{content}}}
	//       </div>
	//   </div>
	// </template>

	// <script>

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _EventListener = __webpack_require__(73);
	
	var _EventListener2 = _interopRequireDefault(_EventListener);
	
	var _coerceBoolean = __webpack_require__(29);
	
	var _coerceBoolean2 = _interopRequireDefault(_coerceBoolean);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopoverMixin = {
	  props: {
	    trigger: {
	      type: String,
	      default: 'click'
	    },
	    effect: {
	      type: String,
	      default: 'fadein'
	    },
	    title: {
	      type: String
	    },
	    content: {
	      type: String
	    },
	    header: {
	      type: Boolean,
	      coerce: _coerceBoolean2.default,
	      default: true
	    },
	    placement: {
	      type: String
	    }
	  },
	  data: function data() {
	    return {
	      position: {
	        top: 0,
	        left: 0
	      },
	      show: true
	    };
	  },
	
	  methods: {
	    toggle: function toggle() {
	      this.show = !this.show;
	    }
	  },
	  ready: function ready() {
	    var _this = this;
	
	    if (!this.$els.popover) return console.error("Couldn't find popover v-el in your component that uses popoverMixin.");
	    var popover = this.$els.popover;
	    var triger = this.$els.trigger.children[0];
	    if (this.trigger === 'hover') {
	      this._mouseenterEvent = _EventListener2.default.listen(triger, 'mouseenter', function () {
	        return _this.show = true;
	      });
	      this._mouseleaveEvent = _EventListener2.default.listen(triger, 'mouseleave', function () {
	        return _this.show = false;
	      });
	    } else if (this.trigger === 'focus') {
	      this._focusEvent = _EventListener2.default.listen(triger, 'focus', function () {
	        return _this.show = true;
	      });
	      this._blurEvent = _EventListener2.default.listen(triger, 'blur', function () {
	        return _this.show = false;
	      });
	    } else {
	      this._clickEvent = _EventListener2.default.listen(triger, 'click', this.toggle);
	    }
	
	    switch (this.placement) {
	      case 'top':
	        this.position.left = triger.offsetLeft - popover.offsetWidth / 2 + triger.offsetWidth / 2;
	        this.position.top = triger.offsetTop - popover.offsetHeight;
	        break;
	      case 'left':
	        this.position.left = triger.offsetLeft - popover.offsetWidth;
	        this.position.top = triger.offsetTop + triger.offsetHeight / 2 - popover.offsetHeight / 2;
	        break;
	      case 'right':
	        this.position.left = triger.offsetLeft + triger.offsetWidth;
	        this.position.top = triger.offsetTop + triger.offsetHeight / 2 - popover.offsetHeight / 2;
	        break;
	      case 'bottom':
	        this.position.left = triger.offsetLeft - popover.offsetWidth / 2 + triger.offsetWidth / 2;
	        this.position.top = triger.offsetTop + triger.offsetHeight;
	        break;
	      default:
	        console.log('Wrong placement prop');
	    }
	    popover.style.top = this.position.top + 'px';
	    popover.style.left = this.position.left + 'px';
	    popover.style.display = 'none';
	    this.show = !this.show;
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this._blurEvent) {
	      this._blurEvent.remove();
	      this._focusEvent.remove();
	    }
	    if (this._mouseenterEvent) {
	      this._mouseenterEvent.remove();
	      this._mouseleaveEvent.remove();
	    }
	    if (this._clickEvent) this._clickEvent.remove();
	  }
	};
	
	exports.default = PopoverMixin;

/***/ },
/* 132 */
/***/ function(module, exports) {

	module.exports = "<span v-el:trigger>\n    <slot>\n    </slot>\n  </span>\n  <div class=\"popover\"\n    v-bind:class=\"{\n    'top':placement === 'top',\n    'left':placement === 'left',\n    'right':placement === 'right',\n    'bottom':placement === 'bottom'\n    }\"\n    v-el:popover\n    v-show=\"show\"\n    :transition=\"effect\">\n      <div class=\"arrow\"></div>\n      <h3 class=\"popover-title\" v-show=\"title\">{{title}}</h3>\n      <div class=\"popover-content\">\n        {{{content}}}\n      </div>\n  </div>";

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(134)
	
	if (module.exports.__esModule) module.exports = module.exports.default
	;(typeof module.exports === "function" ? module.exports.options : module.exports).template = __webpack_require__(135)
	if (false) {
	(function () {
	var hotAPI = require("vue-hot-reload-api")
	hotAPI.install(require("vue"))
	if (!hotAPI.compatible) return
	var id = "-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Progressbar.vue"
	hotAPI.createRecord(id, module.exports)
	module.hot.accept(["-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Progressbar.vue","-!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Progressbar.vue"], function () {
	var newOptions = require("-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Progressbar.vue")
	if (newOptions && newOptions.__esModule) newOptions = newOptions.default
	var newTemplate = require("-!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Progressbar.vue")
	hotAPI.update(id, newOptions, newTemplate)
	})
	})()
	}

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _coerceBoolean = __webpack_require__(29);
	
	var _coerceBoolean2 = _interopRequireDefault(_coerceBoolean);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    now: {
	      type: Number,
	      require: true
	    },
	    label: {
	      type: Boolean,
	      coerce: _coerceBoolean2.default,
	      default: false
	    },
	    type: {
	      type: String
	    },
	    striped: {
	      type: Boolean,
	      coerce: _coerceBoolean2.default,
	      default: false
	    },
	    animated: {
	      type: Boolean,
	      coerce: _coerceBoolean2.default,
	      default: false
	    }
	  }
	};
	// </script>
	// <template>
	//   <div role="progressbar"
	//     v-bind:class="{
	//     'progress-bar' : true,
	//     'progress-bar-success':type == 'success',
	//     'progress-bar-warning':type == 'warning',
	//     'progress-bar-info':type == 'info',
	//     'progress-bar-danger':type == 'danger',
	//     'progress-bar-striped':striped,
	//     'active':animated
	//     }"
	//     v-bind:style="{width: now + '%'}">
	//     {{label ? now + '%':'' }}
	//   </div>
	// </template>

	// <script>

/***/ },
/* 135 */
/***/ function(module, exports) {

	module.exports = "<div role=\"progressbar\"\n    v-bind:class=\"{\n    'progress-bar' : true,\n    'progress-bar-success':type == 'success',\n    'progress-bar-warning':type == 'warning',\n    'progress-bar-info':type == 'info',\n    'progress-bar-danger':type == 'danger',\n    'progress-bar-striped':striped,\n    'active':animated\n    }\"\n    v-bind:style=\"{width: now + '%'}\">\n    {{label ? now + '%':'' }}\n  </div>";

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(137)
	
	if (module.exports.__esModule) module.exports = module.exports.default
	;(typeof module.exports === "function" ? module.exports.options : module.exports).template = __webpack_require__(138)
	if (false) {
	(function () {
	var hotAPI = require("vue-hot-reload-api")
	hotAPI.install(require("vue"))
	if (!hotAPI.compatible) return
	var id = "-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./radioBtn.vue"
	hotAPI.createRecord(id, module.exports)
	module.hot.accept(["-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./radioBtn.vue","-!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./radioBtn.vue"], function () {
	var newOptions = require("-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./radioBtn.vue")
	if (newOptions && newOptions.__esModule) newOptions = newOptions.default
	var newTemplate = require("-!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./radioBtn.vue")
	hotAPI.update(id, newOptions, newTemplate)
	})
	})()
	}

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _coerceBoolean = __webpack_require__(29);
	
	var _coerceBoolean2 = _interopRequireDefault(_coerceBoolean);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    value: {
	      type: String
	    },
	    checked: {
	      type: Boolean,
	      coerce: _coerceBoolean2.default,
	      default: false
	    }
	  },
	  computed: {
	    type: function type() {
	      return this.$parent.type;
	    },
	    active: function active() {
	      return this.$parent.value === this.value;
	    }
	  },
	  methods: {
	    handleClick: function handleClick() {
	      this.$parent.value = this.value;
	    }
	  },
	  created: function created() {
	    if (this.$parent.value === this.value) {
	      this.checked = true;
	    } else if (!this.$parent.value.length && this.checked) {
	      this.$parent.value = this.value;
	    }
	  }
	};
	// </script>
	// <template>
	//   <label class="btn"
	//   v-bind:class="{
	//     'active':active,
	//     'btn-success':type == 'success',
	//     'btn-warning':type == 'warning',
	//     'btn-info':type == 'info',
	//     'btn-danger':type == 'danger',
	//     'btn-default':type == 'default',
	//     'btn-primary':type == 'primary'
	//   }">

	//     <input type="radio" autocomplete="off"
	//       :checked="checked"
	//       @click="handleClick"
	//     />

	//     <slot></slot>

	//   </label>
	// </template>

	// <script>

/***/ },
/* 138 */
/***/ function(module, exports) {

	module.exports = "<label class=\"btn\"\n  v-bind:class=\"{\n    'active':active,\n    'btn-success':type == 'success',\n    'btn-warning':type == 'warning',\n    'btn-info':type == 'info',\n    'btn-danger':type == 'danger',\n    'btn-default':type == 'default',\n    'btn-primary':type == 'primary'\n  }\">\n\n    <input type=\"radio\" autocomplete=\"off\"\n      :checked=\"checked\"\n      @click=\"handleClick\"\n    />\n\n    <slot></slot>\n\n  </label>";

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(140)
	
	if (module.exports.__esModule) module.exports = module.exports.default
	;(typeof module.exports === "function" ? module.exports.options : module.exports).template = __webpack_require__(141)
	if (false) {
	(function () {
	var hotAPI = require("vue-hot-reload-api")
	hotAPI.install(require("vue"))
	if (!hotAPI.compatible) return
	var id = "-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./radioGroup.vue"
	hotAPI.createRecord(id, module.exports)
	module.hot.accept(["-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./radioGroup.vue","-!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./radioGroup.vue"], function () {
	var newOptions = require("-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./radioGroup.vue")
	if (newOptions && newOptions.__esModule) newOptions = newOptions.default
	var newTemplate = require("-!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./radioGroup.vue")
	hotAPI.update(id, newOptions, newTemplate)
	})
	})()
	}

/***/ },
/* 140 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// <template>
	//   <div class="btn-group" data-toggle="buttons">
	//     <slot></slot>
	//   </div>
	// </template>
	
	// <script>
	exports.default = {
	  props: {
	    value: {
	      type: String,
	      twoWay: true
	    },
	    type: {
	      type: String,
	      default: 'default'
	    }
	  }
	};
	// </script>

/***/ },
/* 141 */
/***/ function(module, exports) {

	module.exports = "<div class=\"btn-group\" data-toggle=\"buttons\">\n    <slot></slot>\n  </div>";

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(143)
	module.exports = __webpack_require__(145)
	
	if (module.exports.__esModule) module.exports = module.exports.default
	;(typeof module.exports === "function" ? module.exports.options : module.exports).template = __webpack_require__(146)
	if (false) {
	(function () {
	var hotAPI = require("vue-hot-reload-api")
	hotAPI.install(require("vue"))
	if (!hotAPI.compatible) return
	var id = "-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Select.vue"
	hotAPI.createRecord(id, module.exports)
	module.hot.accept(["-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Select.vue","-!vue-html-loader!./../node_modules/vue-loader/lib/template-rewriter.js?id=_v-c36af018&file=Select.vue!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Select.vue"], function () {
	var newOptions = require("-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Select.vue")
	if (newOptions && newOptions.__esModule) newOptions = newOptions.default
	var newTemplate = require("-!vue-html-loader!./../node_modules/vue-loader/lib/template-rewriter.js?id=_v-c36af018&file=Select.vue!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Select.vue")
	hotAPI.update(id, newOptions, newTemplate)
	})
	})()
	}

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(144);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./../node_modules/vue-loader/lib/style-rewriter.js?id=_v-c36af018&file=Select.vue&scoped=true!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Select.vue", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./../node_modules/vue-loader/lib/style-rewriter.js?id=_v-c36af018&file=Select.vue&scoped=true!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Select.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(26)();
	// imports
	
	
	// module
	exports.push([module.id, ".bs-searchbox[_v-c36af018] {\n    padding: 4px 8px;\n  }\n  .btn-group .dropdown-menu .notify[_v-c36af018] {\n    position: absolute;\n    bottom: 5px;\n    width: 96%;\n    margin: 0 2%;\n    min-height: 26px;\n    padding: 3px 5px;\n    background: #f5f5f5;\n    border: 1px solid #e3e3e3;\n    box-shadow: inset 0 1px 1px rgba(0,0,0,.05);\n     pointer-events: none;\n    opacity: .9;\n  }", ""]);
	
	// exports


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _coerceBoolean = __webpack_require__(29);
	
	var _coerceBoolean2 = _interopRequireDefault(_coerceBoolean);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    options: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    value: {
	      twoWay: true
	    },
	    placeholder: {
	      type: String,
	      default: 'Nothing Selected'
	    },
	    multiple: {
	      type: Boolean,
	      coerce: _coerceBoolean2.default,
	      default: false
	    },
	    search: { // Allow searching (only works when options are provided)
	      type: Boolean,
	      coerce: _coerceBoolean2.default,
	      default: false
	    },
	    limit: {
	      type: Number,
	      default: 1024
	    },
	    closeOnSelect: { // only works when multiple==false
	      type: Boolean,
	      coerce: _coerceBoolean2.default,
	      default: false
	    },
	    disabled: {
	      type: Boolean,
	      coerce: _coerceBoolean2.default,
	      default: false
	    }
	  },
	  ready: function ready() {
	    if (this.value.constructor !== Array) {
	      if (this.value.length === 0) {
	        this.value = [];
	      } else {
	        this.value = [this.value];
	      }
	    } else {
	      if (!this.multiple && this.value.length > 1) {
	        this.value = this.value.slice(0, 1);
	      } else if (this.multiple && this.value.length > this.limit) {
	        this.value = this.value.slice(0, this.limit);
	      }
	    }
	  },
	  data: function data() {
	    return {
	      searchText: null,
	      show: false,
	      showNotify: false
	    };
	  },
	
	  computed: {
	    selectedItems: function selectedItems() {
	      var foundItems = [];
	      if (this.value.length) {
	        for (var item in this.value) {
	          if (typeof this.value[item] === "string") {
	            foundItems.push(this.value[item]);
	          }
	        }
	        return foundItems.join(', ');
	      }
	    },
	    showPlaceholder: function showPlaceholder() {
	      return this.value.length === 0;
	    }
	  },
	  watch: {
	    value: function value(val) {
	      var _this = this;
	
	      if (val.length > this.limit) {
	        this.showNotify = true;
	        this.value.pop();
	        setTimeout(function () {
	          return _this.showNotify = false;
	        }, 1000);
	      }
	    }
	  },
	  methods: {
	    select: function select(v) {
	      if (this.value.indexOf(v) === -1) {
	        if (this.multiple) {
	          this.value.push(v);
	        } else {
	          this.value = [v];
	        }
	      } else {
	        if (this.multiple) {
	          this.value.$remove(v);
	        }
	      }
	      if (this.closeOnSelect) {
	        this.toggleDropdown();
	      }
	    },
	    toggleDropdown: function toggleDropdown() {
	      this.show = !this.show;
	    }
	  }
	};
	// </script>

	// <style scoped>
	//   .bs-searchbox {
	//     padding: 4px 8px;
	//   }
	//   .btn-group .dropdown-menu .notify {
	//     position: absolute;
	//     bottom: 5px;
	//     width: 96%;
	//     margin: 0 2%;
	//     min-height: 26px;
	//     padding: 3px 5px;
	//     background: #f5f5f5;
	//     border: 1px solid #e3e3e3;
	//     box-shadow: inset 0 1px 1px rgba(0,0,0,.05);
	//      pointer-events: none;
	//     opacity: .9;
	//   }
	// </style>
	// <template>
	//   <div class="btn-group" v-bind:class="{open: show}">
	//     <button v-el:btn type="button" class="btn btn-default dropdown-toggle"
	//       @click="toggleDropdown"
	//       @blur="show = (search ? show : false)"
	//       v-bind="{disabled: disabled}"
	//     >
	//       <span class="btn-placeholder" v-show="showPlaceholder">{{placeholder}}</span>
	//       <span class="btn-content">{{ selectedItems }}</span>
	//       <span class="caret"></span>
	//     </button>
	//     <ul class="dropdown-menu">
	//       <template v-if="options.length">
	//         <li v-if="search" class="bs-searchbox">
	//           <input type="text" placeholder="Search" v-model="searchText" class="form-control" autocomplete="off">
	//         </li>
	//         <li v-for="option in options | filterBy searchText " v-bind:id="option.value" style="position:relative">
	//           <a @mousedown.prevent="select(option.value)" style="cursor:pointer">
	//             {{ option.label }}
	//             <span class="glyphicon glyphicon-ok check-mark" v-show="value.indexOf(option.value) !== -1"></span>
	//           </a>
	//         </li>
	//       </template>
	//       <slot v-else></slot>
	//       <div class="notify" v-show="showNotify" transition="fadein">Limit reached ({{limit}} items max).</div>
	//     </ul>
	//   </div>
	// </template>

	// <script>

/***/ },
/* 146 */
/***/ function(module, exports) {

	module.exports = "<div class=\"btn-group\" v-bind:class=\"{open: show}\" _v-c36af018=\"\">\n    <button v-el:btn=\"\" type=\"button\" class=\"btn btn-default dropdown-toggle\" @click=\"toggleDropdown\" @blur=\"show = (search ? show : false)\" v-bind=\"{disabled: disabled}\" _v-c36af018=\"\">\n      <span class=\"btn-placeholder\" v-show=\"showPlaceholder\" _v-c36af018=\"\">{{placeholder}}</span>\n      <span class=\"btn-content\" _v-c36af018=\"\">{{ selectedItems }}</span>\n      <span class=\"caret\" _v-c36af018=\"\"></span>\n    </button>\n    <ul class=\"dropdown-menu\" _v-c36af018=\"\">\n      <template v-if=\"options.length\" _v-c36af018=\"\">\n        <li v-if=\"search\" class=\"bs-searchbox\" _v-c36af018=\"\">\n          <input type=\"text\" placeholder=\"Search\" v-model=\"searchText\" class=\"form-control\" autocomplete=\"off\" _v-c36af018=\"\">\n        </li>\n        <li v-for=\"option in options | filterBy searchText \" v-bind:id=\"option.value\" style=\"position:relative\" _v-c36af018=\"\">\n          <a @mousedown.prevent=\"select(option.value)\" style=\"cursor:pointer\" _v-c36af018=\"\">\n            {{ option.label }}\n            <span class=\"glyphicon glyphicon-ok check-mark\" v-show=\"value.indexOf(option.value) !== -1\" _v-c36af018=\"\"></span>\n          </a>\n        </li>\n      </template>\n      <slot v-else=\"\" _v-c36af018=\"\"></slot>\n      <div class=\"notify\" v-show=\"showNotify\" transition=\"fadein\" _v-c36af018=\"\">Limit reached ({{limit}} items max).</div>\n    </ul>\n  </div>";

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(148)
	module.exports = __webpack_require__(150)
	
	if (module.exports.__esModule) module.exports = module.exports.default
	;(typeof module.exports === "function" ? module.exports.options : module.exports).template = __webpack_require__(151)
	if (false) {
	(function () {
	var hotAPI = require("vue-hot-reload-api")
	hotAPI.install(require("vue"))
	if (!hotAPI.compatible) return
	var id = "-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Tab.vue"
	hotAPI.createRecord(id, module.exports)
	module.hot.accept(["-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Tab.vue","-!vue-html-loader!./../node_modules/vue-loader/lib/template-rewriter.js?id=_v-16bcbd4d&file=Tab.vue!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Tab.vue"], function () {
	var newOptions = require("-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Tab.vue")
	if (newOptions && newOptions.__esModule) newOptions = newOptions.default
	var newTemplate = require("-!vue-html-loader!./../node_modules/vue-loader/lib/template-rewriter.js?id=_v-16bcbd4d&file=Tab.vue!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Tab.vue")
	hotAPI.update(id, newOptions, newTemplate)
	})
	})()
	}

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(149);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./../node_modules/vue-loader/lib/style-rewriter.js?id=_v-16bcbd4d&file=Tab.vue&scoped=true!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Tab.vue", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./../node_modules/vue-loader/lib/style-rewriter.js?id=_v-16bcbd4d&file=Tab.vue&scoped=true!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Tab.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(26)();
	// imports
	
	
	// module
	exports.push([module.id, ".tab-content > .tab-pane[_v-16bcbd4d] {\n    display: block;\n  }", ""]);
	
	// exports


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _coerceBoolean = __webpack_require__(29);
	
	var _coerceBoolean2 = _interopRequireDefault(_coerceBoolean);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    header: {
	      type: String
	    },
	    disabled: {
	      type: Boolean,
	      coerce: _coerceBoolean2.default,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      index: 0,
	      show: false
	    };
	  },
	
	  computed: {
	    show: function show() {
	      return this.$parent.active == this.index;
	    },
	    transition: function transition() {
	      return this.$parent.effect;
	    }
	  },
	  created: function created() {
	    this.$parent.renderData.push({
	      header: this.header,
	      disabled: this.disabled
	    });
	  },
	  ready: function ready() {
	    for (var c in this.$parent.$children) {
	      if (this.$parent.$children[c].$el == this.$el) {
	        this.index = c;
	        break;
	      }
	    }
	  }
	};
	// </script>

	// <style scoped>
	//   .tab-content > .tab-pane {
	//     display: block;
	//   }
	// </style>
	// <template>
	//   <div role="tabpanel" class="tab-pane"
	//       v-bind:class="{hide:!show}"
	//       v-show="show"
	//       :transition="transition"
	//   >
	//     <slot></slot>
	//   </div>
	// </template>

	// <script>

/***/ },
/* 151 */
/***/ function(module, exports) {

	module.exports = "<div role=\"tabpanel\" class=\"tab-pane\" v-bind:class=\"{hide:!show}\" v-show=\"show\" :transition=\"transition\" _v-16bcbd4d=\"\">\n    <slot _v-16bcbd4d=\"\"></slot>\n  </div>";

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(153)
	module.exports = __webpack_require__(155)
	
	if (module.exports.__esModule) module.exports = module.exports.default
	;(typeof module.exports === "function" ? module.exports.options : module.exports).template = __webpack_require__(156)
	if (false) {
	(function () {
	var hotAPI = require("vue-hot-reload-api")
	hotAPI.install(require("vue"))
	if (!hotAPI.compatible) return
	var id = "-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Tabset.vue"
	hotAPI.createRecord(id, module.exports)
	module.hot.accept(["-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Tabset.vue","-!vue-html-loader!./../node_modules/vue-loader/lib/template-rewriter.js?id=_v-1ab76b25&file=Tabset.vue!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Tabset.vue"], function () {
	var newOptions = require("-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Tabset.vue")
	if (newOptions && newOptions.__esModule) newOptions = newOptions.default
	var newTemplate = require("-!vue-html-loader!./../node_modules/vue-loader/lib/template-rewriter.js?id=_v-1ab76b25&file=Tabset.vue!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Tabset.vue")
	hotAPI.update(id, newOptions, newTemplate)
	})
	})()
	}

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(154);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./../node_modules/vue-loader/lib/style-rewriter.js?id=_v-1ab76b25&file=Tabset.vue&scoped=true!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Tabset.vue", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./../node_modules/vue-loader/lib/style-rewriter.js?id=_v-1ab76b25&file=Tabset.vue&scoped=true!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Tabset.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(26)();
	// imports
	
	
	// module
	exports.push([module.id, ".nav-tabs[_v-1ab76b25] {\n    margin-bottom: 15px\n  }", ""]);
	
	// exports


/***/ },
/* 155 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// <template>
	//   <div>
	//     <!-- Nav tabs -->
	//      <ul class="nav nav-tabs" role="tablist">
	//             <li
	//                 v-for="r in renderData"
	//                 v-bind:class="{
	//                   'active': ($index === active),
	//                   'disabled': r.disabled
	//                 }"
	//                 @click.prevent="handleTabListClick($index, r)"
	//                 :disabled="r.disabled"
	//             >
	//                 <a href="#">{{{r.header}}}</a>
	//             </li>
	//      </ul>
	
	//      <!-- Tab panes -->
	//      <div class="tab-content" v-el:tabContent>
	//         <slot></slot>
	//      </div>
	//   </div>
	// </template>
	
	// <script>
	exports.default = {
	  props: {
	    effect: {
	      type: String,
	      default: 'fadein'
	    },
	    active: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      renderData: []
	    };
	  },
	
	  methods: {
	    handleTabListClick: function handleTabListClick(index, el) {
	      if (!el.disabled) this.active = index;
	    }
	  }
	};
	// </script>

	// <style scoped>
	//   .nav-tabs {
	//     margin-bottom: 15px
	//   }
	// </style>

/***/ },
/* 156 */
/***/ function(module, exports) {

	module.exports = "<div _v-1ab76b25=\"\">\n    <!-- Nav tabs -->\n     <ul class=\"nav nav-tabs\" role=\"tablist\" _v-1ab76b25=\"\">\n            <li v-for=\"r in renderData\" v-bind:class=\"{\n                  'active': ($index === active),\n                  'disabled': r.disabled\n                }\" @click.prevent=\"handleTabListClick($index, r)\" :disabled=\"r.disabled\" _v-1ab76b25=\"\">\n                <a href=\"#\" _v-1ab76b25=\"\">{{{r.header}}}</a>\n            </li>\n     </ul>\n\n     <!-- Tab panes -->\n     <div class=\"tab-content\" v-el:tabcontent=\"\" _v-1ab76b25=\"\">\n        <slot _v-1ab76b25=\"\"></slot>\n     </div>\n  </div>";

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(158)
	module.exports = __webpack_require__(160)
	
	if (module.exports.__esModule) module.exports = module.exports.default
	;(typeof module.exports === "function" ? module.exports.options : module.exports).template = __webpack_require__(161)
	if (false) {
	(function () {
	var hotAPI = require("vue-hot-reload-api")
	hotAPI.install(require("vue"))
	if (!hotAPI.compatible) return
	var id = "-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Tooltip.vue"
	hotAPI.createRecord(id, module.exports)
	module.hot.accept(["-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Tooltip.vue","-!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Tooltip.vue"], function () {
	var newOptions = require("-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Tooltip.vue")
	if (newOptions && newOptions.__esModule) newOptions = newOptions.default
	var newTemplate = require("-!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Tooltip.vue")
	hotAPI.update(id, newOptions, newTemplate)
	})
	})()
	}

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(159);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./../node_modules/vue-loader/lib/style-rewriter.js?id=_v-52c516bb&file=Tooltip.vue!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Tooltip.vue", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./../node_modules/vue-loader/lib/style-rewriter.js?id=_v-52c516bb&file=Tooltip.vue!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Tooltip.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(26)();
	// imports
	
	
	// module
	exports.push([module.id, ".tooltip {\n    opacity: .9\n  }\n.fadein-enter {\n  -webkit-animation:fadein-in 0.3s ease-in;\n          animation:fadein-in 0.3s ease-in;\n}\n.fadein-leave {\n  -webkit-animation:fadein-out 0.3s ease-out;\n          animation:fadein-out 0.3s ease-out;\n}\n@-webkit-keyframes fadein-in {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes fadein-in {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@-webkit-keyframes fadein-out {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n@keyframes fadein-out {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}", ""]);
	
	// exports


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _popoverMixins = __webpack_require__(131);
	
	var _popoverMixins2 = _interopRequireDefault(_popoverMixins);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_popoverMixins2.default],
	  props: {
	    trigger: {
	      type: String,
	      default: 'hover'
	    },
	    effect: {
	      type: String,
	      default: 'scale'
	    }
	  }
	};
	// </script>

	// <style>
	//   .tooltip {
	//     opacity: .9
	//   }
	// .fadein-enter {
	//   animation:fadein-in 0.3s ease-in;
	// }
	// .fadein-leave {
	//   animation:fadein-out 0.3s ease-out;
	// }
	// @keyframes fadein-in {
	//   0% {
	//     opacity: 0;
	//   }
	//   100% {
	//     opacity: 1;
	//   }
	// }
	// @keyframes fadein-out {
	//   0% {
	//     opacity: 1;
	//   }
	//   100% {
	//     opacity: 0;
	//   }
	// }

	// </style>
	// <template>
	//   <span v-el:trigger>
	//     <slot>
	//     </slot>
	//   </span>
	//   <div class="tooltip"
	//     v-bind:class="{
	//     'top':    placement === 'top',
	//     'left':   placement === 'left',
	//     'right':  placement === 'right',
	//     'bottom': placement === 'bottom'
	//     }"
	//     v-el:popover
	//     v-show="show"
	//     :transition="effect"
	//     role="tooltip">
	//     <div class="tooltip-arrow"></div>
	//     <div class="tooltip-inner">
	//       {{{content}}}
	//     </div>
	//   </div>
	// </template>

	// <script>

/***/ },
/* 161 */
/***/ function(module, exports) {

	module.exports = "<span v-el:trigger>\n    <slot>\n    </slot>\n  </span>\n  <div class=\"tooltip\"\n    v-bind:class=\"{\n    'top':    placement === 'top',\n    'left':   placement === 'left',\n    'right':  placement === 'right',\n    'bottom': placement === 'bottom'\n    }\"\n    v-el:popover\n    v-show=\"show\"\n    :transition=\"effect\"\n    role=\"tooltip\">\n    <div class=\"tooltip-arrow\"></div>\n    <div class=\"tooltip-inner\">\n      {{{content}}}\n    </div>\n  </div>";

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(163)
	module.exports = __webpack_require__(165)
	
	if (module.exports.__esModule) module.exports = module.exports.default
	;(typeof module.exports === "function" ? module.exports.options : module.exports).template = __webpack_require__(167)
	if (false) {
	(function () {
	var hotAPI = require("vue-hot-reload-api")
	hotAPI.install(require("vue"))
	if (!hotAPI.compatible) return
	var id = "-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Typeahead.vue"
	hotAPI.createRecord(id, module.exports)
	module.hot.accept(["-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Typeahead.vue","-!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Typeahead.vue"], function () {
	var newOptions = require("-!babel!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Typeahead.vue")
	if (newOptions && newOptions.__esModule) newOptions = newOptions.default
	var newTemplate = require("-!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Typeahead.vue")
	hotAPI.update(id, newOptions, newTemplate)
	})
	})()
	}

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(164);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(27)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./../node_modules/vue-loader/lib/style-rewriter.js?id=_v-de861102&file=Typeahead.vue!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Typeahead.vue", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./../node_modules/vue-loader/lib/style-rewriter.js?id=_v-de861102&file=Typeahead.vue!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Typeahead.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(26)();
	// imports
	
	
	// module
	exports.push([module.id, ".dropdown-menu > li > a {\n  cursor: pointer;\n}", ""]);
	
	// exports


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _callAjax = __webpack_require__(166);
	
	var _callAjax2 = _interopRequireDefault(_callAjax);
	
	var _coerceBoolean = __webpack_require__(29);
	
	var _coerceBoolean2 = _interopRequireDefault(_coerceBoolean);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// <template>
	// <div style="position: relative"
	//   v-bind:class="{'open':showDropdown}"
	//   >
	//   <input type="text" class="form-control"
	//     :placeholder="placeholder"
	//     autocomplete="off"
	//     v-model="query"
	//     @input="update"
	//     @keydown.up="up"
	//     @keydown.down="down"
	//     @keydown.enter= "hit"
	//     @keydown.esc="reset"
	//     @blur="showDropdown = false"
	//   />
	//   <ul class="dropdown-menu" v-el:dropdown>
	//     <li v-for="item in items" v-bind:class="{'active': isActive($index)}">
	//       <a @mousedown.prevent="hit" @mousemove="setActive($index)">
	//         <partial :name="templateName"></partial>
	//       </a>
	//     </li>
	//   </ul>
	// </div>
	
	// </template>
	
	// <script>
	
	var typeahead = {
	  created: function created() {
	    this.items = this.primitiveData;
	  },
	
	  partials: {
	    'default': '<span v-html="item | highlight query"></span>'
	  },
	  props: {
	    data: {
	      type: Array
	    },
	    limit: {
	      type: Number,
	      default: 8
	    },
	    async: {
	      type: String
	    },
	    template: {
	      type: String
	    },
	    templateName: {
	      type: String,
	      default: 'default'
	    },
	    key: {
	      type: String
	    },
	    matchCase: {
	      type: Boolean,
	      coerce: _coerceBoolean2.default,
	      default: false
	    },
	    onHit: {
	      type: Function,
	      default: function _default(items) {
	        this.reset();
	        this.query = items;
	      }
	    },
	    placeholder: {
	      type: String
	    }
	  },
	  data: function data() {
	    return {
	      query: '',
	      showDropdown: false,
	      noResults: true,
	      current: 0,
	      items: []
	    };
	  },
	
	  computed: {
	    primitiveData: function primitiveData() {
	      var _this2 = this;
	
	      var _this = this;
	
	      if (this.data) {
	        return this.data.filter(function (value) {
	          value = _this2.matchCase ? value : value.toLowerCase();
	          var query = _this2.matchCase ? _this.query : _this.query.toLowerCase();
	          return value.indexOf(query) !== -1;
	        }).slice(0, this.limit);
	      }
	    }
	  },
	  ready: function ready() {
	    // register a partial:
	    if (this.templateName && this.templateName !== 'default') {
	      Vue.partial(this.templateName, this.template);
	    }
	  },
	
	  methods: {
	    update: function update() {
	      var _this3 = this;
	
	      if (!this.query) {
	        this.reset();
	        return false;
	      }
	      if (this.data) {
	        this.items = this.primitiveData;
	        this.showDropdown = this.items.length ? true : false;
	      }
	      if (this.async) {
	        (0, _callAjax2.default)(this.async + this.query, function (data) {
	          _this3.items = data[_this3.key].slice(0, _this3.limit);
	          _this3.showDropdown = _this3.items.length ? true : false;
	        });
	      }
	    },
	    reset: function reset() {
	      this.items = [];
	      this.query = '';
	      this.loading = false;
	      this.showDropdown = false;
	    },
	    setActive: function setActive(index) {
	      this.current = index;
	    },
	    isActive: function isActive(index) {
	      return this.current === index;
	    },
	    hit: function hit(e) {
	      e.preventDefault();
	      this.onHit(this.items[this.current], this);
	    },
	    up: function up() {
	      if (this.current > 0) this.current--;
	    },
	    down: function down() {
	      if (this.current < this.items.length - 1) this.current++;
	    }
	  },
	  filters: {
	    highlight: function highlight(value, phrase) {
	      return value.replace(new RegExp('(' + phrase + ')', 'gi'), '<strong>$1</strong>');
	    }
	  }
	};
	exports.default = typeahead;
	// </script>

	// <style>
	// .dropdown-menu > li > a {
	//   cursor: pointer;
	// }
	// </style>

/***/ },
/* 166 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (url, callback) {
	    var httpRequest = new XMLHttpRequest();
	    httpRequest.onreadystatechange = function () {
	        if (httpRequest.readyState === 4) {
	            if (httpRequest.status === 200) {
	                var data = JSON.parse(httpRequest.responseText);
	                if (callback) callback(data);
	            }
	        }
	    };
	    httpRequest.open('GET', url);
	    httpRequest.send();
	};

/***/ },
/* 167 */
/***/ function(module, exports) {

	module.exports = "<div style=\"position: relative\"\n  v-bind:class=\"{'open':showDropdown}\"\n  >\n  <input type=\"text\" class=\"form-control\"\n    :placeholder=\"placeholder\"\n    autocomplete=\"off\"\n    v-model=\"query\"\n    @input=\"update\"\n    @keydown.up=\"up\"\n    @keydown.down=\"down\"\n    @keydown.enter= \"hit\"\n    @keydown.esc=\"reset\"\n    @blur=\"showDropdown = false\"\n  />\n  <ul class=\"dropdown-menu\" v-el:dropdown>\n    <li v-for=\"item in items\" v-bind:class=\"{'active': isActive($index)}\">\n      <a @mousedown.prevent=\"hit\" @mousemove=\"setActive($index)\">\n        <partial :name=\"templateName\"></partial>\n      </a>\n    </li>\n  </ul>\n</div>";

/***/ }
/******/ ])
});
;
//# sourceMappingURL=vue-strap.js.map
},
'moment/moment':function(){
//! moment.js
//! version : 2.27.0
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                    matched,
                    p1,
                    p2,
                    p3,
                    p4
                ) {
                    return p1 || p2 || p3 || p4;
                })
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
            '_'
        ),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                aliasedRequire('./locale/' + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged and will be removed in an upcoming major release. Please refer to ' +
            'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
        input,
        array,
        config,
        token
    ) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.27.0';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));
},
'moment-timezone/moment-timezone':function(){
//! moment-timezone.js
//! version : 0.5.31
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if (typeof module === 'object' && module.exports) {
		module.exports = factory(require('moment')); // Node
	} else if (typeof define === 'function' && define.amd) {
		define(['moment'], factory);                 // AMD
	} else {
		factory(root.moment);                        // Browser
	}
}(this, function (moment) {
	"use strict";

	// Resolves es6 module loading issue
	if (moment.version === undefined && moment.default) {
		moment = moment.default;
	}

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.31",
		zones = {},
		links = {},
		countries = {},
		names = {},
		guesses = {},
		cachedGuess;

	if (!moment || typeof moment.version !== 'string') {
		logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
	}

	var momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			for (i = 0; i < untils.length; i++) {
				if (target < untils[i]) {
					return i;
				}
			}
		},

		countries : function () {
			var zone_name = this.name;
			return Object.keys(countries).filter(function (country_code) {
				return countries[country_code].zones.indexOf(zone_name) !== -1;
			});
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			logError("zone.offset has been deprecated in favor of zone.utcOffset");
			return this.offsets[this._index(mom)];
		},

		utcOffset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Country object
	************************************/

	function Country (country_name, zone_names) {
		this.name = country_name;
		this.zones = zone_names;
	}

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			offsets = [last],
			change, next, i;

		for (i = 1; i < 48; i++) {
			next = new OffsetAt(new Date(startYear, i, 1));
			if (next.offset !== last.offset) {
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
			}
			last = next;
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		if (a.zone.population !== b.zone.population) {
			return b.zone.population - a.zone.population;
		}
		return b.zone.name.localeCompare(a.zone.name);
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			i, j, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			guessesOffset = guesses[offsets[i].offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName && intlName.length > 3) {
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			addToGuesses(normalized, split[2].split(' '));
		}
	}

	function getZone (name, caller) {

		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function getCountryNames () {
		return Object.keys(countries);
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function addCountries (data) {
		var i, country_code, country_zones, split;
		if (!data || !data.length) return;
		for (i = 0; i < data.length; i++) {
			split = data[i].split('|');
			country_code = split[0].toUpperCase();
			country_zones = split[1].split(' ');
			countries[country_code] = new Country(
				country_code,
				country_zones
			);
		}
	}

	function getCountry (name) {
		name = name.toUpperCase();
		return countries[name] || null;
	}

	function zonesForCountry(country, with_offset) {
		country = getCountry(country);

		if (!country) return null;

		var zones = country.zones.sort();

		if (with_offset) {
			return zones.map(function (zone_name) {
				var zone = getZone(zone_name);
				return {
					name: zone_name,
					offset: zone.utcOffset(new Date())
				};
			});
		}

		return zones;
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		addCountries(data.countries);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
		return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			zone = getZone(name),
			out  = moment.utc.apply(null, args);

		if (zone && !moment.isMoment(input) && needsOffset(out)) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz._countries	= countries;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;
	tz.countries    = getCountryNames;
	tz.zonesForCountry = zonesForCountry;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.utcOffset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				var z = mom._z;
				mom.utcOffset(-offset, keepTime);
				mom._z = z;
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name, keepTime) {
		if (name) {
			if (typeof name !== 'string') {
				throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
			}
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this, keepTime);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	function resetZoneWrap2 (old) {
		return function () {
			if (arguments.length > 0) this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName  = abbrWrap(fn.zoneName);
	fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
	fn.utc       = resetZoneWrap(fn.utc);
	fn.local     = resetZoneWrap(fn.local);
	fn.utcOffset = resetZoneWrap2(fn.utcOffset);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	loadData({
		"version": "2020a",
		"zones": [
			"Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5",
			"Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5",
			"Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5",
			"Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5",
			"Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6",
			"Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4",
			"Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5",
			"Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6",
			"Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|32e5",
			"Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3",
			"Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|20e4",
			"Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5",
			"Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0|",
			"Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5",
			"Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5",
			"Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5",
			"Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00|",
			"Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5",
			"Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5",
			"Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4",
			"America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326",
			"America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4",
			"America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3",
			"America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4",
			"America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
			"America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
			"America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
			"America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|",
			"America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
			"America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|",
			"America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
			"America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|",
			"America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|",
			"America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|",
			"America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|",
			"America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|",
			"America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4",
			"America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5",
			"America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2",
			"America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3",
			"America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5",
			"America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4",
			"America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5",
			"America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3",
			"America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2",
			"America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2",
			"America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5",
			"America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4",
			"America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2",
			"America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4",
			"America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4",
			"America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5",
			"America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3",
			"America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5",
			"America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
			"America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4",
			"America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5",
			"America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2",
			"America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4",
			"America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8",
			"America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3",
			"America/Dawson|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|01010230405656565656565656565656565656565656565656565656565656565656565656565656565656565657|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|13e2",
			"America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
			"America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5",
			"America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5",
			"America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3",
			"America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5",
			"America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5",
			"America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2",
			"America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5",
			"America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
			"America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3",
			"America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2",
			"America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2",
			"America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5",
			"America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5",
			"America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4",
			"America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4",
			"America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5",
			"America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4",
			"America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010401054541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2",
			"America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2",
			"America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4",
			"America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3",
			"America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5",
			"America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6",
			"America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
			"America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4",
			"America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5",
			"America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5",
			"America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4",
			"America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4",
			"America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4",
			"America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2",
			"America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5",
			"America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
			"America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6",
			"America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2",
			"America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3",
			"America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5",
			"America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5",
			"America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5",
			"America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4",
			"America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
			"America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2",
			"America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2",
			"America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2",
			"America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
			"America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
			"America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4",
			"America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5",
			"America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
			"America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4",
			"America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4",
			"America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5",
			"America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|",
			"America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842",
			"America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2",
			"America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5",
			"America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4",
			"America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229",
			"America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4",
			"America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5",
			"America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5",
			"America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6",
			"America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452",
			"America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2",
			"America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
			"America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3",
			"America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5",
			"America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656",
			"America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
			"America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
			"America/Whitehorse|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|01010230405656565656565656565656565656565656565656565656565656565656565656565656565656565657|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|23e3",
			"America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4",
			"America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642",
			"America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
			"Antarctica/Casey|-00 +08 +11|0 -80 -b0|01212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10|10",
			"Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70",
			"Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80",
			"Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1",
			"Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60",
			"Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5",
			"Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40",
			"Antarctica/Rothera|-00 -03|0 30|01|gOo0|130",
			"Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20",
			"Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40",
			"Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25",
			"Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4",
			"Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5",
			"Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5",
			"Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5",
			"Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3",
			"Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4",
			"Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4",
			"Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4",
			"Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|",
			"Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5",
			"Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4",
			"Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
			"Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6",
			"Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|",
			"Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5",
			"Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4",
			"Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4",
			"Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6",
			"Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4",
			"Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3",
			"Asia/Shanghai|CST CDT|-80 -90|01010101010101010101010101010|-23uw0 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6",
			"Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5",
			"Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6",
			"Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5",
			"Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4",
			"Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5",
			"Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4",
			"Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
			"Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|0101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|18e5",
			"Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|25e4",
			"Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5",
			"Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5",
			"Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3",
			"Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
			"Europe/Istanbul|IMT EET EEST +03 +04|-1U.U -20 -30 -30 -40|0121212121212121212121212121212121212121212121234312121212121212121212121212121212121212121212121212121212121212123|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6",
			"Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6",
			"Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4",
			"Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|012121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4",
			"Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5",
			"Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4",
			"Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6",
			"Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5",
			"Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5",
			"Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2",
			"Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
			"Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5",
			"Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4",
			"Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4",
			"Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3",
			"Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5",
			"Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6",
			"Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4",
			"Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4",
			"Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5",
			"Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5",
			"Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4",
			"Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4",
			"Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5",
			"Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|",
			"Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4",
			"Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5",
			"Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4",
			"Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4",
			"Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6",
			"Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2",
			"Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5",
			"Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5",
			"Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5",
			"Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6",
			"Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3",
			"Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6",
			"Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5",
			"Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5",
			"Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2",
			"Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
			"Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4",
			"Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5",
			"Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5",
			"Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4",
			"Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3",
			"Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
			"Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4",
			"Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3",
			"Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4",
			"Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4",
			"Atlantic/South_Georgia|-02|20|0||30",
			"Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2",
			"Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5",
			"Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5",
			"Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5",
			"Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3",
			"Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746",
			"Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4",
			"Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368",
			"Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4",
			"Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347",
			"Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10",
			"Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5",
			"Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5",
			"CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
			"Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2",
			"CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
			"Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"EST|EST|50|0||",
			"EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"Etc/GMT-0|GMT|0|0||",
			"Etc/GMT-1|+01|-10|0||",
			"Pacific/Port_Moresby|+10|-a0|0||25e4",
			"Etc/GMT-11|+11|-b0|0||",
			"Pacific/Tarawa|+12|-c0|0||29e3",
			"Etc/GMT-13|+13|-d0|0||",
			"Etc/GMT-14|+14|-e0|0||",
			"Etc/GMT-2|+02|-20|0||",
			"Etc/GMT-3|+03|-30|0||",
			"Etc/GMT-4|+04|-40|0||",
			"Etc/GMT-5|+05|-50|0||",
			"Etc/GMT-6|+06|-60|0||",
			"Indian/Christmas|+07|-70|0||21e2",
			"Etc/GMT-8|+08|-80|0||",
			"Pacific/Palau|+09|-90|0||21e3",
			"Etc/GMT+1|-01|10|0||",
			"Etc/GMT+10|-10|a0|0||",
			"Etc/GMT+11|-11|b0|0||",
			"Etc/GMT+12|-12|c0|0||",
			"Etc/GMT+3|-03|30|0||",
			"Etc/GMT+4|-04|40|0||",
			"Etc/GMT+5|-05|50|0||",
			"Etc/GMT+6|-06|60|0||",
			"Etc/GMT+7|-07|70|0||",
			"Etc/GMT+8|-08|80|0||",
			"Etc/GMT+9|-09|90|0||",
			"Etc/UTC|UTC|0|0||",
			"Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5",
			"Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3",
			"Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5",
			"Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5",
			"Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6",
			"Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5",
			"Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5",
			"Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5",
			"Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5",
			"Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
			"Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4",
			"Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4",
			"Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3",
			"Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Kaliningrad|CET CEST EET EEST MSK MSD +03|-10 -20 -20 -30 -30 -40 -30|01010101010101232454545454545454543232323232323232323232323232323232323232323262|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4",
			"Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5",
			"Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4",
			"Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5",
			"Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
			"Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5",
			"Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
			"Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5",
			"Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3",
			"Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6",
			"Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6",
			"Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4",
			"Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5",
			"Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5",
			"Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|",
			"Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4",
			"Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5",
			"Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4",
			"Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
			"Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5",
			"Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4",
			"Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5",
			"Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
			"Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0|10e5",
			"Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
			"Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4",
			"HST|HST|a0|0||",
			"Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2",
			"Indian/Cocos|+0630|-6u|0||596",
			"Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130",
			"Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3",
			"Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4",
			"Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4",
			"Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4",
			"Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3",
			"MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
			"MST|MST|70|0||",
			"MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600",
			"Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3",
			"Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4",
			"Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3",
			"Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3",
			"Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B7X0|1",
			"Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483",
			"Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00|88e4",
			"Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3",
			"Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125",
			"Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4",
			"Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4",
			"Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4",
			"Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2",
			"Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2",
			"Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3",
			"Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2",
			"Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2",
			"Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3",
			"Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2",
			"Pacific/Norfolk|+1112 +1130 +1230 +11 +12|-bc -bu -cu -b0 -c0|012134343434343434343434343434343434343434|-Kgbc W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|25e4",
			"Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3",
			"Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56",
			"Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3",
			"Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3",
			"Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4",
			"Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3",
			"PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|"
		],
		"links": [
			"Africa/Abidjan|Africa/Bamako",
			"Africa/Abidjan|Africa/Banjul",
			"Africa/Abidjan|Africa/Conakry",
			"Africa/Abidjan|Africa/Dakar",
			"Africa/Abidjan|Africa/Freetown",
			"Africa/Abidjan|Africa/Lome",
			"Africa/Abidjan|Africa/Nouakchott",
			"Africa/Abidjan|Africa/Ouagadougou",
			"Africa/Abidjan|Africa/Timbuktu",
			"Africa/Abidjan|Atlantic/St_Helena",
			"Africa/Cairo|Egypt",
			"Africa/Johannesburg|Africa/Maseru",
			"Africa/Johannesburg|Africa/Mbabane",
			"Africa/Lagos|Africa/Bangui",
			"Africa/Lagos|Africa/Brazzaville",
			"Africa/Lagos|Africa/Douala",
			"Africa/Lagos|Africa/Kinshasa",
			"Africa/Lagos|Africa/Libreville",
			"Africa/Lagos|Africa/Luanda",
			"Africa/Lagos|Africa/Malabo",
			"Africa/Lagos|Africa/Niamey",
			"Africa/Lagos|Africa/Porto-Novo",
			"Africa/Maputo|Africa/Blantyre",
			"Africa/Maputo|Africa/Bujumbura",
			"Africa/Maputo|Africa/Gaborone",
			"Africa/Maputo|Africa/Harare",
			"Africa/Maputo|Africa/Kigali",
			"Africa/Maputo|Africa/Lubumbashi",
			"Africa/Maputo|Africa/Lusaka",
			"Africa/Nairobi|Africa/Addis_Ababa",
			"Africa/Nairobi|Africa/Asmara",
			"Africa/Nairobi|Africa/Asmera",
			"Africa/Nairobi|Africa/Dar_es_Salaam",
			"Africa/Nairobi|Africa/Djibouti",
			"Africa/Nairobi|Africa/Kampala",
			"Africa/Nairobi|Africa/Mogadishu",
			"Africa/Nairobi|Indian/Antananarivo",
			"Africa/Nairobi|Indian/Comoro",
			"Africa/Nairobi|Indian/Mayotte",
			"Africa/Tripoli|Libya",
			"America/Adak|America/Atka",
			"America/Adak|US/Aleutian",
			"America/Anchorage|US/Alaska",
			"America/Argentina/Buenos_Aires|America/Buenos_Aires",
			"America/Argentina/Catamarca|America/Argentina/ComodRivadavia",
			"America/Argentina/Catamarca|America/Catamarca",
			"America/Argentina/Cordoba|America/Cordoba",
			"America/Argentina/Cordoba|America/Rosario",
			"America/Argentina/Jujuy|America/Jujuy",
			"America/Argentina/Mendoza|America/Mendoza",
			"America/Atikokan|America/Coral_Harbour",
			"America/Chicago|US/Central",
			"America/Curacao|America/Aruba",
			"America/Curacao|America/Kralendijk",
			"America/Curacao|America/Lower_Princes",
			"America/Denver|America/Shiprock",
			"America/Denver|Navajo",
			"America/Denver|US/Mountain",
			"America/Detroit|US/Michigan",
			"America/Edmonton|Canada/Mountain",
			"America/Fort_Wayne|America/Indiana/Indianapolis",
			"America/Fort_Wayne|America/Indianapolis",
			"America/Fort_Wayne|US/East-Indiana",
			"America/Godthab|America/Nuuk",
			"America/Halifax|Canada/Atlantic",
			"America/Havana|Cuba",
			"America/Indiana/Knox|America/Knox_IN",
			"America/Indiana/Knox|US/Indiana-Starke",
			"America/Jamaica|Jamaica",
			"America/Kentucky/Louisville|America/Louisville",
			"America/Los_Angeles|US/Pacific",
			"America/Los_Angeles|US/Pacific-New",
			"America/Manaus|Brazil/West",
			"America/Mazatlan|Mexico/BajaSur",
			"America/Mexico_City|Mexico/General",
			"America/New_York|US/Eastern",
			"America/Noronha|Brazil/DeNoronha",
			"America/Panama|America/Cayman",
			"America/Phoenix|US/Arizona",
			"America/Port_of_Spain|America/Anguilla",
			"America/Port_of_Spain|America/Antigua",
			"America/Port_of_Spain|America/Dominica",
			"America/Port_of_Spain|America/Grenada",
			"America/Port_of_Spain|America/Guadeloupe",
			"America/Port_of_Spain|America/Marigot",
			"America/Port_of_Spain|America/Montserrat",
			"America/Port_of_Spain|America/St_Barthelemy",
			"America/Port_of_Spain|America/St_Kitts",
			"America/Port_of_Spain|America/St_Lucia",
			"America/Port_of_Spain|America/St_Thomas",
			"America/Port_of_Spain|America/St_Vincent",
			"America/Port_of_Spain|America/Tortola",
			"America/Port_of_Spain|America/Virgin",
			"America/Regina|Canada/Saskatchewan",
			"America/Rio_Branco|America/Porto_Acre",
			"America/Rio_Branco|Brazil/Acre",
			"America/Santiago|Chile/Continental",
			"America/Sao_Paulo|Brazil/East",
			"America/St_Johns|Canada/Newfoundland",
			"America/Tijuana|America/Ensenada",
			"America/Tijuana|America/Santa_Isabel",
			"America/Tijuana|Mexico/BajaNorte",
			"America/Toronto|America/Montreal",
			"America/Toronto|Canada/Eastern",
			"America/Vancouver|Canada/Pacific",
			"America/Whitehorse|Canada/Yukon",
			"America/Winnipeg|Canada/Central",
			"Asia/Ashgabat|Asia/Ashkhabad",
			"Asia/Bangkok|Asia/Phnom_Penh",
			"Asia/Bangkok|Asia/Vientiane",
			"Asia/Dhaka|Asia/Dacca",
			"Asia/Dubai|Asia/Muscat",
			"Asia/Ho_Chi_Minh|Asia/Saigon",
			"Asia/Hong_Kong|Hongkong",
			"Asia/Jerusalem|Asia/Tel_Aviv",
			"Asia/Jerusalem|Israel",
			"Asia/Kathmandu|Asia/Katmandu",
			"Asia/Kolkata|Asia/Calcutta",
			"Asia/Kuala_Lumpur|Asia/Singapore",
			"Asia/Kuala_Lumpur|Singapore",
			"Asia/Macau|Asia/Macao",
			"Asia/Makassar|Asia/Ujung_Pandang",
			"Asia/Nicosia|Europe/Nicosia",
			"Asia/Qatar|Asia/Bahrain",
			"Asia/Rangoon|Asia/Yangon",
			"Asia/Riyadh|Asia/Aden",
			"Asia/Riyadh|Asia/Kuwait",
			"Asia/Seoul|ROK",
			"Asia/Shanghai|Asia/Chongqing",
			"Asia/Shanghai|Asia/Chungking",
			"Asia/Shanghai|Asia/Harbin",
			"Asia/Shanghai|PRC",
			"Asia/Taipei|ROC",
			"Asia/Tehran|Iran",
			"Asia/Thimphu|Asia/Thimbu",
			"Asia/Tokyo|Japan",
			"Asia/Ulaanbaatar|Asia/Ulan_Bator",
			"Asia/Urumqi|Asia/Kashgar",
			"Atlantic/Faroe|Atlantic/Faeroe",
			"Atlantic/Reykjavik|Iceland",
			"Atlantic/South_Georgia|Etc/GMT+2",
			"Australia/Adelaide|Australia/South",
			"Australia/Brisbane|Australia/Queensland",
			"Australia/Broken_Hill|Australia/Yancowinna",
			"Australia/Darwin|Australia/North",
			"Australia/Hobart|Australia/Tasmania",
			"Australia/Lord_Howe|Australia/LHI",
			"Australia/Melbourne|Australia/Victoria",
			"Australia/Perth|Australia/West",
			"Australia/Sydney|Australia/ACT",
			"Australia/Sydney|Australia/Canberra",
			"Australia/Sydney|Australia/NSW",
			"Etc/GMT-0|Etc/GMT",
			"Etc/GMT-0|Etc/GMT+0",
			"Etc/GMT-0|Etc/GMT0",
			"Etc/GMT-0|Etc/Greenwich",
			"Etc/GMT-0|GMT",
			"Etc/GMT-0|GMT+0",
			"Etc/GMT-0|GMT-0",
			"Etc/GMT-0|GMT0",
			"Etc/GMT-0|Greenwich",
			"Etc/UTC|Etc/UCT",
			"Etc/UTC|Etc/Universal",
			"Etc/UTC|Etc/Zulu",
			"Etc/UTC|UCT",
			"Etc/UTC|UTC",
			"Etc/UTC|Universal",
			"Etc/UTC|Zulu",
			"Europe/Belgrade|Europe/Ljubljana",
			"Europe/Belgrade|Europe/Podgorica",
			"Europe/Belgrade|Europe/Sarajevo",
			"Europe/Belgrade|Europe/Skopje",
			"Europe/Belgrade|Europe/Zagreb",
			"Europe/Chisinau|Europe/Tiraspol",
			"Europe/Dublin|Eire",
			"Europe/Helsinki|Europe/Mariehamn",
			"Europe/Istanbul|Asia/Istanbul",
			"Europe/Istanbul|Turkey",
			"Europe/Lisbon|Portugal",
			"Europe/London|Europe/Belfast",
			"Europe/London|Europe/Guernsey",
			"Europe/London|Europe/Isle_of_Man",
			"Europe/London|Europe/Jersey",
			"Europe/London|GB",
			"Europe/London|GB-Eire",
			"Europe/Moscow|W-SU",
			"Europe/Oslo|Arctic/Longyearbyen",
			"Europe/Oslo|Atlantic/Jan_Mayen",
			"Europe/Prague|Europe/Bratislava",
			"Europe/Rome|Europe/San_Marino",
			"Europe/Rome|Europe/Vatican",
			"Europe/Warsaw|Poland",
			"Europe/Zurich|Europe/Busingen",
			"Europe/Zurich|Europe/Vaduz",
			"Indian/Christmas|Etc/GMT-7",
			"Pacific/Auckland|Antarctica/McMurdo",
			"Pacific/Auckland|Antarctica/South_Pole",
			"Pacific/Auckland|NZ",
			"Pacific/Chatham|NZ-CHAT",
			"Pacific/Chuuk|Pacific/Truk",
			"Pacific/Chuuk|Pacific/Yap",
			"Pacific/Easter|Chile/EasterIsland",
			"Pacific/Guam|Pacific/Saipan",
			"Pacific/Honolulu|Pacific/Johnston",
			"Pacific/Honolulu|US/Hawaii",
			"Pacific/Kwajalein|Kwajalein",
			"Pacific/Pago_Pago|Pacific/Midway",
			"Pacific/Pago_Pago|Pacific/Samoa",
			"Pacific/Pago_Pago|US/Samoa",
			"Pacific/Palau|Etc/GMT-9",
			"Pacific/Pohnpei|Pacific/Ponape",
			"Pacific/Port_Moresby|Etc/GMT-10",
			"Pacific/Tarawa|Etc/GMT-12",
			"Pacific/Tarawa|Pacific/Funafuti",
			"Pacific/Tarawa|Pacific/Wake",
			"Pacific/Tarawa|Pacific/Wallis"
		],
		"countries": [
			"AD|Europe/Andorra",
			"AE|Asia/Dubai",
			"AF|Asia/Kabul",
			"AG|America/Port_of_Spain America/Antigua",
			"AI|America/Port_of_Spain America/Anguilla",
			"AL|Europe/Tirane",
			"AM|Asia/Yerevan",
			"AO|Africa/Lagos Africa/Luanda",
			"AQ|Antarctica/Casey Antarctica/Davis Antarctica/DumontDUrville Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Syowa Antarctica/Troll Antarctica/Vostok Pacific/Auckland Antarctica/McMurdo",
			"AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia",
			"AS|Pacific/Pago_Pago",
			"AT|Europe/Vienna",
			"AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Currie Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla",
			"AW|America/Curacao America/Aruba",
			"AX|Europe/Helsinki Europe/Mariehamn",
			"AZ|Asia/Baku",
			"BA|Europe/Belgrade Europe/Sarajevo",
			"BB|America/Barbados",
			"BD|Asia/Dhaka",
			"BE|Europe/Brussels",
			"BF|Africa/Abidjan Africa/Ouagadougou",
			"BG|Europe/Sofia",
			"BH|Asia/Qatar Asia/Bahrain",
			"BI|Africa/Maputo Africa/Bujumbura",
			"BJ|Africa/Lagos Africa/Porto-Novo",
			"BL|America/Port_of_Spain America/St_Barthelemy",
			"BM|Atlantic/Bermuda",
			"BN|Asia/Brunei",
			"BO|America/La_Paz",
			"BQ|America/Curacao America/Kralendijk",
			"BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco",
			"BS|America/Nassau",
			"BT|Asia/Thimphu",
			"BW|Africa/Maputo Africa/Gaborone",
			"BY|Europe/Minsk",
			"BZ|America/Belize",
			"CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Blanc-Sablon America/Toronto America/Nipigon America/Thunder_Bay America/Iqaluit America/Pangnirtung America/Atikokan America/Winnipeg America/Rainy_River America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Yellowknife America/Inuvik America/Creston America/Dawson_Creek America/Fort_Nelson America/Vancouver America/Whitehorse America/Dawson",
			"CC|Indian/Cocos",
			"CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi",
			"CF|Africa/Lagos Africa/Bangui",
			"CG|Africa/Lagos Africa/Brazzaville",
			"CH|Europe/Zurich",
			"CI|Africa/Abidjan",
			"CK|Pacific/Rarotonga",
			"CL|America/Santiago America/Punta_Arenas Pacific/Easter",
			"CM|Africa/Lagos Africa/Douala",
			"CN|Asia/Shanghai Asia/Urumqi",
			"CO|America/Bogota",
			"CR|America/Costa_Rica",
			"CU|America/Havana",
			"CV|Atlantic/Cape_Verde",
			"CW|America/Curacao",
			"CX|Indian/Christmas",
			"CY|Asia/Nicosia Asia/Famagusta",
			"CZ|Europe/Prague",
			"DE|Europe/Zurich Europe/Berlin Europe/Busingen",
			"DJ|Africa/Nairobi Africa/Djibouti",
			"DK|Europe/Copenhagen",
			"DM|America/Port_of_Spain America/Dominica",
			"DO|America/Santo_Domingo",
			"DZ|Africa/Algiers",
			"EC|America/Guayaquil Pacific/Galapagos",
			"EE|Europe/Tallinn",
			"EG|Africa/Cairo",
			"EH|Africa/El_Aaiun",
			"ER|Africa/Nairobi Africa/Asmara",
			"ES|Europe/Madrid Africa/Ceuta Atlantic/Canary",
			"ET|Africa/Nairobi Africa/Addis_Ababa",
			"FI|Europe/Helsinki",
			"FJ|Pacific/Fiji",
			"FK|Atlantic/Stanley",
			"FM|Pacific/Chuuk Pacific/Pohnpei Pacific/Kosrae",
			"FO|Atlantic/Faroe",
			"FR|Europe/Paris",
			"GA|Africa/Lagos Africa/Libreville",
			"GB|Europe/London",
			"GD|America/Port_of_Spain America/Grenada",
			"GE|Asia/Tbilisi",
			"GF|America/Cayenne",
			"GG|Europe/London Europe/Guernsey",
			"GH|Africa/Accra",
			"GI|Europe/Gibraltar",
			"GL|America/Godthab America/Danmarkshavn America/Scoresbysund America/Thule",
			"GM|Africa/Abidjan Africa/Banjul",
			"GN|Africa/Abidjan Africa/Conakry",
			"GP|America/Port_of_Spain America/Guadeloupe",
			"GQ|Africa/Lagos Africa/Malabo",
			"GR|Europe/Athens",
			"GS|Atlantic/South_Georgia",
			"GT|America/Guatemala",
			"GU|Pacific/Guam",
			"GW|Africa/Bissau",
			"GY|America/Guyana",
			"HK|Asia/Hong_Kong",
			"HN|America/Tegucigalpa",
			"HR|Europe/Belgrade Europe/Zagreb",
			"HT|America/Port-au-Prince",
			"HU|Europe/Budapest",
			"ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura",
			"IE|Europe/Dublin",
			"IL|Asia/Jerusalem",
			"IM|Europe/London Europe/Isle_of_Man",
			"IN|Asia/Kolkata",
			"IO|Indian/Chagos",
			"IQ|Asia/Baghdad",
			"IR|Asia/Tehran",
			"IS|Atlantic/Reykjavik",
			"IT|Europe/Rome",
			"JE|Europe/London Europe/Jersey",
			"JM|America/Jamaica",
			"JO|Asia/Amman",
			"JP|Asia/Tokyo",
			"KE|Africa/Nairobi",
			"KG|Asia/Bishkek",
			"KH|Asia/Bangkok Asia/Phnom_Penh",
			"KI|Pacific/Tarawa Pacific/Enderbury Pacific/Kiritimati",
			"KM|Africa/Nairobi Indian/Comoro",
			"KN|America/Port_of_Spain America/St_Kitts",
			"KP|Asia/Pyongyang",
			"KR|Asia/Seoul",
			"KW|Asia/Riyadh Asia/Kuwait",
			"KY|America/Panama America/Cayman",
			"KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral",
			"LA|Asia/Bangkok Asia/Vientiane",
			"LB|Asia/Beirut",
			"LC|America/Port_of_Spain America/St_Lucia",
			"LI|Europe/Zurich Europe/Vaduz",
			"LK|Asia/Colombo",
			"LR|Africa/Monrovia",
			"LS|Africa/Johannesburg Africa/Maseru",
			"LT|Europe/Vilnius",
			"LU|Europe/Luxembourg",
			"LV|Europe/Riga",
			"LY|Africa/Tripoli",
			"MA|Africa/Casablanca",
			"MC|Europe/Monaco",
			"MD|Europe/Chisinau",
			"ME|Europe/Belgrade Europe/Podgorica",
			"MF|America/Port_of_Spain America/Marigot",
			"MG|Africa/Nairobi Indian/Antananarivo",
			"MH|Pacific/Majuro Pacific/Kwajalein",
			"MK|Europe/Belgrade Europe/Skopje",
			"ML|Africa/Abidjan Africa/Bamako",
			"MM|Asia/Yangon",
			"MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan",
			"MO|Asia/Macau",
			"MP|Pacific/Guam Pacific/Saipan",
			"MQ|America/Martinique",
			"MR|Africa/Abidjan Africa/Nouakchott",
			"MS|America/Port_of_Spain America/Montserrat",
			"MT|Europe/Malta",
			"MU|Indian/Mauritius",
			"MV|Indian/Maldives",
			"MW|Africa/Maputo Africa/Blantyre",
			"MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Mazatlan America/Chihuahua America/Ojinaga America/Hermosillo America/Tijuana America/Bahia_Banderas",
			"MY|Asia/Kuala_Lumpur Asia/Kuching",
			"MZ|Africa/Maputo",
			"NA|Africa/Windhoek",
			"NC|Pacific/Noumea",
			"NE|Africa/Lagos Africa/Niamey",
			"NF|Pacific/Norfolk",
			"NG|Africa/Lagos",
			"NI|America/Managua",
			"NL|Europe/Amsterdam",
			"NO|Europe/Oslo",
			"NP|Asia/Kathmandu",
			"NR|Pacific/Nauru",
			"NU|Pacific/Niue",
			"NZ|Pacific/Auckland Pacific/Chatham",
			"OM|Asia/Dubai Asia/Muscat",
			"PA|America/Panama",
			"PE|America/Lima",
			"PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier",
			"PG|Pacific/Port_Moresby Pacific/Bougainville",
			"PH|Asia/Manila",
			"PK|Asia/Karachi",
			"PL|Europe/Warsaw",
			"PM|America/Miquelon",
			"PN|Pacific/Pitcairn",
			"PR|America/Puerto_Rico",
			"PS|Asia/Gaza Asia/Hebron",
			"PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores",
			"PW|Pacific/Palau",
			"PY|America/Asuncion",
			"QA|Asia/Qatar",
			"RE|Indian/Reunion",
			"RO|Europe/Bucharest",
			"RS|Europe/Belgrade",
			"RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Astrakhan Europe/Volgograd Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr",
			"RW|Africa/Maputo Africa/Kigali",
			"SA|Asia/Riyadh",
			"SB|Pacific/Guadalcanal",
			"SC|Indian/Mahe",
			"SD|Africa/Khartoum",
			"SE|Europe/Stockholm",
			"SG|Asia/Singapore",
			"SH|Africa/Abidjan Atlantic/St_Helena",
			"SI|Europe/Belgrade Europe/Ljubljana",
			"SJ|Europe/Oslo Arctic/Longyearbyen",
			"SK|Europe/Prague Europe/Bratislava",
			"SL|Africa/Abidjan Africa/Freetown",
			"SM|Europe/Rome Europe/San_Marino",
			"SN|Africa/Abidjan Africa/Dakar",
			"SO|Africa/Nairobi Africa/Mogadishu",
			"SR|America/Paramaribo",
			"SS|Africa/Juba",
			"ST|Africa/Sao_Tome",
			"SV|America/El_Salvador",
			"SX|America/Curacao America/Lower_Princes",
			"SY|Asia/Damascus",
			"SZ|Africa/Johannesburg Africa/Mbabane",
			"TC|America/Grand_Turk",
			"TD|Africa/Ndjamena",
			"TF|Indian/Reunion Indian/Kerguelen",
			"TG|Africa/Abidjan Africa/Lome",
			"TH|Asia/Bangkok",
			"TJ|Asia/Dushanbe",
			"TK|Pacific/Fakaofo",
			"TL|Asia/Dili",
			"TM|Asia/Ashgabat",
			"TN|Africa/Tunis",
			"TO|Pacific/Tongatapu",
			"TR|Europe/Istanbul",
			"TT|America/Port_of_Spain",
			"TV|Pacific/Funafuti",
			"TW|Asia/Taipei",
			"TZ|Africa/Nairobi Africa/Dar_es_Salaam",
			"UA|Europe/Simferopol Europe/Kiev Europe/Uzhgorod Europe/Zaporozhye",
			"UG|Africa/Nairobi Africa/Kampala",
			"UM|Pacific/Pago_Pago Pacific/Wake Pacific/Honolulu Pacific/Midway",
			"US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu",
			"UY|America/Montevideo",
			"UZ|Asia/Samarkand Asia/Tashkent",
			"VA|Europe/Rome Europe/Vatican",
			"VC|America/Port_of_Spain America/St_Vincent",
			"VE|America/Caracas",
			"VG|America/Port_of_Spain America/Tortola",
			"VI|America/Port_of_Spain America/St_Thomas",
			"VN|Asia/Bangkok Asia/Ho_Chi_Minh",
			"VU|Pacific/Efate",
			"WF|Pacific/Wallis",
			"WS|Pacific/Apia",
			"YE|Asia/Riyadh Asia/Aden",
			"YT|Africa/Nairobi Indian/Mayotte",
			"ZA|Africa/Johannesburg",
			"ZM|Africa/Maputo Africa/Lusaka",
			"ZW|Africa/Maputo Africa/Harare"
		]
	});


	return moment;
}));

},
'jsonpath/jsonpath':function(){
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global.JSONPath = {}));
}(this, (function (exports) { 'use strict';

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _construct(Parent, args, Class) {
    if (isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }

    return _construct.apply(null, arguments);
  }

  function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  }

  function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;

    _wrapNativeSuper = function _wrapNativeSuper(Class) {
      if (Class === null || !_isNativeFunction(Class)) return Class;

      if (typeof Class !== "function") {
        throw new TypeError("Super expression must either be null or a function");
      }

      if (typeof _cache !== "undefined") {
        if (_cache.has(Class)) return _cache.get(Class);

        _cache.set(Class, Wrapper);
      }

      function Wrapper() {
        return _construct(Class, arguments, _getPrototypeOf(this).constructor);
      }

      Wrapper.prototype = Object.create(Class.prototype, {
        constructor: {
          value: Wrapper,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      return _setPrototypeOf(Wrapper, Class);
    };

    return _wrapNativeSuper(Class);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

      return arr2;
    }
  }

  function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  /* eslint-disable prefer-named-capture-group */
  // Disabled `prefer-named-capture-group` due to https://github.com/babel/babel/issues/8951#issuecomment-508045524
  // Only Node.JS has a process variable that is of [[Class]] process
  var supportsNodeVM = function supportsNodeVM() {
    try {
      return Object.prototype.toString.call(global.process) === '[object process]';
    } catch (e) {
      return false;
    }
  };

  var hasOwnProp = Object.prototype.hasOwnProperty;
  /**
  * @typedef {null|boolean|number|string|PlainObject|GenericArray} JSONObject
  */

  /**
  * @callback ConditionCallback
  * @param {any} item
  * @returns {boolean}
  */

  /**
   * Copy items out of one array into another.
   * @param {GenericArray} source Array with items to copy
   * @param {GenericArray} target Array to which to copy
   * @param {ConditionCallback} conditionCb Callback passed the current item;
   *     will move item if evaluates to `true`
   * @returns {void}
   */

  var moveToAnotherArray = function moveToAnotherArray(source, target, conditionCb) {
    var il = source.length;

    for (var i = 0; i < il; i++) {
      var item = source[i];

      if (conditionCb(item)) {
        target.push(source.splice(i--, 1)[0]);
      }
    }
  };

  JSONPath.nodeVMSupported = supportsNodeVM();
  var vm = JSONPath.nodeVMSupported ? require('vm') : {
    /**
     * @param {string} expr Expression to evaluate
     * @param {PlainObject} context Object whose items will be added
     *   to evaluation
     * @returns {any} Result of evaluated code
     */
    runInNewContext: function runInNewContext(expr, context) {
      var keys = Object.keys(context);
      var funcs = [];
      moveToAnotherArray(keys, funcs, function (key) {
        return typeof context[key] === 'function';
      });
      var values = keys.map(function (vr, i) {
        return context[vr];
      });
      var funcString = funcs.reduce(function (s, func) {
        var fString = context[func].toString();

        if (!/function/.exec(fString)) {
          fString = 'function ' + fString;
        }

        return 'var ' + func + '=' + fString + ';' + s;
      }, '');
      expr = funcString + expr; // Mitigate http://perfectionkills.com/global-eval-what-are-the-options/#new_function

      if (!expr.match(/(["'])use strict\1/) && !keys.includes('arguments')) {
        expr = 'var arguments = undefined;' + expr;
      } // Remove last semi so `return` will be inserted before
      //  the previous one instead, allowing for the return
      //  of a bare ending expression


      expr = expr.replace(/;[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/, ''); // Insert `return`

      var lastStatementEnd = expr.lastIndexOf(';');
      var code = lastStatementEnd > -1 ? expr.slice(0, lastStatementEnd + 1) + ' return ' + expr.slice(lastStatementEnd + 1) : ' return ' + expr; // eslint-disable-next-line no-new-func

      return _construct(Function, _toConsumableArray(keys).concat([code])).apply(void 0, _toConsumableArray(values));
    }
  };
  /**
   * Copies array and then pushes item into it.
   * @param {GenericArray} arr Array to copy and into which to push
   * @param {any} item Array item to add (to end)
   * @returns {GenericArray} Copy of the original array
   */

  function push(arr, item) {
    arr = arr.slice();
    arr.push(item);
    return arr;
  }
  /**
   * Copies array and then unshifts item into it.
   * @param {any} item Array item to add (to beginning)
   * @param {GenericArray} arr Array to copy and into which to unshift
   * @returns {GenericArray} Copy of the original array
   */


  function unshift(item, arr) {
    arr = arr.slice();
    arr.unshift(item);
    return arr;
  }
  /**
   * Caught when JSONPath is used without `new` but rethrown if with `new`
   * @extends Error
   */


  var NewError =
  /*#__PURE__*/
  function (_Error) {
    _inherits(NewError, _Error);

    /**
     * @param {any} value The evaluated scalar value
     */
    function NewError(value) {
      var _this;

      _classCallCheck(this, NewError);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(NewError).call(this, 'JSONPath should not be called with "new" (it prevents return ' + 'of (unwrapped) scalar values)'));
      _this.avoidNew = true;
      _this.value = value;
      _this.name = 'NewError';
      return _this;
    }

    return NewError;
  }(_wrapNativeSuper(Error));
  /**
  * @typedef {PlainObject} ReturnObject
  * @property {string} path
  * @property {JSONObject} value
  * @property {PlainObject|GenericArray} parent
  * @property {string} parentProperty
  */

  /**
  * @callback JSONPathCallback
  * @param {string|PlainObject} preferredOutput
  * @param {"value"|"property"} type
  * @param {ReturnObject} fullRetObj
  * @returns {void}
  */

  /**
  * @callback OtherTypeCallback
  * @param {JSONObject} val
  * @param {string} path
  * @param {PlainObject|GenericArray} parent
  * @param {string} parentPropName
  * @returns {boolean}
  */

  /**
   * @typedef {PlainObject} JSONPathOptions
   * @property {JSON} json
   * @property {string|string[]} path
   * @property {"value"|"path"|"pointer"|"parent"|"parentProperty"|"all"}
   *   [resultType="value"]
   * @property {boolean} [flatten=false]
   * @property {boolean} [wrap=true]
   * @property {PlainObject} [sandbox={}]
   * @property {boolean} [preventEval=false]
   * @property {PlainObject|GenericArray|null} [parent=null]
   * @property {string|null} [parentProperty=null]
   * @property {JSONPathCallback} [callback]
   * @property {OtherTypeCallback} [otherTypeCallback] Defaults to
   *   function which throws on encountering `@other`
   * @property {boolean} [autostart=true]
   */

  /**
   * @param {string|JSONPathOptions} opts If a string, will be treated as `expr`
   * @param {string} [expr] JSON path to evaluate
   * @param {JSON} [obj] JSON object to evaluate against
   * @param {JSONPathCallback} [callback] Passed 3 arguments: 1) desired payload
   *     per `resultType`, 2) `"value"|"property"`, 3) Full returned object with
   *     all payloads
   * @param {OtherTypeCallback} [otherTypeCallback] If `@other()` is at the end
   *   of one's query, this will be invoked with the value of the item, its
   *   path, its parent, and its parent's property name, and it should return
   *   a boolean indicating whether the supplied value belongs to the "other"
   *   type or not (or it may handle transformations and return `false`).
   * @returns {JSONPath}
   * @class
   */


  function JSONPath(opts, expr, obj, callback, otherTypeCallback) {
    // eslint-disable-next-line no-restricted-syntax
    if (!(this instanceof JSONPath)) {
      try {
        return new JSONPath(opts, expr, obj, callback, otherTypeCallback);
      } catch (e) {
        if (!e.avoidNew) {
          throw e;
        }

        return e.value;
      }
    }

    if (typeof opts === 'string') {
      otherTypeCallback = callback;
      callback = obj;
      obj = expr;
      expr = opts;
      opts = null;
    }

    var optObj = opts && _typeof(opts) === 'object';
    opts = opts || {};
    this.json = opts.json || obj;
    this.path = opts.path || expr;
    this.resultType = opts.resultType && opts.resultType.toLowerCase() || 'value';
    this.flatten = opts.flatten || false;
    this.wrap = hasOwnProp.call(opts, 'wrap') ? opts.wrap : true;
    this.sandbox = opts.sandbox || {};
    this.preventEval = opts.preventEval || false;
    this.parent = opts.parent || null;
    this.parentProperty = opts.parentProperty || null;
    this.callback = opts.callback || callback || null;

    this.otherTypeCallback = opts.otherTypeCallback || otherTypeCallback || function () {
      throw new TypeError('You must supply an otherTypeCallback callback option ' + 'with the @other() operator.');
    };

    if (opts.autostart !== false) {
      var args = {
        path: optObj ? opts.path : expr
      };

      if (!optObj) {
        args.json = obj;
      } else if ('json' in opts) {
        args.json = opts.json;
      }

      var ret = this.evaluate(args);

      if (!ret || _typeof(ret) !== 'object') {
        throw new NewError(ret);
      }

      return ret;
    }
  } // PUBLIC METHODS


  JSONPath.prototype.evaluate = function (expr, json, callback, otherTypeCallback) {
    var that = this;
    var currParent = this.parent,
        currParentProperty = this.parentProperty;
    var flatten = this.flatten,
        wrap = this.wrap;
    this.currResultType = this.resultType;
    this.currPreventEval = this.preventEval;
    this.currSandbox = this.sandbox;
    callback = callback || this.callback;
    this.currOtherTypeCallback = otherTypeCallback || this.otherTypeCallback;
    json = json || this.json;
    expr = expr || this.path;

    if (expr && _typeof(expr) === 'object' && !Array.isArray(expr)) {
      if (!expr.path) {
        throw new TypeError('You must supply a "path" property when providing an object ' + 'argument to JSONPath.evaluate().');
      }

      if (!('json' in expr)) {
        throw new TypeError('You must supply a "json" property when providing an object ' + 'argument to JSONPath.evaluate().');
      }

      json = hasOwnProp.call(expr, 'json') ? expr.json : json;
      flatten = hasOwnProp.call(expr, 'flatten') ? expr.flatten : flatten;
      this.currResultType = hasOwnProp.call(expr, 'resultType') ? expr.resultType : this.currResultType;
      this.currSandbox = hasOwnProp.call(expr, 'sandbox') ? expr.sandbox : this.currSandbox;
      wrap = hasOwnProp.call(expr, 'wrap') ? expr.wrap : wrap;
      this.currPreventEval = hasOwnProp.call(expr, 'preventEval') ? expr.preventEval : this.currPreventEval;
      callback = hasOwnProp.call(expr, 'callback') ? expr.callback : callback;
      this.currOtherTypeCallback = hasOwnProp.call(expr, 'otherTypeCallback') ? expr.otherTypeCallback : this.currOtherTypeCallback;
      currParent = hasOwnProp.call(expr, 'parent') ? expr.parent : currParent;
      currParentProperty = hasOwnProp.call(expr, 'parentProperty') ? expr.parentProperty : currParentProperty;
      expr = expr.path;
    }

    currParent = currParent || null;
    currParentProperty = currParentProperty || null;

    if (Array.isArray(expr)) {
      expr = JSONPath.toPathString(expr);
    }

    if (!expr || !json) {
      return undefined;
    }

    this._obj = json;
    var exprList = JSONPath.toPathArray(expr);

    if (exprList[0] === '$' && exprList.length > 1) {
      exprList.shift();
    }

    this._hasParentSelector = null;

    var result = this._trace(exprList, json, ['$'], currParent, currParentProperty, callback).filter(function (ea) {
      return ea && !ea.isParentSelector;
    });

    if (!result.length) {
      return wrap ? [] : undefined;
    }

    if (!wrap && result.length === 1 && !result[0].hasArrExpr) {
      return this._getPreferredOutput(result[0]);
    }

    return result.reduce(function (rslt, ea) {
      var valOrPath = that._getPreferredOutput(ea);

      if (flatten && Array.isArray(valOrPath)) {
        rslt = rslt.concat(valOrPath);
      } else {
        rslt.push(valOrPath);
      }

      return rslt;
    }, []);
  }; // PRIVATE METHODS


  JSONPath.prototype._getPreferredOutput = function (ea) {
    var resultType = this.currResultType;

    switch (resultType) {
      default:
        throw new TypeError('Unknown result type');

      case 'all':
        ea.pointer = JSONPath.toPointer(ea.path);
        ea.path = typeof ea.path === 'string' ? ea.path : JSONPath.toPathString(ea.path);
        return ea;

      case 'value':
      case 'parent':
      case 'parentProperty':
        return ea[resultType];

      case 'path':
        return JSONPath.toPathString(ea[resultType]);

      case 'pointer':
        return JSONPath.toPointer(ea.path);
    }
  };

  JSONPath.prototype._handleCallback = function (fullRetObj, callback, type) {
    if (callback) {
      var preferredOutput = this._getPreferredOutput(fullRetObj);

      fullRetObj.path = typeof fullRetObj.path === 'string' ? fullRetObj.path : JSONPath.toPathString(fullRetObj.path); // eslint-disable-next-line callback-return

      callback(preferredOutput, type, fullRetObj);
    }
  };
  /**
   *
   * @param {string} expr
   * @param {JSONObject} val
   * @param {string} path
   * @param {PlainObject|GenericArray} parent
   * @param {string} parentPropName
   * @param {JSONPathCallback} callback
   * @param {boolean} hasArrExpr
   * @param {boolean} literalPriority
   * @returns {ReturnObject|ReturnObject[]}
   */


  JSONPath.prototype._trace = function (expr, val, path, parent, parentPropName, callback, hasArrExpr, literalPriority) {
    // No expr to follow? return path and value as the result of
    //  this trace branch
    var retObj;
    var that = this;

    if (!expr.length) {
      retObj = {
        path: path,
        value: val,
        parent: parent,
        parentProperty: parentPropName,
        hasArrExpr: hasArrExpr
      };

      this._handleCallback(retObj, callback, 'value');

      return retObj;
    }

    var loc = expr[0],
        x = expr.slice(1); // We need to gather the return value of recursive trace calls in order to
    // do the parent sel computation.

    var ret = [];
    /**
     *
     * @param {ReturnObject|ReturnObject[]} elems
     * @returns {void}
     */

    function addRet(elems) {
      if (Array.isArray(elems)) {
        // This was causing excessive stack size in Node (with or
        //  without Babel) against our performance test:
        //  `ret.push(...elems);`
        elems.forEach(function (t) {
          ret.push(t);
        });
      } else {
        ret.push(elems);
      }
    }

    if ((typeof loc !== 'string' || literalPriority) && val && hasOwnProp.call(val, loc)) {
      // simple case--directly follow property
      addRet(this._trace(x, val[loc], push(path, loc), val, loc, callback, hasArrExpr));
    } else if (loc === '*') {
      // all child properties
      this._walk(loc, x, val, path, parent, parentPropName, callback, function (m, l, _x, v, p, par, pr, cb) {
        addRet(that._trace(unshift(m, _x), v, p, par, pr, cb, true, true));
      });
    } else if (loc === '..') {
      // all descendent parent properties
      // Check remaining expression with val's immediate children
      addRet(this._trace(x, val, path, parent, parentPropName, callback, hasArrExpr));

      this._walk(loc, x, val, path, parent, parentPropName, callback, function (m, l, _x, v, p, par, pr, cb) {
        // We don't join m and x here because we only want parents,
        //   not scalar values
        if (_typeof(v[m]) === 'object') {
          // Keep going with recursive descent on val's
          //   object children
          addRet(that._trace(unshift(l, _x), v[m], push(p, m), v, m, cb, true));
        }
      }); // The parent sel computation is handled in the frame above using the
      // ancestor object of val

    } else if (loc === '^') {
      // This is not a final endpoint, so we do not invoke the callback here
      this._hasParentSelector = true;
      return path.length ? {
        path: path.slice(0, -1),
        expr: x,
        isParentSelector: true
      } : [];
    } else if (loc === '~') {
      // property name
      retObj = {
        path: push(path, loc),
        value: parentPropName,
        parent: parent,
        parentProperty: null
      };

      this._handleCallback(retObj, callback, 'property');

      return retObj;
    } else if (loc === '$') {
      // root only
      addRet(this._trace(x, val, path, null, null, callback, hasArrExpr));
    } else if (/^(\x2D?[0-9]*):(\x2D?[0-9]*):?([0-9]*)$/.test(loc)) {
      // [start:end:step]  Python slice syntax
      addRet(this._slice(loc, x, val, path, parent, parentPropName, callback));
    } else if (loc.indexOf('?(') === 0) {
      // [?(expr)] (filtering)
      if (this.currPreventEval) {
        throw new Error('Eval [?(expr)] prevented in JSONPath expression.');
      }

      this._walk(loc, x, val, path, parent, parentPropName, callback, function (m, l, _x, v, p, par, pr, cb) {
        if (that._eval(l.replace(/^\?\(((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?)\)$/, '$1'), v[m], m, p, par, pr)) {
          addRet(that._trace(unshift(m, _x), v, p, par, pr, cb, true));
        }
      });
    } else if (loc[0] === '(') {
      // [(expr)] (dynamic property/index)
      if (this.currPreventEval) {
        throw new Error('Eval [(expr)] prevented in JSONPath expression.');
      } // As this will resolve to a property name (but we don't know it
      //  yet), property and parent information is relative to the
      //  parent of the property to which this expression will resolve


      addRet(this._trace(unshift(this._eval(loc, val, path[path.length - 1], path.slice(0, -1), parent, parentPropName), x), val, path, parent, parentPropName, callback, hasArrExpr));
    } else if (loc[0] === '@') {
      // value type: @boolean(), etc.
      var addType = false;
      var valueType = loc.slice(1, -2);

      switch (valueType) {
        /* istanbul ignore next */
        default:
          throw new TypeError('Unknown value type ' + valueType);

        case 'scalar':
          if (!val || !['object', 'function'].includes(_typeof(val))) {
            addType = true;
          }

          break;

        case 'boolean':
        case 'string':
        case 'undefined':
        case 'function':
          // eslint-disable-next-line valid-typeof
          if (_typeof(val) === valueType) {
            addType = true;
          }

          break;

        case 'number':
          // eslint-disable-next-line valid-typeof
          if (_typeof(val) === valueType && isFinite(val)) {
            addType = true;
          }

          break;

        case 'nonFinite':
          if (typeof val === 'number' && !isFinite(val)) {
            addType = true;
          }

          break;

        case 'object':
          // eslint-disable-next-line valid-typeof
          if (val && _typeof(val) === valueType) {
            addType = true;
          }

          break;

        case 'array':
          if (Array.isArray(val)) {
            addType = true;
          }

          break;

        case 'other':
          addType = this.currOtherTypeCallback(val, path, parent, parentPropName);
          break;

        case 'integer':
          if (val === Number(val) && isFinite(val) && !(val % 1)) {
            addType = true;
          }

          break;

        case 'null':
          if (val === null) {
            addType = true;
          }

          break;
      }

      if (addType) {
        retObj = {
          path: path,
          value: val,
          parent: parent,
          parentProperty: parentPropName
        };

        this._handleCallback(retObj, callback, 'value');

        return retObj;
      } // `-escaped property

    } else if (loc[0] === '`' && val && hasOwnProp.call(val, loc.slice(1))) {
      var locProp = loc.slice(1);
      addRet(this._trace(x, val[locProp], push(path, locProp), val, locProp, callback, hasArrExpr, true));
    } else if (loc.includes(',')) {
      // [name1,name2,...]
      var parts = loc.split(',');
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = parts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var part = _step.value;
          addRet(this._trace(unshift(part, x), val, path, parent, parentPropName, callback, true));
        } // simple case--directly follow property

      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    } else if (!literalPriority && val && hasOwnProp.call(val, loc)) {
      addRet(this._trace(x, val[loc], push(path, loc), val, loc, callback, hasArrExpr, true));
    } // We check the resulting values for parent selections. For parent
    // selections we discard the value object and continue the trace with the
    // current val object


    if (this._hasParentSelector) {
      for (var t = 0; t < ret.length; t++) {
        var rett = ret[t];

        if (rett && rett.isParentSelector) {
          var tmp = that._trace(rett.expr, val, rett.path, parent, parentPropName, callback, hasArrExpr);

          if (Array.isArray(tmp)) {
            ret[t] = tmp[0];
            var tl = tmp.length;

            for (var tt = 1; tt < tl; tt++) {
              t++;
              ret.splice(t, 0, tmp[tt]);
            }
          } else {
            ret[t] = tmp;
          }
        }
      }
    }

    return ret;
  };

  JSONPath.prototype._walk = function (loc, expr, val, path, parent, parentPropName, callback, f) {
    if (Array.isArray(val)) {
      var n = val.length;

      for (var i = 0; i < n; i++) {
        f(i, loc, expr, val, path, parent, parentPropName, callback);
      }
    } else if (_typeof(val) === 'object') {
      for (var m in val) {
        if (hasOwnProp.call(val, m)) {
          f(m, loc, expr, val, path, parent, parentPropName, callback);
        }
      }
    }
  };

  JSONPath.prototype._slice = function (loc, expr, val, path, parent, parentPropName, callback) {
    if (!Array.isArray(val)) {
      return undefined;
    }

    var len = val.length,
        parts = loc.split(':'),
        step = parts[2] && parseInt(parts[2]) || 1;
    var start = parts[0] && parseInt(parts[0]) || 0,
        end = parts[1] && parseInt(parts[1]) || len;
    start = start < 0 ? Math.max(0, start + len) : Math.min(len, start);
    end = end < 0 ? Math.max(0, end + len) : Math.min(len, end);
    var ret = [];

    for (var i = start; i < end; i += step) {
      var tmp = this._trace(unshift(i, expr), val, path, parent, parentPropName, callback, true); // Should only be possible to be an array here since first part of
      //   ``unshift(i, expr)` passed in above would not be empty, nor `~`,
      //     nor begin with `@` (as could return objects)
      // This was causing excessive stack size in Node (with or
      //  without Babel) against our performance test: `ret.push(...tmp);`


      tmp.forEach(function (t) {
        ret.push(t);
      });
    }

    return ret;
  };

  JSONPath.prototype._eval = function (code, _v, _vname, path, parent, parentPropName) {
    if (!this._obj || !_v) {
      return false;
    }

    if (code.includes('@parentProperty')) {
      this.currSandbox._$_parentProperty = parentPropName;
      code = code.replace(/@parentProperty/g, '_$_parentProperty');
    }

    if (code.includes('@parent')) {
      this.currSandbox._$_parent = parent;
      code = code.replace(/@parent/g, '_$_parent');
    }

    if (code.includes('@property')) {
      this.currSandbox._$_property = _vname;
      code = code.replace(/@property/g, '_$_property');
    }

    if (code.includes('@path')) {
      this.currSandbox._$_path = JSONPath.toPathString(path.concat([_vname]));
      code = code.replace(/@path/g, '_$_path');
    }

    if (code.includes('@root')) {
      this.currSandbox._$_root = this.json;
      code = code.replace(/@root/g, '_$_root');
    }

    if (code.match(/@([\t-\r \)\.\[\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF])/)) {
      this.currSandbox._$_v = _v;
      code = code.replace(/@([\t-\r \)\.\[\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF])/g, '_$_v$1');
    }

    try {
      return vm.runInNewContext(code, this.currSandbox);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
      throw new Error('jsonPath: ' + e.message + ': ' + code);
    }
  }; // PUBLIC CLASS PROPERTIES AND METHODS
  // Could store the cache object itself


  JSONPath.cache = {};
  /**
   * @param {string[]} pathArr Array to convert
   * @returns {string} The path string
   */

  JSONPath.toPathString = function (pathArr) {
    var x = pathArr,
        n = x.length;
    var p = '$';

    for (var i = 1; i < n; i++) {
      if (!/^(~|\^|@(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\(\))$/.test(x[i])) {
        p += /^[\*0-9]+$/.test(x[i]) ? '[' + x[i] + ']' : "['" + x[i] + "']";
      }
    }

    return p;
  };
  /**
   * @param {string} pointer JSON Path
   * @returns {string} JSON Pointer
   */


  JSONPath.toPointer = function (pointer) {
    var x = pointer,
        n = x.length;
    var p = '';

    for (var i = 1; i < n; i++) {
      if (!/^(~|\^|@(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\(\))$/.test(x[i])) {
        p += '/' + x[i].toString().replace(/~/g, '~0').replace(/\//g, '~1');
      }
    }

    return p;
  };
  /**
   * @param {string} expr Expression to convert
   * @returns {string[]}
   */


  JSONPath.toPathArray = function (expr) {
    var cache = JSONPath.cache;

    if (cache[expr]) {
      return cache[expr].concat();
    }

    var subx = [];
    var normalized = expr // Properties
    .replace(/@(?:null|boolean|number|string|integer|undefined|nonFinite|scalar|array|object|function|other)\(\)/g, ';$&;') // Parenthetical evaluations (filtering and otherwise), directly
    //   within brackets or single quotes
    .replace(/['\[](\??\((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\))['\]]/g, function ($0, $1) {
      return '[#' + (subx.push($1) - 1) + ']';
    }) // Escape periods and tildes within properties
    .replace(/\['((?:[\0-&\(-\\\^-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)'\]/g, function ($0, prop) {
      return "['" + prop.replace(/\./g, '%@%').replace(/~/g, '%%@@%%') + "']";
    }) // Properties operator
    .replace(/~/g, ';~;') // Split by property boundaries
    .replace(/'?\.'?(?!(?:[\0-Z\\-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*\])|\['?/g, ';') // Reinsert periods within properties
    .replace(/%@%/g, '.') // Reinsert tildes within properties
    .replace(/%%@@%%/g, '~') // Parent
    .replace(/(?:;)?(\^+)(?:;)?/g, function ($0, ups) {
      return ';' + ups.split('').join(';') + ';';
    }) // Descendents
    .replace(/;;;|;;/g, ';..;') // Remove trailing
    .replace(/;$|'?\]|'$/g, '');
    var exprList = normalized.split(';').map(function (exp) {
      var match = exp.match(/#([0-9]+)/);
      return !match || !match[1] ? exp : subx[match[1]];
    });
    cache[expr] = exprList;
    return cache[expr];
  };

  exports.JSONPath = JSONPath;

  Object.defineProperty(exports, '__esModule', { value: true });

})));

},
'flatted/flatted':function(){
(function() {

var Flatted = (function (Primitive, primitive) {

  /*!
   * ISC License
   *
   * Copyright (c) 2018, Andrea Giammarchi, @WebReflection
   *
   * Permission to use, copy, modify, and/or distribute this software for any
   * purpose with or without fee is hereby granted, provided that the above
   * copyright notice and this permission notice appear in all copies.
   *
   * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
   * REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
   * AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
   * INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
   * LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE
   * OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
   * PERFORMANCE OF THIS SOFTWARE.
   */

  var Flatted = {

    parse: function parse(text, reviver) {
      var input = JSON.parse(text, Primitives).map(primitives);
      var value = input[0];
      var $ = reviver || noop;
      var tmp = typeof value === 'object' && value ?
                  revive(input, new Set, value, $) :
                  value;
      return $.call({'': tmp}, '', tmp);
    },

    stringify: function stringify(value, replacer, space) {
      for (var
        firstRun,
        known = new Map,
        input = [],
        output = [],
        $ = replacer && typeof replacer === typeof input ?
              function (k, v) {
                if (k === '' || -1 < replacer.indexOf(k)) return v;
              } :
              (replacer || noop),
        i = +set(known, input, $.call({'': value}, '', value)),
        replace = function (key, value) {
          if (firstRun) {
            firstRun = !firstRun;
            return value;
            // this was invoking twice each root object
            // return i < 1 ? value : $.call(this, key, value);
          }
          var after = $.call(this, key, value);
          switch (typeof after) {
            case 'object':
              if (after === null) return after;
            case primitive:
              return known.get(after) || set(known, input, after);
          }
          return after;
        };
        i < input.length; i++
      ) {
        firstRun = true;
        output[i] = JSON.stringify(input[i], replace, space);
      }
      return '[' + output.join(',') + ']';
    }

  };

  return Flatted;

  function noop(key, value) {
    return value;
  }

  function revive(input, parsed, output, $) {
    return Object.keys(output).reduce(
      function (output, key) {
        var value = output[key];
        if (value instanceof Primitive) {
          var tmp = input[value];
          if (typeof tmp === 'object' && !parsed.has(tmp)) {
            parsed.add(tmp);
            output[key] = $.call(output, key, revive(input, parsed, tmp, $));
          } else {
            output[key] = $.call(output, key, tmp);
          }
        } else
          output[key] = $.call(output, key, value);
        return output;
      },
      output
    );
  }

  function set(known, input, value) {
    var index = Primitive(input.push(value) - 1);
    known.set(value, index);
    return index;
  }

  // the two kinds of primitives
  //  1. the real one
  //  2. the wrapped one

  function primitives(value) {
    return value instanceof Primitive ? Primitive(value) : value;
  }

  function Primitives(key, value) {
    return typeof value === primitive ? new Primitive(value) : value;
  }
  
}(String, 'string'));

if (typeof define === 'function' && define.amd) {
	define([], Flatted);
}

}).call(this);
},
'appivo/vue/VueInit':function(){
define(['vue/vue', 
        'vue/vue-drag-and-drop', 
        './VueState', 
        './VueDragster', 
        './VueLocale',
        './components/HelpLink'], 
  function(Vue, VueDragDrop, VueState, VueDragster, VueLocale, HelpLink) {
	
	return {
		init: function() {
		    Vue.use(VueDragDrop);
		    Vue.use(VueLocale);
		    Vue.use(VueDragster);
		    Vue.component('helplink', HelpLink);			
		}
	};
});
},
'vue/vue-drag-and-drop':function(){
/* https://github.com/james2doyle/vue-drag-and-drop/ */

/* globals Vue */
(function () {

  var DragAndDrop = {}

  DragAndDrop.install = function (Vue) {
    Vue.directive('drag-and-drop', {
      params: [
      'v-drag-and-drop',
      'v-drag-start',
      'v-drag-over',
      'v-drag-enter',
      'v-drag-leave',
      'v-drag-end',
      'drop',
      'droppable',
      'draggable'
      ],
      bind: function () {
        // use the VM so we only have 1 dragging item per app
        this.vm._dragSrcEl = null;
        this.handleDragStart = function (e) {
          e.target.classList.add('dragging');
          this.vm._dragSrcEl = e.target;
          e.dataTransfer.effectAllowed = 'move';
          // Need to set to something or else drag doesn't start
          e.dataTransfer.setData('text', '*');
          if (typeof(this.vm[this.params.vDragStart]) === 'function') {
            this.vm[this.params.vDragStart].call(this, e.target);
          }
        }.bind(this);
        this.handleDragOver = function(e) {
          if (e.preventDefault) {
            // allows dropping
            e.preventDefault();
          }
          e.dataTransfer.dropEffect = 'move';
          e.target.classList.add('drag-over');
          if (typeof(this.vm[this.params.vDragOver]) === 'function') {
            this.vm[this.params.vDragOver].call(this, e.target);
          }
          return false;
        }.bind(this);
        this.handleDragEnter = function(e) {
          if (typeof(this.vm[this.params.vDragEnter]) === 'function') {
            this.vm[this.params.vDragEnter].call(this, e.target);
          }
          e.target.classList.add('drag-enter');
        }.bind(this);
        this.handleDragLeave = function(e) {
          if (typeof(this.vm[this.params.vDragLeave]) === 'function') {
            this.vm[this.params.vDragLeave].call(this, e.target);
          }
          e.target.classList.remove('drag-enter');
        }.bind(this);
        this.handleDragEnd = function(e) {
          e.target.classList.remove('dragging', 'drag-over', 'drag-enter');
          if (typeof(this.vm[this.params.vDragEnd]) === 'function') {
            this.vm[this.params.vDragEnd].call(this, e.target);
          }
        }.bind(this);
        this.handleDrop = function(e) {
          if (e.stopPropagation) {
            // stops the browser from redirecting.
            e.stopPropagation();
          }
          // Don't do anything if dropping the same column we're dragging.
          if (this.vm._dragSrcEl != e.target) {
            if (typeof(this.vm[this.params.drop]) === 'function') {
              var el = (e.target.draggable) ? e.target : e.target.parentElement;
              this.vm[this.params.drop].call(this, this.vm._dragSrcEl, el);
            }
          }
          return false;
        }.bind(this);
        // setup the listeners
        this.el.setAttribute('draggable', this.params.draggable);
        this.el.addEventListener('dragstart', this.handleDragStart, false);
        this.el.addEventListener('dragenter', this.handleDragEnter, false);
        this.el.addEventListener('dragover', this.handleDragOver, false);
        this.el.addEventListener('dragleave', this.handleDragLeave, false);
        if (this.params.droppable) {
            this.el.addEventListener('drop', this.handleDrop, false);        	
        }
        this.el.addEventListener('dragend', this.handleDragEnd, false);
      },
      update: function (newValue, oldValue) {
        // console.log(this);
      },
      unbind: function () {
        // shut er' down
        this.el.classList.remove('dragging', 'drag-over', 'drag-enter');
        this.el.removeAttribute('draggable');
        this.el.removeEventListener('dragstart', this.handleDragStart);
        this.el.removeEventListener('dragenter', this.handleDragEnter);
        this.el.removeEventListener('dragover', this.handleDragOver);
        this.el.removeEventListener('dragleave', this.handleDragLeave);
      }
    });
  }

  if (typeof exports == "object") {
    module.exports = DragAndDrop
  } else if (typeof define == "function" && define.amd) {
    define([], function(){ return DragAndDrop })
  } else if (window.Vue) {
    window.DragAndDrop = DragAndDrop
    Vue.use(DragAndDrop)
  }
})()
},
'appivo/vue/VueState':function(){
/**
 * Hook for enabling propagation of state to all Vue-components
 */
define(['vue/vue'], function(Vue) {
	
	var _init = Vue.prototype._init
	Vue.prototype._init = function (options) {
		options = options || {}
		var componentOptions = this.constructor.options
		// state injection
		var state = options.state || componentOptions.state
		if (state) {
			if (!state._initialized) {
				state._init(this);
			}
			this.$state = state
		} else if (options.parent && options.parent.$state) {
			this.$state = options.parent.$state
		}
		_init.call(this, options);
	};
	
});

},
'appivo/vue/VueDragster':function(){
/**
 * Vue Drag & Drop
 */
define(['appivo/ui/Dragster'], function(Dragster) {
		
	var VueDragster = {};
	
	VueDragster.install = function(Vue) {
		Vue.directive('dragster-draggable', {
			params: [
			  'mode',
			  'fluid',
			  'data',
			  'on-start',
			  'on-drag',
			  'on-end',
			  'create-ghost',
			  'handle'
			],
			bind: function() {
				var fluid = false;
				if (this.params.fluid) {
					fluid = this.params.fluid;
				}
				this._draggable = Dragster.draggable(this.el, {
					mode: this.params.mode,
					data: this.params.data,
					fluid: fluid,
					onDragStart: this.vm[this.params.onStart],
					onDrag: this.vm[this.params.onDrag],
					onDragEnd: this.vm[this.params.onEnd],
					createGhost: this.vm[this.params.createGhost],
					handle: this.vm[this.params.handle]
				});
			},
			unbind: function() {
				this._draggable.destroy();
			}
		});

		Vue.directive('dragster-droppable', {
			params: [
			  'on-enter',
			  'on-over',
			  'on-leave',
			  'on-drop'
			],
			bind: function() {
				this._droppable = Dragster.droppable(this.el, {
					onDragEnter: this.vm[this.params.onEnter],				
					onDragOver: this.vm[this.params.onOver],				
					onDragLeav: this.vm[this.params.onLeave],				
					onDrop: this.vm[this.params.onDrop]
				});			
			},
			unbind: function() {
				this._droppable.destroy();
			}
		});
	}
	
	return VueDragster;
});
},
'appivo/ui/Dragster':function(){
define([], function() {

	var doc = document;
	var oid = 0;
	var logging = false;
	var dragged = null;
	var dragZindex = 1000;
	var currentTarget = null;
	var observers = new Array();
	
	function log(msg, trace) {
		if (logging) {
			console.log(msg);			
		}
	}
	
	function notify(event, msg) {
		for (var i = 0; i < observers.length; i++) {
			observers[i](event, msg);
		}
	}
	
	function bind(instance, node, event, func) {
		var f = func.bind(instance);
		if (!instance.listeners) {
			instance.listeners = new Array();
		}
		instance.listeners.push({
			node: node,
			func: f,
			event: event
		});
		node.addEventListener(event, f, false);
	}

	function unbind(instance, event) {
		if (instance.listeners) {
			for (var i = 0; i < instance.listeners.length; i++) {
				var entry = instance.listeners[i];
				if (!event || entry.event == event) {
					entry.node.removeEventListener(entry.event, entry.func);
					instance.listeners.splice(i, 1);
				}
			}
		}
	}

	function distance(draggable, event, elm2) {
		var node = draggable.getNode();
		var div1rect = node.getBoundingClientRect();
		var div1x = event.x + div1rect.width/2;
		var div1y = event.y + div1rect.height/2;
		var div2rect = elm2.getBoundingClientRect();
		var pos = 0;
		if (div1x < div2rect.left) {
		    pos += 1;
		} else if (div1x < div2rect.right) {
		    pos += 2;
		} else {
		    pos += 4;
		}
		if (div1y < div2rect.top) {
		    pos += 8;
		} else if (div1y < div2rect.bottom) {
		    pos += 16;
		} else {
		    pos += 32;
		}
        switch (pos) {
        case 9: //Top left
            var x = div1x - div2rect.left;
            var y = div1y - div2rect.top;
		    var distSq = Math.pow(x, 2) + Math.pow(y, 2);
            break;
        case 17: //Middle left
            var x = div1x - div2rect.left;
            var y = div1y - div2rect.top + div2rect.height/2;
            var distSq = Math.pow(x, 2);
            break;
        case 33: //Bottom left
            var x = div1x - div2rect.left;
            var y = div1y - div2rect.bottom;
		    var distSq = Math.pow(x, 2) + Math.pow(y, 2);
            break;
        case 10: //Top middle
            var x = div1x - div2rect.left + div2rect.width/2;
            var y = div1y - div2rect.top;
            var distSq = Math.pow(y, 2);
            break;
        case 18: //Middle middle
            var x = div1x - div2rect.left + div2rect.width/2;
            var y = div1y - div2rect.top + div2rect.height/2;
		    var distSq = Math.pow(x, 2) + Math.pow(y, 2);
            break;
        case 34: //Bottom middle
            var x = div1x - div2rect.left + div2rect.width/2;
            var y = div1y - div2rect.bottom;
            var distSq = Math.pow(y, 2);
            break;
        case 12: //Top right
            var x = div1x - div2rect.right;
            var y = div1y - div2rect.top;
		    var distSq = Math.pow(x, 2) + Math.pow(y, 2);
            break;
        case 20: //Middle right
            var x = div1x - div2rect.right;
            var y = div1y - div2rect.top + div2rect.height/2;
            var distSq = Math.pow(x, 2);
            break;
        case 36: //Bottom right
            var x = div1x - div2rect.right;
            var y = div1y - div2rect.bottom;
		    var distSq = Math.pow(x, 2) + Math.pow(y, 2);
            break;
        }
        return {
            dist: Math.sqrt(distSq),
            x: x,
            y: y
        };
	};

	function findDroppable(elm) {
		if (elm._apvDroppable) {
			return elm._apvDroppable;
		} else if (elm.parentNode) {
			return findDroppable(elm.parentNode);
		}
		return null;
	};

	function findDraggables(elm, list, exclude, noback) {
		var found = 0;
		var origElm = null;
		if (elm._apvDroppable && !elm.className.includes("editOverlay") && elm.parentNode.className.includes("editOverlay")) {
		    origElm = elm;
		    elm = elm.parentNode;
		    exclude.push(elm);
		}
		if (elm._apvDraggable && (!exclude || exclude.indexOf(elm) == -1)) {
			if (list.indexOf(elm) == -1) {
				list.push(elm._apvDraggable);				
			}
			found++;
		}
		for (var i = 0; i < elm.childNodes.length; i++) {
			var child = elm.childNodes[i];
			if (child !== origElm && child.nodeType == 1) {
				found += findDraggables(child, list, exclude, true);
			}
		}
		if (found == 0 && !noback) {
			while (elm.parentNode) {
				elm = elm.parentNode;
				if (elm._apvDraggable && (!exclude || exclude.indexOf(elm) == -1)) {
					if (list.indexOf(elm) == -1) {
						list.push(elm._apvDraggable);				
					}
					found++;
					break;
				}
			}
		}
		return found;
	};
	
	function getElementBelow(draggable, event) {
		if (draggable) {
			draggable.show(false);
		}
		var elm = doc.elementFromPoint(event.clientX, event.clientY);
		if (draggable) {
			draggable.show(true);
		}
		while (elm && !elm._apvDroppable) {
			if (elm._widget && elm._widget.parent && elm._widget.parent.overlay) {
				elm = elm._widget.parent.overlay.firstChild;
			} else {
				elm = elm.parentNode;				
			}
		}
		log("returning " + (elm ? elm.id : "<nothing>") + " at " + event.clientX + "," + event.clientY, true);
		
		return elm;
	};
	
	function dispatchSyntheticEvents(elm, source, event) {
		if (currentTarget !== elm) {
			if (currentTarget && currentTarget._apvDroppable) {
				log("Leaving " + currentTarget._apvDroppable.id);
				currentTarget._apvDroppable._simulatedDragLeave({
					clientX: event.clientX,
					clientY: event.clientY,
					x: event.x,
					y: event.y,
					source: source
				});
			}
			currentTarget = elm;
			if (elm && elm._apvDroppable) {
				log("Entering " + currentTarget._apvDroppable.id);
				currentTarget._apvDroppable._simulatedDragEnter({
					clientX: event.clientX,
					clientY: event.clientY,
					x: event.x,
					y: event.y,
					source: source
				});					
			}
		} else if (currentTarget && currentTarget._apvDroppable) {
			currentTarget._apvDroppable._simulatedDragOver({
				clientX: event.clientX,
				clientY: event.clientY,
				x: event.x,
				y: event.y,
				source: source
			});
		}		
	}
	
	function computePos(draggable, event, friend, droppable) {
		var $node = draggable.$node;
		if (!$node) {
			$node = $(draggable.node);
		}
		var coffset = {
			top: 0,
			left: 0
		};
		if (!draggable.cloned) {
			coffset = $(draggable._viewContainer).offset();
		}
 		var x = event.clientX - draggable._offset.x - coffset.left;
 		var y = event.clientY - draggable._offset.y - coffset.top;

		if (draggable._gridOffset) {
			var offset = $node.offset();
			var deltaX = (offset.left % 8) - (draggable._gridOffset.left % 8);
			var deltaY = (offset.top % 8) - (draggable._gridOffset.top % 8);
			x = x - deltaX;
			y = y - deltaY;
			x = x - (x % draggable._gridX);
			y = y - (y % draggable._gridY);
		}
		if (droppable) {
		    var doffset = $(droppable).offset();
		    x += (doffset.left - coffset.left) % 8;
		    y += (doffset.top - coffset.top) % 8;
		}
		if (draggable.node.parentNode == draggable._container) {
			y = y + draggable._container.scrollTop;
			x = x + draggable._container.scrollLeft;
		}

		return {
			x: x,
			y: y
		};
	};

	function pxToInt(str) {
		var i = str.indexOf('px');
		var n = str.substring(0, i);
		return parseInt(n);
	};

	function elevateNodes(draggable) {
		var clone = draggable.mode == 'copy';
		var node = draggable.node;
		var $node = draggable.$node;
		var $friend = null;
		draggable.orgOffset = $node.position();
		draggable.orgParent = null;
		draggable.orgSibling = null;
		draggable.orgFriendParent = null;
		draggable.orgFriendSibling = null;
		var container = draggable._container;
		var viewContainer = draggable._viewContainer ? draggable._viewContainer : container;
		if (node.parentNode !== viewContainer) {
			draggable.orgParent = node.parentNode;
			draggable.orgSibling = node.nextSibling;
			var cstyle = getComputedStyle(viewContainer);
			var containerOffset = $(viewContainer).offset();
			var nodeOffset = $(draggable.orgParent).offset();
			containerOffset.top += pxToInt(cstyle.borderTopWidth);
			containerOffset.left += pxToInt(cstyle.borderLeftWidth);
			var scrollTop = draggable.orgParent.scrollTop;
			var scrollLeft = draggable.orgParent.scrollLeft;
			draggable.diffOffset = {
				left: nodeOffset.left - containerOffset.left,
				top: nodeOffset.top - containerOffset.top
			};
			if (!clone) {
				node.parentNode.removeChild(node);
			}

			var friend = draggable.options.friend;
			if (friend) {
				$friend = $(friend);
				draggable.$friend = $friend;
				draggable.orgFriendParent = friend.parentNode;
				draggable.orgFriendSibling = friend.nextSibling;
				if (!clone && draggable.orgFriendParent) {
					draggable.orgFriendParent.removeChild(friend);
				}
			}

			if (clone) {
				var box = draggable.node.getBoundingClientRect();
				var clone = node.cloneNode(true);
				if (draggable.options.fluid) {
					clone.style.position = 'absolute';
				} else {
					clone.style.position = 'fixed';
				}
				viewContainer.appendChild(clone);
				$node = $(clone);
				$node.addClass('dragging');
				draggable.$node = $node;
				draggable.cloned = true;
				draggable._offset = {
					x: box.width / 2,
					y: box.height / 2
				};
			} else {
				if (friend) {
					viewContainer.appendChild(friend);
				}
				viewContainer.appendChild(node);
			}
			$node.css({
				top: draggable.orgOffset.top + draggable.diffOffset.top,
				left: draggable.orgOffset.left + draggable.diffOffset.left
			});
			if ($friend) {
				$friend.css({
					top: draggable.orgOffset.top + draggable.diffOffset.top,
					left: draggable.orgOffset.left + draggable.diffOffset.left
				});
			}
		} else {
			if (draggable.options.friend) {
				draggable.$friend = $(draggable.options.friend);
			}
		}
	};
	
	function returnNodes(draggable) {
		var clone = draggable.mode == 'copy';
		var node = draggable.node;
		var $node = draggable.$node;
		if (!$node) {
			$node = $(draggable.node);
		}
		var $friend = draggable.$friend;
		if (!$friend) {
			if (draggable.friend) {
				$friend = $(draggable.friend);
			}
		}
		var container = draggable._container;
		if (draggable.orgParent && !clone) {
			var pos = $node.position();
			pos = {
				left: pos.left + container.scrollLeft - draggable.diffOffset.left,
				top: pos.top + container.scrollTop - draggable.diffOffset.top
			};
			var friend = draggable.options.friend;
			if (friend) {
				if (draggable.orgFriendParent) {
					friend.parentNode.removeChild(friend);
					draggable.orgFriendParent.insertBefore(friend, draggable.orgFriendSibling);
				}
			}
			node.parentNode.removeChild(node);
			draggable.orgParent.insertBefore(node, draggable.orgSibling);
			$node.css(pos);
			if ($friend) {
				$friend.css(pos);
			}
		} else if (clone) {
			container.removeChild($node.get()[0]);
		}
		draggable.orgParent = null;
		draggable.orgFriendParent = null;
		draggable.orgSibling = null;
		draggable.orgFriendSibling = null;
		draggable.orgOffset = null;
		draggable.nodeOffset = null;
	}

	function Draggable(node, options) {
		var t = this;
		node._apvDraggable = this;
		this.id = oid++;
		this.node = node;
		this.options = options || {};
		this.mode = 'move';
		this.locked = false;
		this.handle = options.handle || "";
		if (this.options) {
		    if (this.options.mode) {
			    this.mode = this.options.mode;
		    }
		    if (this.options.locked) {
		        this.locked = this.options.locked;
		    }
		}
		node.style['userSelect'] = 'none';

		var handleNode = null;
		if (this.handle) {
			handleNode = $(node).find(this.handle);
			handleNode.on('mousedown', function(event) {
				t.onMouseDown(event);
			});
		} else {
			$(node).on('mousedown', function(event) {
				t.onMouseDown(event);
			});
		}

		this._container = doc.body;
		if (options.container) {
			this._container = options.container;
		}
		this._viewContainer = options.viewContainer;
		if (options.grid) {
			this._gridX = options.grid[0];
			this._gridY = options.grid[1];
			this._gridOffset = $(this._container).offset();
		}
	};

	var lastClick = null;
	var dragged = 0;
	var dragging = false;
	var resizing = false;

	Draggable.prototype = {

		constructor: Draggable,

		getData: function() {
			return this.options.data;
		},

		getDomNode: function() {
			return this.$node ? this.$node[0] : this.node;
		},

		onDblClick: function(event) {
			if (this.options.onDblClick) {
				this.options.onDblClick(event);
			}
		},

		onClick: function(event) {
		    if (this.options.onClick) {
		        this.options.onClick(event);
		    }
		},
		
		show: function(show) {
			var $node = this.$node;
			var $friend = this.$friend;
			if (show) {
				$node.css('display', this._orgDisplay);
				if ($friend) {
					$friend.css('display', this._orgFriendDisplay);
				}								
			} else {
				$node.css('display', 'none');
				if ($friend) {
					$friend.css('display', 'none');
				}				
			}
		},
		
		onMouseDown: function(event) {
			if (event.button != 0 || (this.options.ignoreShiftClick && event.shiftKey)) {
				return;
			}
			// This is the beginning of a resize-operation, cancel out
			if (event.target.classList.contains('ui-resizable-handle')) {
				event.stopPropagation();
				event.preventDefault();
				resizing = true;
				return;
			}
			var time = new Date().getTime();
			var ignore = false;
			if (time && lastClick) {
				var dblclick = (time - lastClick) < 300;
				lastClick = time;
				if (dblclick) {
					unbind(this, 'mousemove');
					unbind(this, 'mouseup');
					this._restore(event);
					this.onDblClick(event);
					ignore = true;
				}
			} else {
				lastClick = time;
			}
			
			if (ignore) {
				return;
			} else {
			    this.onClick(event);
				dragged = 0;
			}

			this.$node = $(this.node);
			// Position within parent
			this._orgPos = this.$node.offset();
			// Drag-start coordinates
			this._startPos = {
				x: event.clientX,
				y: event.clientY
			};
			this._offset = {
				x: this._startPos.x - this._orgPos.left,
				y: this._startPos.y - this._orgPos.top
			};
			if (!this.locked) {
			    bind(this, doc, 'mouseup', this.onMouseUp);
			    bind(this, doc, 'mousemove', this.onMouseMove);
			}
						
			event.stopPropagation();
			event.preventDefault();
		},

		beginSyntheticDrag: function(event) {
		    this.$node = $(this.node);
		    this._orgPos = this.$node.offset();
            // Drag-start coordinates
            this._startPos = {
                x: event.clientX,
                y: event.clientY
            };
            this._offset = {
                x: this._startPos.x - this._orgPos.left,
                y: this._startPos.y - this._orgPos.top
            };
		    elevateNodes(this);
            this._orgZindex = this.$node.css('z-index');
            this._friendOrgZindex = this.$friend ? this.$friend.css('z-index') : null;
            this.$node.css('z-index', dragZindex);
            if (this.$friend) {
                this.$friend.css('z-index', dragZindex);
            }
            currentTarget = null;
            this._orgDisplay = this.$node.css('display');
            this._orgFriendDisplay = this.$friend ? this.$friend.css('display') : null;
		},

		endSyntheticDrag: function(event, droppable) {
			var pos = this._restore(event);
            if (droppable) {
                droppable._simulatedDrop({
                    clientX: event.clientX,
                    clientY: event.clientY,
                    x: pos.x,
                    y: pos.y,
                    source: this
                });
            }
		},

		_beginDrag: function(event) {
			dragged = this;
			dragging = true;
			notify('dragstart', {
				draggable: this
			});
			if (this.options.beginDrag) {
			    this.options.beginDrag(event);
			}

			var nodes = elevateNodes(this);
			this._orgZindex = this.$node.css('z-index');
			this._friendOrgZindex = this.$friend ? this.$friend.css('z-index') : null;
			this.$node.css('z-index', dragZindex);
			if (this.$friend) {
				this.$friend.css('z-index', dragZindex);
			}
			currentTarget = null;
			this._orgDisplay = this.$node.css('display');
			this._orgFriendDisplay = this.$friend ? this.$friend.css('display') : null;
		},

		onMouseMove: function(event) {
			if (resizing) {
				return;
			}
			if (!dragging) {
				this._beginDrag(event);
			}
			var $node = this.$node;
			var $friend = this.$friend;

			var elm = getElementBelow(this, event);
			var pos = computePos(this, event, false, elm);
			var oldCss = $node.css(["top", "left"]);
			var oldPos = {
			    x: parseInt(oldCss.left),
			    y: parseInt(oldCss.top),
			};
			$node.css({
				top: pos.y,
				left: pos.x
			});
			if ($friend) {
				var friendPos = computePos(this, event, true, elm);
				$friend.css({
					top: pos.y,
					left: pos.x
				});
			}

			if (elm) {
				dispatchSyntheticEvents(elm, this, event);
			}
			if (this.options.onDrag) {
			    this.options.onDrag(pos, oldPos);
			}

			event.stopPropagation();
			event.preventDefault();
		},

		_restore: function(event) {
			returnNodes(this);
			var pos = computePos(this, event);
			if (!this.$node && this.node) {
				this.$node = $(this.node);
			}
			this.$node.css('z-index', this._orgZindex);
			if (this.$friend) {
				this.$friend.css('z-index', this._friendOrgZindex);
			}
			this.$node = null;
			this.$friend = null;
			return pos;
		},

		onMouseUp: function(event) {
			var t = this;
			if (resizing) {
				resizing = false;
				return;
			}
			if (dragging) {
				unbind(this, 'mousemove');
				unbind(this, 'mouseup');
				notify('dragstop', {
					draggable: this
				});
				var elm = getElementBelow(this, event);	
				var pos = t._restore(event);
				if (elm) {
					var droppable = findDroppable(elm);
					if (droppable) {
						droppable._simulatedDrop({
							clientX: event.clientX,
							clientY: event.clientY,
							x: pos.x,
							y: pos.y,
							source: t
						});
					}
				}
                if (this.options.endDrag) {
                    this.options.endDrag(event, droppable);
                }
			} else {
				unbind(this, 'mouseup');
				unbind(this, 'mousemove');
			}
			dragging = false;
		},

		onDragStart: function(event) {
			dragged = this;
			log("DragStart " + this.id);
			this.oldDisplay = this.node.style.display;
			event.stopPropagation();
		},
	        
	    onDrag: function(event) {
	    },
					
	    onDragEnd: function(event) {
        	log("DragEnd " + this.id);
	    },
	    
	    getNode: function() {
	    	return this.node;
	    },
	    
	    createGhost: function() {
	    	var ghost = null;
	    	log("Creating ghost for " + this.id);
	    	if (this.options.createGhost) {
	    		ghost = this.options.createGhost(this);
	    	} else {
	    		ghost = this.node.cloneNode(true);
	    		ghost.style.display = dragged.oldDisplay;
	    		ghost._apvDraggable = null;	    		
	    	}
	    	
	    	return ghost;
	    },
	    
	    destroy: function() {
	    	unbind(this);
	    }
	};
		
	function Droppable(node, options) {
		var t = this;
		node._apvDroppable = this;
		this.id = oid++;
		this.node = node;
		this.options = options || {};
		this.fluid = this.options.fluid ? true : false;
		$(node).addClass('apvdrop');
		if (this.options.html5) {
			bind(this, node, 'dragenter', t.onDragEnter);
	        bind(this, node, 'dragover', t.onDragOver);
			bind(this, node, 'dragleave', t.onDragLeave);
			bind(this, node, 'drop', t.onDrop);			
		}
		log("Created droppable");
	};
		
	Droppable.prototype = {
		constructor: Droppable,
	    tmpNode: null,
		tmDraggables: null,
	    tmpClosest: null,
	    tmpBefore: false,
        depth: 0,
	    
	    _simulatedDragEnter: function(event) {
	    	var t = this;
	    	var dragged = event.source;
	    	var setGhost = function(ghost) {
	    		if (ghost.ownerDocument !== doc) {
	    			ghost = doc.importNode(ghost, true);
	    		}
	    		t.tmpNode = ghost;
	    		t.tmpDraggables = new Array();
	    		findDraggables(t.node, t.tmpDraggables, [t.tmpNode, t.node]);
                log("Found " + t.tmpDraggables.length + " draggables");			    		
	    	}
	    	if (this.fluid) {
		    	this.depth++;
		    	var sourceNode = event.source.getDomNode();
	            if ( !this.tmpNode) {
	                log("SimDragEnter " + this.id + " depth " + this.depth);
					log(sourceNode);
			    	if (this.options.hoverClass) {
			    		this.node.classList.add(this.options.hoverClass);
		    		}
			    	var ghost = dragged.createGhost();
			    	if (ghost && ghost.then) {
			    		ghost.then(function(n) {
			    			setGhost(n);
			    		});
			    	} else {
			    		setGhost(ghost);
			    	}
	            } else if (!this.tmpNode) { //todo dead code, does it break anything?
			    	if (this.options.hoverClass) {
			    		this.node.classList.add(this.options.hoverClass);
		    		}
			    	var ghost = dragged.createGhost();
			    	if (ghost && ghost.then) {
			    		ghost.then(function(n) {
			    			setGhost(n);
			    		});
			    	} else {
			    		setGhost(ghost);
			    	}
	            } else {
	            	log("Dud dragenter");
	            }	    		
	    	}
	    	if (this.options.onDragEnter) {
	    		this.options.onDragEnter(event);
	    	}
	    },
	    
	    _simulatedDragOver: function(event) {
	    	var dragged = event.source;
	    	if (this.fluid) {
		    	var dr = this.tmpDraggables;
		    	if (dr && this.tmpNode) {
		    		log("SimDragOver " + this.node.id);
		    		var dist = undefined;
		    		var draggable = null;
		    		for (var i = 0; i < dr.length; i++) {
		    			var d = distance(dragged, event, dr[i].node);
		    			log("Checking distance to " + dr[i].node.id);
		    			if (!dist || d.dist < dist.dist) {
		    				dist = d;
		    				draggable = dr[i];
		    			}
		    		}
		    				
		    		if (draggable) {
			    		log("Draggable = " + draggable.node.id);		    			
		    		}
		    		
		    		var tmpDist = distance(dragged, event, this.tmpNode);
		    		if (draggable && dist.dist < tmpDist.dist) {
		    			var node = draggable.node;
		    			var before = (dist.y <= 0);
		    			log("BEFORE " + before);
		    			if (node !== this.tmpClosest || before != this.tmpBefore) {
		    				this.tmpClosest = node;
		    				this.tmpBefore = before;
		    				if (this.tmpNode.parentNode) {
		    					this.tmpNode.parentNode.removeChild(this.tmpNode);
		    				}
		    				if (this.options.insertGhost) {
		    					log("Calling insertGhost");
		    					this.options.insertGhost(this.tmpNode, before, draggable);
		    				} else if (!before) {
		    					log("no insertGhost - inserting after " + node.id);
		    					node.parentNode.insertBefore(this.tmpNode, node.nextSibling);
		    				} else {
		    					log("no insertGhost - inserting before " + node.id);
		    					node.parentNode.insertBefore(this.tmpNode, node);
		    				}
		    			}
		    		}
		    	} else if (this.tmpNode && this.tmpNode.parentNode) {
		    		this.tmpNode.parentNode.removeChild(this.tmpNode);
		    	}	    		
	    	}

	    	if (this.options.onDragOver) {
	    		this.options.onDragOver(event);
	    	}
	    },
	    
	    _simulatedDragLeave: function(event) {
	    	var dragged = event.source;
	    	if (this.fluid) {
	    		log("SimDragLeave " + this.node.id);
		    	var sourceNode = event.source ? event.source.getDomNode() : undefined;
	        	this.depth--;
	        	if (sourceNode && this.node.contains(sourceNode)  && this.depth > 0) {
	            	log("DragLeave dud depth " + this.depth);
	            	log(this.node);
	            	log(sourceNode);
	                log(this.node === sourceNode);
	            	return;
	            }
	 
		    	if (this.options.hoverClass) {
		    		this.node.classList.remove(this.options.hoverClass);
		    	}			
		    	if (this.tmpNode && this.tmpNode.parentNode) {
		    		this.tmpNode.parentNode.removeChild(this.tmpNode);
		    	}
		    	this.tmpNode = null;
		    	this.tmpClosest = null;
		    	this.tmpDraggables = null;
		    	log("DragLeave " + this.id + " depth "+ this.depth);	    		
	    	}

	    	if (this.options.onDragLeave) {
	    		this.options.onDragLeave(event);
	    	}
	    },
	    
	    _simulatedDrop: function(event) {
	    	var dragged = event.source;
	    	if (this.options.onDrop) {
	    		if (this.fluid) {
	    			if (this.tmpClosest) {
		    			event.details = {
			    			before: this.tmpBefore,
			    			sibling: this.tmpClosest._apvDraggable
			    		};	    				
	    			}
			    	if (this.tmpNode && this.tmpNode.parentNode) {
			    		this.tmpNode.parentNode.removeChild(this.tmpNode);
			    	}
	    		}
	    		this.options.onDrop(event);
	    		this.tmpNode = null;
	    	}
	    },

	    destroy: function() {
	    	unbind(this);
	    }
	};
		
	return {
		draggable: function(node, options) {
			return new Draggable(node, options);
		},
		
		droppable: function(node, options) {
			return new Droppable(node, options);
		},
		
		registerListener: function(observer) {
			if (typeof observer === "function") {
				observers.push(observer);
			}
		},
		
		setLogging: function(log) {
			logging = log;
		},
	
		getDragged: function() {
			return dragged;
		},
		
		setDragged: function(dr) {
			dragged = dr;
			if (dr) {
				dragging = true;				
			}
		},
		
		syntheticDragOver: function(draggable, event) {
			var elm = getElementBelow(draggable, event);
			if (elm) {
				var droppable = findDroppable(elm);
				if (droppable) {
					var pos = computePos(draggable, event, false, elm);
					event.x = pos.x;
					event.y = pos.y;
					dispatchSyntheticEvents(elm, draggable, event);
				} else {
					dispatchSyntheticEvents(null, null, event);
				}
			} else {
				dispatchSyntheticEvents(null, null, event);				
			}	
		},
		
		syntheticDrop: function(draggable, event) {
			var elm = getElementBelow(draggable, event);	
			if (elm) {
				var droppable = findDroppable(elm);
				if (droppable) {
					droppable._simulatedDrop({
						clientX: event.clientX,
						clientY: event.clientY,
						source: draggable
					});						
				}
			}				
		},
		
		unregisterListener: function(observer) {
			for (var i = 0; i < observers.length; i++) {
				if (observers[i] === observer) {
					observers.splice(i, 1);
				}
			}
		}
	};
});
},
'appivo/vue/VueLocale':function(){
/*!
 * Based on vue-i18n 
 * (c) 2016 kazuya kawaguchi
 * Released under the MIT License.
 */
define([], function() { 

	var babelHelpers = {};

	babelHelpers.typeof = function (obj) {
		return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
	};

	babelHelpers;

	/**
	 *  String format template
	 *  - Inspired:  
	 *    https://github.com/Matt-Esch/string-template/index.js
	 */

	var RE_NARGS = /(%|)\{([0-9a-zA-Z]+)\}/g;

	/**
	 * template
	 *  
	 * @param {String} string
	 * @param {Array} ...args
	 * @return {String}
	 */

	function format (string) {
		for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
			args[_key - 1] = arguments[_key];
		}

		if (args.length === 1 && babelHelpers.typeof(args[0]) === 'object') {
			args = args[0];
		}

		if (!args || !args.hasOwnProperty) {
			args = {};
		}

		return string.replace(RE_NARGS, function (match, prefix, i, index) {
			var result = undefined;

			if (string[index - 1] === '{' && string[index + match.length] === '}') {
				return i;
			} else {
				result = args.hasOwnProperty(i) ? args[i] : null;
				if (result === null || result === undefined) {
					return '';
				}

				return result;
			}
		});
	}

	var VueLang = {};

	VueLang.install = function(Vue) {
		var getPath = Vue.parsers.path.getPath;// : Vue.parsers.path.get;
		var util = Vue.util;
		
		var _init = Vue.prototype._init
		Vue.prototype._init = function (options) {
			options = options || {}
			var componentOptions = this.constructor.options
			// state injection
			var locale = options.locale || componentOptions.locale
			if (!locale && options.parent && options.parent.$options.locale) {
				options.locale = options.parent.$options.locale;
			}
			_init.call(this, options);
		};

		function getVal(locale, key, args) {
			var value = key;
			try {
				var val = getPath(locale, key) || locale[key];
				value = (args ? format(val, args) : val) || key;
			} catch (e) {
				value = key;
			}
			return value;
		}

		function getString(locale, key, args) {
			if (!locale) {
				locale = Vue.locale || {};
			}

			if (!key) {
				return '';
			}

			if (args.length === 1) {
				if (util.isObject(args[0]) || util.isArray(args[0])) {
					args = args[0];
				} 
			} else if (args.length === 2) {
				if (util.isObject(args[1]) || util.isArray(args[1])) {
					args = args[1];
				}
			}

			return getVal(locale, key, args);			
		}
		
		Vue.t = function (key) {
			for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
				args[_key2 - 1] = arguments[_key2];
			}
			return getString(Vue.locale, key, args)
		};

		/**
		 * $t
		 *
		 * @param {String} key
		 * @param {Array} ...args
		 * @return {String}
		 */
		Vue.prototype.$t = function (key) {
			for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
				args[_key2 - 1] = arguments[_key2];
			}
			
			var locale = this.locale ? this.locale : this.$options.locale;
			
			return getString(locale, key, args);
		};	  
	};

	return VueLang;
});
},
'appivo/vue/components/HelpLink':function(){
define([
  'vue/vue',
  'dojo/text!../html/HelpLink.html'
], function(Vue, template) {

	var forumURL = "https://forum.appivo.com";
	var docsUrl = "https://docs.appivo.com/";
	var apiUrl = "/apidocs/";
	
	return Vue.extend({
		template: template,
		props: {
			topic: String,
			category: String,
			doc: String,
			video: String,
			label: String,
			icon: String,
            web: String,
			api: String,
			classes: String
		},
		data: function() {
		    return {
		        isVideo: false
		    };
		},
		computed: {
			url: function() {
				var url = forumURL;
				this.isVideo = false;
				if (this.category) {
					url = url + '/c/' + this.category;
				} else if (this.topic) {
					url = url + '/t/' + this.topic;
				} else if (this.doc) {
				    url = docsUrl + this.doc;
				} else if (this.web) {
                    url = this.web;
				} else if (this.video) {
				    url = this.video;
				    this.isVideo = true;
				} else if (this.api !== null && this.api !== undefined) {
					url = apiUrl + this.api;
				}
				return url;
			}
		},
		methods: {
		    showVideo: function() {
		        this.$dispatch('HelpMenu', { cmd: 'openVideo', url: this.url });
		    }
		}
	});
});

},
'dojo/text':function(){
define(["./_base/kernel", "require", "./has", "./request"], function(dojo, require, has, request){
	// module:
	//		dojo/text

	var getText;
	if( 1 ){
		getText= function(url, sync, load){
			request(url, {sync:!!sync, headers: { 'X-Requested-With': null } }).then(load);
		};
	}else{
		// Path for node.js and rhino, to load from local file system.
		// TODO: use node.js native methods rather than depending on a require.getText() method to exist.
		if(require.getText){
			getText= require.getText;
		}else{
			console.error("dojo/text plugin failed to load because loader does not support getText");
		}
	}

	var
		theCache = {},

		strip= function(text){
			//Strips <?xml ...?> declarations so that external SVG and XML
			//documents can be added to a document without worry. Also, if the string
			//is an HTML document, only the part inside the body tag is returned.
			if(text){
				text= text.replace(/^\s*<\?xml(\s)+version=[\'\"](\d)*.(\d)*[\'\"](\s)*\?>/im, "");
				var matches= text.match(/<body[^>]*>\s*([\s\S]+)\s*<\/body>/im);
				if(matches){
					text= matches[1];
				}
			}else{
				text = "";
			}
			return text;
		},

		notFound = {},

		pending = {};

	dojo.cache = function(/*String||Object*/module, /*String*/url, /*String||Object?*/value){
		// summary:
		//		A getter and setter for storing the string content associated with the
		//		module and url arguments.
		// description:
		//		If module is a string that contains slashes, then it is interpretted as a fully
		//		resolved path (typically a result returned by require.toUrl), and url should not be
		//		provided. This is the preferred signature. If module is a string that does not
		//		contain slashes, then url must also be provided and module and url are used to
		//		call `dojo.moduleUrl()` to generate a module URL. This signature is deprecated.
		//		If value is specified, the cache value for the moduleUrl will be set to
		//		that value. Otherwise, dojo.cache will fetch the moduleUrl and store it
		//		in its internal cache and return that cached value for the URL. To clear
		//		a cache value pass null for value. Since XMLHttpRequest (XHR) is used to fetch the
		//		the URL contents, only modules on the same domain of the page can use this capability.
		//		The build system can inline the cache values though, to allow for xdomain hosting.
		// module: String||Object
		//		If a String with slashes, a fully resolved path; if a String without slashes, the
		//		module name to use for the base part of the URL, similar to module argument
		//		to `dojo.moduleUrl`. If an Object, something that has a .toString() method that
		//		generates a valid path for the cache item. For example, a dojo._Url object.
		// url: String
		//		The rest of the path to append to the path derived from the module argument. If
		//		module is an object, then this second argument should be the "value" argument instead.
		// value: String||Object?
		//		If a String, the value to use in the cache for the module/url combination.
		//		If an Object, it can have two properties: value and sanitize. The value property
		//		should be the value to use in the cache, and sanitize can be set to true or false,
		//		to indicate if XML declarations should be removed from the value and if the HTML
		//		inside a body tag in the value should be extracted as the real value. The value argument
		//		or the value property on the value argument are usually only used by the build system
		//		as it inlines cache content.
		// example:
		//		To ask dojo.cache to fetch content and store it in the cache (the dojo["cache"] style
		//		of call is used to avoid an issue with the build system erroneously trying to intern
		//		this example. To get the build system to intern your dojo.cache calls, use the
		//		"dojo.cache" style of call):
		//		| //If template.html contains "<h1>Hello</h1>" that will be
		//		| //the value for the text variable.
		//		| //Note: This is pre-AMD, deprecated syntax
		//		| var text = dojo["cache"]("my.module", "template.html");
		// example:
		//		To ask dojo.cache to fetch content and store it in the cache, and sanitize the input
		//		 (the dojo["cache"] style of call is used to avoid an issue with the build system
		//		erroneously trying to intern this example. To get the build system to intern your
		//		dojo.cache calls, use the "dojo.cache" style of call):
		//		| //If template.html contains "<html><body><h1>Hello</h1></body></html>", the
		//		| //text variable will contain just "<h1>Hello</h1>".
		//		| //Note: This is pre-AMD, deprecated syntax
		//		| var text = dojo["cache"]("my.module", "template.html", {sanitize: true});
		// example:
		//		Same example as previous, but demonstrates how an object can be passed in as
		//		the first argument, then the value argument can then be the second argument.
		//		| //If template.html contains "<html><body><h1>Hello</h1></body></html>", the
		//		| //text variable will contain just "<h1>Hello</h1>".
		//		| //Note: This is pre-AMD, deprecated syntax
		//		| var text = dojo["cache"](new dojo._Url("my/module/template.html"), {sanitize: true});

		//	 * (string string [value]) => (module, url, value)
		//	 * (object [value])        => (module, value), url defaults to ""
		//
		//	 * if module is an object, then it must be convertable to a string
		//	 * (module, url) module + (url ? ("/" + url) : "") must be a legal argument to require.toUrl
		//	 * value may be a string or an object; if an object then may have the properties "value" and/or "sanitize"
		var key;
		if(typeof module=="string"){
			if(/\//.test(module)){
				// module is a version 1.7+ resolved path
				key = module;
				value = url;
			}else{
				// module is a version 1.6- argument to dojo.moduleUrl
				key = require.toUrl(module.replace(/\./g, "/") + (url ? ("/" + url) : ""));
			}
		}else{
			key = module + "";
			value = url;
		}
		var
			val = (value != undefined && typeof value != "string") ? value.value : value,
			sanitize = value && value.sanitize;

		if(typeof val == "string"){
			//We have a string, set cache value
			theCache[key] = val;
			return sanitize ? strip(val) : val;
		}else if(val === null){
			//Remove cached value
			delete theCache[key];
			return null;
		}else{
			//Allow cache values to be empty strings. If key property does
			//not exist, fetch it.
			if(!(key in theCache)){
				getText(key, true, function(text){
					theCache[key]= text;
				});
			}
			return sanitize ? strip(theCache[key]) : theCache[key];
		}
	};

	return {
		// summary:
		//		This module implements the dojo/text! plugin and the dojo.cache API.
		// description:
		//		We choose to include our own plugin to leverage functionality already contained in dojo
		//		and thereby reduce the size of the plugin compared to various foreign loader implementations.
		//		Also, this allows foreign AMD loaders to be used without their plugins.
		//
		//		CAUTION: this module is designed to optionally function synchronously to support the dojo v1.x synchronous
		//		loader. This feature is outside the scope of the CommonJS plugins specification.

		// the dojo/text caches it's own resources because of dojo.cache
		dynamic: true,

		normalize: function(id, toAbsMid){
			// id is something like (path may be relative):
			//
			//	 "path/to/text.html"
			//	 "path/to/text.html!strip"
			var parts= id.split("!"),
				url= parts[0];
			return (/^\./.test(url) ? toAbsMid(url) : url) + (parts[1] ? "!" + parts[1] : "");
		},

		load: function(id, require, load){
			// id: String
			//		Path to the resource.
			// require: Function
			//		Object that include the function toUrl with given id returns a valid URL from which to load the text.
			// load: Function
			//		Callback function which will be called, when the loading finished.

			// id is something like (path is always absolute):
			//
			//	 "path/to/text.html"
			//	 "path/to/text.html!strip"
			var
				parts= id.split("!"),
				stripFlag= parts.length>1,
				absMid= parts[0],
				url = require.toUrl(parts[0]),
				requireCacheUrl = "url:" + url,
				text = notFound,
				finish = function(text){
					load(stripFlag ? strip(text) : text);
				};
			if(absMid in theCache){
				text = theCache[absMid];
			}else if(require.cache && requireCacheUrl in require.cache){
				text = require.cache[requireCacheUrl];
			}else if(url in theCache){
				text = theCache[url];
			}
			if(text===notFound){
				if(pending[url]){
					pending[url].push(finish);
				}else{
					var pendingList = pending[url] = [finish];
					getText(url, !require.async, function(text){
						theCache[absMid]= theCache[url]= text;
						for(var i = 0; i<pendingList.length;){
							pendingList[i++](text);
						}
						delete pending[url];
					});
				}
			}else{
				finish(text);
			}
		}
	};

});


},
'dojo/_base/kernel':function(){
define(["../global", "../has", "./config", "require", "module"], function(global, has, config, require, module){
	// module:
	//		dojo/_base/kernel

	// This module is the foundational module of the dojo boot sequence; it defines the dojo object.

	var
		// loop variables for this module
		i, p,

		// create dojo, dijit, and dojox
		// FIXME: in 2.0 remove dijit, dojox being created by dojo
		dijit = {},
		dojox = {},
		dojo = {
			// summary:
			//		This module is the foundational module of the dojo boot sequence; it defines the dojo object.

			// notice dojo takes ownership of the value of the config module
			config:config,
			global:global,
			dijit:dijit,
			dojox:dojox
		};


	// Configure the scope map. For a 100% AMD application, the scope map is not needed other than to provide
	// a _scopeName property for the dojo, dijit, and dojox root object so those packages can create
	// unique names in the global space.
	//
	// Built, legacy modules use the scope map to allow those modules to be expressed as if dojo, dijit, and dojox,
	// where global when in fact they are either global under different names or not global at all. In v1.6-, the
	// config variable "scopeMap" was used to map names as used within a module to global names. This has been
	// subsumed by the AMD map configuration variable which can relocate packages to different names. For backcompat,
	// only the "*" mapping is supported. See http://livedocs.dojotoolkit.org/developer/design/loader#legacy-cross-domain-mode for details.
	//
	// The following computations contort the packageMap for this dojo instance into a scopeMap.
	var scopeMap =
			// a map from a name used in a legacy module to the (global variable name, object addressed by that name)
			// always map dojo, dijit, and dojox
			{
				dojo:["dojo", dojo],
				dijit:["dijit", dijit],
				dojox:["dojox", dojox]
			},

		packageMap =
			// the package map for this dojo instance; note, a foreign loader or no pacakgeMap results in the above default config
			(require.map && require.map[module.id.match(/[^\/]+/)[0]]),

		item;


	// process all mapped top-level names for this instance of dojo
	for(p in packageMap){
		if(scopeMap[p]){
			// mapped dojo, dijit, or dojox
			scopeMap[p][0] = packageMap[p];
		}else{
			// some other top-level name
			scopeMap[p] = [packageMap[p], {}];
		}
	}

	// publish those names to _scopeName and, optionally, the global namespace
	for(p in scopeMap){
		item = scopeMap[p];
		item[1]._scopeName = item[0];
		if(!config.noGlobals){
			global[item[0]] = item[1];
		}
	}
	dojo.scopeMap = scopeMap;

	/*===== dojo.__docParserConfigureScopeMap(scopeMap); =====*/

	// FIXME: dojo.baseUrl and dojo.config.baseUrl should be deprecated
	dojo.baseUrl = dojo.config.baseUrl = require.baseUrl;
	dojo.isAsync = ! 1  || require.async;
	dojo.locale = config.locale;

	var rev = "$Rev:$".match(/[0-9a-f]{7,}/);
	dojo.version = {
		// summary:
		//		Version number of the Dojo Toolkit
		// description:
		//		Hash about the version, including
		//
		//		- major: Integer: Major version. If total version is "1.2.0beta1", will be 1
		//		- minor: Integer: Minor version. If total version is "1.2.0beta1", will be 2
		//		- patch: Integer: Patch version. If total version is "1.2.0beta1", will be 0
		//		- flag: String: Descriptor flag. If total version is "1.2.0beta1", will be "beta1"
		//		- revision: Number: The Git rev from which dojo was pulled

		major: 1, minor: 17, patch: 3, flag: "",
		revision: rev ? rev[0] : NaN,
		toString: function(){
			var v = dojo.version;
			return v.major + "." + v.minor + "." + v.patch + v.flag + " (" + v.revision + ")";	// String
		}
	};

	// If  1  is truthy, then as a dojo module is defined it should push it's definitions
	// into the dojo object, and conversely. In 2.0, it will likely be unusual to augment another object
	// as a result of defining a module. This has feature gives a way to force 2.0 behavior as the code
	// is migrated. Absent specific advice otherwise, set extend-dojo to truthy.
	 1 || has.add("extend-dojo", 1);

	if(!has("csp-restrictions")){
		(Function("d", "d.eval = function(){return d.global.eval ? d.global.eval(arguments[0]) : eval(arguments[0]);}"))(dojo);
	}
	/*=====
	dojo.eval = function(scriptText){
		// summary:
		//		A legacy method created for use exclusively by internal Dojo methods. Do not use this method
		//		directly unless you understand its possibly-different implications on the platforms your are targeting.
		// description:
		//		Makes an attempt to evaluate scriptText in the global scope. The function works correctly for browsers
		//		that support indirect eval.
		//
		//		As usual, IE does not. On IE, the only way to implement global eval is to
		//		use execScript. Unfortunately, execScript does not return a value and breaks some current usages of dojo.eval.
		//		This implementation uses the technique of executing eval in the scope of a function that is a single scope
		//		frame below the global scope; thereby coming close to the global scope. Note carefully that
		//
		//		dojo.eval("var pi = 3.14;");
		//
		//		will define global pi in non-IE environments, but define pi only in a temporary local scope for IE. If you want
		//		to define a global variable using dojo.eval, write something like
		//
		//		dojo.eval("window.pi = 3.14;")
		// scriptText:
		//		The text to evaluation.
		// returns:
		//		The result of the evaluation. Often `undefined`
	};
	=====*/


	if( 0 ){
		dojo.exit = function(exitcode){
			quit(exitcode);
		};
	}else{
		dojo.exit = function(){
		};
	}

	if(!has("host-webworker")){
		// console is immutable in FF30+, https://bugs.dojotoolkit.org/ticket/18100
		 1 || has.add("dojo-guarantee-console",
			// ensure that console.log, console.warn, etc. are defined
			1
		);
	}

	if( 1 ){
		// IE 9 bug: https://bugs.dojotoolkit.org/ticket/18197
		has.add("console-as-object", function () {
			return Function.prototype.bind && console && typeof console.log === "object";
		});

		typeof console != "undefined" || (console = {});  // intentional assignment
		//	Be careful to leave 'log' always at the end
		var cn = [
			"assert", "count", "debug", "dir", "dirxml", "error", "group",
			"groupEnd", "info", "profile", "profileEnd", "time", "timeEnd",
			"trace", "warn", "log"
		];
		var tn;
		i = 0;
		while((tn = cn[i++])){
			if(!console[tn]){
				(function(){
					var tcn = tn + "";
					console[tcn] = ('log' in console) ? function(){
						var a = Array.prototype.slice.call(arguments);
						a.unshift(tcn + ":");
						console["log"](a.join(" "));
					} : function(){};
					console[tcn]._fake = true;
				})();
			}else if(has("console-as-object")){
				console[tn] = Function.prototype.bind.call(console[tn], console);
			}
		}
	}

	 0 && has.add("dojo-debug-messages",
		// include dojo.deprecated/dojo.experimental implementations
		!!config.isDebug
	);
	dojo.deprecated = dojo.experimental =  function(){};
	if( 0 ){
		dojo.deprecated = function(/*String*/ behaviour, /*String?*/ extra, /*String?*/ removal){
			// summary:
			//		Log a debug message to indicate that a behavior has been
			//		deprecated.
			// behaviour: String
			//		The API or behavior being deprecated. Usually in the form
			//		of "myApp.someFunction()".
			// extra: String?
			//		Text to append to the message. Often provides advice on a
			//		new function or facility to achieve the same goal during
			//		the deprecation period.
			// removal: String?
			//		Text to indicate when in the future the behavior will be
			//		removed. Usually a version number.
			// example:
			//	| dojo.deprecated("myApp.getTemp()", "use myApp.getLocaleTemp() instead", "1.0");

			var message = "DEPRECATED: " + behaviour;
			if(extra){ message += " " + extra; }
			if(removal){ message += " -- will be removed in version: " + removal; }
			console.warn(message);
		};

		dojo.experimental = function(/* String */ moduleName, /* String? */ extra){
			// summary:
			//		Marks code as experimental.
			// description:
			//		This can be used to mark a function, file, or module as
			//		experimental.	 Experimental code is not ready to be used, and the
			//		APIs are subject to change without notice.	Experimental code may be
			//		completed deleted without going through the normal deprecation
			//		process.
			// moduleName: String
			//		The name of a module, or the name of a module file or a specific
			//		function
			// extra: String?
			//		some additional message for the user
			// example:
			//	| dojo.experimental("dojo.data.Result");
			// example:
			//	| dojo.experimental("dojo.weather.toKelvin()", "PENDING approval from NOAA");

			var message = "EXPERIMENTAL: " + moduleName + " -- APIs subject to change without notice.";
			if(extra){ message += " " + extra; }
			console.warn(message);
		};
	}

	 0 && has.add("dojo-modulePaths",
		// consume dojo.modulePaths processing
		1
	);
	if( 0 ){
		// notice that modulePaths won't be applied to any require's before the dojo/_base/kernel factory is run;
		// this is the v1.6- behavior.
		if(config.modulePaths){
			dojo.deprecated("dojo.modulePaths", "use paths configuration");
			var paths = {};
			for(p in config.modulePaths){
				paths[p.replace(/\./g, "/")] = config.modulePaths[p];
			}
			require({paths:paths});
		}
	}

	 0 && has.add("dojo-moduleUrl",
		// include dojo.moduleUrl
		1
	);
	if( 0 ){
		dojo.moduleUrl = function(/*String*/module, /*String?*/url){
			// summary:
			//		Returns a URL relative to a module.
			// example:
			//	|	var pngPath = dojo.moduleUrl("acme","images/small.png");
			//	|	console.dir(pngPath); // list the object properties
			//	|	// create an image and set it's source to pngPath's value:
			//	|	var img = document.createElement("img");
			//	|	img.src = pngPath;
			//	|	// add our image to the document
			//	|	dojo.body().appendChild(img);
			// example:
			//		you may de-reference as far as you like down the package
			//		hierarchy.  This is sometimes handy to avoid lengthy relative
			//		urls or for building portable sub-packages. In this example,
			//		the `acme.widget` and `acme.util` directories may be located
			//		under different roots (see `dojo.registerModulePath`) but the
			//		the modules which reference them can be unaware of their
			//		relative locations on the filesystem:
			//	|	// somewhere in a configuration block
			//	|	dojo.registerModulePath("acme.widget", "../../acme/widget");
			//	|	dojo.registerModulePath("acme.util", "../../util");
			//	|
			//	|	// ...
			//	|
			//	|	// code in a module using acme resources
			//	|	var tmpltPath = dojo.moduleUrl("acme.widget","templates/template.html");
			//	|	var dataPath = dojo.moduleUrl("acme.util","resources/data.json");

			dojo.deprecated("dojo.moduleUrl()", "use require.toUrl", "2.0");

			// require.toUrl requires a filetype; therefore, just append the suffix "/*.*" to guarantee a filetype, then
			// remove the suffix from the result. This way clients can request a url w/out a filetype. This should be
			// rare, but it maintains backcompat for the v1.x line (note: dojo.moduleUrl will be removed in v2.0).
			// Notice * is an illegal filename so it won't conflict with any real path map that may exist the paths config.
			var result = null;
			if(module){
				result = require.toUrl(module.replace(/\./g, "/") + (url ? ("/" + url) : "") + "/*.*").replace(/\/\*\.\*/, "") + (url ? "" : "/");
			}
			return result;
		};
	}

	dojo._hasResource = {}; // for backward compatibility with layers built with 1.6 tooling

	return dojo;
});

},
'dojo/global':function(){
define(function(){
    if (typeof global !== 'undefined' && typeof global !== 'function') {
        // global spec defines a reference to the global object called 'global'
        // https://github.com/tc39/proposal-global
        // `global` is also defined in NodeJS
        return global;
    }
    else if (typeof window !== 'undefined') {
        // window is defined in browsers
        return window;
    }
    else if (typeof self !== 'undefined') {
        // self is defined in WebWorkers
        return self;
    }
    return this;
});

},
'dojo/has':function(){
define(["./global", "require", "module"], function(global, require, module){
	// module:
	//		dojo/has
	// summary:
	//		Defines the has.js API and several feature tests used by dojo.
	// description:
	//		This module defines the has API as described by the project has.js with the following additional features:
	//
	//		- the has test cache is exposed at has.cache.
	//		- the method has.add includes a forth parameter that controls whether or not existing tests are replaced
	//		- the loader's has cache may be optionally copied into this module's has cahce.
	//
	//		This module adopted from https://github.com/phiggins42/has.js; thanks has.js team!

	// try to pull the has implementation from the loader; both the dojo loader and bdLoad provide one
	// if using a foreign loader, then the has cache may be initialized via the config object for this module
	// WARNING: if a foreign loader defines require.has to be something other than the has.js API, then this implementation fail
	var has = require.has || function(){};
	if(! 1 ){
		var
			isBrowser =
				// the most fundamental decision: are we in the browser?
				typeof window != "undefined" &&
				typeof location != "undefined" &&
				typeof document != "undefined" &&
				window.location == location && window.document == document,

			// has API variables
			doc = isBrowser && document,
			element = doc && doc.createElement("DiV"),
			cache = (module.config && module.config()) || {};

		has = function(name){
			// summary:
			//		Return the current value of the named feature.
			//
			// name: String|Integer
			//		The name (if a string) or identifier (if an integer) of the feature to test.
			//
			// description:
			//		Returns the value of the feature named by name. The feature must have been
			//		previously added to the cache by has.add.

			return typeof cache[name] == "function" ? (cache[name] = cache[name](global, doc, element)) : cache[name]; // Boolean
		};

		has.cache = cache;

		has.add = function(name, test, now, force){
			// summary:
			//	 	Register a new feature test for some named feature.
			// name: String|Integer
			//	 	The name (if a string) or identifier (if an integer) of the feature to test.
			// test: Function
			//		 A test function to register. If a function, queued for testing until actually
			//		 needed. The test function should return a boolean indicating
			//	 	the presence of a feature or bug.
			// now: Boolean?
			//		 Optional. Omit if `test` is not a function. Provides a way to immediately
			//		 run the test and cache the result.
			// force: Boolean?
			//	 	Optional. If the test already exists and force is truthy, then the existing
			//	 	test will be replaced; otherwise, add does not replace an existing test (that
			//	 	is, by default, the first test advice wins).
			// example:
			//		A redundant test, testFn with immediate execution:
			//	|	has.add("javascript", function(){ return true; }, true);
			//
			// example:
			//		Again with the redundantness. You can do this in your tests, but we should
			//		not be doing this in any internal has.js tests
			//	|	has.add("javascript", true);
			//
			// example:
			//		Three things are passed to the testFunction. `global`, `document`, and a generic element
			//		from which to work your test should the need arise.
			//	|	has.add("bug-byid", function(g, d, el){
			//	|		// g	== global, typically window, yadda yadda
			//	|		// d	== document object
			//	|		// el == the generic element. a `has` element.
			//	|		return false; // fake test, byid-when-form-has-name-matching-an-id is slightly longer
			//	|	});

			(typeof cache[name]=="undefined" || force) && (cache[name]= test);
			return now && has(name);
		};

		// since we're operating under a loader that doesn't provide a has API, we must explicitly initialize
		// has as it would have otherwise been initialized by the dojo loader; use has.add to the builder
		// can optimize these away iff desired
		 1 || has.add("host-browser", isBrowser);
		 0 && has.add("host-node", (typeof process == "object" && process.versions && process.versions.node && process.versions.v8));
		 0 && has.add("host-rhino", (typeof load == "function" && (typeof Packages == "function" || typeof Packages == "object")));
		 1 || has.add("dom", isBrowser);
		 1 || has.add("dojo-dom-ready-api", 1);
		 1 || has.add("dojo-sniff", 1);
	}

	if( 1 ){
		// Common application level tests
		has.add("dom-addeventlistener", !!document.addEventListener);

		// Do the device and browser have touch capability?
		has.add("touch", "ontouchstart" in document
			|| ("onpointerdown" in document && navigator.maxTouchPoints > 0)
			|| window.navigator.msMaxTouchPoints);

		// Touch events support
		has.add("touch-events", "ontouchstart" in document);

		// Test if pointer events are supported and enabled, with either standard names ("pointerdown" etc.) or
		// IE specific names ("MSPointerDown" etc.).  Tests are designed to work on embedded C# WebBrowser Controls
		// in addition to IE, Edge, and future versions of Firefox and Chrome.
		// Note that on IE11, has("pointer-events") and has("MSPointer") are both true.
		has.add("pointer-events", "pointerEnabled" in window.navigator ?
				window.navigator.pointerEnabled : "PointerEvent" in window);
		has.add("MSPointer", window.navigator.msPointerEnabled);
		// The "pointermove"" event is only continuously emitted in a touch environment if
		// the target node's "touch-action"" CSS property is set to "none"
		// https://www.w3.org/TR/pointerevents/#the-touch-action-css-property
		has.add("touch-action", has("touch") && has("pointer-events"));

		// I don't know if any of these tests are really correct, just a rough guess
		has.add("device-width", screen.availWidth || innerWidth);

		// Tests for DOMNode.attributes[] behavior:
		//	 - dom-attributes-explicit - attributes[] only lists explicitly user specified attributes
		//	 - dom-attributes-specified-flag (IE8) - need to check attr.specified flag to skip attributes user didn't specify
		//	 - Otherwise, in IE6-7. attributes[] will list hundreds of values, so need to do outerHTML to get attrs instead.
		var form = document.createElement("form");
		has.add("dom-attributes-explicit", form.attributes.length == 0); // W3C
		has.add("dom-attributes-specified-flag", form.attributes.length > 0 && form.attributes.length < 40);	// IE8
	}

	has.clearElement = function(element){
		// summary:
		//	 Deletes the contents of the element passed to test functions.
		element.innerHTML= "";
		return element;
	};

	has.normalize = function(id, toAbsMid){
		// summary:
		//	 Resolves id into a module id based on possibly-nested tenary expression that branches on has feature test value(s).
		//
		// toAbsMid: Function
		//	 Resolves a relative module id into an absolute module id
		var
			tokens = id.match(/[\?:]|[^:\?]*/g), i = 0,
			get = function(skip){
				var term = tokens[i++];
				if(term == ":"){
					// empty string module name, resolves to 0
					return 0;
				}else{
					// postfixed with a ? means it is a feature to branch on, the term is the name of the feature
					if(tokens[i++] == "?"){
						if(!skip && has(term)){
							// matched the feature, get the first value from the options
							return get();
						}else{
							// did not match, get the second value, passing over the first
							get(true);
							return get(skip);
						}
					}
					// a module
					return term || 0;
				}
			};
		id = get();
		return id && toAbsMid(id);
	};

	has.load = function(id, parentRequire, loaded){
		// summary:
		//		Conditional loading of AMD modules based on a has feature test value.
		// id: String
		//		Gives the resolved module id to load.
		// parentRequire: Function
		//		The loader require function with respect to the module that contained the plugin resource in it's
		//		dependency list.
		// loaded: Function
		//	 Callback to loader that consumes result of plugin demand.

		if(id){
			parentRequire([id], loaded);
		}else{
			loaded();
		}
	};

	return has;
});

},
'dojo/_base/config':function(){
define(["../global", "../has", "require"], function(global, has, require){
	// module:
	//		dojo/_base/config

/*=====
return {
	// summary:
	//		This module defines the user configuration during bootstrap.
	// description:
	//		By defining user configuration as a module value, an entire configuration can be specified in a build,
	//		thereby eliminating the need for sniffing and or explicitly setting in the global variable dojoConfig.
	//		Also, when multiple instances of dojo exist in a single application, each will necessarily be located
	//		at an unique absolute module identifier as given by the package configuration. Implementing configuration
	//		as a module allows for specifying unique, per-instance configurations.
	// example:
	//		Create a second instance of dojo with a different, instance-unique configuration (assume the loader and
	//		dojo.js are already loaded).
	//		|	// specify a configuration that creates a new instance of dojo at the absolute module identifier "myDojo"
	//		|	require({
	//		|		packages:[{
	//		|			name:"myDojo",
	//		|			location:".", //assume baseUrl points to dojo.js
	//		|		}]
	//		|	});
	//		|
	//		|	// specify a configuration for the myDojo instance
	//		|	define("myDojo/config", {
	//		|		// normal configuration variables go here, e.g.,
	//		|		locale:"fr-ca"
	//		|	});
	//		|
	//		|	// load and use the new instance of dojo
	//		|	require(["myDojo"], function(dojo){
	//		|		// dojo is the new instance of dojo
	//		|		// use as required
	//		|	});

	// isDebug: Boolean
	//		Defaults to `false`. If set to `true`, ensures that Dojo provides
	//		extended debugging feedback to the console.
	isDebug: false,

	// locale: String
	//		The locale to assume for loading localized resources in this page,
	//		specified according to [RFC 3066](http://www.ietf.org/rfc/rfc3066.txt).
	//		Must be specified entirely in lowercase, e.g. `en-us` and `zh-cn`.
	//		See the documentation for `dojo.i18n` and `dojo.requireLocalization`
	//		for details on loading localized resources. If no locale is specified,
	//		Dojo assumes the locale of the user agent, according to `navigator.userLanguage`
	//		or `navigator.language` properties.
	locale: undefined,

	// extraLocale: Array
	//		No default value. Specifies additional locales whose
	//		resources should also be loaded alongside the default locale when
	//		calls to `dojo.requireLocalization()` are processed.
	extraLocale: undefined,

	// baseUrl: String
	//		The directory in which `dojo.js` is located. Under normal
	//		conditions, Dojo auto-detects the correct location from which it
	//		was loaded. You may need to manually configure `baseUrl` in cases
	//		where you have renamed `dojo.js` or in which `<base>` tags confuse
	//		some browsers (e.g. IE 6). The variable `dojo.baseUrl` is assigned
	//		either the value of `djConfig.baseUrl` if one is provided or the
	//		auto-detected root if not. Other modules are located relative to
	//		this path. The path should end in a slash.
	baseUrl: undefined,

	// modulePaths: [deprecated] Object
	//		A map of module names to paths relative to `dojo.baseUrl`. The
	//		key/value pairs correspond directly to the arguments which
	//		`dojo.registerModulePath` accepts. Specifying
	//		`djConfig.modulePaths = { "foo": "../../bar" }` is the equivalent
	//		of calling `dojo.registerModulePath("foo", "../../bar");`. Multiple
	//		modules may be configured via `djConfig.modulePaths`.
	modulePaths: {},

	// addOnLoad: Function|Array
	//		Adds a callback via dojo/ready. Useful when Dojo is added after
	//		the page loads and djConfig.afterOnLoad is true. Supports the same
	//		arguments as dojo/ready. When using a function reference, use
	//		`djConfig.addOnLoad = function(){};`. For object with function name use
	//		`djConfig.addOnLoad = [myObject, "functionName"];` and for object with
	//		function reference use
	//		`djConfig.addOnLoad = [myObject, function(){}];`
	addOnLoad: null,

	// parseOnLoad: Boolean
	//		Run the parser after the page is loaded
	parseOnLoad: false,

	// require: String[]
	//		An array of module names to be loaded immediately after dojo.js has been included
	//		in a page.
	require: [],

	// defaultDuration: Number
	//		Default duration, in milliseconds, for wipe and fade animations within dijits.
	//		Assigned to dijit.defaultDuration.
	defaultDuration: 200,

	// dojoBlankHtmlUrl: String
	//		Used by some modules to configure an empty iframe. Used by dojo/io/iframe and
	//		dojo/back, and dijit/popup support in IE where an iframe is needed to make sure native
	//		controls do not bleed through the popups. Normally this configuration variable
	//		does not need to be set, except when using cross-domain/CDN Dojo builds.
	//		Save dojo/resources/blank.html to your domain and set `djConfig.dojoBlankHtmlUrl`
	//		to the path on your domain your copy of blank.html.
	dojoBlankHtmlUrl: undefined,

	// ioPublish: Boolean?
	//		Set this to true to enable publishing of topics for the different phases of
	//		IO operations. Publishing is done via dojo/topic.publish(). See dojo/main.__IoPublish for a list
	//		of topics that are published.
	ioPublish: false,

	// transparentColor: Array
	//		Array containing the r, g, b components used as transparent color in dojo.Color;
	//		if undefined, [255,255,255] (white) will be used.
	transparentColor: undefined,
	
	// deps: Function|Array
	//		Defines dependencies to be used before the loader has been loaded.
	//		When provided, they cause the loader to execute require(deps, callback) 
	//		once it has finished loading. Should be used with callback.
	deps: undefined,
	
	// callback: Function|Array
	//		Defines a callback to be used when dependencies are defined before 
	//		the loader has been loaded. When provided, they cause the loader to 
	//		execute require(deps, callback) once it has finished loading. 
	//		Should be used with deps.
	callback: undefined,
	
	// deferredInstrumentation: Boolean
	//		Whether deferred instrumentation should be loaded or included
	//		in builds.
	deferredInstrumentation: true,

	// useDeferredInstrumentation: Boolean|String
	//		Whether the deferred instrumentation should be used.
	//
	//		* `"report-rejections"`: report each rejection as it occurs.
	//		* `true` or `1` or `"report-unhandled-rejections"`: wait 1 second
	//			in an attempt to detect unhandled rejections.
	useDeferredInstrumentation: "report-unhandled-rejections"
};
=====*/

	var result = {};
	if( 1 ){
		// must be the dojo loader; take a shallow copy of require.rawConfig
		var src = require.rawConfig, p;
		for(p in src){
			result[p] = src[p];
		}
	}else{
		var adviseHas = function(featureSet, prefix, booting){
			for(p in featureSet){
				p!="has" && has.add(prefix + p, featureSet[p], 0, booting);
			}
		};
		result =  1  ?
			// must be a built version of the dojo loader; all config stuffed in require.rawConfig
			require.rawConfig :
			// a foreign loader
			global.dojoConfig || global.djConfig || {};
		adviseHas(result, "config", 1);
		adviseHas(result.has, "", 1);
	}

	if(!result.locale && typeof navigator != "undefined"){
		// Default locale for browsers (ensure it's read from user-settings not download locale).
		var language = (navigator.languages && navigator.languages.length) ? navigator.languages[0] :
			(navigator.language || navigator.userLanguage);
		if(language){
			result.locale = language.toLowerCase();
		}
	}

	return result;
});


},
'dojo/request':function(){
define([
	'./request/default!'/*=====,
	'./_base/declare',
	'./promise/Promise' =====*/
], function(request/*=====, declare, Promise =====*/){
	/*=====
	request = function(url, options){
		// summary:
		//		Send a request using the default transport for the current platform.
		// url: String
		//		The URL to request.
		// options: dojo/request.__Options?
		//		Options for the request.
		// returns: dojo/request.__Promise
	};
	request.__Promise = declare(Promise, {
		// response: dojo/promise/Promise
		//		A promise resolving to an object representing
		//		the response from the server.
	});
	request.__BaseOptions = declare(null, {
		// query: String|Object?
		//		Query parameters to append to the URL.
		// data: String|Object?
		//		Data to transfer.  This is ignored for GET and DELETE
		//		requests.
		// preventCache: Boolean?
		//		Whether to append a cache-busting parameter to the URL.
		// timeout: Integer?
		//		Milliseconds to wait for the response.  If this time
		//		passes, the then the promise is rejected.
		// handleAs: String?
		//		How to handle the response from the server.  Default is
		//		'text'.  Other values are 'json', 'javascript', and 'xml'.
	});
	request.__MethodOptions = declare(null, {
		// method: String?
		//		The HTTP method to use to make the request.  Must be
		//		uppercase.
	});
	request.__Options = declare([request.__BaseOptions, request.__MethodOptions]);

	request.get = function(url, options){
		// summary:
		//		Send an HTTP GET request using the default transport for the current platform.
		// url: String
		//		URL to request
		// options: dojo/request.__BaseOptions?
		//		Options for the request.
		// returns: dojo/request.__Promise
	};
	request.post = function(url, options){
		// summary:
		//		Send an HTTP POST request using the default transport for the current platform.
		// url: String
		//		URL to request
		// options: dojo/request.__BaseOptions?
		//		Options for the request.
		// returns: dojo/request.__Promise
	};
	request.put = function(url, options){
		// summary:
		//		Send an HTTP POST request using the default transport for the current platform.
		// url: String
		//		URL to request
		// options: dojo/request.__BaseOptions?
		//		Options for the request.
		// returns: dojo/request.__Promise
	};
	request.del = function(url, options){
		// summary:
		//		Send an HTTP DELETE request using the default transport for the current platform.
		// url: String
		//		URL to request
		// options: dojo/request.__BaseOptions?
		//		Options for the request.
		// returns: dojo/request.__Promise
	};
	=====*/
	return request;
});

},
'dojo/request/default':function(){
define([
	'exports',
	'require',
	'../has'
], function(exports, require, has){
	var defId = has('config-requestProvider'),
		platformId;

	if( 1  || has('host-webworker')){
		platformId = './xhr';
	}else if( 0 ){
		platformId = './node';
	/* TODO:
	}else if( 0 ){
		platformId = './rhino';
   */
	}

	if(!defId){
		defId = platformId;
	}

	exports.getPlatformDefaultId = function(){
		return platformId;
	};

	exports.load = function(id, parentRequire, loaded, config){
		require([id == 'platform' ? platformId : defId], function(provider){
			loaded(provider);
		});
	};
});

},
'appivo/vue/components/TextBox':function(){
define([
  'vue/vue',
  './ValidationMixin',
  'dojo/text!../html/TextBox.html'
], function(Vue, ValidationMixin, template) {
	
	return Vue.extend({
		data: function() {
			return {
				previouslyChangedValue: this.value,
				showValidationMessage: this.enablestartupvalidationmessage
			};
		},
		template: template,
		mixins: [ValidationMixin],
		props: {
			value: [String, Number],
			style: Object,
			classes: {
				type: Array,
				"default": function(){
                    return [];
                }
			},
			placeholder: {
				type: String,
				"default": ""
			},
			errorposition: String,
			multiline: {
				type: Boolean,
				"default": false
			},
			id: {
				type: String,
				"default": undefined
			},
			type: {
				type: String,
				"default": "text"
			},
			min: {
				type: Number,
				"default": -9999999
			},
			max: {
				type: Number,
				"default": 9999999
			},
			required: {
				type: String,
				"default": ""
			},
			enablestartupvalidation: {
				type: Boolean,
				"default": true
			},
			enablestartupvalidationmessage: {
				type: Boolean,
				"default": false
			},
			disabled: {
				type: Boolean,
				"default": false
			},
			rows: {
			    type: [Number, String],
			    "default": 3
			},
			autocomplete: {
			    type: String,
			    "default": null
			}
		},		
		computed: {
			styles: function() {
				var s = this.style ? this.style : {};
				if (this.multiline) {
					s.resize = 'none';
				}
				return s;
			},
			internalClasses: function() {
				var obj = {};
				for (var i = 0; i < this.classes.length; i++) {
					var cls = this.classes[i];
					obj[cls] = true
				}
				obj.invalid = !this.valid;
				return obj;
			},
			maxLength: function() {
				var len = "";
				if (this.validation && this.validation.maxLength) {
					len = this.validation.maxLength;
				}
				return len;
			},
			inputValue: function() {
			    return this.value !== null && this.value !== undefined ? '' + this.value : '';
			}
		},
		methods: {
			valueChanged: function() {
				var val = this.$els.input.value;
				switch (this.type) {
                case 'number':
                    val = parseFloat(val);
                    break;
				}
				var id = this.id;
				var event = document.createEvent('Event');
				event.initEvent('update', true, true);
				event.value = val;
				event.sourceId = id;
				this.$el.dispatchEvent(event);
				this.previouslyChangedValue = val;
				this.showValidationMessage = true;
			},
			focus: function() {
				this.$els.input.focus();
			},
			inputChange: function(event) {
				var val = event.target.value;
				this.validate(val);
				this.showValidationMessage = true;
			},
			refreshValidation: function() {
				this.validate(this.previouslyChangedValue);
				this.showValidationMessage = true;
			}
		},
		watch: {
		    'value': function(val) {
				this.valueChanged();
			}
		},
		events: {
		    'TextBox': function(opts) {
		        switch (opts.cmd) {
                case 'ResetValidation':
                    this.cachedValue = null;
				    this.validate(this.value);
				    this.showValidationMessage = false;
                    break;
				case 'RefreshValidation':
					this.validate(this.previouslyChangedValue);
					this.showValidationMessage = true;
					break;
		        }
		    }
		},
		ready: function() {
			if (this.enablestartupvalidation) {
				this.validate(this.value);
			}
        }
	});
});

},
'appivo/vue/components/ValidationMixin':function(){
define([
  'vue/vue',
  'vue/vue-strap',
  'dojo/i18n!../nls/Validation'
], function(Vue, VueStrap, messages) {

	var pattern = {
		alphaNumeric: new RegExp('^[0-9A-Za-zÀ-ÿ]+$'),
		alphaNumericUnderScore: new RegExp('^[0-9A-Za-zÀ-ÿ_]+$'),
		alphaNumericSpace: new RegExp('^[0-9A-Za-zÀ-ÿ ]+$'),
		integer: new RegExp('^[0-9]+$'),
		email: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
		internationalPhoneNumber: new RegExp('^(\\+?[1-9])?\\d{1,14}$'),
		url: new RegExp("^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?"),
		domain: new RegExp("^[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9](\\.[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])*(\\.[a-zA-Z]{2,}){1,2}$"),
    	ipAddress: new RegExp("^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$")
	};

	var validate = function(validation, oldvalue, value, instance) {
		var result = {
			msg: null,
			valid: true,
			source: instance,
			options: validation
		};
		if (value != undefined && value != null) {
			if (validation.minLength) {
				if (value && value.length < validation.minLength) {
					result.valid = false;
					result.msg = messages.minLength;
				}
			}
			if (validation.maxLength) {
				if (value && value.length > validation.maxLength) {
					result.valid = false;
					result.msg = messages.maxLength;
				}
			}
			if (validation.alphaNumeric) {
				if (!pattern.alphaNumeric.test(value)) {
					result.valid = false;
					result.msg = messages.alphaNumeric;
				}
			}
			if (validation.alphaNumericUnderScore) {
				if (!pattern.alphaNumericUnderScore.test(value)) {
					result.valid = false;
					result.msg = messages.alphaNumericUnderScore;
				}
			}
			if (validation.alphaNumericSpace) {
				if (!pattern.alphaNumericSpace.test(value)) {
					result.valid = false;
					result.msg = messages.alphaNumericSpace;
				}
			}
			if (validation.integer) {
				if (!pattern.integer.test(value)) {
					result.valid = false;
					result.msg = messages.integer;
				} else {
					if (validation.max || validation.min) {
						try {
							var int = parseInt(value);
							if (validation.max != undefined && int > validation.max) {
								result.valid = false;
								result.msg = messages.aboveMax;
							}
							if (validation.min != undefined && int < validation.min) {
								result.valid = false;
								result.msg = messages.belowMin;
							}
						} catch (error) {

						}
					}
				}
			}
			if (validation.decimal) {
				if (isNaN(value)) {
					result.valid = false;
					result.msg = messages.decimal;
				} else {
					if (validation.max || validation.min) {
						try {
							var val = parseFloat(value);
							if (validation.max != undefined && val > validation.max) {
								result.valid = false;
								result.msg = messages.aboveMax;
							}
							if (validation.min != undefined && val < validation.min) {
								result.valid = false;
								result.msg = messages.belowMin;
							}
						} catch (error) {

						}
					}
				}
			}
			if (validation.email) {
				if (!pattern.email.test(value)) {
					result.valid = false;
					result.msg = messages.email;
				}
			}
			if (validation.internationalPhoneNumber) {
				if (!pattern.internationalPhoneNumber.test(value)) {
					result.valid = false;
					result.msg = messages.internationalPhoneNumber;
				}
			}
			if (validation.url) {
				if (!pattern.url.test(value)) {
					result.valid = false;
					result.msg = messages.url;
				}
			}
			if (validation.domain) {
				if (!pattern.domain.test(value)) {
					result.valid = false;
					result.msg = messages.domain;
				}
			}
      		if (validation.ipAddress) {
        		if (!pattern.ipAddress.test(value)) {
          			result.valid = false;
          			result.msg = messages.ipAddress;
        		}
      		}
			if (validation.pattern) {
				try {
					// nosemgrep: detect-non-literal-regexp
					var regex = new RegExp(validation.pattern);
					if (!regex.test(value)) {
						result.valid = false;
						result.msg = messages.custom;
					}
				} catch (error) {
					console.log("Warning! - invalid regex " + validation.pattern);
				}
			}
		}
		if (validation.custom) {
			if (typeof(validation.custom) === 'function') {
			    if (validation.async) {
			        validation.custom(value, oldvalue, result, instance).then(function(result){
			            if (!result.valid) {
			                instance.handleResult(result, value);
			            }
			        }, function(error){
			            console.error('failed async validation', this, error);
			        });
			    } else if (!validation.custom(value, oldvalue, result, instance)) {
					result.valid = false;
					if (!result.msg) {
						result.msg = messages.custom;
					}
					if (validation.overrideRequired) {
					    return result;
					}
				}
			}
		}
		if (validation.required) {
			if (!value) {
				result.valid = false;
				result.msg = messages.required;
			}
		} else if (!value) {
		    result.valid = true;
		}
		return result;
	};

	return {
		props: {
			valid: {
				type: Boolean,
				"default": true
			},
			cachedValue: {
				type: String,
				"default": ""
			},
			validationError: {
				type: String,
				"default": ""
			},
			validation: {
				type: Object,
				"default": function() {
					return {};
				}
			}
		},
		methods: {
			isValid: function() {
				return this.valid;
			},
			validate: function(value, oldvalue) {
				if (value && value.target) {
					value = value.target.value;
				}
				if (this.cachedValue == undefined || this.cachedValue == "" || this.cachedValue == null) {
					if (oldvalue != undefined) {
						this.cachedValue = oldvalue;
					} else {
						this.cachedValue = value;
					}
				}
				var res = validate(this.validation, this.cachedValue, value, this);
				this.handleResult(res, value);
			},
			handleResult: function(res, value){
			    var oldvalid = this.valid;
			    this.valid = res.valid;
                this.validationError = res.msg ? res.msg : "";
                if (this.valid != oldvalid) {
                    if (this.valid) {
                        this.$dispatch('valid', {
                            source: this,
                            value: value
                        });
                    } else {
                        this.$dispatch('invalid', {
                            source: this,
                            value: value
                        });
                    }
                }
			}
		},
		watch: {
		},
		components: {
			'tooltip': VueStrap.tooltip
		}
	};
});

},
'dojo/i18n':function(){
define(["./_base/kernel", "require", "./has", "./_base/array", "./_base/config", "./_base/lang", "./_base/xhr", "./json", "module"],
	function(dojo, require, has, array, config, lang, xhr, json, module){

	// module:
	//		dojo/i18n

	has.add("dojo-preload-i18n-Api",
		// if true, define the preload localizations machinery
		1
	);

	 1 || has.add("dojo-v1x-i18n-Api",
		// if true, define the v1.x i18n functions
		1
	);

	var
		thisModule = dojo.i18n =
			{
				// summary:
				//		This module implements the dojo/i18n! plugin and the v1.6- i18n API
				// description:
				//		We choose to include our own plugin to leverage functionality already contained in dojo
				//		and thereby reduce the size of the plugin compared to various loader implementations. Also, this
				//		allows foreign AMD loaders to be used without their plugins.
			},

		nlsRe =
			// regexp for reconstructing the master bundle name from parts of the regexp match
			// nlsRe.exec("foo/bar/baz/nls/en-ca/foo") gives:
			// ["foo/bar/baz/nls/en-ca/foo", "foo/bar/baz/nls/", "/", "/", "en-ca", "foo"]
			// nlsRe.exec("foo/bar/baz/nls/foo") gives:
			// ["foo/bar/baz/nls/foo", "foo/bar/baz/nls/", "/", "/", "foo", ""]
			// so, if match[5] is blank, it means this is the top bundle definition.
			// courtesy of http://requirejs.org
			/(^.*(^|\/)nls)(\/|$)([^\/]*)\/?([^\/]*)/,

		getAvailableLocales = function(
			root,
			locale,
			bundlePath,
			bundleName
		){
			// summary:
			//		return a vector of module ids containing all available locales with respect to the target locale
			//		For example, assuming:
			//
			//		- the root bundle indicates specific bundles for "fr" and "fr-ca",
			//		-  bundlePath is "myPackage/nls"
			//		- bundleName is "myBundle"
			//
			//		Then a locale argument of "fr-ca" would return
			//
			//			["myPackage/nls/myBundle", "myPackage/nls/fr/myBundle", "myPackage/nls/fr-ca/myBundle"]
			//
			//		Notice that bundles are returned least-specific to most-specific, starting with the root.
			//
			//		If root===false indicates we're working with a pre-AMD i18n bundle that doesn't tell about the available locales;
			//		therefore, assume everything is available and get 404 errors that indicate a particular localization is not available

			for(var result = [bundlePath + bundleName], localeParts = locale.split("-"), current = "", i = 0; i<localeParts.length; i++){
				current += (current ? "-" : "") + localeParts[i];
				if(!root || root[current]){
					result.push(bundlePath + current + "/" + bundleName);
					result.specificity = current;
				}
			}
			return result;
		},

		cache = {},

		getBundleName = function(moduleName, bundleName, locale){
			locale = locale ? locale.toLowerCase() : dojo.locale;
			moduleName = moduleName.replace(/\./g, "/");
			bundleName = bundleName.replace(/\./g, "/");
			return (/root/i.test(locale)) ?
				(moduleName + "/nls/" + bundleName) :
				(moduleName + "/nls/" + locale + "/" + bundleName);
		},

		getL10nName = dojo.getL10nName = function(moduleName, bundleName, locale){
			return moduleName = module.id + "!" + getBundleName(moduleName, bundleName, locale);
		},

		doLoad = function(require, bundlePathAndName, bundlePath, bundleName, locale, load){
			// summary:
			//		get the root bundle which instructs which other bundles are required to construct the localized bundle
			require([bundlePathAndName], function(root){
				var current = lang.clone(root.root || root.ROOT),// 1.6 built bundle defined ROOT
					availableLocales = getAvailableLocales(!root._v1x && root, locale, bundlePath, bundleName);
				require(availableLocales, function(){
					for (var i = 1; i<availableLocales.length; i++){
						current = lang.mixin(lang.clone(current), arguments[i]);
					}
					// target may not have been resolve (e.g., maybe only "fr" exists when "fr-ca" was requested)
					var target = bundlePathAndName + "/" + locale;
					cache[target] = current;
					current.$locale = availableLocales.specificity;
					load();
				});
			});
		},

		normalize = function(id, toAbsMid){
			// summary:
			//		id may be relative.
			//		preload has form `*preload*<path>/nls/<module>*<flattened locales>` and
			//		therefore never looks like a relative
			return /^\./.test(id) ? toAbsMid(id) : id;
		},

		getLocalesToLoad = function(targetLocale){
			var list = config.extraLocale || [];
			list = lang.isArray(list) ? list : [list];
			list.push(targetLocale);
			return list;
		},

		load = function(id, require, load){
			// summary:
			//		id is in one of the following formats
			//
			//		1. <path>/nls/<bundle>
			//			=> load the bundle, localized to config.locale; load all bundles localized to
			//			config.extraLocale (if any); return the loaded bundle localized to config.locale.
			//
			//		2. <path>/nls/<locale>/<bundle>
			//			=> load then return the bundle localized to <locale>
			//
			//		3. *preload*<path>/nls/<module>*<JSON array of available locales>
			//			=> for config.locale and all config.extraLocale, load all bundles found
			//			in the best-matching bundle rollup. A value of 1 is returned, which
			//			is meaningless other than to say the plugin is executing the requested
			//			preloads
			//
			//		In cases 1 and 2, <path> is always normalized to an absolute module id upon entry; see
			//		normalize. In case 3, it <path> is assumed to be absolute; this is arranged by the builder.
			//
			//		To load a bundle means to insert the bundle into the plugin's cache and publish the bundle
			//		value to the loader. Given <path>, <bundle>, and a particular <locale>, the cache key
			//
			//			<path>/nls/<bundle>/<locale>
			//
			//		will hold the value. Similarly, then plugin will publish this value to the loader by
			//
			//			define("<path>/nls/<bundle>/<locale>", <bundle-value>);
			//
			//		Given this algorithm, other machinery can provide fast load paths be preplacing
			//		values in the plugin's cache, which is public. When a load is demanded the
			//		cache is inspected before starting any loading. Explicitly placing values in the plugin
			//		cache is an advanced/experimental feature that should not be needed; use at your own risk.
			//
			//		For the normal AMD algorithm, the root bundle is loaded first, which instructs the
			//		plugin what additional localized bundles are required for a particular locale. These
			//		additional locales are loaded and a mix of the root and each progressively-specific
			//		locale is returned. For example:
			//
			//		1. The client demands "dojo/i18n!some/path/nls/someBundle
			//
			//		2. The loader demands load(some/path/nls/someBundle)
			//
			//		3. This plugin require's "some/path/nls/someBundle", which is the root bundle.
			//
			//		4. Assuming config.locale is "ab-cd-ef" and the root bundle indicates that localizations
			//		are available for "ab" and "ab-cd-ef" (note the missing "ab-cd", then the plugin
			//		requires "some/path/nls/ab/someBundle" and "some/path/nls/ab-cd-ef/someBundle"
			//
			//		5. Upon receiving all required bundles, the plugin constructs the value of the bundle
			//		ab-cd-ef as...
			//
			//				mixin(mixin(mixin({}, require("some/path/nls/someBundle"),
			//		  			require("some/path/nls/ab/someBundle")),
			//					require("some/path/nls/ab-cd-ef/someBundle"));
			//
			//		This value is inserted into the cache and published to the loader at the
			//		key/module-id some/path/nls/someBundle/ab-cd-ef.
			//
			//		The special preload signature (case 3) instructs the plugin to stop servicing all normal requests
			//		(further preload requests will be serviced) until all ongoing preloading has completed.
			//
			//		The preload signature instructs the plugin that a special rollup module is available that contains
			//		one or more flattened, localized bundles. The JSON array of available locales indicates which locales
			//		are available. Here is an example:
			//
			//			*preload*some/path/nls/someModule*["root", "ab", "ab-cd-ef"]
			//
			//		This indicates the following rollup modules are available:
			//
			//			some/path/nls/someModule_ROOT
			//			some/path/nls/someModule_ab
			//			some/path/nls/someModule_ab-cd-ef
			//
			//		Each of these modules is a normal AMD module that contains one or more flattened bundles in a hash.
			//		For example, assume someModule contained the bundles some/bundle/path/someBundle and
			//		some/bundle/path/someOtherBundle, then some/path/nls/someModule_ab would be expressed as follows:
			//
			//			define({
			//				some/bundle/path/someBundle:<value of someBundle, flattened with respect to locale ab>,
			//				some/bundle/path/someOtherBundle:<value of someOtherBundle, flattened with respect to locale ab>,
			//			});
			//
			//		E.g., given this design, preloading for locale=="ab" can execute the following algorithm:
			//
			//			require(["some/path/nls/someModule_ab"], function(rollup){
			//				for(var p in rollup){
			//					var id = p + "/ab",
			//					cache[id] = rollup[p];
			//					define(id, rollup[p]);
			//				}
			//			});
			//
			//		Similarly, if "ab-cd" is requested, the algorithm can determine that "ab" is the best available and
			//		load accordingly.
			//
			//		The builder will write such rollups for every layer if a non-empty localeList  profile property is
			//		provided. Further, the builder will include the following cache entry in the cache associated with
			//		any layer.
			//
			//			"*now":function(r){r(['dojo/i18n!*preload*<path>/nls/<module>*<JSON array of available locales>']);}
			//
			//		The *now special cache module instructs the loader to apply the provided function to context-require
			//		with respect to the particular layer being defined. This causes the plugin to hold all normal service
			//		requests until all preloading is complete.
			//
			//		Notice that this algorithm is rarely better than the standard AMD load algorithm. Consider the normal case
			//		where the target locale has a single segment and a layer depends on a single bundle:
			//
			//		Without Preloads:
			//
			//		1. Layer loads root bundle.
			//		2. bundle is demanded; plugin loads single localized bundle.
			//
			//		With Preloads:
			//
			//		1. Layer causes preloading of target bundle.
			//		2. bundle is demanded; service is delayed until preloading complete; bundle is returned.
			//
			//		In each case a single transaction is required to load the target bundle. In cases where multiple bundles
			//		are required and/or the locale has multiple segments, preloads still requires a single transaction whereas
			//		the normal path requires an additional transaction for each additional bundle/locale-segment. However all
			//		of these additional transactions can be done concurrently. Owing to this analysis, the entire preloading
			//		algorithm can be discard during a build by setting the has feature dojo-preload-i18n-Api to false.

			var match = nlsRe.exec(id),
				bundlePath = match[1] + "/",
				bundleName = match[5] || match[4],
				bundlePathAndName = bundlePath + bundleName,
				localeSpecified = (match[5] && match[4]),
				targetLocale =	localeSpecified || dojo.locale || "",
				loadTarget = bundlePathAndName + "/" + targetLocale,
				loadList = localeSpecified ? [targetLocale] : getLocalesToLoad(targetLocale),
				remaining = loadList.length,
				finish = function(){
					if(!--remaining){
						load(lang.delegate(cache[loadTarget]));
					}
				},
				split = id.split("*"),
				preloadDemand = split[1] == "preload";

			if(has("dojo-preload-i18n-Api")){
				if(preloadDemand){
					if(!cache[id]){
						// use cache[id] to prevent multiple preloads of the same preload; this shouldn't happen, but
						// who knows what over-aggressive human optimizers may attempt
						cache[id] = 1;
						preloadL10n(split[2], json.parse(split[3]), 1, require);
					}
					// don't stall the loader!
					load(1);
				}
				if(preloadDemand || (waitForPreloads(id, require, load) && !cache[loadTarget])){
					return;
				}
			}
			else if (preloadDemand) {
				// If a build is created with nls resources and 'dojo-preload-i18n-Api' has not been set to false,
				// the built file will include a preload in the cache (which looks about like so:)
				// '*now':function(r){r(['dojo/i18n!*preload*dojo/nls/dojo*["ar","ca","cs","da","de","el","en-gb","en-us","es-es","fi-fi","fr-fr","he-il","hu","it-it","ja-jp","ko-kr","nl-nl","nb","pl","pt-br","pt-pt","ru","sk","sl","sv","th","tr","zh-tw","zh-cn","ROOT"]']);}
				// If the consumer of the build sets 'dojo-preload-i18n-Api' to false in the Dojo config, the cached
				// preload will not be parsed and will result in an attempt to call 'require' passing it the unparsed
				// preload, which is not a valid module id.
				// In this case we should skip this request.
				load(1);

				return;
			}

			array.forEach(loadList, function(locale){
				var target = bundlePathAndName + "/" + locale;
				if(has("dojo-preload-i18n-Api")){
					checkForLegacyModules(target);
				}
				if(!cache[target]){
					doLoad(require, bundlePathAndName, bundlePath, bundleName, locale, finish);
				}else{
					finish();
				}
			});
		};

	if(has("dojo-preload-i18n-Api") ||  1 ){
		var normalizeLocale = thisModule.normalizeLocale = function(locale){
				var result = locale ? locale.toLowerCase() : dojo.locale;
				return result == "root" ? "ROOT" : result;
			},

			isXd = function(mid, contextRequire){
				return ( 0  &&  1 ) ?
					contextRequire.isXdUrl(require.toUrl(mid + ".js")) :
					true;
			},

			preloading = 0,

			preloadWaitQueue = [],

			preloadL10n = thisModule._preloadLocalizations = function(/*String*/bundlePrefix, /*Array*/localesGenerated, /*boolean?*/ guaranteedAmdFormat, /*function?*/ contextRequire){
				// summary:
				//		Load available flattened resource bundles associated with a particular module for dojo/locale and all dojo/config.extraLocale (if any)
				// description:
				//		Only called by built layer files. The entire locale hierarchy is loaded. For example,
				//		if locale=="ab-cd", then ROOT, "ab", and "ab-cd" are loaded. This is different than v1.6-
				//		in that the v1.6- would only load ab-cd...which was *always* flattened.
				//
				//		If guaranteedAmdFormat is true, then the module can be loaded with require thereby circumventing the detection algorithm
				//		and the extra possible extra transaction.

				// If this function is called from legacy code, then guaranteedAmdFormat and contextRequire will be undefined. Since the function
				// needs a require in order to resolve module ids, fall back to the context-require associated with this dojo/i18n module, which
				// itself may have been mapped.
				contextRequire = contextRequire || require;

				function doRequire(mid, callback){
					if(isXd(mid, contextRequire) || guaranteedAmdFormat){
						contextRequire([mid], callback);
					}else{
						syncRequire([mid], callback, contextRequire);
					}
				}

				function forEachLocale(locale, func){
					// given locale= "ab-cd-ef", calls func on "ab-cd-ef", "ab-cd", "ab", "ROOT"; stops calling the first time func returns truthy
					var parts = locale.split("-");
					while(parts.length){
						if(func(parts.join("-"))){
							return;
						}
						parts.pop();
					}
					func("ROOT");
				}

					function preloadingAddLock(){
						preloading++;
					}

					function preloadingRelLock(){
						--preloading;
						while(!preloading && preloadWaitQueue.length){
							load.apply(null, preloadWaitQueue.shift());
						}
					}

					function cacheId(path, name, loc, require){
						// path is assumed to have a trailing "/"
						return require.toAbsMid(path + name + "/" + loc)
					}

					function preload(locale){
						locale = normalizeLocale(locale);
						forEachLocale(locale, function(loc){
							if(array.indexOf(localesGenerated, loc) >= 0){
								var mid = bundlePrefix.replace(/\./g, "/") + "_" + loc;
								preloadingAddLock();
								doRequire(mid, function(rollup){
									for(var p in rollup){
										var bundle = rollup[p],
											match = p.match(/(.+)\/([^\/]+)$/),
											bundleName, bundlePath;

											// If there is no match, the bundle is not a regular bundle from an AMD layer.
											if (!match){continue;}

											bundleName = match[2];
											bundlePath = match[1] + "/";

										// backcompat
										if(!bundle._localized){continue;}

										var localized;
										if(loc === "ROOT"){
											var root = localized = bundle._localized;
											delete bundle._localized;
											root.root = bundle;
											cache[require.toAbsMid(p)] = root;
										}else{
											localized = bundle._localized;
											cache[cacheId(bundlePath, bundleName, loc, require)] = bundle;
										}

										if(loc !== locale){
											// capture some locale variables
											var improveBundle = function improveBundle(bundlePath, bundleName, bundle, localized){
												// locale was not flattened and we've fallen back to a less-specific locale that was flattened
												// for example, we had a flattened 'fr', a 'fr-ca' is available for at least this bundle, and
												// locale==='fr-ca'; therefore, we must improve the bundle as retrieved from the rollup by
												// manually loading the fr-ca version of the bundle and mixing this into the already-retrieved 'fr'
												// version of the bundle.
												//
												// Remember, different bundles may have different sets of locales available.
												//
												// we are really falling back on the regular algorithm here, but--hopefully--starting with most
												// of the required bundles already on board as given by the rollup and we need to "manually" load
												// only one locale from a few bundles...or even better...we won't find anything better to load.
												// This algorithm ensures there is nothing better to load even when we can only load a less-specific rollup.
												//
												// note: this feature is only available in async mode

												// inspect the loaded bundle that came from the rollup to see if something better is available
												// for any bundle in a rollup, more-specific available locales are given at localized.
												var requiredBundles = [],
													cacheIds = [];
												forEachLocale(locale, function(loc){
													if(localized[loc]){
														requiredBundles.push(require.toAbsMid(bundlePath + loc + "/" + bundleName));
														cacheIds.push(cacheId(bundlePath, bundleName, loc, require));
													}
												});

												if(requiredBundles.length){
													preloadingAddLock();
													contextRequire(requiredBundles, function(){
														// requiredBundles was constructed by forEachLocale so it contains locales from
														// less specific to most specific.
														// the loop starts with the most specific locale, the last one.
														for(var i = requiredBundles.length - 1; i >= 0 ; i--){
															bundle = lang.mixin(lang.clone(bundle), arguments[i]);
															cache[cacheIds[i]] = bundle;
														}
														// this is the best possible (maybe a perfect match, maybe not), accept it
														cache[cacheId(bundlePath, bundleName, locale, require)] = lang.clone(bundle);
														preloadingRelLock();
													});
												}else{
													// this is the best possible (definitely not a perfect match), accept it
													cache[cacheId(bundlePath, bundleName, locale, require)] = bundle;
												}
											};
											improveBundle(bundlePath, bundleName, bundle, localized);
										}
									}
									preloadingRelLock();
								});
								return true;
							}
							return false;
						});
					}

				preload();
				array.forEach(dojo.config.extraLocale, preload);
			},

			waitForPreloads = function(id, require, load){
				if(preloading){
					preloadWaitQueue.push([id, require, load]);
				}
				return preloading;
			},

			checkForLegacyModules = function()
				{};
	}

	if( 1 ){
		// this code path assumes the dojo loader and won't work with a standard AMD loader
		var amdValue = {},
			l10nCache = {},
			evalBundle,

			syncRequire = function(deps, callback, require){
				var results = [];
				array.forEach(deps, function(mid){
					var url = require.toUrl(mid + ".js");

					function load(text){
						if (!evalBundle) {
							// use the function ctor to keep the minifiers away (also come close to global scope, but this is secondary)
							evalBundle = new Function(
								"__bundle",				   // the bundle to evalutate
								"__checkForLegacyModules", // a function that checks if __bundle defined __mid in the global space
								"__mid",				   // the mid that __bundle is intended to define
								"__amdValue",

								// returns one of:
								//		1 => the bundle was an AMD bundle
								//		a legacy bundle object that is the value of __mid
								//		instance of Error => could not figure out how to evaluate bundle

								// used to detect when __bundle calls define
								"var define = function(mid, factory){define.called = 1; __amdValue.result = factory || mid;},"
								+ "	   require = function(){define.called = 1;};"

								+ "try{"
								+		"define.called = 0;"
								+		"eval(__bundle);"
								+		"if(define.called==1)"
											// bundle called define; therefore signal it's an AMD bundle
								+			"return __amdValue;"

								+		"if((__checkForLegacyModules = __checkForLegacyModules(__mid)))"
											// bundle was probably a v1.6- built NLS flattened NLS bundle that defined __mid in the global space
								+			"return __checkForLegacyModules;"

								+ "}catch(e){}"
								// evaulating the bundle was *neither* an AMD *nor* a legacy flattened bundle
								// either way, re-eval *after* surrounding with parentheses

								+ "try{"
								+		"return eval('('+__bundle+')');"
								+ "}catch(e){"
								+		"return e;"
								+ "}"
							);
						}
						var result = evalBundle(text, checkForLegacyModules, mid, amdValue);
						if(result===amdValue){
							// the bundle was an AMD module; re-inject it through the normal AMD path
							// we gotta do this since it could be an anonymous module and simply evaluating
							// the text here won't provide the loader with the context to know what
							// module is being defined()'d. With browser caching, this should be free; further
							// this entire code path can be circumvented by using the AMD format to begin with
							results.push(cache[url] = amdValue.result);
						}else{
							if(result instanceof Error){
								console.error("failed to evaluate i18n bundle; url=" + url, result);
								result = {};
							}
							// nls/<locale>/<bundle-name> indicates not the root.
							results.push(cache[url] = (/nls\/[^\/]+\/[^\/]+$/.test(url) ? result : {root:result, _v1x:1}));
						}
					}

					if(cache[url]){
						results.push(cache[url]);
					}else{
						var bundle = require.syncLoadNls(mid);
						// need to check for legacy module here because there might be a legacy module for a
						// less specific locale (which was not looked up during the first checkForLegacyModules
						// call in load()).
						// Also need to reverse the locale and the module name in the mid because syncRequire
						// deps parameters uses the AMD style package/nls/locale/module while legacy code uses
						// package/nls/module/locale.
						if(!bundle){
							bundle = checkForLegacyModules(mid.replace(/nls\/([^\/]*)\/([^\/]*)$/, "nls/$2/$1"));
						}
						if(bundle){
							results.push(bundle);
						}else{
							if(!xhr){
								try{
									require.getText(url, true, load);
								}catch(e){
									results.push(cache[url] = {});
								}
							}else{
								xhr.get({
									url:url,
									sync:true,
									load:load,
									error:function(){
										results.push(cache[url] = {});
									}
								});
							}
						}
					}
				});
				callback && callback.apply(null, results);
			};

		checkForLegacyModules = function(target){
			// legacy code may have already loaded [e.g] the raw bundle x/y/z at x.y.z; when true, push into the cache
			for(var result, names = target.split("/"), object = dojo.global[names[0]], i = 1; object && i<names.length-1; object = object[names[i++]]){}
			if(object){
				result = object[names[i]];
				if(!result){
					// fallback for incorrect bundle build of 1.6
					result = object[names[i].replace(/-/g,"_")];
				}
				if(result){
					cache[target] = result;
				}
			}
			return result;
		};

		thisModule.getLocalization = function(moduleName, bundleName, locale){
			var result,
				l10nName = getBundleName(moduleName, bundleName, locale);

			if (l10nCache[l10nName]) {
				return l10nCache[l10nName];
			}

			load(
				l10nName,

				// isXd() and syncRequire() need a context-require in order to resolve the mid with respect to a reference module.
				// Since this legacy function does not have the concept of a reference module, resolve with respect to this
				// dojo/i18n module, which, itself may have been mapped.
				(!isXd(l10nName, require) ? function(deps, callback){ syncRequire(deps, callback, require); } : require),

				function(result_){
					l10nCache[l10nName] = result_;
					result = result_;
				}
			);
			return result;
		};
	}
	else {
		thisModule.getLocalization = function(moduleName, bundleName, locale){
			var key = moduleName.replace(/\./g, '/') + '/nls/' + bundleName + '/' + (locale || config.locale);
			return this.cache[key];
		};
	}

	return lang.mixin(thisModule, {
		dynamic:true,
		normalize:normalize,
		load:load,
		cache:cache,
		getL10nName: getL10nName
	});
});

},
'dojo/_base/array':function(){
define(["./kernel", "../has", "./lang"], function(dojo, has, lang){
	// module:
	//		dojo/_base/array

	// our old simple function builder stuff
	var cache = {}, u;

	var buildFn;
	if(!has("csp-restrictions")){
		buildFn = function (fn){
			return cache[fn] = new Function("item", "index", "array", fn); // Function
		};
	}

	// magic snippet: if(typeof fn == "string") fn = cache[fn] || buildFn(fn);

	// every & some

	function everyOrSome(some){
		var every = !some;
		return function(a, fn, o){
			var i = 0, l = a && a.length || 0, result;
			if(l && typeof a == "string") a = a.split("");
			if(typeof fn == "string"){
				if(has("csp-restrictions")){
					throw new TypeError("callback must be a function");
				}
				else{
					fn = cache[fn] || buildFn(fn);
				}
			}
			if(o){
				for(; i < l; ++i){
					result = !fn.call(o, a[i], i, a);
					if(some ^ result){
						return !result;
					}
				}
			}else{
				for(; i < l; ++i){
					result = !fn(a[i], i, a);
					if(some ^ result){
						return !result;
					}
				}
			}
			return every; // Boolean
		};
	}

	// indexOf, lastIndexOf

	function index(up){
		var delta = 1, lOver = 0, uOver = 0;
		if(!up){
			delta = lOver = uOver = -1;
		}
		return function(a, x, from, last){
			if(last && delta > 0){
				// TODO: why do we use a non-standard signature? why do we need "last"?
				return array.lastIndexOf(a, x, from);
			}
			var l = a && a.length || 0, end = up ? l + uOver : lOver, i;
			if(from === u){
				i = up ? lOver : l + uOver;
			}else{
				if(from < 0){
					i = l + from;
					if(i < 0){
						i = lOver;
					}
				}else{
					i = from >= l ? l + uOver : from;
				}
			}
			if(l && typeof a == "string") a = a.split("");
			for(; i != end; i += delta){
				if(a[i] == x){
					return i; // Number
				}
			}
			return -1; // Number
		};
	}

	var array = {
		// summary:
		//		The Javascript v1.6 array extensions.

		every: everyOrSome(false),
		/*=====
		 every: function(arr, callback, thisObject){
			 // summary:
			 //		Determines whether or not every item in arr satisfies the
			 //		condition implemented by callback.
			 // arr: Array|String
			 //		the array to iterate on. If a string, operates on individual characters.
			 // callback: Function|String
			 //		a function is invoked with three arguments: item, index,
			 //		and array and returns true if the condition is met.
			 // thisObject: Object?
			 //		may be used to scope the call to callback
			 // returns: Boolean
			 // description:
			 //		This function corresponds to the JavaScript 1.6 Array.every() method, with one difference: when
			 //		run over sparse arrays, this implementation passes the "holes" in the sparse array to
			 //		the callback function with a value of undefined. JavaScript 1.6's every skips the holes in the sparse array.
			 //		For more details, see:
			 //		https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Objects/Array/every
			 // example:
			 //	|	// returns false
			 //	|	array.every([1, 2, 3, 4], function(item){ return item>1; });
			 // example:
			 //	|	// returns true
			 //	|	array.every([1, 2, 3, 4], function(item){ return item>0; });
		 },
		 =====*/

		some: everyOrSome(true),
		/*=====
		some: function(arr, callback, thisObject){
			// summary:
			//		Determines whether or not any item in arr satisfies the
			//		condition implemented by callback.
			// arr: Array|String
			//		the array to iterate over. If a string, operates on individual characters.
			// callback: Function|String
			//		a function is invoked with three arguments: item, index,
			//		and array and returns true if the condition is met.
			// thisObject: Object?
			//		may be used to scope the call to callback
			// returns: Boolean
			// description:
			//		This function corresponds to the JavaScript 1.6 Array.some() method, with one difference: when
			//		run over sparse arrays, this implementation passes the "holes" in the sparse array to
			//		the callback function with a value of undefined. JavaScript 1.6's some skips the holes in the sparse array.
			//		For more details, see:
			//		https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Objects/Array/some
			// example:
			//	| // is true
			//	| array.some([1, 2, 3, 4], function(item){ return item>1; });
			// example:
			//	| // is false
			//	| array.some([1, 2, 3, 4], function(item){ return item<1; });
		},
		=====*/

		indexOf: index(true),
		/*=====
		indexOf: function(arr, value, fromIndex, findLast){
			// summary:
			//		locates the first index of the provided value in the
			//		passed array. If the value is not found, -1 is returned.
			// description:
			//		This method corresponds to the JavaScript 1.6 Array.indexOf method, with two differences:
			//
			//		1. when run over sparse arrays, the Dojo function invokes the callback for every index
			//		   whereas JavaScript 1.6's indexOf skips the holes in the sparse array.
			//		2. uses equality (==) rather than strict equality (===)
			//
			//		For details on this method, see:
			//		https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Objects/Array/indexOf
			// arr: Array
			// value: Object
			// fromIndex: Integer?
			// findLast: Boolean?
			//		Makes indexOf() work like lastIndexOf().  Used internally; not meant for external usage.
			// returns: Number
		},
		=====*/

		lastIndexOf: index(false),
		/*=====
		lastIndexOf: function(arr, value, fromIndex){
			// summary:
			//		locates the last index of the provided value in the passed
			//		array. If the value is not found, -1 is returned.
			// description:
		 	//		This method corresponds to the JavaScript 1.6 Array.lastIndexOf method, with two differences:
		 	//
		 	//		1. when run over sparse arrays, the Dojo function invokes the callback for every index
		 	//		   whereas JavaScript 1.6's lasIndexOf skips the holes in the sparse array.
		 	//		2. uses equality (==) rather than strict equality (===)
		 	//
		 	//		For details on this method, see:
		 	//		https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Objects/Array/lastIndexOf
			// arr: Array,
			// value: Object,
			// fromIndex: Integer?
			// returns: Number
		},
		=====*/

		forEach: function(arr, callback, thisObject){
			// summary:
			//		for every item in arr, callback is invoked. Return values are ignored.
			//		If you want to break out of the loop, consider using array.every() or array.some().
			//		forEach does not allow breaking out of the loop over the items in arr.
			// arr:
			//		the array to iterate over. If a string, operates on individual characters.
			// callback:
			//		a function is invoked with three arguments: item, index, and array
			// thisObject:
			//		may be used to scope the call to callback
			// description:
			//		This function corresponds to the JavaScript 1.6 Array.forEach() method, with one difference: when
			//		run over sparse arrays, this implementation passes the "holes" in the sparse array to
			//		the callback function with a value of undefined. JavaScript 1.6's forEach skips the holes in the sparse array.
			//		For more details, see:
			//		https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Objects/Array/forEach
			// example:
			//	| // log out all members of the array:
			//	| array.forEach(
			//	|		[ "thinger", "blah", "howdy", 10 ],
			//	|		function(item){
			//	|			console.log(item);
			//	|		}
			//	| );
			// example:
			//	| // log out the members and their indexes
			//	| array.forEach(
			//	|		[ "thinger", "blah", "howdy", 10 ],
			//	|		function(item, idx, arr){
			//	|			console.log(item, "at index:", idx);
			//	|		}
			//	| );
			// example:
			//	| // use a scoped object member as the callback
			//	|
			//	| var obj = {
			//	|		prefix: "logged via obj.callback:",
			//	|		callback: function(item){
			//	|			console.log(this.prefix, item);
			//	|		}
			//	| };
			//	|
			//	| // specifying the scope function executes the callback in that scope
			//	| array.forEach(
			//	|		[ "thinger", "blah", "howdy", 10 ],
			//	|		obj.callback,
			//	|		obj
			//	| );
			//	|
			//	| // alternately, we can accomplish the same thing with lang.hitch()
			//	| array.forEach(
			//	|		[ "thinger", "blah", "howdy", 10 ],
			//	|		lang.hitch(obj, "callback")
			//	| );
			// arr: Array|String
			// callback: Function|String
			// thisObject: Object?

			var i = 0, l = arr && arr.length || 0;
			if(l && typeof arr == "string") arr = arr.split("");
			if(typeof callback == "string"){
				if(has("csp-restrictions")){
					throw new TypeError("callback must be a function");
				}
				else{
					callback = cache[callback] || buildFn(callback);
				}
			}
			if(thisObject){
				for(; i < l; ++i){
					callback.call(thisObject, arr[i], i, arr);
				}
			}else{
				for(; i < l; ++i){
					callback(arr[i], i, arr);
				}
			}
		},

		map: function(arr, callback, thisObject, Ctr){
			// summary:
			//		applies callback to each element of arr and returns
			//		an Array with the results
			// arr: Array|String
			//		the array to iterate on. If a string, operates on
			//		individual characters.
			// callback: Function|String
			//		a function is invoked with three arguments, (item, index,
			//		array),	 and returns a value
			// thisObject: Object?
			//		may be used to scope the call to callback
			// returns: Array
			// description:
			//		This function corresponds to the JavaScript 1.6 Array.map() method, with one difference: when
			//		run over sparse arrays, this implementation passes the "holes" in the sparse array to
			//		the callback function with a value of undefined. JavaScript 1.6's map skips the holes in the sparse array.
			//		For more details, see:
			//		https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Objects/Array/map
			// example:
			//	| // returns [2, 3, 4, 5]
			//	| array.map([1, 2, 3, 4], function(item){ return item+1 });

			// TODO: why do we have a non-standard signature here? do we need "Ctr"?
			var i = 0, l = arr && arr.length || 0, out = new (Ctr || Array)(l);
			if(l && typeof arr == "string") arr = arr.split("");
			if(typeof callback == "string"){
				if(has("csp-restrictions")){
					throw new TypeError("callback must be a function");
				}
				else{
					callback = cache[callback] || buildFn(callback);
				}
			}
			if(thisObject){
				for(; i < l; ++i){
					out[i] = callback.call(thisObject, arr[i], i, arr);
				}
			}else{
				for(; i < l; ++i){
					out[i] = callback(arr[i], i, arr);
				}
			}
			return out; // Array
		},

		filter: function(arr, callback, thisObject){
			// summary:
			//		Returns a new Array with those items from arr that match the
			//		condition implemented by callback.
			// arr: Array
			//		the array to iterate over.
			// callback: Function|String
			//		a function that is invoked with three arguments (item,
			//		index, array). The return of this function is expected to
			//		be a boolean which determines whether the passed-in item
			//		will be included in the returned array.
			// thisObject: Object?
			//		may be used to scope the call to callback
			// returns: Array
			// description:
			//		This function corresponds to the JavaScript 1.6 Array.filter() method, with one difference: when
			//		run over sparse arrays, this implementation passes the "holes" in the sparse array to
			//		the callback function with a value of undefined. JavaScript 1.6's filter skips the holes in the sparse array.
			//		For more details, see:
			//		https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Objects/Array/filter
			// example:
			//	| // returns [2, 3, 4]
			//	| array.filter([1, 2, 3, 4], function(item){ return item>1; });

			// TODO: do we need "Ctr" here like in map()?
			var i = 0, l = arr && arr.length || 0, out = [], value;
			if(l && typeof arr == "string") arr = arr.split("");
			if(typeof callback == "string"){
				if(has("csp-restrictions")){
					throw new TypeError("callback must be a function");
				}
				else{
					callback = cache[callback] || buildFn(callback);
				}
			}
			if(thisObject){
				for(; i < l; ++i){
					value = arr[i];
					if(callback.call(thisObject, value, i, arr)){
						out.push(value);
					}
				}
			}else{
				for(; i < l; ++i){
					value = arr[i];
					if(callback(value, i, arr)){
						out.push(value);
					}
				}
			}
			return out; // Array
		},

		clearCache: function(){
			cache = {};
		}
	};


	 1  && lang.mixin(dojo, array);

	return array;
});

},
'dojo/_base/lang':function(){
define(["./kernel", "../has", "../sniff"], function(dojo, has){
	// module:
	//		dojo/_base/lang

	has.add("bug-for-in-skips-shadowed", function(){
		// if true, the for-in iterator skips object properties that exist in Object's prototype (IE 6 - ?)
		for(var i in {toString: 1}){
			return 0;
		}
		return 1;
	});

	// Helper methods
	var _extraNames =
			has("bug-for-in-skips-shadowed") ?
				"hasOwnProperty.valueOf.isPrototypeOf.propertyIsEnumerable.toLocaleString.toString.constructor".split(".") : [],

		_extraLen = _extraNames.length,

		getProp = function(/*Array*/parts, /*Boolean*/create, /*Object*/context){
			if(!context){
				if(parts[0] && dojo.scopeMap[parts[0]]) {
					// Voodoo code from the old days where "dojo" or "dijit" maps to some special object
					// rather than just window.dojo
					context = dojo.scopeMap[parts.shift()][1];
				}else{
					context = dojo.global;
				}
			}

			try{
				for(var i = 0; i < parts.length; i++){
					var p = parts[i];
					// Fix for prototype pollution CVE-2021-23450
					if (p === '__proto__' || p === 'constructor') {
						return;
					}
					if(!(p in context)){
						if(create){
							context[p] = {};
						}else{
							return;		// return undefined
						}
					}
					context = context[p];
				}
				return context; // mixed
			}catch(e){
				// "p in context" throws an exception when context is a number, boolean, etc. rather than an object,
				// so in that corner case just return undefined (by having no return statement)
			}
		},

		opts = Object.prototype.toString,

		efficient = function(obj, offset, startWith){
			return (startWith||[]).concat(Array.prototype.slice.call(obj, offset||0));
		},

		_pattern = /\{([^\}]+)\}/g;

	// Module export
	var lang = {
		// summary:
		//		This module defines Javascript language extensions.

		// _extraNames: String[]
		//		Lists property names that must be explicitly processed during for-in iteration
		//		in environments that have has("bug-for-in-skips-shadowed") true.
		_extraNames:_extraNames,

		_mixin: function(dest, source, copyFunc){
			// summary:
			//		Copies/adds all properties of source to dest; returns dest.
			// dest: Object
			//		The object to which to copy/add all properties contained in source.
			// source: Object
			//		The object from which to draw all properties to copy into dest.
			// copyFunc: Function?
			//		The process used to copy/add a property in source; defaults to the Javascript assignment operator.
			// returns:
			//		dest, as modified
			// description:
			//		All properties, including functions (sometimes termed "methods"), excluding any non-standard extensions
			//		found in Object.prototype, are copied/added to dest. Copying/adding each particular property is
			//		delegated to copyFunc (if any); copyFunc defaults to the Javascript assignment operator if not provided.
			//		Notice that by default, _mixin executes a so-called "shallow copy" and aggregate types are copied/added by reference.
			var name, s, i, empty = {};
			for(name in source){
				// the (!(name in empty) || empty[name] !== s) condition avoids copying properties in "source"
				// inherited from Object.prototype.	 For example, if dest has a custom toString() method,
				// don't overwrite it with the toString() method that source inherited from Object.prototype
				s = source[name];
				if(!(name in dest) || (dest[name] !== s && (!(name in empty) || empty[name] !== s))){
					dest[name] = copyFunc ? copyFunc(s) : s;
				}
			}

			if(has("bug-for-in-skips-shadowed")){
				if(source){
					for(i = 0; i < _extraLen; ++i){
						name = _extraNames[i];
						s = source[name];
						if(!(name in dest) || (dest[name] !== s && (!(name in empty) || empty[name] !== s))){
							dest[name] = copyFunc ? copyFunc(s) : s;
						}
					}
				}
			}

			return dest; // Object
		},

		mixin: function(dest, sources){
			// summary:
			//		Copies/adds all properties of one or more sources to dest; returns dest.
			// dest: Object
			//		The object to which to copy/add all properties contained in source. If dest is falsy, then
			//		a new object is manufactured before copying/adding properties begins.
			// sources: Object...
			//		One of more objects from which to draw all properties to copy into dest. sources are processed
			//		left-to-right and if more than one of these objects contain the same property name, the right-most
			//		value "wins".
			// returns: Object
			//		dest, as modified
			// description:
			//		All properties, including functions (sometimes termed "methods"), excluding any non-standard extensions
			//		found in Object.prototype, are copied/added from sources to dest. sources are processed left to right.
			//		The Javascript assignment operator is used to copy/add each property; therefore, by default, mixin
			//		executes a so-called "shallow copy" and aggregate types are copied/added by reference.
			// example:
			//		make a shallow copy of an object
			//	|	var copy = lang.mixin({}, source);
			// example:
			//		many class constructors often take an object which specifies
			//		values to be configured on the object. In this case, it is
			//		often simplest to call `lang.mixin` on the `this` object:
			//	|	declare("acme.Base", null, {
			//	|		constructor: function(properties){
			//	|			// property configuration:
			//	|			lang.mixin(this, properties);
			//	|
			//	|			console.log(this.quip);
			//	|			//	...
			//	|		},
			//	|		quip: "I wasn't born yesterday, you know - I've seen movies.",
			//	|		// ...
			//	|	});
			//	|
			//	|	// create an instance of the class and configure it
			//	|	var b = new acme.Base({quip: "That's what it does!" });
			// example:
			//		copy in properties from multiple objects
			//	|	var flattened = lang.mixin(
			//	|		{
			//	|			name: "Frylock",
			//	|			braces: true
			//	|		},
			//	|		{
			//	|			name: "Carl Brutanananadilewski"
			//	|		}
			//	|	);
			//	|
			//	|	// will print "Carl Brutanananadilewski"
			//	|	console.log(flattened.name);
			//	|	// will print "true"
			//	|	console.log(flattened.braces);

			if(!dest){ dest = {}; }
			for(var i = 1, l = arguments.length; i < l; i++){
				lang._mixin(dest, arguments[i]);
			}
			return dest; // Object
		},

		setObject: function(name, value, context){
			// summary:
			//		Set a property from a dot-separated string, such as "A.B.C"
			// description:
			//		Useful for longer api chains where you have to test each object in
			//		the chain, or when you have an object reference in string format.
			//		Objects are created as needed along `path`. Returns the passed
			//		value if setting is successful or `undefined` if not.
			// name: String
			//		Path to a property, in the form "A.B.C".
			// value: anything
			//		value or object to place at location given by name
			// context: Object?
			//		Optional. Object to use as root of path. Defaults to
			//		`dojo.global`.
			// example:
			//		set the value of `foo.bar.baz`, regardless of whether
			//		intermediate objects already exist:
			//	| lang.setObject("foo.bar.baz", value);
			// example:
			//		without `lang.setObject`, we often see code like this:
			//	| // ensure that intermediate objects are available
			//	| if(!obj["parent"]){ obj.parent = {}; }
			//	| if(!obj.parent["child"]){ obj.parent.child = {}; }
			//	| // now we can safely set the property
			//	| obj.parent.child.prop = "some value";
			//		whereas with `lang.setObject`, we can shorten that to:
			//	| lang.setObject("parent.child.prop", "some value", obj);

			var parts = name.split("."), p = parts.pop(), obj = getProp(parts, true, context);
			return obj && p ? (obj[p] = value) : undefined; // Object
		},

		getObject: function(name, create, context){
			// summary:
			//		Get a property from a dot-separated string, such as "A.B.C"
			// description:
			//		Useful for longer api chains where you have to test each object in
			//		the chain, or when you have an object reference in string format.
			// name: String
			//		Path to an property, in the form "A.B.C".
			// create: Boolean?
			//		Optional. Defaults to `false`. If `true`, Objects will be
			//		created at any point along the 'path' that is undefined.
			// context: Object?
			//		Optional. Object to use as root of path. Defaults to
			//		'dojo.global'. Null may be passed.
			return !name ? context : getProp(name.split("."), create, context); // Object
		},

		exists: function(name, obj){
			// summary:
			//		determine if an object supports a given method
			// description:
			//		useful for longer api chains where you have to test each object in
			//		the chain. Useful for object and method detection.
			// name: String
			//		Path to an object, in the form "A.B.C".
			// obj: Object?
			//		Object to use as root of path. Defaults to
			//		'dojo.global'. Null may be passed.
			// example:
			//	| // define an object
			//	| var foo = {
			//	|		bar: { }
			//	| };
			//	|
			//	| // search the global scope
			//	| lang.exists("foo.bar"); // true
			//	| lang.exists("foo.bar.baz"); // false
			//	|
			//	| // search from a particular scope
			//	| lang.exists("bar", foo); // true
			//	| lang.exists("bar.baz", foo); // false
			return lang.getObject(name, false, obj) !== undefined; // Boolean
		},

		// Crockford (ish) functions

		isString: function(it){
			// summary:
			//		Return true if it is a String
			// it: anything
			//		Item to test.
			return (typeof it == "string" || it instanceof String); // Boolean
		},

		isArray: Array.isArray || function(it){
			// summary:
			//		Return true if it is an Array.
			// it: anything
			//		Item to test.
			return opts.call(it) == "[object Array]"; // Boolean
		},

		isFunction: function(it){
			// summary:
			//		Return true if it is a Function
			// it: anything
			//		Item to test.
			return opts.call(it) === "[object Function]";
		},

		isObject: function(it){
			// summary:
			//		Returns true if it is a JavaScript object (or an Array, a Function
			//		or null)
			// it: anything
			//		Item to test.
			return it !== undefined &&
				(it === null || typeof it == "object" || lang.isArray(it) || lang.isFunction(it)); // Boolean
		},

		isArrayLike: function(it){
			// summary:
			//		similar to isArray() but more permissive
			// it: anything
			//		Item to test.
			// returns:
			//		If it walks like a duck and quacks like a duck, return `true`
			// description:
			//		Doesn't strongly test for "arrayness".  Instead, settles for "isn't
			//		a string or number and has a length property". Arguments objects
			//		and DOM collections will return true when passed to
			//		isArrayLike(), but will return false when passed to
			//		isArray().
			return !!it && // Boolean
				// keep out built-in constructors (Number, String, ...) which have length
				// properties
				!lang.isString(it) && !lang.isFunction(it) &&
				!(it.tagName && it.tagName.toLowerCase() == 'form') &&
				(lang.isArray(it) || isFinite(it.length));
		},

		isAlien: function(it){
			// summary:
			//		Returns true if it is a built-in function or some other kind of
			//		oddball that *should* report as a function but doesn't
			return it && !lang.isFunction(it) && /\{\s*\[native code\]\s*\}/.test(String(it)); // Boolean
		},

		extend: function(ctor, props){
			// summary:
			//		Adds all properties and methods of props to constructor's
			//		prototype, making them available to all instances created with
			//		constructor.
			// ctor: Object
			//		Target constructor to extend.
			// props: Object
			//		One or more objects to mix into ctor.prototype
			for(var i=1, l=arguments.length; i<l; i++){
				lang._mixin(ctor.prototype, arguments[i]);
			}
			return ctor; // Object
		},

		_hitchArgs: function(scope, method){
			var pre = lang._toArray(arguments, 2);
			var named = lang.isString(method);
			return function(){
				// arrayify arguments
				var args = lang._toArray(arguments);
				// locate our method
				var f = named ? (scope||dojo.global)[method] : method;
				// invoke with collected args
				return f && f.apply(scope || this, pre.concat(args)); // mixed
			}; // Function
		},

		hitch: function(scope, method){
			// summary:
			//		Returns a function that will only ever execute in the given scope.
			//		This allows for easy use of object member functions
			//		in callbacks and other places in which the "this" keyword may
			//		otherwise not reference the expected scope.
			//		Any number of default positional arguments may be passed as parameters
			//		beyond "method".
			//		Each of these values will be used to "placehold" (similar to curry)
			//		for the hitched function.
			// scope: Object
			//		The scope to use when method executes. If method is a string,
			//		scope is also the object containing method.
			// method: Function|String...
			//		A function to be hitched to scope, or the name of the method in
			//		scope to be hitched.
			// example:
			//	|	lang.hitch(foo, "bar")();
			//		runs foo.bar() in the scope of foo
			// example:
			//	|	lang.hitch(foo, myFunction);
			//		returns a function that runs myFunction in the scope of foo
			// example:
			//		Expansion on the default positional arguments passed along from
			//		hitch. Passed args are mixed first, additional args after.
			//	|	var foo = { bar: function(a, b, c){ console.log(a, b, c); } };
			//	|	var fn = lang.hitch(foo, "bar", 1, 2);
			//	|	fn(3); // logs "1, 2, 3"
			// example:
			//	|	var foo = { bar: 2 };
			//	|	lang.hitch(foo, function(){ this.bar = 10; })();
			//		execute an anonymous function in scope of foo
			if(arguments.length > 2){
				return lang._hitchArgs.apply(dojo, arguments); // Function
			}
			if(!method){
				method = scope;
				scope = null;
			}
			if(lang.isString(method)){
				scope = scope || dojo.global;
				if(!scope[method]){ throw(['lang.hitch: scope["', method, '"] is null (scope="', scope, '")'].join('')); }
				return function(){ return scope[method].apply(scope, arguments || []); }; // Function
			}
			return !scope ? method : function(){ return method.apply(scope, arguments || []); }; // Function
		},

		delegate: (function(){
			// boodman/crockford delegation w/ cornford optimization
			function TMP(){}
			return function(obj, props){
				TMP.prototype = obj;
				var tmp = new TMP();
				TMP.prototype = null;
				if(props){
					lang._mixin(tmp, props);
				}
				return tmp; // Object
			};
		})(),
		/*=====
		delegate: function(obj, props){
			// summary:
			//		Returns a new object which "looks" to obj for properties which it
			//		does not have a value for. Optionally takes a bag of properties to
			//		seed the returned object with initially.
			// description:
			//		This is a small implementation of the Boodman/Crockford delegation
			//		pattern in JavaScript. An intermediate object constructor mediates
			//		the prototype chain for the returned object, using it to delegate
			//		down to obj for property lookup when object-local lookup fails.
			//		This can be thought of similarly to ES4's "wrap", save that it does
			//		not act on types but rather on pure objects.
			// obj: Object
			//		The object to delegate to for properties not found directly on the
			//		return object or in props.
			// props: Object...
			//		an object containing properties to assign to the returned object
			// returns:
			//		an Object of anonymous type
			// example:
			//	|	var foo = { bar: "baz" };
			//	|	var thinger = lang.delegate(foo, { thud: "xyzzy"});
			//	|	thinger.bar == "baz"; // delegated to foo
			//	|	foo.thud == undefined; // by definition
			//	|	thinger.thud == "xyzzy"; // mixed in from props
			//	|	foo.bar = "thonk";
			//	|	thinger.bar == "thonk"; // still delegated to foo's bar
		},
		=====*/

		_toArray: has("ie") ?
			(function(){
				function slow(obj, offset, startWith){
					var arr = startWith||[];
					for(var x = offset || 0; x < obj.length; x++){
						arr.push(obj[x]);
					}
					return arr;
				}
				return function(obj){
					return ((obj.item) ? slow : efficient).apply(this, arguments);
				};
			})() : efficient,
		/*=====
		 _toArray: function(obj, offset, startWith){
			 // summary:
			 //		Converts an array-like object (i.e. arguments, DOMCollection) to an
			 //		array. Returns a new Array with the elements of obj.
			 // obj: Object
			 //		the object to "arrayify". We expect the object to have, at a
			 //		minimum, a length property which corresponds to integer-indexed
			 //		properties.
			 // offset: Number?
			 //		the location in obj to start iterating from. Defaults to 0.
			 //		Optional.
			 // startWith: Array?
			 //		An array to pack with the properties of obj. If provided,
			 //		properties in obj are appended at the end of startWith and
			 //		startWith is the returned array.
		 },
		 =====*/

		partial: function(/*Function|String*/ method /*, ...*/){
			// summary:
			//		similar to hitch() except that the scope object is left to be
			//		whatever the execution context eventually becomes.
			// description:
			//		Calling lang.partial is the functional equivalent of calling:
			//		|	lang.hitch(null, funcName, ...);
			// method:
			//		The function to "wrap"
			var arr = [ null ];
			return lang.hitch.apply(dojo, arr.concat(lang._toArray(arguments))); // Function
		},

		clone: function(/*anything*/ src){
			// summary:
			//		Clones objects (including DOM nodes) and all children.
			//		Warning: do not clone cyclic structures.
			// src:
			//		The object to clone
			if(!src || typeof src != "object" || lang.isFunction(src)){
				// null, undefined, any non-object, or function
				return src;	// anything
			}
			if(src.nodeType && "cloneNode" in src){
				// DOM Node
				return src.cloneNode(true); // Node
			}
			if(src instanceof Date){
				// Date
				return new Date(src.getTime());	// Date
			}
			if(src instanceof RegExp){
				// RegExp
				return new RegExp(src);   // RegExp
			}
			var r, i, l;
			if(lang.isArray(src)){
				// array
				r = [];
				for(i = 0, l = src.length; i < l; ++i){
					if(i in src){
						r[i] = lang.clone(src[i]);
					}
				}
				// we don't clone functions for performance reasons
				//		}else if(d.isFunction(src)){
				//			// function
				//			r = function(){ return src.apply(this, arguments); };
			}else{
				// generic objects
				r = src.constructor ? new src.constructor() : {};
			}
			return lang._mixin(r, src, lang.clone);
		},


		trim: String.prototype.trim ?
			function(str){ return str.trim(); } :
			function(str){ return str.replace(/^\s\s*/, '').replace(/\s\s*$/, ''); },
		/*=====
		 trim: function(str){
			 // summary:
			 //		Trims whitespace from both sides of the string
			 // str: String
			 //		String to be trimmed
			 // returns: String
			 //		Returns the trimmed string
			 // description:
			 //		This version of trim() was selected for inclusion into the base due
			 //		to its compact size and relatively good performance
			 //		(see [Steven Levithan's blog](http://blog.stevenlevithan.com/archives/faster-trim-javascript)
			 //		Uses String.prototype.trim instead, if available.
			 //		The fastest but longest version of this function is located at
			 //		lang.string.trim()
		 },
		 =====*/

		replace: function(tmpl, map, pattern){
			// summary:
			//		Performs parameterized substitutions on a string. Throws an
			//		exception if any parameter is unmatched.
			// tmpl: String
			//		String to be used as a template.
			// map: Object|Function
			//		If an object, it is used as a dictionary to look up substitutions.
			//		If a function, it is called for every substitution with following parameters:
			//		a whole match, a name, an offset, and the whole template
			//		string (see https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Global_Objects/String/replace
			//		for more details).
			// pattern: RegEx?
			//		Optional regular expression objects that overrides the default pattern.
			//		Must be global and match one item. The default is: /\{([^\}]+)\}/g,
			//		which matches patterns like that: "{xxx}", where "xxx" is any sequence
			//		of characters, which doesn't include "}".
			// returns: String
			//		Returns the substituted string.
			// example:
			//	|	// uses a dictionary for substitutions:
			//	|	lang.replace("Hello, {name.first} {name.last} AKA {nick}!",
			//	|		{
			//	|			nick: "Bob",
			//	|			name: {
			//	|				first:	"Robert",
			//	|				middle: "X",
			//	|				last:		"Cringely"
			//	|			}
			//	|		});
			//	|	// returns: Hello, Robert Cringely AKA Bob!
			// example:
			//	|	// uses an array for substitutions:
			//	|	lang.replace("Hello, {0} {2}!",
			//	|		["Robert", "X", "Cringely"]);
			//	|	// returns: Hello, Robert Cringely!
			// example:
			//	|	// uses a function for substitutions:
			//	|	function sum(a){
			//	|		var t = 0;
			//	|		arrayforEach(a, function(x){ t += x; });
			//	|		return t;
			//	|	}
			//	|	lang.replace(
			//	|		"{count} payments averaging {avg} USD per payment.",
			//	|		lang.hitch(
			//	|			{ payments: [11, 16, 12] },
			//	|			function(_, key){
			//	|				switch(key){
			//	|					case "count": return this.payments.length;
			//	|					case "min":		return Math.min.apply(Math, this.payments);
			//	|					case "max":		return Math.max.apply(Math, this.payments);
			//	|					case "sum":		return sum(this.payments);
			//	|					case "avg":		return sum(this.payments) / this.payments.length;
			//	|				}
			//	|			}
			//	|		)
			//	|	);
			//	|	// prints: 3 payments averaging 13 USD per payment.
			// example:
			//	|	// uses an alternative PHP-like pattern for substitutions:
			//	|	lang.replace("Hello, ${0} ${2}!",
			//	|		["Robert", "X", "Cringely"], /\$\{([^\}]+)\}/g);
			//	|	// returns: Hello, Robert Cringely!

			return tmpl.replace(pattern || _pattern, lang.isFunction(map) ?
				map : function(_, k){ return lang.getObject(k, false, map); });
		}
	};

	 1  && lang.mixin(dojo, lang);

	return lang;
});

},
'dojo/sniff':function(){
define(["./has"], function(has){
	// module:
	//		dojo/sniff

	/*=====
	return function(){
		// summary:
		//		This module sets has() flags based on the current browser.
		//		It returns the has() function.
	};
	=====*/

	if( 1 ){
		var n = navigator,
			dua = n.userAgent,
			dav = n.appVersion,
			tv = parseFloat(dav);
		has.add("air", dua.indexOf("AdobeAIR") >= 0);
		has.add("wp", parseFloat(dua.split("Windows Phone")[1]) || undefined);
		has.add("msapp", parseFloat(dua.split("MSAppHost/")[1]) || undefined);
		has.add("khtml", dav.indexOf("Konqueror") >= 0 ? tv : undefined);
		has.add("edge", parseFloat(dua.split("Edge/")[1]) || undefined);
		has.add("opr", parseFloat(dua.split("OPR/")[1]) || undefined);
		// NOTE: https://dev.opera.com/blog/opera-user-agent-strings-opera-15-and-beyond/
		has.add("webkit", !has("wp") // NOTE: necessary since Windows Phone 8.1 Update 1, see #18540
			&& !has("edge") && parseFloat(dua.split("WebKit/")[1]) || undefined);
		has.add("chrome", !has("edge") && !has("opr")
				&& parseFloat(dua.split("Chrome/")[1]) || undefined);
		has.add("android", !has("wp") // NOTE: necessary since Windows Phone 8.1 Update 1, see #18528
				&& parseFloat(dua.split("Android ")[1]) || undefined);
		has.add("safari", dav.indexOf("Safari") >= 0
				&& !has("wp") // NOTE: necessary since Windows Phone 8.1 Update 1, see #18540
				&& !has("chrome") && !has("android") && !has("edge") && !has("opr") ?
			parseFloat(dav.split("Version/")[1]) : undefined);
		has.add("mac", dav.indexOf("Macintosh") >= 0);
		has.add("quirks", document.compatMode == "BackCompat");
		if(!has("wp") // NOTE: necessary since Windows Phone 8.1 Update 1, see #18528
				&& dua.match(/(iPhone|iPod|iPad)/)){
			var p = RegExp.$1.replace(/P/, "p");
			var v = dua.match(/OS ([\d_]+)/) ? RegExp.$1 : "1";
			var os = parseFloat(v.replace(/_/, ".").replace(/_/g, ""));
			has.add(p, os);		// "iphone", "ipad" or "ipod"
			has.add("ios", os);
		}
		has.add("bb", (dua.indexOf("BlackBerry") >= 0 || dua.indexOf("BB10") >= 0) && parseFloat(dua.split("Version/")[1]) || undefined);
		has.add("trident", parseFloat(dav.split("Trident/")[1]) || undefined);

		has.add("svg", typeof SVGAngle !== "undefined");

		if(!has("webkit")){
			// Opera
			if(dua.indexOf("Opera") >= 0){
				// see http://dev.opera.com/articles/view/opera-ua-string-changes and http://www.useragentstring.com/pages/Opera/
				// 9.8 has both styles; <9.8, 9.9 only old style
				has.add("opera", tv >= 9.8 ? parseFloat(dua.split("Version/")[1]) || tv : tv);
			}

			// Mozilla and firefox
			if(dua.indexOf("Gecko") >= 0 && !has("wp") // NOTE: necessary since Windows Phone 8.1 Update 1
					&& !has("khtml") && !has("trident") && !has("edge")){
				has.add("mozilla", tv);
			}
			if(has("mozilla")){
				//We really need to get away from this. Consider a sane isGecko approach for the future.
				has.add("ff", parseFloat(dua.split("Firefox/")[1] || dua.split("Minefield/")[1]) || undefined);
			}

			// IE
			if(document.all && !has("opera")){
				var isIE = parseFloat(dav.split("MSIE ")[1]) || undefined;

				//In cases where the page has an HTTP header or META tag with
				//X-UA-Compatible, then it is in emulation mode.
				//Make sure isIE reflects the desired version.
				//document.documentMode of 5 means quirks mode.
				//Only switch the value if documentMode's major version
				//is different from isIE's major version.
				var mode = document.documentMode;
				if(mode && mode != 5 && Math.floor(isIE) != mode){
					isIE = mode;
				}

				has.add("ie", isIE);
			}

			// Wii
			has.add("wii", typeof opera != "undefined" && opera.wiiremote);
		}
	}

	return has;
});

},
'dojo/_base/xhr':function(){
define([
	"./kernel",
	"./sniff",
	"require",
	"../io-query",
	/*===== "./declare", =====*/
	"../dom",
	"../dom-form",
	"./Deferred",
	"./config",
	"./json",
	"./lang",
	"./array",
	"../on",
	"../aspect",
	"../request/watch",
	"../request/xhr",
	"../request/util"
], function(dojo, has, require, ioq, /*===== declare, =====*/ dom, domForm, Deferred, config, json, lang, array, on, aspect, watch, _xhr, util){
	// module:
	//		dojo/_base/xhr

	/*=====
	dojo._xhrObj = function(){
		// summary:
		//		does the work of portably generating a new XMLHTTPRequest object.
	};
	=====*/
	dojo._xhrObj = _xhr._create;

	var cfg = dojo.config;

	// mix in io-query and dom-form
	dojo.objectToQuery = ioq.objectToQuery;
	dojo.queryToObject = ioq.queryToObject;
	dojo.fieldToObject = domForm.fieldToObject;
	dojo.formToObject = domForm.toObject;
	dojo.formToQuery = domForm.toQuery;
	dojo.formToJson = domForm.toJson;

	// need to block async callbacks from snatching this thread as the result
	// of an async callback might call another sync XHR, this hangs khtml forever
	// must checked by watchInFlight()

	dojo._blockAsync = false;

	// MOW: remove dojo._contentHandlers alias in 2.0
	var handlers = dojo._contentHandlers = dojo.contentHandlers = {
		// summary:
		//		A map of available XHR transport handle types. Name matches the
		//		`handleAs` attribute passed to XHR calls.
		// description:
		//		A map of available XHR transport handle types. Name matches the
		//		`handleAs` attribute passed to XHR calls. Each contentHandler is
		//		called, passing the xhr object for manipulation. The return value
		//		from the contentHandler will be passed to the `load` or `handle`
		//		functions defined in the original xhr call.
		// example:
		//		Creating a custom content-handler:
		//	|	xhr.contentHandlers.makeCaps = function(xhr){
		//	|		return xhr.responseText.toUpperCase();
		//	|	}
		//	|	// and later:
		//	|	dojo.xhrGet({
		//	|		url:"foo.txt",
		//	|		handleAs:"makeCaps",
		//	|		load: function(data){ /* data is a toUpper version of foo.txt */ }
		//	|	});

		"text": function(xhr){
			// summary:
			//		A contentHandler which simply returns the plaintext response data
			return xhr.responseText;
		},
		"json": function(xhr){
			// summary:
			//		A contentHandler which returns a JavaScript object created from the response data
			return json.fromJson(xhr.responseText || null);
		},
		"json-comment-filtered": function(xhr){
			// summary:
			//		A contentHandler which expects comment-filtered JSON.
			// description:
			//		A contentHandler which expects comment-filtered JSON.
			//		the json-comment-filtered option was implemented to prevent
			//		"JavaScript Hijacking", but it is less secure than standard JSON. Use
			//		standard JSON instead. JSON prefixing can be used to subvert hijacking.
			//
			//		Will throw a notice suggesting to use application/json mimetype, as
			//		json-commenting can introduce security issues. To decrease the chances of hijacking,
			//		use the standard `json` contentHandler, and prefix your "JSON" with: {}&&
			//
			//		use djConfig.useCommentedJson = true to turn off the notice
			if(!config.useCommentedJson){
				console.warn("Consider using the standard mimetype:application/json."
					+ " json-commenting can introduce security issues. To"
					+ " decrease the chances of hijacking, use the standard the 'json' handler and"
					+ " prefix your json with: {}&&\n"
					+ "Use djConfig.useCommentedJson=true to turn off this message.");
			}

			var value = xhr.responseText;
			var cStartIdx = value.indexOf("\/*");
			var cEndIdx = value.lastIndexOf("*\/");
			if(cStartIdx == -1 || cEndIdx == -1){
				throw new Error("JSON was not comment filtered");
			}
			return json.fromJson(value.substring(cStartIdx+2, cEndIdx));
		},
		"javascript": function(xhr){
			// summary:
			//		A contentHandler which evaluates the response data, expecting it to be valid JavaScript

			// FIXME: try Moz and IE specific eval variants?
			return dojo.eval(xhr.responseText);
		},
		"xml": function(xhr){
			// summary:
			//		A contentHandler returning an XML Document parsed from the response data
			var result = xhr.responseXML;

			if(result && has("dom-qsa2.1") && !result.querySelectorAll && has("dom-parser")){
				// http://bugs.dojotoolkit.org/ticket/15631
				// IE9 supports a CSS3 querySelectorAll implementation, but the DOM implementation
				// returned by IE9 xhr.responseXML does not. Manually create the XML DOM to gain
				// the fuller-featured implementation and avoid bugs caused by the inconsistency
				result = new DOMParser().parseFromString(xhr.responseText, "application/xml");
			}

			if(has("ie")){
				if((!result || !result.documentElement)){
					//WARNING: this branch used by the xml handling in dojo.io.iframe,
					//so be sure to test dojo.io.iframe if making changes below.
					var ms = function(n){ return "MSXML" + n + ".DOMDocument"; };
					var dp = ["Microsoft.XMLDOM", ms(6), ms(4), ms(3), ms(2)];
					array.some(dp, function(p){
						try{
							var dom = new ActiveXObject(p);
							dom.async = false;
							dom.loadXML(xhr.responseText);
							result = dom;
						}catch(e){ return false; }
						return true;
					});
				}
			}
			return result; // DOMDocument
		},
		"json-comment-optional": function(xhr){
			// summary:
			//		A contentHandler which checks the presence of comment-filtered JSON and
			//		alternates between the `json` and `json-comment-filtered` contentHandlers.
			if(xhr.responseText && /^[^{\[]*\/\*/.test(xhr.responseText)){
				return handlers["json-comment-filtered"](xhr);
			}else{
				return handlers["json"](xhr);
			}
		}
	};

	/*=====

	// kwargs function parameter definitions.   Assigning to dojo namespace rather than making them local variables
	// because they are used by dojo/io modules too

	dojo.__IoArgs = declare(null, {
		// url: String
		//		URL to server endpoint.
		// content: Object?
		//		Contains properties with string values. These
		//		properties will be serialized as name1=value2 and
		//		passed in the request.
		// timeout: Integer?
		//		Milliseconds to wait for the response. If this time
		//		passes, the then error callbacks are called.
		// form: DOMNode?
		//		DOM node for a form. Used to extract the form values
		//		and send to the server.
		// preventCache: Boolean?
		//		Default is false. If true, then a
		//		"dojo.preventCache" parameter is sent in the request
		//		with a value that changes with each request
		//		(timestamp). Useful only with GET-type requests.
		// handleAs: String?
		//		Acceptable values depend on the type of IO
		//		transport (see specific IO calls for more information).
		// rawBody: String?
		//		Sets the raw body for an HTTP request. If this is used, then the content
		//		property is ignored. This is mostly useful for HTTP methods that have
		//		a body to their requests, like PUT or POST. This property can be used instead
		//		of postData and putData for dojo/_base/xhr.rawXhrPost and dojo/_base/xhr.rawXhrPut respectively.
		// ioPublish: Boolean?
		//		Set this explicitly to false to prevent publishing of topics related to
		//		IO operations. Otherwise, if djConfig.ioPublish is set to true, topics
		//		will be published via dojo/topic.publish() for different phases of an IO operation.
		//		See dojo/main.__IoPublish for a list of topics that are published.

		load: function(response, ioArgs){
			// summary:
			//		This function will be
			//		called on a successful HTTP response code.
	 		// ioArgs: dojo/main.__IoCallbackArgs
			//		Provides additional information about the request.
			// response: Object
			//		The response in the format as defined with handleAs.
		},

		error: function(response, ioArgs){
			// summary:
			//		This function will
			//		be called when the request fails due to a network or server error, the url
			//		is invalid, etc. It will also be called if the load or handle callback throws an
			//		exception, unless djConfig.debugAtAllCosts is true.	 This allows deployed applications
			//		to continue to run even when a logic error happens in the callback, while making
			//		it easier to troubleshoot while in debug mode.
			// ioArgs: dojo/main.__IoCallbackArgs
			//		Provides additional information about the request.
			// response: Object
			//		The response in the format as defined with handleAs.
		},

		handle: function(loadOrError, response, ioArgs){
			// summary:
	 		//		This function will
	 		//		be called at the end of every request, whether or not an error occurs.
			// loadOrError: String
			//		Provides a string that tells you whether this function
			//		was called because of success (load) or failure (error).
			// response: Object
			//		The response in the format as defined with handleAs.
			// ioArgs: dojo/main.__IoCallbackArgs
			//		Provides additional information about the request.
		}
	});

	dojo.__IoCallbackArgs = declare(null, {
		// args: Object
		//		the original object argument to the IO call.
		// xhr: XMLHttpRequest
		//		For XMLHttpRequest calls only, the
		//		XMLHttpRequest object that was used for the
		//		request.
		// url: String
		//		The final URL used for the call. Many times it
		//		will be different than the original args.url
		//		value.
		// query: String
		//		For non-GET requests, the
		//		name1=value1&name2=value2 parameters sent up in
		//		the request.
		// handleAs: String
		//		The final indicator on how the response will be
		//		handled.
		// id: String
		//		For dojo/io/script calls only, the internal
		//		script ID used for the request.
		// canDelete: Boolean
		//		For dojo/io/script calls only, indicates
		//		whether the script tag that represents the
		//		request can be deleted after callbacks have
		//		been called. Used internally to know when
		//		cleanup can happen on JSONP-type requests.
		// json: Object
		//		For dojo/io/script calls only: holds the JSON
		//		response for JSONP-type requests. Used
		//		internally to hold on to the JSON responses.
		//		You should not need to access it directly --
		//		the same object should be passed to the success
		//		callbacks directly.
	});

	dojo.__IoPublish = declare(null, {
		// summary:
		//		This is a list of IO topics that can be published
		//		if djConfig.ioPublish is set to true. IO topics can be
		//		published for any Input/Output, network operation. So,
		//		dojo.xhr, dojo.io.script and dojo.io.iframe can all
		//		trigger these topics to be published.
		// start: String
		//		"/dojo/io/start" is sent when there are no outstanding IO
		//		requests, and a new IO request is started. No arguments
		//		are passed with this topic.
		// send: String
		//		"/dojo/io/send" is sent whenever a new IO request is started.
		//		It passes the dojo.Deferred for the request with the topic.
		// load: String
		//		"/dojo/io/load" is sent whenever an IO request has loaded
		//		successfully. It passes the response and the dojo.Deferred
		//		for the request with the topic.
		// error: String
		//		"/dojo/io/error" is sent whenever an IO request has errored.
		//		It passes the error and the dojo.Deferred
		//		for the request with the topic.
		// done: String
		//		"/dojo/io/done" is sent whenever an IO request has completed,
		//		either by loading or by erroring. It passes the error and
		//		the dojo.Deferred for the request with the topic.
		// stop: String
		//		"/dojo/io/stop" is sent when all outstanding IO requests have
		//		finished. No arguments are passed with this topic.
	});
	=====*/


	dojo._ioSetArgs = function(/*dojo/main.__IoArgs*/args,
			/*Function*/canceller,
			/*Function*/okHandler,
			/*Function*/errHandler){
		// summary:
		//		sets up the Deferred and ioArgs property on the Deferred so it
		//		can be used in an io call.
		// args:
		//		The args object passed into the public io call. Recognized properties on
		//		the args object are:
		// canceller:
		//		The canceller function used for the Deferred object. The function
		//		will receive one argument, the Deferred object that is related to the
		//		canceller.
		// okHandler:
		//		The first OK callback to be registered with Deferred. It has the opportunity
		//		to transform the OK response. It will receive one argument -- the Deferred
		//		object returned from this function.
		// errHandler:
		//		The first error callback to be registered with Deferred. It has the opportunity
		//		to do cleanup on an error. It will receive two arguments: error (the
		//		Error object) and dfd, the Deferred object returned from this function.

		var ioArgs = {args: args, url: args.url};

		//Get values from form if requested.
		var formObject = null;
		if(args.form){
			var form = dom.byId(args.form);
			//IE requires going through getAttributeNode instead of just getAttribute in some form cases,
			//so use it for all. See #2844
			var actnNode = form.getAttributeNode("action");
			ioArgs.url = ioArgs.url || (actnNode ? actnNode.value : (dojo.doc ? dojo.doc.URL : null));
			formObject = domForm.toObject(form);
		}

		// set up the query params
		var miArgs = {};

		if(formObject){
			// potentially over-ride url-provided params w/ form values
			lang.mixin(miArgs, formObject);
		}
		if(args.content){
			// stuff in content over-rides what's set by form
			lang.mixin(miArgs, args.content);
		}
		if(args.preventCache){
			miArgs["dojo.preventCache"] = new Date().valueOf();
		}
		ioArgs.query = ioq.objectToQuery(miArgs);

		// .. and the real work of getting the deferred in order, etc.
		ioArgs.handleAs = args.handleAs || "text";
		var d = new Deferred(function(dfd){
			dfd.canceled = true;
			canceller && canceller(dfd);

			var err = dfd.ioArgs.error;
			if(!err){
				err = new Error("request cancelled");
				err.dojoType="cancel";
				dfd.ioArgs.error = err;
			}
			return err;
		});
		d.addCallback(okHandler);

		//Support specifying load, error and handle callback functions from the args.
		//For those callbacks, the "this" object will be the args object.
		//The callbacks will get the deferred result value as the
		//first argument and the ioArgs object as the second argument.
		var ld = args.load;
		if(ld && lang.isFunction(ld)){
			d.addCallback(function(value){
				return ld.call(args, value, ioArgs);
			});
		}
		var err = args.error;
		if(err && lang.isFunction(err)){
			d.addErrback(function(value){
				return err.call(args, value, ioArgs);
			});
		}
		var handle = args.handle;
		if(handle && lang.isFunction(handle)){
			d.addBoth(function(value){
				return handle.call(args, value, ioArgs);
			});
		}

		// Attach error handler last (not including topic publishing)
		// to catch any errors that may have been generated from load
		// or handle functions.
		d.addErrback(function(error){
			return errHandler(error, d);
		});

		//Plug in topic publishing, if dojo.publish is loaded.
		if(cfg.ioPublish && dojo.publish && ioArgs.args.ioPublish !== false){
			d.addCallbacks(
				function(res){
					dojo.publish("/dojo/io/load", [d, res]);
					return res;
				},
				function(res){
					dojo.publish("/dojo/io/error", [d, res]);
					return res;
				}
			);
			d.addBoth(function(res){
				dojo.publish("/dojo/io/done", [d, res]);
				return res;
			});
		}

		d.ioArgs = ioArgs;

		// FIXME: need to wire up the xhr object's abort method to something
		// analogous in the Deferred
		return d;
	};

	var _deferredOk = function(/*Deferred*/dfd){
		// summary:
		//		okHandler function for dojo._ioSetArgs call.

		var ret = handlers[dfd.ioArgs.handleAs](dfd.ioArgs.xhr);
		return ret === undefined ? null : ret;
	};
	var _deferError = function(/*Error*/error, /*Deferred*/dfd){
		// summary:
		//		errHandler function for dojo._ioSetArgs call.

		if(!dfd.ioArgs.args.failOk){
			console.error(error);
		}
		return error;
	};

	//Use a separate count for knowing if we are starting/stopping io calls.
	var _checkPubCount = function(dfd){
		if(_pubCount <= 0){
			_pubCount = 0;
			if(cfg.ioPublish && dojo.publish && (!dfd || dfd && dfd.ioArgs.args.ioPublish !== false)){
				dojo.publish("/dojo/io/stop");
			}
		}
	};

	var _pubCount = 0;
	aspect.after(watch, "_onAction", function(){
		_pubCount -= 1;
	});
	aspect.after(watch, "_onInFlight", _checkPubCount);

	dojo._ioCancelAll = watch.cancelAll;
	/*=====
	dojo._ioCancelAll = function(){
		// summary:
		//		Cancels all pending IO requests, regardless of IO type
		//		(xhr, script, iframe).
	};
	=====*/

	dojo._ioNotifyStart = function(/*Deferred*/dfd){
		// summary:
		//		If dojo.publish is available, publish topics
		//		about the start of a request queue and/or the
		//		the beginning of request.
		//
		//		Used by IO transports. An IO transport should
		//		call this method before making the network connection.
		if(cfg.ioPublish && dojo.publish && dfd.ioArgs.args.ioPublish !== false){
			if(!_pubCount){
				dojo.publish("/dojo/io/start");
			}
			_pubCount += 1;
			dojo.publish("/dojo/io/send", [dfd]);
		}
	};

	dojo._ioWatch = function(dfd, validCheck, ioCheck, resHandle){
		// summary:
		//		Watches the io request represented by dfd to see if it completes.
		// dfd: Deferred
		//		The Deferred object to watch.
		// validCheck: Function
		//		Function used to check if the IO request is still valid. Gets the dfd
		//		object as its only argument.
		// ioCheck: Function
		//		Function used to check if basic IO call worked. Gets the dfd
		//		object as its only argument.
		// resHandle: Function
		//		Function used to process response. Gets the dfd
		//		object as its only argument.

		var args = dfd.ioArgs.options = dfd.ioArgs.args;
		lang.mixin(dfd, {
			response: dfd.ioArgs,
			isValid: function(response){
				return validCheck(dfd);
			},
			isReady: function(response){
				return ioCheck(dfd);
			},
			handleResponse: function(response){
				return resHandle(dfd);
			}
		});
		watch(dfd);

		_checkPubCount(dfd);
	};

	var _defaultContentType = "application/x-www-form-urlencoded";

	dojo._ioAddQueryToUrl = function(/*dojo.__IoCallbackArgs*/ioArgs){
		// summary:
		//		Adds query params discovered by the io deferred construction to the URL.
		//		Only use this for operations which are fundamentally GET-type operations.
		if(ioArgs.query.length){
			ioArgs.url += (ioArgs.url.indexOf("?") == -1 ? "?" : "&") + ioArgs.query;
			ioArgs.query = null;
		}
	};

	/*=====
	dojo.__XhrArgs = declare(dojo.__IoArgs, {
		// summary:
		//		In addition to the properties listed for the dojo._IoArgs type,
		//		the following properties are allowed for dojo.xhr* methods.
		// handleAs: String?
		//		Acceptable values are: text (default), json, json-comment-optional,
		//		json-comment-filtered, javascript, xml. See `dojo/_base/xhr.contentHandlers`
	 	// sync: Boolean?
		//		false is default. Indicates whether the request should
		//		be a synchronous (blocking) request.
		// headers: Object?
		//		Additional HTTP headers to send in the request.
		// failOk: Boolean?
		//		false is default. Indicates whether a request should be
		//		allowed to fail (and therefore no console error message in
		//		the event of a failure)
		// contentType: String|Boolean
		//		"application/x-www-form-urlencoded" is default. Set to false to
		//		prevent a Content-Type header from being sent, or to a string
		//		to send a different Content-Type.
	 });
	=====*/

	dojo.xhr = function(/*String*/ method, /*dojo.__XhrArgs*/ args, /*Boolean?*/ hasBody){
		// summary:
		//		Deprecated.   Use dojo/request instead.
		// description:
		//		Sends an HTTP request with the given method.
		//		See also dojo.xhrGet(), xhrPost(), xhrPut() and dojo.xhrDelete() for shortcuts
		//		for those HTTP methods. There are also methods for "raw" PUT and POST methods
		//		via dojo.rawXhrPut() and dojo.rawXhrPost() respectively.
		// method:
		//		HTTP method to be used, such as GET, POST, PUT, DELETE. Should be uppercase.
		// hasBody:
		//		If the request has an HTTP body, then pass true for hasBody.

		var rDfd;
		//Make the Deferred object for this xhr request.
		var dfd = dojo._ioSetArgs(args, function(dfd){
			rDfd && rDfd.cancel();
		}, _deferredOk, _deferError);
		var ioArgs = dfd.ioArgs;

		//Allow for specifying the HTTP body completely.
		if("postData" in args){
			ioArgs.query = args.postData;
		}else if("putData" in args){
			ioArgs.query = args.putData;
		}else if("rawBody" in args){
			ioArgs.query = args.rawBody;
		}else if((arguments.length > 2 && !hasBody) || "POST|PUT".indexOf(method.toUpperCase()) === -1){
			//Check for hasBody being passed. If no hasBody,
			//then only append query string if not a POST or PUT request.
			dojo._ioAddQueryToUrl(ioArgs);
		}

		var options = {
			method: method,
			handleAs: "text",
			timeout: args.timeout,
			withCredentials: args.withCredentials,
			ioArgs: ioArgs
		};

		if(typeof args.headers !== 'undefined'){
			options.headers = args.headers;
		}
		if(typeof args.contentType !== 'undefined'){
			if(!options.headers){
				options.headers = {};
			}
			options.headers['Content-Type'] = args.contentType;
		}
		if(typeof ioArgs.query !== 'undefined'){
			options.data = ioArgs.query;
		}
		if(typeof args.sync !== 'undefined'){
			options.sync = args.sync;
		}

		dojo._ioNotifyStart(dfd);
		try{
			rDfd = _xhr(ioArgs.url, options, true);
		}catch(e){
			// If XHR creation fails, dojo/request/xhr throws
			// When this happens, cancel the deferred
			dfd.cancel();
			return dfd;
		}

		// sync ioArgs
		dfd.ioArgs.xhr = rDfd.response.xhr;

		rDfd.then(function(){
			dfd.resolve(dfd);
		}).otherwise(function(error){
			ioArgs.error = error;
			if(error.response){
				error.status = error.response.status;
				error.responseText = error.response.text;
				error.xhr = error.response.xhr;
			}
			dfd.reject(error);
		});
		return dfd; // dojo/_base/Deferred
	};

	dojo.xhrGet = function(/*dojo.__XhrArgs*/ args){
		// summary:
		//		Sends an HTTP GET request to the server.
		return dojo.xhr("GET", args); // dojo/_base/Deferred
	};

	dojo.rawXhrPost = dojo.xhrPost = function(/*dojo.__XhrArgs*/ args){
		// summary:
		//		Sends an HTTP POST request to the server. In addition to the properties
		//		listed for the dojo.__XhrArgs type, the following property is allowed:
		// postData:
		//		String. Send raw data in the body of the POST request.
		return dojo.xhr("POST", args, true); // dojo/_base/Deferred
	};

	dojo.rawXhrPut = dojo.xhrPut = function(/*dojo.__XhrArgs*/ args){
		// summary:
		//		Sends an HTTP PUT request to the server. In addition to the properties
		//		listed for the dojo.__XhrArgs type, the following property is allowed:
		// putData:
		//		String. Send raw data in the body of the PUT request.
		return dojo.xhr("PUT", args, true); // dojo/_base/Deferred
	};

	dojo.xhrDelete = function(/*dojo.__XhrArgs*/ args){
		// summary:
		//		Sends an HTTP DELETE request to the server.
		return dojo.xhr("DELETE", args); // dojo/_base/Deferred
	};

	/*
	dojo.wrapForm = function(formNode){
		// summary:
		//		A replacement for FormBind, but not implemented yet.

		// FIXME: need to think harder about what extensions to this we might
		// want. What should we allow folks to do w/ this? What events to
		// set/send?
		throw new Error("dojo.wrapForm not yet implemented");
	}
	*/

	dojo._isDocumentOk = function(x){
		return util.checkStatus(x.status);
	};

	dojo._getText = function(url){
		var result;
		dojo.xhrGet({url:url, sync:true, load:function(text){
			result = text;
		}});
		return result;
	};

	// Add aliases for static functions to dojo.xhr since dojo.xhr is what's returned from this module
	lang.mixin(dojo.xhr, {
		_xhrObj: dojo._xhrObj,
		fieldToObject: domForm.fieldToObject,
		formToObject: domForm.toObject,
		objectToQuery: ioq.objectToQuery,
		formToQuery: domForm.toQuery,
		formToJson: domForm.toJson,
		queryToObject: ioq.queryToObject,
		contentHandlers: handlers,
		_ioSetArgs: dojo._ioSetArgs,
		_ioCancelAll: dojo._ioCancelAll,
		_ioNotifyStart: dojo._ioNotifyStart,
		_ioWatch: dojo._ioWatch,
		_ioAddQueryToUrl: dojo._ioAddQueryToUrl,
		_isDocumentOk: dojo._isDocumentOk,
		_getText: dojo._getText,
		get: dojo.xhrGet,
		post: dojo.xhrPost,
		put: dojo.xhrPut,
		del: dojo.xhrDelete	// because "delete" is a reserved word
	});

	return dojo.xhr;
});

},
'dojo/_base/sniff':function(){
define(["./kernel", "./lang", "../sniff"], function(dojo, lang, has){
	// module:
	//		dojo/_base/sniff

	/*=====
	return {
		// summary:
		//		Deprecated.   New code should use dojo/sniff.
		//		This module populates the dojo browser version sniffing properties like dojo.isIE.
	};
	=====*/

	if(! 1 ){
		return has;
	}

	// no idea what this is for, or if it's used
	dojo._name = "browser";

	lang.mixin(dojo, {
		// isBrowser: Boolean
		//		True if the client is a web-browser
		isBrowser: true,

		// isFF: Number|undefined
		//		Version as a Number if client is FireFox. undefined otherwise. Corresponds to
		//		major detected FireFox version (1.5, 2, 3, etc.)
		isFF: has("ff"),

		// isIE: Number|undefined
		//		Version as a Number if client is MSIE(PC). undefined otherwise. Corresponds to
		//		major detected IE version (6, 7, 8, etc.)
		isIE: has("ie"),

		// isKhtml: Number|undefined
		//		Version as a Number if client is a KHTML browser. undefined otherwise. Corresponds to major
		//		detected version.
		isKhtml: has("khtml"),

		// isWebKit: Number|undefined
		//		Version as a Number if client is a WebKit-derived browser (Konqueror,
		//		Safari, Chrome, etc.). undefined otherwise.
		isWebKit: has("webkit"),

		// isMozilla: Number|undefined
		//		Version as a Number if client is a Mozilla-based browser (Firefox,
		//		SeaMonkey). undefined otherwise. Corresponds to major detected version.
		isMozilla: has("mozilla"),
		// isMoz: Number|undefined
		//		Version as a Number if client is a Mozilla-based browser (Firefox,
		//		SeaMonkey). undefined otherwise. Corresponds to major detected version.
		isMoz: has("mozilla"),

		// isOpera: Number|undefined
		//		Version as a Number if client is Opera. undefined otherwise. Corresponds to
		//		major detected version.
		isOpera: has("opera"),

		// isSafari: Number|undefined
		//		Version as a Number if client is Safari or iPhone. undefined otherwise.
		isSafari: has("safari"),

		// isChrome: Number|undefined
		//		Version as a Number if client is Chrome browser. undefined otherwise.
		isChrome: has("chrome"),

		// isMac: Boolean
		//		True if the client runs on Mac
		isMac: has("mac"),

		// isIos: Number|undefined
		//		Version as a Number if client is iPhone, iPod, or iPad. undefined otherwise.
		isIos: has("ios"),

		// isAndroid: Number|undefined
		//		Version as a Number if client is android browser. undefined otherwise.
		isAndroid: has("android"),

		// isWii: Boolean
		//		True if client is Wii
		isWii: has("wii"),

		// isQuirks: Boolean
		//		Page is in quirks mode.
		isQuirks: has("quirks"),

		// isAir: Boolean
		//		True if client is Adobe Air
		isAir: has("air")
	});

	return has;
});

},
'dojo/io-query':function(){
define(["./_base/lang"], function(lang){

	// module:
	//		dojo/io-query

	var backstop = {};

	return {
		// summary:
		//		This module defines query string processing functions.

		objectToQuery: function objectToQuery(/*Object*/ map){
			// summary:
			//		takes a name/value mapping object and returns a string representing
			//		a URL-encoded version of that object.
			// example:
			//		this object:
			//
			//	|	{
			//	|		blah: "blah",
			//	|		multi: [
			//	|			"thud",
			//	|			"thonk"
			//	|		]
			//	|	};
			//
			//		yields the following query string:
			//
			//	|	"blah=blah&multi=thud&multi=thonk"

			// FIXME: need to implement encodeAscii!!
			var enc = encodeURIComponent, pairs = [];
			for(var name in map){
				var value = map[name];
				if(value != backstop[name]){
					var assign = enc(name) + "=";
					if(lang.isArray(value)){
						for(var i = 0, l = value.length; i < l; ++i){
							pairs.push(assign + enc(value[i]));
						}
					}else{
						pairs.push(assign + enc(value));
					}
				}
			}
			return pairs.join("&"); // String
		},

		queryToObject: function queryToObject(/*String*/ str){
			// summary:
			//		Create an object representing a de-serialized query section of a
			//		URL. Query keys with multiple values are returned in an array.
			//
			// example:
			//		This string:
			//
			//	|		"foo=bar&foo=baz&thinger=%20spaces%20=blah&zonk=blarg&"
			//
			//		results in this object structure:
			//
			//	|		{
			//	|			foo: [ "bar", "baz" ],
			//	|			thinger: " spaces =blah",
			//	|			zonk: "blarg"
			//	|		}
			//
			//		Note that spaces and other urlencoded entities are correctly
			//		handled.

        	var dec = decodeURIComponent, qp = str.split("&"), ret = {}, name, val;
			for(var i = 0, l = qp.length, item; i < l; ++i){
				item = qp[i];
				if(item.length){
					var s = item.indexOf("=");
					if(s < 0){
						name = dec(item);
						val = "";
					}else{
						name = dec(item.slice(0, s));
						val = dec(item.slice(s + 1));
					}
					if(typeof ret[name] == "string"){ // inline'd type check
						ret[name] = [ret[name]];
					}

					if(lang.isArray(ret[name])){
						ret[name].push(val);
					}else{
						ret[name] = val;
					}
				}
			}
			return ret; // Object
		}
	};
});
},
'dojo/dom':function(){
define(["./sniff", "./_base/window", "./_base/kernel"],
		function(has, win, kernel){
	// module:
	//		dojo/dom

	// FIXME: need to add unit tests for all the semi-public methods

	if(has("ie") <= 7){
		try{
			document.execCommand("BackgroundImageCache", false, true);
		}catch(e){
			// sane browsers don't have cache "issues"
		}
	}

	// =============================
	// DOM Functions
	// =============================

	// the result object
	var dom = {
		// summary:
		//		This module defines the core dojo DOM API.
	};

	if(has("ie")){
		dom.byId = function(id, doc){
			if(typeof id != "string"){
				return id || null;
			}
			var _d = doc || win.doc, te = id && _d.getElementById(id);
			// attributes.id.value is better than just id in case the
			// user has a name=id inside a form
			if(te && (te.attributes.id.value == id || te.id == id)){
				return te;
			}else{
				var eles = _d.all[id];
				if(!eles || eles.nodeName){
					eles = [eles];
				}
				// if more than 1, choose first with the correct id
				var i = 0;
				while((te = eles[i++])){
					if((te.attributes && te.attributes.id && te.attributes.id.value == id) || te.id == id){
						return te;
					}
				}
			}
			return null;
		};
	}else{
		dom.byId = function(id, doc){
			// inline'd type check.
			// be sure to return null per documentation, to match IE branch.
			return ((typeof id == "string") ? (doc || win.doc).getElementById(id) : id) || null; // DOMNode
		};
	}
	/*=====
	 dom.byId = function(id, doc){
		// summary:
		//		Returns DOM node with matching `id` attribute or falsy value (ex: null or undefined)
		//		if not found.  If `id` is a DomNode, this function is a no-op.
		//
		// id: String|DOMNode
		//		A string to match an HTML id attribute or a reference to a DOM Node
		//
		// doc: Document?
		//		Document to work in. Defaults to the current value of
		//		dojo/_base/window.doc.  Can be used to retrieve
		//		node references from other documents.
		//
		// example:
		//		Look up a node by ID:
		//	|	require(["dojo/dom"], function(dom){
		//	|		var n = dom.byId("foo");
		//	|	});
		//
		// example:
		//		Check if a node exists, and use it.
		//	|	require(["dojo/dom"], function(dom){
		//	|		var n = dom.byId("bar");
		//	|		if(n){ doStuff() ... }
		//	|	});
		//
		// example:
		//		Allow string or DomNode references to be passed to a custom function:
		//	|	require(["dojo/dom"], function(dom){
		//	|		var foo = function(nodeOrId){
		//	|			nodeOrId = dom.byId(nodeOrId);
		//	|			// ... more stuff
		//	|		}
		//	|	});
	 };
	 =====*/

	// Test for DOMNode.contains() method, available everywhere except FF8-
	// and IE8-, where it's available in general, but not on document itself,
	// and also problems when either ancestor or node are text nodes.

	var doc = kernel.global["document"] || null;
	has.add("dom-contains", !!(doc && doc.contains));
	dom.isDescendant = has("dom-contains") ?
		// FF9+, IE9+, webkit, opera, iOS, Android, Edge, etc.
		function(/*DOMNode|String*/ node, /*DOMNode|String*/ ancestor){
			return !!( (ancestor = dom.byId(ancestor)) && ancestor.contains(dom.byId(node)) );
		} :
		function(/*DOMNode|String*/ node, /*DOMNode|String*/ ancestor){
			// summary:
			//		Returns true if node is a descendant of ancestor
			// node: DOMNode|String
			//		string id or node reference to test
			// ancestor: DOMNode|String
			//		string id or node reference of potential parent to test against
			//
			// example:
			//		Test is node id="bar" is a descendant of node id="foo"
			//	|	require(["dojo/dom"], function(dom){
			//	|		if(dom.isDescendant("bar", "foo")){ ... }
			//	|	});

			try{
				node = dom.byId(node);
				ancestor = dom.byId(ancestor);
				while(node){
					if(node == ancestor){
						return true; // Boolean
					}
					node = node.parentNode;
				}
			}catch(e){ /* squelch, return false */ }
			return false; // Boolean
		};

	// TODO: do we need setSelectable in the base?

	// Add feature test for user-select CSS property
	// (currently known to work in all but IE < 10 and Opera)
	// TODO: The user-select CSS property as of May 2014 is no longer part of
	// any CSS specification. In IE, -ms-user-select does not do the same thing
	// as the unselectable attribute on elements; namely, dijit Editor buttons
	// do not properly prevent the content of the editable content frame from
	// unblurring. As a result, the -ms- prefixed version is omitted here.
	has.add("css-user-select", function(global, doc, element){
		// Avoid exception when dom.js is loaded in non-browser environments
		if(!element){ return false; }

		var style = element.style;
		var prefixes = ["Khtml", "O", "Moz", "Webkit"],
			i = prefixes.length,
			name = "userSelect",
			prefix;

		// Iterate prefixes from most to least likely
		do{
			if(typeof style[name] !== "undefined"){
				// Supported; return property name
				return name;
			}
		}while(i-- && (name = prefixes[i] + "UserSelect"));

		// Not supported if we didn't return before now
		return false;
	});

	/*=====
	dom.setSelectable = function(node, selectable){
		// summary:
		//		Enable or disable selection on a node
		// node: DOMNode|String
		//		id or reference to node
		// selectable: Boolean
		//		state to put the node in. false indicates unselectable, true
		//		allows selection.
		// example:
		//		Make the node id="bar" unselectable
		//	|	require(["dojo/dom"], function(dom){
		//	|		dom.setSelectable("bar");
		//	|	});
		// example:
		//		Make the node id="bar" selectable
		//	|	require(["dojo/dom"], function(dom){
		//	|		dom.setSelectable("bar", true);
		//	|	});
	};
	=====*/

	var cssUserSelect = has("css-user-select");
	dom.setSelectable = cssUserSelect ? function(node, selectable){
		// css-user-select returns a (possibly vendor-prefixed) CSS property name
		dom.byId(node).style[cssUserSelect] = selectable ? "" : "none";
	} : function(node, selectable){
		node = dom.byId(node);

		// (IE < 10 / Opera) Fall back to setting/removing the
		// unselectable attribute on the element and all its children
		var nodes = node.getElementsByTagName("*"),
			i = nodes.length;

		if(selectable){
			node.removeAttribute("unselectable");
			while(i--){
				nodes[i].removeAttribute("unselectable");
			}
		}else{
			node.setAttribute("unselectable", "on");
			while(i--){
				nodes[i].setAttribute("unselectable", "on");
			}
		}
	};

	return dom;
});

},
'dojo/_base/window':function(){
define(["./kernel", "./lang", "../sniff"], function(dojo, lang, has){
// module:
//		dojo/_base/window

var ret = {
	// summary:
	//		API to save/set/restore the global/document scope.

	global: dojo.global,
	/*=====
	 global: {
		 // summary:
		 //		Alias for the current window. 'global' can be modified
		 //		for temporary context shifting. See also withGlobal().
		 // description:
		 //		Use this rather than referring to 'window' to ensure your code runs
		 //		correctly in managed contexts.
	 },
	 =====*/

	doc: dojo.global["document"] || null,
	/*=====
	doc: {
		// summary:
		//		Alias for the current document. 'doc' can be modified
		//		for temporary context shifting. See also withDoc().
		// description:
		//		Use this rather than referring to 'window.document' to ensure your code runs
		//		correctly in managed contexts.
		// example:
		//	|	n.appendChild(dojo.doc.createElement('div'));
	},
	=====*/

	body: function(/*Document?*/ doc){
		// summary:
		//		Return the body element of the specified document or of dojo/_base/window::doc.
		// example:
		//	|	win.body().appendChild(dojo.doc.createElement('div'));

		// Note: document.body is not defined for a strict xhtml document
		// Would like to memoize this, but dojo.doc can change vi dojo.withDoc().
		doc = doc || dojo.doc;
		return doc.body || doc.getElementsByTagName("body")[0]; // Node
	},

	setContext: function(/*Object*/ globalObject, /*DocumentElement*/ globalDocument){
		// summary:
		//		changes the behavior of many core Dojo functions that deal with
		//		namespace and DOM lookup, changing them to work in a new global
		//		context (e.g., an iframe). The varibles dojo.global and dojo.doc
		//		are modified as a result of calling this function and the result of
		//		`dojo.body()` likewise differs.
		dojo.global = ret.global = globalObject;
		dojo.doc = ret.doc = globalDocument;
	},

	withGlobal: function(	/*Object*/ globalObject,
							/*Function*/ callback,
							/*Object?*/ thisObject,
							/*Array?*/ cbArguments){
		// summary:
		//		Invoke callback with globalObject as dojo.global and
		//		globalObject.document as dojo.doc.
		// description:
		//		Invoke callback with globalObject as dojo.global and
		//		globalObject.document as dojo.doc. If provided, globalObject
		//		will be executed in the context of object thisObject
		//		When callback() returns or throws an error, the dojo.global
		//		and dojo.doc will be restored to its previous state.

		var oldGlob = dojo.global;
		try{
			dojo.global = ret.global = globalObject;
			return ret.withDoc.call(null, globalObject.document, callback, thisObject, cbArguments);
		}finally{
			dojo.global = ret.global = oldGlob;
		}
	},

	withDoc: function(	/*DocumentElement*/ documentObject,
						/*Function*/ callback,
						/*Object?*/ thisObject,
						/*Array?*/ cbArguments){
		// summary:
		//		Invoke callback with documentObject as dojo/_base/window::doc.
		// description:
		//		Invoke callback with documentObject as dojo/_base/window::doc. If provided,
		//		callback will be executed in the context of object thisObject
		//		When callback() returns or throws an error, the dojo/_base/window::doc will
		//		be restored to its previous state.

		var oldDoc = ret.doc,
			oldQ = has("quirks"),
			oldIE = has("ie"), isIE, mode, pwin;

		try{
			dojo.doc = ret.doc = documentObject;
			// update dojo.isQuirks and the value of the has feature "quirks".
			// remove setting dojo.isQuirks and dojo.isIE for 2.0
			dojo.isQuirks = has.add("quirks", dojo.doc.compatMode == "BackCompat", true, true); // no need to check for QuirksMode which was Opera 7 only

			if(has("ie")){
				if((pwin = documentObject.parentWindow) && pwin.navigator){
					// re-run IE detection logic and update dojo.isIE / has("ie")
					// (the only time parentWindow/navigator wouldn't exist is if we were not
					// passed an actual legitimate document object)
					isIE = parseFloat(pwin.navigator.appVersion.split("MSIE ")[1]) || undefined;
					mode = documentObject.documentMode;
					if(mode && mode != 5 && Math.floor(isIE) != mode){
						isIE = mode;
					}
					dojo.isIE = has.add("ie", isIE, true, true);
				}
			}

			if(thisObject && typeof callback == "string"){
				callback = thisObject[callback];
			}

			return callback.apply(thisObject, cbArguments || []);
		}finally{
			dojo.doc = ret.doc = oldDoc;
			dojo.isQuirks = has.add("quirks", oldQ, true, true);
			dojo.isIE = has.add("ie", oldIE, true, true);
		}
	}
};

 1  && lang.mixin(dojo, ret);

return ret;

});

},
'dojo/dom-form':function(){
define(["./_base/lang", "./dom", "./io-query", "./json"], function(lang, dom, ioq, json){
	// module:
	//		dojo/dom-form

    function setValue(/*Object*/ obj, /*String*/ name, /*String*/ value){
        // summary:
        //		For the named property in object, set the value. If a value
        //		already exists and it is a string, convert the value to be an
        //		array of values.

        // Skip it if there is no value
        if(value === null){
            return;
        }

        var val = obj[name];
        if(typeof val == "string"){ // inline'd type check
            obj[name] = [val, value];
        }else if(lang.isArray(val)){
            val.push(value);
        }else{
            obj[name] = value;
        }
    }

	var exclude = "file|submit|image|reset|button";

	var form = {
		// summary:
		//		This module defines form-processing functions.

		fieldToObject: function fieldToObject(/*DOMNode|String*/ inputNode){
			// summary:
			//		Serialize a form field to a JavaScript object.
			// description:
			//		Returns the value encoded in a form field as
			//		as a string or an array of strings. Disabled form elements
			//		and unchecked radio and checkboxes are skipped.	Multi-select
			//		elements are returned as an array of string values.
			// inputNode: DOMNode|String
			// returns: Object

			var ret = null;
			inputNode = dom.byId(inputNode);
			if(inputNode){
				var _in = inputNode.name, type = (inputNode.type || "").toLowerCase();
				if(_in && type && !inputNode.disabled){
					if(type == "radio" || type == "checkbox"){
						if(inputNode.checked){
							ret = inputNode.value;
						}
					}else if(inputNode.multiple){
						ret = [];
						var nodes = [inputNode.firstChild];
						while(nodes.length){
							for(var node = nodes.pop(); node; node = node.nextSibling){
								if(node.nodeType == 1 && node.tagName.toLowerCase() == "option"){
									if(node.selected){
										ret.push(node.value);
									}
								}else{
									if(node.nextSibling){
										nodes.push(node.nextSibling);
									}
									if(node.firstChild){
										nodes.push(node.firstChild);
									}
									break;
								}
							}
						}
					}else{
						ret = inputNode.value;
					}
				}
			}
			return ret; // Object
		},

		toObject: function formToObject(/*DOMNode|String*/ formNode){
			// summary:
			//		Serialize a form node to a JavaScript object.
			// description:
			//		Returns the values encoded in an HTML form as
			//		string properties in an object which it then returns. Disabled form
			//		elements, buttons, and other non-value form elements are skipped.
			//		Multi-select elements are returned as an array of string values.
			// formNode: DOMNode|String
			// example:
			//		This form:
			//		|	<form id="test_form">
			//		|		<input type="text" name="blah" value="blah">
			//		|		<input type="text" name="no_value" value="blah" disabled>
			//		|		<input type="button" name="no_value2" value="blah">
			//		|		<select type="select" multiple name="multi" size="5">
			//		|			<option value="blah">blah</option>
			//		|			<option value="thud" selected>thud</option>
			//		|			<option value="thonk" selected>thonk</option>
			//		|		</select>
			//		|	</form>
			//
			//		yields this object structure as the result of a call to
			//		formToObject():
			//
			//		|	{
			//		|		blah: "blah",
			//		|		multi: [
			//		|			"thud",
			//		|			"thonk"
			//		|		]
			//		|	};

			var ret = {}, elems = dom.byId(formNode).elements;
			for(var i = 0, l = elems.length; i < l; ++i){
				var item = elems[i], _in = item.name, type = (item.type || "").toLowerCase();
				if(_in && type && exclude.indexOf(type) < 0 && !item.disabled){
					setValue(ret, _in, form.fieldToObject(item));
					if(type == "image"){
						ret[_in + ".x"] = ret[_in + ".y"] = ret[_in].x = ret[_in].y = 0;
					}
				}
			}
			return ret; // Object
		},

		toQuery: function formToQuery(/*DOMNode|String*/ formNode){
			// summary:
			//		Returns a URL-encoded string representing the form passed as either a
			//		node or string ID identifying the form to serialize
			// formNode: DOMNode|String
			// returns: String

			return ioq.objectToQuery(form.toObject(formNode)); // String
		},

		toJson: function formToJson(/*DOMNode|String*/ formNode, /*Boolean?*/ prettyPrint){
			// summary:
			//		Create a serialized JSON string from a form node or string
			//		ID identifying the form to serialize
			// formNode: DOMNode|String
			// prettyPrint: Boolean?
			// returns: String

			return json.stringify(form.toObject(formNode), null, prettyPrint ? 4 : 0); // String
		}
	};

    return form;
});

},
'dojo/json':function(){
define(["./has"], function(has){
	"use strict";
	var hasJSON = typeof JSON != "undefined";
	has.add("json-parse", hasJSON); // all the parsers work fine
		// Firefox 3.5/Gecko 1.9 fails to use replacer in stringify properly https://bugzilla.mozilla.org/show_bug.cgi?id=509184
	has.add("json-stringify", hasJSON && JSON.stringify({a:0}, function(k,v){return v||1;}) == '{"a":1}');

	/*=====
	return {
		// summary:
		//		Functions to parse and serialize JSON

		parse: function(str, strict){
			// summary:
			//		Parses a [JSON](http://json.org) string to return a JavaScript object.
			// description:
			//		This function follows [native JSON API](https://developer.mozilla.org/en/JSON)
			//		Throws for invalid JSON strings. This delegates to eval() if native JSON
			//		support is not available. By default this will evaluate any valid JS expression.
			//		With the strict parameter set to true, the parser will ensure that only
			//		valid JSON strings are parsed (otherwise throwing an error). Without the strict
			//		parameter, the content passed to this method must come
			//		from a trusted source.
			// str:
			//		a string literal of a JSON item, for instance:
			//		`'{ "foo": [ "bar", 1, { "baz": "thud" } ] }'`
			// strict:
			//		When set to true, this will ensure that only valid, secure JSON is ever parsed.
			//		Make sure this is set to true for untrusted content. Note that on browsers/engines
			//		without native JSON support, setting this to true will run slower.
		},
		stringify: function(value, replacer, spacer){
			// summary:
			//		Returns a [JSON](http://json.org) serialization of an object.
			// description:
			//		Returns a [JSON](http://json.org) serialization of an object.
			//		This function follows [native JSON API](https://developer.mozilla.org/en/JSON)
			//		Note that this doesn't check for infinite recursion, so don't do that!
			// value:
			//		A value to be serialized.
			// replacer:
			//		A replacer function that is called for each value and can return a replacement
			// spacer:
			//		A spacer string to be used for pretty printing of JSON
			// example:
			//		simple serialization of a trivial object
			//	|	define(["dojo/json"], function(JSON){
			// 	|		var jsonStr = JSON.stringify({ howdy: "stranger!", isStrange: true });
			//	|		doh.is('{"howdy":"stranger!","isStrange":true}', jsonStr);
		}
	};
	=====*/

	if(has("json-stringify")){
		return JSON;
	}else{
		var escapeString = function(/*String*/str){
			// summary:
			//		Adds escape sequences for non-visual characters, double quote and
			//		backslash and surrounds with double quotes to form a valid string
			//		literal.
			return ('"' + str.replace(/(["\\])/g, '\\$1') + '"').
				replace(/[\f]/g, "\\f").replace(/[\b]/g, "\\b").replace(/[\n]/g, "\\n").
				replace(/[\t]/g, "\\t").replace(/[\r]/g, "\\r"); // string
		};
		return {
			parse: has("json-parse") ? JSON.parse : function(str, strict){
				if(strict && !/^([\s\[\{]*(?:"(?:\\.|[^"])*"|-?\d[\d\.]*(?:[Ee][+-]?\d+)?|null|true|false|)[\s\]\}]*(?:,|:|$))+$/.test(str)){
					throw new SyntaxError("Invalid characters in JSON");
				}
				return eval('(' + str + ')');
			},
			stringify: function(value, replacer, spacer){
				var undef;
				if(typeof replacer == "string"){
					spacer = replacer;
					replacer = null;
				}
				function stringify(it, indent, key){
					if(replacer){
						it = replacer(key, it);
					}
					var val, objtype = typeof it;
					if(objtype == "number"){
						return isFinite(it) ? it + "" : "null";
					}
					if(objtype == "boolean"){
						return it + "";
					}
					if(it === null){
						return "null";
					}
					if(typeof it == "string"){
						return escapeString(it);
					}
					if(objtype == "function" || objtype == "undefined"){
						return undef; // undefined
					}
					// short-circuit for objects that support "json" serialization
					// if they return "self" then just pass-through...
					if(typeof it.toJSON == "function"){
						return stringify(it.toJSON(key), indent, key);
					}
					if(it instanceof Date){
						return '"{FullYear}-{Month+}-{Date}T{Hours}:{Minutes}:{Seconds}Z"'.replace(/\{(\w+)(\+)?\}/g, function(t, prop, plus){
							var num = it["getUTC" + prop]() + (plus ? 1 : 0);
							return num < 10 ? "0" + num : num;
						});
					}
					if(it.valueOf() !== it){
						// primitive wrapper, try again unwrapped:
						return stringify(it.valueOf(), indent, key);
					}
					var nextIndent= spacer ? (indent + spacer) : "";
					/* we used to test for DOM nodes and throw, but FF serializes them as {}, so cross-browser consistency is probably not efficiently attainable */ 
				
					var sep = spacer ? " " : "";
					var newLine = spacer ? "\n" : "";
				
					// array
					if(it instanceof Array){
						var itl = it.length, res = [];
						for(key = 0; key < itl; key++){
							var obj = it[key];
							val = stringify(obj, nextIndent, key);
							if(typeof val != "string"){
								val = "null";
							}
							res.push(newLine + nextIndent + val);
						}
						return "[" + res.join(",") + newLine + indent + "]";
					}
					// generic object code path
					var output = [];
					for(key in it){
						var keyStr;
						if(it.hasOwnProperty(key)){
							if(typeof key == "number"){
								keyStr = '"' + key + '"';
							}else if(typeof key == "string"){
								keyStr = escapeString(key);
							}else{
								// skip non-string or number keys
								continue;
							}
							val = stringify(it[key], nextIndent, key);
							if(typeof val != "string"){
								// skip non-serializable values
								continue;
							}
							// At this point, the most non-IE browsers don't get in this branch 
							// (they have native JSON), so push is definitely the way to
							output.push(newLine + nextIndent + keyStr + ":" + sep + val);
						}
					}
					return "{" + output.join(",") + newLine + indent + "}"; // String
				}
				return stringify(value, "", "");
			}
		};
	}
});

},
'dojo/_base/Deferred':function(){
define([
	"./kernel",
	"../Deferred",
	"../promise/Promise",
	"../errors/CancelError",
	"../has",
	"./lang",
	"../when"
], function(dojo, NewDeferred, Promise, CancelError, has, lang, when){
	// module:
	//		dojo/_base/Deferred

	var mutator = function(){};
	var freeze = Object.freeze || function(){};
	// A deferred provides an API for creating and resolving a promise.
	var Deferred = dojo.Deferred = function(/*Function?*/ canceller){
		// summary:
		//		Deprecated.   This module defines the legacy dojo/_base/Deferred API.
		//		New code should use dojo/Deferred instead.
		// description:
		//		The Deferred API is based on the concept of promises that provide a
		//		generic interface into the eventual completion of an asynchronous action.
		//		The motivation for promises fundamentally is about creating a
		//		separation of concerns that allows one to achieve the same type of
		//		call patterns and logical data flow in asynchronous code as can be
		//		achieved in synchronous code. Promises allows one
		//		to be able to call a function purely with arguments needed for
		//		execution, without conflating the call with concerns of whether it is
		//		sync or async. One shouldn't need to alter a call's arguments if the
		//		implementation switches from sync to async (or vice versa). By having
		//		async functions return promises, the concerns of making the call are
		//		separated from the concerns of asynchronous interaction (which are
		//		handled by the promise).
		//
		//		The Deferred is a type of promise that provides methods for fulfilling the
		//		promise with a successful result or an error. The most important method for
		//		working with Dojo's promises is the then() method, which follows the
		//		CommonJS proposed promise API. An example of using a Dojo promise:
		//
		//		|	var resultingPromise = someAsyncOperation.then(function(result){
		//		|		... handle result ...
		//		|	},
		//		|	function(error){
		//		|		... handle error ...
		//		|	});
		//
		//		The .then() call returns a new promise that represents the result of the
		//		execution of the callback. The callbacks will never affect the original promises value.
		//
		//		The Deferred instances also provide the following functions for backwards compatibility:
		//
		//		- addCallback(handler)
		//		- addErrback(handler)
		//		- callback(result)
		//		- errback(result)
		//
		//		Callbacks are allowed to return promises themselves, so
		//		you can build complicated sequences of events with ease.
		//
		//		The creator of the Deferred may specify a canceller.  The canceller
		//		is a function that will be called if Deferred.cancel is called
		//		before the Deferred fires. You can use this to implement clean
		//		aborting of an XMLHttpRequest, etc. Note that cancel will fire the
		//		deferred with a CancelledError (unless your canceller returns
		//		another kind of error), so the errbacks should be prepared to
		//		handle that error for cancellable Deferreds.
		// example:
		//	|	var deferred = new Deferred();
		//	|	setTimeout(function(){ deferred.callback({success: true}); }, 1000);
		//	|	return deferred;
		// example:
		//		Deferred objects are often used when making code asynchronous. It
		//		may be easiest to write functions in a synchronous manner and then
		//		split code using a deferred to trigger a response to a long-lived
		//		operation. For example, instead of register a callback function to
		//		denote when a rendering operation completes, the function can
		//		simply return a deferred:
		//
		//		|	// callback style:
		//		|	function renderLotsOfData(data, callback){
		//		|		var success = false
		//		|		try{
		//		|			for(var x in data){
		//		|				renderDataitem(data[x]);
		//		|			}
		//		|			success = true;
		//		|		}catch(e){ }
		//		|		if(callback){
		//		|			callback(success);
		//		|		}
		//		|	}
		//
		//		|	// using callback style
		//		|	renderLotsOfData(someDataObj, function(success){
		//		|		// handles success or failure
		//		|		if(!success){
		//		|			promptUserToRecover();
		//		|		}
		//		|	});
		//		|	// NOTE: no way to add another callback here!!
		// example:
		//		Using a Deferred doesn't simplify the sending code any, but it
		//		provides a standard interface for callers and senders alike,
		//		providing both with a simple way to service multiple callbacks for
		//		an operation and freeing both sides from worrying about details
		//		such as "did this get called already?". With Deferreds, new
		//		callbacks can be added at any time.
		//
		//		|	// Deferred style:
		//		|	function renderLotsOfData(data){
		//		|		var d = new Deferred();
		//		|		try{
		//		|			for(var x in data){
		//		|				renderDataitem(data[x]);
		//		|			}
		//		|			d.callback(true);
		//		|		}catch(e){
		//		|			d.errback(new Error("rendering failed"));
		//		|		}
		//		|		return d;
		//		|	}
		//
		//		|	// using Deferred style
		//		|	renderLotsOfData(someDataObj).then(null, function(){
		//		|		promptUserToRecover();
		//		|	});
		//		|	// NOTE: addErrback and addCallback both return the Deferred
		//		|	// again, so we could chain adding callbacks or save the
		//		|	// deferred for later should we need to be notified again.
		// example:
		//		In this example, renderLotsOfData is synchronous and so both
		//		versions are pretty artificial. Putting the data display on a
		//		timeout helps show why Deferreds rock:
		//
		//		|	// Deferred style and async func
		//		|	function renderLotsOfData(data){
		//		|		var d = new Deferred();
		//		|		setTimeout(function(){
		//		|			try{
		//		|				for(var x in data){
		//		|					renderDataitem(data[x]);
		//		|				}
		//		|				d.callback(true);
		//		|			}catch(e){
		//		|				d.errback(new Error("rendering failed"));
		//		|			}
		//		|		}, 100);
		//		|		return d;
		//		|	}
		//
		//		|	// using Deferred style
		//		|	renderLotsOfData(someDataObj).then(null, function(){
		//		|		promptUserToRecover();
		//		|	});
		//
		//		Note that the caller doesn't have to change his code at all to
		//		handle the asynchronous case.

		var result, finished, canceled, fired, isError, head, nextListener;
		var promise = (this.promise = new Promise());

		function complete(value){
			if(finished){
				throw new Error("This deferred has already been resolved");
			}
			result = value;
			finished = true;
			notify();
		}
		function notify(){
			var mutated;
			while(!mutated && nextListener){
				var listener = nextListener;
				nextListener = nextListener.next;
				if((mutated = (listener.progress == mutator))){ // assignment and check
					finished = false;
				}

				var func = (isError ? listener.error : listener.resolved);
				if(has("config-useDeferredInstrumentation")){
					if(isError && NewDeferred.instrumentRejected){
						NewDeferred.instrumentRejected(result, !!func);
					}
				}
				if(func){
					try{
						var newResult = func(result);
						if (newResult && typeof newResult.then === "function"){
							newResult.then(lang.hitch(listener.deferred, "resolve"), lang.hitch(listener.deferred, "reject"), lang.hitch(listener.deferred, "progress"));
							continue;
						}
						var unchanged = mutated && newResult === undefined;
						if(mutated && !unchanged){
							isError = newResult instanceof Error;
						}
						listener.deferred[unchanged && isError ? "reject" : "resolve"](unchanged ? result : newResult);
					}catch(e){
						listener.deferred.reject(e);
					}
				}else{
					if(isError){
						listener.deferred.reject(result);
					}else{
						listener.deferred.resolve(result);
					}
				}
			}
		}

		this.isResolved = promise.isResolved = function(){
			// summary:
			//		Checks whether the deferred has been resolved.
			// returns: Boolean

			return fired == 0;
		};

		this.isRejected = promise.isRejected = function(){
			// summary:
			//		Checks whether the deferred has been rejected.
			// returns: Boolean

			return fired == 1;
		};

		this.isFulfilled = promise.isFulfilled = function(){
			// summary:
			//		Checks whether the deferred has been resolved or rejected.
			// returns: Boolean

			return fired >= 0;
		};

		this.isCanceled = promise.isCanceled = function(){
			// summary:
			//		Checks whether the deferred has been canceled.
			// returns: Boolean

			return canceled;
		};

		// calling resolve will resolve the promise
		this.resolve = this.callback = function(value){
			// summary:
			//		Fulfills the Deferred instance successfully with the provide value
			this.fired = fired = 0;
			this.results = [value, null];
			complete(value);
		};


		// calling error will indicate that the promise failed
		this.reject = this.errback = function(error){
			// summary:
			//		Fulfills the Deferred instance as an error with the provided error
			isError = true;
			this.fired = fired = 1;
			if(has("config-useDeferredInstrumentation")){
				if(NewDeferred.instrumentRejected){
					NewDeferred.instrumentRejected(error, !!nextListener);
				}
			}
			complete(error);
			this.results = [null, error];
		};
		// call progress to provide updates on the progress on the completion of the promise
		this.progress = function(update){
			// summary:
			//		Send progress events to all listeners
			var listener = nextListener;
			while(listener){
				var progress = listener.progress;
				progress && progress(update);
				listener = listener.next;
			}
		};
		this.addCallbacks = function(callback, errback){
			// summary:
			//		Adds callback and error callback for this deferred instance.
			// callback: Function?
			//		The callback attached to this deferred object.
			// errback: Function?
			//		The error callback attached to this deferred object.
			// returns:
			//		Returns this deferred object.
			this.then(callback, errback, mutator);
			return this;	// Deferred
		};
		// provide the implementation of the promise
		promise.then = this.then = function(/*Function?*/resolvedCallback, /*Function?*/errorCallback, /*Function?*/progressCallback){
			// summary:
			//		Adds a fulfilledHandler, errorHandler, and progressHandler to be called for
			//		completion of a promise. The fulfilledHandler is called when the promise
			//		is fulfilled. The errorHandler is called when a promise fails. The
			//		progressHandler is called for progress events. All arguments are optional
			//		and non-function values are ignored. The progressHandler is not only an
			//		optional argument, but progress events are purely optional. Promise
			//		providers are not required to ever create progress events.
			//
			//		This function will return a new promise that is fulfilled when the given
			//		fulfilledHandler or errorHandler callback is finished. This allows promise
			//		operations to be chained together. The value returned from the callback
			//		handler is the fulfillment value for the returned promise. If the callback
			//		throws an error, the returned promise will be moved to failed state.
			//
			// returns:
			//		Returns a new promise that represents the result of the
			//		execution of the callback. The callbacks will never affect the original promises value.
			// example:
			//		An example of using a CommonJS compliant promise:
			//		|	asyncComputeTheAnswerToEverything().
			//		|		then(addTwo).
			//		|		then(printResult, onError);
			//		|	>44
			//
			var returnDeferred = progressCallback == mutator ? this : new Deferred(promise.cancel);
			var listener = {
				resolved: resolvedCallback,
				error: errorCallback,
				progress: progressCallback,
				deferred: returnDeferred
			};
			if(nextListener){
				head = head.next = listener;
			}
			else{
				nextListener = head = listener;
			}
			if(finished){
				notify();
			}
			return returnDeferred.promise; // Promise
		};
		var deferred = this;
		promise.cancel = this.cancel = function(){
			// summary:
			//		Cancels the asynchronous operation
			if(!finished){
				var error = canceller && canceller(deferred);
				if(!finished){
					if (!(error instanceof Error)){
						error = new CancelError(error);
					}
					error.log = false;
					deferred.reject(error);
				}
			}
			canceled = true;
		};
		freeze(promise);
	};
	lang.extend(Deferred, {
		addCallback: function(/*Function*/ callback){
			// summary:
			//		Adds successful callback for this deferred instance.
			// returns:
			//		Returns this deferred object.
			return this.addCallbacks(lang.hitch.apply(dojo, arguments));	// Deferred
		},

		addErrback: function(/*Function*/ errback){
			// summary:
			//		Adds error callback for this deferred instance.
			// returns:
			//		Returns this deferred object.
			return this.addCallbacks(null, lang.hitch.apply(dojo, arguments));	// Deferred
		},

		addBoth: function(/*Function*/ callback){
			// summary:
			//		Add handler as both successful callback and error callback for this deferred instance.
			// returns:
			//		Returns this deferred object.
			var enclosed = lang.hitch.apply(dojo, arguments);
			return this.addCallbacks(enclosed, enclosed);	// Deferred
		},
		fired: -1
	});

	Deferred.when = dojo.when = when;

	return Deferred;
});

},
'dojo/Deferred':function(){
define([
	"./has",
	"./_base/lang",
	"./errors/CancelError",
	"./promise/Promise",
	"require"
], function(has, lang, CancelError, Promise, instrumentation){
	"use strict";

	// module:
	//		dojo/Deferred

	var PROGRESS = 0,
			RESOLVED = 1,
			REJECTED = 2;
	var FULFILLED_ERROR_MESSAGE = "This deferred has already been fulfilled.";

	var freezeObject = Object.freeze || function(){};

	var signalWaiting = function(waiting, type, result, rejection, deferred){
		if( 0 ){
			if(type === REJECTED && Deferred.instrumentRejected && waiting.length === 0){
				Deferred.instrumentRejected(result, false, rejection, deferred);
			}
		}

		for(var i = 0; i < waiting.length; i++){
			signalListener(waiting[i], type, result, rejection);
		}
	};

	var signalListener = function(listener, type, result, rejection){
		var func = listener[type];
		var deferred = listener.deferred;
		if(func){
			try{
				var newResult = func(result);
				if(type === PROGRESS){
					if(typeof newResult !== "undefined"){
						signalDeferred(deferred, type, newResult);
					}
				}else{
					if(newResult && typeof newResult.then === "function"){
						listener.cancel = newResult.cancel;
						newResult.then(
								// Only make resolvers if they're actually going to be used
								makeDeferredSignaler(deferred, RESOLVED),
								makeDeferredSignaler(deferred, REJECTED),
								makeDeferredSignaler(deferred, PROGRESS));
						return;
					}
					signalDeferred(deferred, RESOLVED, newResult);
				}
			}catch(error){
				signalDeferred(deferred, REJECTED, error);
			}
		}else{
			signalDeferred(deferred, type, result);
		}

		if( 0 ){
			if(type === REJECTED && Deferred.instrumentRejected){
				Deferred.instrumentRejected(result, !!func, rejection, deferred.promise);
			}
		}
	};

	var makeDeferredSignaler = function(deferred, type){
		return function(value){
			signalDeferred(deferred, type, value);
		};
	};

	var signalDeferred = function(deferred, type, result){
		if(!deferred.isCanceled()){
			switch(type){
				case PROGRESS:
					deferred.progress(result);
					break;
				case RESOLVED:
					deferred.resolve(result);
					break;
				case REJECTED:
					deferred.reject(result);
					break;
			}
		}
	};

	var Deferred = function(canceler){
		// summary:
		//		Creates a new deferred. This API is preferred over
		//		`dojo/_base/Deferred`.
		// description:
		//		Creates a new deferred, as an abstraction over (primarily)
		//		asynchronous operations. The deferred is the private interface
		//		that should not be returned to calling code. That's what the
		//		`promise` is for. See `dojo/promise/Promise`.
		// canceler: Function?
		//		Will be invoked if the deferred is canceled. The canceler
		//		receives the reason the deferred was canceled as its argument.
		//		The deferred is rejected with its return value, or a new
		//		`dojo/errors/CancelError` instance.

		// promise: dojo/promise/Promise
		//		The public promise object that clients can add callbacks to. 
		var promise = this.promise = new Promise();

		var deferred = this;
		var fulfilled, result, rejection;
		var canceled = false;
		var waiting = [];

		if( 0  && Error.captureStackTrace){
			Error.captureStackTrace(deferred, Deferred);
			Error.captureStackTrace(promise, Deferred);
		}

		this.isResolved = promise.isResolved = function(){
			// summary:
			//		Checks whether the deferred has been resolved.
			// returns: Boolean

			return fulfilled === RESOLVED;
		};

		this.isRejected = promise.isRejected = function(){
			// summary:
			//		Checks whether the deferred has been rejected.
			// returns: Boolean

			return fulfilled === REJECTED;
		};

		this.isFulfilled = promise.isFulfilled = function(){
			// summary:
			//		Checks whether the deferred has been resolved or rejected.
			// returns: Boolean

			return !!fulfilled;
		};

		this.isCanceled = promise.isCanceled = function(){
			// summary:
			//		Checks whether the deferred has been canceled.
			// returns: Boolean

			return canceled;
		};

		this.progress = function(update, strict){
			// summary:
			//		Emit a progress update on the deferred.
			// description:
			//		Emit a progress update on the deferred. Progress updates
			//		can be used to communicate updates about the asynchronous
			//		operation before it has finished.
			// update: any
			//		The progress update. Passed to progbacks.
			// strict: Boolean?
			//		If strict, will throw an error if the deferred has already
			//		been fulfilled and consequently no progress can be emitted.
			// returns: dojo/promise/Promise
			//		Returns the original promise for the deferred.

			if(!fulfilled){
				signalWaiting(waiting, PROGRESS, update, null, deferred);
				return promise;
			}else if(strict === true){
				throw new Error(FULFILLED_ERROR_MESSAGE);
			}else{
				return promise;
			}
		};

		this.resolve = function(value, strict){
			// summary:
			//		Resolve the deferred.
			// description:
			//		Resolve the deferred, putting it in a success state.
			// value: any
			//		The result of the deferred. Passed to callbacks.
			// strict: Boolean?
			//		If strict, will throw an error if the deferred has already
			//		been fulfilled and consequently cannot be resolved.
			// returns: dojo/promise/Promise
			//		Returns the original promise for the deferred.

			if(!fulfilled){
				// Set fulfilled, store value. After signaling waiting listeners unset
				// waiting.
				signalWaiting(waiting, fulfilled = RESOLVED, result = value, null, deferred);
				waiting = null;
				return promise;
			}else if(strict === true){
				throw new Error(FULFILLED_ERROR_MESSAGE);
			}else{
				return promise;
			}
		};

		var reject = this.reject = function(error, strict){
			// summary:
			//		Reject the deferred.
			// description:
			//		Reject the deferred, putting it in an error state.
			// error: any
			//		The error result of the deferred. Passed to errbacks.
			// strict: Boolean?
			//		If strict, will throw an error if the deferred has already
			//		been fulfilled and consequently cannot be rejected.
			// returns: dojo/promise/Promise
			//		Returns the original promise for the deferred.

			if(!fulfilled){
				if( 0  && Error.captureStackTrace){
					Error.captureStackTrace(rejection = {}, reject);
				}
				signalWaiting(waiting, fulfilled = REJECTED, result = error, rejection, deferred);
				waiting = null;
				return promise;
			}else if(strict === true){
				throw new Error(FULFILLED_ERROR_MESSAGE);
			}else{
				return promise;
			}
		};

		this.then = promise.then = function(callback, errback, progback){
			// summary:
			//		Add new callbacks to the deferred.
			// description:
			//		Add new callbacks to the deferred. Callbacks can be added
			//		before or after the deferred is fulfilled.
			// callback: Function?
			//		Callback to be invoked when the promise is resolved.
			//		Receives the resolution value.
			// errback: Function?
			//		Callback to be invoked when the promise is rejected.
			//		Receives the rejection error.
			// progback: Function?
			//		Callback to be invoked when the promise emits a progress
			//		update. Receives the progress update.
			// returns: dojo/promise/Promise
			//		Returns a new promise for the result of the callback(s).
			//		This can be used for chaining many asynchronous operations.

			var listener = [progback, callback, errback];
			// Ensure we cancel the promise we're waiting for, or if callback/errback
			// have returned a promise, cancel that one.
			listener.cancel = promise.cancel;
			listener.deferred = new Deferred(function(reason){
				// Check whether cancel is really available, returned promises are not
				// required to expose `cancel`
				return listener.cancel && listener.cancel(reason);
			});
			if(fulfilled && !waiting){
				signalListener(listener, fulfilled, result, rejection);
			}else{
				waiting.push(listener);
			}
			return listener.deferred.promise;
		};

		this.cancel = promise.cancel = function(reason, strict){
			// summary:
			//		Inform the deferred it may cancel its asynchronous operation.
			// description:
			//		Inform the deferred it may cancel its asynchronous operation.
			//		The deferred's (optional) canceler is invoked and the
			//		deferred will be left in a rejected state. Can affect other
			//		promises that originate with the same deferred.
			// reason: any
			//		A message that may be sent to the deferred's canceler,
			//		explaining why it's being canceled.
			// strict: Boolean?
			//		If strict, will throw an error if the deferred has already
			//		been fulfilled and consequently cannot be canceled.
			// returns: any
			//		Returns the rejection reason if the deferred was canceled
			//		normally.

			if(!fulfilled){
				// Cancel can be called even after the deferred is fulfilled
				if(canceler){
					var returnedReason = canceler(reason);
					reason = typeof returnedReason === "undefined" ? reason : returnedReason;
				}
				canceled = true;
				if(!fulfilled){
					// Allow canceler to provide its own reason, but fall back to a CancelError
					if(typeof reason === "undefined"){
						reason = new CancelError();
					}
					reject(reason);
					return reason;
				}else if(fulfilled === REJECTED && result === reason){
					return reason;
				}
			}else if(strict === true){
				throw new Error(FULFILLED_ERROR_MESSAGE);
			}
		};

		freezeObject(promise);
	};

	Deferred.prototype.toString = function(){
		// returns: String
		//		Returns `[object Deferred]`.

		return "[object Deferred]";
	};

	if(instrumentation){
		instrumentation(Deferred);
	}

	return Deferred;
});

},
'dojo/errors/CancelError':function(){
define(["./create"], function(create){
	// module:
	//		dojo/errors/CancelError

	/*=====
	return function(){
		// summary:
		//		Default error if a promise is canceled without a reason.
	};
	=====*/

	return create("CancelError", null, null, { dojoType: "cancel", log: false });
});

},
'dojo/errors/create':function(){
define(["../_base/lang"], function(lang){
	return function(name, ctor, base, props){
		base = base || Error;

		var ErrorCtor = function(message){
			if(base === Error){
				if(Error.captureStackTrace){
					Error.captureStackTrace(this, ErrorCtor);
				}

				// Error.call() operates on the returned error
				// object rather than operating on |this|
				var err = Error.call(this, message),
					prop;

				// Copy own properties from err to |this|
				for(prop in err){
					if(err.hasOwnProperty(prop)){
						this[prop] = err[prop];
					}
				}

				// messsage is non-enumerable in ES5
				this.message = message;
				// stack is non-enumerable in at least Firefox
				this.stack = err.stack;
			}else{
				base.apply(this, arguments);
			}
			if(ctor){
				ctor.apply(this, arguments);
			}
		};

		ErrorCtor.prototype = lang.delegate(base.prototype, props);
		ErrorCtor.prototype.name = name;
		ErrorCtor.prototype.constructor = ErrorCtor;

		return ErrorCtor;
	};
});

},
'dojo/promise/Promise':function(){
define([
	"../_base/lang"
], function(lang){
	"use strict";

	// module:
	//		dojo/promise/Promise

	function throwAbstract(){
		throw new TypeError("abstract");
	}

	return lang.extend(function Promise(){
		// summary:
		//		The public interface to a deferred.
		// description:
		//		The public interface to a deferred. All promises in Dojo are
		//		instances of this class.
	}, {
		then: function(callback, errback, progback){
			// summary:
			//		Add new callbacks to the promise.
			// description:
			//		Add new callbacks to the deferred. Callbacks can be added
			//		before or after the deferred is fulfilled.
			// callback: Function?
			//		Callback to be invoked when the promise is resolved.
			//		Receives the resolution value.
			// errback: Function?
			//		Callback to be invoked when the promise is rejected.
			//		Receives the rejection error.
			// progback: Function?
			//		Callback to be invoked when the promise emits a progress
			//		update. Receives the progress update.
			// returns: dojo/promise/Promise
			//		Returns a new promise for the result of the callback(s).
			//		This can be used for chaining many asynchronous operations.

			throwAbstract();
		},

		cancel: function(reason, strict){
			// summary:
			//		Inform the deferred it may cancel its asynchronous operation.
			// description:
			//		Inform the deferred it may cancel its asynchronous operation.
			//		The deferred's (optional) canceler is invoked and the
			//		deferred will be left in a rejected state. Can affect other
			//		promises that originate with the same deferred.
			// reason: any
			//		A message that may be sent to the deferred's canceler,
			//		explaining why it's being canceled.
			// strict: Boolean?
			//		If strict, will throw an error if the deferred has already
			//		been fulfilled and consequently cannot be canceled.
			// returns: any
			//		Returns the rejection reason if the deferred was canceled
			//		normally.

			throwAbstract();
		},

		isResolved: function(){
			// summary:
			//		Checks whether the promise has been resolved.
			// returns: Boolean

			throwAbstract();
		},

		isRejected: function(){
			// summary:
			//		Checks whether the promise has been rejected.
			// returns: Boolean

			throwAbstract();
		},

		isFulfilled: function(){
			// summary:
			//		Checks whether the promise has been resolved or rejected.
			// returns: Boolean

			throwAbstract();
		},

		isCanceled: function(){
			// summary:
			//		Checks whether the promise has been canceled.
			// returns: Boolean

			throwAbstract();
		},

		"finally": function(callback) {
			// summary:
			//		Add a callback to the promise that will fire whether it
			//		resolves or rejects.
			// description:
			//		Conforms to ES2018's `Promise.prototype.finally`.
			//		Add a callback to the promise that will fire whether it
			//		resolves or rejects. No value is passed to the callback.
			//		Returns a promise that reflects the state of the original promise,
			//		with two exceptions:
			//		- If the callback return a promise, the outer promise will wait
			//		until the returned promise is resolved, then it will resolve
			//		with the original value.
			//		- If the callback throws an exception or returns a promise that
			//		is rejected (or rejects later), the outer promise will reject
			//		with the inner promise's rejection reason.
			// callback: Function?
			//		Callback to be invoked when the promise is resolved
			//		or rejected. Doesn't receive any value.
			// returns: dojo/promise/Promise
			//		Returns a new promise that reflects the state of the original promise,
			//		with two small exceptions (see description).
			//

			return this.then(function (value){
				var valueOrPromise = callback();
				if (valueOrPromise && typeof valueOrPromise.then === "function"){
					return valueOrPromise.then(function (){
						return value;
					});
				}
				return value;
			}, function(reason) {
				var valueOrPromise = callback();
				if (valueOrPromise && typeof valueOrPromise.then === "function"){
					return valueOrPromise.then(function (){
						throw reason;
					});
				}
				throw reason;
			});
		},

		always: function(callbackOrErrback){
			// summary:
			//		Add a callback to be invoked when the promise is resolved
			//		or rejected.
			// callbackOrErrback: Function?
			//		A function that is used both as a callback and errback.
			// returns: dojo/promise/Promise
			//		Returns a new promise for the result of the callback/errback.

			return this.then(callbackOrErrback, callbackOrErrback);
		},

		"catch": function(errback){
		    // summary:
		    //		Add new errbacks to the promise. Follows ECMA specification naming.
		    // errback: Function?
		    //		Callback to be invoked when the promise is rejected.
		    // returns: dojo/promise/Promise
		    //		Returns a new promise for the result of the errback.

		    return this.then(null, errback);
		},

		otherwise: function(errback){
			// summary:
			//		Add new errbacks to the promise.
			// errback: Function?
			//		Callback to be invoked when the promise is rejected.
			// returns: dojo/promise/Promise
			//		Returns a new promise for the result of the errback.

			return this.then(null, errback);
		},

		trace: function(){
			return this;
		},

		traceRejected: function(){
			return this;
		},

		toString: function(){
			// returns: string
			//		Returns `[object Promise]`.

			return "[object Promise]";
		}
	});
});

},
'dojo/when':function(){
define([
	"./Deferred",
	"./promise/Promise"
], function(Deferred, Promise){
	"use strict";

	// module:
	//		dojo/when

	return function when(valueOrPromise, callback, errback, progback){
		// summary:
		//		Transparently applies callbacks to values and/or promises.
		// description:
		//		Accepts promises but also transparently handles non-promises. If no
		//		callbacks are provided returns a promise, regardless of the initial
		//		value. Foreign promises are converted.
		//
		//		If callbacks are provided and the initial value is not a promise,
		//		the callback is executed immediately with no error handling. Returns
		//		a promise if the initial value is a promise, or the result of the
		//		callback otherwise.
		// valueOrPromise:
		//		Either a regular value or an object with a `then()` method that
		//		follows the Promises/A specification.
		// callback: Function?
		//		Callback to be invoked when the promise is resolved, or a non-promise
		//		is received.
		// errback: Function?
		//		Callback to be invoked when the promise is rejected.
		// progback: Function?
		//		Callback to be invoked when the promise emits a progress update.
		// returns: dojo/promise/Promise
		//		Promise, or if a callback is provided, the result of the callback.

		var receivedPromise = valueOrPromise && typeof valueOrPromise.then === "function";
		var nativePromise = receivedPromise && valueOrPromise instanceof Promise;

		if(!receivedPromise){
			if(arguments.length > 1){
				return callback ? callback(valueOrPromise) : valueOrPromise;
			}else{
				return new Deferred().resolve(valueOrPromise);
			}
		}else if(!nativePromise){
			var deferred = new Deferred(valueOrPromise.cancel);
			valueOrPromise.then(deferred.resolve, deferred.reject, deferred.progress);
			valueOrPromise = deferred.promise;
		}

		if(callback || errback || progback){
			return valueOrPromise.then(callback, errback, progback);
		}
		return valueOrPromise;
	};
});

},
'dojo/_base/json':function(){
define(["./kernel", "../json"], function(dojo, json){

// module:
//		dojo/_base/json

/*=====
return {
	// summary:
	//		This module defines the dojo JSON API.
};
=====*/

dojo.fromJson = function(/*String*/ js){
	// summary:
	//		Parses a JavaScript expression and returns a JavaScript value.
	// description:
	//		Throws for invalid JavaScript expressions. It does not use a strict JSON parser. It
	//		always delegates to eval(). The content passed to this method must therefore come
	//		from a trusted source.
	//		It is recommend that you use dojo/json's parse function for an
	//		implementation uses the (faster) native JSON parse when available.
	// js:
	//		a string literal of a JavaScript expression, for instance:
	//		`'{ "foo": [ "bar", 1, { "baz": "thud" } ] }'`

	return eval("(" + js + ")"); // Object
};

/*=====
dojo._escapeString = function(){
	// summary:
	//		Adds escape sequences for non-visual characters, double quote and
	//		backslash and surrounds with double quotes to form a valid string
	//		literal.
};
=====*/
dojo._escapeString = json.stringify; // just delegate to json.stringify

dojo.toJsonIndentStr = "\t";
dojo.toJson = function(/*Object*/ it, /*Boolean?*/ prettyPrint){
	// summary:
	//		Returns a [JSON](http://json.org) serialization of an object.
	// description:
	//		Returns a [JSON](http://json.org) serialization of an object.
	//		Note that this doesn't check for infinite recursion, so don't do that!
	//		It is recommend that you use dojo/json's stringify function for an lighter
	//		and faster implementation that matches the native JSON API and uses the
	//		native JSON serializer when available.
	// it:
	//		an object to be serialized. Objects may define their own
	//		serialization via a special "__json__" or "json" function
	//		property. If a specialized serializer has been defined, it will
	//		be used as a fallback.
	//		Note that in 1.6, toJson would serialize undefined, but this no longer supported
	//		since it is not supported by native JSON serializer.
	// prettyPrint:
	//		if true, we indent objects and arrays to make the output prettier.
	//		The variable `dojo.toJsonIndentStr` is used as the indent string --
	//		to use something other than the default (tab), change that variable
	//		before calling dojo.toJson().
	//		Note that if native JSON support is available, it will be used for serialization,
	//		and native implementations vary on the exact spacing used in pretty printing.
	// returns:
	//		A JSON string serialization of the passed-in object.
	// example:
	//		simple serialization of a trivial object
	//		|	var jsonStr = dojo.toJson({ howdy: "stranger!", isStrange: true });
	//		|	doh.is('{"howdy":"stranger!","isStrange":true}', jsonStr);
	// example:
	//		a custom serializer for an objects of a particular class:
	//		|	dojo.declare("Furby", null, {
	//		|		furbies: "are strange",
	//		|		furbyCount: 10,
	//		|		__json__: function(){
	//		|		},
	//		|	});

	// use dojo/json
	return json.stringify(it, function(key, value){
		if(value){
			var tf = value.__json__||value.json;
			if(typeof tf == "function"){
				return tf.call(value);
			}
		}
		return value;
	}, prettyPrint && dojo.toJsonIndentStr);	// String
};

return dojo;
});

},
'dojo/on':function(){
define(["./has!dom-addeventlistener?:./aspect", "./_base/kernel", "./sniff"], function(aspect, dojo, has){

	"use strict";
	if( 1 ){ // check to make sure we are in a browser, this module should work anywhere
		var major = window.ScriptEngineMajorVersion;
		has.add("jscript", major && (major() + ScriptEngineMinorVersion() / 10));
		has.add("event-orientationchange", has("touch") && !has("android")); // TODO: how do we detect this?
		has.add("event-stopimmediatepropagation", window.Event && !!window.Event.prototype && !!window.Event.prototype.stopImmediatePropagation);
		has.add("event-focusin", function(global, doc, element){
			return 'onfocusin' in element;
		});

		if(has("touch")){
			has.add("touch-can-modify-event-delegate", function(){
				// This feature test checks whether deleting a property of an event delegate works
				// for a touch-enabled device. If it works, event delegation can be used as fallback
				// for browsers such as Safari in older iOS where deleting properties of the original
				// event does not work.
				var EventDelegate = function(){};
				EventDelegate.prototype =
					document.createEvent("MouseEvents"); // original event
				// Attempt to modify a property of an event delegate and check if
				// it succeeds. Depending on browsers and on whether dojo/on's
				// strict mode is stripped in a Dojo build, there are 3 known behaviors:
				// it may either succeed, or raise an error, or fail to set the property
				// without raising an error.
				try{
					var eventDelegate = new EventDelegate;
					eventDelegate.target = null;
					return eventDelegate.target === null;
				}catch(e){
					return false; // cannot use event delegation
				}
			});
		}
	}
	var on = function(target, type, listener, dontFix){
		// summary:
		//		A function that provides core event listening functionality. With this function
		//		you can provide a target, event type, and listener to be notified of
		//		future matching events that are fired.
		// target: Element|Object
		//		This is the target object or DOM element that to receive events from
		// type: String|Function
		//		This is the name of the event to listen for or an extension event type.
		// listener: Function
		//		This is the function that should be called when the event fires.
		// returns: Object
		//		An object with a remove() method that can be used to stop listening for this
		//		event.
		// description:
		//		To listen for "click" events on a button node, we can do:
		//		|	define(["dojo/on"], function(on){
		//		|		on(button, "click", clickHandler);
		//		|		...
		//		Evented JavaScript objects can also have their own events.
		//		|	var obj = new Evented;
		//		|	on(obj, "foo", fooHandler);
		//		And then we could publish a "foo" event:
		//		|	on.emit(obj, "foo", {key: "value"});
		//		We can use extension events as well. For example, you could listen for a tap gesture:
		//		|	define(["dojo/on", "dojo/gesture/tap", function(on, tap){
		//		|		on(button, tap, tapHandler);
		//		|		...
		//		which would trigger fooHandler. Note that for a simple object this is equivalent to calling:
		//		|	obj.onfoo({key:"value"});
		//		If you use on.emit on a DOM node, it will use native event dispatching when possible.

		if(typeof target.on == "function" && typeof type != "function" && !target.nodeType){
			// delegate to the target's on() method, so it can handle it's own listening if it wants (unless it
			// is DOM node and we may be dealing with jQuery or Prototype's incompatible addition to the
			// Element prototype
			return target.on(type, listener);
		}
		// delegate to main listener code
		return on.parse(target, type, listener, addListener, dontFix, this);
	};
	on.pausable =  function(target, type, listener, dontFix){
		// summary:
		//		This function acts the same as on(), but with pausable functionality. The
		//		returned signal object has pause() and resume() functions. Calling the
		//		pause() method will cause the listener to not be called for future events. Calling the
		//		resume() method will cause the listener to again be called for future events.
		var paused;
		var signal = on(target, type, function(){
			if(!paused){
				return listener.apply(this, arguments);
			}
		}, dontFix);
		signal.pause = function(){
			paused = true;
		};
		signal.resume = function(){
			paused = false;
		};
		return signal;
	};
	on.once = function(target, type, listener, dontFix){
		// summary:
		//		This function acts the same as on(), but will only call the listener once. The
		//		listener will be called for the first
		//		event that takes place and then listener will automatically be removed.
		var signal = on(target, type, function(){
			// remove this listener
			signal.remove();
			// proceed to call the listener
			return listener.apply(this, arguments);
		});
		return signal;
	};
	on.parse = function(target, type, listener, addListener, dontFix, matchesTarget){
		var events;
		if(type.call){
			// event handler function
			// on(node, touch.press, touchListener);
			return type.call(matchesTarget, target, listener);
		}

		if(type instanceof Array){
			// allow an array of event names (or event handler functions)
			events = type;
		}else if(type.indexOf(",") > -1){
			// we allow comma delimited event names, so you can register for multiple events at once
			events = type.split(/\s*,\s*/);
		}
		if(events){
			var handles = [];
			var i = 0;
			var eventName;
			while(eventName = events[i++]){ // intentional assignment
				handles.push(on.parse(target, eventName, listener, addListener, dontFix, matchesTarget));
			}
			handles.remove = function(){
				for(var i = 0; i < handles.length; i++){
					handles[i].remove();
				}
			};
			return handles;
		}
		return addListener(target, type, listener, dontFix, matchesTarget);
	};
	var touchEvents = /^touch/;
	function addListener(target, type, listener, dontFix, matchesTarget){
		// event delegation:
		var selector = type.match(/(.*):(.*)/);
		// if we have a selector:event, the last one is interpreted as an event, and we use event delegation
		if(selector){
			type = selector[2];
			selector = selector[1];
			// create the extension event for selectors and directly call it
			return on.selector(selector, type).call(matchesTarget, target, listener);
		}
		// test to see if it a touch event right now, so we don't have to do it every time it fires
		if(has("touch")){
			if(touchEvents.test(type)){
				// touch event, fix it
				listener = fixTouchListener(listener);
			}
			if(!has("event-orientationchange") && (type == "orientationchange")){
				//"orientationchange" not supported <= Android 2.1,
				//but works through "resize" on window
				type = "resize";
				target = window;
				listener = fixTouchListener(listener);
			}
		}
		if(addStopImmediate){
			// add stopImmediatePropagation if it doesn't exist
			listener = addStopImmediate(listener);
		}
		// normal path, the target is |this|
		if(target.addEventListener){
			// the target has addEventListener, which should be used if available (might or might not be a node, non-nodes can implement this method as well)
			// check for capture conversions
			var capture = type in captures,
				adjustedType = capture ? captures[type] : type;
			target.addEventListener(adjustedType, listener, capture);
			// create and return the signal
			return {
				remove: function(){
					target.removeEventListener(adjustedType, listener, capture);
				}
			};
		}
		type = "on" + type;
		if(fixAttach && target.attachEvent){
			return fixAttach(target, type, listener);
		}
		throw new Error("Target must be an event emitter");
	}
	on.matches = function(node, selector, context, children, matchesTarget) {
		// summary:
		//		Check if a node match the current selector within the constraint of a context
		// node: DOMNode
		//		The node that originate the event
		// selector: String
		//		The selector to check against
		// context: DOMNode
		//		The context to search in.
		// children: Boolean
		//		Indicates if children elements of the selector should be allowed. This defaults to
		//		true
		// matchesTarget: Object|dojo/query?
		//		An object with a property "matches" as a function. Default is dojo/query.
		//		Matching DOMNodes will be done against this function
		//		The function must return a Boolean.
		//		It will have 3 arguments: "node", "selector" and "context"
		//		True is expected if "node" is matching the current "selector" in the passed "context"
		// returns: DOMNode?
		//		The matching node, if any. Else you get false

		// see if we have a valid matchesTarget or default to dojo/query
		matchesTarget = matchesTarget && (typeof matchesTarget.matches == "function") ? matchesTarget : dojo.query;
		children = children !== false;
		// there is a selector, so make sure it matches
		if(node.nodeType != 1){
			// text node will fail in native match selector
			node = node.parentNode;
		}
		while(!matchesTarget.matches(node, selector, context)){
			if(node == context || children === false || !(node = node.parentNode) || node.nodeType != 1){ // intentional assignment
				return false;
			}
		}
		return node;
	};
	on.selector = function(selector, eventType, children){
		// summary:
		//		Creates a new extension event with event delegation. This is based on
		//		the provided event type (can be extension event) that
		//		only calls the listener when the CSS selector matches the target of the event.
		//
		//		The application must require() an appropriate level of dojo/query to handle the selector.
		// selector:
		//		The CSS selector to use for filter events and determine the |this| of the event listener.
		// eventType:
		//		The event to listen for
		// children:
		//		Indicates if children elements of the selector should be allowed. This defaults to
		//		true
		// example:
		// |	require(["dojo/on", "dojo/mouse", "dojo/query!css2"], function(on, mouse){
		// |		on(node, on.selector(".my-class", mouse.enter), handlerForMyHover);
		return function(target, listener){
			// if the selector is function, use it to select the node, otherwise use the matches method
			var matchesTarget = typeof selector == "function" ? {matches: selector} : this,
				bubble = eventType.bubble;
			function select(eventTarget){
				return on.matches(eventTarget, selector, target, children, matchesTarget);
			}
			if(bubble){
				// the event type doesn't naturally bubble, but has a bubbling form, use that, and give it the selector so it can perform the select itself
				return on(target, bubble(select), listener);
			}
			// standard event delegation
			return on(target, eventType, function(event){
				// call select to see if we match
				var eventTarget = select(event.target);
				// if it matches we call the listener
				if (eventTarget) {
					// We save the matching target into the event, so it can be accessed even when hitching (see #18355)
					event.selectorTarget = eventTarget;
					return listener.call(eventTarget, event);
				}
			});
		};
	};

	function syntheticPreventDefault(){
		this.cancelable = false;
		this.defaultPrevented = true;
	}
	function syntheticStopPropagation(){
		this.bubbles = false;
	}
	var slice = [].slice,
		syntheticDispatch = on.emit = function(target, type, event){
		// summary:
		//		Fires an event on the target object.
		// target:
		//		The target object to fire the event on. This can be a DOM element or a plain
		//		JS object. If the target is a DOM element, native event emitting mechanisms
		//		are used when possible.
		// type:
		//		The event type name. You can emulate standard native events like "click" and
		//		"mouseover" or create custom events like "open" or "finish".
		// event:
		//		An object that provides the properties for the event. See https://developer.mozilla.org/en/DOM/event.initEvent
		//		for some of the properties. These properties are copied to the event object.
		//		Of particular importance are the cancelable and bubbles properties. The
		//		cancelable property indicates whether or not the event has a default action
		//		that can be cancelled. The event is cancelled by calling preventDefault() on
		//		the event object. The bubbles property indicates whether or not the
		//		event will bubble up the DOM tree. If bubbles is true, the event will be called
		//		on the target and then each parent successively until the top of the tree
		//		is reached or stopPropagation() is called. Both bubbles and cancelable
		//		default to false.
		// returns:
		//		If the event is cancelable and the event is not cancelled,
		//		emit will return true. If the event is cancelable and the event is cancelled,
		//		emit will return false.
		// details:
		//		Note that this is designed to emit events for listeners registered through
		//		dojo/on. It should actually work with any event listener except those
		//		added through IE's attachEvent (IE8 and below's non-W3C event emitting
		//		doesn't support custom event types). It should work with all events registered
		//		through dojo/on. Also note that the emit method does do any default
		//		action, it only returns a value to indicate if the default action should take
		//		place. For example, emitting a keypress event would not cause a character
		//		to appear in a textbox.
		// example:
		//		To fire our own click event
		//	|	require(["dojo/on", "dojo/dom"
		//	|	], function(on, dom){
		//	|		on.emit(dom.byId("button"), "click", {
		//	|			cancelable: true,
		//	|			bubbles: true,
		//	|			screenX: 33,
		//	|			screenY: 44
		//	|		});
		//		We can also fire our own custom events:
		//	|		on.emit(dom.byId("slider"), "slide", {
		//	|			cancelable: true,
		//	|			bubbles: true,
		//	|			direction: "left-to-right"
		//	|		});
		//	|	});
		var args = slice.call(arguments, 2);
		var method = "on" + type;
		if("parentNode" in target){
			// node (or node-like), create event controller methods
			var newEvent = args[0] = {};
			for(var i in event){
				newEvent[i] = event[i];
			}
			newEvent.preventDefault = syntheticPreventDefault;
			newEvent.stopPropagation = syntheticStopPropagation;
			newEvent.target = target;
			newEvent.type = type;
			event = newEvent;
		}
		do{
			// call any node which has a handler (note that ideally we would try/catch to simulate normal event propagation but that causes too much pain for debugging)
			target[method] && target[method].apply(target, args);
			// and then continue up the parent node chain if it is still bubbling (if started as bubbles and stopPropagation hasn't been called)
		}while(event && event.bubbles && (target = target.parentNode));
		return event && event.cancelable && event; // if it is still true (was cancelable and was cancelled), return the event to indicate default action should happen
	};
	var captures = has("event-focusin") ? {} : {focusin: "focus", focusout: "blur"};
	if(!has("event-stopimmediatepropagation")){
		var stopImmediatePropagation =function(){
			this.immediatelyStopped = true;
			this.modified = true; // mark it as modified so the event will be cached in IE
		};
		var addStopImmediate = function(listener){
			return function(event){
				if(!event.immediatelyStopped){// check to make sure it hasn't been stopped immediately
					event.stopImmediatePropagation = stopImmediatePropagation;
					return listener.apply(this, arguments);
				}
			};
		};
	}
	if(has("dom-addeventlistener")){
		// emitter that works with native event handling
		on.emit = function(target, type, event){
			if(target.dispatchEvent && document.createEvent){
				// use the native event emitting mechanism if it is available on the target object
				// create a generic event
				// we could create branch into the different types of event constructors, but
				// that would be a lot of extra code, with little benefit that I can see, seems
				// best to use the generic constructor and copy properties over, making it
				// easy to have events look like the ones created with specific initializers
				var ownerDocument = target.ownerDocument || document;
				var nativeEvent = ownerDocument.createEvent("HTMLEvents");
				nativeEvent.initEvent(type, !!event.bubbles, !!event.cancelable);
				// and copy all our properties over
				for(var i in event){
					if(!(i in nativeEvent)){
						nativeEvent[i] = event[i];
					}
				}
				return target.dispatchEvent(nativeEvent) && nativeEvent;
			}
			return syntheticDispatch.apply(on, arguments); // emit for a non-node
		};
	}else{
		// no addEventListener, basically old IE event normalization
		on._fixEvent = function(evt, sender){
			// summary:
			//		normalizes properties on the event object including event
			//		bubbling methods, keystroke normalization, and x/y positions
			// evt:
			//		native event object
			// sender:
			//		node to treat as "currentTarget"
			if(!evt){
				var w = sender && (sender.ownerDocument || sender.document || sender).parentWindow || window;
				evt = w.event;
			}
			if(!evt){return evt;}
			try{
				if(lastEvent && evt.type == lastEvent.type  && evt.srcElement == lastEvent.target){
					// should be same event, reuse event object (so it can be augmented);
					// accessing evt.srcElement rather than evt.target since evt.target not set on IE until fixup below
					evt = lastEvent;
				}
			}catch(e){
				// will occur on IE on lastEvent.type reference if lastEvent points to a previous event that already
				// finished bubbling, but the setTimeout() to clear lastEvent hasn't fired yet
			}
			if(!evt.target){ // check to see if it has been fixed yet
				evt.target = evt.srcElement;
				evt.currentTarget = (sender || evt.srcElement);
				if(evt.type == "mouseover"){
					evt.relatedTarget = evt.fromElement;
				}
				if(evt.type == "mouseout"){
					evt.relatedTarget = evt.toElement;
				}
				if(!evt.stopPropagation){
					evt.stopPropagation = stopPropagation;
					evt.preventDefault = preventDefault;
				}
				switch(evt.type){
					case "keypress":
						var c = ("charCode" in evt ? evt.charCode : evt.keyCode);
						if (c==10){
							// CTRL-ENTER is CTRL-ASCII(10) on IE, but CTRL-ENTER on Mozilla
							c=0;
							evt.keyCode = 13;
						}else if(c==13||c==27){
							c=0; // Mozilla considers ENTER and ESC non-printable
						}else if(c==3){
							c=99; // Mozilla maps CTRL-BREAK to CTRL-c
						}
						// Mozilla sets keyCode to 0 when there is a charCode
						// but that stops the event on IE.
						evt.charCode = c;
						_setKeyChar(evt);
						break;
				}
			}
			return evt;
		};
		var lastEvent, IESignal = function(handle){
			this.handle = handle;
		};
		IESignal.prototype.remove = function(){
			delete _dojoIEListeners_[this.handle];
		};
		var fixListener = function(listener){
			// this is a minimal function for closing on the previous listener with as few as variables as possible
			return function(evt){
				evt = on._fixEvent(evt, this);
				var result = listener.call(this, evt);
				if(evt.modified){
					// cache the last event and reuse it if we can
					if(!lastEvent){
						setTimeout(function(){
							lastEvent = null;
						});
					}
					lastEvent = evt;
				}
				return result;
			};
		};
		var fixAttach = function(target, type, listener){
			listener = fixListener(listener);
			if(((target.ownerDocument ? target.ownerDocument.parentWindow : target.parentWindow || target.window || window) != top ||
						has("jscript") < 5.8) &&
					!has("config-_allow_leaks")){
				// IE will leak memory on certain handlers in frames (IE8 and earlier) and in unattached DOM nodes for JScript 5.7 and below.
				// Here we use global redirection to solve the memory leaks
				if(typeof _dojoIEListeners_ == "undefined"){
					_dojoIEListeners_ = [];
				}
				var emitter = target[type];
				if(!emitter || !emitter.listeners){
					var oldListener = emitter;
					emitter = Function('event', 'var callee = arguments.callee; for(var i = 0; i<callee.listeners.length; i++){var listener = _dojoIEListeners_[callee.listeners[i]]; if(listener){listener.call(this,event);}}');
					emitter.listeners = [];
					target[type] = emitter;
					emitter.global = this;
					if(oldListener){
						emitter.listeners.push(_dojoIEListeners_.push(oldListener) - 1);
					}
				}
				var handle;
				emitter.listeners.push(handle = (emitter.global._dojoIEListeners_.push(listener) - 1));
				return new IESignal(handle);
			}
			return aspect.after(target, type, listener, true);
		};

		var _setKeyChar = function(evt){
			evt.keyChar = evt.charCode ? String.fromCharCode(evt.charCode) : '';
			evt.charOrCode = evt.keyChar || evt.keyCode;	// TODO: remove for 2.0
		};
		// Called in Event scope
		var stopPropagation = function(){
			this.cancelBubble = true;
		};
		var preventDefault = on._preventDefault = function(){
			// Setting keyCode to 0 is the only way to prevent certain keypresses (namely
			// ctrl-combinations that correspond to menu accelerator keys).
			// Otoh, it prevents upstream listeners from getting this information
			// Try to split the difference here by clobbering keyCode only for ctrl
			// combinations. If you still need to access the key upstream, bubbledKeyCode is
			// provided as a workaround.
			this.bubbledKeyCode = this.keyCode;
			if(this.ctrlKey){
				try{
					// squelch errors when keyCode is read-only
					// (e.g. if keyCode is ctrl or shift)
					this.keyCode = 0;
				}catch(e){
				}
			}
			this.defaultPrevented = true;
			this.returnValue = false;
			this.modified = true; // mark it as modified  (for defaultPrevented flag) so the event will be cached in IE
		};
	}
	if(has("touch")){
		var EventDelegate = function(){};
		var windowOrientation = window.orientation;
		var fixTouchListener = function(listener){
			return function(originalEvent){
				//Event normalization(for ontouchxxx and resize):
				//1.incorrect e.pageX|pageY in iOS
				//2.there are no "e.rotation", "e.scale" and "onorientationchange" in Android
				//3.More TBD e.g. force | screenX | screenX | clientX | clientY | radiusX | radiusY

				// see if it has already been corrected
				var event = originalEvent.corrected;
				if(!event){
					var type = originalEvent.type;
					try{
						delete originalEvent.type; // on some JS engines (android), deleting properties makes them mutable
					}catch(e){}
					if(originalEvent.type){
						// Deleting the property of the original event did not work (this is the case of
						// browsers such as older Safari iOS), hence fallback:
						if(has("touch-can-modify-event-delegate")){
							// If deleting properties of delegated event works, use event delegation:
							EventDelegate.prototype = originalEvent;
							event = new EventDelegate;
						}else{
							// Otherwise last fallback: other browsers, such as mobile Firefox, do not like
							// delegated properties, so we have to copy
							event = {};
							for(var name in originalEvent){
								event[name] = originalEvent[name];
							}
						}
						// have to delegate methods to make them work
						event.preventDefault = function(){
							originalEvent.preventDefault();
						};
						event.stopPropagation = function(){
							originalEvent.stopPropagation();
						};
					}else{
						// deletion worked, use property as is
						event = originalEvent;
						event.type = type;
					}
					originalEvent.corrected = event;
					if(type == 'resize'){
						if(windowOrientation == window.orientation){
							return null;//double tap causes an unexpected 'resize' in Android
						}
						windowOrientation = window.orientation;
						event.type = "orientationchange";
						return listener.call(this, event);
					}
					// We use the original event and augment, rather than doing an expensive mixin operation
					if(!("rotation" in event)){ // test to see if it has rotation
						event.rotation = 0;
						event.scale = 1;
					}
					if (window.TouchEvent && originalEvent instanceof TouchEvent) {
						// use event.changedTouches[0].pageX|pageY|screenX|screenY|clientX|clientY|target
						var firstChangeTouch = event.changedTouches[0];
						for(var i in firstChangeTouch){ // use for-in, we don't need to have dependency on dojo/_base/lang here
							delete event[i]; // delete it first to make it mutable
							event[i] = firstChangeTouch[i];
						}
					}
				}
				return listener.call(this, event);
			};
		};
	}
	return on;
});

},
'dojo/aspect':function(){
define([], function(){

	// module:
	//		dojo/aspect

	"use strict";
	var undefined;
	function advise(dispatcher, type, advice, receiveArguments){
		var previous = dispatcher[type];
		var around = type == "around";
		var signal;
		if(around){
			var advised = advice(function(){
				return previous.advice(this, arguments);
			});
			signal = {
				remove: function(){
					if(advised){
						advised = dispatcher = advice = null;
					}
				},
				advice: function(target, args){
					return advised ?
						advised.apply(target, args) :  // called the advised function
						previous.advice(target, args); // cancelled, skip to next one
				}
			};
		}else{
			// create the remove handler
			signal = {
				remove: function(){
					if(signal.advice){
						var previous = signal.previous;
						var next = signal.next;
						if(!next && !previous){
							delete dispatcher[type];
						}else{
							if(previous){
								previous.next = next;
							}else{
								dispatcher[type] = next;
							}
							if(next){
								next.previous = previous;
							}
						}

						// remove the advice to signal that this signal has been removed
						dispatcher = advice = signal.advice = null;
					}
				},
				id: dispatcher.nextId++,
				advice: advice,
				receiveArguments: receiveArguments
			};
		}
		if(previous && !around){
			if(type == "after"){
				// add the listener to the end of the list
				// note that we had to change this loop a little bit to workaround a bizarre IE10 JIT bug
				while(previous.next && (previous = previous.next)){}
				previous.next = signal;
				signal.previous = previous;
			}else if(type == "before"){
				// add to beginning
				dispatcher[type] = signal;
				signal.next = previous;
				previous.previous = signal;
			}
		}else{
			// around or first one just replaces
			dispatcher[type] = signal;
		}
		return signal;
	}
	function aspect(type){
		return function(target, methodName, advice, receiveArguments){
			var existing = target[methodName], dispatcher;
			if(!existing || existing.target != target){
				// no dispatcher in place
				target[methodName] = dispatcher = function(){
					var executionId = dispatcher.nextId;
					// before advice
					var args = arguments;
					var before = dispatcher.before;
					while(before){
						if(before.advice){
							args = before.advice.apply(this, args) || args;
						}
						before = before.next;
					}
					// around advice
					if(dispatcher.around){
						var results = dispatcher.around.advice(this, args);
					}
					// after advice
					var after = dispatcher.after;
					while(after && after.id < executionId){
						if(after.advice){
							if(after.receiveArguments){
								var newResults = after.advice.apply(this, args);
								// change the return value only if a new value was returned
								results = newResults === undefined ? results : newResults;
							}else{
								results = after.advice.call(this, results, args);
							}
						}
						after = after.next;
					}
					return results;
				};
				if(existing){
					dispatcher.around = {advice: function(target, args){
						return existing.apply(target, args);
					}};
				}
				dispatcher.target = target;
				dispatcher.nextId = dispatcher.nextId || 0;
			}
			var results = advise((dispatcher || existing), type, advice, receiveArguments);
			advice = null;
			return results;
		};
	}

	// TODOC: after/before/around return object

	var after = aspect("after");
	/*=====
	after = function(target, methodName, advice, receiveArguments){
		// summary:
		//		The "after" export of the aspect module is a function that can be used to attach
		//		"after" advice to a method. This function will be executed after the original method
		//		is executed. By default the function will be called with a single argument, the return
		//		value of the original method, or the the return value of the last executed advice (if a previous one exists).
		//		The fourth (optional) argument can be set to true to so the function receives the original
		//		arguments (from when the original method was called) rather than the return value.
		//		If there are multiple "after" advisors, they are executed in the order they were registered.
		// target: Object
		//		This is the target object
		// methodName: String
		//		This is the name of the method to attach to.
		// advice: Function
		//		This is function to be called after the original method
		// receiveArguments: Boolean?
		//		If this is set to true, the advice function receives the original arguments (from when the original mehtod
		//		was called) rather than the return value of the original/previous method.
		// returns:
		//		A signal object that can be used to cancel the advice. If remove() is called on this signal object, it will
		//		stop the advice function from being executed.
	};
	=====*/

	var before = aspect("before");
	/*=====
	before = function(target, methodName, advice){
		// summary:
		//		The "before" export of the aspect module is a function that can be used to attach
		//		"before" advice to a method. This function will be executed before the original method
		//		is executed. This function will be called with the arguments used to call the method.
		//		This function may optionally return an array as the new arguments to use to call
		//		the original method (or the previous, next-to-execute before advice, if one exists).
		//		If the before method doesn't return anything (returns undefined) the original arguments
		//		will be preserved.
		//		If there are multiple "before" advisors, they are executed in the reverse order they were registered.
		// target: Object
		//		This is the target object
		// methodName: String
		//		This is the name of the method to attach to.
		// advice: Function
		//		This is function to be called before the original method
	};
	=====*/

	var around = aspect("around");
	/*=====
	 around = function(target, methodName, advice){
		// summary:
		//		The "around" export of the aspect module is a function that can be used to attach
		//		"around" advice to a method. The advisor function is immediately executed when
		//		the around() is called, is passed a single argument that is a function that can be
		//		called to continue execution of the original method (or the next around advisor).
		//		The advisor function should return a function, and this function will be called whenever
		//		the method is called. It will be called with the arguments used to call the method.
		//		Whatever this function returns will be returned as the result of the method call (unless after advise changes it).
		// example:
		//		If there are multiple "around" advisors, the most recent one is executed first,
		//		which can then delegate to the next one and so on. For example:
		//		|	around(obj, "foo", function(originalFoo){
		//		|		return function(){
		//		|			var start = new Date().getTime();
		//		|			var results = originalFoo.apply(this, arguments); // call the original
		//		|			var end = new Date().getTime();
		//		|			console.log("foo execution took " + (end - start) + " ms");
		//		|			return results;
		//		|		};
		//		|	});
		// target: Object
		//		This is the target object
		// methodName: String
		//		This is the name of the method to attach to.
		// advice: Function
		//		This is function to be called around the original method
	};
	=====*/

	return {
		// summary:
		//		provides aspect oriented programming functionality, allowing for
		//		one to add before, around, or after advice on existing methods.
		// example:
		//	|	define(["dojo/aspect"], function(aspect){
		//	|		var signal = aspect.after(targetObject, "methodName", function(someArgument){
		//	|			this will be called when targetObject.methodName() is called, after the original function is called
		//	|		});
		//
		// example:
		//	The returned signal object can be used to cancel the advice.
		//	|	signal.remove(); // this will stop the advice from being executed anymore
		//	|	aspect.before(targetObject, "methodName", function(someArgument){
		//	|		// this will be called when targetObject.methodName() is called, before the original function is called
		//	|	 });

		before: before,
		around: around,
		after: after
	};
});

},
'dojo/request/watch':function(){
define([
	'./util',
	'../errors/RequestTimeoutError',
	'../errors/CancelError',
	'../_base/array',
	'../_base/window',
	'../has!host-browser?dom-addeventlistener?:../on:'
], function(util, RequestTimeoutError, CancelError, array, win, on){
	// avoid setting a timer per request. It degrades performance on IE
	// something fierece if we don't use unified loops.
	var _inFlightIntvl = null,
		_inFlight = [];

	function watchInFlight(){
		// summary:
		//		internal method that checks each inflight XMLHttpRequest to see
		//		if it has completed or if the timeout situation applies.

		var now = +(new Date);

		// we need manual loop because we often modify _inFlight (and therefore 'i') while iterating
		for(var i = 0, dfd; i < _inFlight.length && (dfd = _inFlight[i]); i++){
			var response = dfd.response,
				options = response.options;
			if((dfd.isCanceled && dfd.isCanceled()) || (dfd.isValid && !dfd.isValid(response))){
				_inFlight.splice(i--, 1);
				watch._onAction && watch._onAction();
			}else if(dfd.isReady && dfd.isReady(response)){
				_inFlight.splice(i--, 1);
				dfd.handleResponse(response);
				watch._onAction && watch._onAction();
			}else if(dfd.startTime){
				// did we timeout?
				if(dfd.startTime + (options.timeout || 0) < now){
					_inFlight.splice(i--, 1);
					// Cancel the request so the io module can do appropriate cleanup.
					dfd.cancel(new RequestTimeoutError('Timeout exceeded', response));
					watch._onAction && watch._onAction();
				}
			}
		}

		watch._onInFlight && watch._onInFlight(dfd);

		if(!_inFlight.length){
			clearInterval(_inFlightIntvl);
			_inFlightIntvl = null;
		}
	}

	function watch(dfd){
		// summary:
		//		Watches the io request represented by dfd to see if it completes.
		// dfd: Deferred
		//		The Deferred object to watch.
		// response: Object
		//		The object used as the value of the request promise.
		// validCheck: Function
		//		Function used to check if the IO request is still valid. Gets the dfd
		//		object as its only argument.
		// ioCheck: Function
		//		Function used to check if basic IO call worked. Gets the dfd
		//		object as its only argument.
		// resHandle: Function
		//		Function used to process response. Gets the dfd
		//		object as its only argument.
		if(dfd.response.options.timeout){
			dfd.startTime = +(new Date);
		}

		if(dfd.isFulfilled()){
			// bail out if the deferred is already fulfilled
			return;
		}

		_inFlight.push(dfd);
		if(!_inFlightIntvl){
			_inFlightIntvl = setInterval(watchInFlight, 50);
		}

		// handle sync requests separately from async:
		// http://bugs.dojotoolkit.org/ticket/8467
		if(dfd.response.options.sync){
			watchInFlight();
		}
	}

	watch.cancelAll = function cancelAll(){
		// summary:
		//		Cancels all pending IO requests, regardless of IO type
		try{
			array.forEach(_inFlight, function(dfd){
				try{
					dfd.cancel(new CancelError('All requests canceled.'));
				}catch(e){}
			});
		}catch(e){}
	};

	if(win && on && win.doc.attachEvent){
		// Automatically call cancel all io calls on unload in IE
		// http://bugs.dojotoolkit.org/ticket/2357
		on(win.global, 'unload', function(){
			watch.cancelAll();
		});
	}

	return watch;
});

},
'dojo/request/util':function(){
define([
	'exports',
	'../errors/RequestError',
	'../errors/CancelError',
	'../Deferred',
	'../io-query',
	'../_base/array',
	'../_base/lang',
	'../promise/Promise',
	'../has'
], function(exports, RequestError, CancelError, Deferred, ioQuery, array, lang, Promise, has){

	function isArrayBuffer(value) {
		return has('native-arraybuffer') && value instanceof ArrayBuffer
	}

	function isBlob(value) {
		return has('native-blob') && value instanceof Blob
	}
	
	function isElement(value) {
		if(typeof Element !== 'undefined') { //all other
			return value instanceof Element;
		}

		//IE<=7
		return value.nodeType === 1;
	}

	function isFormData(value) {
		return has('native-formdata') && value instanceof FormData;
	}

	function shouldDeepCopy(value) {
		return value &&
			typeof value === 'object' &&
			!isFormData(value) &&
			!isElement(value) &&
			!isBlob(value) &&
			!isArrayBuffer(value)
	}

	exports.deepCopy = function(target, source) {
		for (var name in source) {
			var tval = target[name],
  			    sval = source[name];
			if (name !== '__proto__' && tval !== sval) {
				if (shouldDeepCopy(sval)) {
					if (Object.prototype.toString.call(sval) === '[object Date]') { // use this date test to handle crossing frame boundaries
						target[name] = new Date(sval);
					} else if (lang.isArray(sval)) {
 						  target[name] = exports.deepCopyArray(sval);
					} else {
						if (tval && typeof tval === 'object') {
							exports.deepCopy(tval, sval);
						} else {
							target[name] = exports.deepCopy({}, sval);
						}
					}
				} else {
					target[name] = sval;
				}
			}
		}
		return target;
	};

	exports.deepCopyArray = function(source) {
		var clonedArray = [];
		for (var i = 0, l = source.length; i < l; i++) {
			var svalItem = source[i];
			if (typeof svalItem === 'object') {
				clonedArray.push(exports.deepCopy({}, svalItem));
			} else {
				clonedArray.push(svalItem);
			}
		}

		return clonedArray;
	};

	exports.deepCreate = function deepCreate(source, properties){
		properties = properties || {};
		var target = lang.delegate(source),
			name, value;

		for(name in source){
			value = source[name];

			if(value && typeof value === 'object'){
				target[name] = exports.deepCreate(value, properties[name]);
			}
		}
		return exports.deepCopy(target, properties);
	};

	var freeze = Object.freeze || function(obj){ return obj; };
	function okHandler(response){
		return freeze(response);
	}
	function dataHandler (response) {
		return response.data !== undefined ? response.data : response.text;
	}

	exports.deferred = function deferred(response, cancel, isValid, isReady, handleResponse, last){
		var def = new Deferred(function(reason){
			cancel && cancel(def, response);

			if(!reason || !(reason instanceof RequestError) && !(reason instanceof CancelError)){
				return new CancelError('Request canceled', response);
			}
			return reason;
		});

		def.response = response;
		def.isValid = isValid;
		def.isReady = isReady;
		def.handleResponse = handleResponse;

		function errHandler(error){
			error.response = response;
			throw error;
		}
		var responsePromise = def.then(okHandler).otherwise(errHandler);

		if(exports.notify){
			responsePromise.then(
				lang.hitch(exports.notify, 'emit', 'load'),
				lang.hitch(exports.notify, 'emit', 'error')
			);
		}

		var dataPromise = responsePromise.then(dataHandler);

		// http://bugs.dojotoolkit.org/ticket/16794
		// The following works around a leak in IE9 through the
		// prototype using lang.delegate on dataPromise and
		// assigning the result a property with a reference to
		// responsePromise.
		var promise = new Promise();
		for (var prop in dataPromise) {
			if (dataPromise.hasOwnProperty(prop)) {
				promise[prop] = dataPromise[prop];
			}
		}
		promise.response = responsePromise;
		freeze(promise);
		// End leak fix


		if(last){
			def.then(function(response){
				last.call(def, response);
			}, function(error){
				last.call(def, response, error);
			});
		}

		def.promise = promise;
		def.then = promise.then;

		return def;
	};

	exports.addCommonMethods = function addCommonMethods(provider, methods){
		array.forEach(methods||['GET', 'POST', 'PUT', 'DELETE'], function(method){
			provider[(method === 'DELETE' ? 'DEL' : method).toLowerCase()] = function(url, options){
				options = lang.delegate(options||{});
				options.method = method;
				return provider(url, options);
			};
		});
	};

	exports.parseArgs = function parseArgs(url, options, skipData){
		var data = options.data,
			query = options.query;

		if(data && !skipData){
			if(typeof data === 'object' && (!(has('native-xhr2')) || !(isArrayBuffer(data) || isBlob(data) ))){
				options.data = ioQuery.objectToQuery(data);
			}
		}

		if(query){
			if(typeof query === 'object'){
				query = ioQuery.objectToQuery(query);
			}
			if(options.preventCache){
				query += (query ? '&' : '') + 'request.preventCache=' + (+(new Date));
			}
		}else if(options.preventCache){
			query = 'request.preventCache=' + (+(new Date));
		}

		if(url && query){
			url += (~url.indexOf('?') ? '&' : '?') + query;
		}

		return {
			url: url,
			options: options,
			getHeader: function(headerName){ return null; }
		};
	};

	exports.checkStatus = function(stat){
		stat = stat || 0;
		return (stat >= 200 && stat < 300) || // allow any 2XX response code
			stat === 304 ||                 // or, get it out of the cache
			stat === 1223 ||                // or, Internet Explorer mangled the status code
			!stat;                         // or, we're Titanium/browser chrome/chrome extension requesting a local file
	};
});

},
'dojo/errors/RequestError':function(){
define(['./create'], function(create){
	// module:
	//		dojo/errors/RequestError

	/*=====
	 return function(){
		 // summary:
		 //		TODOC
	 };
	 =====*/

	return create("RequestError", function(message, response){
		this.response = response;
	});
});

},
'dojo/errors/RequestTimeoutError':function(){
define(['./create', './RequestError'], function(create, RequestError){
	// module:
	//		dojo/errors/RequestTimeoutError

	/*=====
	 return function(){
		 // summary:
		 //		TODOC
	 };
	 =====*/

	return create("RequestTimeoutError", null, RequestError, {
		dojoType: "timeout"
	});
});

},
'dojo/request/xhr':function(){
define([
	'../errors/RequestError',
	'./watch',
	'./handlers',
	'./util',
	'../has'/*=====,
	'../request',
	'../_base/declare' =====*/
], function(RequestError, watch, handlers, util, has/*=====, request, declare =====*/){
	has.add('native-xhr', function(){
		// if true, the environment has a native XHR implementation
		return typeof XMLHttpRequest !== 'undefined';
	});
	has.add('dojo-force-activex-xhr', function(){
		return has('activex') && window.location.protocol === 'file:';
	});

	has.add('native-xhr2', function(){
		if(!has('native-xhr') || has('dojo-force-activex-xhr')){ return; }
		var x = new XMLHttpRequest();
		return typeof x['addEventListener'] !== 'undefined' &&
			(typeof opera === 'undefined' || typeof x['upload'] !== 'undefined');
	});

	has.add('native-formdata', function(){
		// if true, the environment has a native FormData implementation
		return typeof FormData !== 'undefined';
	});

	has.add('native-blob', function(){
		// if true, the environment has a native Blob implementation
		return typeof Blob !== 'undefined';
	});

	has.add('native-arraybuffer', function(){
		// if true, the environment has a native ArrayBuffer implementation
		return typeof ArrayBuffer !== 'undefined';
	});

	has.add('native-response-type', function(){
		return has('native-xhr') && typeof new XMLHttpRequest().responseType !== 'undefined';
	});

	has.add('native-xhr2-blob', function(){
		if(!has('native-response-type')){ return; }
		var x = new XMLHttpRequest();
		// The URL used here does not have to be reachable as the XHR's `send` method is never called.
		// It does need to be parsable/resolvable in all cases, so it should be an absolute URL.
		// XMLHttpRequest within a Worker created from a Blob does not support relative URL paths.
		x.open('GET', 'https://dojotoolkit.org/', true);
		x.responseType = 'blob';
		// will not be set if unsupported
		var responseType = x.responseType;
		x.abort();
		return responseType === 'blob';
	});

	// Google Chrome doesn't support "json" response type
	// up to version 30, so it's intentionally not included here
	var nativeResponseTypes = {
		'blob': has('native-xhr2-blob') ? 'blob' : 'arraybuffer',
		'document': 'document',
		'arraybuffer': 'arraybuffer'
	};

	function handleResponse(response, error){
		var _xhr = response.xhr;
		response.status = response.xhr.status;

		try {
			// Firefox throws an error when trying to access
			// xhr.responseText if response isn't text
			response.text = _xhr.responseText;
		} catch (e) {}

		if(response.options.handleAs === 'xml'){
			response.data = _xhr.responseXML;
		}

		var handleError;
		if(error){
			this.reject(error);
		}else{
			try{
				handlers(response);
			}catch(e){
				handleError = e;
			}
			if(util.checkStatus(_xhr.status)){
				if(!handleError){
					this.resolve(response);
				}else{
					this.reject(handleError);
				}
			}else{
				if(!handleError){
					error = new RequestError('Unable to load ' + response.url + ' status: ' + _xhr.status, response);
					this.reject(error);
				}else{
					error = new RequestError('Unable to load ' + response.url + ' status: ' + _xhr.status +
						' and an error in handleAs: transformation of response', response);
					this.reject(error);
				}
			}
		}
	}

	var isValid, isReady, addListeners, cancel;
	if(has('native-xhr2')){
		// Any platform with XHR2 will only use the watch mechanism for timeout.

		isValid = function(response){
			// summary:
			//		Check to see if the request should be taken out of the watch queue
			return !this.isFulfilled();
		};
		cancel = function(dfd, response){
			// summary:
			//		Canceler for deferred
			response.xhr.abort();
		};
		addListeners = function(_xhr, dfd, response, uploadProgress){
			// summary:
			//		Adds event listeners to the XMLHttpRequest object
			function onLoad(evt){
				dfd.handleResponse(response);
			}
			function onError(evt){
				var _xhr = evt.target;
				var error = new RequestError('Unable to load ' + response.url + ' status: ' + _xhr.status, response);
				dfd.handleResponse(response, error);
			}

			function onProgress(transferType, evt){
				response.transferType = transferType;
				if(evt.lengthComputable){
					response.loaded = evt.loaded;
					response.total = evt.total;
					dfd.progress(response);
				} else if(response.xhr.readyState === 3){
					response.loaded = ('loaded' in evt) ? evt.loaded : evt.position;
					dfd.progress(response);
				}
			}

			function onDownloadProgress(evt) {
				return onProgress('download', evt);
			}

			function onUploadProgress(evt) {
				return onProgress('upload', evt);
			}

			_xhr.addEventListener('load', onLoad, false);
			_xhr.addEventListener('error', onError, false);
			_xhr.addEventListener('progress', onDownloadProgress, false);

			if (uploadProgress && _xhr.upload) {
				_xhr.upload.addEventListener('progress', onUploadProgress, false);
			}

			return function(){
				_xhr.removeEventListener('load', onLoad, false);
				_xhr.removeEventListener('error', onError, false);
				_xhr.removeEventListener('progress', onDownloadProgress, false);
				_xhr.upload.removeEventListener('progress', onUploadProgress, false);
				_xhr = null;
			};
		};
	}else{
		isValid = function(response){
			return response.xhr.readyState; //boolean
		};
		isReady = function(response){
			return 4 === response.xhr.readyState; //boolean
		};
		cancel = function(dfd, response){
			// summary:
			//		canceller function for util.deferred call.
			var xhr = response.xhr;
			var _at = typeof xhr.abort;
			if(_at === 'function' || _at === 'object' || _at === 'unknown'){
				xhr.abort();
			}
		};
	}

	function getHeader(headerName){
		return this.xhr.getResponseHeader(headerName);
	}

	var undefined,
		defaultOptions = {
			data: null,
			query: null,
			sync: false,
			method: 'GET'
		};
	function xhr(url, options, returnDeferred){
		var isFormData = has('native-formdata') && options && options.data && options.data instanceof FormData;
		var response = util.parseArgs(
			url,
			util.deepCreate(defaultOptions, options),
			isFormData
		);
		url = response.url;
		options = response.options;
		var hasNoData = !options.data && options.method !== 'POST' && options.method !== 'PUT';

		if(has('ie') <= 10){
			// older IE breaks point 9 in http://www.w3.org/TR/XMLHttpRequest/#the-open()-method and sends fragment, so strip it
			url = url.split('#')[0];
		}

		var remover,
			last = function(){
				remover && remover();
			};

		//Make the Deferred object for this xhr request.
		var dfd = util.deferred(
			response,
			cancel,
			isValid,
			isReady,
			handleResponse,
			last
		);
		var _xhr = response.xhr = xhr._create();

		if(!_xhr){
			// If XHR factory somehow returns nothings,
			// cancel the deferred.
			dfd.cancel(new RequestError('XHR was not created'));
			return returnDeferred ? dfd : dfd.promise;
		}

		response.getHeader = getHeader;

		if(addListeners){
			remover = addListeners(_xhr, dfd, response, options.uploadProgress);
		}

		// IE11 treats data: undefined different than other browsers
		var data = typeof(options.data) === 'undefined' ? null : options.data,
			async = !options.sync,
			method = options.method;

		try{
			// IE6 won't let you call apply() on the native function.
			_xhr.open(method, url, async, options.user || undefined, options.password || undefined);

			if(options.withCredentials){
				_xhr.withCredentials = options.withCredentials;
			}

			if(has('native-response-type') && options.handleAs in nativeResponseTypes) {
				_xhr.responseType = nativeResponseTypes[options.handleAs];
			}

			var headers = options.headers,
				contentType = (isFormData || hasNoData) ? false : 'application/x-www-form-urlencoded';
			if(headers){
				for(var hdr in headers){
					if(hdr.toLowerCase() === 'content-type'){
						contentType = headers[hdr];
					}else if(headers[hdr]){
						//Only add header if it has a value. This allows for instance, skipping
						//insertion of X-Requested-With by specifying empty value.
						_xhr.setRequestHeader(hdr, headers[hdr]);
					}
				}
			}

			if(contentType && contentType !== false){
				_xhr.setRequestHeader('Content-Type', contentType);
			}
			if(!headers || !('X-Requested-With' in headers)){
				_xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
			}

			if(util.notify){
				util.notify.emit('send', response, dfd.promise.cancel);
			}
			_xhr.send(data);
		}catch(e){
			dfd.reject(e);
		}

		watch(dfd);
		_xhr = null;

		return returnDeferred ? dfd : dfd.promise;
	}

	/*=====
	xhr = function(url, options){
		// summary:
		//		Sends a request using XMLHttpRequest with the given URL and options.
		// url: String
		//		URL to request
		// options: dojo/request/xhr.__Options?
		//		Options for the request.
		// returns: dojo/request.__Promise
	};
	xhr.__BaseOptions = declare(request.__BaseOptions, {
		// sync: Boolean?
		//		Whether to make a synchronous request or not. Default
		//		is `false` (asynchronous).
		// data: String|Object|FormData?
		//		Data to transfer. This is ignored for GET and DELETE
		//		requests.
		// headers: Object?
		//		Headers to use for the request.
		// user: String?
		//		Username to use during the request.
		// password: String?
		//		Password to use during the request.
		// withCredentials: Boolean?
		//		For cross-site requests, whether to send credentials
		//		or not.
		// uploadProgress: Boolean?
		//		Upload progress events cause preflighted requests. This
		//		option enables upload progress event support but also
		//		causes all requests to be preflighted.
	});
	xhr.__MethodOptions = declare(null, {
		// method: String?
		//		The HTTP method to use to make the request. Must be
		//		uppercase. Default is `"GET"`.
	});
	xhr.__Options = declare([xhr.__BaseOptions, xhr.__MethodOptions]);

	xhr.get = function(url, options){
		// summary:
		//		Send an HTTP GET request using XMLHttpRequest with the given URL and options.
		// url: String
		//		URL to request
		// options: dojo/request/xhr.__BaseOptions?
		//		Options for the request.
		// returns: dojo/request.__Promise
	};
	xhr.post = function(url, options){
		// summary:
		//		Send an HTTP POST request using XMLHttpRequest with the given URL and options.
		// url: String
		//		URL to request
		// options: dojo/request/xhr.__BaseOptions?
		//		Options for the request.
		// returns: dojo/request.__Promise
	};
	xhr.put = function(url, options){
		// summary:
		//		Send an HTTP PUT request using XMLHttpRequest with the given URL and options.
		// url: String
		//		URL to request
		// options: dojo/request/xhr.__BaseOptions?
		//		Options for the request.
		// returns: dojo/request.__Promise
	};
	xhr.del = function(url, options){
		// summary:
		//		Send an HTTP DELETE request using XMLHttpRequest with the given URL and options.
		// url: String
		//		URL to request
		// options: dojo/request/xhr.__BaseOptions?
		//		Options for the request.
		// returns: dojo/request.__Promise
	};
	=====*/
	xhr._create = function(){
		// summary:
		//		does the work of portably generating a new XMLHTTPRequest object.
		throw new Error('XMLHTTP not available');
	};
	if(has('native-xhr') && !has('dojo-force-activex-xhr')){
		xhr._create = function(){
			return new XMLHttpRequest();
		};
	}else if(has('activex')){
		try{
			new ActiveXObject('Msxml2.XMLHTTP');
			xhr._create = function(){
				return new ActiveXObject('Msxml2.XMLHTTP');
			};
		}catch(e){
			try{
				new ActiveXObject('Microsoft.XMLHTTP');
				xhr._create = function(){
					return new ActiveXObject('Microsoft.XMLHTTP');
				};
			}catch(e){}
		}
	}

	util.addCommonMethods(xhr);

	return xhr;
});

},
'dojo/request/handlers':function(){
define([
	'../json',
	'../_base/kernel',
	'../_base/array',
	'../has',
	'../selector/_loader' // only included for has() qsa tests
], function(JSON, kernel, array, has){
	has.add('activex', typeof ActiveXObject !== 'undefined');
	has.add('dom-parser', function(global){
		return 'DOMParser' in global;
	});

	var handleXML;
	if(has('activex')){
		// GUIDs obtained from http://msdn.microsoft.com/en-us/library/ms757837(VS.85).aspx
		var dp = [
			'Msxml2.DOMDocument.6.0',
			'Msxml2.DOMDocument.4.0',
			'MSXML2.DOMDocument.3.0',
			'MSXML.DOMDocument' // 2.0
		];
		var lastParser;

		handleXML = function(response){
			var result = response.data;
			var text = response.text;

			if(result && has('dom-qsa2.1') && !result.querySelectorAll && has('dom-parser')){
				// http://bugs.dojotoolkit.org/ticket/15631
				// IE9 supports a CSS3 querySelectorAll implementation, but the DOM implementation
				// returned by IE9 xhr.responseXML does not. Manually create the XML DOM to gain
				// the fuller-featured implementation and avoid bugs caused by the inconsistency
				result = new DOMParser().parseFromString(text, 'application/xml');
			}

			function createDocument(p) {
					try{
						var dom = new ActiveXObject(p);
						dom.async = false;
						dom.loadXML(text);
						result = dom;
						lastParser = p;
					}catch(e){ return false; }
					return true;
			}

			if(!result || !result.documentElement){
				// The creation of an ActiveX object is expensive, so we cache the
				// parser type to avoid trying all parser types each time we handle a
				// document. There is some concern that some parser types might fail
				// depending on the document being parsed. If parsing using the cached
				// parser type fails, we do the more expensive operation of finding one
				// that works for the given document.
				// https://bugs.dojotoolkit.org/ticket/15246
				if(!lastParser || !createDocument(lastParser)) {
					array.some(dp, createDocument);
				}
			}

			return result;
		};
	}

	var handleNativeResponse = function(response) {
		if(!has('native-xhr2-blob') && response.options.handleAs === 'blob' && typeof Blob !== 'undefined'){
			return new Blob([ response.xhr.response ], { type: response.xhr.getResponseHeader('Content-Type') });
		}

		return response.xhr.response;
	}

	var handlers = {
		'javascript': function(response){
			return kernel.eval(response.text || '');
		},
		'json': function(response){
			return JSON.parse(response.text || null);
		},
		'xml': handleXML,
		'blob': handleNativeResponse,
		'arraybuffer': handleNativeResponse,
		'document': handleNativeResponse
	};

	function handle(response){
		var handler = handlers[response.options.handleAs];

		response.data = handler ? handler(response) : (response.data || response.text);

		return response;
	}

	handle.register = function(name, handler){
		handlers[name] = handler;
	};

	return handle;
});

},
'dojo/selector/_loader':function(){
define(["../has", "require"],
		function(has, require){

"use strict";
if (typeof document !== "undefined") {
	var testDiv = document.createElement("div");
	has.add("dom-qsa2.1", !!testDiv.querySelectorAll);
	has.add("dom-qsa3", function(){
		// test to see if we have a reasonable native selector engine available
		try{
			testDiv.innerHTML = "<p class='TEST'></p>"; // test kind of from sizzle
			// Safari can't handle uppercase or unicode characters when
			// in quirks mode, IE8 can't handle pseudos like :empty
			return testDiv.querySelectorAll(".TEST:empty").length == 1;
		}catch(e){}
	});
}

var fullEngine;
var acme = "./acme", lite = "./lite";
return {
	// summary:
	//		This module handles loading the appropriate selector engine for the given browser

	load: function(id, parentRequire, loaded, config){
		if (config && config.isBuild) {
			//Indicate that the optimizer should not wait
			//for this resource any more and complete optimization.
			//This resource will be resolved dynamically during
			//run time in the web browser.
			loaded();
			return;
		}

		var req = require;
		// here we implement the default logic for choosing a selector engine
		id = id == "default" ? has("config-selectorEngine") || "css3" : id;
		id = id == "css2" || id == "lite" ? lite :
				id == "css2.1" ? has("dom-qsa2.1") ? lite : acme :
				id == "css3" ? has("dom-qsa3") ? lite : acme :
				id == "acme" ? acme : (req = parentRequire) && id;
		if(id.charAt(id.length-1) == '?'){
			id = id.substring(0,id.length - 1);
			var optionalLoad = true;
		}
		// the query engine is optional, only load it if a native one is not available or existing one has not been loaded
		if(optionalLoad && (has("dom-compliant-qsa") || fullEngine)){
			return loaded(fullEngine);
		}
		// load the referenced selector engine
		req([id], function(engine){
			if(id != "./lite"){
				fullEngine = engine;
			}
			loaded(engine);
		});
	}
};
});

},
'appivo/vue/components/PlaceHolderImg':function(){
define([
    'vue/vue',
    'dojo/_base/lang',
    'dojo/text!../html/PlaceHolderImg.html'
], function(Vue, lang, template) {
    var colorRange = ['#e2b207', '#DA4167', '#8a47e2', '#004777', '#1cb0d2', '#0db983', '#ffc620','#277FB0','#ff0061', '#ff9845','#083356','#150661', '#ce1554', '#3FB568', '#4255C2', '#6D3BC6', '#f77474', '#5f0f6d', '#4D2587', '#1b9e92', '#014e58', '#9643ec', '#f36893', '#2CC989', '#5444e8', '#21d0b9','#2FDFEB', '#2d755e', '#4c1741', '#3041AF', '#110a4a'];
    return Vue.extend({
        template: template,
        props: {
            placeHolder: String,
            src: String,
            cssClass: String,
            cssStyle: Object,
            mode: {
                type: String,
                'default': 'Avatar' // option = Initials, Avatar
            },
            userItemObject: {
                type: Object,
                'default': function(){
                    return {};
                }
            },
        },
        data: function() {
            return {
                loaded: false,
                invalidImage: false
            };
        },
        watch: {
            'src': function() {
                if (this.src === null) {
                    this.loaded = false;
                } else {
                    this.invalidImage = false;
                }
            }
        },
        computed: {
            assignRandomColor: function() {
                var userId =  this.userItemObject.id;
                var randomcolor = this.stringToColor(userId);
                var styleObject = {
                    backgroundColor: randomcolor
                }
                return styleObject;
            },
            invalidSrc: function() {
                if (this.src === null) {
                    this.invalidImage = true;
                }
            }
        },
        methods: {
            stringToColor: function(str) {
                var hash = 0;
                if (str) {
                    for (var i = 0; i < str.length; i++) {
                       hash = str.charCodeAt(i) + ((hash << 5) - hash);
                   }
                   var colorIndex  = (Math.abs(hash)) % colorRange.length;
                   var color = colorRange[colorIndex];
                   return color;
                }
            },
            getInitials:function (userObject) {
                var initials = "";
                if (userObject) {
                    if (userObject.fullName) {
                        var nameArray = userObject.fullName.split(" ");
                        for (var i = 0; i < nameArray.length; i++)
                        {
                            initials = (initials + nameArray[i].substr(0,1));
                        }
                        return initials;
                    } else if (userObject.firstname && userObject.lastname) {
                        initials = userObject.firstname.substr(0,1) + userObject.lastname.substr(0,1);
                        return initials;
                    }
                }
            },
            onImageLoad: function() {
                this.loaded = true;
            },
            onProfileImageError : function () {
                this.invalidImage = true;
            }
        }
    });
});

},
'appivo/util/Boot':function(){
define([
  "jquery-ui",
  "loadimage/jcrop",
  "cropper/cropper",
  "dojo/_base/lang",
  "dojo/Deferred",
  "dojo/_base/config",
  'moment',
  'appivo/vue/VueInit',
  'appivo/util/BlobPolyfill',
  "appivo/client/Client"], function(jqueryUi, jcrop, cropper, lang, Deferred, config, moment, VueInit, BlobPolyfill, Client) {

	var LOCALE_REMAP = {
		"no": ["nb","nn"]
	};

	var appReady = new Deferred();
	var navigateTo = null;
	function handleOpenURL(url) {
		console.log("Received OpenURL-event " + url);
		var idx = url.indexOf("://");
		url = url.substring(idx + 3);
		if (!url.startsWith("/")) {
			url = "/" + url;
		}
		navigateTo = url;
		appReady.then(function() {
			console.log("Navigating to " + navigateTo);
			window.location.hash = navigateTo;
		});
	};

	window.handleOpenURL = handleOpenURL;

	VueInit.init();

	var CDN_URL = "https://cdn.appivo.com";

	if (config.appivoEnv === undefined) {
		config.appivoEnv = 'temp';
	}
	if (config.appivoVersion === undefined) {
		config.appivoVersion = '19440606-0630';
	}

	window.APPIVO_CDN = (config.appivoDev ? "" : CDN_URL) + "/" + config.appivoEnv + "/" + config.appivoVersion + "/";
	window.APPIVO_DESKTOP_CSS = window.APPIVO_CDN + "css/" + (config.appivoDev ? "_desktop.css" : "desktop.css");
	window.APPIVO_MOBILE_CSS = window.APPIVO_CDN + "css/" + (config.appivoDev ? "_mobile.css" : "mobile.css");

	var client = Client.getInstance();

	var mobileCss = "xstyle/css!" + window.APPIVO_MOBILE_CSS;
	var desktopCss = "xstyle/css!" + window.APPIVO_DESKTOP_CSS;

	var locale = client.getLocale();
	var remapped = LOCALE_REMAP[locale];
	var momentLocales = [locale];
	if (remapped) {
		momentLocales = remapped;
	}
	var mobileFiles = [mobileCss, "appivo/page/components/MobileLoginPage"];
	var desktopFiles = [desktopCss,  "dbootstrap"];

	// No need to add the english locale, it is there by default
	if (locale.indexOf('en') != 0) {
		momentLocales.forEach(function(loc) {
			var locpath = "moment/locale/" + loc;
			mobileFiles.push(locpath);
			desktopFiles.push(locpath);
		})
	}
	
	var def = new Deferred();
	var loadFiles = function(files) {
		var load = new Array();
		for(j = 0; j < files.length; j++){
			load.push(files[j]);
		}
		
		require(load, function() {
			def.resolve();
		}, function() {
			alert(error);
			def.resolve();
		});
		return def;
	};

	appReady.then(function(files) {
		if (!navigator.platform.startsWith("Mac")) {
			var rootElement = document.querySelector("html");
			rootElement.classList.add("scrollbar");
		}
		client.loadCredentials().then(function() {
			loadFiles(files);
		}, function(error) {
			loadFiles(files);
		})
	}, function(error) {
		console.error("Failed to initilize app", error);
	});

	if (client.isHybrid()) {
		console.log("Waiting for deviceready-event...");
		document.addEventListener("deviceready", function() {
			console.log("CORDOVA ", window.cordova);
			if (window.plugins && window.plugins.launchmyapp) {
				var urlScheme = client.getAppProperty("urlScheme");
				console.log("App has custom URL-scheme: " + urlScheme);
				if (window.plugins.launchmyapp.getLastIntent) {
					window.plugins.launchmyapp.getLastIntent(function (url) {
						if (url.indexOf(urlScheme + "://") > -1) {
							console.log("Application open with link " + url);
							handleOpenURL(url);
						} else {
							console.log("Ignoring intent - scheme not matching: " + url);
						}
					}, function (error) {
						console.log("No intent received");
					});
				}
			}

			document.addEventListener("resume", function() {
				console.log("Received resume-event");
				client.refreshToken();
				client.updateCaches();
			}, false);
		
			console.log("Received deviceready-event");
			// fixes ionic styling issues when statusbar is not overlaying webview
			document.body.classList.add('fullscreen');	
			if (window.cordova.InAppBrowser) {
				if (window.StatusBar) {
					// Bugfix for weird behaviour with statusbar/inappbrowser on ios ionic apps.
					var wasVisible = !!window.StatusBar.isVisible;
					window.open = function(url, target, opts) {
						var ref = window.cordova.InAppBrowser.open(url, target, opts);
						ref.addEventListener('exit', function(event) {
							if (wasVisible) {
								window.StatusBar.hide();
								window.StatusBar.show();
							} else {
								window.StatusBar.show();
								window.StatusBar.hide();
							}
						});
						return ref;
					}
				} else {
					window.open = window.cordova.InAppBrowser.open;
				}

				if (window.Keyboard && client.isIOS() && window.Keyboard.hideFormAccessoryBar) {
					window.Keyboard.hideFormAccessoryBar(false);
				}
			}

			// Load the configuration file containing data for the hybrid app
			if (cordova.file) {
				console.log("Loading appinformation.json");
				var metaFile = cordova.file.applicationDirectory + "www/appinformation.json";
				window.resolveLocalFileSystemURL(metaFile, function(cfgFile) {
					cfgFile.file(function(file) {
						var reader = new FileReader();
						reader.onloadend = function(e) {
							try {
								client.setHybridAppMetaData(JSON.parse(this.result));
								console.log("appinformation.json loaded and parsed");
								appReady.resolve(mobileFiles);
							} catch (error) {
								console.error(error);
							}
						};
						reader.onerror = function() {
							console.error(reader.error);
							appReady.reject(reader.error);
						};
						reader.readAsText(file);
					});                	
				}, function(error) {
					console.log("FileSystem Error");
					console.dir(err);
					appReady.resolve(mobileFiles);            	
				});
			} else {
				appReady.resolve(mobileFiles);
			}
		}, false);               	
	} else if (client.isMobile()) {
		appReady.resolve(mobileFiles);
	} else {
		appReady.resolve(desktopFiles);
	}

	return {
		init: function() {
			return def;
		}
	};
});
},
'loadimage/jcrop':function(){
/**
 * jquery.Jcrop.js v0.9.12
 * jQuery Image Cropping Plugin - released under MIT License 
 * Author: Kelly Hallman <khallman@gmail.com>
 * http://github.com/tapmodo/Jcrop
 * Copyright (c) 2008-2013 Tapmodo Interactive LLC {{{
 *
 * Permission is hereby granted, free of charge, to any person
 * obtaining a copy of this software and associated documentation
 * files (the "Software"), to deal in the Software without
 * restriction, including without limitation the rights to use,
 * copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following
 * conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
 * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 * OTHER DEALINGS IN THE SOFTWARE.
 *
 * }}}
 */

define(['jquery'], function($) {
	
	  $.Jcrop = function (obj, opt) {
		    var options = $.extend({}, $.Jcrop.defaults),
		        docOffset,
		        _ua = navigator.userAgent.toLowerCase(),
		        is_msie = /msie/.test(_ua),
		        ie6mode = /msie [1-6]\./.test(_ua);

		    // Internal Methods {{{
		    function px(n) {
		      return Math.round(n) + 'px';
		    }
		    function cssClass(cl) {
		      return options.baseClass + '-' + cl;
		    }
		    function supportsColorFade() {
		      return $.fx.step.hasOwnProperty('backgroundColor');
		    }
		    function getPos(obj) //{{{
		    {
		      var pos = $(obj).offset();
		      return [pos.left, pos.top];
		    }
		    //}}}
		    function mouseAbs(e) //{{{
		    {
		      return [(e.pageX - docOffset[0]), (e.pageY - docOffset[1])];
		    }
		    //}}}
		    function setOptions(opt) //{{{
		    {
		      if (typeof(opt) !== 'object') opt = {};
		      options = $.extend(options, opt);

		      $.each(['onChange','onSelect','onRelease','onDblClick'],function(i,e) {
		        if (typeof(options[e]) !== 'function') options[e] = function () {};
		      });
		    }
		    //}}}
		    function startDragMode(mode, pos, touch) //{{{
		    {
		      docOffset = getPos($img);
		      Tracker.setCursor(mode === 'move' ? mode : mode + '-resize');

		      if (mode === 'move') {
		        return Tracker.activateHandlers(createMover(pos), doneSelect, touch);
		      }

		      var fc = Coords.getFixed();
		      var opp = oppLockCorner(mode);
		      var opc = Coords.getCorner(oppLockCorner(opp));

		      Coords.setPressed(Coords.getCorner(opp));
		      Coords.setCurrent(opc);

		      Tracker.activateHandlers(dragmodeHandler(mode, fc), doneSelect, touch);
		    }
		    //}}}
		    function dragmodeHandler(mode, f) //{{{
		    {
		      return function (pos) {
		        if (!options.aspectRatio) {
		          switch (mode) {
		          case 'e':
		            pos[1] = f.y2;
		            break;
		          case 'w':
		            pos[1] = f.y2;
		            break;
		          case 'n':
		            pos[0] = f.x2;
		            break;
		          case 's':
		            pos[0] = f.x2;
		            break;
		          }
		        } else {
		          switch (mode) {
		          case 'e':
		            pos[1] = f.y + 1;
		            break;
		          case 'w':
		            pos[1] = f.y + 1;
		            break;
		          case 'n':
		            pos[0] = f.x + 1;
		            break;
		          case 's':
		            pos[0] = f.x + 1;
		            break;
		          }
		        }
		        Coords.setCurrent(pos);
		        Selection.update();
		      };
		    }
		    //}}}
		    function createMover(pos) //{{{
		    {
		      var lloc = pos;
		      KeyManager.watchKeys();

		      return function (pos) {
		        Coords.moveOffset([pos[0] - lloc[0], pos[1] - lloc[1]]);
		        lloc = pos;

		        Selection.update();
		      };
		    }
		    //}}}
		    function oppLockCorner(ord) //{{{
		    {
		      switch (ord) {
		      case 'n':
		        return 'sw';
		      case 's':
		        return 'nw';
		      case 'e':
		        return 'nw';
		      case 'w':
		        return 'ne';
		      case 'ne':
		        return 'sw';
		      case 'nw':
		        return 'se';
		      case 'se':
		        return 'nw';
		      case 'sw':
		        return 'ne';
		      }
		    }
		    //}}}
		    function createDragger(ord) //{{{
		    {
		      return function (e) {
		        if (options.disabled) {
		          return false;
		        }
		        if ((ord === 'move') && !options.allowMove) {
		          return false;
		        }
		        
		        // Fix position of crop area when dragged the very first time.
		        // Necessary when crop image is in a hidden element when page is loaded.
		        docOffset = getPos($img);

		        btndown = true;
		        startDragMode(ord, mouseAbs(e));
		        e.stopPropagation();
		        e.preventDefault();
		        return false;
		      };
		    }
		    //}}}
		    function presize($obj, w, h) //{{{
		    {
		      var nw = $obj.width(),
		          nh = $obj.height();
		      if ((nw > w) && w > 0) {
		        nw = w;
		        nh = (w / $obj.width()) * $obj.height();
		      }
		      if ((nh > h) && h > 0) {
		        nh = h;
		        nw = (h / $obj.height()) * $obj.width();
		      }
		      xscale = $obj.width() / nw;
		      yscale = $obj.height() / nh;
		      $obj.width(nw).height(nh);
		    }
		    //}}}
		    function unscale(c) //{{{
		    {
		      return {
		        x: c.x * xscale,
		        y: c.y * yscale,
		        x2: c.x2 * xscale,
		        y2: c.y2 * yscale,
		        w: c.w * xscale,
		        h: c.h * yscale
		      };
		    }
		    //}}}
		    function doneSelect(pos) //{{{
		    {
		      var c = Coords.getFixed();
		      if ((c.w > options.minSelect[0]) && (c.h > options.minSelect[1])) {
		        Selection.enableHandles();
		        Selection.done();
		      } else {
		        Selection.release();
		      }
		      Tracker.setCursor(options.allowSelect ? 'crosshair' : 'default');
		    }
		    //}}}
		    function newSelection(e) //{{{
		    {
		      if (options.disabled) {
		        return false;
		      }
		      if (!options.allowSelect) {
		        return false;
		      }
		      btndown = true;
		      docOffset = getPos($img);
		      Selection.disableHandles();
		      Tracker.setCursor('crosshair');
		      var pos = mouseAbs(e);
		      Coords.setPressed(pos);
		      Selection.update();
		      Tracker.activateHandlers(selectDrag, doneSelect, e.type.substring(0,5)==='touch');
		      KeyManager.watchKeys();

		      e.stopPropagation();
		      e.preventDefault();
		      return false;
		    }
		    //}}}
		    function selectDrag(pos) //{{{
		    {
		      Coords.setCurrent(pos);
		      Selection.update();
		    }
		    //}}}
		    function newTracker() //{{{
		    {
		      var trk = $('<div></div>').addClass(cssClass('tracker'));
		      if (is_msie) {
		        trk.css({
		          opacity: 0,
		          backgroundColor: 'white'
		        });
		      }
		      return trk;
		    }
		    //}}}

		    // }}}
		    // Initialization {{{
		    // Sanitize some options {{{
		    if (typeof(obj) !== 'object') {
		      obj = $(obj)[0];
		    }
		    if (typeof(opt) !== 'object') {
		      opt = {};
		    }
		    // }}}
		    setOptions(opt);
		    // Initialize some jQuery objects {{{
		    // The values are SET on the image(s) for the interface
		    // If the original image has any of these set, they will be reset
		    // However, if you destroy() the Jcrop instance the original image's
		    // character in the DOM will be as you left it.
		    var img_css = {
		      border: 'none',
		      visibility: 'visible',
		      margin: 0,
		      padding: 0,
		      position: 'absolute',
		      top: 0,
		      left: 0
		    };

		    var $origimg = $(obj),
		      img_mode = true;

		    if (obj.tagName == 'IMG') {
		      // Fix size of crop image.
		      // Necessary when crop image is within a hidden element when page is loaded.
		      if ($origimg[0].width != 0 && $origimg[0].height != 0) {
		        // Obtain dimensions from contained img element.
		        $origimg.width($origimg[0].width);
		        $origimg.height($origimg[0].height);
		      } else {
		        // Obtain dimensions from temporary image in case the original is not loaded yet (e.g. IE 7.0). 
		        var tempImage = new Image();
		        tempImage.src = $origimg[0].src;
		        $origimg.width(tempImage.width);
		        $origimg.height(tempImage.height);
		      } 

		      var $img = $origimg.clone().removeAttr('id').css(img_css).show();

		      $img.width($origimg.width());
		      $img.height($origimg.height());
		      $origimg.after($img).hide();

		    } else {
		      $img = $origimg.css(img_css).show();
		      img_mode = false;
		      if (options.shade === null) { options.shade = true; }
		    }

		    presize($img, options.boxWidth, options.boxHeight);

		    var boundx = $img.width(),
		        boundy = $img.height(),
		        
		        
		        $div = $('<div />').width(boundx).height(boundy).addClass(cssClass('holder')).css({
		        position: 'relative',
		        backgroundColor: options.bgColor
		      }).insertAfter($origimg).append($img);

		    if (options.addClass) {
		      $div.addClass(options.addClass);
		    }

		    var $img2 = $('<div />'),

		        $img_holder = $('<div />') 
		        .width('100%').height('100%').css({
		          zIndex: 310,
		          position: 'absolute',
		          overflow: 'hidden'
		        }),

		        $hdl_holder = $('<div />') 
		        .width('100%').height('100%').css('zIndex', 320), 

		        $sel = $('<div />') 
		        .css({
		          position: 'absolute',
		          zIndex: 600
		        }).dblclick(function(){
		          var c = Coords.getFixed();
		          options.onDblClick.call(api,c);
		        }).insertBefore($img).append($img_holder, $hdl_holder); 

		    if (img_mode) {

		      $img2 = $('<img />')
		          .attr('src', $img.attr('src')).css(img_css).width(boundx).height(boundy),

		      $img_holder.append($img2);

		    }

		    if (ie6mode) {
		      $sel.css({
		        overflowY: 'hidden'
		      });
		    }

		    var bound = options.boundary;
		    var $trk = newTracker().width(boundx + (bound * 2)).height(boundy + (bound * 2)).css({
		      position: 'absolute',
		      top: px(-bound),
		      left: px(-bound),
		      zIndex: 290
		    }).mousedown(newSelection);

		    /* }}} */
		    // Set more variables {{{
		    var bgcolor = options.bgColor,
		        bgopacity = options.bgOpacity,
		        xlimit, ylimit, xmin, ymin, xscale, yscale, enabled = true,
		        btndown, animating, shift_down;

		    docOffset = getPos($img);
		    // }}}
		    // }}}
		    // Internal Modules {{{
		    // Touch Module {{{ 
		    var Touch = (function () {
		      // Touch support detection function adapted (under MIT License)
		      // from code by Jeffrey Sambells - http://github.com/iamamused/
		      function hasTouchSupport() {
		        var support = {}, events = ['touchstart', 'touchmove', 'touchend'],
		            el = document.createElement('div'), i;

		        try {
		          for(i=0; i<events.length; i++) {
		            var eventName = events[i];
		            eventName = 'on' + eventName;
		            var isSupported = (eventName in el);
		            if (!isSupported) {
		              el.setAttribute(eventName, 'return;');
		              isSupported = typeof el[eventName] == 'function';
		            }
		            support[events[i]] = isSupported;
		          }
		          return support.touchstart && support.touchend && support.touchmove;
		        }
		        catch(err) {
		          return false;
		        }
		      }

		      function detectSupport() {
		        if ((options.touchSupport === true) || (options.touchSupport === false)) return options.touchSupport;
		          else return hasTouchSupport();
		      }
		      return {
		        createDragger: function (ord) {
		          return function (e) {
		            if (options.disabled) {
		              return false;
		            }
		            if ((ord === 'move') && !options.allowMove) {
		              return false;
		            }
		            docOffset = getPos($img);
		            btndown = true;
		            startDragMode(ord, mouseAbs(Touch.cfilter(e)), true);
		            e.stopPropagation();
		            e.preventDefault();
		            return false;
		          };
		        },
		        newSelection: function (e) {
		          return newSelection(Touch.cfilter(e));
		        },
		        cfilter: function (e){
		          e.pageX = e.originalEvent.changedTouches[0].pageX;
		          e.pageY = e.originalEvent.changedTouches[0].pageY;
		          return e;
		        },
		        isSupported: hasTouchSupport,
		        support: detectSupport()
		      };
		    }());
		    // }}}
		    // Coords Module {{{
		    var Coords = (function () {
		      var x1 = 0,
		          y1 = 0,
		          x2 = 0,
		          y2 = 0,
		          ox, oy;

		      function setPressed(pos) //{{{
		      {
		        pos = rebound(pos);
		        x2 = x1 = pos[0];
		        y2 = y1 = pos[1];
		      }
		      //}}}
		      function setCurrent(pos) //{{{
		      {
		        pos = rebound(pos);
		        ox = pos[0] - x2;
		        oy = pos[1] - y2;
		        x2 = pos[0];
		        y2 = pos[1];
		      }
		      //}}}
		      function getOffset() //{{{
		      {
		        return [ox, oy];
		      }
		      //}}}
		      function moveOffset(offset) //{{{
		      {
		        var ox = offset[0],
		            oy = offset[1];

		        if (0 > x1 + ox) {
		          ox -= ox + x1;
		        }
		        if (0 > y1 + oy) {
		          oy -= oy + y1;
		        }

		        if (boundy < y2 + oy) {
		          oy += boundy - (y2 + oy);
		        }
		        if (boundx < x2 + ox) {
		          ox += boundx - (x2 + ox);
		        }

		        x1 += ox;
		        x2 += ox;
		        y1 += oy;
		        y2 += oy;
		      }
		      //}}}
		      function getCorner(ord) //{{{
		      {
		        var c = getFixed();
		        switch (ord) {
		        case 'ne':
		          return [c.x2, c.y];
		        case 'nw':
		          return [c.x, c.y];
		        case 'se':
		          return [c.x2, c.y2];
		        case 'sw':
		          return [c.x, c.y2];
		        }
		      }
		      //}}}
		      function getFixed() //{{{
		      {
		        if (!options.aspectRatio) {
		          return getRect();
		        }
		        // This function could use some optimization I think...
		        var aspect = options.aspectRatio,
		            min_x = options.minSize[0] / xscale,
		            
		            
		            //min_y = options.minSize[1]/yscale,
		            max_x = options.maxSize[0] / xscale,
		            max_y = options.maxSize[1] / yscale,
		            rw = x2 - x1,
		            rh = y2 - y1,
		            rwa = Math.abs(rw),
		            rha = Math.abs(rh),
		            real_ratio = rwa / rha,
		            xx, yy, w, h;

		        if (max_x === 0) {
		          max_x = boundx * 10;
		        }
		        if (max_y === 0) {
		          max_y = boundy * 10;
		        }
		        if (real_ratio < aspect) {
		          yy = y2;
		          w = rha * aspect;
		          xx = rw < 0 ? x1 - w : w + x1;

		          if (xx < 0) {
		            xx = 0;
		            h = Math.abs((xx - x1) / aspect);
		            yy = rh < 0 ? y1 - h : h + y1;
		          } else if (xx > boundx) {
		            xx = boundx;
		            h = Math.abs((xx - x1) / aspect);
		            yy = rh < 0 ? y1 - h : h + y1;
		          }
		        } else {
		          xx = x2;
		          h = rwa / aspect;
		          yy = rh < 0 ? y1 - h : y1 + h;
		          if (yy < 0) {
		            yy = 0;
		            w = Math.abs((yy - y1) * aspect);
		            xx = rw < 0 ? x1 - w : w + x1;
		          } else if (yy > boundy) {
		            yy = boundy;
		            w = Math.abs(yy - y1) * aspect;
		            xx = rw < 0 ? x1 - w : w + x1;
		          }
		        }

		        // Magic %-)
		        if (xx > x1) { // right side
		          if (xx - x1 < min_x) {
		            xx = x1 + min_x;
		          } else if (xx - x1 > max_x) {
		            xx = x1 + max_x;
		          }
		          if (yy > y1) {
		            yy = y1 + (xx - x1) / aspect;
		          } else {
		            yy = y1 - (xx - x1) / aspect;
		          }
		        } else if (xx < x1) { // left side
		          if (x1 - xx < min_x) {
		            xx = x1 - min_x;
		          } else if (x1 - xx > max_x) {
		            xx = x1 - max_x;
		          }
		          if (yy > y1) {
		            yy = y1 + (x1 - xx) / aspect;
		          } else {
		            yy = y1 - (x1 - xx) / aspect;
		          }
		        }

		        if (xx < 0) {
		          x1 -= xx;
		          xx = 0;
		        } else if (xx > boundx) {
		          x1 -= xx - boundx;
		          xx = boundx;
		        }

		        if (yy < 0) {
		          y1 -= yy;
		          yy = 0;
		        } else if (yy > boundy) {
		          y1 -= yy - boundy;
		          yy = boundy;
		        }

		        return makeObj(flipCoords(x1, y1, xx, yy));
		      }
		      //}}}
		      function rebound(p) //{{{
		      {
		        if (p[0] < 0) p[0] = 0;
		        if (p[1] < 0) p[1] = 0;

		        if (p[0] > boundx) p[0] = boundx;
		        if (p[1] > boundy) p[1] = boundy;

		        return [Math.round(p[0]), Math.round(p[1])];
		      }
		      //}}}
		      function flipCoords(x1, y1, x2, y2) //{{{
		      {
		        var xa = x1,
		            xb = x2,
		            ya = y1,
		            yb = y2;
		        if (x2 < x1) {
		          xa = x2;
		          xb = x1;
		        }
		        if (y2 < y1) {
		          ya = y2;
		          yb = y1;
		        }
		        return [xa, ya, xb, yb];
		      }
		      //}}}
		      function getRect() //{{{
		      {
		        var xsize = x2 - x1,
		            ysize = y2 - y1,
		            delta;

		        if (xlimit && (Math.abs(xsize) > xlimit)) {
		          x2 = (xsize > 0) ? (x1 + xlimit) : (x1 - xlimit);
		        }
		        if (ylimit && (Math.abs(ysize) > ylimit)) {
		          y2 = (ysize > 0) ? (y1 + ylimit) : (y1 - ylimit);
		        }

		        if (ymin / yscale && (Math.abs(ysize) < ymin / yscale)) {
		          y2 = (ysize > 0) ? (y1 + ymin / yscale) : (y1 - ymin / yscale);
		        }
		        if (xmin / xscale && (Math.abs(xsize) < xmin / xscale)) {
		          x2 = (xsize > 0) ? (x1 + xmin / xscale) : (x1 - xmin / xscale);
		        }

		        if (x1 < 0) {
		          x2 -= x1;
		          x1 -= x1;
		        }
		        if (y1 < 0) {
		          y2 -= y1;
		          y1 -= y1;
		        }
		        if (x2 < 0) {
		          x1 -= x2;
		          x2 -= x2;
		        }
		        if (y2 < 0) {
		          y1 -= y2;
		          y2 -= y2;
		        }
		        if (x2 > boundx) {
		          delta = x2 - boundx;
		          x1 -= delta;
		          x2 -= delta;
		        }
		        if (y2 > boundy) {
		          delta = y2 - boundy;
		          y1 -= delta;
		          y2 -= delta;
		        }
		        if (x1 > boundx) {
		          delta = x1 - boundy;
		          y2 -= delta;
		          y1 -= delta;
		        }
		        if (y1 > boundy) {
		          delta = y1 - boundy;
		          y2 -= delta;
		          y1 -= delta;
		        }

		        return makeObj(flipCoords(x1, y1, x2, y2));
		      }
		      //}}}
		      function makeObj(a) //{{{
		      {
		        return {
		          x: a[0],
		          y: a[1],
		          x2: a[2],
		          y2: a[3],
		          w: a[2] - a[0],
		          h: a[3] - a[1]
		        };
		      }
		      //}}}

		      return {
		        flipCoords: flipCoords,
		        setPressed: setPressed,
		        setCurrent: setCurrent,
		        getOffset: getOffset,
		        moveOffset: moveOffset,
		        getCorner: getCorner,
		        getFixed: getFixed
		      };
		    }());

		    //}}}
		    // Shade Module {{{
		    var Shade = (function() {
		      var enabled = false,
		          holder = $('<div />').css({
		            position: 'absolute',
		            zIndex: 240,
		            opacity: 0
		          }),
		          shades = {
		            top: createShade(),
		            left: createShade().height(boundy),
		            right: createShade().height(boundy),
		            bottom: createShade()
		          };

		      function resizeShades(w,h) {
		        shades.left.css({ height: px(h) });
		        shades.right.css({ height: px(h) });
		      }
		      function updateAuto()
		      {
		        return updateShade(Coords.getFixed());
		      }
		      function updateShade(c)
		      {
		        shades.top.css({
		          left: px(c.x),
		          width: px(c.w),
		          height: px(c.y)
		        });
		        shades.bottom.css({
		          top: px(c.y2),
		          left: px(c.x),
		          width: px(c.w),
		          height: px(boundy-c.y2)
		        });
		        shades.right.css({
		          left: px(c.x2),
		          width: px(boundx-c.x2)
		        });
		        shades.left.css({
		          width: px(c.x)
		        });
		      }
		      function createShade() {
		        return $('<div />').css({
		          position: 'absolute',
		          backgroundColor: options.shadeColor||options.bgColor
		        }).appendTo(holder);
		      }
		      function enableShade() {
		        if (!enabled) {
		          enabled = true;
		          holder.insertBefore($img);
		          updateAuto();
		          Selection.setBgOpacity(1,0,1);
		          $img2.hide();

		          setBgColor(options.shadeColor||options.bgColor,1);
		          if (Selection.isAwake())
		          {
		            setOpacity(options.bgOpacity,1);
		          }
		            else setOpacity(1,1);
		        }
		      }
		      function setBgColor(color,now) {
		        colorChangeMacro(getShades(),color,now);
		      }
		      function disableShade() {
		        if (enabled) {
		          holder.remove();
		          $img2.show();
		          enabled = false;
		          if (Selection.isAwake()) {
		            Selection.setBgOpacity(options.bgOpacity,1,1);
		          } else {
		            Selection.setBgOpacity(1,1,1);
		            Selection.disableHandles();
		          }
		          colorChangeMacro($div,0,1);
		        }
		      }
		      function setOpacity(opacity,now) {
		        if (enabled) {
		          if (options.bgFade && !now) {
		            holder.animate({
		              opacity: 1-opacity
		            },{
		              queue: false,
		              duration: options.fadeTime
		            });
		          }
		          else holder.css({opacity:1-opacity});
		        }
		      }
		      function refreshAll() {
		        options.shade ? enableShade() : disableShade();
		        if (Selection.isAwake()) setOpacity(options.bgOpacity);
		      }
		      function getShades() {
		        return holder.children();
		      }

		      return {
		        update: updateAuto,
		        updateRaw: updateShade,
		        getShades: getShades,
		        setBgColor: setBgColor,
		        enable: enableShade,
		        disable: disableShade,
		        resize: resizeShades,
		        refresh: refreshAll,
		        opacity: setOpacity
		      };
		    }());
		    // }}}
		    // Selection Module {{{
		    var Selection = (function () {
		      var awake,
		          hdep = 370,
		          borders = {},
		          handle = {},
		          dragbar = {},
		          seehandles = false;

		      // Private Methods
		      function insertBorder(type) //{{{
		      {
		        var jq = $('<div />').css({
		          position: 'absolute',
		          opacity: options.borderOpacity
		        }).addClass(cssClass(type));
		        $img_holder.append(jq);
		        return jq;
		      }
		      //}}}
		      function dragDiv(ord, zi) //{{{
		      {
		        var jq = $('<div />').mousedown(createDragger(ord)).css({
		          cursor: ord + '-resize',
		          position: 'absolute',
		          zIndex: zi
		        }).addClass('ord-'+ord);

		        if (Touch.support) {
		          jq.bind('touchstart.jcrop', Touch.createDragger(ord));
		        }

		        $hdl_holder.append(jq);
		        return jq;
		      }
		      //}}}
		      function insertHandle(ord) //{{{
		      {
		        var hs = options.handleSize,

		          div = dragDiv(ord, hdep++).css({
		            opacity: options.handleOpacity
		          }).addClass(cssClass('handle'));

		        if (hs) { div.width(hs).height(hs); }

		        return div;
		      }
		      //}}}
		      function insertDragbar(ord) //{{{
		      {
		        return dragDiv(ord, hdep++).addClass('jcrop-dragbar');
		      }
		      //}}}
		      function createDragbars(li) //{{{
		      {
		        var i;
		        for (i = 0; i < li.length; i++) {
		          dragbar[li[i]] = insertDragbar(li[i]);
		        }
		      }
		      //}}}
		      function createBorders(li) //{{{
		      {
		        var cl,i;
		        for (i = 0; i < li.length; i++) {
		          switch(li[i]){
		            case'n': cl='hline'; break;
		            case's': cl='hline bottom'; break;
		            case'e': cl='vline right'; break;
		            case'w': cl='vline'; break;
		          }
		          borders[li[i]] = insertBorder(cl);
		        }
		      }
		      //}}}
		      function createHandles(li) //{{{
		      {
		        var i;
		        for (i = 0; i < li.length; i++) {
		          handle[li[i]] = insertHandle(li[i]);
		        }
		      }
		      //}}}
		      function moveto(x, y) //{{{
		      {
		        if (!options.shade) {
		          $img2.css({
		            top: px(-y),
		            left: px(-x)
		          });
		        }
		        $sel.css({
		          top: px(y),
		          left: px(x)
		        });
		      }
		      //}}}
		      function resize(w, h) //{{{
		      {
		        $sel.width(Math.round(w)).height(Math.round(h));
		      }
		      //}}}
		      function refresh() //{{{
		      {
		        var c = Coords.getFixed();

		        Coords.setPressed([c.x, c.y]);
		        Coords.setCurrent([c.x2, c.y2]);

		        updateVisible();
		      }
		      //}}}

		      // Internal Methods
		      function updateVisible(select) //{{{
		      {
		        if (awake) {
		          return update(select);
		        }
		      }
		      //}}}
		      function update(select) //{{{
		      {
		        var c = Coords.getFixed();

		        resize(c.w, c.h);
		        moveto(c.x, c.y);
		        if (options.shade) Shade.updateRaw(c);

		        awake || show();

		        if (select) {
		          options.onSelect.call(api, unscale(c));
		        } else {
		          options.onChange.call(api, unscale(c));
		        }
		      }
		      //}}}
		      function setBgOpacity(opacity,force,now) //{{{
		      {
		        if (!awake && !force) return;
		        if (options.bgFade && !now) {
		          $img.animate({
		            opacity: opacity
		          },{
		            queue: false,
		            duration: options.fadeTime
		          });
		        } else {
		          $img.css('opacity', opacity);
		        }
		      }
		      //}}}
		      function show() //{{{
		      {
		        $sel.show();

		        if (options.shade) Shade.opacity(bgopacity);
		          else setBgOpacity(bgopacity,true);

		        awake = true;
		      }
		      //}}}
		      function release() //{{{
		      {
		        disableHandles();
		        $sel.hide();

		        if (options.shade) Shade.opacity(1);
		          else setBgOpacity(1);

		        awake = false;
		        options.onRelease.call(api);
		      }
		      //}}}
		      function showHandles() //{{{
		      {
		        if (seehandles) {
		          $hdl_holder.show();
		        }
		      }
		      //}}}
		      function enableHandles() //{{{
		      {
		        seehandles = true;
		        if (options.allowResize) {
		          $hdl_holder.show();
		          return true;
		        }
		      }
		      //}}}
		      function disableHandles() //{{{
		      {
		        seehandles = false;
		        $hdl_holder.hide();
		      } 
		      //}}}
		      function animMode(v) //{{{
		      {
		        if (v) {
		          animating = true;
		          disableHandles();
		        } else {
		          animating = false;
		          enableHandles();
		        }
		      } 
		      //}}}
		      function done() //{{{
		      {
		        animMode(false);
		        refresh();
		      } 
		      //}}}
		      // Insert draggable elements {{{
		      // Insert border divs for outline

		      if (options.dragEdges && $.isArray(options.createDragbars))
		        createDragbars(options.createDragbars);

		      if ($.isArray(options.createHandles))
		        createHandles(options.createHandles);

		      if (options.drawBorders && $.isArray(options.createBorders))
		        createBorders(options.createBorders);

		      //}}}

		      // This is a hack for iOS5 to support drag/move touch functionality
		      $(document).bind('touchstart.jcrop-ios',function(e) {
		        if ($(e.currentTarget).hasClass('jcrop-tracker')) e.stopPropagation();
		      });

		      var $track = newTracker().mousedown(createDragger('move')).css({
		        cursor: 'move',
		        position: 'absolute',
		        zIndex: 360
		      });

		      if (Touch.support) {
		        $track.bind('touchstart.jcrop', Touch.createDragger('move'));
		      }

		      $img_holder.append($track);
		      disableHandles();

		      return {
		        updateVisible: updateVisible,
		        update: update,
		        release: release,
		        refresh: refresh,
		        isAwake: function () {
		          return awake;
		        },
		        setCursor: function (cursor) {
		          $track.css('cursor', cursor);
		        },
		        enableHandles: enableHandles,
		        enableOnly: function () {
		          seehandles = true;
		        },
		        showHandles: showHandles,
		        disableHandles: disableHandles,
		        animMode: animMode,
		        setBgOpacity: setBgOpacity,
		        done: done
		      };
		    }());
		    
		    //}}}
		    // Tracker Module {{{
		    var Tracker = (function () {
		      var onMove = function () {},
		          onDone = function () {},
		          trackDoc = options.trackDocument;

		      function toFront(touch) //{{{
		      {
		        $trk.css({
		          zIndex: 450
		        });

		        if (touch)
		          $(document)
		            .bind('touchmove.jcrop', trackTouchMove)
		            .bind('touchend.jcrop', trackTouchEnd);

		        else if (trackDoc)
		          $(document)
		            .bind('mousemove.jcrop',trackMove)
		            .bind('mouseup.jcrop',trackUp);
		      } 
		      //}}}
		      function toBack() //{{{
		      {
		        $trk.css({
		          zIndex: 290
		        });
		        $(document).unbind('.jcrop');
		      } 
		      //}}}
		      function trackMove(e) //{{{
		      {
		        onMove(mouseAbs(e));
		        return false;
		      } 
		      //}}}
		      function trackUp(e) //{{{
		      {
		        e.preventDefault();
		        e.stopPropagation();

		        if (btndown) {
		          btndown = false;

		          onDone(mouseAbs(e));

		          if (Selection.isAwake()) {
		            options.onSelect.call(api, unscale(Coords.getFixed()));
		          }

		          toBack();
		          onMove = function () {};
		          onDone = function () {};
		        }

		        return false;
		      }
		      //}}}
		      function activateHandlers(move, done, touch) //{{{
		      {
		        btndown = true;
		        onMove = move;
		        onDone = done;
		        toFront(touch);
		        return false;
		      }
		      //}}}
		      function trackTouchMove(e) //{{{
		      {
		        onMove(mouseAbs(Touch.cfilter(e)));
		        return false;
		      }
		      //}}}
		      function trackTouchEnd(e) //{{{
		      {
		        return trackUp(Touch.cfilter(e));
		      }
		      //}}}
		      function setCursor(t) //{{{
		      {
		        $trk.css('cursor', t);
		      }
		      //}}}

		      if (!trackDoc) {
		        $trk.mousemove(trackMove).mouseup(trackUp).mouseout(trackUp);
		      }

		      $img.before($trk);
		      return {
		        activateHandlers: activateHandlers,
		        setCursor: setCursor
		      };
		    }());
		    //}}}
		    // KeyManager Module {{{
		    var KeyManager = (function () {
		      var $keymgr = $('<input type="radio" />').css({
		        position: 'fixed',
		        left: '-120px',
		        width: '12px'
		      }).addClass('jcrop-keymgr'),

		        $keywrap = $('<div />').css({
		          position: 'absolute',
		          overflow: 'hidden'
		        }).append($keymgr);

		      function watchKeys() //{{{
		      {
		        if (options.keySupport) {
		          $keymgr.show();
		          $keymgr.focus();
		        }
		      }
		      //}}}
		      function onBlur(e) //{{{
		      {
		        $keymgr.hide();
		      }
		      //}}}
		      function doNudge(e, x, y) //{{{
		      {
		        if (options.allowMove) {
		          Coords.moveOffset([x, y]);
		          Selection.updateVisible(true);
		        }
		        e.preventDefault();
		        e.stopPropagation();
		      }
		      //}}}
		      function parseKey(e) //{{{
		      {
		        if (e.ctrlKey || e.metaKey) {
		          return true;
		        }
		        shift_down = e.shiftKey ? true : false;
		        var nudge = shift_down ? 10 : 1;

		        switch (e.keyCode) {
		        case 37:
		          doNudge(e, -nudge, 0);
		          break;
		        case 39:
		          doNudge(e, nudge, 0);
		          break;
		        case 38:
		          doNudge(e, 0, -nudge);
		          break;
		        case 40:
		          doNudge(e, 0, nudge);
		          break;
		        case 27:
		          if (options.allowSelect) Selection.release();
		          break;
		        case 9:
		          return true;
		        }

		        return false;
		      }
		      //}}}

		      if (options.keySupport) {
		        $keymgr.keydown(parseKey).blur(onBlur);
		        if (ie6mode || !options.fixedSupport) {
		          $keymgr.css({
		            position: 'absolute',
		            left: '-20px'
		          });
		          $keywrap.append($keymgr).insertBefore($img);
		        } else {
		          $keymgr.insertBefore($img);
		        }
		      }


		      return {
		        watchKeys: watchKeys
		      };
		    }());
		    //}}}
		    // }}}
		    // API methods {{{
		    function setClass(cname) //{{{
		    {
		      $div.removeClass().addClass(cssClass('holder')).addClass(cname);
		    }
		    //}}}
		    function animateTo(a, callback) //{{{
		    {
		      var x1 = a[0] / xscale,
		          y1 = a[1] / yscale,
		          x2 = a[2] / xscale,
		          y2 = a[3] / yscale;

		      if (animating) {
		        return;
		      }

		      var animto = Coords.flipCoords(x1, y1, x2, y2),
		          c = Coords.getFixed(),
		          initcr = [c.x, c.y, c.x2, c.y2],
		          animat = initcr,
		          interv = options.animationDelay,
		          ix1 = animto[0] - initcr[0],
		          iy1 = animto[1] - initcr[1],
		          ix2 = animto[2] - initcr[2],
		          iy2 = animto[3] - initcr[3],
		          pcent = 0,
		          velocity = options.swingSpeed;

		      x1 = animat[0];
		      y1 = animat[1];
		      x2 = animat[2];
		      y2 = animat[3];

		      Selection.animMode(true);
		      var anim_timer;

		      function queueAnimator() {
		        window.setTimeout(animator, interv);
		      }
		      var animator = (function () {
		        return function () {
		          pcent += (100 - pcent) / velocity;

		          animat[0] = Math.round(x1 + ((pcent / 100) * ix1));
		          animat[1] = Math.round(y1 + ((pcent / 100) * iy1));
		          animat[2] = Math.round(x2 + ((pcent / 100) * ix2));
		          animat[3] = Math.round(y2 + ((pcent / 100) * iy2));

		          if (pcent >= 99.8) {
		            pcent = 100;
		          }
		          if (pcent < 100) {
		            setSelectRaw(animat);
		            queueAnimator();
		          } else {
		            Selection.done();
		            Selection.animMode(false);
		            if (typeof(callback) === 'function') {
		              callback.call(api);
		            }
		          }
		        };
		      }());
		      queueAnimator();
		    }
		    //}}}
		    function setSelect(rect) //{{{
		    {
		      setSelectRaw([rect[0] / xscale, rect[1] / yscale, rect[2] / xscale, rect[3] / yscale]);
		      options.onSelect.call(api, unscale(Coords.getFixed()));
		      Selection.enableHandles();
		    }
		    //}}}
		    function setSelectRaw(l) //{{{
		    {
		      Coords.setPressed([l[0], l[1]]);
		      Coords.setCurrent([l[2], l[3]]);
		      Selection.update();
		    }
		    //}}}
		    function tellSelect() //{{{
		    {
		      return unscale(Coords.getFixed());
		    }
		    //}}}
		    function tellScaled() //{{{
		    {
		      return Coords.getFixed();
		    }
		    //}}}
		    function setOptionsNew(opt) //{{{
		    {
		      setOptions(opt);
		      interfaceUpdate();
		    }
		    //}}}
		    function disableCrop() //{{{
		    {
		      options.disabled = true;
		      Selection.disableHandles();
		      Selection.setCursor('default');
		      Tracker.setCursor('default');
		    }
		    //}}}
		    function enableCrop() //{{{
		    {
		      options.disabled = false;
		      interfaceUpdate();
		    }
		    //}}}
		    function cancelCrop() //{{{
		    {
		      Selection.done();
		      Tracker.activateHandlers(null, null);
		    }
		    //}}}
		    function destroy() //{{{
		    {
		      $div.remove();
		      $origimg.show();
		      $origimg.css('visibility','visible');
		      $(obj).removeData('Jcrop');
		    }
		    //}}}
		    function setImage(src, callback) //{{{
		    {
		      Selection.release();
		      disableCrop();
		      var img = new Image();
		      img.onload = function () {
		        var iw = img.width;
		        var ih = img.height;
		        var bw = options.boxWidth;
		        var bh = options.boxHeight;
		        $img.width(iw).height(ih);
		        $img.attr('src', src);
		        $img2.attr('src', src);
		        presize($img, bw, bh);
		        boundx = $img.width();
		        boundy = $img.height();
		        $img2.width(boundx).height(boundy);
		        $trk.width(boundx + (bound * 2)).height(boundy + (bound * 2));
		        $div.width(boundx).height(boundy);
		        Shade.resize(boundx,boundy);
		        enableCrop();

		        if (typeof(callback) === 'function') {
		          callback.call(api);
		        }
		      };
		      img.src = src;
		    }
		    //}}}
		    function colorChangeMacro($obj,color,now) {
		      var mycolor = color || options.bgColor;
		      if (options.bgFade && supportsColorFade() && options.fadeTime && !now) {
		        $obj.animate({
		          backgroundColor: mycolor
		        }, {
		          queue: false,
		          duration: options.fadeTime
		        });
		      } else {
		        $obj.css('backgroundColor', mycolor);
		      }
		    }
		    function interfaceUpdate(alt) //{{{
		    // This method tweaks the interface based on options object.
		    // Called when options are changed and at end of initialization.
		    {
		      if (options.allowResize) {
		        if (alt) {
		          Selection.enableOnly();
		        } else {
		          Selection.enableHandles();
		        }
		      } else {
		        Selection.disableHandles();
		      }

		      Tracker.setCursor(options.allowSelect ? 'crosshair' : 'default');
		      Selection.setCursor(options.allowMove ? 'move' : 'default');

		      if (options.hasOwnProperty('trueSize')) {
		        xscale = options.trueSize[0] / boundx;
		        yscale = options.trueSize[1] / boundy;
		      }

		      if (options.hasOwnProperty('setSelect')) {
		        setSelect(options.setSelect);
		        Selection.done();
		        delete(options.setSelect);
		      }

		      Shade.refresh();

		      if (options.bgColor != bgcolor) {
		        colorChangeMacro(
		          options.shade? Shade.getShades(): $div,
		          options.shade?
		            (options.shadeColor || options.bgColor):
		            options.bgColor
		        );
		        bgcolor = options.bgColor;
		      }

		      if (bgopacity != options.bgOpacity) {
		        bgopacity = options.bgOpacity;
		        if (options.shade) Shade.refresh();
		          else Selection.setBgOpacity(bgopacity);
		      }

		      xlimit = options.maxSize[0] || 0;
		      ylimit = options.maxSize[1] || 0;
		      xmin = options.minSize[0] || 0;
		      ymin = options.minSize[1] || 0;

		      if (options.hasOwnProperty('outerImage')) {
		        $img.attr('src', options.outerImage);
		        delete(options.outerImage);
		      }

		      Selection.refresh();
		    }
		    //}}}
		    //}}}

		    if (Touch.support) $trk.bind('touchstart.jcrop', Touch.newSelection);

		    $hdl_holder.hide();
		    interfaceUpdate(true);

		    var api = {
		      setImage: setImage,
		      animateTo: animateTo,
		      setSelect: setSelect,
		      setOptions: setOptionsNew,
		      tellSelect: tellSelect,
		      tellScaled: tellScaled,
		      setClass: setClass,

		      disable: disableCrop,
		      enable: enableCrop,
		      cancel: cancelCrop,
		      release: Selection.release,
		      destroy: destroy,

		      focus: KeyManager.watchKeys,

		      getBounds: function () {
		        return [boundx * xscale, boundy * yscale];
		      },
		      getWidgetSize: function () {
		        return [boundx, boundy];
		      },
		      getScaleFactor: function () {
		        return [xscale, yscale];
		      },
		      getOptions: function() {
		        // careful: internal values are returned
		        return options;
		      },

		      ui: {
		        holder: $div,
		        selection: $sel
		      }
		    };

		    if (is_msie) $div.bind('selectstart', function () { return false; });

		    $origimg.data('Jcrop', api);
		    return api;
		  };
		  $.fn.Jcrop = function (options, callback) //{{{
		  {
		    var api;
		    // Iterate over each object, attach Jcrop
		    this.each(function () {
		      // If we've already attached to this object
		      if ($(this).data('Jcrop')) {
		        // The API can be requested this way (undocumented)
		        if (options === 'api') return $(this).data('Jcrop');
		        // Otherwise, we just reset the options...
		        else $(this).data('Jcrop').setOptions(options);
		      }
		      // If we haven't been attached, preload and attach
		      else {
		        if (this.tagName == 'IMG')
		          $.Jcrop.Loader(this,function(){
		            $(this).css({display:'block',visibility:'hidden'});
		            api = $.Jcrop(this, options);
		            if ($.isFunction(callback)) callback.call(api);
		          });
		        else {
		          $(this).css({display:'block',visibility:'hidden'});
		          api = $.Jcrop(this, options);
		          if ($.isFunction(callback)) callback.call(api);
		        }
		      }
		    });

		    // Return "this" so the object is chainable (jQuery-style)
		    return this;
		  };
		  //}}}
		  // $.Jcrop.Loader - basic image loader {{{

		  $.Jcrop.Loader = function(imgobj,success,error){
		    var $img = $(imgobj), img = $img[0];

		    function completeCheck(){
		      if (img.complete) {
		        $img.unbind('.jcloader');
		        if ($.isFunction(success)) success.call(img);
		      }
		      else window.setTimeout(completeCheck,50);
		    }

		    $img
		      .bind('load.jcloader',completeCheck)
		      .bind('error.jcloader',function(e){
		        $img.unbind('.jcloader');
		        if ($.isFunction(error)) error.call(img);
		      });

		    if (img.complete && $.isFunction(success)){
		      $img.unbind('.jcloader');
		      success.call(img);
		    }
		  };

		  //}}}
		  // Global Defaults {{{
		  $.Jcrop.defaults = {

		    // Basic Settings
		    allowSelect: true,
		    allowMove: true,
		    allowResize: true,

		    trackDocument: true,

		    // Styling Options
		    baseClass: 'jcrop',
		    addClass: null,
		    bgColor: 'black',
		    bgOpacity: 0.6,
		    bgFade: false,
		    borderOpacity: 0.4,
		    handleOpacity: 0.5,
		    handleSize: null,

		    aspectRatio: 0,
		    keySupport: true,
		    createHandles: ['n','s','e','w','nw','ne','se','sw'],
		    createDragbars: ['n','s','e','w'],
		    createBorders: ['n','s','e','w'],
		    drawBorders: true,
		    dragEdges: true,
		    fixedSupport: true,
		    touchSupport: null,

		    shade: null,

		    boxWidth: 0,
		    boxHeight: 0,
		    boundary: 2,
		    fadeTime: 400,
		    animationDelay: 20,
		    swingSpeed: 3,

		    minSelect: [0, 0],
		    maxSize: [0, 0],
		    minSize: [0, 0],

		    // Callbacks / Event Handlers
		    onChange: function () {},
		    onSelect: function () {},
		    onDblClick: function () {},
		    onRelease: function () {}
		  };
		  
		  return $.Jcrop;
});
},
'cropper/cropper':function(){
/*!
 * Cropper v2.3.4
 * https://github.com/fengyuanchen/cropper
 *
 * Copyright (c) 2014-2016 Fengyuan Chen and contributors
 * Released under the MIT license
 *
 * Date: 2016-09-03T05:50:45.412Z
 */

/*(function (factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as anonymous module.
    define(['jquery'], factory);
  } else if (typeof exports === 'object') {
    // Node / CommonJS
    factory(require('jquery'));
  } else {
    // Browser globals.
    factory(jQuery);
  }
})*/
define(['jquery'], function ($) {

  'use strict';

  // Globals
  var $window = $(window);
  var $document = $(document);
  var location = window.location;
  var navigator = window.navigator;
  var ArrayBuffer = window.ArrayBuffer;
  var Uint8Array = window.Uint8Array;
  var DataView = window.DataView;
  var btoa = window.btoa;

  // Constants
  var NAMESPACE = 'cropper';

  // Classes
  var CLASS_MODAL = 'cropper-modal';
  var CLASS_HIDE = 'cropper-hide';
  var CLASS_HIDDEN = 'cropper-hidden';
  var CLASS_INVISIBLE = 'cropper-invisible';
  var CLASS_MOVE = 'cropper-move';
  var CLASS_CROP = 'cropper-crop';
  var CLASS_DISABLED = 'cropper-disabled';
  var CLASS_BG = 'cropper-bg';

  // Events
  var EVENT_MOUSE_DOWN = 'mousedown touchstart pointerdown MSPointerDown';
  var EVENT_MOUSE_MOVE = 'mousemove touchmove pointermove MSPointerMove';
  var EVENT_MOUSE_UP = 'mouseup touchend touchcancel pointerup pointercancel MSPointerUp MSPointerCancel';
  var EVENT_WHEEL = 'wheel mousewheel DOMMouseScroll';
  var EVENT_DBLCLICK = 'dblclick';
  var EVENT_LOAD = 'load.' + NAMESPACE;
  var EVENT_ERROR = 'error.' + NAMESPACE;
  var EVENT_RESIZE = 'resize.' + NAMESPACE; // Bind to window with namespace
  var EVENT_BUILD = 'build.' + NAMESPACE;
  var EVENT_BUILT = 'built.' + NAMESPACE;
  var EVENT_CROP_START = 'cropstart.' + NAMESPACE;
  var EVENT_CROP_MOVE = 'cropmove.' + NAMESPACE;
  var EVENT_CROP_END = 'cropend.' + NAMESPACE;
  var EVENT_CROP = 'crop.' + NAMESPACE;
  var EVENT_ZOOM = 'zoom.' + NAMESPACE;

  // RegExps
  var REGEXP_ACTIONS = /^(e|w|s|n|se|sw|ne|nw|all|crop|move|zoom)$/;
  var REGEXP_DATA_URL = /^data:/;
  var REGEXP_DATA_URL_HEAD = /^data:([^;]+);base64,/;
  var REGEXP_DATA_URL_JPEG = /^data:image\/jpeg.*;base64,/;

  // Data keys
  var DATA_PREVIEW = 'preview';
  var DATA_ACTION = 'action';

  // Actions
  var ACTION_EAST = 'e';
  var ACTION_WEST = 'w';
  var ACTION_SOUTH = 's';
  var ACTION_NORTH = 'n';
  var ACTION_SOUTH_EAST = 'se';
  var ACTION_SOUTH_WEST = 'sw';
  var ACTION_NORTH_EAST = 'ne';
  var ACTION_NORTH_WEST = 'nw';
  var ACTION_ALL = 'all';
  var ACTION_CROP = 'crop';
  var ACTION_MOVE = 'move';
  var ACTION_ZOOM = 'zoom';
  var ACTION_NONE = 'none';

  // Supports
  var SUPPORT_CANVAS = $.isFunction($('<canvas>')[0].getContext);
  var IS_SAFARI_OR_UIWEBVIEW = navigator && /(Macintosh|iPhone|iPod|iPad).*AppleWebKit/i.test(navigator.userAgent);

  // Maths
  var num = Number;
  var min = Math.min;
  var max = Math.max;
  var abs = Math.abs;
  var sin = Math.sin;
  var cos = Math.cos;
  var sqrt = Math.sqrt;
  var round = Math.round;
  var floor = Math.floor;

  // Utilities
  var fromCharCode = String.fromCharCode;

  function isNumber(n) {
    return typeof n === 'number' && !isNaN(n);
  }

  function isUndefined(n) {
    return typeof n === 'undefined';
  }

  function toArray(obj, offset) {
    var args = [];

    // This is necessary for IE8
    if (isNumber(offset)) {
      args.push(offset);
    }

    return args.slice.apply(obj, args);
  }

  // Custom proxy to avoid jQuery's guid
  function proxy(fn, context) {
    var args = toArray(arguments, 2);

    return function () {
      return fn.apply(context, args.concat(toArray(arguments)));
    };
  }

  function isCrossOriginURL(url) {
    var parts = url.match(/^(https?:)\/\/([^\:\/\?#]+):?(\d*)/i);

    return parts && (
      parts[1] !== location.protocol ||
      parts[2] !== location.hostname ||
      parts[3] !== location.port
    );
  }

  function addTimestamp(url) {
    var timestamp = 'timestamp=' + (new Date()).getTime();

    return (url + (url.indexOf('?') === -1 ? '?' : '&') + timestamp);
  }

  function getCrossOrigin(crossOrigin) {
    return crossOrigin ? ' crossOrigin="' + crossOrigin + '"' : '';
  }

  function getImageSize(image, callback) {
    var newImage;

    // Modern browsers (ignore Safari, #120 & #509)
    if (image.naturalWidth && !IS_SAFARI_OR_UIWEBVIEW) {
      return callback(image.naturalWidth, image.naturalHeight);
    }

    // IE8: Don't use `new Image()` here (#319)
    newImage = document.createElement('img');

    newImage.onload = function () {
      callback(this.width, this.height);
    };

    newImage.src = image.src;
  }

  function getTransform(options) {
    var transforms = [];
    var rotate = options.rotate;
    var scaleX = options.scaleX;
    var scaleY = options.scaleY;

    // Rotate should come first before scale to match orientation transform
    if (isNumber(rotate) && rotate !== 0) {
      transforms.push('rotate(' + rotate + 'deg)');
    }

    if (isNumber(scaleX) && scaleX !== 1) {
      transforms.push('scaleX(' + scaleX + ')');
    }

    if (isNumber(scaleY) && scaleY !== 1) {
      transforms.push('scaleY(' + scaleY + ')');
    }

    return transforms.length ? transforms.join(' ') : 'none';
  }

  function getRotatedSizes(data, isReversed) {
    var deg = abs(data.degree) % 180;
    var arc = (deg > 90 ? (180 - deg) : deg) * Math.PI / 180;
    var sinArc = sin(arc);
    var cosArc = cos(arc);
    var width = data.width;
    var height = data.height;
    var aspectRatio = data.aspectRatio;
    var newWidth;
    var newHeight;

    if (!isReversed) {
      newWidth = width * cosArc + height * sinArc;
      newHeight = width * sinArc + height * cosArc;
    } else {
      newWidth = width / (cosArc + sinArc / aspectRatio);
      newHeight = newWidth / aspectRatio;
    }

    return {
      width: newWidth,
      height: newHeight
    };
  }

  function getSourceCanvas(image, data) {
    var canvas = $('<canvas>')[0];
    var context = canvas.getContext('2d');
    var dstX = 0;
    var dstY = 0;
    var dstWidth = data.naturalWidth;
    var dstHeight = data.naturalHeight;
    var rotate = data.rotate;
    var scaleX = data.scaleX;
    var scaleY = data.scaleY;
    var scalable = isNumber(scaleX) && isNumber(scaleY) && (scaleX !== 1 || scaleY !== 1);
    var rotatable = isNumber(rotate) && rotate !== 0;
    var advanced = rotatable || scalable;
    var canvasWidth = dstWidth * abs(scaleX || 1);
    var canvasHeight = dstHeight * abs(scaleY || 1);
    var translateX;
    var translateY;
    var rotated;

    if (scalable) {
      translateX = canvasWidth / 2;
      translateY = canvasHeight / 2;
    }

    if (rotatable) {
      rotated = getRotatedSizes({
        width: canvasWidth,
        height: canvasHeight,
        degree: rotate
      });

      canvasWidth = rotated.width;
      canvasHeight = rotated.height;
      translateX = canvasWidth / 2;
      translateY = canvasHeight / 2;
    }

    canvas.width = canvasWidth;
    canvas.height = canvasHeight;

    if (advanced) {
      dstX = -dstWidth / 2;
      dstY = -dstHeight / 2;

      context.save();
      context.translate(translateX, translateY);
    }

    // Rotate should come first before scale as in the "getTransform" function
    if (rotatable) {
      context.rotate(rotate * Math.PI / 180);
    }

    if (scalable) {
      context.scale(scaleX, scaleY);
    }

    context.drawImage(image, floor(dstX), floor(dstY), floor(dstWidth), floor(dstHeight));

    if (advanced) {
      context.restore();
    }

    return canvas;
  }

  function getTouchesCenter(touches) {
    var length = touches.length;
    var pageX = 0;
    var pageY = 0;

    if (length) {
      $.each(touches, function (i, touch) {
        pageX += touch.pageX;
        pageY += touch.pageY;
      });

      pageX /= length;
      pageY /= length;
    }

    return {
      pageX: pageX,
      pageY: pageY
    };
  }

  function getStringFromCharCode(dataView, start, length) {
    var str = '';
    var i;

    for (i = start, length += start; i < length; i++) {
      str += fromCharCode(dataView.getUint8(i));
    }

    return str;
  }

  function getOrientation(arrayBuffer) {
    var dataView = new DataView(arrayBuffer);
    var length = dataView.byteLength;
    var orientation;
    var exifIDCode;
    var tiffOffset;
    var firstIFDOffset;
    var littleEndian;
    var endianness;
    var app1Start;
    var ifdStart;
    var offset;
    var i;

    // Only handle JPEG image (start by 0xFFD8)
    if (dataView.getUint8(0) === 0xFF && dataView.getUint8(1) === 0xD8) {
      offset = 2;

      while (offset < length) {
        if (dataView.getUint8(offset) === 0xFF && dataView.getUint8(offset + 1) === 0xE1) {
          app1Start = offset;
          break;
        }

        offset++;
      }
    }

    if (app1Start) {
      exifIDCode = app1Start + 4;
      tiffOffset = app1Start + 10;

      if (getStringFromCharCode(dataView, exifIDCode, 4) === 'Exif') {
        endianness = dataView.getUint16(tiffOffset);
        littleEndian = endianness === 0x4949;

        if (littleEndian || endianness === 0x4D4D /* bigEndian */) {
          if (dataView.getUint16(tiffOffset + 2, littleEndian) === 0x002A) {
            firstIFDOffset = dataView.getUint32(tiffOffset + 4, littleEndian);

            if (firstIFDOffset >= 0x00000008) {
              ifdStart = tiffOffset + firstIFDOffset;
            }
          }
        }
      }
    }

    if (ifdStart) {
      length = dataView.getUint16(ifdStart, littleEndian);

      for (i = 0; i < length; i++) {
        offset = ifdStart + i * 12 + 2;

        if (dataView.getUint16(offset, littleEndian) === 0x0112 /* Orientation */) {

          // 8 is the offset of the current tag's value
          offset += 8;

          // Get the original orientation value
          orientation = dataView.getUint16(offset, littleEndian);

          // Override the orientation with its default value for Safari (#120)
          if (IS_SAFARI_OR_UIWEBVIEW) {
            dataView.setUint16(offset, 1, littleEndian);
          }

          break;
        }
      }
    }

    return orientation;
  }

  function dataURLToArrayBuffer(dataURL) {
    var base64 = dataURL.replace(REGEXP_DATA_URL_HEAD, '');
    var binary = atob(base64);
    var length = binary.length;
    var arrayBuffer = new ArrayBuffer(length);
    var dataView = new Uint8Array(arrayBuffer);
    var i;

    for (i = 0; i < length; i++) {
      dataView[i] = binary.charCodeAt(i);
    }

    return arrayBuffer;
  }

  // Only available for JPEG image
  function arrayBufferToDataURL(arrayBuffer) {
    var dataView = new Uint8Array(arrayBuffer);
    var length = dataView.length;
    var base64 = '';
    var i;

    for (i = 0; i < length; i++) {
      base64 += fromCharCode(dataView[i]);
    }

    return 'data:image/jpeg;base64,' + btoa(base64);
  }

  function Cropper(element, options) {
    this.$element = $(element);
    this.options = $.extend({}, Cropper.DEFAULTS, $.isPlainObject(options) && options);
    this.isLoaded = false;
    this.isBuilt = false;
    this.isCompleted = false;
    this.isRotated = false;
    this.isCropped = false;
    this.isDisabled = false;
    this.isReplaced = false;
    this.isLimited = false;
    this.wheeling = false;
    this.isImg = false;
    this.originalUrl = '';
    this.canvas = null;
    this.cropBox = null;
    this.init();
  }

  Cropper.prototype = {
    constructor: Cropper,

    init: function () {
      var $this = this.$element;
      var url;

      if ($this.is('img')) {
        this.isImg = true;

        // Should use `$.fn.attr` here. e.g.: "img/picture.jpg"
        this.originalUrl = url = $this.attr('src');

        // Stop when it's a blank image
        if (!url) {
          return;
        }

        // Should use `$.fn.prop` here. e.g.: "http://example.com/img/picture.jpg"
        url = $this.prop('src');
      } else if ($this.is('canvas') && SUPPORT_CANVAS) {
        url = $this[0].toDataURL();
      }

      this.load(url);
    },

    // A shortcut for triggering custom events
    trigger: function (type, data) {
      var e = $.Event(type, data);

      this.$element.trigger(e);

      return e;
    },

    load: function (url) {
      var options = this.options;
      var $this = this.$element;
      var read;
      var xhr;

      if (!url) {
        return;
      }

      // Trigger build event first
      $this.one(EVENT_BUILD, options.build);

      if (this.trigger(EVENT_BUILD).isDefaultPrevented()) {
        return;
      }

      this.url = url;
      this.image = {};

      if (!options.checkOrientation || !ArrayBuffer) {
        return this.clone();
      }

      read = $.proxy(this.read, this);

      // XMLHttpRequest disallows to open a Data URL in some browsers like IE11 and Safari
      if (REGEXP_DATA_URL.test(url)) {
        return REGEXP_DATA_URL_JPEG.test(url) ?
          read(dataURLToArrayBuffer(url)) :
          this.clone();
      }

      xhr = new XMLHttpRequest();

      xhr.onerror = xhr.onabort = $.proxy(function () {
        this.clone();
      }, this);

      xhr.onload = function () {
        read(this.response);
      };

      if (options.checkCrossOrigin && isCrossOriginURL(url) && $this.prop('crossOrigin')) {
        url = addTimestamp(url);
      }

      xhr.open('get', url);
      xhr.responseType = 'arraybuffer';
      xhr.send();
    },

    read: function (arrayBuffer) {
      var options = this.options;
      var orientation = getOrientation(arrayBuffer);
      var image = this.image;
      var rotate = 0;
      var scaleX = 1;
      var scaleY = 1;

      if (orientation > 1) {
        this.url = arrayBufferToDataURL(arrayBuffer);

        switch (orientation) {

          // flip horizontal
          case 2:
            scaleX = -1;
            break;

          // rotate left 180°
          case 3:
            rotate = -180;
            break;

          // flip vertical
          case 4:
            scaleY = -1;
            break;

          // flip vertical + rotate right 90°
          case 5:
            rotate = 90;
            scaleY = -1;
            break;

          // rotate right 90°
          case 6:
            rotate = 90;
            break;

          // flip horizontal + rotate right 90°
          case 7:
            rotate = 90;
            scaleX = -1;
            break;

          // rotate left 90°
          case 8:
            rotate = -90;
            break;
        }
      }

      if (options.rotatable) {
        image.rotate = rotate;
      }

      if (options.scalable) {
        image.scaleX = scaleX;
        image.scaleY = scaleY;
      }

      this.clone();
    },

    clone: function () {
      var options = this.options;
      var $this = this.$element;
      var url = this.url;
      var crossOrigin = '';
      var crossOriginUrl;
      var $clone;

      if (options.checkCrossOrigin && isCrossOriginURL(url)) {
        crossOrigin = $this.prop('crossOrigin');

        if (crossOrigin) {
          crossOriginUrl = url;
        } else {
          crossOrigin = 'anonymous';

          // Bust cache (#148) when there is not a "crossOrigin" property
          crossOriginUrl = addTimestamp(url);
        }
      }

      this.crossOrigin = crossOrigin;
      this.crossOriginUrl = crossOriginUrl;
      this.$clone = $clone = $('<img' + getCrossOrigin(crossOrigin) + ' src="' + (crossOriginUrl || url) + '">');

      if (this.isImg) {
        if ($this[0].complete) {
          this.start();
        } else {
          $this.one(EVENT_LOAD, $.proxy(this.start, this));
        }
      } else {
        $clone.
          one(EVENT_LOAD, $.proxy(this.start, this)).
          one(EVENT_ERROR, $.proxy(this.stop, this)).
          addClass(CLASS_HIDE).
          insertAfter($this);
      }
    },

    start: function () {
      var $image = this.$element;
      var $clone = this.$clone;

      if (!this.isImg) {
        $clone.off(EVENT_ERROR, this.stop);
        $image = $clone;
      }

      getImageSize($image[0], $.proxy(function (naturalWidth, naturalHeight) {
        $.extend(this.image, {
          naturalWidth: naturalWidth,
          naturalHeight: naturalHeight,
          aspectRatio: naturalWidth / naturalHeight
        });

        this.isLoaded = true;
        this.build();
      }, this));
    },

    stop: function () {
      this.$clone.remove();
      this.$clone = null;
    },

    build: function () {
      var options = this.options;
      var $this = this.$element;
      var $clone = this.$clone;
      var $cropper;
      var $cropBox;
      var $face;

      if (!this.isLoaded) {
        return;
      }

      // Unbuild first when replace
      if (this.isBuilt) {
        this.unbuild();
      }

      // Create cropper elements
      this.$container = $this.parent();
      this.$cropper = $cropper = $(Cropper.TEMPLATE);
      this.$canvas = $cropper.find('.cropper-canvas').append($clone);
      this.$dragBox = $cropper.find('.cropper-drag-box');
      this.$cropBox = $cropBox = $cropper.find('.cropper-crop-box');
      this.$viewBox = $cropper.find('.cropper-view-box');
      this.$face = $face = $cropBox.find('.cropper-face');

      // Hide the original image
      $this.addClass(CLASS_HIDDEN).after($cropper);

      // Show the clone image if is hidden
      if (!this.isImg) {
        $clone.removeClass(CLASS_HIDE);
      }

      this.initPreview();
      this.bind();

      options.aspectRatio = max(0, options.aspectRatio) || NaN;
      options.viewMode = max(0, min(3, round(options.viewMode))) || 0;

      if (options.autoCrop) {
        this.isCropped = true;

        if (options.modal) {
          this.$dragBox.addClass(CLASS_MODAL);
        }
      } else {
        $cropBox.addClass(CLASS_HIDDEN);
      }

      if (!options.guides) {
        $cropBox.find('.cropper-dashed').addClass(CLASS_HIDDEN);
      }

      if (!options.center) {
        $cropBox.find('.cropper-center').addClass(CLASS_HIDDEN);
      }

      if (options.cropBoxMovable) {
        $face.addClass(CLASS_MOVE).data(DATA_ACTION, ACTION_ALL);
      }

      if (!options.highlight) {
        $face.addClass(CLASS_INVISIBLE);
      }

      if (options.background) {
        $cropper.addClass(CLASS_BG);
      }

      if (!options.cropBoxResizable) {
        $cropBox.find('.cropper-line, .cropper-point').addClass(CLASS_HIDDEN);
      }

      this.setDragMode(options.dragMode);
      this.render();
      this.isBuilt = true;
      this.setData(options.data);
      $this.one(EVENT_BUILT, options.built);

      // Trigger the built event asynchronously to keep `data('cropper')` is defined
      this.completing = setTimeout($.proxy(function () {
        this.trigger(EVENT_BUILT);
        this.trigger(EVENT_CROP, this.getData());
        this.isCompleted = true;
      }, this), 0);
    },

    unbuild: function () {
      if (!this.isBuilt) {
        return;
      }

      if (!this.isCompleted) {
        clearTimeout(this.completing);
      }

      this.isBuilt = false;
      this.isCompleted = false;
      this.initialImage = null;

      // Clear `initialCanvas` is necessary when replace
      this.initialCanvas = null;
      this.initialCropBox = null;
      this.container = null;
      this.canvas = null;

      // Clear `cropBox` is necessary when replace
      this.cropBox = null;
      this.unbind();

      this.resetPreview();
      this.$preview = null;

      this.$viewBox = null;
      this.$cropBox = null;
      this.$dragBox = null;
      this.$canvas = null;
      this.$container = null;

      this.$cropper.remove();
      this.$cropper = null;
    },

    render: function () {
      this.initContainer();
      this.initCanvas();
      this.initCropBox();

      this.renderCanvas();

      if (this.isCropped) {
        this.renderCropBox();
      }
    },

    initContainer: function () {
      var options = this.options;
      var $this = this.$element;
      var $container = this.$container;
      var $cropper = this.$cropper;

      $cropper.addClass(CLASS_HIDDEN);
      $this.removeClass(CLASS_HIDDEN);

      $cropper.css((this.container = {
        width: max($container.width(), num(options.minContainerWidth) || 200),
        height: max($container.height(), num(options.minContainerHeight) || 100)
      }));

      $this.addClass(CLASS_HIDDEN);
      $cropper.removeClass(CLASS_HIDDEN);
    },

    // Canvas (image wrapper)
    initCanvas: function () {
      var viewMode = this.options.viewMode;
      var container = this.container;
      var containerWidth = container.width;
      var containerHeight = container.height;
      var image = this.image;
      var imageNaturalWidth = image.naturalWidth;
      var imageNaturalHeight = image.naturalHeight;
      var is90Degree = abs(image.rotate) === 90;
      var naturalWidth = is90Degree ? imageNaturalHeight : imageNaturalWidth;
      var naturalHeight = is90Degree ? imageNaturalWidth : imageNaturalHeight;
      var aspectRatio = naturalWidth / naturalHeight;
      var canvasWidth = containerWidth;
      var canvasHeight = containerHeight;
      var canvas;

      if (containerHeight * aspectRatio > containerWidth) {
        if (viewMode === 3) {
          canvasWidth = containerHeight * aspectRatio;
        } else {
          canvasHeight = containerWidth / aspectRatio;
        }
      } else {
        if (viewMode === 3) {
          canvasHeight = containerWidth / aspectRatio;
        } else {
          canvasWidth = containerHeight * aspectRatio;
        }
      }

      canvas = {
        naturalWidth: naturalWidth,
        naturalHeight: naturalHeight,
        aspectRatio: aspectRatio,
        width: canvasWidth,
        height: canvasHeight
      };

      canvas.oldLeft = canvas.left = (containerWidth - canvasWidth) / 2;
      canvas.oldTop = canvas.top = (containerHeight - canvasHeight) / 2;

      this.canvas = canvas;
      this.isLimited = (viewMode === 1 || viewMode === 2);
      this.limitCanvas(true, true);
      this.initialImage = $.extend({}, image);
      this.initialCanvas = $.extend({}, canvas);
    },

    limitCanvas: function (isSizeLimited, isPositionLimited) {
      var options = this.options;
      var viewMode = options.viewMode;
      var container = this.container;
      var containerWidth = container.width;
      var containerHeight = container.height;
      var canvas = this.canvas;
      var aspectRatio = canvas.aspectRatio;
      var cropBox = this.cropBox;
      var isCropped = this.isCropped && cropBox;
      var minCanvasWidth;
      var minCanvasHeight;
      var newCanvasLeft;
      var newCanvasTop;

      if (isSizeLimited) {
        minCanvasWidth = num(options.minCanvasWidth) || 0;
        minCanvasHeight = num(options.minCanvasHeight) || 0;

        if (viewMode) {
          if (viewMode > 1) {
            minCanvasWidth = max(minCanvasWidth, containerWidth);
            minCanvasHeight = max(minCanvasHeight, containerHeight);

            if (viewMode === 3) {
              if (minCanvasHeight * aspectRatio > minCanvasWidth) {
                minCanvasWidth = minCanvasHeight * aspectRatio;
              } else {
                minCanvasHeight = minCanvasWidth / aspectRatio;
              }
            }
          } else {
            if (minCanvasWidth) {
              minCanvasWidth = max(minCanvasWidth, isCropped ? cropBox.width : 0);
            } else if (minCanvasHeight) {
              minCanvasHeight = max(minCanvasHeight, isCropped ? cropBox.height : 0);
            } else if (isCropped) {
              minCanvasWidth = cropBox.width;
              minCanvasHeight = cropBox.height;

              if (minCanvasHeight * aspectRatio > minCanvasWidth) {
                minCanvasWidth = minCanvasHeight * aspectRatio;
              } else {
                minCanvasHeight = minCanvasWidth / aspectRatio;
              }
            }
          }
        }

        if (minCanvasWidth && minCanvasHeight) {
          if (minCanvasHeight * aspectRatio > minCanvasWidth) {
            minCanvasHeight = minCanvasWidth / aspectRatio;
          } else {
            minCanvasWidth = minCanvasHeight * aspectRatio;
          }
        } else if (minCanvasWidth) {
          minCanvasHeight = minCanvasWidth / aspectRatio;
        } else if (minCanvasHeight) {
          minCanvasWidth = minCanvasHeight * aspectRatio;
        }

        canvas.minWidth = minCanvasWidth;
        canvas.minHeight = minCanvasHeight;
        canvas.maxWidth = Infinity;
        canvas.maxHeight = Infinity;
      }

      if (isPositionLimited) {
        if (viewMode) {
          newCanvasLeft = containerWidth - canvas.width;
          newCanvasTop = containerHeight - canvas.height;

          canvas.minLeft = min(0, newCanvasLeft);
          canvas.minTop = min(0, newCanvasTop);
          canvas.maxLeft = max(0, newCanvasLeft);
          canvas.maxTop = max(0, newCanvasTop);

          if (isCropped && this.isLimited) {
            canvas.minLeft = min(
              cropBox.left,
              cropBox.left + cropBox.width - canvas.width
            );
            canvas.minTop = min(
              cropBox.top,
              cropBox.top + cropBox.height - canvas.height
            );
            canvas.maxLeft = cropBox.left;
            canvas.maxTop = cropBox.top;

            if (viewMode === 2) {
              if (canvas.width >= containerWidth) {
                canvas.minLeft = min(0, newCanvasLeft);
                canvas.maxLeft = max(0, newCanvasLeft);
              }

              if (canvas.height >= containerHeight) {
                canvas.minTop = min(0, newCanvasTop);
                canvas.maxTop = max(0, newCanvasTop);
              }
            }
          }
        } else {
          canvas.minLeft = -canvas.width;
          canvas.minTop = -canvas.height;
          canvas.maxLeft = containerWidth;
          canvas.maxTop = containerHeight;
        }
      }
    },

    renderCanvas: function (isChanged) {
      var canvas = this.canvas;
      var image = this.image;
      var rotate = image.rotate;
      var naturalWidth = image.naturalWidth;
      var naturalHeight = image.naturalHeight;
      var aspectRatio;
      var rotated;

      if (this.isRotated) {
        this.isRotated = false;

        // Computes rotated sizes with image sizes
        rotated = getRotatedSizes({
          width: image.width,
          height: image.height,
          degree: rotate
        });

        aspectRatio = rotated.width / rotated.height;

        if (aspectRatio !== canvas.aspectRatio) {
          canvas.left -= (rotated.width - canvas.width) / 2;
          canvas.top -= (rotated.height - canvas.height) / 2;
          canvas.width = rotated.width;
          canvas.height = rotated.height;
          canvas.aspectRatio = aspectRatio;
          canvas.naturalWidth = naturalWidth;
          canvas.naturalHeight = naturalHeight;

          // Computes rotated sizes with natural image sizes
          if (rotate % 180) {
            rotated = getRotatedSizes({
              width: naturalWidth,
              height: naturalHeight,
              degree: rotate
            });

            canvas.naturalWidth = rotated.width;
            canvas.naturalHeight = rotated.height;
          }

          this.limitCanvas(true, false);
        }
      }

      if (canvas.width > canvas.maxWidth || canvas.width < canvas.minWidth) {
        canvas.left = canvas.oldLeft;
      }

      if (canvas.height > canvas.maxHeight || canvas.height < canvas.minHeight) {
        canvas.top = canvas.oldTop;
      }

      canvas.width = min(max(canvas.width, canvas.minWidth), canvas.maxWidth);
      canvas.height = min(max(canvas.height, canvas.minHeight), canvas.maxHeight);

      this.limitCanvas(false, true);

      canvas.oldLeft = canvas.left = min(max(canvas.left, canvas.minLeft), canvas.maxLeft);
      canvas.oldTop = canvas.top = min(max(canvas.top, canvas.minTop), canvas.maxTop);

      this.$canvas.css({
        width: canvas.width,
        height: canvas.height,
        left: canvas.left,
        top: canvas.top
      });

      this.renderImage();

      if (this.isCropped && this.isLimited) {
        this.limitCropBox(true, true);
      }

      if (isChanged) {
        this.output();
      }
    },

    renderImage: function (isChanged) {
      var canvas = this.canvas;
      var image = this.image;
      var reversed;

      if (image.rotate) {
        reversed = getRotatedSizes({
          width: canvas.width,
          height: canvas.height,
          degree: image.rotate,
          aspectRatio: image.aspectRatio
        }, true);
      }

      $.extend(image, reversed ? {
        width: reversed.width,
        height: reversed.height,
        left: (canvas.width - reversed.width) / 2,
        top: (canvas.height - reversed.height) / 2
      } : {
        width: canvas.width,
        height: canvas.height,
        left: 0,
        top: 0
      });

      this.$clone.css({
        width: image.width,
        height: image.height,
        marginLeft: image.left,
        marginTop: image.top,
        transform: getTransform(image)
      });

      if (isChanged) {
        this.output();
      }
    },

    initCropBox: function () {
      var options = this.options;
      var canvas = this.canvas;
      var aspectRatio = options.aspectRatio;
      var autoCropArea = num(options.autoCropArea) || 0.8;
      var cropBox = {
            width: canvas.width,
            height: canvas.height
          };

      if (aspectRatio) {
        if (canvas.height * aspectRatio > canvas.width) {
          cropBox.height = cropBox.width / aspectRatio;
        } else {
          cropBox.width = cropBox.height * aspectRatio;
        }
      }

      this.cropBox = cropBox;
      this.limitCropBox(true, true);

      // Initialize auto crop area
      cropBox.width = min(max(cropBox.width, cropBox.minWidth), cropBox.maxWidth);
      cropBox.height = min(max(cropBox.height, cropBox.minHeight), cropBox.maxHeight);

      // The width of auto crop area must large than "minWidth", and the height too. (#164)
      cropBox.width = max(cropBox.minWidth, cropBox.width * autoCropArea);
      cropBox.height = max(cropBox.minHeight, cropBox.height * autoCropArea);
      cropBox.oldLeft = cropBox.left = canvas.left + (canvas.width - cropBox.width) / 2;
      cropBox.oldTop = cropBox.top = canvas.top + (canvas.height - cropBox.height) / 2;

      this.initialCropBox = $.extend({}, cropBox);
    },

    limitCropBox: function (isSizeLimited, isPositionLimited) {
      var options = this.options;
      var aspectRatio = options.aspectRatio;
      var container = this.container;
      var containerWidth = container.width;
      var containerHeight = container.height;
      var canvas = this.canvas;
      var cropBox = this.cropBox;
      var isLimited = this.isLimited;
      var minCropBoxWidth;
      var minCropBoxHeight;
      var maxCropBoxWidth;
      var maxCropBoxHeight;

      if (isSizeLimited) {
        minCropBoxWidth = num(options.minCropBoxWidth) || 0;
        minCropBoxHeight = num(options.minCropBoxHeight) || 0;

        // The min/maxCropBoxWidth/Height must be less than containerWidth/Height
        minCropBoxWidth = min(minCropBoxWidth, containerWidth);
        minCropBoxHeight = min(minCropBoxHeight, containerHeight);
        maxCropBoxWidth = min(containerWidth, isLimited ? canvas.width : containerWidth);
        maxCropBoxHeight = min(containerHeight, isLimited ? canvas.height : containerHeight);

        if (aspectRatio) {
          if (minCropBoxWidth && minCropBoxHeight) {
            if (minCropBoxHeight * aspectRatio > minCropBoxWidth) {
              minCropBoxHeight = minCropBoxWidth / aspectRatio;
            } else {
              minCropBoxWidth = minCropBoxHeight * aspectRatio;
            }
          } else if (minCropBoxWidth) {
            minCropBoxHeight = minCropBoxWidth / aspectRatio;
          } else if (minCropBoxHeight) {
            minCropBoxWidth = minCropBoxHeight * aspectRatio;
          }

          if (maxCropBoxHeight * aspectRatio > maxCropBoxWidth) {
            maxCropBoxHeight = maxCropBoxWidth / aspectRatio;
          } else {
            maxCropBoxWidth = maxCropBoxHeight * aspectRatio;
          }
        }

        // The minWidth/Height must be less than maxWidth/Height
        cropBox.minWidth = min(minCropBoxWidth, maxCropBoxWidth);
        cropBox.minHeight = min(minCropBoxHeight, maxCropBoxHeight);
        cropBox.maxWidth = maxCropBoxWidth;
        cropBox.maxHeight = maxCropBoxHeight;
      }

      if (isPositionLimited) {
        if (isLimited) {
          cropBox.minLeft = max(0, canvas.left);
          cropBox.minTop = max(0, canvas.top);
          cropBox.maxLeft = min(containerWidth, canvas.left + canvas.width) - cropBox.width;
          cropBox.maxTop = min(containerHeight, canvas.top + canvas.height) - cropBox.height;
        } else {
          cropBox.minLeft = 0;
          cropBox.minTop = 0;
          cropBox.maxLeft = containerWidth - cropBox.width;
          cropBox.maxTop = containerHeight - cropBox.height;
        }
      }
    },

    renderCropBox: function () {
      var options = this.options;
      var container = this.container;
      var containerWidth = container.width;
      var containerHeight = container.height;
      var cropBox = this.cropBox;

      if (cropBox.width > cropBox.maxWidth || cropBox.width < cropBox.minWidth) {
        cropBox.left = cropBox.oldLeft;
      }

      if (cropBox.height > cropBox.maxHeight || cropBox.height < cropBox.minHeight) {
        cropBox.top = cropBox.oldTop;
      }

      cropBox.width = min(max(cropBox.width, cropBox.minWidth), cropBox.maxWidth);
      cropBox.height = min(max(cropBox.height, cropBox.minHeight), cropBox.maxHeight);

      this.limitCropBox(false, true);

      cropBox.oldLeft = cropBox.left = min(max(cropBox.left, cropBox.minLeft), cropBox.maxLeft);
      cropBox.oldTop = cropBox.top = min(max(cropBox.top, cropBox.minTop), cropBox.maxTop);

      if (options.movable && options.cropBoxMovable) {

        // Turn to move the canvas when the crop box is equal to the container
        this.$face.data(DATA_ACTION, (cropBox.width === containerWidth && cropBox.height === containerHeight) ? ACTION_MOVE : ACTION_ALL);
      }

      this.$cropBox.css({
        width: cropBox.width,
        height: cropBox.height,
        left: cropBox.left,
        top: cropBox.top
      });

      if (this.isCropped && this.isLimited) {
        this.limitCanvas(true, true);
      }

      if (!this.isDisabled) {
        this.output();
      }
    },

    output: function () {
      this.preview();

      if (this.isCompleted) {
        this.trigger(EVENT_CROP, this.getData());
      }
    },

    initPreview: function () {
      var crossOrigin = getCrossOrigin(this.crossOrigin);
      var url = crossOrigin ? this.crossOriginUrl : this.url;
      var $clone2;

      this.$preview = $(this.options.preview);
      this.$clone2 = $clone2 = $('<img' + crossOrigin + ' src="' + url + '">');
      this.$viewBox.html($clone2);
      this.$preview.each(function () {
        var $this = $(this);

        // Save the original size for recover
        $this.data(DATA_PREVIEW, {
          width: $this.width(),
          height: $this.height(),
          html: $this.html()
        });

        /**
         * Override img element styles
         * Add `display:block` to avoid margin top issue
         * (Occur only when margin-top <= -height)
         */
        $this.html(
          '<img' + crossOrigin + ' src="' + url + '" style="' +
          'display:block;width:100%;height:auto;' +
          'min-width:0!important;min-height:0!important;' +
          'max-width:none!important;max-height:none!important;' +
          'image-orientation:0deg!important;">'
        );
      });
    },

    resetPreview: function () {
      this.$preview.each(function () {
        var $this = $(this);
        var data = $this.data(DATA_PREVIEW);

        $this.css({
          width: data.width,
          height: data.height
        }).html(data.html).removeData(DATA_PREVIEW);
      });
    },

    preview: function () {
      var image = this.image;
      var canvas = this.canvas;
      var cropBox = this.cropBox;
      var cropBoxWidth = cropBox.width;
      var cropBoxHeight = cropBox.height;
      var width = image.width;
      var height = image.height;
      var left = cropBox.left - canvas.left - image.left;
      var top = cropBox.top - canvas.top - image.top;

      if (!this.isCropped || this.isDisabled) {
        return;
      }

      this.$clone2.css({
        width: width,
        height: height,
        marginLeft: -left,
        marginTop: -top,
        transform: getTransform(image)
      });

      this.$preview.each(function () {
        var $this = $(this);
        var data = $this.data(DATA_PREVIEW);
        var originalWidth = data.width;
        var originalHeight = data.height;
        var newWidth = originalWidth;
        var newHeight = originalHeight;
        var ratio = 1;

        if (cropBoxWidth) {
          ratio = originalWidth / cropBoxWidth;
          newHeight = cropBoxHeight * ratio;
        }

        if (cropBoxHeight && newHeight > originalHeight) {
          ratio = originalHeight / cropBoxHeight;
          newWidth = cropBoxWidth * ratio;
          newHeight = originalHeight;
        }

        $this.css({
          width: newWidth,
          height: newHeight
        }).find('img').css({
          width: width * ratio,
          height: height * ratio,
          marginLeft: -left * ratio,
          marginTop: -top * ratio,
          transform: getTransform(image)
        });
      });
    },

    bind: function () {
      var options = this.options;
      var $this = this.$element;
      var $cropper = this.$cropper;

      if ($.isFunction(options.cropstart)) {
        $this.on(EVENT_CROP_START, options.cropstart);
      }

      if ($.isFunction(options.cropmove)) {
        $this.on(EVENT_CROP_MOVE, options.cropmove);
      }

      if ($.isFunction(options.cropend)) {
        $this.on(EVENT_CROP_END, options.cropend);
      }

      if ($.isFunction(options.crop)) {
        $this.on(EVENT_CROP, options.crop);
      }

      if ($.isFunction(options.zoom)) {
        $this.on(EVENT_ZOOM, options.zoom);
      }

      $cropper.on(EVENT_MOUSE_DOWN, $.proxy(this.cropStart, this));

      if (options.zoomable && options.zoomOnWheel) {
        $cropper.on(EVENT_WHEEL, $.proxy(this.wheel, this));
      }

      if (options.toggleDragModeOnDblclick) {
        $cropper.on(EVENT_DBLCLICK, $.proxy(this.dblclick, this));
      }

      $document.
        on(EVENT_MOUSE_MOVE, (this._cropMove = proxy(this.cropMove, this))).
        on(EVENT_MOUSE_UP, (this._cropEnd = proxy(this.cropEnd, this)));

      if (options.responsive) {
        $window.on(EVENT_RESIZE, (this._resize = proxy(this.resize, this)));
      }
    },

    unbind: function () {
      var options = this.options;
      var $this = this.$element;
      var $cropper = this.$cropper;

      if ($.isFunction(options.cropstart)) {
        $this.off(EVENT_CROP_START, options.cropstart);
      }

      if ($.isFunction(options.cropmove)) {
        $this.off(EVENT_CROP_MOVE, options.cropmove);
      }

      if ($.isFunction(options.cropend)) {
        $this.off(EVENT_CROP_END, options.cropend);
      }

      if ($.isFunction(options.crop)) {
        $this.off(EVENT_CROP, options.crop);
      }

      if ($.isFunction(options.zoom)) {
        $this.off(EVENT_ZOOM, options.zoom);
      }

      $cropper.off(EVENT_MOUSE_DOWN, this.cropStart);

      if (options.zoomable && options.zoomOnWheel) {
        $cropper.off(EVENT_WHEEL, this.wheel);
      }

      if (options.toggleDragModeOnDblclick) {
        $cropper.off(EVENT_DBLCLICK, this.dblclick);
      }

      $document.
        off(EVENT_MOUSE_MOVE, this._cropMove).
        off(EVENT_MOUSE_UP, this._cropEnd);

      if (options.responsive) {
        $window.off(EVENT_RESIZE, this._resize);
      }
    },

    resize: function () {
      var restore = this.options.restore;
      var $container = this.$container;
      var container = this.container;
      var canvasData;
      var cropBoxData;
      var ratio;

      // Check `container` is necessary for IE8
      if (this.isDisabled || !container) {
        return;
      }

      ratio = $container.width() / container.width;

      // Resize when width changed or height changed
      if (ratio !== 1 || $container.height() !== container.height) {
        if (restore) {
          canvasData = this.getCanvasData();
          cropBoxData = this.getCropBoxData();
        }

        this.render();

        if (restore) {
          this.setCanvasData($.each(canvasData, function (i, n) {
            canvasData[i] = n * ratio;
          }));
          this.setCropBoxData($.each(cropBoxData, function (i, n) {
            cropBoxData[i] = n * ratio;
          }));
        }
      }
    },

    dblclick: function () {
      if (this.isDisabled) {
        return;
      }

      if (this.$dragBox.hasClass(CLASS_CROP)) {
        this.setDragMode(ACTION_MOVE);
      } else {
        this.setDragMode(ACTION_CROP);
      }
    },

    wheel: function (event) {
      var e = event.originalEvent || event;
      var ratio = num(this.options.wheelZoomRatio) || 0.1;
      var delta = 1;

      if (this.isDisabled) {
        return;
      }

      event.preventDefault();

      // Limit wheel speed to prevent zoom too fast
      if (this.wheeling) {
        return;
      }

      this.wheeling = true;

      setTimeout($.proxy(function () {
        this.wheeling = false;
      }, this), 50);

      if (e.deltaY) {
        delta = e.deltaY > 0 ? 1 : -1;
      } else if (e.wheelDelta) {
        delta = -e.wheelDelta / 120;
      } else if (e.detail) {
        delta = e.detail > 0 ? 1 : -1;
      }

      this.zoom(-delta * ratio, event);
    },

    cropStart: function (event) {
      var options = this.options;
      var originalEvent = event.originalEvent;
      var touches = originalEvent && originalEvent.touches;
      var e = event;
      var touchesLength;
      var action;

      if (this.isDisabled) {
        return;
      }

      if (touches) {
        touchesLength = touches.length;

        if (touchesLength > 1) {
          if (options.zoomable && options.zoomOnTouch && touchesLength === 2) {
            e = touches[1];
            this.startX2 = e.pageX;
            this.startY2 = e.pageY;
            action = ACTION_ZOOM;
          } else {
            return;
          }
        }

        e = touches[0];
      }

      action = action || $(e.target).data(DATA_ACTION);

      if (REGEXP_ACTIONS.test(action)) {
        if (this.trigger(EVENT_CROP_START, {
          originalEvent: originalEvent,
          action: action
        }).isDefaultPrevented()) {
          return;
        }

        event.preventDefault();

        this.action = action;
        this.cropping = false;

        // IE8  has `event.pageX/Y`, but not `event.originalEvent.pageX/Y`
        // IE10 has `event.originalEvent.pageX/Y`, but not `event.pageX/Y`
        this.startX = e.pageX || originalEvent && originalEvent.pageX;
        this.startY = e.pageY || originalEvent && originalEvent.pageY;

        if (action === ACTION_CROP) {
          this.cropping = true;
          this.$dragBox.addClass(CLASS_MODAL);
        }
      }
    },

    cropMove: function (event) {
      var options = this.options;
      var originalEvent = event.originalEvent;
      var touches = originalEvent && originalEvent.touches;
      var e = event;
      var action = this.action;
      var touchesLength;

      if (this.isDisabled) {
        return;
      }

      if (touches) {
        touchesLength = touches.length;

        if (touchesLength > 1) {
          if (options.zoomable && options.zoomOnTouch && touchesLength === 2) {
            e = touches[1];
            this.endX2 = e.pageX;
            this.endY2 = e.pageY;
          } else {
            return;
          }
        }

        e = touches[0];
      }

      if (action) {
        if (this.trigger(EVENT_CROP_MOVE, {
          originalEvent: originalEvent,
          action: action
        }).isDefaultPrevented()) {
          return;
        }

        event.preventDefault();

        this.endX = e.pageX || originalEvent && originalEvent.pageX;
        this.endY = e.pageY || originalEvent && originalEvent.pageY;

        this.change(e.shiftKey, action === ACTION_ZOOM ? event : null);
      }
    },

    cropEnd: function (event) {
      var originalEvent = event.originalEvent;
      var action = this.action;

      if (this.isDisabled) {
        return;
      }

      if (action) {
        event.preventDefault();

        if (this.cropping) {
          this.cropping = false;
          this.$dragBox.toggleClass(CLASS_MODAL, this.isCropped && this.options.modal);
        }

        this.action = '';

        this.trigger(EVENT_CROP_END, {
          originalEvent: originalEvent,
          action: action
        });
      }
    },

    change: function (shiftKey, event) {
      var options = this.options;
      var aspectRatio = options.aspectRatio;
      var action = this.action;
      var container = this.container;
      var canvas = this.canvas;
      var cropBox = this.cropBox;
      var width = cropBox.width;
      var height = cropBox.height;
      var left = cropBox.left;
      var top = cropBox.top;
      var right = left + width;
      var bottom = top + height;
      var minLeft = 0;
      var minTop = 0;
      var maxWidth = container.width;
      var maxHeight = container.height;
      var renderable = true;
      var offset;
      var range;

      // Locking aspect ratio in "free mode" by holding shift key (#259)
      if (!aspectRatio && shiftKey) {
        aspectRatio = width && height ? width / height : 1;
      }

      if (this.isLimited) {
        minLeft = cropBox.minLeft;
        minTop = cropBox.minTop;
        maxWidth = minLeft + min(container.width, canvas.width, canvas.left + canvas.width);
        maxHeight = minTop + min(container.height, canvas.height, canvas.top + canvas.height);
      }

      range = {
        x: this.endX - this.startX,
        y: this.endY - this.startY
      };

      if (aspectRatio) {
        range.X = range.y * aspectRatio;
        range.Y = range.x / aspectRatio;
      }

      switch (action) {
        // Move crop box
        case ACTION_ALL:
          left += range.x;
          top += range.y;
          break;

        // Resize crop box
        case ACTION_EAST:
          if (range.x >= 0 && (right >= maxWidth || aspectRatio &&
            (top <= minTop || bottom >= maxHeight))) {

            renderable = false;
            break;
          }

          width += range.x;

          if (aspectRatio) {
            height = width / aspectRatio;
            top -= range.Y / 2;
          }

          if (width < 0) {
            action = ACTION_WEST;
            width = 0;
          }

          break;

        case ACTION_NORTH:
          if (range.y <= 0 && (top <= minTop || aspectRatio &&
            (left <= minLeft || right >= maxWidth))) {

            renderable = false;
            break;
          }

          height -= range.y;
          top += range.y;

          if (aspectRatio) {
            width = height * aspectRatio;
            left += range.X / 2;
          }

          if (height < 0) {
            action = ACTION_SOUTH;
            height = 0;
          }

          break;

        case ACTION_WEST:
          if (range.x <= 0 && (left <= minLeft || aspectRatio &&
            (top <= minTop || bottom >= maxHeight))) {

            renderable = false;
            break;
          }

          width -= range.x;
          left += range.x;

          if (aspectRatio) {
            height = width / aspectRatio;
            top += range.Y / 2;
          }

          if (width < 0) {
            action = ACTION_EAST;
            width = 0;
          }

          break;

        case ACTION_SOUTH:
          if (range.y >= 0 && (bottom >= maxHeight || aspectRatio &&
            (left <= minLeft || right >= maxWidth))) {

            renderable = false;
            break;
          }

          height += range.y;

          if (aspectRatio) {
            width = height * aspectRatio;
            left -= range.X / 2;
          }

          if (height < 0) {
            action = ACTION_NORTH;
            height = 0;
          }

          break;

        case ACTION_NORTH_EAST:
          if (aspectRatio) {
            if (range.y <= 0 && (top <= minTop || right >= maxWidth)) {
              renderable = false;
              break;
            }

            height -= range.y;
            top += range.y;
            width = height * aspectRatio;
          } else {
            if (range.x >= 0) {
              if (right < maxWidth) {
                width += range.x;
              } else if (range.y <= 0 && top <= minTop) {
                renderable = false;
              }
            } else {
              width += range.x;
            }

            if (range.y <= 0) {
              if (top > minTop) {
                height -= range.y;
                top += range.y;
              }
            } else {
              height -= range.y;
              top += range.y;
            }
          }

          if (width < 0 && height < 0) {
            action = ACTION_SOUTH_WEST;
            height = 0;
            width = 0;
          } else if (width < 0) {
            action = ACTION_NORTH_WEST;
            width = 0;
          } else if (height < 0) {
            action = ACTION_SOUTH_EAST;
            height = 0;
          }

          break;

        case ACTION_NORTH_WEST:
          if (aspectRatio) {
            if (range.y <= 0 && (top <= minTop || left <= minLeft)) {
              renderable = false;
              break;
            }

            height -= range.y;
            top += range.y;
            width = height * aspectRatio;
            left += range.X;
          } else {
            if (range.x <= 0) {
              if (left > minLeft) {
                width -= range.x;
                left += range.x;
              } else if (range.y <= 0 && top <= minTop) {
                renderable = false;
              }
            } else {
              width -= range.x;
              left += range.x;
            }

            if (range.y <= 0) {
              if (top > minTop) {
                height -= range.y;
                top += range.y;
              }
            } else {
              height -= range.y;
              top += range.y;
            }
          }

          if (width < 0 && height < 0) {
            action = ACTION_SOUTH_EAST;
            height = 0;
            width = 0;
          } else if (width < 0) {
            action = ACTION_NORTH_EAST;
            width = 0;
          } else if (height < 0) {
            action = ACTION_SOUTH_WEST;
            height = 0;
          }

          break;

        case ACTION_SOUTH_WEST:
          if (aspectRatio) {
            if (range.x <= 0 && (left <= minLeft || bottom >= maxHeight)) {
              renderable = false;
              break;
            }

            width -= range.x;
            left += range.x;
            height = width / aspectRatio;
          } else {
            if (range.x <= 0) {
              if (left > minLeft) {
                width -= range.x;
                left += range.x;
              } else if (range.y >= 0 && bottom >= maxHeight) {
                renderable = false;
              }
            } else {
              width -= range.x;
              left += range.x;
            }

            if (range.y >= 0) {
              if (bottom < maxHeight) {
                height += range.y;
              }
            } else {
              height += range.y;
            }
          }

          if (width < 0 && height < 0) {
            action = ACTION_NORTH_EAST;
            height = 0;
            width = 0;
          } else if (width < 0) {
            action = ACTION_SOUTH_EAST;
            width = 0;
          } else if (height < 0) {
            action = ACTION_NORTH_WEST;
            height = 0;
          }

          break;

        case ACTION_SOUTH_EAST:
          if (aspectRatio) {
            if (range.x >= 0 && (right >= maxWidth || bottom >= maxHeight)) {
              renderable = false;
              break;
            }

            width += range.x;
            height = width / aspectRatio;
          } else {
            if (range.x >= 0) {
              if (right < maxWidth) {
                width += range.x;
              } else if (range.y >= 0 && bottom >= maxHeight) {
                renderable = false;
              }
            } else {
              width += range.x;
            }

            if (range.y >= 0) {
              if (bottom < maxHeight) {
                height += range.y;
              }
            } else {
              height += range.y;
            }
          }

          if (width < 0 && height < 0) {
            action = ACTION_NORTH_WEST;
            height = 0;
            width = 0;
          } else if (width < 0) {
            action = ACTION_SOUTH_WEST;
            width = 0;
          } else if (height < 0) {
            action = ACTION_NORTH_EAST;
            height = 0;
          }

          break;

        // Move canvas
        case ACTION_MOVE:
          this.move(range.x, range.y);
          renderable = false;
          break;

        // Zoom canvas
        case ACTION_ZOOM:
          this.zoom((function (x1, y1, x2, y2) {
            var z1 = sqrt(x1 * x1 + y1 * y1);
            var z2 = sqrt(x2 * x2 + y2 * y2);

            return (z2 - z1) / z1;
          })(
            abs(this.startX - this.startX2),
            abs(this.startY - this.startY2),
            abs(this.endX - this.endX2),
            abs(this.endY - this.endY2)
          ), event);
          this.startX2 = this.endX2;
          this.startY2 = this.endY2;
          renderable = false;
          break;

        // Create crop box
        case ACTION_CROP:
          if (!range.x || !range.y) {
            renderable = false;
            break;
          }

          offset = this.$cropper.offset();
          left = this.startX - offset.left;
          top = this.startY - offset.top;
          width = cropBox.minWidth;
          height = cropBox.minHeight;

          if (range.x > 0) {
            action = range.y > 0 ? ACTION_SOUTH_EAST : ACTION_NORTH_EAST;
          } else if (range.x < 0) {
            left -= width;
            action = range.y > 0 ? ACTION_SOUTH_WEST : ACTION_NORTH_WEST;
          }

          if (range.y < 0) {
            top -= height;
          }

          // Show the crop box if is hidden
          if (!this.isCropped) {
            this.$cropBox.removeClass(CLASS_HIDDEN);
            this.isCropped = true;

            if (this.isLimited) {
              this.limitCropBox(true, true);
            }
          }

          break;

        // No default
      }

      if (renderable) {
        cropBox.width = width;
        cropBox.height = height;
        cropBox.left = left;
        cropBox.top = top;
        this.action = action;

        this.renderCropBox();
      }

      // Override
      this.startX = this.endX;
      this.startY = this.endY;
    },

    // Show the crop box manually
    crop: function () {
      if (!this.isBuilt || this.isDisabled) {
        return;
      }

      if (!this.isCropped) {
        this.isCropped = true;
        this.limitCropBox(true, true);

        if (this.options.modal) {
          this.$dragBox.addClass(CLASS_MODAL);
        }

        this.$cropBox.removeClass(CLASS_HIDDEN);
      }

      this.setCropBoxData(this.initialCropBox);
    },

    // Reset the image and crop box to their initial states
    reset: function () {
      if (!this.isBuilt || this.isDisabled) {
        return;
      }

      this.image = $.extend({}, this.initialImage);
      this.canvas = $.extend({}, this.initialCanvas);
      this.cropBox = $.extend({}, this.initialCropBox);

      this.renderCanvas();

      if (this.isCropped) {
        this.renderCropBox();
      }
    },

    // Clear the crop box
    clear: function () {
      if (!this.isCropped || this.isDisabled) {
        return;
      }

      $.extend(this.cropBox, {
        left: 0,
        top: 0,
        width: 0,
        height: 0
      });

      this.isCropped = false;
      this.renderCropBox();

      this.limitCanvas(true, true);

      // Render canvas after crop box rendered
      this.renderCanvas();

      this.$dragBox.removeClass(CLASS_MODAL);
      this.$cropBox.addClass(CLASS_HIDDEN);
    },

    /**
     * Replace the image's src and rebuild the cropper
     *
     * @param {String} url
     * @param {Boolean} onlyColorChanged (optional)
     */
    replace: function (url, onlyColorChanged) {
      if (!this.isDisabled && url) {
        if (this.isImg) {
          this.$element.attr('src', url);
        }

        if (onlyColorChanged) {
          this.url = url;
          this.$clone.attr('src', url);

          if (this.isBuilt) {
            this.$preview.find('img').add(this.$clone2).attr('src', url);
          }
        } else {
          if (this.isImg) {
            this.isReplaced = true;
          }

          // Clear previous data
          this.options.data = null;
          this.load(url);
        }
      }
    },

    // Enable (unfreeze) the cropper
    enable: function () {
      if (this.isBuilt) {
        this.isDisabled = false;
        this.$cropper.removeClass(CLASS_DISABLED);
      }
    },

    // Disable (freeze) the cropper
    disable: function () {
      if (this.isBuilt) {
        this.isDisabled = true;
        this.$cropper.addClass(CLASS_DISABLED);
      }
    },

    // Destroy the cropper and remove the instance from the image
    destroy: function () {
      var $this = this.$element;

      if (this.isLoaded) {
        if (this.isImg && this.isReplaced) {
          $this.attr('src', this.originalUrl);
        }

        this.unbuild();
        $this.removeClass(CLASS_HIDDEN);
      } else {
        if (this.isImg) {
          $this.off(EVENT_LOAD, this.start);
        } else if (this.$clone) {
          this.$clone.remove();
        }
      }

      $this.removeData(NAMESPACE);
    },

    /**
     * Move the canvas with relative offsets
     *
     * @param {Number} offsetX
     * @param {Number} offsetY (optional)
     */
    move: function (offsetX, offsetY) {
      var canvas = this.canvas;

      this.moveTo(
        isUndefined(offsetX) ? offsetX : canvas.left + num(offsetX),
        isUndefined(offsetY) ? offsetY : canvas.top + num(offsetY)
      );
    },

    /**
     * Move the canvas to an absolute point
     *
     * @param {Number} x
     * @param {Number} y (optional)
     */
    moveTo: function (x, y) {
      var canvas = this.canvas;
      var isChanged = false;

      // If "y" is not present, its default value is "x"
      if (isUndefined(y)) {
        y = x;
      }

      x = num(x);
      y = num(y);

      if (this.isBuilt && !this.isDisabled && this.options.movable) {
        if (isNumber(x)) {
          canvas.left = x;
          isChanged = true;
        }

        if (isNumber(y)) {
          canvas.top = y;
          isChanged = true;
        }

        if (isChanged) {
          this.renderCanvas(true);
        }
      }
    },

    /**
     * Zoom the canvas with a relative ratio
     *
     * @param {Number} ratio
     * @param {jQuery Event} _event (private)
     */
    zoom: function (ratio, _event) {
      var canvas = this.canvas;

      ratio = num(ratio);

      if (ratio < 0) {
        ratio =  1 / (1 - ratio);
      } else {
        ratio = 1 + ratio;
      }

      this.zoomTo(canvas.width * ratio / canvas.naturalWidth, _event);
    },

    /**
     * Zoom the canvas to an absolute ratio
     *
     * @param {Number} ratio
     * @param {jQuery Event} _event (private)
     */
    zoomTo: function (ratio, _event) {
      var options = this.options;
      var canvas = this.canvas;
      var width = canvas.width;
      var height = canvas.height;
      var naturalWidth = canvas.naturalWidth;
      var naturalHeight = canvas.naturalHeight;
      var originalEvent;
      var newWidth;
      var newHeight;
      var offset;
      var center;

      ratio = num(ratio);

      if (ratio >= 0 && this.isBuilt && !this.isDisabled && options.zoomable) {
        newWidth = naturalWidth * ratio;
        newHeight = naturalHeight * ratio;

        if (_event) {
          originalEvent = _event.originalEvent;
        }

        if (this.trigger(EVENT_ZOOM, {
          originalEvent: originalEvent,
          oldRatio: width / naturalWidth,
          ratio: newWidth / naturalWidth
        }).isDefaultPrevented()) {
          return;
        }

        if (originalEvent) {
          offset = this.$cropper.offset();
          center = originalEvent.touches ? getTouchesCenter(originalEvent.touches) : {
            pageX: _event.pageX || originalEvent.pageX || 0,
            pageY: _event.pageY || originalEvent.pageY || 0
          };

          // Zoom from the triggering point of the event
          canvas.left -= (newWidth - width) * (
            ((center.pageX - offset.left) - canvas.left) / width
          );
          canvas.top -= (newHeight - height) * (
            ((center.pageY - offset.top) - canvas.top) / height
          );
        } else {

          // Zoom from the center of the canvas
          canvas.left -= (newWidth - width) / 2;
          canvas.top -= (newHeight - height) / 2;
        }

        canvas.width = newWidth;
        canvas.height = newHeight;
        this.renderCanvas(true);
      }
    },

    /**
     * Rotate the canvas with a relative degree
     *
     * @param {Number} degree
     */
    rotate: function (degree) {
      this.rotateTo((this.image.rotate || 0) + num(degree));
    },

    /**
     * Rotate the canvas to an absolute degree
     * https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function#rotate()
     *
     * @param {Number} degree
     */
    rotateTo: function (degree) {
      degree = num(degree);

      if (isNumber(degree) && this.isBuilt && !this.isDisabled && this.options.rotatable) {
        this.image.rotate = degree % 360;
        this.isRotated = true;
        this.renderCanvas(true);
      }
    },

    /**
     * Scale the image
     * https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function#scale()
     *
     * @param {Number} scaleX
     * @param {Number} scaleY (optional)
     */
    scale: function (scaleX, scaleY) {
      var image = this.image;
      var isChanged = false;

      // If "scaleY" is not present, its default value is "scaleX"
      if (isUndefined(scaleY)) {
        scaleY = scaleX;
      }

      scaleX = num(scaleX);
      scaleY = num(scaleY);

      if (this.isBuilt && !this.isDisabled && this.options.scalable) {
        if (isNumber(scaleX)) {
          image.scaleX = scaleX;
          isChanged = true;
        }

        if (isNumber(scaleY)) {
          image.scaleY = scaleY;
          isChanged = true;
        }

        if (isChanged) {
          this.renderImage(true);
        }
      }
    },

    /**
     * Scale the abscissa of the image
     *
     * @param {Number} scaleX
     */
    scaleX: function (scaleX) {
      var scaleY = this.image.scaleY;

      this.scale(scaleX, isNumber(scaleY) ? scaleY : 1);
    },

    /**
     * Scale the ordinate of the image
     *
     * @param {Number} scaleY
     */
    scaleY: function (scaleY) {
      var scaleX = this.image.scaleX;

      this.scale(isNumber(scaleX) ? scaleX : 1, scaleY);
    },

    /**
     * Get the cropped area position and size data (base on the original image)
     *
     * @param {Boolean} isRounded (optional)
     * @return {Object} data
     */
    getData: function (isRounded) {
      var options = this.options;
      var image = this.image;
      var canvas = this.canvas;
      var cropBox = this.cropBox;
      var ratio;
      var data;

      if (this.isBuilt && this.isCropped) {
        data = {
          x: cropBox.left - canvas.left,
          y: cropBox.top - canvas.top,
          width: cropBox.width,
          height: cropBox.height
        };

        ratio = image.width / image.naturalWidth;

        $.each(data, function (i, n) {
          n = n / ratio;
          data[i] = isRounded ? round(n) : n;
        });

      } else {
        data = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }

      if (options.rotatable) {
        data.rotate = image.rotate || 0;
      }

      if (options.scalable) {
        data.scaleX = image.scaleX || 1;
        data.scaleY = image.scaleY || 1;
      }

      return data;
    },

    /**
     * Set the cropped area position and size with new data
     *
     * @param {Object} data
     */
    setData: function (data) {
      var options = this.options;
      var image = this.image;
      var canvas = this.canvas;
      var cropBoxData = {};
      var isRotated;
      var isScaled;
      var ratio;

      if ($.isFunction(data)) {
        data = data.call(this.element);
      }

      if (this.isBuilt && !this.isDisabled && $.isPlainObject(data)) {
        if (options.rotatable) {
          if (isNumber(data.rotate) && data.rotate !== image.rotate) {
            image.rotate = data.rotate;
            this.isRotated = isRotated = true;
          }
        }

        if (options.scalable) {
          if (isNumber(data.scaleX) && data.scaleX !== image.scaleX) {
            image.scaleX = data.scaleX;
            isScaled = true;
          }

          if (isNumber(data.scaleY) && data.scaleY !== image.scaleY) {
            image.scaleY = data.scaleY;
            isScaled = true;
          }
        }

        if (isRotated) {
          this.renderCanvas();
        } else if (isScaled) {
          this.renderImage();
        }

        ratio = image.width / image.naturalWidth;

        if (isNumber(data.x)) {
          cropBoxData.left = data.x * ratio + canvas.left;
        }

        if (isNumber(data.y)) {
          cropBoxData.top = data.y * ratio + canvas.top;
        }

        if (isNumber(data.width)) {
          cropBoxData.width = data.width * ratio;
        }

        if (isNumber(data.height)) {
          cropBoxData.height = data.height * ratio;
        }

        this.setCropBoxData(cropBoxData);
      }
    },

    /**
     * Get the container size data
     *
     * @return {Object} data
     */
    getContainerData: function () {
      return this.isBuilt ? this.container : {};
    },

    /**
     * Get the image position and size data
     *
     * @return {Object} data
     */
    getImageData: function () {
      return this.isLoaded ? this.image : {};
    },

    /**
     * Get the canvas position and size data
     *
     * @return {Object} data
     */
    getCanvasData: function () {
      var canvas = this.canvas;
      var data = {};

      if (this.isBuilt) {
        $.each([
          'left',
          'top',
          'width',
          'height',
          'naturalWidth',
          'naturalHeight'
        ], function (i, n) {
          data[n] = canvas[n];
        });
      }

      return data;
    },

    /**
     * Set the canvas position and size with new data
     *
     * @param {Object} data
     */
    setCanvasData: function (data) {
      var canvas = this.canvas;
      var aspectRatio = canvas.aspectRatio;

      if ($.isFunction(data)) {
        data = data.call(this.$element);
      }

      if (this.isBuilt && !this.isDisabled && $.isPlainObject(data)) {
        if (isNumber(data.left)) {
          canvas.left = data.left;
        }

        if (isNumber(data.top)) {
          canvas.top = data.top;
        }

        if (isNumber(data.width)) {
          canvas.width = data.width;
          canvas.height = data.width / aspectRatio;
        } else if (isNumber(data.height)) {
          canvas.height = data.height;
          canvas.width = data.height * aspectRatio;
        }

        this.renderCanvas(true);
      }
    },

    /**
     * Get the crop box position and size data
     *
     * @return {Object} data
     */
    getCropBoxData: function () {
      var cropBox = this.cropBox;
      var data;

      if (this.isBuilt && this.isCropped) {
        data = {
          left: cropBox.left,
          top: cropBox.top,
          width: cropBox.width,
          height: cropBox.height
        };
      }

      return data || {};
    },

    /**
     * Set the crop box position and size with new data
     *
     * @param {Object} data
     */
    setCropBoxData: function (data) {
      var cropBox = this.cropBox;
      var aspectRatio = this.options.aspectRatio;
      var isWidthChanged;
      var isHeightChanged;

      if ($.isFunction(data)) {
        data = data.call(this.$element);
      }

      if (this.isBuilt && this.isCropped && !this.isDisabled && $.isPlainObject(data)) {

        if (isNumber(data.left)) {
          cropBox.left = data.left;
        }

        if (isNumber(data.top)) {
          cropBox.top = data.top;
        }

        if (isNumber(data.width)) {
          isWidthChanged = true;
          cropBox.width = data.width;
        }

        if (isNumber(data.height)) {
          isHeightChanged = true;
          cropBox.height = data.height;
        }

        if (aspectRatio) {
          if (isWidthChanged) {
            cropBox.height = cropBox.width / aspectRatio;
          } else if (isHeightChanged) {
            cropBox.width = cropBox.height * aspectRatio;
          }
        }

        this.renderCropBox();
      }
    },

    /**
     * Get a canvas drawn the cropped image
     *
     * @param {Object} options (optional)
     * @return {HTMLCanvasElement} canvas
     */
    getCroppedCanvas: function (options) {
      var originalWidth;
      var originalHeight;
      var canvasWidth;
      var canvasHeight;
      var scaledWidth;
      var scaledHeight;
      var scaledRatio;
      var aspectRatio;
      var canvas;
      var context;
      var data;

      if (!this.isBuilt || !SUPPORT_CANVAS) {
        return;
      }

      if (!this.isCropped) {
        return getSourceCanvas(this.$clone[0], this.image);
      }

      if (!$.isPlainObject(options)) {
        options = {};
      }

      data = this.getData();
      originalWidth = data.width;
      originalHeight = data.height;
      aspectRatio = originalWidth / originalHeight;

      if ($.isPlainObject(options)) {
        scaledWidth = options.width;
        scaledHeight = options.height;

        if (scaledWidth) {
          scaledHeight = scaledWidth / aspectRatio;
          scaledRatio = scaledWidth / originalWidth;
        } else if (scaledHeight) {
          scaledWidth = scaledHeight * aspectRatio;
          scaledRatio = scaledHeight / originalHeight;
        }
      }

      // The canvas element will use `Math.floor` on a float number, so floor first
      canvasWidth = floor(scaledWidth || originalWidth);
      canvasHeight = floor(scaledHeight || originalHeight);

      canvas = $('<canvas>')[0];
      canvas.width = canvasWidth;
      canvas.height = canvasHeight;
      context = canvas.getContext('2d');

      if (options.fillColor) {
        context.fillStyle = options.fillColor;
        context.fillRect(0, 0, canvasWidth, canvasHeight);
      }

      // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D.drawImage
      context.drawImage.apply(context, (function () {
        var source = getSourceCanvas(this.$clone[0], this.image);
        var sourceWidth = source.width;
        var sourceHeight = source.height;
        var canvas = this.canvas;
        var params = [source];

        // Source canvas
        var srcX = data.x + canvas.naturalWidth * (abs(data.scaleX || 1) - 1) / 2;
        var srcY = data.y + canvas.naturalHeight * (abs(data.scaleY || 1) - 1) / 2;
        var srcWidth;
        var srcHeight;

        // Destination canvas
        var dstX;
        var dstY;
        var dstWidth;
        var dstHeight;

        if (srcX <= -originalWidth || srcX > sourceWidth) {
          srcX = srcWidth = dstX = dstWidth = 0;
        } else if (srcX <= 0) {
          dstX = -srcX;
          srcX = 0;
          srcWidth = dstWidth = min(sourceWidth, originalWidth + srcX);
        } else if (srcX <= sourceWidth) {
          dstX = 0;
          srcWidth = dstWidth = min(originalWidth, sourceWidth - srcX);
        }

        if (srcWidth <= 0 || srcY <= -originalHeight || srcY > sourceHeight) {
          srcY = srcHeight = dstY = dstHeight = 0;
        } else if (srcY <= 0) {
          dstY = -srcY;
          srcY = 0;
          srcHeight = dstHeight = min(sourceHeight, originalHeight + srcY);
        } else if (srcY <= sourceHeight) {
          dstY = 0;
          srcHeight = dstHeight = min(originalHeight, sourceHeight - srcY);
        }

        // All the numerical parameters should be integer for `drawImage` (#476)
        params.push(floor(srcX), floor(srcY), floor(srcWidth), floor(srcHeight));

        // Scale destination sizes
        if (scaledRatio) {
          dstX *= scaledRatio;
          dstY *= scaledRatio;
          dstWidth *= scaledRatio;
          dstHeight *= scaledRatio;
        }

        // Avoid "IndexSizeError" in IE and Firefox
        if (dstWidth > 0 && dstHeight > 0) {
          params.push(floor(dstX), floor(dstY), floor(dstWidth), floor(dstHeight));
        }

        return params;
      }).call(this));

      return canvas;
    },

    /**
     * Change the aspect ratio of the crop box
     *
     * @param {Number} aspectRatio
     */
    setAspectRatio: function (aspectRatio) {
      var options = this.options;

      if (!this.isDisabled && !isUndefined(aspectRatio)) {

        // 0 -> NaN
        options.aspectRatio = max(0, aspectRatio) || NaN;

        if (this.isBuilt) {
          this.initCropBox();

          if (this.isCropped) {
            this.renderCropBox();
          }
        }
      }
    },

    /**
     * Change the drag mode
     *
     * @param {String} mode (optional)
     */
    setDragMode: function (mode) {
      var options = this.options;
      var croppable;
      var movable;

      if (this.isLoaded && !this.isDisabled) {
        croppable = mode === ACTION_CROP;
        movable = options.movable && mode === ACTION_MOVE;
        mode = (croppable || movable) ? mode : ACTION_NONE;

        this.$dragBox.
          data(DATA_ACTION, mode).
          toggleClass(CLASS_CROP, croppable).
          toggleClass(CLASS_MOVE, movable);

        if (!options.cropBoxMovable) {

          // Sync drag mode to crop box when it is not movable(#300)
          this.$face.
            data(DATA_ACTION, mode).
            toggleClass(CLASS_CROP, croppable).
            toggleClass(CLASS_MOVE, movable);
        }
      }
    }
  };

  Cropper.DEFAULTS = {

    // Define the view mode of the cropper
    viewMode: 0, // 0, 1, 2, 3

    // Define the dragging mode of the cropper
    dragMode: 'crop', // 'crop', 'move' or 'none'

    // Define the aspect ratio of the crop box
    aspectRatio: NaN,

    // An object with the previous cropping result data
    data: null,

    // A jQuery selector for adding extra containers to preview
    preview: '',

    // Re-render the cropper when resize the window
    responsive: true,

    // Restore the cropped area after resize the window
    restore: true,

    // Check if the current image is a cross-origin image
    checkCrossOrigin: true,

    // Check the current image's Exif Orientation information
    checkOrientation: true,

    // Show the black modal
    modal: true,

    // Show the dashed lines for guiding
    guides: true,

    // Show the center indicator for guiding
    center: true,

    // Show the white modal to highlight the crop box
    highlight: true,

    // Show the grid background
    background: true,

    // Enable to crop the image automatically when initialize
    autoCrop: true,

    // Define the percentage of automatic cropping area when initializes
    autoCropArea: 0.8,

    // Enable to move the image
    movable: true,

    // Enable to rotate the image
    rotatable: true,

    // Enable to scale the image
    scalable: true,

    // Enable to zoom the image
    zoomable: true,

    // Enable to zoom the image by dragging touch
    zoomOnTouch: true,

    // Enable to zoom the image by wheeling mouse
    zoomOnWheel: true,

    // Define zoom ratio when zoom the image by wheeling mouse
    wheelZoomRatio: 0.1,

    // Enable to move the crop box
    cropBoxMovable: true,

    // Enable to resize the crop box
    cropBoxResizable: true,

    // Toggle drag mode between "crop" and "move" when click twice on the cropper
    toggleDragModeOnDblclick: true,

    // Size limitation
    minCanvasWidth: 0,
    minCanvasHeight: 0,
    minCropBoxWidth: 0,
    minCropBoxHeight: 0,
    minContainerWidth: 200,
    minContainerHeight: 100,

    // Shortcuts of events
    build: null,
    built: null,
    cropstart: null,
    cropmove: null,
    cropend: null,
    crop: null,
    zoom: null
  };

  Cropper.setDefaults = function (options) {
    $.extend(Cropper.DEFAULTS, options);
  };

  Cropper.TEMPLATE = (
    '<div class="cropper-container">' +
      '<div class="cropper-wrap-box">' +
        '<div class="cropper-canvas"></div>' +
      '</div>' +
      '<div class="cropper-drag-box"></div>' +
      '<div class="cropper-crop-box">' +
        '<span class="cropper-view-box"></span>' +
        '<span class="cropper-dashed dashed-h"></span>' +
        '<span class="cropper-dashed dashed-v"></span>' +
        '<span class="cropper-center"></span>' +
        '<span class="cropper-face"></span>' +
        '<span class="cropper-line line-e" data-action="e"></span>' +
        '<span class="cropper-line line-n" data-action="n"></span>' +
        '<span class="cropper-line line-w" data-action="w"></span>' +
        '<span class="cropper-line line-s" data-action="s"></span>' +
        '<span class="cropper-point point-e" data-action="e"></span>' +
        '<span class="cropper-point point-n" data-action="n"></span>' +
        '<span class="cropper-point point-w" data-action="w"></span>' +
        '<span class="cropper-point point-s" data-action="s"></span>' +
        '<span class="cropper-point point-ne" data-action="ne"></span>' +
        '<span class="cropper-point point-nw" data-action="nw"></span>' +
        '<span class="cropper-point point-sw" data-action="sw"></span>' +
        '<span class="cropper-point point-se" data-action="se"></span>' +
      '</div>' +
    '</div>'
  );

  // Save the other cropper
  Cropper.other = $.fn.cropper;

  // Register as jQuery plugin
  $.fn.cropper = function (option) {
    var args = toArray(arguments, 1);
    var result;

    this.each(function () {
      var $this = $(this);
      var data = $this.data(NAMESPACE);
      var options;
      var fn;

      if (!data) {
        if (/destroy/.test(option)) {
          return;
        }

        options = $.extend({}, $this.data(), $.isPlainObject(option) && option);
        $this.data(NAMESPACE, (data = new Cropper(this, options)));
      }

      if (typeof option === 'string' && $.isFunction(fn = data[option])) {
        result = fn.apply(data, args);
      }
    });

    return isUndefined(result) ? this : result;
  };

  $.fn.cropper.Constructor = Cropper;
  $.fn.cropper.setDefaults = Cropper.setDefaults;

  // No conflict
  $.fn.cropper.noConflict = function () {
    $.fn.cropper = Cropper.other;
    return this;
  };

});

},
'appivo/util/BlobPolyfill':function(){
define([], function() {
	(function() {
	    'use strict';
        if (!HTMLCanvasElement.prototype.toBlob) {
         Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
          value: function (callback, type, quality) {
            var binStr = atob( this.toDataURL(type, quality).split(',')[1] ),
                len = binStr.length,
                arr = new Uint8Array(len);

            for (var i = 0; i < len; i++ ) {
             arr[i] = binStr.charCodeAt(i);
            }
            callback( new Blob( [arr], {type: type || 'image/png'} ) );
          }
         });
        }
	}());
	return {};
});

},
'appivo/client/Client':function(){
define(['dojo/_base/lang',
    'dojo/_base/declare',
    'dojo/_base/kernel',
    'dojo/_base/Deferred',
    'dojo/_base/config',
    'dojo/io-query',
    'dojo/hash',
    "dojo/request/xhr",
    "dojo/request/handlers",
    "dojo/cookie",
    "moment/moment",
    "moment-timezone/moment-timezone",
    'appivo/util/isMobile',
    'appivo/util/Currency',
    'appivo/ui/Alertify',
    'appivo/util/Identity',
    'appivo/util/native/File',
    'appivo/util/idb',
    'dojo/i18n!appivo/nls/Client'
], function(lang, declare, kernel, Deferred, config, ioQuery, hash, xhr, handlers, cookie, moment, momentTz, isMobile, Currency, alertify, Identity, File, IDb, messages) {

    const idb = new IDb();

    var OFFLINE_MODES = ["ONLINE", "AUTO", "OFFLINE"];

    var HEADER_AUTHORIZATION = "Authorization";
    var HEADER_OFFLINE = "X-Offline";
    var HEADER_REFRESHTOKEN = "X-RefreshToken";
    var HEADER_VHOST_REFRESHTOKEN = "X-VHost-RefreshToken";
    var HEADER_CONTENTTYPE = "Content-Type";
    var HEADER_SESSION = "X-Session";
    var HEADER_CLIENT_ID = "X-Client";
    var COOKIE_APPLICATION = "x-application";
    var COOKIE_PUBLIC_UIS = "x-public-userinterfaces";
    var COOKIE_TENANT = "x-tenant";
    var COOKIE_TENANT_NAME = "x-tenant-name";
    var COOKIE_DOMAIN_META = "x-domain-meta";
    var COOKIE_VENDOR = "x-vendor";
    var COOKIE_VIEW = "x-view";
    var COOKIE_REFRESHTOKEN = "refreshtoken";
    var COOKIE_POST_ACTIVATION_REDIRECT = "x-post-activation-redirect";
    var CREDENTIALS_FILE = "credentials.json";

    var ANONYMOUS_ID = "00000000000000000000000000040001";
    var APPIVO_TENANT = "00000000000000000000000000030000";
    var SECOND = 1000;
    var MINUTE = 60 * SECOND;
    var HOUR = 60 * MINUTE;
    var DAY = 24 * HOUR;
    var REFRESH_TOKEN_INTERVAL = 10 * 60 * SECOND;
    var MIN_UPDATE_INTERVAL = 10000; // ms
    var ACTIVITY_CHECK_INTERVAL = 1 * 60 * SECOND;

    var device = undefined;
    var appStarted = false;
    var refreshTimer = null;
    var forceOffline = false;
    var offlineMode = 'ONLINE';
    var ssoConfig = null;
    var deviceInfo = isMobile.isMobile();
    var usingSw = false;
    var keepToken = false;
    var platformFeatures = {};
    var platformPlan = null;
    var clientId = Identity.generateUUID();

    console.log("Device-info:", deviceInfo);

    var langCountryMap = {
        'sv': 'SE',
        'en': 'US',
        'fr': 'FR',
        'dk': 'DK',
        'de': 'DE',
        'es': 'ES',
        'no': 'NO'
    };

    var originCountry = "US";
    var originCity = "";
    var vhostData = null;
    var publicContext = null;
    var accessToken = null;
    var jwt = null;
    var tokenExpiration = 0;
    var refreshTimer;
    var lastRefresh;
    var	userObservers = [];
    var stateObservers = [];
    var accountStatsObservers = [];
    var networkObservers = [];
    var	loggedIn = false;
    var wasLoggedIn = false;
    var preventReauth = false;
    var preventTokenRefresh = false;
    var lastCacheUpdate = 0;
    var online = navigator.onLine;
    var workboxInstance = null;
    var workboxRegistration = null;
    var workerReady = new Deferred();
    var clearSW = false;
    var session = false;
    var isAppDomain = false;
    var domainApp = null;
    var publicUis = null;
    var domainTenant = null;
    var domainType = null;
    var domainVendor = null;
    var tokenRefreshes = 0;
    var currentRefreshToken;
    var lastActivity = Date.now();

    function activityDetected() {
        lastActivity = Date.now();
    }
    var activityEvents = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
    activityEvents.forEach(function(name) {
        document.addEventListener(name, activityDetected, true);
    });

    function checkConnection() {
        if (navigator.connection && window.Connection) {
            online = navigator.connection.type !== window.Connection.NONE;
        } else {
            online = navigator.onLine;
        }
    }

    checkConnection();

    handlers.register("text", function(response){
        return response.text;
    });

    function signalWorkerReady() {
        try {
            console.log("signalWorkReady called");
            if (!workerReady.isFulfilled()) {
                workerReady.resolve();
            }
        } catch (error) {
            // swallow
        }
    };

    function findHeader(headers, header) {
        var found = false;
        for (var hdr in headers) {
            if (hdr.toLowerCase() === header.toLowerCase()) {
                found = true;
            }
        }
        return found;
    }

    var workerSupport = false;
    if ('serviceWorker' in navigator) {
        workerSupport = true;
    } else {
        signalWorkerReady();
        console.log("Warning! No service-worker support.");
    }

    var sendMessage = function(type, message) {
        var wb = workboxInstance;
        if (wb) {
            return wb.messageSW({
                type: type,
                payload: message
            });
        }
    };

    var SWController = function(options) {
    };

    SWController.prototype = {
        constructor: SWController,

        install: function(schema) {
            console.log("Sending: Install Schema")
            sendMessage('install', schema);
        },

        uninstall: function(schema) {
            return sendMessage('uninstall', schema);
        },

        logout: function() {
            console.log("Sending to SW: delete tokens");
            return sendMessage('logout', {});
        },

        cache: function(url) {
            return sendMessage('cache', url);
        },

        setRefreshToken: function(token) {
            console.log("Sending to SW: store refresh-token");
            currentRefreshToken = token;
            if (!keepToken || token == null) {
                localStorage.removeItem("refreshToken");
            }
            return sendMessage('refreshToken', token);
        },

        storeRecords: function(schema, model, records) {
            return sendMessage('store', {
                schema: schema,
                model: model,
                records: records
            });
        },

        clear: function(schema) {
            return sendMessage('clear', schema);
        }
    };

    function clearCookie(name) {
        cookie(name, '', {
            path: '/',
            expires: 'Thu, 01-Jan-70 00:00:01 GMT'
        });
    }

    var swcontroller = new SWController({});
    var lastActivity = new Date().getTime();

    var clss = declare("appivo.client.Client", null, {

        bus: null,
        user: null,
        valid: false,
        appConfig: null,
        server: '',
        createApp: false,
        tenantId: null,
        tenantName: null,
        tenantDomain: null,
        tenantAddress1: null,
        tenantAddress2: null,
        tenantCity: null,
        tenantZipcode: null,
        tenantCountry: null,
        tenantPhone: null,
        tenantEmail: null,
        stripeKey: null,
        hybridAppMetaData: {},
        privileges: {},
        accountStats: {},
        publicSchema: null,
        preferences: {},
        browserLanguages: "en",
        options: {},
        impersonationToken: null,
        impersonatedTenant: null,
        _suppressDialogs: false,
        whitelabel: null,
        applianceTags: null,
        anonUrl: null,

        constructor: function(options) {
            declare.safeMixin(this, options);
            var t = this;
            var domain = window.location.host;
            var domainMeta = cookie(COOKIE_DOMAIN_META);
            if (!domainMeta) {
                try {
                    domainMeta = localStorage.getItem("domain-meta-" + domain);
                } catch (error) {
                }
            }
            if (domainMeta) {
                try {
                    localStorage.setItem("domain-meta-" + domain, domainMeta);
                } catch (error) {
                    console.error("Failed to store domain-metadata");
                }
                domainMeta = this.parseB64Json(domainMeta);
                domainApp = domainMeta.a;
                publicUis = domainMeta.u;
                domainTenant = domainMeta.t;
                domainVendor = domainMeta.v;
                domainType = domainMeta.dt;
                if (domainMeta.d !== undefined) {
                    isAppDomain = (domainMeta.d == 1);
                    if (isAppDomain) {
                        isAppDomain = !!domainApp;
                    }
                }
            }
            if (!domainApp) {
                domainApp = cookie(COOKIE_APPLICATION);
            }
            if (!domainVendor) {
                domainVendor = cookie(COOKIE_VENDOR);
            }
            if (!publicUis) {
                publicUis = cookie(COOKIE_PUBLIC_UIS);
            }
            if (!domainTenant) {
                domainTenant = cookie(COOKIE_TENANT);
            }
            if (domainTenant) {
                this.tenantId = domainTenant;
            }
            if (!this.tenantName) {
                this.tenantName = cookie(COOKIE_TENANT_NAME);
            }
            var domainView = cookie(COOKIE_VIEW);
            if (domainVendor) {
                var token = cookie(COOKIE_REFRESHTOKEN);
                if (token) {
                    this.setRefreshToken(token);
                }
            }

            session = sessionStorage.getItem("session");
            this.options = ioQuery.queryToObject(location.search.substring(1));
            this._suppressDialogs = this.options['_suppressDialogs'] == 'true';
            var hybridMeta = localStorage.getItem("hybridMetadata");
            if (hybridMeta) {
                try {
                    this.hybridAppMetaData = JSON.parse(hybridMeta);
                } catch (error) {
                    console.error("Failed to load hybrid-app metadata from localstorage", error);
                }
            }
            console.log("Client locale " + kernel.locale);

            window.addEventListener('online', function() {
                t._changeOnlineStatus(true);
            });
            window.addEventListener('offline', function() {
                t._changeOnlineStatus(false);
            });
        },

        init: function() {
            var t = this;
            console.log("Starting appivo-client");
            var validToken = this.hasValidRefreshToken(true);
            var vhostToken = cookie(HEADER_VHOST_REFRESHTOKEN);
            console.log(validToken ? "A valid refresh-token exists" : "A valid refresh-token does not exist");
            if (vhostToken) {
                console.log("Launched from a public UI");
            }
            if (vhostToken && !(validToken && this.isMobile())) {
                clearCookie(HEADER_VHOST_REFRESHTOKEN);
                session = true;
                this.setRefreshToken(vhostToken);
                if (vhostData && !vhostData.ui) {
                    var uis = this.getPublicUserInterfaces();
                    if (uis && uis.length > 0) {
                        vhostData.ui = uis[0];
                    }
                }
            }
            if (this.options && this.options.tenant) {
                this.tenantId = this.options.tenant;
            }
            var impTenant = localStorage.getItem("impersonatedTenant");
            if (impTenant != null) {
                this.impersonatedTenant = JSON.parse(impTenant);
                this.impersonationToken = cookie('Impersonate');
            }
            this.anonUrl = cookie('AnonAccess');
            if (this.anonUrl) {
                session = true;
                var refreshToken = cookie("refreshtoken");
                if (refreshToken) {
                    var parsed = this.parseJwt(refreshToken);
                    this.setRefreshToken(refreshToken);
                }
                this.anonUrl = '#' + this.anonUrl;
                clearSW = true;
                clearCookie('AnonAccess');
            }
            if (cookie('forcelogout') === "yes") {
                clearSW = true;
                clearCookie('refreshtoken');
                clearCookie('forcelogout');
            }

            if (this.isHybrid()) {
                document.addEventListener("resume", function() {
                    checkConnection();
                }, false);
                    document.addEventListener('online', function() {
                    t._changeOnlineStatus(true);
                }, false);
                document.addEventListener('offline', function() {
                    t._changeOnlineStatus(false);
                }, false);
            }
            if (session) {
                sessionStorage.setItem("session", true);
            }

            function onActivity() {
                lastActivity = new Date().getTime();
            }

            inactivityTimer = window.setInterval(function() {
                var now = new Date().getTime();
                if (lastActivity > lastRefresh) {
                    console.log("Trigger refresh of access-token because of user activity");
                    t.refreshToken();
                }
            }, ACTIVITY_CHECK_INTERVAL);

            document.addEventListener("mousemove", onActivity);
            document.addEventListener("mousedown", onActivity);
            document.addEventListener("touchmove", onActivity);
            document.addEventListener("keypress", onActivity);
        },

        getClientId: function() {
            return clientId;
        },

        isMobile: function() {
            return deviceInfo.any || this.options.forceMobile;
        },

        isPhone: function() {
            return deviceInfo.phone;
        },

        isTablet: function() {
            return deviceInfo.tablet;
        },

        isIOS: function() {
            return deviceInfo.apple.device;
        },

        isAndroid: function() {
            return deviceInfo.android.device;
        },

        isHybrid: function() {
            return !!window.cordova || window.location.pathname.indexOf('/h/') == 0 || window.location.pathname.indexOf('/h-public/') == 0;
        },

        isVendorDomain: function() {
            return !!domainVendor;
        },

        getDomainVendor: function() {
            return domainVendor;
        },

        getDomainType: function() {
            return domainType;
        },

        isApplicationDomain: function() {
            return isAppDomain;
        },

        getDomainApplication: function() {
            return domainApp;
        },

        getPostActivationRedirect: function() {
            var url = cookie(COOKIE_POST_ACTIVATION_REDIRECT);
            clearCookie(COOKIE_POST_ACTIVATION_REDIRECT);
            return url;
        },

        getPublicUserInterfaces: function() {
            var t = this;
            var uis = [];
            if (publicUis) {
                var parts = publicUis.split(",");
                parts.forEach(function(part) {
                    part = part.trim();
                    var seg = part.split(":");
                    var type = seg[1];
                    if ((t.isMobile() && type == "mobile") || (!t.isMobile() && type == "desktop")) {
                        uis.push(seg[0]);
                    }
                });
            }
            return uis;
        },

        suppressDialogs: function() {
            return this._suppressDialogs;
        },

        setHybridAppMetaData: function(data) {
            if (data) {
                this.hybridAppMetaData = data;
                localStorage.setItem("hybridMetadata", JSON.stringify(data));
            }
        },

        getHybridAppMetaData: function() {
            return this.hybridAppMetaData;
        },

        getAppProperty: function(key) {
            var val = null;
            if (this.hybridAppMetaData) {
                val = this.hybridAppMetaData[key];
            }
            return val;
        },

        isStart: function() {
            return appStarted;
        },

        isOnline: function() {
            checkConnection();
            return online && !forceOffline;
        },

        isOffline: function() {
            checkConnection();
            return !online || forceOffline;
        },

        forceOffline: function(offline) {
            forceOffline = offline;
        },

        isForcedOffline: function() {
            return forceOffline;
        },

        setOfflineMode: function(mode) {
            console.log("Setting client offline-mode to " + mode);
            offlineMode = mode;
        },

        getOfflineMode: function() {
            return offlineMode;
        },

        observeNetwork: function(callback) {
            networkObservers.push(callback);
        },

        unObserveNetwork: function(callback) {
            var index = networkObservers.indexOf(callback);
            if (index !== -1) {
                networkObservers.splice(index, 1);
            }
        },

        _changeOnlineStatus: function(networkStatus) {
            var changed = online != networkStatus;
            online = networkStatus;
            var status = online ? "online" : "offline";
            console.log("Network status changed to " + status);
            if (changed) {
                for (var i = 0; i < networkObservers.length; i++) {
                    try {
                        var callback = networkObservers[i];
                        var event = {
                            status: status
                        };
                        if (window.connection) {
                            event.connection = window.connection.type;
                        }
                        callback(event);
                    } catch (error) {
                        console.error("Failed to update network status", error);
                    }
                }
            }
            if (online && changed) {
                console.log("Device is online again, trigger token-refresh.");
                this.refreshToken();
            }
        },

        setPreventReauth: function(prevent) {
            preventReauth = prevent;
            this.updateState();
        },

        setPreventTokenRefresh: function(prevent) {
            preventTokenRefresh = prevent;
        },

        isLocalhost: function() {
            var host = window.location.host;
            var colon = host.indexOf(':');
            if (colon >= 0) {
                host = host.substring(0, colon);
            }
            return host == 'localhost' || host == '127.0.0.1' || host == '0:0:0:0:0:0:0:1' || host == '::1';
        },

        isAppivo: function() {
            return APPIVO_TENANT == this.tenantId;
        },

        getCookie: function(cookieName) {
            return cookie(cookieName);
        },

        registerPageView: function(event, data, title) {
            if (window.gtag) {
                if (!event) {
                    var hash = window.location.hash;
                    if (hash) {
                        if (hash.startsWith("#")) {
                            hash = hash.substring(1);
                        }
                        if (!hash.startsWith("/")) {
                            hash = "/" + hash;
                        }
                    }
                    if (!hash) {
                        hash = "/";
                    }
                    var page = "/page" + hash;
                    if (!title) {
                        title = document.title;
                    }
                    window.gtag('event', 'page_view', {
                        page_title: title,
                        page_path: page
                    });
                } else {
                    window.gtag('event', event, data);
                }
            }
        },

        _completeServiceWorker: function(clearSW) {
            var t = this;
            var p =  new Promise(function(resolve, reject) {
                if (!clearSW) {
                    var refreshToken = localStorage.getItem("refreshToken");
                    if (refreshToken && swcontroller) {
                        var jwt = t.parseJwt(refreshToken);
                        if (jwt) {
                            if (t._isExpired(jwt.exp)) {
                                var exp = t.msToDate(jwt.exp);
                                console.log("Refresh token expired " + exp + ", not sending to serviceworker");
                            } else {
                                console.log("Sending refresh-token to serviceworker");
                                swcontroller.setRefreshToken(refreshToken);
                            }
                        }
                    }
                    setTimeout(function() {
                        signalWorkerReady();
                        resolve();
                    }, 5);
                } else {
                    console.log("Clearing tokens");
                    swcontroller.logout().then(function(msg) {
                        console.log("Tokens cleared, proceeding");
                        accessToken = null;
                        if (!session) {
                            t.setRefreshToken(null);
                        }
                        setTimeout(function() {
                            signalWorkerReady();
                            resolve();
                        }, 5);
                    }, function(error) {
                        console.log("Failed to clear tokens, proceeding");
                        signalWorkerReady();
                        resolve();
                    });
                }
            });
            return p;
        },

        _registerServiceWorker: function(wb, def) {
            var t = this;
            if (!def || def.isFulfilled()) {
                def = new Deferred();
            }
            workboxInstance = wb;
            if (wb) {
                usingSw = true;
                wb.register().then(function(registration) {
                    console.log("Serviceworker registered");
                    workboxRegistration = registration;
                    if (registration.active && registration.active.state == 'activated') {
                        if (!navigator.serviceWorker.controller) {
                            def.reject();
                        } else {
                            console.log("Serviceworker - registration active");
                            t._completeServiceWorker(clearSW).then(function() {
                                def.resolve(registration);
                            }, function(error) {
                                def.reject(error);
                            })
                        }
                    }

                    registration.addEventListener('updatefound', function(event) {
                        // A wild service worker has appeared in reg.installing!
                        var newWorker = registration.installing;
                        // nosemgrep: unsafe-formatstring
                        console.log("Serviceworker - update found - state " + newWorker.state, event);
                        // "installing" - the install event has fired, but not yet complete
                        // "installed"  - install complete
                        // "activating" - the activate event has fired, but not yet complete
                        // "activated"  - fully active
                        // "redundant"  - discarded. Either failed install, or it's been
                        //                replaced by a newer version

                        function workerActive() {
                            console.log("Serviceworker state changed to " + newWorker.state);
                            if (newWorker.state == 'activated') {
                                t._completeServiceWorker(clearSW).then(function() {
                                    def.resolve(registration);
                                }, function(error) {
                                    def.reject(error);
                                })
                            }
                        }

                        if (newWorker.state === 'activated') {
                            workerActive();
                        } else {
                            newWorker.addEventListener('statechange', function () {
                                workerActive();
                            });
                        }
                    });
                });

                wb.controlling.then(function() {
                    console.log("Serviceworker is controlling");
                });
            } else if (wb === null) {
                signalWorkerReady();
                def.resolve();
            }
            return def;
        },

        getServiceWorker: function() {
            return workboxInstance;
        },

        isUsingServiceWorker: function() {
            return usingSw;
        },

        getServiceWorkerController: function() {
            return swcontroller;
        },

        checkForUpgrade: function() {
            if (workboxInstance) {
                workboxInstance.update();
            }
        },

        isCors: function() {
            return this.cors;
        },

        updateCaches: function() {
            var now = new Date().getTime();
            var delta = now - lastCacheUpdate;
            if (delta > MIN_UPDATE_INTERVAL) {
                lastCacheUpdate = now;
                try {
                    console.log("Updating application-cache");
                    //window.applicationCache.update();
                } catch (error) {
                    // ignore
                }
            } else {
                console.log("Skipping update since it was just updated " + delta + "ms ago");
            }
        },

        getDeviceType: function() {
            if (!device) {
                device = 'unknown';
                if (this._isWindowsPhone()) {
                    device = 'windowsphone';
                } else if (deviceInfo.apple.device) {
                    device = 'ios';
                } else if (deviceInfo.android.device) {
                    device = 'android';
                } else if (deviceInfo.windows.device) {
                    device = 'windowsphone';
                }
            }
            return device;
        },

        allowPopups: function() {
            return (!this.options || !this.options.forceNoPopups);
        },

        hasSSO: function() {
            return ssoConfig && ssoConfig.url;
        },

        setSSO: function(config) {
            ssoConfig = config;
        },

        getSSO: function() {
            return ssoConfig;
        },

        setTenant: function(tenant) {
            if (tenant) {
                this.tenantId = tenant.id;
                this.tenantName = tenant.name;
                this.tenantShortcode = tenant.shortcode;
            }
        },

        getCountry: function() {
            var country = null;
            var locale = kernel.locale;
            if (this.options && this.options.forceLang) {
                locale = this.options.forceLang;
            }

            var dash = locale.indexOf('-')
            if (dash != -1) {
                country = locale.substring(dash + 1).toUpperCase();
            } else {
                country = langCountryMap[this.getLocale()];
            }
            if (!country) {
                country = 'US';
            }
            return country;
        },

        getOriginCountry: function() {
            return originCountry ? originCountry : "US";
        },

        getOriginCity: function() {
            return originCity;
        },

        getLocale: function() {
            var locale = kernel.locale;
            if (this.options && this.options.forceLang) {
                locale = this.options.forceLang;
            }

            var dash = locale.indexOf('-')
            if (dash != -1) {
                locale = locale.substring(0, dash);
            }

            return locale;
        },

        getCurrency: function(locale) {
            if (!locale) {
                locale = getLocale();
            }
            return Currency.getCurrency(locale);
        },

        getPreferences: function() {
            return this.preferences;
        },

        getPreferredLanguages: function() {
            return this.preferences.langs ? this.preferences.langs : this.getBrowserLanguages();
        },

        getBrowserLanguages: function() {
            if (!this.browserLanguages) {
                if (navigator.language) {
                    this.browserLanguages = navigator.language;
                }
            }
            return this.browserLanguages ? this.browserLanguages : "en";
        },

        getServer: function() {
            return this.cors ? this.cell : location.host;
        },

        getInactiveTime: function() {
            return Date.now() - lastActivity;
        },

        getStripeKey: function() {
            return this.stripeKey;
        },

        impersonateUser: function(user) {
            return this._impersonate({
                user: user
            });
        },

        impersonateTenant: function(tenant) {
            var t = this;
            return this._impersonate({
                tenant: tenant.id
            }).then(function(token) {
                localStorage.setItem("impersonatedTenant", JSON.stringify(tenant));
                t.impersonatedTenant = tenant;
                return token;
            });
        },

        isImpersonating: function() {
            return this.impersonationToken && this.impersonatedTenant;
        },

        stopImpersonation: function() {
            this.impersonationToken = null;
            localStorage.removeItem("impersonatedTenant");
            this._clearImpersonationCookie();
        },

        _clearImpersonationCookie: function() {
            clearCookie('Impersonate');
        },

        _impersonate: function(req) {
            var t = this;
            var url = '/api/impersonate';

            var promise = this.sendRequest(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify(req)
            });

            var def = new Deferred();
            promise.response.then(function(response) {
                if (response.status == 200) {
                    var data = response.data;
                    if (data && data.token) {
                        var exp = new Date();
                        var time = exp.getTime() + ((60 * 60) * 300);
                        exp.setTime(time);
                        t.impersonationToken = data.token;
                        cookie('Impersonate', data.token, {
                            path: '/',
                            expires: exp.toGMTString()
                        });
                        def.resolve(t.impersonationToken);
                    } else {
                        def.reject();
                    }
                } else {
                    def.reject();
                }
            }, function(error) {
                def.reject(error);
            });
            return def;
        },

        registerDevice: function(registrationId) {
            var t = this;
            if (!registrationId) {
                registrationId = localStorage.getItem('newRegistrationId');
                localStorage.removeItem('newRegistrationId');
            }
            if (registrationId != undefined && registrationId != null && registrationId != 'null') {
                var oldRegId = localStorage.getItem('oldRegistrationId');
                if (oldRegId !== registrationId) {
                    if (oldRegId == undefined || oldRegId == null || oldRegId == '') {
                        var method = 'POST';
                        var data = {
                            platform: t.getDeviceType(),
                            deviceid: registrationId,
                            meta_app_id: t.getAppProperty("appId")
                        };
                    } else {
                        var method = 'PUT';
                        var data = {
                            olddeviceid: oldRegId,
                            newdeviceid: registrationId,
                            meta_app_id: t.getAppProperty("appId")
                        }
                    }
                    this.isSessionValid().then(function() {
                        var promise = t.sendRequest('api/app/' + t.getAppProperty("schema") + '/device', {
                            method: method,
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            data: JSON.stringify(data)
                        });
                        promise.response.then(function(response) {
                            if (response.status == 200) {
                                localStorage.setItem('oldRegistrationId', registrationId);
                            }
                        }, function(response) {
                            if (response.response.status == 500 && response.response.data.errorCode === 'REC_0007') {
                                //Unable to update, server most likely forgot about us..
                                localStorage.removeItem('oldRegistrationId');
                                t.registerDevice(registrationId);
                            } else { //Unhandled error, just store Id for now
                                localStorage.setItem('newRegistrationId', registrationId);
                            }
                        });
                    }, function() {
                        localStorage.setItem('newRegistrationId', registrationId);
                    });
                }
            }
        },

        unregisterDevice: function() {
            var def = new Deferred();
            var registrationId = localStorage.getItem('oldRegistrationId');
            if (registrationId != undefined && registrationId != null && registrationId != 'null') {
                console.log("unregistering device " + registrationId);
                this.sendRequest('api/app/' + this.getAppProperty("schema") + '/device', {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    query: {
                        delete: true
                    },
                    data: JSON.stringify({
                        platform: this.getDeviceType(),
                        deviceid: registrationId,
                        meta_app_id: this.getAppProperty("appId")
                    })
                }).response.then(function(response) {
                    if (response.status == 200) {
                        console.log("Device unregistered successfully");
                        localStorage.removeItem('oldRegistrationId');
                        def.resolve();
                    } else {
                        console.log("Failed to unregister - responsecode " + response.status);
                        def.reject();
                    }
                }, function(response) {
                    console.error("Failed to unregister", response);
                    def.reject();
                });
            } else {
                def.resolve();
            }
            return def;
        },

        _constructStatusURL: function() {
            var url = '/api/status';
            if (this.isHybrid()) {
                var config = this.getHybridAppMetaData();
                if (config['public']) {
                    vhostData = {};
                    if (config.vhost) {
                        vhostData.host = config.vhost;
                    }
                    if (config.tenantId) {
                        vhostData.tenant = config.tenantId;
                    }
                    if (config.schema) {
                        vhostData.schema = config.schema;
                    }
                    if (config.ui) {
                        vhostData.ui = config.ui;
                    }
                }
            }

            if (vhostData && vhostData.host) {
                url = url + '?vhost=' + vhostData.host;
            }

            return url;
        },

        hasPublicUI: function() {
            var uis = this.getPublicUserInterfaces();
            return uis && uis.length > 0;
        },

        registerPublicApp: function() {
            if (this.isApplicationDomain()) {
                var uis = this.getPublicUserInterfaces();
                if (uis && uis.length > 0) {
                    vhostData = {};
                    vhostData.tenant = domainTenant;
                    vhostData.schema = domainApp;
                    vhostData.ui = uis[0];
                }
            }
        },

        isPublicApp: function() {
            return !!vhostData;
        },

        isAnonymousDispatch: function() {
            var path = window.location.hash;
            return path == this.anonUrl;
        },

        isAnonymousAccess: function() {
            return this.getTokenProperty("aac");
        },

        getPublicAppPath: function() {
            var path = null;
            if (vhostData) {
                path = '/app/' + vhostData.schema;
                if (vhostData.ui) {
                    path = path + '/' + vhostData.ui;
                }
            }
            return path;
        },

        getTokenProperty: function(key) {
            return jwt ? jwt[key] : undefined;
        },

        getApplianceId: function() {
            return this.getTokenProperty("did");
        },

        getApplianceTags: function() {
            return this.applianceTags ? this.applianceTags : [];
        },

        msToDate: function(ms) {
            var expiration = ms ? ms * SECOND : undefined;
            var expirationDate = ms ? new Date(expiration) : null;
            return expirationDate;
        },

        hasValidRefreshToken: function(ignoreSession) {
            var valid = false;
            var token = this.getRefreshToken(ignoreSession);
            if (token) {
                var now = new Date().getTime() + MINUTE;
                var jwt = this.parseJwt(token);
                if (jwt) {
                    var expirationDate = this.msToDate(jwt.exp);
                    if (expirationDate != null && expirationDate.getTime() > now) {
                        valid = true;
                        console.log("Valid refresh-token exists with expiration " + expirationDate);
                    }
                }
            }
            return valid;
        },

        _loadCredentialsFromFile: function() {
            var t = this;
            return new Promise(function(resolve, reject) {
                if (this.isHybrid() && File._readWriteFile) {
                    try {
                        console.log("Loading credentials");
                        File.readFile(CREDENTIALS_FILE, {}).then(function (content) {
                            try {
                                console.log("Credentials loaded!");
                                var creds = JSON.parse(content);
                                var refreshToken = creds.refreshToken;
                                if (refreshToken) {
                                    var parsed = t.parseJwt(refreshToken);
                                    if (!t._isExpired(parsed.exp)) {
                                        console.log("Using stored refreshtoken");
                                        t.setRefreshToken(refreshToken, true);
                                        resolve(refreshToken);
                                    } else {
                                        refreshToken = null;
                                        console.log("Stored refreshtoken expired");
                                        reject("Stored refreshtoken expired");
                                    }
                                } else {
                                    reject("No stored refreshtoken found");
                                }
                            } catch (error) {
                                console.error("Failed to parse credentials", error);
                                reject(error);
                            }
                        });
                    } catch (error) {
                        console.error("Failed to load credentials", error);
                        reject(error);
                    }
                } else {
                    resolve();
                }
            });
        },

        loadCredentials: function() {
            var t = this;
            return new Promise(function(resolve, reject) {
                idb.get("creds").then(function(creds) {
                    let rt = creds ? t.verifyJwt(creds.refreshToken) : null;
                      t._loadCredentialsFromFile().then(function(refreshToken) {
                        resolve(refreshToken);
                    }, function(error) {
                        if (rt) {
                            resolve(rt);
                        } else {
                            reject(error);
                        }
                    })
                }, function(error) {
                    t._loadCredentialsFromFile().then(function(refreshToken) {
                        resolve(refreshToken);
                    }, function(error) {
                        if (rt) {
                            resolve(rt);
                        } else {
                            reject(error);
                        }
                    })
                });
            });
        },

        _saveCredentials: function(token) {
            if (File._readWriteFile) {
                var credentials = null;
                if (token) {
                    credentials = {
                        refreshToken: token,
                        accessToken: accessToken
                    };
                }
                idb.set("cred", credentials);
                var content = JSON.stringify(credentials);
                return File.writeFile(CREDENTIALS_FILE, content, {
                    contentType: 'application/json'
                });
            } else {
                console.log("Filesystem not available");
                return Promise.resolve();
            }
        },

        setRefreshToken: function(token, noStore) {
            var t = this;
            if (!this.verifyJwt(token)) {
                return new Promise(function (resolve, reject) {
                    clearCookie(COOKIE_REFRESHTOKEN);
                    idb.set("creds", null);
                    localStorage.removeItem("refreshToken");
                    sessionStorage.removeItem("refreshToken");
                    reject("Expired refresh-token");
                });
            } else {
                currentRefreshToken = token;
                return new Promise(function (resolve, reject) {
                    if (!noStore) {
                        try {
                            t._saveCredentials(token);
                        } catch (error) {
                            console.error("Failed to store credentials", error);
                        }
                    }
                    if (!usingSw || keepToken) {
                        console.log("Storing refresh-token as serviceworker is not running");
                        try {
                            var jwt = token ? t.parseJwt(token) : {};
                            if (jwt) {
                                var expiration = jwt.exp ? jwt.exp * SECOND : undefined;
                                var expirationDate = jwt.exp ? new Date(expiration) : null;
                                if (expiration) {
                                    console.log("New refresh-token expires at " + expirationDate);
                                } else {
                                    console.log("New refresh-token has no expiration");
                                }
                                console.log("JWT:", jwt);
                            }
                            if (!usingSw) {
                                cookie(COOKIE_REFRESHTOKEN, token, {
                                    path: "/api/refreshtoken",
                                    expires: expirationDate,
                                    secure: true
                                });
                            }
                            if (!session) {
                                console.log("Storing token in local-storage");
                                if (token) {
                                    localStorage.setItem("refreshToken", token);
                                } else {
                                    localStorage.removeItem("refreshToken");
                                }
                            } else {
                                if (token) {
                                    sessionStorage.setItem("refreshToken", token);
                                } else {
                                    sessionStorage.removeItem("refreshToken");
                                }
                            }
                            resolve();
                        } catch (error) {
                            // nosemgrep: unsafe-formatstring
                            console.warn("Failed to parse refresh-token: " + token, error);
                            reject();
                        }
                    } else {
                        if (session) {
                            if (token) {
                                sessionStorage.setItem("refreshToken", token);
                            } else {
                                sessionStorage.removeItem("refreshToken");
                            }
                            resolve();
                        } else {
                            swcontroller.setRefreshToken(token).then(function () {
                                if (keepToken) {
                                    if (token) {
                                        localStorage.setItem("refreshToken", token);
                                    } else {
                                        localStorage.removeItem("refreshToken");
                                    }
                                }
                                resolve();
                            }, function (err) {
                                console.error("Failed to set refresh-token", err);
                                reject();
                            });
                        }
                        if (!keepToken) {
                            localStorage.removeItem("refreshToken");
                        }
                        cookie(COOKIE_REFRESHTOKEN, '', {
                            path: '/api/refreshtoken',
                            expires: -1,
                            secure: true
                        });
                        clearCookie('accesstoken');
                    }
                });
            }
        },

        getRefreshToken: function(ignoreSession) {
            if (currentRefreshToken) {
                return currentRefreshToken;
            }
            var token = sessionStorage.getItem("refreshToken");
            if  (!token || ignoreSession) {
                token = (usingSw && !keepToken) ? null : localStorage.getItem("refreshToken");
            }
            currentRefreshToken = token;
            return token;
        },

        getAccessToken: function() {
            return accessToken;
        },

        setAccessToken: function(token) {
            try {
                var t = this;
                var now = new Date().getTime();
                jwt = this.parseJwt(token);
                accessToken = token;
                var expiration = now + REFRESH_TOKEN_INTERVAL;
                if (jwt) {
                    if (jwt.exp) {
                        expiration = jwt.exp * SECOND;
                    } else {
                        expiration = null;
                    }

                    if (jwt.vh) {
                        var parts = jwt.vh.split("/");
                        var pui = parts[2];
                        if (!pui) {
                            var uilist = this.getPublicUserInterfaces();
                            if (uilist && uilist.length > 0) {
                                pui = uilist[0];
                            }
                        }
                        vhostData = {
                            host: parts[0],
                            tenant: jwt.tenant,
                            schema: parts[1],
                        };
                        if (pui) {
                            vhostData.ui = pui;
                        }
                        if (tokenRefreshes == 0) {
                            hash(this.getPublicAppPath(), true);
                        }
                        if (jwt.tenant && !this.tenantId) {
                            this.tenantId = jwt.tenant;
                        }
                    }
                    tokenRefreshes++;

                    if (!usingSw) {
                        console.log("Storing access-token in cookie as serviceworker is not present");
                        cookie("accesstoken", token, {
                            path: '/',
                            expires: new Date(expiration),
                            secure: true
                        });
                    }
                    console.log("New accesstoken set");
                }
                if (expiration && token) {
                    console.log("Accesstoken expires at " + new Date(expiration));
                    expiration = (expiration - now);
                } else if (token) {
                    console.log("Accesstoken has no expiration");
                }
                tokenExpiration = expiration;
                if (token && expiration && !preventTokenRefresh) {
                    wasLoggedIn = true;
                    var next = REFRESH_TOKEN_INTERVAL;
                    if (expiration) {
                        next = 0.5005 * expiration;
                    }
                    if (next > DAY) {
                        next = DAY / 2;
                    }
                    if (next < (60 * SECOND)) {
                        next = 60 * SECOND;
                    }
                    if (refreshTimer) {
                        clearInterval(refreshTimer);
                        refreshTimer = null;
                    }
                    refreshTimer = setInterval(function() {
                        t.refreshToken().then(function(ok) {
                            console.log("Token refreshed successfully");
                        });
                    }, next);
                    console.log("Next token-refresh in " + Math.round(next / SECOND) + " seconds (at " + new Date(next + now) + ")");

                    if (jwt.did && !this.applianceTags) {
                        console.log("Loading appliance-tags");
                        this.sendRequest("/api/appliance/" + jwt.did + "/tags").then(function(tags) {
                            t.applianceTags = tags;
                        }, function(error) {
                            console.error("Failed to load appliance-tags", error);
                        });
                    }
                } else if (!token) {
                    console.log("Access-token cleared");
                    wasLoggedIn = false;
                    t.updateState();
                }
            } catch (error) {
                console.error("Failed to set access-token", error);
            }
        },

        sendStatusRequest: function() {
            var t = this;
            var def = new Deferred();
            var statusUrl = this._constructStatusURL();
            var headers = {
                'X-TimeZone': this.getTimeZone(),
                'X-TimeZoneOffset': this.getTimeZoneOffset()
            };
            var jwtToken = this.getAccessToken();
            if (jwtToken) {
                headers[HEADER_AUTHORIZATION] = jwtToken;
            }
            var promise = this.sendRequest(statusUrl, {
                headers: headers
            });
            promise.response.then(function(response) {
                if (response.status == 200) {
                    t.valid = true;
                    t._setUserInfo(response.data);

                    def.resolve(t.user);
                } else {
                    t.valid = false;
                    if (strict) {
                        def.resolve(null);
                    } else {
                        def.reject();
                    }
                }
            }, function(error) {
                def.reject(error);
            });
            return def;
        },

        loadSystemStatus: function() {
            var t = this;
            var def = new Deferred();
            this.sendRequest('/api/status', {
                headers: {
                    'X-TimeZone': this.getTimeZone(),
                    'X-TimeZoneOffset': this.getTimeZoneOffset()
                },
                query: "system"
            }).then(function(response) {
                t._setSystemInfo(response);
                def.resolve();
            }, function(error) {
                def.reject();
            });
            return def;
        },

        requestPublicAccess: function() {
            var t = this;
            var def = new Deferred();
            t.waitForServiceWorker().then(function() {
                t.sendRequest('/request-access', {
                    raw: true
                }).then(function(response) {
                    var rtoken = response.getHeader(HEADER_REFRESHTOKEN);
                    if (rtoken) {
                        console.log("Got refreshtoken for public access");
                        t.setRefreshToken(rtoken).then(function() {
                            t.isSessionValid().then(function() {
                                def.resolve();
                            }, function() {
                                def.reject();
                            })
                        }, function(err) {
                            def.reject(err);
                        });
                    } else {
                        def.reject("Failed to get refresh-token");
                    }
                }, function(error) {
                    console.error("Failed to get public access", error);
                    def.reject();
                });
            });
            return def;
        },

        isSessionValid: function(strict) {
            var t = this;
            var def = new Deferred();
            var path = hash();
            console.log("Waiting for serviceworker");
            idb.get('creds').then(function(creds) {
                if (creds && t.verifyJwt(creds.refreshToken)) {
                    t.setRefreshToken(creds.refreshToken);
                }
                t.waitForServiceWorker().then(function () {
                    console.log("Checking session status");
                    if ('login' != path) {
                        console.log("Checking if session is valid. Current url is " + path);
                        if (!accessToken) {
                            console.log("No access-token present, attempting to refresh...");
                            t.refreshToken(true).then(function (ok) {
                                if (ok) {
                                    console.log("Access-token acquired...");
                                    t.sendStatusRequest().then(function (user) {
                                        def.resolve(user);
                                    }, function (err) {
                                        def.reject(err);
                                    });
                                } else {
                                    def.reject("Not logged in");
                                }
                            }, function (err) {
                                def.reject("Not logged in");
                            });
                        } else {
                            console.log("Checking if session is valid. Current url is " + path);
                            t.sendStatusRequest().then(function (user) {
                                def.resolve(user);
                            }, function (err) {
                                def.reject(err);
                            });
                        }
                    } else {
                        this.valid = false;
                        def.reject("Login Requested");
                    }
                });
            });
            return def;
        },

        isLoggedIn: function() {
            var def = new  Deferred();
            this.isSessionValid(true).then(function(user) {
                def.resolve(user && user.id != ANONYMOUS_ID);
            }, function(error) {
                def.resolve(false);
            });
            return def;
        },

        parseB64Json: function(str) {
            str = this._decodeb64Unicode(str);
            var json = JSON.parse(str);
            return json;
        },

        _decodeb64Unicode: function(str) {
            return decodeURIComponent(Array.prototype.map.call(atob(str), function(c){
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
        },

        _isExpired: function(timestamp) {
            var now = new Date().getTime();
            var exp = this.msToDate(timestamp);
            var expTime = exp ? exp.getTime() : 0;
            return now > expTime;
        },

        parseJwt: function(token, verify) {
            var jwt = null;
            if (token) {
                try {
                    jwt = JSON.parse(this._decodeb64Unicode(token.split('.')[1].replace('-', '+').replace('_', '/')));
                    if (jwt && verify) {
                        if (this._isExpired(jwt.exp)) {
                            jwt = null;
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            }
            return jwt;
        },

        verifyJwt: function(jwt) {
            let ret = jwt;
            if (!this.parseJwt(jwt, true)) {
                ret = null;
            }
            return ret;
        },

        isGuideEnabled: function() {
            var enabled = true;
            if (this.preferences) {
                if (this.preferences.disableGuide != undefined) {
                    enabled = !this.preferences.disableGuide;
                }
            }
            return enabled;
        },

        setWhitelabel: function(wl) {
            this.whitelabel = wl;
        },

        getWhitelabel: function() {
            return this.whitelabel;
        },

        updateUser: function(user) {
            lang.mixin(this.user, user);
            for (var i = 0; i < userObservers.length; i++) {
                var obs = userObservers[i];
                try {
                    console.log("Notifying observer of user-update");
                    obs(this.user);
                } catch (e) {
                    console.error("Failed to update user", e);
                }
            }
        },

        observeUser: function(callback) {
            userObservers.push(callback);
        },

        observeState: function(callback) {
            stateObservers.push(callback);
        },

        observeAccountStats: function(callback) {
            accountStatsObservers.push(callback);
            try {
                callback(this.accountStats);
            } catch (e) {
                console.error("Failed to observe account status", e);
            }
        },

        unObserveAccountStats: function(callback) {
            var index = accountStatsObservers.indexOf(callback);
            if (index !== -1) {
                accountStatsObservers.splice(index, 1);
            }
        },

        updateState: function() {
            var event = {
                loggedIn: loggedIn,
                online: this.isOnline(),
                preventReauth: preventReauth,
                wasLoggedIn: wasLoggedIn
            };
            stateObservers.forEach(function(obs) {
                try {
                    obs(event);
                } catch (error) {
                    console.error("Failed to notify state observer", error);
                }
            });
        },

        updatePreferences: function(preferences) {
            var t = this;
            var url = '/api/app/System/model/user/record/' + this.user.id;

            var newPrefs = lang.mixin({}, this.preferences);
            lang.mixin(newPrefs, preferences);
            var user = lang.clone(this.user);
            user.data = JSON.stringify(newPrefs);

            var promise = this.sendRequest(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify(user)
            });

            var def = new Deferred();
            promise.response.then(function(response) {
                if (response.status == 200) {
                    var data = response.data;
                    t.user = data;
                    if (data.data) {
                        t.preferences = JSON.parse(data.data);
                    }
                    def.resolve(t.user);
                } else {
                    def.reject();
                }
            }, function(error) {
                def.reject(error);
            });
            return def;
        },

        isAnonymous: function() {
            return (this.user && this.user.id == ANONYMOUS_ID) || this.isAnonymousAccess();
        },

        _setUserInfo: function(data) {
            this._cacheStatus(data);
            this._setSystemInfo(data);
            this.user = data.user;
            this.stripeKey = data.config ? data.config.stripeKey : null;
            if (data.user) {
                this.tenantId = this.user.tenant_id;
            }
            if (data.user && data.user.data) {
                this.preferences = JSON.parse(data.user.data);
            } else {
                this.preferences = {};
            }
            platformFeatures = {};
            platformPlan = data.plan;
            if (data.features) {
                for (var i = 0; i < data.features.length; i++) {
                    platformFeatures[data.features[i]] = true;
                }
            }
            this.tenantName = data.tenantName;
            this.tenantShortcode = data.tenantShortcode;
            this.tenantAddress1 = data.tenantAddress1;
            this.tenantAddress1 = data.tenantAddress1;
            this.tenantCity = data.tenantCity;
            this.tenantZipcode = data.tenantZipcode;
            this.tenantCountry = data.tenantCountry;
            this.tenantPhone = data.tenantPhone;
            this.tenantEmail = data.tenantEmail;
            this.tenantDomain = data.tenantDomain;
            this.privileges = data.privileges;
            this.cell = data.cell + '.appivo.com';
            this.cors = data.cors;
            this.publicSchema = data.schema;
            this.browserLanguages = data.browserLang;

            var vhostCookie = sessionStorage.getItem('vhost');
            if (vhostCookie) {
                // Clear vhost-cookie
                clearCookie('vhost');
                sessionStorage.removeItem('vhost');
            }
        },

        _cacheStatus: function(data) {
            var json = JSON.stringify(data);
            localStorage.setItem('system.status', json);
        },

        _getCachedStatus: function() {
            var data = null;
            var str = localStorage.getItem('system.status');
            if (str) {
                data = JSON.parse(str);
            }
            return data;
        },

        _isWindowsPhone: function(){
            return deviceInfo.windows.device;
        },

        setStatusBarStyle: function(opts) {
            var opts = opts || {};
            var style = opts.style;
            var overlay = opts.overlay;
            if (this.isIOS()) {
                if (!this.isHybrid()) {
                    if (!style) {
                        var meta = $('meta[name="apple-mobile-web-app-status-bar-style"]');
                        if (meta) {
                            meta.remove();
                        }
                    } else {
                        var meta = $('meta[name="apple-mobile-web-app-status-bar-style"]');
                        if (meta) {
                            meta.attr('content', style);
                        } else {
                            meta = document.createElement('meta');
                            meta.name = 'apple-mobile-web-app-status-bar-style';
                            meta.content = style
                            document.getElementsByTagName('head')[0].appendChild(meta);					}
                    }
                } else if (window.StatusBar) {
                    if (style) {
                        var meta = $('meta[name="apple-mobile-web-app-status-bar-style"]');
                        if (meta) {
                            meta.remove();
                        }

                        try {
                            switch (style) {
                                case 'black-translucent':
                                    try {
                                        window.StatusBar.styleBlackTranslucent();
                                    } catch (error) {
                                        if (cordova.platformId == 'android') {
                                            window.StatusBar.overlaysWebView(true);
                                            window.StatusBar.backgroundColorByHexString('#33000000');
                                        } else {
                                            window.StatusBar.backgroundColorByName("black");
                                        }
                                    }
                                    break;
                                case 'default':
                                    window.StatusBar.styleDefault();
                                    break;
                                case 'black-opaque':
                                    try {
                                        window.StatusBar.styleBlackOpaque();
                                    } catch (error) {
                                        window.StatusBar.backgroundColorByName("black");
                                    }
                                    break;
                                case 'light-content':
                                    window.StatusBar.styleLightContent();
                                    break;
                            }
                            if (overlay !== undefined) {
                                window.StatusBar.overlaysWebView(overlay);
                            }
                        } catch(error) {
                            console.error("Failed to set statusbar-properties", error);
                        }
                    }
                }
            }
        },

        getPublicSchema: function() {
            return this.publicSchema;
        },

        validateEmail: function(email) {
            //var pm = this.getPageManager;
            if (email == "" || email == null){
                alertify.alert('appivo', messages.email_mandatory);
                return false;
            }
            if (email != null && !email.includes("@")){
                alertify.alert('appivo', messages.valid_email);
                return false;
            }
            return true;
        },

        resetPassword: function(email, tenant) {
            if (this.validateEmail(email)){
                if (!tenant) {
                    tenant = this.getTenantId();
                }
                var request = {
                    user: email,
                    tenant: tenant
                };

                var def = this.sendRequest('/api/resetPassword', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: JSON.stringify(request)
                });
                return def;
            } else {
                var def = new Deferred();
                def.reject("Invalid email address " + email);
                return def;
            }
        },

        resetCurrentView: function() {
            localStorage.removeItem('appshift.viewPos');
        },

        waitForServiceWorker: function() {
            return workerReady;
        },

        callAgent: function(agent, args, opts) {
            const data = {
                agent : agent,
                arguments: args,
                history: opts ? opts.history : undefined
            };
            Object.assign(data, opts);
            const headers = {
                'Content-Type': 'application/json'
            };
            if (opts && opts.app) {
                headers['x-app-id'] = opts.app;
            }
            return this.sendRequest('/api/ai', {
                method: 'POST',
                headers: headers,
                handleAs: 'json',
                data
            });
        },

        login: function(email, password, code, remember, tenantId, path, app, options) {
            var usingStored = false;
            var authToken = '';
            if (remember === undefined || remember === null) {
                remember = this.isHybrid();
            }
            var login = {
                user: email,
                password: password,
                remember: remember,
                code: code,
                type: this.isMobile() ? (this.isHybrid() ? 'hybrid' : 'mobile') : 'web',
                options: options
            };

            if (!workerSupport) {
                if (!login.options) {
                    login.options = {};
                }
                login.options.legacy = true;
                console.log("legacy login, using cookie");
            }

            // Login to locked tenant, if there is one
            var tid = this.getTenantId();
            if (tid) {
                login['tenant'] = tid;
            } else if (tenantId !== undefined) {
                login['tenant'] = tenantId;
            }

            var t = this;
            var def = new Deferred();
            console.log("Waiting for serviceworker to become active");
            t.waitForServiceWorker().then(function() {
                t.registerPageView('login');
                var headers = {
                    'Content-Type': 'application/json',
                    'X-TimeZoneOffset': t.getTimeZoneOffset(),
                    'X-TimeZone': t.getTimeZone()
                };
                if (app) {
                    headers['x-app'] = app;
                }
                var promise = t.sendRequest("/api/login", {
                    method: 'POST',
                    ignoreSession: true,
                    headers: headers,
                    data: JSON.stringify(login)
                });

                t.redirect = undefined;
                promise.response.then(function (response) {
                    t.stopImpersonation();
                    var data = response.data
                    if (response.status == 200) {
                        t.setPreventReauth(false);
                        t._setUserInfo(data);
                        sessionStorage.removeItem("refreshToken");
                        sessionStorage.removeItem("session");
                        session = false;
                        var jwt = response.getHeader(HEADER_AUTHORIZATION);
                        if (jwt) {
                            t.setAccessToken(jwt);
                        }
                        if (!usingSw || keepToken) {
                            var rtoken = response.getHeader(HEADER_REFRESHTOKEN);
                            if (rtoken) {
                                t.setRefreshToken(rtoken);
                            }
                        }

                        if (t.isMobile()) {
                            if (window.location.pathname.indexOf('/h/') == 0 || window.location.pathname.indexOf('/h-public/') == 0) {
                                t.registerDevice();
                            }
                        }
                        loggedIn = true;
                        t.updateState();

                        var chash = window.location.hash;
                        if (data.redirect) {
                            t.redirect = data.redirect;
                        } else if (t.isHybrid()) {
                            if (!chash.match("#/app/.+")) {
                                var schema = t.getAppProperty('schema');
                                if (schema) {
                                    var hash = '#/app/' + schema;
                                    var ui = t.getAppProperty('ui');
                                    if (ui) {
                                        hash += "/" + ui;
                                    }
                                    // REMIND: Check if hash starts with app-path ?
                                    if (chash != hash) {
                                        window.location.hash = hash;
                                    }
                                }
                            }
                        } else if (path) {
                            var phash = '#/app/';
                            if (path.app) {
                                phash += path.app;
                                if (path.ui) {
                                    phash += '/' + path.ui;
                                    if (path.view) {
                                        phash += '/' + path.view;
                                        if (path.record) {
                                            phash += '/' + path.record
                                        }
                                    }
                                }
                                if (chash != phash) {
                                    window.location.hash = phash;
                                }
                            }
                        }

                        setTimeout(function () {
                            def.resolve(t.user);
                        }, 1);
                    } else {
                        if (usingStored) {
                            //t._removeCredentials();
                            t.clearTokens();
                        }
                        def.reject(data.error);
                    }
                }, function (error) {
                    def.reject(error);
                });
            });
            return def;
        },

        _setSystemInfo: function(data) {
            originCity = data.city;
            originCountry = data.country;
            this.cors = data.cors;
            this.browserLanguages = data.browserLang;
            this.stripeKey = data.config ? data.config.stripeKey : null;
        },

        refreshToken: function(force) {
            var t = this;
            try {
                if (this.isOffline()) {
                    console.log("Skipping token-refresh as client is offline");
                    var def = new Deferred();
                    def.resolve(true);
                    return def;
                }
                var now = new Date().getTime() ;
                if (force || (!lastRefresh || lastRefresh < (now - REFRESH_TOKEN_INTERVAL))) {
                    console.log("Refreshing access-token...");
                    var headers = {
                        'X-TimeZoneOffset': this.getTimeZoneOffset(),
                        'X-TimeZone': this.getTimeZone()
                    };
                    var refreshToken = this.getRefreshToken();
                    if (refreshToken) {
                        headers[HEADER_REFRESHTOKEN] = refreshToken;
                    }

                    var promise = this.sendRequest("/api/refreshtoken", {
                        method: 'GET',
                        handleAs: 'json',
                        headers: headers
                    });

                    return promise.response.then(function(response) {
                        var status = response.status;
                        var st = Math.round(status / 100);
                        if (st == 2) {
                            loggedIn = true;
                            lastRefresh = now;
                            var data = response.data;
                            t.setAccessToken(data.token, data.expiration);
                            if (!usingSw) {
                                t.setRefreshToken(data.refreshToken);
                            }
                            console.log("Access-token refreshed!");
                            t.updateState();
                            return true;
                        } else if (st == 4) {
                            loggedIn = false;
                            console.log("Failed to get new access-token");
                            t.updateState();
                            return false;
                        } else {
                            console.error("Failed to get new access-token: " + response.status);
                            return false;
                        }
                    }, function(response) {
                        var status = response.response.status;
                        var st = Math.round(status / 100);
                        if (st == 4) {
                            loggedIn = false;
                            var msg = response.error ? response.error.error ? response.error.error : response.error : "Failed to get new access-token";
                            console.log(msg);
                            t.updateState();
                            return false;
                        } else {
                            // nosemgrep: unsafe-formatstring
                            console.error("Failed to get new access-token: " + status, response);
                            return false;
                        }
                    });
                } else {
                    console.log("Access-token was refreshed less than five minutes ago, skipping.");
                    var def = new Deferred();
                    def.resolve(false);
                    return def;
                }
            } catch (error) {
                console.error("Failed to refresh access-token", error);
                var def = new Deferred();
                def.reject(error);
                return def;
            }
        },

        hasRedirect: function() {
            return !!this.redirect;
        },

        doRedirect: function() {
            if (this.redirect) {
                window.location = this.redirect;
                this.redirect = undefined;
            }
        },

        getTenantId: function() {
            var tid = this.tenantId;
            var tenantLocked = this.getAppProperty("tenantLocked");
            var appTenant = this.getAppProperty('tenantId');
            if (tenantLocked) {
                tid = appTenant;
            } else if (this.isPublicApp()) {
                tid = undefined;
            }
            return (this.impersonatedTenant && this.impersonationToken) ? this.impersonatedTenant.id : tid;
        },

        getTenantName: function() {
            return (this.impersonatedTenant && this.impersonationToken) ? this.impersonatedTenant.name : this.tenantName;
        },

        getTenantShortcode: function() {
            return (this.impersonatedTenant && this.impersonationToken) ? this.impersonatedTenant.shortname : this.tenantShortcode;
        },

        getTenantDomain: function() {
            return this.tenantDomain;
        },

        getTenantInfo: function() {
            return {
                name: this.tenantName,
                address1: this.tenantAddress1,
                address2: this.tenantAddress2,
                city: this.tenantCity,
                zipcode: this.tenantZipcode,
                country: this.tenantCountry,
                phone: this.tenantPhone,
                email: this.tenantEmail
            };
        },

        getPublicContext: function() {
            var def = new Deferred();
            if (!publicContext) {
                if (this.tenantId) {
                    this.sendRequest("/public-context?tenant=" + this.tenantId).then(function(data) {
                        publicContext = data;
                        def.resolve(publicContext);
                    }, function(error) {
                        def.reject(error);
                    });
                } else {
                    def.resolve(null);
                }
            } else {
                def.resolve(publicContext);
            }
            return def;
        },

        getUser: function() {
            return this.user;
        },

        getServerInfo: function() {
            return this.server;
        },

        getCell: function() {
            return this.cell;
        },

        getAccountStats: function() {
            return this.accountStats;
        },

        reloadAccountStats: function() {
            var t = this;
            this.sendRequest("/api/accountstats").then(function(res) {
                t.accountStats = res;
                accountStatsObservers.forEach(function(obs) {
                    try {
                        obs(t.accountStats);
                    } catch (error) {
                        console.error("Failed to notify account-status observer", error);
                    }
                });
            }, function(error) {
                console.error("Failed to get account status", error);
            });
        },

        hasPlatformFeature: function(feature) {
            return !!platformFeatures[feature];
        },

        getPlan: function() {
            return platformPlan;
        },

        hasPrivilege: function(model, privilege) {
            var has = false;
            if (this.privileges) {
                var mprivs = this.privileges[model];
                if (mprivs) {
                    has = mprivs[privilege];
                }
            }
            return has;
        },

        getDomain: function() {
            var url = this.getURI();
            var domain;

            //find & remove protocol (http, ftp, etc.) and get domain
            if (url.indexOf("://") > -1) {
                domain = url.split('/')[2];
            }
            else {
                domain = url.split('/')[0];
            }

            //find & remove port number
            domain = domain.split(':')[0];

            return domain;
        },

        getURI: function(url, protocol) {
            var target;
            var host = this.cors ? this.cell : location.hostname;
            if (url) {
                if (url.indexOf('http://') == 0 || url.indexOf('https://') == 0) {
                    return url;
                }
                if (url.indexOf('/') == 0) {
                    url = url.substring(1);
                }
            } else {
                url = "";
            }

            if (window.cordova) {
                if (this.cell) {
                    // REMIND: replace host
                }
            }

            var proto = location.protocol;
            if (protocol == 'ws') {
                switch (proto) {
                    case 'http:':
                        proto = 'ws:';
                        break;
                    case 'https:':
                        proto = 'wss:';
                        break;
                }
            }

            target = proto + '//' + host;
            if (location.port) {
                target += ':' + location.port;
            }
            target += '/' + url;

            return target;
        },

        getTimeZoneOffset: function() {
            var dtDate = new Date('1/1/' + (new Date()).getUTCFullYear());
            var intOffset = 10000; //set initial offset high so it is adjusted on the first attempt
            var intMonth;
            var intHoursUtc;
            var intHours;
            var intDaysMultiplyBy;

            //go through each month to find the lowest offset to account for DST
            for (intMonth=0;intMonth < 12;intMonth++){
                //go to the next month
                dtDate.setUTCMonth(dtDate.getUTCMonth() + 1);

                //To ignore daylight saving time look for the lowest offset.
                //Since, during DST, the clock moves forward, it'll be a bigger number.
                if (intOffset > (dtDate.getTimezoneOffset() * (-1))){
                    intOffset = (dtDate.getTimezoneOffset() * (-1));
                }
            }

            return intOffset;
        },

        getTimeZone: function() {
            return moment.tz.guess();
        },

        setAppConfig: function(config) {
            if (!config) {
                config = {};
            }
            this.appConfig = config;
        },

        setAppDomain: function(domain) {
            if (!domain) {
                appDomain = {};
            }  else {
                appDomain = domain;
            }
        },

        getAppDomain: function() {
            return appDomain;
        },

        getAppConfig: function() {
            return this.appConfig ? this.appConfig : {};
        },

        copyFile: function(opts) {
            return this.sendRequest('/files/',{
                method: 'POST',
                handleAs: 'json',
                headers: {
                    'Content-Type': 'application/appivo-copyrequest'
                },
                data: {
                    url: opts.url,
                    filename: opts.filename,
                    headers: opts.headers
                }
            });
        },

        invokeService: function(opts) {
            var service = opts;
            if (lang.isObject(opts)) {
                service = opts.service;
                timeout = opts.timeout;
            }
            var timeout = null;
            if (lang.isObject(opts)) {
                timeout = opts.timeout;
            }
            var args = [];
            if (arguments.length > 1) {
                for (var i = 1; i < arguments.length; i++) {
                    args.push(arguments[i]);
                }
            }
            var headers = {};
            if (timeout) {
                headers['X-Timeout'] = timeout;
            }
            var opts = {
                method: 'POST',
                headers: headers,
                handleAs: 'json',
                data: args
            };
            return this.sendRequest("/api/service/" + service, opts);
        },

        uploadFile: function(file, options) {
            var options = options || {};
            var headers = {};
            if (options.filename) {
                headers['X-Filename'] = options.filename;
            }
            if (options.contentType) {
                headers['Content-Type'] = options.contentType;
            }
            return this.sendRequest("/files/", {
                data: file,
                method: 'POST',
                headers: headers,
                contentType: options.contentType
            });
        },

        sendRequest: function(url, options) {
            var t = this;
            var allowOffline = true;
            if (options && options.storageMode) {
                if (options.storageMode === "cloud") {
                    allowOffline = false;
                }
            }
            if (!options) {
                options = {
                    method: 'GET',
                    handleAs: 'json'
                };
            } else {
                if (!options.method) {
                    options.method = 'GET';
                }
            }

            if (!options.handleAs) {
                options.handleAs = 'json';
                if (options.data) {
                    if (options.data instanceof Blob) {
                        //options.handleAs = 'blob';
                    }
                }
            }

            if (options.handleAs == 'json' && options.data && lang.isObject(options.data)) {
                if (!(options.data instanceof Blob)) {
                    options.data = JSON.stringify(options.data);
                }
            }
            if (this.cors || options.cors) {
                options.withCredentials = true;
            }
            if (!options.headers) {
                options.headers = {};
            }
            if (options.contentType) {
                options.headers[HEADER_CONTENTTYPE] = options.contentType;
            }
            var contentTypeSet = findHeader(options.headers, HEADER_CONTENTTYPE);
            if (!contentTypeSet && (options.method == 'POST' || options.method == 'PUT' || options.method == 'DELETE')) {
                options.headers[HEADER_CONTENTTYPE] = "application/json";
            }
            if (session && !options.ignoreSession) {
                options.headers[HEADER_SESSION] = "Yes";
            }
            options.headers[HEADER_CLIENT_ID] = clientId;

            var jwt = this.getAccessToken();
            if (jwt) {
                options.headers[HEADER_AUTHORIZATION] = jwt;
            }

            if (allowOffline && ((this.isOffline() || (offlineMode === "OFFLINE" || options.offline)) && !options.online)) {
                options.headers[HEADER_OFFLINE] = "yes";
            }

            var errorHandler = options.onError;
            options.onError = function(error) {
                if (error.response && error.response.data && error.response.data.errorMessage) {
                    error.message = error.response.data.errorMessage;
                }
                error.error = error.response.data;
                if (errorHandler) {
                    errorHandler(error);
                }
            };
            var uriComplete = options.uriComplete;
            delete options['uriComplete'];
            var uri = uriComplete ? url : this.getURI(url);

            if (options.raw) {
                var def = xhr(uri, options, options.returnDeferred);
                def.response.then(function (response) {
                    if (options.onSuccessResponse) {
                        options.onSuccessResponse(response);
                    }
                });

                def.then(function (res) {
                    if (options.onSuccess) {
                        options.onSuccess(res);
                    }
                }, function (error) {
                    if (options.onError) {
                        options.onError(error);
                    }
                });
                return def.response;
            } else {
                var backoff = 500;
                var def = new Deferred();
                def.response = new Deferred();
                this._doSendRequest(uri, options, def, 0, backoff);
                def.response.then(function (response) {
                    if (options.onSuccessResponse) {
                        options.onSuccessResponse(response);
                    }
                });
                def.then(function (res) {
                    if (options.onSuccess) {
                        options.onSuccess(res);
                    }
                }, function (error) {
                    if (options.onError) {
                        options.onError(error);
                    }
                });
                return def;
            }
        },

        _doSendRequest: function(uri, options, xdef, attempt, backoff) {
            var t = this;
            var def = xhr(uri, options, options.returnDeferred);
            def.then(function(data) {
                xdef.resolve(data);
            }, function(error) {
                if (error.response && error.response.status < 100) {
                    console.log("Request #" + attempt + " failed with status " + def.response.status);
                    if (++attempt < 3) {
                        console.log("Retrying in " + backoff + "ms");
                        setTimeout(function() {
                            t._doSendRequest(uri, options, xdef, attempt, backoff * 2);
                        }, backoff);
                    } else {
                        console.log("Failed after " + attempt + " attempts");
                        if (t.isOffline()) {
                            var err = new Error("A network error occured. You seem to have no internet connectivity.");
                            err.response = error.response;
                            xdef.reject(err);
                        } else {
                            var err = new Error("Failure to communicate with cloud servers. Either you are not connected to the internet or there is a temporary problem. Please try again later.")
                            err.response = error.response;
                            xdef.reject(error);
                        }
                    }
                } else {
                    xdef.reject(error);
                }
            });
            xdef.response = def.response;
            return def;
        },

        clearTokens: function() {
            this.setAccessToken(null);
            this.setRefreshToken(null);

            cookie('accesstoken', '', {
                path: '/',
                expires: 'Thu, 01-Jan-70 00:00:01 GMT'
            });

            if (swcontroller) {
                swcontroller.logout();
            }
        },

        logout: function() {
            var t = this;
            console.log("logout invoked");
            var def = new Deferred();
            this.valid = false;
            wasLoggedIn = false;
            if (refreshTimer) {
                clearInterval(refreshTimer);
            }
            var doLogout = function () {
                t.setRefreshToken(null);
                console.log("Sending logout request");
                return t.sendRequest("/api/login", {
                    method: 'DELETE'
                }).response.then(function (response) {
                    var data = response.data;
                    if (response.status == 200) {
                        console.log("Successfully logged out");
                        t.stopImpersonation();
                        //t._removeCredentials();
                        t._setUserInfo({});
                        t.clearTokens();
                        def.resolve();
                    } else {
                        console.log("Logout failed - responsecode " + response.status);
                        def.reject("Logout failed - " + response.status);
                    }
                }, function (error) {
                    console.error("Logout failed", error);
                    def.reject("Logout failed");
                });
            };

            if (this.isHybrid()) {
                console.log("logging out from hybridapp");
                this.unregisterDevice().then(function () {
                    doLogout();
                }, function () {
                    doLogout();
                });
            } else {
                doLogout();
            }
            return def;
        },

        getLoginUrl: function() {
            var url = "/";
            if (this.isHybrid()) {
                url += "h/";
            } else if (this.isMobile()) {
                url += "m/";
            }
            var config = this.getHybridAppMetaData();
            if (config && config.vhost) {
                if (this.isHybrid()) {
                    url = "/h-public/";
                } else if (this.isMobile()) {
                    url = "/m-public/";
                } else {
                    url = "/public/";
                }
                url += config.vhost;
            } else if (this.whitelabel) {
                url += '#/';
                if (this.whitelabel.app) {
                    url += "a/" + this.whitelabel.app;
                }
                if (this.whitelabel.tenant) {
                    if (!url.endsWith('/')) {
                        url += '/';
                    }
                    url += "t/" + this.whitelabel.tenant;
                }
            } else if (config && config.app) {
                url += '#/a/' + config.app;
                if (config.tenantLocked && config.tenantId) {
                    url += "/t/" + config.tenantId;
                }
            }
            return url;
        },

        setPassword: function(secret, password) {
            var _this = this;
            var def = new Deferred();
            var data = {
                secret: secret,
                password: password
            };
            var promise = this.sendRequest("/api/setPassword", {
                method: 'POST' ,
                headers: {
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify(data)
            });

            promise.response.then(function(response) {
                var data = response.data;
                if (response.status == 200) {
                    def.resolve(data);
                } else {
                    def.reject(data.error);
                }
            }, function(error) {
                def.reject(error);
            });
            return def;
        }

    });

    clss.getInstance = function() {
        if (clss._instance == null) {
            clss._instance = new clss();
            File._client = clss._instance;
        }
        return clss._instance;
    };

    return clss;
});
},
'dojo/_base/declare':function(){
define(["./kernel", "../has", "./lang"], function(dojo, has, lang){
	// module:
	//		dojo/_base/declare

	var mix = lang.mixin, op = Object.prototype, opts = op.toString,
		xtor, counter = 0, cname = "constructor";

	if(!has("csp-restrictions")){
		// 'new Function()' is preferable when available since it does not create a closure
		xtor = new Function;
	}else{
		xtor = function(){};
	}

	function err(msg, cls){ throw new Error("declare" + (cls ? " " + cls : "") + ": " + msg); }

	// C3 Method Resolution Order (see http://www.python.org/download/releases/2.3/mro/)
	function c3mro(bases, className){
		var result = [], roots = [{cls: 0, refs: []}], nameMap = {}, clsCount = 1,
			l = bases.length, i = 0, j, lin, base, top, proto, rec, name, refs;

		// build a list of bases naming them if needed
		for(; i < l; ++i){
			base = bases[i];
			if(!base){
				err("mixin #" + i + " is unknown. Did you use dojo.require to pull it in?", className);
			}else if(opts.call(base) != "[object Function]"){
				err("mixin #" + i + " is not a callable constructor.", className);
			}
			lin = base._meta ? base._meta.bases : [base];
			top = 0;
			// add bases to the name map
			for(j = lin.length - 1; j >= 0; --j){
				proto = lin[j].prototype;
				if(!proto.hasOwnProperty("declaredClass")){
					proto.declaredClass = "uniqName_" + (counter++);
				}
				name = proto.declaredClass;
				if(!nameMap.hasOwnProperty(name)){
					nameMap[name] = {count: 0, refs: [], cls: lin[j]};
					++clsCount;
				}
				rec = nameMap[name];
				if(top && top !== rec){
					rec.refs.push(top);
					++top.count;
				}
				top = rec;
			}
			++top.count;
			roots[0].refs.push(top);
		}

		// remove classes without external references recursively
		while(roots.length){
			top = roots.pop();
			result.push(top.cls);
			--clsCount;
			// optimization: follow a single-linked chain
			while(refs = top.refs, refs.length == 1){
				top = refs[0];
				if(!top || --top.count){
					// branch or end of chain => do not end to roots
					top = 0;
					break;
				}
				result.push(top.cls);
				--clsCount;
			}
			if(top){
				// branch
				for(i = 0, l = refs.length; i < l; ++i){
					top = refs[i];
					if(!--top.count){
						roots.push(top);
					}
				}
			}
		}
		if(clsCount){
			err("can't build consistent linearization", className);
		}

		// calculate the superclass offset
		base = bases[0];
		result[0] = base ?
			base._meta && base === result[result.length - base._meta.bases.length] ?
				base._meta.bases.length : 1 : 0;

		return result;
	}

	function inherited(args, a, f, g){
		var name, chains, bases, caller, meta, base, proto, opf, pos,
			cache = this._inherited = this._inherited || {};

		// crack arguments
		if(typeof args === "string"){
			name = args;
			args = a;
			a = f;
			f = g;
		}

		if(typeof args === "function"){
			// support strict mode
			caller = args;
			args = a;
			a = f;
		}else{
			try{
				caller = args.callee;
			}catch (e){
				if(e instanceof TypeError){
					// caller was defined in a strict-mode context
					err("strict mode inherited() requires the caller function to be passed before arguments", this.declaredClass);
				}else{
					throw e;
				}
			}
		}

		name = name || caller.nom;
		if(!name){
			err("can't deduce a name to call inherited()", this.declaredClass);
		}
		f = g = 0;

		meta = this.constructor._meta;
		bases = meta.bases;

		pos = cache.p;
		if(name != cname){
			// method
			if(cache.c !== caller){
				// cache bust
				pos = 0;
				base = bases[0];
				meta = base._meta;
				if(meta.hidden[name] !== caller){
					// error detection
					chains = meta.chains;
					if(chains && typeof chains[name] == "string"){
						err("calling chained method with inherited: " + name, this.declaredClass);
					}
					// find caller
					do{
						meta = base._meta;
						proto = base.prototype;
						if(meta && (proto[name] === caller && proto.hasOwnProperty(name) || meta.hidden[name] === caller)){
							break;
						}
					}while(base = bases[++pos]); // intentional assignment
					pos = base ? pos : -1;
				}
			}
			// find next
			base = bases[++pos];
			if(base){
				proto = base.prototype;
				if(base._meta && proto.hasOwnProperty(name)){
					f = proto[name];
				}else{
					opf = op[name];
					do{
						proto = base.prototype;
						f = proto[name];
						if(f && (base._meta ? proto.hasOwnProperty(name) : f !== opf)){
							break;
						}
					}while(base = bases[++pos]); // intentional assignment
				}
			}
			f = base && f || op[name];
		}else{
			// constructor
			if(cache.c !== caller){
				// cache bust
				pos = 0;
				meta = bases[0]._meta;
				if(meta && meta.ctor !== caller){
					// error detection
					chains = meta.chains;
					if(!chains || chains.constructor !== "manual"){
						err("calling chained constructor with inherited", this.declaredClass);
					}
					// find caller
					while(base = bases[++pos]){ // intentional assignment
						meta = base._meta;
						if(meta && meta.ctor === caller){
							break;
						}
					}
					pos = base ? pos : -1;
				}
			}
			// find next
			while(base = bases[++pos]){	// intentional assignment
				meta = base._meta;
				f = meta ? meta.ctor : base;
				if(f){
					break;
				}
			}
			f = base && f;
		}

		// cache the found super method
		cache.c = f;
		cache.p = pos;

		// now we have the result
		if(f){
			return a === true ? f : f.apply(this, a || args);
		}
		// intentionally no return if a super method was not found
	}

	function getInherited(name, args, a){
		if(typeof name === "string"){
			if (typeof args === "function") {
				return this.__inherited(name, args, a, true);
			}
			return this.__inherited(name, args, true);
		}
		else if (typeof name === "function") {
			return this.__inherited(name, args, true);
		}
		return this.__inherited(name, true);
	}

	function inherited__debug(args, a1, a2, a3){
		var f = this.getInherited(args, a1, a2);
		if(f){
			return f.apply(this, a3 || a2 || a1 || args);
		}
		// intentionally no return if a super method was not found
	}

	var inheritedImpl = dojo.config.isDebug ? inherited__debug : inherited;

	// emulation of "instanceof"
	function isInstanceOf(cls){
		var bases = this.constructor._meta.bases;
		for(var i = 0, l = bases.length; i < l; ++i){
			if(bases[i] === cls){
				return true;
			}
		}
		return this instanceof cls;
	}

	function mixOwn(target, source){
		// add props adding metadata for incoming functions skipping a constructor
		for(var name in source){
			if(name != cname && source.hasOwnProperty(name)){
				target[name] = source[name];
			}
		}
		if(has("bug-for-in-skips-shadowed")){
			for(var extraNames= lang._extraNames, i= extraNames.length; i;){
				name = extraNames[--i];
				if(name != cname && source.hasOwnProperty(name)){
					  target[name] = source[name];
				}
			}
		}
	}

	// implementation of safe mixin function
	function safeMixin(target, source){
		// summary:
		//		Mix in properties skipping a constructor and decorating functions
		//		like it is done by declare().
		// target: Object
		//		Target object to accept new properties.
		// source: Object
		//		Source object for new properties.
		// description:
		//		This function is used to mix in properties like lang.mixin does,
		//		but it skips a constructor property and decorates functions like
		//		declare() does.
		//
		//		It is meant to be used with classes and objects produced with
		//		declare. Functions mixed in with dojo.safeMixin can use
		//		this.inherited() like normal methods.
		//
		//		This function is used to implement extend() method of a constructor
		//		produced with declare().
		//
		// example:
		//	|	var A = declare(null, {
		//	|		m1: function(){
		//	|			console.log("A.m1");
		//	|		},
		//	|		m2: function(){
		//	|			console.log("A.m2");
		//	|		}
		//	|	});
		//	|	var B = declare(A, {
		//	|		m1: function(){
		//	|			this.inherited(arguments);
		//	|			console.log("B.m1");
		//	|		}
		//	|	});
		//	|	B.extend({
		//	|		m2: function(){
		//	|			this.inherited(arguments);
		//	|			console.log("B.m2");
		//	|		}
		//	|	});
		//	|	var x = new B();
		//	|	dojo.safeMixin(x, {
		//	|		m1: function(){
		//	|			this.inherited(arguments);
		//	|			console.log("X.m1");
		//	|		},
		//	|		m2: function(){
		//	|			this.inherited(arguments);
		//	|			console.log("X.m2");
		//	|		}
		//	|	});
		//	|	x.m2();
		//	|	// prints:
		//	|	// A.m1
		//	|	// B.m1
		//	|	// X.m1

		var name, t;
		// add props adding metadata for incoming functions skipping a constructor
		for(name in source){
			t = source[name];
			if((t !== op[name] || !(name in op)) && name != cname){
				if(opts.call(t) == "[object Function]"){
					// non-trivial function method => attach its name
					t.nom = name;
				}
				target[name] = t;
			}
		}
		if(has("bug-for-in-skips-shadowed") && source){
			for(var extraNames= lang._extraNames, i= extraNames.length; i;){
				name = extraNames[--i];
				t = source[name];
				if((t !== op[name] || !(name in op)) && name != cname){
					if(opts.call(t) == "[object Function]"){
						// non-trivial function method => attach its name
						  t.nom = name;
					}
					target[name] = t;
				}
			}
		}
		return target;
	}

	function extend(source){
		declare.safeMixin(this.prototype, source);
		return this;
	}

	function createSubclass(mixins, props){
		// crack parameters
		if(!(mixins instanceof Array || typeof mixins === 'function')){
			props = mixins;
			mixins = undefined;
		}

		props = props || {};
		mixins = mixins || [];

		return declare([this].concat(mixins), props);
	}

	// chained constructor compatible with the legacy declare()
	function chainedConstructor(bases, ctorSpecial){
		return function(){
			var a = arguments, args = a, a0 = a[0], f, i, m,
				l = bases.length, preArgs;

			if(!(this instanceof a.callee)){
				// not called via new, so force it
				return applyNew(a);
			}

			//this._inherited = {};
			// perform the shaman's rituals of the original declare()
			// 1) call two types of the preamble
			if(ctorSpecial && (a0 && a0.preamble || this.preamble)){
				// full blown ritual
				preArgs = new Array(bases.length);
				// prepare parameters
				preArgs[0] = a;
				for(i = 0;;){
					// process the preamble of the 1st argument
					a0 = a[0];
					if(a0){
						f = a0.preamble;
						if(f){
							a = f.apply(this, a) || a;
						}
					}
					// process the preamble of this class
					f = bases[i].prototype;
					f = f.hasOwnProperty("preamble") && f.preamble;
					if(f){
						a = f.apply(this, a) || a;
					}
					// one peculiarity of the preamble:
					// it is called if it is not needed,
					// e.g., there is no constructor to call
					// let's watch for the last constructor
					// (see ticket #9795)
					if(++i == l){
						break;
					}
					preArgs[i] = a;
				}
			}
			// 2) call all non-trivial constructors using prepared arguments
			for(i = l - 1; i >= 0; --i){
				f = bases[i];
				m = f._meta;
				f = m ? m.ctor : f;
				if(f){
					f.apply(this, preArgs ? preArgs[i] : a);
				}
			}
			// 3) continue the original ritual: call the postscript
			f = this.postscript;
			if(f){
				f.apply(this, args);
			}
		};
	}


	// chained constructor compatible with the legacy declare()
	function singleConstructor(ctor, ctorSpecial){
		return function(){
			var a = arguments, t = a, a0 = a[0], f;

			if(!(this instanceof a.callee)){
				// not called via new, so force it
				return applyNew(a);
			}

			//this._inherited = {};
			// perform the shaman's rituals of the original declare()
			// 1) call two types of the preamble
			if(ctorSpecial){
				// full blown ritual
				if(a0){
					// process the preamble of the 1st argument
					f = a0.preamble;
					if(f){
						t = f.apply(this, t) || t;
					}
				}
				f = this.preamble;
				if(f){
					// process the preamble of this class
					f.apply(this, t);
					// one peculiarity of the preamble:
					// it is called even if it is not needed,
					// e.g., there is no constructor to call
					// let's watch for the last constructor
					// (see ticket #9795)
				}
			}
			// 2) call a constructor
			if(ctor){
				ctor.apply(this, a);
			}
			// 3) continue the original ritual: call the postscript
			f = this.postscript;
			if(f){
				f.apply(this, a);
			}
		};
	}

	// plain vanilla constructor (can use inherited() to call its base constructor)
	function simpleConstructor(bases){
		return function(){
			var a = arguments, i = 0, f, m;

			if(!(this instanceof a.callee)){
				// not called via new, so force it
				return applyNew(a);
			}

			//this._inherited = {};
			// perform the shaman's rituals of the original declare()
			// 1) do not call the preamble
			// 2) call the top constructor (it can use this.inherited())
			for(; f = bases[i]; ++i){ // intentional assignment
				m = f._meta;
				f = m ? m.ctor : f;
				if(f){
					f.apply(this, a);
					break;
				}
			}
			// 3) call the postscript
			f = this.postscript;
			if(f){
				f.apply(this, a);
			}
		};
	}

	function chain(name, bases, reversed){
		return function(){
			var b, m, f, i = 0, step = 1;
			if(reversed){
				i = bases.length - 1;
				step = -1;
			}
			for(; b = bases[i]; i += step){ // intentional assignment
				m = b._meta;
				f = (m ? m.hidden : b.prototype)[name];
				if(f){
					f.apply(this, arguments);
				}
			}
		};
	}

	// forceNew(ctor)
	// return a new object that inherits from ctor.prototype but
	// without actually running ctor on the object.
	function forceNew(ctor){
		// create object with correct prototype using a do-nothing
		// constructor
		xtor.prototype = ctor.prototype;
		var t = new xtor;
		xtor.prototype = null;	// clean up
		return t;
	}

	// applyNew(args)
	// just like 'new ctor()' except that the constructor and its arguments come
	// from args, which must be an array or an arguments object
	function applyNew(args){
		// create an object with ctor's prototype but without
		// calling ctor on it.
		var ctor = args.callee, t = forceNew(ctor);
		// execute the real constructor on the new object
		ctor.apply(t, args);
		return t;
	}

	function declare(className, superclass, props){
		// summary:
		//		Create a feature-rich constructor from compact notation.
		// className: String?
		//		The optional name of the constructor (loosely, a "class")
		//		stored in the "declaredClass" property in the created prototype.
		//		It will be used as a global name for a created constructor.
		// superclass: Function|Function[]
		//		May be null, a Function, or an Array of Functions. This argument
		//		specifies a list of bases (the left-most one is the most deepest
		//		base).
		// props: Object
		//		An object whose properties are copied to the created prototype.
		//		Add an instance-initialization function by making it a property
		//		named "constructor".
		// returns: dojo/_base/declare.__DeclareCreatedObject
		//		New constructor function.
		// description:
		//		Create a constructor using a compact notation for inheritance and
		//		prototype extension.
		//
		//		Mixin ancestors provide a type of multiple inheritance.
		//		Prototypes of mixin ancestors are copied to the new class:
		//		changes to mixin prototypes will not affect classes to which
		//		they have been mixed in.
		//
		//		Ancestors can be compound classes created by this version of
		//		declare(). In complex cases all base classes are going to be
		//		linearized according to C3 MRO algorithm
		//		(see http://www.python.org/download/releases/2.3/mro/ for more
		//		details).
		//
		//		"className" is cached in "declaredClass" property of the new class,
		//		if it was supplied. The immediate super class will be cached in
		//		"superclass" property of the new class.
		//
		//		Methods in "props" will be copied and modified: "nom" property
		//		(the declared name of the method) will be added to all copied
		//		functions to help identify them for the internal machinery. Be
		//		very careful, while reusing methods: if you use the same
		//		function under different names, it can produce errors in some
		//		cases.
		//
		//		It is possible to use constructors created "manually" (without
		//		declare()) as bases. They will be called as usual during the
		//		creation of an instance, their methods will be chained, and even
		//		called by "this.inherited()".
		//
		//		Special property "-chains-" governs how to chain methods. It is
		//		a dictionary, which uses method names as keys, and hint strings
		//		as values. If a hint string is "after", this method will be
		//		called after methods of its base classes. If a hint string is
		//		"before", this method will be called before methods of its base
		//		classes.
		//
		//		If "constructor" is not mentioned in "-chains-" property, it will
		//		be chained using the legacy mode: using "after" chaining,
		//		calling preamble() method before each constructor, if available,
		//		and calling postscript() after all constructors were executed.
		//		If the hint is "after", it is chained as a regular method, but
		//		postscript() will be called after the chain of constructors.
		//		"constructor" cannot be chained "before", but it allows
		//		a special hint string: "manual", which means that constructors
		//		are not going to be chained in any way, and programmer will call
		//		them manually using this.inherited(). In the latter case
		//		postscript() will be called after the construction.
		//
		//		All chaining hints are "inherited" from base classes and
		//		potentially can be overridden. Be very careful when overriding
		//		hints! Make sure that all chained methods can work in a proposed
		//		manner of chaining.
		//
		//		Once a method was chained, it is impossible to unchain it. The
		//		only exception is "constructor". You don't need to define a
		//		method in order to supply a chaining hint.
		//
		//		If a method is chained, it cannot use this.inherited() because
		//		all other methods in the hierarchy will be called automatically.
		//
		//		Usually constructors and initializers of any kind are chained
		//		using "after" and destructors of any kind are chained as
		//		"before". Note that chaining assumes that chained methods do not
		//		return any value: any returned value will be discarded.
		//
		// example:
		//	|	declare("my.classes.bar", my.classes.foo, {
		//	|		// properties to be added to the class prototype
		//	|		someValue: 2,
		//	|		// initialization function
		//	|		constructor: function(){
		//	|			this.myComplicatedObject = new ReallyComplicatedObject();
		//	|		},
		//	|		// other functions
		//	|		someMethod: function(){
		//	|			doStuff();
		//	|		}
		//	|	});
		//
		// example:
		//	|	var MyBase = declare(null, {
		//	|		// constructor, properties, and methods go here
		//	|		// ...
		//	|	});
		//	|	var MyClass1 = declare(MyBase, {
		//	|		// constructor, properties, and methods go here
		//	|		// ...
		//	|	});
		//	|	var MyClass2 = declare(MyBase, {
		//	|		// constructor, properties, and methods go here
		//	|		// ...
		//	|	});
		//	|	var MyDiamond = declare([MyClass1, MyClass2], {
		//	|		// constructor, properties, and methods go here
		//	|		// ...
		//	|	});
		//
		// example:
		//	|	var F = function(){ console.log("raw constructor"); };
		//	|	F.prototype.method = function(){
		//	|		console.log("raw method");
		//	|	};
		//	|	var A = declare(F, {
		//	|		constructor: function(){
		//	|			console.log("A.constructor");
		//	|		},
		//	|		method: function(){
		//	|			console.log("before calling F.method...");
		//	|			this.inherited(arguments);
		//	|			console.log("...back in A");
		//	|		}
		//	|	});
		//	|	new A().method();
		//	|	// will print:
		//	|	// raw constructor
		//	|	// A.constructor
		//	|	// before calling F.method...
		//	|	// raw method
		//	|	// ...back in A
		//
		// example:
		//	|	var A = declare(null, {
		//	|		"-chains-": {
		//	|			destroy: "before"
		//	|		}
		//	|	});
		//	|	var B = declare(A, {
		//	|		constructor: function(){
		//	|			console.log("B.constructor");
		//	|		},
		//	|		destroy: function(){
		//	|			console.log("B.destroy");
		//	|		}
		//	|	});
		//	|	var C = declare(B, {
		//	|		constructor: function(){
		//	|			console.log("C.constructor");
		//	|		},
		//	|		destroy: function(){
		//	|			console.log("C.destroy");
		//	|		}
		//	|	});
		//	|	new C().destroy();
		//	|	// prints:
		//	|	// B.constructor
		//	|	// C.constructor
		//	|	// C.destroy
		//	|	// B.destroy
		//
		// example:
		//	|	var A = declare(null, {
		//	|		"-chains-": {
		//	|			constructor: "manual"
		//	|		}
		//	|	});
		//	|	var B = declare(A, {
		//	|		constructor: function(){
		//	|			// ...
		//	|			// call the base constructor with new parameters
		//	|			this.inherited(arguments, [1, 2, 3]);
		//	|			// ...
		//	|		}
		//	|	});
		//
		// example:
		//	|	var A = declare(null, {
		//	|		"-chains-": {
		//	|			m1: "before"
		//	|		},
		//	|		m1: function(){
		//	|			console.log("A.m1");
		//	|		},
		//	|		m2: function(){
		//	|			console.log("A.m2");
		//	|		}
		//	|	});
		//	|	var B = declare(A, {
		//	|		"-chains-": {
		//	|			m2: "after"
		//	|		},
		//	|		m1: function(){
		//	|			console.log("B.m1");
		//	|		},
		//	|		m2: function(){
		//	|			console.log("B.m2");
		//	|		}
		//	|	});
		//	|	var x = new B();
		//	|	x.m1();
		//	|	// prints:
		//	|	// B.m1
		//	|	// A.m1
		//	|	x.m2();
		//	|	// prints:
		//	|	// A.m2
		//	|	// B.m2

		// crack parameters
		if(typeof className != "string"){
			props = superclass;
			superclass = className;
			className = "";
		}
		props = props || {};

		var proto, i, t, ctor, name, bases, chains, mixins = 1, parents = superclass;

		// build a prototype
		if(opts.call(superclass) == "[object Array]"){
			// C3 MRO
			bases = c3mro(superclass, className);
			t = bases[0];
			mixins = bases.length - t;
			superclass = bases[mixins];
		}else{
			bases = [0];
			if(superclass){
				if(opts.call(superclass) == "[object Function]"){
					t = superclass._meta;
					bases = bases.concat(t ? t.bases : superclass);
				}else{
					err("base class is not a callable constructor.", className);
				}
			}else if(superclass !== null){
				err("unknown base class. Did you use dojo.require to pull it in?", className);
			}
		}
		if(superclass){
			for(i = mixins - 1;; --i){
				proto = forceNew(superclass);
				if(!i){
					// stop if nothing to add (the last base)
					break;
				}
				// mix in properties
				t = bases[i];
				(t._meta ? mixOwn : mix)(proto, t.prototype);
				// chain in new constructor
				if (has("csp-restrictions")) {
					ctor = function () {};
				}
				else {
					ctor = new Function;
				}
				ctor.superclass = superclass;
				ctor.prototype = proto;
				superclass = proto.constructor = ctor;
			}
		}else{
			proto = {};
		}
		// add all properties
		declare.safeMixin(proto, props);
		// add constructor
		t = props.constructor;
		if(t !== op.constructor){
			t.nom = cname;
			proto.constructor = t;
		}

		// collect chains and flags
		for(i = mixins - 1; i; --i){ // intentional assignment
			t = bases[i]._meta;
			if(t && t.chains){
				chains = mix(chains || {}, t.chains);
			}
		}
		if(proto["-chains-"]){
			chains = mix(chains || {}, proto["-chains-"]);
		}

		if(superclass && superclass.prototype && superclass.prototype["-chains-"]) {
			chains = mix(chains || {}, superclass.prototype["-chains-"]);
		}

		// build ctor
		t = !chains || !chains.hasOwnProperty(cname);
		bases[0] = ctor = (chains && chains.constructor === "manual") ? simpleConstructor(bases) :
			(bases.length == 1 ? singleConstructor(props.constructor, t) : chainedConstructor(bases, t));

		// add meta information to the constructor
		ctor._meta  = {bases: bases, hidden: props, chains: chains,
			parents: parents, ctor: props.constructor};
		ctor.superclass = superclass && superclass.prototype;
		ctor.extend = extend;
		ctor.createSubclass = createSubclass;
		ctor.prototype = proto;
		proto.constructor = ctor;

		// add "standard" methods to the prototype
		proto.getInherited = getInherited;
		proto.isInstanceOf = isInstanceOf;
		proto.inherited    = inheritedImpl;
		proto.__inherited  = inherited;

		// add name if specified
		if(className){
			proto.declaredClass = className;
			lang.setObject(className, ctor);
		}

		// build chains and add them to the prototype
		if(chains){
			for(name in chains){
				if(proto[name] && typeof chains[name] == "string" && name != cname){
					t = proto[name] = chain(name, bases, chains[name] === "after");
					t.nom = name;
				}
			}
		}
		// chained methods do not return values
		// no need to chain "invisible" functions

		return ctor;	// Function
	}

	/*=====
	declare.__DeclareCreatedObject = {
		// summary:
		//		dojo/_base/declare() returns a constructor `C`.   `new C()` returns an Object with the following
		//		methods, in addition to the methods and properties specified via the arguments passed to declare().

		inherited: function(name, caller, args, newArgs){
			// summary:
			//		Calls a super method.
			// name: String?
			//		The optional method name. Should be the same as the caller's
			//		name. Usually "name" is specified in complex dynamic cases, when
			//		the calling method was dynamically added, undecorated by
			//		declare(), and it cannot be determined.
			// caller: Function?
			//		The reference to the calling function. Required only if the
			//		call to "this.inherited" occurs from within strict-mode code.
			//		If the caller is omitted within strict-mode code, an error will
			//		be thrown.
			//		The best way to obtain a reference to the calling function is to
			//		use a named function expression (i.e. place a function name
			//		after the "function" keyword and before the open paren, as in
			//		"function fn(a, b)"). If the function is parsed as an expression
			//		and not a statement (i.e. it's not by itself on its own line),
			//		the function name will only be accessible as an identifier from
			//		within the body of the function.
			// args: Arguments
			//		The caller supply this argument, which should be the original
			//		"arguments".
			// newArgs: Object?
			//		If "true", the found function will be returned without
			//		executing it.
			//		If Array, it will be used to call a super method. Otherwise
			//		"args" will be used.
			// returns:
			//		Whatever is returned by a super method, or a super method itself,
			//		if "true" was specified as newArgs.
			// description:
			//		This method is used inside method of classes produced with
			//		declare() to call a super method (next in the chain). It is
			//		used for manually controlled chaining. Consider using the regular
			//		chaining, because it is faster. Use "this.inherited()" only in
			//		complex cases.
			//
			//		This method cannot me called from automatically chained
			//		constructors including the case of a special (legacy)
			//		constructor chaining. It cannot be called from chained methods.
			//
			//		If "this.inherited()" cannot find the next-in-chain method, it
			//		does nothing and returns "undefined". The last method in chain
			//		can be a default method implemented in Object, which will be
			//		called last.
			//
			//		If "name" is specified, it is assumed that the method that
			//		received "args" is the parent method for this call. It is looked
			//		up in the chain list and if it is found the next-in-chain method
			//		is called. If it is not found, the first-in-chain method is
			//		called.
			//
			//		If "name" is not specified, it will be derived from the calling
			//		method (using a methoid property "nom").
			//
			// example:
			//	|	var B = declare(A, {
			//	|		method1: function(a, b, c){
			//	|			this.inherited(arguments);
			//	|		},
			//	|		method2: function(a, b){
			//	|			return this.inherited(arguments, [a + b]);
			//	|		}
			//	|	});
			//	|	// next method is not in the chain list because it is added
			//	|	// manually after the class was created.
			//	|	B.prototype.method3 = function(){
			//	|		console.log("This is a dynamically-added method.");
			//	|		this.inherited("method3", arguments);
			//	|	};
			// example:
			//	|	var B = declare(A, {
			//	|		method: function(a, b){
			//	|			var super = this.inherited(arguments, true);
			//	|			// ...
			//	|			if(!super){
			//	|				console.log("there is no super method");
			//	|				return 0;
			//	|			}
			//	|			return super.apply(this, arguments);
			//	|		}
			//	|	});
			// example:
			//	|	"use strict";
			//	|	// class is defined in strict-mode code,
			//	|	// so caller must be passed before arguments.
			//	|	var B = declare(A, {
			//	|		// using a named function expression with "fn" as the name.
			//	|		method: function fn(a, b) {
			//	|			this.inherited(fn, arguments);
			//	|		}
			//	|	});
			return	{};	// Object
		},

		getInherited: function(name, caller, args){
			// summary:
			//		Returns a super method.
			// name: String?
			//		The optional method name. Should be the same as the caller's
			//		name. Usually "name" is specified in complex dynamic cases, when
			//		the calling method was dynamically added, undecorated by
			//		declare(), and it cannot be determined.
			// caller: Function?
			//		The caller function. This is required when running in
			//		strict-mode code. A reference to the caller function
			//		can be obtained by using a named function expression
			//		(e.g. function fn(a,b) {...}).
			// args: Arguments
			//		The caller supply this argument, which should be the original
			//		"arguments".
			// returns:
			//		Returns a super method (Function) or "undefined".
			// description:
			//		This method is a convenience method for "this.inherited()".
			//		It uses the same algorithm but instead of executing a super
			//		method, it returns it, or "undefined" if not found.
			//
			// example:
			//	|	var B = declare(A, {
			//	|		method: function(a, b){
			//	|			var super = this.getInherited(arguments);
			//	|			// ...
			//	|			if(!super){
			//	|				console.log("there is no super method");
			//	|				return 0;
			//	|			}
			//	|			return super.apply(this, arguments);
			//	|		}
			//	|	});
			// example:
			//	|	"use strict;" // first line of function or file
			//	|	//...
			//	|	var B = declare(A, {
			//	|		// Using a named function expression with "fn" as the name,
			//	|		// since we're in strict mode.
			//	|		method: function fn(a, b){
			//	|			var super = this.getInherited(fn, arguments);
			//	|			if(super){
			//	|				return super.apply(this, arguments);
			//	|			}
			//	|		}
			//	|	});
			return	{};	// Object
		},

		isInstanceOf: function(cls){
			// summary:
			//		Checks the inheritance chain to see if it is inherited from this
			//		class.
			// cls: Function
			//		Class constructor.
			// returns:
			//		"true", if this object is inherited from this class, "false"
			//		otherwise.
			// description:
			//		This method is used with instances of classes produced with
			//		declare() to determine of they support a certain interface or
			//		not. It models "instanceof" operator.
			//
			// example:
			//	|	var A = declare(null, {
			//	|		// constructor, properties, and methods go here
			//	|		// ...
			//	|	});
			//	|	var B = declare(null, {
			//	|		// constructor, properties, and methods go here
			//	|		// ...
			//	|	});
			//	|	var C = declare([A, B], {
			//	|		// constructor, properties, and methods go here
			//	|		// ...
			//	|	});
			//	|	var D = declare(A, {
			//	|		// constructor, properties, and methods go here
			//	|		// ...
			//	|	});
			//	|
			//	|	var a = new A(), b = new B(), c = new C(), d = new D();
			//	|
			//	|	console.log(a.isInstanceOf(A)); // true
			//	|	console.log(b.isInstanceOf(A)); // false
			//	|	console.log(c.isInstanceOf(A)); // true
			//	|	console.log(d.isInstanceOf(A)); // true
			//	|
			//	|	console.log(a.isInstanceOf(B)); // false
			//	|	console.log(b.isInstanceOf(B)); // true
			//	|	console.log(c.isInstanceOf(B)); // true
			//	|	console.log(d.isInstanceOf(B)); // false
			//	|
			//	|	console.log(a.isInstanceOf(C)); // false
			//	|	console.log(b.isInstanceOf(C)); // false
			//	|	console.log(c.isInstanceOf(C)); // true
			//	|	console.log(d.isInstanceOf(C)); // false
			//	|
			//	|	console.log(a.isInstanceOf(D)); // false
			//	|	console.log(b.isInstanceOf(D)); // false
			//	|	console.log(c.isInstanceOf(D)); // false
			//	|	console.log(d.isInstanceOf(D)); // true
			return	{};	// Object
		},

		extend: function(source){
			// summary:
			//		Adds all properties and methods of source to constructor's
			//		prototype, making them available to all instances created with
			//		constructor. This method is specific to constructors created with
			//		declare().
			// source: Object
			//		Source object which properties are going to be copied to the
			//		constructor's prototype.
			// description:
			//		Adds source properties to the constructor's prototype. It can
			//		override existing properties.
			//
			//		This method is similar to dojo.extend function, but it is specific
			//		to constructors produced by declare(). It is implemented
			//		using dojo.safeMixin, and it skips a constructor property,
			//		and properly decorates copied functions.
			//
			// example:
			//	|	var A = declare(null, {
			//	|		m1: function(){},
			//	|		s1: "Popokatepetl"
			//	|	});
			//	|	A.extend({
			//	|		m1: function(){},
			//	|		m2: function(){},
			//	|		f1: true,
			//	|		d1: 42
			//	|	});
		},

		createSubclass: function(mixins, props){
			// summary:
			//		Create a subclass of the declared class from a list of base classes.
			// mixins: Function[]
			//		Specifies a list of bases (the left-most one is the most deepest
			//		base).
			// props: Object?
			//		An optional object whose properties are copied to the created prototype.
			// returns: dojo/_base/declare.__DeclareCreatedObject
			//		New constructor function.
			// description:
			//		Create a constructor using a compact notation for inheritance and
			//		prototype extension.
			//
			//		Mixin ancestors provide a type of multiple inheritance.
			//		Prototypes of mixin ancestors are copied to the new class:
			//		changes to mixin prototypes will not affect classes to which
			//		they have been mixed in.
			//
			// example:
			//	|	var A = declare(null, {
			//	|		m1: function(){},
			//	|		s1: "bar"
			//	|	});
			//	|	var B = declare(null, {
			//	|		m2: function(){},
			//	|		s2: "foo"
			//	|	});
			//	|	var C = declare(null, {
			//	|	});
			//	|	var D1 = A.createSubclass([B, C], {
			//	|		m1: function(){},
			//	|		d1: 42
			//	|	});
			//	|	var d1 = new D1();
			//	|
			//	|	// this is equivalent to:
			//	|	var D2 = declare([A, B, C], {
			//	|		m1: function(){},
			//	|		d1: 42
			//	|	});
			//	|	var d2 = new D2();
		}
	};
	=====*/

	// For back-compat, remove for 2.0
	dojo.safeMixin = declare.safeMixin = safeMixin;
	dojo.declare = declare;

	return declare;
});

},
'dojo/hash':function(){
define(["./_base/kernel", "require", "./_base/config", "./aspect", "./_base/lang", "./topic", "./domReady", "./sniff"],
	function(dojo, require, config, aspect, lang, topic, domReady, has){

	// module:
	//		dojo/hash

	dojo.hash = function(/* String? */ hash, /* Boolean? */ replace){
		// summary:
		//		Gets or sets the hash string in the browser URL.
		// description:
		//		Handles getting and setting of location.hash.
		//
		//		 - If no arguments are passed, acts as a getter.
		//		 - If a string is passed, acts as a setter.
		// hash:
		//		the hash is set - #string.
		// replace:
		//		If true, updates the hash value in the current history
		//		state instead of creating a new history state.
		// returns:
		//		when used as a getter, returns the current hash string.
		//		when used as a setter, returns the new hash string.
		// example:
		//	|	topic.subscribe("/dojo/hashchange", context, callback);
		//	|
		//	|	function callback (hashValue){
		//	|		// do something based on the hash value.
		//	|	}

		// getter
		if(!arguments.length){
			return _getHash();
		}
		// setter
		if(hash.charAt(0) == "#"){
			hash = hash.substring(1);
		}
		if(replace){
			_replace(hash);
		}else{
			location.hash = "#" + hash;
		}
		return hash; // String
	};

	// Global vars
	var _recentHash, _ieUriMonitor, _connect,
		_pollFrequency = config.hashPollFrequency || 100;

	//Internal functions
	function _getSegment(str, delimiter){
		var i = str.indexOf(delimiter);
		return (i >= 0) ? str.substring(i+1) : "";
	}

	function _getHash(){
		return _getSegment(location.href, "#");
	}

	function _dispatchEvent(){
		topic.publish("/dojo/hashchange", _getHash());
	}

	function _pollLocation(){
		if(_getHash() === _recentHash){
			return;
		}
		_recentHash = _getHash();
		_dispatchEvent();
	}

	function _replace(hash){
		if(_ieUriMonitor){
			if(_ieUriMonitor.isTransitioning()){
				setTimeout(lang.hitch(null,_replace,hash), _pollFrequency);
				return;
			}
			var href = _ieUriMonitor.iframe.location.href;
			var index = href.indexOf('?');
			// main frame will detect and update itself
			_ieUriMonitor.iframe.location.replace(href.substring(0, index) + "?" + hash);
			return;
		}
		var href = location.href.replace(/#.*/, "");
		location.replace(href + "#" + hash);
		!_connect && _pollLocation();
	}

	function IEUriMonitor(){
		// summary:
		//		Determine if the browser's URI has changed or if the user has pressed the
		//		back or forward button. If so, call _dispatchEvent.
		//
		// description:
		//		IE doesn't add changes to the URI's hash into the history unless the hash
		//		value corresponds to an actual named anchor in the document. To get around
		//		this IE difference, we use a background IFrame to maintain a back-forward
		//		history, by updating the IFrame's query string to correspond to the
		//		value of the main browser location's hash value.
		//
		//		E.g. if the value of the browser window's location changes to
		//
		//		#action=someAction
		//
		//		... then we'd update the IFrame's source to:
		//
		//		?action=someAction
		//
		//		This design leads to a somewhat complex state machine, which is
		//		described below:
		//
		//		####s1
		//
		//		Stable state - neither the window's location has changed nor
		//		has the IFrame's location. Note that this is the 99.9% case, so
		//		we optimize for it.
		//
		//		Transitions: s1, s2, s3
		//
		//		####s2
		//
		//		Window's location changed - when a user clicks a hyperlink or
		//		code programmatically changes the window's URI.
		//
		//		Transitions: s4
		//
		//		####s3
		//
		//		Iframe's location changed as a result of user pressing back or
		//		forward - when the user presses back or forward, the location of
		//		the background's iframe changes to the previous or next value in
		//		its history.
		//
		//		Transitions: s1
		//
		//		####s4
		//
		//		IEUriMonitor has programmatically changed the location of the
		//		background iframe, but it's location hasn't yet changed. In this
		//		case we do nothing because we need to wait for the iframe's
		//		location to reflect its actual state.
		//
		//		Transitions: s4, s5
		//
		//		####s5
		//
		//		IEUriMonitor has programmatically changed the location of the
		//		background iframe, and the iframe's location has caught up with
		//		reality. In this case we need to transition to s1.
		//
		//		Transitions: s1
		//
		//		The hashchange event is always dispatched on the transition back to s1.


		// create and append iframe
		var ifr = document.createElement("iframe"),
			IFRAME_ID = "dojo-hash-iframe",
			ifrSrc = config.dojoBlankHtmlUrl || require.toUrl("./resources/blank.html");

		if(config.useXDomain && !config.dojoBlankHtmlUrl){
			console.warn("dojo/hash: When using cross-domain Dojo builds,"
				+ " please save dojo/resources/blank.html to your domain and set djConfig.dojoBlankHtmlUrl"
				+ " to the path on your domain to blank.html");
		}

		ifr.id = IFRAME_ID;
		ifr.src = ifrSrc + "?" + _getHash();
		ifr.style.display = "none";
		document.body.appendChild(ifr);

		this.iframe = dojo.global[IFRAME_ID];
		var recentIframeQuery, transitioning, expectedIFrameQuery, docTitle, ifrOffline,
			iframeLoc = this.iframe.location;

		function resetState(){
			_recentHash = _getHash();
			recentIframeQuery = ifrOffline ? _recentHash : _getSegment(iframeLoc.href, "?");
			transitioning = false;
			expectedIFrameQuery = null;
		}

		this.isTransitioning = function(){
			return transitioning;
		};

		this.pollLocation = function(){
			if(!ifrOffline){
				try{
					//see if we can access the iframe's location without a permission denied error
					var iframeSearch = _getSegment(iframeLoc.href, "?");
					//good, the iframe is same origin (no thrown exception)
					if(document.title != docTitle){ //sync title of main window with title of iframe.
						docTitle = this.iframe.document.title = document.title;
					}
				}catch(e){
					//permission denied - server cannot be reached.
					ifrOffline = true;
					console.error("dojo/hash: Error adding history entry. Server unreachable.");
				}
			}
			var hash = _getHash();
			if(transitioning && _recentHash === hash){
				// we're in an iframe transition (s4 or s5)
				if(ifrOffline || iframeSearch === expectedIFrameQuery){
					// s5 (iframe caught up to main window or iframe offline), transition back to s1
					resetState();
					_dispatchEvent();
				}else{
					// s4 (waiting for iframe to catch up to main window)
					setTimeout(lang.hitch(this,this.pollLocation),0);
					return;
				}
			}else if(_recentHash === hash && (ifrOffline || recentIframeQuery === iframeSearch)){
				// we're in stable state (s1, iframe query == main window hash), do nothing
			}else{
				// the user has initiated a URL change somehow.
				// sync iframe query <-> main window hash
				if(_recentHash !== hash){
					// s2 (main window location changed), set iframe url and transition to s4
					_recentHash = hash;
					transitioning = true;
					expectedIFrameQuery = hash;
					ifr.src = ifrSrc + "?" + expectedIFrameQuery;
					ifrOffline = false; //we're updating the iframe src - set offline to false so we can check again on next poll.
					setTimeout(lang.hitch(this,this.pollLocation),0); //yielded transition to s4 while iframe reloads.
					return;
				}else if(!ifrOffline){
					// s3 (iframe location changed via back/forward button), set main window url and transition to s1.
					location.href = "#" + iframeLoc.search.substring(1);
					resetState();
					_dispatchEvent();
				}
			}
			setTimeout(lang.hitch(this,this.pollLocation), _pollFrequency);
		};
		resetState(); // initialize state (transition to s1)
		setTimeout(lang.hitch(this,this.pollLocation), _pollFrequency);
	}
	domReady(function(){
		if("onhashchange" in dojo.global && (!has("ie") || (has("ie") >= 8 && document.compatMode != "BackCompat"))){	//need this IE browser test because "onhashchange" exists in IE8 in IE7 mode
			_connect = aspect.after(dojo.global,"onhashchange",_dispatchEvent, true);
		}else{
			if(document.addEventListener){ // Non-IE
				_recentHash = _getHash();
				setInterval(_pollLocation, _pollFrequency); //Poll the window location for changes
			}else if(document.attachEvent){ // IE7-
				//Use hidden iframe in versions of IE that don't have onhashchange event
				_ieUriMonitor = new IEUriMonitor();
			}
			// else non-supported browser, do nothing.
		}
	});

	return dojo.hash;

});

},
'dojo/topic':function(){
define(["./Evented"], function(Evented){

	// module:
	//		dojo/topic

	var hub = new Evented;
	return {
		// summary:
		//		Pubsub hub.
		// example:
		//		| 	topic.subscribe("some/topic", function(event){
		//		|	... do something with event
		//		|	});
		//		|	topic.publish("some/topic", {name:"some event", ...});

		publish: function(topic, event){
			// summary:
			//		Publishes a message to a topic on the pub/sub hub. All arguments after
			//		the first will be passed to the subscribers, so any number of arguments
			//		can be provided (not just event).
			// topic: String
			//		The name of the topic to publish to
			// event: Object
			//		An event to distribute to the topic listeners
			return hub.emit.apply(hub, arguments);
		},

		subscribe: function(topic, listener){
			// summary:
			//		Subscribes to a topic on the pub/sub hub
			// topic: String
			//		The topic to subscribe to
			// listener: Function
			//		A function to call when a message is published to the given topic
			return hub.on.apply(hub, arguments);
		}
	};
});

},
'dojo/Evented':function(){
define(["./aspect", "./on"], function(aspect, on){
	// module:
	//		dojo/Evented

 	"use strict";
 	var after = aspect.after;
	function Evented(){
		// summary:
		//		A class that can be used as a mixin or base class,
		//		to add on() and emit() methods to a class
		//		for listening for events and emitting events:
		// example:
		//		|	define(["dojo/Evented", "dojo/_base/declare", "dojo/Stateful"
		//		|	], function(Evented, declare, Stateful){
		//		|		var EventedStateful = declare([Evented, Stateful], {...});
		//		|		var instance = new EventedStateful();
		//		|		instance.on("open", function(event){
		//		|		... do something with event
		//		|	 });
		//		|
		//		|	instance.emit("open", {name:"some event", ...});
	}
	Evented.prototype = {
		on: function(type, listener){
			return on.parse(this, type, listener, function(target, type){
				return after(target, 'on' + type, listener, true);
			});
		},
		emit: function(type, event){
			var args = [this];
			args.push.apply(args, arguments);
			return on.emit.apply(on, args);
		}
	};
	return Evented;
});

},
'dojo/domReady':function(){
define(['./global', './has'], function(global, has){
	var doc = document,
		readyStates = { 'loaded': 1, 'complete': 1 },
		fixReadyState = typeof doc.readyState != "string",
		ready = !!readyStates[doc.readyState],
		readyQ = [],
		recursiveGuard;

	function domReady(callback){
		// summary:
		//		Plugin to delay require()/define() callback from firing until the DOM has finished loading.
		readyQ.push(callback);
		if(ready){ processQ(); }
	}
	domReady.load = function(id, req, load){
		domReady(load);
	};

	// Export queue so that ready() can check if it's empty or not.
	domReady._Q = readyQ;
	domReady._onQEmpty = function(){
		// summary:
		//		Private method overridden by dojo/ready, to notify when everything in the
		//		domReady queue has been processed.  Do not use directly.
		//		Will be removed in 2.0, along with domReady._Q.
	};

	// For FF <= 3.5
	if(fixReadyState){ doc.readyState = "loading"; }

	function processQ(){
		// Calls all functions in the queue in order, unless processQ() is already running, in which case just return

		if(recursiveGuard){ return; }
		recursiveGuard = true;

		while(readyQ.length){
			try{
				(readyQ.shift())(doc);
			}catch(err){
				console.error(err, "in domReady callback", err.stack);
			}
		}

		recursiveGuard = false;

		// Notification for dojo/ready.  Remove for 2.0.
		// Note that this could add more tasks to the ready queue.
		domReady._onQEmpty();
	}

	if(!ready){
		var tests = [],
			detectReady = function(evt){
				evt = evt || global.event;
				if(ready || (evt.type == "readystatechange" && !readyStates[doc.readyState])){ return; }

				// For FF <= 3.5
				if(fixReadyState){ doc.readyState = "complete"; }

				ready = 1;
				processQ();
			},
			on = function(node, event){
				node.addEventListener(event, detectReady, false);
				readyQ.push(function(){ node.removeEventListener(event, detectReady, false); });
			};

		if(!has("dom-addeventlistener")){
			on = function(node, event){
				event = "on" + event;
				node.attachEvent(event, detectReady);
				readyQ.push(function(){ node.detachEvent(event, detectReady); });
			};

			var div = doc.createElement("div");
			try{
				if(div.doScroll && global.frameElement === null){
					// the doScroll test is only useful if we're in the top-most frame
					tests.push(function(){
						// Derived with permission from Diego Perini's IEContentLoaded
						// http://javascript.nwbox.com/IEContentLoaded/
						try{
							div.doScroll("left");
							return 1;
						}catch(e){}
					});
				}
			}catch(e){}
		}

		on(doc, "DOMContentLoaded");
		on(global, "load");

		if("onreadystatechange" in doc){
			on(doc, "readystatechange");
		}else if(!fixReadyState){
			// if the ready state property exists and there's
			// no readystatechange event, poll for the state
			// to change
			tests.push(function(){
				return readyStates[doc.readyState];
			});
		}

		if(tests.length){
			var poller = function(){
				if(ready){ return; }
				var i = tests.length;
				while(i--){
					if(tests[i]()){
						detectReady("poller");
						return;
					}
				}
				setTimeout(poller, 30);
			};
			poller();
		}
	}

	return domReady;
});

},
'dojo/cookie':function(){
define(["./_base/kernel", "./regexp"], function(dojo, regexp){

// module:
//		dojo/cookie

/*=====
var __cookieProps = {
	// expires: Date|String|Number?
	//		If a number, the number of days from today at which the cookie
	//		will expire. If a date, the date past which the cookie will expire.
	//		If expires is in the past, the cookie will be deleted.
	//		If expires is omitted or is 0, the cookie will expire when the browser closes.
	// path: String?
	//		The path to use for the cookie.
	// domain: String?
	//		The domain to use for the cookie.
	// secure: Boolean?
	//		Whether to only send the cookie on secure connections
};
=====*/


dojo.cookie = function(/*String*/name, /*String?*/ value, /*__cookieProps?*/ props){
	// summary:
	//		Get or set a cookie.
	// description:
	//		If one argument is passed, returns the value of the cookie
	//		For two or more arguments, acts as a setter.
	// name:
	//		Name of the cookie
	// value:
	//		Value for the cookie
	// props:
	//		Properties for the cookie
	// example:
	//		set a cookie with the JSON-serialized contents of an object which
	//		will expire 5 days from now:
	//	|	require(["dojo/cookie", "dojo/json"], function(cookie, json){
	//	|		cookie("configObj", json.stringify(config, {expires: 5 }));
	//	|	});
	//
	// example:
	//		de-serialize a cookie back into a JavaScript object:
	//	|	require(["dojo/cookie", "dojo/json"], function(cookie, json){
	//	|		config = json.parse(cookie("configObj"));
	//	|	});
	//
	// example:
	//		delete a cookie:
	//	|	require(["dojo/cookie"], function(cookie){
	//	|		cookie("configObj", null, {expires: -1});
	//	|	});
	var c = document.cookie, ret;
	if(arguments.length == 1){
		var matches = c.match(new RegExp("(?:^|; )" + regexp.escapeString(name) + "=([^;]*)"));
		ret = matches ? decodeURIComponent(matches[1]) : undefined; 
	}else{
		props = props || {};
// FIXME: expires=0 seems to disappear right away, not on close? (FF3)  Change docs?
		var exp = props.expires;
		if(typeof exp == "number"){
			var d = new Date();
			d.setTime(d.getTime() + exp*24*60*60*1000);
			exp = props.expires = d;
		}
		if(exp && exp.toUTCString){ props.expires = exp.toUTCString(); }

		value = encodeURIComponent(value);
		var updatedCookie = name + "=" + value, propName;
		for(propName in props){
			updatedCookie += "; " + propName;
			var propValue = props[propName];
			if(propValue !== true){ updatedCookie += "=" + propValue; }
		}
		document.cookie = updatedCookie;
	}
	return ret; // String|undefined
};

dojo.cookie.isSupported = function(){
	// summary:
	//		Use to determine if the current browser supports cookies or not.
	//
	//		Returns true if user allows cookies.
	//		Returns false if user doesn't allow cookies.

	if(!("cookieEnabled" in navigator)){
		this("__djCookieTest__", "CookiesAllowed");
		navigator.cookieEnabled = this("__djCookieTest__") == "CookiesAllowed";
		if(navigator.cookieEnabled){
			this("__djCookieTest__", "", {expires: -1});
		}
	}
	return navigator.cookieEnabled;
};

return dojo.cookie;
});

},
'dojo/regexp':function(){
define(["./_base/kernel", "./_base/lang"], function(dojo, lang){

// module:
//		dojo/regexp

var regexp = {
	// summary:
	//		Regular expressions and Builder resources
};
lang.setObject("dojo.regexp", regexp);

regexp.escapeString = function(/*String*/str, /*String?*/except){
	// summary:
	//		Adds escape sequences for special characters in regular expressions
	// except:
	//		a String with special characters to be left unescaped

	return str.replace(/([\.$?*|{}\(\)\[\]\\\/\+\-^])/g, function(ch){
		if(except && except.indexOf(ch) != -1){
			return ch;
		}
		return "\\" + ch;
	}); // String
};

regexp.buildGroupRE = function(/*Object|Array*/arr, /*Function*/re, /*Boolean?*/nonCapture){
	// summary:
	//		Builds a regular expression that groups subexpressions
	// description:
	//		A utility function used by some of the RE generators. The
	//		subexpressions are constructed by the function, re, in the second
	//		parameter.  re builds one subexpression for each elem in the array
	//		a, in the first parameter. Returns a string for a regular
	//		expression that groups all the subexpressions.
	// arr:
	//		A single value or an array of values.
	// re:
	//		A function. Takes one parameter and converts it to a regular
	//		expression.
	// nonCapture:
	//		If true, uses non-capturing match, otherwise matches are retained
	//		by regular expression. Defaults to false

	// case 1: a is a single value.
	if(!(arr instanceof Array)){
		return re(arr); // String
	}

	// case 2: a is an array
	var b = [];
	for(var i = 0; i < arr.length; i++){
		// convert each elem to a RE
		b.push(re(arr[i]));
	}

	 // join the REs as alternatives in a RE group.
	return regexp.group(b.join("|"), nonCapture); // String
};

regexp.group = function(/*String*/expression, /*Boolean?*/nonCapture){
	// summary:
	//		adds group match to expression
	// nonCapture:
	//		If true, uses non-capturing match, otherwise matches are retained
	//		by regular expression.
	return "(" + (nonCapture ? "?:":"") + expression + ")"; // String
};

return regexp;
});

},
'appivo/util/isMobile':function(){
/**
 * IsMobile.js - taken from https://github.com/kaimallea/isMobile
 */
define([], function() {
    var appleIphone = /iPhone/i;
    var appleIpod = /iPod/i;
    var appleTablet = /iPad/i;
    var appleUniversal = /\biOS-universal(?:.+)Mac\b/i;
    var androidPhone = /\bAndroid(?:.+)Mobile\b/i; // Match 'Android' AND 'Mobile'
    var androidTablet = /Android/i;
    var amazonPhone = /(?:SD4930UR|\bSilk(?:.+)Mobile\b)/i; // Match 'Silk' AND 'Mobile'
    var amazonTablet = /Silk/i;
    var windowsPhone = /Windows Phone/i;
    var windowsTablet = /\bWindows(?:.+)ARM\b/i; // Match 'Windows' AND 'ARM'
    var otherBlackBerry = /BlackBerry/i;
    var otherBlackBerry10 = /BB10/i;
    var otherOpera = /Opera Mini/i;
    var otherChrome = /\b(CriOS|Chrome)(?:.+)Mobile/i;
    var otherFirefox = /Mobile(?:.+)Firefox\b/i; // Match 'Mobile' AND 'Firefox'

    var isAppleTabletOnIos13 = function (navigator) {
        return (typeof navigator !== 'undefined' &&
            navigator.platform === 'MacIntel' &&
            typeof navigator.maxTouchPoints === 'number' &&
            navigator.maxTouchPoints > 1 &&
            typeof MSStream === 'undefined');
    };

    function createMatch(userAgent) {
        return function (regex) {
            return regex.test(userAgent);
        };
    }

    function isMobile(param) {
        var nav = {
            userAgent: '',
            platform: '',
            maxTouchPoints: 0,
        };
        if (!param && typeof navigator !== 'undefined') {
            nav = {
                userAgent: navigator.userAgent,
                platform: navigator.platform,
                maxTouchPoints: navigator.maxTouchPoints || 0,
            };
        } else if (typeof param === 'string') {
            nav.userAgent = param;
        } else if (param && param.userAgent) {
            nav = {
                userAgent: param.userAgent,
                platform: param.platform,
                maxTouchPoints: param.maxTouchPoints || 0,
            };
        }
        var userAgent = nav.userAgent;
        // Facebook mobile app's integrated browser adds a bunch of strings that
        // match everything. Strip it out if it exists.
        var tmp = userAgent.split('[FBAN');
        if (typeof tmp[1] !== 'undefined') {
            userAgent = tmp[0];
        }
        // Twitter mobile app's integrated browser on iPad adds a "Twitter for
        // iPhone" string. Same probably happens on other tablet platforms.
        // This will confuse detection so strip it out if it exists.
        tmp = userAgent.split('Twitter');
        if (typeof tmp[1] !== 'undefined') {
            userAgent = tmp[0];
        }
        var match = createMatch(userAgent);
        var result = {
            apple: {
                phone: match(appleIphone) && !match(windowsPhone),
                ipod: match(appleIpod),
                tablet: !match(appleIphone) &&
                    (match(appleTablet) || isAppleTabletOnIos13(nav)) &&
                    !match(windowsPhone),
                universal: match(appleUniversal),
                device: (match(appleIphone) ||
                    match(appleIpod) ||
                    match(appleTablet) ||
                    match(appleUniversal) ||
                    isAppleTabletOnIos13(nav)) &&
                    !match(windowsPhone),
            },
            amazon: {
                phone: match(amazonPhone),
                tablet: !match(amazonPhone) && match(amazonTablet),
                device: match(amazonPhone) || match(amazonTablet),
            },
            android: {
                phone: (!match(windowsPhone) && match(amazonPhone)) ||
                    (!match(windowsPhone) && match(androidPhone)),
                tablet: !match(windowsPhone) &&
                    !match(amazonPhone) &&
                    !match(androidPhone) &&
                    (match(amazonTablet) || match(androidTablet)),
                device: (!match(windowsPhone) &&
                    (match(amazonPhone) ||
                        match(amazonTablet) ||
                        match(androidPhone) ||
                        match(androidTablet))) ||
                    match(/\bokhttp\b/i),
            },
            windows: {
                phone: match(windowsPhone),
                tablet: match(windowsTablet),
                device: match(windowsPhone) || match(windowsTablet),
            },
            other: {
                blackberry: match(otherBlackBerry),
                blackberry10: match(otherBlackBerry10),
                opera: match(otherOpera),
                firefox: match(otherFirefox),
                chrome: match(otherChrome),
                device: match(otherBlackBerry) ||
                    match(otherBlackBerry10) ||
                    match(otherOpera) ||
                    match(otherFirefox) ||
                    match(otherChrome),
            },
            any: false,
            phone: false,
            tablet: false,
        };
        result.any =
            result.apple.device ||
            result.android.device ||
            result.windows.device ||
            result.other.device;
        // excludes 'other' devices and ipods, targeting touchscreen phones
        result.phone =
            result.apple.phone || result.android.phone || result.windows.phone;
        result.tablet =
            result.apple.tablet || result.android.tablet || result.windows.tablet;
        return result;
    }

    return {
        isMobile: isMobile
    };
});
},
'appivo/util/Currency':function(){
define(["dojo/_base/lang", "dojo/currency"], function(lang, Currency) {

	var currencyMap = {
		AD: 'EUR',
		AE: 'AED',
		AF: 'AFN',
		AG: 'XCD',
		AI: 'XCD',
		AL: 'ALL',
		AM: 'AMD',
		AN: 'ANG',
		AO: 'AOA',
		AR: 'ARS',
		AS: 'USD',
		AT: 'EUR',
		AU: 'AUD',
		AW: 'AWG',
		AX: 'EUR',
		AZ: 'AZN',
		BA: 'BAM',
		BB: 'BBD',
		BD: 'BDT',
		BE: 'EUR',
		BF: 'XOF',
		BG: 'BGN',
		BH: 'BHD',
		BI: 'BIF',
		BJ: 'XOF',
		BL: 'EUR',
		BM: 'BMD',
		BN: 'BND',
		BO: 'BOB',
		BQ: 'USD',
		BR: 'BRL',
		BS: 'BSD',
		BT: 'BTN',
		BV: 'NOK',
		BW: 'BWP',
		BY: 'BYN',
		BZ: 'BZD',
		CA: 'CAD',
		CC: 'AUD',
		CD: 'CDF',
		CF: 'XAF',
		CG: 'XAF',
		CH: 'CHF',
		CI: 'XOF',
		CK: 'NZD',
		CL: 'CLP',
		CM: 'XAF',
		CN: 'CNY',
		CO: 'COP',
		CR: 'CRC',
		CU: 'CUP',
		CV: 'CVE',
		CW: 'ANG',
		CX: 'AUD',
		CY: 'EUR',
		CZ: 'CZK',
		DE: 'EUR',
		DJ: 'DJF',
		DK: 'DKK',
		DM: 'XCD',
		DO: 'DOP',
		DZ: 'DZD',
		EC: 'USD',
		EE: 'EUR',
		EG: 'EGP',
		EH: 'MAD',
		ER: 'ERN',
		ES: 'EUR',
		ET: 'ETB',
		FI: 'EUR',
		FJ: 'FJD',
		FK: 'FKP',
		FM: 'USD',
		FO: 'DKK',
		FR: 'EUR',
		GA: 'XAF',
		GB: 'GBP',
		GD: 'XCD',
		GE: 'GEL',
		GF: 'EUR',
		GG: 'GBP',
		GH: 'GHS',
		GI: 'GIP',
		GL: 'DKK',
		GM: 'GMD',
		GN: 'GNF',
		GP: 'EUR',
		GQ: 'XAF',
		GR: 'EUR',
		GS: 'GBP',
		GT: 'GTQ',
		GU: 'USD',
		GW: 'XOF',
		GY: 'GYD',
		HK: 'HKD',
		HM: 'AUD',
		HN: 'HNL',
		HR: 'HRK',
		HT: 'HTG',
		HU: 'HUF',
		ID: 'IDR',
		IE: 'EUR',
		IL: 'ILS',
		IM: 'GBP',
		IN: 'INR',
		IO: 'USD',
		IQ: 'IQD',
		IR: 'IRR',
		IS: 'ISK',
		IT: 'EUR',
		JE: 'GBP',
		JM: 'JMD',
		JO: 'JOD',
		JP: 'JPY',
		KE: 'KES',
		KG: 'KGS',
		KH: 'KHR',
		KI: 'AUD',
		KM: 'KMF',
		KN: 'XCD',
		KP: 'KPW',
		KR: 'KRW',
		KW: 'KWD',
		KY: 'KYD',
		KZ: 'KZT',
		LA: 'LAK',
		LB: 'LBP',
		LC: 'XCD',
		LI: 'CHF',
		LK: 'LKR',
		LR: 'LRD',
		LS: 'LSL',
		LT: 'EUR',
		LU: 'EUR',
		LV: 'EUR',
		LY: 'LYD',
		MA: 'MAD',
		MC: 'EUR',
		MD: 'MDL',
		ME: 'EUR',
		MF: 'EUR',
		MG: 'MGA',
		MH: 'USD',
		MK: 'MKD',
		ML: 'XOF',
		MM: 'MMK',
		MN: 'MNT',
		MO: 'MOP',
		MP: 'USD',
		MQ: 'EUR',
		MR: 'MRO',
		MS: 'XCD',
		MT: 'EUR',
		MU: 'MUR',
		MV: 'MVR',
		MW: 'MWK',
		MX: 'MXN',
		MY: 'MYR',
		MZ: 'MZN',
		NA: 'NAD',
		NC: 'XPF',
		NE: 'XOF',
		NF: 'AUD',
		NG: 'NGN',
		NI: 'NIO',
		NL: 'EUR',
		NO: 'NOK',
		NP: 'NPR',
		NR: 'AUD',
		NU: 'NZD',
		NZ: 'NZD',
		OM: 'OMR',
		PA: 'PAB',
		PE: 'PEN',
		PF: 'XPF',
		PG: 'PGK',
		PH: 'PHP',
		PK: 'PKR',
		PL: 'PLN',
		PM: 'EUR',
		PN: 'NZD',
		PR: 'USD',
		PS: 'ILS',
		PT: 'EUR',
		PW: 'USD',
		PY: 'PYG',
		QA: 'QAR',
		RE: 'EUR',
		RO: 'RON',
		RS: 'RSD',
		RU: 'RUB',
		RW: 'RWF',
		SA: 'SAR',
		SB: 'SBD',
		SC: 'SCR',
		SD: 'SDG',
		SE: 'SEK',
		SG: 'SGD',
		SH: 'SHP',
		SI: 'EUR',
		SJ: 'NOK',
		SK: 'EUR',
		SL: 'SLL',
		SM: 'EUR',
		SN: 'XOF',
		SO: 'SOS',
		SR: 'SRD',
		ST: 'STD',
		SV: 'SVC',
		SX: 'ANG',
		SY: 'SYP',
		SZ: 'SZL',
		TC: 'USD',
		TD: 'XAF',
		TF: 'EUR',
		TG: 'XOF',
		TH: 'THB',
		TJ: 'TJS',
		TK: 'NZD',
		TL: 'USD',
		TM: 'TMT',
		TN: 'TND',
		TO: 'TOP',
		TR: 'TRY',
		TT: 'TTD',
		TV: 'AUD',
		TW: 'TWD',
		TZ: 'TZS',
		UA: 'UAH',
		UG: 'UGX',
		UM: 'USD',
		US: 'USD',
		UY: 'UYU',
		UZ: 'UZS',
		VA: 'EUR',
		VC: 'XCD',
		VE: 'VEF',
		VG: 'USD',
		VI: 'USD',
		VN: 'VND',
		VU: 'VUV',
		WF: 'XPF',
		WS: 'WST',
		YE: 'YER',
		YT: 'EUR',
		ZA: 'ZAR',
		ZM: 'ZMK',
		ZW: 'ZWL'
	};

	var currencies = {
		SEK: {
			format: function(value) {
				return value + ' :-';
			}
		},
		USD: {
			format: function(value) {
				return '$' + value;
			}
		},
		EUR: {
			format: function(value) {
				return '€' + value;
			}
		}
			
	};
	
	var currency = {

		getCurrency: function(locale) {
			if (!locale) {
				locale = navigator.language;
			}

			var dash = locale.indexOf("-");
			var lang = locale.substring(0, dash);
			var country = locale.substring(dash + 1);
			dash = country.indexOf("-");
			if (dash > -1) {
				country = country.substring(0, dash);
			}

			var currency = currencyMap[country];

			return currency;
		},

		format: function(value, options) {
			if (!options) {
				options = {};
			}
			if (!options.places === undefined) {
				options.places = 2;
			}
			if (!options.currency) {
				options.currency = this.getCurrency();
			}

			value = Currency.format(value, options);
			return value;
		}	
	};
	
	return currency;
});

},
'dojo/currency':function(){
define([
	"./_base/array",
	"./_base/lang",
	/*===== "./_base/declare", =====*/
	"./number",
	"./i18n", "./i18n!./cldr/nls/currency",
	"./cldr/monetary"
], function(darray, lang, /*===== declare, =====*/ dnumber, i18n, nlsCurrency, cldrMonetary){

// module:
//		dojo/currency

var currency = {
	// summary:
	//		localized formatting and parsing routines for currencies
	// description:
	//		extends dojo.number to provide culturally-appropriate formatting of values
	//		in various world currencies, including use of a currency symbol.  The currencies are specified
	//		by a three-letter international symbol in all uppercase, and support for the currencies is
	//		provided by the data in `dojo.cldr`.  The scripts generating dojo.cldr specify which
	//		currency support is included.  A fixed number of decimal places is determined based
	//		on the currency type and is not determined by the 'pattern' argument.  The fractional
	//		portion is optional, by default, and variable length decimals are not supported.
};
lang.setObject("dojo.currency", currency);

currency._mixInDefaults = function(options){
	options = options || {};
	options.type = "currency";

	// Get locale-dependent currency data, like the symbol
	var bundle = i18n.getLocalization("dojo.cldr", "currency", options.locale) || {};

	// Mixin locale-independent currency data, like # of places
	var iso = options.currency;
	var data = cldrMonetary.getData(iso);

	darray.forEach(["displayName","symbol","group","decimal"], function(prop){
		data[prop] = bundle[iso+"_"+prop];
	});

	data.fractional = [true, false];

	// Mixin with provided options
	return lang.mixin(data, options);
};

/*=====
currency.__FormatOptions = declare([dnumber.__FormatOptions], {
	// type: String?
	//		Should not be set.  Value is assumed to be "currency".
	// symbol: String?
	//		localized currency symbol. The default will be looked up in table of supported currencies in `dojo.cldr`
	//		A [ISO4217](http://en.wikipedia.org/wiki/ISO_4217) currency code will be used if not found.
	// currency: String?
	//		an [ISO4217](http://en.wikipedia.org/wiki/ISO_4217) currency code, a three letter sequence like "USD".
	//		For use with dojo.currency only.
	// places: Number?
	//		number of decimal places to show.  Default is defined based on which currency is used.
	type: "",
	symbol: "",
	currency: "",
	places: ""
});
=====*/

currency.format = function(/*Number*/ value, /*__FormatOptions?*/ options){
	// summary:
	//		Format a Number as a currency, using locale-specific settings
	//
	// description:
	//		Create a string from a Number using a known, localized pattern.
	//		[Formatting patterns](http://www.unicode.org/reports/tr35/#Number_Elements)
	//		appropriate to the locale are chosen from the [CLDR](http://unicode.org/cldr)
	//		as well as the appropriate symbols and delimiters and number of decimal places.
	//
	// value:
	//		the number to be formatted.

	return dnumber.format(value, currency._mixInDefaults(options));
};

currency.regexp = function(/*dnumber.__RegexpOptions?*/ options){
	//
	// summary:
	//		Builds the regular needed to parse a currency value
	//
	// description:
	//		Returns regular expression with positive and negative match, group and decimal separators
	//		Note: the options.places default, the number of decimal places to accept, is defined by the currency type.
	return dnumber.regexp(currency._mixInDefaults(options)); // String
};

/*=====
var __ParseOptions = currency.__ParseOptions = declare(dnumber.__ParseOptions, {
	// type: String?
	//		Should not be set.  Value is assumed to be currency.
	// currency: String?
	//		an [ISO4217](http://en.wikipedia.org/wiki/ISO_4217) currency code, a three letter sequence like "USD".
	//		For use with dojo.currency only.
	// symbol: String?
	//		localized currency symbol. The default will be looked up in table of supported currencies in `dojo.cldr`
	//		A [ISO4217](http://en.wikipedia.org/wiki/ISO_4217) currency code will be used if not found.
	// places: Number?
	//		fixed number of decimal places to accept.  The default is determined based on which currency is used.
	// fractional: Boolean|Array?
	//		Whether to include the fractional portion, where the number of decimal places are implied by the currency
	//		or explicit 'places' parameter.  The value [true,false] makes the fractional portion optional.
	//		By default for currencies, it the fractional portion is optional.
});
=====*/

currency.parse = function(/*String*/ expression, /*__ParseOptions?*/ options){
	//
	// summary:
	//		Convert a properly formatted currency string to a primitive Number,
	//		using locale-specific settings.
	// description:
	//		Create a Number from a string using a known, localized pattern.
	//		[Formatting patterns](http://www.unicode.org/reports/tr35/#Number_Format_Patterns)
	//		are chosen appropriate to the locale, as well as the appropriate symbols and delimiters
	//		and number of decimal places.
	// expression:
	//		A string representation of a currency value

	return dnumber.parse(expression, currency._mixInDefaults(options));
};

return currency;
});

},
'dojo/number':function(){
define([/*===== "./_base/declare", =====*/ "./_base/lang", "./i18n", "./i18n!./cldr/nls/number", "./string", "./regexp"],
	function(/*===== declare, =====*/ lang, i18n, nlsNumber, dstring, dregexp){

// module:
//		dojo/number

var number = {
	// summary:
	//		localized formatting and parsing routines for Number
};
lang.setObject("dojo.number", number);

/*=====
number.__FormatOptions = declare(null, {
	// pattern: String?
	//		override [formatting pattern](http://www.unicode.org/reports/tr35/#Number_Format_Patterns)
	//		with this string.  Default value is based on locale.  Overriding this property will defeat
	//		localization.  Literal characters in patterns are not supported.
	// type: String?
	//		choose a format type based on the locale from the following:
	//		decimal, scientific (not yet supported), percent, currency. decimal by default.
	// places: Number?
	//		fixed number of decimal places to show.  This overrides any
	//		information in the provided pattern.
	// round: Number?
	//		5 rounds to nearest .5; 0 rounds to nearest whole (default). -1
	//		means do not round.
	// locale: String?
	//		override the locale used to determine formatting rules
	// fractional: Boolean?
	//		If false, show no decimal places, overriding places and pattern settings.
});
=====*/

number.format = function(/*Number*/ value, /*number.__FormatOptions?*/ options){
	// summary:
	//		Format a Number as a String, using locale-specific settings
	// description:
	//		Create a string from a Number using a known localized pattern.
	//		Formatting patterns appropriate to the locale are chosen from the
	//		[Common Locale Data Repository](http://unicode.org/cldr) as well as the appropriate symbols and
	//		delimiters.
	//		If value is Infinity, -Infinity, or is not a valid JavaScript number, return null.
	// value:
	//		the number to be formatted

	options = lang.mixin({}, options || {});
	var locale = i18n.normalizeLocale(options.locale),
		bundle = i18n.getLocalization("dojo.cldr", "number", locale);
	options.customs = bundle;
	var pattern = options.pattern || bundle[(options.type || "decimal") + "Format"];
	if(isNaN(value) || Math.abs(value) == Infinity){ return null; } // null
	return number._applyPattern(value, pattern, options); // String
};

//number._numberPatternRE = /(?:[#0]*,?)*[#0](?:\.0*#*)?/; // not precise, but good enough
number._numberPatternRE = /[#0,]*[#0](?:\.0*#*)?/; // not precise, but good enough

number._applyPattern = function(/*Number*/ value, /*String*/ pattern, /*number.__FormatOptions?*/ options){
	// summary:
	//		Apply pattern to format value as a string using options. Gives no
	//		consideration to local customs.
	// value:
	//		the number to be formatted.
	// pattern:
	//		a pattern string as described by
	//		[unicode.org TR35](http://www.unicode.org/reports/tr35/#Number_Format_Patterns)
	// options: number.__FormatOptions?
	//		_applyPattern is usually called via `dojo/number.format()` which
	//		populates an extra property in the options parameter, "customs".
	//		The customs object specifies group and decimal parameters if set.

	//TODO: support escapes
	options = options || {};
	var group = options.customs.group,
		decimal = options.customs.decimal,
		patternList = pattern.split(';'),
		positivePattern = patternList[0];
	pattern = patternList[(value < 0) ? 1 : 0] || ("-" + positivePattern);

	//TODO: only test against unescaped
	if(pattern.indexOf('%') != -1){
		value *= 100;
	}else if(pattern.indexOf('\u2030') != -1){
		value *= 1000; // per mille
	}else if(pattern.indexOf('\u00a4') != -1){
		group = options.customs.currencyGroup || group;//mixins instead?
		decimal = options.customs.currencyDecimal || decimal;// Should these be mixins instead?
		pattern = pattern.replace(/([\s\xa0\u202f]*)(\u00a4{1,3})([\s\xa0\u202f]*)/, function(match, before, target, after){
			var prop = ["symbol", "currency", "displayName"][target.length-1],
				symbol = options[prop] || options.currency || "";
			// if there is no symbol, also remove surrounding whitespaces
			if(!symbol){
				return "";
			}
			return before+symbol+after;
		});
	}else if(pattern.indexOf('E') != -1){
		throw new Error("exponential notation not supported");
	}

	//TODO: support @ sig figs?
	var numberPatternRE = number._numberPatternRE;
	var numberPattern = positivePattern.match(numberPatternRE);
	if(!numberPattern){
		throw new Error("unable to find a number expression in pattern: "+pattern);
	}
	if(options.fractional === false){ options.places = 0; }
	return pattern.replace(numberPatternRE,
		number._formatAbsolute(value, numberPattern[0], {decimal: decimal, group: group, places: options.places, round: options.round}));
};

number.round = function(/*Number*/ value, /*Number?*/ places, /*Number?*/ increment){
	// summary:
	//		Rounds to the nearest value with the given number of decimal places, away from zero
	// description:
	//		Rounds to the nearest value with the given number of decimal places, away from zero if equal.
	//		Similar to Number.toFixed(), but compensates for browser quirks. Rounding can be done by
	//		fractional increments also, such as the nearest quarter.
	//		NOTE: Subject to floating point errors.  See dojox/math/round for experimental workaround.
	// value:
	//		The number to round
	// places:
	//		The number of decimal places where rounding takes place.  Defaults to 0 for whole rounding.
	//		Must be non-negative.
	// increment:
	//		Rounds next place to nearest value of increment/10.  10 by default.
	// example:
	// |	>>> number.round(-0.5)
	// |	-1
	// |	>>> number.round(162.295, 2)
	// |	162.29  // note floating point error.  Should be 162.3
	// |	>>> number.round(10.71, 0, 2.5)
	// |	10.75
	var factor = 10 / (increment || 10);
	return (factor * +value).toFixed(places) / factor; // Number
};

if((0.9).toFixed() == 0){
	// (isIE) toFixed() bug workaround: Rounding fails on IE when most significant digit
	// is just after the rounding place and is >=5
	var round = number.round;
	number.round = function(v, p, m){
		var d = Math.pow(10, -p || 0), a = Math.abs(v);
		if(!v || a >= d){
			d = 0;
		}else{
			a /= d;
			if(a < 0.5 || a >= 0.95){
				d = 0;
			}
		}
		return round(v, p, m) + (v > 0 ? d : -d);
	};

	// Use "doc hint" so the doc parser ignores this new definition of round(), and uses the one above.
	/*===== number.round = round; =====*/
}

/*=====
number.__FormatAbsoluteOptions = declare(null, {
	// decimal: String?
	//		the decimal separator
	// group: String?
	//		the group separator
	// places: Number|String?
	//		number of decimal places.  the range "n,m" will format to m places.
	// round: Number?
	//		5 rounds to nearest .5; 0 rounds to nearest whole (default). -1
	//		means don't round.
});
=====*/

number._formatAbsolute = function(/*Number*/ value, /*String*/ pattern, /*number.__FormatAbsoluteOptions?*/ options){
	// summary:
	//		Apply numeric pattern to absolute value using options. Gives no
	//		consideration to local customs.
	// value:
	//		the number to be formatted, ignores sign
	// pattern:
	//		the number portion of a pattern (e.g. `#,##0.00`)
	options = options || {};
	if(options.places === true){options.places=0;}
	if(options.places === Infinity){options.places=6;} // avoid a loop; pick a limit

	var patternParts = pattern.split("."),
		comma = typeof options.places == "string" && options.places.indexOf(","),
		maxPlaces = options.places;
	if(comma){
		maxPlaces = options.places.substring(comma + 1);
	}else if(!(maxPlaces >= 0)){
		maxPlaces = (patternParts[1] || []).length;
	}
	if(!(options.round < 0)){
		value = number.round(value, maxPlaces, options.round);
	}

	var valueParts = String(Math.abs(value)).split("."),
		fractional = valueParts[1] || "";
	if(patternParts[1] || options.places){
		if(comma){
			options.places = options.places.substring(0, comma);
		}
		// Pad fractional with trailing zeros
		var pad = options.places !== undefined ? options.places : (patternParts[1] && patternParts[1].lastIndexOf("0") + 1);
		if(pad > fractional.length){
			valueParts[1] = dstring.pad(fractional, pad, '0', true);
		}

		// Truncate fractional
		if(maxPlaces < fractional.length){
			valueParts[1] = fractional.substr(0, maxPlaces);
		}
	}else{
		if(valueParts[1]){ valueParts.pop(); }
	}

	// Pad whole with leading zeros
	var patternDigits = patternParts[0].replace(',', '');
	pad = patternDigits.indexOf("0");
	if(pad != -1){
		pad = patternDigits.length - pad;
		if(pad > valueParts[0].length){
			valueParts[0] = dstring.pad(valueParts[0], pad);
		}

		// Truncate whole
		if(patternDigits.indexOf("#") == -1){
			valueParts[0] = valueParts[0].substr(valueParts[0].length - pad);
		}
	}

	// Add group separators
	var index = patternParts[0].lastIndexOf(','),
		groupSize, groupSize2;
	if(index != -1){
		groupSize = patternParts[0].length - index - 1;
		var remainder = patternParts[0].substr(0, index);
		index = remainder.lastIndexOf(',');
		if(index != -1){
			groupSize2 = remainder.length - index - 1;
		}
	}
	var pieces = [];
	for(var whole = valueParts[0]; whole;){
		var off = whole.length - groupSize;
		pieces.push((off > 0) ? whole.substr(off) : whole);
		whole = (off > 0) ? whole.slice(0, off) : "";
		if(groupSize2){
			groupSize = groupSize2;
			groupSize2 = undefined;
		}
	}
	valueParts[0] = pieces.reverse().join(options.group || ",");

	return valueParts.join(options.decimal || ".");
};

/*=====
number.__RegexpOptions = declare(null, {
	// pattern: String?
	//		override [formatting pattern](http://www.unicode.org/reports/tr35/#Number_Format_Patterns)
	//		with this string.  Default value is based on locale.  Overriding this property will defeat
	//		localization.
	// type: String?
	//		choose a format type based on the locale from the following:
	//		decimal, scientific (not yet supported), percent, currency. decimal by default.
	// locale: String?
	//		override the locale used to determine formatting rules
	// strict: Boolean?
	//		strict parsing, false by default.  Strict parsing requires input as produced by the format() method.
	//		Non-strict is more permissive, e.g. flexible on white space, omitting thousands separators
	// places: Number|String?
	//		number of decimal places to accept: Infinity, a positive number, or
	//		a range "n,m".  Defined by pattern or Infinity if pattern not provided.
});
=====*/
number.regexp = function(/*number.__RegexpOptions?*/ options){
	// summary:
	//		Builds the regular needed to parse a number
	// description:
	//		Returns regular expression with positive and negative match, group
	//		and decimal separators
	return number._parseInfo(options).regexp; // String
};

number._parseInfo = function(/*Object?*/ options){
	options = options || {};
	var locale = i18n.normalizeLocale(options.locale),
		bundle = i18n.getLocalization("dojo.cldr", "number", locale),
		pattern = options.pattern || bundle[(options.type || "decimal") + "Format"],
//TODO: memoize?
		group = bundle.group,
		decimal = bundle.decimal,
		factor = 1;

	if(pattern.indexOf('%') != -1){
		factor /= 100;
	}else if(pattern.indexOf('\u2030') != -1){
		factor /= 1000; // per mille
	}else{
		var isCurrency = pattern.indexOf('\u00a4') != -1;
		if(isCurrency){
			group = bundle.currencyGroup || group;
			decimal = bundle.currencyDecimal || decimal;
		}
	}

	//TODO: handle quoted escapes
	var patternList = pattern.split(';');
	if(patternList.length == 1){
		patternList.push("-" + patternList[0]);
	}

	var re = dregexp.buildGroupRE(patternList, function(pattern){
		pattern = "(?:"+dregexp.escapeString(pattern, '.')+")";
		return pattern.replace(number._numberPatternRE, function(format){
			var flags = {
				signed: false,
				separator: options.strict ? group : [group,""],
				fractional: options.fractional,
				decimal: decimal,
				exponent: false
				},

				parts = format.split('.'),
				places = options.places;

			// special condition for percent (factor != 1)
			// allow decimal places even if not specified in pattern
			if(parts.length == 1 && factor != 1){
			    parts[1] = "###";
			}
			if(parts.length == 1 || places === 0){
				flags.fractional = false;
			}else{
				if(places === undefined){ places = options.pattern ? parts[1].lastIndexOf('0') + 1 : Infinity; }
				if(places && options.fractional == undefined){flags.fractional = true;} // required fractional, unless otherwise specified
				if(!options.places && (places < parts[1].length)){ places += "," + parts[1].length; }
				flags.places = places;
			}
			var groups = parts[0].split(',');
			if(groups.length > 1){
				flags.groupSize = groups.pop().length;
				if(groups.length > 1){
					flags.groupSize2 = groups.pop().length;
				}
			}
			return "("+number._realNumberRegexp(flags)+")";
		});
	}, true);

	if(isCurrency){
		// substitute the currency symbol for the placeholder in the pattern
		re = re.replace(/([\s\xa0\u202f]*)(\u00a4{1,3})([\s\xa0\u202f]*)/g, function(match, before, target, after){
			var prop = ["symbol", "currency", "displayName"][target.length-1],
				symbol = dregexp.escapeString(options[prop] || options.currency || "");

			// if there is no symbol there is no need to take white-spaces into account.
			if(!symbol){
				return "";
			}

			before = before ? "[\\s\\xa0\\u202f]" : "";
			after = after ? "[\\s\\xa0\\u202f]" : "";
			if(!options.strict){
				if(before){before += "*";}
				if(after){after += "*";}
				return "(?:"+before+symbol+after+")?";
			}
			return before+symbol+after;
		});
	}

//TODO: substitute localized sign/percent/permille/etc.?

	// normalize whitespace and return
	return {regexp: re.replace(/[\xa0\u202f ]/g, "[\\s\\xa0\\u202f]"), group: group, decimal: decimal, factor: factor}; // Object
};

/*=====
number.__ParseOptions = declare(null, {
	// pattern: String?
	//		override [formatting pattern](http://www.unicode.org/reports/tr35/#Number_Format_Patterns)
	//		with this string.  Default value is based on locale.  Overriding this property will defeat
	//		localization.  Literal characters in patterns are not supported.
	// type: String?
	//		choose a format type based on the locale from the following:
	//		decimal, scientific (not yet supported), percent, currency. decimal by default.
	// locale: String?
	//		override the locale used to determine formatting rules
	// strict: Boolean?
	//		strict parsing, false by default.  Strict parsing requires input as produced by the format() method.
	//		Non-strict is more permissive, e.g. flexible on white space, omitting thousands separators
	// fractional: Boolean|Array?
	//		Whether to include the fractional portion, where the number of decimal places are implied by pattern
	//		or explicit 'places' parameter.  The value [true,false] makes the fractional portion optional.
});
=====*/
number.parse = function(/*String*/ expression, /*number.__ParseOptions?*/ options){
	// summary:
	//		Convert a properly formatted string to a primitive Number, using
	//		locale-specific settings.
	// description:
	//		Create a Number from a string using a known localized pattern.
	//		Formatting patterns are chosen appropriate to the locale
	//		and follow the syntax described by
	//		[unicode.org TR35](http://www.unicode.org/reports/tr35/#Number_Format_Patterns)
    	//		Note that literal characters in patterns are not supported.
	// expression:
	//		A string representation of a Number
	var info = number._parseInfo(options),
		results = (new RegExp("^"+info.regexp+"$")).exec(expression);
	if(!results){
		return NaN; //NaN
	}
	var absoluteMatch = results[1]; // match for the positive expression
	if(!results[1]){
		if(!results[2]){
			return NaN; //NaN
		}
		// matched the negative pattern
		absoluteMatch =results[2];
		info.factor *= -1;
	}

	// Transform it to something Javascript can parse as a number.  Normalize
	// decimal point and strip out group separators or alternate forms of whitespace
	absoluteMatch = absoluteMatch.
		replace(new RegExp("["+info.group + "\\s\\xa0\\u202f"+"]", "g"), "").
		replace(info.decimal, ".");
	// Adjust for negative sign, percent, etc. as necessary
	return absoluteMatch * info.factor; //Number
};

/*=====
number.__RealNumberRegexpFlags = declare(null, {
	// places: Number?
	//		The integer number of decimal places or a range given as "n,m".  If
	//		not given, the decimal part is optional and the number of places is
	//		unlimited.
	// decimal: String?
	//		A string for the character used as the decimal point.  Default
	//		is ".".
	// fractional: Boolean|Array?
	//		Whether decimal places are used.  Can be true, false, or [true,
	//		false].  Default is [true, false] which means optional.
	// exponent: Boolean|Array?
	//		Express in exponential notation.  Can be true, false, or [true,
	//		false]. Default is [true, false], (i.e. will match if the
	//		exponential part is present are not).
	// eSigned: Boolean|Array?
	//		The leading plus-or-minus sign on the exponent.  Can be true,
	//		false, or [true, false].  Default is [true, false], (i.e. will
	//		match if it is signed or unsigned).  flags in regexp.integer can be
	//		applied.
});
=====*/

number._realNumberRegexp = function(/*__RealNumberRegexpFlags?*/ flags){
	// summary:
	//		Builds a regular expression to match a real number in exponential
	//		notation

	// assign default values to missing parameters
	flags = flags || {};
	//TODO: use mixin instead?
	if(!("places" in flags)){ flags.places = Infinity; }
	if(typeof flags.decimal != "string"){ flags.decimal = "."; }
	if(!("fractional" in flags) || /^0/.test(flags.places)){ flags.fractional = [true, false]; }
	if(!("exponent" in flags)){ flags.exponent = [true, false]; }
	if(!("eSigned" in flags)){ flags.eSigned = [true, false]; }

	var integerRE = number._integerRegexp(flags),
		decimalRE = dregexp.buildGroupRE(flags.fractional,
		function(q){
			var re = "";
			if(q && (flags.places!==0)){
				re = "\\" + flags.decimal;
				if(flags.places == Infinity){
					re = "(?:" + re + "\\d+)?";
				}else{
					re += "\\d{" + flags.places + "}";
				}
			}
			return re;
		},
		true
	);

	var exponentRE = dregexp.buildGroupRE(flags.exponent,
		function(q){
			if(q){ return "([eE]" + number._integerRegexp({ signed: flags.eSigned}) + ")"; }
			return "";
		}
	);

	var realRE = integerRE + decimalRE;
	// allow for decimals without integers, e.g. .25
	if(decimalRE){realRE = "(?:(?:"+ realRE + ")|(?:" + decimalRE + "))";}
	return realRE + exponentRE; // String
};

/*=====
number.__IntegerRegexpFlags = declare(null, {
	// signed: Boolean?
	//		The leading plus-or-minus sign. Can be true, false, or `[true,false]`.
	//		Default is `[true, false]`, (i.e. will match if it is signed
	//		or unsigned).
	// separator: String?
	//		The character used as the thousands separator. Default is no
	//		separator. For more than one symbol use an array, e.g. `[",", ""]`,
	//		makes ',' optional.
	// groupSize: Number?
	//		group size between separators
	// groupSize2: Number?
	//		second grouping, where separators 2..n have a different interval than the first separator (for India)
});
=====*/

number._integerRegexp = function(/*number.__IntegerRegexpFlags?*/ flags){
	// summary:
	//		Builds a regular expression that matches an integer

	// assign default values to missing parameters
	flags = flags || {};
	if(!("signed" in flags)){ flags.signed = [true, false]; }
	if(!("separator" in flags)){
		flags.separator = "";
	}else if(!("groupSize" in flags)){
		flags.groupSize = 3;
	}

	var signRE = dregexp.buildGroupRE(flags.signed,
		function(q){ return q ? "[-+]" : ""; },
		true
	);

	var numberRE = dregexp.buildGroupRE(flags.separator,
		function(sep){
			if(!sep){
				return "(?:\\d+)";
			}

			sep = dregexp.escapeString(sep);
			if(sep == " "){ sep = "\\s"; }
			else if(sep == "\xa0"){ sep = "\\s\\xa0"; }
			else if(sep == "\u202f"){ sep = "\\s\\u202f"; }

			var grp = flags.groupSize, grp2 = flags.groupSize2;
			//TODO: should we continue to enforce that numbers with separators begin with 1-9?  See #6933
			if(grp2){
				var grp2RE = "(?:0|[1-9]\\d{0," + (grp2-1) + "}(?:[" + sep + "]\\d{" + grp2 + "})*[" + sep + "]\\d{" + grp + "})";
				return ((grp-grp2) > 0) ? "(?:" + grp2RE + "|(?:0|[1-9]\\d{0," + (grp-1) + "}))" : grp2RE;
			}
			return "(?:0|[1-9]\\d{0," + (grp-1) + "}(?:[" + sep + "]\\d{" + grp + "})*)";
		},
		true
	);

	return signRE + numberRE; // String
};

return number;
});

},
'dojo/string':function(){
define([
	"./_base/kernel",	// kernel.global
	"./_base/lang"
], function(kernel, lang){

// module:
//		dojo/string
var ESCAPE_REGEXP = /[&<>'"\/]/g;
var ESCAPE_MAP = {
	'&': '&amp;',
	'<': '&lt;',
	'>': '&gt;',
	'"': '&quot;',
	"'": '&#x27;',
	'/': '&#x2F;'
};
var string = {
	// summary:
	//		String utilities for Dojo
};
lang.setObject("dojo.string", string);

string.escape = function(/*String*/str){
	// summary:
	//		Efficiently escape a string for insertion into HTML (innerHTML or attributes), replacing &, <, >, ", ', and / characters.
	// str:
	//		the string to escape
	if(!str){ return ""; }
	return str.replace(ESCAPE_REGEXP, function(c) {
		return ESCAPE_MAP[c];
	});
};

// Adapted from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/codePointAt#Polyfill
string.codePointAt = String.prototype.codePointAt ?
	function (str, position) {
		return String.prototype.codePointAt.call(str, position);
	} :
	function(str, position) {
		if (str == null) {
			throw new TypeError('codePointAt called on null or undefined');
		}

		var size;
		var first;
		var second;
		var index;

		str = String(str);
		size = str.length;
		// `ToInteger`
		index = position ? Number(position) : 0;

		if (index != index) { // better `isNaN`
			index = 0;
		}

		// Account for out-of-bounds indices:
		if (index < 0 || index >= size) {
			return undefined;
		}

		// Get the first code unit
		first = str.charCodeAt(index);

		// check if it's the start of a surrogate pair
		if (first >= 0xD800 && first <= 0xDBFF && // high surrogate
			size > index + 1 // there is a next code unit
		) {
			second = str.charCodeAt(index + 1);
			if (second >= 0xDC00 && second <= 0xDFFF) { // low surrogate
				// https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
				return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
			}
		}

		return first;
	};

// Adapted from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/fromCodePoint#Polyfill
string.fromCodePoint = String.fromCodePoint || function () {
	var codeUnits = [];
	var codeLen = 0;
	var result = "";
	var codePoint;
	var index;

	for (index = 0, len = arguments.length; index !== len; ++index) {
		codePoint = +arguments[index];
		// correctly handles all cases including `NaN`, `-Infinity`, `+Infinity`
		// The surrounding `!(...)` is required to correctly handle `NaN` cases
		// The (codePoint>>>0) === codePoint clause handles decimals and negatives
		if (!(codePoint < 0x10FFFF && (codePoint>>>0) === codePoint)) {
			throw RangeError("Invalid code point: " + codePoint);
		}

		if (codePoint <= 0xFFFF) { // BMP code point
			codeLen = codeUnits.push(codePoint);
		} else { // Astral code point; split in surrogate halves
			// https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
			codePoint -= 0x10000;
			codeLen = codeUnits.push(
				(codePoint >> 10) + 0xD800,  // highSurrogate
				(codePoint % 0x400) + 0xDC00 // lowSurrogate
			);
		}

		if (codeLen >= 0x3fff) {
			result += String.fromCharCode.apply(null, codeUnits);
			codeUnits.length = 0;
		}
	}

	return result + String.fromCharCode.apply(null, codeUnits);
};

string.rep = function(/*String*/str, /*Integer*/num){
	// summary:
	//		Efficiently replicate a string `n` times.
	// str:
	//		the string to replicate
	// num:
	//		number of times to replicate the string

	if(num <= 0 || !str){ return ""; }

	var buf = [];
	for(;;){
		if(num & 1){
			buf.push(str);
		}
		if(!(num >>= 1)){ break; }
		str += str;
	}
	return buf.join("");	// String
};

string.pad = function(/*String*/text, /*Integer*/size, /*String?*/ch, /*Boolean?*/end){
	// summary:
	//		Pad a string to guarantee that it is at least `size` length by
	//		filling with the character `ch` at either the start or end of the
	//		string. Pads at the start, by default.
	// text:
	//		the string to pad
	// size:
	//		length to provide padding
	// ch:
	//		character to pad, defaults to '0'
	// end:
	//		adds padding at the end if true, otherwise pads at start
	// example:
	//	|	// Fill the string to length 10 with "+" characters on the right.  Yields "Dojo++++++".
	//	|	string.pad("Dojo", 10, "+", true);

	if(!ch){
		ch = '0';
	}
	var out = String(text),
		pad = string.rep(ch, Math.ceil((size - out.length) / ch.length));
	return end ? out + pad : pad + out;	// String
};

string.substitute = function(	/*String*/		template,
									/*Object|Array*/map,
									/*Function?*/	transform,
									/*Object?*/		thisObject){
	// summary:
	//		Performs parameterized substitutions on a string. Throws an
	//		exception if any parameter is unmatched.
	// template:
	//		a string with expressions in the form `${key}` to be replaced or
	//		`${key:format}` which specifies a format function. keys are case-sensitive.
	//		The special sequence `${}` can be used escape `$`.
	// map:
	//		hash to search for substitutions
	// transform:
	//		a function to process all parameters before substitution takes
	//		place, e.g. mylib.encodeXML
	// thisObject:
	//		where to look for optional format function; default to the global
	//		namespace
	// example:
	//		Substitutes two expressions in a string from an Array or Object
	//	|	// returns "File 'foo.html' is not found in directory '/temp'."
	//	|	// by providing substitution data in an Array
	//	|	string.substitute(
	//	|		"File '${0}' is not found in directory '${1}'.",
	//	|		["foo.html","/temp"]
	//	|	);
	//	|
	//	|	// also returns "File 'foo.html' is not found in directory '/temp'."
	//	|	// but provides substitution data in an Object structure.  Dotted
	//	|	// notation may be used to traverse the structure.
	//	|	string.substitute(
	//	|		"File '${name}' is not found in directory '${info.dir}'.",
	//	|		{ name: "foo.html", info: { dir: "/temp" } }
	//	|	);
	// example:
	//		Use a transform function to modify the values:
	//	|	// returns "file 'foo.html' is not found in directory '/temp'."
	//	|	string.substitute(
	//	|		"${0} is not found in ${1}.",
	//	|		["foo.html","/temp"],
	//	|		function(str){
	//	|			// try to figure out the type
	//	|			var prefix = (str.charAt(0) == "/") ? "directory": "file";
	//	|			return prefix + " '" + str + "'";
	//	|		}
	//	|	);
	// example:
	//		Use a formatter
	//	|	// returns "thinger -- howdy"
	//	|	string.substitute(
	//	|		"${0:postfix}", ["thinger"], null, {
	//	|			postfix: function(value, key){
	//	|				return value + " -- howdy";
	//	|			}
	//	|		}
	//	|	);

	thisObject = thisObject || kernel.global;
	transform = transform ?
		lang.hitch(thisObject, transform) : function(v){ return v; };

	return template.replace(/\$\{([^\s\:\}]*)(?:\:([^\s\:\}]+))?\}/g,
		function(match, key, format){
			if (key == ''){
				return '$';
			}
			var value = lang.getObject(key, false, map);
			if(format){
				var formatMethod = lang.getObject(format, false, thisObject);
				if (formatMethod) {
					value = formatMethod.call(thisObject, value, key);
				}
			}

			if (value == undefined || value == null) {
				value = "";
			}

			return transform(value, key).toString();
		}); // String
};

string.trim = String.prototype.trim ?
	lang.trim : // aliasing to the native function
	function(str){
		str = str.replace(/^\s+/, '');
		for(var i = str.length - 1; i >= 0; i--){
			if(/\S/.test(str.charAt(i))){
				str = str.substring(0, i + 1);
				break;
			}
		}
		return str;
	};

/*=====
 string.trim = function(str){
	 // summary:
	 //		Trims whitespace from both sides of the string
	 // str: String
	 //		String to be trimmed
	 // returns: String
	 //		Returns the trimmed string
	 // description:
	 //		This version of trim() was taken from [Steven Levithan's blog](http://blog.stevenlevithan.com/archives/faster-trim-javascript).
	 //		The short yet performant version of this function is dojo/_base/lang.trim(),
	 //		which is part of Dojo base.  Uses String.prototype.trim instead, if available.
	 return "";	// String
 };
 =====*/

	return string;
});

},
'dojo/cldr/monetary':function(){
define(["../_base/kernel", "../_base/lang"], function(dojo, lang){

// module:
//		dojo/cldr/monetary

var monetary = {
	// summary:
	//		TODOC
};
lang.setObject("dojo.cldr.monetary", monetary);

monetary.getData = function(/*String*/ code){
	// summary:
	//		A mapping of currency code to currency-specific formatting information. Returns a unique object with properties: places, round.
	// code:
	//		an [ISO 4217](http://en.wikipedia.org/wiki/ISO_4217) currency code

	// from http://www.unicode.org/cldr/data/common/supplemental/supplementalData.xml:supplementalData/currencyData/fractions

	var placesData = {
		ADP:0,AFN:0,ALL:0,AMD:0,BHD:3,BIF:0,BYR:0,CLF:0,CLP:0,
		COP:2,CRC:0,DJF:0,ESP:0,GNF:0,GYD:0,HUF:0,IDR:0,IQD:0,
		IRR:3,ISK:0,ITL:0,JOD:3,JPY:0,KMF:0,KPW:0,KRW:0,KWD:3,
		LAK:0,LBP:0,LUF:0,LYD:3,MGA:0,MGF:0,MMK:0,MNT:0,MRO:0,
		MUR:0,OMR:3,PKR:2,PYG:0,RSD:0,RWF:0,SLL:0,SOS:0,STD:0,
		SYP:0,TMM:0,TND:3,TRL:0,TZS:0,UGX:0,UZS:0,VND:0,VUV:0,
		XAF:0,XOF:0,XPF:0,YER:0,ZMK:0,ZWD:0
	};

	var roundingData = {};

	var places = placesData[code], round = roundingData[code];
	if(typeof places == "undefined"){ places = 2; }
	if(typeof round == "undefined"){ round = 0; }

	return {places: places, round: round}; // Object
};

return monetary;
});

},
'appivo/ui/Alertify':function(){
/**
 * alertifyjs 1.11.0 http://alertifyjs.com
 * AlertifyJS is a javascript framework for developing pretty browser dialogs and notifications.
 * Copyright 2017 Mohammad Younes <Mohammad@alertifyjs.com> (http://alertifyjs.com) 
 * Licensed under GPL 3 <https://opensource.org/licenses/gpl-3.0>*/
( function ( window ) {
    'use strict';
    
    /**
     * Keys enum
     * @type {Object}
     */
    var keys = {
        ENTER: 13,
        ESC: 27,
        F1: 112,
        F12: 123,
        LEFT: 37,
        RIGHT: 39
    };
    /**
     * Default options 
     * @type {Object}
     */
    var defaults = {
        autoReset:true,
        basic:false,
        closable:true,
        closableByDimmer:true,
        frameless:false,
        maintainFocus:true, //global default not per instance, applies to all dialogs
        maximizable:true,
        modal:true,
        movable:true,
        moveBounded:false,
        overflow:true,
        padding: true,
        pinnable:true,
        pinned:true,
        preventBodyShift:false, //global default not per instance, applies to all dialogs
        resizable:true,
        startMaximized:false,
        transition:'pulse',
        notifier:{
            delay:5,
            position:'bottom-right',
            closeButton:false
        },
        glossary:{
            title:'AlertifyJS',
            ok: 'OK',
            cancel: 'Cancel',
            acccpt: 'Accept',
            deny: 'Deny',
            confirm: 'Confirm',
            decline: 'Decline',
            close: 'Close',
            maximize: 'Maximize',
            restore: 'Restore',
        },
        theme:{
            input:'ajs-input',
            ok:'ajs-ok',
            cancel:'ajs-cancel',
        }
    };
    
    //holds open dialogs instances
    var openDialogs = [];

    /**
     * [Helper]  Adds the specified class(es) to the element.
     *
     * @element {node}      The element
     * @className {string}  One or more space-separated classes to be added to the class attribute of the element.
     * 
     * @return {undefined}
     */
    function addClass(element,classNames){
        element.className += ' ' + classNames;
    }
    
    /**
     * [Helper]  Removes the specified class(es) from the element.
     *
     * @element {node}      The element
     * @className {string}  One or more space-separated classes to be removed from the class attribute of the element.
     * 
     * @return {undefined}
     */
    function removeClass(element, classNames) {
        var original = element.className.split(' ');
        var toBeRemoved = classNames.split(' ');
        for (var x = 0; x < toBeRemoved.length; x += 1) {
            var index = original.indexOf(toBeRemoved[x]);
            if (index > -1){
                original.splice(index,1);
            }
        }
        element.className = original.join(' ');
    }

    /**
     * [Helper]  Checks if the document is RTL
     *
     * @return {Boolean} True if the document is RTL, false otherwise.
     */
    function isRightToLeft(){
        return window.getComputedStyle(document.body).direction === 'rtl';
    }
    /**
     * [Helper]  Get the document current scrollTop
     *
     * @return {Number} current document scrollTop value
     */
    function getScrollTop(){
        return ((document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop);
    }

    /**
     * [Helper]  Get the document current scrollLeft
     *
     * @return {Number} current document scrollLeft value
     */
    function getScrollLeft(){
        return ((document.documentElement && document.documentElement.scrollLeft) || document.body.scrollLeft);
    }

    /**
    * Helper: clear contents
    *
    */
    function clearContents(element){
        while (element.lastChild) {
            element.removeChild(element.lastChild);
        }
    }
    /**
     * Extends a given prototype by merging properties from base into sub.
     *
     * @sub {Object} sub The prototype being overwritten.
     * @base {Object} base The prototype being written.
     *
     * @return {Object} The extended prototype.
     */
    function copy(src) {
        if(null === src){
            return src;
        }
        var cpy;
        if(Array.isArray(src)){
            cpy = [];
            for(var x=0;x<src.length;x+=1){
                cpy.push(copy(src[x]));
            }
            return cpy;
        }
      
        if(src instanceof Date){
            return new Date(src.getTime());
        }
      
        if(src instanceof RegExp){
            // nosemgrep: detect-non-literal-regexp
            cpy = new RegExp(src.source);
            cpy.global = src.global;
            cpy.ignoreCase = src.ignoreCase;
            cpy.multiline = src.multiline;
            cpy.lastIndex = src.lastIndex;
            return cpy;
        }
        
        if(typeof src === 'object'){
            cpy = {};
            // copy dialog pototype over definition.
            for (var prop in src) {
                if (src.hasOwnProperty(prop)) {
                    cpy[prop] = copy(src[prop]);
                }
            }
            return cpy;
        }
        return src;
    }
    /**
      * Helper: destruct the dialog
      *
      */
    function destruct(instance, initialize){
        //delete the dom and it's references.
        var root = instance.elements.root;
        root.parentNode.removeChild(root);
        delete instance.elements;
        //copy back initial settings.
        instance.settings = copy(instance.__settings);
        //re-reference init function.
        instance.__init = initialize;
        //delete __internal variable to allow re-initialization.
        delete instance.__internal;
    }

    /**
     * Use a closure to return proper event listener method. Try to use
     * `addEventListener` by default but fallback to `attachEvent` for
     * unsupported browser. The closure simply ensures that the test doesn't
     * happen every time the method is called.
     *
     * @param    {Node}     el    Node element
     * @param    {String}   event Event type
     * @param    {Function} fn    Callback of event
     * @return   {Function}
     */
    var on = (function () {
        if (document.addEventListener) {
            return function (el, event, fn, useCapture) {
                el.addEventListener(event, fn, useCapture === true);
            };
        } else if (document.attachEvent) {
            return function (el, event, fn) {
                el.attachEvent('on' + event, fn);
            };
        }
    }());

    /**
     * Use a closure to return proper event listener method. Try to use
     * `removeEventListener` by default but fallback to `detachEvent` for
     * unsupported browser. The closure simply ensures that the test doesn't
     * happen every time the method is called.
     *
     * @param    {Node}     el    Node element
     * @param    {String}   event Event type
     * @param    {Function} fn    Callback of event
     * @return   {Function}
     */
    var off = (function () {
        if (document.removeEventListener) {
            return function (el, event, fn, useCapture) {
                el.removeEventListener(event, fn, useCapture === true);
            };
        } else if (document.detachEvent) {
            return function (el, event, fn) {
                el.detachEvent('on' + event, fn);
            };
        }
    }());

    /**
     * Prevent default event from firing
     *
     * @param  {Event} event Event object
     * @return {undefined}

    function prevent ( event ) {
        if ( event ) {
            if ( event.preventDefault ) {
                event.preventDefault();
            } else {
                event.returnValue = false;
            }
        }
    }
    */
    var transition = (function () {
        var t, type;
        var supported = false;
        var transitions = {
            'animation'        : 'animationend',
            'OAnimation'       : 'oAnimationEnd oanimationend',
            'msAnimation'      : 'MSAnimationEnd',
            'MozAnimation'     : 'animationend',
            'WebkitAnimation'  : 'webkitAnimationEnd'
        };

        for (t in transitions) {
            if (document.documentElement.style[t] !== undefined) {
                type = transitions[t];
                supported = true;
                break;
            }
        }

        return {
            type: type,
            supported: supported
        };
    }());

    /**
    * Creates event handler delegate that sends the instance as last argument.
    * 
    * @return {Function}    a function wrapper which sends the instance as last argument.
    */
    function delegate(context, method) {
        return function () {
            if (arguments.length > 0) {
                var args = [];
                for (var x = 0; x < arguments.length; x += 1) {
                    args.push(arguments[x]);
                }
                args.push(context);
                return method.apply(context, args);
            }
            return method.apply(context, [null, context]);
        };
    }
    /**
    * Helper for creating a dialog close event.
    * 
    * @return {object}
    */
    function createCloseEvent(index, button) {
        return {
            index: index,
            button: button,
            cancel: false
        };
    }
    /**
    * Helper for dispatching events.
    *
    * @param  {string} evenType The type of the event to disptach.
    * @param  {object} instance The dialog instance disptaching the event.
    *
    * @return   {any}   The result of the invoked function.
    */
    function dispatchEvent(eventType, instance) {
        if ( typeof instance.get(eventType) === 'function' ) {
            return instance.get(eventType).call(instance);
        }
    }


    /**
     * Super class for all dialogs
     *
     * @return {Object}		base dialog prototype
     */
    var dialog = (function () {
        var //holds the list of used keys.
            usedKeys = [],
            //dummy variable, used to trigger dom reflow.
            reflow = null,
            //condition for detecting safari
            isSafari = window.navigator.userAgent.indexOf('Safari') > -1 && window.navigator.userAgent.indexOf('Chrome') < 0,
            //dialog building blocks
            templates = {
                dimmer:'<div class="ajs-dimmer"></div>',
                /*tab index required to fire click event before body focus*/
                modal: '<div class="ajs-modal" tabindex="0"></div>',
                dialog: '<div class="ajs-dialog" tabindex="0"></div>',
                reset: '<button class="ajs-reset"></button>',
                commands: '<div class="ajs-commands"><button class="ajs-pin"></button><button class="ajs-maximize"></button><button class="ajs-close"></button></div>',
                header: '<div class="ajs-header"></div>',
                body: '<div class="ajs-body"></div>',
                content: '<div class="ajs-content"></div>',
                footer: '<div class="ajs-footer"></div>',
                buttons: { primary: '<div class="ajs-primary ajs-buttons"></div>', auxiliary: '<div class="ajs-auxiliary ajs-buttons"></div>' },
                button: '<button class="ajs-button"></button>',
                resizeHandle: '<div class="ajs-handle"></div>',
            },
            //common class names
            classes = {
                animationIn: 'ajs-in',
                animationOut: 'ajs-out',
                base: 'alertify',
                basic:'ajs-basic',
                capture: 'ajs-capture',
                closable:'ajs-closable',
                fixed: 'ajs-fixed',
                frameless:'ajs-frameless',
                hidden: 'ajs-hidden',
                maximize: 'ajs-maximize',
                maximized: 'ajs-maximized',
                maximizable:'ajs-maximizable',
                modeless: 'ajs-modeless',
                movable: 'ajs-movable',
                noSelection: 'ajs-no-selection',
                noOverflow: 'ajs-no-overflow',
                noPadding:'ajs-no-padding',
                pin:'ajs-pin',
                pinnable:'ajs-pinnable',
                prefix: 'ajs-',
                resizable: 'ajs-resizable',
                restore: 'ajs-restore',
                shake:'ajs-shake',
                unpinned:'ajs-unpinned',
            };

        /**
         * Helper: initializes the dialog instance
         * 
         * @return	{Number}	The total count of currently open modals.
         */
        function initialize(instance){
            
            if(!instance.__internal){

                //no need to expose init after this.
                delete instance.__init;
              
                //keep a copy of initial dialog settings
                if(!instance.__settings){
                    instance.__settings = copy(instance.settings);
                }
                //in case the script was included before body.
                //after first dialog gets initialized, it won't be null anymore!
                if(null === reflow){
                    // set tabindex attribute on body element this allows script to give it
                    // focus after the dialog is closed
                    document.body.setAttribute( 'tabindex', '0' );
                }

                //get dialog buttons/focus setup
                var setup;
                if(typeof instance.setup === 'function'){
                    setup = instance.setup();
                    setup.options = setup.options  || {};
                    setup.focus = setup.focus  || {};
                }else{
                    setup = {
                        buttons:[],
                        focus:{
                            element:null,
                            select:false
                        },
                        options:{
                        }
                    };
                }
                
                //initialize hooks object.
                if(typeof instance.hooks !== 'object'){
                    instance.hooks = {};
                }

                //copy buttons defintion
                var buttonsDefinition = [];
                if(Array.isArray(setup.buttons)){
                    for(var b=0;b<setup.buttons.length;b+=1){
                        var ref  = setup.buttons[b],
                            cpy = {};
                        for (var i in ref) {
                            if (ref.hasOwnProperty(i)) {
                                cpy[i] = ref[i];
                            }
                        }
                        buttonsDefinition.push(cpy);
                    }
                }

                var internal = instance.__internal = {
                    /**
                     * Flag holding the open state of the dialog
                     * 
                     * @type {Boolean}
                     */
                    isOpen:false,
                    /**
                     * Active element is the element that will receive focus after
                     * closing the dialog. It defaults as the body tag, but gets updated
                     * to the last focused element before the dialog was opened.
                     *
                     * @type {Node}
                     */
                    activeElement:document.body,
                    timerIn:undefined,
                    timerOut:undefined,
                    buttons: buttonsDefinition,
                    focus: setup.focus,
                    options: {
                        title: undefined,
                        modal: undefined,
                        basic:undefined,
                        frameless:undefined,
                        pinned: undefined,
                        movable: undefined,
                        moveBounded:undefined,
                        resizable: undefined,
                        autoReset: undefined,
                        closable: undefined,
                        closableByDimmer: undefined,
                        maximizable: undefined,
                        startMaximized: undefined,
                        pinnable: undefined,
                        transition: undefined,
                        padding:undefined,
                        overflow:undefined,
                        onshow:undefined,
                        onclosing:undefined,
                        onclose:undefined,
                        onfocus:undefined,
                        onmove:undefined,
                        onmoved:undefined,
                        onresize:undefined,
                        onresized:undefined,
                        onmaximize:undefined,
                        onmaximized:undefined,
                        onrestore:undefined,
                        onrestored:undefined
                    },
                    resetHandler:undefined,
                    beginMoveHandler:undefined,
                    beginResizeHandler:undefined,
                    bringToFrontHandler:undefined,
                    modalClickHandler:undefined,
                    buttonsClickHandler:undefined,
                    commandsClickHandler:undefined,
                    transitionInHandler:undefined,
                    transitionOutHandler:undefined,
                    destroy:undefined
                };

                var elements = {};
                //root node
                elements.root = document.createElement('div');
                
                elements.root.className = classes.base + ' ' + classes.hidden + ' ';

                // nosemgrep: insecure-document-method
                elements.root.innerHTML = templates.dimmer + templates.modal;
                
                //dimmer
                elements.dimmer = elements.root.firstChild;

                //dialog
                elements.modal = elements.root.lastChild;
                // nosemgrep: insecure-document-method
                elements.modal.innerHTML = templates.dialog;
                elements.dialog = elements.modal.firstChild;
                // nosemgrep: insecure-document-method
                elements.dialog.innerHTML = templates.reset + templates.commands + templates.header + templates.body + templates.footer + templates.resizeHandle + templates.reset;

                //reset links
                elements.reset = [];
                elements.reset.push(elements.dialog.firstChild);
                elements.reset.push(elements.dialog.lastChild);
                
                //commands
                elements.commands = {};
                elements.commands.container = elements.reset[0].nextSibling;
                elements.commands.pin = elements.commands.container.firstChild;
                elements.commands.maximize = elements.commands.pin.nextSibling;
                elements.commands.close = elements.commands.maximize.nextSibling;
                
                //header
                elements.header = elements.commands.container.nextSibling;

                //body
                elements.body = elements.header.nextSibling;
                // nosemgrep: insecure-document-method
                elements.body.innerHTML = templates.content;
                elements.content = elements.body.firstChild;

                //footer
                elements.footer = elements.body.nextSibling;
                // nosemgrep: insecure-document-method
                elements.footer.innerHTML = templates.buttons.auxiliary + templates.buttons.primary;
                
                //resize handle
                elements.resizeHandle = elements.footer.nextSibling;

                //buttons
                elements.buttons = {};
                elements.buttons.auxiliary = elements.footer.firstChild;
                elements.buttons.primary = elements.buttons.auxiliary.nextSibling;
                // nosemgrep: insecure-document-method
                elements.buttons.primary.innerHTML = templates.button;
                elements.buttonTemplate = elements.buttons.primary.firstChild;
                //remove button template
                elements.buttons.primary.removeChild(elements.buttonTemplate);
                               
                for(var x=0; x < instance.__internal.buttons.length; x+=1) {
                    var button = instance.__internal.buttons[x];
                    
                    // add to the list of used keys.
                    if(usedKeys.indexOf(button.key) < 0){
                        usedKeys.push(button.key);
                    }

                    button.element = elements.buttonTemplate.cloneNode();
                    // nosemgrep: insecure-document-method
                    button.element.innerHTML = button.text;
                    if(typeof button.className === 'string' &&  button.className !== ''){
                        addClass(button.element, button.className);
                    }
                    for(var key in button.attrs){
                        if(key !== 'className' && button.attrs.hasOwnProperty(key)){
                            button.element.setAttribute(key, button.attrs[key]);
                        }
                    }
                    if(button.scope === 'auxiliary'){
                        elements.buttons.auxiliary.appendChild(button.element);
                    }else{
                        elements.buttons.primary.appendChild(button.element);
                    }
                }
                //make elements pubic
                instance.elements = elements;
                
                //save event handlers delegates
                internal.resetHandler = delegate(instance, onReset);
                internal.beginMoveHandler = delegate(instance, beginMove);
                internal.beginResizeHandler = delegate(instance, beginResize);
                internal.bringToFrontHandler = delegate(instance, bringToFront);
                internal.modalClickHandler = delegate(instance, modalClickHandler);
                internal.buttonsClickHandler = delegate(instance, buttonsClickHandler);
                internal.commandsClickHandler = delegate(instance, commandsClickHandler);
                internal.transitionInHandler = delegate(instance, handleTransitionInEvent);
                internal.transitionOutHandler = delegate(instance, handleTransitionOutEvent);

                //settings
                for(var opKey in internal.options){
                    if(setup.options[opKey] !== undefined){
                        // if found in user options
                        instance.set(opKey, setup.options[opKey]);
                    }else if(alertify.defaults.hasOwnProperty(opKey)) {
                        // else if found in defaults options
                        instance.set(opKey, alertify.defaults[opKey]);
                    }else if(opKey === 'title' ) {
                        // else if title key, use alertify.defaults.glossary
                        instance.set(opKey, alertify.defaults.glossary[opKey]);
                    }
                }

                // allow dom customization
                if(typeof instance.build === 'function'){
                    instance.build();
                }
            }
            
            //add to the end of the DOM tree.
            document.body.appendChild(instance.elements.root);
        }

        /**
         * Helper: maintains scroll position
         *
         */
        var scrollX, scrollY;
        function saveScrollPosition(){
            scrollX = getScrollLeft();
            scrollY = getScrollTop();
        }
        function restoreScrollPosition(){
            window.scrollTo(scrollX, scrollY);
        }

        /**
         * Helper: adds/removes no-overflow class from body
         *
         */
        function ensureNoOverflow(){
            var requiresNoOverflow = 0;
            for(var x=0;x<openDialogs.length;x+=1){
                var instance = openDialogs[x];
                if(instance.isModal() || instance.isMaximized()){
                    requiresNoOverflow+=1;
                }
            }
            if(requiresNoOverflow === 0 && document.body.className.indexOf(classes.noOverflow) >= 0){
                //last open modal or last maximized one
                removeClass(document.body, classes.noOverflow);
                preventBodyShift(false);
            }else if(requiresNoOverflow > 0 && document.body.className.indexOf(classes.noOverflow) < 0){
                //first open modal or first maximized one
                preventBodyShift(true);
                addClass(document.body, classes.noOverflow);
            }
        }
        var top = '', topScroll = 0;
        /**
         * Helper: prevents body shift.
         *
         */
        function preventBodyShift(add){
            if(alertify.defaults.preventBodyShift && document.documentElement.scrollHeight > document.documentElement.clientHeight){
                if(add ){//&& openDialogs[openDialogs.length-1].elements.dialog.clientHeight <= document.documentElement.clientHeight){
                    topScroll = scrollY;
                    top = window.getComputedStyle(document.body).top;
                    addClass(document.body, classes.fixed);
                    document.body.style.top = -scrollY + 'px';
                } else {
                    scrollY = topScroll;
                    document.body.style.top = top;
                    removeClass(document.body, classes.fixed);
                    restoreScrollPosition();
                }
            }
        }
		
        /**
         * Sets the name of the transition used to show/hide the dialog
         * 
         * @param {Object} instance The dilog instance.
         *
         */
        function updateTransition(instance, value, oldValue){
            if(typeof oldValue === 'string'){
                removeClass(instance.elements.root,classes.prefix +  oldValue);
            }
            addClass(instance.elements.root, classes.prefix + value);
            reflow = instance.elements.root.offsetWidth;
        }
		
        /**
         * Toggles the dialog display mode
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function updateDisplayMode(instance){
            if(instance.get('modal')){

                //make modal
                removeClass(instance.elements.root, classes.modeless);

                //only if open
                if(instance.isOpen()){
                    unbindModelessEvents(instance);

                    //in case a pinned modless dialog was made modal while open.
                    updateAbsPositionFix(instance);

                    ensureNoOverflow();
                }
            }else{
                //make modelss
                addClass(instance.elements.root, classes.modeless);

                //only if open
                if(instance.isOpen()){
                    bindModelessEvents(instance);

                    //in case pin/unpin was called while a modal is open
                    updateAbsPositionFix(instance);

                    ensureNoOverflow();
                }
            }
        }

        /**
         * Toggles the dialog basic view mode 
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function updateBasicMode(instance){
            if (instance.get('basic')) {
                // add class
                addClass(instance.elements.root, classes.basic);
            } else {
                // remove class
                removeClass(instance.elements.root, classes.basic);
            }
        }

        /**
         * Toggles the dialog frameless view mode 
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function updateFramelessMode(instance){
            if (instance.get('frameless')) {
                // add class
                addClass(instance.elements.root, classes.frameless);
            } else {
                // remove class
                removeClass(instance.elements.root, classes.frameless);
            }
        }
		
        /**
         * Helper: Brings the modeless dialog to front, attached to modeless dialogs.
         *
         * @param {Event} event Focus event
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function bringToFront(event, instance){
            
            // Do not bring to front if preceeded by an open modal
            var index = openDialogs.indexOf(instance);
            for(var x=index+1;x<openDialogs.length;x+=1){
                if(openDialogs[x].isModal()){
                    return;
                }
            }
			
            // Bring to front by making it the last child.
            if(document.body.lastChild !== instance.elements.root){
                document.body.appendChild(instance.elements.root);
                //also make sure its at the end of the list
                openDialogs.splice(openDialogs.indexOf(instance),1);
                openDialogs.push(instance);
                setFocus(instance);
            }
			
            return false;
        }
		
        /**
         * Helper: reflects dialogs options updates
         *
         * @param {Object} instance The dilog instance.
         * @param {String} option The updated option name.
         *
         * @return	{undefined}	
         */
        function optionUpdated(instance, option, oldValue, newValue){
            switch(option){
            case 'title':
                instance.setHeader(newValue);
                break;
            case 'modal':
                updateDisplayMode(instance);
                break;
            case 'basic':
                updateBasicMode(instance);
                break;
            case 'frameless':
                updateFramelessMode(instance);
                break;
            case 'pinned':
                updatePinned(instance);
                break;
            case 'closable':
                updateClosable(instance);
                break;
            case 'maximizable':
                updateMaximizable(instance);
                break;
            case 'pinnable':
                updatePinnable(instance);
                break;
            case 'movable':
                updateMovable(instance);
                break;
            case 'resizable':
                updateResizable(instance);
                break;
            case 'transition':
                updateTransition(instance,newValue, oldValue);
                break;
            case 'padding':
                if(newValue){
                    removeClass(instance.elements.root, classes.noPadding);
                }else if(instance.elements.root.className.indexOf(classes.noPadding) < 0){
                    addClass(instance.elements.root, classes.noPadding);
                }
                break;
            case 'overflow':
                if(newValue){
                    removeClass(instance.elements.root, classes.noOverflow);
                }else if(instance.elements.root.className.indexOf(classes.noOverflow) < 0){
                    addClass(instance.elements.root, classes.noOverflow);
                }
                break;
            case 'transition':
                updateTransition(instance,newValue, oldValue);
                break;
            }

            // internal on option updated event
            if(typeof instance.hooks.onupdate === 'function'){
                instance.hooks.onupdate.call(instance, option, oldValue, newValue);
            }
        }
		
        /**
         * Helper: reflects dialogs options updates
         *
         * @param {Object} instance The dilog instance.
         * @param {Object} obj The object to set/get a value on/from.
         * @param {Function} callback The callback function to call if the key was found.
         * @param {String|Object} key A string specifying a propery name or a collection of key value pairs.
         * @param {Object} value Optional, the value associated with the key (in case it was a string).
         * @param {String} option The updated option name.
         *
         * @return	{Object} result object 
         *	The result objects has an 'op' property, indicating of this is a SET or GET operation.
         *		GET: 
         *		- found: a flag indicating if the key was found or not.
         *		- value: the property value.
         *		SET:
         *		- items: a list of key value pairs of the properties being set.
         *				each contains:
         *					- found: a flag indicating if the key was found or not.
         *					- key: the property key.
         *					- value: the property value.
         */
        function update(instance, obj, callback, key, value){
            var result = {op:undefined, items: [] };
            if(typeof value === 'undefined' && typeof key === 'string') {
                //get
                result.op = 'get';
                if(obj.hasOwnProperty(key)){
                    result.found = true;
                    result.value = obj[key];
                }else{
                    result.found = false;
                    result.value = undefined;
                }
            }
            else
            {
                var old;
                //set
                result.op = 'set';
                if(typeof key === 'object'){
                    //set multiple
                    var args = key;
                    for (var prop in args) {
                        if (obj.hasOwnProperty(prop)) {
                            if(obj[prop] !== args[prop]){
                                old = obj[prop];
                                obj[prop] = args[prop];
                                callback.call(instance,prop, old, args[prop]);
                            }
                            result.items.push({ 'key': prop, 'value': args[prop], 'found':true});
                        }else{
                            result.items.push({ 'key': prop, 'value': args[prop], 'found':false});
                        }
                    }
                } else if (typeof key === 'string'){
                    //set single
                    if (obj.hasOwnProperty(key)) {
                        if(obj[key] !== value){
                            old  = obj[key];
                            obj[key] = value;
                            callback.call(instance,key, old, value);
                        }
                        result.items.push({'key': key, 'value': value , 'found':true});

                    }else{
                        result.items.push({'key': key, 'value': value , 'found':false});
                    }
                } else {
                    //invalid params
                    throw new Error('args must be a string or object');
                }
            }
            return result;
        }


        /**
         * Triggers a close event.
         *
         * @param {Object} instance	The dilog instance.
         * 
         * @return {undefined}
         */
        function triggerClose(instance) {
            var found;
            triggerCallback(instance, function (button) {
                return found = (button.invokeOnClose === true);
            });
            //none of the buttons registered as onclose callback
            //close the dialog
            if (!found && instance.isOpen()) {
                instance.close();
            }
        }

        /**
         * Dialogs commands event handler, attached to the dialog commands element.
         *
         * @param {Event} event	DOM event object.
         * @param {Object} instance	The dilog instance.
         * 
         * @return {undefined}
         */
        function commandsClickHandler(event, instance) {
            var target = event.srcElement || event.target;
            switch (target) {
            case instance.elements.commands.pin:
                if (!instance.isPinned()) {
                    pin(instance);
                } else {
                    unpin(instance);
                }
                break;
            case instance.elements.commands.maximize:
                if (!instance.isMaximized()) {
                    maximize(instance);
                } else {
                    restore(instance);
                }
                break;
            case instance.elements.commands.close:
                triggerClose(instance);
                break;
            }
            return false;
        }

        /**
         * Helper: pins the modeless dialog.
         *
         * @param {Object} instance	The dialog instance.
         * 
         * @return {undefined}
         */
        function pin(instance) {
            //pin the dialog
            instance.set('pinned', true);
        }

        /**
         * Helper: unpins the modeless dialog.
         *
         * @param {Object} instance	The dilog instance.
         * 
         * @return {undefined}
         */
        function unpin(instance) {
            //unpin the dialog 
            instance.set('pinned', false);
        }


        /**
         * Helper: enlarges the dialog to fill the entire screen.
         *
         * @param {Object} instance	The dilog instance.
         * 
         * @return {undefined}
         */
        function maximize(instance) {
            // allow custom `onmaximize` method
            dispatchEvent('onmaximize', instance);
            //maximize the dialog 
            addClass(instance.elements.root, classes.maximized);
            if (instance.isOpen()) {
                ensureNoOverflow();
            }
            // allow custom `onmaximized` method
            dispatchEvent('onmaximized', instance);
        }

        /**
         * Helper: returns the dialog to its former size.
         *
         * @param {Object} instance	The dilog instance.
         * 
         * @return {undefined}
         */
        function restore(instance) {
            // allow custom `onrestore` method
            dispatchEvent('onrestore', instance);
            //maximize the dialog 
            removeClass(instance.elements.root, classes.maximized);
            if (instance.isOpen()) {
                ensureNoOverflow();
            }
            // allow custom `onrestored` method
            dispatchEvent('onrestored', instance);
        }

        /**
         * Show or hide the maximize box.
         *
         * @param {Object} instance The dilog instance.
         * @param {Boolean} on True to add the behavior, removes it otherwise.
         *
         * @return {undefined}
         */
        function updatePinnable(instance) {
            if (instance.get('pinnable')) {
                // add class
                addClass(instance.elements.root, classes.pinnable);
            } else {
                // remove class
                removeClass(instance.elements.root, classes.pinnable);
            }
        }

        /**
         * Helper: Fixes the absolutly positioned modal div position.
         *
         * @param {Object} instance The dialog instance.
         *
         * @return {undefined}
         */
        function addAbsPositionFix(instance) {
            var scrollLeft = getScrollLeft();
            instance.elements.modal.style.marginTop = getScrollTop() + 'px';
            instance.elements.modal.style.marginLeft = scrollLeft + 'px';
            instance.elements.modal.style.marginRight = (-scrollLeft) + 'px';
        }

        /**
         * Helper: Removes the absolutly positioned modal div position fix.
         *
         * @param {Object} instance The dialog instance.
         *
         * @return {undefined}
         */
        function removeAbsPositionFix(instance) {
            var marginTop = parseInt(instance.elements.modal.style.marginTop, 10);
            var marginLeft = parseInt(instance.elements.modal.style.marginLeft, 10);
            instance.elements.modal.style.marginTop = '';
            instance.elements.modal.style.marginLeft = '';
            instance.elements.modal.style.marginRight = '';

            if (instance.isOpen()) {
                var top = 0,
                    left = 0
                ;
                if (instance.elements.dialog.style.top !== '') {
                    top = parseInt(instance.elements.dialog.style.top, 10);
                }
                instance.elements.dialog.style.top = (top + (marginTop - getScrollTop())) + 'px';

                if (instance.elements.dialog.style.left !== '') {
                    left = parseInt(instance.elements.dialog.style.left, 10);
                }
                instance.elements.dialog.style.left = (left + (marginLeft - getScrollLeft())) + 'px';
            }
        }
        /**
         * Helper: Adds/Removes the absolutly positioned modal div position fix based on its pinned setting.
         *
         * @param {Object} instance The dialog instance.
         *
         * @return {undefined}
         */
        function updateAbsPositionFix(instance) {
            // if modeless and unpinned add fix
            if (!instance.get('modal') && !instance.get('pinned')) {
                addAbsPositionFix(instance);
            } else {
                removeAbsPositionFix(instance);
            }
        }
        /**
         * Toggles the dialog position lock | modeless only.
         *
         * @param {Object} instance The dilog instance.
         * @param {Boolean} on True to make it modal, false otherwise.
         *
         * @return {undefined}
         */
        function updatePinned(instance) {
            if (instance.get('pinned')) {
                removeClass(instance.elements.root, classes.unpinned);
                if (instance.isOpen()) {
                    removeAbsPositionFix(instance);
                }
            } else {
                addClass(instance.elements.root, classes.unpinned);
                if (instance.isOpen() && !instance.isModal()) {
                    addAbsPositionFix(instance);
                }
            }
        }

        /**
         * Show or hide the maximize box.
         *
         * @param {Object} instance The dilog instance.
         * @param {Boolean} on True to add the behavior, removes it otherwise.
         *
         * @return {undefined}
         */
        function updateMaximizable(instance) {
            if (instance.get('maximizable')) {
                // add class
                addClass(instance.elements.root, classes.maximizable);
            } else {
                // remove class
                removeClass(instance.elements.root, classes.maximizable);
            }
        }

        /**
         * Show or hide the close box.
         *
         * @param {Object} instance The dilog instance.
         * @param {Boolean} on True to add the behavior, removes it otherwise.
         *
         * @return {undefined}
         */
        function updateClosable(instance) {
            if (instance.get('closable')) {
                // add class
                addClass(instance.elements.root, classes.closable);
                bindClosableEvents(instance);
            } else {
                // remove class
                removeClass(instance.elements.root, classes.closable);
                unbindClosableEvents(instance);
            }
        }

        // flag to cancel click event if already handled by end resize event (the mousedown, mousemove, mouseup sequence fires a click event.).
        var cancelClick = false;

        /**
         * Helper: closes the modal dialog when clicking the modal
         *
         * @param {Event} event	DOM event object.
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function modalClickHandler(event, instance) {
            var target = event.srcElement || event.target;
            if (!cancelClick && target === instance.elements.modal && instance.get('closableByDimmer') === true) {
                triggerClose(instance);
            }
            cancelClick = false;
            return false;
        }

        // flag to cancel keyup event if already handled by click event (pressing Enter on a focusted button).
        var cancelKeyup = false;
        /** 
         * Helper: triggers a button callback
         *
         * @param {Object}		The dilog instance.
         * @param {Function}	Callback to check which button triggered the event.
         *
         * @return {undefined}
         */
        function triggerCallback(instance, check) {
            for (var idx = 0; idx < instance.__internal.buttons.length; idx += 1) {
                var button = instance.__internal.buttons[idx];
                if (!button.element.disabled && check(button)) {
                    var closeEvent = createCloseEvent(idx, button);
                    if (typeof instance.callback === 'function') {
                        instance.callback.apply(instance, [closeEvent]);
                    }
                    //close the dialog only if not canceled.
                    if (closeEvent.cancel === false) {
                        instance.close();
                    }
                    break;
                }
            }
        }

        /**
         * Clicks event handler, attached to the dialog footer.
         *
         * @param {Event}		DOM event object.
         * @param {Object}		The dilog instance.
         * 
         * @return {undefined}
         */
        function buttonsClickHandler(event, instance) {
            var target = event.srcElement || event.target;
            triggerCallback(instance, function (button) {
                // if this button caused the click, cancel keyup event
                return button.element === target && (cancelKeyup = true);
            });
        }

        /**
         * Keyup event handler, attached to the document.body
         *
         * @param {Event}		DOM event object.
         * @param {Object}		The dilog instance.
         * 
         * @return {undefined}
         */
        function keyupHandler(event) {
            //hitting enter while button has focus will trigger keyup too.
            //ignore if handled by clickHandler
            if (cancelKeyup) {
                cancelKeyup = false;
                return;
            }
            var instance = openDialogs[openDialogs.length - 1];
            var keyCode = event.keyCode;
            if (instance.__internal.buttons.length === 0 && keyCode === keys.ESC && instance.get('closable') === true) {
                triggerClose(instance);
                return false;
            }else if (usedKeys.indexOf(keyCode) > -1) {
                triggerCallback(instance, function (button) {
                    return button.key === keyCode;
                });
                return false;
            }
        }
        /**
        * Keydown event handler, attached to the document.body
        *
        * @param {Event}		DOM event object.
        * @param {Object}		The dilog instance.
        * 
        * @return {undefined}
        */
        function keydownHandler(event) {
            var instance = openDialogs[openDialogs.length - 1];
            var keyCode = event.keyCode;
            if (keyCode === keys.LEFT || keyCode === keys.RIGHT) {
                var buttons = instance.__internal.buttons;
                for (var x = 0; x < buttons.length; x += 1) {
                    if (document.activeElement === buttons[x].element) {
                        switch (keyCode) {
                        case keys.LEFT:
                            buttons[(x || buttons.length) - 1].element.focus();
                            return;
                        case keys.RIGHT:
                            buttons[(x + 1) % buttons.length].element.focus();
                            return;
                        }
                    }
                }
            }else if (keyCode < keys.F12 + 1 && keyCode > keys.F1 - 1 && usedKeys.indexOf(keyCode) > -1) {
                event.preventDefault();
                event.stopPropagation();
                triggerCallback(instance, function (button) {
                    return button.key === keyCode;
                });
                return false;
            }
        }


        /**
         * Sets focus to proper dialog element
         *
         * @param {Object} instance The dilog instance.
         * @param {Node} [resetTarget=undefined] DOM element to reset focus to.
         *
         * @return {undefined}
         */
        function setFocus(instance, resetTarget) {
            // reset target has already been determined.
            if (resetTarget) {
                resetTarget.focus();
            } else {
                // current instance focus settings
                var focus = instance.__internal.focus;
                // the focus element.
                var element = focus.element;

                switch (typeof focus.element) {
                // a number means a button index
                case 'number':
                    if (instance.__internal.buttons.length > focus.element) {
                        //in basic view, skip focusing the buttons.
                        if (instance.get('basic') === true) {
                            element = instance.elements.reset[0];
                        } else {
                            element = instance.__internal.buttons[focus.element].element;
                        }
                    }
                    break;
                // a string means querySelector to select from dialog body contents.
                case 'string':
                    element = instance.elements.body.querySelector(focus.element);
                    break;
                // a function should return the focus element.
                case 'function':
                    element = focus.element.call(instance);
                    break;
                }
                
                // if no focus element, default to first reset element.
                if ((typeof element === 'undefined' || element === null) && instance.__internal.buttons.length === 0) {
                    element = instance.elements.reset[0];
                }
                // focus
                if (element && element.focus) {
                    element.focus();
                    // if selectable
                    if (focus.select && element.select) {
                        element.select();
                    }
                }
            }
        }

        /**
         * Focus event handler, attached to document.body and dialogs own reset links.
         * handles the focus for modal dialogs only.
         *
         * @param {Event} event DOM focus event object.
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function onReset(event, instance) {

            // should work on last modal if triggered from document.body 
            if (!instance) {
                for (var x = openDialogs.length - 1; x > -1; x -= 1) {
                    if (openDialogs[x].isModal()) {
                        instance = openDialogs[x];
                        break;
                    }
                }
            }
            // if modal
            if (instance && instance.isModal()) {
                // determine reset target to enable forward/backward tab cycle.
                var resetTarget, target = event.srcElement || event.target;
                var lastResetElement = target === instance.elements.reset[1] || (instance.__internal.buttons.length === 0 && target === document.body);

                // if last reset link, then go to maximize or close
                if (lastResetElement) {
                    if (instance.get('maximizable')) {
                        resetTarget = instance.elements.commands.maximize;
                    } else if (instance.get('closable')) {
                        resetTarget = instance.elements.commands.close;
                    }
                }
                // if no reset target found, try finding the best button
                if (resetTarget === undefined) {
                    if (typeof instance.__internal.focus.element === 'number') {
                        // button focus element, go to first available button
                        if (target === instance.elements.reset[0]) {
                            resetTarget = instance.elements.buttons.auxiliary.firstChild || instance.elements.buttons.primary.firstChild;
                        } else if (lastResetElement) {
                            //restart the cycle by going to first reset link
                            resetTarget = instance.elements.reset[0];
                        }
                    } else {
                        // will reach here when tapping backwards, so go to last child
                        // The focus element SHOULD NOT be a button (logically!).
                        if (target === instance.elements.reset[0]) {
                            resetTarget = instance.elements.buttons.primary.lastChild || instance.elements.buttons.auxiliary.lastChild;
                        }
                    }
                }
                // focus
                setFocus(instance, resetTarget);
            }
        }
        /**
         * Transition in transitionend event handler. 
         *
         * @param {Event}		TransitionEnd event object.
         * @param {Object}		The dilog instance.
         *
         * @return {undefined}
         */
        function handleTransitionInEvent(event, instance) {
            // clear the timer
            clearTimeout(instance.__internal.timerIn);

            // once transition is complete, set focus
            setFocus(instance);

            //restore scroll to prevent document jump
            restoreScrollPosition();

            // allow handling key up after transition ended.
            cancelKeyup = false;

            // allow custom `onfocus` method
            dispatchEvent('onfocus', instance);

            // unbind the event
            off(instance.elements.dialog, transition.type, instance.__internal.transitionInHandler);

            removeClass(instance.elements.root, classes.animationIn);
        }

        /**
         * Transition out transitionend event handler. 
         *
         * @param {Event}		TransitionEnd event object.
         * @param {Object}		The dilog instance.
         *
         * @return {undefined}
         */
        function handleTransitionOutEvent(event, instance) {
            // clear the timer
            clearTimeout(instance.__internal.timerOut);
            // unbind the event
            off(instance.elements.dialog, transition.type, instance.__internal.transitionOutHandler);

            // reset move updates
            resetMove(instance);
            // reset resize updates
            resetResize(instance);

            // restore if maximized
            if (instance.isMaximized() && !instance.get('startMaximized')) {
                restore(instance);
            }

            // return focus to the last active element
            if (alertify.defaults.maintainFocus && instance.__internal.activeElement) {
                instance.__internal.activeElement.focus();
                instance.__internal.activeElement = null;
            }
            
            //destory the instance
            if (typeof instance.__internal.destroy === 'function') {
                instance.__internal.destroy.apply(instance);
            }
        }
        /* Controls moving a dialog around */
        //holde the current moving instance
        var movable = null,
            //holds the current X offset when move starts
            offsetX = 0,
            //holds the current Y offset when move starts
            offsetY = 0,
            xProp = 'pageX',
            yProp = 'pageY',
            bounds = null,
            refreshTop = false,
            moveDelegate = null
        ;

        /**
         * Helper: sets the element top/left coordinates
         *
         * @param {Event} event	DOM event object.
         * @param {Node} element The element being moved.
         * 
         * @return {undefined}
         */
        function moveElement(event, element) {
            var left = (event[xProp] - offsetX),
                top  = (event[yProp] - offsetY);

            if(refreshTop){
                top -= document.body.scrollTop;
            }
           
            element.style.left = left + 'px';
            element.style.top = top + 'px';
           
        }
        /**
         * Helper: sets the element top/left coordinates within screen bounds
         *
         * @param {Event} event	DOM event object.
         * @param {Node} element The element being moved.
         * 
         * @return {undefined}
         */
        function moveElementBounded(event, element) {
            var left = (event[xProp] - offsetX),
                top  = (event[yProp] - offsetY);

            if(refreshTop){
                top -= document.body.scrollTop;
            }
            
            element.style.left = Math.min(bounds.maxLeft, Math.max(bounds.minLeft, left)) + 'px';
            if(refreshTop){
                element.style.top = Math.min(bounds.maxTop, Math.max(bounds.minTop, top)) + 'px';
            }else{
                element.style.top = Math.max(bounds.minTop, top) + 'px';
            }
        }
            

        /**
         * Triggers the start of a move event, attached to the header element mouse down event.
         * Adds no-selection class to the body, disabling selection while moving.
         *
         * @param {Event} event	DOM event object.
         * @param {Object} instance The dilog instance.
         * 
         * @return {Boolean} false
         */
        function beginMove(event, instance) {
            if (resizable === null && !instance.isMaximized() && instance.get('movable')) {
                var eventSrc, left=0, top=0;
                if (event.type === 'touchstart') {
                    event.preventDefault();
                    eventSrc = event.targetTouches[0];
                    xProp = 'clientX';
                    yProp = 'clientY';
                } else if (event.button === 0) {
                    eventSrc = event;
                }

                if (eventSrc) {

                    var element = instance.elements.dialog;
                    addClass(element, classes.capture);

                    if (element.style.left) {
                        left = parseInt(element.style.left, 10);
                    }

                    if (element.style.top) {
                        top = parseInt(element.style.top, 10);
                    }
                    
                    offsetX = eventSrc[xProp] - left;
                    offsetY = eventSrc[yProp] - top;

                    if(instance.isModal()){
                        offsetY += instance.elements.modal.scrollTop;
                    }else if(instance.isPinned()){
                        offsetY -= document.body.scrollTop;
                    }
                    
                    if(instance.get('moveBounded')){
                        var current = element,
                            offsetLeft = -left,
                            offsetTop = -top;
                        
                        //calc offset
                        do {
                            offsetLeft += current.offsetLeft;
                            offsetTop += current.offsetTop;
                        } while (current = current.offsetParent);
                        
                        bounds = {
                            maxLeft : offsetLeft,
                            minLeft : -offsetLeft,
                            maxTop  : document.documentElement.clientHeight - element.clientHeight - offsetTop,
                            minTop  : -offsetTop
                        };
                        moveDelegate = moveElementBounded;
                    }else{
                        bounds = null;
                        moveDelegate = moveElement;
                    }
                    
                    // allow custom `onmove` method
                    dispatchEvent('onmove', instance);

                    refreshTop = !instance.isModal() && instance.isPinned();
                    movable = instance;
                    moveDelegate(eventSrc, element);
                    addClass(document.body, classes.noSelection);
                    return false;
                }
            }
        }

        /**
         * The actual move handler,  attached to document.body mousemove event.
         *
         * @param {Event} event	DOM event object.
         * 
         * @return {undefined}
         */
        function move(event) {
            if (movable) {
                var eventSrc;
                if (event.type === 'touchmove') {
                    event.preventDefault();
                    eventSrc = event.targetTouches[0];
                } else if (event.button === 0) {
                    eventSrc = event;
                }
                if (eventSrc) {
                    moveDelegate(eventSrc, movable.elements.dialog);
                }
            }
        }

        /**
         * Triggers the end of a move event,  attached to document.body mouseup event.
         * Removes no-selection class from document.body, allowing selection.
         *
         * @return {undefined}
         */
        function endMove() {
            if (movable) {
                var instance = movable;
                movable = bounds = null;
                removeClass(document.body, classes.noSelection);
                removeClass(instance.elements.dialog, classes.capture);
                // allow custom `onmoved` method
                dispatchEvent('onmoved', instance);
            }
        }

        /**
         * Resets any changes made by moving the element to its original state,
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function resetMove(instance) {
            movable = null;
            var element = instance.elements.dialog;
            element.style.left = element.style.top = '';
        }

        /**
         * Updates the dialog move behavior.
         *
         * @param {Object} instance The dilog instance.
         * @param {Boolean} on True to add the behavior, removes it otherwise.
         *
         * @return {undefined}
         */
        function updateMovable(instance) {
            if (instance.get('movable')) {
                // add class
                addClass(instance.elements.root, classes.movable);
                if (instance.isOpen()) {
                    bindMovableEvents(instance);
                }
            } else {

                //reset
                resetMove(instance);
                // remove class
                removeClass(instance.elements.root, classes.movable);
                if (instance.isOpen()) {
                    unbindMovableEvents(instance);
                }
            }
        }

        /* Controls moving a dialog around */
        //holde the current instance being resized		
        var resizable = null,
            //holds the staring left offset when resize starts.
            startingLeft = Number.Nan,
            //holds the staring width when resize starts.
            startingWidth = 0,
            //holds the initial width when resized for the first time.
            minWidth = 0,
            //holds the offset of the resize handle.
            handleOffset = 0
        ;

        /**
         * Helper: sets the element width/height and updates left coordinate if neccessary.
         *
         * @param {Event} event	DOM mousemove event object.
         * @param {Node} element The element being moved.
         * @param {Boolean} pinned A flag indicating if the element being resized is pinned to the screen.
         * 
         * @return {undefined}
         */
        function resizeElement(event, element, pageRelative) {

            //calculate offsets from 0,0
            var current = element;
            var offsetLeft = 0;
            var offsetTop = 0;
            do {
                offsetLeft += current.offsetLeft;
                offsetTop += current.offsetTop;
            } while (current = current.offsetParent);

            // determine X,Y coordinates.
            var X, Y;
            if (pageRelative === true) {
                X = event.pageX;
                Y = event.pageY;
            } else {
                X = event.clientX;
                Y = event.clientY;
            }
            // rtl handling
            var isRTL = isRightToLeft();
            if (isRTL) {
                // reverse X 
                X = document.body.offsetWidth - X;
                // if has a starting left, calculate offsetRight
                if (!isNaN(startingLeft)) {
                    offsetLeft = document.body.offsetWidth - offsetLeft - element.offsetWidth;
                }
            }

            // set width/height
            element.style.height = (Y - offsetTop + handleOffset) + 'px';
            element.style.width = (X - offsetLeft + handleOffset) + 'px';

            // if the element being resized has a starting left, maintain it.
            // the dialog is centered, divide by half the offset to maintain the margins.
            if (!isNaN(startingLeft)) {
                var diff = Math.abs(element.offsetWidth - startingWidth) * 0.5;
                if (isRTL) {
                    //negate the diff, why?
                    //when growing it should decrease left
                    //when shrinking it should increase left
                    diff *= -1;
                }
                if (element.offsetWidth > startingWidth) {
                    //growing
                    element.style.left = (startingLeft + diff) + 'px';
                } else if (element.offsetWidth >= minWidth) {
                    //shrinking
                    element.style.left = (startingLeft - diff) + 'px';
                }
            }
        }

        /**
         * Triggers the start of a resize event, attached to the resize handle element mouse down event.
         * Adds no-selection class to the body, disabling selection while moving.
         *
         * @param {Event} event	DOM event object.
         * @param {Object} instance The dilog instance.
         * 
         * @return {Boolean} false
         */
        function beginResize(event, instance) {
            if (!instance.isMaximized()) {
                var eventSrc;
                if (event.type === 'touchstart') {
                    event.preventDefault();
                    eventSrc = event.targetTouches[0];
                } else if (event.button === 0) {
                    eventSrc = event;
                }
                if (eventSrc) {
                    // allow custom `onresize` method
                    dispatchEvent('onresize', instance);
                    
                    resizable = instance;
                    handleOffset = instance.elements.resizeHandle.offsetHeight / 2;
                    var element = instance.elements.dialog;
                    addClass(element, classes.capture);
                    startingLeft = parseInt(element.style.left, 10);
                    element.style.height = element.offsetHeight + 'px';
                    element.style.minHeight = instance.elements.header.offsetHeight + instance.elements.footer.offsetHeight + 'px';
                    element.style.width = (startingWidth = element.offsetWidth) + 'px';

                    if (element.style.maxWidth !== 'none') {
                        element.style.minWidth = (minWidth = element.offsetWidth) + 'px';
                    }
                    element.style.maxWidth = 'none';
                    addClass(document.body, classes.noSelection);
                    return false;
                }
            }
        }

        /**
         * The actual resize handler,  attached to document.body mousemove event.
         *
         * @param {Event} event	DOM event object.
         * 
         * @return {undefined}
         */
        function resize(event) {
            if (resizable) {
                var eventSrc;
                if (event.type === 'touchmove') {
                    event.preventDefault();
                    eventSrc = event.targetTouches[0];
                } else if (event.button === 0) {
                    eventSrc = event;
                }
                if (eventSrc) {
                    resizeElement(eventSrc, resizable.elements.dialog, !resizable.get('modal') && !resizable.get('pinned'));
                }
            }
        }

        /**
         * Triggers the end of a resize event,  attached to document.body mouseup event.
         * Removes no-selection class from document.body, allowing selection.
         *
         * @return {undefined}
         */
        function endResize() {
            if (resizable) {
                var instance = resizable;
                resizable = null;
                removeClass(document.body, classes.noSelection);
                removeClass(instance.elements.dialog, classes.capture);
                cancelClick = true;
                // allow custom `onresized` method
                dispatchEvent('onresized', instance);
            }
        }

        /**
         * Resets any changes made by resizing the element to its original state.
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function resetResize(instance) {
            resizable = null;
            var element = instance.elements.dialog;
            if (element.style.maxWidth === 'none') {
                //clear inline styles.
                element.style.maxWidth = element.style.minWidth = element.style.width = element.style.height = element.style.minHeight = element.style.left = '';
                //reset variables.
                startingLeft = Number.Nan;
                startingWidth = minWidth = handleOffset = 0;
            }
        }


        /**
         * Updates the dialog move behavior.
         *
         * @param {Object} instance The dilog instance.
         * @param {Boolean} on True to add the behavior, removes it otherwise.
         *
         * @return {undefined}
         */
        function updateResizable(instance) {
            if (instance.get('resizable')) {
                // add class
                addClass(instance.elements.root, classes.resizable);
                if (instance.isOpen()) {
                    bindResizableEvents(instance);
                }
            } else {
                //reset
                resetResize(instance);
                // remove class
                removeClass(instance.elements.root, classes.resizable);
                if (instance.isOpen()) {
                    unbindResizableEvents(instance);
                }
            }
        }

        /**
         * Reset move/resize on window resize.
         *
         * @param {Event} event	window resize event object.
         *
         * @return {undefined}
         */
        function windowResize(/*event*/) {
            for (var x = 0; x < openDialogs.length; x += 1) {
                var instance = openDialogs[x];
                if (instance.get('autoReset')) {
                    resetMove(instance);
                    resetResize(instance);
                }
            }
        }
        /**
         * Bind dialogs events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function bindEvents(instance) {
            // if first dialog, hook global handlers
            if (openDialogs.length === 1) {
                //global
                on(window, 'resize', windowResize);
                on(document.body, 'keyup', keyupHandler);
                on(document.body, 'keydown', keydownHandler);
                on(document.body, 'focus', onReset);

                //move
                on(document.documentElement, 'mousemove', move);
                on(document.documentElement, 'touchmove', move);
                on(document.documentElement, 'mouseup', endMove);
                on(document.documentElement, 'touchend', endMove);
                //resize
                on(document.documentElement, 'mousemove', resize);
                on(document.documentElement, 'touchmove', resize);
                on(document.documentElement, 'mouseup', endResize);
                on(document.documentElement, 'touchend', endResize);
            }

            // common events
            on(instance.elements.commands.container, 'click', instance.__internal.commandsClickHandler);
            on(instance.elements.footer, 'click', instance.__internal.buttonsClickHandler);
            on(instance.elements.reset[0], 'focus', instance.__internal.resetHandler);
            on(instance.elements.reset[1], 'focus', instance.__internal.resetHandler);

            //prevent handling key up when dialog is being opened by a key stroke.
            cancelKeyup = true;
            // hook in transition handler
            on(instance.elements.dialog, transition.type, instance.__internal.transitionInHandler);

            // modelss only events
            if (!instance.get('modal')) {
                bindModelessEvents(instance);
            }

            // resizable
            if (instance.get('resizable')) {
                bindResizableEvents(instance);
            }

            // movable
            if (instance.get('movable')) {
                bindMovableEvents(instance);
            }
        }

        /**
         * Unbind dialogs events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function unbindEvents(instance) {
            // if last dialog, remove global handlers
            if (openDialogs.length === 1) {
                //global
                off(window, 'resize', windowResize);
                off(document.body, 'keyup', keyupHandler);
                off(document.body, 'keydown', keydownHandler);
                off(document.body, 'focus', onReset);
                //move
                off(document.documentElement, 'mousemove', move);
                off(document.documentElement, 'mouseup', endMove);
                //resize
                off(document.documentElement, 'mousemove', resize);
                off(document.documentElement, 'mouseup', endResize);
            }

            // common events
            off(instance.elements.commands.container, 'click', instance.__internal.commandsClickHandler);
            off(instance.elements.footer, 'click', instance.__internal.buttonsClickHandler);
            off(instance.elements.reset[0], 'focus', instance.__internal.resetHandler);
            off(instance.elements.reset[1], 'focus', instance.__internal.resetHandler);

            // hook out transition handler
            on(instance.elements.dialog, transition.type, instance.__internal.transitionOutHandler);

            // modelss only events
            if (!instance.get('modal')) {
                unbindModelessEvents(instance);
            }

            // movable
            if (instance.get('movable')) {
                unbindMovableEvents(instance);
            }

            // resizable
            if (instance.get('resizable')) {
                unbindResizableEvents(instance);
            }

        }

        /**
         * Bind modeless specific events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function bindModelessEvents(instance) {
            on(instance.elements.dialog, 'focus', instance.__internal.bringToFrontHandler, true);
        }

        /**
         * Unbind modeless specific events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function unbindModelessEvents(instance) {
            off(instance.elements.dialog, 'focus', instance.__internal.bringToFrontHandler, true);
        }



        /**
         * Bind movable specific events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function bindMovableEvents(instance) {
            on(instance.elements.header, 'mousedown', instance.__internal.beginMoveHandler);
            on(instance.elements.header, 'touchstart', instance.__internal.beginMoveHandler);
        }

        /**
         * Unbind movable specific events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function unbindMovableEvents(instance) {
            off(instance.elements.header, 'mousedown', instance.__internal.beginMoveHandler);
            off(instance.elements.header, 'touchstart', instance.__internal.beginMoveHandler);
        }



        /**
         * Bind resizable specific events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function bindResizableEvents(instance) {
            on(instance.elements.resizeHandle, 'mousedown', instance.__internal.beginResizeHandler);
            on(instance.elements.resizeHandle, 'touchstart', instance.__internal.beginResizeHandler);
        }

        /**
         * Unbind resizable specific events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function unbindResizableEvents(instance) {
            off(instance.elements.resizeHandle, 'mousedown', instance.__internal.beginResizeHandler);
            off(instance.elements.resizeHandle, 'touchstart', instance.__internal.beginResizeHandler);
        }

        /**
         * Bind closable events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function bindClosableEvents(instance) {
            on(instance.elements.modal, 'click', instance.__internal.modalClickHandler);
        }

        /**
         * Unbind closable specific events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function unbindClosableEvents(instance) {
            off(instance.elements.modal, 'click', instance.__internal.modalClickHandler);
        }
        // dialog API
        return {
            __init:initialize,
            /**
             * Check if dialog is currently open
             *
             * @return {Boolean}
             */
            isOpen: function () {
                return this.__internal.isOpen;
            },
            isModal: function (){
                return this.elements.root.className.indexOf(classes.modeless) < 0;
            },
            isMaximized:function(){
                return this.elements.root.className.indexOf(classes.maximized) > -1;
            },
            isPinned:function(){
                return this.elements.root.className.indexOf(classes.unpinned) < 0;
            },
            maximize:function(){
                if(!this.isMaximized()){
                    maximize(this);
                }
                return this;
            },
            restore:function(){
                if(this.isMaximized()){
                    restore(this);
                }
                return this;
            },
            pin:function(){
                if(!this.isPinned()){
                    pin(this);
                }
                return this;
            },
            unpin:function(){
                if(this.isPinned()){
                    unpin(this);
                }
                return this;
            },
            bringToFront:function(){
                bringToFront(null, this);
                return this;
            },
            /**
             * Move the dialog to a specific x/y coordinates
             *
             * @param {Number} x    The new dialog x coordinate in pixels.
             * @param {Number} y    The new dialog y coordinate in pixels.
             *
             * @return {Object} The dialog instance.
             */
            moveTo:function(x,y){
                if(!isNaN(x) && !isNaN(y)){
                    // allow custom `onmove` method
                    dispatchEvent('onmove', this);
                    
                    var element = this.elements.dialog,
                        current = element,
                        offsetLeft = 0,
                        offsetTop = 0;
                    
                    //subtract existing left,top
                    if (element.style.left) {
                        offsetLeft -= parseInt(element.style.left, 10);
                    }
                    if (element.style.top) {
                        offsetTop -= parseInt(element.style.top, 10);
                    }
                    //calc offset
                    do {
                        offsetLeft += current.offsetLeft;
                        offsetTop += current.offsetTop;
                    } while (current = current.offsetParent);

                    //calc left, top
                    var left = (x - offsetLeft);
                    var top  = (y - offsetTop);

                    //// rtl handling
                    if (isRightToLeft()) {
                        left *= -1;
                    }

                    element.style.left = left + 'px';
                    element.style.top = top + 'px';
                    
                    // allow custom `onmoved` method
                    dispatchEvent('onmoved', this);
                }
                return this;
            },
            /**
             * Resize the dialog to a specific width/height (the dialog must be 'resizable').
             * The dialog can be resized to:
             *  A minimum width equal to the initial display width
             *  A minimum height equal to the sum of header/footer heights.
             *
             *
             * @param {Number or String} width    The new dialog width in pixels or in percent.
             * @param {Number or String} height   The new dialog height in pixels or in percent.
             *
             * @return {Object} The dialog instance.
             */
            resizeTo:function(width,height){
                var w = parseFloat(width),
                    h = parseFloat(height),
                    regex = /(\d*\.\d+|\d+)%/
                ;

                if(!isNaN(w) && !isNaN(h) && this.get('resizable') === true){
                    
                    // allow custom `onresize` method
                    dispatchEvent('onresize', this);
                    
                    if(('' + width).match(regex)){
                        w = w / 100 * document.documentElement.clientWidth ;
                    }

                    if(('' + height).match(regex)){
                        h = h / 100 * document.documentElement.clientHeight;
                    }

                    var element = this.elements.dialog;
                    if (element.style.maxWidth !== 'none') {
                        element.style.minWidth = (minWidth = element.offsetWidth) + 'px';
                    }
                    element.style.maxWidth = 'none';
                    element.style.minHeight = this.elements.header.offsetHeight + this.elements.footer.offsetHeight + 'px';
                    element.style.width = w + 'px';
                    element.style.height = h + 'px';
                    
                    // allow custom `onresized` method
                    dispatchEvent('onresized', this);
                }
                return this;
            },
            /**
             * Gets or Sets dialog settings/options 
             *
             * @param {String|Object} key A string specifying a propery name or a collection of key/value pairs.
             * @param {Object} value Optional, the value associated with the key (in case it was a string).
             *
             * @return {undefined}
             */
            setting : function (key, value) {
                var self = this;
                var result = update(this, this.__internal.options, function(k,o,n){ optionUpdated(self,k,o,n); }, key, value);
                if(result.op === 'get'){
                    if(result.found){
                        return result.value;
                    }else if(typeof this.settings !== 'undefined'){
                        return update(this, this.settings, this.settingUpdated || function(){}, key, value).value;
                    }else{
                        return undefined;
                    }
                }else if(result.op === 'set'){
                    if(result.items.length > 0){
                        var callback = this.settingUpdated || function(){};
                        for(var x=0;x<result.items.length;x+=1){
                            var item = result.items[x];
                            if(!item.found && typeof this.settings !== 'undefined'){
                                update(this, this.settings, callback, item.key, item.value);
                            }
                        }
                    }
                    return this;
                }
            },
            /**
             * [Alias] Sets dialog settings/options 
             */
            set:function(key, value){
                this.setting(key,value);
                return this;
            },
            /**
             * [Alias] Gets dialog settings/options 
             */
            get:function(key){
                return this.setting(key);
            },
            /**
            * Sets dialog header
            * @content {string or element}
            *
            * @return {undefined}
            */
            setHeader:function(content){
                if(typeof content === 'string'){
                    clearContents(this.elements.header);
                    // nosemgrep: insecure-document-method
                    this.elements.header.innerHTML = content;
                }else if (content instanceof window.HTMLElement && this.elements.header.firstChild !== content){
                    clearContents(this.elements.header);
                    this.elements.header.appendChild(content);
                }
                return this;
            },
            /**
            * Sets dialog contents
            * @content {string or element}
            *
            * @return {undefined}
            */
            setContent:function(content){
                if(typeof content === 'string'){
                    clearContents(this.elements.content);
                    // nosemgrep: insecure-document-method
                    this.elements.content.innerHTML = content;
                }else if (content instanceof window.HTMLElement && this.elements.content.firstChild !== content){
                    clearContents(this.elements.content);
                    this.elements.content.appendChild(content);
                }
                return this;
            },
            /**
             * Show the dialog as modal
             *
             * @return {Object} the dialog instance.
             */
            showModal: function(className){
                return this.show(true, className);
            },
            /**
             * Show the dialog
             *
             * @return {Object} the dialog instance.
             */
            show: function (modal, className) {
                
                // ensure initialization
                initialize(this);

                if ( !this.__internal.isOpen ) {

                    // add to open dialogs
                    this.__internal.isOpen = true;
                    openDialogs.push(this);

                    // save last focused element
                    if(alertify.defaults.maintainFocus){
                        this.__internal.activeElement = document.activeElement;
                    }

                    //allow custom dom manipulation updates before showing the dialog.
                    if(typeof this.prepare === 'function'){
                        this.prepare();
                    }

                    bindEvents(this);

                    if(modal !== undefined){
                        this.set('modal', modal);
                    }

                    //save scroll to prevent document jump
                    saveScrollPosition();

                    ensureNoOverflow();

                    // allow custom dialog class on show
                    if(typeof className === 'string' && className !== ''){
                        this.__internal.className = className;
                        addClass(this.elements.root, className);
                    }

                    // maximize if start maximized
                    if ( this.get('startMaximized')) {
                        this.maximize();
                    }else if(this.isMaximized()){
                        restore(this);
                    }

                    updateAbsPositionFix(this);

                    removeClass(this.elements.root, classes.animationOut);
                    addClass(this.elements.root, classes.animationIn);

                    // set 1s fallback in case transition event doesn't fire
                    clearTimeout( this.__internal.timerIn);
                    this.__internal.timerIn = setTimeout( this.__internal.transitionInHandler, transition.supported ? 1000 : 100 );

                    if(isSafari){
                        // force desktop safari reflow
                        var root = this.elements.root;
                        root.style.display  = 'none';
                        setTimeout(function(){root.style.display  = 'block';}, 0);
                    }

                    //reflow
                    reflow = this.elements.root.offsetWidth;
                  
                    // show dialog
                    removeClass(this.elements.root, classes.hidden);

                    // internal on show event
                    if(typeof this.hooks.onshow === 'function'){
                        this.hooks.onshow.call(this);
                    }

                    // allow custom `onshow` method
                    dispatchEvent('onshow', this);

                }else{
                    // reset move updates
                    resetMove(this);
                    // reset resize updates
                    resetResize(this);
                    // shake the dialog to indicate its already open
                    addClass(this.elements.dialog, classes.shake);
                    var self = this;
                    setTimeout(function(){
                        removeClass(self.elements.dialog, classes.shake);
                    },200);
                }
                return this;
            },
            /**
             * Close the dialog
             *
             * @return {Object} The dialog instance
             */
            close: function () {
                if (this.__internal.isOpen ) {
                    // custom `onclosing` event
                    if(dispatchEvent('onclosing', this) !== false){

                        unbindEvents(this);

                        removeClass(this.elements.root, classes.animationIn);
                        addClass(this.elements.root, classes.animationOut);

                        // set 1s fallback in case transition event doesn't fire
                        clearTimeout( this.__internal.timerOut );
                        this.__internal.timerOut = setTimeout( this.__internal.transitionOutHandler, transition.supported ? 1000 : 100 );
                        // hide dialog
                        addClass(this.elements.root, classes.hidden);
                        //reflow
                        reflow = this.elements.modal.offsetWidth;

                        // remove custom dialog class on hide
                        if (typeof this.__internal.className !== 'undefined' && this.__internal.className !== '') {
                            removeClass(this.elements.root, this.__internal.className);
                        }

                        // internal on close event
                        if(typeof this.hooks.onclose === 'function'){
                            this.hooks.onclose.call(this);
                        }

                        // allow custom `onclose` method
                        dispatchEvent('onclose', this);

                        //remove from open dialogs
                        openDialogs.splice(openDialogs.indexOf(this),1);
                        this.__internal.isOpen = false;

                        ensureNoOverflow();
                    }

                }
                return this;
            },
            /**
             * Close all open dialogs except this.
             *
             * @return {undefined}
             */
            closeOthers:function(){
                alertify.closeAll(this);
                return this;
            },
            /**
             * Destroys this dialog instance
             *
             * @return {undefined}
             */
            destroy:function(){
                if (this.__internal.isOpen ) {
                    //mark dialog for destruction, this will be called on tranistionOut event.
                    this.__internal.destroy = function(){
                        destruct(this, initialize);
                    };
                    //close the dialog to unbind all events.
                    this.close();
                }else{
                    destruct(this, initialize);
                }
                return this;
            },
        };
	} () );
    var notifier = (function () {
        var reflow,
            element,
            openInstances = [],
            classes = {
                base: 'alertify-notifier',
                message: 'ajs-message',
                top: 'ajs-top',
                right: 'ajs-right',
                bottom: 'ajs-bottom',
                left: 'ajs-left',
                center: 'ajs-center',
                visible: 'ajs-visible',
                hidden: 'ajs-hidden',
                close: 'ajs-close'
            };
        /**
         * Helper: initializes the notifier instance
         *
         */
        function initialize(instance) {

            if (!instance.__internal) {
                instance.__internal = {
                    position: alertify.defaults.notifier.position,
                    delay: alertify.defaults.notifier.delay,
                };

                element = document.createElement('DIV');

                updatePosition(instance);
            }

            //add to DOM tree.
            if (element.parentNode !== document.body) {
                document.body.appendChild(element);
            }
        }

        function pushInstance(instance) {
            instance.__internal.pushed = true;
            openInstances.push(instance);
        }
        function popInstance(instance) {
            openInstances.splice(openInstances.indexOf(instance), 1);
            instance.__internal.pushed = false;
        }
        /**
         * Helper: update the notifier instance position
         *
         */
        function updatePosition(instance) {
            element.className = classes.base;
            switch (instance.__internal.position) {
            case 'top-right':
                addClass(element, classes.top + ' ' + classes.right);
                break;
            case 'top-left':
                addClass(element, classes.top + ' ' + classes.left);
                break;
            case 'top-center':
                addClass(element, classes.top + ' ' + classes.center);
                break;
            case 'bottom-left':
                addClass(element, classes.bottom + ' ' + classes.left);
                break;
            case 'bottom-center':
                addClass(element, classes.bottom + ' ' + classes.center);
                break;

            default:
            case 'bottom-right':
                addClass(element, classes.bottom + ' ' + classes.right);
                break;
            }
        }

        /**
        * creates a new notification message
        *
        * @param  {DOMElement} message	The notifier message element
        * @param  {Number} wait   Time (in ms) to wait before the message is dismissed, a value of 0 means keep open till clicked.
        * @param  {Function} callback A callback function to be invoked when the message is dismissed.
        *
        * @return {undefined}
        */
        function create(div, callback) {

            function clickDelegate(event, instance) {
                if(!instance.__internal.closeButton || event.target.getAttribute('data-close') === 'true'){
                    instance.dismiss(true);
                }
            }

            function transitionDone(event, instance) {
                // unbind event
                off(instance.element, transition.type, transitionDone);
                // remove the message
                element.removeChild(instance.element);
            }

            function initialize(instance) {
                if (!instance.__internal) {
                    instance.__internal = {
                        pushed: false,
                        delay : undefined,
                        timer: undefined,
                        clickHandler: undefined,
                        transitionEndHandler: undefined,
                        transitionTimeout: undefined
                    };
                    instance.__internal.clickHandler = delegate(instance, clickDelegate);
                    instance.__internal.transitionEndHandler = delegate(instance, transitionDone);
                }
                return instance;
            }
            function clearTimers(instance) {
                clearTimeout(instance.__internal.timer);
                clearTimeout(instance.__internal.transitionTimeout);
            }
            return initialize({
                /* notification DOM element*/
                element: div,
                /*
                 * Pushes a notification message
                 * @param {string or DOMElement} content The notification message content
                 * @param {Number} wait The time (in seconds) to wait before the message is dismissed, a value of 0 means keep open till clicked.
                 *
                 */
                push: function (_content, _wait) {
                    if (!this.__internal.pushed) {

                        pushInstance(this);
                        clearTimers(this);

                        var content, wait;
                        switch (arguments.length) {
                        case 0:
                            wait = this.__internal.delay;
                            break;
                        case 1:
                            if (typeof (_content) === 'number') {
                                wait = _content;
                            } else {
                                content = _content;
                                wait = this.__internal.delay;
                            }
                            break;
                        case 2:
                            content = _content;
                            wait = _wait;
                            break;
                        }
                        this.__internal.closeButton = alertify.defaults.notifier.closeButton;
                        // set contents
                        if (typeof content !== 'undefined') {
                            this.setContent(content);
                        }
                        // append or insert
                        if (notifier.__internal.position.indexOf('top') < 0) {
                            element.appendChild(this.element);
                        } else {
                            element.insertBefore(this.element, element.firstChild);
                        }
                        reflow = this.element.offsetWidth;
                        addClass(this.element, classes.visible);
                        // attach click event
                        on(this.element, 'click', this.__internal.clickHandler);
                        return this.delay(wait);
                    }
                    return this;
                },
                /*
                 * {Function} callback function to be invoked before dismissing the notification message.
                 * Remarks: A return value === 'false' will cancel the dismissal
                 *
                 */
                ondismiss: function () { },
                /*
                 * {Function} callback function to be invoked when the message is dismissed.
                 *
                 */
                callback: callback,
                /*
                 * Dismisses the notification message
                 * @param {Boolean} clicked A flag indicating if the dismissal was caused by a click.
                 *
                 */
                dismiss: function (clicked) {
                    if (this.__internal.pushed) {
                        clearTimers(this);
                        if (!(typeof this.ondismiss === 'function' && this.ondismiss.call(this) === false)) {
                            //detach click event
                            off(this.element, 'click', this.__internal.clickHandler);
                            // ensure element exists
                            if (typeof this.element !== 'undefined' && this.element.parentNode === element) {
                                //transition end or fallback
                                this.__internal.transitionTimeout = setTimeout(this.__internal.transitionEndHandler, transition.supported ? 1000 : 100);
                                removeClass(this.element, classes.visible);

                                // custom callback on dismiss
                                if (typeof this.callback === 'function') {
                                    this.callback.call(this, clicked);
                                }
                            }
                            popInstance(this);
                        }
                    }
                    return this;
                },
                /*
                 * Delays the notification message dismissal
                 * @param {Number} wait The time (in seconds) to wait before the message is dismissed, a value of 0 means keep open till clicked.
                 */
                delay: function (wait) {
                    clearTimers(this);
                    this.__internal.delay = typeof wait !== 'undefined' && !isNaN(+wait) ? +wait : notifier.__internal.delay;
                    if (this.__internal.delay > 0) {
                        var  self = this;
                        this.__internal.timer = setTimeout(function () { self.dismiss(); }, this.__internal.delay * 1000);
                    }
                    return this;
                },
                /*
                 * Sets the notification message contents
                 * @param {string or DOMElement} content The notification message content
                 */
                setContent: function (content) {
                    if (typeof content === 'string') {
                        clearContents(this.element);
                        // nosemgrep: insecure-document-method
                        this.element.innerHTML = content;
                    } else if (content instanceof window.HTMLElement && this.element.firstChild !== content) {
                        clearContents(this.element);
                        this.element.appendChild(content);
                    }
                    if(this.__internal.closeButton){
                        var close = document.createElement('span');
                        addClass(close, classes.close);
                        close.setAttribute('data-close', true);
                        this.element.appendChild(close);
                    }
                    return this;
                },
                /*
                 * Dismisses all open notifications except this.
                 *
                 */
                dismissOthers: function () {
                    notifier.dismissAll(this);
                    return this;
                }
            });
        }

        //notifier api
        return {
            /**
             * Gets or Sets notifier settings.
             *
             * @param {string} key The setting name
             * @param {Variant} value The setting value.
             *
             * @return {Object}	if the called as a setter, return the notifier instance.
             */
            setting: function (key, value) {
                //ensure init
                initialize(this);

                if (typeof value === 'undefined') {
                    //get
                    return this.__internal[key];
                } else {
                    //set
                    switch (key) {
                    case 'position':
                        this.__internal.position = value;
                        updatePosition(this);
                        break;
                    case 'delay':
                        this.__internal.delay = value;
                        break;
                    }
                }
                return this;
            },
            /**
             * [Alias] Sets dialog settings/options
             */
            set:function(key,value){
                this.setting(key,value);
                return this;
            },
            /**
             * [Alias] Gets dialog settings/options
             */
            get:function(key){
                return this.setting(key);
            },
            /**
             * Creates a new notification message
             *
             * @param {string} type The type of notification message (simply a CSS class name 'ajs-{type}' to be added).
             * @param {Function} callback  A callback function to be invoked when the message is dismissed.
             *
             * @return {undefined}
             */
            create: function (type, callback) {
                //ensure notifier init
                initialize(this);
                //create new notification message
                var div = document.createElement('div');
                div.className = classes.message + ((typeof type === 'string' && type !== '') ? ' ajs-' + type : '');
                return create(div, callback);
            },
            /**
             * Dismisses all open notifications.
             *
             * @param {Object} excpet [optional] The notification object to exclude from dismissal.
             *
             */
            dismissAll: function (except) {
                var clone = openInstances.slice(0);
                for (var x = 0; x < clone.length; x += 1) {
                    var  instance = clone[x];
                    if (except === undefined || except !== instance) {
                        instance.dismiss();
                    }
                }
            }
        };
    })();

    /**
     * Alertify public API
     * This contains everything that is exposed through the alertify object.
     *
     * @return {Object}
     */
    function Alertify() {

        // holds a references of created dialogs
        var dialogs = {};

        /**
         * Extends a given prototype by merging properties from base into sub.
         *
         * @sub {Object} sub The prototype being overwritten.
         * @base {Object} base The prototype being written.
         *
         * @return {Object} The extended prototype.
         */
        function extend(sub, base) {
            // copy dialog pototype over definition.
            for (var prop in base) {
                if (base.hasOwnProperty(prop)) {
                    sub[prop] = base[prop];
                }
            }
            return sub;
        }


        /**
        * Helper: returns a dialog instance from saved dialogs.
        * and initializes the dialog if its not already initialized.
        *
        * @name {String} name The dialog name.
        *
        * @return {Object} The dialog instance.
        */
        function get_dialog(name) {
            var dialog = dialogs[name].dialog;
            //initialize the dialog if its not already initialized.
            if (dialog && typeof dialog.__init === 'function') {
                dialog.__init(dialog);
            }
            return dialog;
        }

        /**
         * Helper:  registers a new dialog definition.
         *
         * @name {String} name The dialog name.
         * @Factory {Function} Factory a function resposible for creating dialog prototype.
         * @transient {Boolean} transient True to create a new dialog instance each time the dialog is invoked, false otherwise.
         * @base {String} base the name of another dialog to inherit from.
         *
         * @return {Object} The dialog definition.
         */
        function register(name, Factory, transient, base) {
            var definition = {
                dialog: null,
                factory: Factory
            };

            //if this is based on an existing dialog, create a new definition
            //by applying the new protoype over the existing one.
            if (base !== undefined) {
                definition.factory = function () {
                    return extend(new dialogs[base].factory(), new Factory());
                };
            }

            if (!transient) {
                //create a new definition based on dialog
                definition.dialog = extend(new definition.factory(), dialog);
            }
            return dialogs[name] = definition;
        }

        return {
            /**
             * Alertify defaults
             * 
             * @type {Object}
             */
            defaults: defaults,
            /**
             * Dialogs factory 
             *
             * @param {string}      Dialog name.
             * @param {Function}    A Dialog factory function.
             * @param {Boolean}     Indicates whether to create a singleton or transient dialog.
             * @param {String}      The name of the base type to inherit from.
             */
            dialog: function (name, Factory, transient, base) {

                // get request, create a new instance and return it.
                if (typeof Factory !== 'function') {
                    return get_dialog(name);
                }

                if (this.hasOwnProperty(name)) {
                    throw new Error('alertify.dialog: name already exists');
                }

                // register the dialog
                var definition = register(name, Factory, transient, base);

                if (transient) {

                    // make it public
                    this[name] = function () {
                        //if passed with no params, consider it a get request
                        if (arguments.length === 0) {
                            return definition.dialog;
                        } else {
                            var instance = extend(new definition.factory(), dialog);
                            //ensure init
                            if (instance && typeof instance.__init === 'function') {
                                instance.__init(instance);
                            }
                            instance['main'].apply(instance, arguments);
                            return instance['show'].apply(instance);
                        }
                    };
                } else {
                    // make it public
                    this[name] = function () {
                        //ensure init
                        if (definition.dialog && typeof definition.dialog.__init === 'function') {
                            definition.dialog.__init(definition.dialog);
                        }
                        //if passed with no params, consider it a get request
                        if (arguments.length === 0) {
                            return definition.dialog;
                        } else {
                            var dialog = definition.dialog;
                            dialog['main'].apply(definition.dialog, arguments);
                            return dialog['show'].apply(definition.dialog);
                        }
                    };
                }
            },
            /**
             * Close all open dialogs.
             *
             * @param {Object} excpet [optional] The dialog object to exclude from closing.
             *
             * @return {undefined}
             */
            closeAll: function (except) {
                var clone = openDialogs.slice(0);
                for (var x = 0; x < clone.length; x += 1) {
                    var instance = clone[x];
                    if (except === undefined || except !== instance) {
                        instance.close();
                    }
                }
            },
            /**
             * Gets or Sets dialog settings/options. if the dialog is transient, this call does nothing.
             *
             * @param {string} name The dialog name.
             * @param {String|Object} key A string specifying a propery name or a collection of key/value pairs.
             * @param {Variant} value Optional, the value associated with the key (in case it was a string).
             *
             * @return {undefined}
             */
            setting: function (name, key, value) {

                if (name === 'notifier') {
                    return notifier.setting(key, value);
                }

                var dialog = get_dialog(name);
                if (dialog) {
                    return dialog.setting(key, value);
                }
            },
            /**
             * [Alias] Sets dialog settings/options 
             */
            set: function(name,key,value){
                return this.setting(name, key,value);
            },
            /**
             * [Alias] Gets dialog settings/options 
             */
            get: function(name, key){
                return this.setting(name, key);
            },
            /**
             * Creates a new notification message.
             * If a type is passed, a class name "ajs-{type}" will be added.
             * This allows for custom look and feel for various types of notifications.
             *
             * @param  {String | DOMElement}    [message=undefined]		Message text
             * @param  {String}                 [type='']				Type of log message
             * @param  {String}                 [wait='']				Time (in seconds) to wait before auto-close
             * @param  {Function}               [callback=undefined]	A callback function to be invoked when the log is closed.
             *
             * @return {Object} Notification object.
             */
            notify: function (message, type, wait, callback) {
                return notifier.create(type, callback).push(message, wait);
            },
            /**
             * Creates a new notification message.
             *
             * @param  {String}		[message=undefined]		Message text
             * @param  {String}     [wait='']				Time (in seconds) to wait before auto-close
             * @param  {Function}	[callback=undefined]	A callback function to be invoked when the log is closed.
             *
             * @return {Object} Notification object.
             */
            message: function (message, wait, callback) {
                return notifier.create(null, callback).push(message, wait);
            },
            /**
             * Creates a new notification message of type 'success'.
             *
             * @param  {String}		[message=undefined]		Message text
             * @param  {String}     [wait='']				Time (in seconds) to wait before auto-close
             * @param  {Function}	[callback=undefined]	A callback function to be invoked when the log is closed.
             *
             * @return {Object} Notification object.
             */
            success: function (message, wait, callback) {
                return notifier.create('success', callback).push(message, wait);
            },
            /**
             * Creates a new notification message of type 'error'.
             *
             * @param  {String}		[message=undefined]		Message text
             * @param  {String}     [wait='']				Time (in seconds) to wait before auto-close
             * @param  {Function}	[callback=undefined]	A callback function to be invoked when the log is closed.
             *
             * @return {Object} Notification object.
             */
            error: function (message, wait, callback) {
                return notifier.create('error', callback).push(message, wait);
            },
            /**
             * Creates a new notification message of type 'warning'.
             *
             * @param  {String}		[message=undefined]		Message text
             * @param  {String}     [wait='']				Time (in seconds) to wait before auto-close
             * @param  {Function}	[callback=undefined]	A callback function to be invoked when the log is closed.
             *
             * @return {Object} Notification object.
             */
            warning: function (message, wait, callback) {
                return notifier.create('warning', callback).push(message, wait);
            },
            /**
             * Dismisses all open notifications
             *
             * @return {undefined}
             */
            dismissAll: function () {
                notifier.dismissAll();
            }
        };
    }
    var alertify = new Alertify();

    /**
    * Alert dialog definition
    *
    * invoked by:
    *	alertify.alert(message);
    *	alertify.alert(title, message);
    *	alertify.alert(message, onok);
    *	alertify.alert(title, message, onok);
     */
    alertify.dialog('alert', function () {
        return {
            main: function (_title, _message, _onok) {
                var title, message, onok;
                switch (arguments.length) {
                case 1:
                    message = _title;
                    break;
                case 2:
                    if (typeof _message === 'function') {
                        message = _title;
                        onok = _message;
                    } else {
                        title = _title;
                        message = _message;
                    }
                    break;
                case 3:
                    title = _title;
                    message = _message;
                    onok = _onok;
                    break;
                }
                this.set('title', title);
                this.set('message', message);
                this.set('onok', onok);
                return this;
            },
            setup: function () {
                return {
                    buttons: [
                        {
                            text: alertify.defaults.glossary.ok,
                            key: keys.ESC,
                            invokeOnClose: true,
                            className: alertify.defaults.theme.ok,
                        }
                    ],
                    focus: {
                        element: 0,
                        select: false
                    },
                    options: {
                        maximizable: false,
                        resizable: false
                    }
                };
            },
            build: function () {
                // nothing
            },
            prepare: function () {
                //nothing
            },
            setMessage: function (message) {
                this.setContent(message);
            },
            settings: {
                message: undefined,
                onok: undefined,
                label: undefined,
            },
            settingUpdated: function (key, oldValue, newValue) {
                switch (key) {
                case 'message':
                    this.setMessage(newValue);
                    break;
                case 'label':
                    if (this.__internal.buttons[0].element) {
                        // nosemgrep: insecure-document-method
                        this.__internal.buttons[0].element.innerHTML = newValue;
                    }
                    break;
                }
            },
            callback: function (closeEvent) {
                if (typeof this.get('onok') === 'function') {
                    var returnValue = this.get('onok').call(this, closeEvent);
                    if (typeof returnValue !== 'undefined') {
                        closeEvent.cancel = !returnValue;
                    }
                }
            }
        };
    });
    /**
     * Confirm dialog object
     *
     *	alertify.confirm(message);
     *	alertify.confirm(message, onok);
     *	alertify.confirm(message, onok, oncancel);
     *	alertify.confirm(title, message, onok, oncancel);
     */
    alertify.dialog('confirm', function () {

        var autoConfirm = {
            timer: null,
            index: null,
            text: null,
            duration: null,
            task: function (event, self) {
                if (self.isOpen()) {
                    self.__internal.buttons[autoConfirm.index].element.innerHTML = autoConfirm.text + ' (&#8207;' + autoConfirm.duration + '&#8207;) ';
                    autoConfirm.duration -= 1;
                    if (autoConfirm.duration === -1) {
                        clearAutoConfirm(self);
                        var button = self.__internal.buttons[autoConfirm.index];
                        var closeEvent = createCloseEvent(autoConfirm.index, button);

                        if (typeof self.callback === 'function') {
                            self.callback.apply(self, [closeEvent]);
                        }
                        //close the dialog.
                        if (closeEvent.close !== false) {
                            self.close();
                        }
                    }
                } else {
                    clearAutoConfirm(self);
                }
            }
        };

        function clearAutoConfirm(self) {
            if (autoConfirm.timer !== null) {
                clearInterval(autoConfirm.timer);
                autoConfirm.timer = null;
                // nosemgrep: insecure-document-method
                self.__internal.buttons[autoConfirm.index].element.innerHTML = autoConfirm.text;
            }
        }

        function startAutoConfirm(self, index, duration) {
            clearAutoConfirm(self);
            autoConfirm.duration = duration;
            autoConfirm.index = index;
            autoConfirm.text = self.__internal.buttons[index].element.innerHTML;
            autoConfirm.timer = setInterval(delegate(self, autoConfirm.task), 1000);
            autoConfirm.task(null, self);
        }


        return {
            main: function (_title, _message, _onok, _oncancel) {
                var title, message, onok, oncancel;
                switch (arguments.length) {
                case 1:
                    message = _title;
                    break;
                case 2:
                    message = _title;
                    onok = _message;
                    break;
                case 3:
                    message = _title;
                    onok = _message;
                    oncancel = _onok;
                    break;
                case 4:
                    title = _title;
                    message = _message;
                    onok = _onok;
                    oncancel = _oncancel;
                    break;
                }
                this.set('title', title);
                this.set('message', message);
                this.set('onok', onok);
                this.set('oncancel', oncancel);
                this.set('labels', {
                    ok: alertify.defaults.glossary.ok,
                    cancel: alertify.defaults.glossary.cancel
                });
                return this;
            },
            setup: function () {
                return {
                    buttons: [
                        {
                            text: alertify.defaults.glossary.ok,
                            key: keys.ENTER,
                            className: alertify.defaults.theme.ok,
                        },
                        {
                            text: alertify.defaults.glossary.cancel,
                            key: keys.ESC,
                            invokeOnClose: true,
                            className: alertify.defaults.theme.cancel,
                        }
                    ],
                    focus: {
                        element: 0,
                        select: false
                    },
                    options: {
                        maximizable: false,
                        resizable: false
                    }
                };
            },
            build: function () {
                //nothing
            },
            prepare: function () {
                //nothing
            },
            setMessage: function (message) {
                this.setContent(message);
            },
            settings: {
                message: null,
                labels: null,
                onok: null,
                oncancel: null,
                defaultFocus: null,
                reverseButtons: null,
            },
            settingUpdated: function (key, oldValue, newValue) {
                switch (key) {
                case 'message':
                    this.setMessage(newValue);
                    break;
                case 'labels':
                    if ('ok' in newValue && this.__internal.buttons[0].element) {
                        this.__internal.buttons[0].text = newValue.ok;
                        // nosemgrep: insecure-document-method
                        this.__internal.buttons[0].element.innerHTML = newValue.ok;
                    }
                    if ('cancel' in newValue && this.__internal.buttons[1].element) {
                        this.__internal.buttons[1].text = newValue.cancel;
                        // nosemgrep: insecure-document-method
                        this.__internal.buttons[1].element.innerHTML = newValue.cancel;
                    }
                    break;
                case 'reverseButtons':
                    if (newValue === true) {
                        this.elements.buttons.primary.appendChild(this.__internal.buttons[0].element);
                    } else {
                        this.elements.buttons.primary.appendChild(this.__internal.buttons[1].element);
                    }
                    break;
                case 'defaultFocus':
                    this.__internal.focus.element = newValue === 'ok' ? 0 : 1;
                    break;
                }
            },
            callback: function (closeEvent) {
                clearAutoConfirm(this);
                var returnValue;
                switch (closeEvent.index) {
                case 0:
                    if (typeof this.get('onok') === 'function') {
                        returnValue = this.get('onok').call(this, closeEvent);
                        if (typeof returnValue !== 'undefined') {
                            closeEvent.cancel = !returnValue;
                        }
                    }
                    break;
                case 1:
                    if (typeof this.get('oncancel') === 'function') {
                        returnValue = this.get('oncancel').call(this, closeEvent);
                        if (typeof returnValue !== 'undefined') {
                            closeEvent.cancel = !returnValue;
                        }
                    }
                    break;
                }
            },
            autoOk: function (duration) {
                startAutoConfirm(this, 0, duration);
                return this;
            },
            autoCancel: function (duration) {
                startAutoConfirm(this, 1, duration);
                return this;
            }
        };
    });
    /**
     * Prompt dialog object
     *
     * invoked by:
     *	alertify.prompt(message);
     *	alertify.prompt(message, value);
     *	alertify.prompt(message, value, onok);
     *	alertify.prompt(message, value, onok, oncancel);
     *	alertify.prompt(title, message, value, onok, oncancel);
     */
    alertify.dialog('prompt', function () {
        var input = document.createElement('INPUT');
        var p = document.createElement('P');
        return {
            main: function (_title, _message, _value, _onok, _oncancel) {
                var title, message, value, onok, oncancel;
                switch (arguments.length) {
                case 1:
                    message = _title;
                    break;
                case 2:
                    message = _title;
                    value = _message;
                    break;
                case 3:
                    message = _title;
                    value = _message;
                    onok = _value;
                    break;
                case 4:
                    message = _title;
                    value = _message;
                    onok = _value;
                    oncancel = _onok;
                    break;
                case 5:
                    title = _title;
                    message = _message;
                    value = _value;
                    onok = _onok;
                    oncancel = _oncancel;
                    break;
                }
                this.set('title', title);
                this.set('message', message);
                this.set('value', value);
                this.set('onok', onok);
                this.set('oncancel', oncancel);
                return this;
            },
            setup: function () {
                return {
                    buttons: [
                        {
                            text: alertify.defaults.glossary.ok,
                            key: keys.ENTER,
                            className: alertify.defaults.theme.ok,
                        },
                        {
                            text: alertify.defaults.glossary.cancel,
                            key: keys.ESC,
                            invokeOnClose: true,
                            className: alertify.defaults.theme.cancel,
                        }
                    ],
                    focus: {
                        element: input,
                        select: true
                    },
                    options: {
                        maximizable: false,
                        resizable: false
                    }
                };
            },
            build: function () {
                input.className = alertify.defaults.theme.input;
                input.setAttribute('type', 'text');
                input.value = this.get('value');
                this.elements.content.appendChild(p);
                this.elements.content.appendChild(input);
            },
            prepare: function () {
                //nothing
            },
            setMessage: function (message) {
                if (typeof message === 'string') {
                    clearContents(p);
                    // nosemgrep: insecure-document-method
                    p.innerHTML = message;
                } else if (message instanceof window.HTMLElement && p.firstChild !== message) {
                    clearContents(p);
                    p.appendChild(message);
                }
            },
            settings: {
                message: undefined,
                labels: undefined,
                onok: undefined,
                oncancel: undefined,
                value: '',
                type:'text',
                reverseButtons: undefined,
            },
            settingUpdated: function (key, oldValue, newValue) {
                switch (key) {
                case 'message':
                    this.setMessage(newValue);
                    break;
                case 'value':
                    input.value = newValue;
                    break;
                case 'type':
                    switch (newValue) {
                    case 'text':
                    case 'color':
                    case 'date':
                    case 'datetime-local':
                    case 'email':
                    case 'month':
                    case 'number':
                    case 'password':
                    case 'search':
                    case 'tel':
                    case 'time':
                    case 'week':
                        input.type = newValue;
                        break;
                    default:
                        input.type = 'text';
                        break;
                    }
                    break;
                case 'labels':
                    if (newValue.ok && this.__internal.buttons[0].element) {
                        // nosemgrep: insecure-document-method
                        this.__internal.buttons[0].element.innerHTML = newValue.ok;
                    }
                    if (newValue.cancel && this.__internal.buttons[1].element) {
                        // nosemgrep: insecure-document-method
                        this.__internal.buttons[1].element.innerHTML = newValue.cancel;
                    }
                    break;
                case 'reverseButtons':
                    if (newValue === true) {
                        this.elements.buttons.primary.appendChild(this.__internal.buttons[0].element);
                    } else {
                        this.elements.buttons.primary.appendChild(this.__internal.buttons[1].element);
                    }
                    break;
                }
            },
            callback: function (closeEvent) {
                var returnValue;
                switch (closeEvent.index) {
                case 0:
                    this.settings.value = input.value;
                    if (typeof this.get('onok') === 'function') {
                        returnValue = this.get('onok').call(this, closeEvent, this.settings.value);
                        if (typeof returnValue !== 'undefined') {
                            closeEvent.cancel = !returnValue;
                        }
                    }
                    break;
                case 1:
                    if (typeof this.get('oncancel') === 'function') {
                        returnValue = this.get('oncancel').call(this, closeEvent);
                        if (typeof returnValue !== 'undefined') {
                            closeEvent.cancel = !returnValue;
                        }
                    }
                    if(!closeEvent.cancel){
                        input.value = this.settings.value;
                    }
                    break;
                }
            }
        };
    });

    // CommonJS
    if ( typeof module === 'object' && typeof module.exports === 'object' ) {
        module.exports = alertify;
    // AMD
    } else if ( typeof define === 'function' && define.amd) {
        define( [], function () {
            return alertify;
        } );
    // window
    } else if ( !window.alertify ) {
        window.alertify = alertify;
    }

} ( typeof window !== 'undefined' ? window : this ) );

},
'appivo/util/Identity':function(){
define(["dojo/_base/lang"], function(lang) {
	
	var nextId = 0;
	var itemIdPrefix = "cid_";
	var newPrefix = "n:";
	var identity = {};
	
	function random() {
		return Math.floor((1 + Math.random()) * 0x10000)
		.toString(16)
		.substring(1);
	};

	identity.generateUUID = function() {
		var d = new Date().getTime();//Timestamp
		var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			var r = Math.random() * 16;//random number between 0 and 16
			if(d > 0){//Use timestamp until depleted
				r = (d + r)%16 | 0;
				d = Math.floor(d/16);
			} else {//Use microseconds since page-load if supported
				r = (d2 + r)%16 | 0;
				d2 = Math.floor(d2/16);
			}
			return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
		});
	};

	identity.generateItemId = function() {
		var id = random() + '-' + random() + '-' + random(); 
		return itemIdPrefix + id;
	};

	identity.prepareItemId = function(item) {
		if (typeof(item.id) == "undefined" || item.id == null) {
			item.id = this.generateItemId();
		}
	};

	identity.cleanItemId = function(item) {
		if (identity.hasTempId(item)) {
			delete item.id;
		}
	};

	identity.toRealId = function(id) {
		if (id && id.startsWith(newPrefix)) {
			id = id.substring(newPrefix.length);
		}
		return id;
	};
	
	identity.cleanItemIds = function(item, excludeMap) {
		if (lang.isArray(item)) {
			for (var i = 0; i < item.length; i++) {
				identity.cleanItemIds(item[i], excludeMap);
			}
		} else if (item && lang.isObject(item)) {
			if (item.id) {
				identity.cleanItemId(item);
			}
			for (var key in item) {
			    if (!(excludeMap && excludeMap[key] && excludeMap[key]._skip)) {
				    identity.cleanItemIds(item[key], excludeMap ? excludeMap[key] : null);
			    }
			}
		}
	};
	
	identity.hasRealId = function(item) {
		return !this.hasTempId(item);
	};
	
	identity.hasTempId = function(item) {
		return item ? identity.isTempId(item.id) : false;
	};
	
	identity.isTempId = function(id) {
		var tmp = false;
		if (id && typeof id == "string") {
			var hasDot = id.indexOf('.') >= 0;
			var hasPrefix = id.indexOf(itemIdPrefix) == 0;
			tmp = hasDot || hasPrefix || id.length == 0;
		} else {
			tmp = true;
		}
		return tmp;
	};
	
	identity.isRealId = function(id) {
		var real = false;
		if (id && typeof id == "string") {
			var hasDot = id.indexOf('.') >= 0;
			var hasPrefix = id.indexOf(itemIdPrefix) == 0;
			var hasNewPrefix = id.indexOf(newPrefix) == 0;
			real = (!(hasDot || hasPrefix) && (id.length == 32 || (hasNewPrefix && id.length == 34)));
		}
		return real;
	};
	
	identity.findHighest = 	function(list, attr, prefix) {
		var hi = 0;
		for (var i = 0; i < list.length; i++) {
			var item = list[i];
			var name = item[attr];
			if (name && name.indexOf(prefix) == 0) {
				var str = name.substring(prefix.length);
				try {
					var idx = parseInt(str);
					if (!isNaN(idx) && idx > hi) {
						hi = idx;
					}
				} catch (error) {
				}
			}
		}
		return hi;
	};
	
	identity.compareObjects = function(o1, o2) {
		var eq = true;
		if (o1 && o2) {
			var o1k = Object.keys(o1).sort();
			var o2k = Object.keys(o2).sort();
			if (o1k.length == o2k.length) {
				for (var i in o1k) {
					var k1 = o1k[i];
					var k2 = o2k[i];
					if (k1 === k2) {
						var v1 = o1[k1];
						var v2 = o2[k1];
						if (typeof v1 == "object" && typeof v2 == "object") {
							if (!this.compareObjects(v1, v2)) {
								return false;
							}
						} else if (v1 != v2) {
							console.log("key: " + k1 + "v1 " + v1 + " " + v2);
							return false;
						}
					} else {
						console.log("Different keys " + k1 + " " + k2);
						return false;
					}
				}
			} else {
				console.log("Different lengths");
				eq = false;
			}
		} else if (o1 || o2) {
			console.log("One object is null");
			eq = false;
		}
		return eq;
	};

	return identity;
});

},
'appivo/util/native/File':function(){
define([
    "dojo/_base/lang",
], function(lang) {
    var wrapper = {
        _isSupported: false
    };
    var cordova = window.cordova;
    var fileTransfer = window.FileTransfer ? window.FileTransfer : undefined;
    var fileOpener = window.cordova ? (window.cordova.plugins ? window.cordova.plugins.fileOpener2 : undefined) : undefined;
    var device = window.device;

    /*
        Mime types that we want to open in InAppBrowser on iOS.
        http://filext.com/faq/office_mime_types.php
     */
    var iosBrowserMimes = {
        "application/pdf": true,
        "application/msword": true,
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": true,
        "application/vnd.openxmlformats-officedocument.wordprocessingml.template": true,
        "application/vnd.ms-word.document.macroEnabled.12": true,
        "application/vnd.ms-word.template.macroEnabled.12": true,
        "application/vnd.ms-excel": true,
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": true,
        "application/vnd.openxmlformats-officedocument.spreadsheetml.template": true,
        "application/vnd.ms-excel.sheet.macroEnabled.12": true,
        "application/vnd.ms-excel.template.macroEnabled.12": true,
        "application/vnd.ms-excel.addin.macroEnabled.12": true,
        "application/vnd.ms-excel.sheet.binary.macroEnabled.12": true,
        "application/vnd.ms-powerpoint": true,
        "application/vnd.openxmlformats-officedocument.presentationml.presentation": true,
        "application/vnd.openxmlformats-officedocument.presentationml.template": true,
        "application/vnd.openxmlformats-officedocument.presentationml.slideshow": true,
        "application/vnd.ms-powerpoint.addin.macroEnabled.12": true,
        "application/vnd.ms-powerpoint.presentation.macroEnabled.12": true,
        "application/vnd.ms-powerpoint.template.macroEnabled.12": true,
        "application/vnd.ms-powerpoint.slideshow.macroEnabled.12": true
    };

    if (cordova && fileTransfer && fileOpener) {
        var device = window.device;
        wrapper = {
            _isSupported: true,

            /**
             * @LogicMeta {
             *      "api": "File@Native",
             *      "paramTypes": ["Object"],
             *      "tooltip": "$"
             * }
             */
            download: function(options) {
                var fileTransfer = new FileTransfer();
                options = options || {};

                if (!options.headers) {
                    options.headers = {};
                }
                let accessToken = this._client ? this._client.getAccessToken() : null;
                if (options.accessToken) {
                    accessToken = options.accessToken;
                }
                options.headers['Authorization'] = accessToken;

                window.requestFileSystem(LocalFileSystem.PERSISTENT, 0, function(defaultSaveLocation) {
                    var downloadOptions = {
                        url: "",
                        saveLocation: encodeURI(defaultSaveLocation.root.nativeURL + (options.fileName ? options.fileName : "file")),
                        onSuccess: function(entry) {
                            console.log("Download complete: " + entry.toURL());
                        },
                        onError: function(error) {
                            console.log("Download error source " + error.source);
                            console.log("Download error target " + error.target);
                            console.log("Download error code" + error.code);
                        },
                        trustAllHosts: false,
                        options: {
                            headers: options.headers
                        }
                    };

                    for (var opt in options) {
                        if (downloadOptions[opt] != undefined && downloadOptions[opt] != null && options[opt] != null && options[opt] != undefined) {
                            if (opt == "onSuccess") {
                                downloadOptions["onSuccess"] = function(entry) {
                                    options["onSuccess"](entry);
                                }
                            } else if (opt == "onError") {
                                downloadOptions["onError"] = function(error) {
                                    options["onError"](error);
                                }
                            } else {
                                downloadOptions[opt] = options[opt];
                            }
                        }
                    }

                    fileTransfer.download(
                        downloadOptions.url,
                        downloadOptions.saveLocation,
                        downloadOptions.onSuccess,
                        downloadOptions.onError,
                        downloadOptions.trustAllHosts,
                        downloadOptions.options
                    );
                }, function() {
                    throw new Error("Could not retrieve default save location on device")
                });

            },

            /**
             * @LogicMeta {
             *      "api": "File@Native",
             *      "paramTypes": ["Object"],
             *      "tooltip": "$"
             * }
             */
            open: function(options) {
                options = options || {};
                var defaultMIMEType = "octet-stream";
                var MIMEType = options.mimetype ? options.mimetype : undefined;
                if (!MIMEType) {
                    enteredMIMEType = options.path ? options.path.substring(options.path.lastIndexOf(".") + 1) : undefined;
                    MIMEType = "application/" + (enteredMIMEType ? enteredMIMEType : defaultMIMEType);
                }

                var previousPath;
                var fileOpenerOptions = {
                    path: "",
                    type: MIMEType,
                    forceOpenWithBrowser: false,
                    onSuccess: function() {
                        console.log("Opened file with path " + fileOpenerOptions.path);
                        if (options.onSuccess) {
                            options.onSuccess();
                        }
                    },
                    onError: function(error) {
                        if (error.message.indexOf("Activity not found") == 0) {
                            openFileInBrowser(fileOpenerOptions.path);
                            if (options.onError) {
                                options.onError("Could not find native app to open file " + '"' + fileOpenerOptions.path + '"' + " with extension " + MIMEType + ". Opening in browser instead.");
                            }
                            throw new Error("Could not find native app to open file " + '"' + fileOpenerOptions.path + '"' + " with extension " + MIMEType + ". Opening in browser instead.");
                        } else if (error.message.indexOf("File not found") == 0) {
                            fileOpenerOptions.path = decodeURIComponent(fileOpenerOptions.path);
                            if (previousPath == fileOpenerOptions.path) {
                                if (options.onError) {
                                    options.onError("Could not find file with path " + '"' + fileOpenerOptions.path + '"');
                                }
                                throw new Error("Could not find file with path " + '"' + fileOpenerOptions.path + '"');
                            } else {
                                previousPath = fileOpenerOptions.path;
                                fileOpener.open(
                                    fileOpenerOptions.path,
                                    fileOpenerOptions.type, {
                                        success: fileOpenerOptions.onSuccess,
                                        error: fileOpenerOptions.onError
                                    }
                                );
                            }
                        } else {
                            if (options.onError) {
                                var msg = error.message ? error.message : error;
                                options.onError(msg);
                            }
                        }
                    }
                };

                for (var opt in options) {
                    if (fileOpenerOptions[opt] != undefined && fileOpenerOptions[opt] != null && fileOpenerOptions[opt] != null && fileOpenerOptions[opt] != undefined) {
                        fileOpenerOptions[opt] = options[opt];
                    }
                }
                openFile(fileOpenerOptions, options.name);
            }
        };

        function openFileInBrowser(path) {
            window.open(path, "_blank", "menubar=yes,titlebar=yes,EnableViewPortScale=yes");
        };

        function getMimetype(signature) {
        	switch (signature) {
        	case '89504E47':
        		return 'image/png';
        	case '47494638':
        		return 'image/gif';
        	case '25504446':
        		return 'application/pdf';
        	case 'FFD8FFDB':
        	case 'FFD8FFE0':
        	case 'FFD8FFE1':
        		return 'image/jpeg';
        	case '504B0304':
        		return 'application/zip';
        	default:
        		return 'Unknown filetype';
        	}
        };

        function openFile(fileOpenerOptions, fileName) {
            if (fileOpenerOptions.forceOpenWithBrowser) {
                openFileInBrowser(fileOpenerOptions.path);
            } else {
                if (device.platform.toLowerCase() == "android") {
                    window.resolveLocalFileSystemURL(fileOpenerOptions.path, function(fileEntry) {
                        window.resolveLocalFileSystemURL(cordova.file.externalDataDirectory, function(dirEntry) {
                            fileEntry.copyTo(dirEntry, fileName, function(newFileEntry) {
                                var file = dirEntry.nativeURL + fileName;
                                if(fileOpenerOptions.type) {
                                	fileOpener.open(file, fileOpenerOptions.type, {
                                		success: fileOpenerOptions.onSuccess,
                                		error: fileOpenerOptions.onError
                                	});
                                } else {
                                	fileEntry.file(function(file) {
                                		var filereader = new FileReader();
                                		filereader.onloadend = function(evt) {
                                			if (evt.target.readyState === FileReader.DONE) {
                                				var uint = new Uint8Array(evt.target.result)
                                				var bytes = []
                                				uint.forEach(function(byte) {
                                					bytes.push(byte.toString(16));
                                				})
                                				var hex = bytes.join('').toUpperCase();
                                				var type = getMimetype(hex);
                                				fileOpener.open(file, type, {
                                					success: fileOpenerOptions.onSuccess,
                                					error: fileOpenerOptions.onError
                                				});
                                			}
                                		}
                                		var blob = file.slice(0, 4);
                                		filereader.readAsArrayBuffer(blob);
                                	});
                                }
                            });
                        });
                    });
                } else if (device.platform.toLowerCase() == "ios") {
                    if (iosBrowserMimes[fileOpenerOptions.type]) {
                        openFileInBrowser(fileOpenerOptions.path);
                    } else {
                        fileOpener.open(
                            fileOpenerOptions.path,
                            fileOpenerOptions.type, {
                                success: fileOpenerOptions.onSuccess,
                                error: fileOpenerOptions.onError
                            }
                        );
                    }
                }
            }
        };
    };

    if (cordova && cordova.file) {

        wrapper._readWriteFile = true;

        wrapper.writeFile = function(filename, content, options) {
            let filesystem = LocalFileSystem.PERSISTENT;
            if (options && options.filesystem) {
                filesystem = options.filesystem;
            }
            return new Promise(function(resolve, reject) {
                window.requestFileSystem(filesystem, 0, function (fs) {
                    console.log('file system open: ' + fs.name);
                    fs.root.getFile(filename, {create: true, exclusive: false}, function (fileEntry) {
                        console.log("fileEntry is file?" + fileEntry.isFile.toString());
                        fileEntry.createWriter(function (fileWriter) {
                            fileWriter.onwriteend = function() {
                                // nosemgrep: unsafe-formatstring
                                console.log("Successfully wrote file " + filename, content);
                                resolve();
                            };

                            fileWriter.onerror = function (error) {
                                console.log("Failed file write: " + e.toString());
                                reject(error);
                            };

                            let contentType = "text/plain";
                            if (options && options.contentType) {
                                contentType = options.contentType;
                            }

                            let blob = content;
                            if (typeof(content) === "string") {
                                 blob = new Blob([content], { type: contentType });
                            }

                            fileWriter.write(blob);
                        });
                    }, function(error) {
                        reject(error);
                    });
                }, function(error) {
                    reject(error);
                });
            });
        };

        wrapper.readFile = function(filename, options) {
            let filesystem = LocalFileSystem.PERSISTENT;
            if (options && options.filesystem) {
                filesystem = options.filesystem;
            }
            return new Promise(function (resolve, reject) {
                window.requestFileSystem(filesystem, 0, function (fs) {
                    console.log('file system open: ' + fs.name);
                    fs.root.getFile(filename, {create: false, exclusive: false}, function (fileEntry) {
                        fileEntry.file(function (file) {
                            var reader = new FileReader();
                            reader.onloadend = function () {
                                // nosemgrep: unsafe-formatstring
                                console.log("Successfully read file " + filename, this.result);
                                resolve(this.result);
                            };
                            reader.onerror = function (error) {
                                reject(error);
                            };
                            reader.readAsText(file);
                        });
                    },
                    function (error) {
                        reject(error);
                    });
                }, function (error) {
                    reject(error);
                });
            });
        };
    }

    return wrapper;
});
},
'appivo/util/idb':function(){
define([], function() {

    const db = function(name) {
        if (!name) {
            name = "AppivoDefault";
        }
        this.name = name;
    }

    db.prototype = {
        open: function() {
            const t = this;
            return new Promise((resolve, reject) => {
                if (t.db) {
                    resolve(t.db);
                } else {
                    const request = indexedDB.open(this.name, 1);

                    request.onerror = (event) => reject("Error opening DB:", event.target.error);

                    request.onsuccess = (event) => resolve(event.target.result);

                    request.onupgradeneeded = (event) => {
                        const db = event.target.result;
                        t.db = db;
                        db.createObjectStore("data", {keyPath: "key"});
                    };
                }
            });
        },

        set: function(key, value) {
            return this.open().then(db => {
                return new Promise((resolve, reject) => {
                    const transaction = db.transaction(["data"], "readwrite");
                    const store = transaction.objectStore("data");
                    let request;
                    if (value === null) {
                        request = store.delete(key);
                    } else {
                        const serializedValue = typeof value === 'object' ? JSON.stringify(value) : value;
                        request = store.put({ key: key, value: serializedValue, isObject: typeof value === 'object' });
                    }

                    request.onerror = (event) => reject("Error adding data:", event.target.error);
                    request.onsuccess = (event) => resolve("Data added successfully");
                });
            });
        },

        get: function(key) {
            return this.open().then(db => {
                return new Promise((resolve, reject) => {
                    const transaction = db.transaction(["data"], "readonly");
                    const store = transaction.objectStore("data");
                    const request = store.get(key);

                    request.onerror = (event) => reject("Error getting data:", event.target.error);
                    request.onsuccess = (event) => {
                        if (request.result) {
                            // Deserialize the value if it was originally an object
                            if (request.result.isObject) {
                                try {
                                    resolve(JSON.parse(request.result.value));
                                } catch (e) {
                                    reject("Error parsing stored object:", e);
                                }
                            } else {
                                resolve(request.result.value);
                            }
                        } else {
                            resolve(null);
                        }
                    };
                });
            });
        }
    };

    return db;
});
},
'dojo/dom-style':function(){
define(["./sniff", "./dom", "./_base/window"], function(has, dom, win){
	// module:
	//		dojo/dom-style

	// =============================
	// Style Functions
	// =============================

	// getComputedStyle drives most of the style code.
	// Wherever possible, reuse the returned object.
	//
	// API functions below that need to access computed styles accept an
	// optional computedStyle parameter.
	// If this parameter is omitted, the functions will call getComputedStyle themselves.
	// This way, calling code can access computedStyle once, and then pass the reference to
	// multiple API functions.

	// Although we normally eschew argument validation at this
	// level, here we test argument 'node' for (duck)type,
	// by testing nodeType, ecause 'document' is the 'parentNode' of 'body'
	// it is frequently sent to this function even
	// though it is not Element.
	var getComputedStyle, style = {
		// summary:
		//		This module defines the core dojo DOM style API.
	};
	if(has("webkit")){
		getComputedStyle = function(/*DomNode*/ node){
			var s;
			if(node.nodeType == 1){
				var dv = node.ownerDocument.defaultView;
				s = dv.getComputedStyle(node, null);
				if(!s && node.style){
					node.style.display = "";
					s = dv.getComputedStyle(node, null);
				}
			}
			return s || {};
		};
	}else if(has("ie") && (has("ie") < 9 || has("quirks"))){
		getComputedStyle = function(node){
			// IE (as of 7) doesn't expose Element like sane browsers
			// currentStyle can be null on IE8!
			return node.nodeType == 1 /* ELEMENT_NODE*/ && node.currentStyle ? node.currentStyle : {};
		};
	}else{
		getComputedStyle = function(node){
			if(node.nodeType === 1 /* ELEMENT_NODE*/){
				var dv = node.ownerDocument.defaultView,
					w = dv.opener ? dv : win.global.window;
				return w.getComputedStyle(node, null);
			}
			return {};
		};
	}
	style.getComputedStyle = getComputedStyle;
	/*=====
	style.getComputedStyle = function(node){
		// summary:
		//		Returns a "computed style" object.
		//
		// description:
		//		Gets a "computed style" object which can be used to gather
		//		information about the current state of the rendered node.
		//
		//		Note that this may behave differently on different browsers.
		//		Values may have different formats and value encodings across
		//		browsers.
		//
		//		Note also that this method is expensive.  Wherever possible,
		//		reuse the returned object.
		//
		//		Use the dojo/dom-style.get() method for more consistent (pixelized)
		//		return values.
		//
		// node: DOMNode
		//		A reference to a DOM node. Does NOT support taking an
		//		ID string for speed reasons.
		// example:
		//	|	require(["dojo/dom-style", "dojo/dom"], function(domStyle, dom){
		//	|		domStyle.getComputedStyle(dom.byId('foo')).borderWidth;
		//	|	});
		//
		// example:
		//		Reusing the returned object, avoiding multiple lookups:
		//	|	require(["dojo/dom-style", "dojo/dom"], function(domStyle, dom){
		//	|		var cs = domStyle.getComputedStyle(dom.byId("someNode"));
		//	|		var w = cs.width, h = cs.height;
		//	|	});
		return; // CSS2Properties
	};
	=====*/

	var toPixel;
	if(!has("ie")){
		toPixel = function(element, value){
			// style values can be floats, client code may want
			// to round for integer pixels.
			return parseFloat(value) || 0;
		};
	}else{
		toPixel = function(element, avalue){
			if(!avalue){ return 0; }
			// on IE7, medium is usually 4 pixels
			if(avalue == "medium"){ return 4; }
			// style values can be floats, client code may
			// want to round this value for integer pixels.
			if(avalue.slice && avalue.slice(-2) == 'px'){ return parseFloat(avalue); }
			var s = element.style, rs = element.runtimeStyle, cs = element.currentStyle,
				sLeft = s.left, rsLeft = rs.left;
			rs.left = cs.left;
			try{
				// 'avalue' may be incompatible with style.left, which can cause IE to throw
				// this has been observed for border widths using "thin", "medium", "thick" constants
				// those particular constants could be trapped by a lookup
				// but perhaps there are more
				s.left = avalue;
				avalue = s.pixelLeft;
			}catch(e){
				avalue = 0;
			}
			s.left = sLeft;
			rs.left = rsLeft;
			return avalue;
		};
	}
	style.toPixelValue = toPixel;
	/*=====
	style.toPixelValue = function(node, value){
		// summary:
		//		converts style value to pixels on IE or return a numeric value.
		// node: DOMNode
		// value: String
		// returns: Number
	};
	=====*/

	// FIXME: there opacity quirks on FF that we haven't ported over. Hrm.

	var astr = "DXImageTransform.Microsoft.Alpha";
	var af = function(n, f){
		try{
			return n.filters.item(astr);
		}catch(e){
			return f ? {} : null;
		}
	};

	var _getOpacity =
		has("ie") < 9 || (has("ie") < 10 && has("quirks")) ? function(node){
			try{
				return af(node).Opacity / 100; // Number
			}catch(e){
				return 1; // Number
			}
		} :
		function(node){
			return getComputedStyle(node).opacity;
		};

	var _setOpacity =
		has("ie") < 9 || (has("ie") < 10 && has("quirks")) ? function(/*DomNode*/ node, /*Number*/ opacity){
			if(opacity === ""){ opacity = 1; }
			var ov = opacity * 100, fullyOpaque = opacity === 1;

			// on IE7 Alpha(Filter opacity=100) makes text look fuzzy so disable it altogether (bug #2661),
			// but still update the opacity value so we can get a correct reading if it is read later:
			// af(node, 1).Enabled = !fullyOpaque;

			if(fullyOpaque){
				node.style.zoom = "";
				if(af(node)){
					node.style.filter = node.style.filter.replace(
						new RegExp("\\s*progid:" + astr + "\\([^\\)]+?\\)", "i"), "");
				}
			}else{
				node.style.zoom = 1;
				if(af(node)){
					af(node, 1).Opacity = ov;
				}else{
					node.style.filter += " progid:" + astr + "(Opacity=" + ov + ")";
				}
				af(node, 1).Enabled = true;
			}

			if(node.tagName.toLowerCase() == "tr"){
				for(var td = node.firstChild; td; td = td.nextSibling){
					if(td.tagName.toLowerCase() == "td"){
						_setOpacity(td, opacity);
					}
				}
			}
			return opacity;
		} :
		function(node, opacity){
			return node.style.opacity = opacity;
		};

	var _pixelNamesCache = {
		left: true, top: true
	};
	var _pixelRegExp = /margin|padding|width|height|max|min|offset/; // |border
	function _toStyleValue(node, type, value){
		//TODO: should we really be doing string case conversion here? Should we cache it? Need to profile!
		type = type.toLowerCase();

		// Adjustments for IE and Edge
		if(value == "auto"){
			if(type == "height"){ return node.offsetHeight; }
			if(type == "width"){ return node.offsetWidth; }
		}
		if(type == "fontweight"){
			switch(value){
				case 700: return "bold";
				case 400:
				default: return "normal";
			}
		}

		if(!(type in _pixelNamesCache)){
			_pixelNamesCache[type] = _pixelRegExp.test(type);
		}
		return _pixelNamesCache[type] ? toPixel(node, value) : value;
	}

	var _floatAliases = {cssFloat: 1, styleFloat: 1, "float": 1};

	// public API

	style.get = function getStyle(/*DOMNode|String*/ node, /*String?*/ name){
		// summary:
		//		Accesses styles on a node.
		// description:
		//		Getting the style value uses the computed style for the node, so the value
		//		will be a calculated value, not just the immediate node.style value.
		//		Also when getting values, use specific style names,
		//		like "borderBottomWidth" instead of "border" since compound values like
		//		"border" are not necessarily reflected as expected.
		//		If you want to get node dimensions, use `dojo/dom-geometry.getMarginBox()`,
		//		`dojo/dom-geometry.getContentBox()` or `dojo/dom-geometry.getPosition()`.
		// node: DOMNode|String
		//		id or reference to node to get style for
		// name: String?
		//		the style property to get
		// example:
		//		Passing only an ID or node returns the computed style object of
		//		the node:
		//	|	require(["dojo/dom-style", "dojo/dom"], function(domStyle, dom){
		//	|		domStyle.get("thinger");
		//	|	});
		// example:
		//		Passing a node and a style property returns the current
		//		normalized, computed value for that property:
		//	|	require(["dojo/dom-style", "dojo/dom"], function(domStyle, dom){
		//	|		domStyle.get("thinger", "opacity"); // 1 by default
		//	|	});

		var n = dom.byId(node), l = arguments.length, op = (name == "opacity");
		if(l == 2 && op){
			return _getOpacity(n);
		}
		name = _floatAliases[name] ? "cssFloat" in n.style ? "cssFloat" : "styleFloat" : name;
		var s = style.getComputedStyle(n);
		return (l == 1) ? s : _toStyleValue(n, name, s[name] || n.style[name]); /* CSS2Properties||String||Number */
	};

	style.set = function setStyle(/*DOMNode|String*/ node, /*String|Object*/ name, /*String?*/ value){
		// summary:
		//		Sets styles on a node.
		// node: DOMNode|String
		//		id or reference to node to set style for
		// name: String|Object
		//		the style property to set in DOM-accessor format
		//		("borderWidth", not "border-width") or an object with key/value
		//		pairs suitable for setting each property.
		// value: String?
		//		If passed, sets value on the node for style, handling
		//		cross-browser concerns.  When setting a pixel value,
		//		be sure to include "px" in the value. For instance, top: "200px".
		//		Otherwise, in some cases, some browsers will not apply the style.
		//
		// example:
		//		Passing a node, a style property, and a value changes the
		//		current display of the node and returns the new computed value
		//	|	require(["dojo/dom-style"], function(domStyle){
		//	|		domStyle.set("thinger", "opacity", 0.5); // == 0.5
		//	|	});
		//
		// example:
		//		Passing a node, an object-style style property sets each of the values in turn and returns the computed style object of the node:
		//	|	require(["dojo/dom-style"], function(domStyle){
		//	|		domStyle.set("thinger", {
		//	|			"opacity": 0.5,
		//	|			"border": "3px solid black",
		//	|			"height": "300px"
		//	|		});
		//	|	});
		//
		// example:
		//		When the CSS style property is hyphenated, the JavaScript property is camelCased.
		//		font-size becomes fontSize, and so on.
		//	|	require(["dojo/dom-style", "dojo/dom"], function(domStyle, dom){
		//	|		domStyle.set("thinger",{
		//	|			fontSize:"14pt",
		//	|			letterSpacing:"1.2em"
		//	|		});
		//	|	});
		//
		// example:
		//		dojo/NodeList implements .style() using the same syntax, omitting the "node" parameter, calling
		//		dojo/dom-style.get() on every element of the list. See: `dojo/query` and `dojo/NodeList`
		//	|	require(["dojo/dom-style", "dojo/query", "dojo/NodeList-dom"],
		//	|	function(domStyle, query){
		//	|		query(".someClassName").style("visibility","hidden");
		//	|		// or
		//	|		query("#baz > div").style({
		//	|			opacity:0.75,
		//	|			fontSize:"13pt"
		//	|		});
		//	|	});

		var n = dom.byId(node), l = arguments.length, op = (name == "opacity");
		name = _floatAliases[name] ? "cssFloat" in n.style ? "cssFloat" : "styleFloat" : name;
		if(l == 3){
			return op ? _setOpacity(n, value) : n.style[name] = value; // Number
		}
		for(var x in name){
			style.set(node, x, name[x]);
		}
		return style.getComputedStyle(n);
	};

	return style;
});

},
'dojo/dom-class':function(){
define(["./_base/lang", "./_base/array", "./dom"], function(lang, array, dom){
	// module:
	//		dojo/dom-class

	var className = "className";

	/* Part I of classList-based implementation is preserved here for posterity
	var classList = "classList";
	has.add("dom-classList", function(){
		return classList in document.createElement("p");
	});
	*/

	// =============================
	// (CSS) Class Functions
	// =============================

	var cls, // exports object
		spaces = /\s+/, a1 = [""];

	function str2array(s){
		if(typeof s == "string" || s instanceof String){
			if(s && !spaces.test(s)){
				a1[0] = s;
				return a1;
			}
			var a = s.split(spaces);
			if(a.length && !a[0]){
				a.shift();
			}
			if(a.length && !a[a.length - 1]){
				a.pop();
			}
			return a;
		}
		// assumed to be an array
		if(!s){
			return [];
		}
		return array.filter(s, function(x){ return x; });
	}

	/* Part II of classList-based implementation is preserved here for posterity
	if(has("dom-classList")){
		// new classList version
		cls = {
			contains: function containsClass(node, classStr){
				var clslst = classStr && dom.byId(node)[classList];
				return clslst && clslst.contains(classStr); // Boolean
			},

			add: function addClass(node, classStr){
				node = dom.byId(node);
				classStr = str2array(classStr);
				for(var i = 0, len = classStr.length; i < len; ++i){
					node[classList].add(classStr[i]);
				}
			},

			remove: function removeClass(node, classStr){
				node = dom.byId(node);
				if(classStr === undefined){
					node[className] = "";
				}else{
					classStr = str2array(classStr);
					for(var i = 0, len = classStr.length; i < len; ++i){
						node[classList].remove(classStr[i]);
					}
				}
			},

			replace: function replaceClass(node, addClassStr, removeClassStr){
				node = dom.byId(node);
				if(removeClassStr === undefined){
					node[className] = "";
				}else{
					removeClassStr = str2array(removeClassStr);
					for(var i = 0, len = removeClassStr.length; i < len; ++i){
						node[classList].remove(removeClassStr[i]);
					}
				}
				addClassStr = str2array(addClassStr);
				for(i = 0, len = addClassStr.length; i < len; ++i){
					node[classList].add(addClassStr[i]);
				}
			},

			toggle: function toggleClass(node, classStr, condition){
				node = dom.byId(node);
				if(condition === undefined){
					classStr = str2array(classStr);
					for(var i = 0, len = classStr.length; i < len; ++i){
						node[classList].toggle(classStr[i]);
					}
				}else{
					cls[condition ? "add" : "remove"](node, classStr);
				}
				return condition;   // Boolean
			}
		}
	}
	*/

	// regular DOM version
	var fakeNode = {};  // for effective replacement
	cls = {
		// summary:
		//		This module defines the core dojo DOM class API.

		contains: function containsClass(/*DomNode|String*/ node, /*String*/ classStr){
			// summary:
			//		Returns whether or not the specified classes are a portion of the
			//		class list currently applied to the node.
			// node: String|DOMNode
			//		String ID or DomNode reference to check the class for.
			// classStr: String
			//		A string class name to look for.
			// example:
			//		Do something if a node with id="someNode" has class="aSillyClassName" present
			//	|	if(domClass.contains("someNode","aSillyClassName")){ ... }

			return ((" " + dom.byId(node)[className] + " ").indexOf(" " + classStr + " ") >= 0); // Boolean
		},

		add: function addClass(/*DomNode|String*/ node, /*String|Array*/ classStr){
			// summary:
			//		Adds the specified classes to the end of the class list on the
			//		passed node. Will not re-apply duplicate classes.
			//
			// node: String|DOMNode
			//		String ID or DomNode reference to add a class string too
			//
			// classStr: String|Array
			//		A String class name to add, or several space-separated class names,
			//		or an array of class names.
			//
			// example:
			//		Add a class to some node:
			//	|	require(["dojo/dom-class"], function(domClass){
			//	|		domClass.add("someNode", "anewClass");
			//	|	});
			//
			// example:
			//		Add two classes at once:
			//	|	require(["dojo/dom-class"], function(domClass){
			//	|		domClass.add("someNode", "firstClass secondClass");
			//	|	});
			//
			// example:
			//		Add two classes at once (using array):
			//	|	require(["dojo/dom-class"], function(domClass){
			//	|		domClass.add("someNode", ["firstClass", "secondClass"]);
			//	|	});
			//
			// example:
			//		Available in `dojo/NodeList` for multiple additions
			//	|	require(["dojo/query"], function(query){
			//	|		query("ul > li").addClass("firstLevel");
			//	|	});

			node = dom.byId(node);
			classStr = str2array(classStr);
			var cls = node[className], oldLen;
			cls = cls ? " " + cls + " " : " ";
			oldLen = cls.length;
			for(var i = 0, len = classStr.length, c; i < len; ++i){
				c = classStr[i];
				if(c && cls.indexOf(" " + c + " ") < 0){
					cls += c + " ";
				}
			}
			if(oldLen < cls.length){
				node[className] = cls.substr(1, cls.length - 2);
			}
		},

		remove: function removeClass(/*DomNode|String*/ node, /*String|Array?*/ classStr){
			// summary:
			//		Removes the specified classes from node. No `contains()`
			//		check is required.
			//
			// node: String|DOMNode
			//		String ID or DomNode reference to remove the class from.
			//
			// classStr: String|Array
			//		An optional String class name to remove, or several space-separated
			//		class names, or an array of class names. If omitted, all class names
			//		will be deleted.
			//
			// example:
			//		Remove a class from some node:
			//	|	require(["dojo/dom-class"], function(domClass){
			//	|		domClass.remove("someNode", "firstClass");
			//	|	});
			//
			// example:
			//		Remove two classes from some node:
			//	|	require(["dojo/dom-class"], function(domClass){
			//	|		domClass.remove("someNode", "firstClass secondClass");
			//	|	});
			//
			// example:
			//		Remove two classes from some node (using array):
			//	|	require(["dojo/dom-class"], function(domClass){
			//	|		domClass.remove("someNode", ["firstClass", "secondClass"]);
			//	|	});
			//
			// example:
			//		Remove all classes from some node:
			//	|	require(["dojo/dom-class"], function(domClass){
			//	|		domClass.remove("someNode");
			//	|	});
			//
			// example:
			//		Available in `dojo/NodeList` for multiple removal
			//	|	require(["dojo/query"], function(query){
			//	|		query("ul > li").removeClass("foo");
			//	|	});

			node = dom.byId(node);
			var cls;
			if(classStr !== undefined){
				classStr = str2array(classStr);
				cls = " " + node[className] + " ";
				for(var i = 0, len = classStr.length; i < len; ++i){
					cls = cls.replace(" " + classStr[i] + " ", " ");
				}
				cls = lang.trim(cls);
			}else{
				cls = "";
			}
			if(node[className] != cls){ node[className] = cls; }
		},

		replace: function replaceClass(/*DomNode|String*/ node, /*String|Array*/ addClassStr, /*String|Array?*/ removeClassStr){
			// summary:
			//		Replaces one or more classes on a node if not present.
			//		Operates more quickly than calling domClass.remove and domClass.add
			//
			// node: String|DOMNode
			//		String ID or DomNode reference to remove the class from.
			//
			// addClassStr: String|Array
			//		A String class name to add, or several space-separated class names,
			//		or an array of class names.
			//
			// removeClassStr: String|Array?
			//		A String class name to remove, or several space-separated class names,
			//		or an array of class names.
			//
			// example:
			//	|	require(["dojo/dom-class"], function(domClass){
			//	|		domClass.replace("someNode", "add1 add2", "remove1 remove2");
			//	|	});
			//
			// example:
			//	Replace all classes with addMe
			//	|	require(["dojo/dom-class"], function(domClass){
			//	|		domClass.replace("someNode", "addMe");
			//	|	});
			//
			// example:
			//	Available in `dojo/NodeList` for multiple toggles
			//	|	require(["dojo/query"], function(query){
			//	|		query(".findMe").replaceClass("addMe", "removeMe");
			//	|	});

			node = dom.byId(node);
			fakeNode[className] = node[className];
			cls.remove(fakeNode, removeClassStr);
			cls.add(fakeNode, addClassStr);
			if(node[className] !== fakeNode[className]){
				node[className] = fakeNode[className];
			}
		},

		toggle: function toggleClass(/*DomNode|String*/ node, /*String|Array*/ classStr, /*Boolean?*/ condition){
			// summary:
			//		Adds a class to node if not present, or removes if present.
			//		Pass a boolean condition if you want to explicitly add or remove.
			//		Returns the condition that was specified directly or indirectly.
			//
			// node: String|DOMNode
			//		String ID or DomNode reference to toggle a class string
			//
			// classStr: String|Array
			//		A String class name to toggle, or several space-separated class names,
			//		or an array of class names.
			//
			// condition:
			//		If passed, true means to add the class, false means to remove.
			//		Otherwise domClass.contains(node, classStr) is used to detect the class presence.
			//
			// example:
			//	|	require(["dojo/dom-class"], function(domClass){
			//	|		domClass.toggle("someNode", "hovered");
			//	|	});
			//
			// example:
			//		Forcefully add a class
			//	|	require(["dojo/dom-class"], function(domClass){
			//	|		domClass.toggle("someNode", "hovered", true);
			//	|	});
			//
			// example:
			//		Available in `dojo/NodeList` for multiple toggles
			//	|	require(["dojo/query"], function(query){
			//	|		query(".toggleMe").toggleClass("toggleMe");
			//	|	});

			node = dom.byId(node);
			if(condition === undefined){
				classStr = str2array(classStr);
				for(var i = 0, len = classStr.length, c; i < len; ++i){
					c = classStr[i];
					cls[cls.contains(node, c) ? "remove" : "add"](node, c);
				}
			}else{
				cls[condition ? "add" : "remove"](node, classStr);
			}
			return condition;   // Boolean
		}
	};

	return cls;
});

},
'dojo/dom-attr':function(){
define(["exports", "./sniff", "./_base/lang", "./dom", "./dom-style", "./dom-prop"],
		function(exports, has, lang, dom, style, prop){
	// module:
	//		dojo/dom-attr
	// summary:
	//		This module defines the core dojo DOM attributes API.

	// TODOC: summary not showing up in output see https://github.com/csnover/js-doc-parse/issues/42

	// =============================
	// Element attribute Functions
	// =============================

	// This module will be obsolete soon. Use dojo/prop instead.

	// dojo/dom-attr.get() should conform to http://www.w3.org/TR/DOM-Level-2-Core/

	// attribute-related functions (to be obsolete soon)
	var forcePropNames = {
			innerHTML:	1,
			textContent:1,
			className:	1,
			htmlFor:	has("ie") ? 1 : 0,
			value:		1
		},
		attrNames = {
			// original attribute names
			classname: "class",
			htmlfor: "for",
			// for IE
			tabindex: "tabIndex",
			readonly: "readOnly"
		};

	function _hasAttr(node, name){
		var attr = node.getAttributeNode && node.getAttributeNode(name);
		return !!attr && attr.specified; // Boolean
	}
	
	// There is a difference in the presence of certain properties and their default values
	// between browsers. For example, on IE "disabled" is present on all elements,
	// but it is value is "false"; "tabIndex" of <div> returns 0 by default on IE, yet other browsers
	// can return -1.

	exports.has = function hasAttr(/*DOMNode|String*/ node, /*String*/ name){
		// summary:
		//		Returns true if the requested attribute is specified on the
		//		given element, and false otherwise.
		// node: DOMNode|String
		//		id or reference to the element to check
		// name: String
		//		the name of the attribute
		// returns: Boolean
		//		true if the requested attribute is specified on the
		//		given element, and false otherwise

		var lc = name.toLowerCase();
		return !!forcePropNames[prop.names[lc] || name] || _hasAttr(dom.byId(node), attrNames[lc] || name);	// Boolean
	};

	exports.get = function getAttr(/*DOMNode|String*/ node, /*String*/ name){
		// summary:
		//		Gets an attribute on an HTML element.
		// description:
		//		Handles normalized getting of attributes on DOM Nodes.
		// node: DOMNode|String
		//		id or reference to the element to get the attribute on
		// name: String
		//		the name of the attribute to get.
		// returns:
		//		the value of the requested attribute or null if that attribute does not have a specified or
		//		default value;
		//
		// example:
		//	|	// get the current value of the "foo" attribute on a node
		//	|	require(["dojo/dom-attr", "dojo/dom"], function(domAttr, dom){
		//	|		domAttr.get(dom.byId("nodeId"), "foo");
		//	|		// or we can just pass the id:
		//	|		domAttr.get("nodeId", "foo");
		//	|	});	
		//	|	

		node = dom.byId(node);
		var lc = name.toLowerCase(),
			propName = prop.names[lc] || name,
			forceProp = forcePropNames[propName],
			value = node[propName];		// should we access this attribute via a property or via getAttribute()?

		if(forceProp && typeof value != "undefined"){
			// node's property
			return value;	// Anything
		}
		
		if(propName == "textContent"){
			return prop.get(node, propName);
		}
		
		if(propName != "href" && (typeof value == "boolean" || lang.isFunction(value))){
			// node's property
			return value;	// Anything
		}
		// node's attribute
		// we need _hasAttr() here to guard against IE returning a default value
		var attrName = attrNames[lc] || name;
		return _hasAttr(node, attrName) ? node.getAttribute(attrName) : null; // Anything
	};

	exports.set = function setAttr(/*DOMNode|String*/ node, /*String|Object*/ name, /*String?*/ value){
		// summary:
		//		Sets an attribute on an HTML element.
		// description:
		//		Handles normalized setting of attributes on DOM Nodes.
		//
		//		When passing functions as values, note that they will not be
		//		directly assigned to slots on the node, but rather the default
		//		behavior will be removed and the new behavior will be added
		//		using `dojo.connect()`, meaning that event handler properties
		//		will be normalized and that some caveats with regards to
		//		non-standard behaviors for onsubmit apply. Namely that you
		//		should cancel form submission using `dojo.stopEvent()` on the
		//		passed event object instead of returning a boolean value from
		//		the handler itself.
		// node: DOMNode|String
		//		id or reference to the element to set the attribute on
		// name: String|Object
		//		the name of the attribute to set, or a hash of key-value pairs to set.
		// value: String?
		//		the value to set for the attribute, if the name is a string.
		// returns:
		//		the DOM node
		//
		// example:
		//	|	// use attr() to set the tab index
		//	|	require(["dojo/dom-attr"], function(domAttr){
		//	|		domAttr.set("nodeId", "tabIndex", 3);
		//	|	});
		//
		// example:
		//	Set multiple values at once, including event handlers:
		//	|	require(["dojo/dom-attr"],
		//	|	function(domAttr){
		//	|		domAttr.set("formId", {
		//	|			"foo": "bar",
		//	|			"tabIndex": -1,
		//	|			"method": "POST"
		//	|		}
		//	|	});

		node = dom.byId(node);
		if(arguments.length == 2){ // inline'd type check
			// the object form of setter: the 2nd argument is a dictionary
			for(var x in name){
				exports.set(node, x, name[x]);
			}
			return node; // DomNode
		}
		var lc = name.toLowerCase(),
			propName = prop.names[lc] || name,
			forceProp = forcePropNames[propName];
		if(propName == "style" && typeof value != "string"){ // inline'd type check
			// special case: setting a style
			style.set(node, value);
			return node; // DomNode
		}
		if(forceProp || typeof value == "boolean" || lang.isFunction(value)){
			return prop.set(node, name, value);
		}
		// node's attribute
		node.setAttribute(attrNames[lc] || name, value);
		return node; // DomNode
	};

	exports.remove = function removeAttr(/*DOMNode|String*/ node, /*String*/ name){
		// summary:
		//		Removes an attribute from an HTML element.
		// node: DOMNode|String
		//		id or reference to the element to remove the attribute from
		// name: String
		//		the name of the attribute to remove

		dom.byId(node).removeAttribute(attrNames[name.toLowerCase()] || name);
	};

	exports.getNodeProp = function getNodeProp(/*DomNode|String*/ node, /*String*/ name){
		// summary:
		//		Returns an effective value of a property or an attribute.
		// node: DOMNode|String
		//		id or reference to the element to remove the attribute from
		// name: String
		//		the name of the attribute
		// returns:
		//		the value of the attribute

		node = dom.byId(node);
		var lc = name.toLowerCase(), propName = prop.names[lc] || name;
		if((propName in node) && propName != "href"){
			// node's property
			return node[propName];	// Anything
		}
		// node's attribute
		var attrName = attrNames[lc] || name;
		return _hasAttr(node, attrName) ? node.getAttribute(attrName) : null; // Anything
	};
});

},
'dojo/dom-prop':function(){
define(["exports", "./_base/kernel", "./sniff", "./_base/lang", "./dom", "./dom-style", "./dom-construct", "./_base/connect"],
		function(exports, dojo, has, lang, dom, style, ctr, conn){
	// module:
	//		dojo/dom-prop
	// summary:
	//		This module defines the core dojo DOM properties API.

	// TODOC: summary not showing up in output, see https://github.com/csnover/js-doc-parse/issues/42

	// =============================
	// Element properties Functions
	// =============================

	// helper to connect events
	var _evtHdlrMap = {}, _ctr = 1, _attrId = dojo._scopeName + "attrid";
	has.add('dom-textContent', function (global, doc, element) { return 'textContent' in element; });

	exports.names = {
		// properties renamed to avoid clashes with reserved words
		"class": "className",
		"for": "htmlFor",
		// properties written as camelCase
		tabindex: "tabIndex",
		readonly: "readOnly",
		colspan: "colSpan",
		frameborder: "frameBorder",
		rowspan: "rowSpan",
		textcontent: "textContent",
		valuetype: "valueType"
	};
	
	function getText(/*DOMNode*/node){
		// summary:
		//		recursion method for get('textContent') to use. Gets text value for a node.
		// description:
		//		Juse uses nodedValue so things like <br/> tags do not end up in
		//		the text as any sort of line return.
		var text = "", ch = node.childNodes;
		for(var i = 0, n; n = ch[i]; i++){
			//Skip comments.
			if(n.nodeType != 8){
				if(n.nodeType == 1){
					text += getText(n);
				}else{
					text += n.nodeValue;
				}
			}
		}
		return text;
	}

	exports.get = function getProp(/*DOMNode|String*/ node, /*String*/ name){
		// summary:
		//		Gets a property on an HTML element.
		// description:
		//		Handles normalized getting of properties on DOM nodes.
		//
		// node: DOMNode|String
		//		id or reference to the element to get the property on
		// name: String
		//		the name of the property to get.
		// returns:
		//		the value of the requested property or its default value
		//
		// example:
		//	|	// get the current value of the "foo" property on a node
		//	|	require(["dojo/dom-prop", "dojo/dom"], function(domProp, dom){
		//	|		domProp.get(dom.byId("nodeId"), "foo");
		//	|		// or we can just pass the id:
		//	|		domProp.get("nodeId", "foo");
		//	|	});

		node = dom.byId(node);
		var lc = name.toLowerCase(), propName = exports.names[lc] || name;
		
		if(propName == "textContent" && !has("dom-textContent")){
			return getText(node);
		}
		
		return node[propName];	// Anything
	};

	exports.set = function setProp(/*DOMNode|String*/ node, /*String|Object*/ name, /*String?*/ value){
		// summary:
		//		Sets a property on an HTML element.
		// description:
		//		Handles normalized setting of properties on DOM nodes.
		//
		//		When passing functions as values, note that they will not be
		//		directly assigned to slots on the node, but rather the default
		//		behavior will be removed and the new behavior will be added
		//		using `dojo.connect()`, meaning that event handler properties
		//		will be normalized and that some caveats with regards to
		//		non-standard behaviors for onsubmit apply. Namely that you
		//		should cancel form submission using `dojo.stopEvent()` on the
		//		passed event object instead of returning a boolean value from
		//		the handler itself.
		// node: DOMNode|String
		//		id or reference to the element to set the property on
		// name: String|Object
		//		the name of the property to set, or a hash object to set
		//		multiple properties at once.
		// value: String?
		//		The value to set for the property
		// returns:
		//		the DOM node
		//
		// example:
		//	|	// use prop() to set the tab index
		//	|	require(["dojo/dom-prop"], function(domProp){
		//	|		domProp.set("nodeId", "tabIndex", 3);
		//	|	});
		//
		// example:
		//	Set multiple values at once, including event handlers:
		//	|	require(["dojo/dom-prop"], function(domProp){
		//	|		domProp.set("formId", {
		//	|			"foo": "bar",
		//	|			"tabIndex": -1,
		//	|			"method": "POST",
		//	|		});
		//	|	});

		node = dom.byId(node);
		var l = arguments.length;
		if(l == 2 && typeof name != "string"){ // inline'd type check
			// the object form of setter: the 2nd argument is a dictionary
			for(var x in name){
				exports.set(node, x, name[x]);
			}
			return node; // DomNode
		}
		var lc = name.toLowerCase(), propName = exports.names[lc] || name;
		if(propName == "style" && typeof value != "string"){ // inline'd type check
			// special case: setting a style
			style.set(node, value);
			return node; // DomNode
		}
		if(propName == "innerHTML"){
			// special case: assigning HTML
			// the hash lists elements with read-only innerHTML on IE
			if(has("ie") && node.tagName.toLowerCase() in {col: 1, colgroup: 1,
						table: 1, tbody: 1, tfoot: 1, thead: 1, tr: 1, title: 1}){
				ctr.empty(node);
				node.appendChild(ctr.toDom(value, node.ownerDocument));
			}else{
				node[propName] = value;
			}
			return node; // DomNode
		}
		if(propName == "textContent" && !has("dom-textContent")) {
			ctr.empty(node);
			node.appendChild(node.ownerDocument.createTextNode(value));
			return node;
		}
		if(lang.isFunction(value)){
			// special case: assigning an event handler
			// clobber if we can
			var attrId = node[_attrId];
			if(!attrId){
				attrId = _ctr++;
				node[_attrId] = attrId;
			}
			if(!_evtHdlrMap[attrId]){
				_evtHdlrMap[attrId] = {};
			}
			var h = _evtHdlrMap[attrId][propName];
			if(h){
				//h.remove();
				conn.disconnect(h);
			}else{
				try{
					delete node[propName];
				}catch(e){}
			}
			// ensure that event objects are normalized, etc.
			if(value){
				//_evtHdlrMap[attrId][propName] = on(node, propName, value);
				_evtHdlrMap[attrId][propName] = conn.connect(node, propName, value);
			}else{
				node[propName] = null;
			}
			return node; // DomNode
		}
		node[propName] = value;
		return node;	// DomNode
	};
});

},
'dojo/dom-construct':function(){
define(["exports", "./_base/kernel", "./sniff", "./_base/window", "./dom", "./dom-attr"],
		function(exports, dojo, has, win, dom, attr){
	// module:
	//		dojo/dom-construct
	// summary:
	//		This module defines the core dojo DOM construction API.

	// TODOC: summary not showing up in output, see https://github.com/csnover/js-doc-parse/issues/42

	// support stuff for toDom()
	var tagWrap = {
			option: ["select"],
			tbody: ["table"],
			thead: ["table"],
			tfoot: ["table"],
			tr: ["table", "tbody"],
			td: ["table", "tbody", "tr"],
			th: ["table", "thead", "tr"],
			legend: ["fieldset"],
			caption: ["table"],
			colgroup: ["table"],
			col: ["table", "colgroup"],
			li: ["ul"]
		},
		reTag = /<\s*([\w\:]+)/,
		masterNode = {}, masterNum = 0,
		masterName = "__" + dojo._scopeName + "ToDomId";

	// generate start/end tag strings to use
	// for the injection for each special tag wrap case.
	for(var param in tagWrap){
		if(tagWrap.hasOwnProperty(param)){
			var tw = tagWrap[param];
			tw.pre = param == "option" ? '<select multiple="multiple">' : "<" + tw.join("><") + ">";
			tw.post = "</" + tw.reverse().join("></") + ">";
			// the last line is destructive: it reverses the array,
			// but we don't care at this point
		}
	}

	var html5domfix;
	if(has("ie") <= 8){
		html5domfix = function(doc){
			doc.__dojo_html5_tested = "yes";
			var div = create('div', {innerHTML: "<nav>a</nav>", style: {visibility: "hidden"}}, doc.body);
			if(div.childNodes.length !== 1){
				('abbr article aside audio canvas details figcaption figure footer header ' +
				'hgroup mark meter nav output progress section summary time video').replace(
					/\b\w+\b/g, function(n){
						doc.createElement(n);
					}
				);
			}
			destroy(div);
		}
	}

	function _insertBefore(/*DomNode*/ node, /*DomNode*/ ref){
		var parent = ref.parentNode;
		if(parent){
			parent.insertBefore(node, ref);
		}
	}

	function _insertAfter(/*DomNode*/ node, /*DomNode*/ ref){
		// summary:
		//		Try to insert node after ref
		var parent = ref.parentNode;
		if(parent){
			if(parent.lastChild == ref){
				parent.appendChild(node);
			}else{
				parent.insertBefore(node, ref.nextSibling);
			}
		}
	}

	exports.toDom = function toDom(frag, doc){
		// summary:
		//		instantiates an HTML fragment returning the corresponding DOM.
		// frag: String
		//		the HTML fragment
		// doc: DocumentNode?
		//		optional document to use when creating DOM nodes, defaults to
		//		dojo/_base/window.doc if not specified.
		// returns:
		//		Document fragment, unless it's a single node in which case it returns the node itself
		// example:
		//		Create a table row:
		//	|	require(["dojo/dom-construct"], function(domConstruct){
		//	|		var tr = domConstruct.toDom("<tr><td>First!</td></tr>");
		//	|	});

		doc = doc || win.doc;
		var masterId = doc[masterName];
		if(!masterId){
			doc[masterName] = masterId = ++masterNum + "";
			masterNode[masterId] = doc.createElement("div");
		}

		if(has("ie") <= 8){
			if(!doc.__dojo_html5_tested && doc.body){
				html5domfix(doc);
			}
		}

		// make sure the frag is a string.
		frag += "";

		// find the starting tag, and get node wrapper
		var match = frag.match(reTag),
			tag = match ? match[1].toLowerCase() : "",
			master = masterNode[masterId],
			wrap, i, fc, df;
		if(match && tagWrap[tag]){
			wrap = tagWrap[tag];
			master.innerHTML = wrap.pre + frag + wrap.post;
			for(i = wrap.length; i; --i){
				master = master.firstChild;
			}
		}else{
			master.innerHTML = frag;
		}

		// one node shortcut => return the node itself
		if(master.childNodes.length == 1){
			return master.removeChild(master.firstChild); // DOMNode
		}

		// return multiple nodes as a document fragment
		df = doc.createDocumentFragment();
		while((fc = master.firstChild)){ // intentional assignment
			df.appendChild(fc);
		}
		return df; // DocumentFragment
	};

	exports.place = function place(node, refNode, position){
		// summary:
		//		Attempt to insert node into the DOM, choosing from various positioning options.
		//		Returns the first argument resolved to a DOM node.
		// node: DOMNode|DocumentFragment|String
		//		id or node reference, or HTML fragment starting with "<" to place relative to refNode
		// refNode: DOMNode|String
		//		id or node reference to use as basis for placement
		// position: String|Number?
		//		string noting the position of node relative to refNode or a
		//		number indicating the location in the childNodes collection of refNode.
		//		Accepted string values are:
		//
		//		- before
		//		- after
		//		- replace
		//		- only
		//		- first
		//		- last
		//
		//		"first" and "last" indicate positions as children of refNode, "replace" replaces refNode,
		//		"only" replaces all children.  position defaults to "last" if not specified
		// returns: DOMNode
		//		Returned values is the first argument resolved to a DOM node.
		//
		//		.place() is also a method of `dojo/NodeList`, allowing `dojo/query` node lookups.
		// example:
		//		Place a node by string id as the last child of another node by string id:
		//	|	require(["dojo/dom-construct"], function(domConstruct){
		//	|		domConstruct.place("someNode", "anotherNode");
		//	|	});
		// example:
		//		Place a node by string id before another node by string id
		//	|	require(["dojo/dom-construct"], function(domConstruct){
		//	|		domConstruct.place("someNode", "anotherNode", "before");
		//	|	});
		// example:
		//		Create a Node, and place it in the body element (last child):
		//	|	require(["dojo/dom-construct", "dojo/_base/window"
		//	|	], function(domConstruct, win){
		//	|		domConstruct.place("<div></div>", win.body());
		//	|	});
		// example:
		//		Put a new LI as the first child of a list by id:
		//	|	require(["dojo/dom-construct"], function(domConstruct){
		//	|		domConstruct.place("<li></li>", "someUl", "first");
		//	|	});

		refNode = dom.byId(refNode);
		if(typeof node == "string"){ // inline'd type check
			node = /^\s*</.test(node) ? exports.toDom(node, refNode.ownerDocument) : dom.byId(node);
		}
		if(typeof position == "number"){ // inline'd type check
			var cn = refNode.childNodes;
			if(!cn.length || cn.length <= position){
				refNode.appendChild(node);
			}else{
				_insertBefore(node, cn[position < 0 ? 0 : position]);
			}
		}else{
			switch(position){
				case "before":
					_insertBefore(node, refNode);
					break;
				case "after":
					_insertAfter(node, refNode);
					break;
				case "replace":
					refNode.parentNode.replaceChild(node, refNode);
					break;
				case "only":
					exports.empty(refNode);
					refNode.appendChild(node);
					break;
				case "first":
					if(refNode.firstChild){
						_insertBefore(node, refNode.firstChild);
						break;
					}
					// else fallthrough...
				default: // aka: last
					refNode.appendChild(node);
			}
		}
		return node; // DomNode
	};

	var create = exports.create = function create(/*DOMNode|String*/ tag, /*Object*/ attrs, /*DOMNode|String?*/ refNode, /*String?*/ pos){
		// summary:
		//		Create an element, allowing for optional attribute decoration
		//		and placement.
		// description:
		//		A DOM Element creation function. A shorthand method for creating a node or
		//		a fragment, and allowing for a convenient optional attribute setting step,
		//		as well as an optional DOM placement reference.
		//
		//		Attributes are set by passing the optional object through `dojo/dom-attr.set`.
		//		See `dojo/dom-attr.set` for noted caveats and nuances, and API if applicable.
		//
		//		Placement is done via `dojo/dom-construct.place`, assuming the new node to be
		//		the action node, passing along the optional reference node and position.
		// tag: DOMNode|String
		//		A string of the element to create (eg: "div", "a", "p", "li", "script", "br"),
		//		or an existing DOM node to process.
		// attrs: Object
		//		An object-hash of attributes to set on the newly created node.
		//		Can be null, if you don't want to set any attributes/styles.
		//		See: `dojo/dom-attr.set` for a description of available attributes.
		// refNode: DOMNode|String?
		//		Optional reference node. Used by `dojo/dom-construct.place` to place the newly created
		//		node somewhere in the dom relative to refNode. Can be a DomNode reference
		//		or String ID of a node.
		// pos: String?
		//		Optional positional reference. Defaults to "last" by way of `dojo/domConstruct.place`,
		//		though can be set to "first","after","before","last", "replace" or "only"
		//		to further control the placement of the new node relative to the refNode.
		//		'refNode' is required if a 'pos' is specified.
		// example:
		//		Create a DIV:
		//	|	require(["dojo/dom-construct"], function(domConstruct){
		//	|		var n = domConstruct.create("div");
		//	|	});
		//
		// example:
		//		Create a DIV with content:
		//	|	require(["dojo/dom-construct"], function(domConstruct){
		//	|		var n = domConstruct.create("div", { innerHTML:"<p>hi</p>" });
		//	|	});
		//
		// example:
		//		Place a new DIV in the BODY, with no attributes set
		//	|	require(["dojo/dom-construct", "dojo/_base/window"], function(domConstruct, win){
		//	|		var n = domConstruct.create("div", null, win.body());
		//	|	});
		//
		// example:
		//		Create an UL, and populate it with LI's. Place the list as the first-child of a
		//		node with id="someId":
		//	|	require(["dojo/dom-construct", "dojo/_base/array"],
		//	|	function(domConstruct, arrayUtil){
		//	|		var ul = domConstruct.create("ul", null, "someId", "first");
		//	|		var items = ["one", "two", "three", "four"];
		//	|		arrayUtil.forEach(items, function(data){
		//	|			domConstruct.create("li", { innerHTML: data }, ul);
		//	|		});
		//	|	});
		//
		// example:
		//		Create an anchor, with an href. Place in BODY:
		//	|	require(["dojo/dom-construct", "dojo/_base/window"], function(domConstruct, win){
		//	|		domConstruct.create("a", { href:"foo.html", title:"Goto FOO!" }, win.body());
		//	|	});

		var doc = win.doc;
		if(refNode){
			refNode = dom.byId(refNode);
			doc = refNode.ownerDocument;
		}
		if(typeof tag == "string"){ // inline'd type check
			tag = doc.createElement(tag);
		}
		if(attrs){ attr.set(tag, attrs); }
		if(refNode){ exports.place(tag, refNode, pos); }
		return tag; // DomNode
	};

	function _empty(/*DomNode*/ node){
		// TODO: remove this if() block in 2.0 when we no longer have to worry about IE memory leaks,
		// and then uncomment the emptyGrandchildren() test case from html.html.
		// Note that besides fixing #16957, using removeChild() is actually faster than setting node.innerHTML,
		// see http://jsperf.com/clear-dom-node.
		if("innerHTML" in node){
			try{
				// fast path
				node.innerHTML = "";
				return;
			}catch(e){
				// innerHTML is readOnly (e.g. TABLE (sub)elements in quirks mode)
				// Fall through (saves bytes)
			}
		}

		// SVG/strict elements don't support innerHTML
		for(var c; c = node.lastChild;){ // intentional assignment
			node.removeChild(c);
		}
	}

	exports.empty = function empty(/*DOMNode|String*/ node){
		// summary:
		//		safely removes all children of the node.
		// node: DOMNode|String
		//		a reference to a DOM node or an id.
		// example:
		//		Destroy node's children byId:
		//	|	require(["dojo/dom-construct"], function(domConstruct){
		//	|		domConstruct.empty("someId");
		//	|	});

		_empty(dom.byId(node));
	};


	function _destroy(/*DomNode*/ node, /*DomNode*/ parent){
		// in IE quirks, node.canHaveChildren can be false but firstChild can be non-null (OBJECT/APPLET)
		if(node.firstChild){
			_empty(node);
		}
		if(parent){
			// removeNode(false) doesn't leak in IE 6+, but removeChild() and removeNode(true) are known to leak under IE 8- while 9+ is TBD.
			// In IE quirks mode, PARAM nodes as children of OBJECT/APPLET nodes have a removeNode method that does nothing and
			// the parent node has canHaveChildren=false even though removeChild correctly removes the PARAM children.
			// In IE, SVG/strict nodes don't have a removeNode method nor a canHaveChildren boolean.
			has("ie") && parent.canHaveChildren && "removeNode" in node ? node.removeNode(false) : parent.removeChild(node);
		}
	}
	var destroy = exports.destroy = function destroy(/*DOMNode|String*/ node){
		// summary:
		//		Removes a node from its parent, clobbering it and all of its
		//		children.
		//
		// description:
		//		Removes a node from its parent, clobbering it and all of its
		//		children. Function only works with DomNodes, and returns nothing.
		//
		// node: DOMNode|String
		//		A String ID or DomNode reference of the element to be destroyed
		//
		// example:
		//		Destroy a node byId:
		//	|	require(["dojo/dom-construct"], function(domConstruct){
		//	|		domConstruct.destroy("someId");
		//	|	});

		node = dom.byId(node);
		if(!node){ return; }
		_destroy(node, node.parentNode);
	};
});

},
'dojo/_base/connect':function(){
define(["./kernel", "../on", "../topic", "../aspect", "./event", "../mouse", "./sniff", "./lang", "../keys"], function(dojo, on, hub, aspect, eventModule, mouse, has, lang){
// module:
//		dojo/_base/connect

has.add("events-keypress-typed", function(){ // keypresses should only occur a printable character is hit
	var testKeyEvent = {charCode: 0};
	try{
		testKeyEvent = document.createEvent("KeyboardEvent");
		(testKeyEvent.initKeyboardEvent || testKeyEvent.initKeyEvent).call(testKeyEvent, "keypress", true, true, null, false, false, false, false, 9, 3);
	}catch(e){}
	return testKeyEvent.charCode == 0 && !has("opera");
});

function connect_(obj, event, context, method, dontFix){
	method = lang.hitch(context, method);
	if(!obj || !(obj.addEventListener || obj.attachEvent)){
		// it is a not a DOM node and we are using the dojo.connect style of treating a
		// method like an event, must go right to aspect
		return aspect.after(obj || dojo.global, event, method, true);
	}
	if(typeof event == "string" && event.substring(0, 2) == "on"){
		event = event.substring(2);
	}
	if(!obj){
		obj = dojo.global;
	}
	if(!dontFix){
		switch(event){
			// dojo.connect has special handling for these event types
			case "keypress":
				event = keypress;
				break;
			case "mouseenter":
				event = mouse.enter;
				break;
			case "mouseleave":
				event = mouse.leave;
				break;
		}
	}
	return on(obj, event, method, dontFix);
}

var _punctMap = {
	106:42,
	111:47,
	186:59,
	187:43,
	188:44,
	189:45,
	190:46,
	191:47,
	192:96,
	219:91,
	220:92,
	221:93,
	222:39,
	229:113
};
var evtCopyKey = has("mac") ? "metaKey" : "ctrlKey";


var _synthesizeEvent = function(evt, props){
	var faux = lang.mixin({}, evt, props);
	setKeyChar(faux);
	// FIXME: would prefer to use lang.hitch: lang.hitch(evt, evt.preventDefault);
	// but it throws an error when preventDefault is invoked on Safari
	// does Event.preventDefault not support "apply" on Safari?
	faux.preventDefault = function(){ evt.preventDefault(); };
	faux.stopPropagation = function(){ evt.stopPropagation(); };
	return faux;
};
function setKeyChar(evt){
	evt.keyChar = evt.charCode ? String.fromCharCode(evt.charCode) : '';
	evt.charOrCode = evt.keyChar || evt.keyCode;
}
var keypress;
if(has("events-keypress-typed")){
	// this emulates Firefox's keypress behavior where every keydown can correspond to a keypress
	var _trySetKeyCode = function(e, code){
		try{
			// squelch errors when keyCode is read-only
			// (e.g. if keyCode is ctrl or shift)
			return (e.keyCode = code);
		}catch(e){
			return 0;
		}
	};
	keypress = function(object, listener){
		var keydownSignal = on(object, "keydown", function(evt){
			// munge key/charCode
			var k=evt.keyCode;
			// These are Windows Virtual Key Codes
			// http://msdn.microsoft.com/library/default.asp?url=/library/en-us/winui/WinUI/WindowsUserInterface/UserInput/VirtualKeyCodes.asp
			var unprintable = (k!=13) && k!=32 && (k!=27||!has("ie")) && (k<48||k>90) && (k<96||k>111) && (k<186||k>192) && (k<219||k>222) && k!=229;
			// synthesize keypress for most unprintables and CTRL-keys
			if(unprintable||evt.ctrlKey){
				var c = unprintable ? 0 : k;
				if(evt.ctrlKey){
					if(k==3 || k==13){
						return listener.call(evt.currentTarget, evt); // IE will post CTRL-BREAK, CTRL-ENTER as keypress natively
					}else if(c>95 && c<106){
						c -= 48; // map CTRL-[numpad 0-9] to ASCII
					}else if((!evt.shiftKey)&&(c>=65&&c<=90)){
						c += 32; // map CTRL-[A-Z] to lowercase
					}else{
						c = _punctMap[c] || c; // map other problematic CTRL combinations to ASCII
					}
				}
				// simulate a keypress event
				var faux = _synthesizeEvent(evt, {type: 'keypress', faux: true, charCode: c});
				listener.call(evt.currentTarget, faux);
				if(has("ie")){
					_trySetKeyCode(evt, faux.keyCode);
				}
			}
		});
		var keypressSignal = on(object, "keypress", function(evt){
			var c = evt.charCode;
			c = c>=32 ? c : 0;
			evt = _synthesizeEvent(evt, {charCode: c, faux: true});
			return listener.call(this, evt);
		});
		return {
			remove: function(){
				keydownSignal.remove();
				keypressSignal.remove();
			}
		};
	};
}else{
	if(has("opera")){
		keypress = function(object, listener){
			return on(object, "keypress", function(evt){
				var c = evt.which;
				if(c==3){
					c=99; // Mozilla maps CTRL-BREAK to CTRL-c
				}
				// can't trap some keys at all, like INSERT and DELETE
				// there is no differentiating info between DELETE and ".", or INSERT and "-"
				c = c<32 && !evt.shiftKey ? 0 : c;
				if(evt.ctrlKey && !evt.shiftKey && c>=65 && c<=90){
					// lowercase CTRL-[A-Z] keys
					c += 32;
				}
				return listener.call(this, _synthesizeEvent(evt, { charCode: c }));
			});
		};
	}else{
		keypress = function(object, listener){
			return on(object, "keypress", function(evt){
				setKeyChar(evt);
				return listener.call(this, evt);
			});
		};
	}
}

var connect = {
	// summary:
	//		This module defines the dojo.connect API.
	//		This modules also provides keyboard event handling helpers.
	//		This module exports an extension event for emulating Firefox's keypress handling.
	//		However, this extension event exists primarily for backwards compatibility and
	//		is not recommended. WebKit and IE uses an alternate keypress handling (only
	//		firing for printable characters, to distinguish from keydown events), and most
	//		consider the WebKit/IE behavior more desirable.

	_keypress:keypress,

	connect:function(obj, event, context, method, dontFix){
		// summary:
		//		`dojo.connect` is a deprecated event handling and delegation method in
		//		Dojo. It allows one function to "listen in" on the execution of
		//		any other, triggering the second whenever the first is called. Many
		//		listeners may be attached to a function, and source functions may
		//		be either regular function calls or DOM events.
		//
		// description:
		//		Connects listeners to actions, so that after event fires, a
		//		listener is called with the same arguments passed to the original
		//		function.
		//
		//		Since `dojo.connect` allows the source of events to be either a
		//		"regular" JavaScript function or a DOM event, it provides a uniform
		//		interface for listening to all the types of events that an
		//		application is likely to deal with though a single, unified
		//		interface. DOM programmers may want to think of it as
		//		"addEventListener for everything and anything".
		//
		//		When setting up a connection, the `event` parameter must be a
		//		string that is the name of the method/event to be listened for. If
		//		`obj` is null, `kernel.global` is assumed, meaning that connections
		//		to global methods are supported but also that you may inadvertently
		//		connect to a global by passing an incorrect object name or invalid
		//		reference.
		//
		//		`dojo.connect` generally is forgiving. If you pass the name of a
		//		function or method that does not yet exist on `obj`, connect will
		//		not fail, but will instead set up a stub method. Similarly, null
		//		arguments may simply be omitted such that fewer than 4 arguments
		//		may be required to set up a connection See the examples for details.
		//
		//		The return value is a handle that is needed to
		//		remove this connection with `dojo.disconnect`.
		//
		// obj: Object?
		//		The source object for the event function.
		//		Defaults to `kernel.global` if null.
		//		If obj is a DOM node, the connection is delegated
		//		to the DOM event manager (unless dontFix is true).
		//
		// event: String
		//		String name of the event function in obj.
		//		I.e. identifies a property `obj[event]`.
		//
		// context: Object|null
		//		The object that method will receive as "this".
		//
		//		If context is null and method is a function, then method
		//		inherits the context of event.
		//
		//		If method is a string then context must be the source
		//		object object for method (context[method]). If context is null,
		//		kernel.global is used.
		//
		// method: String|Function
		//		A function reference, or name of a function in context.
		//		The function identified by method fires after event does.
		//		method receives the same arguments as the event.
		//		See context argument comments for information on method's scope.
		//
		// dontFix: Boolean?
		//		If obj is a DOM node, set dontFix to true to prevent delegation
		//		of this connection to the DOM event manager.
		//
		// example:
		//		When obj.onchange(), do ui.update():
		//	|	dojo.connect(obj, "onchange", ui, "update");
		//	|	dojo.connect(obj, "onchange", ui, ui.update); // same
		//
		// example:
		//		Using return value for disconnect:
		//	|	var link = dojo.connect(obj, "onchange", ui, "update");
		//	|	...
		//	|	dojo.disconnect(link);
		//
		// example:
		//		When onglobalevent executes, watcher.handler is invoked:
		//	|	dojo.connect(null, "onglobalevent", watcher, "handler");
		//
		// example:
		//		When ob.onCustomEvent executes, customEventHandler is invoked:
		//	|	dojo.connect(ob, "onCustomEvent", null, "customEventHandler");
		//	|	dojo.connect(ob, "onCustomEvent", "customEventHandler"); // same
		//
		// example:
		//		When ob.onCustomEvent executes, customEventHandler is invoked
		//		with the same scope (this):
		//	|	dojo.connect(ob, "onCustomEvent", null, customEventHandler);
		//	|	dojo.connect(ob, "onCustomEvent", customEventHandler); // same
		//
		// example:
		//		When globalEvent executes, globalHandler is invoked
		//		with the same scope (this):
		//	|	dojo.connect(null, "globalEvent", null, globalHandler);
		//	|	dojo.connect("globalEvent", globalHandler); // same

		// normalize arguments
		var a=arguments, args=[], i=0;
		// if a[0] is a String, obj was omitted
		args.push(typeof a[0] == "string" ? null : a[i++], a[i++]);
		// if the arg-after-next is a String or Function, context was NOT omitted
		var a1 = a[i+1];
		args.push(typeof a1 == "string" || typeof a1 == "function" ? a[i++] : null, a[i++]);
		// absorb any additional arguments
		for(var l=a.length; i<l; i++){	args.push(a[i]); }
		return connect_.apply(this, args);
	},

	disconnect:function(handle){
		// summary:
		//		Remove a link created by dojo.connect.
		// description:
		//		Removes the connection between event and the method referenced by handle.
		// handle: Handle
		//		the return value of the dojo.connect call that created the connection.

		if(handle){
			handle.remove();
		}
	},

	subscribe:function(topic, context, method){
		// summary:
		//		Attach a listener to a named topic. The listener function is invoked whenever the
		//		named topic is published (see: dojo.publish).
		//		Returns a handle which is needed to unsubscribe this listener.
		// topic: String
		//		The topic to which to subscribe.
		// context: Object?
		//		Scope in which method will be invoked, or null for default scope.
		// method: String|Function
		//		The name of a function in context, or a function reference. This is the function that
		//		is invoked when topic is published.
		// example:
		//	|	dojo.subscribe("alerts", null, function(caption, message){ alert(caption + "\n" + message); });
		//	|	dojo.publish("alerts", [ "read this", "hello world" ]);
		return hub.subscribe(topic, lang.hitch(context, method));
	},

	publish:function(topic, args){
		// summary:
		//		Invoke all listener method subscribed to topic.
		// topic: String
		//		The name of the topic to publish.
		// args: Array?
		//		An array of arguments. The arguments will be applied
		//		to each topic subscriber (as first class parameters, via apply).
		// example:
		//	|	dojo.subscribe("alerts", null, function(caption, message){ alert(caption + "\n" + message); };
		//	|	dojo.publish("alerts", [ "read this", "hello world" ]);
		return hub.publish.apply(hub, [topic].concat(args));
	},

	connectPublisher:function(topic, obj, event){
		// summary:
		//		Ensure that every time obj.event() is called, a message is published
		//		on the topic. Returns a handle which can be passed to
		//		dojo.disconnect() to disable subsequent automatic publication on
		//		the topic.
		// topic: String
		//		The name of the topic to publish.
		// obj: Object?
		//		The source object for the event function. Defaults to kernel.global
		//		if null.
		// event: String
		//		The name of the event function in obj.
		//		I.e. identifies a property obj[event].
		// example:
		//	|	dojo.connectPublisher("/ajax/start", dojo, "xhrGet");
		var pf = function(){ connect.publish(topic, arguments); };
		return event ? connect.connect(obj, event, pf) : connect.connect(obj, pf); //Handle
	},

	isCopyKey: function(e){
		// summary:
		//		Checks an event for the copy key (meta on Mac, and ctrl anywhere else)
		// e: Event
		//		Event object to examine
		return e[evtCopyKey];	// Boolean
	}
};

connect.unsubscribe = connect.disconnect;
/*=====
 connect.unsubscribe = function(handle){
	 // summary:
	 //		Remove a topic listener.
	 // handle: Handle
	 //		The handle returned from a call to subscribe.
	 // example:
	 //	|	var alerter = dojo.subscribe("alerts", null, function(caption, message){ alert(caption + "\n" + message); };
	 //	|	...
	 //	|	dojo.unsubscribe(alerter);
 };
 =====*/

 1  && lang.mixin(dojo, connect);
return connect;

});



},
'dojo/_base/event':function(){
define(["./kernel", "../on", "../has", "../dom-geometry"], function(dojo, on, has, dom){
	// module:
	//		dojo/_base/event

	if(on._fixEvent){
		var fixEvent = on._fixEvent;
		on._fixEvent = function(evt, se){
			// add some additional normalization for back-compat, this isn't in on.js because it is somewhat more expensive
			evt = fixEvent(evt, se);
			if(evt){
				dom.normalizeEvent(evt);
			}
			return evt;
		};		
	}
	
	var ret = {
		// summary:
		//		This module defines dojo DOM event API.   Usually you should use dojo/on, and evt.stopPropagation() +
		//		evt.preventDefault(), rather than this module.

		fix: function(/*Event*/ evt, /*DOMNode*/ sender){
			// summary:
			//		normalizes properties on the event object including event
			//		bubbling methods, keystroke normalization, and x/y positions
			// evt: Event
			//		native event object
			// sender: DOMNode
			//		node to treat as "currentTarget"
			if(on._fixEvent){
				return on._fixEvent(evt, sender);
			}
			return evt;	// Event
		},
	
		stop: function(/*Event*/ evt){
			// summary:
			//		prevents propagation and clobbers the default action of the
			//		passed event
			// evt: Event
			//		The event object. If omitted, window.event is used on IE.
			if(has("dom-addeventlistener") || (evt && evt.preventDefault)){
				evt.preventDefault();
				evt.stopPropagation();
			}else{
				evt = evt || window.event;
				evt.cancelBubble = true;
				on._preventDefault.call(evt);
			}
		}
	};

	if( 1 ){
		dojo.fixEvent = ret.fix;
		dojo.stopEvent = ret.stop;
	}

	return ret;
});

},
'dojo/dom-geometry':function(){
define(["./sniff", "./_base/window","./dom", "./dom-style"],
		function(has, win, dom, style){
	// module:
	//		dojo/dom-geometry

	// the result object
	var geom = {
		// summary:
		//		This module defines the core dojo DOM geometry API.
	};

	// Box functions will assume this model.
	// On IE/Opera, BORDER_BOX will be set if the primary document is in quirks mode.
	// Can be set to change behavior of box setters.

	// can be either:
	//	"border-box"
	//	"content-box" (default)
	geom.boxModel = "content-box";

	// We punt per-node box mode testing completely.
	// If anybody cares, we can provide an additional (optional) unit
	// that overrides existing code to include per-node box sensitivity.

	// Opera documentation claims that Opera 9 uses border-box in BackCompat mode.
	// but experiments (Opera 9.10.8679 on Windows Vista) indicate that it actually continues to use content-box.
	// IIRC, earlier versions of Opera did in fact use border-box.
	// Opera guys, this is really confusing. Opera being broken in quirks mode is not our fault.

	if(has("ie") /*|| has("opera")*/){
		// client code may have to adjust if compatMode varies across iframes
		geom.boxModel = document.compatMode == "BackCompat" ? "border-box" : "content-box";
	}

	geom.getPadExtents = function getPadExtents(/*DomNode*/ node, /*Object*/ computedStyle){
		// summary:
		//		Returns object with special values specifically useful for node
		//		fitting.
		// description:
		//		Returns an object with `w`, `h`, `l`, `t` properties:
		//	|		l/t/r/b = left/top/right/bottom padding (respectively)
		//	|		w = the total of the left and right padding
		//	|		h = the total of the top and bottom padding
		//		If 'node' has position, l/t forms the origin for child nodes.
		//		The w/h are used for calculating boxes.
		//		Normally application code will not need to invoke this
		//		directly, and will use the ...box... functions instead.
		// node: DOMNode
		// computedStyle: Object?
		//		This parameter accepts computed styles object.
		//		If this parameter is omitted, the functions will call
		//		dojo/dom-style.getComputedStyle to get one. It is a better way, calling
		//		dojo/dom-style.getComputedStyle once, and then pass the reference to this
		//		computedStyle parameter. Wherever possible, reuse the returned
		//		object of dojo/dom-style.getComputedStyle().

		node = dom.byId(node);
		var s = computedStyle || style.getComputedStyle(node), px = style.toPixelValue,
			l = px(node, s.paddingLeft), t = px(node, s.paddingTop), r = px(node, s.paddingRight), b = px(node, s.paddingBottom);
		return {l: l, t: t, r: r, b: b, w: l + r, h: t + b};
	};

	var none = "none";

	geom.getBorderExtents = function getBorderExtents(/*DomNode*/ node, /*Object*/ computedStyle){
		// summary:
		//		returns an object with properties useful for noting the border
		//		dimensions.
		// description:
		//		- l/t/r/b = the sum of left/top/right/bottom border (respectively)
		//		- w = the sum of the left and right border
		//		- h = the sum of the top and bottom border
		//
		//		The w/h are used for calculating boxes.
		//		Normally application code will not need to invoke this
		//		directly, and will use the ...box... functions instead.
		// node: DOMNode
		// computedStyle: Object?
		//		This parameter accepts computed styles object.
		//		If this parameter is omitted, the functions will call
		//		dojo/dom-style.getComputedStyle to get one. It is a better way, calling
		//		dojo/dom-style.getComputedStyle once, and then pass the reference to this
		//		computedStyle parameter. Wherever possible, reuse the returned
		//		object of dojo/dom-style.getComputedStyle().

		node = dom.byId(node);
		var px = style.toPixelValue, s = computedStyle || style.getComputedStyle(node),
			l = s.borderLeftStyle != none ? px(node, s.borderLeftWidth) : 0,
			t = s.borderTopStyle != none ? px(node, s.borderTopWidth) : 0,
			r = s.borderRightStyle != none ? px(node, s.borderRightWidth) : 0,
			b = s.borderBottomStyle != none ? px(node, s.borderBottomWidth) : 0;
		return {l: l, t: t, r: r, b: b, w: l + r, h: t + b};
	};

	geom.getPadBorderExtents = function getPadBorderExtents(/*DomNode*/ node, /*Object*/ computedStyle){
		// summary:
		//		Returns object with properties useful for box fitting with
		//		regards to padding.
		// description:
		//		- l/t/r/b = the sum of left/top/right/bottom padding and left/top/right/bottom border (respectively)
		//		- w = the sum of the left and right padding and border
		//		- h = the sum of the top and bottom padding and border
		//
		//		The w/h are used for calculating boxes.
		//		Normally application code will not need to invoke this
		//		directly, and will use the ...box... functions instead.
		// node: DOMNode
		// computedStyle: Object?
		//		This parameter accepts computed styles object.
		//		If this parameter is omitted, the functions will call
		//		dojo/dom-style.getComputedStyle to get one. It is a better way, calling
		//		dojo/dom-style.getComputedStyle once, and then pass the reference to this
		//		computedStyle parameter. Wherever possible, reuse the returned
		//		object of dojo/dom-style.getComputedStyle().

		node = dom.byId(node);
		var s = computedStyle || style.getComputedStyle(node),
			p = geom.getPadExtents(node, s),
			b = geom.getBorderExtents(node, s);
		return {
			l: p.l + b.l,
			t: p.t + b.t,
			r: p.r + b.r,
			b: p.b + b.b,
			w: p.w + b.w,
			h: p.h + b.h
		};
	};

	geom.getMarginExtents = function getMarginExtents(node, computedStyle){
		// summary:
		//		returns object with properties useful for box fitting with
		//		regards to box margins (i.e., the outer-box).
		//
		//		- l/t = marginLeft, marginTop, respectively
		//		- w = total width, margin inclusive
		//		- h = total height, margin inclusive
		//
		//		The w/h are used for calculating boxes.
		//		Normally application code will not need to invoke this
		//		directly, and will use the ...box... functions instead.
		// node: DOMNode
		// computedStyle: Object?
		//		This parameter accepts computed styles object.
		//		If this parameter is omitted, the functions will call
		//		dojo/dom-style.getComputedStyle to get one. It is a better way, calling
		//		dojo/dom-style.getComputedStyle once, and then pass the reference to this
		//		computedStyle parameter. Wherever possible, reuse the returned
		//		object of dojo/dom-style.getComputedStyle().

		node = dom.byId(node);
		var s = computedStyle || style.getComputedStyle(node), px = style.toPixelValue,
			l = px(node, s.marginLeft), t = px(node, s.marginTop), r = px(node, s.marginRight), b = px(node, s.marginBottom);
		return {l: l, t: t, r: r, b: b, w: l + r, h: t + b};
	};

	// Box getters work in any box context because offsetWidth/clientWidth
	// are invariant wrt box context
	//
	// They do *not* work for display: inline objects that have padding styles
	// because the user agent ignores padding (it's bogus styling in any case)
	//
	// Be careful with IMGs because they are inline or block depending on
	// browser and browser mode.

	// Although it would be easier to read, there are not separate versions of
	// _getMarginBox for each browser because:
	// 1. the branching is not expensive
	// 2. factoring the shared code wastes cycles (function call overhead)
	// 3. duplicating the shared code wastes bytes

	geom.getMarginBox = function getMarginBox(/*DomNode*/ node, /*Object*/ computedStyle){
		// summary:
		//		returns an object that encodes the width, height, left and top
		//		positions of the node's margin box.
		// node: DOMNode
		// computedStyle: Object?
		//		This parameter accepts computed styles object.
		//		If this parameter is omitted, the functions will call
		//		dojo/dom-style.getComputedStyle to get one. It is a better way, calling
		//		dojo/dom-style.getComputedStyle once, and then pass the reference to this
		//		computedStyle parameter. Wherever possible, reuse the returned
		//		object of dojo/dom-style.getComputedStyle().

		node = dom.byId(node);
		var s = computedStyle || style.getComputedStyle(node), me = geom.getMarginExtents(node, s),
			l = node.offsetLeft - me.l, t = node.offsetTop - me.t, p = node.parentNode, px = style.toPixelValue, pcs;

		if((has("ie") == 8 && !has("quirks"))){
			// IE 8 offsetLeft/Top includes the parent's border
			if(p){
				pcs = style.getComputedStyle(p);
				l -= pcs.borderLeftStyle != none ? px(node, pcs.borderLeftWidth) : 0;
				t -= pcs.borderTopStyle != none ? px(node, pcs.borderTopWidth) : 0;
			}
		}
		return {l: l, t: t, w: node.offsetWidth + me.w, h: node.offsetHeight + me.h};
	};

	geom.getContentBox = function getContentBox(node, computedStyle){
		// summary:
		//		Returns an object that encodes the width, height, left and top
		//		positions of the node's content box, irrespective of the
		//		current box model.
		// node: DOMNode
		// computedStyle: Object?
		//		This parameter accepts computed styles object.
		//		If this parameter is omitted, the functions will call
		//		dojo/dom-style.getComputedStyle to get one. It is a better way, calling
		//		dojo/dom-style.getComputedStyle once, and then pass the reference to this
		//		computedStyle parameter. Wherever possible, reuse the returned
		//		object of dojo/dom-style.getComputedStyle().

		// clientWidth/Height are important since the automatically account for scrollbars
		// fallback to offsetWidth/Height for special cases (see #3378)
		node = dom.byId(node);
		var s = computedStyle || style.getComputedStyle(node), w = node.clientWidth, h,
			pe = geom.getPadExtents(node, s), be = geom.getBorderExtents(node, s), l = node.offsetLeft + pe.l + be.l,
			t = node.offsetTop + pe.t + be.t;
		if(!w){
			w = node.offsetWidth - be.w;
			h = node.offsetHeight - be.h;
		}else{
			h = node.clientHeight;
		}

		if((has("ie") == 8 && !has("quirks"))){
			// IE 8 offsetLeft/Top includes the parent's border
			var p = node.parentNode, px = style.toPixelValue, pcs;
			if(p){
				pcs = style.getComputedStyle(p);
				l -= pcs.borderLeftStyle != none ? px(node, pcs.borderLeftWidth) : 0;
				t -= pcs.borderTopStyle != none ? px(node, pcs.borderTopWidth) : 0;
			}
		}

		return {l: l, t: t, w: w - pe.w, h: h - pe.h};
	};

	// Box setters depend on box context because interpretation of width/height styles
	// vary wrt box context.
	//
	// The value of boxModel is used to determine box context.
	// boxModel can be set directly to change behavior.
	//
	// Beware of display: inline objects that have padding styles
	// because the user agent ignores padding (it's a bogus setup anyway)
	//
	// Be careful with IMGs because they are inline or block depending on
	// browser and browser mode.
	//
	// Elements other than DIV may have special quirks, like built-in
	// margins or padding, or values not detectable via computedStyle.
	// In particular, margins on TABLE do not seems to appear
	// at all in computedStyle on Mozilla.

	function setBox(/*DomNode*/ node, /*Number?*/ l, /*Number?*/ t, /*Number?*/ w, /*Number?*/ h, /*String?*/ u){
		// summary:
		//		sets width/height/left/top in the current (native) box-model
		//		dimensions. Uses the unit passed in u.
		// node:
		//		DOM Node reference. Id string not supported for performance
		//		reasons.
		// l:
		//		left offset from parent.
		// t:
		//		top offset from parent.
		// w:
		//		width in current box model.
		// h:
		//		width in current box model.
		// u:
		//		unit measure to use for other measures. Defaults to "px".
		u = u || "px";
		var s = node.style;
		if(!isNaN(l)){
			s.left = l + u;
		}
		if(!isNaN(t)){
			s.top = t + u;
		}
		if(w >= 0){
			s.width = w + u;
		}
		if(h >= 0){
			s.height = h + u;
		}
	}

	function isButtonTag(/*DomNode*/ node){
		// summary:
		//		True if the node is BUTTON or INPUT.type="button".
		return node.tagName.toLowerCase() == "button" ||
			node.tagName.toLowerCase() == "input" && (node.getAttribute("type") || "").toLowerCase() == "button"; // boolean
	}

	function usesBorderBox(/*DomNode*/ node){
		// summary:
		//		True if the node uses border-box layout.

		// We could test the computed style of node to see if a particular box
		// has been specified, but there are details and we choose not to bother.

		// TABLE and BUTTON (and INPUT type=button) are always border-box by default.
		// If you have assigned a different box to either one via CSS then
		// box functions will break.

		return geom.boxModel == "border-box" || node.tagName.toLowerCase() == "table" || isButtonTag(node); // boolean
	}

	function getBoundingClientRect(/*DomNode*/ node) {
		// summary:
		//		Gets the bounding client rectangle for a dom node.
		// node: DOMNode

		// This will return the result of node.getBoundingClientRect if node is in the dom, and
		// {x:0, y:0, width:0, height:0, top:0, right:0, bottom:0, left:0} if it throws an error or the node is not on the dom
		// This will handle when IE throws an error or Edge returns an empty object when node is not on the dom

		var retEmpty = { x: 0, y: 0, width: 0, height: 0, top: 0, right: 0, bottom: 0, left: 0 },
			ret;

		try {
			ret = node.getBoundingClientRect();
		} catch (e) {
			// IE throws an Unspecified Error if the node is not in the dom. Handle this by returning an object with 0 values
			return retEmpty;
		}

		// Edge returns an empty object if the node is not in the dom. Handle this by returning an object with 0 values
		if (typeof ret.left === "undefined") { return retEmpty; }

		return ret;
	}

	geom.setContentSize = function setContentSize(/*DomNode*/ node, /*Object*/ box, /*Object*/ computedStyle){
		// summary:
		//		Sets the size of the node's contents, irrespective of margins,
		//		padding, or borders.
		// node: DOMNode
		// box: Object
		//		hash with optional "w", and "h" properties for "width", and "height"
		//		respectively. All specified properties should have numeric values in whole pixels.
		// computedStyle: Object?
		//		This parameter accepts computed styles object.
		//		If this parameter is omitted, the functions will call
		//		dojo/dom-style.getComputedStyle to get one. It is a better way, calling
		//		dojo/dom-style.getComputedStyle once, and then pass the reference to this
		//		computedStyle parameter. Wherever possible, reuse the returned
		//		object of dojo/dom-style.getComputedStyle().

		node = dom.byId(node);
		var w = box.w, h = box.h;
		if(usesBorderBox(node)){
			var pb = geom.getPadBorderExtents(node, computedStyle);
			if(w >= 0){
				w += pb.w;
			}
			if(h >= 0){
				h += pb.h;
			}
		}
		setBox(node, NaN, NaN, w, h);
	};

	var nilExtents = {l: 0, t: 0, w: 0, h: 0};

	geom.setMarginBox = function setMarginBox(/*DomNode*/ node, /*Object*/ box, /*Object*/ computedStyle){
		// summary:
		//		sets the size of the node's margin box and placement
		//		(left/top), irrespective of box model. Think of it as a
		//		passthrough to setBox that handles box-model vagaries for
		//		you.
		// node: DOMNode
		// box: Object
		//		hash with optional "l", "t", "w", and "h" properties for "left", "right", "width", and "height"
		//		respectively. All specified properties should have numeric values in whole pixels.
		// computedStyle: Object?
		//		This parameter accepts computed styles object.
		//		If this parameter is omitted, the functions will call
		//		dojo/dom-style.getComputedStyle to get one. It is a better way, calling
		//		dojo/dom-style.getComputedStyle once, and then pass the reference to this
		//		computedStyle parameter. Wherever possible, reuse the returned
		//		object of dojo/dom-style.getComputedStyle().

		node = dom.byId(node);
		var s = computedStyle || style.getComputedStyle(node), w = box.w, h = box.h,
		// Some elements have special padding, margin, and box-model settings.
		// To use box functions you may need to set padding, margin explicitly.
		// Controlling box-model is harder, in a pinch you might set dojo/dom-geometry.boxModel.
			pb = usesBorderBox(node) ? nilExtents : geom.getPadBorderExtents(node, s),
			mb = geom.getMarginExtents(node, s);
		if(has("webkit")){
			// on Safari (3.1.2), button nodes with no explicit size have a default margin
			// setting an explicit size eliminates the margin.
			// We have to swizzle the width to get correct margin reading.
			if(isButtonTag(node)){
				var ns = node.style;
				if(w >= 0 && !ns.width){
					ns.width = "4px";
				}
				if(h >= 0 && !ns.height){
					ns.height = "4px";
				}
			}
		}
		if(w >= 0){
			w = Math.max(w - pb.w - mb.w, 0);
		}
		if(h >= 0){
			h = Math.max(h - pb.h - mb.h, 0);
		}
		setBox(node, box.l, box.t, w, h);
	};

	// =============================
	// Positioning
	// =============================

	geom.isBodyLtr = function isBodyLtr(/*Document?*/ doc){
		// summary:
		//		Returns true if the current language is left-to-right, and false otherwise.
		// doc: Document?
		//		Optional document to query.   If unspecified, use win.doc.
		// returns: Boolean

		doc = doc || win.doc;
		return (win.body(doc).dir || doc.documentElement.dir || "ltr").toLowerCase() == "ltr"; // Boolean
	};

	geom.docScroll = function docScroll(/*Document?*/ doc){
		// summary:
		//		Returns an object with {node, x, y} with corresponding offsets.
		// doc: Document?
		//		Optional document to query.   If unspecified, use win.doc.
		// returns: Object

		doc = doc || win.doc;
		var node = doc.parentWindow || doc.defaultView;   // use UI window, not dojo.global window.   TODO: use dojo/window::get() except for circular dependency problem
		return "pageXOffset" in node ? {x: node.pageXOffset, y: node.pageYOffset } :
			(node = has("quirks") ? win.body(doc) : doc.documentElement) &&
				{x: geom.fixIeBiDiScrollLeft(node.scrollLeft || 0, doc), y: node.scrollTop || 0 };
	};

	geom.getIeDocumentElementOffset = function(/*Document?*/ doc){
		// summary:
		//		Deprecated method previously used for IE6-IE7.  Now, just returns `{x:0, y:0}`.
		return {
			x: 0,
			y: 0
		};
	};

	geom.fixIeBiDiScrollLeft = function fixIeBiDiScrollLeft(/*Integer*/ scrollLeft, /*Document?*/ doc){
		// summary:
		//		In RTL direction, scrollLeft should be a negative value, but IE
		//		returns a positive one. All codes using documentElement.scrollLeft
		//		must call this function to fix this error, otherwise the position
		//		will offset to right when there is a horizontal scrollbar.
		// scrollLeft: Number
		// doc: Document?
		//		Optional document to query.   If unspecified, use win.doc.
		// returns: Number

		// In RTL direction, scrollLeft should be a negative value, but IE
		// returns a positive one. All codes using documentElement.scrollLeft
		// must call this function to fix this error, otherwise the position
		// will offset to right when there is a horizontal scrollbar.

		doc = doc || win.doc;
		var ie = has("ie");
		if(ie && !geom.isBodyLtr(doc)){
			var qk = has("quirks"),
				de = qk ? win.body(doc) : doc.documentElement,
				pwin = win.global;	// TODO: use winUtils.get(doc) after resolving circular dependency b/w dom-geometry.js and dojo/window.js
			if(ie == 6 && !qk && pwin.frameElement && de.scrollHeight > de.clientHeight){
				scrollLeft += de.clientLeft; // workaround ie6+strict+rtl+iframe+vertical-scrollbar bug where clientWidth is too small by clientLeft pixels
			}
			return (ie < 8 || qk) ? (scrollLeft + de.clientWidth - de.scrollWidth) : -scrollLeft; // Integer
		}
		return scrollLeft; // Integer
	};

	geom.position = function(/*DomNode*/ node, /*Boolean?*/ includeScroll){
		// summary:
		//		Gets the position and size of the passed element relative to
		//		the viewport (if includeScroll==false), or relative to the
		//		document root (if includeScroll==true).
		//
		// description:
		//		Returns an object of the form:
		//		`{ x: 100, y: 300, w: 20, h: 15 }`.
		//		If includeScroll==true, the x and y values will include any
		//		document offsets that may affect the position relative to the
		//		viewport.
		//		Uses the border-box model (inclusive of border and padding but
		//		not margin).  Does not act as a setter.
		// node: DOMNode|String
		// includeScroll: Boolean?
		// returns: Object

		node = dom.byId(node);
		var	db = win.body(node.ownerDocument),
			ret= getBoundingClientRect(node);
		ret = {x: ret.left, y: ret.top, w: ret.right - ret.left, h: ret.bottom - ret.top};

		if(has("ie") < 9){
			// fixes the position in IE, quirks mode
			ret.x -= (has("quirks") ? db.clientLeft + db.offsetLeft : 0);
			ret.y -= (has("quirks") ? db.clientTop + db.offsetTop : 0);
		}

		// account for document scrolling
		// if offsetParent is used, ret value already includes scroll position
		// so we may have to actually remove that value if !includeScroll
		if(includeScroll){
			var scroll = geom.docScroll(node.ownerDocument);
			ret.x += scroll.x;
			ret.y += scroll.y;
		}

		return ret; // Object
	};

	// random "private" functions wildly used throughout the toolkit

	geom.getMarginSize = function getMarginSize(/*DomNode*/ node, /*Object*/ computedStyle){
		// summary:
		//		returns an object that encodes the width and height of
		//		the node's margin box
		// node: DOMNode|String
		// computedStyle: Object?
		//		This parameter accepts computed styles object.
		//		If this parameter is omitted, the functions will call
		//		dojo/dom-style.getComputedStyle to get one. It is a better way, calling
		//		dojo/dom-style.getComputedStyle once, and then pass the reference to this
		//		computedStyle parameter. Wherever possible, reuse the returned
		//		object of dojo/dom-style.getComputedStyle().

		node = dom.byId(node);
		var me = geom.getMarginExtents(node, computedStyle || style.getComputedStyle(node));
		var size = getBoundingClientRect(node);
		return {
			w: (size.right - size.left) + me.w,
			h: (size.bottom - size.top) + me.h
		};
	};

	geom.normalizeEvent = function(event){
		// summary:
		//		Normalizes the geometry of a DOM event, normalizing the pageX, pageY,
		//		offsetX, offsetY, layerX, and layerX properties
		// event: Object
		if(!("layerX" in event)){
			event.layerX = event.offsetX;
			event.layerY = event.offsetY;
		}

		if(!("pageX" in event)){
			// FIXME: scroll position query is duped from dojo/_base/html to
			// avoid dependency on that entire module. Now that HTML is in
			// Base, we should convert back to something similar there.
			var se = event.target;
			var doc = (se && se.ownerDocument) || document;
			// DO NOT replace the following to use dojo/_base/window.body(), in IE, document.documentElement should be used
			// here rather than document.body
			var docBody = has("quirks") ? doc.body : doc.documentElement;
			event.pageX = event.clientX + geom.fixIeBiDiScrollLeft(docBody.scrollLeft || 0, doc);
			event.pageY = event.clientY + (docBody.scrollTop || 0);
		}
	};

	// TODO: evaluate separate getters/setters for position and sizes?

	return geom;
});

},
'dojo/mouse':function(){
define(["./_base/kernel", "./on", "./has", "./dom", "./_base/window"], function(dojo, on, has, dom, win){

	// module:
	//		dojo/mouse

    has.add("dom-quirks", win.doc && win.doc.compatMode == "BackCompat");
	has.add("events-mouseenter", win.doc && "onmouseenter" in win.doc.createElement("div"));
	has.add("events-mousewheel", win.doc && 'onmousewheel' in win.doc);

	var mouseButtons;
	if((has("dom-quirks") && has("ie")) || !has("dom-addeventlistener")){
		mouseButtons = {
			LEFT:   1,
			MIDDLE: 4,
			RIGHT:  2,
			// helper functions
			isButton: function(e, button){ return e.button & button; },
			isLeft:   function(e){ return e.button & 1; },
			isMiddle: function(e){ return e.button & 4; },
			isRight:  function(e){ return e.button & 2; }
		};
	}else{
		mouseButtons = {
			LEFT:   0,
			MIDDLE: 1,
			RIGHT:  2,
			// helper functions
			isButton: function(e, button){ return e.button == button; },
			isLeft:   function(e){ return e.button == 0; },
			isMiddle: function(e){ return e.button == 1; },
			isRight:  function(e){ return e.button == 2; }
		};
	}
	dojo.mouseButtons = mouseButtons;

/*=====
	dojo.mouseButtons = {
		// LEFT: Number
		//		Numeric value of the left mouse button for the platform.
		LEFT:   0,
		// MIDDLE: Number
		//		Numeric value of the middle mouse button for the platform.
		MIDDLE: 1,
		// RIGHT: Number
		//		Numeric value of the right mouse button for the platform.
		RIGHT:  2,

		isButton: function(e, button){
			// summary:
			//		Checks an event object for a pressed button
			// e: Event
			//		Event object to examine
			// button: Number
			//		The button value (example: dojo.mouseButton.LEFT)
			return e.button == button; // Boolean
		},
		isLeft: function(e){
			// summary:
			//		Checks an event object for the pressed left button
			// e: Event
			//		Event object to examine
			return e.button == 0; // Boolean
		},
		isMiddle: function(e){
			// summary:
			//		Checks an event object for the pressed middle button
			// e: Event
			//		Event object to examine
			return e.button == 1; // Boolean
		},
		isRight: function(e){
			// summary:
			//		Checks an event object for the pressed right button
			// e: Event
			//		Event object to examine
			return e.button == 2; // Boolean
		}
	};
=====*/

	function eventHandler(type, selectHandler){
		// emulation of mouseenter/leave with mouseover/out using descendant checking
		var handler = function(node, listener){
			return on(node, type, function(evt){
				if(selectHandler){
					return selectHandler(evt, listener);
				}
				if(!dom.isDescendant(evt.relatedTarget, node)){
					return listener.call(this, evt);
				}
			});
		};
		handler.bubble = function(select){
			return eventHandler(type, function(evt, listener){
				// using a selector, use the select function to determine if the mouse moved inside the selector and was previously outside the selector
				var target = select(evt.target);
				var relatedTarget = evt.relatedTarget;
				if(target && (target != (relatedTarget && relatedTarget.nodeType == 1 && select(relatedTarget)))){
					return listener.call(target, evt);
				} 
			});
		};
		return handler;
	}
	var wheel;
	if(has("events-mousewheel")){
		wheel = 'mousewheel';
	}else{ //firefox
		wheel = function(node, listener){
			return on(node, 'DOMMouseScroll', function(evt){
				evt.wheelDelta = -evt.detail;
				listener.call(this, evt);
			});
		};
	}
	return {
		// summary:
		//		This module provide mouse event handling utility functions and exports
		//		mouseenter and mouseleave event emulation.
		// example:
		//		To use these events, you register a mouseenter like this:
		//		|	define(["dojo/on", "dojo/mouse"], function(on, mouse){
		//		|		on(targetNode, mouse.enter, function(event){
		//		|			dojo.addClass(targetNode, "highlighted");
		//		|		});
		//		|		on(targetNode, mouse.leave, function(event){
		//		|			dojo.removeClass(targetNode, "highlighted");
		//		|		});

		_eventHandler: eventHandler,		// for dojo/touch

		// enter: Synthetic Event
		//		This is an extension event for the mouseenter that IE provides, emulating the
		//		behavior on other browsers.
		enter: eventHandler("mouseover"),

		// leave: Synthetic Event
		//		This is an extension event for the mouseleave that IE provides, emulating the
		//		behavior on other browsers.
		leave: eventHandler("mouseout"),

		// wheel: Normalized Mouse Wheel Event
		//		This is an extension event for the mousewheel that non-Mozilla browsers provide,
		//		emulating the behavior on Mozilla based browsers.
		wheel: wheel,

		isLeft: mouseButtons.isLeft,
		/*=====
		isLeft: function(){
			// summary:
			//		Test an event object (from a mousedown event) to see if the left button was pressed.
		},
		=====*/

		isMiddle: mouseButtons.isMiddle,
		/*=====
		 isMiddle: function(){
			 // summary:
			 //		Test an event object (from a mousedown event) to see if the middle button was pressed.
		 },
		 =====*/

		isRight: mouseButtons.isRight
		/*=====
		 , isRight: function(){
			 // summary:
			 //		Test an event object (from a mousedown event) to see if the right button was pressed.
		 }
		 =====*/
	};
});

},
'dojo/keys':function(){
define(["./_base/kernel", "./sniff"], function(dojo, has){

	// module:
	//		dojo/keys

	return dojo.keys = {
		// summary:
		//		Definitions for common key values.  Client code should test keyCode against these named constants,
		//		as the actual codes can vary by browser.

		BACKSPACE: 8,
		TAB: 9,
		CLEAR: 12,
		ENTER: 13,
		SHIFT: 16,
		CTRL: 17,
		ALT: 18,
		META: has("webkit") ? 91 : 224,		// the apple key on macs
		PAUSE: 19,
		CAPS_LOCK: 20,
		ESCAPE: 27,
		SPACE: 32,
		PAGE_UP: 33,
		PAGE_DOWN: 34,
		END: 35,
		HOME: 36,
		LEFT_ARROW: 37,
		UP_ARROW: 38,
		RIGHT_ARROW: 39,
		DOWN_ARROW: 40,
		INSERT: 45,
		DELETE: 46,
		HELP: 47,
		LEFT_WINDOW: 91,
		RIGHT_WINDOW: 92,
		SELECT: 93,
		NUMPAD_0: 96,
		NUMPAD_1: 97,
		NUMPAD_2: 98,
		NUMPAD_3: 99,
		NUMPAD_4: 100,
		NUMPAD_5: 101,
		NUMPAD_6: 102,
		NUMPAD_7: 103,
		NUMPAD_8: 104,
		NUMPAD_9: 105,
		NUMPAD_MULTIPLY: 106,
		NUMPAD_PLUS: 107,
		NUMPAD_ENTER: 108,
		NUMPAD_MINUS: 109,
		NUMPAD_PERIOD: 110,
		NUMPAD_DIVIDE: 111,
		F1: 112,
		F2: 113,
		F3: 114,
		F4: 115,
		F5: 116,
		F6: 117,
		F7: 118,
		F8: 119,
		F9: 120,
		F10: 121,
		F11: 122,
		F12: 123,
		F13: 124,
		F14: 125,
		F15: 126,
		NUM_LOCK: 144,
		SCROLL_LOCK: 145,
		UP_DPAD: 175,
		DOWN_DPAD: 176,
		LEFT_DPAD: 177,
		RIGHT_DPAD: 178,
		// virtual key mapping
		copyKey: has("mac") && !has("air") ? (has("safari") ? 91 : 224 ) : 17
	};
});

},
'dojo/html':function(){
define(["./_base/kernel", "./_base/lang", "./_base/array", "./_base/declare", "./dom", "./dom-construct", "./parser"],
	function(kernel, lang, darray, declare, dom, domConstruct, parser){
	// module:
	//		dojo/html

	// the parser might be needed..

	// idCounter is incremented with each instantiation to allow assignment of a unique id for tracking, logging purposes
	var idCounter = 0;

	var html = {
		// summary:
		//		TODOC

		_secureForInnerHtml: function(/*String*/ cont){
			// summary:
			//		removes !DOCTYPE and title elements from the html string.
			//
			//		khtml is picky about dom faults, you can't attach a style or `<title>` node as child of body
			//		must go into head, so we need to cut out those tags
			// cont:
			//		An html string for insertion into the dom
			//
			return cont.replace(/(?:\s*<!DOCTYPE\s[^>]+>|<title[^>]*>[\s\S]*?<\/title>)/ig, ""); // String
		},

		// Deprecated, should use dojo/dom-constuct.empty() directly, remove in 2.0.
		_emptyNode: domConstruct.empty,

		_setNodeContent: function(/*DomNode*/ node, /*String|DomNode|NodeList*/ cont){
			// summary:
			//		inserts the given content into the given node
			// node:
			//		the parent element
			// content:
			//		the content to be set on the parent element.
			//		This can be an html string, a node reference or a NodeList, dojo/NodeList, Array or other enumerable list of nodes

			// always empty
			domConstruct.empty(node);

			if(cont){
				if(typeof cont == "number"){
					cont = cont.toString();
				}
				if(typeof cont == "string"){
					cont = domConstruct.toDom(cont, node.ownerDocument);
				}
				if(!cont.nodeType && lang.isArrayLike(cont)){
					// handle as enumerable, but it may shrink as we enumerate it
					for(var startlen=cont.length, i=0; i<cont.length; i=startlen==cont.length ? i+1 : 0){
						domConstruct.place( cont[i], node, "last");
					}
				}else{
					// pass nodes, documentFragments and unknowns through to dojo.place
					domConstruct.place(cont, node, "last");
				}
			}

			// return DomNode
			return node;
		},

		// we wrap up the content-setting operation in a object
		_ContentSetter: declare("dojo.html._ContentSetter", null, {
			// node: DomNode|String
			//		An node which will be the parent element that we set content into
			node: "",

			// content: String|DomNode|DomNode[]
			//		The content to be placed in the node. Can be an HTML string, a node reference, or a enumerable list of nodes
			content: "",

			// id: String?
			//		Usually only used internally, and auto-generated with each instance
			id: "",

			// cleanContent: Boolean
			//		Should the content be treated as a full html document,
			//		and the real content stripped of <html>, <body> wrapper before injection
			cleanContent: false,

			// extractContent: Boolean
			//		Should the content be treated as a full html document,
			//		and the real content stripped of `<html> <body>` wrapper before injection
			extractContent: false,

			// parseContent: Boolean
			//		Should the node by passed to the parser after the new content is set
			parseContent: false,

			// parserScope: String
			//		Flag passed to parser.	Root for attribute names to search for.	  If scopeName is dojo,
			//		will search for data-dojo-type (or dojoType).  For backwards compatibility
			//		reasons defaults to dojo._scopeName (which is "dojo" except when
			//		multi-version support is used, when it will be something like dojo16, dojo20, etc.)
			parserScope: kernel._scopeName,

			// startup: Boolean
			//		Start the child widgets after parsing them.	  Only obeyed if parseContent is true.
			startup: true,

			// lifecycle methods
			constructor: function(/*Object*/ params, /*String|DomNode*/ node){
				// summary:
				//		Provides a configurable, extensible object to wrap the setting on content on a node
				//		call the set() method to actually set the content..

				// the original params are mixed directly into the instance "this"
				lang.mixin(this, params || {});

				// give precedence to params.node vs. the node argument
				// and ensure its a node, not an id string
				node = this.node = dom.byId( this.node || node );

				if(!this.id){
					this.id = [
						"Setter",
						(node) ? node.id || node.tagName : "",
						idCounter++
					].join("_");
				}
			},
			set: function(/* String|DomNode|NodeList? */ cont, /*Object?*/ params){
				// summary:
				//		front-end to the set-content sequence
				// cont:
				//		An html string, node or enumerable list of nodes for insertion into the dom
				//		If not provided, the object's content property will be used
				if(undefined !== cont){
					this.content = cont;
				}
				if(typeof cont == 'number'){
					cont = cont.toString();
				}
				// in the re-use scenario, set needs to be able to mixin new configuration
				if(params){
					this._mixin(params);
				}

				this.onBegin();
				this.setContent();

				var ret = this.onEnd();

				if(ret && ret.then){
					// Make dojox/html/_ContentSetter.set() return a Promise that resolves when load and parse complete.
					return ret;
				}else{
					// Vanilla dojo/html._ContentSetter.set() returns a DOMNode for back compat.   For 2.0, switch it to
					// return a Deferred like above.
					return this.node;
				}
			},

			setContent: function(){
				// summary:
				//		sets the content on the node

				var node = this.node;
				if(!node){
					// can't proceed
					throw new Error(this.declaredClass + ": setContent given no node");
				}
				try{
					node = html._setNodeContent(node, this.content);
				}catch(e){
					// check if a domfault occurs when we are appending this.errorMessage
					// like for instance if domNode is a UL and we try append a DIV

					// FIXME: need to allow the user to provide a content error message string
					var errMess = this.onContentError(e);
					try{
						node.innerHTML = errMess;
					}catch(e){
						console.error('Fatal ' + this.declaredClass + '.setContent could not change content due to '+e.message, e);
					}
				}
				// always put back the node for the next method
				this.node = node; // DomNode
			},

			empty: function(){
				// summary:
				//		cleanly empty out existing content

				// If there is a parse in progress, cancel it.
				if(this.parseDeferred){
					if(!this.parseDeferred.isResolved()){
						this.parseDeferred.cancel();
					}
					delete this.parseDeferred;
				}

				// destroy any widgets from a previous run
				// NOTE: if you don't want this you'll need to empty
				// the parseResults array property yourself to avoid bad things happening
				if(this.parseResults && this.parseResults.length){
					darray.forEach(this.parseResults, function(w){
						if(w.destroy){
							w.destroy();
						}
					});
					delete this.parseResults;
				}
				// this is fast, but if you know its already empty or safe, you could
				// override empty to skip this step
				domConstruct.empty(this.node);
			},

			onBegin: function(){
				// summary:
				//		Called after instantiation, but before set();
				//		It allows modification of any of the object properties -
				//		including the node and content provided - before the set operation actually takes place
				//		This default implementation checks for cleanContent and extractContent flags to
				//		optionally pre-process html string content
				var cont = this.content;

				if(lang.isString(cont)){
					if(this.cleanContent){
						cont = html._secureForInnerHtml(cont);
					}

					if(this.extractContent){
						var match = cont.match(/<body[^>]*>\s*([\s\S]+)\s*<\/body>/im);
						if(match){ cont = match[1]; }
					}
				}

				// clean out the node and any cruft associated with it - like widgets
				this.empty();

				this.content = cont;
				return this.node; // DomNode
			},

			onEnd: function(){
				// summary:
				//		Called after set(), when the new content has been pushed into the node
				//		It provides an opportunity for post-processing before handing back the node to the caller
				//		This default implementation checks a parseContent flag to optionally run the dojo parser over the new content
				if(this.parseContent){
					// populates this.parseResults and this.parseDeferred if you need those..
					this._parse();
				}
				return this.node; // DomNode
				// TODO: for 2.0 return a Promise indicating that the parse completed.
			},

			tearDown: function(){
				// summary:
				//		manually reset the Setter instance if its being re-used for example for another set()
				// description:
				//		tearDown() is not called automatically.
				//		In normal use, the Setter instance properties are simply allowed to fall out of scope
				//		but the tearDown method can be called to explicitly reset this instance.
				delete this.parseResults;
				delete this.parseDeferred;
				delete this.node;
				delete this.content;
			},

			onContentError: function(err){
				return "Error occurred setting content: " + err;
			},

			onExecError: function(err){
				return "Error occurred executing scripts: " + err;
			},

			_mixin: function(params){
				// mix properties/methods into the instance
				// TODO: the intention with tearDown is to put the Setter's state
				// back to that of the original constructor (vs. deleting/resetting everything regardless of ctor params)
				// so we could do something here to move the original properties aside for later restoration
				var empty = {}, key;
				for(key in params){
					if(key in empty){ continue; }
					// TODO: here's our opportunity to mask the properties we don't consider configurable/overridable
					// .. but history shows we'll almost always guess wrong
					this[key] = params[key];
				}
			},
			_parse: function(){
				// summary:
				//		runs the dojo parser over the node contents, storing any results in this.parseResults
				//		and the parse promise in this.parseDeferred
				//		Any errors resulting from parsing are passed to _onError for handling

				var rootNode = this.node;
				try{
					// store the results (widgets, whatever) for potential retrieval
					var inherited = {};
					darray.forEach(["dir", "lang", "textDir"], function(name){
						if(this[name]){
							inherited[name] = this[name];
						}
					}, this);
					var self = this;
					this.parseDeferred = parser.parse({
						rootNode: rootNode,
						noStart: !this.startup,
						inherited: inherited,
						scope: this.parserScope
					}).then(function(results){
							return self.parseResults = results;
						}, function(e){
							self._onError('Content', e, "Error parsing in _ContentSetter#" + self.id);
						});
				}catch(e){
					this._onError('Content', e, "Error parsing in _ContentSetter#" + this.id);
				}
			},

			_onError: function(type, err, consoleText){
				// summary:
				//		shows user the string that is returned by on[type]Error
				//		override/implement on[type]Error and return your own string to customize
				var errText = this['on' + type + 'Error'].call(this, err);
				if(consoleText){
					console.error(consoleText, err);
				}else if(errText){ // a empty string won't change current content
					html._setNodeContent(this.node, errText, true);
				}
			}
		}), // end declare()

		set: function(/*DomNode*/ node, /*String|DomNode|NodeList*/ cont, /*Object?*/ params){
			// summary:
			//		inserts (replaces) the given content into the given node. dojo/dom-construct.place(cont, node, "only")
			//		may be a better choice for simple HTML insertion.
			// description:
			//		Unless you need to use the params capabilities of this method, you should use
			//		dojo/dom-construct.place(cont, node, "only"). dojo/dom-construct..place() has more robust support for injecting
			//		an HTML string into the DOM, but it only handles inserting an HTML string as DOM
			//		elements, or inserting a DOM node. dojo/dom-construct..place does not handle NodeList insertions
			//		dojo/dom-construct.place(cont, node, "only"). dojo/dom-construct.place() has more robust support for injecting
			//		an HTML string into the DOM, but it only handles inserting an HTML string as DOM
			//		elements, or inserting a DOM node. dojo/dom-construct.place does not handle NodeList insertions
			//		or the other capabilities as defined by the params object for this method.
			// node:
			//		the parent element that will receive the content
			// cont:
			//		the content to be set on the parent element.
			//		This can be an html string, a node reference or a NodeList, dojo/NodeList, Array or other enumerable list of nodes
			// params:
			//		Optional flags/properties to configure the content-setting. See dojo/html/_ContentSetter
			// example:
			//		A safe string/node/nodelist content replacement/injection with hooks for extension
			//		Example Usage:
			//	|	html.set(node, "some string");
			//	|	html.set(node, contentNode, {options});
			//	|	html.set(node, myNode.childNodes, {options});
			if(undefined == cont){
				console.warn("dojo.html.set: no cont argument provided, using empty string");
				cont = "";
			}
			if (typeof cont == 'number'){
				cont = cont.toString();
			}
			if(!params){
				// simple and fast
				return html._setNodeContent(node, cont, true);
			}else{
				// more options but slower
				// note the arguments are reversed in order, to match the convention for instantiation via the parser
				var op = new html._ContentSetter(lang.mixin(
					params,
					{ content: cont, node: node }
				));
				return op.set();
			}
		}
	};
	lang.setObject("dojo.html", html);

	return html;
});

},
'dojo/parser':function(){
define([
	"require", "./_base/kernel", "./_base/lang", "./_base/array", "./_base/config", "./dom", "./_base/window",
	"./_base/url", "./aspect", "./promise/all", "./date/stamp", "./Deferred", "./has", "./json5", "./query", "./on",
	"./ready"
], function(require, dojo, dlang, darray, config, dom, dwindow, _Url, aspect, all, dates, Deferred, has, json5, query,
	don, ready){

	// module:
	//		dojo/parser

	new Date("X"); // workaround for #11279, new Date("") == NaN

	var myEval;
	if(has('csp-restrictions')) {
		// JSON5 data attributes can be parsed without using eval; JS expressions will throw an error
		myEval = json5.parse;
	}
	else {
		myEval = function(text){
			// data-dojo-props etc. is not restricted to JSON, it can be any javascript
			/* jshint -W061 */
			return eval("(" + text + ")");
		};
	}

	// Widgets like BorderContainer add properties to _Widget via dojo.extend().
	// If BorderContainer is loaded after _Widget's parameter list has been cached,
	// we need to refresh that parameter list (for _Widget and all widgets that extend _Widget).
	var extendCnt = 0;
	aspect.after(dlang, "extend", function(){
		extendCnt++;
	}, true);

	function getNameMap(ctor){
		// summary:
		//		Returns map from lowercase name to attribute name in class, ex: {onclick: "onClick"}
		var map = ctor._nameCaseMap, proto = ctor.prototype;

		// Create the map if it's undefined.
		// Refresh the map if a superclass was possibly extended with new methods since the map was created.
		if(!map || map._extendCnt < extendCnt){
			map = ctor._nameCaseMap = {};
			for(var name in proto){
				if(name.charAt(0) === "_"){
					continue;
				}	// skip internal properties
				map[name.toLowerCase()] = name;
			}
			map._extendCnt = extendCnt;
		}
		return map;
	}

	function getCtor(/*String[]*/ types, /*Function?*/ contextRequire){
		// summary:
		//		Retrieves a constructor.  If the types array contains more than one class/MID then the
		//		subsequent classes will be mixed into the first class and a unique constructor will be
		//		returned for that array.

		if(!contextRequire){
			contextRequire = require;
		}

		// Map from widget name or list of widget names(ex: "dijit/form/Button,acme/MyMixin") to a constructor.
		// Keep separate map for each requireContext to avoid false matches (ex: "./Foo" can mean different things
		// depending on context.)
		var ctorMap = contextRequire._dojoParserCtorMap || (contextRequire._dojoParserCtorMap = {});

		var ts = types.join();
		if(!ctorMap[ts]){
			var mixins = [];
			for(var i = 0, l = types.length; i < l; i++){
				var t = types[i];
				// TODO: Consider swapping getObject and require in the future
				mixins[mixins.length] = (ctorMap[t] = ctorMap[t] || (dlang.getObject(t) || (~t.indexOf('/') &&
					contextRequire(t))));
			}
			var ctor = mixins.shift();
			ctorMap[ts] = mixins.length ? (ctor.createSubclass ? ctor.createSubclass(mixins) : ctor.extend.apply(ctor, mixins)) : ctor;
		}

		return ctorMap[ts];
	}

	var parser = {
		// summary:
		//		The Dom/Widget parsing package

		_clearCache: function(){
			// summary:
			//		Clear cached data.   Used mainly for benchmarking.
			extendCnt++;
			_ctorMap = {};
		},

		_functionFromScript: function(script, attrData){
			// summary:
			//		Convert a `<script type="dojo/method" args="a, b, c"> ... </script>`
			//		into a function
			// script: DOMNode
			//		The `<script>` DOMNode
			// attrData: String
			//		For HTML5 compliance, searches for attrData + "args" (typically
			//		"data-dojo-args") instead of "args"
			var preamble = "",
				suffix = "",
				argsStr = (script.getAttribute(attrData + "args") || script.getAttribute("args")),
				withStr = script.getAttribute("with");

			// Convert any arguments supplied in script tag into an array to be passed to the
			var fnArgs = (argsStr || "").split(/\s*,\s*/);

			if(withStr && withStr.length){
				darray.forEach(withStr.split(/\s*,\s*/), function(part){
					preamble += "with(" + part + "){";
					suffix += "}";
				});
			}

			return new Function(fnArgs, preamble + script.innerHTML + suffix);
		},

		instantiate: function(nodes, mixin, options){
			// summary:
			//		Takes array of nodes, and turns them into class instances and
			//		potentially calls a startup method to allow them to connect with
			//		any children.
			// nodes: Array
			//		Array of DOM nodes
			// mixin: Object?
			//		An object that will be mixed in with each node in the array.
			//		Values in the mixin will override values in the node, if they
			//		exist.
			// options: Object?
			//		An object used to hold kwArgs for instantiation.
			//		See parse.options argument for details.
			// returns:
			//		Array of instances.

			mixin = mixin || {};
			options = options || {};

			var dojoType = (options.scope || dojo._scopeName) + "Type", // typically "dojoType"
				attrData = "data-" + (options.scope || dojo._scopeName) + "-", // typically "data-dojo-"
				dataDojoType = attrData + "type", // typically "data-dojo-type"
				dataDojoMixins = attrData + "mixins";					// typically "data-dojo-mixins"

			var list = [];
			darray.forEach(nodes, function(node){
				var type = dojoType in mixin ? mixin[dojoType] : node.getAttribute(dataDojoType) || node.getAttribute(dojoType);
				if(type){
					var mixinsValue = node.getAttribute(dataDojoMixins),
						types = mixinsValue ? [type].concat(mixinsValue.split(/\s*,\s*/)) : [type];

					list.push({
						node: node,
						types: types
					});
				}
			});

			// Instantiate the nodes and return the list of instances.
			return this._instantiate(list, mixin, options);
		},

		_instantiate: function(nodes, mixin, options, returnPromise){
			// summary:
			//		Takes array of objects representing nodes, and turns them into class instances and
			//		potentially calls a startup method to allow them to connect with
			//		any children.
			// nodes: Array
			//		Array of objects like
			//	|		{
			//	|			ctor: Function (may be null)
			//	|			types: ["dijit/form/Button", "acme/MyMixin"] (used if ctor not specified)
			//	|			node: DOMNode,
			//	|			scripts: [ ... ],	// array of <script type="dojo/..."> children of node
			//	|			inherited: { ... }	// settings inherited from ancestors like dir, theme, etc.
			//	|		}
			// mixin: Object
			//		An object that will be mixed in with each node in the array.
			//		Values in the mixin will override values in the node, if they
			//		exist.
			// options: Object
			//		An options object used to hold kwArgs for instantiation.
			//		See parse.options argument for details.
			// returnPromise: Boolean
			//		Return a Promise rather than the instance; supports asynchronous widget creation.
			// returns:
			//		Array of instances, or if returnPromise is true, a promise for array of instances
			//		that resolves when instances have finished initializing.

			// Call widget constructors.   Some may be asynchronous and return promises.
			var thelist = darray.map(nodes, function(obj){
				var ctor = obj.ctor || getCtor(obj.types, options.contextRequire);
				// If we still haven't resolved a ctor, it is fatal now
				if(!ctor){
					throw new Error("Unable to resolve constructor for: '" + obj.types.join() + "'");
				}
				return this.construct(ctor, obj.node, mixin, options, obj.scripts, obj.inherited);
			}, this);

			// After all widget construction finishes, call startup on each top level instance if it makes sense (as for
			// widgets).  Parent widgets will recursively call startup on their (non-top level) children
			function onConstruct(thelist){
				if(!mixin._started && !options.noStart){
					darray.forEach(thelist, function(instance){
						if(typeof instance.startup === "function" && !instance._started){
							instance.startup();
						}
					});
				}

				return thelist;
			}

			if(returnPromise){
				return all(thelist).then(onConstruct);
			}else{
				// Back-compat path, remove for 2.0
				return onConstruct(thelist);
			}
		},

		construct: function(ctor, node, mixin, options, scripts, inherited){
			// summary:
			//		Calls new ctor(params, node), where params is the hash of parameters specified on the node,
			//		excluding data-dojo-type and data-dojo-mixins.   Does not call startup().
			// ctor: Function
			//		Widget constructor.
			// node: DOMNode
			//		This node will be replaced/attached to by the widget.  It also specifies the arguments to pass to ctor.
			// mixin: Object?
			//		Attributes in this object will be passed as parameters to ctor,
			//		overriding attributes specified on the node.
			// options: Object?
			//		An options object used to hold kwArgs for instantiation.   See parse.options argument for details.
			// scripts: DomNode[]?
			//		Array of `<script type="dojo/*">` DOMNodes.  If not specified, will search for `<script>` tags inside node.
			// inherited: Object?
			//		Settings from dir=rtl or lang=... on a node above this node.   Overrides options.inherited.
			// returns:
			//		Instance or Promise for the instance, if markupFactory() itself returned a promise

			var proto = ctor && ctor.prototype;
			options = options || {};

			// Setup hash to hold parameter settings for this widget.	Start with the parameter
			// settings inherited from ancestors ("dir" and "lang").
			// Inherited setting may later be overridden by explicit settings on node itself.
			var params = {};

			if(options.defaults){
				// settings for the document itself (or whatever subtree is being parsed)
				dlang.mixin(params, options.defaults);
			}
			if(inherited){
				// settings from dir=rtl or lang=... on a node above this node
				dlang.mixin(params, inherited);
			}

			// Get list of attributes explicitly listed in the markup
			var attributes;
			if(has("dom-attributes-explicit")){
				// Standard path to get list of user specified attributes
				attributes = node.attributes;
			}else if(has("dom-attributes-specified-flag")){
				// Special processing needed for IE8, to skip a few faux values in attributes[]
				attributes = darray.filter(node.attributes, function(a){
					return a.specified;
				});
			}else{
				// Special path for IE6-7, avoid (sometimes >100) bogus entries in node.attributes
				var clone = /^input$|^img$/i.test(node.nodeName) ? node : node.cloneNode(false),
					attrs = clone.outerHTML.replace(/=[^\s"']+|="[^"]*"|='[^']*'/g, "").replace(/^\s*<[a-zA-Z0-9]*\s*/, "").replace(/\s*>.*$/, "");

				attributes = darray.map(attrs.split(/\s+/), function(name){
					var lcName = name.toLowerCase();
					return {
						name: name,
						// getAttribute() doesn't work for button.value, returns innerHTML of button.
						// but getAttributeNode().value doesn't work for the form.encType or li.value
						value: (node.nodeName == "LI" && name == "value") || lcName == "enctype" ?
							node.getAttribute(lcName) : node.getAttributeNode(lcName).value
					};
				});
			}

			// Hash to convert scoped attribute name (ex: data-dojo17-params) to something friendly (ex: data-dojo-params)
			// TODO: remove scope for 2.0
			var scope = options.scope || dojo._scopeName,
				attrData = "data-" + scope + "-", // typically "data-dojo-"
				hash = {};
			if(scope !== "dojo"){
				hash[attrData + "props"] = "data-dojo-props";
				hash[attrData + "type"] = "data-dojo-type";
				hash[attrData + "mixins"] = "data-dojo-mixins";
				hash[scope + "type"] = "dojotype";
				hash[attrData + "id"] = "data-dojo-id";
			}

			// Read in attributes and process them, including data-dojo-props, data-dojo-type,
			// dojoAttachPoint, etc., as well as normal foo=bar attributes.
			var i = 0, item, funcAttrs = [], jsname, extra;
			while(item = attributes[i++]){
				var name = item.name,
					lcName = name.toLowerCase(),
					value = item.value;

				switch(hash[lcName] || lcName){
				// Already processed, just ignore
				case "data-dojo-type":
				case "dojotype":
				case "data-dojo-mixins":
					break;

				// Data-dojo-props.   Save for later to make sure it overrides direct foo=bar settings
				case "data-dojo-props":
					extra = value;
					break;

				// data-dojo-id or jsId. TODO: drop jsId in 2.0
				case "data-dojo-id":
				case "jsid":
					jsname = value;
					break;

				// For the benefit of _Templated
				case "data-dojo-attach-point":
				case "dojoattachpoint":
					params.dojoAttachPoint = value;
					break;
				case "data-dojo-attach-event":
				case "dojoattachevent":
					params.dojoAttachEvent = value;
					break;

				// Special parameter handling needed for IE
				case "class":
					params["class"] = node.className;
					break;
				case "style":
					params["style"] = node.style && node.style.cssText;
					break;
				default:
					// Normal attribute, ex: value="123"

					// Find attribute in widget corresponding to specified name.
					// May involve case conversion, ex: onclick --> onClick
					if(!(name in proto)){
						var map = getNameMap(ctor);
						name = map[lcName] || name;
					}

					// Set params[name] to value, doing type conversion
					if(name in proto){
						switch(typeof proto[name]){
						case "string":
							params[name] = value;
							break;
						case "number":
							params[name] = value.length ? Number(value) : NaN;
							break;
						case "boolean":
							// for checked/disabled value might be "" or "checked".	 interpret as true.
							params[name] = value.toLowerCase() != "false";
							break;
						case "function":
							if(value === "" || value.search(/[^\w\.]+/i) != -1){
								// The user has specified some text for a function like "return x+5"
								params[name] = new Function(value);
							}else{
								// The user has specified the name of a global function like "myOnClick"
								// or a single word function "return"
								params[name] = dlang.getObject(value, false) || new Function(value);
							}
							funcAttrs.push(name);	// prevent "double connect", see #15026
							break;
						default:
							var pVal = proto[name];
							try{
								params[name] =
									(pVal && "length" in pVal) ? (value ? value.split(/\s*,\s*/) : []) :	// array
										(pVal instanceof Date) ?
											(value == "" ? new Date("") :	// the NaN of dates
											value == "now" ? new Date() :	// current date
											dates.fromISOString(value)) :
									(pVal instanceof _Url) ? (dojo.baseUrl + value) :
									myEval(value);
							}
							catch(error){
								console.error(error);
							}
						}
					}else{
						params[name] = value;
					}
				}
			}

			// Remove function attributes from DOMNode to prevent "double connect" problem, see #15026.
			// Do this as a separate loop since attributes[] is often a live collection (depends on the browser though).
			for(var j = 0; j < funcAttrs.length; j++){
				var lcfname = funcAttrs[j].toLowerCase();
				node.removeAttribute(lcfname);
				node[lcfname] = null;
			}

			// Mix things found in data-dojo-props into the params, overriding any direct settings
			if(extra){
				try{
					extra = myEval.call(options.propsThis, "{" + extra + "}");
					dlang.mixin(params, extra);
				}catch(e){
					// give the user a pointer to their invalid parameters. FIXME: can we kill this in production?
					throw new Error(e.toString() + " in data-dojo-props='" + extra + "'");
				}
			}

			// Any parameters specified in "mixin" override everything else.
			dlang.mixin(params, mixin);

			// Get <script> nodes associated with this widget, if they weren't specified explicitly
			if(!scripts){
				scripts = (ctor && (ctor._noScript || proto._noScript) ? [] : query("> script[type^='dojo/']", node));
			}

			// Process <script type="dojo/*"> script tags
			// <script type="dojo/method" data-dojo-event="foo"> tags are added to params, and passed to
			// the widget on instantiation.
			// <script type="dojo/method"> tags (with no event) are executed after instantiation
			// <script type="dojo/connect" data-dojo-event="foo"> tags are dojo.connected after instantiation,
			// and likewise with <script type="dojo/aspect" data-dojo-method="foo">
			// <script type="dojo/watch" data-dojo-prop="foo"> tags are dojo.watch after instantiation
			// <script type="dojo/on" data-dojo-event="foo"> tags are dojo.on after instantiation
			// note: dojo/* script tags cannot exist in self closing widgets, like <input />
			var aspects = [],	// aspects to connect after instantiation
				calls = [],		// functions to call after instantiation
				watches = [],  // functions to watch after instantiation
				ons = []; // functions to on after instantiation

			if(scripts){
				for(i = 0; i < scripts.length; i++){
					var script = scripts[i];
					node.removeChild(script);
					// FIXME: drop event="" support in 2.0. use data-dojo-event="" instead
					var event = (script.getAttribute(attrData + "event") || script.getAttribute("event")),
						prop = script.getAttribute(attrData + "prop"),
						method = script.getAttribute(attrData + "method"),
						advice = script.getAttribute(attrData + "advice"),
						scriptType = script.getAttribute("type"),
						nf = this._functionFromScript(script, attrData);
					if(event){
						if(scriptType == "dojo/connect"){
							aspects.push({ method: event, func: nf });
						}else if(scriptType == "dojo/on"){
							ons.push({ event: event, func: nf });
						}else{
							// <script type="dojo/method" data-dojo-event="foo">
							// TODO for 2.0: use data-dojo-method="foo" instead (also affects dijit/Declaration)
							params[event] = nf;
						}
					}else if(scriptType == "dojo/aspect"){
						aspects.push({ method: method, advice: advice, func: nf });
					}else if(scriptType == "dojo/watch"){
						watches.push({ prop: prop, func: nf });
					}else{
						calls.push(nf);
					}
				}
			}

			// create the instance
			var markupFactory = ctor.markupFactory || proto.markupFactory;
			var instance = markupFactory ? markupFactory(params, node, ctor) : new ctor(params, node);

			function onInstantiate(instance){
				// map it to the JS namespace if that makes sense
				if(jsname){
					dlang.setObject(jsname, instance);
				}

				// process connections and startup functions
				for(i = 0; i < aspects.length; i++){
					aspect[aspects[i].advice || "after"](instance, aspects[i].method, dlang.hitch(instance, aspects[i].func), true);
				}
				for(i = 0; i < calls.length; i++){
					calls[i].call(instance);
				}
				for(i = 0; i < watches.length; i++){
					instance.watch(watches[i].prop, watches[i].func);
				}
				for(i = 0; i < ons.length; i++){
					don(instance, ons[i].event, ons[i].func);
				}

				return instance;
			}

			if(instance.then){
				return instance.then(onInstantiate);
			}else{
				return onInstantiate(instance);
			}
		},

		scan: function(root, options){
			// summary:
			//		Scan a DOM tree and return an array of objects representing the DOMNodes
			//		that need to be turned into widgets.
			// description:
			//		Search specified node (or document root node) recursively for class instances
			//		and return an array of objects that represent potential widgets to be
			//		instantiated. Searches for either data-dojo-type="MID" or dojoType="MID" where
			//		"MID" is a module ID like "dijit/form/Button" or a fully qualified Class name
			//		like "dijit/form/Button".  If the MID is not currently available, scan will
			//		attempt to require() in the module.
			//
			//		See parser.parse() for details of markup.
			// root: DomNode?
			//		A default starting root node from which to start the parsing. Can be
			//		omitted, defaulting to the entire document. If omitted, the `options`
			//		object can be passed in this place. If the `options` object has a
			//		`rootNode` member, that is used.
			// options: Object
			//		a kwArgs options object, see parse() for details
			//
			// returns: Promise
			//		A promise that is resolved with the nodes that have been parsed.

			var list = [], // Output List
				mids = [], // An array of modules that are not yet loaded
				midsHash = {}; // Used to keep the mids array unique

			var dojoType = (options.scope || dojo._scopeName) + "Type", // typically "dojoType"
				attrData = "data-" + (options.scope || dojo._scopeName) + "-", // typically "data-dojo-"
				dataDojoType = attrData + "type", // typically "data-dojo-type"
				dataDojoTextDir = attrData + "textdir", // typically "data-dojo-textdir"
				dataDojoMixins = attrData + "mixins";					// typically "data-dojo-mixins"

			// Info on DOMNode currently being processed
			var node = root.firstChild;

			// Info on parent of DOMNode currently being processed
			//	- inherited: dir, lang, and textDir setting of parent, or inherited by parent
			//	- parent: pointer to identical structure for my parent (or null if no parent)
			//	- scripts: if specified, collects <script type="dojo/..."> type nodes from children
			var inherited = options.inherited;
			if(!inherited){
				var findAncestorAttr = function findAncestorAttr(node, attr){
					return (node.getAttribute && node.getAttribute(attr)) ||
						(node.parentNode && findAncestorAttr(node.parentNode, attr));
				};

				inherited = {
					dir: findAncestorAttr(root, "dir"),
					lang: findAncestorAttr(root, "lang"),
					textDir: findAncestorAttr(root, dataDojoTextDir)
				};
				for(var key in inherited){
					if(!inherited[key]){
						delete inherited[key];
					}
				}
			}

			// Metadata about parent node
			var parent = {
				inherited: inherited
			};

			// For collecting <script type="dojo/..."> type nodes (when null, we don't need to collect)
			var scripts;

			// when true, only look for <script type="dojo/..."> tags, and don't recurse to children
			var scriptsOnly;

			function getEffective(parent){
				// summary:
				//		Get effective dir, lang, textDir settings for specified obj
				//		(matching "parent" object structure above), and do caching.
				//		Take care not to return null entries.
				if(!parent.inherited){
					parent.inherited = {};
					var node = parent.node,
						grandparent = getEffective(parent.parent);
					var inherited = {
						dir: node.getAttribute("dir") || grandparent.dir,
						lang: node.getAttribute("lang") || grandparent.lang,
						textDir: node.getAttribute(dataDojoTextDir) || grandparent.textDir
					};
					for(var key in inherited){
						if(inherited[key]){
							parent.inherited[key] = inherited[key];
						}
					}
				}
				return parent.inherited;
			}

			// DFS on DOM tree, collecting nodes with data-dojo-type specified.
			while(true){
				if(!node){
					// Finished this level, continue to parent's next sibling
					if(!parent || !parent.node){
						break;
					}
					node = parent.node.nextSibling;
					scriptsOnly = false;
					parent = parent.parent;
					scripts = parent.scripts;
					continue;
				}

				if(node.nodeType != 1){
					// Text or comment node, skip to next sibling
					node = node.nextSibling;
					continue;
				}

				if(scripts && node.nodeName.toLowerCase() == "script"){
					// Save <script type="dojo/..."> for parent, then continue to next sibling
					type = node.getAttribute("type");
					if(type && /^dojo\/\w/i.test(type)){
						scripts.push(node);
					}
					node = node.nextSibling;
					continue;
				}
				if(scriptsOnly){
					// scriptsOnly flag is set, we have already collected scripts if the parent wants them, so now we shouldn't
					// continue further analysis of the node and will continue to the next sibling
					node = node.nextSibling;
					continue;
				}

				// Check for data-dojo-type attribute, fallback to backward compatible dojoType
				// TODO: Remove dojoType in 2.0
				var type = node.getAttribute(dataDojoType) || node.getAttribute(dojoType);

				// Short circuit for leaf nodes containing nothing [but text]
				var firstChild = node.firstChild;
				if(!type && (!firstChild || (firstChild.nodeType == 3 && !firstChild.nextSibling))){
					node = node.nextSibling;
					continue;
				}

				// Meta data about current node
				var current;

				var ctor = null;
				if(type){
					// If dojoType/data-dojo-type specified, add to output array of nodes to instantiate.
					var mixinsValue = node.getAttribute(dataDojoMixins),
						types = mixinsValue ? [type].concat(mixinsValue.split(/\s*,\s*/)) : [type];

					// Note: won't find classes declared via dojo/Declaration or any modules that haven't been
					// loaded yet so use try/catch to avoid throw from require()
					try{
						ctor = getCtor(types, options.contextRequire);
					}catch(e){}

					// If the constructor was not found, check to see if it has modules that can be loaded
					if(!ctor){
						darray.forEach(types, function(t){
							if(~t.indexOf('/') && !midsHash[t]){
								// If the type looks like a MID and it currently isn't in the array of MIDs to load, add it.
								midsHash[t] = true;
								mids[mids.length] = t;
							}
						});
					}

					var childScripts = ctor && !ctor.prototype._noScript ? [] : null; // <script> nodes that are parent's children

					// Setup meta data about this widget node, and save it to list of nodes to instantiate
					current = {
						types: types,
						ctor: ctor,
						parent: parent,
						node: node,
						scripts: childScripts
					};
					current.inherited = getEffective(current); // dir & lang settings for current node, explicit or inherited
					list.push(current);
				}else{
					// Meta data about this non-widget node
					current = {
						node: node,
						scripts: scripts,
						parent: parent
					};
				}

				// Recurse, collecting <script type="dojo/..."> children, and also looking for
				// descendant nodes with dojoType specified (unless the widget has the stopParser flag).
				// When finished with children, go to my next sibling.
				scripts = childScripts;
				scriptsOnly = node.stopParser || (ctor && ctor.prototype.stopParser && !(options.template));
				parent = current;
				node = firstChild;
			}

			var d = new Deferred();

			// If there are modules to load then require them in
			if(mids.length){
				// Warn that there are modules being auto-required
				if( 0 ){
					console.warn("WARNING: Modules being Auto-Required: " + mids.join(", "));
				}
				var r = options.contextRequire || require;
				r(mids, function(){
					// Go through list of widget nodes, filling in missing constructors, and filtering out nodes that shouldn't
					// be instantiated due to a stopParser flag on an ancestor that we belatedly learned about due to
					// auto-require of a module like ContentPane.   Assumes list is in DFS order.
					d.resolve(darray.filter(list, function(widget){
						if(!widget.ctor){
							// Attempt to find the constructor again.   Still won't find classes defined via
							// dijit/Declaration so need to try/catch.
							try{
								widget.ctor = getCtor(widget.types, options.contextRequire);
							}catch(e){}
						}

						// Get the parent widget
						var parent = widget.parent;
						while(parent && !parent.types){
							parent = parent.parent;
						}

						// Return false if this node should be skipped due to stopParser on an ancestor.
						// Since list[] is in DFS order, this loop will always set parent.instantiateChildren before
						// trying to compute widget.instantiate.
						var proto = widget.ctor && widget.ctor.prototype;
						widget.instantiateChildren = !(proto && proto.stopParser && !(options.template));
						widget.instantiate = !parent || (parent.instantiate && parent.instantiateChildren);
						return widget.instantiate;
					}));
				});
			}else{
				// There were no modules to load, so just resolve with the parsed nodes.   This separate code path is for
				// efficiency, to avoid running the require() and the callback code above.
				d.resolve(list);
			}

			// Return the promise
			return d.promise;
		},

		_require: function(/*DOMNode*/ script, /*Object?*/ options){
			// summary:
			//		Helper for _scanAMD().  Takes a `<script type=dojo/require>bar: "acme/bar", ...</script>` node,
			//		calls require() to load the specified modules and (asynchronously) assign them to the specified global
			//		variables, and returns a Promise for when that operation completes.
			//
			//		In the example above, it is effectively doing a require(["acme/bar", ...], function(a){ bar = a; }).

			var hash = myEval("{" + script.innerHTML + "}"), // can't use dojo/json::parse() because maybe no quotes
				vars = [],
				mids = [],
				d = new Deferred();

			var contextRequire = (options && options.contextRequire) || require;

			for(var name in hash){
				vars.push(name);
				mids.push(hash[name]);
			}

			contextRequire(mids, function(){
				for(var i = 0; i < vars.length; i++){
					dlang.setObject(vars[i], arguments[i]);
				}
				d.resolve(arguments);
			});

			return d.promise;
		},

		_scanAmd: function(root, options){
			// summary:
			//		Scans the DOM for any declarative requires and returns their values.
			// description:
			//		Looks for `<script type=dojo/require>bar: "acme/bar", ...</script>` node, calls require() to load the
			//		specified modules and (asynchronously) assign them to the specified global variables,
			//		and returns a Promise for when those operations complete.
			// root: DomNode
			//		The node to base the scan from.
			// options: Object?
			//		a kwArgs options object, see parse() for details

			// Promise that resolves when all the <script type=dojo/require> nodes have finished loading.
			var deferred = new Deferred(),
				promise = deferred.promise;
			deferred.resolve(true);

			var self = this;
			query("script[type='dojo/require']", root).forEach(function(node){
				// Fire off require() call for specified modules.  Chain this require to fire after
				// any previous requires complete, so that layers can be loaded before individual module require()'s fire.
				promise = promise.then(function(){
					return self._require(node, options);
				});

				// Remove from DOM so it isn't seen again
				node.parentNode.removeChild(node);
			});

			return promise;
		},

		parse: function(rootNode, options){
			// summary:
			//		Scan the DOM for class instances, and instantiate them.
			// description:
			//		Search specified node (or root node) recursively for class instances,
			//		and instantiate them. Searches for either data-dojo-type="Class" or
			//		dojoType="Class" where "Class" is a a fully qualified class name,
			//		like `dijit/form/Button`
			//
			//		Using `data-dojo-type`:
			//		Attributes using can be mixed into the parameters used to instantiate the
			//		Class by using a `data-dojo-props` attribute on the node being converted.
			//		`data-dojo-props` should be a string attribute to be converted from JSON.
			//
			//		Using `dojoType`:
			//		Attributes are read from the original domNode and converted to appropriate
			//		types by looking up the Class prototype values. This is the default behavior
			//		from Dojo 1.0 to Dojo 1.5. `dojoType` support is deprecated, and will
			//		go away in Dojo 2.0.
			// rootNode: DomNode?
			//		A default starting root node from which to start the parsing. Can be
			//		omitted, defaulting to the entire document. If omitted, the `options`
			//		object can be passed in this place. If the `options` object has a
			//		`rootNode` member, that is used.
			// options: Object?
			//		A hash of options.
			//
			//		- noStart: Boolean?:
			//			when set will prevent the parser from calling .startup()
			//			when locating the nodes.
			//		- rootNode: DomNode?:
			//			identical to the function's `rootNode` argument, though
			//			allowed to be passed in via this `options object.
			//		- template: Boolean:
			//			If true, ignores ContentPane's stopParser flag and parses contents inside of
			//			a ContentPane inside of a template.   This allows dojoAttachPoint on widgets/nodes
			//			nested inside the ContentPane to work.
			//		- inherited: Object:
			//			Hash possibly containing dir and lang settings to be applied to
			//			parsed widgets, unless there's another setting on a sub-node that overrides
			//		- scope: String:
			//			Root for attribute names to search for.   If scopeName is dojo,
			//			will search for data-dojo-type (or dojoType).   For backwards compatibility
			//			reasons defaults to dojo._scopeName (which is "dojo" except when
			//			multi-version support is used, when it will be something like dojo16, dojo20, etc.)
			//		- propsThis: Object:
			//			If specified, "this" referenced from data-dojo-props will refer to propsThis.
			//			Intended for use from the widgets-in-template feature of `dijit._WidgetsInTemplateMixin`
			//		- contextRequire: Function:
			//			If specified, this require is utilised for looking resolving modules instead of the
			//			`dojo/parser` context `require()`.  Intended for use from the widgets-in-template feature of
			//			`dijit._WidgetsInTemplateMixin`.
			// returns: Mixed
			//		Returns a blended object that is an array of the instantiated objects, but also can include
			//		a promise that is resolved with the instantiated objects.  This is done for backwards
			//		compatibility.  If the parser auto-requires modules, it will always behave in a promise
			//		fashion and `parser.parse().then(function(instances){...})` should be used.
			// example:
			//		Parse all widgets on a page:
			//	|		parser.parse();
			// example:
			//		Parse all classes within the node with id="foo"
			//	|		parser.parse(dojo.byId('foo'));
			// example:
			//		Parse all classes in a page, but do not call .startup() on any
			//		child
			//	|		parser.parse({ noStart: true })
			// example:
			//		Parse all classes in a node, but do not call .startup()
			//	|		parser.parse(someNode, { noStart:true });
			//	|		// or
			//	|		parser.parse({ noStart:true, rootNode: someNode });

			// determine the root node and options based on the passed arguments.
			if(rootNode && typeof rootNode != "string" && !("nodeType" in rootNode)){
				// If called as parse(options) rather than parse(), parse(rootNode), or parse(rootNode, options)...
				options = rootNode;
				rootNode = options.rootNode;
			}
			var root = rootNode ? dom.byId(rootNode) : dwindow.body();
			options = options || {};

			var mixin = options.template ? { template: true } : {},
				instances = [],
				self = this;

			// First scan for any <script type=dojo/require> nodes, and execute.
			// Then scan for all nodes with data-dojo-type, and load any unloaded modules.
			// Then build the object instances.  Add instances to already existing (but empty) instances[] array,
			// which may already have been returned to caller.  Also, use otherwise to collect and throw any errors
			// that occur during the parse().
			var p =
				this._scanAmd(root, options).then(function(){
					return self.scan(root, options);
				}).then(function(parsedNodes){
					return self._instantiate(parsedNodes, mixin, options, true);
				}).then(function(_instances){
					// Copy the instances into the instances[] array we declared above, and are accessing as
					// our return value.
					return instances = instances.concat(_instances);
				}).otherwise(function(e){
					// TODO Modify to follow better pattern for promise error management when available
					console.error("dojo/parser::parse() error", e);
					throw e;
				});

			// Blend the array with the promise
			dlang.mixin(instances, p);
			return instances;
		}
	};

	if( 1 ){
		dojo.parser = parser;
	}

	// Register the parser callback. It should be the first callback
	// after the a11y test.
	if(config.parseOnLoad){
		ready(100, parser, "parse");
	}

	return parser;
});

},
'dojo/_base/url':function(){
define(["./kernel"], function(dojo){
	// module:
	//		dojo/url

	var
		ore = new RegExp("^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?$"),
		ire = new RegExp("^((([^\\[:]+):)?([^@]+)@)?(\\[([^\\]]+)\\]|([^\\[:]*))(:([0-9]+))?$"),
		_Url = function(){
			var n = null,
				_a = arguments,
				uri = [_a[0]];
			// resolve uri components relative to each other
			for(var i = 1; i<_a.length; i++){
				if(!_a[i]){ continue; }

				// Safari doesn't support this.constructor so we have to be explicit
				// FIXME: Tracked (and fixed) in Webkit bug 3537.
				//		http://bugs.webkit.org/show_bug.cgi?id=3537
				var relobj = new _Url(_a[i]+""),
					uriobj = new _Url(uri[0]+"");

				if(
					relobj.path == "" &&
					!relobj.scheme &&
					!relobj.authority &&
					!relobj.query
				){
					if(relobj.fragment != n){
						uriobj.fragment = relobj.fragment;
					}
					relobj = uriobj;
				}else if(!relobj.scheme){
					relobj.scheme = uriobj.scheme;

					if(!relobj.authority){
						relobj.authority = uriobj.authority;

						if(relobj.path.charAt(0) != "/"){
							var path = uriobj.path.substring(0,
								uriobj.path.lastIndexOf("/") + 1) + relobj.path;

							var segs = path.split("/");
							for(var j = 0; j < segs.length; j++){
								if(segs[j] == "."){
									// flatten "./" references
									if(j == segs.length - 1){
										segs[j] = "";
									}else{
										segs.splice(j, 1);
										j--;
									}
								}else if(j > 0 && !(j == 1 && segs[0] == "") &&
									segs[j] == ".." && segs[j-1] != ".."){
									// flatten "../" references
									if(j == (segs.length - 1)){
										segs.splice(j, 1);
										segs[j - 1] = "";
									}else{
										segs.splice(j - 1, 2);
										j -= 2;
									}
								}
							}
							relobj.path = segs.join("/");
						}
					}
				}

				uri = [];
				if(relobj.scheme){
					uri.push(relobj.scheme, ":");
				}
				if(relobj.authority){
					uri.push("//", relobj.authority);
				}
				uri.push(relobj.path);
				if(relobj.query){
					uri.push("?", relobj.query);
				}
				if(relobj.fragment){
					uri.push("#", relobj.fragment);
				}
			}

			this.uri = uri.join("");

			// break the uri into its main components
			var r = this.uri.match(ore);

			this.scheme = r[2] || (r[1] ? "" : n);
			this.authority = r[4] || (r[3] ? "" : n);
			this.path = r[5]; // can never be undefined
			this.query = r[7] || (r[6] ? "" : n);
			this.fragment	 = r[9] || (r[8] ? "" : n);

			if(this.authority != n){
				// server based naming authority
				r = this.authority.match(ire);

				this.user = r[3] || n;
				this.password = r[4] || n;
				this.host = r[6] || r[7]; // ipv6 || ipv4
				this.port = r[9] || n;
			}
		};
	_Url.prototype.toString = function(){ return this.uri; };

	return dojo._Url = _Url;
});

},
'dojo/promise/all':function(){
define([
	"../_base/array",
	"../_base/lang",
	"../Deferred",
	"../when"
], function(array, lang, Deferred, when){
	"use strict";

	// module:
	//		dojo/promise/all

	var some = array.some;

	return function all(objectOrArray){
		// summary:
		//		Takes multiple promises and returns a new promise that is fulfilled
		//		when all promises have been resolved or one has been rejected.
		// description:
		//		Takes multiple promises and returns a new promise that is fulfilled
		//		when all promises have been resolved or one has been rejected. If one of
		//		the promises is rejected, the returned promise is also rejected. Canceling
		//		the returned promise will *not* cancel any passed promises.
		// objectOrArray: Object|Array?
		//		The promise will be fulfilled with a list of results if invoked with an
		//		array, or an object of results when passed an object (using the same
		//		keys). If passed neither an object or array it is resolved with an
		//		undefined value.
		// returns: dojo/promise/Promise

		var object, array;
		if(lang.isArray(objectOrArray)){
			array = objectOrArray;
		}else if(objectOrArray && typeof objectOrArray === "object"){
			object = objectOrArray;
		}

		var results;
		var keyLookup = [];
		if(object){
			array = [];
			for(var key in object){
				if(Object.hasOwnProperty.call(object, key)){
					keyLookup.push(key);
					array.push(object[key]);
				}
			}
			results = {};
		}else if(array){
			results = [];
		}

		if(!array || !array.length){
			return new Deferred().resolve(results);
		}

		var deferred = new Deferred();
		deferred.promise.always(function(){
			results = keyLookup = null;
		});
		var waiting = array.length;
		some(array, function(valueOrPromise, index){
			if(!object){
				keyLookup.push(index);
			}
			when(valueOrPromise, function(value){
				if(!deferred.isFulfilled()){
					results[keyLookup[index]] = value;
					if(--waiting === 0){
						deferred.resolve(results);
					}
				}
			}, deferred.reject);
			return deferred.isFulfilled();
		});
		return deferred.promise;	// dojo/promise/Promise
	};
});

},
'dojo/date/stamp':function(){
define(["../_base/lang", "../_base/array"], function(lang, array){

// module:
//		dojo/date/stamp

var stamp = {
	// summary:
	//		TODOC
};
lang.setObject("dojo.date.stamp", stamp);

// Methods to convert dates to or from a wire (string) format using well-known conventions

stamp.fromISOString = function(/*String*/ formattedString, /*Number?*/ defaultTime){
	// summary:
	//		Returns a Date object given a string formatted according to a subset of the ISO-8601 standard.
	//
	// description:
	//		Accepts a string formatted according to a profile of ISO8601 as defined by
	//		[RFC3339](http://www.ietf.org/rfc/rfc3339.txt), except that partial input is allowed.
	//		Can also process dates as specified [by the W3C](http://www.w3.org/TR/NOTE-datetime)
	//		The following combinations are valid:
	//
	//		- dates only
	//			- yyyy
	//			- yyyy-MM
	//			- yyyy-MM-dd
	//		- times only, with an optional time zone appended
	//			- THH:mm
	//			- THH:mm:ss
	//			- THH:mm:ss.SSS
	//		- and "datetimes" which could be any combination of the above
	//
	//		timezones may be specified as Z (for UTC) or +/- followed by a time expression HH:mm
	//		Assumes the local time zone if not specified.  Does not validate.  Improperly formatted
	//		input may return null.  Arguments which are out of bounds will be handled
	//		by the Date constructor (e.g. January 32nd typically gets resolved to February 1st)
	//		Only years between 100 and 9999 are supported.
  	// formattedString:
	//		A string such as 2005-06-30T08:05:00-07:00 or 2005-06-30 or T08:05:00
	// defaultTime:
	//		Used for defaults for fields omitted in the formattedString.
	//		Uses 1970-01-01T00:00:00.0Z by default.

	if(!stamp._isoRegExp){
		stamp._isoRegExp =
//TODO: could be more restrictive and check for 00-59, etc.
			/^(?:(\d{4})(?:-(\d{2})(?:-(\d{2}))?)?)?(?:T(\d{2}):(\d{2})(?::(\d{2})(.\d+)?)?((?:[+-](\d{2}):(\d{2}))|Z)?)?$/;
	}

	var match = stamp._isoRegExp.exec(formattedString),
		result = null;

	if(match){
		match.shift();
		if(match[1]){match[1]--;} // Javascript Date months are 0-based
		if(match[6]){match[6] *= 1000;} // Javascript Date expects fractional seconds as milliseconds

		if(defaultTime){
			// mix in defaultTime.  Relatively expensive, so use || operators for the fast path of defaultTime === 0
			defaultTime = new Date(defaultTime);
			array.forEach(array.map(["FullYear", "Month", "Date", "Hours", "Minutes", "Seconds", "Milliseconds"], function(prop){
				return defaultTime["get" + prop]();
			}), function(value, index){
				match[index] = (match[index] == undefined) ? value : match[index];
			});
		}
		result = new Date(match[0]||1970, match[1]||0, match[2]||1, match[3]||0, match[4]||0, match[5]||0, match[6]||0); //TODO: UTC defaults
		if(match[0] < 100){
			result.setFullYear(match[0] || 1970);
		}

		var offset = 0,
			zoneSign = match[7] && match[7].charAt(0);
		if(zoneSign != 'Z'){
			offset = ((match[8] || 0) * 60) + (Number(match[9]) || 0);
			if(zoneSign != '-'){ offset *= -1; }
		}
		if(zoneSign){
			offset -= result.getTimezoneOffset();
		}
		if(offset){
			result.setTime(result.getTime() + offset * 60000);
		}
	}

	return result; // Date or null
};

/*=====
var __Options = {
	// selector: String
	//		"date" or "time" for partial formatting of the Date object.
	//		Both date and time will be formatted by default.
	// zulu: Boolean
	//		if true, UTC/GMT is used for a timezone
	// milliseconds: Boolean
	//		if true, output milliseconds
};
=====*/

stamp.toISOString = function(/*Date*/ dateObject, /*__Options?*/ options){
	// summary:
	//		Format a Date object as a string according a subset of the ISO-8601 standard
	//
	// description:
	//		When options.selector is omitted, output follows [RFC3339](http://www.ietf.org/rfc/rfc3339.txt)
	//		The local time zone is included as an offset from GMT, except when selector=='time' (time without a date)
	//		Does not check bounds.  Only years between 100 and 9999 are supported.
	//
	// dateObject:
	//		A Date object

	var _ = function(n){ return (n < 10) ? "0" + n : n; };
	options = options || {};
	var formattedDate = [],
		getter = options.zulu ? "getUTC" : "get",
		date = "";
	if(options.selector != "time"){
		var year = dateObject[getter+"FullYear"]();
		date = ["0000".substr((year+"").length)+year, _(dateObject[getter+"Month"]()+1), _(dateObject[getter+"Date"]())].join('-');
	}
	formattedDate.push(date);
	if(options.selector != "date"){
		var time = [_(dateObject[getter+"Hours"]()), _(dateObject[getter+"Minutes"]()), _(dateObject[getter+"Seconds"]())].join(':');
		var millis = dateObject[getter+"Milliseconds"]();
		if(options.milliseconds){
			time += "."+ (millis < 100 ? "0" : "") + _(millis);
		}
		if(options.zulu){
			time += "Z";
		}else if(options.selector != "time"){
			var timezoneOffset = dateObject.getTimezoneOffset();
			var absOffset = Math.abs(timezoneOffset);
			time += (timezoneOffset > 0 ? "-" : "+") +
				_(Math.floor(absOffset/60)) + ":" + _(absOffset%60);
		}
		formattedDate.push(time);
	}
	return formattedDate.join('T'); // String
};

return stamp;
});

},
'dojo/json5':function(){
define([
	'./json5/parse'
], function (parse) {
	return {
		parse: parse
	};
});

},
'dojo/json5/parse':function(){
define([
	'../string',
	'./util'
], function (dstring, util) {
	var source;
	var parseState;
	var stack;
	var pos;
	var line;
	var column;
	var token;
	var key;
	var root;

	function parse(text, reviver) {
		source = String(text);
		parseState = 'start';
		stack = [];
		pos = 0;
		line = 1;
		column = 0;
		token = undefined;
		key = undefined;
		root = undefined;
		do {
			token = lex();
			parseStates[parseState]();
		} while (token.type !== 'eof');
		if (typeof reviver === 'function') {
			return internalize({ '': root }, '', reviver);
		}
		return root;
	}
	function internalize(holder, name, reviver) {
		var value = holder[name];
		if (value != null && typeof value === 'object') {
			for (var key_1 in value) {
				var replacement = internalize(value, key_1, reviver);
				if (replacement === undefined) {
					delete value[key_1];
				}
				else {
					value[key_1] = replacement;
				}
			}
		}
		return reviver.call(holder, name, value);
	}
	var lexState;
	var buffer;
	var doubleQuote;
	var sign;
	var c;
	function lex() {
		lexState = 'default';
		buffer = '';
		doubleQuote = false;
		sign = 1;
		for (;;) {
			c = peek();
			var token_1 = lexStates[lexState]();
			if (token_1) {
				return token_1;
			}
		}
	}
	function peek() {
		if (source[pos]) {
			return dstring.fromCodePoint(dstring.codePointAt(source, pos));
		}
	}
	function read() {
		var c = peek();
		if (c === '\n') {
			line++;
			column = 0;
		}
		else if (c) {
			column += c.length;
		}
		else {
			column++;
		}
		if (c) {
			pos += c.length;
		}
		return c;
	}
	var lexStates = {
		'default': function () {
			switch (c) {
				case '\t':
				case '\v':
				case '\f':
				case ' ':
				case '\u00A0':
				case '\uFEFF':
				case '\n':
				case '\r':
				case '\u2028':
				case '\u2029':
					read();
					return;
				case '/':
					read();
					lexState = 'comment';
					return;
				case undefined:
					read();
					return newToken('eof');
			}
			if (util.isSpaceSeparator(c)) {
				read();
				return;
			}
			return lexStates[parseState]();
		},
		comment: function () {
			switch (c) {
				case '*':
					read();
					lexState = 'multiLineComment';
					return;
				case '/':
					read();
					lexState = 'singleLineComment';
					return;
			}
			throw invalidChar(read());
		},
		multiLineComment: function () {
			switch (c) {
				case '*':
					read();
					lexState = 'multiLineCommentAsterisk';
					return;
				case undefined:
					throw invalidChar(read());
			}
			read();
		},
		multiLineCommentAsterisk: function () {
			switch (c) {
				case '*':
					read();
					return;
				case '/':
					read();
					lexState = 'default';
					return;
				case undefined:
					throw invalidChar(read());
			}
			read();
			lexState = 'multiLineComment';
		},
		singleLineComment: function () {
			switch (c) {
				case '\n':
				case '\r':
				case '\u2028':
				case '\u2029':
					read();
					lexState = 'default';
					return;
				case undefined:
					read();
					return newToken('eof');
			}
			read();
		},
		value: function () {
			switch (c) {
				case '{':
				case '[':
					return newToken('punctuator', read());
				case 'n':
					read();
					literal('ull');
					return newToken('null', null);
				case 't':
					read();
					literal('rue');
					return newToken('boolean', true);
				case 'f':
					read();
					literal('alse');
					return newToken('boolean', false);
				case '-':
				case '+':
					if (read() === '-') {
						sign = -1;
					}
					lexState = 'sign';
					return;
				case '.':
					buffer = read();
					lexState = 'decimalPointLeading';
					return;
				case '0':
					buffer = read();
					lexState = 'zero';
					return;
				case '1':
				case '2':
				case '3':
				case '4':
				case '5':
				case '6':
				case '7':
				case '8':
				case '9':
					buffer = read();
					lexState = 'decimalInteger';
					return;
				case 'I':
					read();
					literal('nfinity');
					return newToken('numeric', Infinity);
				case 'N':
					read();
					literal('aN');
					return newToken('numeric', NaN);
				case '"':
				case "'":
					doubleQuote = (read() === '"');
					buffer = '';
					lexState = 'string';
					return;
			}
			throw invalidChar(read());
		},
		identifierNameStartEscape: function () {
			if (c !== 'u') {
				throw invalidChar(read());
			}
			read();
			var u = unicodeEscape();
			switch (u) {
				case '$':
				case '_':
					break;
				default:
					if (!util.isIdStartChar(u)) {
						throw invalidIdentifier();
					}
					break;
			}
			buffer += u;
			lexState = 'identifierName';
		},
		identifierName: function () {
			switch (c) {
				case '$':
				case '_':
				case '\u200C':
				case '\u200D':
					buffer += read();
					return;
				case '\\':
					read();
					lexState = 'identifierNameEscape';
					return;
			}
			if (util.isIdContinueChar(c)) {
				buffer += read();
				return;
			}
			return newToken('identifier', buffer);
		},
		identifierNameEscape: function () {
			if (c !== 'u') {
				throw invalidChar(read());
			}
			read();
			var u = unicodeEscape();
			switch (u) {
				case '$':
				case '_':
				case '\u200C':
				case '\u200D':
					break;
				default:
					if (!util.isIdContinueChar(u)) {
						throw invalidIdentifier();
					}
					break;
			}
			buffer += u;
			lexState = 'identifierName';
		},
		sign: function () {
			switch (c) {
				case '.':
					buffer = read();
					lexState = 'decimalPointLeading';
					return;
				case '0':
					buffer = read();
					lexState = 'zero';
					return;
				case '1':
				case '2':
				case '3':
				case '4':
				case '5':
				case '6':
				case '7':
				case '8':
				case '9':
					buffer = read();
					lexState = 'decimalInteger';
					return;
				case 'I':
					read();
					literal('nfinity');
					return newToken('numeric', sign * Infinity);
				case 'N':
					read();
					literal('aN');
					return newToken('numeric', NaN);
			}
			throw invalidChar(read());
		},
		zero: function () {
			switch (c) {
				case '.':
					buffer += read();
					lexState = 'decimalPoint';
					return;
				case 'e':
				case 'E':
					buffer += read();
					lexState = 'decimalExponent';
					return;
				case 'x':
				case 'X':
					buffer += read();
					lexState = 'hexadecimal';
					return;
			}
			return newToken('numeric', sign * 0);
		},
		decimalInteger: function () {
			switch (c) {
				case '.':
					buffer += read();
					lexState = 'decimalPoint';
					return;
				case 'e':
				case 'E':
					buffer += read();
					lexState = 'decimalExponent';
					return;
			}
			if (util.isDigit(c)) {
				buffer += read();
				return;
			}
			return newToken('numeric', sign * Number(buffer));
		},
		decimalPointLeading: function () {
			if (util.isDigit(c)) {
				buffer += read();
				lexState = 'decimalFraction';
				return;
			}
			throw invalidChar(read());
		},
		decimalPoint: function () {
			switch (c) {
				case 'e':
				case 'E':
					buffer += read();
					lexState = 'decimalExponent';
					return;
			}
			if (util.isDigit(c)) {
				buffer += read();
				lexState = 'decimalFraction';
				return;
			}
			return newToken('numeric', sign * Number(buffer));
		},
		decimalFraction: function () {
			switch (c) {
				case 'e':
				case 'E':
					buffer += read();
					lexState = 'decimalExponent';
					return;
			}
			if (util.isDigit(c)) {
				buffer += read();
				return;
			}
			return newToken('numeric', sign * Number(buffer));
		},
		decimalExponent: function () {
			switch (c) {
				case '+':
				case '-':
					buffer += read();
					lexState = 'decimalExponentSign';
					return;
			}
			if (util.isDigit(c)) {
				buffer += read();
				lexState = 'decimalExponentInteger';
				return;
			}
			throw invalidChar(read());
		},
		decimalExponentSign: function () {
			if (util.isDigit(c)) {
				buffer += read();
				lexState = 'decimalExponentInteger';
				return;
			}
			throw invalidChar(read());
		},
		decimalExponentInteger: function () {
			if (util.isDigit(c)) {
				buffer += read();
				return;
			}
			return newToken('numeric', sign * Number(buffer));
		},
		hexadecimal: function () {
			if (util.isHexDigit(c)) {
				buffer += read();
				lexState = 'hexadecimalInteger';
				return;
			}
			throw invalidChar(read());
		},
		hexadecimalInteger: function () {
			if (util.isHexDigit(c)) {
				buffer += read();
				return;
			}
			return newToken('numeric', sign * Number(buffer));
		},
		string: function () {
			switch (c) {
				case '\\':
					read();
					buffer += escape();
					return;
				case '"':
					if (doubleQuote) {
						read();
						return newToken('string', buffer);
					}
					buffer += read();
					return;
				case "'":
					if (!doubleQuote) {
						read();
						return newToken('string', buffer);
					}
					buffer += read();
					return;
				case '\n':
				case '\r':
					throw invalidChar(read());
				case '\u2028':
				case '\u2029':
					separatorChar(c);
					break;
				case undefined:
					throw invalidChar(read());
			}
			buffer += read();
		},
		start: function () {
			switch (c) {
				case '{':
				case '[':
					return newToken('punctuator', read());
			}
			lexState = 'value';
		},
		beforePropertyName: function () {
			switch (c) {
				case '$':
				case '_':
					buffer = read();
					lexState = 'identifierName';
					return;
				case '\\':
					read();
					lexState = 'identifierNameStartEscape';
					return;
				case '}':
					return newToken('punctuator', read());
				case '"':
				case "'":
					doubleQuote = (read() === '"');
					lexState = 'string';
					return;
			}
			if (util.isIdStartChar(c)) {
				buffer += read();
				lexState = 'identifierName';
				return;
			}
			throw invalidChar(read());
		},
		afterPropertyName: function () {
			if (c === ':') {
				return newToken('punctuator', read());
			}
			throw invalidChar(read());
		},
		beforePropertyValue: function () {
			lexState = 'value';
		},
		afterPropertyValue: function () {
			switch (c) {
				case ',':
				case '}':
					return newToken('punctuator', read());
			}
			throw invalidChar(read());
		},
		beforeArrayValue: function () {
			if (c === ']') {
				return newToken('punctuator', read());
			}
			lexState = 'value';
		},
		afterArrayValue: function () {
			switch (c) {
				case ',':
				case ']':
					return newToken('punctuator', read());
			}
			throw invalidChar(read());
		},
		end: function () {
			throw invalidChar(read());
		}
	};
	function newToken(type, value) {
		return {
			type: type,
			value: value,
			line: line,
			column: column
		};
	}
	function literal(s) {
		for (var _i = 0, s_1 = s; _i < s_1.length; _i++) {
			var c_1 = s_1[_i];
			var p = peek();
			if (p !== c_1) {
				throw invalidChar(read());
			}
			read();
		}
	}
	function escape() {
		var c = peek();
		switch (c) {
			case 'b':
				read();
				return '\b';
			case 'f':
				read();
				return '\f';
			case 'n':
				read();
				return '\n';
			case 'r':
				read();
				return '\r';
			case 't':
				read();
				return '\t';
			case 'v':
				read();
				return '\v';
			case '0':
				read();
				if (util.isDigit(peek())) {
					throw invalidChar(read());
				}
				return '\0';
			case 'x':
				read();
				return hexEscape();
			case 'u':
				read();
				return unicodeEscape();
			case '\n':
			case '\u2028':
			case '\u2029':
				read();
				return '';
			case '\r':
				read();
				if (peek() === '\n') {
					read();
				}
				return '';
			case '1':
			case '2':
			case '3':
			case '4':
			case '5':
			case '6':
			case '7':
			case '8':
			case '9':
				throw invalidChar(read());
			case undefined:
				throw invalidChar(read());
		}
		return read();
	}
	function hexEscape() {
		var buffer = '';
		var c = peek();
		if (!util.isHexDigit(c)) {
			throw invalidChar(read());
		}
		buffer += read();
		c = peek();
		if (!util.isHexDigit(c)) {
			throw invalidChar(read());
		}
		buffer += read();
		return dstring.fromCodePoint(parseInt(buffer, 16));
	}
	function unicodeEscape() {
		var buffer = '';
		var count = 4;
		while (count-- > 0) {
			var c_2 = peek();
			if (!util.isHexDigit(c_2)) {
				throw invalidChar(read());
			}
			buffer += read();
		}
		return dstring.fromCodePoint(parseInt(buffer, 16));
	}
	var parseStates = {
		start: function () {
			if (token.type === 'eof') {
				throw invalidEOF();
			}
			push();
		},
		beforePropertyName: function () {
			switch (token.type) {
				case 'identifier':
				case 'string':
					key = token.value;
					parseState = 'afterPropertyName';
					return;
				case 'punctuator':
					pop();
					return;
				case 'eof':
					throw invalidEOF();
			}
		},
		afterPropertyName: function () {
			if (token.type === 'eof') {
				throw invalidEOF();
			}
			parseState = 'beforePropertyValue';
		},
		beforePropertyValue: function () {
			if (token.type === 'eof') {
				throw invalidEOF();
			}
			push();
		},
		beforeArrayValue: function () {
			if (token.type === 'eof') {
				throw invalidEOF();
			}
			if (token.type === 'punctuator' && token.value === ']') {
				pop();
				return;
			}
			push();
		},
		afterPropertyValue: function () {
			if (token.type === 'eof') {
				throw invalidEOF();
			}
			switch (token.value) {
				case ',':
					parseState = 'beforePropertyName';
					return;
				case '}':
					pop();
			}
		},
		afterArrayValue: function () {
			if (token.type === 'eof') {
				throw invalidEOF();
			}
			switch (token.value) {
				case ',':
					parseState = 'beforeArrayValue';
					return;
				case ']':
					pop();
			}
		},
		end: function () {
		}
	};
	function push() {
		var value;
		switch (token.type) {
			case 'punctuator':
				switch (token.value) {
					case '{':
						value = {};
						break;
					case '[':
						value = [];
						break;
				}
				break;
			case 'null':
			case 'boolean':
			case 'numeric':
			case 'string':
				value = token.value;
				break;
		}
		if (root === undefined) {
			root = value;
		}
		else {
			var parent_1 = stack[stack.length - 1];
			if (Array.isArray(parent_1)) {
				parent_1.push(value);
			}
			else {
				parent_1[key] = value;
			}
		}
		if (value !== null && typeof value === 'object') {
			stack.push(value);
			if (Array.isArray(value)) {
				parseState = 'beforeArrayValue';
			}
			else {
				parseState = 'beforePropertyName';
			}
		}
		else {
			var current = stack[stack.length - 1];
			if (current == null) {
				parseState = 'end';
			}
			else if (Array.isArray(current)) {
				parseState = 'afterArrayValue';
			}
			else {
				parseState = 'afterPropertyValue';
			}
		}
	}
	function pop() {
		stack.pop();
		var current = stack[stack.length - 1];
		if (current == null) {
			parseState = 'end';
		}
		else if (Array.isArray(current)) {
			parseState = 'afterArrayValue';
		}
		else {
			parseState = 'afterPropertyValue';
		}
	}
	function invalidChar(c) {
		if (c === undefined) {
			return syntaxError("JSON5: invalid end of input at " + line + ":" + column);
		}
		return syntaxError("JSON5: invalid character '" + formatChar(c) + "' at " + line + ":" + column);
	}
	function invalidEOF() {
		return syntaxError("JSON5: invalid end of input at " + line + ":" + column);
	}
	function invalidIdentifier() {
		column -= 5;
		return syntaxError("JSON5: invalid identifier character at " + line + ":" + column);
	}
	function separatorChar(c) {
		console.warn("JSON5: '" + formatChar(c) + "' in strings is not valid ECMAScript; consider escaping");
	}
	function formatChar(c) {
		var replacements = {
			"'": "\\'",
			'"': '\\"',
			'\\': '\\\\',
			'\b': '\\b',
			'\f': '\\f',
			'\n': '\\n',
			'\r': '\\r',
			'\t': '\\t',
			'\v': '\\v',
			'\0': '\\0',
			'\u2028': '\\u2028',
			'\u2029': '\\u2029'
		};
		if (replacements[c]) {
			return replacements[c];
		}
		if (c < ' ') {
			var hexString = c.charCodeAt(0).toString(16);
			return '\\x' + ('00' + hexString).substring(hexString.length);
		}
		return c;
	}
	function syntaxError(message) {
		var err = new SyntaxError(message);
		err.lineNumber = line;
		err.columnNumber = column;
		return err;
	}

	return parse;
});

},
'dojo/json5/util':function(){
define([
	'./unicode'
], function (unicode) {
	return {
		isSpaceSeparator: function (c) {
			return typeof c === 'string' && unicode.Space_Separator.test(c);
		},
		isIdStartChar: function (c) {
			return typeof c === 'string' && ((c >= 'a' && c <= 'z') ||
				(c >= 'A' && c <= 'Z') ||
				(c === '$') || (c === '_') ||
				unicode.ID_Start.test(c));
		},
		isIdContinueChar: function (c) {
			return typeof c === 'string' && ((c >= 'a' && c <= 'z') ||
				(c >= 'A' && c <= 'Z') ||
				(c >= '0' && c <= '9') ||
				(c === '$') || (c === '_') ||
				(c === '\u200C') || (c === '\u200D') ||
				unicode.ID_Continue.test(c));
		},
		isDigit: function (c) {
			return typeof c === 'string' && /[0-9]/.test(c);
		},
		isHexDigit: function (c) {
			return typeof c === 'string' && /[0-9A-Fa-f]/.test(c);
		},
	};
});

},
'dojo/json5/unicode':function(){
define({
	Space_Separator: /[\u1680\u2000-\u200A\u202F\u205F\u3000]/,
	ID_Start: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312E\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEA\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE83\uDE86-\uDE89\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0\uDFE1]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00-\uDD1E\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]/,
	ID_Continue: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u09FC\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9-\u0AFF\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D00-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF9\u1D00-\u1DF9\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312E\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEA\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF2D-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDCA-\uDDCC\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC00-\uDC4A\uDC50-\uDC59\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDE00-\uDE3E\uDE47\uDE50-\uDE83\uDE86-\uDE99\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC40\uDC50-\uDC59\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD47\uDD50-\uDD59]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F\uDFE0\uDFE1]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00-\uDD1E\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6\uDD00-\uDD4A\uDD50-\uDD59]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/
});

},
'dojo/query':function(){
define(["./_base/kernel", "./has", "./dom", "./on", "./_base/array", "./_base/lang", "./selector/_loader", "./selector/_loader!default"],
	function(dojo, has, dom, on, array, lang, loader, defaultEngine){

	"use strict";

	has.add("array-extensible", function(){
		// test to see if we can extend an array (not supported in old IE)
		return lang.delegate([], {length: 1}).length == 1 && !has("bug-for-in-skips-shadowed");
	});
	
	var ap = Array.prototype, aps = ap.slice, apc = ap.concat, forEach = array.forEach;

	var tnl = function(/*Array*/ a, /*dojo/NodeList?*/ parent, /*Function?*/ NodeListCtor){
		// summary:
		//		decorate an array to make it look like a `dojo/NodeList`.
		// a:
		//		Array of nodes to decorate.
		// parent:
		//		An optional parent NodeList that generated the current
		//		list of nodes. Used to call _stash() so the parent NodeList
		//		can be accessed via end() later.
		// NodeListCtor:
		//		An optional constructor function to use for any
		//		new NodeList calls. This allows a certain chain of
		//		NodeList calls to use a different object than dojo/NodeList.
		var nodeList = new (NodeListCtor || this._NodeListCtor || nl)(a);
		return parent ? nodeList._stash(parent) : nodeList;
	};

	var loopBody = function(f, a, o){
		a = [0].concat(aps.call(a, 0));
		o = o || dojo.global;
		return function(node){
			a[0] = node;
			return f.apply(o, a);
		};
	};

	// adapters

	var adaptAsForEach = function(f, o){
		// summary:
		//		adapts a single node function to be used in the forEach-type
		//		actions. The initial object is returned from the specialized
		//		function.
		// f: Function
		//		a function to adapt
		// o: Object?
		//		an optional context for f
		return function(){
			this.forEach(loopBody(f, arguments, o));
			return this;	// Object
		};
	};

	var adaptAsMap = function(f, o){
		// summary:
		//		adapts a single node function to be used in the map-type
		//		actions. The return is a new array of values, as via `dojo/_base/array.map`
		// f: Function
		//		a function to adapt
		// o: Object?
		//		an optional context for f
		return function(){
			return this.map(loopBody(f, arguments, o));
		};
	};

	var adaptAsFilter = function(f, o){
		// summary:
		//		adapts a single node function to be used in the filter-type actions
		// f: Function
		//		a function to adapt
		// o: Object?
		//		an optional context for f
		return function(){
			return this.filter(loopBody(f, arguments, o));
		};
	};

	var adaptWithCondition = function(f, g, o){
		// summary:
		//		adapts a single node function to be used in the map-type
		//		actions, behaves like forEach() or map() depending on arguments
		// f: Function
		//		a function to adapt
		// g: Function
		//		a condition function, if true runs as map(), otherwise runs as forEach()
		// o: Object?
		//		an optional context for f and g
		return function(){
			var a = arguments, body = loopBody(f, a, o);
			if(g.call(o || dojo.global, a)){
				return this.map(body);	// self
			}
			this.forEach(body);
			return this;	// self
		};
	};

	var NodeList = function(array){
		// summary:
		//		Array-like object which adds syntactic
		//		sugar for chaining, common iteration operations, animation, and
		//		node manipulation. NodeLists are most often returned as the
		//		result of dojo/query() calls.
		// description:
		//		NodeList instances provide many utilities that reflect
		//		core Dojo APIs for Array iteration and manipulation, DOM
		//		manipulation, and event handling. Instead of needing to dig up
		//		functions in the dojo package, NodeLists generally make the
		//		full power of Dojo available for DOM manipulation tasks in a
		//		simple, chainable way.
		// example:
		//		create a node list from a node
		//		|	require(["dojo/query", "dojo/dom"
		//		|	], function(query, dom){
		//		|		query.NodeList(dom.byId("foo"));
		//		|	});
		// example:
		//		get a NodeList from a CSS query and iterate on it
		//		|	require(["dojo/on", "dojo/dom"
		//		|	], function(on, dom){
		//		|		var l = query(".thinger");
		//		|		l.forEach(function(node, index, nodeList){
		//		|			console.log(index, node.innerHTML);
		//		|		});
		//		|	});
		// example:
		//		use native and Dojo-provided array methods to manipulate a
		//		NodeList without needing to use dojo.* functions explicitly:
		//		|	require(["dojo/query", "dojo/dom-construct", "dojo/dom"
		//		|	], function(query, domConstruct, dom){
		//		|		var l = query(".thinger");
		//		|		// since NodeLists are real arrays, they have a length
		//		|		// property that is both readable and writable and
		//		|		// push/pop/shift/unshift methods
		//		|		console.log(l.length);
		//		|		l.push(domConstruct.create("span"));
		//		|
		//		|		// dojo's normalized array methods work too:
		//		|		console.log( l.indexOf(dom.byId("foo")) );
		//		|		// ...including the special "function as string" shorthand
		//		|		console.log( l.every("item.nodeType == 1") );
		//		|
		//		|		// NodeLists can be [..] indexed, or you can use the at()
		//		|		// function to get specific items wrapped in a new NodeList:
		//		|		var node = l[3]; // the 4th element
		//		|		var newList = l.at(1, 3); // the 2nd and 4th elements
		//		|	});
		// example:
		//		chainability is a key advantage of NodeLists:
		//		|	require(["dojo/query", "dojo/NodeList-dom"
		//		|	], function(query){
		//		|		query(".thinger")
		//		|			.onclick(function(e){ /* ... */ })
		//		|			.at(1, 3, 8) // get a subset
		//		|				.style("padding", "5px")
		//		|				.forEach(console.log);
		//		|	});

		var isNew = this instanceof nl && has("array-extensible");
		if(typeof array == "number"){
			array = Array(array);
		}
		var nodeArray = (array && "length" in array) ? array : arguments;
		if(isNew || !nodeArray.sort){
			// make sure it's a real array before we pass it on to be wrapped 
			var target = isNew ? this : [],
				l = target.length = nodeArray.length;
			for(var i = 0; i < l; i++){
				target[i] = nodeArray[i];
			}
			if(isNew){
				// called with new operator, this means we are going to use this instance and push
				// the nodes on to it. This is usually much faster since the NodeList properties
				//	don't need to be copied (unless the list of nodes is extremely large).
				return target;
			}
			nodeArray = target;
		}
		// called without new operator, use a real array and copy prototype properties,
		// this is slower and exists for back-compat. Should be removed in 2.0.
		lang._mixin(nodeArray, nlp);
		nodeArray._NodeListCtor = function(array){
			// call without new operator to preserve back-compat behavior
			return nl(array);
		};
		return nodeArray;
	};
	
	var nl = NodeList, nlp = nl.prototype = 
		has("array-extensible") ? [] : {};// extend an array if it is extensible

	// expose adapters and the wrapper as private functions

	nl._wrap = nlp._wrap = tnl;
	nl._adaptAsMap = adaptAsMap;
	nl._adaptAsForEach = adaptAsForEach;
	nl._adaptAsFilter  = adaptAsFilter;
	nl._adaptWithCondition = adaptWithCondition;

	// mass assignment

	// add array redirectors
	forEach(["slice", "splice"], function(name){
		var f = ap[name];
		//Use a copy of the this array via this.slice() to allow .end() to work right in the splice case.
		// CANNOT apply ._stash()/end() to splice since it currently modifies
		// the existing this array -- it would break backward compatibility if we copy the array before
		// the splice so that we can use .end(). So only doing the stash option to this._wrap for slice.
		nlp[name] = function(){ return this._wrap(f.apply(this, arguments), name == "slice" ? this : null); };
	});
	// concat should be here but some browsers with native NodeList have problems with it

	// add array.js redirectors
	forEach(["indexOf", "lastIndexOf", "every", "some"], function(name){
		var f = array[name];
		nlp[name] = function(){ return f.apply(dojo, [this].concat(aps.call(arguments, 0))); };
	});

	lang.extend(NodeList, {
		// copy the constructors
		constructor: nl,
		_NodeListCtor: nl,
		toString: function(){
			// Array.prototype.toString can't be applied to objects, so we use join
			return this.join(",");
		},
		_stash: function(parent){
			// summary:
			//		private function to hold to a parent NodeList. end() to return the parent NodeList.
			//
			// example:
			//		How to make a `dojo/NodeList` method that only returns the third node in
			//		the dojo/NodeList but allows access to the original NodeList by using this._stash:
			//	|	require(["dojo/query", "dojo/_base/lang", "dojo/NodeList", "dojo/NodeList-dom"
			//	|	], function(query, lang){
			//	|		lang.extend(NodeList, {
			//	|			third: function(){
			//	|				var newNodeList = NodeList(this[2]);
			//	|				return newNodeList._stash(this);
			//	|			}
			//	|		});
			//	|		// then see how _stash applies a sub-list, to be .end()'ed out of
			//	|		query(".foo")
			//	|			.third()
			//	|				.addClass("thirdFoo")
			//	|			.end()
			//	|			// access to the orig .foo list
			//	|			.removeClass("foo")
			//	|	});
			//
			this._parent = parent;
			return this; // dojo/NodeList
		},

		on: function(eventName, listener){
			// summary:
			//		Listen for events on the nodes in the NodeList. Basic usage is:
			//
			// example:
			//		|	require(["dojo/query"
			//		|	], function(query){
			//		|		query(".my-class").on("click", listener);
			//			This supports event delegation by using selectors as the first argument with the event names as
			//			pseudo selectors. For example:
			//		| 		query("#my-list").on("li:click", listener);
			//			This will listen for click events within `<li>` elements that are inside the `#my-list` element.
			//			Because on supports CSS selector syntax, we can use comma-delimited events as well:
			//		| 		query("#my-list").on("li button:mouseover, li:click", listener);
			//		|	});
			var handles = this.map(function(node){
				return on(node, eventName, listener); // TODO: apply to the NodeList so the same selector engine is used for matches
			});
			handles.remove = function(){
				for(var i = 0; i < handles.length; i++){
					handles[i].remove();
				}
			};
			return handles;
		},

		end: function(){
			// summary:
			//		Ends use of the current `NodeList` by returning the previous NodeList
			//		that generated the current NodeList.
			// description:
			//		Returns the `NodeList` that generated the current `NodeList`. If there
			//		is no parent NodeList, an empty NodeList is returned.
			// example:
			//	|	require(["dojo/query", "dojo/NodeList-dom"
			//	|	], function(query){
			//	|		query("a")
			//	|			.filter(".disabled")
			//	|				// operate on the anchors that only have a disabled class
			//	|				.style("color", "grey")
			//	|			.end()
			//	|			// jump back to the list of anchors
			//	|			.style(...)
			//	|	});
			//
			if(this._parent){
				return this._parent;
			}else{
				//Just return empty list.
				return new this._NodeListCtor(0);
			}
		},

		// http://developer.mozilla.org/en/docs/Core_JavaScript_1.5_Reference:Global_Objects:Array#Methods

		// FIXME: handle return values for #3244
		//		http://trac.dojotoolkit.org/ticket/3244

		// FIXME:
		//		need to wrap or implement:
		//			join (perhaps w/ innerHTML/outerHTML overload for toString() of items?)
		//			reduce
		//			reduceRight

		/*=====
		slice: function(begin, end){
			// summary:
			//		Returns a new NodeList, maintaining this one in place
			// description:
			//		This method behaves exactly like the Array.slice method
			//		with the caveat that it returns a `dojo/NodeList` and not a
			//		raw Array. For more details, see Mozilla's [slice
			//		documentation](https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/slice)
			// begin: Integer
			//		Can be a positive or negative integer, with positive
			//		integers noting the offset to begin at, and negative
			//		integers denoting an offset from the end (i.e., to the left
			//		of the end)
			// end: Integer?
			//		Optional parameter to describe what position relative to
			//		the NodeList's zero index to end the slice at. Like begin,
			//		can be positive or negative.
			return this._wrap(a.slice.apply(this, arguments));
		},

		splice: function(index, howmany, item){
			// summary:
			//		Returns a new NodeList, manipulating this NodeList based on
			//		the arguments passed, potentially splicing in new elements
			//		at an offset, optionally deleting elements
			// description:
			//		This method behaves exactly like the Array.splice method
			//		with the caveat that it returns a `dojo/NodeList` and not a
			//		raw Array. For more details, see Mozilla's [splice
			//		documentation](https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/splice)
			//		For backwards compatibility, calling .end() on the spliced NodeList
			//		does not return the original NodeList -- splice alters the NodeList in place.
			// index: Integer
			//		begin can be a positive or negative integer, with positive
			//		integers noting the offset to begin at, and negative
			//		integers denoting an offset from the end (i.e., to the left
			//		of the end)
			// howmany: Integer?
			//		Optional parameter to describe what position relative to
			//		the NodeList's zero index to end the slice at. Like begin,
			//		can be positive or negative.
			// item: Object...?
			//		Any number of optional parameters may be passed in to be
			//		spliced into the NodeList
			return this._wrap(a.splice.apply(this, arguments));	// dojo/NodeList
		},

		indexOf: function(value, fromIndex){
			// summary:
			//		see `dojo/_base/array.indexOf()`. The primary difference is that the acted-on
			//		array is implicitly this NodeList
			// value: Object
			//		The value to search for.
			// fromIndex: Integer?
			//		The location to start searching from. Optional. Defaults to 0.
			// description:
			//		For more details on the behavior of indexOf, see Mozilla's
			//		[indexOf
			//		docs](https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/indexOf)
			// returns:
			//		Positive Integer or 0 for a match, -1 of not found.
			return d.indexOf(this, value, fromIndex); // Integer
		},

		lastIndexOf: function(value, fromIndex){
			// summary:
			//		see `dojo/_base/array.lastIndexOf()`. The primary difference is that the
			//		acted-on array is implicitly this NodeList
			// description:
			//		For more details on the behavior of lastIndexOf, see
			//		Mozilla's [lastIndexOf
			//		docs](https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/lastIndexOf)
			// value: Object
			//		The value to search for.
			// fromIndex: Integer?
			//		The location to start searching from. Optional. Defaults to 0.
			// returns:
			//		Positive Integer or 0 for a match, -1 of not found.
			return d.lastIndexOf(this, value, fromIndex); // Integer
		},

		every: function(callback, thisObject){
			// summary:
			//		see `dojo/_base/array.every()` and the [Array.every
			//		docs](https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/every).
			//		Takes the same structure of arguments and returns as
			//		dojo/_base/array.every() with the caveat that the passed array is
			//		implicitly this NodeList
			// callback: Function
			//		the callback
			// thisObject: Object?
			//		the context
			return d.every(this, callback, thisObject); // Boolean
		},

		some: function(callback, thisObject){
			// summary:
			//		Takes the same structure of arguments and returns as
			//		`dojo/_base/array.some()` with the caveat that the passed array is
			//		implicitly this NodeList.  See `dojo/_base/array.some()` and Mozilla's
			//		[Array.some
			//		documentation](https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/some).
			// callback: Function
			//		the callback
			// thisObject: Object?
			//		the context
			return d.some(this, callback, thisObject); // Boolean
		},
		=====*/

		concat: function(item){
			// summary:
			//		Returns a new NodeList comprised of items in this NodeList
			//		as well as items passed in as parameters
			// description:
			//		This method behaves exactly like the Array.concat method
			//		with the caveat that it returns a `NodeList` and not a
			//		raw Array. For more details, see the [Array.concat
			//		docs](https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/concat)
			// item: Object?
			//		Any number of optional parameters may be passed in to be
			//		spliced into the NodeList

			//return this._wrap(apc.apply(this, arguments));
			// the line above won't work for the native NodeList, or for Dojo NodeLists either :-(

			// implementation notes:
			// Array.concat() doesn't recognize native NodeLists or Dojo NodeLists
			// as arrays, and so does not inline them into a unioned array, but
			// appends them as single entities. Both the original NodeList and the
			// items passed in as parameters must be converted to raw Arrays
			// and then the concatenation result may be re-_wrap()ed as a Dojo NodeList.

			var t = aps.call(this, 0),
				m = array.map(arguments, function(a){
					return aps.call(a, 0);
				});
			return this._wrap(apc.apply(t, m), this);	// dojo/NodeList
		},

		map: function(/*Function*/ func, /*Function?*/ obj){
			// summary:
			//		see `dojo/_base/array.map()`. The primary difference is that the acted-on
			//		array is implicitly this NodeList and the return is a
			//		NodeList (a subclass of Array)
			return this._wrap(array.map(this, func, obj), this); // dojo/NodeList
		},

		forEach: function(callback, thisObj){
			// summary:
			//		see `dojo/_base/array.forEach()`. The primary difference is that the acted-on
			//		array is implicitly this NodeList. If you want the option to break out
			//		of the forEach loop, use every() or some() instead.
			forEach(this, callback, thisObj);
			// non-standard return to allow easier chaining
			return this; // dojo/NodeList
		},
		filter: function(/*String|Function*/ filter){
			// summary:
			//		"masks" the built-in javascript filter() method (supported
			//		in Dojo via `dojo/_base/array.filter`) to support passing a simple
			//		string filter in addition to supporting filtering function
			//		objects.
			// filter:
			//		If a string, a CSS rule like ".thinger" or "div > span".
			// example:
			//		"regular" JS filter syntax as exposed in `dojo/_base/array.filter`:
			//		|	require(["dojo/query", "dojo/NodeList-dom"
			//		|	], function(query){
			//		|		query("*").filter(function(item){
			//		|			// highlight every paragraph
			//		|			return (item.nodeName == "p");
			//		|		}).style("backgroundColor", "yellow");
			//		|	});
			// example:
			//		the same filtering using a CSS selector
			//		|	require(["dojo/query", "dojo/NodeList-dom"
			//		|	], function(query){
			//		|		query("*").filter("p").styles("backgroundColor", "yellow");
			//		|	});

			var a = arguments, items = this, start = 0;
			if(typeof filter == "string"){ // inline'd type check
				items = query._filterResult(this, a[0]);
				if(a.length == 1){
					// if we only got a string query, pass back the filtered results
					return items._stash(this); // dojo/NodeList
				}
				// if we got a callback, run it over the filtered items
				start = 1;
			}
			return this._wrap(array.filter(items, a[start], a[start + 1]), this);	// dojo/NodeList
		},
		instantiate: function(/*String|Object*/ declaredClass, /*Object?*/ properties){
			// summary:
			//		Create a new instance of a specified class, using the
			//		specified properties and each node in the NodeList as a
			//		srcNodeRef.
			// example:
			//		Grabs all buttons in the page and converts them to dijit/form/Button's.
			//	|	var buttons = query("button").instantiate(Button, {showLabel: true});
			var c = lang.isFunction(declaredClass) ? declaredClass : lang.getObject(declaredClass);
			properties = properties || {};
			return this.forEach(function(node){
				new c(properties, node);
			});	// dojo/NodeList
		},
		at: function(/*===== index =====*/){
			// summary:
			//		Returns a new NodeList comprised of items in this NodeList
			//		at the given index or indices.
			//
			// index: Integer...
			//		One or more 0-based indices of items in the current
			//		NodeList. A negative index will start at the end of the
			//		list and go backwards.
			//
			// example:
			//	Shorten the list to the first, second, and third elements
			//	|	require(["dojo/query"
			//	|	], function(query){
			//	|		query("a").at(0, 1, 2).forEach(fn);
			//	|	});
			//
			// example:
			//	Retrieve the first and last elements of a unordered list:
			//	|	require(["dojo/query"
			//	|	], function(query){
			//	|		query("ul > li").at(0, -1).forEach(cb);
			//	|	});
			//
			// example:
			//	Do something for the first element only, but end() out back to
			//	the original list and continue chaining:
			//	|	require(["dojo/query"
			//	|	], function(query){
			//	|		query("a").at(0).onclick(fn).end().forEach(function(n){
			//	|			console.log(n); // all anchors on the page.
			//	|	})
			//	|	});

			var t = new this._NodeListCtor(0);
			forEach(arguments, function(i){
				if(i < 0){ i = this.length + i; }
				if(this[i]){ t.push(this[i]); }
			}, this);
			return t._stash(this); // dojo/NodeList
		}
	});

	function queryForEngine(engine, NodeList){
		var query = function(/*String*/ query, /*String|DOMNode?*/ root){
			// summary:
			//		Returns nodes which match the given CSS selector, searching the
			//		entire document by default but optionally taking a node to scope
			//		the search by. Returns an instance of NodeList.
			if(typeof root == "string"){
				root = dom.byId(root);
				if(!root){
					return new NodeList([]);
				}
			}
			var results = typeof query == "string" ? engine(query, root) : query ? (query.end && query.on) ? query : [query] : [];
			if(results.end && results.on){
				// already wrapped
				return results;
			}
			return new NodeList(results);
		};
		query.matches = engine.match || function(node, selector, root){
			// summary:
			//		Test to see if a node matches a selector
			return query.filter([node], selector, root).length > 0;
		};
		// the engine provides a filtering function, use it to for matching
		query.filter = engine.filter || function(nodes, selector, root){
			// summary:
			//		Filters an array of nodes. Note that this does not guarantee to return a NodeList, just an array.
			return query(selector, root).filter(function(node){
				return array.indexOf(nodes, node) > -1;
			});
		};
		if(typeof engine != "function"){
			var search = engine.search;
			engine = function(selector, root){
				// Slick does it backwards (or everyone else does it backwards, probably the latter)
				return search(root || document, selector);
			};
		}
		return query;
	}
	var query = queryForEngine(defaultEngine, NodeList);
	/*=====
	query = function(selector, context){
		// summary:
		//		This modules provides DOM querying functionality. The module export is a function
		//		that can be used to query for DOM nodes by CSS selector and returns a NodeList
		//		representing the matching nodes.
		// selector: String
		//		A CSS selector to search for.
		// context: String|DomNode?
		//		An optional context to limit the searching scope. Only nodes under `context` will be
		//		scanned.
		// example:
		//		add an onclick handler to every submit button in the document
		//		which causes the form to be sent via Ajax instead:
		//	|	require(["dojo/query", "dojo/request", "dojo/dom-form", "dojo/dom-construct", "dojo/dom-style"
		//	|	], function(query, request, domForm, domConstruct, domStyle){
		//	|		query("input[type='submit']").on("click", function(e){
		//	|			e.preventDefault(); // prevent sending the form
		//	|			var btn = e.target;
		//	|			request.post("http://example.com/", {
		//	|				data: domForm.toObject(btn.form)
		//	|			}).then(function(response){
		//	|				// replace the form with the response
		//	|				domConstruct.create(div, {innerHTML: response}, btn.form, "after");
		//	|				domStyle.set(btn.form, "display", "none");
		//	|			});
		//	|		});
		//	|	});
		//
		// description:
		//		dojo/query is responsible for loading the appropriate query engine and wrapping
		//		its results with a `NodeList`. You can use dojo/query with a specific selector engine
		//		by using it as a plugin. For example, if you installed the sizzle package, you could
		//		use it as the selector engine with:
		//		|	require(["dojo/query!sizzle"], function(query){
		//		|		query("div")...
		//
		//		The id after the ! can be a module id of the selector engine or one of the following values:
		//
		//		- acme: This is the default engine used by Dojo base, and will ensure that the full
		//		Acme engine is always loaded.
		//
		//		- css2: If the browser has a native selector engine, this will be used, otherwise a
		//		very minimal lightweight selector engine will be loaded that can do simple CSS2 selectors
		//		(by #id, .class, tag, and [name=value] attributes, with standard child or descendant (>)
		//		operators) and nothing more.
		//
		//		- css2.1: If the browser has a native selector engine, this will be used, otherwise the
		//		full Acme engine will be loaded.
		//
		//		- css3: If the browser has a native selector engine with support for CSS3 pseudo
		//		selectors (most modern browsers except IE8), this will be used, otherwise the
		//		full Acme engine will be loaded.
		//
		//		- Or the module id of a selector engine can be used to explicitly choose the selector engine
		//
		//		For example, if you are using CSS3 pseudo selectors in module, you can specify that
		//		you will need support them with:
		//		|	require(["dojo/query!css3"], function(query){
		//		|		query('#t > h3:nth-child(odd)')...
		//
		//		You can also choose the selector engine/load configuration by setting the query-selector:
		//		For example:
		//		|	<script data-dojo-config="query-selector:'css3'" src="dojo.js"></script>
		//
		return new NodeList(); // dojo/NodeList
	 };
	 =====*/

	// the query that is returned from this module is slightly different than dojo.query,
	// because dojo.query has to maintain backwards compatibility with returning a
	// true array which has performance problems. The query returned from the module
	// does not use true arrays, but rather inherits from Array, making it much faster to
	// instantiate.
	dojo.query = queryForEngine(defaultEngine, function(array){
		// call it without the new operator to invoke the back-compat behavior that returns a true array
		return NodeList(array);	// dojo/NodeList
	});

	query.load = function(id, parentRequire, loaded){
		// summary:
		//		can be used as AMD plugin to conditionally load new query engine
		// example:
		//	|	require(["dojo/query!custom"], function(qsa){
		//	|		// loaded selector/custom.js as engine
		//	|		qsa("#foobar").forEach(...);
		//	|	});
		loader.load(id, parentRequire, function(engine){
			loaded(queryForEngine(engine, NodeList));
		});
	};

	dojo._filterQueryResult = query._filterResult = function(nodes, selector, root){
		return new NodeList(query.filter(nodes, selector, root));
	};
	dojo.NodeList = query.NodeList = NodeList;
	return query;
});

},
'dojo/selector/lite':function(){
define(["../has", "../_base/kernel"], function(has, dojo){
"use strict";

var testDiv = document.createElement("div");
var matchesSelector = testDiv.matches || testDiv.webkitMatchesSelector || testDiv.mozMatchesSelector || testDiv.msMatchesSelector || testDiv.oMatchesSelector;
var querySelectorAll = testDiv.querySelectorAll;
var unionSplit = /([^\s,](?:"(?:\\.|[^"])+"|'(?:\\.|[^'])+'|[^,])*)/g;
has.add("dom-matches-selector", !!matchesSelector);
has.add("dom-qsa", !!querySelectorAll); 

// this is a simple query engine. It has handles basic selectors, and for simple
// common selectors is extremely fast
var liteEngine = function(selector, root){
	// summary:
	//		A small lightweight query selector engine that implements CSS2.1 selectors
	//		minus pseudo-classes and the sibling combinator, plus CSS3 attribute selectors

	if(combine && selector.indexOf(',') > -1){
		return combine(selector, root);
	}
	// use the root's ownerDocument if provided, otherwise try to use dojo.doc. Note 
	// that we don't use dojo/_base/window's doc to reduce dependencies, and 
	// fallback to plain document if dojo.doc hasn't been defined (by dojo/_base/window).
	// presumably we will have a better way to do this in 2.0 
	var doc = root ? root.ownerDocument || root : dojo.doc || document, 
		match = (querySelectorAll ? 
			/^([\w]*)#([\w\-]+$)|^(\.)([\w\-\*]+$)|^(\w+$)/ : // this one only matches on simple queries where we can beat qSA with specific methods
			/^([\w]*)#([\w\-]+)(?:\s+(.*))?$|(?:^|(>|.+\s+))([\w\-\*]+)(\S*$)/) // this one matches parts of the query that we can use to speed up manual filtering
			.exec(selector);
	root = root || doc;
	if(match){
		var isInsideDomTree = has('ie') === 8 && has('quirks')?
			root.nodeType === doc.nodeType:
			root.parentNode !== null && root.nodeType !== 9 && root.parentNode === doc;

		// fast path regardless of whether or not querySelectorAll exists
		if(match[2] && isInsideDomTree){
			// an #id
			// use dojo.byId if available as it fixes the id retrieval in IE, note that we can't use the dojo namespace in 2.0, but if there is a conditional module use, we will use that
			var found = dojo.byId ? dojo.byId(match[2], doc) : doc.getElementById(match[2]);
			if(!found || (match[1] && match[1] != found.tagName.toLowerCase())){
				// if there is a tag qualifer and it doesn't match, no matches
				return [];
			}
			if(root != doc){
				// there is a root element, make sure we are a child of it
				var parent = found;
				while(parent != root){
					parent = parent.parentNode;
					if(!parent){
						return [];
					}
				}
			}
			return match[3] ?
					liteEngine(match[3], found) 
					: [found];
		}
		if(match[3] && root.getElementsByClassName){
			// a .class
			return root.getElementsByClassName(match[4]);
		}
		var found;
		if(match[5]){
			// a tag
			found = root.getElementsByTagName(match[5]);
			if(match[4] || match[6]){
				selector = (match[4] || "") + match[6];
			}else{
				// that was the entirety of the query, return results
				return found;
			}
		}
	}
	if(querySelectorAll){
		// qSA works strangely on Element-rooted queries
		// We can work around this by specifying an extra ID on the root
		// and working up from there (Thanks to Andrew Dupont for the technique)
		// IE 8 doesn't work on object elements
		if (root.nodeType === 1 && root.nodeName.toLowerCase() !== "object"){				
			return useRoot(root, selector, root.querySelectorAll);
		}else{
			// we can use the native qSA
			return root.querySelectorAll(selector);
		}
	}else if(!found){
		// search all children and then filter
		found = root.getElementsByTagName("*");
	}
	// now we filter the nodes that were found using the matchesSelector
	var results = [];
	for(var i = 0, l = found.length; i < l; i++){
		var node = found[i];
		if(node.nodeType == 1 && jsMatchesSelector(node, selector, root)){
			// keep the nodes that match the selector
			results.push(node);
		}
	}
	return results;
};
var useRoot = function(context, query, method){
	// this function creates a temporary id so we can do rooted qSA queries, this is taken from sizzle
	var oldContext = context,
		old = context.getAttribute("id"),
		nid = old || "__dojo__",
		hasParent = context.parentNode,
		relativeHierarchySelector = /^\s*[+~]/.test(query);

	if(relativeHierarchySelector && !hasParent){
		return [];
	}
	if(!old){
		context.setAttribute("id", nid);
	}else{
		nid = nid.replace(/'/g, "\\$&");
	}
	if(relativeHierarchySelector && hasParent){
		context = context.parentNode;
	}
	var selectors = query.match(unionSplit);
	for(var i = 0; i < selectors.length; i++){
		selectors[i] = "[id='" + nid + "'] " + selectors[i];
	}
	query = selectors.join(",");

	try{
		return method.call(context, query);
	}finally{
		if(!old){
			oldContext.removeAttribute("id");
		}
	}
};

if(!has("dom-matches-selector")){
	var jsMatchesSelector = (function(){
		// a JS implementation of CSS selector matching, first we start with the various handlers
		var caseFix = testDiv.tagName == "div" ? "toLowerCase" : "toUpperCase";
		var selectorTypes = {
			"": function(tagName){
				tagName = tagName[caseFix]();
				return function(node){
					return node.tagName == tagName;
				};
			},
			".": function(className){
				var classNameSpaced = ' ' + className + ' ';
				return function(node){
					return node.className.indexOf(className) > -1 && (' ' + node.className + ' ').indexOf(classNameSpaced) > -1;
				};
			},
			"#": function(id){
				return function(node){
					return node.id == id;
				};
			}
		};
		var attrComparators = {
			"^=": function(attrValue, value){
				return attrValue.indexOf(value) == 0;
			},
			"*=": function(attrValue, value){
				return attrValue.indexOf(value) > -1;
			},
			"$=": function(attrValue, value){
				return attrValue.substring(attrValue.length - value.length, attrValue.length) == value;
			},
			"~=": function(attrValue, value){
				return (' ' + attrValue + ' ').indexOf(' ' + value + ' ') > -1;
			},
			"|=": function(attrValue, value){
				return (attrValue + '-').indexOf(value + '-') == 0;
			},
			"=": function(attrValue, value){
				return attrValue == value;
			},
			"": function(attrValue, value){
				return true;
			}
		};
		function attr(name, value, type){
			var firstChar = value.charAt(0);
			if(firstChar == '"' || firstChar == "'"){
				// it is quoted, remove the quotes
				value = value.slice(1, -1);
			}
			value = value.replace(/\\/g,'');
			var comparator = attrComparators[type || ""];
			return function(node){
				var attrValue = node.getAttribute(name);
				return attrValue && comparator(attrValue, value);
			};
		}
		function ancestor(matcher){
			return function(node, root){
				while((node = node.parentNode) != root){
					if(matcher(node, root)){
						return true;
					}
				}
			};
		}
		function parent(matcher){
			return function(node, root){
				node = node.parentNode;
				return matcher ? 
					node != root && matcher(node, root)
					: node == root;
			};
		}
		var cache = {};
		function and(matcher, next){
			return matcher ?
				function(node, root){
					return next(node) && matcher(node, root);
				}
				: next;
		}
		return function(node, selector, root){
			// this returns true or false based on if the node matches the selector (optionally within the given root)
			var matcher = cache[selector]; // check to see if we have created a matcher function for the given selector
			if(!matcher){
				// create a matcher function for the given selector
				// parse the selectors
				if(selector.replace(/(?:\s*([> ])\s*)|(#|\.)?((?:\\.|[\w-])+)|\[\s*([\w-]+)\s*(.?=)?\s*("(?:\\.|[^"])+"|'(?:\\.|[^'])+'|(?:\\.|[^\]])*)\s*\]/g, function(t, combinator, type, value, attrName, attrType, attrValue){
					if(value){
						matcher = and(matcher, selectorTypes[type || ""](value.replace(/\\/g, '')));
					}
					else if(combinator){
						matcher = (combinator == " " ? ancestor : parent)(matcher);
					}
					else if(attrName){
						matcher = and(matcher, attr(attrName, attrValue, attrType));
					}
					return "";
				})){
					throw new Error("Syntax error in query");
				}
				if(!matcher){
					return true;
				}
				cache[selector] = matcher;
			}
			// now run the matcher function on the node
			return matcher(node, root);
		};
	})();
}
if(!has("dom-qsa")){
	var combine = function(selector, root){
		// combined queries
		var selectors = selector.match(unionSplit);
		var indexed = [];
		// add all results and keep unique ones, this only runs in IE, so we take advantage 
		// of known IE features, particularly sourceIndex which is unique and allows us to 
		// order the results 
		for(var i = 0; i < selectors.length; i++){
			selector = new String(selectors[i].replace(/\s*$/,''));
			selector.indexOf = escape; // keep it from recursively entering combine
			var results = liteEngine(selector, root);
			for(var j = 0, l = results.length; j < l; j++){
				var node = results[j];
				indexed[node.sourceIndex] = node;
			}
		}
		// now convert from a sparse array to a dense array
		var totalResults = [];
		for(i in indexed){
			totalResults.push(indexed[i]);
		}
		return totalResults;
	};
}

liteEngine.match = matchesSelector ? function(node, selector, root){
	if(root && root.nodeType != 9){
		// doesn't support three args, use rooted id trick
		return useRoot(root, selector, function(query){
			return matchesSelector.call(node, query);
		});
	}
	// we have a native matchesSelector, use that
	return matchesSelector.call(node, selector);
} : jsMatchesSelector; // otherwise use the JS matches impl

return liteEngine;
});

},
'dojo/ready':function(){
define(["./_base/kernel", "./has", "require", "./domReady", "./_base/lang"], function(dojo, has, require, domReady, lang){
	// module:
	//		dojo/ready
	// note:
	//		This module should be unnecessary in dojo 2.0

	var
		// truthy if DOMContentLoaded or better (e.g., window.onload fired) has been achieved
		isDomReady = 0,

		// The queue of functions waiting to execute as soon as dojo.ready conditions satisfied
		loadQ = [],

		// prevent recursion in onLoad
		onLoadRecursiveGuard = 0,

		handleDomReady = function(){
			isDomReady = 1;
			dojo._postLoad = dojo.config.afterOnLoad = true;
			onEvent();
		},

		onEvent = function(){
			// Called when some state changes:
			//		- dom ready
			//		- dojo/domReady has finished processing everything in its queue
			//		- task added to loadQ
			//		- require() has finished loading all currently requested modules
			//
			// Run the functions queued with dojo.ready if appropriate.


			//guard against recursions into this function
			if(onLoadRecursiveGuard){
				return;
			}
			onLoadRecursiveGuard = 1;

			// Run tasks in queue if require() is finished loading modules, the dom is ready, and there are no
			// pending tasks registered via domReady().
			// The last step is necessary so that a user defined dojo.ready() callback is delayed until after the
			// domReady() calls inside of dojo.	  Failure can be seen on dijit/tests/robot/Dialog_ally.html on IE8
			// because the dijit/focus.js domReady() callback doesn't execute until after the test starts running.
			while(isDomReady && (!domReady || domReady._Q.length == 0) && (require.idle ? require.idle() : true) && loadQ.length){
				var f = loadQ.shift();
				try{
					f();
				}catch(e){
					// force the dojo.js on("error") handler do display the message
					e.info = e.message;
					if(require.signal){
						require.signal("error", e);
					}else{
						throw e;
					}
				}
			}

			onLoadRecursiveGuard = 0;
		};

	// Check if we should run the next queue operation whenever require() finishes loading modules or domReady
	// finishes processing it's queue.
	require.on && require.on("idle", onEvent);
	if(domReady){
		domReady._onQEmpty = onEvent;
	}

	var ready = dojo.ready = dojo.addOnLoad = function(priority, context, callback){
		// summary:
		//		Add a function to execute on DOM content loaded and all requested modules have arrived and been evaluated.
		//		In most cases, the `domReady` plug-in should suffice and this method should not be needed.
		//
		//		When called in a non-browser environment, just checks that all requested modules have arrived and been
		//		evaluated.
		// priority: Integer?
		//		The order in which to exec this callback relative to other callbacks, defaults to 1000
		// context: Object?|Function
		//		The context in which to run execute callback, or a callback if not using context
		// callback: Function?
		//		The function to execute.
		//
		// example:
		//	Simple DOM and Modules ready syntax
		//	|	require(["dojo/ready"], function(ready){
		//	|		ready(function(){ alert("Dom ready!"); });
		//	|	});
		//
		// example:
		//	Using a priority
		//	|	require(["dojo/ready"], function(ready){
		//	|		ready(2, function(){ alert("low priority ready!"); })
		//	|	});
		//
		// example:
		//	Using context
		//	|	require(["dojo/ready"], function(ready){
		//	|		ready(foo, function(){
		//	|			// in here, this == foo
		//	|		});
		//	|	});
		//
		// example:
		//	Using dojo/hitch style args:
		//	|	require(["dojo/ready"], function(ready){
		//	|		var foo = { dojoReady: function(){ console.warn(this, "dojo dom and modules ready."); } };
		//	|		ready(foo, "dojoReady");
		//	|	});

		var hitchArgs = lang._toArray(arguments);
		if(typeof priority != "number"){
			callback = context;
			context = priority;
			priority = 1000;
		}else{
			hitchArgs.shift();
		}
		callback = callback ?
			lang.hitch.apply(dojo, hitchArgs) :
			function(){
				context();
			};
		callback.priority = priority;
		for(var i = 0; i < loadQ.length && priority >= loadQ[i].priority; i++){}
		loadQ.splice(i, 0, callback);
		onEvent();
	};

	 1 || has.add("dojo-config-addOnLoad", 1);
	if( 1 ){
		var dca = dojo.config.addOnLoad;
		if(dca){
			ready[(lang.isArray(dca) ? "apply" : "call")](dojo, dca);
		}
	}

	if( 0  && dojo.config.parseOnLoad && !dojo.isAsync){
		ready(99, function(){
			if(!dojo.parser){
				dojo.deprecated("Add explicit require(['dojo/parser']);", "", "2.0");
				require(["dojo/parser"]);
			}
		});
	}

	if(domReady){
		domReady(handleDomReady);
	}else{
		handleDomReady();
	}

	return ready;
});

},
'dojo/hccss':function(){
define([
	"require",			// require, require.toUrl
	"./_base/config", // config.blankGif
	"./dom-class", // domClass.add
	"./dom-style", // domStyle.getComputedStyle
	"./has",
	"./domReady",
	"./_base/window" // win.body
], function(require, config, domClass, domStyle, has, domReady, win){

	// module:
	//		dojo/hccss

	/*=====
	return function(){
		// summary:
		//		Test if computer is in high contrast mode (i.e. if browser is not displaying background images).
		//		Defines `has("highcontrast")` and sets `dj_a11y` CSS class on `<body>` if machine is in high contrast mode.
		//		Returns `has()` method;
	};
	=====*/

	// Has() test for when background images aren't displayed.  Don't call has("highcontrast") before dojo/domReady!.
	has.add("highcontrast", function(){
		// note: if multiple documents, doesn't matter which one we use
		var div = win.doc.createElement("div");
		try{
			div.style.cssText = "border: 1px solid; border-color:red green; position: absolute; height: 5px; top: -999px;" +
				"background-image: url(\"" + (config.blankGif || require.toUrl("./resources/blank.gif")) + "\");";
			win.body().appendChild(div);

			var cs = domStyle.getComputedStyle(div),
				bkImg = cs.backgroundImage;
			return cs.borderTopColor == cs.borderRightColor ||
				(bkImg && (bkImg == "none" || bkImg == "url(invalid-url:)" ));
		}catch(e){
			console.warn("hccss: exception detecting high-contrast mode, document is likely hidden: " + e.toString());
			return false;
		}finally{
			if(has("ie") <= 8){
				div.outerHTML = "";		// prevent mixed-content warning, see http://support.microsoft.com/kb/925014
			}else{
				win.body().removeChild(div);
			}
		}
	});

	domReady(function(){
		if(has("highcontrast")){
			domClass.add(win.body(), "dj_a11y");
		}
	});

	return has;
});

},
'dojo/cache':function(){
define(["./_base/kernel", "./text"], function(dojo){
	// module:
	//		dojo/cache

	// dojo.cache is defined in dojo/text
	return dojo.cache;
});

},
'dojo/window':function(){
define(["./_base/lang", "./sniff", "./_base/window", "./dom", "./dom-geometry", "./dom-style", "./dom-construct"],
	function(lang, has, baseWindow, dom, geom, style, domConstruct){

	// feature detection
	/* not needed but included here for future reference
	has.add("rtl-innerVerticalScrollBar-on-left", function(win, doc){
		var	body = baseWindow.body(doc),
			scrollable = domConstruct.create('div', {
				style: {overflow:'scroll', overflowX:'hidden', direction:'rtl', visibility:'hidden', position:'absolute', left:'0', width:'64px', height:'64px'}
			}, body, "last"),
			center = domConstruct.create('center', {
				style: {overflow:'hidden', direction:'ltr'}
			}, scrollable, "last"),
			inner = domConstruct.create('div', {
				style: {overflow:'visible', display:'inline' }
			}, center, "last");
		inner.innerHTML="&nbsp;";
		var midPoint = Math.max(inner.offsetLeft, geom.position(inner).x);
		var ret = midPoint >= 32;
		center.removeChild(inner);
		scrollable.removeChild(center);
		body.removeChild(scrollable);
		return ret;
	});
	*/
	has.add("rtl-adjust-position-for-verticalScrollBar", function(win, doc){
		var	body = baseWindow.body(doc),
			scrollable = domConstruct.create('div', {
				style: {overflow:'scroll', overflowX:'visible', direction:'rtl', visibility:'hidden', position:'absolute', left:'0', top:'0', width:'64px', height:'64px'}
			}, body, "last"),
			div = domConstruct.create('div', {
				style: {overflow:'hidden', direction:'ltr'}
			}, scrollable, "last"),
			ret = geom.position(div).x != 0;
		scrollable.removeChild(div);
		body.removeChild(scrollable);
		return ret;
	});

	has.add("position-fixed-support", function(win, doc){
		// IE6, IE7+quirks, and some older mobile browsers don't support position:fixed
		var	body = baseWindow.body(doc),
			outer = domConstruct.create('span', {
				style: {visibility:'hidden', position:'fixed', left:'1px', top:'1px'}
			}, body, "last"),
			inner = domConstruct.create('span', {
				style: {position:'fixed', left:'0', top:'0'}
			}, outer, "last"),
			ret = geom.position(inner).x != geom.position(outer).x;
		outer.removeChild(inner);
		body.removeChild(outer);
		return ret;
	});

	// module:
	//		dojo/window

	var window = {
		// summary:
		//		TODOC

		getBox: function(/*Document?*/ doc){
			// summary:
			//		Returns the dimensions and scroll position of the viewable area of a browser window

			doc = doc || baseWindow.doc;

			var
				scrollRoot = (doc.compatMode == 'BackCompat') ? baseWindow.body(doc) : doc.documentElement,
				// get scroll position
				scroll = geom.docScroll(doc), // scrollRoot.scrollTop/Left should work
				w, h;

			if(has("touch")){ // if(scrollbars not supported)
				var uiWindow = window.get(doc);   // use UI window, not dojo.global window
				// on mobile, scrollRoot.clientHeight <= uiWindow.innerHeight <= scrollRoot.offsetHeight, return uiWindow.innerHeight
				w = uiWindow.innerWidth || scrollRoot.clientWidth; // || scrollRoot.clientXXX probably never evaluated
				h = uiWindow.innerHeight || scrollRoot.clientHeight;
			}else{
				// on desktops, scrollRoot.clientHeight <= scrollRoot.offsetHeight <= uiWindow.innerHeight, return scrollRoot.clientHeight
				// uiWindow.innerWidth/Height includes the scrollbar and cannot be used
				w = scrollRoot.clientWidth;
				h = scrollRoot.clientHeight;
			}
			return {
				l: scroll.x,
				t: scroll.y,
				w: w,
				h: h
			};
		},

		get: function(/*Document*/ doc){
			// summary:
			//		Get window object associated with document doc.
			// doc:
			//		The document to get the associated window for.

			// In some IE versions (at least 6.0), document.parentWindow does not return a
			// reference to the real window object (maybe a copy), so we must fix it as well
			// We use IE specific execScript to attach the real window reference to
			// document._parentWindow for later use
			if(has("ie") && window !== document.parentWindow){
				/*
				In IE 6, only the variable "window" can be used to connect events (others
				may be only copies).
				*/
				doc.parentWindow.execScript("document._parentWindow = window;", "Javascript");
				//to prevent memory leak, unset it after use
				//another possibility is to add an onUnload handler which seems overkill to me (liucougar)
				var win = doc._parentWindow;
				doc._parentWindow = null;
				return win;	//	Window
			}

			return doc.parentWindow || doc.defaultView;	//	Window
		},

		scrollIntoView: function(/*DomNode*/ node, /*Object?*/ pos){
			// summary:
			//		Scroll the passed node into view using minimal movement, if it is not already.

			// Don't rely on node.scrollIntoView working just because the function is there since
			// it forces the node to the page's bottom or top (and left or right in IE) without consideration for the minimal movement.
			// WebKit's node.scrollIntoViewIfNeeded doesn't work either for inner scrollbars in right-to-left mode
			// and when there's a fixed position scrollable element

			try{ // catch unexpected/unrecreatable errors (#7808) since we can recover using a semi-acceptable native method
				node = dom.byId(node);
				var	doc = node.ownerDocument || baseWindow.doc,	// TODO: why baseWindow.doc?  Isn't node.ownerDocument always defined?
					body = baseWindow.body(doc),
					html = doc.documentElement || body.parentNode,
					isIE = has("ie") || has("trident"),
					isWK = has("webkit");
				// if an untested browser, then use the native method
				if(node == body || node == html){ return; }
				if(!(has("mozilla") || isIE || isWK || has("opera") || has("trident") || has("edge"))
						&& ("scrollIntoView" in node)){
					node.scrollIntoView(false); // short-circuit to native if possible
					return;
				}
				var	backCompat = doc.compatMode == 'BackCompat',
					rootWidth = Math.min(body.clientWidth || html.clientWidth, html.clientWidth || body.clientWidth),
					rootHeight = Math.min(body.clientHeight || html.clientHeight, html.clientHeight || body.clientHeight),
					scrollRoot = (isWK || backCompat) ? body : html,
					nodePos = pos || geom.position(node),
					el = node.parentNode,
					isFixed = function(el){
						return (isIE <= 6 || (isIE == 7 && backCompat))
							? false
							: (has("position-fixed-support") && (style.get(el, 'position').toLowerCase() == "fixed"));
					},
					self = this,
					scrollElementBy = function(el, x, y){
						if(el.tagName == "BODY" || el.tagName == "HTML"){
							self.get(el.ownerDocument).scrollBy(x, y);
						}else{
							x && (el.scrollLeft += x);
							y && (el.scrollTop += y);
						}
					};
				if(isFixed(node)){ return; } // nothing to do
				while(el){
					if(el == body){ el = scrollRoot; }
					var	elPos = geom.position(el),
						fixedPos = isFixed(el),
						rtl = style.getComputedStyle(el).direction.toLowerCase() == "rtl";

					if(el == scrollRoot){
						elPos.w = rootWidth; elPos.h = rootHeight;
						if(scrollRoot == html && (isIE || has("trident")) && rtl){
							elPos.x += scrollRoot.offsetWidth-elPos.w;// IE workaround where scrollbar causes negative x
						}
						elPos.x = 0;
						elPos.y = 0;
					}else{
						var pb = geom.getPadBorderExtents(el);
						elPos.w -= pb.w; elPos.h -= pb.h; elPos.x += pb.l; elPos.y += pb.t;
						var clientSize = el.clientWidth,
							scrollBarSize = elPos.w - clientSize;
						if(clientSize > 0 && scrollBarSize > 0){
							if(rtl && has("rtl-adjust-position-for-verticalScrollBar")){
								elPos.x += scrollBarSize;
							}
							elPos.w = clientSize;
						}
						clientSize = el.clientHeight;
						scrollBarSize = elPos.h - clientSize;
						if(clientSize > 0 && scrollBarSize > 0){
							elPos.h = clientSize;
						}
					}
					if(fixedPos){ // bounded by viewport, not parents
						if(elPos.y < 0){
							elPos.h += elPos.y; elPos.y = 0;
						}
						if(elPos.x < 0){
							elPos.w += elPos.x; elPos.x = 0;
						}
						if(elPos.y + elPos.h > rootHeight){
							elPos.h = rootHeight - elPos.y;
						}
						if(elPos.x + elPos.w > rootWidth){
							elPos.w = rootWidth - elPos.x;
						}
					}
					// calculate overflow in all 4 directions
					var	l = nodePos.x - elPos.x, // beyond left: < 0
//						t = nodePos.y - Math.max(elPos.y, 0), // beyond top: < 0
						t = nodePos.y - elPos.y, // beyond top: < 0
						r = l + nodePos.w - elPos.w, // beyond right: > 0
						bot = t + nodePos.h - elPos.h; // beyond bottom: > 0
					var s, old;
					if(r * l > 0 && (!!el.scrollLeft || el == scrollRoot || el.scrollWidth > el.offsetHeight)){
						s = Math[l < 0? "max" : "min"](l, r);
						if(rtl && ((isIE == 8 && !backCompat) || has("trident") >= 5)){ s = -s; }
						old = el.scrollLeft;
						scrollElementBy(el, s, 0);
						s = el.scrollLeft - old;
						nodePos.x -= s;
					}
					if(bot * t > 0 && (!!el.scrollTop || el == scrollRoot || el.scrollHeight > el.offsetHeight)){
						s = Math.ceil(Math[t < 0? "max" : "min"](t, bot));
						old = el.scrollTop;
						scrollElementBy(el, 0, s);
						s = el.scrollTop - old;
						nodePos.y -= s;
					}
					el = (el != scrollRoot) && !fixedPos && el.parentNode;
				}
			}catch(error){
				console.error('scrollIntoView: ' + error);
				node.scrollIntoView(false);
			}
		}
	};

	 1  && lang.setObject("dojo.window", window);

	return window;
});

},
'dojo/DeferredList':function(){
define(["./_base/kernel", "./_base/Deferred", "./_base/array"], function(dojo, Deferred, darray){
	// module:
	//		dojo/DeferredList


dojo.DeferredList = function(/*Array*/ list, /*Boolean?*/ fireOnOneCallback, /*Boolean?*/ fireOnOneErrback, /*Boolean?*/ consumeErrors, /*Function?*/ canceller){
	// summary:
	//		Deprecated, use dojo/promise/all instead.
	//		Provides event handling for a group of Deferred objects.
	// description:
	//		DeferredList takes an array of existing deferreds and returns a new deferred of its own
	//		this new deferred will typically have its callback fired when all of the deferreds in
	//		the given list have fired their own deferreds.  The parameters `fireOnOneCallback` and
	//		fireOnOneErrback, will fire before all the deferreds as appropriate
	// list:
	//		The list of deferreds to be synchronizied with this DeferredList
	// fireOnOneCallback:
	//		Will cause the DeferredLists callback to be fired as soon as any
	//		of the deferreds in its list have been fired instead of waiting until
	//		the entire list has finished
	// fireonOneErrback:
	//		Will cause the errback to fire upon any of the deferreds errback
	// canceller:
	//		A deferred canceller function, see dojo.Deferred
	var resultList = [];
	Deferred.call(this);
	var self = this;
	if(list.length === 0 && !fireOnOneCallback){
		this.resolve([0, []]);
	}
	var finished = 0;
	darray.forEach(list, function(item, i){
		item.then(function(result){
			if(fireOnOneCallback){
				self.resolve([i, result]);
			}else{
				addResult(true, result);
			}
		},function(error){
			if(fireOnOneErrback){
				self.reject(error);
			}else{
				addResult(false, error);
			}
			if(consumeErrors){
				return null;
			}
			throw error;
		});
		function addResult(succeeded, result){
			resultList[i] = [succeeded, result];
			finished++;
			if(finished === list.length){
				self.resolve(resultList);
			}

		}
	});
};
dojo.DeferredList.prototype = new Deferred();

dojo.DeferredList.prototype.gatherResults = function(deferredList){
	// summary:
	//		Gathers the results of the deferreds for packaging
	//		as the parameters to the Deferred Lists' callback
	// deferredList: dojo/DeferredList
	//		The deferred list from which this function gathers results.
	// returns: dojo/DeferredList
	//		The newly created deferred list which packs results as
	//		parameters to its callback.

	var d = new dojo.DeferredList(deferredList, false, true, false);
	d.addCallback(function(results){
		var ret = [];
		darray.forEach(results, function(result){
			ret.push(result[1]);
		});
		return ret;
	});
	return d;
};

return dojo.DeferredList;
});

},
'dojo/fx':function(){
define([
	"./_base/lang",
	"./Evented",
	"./_base/kernel",
	"./_base/array",
	"./aspect",
	"./_base/fx",
	"./dom",
	"./dom-style",
	"./dom-geometry",
	"./ready",
	"require" // for context sensitive loading of Toggler
], function(lang, Evented, dojo, arrayUtil, aspect, baseFx, dom, domStyle, geom, ready, require){

	// module:
	//		dojo/fx

	// For back-compat, remove in 2.0.
	if(!dojo.isAsync){
		ready(0, function(){
			var requires = ["./fx/Toggler"];
			require(requires);	// use indirection so modules not rolled into a build
		});
	}

	var coreFx = dojo.fx = {
		// summary:
		//		Effects library on top of Base animations
	};

	var _baseObj = {
			_fire: function(evt, args){
				if(this[evt]){
					this[evt].apply(this, args||[]);
				}
				return this;
			}
		};

	var _chain = function(animations){
		this._index = -1;
		this._animations = animations||[];
		this._current = this._onAnimateCtx = this._onEndCtx = null;

		this.duration = 0;
		arrayUtil.forEach(this._animations, function(a){
			if(a){
				if(typeof a.duration != "undefined"){
	        		this.duration += a.duration;
				}
				if(a.delay){
					this.duration += a.delay;
				}
			}
		}, this);
	};
	_chain.prototype = new Evented();
	lang.extend(_chain, {
		_onAnimate: function(){
			this._fire("onAnimate", arguments);
		},
		_onEnd: function(){
			this._onAnimateCtx.remove();
			this._onEndCtx.remove();
			this._onAnimateCtx = this._onEndCtx = null;
			if(this._index + 1 == this._animations.length){
				this._fire("onEnd");
			}else{
				// switch animations
				this._current = this._animations[++this._index];
				this._onAnimateCtx = aspect.after(this._current, "onAnimate", lang.hitch(this, "_onAnimate"), true);
				this._onEndCtx = aspect.after(this._current, "onEnd", lang.hitch(this, "_onEnd"), true);
				this._current.play(0, true);
			}
		},
		play: function(/*int?*/ delay, /*Boolean?*/ gotoStart){
			if(!this._current){ this._current = this._animations[this._index = 0]; }
			if(!gotoStart && this._current.status() == "playing"){ return this; }
			var beforeBegin = aspect.after(this._current, "beforeBegin", lang.hitch(this, function(){
					this._fire("beforeBegin");
				}), true),
				onBegin = aspect.after(this._current, "onBegin", lang.hitch(this, function(arg){
					this._fire("onBegin", arguments);
				}), true),
				onPlay = aspect.after(this._current, "onPlay", lang.hitch(this, function(arg){
					this._fire("onPlay", arguments);
					beforeBegin.remove();
					onBegin.remove();
					onPlay.remove();
				}));
			if(this._onAnimateCtx){
				this._onAnimateCtx.remove();
			}
			this._onAnimateCtx = aspect.after(this._current, "onAnimate", lang.hitch(this, "_onAnimate"), true);
			if(this._onEndCtx){
				this._onEndCtx.remove();
			}
			this._onEndCtx = aspect.after(this._current, "onEnd", lang.hitch(this, "_onEnd"), true);
			this._current.play.apply(this._current, arguments);
			return this;
		},
		pause: function(){
			if(this._current){
				var e = aspect.after(this._current, "onPause", lang.hitch(this, function(arg){
						this._fire("onPause", arguments);
						e.remove();
					}), true);
				this._current.pause();
			}
			return this;
		},
		gotoPercent: function(/*Decimal*/percent, /*Boolean?*/ andPlay){
			this.pause();
			var offset = this.duration * percent;
			this._current = null;

			arrayUtil.some(this._animations, function(a, index){
				if(offset <= a.duration){
					this._current = a;
					this._index = index;
					return true;
				}
				offset -= a.duration;
				return false;
			}, this);
			if(this._current){
				this._current.gotoPercent(offset / this._current.duration);
			}
			if (andPlay) { this.play(); }
			return this;
		},
		stop: function(/*boolean?*/ gotoEnd){
			if(this._current){
				if(gotoEnd){
					for(; this._index + 1 < this._animations.length; ++this._index){
						this._animations[this._index].stop(true);
					}
					this._current = this._animations[this._index];
				}
				var e = aspect.after(this._current, "onStop", lang.hitch(this, function(arg){
						this._fire("onStop", arguments);
						e.remove();
					}), true);
				this._current.stop();
			}
			return this;
		},
		status: function(){
			return this._current ? this._current.status() : "stopped";
		},
		destroy: function(){
			this.stop();
			if(this._onAnimateCtx){ this._onAnimateCtx.remove(); }
			if(this._onEndCtx){ this._onEndCtx.remove(); }
		}
	});
	lang.extend(_chain, _baseObj);

	coreFx.chain = function(/*dojo/_base/fx.Animation[]*/ animations){
		// summary:
		//		Chain a list of `dojo/_base/fx.Animation`s to run in sequence
		//
		// description:
		//		Return a `dojo/_base/fx.Animation` which will play all passed
		//		`dojo/_base/fx.Animation` instances in sequence, firing its own
		//		synthesized events simulating a single animation. (eg:
		//		onEnd of this animation means the end of the chain,
		//		not the individual animations within)
		//
		// example:
		//	Once `node` is faded out, fade in `otherNode`
		//	|	require(["dojo/fx"], function(fx){
		//	|		fx.chain([
		//	|			fx.fadeIn({ node:node }),
		//	|			fx.fadeOut({ node:otherNode })
		//	|		]).play();
		//	|	});
		//
		return new _chain(lang.isArray(animations) ? animations : Array.prototype.slice.call(animations, 0)); // dojo/_base/fx.Animation
	};

	var _combine = function(animations){
		this._animations = animations||[];
		this._connects = [];
		this._finished = 0;

		this.duration = 0;
		arrayUtil.forEach(animations, function(a){
			var duration = a.duration;
			if(a.delay){ duration += a.delay; }
			if(this.duration < duration){ this.duration = duration; }
			this._connects.push(aspect.after(a, "onEnd", lang.hitch(this, "_onEnd"), true));
		}, this);

		this._pseudoAnimation = new baseFx.Animation({curve: [0, 1], duration: this.duration});
		var self = this;
		arrayUtil.forEach(["beforeBegin", "onBegin", "onPlay", "onAnimate", "onPause", "onStop", "onEnd"],
			function(evt){
				self._connects.push(aspect.after(self._pseudoAnimation, evt,
					function(){ self._fire(evt, arguments); },
				true));
			}
		);
	};
	lang.extend(_combine, {
		_doAction: function(action, args){
			arrayUtil.forEach(this._animations, function(a){
				a[action].apply(a, args);
			});
			return this;
		},
		_onEnd: function(){
			if(++this._finished > this._animations.length){
				this._fire("onEnd");
			}
		},
		_call: function(action, args){
			var t = this._pseudoAnimation;
			t[action].apply(t, args);
		},
		play: function(/*int?*/ delay, /*Boolean?*/ gotoStart){
			this._finished = 0;
			this._doAction("play", arguments);
			this._call("play", arguments);
			return this;
		},
		pause: function(){
			this._doAction("pause", arguments);
			this._call("pause", arguments);
			return this;
		},
		gotoPercent: function(/*Decimal*/percent, /*Boolean?*/ andPlay){
			var ms = this.duration * percent;
			arrayUtil.forEach(this._animations, function(a){
				a.gotoPercent(a.duration < ms ? 1 : (ms / a.duration), andPlay);
			});
			this._call("gotoPercent", arguments);
			return this;
		},
		stop: function(/*boolean?*/ gotoEnd){
			this._doAction("stop", arguments);
			this._call("stop", arguments);
			return this;
		},
		status: function(){
			return this._pseudoAnimation.status();
		},
		destroy: function(){
			this.stop();
			arrayUtil.forEach(this._connects, function(handle){
				handle.remove();
			});
		}
	});
	lang.extend(_combine, _baseObj);

	coreFx.combine = function(/*dojo/_base/fx.Animation[]*/ animations){
		// summary:
		//		Combine a list of `dojo/_base/fx.Animation`s to run in parallel
		//
		// description:
		//		Combine an array of `dojo/_base/fx.Animation`s or N
		//		`dojo/_base/fx.Animation`s  to run in parallel, providing
		//		a new `dojo/_base/fx.Animation` instance encompassing each
		//		animation, firing standard animation events.
		//
		// example:
		//	Fade out `node` while fading in `otherNode` simultaneously
		//	|	require(["dojo/fx"], function(fx){
		//	|		fx.combine([
		//	|			fx.fadeIn({ node:node }),
		//	|			fx.fadeOut({ node:otherNode })
		//	|		]).play();
		//	|	});
		//
		// example:
		//	When the longest animation ends, execute a function:
		//	|	require(["dojo/fx"], function(fx){
		//	|		var anim = fx.combine([
		//	|			fx.fadeIn({ node: n, duration:700 }),
		//	|			fx.fadeOut({ node: otherNode, duration: 300 })
		//	|		]);
		//	|		aspect.after(anim, "onEnd", function(){
		//	|			// overall animation is done.
		//	|		}, true);
		//	|		anim.play(); // play the animation
		//	|	});
		//
		return new _combine(lang.isArray(animations) ? animations : Array.prototype.slice.call(animations, 0)); // dojo/_base/fx.Animation
	};

	coreFx.wipeIn = function(/*Object*/ args){
		// summary:
		//		Expand a node to it's natural height.
		//
		// description:
		//		Returns an animation that will expand the
		//		node defined in 'args' object from it's current height to
		//		it's natural height (with no scrollbar).
		//		Node must have no margin/border/padding.
		//
		// args: Object
		//		A hash-map of standard `dojo/_base/fx.Animation` constructor properties
		//		(such as easing: node: duration: and so on)
		//
		// example:
		//	|	require(["dojo/fx"], function(fx){
		//	|		fx.wipeIn({
		//	|			node:"someId"
		//	|		}).play()
		//	|	});

		var node = args.node = dom.byId(args.node), s = node.style, o;

		var anim = baseFx.animateProperty(lang.mixin({
			properties: {
				height: {
					// wrapped in functions so we wait till the last second to query (in case value has changed)
					start: function(){
						// start at current [computed] height, but use 1px rather than 0
						// because 0 causes IE to display the whole panel
						o = s.overflow;
						s.overflow = "hidden";
						if(s.visibility == "hidden" || s.display == "none"){
							s.height = "1px";
							s.display = "";
							s.visibility = "";
							return 1;
						}else{
							var height = domStyle.get(node, "height");
							return Math.max(height, 1);
						}
					},
					end: function(){
						return node.scrollHeight;
					}
				}
			}
		}, args));

		var fini = function(){
			s.height = "auto";
			s.overflow = o;
		};
		aspect.after(anim, "onStop", fini, true);
		aspect.after(anim, "onEnd", fini, true);

		return anim; // dojo/_base/fx.Animation
	};

	coreFx.wipeOut = function(/*Object*/ args){
		// summary:
		//		Shrink a node to nothing and hide it.
		//
		// description:
		//		Returns an animation that will shrink node defined in "args"
		//		from it's current height to 1px, and then hide it.
		//
		// args: Object
		//		A hash-map of standard `dojo/_base/fx.Animation` constructor properties
		//		(such as easing: node: duration: and so on)
		//
		// example:
		//	|	require(["dojo/fx"], function(fx){
		//	|		fx.wipeOut({ node:"someId" }).play()
		//	|	});

		var node = args.node = dom.byId(args.node), s = node.style, o;

		var anim = baseFx.animateProperty(lang.mixin({
			properties: {
				height: {
					end: 1 // 0 causes IE to display the whole panel
				}
			}
		}, args));

		aspect.after(anim, "beforeBegin", function(){
			o = s.overflow;
			s.overflow = "hidden";
			s.display = "";
		}, true);
		var fini = function(){
			s.overflow = o;
			s.height = "auto";
			s.display = "none";
		};
		aspect.after(anim, "onStop", fini, true);
		aspect.after(anim, "onEnd", fini, true);

		return anim; // dojo/_base/fx.Animation
	};

	coreFx.slideTo = function(/*Object*/ args){
		// summary:
		//		Slide a node to a new top/left position
		//
		// description:
		//		Returns an animation that will slide "node"
		//		defined in args Object from its current position to
		//		the position defined by (args.left, args.top).
		//
		// args: Object
		//		A hash-map of standard `dojo/_base/fx.Animation` constructor properties
		//		(such as easing: node: duration: and so on). Special args members
		//		are `top` and `left`, which indicate the new position to slide to.
		//
		// example:
		//	|	.slideTo({ node: node, left:"40", top:"50", units:"px" }).play()

		var node = args.node = dom.byId(args.node),
			top = null, left = null;

		var init = (function(n){
			return function(){
				var cs = domStyle.getComputedStyle(n);
				var pos = cs.position;
				top = (pos == 'absolute' ? n.offsetTop : parseInt(cs.top) || 0);
				left = (pos == 'absolute' ? n.offsetLeft : parseInt(cs.left) || 0);
				if(pos != 'absolute' && pos != 'relative'){
					var ret = geom.position(n, true);
					top = ret.y;
					left = ret.x;
					n.style.position="absolute";
					n.style.top=top+"px";
					n.style.left=left+"px";
				}
			};
		})(node);
		init();

		var anim = baseFx.animateProperty(lang.mixin({
			properties: {
				top: args.top || 0,
				left: args.left || 0
			}
		}, args));
		aspect.after(anim, "beforeBegin", init, true);

		return anim; // dojo/_base/fx.Animation
	};

	return coreFx;
});

},
'dojo/_base/fx':function(){
define(["./kernel", "./config", /*===== "./declare", =====*/ "./lang", "../Evented", "./Color", "../aspect", "../sniff", "../dom", "../dom-style"],
	function(dojo, config, /*===== declare, =====*/ lang, Evented, Color, aspect, has, dom, style){
	// module:
	//		dojo/_base/fx
	// notes:
	//		Animation loosely package based on Dan Pupius' work, contributed under CLA; see
	//		http://pupius.co.uk/js/Toolkit.Drawing.js

	var _mixin = lang.mixin;

	// Module export
	var basefx = {
		// summary:
		//		This module defines the base dojo/_base/fx implementation.
	};

	var _Line = basefx._Line = function(/*int*/ start, /*int*/ end){
		// summary:
		//		Object used to generate values from a start value to an end value
		// start: int
		//		Beginning value for range
		// end: int
		//		Ending value for range
		this.start = start;
		this.end = end;
	};

	_Line.prototype.getValue = function(/*float*/ n){
		// summary:
		//		Returns the point on the line
		// n:
		//		a floating point number greater than 0 and less than 1
		return ((this.end - this.start) * n) + this.start; // Decimal
	};

	var Animation = basefx.Animation = function(args){
		// summary:
		//		A generic animation class that fires callbacks into its handlers
		//		object at various states.
		// description:
		//		A generic animation class that fires callbacks into its handlers
		//		object at various states. Nearly all dojo animation functions
		//		return an instance of this method, usually without calling the
		//		.play() method beforehand. Therefore, you will likely need to
		//		call .play() on instances of `Animation` when one is
		//		returned.
		// args: Object
		//		The 'magic argument', mixing all the properties into this
		//		animation instance.

		_mixin(this, args);
		if(lang.isArray(this.curve)){
			this.curve = new _Line(this.curve[0], this.curve[1]);
		}

	};
	Animation.prototype = new Evented();

	lang.extend(Animation, {
		// duration: Integer
		//		The time in milliseconds the animation will take to run
		duration: 350,

	/*=====
		// curve: _Line|Array
		//		A two element array of start and end values, or a `_Line` instance to be
		//		used in the Animation.
		curve: null,

		// easing: Function?
		//		A Function to adjust the acceleration (or deceleration) of the progress
		//		across a _Line
		easing: null,
	=====*/

		// repeat: Integer?
		//		The number of times to loop the animation
		repeat: 0,

		// rate: Integer?
		//		the time in milliseconds to wait before advancing to next frame
		//		(used as a fps timer: 1000/rate = fps)
		rate: 20 /* 50 fps */,

	/*=====
		// delay: Integer?
		//		The time in milliseconds to wait before starting animation after it
		//		has been .play()'ed
		delay: null,

		// beforeBegin: Event?
		//		Synthetic event fired before a Animation begins playing (synchronous)
		beforeBegin: null,

		// onBegin: Event?
		//		Synthetic event fired as a Animation begins playing (useful?)
		onBegin: null,

		// onAnimate: Event?
		//		Synthetic event fired at each interval of the Animation
		onAnimate: null,

		// onEnd: Event?
		//		Synthetic event fired after the final frame of the Animation
		onEnd: null,

		// onPlay: Event?
		//		Synthetic event fired any time the Animation is play()'ed
		onPlay: null,

		// onPause: Event?
		//		Synthetic event fired when the Animation is paused
		onPause: null,

		// onStop: Event
		//		Synthetic event fires when the Animation is stopped
		onStop: null,

	=====*/

		_percent: 0,
		_startRepeatCount: 0,

		_getStep: function(){
			var _p = this._percent,
				_e = this.easing
			;
			return _e ? _e(_p) : _p;
		},
		_fire: function(/*Event*/ evt, /*Array?*/ args){
			// summary:
			//		Convenience function.  Fire event "evt" and pass it the
			//		arguments specified in "args".
			// description:
			//		Convenience function.  Fire event "evt" and pass it the
			//		arguments specified in "args".
			//		Fires the callback in the scope of this Animation
			//		instance.
			// evt:
			//		The event to fire.
			// args:
			//		The arguments to pass to the event.
			var a = args||[];
			if(this[evt]){
				if(config.debugAtAllCosts){
					this[evt].apply(this, a);
				}else{
					try{
						this[evt].apply(this, a);
					}catch(e){
						// squelch and log because we shouldn't allow exceptions in
						// synthetic event handlers to cause the internal timer to run
						// amuck, potentially pegging the CPU. I'm not a fan of this
						// squelch, but hopefully logging will make it clear what's
						// going on
						console.error("exception in animation handler for:", evt);
						console.error(e);
					}
				}
			}
			return this; // Animation
		},

		play: function(/*int?*/ delay, /*Boolean?*/ gotoStart){
			// summary:
			//		Start the animation.
			// delay:
			//		How many milliseconds to delay before starting.
			// gotoStart:
			//		If true, starts the animation from the beginning; otherwise,
			//		starts it from its current position.
			// returns: Animation
			//		The instance to allow chaining.

			var _t = this;
			if(_t._delayTimer){ _t._clearTimer(); }
			if(gotoStart){
				_t._stopTimer();
				_t._active = _t._paused = false;
				_t._percent = 0;
			}else if(_t._active && !_t._paused){
				return _t;
			}

			_t._fire("beforeBegin", [_t.node]);

			var de = delay || _t.delay,
				_p = lang.hitch(_t, "_play", gotoStart);

			if(de > 0){
				_t._delayTimer = setTimeout(_p, de);
				return _t;
			}
			_p();
			return _t;	// Animation
		},

		_play: function(gotoStart){
			var _t = this;
			if(_t._delayTimer){ _t._clearTimer(); }
			_t._startTime = new Date().valueOf();
			if(_t._paused){
				_t._startTime -= _t.duration * _t._percent;
			}

			_t._active = true;
			_t._paused = false;
			var value = _t.curve.getValue(_t._getStep());
			if(!_t._percent){
				if(!_t._startRepeatCount){
					_t._startRepeatCount = _t.repeat;
				}
				_t._fire("onBegin", [value]);
			}

			_t._fire("onPlay", [value]);

			_t._cycle();
			return _t; // Animation
		},

		pause: function(){
			// summary:
			//		Pauses a running animation.
			var _t = this;
			if(_t._delayTimer){ _t._clearTimer(); }
			_t._stopTimer();
			if(!_t._active){ return _t; /*Animation*/ }
			_t._paused = true;
			_t._fire("onPause", [_t.curve.getValue(_t._getStep())]);
			return _t; // Animation
		},

		gotoPercent: function(/*Decimal*/ percent, /*Boolean?*/ andPlay){
			// summary:
			//		Sets the progress of the animation.
			// percent:
			//		A percentage in decimal notation (between and including 0.0 and 1.0).
			// andPlay:
			//		If true, play the animation after setting the progress.
			var _t = this;
			_t._stopTimer();
			_t._active = _t._paused = true;
			_t._percent = percent;
			if(andPlay){ _t.play(); }
			return _t; // Animation
		},

		stop: function(/*boolean?*/ gotoEnd){
			// summary:
			//		Stops a running animation.
			// gotoEnd:
			//		If true, the animation will end.
			var _t = this;
			if(_t._delayTimer){ _t._clearTimer(); }
			if(!_t._timer){ return _t; /* Animation */ }
			_t._stopTimer();
			if(gotoEnd){
				_t._percent = 1;
			}
			_t._fire("onStop", [_t.curve.getValue(_t._getStep())]);
			_t._active = _t._paused = false;
			return _t; // Animation
		},

		destroy: function(){
			// summary:
			//		cleanup the animation
			this.stop();
		},

		status: function(){
			// summary:
			//		Returns a string token representation of the status of
			//		the animation, one of: "paused", "playing", "stopped"
			if(this._active){
				return this._paused ? "paused" : "playing"; // String
			}
			return "stopped"; // String
		},

		_cycle: function(){
			var _t = this;
			if(_t._active){
				var curr = new Date().valueOf();
				// Allow durations of 0 (instant) by setting step to 1 - see #13798
				var step = _t.duration === 0 ? 1 : (curr - _t._startTime) / (_t.duration);

				if(step >= 1){
					step = 1;
				}
				_t._percent = step;

				// Perform easing
				if(_t.easing){
					step = _t.easing(step);
				}

				_t._fire("onAnimate", [_t.curve.getValue(step)]);

				if(_t._percent < 1){
					_t._startTimer();
				}else{
					_t._active = false;

					if(_t.repeat > 0){
						_t.repeat--;
						_t.play(null, true);
					}else if(_t.repeat == -1){
						_t.play(null, true);
					}else{
						if(_t._startRepeatCount){
							_t.repeat = _t._startRepeatCount;
							_t._startRepeatCount = 0;
						}
					}
					_t._percent = 0;
					_t._fire("onEnd", [_t.node]);
					!_t.repeat && _t._stopTimer();
				}
			}
			return _t; // Animation
		},

		_clearTimer: function(){
			// summary:
			//		Clear the play delay timer
			clearTimeout(this._delayTimer);
			delete this._delayTimer;
		}

	});

	// the local timer, stubbed into all Animation instances
	var ctr = 0,
		timer = null,
		runner = {
			run: function(){}
		};

	lang.extend(Animation, {

		_startTimer: function(){
			if(!this._timer){
				this._timer = aspect.after(runner, "run", lang.hitch(this, "_cycle"), true);
				ctr++;
			}
			if(!timer){
				timer = setInterval(lang.hitch(runner, "run"), this.rate);
			}
		},

		_stopTimer: function(){
			if(this._timer){
				this._timer.remove();
				this._timer = null;
				ctr--;
			}
			if(ctr <= 0){
				clearInterval(timer);
				timer = null;
				ctr = 0;
			}
		}

	});

	var _makeFadeable =
		has("ie") ? function(node){
			// only set the zoom if the "tickle" value would be the same as the
			// default
			var ns = node.style;
			// don't set the width to auto if it didn't already cascade that way.
			// We don't want to f anyones designs
			if(!ns.width.length && style.get(node, "width") == "auto"){
				ns.width = "auto";
			}
		} :
		function(){};

	basefx._fade = function(/*Object*/ args){
		// summary:
		//		Returns an animation that will fade the node defined by
		//		args.node from the start to end values passed (args.start
		//		args.end) (end is mandatory, start is optional)

		args.node = dom.byId(args.node);
		var fArgs = _mixin({ properties: {} }, args),
			props = (fArgs.properties.opacity = {});

		props.start = !("start" in fArgs) ?
			function(){
				return +style.get(fArgs.node, "opacity")||0;
			} : fArgs.start;
		props.end = fArgs.end;

		var anim = basefx.animateProperty(fArgs);
		aspect.after(anim, "beforeBegin", lang.partial(_makeFadeable, fArgs.node), true);

		return anim; // Animation
	};

	/*=====
	var __FadeArgs = declare(null, {
		// node: DOMNode|String
		//		The node referenced in the animation
		// duration: Integer?
		//		Duration of the animation in milliseconds.
		// easing: Function?
		//		An easing function.
	});
	=====*/

	basefx.fadeIn = function(/*__FadeArgs*/ args){
		// summary:
		//		Returns an animation that will fade node defined in 'args' from
		//		its current opacity to fully opaque.
		return basefx._fade(_mixin({ end: 1 }, args)); // Animation
	};

	basefx.fadeOut = function(/*__FadeArgs*/ args){
		// summary:
		//		Returns an animation that will fade node defined in 'args'
		//		from its current opacity to fully transparent.
		return basefx._fade(_mixin({ end: 0 }, args)); // Animation
	};

	basefx._defaultEasing = function(/*Decimal?*/ n){
		// summary:
		//		The default easing function for Animation(s)
		return 0.5 + ((Math.sin((n + 1.5) * Math.PI)) / 2);	// Decimal
	};

	var PropLine = function(properties){
		// PropLine is an internal class which is used to model the values of
		// an a group of CSS properties across an animation lifecycle. In
		// particular, the "getValue" function handles getting interpolated
		// values between start and end for a particular CSS value.
		this._properties = properties;
		for(var p in properties){
			var prop = properties[p];
			if(prop.start instanceof Color){
				// create a reusable temp color object to keep intermediate results
				prop.tempColor = new Color();
			}
		}
	};

	PropLine.prototype.getValue = function(r){
		var ret = {};
		for(var p in this._properties){
			var prop = this._properties[p],
				start = prop.start;
			if(start instanceof Color){
				ret[p] = Color.blendColors(start, prop.end, r, prop.tempColor).toCss();
			}else if(!lang.isArray(start)){
				ret[p] = ((prop.end - start) * r) + start + (p != "opacity" ? prop.units || "px" : 0);
			}
		}
		return ret;
	};

	/*=====
	var __AnimArgs = declare(__FadeArgs, {
		// properties: Object?
		//		A hash map of style properties to Objects describing the transition,
		//		such as the properties of _Line with an additional 'units' property
		properties: {}

		//TODOC: add event callbacks
	});
	=====*/

	basefx.animateProperty = function(/*__AnimArgs*/ args){
		// summary:
		//		Returns an animation that will transition the properties of
		//		node defined in `args` depending how they are defined in
		//		`args.properties`
		//
		// description:
		//		Foundation of most `dojo/_base/fx`
		//		animations. It takes an object of "properties" corresponding to
		//		style properties, and animates them in parallel over a set
		//		duration.
		//
		// example:
		//		A simple animation that changes the width of the specified node.
		//	|	basefx.animateProperty({
		//	|		node: "nodeId",
		//	|		properties: { width: 400 },
		//	|	}).play();
		//		Dojo figures out the start value for the width and converts the
		//		integer specified for the width to the more expressive but
		//		verbose form `{ width: { end: '400', units: 'px' } }` which you
		//		can also specify directly. Defaults to 'px' if omitted.
		//
		// example:
		//		Animate width, height, and padding over 2 seconds... the
		//		pedantic way:
		//	|	basefx.animateProperty({ node: node, duration:2000,
		//	|		properties: {
		//	|			width: { start: '200', end: '400', units:"px" },
		//	|			height: { start:'200', end: '400', units:"px" },
		//	|			paddingTop: { start:'5', end:'50', units:"px" }
		//	|		}
		//	|	}).play();
		//		Note 'paddingTop' is used over 'padding-top'. Multi-name CSS properties
		//		are written using "mixed case", as the hyphen is illegal as an object key.
		//
		// example:
		//		Plug in a different easing function and register a callback for
		//		when the animation ends. Easing functions accept values between
		//		zero and one and return a value on that basis. In this case, an
		//		exponential-in curve.
		//	|	basefx.animateProperty({
		//	|		node: "nodeId",
		//	|		// dojo figures out the start value
		//	|		properties: { width: { end: 400 } },
		//	|		easing: function(n){
		//	|			return (n==0) ? 0 : Math.pow(2, 10 * (n - 1));
		//	|		},
		//	|		onEnd: function(node){
		//	|			// called when the animation finishes. The animation
		//	|			// target is passed to this function
		//	|		}
		//	|	}).play(500); // delay playing half a second
		//
		// example:
		//		Like all `Animation`s, animateProperty returns a handle to the
		//		Animation instance, which fires the events common to Dojo FX. Use `aspect.after`
		//		to access these events outside of the Animation definition:
		//	|	var anim = basefx.animateProperty({
		//	|		node:"someId",
		//	|		properties:{
		//	|			width:400, height:500
		//	|		}
		//	|	});
		//	|	aspect.after(anim, "onEnd", function(){
		//	|		console.log("animation ended");
		//	|	}, true);
		//	|	// play the animation now:
		//	|	anim.play();
		//
		// example:
		//		Each property can be a function whose return value is substituted along.
		//		Additionally, each measurement (eg: start, end) can be a function. The node
		//		reference is passed directly to callbacks.
		//	|	basefx.animateProperty({
		//	|		node:"mine",
		//	|		properties:{
		//	|			height:function(node){
		//	|				// shrink this node by 50%
		//	|				return domGeom.position(node).h / 2
		//	|			},
		//	|			width:{
		//	|				start:function(node){ return 100; },
		//	|				end:function(node){ return 200; }
		//	|			}
		//	|		}
		//	|	}).play();
		//

		var n = args.node = dom.byId(args.node);
		if(!args.easing){ args.easing = dojo._defaultEasing; }

		var anim = new Animation(args);
		aspect.after(anim, "beforeBegin", lang.hitch(anim, function(){
			var pm = {};
			for(var p in this.properties){
				// Make shallow copy of properties into pm because we overwrite
				// some values below. In particular if start/end are functions
				// we don't want to overwrite them or the functions won't be
				// called if the animation is reused.
				if(p == "width" || p == "height"){
					this.node.display = "block";
				}
				var prop = this.properties[p];
				if(lang.isFunction(prop)){
					prop = prop(n);
				}
				prop = pm[p] = _mixin({}, (lang.isObject(prop) ? prop: { end: prop }));

				if(lang.isFunction(prop.start)){
					prop.start = prop.start(n);
				}
				if(lang.isFunction(prop.end)){
					prop.end = prop.end(n);
				}
				var isColor = (p.toLowerCase().indexOf("color") >= 0);
				var getStyle = function getStyle(node, p){
					// domStyle.get(node, "height") can return "auto" or "" on IE; this is more reliable:
					var v = { height: node.offsetHeight, width: node.offsetWidth }[p];
					if(v !== undefined){ return v; }
					v = style.get(node, p);
					return (p == "opacity") ? +v : (isColor ? v : parseFloat(v));
				};
				if(!("end" in prop)){
					prop.end = getStyle(n, p);
				}else if(!("start" in prop)){
					prop.start = getStyle(n, p);
				}

				if(isColor){
					prop.start = new Color(prop.start);
					prop.end = new Color(prop.end);
				}else{
					prop.start = (p == "opacity") ? +prop.start : parseFloat(prop.start);
				}
			}
			this.curve = new PropLine(pm);
		}), true);
		aspect.after(anim, "onAnimate", lang.hitch(style, "set", anim.node), true);
		return anim; // Animation
	};

	basefx.anim = function(	/*DOMNode|String*/	node,
							/*Object*/			properties,
							/*Integer?*/		duration,
							/*Function?*/		easing,
							/*Function?*/		onEnd,
							/*Integer?*/		delay){
		// summary:
		//		A simpler interface to `animateProperty()`, also returns
		//		an instance of `Animation` but begins the animation
		//		immediately, unlike nearly every other Dojo animation API.
		// description:
		//		Simpler (but somewhat less powerful) version
		//		of `animateProperty`.  It uses defaults for many basic properties
		//		and allows for positional parameters to be used in place of the
		//		packed "property bag" which is used for other Dojo animation
		//		methods.
		//
		//		The `Animation` object returned will be already playing, so
		//		calling play() on it again is (usually) a no-op.
		// node:
		//		a DOM node or the id of a node to animate CSS properties on
		// duration:
		//		The number of milliseconds over which the animation
		//		should run. Defaults to the global animation default duration
		//		(350ms).
		// easing:
		//		An easing function over which to calculate acceleration
		//		and deceleration of the animation through its duration.
		//		A default easing algorithm is provided, but you may
		//		plug in any you wish. A large selection of easing algorithms
		//		are available in `dojo/fx/easing`.
		// onEnd:
		//		A function to be called when the animation finishes
		//		running.
		// delay:
		//		The number of milliseconds to delay beginning the
		//		animation by. The default is 0.
		// example:
		//		Fade out a node
		//	|	basefx.anim("id", { opacity: 0 });
		// example:
		//		Fade out a node over a full second
		//	|	basefx.anim("id", { opacity: 0 }, 1000);
		return basefx.animateProperty({ // Animation
			node: node,
			duration: duration || Animation.prototype.duration,
			properties: properties,
			easing: easing,
			onEnd: onEnd
		}).play(delay || 0);
	};


	if( 1 ){
		_mixin(dojo, basefx);
		// Alias to drop come 2.0:
		dojo._Animation = Animation;
	}

	return basefx;
});

},
'dojo/_base/Color':function(){
define(["./kernel", "./lang", "./array", "./config"], function(dojo, lang, ArrayUtil, config){

	var Color = dojo.Color = function(/*Array|String|Object*/ color){
		// summary:
		//		Takes a named string, hex string, array of rgb or rgba values,
		//		an object with r, g, b, and a properties, or another `Color` object
		//		and creates a new Color instance to work from.
		//
		// example:
		//		Work with a Color instance:
		//	|	require(["dojo/_base/color"], function(Color){
		//	|		var c = new Color();
		//	|		c.setColor([0,0,0]); // black
		//	|		var hex = c.toHex(); // #000000
		//	|	});
		//
		// example:
		//		Work with a node's color:
		//	| 
		//	|	require(["dojo/_base/color", "dojo/dom-style"], function(Color, domStyle){
		//	|		var color = domStyle("someNode", "backgroundColor");
		//	|		var n = new Color(color);
		//	|		// adjust the color some
		//	|		n.r *= .5;
		//	|		console.log(n.toString()); // rgb(128, 255, 255);
		//	|	});
		if(color){ this.setColor(color); }
	};

	// FIXME:
	// there's got to be a more space-efficient way to encode or discover
	// these!! Use hex?
	Color.named = {
		// summary:
		//		Dictionary list of all CSS named colors, by name. Values are 3-item arrays with corresponding RG and B values.
		"black":  [0,0,0],
		"silver": [192,192,192],
		"gray":	  [128,128,128],
		"white":  [255,255,255],
		"maroon": [128,0,0],
		"red":	  [255,0,0],
		"purple": [128,0,128],
		"fuchsia":[255,0,255],
		"green":  [0,128,0],
		"lime":	  [0,255,0],
		"olive":  [128,128,0],
		"yellow": [255,255,0],
		"navy":	  [0,0,128],
		"blue":	  [0,0,255],
		"teal":	  [0,128,128],
		"aqua":	  [0,255,255],
		"transparent": config.transparentColor || [0,0,0,0]
	};

	lang.extend(Color, {
		r: 255, g: 255, b: 255, a: 1,
		_set: function(r, g, b, a){
			var t = this; t.r = r; t.g = g; t.b = b; t.a = a;
		},
		setColor: function(/*Array|String|Object*/ color){
			// summary:
			//		Takes a named string, hex string, array of rgb or rgba values,
			//		an object with r, g, b, and a properties, or another `Color` object
			//		and sets this color instance to that value.
			//
			// example:
			//	|	require(["dojo/_base/color"], function(Color){
			//	|		var c = new Color(); // no color
			//	|		c.setColor("#ededed"); // greyish
			//	|	});
			if(lang.isString(color)){
				Color.fromString(color, this);
			}else if(lang.isArray(color)){
				Color.fromArray(color, this);
			}else{
				this._set(color.r, color.g, color.b, color.a);
				if(!(color instanceof Color)){ this.sanitize(); }
			}
			return this;	// Color
		},
		sanitize: function(){
			// summary:
			//		Ensures the object has correct attributes
			// description:
			//		the default implementation does nothing, include dojo.colors to
			//		augment it with real checks
			return this;	// Color
		},
		toRgb: function(){
			// summary:
			//		Returns 3 component array of rgb values
			// example:
			//	|	require(["dojo/_base/color"], function(Color){
			//	|		var c = new Color("#000000");
			//	|		console.log(c.toRgb()); // [0,0,0]
			//	|	});
			var t = this;
			return [t.r, t.g, t.b]; // Array
		},
		toRgba: function(){
			// summary:
			//		Returns a 4 component array of rgba values from the color
			//		represented by this object.
			var t = this;
			return [t.r, t.g, t.b, t.a];	// Array
		},
		toHex: function(){
			// summary:
			//		Returns a CSS color string in hexadecimal representation
			// example:
			//	|	require(["dojo/_base/color"], function(Color){
			//	|		console.log(new Color([0,0,0]).toHex()); // #000000
			//	|	});
			var arr = ArrayUtil.map(["r", "g", "b"], function(x){
				var s = this[x].toString(16);
				return s.length < 2 ? "0" + s : s;
			}, this);
			return "#" + arr.join("");	// String
		},
		toCss: function(/*Boolean?*/ includeAlpha){
			// summary:
			//		Returns a css color string in rgb(a) representation
			// example:
			//	|	require(["dojo/_base/color"], function(Color){
			//	|		var c = new Color("#FFF").toCss();
			//	|		console.log(c); // rgb('255','255','255')
			//	|	});
			var t = this, rgb = t.r + ", " + t.g + ", " + t.b;
			return (includeAlpha ? "rgba(" + rgb + ", " + t.a : "rgb(" + rgb) + ")";	// String
		},
		toString: function(){
			// summary:
			//		Returns a visual representation of the color
			return this.toCss(true); // String
		}
	});

	Color.blendColors = dojo.blendColors = function(
		/*Color*/ start,
		/*Color*/ end,
		/*Number*/ weight,
		/*Color?*/ obj
	){
		// summary:
		//		Blend colors end and start with weight from 0 to 1, 0.5 being a 50/50 blend,
		//		can reuse a previously allocated Color object for the result
		var t = obj || new Color();
		t.r = Math.round(start.r + (end.r - start.r) * weight);
		t.g = Math.round(start.g + (end.g - start.g) * weight);
		t.b = Math.round(start.b + (end.b - start.b) * weight);
		t.a = start.a + (end.a - start.a) * weight;
		return t.sanitize();	// Color
	};

	Color.fromRgb = dojo.colorFromRgb = function(/*String*/ color, /*Color?*/ obj){
		// summary:
		//		Returns a `Color` instance from a string of the form
		//		"rgb(...)" or "rgba(...)". Optionally accepts a `Color`
		//		object to update with the parsed value and return instead of
		//		creating a new object.
		// returns:
		//		A Color object. If obj is passed, it will be the return value.
		var m = color.toLowerCase().match(/^rgba?\(([\s\.,0-9]+)\)/);
		return m && Color.fromArray(m[1].split(/\s*,\s*/), obj);	// Color
	};

	Color.fromHex = dojo.colorFromHex = function(/*String*/ color, /*Color?*/ obj){
		// summary:
		//		Converts a hex string with a '#' prefix to a color object.
		//		Supports 12-bit #rgb shorthand. Optionally accepts a
		//		`Color` object to update with the parsed value.
		//
		// returns:
		//		A Color object. If obj is passed, it will be the return value.
		//
		// example:
		//	|	require(["dojo/_base/color"], function(Color){
		//	|		var thing = new Color().fromHex("#ededed"); // grey, longhand
		//	|		var thing2 = new Color().fromHex("#000"); // black, shorthand
		//	|	});
		var t = obj || new Color(),
			bits = (color.length == 4) ? 4 : 8,
			mask = (1 << bits) - 1;
		color = Number("0x" + color.substr(1));
		if(isNaN(color)){
			return null; // Color
		}
		ArrayUtil.forEach(["b", "g", "r"], function(x){
			var c = color & mask;
			color >>= bits;
			t[x] = bits == 4 ? 17 * c : c;
		});
		t.a = 1;
		return t;	// Color
	};

	Color.fromArray = dojo.colorFromArray = function(/*Array*/ a, /*Color?*/ obj){
		// summary:
		//		Builds a `Color` from a 3 or 4 element array, mapping each
		//		element in sequence to the rgb(a) values of the color.
		// example:
		//		|	require(["dojo/_base/color"], function(Color){
		//		|		var myColor = new Color().fromArray([237,237,237,0.5]); // grey, 50% alpha
		//		|	});
		// returns:
		//		A Color object. If obj is passed, it will be the return value.
		var t = obj || new Color();
		t._set(Number(a[0]), Number(a[1]), Number(a[2]), Number(a[3]));
		if(isNaN(t.a)){ t.a = 1; }
		return t.sanitize();	// Color
	};

	Color.fromString = dojo.colorFromString = function(/*String*/ str, /*Color?*/ obj){
		// summary:
		//		Parses `str` for a color value. Accepts hex, rgb, and rgba
		//		style color values.
		// description:
		//		Acceptable input values for str may include arrays of any form
		//		accepted by dojo.colorFromArray, hex strings such as "#aaaaaa", or
		//		rgb or rgba strings such as "rgb(133, 200, 16)" or "rgba(10, 10,
		//		10, 50)"
		// returns:
		//		A Color object. If obj is passed, it will be the return value.
		var a = Color.named[str];
		return a && Color.fromArray(a, obj) || Color.fromRgb(str, obj) || Color.fromHex(str, obj);	// Color
	};

	return Color;
});

},
'dojo/fx/easing':function(){
define(["../_base/lang"], function(lang){

// module:
//		dojo/fx/easing

var easingFuncs = {
	// summary:
	//		Collection of easing functions to use beyond the default
	//		`dojo._defaultEasing` function.
	// description:
	//		Easing functions are used to manipulate the iteration through
	//		an `dojo.Animation`s _Line. _Line being the properties of an Animation,
	//		and the easing function progresses through that Line determining
	//		how quickly (or slowly) it should go. Or more accurately: modify
	//		the value of the _Line based on the percentage of animation completed.
	//
	//		All functions follow a simple naming convention of "ease type" + "when".
	//		If the name of the function ends in Out, the easing described appears
	//		towards the end of the animation. "In" means during the beginning,
	//		and InOut means both ranges of the Animation will applied, both
	//		beginning and end.
	//
	//		One does not call the easing function directly, it must be passed to
	//		the `easing` property of an animation.
	// example:
	//	|	dojo.require("dojo.fx.easing");
	//	|	var anim = dojo.fadeOut({
	//	|		node: 'node',
	//	|		duration: 2000,
	//	|		//	note there is no ()
	//	|		easing: dojo.fx.easing.quadIn
	//	|	}).play();
	//

	linear: function(/* Decimal? */n){
		// summary:
		//		A linear easing function
		return n;
	},

	quadIn: function(/* Decimal? */n){
		return Math.pow(n, 2);
	},

	quadOut: function(/* Decimal? */n){
		return n * (n - 2) * -1;
	},

	quadInOut: function(/* Decimal? */n){
		n = n * 2;
		if(n < 1){ return Math.pow(n, 2) / 2; }
		return -1 * ((--n) * (n - 2) - 1) / 2;
	},

	cubicIn: function(/* Decimal? */n){
		return Math.pow(n, 3);
	},

	cubicOut: function(/* Decimal? */n){
		return Math.pow(n - 1, 3) + 1;
	},

	cubicInOut: function(/* Decimal? */n){
		n = n * 2;
		if(n < 1){ return Math.pow(n, 3) / 2; }
		n -= 2;
		return (Math.pow(n, 3) + 2) / 2;
	},

	quartIn: function(/* Decimal? */n){
		return Math.pow(n, 4);
	},

	quartOut: function(/* Decimal? */n){
		return -1 * (Math.pow(n - 1, 4) - 1);
	},

	quartInOut: function(/* Decimal? */n){
		n = n * 2;
		if(n < 1){ return Math.pow(n, 4) / 2; }
		n -= 2;
		return -1 / 2 * (Math.pow(n, 4) - 2);
	},

	quintIn: function(/* Decimal? */n){
		return Math.pow(n, 5);
	},

	quintOut: function(/* Decimal? */n){
		return Math.pow(n - 1, 5) + 1;
	},

	quintInOut: function(/* Decimal? */n){
		n = n * 2;
		if(n < 1){ return Math.pow(n, 5) / 2; }
		n -= 2;
		return (Math.pow(n, 5) + 2) / 2;
	},

	sineIn: function(/* Decimal? */n){
		return -1 * Math.cos(n * (Math.PI / 2)) + 1;
	},

	sineOut: function(/* Decimal? */n){
		return Math.sin(n * (Math.PI / 2));
	},

	sineInOut: function(/* Decimal? */n){
		return -1 * (Math.cos(Math.PI * n) - 1) / 2;
	},

	expoIn: function(/* Decimal? */n){
		return (n == 0) ? 0 : Math.pow(2, 10 * (n - 1));
	},

	expoOut: function(/* Decimal? */n){
		return (n == 1) ? 1 : (-1 * Math.pow(2, -10 * n) + 1);
	},

	expoInOut: function(/* Decimal? */n){
		if(n == 0){ return 0; }
		if(n == 1){ return 1; }
		n = n * 2;
		if(n < 1){ return Math.pow(2, 10 * (n - 1)) / 2; }
		--n;
		return (-1 * Math.pow(2, -10 * n) + 2) / 2;
	},

	circIn: function(/* Decimal? */n){
		return -1 * (Math.sqrt(1 - Math.pow(n, 2)) - 1);
	},

	circOut: function(/* Decimal? */n){
		n = n - 1;
		return Math.sqrt(1 - Math.pow(n, 2));
	},

	circInOut: function(/* Decimal? */n){
		n = n * 2;
		if(n < 1){ return -1 / 2 * (Math.sqrt(1 - Math.pow(n, 2)) - 1); }
		n -= 2;
		return 1 / 2 * (Math.sqrt(1 - Math.pow(n, 2)) + 1);
	},

	backIn: function(/* Decimal? */n){
		// summary:
		//		An easing function that starts away from the target,
		//		and quickly accelerates towards the end value.
		//
		//		Use caution when the easing will cause values to become
		//		negative as some properties cannot be set to negative values.
		var s = 1.70158;
		return Math.pow(n, 2) * ((s + 1) * n - s);
	},

	backOut: function(/* Decimal? */n){
		// summary:
		//		An easing function that pops past the range briefly, and slowly comes back.
		// description:
		//		An easing function that pops past the range briefly, and slowly comes back.
		//
		//		Use caution when the easing will cause values to become negative as some
		//		properties cannot be set to negative values.

		n = n - 1;
		var s = 1.70158;
		return Math.pow(n, 2) * ((s + 1) * n + s) + 1;
	},

	backInOut: function(/* Decimal? */n){
		// summary:
		//		An easing function combining the effects of `backIn` and `backOut`
		// description:
		//		An easing function combining the effects of `backIn` and `backOut`.
		//		Use caution when the easing will cause values to become negative
		//		as some properties cannot be set to negative values.
		var s = 1.70158 * 1.525;
		n = n * 2;
		if(n < 1){ return (Math.pow(n, 2) * ((s + 1) * n - s)) / 2; }
		n-=2;
		return (Math.pow(n, 2) * ((s + 1) * n + s) + 2) / 2;
	},

	elasticIn: function(/* Decimal? */n){
		// summary:
		//		An easing function the elastically snaps from the start value
		// description:
		//		An easing function the elastically snaps from the start value
		//
		//		Use caution when the elasticity will cause values to become negative
		//		as some properties cannot be set to negative values.
		if(n == 0 || n == 1){ return n; }
		var p = .3;
		var s = p / 4;
		n = n - 1;
		return -1 * Math.pow(2, 10 * n) * Math.sin((n - s) * (2 * Math.PI) / p);
	},

	elasticOut: function(/* Decimal? */n){
		// summary:
		//		An easing function that elasticly snaps around the target value,
		//		near the end of the Animation
		// description:
		//		An easing function that elasticly snaps around the target value,
		//		near the end of the Animation
		//
		//		Use caution when the elasticity will cause values to become
		//		negative as some properties cannot be set to negative values.
		if(n==0 || n == 1){ return n; }
		var p = .3;
		var s = p / 4;
		return Math.pow(2, -10 * n) * Math.sin((n - s) * (2 * Math.PI) / p) + 1;
	},

	elasticInOut: function(/* Decimal? */n){
		// summary:
		//		An easing function that elasticly snaps around the value, near
		//		the beginning and end of the Animation.
		// description:
		//		An easing function that elasticly snaps around the value, near
		//		the beginning and end of the Animation.
		//
		//		Use caution when the elasticity will cause values to become
		//		negative as some properties cannot be set to negative values.
		if(n == 0) return 0;
		n = n * 2;
		if(n == 2) return 1;
		var p = .3 * 1.5;
		var s = p / 4;
		if(n < 1){
			n -= 1;
			return -.5 * (Math.pow(2, 10 * n) * Math.sin((n - s) * (2 * Math.PI) / p));
		}
		n -= 1;
		return .5 * (Math.pow(2, -10 * n) * Math.sin((n - s) * (2 * Math.PI) / p)) + 1;
	},

	bounceIn: function(/* Decimal? */n){
		// summary:
		//		An easing function that 'bounces' near the beginning of an Animation
		return (1 - easingFuncs.bounceOut(1 - n)); // Decimal
	},

	bounceOut: function(/* Decimal? */n){
		// summary:
		//		An easing function that 'bounces' near the end of an Animation
		var s = 7.5625;
		var p = 2.75;
		var l;
		if(n < (1 / p)){
			l = s * Math.pow(n, 2);
		}else if(n < (2 / p)){
			n -= (1.5 / p);
			l = s * Math.pow(n, 2) + .75;
		}else if(n < (2.5 / p)){
			n -= (2.25 / p);
			l = s * Math.pow(n, 2) + .9375;
		}else{
			n -= (2.625 / p);
			l = s * Math.pow(n, 2) + .984375;
		}
		return l;
	},

	bounceInOut: function(/* Decimal? */n){
		// summary:
		//		An easing function that 'bounces' at the beginning and end of the Animation
		if(n < 0.5){ return easingFuncs.bounceIn(n * 2) / 2; }
		return (easingFuncs.bounceOut(n * 2 - 1) / 2) + 0.5; // Decimal
	}
};

lang.setObject("dojo.fx.easing", easingFuncs);

return easingFuncs;
});

},
'dojo/NodeList-manipulate':function(){
define(["./query", "./_base/lang", "./_base/array", "./dom-construct", "./dom-attr", "./NodeList-dom"], function(dquery, lang, array, construct, attr){
	// module:
	//		dojo/NodeList-manipulate

	/*=====
	return function(){
		// summary:
		//		Adds chainable methods to dojo.query() / NodeList instances for manipulating HTML
		//		and DOM nodes and their properties.
	};
	=====*/

	var NodeList = dquery.NodeList;

	//TODO: add a way to parse for widgets in the injected markup?


	function getWrapInsertion(/*DOMNode*/node){
		// summary:
		//		finds the innermost element to use for wrap insertion.

		//Make it easy, assume single nesting, no siblings.
		while(node.childNodes[0] && node.childNodes[0].nodeType == 1){
			node = node.childNodes[0];
		}
		return node; //DOMNode
	}

	function makeWrapNode(/*DOMNode||String*/html, /*DOMNode*/refNode){
		// summary:
		//		convert HTML into nodes if it is not already a node.
		if(typeof html == "string"){
			html = construct.toDom(html, (refNode && refNode.ownerDocument));
			if(html.nodeType == 11){
				//DocumentFragment cannot handle cloneNode, so choose first child.
				html = html.childNodes[0];
			}
		}else if(html.nodeType == 1 && html.parentNode){
			//This element is already in the DOM clone it, but not its children.
			html = html.cloneNode(false);
		}
		return html; /*DOMNode*/
	}

	lang.extend(NodeList, {
		_placeMultiple: function(/*String||Node||NodeList*/query, /*String*/position){
			// summary:
			//		private method for inserting queried nodes into all nodes in this NodeList
			//		at different positions. Differs from NodeList.place because it will clone
			//		the nodes in this NodeList if the query matches more than one element.
			var nl2 = typeof query == "string" || query.nodeType ? dquery(query) : query;
			var toAdd = [];
			for(var i = 0; i < nl2.length; i++){
				//Go backwards in DOM to make dom insertions easier via insertBefore
				var refNode = nl2[i];
				var length = this.length;
				for(var j = length - 1, item; item = this[j]; j--){
					if(i > 0){
						//Need to clone the item. This also means
						//it needs to be added to the current NodeList
						//so it can also be the target of other chaining operations.
						item = this._cloneNode(item);
						toAdd.unshift(item);
					}
					if(j == length - 1){
						construct.place(item, refNode, position);
					}else{
						refNode.parentNode.insertBefore(item, refNode);
					}
					refNode = item;
				}
			}

			if(toAdd.length){
				//Add the toAdd items to the current NodeList. Build up list of args
				//to pass to splice.
				toAdd.unshift(0);
				toAdd.unshift(this.length - 1);
				Array.prototype.splice.apply(this, toAdd);
			}

			return this; // dojo/NodeList
		},

		innerHTML: function(/*String|DOMNode|NodeList?*/ value){
			// summary:
			//		allows setting the innerHTML of each node in the NodeList,
			//		if there is a value passed in, otherwise, reads the innerHTML value of the first node.
			// description:
			//		This method is simpler than the dojo/NodeList.html() method provided by
			//		`dojo/NodeList-html`. This method just does proper innerHTML insertion of HTML fragments,
			//		and it allows for the innerHTML to be read for the first node in the node list.
			//		Since dojo/NodeList-html already took the "html" name, this method is called
			//		"innerHTML". However, if dojo/NodeList-html has not been loaded yet, this
			//		module will define an "html" method that can be used instead. Be careful if you
			//		are working in an environment where it is possible that dojo/NodeList-html could
			//		have been loaded, since its definition of "html" will take precedence.
			//		The nodes represented by the value argument will be cloned if more than one
			//		node is in this NodeList. The nodes in this NodeList are returned in the "set"
			//		usage of this method, not the HTML that was inserted.
			// returns:
			//		if no value is passed, the result is String, the innerHTML of the first node.
			//		If a value is passed, the return is this dojo/NodeList
			// example:
			//		assume a DOM created by this markup:
			//	|	<div id="foo"></div>
			//	|	<div id="bar"></div>
			//		This code inserts `<p>Hello World</p>` into both divs:
			//	|	require(["dojo/query", "dojo/NodeList-manipulate"
			//	|	], function(query){
			//	|		query("div").innerHTML("<p>Hello World</p>");
			//	| 	});
			// example:
			//		assume a DOM created by this markup:
			//	|	<div id="foo"><p>Hello Mars</p></div>
			//	|	<div id="bar"><p>Hello World</p></div>
			//		This code returns `<p>Hello Mars</p>`:
			//	|	require(["dojo/query", "dojo/NodeList-manipulate"
			//	|	], function(query){
			//	|		var message = query("div").innerHTML();
			//	| 	});
			if(arguments.length){
				return this.addContent(value, "only"); // dojo/NodeList
			}else{
				return this[0].innerHTML; //String
			}
		},

		/*=====
		html: function(value){
			// summary:
			//		see the information for "innerHTML". "html" is an alias for "innerHTML", but is
			//		only defined if dojo/NodeList-html has not been loaded.
			// description:
			//		An alias for the "innerHTML" method, but only defined if there is not an existing
			//		"html" method on dojo/NodeList. Be careful if you are working in an environment
			//		where it is possible that dojo/NodeList-html could have been loaded, since its
			//		definition of "html" will take precedence. If you are not sure if dojo/NodeList-html
			//		could be loaded, use the "innerHTML" method.
			// value: String|DOMNode|NodeList?
			//		The HTML fragment to use as innerHTML. If value is not passed, then the innerHTML
			//		of the first element in this NodeList is returned.
			// returns:
			//		if no value is passed, the result is String, the innerHTML of the first node.
			//		If a value is passed, the return is this dojo/NodeList
			return; // dojo/NodeList|String
		},
		=====*/

		text: function(/*String*/value){
			// summary:
			//		Allows setting the text value of each node in the NodeList,
			//		if there is a value passed in.  Otherwise, returns the text value for all the
			//		nodes in the NodeList in one string.
			// example:
			//		Assume a DOM created by this markup:
			//	|	<div id="foo"></div>
			//	|	<div id="bar"></div>
			//		This code inserts "Hello World" into both divs:
			//	|	require(["dojo/query", "dojo/NodeList-manipulate"], function(query){
			//	|		query("div").text("Hello World");
			//	| 	});
			// example:
			//		Assume a DOM created by this markup:
			//	|	<div id="foo"><p>Hello Mars <span>today</span></p></div>
			//	|	<div id="bar"><p>Hello World</p></div>
			//		This code writes "Hello Mars todayHello World" to the console:
			//	|	require(["dojo/query", "dojo/NodeList-manipulate"], function(query){
			//	|		console.log(query("div").text());
			//	| 	});
			// returns:
			//		If no value is passed, the result is String: the text value of the nodes.
			//		If a value is passed, the return is this dojo/NodeList.
			if(arguments.length){
				for(var i = 0, node; node = this[i]; i++){
					if(node.nodeType == 1){
						attr.set(node, 'textContent', value);
					}
				}
				return this; // dojo/NodeList
			}else{
				var result = "";
				for(i = 0; node = this[i]; i++){
					result += attr.get(node, 'textContent');
				}
				return result; //String
			}
		},

		val: function(/*String||Array*/value){
			// summary:
			//		If a value is passed, allows setting the value property of form elements in this
			//		NodeList, or properly selecting/checking the right value for radio/checkbox/select
			//		elements. If no value is passed, the value of the first node in this NodeList
			//		is returned.
			// returns:
			//		if no value is passed, the result is String or an Array, for the value of the
			//		first node.
			//		If a value is passed, the return is this dojo/NodeList
			// example:
			//		assume a DOM created by this markup:
			//	|	<input type="text" value="foo">
			//	|	<select multiple>
			//	|		<option value="red" selected>Red</option>
			//	|		<option value="blue">Blue</option>
			//	|		<option value="yellow" selected>Yellow</option>
			//	|	</select>
			//		This code gets and sets the values for the form fields above:
			//	|	require(["dojo/query", "dojo/NodeList-manipulate"
			//	|	], function(query){
			//	|		query('[type="text"]').val(); //gets value foo
			//	|		query('[type="text"]').val("bar"); //sets the input's value to "bar"
			// 	|		query("select").val() //gets array value ["red", "yellow"]
			// 	|		query("select").val(["blue", "yellow"]) //Sets the blue and yellow options to selected.
			//	| 	});

			//Special work for input elements.
			if(arguments.length){
				var isArray = lang.isArray(value);
				for(var index = 0, node; node = this[index]; index++){
					var name = node.nodeName.toUpperCase();
					var type = node.type;
					var newValue = isArray ? value[index] : value;

					if(name == "SELECT"){
						var opts = node.options;
						for(var i = 0; i < opts.length; i++){
							var opt = opts[i];
							if(node.multiple){
								opt.selected = (array.indexOf(value, opt.value) != -1);
							}else{
								opt.selected = (opt.value == newValue);
							}
						}
					}else if(type == "checkbox" || type == "radio"){
						node.checked = (node.value == newValue);
					}else{
						node.value = newValue;
					}
				}
				return this; // dojo/NodeList
			}else{
				//node already declared above.
				node = this[0];
				if(!node || node.nodeType != 1){
					return undefined;
				}
				value = node.value || "";
				if(node.nodeName.toUpperCase() == "SELECT" && node.multiple){
					//A multivalued selectbox. Do the pain.
					value = [];
					//opts declared above in if block.
					opts = node.options;
					//i declared above in if block;
					for(i = 0; i < opts.length; i++){
						//opt declared above in if block
						opt = opts[i];
						if(opt.selected){
							value.push(opt.value);
						}
					}
					if(!value.length){
						value = null;
					}
				}
				return value; //String||Array
			}
		},

		append: function(/*String||DOMNode||NodeList*/content){
			// summary:
			//		appends the content to every node in the NodeList.
			// description:
			//		The content will be cloned if the length of NodeList
			//		is greater than 1. Only the DOM nodes are cloned, not
			//		any attached event handlers.
			// returns:
			//		dojo/NodeList, the nodes currently in this NodeList will be returned,
			//		not the appended content.
			// example:
			//		assume a DOM created by this markup:
			//	|	<div id="foo"><p>Hello Mars</p></div>
			//	|	<div id="bar"><p>Hello World</p></div>
			//		Running this code:
			//	|	require(["dojo/query", "dojo/NodeList-manipulate"
			//	|	], function(query){
			//	|		query("div").append("<span>append</span>");
			//	| 	});
			//		Results in this DOM structure:
			//	|	<div id="foo"><p>Hello Mars</p><span>append</span></div>
			//	|	<div id="bar"><p>Hello World</p><span>append</span></div>
			return this.addContent(content, "last"); // dojo/NodeList
		},

		appendTo: function(/*String*/query){
			// summary:
			//		appends nodes in this NodeList to the nodes matched by
			//		the query passed to appendTo.
			// description:
			//		The nodes in this NodeList will be cloned if the query
			//		matches more than one element. Only the DOM nodes are cloned, not
			//		any attached event handlers.
			// returns:
			//		dojo/NodeList, the nodes currently in this NodeList will be returned,
			//		not the matched nodes from the query.
			// example:
			//		assume a DOM created by this markup:
			//	|	<span>append</span>
			//	|	<p>Hello Mars</p>
			//	|	<p>Hello World</p>
			//		Running this code:
			//	|	require(["dojo/query", "dojo/NodeList-manipulate"
			//	|	], function(query){
			//	|		query("span").appendTo("p");
			//	| 	});
			//		Results in this DOM structure:
			//	|	<p>Hello Mars<span>append</span></p>
			//	|	<p>Hello World<span>append</span></p>
			return this._placeMultiple(query, "last"); // dojo/NodeList
		},

		prepend: function(/*String||DOMNode||NodeList*/content){
			// summary:
			//		prepends the content to every node in the NodeList.
			// description:
			//		The content will be cloned if the length of NodeList
			//		is greater than 1. Only the DOM nodes are cloned, not
			//		any attached event handlers.
			// returns:
			//		dojo/NodeList, the nodes currently in this NodeList will be returned,
			//		not the appended content.
			//		assume a DOM created by this markup:
			//	|	<div id="foo"><p>Hello Mars</p></div>
			//	|	<div id="bar"><p>Hello World</p></div>
			//		Running this code:
			//	|	require(["dojo/query", "dojo/NodeList-manipulate"
			//	|	], function(query){
			//	|		query("div").prepend("<span>prepend</span>");
			//	| 	});
			//		Results in this DOM structure:
			//	|	<div id="foo"><span>prepend</span><p>Hello Mars</p></div>
			//	|	<div id="bar"><span>prepend</span><p>Hello World</p></div>
			return this.addContent(content, "first"); // dojo/NodeList
		},

		prependTo: function(/*String*/query){
			// summary:
			//		prepends nodes in this NodeList to the nodes matched by
			//		the query passed to prependTo.
			// description:
			//		The nodes in this NodeList will be cloned if the query
			//		matches more than one element. Only the DOM nodes are cloned, not
			//		any attached event handlers.
			// returns:
			//		dojo/NodeList, the nodes currently in this NodeList will be returned,
			//		not the matched nodes from the query.
			// example:
			//		assume a DOM created by this markup:
			//	|	<span>prepend</span>
			//	|	<p>Hello Mars</p>
			//	|	<p>Hello World</p>
			//		Running this code:
			//	|	require(["dojo/query", "dojo/NodeList-manipulate"
			//	|	], function(query){
			//	|		query("span").prependTo("p");
			//	| 	});
			//		Results in this DOM structure:
			//	|	<p><span>prepend</span>Hello Mars</p>
			//	|	<p><span>prepend</span>Hello World</p>
			return this._placeMultiple(query, "first"); // dojo/NodeList
		},

		after: function(/*String||Element||NodeList*/content){
			// summary:
			//		Places the content after every node in the NodeList.
			// description:
			//		The content will be cloned if the length of NodeList
			//		is greater than 1. Only the DOM nodes are cloned, not
			//		any attached event handlers.
			// returns:
			//		dojo/NodeList, the nodes currently in this NodeList will be returned,
			//		not the appended content.
			// example:
			//		assume a DOM created by this markup:
			//	|	<div id="foo"><p>Hello Mars</p></div>
			//	|	<div id="bar"><p>Hello World</p></div>
			//		Running this code:
			//	|	require(["dojo/query", "dojo/NodeList-manipulate"
			//	|	], function(query){
			//	|		query("div").after("<span>after</span>");
			//	| 	});
			//		Results in this DOM structure:
			//	|	<div id="foo"><p>Hello Mars</p></div><span>after</span>
			//	|	<div id="bar"><p>Hello World</p></div><span>after</span>
			return this.addContent(content, "after"); // dojo/NodeList
		},

		insertAfter: function(/*String*/query){
			// summary:
			//		The nodes in this NodeList will be placed after the nodes
			//		matched by the query passed to insertAfter.
			// description:
			//		The nodes in this NodeList will be cloned if the query
			//		matches more than one element. Only the DOM nodes are cloned, not
			//		any attached event handlers.
			// returns:
			//		dojo/NodeList, the nodes currently in this NodeList will be returned,
			//		not the matched nodes from the query.
			// example:
			//		assume a DOM created by this markup:
			//	|	<span>after</span>
			//	|	<p>Hello Mars</p>
			//	|	<p>Hello World</p>
			//		Running this code:
			//	|	require(["dojo/query", "dojo/NodeList-manipulate"
			//	|	], function(query){
			//	|		query("span").insertAfter("p");
			//	| 	});
			//		Results in this DOM structure:
			//	|	<p>Hello Mars</p><span>after</span>
			//	|	<p>Hello World</p><span>after</span>
			return this._placeMultiple(query, "after"); // dojo/NodeList
		},

		before: function(/*String||DOMNode||NodeList*/content){
			// summary:
			//		Places the content before every node in the NodeList.
			// description:
			//		The content will be cloned if the length of NodeList
			//		is greater than 1. Only the DOM nodes are cloned, not
			//		any attached event handlers.
			// returns:
			//		dojo/NodeList, the nodes currently in this NodeList will be returned,
			//		not the appended content.
			// example:
			//		assume a DOM created by this markup:
			//	|	<div id="foo"><p>Hello Mars</p></div>
			//	|	<div id="bar"><p>Hello World</p></div>
			//		Running this code:
			//	|	require(["dojo/query", "dojo/NodeList-manipulate"
			//	|	], function(query){
			//	|		query("div").before("<span>before</span>");
			//	| 	});
			//		Results in this DOM structure:
			//	|	<span>before</span><div id="foo"><p>Hello Mars</p></div>
			//	|	<span>before</span><div id="bar"><p>Hello World</p></div>
			return this.addContent(content, "before"); // dojo/NodeList
		},

		insertBefore: function(/*String*/query){
			// summary:
			//		The nodes in this NodeList will be placed after the nodes
			//		matched by the query passed to insertAfter.
			// description:
			//		The nodes in this NodeList will be cloned if the query
			//		matches more than one element. Only the DOM nodes are cloned, not
			//		any attached event handlers.
			// returns:
			//		dojo/NodeList, the nodes currently in this NodeList will be returned,
			//		not the matched nodes from the query.
			// example:
			//		assume a DOM created by this markup:
			//	|	<span>before</span>
			//	|	<p>Hello Mars</p>
			//	|	<p>Hello World</p>
			//		Running this code:
			//	|	require(["dojo/query", "dojo/NodeList-manipulate"
			//	|	], function(query){
			//	|		query("span").insertBefore("p");
			//	| 	});
			//		Results in this DOM structure:
			//	|	<span>before</span><p>Hello Mars</p>
			//	|	<span>before</span><p>Hello World</p>
			return this._placeMultiple(query, "before"); // dojo/NodeList
		},

		/*=====
		remove: function(simpleFilter){
			// summary:
			//		alias for dojo/NodeList's orphan method. Removes elements
			//		in this list that match the simple filter from their parents
			//		and returns them as a new NodeList.
			// simpleFilter: String
			//		single-expression CSS rule. For example, ".thinger" or
			//		"#someId[attrName='value']" but not "div > span". In short,
			//		anything which does not invoke a descent to evaluate but
			//		can instead be used to test a single node is acceptable.

			return; // dojo/NodeList
		},
		=====*/
		remove: NodeList.prototype.orphan,

		wrap: function(/*String||DOMNode*/html){
			// summary:
			//		Wrap each node in the NodeList with html passed to wrap.
			// description:
			//		html will be cloned if the NodeList has more than one
			//		element. Only DOM nodes are cloned, not any attached
			//		event handlers.
			// returns:
			//		the nodes in the current NodeList will be returned,
			//		not the nodes from html argument.
			// example:
			//		assume a DOM created by this markup:
			//	|	<b>one</b>
			//	|	<b>two</b>
			//		Running this code:
			//	|	require(["dojo/query", "dojo/NodeList-manipulate"
			//	|	], function(query){
			//	|		query("b").wrap("<div><span></span></div>");
			//	| 	});
			//		Results in this DOM structure:
			//	|	<div><span><b>one</b></span></div>
			//	|	<div><span><b>two</b></span></div>
			if(this[0]){
				html = makeWrapNode(html, this[0]);

				//Now cycle through the elements and do the insertion.
				for(var i = 0, node; node = this[i]; i++){
					//Always clone because if html is used to hold one of
					//the "this" nodes, then on the clone of html it will contain
					//that "this" node, and that would be bad.
					var clone = this._cloneNode(html);
					if(node.parentNode){
						node.parentNode.replaceChild(clone, node);
					}
					//Find deepest element and insert old node in it.
					var insertion = getWrapInsertion(clone);
					insertion.appendChild(node);
				}
			}
			return this; // dojo/NodeList
		},

		wrapAll: function(/*String||DOMNode*/html){
			// summary:
			//		Insert html where the first node in this NodeList lives, then place all
			//		nodes in this NodeList as the child of the html.
			// returns:
			//		the nodes in the current NodeList will be returned,
			//		not the nodes from html argument.
			// example:
			//		assume a DOM created by this markup:
			//	|	<div class="container">
			// 	|		<div class="red">Red One</div>
			// 	|		<div class="blue">Blue One</div>
			// 	|		<div class="red">Red Two</div>
			// 	|		<div class="blue">Blue Two</div>
			//	|	</div>
			//		Running this code:
			//	|	require(["dojo/query", "dojo/NodeList-manipulate"
			//	|	], function(query){
			//	|		query(".red").wrapAll('<div class="allRed"></div>');
			//	| 	});
			//		Results in this DOM structure:
			//	|	<div class="container">
			// 	|		<div class="allRed">
			// 	|			<div class="red">Red One</div>
			// 	|			<div class="red">Red Two</div>
			// 	|		</div>
			// 	|		<div class="blue">Blue One</div>
			// 	|		<div class="blue">Blue Two</div>
			//	|	</div>
			if(this[0]){
				html = makeWrapNode(html, this[0]);

				//Place the wrap HTML in place of the first node.
				this[0].parentNode.replaceChild(html, this[0]);

				//Now cycle through the elements and move them inside
				//the wrap.
				var insertion = getWrapInsertion(html);
				for(var i = 0, node; node = this[i]; i++){
					insertion.appendChild(node);
				}
			}
			return this; // dojo/NodeList
		},

		wrapInner: function(/*String||DOMNode*/html){
			// summary:
			//		For each node in the NodeList, wrap all its children with the passed in html.
			// description:
			//		html will be cloned if the NodeList has more than one
			//		element. Only DOM nodes are cloned, not any attached
			//		event handlers.
			// returns:
			//		the nodes in the current NodeList will be returned,
			//		not the nodes from html argument.
			// example:
			//		assume a DOM created by this markup:
			//	|	<div class="container">
			// 	|		<div class="red">Red One</div>
			// 	|		<div class="blue">Blue One</div>
			// 	|		<div class="red">Red Two</div>
			// 	|		<div class="blue">Blue Two</div>
			//	|	</div>
			//		Running this code:
			//	|	require(["dojo/query", "dojo/NodeList-manipulate"
			//	|	], function(query){
			//	|		query(".red").wrapInner('<span class="special"></span>');
			//	| 	});
			//		Results in this DOM structure:
			//	|	<div class="container">
			// 	|		<div class="red"><span class="special">Red One</span></div>
			// 	|		<div class="blue">Blue One</div>
			// 	|		<div class="red"><span class="special">Red Two</span></div>
			// 	|		<div class="blue">Blue Two</div>
			//	|	</div>
			if(this[0]){
				html = makeWrapNode(html, this[0]);
				for(var i = 0; i < this.length; i++){
					//Always clone because if html is used to hold one of
					//the "this" nodes, then on the clone of html it will contain
					//that "this" node, and that would be bad.
					var clone = this._cloneNode(html);

					//Need to convert the childNodes to an array since wrapAll modifies the
					//DOM and can change the live childNodes NodeList.
					this._wrap(lang._toArray(this[i].childNodes), null, this._NodeListCtor).wrapAll(clone);
				}
			}
			return this; // dojo/NodeList
		},

		replaceWith: function(/*String||DOMNode||NodeList*/content){
			// summary:
			//		Replaces each node in ths NodeList with the content passed to replaceWith.
			// description:
			//		The content will be cloned if the length of NodeList
			//		is greater than 1. Only the DOM nodes are cloned, not
			//		any attached event handlers.
			// returns:
			//		The nodes currently in this NodeList will be returned, not the replacing content.
			//		Note that the returned nodes have been removed from the DOM.
			// example:
			//		assume a DOM created by this markup:
			//	|	<div class="container">
			// 	|		<div class="red">Red One</div>
			// 	|		<div class="blue">Blue One</div>
			// 	|		<div class="red">Red Two</div>
			// 	|		<div class="blue">Blue Two</div>
			//	|	</div>
			//		Running this code:
			//	|	require(["dojo/query", "dojo/NodeList-manipulate"
			//	|	], function(query){
			//	|		query(".red").replaceWith('<div class="green">Green</div>');
			//	| 	});
			//		Results in this DOM structure:
			//	|	<div class="container">
			// 	|		<div class="green">Green</div>
			// 	|		<div class="blue">Blue One</div>
			// 	|		<div class="green">Green</div>
			// 	|		<div class="blue">Blue Two</div>
			//	|	</div>
			content = this._normalize(content, this[0]);
			for(var i = 0, node; node = this[i]; i++){
				this._place(content, node, "before", i > 0);
				node.parentNode.removeChild(node);
			}
			return this; // dojo/NodeList
		},

		replaceAll: function(/*String*/query){
			// summary:
			//		replaces nodes matched by the query passed to replaceAll with the nodes
			//		in this NodeList.
			// description:
			//		The nodes in this NodeList will be cloned if the query
			//		matches more than one element. Only the DOM nodes are cloned, not
			//		any attached event handlers.
			// returns:
			//		The nodes currently in this NodeList will be returned, not the matched nodes
			//		from the query. The nodes currently in this NodeLIst could have
			//		been cloned, so the returned NodeList will include the cloned nodes.
			// example:
			//		assume a DOM created by this markup:
			//	|	<div class="container">
			// 	|		<div class="spacer">___</div>
			// 	|		<div class="red">Red One</div>
			// 	|		<div class="spacer">___</div>
			// 	|		<div class="blue">Blue One</div>
			// 	|		<div class="spacer">___</div>
			// 	|		<div class="red">Red Two</div>
			// 	|		<div class="spacer">___</div>
			// 	|		<div class="blue">Blue Two</div>
			//	|	</div>
			//		Running this code:
			//	|	require(["dojo/query", "dojo/NodeList-manipulate"
			//	|	], function(query){
			//	|		query(".red").replaceAll(".blue");
			//	| 	});
			//		Results in this DOM structure:
			//	|	<div class="container">
			// 	|		<div class="spacer">___</div>
			// 	|		<div class="spacer">___</div>
			// 	|		<div class="red">Red One</div>
			// 	|		<div class="red">Red Two</div>
			// 	|		<div class="spacer">___</div>
			// 	|		<div class="spacer">___</div>
			// 	|		<div class="red">Red One</div>
			// 	|		<div class="red">Red Two</div>
			//	|	</div>
			var nl = dquery(query);
			var content = this._normalize(this, this[0]);
			for(var i = 0, node; node = nl[i]; i++){
				this._place(content, node, "before", i > 0);
				node.parentNode.removeChild(node);
			}
			return this; // dojo/NodeList
		},

		clone: function(){
			// summary:
			//		Clones all the nodes in this NodeList and returns them as a new NodeList.
			// description:
			//		Only the DOM nodes are cloned, not any attached event handlers.
			// returns:
			//		a cloned set of the original nodes.
			// example:
			//		assume a DOM created by this markup:
			//	|	<div class="container">
			// 	|		<div class="red">Red One</div>
			// 	|		<div class="blue">Blue One</div>
			// 	|		<div class="red">Red Two</div>
			// 	|		<div class="blue">Blue Two</div>
			//	|	</div>
			//		Running this code:
			//	|	require(["dojo/query", "dojo/NodeList-manipulate"
			//	|	], function(query){
			//	|		query(".red").clone().appendTo(".container");
			//	| 	});
			//		Results in this DOM structure:
			//	|	<div class="container">
			// 	|		<div class="red">Red One</div>
			// 	|		<div class="blue">Blue One</div>
			// 	|		<div class="red">Red Two</div>
			// 	|		<div class="blue">Blue Two</div>
			// 	|		<div class="red">Red One</div>
			// 	|		<div class="red">Red Two</div>
			//	|	</div>

			//TODO: need option to clone events?
			var ary = [];
			for(var i = 0; i < this.length; i++){
				ary.push(this._cloneNode(this[i]));
			}
			return this._wrap(ary, this, this._NodeListCtor); // dojo/NodeList
		}
	});

	//set up html method if one does not exist
	if(!NodeList.prototype.html){
		NodeList.prototype.html = NodeList.prototype.innerHTML;
	}

	return NodeList;
});

},
'dojo/NodeList-dom':function(){
define(["./_base/kernel", "./query", "./_base/array", "./_base/lang", "./dom-class", "./dom-construct", "./dom-geometry", "./dom-attr", "./dom-style"], function(dojo, query, array, lang, domCls, domCtr, domGeom, domAttr, domStyle){

	// module:
	//		dojo/NodeList-dom.js

	/*=====
	 return function(){
		 // summary:
		 //		Adds DOM related methods to NodeList, and returns NodeList constructor.
	 };
	 =====*/

	var magicGuard = function(a){
		// summary:
		//		the guard function for dojo/dom-attr() and dojo/dom-style()
		return a.length == 1 && (typeof a[0] == "string"); // inline'd type check
	};

	var orphan = function(node){
		// summary:
		//		function to orphan nodes
		var p = node.parentNode;
		if(p){
			p.removeChild(node);
		}
	};
	// FIXME: should we move orphan() to dojo/_base/html?

	var NodeList = query.NodeList,
		awc = NodeList._adaptWithCondition,
		aafe = NodeList._adaptAsForEach,
		aam = NodeList._adaptAsMap;

	function getSet(module){
		return function(node, name, value){
			if(arguments.length == 2){
				return module[typeof name == "string" ? "get" : "set"](node, name);
			}
			// setter
			return module.set(node, name, value);
		};
	}

	lang.extend(NodeList, {
		_normalize: function(/*String||Element||Object||NodeList*/content, /*DOMNode?*/refNode){
			// summary:
			//		normalizes data to an array of items to insert.
			// description:
			//		If content is an object, it can have special properties "template" and
			//		"parse". If "template" is defined, then the template value is run through
			//		dojo/string.substitute (if dojo/string.substitute() has been required elsewhere),
			//		or if templateFunc is a function on the content, that function will be used to
			//		transform the template into a final string to be used for for passing to dojo/dom-construct.toDom().
			//		If content.parse is true, then it is remembered for later, for when the content
			//		nodes are inserted into the DOM. At that point, the nodes will be parsed for widgets
			//		(if dojo/parser has been required elsewhere).

			//Wanted to just use a DocumentFragment, but for the array/NodeList
			//case that meant using cloneNode, but we may not want that.
			//Cloning should only happen if the node operations span
			//multiple refNodes. Also, need a real array, not a NodeList from the
			//DOM since the node movements could change those NodeLists.

			var parse = content.parse === true;

			//Do we have an object that needs to be run through a template?
			if(typeof content.template == "string"){
				var templateFunc = content.templateFunc || (dojo.string && dojo.string.substitute);
				content = templateFunc ? templateFunc(content.template, content) : content;
			}

			var type = (typeof content);
			if(type == "string" || type == "number"){
				content = domCtr.toDom(content, (refNode && refNode.ownerDocument));
				if(content.nodeType == 11){
					//DocumentFragment. It cannot handle cloneNode calls, so pull out the children.
					content = lang._toArray(content.childNodes);
				}else{
					content = [content];
				}
			}else if(!lang.isArrayLike(content)){
				content = [content];
			}else if(!lang.isArray(content)){
				//To get to this point, content is array-like, but
				//not an array, which likely means a DOM NodeList. Convert it now.
				content = lang._toArray(content);
			}

			//Pass around the parse info
			if(parse){
				content._runParse = true;
			}
			return content; //Array
		},

		_cloneNode: function(/*DOMNode*/ node){
			// summary:
			//		private utility to clone a node. Not very interesting in the vanilla
			//		dojo/NodeList case, but delegates could do interesting things like
			//		clone event handlers if that is derivable from the node.
			return node.cloneNode(true);
		},

		_place: function(/*Array*/ary, /*DOMNode*/refNode, /*String*/position, /*Boolean*/useClone){
			// summary:
			//		private utility to handle placing an array of nodes relative to another node.
			// description:
			//		Allows for cloning the nodes in the array, and for
			//		optionally parsing widgets, if ary._runParse is true.

			//Avoid a disallowed operation if trying to do an innerHTML on a non-element node.
			if(refNode.nodeType != 1 && position == "only"){
				return;
			}
			var rNode = refNode, tempNode;

			//Always cycle backwards in case the array is really a
			//DOM NodeList and the DOM operations take it out of the live collection.
			var length = ary.length;
			for(var i = length - 1; i >= 0; i--){
				var node = (useClone ? this._cloneNode(ary[i]) : ary[i]);

				//If need widget parsing, use a temp node, instead of waiting after inserting into
				//real DOM because we need to start widget parsing at one node up from current node,
				//which could cause some already parsed widgets to be parsed again.
				if(ary._runParse && dojo.parser && dojo.parser.parse){
					if(!tempNode){
						tempNode = rNode.ownerDocument.createElement("div");
					}
					tempNode.appendChild(node);
					dojo.parser.parse(tempNode);
					node = tempNode.firstChild;
					while(tempNode.firstChild){
						tempNode.removeChild(tempNode.firstChild);
					}
				}

				if(i == length - 1){
					domCtr.place(node, rNode, position);
				}else{
					rNode.parentNode.insertBefore(node, rNode);
				}
				rNode = node;
			}
		},


		position: aam(domGeom.position),
		/*=====
		position: function(){
			// summary:
			//		Returns border-box objects (x/y/w/h) of all elements in a node list
			//		as an Array (*not* a NodeList). Acts like `dojo/dom-geometry-position`, though
			//		assumes the node passed is each node in this list.

			return dojo.map(this, dojo.position); // Array
		},
		=====*/

		attr: awc(getSet(domAttr), magicGuard),
		/*=====
		attr: function(property, value){
			// summary:
			//		gets or sets the DOM attribute for every element in the
			//		NodeList. See also `dojo/dom-attr`
			// property: String
			//		the attribute to get/set
			// value: String?
			//		optional. The value to set the property to
			// returns:
			//		if no value is passed, the result is an array of attribute values
			//		If a value is passed, the return is this NodeList
			// example:
			//		Make all nodes with a particular class focusable:
			//	|	require(["dojo/query", "dojo/NodeList-dom"], function(query){
			//	|		query(".focusable").attr("tabIndex", -1);
			//	|	});
			// example:
			//		Disable a group of buttons:
			//	|	require(["dojo/query", "dojo/NodeList-dom"], function(query){
			//	|		query("button.group").attr("disabled", true);
			//	|	});
			// example:
			//		innerHTML can be assigned or retrieved as well:
			//	|	// get the innerHTML (as an array) for each list item
			//	|	require(["dojo/query", "dojo/NodeList-dom"], function(query){
			//	|		var ih = query("li.replaceable").attr("innerHTML");
			//	|	});
			return; // dojo/NodeList|Array
		},
		=====*/

		style: awc(getSet(domStyle), magicGuard),
		/*=====
		style: function(property, value){
			// summary:
			//		gets or sets the CSS property for every element in the NodeList
			// property: String
			//		the CSS property to get/set, in JavaScript notation
			//		("lineHieght" instead of "line-height")
			// value: String?
			//		optional. The value to set the property to
			// returns:
			//		if no value is passed, the result is an array of strings.
			//		If a value is passed, the return is this NodeList
			return; // dojo/NodeList
			return; // Array
		},
		=====*/

		addClass: aafe(domCls.add),
		/*=====
		addClass: function(className){
			// summary:
			//		adds the specified class to every node in the list
			// className: String|Array
			//		A String class name to add, or several space-separated class names,
			//		or an array of class names.
			return; // dojo/NodeList
		},
		=====*/

		removeClass: aafe(domCls.remove),
		/*=====
		removeClass: function(className){
			// summary:
			//		removes the specified class from every node in the list
			// className: String|Array?
			//		An optional String class name to remove, or several space-separated
			//		class names, or an array of class names. If omitted, all class names
			//		will be deleted.
			// returns:
			//		this list
			return; // dojo/NodeList
		},
		=====*/

		toggleClass: aafe(domCls.toggle),
		/*=====
		toggleClass: function(className, condition){
			// summary:
			//		Adds a class to node if not present, or removes if present.
			//		Pass a boolean condition if you want to explicitly add or remove.
			// condition: Boolean?
			//		If passed, true means to add the class, false means to remove.
			// className: String
			//		the CSS class to add
			return; // dojo/NodeList
		},
		=====*/

		replaceClass: aafe(domCls.replace),
		/*=====
		replaceClass: function(addClassStr, removeClassStr){
			// summary:
			//		Replaces one or more classes on a node if not present.
			//		Operates more quickly than calling `removeClass()` and `addClass()`
			// addClassStr: String|Array
			//		A String class name to add, or several space-separated class names,
			//		or an array of class names.
			// removeClassStr: String|Array?
			//		A String class name to remove, or several space-separated class names,
			//		or an array of class names.
			return; // dojo/NodeList
		 },
		 =====*/

		empty: aafe(domCtr.empty),
		/*=====
		empty: function(){
			// summary:
			//		clears all content from each node in the list. Effectively
			//		equivalent to removing all child nodes from every item in
			//		the list.
			return this.forEach("item.innerHTML='';"); // dojo/NodeList
			// FIXME: should we be checking for and/or disposing of widgets below these nodes?
		},
		=====*/

		removeAttr: aafe(domAttr.remove),
		/*=====
		 removeAttr: function(name){
			// summary:
			//		Removes an attribute from each node in the list.
			// name: String
			//		the name of the attribute to remove
			return;		// dojo/NodeList
		},
		=====*/

		marginBox: aam(domGeom.getMarginBox),
		/*=====
		marginBox: function(){
			// summary:
			//		Returns margin-box size of nodes
		 	return; // dojo/NodeList
		 },
		 =====*/

		// FIXME: connectPublisher()? connectRunOnce()?

		/*
		destroy: function(){
			// summary:
			//		destroys every item in the list.
			this.forEach(d.destroy);
			// FIXME: should we be checking for and/or disposing of widgets below these nodes?
		},
		*/

		place: function(/*String||Node*/ queryOrNode, /*String*/ position){
			// summary:
			//		places elements of this node list relative to the first element matched
			//		by queryOrNode. Returns the original NodeList. See: `dojo/dom-construct.place`
			// queryOrNode:
			//		may be a string representing any valid CSS3 selector or a DOM node.
			//		In the selector case, only the first matching element will be used
			//		for relative positioning.
			// position:
			//		can be one of:
			//
			//		-	"last" (default)
			//		-	"first"
			//		-	"before"
			//		-	"after"
			//		-	"only"
			//		-	"replace"
			//
			//		or an offset in the childNodes property
			var item = query(queryOrNode)[0];
			return this.forEach(function(node){ domCtr.place(node, item, position); }); // dojo/NodeList
		},

		orphan: function(/*String?*/ filter){
			// summary:
			//		removes elements in this list that match the filter
			//		from their parents and returns them as a new NodeList.
			// filter:
			//		CSS selector like ".foo" or "div > span"
			// returns:
			//		NodeList containing the orphaned elements
			return (filter ? query._filterResult(this, filter) : this).forEach(orphan); // dojo/NodeList
		},

		adopt: function(/*String||Array||DomNode*/ queryOrListOrNode, /*String?*/ position){
			// summary:
			//		places any/all elements in queryOrListOrNode at a
			//		position relative to the first element in this list.
			//		Returns a dojo/NodeList of the adopted elements.
			// queryOrListOrNode:
			//		a DOM node or a query string or a query result.
			//		Represents the nodes to be adopted relative to the
			//		first element of this NodeList.
			// position:
			//		can be one of:
			//
			//		-	"last" (default)
			//		-	"first"
			//		-	"before"
			//		-	"after"
			//		-	"only"
			//		-	"replace"
			//
			//		or an offset in the childNodes property
			return query(queryOrListOrNode).place(this[0], position)._stash(this);	// dojo/NodeList
		},

		// FIXME: do we need this?
		query: function(/*String*/ queryStr){
			// summary:
			//		Returns a new list whose members match the passed query,
			//		assuming elements of the current NodeList as the root for
			//		each search.
			// example:
			//		assume a DOM created by this markup:
			//	|	<div id="foo">
			//	|		<p>
			//	|			bacon is tasty, <span>dontcha think?</span>
			//	|		</p>
			//	|	</div>
			//	|	<div id="bar">
			//	|		<p>great comedians may not be funny <span>in person</span></p>
			//	|	</div>
			//		If we are presented with the following definition for a NodeList:
			//	|	require(["dojo/dom", "dojo/query", "dojo/NodeList-dom"
			//	|	], function(dom, query){
			//	|		var l = new NodeList(dom.byId("foo"), dom.byId("bar"));
			//		it's possible to find all span elements under paragraphs
			//		contained by these elements with this sub-query:
			//	|		var spans = l.query("p span");
			//	|	});

			// FIXME: probably slow
			if(!queryStr){ return this; }
			var ret = new NodeList;
			this.map(function(node){
				// FIXME: why would we ever get undefined here?
				query(queryStr, node).forEach(function(subNode){
					if(subNode !== undefined){
						ret.push(subNode);
					}
				});
			});
			return ret._stash(this);	// dojo/NodeList
		},

		filter: function(/*String|Function*/ filter){
			// summary:
			//		"masks" the built-in javascript filter() method (supported
			//		in Dojo via `dojo.filter`) to support passing a simple
			//		string filter in addition to supporting filtering function
			//		objects.
			// filter:
			//		If a string, a CSS rule like ".thinger" or "div > span".
			// example:
			//		"regular" JS filter syntax as exposed in dojo.filter:
			//	|	require(["dojo/query", "dojo/NodeList-dom"
			//	|	], function(query){
			//	|		query("*").filter(function(item){
			//	|			// highlight every paragraph
			//	|			return (item.nodeName == "p");
			//	|		}).style("backgroundColor", "yellow");
			//	|	});
			// example:
			//	the same filtering using a CSS selector
			//	|	require(["dojo/query", "dojo/NodeList-dom"
			//	|	], function(query){
			//	|		query("*").filter("p").styles("backgroundColor", "yellow");
			//	|	});
			var a = arguments, items = this, start = 0;
			if(typeof filter == "string"){ // inline'd type check
				items = query._filterResult(this, a[0]);
				if(a.length == 1){
					// if we only got a string query, pass back the filtered results
					return items._stash(this); // dojo/NodeList
				}
				// if we got a callback, run it over the filtered items
				start = 1;
			}
			return this._wrap(array.filter(items, a[start], a[start + 1]), this);	// dojo/NodeList
		},

		/*
		// FIXME: should this be "copyTo" and include parenting info?
		clone: function(){
			// summary:
			//		creates node clones of each element of this list
			//		and returns a new list containing the clones
		},
		*/

		addContent: function(/*String||DomNode||Object||dojo/NodeList*/ content, /*String||Integer?*/ position){
			// summary:
			//		add a node, NodeList or some HTML as a string to every item in the
			//		list.  Returns the original list.
			// description:
			//		a copy of the HTML content is added to each item in the
			//		list, with an optional position argument. If no position
			//		argument is provided, the content is appended to the end of
			//		each item.
			// content:
			//		DOM node, HTML in string format, a NodeList or an Object. If a DOM node or
			//		NodeList, the content will be cloned if the current NodeList has more than one
			//		element. Only the DOM nodes are cloned, no event handlers. If it is an Object,
			//		it should be an object with at "template" String property that has the HTML string
			//		to insert. If dojo.string has already been dojo.required, then dojo.string.substitute
			//		will be used on the "template" to generate the final HTML string. Other allowed
			//		properties on the object are: "parse" if the HTML
			//		string should be parsed for widgets (dojo.require("dojo.parser") to get that
			//		option to work), and "templateFunc" if a template function besides dojo.string.substitute
			//		should be used to transform the "template".
			// position:
			//		can be one of:
			//
			//		-	"last"||"end" (default)
			//		-	"first||"start"
			//		-	"before"
			//		-	"after"
			//		-	"replace" (replaces nodes in this NodeList with new content)
			//		-	"only" (removes other children of the nodes so new content is the only child)
			//
			//		or an offset in the childNodes property
			// example:
			//		appends content to the end if the position is omitted
			//	|	require(["dojo/query", "dojo/NodeList-dom"
			//	|	], function(query){
			//	|		query("h3 > p").addContent("hey there!");
			//	|	});
			// example:
			//		add something to the front of each element that has a
			//		"thinger" property:
			//	|	require(["dojo/query", "dojo/NodeList-dom"
			//	|	], function(query){
			//	|		query("[thinger]").addContent("...", "first");
			//	|	});
			// example:
			//		adds a header before each element of the list
			//	|	require(["dojo/query", "dojo/NodeList-dom"
			//	|	], function(query){
			//	|		query(".note").addContent("<h4>NOTE:</h4>", "before");
			//	|	});
			// example:
			//		add a clone of a DOM node to the end of every element in
			//		the list, removing it from its existing parent.
			//	|	require(["dojo/dom", "dojo/query", "dojo/NodeList-dom"
			//	|	], function(dom, query){
			//	|		query(".note").addContent(dom.byId("foo"));
			//	|	});
			// example:
			//		Append nodes from a templatized string.
			//	|	require(["dojo/string", "dojo/query", "dojo/NodeList-dom"
			//	|	], function(string, query){
			//	|		query(".note").addContent({
			//	|			template: '<b>${id}: </b><span>${name}</span>',
			//	|			id: "user332",
			//	|			name: "Mr. Anderson"
			//	|		});
			//	|	});
			// example:
			//		Append nodes from a templatized string that also has widgets parsed.
			//	|	require(["dojo/string", "dojo/parser", "dojo/query", "dojo/NodeList-dom"
			//	|	], function(string, parser, query){
			//	|		var notes = query(".note").addContent({
			//	|			template: '<button dojoType="dijit/form/Button">${text}</button>',
			//	|			parse: true,
			//	|			text: "Send"
			//	|		});
			//	|	});
			content = this._normalize(content, this[0]);
			for(var i = 0, node; (node = this[i]); i++){
				if(content.length){
					this._place(content, node, position, i > 0);
				}else{
					// if it is an empty array, we empty the target node
					domCtr.empty(node);
				}
			}
			return this; // dojo/NodeList
		}
	});

	return NodeList;
});

},
'dojo/request/iframe':function(){
define([
	'module',
	'require',
	'./watch',
	'./util',
	'./handlers',
	'../_base/lang',
	'../io-query',
	'../query',
	'../has',
	'../dom',
	'../dom-construct',
	'../_base/window',
	// NodeList enhancement modules;
	// must be loaded (but no reference needed)
	'../NodeList-dom',
        '../NodeList-manipulate'
], function(module, require, watch, util, handlers, lang, ioQuery, query, has, dom, domConstruct, win){
	var mid = module.id.replace(/[\/\.\-]/g, '_'),
		onload = mid + '_onload';

	if(!win.global[onload]){
		win.global[onload] = function(){
			var dfd = iframe._currentDfd;
			if(!dfd){
				iframe._fireNextRequest();
				return;
			}

			var response = dfd.response,
				options = response.options,
				formNode = dom.byId(options.form) || dfd._tmpForm;

			if(formNode){
				// remove all the hidden content inputs
				var toClean = dfd._contentToClean;
				for(var i=0; i<toClean.length; i++){
					var key = toClean[i];
					//Need to cycle over all nodes since we may have added
					//an array value which means that more than one node could
					//have the same .name value.
					for(var j=0; j<formNode.childNodes.length; j++){
						var childNode = formNode.childNodes[j];
						if(childNode.name === key){
							domConstruct.destroy(childNode);
							break;
						}
					}
				}

				// restore original action + target
				dfd._originalAction && formNode.setAttribute('action', dfd._originalAction);
				if(dfd._originalMethod){
					formNode.setAttribute('method', dfd._originalMethod);
					formNode.method = dfd._originalMethod;
				}
				if(dfd._originalTarget){
					formNode.setAttribute('target', dfd._originalTarget);
					formNode.target = dfd._originalTarget;
				}
			}

			if(dfd._tmpForm){
				domConstruct.destroy(dfd._tmpForm);
				delete dfd._tmpForm;
			}

			dfd._finished = true;
		};
	}

	function create(name, onloadstr, uri){
		if(win.global[name]){
			return win.global[name];
		}

		if(win.global.frames[name]){
			return win.global.frames[name];
		}

		if(!uri){
			if(has('config-useXDomain') && !has('config-dojoBlankHtmlUrl')){
				console.warn('dojo/request/iframe: When using cross-domain Dojo builds,' +
					' please save dojo/resources/blank.html to your domain and set dojoConfig.dojoBlankHtmlUrl' +
					' to the path on your domain to blank.html');
			}
			uri = (has('config-dojoBlankHtmlUrl')||require.toUrl('dojo/resources/blank.html'));
		}

		var frame = domConstruct.place(
			'<iframe id="'+name+'" name="'+name+'" src="'+uri+'" onload="'+onloadstr+
			'" style="position: absolute; left: 1px; top: 1px; height: 1px; width: 1px; visibility: hidden">',
			win.body());

		win.global[name] = frame;

		return frame;
	}

	function setSrc(_iframe, src, replace){
		var frame = win.global.frames[_iframe.name];

		if(frame.contentWindow){
			// We have an iframe node instead of the window
			frame = frame.contentWindow;
		}

		try{
			if(!replace){
				frame.location = src;
			}else{
				frame.location.replace(src);
			}
		}catch(e){
			console.log('dojo/request/iframe.setSrc: ', e);
		}
	}

	function doc(iframeNode){
		if(iframeNode.contentDocument){
			return iframeNode.contentDocument;
		}
		var name = iframeNode.name;
		if(name){
			var iframes = win.doc.getElementsByTagName('iframe');
			if(iframeNode.document && iframes[name].contentWindow && iframes[name].contentWindow.document){
				return iframes[name].contentWindow.document;
			}else if(win.doc.frames[name] && win.doc.frames[name].document){
				return win.doc.frames[name].document;
			}
		}
		return null;
	}

	function createForm(){
		return domConstruct.create('form', {
			name: mid + '_form',
			style: {
				position: 'absolute',
				top: '-1000px',
				left: '-1000px'
			}
		}, win.body());
	}

	function fireNextRequest(){
		// summary:
		//		Internal method used to fire the next request in the queue.
		var dfd;
		try{
			if(iframe._currentDfd || !iframe._dfdQueue.length){
				return;
			}
			do{
				dfd = iframe._currentDfd = iframe._dfdQueue.shift();
			}while(dfd && (dfd.canceled || (dfd.isCanceled && dfd.isCanceled())) && iframe._dfdQueue.length);

			if(!dfd || dfd.canceled || (dfd.isCanceled && dfd.isCanceled())){
				iframe._currentDfd = null;
				return;
			}

			var response = dfd.response,
				options = response.options,
				c2c = dfd._contentToClean = [],
				formNode = dom.byId(options.form),
				notify = util.notify,
				data = options.data || null,
				queryStr;

			if(!dfd._legacy && options.method === 'POST' && !formNode){
				formNode = dfd._tmpForm = createForm();
			}else if(options.method === 'GET' && formNode && response.url.indexOf('?') > -1){
				queryStr = response.url.slice(response.url.indexOf('?') + 1);
				data = lang.mixin(ioQuery.queryToObject(queryStr), data);
			}

			if(formNode){
				if(!dfd._legacy){
					var parentNode = formNode;
					do{
						parentNode = parentNode.parentNode;
					}while(parentNode && parentNode !== win.doc.documentElement);

					// Append the form node or some browsers won't work
					if(!parentNode){
						formNode.style.position = 'absolute';
						formNode.style.left = '-1000px';
						formNode.style.top = '-1000px';
						win.body().appendChild(formNode);
					}

					if(!formNode.name){
						formNode.name = mid + '_form';
					}
				}

				// if we have things in data, we need to add them to the form
				// before submission
				if(data){
					var createInput = function(name, value){
						domConstruct.create('input', {
							type: 'hidden',
							name: name,
							value: value
						}, formNode);
						c2c.push(name);
					};
					for(var x in data){
						var val = data[x];
						if(lang.isArray(val) && val.length > 1){
							for(var i=0; i<val.length; i++){
								createInput(x, val[i]);
							}
						}else{
							// Explicitly search for nodes in the dom tree
							// using formNode[x] may access attributes of the
							// form node itself, e.g. formNode['action']
							var n = query("input[name='"+x+"']", formNode);

							// Not found if indexOf == -1
							if(n.indexOf() == -1){
								createInput(x, val);
							}else{
								n.val(val);
							}
						}
					}
				}

				//IE requires going through getAttributeNode instead of just getAttribute in some form cases,
				//so use it for all.  See #2844
				var actionNode = formNode.getAttributeNode('action'),
					methodNode = formNode.getAttributeNode('method'),
					targetNode = formNode.getAttributeNode('target');

				if(response.url){
					dfd._originalAction = actionNode ? actionNode.value : null;
					if(actionNode){
						actionNode.value = response.url;
					}else{
						formNode.setAttribute('action', response.url);
					}
				}

				if(!dfd._legacy){
					dfd._originalMethod = methodNode ? methodNode.value : null;
					if(methodNode){
						methodNode.value = options.method;
					}else{
						formNode.setAttribute('method', options.method);
					}
				}else{
					if(!methodNode || !methodNode.value){
						if(methodNode){
							methodNode.value = options.method;
						}else{
							formNode.setAttribute('method', options.method);
						}
					}
				}

				dfd._originalTarget = targetNode ? targetNode.value : null;
				if(targetNode){
					targetNode.value = iframe._iframeName;
				}else{
					formNode.setAttribute('target', iframe._iframeName);
				}
				formNode.target = iframe._iframeName;

				notify && notify.emit('send', response, dfd.promise.cancel);
				iframe._notifyStart(response);
				formNode.submit();
			}else{
				// otherwise we post a GET string by changing URL location for the
				// iframe

				var extra = '';
				if(response.options.data){
					extra = response.options.data;
					if(typeof extra !== 'string'){
						extra = ioQuery.objectToQuery(extra);
					}
				}
				var tmpUrl = response.url + (response.url.indexOf('?') > -1 ? '&' : '?') + extra;
				notify && notify.emit('send', response, dfd.promise.cancel);
				iframe._notifyStart(response);
				iframe.setSrc(iframe._frame, tmpUrl, true);
			}
		}catch(e){
			dfd.reject(e);
		}
	}

	// dojo/request/watch handlers
	function isValid(response){
		return !this.isFulfilled();
	}
	function isReady(response){
		return !!this._finished;
	}
	function handleResponse(response, error){
		if(!error){
			try{
				var options = response.options,
					doc = iframe.doc(iframe._frame),
					handleAs = options.handleAs;

				if(handleAs !== 'html'){
					if(handleAs === 'xml'){
						// IE6-8 have to parse the XML manually. See http://bugs.dojotoolkit.org/ticket/6334
						if(doc.documentElement.tagName.toLowerCase() === 'html'){
							query('a', doc.documentElement).orphan();
							var xmlText = doc.documentElement.innerText || doc.documentElement.textContent;
							xmlText = xmlText.replace(/>\s+</g, '><');
							response.text = lang.trim(xmlText);
						}else{
							response.data = doc;
						}
					}else{
						// 'json' and 'javascript' and 'text'
						response.text = doc.getElementsByTagName('textarea')[0].value; // text
					}
					handlers(response);
				}else{
					response.data = doc;
				}
			}catch(e){
				error = e;
			}
		}

		if(error){
			this.reject(error);
		}else if(this._finished){
			this.resolve(response);
		}else{
			this.reject(new Error('Invalid dojo/request/iframe request state'));
		}
	}
	function last(response){
		this._callNext();
	}

	var defaultOptions = {
		method: 'POST'
	};
	function iframe(url, options, returnDeferred){
		var response = util.parseArgs(url, util.deepCreate(defaultOptions, options), true);
		url = response.url;
		options = response.options;

		if(options.method !== 'GET' && options.method !== 'POST'){
			throw new Error(options.method + ' not supported by dojo/request/iframe');
		}

		if(!iframe._frame){
			iframe._frame = iframe.create(iframe._iframeName, onload + '();');
		}

		var dfd = util.deferred(response, null, isValid, isReady, handleResponse, last);
		dfd._callNext = function(){
			if(!this._calledNext){
				this._calledNext = true;
				iframe._currentDfd = null;
				iframe._fireNextRequest();
			}
		};
		dfd._legacy = returnDeferred;

		iframe._dfdQueue.push(dfd);
		iframe._fireNextRequest();

		watch(dfd);

		return returnDeferred ? dfd : dfd.promise;
	}

	/*=====
	iframe = function(url, options){
		// summary:
		//		Sends a request using an iframe element with the given URL and options.
		// url: String
		//		URL to request
		// options: dojo/request/iframe.__Options?
		//		Options for the request.
		// returns: dojo/request.__Promise
	};
	iframe.__BaseOptions = declare(request.__BaseOptions, {
		// form: DOMNode?
		//		A form node to use to submit data to the server.
		// data: String|Object?
		//		Data to transfer. When making a GET request, this will
		//		be converted to key=value parameters and appended to the
		//		URL.
	});
	iframe.__MethodOptions = declare(null, {
		// method: String?
		//		The HTTP method to use to make the request. Must be
		//		uppercase. Only `"GET"` and `"POST"` are accepted.
		//		Default is `"POST"`.
	});
	iframe.__Options = declare([iframe.__BaseOptions, iframe.__MethodOptions]);

	iframe.get = function(url, options){
		// summary:
		//		Send an HTTP GET request using an iframe element with the given URL and options.
		// url: String
		//		URL to request
		// options: dojo/request/iframe.__BaseOptions?
		//		Options for the request.
		// returns: dojo/request.__Promise
	};
	iframe.post = function(url, options){
		// summary:
		//		Send an HTTP POST request using an iframe element with the given URL and options.
		// url: String
		//		URL to request
		// options: dojo/request/iframe.__BaseOptions?
		//		Options for the request.
		// returns: dojo/request.__Promise
	};
	=====*/
	iframe.create = create;
	iframe.doc = doc;
	iframe.setSrc = setSrc;

	// TODO: Make these truly private in 2.0
	iframe._iframeName = mid + '_IoIframe';
	iframe._notifyStart = function(){};
	iframe._dfdQueue = [];
	iframe._currentDfd = null;
	iframe._fireNextRequest = fireNextRequest;

	util.addCommonMethods(iframe, ['GET', 'POST']);

	return iframe;
});

},
'dijit/_WidgetBase':function(){
define([
	"require", // require.toUrl
	"dojo/_base/array", // array.forEach array.map
	"dojo/aspect",
	"dojo/_base/config", // config.blankGif
	"dojo/_base/connect", // connect.connect
	"dojo/_base/declare", // declare
	"dojo/dom", // dom.byId
	"dojo/dom-attr", // domAttr.set domAttr.remove
	"dojo/dom-class", // domClass.add domClass.replace
	"dojo/dom-construct", // domConstruct.destroy domConstruct.place
	"dojo/dom-geometry", // isBodyLtr
	"dojo/dom-style", // domStyle.set, domStyle.get
	"dojo/has",
	"dojo/_base/kernel",
	"dojo/_base/lang", // mixin(), isArray(), etc.
	"dojo/on",
	"dojo/ready",
	"dojo/Stateful", // Stateful
	"dojo/topic",
	"dojo/_base/window", // win.body()
	"./Destroyable",
	"dojo/has!dojo-bidi?./_BidiMixin",
	"./registry"    // registry.getUniqueId(), registry.findWidgets()
], function(require, array, aspect, config, connect, declare,
			dom, domAttr, domClass, domConstruct, domGeometry, domStyle, has, kernel,
			lang, on, ready, Stateful, topic, win, Destroyable, _BidiMixin, registry){

	// module:
	//		dijit/_WidgetBase

	// Flag to make dijit load modules the app didn't explicitly request, for backwards compatibility
	has.add("dijit-legacy-requires", !kernel.isAsync);

	// Flag to enable support for textdir attribute
	has.add("dojo-bidi", false);


	// For back-compat, remove in 2.0.
	if(has("dijit-legacy-requires")){
		ready(0, function(){
			var requires = ["dijit/_base/manager"];
			require(requires);	// use indirection so modules not rolled into a build
		});
	}

	// Nested hash listing attributes for each tag, all strings in lowercase.
	// ex: {"div": {"style": true, "tabindex" true}, "form": { ...
	var tagAttrs = {};

	function getAttrs(obj){
		var ret = {};
		for(var attr in obj){
			ret[attr.toLowerCase()] = true;
		}
		return ret;
	}

	function nonEmptyAttrToDom(attr){
		// summary:
		//		Returns a setter function that copies the attribute to this.domNode,
		//		or removes the attribute from this.domNode, depending on whether the
		//		value is defined or not.
		return function(val){
			domAttr[val ? "set" : "remove"](this.domNode, attr, val);
			this._set(attr, val);
		};
	}

	function isEqual(a, b){
		//	summary:
		//		Function that determines whether two values are identical,
		//		taking into account that NaN is not normally equal to itself
		//		in JS.

		return a === b || (/* a is NaN */ a !== a && /* b is NaN */ b !== b);
	}

	var _WidgetBase = declare("dijit._WidgetBase", [Stateful, Destroyable], {
		// summary:
		//		Future base class for all Dijit widgets.
		// description:
		//		Future base class for all Dijit widgets.
		//		_Widget extends this class adding support for various features needed by desktop.
		//
		//		Provides stubs for widget lifecycle methods for subclasses to extend, like postMixInProperties(), buildRendering(),
		//		postCreate(), startup(), and destroy(), and also public API methods like set(), get(), and watch().
		//
		//		Widgets can provide custom setters/getters for widget attributes, which are called automatically by set(name, value).
		//		For an attribute XXX, define methods _setXXXAttr() and/or _getXXXAttr().
		//
		//		_setXXXAttr can also be a string/hash/array mapping from a widget attribute XXX to the widget's DOMNodes:
		//
		//		- DOM node attribute
		// |		_setFocusAttr: {node: "focusNode", type: "attribute"}
		// |		_setFocusAttr: "focusNode"	(shorthand)
		// |		_setFocusAttr: ""		(shorthand, maps to this.domNode)
		//		Maps this.focus to this.focusNode.focus, or (last example) this.domNode.focus
		//
		//		- DOM node innerHTML
		//	|		_setTitleAttr: { node: "titleNode", type: "innerHTML" }
		//		Maps this.title to this.titleNode.innerHTML
		//
		//		- DOM node innerText
		//	|		_setTitleAttr: { node: "titleNode", type: "innerText" }
		//		Maps this.title to this.titleNode.innerText
		//
		//		- DOM node CSS class
		// |		_setMyClassAttr: { node: "domNode", type: "class" }
		//		Maps this.myClass to this.domNode.className
		//
		//		- Toggle DOM node CSS class
		// |		_setMyClassAttr: { node: "domNode", type: "toggleClass" }
		//		Toggles myClass on this.domNode by this.myClass
		//
		//		If the value of _setXXXAttr is an array, then each element in the array matches one of the
		//		formats of the above list.
		//
		//		If the custom setter is null, no action is performed other than saving the new value
		//		in the widget (in this).
		//
		//		If no custom setter is defined for an attribute, then it will be copied
		//		to this.focusNode (if the widget defines a focusNode), or this.domNode otherwise.
		//		That's only done though for attributes that match DOMNode attributes (title,
		//		alt, aria-labelledby, etc.)

		// id: [const] String
		//		A unique, opaque ID string that can be assigned by users or by the
		//		system. If the developer passes an ID which is known not to be
		//		unique, the specified ID is ignored and the system-generated ID is
		//		used instead.
		id: "",
		_setIdAttr: "domNode", // to copy to this.domNode even for auto-generated id's

		// lang: [const] String
		//		Rarely used.  Overrides the default Dojo locale used to render this widget,
		//		as defined by the [HTML LANG](http://www.w3.org/TR/html401/struct/dirlang.html#adef-lang) attribute.
		//		Value must be among the list of locales specified during by the Dojo bootstrap,
		//		formatted according to [RFC 3066](http://www.ietf.org/rfc/rfc3066.txt) (like en-us).
		lang: "",
		// set on domNode even when there's a focus node.	but don't set lang="", since that's invalid.
		_setLangAttr: nonEmptyAttrToDom("lang"),

		// dir: [const] String
		//		Bi-directional support, as defined by the [HTML DIR](http://www.w3.org/TR/html401/struct/dirlang.html#adef-dir)
		//		attribute. Either left-to-right "ltr" or right-to-left "rtl".  If undefined, widgets renders in page's
		//		default direction.
		dir: "",
		// set on domNode even when there's a focus node.	but don't set dir="", since that's invalid.
		_setDirAttr: nonEmptyAttrToDom("dir"), // to set on domNode even when there's a focus node

		// class: String
		//		HTML class attribute
		"class": "",
		_setClassAttr: { node: "domNode", type: "class" },

		// Override automatic assigning type --> focusNode, it causes exception on IE6-8.
		// Instead, type must be specified as ${type} in the template, as part of the original DOM.
		_setTypeAttr: null,

		// style: String||Object
		//		HTML style attributes as cssText string or name/value hash
		style: "",

		// title: String
		//		HTML title attribute.
		//
		//		For form widgets this specifies a tooltip to display when hovering over
		//		the widget (just like the native HTML title attribute).
		//
		//		For TitlePane or for when this widget is a child of a TabContainer, AccordionContainer,
		//		etc., it's used to specify the tab label, accordion pane title, etc.  In this case it's
		//		interpreted as HTML.
		title: "",

		// tooltip: String
		//		When this widget's title attribute is used to for a tab label, accordion pane title, etc.,
		//		this specifies the tooltip to appear when the mouse is hovered over that text.
		tooltip: "",

		// baseClass: [protected] String
		//		Root CSS class of the widget (ex: dijitTextBox), used to construct CSS classes to indicate
		//		widget state.
		baseClass: "",

		// srcNodeRef: [readonly] DomNode
		//		pointer to original DOM node
		srcNodeRef: null,

		// domNode: [readonly] DomNode
		//		This is our visible representation of the widget! Other DOM
		//		Nodes may by assigned to other properties, usually through the
		//		template system's data-dojo-attach-point syntax, but the domNode
		//		property is the canonical "top level" node in widget UI.
		domNode: null,

		// containerNode: [readonly] DomNode
		//		Designates where children of the source DOM node will be placed.
		//		"Children" in this case refers to both DOM nodes and widgets.
		//		For example, for myWidget:
		//
		//		|	<div data-dojo-type=myWidget>
		//		|		<b> here's a plain DOM node
		//		|		<span data-dojo-type=subWidget>and a widget</span>
		//		|		<i> and another plain DOM node </i>
		//		|	</div>
		//
		//		containerNode would point to:
		//
		//		|		<b> here's a plain DOM node
		//		|		<span data-dojo-type=subWidget>and a widget</span>
		//		|		<i> and another plain DOM node </i>
		//
		//		In templated widgets, "containerNode" is set via a
		//		data-dojo-attach-point assignment.
		//
		//		containerNode must be defined for any widget that accepts innerHTML
		//		(like ContentPane or BorderContainer or even Button), and conversely
		//		is null for widgets that don't, like TextBox.
		containerNode: null,

		// ownerDocument: [const] Document?
		//		The document this widget belongs to.  If not specified to constructor, will default to
		//		srcNodeRef.ownerDocument, or if no sourceRef specified, then to the document global
		ownerDocument: null,
		_setOwnerDocumentAttr: function(val){
			// this setter is merely to avoid automatically trying to set this.domNode.ownerDocument
			this._set("ownerDocument", val);
		},

		/*=====
		// _started: [readonly] Boolean
		//		startup() has completed.
		_started: false,
		=====*/

		// attributeMap: [protected] Object
		//		Deprecated.	Instead of attributeMap, widget should have a _setXXXAttr attribute
		//		for each XXX attribute to be mapped to the DOM.
		//
		//		attributeMap sets up a "binding" between attributes (aka properties)
		//		of the widget and the widget's DOM.
		//		Changes to widget attributes listed in attributeMap will be
		//		reflected into the DOM.
		//
		//		For example, calling set('title', 'hello')
		//		on a TitlePane will automatically cause the TitlePane's DOM to update
		//		with the new title.
		//
		//		attributeMap is a hash where the key is an attribute of the widget,
		//		and the value reflects a binding to a:
		//
		//		- DOM node attribute
		// |		focus: {node: "focusNode", type: "attribute"}
		//		Maps this.focus to this.focusNode.focus
		//
		//		- DOM node innerHTML
		//	|		title: { node: "titleNode", type: "innerHTML" }
		//		Maps this.title to this.titleNode.innerHTML
		//
		//		- DOM node innerText
		//	|		title: { node: "titleNode", type: "innerText" }
		//		Maps this.title to this.titleNode.innerText
		//
		//		- DOM node CSS class
		// |		myClass: { node: "domNode", type: "class" }
		//		Maps this.myClass to this.domNode.className
		//
		//		If the value is an array, then each element in the array matches one of the
		//		formats of the above list.
		//
		//		There are also some shorthands for backwards compatibility:
		//
		//		- string --> { node: string, type: "attribute" }, for example:
		//
		//	|	"focusNode" ---> { node: "focusNode", type: "attribute" }
		//
		//		- "" --> { node: "domNode", type: "attribute" }
		attributeMap: {},

		// _blankGif: [protected] String
		//		Path to a blank 1x1 image.
		//		Used by `<img>` nodes in templates that really get their image via CSS background-image.
		_blankGif: config.blankGif || require.toUrl("dojo/resources/blank.gif"),

		// textDir: String
		//		Bi-directional support,	the main variable which is responsible for the direction of the text.
		//		The text direction can be different than the GUI direction by using this parameter in creation
		//		of a widget.
		//
		//		This property is only effective when `has("dojo-bidi")` is defined to be true.
		//
		//		Allowed values:
		//
		//		1. "" - default value; text is same direction as widget
		//		2. "ltr"
		//		3. "rtl"
		//		4. "auto" - contextual the direction of a text defined by first strong letter.
		textDir: "",

		//////////// INITIALIZATION METHODS ///////////////////////////////////////

		/*=====
		constructor: function(params, srcNodeRef){
			// summary:
			//		Create the widget.
			// params: Object|null
			//		Hash of initialization parameters for widget, including scalar values (like title, duration etc.)
			//		and functions, typically callbacks like onClick.
			//		The hash can contain any of the widget's properties, excluding read-only properties.
			// srcNodeRef: DOMNode|String?
			//		If a srcNodeRef (DOM node) is specified:
			//
			//		- use srcNodeRef.innerHTML as my contents
			//		- if this is a behavioral widget then apply behavior to that srcNodeRef
			//		- otherwise, replace srcNodeRef with my generated DOM tree
		},
		=====*/

		_introspect: function(){
			// summary:
			//		Collect metadata about this widget (only once per class, not once per instance):
			//
			//			- list of attributes with custom setters, storing in this.constructor._setterAttrs
			//			- generate this.constructor._onMap, mapping names like "mousedown" to functions like onMouseDown

			var ctor = this.constructor;
			if(!ctor._setterAttrs){
				var proto = ctor.prototype,
					attrs = ctor._setterAttrs = [], // attributes with custom setters
					onMap = (ctor._onMap = {});

				// Items in this.attributeMap are like custom setters.  For back-compat, remove for 2.0.
				for(var name in proto.attributeMap){
					attrs.push(name);
				}

				// Loop over widget properties, collecting properties with custom setters and filling in ctor._onMap.
				for(name in proto){
					if(/^on/.test(name)){
						onMap[name.substring(2).toLowerCase()] = name;
					}

					if(/^_set[A-Z](.*)Attr$/.test(name)){
						name = name.charAt(4).toLowerCase() + name.substr(5, name.length - 9);
						if(!proto.attributeMap || !(name in proto.attributeMap)){
							attrs.push(name);
						}
					}
				}

				// Note: this isn't picking up info on properties like aria-label and role, that don't have custom setters
				// but that set() maps to attributes on this.domNode or this.focusNode
			}
		},

		postscript: function(/*Object?*/params, /*DomNode|String*/srcNodeRef){
			// summary:
			//		Kicks off widget instantiation.  See create() for details.
			// tags:
			//		private

			// Note that we skip calling this.inherited(), i.e. dojo/Stateful::postscript(), because 1.x widgets don't
			// expect their custom setters to get called until after buildRendering().  Consider changing for 2.0.

			this.create(params, srcNodeRef);
		},

		create: function(params, srcNodeRef){
			// summary:
			//		Kick off the life-cycle of a widget
			// description:
			//		Create calls a number of widget methods (postMixInProperties, buildRendering, postCreate,
			//		etc.), some of which of you'll want to override. See http://dojotoolkit.org/reference-guide/dijit/_WidgetBase.html
			//		for a discussion of the widget creation lifecycle.
			//
			//		Of course, adventurous developers could override create entirely, but this should
			//		only be done as a last resort.
			// params: Object|null
			//		Hash of initialization parameters for widget, including scalar values (like title, duration etc.)
			//		and functions, typically callbacks like onClick.
			//		The hash can contain any of the widget's properties, excluding read-only properties.
			// srcNodeRef: DOMNode|String?
			//		If a srcNodeRef (DOM node) is specified:
			//
			//		- use srcNodeRef.innerHTML as my contents
			//		- if this is a behavioral widget then apply behavior to that srcNodeRef
			//		- otherwise, replace srcNodeRef with my generated DOM tree
			// tags:
			//		private

			// First time widget is instantiated, scan prototype to figure out info about custom setters etc.
			this._introspect();

			// store pointer to original DOM tree
			this.srcNodeRef = dom.byId(srcNodeRef);

			// No longer used, remove for 2.0.
			this._connects = [];
			this._supportingWidgets = [];

			// this is here for back-compat, remove in 2.0 (but check NodeList-instantiate.html test)
			if(this.srcNodeRef && this.srcNodeRef.id  && (typeof this.srcNodeRef.id == "string")){
				this.id = this.srcNodeRef.id;
			}

			// mix in our passed parameters
			if(params){
				this.params = params;
				lang.mixin(this, params);
			}
			this.postMixInProperties();

			// Generate an id for the widget if one wasn't specified, or it was specified as id: undefined.
			// Do this before buildRendering() because it might expect the id to be there.
			if(!this.id){
				this.id = registry.getUniqueId(this.declaredClass.replace(/\./g, "_"));
				if(this.params){
					// if params contains {id: undefined}, prevent _applyAttributes() from processing it
					delete this.params.id;
				}
			}

			// The document and <body> node this widget is associated with
			this.ownerDocument = this.ownerDocument || (this.srcNodeRef ? this.srcNodeRef.ownerDocument : document);
			this.ownerDocumentBody = win.body(this.ownerDocument);

			registry.add(this);

			this.buildRendering();

			var deleteSrcNodeRef;

			if(this.domNode){
				// Copy attributes listed in attributeMap into the [newly created] DOM for the widget.
				// Also calls custom setters for all attributes with custom setters.
				this._applyAttributes();

				// If srcNodeRef was specified, then swap out original srcNode for this widget's DOM tree.
				// For 2.0, move this after postCreate().  postCreate() shouldn't depend on the
				// widget being attached to the DOM since it isn't when a widget is created programmatically like
				// new MyWidget({}).	See #11635.
				var source = this.srcNodeRef;
				if(source && source.parentNode && this.domNode !== source){
					source.parentNode.replaceChild(this.domNode, source);
					deleteSrcNodeRef = true;
				}

				// Note: for 2.0 may want to rename widgetId to dojo._scopeName + "_widgetId",
				// assuming that dojo._scopeName even exists in 2.0
				this.domNode.setAttribute("widgetId", this.id);
			}
			this.postCreate();

			// If srcNodeRef has been processed and removed from the DOM (e.g. TemplatedWidget) then delete it to allow GC.
			// I think for back-compatibility it isn't deleting srcNodeRef until after postCreate() has run.
			if(deleteSrcNodeRef){
				delete this.srcNodeRef;
			}

			this._created = true;
		},

		_applyAttributes: function(){
			// summary:
			//		Step during widget creation to copy  widget attributes to the
			//		DOM according to attributeMap and _setXXXAttr objects, and also to call
			//		custom _setXXXAttr() methods.
			//
			//		Skips over blank/false attribute values, unless they were explicitly specified
			//		as parameters to the widget, since those are the default anyway,
			//		and setting tabIndex="" is different than not setting tabIndex at all.
			//
			//		For backwards-compatibility reasons attributeMap overrides _setXXXAttr when
			//		_setXXXAttr is a hash/string/array, but _setXXXAttr as a functions override attributeMap.
			// tags:
			//		private

			// Call this.set() for each property that was either specified as parameter to constructor,
			// or is in the list found above.	For correlated properties like value and displayedValue, the one
			// specified as a parameter should take precedence.
			// Particularly important for new DateTextBox({displayedValue: ...}) since DateTextBox's default value is
			// NaN and thus is not ignored like a default value of "".

			// Step 1: Save the current values of the widget properties that were specified as parameters to the constructor.
			// Generally this.foo == this.params.foo, except if postMixInProperties() changed the value of this.foo.
			var params = {};
			for(var key in this.params || {}){
				params[key] = this._get(key);
			}

			// Step 2: Call set() for each property with a non-falsy value that wasn't passed as a parameter to the constructor
			array.forEach(this.constructor._setterAttrs, function(key){
				if(!(key in params)){
					var val = this._get(key);
					if(val){
						this.set(key, val);
					}
				}
			}, this);

			// Step 3: Call set() for each property that was specified as parameter to constructor.
			// Use params hash created above to ignore side effects from step #2 above.
			for(key in params){
				this.set(key, params[key]);
			}
		},

		postMixInProperties: function(){
			// summary:
			//		Called after the parameters to the widget have been read-in,
			//		but before the widget template is instantiated. Especially
			//		useful to set properties that are referenced in the widget
			//		template.
			// tags:
			//		protected
		},

		buildRendering: function(){
			// summary:
			//		Construct the UI for this widget, setting this.domNode.
			//		Most widgets will mixin `dijit._TemplatedMixin`, which implements this method.
			// tags:
			//		protected

			if(!this.domNode){
				// Create root node if it wasn't created by _TemplatedMixin
				this.domNode = this.srcNodeRef || this.ownerDocument.createElement("div");
			}

			// baseClass is a single class name or occasionally a space-separated list of names.
			// Add those classes to the DOMNode.  If RTL mode then also add with Rtl suffix.
			// TODO: make baseClass custom setter
			if(this.baseClass){
				var classes = this.baseClass.split(" ");
				if(!this.isLeftToRight()){
					classes = classes.concat(array.map(classes, function(name){
						return name + "Rtl";
					}));
				}
				domClass.add(this.domNode, classes);
			}
		},

		postCreate: function(){
			// summary:
			//		Processing after the DOM fragment is created
			// description:
			//		Called after the DOM fragment has been created, but not necessarily
			//		added to the document.  Do not include any operations which rely on
			//		node dimensions or placement.
			// tags:
			//		protected
		},

		startup: function(){
			// summary:
			//		Processing after the DOM fragment is added to the document
			// description:
			//		Called after a widget and its children have been created and added to the page,
			//		and all related widgets have finished their create() cycle, up through postCreate().
			//
			//		Note that startup() may be called while the widget is still hidden, for example if the widget is
			//		inside a hidden dijit/Dialog or an unselected tab of a dijit/layout/TabContainer.
			//		For widgets that need to do layout, it's best to put that layout code inside resize(), and then
			//		extend dijit/layout/_LayoutWidget so that resize() is called when the widget is visible.
			if(this._started){
				return;
			}
			this._started = true;
			array.forEach(this.getChildren(), function(obj){
				if(!obj._started && !obj._destroyed && lang.isFunction(obj.startup)){
					obj.startup();
					obj._started = true;
				}
			});
		},

		//////////// DESTROY FUNCTIONS ////////////////////////////////

		destroyRecursive: function(/*Boolean?*/ preserveDom){
			// summary:
			//		Destroy this widget and its descendants
			// description:
			//		This is the generic "destructor" function that all widget users
			//		should call to cleanly discard with a widget. Once a widget is
			//		destroyed, it is removed from the manager object.
			// preserveDom:
			//		If true, this method will leave the original DOM structure
			//		alone of descendant Widgets. Note: This will NOT work with
			//		dijit._TemplatedMixin widgets.

			this._beingDestroyed = true;
			this.destroyDescendants(preserveDom);
			this.destroy(preserveDom);
		},

		destroy: function(/*Boolean*/ preserveDom){
			// summary:
			//		Destroy this widget, but not its descendants.  Descendants means widgets inside of
			//		this.containerNode.   Will also destroy any resources (including widgets) registered via this.own().
			//
			//		This method will also destroy internal widgets such as those created from a template,
			//		assuming those widgets exist inside of this.domNode but outside of this.containerNode.
			//
			//		For 2.0 it's planned that this method will also destroy descendant widgets, so apps should not
			//		depend on the current ability to destroy a widget without destroying its descendants.   Generally
			//		they should use destroyRecursive() for widgets with children.
			// preserveDom: Boolean
			//		If true, this method will leave the original DOM structure alone.
			//		Note: This will not yet work with _TemplatedMixin widgets

			this._beingDestroyed = true;
			this.uninitialize();

			function destroy(w){
				if(w.destroyRecursive){
					w.destroyRecursive(preserveDom);
				}else if(w.destroy){
					w.destroy(preserveDom);
				}
			}

			// Back-compat, remove for 2.0
			array.forEach(this._connects, lang.hitch(this, "disconnect"));
			array.forEach(this._supportingWidgets, destroy);

			// Destroy supporting widgets, but not child widgets under this.containerNode (for 2.0, destroy child widgets
			// here too).   if() statement is to guard against exception if destroy() called multiple times (see #15815).
			if(this.domNode){
				array.forEach(registry.findWidgets(this.domNode, this.containerNode), destroy);
			}

			this.destroyRendering(preserveDom);
			registry.remove(this.id);
			this._destroyed = true;
		},

		destroyRendering: function(/*Boolean?*/ preserveDom){
			// summary:
			//		Destroys the DOM nodes associated with this widget.
			// preserveDom:
			//		If true, this method will leave the original DOM structure alone
			//		during tear-down. Note: this will not work with _Templated
			//		widgets yet.
			// tags:
			//		protected

			if(this.bgIframe){
				this.bgIframe.destroy(preserveDom);
				delete this.bgIframe;
			}

			if(this.domNode){
				if(preserveDom){
					domAttr.remove(this.domNode, "widgetId");
				}else{
					domConstruct.destroy(this.domNode);
				}
				delete this.domNode;
			}

			if(this.srcNodeRef){
				if(!preserveDom){
					domConstruct.destroy(this.srcNodeRef);
				}
				delete this.srcNodeRef;
			}
		},

		destroyDescendants: function(/*Boolean?*/ preserveDom){
			// summary:
			//		Recursively destroy the children of this widget and their
			//		descendants.
			// preserveDom:
			//		If true, the preserveDom attribute is passed to all descendant
			//		widget's .destroy() method. Not for use with _Templated
			//		widgets.

			// get all direct descendants and destroy them recursively
			array.forEach(this.getChildren(), function(widget){
				if(widget.destroyRecursive){
					widget.destroyRecursive(preserveDom);
				}
			});
		},

		uninitialize: function(){
			// summary:
			//		Deprecated. Override destroy() instead to implement custom widget tear-down
			//		behavior.
			// tags:
			//		protected
			return false;
		},

		////////////////// GET/SET, CUSTOM SETTERS, ETC. ///////////////////

		_setStyleAttr: function(/*String||Object*/ value){
			// summary:
			//		Sets the style attribute of the widget according to value,
			//		which is either a hash like {height: "5px", width: "3px"}
			//		or a plain string
			// description:
			//		Determines which node to set the style on based on style setting
			//		in attributeMap.
			// tags:
			//		protected

			var mapNode = this.domNode;

			// Note: technically we should revert any style setting made in a previous call
			// to his method, but that's difficult to keep track of.

			if(lang.isObject(value)){
				domStyle.set(mapNode, value);
			}else{
				if(mapNode.style.cssText){
					mapNode.style.cssText += "; " + value;
				}else{
					mapNode.style.cssText = value;
				}
			}

			this._set("style", value);
		},

		_attrToDom: function(/*String*/ attr, /*String*/ value, /*Object?*/ commands){
			// summary:
			//		Reflect a widget attribute (title, tabIndex, duration etc.) to
			//		the widget DOM, as specified by commands parameter.
			//		If commands isn't specified then it's looked up from attributeMap.
			//		Note some attributes like "type"
			//		cannot be processed this way as they are not mutable.
			// attr:
			//		Name of member variable (ex: "focusNode" maps to this.focusNode) pointing
			//		to DOMNode inside the widget, or alternately pointing to a subwidget
			// tags:
			//		private

			commands = arguments.length >= 3 ? commands : this.attributeMap[attr];

			array.forEach(lang.isArray(commands) ? commands : [commands], function(command){

				// Get target node and what we are doing to that node
				var mapNode = this[command.node || command || "domNode"];	// DOM node
				var type = command.type || "attribute";	// class, innerHTML, innerText, or attribute

				switch(type){
					case "attribute":
						if(lang.isFunction(value)){ // functions execute in the context of the widget
							value = lang.hitch(this, value);
						}

						// Get the name of the DOM node attribute; usually it's the same
						// as the name of the attribute in the widget (attr), but can be overridden.
						// Also maps handler names to lowercase, like onSubmit --> onsubmit
						var attrName = command.attribute ? command.attribute :
							(/^on[A-Z][a-zA-Z]*$/.test(attr) ? attr.toLowerCase() : attr);

						if(mapNode.tagName){
							// Normal case, mapping to a DOMNode.  Note that modern browsers will have a mapNode.set()
							// method, but for consistency we still call domAttr
							domAttr.set(mapNode, attrName, value);
						}else{
							// mapping to a sub-widget
							mapNode.set(attrName, value);
						}
						break;
					case "innerText":
						// Deprecated, use "textContent" instead.
						mapNode.innerHTML = "";
						mapNode.appendChild(this.ownerDocument.createTextNode(value));
						break;
					case "textContent":
						mapNode.textContent = value;
						break;
					case "innerHTML":
						mapNode.innerHTML = value;
						break;
					case "class":
						domClass.replace(mapNode, value, this[attr]);
						break;
					case "toggleClass":
						domClass.toggle(mapNode, command.className || attr, value);
						break;
				}
			}, this);
		},

		get: function(name){
			// summary:
			//		Get a property from a widget.
			// name:
			//		The property to get.
			// description:
			//		Get a named property from a widget. The property may
			//		potentially be retrieved via a getter method. If no getter is defined, this
			//		just retrieves the object's property.
			//
			//		For example, if the widget has properties `foo` and `bar`
			//		and a method named `_getFooAttr()`, calling:
			//		`myWidget.get("foo")` would be equivalent to calling
			//		`widget._getFooAttr()` and `myWidget.get("bar")`
			//		would be equivalent to the expression
			//		`widget.bar2`
			var names = this._getAttrNames(name);
			return this[names.g] ? this[names.g]() : this._get(name);
		},

		set: function(name, value){
			// summary:
			//		Set a property on a widget
			// name:
			//		The property to set.
			// value:
			//		The value to set in the property.
			// description:
			//		Sets named properties on a widget which may potentially be handled by a
			//		setter in the widget.
			//
			//		For example, if the widget has properties `foo` and `bar`
			//		and a method named `_setFooAttr()`, calling
			//		`myWidget.set("foo", "Howdy!")` would be equivalent to calling
			//		`widget._setFooAttr("Howdy!")` and `myWidget.set("bar", 3)`
			//		would be equivalent to the statement `widget.bar = 3;`
			//
			//		set() may also be called with a hash of name/value pairs, ex:
			//
			//	|	myWidget.set({
			//	|		foo: "Howdy",
			//	|		bar: 3
			//	|	});
			//
			//	This is equivalent to calling `set(foo, "Howdy")` and `set(bar, 3)`

			if(typeof name === "object"){
				for(var x in name){
					this.set(x, name[x]);
				}
				return this;
			}
			var names = this._getAttrNames(name),
				setter = this[names.s];
			if(lang.isFunction(setter)){
				// use the explicit setter
				var result = setter.apply(this, Array.prototype.slice.call(arguments, 1));
			}else{
				// Mapping from widget attribute to DOMNode/subwidget attribute/value/etc.
				// Map according to:
				//		1. attributeMap setting, if one exists (TODO: attributeMap deprecated, remove in 2.0)
				//		2. _setFooAttr: {...} type attribute in the widget (if one exists)
				//		3. apply to focusNode or domNode if standard attribute name, excluding funcs like onClick.
				// Checks if an attribute is a "standard attribute" by whether the DOMNode JS object has a similar
				// attribute name (ex: accept-charset attribute matches jsObject.acceptCharset).
				// Note also that Tree.focusNode() is a function not a DOMNode, so test for that.
				var defaultNode = this.focusNode && !lang.isFunction(this.focusNode) ? "focusNode" : "domNode",
					tag = this[defaultNode] && this[defaultNode].tagName,
					attrsForTag = tag && (tagAttrs[tag] || (tagAttrs[tag] = getAttrs(this[defaultNode]))),
					map = name in this.attributeMap ? this.attributeMap[name] :
						names.s in this ? this[names.s] :
							((attrsForTag && names.l in attrsForTag && typeof value != "function") ||
								/^aria-|^data-|^role$/.test(name)) ? defaultNode : null;
				if(map != null){
					this._attrToDom(name, value, map);
				}
				this._set(name, value);
			}
			return result || this;
		},

		_attrPairNames: {}, // shared between all widgets
		_getAttrNames: function(name){
			// summary:
			//		Helper function for get() and set().
			//		Caches attribute name values so we don't do the string ops every time.
			// tags:
			//		private

			var apn = this._attrPairNames;
			if(apn[name]){
				return apn[name];
			}
			var uc = name.replace(/^[a-z]|-[a-zA-Z]/g, function(c){
				return c.charAt(c.length - 1).toUpperCase();
			});
			return (apn[name] = {
				n: name + "Node",
				s: "_set" + uc + "Attr", // converts dashes to camel case, ex: accept-charset --> _setAcceptCharsetAttr
				g: "_get" + uc + "Attr",
				l: uc.toLowerCase()        // lowercase name w/out dashes, ex: acceptcharset
			});
		},

		_set: function(/*String*/ name, /*anything*/ value){
			// summary:
			//		Helper function to set new value for specified property, and call handlers
			//		registered with watch() if the value has changed.
			var oldValue = this[name];
			this[name] = value;
			if(this._created && !isEqual(oldValue, value)){
				if(this._watchCallbacks){
					this._watchCallbacks(name, oldValue, value);
				}
				this.emit("attrmodified-" + name, {
					detail: {
						prevValue: oldValue,
						newValue: value
					}
				});
			}
		},

		_get: function(/*String*/ name){
			// summary:
			//		Helper function to get value for specified property stored by this._set(),
			//		i.e. for properties with custom setters.  Used mainly by custom getters.
			//
			//		For example, CheckBox._getValueAttr() calls this._get("value").

			// future: return name in this.props ? this.props[name] : this[name];
			return this[name];
		},

		emit: function(/*String*/ type, /*Object?*/ eventObj, /*Array?*/ callbackArgs){
			// summary:
			//		Used by widgets to signal that a synthetic event occurred, ex:
			//	|	myWidget.emit("attrmodified-selectedChildWidget", {}).
			//
			//		Emits an event on this.domNode named type.toLowerCase(), based on eventObj.
			//		Also calls onType() method, if present, and returns value from that method.
			//		By default passes eventObj to callback, but will pass callbackArgs instead, if specified.
			//		Modifies eventObj by adding missing parameters (bubbles, cancelable, widget).
			// tags:
			//		protected

			// Specify fallback values for bubbles, cancelable in case they are not set in eventObj.
			// Also set pointer to widget, although since we can't add a pointer to the widget for native events
			// (see #14729), maybe we shouldn't do it here?
			eventObj = eventObj || {};
			if(eventObj.bubbles === undefined){
				eventObj.bubbles = true;
			}
			if(eventObj.cancelable === undefined){
				eventObj.cancelable = true;
			}
			if(!eventObj.detail){
				eventObj.detail = {};
			}
			eventObj.detail.widget = this;

			var ret, callback = this["on" + type];
			if(callback){
				ret = callback.apply(this, callbackArgs ? callbackArgs : [eventObj]);
			}

			// Emit event, but avoid spurious emit()'s as parent sets properties on child during startup/destroy
			if(this._started && !this._beingDestroyed){
				on.emit(this.domNode, type.toLowerCase(), eventObj);
			}

			return ret;
		},

		on: function(/*String|Function*/ type, /*Function*/ func){
			// summary:
			//		Call specified function when event occurs, ex: myWidget.on("click", function(){ ... }).
			// type:
			//		Name of event (ex: "click") or extension event like touch.press.
			// description:
			//		Call specified function when event `type` occurs, ex: `myWidget.on("click", function(){ ... })`.
			//		Note that the function is not run in any particular scope, so if (for example) you want it to run in the
			//		widget's scope you must do `myWidget.on("click", lang.hitch(myWidget, func))`.

			// For backwards compatibility, if there's an onType() method in the widget then connect to that.
			// Remove in 2.0.
			var widgetMethod = this._onMap(type);
			if(widgetMethod){
				return aspect.after(this, widgetMethod, func, true);
			}

			// Otherwise, just listen for the event on this.domNode.
			return this.own(on(this.domNode, type, func))[0];
		},

		_onMap: function(/*String|Function*/ type){
			// summary:
			//		Maps on() type parameter (ex: "mousemove") to method name (ex: "onMouseMove").
			//		If type is a synthetic event like touch.press then returns undefined.
			var ctor = this.constructor, map = ctor._onMap;
			if(!map){
				map = (ctor._onMap = {});
				for(var attr in ctor.prototype){
					if(/^on/.test(attr)){
						map[attr.replace(/^on/, "").toLowerCase()] = attr;
					}
				}
			}
			return map[typeof type == "string" && type.toLowerCase()];	// String
		},

		toString: function(){
			// summary:
			//		Returns a string that represents the widget.
			// description:
			//		When a widget is cast to a string, this method will be used to generate the
			//		output. Currently, it does not implement any sort of reversible
			//		serialization.
			return '[Widget ' + this.declaredClass + ', ' + (this.id || 'NO ID') + ']'; // String
		},

		getChildren: function(){
			// summary:
			//		Returns all direct children of this widget, i.e. all widgets underneath this.containerNode whose parent
			//		is this widget.   Note that it does not return all descendants, but rather just direct children.
			//		Analogous to [Node.childNodes](https://developer.mozilla.org/en-US/docs/DOM/Node.childNodes),
			//		except containing widgets rather than DOMNodes.
			//
			//		The result intentionally excludes internally created widgets (a.k.a. supporting widgets)
			//		outside of this.containerNode.
			//
			//		Note that the array returned is a simple array.  Application code should not assume
			//		existence of methods like forEach().

			return this.containerNode ? registry.findWidgets(this.containerNode) : []; // dijit/_WidgetBase[]
		},

		getParent: function(){
			// summary:
			//		Returns the parent widget of this widget.

			return registry.getEnclosingWidget(this.domNode.parentNode);
		},

		connect: function(/*Object|null*/ obj, /*String|Function*/ event, /*String|Function*/ method){
			// summary:
			//		Deprecated, will be removed in 2.0, use this.own(on(...)) or this.own(aspect.after(...)) instead.
			//
			//		Connects specified obj/event to specified method of this object
			//		and registers for disconnect() on widget destroy.
			//
			//		Provide widget-specific analog to dojo.connect, except with the
			//		implicit use of this widget as the target object.
			//		Events connected with `this.connect` are disconnected upon
			//		destruction.
			// returns:
			//		A handle that can be passed to `disconnect` in order to disconnect before
			//		the widget is destroyed.
			// example:
			//	|	var btn = new Button();
			//	|	// when foo.bar() is called, call the listener we're going to
			//	|	// provide in the scope of btn
			//	|	btn.connect(foo, "bar", function(){
			//	|		console.debug(this.toString());
			//	|	});
			// tags:
			//		protected

			return this.own(connect.connect(obj, event, this, method))[0];	// handle
		},

		disconnect: function(handle){
			// summary:
			//		Deprecated, will be removed in 2.0, use handle.remove() instead.
			//
			//		Disconnects handle created by `connect`.
			// tags:
			//		protected

			handle.remove();
		},

		subscribe: function(t, method){
			// summary:
			//		Deprecated, will be removed in 2.0, use this.own(topic.subscribe()) instead.
			//
			//		Subscribes to the specified topic and calls the specified method
			//		of this object and registers for unsubscribe() on widget destroy.
			//
			//		Provide widget-specific analog to dojo.subscribe, except with the
			//		implicit use of this widget as the target object.
			// t: String
			//		The topic
			// method: Function
			//		The callback
			// example:
			//	|	var btn = new Button();
			//	|	// when /my/topic is published, this button changes its label to
			//	|	// be the parameter of the topic.
			//	|	btn.subscribe("/my/topic", function(v){
			//	|		this.set("label", v);
			//	|	});
			// tags:
			//		protected
			return this.own(topic.subscribe(t, lang.hitch(this, method)))[0];	// handle
		},

		unsubscribe: function(/*Object*/ handle){
			// summary:
			//		Deprecated, will be removed in 2.0, use handle.remove() instead.
			//
			//		Unsubscribes handle created by this.subscribe.
			//		Also removes handle from this widget's list of subscriptions
			// tags:
			//		protected

			handle.remove();
		},

		isLeftToRight: function(){
			// summary:
			//		Return this widget's explicit or implicit orientation (true for LTR, false for RTL)
			// tags:
			//		protected
			return this.dir ? (this.dir.toLowerCase() == "ltr") : domGeometry.isBodyLtr(this.ownerDocument); //Boolean
		},

		isFocusable: function(){
			// summary:
			//		Return true if this widget can currently be focused
			//		and false if not
			return this.focus && (domStyle.get(this.domNode, "display") != "none");
		},

		placeAt: function(/*String|DomNode|DocumentFragment|dijit/_WidgetBase*/ reference, /*String|Int?*/ position){
			// summary:
			//		Place this widget somewhere in the DOM based
			//		on standard domConstruct.place() conventions.
			// description:
			//		A convenience function provided in all _Widgets, providing a simple
			//		shorthand mechanism to put an existing (or newly created) Widget
			//		somewhere in the dom, and allow chaining.
			// reference:
			//		Widget, DOMNode, DocumentFragment, or id of widget or DOMNode
			// position:
			//		If reference is a widget (or id of widget), and that widget has an ".addChild" method,
			//		it will be called passing this widget instance into that method, supplying the optional
			//		position index passed.  In this case position (if specified) should be an integer.
			//
			//		If reference is a DOMNode (or id matching a DOMNode but not a widget),
			//		the position argument can be a numeric index or a string
			//		"first", "last", "before", or "after", same as dojo/dom-construct::place().
			// returns: dijit/_WidgetBase
			//		Provides a useful return of the newly created dijit._Widget instance so you
			//		can "chain" this function by instantiating, placing, then saving the return value
			//		to a variable.
			// example:
			//	|	// create a Button with no srcNodeRef, and place it in the body:
			//	|	var button = new Button({ label:"click" }).placeAt(win.body());
			//	|	// now, 'button' is still the widget reference to the newly created button
			//	|	button.on("click", function(e){ console.log('click'); }));
			// example:
			//	|	// create a button out of a node with id="src" and append it to id="wrapper":
			//	|	var button = new Button({},"src").placeAt("wrapper");
			// example:
			//	|	// place a new button as the first element of some div
			//	|	var button = new Button({ label:"click" }).placeAt("wrapper","first");
			// example:
			//	|	// create a contentpane and add it to a TabContainer
			//	|	var tc = dijit.byId("myTabs");
			//	|	new ContentPane({ href:"foo.html", title:"Wow!" }).placeAt(tc)

			var refWidget = !reference.tagName && registry.byId(reference);
			if(refWidget && refWidget.addChild && (!position || typeof position === "number")){
				// Adding this to refWidget and can use refWidget.addChild() to handle everything.
				refWidget.addChild(this, position);
			}else{
				// "reference" is a plain DOMNode, or we can't use refWidget.addChild().   Use domConstruct.place() and
				// target refWidget.containerNode for nested placement (position==number, "first", "last", "only"), and
				// refWidget.domNode otherwise ("after"/"before"/"replace").  (But not supported officially, see #14946.)
				var ref = refWidget && ("domNode" in refWidget) ?
					(refWidget.containerNode && !/after|before|replace/.test(position || "") ?
						refWidget.containerNode : refWidget.domNode) : dom.byId(reference, this.ownerDocument);
				domConstruct.place(this.domNode, ref, position);

				// Start this iff it has a parent widget that's already started.
				// TODO: for 2.0 maybe it should also start the widget when this.getParent() returns null??
				if(!this._started && (this.getParent() || {})._started){
					this.startup();
				}
			}
			return this;
		},

		defer: function(fcn, delay){
			// summary:
			//		Wrapper to setTimeout to avoid deferred functions executing
			//		after the originating widget has been destroyed.
			//		Returns an object handle with a remove method (that returns null) (replaces clearTimeout).
			// fcn: Function
			//		Function reference.
			// delay: Number?
			//		Delay, defaults to 0.
			// tags:
			//		protected

			var timer = setTimeout(lang.hitch(this,
				function(){
					if(!timer){
						return;
					}
					timer = null;
					if(!this._destroyed){
						lang.hitch(this, fcn)();
					}
				}),
				delay || 0
			);
			return {
				remove: function(){
					if(timer){
						clearTimeout(timer);
						timer = null;
					}
					return null; // so this works well: handle = handle.remove();
				}
			};
		}
	});

	if(has("dojo-bidi")){
		_WidgetBase.extend(_BidiMixin);
	}

	return _WidgetBase;
});

},
'dojo/Stateful':function(){
define(["./_base/declare", "./_base/lang", "./_base/array", "./when"], function(declare, lang, array, when){
	// module:
	//		dojo/Stateful

return declare("dojo.Stateful", null, {
	// summary:
	//		Base class for objects that provide named properties with optional getter/setter
	//		control and the ability to watch for property changes
	//
	//		The class also provides the functionality to auto-magically manage getters
	//		and setters for object attributes/properties.
	//		
	//		Getters and Setters should follow the format of _xxxGetter or _xxxSetter where 
	//		the xxx is a name of the attribute to handle.  So an attribute of "foo" 
	//		would have a custom getter of _fooGetter and a custom setter of _fooSetter.
	//
	// example:
	//	|	require(["dojo/Stateful", function(Stateful) {
	//	|		var obj = new Stateful();
	//	|		obj.watch("foo", function(){
	//	|			console.log("foo changed to " + this.get("foo"));
	//	|		});
	//	|		obj.set("foo","bar");
	//	|	});

	// _attrPairNames: Hash
	//		Used across all instances a hash to cache attribute names and their getter 
	//		and setter names.
	_attrPairNames: {},

	_getAttrNames: function(name){
		// summary:
		//		Helper function for get() and set().
		//		Caches attribute name values so we don't do the string ops every time.
		// tags:
		//		private

		var apn = this._attrPairNames;
		if(apn[name]){ return apn[name]; }
		return (apn[name] = {
			s: "_" + name + "Setter",
			g: "_" + name + "Getter"
		});
	},

	postscript: function(/*Object?*/ params){
		// Automatic setting of params during construction
		if (params){ this.set(params); }
	},

	_get: function(name, names){
		// summary:
		//		Private function that does a get based off a hash of names
		// names:
		//		Hash of names of custom attributes
		return typeof this[names.g] === "function" ? this[names.g]() : this[name];
	},
	get: function(/*String*/name){
		// summary:
		//		Get a property on a Stateful instance.
		// name:
		//		The property to get.
		// returns:
		//		The property value on this Stateful instance.
		// description:
		//		Get a named property on a Stateful object. The property may
		//		potentially be retrieved via a getter method in subclasses. In the base class
		//		this just retrieves the object's property.
		// example:
		//	|	require(["dojo/Stateful", function(Stateful) {
		//	|		var stateful = new Stateful({foo: 3});
		//	|		stateful.get("foo") // returns 3
		//	|		stateful.foo // returns 3
		//	|	});

		return this._get(name, this._getAttrNames(name)); //Any
	},
	set: function(/*String*/name, /*Object*/value){
		// summary:
		//		Set a property on a Stateful instance
		// name:
		//		The property to set.
		// value:
		//		The value to set in the property.
		// returns:
		//		The function returns this dojo.Stateful instance.
		// description:
		//		Sets named properties on a stateful object and notifies any watchers of
		//		the property. A programmatic setter may be defined in subclasses.
		// example:
		//	|	require(["dojo/Stateful", function(Stateful) {
		//	|		var stateful = new Stateful();
		//	|		stateful.watch(function(name, oldValue, value){
		//	|			// this will be called on the set below
		//	|		}
		//	|		stateful.set(foo, 5);
		//	set() may also be called with a hash of name/value pairs, ex:
		//	|		stateful.set({
		//	|			foo: "Howdy",
		//	|			bar: 3
		//	|		});
		//	|	});
		//	This is equivalent to calling set(foo, "Howdy") and set(bar, 3)

		// If an object is used, iterate through object
		if(typeof name === "object"){
			for(var x in name){
				if(name.hasOwnProperty(x) && x !="_watchCallbacks"){
					this.set(x, name[x]);
				}
			}
			return this;
		}

		var names = this._getAttrNames(name),
			oldValue = this._get(name, names),
			setter = this[names.s],
			result;
		if(typeof setter === "function"){
			// use the explicit setter
			result = setter.apply(this, Array.prototype.slice.call(arguments, 1));
		}else{
			// no setter so set attribute directly
			this[name] = value;
		}
		if(this._watchCallbacks){
			var self = this;
			// If setter returned a promise, wait for it to complete, otherwise call watches immediately
			when(result, function(){
				self._watchCallbacks(name, oldValue, value);
			});
		}
		return this; // dojo/Stateful
	},
	_changeAttrValue: function(name, value){
		// summary:
		//		Internal helper for directly changing an attribute value.
		//
		// name: String
		//		The property to set.
		// value: Mixed
		//		The value to set in the property.
		//
		// description:
		//		Directly change the value of an attribute on an object, bypassing any 
		//		accessor setter.  Also handles the calling of watch and emitting events. 
		//		It is designed to be used by descendant class when there are two values 
		//		of attributes that are linked, but calling .set() is not appropriate.

		var oldValue = this.get(name);
		this[name] = value;
		if(this._watchCallbacks){
			this._watchCallbacks(name, oldValue, value);
		}
		return this; // dojo/Stateful
	},
	watch: function(/*String?*/name, /*Function*/callback){
		// summary:
		//		Watches a property for changes
		// name:
		//		Indicates the property to watch. This is optional (the callback may be the
		//		only parameter), and if omitted, all the properties will be watched
		// returns:
		//		An object handle for the watch. The unwatch method of this object
		//		can be used to discontinue watching this property:
		//		|	var watchHandle = obj.watch("foo", callback);
		//		|	watchHandle.unwatch(); // callback won't be called now
		// callback:
		//		The function to execute when the property changes. This will be called after
		//		the property has been changed. The callback will be called with the |this|
		//		set to the instance, the first argument as the name of the property, the
		//		second argument as the old value and the third argument as the new value.

		var callbacks = this._watchCallbacks;
		if(!callbacks){
			var self = this;
			callbacks = this._watchCallbacks = function(name, oldValue, value, ignoreCatchall){
				var notify = function(propertyCallbacks){
					if(propertyCallbacks){
						propertyCallbacks = propertyCallbacks.slice();
						for(var i = 0, l = propertyCallbacks.length; i < l; i++){
							propertyCallbacks[i].call(self, name, oldValue, value);
						}
					}
				};
				notify(callbacks['_' + name]);
				if(!ignoreCatchall){
					notify(callbacks["*"]); // the catch-all
				}
			}; // we use a function instead of an object so it will be ignored by JSON conversion
		}
		if(!callback && typeof name === "function"){
			callback = name;
			name = "*";
		}else{
			// prepend with dash to prevent name conflicts with function (like "name" property)
			name = '_' + name;
		}
		var propertyCallbacks = callbacks[name];
		if(typeof propertyCallbacks !== "object"){
			propertyCallbacks = callbacks[name] = [];
		}
		propertyCallbacks.push(callback);

		// TODO: Remove unwatch in 2.0
		var handle = {};
		handle.unwatch = handle.remove = function(){
			var index = array.indexOf(propertyCallbacks, callback);
			if(index > -1){
				propertyCallbacks.splice(index, 1);
			}
		};
		return handle; //Object
	}

});

});

},
'dijit/Destroyable':function(){
define([
	"dojo/_base/array", // array.forEach array.map
	"dojo/aspect",
	"dojo/_base/declare"
], function(array, aspect, declare){

	// module:
	//		dijit/Destroyable

	return declare("dijit.Destroyable", null, {
		// summary:
		//		Mixin to track handles and release them when instance is destroyed.
		// description:
		//		Call this.own(...) on list of handles (returned from dojo/aspect, dojo/on,
		//		dojo/Stateful::watch, or any class (including widgets) with a destroyRecursive() or destroy() method.
		//		Then call destroy() later to destroy this instance and release the resources.

		destroy: function(/*Boolean*/ preserveDom){
			// summary:
			//		Destroy this class, releasing any resources registered via own().
			this._destroyed = true;
		},

		own: function(){
			// summary:
			//		Track specified handles and remove/destroy them when this instance is destroyed, unless they were
			//		already removed/destroyed manually.
			// tags:
			//		protected
			// returns:
			//		The array of specified handles, so you can do for example:
			//	|		var handle = this.own(on(...))[0];

			var cleanupMethods = [
				"destroyRecursive",
				"destroy",
				"remove"
			];

			array.forEach(arguments, function(handle){
				// When this.destroy() is called, destroy handle.  Since I'm using aspect.before(),
				// the handle will be destroyed before a subclass's destroy() method starts running, before it calls
				// this.inherited() or even if it doesn't call this.inherited() at all.  If that's an issue, make an
				// onDestroy() method and connect to that instead.
				var destroyMethodName;
				var odh = aspect.before(this, "destroy", function (preserveDom){
					handle[destroyMethodName](preserveDom);
				});

				// Callback for when handle is manually destroyed.
				var hdhs = [];
				function onManualDestroy(){
					odh.remove();
					array.forEach(hdhs, function(hdh){
						hdh.remove();
					});
				}

				// Setup listeners for manual destroy of handle.
				// Also computes destroyMethodName, used in listener above.
				if(handle.then){
					// Special path for Promises.  Detect when Promise is resolved, rejected, or
					// canceled (nb: cancelling a Promise causes it to be rejected).
					destroyMethodName = "cancel";
					handle.then(onManualDestroy, onManualDestroy);
				}else{
					// Path for other handles.  Just use AOP to detect when handle is manually destroyed.
					array.forEach(cleanupMethods, function(cleanupMethod){
						if(typeof handle[cleanupMethod] === "function"){
							if(!destroyMethodName){
								// Use first matching method name in above listener (prefer destroyRecursive() to destroy())
								destroyMethodName = cleanupMethod;
							}
							hdhs.push(aspect.after(handle, cleanupMethod, onManualDestroy, true));
						}
					});
				}
			}, this);

			return arguments;		// handle
		}
	});
});

},
'dijit/registry':function(){
define([
	"dojo/_base/array", // array.forEach array.map
	"dojo/_base/window", // win.body
	"./main"	// dijit._scopeName
], function(array, win, dijit){

	// module:
	//		dijit/registry

	var _widgetTypeCtr = {}, hash = {};

	var registry =  {
		// summary:
		//		Registry of existing widget on page, plus some utility methods.

		// length: Number
		//		Number of registered widgets
		length: 0,

		add: function(widget){
			// summary:
			//		Add a widget to the registry. If a duplicate ID is detected, a error is thrown.
			// widget: dijit/_WidgetBase
			//		Any dijit/_WidgetBase subclass.
			if(hash[widget.id]){
				throw new Error("Tried to register widget with id==" + widget.id + " but that id is already registered");
			}
			hash[widget.id] = widget;
			this.length++;
		},

		remove: function(/*String*/ id){
			// summary:
			//		Remove a widget from the registry. Does not destroy the widget; simply
			//		removes the reference.
			if(hash[id]){
				delete hash[id];
				this.length--;
			}
		},

		byId: function(/*String|Widget*/ id){
			// summary:
			//		Find a widget by it's id.
			//		If passed a widget then just returns the widget.
			return typeof id == "string" ? hash[id] : id;	// dijit/_WidgetBase
		},

		byNode: function(/*DOMNode*/ node){
			// summary:
			//		Returns the widget corresponding to the given DOMNode
			return hash[node.getAttribute("widgetId")]; // dijit/_WidgetBase
		},

		toArray: function(){
			// summary:
			//		Convert registry into a true Array
			//
			// example:
			//		Work with the widget .domNodes in a real Array
			//		|	array.map(registry.toArray(), function(w){ return w.domNode; });

			var ar = [];
			for(var id in hash){
				ar.push(hash[id]);
			}
			return ar;	// dijit/_WidgetBase[]
		},

		getUniqueId: function(/*String*/widgetType){
			// summary:
			//		Generates a unique id for a given widgetType

			var id;
			do{
				id = widgetType + "_" +
					(widgetType in _widgetTypeCtr ?
						++_widgetTypeCtr[widgetType] : _widgetTypeCtr[widgetType] = 0);
			}while(hash[id]);
			return dijit._scopeName == "dijit" ? id : dijit._scopeName + "_" + id; // String
		},

		findWidgets: function(root, skipNode){
			// summary:
			//		Search subtree under root returning widgets found.
			//		Doesn't search for nested widgets (ie, widgets inside other widgets).
			// root: DOMNode
			//		Node to search under.
			// skipNode: DOMNode
			//		If specified, don't search beneath this node (usually containerNode).

			var outAry = [];

			function getChildrenHelper(root){
				for(var node = root.firstChild; node; node = node.nextSibling){
					if(node.nodeType == 1){
						var widgetId = node.getAttribute("widgetId");
						if(widgetId){
							var widget = hash[widgetId];
							if(widget){	// may be null on page w/multiple dojo's loaded
								outAry.push(widget);
							}
						}else if(node !== skipNode){
							getChildrenHelper(node);
						}
					}
				}
			}

			getChildrenHelper(root);
			return outAry;
		},

		_destroyAll: function(){
			// summary:
			//		Code to destroy all widgets and do other cleanup on page unload

			// Clean up focus manager lingering references to widgets and nodes
			dijit._curFocus = null;
			dijit._prevFocus = null;
			dijit._activeStack = [];

			// Destroy all the widgets, top down
			array.forEach(registry.findWidgets(win.body()), function(widget){
				// Avoid double destroy of widgets like Menu that are attached to <body>
				// even though they are logically children of other widgets.
				if(!widget._destroyed){
					if(widget.destroyRecursive){
						widget.destroyRecursive();
					}else if(widget.destroy){
						widget.destroy();
					}
				}
			});
		},

		getEnclosingWidget: function(/*DOMNode*/ node){
			// summary:
			//		Returns the widget whose DOM tree contains the specified DOMNode, or null if
			//		the node is not contained within the DOM tree of any widget
			while(node){
				var id = node.nodeType == 1 && node.getAttribute("widgetId");
				if(id){
					return hash[id];
				}
				node = node.parentNode;
			}
			return null;
		},

		// In case someone needs to access hash.
		// Actually, this is accessed from WidgetSet back-compatibility code
		_hash: hash
	};

	dijit.registry = registry;

	return registry;
});

},
'dijit/main':function(){
define([
	"dojo/_base/kernel"
], function(dojo){
	// module:
	//		dijit/main

/*=====
return {
	// summary:
	//		The dijit package main module.
	//		Deprecated.   Users should access individual modules (ex: dijit/registry) directly.
};
=====*/

	return dojo.dijit;
});

},
'dijit/_Widget':function(){
define([
	"dojo/aspect",	// aspect.around
	"dojo/_base/config",	// config.isDebug
	"dojo/_base/connect",	// connect.connect
	"dojo/_base/declare", // declare
	"dojo/has",
	"dojo/_base/kernel", // kernel.deprecated
	"dojo/_base/lang", // lang.hitch
	"dojo/query",
	"dojo/ready",
	"./registry",	// registry.byNode
	"./_WidgetBase",
	"./_OnDijitClickMixin",
	"./_FocusMixin",
	"dojo/uacss",		// browser sniffing (included for back-compat; subclasses may be using)
	"./hccss"		// high contrast mode sniffing (included to set CSS classes on <body>, module ret value unused)
], function(aspect, config, connect, declare, has, kernel, lang, query, ready,
			registry, _WidgetBase, _OnDijitClickMixin, _FocusMixin){


// module:
//		dijit/_Widget


function connectToDomNode(){
	// summary:
	//		If user connects to a widget method === this function, then they will
	//		instead actually be connecting the equivalent event on this.domNode
}

// Trap dojo.connect() calls to connectToDomNode methods, and redirect to _Widget.on()
function aroundAdvice(originalConnect){
	return function(obj, event, scope, method){
		if(obj && typeof event == "string" && obj[event] == connectToDomNode){
			return obj.on(event.substring(2).toLowerCase(), lang.hitch(scope, method));
		}
		return originalConnect.apply(connect, arguments);
	};
}
aspect.around(connect, "connect", aroundAdvice);
if(kernel.connect){
	aspect.around(kernel, "connect", aroundAdvice);
}

var _Widget = declare("dijit._Widget", [_WidgetBase, _OnDijitClickMixin, _FocusMixin], {
	// summary:
	//		Old base class for widgets.   New widgets should extend `dijit/_WidgetBase` instead
	// description:
	//		Old Base class for Dijit widgets.
	//
	//		Extends _WidgetBase, adding support for:
	//
	//		- declaratively/programatically specifying widget initialization parameters like
	//			onMouseMove="foo" that call foo when this.domNode gets a mousemove event
	//		- ondijitclick:
	//			Support new data-dojo-attach-event="ondijitclick: ..." that is triggered by a mouse click or a SPACE/ENTER keypress
	//		- focus related functions:
	//			In particular, the onFocus()/onBlur() callbacks.   Driven internally by
	//			dijit/_base/focus.js.
	//		- deprecated methods
	//		- onShow(), onHide(), onClose()
	//
	//		Also, by loading code in dijit/_base, turns on:
	//
	//		- browser sniffing (putting browser class like `dj_ie` on `<html>` node)
	//		- high contrast mode sniffing (add `dijit_a11y` class to `<body>` if machine is in high contrast mode)


	////////////////// DEFERRED CONNECTS ///////////////////

	onClick: connectToDomNode,
	/*=====
	onClick: function(event){
		// summary:
		//		Connect to this function to receive notifications of mouse click events.
		// event:
		//		mouse Event
		// tags:
		//		callback
	},
	=====*/
	onDblClick: connectToDomNode,
	/*=====
	onDblClick: function(event){
		// summary:
		//		Connect to this function to receive notifications of mouse double click events.
		// event:
		//		mouse Event
		// tags:
		//		callback
	},
	=====*/
	onKeyDown: connectToDomNode,
	/*=====
	onKeyDown: function(event){
		// summary:
		//		Connect to this function to receive notifications of keys being pressed down.
		// event:
		//		key Event
		// tags:
		//		callback
	},
	=====*/
	onKeyPress: connectToDomNode,
	/*=====
	onKeyPress: function(event){
		// summary:
		//		Connect to this function to receive notifications of printable keys being typed.
		// event:
		//		key Event
		// tags:
		//		callback
	},
	=====*/
	onKeyUp: connectToDomNode,
	/*=====
	onKeyUp: function(event){
		// summary:
		//		Connect to this function to receive notifications of keys being released.
		// event:
		//		key Event
		// tags:
		//		callback
	},
	=====*/
	onMouseDown: connectToDomNode,
	/*=====
	onMouseDown: function(event){
		// summary:
		//		Connect to this function to receive notifications of when the mouse button is pressed down.
		// event:
		//		mouse Event
		// tags:
		//		callback
	},
	=====*/
	onMouseMove: connectToDomNode,
	/*=====
	onMouseMove: function(event){
		// summary:
		//		Connect to this function to receive notifications of when the mouse moves over nodes contained within this widget.
		// event:
		//		mouse Event
		// tags:
		//		callback
	},
	=====*/
	onMouseOut: connectToDomNode,
	/*=====
	onMouseOut: function(event){
		// summary:
		//		Connect to this function to receive notifications of when the mouse moves off of nodes contained within this widget.
		// event:
		//		mouse Event
		// tags:
		//		callback
	},
	=====*/
	onMouseOver: connectToDomNode,
	/*=====
	onMouseOver: function(event){
		// summary:
		//		Connect to this function to receive notifications of when the mouse moves onto nodes contained within this widget.
		// event:
		//		mouse Event
		// tags:
		//		callback
	},
	=====*/
	onMouseLeave: connectToDomNode,
	/*=====
	onMouseLeave: function(event){
		// summary:
		//		Connect to this function to receive notifications of when the mouse moves off of this widget.
		// event:
		//		mouse Event
		// tags:
		//		callback
	},
	=====*/
	onMouseEnter: connectToDomNode,
	/*=====
	onMouseEnter: function(event){
		// summary:
		//		Connect to this function to receive notifications of when the mouse moves onto this widget.
		// event:
		//		mouse Event
		// tags:
		//		callback
	},
	=====*/
	onMouseUp: connectToDomNode,
	/*=====
	onMouseUp: function(event){
		// summary:
		//		Connect to this function to receive notifications of when the mouse button is released.
		// event:
		//		mouse Event
		// tags:
		//		callback
	},
	=====*/

	constructor: function(params /*===== ,srcNodeRef =====*/){
		// summary:
		//		Create the widget.
		// params: Object|null
		//		Hash of initialization parameters for widget, including scalar values (like title, duration etc.)
		//		and functions, typically callbacks like onClick.
		//		The hash can contain any of the widget's properties, excluding read-only properties.
		// srcNodeRef: DOMNode|String?
		//		If a srcNodeRef (DOM node) is specified:
		//
		//		- use srcNodeRef.innerHTML as my contents
		//		- if this is a behavioral widget then apply behavior to that srcNodeRef
		//		- otherwise, replace srcNodeRef with my generated DOM tree

		// extract parameters like onMouseMove that should connect directly to this.domNode
		this._toConnect = {};
		for(var name in params){
			if(this[name] === connectToDomNode){
				this._toConnect[name.replace(/^on/, "").toLowerCase()] = params[name];
				delete params[name];
			}
		}
	},

	postCreate: function(){
		this.inherited(arguments);

		// perform connection from this.domNode to user specified handlers (ex: onMouseMove)
		for(var name in this._toConnect){
			this.on(name, this._toConnect[name]);
		}
		delete this._toConnect;
	},

	on: function(/*String|Function*/ type, /*Function*/ func){
		if(this[this._onMap(type)] === connectToDomNode){
			// Use connect.connect() rather than on() to get handling for "onmouseenter" on non-IE,
			// normalization of onkeypress/onkeydown to behave like firefox, etc.
			// Also, need to specify context as "this" rather than the default context of the DOMNode
			// Remove in 2.0.
			return connect.connect(this.domNode, type.toLowerCase(), this, func);
		}
		return this.inherited(arguments);
	},

	_setFocusedAttr: function(val){
		// Remove this method in 2.0 (or sooner), just here to set _focused == focused, for back compat
		// (but since it's a private variable we aren't required to keep supporting it).
		this._focused = val;
		this._set("focused", val);
	},

	////////////////// DEPRECATED METHODS ///////////////////

	setAttribute: function(/*String*/ attr, /*anything*/ value){
		// summary:
		//		Deprecated.  Use set() instead.
		// tags:
		//		deprecated
		kernel.deprecated(this.declaredClass+"::setAttribute(attr, value) is deprecated. Use set() instead.", "", "2.0");
		this.set(attr, value);
	},

	attr: function(/*String|Object*/name, /*Object?*/value){
		// summary:
		//		This method is deprecated, use get() or set() directly.
		// name:
		//		The property to get or set. If an object is passed here and not
		//		a string, its keys are used as names of attributes to be set
		//		and the value of the object as values to set in the widget.
		// value:
		//		Optional. If provided, attr() operates as a setter. If omitted,
		//		the current value of the named property is returned.
		// tags:
		//		deprecated

		var args = arguments.length;
		if(args >= 2 || typeof name === "object"){ // setter
			return this.set.apply(this, arguments);
		}else{ // getter
			return this.get(name);
		}
	},

	getDescendants: function(){
		// summary:
		//		Returns all the widgets contained by this, i.e., all widgets underneath this.containerNode.
		//		This method should generally be avoided as it returns widgets declared in templates, which are
		//		supposed to be internal/hidden, but it's left here for back-compat reasons.

		kernel.deprecated(this.declaredClass+"::getDescendants() is deprecated. Use getChildren() instead.", "", "2.0");
		return this.containerNode ? query('[widgetId]', this.containerNode).map(registry.byNode) : []; // dijit/_WidgetBase[]
	},

	////////////////// MISCELLANEOUS METHODS ///////////////////

	_onShow: function(){
		// summary:
		//		Internal method called when this widget is made visible.
		//		See `onShow` for details.
		this.onShow();
	},

	onShow: function(){
		// summary:
		//		Called when this widget becomes the selected pane in a
		//		`dijit/layout/TabContainer`, `dijit/layout/StackContainer`,
		//		`dijit/layout/AccordionContainer`, etc.
		//
		//		Also called to indicate display of a `dijit.Dialog`, `dijit.TooltipDialog`, or `dijit.TitlePane`.
		// tags:
		//		callback
	},

	onHide: function(){
		// summary:
		//		Called when another widget becomes the selected pane in a
		//		`dijit/layout/TabContainer`, `dijit/layout/StackContainer`,
		//		`dijit/layout/AccordionContainer`, etc.
		//
		//		Also called to indicate hide of a `dijit.Dialog`, `dijit.TooltipDialog`, or `dijit.TitlePane`.
		// tags:
		//		callback
	},

	onClose: function(){
		// summary:
		//		Called when this widget is being displayed as a popup (ex: a Calendar popped
		//		up from a DateTextBox), and it is hidden.
		//		This is called from the dijit.popup code, and should not be called directly.
		//
		//		Also used as a parameter for children of `dijit/layout/StackContainer` or subclasses.
		//		Callback if a user tries to close the child.   Child will be closed if this function returns true.
		// tags:
		//		extension

		return true;		// Boolean
	}
});

// For back-compat, remove in 2.0.
if(has("dijit-legacy-requires")){
	ready(0, function(){
		var requires = ["dijit/_base"];
		require(requires);	// use indirection so modules not rolled into a build
	});
}
return _Widget;
});

},
'dijit/_OnDijitClickMixin':function(){
define([
	"dojo/on",
	"dojo/_base/array", // array.forEach
	"dojo/keys", // keys.ENTER keys.SPACE
	"dojo/_base/declare", // declare
	"dojo/has", // has("dom-addeventlistener")
	"./a11yclick"
], function(on, array, keys, declare, has, a11yclick){

	// module:
	//		dijit/_OnDijitClickMixin

	var ret = declare("dijit._OnDijitClickMixin", null, {
		// summary:
		//		Deprecated.   New code should access the dijit/a11yclick event directly, ex:
		//		|	this.own(on(node, a11yclick, function(){ ... }));
		//
		//		Mixing in this class will make _WidgetBase.connect(node, "ondijitclick", ...) work.
		//		It also used to be necessary to make templates with ondijitclick work, but now you can just require
		//		dijit/a11yclick.

		connect: function(obj, event, method){
			// override _WidgetBase.connect() to make this.connect(node, "ondijitclick", ...) work
			return this.inherited(arguments, [obj, event == "ondijitclick" ? a11yclick : event, method]);
		}
	});

	ret.a11yclick = a11yclick;	// back compat

	return ret;
});

},
'dijit/a11yclick':function(){
define([
	"dojo/keys", // keys.ENTER keys.SPACE
	"dojo/mouse",
	"dojo/on",
	"dojo/touch" // touch support for click is now there
], function(keys, mouse, on, touch){

	// module:
	//		dijit/a11yclick

	/*=====
	return {
		// summary:
		//		Custom press, release, and click synthetic events
		//		which trigger on a left mouse click, touch, or space/enter keyup.

		click: function(node, listener){
			// summary:
			//		Logical click operation for mouse, touch, or keyboard (space/enter key)
		},
		press: function(node, listener){
			// summary:
			//		Mousedown (left button), touchstart, or keydown (space or enter) corresponding to logical click operation.
		},
		release: function(node, listener){
			// summary:
			//		Mouseup (left button), touchend, or keyup (space or enter) corresponding to logical click operation.
		},
		move: function(node, listener){
			// summary:
			//		Mouse cursor or a finger is dragged over the given node.
		}
	};
	=====*/

	function clickKey(/*Event*/ e){
		// Test if this keyboard event should be tracked as the start (if keydown) or end (if keyup) of a click event.
		// Only track for nodes marked to be tracked, and not for buttons or inputs,
		// since buttons handle keyboard click natively, and text inputs should not
		// prevent typing spaces or newlines.
		if((e.keyCode === keys.ENTER || e.keyCode === keys.SPACE) && !/input|button|textarea/i.test(e.target.nodeName)){

			// Test if a node or its ancestor has been marked with the dojoClick property to indicate special processing
			for(var node = e.target; node; node = node.parentNode){
				if(node.dojoClick){ return true; }
			}
		}
	}

	var lastKeyDownNode;

	on(document, "keydown", function(e){
		//console.log("a11yclick: onkeydown, e.target = ", e.target, ", lastKeyDownNode was ", lastKeyDownNode, ", equality is ", (e.target === lastKeyDownNode));
		if(clickKey(e)){
			// needed on IE for when focus changes between keydown and keyup - otherwise dropdown menus do not work
			lastKeyDownNode = e.target;

			// Prevent viewport scrolling on space key in IE<9.
			// (Reproducible on test_Button.html on any of the first dijit/form/Button examples)
			e.preventDefault();
		}else{
			lastKeyDownNode = null;
		}
	});

	on(document, "keyup", function(e){
		//console.log("a11yclick: onkeyup, e.target = ", e.target, ", lastKeyDownNode was ", lastKeyDownNode, ", equality is ", (e.target === lastKeyDownNode));
		if(clickKey(e) && e.target == lastKeyDownNode){	// === breaks greasemonkey
			//need reset here or have problems in FF when focus returns to trigger element after closing popup/alert
			lastKeyDownNode = null;

			on.emit(e.target, "click", {
				cancelable: true,
				bubbles: true,
				ctrlKey: e.ctrlKey,
				shiftKey: e.shiftKey,
				metaKey: e.metaKey,
				altKey: e.altKey,
				_origType: e.type
			});
		}
	});

	// I want to return a hash of the synthetic events, but for backwards compatibility the main return value
	// needs to be the click event.   Change for 2.0.

	var click = function(node, listener){
		// Set flag on node so that keydown/keyup above emits click event.
		// Also enables fast click processing from dojo/touch.
		node.dojoClick = true;

		return on(node, "click", listener);
	};
	click.click = click;	// forward compatibility with 2.0

	click.press =  function(node, listener){
		var touchListener = on(node, touch.press, function(evt){
			if(evt.type == "mousedown" && !mouse.isLeft(evt)){
				// Ignore right click
				return;
			}
			listener(evt);
		}), keyListener = on(node, "keydown", function(evt){
			if(evt.keyCode === keys.ENTER || evt.keyCode === keys.SPACE){
				listener(evt);
			}
		});
		return {
			remove: function(){
				touchListener.remove();
				keyListener.remove();
			}
		};
	};

	click.release =  function(node, listener){
		var touchListener = on(node, touch.release, function(evt){
			if(evt.type == "mouseup" && !mouse.isLeft(evt)){
				// Ignore right click
				return;
			}
			listener(evt);
		}), keyListener = on(node, "keyup", function(evt){
			if(evt.keyCode === keys.ENTER || evt.keyCode === keys.SPACE){
				listener(evt);
			}
		});
		return {
			remove: function(){
				touchListener.remove();
				keyListener.remove();
			}
		};
	};

	click.move = touch.move;	// just for convenience

	return click;
});

},
'dojo/touch':function(){
define(["./_base/kernel", "./aspect", "./dom", "./dom-class", "./_base/lang", "./on", "./has", "./mouse", "./domReady", "./_base/window"],
function(dojo, aspect, dom, domClass, lang, on, has, mouse, domReady, win){

	// module:
	//		dojo/touch

	var ios4 = has("ios") < 5;

	// Detect if platform supports Pointer Events, and if so, the names of the events (pointerdown vs. MSPointerDown).
	var hasPointer = has("pointer-events") || has("MSPointer"),
		pointer = (function () {
			var pointer = {};
			for (var type in { down: 1, move: 1, up: 1, cancel: 1, over: 1, out: 1 }) {
				pointer[type] = has("MSPointer") ?
					"MSPointer" + type.charAt(0).toUpperCase() + type.slice(1) :
					"pointer" + type;
			}
			return pointer;
		})();

	// Detect if platform supports the webkit touchstart/touchend/... events
	var hasTouch = has("touch-events");

	// Click generation variables
	var clicksInited, clickTracker, useTarget = false, clickTarget, clickX, clickY, clickDx, clickDy, clickTime;

	// Time of most recent touchstart, touchmove, or touchend event
	var lastTouch;

	function dualEvent(mouseType, touchType, pointerType){
		// Returns synthetic event that listens for both the specified mouse event and specified touch event.
		// But ignore fake mouse events that were generated due to the user touching the screen.
		if(hasPointer && pointerType){
			// IE10+: MSPointer* events are designed to handle both mouse and touch in a uniform way,
			// so just use that regardless of hasTouch.
			return function(node, listener){
				return on(node, pointerType, listener);
			};
		}else if(hasTouch){
			return function(node, listener){
				var handle1 = on(node, touchType, function(evt){
						listener.call(this, evt);

						// On slow mobile browsers (see https://bugs.dojotoolkit.org/ticket/17634),
						// a handler for a touch event may take >1s to run.  That time shouldn't
						// be included in the calculation for lastTouch.
						lastTouch = (new Date()).getTime();
					}),
					handle2 = on(node, mouseType, function(evt){
						if(!lastTouch || (new Date()).getTime() > lastTouch + 1000){
							listener.call(this, evt);
						}
					});
				return {
					remove: function(){
						handle1.remove();
						handle2.remove();
					}
				};
			};
		}else{
			// Avoid creating listeners for touch events on performance sensitive older browsers like IE6
			return function(node, listener){
				return on(node, mouseType, listener);
			};
		}
	}

	function marked(/*DOMNode*/ node){
		// Search for node ancestor has been marked with the dojoClick property to indicate special processing.
		// Returns marked ancestor.
		do{
			if(node.dojoClick !== undefined){ return node; }
		}while(node = node.parentNode);
	}

	function doClicks(e, moveType, endType){
		// summary:
		//		Setup touch listeners to generate synthetic clicks immediately (rather than waiting for the browser
		//		to generate clicks after the double-tap delay) and consistently (regardless of whether event.preventDefault()
		//		was called in an event listener. Synthetic clicks are generated only if a node or one of its ancestors has
		//		its dojoClick property set to truthy. If a node receives synthetic clicks because one of its ancestors has its
		//      dojoClick property set to truthy, you can disable synthetic clicks on this node by setting its own dojoClick property
		//      to falsy.

		if(mouse.isRight(e)){
			return;		// avoid spurious dojoclick event on IE10+; right click is just for context menu
		}

		var markedNode = marked(e.target);
		clickTracker  = !e.target.disabled && markedNode && markedNode.dojoClick; // click threshold = true, number, x/y object, or "useTarget"
		if(clickTracker){
			useTarget = (clickTracker == "useTarget");
			clickTarget = (useTarget?markedNode:e.target);
			if(useTarget){
				// We expect a click, so prevent any other
				// default action on "touchpress"
				e.preventDefault();
			}
			clickX = e.changedTouches ? e.changedTouches[0].pageX - win.global.pageXOffset : e.clientX;
			clickY = e.changedTouches ? e.changedTouches[0].pageY - win.global.pageYOffset : e.clientY;
			clickDx = (typeof clickTracker == "object" ? clickTracker.x : (typeof clickTracker == "number" ? clickTracker : 0)) || 4;
			clickDy = (typeof clickTracker == "object" ? clickTracker.y : (typeof clickTracker == "number" ? clickTracker : 0)) || 4;

			// add move/end handlers only the first time a node with dojoClick is seen,
			// so we don't add too much overhead when dojoClick is never set.
			if(!clicksInited){
				clicksInited = true;

				var updateClickTracker = function updateClickTracker(e){
					if(useTarget){
						clickTracker = dom.isDescendant(
							win.doc.elementFromPoint(
								(e.changedTouches ? e.changedTouches[0].pageX - win.global.pageXOffset : e.clientX),
								(e.changedTouches ? e.changedTouches[0].pageY - win.global.pageYOffset : e.clientY)),
							clickTarget);
					}else{
						clickTracker = clickTracker &&
							(e.changedTouches ? e.changedTouches[0].target : e.target) == clickTarget &&
							Math.abs((e.changedTouches ? e.changedTouches[0].pageX - win.global.pageXOffset : e.clientX) - clickX) <= clickDx &&
							Math.abs((e.changedTouches ? e.changedTouches[0].pageY - win.global.pageYOffset : e.clientY) - clickY) <= clickDy;
					}
				};

				win.doc.addEventListener(moveType, function(e){
					if(mouse.isRight(e)){
						return;		// avoid spurious dojoclick event on IE10+; right click is just for context menu
					}
					updateClickTracker(e);
					if(useTarget){
						// prevent native scroll event and ensure touchend is
						// fire after touch moves between press and release.
						e.preventDefault();
					}
				}, true);

				win.doc.addEventListener(endType, function(e){
					if(mouse.isRight(e)){
						return;		// avoid spurious dojoclick event on IE10+; right click is just for context menu
					}
					updateClickTracker(e);
					if(clickTracker){
						clickTime = (new Date()).getTime();
						var target = (useTarget?clickTarget:e.target);
						if(target.tagName === "LABEL"){
							// when clicking on a label, forward click to its associated input if any
							target = dom.byId(target.getAttribute("for")) || target;
						}
						//some attributes can be on the Touch object, not on the Event:
						//http://www.w3.org/TR/touch-events/#touch-interface
						var src = (e.changedTouches) ? e.changedTouches[0] : e;
						var createMouseEvent = function createMouseEvent(type){
							//create the synthetic event.
							//http://www.w3.org/TR/DOM-Level-3-Events/#widl-MouseEvent-initMouseEvent
							var evt = document.createEvent("MouseEvents");
							evt._dojo_click = true;
							evt.initMouseEvent(type,
								true, //bubbles
								true, //cancelable
								e.view,
								e.detail,
								src.screenX,
								src.screenY,
								src.clientX,
								src.clientY,
								e.ctrlKey,
								e.altKey,
								e.shiftKey,
								e.metaKey,
								0, //button
								null //related target
							);
							return evt;
						};
						var mouseDownEvt = createMouseEvent("mousedown");
						var mouseUpEvt = createMouseEvent("mouseup");
						var clickEvt = createMouseEvent("click");

						setTimeout(function(){
							on.emit(target, "mousedown", mouseDownEvt);
							on.emit(target, "mouseup", mouseUpEvt);
							on.emit(target, "click", clickEvt);

							// refresh clickTime in case app-defined click handler took a long time to run
							clickTime = (new Date()).getTime();
						}, 0);
					}
				}, true);

				var stopNativeEvents = function stopNativeEvents(type){
					win.doc.addEventListener(type, function(e){
						// Stop native events when we emitted our own click event.  Note that the native click may occur
						// on a different node than the synthetic click event was generated on.  For example,
						// click on a menu item, causing the menu to disappear, and then (~300ms later) the browser
						// sends a click event to the node that was *underneath* the menu.  So stop all native events
						// sent shortly after ours, similar to what is done in dualEvent.
						// The INPUT.dijitOffScreen test is for offscreen inputs used in dijit/form/Button, on which
						// we call click() explicitly, we don't want to stop this event.
						var target = e.target;
						if(clickTracker && !e._dojo_click &&
								(new Date()).getTime() <= clickTime + 1000 &&
								!(target.tagName == "INPUT" && domClass.contains(target, "dijitOffScreen"))){
							e.stopPropagation();
							e.stopImmediatePropagation && e.stopImmediatePropagation();
							if(type == "click" &&
								(target.tagName != "INPUT" ||
								(target.type == "radio" &&
									// #18352 Do not preventDefault for radios that are not dijit or
									// dojox/mobile widgets.
									// (The CSS class dijitCheckBoxInput holds for both checkboxes and radio buttons.)
									(domClass.contains(target, "dijitCheckBoxInput") ||
										domClass.contains(target, "mblRadioButton"))) ||
								(target.type == "checkbox" &&
									// #18352 Do not preventDefault for checkboxes that are not dijit or
									// dojox/mobile widgets.
									(domClass.contains(target, "dijitCheckBoxInput") ||
										domClass.contains(target, "mblCheckBox")))) &&
								target.tagName != "TEXTAREA" && target.tagName != "AUDIO" && target.tagName != "VIDEO"){
								// preventDefault() breaks textual <input>s on android, keyboard doesn't popup,
								// but it is still needed for checkboxes and radio buttons, otherwise in some cases
								// the checked state becomes inconsistent with the widget's state
								e.preventDefault();
							}
						}
					}, true);
				};

				stopNativeEvents("click");

				// We also stop mousedown/up since these would be sent well after with our "fast" click (300ms),
				// which can confuse some dijit widgets.
				stopNativeEvents("mousedown");
				stopNativeEvents("mouseup");
			}
		}
	}

	var hoveredNode;

	if(has("touch")){
		if(hasPointer){
			// MSPointer (IE10+) already has support for over and out, so we just need to init click support
			domReady(function(){
				win.doc.addEventListener(pointer.down, function(evt){
					doClicks(evt, pointer.move, pointer.up);
				}, true);
			});
		}else{
			domReady(function(){
				// Keep track of currently hovered node
				hoveredNode = win.body();	// currently hovered node

				win.doc.addEventListener("touchstart", function(evt){
						lastTouch = (new Date()).getTime();

					// Precede touchstart event with touch.over event.  DnD depends on this.
					// Use addEventListener(cb, true) to run cb before any touchstart handlers on node run,
					// and to ensure this code runs even if the listener on the node does event.stop().
					var oldNode = hoveredNode;
					hoveredNode = evt.target;
					on.emit(oldNode, "dojotouchout", {
						relatedTarget: hoveredNode,
						bubbles: true
					});
					on.emit(hoveredNode, "dojotouchover", {
						relatedTarget: oldNode,
						bubbles: true
					});

					doClicks(evt, "touchmove", "touchend"); // init click generation
				}, true);

				function copyEventProps(evt){
					// Make copy of event object and also set bubbles:true.  Used when calling on.emit().
					var props = lang.delegate(evt, {
						bubbles: true
					});

					if(has("ios") >= 6){
						// On iOS6 "touches" became a non-enumerable property, which
						// is not hit by for...in.  Ditto for the other properties below.
						props.touches = evt.touches;
						props.altKey = evt.altKey;
						props.changedTouches = evt.changedTouches;
						props.ctrlKey = evt.ctrlKey;
						props.metaKey = evt.metaKey;
						props.shiftKey = evt.shiftKey;
						props.targetTouches = evt.targetTouches;
					}

					return props;
				}

				on(win.doc, "touchmove", function(evt){
					lastTouch = (new Date()).getTime();

					var newNode = win.doc.elementFromPoint(
						evt.pageX - (ios4 ? 0 : win.global.pageXOffset), // iOS 4 expects page coords
						evt.pageY - (ios4 ? 0 : win.global.pageYOffset)
					);

					if(newNode){
						// Fire synthetic touchover and touchout events on nodes since the browser won't do it natively.
						if(hoveredNode !== newNode){
							// touch out on the old node
							on.emit(hoveredNode, "dojotouchout", {
								relatedTarget: newNode,
								bubbles: true
							});

							// touchover on the new node
							on.emit(newNode, "dojotouchover", {
								relatedTarget: hoveredNode,
								bubbles: true
							});

							hoveredNode = newNode;
						}

						// Unlike a listener on "touchmove", on(node, "dojotouchmove", listener) fires when the finger
						// drags over the specified node, regardless of which node the touch started on.
						if(!on.emit(newNode, "dojotouchmove", copyEventProps(evt))){
							// emit returns false when synthetic event "dojotouchmove" is cancelled, so we prevent the
							// default behavior of the underlying native event "touchmove".
							evt.preventDefault();
						}
					}
				});

				// Fire a dojotouchend event on the node where the finger was before it was removed from the screen.
				// This is different than the native touchend, which fires on the node where the drag started.
				on(win.doc, "touchend", function(evt){
						lastTouch = (new Date()).getTime();
					var node = win.doc.elementFromPoint(
						evt.pageX - (ios4 ? 0 : win.global.pageXOffset), // iOS 4 expects page coords
						evt.pageY - (ios4 ? 0 : win.global.pageYOffset)
					) || win.body(); // if out of the screen

					on.emit(node, "dojotouchend", copyEventProps(evt));
				});
			});
		}
	}

	//device neutral events - touch.press|move|release|cancel/over/out
	var touch = {
		press: dualEvent("mousedown", "touchstart", pointer.down),
		move: dualEvent("mousemove", "dojotouchmove", pointer.move),
		release: dualEvent("mouseup", "dojotouchend", pointer.up),
		cancel: dualEvent(mouse.leave, "touchcancel", hasPointer ? pointer.cancel : null),
		over: dualEvent("mouseover", "dojotouchover", pointer.over),
		out: dualEvent("mouseout", "dojotouchout", pointer.out),
		enter: mouse._eventHandler(dualEvent("mouseover","dojotouchover", pointer.over)),
		leave: mouse._eventHandler(dualEvent("mouseout", "dojotouchout", pointer.out))
	};

	/*=====
	touch = {
		// summary:
		//		This module provides unified touch event handlers by exporting
		//		press, move, release and cancel which can also run well on desktop.
		//		Based on http://dvcs.w3.org/hg/webevents/raw-file/tip/touchevents.html
		//      Also, if the dojoClick property is set to truthy on a DOM node, dojo/touch generates
		//      click events immediately for this node and its descendants (except for descendants that
		//      have a dojoClick property set to falsy), to avoid the delay before native browser click events,
		//      and regardless of whether evt.preventDefault() was called in a touch.press event listener.
		//
		// example:
		//		Used with dojo/on
		//		|	define(["dojo/on", "dojo/touch"], function(on, touch){
		//		|		on(node, touch.press, function(e){});
		//		|		on(node, touch.move, function(e){});
		//		|		on(node, touch.release, function(e){});
		//		|		on(node, touch.cancel, function(e){});
		// example:
		//		Used with touch.* directly
		//		|	touch.press(node, function(e){});
		//		|	touch.move(node, function(e){});
		//		|	touch.release(node, function(e){});
		//		|	touch.cancel(node, function(e){});
		// example:
		//		Have dojo/touch generate clicks without delay, with a default move threshold of 4 pixels
		//		|	node.dojoClick = true;
		// example:
		//		Have dojo/touch generate clicks without delay, with a move threshold of 10 pixels horizontally and vertically
		//		|	node.dojoClick = 10;
		// example:
		//		Have dojo/touch generate clicks without delay, with a move threshold of 50 pixels horizontally and 10 pixels vertically
		//		|	node.dojoClick = {x:50, y:5};
		// example:
		//		Disable clicks without delay generated by dojo/touch on a node that has an ancestor with property dojoClick set to truthy
		//		|  node.dojoClick = false;

		press: function(node, listener){
			// summary:
			//		Register a listener to 'touchstart'|'mousedown' for the given node
			// node: Dom
			//		Target node to listen to
			// listener: Function
			//		Callback function
			// returns:
			//		A handle which will be used to remove the listener by handle.remove()
		},
		move: function(node, listener){
			// summary:
			//		Register a listener that fires when the mouse cursor or a finger is dragged over the given node.
			// node: Dom
			//		Target node to listen to
			// listener: Function
			//		Callback function
			// returns:
			//		A handle which will be used to remove the listener by handle.remove()
		},
		release: function(node, listener){
			// summary:
			//		Register a listener to releasing the mouse button while the cursor is over the given node
			//		(i.e. "mouseup") or for removing the finger from the screen while touching the given node.
			// node: Dom
			//		Target node to listen to
			// listener: Function
			//		Callback function
			// returns:
			//		A handle which will be used to remove the listener by handle.remove()
		},
		cancel: function(node, listener){
			// summary:
			//		Register a listener to 'touchcancel'|'mouseleave' for the given node
			// node: Dom
			//		Target node to listen to
			// listener: Function
			//		Callback function
			// returns:
			//		A handle which will be used to remove the listener by handle.remove()
		},
		over: function(node, listener){
			// summary:
			//		Register a listener to 'mouseover' or touch equivalent for the given node
			// node: Dom
			//		Target node to listen to
			// listener: Function
			//		Callback function
			// returns:
			//		A handle which will be used to remove the listener by handle.remove()
		},
		out: function(node, listener){
			// summary:
			//		Register a listener to 'mouseout' or touch equivalent for the given node
			// node: Dom
			//		Target node to listen to
			// listener: Function
			//		Callback function
			// returns:
			//		A handle which will be used to remove the listener by handle.remove()
		},
		enter: function(node, listener){
			// summary:
			//		Register a listener to mouse.enter or touch equivalent for the given node
			// node: Dom
			//		Target node to listen to
			// listener: Function
			//		Callback function
			// returns:
			//		A handle which will be used to remove the listener by handle.remove()
		},
		leave: function(node, listener){
			// summary:
			//		Register a listener to mouse.leave or touch equivalent for the given node
			// node: Dom
			//		Target node to listen to
			// listener: Function
			//		Callback function
			// returns:
			//		A handle which will be used to remove the listener by handle.remove()
		}
	};
	=====*/

	 1  && (dojo.touch = touch);

	return touch;
});

},
'dijit/_FocusMixin':function(){
define([
	"./focus",
	"./_WidgetBase",
	"dojo/_base/declare", // declare
	"dojo/_base/lang" // lang.extend
], function(focus, _WidgetBase, declare, lang){

	// module:
	//		dijit/_FocusMixin

	// We don't know where _FocusMixin will occur in the inheritance chain, but we need the _onFocus()/_onBlur() below
	// to be last in the inheritance chain, so mixin to _WidgetBase.
	lang.extend(_WidgetBase, {
		// focused: [readonly] Boolean
		//		This widget or a widget it contains has focus, or is "active" because
		//		it was recently clicked.
		focused: false,

		onFocus: function(){
			// summary:
			//		Called when the widget becomes "active" because
			//		it or a widget inside of it either has focus, or has recently
			//		been clicked.
			// tags:
			//		callback
		},

		onBlur: function(){
			// summary:
			//		Called when the widget stops being "active" because
			//		focus moved to something outside of it, or the user
			//		clicked somewhere outside of it, or the widget was
			//		hidden.
			// tags:
			//		callback
		},

		_onFocus: function(){
			// summary:
			//		This is where widgets do processing for when they are active,
			//		such as changing CSS classes.  See onFocus() for more details.
			// tags:
			//		protected
			this.onFocus();
		},

		_onBlur: function(){
			// summary:
			//		This is where widgets do processing for when they stop being active,
			//		such as changing CSS classes.  See onBlur() for more details.
			// tags:
			//		protected
			this.onBlur();
		}
	});

	return declare("dijit._FocusMixin", null, {
		// summary:
		//		Mixin to widget to provide _onFocus() and _onBlur() methods that
		//		fire when a widget or its descendants get/lose focus

		// flag that I want _onFocus()/_onBlur() notifications from focus manager
		_focusManager: focus
	});

});

},
'dijit/focus':function(){
define([
	"dojo/aspect",
	"dojo/_base/declare", // declare
	"dojo/dom", // domAttr.get dom.isDescendant
	"dojo/dom-attr", // domAttr.get dom.isDescendant
	"dojo/dom-class",
	"dojo/dom-construct", // connect to domConstruct.empty, domConstruct.destroy
	"dojo/Evented",
	"dojo/_base/lang", // lang.hitch
	"dojo/on",
	"dojo/domReady",
	"dojo/sniff", // has("ie")
	"dojo/Stateful",
	"dojo/_base/window", // win.body
	"dojo/window", // winUtils.get
	"./a11y",	// a11y.isTabNavigable
	"./registry",	// registry.byId
	"./main"		// to set dijit.focus
], function(aspect, declare, dom, domAttr, domClass, domConstruct, Evented, lang, on, domReady, has, Stateful, win, winUtils,
			a11y, registry, dijit){

	// module:
	//		dijit/focus

	// Time of the last focusin event
	var lastFocusin;

	// Time of the last touch/mousedown or focusin event
	var lastTouchOrFocusin;

	var FocusManager = declare([Stateful, Evented], {
		// summary:
		//		Tracks the currently focused node, and which widgets are currently "active".
		//		Access via require(["dijit/focus"], function(focus){ ... }).
		//
		//		A widget is considered active if it or a descendant widget has focus,
		//		or if a non-focusable node of this widget or a descendant was recently clicked.
		//
		//		Call focus.watch("curNode", callback) to track the current focused DOMNode,
		//		or focus.watch("activeStack", callback) to track the currently focused stack of widgets.
		//
		//		Call focus.on("widget-blur", func) or focus.on("widget-focus", ...) to monitor when
		//		when widgets become active/inactive
		//
		//		Finally, focus(node) will focus a node, suppressing errors if the node doesn't exist.

		// curNode: DomNode
		//		Currently focused item on screen
		curNode: null,

		// activeStack: dijit/_WidgetBase[]
		//		List of currently active widgets (focused widget and it's ancestors)
		activeStack: [],

		constructor: function(){
			// Don't leave curNode/prevNode pointing to bogus elements
			var check = lang.hitch(this, function(node){
				if(dom.isDescendant(this.curNode, node)){
					this.set("curNode", null);
				}
				if(dom.isDescendant(this.prevNode, node)){
					this.set("prevNode", null);
				}
			});
			aspect.before(domConstruct, "empty", check);
			aspect.before(domConstruct, "destroy", check);
		},

		registerIframe: function(/*DomNode*/ iframe){
			// summary:
			//		Registers listeners on the specified iframe so that any click
			//		or focus event on that iframe (or anything in it) is reported
			//		as a focus/click event on the `<iframe>` itself.
			// description:
			//		Currently only used by editor.
			// returns:
			//		Handle with remove() method to deregister.
			return this.registerWin(iframe.contentWindow, iframe);
		},

		registerWin: function(/*Window?*/targetWindow, /*DomNode?*/ effectiveNode){
			// summary:
			//		Registers listeners on the specified window (either the main
			//		window or an iframe's window) to detect when the user has clicked somewhere
			//		or focused somewhere.
			// description:
			//		Users should call registerIframe() instead of this method.
			// targetWindow:
			//		If specified this is the window associated with the iframe,
			//		i.e. iframe.contentWindow.
			// effectiveNode:
			//		If specified, report any focus events inside targetWindow as
			//		an event on effectiveNode, rather than on evt.target.
			// returns:
			//		Handle with remove() method to deregister.

			// TODO: make this function private in 2.0; Editor/users should call registerIframe(),

			// Listen for blur and focus events on targetWindow's document.
			var _this = this,
				body = targetWindow.document && targetWindow.document.body;

			if(body){
				// Listen for touches or mousedowns... could also use dojo/touch.press here.
				var event = has("pointer-events") ? "pointerdown" : has("MSPointer") ? "MSPointerDown" :
					has("touch-events") ? "mousedown, touchstart" : "mousedown";
				var mdh = on(targetWindow.document, event, function(evt){
					// workaround weird IE bug where the click is on an orphaned node
					// (first time clicking a Select/DropDownButton inside a TooltipDialog).
					// actually, strangely this is happening on latest chrome too.
					if(evt && evt.target && evt.target.parentNode == null){
						return;
					}

					_this._onTouchNode(effectiveNode || evt.target, "mouse");
				});

				var fih = on(body, 'focusin', function(evt){
					// When you refocus the browser window, IE gives an event with an empty srcElement
					if(!evt.target.tagName) { return; }

					// IE reports that nodes like <body> have gotten focus, even though they have tabIndex=-1,
					// ignore those events
					var tag = evt.target.tagName.toLowerCase();
					if(tag == "#document" || tag == "body"){ return; }

					if(a11y.isFocusable(evt.target)){
						_this._onFocusNode(effectiveNode || evt.target);
					}else{
						// Previous code called _onTouchNode() for any activate event on a non-focusable node.   Can
						// probably just ignore such an event as it will be handled by onmousedown handler above, but
						// leaving the code for now.
						_this._onTouchNode(effectiveNode || evt.target);
					}
				});

				var foh = on(body, 'focusout', function(evt){
					_this._onBlurNode(effectiveNode || evt.target);
				});

				return {
					remove: function(){
						mdh.remove();
						fih.remove();
						foh.remove();
						mdh = fih = foh = null;
						body = null;	// prevent memory leak (apparent circular reference via closure)
					}
				};
			}
		},

		_onBlurNode: function(/*DomNode*/ node){
			// summary:
			//		Called when focus leaves a node.
			//		Usually ignored, _unless_ it *isn't* followed by touching another node,
			//		which indicates that we tabbed off the last field on the page,
			//		in which case every widget is marked inactive

			var now = (new Date()).getTime();

			// IE9+ and chrome have a problem where focusout events come after the corresponding focusin event.
			// For chrome problem see https://bugs.dojotoolkit.org/ticket/17668.
			// IE problem happens when moving focus from the Editor's <iframe> to a normal DOMNode.
			if(now < lastFocusin + 100){
				return;
			}

			// If the blur event isn't followed by a focus event, it means the user clicked on something unfocusable,
			// so clear focus.
			if(this._clearFocusTimer){
				clearTimeout(this._clearFocusTimer);
			}
			this._clearFocusTimer = setTimeout(lang.hitch(this, function(){
				this.set("prevNode", this.curNode);
				this.set("curNode", null);
			}), 0);

			// Unset timer to zero-out widget stack; we'll reset it below if appropriate.
			if(this._clearActiveWidgetsTimer){
				clearTimeout(this._clearActiveWidgetsTimer);
			}

			if(now < lastTouchOrFocusin + 100){
				// This blur event is coming late (after the call to _onTouchNode() rather than before.
				// So let _onTouchNode() handle setting the widget stack.
				// See https://bugs.dojotoolkit.org/ticket/17668
				return;
			}

			// If the blur event isn't followed (or preceded) by a focus or touch event then mark all widgets as inactive.
			this._clearActiveWidgetsTimer = setTimeout(lang.hitch(this, function(){
				delete this._clearActiveWidgetsTimer;
				this._setStack([]);
			}), 0);
		},

		_onTouchNode: function(/*DomNode*/ node, /*String*/ by){
			// summary:
			//		Callback when node is focused or touched.
			//		Note that _onFocusNode() calls _onTouchNode().
			// node:
			//		The node that was touched.
			// by:
			//		"mouse" if the focus/touch was caused by a mouse down event

			// Keep track of time of last focusin or touch event.
			lastTouchOrFocusin = (new Date()).getTime();

			if(this._clearActiveWidgetsTimer){
				// forget the recent blur event
				clearTimeout(this._clearActiveWidgetsTimer);
				delete this._clearActiveWidgetsTimer;
			}

			// if the click occurred on the scrollbar of a dropdown, treat it as a click on the dropdown,
			// even though the scrollbar is technically on the popup wrapper (see #10631)
			if(domClass.contains(node, "dijitPopup")){
				node = node.firstChild;
			}

			// compute stack of active widgets (ex: ComboButton --> Menu --> MenuItem)
			var newStack=[];
			try{
				while(node){
					var popupParent = domAttr.get(node, "dijitPopupParent");
					if(popupParent){
						node=registry.byId(popupParent).domNode;
					}else if(node.tagName && node.tagName.toLowerCase() == "body"){
						// is this the root of the document or just the root of an iframe?
						if(node === win.body()){
							// node is the root of the main document
							break;
						}
						// otherwise, find the iframe this node refers to (can't access it via parentNode,
						// need to do this trick instead). window.frameElement is supported in IE/FF/Webkit
						node=winUtils.get(node.ownerDocument).frameElement;
					}else{
						// if this node is the root node of a widget, then add widget id to stack,
						// except ignore clicks on disabled widgets (actually focusing a disabled widget still works,
						// to support MenuItem)
						var id = node.getAttribute && node.getAttribute("widgetId"),
							widget = id && registry.byId(id);
						if(widget && !(by == "mouse" && widget.get("disabled"))){
							newStack.unshift(id);
						}
						node=node.parentNode;
					}
				}
			}catch(e){ /* squelch */ }

			this._setStack(newStack, by);
		},

		_onFocusNode: function(/*DomNode*/ node){
			// summary:
			//		Callback when node is focused

			if(!node){
				return;
			}

			if(node.nodeType == 9){
				// Ignore focus events on the document itself.  This is here so that
				// (for example) clicking the up/down arrows of a spinner
				// (which don't get focus) won't cause that widget to blur. (FF issue)
				return;
			}

			// Keep track of time of last focusin event.
			lastFocusin = (new Date()).getTime();

			// There was probably a blur event right before this event, but since we have a new focus,
			// forget about the blur
			if(this._clearFocusTimer){
				clearTimeout(this._clearFocusTimer);
				delete this._clearFocusTimer;
			}

			this._onTouchNode(node);

			if(node == this.curNode){ return; }
			this.set("prevNode", this.curNode);
			this.set("curNode", node);
		},

		_setStack: function(/*String[]*/ newStack, /*String*/ by){
			// summary:
			//		The stack of active widgets has changed.  Send out appropriate events and records new stack.
			// newStack:
			//		array of widget id's, starting from the top (outermost) widget
			// by:
			//		"mouse" if the focus/touch was caused by a mouse down event

			var oldStack = this.activeStack, lastOldIdx = oldStack.length - 1, lastNewIdx = newStack.length - 1;

			if(newStack[lastNewIdx] == oldStack[lastOldIdx]){
				// no changes, return now to avoid spurious notifications about changes to activeStack
				return;
			}

			this.set("activeStack", newStack);

			var widget, i;

			// for all elements that have gone out of focus, set focused=false
			for(i = lastOldIdx; i >= 0 && oldStack[i] != newStack[i]; i--){
				widget = registry.byId(oldStack[i]);
				if(widget){
					widget._hasBeenBlurred = true;		// TODO: used by form widgets, should be moved there
					widget.set("focused", false);
					if(widget._focusManager == this){
						widget._onBlur(by);
					}
					this.emit("widget-blur", widget, by);
				}
			}

			// for all element that have come into focus, set focused=true
			for(i++; i <= lastNewIdx; i++){
				widget = registry.byId(newStack[i]);
				if(widget){
					widget.set("focused", true);
					if(widget._focusManager == this){
						widget._onFocus(by);
					}
					this.emit("widget-focus", widget, by);
				}
			}
		},

		focus: function(node){
			// summary:
			//		Focus the specified node, suppressing errors if they occur
			if(node){
				try{ node.focus(); }catch(e){/*quiet*/}
			}
		}
	});

	var singleton = new FocusManager();

	// register top window and all the iframes it contains
	domReady(function(){
		var handle = singleton.registerWin(winUtils.get(document));
		if(has("ie")){
			on(window, "unload", function(){
				if(handle){	// because this gets called twice when doh.robot is running
					handle.remove();
					handle = null;
				}
			});
		}
	});

	// Setup dijit.focus as a pointer to the singleton but also (for backwards compatibility)
	// as a function to set focus.   Remove for 2.0.
	dijit.focus = function(node){
		singleton.focus(node);	// indirection here allows dijit/_base/focus.js to override behavior
	};
	for(var attr in singleton){
		if(!/^_/.test(attr)){
			dijit.focus[attr] = typeof singleton[attr] == "function" ? lang.hitch(singleton, attr) : singleton[attr];
		}
	}
	singleton.watch(function(attr, oldVal, newVal){
		dijit.focus[attr] = newVal;
	});

	return singleton;
});

},
'dijit/a11y':function(){
define([
	"dojo/_base/array", // array.forEach array.map
	"dojo/dom",			// dom.byId
	"dojo/dom-attr", // domAttr.attr domAttr.has
	"dojo/dom-style", // domStyle.style
	"dojo/_base/lang", // lang.mixin()
	"dojo/sniff", // has("ie")  1 
	"./main"	// for exporting methods to dijit namespace
], function(array, dom, domAttr, domStyle, lang, has, dijit){

	// module:
	//		dijit/a11y

	var undefined;

	var a11y = {
		// summary:
		//		Accessibility utility functions (keyboard, tab stops, etc.)

		_isElementShown: function(/*Element*/ elem){
			var s = domStyle.get(elem);
			return (s.visibility != "hidden")
				&& (s.visibility != "collapsed")
				&& (s.display != "none")
				&& (domAttr.get(elem, "type") != "hidden");
		},

		hasDefaultTabStop: function(/*Element*/ elem){
			// summary:
			//		Tests if element is tab-navigable even without an explicit tabIndex setting

			// No explicit tabIndex setting, need to investigate node type
			switch(elem.nodeName.toLowerCase()){
				case "a":
					// An <a> w/out a tabindex is only navigable if it has an href
					return domAttr.has(elem, "href");
				case "area":
				case "button":
				case "input":
				case "object":
				case "select":
				case "textarea":
					// These are navigable by default
					return true;
				case "iframe":
					// If it's an editor <iframe> then it's tab navigable.
					var body;
					try{
						// non-IE
						var contentDocument = elem.contentDocument;
						if("designMode" in contentDocument && contentDocument.designMode == "on"){
							return true;
						}
						body = contentDocument.body;
					}catch(e1){
						// contentWindow.document isn't accessible within IE7/8
						// if the iframe.src points to a foreign url and this
						// page contains an element, that could get focus
						try{
							body = elem.contentWindow.document.body;
						}catch(e2){
							return false;
						}
					}
					return body && (body.contentEditable == 'true' ||
						(body.firstChild && body.firstChild.contentEditable == 'true'));
				default:
					return elem.contentEditable == 'true';
			}
		},

		effectiveTabIndex: function(/*Element*/ elem){
			// summary:
			//		Returns effective tabIndex of an element, either a number, or undefined if element isn't focusable.

			if(domAttr.get(elem, "disabled")){
				return undefined;
			}else if(domAttr.has(elem, "tabIndex")){
				// Explicit tab index setting
				return +domAttr.get(elem, "tabIndex");// + to convert string --> number
			}else{
				// No explicit tabIndex setting, so depends on node type
				return a11y.hasDefaultTabStop(elem) ? 0 : undefined;
			}
		},

		isTabNavigable: function(/*Element*/ elem){
			// summary:
			//		Tests if an element is tab-navigable

			return a11y.effectiveTabIndex(elem) >= 0;
		},

		isFocusable: function(/*Element*/ elem){
			// summary:
			//		Tests if an element is focusable by tabbing to it, or clicking it with the mouse.

			return a11y.effectiveTabIndex(elem) >= -1;
		},

		_getTabNavigable: function(/*DOMNode*/ root){
			// summary:
			//		Finds descendants of the specified root node.
			// description:
			//		Finds the following descendants of the specified root node:
			//
			//		- the first tab-navigable element in document order
			//		  without a tabIndex or with tabIndex="0"
			//		- the last tab-navigable element in document order
			//		  without a tabIndex or with tabIndex="0"
			//		- the first element in document order with the lowest
			//		  positive tabIndex value
			//		- the last element in document order with the highest
			//		  positive tabIndex value
			var first, last, lowest, lowestTabindex, highest, highestTabindex, radioSelected = {};

			function radioName(node){
				// If this element is part of a radio button group, return the name for that group.
				return node && node.tagName.toLowerCase() == "input" &&
					node.type && node.type.toLowerCase() == "radio" &&
					node.name && node.name.toLowerCase();
			}

			var shown = a11y._isElementShown, effectiveTabIndex = a11y.effectiveTabIndex;
			var walkTree = function(/*DOMNode*/ parent){
				for(var child = parent.firstChild; child; child = child.nextSibling){
					// Skip text elements, hidden elements, and also non-HTML elements (those in custom namespaces) in IE,
					// since show() invokes getAttribute("type"), which crash on VML nodes in IE.
					if(child.nodeType != 1 || (has("ie") <= 9 && child.scopeName !== "HTML") || !shown(child)){
						continue;
					}

					var tabindex = effectiveTabIndex(child);
					if(tabindex >= 0){
						if(tabindex == 0){
							if(!first){
								first = child;
							}
							last = child;
						}else if(tabindex > 0){
							if(!lowest || tabindex < lowestTabindex){
								lowestTabindex = tabindex;
								lowest = child;
							}
							if(!highest || tabindex >= highestTabindex){
								highestTabindex = tabindex;
								highest = child;
							}
						}
						var rn = radioName(child);
						if(domAttr.get(child, "checked") && rn){
							radioSelected[rn] = child;
						}
					}
					if(child.nodeName.toUpperCase() != 'SELECT'){
						walkTree(child);
					}
				}
			};
			if(shown(root)){
				walkTree(root);
			}
			function rs(node){
				// substitute checked radio button for unchecked one, if there is a checked one with the same name.
				return radioSelected[radioName(node)] || node;
			}

			return { first: rs(first), last: rs(last), lowest: rs(lowest), highest: rs(highest) };
		},

		getFirstInTabbingOrder: function(/*String|DOMNode*/ root, /*Document?*/ doc){
			// summary:
			//		Finds the descendant of the specified root node
			//		that is first in the tabbing order
			var elems = a11y._getTabNavigable(dom.byId(root, doc));
			return elems.lowest ? elems.lowest : elems.first; // DomNode
		},

		getLastInTabbingOrder: function(/*String|DOMNode*/ root, /*Document?*/ doc){
			// summary:
			//		Finds the descendant of the specified root node
			//		that is last in the tabbing order
			var elems = a11y._getTabNavigable(dom.byId(root, doc));
			return elems.last ? elems.last : elems.highest; // DomNode
		}
	};

	 1  && lang.mixin(dijit, a11y);

	return a11y;
});

},
'dojo/uacss':function(){
define(["./dom-geometry", "./_base/lang", "./domReady", "./sniff", "./_base/window"],
	function(geometry, lang, domReady, has, baseWindow){

	// module:
	//		dojo/uacss

	/*=====
	return {
		// summary:
		//		Applies pre-set CSS classes to the top-level HTML node, based on:
		//
		//		- browser (ex: dj_ie)
		//		- browser version (ex: dj_ie6)
		//		- box model (ex: dj_contentBox)
		//		- text direction (ex: dijitRtl)
		//
		//		In addition, browser, browser version, and box model are
		//		combined with an RTL flag when browser text is RTL. ex: dj_ie-rtl.
		//
		//		Returns the has() method.
	};
	=====*/

	var
		html = baseWindow.doc.documentElement,
		ie = has("ie"),
		trident = has("trident"),
		opera = has("opera"),
		maj = Math.floor,
		ff = has("ff"),
		boxModel = geometry.boxModel.replace(/-/,''),

		classes = {
			"dj_quirks": has("quirks"),

			// NOTE: Opera not supported by dijit
			"dj_opera": opera,

			"dj_khtml": has("khtml"),

			"dj_webkit": has("webkit"),
			"dj_safari": has("safari"),
			"dj_chrome": has("chrome"),
			"dj_edge": has("edge"),

			"dj_gecko": has("mozilla"),

			"dj_ios": has("ios"),
			"dj_android": has("android")
		}; // no dojo unsupported browsers

	if(ie){
		classes["dj_ie"] = true;
		classes["dj_ie" + maj(ie)] = true;
		classes["dj_iequirks"] = has("quirks");
	}
	if(trident){
		classes["dj_trident"] = true;
		classes["dj_trident" + maj(trident)] = true;
	}
	if(ff){
		classes["dj_ff" + maj(ff)] = true;
	}

	classes["dj_" + boxModel] = true;

	// apply browser, browser version, and box model class names
	var classStr = "";
	for(var clz in classes){
		if(classes[clz]){
			classStr += clz + " ";
		}
	}
	html.className = lang.trim(html.className + " " + classStr);

	// If RTL mode, then add dj_rtl flag plus repeat existing classes with -rtl extension.
	// We can't run the code below until the <body> tag has loaded (so we can check for dir=rtl).
	domReady(function(){
		if(!geometry.isBodyLtr()){
			var rtlClassStr = "dj_rtl dijitRtl " + classStr.replace(/ /g, "-rtl ");
			html.className = lang.trim(html.className + " " + rtlClassStr + "dj_rtl dijitRtl " + classStr.replace(/ /g, "-rtl "));
		}
	});
	return has;
});

},
'dijit/hccss':function(){
define(["dojo/dom-class", "dojo/hccss", "dojo/domReady", "dojo/_base/window"], function(domClass, has, domReady, win){

	// module:
	//		dijit/hccss

	/*=====
	return function(){
		// summary:
		//		Test if computer is in high contrast mode, and sets `dijit_a11y` flag on `<body>` if it is.
		//		Deprecated, use ``dojo/hccss`` instead.
	};
	=====*/

	domReady(function(){
		if(has("highcontrast")){
			domClass.add(win.body(), "dijit_a11y");
		}
	});

	return has;
});

},
'dijit/_AttachMixin':function(){
define([
	"require",
	"dojo/_base/array", // array.forEach
	"dojo/_base/connect",	// remove for 2.0
	"dojo/_base/declare", // declare
	"dojo/_base/lang", // lang.getObject
	"dojo/mouse",
	"dojo/on",
	"dojo/touch",
	"./_WidgetBase"
], function(require, array, connect, declare, lang, mouse, on, touch, _WidgetBase){

	// module:
	//		dijit/_AttachMixin

	// Map from string name like "mouseenter" to synthetic event like mouse.enter
	var synthEvents = lang.delegate(touch, {
		"mouseenter": mouse.enter,
		"mouseleave": mouse.leave,
		"keypress": connect._keypress	// remove for 2.0
	});

	// To be lightweight, _AttachMixin doesn't require() dijit/a11yclick.
	// If the subclass has a template using "ondijitclick", it must load dijit/a11yclick itself.
	// In that case, the a11yclick variable below will get set to point to that synthetic event.
	var a11yclick;

	var _AttachMixin = declare("dijit._AttachMixin", null, {
		// summary:
		//		Mixin for widgets to attach to dom nodes and setup events via
		//		convenient data-dojo-attach-point and data-dojo-attach-event DOM attributes.
		//
		//		Superclass of _TemplatedMixin, and can also be used standalone when templates are pre-rendered on the
		//		server.
		//
		//		Does not [yet] handle widgets like ContentPane with this.containerNode set.   It should skip
		//		scanning for data-dojo-attach-point and data-dojo-attach-event inside this.containerNode, but it
		//		doesn't.

/*=====
		// _attachPoints: [private] String[]
		//		List of widget attribute names associated with data-dojo-attach-point=... in the
		//		template, ex: ["containerNode", "labelNode"]
		_attachPoints: [],

		// _attachEvents: [private] Handle[]
		//		List of connections associated with data-dojo-attach-event=... in the
		//		template
		_attachEvents: [],

		// attachScope: [public] Object
		//		Object to which attach points and events will be scoped.  Defaults
		//		to 'this'.
		attachScope: undefined,

		// searchContainerNode: [protected] Boolean
		//		Search descendants of this.containerNode for data-dojo-attach-point and data-dojo-attach-event.
		//		Should generally be left false (the default value) both for performance and to avoid failures when
		//		this.containerNode holds other _AttachMixin instances with their own attach points and events.
 		searchContainerNode: false,
 =====*/

		constructor: function(/*===== params, srcNodeRef =====*/){
			// summary:
			//		Create the widget.
			// params: Object|null
			//		Hash of initialization parameters for widget, including scalar values (like title, duration etc.)
			//		and functions, typically callbacks like onClick.
			//		The hash can contain any of the widget's properties, excluding read-only properties.
			// srcNodeRef: DOMNode|String?
			//		If a srcNodeRef (DOM node) is specified, replace srcNodeRef with my generated DOM tree.

			this._attachPoints = [];
			this._attachEvents = [];
		},


		buildRendering: function(){
			// summary:
			//		Attach to DOM nodes marked with special attributes.
			// tags:
			//		protected

			this.inherited(arguments);

			// recurse through the node, looking for, and attaching to, our
			// attachment points and events, which should be defined on the template node.
			this._attachTemplateNodes(this.domNode);

			this._beforeFillContent();		// hook for _WidgetsInTemplateMixin
		},

		_beforeFillContent: function(){
		},

		_attachTemplateNodes: function(rootNode){
			// summary:
			//		Iterate through the dom nodes and attach functions and nodes accordingly.
			// description:
			//		Map widget properties and functions to the handlers specified in
			//		the dom node and it's descendants. This function iterates over all
			//		nodes and looks for these properties:
			//
			//		- dojoAttachPoint/data-dojo-attach-point
			//		- dojoAttachEvent/data-dojo-attach-event
			// rootNode: DomNode
			//		The node to search for properties. All descendants will be searched.
			// tags:
			//		private

			// DFS to process all nodes except those inside of this.containerNode
			var node = rootNode;
			while(true){
				if(node.nodeType == 1 && (this._processTemplateNode(node, function(n,p){ return n.getAttribute(p); },
						this._attach) || this.searchContainerNode) && node.firstChild){
					node = node.firstChild;
				}else{
					if(node == rootNode){ return; }
					while(!node.nextSibling){
						node = node.parentNode;
						if(node == rootNode){ return; }
					}
					node = node.nextSibling;
				}
			}
		},

		_processTemplateNode: function(/*DOMNode|Widget*/ baseNode, getAttrFunc, attachFunc){
			// summary:
			//		Process data-dojo-attach-point and data-dojo-attach-event for given node or widget.
			//		Returns true if caller should process baseNode's children too.

			var ret = true;

			// Process data-dojo-attach-point
			var _attachScope = this.attachScope || this,
				attachPoint = getAttrFunc(baseNode, "dojoAttachPoint") || getAttrFunc(baseNode, "data-dojo-attach-point");
			if(attachPoint){
				var point, points = attachPoint.split(/\s*,\s*/);
				while((point = points.shift())){
					if(lang.isArray(_attachScope[point])){
						_attachScope[point].push(baseNode);
					}else{
						_attachScope[point] = baseNode;
					}
					ret = (point != "containerNode");
					this._attachPoints.push(point);
				}
			}

			// Process data-dojo-attach-event
			var attachEvent = getAttrFunc(baseNode, "dojoAttachEvent") || getAttrFunc(baseNode, "data-dojo-attach-event");
			if(attachEvent){
				// NOTE: we want to support attributes that have the form
				// "domEvent: nativeEvent, ..."
				var event, events = attachEvent.split(/\s*,\s*/);
				var trim = lang.trim;
				while((event = events.shift())){
					if(event){
						var thisFunc = null;
						if(event.indexOf(":") != -1){
							// oh, if only JS had tuple assignment
							var funcNameArr = event.split(":");
							event = trim(funcNameArr[0]);
							thisFunc = trim(funcNameArr[1]);
						}else{
							event = trim(event);
						}
						if(!thisFunc){
							thisFunc = event;
						}

						this._attachEvents.push(attachFunc(baseNode, event, lang.hitch(_attachScope, thisFunc)));
					}
				}
			}

			return ret;
		},

		_attach: function(node, type, func){
			// summary:
			//		Roughly corresponding to dojo/on, this is the default function for processing a
			//		data-dojo-attach-event.  Meant to attach to DOMNodes, not to widgets.
			// node: DOMNode
			//		The node to setup a listener on.
			// type: String
			//		Event name like "click".
			// getAttrFunc: Function
			//		Function to get the specified property for a given DomNode/Widget.
			// attachFunc: Function?
			//		Attaches an event handler from the specified node/widget to specified function.

			// Map special type names like "mouseenter" to synthetic events.
			// Subclasses are responsible to require() dijit/a11yclick if they want to use it.
			type = type.replace(/^on/, "").toLowerCase();
			if(type == "dijitclick"){
				type = a11yclick || (a11yclick = require("./a11yclick"));
			}else{
				type = synthEvents[type] || type;
			}

			return on(node, type, func);
		},

		_detachTemplateNodes: function() {
			// summary:
			//		Detach and clean up the attachments made in _attachtempalteNodes.

			// Delete all attach points to prevent IE6 memory leaks.
			var _attachScope = this.attachScope || this;
			array.forEach(this._attachPoints, function(point){
				delete _attachScope[point];
			});
			this._attachPoints = [];

			// And same for event handlers
			array.forEach(this._attachEvents, function(handle){ handle.remove(); });
			this._attachEvents = [];
		},

		destroyRendering: function(){
			this._detachTemplateNodes();
			this.inherited(arguments);
		}
	});

	// These arguments can be specified for widgets which are used in templates.
	// Since any widget can be specified as sub widgets in template, mix it
	// into the base widget class.  (This is a hack, but it's effective.).
	// Remove for 2.0.   Also, hide from API doc parser.
	lang.extend(_WidgetBase, /*===== {} || =====*/ {
		dojoAttachEvent: "",
		dojoAttachPoint: ""
	});
	
	return _AttachMixin;
});

},
'dijit/_WidgetsInTemplateMixin':function(){
define([
	"dojo/_base/array", // forEach()
	"dojo/aspect", // after()
	"dojo/_base/declare", // declare()
	"dojo/_base/lang",	// hitch()
	"dojo/parser" // parse()
], function(array, aspect, declare, lang, parser){

	// module:
	//		dijit/_WidgetsInTemplateMixin

	return declare("dijit._WidgetsInTemplateMixin", null, {
		// summary:
		//		Mixin to supplement _TemplatedMixin when template contains widgets

		// _earlyTemplatedStartup: Boolean
		//		A fallback to preserve the 1.0 - 1.3 behavior of children in
		//		templates having their startup called before the parent widget
		//		fires postCreate. Defaults to 'false', causing child widgets to
		//		have their .startup() called immediately before a parent widget
		//		.startup(), but always after the parent .postCreate(). Set to
		//		'true' to re-enable to previous, arguably broken, behavior.
		_earlyTemplatedStartup: false,

		// contextRequire: Function
		//		Used to provide a context require to the dojo/parser in order to be
		//		able to use relative MIDs (e.g. `./Widget`) in the widget's template.
		contextRequire: null,

		_beforeFillContent: function(){
			// Short circuit the parser when the template doesn't contain any widgets.  Note that checking against
			// this.templateString is insufficient because the data-dojo-type=... may appear through a substitution
			// variable, like in ConfirmDialog, where the widget is hidden inside of the ${!actionBarTemplate}.
			if(/dojoType|data-dojo-type/i.test(this.domNode.innerHTML)){
				// Before copying over content, instantiate widgets in template
				var node = this.domNode;

				if(this.containerNode && !this.searchContainerNode){
					// Tell parse call below not to look for widgets inside of this.containerNode
					this.containerNode.stopParser = true;
				}

				parser.parse(node, {
					noStart: !this._earlyTemplatedStartup,
					template: true,
					inherited: {dir: this.dir, lang: this.lang, textDir: this.textDir},
					propsThis: this,	// so data-dojo-props of widgets in the template can reference "this" to refer to me
					contextRequire: this.contextRequire,
					scope: "dojo"	// even in multi-version mode templates use dojoType/data-dojo-type
				}).then(lang.hitch(this, function(widgets){
					this._startupWidgets = widgets;

					// _WidgetBase::destroy() will destroy any supporting widgets under this.domNode.
					// If we wanted to, we could call this.own() on anything in this._startupWidgets that was moved outside
					// of this.domNode (like Dialog, which is moved to <body>).

					// Hook up attach points and events for nodes that were converted to widgets
					for(var i = 0; i < widgets.length; i++){
						this._processTemplateNode(widgets[i], function(n,p){
							// callback to get a property of a widget
							return n[p];
						}, function(widget, type, callback){
							// callback to do data-dojo-attach-event to a widget
							if(type in widget){
								// back-compat, remove for 2.0
								return widget.connect(widget, type, callback);
							}else{
								// 1.x may never hit this branch, but it's the default for 2.0
								return widget.on(type, callback, true);
							}
						});
					}

					// Cleanup flag set above, just in case
					if(this.containerNode && this.containerNode.stopParser){
						delete this.containerNode.stopParser;
					}
				}));

				if(!this._startupWidgets){
					throw new Error(this.declaredClass + ": parser returned unfilled promise (probably waiting for module auto-load), " +
						"unsupported by _WidgetsInTemplateMixin.   Must pre-load all supporting widgets before instantiation.");
				}
			}
		},

		_processTemplateNode: function(/*DOMNode|Widget*/ baseNode, getAttrFunc, attachFunc){
			// Override _AttachMixin._processNode to skip DOMNodes with data-dojo-type set.   They are handled separately
			// in the _beforeFillContent() code above.

			if(getAttrFunc(baseNode, "dojoType") || getAttrFunc(baseNode, "data-dojo-type")){
				return true;
			}

			return this.inherited(arguments);
		},

		startup: function(){
			array.forEach(this._startupWidgets, function(w){
				if(w && !w._started && w.startup){
					w.startup();
				}
			});
			this._startupWidgets = null;
			this.inherited(arguments);
		}
	});
});

},
'dijit/layout/_LayoutWidget':function(){
define([
	"dojo/_base/lang", // lang.mixin
	"../_Widget",
	"../_Container",
	"../_Contained",
	"../Viewport",
	"dojo/_base/declare", // declare
	"dojo/dom-class", // domClass.add domClass.remove
	"dojo/dom-geometry", // domGeometry.marginBox
	"dojo/dom-style" // domStyle.getComputedStyle
], function(lang, _Widget, _Container, _Contained, Viewport,
	declare, domClass, domGeometry, domStyle){

	// module:
	//		dijit/layout/_LayoutWidget


	return declare("dijit.layout._LayoutWidget", [_Widget, _Container, _Contained], {
		// summary:
		//		Base class for a _Container widget which is responsible for laying out its children.
		//		Widgets which mixin this code must define layout() to manage placement and sizing of the children.

		// baseClass: [protected extension] String
		//		This class name is applied to the widget's domNode
		//		and also may be used to generate names for sub nodes,
		//		for example dijitTabContainer-content.
		baseClass: "dijitLayoutContainer",

		// isLayoutContainer: [protected] Boolean
		//		Indicates that this widget is going to call resize() on its
		//		children widgets, setting their size, when they become visible.
		isLayoutContainer: true,

		// Cancel _WidgetBase's _setTitleAttr because we don't want the title property (used to specify
		// tab labels) to be set as an attribute on this.domNode... otherwise a tooltip shows up over the
		// entire widget.
		_setTitleAttr: null,

		buildRendering: function(){
			this.inherited(arguments);
			domClass.add(this.domNode, "dijitContainer");
		},

		startup: function(){
			// summary:
			//		Called after all the widgets have been instantiated and their
			//		dom nodes have been inserted somewhere under <body>.
			//
			//		Widgets should override this method to do any initialization
			//		dependent on other widgets existing, and then call
			//		this superclass method to finish things off.
			//
			//		startup() in subclasses shouldn't do anything
			//		size related because the size of the widget hasn't been set yet.

			if(this._started){ return; }

			// Need to call inherited first - so that child widgets get started
			// up correctly
			this.inherited(arguments);

			// If I am a not being controlled by a parent layout widget...
			var parent = this.getParent && this.getParent();
			if(!(parent && parent.isLayoutContainer)){
				// Do recursive sizing and layout of all my descendants
				// (passing in no argument to resize means that it has to glean the size itself)
				this.resize();

				// Since my parent isn't a layout container, and my style *may be* width=height=100%
				// or something similar (either set directly or via a CSS class),
				// monitor when viewport size changes so that I can re-layout.
				this.own(Viewport.on("resize", lang.hitch(this, "resize")));
			}
		},

		resize: function(changeSize, resultSize){
			// summary:
			//		Call this to resize a widget, or after its size has changed.
			// description:
			//		####Change size mode:
			//
			//		When changeSize is specified, changes the marginBox of this widget
			//		and forces it to re-layout its contents accordingly.
			//		changeSize may specify height, width, or both.
			//
			//		If resultSize is specified it indicates the size the widget will
			//		become after changeSize has been applied.
			//
			//		####Notification mode:
			//
			//		When changeSize is null, indicates that the caller has already changed
			//		the size of the widget, or perhaps it changed because the browser
			//		window was resized.  Tells widget to re-layout its contents accordingly.
			//
			//		If resultSize is also specified it indicates the size the widget has
			//		become.
			//
			//		In either mode, this method also:
			//
			//		1. Sets this._borderBox and this._contentBox to the new size of
			//			the widget.  Queries the current domNode size if necessary.
			//		2. Calls layout() to resize contents (and maybe adjust child widgets).
			// changeSize: Object?
			//		Sets the widget to this margin-box size and position.
			//		May include any/all of the following properties:
			//	|	{w: int, h: int, l: int, t: int}
			// resultSize: Object?
			//		The margin-box size of this widget after applying changeSize (if
			//		changeSize is specified).  If caller knows this size and
			//		passes it in, we don't need to query the browser to get the size.
			//	|	{w: int, h: int}

			var node = this.domNode;

			// set margin box size, unless it wasn't specified, in which case use current size
			if(changeSize){
				domGeometry.setMarginBox(node, changeSize);
			}

			// If either height or width wasn't specified by the user, then query node for it.
			// But note that setting the margin box and then immediately querying dimensions may return
			// inaccurate results, so try not to depend on it.
			var mb = resultSize || {};
			lang.mixin(mb, changeSize || {});	// changeSize overrides resultSize
			if( !("h" in mb) || !("w" in mb) ){
				mb = lang.mixin(domGeometry.getMarginBox(node), mb);	// just use domGeometry.marginBox() to fill in missing values
			}

			// Compute and save the size of my border box and content box
			// (w/out calling domGeometry.getContentBox() since that may fail if size was recently set)
			var cs = domStyle.getComputedStyle(node);
			var me = domGeometry.getMarginExtents(node, cs);
			var be = domGeometry.getBorderExtents(node, cs);
			var bb = (this._borderBox = {
				w: mb.w - (me.w + be.w),
				h: mb.h - (me.h + be.h)
			});
			var pe = domGeometry.getPadExtents(node, cs);
			this._contentBox = {
				l: domStyle.toPixelValue(node, cs.paddingLeft),
				t: domStyle.toPixelValue(node, cs.paddingTop),
				w: bb.w - pe.w,
				h: bb.h - pe.h
			};

			// Callback for widget to adjust size of its children
			this.layout();
		},

		layout: function(){
			// summary:
			//		Widgets override this method to size and position their contents/children.
			//		When this is called this._contentBox is guaranteed to be set (see resize()).
			//
			//		This is called after startup(), and also when the widget's size has been
			//		changed.
			// tags:
			//		protected extension
		},

		_setupChild: function(/*dijit/_WidgetBase*/child){
			// summary:
			//		Common setup for initial children and children which are added after startup
			// tags:
			//		protected extension

			var cls = this.baseClass + "-child "
				+ (child.baseClass ? this.baseClass + "-" + child.baseClass : "");
			domClass.add(child.domNode, cls);
		},

		addChild: function(/*dijit/_WidgetBase*/ child, /*Integer?*/ insertIndex){
			// Overrides _Container.addChild() to call _setupChild()
			this.inherited(arguments);
			if(this._started){
				this._setupChild(child);
			}
		},

		removeChild: function(/*dijit/_WidgetBase*/ child){
			// Overrides _Container.removeChild() to remove class added by _setupChild()
			var cls = this.baseClass + "-child"
					+ (child.baseClass ?
						" " + this.baseClass + "-" + child.baseClass : "");
			domClass.remove(child.domNode, cls);

			this.inherited(arguments);
		}
	});
});

},
'dijit/_Container':function(){
define([
	"dojo/_base/array", // array.forEach array.indexOf
	"dojo/_base/declare", // declare
	"dojo/dom-construct", // domConstruct.place
	"dojo/_base/kernel" // kernel.deprecated
], function(array, declare, domConstruct, kernel){

	// module:
	//		dijit/_Container

	return declare("dijit._Container", null, {
		// summary:
		//		Mixin for widgets that contain HTML and/or a set of widget children.

		buildRendering: function(){
			this.inherited(arguments);
			if(!this.containerNode){
				// All widgets with descendants must set containerNode.
				// NB: this code doesn't quite work right because for TabContainer it runs before
				// _TemplatedMixin::buildRendering(), and thus
				// sets this.containerNode to this.domNode, later to be overridden by the assignment in the template.
				this.containerNode = this.domNode;
			}
		},

		addChild: function(/*dijit/_WidgetBase*/ widget, /*int?*/ insertIndex){
			// summary:
			//		Makes the given widget a child of this widget.
			// description:
			//		Inserts specified child widget's dom node as a child of this widget's
			//		container node, and possibly does other processing (such as layout).

			// I want to just call domConstruct.place(widget.domNode, this.containerNode, insertIndex), but the counting
			// is thrown off by text nodes and comment nodes that show up when constructed by markup.
			// In the future consider stripping those nodes on construction, either in the parser or this widget code.
			var refNode = this.containerNode;
			if(insertIndex > 0){
				// Old-school way to get nth child; dojo.query would be easier but _Container was weened from dojo.query
				// in #10087 to minimize download size.   Not sure if that's still and issue with new smaller dojo/query.
				refNode = refNode.firstChild;
				while(insertIndex > 0){
					if(refNode.nodeType == 1){ insertIndex--; }
					refNode = refNode.nextSibling;
				}
				if(refNode){
					insertIndex = "before";
				}else{
					// to support addChild(child, n-1) where there are n children (should add child at end)
					refNode = this.containerNode;
					insertIndex = "last";
				}
			}

			domConstruct.place(widget.domNode, refNode, insertIndex);

			// If I've been started but the child widget hasn't been started,
			// start it now.  Make sure to do this after widget has been
			// inserted into the DOM tree, so it can see that it's being controlled by me,
			// so it doesn't try to size itself.
			if(this._started && !widget._started){
				widget.startup();
			}
		},

		removeChild: function(/*Widget|int*/ widget){
			// summary:
			//		Removes the passed widget instance from this widget but does
			//		not destroy it.  You can also pass in an integer indicating
			//		the index within the container to remove (ie, removeChild(5) removes the sixth widget).

			if(typeof widget == "number"){
				widget = this.getChildren()[widget];
			}

			if(widget){
				var node = widget.domNode;
				if(node && node.parentNode){
					node.parentNode.removeChild(node); // detach but don't destroy
				}
			}
		},

		hasChildren: function(){
			// summary:
			//		Returns true if widget has child widgets, i.e. if this.containerNode contains widgets.
			return this.getChildren().length > 0;	// Boolean
		},

		_getSiblingOfChild: function(/*dijit/_WidgetBase*/ child, /*int*/ dir){
			// summary:
			//		Get the next or previous widget sibling of child
			// dir:
			//		if 1, get the next sibling
			//		if -1, get the previous sibling
			// tags:
			//		private
			var children = this.getChildren(),
				idx = array.indexOf(children, child);	// int
			return children[idx + dir];
		},

		getIndexOfChild: function(/*dijit/_WidgetBase*/ child){
			// summary:
			//		Gets the index of the child in this container or -1 if not found
			return array.indexOf(this.getChildren(), child);	// int
		}
	});
});

},
'dijit/_Contained':function(){
define([
	"dojo/_base/declare", // declare
	"./registry"	// registry.getEnclosingWidget(), registry.byNode()
], function(declare, registry){

	// module:
	//		dijit/_Contained

	return declare("dijit._Contained", null, {
		// summary:
		//		Mixin for widgets that are children of a container widget
		// example:
		//	|	// make a basic custom widget that knows about its parents
		//	|	declare("my.customClass",[dijit._WidgetBase, dijit._Contained],{});

		_getSibling: function(/*String*/ which){
			// summary:
			//		Returns next or previous sibling
			// which:
			//		Either "next" or "previous"
			// tags:
			//		private
			var p = this.getParent();
			return (p && p._getSiblingOfChild && p._getSiblingOfChild(this, which == "previous" ? -1 : 1)) || null;	// dijit/_WidgetBase
		},

		getPreviousSibling: function(){
			// summary:
			//		Returns null if this is the first child of the parent,
			//		otherwise returns the next element sibling to the "left".

			return this._getSibling("previous"); // dijit/_WidgetBase
		},

		getNextSibling: function(){
			// summary:
			//		Returns null if this is the last child of the parent,
			//		otherwise returns the next element sibling to the "right".

			return this._getSibling("next"); // dijit/_WidgetBase
		},

		getIndexInParent: function(){
			// summary:
			//		Returns the index of this widget within its container parent.
			//		It returns -1 if the parent does not exist, or if the parent
			//		is not a dijit/_Container

			var p = this.getParent();
			if(!p || !p.getIndexOfChild){
				return -1; // int
			}
			return p.getIndexOfChild(this); // int
		}
	});
});

},
'dijit/Viewport':function(){
define([
	"dojo/Evented",
	"dojo/on",
	"dojo/domReady",
	"dojo/sniff",	// has("ie"), has("ios")
	"dojo/window" // getBox()
], function(Evented, on, domReady, has, winUtils){

	// module:
	//		dijit/Viewport

	/*=====
	return {
		// summary:
		//		Utility singleton to watch for viewport resizes, avoiding duplicate notifications
		//		which can lead to infinite loops.
		// description:
		//		Usage: Viewport.on("resize", myCallback).
		//
		//		myCallback() is called without arguments in case it's _WidgetBase.resize(),
		//		which would interpret the argument as the size to make the widget.
	};
	=====*/

	var Viewport = new Evented();

	var focusedNode;

	domReady(function(){
		var oldBox = winUtils.getBox();
		Viewport._rlh = on(window, "resize", function(){
			var newBox = winUtils.getBox();
			if(oldBox.h == newBox.h && oldBox.w == newBox.w){ return; }
			oldBox = newBox;
			Viewport.emit("resize");
		});

		// Also catch zoom changes on IE8, since they don't naturally generate resize events
		if(has("ie") == 8){
			var deviceXDPI = screen.deviceXDPI;
			setInterval(function(){
				if(screen.deviceXDPI != deviceXDPI){
					deviceXDPI = screen.deviceXDPI;
					Viewport.emit("resize");
				}
			}, 500);
		}

		// On iOS, keep track of the focused node so we can guess when the keyboard is/isn't being displayed.
		if(has("ios")){
			on(document, "focusin", function(evt){
				focusedNode = evt.target;
			});
			on(document, "focusout", function(evt){
				focusedNode = null;
			});
		}
	});

	Viewport.getEffectiveBox = function(/*Document*/ doc){
		// summary:
		//		Get the size of the viewport, or on mobile devices, the part of the viewport not obscured by the
		//		virtual keyboard.

		var box = winUtils.getBox(doc);

		// Account for iOS virtual keyboard, if it's being shown.  Unfortunately no direct way to check or measure.
		var tag = focusedNode && focusedNode.tagName && focusedNode.tagName.toLowerCase();
		if(has("ios") && focusedNode && !focusedNode.readOnly && (tag == "textarea" || (tag == "input" &&
			/^(color|email|number|password|search|tel|text|url)$/.test(focusedNode.type)))){

			// Box represents the size of the viewport.  Some of the viewport is likely covered by the keyboard.
			// Estimate height of visible viewport assuming viewport goes to bottom of screen, but is covered by keyboard.
			box.h *= (orientation == 0 || orientation == 180 ? 0.66 : 0.40);

			// Above measurement will be inaccurate if viewport was scrolled up so far that it ends before the bottom
			// of the screen.   In this case, keyboard isn't covering as much of the viewport as we thought.
			// We know the visible size is at least the distance from the top of the viewport to the focused node.
			var rect = focusedNode.getBoundingClientRect();
			box.h = Math.max(box.h, rect.top + rect.height);
		}

		return box;
	};

	return Viewport;
});

},
'dijit/layout/ContentPane':function(){
define([
	"dojo/_base/kernel", // kernel.deprecated
	"dojo/_base/lang", // lang.mixin lang.delegate lang.hitch lang.isFunction lang.isObject
	"../_Widget",
	"../_Container",
	"./_ContentPaneResizeMixin",
	"dojo/string", // string.substitute
	"dojo/html", // html._ContentSetter
	"dojo/_base/array", // array.forEach
	"dojo/_base/declare", // declare
	"dojo/_base/Deferred", // Deferred
	"dojo/dom", // dom.byId
	"dojo/dom-attr", // domAttr.attr
	"dojo/dom-construct", // empty()
	"dojo/_base/xhr", // xhr.get
	"dojo/i18n", // i18n.getLocalization
	"dojo/when",
	"dojo/i18n!../nls/loading"
], function(kernel, lang, _Widget, _Container, _ContentPaneResizeMixin, string, html, array, declare,
			Deferred, dom, domAttr, domConstruct, xhr, i18n, when){

	// module:
	//		dijit/layout/ContentPane

	return declare("dijit.layout.ContentPane", [_Widget, _Container, _ContentPaneResizeMixin], {
		// summary:
		//		A widget containing an HTML fragment, specified inline
		//		or by uri.  Fragment may include widgets.
		//
		// description:
		//		This widget embeds a document fragment in the page, specified
		//		either by uri, javascript generated markup or DOM reference.
		//		Any widgets within this content are instantiated and managed,
		//		but laid out according to the HTML structure.  Unlike IFRAME,
		//		ContentPane embeds a document fragment as would be found
		//		inside the BODY tag of a full HTML document.  It should not
		//		contain the HTML, HEAD, or BODY tags.
		//		For more advanced functionality with scripts and
		//		stylesheets, see dojox/layout/ContentPane.  This widget may be
		//		used stand alone or as a base class for other widgets.
		//		ContentPane is useful as a child of other layout containers
		//		such as BorderContainer or TabContainer, but note that those
		//		widgets can contain any widget as a child.
		//
		// example:
		//		Some quick samples:
		//		To change the innerHTML:
		// |		cp.set('content', '<b>new content</b>')`
		//		Or you can send it a NodeList:
		// |		cp.set('content', dojo.query('div [class=selected]', userSelection))
		//		To do an ajax update:
		// |		cp.set('href', url)

		// href: String
		//		The href of the content that displays now.
		//		Set this at construction if you want to load data externally when the
		//		pane is shown.  (Set preload=true to load it immediately.)
		//		Changing href after creation doesn't have any effect; Use set('href', ...);
		href: "",

		// content: String|DomNode|NodeList|dijit/_Widget
		//		The innerHTML of the ContentPane.
		//		Note that the initialization parameter / argument to set("content", ...)
		//		can be a String, DomNode, Nodelist, or _Widget.
		content: "",

		// extractContent: Boolean
		//		Extract visible content from inside of `<body> .... </body>`.
		//		I.e., strip `<html>` and `<head>` (and it's contents) from the href
		extractContent: false,

		// parseOnLoad: Boolean
		//		Parse content and create the widgets, if any.
		parseOnLoad: true,

		// parserScope: String
		//		Flag passed to parser.  Root for attribute names to search for.   If scopeName is dojo,
		//		will search for data-dojo-type (or dojoType).  For backwards compatibility
		//		reasons defaults to dojo._scopeName (which is "dojo" except when
		//		multi-version support is used, when it will be something like dojo16, dojo20, etc.)
		parserScope: kernel._scopeName,

		// preventCache: Boolean
		//		Prevent caching of data from href's by appending a timestamp to the href.
		preventCache: false,

		// preload: Boolean
		//		Force load of data on initialization even if pane is hidden.
		preload: false,

		// refreshOnShow: Boolean
		//		Refresh (re-download) content when pane goes from hidden to shown
		refreshOnShow: false,

		// loadingMessage: String
		//		Message that shows while downloading
		loadingMessage: "<span class='dijitContentPaneLoading'><span class='dijitInline dijitIconLoading'></span>${loadingState}</span>",

		// errorMessage: String
		//		Message that shows if an error occurs
		errorMessage: "<span class='dijitContentPaneError'><span class='dijitInline dijitIconError'></span>${errorState}</span>",

		// isLoaded: [readonly] Boolean
		//		True if the ContentPane has data in it, either specified
		//		during initialization (via href or inline content), or set
		//		via set('content', ...) / set('href', ...)
		//
		//		False if it doesn't have any content, or if ContentPane is
		//		still in the process of downloading href.
		isLoaded: false,

		baseClass: "dijitContentPane",

		/*======
		 // ioMethod: dojo/_base/xhr.get|dojo._base/xhr.post
		 //		Function that should grab the content specified via href.
		 ioMethod: dojo.xhrGet,
		 ======*/

		// ioArgs: Object
		//		Parameters to pass to xhrGet() request, for example:
		// |	<div data-dojo-type="dijit/layout/ContentPane" data-dojo-props="href: './bar', ioArgs: {timeout: 500}">
		ioArgs: {},

		// onLoadDeferred: [readonly] dojo.Deferred
		//		This is the `dojo.Deferred` returned by set('href', ...) and refresh().
		//		Calling onLoadDeferred.then() registers your
		//		callback to be called only once, when the prior set('href', ...) call or
		//		the initial href parameter to the constructor finishes loading.
		//
		//		This is different than an onLoad() handler which gets called any time any href
		//		or content is loaded.
		onLoadDeferred: null,

		// Cancel _WidgetBase's _setTitleAttr because we don't want the title attribute (used to specify
		// tab labels) to be copied to ContentPane.domNode... otherwise a tooltip shows up over the
		// entire pane.
		_setTitleAttr: null,

		// Flag to parser that I'll parse my contents, so it shouldn't.
		stopParser: true,

		// template: [private] Boolean
		//		Flag from the parser that this ContentPane is inside a template
		//		so the contents are pre-parsed.
		// TODO: this declaration can be commented out in 2.0
		template: false,

		markupFactory: function(params, node, ctor){
			var self = new ctor(params, node);

			// If a parse has started but is waiting for modules to load, then return a Promise for when the parser
			// finishes.  Don't return a promise though for the case when content hasn't started loading because the
			// ContentPane is hidden and it has an href (ex: hidden pane of a TabContainer).   In that case we consider
			// that initialization has already finished.
			return !self.href && self._contentSetter && self._contentSetter.parseDeferred && !self._contentSetter.parseDeferred.isFulfilled() ?
				self._contentSetter.parseDeferred.then(function(){
					return self;
				}) : self;
		},

		create: function(params, srcNodeRef){
			// Convert a srcNodeRef argument into a content parameter, so that the original contents are
			// processed in the same way as contents set via set("content", ...), calling the parser etc.
			// Avoid modifying original params object since that breaks NodeList instantiation, see #11906.
			if((!params || !params.template) && srcNodeRef && !("href" in params) && !("content" in params)){
				srcNodeRef = dom.byId(srcNodeRef);
				var df = srcNodeRef.ownerDocument.createDocumentFragment();
				while(srcNodeRef.firstChild){
					df.appendChild(srcNodeRef.firstChild);
				}
				params = lang.delegate(params, {content: df});
			}
			this.inherited(arguments, [params, srcNodeRef]);
		},

		postMixInProperties: function(){
			this.inherited(arguments);
			var messages = i18n.getLocalization("dijit", "loading", this.lang);
			this.loadingMessage = string.substitute(this.loadingMessage, messages);
			this.errorMessage = string.substitute(this.errorMessage, messages);
		},

		buildRendering: function(){
			this.inherited(arguments);

			// Since we have no template we need to set this.containerNode ourselves, to make getChildren() work.
			// For subclasses of ContentPane that do have a template, does nothing.
			if(!this.containerNode){
				this.containerNode = this.domNode;
			}

			// remove the title attribute so it doesn't show up when hovering
			// over a node  (TODO: remove in 2.0, no longer needed after #11490)
			this.domNode.removeAttribute("title");
		},

		startup: function(){
			// summary:
			//		Call startup() on all children including non _Widget ones like dojo/dnd/Source objects

			// This starts all the widgets
			this.inherited(arguments);

			// And this catches stuff like dojo/dnd/Source
			if(this._contentSetter){
				array.forEach(this._contentSetter.parseResults, function(obj){
					if(!obj._started && !obj._destroyed && lang.isFunction(obj.startup)){
						obj.startup();
						obj._started = true;
					}
				}, this);
			}
		},

		_startChildren: function(){
			// summary:
			//		Called when content is loaded.   Calls startup on each child widget.   Similar to ContentPane.startup()
			//		itself, but avoids marking the ContentPane itself as "restarted" (see #15581).

			// This starts all the widgets
			array.forEach(this.getChildren(), function(obj){
				if(!obj._started && !obj._destroyed && lang.isFunction(obj.startup)){
					obj.startup();
					obj._started = true;
				}
			});

			// And this catches stuff like dojo/dnd/Source
			if(this._contentSetter){
				array.forEach(this._contentSetter.parseResults, function(obj){
					if(!obj._started && !obj._destroyed && lang.isFunction(obj.startup)){
						obj.startup();
						obj._started = true;
					}
				}, this);
			}
		},

		setHref: function(/*String|Uri*/ href){
			// summary:
			//		Deprecated.   Use set('href', ...) instead.
			kernel.deprecated("dijit.layout.ContentPane.setHref() is deprecated. Use set('href', ...) instead.", "", "2.0");
			return this.set("href", href);
		},
		_setHrefAttr: function(/*String|Uri*/ href){
			// summary:
			//		Hook so set("href", ...) works.
			// description:
			//		Reset the (external defined) content of this pane and replace with new url
			//		Note: It delays the download until widget is shown if preload is false.
			// href:
			//		url to the page you want to get, must be within the same domain as your mainpage

			// Cancel any in-flight requests (a set('href', ...) will cancel any in-flight set('href', ...))
			this.cancel();

			this.onLoadDeferred = new Deferred(lang.hitch(this, "cancel"));
			this.onLoadDeferred.then(lang.hitch(this, "onLoad"));

			this._set("href", href);

			// _setHrefAttr() is called during creation and by the user, after creation.
			// Assuming preload == false, only in the second case do we actually load the URL;
			// otherwise it's done in startup(), and only if this widget is shown.
			if(this.preload || (this._created && this._isShown())){
				this._load();
			}else{
				// Set flag to indicate that href needs to be loaded the next time the
				// ContentPane is made visible
				this._hrefChanged = true;
			}

			return this.onLoadDeferred;		// Deferred
		},

		setContent: function(/*String|DomNode|Nodelist*/data){
			// summary:
			//		Deprecated.   Use set('content', ...) instead.
			kernel.deprecated("dijit.layout.ContentPane.setContent() is deprecated.  Use set('content', ...) instead.", "", "2.0");
			this.set("content", data);
		},
		_setContentAttr: function(/*String|DomNode|Nodelist*/data){
			// summary:
			//		Hook to make set("content", ...) work.
			//		Replaces old content with data content, include style classes from old content
			// data:
			//		the new Content may be String, DomNode or NodeList
			//
			//		if data is a NodeList (or an array of nodes) nodes are copied
			//		so you can import nodes from another document implicitly

			// clear href so we can't run refresh and clear content
			// refresh should only work if we downloaded the content
			this._set("href", "");

			// Cancel any in-flight requests (a set('content', ...) will cancel any in-flight set('href', ...))
			this.cancel();

			// Even though user is just setting content directly, still need to define an onLoadDeferred
			// because the _onLoadHandler() handler is still getting called from setContent()
			this.onLoadDeferred = new Deferred(lang.hitch(this, "cancel"));
			if(this._created){
				// For back-compat reasons, call onLoad() for set('content', ...)
				// calls but not for content specified in srcNodeRef (ie: <div data-dojo-type=ContentPane>...</div>)
				// or as initialization parameter (ie: new ContentPane({content: ...})
				this.onLoadDeferred.then(lang.hitch(this, "onLoad"));
			}

			this._setContent(data || "");

			this._isDownloaded = false; // mark that content is from a set('content') not a set('href')

			return this.onLoadDeferred;	// Deferred
		},
		_getContentAttr: function(){
			// summary:
			//		Hook to make get("content") work
			return this.containerNode.innerHTML;
		},

		cancel: function(){
			// summary:
			//		Cancels an in-flight download of content
			if(this._xhrDfd && (this._xhrDfd.fired == -1)){
				this._xhrDfd.cancel();
			}
			delete this._xhrDfd; // garbage collect

			this.onLoadDeferred = null;
		},

		destroy: function(){
			this.cancel();
			this.inherited(arguments);
		},

		destroyRecursive: function(/*Boolean*/ preserveDom){
			// summary:
			//		Destroy the ContentPane and its contents

			// if we have multiple controllers destroying us, bail after the first
			if(this._beingDestroyed){
				return;
			}
			this.inherited(arguments);
		},

		_onShow: function(){
			// summary:
			//		Called when the ContentPane is made visible
			// description:
			//		For a plain ContentPane, this is called on initialization, from startup().
			//		If the ContentPane is a hidden pane of a TabContainer etc., then it's
			//		called whenever the pane is made visible.
			//
			//		Does necessary processing, including href download and layout/resize of
			//		child widget(s)

			this.inherited(arguments);

			if(this.href){
				if(!this._xhrDfd && // if there's an href that isn't already being loaded
					(!this.isLoaded || this._hrefChanged || this.refreshOnShow)
					){
					return this.refresh();	// If child has an href, promise that fires when the load is complete
				}
			}
		},

		refresh: function(){
			// summary:
			//		[Re]download contents of href and display
			// description:
			//		1. cancels any currently in-flight requests
			//		2. posts "loading..." message
			//		3. sends XHR to download new data

			// Cancel possible prior in-flight request
			this.cancel();

			this.onLoadDeferred = new Deferred(lang.hitch(this, "cancel"));
			this.onLoadDeferred.then(lang.hitch(this, "onLoad"));
			this._load();
			return this.onLoadDeferred;		// If child has an href, promise that fires when refresh is complete
		},

		_load: function(){
			// summary:
			//		Load/reload the href specified in this.href

			// display loading message
			this._setContent(this.onDownloadStart(), true);

			var self = this;
			var getArgs = {
				preventCache: (this.preventCache || this.refreshOnShow),
				url: this.href,
				handleAs: "text"
			};
			if(lang.isObject(this.ioArgs)){
				lang.mixin(getArgs, this.ioArgs);
			}

			var hand = (this._xhrDfd = (this.ioMethod || xhr.get)(getArgs)),
				returnedHtml;

			hand.then(
				function(html){
					returnedHtml = html;
					try{
						self._isDownloaded = true;
						return self._setContent(html, false);
					}catch(err){
						self._onError('Content', err); // onContentError
					}
				},
				function(err){
					if(!hand.canceled){
						// show error message in the pane
						self._onError('Download', err); // onDownloadError
					}
					delete self._xhrDfd;
					return err;
				}
			).then(function(){
					self.onDownloadEnd();
					delete self._xhrDfd;
					return returnedHtml;
				});

			// Remove flag saying that a load is needed
			delete this._hrefChanged;
		},

		_onLoadHandler: function(data){
			// summary:
			//		This is called whenever new content is being loaded
			this._set("isLoaded", true);
			try{
				this.onLoadDeferred.resolve(data);
			}catch(e){
				console.error('Error ' + (this.widgetId || this.id) + ' running custom onLoad code: ' + e.message);
			}
		},

		_onUnloadHandler: function(){
			// summary:
			//		This is called whenever the content is being unloaded
			this._set("isLoaded", false);
			try{
				this.onUnload();
			}catch(e){
				console.error('Error ' + this.widgetId + ' running custom onUnload code: ' + e.message);
			}
		},

		destroyDescendants: function(/*Boolean*/ preserveDom){
			// summary:
			//		Destroy all the widgets inside the ContentPane and empty containerNode

			// Make sure we call onUnload (but only when the ContentPane has real content)
			if(this.isLoaded){
				this._onUnloadHandler();
			}

			// Even if this.isLoaded == false there might still be a "Loading..." message
			// to erase, so continue...

			// For historical reasons we need to delete all widgets under this.containerNode,
			// even ones that the user has created manually.
			var setter = this._contentSetter;
			array.forEach(this.getChildren(), function(widget){
				if(widget.destroyRecursive){
					// All widgets will hit this branch
					widget.destroyRecursive(preserveDom);
				}else if(widget.destroy){
					// Things like dojo/dnd/Source have destroy(), not destroyRecursive()
					widget.destroy(preserveDom);
				}
				widget._destroyed = true;
			});
			if(setter){
				// Most of the widgets in setter.parseResults have already been destroyed, but
				// things like Menu that have been moved to <body> haven't yet
				array.forEach(setter.parseResults, function(widget){
					if(!widget._destroyed){
						if(widget.destroyRecursive){
							// All widgets will hit this branch
							widget.destroyRecursive(preserveDom);
						}else if(widget.destroy){
							// Things like dojo/dnd/Source have destroy(), not destroyRecursive()
							widget.destroy(preserveDom);
						}
						widget._destroyed = true;
					}
				});
				delete setter.parseResults;
			}

			// And then clear away all the DOM nodes
			if(!preserveDom){
				domConstruct.empty(this.containerNode);
			}

			// Delete any state information we have about current contents
			delete this._singleChild;
		},

		_setContent: function(/*String|DocumentFragment*/ cont, /*Boolean*/ isFakeContent){
			// summary:
			//		Insert the content into the container node
			// returns:
			//		Returns a Deferred promise that is resolved when the content is parsed.

			cont = this.preprocessContent(cont);
			// first get rid of child widgets
			this.destroyDescendants();

			// html.set will take care of the rest of the details
			// we provide an override for the error handling to ensure the widget gets the errors
			// configure the setter instance with only the relevant widget instance properties
			// NOTE: unless we hook into attr, or provide property setters for each property,
			// we need to re-configure the ContentSetter with each use
			var setter = this._contentSetter;
			if(!(setter && setter instanceof html._ContentSetter)){
				setter = this._contentSetter = new html._ContentSetter({
					node: this.containerNode,
					_onError: lang.hitch(this, this._onError),
					onContentError: lang.hitch(this, function(e){
						// fires if a domfault occurs when we are appending this.errorMessage
						// like for instance if domNode is a UL and we try append a DIV
						var errMess = this.onContentError(e);
						try{
							this.containerNode.innerHTML = errMess;
						}catch(e){
							console.error('Fatal ' + this.id + ' could not change content due to ' + e.message, e);
						}
					})/*,
					 _onError */
				});
			}

			var setterParams = lang.mixin({
				cleanContent: this.cleanContent,
				extractContent: this.extractContent,
				parseContent: !cont.domNode && this.parseOnLoad,
				parserScope: this.parserScope,
				startup: false,
				dir: this.dir,
				lang: this.lang,
				textDir: this.textDir
			}, this._contentSetterParams || {});

			var p = setter.set((lang.isObject(cont) && cont.domNode) ? cont.domNode : cont, setterParams);

			// dojox/layout/html/_base::_ContentSetter.set() returns a Promise that indicates when everything is completed.
			// dojo/html::_ContentSetter.set() currently returns the DOMNode, but that will be changed for 2.0.
			// So, if set() returns a promise then use it, otherwise fallback to waiting on setter.parseDeferred
			var self = this;
			return when(p && p.then ? p : setter.parseDeferred, function(){
				// setter params must be pulled afresh from the ContentPane each time
				delete self._contentSetterParams;

				if(!isFakeContent){
					if(self._started){
						// Startup each top level child widget (and they will start their children, recursively)
						self._startChildren();

						// Call resize() on each of my child layout widgets,
						// or resize() on my single child layout widget...
						// either now (if I'm currently visible) or when I become visible
						self._scheduleLayout();
					}
					self._onLoadHandler(cont);
				}
			});
		},

		preprocessContent: function(/*String|DocumentFragment*/ content){
			// summary:
			//		Hook, called after content has loaded, before being processed.
			// description:
			//		A subclass should preprocess the content and return the preprocessed content.
			//		See https://bugs.dojotoolkit.org/ticket/9622
			// returns:
			//		Returns preprocessed content, either a String or DocumentFragment
			return content;
		},

		_onError: function(type, err, consoleText){
			this.onLoadDeferred.reject(err);

			// shows user the string that is returned by on[type]Error
			// override on[type]Error and return your own string to customize
			var errText = this['on' + type + 'Error'].call(this, err);
			if(consoleText){
				console.error(consoleText, err);
			}else if(errText){// a empty string won't change current content
				this._setContent(errText, true);
			}
		},

		// EVENT's, should be overide-able
		onLoad: function(/*===== data =====*/){
			// summary:
			//		Event hook, is called after everything is loaded and widgetified
			// tags:
			//		callback
		},

		onUnload: function(){
			// summary:
			//		Event hook, is called before old content is cleared
			// tags:
			//		callback
		},

		onDownloadStart: function(){
			// summary:
			//		Called before download starts.
			// description:
			//		The string returned by this function will be the html
			//		that tells the user we are loading something.
			//		Override with your own function if you want to change text.
			// tags:
			//		extension
			return this.loadingMessage;
		},

		onContentError: function(/*Error*/ /*===== error =====*/){
			// summary:
			//		Called on DOM faults, require faults etc. in content.
			//
			//		In order to display an error message in the pane, return
			//		the error message from this method, as an HTML string.
			//
			//		By default (if this method is not overriden), it returns
			//		nothing, so the error message is just printed to the console.
			// tags:
			//		extension
		},

		onDownloadError: function(/*Error*/ /*===== error =====*/){
			// summary:
			//		Called when download error occurs.
			//
			//		In order to display an error message in the pane, return
			//		the error message from this method, as an HTML string.
			//
			//		Default behavior (if this method is not overriden) is to display
			//		the error message inside the pane.
			// tags:
			//		extension
			return this.errorMessage;
		},

		onDownloadEnd: function(){
			// summary:
			//		Called when download is finished.
			// tags:
			//		callback
		}
	});
});

},
'dijit/layout/_ContentPaneResizeMixin':function(){
define([
	"dojo/_base/array", // array.filter array.forEach
	"dojo/_base/declare", // declare
	"dojo/dom-class", // domClass.contains domClass.toggle
	"dojo/dom-geometry", // domGeometry.contentBox domGeometry.marginBox
	"dojo/dom-style",
	"dojo/_base/lang", // lang.mixin
	"dojo/query", // query
	"../registry", // registry.byId
	"../Viewport",
	"./utils" // marginBox2contextBox
], function(array, declare, domClass, domGeometry, domStyle, lang, query,
			registry, Viewport, layoutUtils){

	// module:
	//		dijit/layout/_ContentPaneResizeMixin

	return declare("dijit.layout._ContentPaneResizeMixin", null, {
		// summary:
		//		Resize() functionality of ContentPane.   If there's a single layout widget
		//		child then it will call resize() with the same dimensions as the ContentPane.
		//		Otherwise just calls resize on each child.
		//
		//		Also implements basic startup() functionality, where starting the parent
		//		will start the children

		// doLayout: Boolean
		//		- false - don't adjust size of children
		//		- true - if there is a single visible child widget, set it's size to however big the ContentPane is
		doLayout: true,

		// isLayoutContainer: [protected] Boolean
		//		Indicates that this widget will call resize() on it's child widgets
		//		when they become visible.
		isLayoutContainer: true,

		startup: function(){
			// summary:
			//		See `dijit/layout/_LayoutWidget.startup()` for description.
			//		Although ContentPane doesn't extend _LayoutWidget, it does implement
			//		the same API.

			if(this._started){
				return;
			}

			var parent = this.getParent();
			this._childOfLayoutWidget = parent && parent.isLayoutContainer;

			// I need to call resize() on my child/children (when I become visible), unless
			// I'm the child of a layout widget in which case my parent will call resize() on me and I'll do it then.
			this._needLayout = !this._childOfLayoutWidget;

			this.inherited(arguments);

			if(this._isShown()){
				this._onShow();
			}

			if(!this._childOfLayoutWidget){
				// Since my parent isn't a layout container, and my style *may be* width=height=100%
				// or something similar (either set directly or via a CSS class),
				// monitor when viewport size changes so that I can re-layout.
				// This is more for subclasses of ContentPane than ContentPane itself, although it
				// could be useful for a ContentPane if it has a single child widget inheriting ContentPane's size.
				this.own(Viewport.on("resize", lang.hitch(this, "resize")));
			}
		},

		_checkIfSingleChild: function(){
			// summary:
			//		Test if we have exactly one visible widget as a child,
			//		and if so assume that we are a container for that widget,
			//		and should propagate startup() and resize() calls to it.
			//		Skips over things like data stores since they aren't visible.

			if(!this.doLayout){ return; }

			var candidateWidgets = [],
				otherVisibleNodes = false;

			query("> *", this.containerNode).some(function(node){
				var widget = registry.byNode(node);
				if(widget && widget.resize){
					candidateWidgets.push(widget);
				}else if(!/script|link|style/i.test(node.nodeName) && node.offsetHeight){
					otherVisibleNodes = true;
				}
			});

			this._singleChild = candidateWidgets.length == 1 && !otherVisibleNodes ?
				candidateWidgets[0] : null;

			// So we can set overflow: hidden to avoid a safari bug w/scrollbars showing up (#9449)
			domClass.toggle(this.containerNode, this.baseClass + "SingleChild", !!this._singleChild);
		},

		resize: function(changeSize, resultSize){
			// summary:
			//		See `dijit/layout/_LayoutWidget.resize()` for description.
			//		Although ContentPane doesn't extend _LayoutWidget, it does implement
			//		the same API.

			this._resizeCalled = true;

			this._scheduleLayout(changeSize, resultSize);
		},

		_scheduleLayout: function(changeSize, resultSize){
			// summary:
			//		Resize myself, and call resize() on each of my child layout widgets, either now
			//		(if I'm currently visible) or when I become visible
			if(this._isShown()){
				this._layout(changeSize, resultSize);
			}else{
				this._needLayout = true;
				this._changeSize = changeSize;
				this._resultSize = resultSize;
			}
		},

		_layout: function(changeSize, resultSize){
			// summary:
			//		Resize myself according to optional changeSize/resultSize parameters, like a layout widget.
			//		Also, since I am an isLayoutContainer widget, each of my children expects me to
			//		call resize() or layout() on it.
			//
			//		Should be called on initialization and also whenever we get new content
			//		(from an href, or from set('content', ...))... but deferred until
			//		the ContentPane is visible

			delete this._needLayout;

			// For the TabContainer --> BorderContainer --> ContentPane case, _onShow() is
			// never called directly, so resize() is our trigger to do the initial href download (see [20099]).
			// However, don't load href for closed TitlePanes.
			if(!this._wasShown && this.open !== false){
				this._onShow();
			}

			// Set margin box size, unless it wasn't specified, in which case use current size.
			if(changeSize){
				domGeometry.setMarginBox(this.domNode, changeSize);
			}

			// Compute content box size of containerNode in case we [later] need to size our single child.
			var cn = this.containerNode;
			if(cn === this.domNode){
				// If changeSize or resultSize was passed to this method and this.containerNode ==
				// this.domNode then we can compute the content-box size without querying the node,
				// which is more reliable (similar to LayoutWidget.resize) (see for example #9449).
				var mb = resultSize || {};
				lang.mixin(mb, changeSize || {}); // changeSize overrides resultSize
				if(!("h" in mb) || !("w" in mb)){
					mb = lang.mixin(domGeometry.getMarginBox(cn), mb); // just use domGeometry.setMarginBox() to fill in missing values
				}
				this._contentBox = layoutUtils.marginBox2contentBox(cn, mb);
			}else{
				this._contentBox = domGeometry.getContentBox(cn);
			}

			this._layoutChildren();
		},

		_layoutChildren: function(){
			// Call _checkIfSingleChild() again in case app has manually mucked w/the content
			// of the ContentPane (rather than changing it through the set("content", ...) API.
			this._checkIfSingleChild();

			if(this._singleChild && this._singleChild.resize){
				var cb = this._contentBox || domGeometry.getContentBox(this.containerNode);

				// note: if widget has padding this._contentBox will have l and t set,
				// but don't pass them to resize() or it will doubly-offset the child
				this._singleChild.resize({w: cb.w, h: cb.h});
			}else{
				// All my child widgets are independently sized (rather than matching my size),
				// but I still need to call resize() on each child to make it layout.
				var children = this.getChildren(),
					widget,
					i = 0;
				while(widget = children[i++]){
					if(widget.resize){
						widget.resize();
					}
				}
			}
		},

		_isShown: function(){
			// summary:
			//		Returns true if the content is currently shown.
			// description:
			//		If I am a child of a layout widget then it actually returns true if I've ever been visible,
			//		not whether I'm currently visible, since that's much faster than tracing up the DOM/widget
			//		tree every call, and at least solves the performance problem on page load by deferring loading
			//		hidden ContentPanes until they are first shown

			if(this._childOfLayoutWidget){
				// If we are TitlePane, etc - we return that only *IF* we've been resized
				if(this._resizeCalled && "open" in this){
					return this.open;
				}
				return this._resizeCalled;
			}else if("open" in this){
				return this.open;		// for TitlePane, etc.
			}else{
				var node = this.domNode, parent = this.domNode.parentNode;
				return (node.style.display != 'none') && (node.style.visibility != 'hidden') && !domClass.contains(node, "dijitHidden") &&
					parent && parent.style && (parent.style.display != 'none');
			}
		},

		_onShow: function(){
			// summary:
			//		Called when the ContentPane is made visible
			// description:
			//		For a plain ContentPane, this is called on initialization, from startup().
			//		If the ContentPane is a hidden pane of a TabContainer etc., then it's
			//		called whenever the pane is made visible.
			//
			//		Does layout/resize of child widget(s)

			// Need to keep track of whether ContentPane has been shown (which is different than
			// whether or not it's currently visible).
			this._wasShown = true;

			if(this._needLayout){
				// If a layout has been scheduled for when we become visible, do it now
				this._layout(this._changeSize, this._resultSize);
			}

			this.inherited(arguments);
		}
	});
});

},
'dijit/layout/utils':function(){
define([
	"dojo/_base/array", // array.filter array.forEach
	"dojo/dom-class", // domClass.add domClass.remove
	"dojo/dom-geometry", // domGeometry.marginBox
	"dojo/dom-style", // domStyle.getComputedStyle
	"dojo/_base/lang" // lang.mixin, lang.setObject
], function(array, domClass, domGeometry, domStyle, lang){

	// module:
	//		dijit/layout/utils

	function capitalize(word){
		return word.substring(0,1).toUpperCase() + word.substring(1);
	}

	function size(widget, dim){
		// size the child
		var newSize = widget.resize ? widget.resize(dim) : domGeometry.setMarginBox(widget.domNode, dim);

		// record child's size
		if(newSize){
			// if the child returned it's new size then use that
			lang.mixin(widget, newSize);
		}else{
			// otherwise, call getMarginBox(), but favor our own numbers when we have them.
			// the browser lies sometimes
			lang.mixin(widget, domGeometry.getMarginBox(widget.domNode));
			lang.mixin(widget, dim);
		}
	}

	var utils = {
		// summary:
		//		Utility functions for doing layout

		marginBox2contentBox: function(/*DomNode*/ node, /*Object*/ mb){
			// summary:
			//		Given the margin-box size of a node, return its content box size.
			//		Functions like domGeometry.contentBox() but is more reliable since it doesn't have
			//		to wait for the browser to compute sizes.
			var cs = domStyle.getComputedStyle(node);
			var me = domGeometry.getMarginExtents(node, cs);
			var pb = domGeometry.getPadBorderExtents(node, cs);
			return {
				l: domStyle.toPixelValue(node, cs.paddingLeft),
				t: domStyle.toPixelValue(node, cs.paddingTop),
				w: mb.w - (me.w + pb.w),
				h: mb.h - (me.h + pb.h)
			};
		},


		layoutChildren: function(/*DomNode*/ container, /*Object*/ dim, /*Widget[]*/ children,
				/*String?*/ changedRegionId, /*Number?*/ changedRegionSize){
			// summary:
			//		Layout a bunch of child dom nodes within a parent dom node
			// container:
			//		parent node
			// dim:
			//		{l, t, w, h} object specifying dimensions of container into which to place children
			// children:
			//		An array of Widgets or at least objects containing:
			//
			//		- domNode: pointer to DOM node to position
			//		- region or layoutAlign: position to place DOM node
			//		- resize(): (optional) method to set size of node
			//		- id: (optional) Id of widgets, referenced from resize object, below.
			//
			//		The widgets in this array should be ordered according to how they should be laid out
			//		(each element will be processed in order, and take up as much remaining space as needed),
			//		with the center widget last.
			// changedRegionId:
			//		If specified, the slider for the region with the specified id has been dragged, and thus
			//		the region's height or width should be adjusted according to changedRegionSize
			// changedRegionSize:
			//		See changedRegionId.

			// copy dim because we are going to modify it
			dim = lang.mixin({}, dim);

			domClass.add(container, "dijitLayoutContainer");

			// Move "client" elements to the end of the array for layout.  a11y dictates that the author
			// needs to be able to put them in the document in tab-order, but this algorithm requires that
			// client be last.    TODO: remove for 2.0, all dijit client code already sends children as last item.
			children = array.filter(children, function(item){ return item.region != "center" && item.layoutAlign != "client"; })
				.concat(array.filter(children, function(item){ return item.region == "center" || item.layoutAlign == "client"; }));

			// set positions/sizes
			array.forEach(children, function(child){
				var elm = child.domNode,
					pos = (child.region || child.layoutAlign);
				if(!pos){
					throw new Error("No region setting for " + child.id)
				}

				// set elem to upper left corner of unused space; may move it later
				var elmStyle = elm.style;
				elmStyle.left = dim.l+"px";
				elmStyle.top = dim.t+"px";
				elmStyle.position = "absolute";

				domClass.add(elm, "dijitAlign" + capitalize(pos));

				// Size adjustments to make to this child widget
				var sizeSetting = {};

				// Check for optional size adjustment due to splitter drag (height adjustment for top/bottom align
				// panes and width adjustment for left/right align panes.
				if(changedRegionId && changedRegionId == child.id){
					sizeSetting[child.region == "top" || child.region == "bottom" ? "h" : "w"] = changedRegionSize;
				}

				if(pos == "leading"){
					pos = child.isLeftToRight() ? "left" : "right";
				}
				if(pos == "trailing"){
					pos = child.isLeftToRight() ? "right" : "left";
				}

				// set size && adjust record of remaining space.
				// note that setting the width of a <div> may affect its height.
				if(pos == "top" || pos == "bottom"){
					sizeSetting.w = dim.w;
					size(child, sizeSetting);
					dim.h -= child.h;
					if(pos == "top"){
						dim.t += child.h;
					}else{
						elmStyle.top = dim.t + dim.h + "px";
					}
				}else if(pos == "left" || pos == "right"){
					sizeSetting.h = dim.h;
					size(child, sizeSetting);
					dim.w -= child.w;
					if(pos == "left"){
						dim.l += child.w;
					}else{
						elmStyle.left = dim.l + dim.w + "px";
					}
				}else if(pos == "client" || pos == "center"){
					size(child, dim);
				}
			});
		}
	};

	lang.setObject("dijit.layout.utils", utils);	// remove for 2.0

	return utils;
});

},
'dijit/place':function(){
define([
	"dojo/_base/array", // array.forEach array.map array.some
	"dojo/dom-geometry", // domGeometry.position
	"dojo/dom-style", // domStyle.getComputedStyle
	"dojo/_base/kernel", // kernel.deprecated
	"dojo/_base/window", // win.body
	"./Viewport", // getEffectiveBox
	"./main"	// dijit (defining dijit.place to match API doc)
], function(array, domGeometry, domStyle, kernel, win, Viewport, dijit){

	// module:
	//		dijit/place


	function _place(/*DomNode*/ node, choices, layoutNode, aroundNodeCoords){
		// summary:
		//		Given a list of spots to put node, put it at the first spot where it fits,
		//		of if it doesn't fit anywhere then the place with the least overflow
		// choices: Array
		//		Array of elements like: {corner: 'TL', pos: {x: 10, y: 20} }
		//		Above example says to put the top-left corner of the node at (10,20)
		// layoutNode: Function(node, aroundNodeCorner, nodeCorner, size)
		//		for things like tooltip, they are displayed differently (and have different dimensions)
		//		based on their orientation relative to the parent.	 This adjusts the popup based on orientation.
		//		It also passes in the available size for the popup, which is useful for tooltips to
		//		tell them that their width is limited to a certain amount.	 layoutNode() may return a value expressing
		//		how much the popup had to be modified to fit into the available space.	 This is used to determine
		//		what the best placement is.
		// aroundNodeCoords: Object
		//		Size of aroundNode, ex: {w: 200, h: 50}

		// get {x: 10, y: 10, w: 100, h:100} type obj representing position of
		// viewport over document
		var view = Viewport.getEffectiveBox(node.ownerDocument);

		// This won't work if the node is inside a <div style="position: relative">,
		// so reattach it to <body>.	 (Otherwise, the positioning will be wrong
		// and also it might get cutoff.)
		if(!node.parentNode || String(node.parentNode.tagName).toLowerCase() != "body"){
			win.body(node.ownerDocument).appendChild(node);
		}

		var best = null;
		array.some(choices, function(choice){
			var corner = choice.corner;
			var pos = choice.pos;
			var overflow = 0;

			// calculate amount of space available given specified position of node
			var spaceAvailable = {
				w: {
					'L': view.l + view.w - pos.x,
					'R': pos.x - view.l,
					'M': view.w
				}[corner.charAt(1)],
				h: {
					'T': view.t + view.h - pos.y,
					'B': pos.y - view.t,
					'M': view.h
				}[corner.charAt(0)]
			};

			// Clear left/right position settings set earlier so they don't interfere with calculations,
			// specifically when layoutNode() (a.k.a. Tooltip.orient()) measures natural width of Tooltip
			var s = node.style;
			s.left = s.right = "auto";

			// configure node to be displayed in given position relative to button
			// (need to do this in order to get an accurate size for the node, because
			// a tooltip's size changes based on position, due to triangle)
			if(layoutNode){
				var res = layoutNode(node, choice.aroundCorner, corner, spaceAvailable, aroundNodeCoords);
				overflow = typeof res == "undefined" ? 0 : res;
			}

			// get node's size
			var style = node.style;
			var oldDisplay = style.display;
			var oldVis = style.visibility;
			if(style.display == "none"){
				style.visibility = "hidden";
				style.display = "";
			}
			var bb = domGeometry.position(node);
			style.display = oldDisplay;
			style.visibility = oldVis;

			// coordinates and size of node with specified corner placed at pos,
			// and clipped by viewport
			var
				startXpos = {
					'L': pos.x,
					'R': pos.x - bb.w,
					'M': Math.max(view.l, Math.min(view.l + view.w, pos.x + (bb.w >> 1)) - bb.w) // M orientation is more flexible
				}[corner.charAt(1)],
				startYpos = {
					'T': pos.y,
					'B': pos.y - bb.h,
					'M': Math.max(view.t, Math.min(view.t + view.h, pos.y + (bb.h >> 1)) - bb.h)
				}[corner.charAt(0)],
				startX = Math.max(view.l, startXpos),
				startY = Math.max(view.t, startYpos),
				endX = Math.min(view.l + view.w, startXpos + bb.w),
				endY = Math.min(view.t + view.h, startYpos + bb.h),
				width = endX - startX,
				height = endY - startY;

			overflow += (bb.w - width) + (bb.h - height);

			if(best == null || overflow < best.overflow){
				best = {
					corner: corner,
					aroundCorner: choice.aroundCorner,
					x: startX,
					y: startY,
					w: width,
					h: height,
					overflow: overflow,
					spaceAvailable: spaceAvailable
				};
			}

			return !overflow;
		});

		// In case the best position is not the last one we checked, need to call
		// layoutNode() again.
		if(best.overflow && layoutNode){
			layoutNode(node, best.aroundCorner, best.corner, best.spaceAvailable, aroundNodeCoords);
		}

		// And then position the node.  Do this last, after the layoutNode() above
		// has sized the node, due to browser quirks when the viewport is scrolled
		// (specifically that a Tooltip will shrink to fit as though the window was
		// scrolled to the left).

		var top = best.y,
			side = best.x,
			body = win.body(node.ownerDocument);

		if(/relative|absolute/.test(domStyle.get(body, "position"))){
			// compensate for margin on <body>, see #16148
			top -= domStyle.get(body, "marginTop");
			side -= domStyle.get(body, "marginLeft");
		}

		var s = node.style;
		s.top = top + "px";
		s.left = side + "px";
		s.right = "auto";	// needed for FF or else tooltip goes to far left

		return best;
	}

	var reverse = {
		// Map from corner to kitty-corner
		"TL": "BR",
		"TR": "BL",
		"BL": "TR",
		"BR": "TL"
	};

	var place = {
		// summary:
		//		Code to place a DOMNode relative to another DOMNode.
		//		Load using require(["dijit/place"], function(place){ ... }).

		at: function(node, pos, corners, padding, layoutNode){
			// summary:
			//		Positions node kitty-corner to the rectangle centered at (pos.x, pos.y) with width and height of
			//		padding.x * 2 and padding.y * 2, or zero if padding not specified.  Picks first corner in corners[]
			//		where node is fully visible, or the corner where it's most visible.
			//
			//		Node is assumed to be absolutely or relatively positioned.
			// node: DOMNode
			//		The node to position
			// pos: dijit/place.__Position
			//		Object like {x: 10, y: 20}
			// corners: String[]
			//		Array of Strings representing order to try corners of the node in, like ["TR", "BL"].
			//		Possible values are:
			//
			//		- "BL" - bottom left
			//		- "BR" - bottom right
			//		- "TL" - top left
			//		- "TR" - top right
			// padding: dijit/place.__Position?
			//		Optional param to set padding, to put some buffer around the element you want to position.
			//		Defaults to zero.
			// layoutNode: Function(node, aroundNodeCorner, nodeCorner)
			//		For things like tooltip, they are displayed differently (and have different dimensions)
			//		based on their orientation relative to the parent.  This adjusts the popup based on orientation.
			// example:
			//		Try to place node's top right corner at (10,20).
			//		If that makes node go (partially) off screen, then try placing
			//		bottom left corner at (10,20).
			//	|	place(node, {x: 10, y: 20}, ["TR", "BL"])
			var choices = array.map(corners, function(corner){
				var c = {
					corner: corner,
					aroundCorner: reverse[corner],	// so TooltipDialog.orient() gets aroundCorner argument set
					pos: {x: pos.x,y: pos.y}
				};
				if(padding){
					c.pos.x += corner.charAt(1) == 'L' ? padding.x : -padding.x;
					c.pos.y += corner.charAt(0) == 'T' ? padding.y : -padding.y;
				}
				return c;
			});

			return _place(node, choices, layoutNode);
		},

		around: function(
			/*DomNode*/		node,
			/*DomNode|dijit/place.__Rectangle*/ anchor,
			/*String[]*/	positions,
			/*Boolean*/		leftToRight,
			/*Function?*/	layoutNode){

			// summary:
			//		Position node adjacent or kitty-corner to anchor
			//		such that it's fully visible in viewport.
			// description:
			//		Place node such that corner of node touches a corner of
			//		aroundNode, and that node is fully visible.
			// anchor:
			//		Either a DOMNode or a rectangle (object with x, y, width, height).
			// positions:
			//		Ordered list of positions to try matching up.
			//
			//		- before: places drop down to the left of the anchor node/widget, or to the right in the case
			//			of RTL scripts like Hebrew and Arabic; aligns either the top of the drop down
			//			with the top of the anchor, or the bottom of the drop down with bottom of the anchor.
			//		- after: places drop down to the right of the anchor node/widget, or to the left in the case
			//			of RTL scripts like Hebrew and Arabic; aligns either the top of the drop down
			//			with the top of the anchor, or the bottom of the drop down with bottom of the anchor.
			//		- before-centered: centers drop down to the left of the anchor node/widget, or to the right
			//			in the case of RTL scripts like Hebrew and Arabic
			//		- after-centered: centers drop down to the right of the anchor node/widget, or to the left
			//			in the case of RTL scripts like Hebrew and Arabic
			//		- above-centered: drop down is centered above anchor node
			//		- above: drop down goes above anchor node, left sides aligned
			//		- above-alt: drop down goes above anchor node, right sides aligned
			//		- below-centered: drop down is centered above anchor node
			//		- below: drop down goes below anchor node
			//		- below-alt: drop down goes below anchor node, right sides aligned
			// layoutNode: Function(node, aroundNodeCorner, nodeCorner)
			//		For things like tooltip, they are displayed differently (and have different dimensions)
			//		based on their orientation relative to the parent.	 This adjusts the popup based on orientation.
			// leftToRight:
			//		True if widget is LTR, false if widget is RTL.   Affects the behavior of "above" and "below"
			//		positions slightly.
			// example:
			//	|	placeAroundNode(node, aroundNode, ['below', 'above-alt']);
			//		This will try to position node such that node's top-left corner is at the same position
			//		as the bottom left corner of the aroundNode (ie, put node below
			//		aroundNode, with left edges aligned).	If that fails it will try to put
			//		the bottom-right corner of node where the top right corner of aroundNode is
			//		(ie, put node above aroundNode, with right edges aligned)
			//

			// If around is a DOMNode (or DOMNode id), convert to coordinates.
			var aroundNodePos;
			if(typeof anchor == "string" || "offsetWidth" in anchor || "ownerSVGElement" in anchor){
				aroundNodePos = domGeometry.position(anchor, true);

				// For above and below dropdowns, subtract width of border so that popup and aroundNode borders
				// overlap, preventing a double-border effect.  Unfortunately, difficult to measure the border
				// width of either anchor or popup because in both cases the border may be on an inner node.
				if(/^(above|below)/.test(positions[0])){
					var anchorBorder = domGeometry.getBorderExtents(anchor),
						anchorChildBorder = anchor.firstChild ? domGeometry.getBorderExtents(anchor.firstChild) : {t:0,l:0,b:0,r:0},
						nodeBorder =  domGeometry.getBorderExtents(node),
						nodeChildBorder = node.firstChild ? domGeometry.getBorderExtents(node.firstChild) : {t:0,l:0,b:0,r:0};
					aroundNodePos.y += Math.min(anchorBorder.t + anchorChildBorder.t, nodeBorder.t + nodeChildBorder.t);
					aroundNodePos.h -=  Math.min(anchorBorder.t + anchorChildBorder.t, nodeBorder.t+ nodeChildBorder.t) +
						Math.min(anchorBorder.b + anchorChildBorder.b, nodeBorder.b + nodeChildBorder.b);
				}
			}else{
				aroundNodePos = anchor;
			}

			// Compute position and size of visible part of anchor (it may be partially hidden by ancestor nodes w/scrollbars)
			if(anchor.parentNode){
				// ignore nodes between position:relative and position:absolute
				var sawPosAbsolute = domStyle.getComputedStyle(anchor).position == "absolute";
				var parent = anchor.parentNode;
				while(parent && parent.nodeType == 1 && parent.nodeName != "BODY"){  //ignoring the body will help performance
					var parentPos = domGeometry.position(parent, true),
						pcs = domStyle.getComputedStyle(parent);
					if(/relative|absolute/.test(pcs.position)){
						sawPosAbsolute = false;
					}
					if(!sawPosAbsolute && /hidden|auto|scroll/.test(pcs.overflow)){
						var bottomYCoord = Math.min(aroundNodePos.y + aroundNodePos.h, parentPos.y + parentPos.h);
						var rightXCoord = Math.min(aroundNodePos.x + aroundNodePos.w, parentPos.x + parentPos.w);
						aroundNodePos.x = Math.max(aroundNodePos.x, parentPos.x);
						aroundNodePos.y = Math.max(aroundNodePos.y, parentPos.y);
						aroundNodePos.h = bottomYCoord - aroundNodePos.y;
						aroundNodePos.w = rightXCoord - aroundNodePos.x;
					}
					if(pcs.position == "absolute"){
						sawPosAbsolute = true;
					}
					parent = parent.parentNode;
				}
			}

			var x = aroundNodePos.x,
				y = aroundNodePos.y,
				width = "w" in aroundNodePos ? aroundNodePos.w : (aroundNodePos.w = aroundNodePos.width),
				height = "h" in aroundNodePos ? aroundNodePos.h : (kernel.deprecated("place.around: dijit/place.__Rectangle: { x:"+x+", y:"+y+", height:"+aroundNodePos.height+", width:"+width+" } has been deprecated.  Please use { x:"+x+", y:"+y+", h:"+aroundNodePos.height+", w:"+width+" }", "", "2.0"), aroundNodePos.h = aroundNodePos.height);

			// Convert positions arguments into choices argument for _place()
			var choices = [];
			function push(aroundCorner, corner){
				choices.push({
					aroundCorner: aroundCorner,
					corner: corner,
					pos: {
						x: {
							'L': x,
							'R': x + width,
							'M': x + (width >> 1)
						}[aroundCorner.charAt(1)],
						y: {
							'T': y,
							'B': y + height,
							'M': y + (height >> 1)
						}[aroundCorner.charAt(0)]
					}
				})
			}
			array.forEach(positions, function(pos){
				var ltr =  leftToRight;
				switch(pos){
					case "above-centered":
						push("TM", "BM");
						break;
					case "below-centered":
						push("BM", "TM");
						break;
					case "after-centered":
						ltr = !ltr;
						// fall through
					case "before-centered":
						push(ltr ? "ML" : "MR", ltr ? "MR" : "ML");
						break;
					case "after":
						ltr = !ltr;
						// fall through
					case "before":
						push(ltr ? "TL" : "TR", ltr ? "TR" : "TL");
						push(ltr ? "BL" : "BR", ltr ? "BR" : "BL");
						break;
					case "below-alt":
						ltr = !ltr;
						// fall through
					case "below":
						// first try to align left borders, next try to align right borders (or reverse for RTL mode)
						push(ltr ? "BL" : "BR", ltr ? "TL" : "TR");
						push(ltr ? "BR" : "BL", ltr ? "TR" : "TL");
						break;
					case "above-alt":
						ltr = !ltr;
						// fall through
					case "above":
						// first try to align left borders, next try to align right borders (or reverse for RTL mode)
						push(ltr ? "TL" : "TR", ltr ? "BL" : "BR");
						push(ltr ? "TR" : "TL", ltr ? "BR" : "BL");
						break;
					default:
						// To assist dijit/_base/place, accept arguments of type {aroundCorner: "BL", corner: "TL"}.
						// Not meant to be used directly.  Remove for 2.0.
						push(pos.aroundCorner, pos.corner);
				}
			});

			var position = _place(node, choices, layoutNode, {w: width, h: height});
			position.aroundNodePos = aroundNodePos;

			return position;
		}
	};

	/*=====
	place.__Position = {
		// x: Integer
		//		horizontal coordinate in pixels, relative to document body
		// y: Integer
		//		vertical coordinate in pixels, relative to document body
	};
	place.__Rectangle = {
		// x: Integer
		//		horizontal offset in pixels, relative to document body
		// y: Integer
		//		vertical offset in pixels, relative to document body
		// w: Integer
		//		width in pixels.   Can also be specified as "width" for backwards-compatibility.
		// h: Integer
		//		height in pixels.   Can also be specified as "height" for backwards-compatibility.
	};
	=====*/

	return dijit.place = place;	// setting dijit.place for back-compat, remove for 2.0
});

},
'dijit/popup':function(){
define([
	"dojo/_base/array", // array.forEach array.some
	"dojo/aspect",
	"dojo/_base/declare", // declare
	"dojo/dom", // dom.isDescendant
	"dojo/dom-attr", // domAttr.set
	"dojo/dom-construct", // domConstruct.create domConstruct.destroy
	"dojo/dom-geometry", // domGeometry.isBodyLtr
	"dojo/dom-style", // domStyle.set
	"dojo/has", // has("config-bgIframe")
	"dojo/keys",
	"dojo/_base/lang", // lang.hitch
	"dojo/on",
	"./place",
	"./BackgroundIframe",
	"./Viewport",
	"./main",    // dijit (defining dijit.popup to match API doc)
	"dojo/touch"		// use of dojoClick
], function(array, aspect, declare, dom, domAttr, domConstruct, domGeometry, domStyle, has, keys, lang, on,
			place, BackgroundIframe, Viewport, dijit){

	// module:
	//		dijit/popup

	/*=====
	 var __OpenArgs = {
		 // popup: Widget
		 //		widget to display
		 // parent: Widget
		 //		the button etc. that is displaying this popup
		 // around: DomNode
		 //		DOM node (typically a button); place popup relative to this node.  (Specify this *or* "x" and "y" parameters.)
		 // x: Integer
		 //		Absolute horizontal position (in pixels) to place node at.  (Specify this *or* "around" parameter.)
		 // y: Integer
		 //		Absolute vertical position (in pixels) to place node at.  (Specify this *or* "around" parameter.)
		 // orient: Object|String
		 //		When the around parameter is specified, orient should be a list of positions to try, ex:
		 //	|	[ "below", "above" ]
		 //		For backwards compatibility it can also be an (ordered) hash of tuples of the form
		 //		(around-node-corner, popup-node-corner), ex:
		 //	|	{ "BL": "TL", "TL": "BL" }
		 //		where BL means "bottom left" and "TL" means "top left", etc.
		 //
		 //		dijit/popup.open() tries to position the popup according to each specified position, in order,
		 //		until the popup appears fully within the viewport.
		 //
		 //		The default value is ["below", "above"]
		 //
		 //		When an (x,y) position is specified rather than an around node, orient is either
		 //		"R" or "L".  R (for right) means that it tries to put the popup to the right of the mouse,
		 //		specifically positioning the popup's top-right corner at the mouse position, and if that doesn't
		 //		fit in the viewport, then it tries, in order, the bottom-right corner, the top left corner,
		 //		and the top-right corner.
		 // onCancel: Function
		 //		callback when user has canceled the popup by:
		 //
		 //		1. hitting ESC or
		 //		2. by using the popup widget's proprietary cancel mechanism (like a cancel button in a dialog);
		 //		   i.e. whenever popupWidget.onCancel() is called, args.onCancel is called
		 // onClose: Function
		 //		callback whenever this popup is closed
		 // onExecute: Function
		 //		callback when user "executed" on the popup/sub-popup by selecting a menu choice, etc. (top menu only)
		 // padding: place.__Position
		 //		adding a buffer around the opening position. This is only useful when around is not set.
		 // maxHeight: Integer
		 //		The max height for the popup.  Any popup taller than this will have scrollbars.
		 //		Set to Infinity for no max height.  Default is to limit height to available space in viewport,
		 //		above or below the aroundNode or specified x/y position.
	 };
	 =====*/

	function destroyWrapper(){
		// summary:
		//		Function to destroy wrapper when popup widget is destroyed.
		//		Left in this scope to avoid memory leak on IE8 on refresh page, see #15206.
		if(this._popupWrapper){
			domConstruct.destroy(this._popupWrapper);
			delete this._popupWrapper;
		}
	}

	var PopupManager = declare(null, {
		// summary:
		//		Used to show drop downs (ex: the select list of a ComboBox)
		//		or popups (ex: right-click context menus).

		// _stack: dijit/_WidgetBase[]
		//		Stack of currently popped up widgets.
		//		(someone opened _stack[0], and then it opened _stack[1], etc.)
		_stack: [],

		// _beginZIndex: Number
		//		Z-index of the first popup.   (If first popup opens other
		//		popups they get a higher z-index.)
		_beginZIndex: 1000,

		_idGen: 1,

		_repositionAll: function(){
			// summary:
			//		If screen has been scrolled, reposition all the popups in the stack.
			//		Then set timer to check again later.

			if(this._firstAroundNode){	// guard for when clearTimeout() on IE doesn't work
				var oldPos = this._firstAroundPosition,
					newPos = domGeometry.position(this._firstAroundNode, true),
					dx = newPos.x - oldPos.x,
					dy = newPos.y - oldPos.y;

				if(dx || dy){
					this._firstAroundPosition = newPos;
					for(var i = 0; i < this._stack.length; i++){
						var style = this._stack[i].wrapper.style;
						style.top = (parseFloat(style.top) + dy) + "px";
						if(style.right == "auto"){
							style.left = (parseFloat(style.left) + dx) + "px";
						}else{
							style.right = (parseFloat(style.right) - dx) + "px";
						}
					}
				}

				this._aroundMoveListener = setTimeout(lang.hitch(this, "_repositionAll"), dx || dy ? 10 : 50);
			}
		},

		_createWrapper: function(/*Widget*/ widget){
			// summary:
			//		Initialization for widgets that will be used as popups.
			//		Puts widget inside a wrapper DIV (if not already in one),
			//		and returns pointer to that wrapper DIV.

			var wrapper = widget._popupWrapper,
				node = widget.domNode;

			if(!wrapper){
				// Create wrapper <div> for when this widget [in the future] will be used as a popup.
				// This is done early because of IE bugs where creating/moving DOM nodes causes focus
				// to go wonky, see tests/robot/Toolbar.html to reproduce
				wrapper = domConstruct.create("div", {
					"class": "dijitPopup",
					style: { display: "none"},
					role: "region",
					"aria-label": widget["aria-label"] || widget.label || widget.name || widget.id
				}, widget.ownerDocumentBody);
				wrapper.appendChild(node);

				var s = node.style;
				s.display = "";
				s.visibility = "";
				s.position = "";
				s.top = "0px";

				widget._popupWrapper = wrapper;
				aspect.after(widget, "destroy", destroyWrapper, true);

				// Workaround iOS problem where clicking a Menu can focus an <input> (or click a button) behind it.
				// Need to be careful though that you can still focus <input>'s and click <button>'s in a TooltipDialog.
				// Also, be careful not to break (native) scrolling of dropdown like ComboBox's options list.
				if("ontouchend" in document) {
					on(wrapper, "touchend", function (evt){
						if(!/^(input|button|textarea)$/i.test(evt.target.tagName)) {
							evt.preventDefault();
						}
					});
				}

				// Calling evt.preventDefault() suppresses the native click event on most browsers.  However, it doesn't
				// suppress the synthetic click event emitted by dojo/touch.  In order for clicks in popups to work
				// consistently, always use dojo/touch in popups.  See #18150.
				wrapper.dojoClick = true;
			}

			return wrapper;
		},

		moveOffScreen: function(/*Widget*/ widget){
			// summary:
			//		Moves the popup widget off-screen.
			//		Do not use this method to hide popups when not in use, because
			//		that will create an accessibility issue: the offscreen popup is
			//		still in the tabbing order.

			// Create wrapper if not already there
			var wrapper = this._createWrapper(widget);

			// Besides setting visibility:hidden, move it out of the viewport, see #5776, #10111, #13604
			var ltr = domGeometry.isBodyLtr(widget.ownerDocument),
				style = {
					visibility: "hidden",
					top: "-9999px",
					display: ""
				};
			style[ltr ? "left" : "right"] = "-9999px";
			style[ltr ? "right" : "left"] = "auto";
			domStyle.set(wrapper, style);

			return wrapper;
		},

		hide: function(/*Widget*/ widget){
			// summary:
			//		Hide this popup widget (until it is ready to be shown).
			//		Initialization for widgets that will be used as popups
			//
			//		Also puts widget inside a wrapper DIV (if not already in one)
			//
			//		If popup widget needs to layout it should
			//		do so when it is made visible, and popup._onShow() is called.

			// Create wrapper if not already there
			var wrapper = this._createWrapper(widget);

			domStyle.set(wrapper, {
				display: "none",
				height: "auto",			// Open() may have limited the height to fit in the viewport,
				overflowY: "visible",	// and set overflowY to "auto".
				border: ""				// Open() may have moved border from popup to wrapper.
			});

			// Open() may have moved border from popup to wrapper.  Move it back.
			var node = widget.domNode;
			if("_originalStyle" in node){
				node.style.cssText = node._originalStyle;
			}
		},

		getTopPopup: function(){
			// summary:
			//		Compute the closest ancestor popup that's *not* a child of another popup.
			//		Ex: For a TooltipDialog with a button that spawns a tree of menus, find the popup of the button.
			var stack = this._stack;
			for(var pi = stack.length - 1; pi > 0 && stack[pi].parent === stack[pi - 1].widget; pi--){
				/* do nothing, just trying to get right value for pi */
			}
			return stack[pi];
		},

		open: function(/*__OpenArgs*/ args){
			// summary:
			//		Popup the widget at the specified position
			//
			// example:
			//		opening at the mouse position
			//		|		popup.open({popup: menuWidget, x: evt.pageX, y: evt.pageY});
			//
			// example:
			//		opening the widget as a dropdown
			//		|		popup.open({parent: this, popup: menuWidget, around: this.domNode, onClose: function(){...}});
			//
			//		Note that whatever widget called dijit/popup.open() should also listen to its own _onBlur callback
			//		(fired from _base/focus.js) to know that focus has moved somewhere else and thus the popup should be closed.

			var stack = this._stack,
				widget = args.popup,
				node = widget.domNode,
				orient = args.orient || ["below", "below-alt", "above", "above-alt"],
				ltr = args.parent ? args.parent.isLeftToRight() : domGeometry.isBodyLtr(widget.ownerDocument),
				around = args.around,
				id = (args.around && args.around.id) ? (args.around.id + "_dropdown") : ("popup_" + this._idGen++);

			// If we are opening a new popup that isn't a child of a currently opened popup, then
			// close currently opened popup(s).   This should happen automatically when the old popups
			// gets the _onBlur() event, except that the _onBlur() event isn't reliable on IE, see [22198].
			while(stack.length && (!args.parent || !dom.isDescendant(args.parent.domNode, stack[stack.length - 1].widget.domNode))){
				this.close(stack[stack.length - 1].widget);
			}

			// Get pointer to popup wrapper, and create wrapper if it doesn't exist.  Remove display:none (but keep
			// off screen) so we can do sizing calculations.
			var wrapper = this.moveOffScreen(widget);

			if(widget.startup && !widget._started){
				widget.startup(); // this has to be done after being added to the DOM
			}

			// Limit height to space available in viewport either above or below aroundNode (whichever side has more
			// room), adding scrollbar if necessary. Can't add scrollbar to widget because it may be a <table> (ex:
			// dijit/Menu), so add to wrapper, and then move popup's border to wrapper so scroll bar inside border.
			var maxHeight, popupSize = domGeometry.position(node);
			if("maxHeight" in args && args.maxHeight != -1){
				maxHeight = args.maxHeight || Infinity;	// map 0 --> infinity for back-compat of _HasDropDown.maxHeight
			}else{
				var viewport = Viewport.getEffectiveBox(this.ownerDocument),
					aroundPos = around ? domGeometry.position(around, false) : {y: args.y - (args.padding||0), h: (args.padding||0) * 2};
				maxHeight = Math.floor(Math.max(aroundPos.y, viewport.h - (aroundPos.y + aroundPos.h)));
			}
			if(popupSize.h > maxHeight){
				// Get style of popup's border.  Unfortunately domStyle.get(node, "border") doesn't work on FF or IE,
				// and domStyle.get(node, "borderColor") etc. doesn't work on FF, so need to use fully qualified names.
				var cs = domStyle.getComputedStyle(node),
					borderStyle = cs.borderLeftWidth + " " + cs.borderLeftStyle + " " + cs.borderLeftColor;
				domStyle.set(wrapper, {
					overflowY: "scroll",
					height: maxHeight + "px",
					border: borderStyle	// so scrollbar is inside border
				});
				node._originalStyle = node.style.cssText;
				node.style.border = "none";
			}

			domAttr.set(wrapper, {
				id: id,
				style: {
					zIndex: this._beginZIndex + stack.length
				},
				"class": "dijitPopup " + (widget.baseClass || widget["class"] || "").split(" ")[0] + "Popup",
				dijitPopupParent: args.parent ? args.parent.id : ""
			});

			if(stack.length == 0 && around){
				// First element on stack. Save position of aroundNode and setup listener for changes to that position.
				this._firstAroundNode = around;
				this._firstAroundPosition = domGeometry.position(around, true);
				this._aroundMoveListener = setTimeout(lang.hitch(this, "_repositionAll"), 50);
			}

			if(has("config-bgIframe") && !widget.bgIframe){
				// setting widget.bgIframe triggers cleanup in _WidgetBase.destroyRendering()
				widget.bgIframe = new BackgroundIframe(wrapper);
			}

			// position the wrapper node and make it visible
			var layoutFunc = widget.orient ? lang.hitch(widget, "orient") : null,
				best = around ?
					place.around(wrapper, around, orient, ltr, layoutFunc) :
					place.at(wrapper, args, orient == 'R' ? ['TR', 'BR', 'TL', 'BL'] : ['TL', 'BL', 'TR', 'BR'], args.padding,
						layoutFunc);

			wrapper.style.visibility = "visible";
			node.style.visibility = "visible";	// counteract effects from _HasDropDown

			var handlers = [];

			// provide default escape and tab key handling
			// (this will work for any widget, not just menu)
			handlers.push(on(wrapper, "keydown", lang.hitch(this, function(evt){
				if(evt.keyCode == keys.ESCAPE && args.onCancel){
					evt.stopPropagation();
					evt.preventDefault();
					args.onCancel();
				}else if(evt.keyCode == keys.TAB){
					evt.stopPropagation();
					evt.preventDefault();
					var topPopup = this.getTopPopup();
					if(topPopup && topPopup.onCancel){
						topPopup.onCancel();
					}
				}
			})));

			// watch for cancel/execute events on the popup and notify the caller
			// (for a menu, "execute" means clicking an item)
			if(widget.onCancel && args.onCancel){
				handlers.push(widget.on("cancel", args.onCancel));
			}

			handlers.push(widget.on(widget.onExecute ? "execute" : "change", lang.hitch(this, function(){
				var topPopup = this.getTopPopup();
				if(topPopup && topPopup.onExecute){
					topPopup.onExecute();
				}
			})));

			stack.push({
				widget: widget,
				wrapper: wrapper,
				parent: args.parent,
				onExecute: args.onExecute,
				onCancel: args.onCancel,
				onClose: args.onClose,
				handlers: handlers
			});

			if(widget.onOpen){
				// TODO: in 2.0 standardize onShow() (used by StackContainer) and onOpen() (used here)
				widget.onOpen(best);
			}

			return best;
		},

		close: function(/*Widget?*/ popup){
			// summary:
			//		Close specified popup and any popups that it parented.
			//		If no popup is specified, closes all popups.

			var stack = this._stack;

			// Basically work backwards from the top of the stack closing popups
			// until we hit the specified popup, but IIRC there was some issue where closing
			// a popup would cause others to close too.  Thus if we are trying to close B in [A,B,C]
			// closing C might close B indirectly and then the while() condition will run where stack==[A]...
			// so the while condition is constructed defensively.
			while((popup && array.some(stack, function(elem){
				return elem.widget == popup;
			})) ||
				(!popup && stack.length)){
				var top = stack.pop(),
					widget = top.widget,
					onClose = top.onClose;

				if (widget.bgIframe) {
					// push the iframe back onto the stack.
					widget.bgIframe.destroy();
					delete widget.bgIframe;
				}

				if(widget.onClose){
					// TODO: in 2.0 standardize onHide() (used by StackContainer) and onClose() (used here).
					// Actually, StackContainer also calls onClose(), but to mean that the pane is being deleted
					// (i.e. that the TabContainer's tab's [x] icon was clicked)
					widget.onClose();
				}

				var h;
				while(h = top.handlers.pop()){
					h.remove();
				}

				// Hide the widget and it's wrapper unless it has already been destroyed in above onClose() etc.
				if(widget && widget.domNode){
					this.hide(widget);
				}

				if(onClose){
					onClose();
				}
			}

			if(stack.length == 0 && this._aroundMoveListener){
				clearTimeout(this._aroundMoveListener);
				this._firstAroundNode = this._firstAroundPosition = this._aroundMoveListener = null;
			}
		}
	});

	return (dijit.popup = new PopupManager());
});

},
'dijit/BackgroundIframe':function(){
define([
	"require",			// require.toUrl
	"./main",	// to export dijit.BackgroundIframe
	"dojo/_base/config",
	"dojo/dom-construct", // domConstruct.create
	"dojo/dom-style", // domStyle.set
	"dojo/_base/lang", // lang.extend lang.hitch
	"dojo/on",
	"dojo/sniff" // has("ie"), has("trident"), has("quirks")
], function(require, dijit, config, domConstruct, domStyle, lang, on, has){

	// module:
	//		dijit/BackgroundIFrame

	// Flag for whether to create background iframe behind popups like Menus and Dialog.
	// A background iframe is useful to prevent problems with popups appearing behind applets/pdf files,
	// and is also useful on older versions of IE (IE6 and IE7) to prevent the "bleed through select" problem.
	// By default, it's enabled for IE6-11, excluding Windows Phone 8.
	// TODO: For 2.0, make this false by default.  Also, possibly move definition to has.js so that this module can be
	// conditionally required via  dojo/has!bgIfame?dijit/BackgroundIframe
	has.add("config-bgIframe",
    	(has("ie") || has("trident")) && !/IEMobile\/10\.0/.test(navigator.userAgent)); // No iframe on WP8, to match 1.9 behavior

	var _frames = new function(){
		// summary:
		//		cache of iframes

		var queue = [];

		this.pop = function(){
			var iframe;
			if(queue.length){
				iframe = queue.pop();
				iframe.style.display="";
			}else{
				// transparency needed for DialogUnderlay and for tooltips on IE (to see screen near connector)
				if(has("ie") < 9){
					var burl = config["dojoBlankHtmlUrl"] || require.toUrl("dojo/resources/blank.html") || "javascript:\"\"";
					var html="<iframe src='" + burl + "' role='presentation'"
						+ " style='position: absolute; left: 0px; top: 0px;"
						+ "z-index: -1; filter:Alpha(Opacity=\"0\");'>";
					iframe = document.createElement(html);
				}else{
					iframe = domConstruct.create("iframe");
					iframe.src = 'javascript:""';
					iframe.className = "dijitBackgroundIframe";
					iframe.setAttribute("role", "presentation");
					domStyle.set(iframe, "opacity", 0.1);
				}
				iframe.tabIndex = -1; // Magic to prevent iframe from getting focus on tab keypress - as style didn't work.
			}
			return iframe;
		};

		this.push = function(iframe){
			iframe.style.display="none";
			queue.push(iframe);
		}
	}();


	dijit.BackgroundIframe = function(/*DomNode*/ node){
		// summary:
		//		For IE/FF z-index shenanigans. id attribute is required.
		//
		// description:
		//		new dijit.BackgroundIframe(node).
		//
		//		Makes a background iframe as a child of node, that fills
		//		area (and position) of node

		if(!node.id){ throw new Error("no id"); }
		if(has("config-bgIframe")){
			var iframe = (this.iframe = _frames.pop());
			node.appendChild(iframe);
			if(has("ie")<7 || has("quirks")){
				this.resize(node);
				this._conn = on(node, 'resize', lang.hitch(this, "resize", node));
			}else{
				domStyle.set(iframe, {
					width: '100%',
					height: '100%'
				});
			}
		}
	};

	lang.extend(dijit.BackgroundIframe, {
		resize: function(node){
			// summary:
			//		Resize the iframe so it's the same size as node.
			//		Needed on IE6 and IE/quirks because height:100% doesn't work right.
			if(this.iframe){
				domStyle.set(this.iframe, {
					width: node.offsetWidth + 'px',
					height: node.offsetHeight + 'px'
				});
			}
		},
		destroy: function(){
			// summary:
			//		destroy the iframe
			if(this._conn){
				this._conn.remove();
				this._conn = null;
			}
			if(this.iframe){
				this.iframe.parentNode.removeChild(this.iframe);
				_frames.push(this.iframe);
				delete this.iframe;
			}
		}
	});

	return dijit.BackgroundIframe;
});

},
'dijit/Menu':function(){
define([
	"require",
	"dojo/_base/array", // array.forEach
	"dojo/_base/declare", // declare
	"dojo/dom", // dom.byId dom.isDescendant
	"dojo/dom-attr", // domAttr.get domAttr.set domAttr.has domAttr.remove
	"dojo/dom-geometry", // domStyle.getComputedStyle domGeometry.position
	"dojo/dom-style", // domStyle.getComputedStyle
	"dojo/keys", // keys.F10
	"dojo/_base/lang", // lang.hitch
	"dojo/on",
	"dojo/sniff", // has("ie"), has("quirks")
	"dojo/_base/window", // win.body
	"dojo/window", // winUtils.get
	"./popup",
	"./DropDownMenu",
	"dojo/ready"
], function(require, array, declare, dom, domAttr, domGeometry, domStyle, keys, lang, on, has, win, winUtils, pm, DropDownMenu, ready){

	// module:
	//		dijit/Menu

	// Back compat w/1.6, remove for 2.0
	if(has("dijit-legacy-requires")){
		ready(0, function(){
			var requires = ["dijit/MenuItem", "dijit/PopupMenuItem", "dijit/CheckedMenuItem", "dijit/MenuSeparator"];
			require(requires);	// use indirection so modules not rolled into a build
		});
	}

	return declare("dijit.Menu", DropDownMenu, {
		// summary:
		//		A context menu you can assign to multiple elements

		constructor: function(/*===== params, srcNodeRef =====*/){
			// summary:
			//		Create the widget.
			// params: Object|null
			//		Hash of initialization parameters for widget, including scalar values (like title, duration etc.)
			//		and functions, typically callbacks like onClick.
			//		The hash can contain any of the widget's properties, excluding read-only properties.
			// srcNodeRef: DOMNode|String?
			//		If a srcNodeRef (DOM node) is specified:
			//
			//		- use srcNodeRef.innerHTML as my contents
			//		- replace srcNodeRef with my generated DOM tree

			this._bindings = [];
		},

		// targetNodeIds: [const] String[]
		//		Array of dom node ids of nodes to attach to.
		//		Fill this with nodeIds upon widget creation and it becomes context menu for those nodes.
		targetNodeIds: [],

		// selector: String?
		//		CSS expression to apply this Menu to descendants of targetNodeIds, rather than to
		//		the nodes specified by targetNodeIds themselves.  Useful for applying a Menu to
		//		a range of rows in a table, tree, etc.
		//
		//		The application must require() an appropriate level of dojo/query to handle the selector.
		selector: "",

		// TODO: in 2.0 remove support for multiple targetNodeIds.   selector gives the same effect.
		// So, change targetNodeIds to a targetNodeId: "", remove bindDomNode()/unBindDomNode(), etc.

		/*=====
		// currentTarget: [readonly] DOMNode
		//		For context menus, set to the current node that the Menu is being displayed for.
		//		Useful so that the menu actions can be tailored according to the node
		currentTarget: null,
		=====*/

		// contextMenuForWindow: [const] Boolean
		//		If true, right clicking anywhere on the window will cause this context menu to open.
		//		If false, must specify targetNodeIds.
		contextMenuForWindow: false,

		// leftClickToOpen: [const] Boolean
		//		If true, menu will open on left click instead of right click, similar to a file menu.
		leftClickToOpen: false,
		// TODO: remove in 2.0, we have better ways of opening a menu with a left click, by extending _HasDropDown.

		// refocus: Boolean
		//		When this menu closes, re-focus the element which had focus before it was opened.
		refocus: true,

		postCreate: function(){
			if(this.contextMenuForWindow){
				this.bindDomNode(this.ownerDocumentBody);
			}else{
				array.forEach(this.targetNodeIds, this.bindDomNode, this);
			}
			this.inherited(arguments);
		},

		// thanks burstlib!
		_iframeContentWindow: function(/* HTMLIFrameElement */iframe_el){
			// summary:
			//		Returns the window reference of the passed iframe
			// tags:
			//		private
			return winUtils.get(this._iframeContentDocument(iframe_el)) ||
				// Moz. TODO: is this available when defaultView isn't?
				this._iframeContentDocument(iframe_el)['__parent__'] ||
				(iframe_el.name && document.frames[iframe_el.name]) || null;	//	Window
		},

		_iframeContentDocument: function(/* HTMLIFrameElement */iframe_el){
			// summary:
			//		Returns a reference to the document object inside iframe_el
			// tags:
			//		protected
			return iframe_el.contentDocument // W3
				|| (iframe_el.contentWindow && iframe_el.contentWindow.document) // IE
				|| (iframe_el.name && document.frames[iframe_el.name] && document.frames[iframe_el.name].document)
				|| null;	//	HTMLDocument
		},

		bindDomNode: function(/*String|DomNode*/ node){
			// summary:
			//		Attach menu to given node
			node = dom.byId(node, this.ownerDocument);

			var cn;	// Connect node

			// Support context menus on iframes.  Rather than binding to the iframe itself we need
			// to bind to the <body> node inside the iframe.
			if(node.tagName.toLowerCase() == "iframe"){
				var iframe = node,
					window = this._iframeContentWindow(iframe);
				cn = win.body(window.document);
			}else{
				// To capture these events at the top level, attach to <html>, not <body>.
				// Otherwise right-click context menu just doesn't work.
				cn = (node == win.body(this.ownerDocument) ? this.ownerDocument.documentElement : node);
			}


			// "binding" is the object to track our connection to the node (ie, the parameter to bindDomNode())
			var binding = {
				node: node,
				iframe: iframe
			};

			// Save info about binding in _bindings[], and make node itself record index(+1) into
			// _bindings[] array.  Prefix w/_dijitMenu to avoid setting an attribute that may
			// start with a number, which fails on FF/safari.
			domAttr.set(node, "_dijitMenu" + this.id, this._bindings.push(binding));

			// Setup the connections to monitor click etc., unless we are connecting to an iframe which hasn't finished
			// loading yet, in which case we need to wait for the onload event first, and then connect
			// On linux Shift-F10 produces the oncontextmenu event, but on Windows it doesn't, so
			// we need to monitor keyboard events in addition to the oncontextmenu event.
			var doConnects = lang.hitch(this, function(cn){
				var selector = this.selector,
					delegatedEvent = selector ?
						function(eventType){
							return on.selector(selector, eventType);
						} :
						function(eventType){
							return eventType;
						},
					self = this;
				return [
					on(cn, delegatedEvent(this.leftClickToOpen ? "click" : "contextmenu"), function(evt){
						 //REMIND Appivo code to grant access to original event
						self.openEvent = evt;
						evt.stopPropagation();
						evt.preventDefault();

						if((new Date()).getTime() < self._lastKeyDown + 500){
							// Ignore contextmenu/click events that were already processed in keydown handler below.
							// But still call preventDefault() (above) so system context menu doesn't appear.
							return;
						}

						// Schedule context menu to be opened.
						// Note that this won't work will if the click was generated by the keyboard, while
						// focused on a <button> etc.   In that case evt.pageX and evt.pageY are either (0,0) or
						// wherever the mouse cursor is.  See keydown handler below.
						self._scheduleOpen(this, iframe, {x: evt.pageX, y: evt.pageY}, evt.target);
					}),
					on(cn, delegatedEvent("keydown"), function(evt){
						if(evt.keyCode == 93 ||									// context menu key
							(evt.shiftKey && evt.keyCode == keys.F10) ||		// shift-F10
							(self.leftClickToOpen && evt.keyCode == keys.SPACE)	// space key
						){
							evt.stopPropagation();
							evt.preventDefault();

							// Open the menu around evt.target.  Note that "this" and evt.target
							// are likely different, especially for global context menu, where "this" is <body>.
							self._scheduleOpen(this, iframe, null, evt.target);	// no coords - open near evt.target

							self._lastKeyDown = (new Date()).getTime();
						}
					})
				];
			});
			binding.connects = cn ? doConnects(cn) : [];

			if(iframe){
				// Setup handler to [re]bind to the iframe when the contents are initially loaded,
				// and every time the contents change.
				// Need to do this b/c we are actually binding to the iframe's <body> node.
				// Note: can't use connect.connect(), see #9609.

				binding.onloadHandler = lang.hitch(this, function(){
					// want to remove old connections, but IE throws exceptions when trying to
					// access the <body> node because it's already gone, or at least in a state of limbo

					var window = this._iframeContentWindow(iframe),
						cn = win.body(window.document);
					binding.connects = doConnects(cn);
				});
				if(iframe.addEventListener){
					iframe.addEventListener("load", binding.onloadHandler, false);
				}else{
					iframe.attachEvent("onload", binding.onloadHandler);
				}
			}
		},

		unBindDomNode: function(/*String|DomNode*/ nodeName){
			// summary:
			//		Detach menu from given node

			var node;
			try{
				node = dom.byId(nodeName, this.ownerDocument);
			}catch(e){
				// On IE the dom.byId() call will get an exception if the attach point was
				// the <body> node of an <iframe> that has since been reloaded (and thus the
				// <body> node is in a limbo state of destruction.
				return;
			}

			// node["_dijitMenu" + this.id] contains index(+1) into my _bindings[] array
			var attrName = "_dijitMenu" + this.id;
			if(node && domAttr.has(node, attrName)){
				var bid = domAttr.get(node, attrName) - 1, b = this._bindings[bid], h;
				while((h = b.connects.pop())){
					h.remove();
				}

				// Remove listener for iframe onload events
				var iframe = b.iframe;
				if(iframe){
					if(iframe.removeEventListener){
						iframe.removeEventListener("load", b.onloadHandler, false);
					}else{
						iframe.detachEvent("onload", b.onloadHandler);
					}
				}

				domAttr.remove(node, attrName);
				delete this._bindings[bid];
			}
		},

		_scheduleOpen: function(delegatedTarget, iframe, coords, target){
			// summary:
			//		Set timer to display myself.  Using a timer rather than displaying immediately solves
			//		IE problem: without the delay, focus work in "open" causes the system
			//		context menu to appear in spite of evt.preventDefault().
			// delegatedTarget: Element
			//		The node specified in targetNodeIds or matching selector that the menu is being opened for.
			// iframe: HTMLIframeElement?
			//		Set if target is inside the specified iframe.
			// coords: Object
			//		x/y position to center the menu around.  Undefined if menu was opened via keyboard.
			// target: Element
			//		The actual clicked node, either delegatedTarget or a descendant.

			if(!this._openTimer){
				this._openTimer = this.defer(function(){
					delete this._openTimer;
					this._openMyself({
						target: target,
						delegatedTarget: delegatedTarget,
						iframe: iframe,
						coords: coords
					});
				}, 1);
			}
		},

		_openMyself: function(args){
			// summary:
			//		Internal function for opening myself when the user does a right-click or something similar.
			// args:
			//		This is an Object containing:
			//
			//		- target: The node that is being clicked.
			//		- delegatedTarget: The node from this.targetNodeIds or matching this.selector,
			//		  either the same as target or an ancestor of target.
			//		- iframe: If an `<iframe>` is being clicked, iframe points to that iframe
			//		- coords: Mouse cursor x/y coordinates.  Null when opened via keyboard.
			//		  Put menu at specified position in iframe (if iframe specified) or otherwise in viewport.
			//
			//		_openMyself() formerly took the event object, and since various code references
			//		evt.target (after connecting to _openMyself()), using an Object for parameters
			//		(so that old code still works).

			var target = args.target,
				iframe = args.iframe,
				coords = args.coords,
				byKeyboard = !coords;

			// To be used by MenuItem event handlers to tell which node the menu was opened on
			this.currentTarget = args.delegatedTarget;

			// Get coordinates to open menu, either at specified (mouse) position or (if triggered via keyboard)
			// then near the node the menu is assigned to.
			if(coords){
				if(iframe){
					// Specified coordinates are on <body> node of an <iframe>, convert to match main document
					var ifc = domGeometry.position(iframe, true),
						window = this._iframeContentWindow(iframe),
						scroll = domGeometry.docScroll(window.document);

					var cs = domStyle.getComputedStyle(iframe),
						tp = domStyle.toPixelValue,
						left = (has("ie") && has("quirks") ? 0 : tp(iframe, cs.paddingLeft)) + (has("ie") && has("quirks") ? tp(iframe, cs.borderLeftWidth) : 0),
						top = (has("ie") && has("quirks") ? 0 : tp(iframe, cs.paddingTop)) + (has("ie") && has("quirks") ? tp(iframe, cs.borderTopWidth) : 0);

					coords.x += ifc.x + left - scroll.x;
					coords.y += ifc.y + top - scroll.y;
				}
			}else{
				coords = domGeometry.position(target, true);
				coords.x += 10;
				coords.y += 10;
			}

			var self = this;
			var prevFocusNode = this._focusManager.get("prevNode");
			var curFocusNode = this._focusManager.get("curNode");
			var savedFocusNode = !curFocusNode || (dom.isDescendant(curFocusNode, this.domNode)) ? prevFocusNode : curFocusNode;

			function closeAndRestoreFocus(){
				// user has clicked on a menu or popup
				if(self.refocus && savedFocusNode){
					savedFocusNode.focus();
				}
				pm.close(self);
			}

			pm.open({
				popup: this,
				x: coords.x,
				y: coords.y,
				onExecute: closeAndRestoreFocus,
				onCancel: closeAndRestoreFocus,
				orient: this.isLeftToRight() ? 'L' : 'R'
			});

			// Focus the menu even when opened by mouse, so that a click on blank area of screen will close it
			this.focus();
			if(!byKeyboard){
				// But then (when opened by mouse), mark Menu as passive, so that the first item isn't highlighted.
				// On IE9+ this needs to be on a delay because the focus is asynchronous.
				this.defer(function(){
					this._cleanUp(true);
				});
			}

			this._onBlur = function(){
				this.inherited('_onBlur', arguments);
				// Usually the parent closes the child widget but if this is a context
				// menu then there is no parent
				pm.close(this);
				// don't try to restore focus; user has clicked another part of the screen
				// and set focus there
			};
		},

		destroy: function(){
			array.forEach(this._bindings, function(b){
				if(b){
					this.unBindDomNode(b.node);
				}
			}, this);
			this.inherited(arguments);
		}
	});
});

},
'dijit/DropDownMenu':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/keys", // keys
	"dojo/text!./templates/Menu.html",
	"./_MenuBase"
], function(declare, keys, template, _MenuBase){

	// module:
	//		dijit/DropDownMenu

	return declare("dijit.DropDownMenu", _MenuBase, {
		// summary:
		//		A menu, without features for context menu (Meaning, drop down menu)

		templateString: template,

		baseClass: "dijitMenu",

		// Arrow key navigation
		_onUpArrow: function(){
			this.focusPrev();
		},
		_onDownArrow: function(){
			this.focusNext();
		},
		_onRightArrow: function(/*Event*/ evt){
			this._moveToPopup(evt);
			evt.stopPropagation();
			evt.preventDefault();
		},
		_onLeftArrow: function(/*Event*/ evt){
			if(this.parentMenu){
				if(this.parentMenu._isMenuBar){
					this.parentMenu.focusPrev();
				}else{
					this.onCancel(false);
				}
			}else{
				evt.stopPropagation();
				evt.preventDefault();
			}
		}
	});
});

},
'dijit/_MenuBase':function(){
define([
	"dojo/_base/array", // array.indexOf
	"dojo/_base/declare", // declare
	"dojo/dom", // dom.isDescendant domClass.replace
	"dojo/dom-attr",
	"dojo/dom-class", // domClass.replace
	"dojo/_base/lang", // lang.hitch
	"dojo/mouse", // mouse.enter, mouse.leave
	"dojo/on",
	"dojo/window",
	"./a11yclick",
	"./registry",
	"./_Widget",
	"./_CssStateMixin",
	"./_KeyNavContainer",
	"./_TemplatedMixin"
], function(array, declare, dom, domAttr, domClass, lang, mouse, on, winUtils, a11yclick,
			registry, _Widget, _CssStateMixin, _KeyNavContainer, _TemplatedMixin){

	// module:
	//		dijit/_MenuBase

	return declare("dijit._MenuBase", [_Widget, _TemplatedMixin, _KeyNavContainer, _CssStateMixin], {
		// summary:
		//		Abstract base class for Menu and MenuBar.
		//		Subclass should implement _onUpArrow(), _onDownArrow(), _onLeftArrow(), and _onRightArrow().

		// selected: dijit/MenuItem
		//		Currently selected (a.k.a. highlighted) MenuItem, or null if no MenuItem is selected.
		//		If a submenu is open, will be set to MenuItem that displayed the submenu.   OTOH, if
		//		this Menu is in passive mode (i.e. hasn't been clicked yet), will be null, because
		//		"selected" is not merely "hovered".
		selected: null,
		_setSelectedAttr: function(item){
			if(this.selected != item){
				if(this.selected){
					this.selected._setSelected(false);
					this._onChildDeselect(this.selected);
				}
				if(item){
					item._setSelected(true);
				}
				this._set("selected", item);
			}
		},

		// activated: [readonly] Boolean
		//		This Menu has been clicked (mouse or via space/arrow key) or opened as a submenu,
		//		so mere mouseover will open submenus.  Focusing a menu via TAB does NOT automatically make it active
		//		since TAB is a navigation operation and not a selection one.
		//		For Windows apps, pressing the ALT key focuses the menubar menus (similar to TAB navigation) but the
		//		menu is not active (ie no dropdown) until an item is clicked.
		activated: false,
		_setActivatedAttr: function(val){
			domClass.toggle(this.domNode, "dijitMenuActive", val);
			domClass.toggle(this.domNode, "dijitMenuPassive", !val);
			this._set("activated", val);
		},

		// parentMenu: [readonly] Widget
		//		pointer to menu that displayed me
		parentMenu: null,

		// popupDelay: Integer
		//		After a menu has been activated (by clicking on it etc.), number of milliseconds before hovering
		//		(without clicking) another MenuItem causes that MenuItem's popup to automatically open.
		popupDelay: 500,

		// passivePopupDelay: Integer
		//		For a passive (unclicked) Menu, number of milliseconds before hovering (without clicking) will cause
		//		the popup to open.  Default is Infinity, meaning you need to click the menu to open it.
		passivePopupDelay: Infinity,

		// autoFocus: Boolean
		//		A toggle to control whether or not a Menu gets focused when opened as a drop down from a MenuBar
		//		or DropDownButton/ComboButton.   Note though that it always get focused when opened via the keyboard.
		autoFocus: false,

		childSelector: function(/*DOMNode*/ node){
			// summary:
			//		Selector (passed to on.selector()) used to identify MenuItem child widgets, but exclude inert children
			//		like MenuSeparator.  If subclass overrides to a string (ex: "> *"), the subclass must require dojo/query.
			// tags:
			//		protected

			var widget = registry.byNode(node);
			return node.parentNode == this.containerNode && widget && widget.focus;
		},

		postCreate: function(){
			var self = this,
				matches = typeof this.childSelector == "string" ? this.childSelector : lang.hitch(this, "childSelector");
			this.own(
				on(this.containerNode, on.selector(matches, mouse.enter), function(){
					self.onItemHover(registry.byNode(this));
				}),
				on(this.containerNode, on.selector(matches, mouse.leave), function(){
					self.onItemUnhover(registry.byNode(this));
				}),
				on(this.containerNode, on.selector(matches, a11yclick), function(evt){
					self.onItemClick(registry.byNode(this), evt);
					evt.stopPropagation();
				}),
				on(this.containerNode, on.selector(matches, "focusin"), function(){
					self._onItemFocus(registry.byNode(this));
				})
			);
			this.inherited(arguments);
		},

		onKeyboardSearch: function(/*MenuItem*/ item, /*Event*/ evt, /*String*/ searchString, /*Number*/ numMatches){
			// summary:
			//		Attach point for notification about when a menu item has been searched for
			//		via the keyboard search mechanism.
			// tags:
			//		protected
			this.inherited(arguments);
			if(!!item && (numMatches == -1 || (!!item.popup && numMatches == 1))){
				this.onItemClick(item, evt);
			}
		},

		_keyboardSearchCompare: function(/*dijit/_WidgetBase*/ item, /*String*/ searchString){
			// summary:
			//		Compares the searchString to the widget's text label, returning:
			//		-1: a high priority match and stop searching
			//		 0: no match
			//		 1: a match but keep looking for a higher priority match
			// tags:
			//		private
			if(!!item.shortcutKey){
				// accessKey matches have priority
				return searchString == item.shortcutKey.toLowerCase() ? -1 : 0;
			}
			return this.inherited(arguments) ? 1 : 0; // change return value of -1 to 1 so that searching continues
		},

		onExecute: function(){
			// summary:
			//		Attach point for notification about when a menu item has been executed.
			//		This is an internal mechanism used for Menus to signal to their parent to
			//		close them, because they are about to execute the onClick handler.  In
			//		general developers should not attach to or override this method.
			// tags:
			//		protected
		},

		onCancel: function(/*Boolean*/ /*===== closeAll =====*/){
			// summary:
			//		Attach point for notification about when the user cancels the current menu
			//		This is an internal mechanism used for Menus to signal to their parent to
			//		close them.  In general developers should not attach to or override this method.
			// tags:
			//		protected
		},

		_moveToPopup: function(/*Event*/ evt){
			// summary:
			//		This handles the right arrow key (left arrow key on RTL systems),
			//		which will either open a submenu, or move to the next item in the
			//		ancestor MenuBar
			// tags:
			//		private

			if(this.focusedChild && this.focusedChild.popup && !this.focusedChild.disabled){
				this.onItemClick(this.focusedChild, evt);
			}else{
				var topMenu = this._getTopMenu();
				if(topMenu && topMenu._isMenuBar){
					topMenu.focusNext();
				}
			}
		},

		_onPopupHover: function(/*Event*/ /*===== evt =====*/){
			// summary:
			//		This handler is called when the mouse moves over the popup.
			// tags:
			//		private

			// if the mouse hovers over a menu popup that is in pending-close state,
			// then stop the close operation.
			// This can't be done in onItemHover since some popup targets don't have MenuItems (e.g. ColorPicker)

			// highlight the parent menu item pointing to this popup (in case user temporarily moused over another MenuItem)
			this.set("selected", this.currentPopupItem);

			// cancel the pending close (if there is one) (in case user temporarily moused over another MenuItem)
			this._stopPendingCloseTimer();
		},

		onItemHover: function(/*MenuItem*/ item){
			// summary:
			//		Called when cursor is over a MenuItem.
			// tags:
			//		protected

			// Don't do anything unless user has "activated" the menu by:
			//		1) clicking it
			//		2) opening it from a parent menu (which automatically activates it)

			if(this.activated){
				this.set("selected", item);
				if(item.popup && !item.disabled && !this.hover_timer){
					this.hover_timer = this.defer(function(){
						this._openItemPopup(item);
					}, this.popupDelay);
				}
			}else if(this.passivePopupDelay < Infinity){
				if(this.passive_hover_timer){
					this.passive_hover_timer.remove();
				}
				this.passive_hover_timer = this.defer(function(){
					this.onItemClick(item, {type: "click"});
				}, this.passivePopupDelay);
			}

			this._hoveredChild = item;

			item._set("hovering", true);
		},

		_onChildDeselect: function(item){
			// summary:
			//		Called when a child MenuItem becomes deselected.   Setup timer to close its popup.

			this._stopPopupTimer();

			// Setup timer to close all popups that are open and descendants of this menu.
			// Will be canceled if user quickly moves the mouse over the popup.
			if(this.currentPopupItem == item){
				this._stopPendingCloseTimer();
				this._pendingClose_timer = this.defer(function(){
					this._pendingClose_timer = null;
					this.currentPopupItem = null;
					item._closePopup(); // this calls onClose
				}, this.popupDelay);
			}
		},

		onItemUnhover: function(/*MenuItem*/ item){
			// summary:
			//		Callback fires when mouse exits a MenuItem
			// tags:
			//		protected

			if(this._hoveredChild == item){
				this._hoveredChild = null;
			}

			if(this.passive_hover_timer){
				this.passive_hover_timer.remove();
				this.passive_hover_timer = null;
			}

			item._set("hovering", false);
		},

		_stopPopupTimer: function(){
			// summary:
			//		Cancels the popup timer because the user has stop hovering
			//		on the MenuItem, etc.
			// tags:
			//		private

			if(this.hover_timer){
				this.hover_timer = this.hover_timer.remove();
			}
		},

		_stopPendingCloseTimer: function(){
			// summary:
			//		Cancels the pending-close timer because the close has been preempted
			// tags:
			//		private
			if(this._pendingClose_timer){
				this._pendingClose_timer = this._pendingClose_timer.remove();
			}
		},

		_getTopMenu: function(){
			// summary:
			//		Returns the top menu in this chain of Menus
			// tags:
			//		private
			for(var top = this; top.parentMenu; top = top.parentMenu){}
			return top;
		},

		onItemClick: function(/*dijit/_WidgetBase*/ item, /*Event*/ evt){
			// summary:
			//		Handle clicks on an item.
			// tags:
			//		private

			if(this.passive_hover_timer){
				this.passive_hover_timer.remove();
			}

			this.focusChild(item);

			if(item.disabled){
				return false;
			}

			if(item.popup){
				this.set("selected", item);
				this.set("activated", true);
				var byKeyboard = /^key/.test(evt._origType || evt.type) ||
					(evt.clientX == 0 && evt.clientY == 0);	// detects accessKey like ALT+SHIFT+F, where type is "click"
				this._openItemPopup(item, byKeyboard);
			}else{
				// before calling user defined handler, close hierarchy of menus
				// and restore focus to place it was when menu was opened
				this.onExecute();

				// user defined handler for click
				item._onClick ? item._onClick(evt) : item.onClick(evt);
			}
		},

		_openItemPopup: function(/*dijit/MenuItem*/ from_item, /*Boolean*/ focus){
			// summary:
			//		Open the popup to the side of/underneath the current menu item, and optionally focus first item
			// tags:
			//		protected

			if(from_item == this.currentPopupItem){
				// Specified popup is already being shown, so just return
				return;
			}
			if(this.currentPopupItem){
				// If another popup is currently shown, then close it
				this._stopPendingCloseTimer();
				this.currentPopupItem._closePopup();
			}
			this._stopPopupTimer();

			var popup = from_item.popup;
			popup.parentMenu = this;

			// detect mouseover of the popup to handle lazy mouse movements that temporarily focus other menu items\c
			this.own(this._mouseoverHandle = on.once(popup.domNode, "mouseover", lang.hitch(this, "_onPopupHover")));

			var self = this;
			from_item._openPopup({
				parent: this,
				orient: this._orient || ["after", "before"],
				onCancel: function(){ // called when the child menu is canceled
					if(focus){
						// put focus back on my node before focused node is hidden
						self.focusChild(from_item);
					}

					// close the submenu (be sure this is done _after_ focus is moved)
					self._cleanUp();
				},
				onExecute: lang.hitch(this, "_cleanUp", true),
				onClose: function(){
					// Remove handler created by onItemHover
					if(self._mouseoverHandle){
						self._mouseoverHandle.remove();
						delete self._mouseoverHandle;
					}
				}
			}, focus);

			this.currentPopupItem = from_item;

			// TODO: focusing a popup should clear tabIndex on Menu (and it's child MenuItems), so that neither
			// TAB nor SHIFT-TAB returns to the menu.  Only ESC or ENTER should return to the menu.
		},

		onOpen: function(/*Event*/ /*===== e =====*/){
			// summary:
			//		Callback when this menu is opened.
			//		This is called by the popup manager as notification that the menu
			//		was opened.
			// tags:
			//		private

			this.isShowingNow = true;
			this.set("activated", true);
		},

		onClose: function(){
			// summary:
			//		Callback when this menu is closed.
			//		This is called by the popup manager as notification that the menu
			//		was closed.
			// tags:
			//		private

			this.set("activated", false);
			this.set("selected", null);
			this.isShowingNow = false;
			this.parentMenu = null;
		},

		_closeChild: function(){
			// summary:
			//		Called when submenu is clicked or focus is lost.  Close hierarchy of menus.
			// tags:
			//		private
			this._stopPopupTimer();

			if(this.currentPopupItem){
				// If focus is on a descendant MenuItem then move focus to me,
				// because IE doesn't like it when you display:none a node with focus,
				// and also so keyboard users don't lose control.
				// Likely, immediately after a user defined onClick handler will move focus somewhere
				// else, like a Dialog.
				if(this.focused){
					domAttr.set(this.selected.focusNode, "tabIndex", this.tabIndex);
					this.selected.focusNode.focus();
				}

				// Close all popups that are open and descendants of this menu
				this.currentPopupItem._closePopup();
				this.currentPopupItem = null;
			}
		},

		_onItemFocus: function(/*MenuItem*/ item){
			// summary:
			//		Called when child of this Menu gets focus from:
			//
			//		1. clicking it
			//		2. tabbing into it
			//		3. being opened by a parent menu.
			//
			//		This is not called just from mouse hover.

			if(this._hoveredChild && this._hoveredChild != item){
				this.onItemUnhover(this._hoveredChild);	// any previous mouse movement is trumped by focus selection
			}
			this.set("selected", item);
		},

		_onBlur: function(){
			// summary:
			//		Called when focus is moved away from this Menu and it's submenus.
			// tags:
			//		protected

			this._cleanUp(true);
			this.inherited(arguments);
		},

		_cleanUp: function(/*Boolean*/ clearSelectedItem){
			// summary:
			//		Called when the user is done with this menu.  Closes hierarchy of menus.
			// tags:
			//		private

			this._closeChild(); // don't call this.onClose since that's incorrect for MenuBar's that never close
			if(typeof this.isShowingNow == 'undefined'){ // non-popup menu doesn't call onClose
				this.set("activated", false);
			}

			if(clearSelectedItem){
				this.set("selected", null);
			}
		}
	});
});

},
'dijit/_CssStateMixin':function(){
define([
	"dojo/_base/array", // array.forEach array.map
	"dojo/_base/declare", // declare
	"dojo/dom", // dom.isDescendant()
	"dojo/dom-class", // domClass.toggle
	"dojo/has",
	"dojo/_base/lang", // lang.hitch
	"dojo/on",
	"dojo/domReady",
	"dojo/touch",
	"dojo/_base/window", // win.body
	"./a11yclick",
	"./registry"
], function(array, declare, dom, domClass, has, lang, on, domReady, touch, win, a11yclick, registry){

	// module:
	//		dijit/_CssStateMixin

	var CssStateMixin = declare("dijit._CssStateMixin", [], {
		// summary:
		//		Mixin for widgets to set CSS classes on the widget DOM nodes depending on hover/mouse press/focus
		//		state changes, and also higher-level state changes such becoming disabled or selected.
		//
		// description:
		//		By mixing this class into your widget, and setting the this.baseClass attribute, it will automatically
		//		maintain CSS classes on the widget root node (this.domNode) depending on hover,
		//		active, focus, etc. state.   Ex: with a baseClass of dijitButton, it will apply the classes
		//		dijitButtonHovered and dijitButtonActive, as the user moves the mouse over the widget and clicks it.
		//
		//		It also sets CSS like dijitButtonDisabled based on widget semantic state.
		//
		//		By setting the cssStateNodes attribute, a widget can also track events on subnodes (like buttons
		//		within the widget).

		/*=====
		 // cssStateNodes: [protected] Object
		 //		Subclasses may define a cssStateNodes property that lists sub-nodes within the widget that
		 //		need CSS classes applied on mouse hover/press and focus.
		 //
		 //		Each entry in this optional hash is a an attach-point name (like "upArrowButton") mapped to a CSS class name
		 //		(like "dijitUpArrowButton"). Example:
		 //	|		{
		 //	|			"upArrowButton": "dijitUpArrowButton",
		 //	|			"downArrowButton": "dijitDownArrowButton"
		 //	|		}
		 //		The above will set the CSS class dijitUpArrowButton to the this.upArrowButton DOMNode when it
		 //		is hovered, etc.
		 cssStateNodes: {},
		 =====*/

		// hovering: [readonly] Boolean
		//		True if cursor is over this widget
		hovering: false,

		// active: [readonly] Boolean
		//		True if mouse was pressed while over this widget, and hasn't been released yet
		active: false,

		_applyAttributes: function(){
			// This code would typically be in postCreate(), but putting in _applyAttributes() for
			// performance: so the class changes happen before DOM is inserted into the document.
			// Change back to postCreate() in 2.0.  See #11635.

			this.inherited(arguments);

			// Monitoring changes to disabled, readonly, etc. state, and update CSS class of root node
			array.forEach(["disabled", "readOnly", "checked", "selected", "focused", "state", "hovering", "active", "_opened"], function(attr){
				this.watch(attr, lang.hitch(this, "_setStateClass"));
			}, this);

			// Track hover and active mouse events on widget root node, plus possibly on subnodes
			for(var ap in this.cssStateNodes || {}){
				this._trackMouseState(this[ap], this.cssStateNodes[ap]);
			}
			this._trackMouseState(this.domNode, this.baseClass);

			// Set state initially; there's probably no hover/active/focus state but widget might be
			// disabled/readonly/checked/selected so we want to set CSS classes for those conditions.
			this._setStateClass();
		},

		_cssMouseEvent: function(/*Event*/ event){
			// summary:
			//		Handler for CSS event on this.domNode. Sets hovering and active properties depending on mouse state,
			//		which triggers _setStateClass() to set appropriate CSS classes for this.domNode.

			if(!this.disabled){
				switch(event.type){
					case "mouseover":
					case "MSPointerOver":
					case "pointerover":
						this._set("hovering", true);
						this._set("active", this._mouseDown);
						break;
					case "mouseout":
					case "MSPointerOut":
					case "pointerout":
						this._set("hovering", false);
						this._set("active", false);
						break;
					case "mousedown":
					case "touchstart":
					case "MSPointerDown":
					case "pointerdown":
					case "keydown":
						this._set("active", true);
						break;
					case "mouseup":
					case "dojotouchend":
					case "MSPointerUp":
					case "pointerup":
					case "keyup":
						this._set("active", false);
						break;
				}
			}
		},

		_setStateClass: function(){
			// summary:
			//		Update the visual state of the widget by setting the css classes on this.domNode
			//		(or this.stateNode if defined) by combining this.baseClass with
			//		various suffixes that represent the current widget state(s).
			//
			// description:
			//		In the case where a widget has multiple
			//		states, it sets the class based on all possible
			//		combinations.  For example, an invalid form widget that is being hovered
			//		will be "dijitInput dijitInputInvalid dijitInputHover dijitInputInvalidHover".
			//
			//		The widget may have one or more of the following states, determined
			//		by this.state, this.checked, this.valid, and this.selected:
			//
			//		- Error - ValidationTextBox sets this.state to "Error" if the current input value is invalid
			//		- Incomplete - ValidationTextBox sets this.state to "Incomplete" if the current input value is not finished yet
			//		- Checked - ex: a checkmark or a ToggleButton in a checked state, will have this.checked==true
			//		- Selected - ex: currently selected tab will have this.selected==true
			//
			//		In addition, it may have one or more of the following states,
			//		based on this.disabled and flags set in _onMouse (this.active, this.hovering) and from focus manager (this.focused):
			//
			//		- Disabled	- if the widget is disabled
			//		- Active		- if the mouse (or space/enter key?) is being pressed down
			//		- Focused		- if the widget has focus
			//		- Hover		- if the mouse is over the widget

			// Compute new set of classes
			var newStateClasses = this.baseClass.split(" ");

			function multiply(modifier){
				newStateClasses = newStateClasses.concat(array.map(newStateClasses, function(c){
					return c + modifier;
				}), "dijit" + modifier);
			}

			if(!this.isLeftToRight()){
				// For RTL mode we need to set an addition class like dijitTextBoxRtl.
				multiply("Rtl");
			}

			var checkedState = this.checked == "mixed" ? "Mixed" : (this.checked ? "Checked" : "");
			if(this.checked){
				multiply(checkedState);
			}
			if(this.state){
				multiply(this.state);
			}
			if(this.selected){
				multiply("Selected");
			}
			if(this._opened){
				multiply("Opened");
			}

			if(this.disabled){
				multiply("Disabled");
			}else if(this.readOnly){
				multiply("ReadOnly");
			}else{
				if(this.active){
					multiply("Active");
				}else if(this.hovering){
					multiply("Hover");
				}
			}

			if(this.focused){
				multiply("Focused");
			}

			// Remove old state classes and add new ones.
			// For performance concerns we only write into domNode.className once.
			var tn = this.stateNode || this.domNode,
				classHash = {};	// set of all classes (state and otherwise) for node

			array.forEach(tn.className.split(" "), function(c){
				classHash[c] = true;
			});

			if("_stateClasses" in this){
				array.forEach(this._stateClasses, function(c){
					delete classHash[c];
				});
			}

			array.forEach(newStateClasses, function(c){
				classHash[c] = true;
			});

			var newClasses = [];
			for(var c in classHash){
				newClasses.push(c);
			}
			tn.className = newClasses.join(" ");

			this._stateClasses = newStateClasses;
		},

		_subnodeCssMouseEvent: function(node, clazz, evt){
			// summary:
			//		Handler for hover/active mouse event on widget's subnode
			if(this.disabled || this.readOnly){
				return;
			}

			function hover(isHovering){
				domClass.toggle(node, clazz + "Hover", isHovering);
			}

			function active(isActive){
				domClass.toggle(node, clazz + "Active", isActive);
			}

			function focused(isFocused){
				domClass.toggle(node, clazz + "Focused", isFocused);
			}

			switch(evt.type){
				case "mouseover":
				case "MSPointerOver":
				case "pointerover":
					hover(true);
					break;
				case "mouseout":
				case "MSPointerOut":
				case "pointerout":
					hover(false);
					active(false);
					break;
				case "mousedown":
				case "touchstart":
				case "MSPointerDown":
				case "pointerdown":
				case "keydown":
					active(true);
					break;
				case "mouseup":
				case "MSPointerUp":
				case "pointerup":
				case "dojotouchend":
				case "keyup":
					active(false);
					break;
				case "focus":
				case "focusin":
					focused(true);
					break;
				case "blur":
				case "focusout":
					focused(false);
					break;
			}
		},

		_trackMouseState: function(/*DomNode*/ node, /*String*/ clazz){
			// summary:
			//		Track mouse/focus events on specified node and set CSS class on that node to indicate
			//		current state.   Usually not called directly, but via cssStateNodes attribute.
			// description:
			//		Given class=foo, will set the following CSS class on the node
			//
			//		- fooActive: if the user is currently pressing down the mouse button while over the node
			//		- fooHover: if the user is hovering the mouse over the node, but not pressing down a button
			//		- fooFocus: if the node is focused
			//
			//		Note that it won't set any classes if the widget is disabled.
			// node: DomNode
			//		Should be a sub-node of the widget, not the top node (this.domNode), since the top node
			//		is handled specially and automatically just by mixing in this class.
			// clazz: String
			//		CSS class name (ex: dijitSliderUpArrow)

			// Flag for listener code below to call this._cssMouseEvent() or this._subnodeCssMouseEvent()
			// when node is hovered/active
			node._cssState = clazz;
		}
	});

	domReady(function(){
		// Document level listener to catch hover etc. events on widget root nodes and subnodes.
		// Note that when the mouse is moved quickly, a single onmouseenter event could signal that multiple widgets
		// have been hovered or unhovered (try test_Accordion.html)

		function pointerHandler(evt, target, relatedTarget){
			// Handler for mouseover, mouseout, a11yclick.press and a11click.release events

			// Poor man's event propagation.  Don't propagate event to ancestors of evt.relatedTarget,
			// to avoid processing mouseout events moving from a widget's domNode to a descendant node;
			// such events shouldn't be interpreted as a mouseleave on the widget.
			if(relatedTarget && dom.isDescendant(relatedTarget, target)){
				return;
			}

			for(var node = target; node && node != relatedTarget; node = node.parentNode){
				// Process any nodes with _cssState property.   They are generally widget root nodes,
				// but could also be sub-nodes within a widget
				if(node._cssState){
					var widget = registry.getEnclosingWidget(node);
					if(widget){
						if(node == widget.domNode){
							// event on the widget's root node
							widget._cssMouseEvent(evt);
						}else{
							// event on widget's sub-node
							widget._subnodeCssMouseEvent(node, node._cssState, evt);
						}
					}
				}
			}
		}

		var body = win.body(), activeNode;

		// Handle pointer related events (i.e. mouse or touch)
		on(body, touch.over, function(evt){
			// Using touch.over rather than mouseover mainly to ignore phantom mouse events on iOS.
			pointerHandler(evt, evt.target, evt.relatedTarget);
		});
		on(body, touch.out, function(evt){
			// Using touch.out rather than mouseout mainly to ignore phantom mouse events on iOS.
			pointerHandler(evt, evt.target, evt.relatedTarget);
		});
		on(body, a11yclick.press, function(evt){
			// Save the a11yclick.press target to reference when the a11yclick.release comes.
			activeNode = evt.target;
			pointerHandler(evt, activeNode)
		});
		on(body, a11yclick.release, function(evt){
			// The release event could come on a separate node than the press event, if for example user slid finger.
			// Reference activeNode to reset the state of the node that got state set in the a11yclick.press handler.
			pointerHandler(evt, activeNode);
			activeNode = null;
		});

		// Track focus events on widget sub-nodes that have been registered via _trackMouseState().
		// However, don't track focus events on the widget root nodes, because focus is tracked via the
		// focus manager (and it's not really tracking focus, but rather tracking that focus is on one of the widget's
		// nodes or a subwidget's node or a popup node, etc.)
		// Remove for 2.0 (if focus CSS needed, just use :focus pseudo-selector).
		on(body, "focusin, focusout", function(evt){
			var node = evt.target;
			if(node._cssState && !node.getAttribute("widgetId")){
				var widget = registry.getEnclosingWidget(node);
				if(widget){
					widget._subnodeCssMouseEvent(node, node._cssState, evt);
				}
			}
		});
	});

	return CssStateMixin;
});

},
'dijit/_KeyNavContainer':function(){
define([
	"dojo/_base/array", // array.forEach
	"dojo/_base/declare", // declare
	"dojo/dom-attr", // domAttr.set
	"dojo/_base/kernel", // kernel.deprecated
	"dojo/keys", // keys.END keys.HOME
	"dojo/_base/lang", // lang.hitch
	"./registry",
	"./_Container",
	"./_FocusMixin",
	"./_KeyNavMixin"
], function(array, declare, domAttr, kernel, keys, lang, registry, _Container, _FocusMixin, _KeyNavMixin){


	// module:
	//		dijit/_KeyNavContainer

	return declare("dijit._KeyNavContainer", [_FocusMixin, _KeyNavMixin, _Container], {
		// summary:
		//		A _Container with keyboard navigation of its children.
		// description:
		//		Provides normalized keyboard and focusing code for Container widgets.
		//		To use this mixin, call connectKeyNavHandlers() in postCreate().
		//		Also, child widgets must implement a focus() method.

		connectKeyNavHandlers: function(/*keys[]*/ prevKeyCodes, /*keys[]*/ nextKeyCodes){
			// summary:
			//		Deprecated.  You can call this in postCreate() to attach the keyboard handlers to the container,
			//		but the preferred method is to override _onLeftArrow() and _onRightArrow(), or
			//		_onUpArrow() and _onDownArrow(), to call focusPrev() and focusNext().
			// prevKeyCodes: keys[]
			//		Key codes for navigating to the previous child.
			// nextKeyCodes: keys[]
			//		Key codes for navigating to the next child.
			// tags:
			//		protected

			// TODO: remove for 2.0, and make subclasses override _onLeftArrow, _onRightArrow etc. instead.

			var keyCodes = (this._keyNavCodes = {});
			var prev = lang.hitch(this, "focusPrev");
			var next = lang.hitch(this, "focusNext");
			array.forEach(prevKeyCodes, function(code){
				keyCodes[code] = prev;
			});
			array.forEach(nextKeyCodes, function(code){
				keyCodes[code] = next;
			});
			keyCodes[keys.HOME] = lang.hitch(this, "focusFirstChild");
			keyCodes[keys.END] = lang.hitch(this, "focusLastChild");
		},

		startupKeyNavChildren: function(){
			kernel.deprecated("startupKeyNavChildren() call no longer needed", "", "2.0");
		},

		startup: function(){
			this.inherited(arguments);
			array.forEach(this.getChildren(), lang.hitch(this, "_startupChild"));
		},

		addChild: function(/*dijit/_WidgetBase*/ widget, /*int?*/ insertIndex){
			this.inherited(arguments);
			this._startupChild(widget);
		},

		_startupChild: function(/*dijit/_WidgetBase*/ widget){
			// summary:
			//		Setup for each child widget.
			// description:
			//		Sets tabIndex=-1 on each child, so that the tab key will
			//		leave the container rather than visiting each child.
			//
			//		Note: if you add children by a different method than addChild(), then need to call this manually
			//		or at least make sure the child's tabIndex is -1.
			//
			//		Note: see also _LayoutWidget.setupChild(), which is also called for each child widget.
			// tags:
			//		private

			widget.set("tabIndex", "-1");
		},

		_getFirst: function(){
			// summary:
			//		Returns the first child.
			// tags:
			//		abstract extension
			var children = this.getChildren();
			return children.length ? children[0] : null;
		},

		_getLast: function(){
			// summary:
			//		Returns the last descendant.
			// tags:
			//		abstract extension
			var children = this.getChildren();
			return children.length ? children[children.length - 1] : null;
		},

		focusNext: function(){
			// summary:
			//		Focus the next widget
			// tags:
			//		protected
			this.focusChild(this._getNextFocusableChild(this.focusedChild, 1));
		},

		focusPrev: function(){
			// summary:
			//		Focus the last focusable node in the previous widget
			//		(ex: go to the ComboButton icon section rather than button section)
			// tags:
			//		protected
			this.focusChild(this._getNextFocusableChild(this.focusedChild, -1), true);
		},

		childSelector: function(/*DOMNode*/ node){
			// Implement _KeyNavMixin.childSelector, to identify focusable child nodes.
			// If we allowed a dojo/query dependency from this module this could more simply be a string "> *"
			// instead of this function.

			var node = registry.byNode(node);
			return node && node.getParent() == this;
		}
	});
});

},
'dijit/_KeyNavMixin':function(){
define([
	"dojo/_base/array", // array.forEach
	"dojo/_base/declare", // declare
	"dojo/dom-attr", // domAttr.set
	"dojo/keys", // keys.END keys.HOME, keys.LEFT_ARROW etc.
	"dojo/_base/lang", // lang.hitch
	"dojo/on",
	"dijit/registry",
	"dijit/_FocusMixin"        // to make _onBlur() work
], function(array, declare, domAttr, keys, lang, on, registry, _FocusMixin){

	// module:
	//		dijit/_KeyNavMixin

	return declare("dijit._KeyNavMixin", _FocusMixin, {
		// summary:
		//		A mixin to allow arrow key and letter key navigation of child or descendant widgets.
		//		It can be used by dijit/_Container based widgets with a flat list of children,
		//		or more complex widgets like dijit/Tree.
		//
		//		To use this mixin, the subclass must:
		//
		//			- Implement  _getNext(), _getFirst(), _getLast(), _onLeftArrow(), _onRightArrow()
		//			  _onDownArrow(), _onUpArrow() methods to handle home/end/left/right/up/down keystrokes.
		//			  Next and previous in this context refer to a linear ordering of the descendants used
		//			  by letter key search.
		//			- Set all descendants' initial tabIndex to "-1"; both initial descendants and any
		//			  descendants added later, by for example addChild()
		//			- Define childSelector to a function or string that identifies focusable descendant widgets
		//
		//		Also, child widgets must implement a focus() method.

		/*=====
		 // focusedChild: [protected readonly] Widget
		 //		The currently focused child widget, or null if there isn't one
		 focusedChild: null,

		 // _keyNavCodes: Object
		 //		Hash mapping key code (arrow keys and home/end key) to functions to handle those keys.
		 //		Usually not used directly, as subclasses can instead override _onLeftArrow() etc.
		 _keyNavCodes: {},
		 =====*/

		// tabIndex: String
		//		Tab index of the container; same as HTML tabIndex attribute.
		//		Note then when user tabs into the container, focus is immediately
		//		moved to the first item in the container.
		tabIndex: "0",

		// childSelector: [protected abstract] Function||String
		//		Selector (passed to on.selector()) used to identify what to treat as a child widget.   Used to monitor
		//		focus events and set this.focusedChild.   Must be set by implementing class.   If this is a string
		//		(ex: "> *") then the implementing class must require dojo/query.
		childSelector: null,

		postCreate: function(){
			this.inherited(arguments);

			// Set tabIndex on this.domNode.  Will be automatic after #7381 is fixed.
			domAttr.set(this.domNode, "tabIndex", this.tabIndex);

			if(!this._keyNavCodes){
				var keyCodes = this._keyNavCodes = {};
				keyCodes[keys.HOME] = lang.hitch(this, "focusFirstChild");
				keyCodes[keys.END] = lang.hitch(this, "focusLastChild");
				keyCodes[this.isLeftToRight() ? keys.LEFT_ARROW : keys.RIGHT_ARROW] = lang.hitch(this, "_onLeftArrow");
				keyCodes[this.isLeftToRight() ? keys.RIGHT_ARROW : keys.LEFT_ARROW] = lang.hitch(this, "_onRightArrow");
				keyCodes[keys.UP_ARROW] = lang.hitch(this, "_onUpArrow");
				keyCodes[keys.DOWN_ARROW] = lang.hitch(this, "_onDownArrow");
			}

			var self = this,
				childSelector = typeof this.childSelector == "string"
					? this.childSelector
					: lang.hitch(this, "childSelector");
			this.own(
				on(this.domNode, "keypress", lang.hitch(this, "_onContainerKeypress")),
				on(this.domNode, "keydown", lang.hitch(this, "_onContainerKeydown")),
				on(this.domNode, "focus", lang.hitch(this, "_onContainerFocus")),
				on(this.containerNode, on.selector(childSelector, "focusin"), function(evt){
					self._onChildFocus(registry.getEnclosingWidget(this), evt);
				})
			);
		},

		_onLeftArrow: function(){
			// summary:
			//		Called on left arrow key, or right arrow key if widget is in RTL mode.
			//		Should go back to the previous child in horizontal container widgets like Toolbar.
			// tags:
			//		extension
		},

		_onRightArrow: function(){
			// summary:
			//		Called on right arrow key, or left arrow key if widget is in RTL mode.
			//		Should go to the next child in horizontal container widgets like Toolbar.
			// tags:
			//		extension
		},

		_onUpArrow: function(){
			// summary:
			//		Called on up arrow key. Should go to the previous child in vertical container widgets like Menu.
			// tags:
			//		extension
		},

		_onDownArrow: function(){
			// summary:
			//		Called on down arrow key. Should go to the next child in vertical container widgets like Menu.
			// tags:
			//		extension
		},

		focus: function(){
			// summary:
			//		Default focus() implementation: focus the first child.
			this.focusFirstChild();
		},

		_getFirstFocusableChild: function(){
			// summary:
			//		Returns first child that can be focused.

			// Leverage _getNextFocusableChild() to skip disabled children
			return this._getNextFocusableChild(null, 1);	// dijit/_WidgetBase
		},

		_getLastFocusableChild: function(){
			// summary:
			//		Returns last child that can be focused.

			// Leverage _getNextFocusableChild() to skip disabled children
			return this._getNextFocusableChild(null, -1);	// dijit/_WidgetBase
		},

		focusFirstChild: function(){
			// summary:
			//		Focus the first focusable child in the container.
			// tags:
			//		protected

			this.focusChild(this._getFirstFocusableChild());
		},

		focusLastChild: function(){
			// summary:
			//		Focus the last focusable child in the container.
			// tags:
			//		protected

			this.focusChild(this._getLastFocusableChild());
		},

		focusChild: function(/*dijit/_WidgetBase*/ widget, /*Boolean*/ last){
			// summary:
			//		Focus specified child widget.
			// widget:
			//		Reference to container's child widget
			// last:
			//		If true and if widget has multiple focusable nodes, focus the
			//		last one instead of the first one
			// tags:
			//		protected

			if(!widget){
				return;
			}

			if(this.focusedChild && widget !== this.focusedChild){
				this._onChildBlur(this.focusedChild);	// used to be used by _MenuBase
			}
			widget.set("tabIndex", this.tabIndex);	// for IE focus outline to appear, must set tabIndex before focus
			widget.focus(last ? "end" : "start");

			// Don't set focusedChild here, because the focus event should trigger a call to _onChildFocus(), which will
			// set it.   More importantly, _onChildFocus(), which may be executed asynchronously (after this function
			// returns) needs to know the old focusedChild to set its tabIndex to -1.
		},

		_onContainerFocus: function(evt){
			// summary:
			//		Handler for when the container itself gets focus.
			// description:
			//		Initially the container itself has a tabIndex, but when it gets
			//		focus, switch focus to first child.
			//
			//		TODO for 2.0 (or earlier): Instead of having the container tabbable, always maintain a single child
			//		widget as tabbable, Requires code in startup(), addChild(), and removeChild().
			//		That would avoid various issues like #17347.
			// tags:
			//		private

			// Note that we can't use _onFocus() because switching focus from the
			// _onFocus() handler confuses the focus.js code
			// (because it causes _onFocusNode() to be called recursively).
			// Also, _onFocus() would fire when focus went directly to a child widget due to mouse click.

			// Ignore spurious focus events:
			//	1. focus on a child widget bubbles on FF
			//	2. on IE, clicking the scrollbar of a select dropdown moves focus from the focused child item to me
			if(evt.target !== this.domNode || this.focusedChild){
				return;
			}

			this.focus();
		},

		_onFocus: function(){
			// When the container gets focus by being tabbed into, or a descendant gets focus by being clicked,
			// set the container's tabIndex to -1 (don't remove as that breaks Safari 4) so that tab or shift-tab
			// will go to the fields after/before the container, rather than the container itself
			domAttr.set(this.domNode, "tabIndex", "-1");

			this.inherited(arguments);
		},

		_onBlur: function(evt){
			// When focus is moved away the container, and its descendant (popup) widgets,
			// then restore the container's tabIndex so that user can tab to it again.
			// Note that using _onBlur() so that this doesn't happen when focus is shifted
			// to one of my child widgets (typically a popup)

			// TODO: for 2.0 consider changing this to blur whenever the container blurs, to be truthful that there is
			// no focused child at that time.

			domAttr.set(this.domNode, "tabIndex", this.tabIndex);
			if(this.focusedChild){
				this.focusedChild.set("tabIndex", "-1");
				this.lastFocusedChild = this.focusedChild;
				this._set("focusedChild", null);
			}
			this.inherited(arguments);
		},

		_onChildFocus: function(/*dijit/_WidgetBase*/ child){
			// summary:
			//		Called when a child widget gets focus, either by user clicking
			//		it, or programatically by arrow key handling code.
			// description:
			//		It marks that the current node is the selected one, and the previously
			//		selected node no longer is.

			if(child && child != this.focusedChild){
				if(this.focusedChild && !this.focusedChild._destroyed){
					// mark that the previously focusable node is no longer focusable
					this.focusedChild.set("tabIndex", "-1");
				}

				// mark that the new node is the currently selected one
				child.set("tabIndex", this.tabIndex);
				this.lastFocused = child;		// back-compat for Tree, remove for 2.0
				this._set("focusedChild", child);
			}
		},

		_searchString: "",
		// multiCharSearchDuration: Number
		//		If multiple characters are typed where each keystroke happens within
		//		multiCharSearchDuration of the previous keystroke,
		//		search for nodes matching all the keystrokes.
		//
		//		For example, typing "ab" will search for entries starting with
		//		"ab" unless the delay between "a" and "b" is greater than multiCharSearchDuration.
		multiCharSearchDuration: 1000,

		onKeyboardSearch: function(/*dijit/_WidgetBase*/ item, /*Event*/ evt, /*String*/ searchString, /*Number*/ numMatches){
			// summary:
			//		When a key is pressed that matches a child item,
			//		this method is called so that a widget can take appropriate action is necessary.
			// tags:
			//		protected
			if(item){
				this.focusChild(item);
			}
		},

		_keyboardSearchCompare: function(/*dijit/_WidgetBase*/ item, /*String*/ searchString){
			// summary:
			//		Compares the searchString to the widget's text label, returning:
			//
			//			* -1: a high priority match  and stop searching
			//		 	* 0: not a match
			//		 	* 1: a match but keep looking for a higher priority match
			// tags:
			//		private

			var element = item.domNode,
				text = item.label || (element.focusNode ? element.focusNode.label : '') || element.innerText || element.textContent || "",
				currentString = text.replace(/^\s+/, '').substr(0, searchString.length).toLowerCase();

			return (!!searchString.length && currentString == searchString) ? -1 : 0; // stop searching after first match by default
		},

		_onContainerKeydown: function(evt){
			// summary:
			//		When a key is pressed, if it's an arrow key etc. then it's handled here.
			// tags:
			//		private

			var func = this._keyNavCodes[evt.keyCode];
			if(func){
				func(evt, this.focusedChild);
				evt.stopPropagation();
				evt.preventDefault();
				this._searchString = ''; // so a DOWN_ARROW b doesn't search for ab
			}else if(evt.keyCode == keys.SPACE && this._searchTimer && !(evt.ctrlKey || evt.altKey || evt.metaKey)){
				evt.stopImmediatePropagation(); // stop a11yclick and _HasDropdown from seeing SPACE if we're doing keyboard searching
				evt.preventDefault(); // stop IE from scrolling, and most browsers (except FF) from sending keypress
				this._keyboardSearch(evt, ' ');
			}
		},

		_onContainerKeypress: function(evt){
			// summary:
			//		When a printable key is pressed, it's handled here, searching by letter.
			// tags:
			//		private

			// Ignore:
			// 		- duplicate events on firefox (ex: arrow key that will be handled by keydown handler)
			//		- control sequences like CMD-Q.
			//		- the SPACE key (only occurs on FF)
			//
			// Note: if there's no search in progress, then SPACE should be ignored.   If there is a search
			// in progress, then SPACE is handled in _onContainerKeyDown.
			if(evt.charCode <= keys.SPACE || evt.ctrlKey || evt.altKey || evt.metaKey){
				return;
			}

			evt.preventDefault();
			evt.stopPropagation();

			this._keyboardSearch(evt, String.fromCharCode(evt.charCode).toLowerCase());
		},

		_keyboardSearch: function(/*Event*/ evt, /*String*/ keyChar){
			// summary:
			//		Perform a search of the widget's options based on the user's keyboard activity
			// description:
			//		Called on keypress (and sometimes keydown), searches through this widget's children
			//		looking for items that match the user's typed search string.  Multiple characters
			//		typed within 1 sec of each other are combined for multicharacter searching.
			// tags:
			//		private
			var
				matchedItem = null,
				searchString,
				numMatches = 0,
				search = lang.hitch(this, function(){
					if(this._searchTimer){
						this._searchTimer.remove();
					}
					this._searchString += keyChar;
					var allSameLetter = /^(.)\1*$/.test(this._searchString);
					var searchLen = allSameLetter ? 1 : this._searchString.length;
					searchString = this._searchString.substr(0, searchLen);
					// commented out code block to search again if the multichar search fails after a smaller timeout
					//this._searchTimer = this.defer(function(){ // this is the "failure" timeout
					//	this._typingSlowly = true; // if the search fails, then treat as a full timeout
					//	this._searchTimer = this.defer(function(){ // this is the "success" timeout
					//		this._searchTimer = null;
					//		this._searchString = '';
					//	}, this.multiCharSearchDuration >> 1);
					//}, this.multiCharSearchDuration >> 1);
					this._searchTimer = this.defer(function(){ // this is the "success" timeout
						this._searchTimer = null;
						this._searchString = '';
					}, this.multiCharSearchDuration);
					var currentItem = this.focusedChild || null;
					if(searchLen == 1 || !currentItem){
						currentItem = this._getNextFocusableChild(currentItem, 1); // skip current
						if(!currentItem){
							return;
						} // no items
					}
					var stop = currentItem;
					do{
						var rc = this._keyboardSearchCompare(currentItem, searchString);
						if(!!rc && numMatches++ == 0){
							matchedItem = currentItem;
						}
						if(rc == -1){ // priority match
							numMatches = -1;
							break;
						}
						currentItem = this._getNextFocusableChild(currentItem, 1);
					}while(currentItem && currentItem != stop);
					// commented out code block to search again if the multichar search fails after a smaller timeout
					//if(!numMatches && (this._typingSlowly || searchLen == 1)){
					//	this._searchString = '';
					//	if(searchLen > 1){
					//		// if no matches and they're typing slowly, then go back to first letter searching
					//		search();
					//	}
					//}
				});

			search();
			// commented out code block to search again if the multichar search fails after a smaller timeout
			//this._typingSlowly = false;
			this.onKeyboardSearch(matchedItem, evt, searchString, numMatches);
		},

		_onChildBlur: function(/*dijit/_WidgetBase*/ /*===== widget =====*/){
			// summary:
			//		Called when focus leaves a child widget to go
			//		to a sibling widget.
			//		Used to be used by MenuBase.js (remove for 2.0)
			// tags:
			//		protected
		},

		_getNextFocusableChild: function(child, dir){
			// summary:
			//		Returns the next or previous focusable descendant, compared to "child".
			//		Implements and extends _KeyNavMixin._getNextFocusableChild() for a _Container.
			// child: Widget
			//		The current widget
			// dir: Integer
			//		- 1 = after
			//		- -1 = before
			// tags:
			//		abstract extension

			var wrappedValue = child;
			do{
				if(!child){
					child = this[dir > 0 ? "_getFirst" : "_getLast"]();
					if(!child){ break; }
				}else{
					child = this._getNext(child, dir);
				}
				if(child != null && child != wrappedValue && child.isFocusable()){
					return child;	// dijit/_WidgetBase
				}
			}while(child != wrappedValue);
			// no focusable child found
			return null;	// dijit/_WidgetBase
		},

		_getFirst: function(){
			// summary:
			//		Returns the first child.
			// tags:
			//		abstract extension

			return null;	// dijit/_WidgetBase
		},

		_getLast: function(){
			// summary:
			//		Returns the last descendant.
			// tags:
			//		abstract extension

			return null;	// dijit/_WidgetBase
		},

		_getNext: function(child, dir){
			// summary:
			//		Returns the next descendant, compared to "child".
			// child: Widget
			//		The current widget
			// dir: Integer
			//		- 1 = after
			//		- -1 = before
			// tags:
			//		abstract extension

			if(child){
				child = child.domNode;
				while(child){
					child = child[dir < 0 ? "previousSibling" : "nextSibling"];
					if(child  && "getAttribute" in child){
						var w = registry.byNode(child);
						if(w){
							return w; // dijit/_WidgetBase
						}
					}
				}
			}
			return null;	// dijit/_WidgetBase
		}
	});
});

},
'dijit/_TemplatedMixin':function(){
define([
	"dojo/cache",	// dojo.cache
	"dojo/_base/declare", // declare
	"dojo/dom-construct", // domConstruct.destroy, domConstruct.toDom
	"dojo/_base/lang", // lang.getObject
	"dojo/on",
	"dojo/sniff", // has("ie")
	"dojo/string", // string.substitute string.trim
	"./_AttachMixin"
], function(cache, declare, domConstruct, lang, on, has, string, _AttachMixin){

	// module:
	//		dijit/_TemplatedMixin

	var _TemplatedMixin = declare("dijit._TemplatedMixin", _AttachMixin, {
		// summary:
		//		Mixin for widgets that are instantiated from a template

		// templateString: [protected] String
		//		A string that represents the widget template.
		//		Use in conjunction with dojo.cache() to load from a file.
		templateString: null,

		// templatePath: [protected deprecated] String
		//		Path to template (HTML file) for this widget relative to dojo.baseUrl.
		//		Deprecated: use templateString with require([... "dojo/text!..."], ...) instead
		templatePath: null,

		// skipNodeCache: [protected] Boolean
		//		If using a cached widget template nodes poses issues for a
		//		particular widget class, it can set this property to ensure
		//		that its template is always re-built from a string
		_skipNodeCache: false,

/*=====
		// _rendered: Boolean
		//		Not normally use, but this flag can be set by the app if the server has already rendered the template,
		//		i.e. already inlining the template for the widget into the main page.   Reduces _TemplatedMixin to
		//		just function like _AttachMixin.
		_rendered: false,
=====*/

		// Set _AttachMixin.searchContainerNode to true for back-compat for widgets that have data-dojo-attach-point's
		// and events inside this.containerNode.   Remove for 2.0.
		searchContainerNode: true,

		_stringRepl: function(tmpl){
			// summary:
			//		Does substitution of ${foo} type properties in template string
			// tags:
			//		private
			var className = this.declaredClass, _this = this;
			// Cache contains a string because we need to do property replacement
			// do the property replacement
			return string.substitute(tmpl, this, function(value, key){
				if(key.charAt(0) == '!'){ value = lang.getObject(key.substr(1), false, _this); }
				if(typeof value == "undefined"){ throw new Error(className+" template:"+key); } // a debugging aide
				if(value == null){ return ""; }

				// Substitution keys beginning with ! will skip the transform step,
				// in case a user wishes to insert unescaped markup, e.g. ${!foo}
				return key.charAt(0) == "!" ? value : this._escapeValue("" + value);
			}, this);
		},

		_escapeValue: function(/*String*/ val){
			// summary:
			//		Escape a value to be inserted into the template, either into an attribute value
			//		(ex: foo="${bar}") or as inner text of an element (ex: <span>${foo}</span>)

			// Safer substitution, see heading "Attribute values" in
			// http://www.w3.org/TR/REC-html40/appendix/notes.html#h-B.3.2
			// and also https://www.owasp.org/index.php/XSS_%28Cross_Site_Scripting%29_Prevention_Cheat_Sheet#RULE_.231_-_HTML_Escape_Before_Inserting_Untrusted_Data_into_HTML_Element_Content
			return val.replace(/["'<>&]/g, function(val){
				return {
					"&": "&amp;",
					"<": "&lt;",
					">": "&gt;",
					"\"": "&quot;",
					"'": "&#x27;"
				}[val];
			});
		},

		buildRendering: function(){
			// summary:
			//		Construct the UI for this widget from a template, setting this.domNode.
			// tags:
			//		protected

			if(!this._rendered){
				if(!this.templateString){
					this.templateString = cache(this.templatePath, {sanitize: true});
				}

				// Lookup cached version of template, and download to cache if it
				// isn't there already.  Returns either a DomNode or a string, depending on
				// whether or not the template contains ${foo} replacement parameters.
				var cached = _TemplatedMixin.getCachedTemplate(this.templateString, this._skipNodeCache, this.ownerDocument);

				var node;
				if(lang.isString(cached)){
					node = domConstruct.toDom(this._stringRepl(cached), this.ownerDocument);
					if(node.nodeType != 1){
						// Flag common problems such as templates with multiple top level nodes (nodeType == 11)
						throw new Error("Invalid template: " + cached);
					}
				}else{
					// if it's a node, all we have to do is clone it
					node = cached.cloneNode(true);
				}

				this.domNode = node;
			}

			// Call down to _WidgetBase.buildRendering() to get base classes assigned
			// TODO: change the baseClass assignment to _setBaseClassAttr
			this.inherited(arguments);

			if(!this._rendered){
				this._fillContent(this.srcNodeRef);
			}

			this._rendered = true;
		},

		_fillContent: function(/*DomNode*/ source){
			// summary:
			//		Relocate source contents to templated container node.
			//		this.containerNode must be able to receive children, or exceptions will be thrown.
			// tags:
			//		protected
			var dest = this.containerNode;
			if(source && dest){
				while(source.hasChildNodes()){
					dest.appendChild(source.firstChild);
				}
			}
		}

	});

	// key is templateString; object is either string or DOM tree
	_TemplatedMixin._templateCache = {};

	_TemplatedMixin.getCachedTemplate = function(templateString, alwaysUseString, doc){
		// summary:
		//		Static method to get a template based on the templatePath or
		//		templateString key
		// templateString: String
		//		The template
		// alwaysUseString: Boolean
		//		Don't cache the DOM tree for this template, even if it doesn't have any variables
		// doc: Document?
		//		The target document.   Defaults to document global if unspecified.
		// returns: Mixed
		//		Either string (if there are ${} variables that need to be replaced) or just
		//		a DOM tree (if the node can be cloned directly)

		// is it already cached?
		var tmplts = _TemplatedMixin._templateCache;
		var key = templateString;
		var cached = tmplts[key];
		if(cached){
			try{
				// if the cached value is an innerHTML string (no ownerDocument) or a DOM tree created within the
				// current document, then use the current cached value
				if(!cached.ownerDocument || cached.ownerDocument == (doc || document)){
					// string or node of the same document
					return cached;
				}
			}catch(e){ /* squelch */ } // IE can throw an exception if cached.ownerDocument was reloaded
			domConstruct.destroy(cached);
		}

		templateString = string.trim(templateString);

		if(alwaysUseString || templateString.match(/\$\{([^\}]+)\}/g)){
			// there are variables in the template so all we can do is cache the string
			return (tmplts[key] = templateString); //String
		}else{
			// there are no variables in the template so we can cache the DOM tree
			var node = domConstruct.toDom(templateString, doc);
			if(node.nodeType != 1){
				throw new Error("Invalid template: " + templateString);
			}
			return (tmplts[key] = node); //Node
		}
	};

	if(has("ie")){
		on(window, "unload", function(){
			var cache = _TemplatedMixin._templateCache;
			for(var key in cache){
				var value = cache[key];
				if(typeof value == "object"){ // value is either a string or a DOM node template
					domConstruct.destroy(value);
				}
				delete cache[key];
			}
		});
	}

	return _TemplatedMixin;
});

},
'dijit/MenuItem':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/dom", // dom.setSelectable
	"dojo/dom-attr", // domAttr.set
	"dojo/dom-class", // domClass.toggle
	"dojo/_base/kernel", // kernel.deprecated
	"dojo/sniff", // has("ie")
	"dojo/_base/lang", // lang.hitch
	"./_Widget",
	"./_TemplatedMixin",
	"./_Contained",
	"./_CssStateMixin",
	"dojo/text!./templates/MenuItem.html"
], function(declare, dom, domAttr, domClass, kernel, has, lang,
			_Widget, _TemplatedMixin, _Contained, _CssStateMixin, template){

	// module:
	//		dijit/MenuItem

	var MenuItem = declare("dijit.MenuItem" + (has("dojo-bidi") ? "_NoBidi" : ""),
		[_Widget, _TemplatedMixin, _Contained, _CssStateMixin], {
		// summary:
		//		A line item in a Menu Widget

		// Make 3 columns
		// icon, label, and expand arrow (BiDi-dependent) indicating sub-menu
		templateString: template,

		baseClass: "dijitMenuItem",

		// label: String
		//		Menu text as HTML
		label: "",
		_setLabelAttr: function(val){
			this._set("label", val);
			var shortcutKey = "";
			var text;
			var ndx = (val instanceof String) ? val.search(/{\S}/) : -1;
			if(ndx >= 0){
				shortcutKey = val.charAt(ndx + 1);
				var prefix = val.substr(0, ndx);
				var suffix = val.substr(ndx + 3);
				text = prefix + shortcutKey + suffix;
				val = prefix + '<span class="dijitMenuItemShortcutKey">' + shortcutKey + '</span>' + suffix;
			}else{
				text = val;
			}
			this.domNode.setAttribute("aria-label", text + " " + this.accelKey);
			this.containerNode.innerHTML = val;
			this._set('shortcutKey', shortcutKey);
		},

		/*=====
		// shortcutKey: [readonly] String
		//		Single character (underlined when the parent Menu is focused) used to navigate directly to this widget,
		//		also known as [a mnemonic](http://en.wikipedia.org/wiki/Mnemonics_(keyboard%29).
		//		This is denoted in the label by surrounding the single character with {}.
		//		For example, if label="{F}ile", then shortcutKey="F".
		shortcutKey: "",
		=====*/

		// iconClass: String
		//		Class to apply to DOMNode to make it display an icon.
		iconClass: "dijitNoIcon",
		_setIconClassAttr: { node: "iconNode", type: "class" },

		// accelKey: String
		//		Text for the accelerator (shortcut) key combination, a control, alt, etc. modified keystroke meant to
		//		execute the menu item regardless of where the focus is on the page.
		//
		//		Note that although Menu can display accelerator keys, there is no infrastructure to actually catch and
		//		execute those accelerators.
		accelKey: "",

		// disabled: Boolean
		//		If true, the menu item is disabled.
		//		If false, the menu item is enabled.
		disabled: false,

		_fillContent: function(/*DomNode*/ source){
			// If button label is specified as srcNodeRef.innerHTML rather than
			// this.params.label, handle it here.
			if(source && !("label" in this.params)){
				this._set('label', source.innerHTML);
			}
		},

		buildRendering: function(){
			this.inherited(arguments);
			var label = this.id + "_text";
			domAttr.set(this.containerNode, "id", label); // only needed for backward compat
			if(this.accelKeyNode){
				domAttr.set(this.accelKeyNode, "id", this.id + "_accel"); // only needed for backward compat
			}
			dom.setSelectable(this.domNode, false);
		},

		onClick: function(/*Event*/){
			// summary:
			//		User defined function to handle clicks
			// tags:
			//		callback
		},

		focus: function(){
			// summary:
			//		Focus on this MenuItem
			try{
				if(has("ie") == 8){
					// needed for IE8 which won't scroll TR tags into view on focus yet calling scrollIntoView creates flicker (#10275)
					this.containerNode.focus();
				}
				this.focusNode.focus();
			}catch(e){
				// this throws on IE (at least) in some scenarios
			}
		},

		_setSelected: function(selected){
			// summary:
			//		Indicate that this node is the currently selected one
			// tags:
			//		private

			domClass.toggle(this.domNode, "dijitMenuItemSelected", selected);
		},

		setLabel: function(/*String*/ content){
			// summary:
			//		Deprecated.   Use set('label', ...) instead.
			// tags:
			//		deprecated
			kernel.deprecated("dijit.MenuItem.setLabel() is deprecated.  Use set('label', ...) instead.", "", "2.0");
			this.set("label", content);
		},

		setDisabled: function(/*Boolean*/ disabled){
			// summary:
			//		Deprecated.   Use set('disabled', bool) instead.
			// tags:
			//		deprecated
			kernel.deprecated("dijit.Menu.setDisabled() is deprecated.  Use set('disabled', bool) instead.", "", "2.0");
			this.set('disabled', disabled);
		},

		_setDisabledAttr: function(/*Boolean*/ value){
			// summary:
			//		Hook for attr('disabled', ...) to work.
			//		Enable or disable this menu item.

			this.focusNode.setAttribute('aria-disabled', value ? 'true' : 'false');
			this._set("disabled", value);
		},

		_setAccelKeyAttr: function(/*String*/ value){
			// summary:
			//		Hook for attr('accelKey', ...) to work.
			//		Set accelKey on this menu item.

			if(this.accelKeyNode){
				this.accelKeyNode.style.display = value ? "" : "none";
				this.accelKeyNode.innerHTML = value;
				//have to use colSpan to make it work in IE
				domAttr.set(this.containerNode, 'colSpan', value ? "1" : "2");
			}
			this._set("accelKey", value);
		}
	});

	if(has("dojo-bidi")){
		MenuItem = declare("dijit.MenuItem", MenuItem, {
			_setLabelAttr: function(val){
				this.inherited(arguments);
				if(this.textDir === "auto"){
					this.applyTextDir(this.textDirNode);
				}
			}
		});
	}

	return MenuItem;
});

},
'dijit/PopupMenuItem':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/dom-style", // domStyle.set
	"dojo/_base/lang",
	"dojo/query", // query
	"./popup",
	"./registry",	// registry.byNode
	"./MenuItem",
	"./hccss"
], function(declare, domStyle, lang, query, pm, registry, MenuItem){

	// module:
	//		dijit/PopupMenuItem

	return declare("dijit.PopupMenuItem", MenuItem, {
		// summary:
		//		An item in a Menu that spawn a drop down (usually a drop down menu)

		baseClass: "dijitMenuItem dijitPopupMenuItem",

		_fillContent: function(){
			// summary:
			//		When Menu is declared in markup, this code gets the menu label and
			//		the popup widget from the srcNodeRef.
			// description:
			//		srcNodeRef.innerHTML contains both the menu item text and a popup widget
			//		The first part holds the menu item text and the second part is the popup
			// example:
			// |	<div data-dojo-type="dijit/PopupMenuItem">
			// |		<span>pick me</span>
			// |		<popup> ... </popup>
			// |	</div>
			// tags:
			//		protected

			if(this.srcNodeRef){
				var nodes = query("*", this.srcNodeRef);
				this.inherited(arguments, [nodes[0]]);

				// save pointer to srcNode so we can grab the drop down widget after it's instantiated
				this.dropDownContainer = this.srcNodeRef;
			}
		},

		_openPopup: function(/*Object*/ params, /*Boolean*/ focus){
			// summary:
			//		Open the popup to the side of/underneath this MenuItem, and optionally focus first item
			// tags:
			//		protected

			var popup = this.popup;

			pm.open(lang.delegate(params, {
				popup: this.popup,
				around: this.domNode
			}));

			if(focus && popup.focus){
				popup.focus();
			}
		},

		_closePopup: function(){
			pm.close(this.popup);
			this.popup.parentMenu = null;
		},

		startup: function(){
			if(this._started){ return; }
			this.inherited(arguments);

			// We didn't copy the dropdown widget from the this.srcNodeRef, so it's in no-man's
			// land now.  Move it to <body>.
			if(!this.popup){
				var node = query("[widgetId]", this.dropDownContainer)[0];
				this.popup = registry.byNode(node);
			}
			this.ownerDocumentBody.appendChild(this.popup.domNode);
			this.popup.domNode.setAttribute("aria-labelledby", this.containerNode.id);
			this.popup.startup();

			this.popup.domNode.style.display="none";
			if(this.arrowWrapper){
				domStyle.set(this.arrowWrapper, "visibility", "");
			}
			this.focusNode.setAttribute("aria-haspopup", "true");
		},

		destroyDescendants: function(/*Boolean*/ preserveDom){
			if(this.popup){
				// Destroy the popup, unless it's already been destroyed.  This can happen because
				// the popup is a direct child of <body> even though it's logically my child.
				if(!this.popup._destroyed){
					this.popup.destroyRecursive(preserveDom);
				}
				delete this.popup;
			}
			this.inherited(arguments);
		}
	});
});

},
'xstyle/css':function(){
define(["require"], function(moduleRequire){
"use strict";
/*
 * AMD css! plugin
 * This plugin will load and wait for css files. This allows JavaScript resources to 
 * fully there dependencies on stylesheets. This can also be used when
 * loading css files as part of a layer or as a way to apply a run-time theme. This
 * module checks to see if the CSS is already loaded before incurring the cost
 * of loading the full CSS loader codebase
 */
 	function testElementStyle(tag, id, property){
 		// test an element's style
		var docElement = document.documentElement;
		var testDiv = docElement.insertBefore(document.createElement(tag), docElement.firstChild);
		testDiv.id = id;
		var styleValue = (testDiv.currentStyle || getComputedStyle(testDiv, null) || {})[property];
		docElement.removeChild(testDiv);
 		return styleValue;
 	} 
 	return {
		load: function(resourceDef, require, callback, config) {
			var url = require.toUrl(resourceDef);
			var options;
			if(url.match(/!$/)){
				// a final ! can be used to indicate not to wait for the stylesheet to load
				options = {
					wait: false
				};
				url = url.slice(0, -1);
			}
			var cachedCss = require.cache && require.cache['url:' + url];
			if(cachedCss != null){
				// we have CSS cached inline in the build
				if(cachedCss.xCss){
					var parser = cachedCss.parser;
					var xCss =cachedCss.xCss;
					cachedCss = cachedCss.cssText;
				}
				// cachedCss might be {}, indicating this CSS was part of a built stylesheet. Assume the built
				// stylesheet is already loaded, so no need to inject this CSS again.
				if (typeof cachedCss == 'string') {
					moduleRequire(['./core/load-css'],function(load){
						checkForParser(load.insertCss(cachedCss));
					});
				} else {
					checkForParser();
				}
				if(xCss){
					//require([parsed], callback);
				}
				return;
			}
			function checkForParser(styleSheetElement){
				var parser = testElementStyle('x-parse', null, 'content');
				var sheet = styleSheetElement && 
					(styleSheetElement.sheet || styleSheetElement.styleSheet);
				if(parser && parser != 'none' && parser != 'normal'){
					// TODO: wait for parser to load
					require([eval(parser)], function(parser){
						if(styleSheetElement){
							parser.process(styleSheetElement, callback);
						}else{
							parser.processAll();
							callback(sheet);
						}
					});
				}else{
					callback(sheet);
				}
			}
			
			// if there is an id test available, see if the referenced rule is already loaded,
			// and if so we can completely avoid any dynamic CSS loading. If it is
			// not present, we need to use the dynamic CSS loader.
			var displayStyle = testElementStyle('div', resourceDef.replace(/\//g,'-').replace(/\..*/,'') + "-loaded", 'display');
			if(displayStyle == "none"){
				return checkForParser();
			}
			// use dynamic loader
			moduleRequire(["./core/load-css"], function(load){
				load(url, checkForParser, options);
			});
		}
	};
});

},
'xstyle/core/load-css':function(){
define([], function(){
	'use strict';
	// this module is responsible for doing the loading/insertion
	// of stylesheets to get CSS loaded.

	var cache = typeof _css_cache == 'undefined' ? {} : _css_cache;
	var doc = document;

	function has(){
		return !doc.createStyleSheet;
	}
	var head = doc.head;
	function insertCss(css){
		if(has("dom-create-style-element")){
			// we can use standard <style> element creation
			styleSheet = doc.createElement("style");
			styleSheet.setAttribute("type", "text/css");
			styleSheet.appendChild(doc.createTextNode(css));
			head.appendChild(styleSheet);
			return styleSheet;
		}
		else{
			// IE's stylesheet insertion
			var styleSheet = doc.createStyleSheet();
			styleSheet.cssText = css;
			return styleSheet.owningElement;
		}
	}

	function load(resourceDef, callback, options){
		var cached = cache[resourceDef];
		if(cached){
			// if it is cached (from a build), we directly insert
			link = insertCss(cached);
			return callback(link);
		}
		// create a link element to load the stylesheet
		var link = doc.createElement('link');
		link.type = 'text/css';
		link.rel = 'stylesheet';
		link.href = resourceDef;
		var wait = !options || options.wait !== false;
		// old webkit's would claim to have onload, but didn't really support it
		var webkitVersion = navigator.userAgent.match(/AppleWebKit\/(\d+\.?\d*)/);
		webkitVersion = webkitVersion && +webkitVersion[1];
		if(link.onload === null && !(webkitVersion < 536)){
			// most browsers support this onload function now
			link.onload = function(){
				// cleanup
				link.onload = null;
				link.onerror = null;
				wait && callback(link);
			};
			// always add the error handler, so we can notify of any errors
			link.onerror = function(){
				// there isn't really any recourse in AMD for errors, so
				// we just output the error and continue on
				console.error('Error loading stylesheet ' + resourceDef);
				wait && callback(link);
			};
		}else if(wait){
			var interval = setInterval(function(){
				if(link.style){
					// loaded
					clearInterval(interval);
					callback(link);
				}
			}, 15);
		}
		// add it to the head to trigger loading
		(head || doc.getElementsByTagName('head')[0]).appendChild(link);
		if(!wait){
			// don't wait for the stylesheet to load, proceed
			callback(link);
		}
	}
	load.insertCss = insertCss;
	return load;
});

},
'put-selector/put':function(){
(function(define){
var forDocument, fragmentFasterHeuristic = /[-+,> ]/; // if it has any of these combinators, it is probably going to be faster with a document fragment 
define([], forDocument = function(doc, newFragmentFasterHeuristic){
"use strict";
	// module:
	//		put-selector/put
	// summary:
	//		This module defines a fast lightweight function for updating and creating new elements
	//		terse, CSS selector-based syntax. The single function from this module creates
	// 		new DOM elements and updates existing elements. See README.md for more information.
	//	examples:
	//		To create a simple div with a class name of "foo":
	//		|	put("div.foo");
	fragmentFasterHeuristic = newFragmentFasterHeuristic || fragmentFasterHeuristic;
	var selectorParse = /(?:\s*([-+ ,<>]))?\s*(\.|!\.?|#)?([-\w%$|]+)?(?:\[([^\]=]+)=?['"]?([^\]'"]*)['"]?\])?/g,
		undefined, namespaceIndex, namespaces = false,
		doc = doc || document,
		ieCreateElement = typeof doc.createElement == "object"; // telltale sign of the old IE behavior with createElement that does not support later addition of name 
	function insertTextNode(element, text){
		element.appendChild(doc.createTextNode(text));
	}
	function put(topReferenceElement){
		var fragment, lastSelectorArg, nextSibling, referenceElement, current,
			args = arguments,
			returnValue = args[0]; // use the first argument as the default return value in case only an element is passed in
		function insertLastElement(){
			// we perform insertBefore actions after the element is fully created to work properly with 
			// <input> tags in older versions of IE that require type attributes
			//	to be set before it is attached to a parent.
			// We also handle top level as a document fragment actions in a complex creation 
			// are done on a detached DOM which is much faster
			// Also if there is a parse error, we generally error out before doing any DOM operations (more atomic) 
			if(current && referenceElement && current != referenceElement){
				(referenceElement == topReferenceElement &&
					// top level, may use fragment for faster access 
					(fragment || 
						// fragment doesn't exist yet, check to see if we really want to create it 
						(fragment = fragmentFasterHeuristic.test(argument) && doc.createDocumentFragment()))
							// any of the above fails just use the referenceElement  
							 ? fragment : referenceElement).
								insertBefore(current, nextSibling || null); // do the actual insertion
			}
		}
		for(var i = 0; i < args.length; i++){
			var argument = args[i];
			if(typeof argument == "object"){
				lastSelectorArg = false;
				if(argument instanceof Array){
					// an array
					current = doc.createDocumentFragment();
					for(var key = 0; key < argument.length; key++){
						current.appendChild(put(argument[key]));
					}
					argument = current;
				}
				if(argument.nodeType){
					current = argument;
					insertLastElement();
					referenceElement = argument;
					nextSibling = 0;
				}else{
					// an object hash
					for(var key in argument){
						current[key] = argument[key];
					}				
				}
			}else if(lastSelectorArg){
				// a text node should be created
				// take a scalar value, use createTextNode so it is properly escaped
				// createTextNode is generally several times faster than doing an escaped innerHTML insertion: http://jsperf.com/createtextnode-vs-innerhtml/2
				lastSelectorArg = false;
				insertTextNode(current, argument);
			}else{
				if(i < 1){
					// if we are starting with a selector, there is no top element
					topReferenceElement = null;
				}
				lastSelectorArg = true;
				var leftoverCharacters = argument.replace(selectorParse, function(t, combinator, prefix, value, attrName, attrValue){
					if(combinator){
						// insert the last current object
						insertLastElement();
						if(combinator == '-' || combinator == '+'){
							// + or - combinator, 
							// TODO: add support for >- as a means of indicating before the first child?
							referenceElement = (nextSibling = (current || referenceElement)).parentNode;
							current = null;
							if(combinator == "+"){
								nextSibling = nextSibling.nextSibling;
							}// else a - operator, again not in CSS, but obvious in it's meaning (create next element before the current/referenceElement)
						}else{
							if(combinator == "<"){
								// parent combinator (not really in CSS, but theorized, and obvious in it's meaning)
								referenceElement = current = (current || referenceElement).parentNode;
							}else{
								if(combinator == ","){
									// comma combinator, start a new selector
									referenceElement = topReferenceElement;
								}else if(current){
									// else descendent or child selector (doesn't matter, treated the same),
									referenceElement = current;
								}
								current = null;
							}
							nextSibling = 0;
						}
						if(current){
							referenceElement = current;
						}
					}
					var tag = !prefix && value;
					if(tag || (!current && (prefix || attrName))){
						if(tag == "$"){
							// this is a variable to be replaced with a text node
							insertTextNode(referenceElement, args[++i]);
						}else{
							// Need to create an element
							tag = tag || put.defaultTag;
							var ieInputName = ieCreateElement && args[i +1] && args[i +1].name;
							if(ieInputName){
								// in IE, we have to use the crazy non-standard createElement to create input's that have a name 
								tag = '<' + tag + ' name="' + ieInputName + '">';
							}
							// we swtich between creation methods based on namespace usage
							current = namespaces && ~(namespaceIndex = tag.indexOf('|')) ?
								doc.createElementNS(namespaces[tag.slice(0, namespaceIndex)], tag.slice(namespaceIndex + 1)) : 
								doc.createElement(tag);
						}
					}
					if(prefix){
						if(value == "$"){
							value = args[++i];
						}
						if(prefix == "#"){
							// #id was specified
							current.id = value;
						}else{
							// we are in the className addition and removal branch
							var currentClassName = current.className;
							// remove the className (needed for addition or removal)
							// see http://jsperf.com/remove-class-name-algorithm/2 for some tests on this
							var removed = currentClassName && (" " + currentClassName + " ").replace(" " + value + " ", " ");
							if(prefix == "."){
								// addition, add the className
								current.className = currentClassName ? (removed + value).substring(1) : value;
							}else{
								// else a '!' class removal
								if(argument == "!"){
									var parentNode;
									// special signal to delete this element
									if(ieCreateElement){
										// use the ol' innerHTML trick to get IE to do some cleanup
										put("div", current, '<').innerHTML = "";
									}else if(parentNode = current.parentNode){ // intentional assigment
										// use a faster, and more correct (for namespaced elements) removal (http://jsperf.com/removechild-innerhtml)
										parentNode.removeChild(current);
									}
								}else{
									// we already have removed the class, just need to trim
									removed = removed.substring(1, removed.length - 1);
									// only assign if it changed, this can save a lot of time
									if(removed != currentClassName){
										current.className = removed;
									}
								}
							}
							// CSS class removal
						}
					}
					if(attrName){
						if(attrValue == "$"){
							attrValue = args[++i];
						}
						// [name=value]
						if(attrName == "style"){
							// handle the special case of setAttribute not working in old IE
							current.style.cssText = attrValue;
						}else{
							var method = attrName.charAt(0) == "!" ? (attrName = attrName.substring(1)) && 'removeAttribute' : 'setAttribute';
							attrValue = attrValue === '' ? attrName : attrValue;
							// determine if we need to use a namespace
							namespaces && ~(namespaceIndex = attrName.indexOf('|')) ?
								current[method + "NS"](namespaces[attrName.slice(0, namespaceIndex)], attrName.slice(namespaceIndex + 1), attrValue) :
								current[method](attrName, attrValue);
						}
					}
					return '';
				});
				if(leftoverCharacters){
					throw new SyntaxError("Unexpected char " + leftoverCharacters + " in " + argument);
				}
				insertLastElement();
				referenceElement = returnValue = current || referenceElement;
			}
		}
		if(topReferenceElement && fragment){
			// we now insert the top level elements for the fragment if it exists
			topReferenceElement.appendChild(fragment);
		}
		return returnValue;
	}
	put.addNamespace = function(name, uri){
		if(doc.createElementNS){
			(namespaces || (namespaces = {}))[name] = uri;
		}else{
			// for old IE
			doc.namespaces.add(name, uri);
		}
	};
	put.defaultTag = "div";
	put.forDocument = forDocument;
	return put;
});
})(function(id, deps, factory){
	factory = factory || deps;
	if(typeof define === "function"){
		// AMD loader
		define([], function(){
			return factory();
		});
	}else if(typeof window == "undefined"){
		// server side JavaScript, probably (hopefully) NodeJS
		require("./node-html")(module, factory);
	}else{
		// plain script in a browser
		put = factory();
	}
});

},
'appivo/model/Schema':function(){
define(['dojo/_base/lang',
        'dojo/_base/declare',
        'dojo/_base/Deferred',
        'dojo/Evented',
        'dojo/string',
        'dojo/store/Memory',
        'dojo/store/Observable',
        'appivo/model/Model',
        'appivo/model/Attribute',
        'appivo/model/Relation',
		'appivo/model/SearchIndex',
		'appivo/model/AIAgent',
        'appivo/model/Param',
        'appivo/model/Query',
        'appivo/model/Rule',
        'appivo/model/Action',
        'appivo/model/Locale',
        'appivo/model/Feature',
        'appivo/model/Template',
        'appivo/client/Client',
        'appivo/util/Identity',
        'appivo/util/StringFormatters',
        'appivo/model/SampleModel',
        'dojo/text!./SampleModel.json'], function(lang, declare, Deferred, Evented, string, Memory, Observable, Model, Attribute, Relation, SearchIndex, AIAgent, Param, Query, Rule, Action, Locale, Feature, Template, Client, Identity, StringFormatters, SampleModel, SampleModelData) {

	var client = Client.getInstance();

	var sampleData = JSON.parse(SampleModelData);

	function cloneObject(obj) {
		if (obj) {
			obj = JSON.parse(JSON.stringify(obj));
		}
		return obj;
	};

	var LOG_DELAY = 5 * 1000;
	var METASCHEMA_ID = "00000000000000000000000000000001";
	var logEntries = [];
	var logTimer = null;

	return declare("appivo.model.Schema", [Evented], {

		id: null,
		ver: null,
		name: null,
		tenant: null,
		apiName: null,
		description: null,
		locale: null,
		extendable: null,
		published: null,
		parent: null,
		ancestor: null,
		type: null,
		tenantId: null,
		models: null,
		counters: null,
		relations: null,
		integrations: null,
		userInterfaces: null,
		userInterfaceIndex: null,
		locales: null,
		_models: null,
		agents: null,
		roles: null,
		defaultRole: null,
		rules: null,
		features: null,
		_featureIndex: null,
		actions: null,
		queries: null,
		userPrivileges: {},
		params: null,
		metaSchema: false,
		terms: null,
		strings: null,
		templates: null,
		resources: null,
		devices: null,
		language: 'default',
		mobilePlugins: null,
		mobilePrivileges: null,
		licenses: null,
		whiteLabel: null,
		ctenant: null,
		flightRecorder: null,

		modelClass: Model,
		relationClass: Relation,
		paramClass: Param,
		queryClass: Query,
		actionClass: Action,
		ruleClass: Rule,
		localeClass: Locale,
		featureClass: Feature,
		templateClass: Template,

		constructor: function(data) {
			if (data) {
				this._setData(data);
			}
		},

		_setData: function(data) {
			var options = this._createOptions(data);
			lang.mixin(this, options);
			this._createApiName();
			this.metaSchema = this.id === METASCHEMA_ID;
			this._models = new Observable(new Memory({}));
			this._counters = new Observable(new Memory({}));
			var models = new Array();
			if (this.models) {
				for (var i = 0; i < this.models.length; i++) {
					var m = this.models[i];
					m.schema = this;
					var model = new this.modelClass(m);
					models.push(model);
				}
			}
			this._models.setData(models);

			if (!this.agents) {
				this.agents = [];
			}
			for (var i = 0; i < this.agents.length; i++) {
				var ag = this.agents[i];
				var aig = new AIAgent(ag);
				this.agents[i] = aig;
			}

			if (!this.searchIndexes) {
				this.searchIndexes = [];
			}
			for (var i = 0; i < this.searchIndexes.length; i++) {
				var sid = this.searchIndexes[i];
				var si = new SearchIndex(sid);
				this.searchIndexes[i] = si;
			}

			if (this.counters) {
				this._counters.setData(this.counters);
			}

			var relations = {};
			if (this.relations) {
				for (var i = 0; i < this.relations.length; i++) {
					var rel = this.relations[i];
					var relation = new this.relationClass(rel);
					relation._resolveOnLoad(this);
					relations[relation.id] = relation;
				}
			}
			this.relations = relations;

			for (var i = 0; i < models.length; i++) {
				var model = models[i];
				model.resolve(this);
			}

			this.userInterfaceIndex = new Array();
			if (this.userInterfaces) {
				for (var i = 0; i< this.userInterfaces.length; i++) {
					var ui = this.userInterfaces[i];
					this.userInterfaceIndex[ui.name] = ui;
				}
			}

			if (this.actions) {
				var actions = new Array();
				for (var i = 0; i < this.actions.length; i++) {
					var action = new this.actionClass(this.actions[i]);
					actions.push(action);
				}
				this.actions = actions;
			}

			if (this.rules) {
				var rules = new Array();
				for (var i = 0; i < this.rules.length; i++) {
					this.rules[i].schema = this;
					var rule = new this.ruleClass(this.rules[i]);
					rule.resolve(this);
					rules.push(rule);
				}
				this.rules = rules;
			}

			if (this.locales) {
				var locales = new Array();
				for (var i = 0; i < this.locales.length; i++) {
					this.locales[i].schema = this;
					var locale = new this.localeClass(this.locales[i]);
					locale.resolve(this);
					locales.push(locale);
				}
				this.locales = locales;
			}

			this.setFeatures(this.features);

			if (this.queries) {
				var queries = new Array();
				for (var i = 0; i < this.queries.length; i++) {
					var queryDef = this.queries[i];
					queryDef.schema = this;
					var query = new this.queryClass(queryDef);
					queries.push(query);
				}
				this.queries = queries;
			}

			if (this.params) {
				var params = new Array();
				for (var i = 0; i < this.params.length; i++) {
					var paramDef = this.params[i];
					paramDef.schema = this;
					params.push(new this.paramClass(paramDef));
				}
				this.params = params;
			}

			if (this.templates) {
				var templates = new Array();
				for (var i = 0; i < this.templates.length; i++) {
					var tplDef = this.templates[i];
					tplDef.schema = this;
					templates.push(new this.templateClass(tplDef));
				}
				this.templates = templates;
			}

			var locale = this.getLocaleData();
			if (locale) {
				for (var i = 0; i < models.length; i++) {
					var model = models[i];
					model._localize(locale);
				}
			}
			delete this.models;
		},

		_createOptions: function(rawSchema) {
			var options = {
				id: rawSchema.id,
				schemaId: rawSchema.id,
				ver: rawSchema.ver,
				type: rawSchema.type,
				name: rawSchema.name,
				description: rawSchema.description,
				locale: rawSchema.locale,
				language: rawSchema.selectedLocale,
				extendable: rawSchema.extendable,
				published: rawSchema.published,
				public: rawSchema.public,
				parent: rawSchema.parent,
				ancestor: rawSchema.ancestor,
				tenantId: client.getTenantId(),
				tenant: rawSchema.tenant,
				models: rawSchema.models,
				relations: rawSchema.relations,
				agents: rawSchema.agents,
				searchIndexes: rawSchema.searchIndexes,
				counters: rawSchema.counters,
				integrations: rawSchema.integrations,
				rules: rawSchema.rules,
				actions: rawSchema.actions,
				queries: rawSchema.queries,
				roles: rawSchema.roles,
				devices: rawSchema.devices,
				defaultRole: rawSchema.defaultRole,
				params: rawSchema.params,
				locales: rawSchema.locales,
				features: rawSchema.features,
				templates: rawSchema.templates,
				resources: rawSchema.resources,
				userInterfaces: rawSchema.userInterfaces,
				mobilePlugins: rawSchema.mobilePlugins,
				mobilePrivileges: rawSchema.mobilePrivileges,
				licenses: rawSchema.licenses,
				whiteLabel: rawSchema.whiteLabel
			};

			if (rawSchema.pluginData) {
				options.pluginData = rawSchema.pluginData;
			}

			options.hybrid = rawSchema.hybrid;
			options.complete = rawSchema.complete;
			options.localized = rawSchema.localized;
			return options;
		},

		setName: function(name) {
			this.name = name;
		},

		getName: function() {
			return this.name;
		},

		setTenant: function(tenant) {
			this.ctenant = tenant;
			this._createApiName();
		},

		getTenant: function() {
			return this.ctenant;
		},

		_createApiName: function() {
			var str = '/api';
			if (this.ctenant) {
				str = str + '[' + this.ctenant + ']';
			}
			str = str + '/';
			this.apiName = str;
		},

		setDescription: function(description) {
			this.description = description;
		},

		getDescription: function() {
			return this.description;
		},

		setLocale: function(locale) {
			this.locale = locale;
		},

		getLocale: function() {
			return this.locale;
		},

		isPublished: function() {
			return this.published;
		},

		setPublished: function(published) {
			this.published = published;
		},

		isExtendable: function() {
			return this.extendable;
		},

		setExtendable: function(extendable) {
			this.extendable = extendable;
		},

		getDefaultLocaleData: function() {
			return this.getLocaleData("default");
		},

		getParent: function() {
			return this.parent;
		},

		setParent: function(parent) {
			this.parent = parent;
		},

		setLocaleData: function(locale) {
			if (!this.locales) {
				this.locales = new Array();
			}
			var found = false;
			for (var i = 0; i < this.locales.length; i++) {
				var loc = this.locales[i];
				if (loc.name == locale.name) {
					this.locales[i] = locale;
					found = true;
				}
			}

			if (!found) {
				this.locales.push(locale);
			}
		},

		getLocaleData: function(name) {
			if (!name) {
				name = this.language;
			}
			return this._getLocaleData(name);
		},

		_getLocaleData: function(name) {
			var locale = null;
			if (this.locales) {
				for (var i = 0; i < this.locales.length; i++) {
					var loc = this.locales[i];
					if (loc.name == name) {
						locale = loc;
						break;
					}
				}
			}
			return locale;
		},

		getStrings: function() {
			if (!this.strings) {
				var strings = {};
				var def = this.getDefaultLocaleData();
				var locale = this.getLocaleData();
				if (def) {
					var strs = {};
					if (def.data && def.data.custom) {
						strs = def.data.custom;
					}
					for (var i = 0; i < strs.length; i++) {
						var str = strs[i];
						strings[str.name] = str.value;
					}
					if (locale && locale.data) {
						strs = locale.data.custom;
						if (strs) {
							for (var i = 0; i < strs.length; i++) {
								var str = strs[i];
								if (str) {
									if (strings[str.name] && str.value) {
										strings[str.name] = str.value;
									}
								}
							}
						}
					}
				}
				if (this.terms) {
					lang.mixin(strings, this.terms);
				}
				this.strings = strings;
			}
			return this.strings;
		},

		getString: function(name, vars) {
			var value = null;
			var strings = this.getStrings();
			var str = strings[name];
			if (str) {
				value = this.replaceTerms(str, vars);
			} else {
				value = '#' + name;
			}
			return value;
		},

		getTemplates: function() {
			return this.templates;
		},

		getTemplate: function(name) {
			var template = null;
			for (var i = 0; i < this.templates.length; i++) {
				if (this.templates[i].name == name) {
					template = this.templates[i];
					break;
				}
			}
			return template;
		},

		replaceTerms: function(str, vars) {
            var terms = lang.mixin({}, this.getStrings());
			if (vars) {
			    lang.mixin(terms, vars);
			}
			var res = string.substitute(str, terms, null, StringFormatters);

			if (res !== str) {
				return this.replaceTerms(res, vars);
			} else {
				return res;
			}
		},

		substituteString: function(template, data) {
			var ctx = {
				data: data,
				string: this.strings
			};
			return string.substitute(template, ctx);
		},

		getType: function() {
			return this.type;
		},

		getStore: function() {
			return this._models;
		},

		getResources: function() {
		    return this.resources;
		},

		getResourceById: function(id) {
			var resource = null;
			for (var i = 0; i < this.resources.length; i++) {
				if (this.resources[i].id == id) {
					resource = this.resources[i];
					break;
				}
			}
			return resource;
		},

		getResourceByName: function(name) {
			var resource = null;
			for (var i = 0; i < this.resources.length; i++) {
				if (this.resources[i].filename == name) {
					resource = this.resources[i];
					break;
				}
			}
			return resource;
		},

		getRules: function() {
			return this.rules;
		},

		getRule: function(name) {
			var rule = null;
			for (var i = 0; i < this.rules.length; i++) {
				var r = this.rules[i];
				if (r.name == name) {
					rule = r;
					break;
				}
			}
			return rule;
		},

		setLocales: function(locales) {
			this.locales = locales;
		},

		getLocales: function() {
			return this.locales;
		},

		getIntegration: function(name) {
			var integration = null;
			if (this.integrations) {
				for (var i = 0; i < this.integrations.length; i++) {
					var ig = this.integrations[i];
					if (ig.name == name || ig.id == name) {
						integration = ig;
						break;
					}
				}
			}
			return integration;
		},

		getFeatures: function() {
			return this.features;
		},

		setFeatures: function(features) {
			this.featureIndex = {};
			this.features = new Array();
			if (features) {
				for (var i = 0; i < features.length; i++) {
					features[i].schema = this;
					var feature = new Feature(features[i]);
					this.features.push(feature);
					this.featureIndex[feature.name] = feature;
					this.featureIndex[feature.id] = feature;
				}
			}
		},

		getActions: function() {
			return this.actions;
		},

		getActionByName: function(name) {
			var action = null;
			for (var i in this.actions) {
				if (this.actions[i].name == name) {
					action = this.actions[i];
					break;
				}
			}
			return action;
		},

		getFeature: function(name) {
			var id = name;
			if (lang.isObject(name)) {
				id = name.id;
			}
			return this.featureIndex[id];
		},

		getParams: function() {
			return this.params;
		},

		setParams: function(params) {
			this.params = params;
		},

		getParamById: function(id) {
			var param = null;
			for (var i = 0; i < this.params.length; i++) {
				if (this.params[i].id == id) {
					param = this.params[i];
					break;
				}
			}
			return param;
		},

		getQueries: function() {
			return this.queries;
		},

		getQuery: function(id) {
			var query = null;
			for (var i in this.queries) {
				if (this.queries[i].id == id) {
					query = this.queries[i];
					break;
				}
			}
			return query;
		},

		getQueryByName: function(name) {
			var query = null;
			for (var i in this.queries) {
				if (this.queries[i].name == name) {
					query = this.queries[i];
					break;
				}
			}
			return query;
		},

		setQuery: function(query) {
			var done = false;
			if (!this.queries) {
				this.queries = new Array();
			}
			if (!query.id) {
				Identity.prepareItemId(query);
			}
			for (var i in this.queries) {
				var q = this.queries[i];
				if (q.id == query.id) {
					if (q.name != query.name) {
						this._publishEvent('queryNameChange', {
							oldName: q.name,
							newName: query.name
						});
					}
					this.queries[i] = query;
					done = true;
					break;
				}
			}
			if (!done) {
				this.queries.push(query);
			}
		},

		removeQuery: function(id) {
			for (var i in this.queries) {
				if (this.queries[i].id == id) {
					this.queries.splice(i, 1);
					break;
				}
			}
		},

		getTenantId: function() {
			return this.tenantId;
		},

		getURI: function() {
			return client.getURI('/api/app/' + this.name + '/');
		},

		getResourceURI: function(id) {
			if (typeof id === 'object') {
				id = id.id;
			} else if (typeof id === 'string') {
				var rsrc = this.getResourceByName(id);
				if (rsrc) {
					id = rsrc.id;
				}
			}
			return client.getURI('/resources/' + this.name + '/' + id);
		},

		getTransactionURI: function() {
			return this.getURI() + 'tx';
		},

		createModel: function(name, type) {
			var model = new appivo.model.Model({
				name: name,
				type: type,
				schema: this
			});
			Identity.prepareItemId(model);
			this._models.add(model);
			return model;
		},

		addModel: function(model) {
			Identity.prepareItemId(model);
			this._addModel(model);
		},

		_addModel: function(model) {
			model.schema = this;
			this._models.add(model);
		},

		importModel: function(model, name) {
			var imported = new Model({
				imported: true,
				name: name,
				schema: this,
				imports: model.getSchema().getName() + "/" + model.getId()
			});
			Identity.prepareItemId(imported);
			var attrs = model.getAttributes();
			for (var i in attrs) {
				var attr = attrs[i];
				var iattr = new Attribute(attr);
				imported.setAttribute(iattr);
			}
			this._models.add(imported);
			return imported;
		},

		getModel: function(name) {
			var model = null;
			var result = this._models.query({name: name});
			if (result[0]) {
				model = result[0];
			}
			return model;
		},

		getModelId: function(name) {
			var id = null;
			var model = this.getModel(name);
			if (model) {
				id = model.id;
			}
			return id;
		},

		getModelById: function(id) {
			return this._models.get(id);
		},

		getSampleModel: function() {
			sampleData.schema = this;
			var model = new SampleModel(sampleData);
            // This does not work
			// model.getStore().setData(sampleData.records);
			return model;
		},

		deleteModel: function(name) {
			var ok = false;
			var model = this.getModel(name);
			if (model != null) {
				this.deleteModelById(model.id);
				ok = true;
			}
			return ok;
		},

		deleteModelById: function(id) {
			var model = this.getModelById(id);
			this._models.remove(id);
			this._onDeleteModel(model);
		},

		getModels: function() {
			return this._models.query({}, {
				sort: [
				  {
					  attribute: 'name'
				  }
				]
			});
		},

		getAgents: function() {
			return this.agents;
		},

		getSearchIndexes: function() {
			return this.searchIndexes;
		},

		createCounter: function(name) {
			var counter = {
				name: name
			};
			Identity.prepareItemId(counter);
			this.addCounter(counter);
			return counter;
		},

		getCounters: function() {
			return this._counters.query({});
		},

		addCounter: function(counter) {
			Identity.prepareItemId(counter);
			this._counters.add(counter);
		},

		getCounterId: function(name) {
			var id = null;
			var counter = this.getCounter(name);
			if (counter) {
				id = counter.id;
			}
			return id;
		},

		deleteCounterById: function(id) {
			this._counters.remove(id);
		},

		getCounter: function(name) {
			var counter = null;
			var result = this._counters.query({name: name});
			if (result[0]) {
				counter = result[0];
			}
			return counter;
		},

		getCounterById: function(id) {
			return this._counters.get(id);
		},

		getRelations: function() {
			var rels = new Array();
			for (var i in this.relations) {
				var rel = this.relations[i];
				rels.push(rel);
			}
			return rels;
		},

		getRelationsForModel: function(model) {
			var rels = new Array();
			for (var i in this.relations) {
				var rel = this.relations[i];
				if (this.metaSchema || !rel.isHidden()) {
					var srcId = null;
					var destId = null;
					var src = rel.getSource();
					var dest = rel.getDestination();
					if (src) {
						srcId = src.id;
					}
					if (dest) {
						destId = dest.id;
					}
					if ((srcId == model.id || destId == model.id) && (src && dest)) {
						rels.push(rel);
					}
				}
			}
			return rels;
		},

		setModelRelations: function(model, relations) {
			this._clearModelRelations(model);
			for (var i in relations) {
				var rel = relations[i];
				this.relations[rel.id] = rel;
				rel.getSource()._clearCachedRelations();
				rel.getDestination()._clearCachedRelations();
			}
		},

		setRelations: function(relations) {
			this.clearRelations();
			var rels = {};
			for (var i in relations) {
				var rel = relations[i];
				rels[rel.id] = rel;
			}
			this.relations = rels;
		},

		clearRelations: function() {
			var models = this.getModels();
			models.forEach(function(m) {
				m._clearCachedRelations();
			});
		},

		resolveReference: function(ref) {
			var obj = null;
			if (ref) {
				var elms = ref.split(/[.#@]+/);
				obj = this.getModel(elms[0]);
				for (var i = 1; i < elms.length; i++) {
					if (i == (elms.length - 1)) {
						obj = obj.getAttribute(elms[i]);
					} else {
						var rel = obj.getRelationship(elms[i]);
						if (obj) {
							obj = rel.getDestination();
						} else {
							obj = null;
							break;
						}
					}
				}
			}
			return obj;
		},

		_clearModelRelations: function(model) {
			var relations = {};
			for (var i in this.relations) {
				var rel = this.relations[i];
				if (rel.getSource() != model && rel.getDestination() != model) {
					relations[rel.id] = rel;
				} else if (this.metaSchema || !rel.isHidden()) {
					rel.getSource()._clearCachedRelations();
					rel.getDestination()._clearCachedRelations();
				}
			}
			this.relations = relations;
		},

		_clearQueries: function(model) {
			var toDelete = new Array();
			for (var i in this.queries) {
				var query = this.queries[i];
				if (query.getFrom().getModelName() == model.getName()) {
					toDelete.push(query);
				}
			}
			for (var i = 0; i < toDelete.length; i++) {
				var query = toDelete[i];
				this.removeQuery(query.id);
				this._publishEvent("queryDeleted", {
					query: query
				});
			}
		},

		getRoles: function() {
			return this.roles;
		},

		hasUserInterface: function(name) {
			var ok = false;
			if (this.userInterfaceIndex[name]) {
				ok = true;
			}
			return ok;
		},

		getUserInterfaces: function() {
			var uis = new Array();
			for (var i in this.userInterfaceIndex) {
				uis.push(this.userInterfaceIndex[i]);
			}
			return uis;
		},

		getUserInterface: function(name) {
			return this.userInterfaceIndex[name];
		},

		getUserPrivileges: function() {
			var def = new Deferred();
			var headers = {};
			if (this.ctenant) {
				headers['X-Tenant'] = this.ctenant;
			}
			client.sendRequest(this.getURI() + 'context', {
				uriComplete: true,
				headers: headers
			}).then(lang.hitch(this, function(data) {
				def.resolve(this._setUserContext(data));
			}), function(err) {
				def.reject(err);
			}, function(event) {
				def.progress(event);
			});
			return def.promise;
		},

		getMobilePlugins: function() {
			return this.mobilePlugins;
		},

		setMobilePlugins: function(plugins) {
			this.mobilePlugins = plugins;
		},

		getMobilePrivileges: function() {
			return this.mobilePrivileges;
		},

		setMobilePrivileges: function(plugins) {
			this.mobilePrivileges = plugins;
		},

		executeTransaction: function(tx, options) {
			options = options || {};
			var opts = {
				method: 'POST',
				url: this.getTransactionURI(),
				customData: true,
				data: tx,
				onSuccess: options.onSuccess,
				onError: options.onError
			};

			var headers = {
				'Content-Type': 'application/json'
			};

			var tenant = this.schema.getTenant();
			if (tenant) {
				headers['X-Tenant'] = tenant;
			}

			var def = client.sendRequest(opts.url, {
				uriComplete: true,
				method: opts.method,
				handleAs: 'json',
				headers: headers,
				withCredentials: true,
				data: JSON.stringify(opts.data)
			}).then(opts.onSuccess, opts.onError);
		},

		/**
		 * Write an entry to the application-log.
		 * Opts should hold:
		 *
		 *  - level (logging level DEBUG, INFO, ERROR, WARN)
		 *  - entry_id (ID of logging source)
		 *  - entry_name (Name of logging source)
		 *  - entry_type (Type of logging source)
		 *  - message (Logged message)
		 *  - line (Source linenumber)
		 *  - column (Source column)
		 */
		logEntry: function(opts) {
			var t = this;
			if (lang.isObject(opts.message) && !lang.isString(opts.message)) {
				try {
					opts.message = JSON.stringify(opts.message);
				} catch (error) {
					opts.message = opts.message.toString();
				}
			}
			
			var headers = {
				'Content-Type': 'application/json'
			};
			if (opts.level === "ERROR") {
				console.error(opts.message);
			}

			logEntries.push(opts);

			if (!logTimer) {
				logTimer = setTimeout(function() {
					logTimer = null;
					var logs = logEntries;
					logEntries = [];
					var url = t.getURI() + 'log';
					try {
						console.log("Uploading logs...");
						if (t.flightRecorder) {
							var events = t.flightRecorder.getEvents();
							console.log("FlightRecorder:");
							console.table(events);
						}
						client.sendRequest(url, {
							method: 'POST',
							headers: headers,
							handleAs: 'json',
							withCredentials: true,
							data: JSON.stringify(logs)
						}).then(function() {
							console.log("Logs uploaded successfully.");
						}, function(err) {
							console.log("Failed to upload logs");
							// reappend logs
							logEntries = logs.concat(logEntries);
						})
					} catch (error) {
						console.error("Failed to send logging-event to cloud");
						console.error(error);
					}
				}, LOG_DELAY);
			} else {
				// logging already scheduled
			}
		},

		_setUserContext: function(data) {
			this._createAppConfig(data);
			this._createUserPrivilegeMap(data.privileges);
			this._setAvailableFeatures(data.features);
			if (data.domain) {
				client.setAppDomain(data.domain);
			} else {
				client.setAppDomain(null);
			}
		},

		getDefaultAppConfig: function() {
			var config = {};
			for (var i = 0; i < this.params.length; i++) {
				var param = this.params[i];
				config[param.name] = param.defaultValue;
			}
			return config;
		},

		getConfigDefault: function(param) {
			return this.params[param];
		},

		_setAvailableFeatures: function(features) {
			this.availableFeatures = {};
			if (features) {
				for (var i = 0; i < features.length; i++) {
					var feature = this.getFeature(features[i].feature_id);
					if (feature) {
						this.availableFeatures[feature.id] = feature;
						this.availableFeatures[feature.name] = feature;
					}
				}
			}
		},

		getAvailableFeatures: function() {
			return this.availableFeatures;
		},

		_createAppConfig: function(data) {
			var config = this.getDefaultAppConfig();
			if (data.config && data.config.config) {
				lang.mixin(config, data.config.config);
			}
			if (data.config && data.config.terms) {
				this.terms = data.config.terms;
			}
			client.setAppConfig(config);
		},

		_createUserPrivilegeMap: function(data) {
			var privs = {};
			for (var i in data) {
				var p = data[i];
				var mdata = privs[p.model];
				if (!mdata) {
					mdata = {};
					privs[p.model] = mdata;
				}
				mdata[p.privilege] = true;
			}
			this.userPrivileges = privs;
			return privs;
		},

		hasUserPrivileges: function(privs) {
			var ok = true;
			var up = this.userPrivileges;
			for (var i in privs) {
				var priv = privs[i];
				var has = up[priv.model] && up[priv.model][priv.privilege];
				if (priv.has && !has) {
					ok = false;
					break;
				} else if (!priv.has && has) {
					ok = false;
					break;
				}
			}
			return ok;
		},

		hasFeatures: function(features) {
			var ok = true;
			if (features) {
				for (var i = 0; i < features.length; i++) {
					var feature = features[i];
					if (!this.availableFeatures[feature]) {
						ok = false;
						break;
					}
				}
			}
			return ok;
		},

		_onDeleteModel: function(model) {
			this._clearModelRelations(model);
			this._clearQueries(model);
			this._publishEvent('modelDeleted', {
				model: model
			});
		},

		_publishEvent: function(eventName, data) {
			this.emit(eventName, data);
		},

		isUpdateAvailable: function() {
			var t = this;
			console.log("Getting version of application " + this.name + "(current version is " + this.ver + ")");
			var def = new Deferred();
			client.sendRequest(client.getURI("/api/app/" + this.name + "/version"), {
				method: "GET"
			}).then(function(res) {
				console.log("Version " + res.version + " is present in the cloud");
				var available = res.version != t.ver;
				if (available) {
					console.log("An update is available");
				} else {
					console.log("No update is available");
				}
				def.resolve(available);
			}, function(error) {
				console.error("Failed to check application version");
				def.reject(error);
			});
			return def;
		},

		update: function() {
			var t = this;
			var headers = {};
			if (this.complete) {
				headers = {
					'X-Complete' : 'Yes'
				};
			}
			if (this.localized) {
				headers = {
					'X-Language' : client.getPreferredLanguages()
				};
			}
			if (this.hybrid) {
				headers['X-Hybrid'] = 'Yes';
			}
			var def = new Deferred();
			console.log("Updating app " + this.name + "(version=" + this.ver + ")");
			var req = client.sendRequest(client.getURI('/api/app/' + this.name), {
				method: 'GET',
				headers: headers,
				handleAs: 'json'
			});
			req.response.then(function(response) {
				var data = response.data;
				data.selectedLocale = lang;
				if (data.ver != t.ver) {
					console.log("Updating to version " + data.ver);
					t._setData(data);
					if (t.schemaManager) {
						t._cacheSchema(data);
					}
					def.resolve(true);
				} else {
					console.log("No update available");
					def.resolve(false);
				}
			}, function(error) {
				def.reject(error);
			});
			return def;
		},

		toJSON: function(full) {
			var mdl = new Array();
			var models = this.getModels().forEach(function(m) {
				mdl.push(m.toJSON(full));
			});

			var counters = new Array();
			this.getCounters().forEach(function(c) {
				Identity.cleanItemId(c);
				counters.push(c);
			});

			var searchIndexes = [];
			this.getSearchIndexes().forEach(function(si) {
				Identity.cleanItemId(si);
				searchIndexes.push(si.toJSON());
			});

			var agents = [];
			this.getAgents().forEach(function(agent) {
				Identity.cleanItemId(agent);
				agents.push(agent.toJSON());
			});

			var relations = new Array();
			for (var i in this.relations) {
				var rel = this.relations[i];
				if (this.metaSchema || !rel.isHidden()) {
					relations.push(rel.toJSON());
				}
			}

			var locales = new Array();
			if (this.locales) {
				for (var i in this.locales) {
					locales.push(this.locales[i].toJSON());
				}
			}

			var rules = new Array();
			if (this.rules) {
				for (var i in this.rules) {
					rules.push(this.rules[i].toJSON());
				}
			}

			var actions = new Array();
			if (this.actions) {
				for (var i in this.actions) {
					actions.push(this.actions[i].toJSON());
				}
			}

			var queries = new Array();
			if  (this.queries) {
				for (var i in this.queries) {
					queries.push(this.queries[i].toJSON());
				}
			}

			var params = new Array();
			if (this.params) {
				for (var i = 0; i < this.params.length; i++) {
					params.push(this.params[i].toJSON());
				}
			}

			var features = new Array();
			if (this.features) {
				for (var i = 0; i < this.features.length; i++) {
					features.push(this.features[i].toJSON());
				}
			}

			var roles = new Array();
			if (this.roles) {
				for (var i = 0; i < this.roles.length; i++) {
					roles.push(cloneObject(this.roles[i]));
				}
			}

			var templates = new Array();
			if (this.templates) {
				for (var i = 0; i < this.templates.length; i++) {
					templates.push(cloneObject(this.templates[i]));
				}
			}

			var mobilePlugins = [];
			if (this.mobilePlugins) {
				for (var i = 0; i < this.mobilePlugins.length; i++) {
					var plugin = cloneObject(this.mobilePlugins[i]);
					plugin.platforms = JSON.parse(plugin.platforms);
					mobilePlugins.push(plugin);
				}
			}

			var mobilePrivileges = [];
			if (this.mobilePrivileges) {
				for (var i = 0; i < this.mobilePrivileges.length; i++) {
					var priv = cloneObject(this.mobilePrivileges[i]);
					mobilePrivileges.push(priv);
				}
			}

			var licenses = [];
			if (this.licenses) {
			    for (var i = 0; i < this.licenses.length; i++) {
			        var license = cloneObject(this.licenses[i]);
			        licenses.push(license);
			    }
			}

			var resources = this.resources;

			var devices = [];
			if (this.devices) {
			    for (var i = 0; i < this.devices.length; i++) {
			        var device = cloneObject(this.devices[i]);
			        devices.push(device);
			    }
			}

			var uis = cloneObject(this.userInterfaces);
			var whiteLabel = cloneObject(this.whiteLabel);
			var integrations = cloneObject(this.integrations);

			var schema = {
				id: this.id,
				ver: this.ver,
				name: this.name,
				description: this.description,
				locale: this.locale,
				extendable: this.extendable,
				published: this.published,
				'public': this.public,
				ancestor: this.ancestor,
				parent: this.parent,
				tenantId: this.tenantId,
				models: mdl,
				relations: relations,
				searchIndexes: searchIndexes,
				counters: counters,
				integrations: integrations,
				roles: roles,
				defaultRole: this.defaultRole,
				agents: agents,
				rules: rules,
				features: features,
				locales: locales,
				actions: actions,
				queries: queries,
				templates: templates,
				resources: resources,
				devices: devices,
				userInterfaces: uis,
				params: params,
				mobilePlugins: mobilePlugins,
				mobilePrivileges: mobilePrivileges,
				licenses: licenses,
				whiteLabel: whiteLabel
			}

			if (!schema.id) {
				delete schema.id;
			}

			return schema;
		}
	})
});

},
'dojo/store/Memory':function(){
define(["../_base/declare", "./util/QueryResults", "./util/SimpleQueryEngine" /*=====, "./api/Store" =====*/],
function(declare, QueryResults, SimpleQueryEngine /*=====, Store =====*/){

// module:
//		dojo/store/Memory

// No base class, but for purposes of documentation, the base class is dojo/store/api/Store
var base = null;
/*===== base = Store; =====*/

return declare("dojo.store.Memory", base, {
	// summary:
	//		This is a basic in-memory object store. It implements dojo/store/api/Store.
	constructor: function(options){
		// summary:
		//		Creates a memory object store.
		// options: dojo/store/Memory
		//		This provides any configuration information that will be mixed into the store.
		//		This should generally include the data property to provide the starting set of data.
		for(var i in options){
			this[i] = options[i];
		}
		this.setData(this.data || []);
	},
	// data: Array
	//		The array of all the objects in the memory store
	data:null,

	// idProperty: String
	//		Indicates the property to use as the identity property. The values of this
	//		property should be unique.
	idProperty: "id",

	// index: Object
	//		An index of data indices into the data array by id
	index:null,

	// queryEngine: Function
	//		Defines the query engine to use for querying the data store
	queryEngine: SimpleQueryEngine,
	get: function(id){
		// summary:
		//		Retrieves an object by its identity
		// id: Number
		//		The identity to use to lookup the object
		// returns: Object
		//		The object in the store that matches the given id.
		return this.data[this.index[id]];
	},
	getIdentity: function(object){
		// summary:
		//		Returns an object's identity
		// object: Object
		//		The object to get the identity from
		// returns: Number
		return object[this.idProperty];
	},
	put: function(object, options){
		// summary:
		//		Stores an object
		// object: Object
		//		The object to store.
		// options: dojo/store/api/Store.PutDirectives?
		//		Additional metadata for storing the data.  Includes an "id"
		//		property if a specific id is to be used.
		// returns: Number
		var data = this.data;
		var index = this.index;
		var idProperty = this.idProperty;
		var id = object[idProperty] = (options && "id" in options) ?
			options.id : idProperty in object ? object[idProperty] : Math.random();
		var defaultDestination = data.length;
		var newIndex;
		var previousIndex;
		var eventType = id in index ? "update" : "add";

		if(eventType === "update"){
			if(options && options.overwrite === false){
				throw new Error("Object already exists");
			}
			else{
				previousIndex = index[id];
				defaultDestination = previousIndex;
			}
		}

		if(options && "before" in options){
			if(options.before == null){
				newIndex = data.length;
				if(eventType === "update"){
					--newIndex;
				}
			}
			else{
				newIndex = index[this.getIdentity(options.before)];
				// Account for the removed item
				if(previousIndex < newIndex){
					--newIndex;
				}
			}
		}
		else{
			newIndex = defaultDestination;
		}

		if(newIndex === previousIndex){
			data[newIndex] = object;
		}
		else{
			if(previousIndex !== undefined){
				data.splice(previousIndex, 1);
			}
			data.splice(newIndex, 0, object);
			this._rebuildIndex(previousIndex === undefined ? newIndex : Math.min(previousIndex, newIndex));
		}

		return id;
	},
	add: function(object, options){
		// summary:
		//		Creates an object, throws an error if the object already exists
		// object: Object
		//		The object to store.
		// options: dojo/store/api/Store.PutDirectives?
		//		Additional metadata for storing the data.  Includes an "id"
		//		property if a specific id is to be used.
		// returns: Number
		(options = options || {}).overwrite = false;
		// call put with overwrite being false
		return this.put(object, options);
	},
	remove: function(id){
		// summary:
		//		Deletes an object by its identity
		// id: Number
		//		The identity to use to delete the object
		// returns: Boolean
		//		Returns true if an object was removed, falsy (undefined) if no object matched the id
		var index = this.index;
		var data = this.data;
		if(id in index){
			data.splice(index[id], 1);
			this.index = {};
			this._rebuildIndex();
			return true;
		}
	},
	query: function(query, options){
		// summary:
		//		Queries the store for objects.
		// query: Object
		//		The query to use for retrieving objects from the store.
		// options: dojo/store/api/Store.QueryOptions?
		//		The optional arguments to apply to the resultset.
		// returns: dojo/store/api/Store.QueryResults
		//		The results of the query, extended with iterative methods.
		//
		// example:
		//		Given the following store:
		//
		// 	|	var store = new Memory({
		// 	|		data: [
		// 	|			{id: 1, name: "one", prime: false },
		//	|			{id: 2, name: "two", even: true, prime: true},
		//	|			{id: 3, name: "three", prime: true},
		//	|			{id: 4, name: "four", even: true, prime: false},
		//	|			{id: 5, name: "five", prime: true}
		//	|		]
		//	|	});
		//
		//	...find all items where "prime" is true:
		//
		//	|	var results = store.query({ prime: true });
		//
		//	...or find all items where "even" is true:
		//
		//	|	var results = store.query({ even: true });
		return QueryResults(this.queryEngine(query, options)(this.data));
	},
	setData: function(data){
		// summary:
		//		Sets the given data as the source for this store, and indexes it
		// data: Object[]
		//		An array of objects to use as the source of data.
		if(data.items){
			// just for convenience with the data format IFRS expects
			this.idProperty = data.identifier || this.idProperty;
			data = this.data = data.items;
		}else{
			this.data = data;
		}
		this.index = {};
		this._rebuildIndex();
	},
	_rebuildIndex: function(startIndex){
		var data = this.data;
		var dataLength = data.length;
		var i;

		startIndex = startIndex || 0;

		for(i = startIndex; i < dataLength; i++){
			this.index[data[i][this.idProperty]] = i;
		}
	}
});

});

},
'dojo/store/util/QueryResults':function(){
define(["../../_base/array", "../../_base/lang", "../../when"
], function(array, lang, when){

// module:
//		dojo/store/util/QueryResults

var QueryResults = function(results){
	// summary:
	//		A function that wraps the results of a store query with additional
	//		methods.
	// description:
	//		QueryResults is a basic wrapper that allows for array-like iteration
	//		over any kind of returned data from a query.  While the simplest store
	//		will return a plain array of data, other stores may return deferreds or
	//		promises; this wrapper makes sure that *all* results can be treated
	//		the same.
	//
	//		Additional methods include `forEach`, `filter` and `map`.
	// results: Array|dojo/promise/Promise
	//		The result set as an array, or a promise for an array.
	// returns:
	//		An array-like object that can be used for iterating over.
	// example:
	//		Query a store and iterate over the results.
	//
	//	|	store.query({ prime: true }).forEach(function(item){
	//	|		//	do something
	//	|	});

	if(!results){
		return results;
	}

	var isPromise = !!results.then;
	// if it is a promise it may be frozen
	if(isPromise){
		results = lang.delegate(results);
	}
	function addIterativeMethod(method){
		// Always add the iterative methods so a QueryResults is
		// returned whether the environment is ES3 or ES5
		results[method] = function(){
			var args = arguments;
			var result = when(results, function(results){
				Array.prototype.unshift.call(args, results);
				return QueryResults(array[method].apply(array, args));
			});
			// forEach should only return the result of when()
			// when we're wrapping a promise
			if(method !== "forEach" || isPromise){
				return result;
			}
		};
	}

	addIterativeMethod("forEach");
	addIterativeMethod("filter");
	addIterativeMethod("map");
	if(results.total == null){
		results.total = when(results, function(results){
			return results.length;
		});
	}
	return results; // Object
};

lang.setObject("dojo.store.util.QueryResults", QueryResults);

return QueryResults;

});

},
'dojo/store/util/SimpleQueryEngine':function(){
define(["../../_base/array" /*=====, "../api/Store" =====*/], function(arrayUtil /*=====, Store =====*/){

// module:
//		dojo/store/util/SimpleQueryEngine

return function(query, options){
	// summary:
	//		Simple query engine that matches using filter functions, named filter
	//		functions or objects by name-value on a query object hash
	//
	// description:
	//		The SimpleQueryEngine provides a way of getting a QueryResults through
	//		the use of a simple object hash as a filter.  The hash will be used to
	//		match properties on data objects with the corresponding value given. In
	//		other words, only exact matches will be returned.
	//
	//		This function can be used as a template for more complex query engines;
	//		for example, an engine can be created that accepts an object hash that
	//		contains filtering functions, or a string that gets evaluated, etc.
	//
	//		When creating a new dojo.store, simply set the store's queryEngine
	//		field as a reference to this function.
	//
	// query: Object
	//		An object hash with fields that may match fields of items in the store.
	//		Values in the hash will be compared by normal == operator, but regular expressions
	//		or any object that provides a test() method are also supported and can be
	//		used to match strings by more complex expressions
	//		(and then the regex's or object's test() method will be used to match values).
	//
	// options: dojo/store/api/Store.QueryOptions?
	//		An object that contains optional information such as sort, start, and count.
	//
	// returns: Function
	//		A function that caches the passed query under the field "matches".  See any
	//		of the "query" methods on dojo.stores.
	//
	// example:
	//		Define a store with a reference to this engine, and set up a query method.
	//
	//	|	var myStore = function(options){
	//	|		//	...more properties here
	//	|		this.queryEngine = SimpleQueryEngine;
	//	|		//	define our query method
	//	|		this.query = function(query, options){
	//	|			return QueryResults(this.queryEngine(query, options)(this.data));
	//	|		};
	//	|	};

	// create our matching query function
	switch(typeof query){
		default:
			throw new Error("Can not query with a " + typeof query);
		case "object": case "undefined":
			var queryObject = query;
			query = function(object){
				for(var key in queryObject){
					var required = queryObject[key];
					if(required && required.test){
						// an object can provide a test method, which makes it work with regex
						if(!required.test(object[key], object)){
							return false;
						}
					}else if(required != object[key]){
						return false;
					}
				}
				return true;
			};
			break;
		case "string":
			// named query
			if(!this[query]){
				throw new Error("No filter function " + query + " was found in store");
			}
			query = this[query];
			// fall through
		case "function":
			// fall through
	}
	function execute(array){
		// execute the whole query, first we filter
		var results = arrayUtil.filter(array, query);
		// next we sort
		var sortSet = options && options.sort;
		if(sortSet){
			results.sort(typeof sortSet == "function" ? sortSet : function(a, b){
				for(var sort, i=0; sort = sortSet[i]; i++){
					var aValue = a[sort.attribute];
					var bValue = b[sort.attribute];
					// valueOf enables proper comparison of dates
					aValue = aValue != null ? aValue.valueOf() : aValue;
					bValue = bValue != null ? bValue.valueOf() : bValue;
					if (aValue != bValue){
						return !!sort.descending == (aValue == null || aValue > bValue) ? -1 : 1;
					}
				}
				return 0;
			});
		}
		// now we paginate
		if(options && (options.start || options.count)){
			var total = results.length;
			results = results.slice(options.start || 0, (options.start || 0) + (options.count || Infinity));
			results.total = total;
		}
		return results;
	}
	execute.matches = query;
	return execute;
};

});

},
'dojo/store/Observable':function(){
define(["../_base/lang", "../when", "../_base/array" /*=====, "./api/Store" =====*/
], function(lang, when, array /*=====, Store =====*/){

function findObject(store, data, id, start, end){
	var i;

	start = start == undefined ? 0 : start;
	end = end == undefined ? data.length : end;

	for (i = start; i < end; ++i) {
		if (store.getIdentity(data[i]) === id) {
			return i;
		}
	}

	return -1;
}

// module:
//		dojo/store/Observable

var Observable = function(/*Store*/ store){
	// summary:
	//		The Observable store wrapper takes a store and sets an observe method on query()
	//		results that can be used to monitor results for changes.
	//
	// description:
	//		Observable wraps an existing store so that notifications can be made when a query
	//		is performed.
	//
	// example:
	//		Create a Memory store that returns an observable query, and then log some
	//		information about that query.
	//
	//	|	var store = Observable(new Memory({
	//	|		data: [
	//	|			{id: 1, name: "one", prime: false},
	//	|			{id: 2, name: "two", even: true, prime: true},
	//	|			{id: 3, name: "three", prime: true},
	//	|			{id: 4, name: "four", even: true, prime: false},
	//	|			{id: 5, name: "five", prime: true}
	//	|		]
	//	|	}));
	//	|	var changes = [], results = store.query({ prime: true });
	//	|	var observer = results.observe(function(object, previousIndex, newIndex){
	//	|		changes.push({previousIndex:previousIndex, newIndex:newIndex, object:object});
	//	|	});
	//
	//		See the Observable tests for more information.

	var undef, queryUpdaters = [], revision = 0;
	// a Comet driven store could directly call notify to notify observers when data has
	// changed on the backend
	// create a new instance
	store = lang.delegate(store);

	store.notify = function(object, existingId, storeMethodOptions){
		revision++;
		var updaters = queryUpdaters.slice();
		for(var i = 0, l = updaters.length; i < l; i++){
			updaters[i](object, existingId, storeMethodOptions);
		}
	};
	var originalQuery = store.query;
	store.query = function(query, options){
		options = options || {};
		var results = originalQuery.apply(this, arguments);
		if(results && results.forEach){
			var nonPagedOptions = lang.mixin({}, options);
			delete nonPagedOptions.start;
			delete nonPagedOptions.count;

			var queryExecutor = store.queryEngine && store.queryEngine(query, nonPagedOptions);
			var queryRevision = revision;
			var listeners = [], queryUpdater;
			results.observe = function(listener, includeObjectUpdates){
				if(listeners.push(listener) == 1){
					// first listener was added, create the query checker and updater
					queryUpdaters.push(queryUpdater = function(changed, existingId, storeMethodOptions){
						var beforeId =  storeMethodOptions &&
							storeMethodOptions.before &&
							store.getIdentity(storeMethodOptions.before);

						when(results, function(resultsArray){
							var atEnd = resultsArray.length != options.count;
							var i, l, listener;
							if(++queryRevision != revision){
								throw new Error("Query is out of date, you must observe() the query prior to any data modifications");
							}
							var removedObject, removedFrom = -1, insertedInto = -1;
							var beforeIndex;
							if(existingId !== undef){
								// remove the old one
								var filteredArray = [].concat(resultsArray);
								if(queryExecutor && !changed){
									filteredArray = queryExecutor(resultsArray);
								}
								for(i = 0, l = resultsArray.length; i < l; i++){
									var object = resultsArray[i];
									if(store.getIdentity(object) == existingId){
										if(filteredArray.indexOf(object)<0) continue;
										removedObject = object;
										removedFrom = i;
										if(queryExecutor || !changed){// if it was changed and we don't have a queryExecutor, we shouldn't remove it because updated objects would be eliminated
											resultsArray.splice(i, 1);
										}
										break;
									}
								}
							}
							if(queryExecutor){
								// add the new one
								if(changed &&
										// if a matches function exists, use that (probably more efficient)
										(queryExecutor.matches ? queryExecutor.matches(changed) : queryExecutor([changed]).length)){

									var firstInsertedInto = removedFrom > -1 ?
										removedFrom : // put back in the original slot so it doesn't move unless it needs to (relying on a stable sort below)
										resultsArray.length;
									resultsArray.splice(firstInsertedInto, 0, changed); // add the new item
									insertedInto = array.indexOf(queryExecutor(resultsArray), changed); // sort it
									// we now need to push the change back into the original results array
									resultsArray.splice(firstInsertedInto, 1); // remove the inserted item from the previous index

									if((options.start && insertedInto == 0) ||
										(!atEnd && insertedInto == resultsArray.length)){
										// if it is at the end of the page, assume it goes into the prev or next page
										insertedInto = -1;
									}else{
										if(storeMethodOptions && storeMethodOptions.before !== undefined){
											beforeIndex = storeMethodOptions.before === null ?
												resultsArray.length :
												findObject(store, resultsArray, beforeId);

											if(beforeIndex !== -1){
												insertedInto = beforeIndex;
											}
										}
										resultsArray.splice(insertedInto, 0, changed); // and insert into the results array with the correct index
									}
								}
							}else if(changed){
								// we don't have a queryEngine, so we can't provide any information about where it
								// was inserted or moved to. If it is an update, we leave it's position alone,
								// otherwise we at least indicate a new object
								if(existingId !== undef){
									// an update, keep the index the same
									insertedInto = removedFrom;
								}else if(!options.start){
									// a new object
									insertedInto = store.defaultIndex || 0;
									resultsArray.splice(insertedInto, 0, changed);
								}
							}
							if((removedFrom > -1 || insertedInto > -1) &&
									(includeObjectUpdates || !queryExecutor || (removedFrom != insertedInto))){
								var copyListeners = listeners.slice();
								for(i = 0;listener = copyListeners[i]; i++){
									listener(changed || removedObject, removedFrom, insertedInto);
								}
							}
						});
					});
				}
				var handle = {};
				// TODO: Remove cancel in 2.0.
				handle.remove = handle.cancel = function(){
					// remove this listener
					var index = array.indexOf(listeners, listener);
					if(index > -1){ // check to make sure we haven't already called cancel
						listeners.splice(index, 1);
						if(!listeners.length){
							// no more listeners, remove the query updater too
							queryUpdaters.splice(array.indexOf(queryUpdaters, queryUpdater), 1);
						}
					}
				};
				return handle;
			};
		}
		return results;
	};
	var inMethod;
	function whenFinished(method, action){
		var original = store[method];
		if(original){
			store[method] = function(value, storeMethodOptions){
				var originalId;
				if(method === 'put'){
					originalId = store.getIdentity(value);
				}
				if(inMethod){
					// if one method calls another (like add() calling put()) we don't want two events
					return original.apply(this, arguments);
				}
				inMethod = true;
				try{
					var results = original.apply(this, arguments);
					when(results, function(results){
						action((typeof results == "object" && results) || value, originalId, storeMethodOptions);
					});
					return results;
				}finally{
					inMethod = false;
				}
			};
		}
	}
	// monitor for updates by listening to these methods
	whenFinished("put", function(object, originalId, storeMethodOptions){
		store.notify(object, originalId, storeMethodOptions);
	});
	whenFinished("add", function(object, originalId, storeMethodOptions){
		store.notify(object, originalId, storeMethodOptions);
	});
	whenFinished("remove", function(id){
		store.notify(undefined, id);
	});

	return store;
};

lang.setObject("dojo.store.Observable", Observable);

return Observable;
});

},
'appivo/model/Model':function(){
/**
*	A database model.
*	@interface Model
*/

define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'dojo/_base/Deferred',
        'dojo/when',
        'dojo/store/Observable',
        'appivo/client/Client',
        'appivo/store/Memory',
        'appivo/util/Identity',
        'appivo/model/Attribute',
        'appivo/model/RelationEnd',
        'appivo/model/Relation',
        'appivo/model/Privilege',
        'appivo/model/Record',
		'appivo/model/QueryHandle',
        'appivo/store/RecordStoreMixin',
        'appivo/store/PublishingStoreMixin'], function(lang, declare, Deferred, when, Observable, Client, Memory, Identity, Attribute, RelationEnd, Relation, Privilege, Record, QueryHandle, RecordStoreMixin, PublishingStoreMixin) {
	
	var client = Client.getInstance();

	var FORBIDDEN_ATTRIBUTES = {
		id: "",
		ver: "",
		created_at: "",		
		updated_at: "",
		checksum: "",
		contenttype: "",
		size: "",
		width: "",
		height: ""
	};

	var dataSystemAttributes = [
		{
			"name": "id",
			"relation": false,
			"type": "ID",
			"defaultValue": null,
			"notNull": true,
			"unsigned": false,
			"unique": false,
			"system": true,
			"size": 16,
			"decimalDigits": 0,
			"primaryKey": true,
			"foreignKey": false,
			"relationName": null
		},
		{
			"name": "created_at",
			"relation": false,
			"type": "TIMESTAMP",
			"defaultValue": "CURRENT_TIMESTAMP",
			"notNull": true,
			"unsigned": false,
			"unique": false,
			"system": true,
			"size": 19,
			"decimalDigits": 0,
			"primaryKey": false,
			"foreignKey": false,
			"relationName": null
		},
		{
			"name": "updated_at",
			"relation": false,
			"type": "TIMESTAMP",
			"defaultValue": "CURRENT_TIMESTAMP",
			"notNull": true,
			"unsigned": false,
			"unique": false,
			"system": true,
			"size": 19,
			"decimalDigits": 0,
			"primaryKey": false,
			"foreignKey": false,
			"relationName": null
		},
		{
			"name": "ver",
			"relation": false,
			"type": "INTEGER",
			"defaultValue": "0",
			"notNull": true,
			"unsigned": true,
			"unique": false,
			"system": true,
			"size": 10,
			"decimalDigits": 0,
			"primaryKey": false,
			"foreignKey": false,
			"relationName": null
		}
	];

	var documentSystemAttributes = [
		{
			"name": "filename",
			"relation": false,
			"type": "STRING",
			"defaultValue": null,
			"notNull": true,
			"unsigned": false,
			"unique": false,
			"system": true,
			"size": 256,
			"decimalDigits": 0,
			"primaryKey": false,
			"foreignKey": false,
			"relationName": null
		},
		{
			"name": "checksum",
			"relation": false,
			"type": "STRING",
			"defaultValue": null,
			"notNull": true,
			"unsigned": false,
			"unique": false,
			"system": true,
			"size": 64,
			"decimalDigits": 0,
			"primaryKey": false,
			"foreignKey": false,
			"relationName": null
		},
		{
			"name": "contenttype",
			"relation": false,
			"type": "STRING",
			"defaultValue": null,
			"notNull": true,
			"unsigned": false,
			"unique": false,
			"system": true,
			"size": 256,
			"decimalDigits": 0,
			"primaryKey": false,
			"foreignKey": false,
			"relationName": null
		},
		{
			"name": "size",
			"relation": false,
			"type": "INTEGER",
			"defaultValue": null,
			"notNull": true,
			"unsigned": false,
			"unique": false,
			"system": true,
			"size": 10,
			"decimalDigits": 0,
			"primaryKey": false,
			"foreignKey": false,
			"relationName": null
		},
		{
			"name": "width",
			"relation": false,
			"type": "INTEGER",
			"defaultValue": null,
			"notNull": false,
			"unsigned": false,
			"unique": false,
			"system": true,
			"size": 10,
			"decimalDigits": 0,
			"primaryKey": false,
			"foreignKey": false,
			"relationName": null
		},
		{
			"name": "height",
			"relation": false,
			"type": "INTEGER",
			"defaultValue": null,
			"notNull": false,
			"unsigned": false,
			"unique": false,
			"system": true,
			"size": 10,
			"decimalDigits": 0,
			"primaryKey": false,
			"foreignKey": false,
			"relationName": null
		}
	];
		
	var ModelClass = declare("appivo.model.Model", null, {

		id: null,
		ver: 0,
		type: 'Data',
		name: null,
		description: null,
		spec: null,
		access: null,
		schema: null,
		hidden: false,
		exportable: false,
		importId: null,
		imports: null,
		attrIndex: null,
		attributes: null,
		relationAttributes: null,
		searchIndexes: null,
		privileges: null,
		privIndex: null,
		records: null,
		label: null,
		lbl: null,
		sort: null,
		isNew: true,	
		locale: null,
		_relationEnds: null,
		_relationEndIndex: null,
		attributeClass: Attribute,

		constructor: function(options) {
			lang.mixin(this, options);
			this._init();
		},

		_init: function() {
			if (this.id) {
				this.isNew = false;
			}
			var attrs = this.attributes;
			var rels = this.relations;
			var privs = this.privileges;
			this.attrIndex = {};
			this.relIndex = {};
			var imported = this.isImported();
			if (attrs) {
				for (var i in attrs) {
					var data = attrs[i];
					if (imported) {
						delete data.id;
						Identity.prepareItemId(data);
					}
					data.model = this;
					data.isAttribute = true;
					var attr = new this.attributeClass(data);
					this.attrIndex[attr.getName()] = attr;
				}
			}
			if (rels) {
				for (var i in rels) {
					var data = rels[i];
					data.model = this;
					var rel = new Relation(data);
					this.relIndex[rel.getName()] = rel;
				}
			}
			if (!this.searchIndexes) {
				this.searchIndexes = [];
			}
			if (privs) {
				this.setPrivileges(privs);
			}
			delete this.attributes;
			delete this.privileges;
		},

	/**
	*	Returns the model's ID.
	*	@returns {ID} - The ID of the model.
	*	@memberof Model
	*	@instance
	*
	*	@LogicMeta {
	* 	  "api":"Model",
	* 	  "returntype":"Id",
	* 	  "tooltip": "$"
	* 	} 
	*/
		getId: function() {
			return this.id;
		},

	/** 
	*	Returns the model's name
	*	@returns {String} - The name of the model.
	*	@memberof Model
	*	@instance
	*
	*	@LogicMeta {
	*     "api":"Model",
	*     "returntype":"String",
	*     "tooltip": "$"
	* 	} 
	*/
		getName: function() {
			return this.name;
		},
		
	/**
	*	Returns the type of the model.
	*	@returns {String} - The type of the model. The type can be either 'document' or 'data'.
	*	@memberof Model
	*	@instance
	*
	*	@LogicMeta {
	*     "api":"Model",
	*     "returntype":"String",
	*     "tooltip": "$"
	* 	} 
	*/
		getType: function() {
			return this.type;
		},

	/**
	*	Convenience function that returns true if the model's type is 'document'.
	*	@returns {Boolean} - True or false depending on if the model's type is 'document'.
	*	@memberof Model
	*	@instance
	*
	*	@LogicMeta {
	*     "api":"Model",
	*     "returntype":"Boolean",
	*     "tooltip": "$"
	* 	} 
	*/
		isDocument: function() {
			return this.type == 'Document';
		},
		
		setName: function(name) {
			var emitEvent = (this.name != null && this.name != name);
			var oldName = this.name;
			this.name = name;
			if (emitEvent) {
				this.schema._publishEvent('modelNameChange', {
					oldName: oldName,
					newName: name
				});
			}
		},
		
	/** 
	*	Returns the model's description.
	*	@returns {String} - The model's description.
	*	@memberof Model
	*	@instance
	*
	*	@LogicMeta {
	*     "api":"Model",
	*     "returntype":"String",
	*	  "tooltip": "$"
	* 	} 
	*/
		getDescription: function() {
			return this.description;
		},
		
		setDescription: function(description) {
			this.description = description;
		},
		
		getSpec: function() {
			return this.spec;
		},
		
		setSpec: function(spec) {
			this.spec = spec;				
		},

		getSchema: function() {
			return this.schema;
		},

	/**
	*	Returns true if the model is marked as exportable.
	*	@returns {Boolean} - True if the model is marked as exportable.
	*	@memberof Model
	*	@instance
	*
	*	@LogicMeta {
	*     "api":"Model",
	*     "returntype":"Boolean",
	*     "tooltip": "$"
	* 	} 
	*/
		isExportable: function() {
			return this.exportable;
		},
		
	/**
	*	@private
	*
	*	@LogicMeta {
	*     "api":"Model",
	*     "returntype":"Boolean",
	*     "tooltip": "$"
	* } 
	*/
		isHidden: function() {
			return this.hidden;
		},
		
		isCreated: function() {
			return Identity.isRealId(this.id);
		},
		
		setExportable: function(exportable) {
			this.exportable = exportable;
		},
		
	/** 
	*	@private
	*
	*	@LogicMeta {
	*     "api":"Model",
	*     "returntype":"Boolean",
	*     "tooltip": "$"
	* 	} 
	*/
		isImported: function() {
			return this.imports != null;
		},
		
	/**
	*	@private
	*
	*	@LogicMeta {
	*     "api":"Model",
	*     "returntype":"Boolean",
	*     "tooltip": "$"
	* 	} 
	*/
		isImportedFromSystem: function() {
			return this.imports != undefined && this.imports != null && this.imports.indexOf('System') == 0; 
		},
		
		getRecords: function() {
			return this.records;
		},
		
		setRecords: function(records) {
			this.records = records;
		},
		
		sortRecords: function(records) {
			try {
				var sortAttr = this.sort;
				if (sortAttr) {
					var attr = this.getAttribute(sortAttr);
					if (attr) {
						records.sort(function(a, b) {
							var av = a[attr.name];
							var bv = b[attr.name];
							return attr.compareValues(av,bv);
						});
					}
				}
			} catch (error) {
				console.error("Failed to sort records of model " + this.name);
				console.error(error);
			}
		},
		
	/** 
	*	@private
	*
	*	@LogicMeta {
	*     "api":"Model",
	*     "returntype":"String",
	*     "tooltip": "$"
	*   } 
	*/
		getURI: function() {
			return client.getURI("/api/app/" + this.schema.getName() + "/model/" + this.name);
		},

	/** 
	*	@private
	*
	*	@LogicMeta { 
	*	  "api":"Model", 
	*	  "returntype":"Object", 
	*	  "paramTypes":["String"],
	*	  "tooltip": "$",
	*	  "shadowBlocks": {
	*	  	"name": "text#attribute name"
	*	  }
	*	} 
	*/
		getAttribute: function(name) {
			var attr = this.attrIndex[name];
			if (attr && attr.isAttribute) {
				return attr;
			}
			return undefined;
		},

		removeAttribute: function(name) {
			delete this.attrIndex[name];
		},

		getLabelAttributeName: function() {
			if (!this.lbl) {
				this.lbl = this.getFirstLocalLabel();
			} 
			return this.lbl;
		},
		
		_getFirstStringAttr: function() {
			for (var i in this.attrIndex) {
				var attr = this.attrIndex[i];
				if (attr.type == "STRING") {
					return attr;
				}
			}	
			return null;
		},
		
		getFirstLocalLabel: function() {
			var lb = null;
			var hasRelations = false;
			if (this.label) {
				var list = this.label.split(',');
				for (var i = 0; i < list.length; i++) {
					var name = list[i];
					var idx = name.indexOf('.');
					if (idx == -1 && !lb) {
						var attr = this.attrIndex[name];
						if (attr) {
							lb = attr.name;
						}
					} else if (idx >= 0) {
						hasRelations = true;
					}
				}
			}
			if (!hasRelations) {
				lb = this.label;
			}

            if (!lb) {
				var attr = this._getFirstStringAttr();
				if (attr) {
					lb = attr.name;
				}
			}

			return lb;
		},

		setLabelAttributeName: function(name) {
			this.label = name;
		},

		getSorting: function() {
			return this.sort;
		},

		setSorting: function(sort) {
			this.sort = sort;
		},

		getLabel: function(record) {
			var labelDef = this.label;
			if (!labelDef) {
				if (this.lbl && this.lbl.indexOf('.') == -1 && this.lbl.indexOf(',') > -1) {
					labelDef = this.lbl;
				} else {
					labelDef = this.getLabelAttributeName();
				}
			}
			
			var parts = labelDef.split(',');
			var label = '';
			for (var i = 0; i < parts.length; i++) {
				if (i > 0) {
					label = label + ' ';
				}
				var attr = parts[i];
				var idx = attr.indexOf('.');
				if (idx > -1) {
					var relName = attr.substring(0,idx);
					var comp = record[relName + '_label'];
					if (comp) {
						label = label + comp;
					}
				} else {
					var part = record[attr];
					if (part !== null && part !== undefined) {
						label = label + part;
					}
				}
			}
			return label;			
		},
		
		getAttributeForRelation: function(relation) {
			var attr = null;
			for (var i in this.attrIndex) {
				var a = this.attrIndex[i];
				if (a.isRelation()) {
					var rel = a.getRelationship();
					if (rel && rel.getName() == relation) {
						attr = a;
						break;												
					}
				}
			}
			return attr;
		},

		setAttribute: function(attr) {
			var oldName = null;
			attr.isAttribute = true;
			for (var name in this.attrIndex) {
				var oldAttr = this.attrIndex[name];
				if (oldAttr.id == attr.id) {
					oldName = name;
					break;
				}
			}
			if (oldName != null) {
				delete this.attrIndex[oldName];				
			}
			this.attrIndex[attr.name] = attr;
		},

		setAttributes: function(attrs) {
			this.attrIndex = {};
			this.relationAttributes = {};
			for (var i = 0; i < attrs.length; i++) {
				var attr = attrs[i];
				attr.isAttribute = true;
				this.attrIndex[attr.name] = attr;
				if (attr.relation) {
					this.relationAttributes[attr.relationName] = attr;
				}
			}    	
		},

		getAttributes: function() {
			var attrs = new Array();
			for (var i in this.attrIndex) {
				attrs.push(this.attrIndex[i]);
			}
			return attrs;
		},

		getRelationship: function(name, lenient) {
			this.getRelationships();
			var rel = this._relationEndIndex[name];
			if (rel == null || rel == undefined) {
				if (!lenient) {
					throw {
						name: 'UknownRelationshipError',
						message: 'Model ' + this.name + ' has no relationship named ' + name 
					}					
				} else {
					console.error("Unknown relationship: Model " + this.name + " has no relationship named " + name);
				}
			}
			return rel;
		},

		getRelationships: function() {
			if (!this._relationEnds) {
				var rels = this.schema.getRelationsForModel(this);
				this._relationEnds = new Array();
				this._relationEndIndex = {};
				for (var i in rels) {
					var rel = rels[i];
					var inverse = rel.getDestination().id == this.id;
					var end = new RelationEnd({
						relation: rel,
						inverse: inverse
					});
					this._relationEnds.push(end);
					this._relationEndIndex[end.getName()] = end;
					if (inverse && rel.getSource().id == this.id) {
						var end2 = new RelationEnd({
							relation: rel,
							inverse: false
						});
						this._relationEndIndex[end2.getName()] = end2;
						this._relationEnds.push(end2);
					}
				}
			}
			return this._relationEnds;
		},
		
		_clearCachedRelations: function() {
			this._relationEnds = null;
			this._relationEndIndex = {};
		},
		
		addRelationship: function(relationship, notrickle) {
			this.setRelationship(relationship);
			
			var destRel = {
				name: this.getName(),
				destination: this
			};

			switch (relationship.cardinality) {
			case 'HAS_ZERO_OR_ONE':
			case 'HAS_ONE':
			case 'HAS_ZERO_TO_MANY':
				destRel.cardinality = 'BELONGS_TO';
				break;
			case 'HAS_MANY':
				destRel.cardinality = 'HAS_ONE';
				break;
			case 'HAS_AND_BELONGS_TO_MANY':
				destRel.cardinality = 'HAS_AND_BELONGS_TO_MANY';
				destRel.through = relationship.through;
				break;
			}
			
			if (!notrickle) {
				var dr = new appivo.model.Relationship(destRel);
				relationship.destination.addRelationship(dr, true);
			}
		},
		
		_generateRelationField: function(relationship) {
			var field = {
					name: this._generateRelationFieldName(),
					relation: true,
					type: 'INTEGER'
			};
		},

		_generateRelationFieldName: function(relationship) {
			return relationship.name.toLowerCase()+ "_id";
		},

		getPrivileges: function() {
			var privs = new Array();
			for (var i in this.privIndex) {
				privs.push(this.privIndex[i]);
			}
			return privs;
		},
		
		setPrivilege: function(privilege) {
			this.privIndex[privilege.getName()] = privilege;
		},
		
		setPrivileges: function(privs) {
			this.privIndex = {};
			for (var i in privs) {
				var data = privs[i];
				data.model = this;
				var priv = new Privilege(data);
				this.privIndex[priv.getName()] = priv;
			}
		},
		
		removePrivilege: function(name) {
			delete this.privIndex[name];
		},
				
		createRecord: function(item, store) {
			if (item && item.declaredClass === 'appivo.model.Record') {
				if (item.__model && item.__model.id === this.id) {
					// REMIND: This should clone the item...
					return item;
				} else if (item.toJSON) {
					item = item.toJSON(true);
				} else {
					var model = item.__model;
					var query = item.__query;
					var st = item.__store;
					var privs = item.__privileges;
					delete item.__model;
					delete item.__query;
					delete item.__store;
					item = JSON.parse(JSON.stringify(item));
					item.__model = model;
					item.__query = query;
					item.__store = st;
					item.__privileges = privs;
				}
			}
			if (!store) {
				store = this.getStore({exists: true});
			}
			return new Record({
				model: this,
				store: store,
				data: item
			});
		},
		
		createDocumentRecord: function(item, store, file) {
			var record = this.createRecord(item, store);
			var def = new Deferred();
			
			if (file && file.data) {
				var data = file.data;
				var filename = file.filename ? file.filename : "file.txt";
				var contentType = file.contentType ? file.contentType : "text/plain";
				var timestamp = data.lastModifiedDate ? data.lastModifiedDate : file.lastModifiedDate ? file.lastModifiedDate : new Date().getTime();
				var headers = {
					"X-Filename": filename,
					"X-LastModified": timestamp,
					"Content-Type": contentType
				};
				
				client.sendRequest("/files", {
					method: 'POST',
					uriComplete: true,
					withCredentials: true,
					headers: headers,
					data: data,
					handleAs: "json"
				}).then(function(res) {
					var meta = res[0];
					record.checksum = meta.checksum;
					record.contenttype = meta.contenttype;
					record.size = meta.size;
					record.filename = meta.filename;
					def.resolve(record);
				}, function(error) {
					def.reject(error);
				});
				
			} else {
				def.resolve(record);
			}
			return def;
		},
		
		query: function(query, callback, errorCallback) {
			var store = this.getStore({
				exists: true
			});
			var q = query;
			if (!lang.isObject(query)) {
				q = {
					query: query	
				};
			}
			var res = store.query(q);
			if (!errorCallback) {
				errorCallback = function(error) {
					alert(error);
				};
			}
			when(res, callback, errorCallback)
		},

		getById: function(id, args) {
			var t = this;
			var opts = {};
			if (args && !lang.isObject(args)) {
				// Do nothing now...
			} else if (args) {
				opts = args;
			}
			var headers = {
				FetchMode: 'NESTED|LABELS'
			};
			if (opts.headers) {
				headers = opts.headers;
			}

			var tenant = this.schema.getTenant();
			if (tenant) {
				headers['X-Tenant'] = tenant;
			}
			if (opts.relations) {
				headers.Relations = opts.relations;
			}
			if (opts.features) {
				headers['X-Features'] = opts.features;
			}

			var def = client.sendRequest(this.getURI() + '/record/' + id, {
				uriComplete: true,
				handleAs: 'json',
				withCredentials: true,
				headers: headers,
				offline: opts.offline,
				online: opts.online,
				raw: true
			});
			
			var def2 = def.then(lang.hitch(this, function(response) {
				var item = response.data;
				var privs = response.getHeader("X-Privileges");
				var privObj = undefined;
				if (privs) {
					privObj = t._parsePrivileges(privs);
				}

				var record = t.createRecord(item);
				if (privObj) {
					record.__privileges = privObj;
				}
				return record;
			}));
			if (args && (args.onSuccess || args.onError)) {
				def2.then(args.onSuccess, args.onError);
			}
			return def2;
		},

		_parsePrivileges: function(str) {
			var list = str.split(",");
			var privs = {};
			for (var i = 0; i < list.length;i++) {
				var l = list[i];
				privs[l] = true;
			}
			return privs;
		},

        /**
		 * Returns the Record.
         * @param {Object} opts - test.
		 * @returns {Record} - The query's result set.
		 * @memberof Model
		 * @instance
		 *
		 * @LogicMeta {
		 *	"api": "Model",
         *  "paramTypes":["Object"],
		 *  "returnType": "Record",
		 *	"tooltip": "$"
		 * }
		 */

		getRecord: function(opts) {
			opts = opts ? opts : {};
			opts.method = 'GET';
			opts.data = undefined;
			opts.nodata = true;
			return this._sendRecordRequest(opts);
		},

		deleteRecord: function(rec, opts) {
			opts = opts ? opts : {};
			var id = lang.isObject(rec) ? rec.id : rec;
			var headers = {};
			var tenant = this.schema.getTenant();
			if (tenant) {
				headers['X-Tenant'] = tenant;
			}

			var def = client.sendRequest(this.getRecordURI(id), {
				method: 'DELETE',
				uriComplete: true,
				handleAs: 'json',
				withCredentials: true,
				headers: headers,
				onSuccess: opts.onSuccess,
				onError: opts.onError
			});
			return def;
		},
		
		createRecords: function(opts) {
			opts = opts ? opts : {};
			opts.method = 'POST';
			return this._sendRecordRequest(opts);
		},
		
		updateRecords: function(opts) {
			opts = opts ? opts : {};
			opts.method = 'PUT';
			return this._sendRecordRequest(opts);			
		},
		
		executeTransaction: function(tx, options) {
			options = options || {};
			var opts = {
				method: 'POST',
				url: this.getTransactionURI(),
				customData: true,
				data: tx,
				onSuccess: options.onSuccess,
				onError: options.onError
			};
			this._sendRecordRequest(opts);
		},

		_sendRecordRequest: function(opts) {
			var data = undefined;
			if (opts.records && !opts.nodata) {
				var records = opts.records;
				if (lang.isArray(records)) {
					var recs = new Array();
					for (var i = 0; i < records.length; i++) {
						var rec = records[i];
						if (rec.toJSON) {
							recs.push(rec.toJSON());
						} else {
							recs.push(rec);
						}
					}
					data = recs;
				} else if (records && records.toJSON) {
					data = records.toJSON();
				} else {
					data = records;
				}
			} else if (opts.customData) {
			    data = opts.data;
			} else {
				if (opts.onError) {
					opts.onError('Missing records');
					return;
				}
			}	

			if (!opts.url) {
				if (lang.isArray(data)) {
					opts.url = this.getRecordURI();					
				} else if (data) {
					opts.url = this.getRecordURI(data.id)
				}
			}
			
			var headers = {
				'Content-Type': 'application/json'	
			};
			
			var tenant = this.schema.getTenant();
			if (tenant) {
				headers['X-Tenant'] = tenant;
			}
			
			var def = client.sendRequest(opts.url, {
				uriComplete: true,
				method: opts.method,
				handleAs: 'json',
				headers: headers,
				withCredentials: true,
				data: JSON.stringify(data)
			}).then(opts.onSuccess, opts.onError);							
		},
				
		getRecordURI: function(id) {
			var uri = this.getURI() + '/record/';
			if (id) {
				uri = uri + id;
			}
			return uri;
		},
		
		getTransactionURI: function() {
			return this.getURI() + '/tx/';
		},
		
		getDocumentURI: function(data, encode) {
			var id = data;
			var chk = null;
			var filename = 'file';
			if (lang.isObject(data)) {
				id = data.id;
				chk = data.checksum;
				if (data.filename) {
					filename = data.filename;
				}
			} else {
				if (!Identity.isRealId(id)) {
					chk = id;
					id = null;
				}
			}
			// Note - getRecordURI can be overridden by query models (From.js)
			var uri = null;
			if (chk) {
				uri = '/files/' + chk;
				if (filename) {
					filename = encodeURIComponent(filename);
					if (encode) {
						filename = encodeURIComponent(filename);
					}
					uri += "?filename=" + encodeURIComponent(filename);
				}
			} else {
				uri = this.getURI() + '/record/' + id + '/file/';
				if (filename) {
					uri = uri + encodeURIComponent(filename);
				}
			}
			return uri;
		},
		
		getThumbnailSpecs: function() {
			var spec = null;
			if (this.spec && this.spec.thumbs) {
				spec = this.spec.thumbs;
			}
			return spec;
		},
		
		getThumbnailSpec: function(name) {
			var spec = null;
			if (this.spec && this.spec.thumbs) {
				if (name) {
					spec = this.spec.thumbs[name];					
				} else {
					for (var n in this.spec.thumbs) {
						spec = this.spec.thumbs[n];
						break;
					}
				}
			} 
			return spec;
		},
		
		getThumbnailURI: function(data, formatName) {
			var id = data;
			var chk = null;
			if (lang.isObject(data)) {
				id = data.id;
				chk = data.checksum;
			}

			var format = "120x120";
			var spec = this.getThumbnailSpec(formatName);
            if (spec) {
                format = spec.width + 'x' + spec.height;
            }
            
            var uri = null;
            if (Identity.isTempId(id)) {
            	uri = '/files/' + chk;
            } else {
				uri = this.getURI() + '/record/' + id + '/thumb/' + format;
            }
			return uri;
		},

		getQueryHandle: function() {
			let store = this.getStore({
				exists: true
			});
			return new QueryHandle({
				store: store
			});
		},

		getStore: function(options) {
			var store = null;
			if (options && options.exists) {
				var uri = this.getRecordURI();
				var storeManager = appivo.store.StoreManager.getInstance();
				store = storeManager.getStore(uri, options.fetchMode, undefined, options.storageMode);
				store = RecordStoreMixin(store, this, false, this.isNew);
			} else {
				store = new Memory({});
				store = Observable(store);
				store = RecordStoreMixin(store, this, false, this.isNew);
				store = PublishingStoreMixin(store, this.getRecordURI(), false, true);
			}
			var tenant = this.schema.getTenant();
			if (tenant) {
				store.setTenant(tenant);
			}
			return store;
		},
		
		getRelatedStore: function(options) {
			var store = null;
			var rel = this.getRelationship(options.relation);
			if (rel) {
				var model = rel.getDestination();
				var storeManager = appivo.store.StoreManager.getInstance();
				if (options.transactional) {
					store = model.getStore();
				} else {
					var uri = this.getRecordURI(options.id) + '/relation/' + options.relation;
					store = storeManager.getStore(uri, options.fetchMode);
					store = RecordStoreMixin(store, this, false, this.isNew);
					store = PublishingStoreMixin(store, model.getRecordURI(), true, false);
				}
			}
			var tenant = this.schema.getTenant();
			if (tenant) {
				store.setTenant(tenant);
			}
			return store;
		},
		
		checkReference: function(path) {
			var idx = path.indexOf(".");
			var name = path;
			if (idx > 0) {
				name = path.substring(0, idx);
				path = path.substring(idx + 1);
			} else {
				path = null;
			}
			
			var node = null;
			if (!path) {
				node = this.getAttribute(name);
				if (!node) {
					throw new Error("Unknown attribute " + name + " in model " + this.name);
				}
				return true;
			} else {
				node = this.getRelationship(name, true);
				if (!node) {
					throw new Error("Unknown relation " + name + " in model " + this.name);
				} else {
					var dest = node.getDestination();
					return dest.checkReference(path);
				}				
			}
			return false;
		},
				
		_localize: function(locale) {
			this.locale = locale;
			if (locale && locale.data && locale.data.model) {
				var data = locale.data.model[this.name];
				if (data) {
					for (var attrName in data) {
					    if(attrName != "_ModelLabel"){
                            var attrData = data[attrName];
                            if (attrData) {
                                var attr = this.getAttribute(attrName);
                                if (attr) {
                                    attr._localize(attrData);
                                }
                            }
                        }
					}
				}				
			}
		},

		getLocalizedName: function() {
		    if (this.locale && this.locale.data && this.locale.data.model) {
                var data = this.locale.data.model[this.name];
                if(data && data._ModelLabel){
		            return data._ModelLabel;
                } else {
                    return this.name;
                }
		    } else {
		        return this.name;
		    }
		},
		
		resolve: function(schema) {
			this.schema = schema;
			for (var i in this.attrIndex) {
				var attr = this.attrIndex[i];
				attr._resolve(schema);
			}
		},
		
		clone: function() {
			var json = this.toJSON(true);
			json.schema = this.schema;
			var model = new ModelClass(json);
			model.resolve(this.schema);
			return model;
		},

		toJSON: function(full) {
			var attrs = new  Array();
			var rels = new Array();
			var privs = new Array();
			
			for (var i in this.attrIndex) {
				var attr = this.attrIndex[i];
				var attrJson = attr.toJSON();
				attrs.push(attrJson);
			}
						
			for (var i in this.privIndex) {
				var priv = this.privIndex[i];
				var privJson = priv.toJSON();
				privs.push(privJson);
			}
			
			var json = {
				id: this.id,
				type: this.type,
				ver: this.ver,
				name: this.name,
				description: this.description,
				hidden: this.hidden,
				exportable: this.exportable,
				label: this.label ? this.label : undefined,
				sort: this.sort ? this.sort : undefined,
				searchIndexes: this.searchIndexes ? this.searchIndexes : undefined,
				spec: this.spec,
				access: this.access,
				records: this.records,
				privileges: privs
			}
			if (this.imports) {
				json.imports = this.imports;
				json.importId = this.importId;
				if (full) {
					json.attributes = attrs;
				}
			} else {
				json.attributes = attrs;				
			}
			Identity.cleanItemId(json);
			if (this.id == null) {
				delete json.id;
			}
			return json;
		}
	});

	ModelClass.getDataSystemAttributes = function() {
		return JSON.parse(JSON.stringify(dataSystemAttributes));
	};

	ModelClass.getDocumentSystemAttributes = function() {
		return JSON.parse(JSON.stringify(documentSystemAttributes));
	};

	ModelClass.FORBIDDEN_ATTRIBUTES = FORBIDDEN_ATTRIBUTES;

	return ModelClass;
});
},
'appivo/store/Memory':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'dojo/store/Memory',
        "dojo/store/util/QueryResults",
        'appivo/util/Identity'],

  function(lang, declare, Memory, QueryResults, Identity) {
	
    return declare("appivo.store.Memory", [Memory], {

    	tenant: null,
    	type: 'memory',
    	monitors: null,
    	
    	setEnabled: function(enabled) {
			this.enabled = enabled;
		},
		
		setTenant: function(tenant) {
			this.tenant = tenant;
		},
		
		_notify: function(event, record) {
			var monitors = this.monitors;
			if (this.monitors) {
				for (var i in monitors) {
					var monitor = monitors[i];
					try {
						monitor(event, record);
					} catch(error) {
						console.error(error);
					}
				}
			}
		},
		
		monitor: function(monitor) {
			if (!this.monitors) {
				this.monitors = [];
			}
			this.monitors.push(monitor);
		},

    	put: function(object, options) {
    		var idProperty = this.idProperty;
    		var id = object[idProperty];
    		if (options && options != null) {
    			if ("id" in options) {
    	   			id = options.id;   				
    			}
    		}
    		if (!id) {
    			id = Identity.generateItemId();
    		}
    		object[idProperty] = id;
    		
    		var obj = this.inherited(arguments);
    		this._notify("put", obj);
    		return id;
    	},
    	
    	remove: function(id) {
    		var result = this.inherited(arguments);
    		this._notify("remove", id);
			return result;
    	},
    	
    	setData: function(data) {
    		var list = [];
    		if (Array.isArray(data)) {
    			for (var i in data) {
    				var rec = data[i];
    				if (rec && rec.toJSON) {
    					rec = rec.toJSON({
    						loose: true
    					});
     				}
					list[i] = rec;
    			}
    		}  		
    		arguments[0] = list;
    		this.inherited(arguments);
    	},

    	onQueryResult: function(result) {   		
    	},
    	
    	query: function() {
    		var result = this.inherited(arguments);
    		this.onQueryResult({
    			store: this,
    			result: result
    		});
     		return result;
    	}
    })
});
},
'appivo/model/Attribute':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'dojo/_base/Deferred',
        'appivo/model/Element',
        'appivo/util/Identity',
        'appivo/util/Date',
        'dojo/i18n!appivo/nls/Attribute'], function(lang, declare, Deferred, Element, Identity, ADate, messages) {
	
	var DATATYPE_MAP = {
		STRING: messages.type_string,
		INTEGER: messages.type_integer,
		FLOAT: messages.type_float,
		BOOLEAN: messages.type_boolean,
		DECIMAL: messages.type_decimal,
		TIME: messages.type_time,
		DATE: messages.type_date,
		TIMESTAMP: messages.type_timestamp,
		ENUM: messages.type_enum,
		TEXT: messages.type_text,
		BIGINTEGER: messages.type_bigint,
		POINT: messages.type_point,
		ID: messages.type_id
	};
	
	var typeOptions = [
	    {
	    	value: 'STRING',
	    	label: messages.type_string
	    },
	    {
	    	value: 'INTEGER',
	    	label: messages.type_integer
	    },
	    {
	    	value: 'FLOAT',
	    	label: messages.type_float
	    },
	    {
	    	value: 'BOOLEAN',
	    	label: messages.type_boolean
	    },
	    {
	    	value: 'DATE',
	    	label: messages.type_date
	    },
	    {
	    	value: 'TIME',
	    	label: messages.type_time
	    },
	    {
	    	value: 'TIMESTAMP',
	    	label: messages.type_timestamp
	    },
	    {
	    	value: 'ENUM',
	    	label: messages.type_enum
	    },
	    {
	    	value: 'ID',
	    	label: messages.type_id
	    },
	    {
	    	value: 'DECIMAL',
	    	label: messages.type_decimal
	    },
	    {
	    	value: 'BIGINTEGER',
	    	label: messages.type_bigint
	    },
	    {
	    	value: 'TEXT',
	    	label: messages.type_text
	    },
	    {
	    	value: 'POINT',
	    	label: messages.type_point
	    }
	];
	
	var attr = declare("appivo.model.Attribute", [Element], {

		type: 'STRING',
		typeAnnotation: null,
		subtype: null,
		ver: 0,
		defaultValue: null,
		size: 48,
		decimalDigits: 0,
		notNull: false,
		unsigned: false,
		sequence: false,
		system: false,
		secret: false,
		personal: false,
		unique: false,
		primaryKey: false,
		foreignKey: false,
		relationId: null,
		relationName: null,
		relationship: null,
		enumValues: null,
		enumIndex: null,
		model: null,
		localeData: null,
		
		constructor: function(options) {
			lang.mixin(this, options);
			if (this.type == 'TIMESTAMP') {
				if (this.defaultValue != 'CURRENT_TIMESTAMP') {
					this.defaultValue = this._formatDate(this.defaultValue);					
				}
			} else if (this.type == 'ENUM') {
				this.enumIndex = {};
				for (var i in this.enumValues) {
					var ev = this.enumValues[i];
					this.enumIndex[ev.name] = ev.index;
				}
			}
		},
			
		getType: function() {
			return this.type;
		},

		getSubType: function() {
			return this.subtype;
		},
		
		getSize: function() {
			return this.size;
		},
				
		isRelation: function() {
			return this.relationship != null;
		},
		
		isRequired: function() {
			return this.notNull;
		},
		
		isEnum: function() {
			return this.enumValues != null;
		},
		
		isSecret: function() {
			return this.secret;
		},
		
		isPersonal: function() {
			return this.personal;
		},
		
		getEnumValues: function() {
			return this.enumValues;
		},
		
		getEnumOptions: function() {
			var opts = new Array();
			for (var i in this.enumValues) {
				var ev = this.enumValues[i];
				var label = ev.name;
				if (this.localeData && this.localeData[label]) {
					label = this.localeData[ev.name];
				}
				opts.push({
					label: label,
					value: ev.name
				});
			}
			return opts;
		},
		
		getEnumLabel: function(value) {
			var str = null;
			if (lang.isString(value) && this.enumIndex[value] != undefined) {
				str = value;
			} else {
				str = this.intToEnum(value);
			}
			if (this.localeData) {
				str = this.localeData[str];
			}
			return str;
		},
		
		enumToInt: function(value) {
			return this.enumIndex[value];
		},
		
		intToEnum: function(value) {
			var intval = value;
			if (lang.isString(value)) {
				intval = parseInt(value);
			}
			if (typeof intval === 'number') {
				for (var i = 0; i < this.enumValues.length; i++) {
					var ev = this.enumValues[i];
					if (ev.index == intval) {
						value = ev.name;
						break;
					}
				}				
			}
			return value;
		},
		
		getRelationship: function() {
			return this.relationship;
		},
		
		getDefaultValue: function() {
			var dv = this.defaultValue;
			switch (this.type) {
			case 'BOOLEAN':
				if (dv == null) {
					dv = false;
				} else {
					if (lang.isString(dv)) {
						dv = (dv == "true");
					}
				}
				break;
			case 'INTEGER':
				if (dv != null) {
					dv = parseInt(dv);
				}
				break;
			case 'FLOAT':
				if (dv != null) {
					dv = parseFloat(dv);
				}
				break;
			case 'TIMESTAMP':
				if (dv == 'CURRENT_TIMESTAMP') {
					dv = new Date();
				}
				break;
			case 'DATE':
				if (dv == 'CURRENT_TIMESTAMP') {
					var d = new Date();
			        var month = '' + (d.getMonth() + 1);
			        var day = '' + d.getDate();
			        var year = d.getFullYear();

			        if (month.length < 2) {
			        	month = '0' + month;
			        }
			        if (day.length < 2) {
			        	day = '0' + day;
			        }
			        
			        dv = [year, month, day].join('-');
				}
				break;
			case 'TIME':
				if (dv == 'CURRENT_TIMESTAMP') {
					var d = new Date();
					var hour = "" + d.getHours();
					var min = "" + d.getMinutes();
					var sec = "" + d.getSeconds();
					if (hour.length < 2) {
						hour = "0" + hour;
 					}
					if (min.length < 2) {
						min = "0" + min;
					}
					if (sec.length < 2) {
						sec = "0" + sec;
					}
 					dv = "T" + [hour, min, sec].join(':');
				}
				break;
			case 'ENUM':
				dv = this.intToEnum(dv);
				break;
			default:
				break;
			}
			return dv;
		},
		
		getTypeAnnotation: function() {
			return this.typeAnnotation;
		},
		
		compareValues: function(a, b) {
			var aud = a === null || a === undefined;
			var bud = b === null || b === undefined;
			if (aud && bud) {
				return 0;
			}
			if (aud && !bud) {
				return 1;
			}
			if (bud && !aud) {
				return -1;
			}
			switch (this.type) {
			case "ID":
			case "STRING":
			case "TEXT":
				if (!lang.isString(a)) {
					a = "" + a;
				}
				if (!lang.isString(b)) {
					b = "" + b;
				}
				return a.localeCompare(b);
			case "INTEGER":
				if (typeof a == "string") {
					a = parseInt(a);
				}
				if (typeof b === "string") {
					b = parseInt(b);
				}
				return a - b;
				break;
			case "FLOAT":
				if (typeof a == "string") {
					a = parseFloat(a);
				}
				if (typeof b === "string") {
					b = parseFloat(b);
				}
				return a - b;
			case "BOOLEAN":
				return a == b;
			case "TIME":
				var a1 = ADate.fromTimeStrToDate(a);
				var b1 = ADate.fromTimeStrToDate(b);
				return a1.getTime() - b1.getTime();				
			case "TIMESTAMP":
			case "DATE":
				var a1 = ADate.fromStrToDate(a);
				var b1 = ADate.fromStrToDate(b);
				return a1.getTime() - b1.getTime();
			}
			return 0;
		},
		
		_resolve: function(schema) {
			if (this.relationName != null) {
				this.relationship = this.model.getRelationship(this.relationName, true);
			}
		},

		_formatDate: function(value) {
			if (value && lang.isString(value)) {
				var end = value.length - 5;
				value = value.substring(0, end) + 'Z';
				value = dojo.date.stamp.fromISOString(value);
			}
			return value;
		},
		
		_localize: function(localeData) {
			this.localeData = localeData;
		},

		toJSON: function() {
			var json = this.inherited(arguments);
			var attrJson = {
				ver: this.ver,
				relation: (this.relationship != null) ,
				relationId: this.relationId,
				type: this.type,
				subtype: this.subtype,
				defaultValue: this.defaultValue,
				notNull: this.notNull,
				unsigned: this.unsigned,
				unique: this.unique,
				system: this.system,
				secret: this.secret,
				personal: this.personal,
				size: this.size,
				decimalDigits: this.decimalDigits,
				primaryKey: this.primaryKey,
				foreignKey: this.foreignKey,
				relationName: this.relationName
			};
			if (this.enumValues) {
				attrJson.enumValues = this.enumValues;
			}
			lang.mixin(json, attrJson);
		
			return json;
		}
	});
	
	attr.DATATYPE_MAP = DATATYPE_MAP;
	
	attr.getMonthName = function(month, format) {
		if (!format) {
			format = 'short';
		}
		return messages['month_name_' + month + '_' + format];
	};
	
	attr.getWeekdayName = function(month, format) {
		if (!format) {
			format = 'short';
		}
		return messages['weekday_name_' + month + '_' + format];
	};
	
	attr.getDataTypeOptions = function() {
		return typeOptions;
	};
	
	attr.getTypeMap = function() {
		return DATATYPE_MAP;
	};
		
	return attr;
});
},
'appivo/model/Element':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'dojo/_base/Deferred',
        'appivo/util/Identity'], function(lang, declare, Deferred, Identity) {
	return declare("appivo.model.Element", null, {

		id: null,
		model: null,
		name: null,
		system: false,
		
		constructor: function(options) {
			declare.safeMixin(this, options);
			Identity.prepareItemId(this);
		},
		
		getId: function() {
			return this.id;
		},
		
		getModel: function() {
			return this.model;
		},
				
		getName: function() {
			return this.name;
		},
	
		isSystem: function() {
			return this.system;
		},
		
		_removeDuplicates: function(items) {
			var dupes = {};
			var arr = new Array();
			var i;
			for (i = 0; i < items.length; i++) {
				var item = items[i];
				if (!dupes[item]) {
					arr.push(item);
				} 
				dupes[item] = true;
			}
			return arr;
		},
		
		_createSet: function(items, key) {
			var map = {};
			for (var i = 0; i < items.length; i++) {
				var item = items[i];
				map[item[key]] = item;
			}
			var a = new Array();
			for (var key in map) {
				var val = map[key];
				a.push(val);
			}
			return a;
		},
		
		toJSON: function(options) {
			var json = {
				id: this.id
			};
			if (this.name) {
				json.name = this.name;
			}
			var clean = true;
			if (typeof(options) !== "undefined") {
				clean = options.clean;
			}
			if (clean) {
				Identity.cleanItemId(json);
			}
			return json;
		}
	});
});
},
'appivo/util/Date':function(){
define(["dojo/_base/lang", "dojo/date/stamp", "dojo/date/locale", "moment/moment"], function(lang, stamp, locale, moment) {
	
	var date = {};
	
	var pad = function(value, size) {
		if (!size) {
			size = 2;
		}
		var str = value + '';
		while (str.length < size) {
			str = '0' + str;
		}
		return str;
	};
	
	date.pad = pad;
	
	date.currentTime = function() {
		return new Date();
	};
	
	date.getTimeZoneOffset = function() {
		var d = new Date();
		var offset = d.getTimezoneOffset();
		var hrs = -offset / 60;
		if (hrs >= 0) {
			hrs = '+' + hrs;
		} else {
			hrs = '' + hrs;
		}
		return hrs;
	};
	
	date.formatTime = function(value) {
		var hour = 0;
		var min = 0;
		var cmp = null;
		if (value) {
			cmp = value.split(':');
		} else {
			cmp = [];
		}
		if (cmp[0] != undefined) {
			hour = parseInt(cmp[0]);
		}
		if (cmp[1] != undefined) {
			min = parseInt(cmp[1]);
		}
		var str = pad(hour, 2) + ':' + pad(min, 2);
		return str;
	};
	
	date.fromTimeStrToDate = function(value) {
		if (lang.isString(value)) {
			value = stamp.fromISOString(value);
		}
		return value;
	};
	
	date.fromStrToDate = function(value) {
		if (lang.isString(value)) {
			/*
			if (value.length > 10) {
				var end = value.length - 5;
				value = value.substring(0, end) + 'Z';				
			}
			*/
			value = stamp.fromISOString(value);
		}
		return value;		
	};
	
	date.fromDateToStr = function(date) {
		var val = date;
		if (lang.isObject(date)) {
			if (date.declaredClass == 'dojo.Date' || date instanceof Date) {
				val = stamp.toISOString(date); 
			}
		}
		return val;
	};
	
	date.fromDateToTimeStr = function(date, formatLength) {
		var hrs = date.getHours();
		var mins = date.getMinutes();
		var secs = date.getSeconds();
		var val = 'T';
		if (hrs < 10) {
			val = val + '0';
		}
		val = val + hrs + ':';
		if (mins < 10) {
			val = val + '0';
		}
		val = val + mins + ':';
		if (secs < 10) {
			val = val + '0';
		}
		val = val + secs;
		return val;
	};
	
	date.fromDateToLocalTimeStr = function(date, formatLength) {
		if (!formatLength) {
			formatLength = 'short';
		}
		var val = locale.format(date, {
			selector: "time",
			formatLength: formatLength
		});
		return val;		
	};
	
	date.fromLocalTimeStrToDate = function(str) {
		var val = locale.parse(str);
		return val;
	};
	
	date.newDate = function(date, timezone) {
		var strDate = null;
		if (date == null || date === undefined) {
			date = new Date().toISOString();
		}
		if (Object.prototype.toString.call(date) === '[object Date]') {
			return date;
		} else if (lang.isString(date)) {
			strDate = date;
		} else {
			strDate = this.fromDateToStr(date);
		}
		var m = moment.tz(strDate, timezone);
		return m.toDate();
	};
		
	return date;
});
},
'dojo/date/locale':function(){
define([
	"../_base/lang",
	"../_base/array",
	"../date",
	/*===== "../_base/declare", =====*/
	"../cldr/supplemental",
	"../i18n",
	"../regexp",
	"../string",
	"../i18n!../cldr/nls/gregorian",
	"module"
], function(lang, array, date, /*===== declare, =====*/ supplemental, i18n, regexp, string, gregorian, module){

// module:
//		dojo/date/locale

var exports = {
	// summary:
	//		This modules defines dojo/date/locale, localization methods for Date.
};
lang.setObject(module.id.replace(/\//g, "."), exports);

// Localization methods for Date.   Honor local customs using locale-dependent dojo.cldr data.

// Load the bundles containing localization information for
// names and formats

//NOTE: Everything in this module assumes Gregorian calendars.
// Other calendars will be implemented in separate modules.

	// Format a pattern without literals
	function formatPattern(dateObject, bundle, options, pattern){
		return pattern.replace(/([a-z])\1*/ig, function(match){
			var s, pad,
				c = match.charAt(0),
				l = match.length,
				widthList = ["abbr", "wide", "narrow"];
			switch(c){
				case 'G':
					s = bundle[(l < 4) ? "eraAbbr" : "eraNames"][dateObject.getFullYear() < 0 ? 0 : 1];
					break;
				case 'y':
					s = dateObject.getFullYear();
					switch(l){
						case 1:
							break;
						case 2:
							if(!options.fullYear){
								s = String(s); s = s.substr(s.length - 2);
								break;
							}
							// fallthrough
						default:
							pad = true;
					}
					break;
				case 'Q':
				case 'q':
					s = Math.ceil((dateObject.getMonth()+1)/3);
//					switch(l){
//						case 1: case 2:
							pad = true;
//							break;
//						case 3: case 4: // unimplemented
//					}
					break;
				case 'M':
				case 'L':
					var m = dateObject.getMonth();
					if(l<3){
						s = m+1; pad = true;
					}else{
						var propM = [
							"months",
							c == 'L' ? "standAlone" : "format",
							widthList[l-3]
						].join("-");
						s = bundle[propM][m];
					}
					break;
				case 'w':
					var firstDay = 0;
					s = exports._getWeekOfYear(dateObject, firstDay); pad = true;
					break;
				case 'd':
					s = dateObject.getDate(); pad = true;
					break;
				case 'D':
					s = exports._getDayOfYear(dateObject); pad = true;
					break;
				case 'e':
				case 'c':
					var d = dateObject.getDay();
					if(l<2){
						s = (d - supplemental.getFirstDayOfWeek(options.locale) + 8) % 7
						break;
					}
					// fallthrough
				case 'E':
					d = dateObject.getDay();
					if(l<3){
						s = d+1; pad = true;
					}else{
						var propD = [
							"days",
							c == 'c' ? "standAlone" : "format",
							widthList[l-3]
						].join("-");
						s = bundle[propD][d];
					}
					break;
				case 'a':
					var timePeriod = dateObject.getHours() < 12 ? 'am' : 'pm';
					s = options[timePeriod] || bundle['dayPeriods-format-wide-' + timePeriod];
					break;
				case 'h':
				case 'H':
				case 'K':
				case 'k':
					var h = dateObject.getHours();
					// strange choices in the date format make it impossible to write this succinctly
					switch (c){
						case 'h': // 1-12
							s = (h % 12) || 12;
							break;
						case 'H': // 0-23
							s = h;
							break;
						case 'K': // 0-11
							s = (h % 12);
							break;
						case 'k': // 1-24
							s = h || 24;
							break;
					}
					pad = true;
					break;
				case 'm':
					s = dateObject.getMinutes(); pad = true;
					break;
				case 's':
					s = dateObject.getSeconds(); pad = true;
					break;
				case 'S':
					s = Math.round(dateObject.getMilliseconds() * Math.pow(10, l-3)); pad = true;
					break;
				case 'v': // FIXME: don't know what this is. seems to be same as z?
				case 'z':
					// We only have one timezone to offer; the one from the browser
					s = exports._getZone(dateObject, true, options);
					if(s){break;}
					l=4;
					// fallthrough... use GMT if tz not available
				case 'Z':
					var offset = exports._getZone(dateObject, false, options);
					var tz = [
						(offset<=0 ? "+" : "-"),
						string.pad(Math.floor(Math.abs(offset)/60), 2),
						string.pad(Math.abs(offset)% 60, 2)
					];
					if(l==4){
						tz.splice(0, 0, "GMT");
						tz.splice(3, 0, ":");
					}
					s = tz.join("");
					break;
//				case 'Y': case 'u': case 'W': case 'F': case 'g': case 'A':
//					console.log(match+" modifier unimplemented");
				default:
					throw new Error("dojo.date.locale.format: invalid pattern char: "+pattern);
			}
			if(pad){ s = string.pad(s, l); }
			return s;
		});
	}

/*=====
var __FormatOptions = exports.__FormatOptions = declare(null, {
	// selector: String
	//		choice of 'time','date' (default: date and time)
	// formatLength: String
	//		choice of long, short, medium or full (plus any custom additions).  Defaults to 'short'
	// datePattern:String
	//		override pattern with this string
	// timePattern:String
	//		override pattern with this string
	// am: String
	//		override strings for am in times
	// pm: String
	//		override strings for pm in times
	// locale: String
	//		override the locale used to determine formatting rules
	// fullYear: Boolean
	//		(format only) use 4 digit years whenever 2 digit years are called for
	// strict: Boolean
	//		(parse only) strict parsing, off by default
});
=====*/

exports._getZone = function(/*Date*/ dateObject, /*boolean*/ getName, /*__FormatOptions?*/ options){
	// summary:
	//		Returns the zone (or offset) for the given date and options.  This
	//		is broken out into a separate function so that it can be overridden
	//		by timezone-aware code.
	//
	// dateObject:
	//		the date and/or time being formatted.
	//
	// getName:
	//		Whether to return the timezone string (if true), or the offset (if false)
	//
	// options:
	//		The options being used for formatting
	if(getName){
		return date.getTimezoneName(dateObject);
	}else{
		return dateObject.getTimezoneOffset();
	}
};


exports.format = function(/*Date*/ dateObject, /*__FormatOptions?*/ options){
	// summary:
	//		Format a Date object as a String, using locale-specific settings.
	//
	// description:
	//		Create a string from a Date object using a known localized pattern.
	//		By default, this method formats both date and time from dateObject.
	//		Formatting patterns are chosen appropriate to the locale.  Different
	//		formatting lengths may be chosen, with "full" used by default.
	//		Custom patterns may be used or registered with translations using
	//		the dojo/date/locale.addCustomFormats() method.
	//		Formatting patterns are implemented using [the syntax described at
	//		unicode.org](http://www.unicode.org/reports/tr35/tr35-4.html#Date_Format_Patterns)
	//
	// dateObject:
	//		the date and/or time to be formatted.  If a time only is formatted,
	//		the values in the year, month, and day fields are irrelevant.  The
	//		opposite is true when formatting only dates.

	options = options || {};

	var locale = i18n.normalizeLocale(options.locale),
		formatLength = options.formatLength || 'short',
		bundle = exports._getGregorianBundle(locale),
		str = [],
		sauce = lang.hitch(this, formatPattern, dateObject, bundle, options);
	if(options.selector == "year"){
		return _processPattern(bundle["dateFormatItem-yyyy"] || "yyyy", sauce);
	}
	var pattern;
	if(options.selector != "date"){
		pattern = options.timePattern || bundle["timeFormat-"+formatLength];
		if(pattern){str.push(_processPattern(pattern, sauce));}
	}
	if(options.selector != "time"){
		pattern = options.datePattern || bundle["dateFormat-"+formatLength];
		if(pattern){str.push(_processPattern(pattern, sauce));}
	}

	return str.length == 1 ? str[0] : bundle["dateTimeFormat-"+formatLength].replace(/\'/g,'').replace(/\{(\d+)\}/g,
		function(match, key){ return str[key]; }); // String
};

exports.regexp = function(/*__FormatOptions?*/ options){
	// summary:
	//		Builds the regular needed to parse a localized date

	return exports._parseInfo(options).regexp; // String
};

exports._parseInfo = function(/*__FormatOptions?*/ options){
	options = options || {};
	var locale = i18n.normalizeLocale(options.locale),
		bundle = exports._getGregorianBundle(locale),
		formatLength = options.formatLength || 'short',
		datePattern = options.datePattern || bundle["dateFormat-" + formatLength],
		timePattern = options.timePattern || bundle["timeFormat-" + formatLength],
		pattern;
	if(options.selector == 'date'){
		pattern = datePattern;
	}else if(options.selector == 'time'){
		pattern = timePattern;
	}else{
		pattern = bundle["dateTimeFormat-"+formatLength].replace(/\{(\d+)\}/g,
			function(match, key){ return [timePattern, datePattern][key]; });
	}

	var tokens = [],
		re = _processPattern(pattern, lang.hitch(this, _buildDateTimeRE, tokens, bundle, options));
	return {regexp: re, tokens: tokens, bundle: bundle};
};

exports.parse = function(/*String*/ value, /*__FormatOptions?*/ options){
	// summary:
	//		Convert a properly formatted string to a primitive Date object,
	//		using locale-specific settings.
	//
	// description:
	//		Create a Date object from a string using a known localized pattern.
	//		By default, this method parses looking for both date and time in the string.
	//		Formatting patterns are chosen appropriate to the locale.  Different
	//		formatting lengths may be chosen, with "full" used by default.
	//		Custom patterns may be used or registered with translations using
	//		the dojo/date/locale.addCustomFormats() method.
	//
	//		Formatting patterns are implemented using [the syntax described at
	//		unicode.org](http://www.unicode.org/reports/tr35/tr35-4.html#Date_Format_Patterns)
	//		When two digit years are used, a century is chosen according to a sliding
	//		window of 80 years before and 20 years after present year, for both `yy` and `yyyy` patterns.
	//		year < 100CE requires strict mode.
	//
	// value:
	//		A string representation of a date

	// remove non-printing bidi control chars from input and pattern
	var controlChars = /[\u200E\u200F\u202A\u202E]/g,
		info = exports._parseInfo(options),
		tokens = info.tokens, bundle = info.bundle,
		re = new RegExp("^" + info.regexp.replace(controlChars, "") + "$",
			info.strict ? "" : "i"),
		match = re.exec(value && value.replace(controlChars, ""));

	if(!match){ return null; } // null

	var widthList = ['abbr', 'wide', 'narrow'],
		result = [1970,0,1,0,0,0,0], // will get converted to a Date at the end
		amPm = "",
		valid = array.every(match, function(v, i){
		if(!i){return true;}
		var token = tokens[i-1],
			l = token.length,
			c = token.charAt(0);
		switch(c){
			case 'y':
				if(l != 2 && options.strict){
					//interpret year literally, so '5' would be 5 A.D.
					result[0] = v;
				}else{
					if(v<100){
						v = Number(v);
						//choose century to apply, according to a sliding window
						//of 80 years before and 20 years after present year
						var year = '' + new Date().getFullYear(),
							century = year.substring(0, 2) * 100,
							cutoff = Math.min(Number(year.substring(2, 4)) + 20, 99);
						result[0] = (v < cutoff) ? century + v : century - 100 + v;
					}else{
						//we expected 2 digits and got more...
						if(options.strict){
							return false;
						}
						//interpret literally, so '150' would be 150 A.D.
						//also tolerate '1950', if 'yyyy' input passed to 'yy' format
						result[0] = v;
					}
				}
				break;
			case 'M':
			case 'L':
				if(l>2){
					var months = bundle['months-' +
							    (c == 'L' ? 'standAlone' : 'format') +
							    '-' + widthList[l-3]].concat();
					if(!options.strict){
						//Tolerate abbreviating period in month part
						//Case-insensitive comparison
						v = v.replace(".","").toLowerCase();
						months = array.map(months, function(s){ return s.replace(".","").toLowerCase(); } );
					}
					v = array.indexOf(months, v);
					if(v == -1){
//						console.log("dojo/date/locale.parse: Could not parse month name: '" + v + "'.");
						return false;
					}
				}else{
					v--;
				}
				result[1] = v;
				break;
			case 'E':
			case 'e':
			case 'c':
				var days = bundle['days-' +
						  (c == 'c' ? 'standAlone' : 'format') +
						  '-' + widthList[l-3]].concat();
				if(!options.strict){
					//Case-insensitive comparison
					v = v.toLowerCase();
					days = array.map(days, function(d){return d.toLowerCase();});
				}
				v = array.indexOf(days, v);
				if(v == -1){
//					console.log("dojo/date/locale.parse: Could not parse weekday name: '" + v + "'.");
					return false;
				}

				//TODO: not sure what to actually do with this input,
				//in terms of setting something on the Date obj...?
				//without more context, can't affect the actual date
				//TODO: just validate?
				break;
			case 'D':
				result[1] = 0;
				// fallthrough...
			case 'd':
				result[2] = v;
				break;
			case 'a': //am/pm
				var am = options.am || bundle['dayPeriods-format-wide-am'],
					pm = options.pm || bundle['dayPeriods-format-wide-pm'];
				if(!options.strict){
					var period = /\./g;
					v = v.replace(period,'').toLowerCase();
					am = am.replace(period,'').toLowerCase();
					pm = pm.replace(period,'').toLowerCase();
				}
				if(options.strict && v != am && v != pm){
//					console.log("dojo/date/locale.parse: Could not parse am/pm part.");
					return false;
				}

				// we might not have seen the hours field yet, so store the state and apply hour change later
				amPm = (v == pm) ? 'p' : (v == am) ? 'a' : '';
				break;
			case 'K': //hour (1-24)
				if(v == 24){ v = 0; }
				// fallthrough...
			case 'h': //hour (1-12)
			case 'H': //hour (0-23)
			case 'k': //hour (0-11)
				//TODO: strict bounds checking, padding
				if(v > 23){
//					console.log("dojo/date/locale.parse: Illegal hours value");
					return false;
				}

				//in the 12-hour case, adjusting for am/pm requires the 'a' part
				//which could come before or after the hour, so we will adjust later
				result[3] = v;
				break;
			case 'm': //minutes
				result[4] = v;
				break;
			case 's': //seconds
				result[5] = v;
				break;
			case 'S': //milliseconds
				result[6] = v;
//				break;
//			case 'w':
//TODO				var firstDay = 0;
//			default:
//TODO: throw?
//				console.log("dojo/date/locale.parse: unsupported pattern char=" + token.charAt(0));
		}
		return true;
	});

	var hours = +result[3];
	if(amPm === 'p' && hours < 12){
		result[3] = hours + 12; //e.g., 3pm -> 15
	}else if(amPm === 'a' && hours == 12){
		result[3] = 0; //12am -> 0
	}

	//TODO: implement a getWeekday() method in order to test
	//validity of input strings containing 'EEE' or 'EEEE'...

	var dateObject = new Date(result[0], result[1], result[2], result[3], result[4], result[5], result[6]); // Date
	if(options.strict){
		dateObject.setFullYear(result[0]);
	}

	// Check for overflow.  The Date() constructor normalizes things like April 32nd...
	//TODO: why isn't this done for times as well?
	var allTokens = tokens.join(""),
		dateToken = allTokens.indexOf('d') != -1,
		monthToken = allTokens.indexOf('M') != -1;

	if(!valid ||
		(monthToken && dateObject.getMonth() > result[1]) ||
		(dateToken && dateObject.getDate() > result[2])){
		return null;
	}

	// Check for underflow, due to DST shifts.  See #9366
	// This assumes a 1 hour dst shift correction at midnight
	// We could compare the timezone offset after the shift and add the difference instead.
	if((monthToken && dateObject.getMonth() < result[1]) ||
		(dateToken && dateObject.getDate() < result[2])){
		dateObject = date.add(dateObject, "hour", 1);
	}

	return dateObject; // Date
};

function _processPattern(pattern, applyPattern, applyLiteral, applyAll){
	//summary: Process a pattern with literals in it

	// Break up on single quotes, treat every other one as a literal, except '' which becomes '
	var identity = function(x){return x;};
	applyPattern = applyPattern || identity;
	applyLiteral = applyLiteral || identity;
	applyAll = applyAll || identity;

	//split on single quotes (which escape literals in date format strings)
	//but preserve escaped single quotes (e.g., o''clock)
	var chunks = pattern.match(/(''|[^'])+/g),
		literal = pattern.charAt(0) == "'";

	array.forEach(chunks, function(chunk, i){
		if(!chunk){
			chunks[i]='';
		}else{
			chunks[i]=(literal ? applyLiteral : applyPattern)(chunk.replace(/''/g, "'"));
			literal = !literal;
		}
	});
	return applyAll(chunks.join(''));
}

var widthList = ['abbr', 'wide', 'narrow'];
function _buildDateTimeRE(tokens, bundle, options, pattern){
	pattern = regexp.escapeString(pattern);
	if(!options.strict){ pattern = pattern.replace(" a", " ?a"); } // kludge to tolerate no space before am/pm
	return pattern.replace(/([a-z])\1*/ig, function(match){
		// Build a simple regexp.  Avoid captures, which would ruin the tokens list
		var s,
			c = match.charAt(0),
			l = match.length,
			p2 = '', p3 = '';
		if(options.strict){
			if(l > 1){ p2 = '0' + '{'+(l-1)+'}'; }
			if(l > 2){ p3 = '0' + '{'+(l-2)+'}'; }
		}else{
			p2 = '0?'; p3 = '0{0,2}';
		}
		switch(c){
			case 'y':
				s = '\\d{2,4}';
				break;
			case 'M':
			case 'L':
				if(l>2){
					var months = bundle[
						'months-' +
						(c == 'L' ? 'standAlone' : 'format') +
						'-' + widthList[l-3]
					].slice(0);
					s = months.join('|');
					if(!options.strict){
						s = s.replace(/\./g, '');
						//Tolerate abbreviating period in month part
						s = '(?:' + s + ')\\.?';
					}
				}else{
					s = '1[0-2]|'+p2+'[1-9]';
				}
				break;
			case 'D':
				s = '[12][0-9][0-9]|3[0-5][0-9]|36[0-6]|'+p2+'[1-9][0-9]|'+p3+'[1-9]';
				break;
			case 'd':
				s = '3[01]|[12]\\d|'+p2+'[1-9]';
				break;
			case 'w':
				s = '[1-4][0-9]|5[0-3]|'+p2+'[1-9]';
				break;
			case 'E':
			case 'e':
			case 'c':
				s = '.+?'; // match anything including spaces until the first pattern delimiter is found such as a comma or space
				break;
			case 'h': //hour (1-12)
				s = '1[0-2]|'+p2+'[1-9]';
				break;
			case 'k': //hour (0-11)
				s = '1[01]|'+p2+'\\d';
				break;
			case 'H': //hour (0-23)
				s = '1\\d|2[0-3]|'+p2+'\\d';
				break;
			case 'K': //hour (1-24)
				s = '1\\d|2[0-4]|'+p2+'[1-9]';
				break;
			case 'm':
			case 's':
				s = '[0-5]\\d';
				break;
			case 'S':
				s = '\\d{'+l+'}';
				break;
			case 'a':
				var am = options.am || bundle['dayPeriods-format-wide-am'],
					pm = options.pm || bundle['dayPeriods-format-wide-pm'];
					s = am + '|' + pm;
				if(!options.strict){
					if(am != am.toLowerCase()){ s += '|' + am.toLowerCase(); }
					if(pm != pm.toLowerCase()){ s += '|' + pm.toLowerCase(); }
					if(s.indexOf('.') != -1){ s += '|' + s.replace(/\./g, ""); }
				}
				s = s.replace(/\./g, "\\.");
				break;
			default:
			// case 'v':
			// case 'z':
			// case 'Z':
				s = ".*";
//				console.log("parse of date format, pattern=" + pattern);
		}

		if(tokens){ tokens.push(match); }

		return "(" + s + ")"; // add capture
	}).replace(/[\xa0 ]/g, "[\\s\\xa0]"); // normalize whitespace.  Need explicit handling of \xa0 for IE.
}

var _customFormats = [];
var _cachedGregorianBundles = {};
exports.addCustomFormats = function(/*String*/ packageName, /*String*/ bundleName){
	// summary:
	//		Add a reference to a bundle containing localized custom formats to be
	//		used by date/time formatting and parsing routines.
	//
	// description:
	//		The user may add custom localized formats where the bundle has properties following the
	//		same naming convention used by dojo.cldr: `dateFormat-xxxx` / `timeFormat-xxxx`
	//		The pattern string should match the format used by the CLDR.
	//		See dojo/date/locale.format() for details.
	//		The resources must be loaded by dojo.requireLocalization() prior to use

	_customFormats.push({pkg:packageName,name:bundleName});
	_cachedGregorianBundles = {};
};

exports._getGregorianBundle = function(/*String*/ locale){
	if(_cachedGregorianBundles[locale]){
		return _cachedGregorianBundles[locale];
	}
	var gregorian = {};
	array.forEach(_customFormats, function(desc){
		var bundle = i18n.getLocalization(desc.pkg, desc.name, locale);
		gregorian = lang.mixin(gregorian, bundle);
	}, this);
	return _cachedGregorianBundles[locale] = gregorian; /*Object*/
};

exports.addCustomFormats(module.id.replace(/\/date\/locale$/, ".cldr"),"gregorian");

exports.getNames = function(/*String*/ item, /*String*/ type, /*String?*/ context, /*String?*/ locale){
	// summary:
	//		Used to get localized strings from dojo.cldr for day or month names.
	//
	// item:
	//	'months' || 'days'
	// type:
	//	'wide' || 'abbr' || 'narrow' (e.g. "Monday", "Mon", or "M" respectively, in English)
	// context:
	//	'standAlone' || 'format' (default)
	// locale:
	//	override locale used to find the names

	var label,
		lookup = exports._getGregorianBundle(locale),
		props = [item, context, type];
	if(context == 'standAlone'){
		var key = props.join('-');
		label = lookup[key];
		// Fall back to 'format' flavor of name
		if(label[0] == 1){ label = undefined; } // kludge, in the absence of real aliasing support in dojo.cldr
	}
	props[1] = 'format';

	// return by copy so changes won't be made accidentally to the in-memory model
	return (label || lookup[props.join('-')]).concat(); /*Array*/
};

exports.isWeekend = function(/*Date?*/ dateObject, /*String?*/ locale){
	// summary:
	//	Determines if the date falls on a weekend, according to local custom.

	var weekend = supplemental.getWeekend(locale),
		day = (dateObject || new Date()).getDay();
	if(weekend.end < weekend.start){
		weekend.end += 7;
		if(day < weekend.start){ day += 7; }
	}
	return day >= weekend.start && day <= weekend.end; // Boolean
};

// These are used only by format and strftime.  Do they need to be public?  Which module should they go in?

exports._getDayOfYear = function(/*Date*/ dateObject){
	// summary:
	//		gets the day of the year as represented by dateObject
	return date.difference(new Date(dateObject.getFullYear(), 0, 1, dateObject.getHours()), dateObject) + 1; // Number
};

exports._getWeekOfYear = function(/*Date*/ dateObject, /*Number*/ firstDayOfWeek){
	if(arguments.length == 1){ firstDayOfWeek = 0; } // Sunday

	var firstDayOfYear = new Date(dateObject.getFullYear(), 0, 1).getDay(),
		adj = (firstDayOfYear - firstDayOfWeek + 7) % 7,
		week = Math.floor((exports._getDayOfYear(dateObject) + adj - 1) / 7);

	// if year starts on the specified day, start counting weeks at 1
	if(firstDayOfYear == firstDayOfWeek){ week++; }

	return week; // Number
};

return exports;
});

},
'dojo/date':function(){
define(["./has", "./_base/lang"], function(has, lang){
// module:
//		dojo/date

var date = {
	// summary:
	//		Date manipulation utilities
};

date.getDaysInMonth = function(/*Date*/dateObject){
	// summary:
	//		Returns the number of days in the month used by dateObject
	var month = dateObject.getMonth();
	var days = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	if(month == 1 && date.isLeapYear(dateObject)){ return 29; } // Number
	return days[month]; // Number
};

date.isLeapYear = function(/*Date*/dateObject){
	// summary:
	//		Determines if the year of the dateObject is a leap year
	// description:
	//		Leap years are years with an additional day YYYY-02-29, where the
	//		year number is a multiple of four with the following exception: If
	//		a year is a multiple of 100, then it is only a leap year if it is
	//		also a multiple of 400. For example, 1900 was not a leap year, but
	//		2000 is one.

	var year = dateObject.getFullYear();
	return !(year%400) || (!(year%4) && !!(year%100)); // Boolean
};

// FIXME: This is not localized
date.getTimezoneName = function(/*Date*/dateObject){
	// summary:
	//		Get the user's time zone as provided by the browser
	// dateObject:
	//		Needed because the timezone may vary with time (daylight savings)
	// description:
	//		Try to get time zone info from toString or toLocaleString method of
	//		the Date object -- UTC offset is not a time zone.  See
	//		http://www.twinsun.com/tz/tz-link.htm Note: results may be
	//		inconsistent across browsers.

	var str = dateObject.toString(); // Start looking in toString
	var tz = ''; // The result -- return empty string if nothing found
	var match;

	// First look for something in parentheses -- fast lookup, no regex
	var pos = str.indexOf('(');
	if(pos > -1){
		tz = str.substring(++pos, str.indexOf(')'));
	}else{
		// If at first you don't succeed ...
		// If IE knows about the TZ, it appears before the year
		// Capital letters or slash before a 4-digit year
		// at the end of string
		var pat = /([A-Z\/]+) \d{4}$/;
		if((match = str.match(pat))){
			tz = match[1];
		}else{
		// Some browsers (e.g. Safari) glue the TZ on the end
		// of toLocaleString instead of putting it in toString
			str = dateObject.toLocaleString();
			// Capital letters or slash -- end of string,
			// after space
			pat = / ([A-Z\/]+)$/;
			if((match = str.match(pat))){
				tz = match[1];
			}
		}
	}

	// Make sure it doesn't somehow end up return AM or PM
	return (tz == 'AM' || tz == 'PM') ? '' : tz; // String
};

// Utility methods to do arithmetic calculations with Dates

date.compare = function(/*Date*/date1, /*Date?*/date2, /*String?*/portion){
	// summary:
	//		Compare two date objects by date, time, or both.
	// description:
	//		Returns 0 if equal, positive if a > b, else negative.
	// date1:
	//		Date object
	// date2:
	//		Date object.  If not specified, the current Date is used.
	// portion:
	//		A string indicating the "date" or "time" portion of a Date object.
	//		Compares both "date" and "time" by default.  One of the following:
	//		"date", "time", "datetime"

	// Extra step required in copy for IE - see #3112
	date1 = new Date(+date1);
	date2 = new Date(+(date2 || new Date()));

	if(portion == "date"){
		// Ignore times and compare dates.
		date1.setHours(0, 0, 0, 0);
		date2.setHours(0, 0, 0, 0);
	}else if(portion == "time"){
		// Ignore dates and compare times.
		date1.setFullYear(0, 0, 0);
		date2.setFullYear(0, 0, 0);
	}

	if(date1 > date2){ return 1; } // int
	if(date1 < date2){ return -1; } // int
	return 0; // int
};

date.add = function(/*Date*/date, /*String*/interval, /*int*/amount){
	// summary:
	//		Add to a Date in intervals of different size, from milliseconds to years
	// date: Date
	//		Date object to start with
	// interval:
	//		A string representing the interval.  One of the following:
	//		"year", "month", "day", "hour", "minute", "second",
	//		"millisecond", "quarter", "week", "weekday"
	// amount:
	//		How much to add to the date.

	var sum = new Date(+date); // convert to Number before copying to accommodate IE (#3112)
	var fixOvershoot = false;
	var property = "Date";

	switch(interval){
		case "day":
			break;
		case "weekday":
			//i18n FIXME: assumes Saturday/Sunday weekend, but this is not always true.  see dojo/cldr/supplemental

			// Divide the increment time span into weekspans plus leftover days
			// e.g., 8 days is one 5-day weekspan / and two leftover days
			// Can't have zero leftover days, so numbers divisible by 5 get
			// a days value of 5, and the remaining days make up the number of weeks
			var days, weeks;
			var mod = amount % 5;
			if(!mod){
				days = (amount > 0) ? 5 : -5;
				weeks = (amount > 0) ? ((amount-5)/5) : ((amount+5)/5);
			}else{
				days = mod;
				weeks = parseInt(amount/5);
			}
			// Get weekday value for orig date param
			var strt = date.getDay();
			// Orig date is Sat / positive incrementer
			// Jump over Sun
			var adj = 0;
			if(strt == 6 && amount > 0){
				adj = 1;
			}else if(strt == 0 && amount < 0){
			// Orig date is Sun / negative incrementer
			// Jump back over Sat
				adj = -1;
			}
			// Get weekday val for the new date
			var trgt = strt + days;
			// New date is on Sat or Sun
			if(trgt == 0 || trgt == 6){
				adj = (amount > 0) ? 2 : -2;
			}
			// Increment by number of weeks plus leftover days plus
			// weekend adjustments
			amount = (7 * weeks) + days + adj;
			break;
		case "year":
			property = "FullYear";
			// Keep increment/decrement from 2/29 out of March
			fixOvershoot = true;
			break;
		case "week":
			amount *= 7;
			break;
		case "quarter":
			// Naive quarter is just three months
			amount *= 3;
			// fallthrough...
		case "month":
			// Reset to last day of month if you overshoot
			fixOvershoot = true;
			property = "Month";
			break;
//		case "hour":
//		case "minute":
//		case "second":
//		case "millisecond":
		default:
			property = "UTC"+interval.charAt(0).toUpperCase() + interval.substring(1) + "s";
	}

	if(property){
		sum["set"+property](sum["get"+property]()+amount);
	}

	if(fixOvershoot && (sum.getDate() < date.getDate())){
		sum.setDate(0);
	}

	return sum; // Date
};

date.difference = function(/*Date*/date1, /*Date?*/date2, /*String?*/interval){
	// summary:
	//		Get the difference in a specific unit of time (e.g., number of
	//		months, weeks, days, etc.) between two dates, rounded to the
	//		nearest integer.
	// date1:
	//		Date object
	// date2:
	//		Date object.  If not specified, the current Date is used.
	// interval:
	//		A string representing the interval.  One of the following:
	//		"year", "month", "day", "hour", "minute", "second",
	//		"millisecond", "quarter", "week", "weekday"
	//
	//		Defaults to "day".

	date2 = date2 || new Date();
	interval = interval || "day";
	var yearDiff = date2.getFullYear() - date1.getFullYear();
	var delta = 1; // Integer return value

	switch(interval){
		case "quarter":
			var m1 = date1.getMonth();
			var m2 = date2.getMonth();
			// Figure out which quarter the months are in
			var q1 = Math.floor(m1/3) + 1;
			var q2 = Math.floor(m2/3) + 1;
			// Add quarters for any year difference between the dates
			q2 += (yearDiff * 4);
			delta = q2 - q1;
			break;
		case "weekday":
			var days = Math.round(date.difference(date1, date2, "day"));
			var weeks = parseInt(date.difference(date1, date2, "week"));
			var mod = days % 7;

			// Even number of weeks
			if(mod == 0){
				days = weeks*5;
			}else{
				// Weeks plus spare change (< 7 days)
				var adj = 0;
				var aDay = date1.getDay();
				var bDay = date2.getDay();

				weeks = parseInt(days/7);
				mod = days % 7;
				// Mark the date advanced by the number of
				// round weeks (may be zero)
				var dtMark = new Date(date1);
				dtMark.setDate(dtMark.getDate()+(weeks*7));
				var dayMark = dtMark.getDay();

				// Spare change days -- 6 or less
				if(days > 0){
					switch(true){
						// Range starts on Sat
						case aDay == 6:
							adj = -1;
							break;
						// Range starts on Sun
						case aDay == 0:
							adj = 0;
							break;
						// Range ends on Sat
						case bDay == 6:
							adj = -1;
							break;
						// Range ends on Sun
						case bDay == 0:
							adj = -2;
							break;
						// Range contains weekend
						case (dayMark + mod) > 5:
							adj = -2;
					}
				}else if(days < 0){
					switch(true){
						// Range starts on Sat
						case aDay == 6:
							adj = 0;
							break;
						// Range starts on Sun
						case aDay == 0:
							adj = 1;
							break;
						// Range ends on Sat
						case bDay == 6:
							adj = 2;
							break;
						// Range ends on Sun
						case bDay == 0:
							adj = 1;
							break;
						// Range contains weekend
						case (dayMark + mod) < 0:
							adj = 2;
					}
				}
				days += adj;
				days -= (weeks*2);
			}
			delta = days;
			break;
		case "year":
			delta = yearDiff;
			break;
		case "month":
			delta = (date2.getMonth() - date1.getMonth()) + (yearDiff * 12);
			break;
		case "week":
			// Truncate instead of rounding
			// Don't use Math.floor -- value may be negative
			delta = parseInt(date.difference(date1, date2, "day")/7);
			break;
		case "day":
			delta /= 24;
			// fallthrough
		case "hour":
			delta /= 60;
			// fallthrough
		case "minute":
			delta /= 60;
			// fallthrough
		case "second":
			delta /= 1000;
			// fallthrough
		case "millisecond":
			delta *= date2.getTime() - date1.getTime();
	}

	// Round for fractional values and DST leaps
	return Math.round(delta); // Number (integer)
};

// Don't use setObject() because it may overwrite dojo/date/stamp (if that has already been loaded)
 1  && lang.mixin(lang.getObject("dojo.date", true), date);

return date;
});

},
'dojo/cldr/supplemental':function(){
define(["../_base/lang", "../i18n"], function(lang, i18n){

// module:
//		dojo/cldr/supplemental


var supplemental = {
	// summary:
	//		TODOC
};
lang.setObject("dojo.cldr.supplemental", supplemental);

supplemental.getFirstDayOfWeek = function(/*String?*/locale){
	// summary:
	//		Returns a zero-based index for first day of the week
	// description:
	//		Returns a zero-based index for first day of the week, as used by the local (Gregorian) calendar.
	//		e.g. Sunday (returns 0), or Monday (returns 1)

	// from http://www.unicode.org/cldr/data/common/supplemental/supplementalData.xml:supplementalData/weekData/firstDay
	var firstDay = {/*default is 1=Monday*/
		bd:5,mv:5,
		ae:6,af:6,bh:6,dj:6,dz:6,eg:6,iq:6,ir:6,jo:6,kw:6,
		ly:6,ma:6,om:6,qa:6,sa:6,sd:6,sy:6,ye:6,
		ag:0,ar:0,as:0,au:0,br:0,bs:0,bt:0,bw:0,by:0,bz:0,ca:0,cn:0,
		co:0,dm:0,'do':0,et:0,gt:0,gu:0,hk:0,hn:0,id:0,ie:0,il:0,'in':0,
		jm:0,jp:0,ke:0,kh:0,kr:0,la:0,mh:0,mm:0,mo:0,mt:0,mx:0,mz:0,
		ni:0,np:0,nz:0,pa:0,pe:0,ph:0,pk:0,pr:0,py:0,sg:0,sv:0,th:0,
		tn:0,tt:0,tw:0,um:0,us:0,ve:0,vi:0,ws:0,za:0,zw:0
	};

	var country = supplemental._region(locale);
	var dow = firstDay[country];
	return (dow === undefined) ? 1 : dow; /*Number*/
};

supplemental._region = function(/*String?*/locale){
	locale = i18n.normalizeLocale(locale);
	var tags = locale.split('-');
	var region = tags[1];
	if(!region){
		// IE often gives language only (#2269)
		// Arbitrary mappings of language-only locales to a country:
		region = {
			aa:"et", ab:"ge", af:"za", ak:"gh", am:"et", ar:"eg", as:"in", av:"ru", ay:"bo", az:"az", ba:"ru",
			be:"by", bg:"bg", bi:"vu", bm:"ml", bn:"bd", bo:"cn", br:"fr", bs:"ba", ca:"es", ce:"ru", ch:"gu",
			co:"fr", cr:"ca", cs:"cz", cv:"ru", cy:"gb", da:"dk", de:"de", dv:"mv", dz:"bt", ee:"gh", el:"gr",
			en:"us", es:"es", et:"ee", eu:"es", fa:"ir", ff:"sn", fi:"fi", fj:"fj", fo:"fo", fr:"fr", fy:"nl",
			ga:"ie", gd:"gb", gl:"es", gn:"py", gu:"in", gv:"gb", ha:"ng", he:"il", hi:"in", ho:"pg", hr:"hr",
			ht:"ht", hu:"hu", hy:"am", ia:"fr", id:"id", ig:"ng", ii:"cn", ik:"us", "in":"id", is:"is", it:"it",
			iu:"ca", iw:"il", ja:"jp", ji:"ua", jv:"id", jw:"id", ka:"ge", kg:"cd", ki:"ke", kj:"na", kk:"kz",
			kl:"gl", km:"kh", kn:"in", ko:"kr", ks:"in", ku:"tr", kv:"ru", kw:"gb", ky:"kg", la:"va", lb:"lu",
			lg:"ug", li:"nl", ln:"cd", lo:"la", lt:"lt", lu:"cd", lv:"lv", mg:"mg", mh:"mh", mi:"nz", mk:"mk",
			ml:"in", mn:"mn", mo:"ro", mr:"in", ms:"my", mt:"mt", my:"mm", na:"nr", nb:"no", nd:"zw", ne:"np",
			ng:"na", nl:"nl", nn:"no", no:"no", nr:"za", nv:"us", ny:"mw", oc:"fr", om:"et", or:"in", os:"ge",
			pa:"in", pl:"pl", ps:"af", pt:"br", qu:"pe", rm:"ch", rn:"bi", ro:"ro", ru:"ru", rw:"rw", sa:"in",
			sd:"in", se:"no", sg:"cf", si:"lk", sk:"sk", sl:"si", sm:"ws", sn:"zw", so:"so", sq:"al", sr:"rs",
			ss:"za", st:"za", su:"id", sv:"se", sw:"tz", ta:"in", te:"in", tg:"tj", th:"th", ti:"et", tk:"tm",
			tl:"ph", tn:"za", to:"to", tr:"tr", ts:"za", tt:"ru", ty:"pf", ug:"cn", uk:"ua", ur:"pk", uz:"uz",
			ve:"za", vi:"vn", wa:"be", wo:"sn", xh:"za", yi:"il", yo:"ng", za:"cn", zh:"cn", zu:"za",
			ace:"id", ady:"ru", agq:"cm", alt:"ru", amo:"ng", asa:"tz", ast:"es", awa:"in", bal:"pk",
			ban:"id", bas:"cm", bax:"cm", bbc:"id", bem:"zm", bez:"tz", bfq:"in", bft:"pk", bfy:"in",
			bhb:"in", bho:"in", bik:"ph", bin:"ng", bjj:"in", bku:"ph", bqv:"ci", bra:"in", brx:"in",
			bss:"cm", btv:"pk", bua:"ru", buc:"yt", bug:"id", bya:"id", byn:"er", cch:"ng", ccp:"in",
			ceb:"ph", cgg:"ug", chk:"fm", chm:"ru", chp:"ca", chr:"us", cja:"kh", cjm:"vn", ckb:"iq",
			crk:"ca", csb:"pl", dar:"ru", dav:"ke", den:"ca", dgr:"ca", dje:"ne", doi:"in", dsb:"de",
			dua:"cm", dyo:"sn", dyu:"bf", ebu:"ke", efi:"ng", ewo:"cm", fan:"gq", fil:"ph", fon:"bj",
			fur:"it", gaa:"gh", gag:"md", gbm:"in", gcr:"gf", gez:"et", gil:"ki", gon:"in", gor:"id",
			grt:"in", gsw:"ch", guz:"ke", gwi:"ca", haw:"us", hil:"ph", hne:"in", hnn:"ph", hoc:"in",
			hoj:"in", ibb:"ng", ilo:"ph", inh:"ru", jgo:"cm", jmc:"tz", kaa:"uz", kab:"dz", kaj:"ng",
			kam:"ke", kbd:"ru", kcg:"ng", kde:"tz", kdt:"th", kea:"cv", ken:"cm", kfo:"ci", kfr:"in",
			kha:"in", khb:"cn", khq:"ml", kht:"in", kkj:"cm", kln:"ke", kmb:"ao", koi:"ru", kok:"in",
			kos:"fm", kpe:"lr", krc:"ru", kri:"sl", krl:"ru", kru:"in", ksb:"tz", ksf:"cm", ksh:"de",
			kum:"ru", lag:"tz", lah:"pk", lbe:"ru", lcp:"cn", lep:"in", lez:"ru", lif:"np", lis:"cn",
			lki:"ir", lmn:"in", lol:"cd", lua:"cd", luo:"ke", luy:"ke", lwl:"th", mad:"id", mag:"in",
			mai:"in", mak:"id", man:"gn", mas:"ke", mdf:"ru", mdh:"ph", mdr:"id", men:"sl", mer:"ke",
			mfe:"mu", mgh:"mz", mgo:"cm", min:"id", mni:"in", mnk:"gm", mnw:"mm", mos:"bf", mua:"cm",
			mwr:"in", myv:"ru", nap:"it", naq:"na", nds:"de", "new":"np", niu:"nu", nmg:"cm", nnh:"cm",
			nod:"th", nso:"za", nus:"sd", nym:"tz", nyn:"ug", pag:"ph", pam:"ph", pap:"bq", pau:"pw",
			pon:"fm", prd:"ir", raj:"in", rcf:"re", rej:"id", rjs:"np", rkt:"in", rof:"tz", rwk:"tz",
			saf:"gh", sah:"ru", saq:"ke", sas:"id", sat:"in", saz:"in", sbp:"tz", scn:"it", sco:"gb",
			sdh:"ir", seh:"mz", ses:"ml", shi:"ma", shn:"mm", sid:"et", sma:"se", smj:"se", smn:"fi",
			sms:"fi", snk:"ml", srn:"sr", srr:"sn", ssy:"er", suk:"tz", sus:"gn", swb:"yt", swc:"cd",
			syl:"bd", syr:"sy", tbw:"ph", tcy:"in", tdd:"cn", tem:"sl", teo:"ug", tet:"tl", tig:"er",
			tiv:"ng", tkl:"tk", tmh:"ne", tpi:"pg", trv:"tw", tsg:"ph", tts:"th", tum:"mw", tvl:"tv",
			twq:"ne", tyv:"ru", tzm:"ma", udm:"ru", uli:"fm", umb:"ao", unr:"in", unx:"in", vai:"lr",
			vun:"tz", wae:"ch", wal:"et", war:"ph", xog:"ug", xsr:"np", yao:"mz", yap:"fm", yav:"cm", zza:"tr"
		}[tags[0]];
	}else if(region.length == 4){
		// The ISO 3166 country code is usually in the second position, unless a
		// 4-letter script is given. See http://www.ietf.org/rfc/rfc4646.txt
		region = tags[2];
	}
	return region;
};

supplemental.getWeekend = function(/*String?*/locale){
	// summary:
	//		Returns a hash containing the start and end days of the weekend
	// description:
	//		Returns a hash containing the start and end days of the weekend according to local custom using locale,
	//		or by default in the user's locale.
	//		e.g. {start:6, end:0}

	// from http://www.unicode.org/cldr/data/common/supplemental/supplementalData.xml:supplementalData/weekData/weekend{Start,End}
	var weekendStart = {/*default is 6=Saturday*/
			'in':0,
			af:4,dz:4,ir:4,om:4,sa:4,ye:4,
			ae:5,bh:5,eg:5,il:5,iq:5,jo:5,kw:5,ly:5,ma:5,qa:5,sd:5,sy:5,tn:5
		},

		weekendEnd = {/*default is 0=Sunday*/
			af:5,dz:5,ir:5,om:5,sa:5,ye:5,
			ae:6,bh:5,eg:6,il:6,iq:6,jo:6,kw:6,ly:6,ma:6,qa:6,sd:6,sy:6,tn:6
		},

		country = supplemental._region(locale),
		start = weekendStart[country],
		end = weekendEnd[country];

	if(start === undefined){start=6;}
	if(end === undefined){end=0;}
	return {start:start, end:end}; /*Object {start,end}*/
};

return supplemental;
});

},
'appivo/model/RelationEnd':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'dojo/_base/Deferred',
        'appivo/model/Element'], function(lang, declare, Deferred) {
	return declare("appivo.model.RelationEnd", [appivo.model.Element], {

		inverse: false,
		relation: null,
		
		constructor: function(options) {
			lang.mixin(this, options);
		},
		
		getName: function() {
			return this.inverse ? this.relation.getDestinationName() : this.relation.getSourceName();			
		},
		
		getRemoteName: function() {
			return this.inverse ? this.relation.getSourceName() : this.relation.getDestinationName();						
		},
		
		getCardinality: function() {
			return this.inverse ? this.relation.getDestinationCardinality() : this.relation.getSourceCardinality();
		},
		
		getRemoteCardinality: function() {
			return this.inverse ? this.relation.getSourceCardinality() : this.relation.getDestinationCardinality();			
		},
		
		isOneway: function() {
			return this.relation.isOneway();
		},

		isPlural: function() {
		    var cardinality = this.getCardinality();
		    return cardinality === "ZERO_TO_MANY" || cardinality === "ONE_TO_MANY";
		},
		
		isSystem: function() {
			return this.relation.isSystem();
		},
		
		isHidden: function() {
			return this.relation.isHidden();
		},
		
		isIntegrityEnforced: function() {
			return this.relation.isIntegrityEnforced();
		},
		
		isManyToMany: function() {
			return this.relation.isManyToMany();
		},
		
		isOneToOne: function() {
			return this.relation.isOneToOne();
		},
		
		getSource: function() {
			return this.inverse ? this.relation.getDestination() : this.relation.getSource();
		},
		
		getDestination: function() {
			return this.inverse ? this.relation.getSource() : this.relation.getDestination();
		},
				
		getThrough: function() {
			return this.relation.getThrough();
		},
		
		getRelation: function() {
			return this.relation;
		},
		
		isInverse: function() {
			return this.inverse;
		},
		
		toJSON: function(args) {
			var options = {};
			lang.mixin(options, args);
			var oldinv = this.inverse;
			if (options.normalize) {
				this.inverse = false;
			}
			var rel = {
				id: this.relation.getId(),
				ver: this.relation.getVersion(),
				source: this.getSource().getName(),
				sourceName: this.getName(),
				sourceCardinality: this.getCardinality(),
				destination: this.getDestination().getName(),
				destinationName: this.getRemoteName(),
				destinationCardinality: this.getRemoteCardinality(),
				strong: this.relation.isStrong(),
				inverse: this.inverse
			};
			var through = this.getThrough();
			if (through) {
				rel.through = through.getName()
			}
			if (args && args.useIds) {
				rel.source = this.getSource().getId();
				rel.destination = this.getDestination().getId();
				if (through) {
					rel.through = through.getId();
				}
			}
			if (options.normalize) {
				this.inverse = oldinv;
			}
			return rel;
		}
	});
});
},
'appivo/model/Relation':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'dojo/_base/Deferred',
        'appivo/model/Element',
        'dojo/i18n!appivo/nls/Relation'], function(lang, declare, Deferred, Element, messages) {
	
	var clss = declare("appivo.model.Relation", [Element], {

		ver: null,
		sourceCardinality: 'ZERO_OR_ONE',
		destinationCardinality: 'ZERO_OR_ONE',
		enforcedIntegrity: true,
		oneway: false,
		system: false,
		strong: false,
		hidden: false,
		imported: false,
		sourceName: null,
		destinationName: null,
		source: null,
		destination: null,
		through: null,
		spec: null,
		
		getVersion: function() {
			return this.ver;
		},
		
		getSourceName: function() {
			return this.sourceName;
		},
		
		getDestinationName: function() {
			return this.destinationName;
		},

		getSourceCardinality: function() {
			return this.sourceCardinality;
		},
		
		getDestinationCardinality: function() {
			return this.destinationCardinality;
		},
		
		isStrong: function() {
			return this.strong;
		},
		
		isOneway: function() {
			return this.oneway;
		},

		isSystem: function() {
			return this.system;
		},
		
		isHidden: function() {
			return this.hidden;
		},
		
		isImported: function() {
			return this.imported;
		},
		
		isIntegrityEnforced: function() {
			return this.enforcedIntegrity;
		},
		
		isManyToMany: function() {
			var src = this.getSourceCardinality();
			var dst = this.getDestinationCardinality();
			return (src == 'ZERO_TO_MANY' || src == 'ONE_TO_MANY') && (dst == 'ZERO_TO_MANY' || dst == 'ONE_TO_MANY');
		},
		
		isOneToOne: function() {
			var src = this.getSourceCardinality();
			var dst = this.getDestinationCardinality();
			return (src == 'ZERO_OR_ONE' || src == 'ONE') && (dst == 'ZERO_OR_ONE' || dst == 'ONE');			
		},
		
		getSource: function() {
			return this.source;
		},
		
		getDestination: function() {
			return this.destination;
		},
				
		getThrough: function() {
			return this.through;
		},
		
		getSpec: function() {
			return this.spec;
		},
		
		setSpec: function(spec) {
			this.spec = spec;
		},
		
		_resolveOnLoad: function(schema) {
		    this.source = schema.getModel(this.source);
			this.destination = schema.getModel(this.destination);
			if (this.through != null) {
				this.through = schema.getModel(this.through); 
			}			
		},
		
		_resolve: function(schema) {
			this.source = schema.getModelById(this.source);
			this.destination = schema.getModelById(this.destination);
			if (this.through != null) {
				this.through = schema.getModelById(this.through); 
			}
		},
		
		invert: function() {
			var source = this.source;
			var sourceCardinality = this.sourceCardinality;
			var sourceName = this.sourceName;
			this.source = this.destination;
			this.sourceCardinality = this.destinationCardinality;
			this.sourceName = this.destinationName;
			this.destination = source;
			this.destinationCardinality = sourceCardinality;
			this.destinationName = sourceName;
		},
		
		toJSON: function(options) {
			var json = this.inherited(arguments);
			if(!this.source){
			    return {};
			}
			var relJson = {
				ver: this.ver,
				sourceCardinality: this.sourceCardinality,
				destinationCardinality: this.destinationCardinality,
				source: this.source.getName(),
				sourceName: this.sourceName,
				destinationName: this.destinationName,
				oneway: this.oneway,
				hidden: this.hidden,
				system: this.system,
				strong: this.strong,
				imported: this.imported,
				enforcedIntegrity: this.enforcedIntegrity,
				spec: this.spec
			};
			if (this.destination) {
				relJson.destination = this.destination.getName();
			}
			if (options && options.useIds) {
				relJson.source = this.source.getId();
				relJson.destination = this.destination.getId();
				if (this.destination) {
					relJson.destination = this.destination.getId();
				}
				if (this.through) {
					relJson.through = this.through.getId();
				}
			}
			lang.mixin(json, relJson);
			return json;
		}
	});
	
	clss.cardinalityMap = {
		ONE: messages.cardOne,
		ZERO_OR_ONE: messages.cardZeroOrOne,
		ZERO_TO_MANY: messages.cardZeroToMany,
		ONE_TO_MANY: messages.cardOneToMany
	};
	
	clss.cardinalityOptions = [
	     {
	    	 label: messages.cardZeroOrOne,
	    	 value: 'ZERO_OR_ONE'
	     },
	     {
	    	 label: messages.cardOne,
	    	 value: 'ONE'
	     },
	     {
	    	 label: messages.cardZeroToMany,
	    	 value: 'ZERO_TO_MANY'
	     },
	     {
	    	 label: messages.cardOneToMany,
	    	 value: 'ONE_TO_MANY'
	     }
	];
	
	clss.getCardinalityOptions = function() {
		return clss.cardinalityOptions;
	};
	
	return clss;
});
},
'appivo/model/Privilege':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'dojo/_base/Deferred',
        'appivo/model/Element',
        'appivo/util/Identity'], function(lang, declare, Deferred, Element, Identity) {
	return declare("appivo.model.Privilege", [Element], {
		
		constructor: function(options) {
			lang.mixin(this.options);
		}
	
	});
});
},
'appivo/model/Record':function(){
/**
 * A database record.
 * @interface Record
 */

define(['dojo/_base/lang',
        'dojo/_base/declare',
        'dojo/_base/Deferred',
        'dojo/when',
		'./RecordDiff',
        'appivo/util/Date',
        'appivo/util/Point',
        'appivo/client/Client',
		'appivo/client/Bus',
		'appivo/util/Equals',
        'appivo/util/ExpressionParser',
        'appivo/util/Identity'], function(lang, declare, Deferred, when, RecordDiff, AMDate, Point, Client, Bus, Equals, ExpressionParser, Identity) {

	var BASE64_PROPERTY = "@base64";
	var TEXT_PROPERTY = "@text";
	var META_PROPERTY = "@meta";
	var MAXSIZE = 64 * 1024;
	var client = Client.getInstance();
	
	var serMap = null;

	var Record = declare("appivo.model.Record", [], {

		__new: true,
		__model: null,
		__store: null,

		/**
		 * Creates a new Record instance.
		 * 
		 * @param {Object} options - Configuration options
		 * @param {Object} options.data - Record data to initialize with
		 * @param {Object} options.store - Data store associated with this record
		 * @param {Object} options.model - Model associated with this record
		 * @param {boolean} norecurse - Whether to avoid recursively creating relation objects
		 * @memberof Record
		 * @instance
		 */
		constructor: function(options, norecurse) {
			var data = null;
			if (options) {
				if (options.data) {
					data = options.data;
					if (!this.__model && data.__model) {
						this.__model = data.__model;
					}
					if (data.__model && data.toJSON) {
						data = data.toJSON({
							keepIds: true,
							includeLabels: true
						});
					}
				}
				if (data) {
					lang.mixin(this, data);
				}
				this.__store = options.store;
				this.__model = options.model;
			}
			if (data != null) {
				var keys = Object.keys(data);
				for (var i = 0; i < keys.length; i++) {
					var name = keys[i];
					var attr = this.__model.getAttribute(name);
					if (attr != null && attr.getType() == 'POINT') {
						var val = this[name];
						if (val) {
							var point = new Point(val);
							this[name] = point;
						} else {
							this[name] = val;
						}
					}
				}
			} else {
				this.reset();
			}
			
			if (!norecurse) {
				serMap = {};
				if (this.id) {
					serMap[this.id] = this;					
				}
			} else if (serMap && this.id) {
				serMap[this.id] = this;
			}
			
			if (!this.__store && this.__model) {
				this.__store = this.__model.getStore();
			}
			if (options) {
				lang.mixin(options);				
			}
			this._createRelations();
			if (!norecurse) {
				serMap = null;
			}
		},
				
	    /**
		 * Returns the record's ID.
		 * @returns {string} The ID of the record
		 * @memberof Record
		 * @instance
		 * 
		 * @example
		 * // Get a record's ID
		 * var recordId = record.getId();
		 * console.log("Record ID:", recordId);
		 */
		getId: function() {
			return this.id;
		},
		
	    /**
		 * Returns the URL for this record.
		 * @returns {string} The URL pointing to this record's resource
		 * @memberof Record
		 * @instance
		 * 
		 * @example
		 * // Get the URL for a record
		 * var url = record.getURL();
		 * // Returns something like "/api/myschema/mymodel/123456"
		 */
		getURL: function() {
			return this.__model.getRecordURI(this.id);
		},
		
	    /**
		 * If this is a document record, this function returns the URL to the file pointed to by this record.
		 * @param {boolean} nocache - If true, ensures the link cannot be cached
		 * @param {boolean} encode - If true, ensures any query parameters are URI-encoded
		 * @returns {string} The URL to the document
		 * @memberof Record
		 * @instance
		 * 
		 * @example
		 * // Get the URL to a document without caching
		 * var docUrl = documentRecord.getDocumentURL(true);
		 * 
		 * // Get the URL with double-encoding for parameters
		 * var encodedUrl = documentRecord.getDocumentURL(false, true);
		 *
		 */
		getDocumentURL: function(nocache, encode) {
			var url = '/files/' + this.checksum;
			if (this.filename) {
				var filename = encodeURIComponent(this.filename);
				if (encode) {
					filename = encodeURIComponent(filename);
				}
				url += "?filename=" + filename;
			}
			//if (Identity.isTempId(this.id)) {

				url = client.getURI(url);
				/*
			} else {
				url = this.getURL() + '/file/' + (nocache ? this.checksum : this.filename + '?v=' + this.ver);
			}
			*/
			return url;
		},
		
	    /**
		 * If this is a document record, this function returns the download URL.
		 * The download URL includes a query parameter that triggers download behavior in the browser.
		 * @returns {string} The download URL for the document
		 * @memberof Record
		 * @instance
		 * 
		 * @example
		 * // Get the download URL for a document
		 * var downloadUrl = documentRecord.getDownloadURL();
		 * // Can be used in an anchor tag to trigger download:
		 * // <a href="downloadUrl">Download Document</a>
		 *
		 * @LogicMeta {
		 *     "api":"Record",
		 *     "returntype": "String",
		 *     "tooltip": "$"
		 * }
		 */
		getDownloadURL: function() {
			var url = this.getDocumentURL();
			if (url.indexOf("?v=") > 0) {
				url = url + "&";
			} else {
				url = url + "?";
			}
			url = url + 'download=true';
			return url;
		},
		
	    /**
		 * Returns the URL to a thumbnail of a document.
		 * @param {string} format - The format/size of the thumbnail (e.g., "small", "medium", "large")
		 * @returns {string} The URL to the thumbnail
		 * @memberof Record
		 * @instance
		 * 
		 * @example
		 * // Get a small thumbnail URL
		 * var thumbUrl = documentRecord.getThumbnailURL("small");
		 * 
		 * // Get a medium thumbnail URL
		 * var mediumThumbUrl = documentRecord.getThumbnailURL("medium");
		 */
		getThumbnailURL: function(format) {
			var url = null;
			if (Identity.isTempId(this.id)) {
				url = client.getURI('/files/' + this.checksum + "-thumb" + format);
			} else {
				url = this.getURL() + '/thumb/' + format + '?v=' + this.ver;
			}
			return url;
		},
		
		/**
		 * Download the contents of this document.
		 * @returns {Promise} A promise that resolves with the document content
		 * @memberof Record
		 * @instance
		 * 
		 * @example
		 * // Load a document's content
		 * documentRecord.load().then(function(content) {
		 *     console.log("Document loaded:", content);
		 * }, function(error) {
		 *     console.error("Failed to load document:", error);
		 * });
		 */
		load: function() {
			var t = this;
			var url = this.getDocumentURL();
			var handleAs = "text";
			var contentType = this.contenttype;
			if (contentType) {
				if (contentType == "application/json") {
					handleAs = "json";
				} else if (contentType == "text/xml" || contentType == "application/xml") {
					handleAs = "xml";
				} else if (contentType.startsWith("text/")) {
					handleAs = "text";
				} else {
					handleAs = "document";
				}
			} 
			
			var def = client.sendRequest(url, {
				uriComplete: true,
				handleAs: handleAs,
				withCredentials: true
			});
			return def;
		},

		/**
		 * Load the records of a relation.
		 *
		 * @param {string} relation - Name of relationship to load
		 * @param {Object} [options] - Options for loading the records
		 * @param {boolean} [options.add=false] - If true, adds loaded records to this record instance
		 * @param {boolean} [options.labels=false] - If true, fetches associated labels
		 * @returns {Promise} A promise that resolves with the loaded related records
		 * 
		 * @example
		 * // Load related "comments" and add them to the record
		 * record.loadRelatedRecords("comments", { add: true }).then(function(comments) {
		 *     console.log("Loaded", comments.length, "comments");
		 * });
		 * 
		 * // Load related "categories" with their labels
		 * record.loadRelatedRecords("categories", { 
		 *     add: true, 
		 *     labels: true 
		 * }).then(function(categories) {
		 *     console.log("Loaded categories with labels");
		 * });
		 */
		loadRelatedRecords: function(relation, options) {
			var t = this;
			if (!options) {
				options = {};
			}
			var def = new Deferred();
			var rel = this.getModel().getRelationship(relation);
			if (rel) {
				if (!this._isNew()) {
					var destModel = rel.getDestination();
					var url = this.getURL() + "/relation/" + relation;
					var headers = {};
					if (options.labels) {
						headers['FetchMode'] = "LABELS";
					}
					client.sendRequest(url, {
						uriComplete: true,
						headers: headers,
						handleAs: "json",
						withCredentials: true
					}).then(function (records) {
						if (records) {
							for (var i = 0; i < records.length; i++) {
								records[i] = destModel.createRecord(records[i]);
							}
						}
						if (options.add) {
							t[relation] = records;
						}
						def.resolve(records);
					}, function (error) {
						def.reject(error);
					});
				} else {
					def.resolve(this[relation]);
				}
			} else {
				def.reject("Unknown relationship " + relation);
			}
			return def;
		},
		
	    /**
		 * Returns the record's model.
		 * @returns {Model} The model this record belongs to
		 * @memberof Record
		 * @instance
		 * 
		 * @example
		 * // Get the model of a record
		 * var model = record.getModel();
		 * console.log("Model name:", model.getName());
		 */
		getModel: function() {
			return this.__model;
		},

		/**
		 * Returns the display label for this record.
		 * The label is determined by the model's label configuration.
		 * 
		 * @returns {string} The display label for this record
		 * @memberof Record
		 * @instance
		 * 
		 * @example
		 * // Get the display label for a record
		 * var label = record.getLabel();
		 * console.log("Record label:", label);
		 */
		getLabel: function() {
			return this.__model.getLabel(this);
		},

		getStore: function() {
			return this.__store;
		},

		setStore: function(store) {
			this.__store = store;
		},
		
		/**
		 * Checks if the record has all necessary data loaded.
		 * A record is considered complete if at least one attribute (other than id) has a value.
		 * 
		 * @returns {boolean} True if the record is complete, false otherwise
		 * @memberof Record
		 * @instance
		 * 
		 * @example
		 * // Check if a record is complete
		 * if (record.isComplete()) {
		 *     console.log("Record has all necessary data");
		 * } else {
		 *     console.log("Record is incomplete");
		 * }
		 */
		isComplete: function() {
			var complete = false;
			/*
			var rels = this.__model.getRelationships();
			for (var i in rels) {
				var rel = rels[i];
				var attr = this.__model.getAttributeForRelation(rel.getName());
				if (attr != null) {
					// Should we check if it's set ?
				} else if (!rel.isSystem() && !rel.isHidden()) {
					if (this[rel.getName()] == undefined) {
						complete = false;
						break;
					}					
				}
			}
			*/
			var attrs = this.__model.getAttributes();
			for (var i in attrs) {
				var attr = attrs[i];
				if (attr.name != 'id') {
					if (this[attr.name] != undefined) {
						complete = true;
						break;
					}
				}
			}
			return complete;
		},
		
		/**
		 * Resets the record to its default values.
		 * All non-system attributes are set to their default values, and relationships are removed.
		 * 
		 * @memberof Record
		 * @instance
		 * 
		 * @example
		 * // Reset a record to its default state
		 * record.reset();
		 */
		reset: function() {
			if (this.__model) {
				var attrs = this.__model.getAttributes();
				for (var i in attrs) {
					var attr = attrs[i];
					if (!attr.system) {
						this[attr.name] = attr.getDefaultValue();
					}
				}	
				var rels = this.__model.getRelationships();
				for (var i in rels) {
					var rel = rels[i];
					delete this[rel.name];
				}				
			}
		},
		
		/**
		 * Gets a property from a JSON attribute by path.
		 * 
		 * @param {string} attr - The attribute name containing JSON data
		 * @param {string} path - The path to the property within the JSON object
		 * @returns {*} The value at the specified path
		 * @memberof Record
		 * @instance
		 * 
		 * @example
		 * // If record has a "config" attribute with a JSON object: {"server": {"port": 8080}}
		 * var port = record.getJsonProperty("config", "server.port");
		 * console.log("Server port:", port); // Outputs: 8080
		 */
		getJsonProperty: function(attr, path) {
			var obj = this._prepareJsonProperty(attr);
			return lang.getObject(path, false, obj);
		},

		_prepareJsonProperty: function(attr) {
			var obj = this[attr];
			if (obj && typeof obj == "string") {
				obj = JSON.parse(obj);
			} else if (!lang.isObject(obj) || obj == null) {
				obj = {};
			}
			this[attr] = obj;
			return obj;
		},
				
		/**
		 * Sets a property in a JSON attribute by path.
		 * 
		 * @param {string} attr - The attribute name containing JSON data
		 * @param {string} path - The path to the property within the JSON object
		 * @param {*} value - The value to set
		 * @returns {Object} The updated JSON object
		 * @memberof Record
		 * @instance
		 * 
		 * @example
		 * // If record has a "config" attribute, set a nested property
		 * record.setJsonProperty("config", "server.port", 9000);
		 * // Now record.config contains: {"server": {"port": 9000}}
		 */
		setJsonProperty: function(attr, path, value) {
			var obj = this._prepareJsonProperty(attr);
			return lang.setObject(path, value, obj);
		},
		
	    /**
		 * Synchronizes this record with the backend and deletes it from offline storage.
		 * 
		 * @param {Object} [opts] - Options for the synchronization
		 * @returns {Promise} A promise that resolves when synchronization is complete
		 * @memberof Record
		 * @instance
		 * 
		 * @example
		 * // Synchronize a record with the backend
		 * record.sync().then(function(syncedRecord) {
		 *     console.log("Record synchronized successfully");
		 * }, function(error) {
		 *     console.error("Sync failed:", error);
		 * });
		 */
		sync: function(opts) {
			return this.save(true, {
				sync: true
			});
		},
		
	    /**
		 * Loads related records by relation path.
		 * 
		 * @param {string|string[]} relations - Comma-separated list or array of relation-paths to load
		 * @param {Object} opts - Options for loading relations
		 * @returns {Promise} A promise that resolves when relations are loaded
		 * @memberof Record
		 * @instance
		 * 
		 * @example
		 * // Load a single relation
		 * record.loadRelations("comments").then(function(record) {
		 *     console.log("Comments loaded:", record.comments);
		 * });
		 * 
		 * // Load multiple relations
		 * record.loadRelations(["comments", "author", "categories"]).then(function(record) {
		 *     console.log("All relations loaded");
		 * });
		 * 
		 * // Load nested relations
		 * record.loadRelations("comments.author").then(function(record) {
		 *     console.log("Comments and their authors loaded");
		 * });
		 */
		loadRelations: function(relations, opts) {
			if (!opts) {
				opts = {};
			}
			var t = this;
			var rels = null;
			if (Array.isArray(relations)) {
				rels = relations;
				relations = relations.join(",");
			} else {
				rels = relations.split(",");
			}
			opts.relations = relations;
			return this.__model.getById(this.id, opts).then(function(rec) {
				rels.forEach(function(rel) {
					var dot = rel.indexOf(".");
					if (dot >= 0) {
						rel = rel.substring(0, dot);
					}
					t[rel] = rec[rel];
					delete t[rel + "_id"];
					return t;
				});
			});
		},
		
	    /**
		 * Saves this record to the data store.
		 * 
		 * @param {boolean} check - If true, checks if the record exists before saving
		 * @param {Object} options - Options for saving
		 * @param {Object} options.headers - HTTP headers to include with the save request
		 * @param {boolean} options.sync - If true, synchronizes the record with the backend
		 * @returns {Promise} A promise that resolves with the saved record
		 * @memberof Record
		 * @instance
		 * 
		 * @example
		 * // Save a record
		 * record.save().then(function(savedRecord) {
		 *     console.log("Record saved successfully with ID:", savedRecord.id);
		 * }, function(error) {
		 *     console.error("Save failed:", error);
		 * });
		 * 
		 * // Save with synchronization
		 * record.save(true, { sync: true }).then(function(savedRecord) {
		 *     console.log("Record saved and synchronized");
		 * });
		 */
		save: function(check, options) {
			options = options || {};
			if (!options.headers) {
				options.headers = {};
			}
			var ret = null;
			var json = this.toJSON({
				includeLabels: true
			});
			if (options.sync) {
				options.headers["X-Sync"] = "Yes";
			}
			var saveStore = this._getSaveStore();
			if (check) {
				if (Identity.hasRealId(json) && check) {
					var old = saveStore.get(json.id);
					if (!old) {
						this.__new = true; 
					}
				}				
				if (this.__new) {
					ret = saveStore.add(json, options);
				} else {
					ret = saveStore.put(json, options);
				}
			} else {
				options.overwrite = true;
				ret = saveStore.put(json, options);
			}

			var def = new Deferred();
			when(ret, lang.hitch(this, function(v) {
				var obj = v;
				if (!lang.isObject(v)) {
					obj = saveStore.get(v);
				}
				def.resolve(obj);
			}), function(err) {
				def.reject(err);
			});
			return def;
		},

		_getSaveStore: function() {
			var store = this.__store;
			if (store) {
				if (store.__query) {
					var qmodel = store.__query.getFrom().getModel();
					if (this.__model.id == qmodel.id) {
						store = qmodel.getStore({exists: true});
					}
				}
			}
			return store;
		},

		/**
		 * Observe remote changes on this record.
		 *
		 * @param {Function} callback - Function to invoke when the record is changed
		 * @returns {Object} A handle with a close() method to stop observing
		 * @memberof Record
		 * @instance
		 * 
		 * @example
		 * // Start observing changes to a record
		 * var observer = record.observe(function(message) {
		 *     console.log("Record changed:", message);
		 *     // Update UI or perform other actions
		 * });
		 * 
		 * // Later, stop observing
		 * observer.close();
		 */
		observe: function(callback) {
			var handle = null;
			var enabled = Identity.isRealId(this.id);
			if (enabled) {
				var topic = "app." + this.__model.getSchema().name + ".out.model." + this.__model.name + "." + this.id;
				handle = Bus.subscribe(topic, function(message) {
					var cid = message.headers['x-origin-client'];
					if (!cid || cid !== client.getClientId()) {
						callback(message);
					}
				});
			} else {
				handle = {
					close: function() {
					}
				};
			}
			return handle;
		},

		/**
		 * Removes a record from the database.
		 * 
		 * @param {Object} [opts] - Configuration options
		 * @param {boolean} [opts.force] - If true, forces deletion even if the record is referenced by others
		 * @param {Function} [opts.onSuccess] - Callback when the operation was successful
		 * @param {Function} [opts.onError] - Callback when the operation resulted in an error
		 * @returns {Promise} A promise that resolves when the record is removed
		 * @memberof Record
		 * @instance
		 * 
		 * @example
		 * // Remove a record with callbacks
		 * record.remove({
		 *     onSuccess: function(result) {
		 *         console.log("Record removed successfully");
		 *     },
		 *     onError: function(error) {
		 *         console.error("Failed to remove record:", error);
		 *     }
		 * });
		 * 
		 * // Remove a record with promise
		 * record.remove().then(function(result) {
		 *     console.log("Record removed successfully");
		 * }, function(error) {
		 *     console.error("Failed to remove record:", error);
		 * });
		 * 
		 * // Force remove a record even if it has references
		 * record.remove({ force: true });
		 *
		 */
		remove: function(opts) {
			opts = opts ? opts : {};
			var def = new Deferred();
			if (opts.force) {
				this.__model.deleteRecord(this, {
					onSuccess: opts.onSuccess,
					onError: opts.onError
				});
			} else if (Identity.hasRealId(this) && this.__store) {
				var ret =  this.__store.remove(this.id);
				when(ret, lang.hitch(this, function(res) {
					if (opts.onSuccess) {
						opts.onSuccess(res);
					}
					def.resolve(res);
				}), function(err) {
					if (opts.onError) {
						opts.onError(err);
					}
					def.reject(err);
				});
			}
			return def;
		},
		
		/**
		 * Evaluates an expression against the record data.
		 * 
		 * @param {string} expr - The expression to evaluate
		 * @param {Object} data - The data context for evaluation
		 * @returns {*} The result of the expression
		 * @private
		 */
		_evalExpr: function(expr, data) {
			
		},

		_setData: function(options) {
			if (options.text) {
				if (options.text.length > MAXSIZE) {
					throw new Error("File is too large for embedding.")
				}
				this[TEXT_PROPERTY] = options.text;
			}
			if (options.base64) {
				if (options.base64.length > MAXSIZE) {
					throw new Error("File is too large for embedding.")
				}
				this[BASE64_PROPERTY] = options.base64;
			}
		},
		
		/**
		 * Gets the document URI for this record.
		 * 
		 * @returns {string} The document URI
		 */
		_getDocumentURI: function() {
			var uri = this.__model.getRecordURI(this.id) + '/file/' + this.filename;
		},
		
	    /**
		 * Returns true if the record is a new record (has no ID yet).
		 * 
		 * @returns {boolean} True if the record is new, false otherwise
		 * @memberof Record
		 * @instance
		 * 
		 * @example
		 * // Check if a record is new
		 * if (record._isNew()) {
		 *     console.log("This is a new record that hasn't been saved yet");
		 * } else {
		 *     console.log("This is an existing record from the database");
		 * }
		 */
		_isNew: function() {
			return Identity.isTempId(this.id);
		},

		/**
		 * Checks whether the user has a certain privilege on this record. 
		 * If privileges are not loaded this method will return undefined.
		 *
		 * @param {string} privilege - The privilege to check for
		 * @returns {boolean|undefined} True if the user has the privilege, false if not, undefined if privileges aren't loaded
		 * @memberof Record
		 * @instance
		 * 
		 * @example
		 * // Check if the current user has the "edit" privilege on this record
		 * var canEdit = record._hasPrivilege("edit");
		 * if (canEdit === true) {
		 *     console.log("User can edit this record");
		 * } else if (canEdit === false) {
		 *     console.log("User cannot edit this record");
		 * } else {
		 *     console.log("Privilege information not loaded");
		 * }
		 */
		_hasPrivilege: function(privilege) {
			var has = undefined;
			if (this.__privileges) {
				has = !!this.__privileges[privilege];
			}
			return has;
		},

		/**
		 * Optimizes a record for serialization by reducing redundant data.
		 * 
		 * @param {Object} org - The original record to compare against
		 * @returns {Object} The optimized record
		 */
		_optimize: function(org) {
			var optimized = undefined;
			var model = this.__model;
			if (org && !org.__model) {
				org = model.createRecord(org);
			}
			var isCreate = Identity.hasTempId(this);
			var ignore = ["updated_at", "ver"];
			if (org && model.id == org.__model.id) {
				optimized = this._clone();
				var rels = model.getRelationships();
				rels.forEach(function(rel) {
					var destName = rel.getName();
					var relModel = rel.getDestination();
					var nrecs = optimized[destName];
					var orecs = org[destName];
					if (orecs == null && nrecs == null) {
						delete optimized[destName];
					} else if (nrecs !== undefined && nrecs !== null) {
						if (orecs !== undefined && orecs !== null) {
							var omap = {};
							if (Array.isArray(orecs)) {
								for (var i = 0; i < orecs.length; i++) {
									var rec = orecs[i];
									if (!rec.__model) {
										rec = relModel.createRecord(rec);
										orecs[i] = rec;
									}
									if (rec) {
										omap[rec.id] = rec;
									}
								}
							} else if (orecs) {
								if (!orecs.__model) {
									orecs = relModel.createRecord(orecs);
								}
								omap[orecs.id] = orecs;
							}

							var opt = [];
							var refs = 0;
							var same = 0;
							if (!Array.isArray(nrecs)) {
								nrecs = [nrecs];
							}
							nrecs.forEach(function(rec) {
								if (rec) {
									var orec = omap[rec.id];
									if (orec) {
										rec = rec._optimize(orec);
										same++;
									}
									if (Identity.isTempId(rec.id)) {
										opt.push(rec);
									} else {
										if (!orec) {
											opt.push(rec);
										} else {
											if (orec._compare(rec, ignore)) {
												var refrec = relModel.createRecord({
													id: rec.id
												})
												opt.push(refrec);
												refs++;
											} else {
												opt.push(rec);
											}
										}
									}
								}
							});

							if (nrecs.length == refs && orecs.length == refs && same == orecs.length && !isCreate) {
								delete optimized[destName];
								var attr = model.getAttributeForRelation(rel);
								if (attr && nrecs.length == 1) {
									optimized[attr.name] = nrecs[0].id;
								}
							} else {
								optimized[destName] = opt;
							}
						}
					}
				});
			} else {
				optimized = this;
			}
			return optimized;
		},
		
	    /**
		 * Clones the record.
		 * 
		 * @param {boolean} [reset=false] - If true, removes the ID from the clone
		 * @param {boolean} [deep=false] - If true, performs a deep clone including related records
		 * @returns {Record} A clone of the record
		 * @memberof Record
		 * @instance
		 * 
		 * @example
		 * // Create a simple clone that preserves the ID
		 * var clone = record._clone();
		 * 
		 * // Create a clone as a new record (removes ID)
		 * var newRecord = record._clone(true);
		 * 
		 * // Create a deep clone as a new record
		 * var deepNewRecord = record._clone(true, true);
		 */
		_clone: function(reset, deep) {
			var json = this.toJSON({
				loose: true
			});
			var clone = this.__model ? this.__model.createRecord(json, this.__store) : json;
			if (reset) {
				clone._reset(deep, true);
			} else if (this.__privileges) {
				clone.__privileges = this.__privileges;
			}
			return clone;
		},
		
	    /**
		 * Creates a reference to this record (a record with only the ID).
		 * 
		 * @returns {Record} A reference to this record
		 * @memberof Record
		 * @instance
		 * 
		 * @example
		 * // Create a reference to a record
		 * var reference = record._toReference();
		 * // reference contains only the ID of the original record
		 */
		_toReference: function() {
			return this.__model.createRecord({
				id: this.id
			});
		},
		
	    /**
		 * Merges this record with another record.
		 * The other record's values are copied to this record if this record's values are undefined or null.
		 *
		 * @param {Record|Object} record - The record to merge with
		 * @param {boolean} [noResolve=false] - If true, doesn't resolve relations after merging
		 * @returns {Record} This record, after merging
		 * @memberof Record
		 * @instance
		 * 
		 * @example
		 * // Merge two records
		 * var mergedRecord = record1._merge(record2);
		 */
		_merge: function(record, noResolve) {
			if (this.__model) {
				var attrs = this.__model.getAttributes();
				for (var i = 0; i < attrs.length; i++) {
					var attr = attrs[i].getName();
					var oval = this[attr];
					var nval = record[attr];
					var val = oval;
					if ((oval == undefined || oval == null) && (nval != undefined && nval != null)) {
						val = nval;
					}
					this[attr] = val;
				}
				var rels = this.__model.getRelationships();
				for (var i = 0; i < rels.length; i++) {
					var rel = rels[i].getName();
					var orecs = this[rel];
					var nrecs = record[rel];
					var recs = orecs;
					if ((orecs == undefined || orecs == null) && (nrecs != undefined && nrecs != null)) {
						recs = nrecs;
					} else if (orecs && nrecs) {
						
					}
					this[rel] = recs;
				}
				if (!noResolve) {
					this._createRelations();					
				}
			}
			return this;
		},

		_createRelations: function() {
			if (this.__model) {
				var rels = this.__model.getRelationships();
				for (var i = 0; i < rels.length; i++) {
					var rel = rels[i];
					var relName = rel.getName();
					var records = this[relName];
					var rmodel = rel.getDestination();
					if (lang.isArray(records) && records.length > 0) {
						for (var j = 0; j < records.length; j++) {
							var rec = records[j];
							if (!rec.__model) {
								var r = serMap[rec.id];
								if (!r) {
									r = new Record({
										data: rec,
										model: rmodel
									}, true);				
								} else {
									r._merge(rec, true);
								}
								records[j] = r		
							} else {
								// REMIND check serMap ?
							    records[j] = rec;
							}
						}
					} else if (records) {
					    if (!lang.isArray(records) && lang.isObject(records)) {
					        if (records.__model) {
					            this[relName] = records;
					        } else {
					        	var r = serMap[records.id];
					        	if (!r) {
					        		r = new Record({
    			    				data: records,
    				    			model: rmodel
    					    	}, true);
					        	} else {
					        		var r2 = new Record({
    			    				data: records,
    				    			model: rmodel
    					    	}, true);
					        		r._merge(r2, true);
					        	}
		        				this[relName] = r; 
					    }
					    } else if (lang.isArray(records)) {
					    	var resolved = [];
					    	for (var x = 0; x < records.length; x++) {
					    		var rec = records[x];
					    		var r = serMap[rec.id];
					    		if (r) {
					    			rec = r;
					    		}
					    		resolved.push(rec);
					    	}
					        this[relName] = resolved;
					    }
					}
				}
			}	
		},

		_reset: function(deep, generate) {
			if (deep === undefined) {
				deep = true;
			}
			if (generate) {
				this.id = Identity.generateItemId();
			} else {
				delete this.id;
			}
			delete this.ver;
			if (this.__model && deep) {
				var rels = this.__model.getRelationships();
				for (var i = 0; i < rels.length; i++) {
					var rel = rels[i];
					var relName = rel.getName();
					var records = this[relName];
					var rmodel = rel.getDestination();
					var relAttr = rmodel.getAttributeForRelation(rel.getRemoteName());
					var clearRel = function(rec) {
						if (relAttr) {
							delete rec[relAttr.getName()];
						}
					};
					if (lang.isArray(records) && records.length > 0) {
						for (var j = 0; j < records.length; j++) {
							var rec = records[j];
							clearRel(rec);
							if (!rec.__model) {
								if (generate) {
									rec.id = Identity.generateItemId();
								} else {
									delete rec.id;
								}
								delete rec.ver;
							} else {
								rec._reset(deep);
							}
						}
					} else if (records) {
					    if (!lang.isArray(records) && lang.isObject(records)) {
							clearRel(records);
					        if (records.__model) {
					        	records._reset(deep, generate);
					        } else {
								if (generate) {
									records.id = Identity.generateItemId();
								} else {
									delete records.id;
								}
					        	delete records.ver;
    					    }
					    } else if (lang.isArray(records)) {
					    	for (var j = 0; j < records.length; j++) {
					    		var rec = records[j];
								clearRel(rec);
					    		if (rec.__model) {
					    			rec._reset(deep, generate);
					    		} else {
									if (generate) {
										rec.id = Identity.generateItemId();
									} else {
										delete rec.id;
									}
					    			delete rec.ver;
					    		}
					    	}
					    }
					}
				}
			}	
		},

	    /**
	 	* Returns the value of the specified attribute.
	 	* 
	 	* @param {string} name - The name of the attribute
	 	* @returns {*} The attribute's value
	 	* @memberof Record
	 	* @instance
	 	* 
	 	* @example
	 	* // Get the value of the "title" attribute
	 	* var title = record._getAttributeValue("title");
	 	* console.log("Title:", title);
        */
		_getAttributeValue: function(name) {
		    return this.name;
		},

		/**
		 * Sets the record's metadata.
		 *
		 * @param {Object} metadata - Metadata properties to set
		 * @memberof Record
		 * @instance
		 * 
		 * @example
		 * // Set metadata on a record
		 * record._setMetadata({
		 *     author: "John Doe",
		 *     lastModified: new Date(),
		 *     source: "Import"
		 * });
		 */
		_setMetadata: function(metadata) {
			this[META_PROPERTY] = metadata;
		},

		/**
		 * Returns the record's metadata, if available.
		 * 
		 * @returns {Object} The record's metadata
		 * @memberof Record
		 * @instance
		 * 
		 * @example
		 * // Get a record's metadata
		 * var metadata = record._getMetadata();
		 * if (metadata) {
		 *     console.log("Author:", metadata.author);
		 *     console.log("Last modified:", metadata.lastModified);
		 * }
		 */
		_getMetadata: function() {
			return this[META_PROPERTY];
		},
		
		/**
		 * Performs aggregate calculations on related records.
		 * 
		 * @param {Object} opts - Options for aggregation
		 * @param {string} [opts.rel] - The relationship name to aggregate
		 * @param {Array} [opts.records] - Array of records to aggregate (alternative to opts.rel)
		 * @param {string|Array} opts.expr - Expression(s) to evaluate for aggregation
		 * @param {string} [opts.func="sum"] - Aggregation function: "sum", "avg", "count", "min", "max", or "copy"
		 * @param {string} [opts.pivot] - Field to pivot by
		 * @param {Object} [opts.env] - Additional environment variables for expressions
		 * @returns {*} The aggregation result
		 * 
		 * @example
		 * // Sum the "amount" property of all related "transactions"
		 * var total = record.aggregate({
		 *     rel: "transactions",
		 *     expr: "amount",
		 *     func: "sum"
		 * });
		 * console.log("Total amount:", total);
		 * 
		 * // Calculate average, minimum, and maximum of "price" for all related "products"
		 * var stats = record.aggregate({
		 *     rel: "products",
		 *     expr: [
		 *         { name: "avg", expr: "price", func: "avg" },
		 *         { name: "min", expr: "price", func: "min" },
		 *         { name: "max", expr: "price", func: "max" }
		 *     ]
		 * });
		 * console.log("Price stats:", stats);
		 * 
		 * // Count products by category
		 * var countByCategory = record.aggregate({
		 *     rel: "products",
		 *     expr: { name: "count", expr: "1", func: "count" },
		 *     pivot: "category"
		 * });
		 * console.log("Products by category:", countByCategory);
		 */
		aggregate: function(opts) {
			var result = null;
			var multi = false;
			if ((opts.rel || opts.records) && opts.expr) {
				var expr = new Array();
				var exprIndex = {};
				var parser = new ExpressionParser();
				if (lang.isArray(opts.expr)) {
					multi = true;
					for (var i = 0; i < opts.expr.length; i++) {
						var exprObj = opts.expr[i];
						expr[i] = {
							name: exprObj.name,
							expr: parser.parse(exprObj.expr),
							func: exprObj.func
						};
						exprIndex[exprObj.name] = expr[i];
					}
				} else {
					expr[0] = {
						name: 'result',
						expr: parser.parse(opts.expr),
						func: opts.func
					};
					exprIndex['result'] = expr[0];
				}

				var func = 'sum';
				if (opts.func) {
					func = opts.func;
				}
				var map = {};
				var pivot = null;
				if (opts.pivot) {
					pivot = opts.pivot;
					map = {};
				}
				var records = opts.records ? opts.records : this[opts.rel];
				if (records && records.length > 0) {
					var len = records.length;
					for (var i = 0; i < records.length; i++) {
						var record = records[i];
						var context = {};
						for (var j = 0; j < expr.length; j++) {
							var cexpr = expr[j];
							var data = null;
							if (record.toJSON) {
								data = record.toJSON({
									loose: true
								});
							} else {
								data = lang.clone(record);
							}
							if (opts.env) {
								lang.mixin(data, opts.env);
							}
							lang.mixin(data, context);
							var cres = cexpr.expr.evaluate(data);
							if (typeof cres == "boolean") {
								if (cres) {
									cres = 1;
								} else {
									cres = 0;
								}
							}
							context[cexpr.name] = cres;
						}
						var pivotRecord = null;
						var pval = "result";
						if (pivot) {
							pval = record[pivot];
						}
						var pres = map[pval];
						if (!pres) {
							var pres = {};
							for (var key in context) {
								pres[key] = {
									result: 0,
									copy: null,
									count: 0,
									min: null,
									max: null									
								};
							}
							map[pval] = pres;
						}
						for (var key in context) {
							var spart = pres[key];
							var sres = context[key];
							spart.copy = sres;
							if (typeof sres == "number") {
								spart.result += sres;
								spart.count += 1;
								if (!spart.min || spart.min > sres) {
									spart.min = sres;
								}
								if (!spart.max || spart.max < sres) {
									spart.max = sres;
								}							
							} else if (typeof sres == "string") {
								spart.result = sres;
								spart.count += 1;
							}
						}
					}

					for (var key in map) {
						var pres = map[key];
						for (var pkey in pres) {
							var e = exprIndex[pkey];
							var tres = pres[pkey];
							var fres = null;
							switch (e.func) {
							case 'sum':
								fres = tres.result;
								break;
							case 'avg':
								fres = tres.result / tres.count;
								break;
							case 'count':
								fres = tres.count;
								break;
							case 'min':
								fres = tres.min;
								break;
							case 'max':
								fres = tres.max;
								break;
							case 'copy':
								fres = tres.copy;
								break;
							}				
							pres[pkey] = fres;
						}
					}
						
					if (pivot) {
						var result = {};
						for (var key in map) {
							if (multi) {
								result[key] = map[key];
							} else {
								result[key] = map[key].result;
							}
						}
					} else {
						if (multi) {
							result = map.result;
						} else {
							result = map.result.result;							
						}
					}
				}				
			}
			return result;
		},

		_attributeCount: function(data) {
			if (!data) {
				data = this;
			}
			var cnt = 0;
			for (var attr in this.__model.getAttributes()) {
				if (data[attr.name] !== undefined) {
					cnt++;
				}
			}
			for (var rel in this.__model.getRelationships()) {
				if (data[rel.name] !== undefined) {
					cnt++;
				}
			}
			return cnt;
		},
		
		/**
		 * Gets the Base64-encoded data for a document record.
		 * 
		 * @returns {string|null} The Base64-encoded data, or null if not a document or no data
		 * @memberof Record
		 * @instance
		 * 
		 * @example
		 * // Get Base64 data for a document record
		 * var base64Data = documentRecord._getBase64();
		 * if (base64Data) {
		 *     // Use the Base64 data, e.g., to display an image
		 *     var imgElement = document.createElement("img");
		 *     imgElement.src = "data:image/jpeg;base64," + base64Data;
		 * }
		 */
		_getBase64: function() {
			var b64 = null;
			if (this.__model.isDocument) {
				if (this[BASE64_PROPERTY]) {
					b64 = this[BASE64_PROPERTY];
				}
			}
			return b64;
		},
		
		/**
		 * Gets a date value from an attribute, converting from string if necessary.
		 * 
		 * @param {string} name - The name of the date attribute
		 * @returns {Date|string} The date value
		 */
		_getDate: function(name) {
			var val = this[name];
			if (val && typeof(val) == "string") {
				val = AMDate.fromStrToDate(val);
			}
			return val;
		},

		/**
		 * Creates a diff between this record and another record.
		 * 
		 * @param {Record} rec - The record to compare with
		 * @returns {RecordDiff} A RecordDiff object containing the differences
		 */
		_diff: function(rec) {
			var diff = new RecordDiff();
			var model = this.__model;
			var attrs = model.getAttributes();
			for (var i = 0; i < attrs.length; i++) {
				var attr = attrs[i];
				var v1 = this[attr.name];
				var v2 = rec[attr.name];
				if (v1 != v2) {
					diff.add(attr.name, v1,  v2);
				}
			}
			return diff;
		},

		/**
		 * Compares this record with another record.
		 * 
		 * @param {Record|Object} rec - The record to compare with
		 * @param {Array} [ignore] - Array of attribute names to ignore in the comparison
		 * @returns {boolean} True if the records are equal, false otherwise
		 */
		_compare: function(rec, ignore) {
			var o1 = this.toJSON();
			var o2 = undefined;
			if (rec && rec.toJSON) {
				o2 = rec.toJSON();
			} else if (rec) {
				o2 = JSON.parse(JSON.stringify(rec));
			}
			return Equals(o1, o2, ignore);
		},

	   /**
		* Creates a JSON representation of the record.
		* 
		* @param {Object} [opts] - Options for JSON conversion
		* @param {boolean} [opts.loose=false] - If true, includes all properties; if false, only includes model attributes and relationships
		* @param {boolean} [opts.resolve=true] - If true, resolves circular references
		* @param {boolean} [opts.includeLabels=false] - If true, includes label fields for foreign keys
		* @returns {Object} The record as a JSON object
		* @memberof Record
		* @instance
		* 
		* @example
		* // Get basic JSON representation
		* var json = record.toJSON();
		* 
		* // Get JSON with all properties
		* var looseJson = record.toJSON({ loose: true });
		* 
		* // Get JSON with labels for foreign keys
		* var jsonWithLabels = record.toJSON({ includeLabels: true });
		*/
		toJSON: function(opts) {
			var resolve = true;
			if (opts && opts.resolve === false) {
				resolve = false;
			}
			var clearMap = false;
			if (!serMap) {
				clearMap = true;
				serMap = {};
			}
			try {
				if (!this.id) {
					Identity.prepareItemId(this);
				}
				if (resolve && serMap[this.id]) {
					return {
						id: this.id
					};
				}
				serMap[this.id] = this;
				var json = {};
				if (opts && opts.loose) {
					for (var name in this) {
						if (!name.startsWith("__")) {
							var obj = this[name];
							if (!lang.isFunction(obj)) {
								if (lang.isArray(obj)) {
									var list = new Array();
									for (var i = 0; i < obj.length; i++) {
										var rec = obj[i];
										if (rec.toJSON) {
											rec = rec.toJSON({
												loose: true,
												resolve: resolve
											});
										}
										list.push(rec);
									}
									json[name] = list;
								} else if (obj === null || obj === undefined) {
									json[name] = obj;
								} else if (lang.isString(obj)) {
									json[name] = obj;
								} else if (typeof obj === "number") {
									json[name] = obj;
								} else if (typeof obj === "boolean") {
									json[name] = obj;
								} else if (lang.isObject(obj)) {
									if (obj.toJSON) {
										obj = obj.toJSON({
											loose: true,
											resolve: resolve
										});
									} else {
										obj = JSON.parse(JSON.stringify(obj));
									}
									json[name] = obj;
								} else {
									json[name] = JSON.parse(JSON.stringify(obj));
								}
							}
						}
					}
				} else {
					for (var name in this.__model.attrIndex) {
						var attr = this.__model.attrIndex[name];
						if (this['$' + name] !== undefined) {
							json['$' + name] = this['$' + name];
						} else if (this[name] !== undefined) {
							var value = this[name];
							if (lang.isObject(value) && value != null) { 
								switch (attr.type) { 
								case 'STRING': 
									value = JSON.stringify(value);
									break;
								}
							}
							json[name] = value;							
						}
						if (opts && opts.includeLabels) {
							var idx = name.lastIndexOf('_id');
							if (idx > 0) {
								var lbl = name.substring(0, idx) + '_label';
								if (this[lbl]) {
									json[lbl] = this[lbl];
								}
							}
						}
					}
					for (var name in this.__model._relationEndIndex) {
						if (this[name] != undefined) {
							var val = this[name];
							if (lang.isArray(val)) {
								var list = [];
								for (var i = 0; i < val.length; i++) {
									var vl = val[i];
									if (resolve && serMap[vl.id]) {
										list.push({
											id: vl.id
										});
									} else if (vl.toJSON) {
										list.push(vl.toJSON(opts));
									} else {
										list.push(JSON.parse(JSON.stringify(vl)));
									}
								}
								json[name] = list;
							} else {
								if (resolve && serMap[val.id]) {
									val = {
										id: val.id
									};
								}
								if (val.toJSON) {
									val = val.toJSON(opts);
								}
								json[name] = val;													
							}
						}
					}
					if (json.id == null) {
						delete json.id;
					}				
				}
				if (this.__model.isDocument) {
					if (this[TEXT_PROPERTY]) {
						json[TEXT_PROPERTY] = this[TEXT_PROPERTY];
					}
					var b64 = this[BASE64_PROPERTY];
					if (b64 && b64.length < (16 * 1024)) {
						json[BASE64_PROPERTY] = b64;
					}
				}
				if (this[META_PROPERTY]) {
					json[META_PROPERTY] = this[META_PROPERTY];
				}
			} finally {
				if (clearMap) {
					serMap = null;
				}				
			}
			return json;
		},

        _mapIds: function(json, map){
           for (var name in json) {
               if (name.indexOf("_") == 0) {
                    continue;
               }
               var val = json[name];
               if (val) {
                   if(lang.isFunction(val)){
                       continue;
                   }
                   if (lang.isArray(val)){
                       for (var i = 0; i < val.length; i++) {
                           var obj = val[i];
                           if(lang.isObject(obj) && obj.id){
                                if (Object.keys(obj).length > 1){
                                    map[obj.id] = obj;
                                }
                                this._mapIds(obj, map);
                           }
                       }
                   } else if (lang.isObject(val)){
                       if(val.id && Object.keys(val).length > 1){
                           if (!map[val.id]) {
                                map[val.id] = val;
                           }
                       }
                   }
               }
           }
           return map;
        },
        
        /**
         * Resolves references in a JSON object.
         * 
         * @param {Object} json - JSON object to resolve references in
         * @param {Object} map - Map of IDs to objects
         * @private
         */
        _resolveLevel: function(json, map){
            for (var prop in json) {
                if (prop.indexOf('_') == 0) {
                    continue;
                }
                var val = json[prop];
                if (val) {
                    if (lang.isFunction(val)) {
                        continue;
                    }
                    if (lang.isArray(val)){
                        for (var i = 0; i < val.length; i++){
                            var obj = val[i];
                            if (lang.isObject(obj)) {
                                if (Object.keys(obj).length == 1 && obj.id) {
                                    if (map[obj.id]) {
                                        val[i] = map[obj.id];
                                    }
                                } else {
                                    this._resolveLevel(obj, map);
                                }
                            }
                        }
                    } else if (lang.isObject(val)){
                        if (Object.keys(val).length == 1 && val.id) {
                            if (map[val.id]) {
                                json[prop] = map[val.id];
                            }
                        }
                    }
                }
            }
        },

        _resolve: function(idMap){
            if (!idMap) {
                var idMap = this._mapIds(this, {});
            }
            this._resolveLevel(this, idMap);
        }
	});
	
	return Record;
});
},
'appivo/model/RecordDiff':function(){
define([], function() {
   function Diff(options) {
       this._attrs = [];
       this._count = 0;
   };

   Diff.prototype = {
       add: function(attr, v1, v2) {
           this._attrs[attr] = {
               oldValue: v1,
               newValue: v2
           };
           this._count++;
       },
       getAttributes: function() {
           return Object.keys(this._attrs);
       },
       getValueDiff: function(attr) {
           var ad = this._attrs[attr];
           return ad;
       },
       size: function() {
           return this._count;
       },
       isEmpty: function() {
           return this._size === 0;
       },
       diff: function(diff) {
           var t = this;
           var k1 = Object.keys(this._attrs);
           var k2 = Object.keys(diff._attrs);
           var ndiff = new Diff();
           k1.forEach(function(attr) {
               var ad1 = t.getValueDiff(attr);
               if (k2.indexOf(attr) === -1) {
                   ndiff.add(attr, ad1.newValue, undefined);
               } else {
                   var ad2 = diff.getValueDiff(attr);
                   if (ad1.newValue != ad2.newValue) {
                       ndiff.add(attr, ad1.newValue, ad2.newValue);
                    }
               }
           });
           k2.forEach(function(attr) {
               var ad2 = diff.getValueDiff(attr);
               if (k1.indexOf(attr) === -1) {
                   ndiff.add(attr, undefined, ad2.newValue);
               }
           });
           return ndiff;
       }
   };

   return Diff;
});
},
'appivo/util/Point':function(){
define([],

  function() {

	function Point() {
		if (arguments.length == 2) {
			this.lat = arguments[0];
			this.lng = arguments[1];
		} else if (arguments.length == 1) {
			this.lat = arguments[0].lat;
			this.lng = arguments[0].lng;
		}
	};
	
	Point.prototype = {
		lat: 0.0,
		lng: 0.0,
		
		constructor: Point,
		
		getLatitude: function() {
			return this.lat;
		},
		
		getLongitude: function() {
			return this.lng;
		},
		
		toJSON: function() {
			return {
				lat: this.lat,
				lng: this.lng
			};
		}
	};
			
	return Point;
});
},
'appivo/client/Bus':function(){
/**
 * @interface MessageBus
 */
define(['dojo/Deferred', 'appivo/bus/MessageBus'], function(Deferred, MessageBus) {
	
	var bus = new MessageBus();
		
	var publishers = {};
	var queues = {};
	
	return {
	
		_open: function() {
			bus.open();
		},
		
		_getPublisher: function(exchange) {
			var publisher = publishers[exchange];
			if (!publisher) {
				publisher = bus.createPublisher({
					exchange: exchange
				});
				publishers[exchange] = publisher;
			}
			return publisher;
		},
		
		_getQueue: function(exchange, queueName) {
			var def = null;
			var queue = null;
			if (queueName) {
				var key = exchange + ':' + queueName;
				queue = queues[key];
			}
			if (!queue) {
				def = bus.getQueue({
					exchange: exchange,
					queue: queue
				});
				def.then(function(queue) {
					if (key) {
						queues[key] = queue;
					}
				});
			} else {
				def = new Deferred();
				def.resolve(queue);
			}
			return def;
		},
		
		/**
		 * Publish a message
		 * @memberof MessageBus
		 * @instance
		 * @param {String} topic - The topic to which you want to publish your message
		 * @param {Object} message - The message to publish
		 * @param {Object} options
		 * @param {Object} options.headers - Message-headers 
		 */
		publish: function(topic, message, opts) {
			opts = opts ? opts : {};
			if (!opts.exchange) {
				opts.exchange = 'public-topics';
			}
			var publisher = this._getPublisher(opts.exchange);
			
			publisher.publish(topic, message, opts.headers);
		},
		
		/**
		 * Subscribe to a messaging-topic
		 * 
		 * @memberof MessageBus
		 * @instance
		 * @param {String} topic - The topic to which you want to subscribe
		 * @param {Function} callback - function to be called when a message arrives
		 * @param {Object} options 
		 * @returns {Consumer}
		 */
		subscribe: function(topic, callback, opts) {
			var t = this;
			var def = new Deferred();
			opts = opts ? opts : {};
			if (!opts.exchange) {
				opts.exchange = 'public-topics';
			}
			this._getQueue(opts.exchange, opts.queue).then(function(queue) {
				queue.bind(topic).then(function() {
					var consumer = queue.createConsumer(callback, opts.filter);
					def.resolve(consumer);
				}, function(error) {
					def.reject(error);
				});
			}, function(error) {
				def.reject(error);
			});

			return {
				ready: function() {
					return def;
				},
				close: function() {
					def.then(function(consumer) {
						consumer.close();
					});
				}
			};
		},
		
		_close: function() {
			bus.close();
		}
	};
});
},
'appivo/bus/MessageBus':function(){
define(['dojo/Deferred', 
        'robust-websocket/robust-websocket',
        'appivo/client/Client', 
        './Session', 
        './Queue', 
        './Publisher'],

  /**
   * Packet-format: 'v1':<type>:<subtype>:<session>:<seq>:<response-to>
   */		
		
  function(Deferred, RobustWebSocket, Client, Session, Queue, Publisher) {
	
	var STATE_DISCONNECTED = 'DISCONNECTED';
	var STATE_CONNECTING = 'CONNECTING';
	var STATE_CONNECTED = 'CONNECTED';
	var STATE_FAILURE = 'FAILURE';
	
	var TYPE_INTERNAL = 0;
	var TYPE_STANDARD = 1;
	
	var CTRL_CUSTOM = 0;
	var CTRL_PING = 1;
	var CTRL_PONG = 2;
	var CTRL_STARTSESSION = 3;
	var CTRL_ENDSESSION = 4;
	var CTRL_AUTH = 5;
	
	var CMD_GETQUEUE = 0;
		
	var nextSessionId = 0;
	
	var client = Client.getInstance();
	var ticket = null;
	function getTicket() {
	  var promise = new Promise(function(resolve, reject) {
		  console.log("Requesting bus-ticket");
		  client.sendRequest("/api/bus-ticket").then(function(data) {
			  console.log("Bus-ticket received");
			  ticket = data.ticket;
			  resolve(data.ticket);
		  }, function(error) {
			  reject(error);
		  });
	  });
	  return promise;
	};


	  function createMeta(options) {
		var meta = 'v1:';
		meta = meta + options.type + ':';
		meta = meta + options.subtype + ':';
		meta = meta + ((typeof(options.session) === "number") ? options.session : "") + ':';
		meta = meta + options.seq + ':';
		meta = meta + options.response;
		return meta;
	};
	
	function parsePacket(msg) {
		var packet = null;
		try {
			var data = JSON.parse(msg.data);
			var meta = data.meta.split(':');
			delete data.meta;
			packet = {
				type: parseInt(meta[1]),
				subtype: parseInt(meta[2]),
				session: parseInt(meta[3]),
				seq: parseInt(meta[4]),
				response: parseInt(meta[5]),
				content: data
			};				
		} catch (error) {
			console.error("Received bad packet");
			console.error(error);
		}
		return packet;		
	}
	
	function MessageBus(options) {
	};
	
	MessageBus.prototype = {
		constructor: MessageBus,
		
		publishers: [],
		queues: [],
		state: STATE_DISCONNECTED,

		open: function() {
			if (!this.socket) {
				this._connect();				
			}
		},
						
		_connect: function() {
			var t = this;
			this.def = new Deferred();
			this._setState(STATE_CONNECTING);
			this.sessions = {};
			this.url = client.getURI('/api/bus', 'ws');
			this._log("Connecting to " + this.url);

			var shouldReconnect = function(event, ws) {
				t._setState(STATE_FAILURE);
				/*
				if (event.type === 'online') {
					return 0;
				} else if ([1006,1011,1012].indexOf(event.code)) {
					return 1000;
				}
				*/
				console.log("reconnect");
				var promise = getTicket().then(function(ticket) {
					t.ticket = ticket;
					return 1000;
				})
				return promise;
			};
			shouldReconnect.handle1000 = true;
			
			this.socket = new RobustWebSocket(this.url, undefined, {
				timeout: 15000,
				shouldReconnect: shouldReconnect
			});

			this.socket.addEventListener('open', function(event) {
				t._onOpen(event);
			});
			this.socket.addEventListener('message', function(event) {
				t._receive(event);
			});
			this.socket.addEventListener('error', function(event) {
				t._onError(event);
			});
			this.socket.addEventListener('timeout', function(event) {
				t._onTimeout(event);
			});
		},

		_onOpen: function(event) {
			var t = this;
			this._setState(STATE_CONNECTED);
			console.log("MessageBus: open ", event);
			getTicket().then(function(ticket) {
				var packet = t._createPacket({
					internal: true,
					type: CTRL_AUTH
				});
				packet.ticket = ticket;
				t.session = t._newSession();
				t._send(packet);
				t.def.resolve(t.session);
				t._reconnect();
			});
		},
		
		_onError:function(event) {
			console.log("MessageBus: error ", event);
		},

		_onTimeout:function(event) {
			console.log("MessageBus: timeout ", event);
		},
		
		_getSession: function() {
			return this.session;
		},
		
		_log: function(msg) {
			console.log("MessageBus: " + msg);
		},
		
		_setState: function(state) {
			if (this.state != state) {
				this._log("State changed from " + this.state + " to " + state);
				this.state = state;
			}
			if (state == STATE_FAILURE) {
				this.def = new Deferred();
			}
		},
				
		ready: function() {
			return this.def;
		},
		
		getQueue: function(options) {
			var t = this;
			var def = new Deferred();
			if (!this.socket) {
				this.open();				
			}
			
			this.def.then(function() {
				t._connectQueue(options).then(function(data) {
					queue = new Queue({
						name: options.name,
						bus: t,
						exchange: data.exchange,
						queue: data.queue
					});	
					t._addQueue(queue);	
					def.resolve(queue);
				}, function(error) {
					def.reject(error);
				});
			}, function(error) {
				def.reject(error);
			});
			return def;
		},
		
		_connectQueue: function(options) {
			var t = this;
			var def = new Deferred();
			var meta = createMeta(options);
			var packet = t.session._createPacket(CMD_GETQUEUE);
			packet.exchange = options.exchange;
			packet.queue = options.queue;
			packet.bindings = options.bindings;
			t.session._sendAndWait(packet, 10000, function(success, packet) {
				if (success && packet.content.ok) {
					def.resolve({
						name: options.queue,
						exchange: options.exchange,
						queue: packet.content.queue
					});
				} else {
					def.reject('Failed to get queue');
				}
			});				
			return def;
		},
		
		createPublisher: function(options) {
			this.open();
			var publisher = new Publisher({
				bus: this,
				exchange: options.exchange
			});
			publisher._reconnect();
			this._addPublisher(publisher);
			return publisher;
		},
		
		_reconnect: function() {
			for (var i = 0; i < this.publishers.length; i++) {
				var publisher = this.publishers[i];
				publisher._reconnect();
			}
			
			for (var i = 0; i < this.queues.length; i++) {
				var queue = this.queues[i];
				this._connectQueue({
					name: queue.name,
					exchange: queue.exchange
				}).then(function(data) {
					queue._reconnect(data);					
				});
			}
		},
		
		_addPublisher: function(publisher) {
			this.publishers.push(publisher);
		},
		
		_removePublisher: function(publisher) {
			var index = this.publishers.indexOf(publisher);
			if (index >= 0) {
				this.publishers.splice(index, 1);
			}
		},
		
		_addQueue: function(queue) {
			this.queues.push(queue);
		},
		
		_removeQueue: function(queue) {
			var index = this.queues.indexOf(queue);
			if (index >= 0) {
				this.queues.splice(index, 1);
			}
		},
		
		_createPacket: function(options) {
			if (!options.response) {
				options.response = -1;
			}
			if (!options.seq) {
				options.seq = 0;
			}
			var ptype = options.internal ? TYPE_INTERNAL : TYPE_STANDARD;
			var metaOpts = {
				type: ptype,
				subtype: options.type,
				session: options.session,
				seq: options.seq,
				response: options.response					
			};
			var packet = {
				meta: createMeta(metaOpts),
				_meta: metaOpts
			};
			return packet;
		},
				
		_receive: function(event) {
			var packet = parsePacket(event);
			if (packet) {
				switch (packet.type) {
				case TYPE_INTERNAL:
					this._handleInternal(packet);
					break;
				case TYPE_STANDARD:
					var session = this.sessions[packet.session];
					if (session) {
						session._handlePacket(packet);
					}
					break;
				}	
			}
		},
		
		_newSession: function(id) {
			var start = false;
			if (!id) {
				start = true;
				id = ++nextSessionId;
			}
			var session = new Session({
				bus: this,
				id: id
			});
			
			if (start) {
				var packet = this._createPacket({
					internal: true,
					type: CTRL_STARTSESSION,
					session: session.id
				});
				this._send(packet);
			}

			this.sessions[id] = session;
			
			return session;
		},
		
		_handleInternal: function(packet) {
			switch (packet.subtype) {
			case CTRL_CUSTOM:
				break;
			case CTRL_PING:
				var session = this.sessions[packet.session];
				if (session) {
					var packet = session._createPacket(CTRL_PONG, true);
					session._send(packet);
				}
				break;
			case CTRL_PONG:
				break;
			case CTRL_STARTSESSION:
				var session = this._newSession(packet.session);
				this.sessions[packet.session] = session;
				this.nextSessionId = packet.session;
				break;
			case CTRL_ENDSESSION:
				var session = this.sessions[packet.session];
				if (session) {
					delete this.sessions[packet.session];
					session._onClose();
				}
				break;
			}
		},
		
		_send: function(packet) {
			var t = this;
			delete packet._meta;
			var msg = JSON.stringify(packet);
			this.def.then(function() {
				t.socket.send(msg);				
			});
		},
		
		_release: function() {
			if (this.queues.length == 0 && this.publishers.length == 0) {
				this.close();
			}
		},
		
		close: function() {
			this.publishers.forEach(function(p) {
				p.close();
			});
			this.queues.forEach(function(q) {
				q.close();
			});
			this.socket.close();
			delete this.socket;
			this._setState(STATE_DISCONNECTED);
		}		
	};
			
	return MessageBus;
});
},
'robust-websocket/robust-websocket':function(){
(function(factory, global) {
  if (typeof define === 'function' && define.amd) {
    define(function() {
      return factory(global, navigator)
    })
  } else if (typeof exports === 'object' && typeof module === 'object') {
    module.exports = factory(global, navigator)
  } else {
    // mock the navigator object when under test since `navigator.onLine` is read only
    global.RobustWebSocket = factory(global, typeof Mocha !== 'undefined' ? Mocha : navigator)
  }
})(function(global, navigator) {

  var RobustWebSocket = function(url, protocols, userOptions) {
    var realWs = { close: function() {} },
        connectTimeout,
        self = this,
        attempts = 0,
        reconnects = -1,
        reconnectWhenOnlineAgain = false,
        explicitlyClosed = false,
        pendingReconnect,
        opts = Object.assign({},
          RobustWebSocket.defaultOptions,
          typeof userOptions === 'function' ? { shouldReconnect: userOptions } : userOptions
        )

    if (typeof opts.timeout !== 'number') {
      throw new Error('timeout must be the number of milliseconds to timeout a connection attempt')
    }

    if (typeof opts.shouldReconnect !== 'function') {
      throw new Error('shouldReconnect must be a function that returns the number of milliseconds to wait for a reconnect attempt, or null or undefined to not reconnect.')
    }

    ['bufferedAmount', 'url', 'readyState', 'protocol', 'extensions'].forEach(function(readOnlyProp) {
      Object.defineProperty(self, readOnlyProp, {
        get: function() { return realWs[readOnlyProp] }
      })
    })

    function clearPendingReconnectIfNeeded() {
      if (pendingReconnect) {
        pendingReconnect = null
        clearTimeout(pendingReconnect)
      }
    }

    var ononline = function(event) {
      if (reconnectWhenOnlineAgain) {
        clearPendingReconnectIfNeeded()
        reconnect(event)
      }
    },
    onoffline = function() {
      reconnectWhenOnlineAgain = true
      realWs.close(1000)
    },
    connectivityEventsAttached = false

    function detachConnectivityEvents() {
      if (connectivityEventsAttached) {
        global.removeEventListener('online', ononline)
        global.removeEventListener('offline', onoffline)
        connectivityEventsAttached = false
      }
    }

    function attachConnectivityEvents() {
      if (!connectivityEventsAttached) {
        global.addEventListener('online', ononline)
        global.addEventListener('offline', onoffline)
        connectivityEventsAttached = true
      }
    }

    self.send = function() {
      return realWs.send.apply(realWs, arguments)
    }

    self.close = function(code, reason) {
      if (typeof code !== 'number') {
        reason = code
        code = 1000
      }

      clearPendingReconnectIfNeeded()
      reconnectWhenOnlineAgain = false
      explicitlyClosed = true
      detachConnectivityEvents()

      return realWs.close(code, reason)
    }

    self.open = function() {
      if (realWs.readyState !== WebSocket.OPEN && realWs.readyState !== WebSocket.CONNECTING) {
        clearPendingReconnectIfNeeded()
        reconnectWhenOnlineAgain = false
        explicitlyClosed = false

        newWebSocket()
      }
    }

    function reconnect(event) {
      if (event.code === 1000 || explicitlyClosed) {
        attempts = 0
        return
      }
      if (navigator.onLine === false) {
        reconnectWhenOnlineAgain = true
        return
      }

      var delay = opts.shouldReconnect(event, self)
      if (typeof delay === 'number') {
        pendingReconnect = setTimeout(newWebSocket, delay)
      } else if (delay instanceof Promise) {
        delay.then(function(time) {
          pendingReconnect = setTimeout(newWebSocket, time);
        });
      }
    }

    Object.defineProperty(self, 'listeners', {
      value: {
        open: [function(event) {
          if (connectTimeout) {
            clearTimeout(connectTimeout)
            connectTimeout = null
          }
          event.reconnects = ++reconnects
          event.attempts = attempts
          attempts = 0
          reconnectWhenOnlineAgain = false
        }],
        close: [reconnect]
      }
    })

    Object.defineProperty(self, 'attempts', {
      get: function() { return attempts },
      enumerable: true
    })

    Object.defineProperty(self, 'reconnects', {
      get: function() { return reconnects },
      enumerable: true
    })

    function newWebSocket() {
      pendingReconnect = null
      realWs = new WebSocket(url, protocols)
      realWs.binaryType = self.binaryType

      attempts++
      self.dispatchEvent(Object.assign(new CustomEvent('connecting'), {
        attempts: attempts,
        reconnects: reconnects
      }))

      connectTimeout = setTimeout(function() {
        connectTimeout = null
        detachConnectivityEvents()
        self.dispatchEvent(Object.assign(new CustomEvent('timeout'), {
          attempts: attempts,
          reconnects: reconnects
        }))
      }, opts.timeout)

      ;['open', 'close', 'message', 'error'].forEach(function(stdEvent) {
        realWs.addEventListener(stdEvent, function(event) {
          self.dispatchEvent(event)

          var cb = self['on' + stdEvent]
          if (typeof cb === 'function') {
            return cb.apply(self, arguments)
          }
        })
      })

      attachConnectivityEvents()
    }

    if (opts.automaticOpen) {
      newWebSocket()
    }
  }

  RobustWebSocket.defaultOptions = {
    // the time to wait before a successful connection
    // before the attempt is considered to have timed out
    timeout: 4000,
    // Given a CloseEvent or OnlineEvent and the RobustWebSocket state,
    // should a reconnect be attempted? Return the number of milliseconds to wait
    // to reconnect (or null or undefined to not), rather than true or false
    shouldReconnect: function(event, ws) {
      if (event.code === 1008 || event.code === 1011) return
      return [0, 3000, 10000][ws.attempts]
    },

    // Create and connect the WebSocket when the instance is instantiated.
    // Defaults to true to match standard WebSocket behavior
    automaticOpen: true
  }

  RobustWebSocket.prototype.binaryType = 'blob'

  // Taken from MDN https://developer.mozilla.org/en-US/docs/Web/API/EventTarget
  RobustWebSocket.prototype.addEventListener = function(type, callback) {
    if (!(type in this.listeners)) {
      this.listeners[type] = []
    }
    this.listeners[type].push(callback)
  }

  RobustWebSocket.prototype.removeEventListener = function(type, callback) {
    if (!(type in this.listeners)) {
      return
    }
    var stack = this.listeners[type]
    for (var i = 0, l = stack.length; i < l; i++) {
      if (stack[i] === callback) {
        stack.splice(i, 1)
        return
      }
    }
  }

  RobustWebSocket.prototype.dispatchEvent = function(event) {
    if (!(event.type in this.listeners)) {
      return
    }
    event.currentTarget = this
    var stack = this.listeners[event.type]
    for (var i = 0, l = stack.length; i < l; i++) {
      stack[i].call(this, event)
    }
  }

  return RobustWebSocket
}, typeof window != 'undefined' ? window : (typeof global != 'undefined' ? global : this))

},
'appivo/bus/Session':function(){
define([],

  /**
   * Packet-format: 'v1':<type>:<subtype>:<session>:<seq>:<response-to>
   */		
		
  function() {
		
	var CMD_GETQUEUE = 0;
	var CMD_CLOSEQUEUE = 1;
	var CMD_PURGEQUEUE = 2;
	var CMD_DELETEQUEUE = 3;
	var CMD_BIND = 4;
	var CMD_UNBIND = 5;
	var CMD_SUBSCRIBE = 6;
	var CMD_UNSUBSCRIBE = 7;
	var CMD_GETPUBLISHER = 8;
	var CMD_PUBLISH = 9;
	var CMD_DELIVER = 10;
	var CMD_ACK = 11;
	var CMD_REJECT = 12;
	var CMD_RESPONSE = 13;

	var CTRL_ENDSESSION = 4;
	
	function Session(options) {
		this.id = options.id;
		this.seq = 0;
		this.bus = options.bus;	
		this.listeners = new Array();
		this.waitingFor = {};
	};
	
	Session.prototype = {
		constructor: Session,
		seq: 0,
		
		_createPacket: function(type, internal) {
			var options = {
				type: type,
				internal: internal,
				session: this.id,
				seq: this.seq++
			};
			var packet = this.bus._createPacket(options);
			return packet;
		},
		
		_addListener: function(listener) {
			this.listeners.push(listener);
		},
		
		_removeListener: function(listener) {
			var pos = this.listeners.indexOf(listener);
			if (pos >= 0) {
				this.listeners.splice(pos, 1);
			}
		},
		
		_handlePacket: function(packet) {
			var callback = this.waitingFor[packet.response];
			if (callback) {
				delete this.waitingFor[packet.response];
				callback(true, packet);
			}
			for (var i = 0; i < this.listeners.length; i++) {
				var listener = this.listeners[i];
				listener._handlePacket(packet);
			}
		},
		
		_onClose: function() {
			
		},
		
		_send: function(packet) {
			this.bus._send(packet);
		},
		
		_sendAndWait: function(packet, timeout, callback) {
			var t = this;
			var id = packet._meta.seq;
			this.waitingFor[id] = callback;
			setTimeout(function() {
				delete t.waitingFor[id];
				callback(false);
			}, timeout);
			this.bus._send(packet);
		},
		
		_remoteClose: function() {
			
		},
		
		close: function() {
			this._onClose();
			var packet = this.bus._createPacket({
				internal: true,
				type: CTRL_ENDSESSION,
				session: this.id
			});
			this._send(packet);
			this._remoteClose();
		}
	};
			
	return Session;
});
},
'appivo/bus/Queue':function(){
define(['./Consumer', 'dojo/Deferred'],

  /**
   * Packet-format: 'v1':<type>:<subtype>:<session>:<seq>:<response-to>
   */		
		
  function(Consumer, Deferred) {
    var DEFAULT_TIMEOUT = 5000;
	var CMD_BIND = 4;
	var CMD_UNBIND = 5;
	var CMD_SUBSCRIBE = 6;
	
	function Queue(options) {
		this.bus = options.bus;
		this.name = options.name;
		this.exchange = options.exchange;
		this.queue = options.queue;
	};
	
	var consumers = new Array();
	var bindings = new Array();
	
	Queue.prototype = {
		constructor: Queue,
		
		createConsumer: function(callback, filter) {
			var session = this._subscribe(filter);
			var consumer = new Consumer({
				session: session,
				queue: this,
				callback: callback
			});
			consumers.push(consumer);
			return consumer;
		},
		
		bind: function(path) {
			var session = this.bus._getSession();
			var packet = session._createPacket(CMD_BIND);
			packet.exchange = this.exchange;
			packet.queue = this.queue;
			packet.bindings = path;
			var def = new Deferred();
			session._sendAndWait(packet, DEFAULT_TIMEOUT, function(ok) {
				if (ok) {
					bindings.push(path);
					def.resolve();
				} else {
					def.reject("Timeout");
				}
			});
			return def;
		},

		unbind: function(path) {
			var session = this.bus._getSession();
			var packet = session._createPacket(CMD_UNBIND);
			packet.exchange = this.exchange;
			packet.queue = this.queue;
			packet.bindings = path;
			session._send(packet);
			var index = bindings.indexOf(path);
			bindings.splice(index, 1);
		},

		_subscribe: function(filter) {
			var session = this.bus._newSession();
			var packet = session._createPacket(CMD_SUBSCRIBE);
			packet.exchange = this.exchange;
			packet.queue = this.queue;
			if (filter) {
				packet.filter = filter;
			}
			session._send(packet);
			return session;
		},
		
		_reconnect: function(data) {
			this.queue = data.queue;
			this.bind(bindings);
			for (var i = 0; i < consumers.length; i++) {
				var consumer = consumers[i];
				var session = this._subscribe();
				consumer._reconnect(session);
			}
		},
		
		_removeConsumer: function(consumer) {
			var index = consumers.indexOf(consumer);
			consumers.splice(index, 1);
		},
		
		close: function() {
			this.bus._removeQueue(this);
			for (var i = 0; i < consumers.length; i++) {
				consumers[i].close();
			}
		}
	};
			
	return Queue;
});
},
'appivo/bus/Consumer':function(){
/**
 * @interface Consumer
 */
define([],

  /**
   * Packet-format: 'v1':<type>:<subtype>:<session>:<seq>:<response-to>
   */		
		
  function() {
		
	var CMD_DELIVER = 10;

	function Consumer(options) {
		this.callback = options.callback;
		this.queue = options.queue;
		this._reconnect(options.session);
	};
	
	Consumer.prototype = {
		constructor: Consumer,
		
		_handlePacket: function(packet) {
			switch (packet.subtype) {
			case CMD_DELIVER:
				var content = packet.content;
				try {
					this.callback({
						headers: content.headers,
						content: content.env.message
					});
				} catch (error) {
					console.log("Error consuming message", error);
				}
				break;
			}
		},
		
		_reconnect: function(session) {
			this.session = session;
			this.session._addListener(this);
		},
		
		/**
		 * Close the consumer
		 * @memberof Consumer
		 * @instance
		 */
		close: function() {
			this.session._removeListener(this);
			this.session.close();
			this.queue._removeConsumer(this);
		}
	};
			
	return Consumer;
});
},
'appivo/bus/Publisher':function(){
define([],

  /**
   * Packet-format: 'v1':<type>:<subtype>:<session>:<seq>:<response-to>
   */		
		
  function() {
		
	var CMD_GETPUBLISHER = 8;
	var CMD_PUBLISH = 9;
	
	function Publisher(options) {
		this.bus = options.bus;
		this.exchange = options.exchange;
		this.session = options.session;
	};
	
	Publisher.prototype = {
		constructor: Publisher,
		
		publish:  function(key, message, headers) {
			var packet = this.session._createPacket(CMD_PUBLISH);
						
			packet.content = {
				key: key,
				headers: headers,
				env: {
					type: 'map',
					message: message
				}
			};
			
			this.session._send(packet);
		},
		
		_reconnect: function() {
			this.session = this.bus._newSession();
			var packet = this.session._createPacket(CMD_GETPUBLISHER);
			packet.exchange = this.exchange;
			this.session._send(packet);
		},
		
		close: function() {
			this.bus._removePublisher(this);
		}
	};
			
	return Publisher;
});
},
'appivo/util/Equals':function(){
define([], function() {

	function objectEquals(x, y, exclude, include) {
		'use strict';

		if (x === null || x === undefined || y === null || y === undefined) { return x === y; }
		// after this just checking type of one would be enough
		if (x.constructor !== y.constructor) { return false; }
		// if they are functions, they should exactly refer to same one (because of closures)
		if (x instanceof Function) { return x === y; }
		// if they are regexps, they should exactly refer to same one (it is hard to better equality check on current ES)
		if (x instanceof RegExp) { return x === y; }
		if (x === y || x.valueOf() === y.valueOf()) { return true; }
		if (Array.isArray(x) && x.length !== y.length) { return false; }

		// if they are dates, they must had equal valueOf
		if (x instanceof Date) { return false; }

		// if they are strictly equal, they both need to be object at least
		if (!(x instanceof Object)) { return false; }
		if (!(y instanceof Object)) { return false; }

		// recursive object equality check
		var p = Object.keys(x);
		var p2 = Object.keys(y);
		if (exclude && Array.isArray(exclude)) {
			p = p.filter(function(key) {
				return exclude.indexOf(key) === -1;
			});
			p2 = p2.filter(function(key) {
				return exclude.indexOf(key) === -1;
			});
		} else if (include && Array.isArray(include)) {
			p = p.filter(function(key) {
				return include.indexOf(key) >= 0;
			});
			p2 = p2.filter(function(key) {
				return include.indexOf(key) >= 0;
			});
		}
		return p2.every(function (i) {
			return p.indexOf(i) !== -1;
		}) && p.every(function (i) {
			return objectEquals(x[i], y[i]);
		});
	}

	return objectEquals;
});
},
'appivo/util/ExpressionParser':function(){
define(['dojo/number'], function(dojoNumber) {
		
	/*!
	 Based on ndef.parser, by Raphael Graf(r@undefined.ch)
	 http://www.undefined.ch/mparser/index.html

	 Ported to JavaScript and modified by Matthew Crumley (email@matthewcrumley.com, http://silentmatt.com/)

	 You are free to use and modify this code in anyway you find useful. Please leave this comment in the code
	 to acknowledge its original source. If you feel like it, I enjoy hearing about projects that use my code,
	 but don't feel like you have to let me know or ask permission.
	*/

	//  Added by stlsmiths 6/13/2011
	//  re-define Array.indexOf, because IE doesn't know it ...
	//
	//  from http://stellapower.net/content/javascript-support-and-arrayindexof-ie
		if (!Array.indexOf) {
			Array.prototype.indexOf = function (obj, start) {
				for (var i = (start || 0); i < this.length; i++) {
					if (this[i] === obj) {
						return i;
					}
				}
				return -1;
			}
		}

	var Parser = (function (scope) {
		function object(o) {
			function F() {}
			F.prototype = o;
			return new F();
		}

		var TNUMBER = 0;
		var TOP1 = 1;
		var TOP2 = 2;
		var TVAR = 3;
		var TFUNCALL = 4;

		function Token(type_, index_, prio_, number_) {
			this.type_ = type_;
			this.index_ = index_ || 0;
			this.prio_ = prio_ || 0;
			this.number_ = (number_ !== undefined && number_ !== null) ? number_ : 0;
			this.toString = function () {
				switch (this.type_) {
				case TNUMBER:
					return this.number_;
				case TOP1:
				case TOP2:
				case TVAR:
					return this.index_;
				case TFUNCALL:
					return "CALL";
				default:
					return "Invalid Token";
				}
			};
		}

		function Expression(tokens, ops1, ops2, functions) {
			this.tokens = tokens;
			this.ops1 = ops1;
			this.ops2 = ops2;
			this.functions = functions;
		}

		// Based on http://www.json.org/json2.js
	    var cx = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
	        escapable = /[\\\'\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
	        meta = {    // table of character substitutions
	            '\b': '\\b',
	            '\t': '\\t',
	            '\n': '\\n',
	            '\f': '\\f',
	            '\r': '\\r',
	            "'" : "\\'",
	            '\\': '\\\\'
	        };

		function escapeValue(v) {
			if (typeof v === "string") {
				escapable.lastIndex = 0;
		        return escapable.test(v) ?
		            "'" + v.replace(escapable, function (a) {
		                var c = meta[a];
		                return typeof c === 'string' ? c :
		                    '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
		            }) + "'" :
		            "'" + v + "'";
			}
			return v;
		}

		Expression.prototype = {
			simplify: function (values) {
				values = values || {};
				var nstack = [];
				var newexpression = [];
				var n1;
				var n2;
				var f;
				var L = this.tokens.length;
				var item;
				var i = 0;
				for (i = 0; i < L; i++) {
					item = this.tokens[i];
					var type_ = item.type_;
					if (type_ === TNUMBER) {
						nstack.push(item);
					}
					else if (type_ === TVAR && (item.index_ in values)) {
						item = new Token(TNUMBER, 0, 0, values[item.index_]);
						nstack.push(item);
					}
					else if (type_ === TOP2 && nstack.length > 1) {
						n2 = nstack.pop();
						n1 = nstack.pop();
						f = this.ops2[item.index_];
						item = new Token(TNUMBER, 0, 0, f(n1.number_, n2.number_));
						nstack.push(item);
					}
					else if (type_ === TOP1 && nstack.length > 0) {
						n1 = nstack.pop();
						f = this.ops1[item.index_];
						item = new Token(TNUMBER, 0, 0, f(n1.number_));
						nstack.push(item);
					}
					else {
						while (nstack.length > 0) {
							newexpression.push(nstack.shift());
						}
						newexpression.push(item);
					}
				}
				while (nstack.length > 0) {
					newexpression.push(nstack.shift());
				}

				return new Expression(newexpression, object(this.ops1), object(this.ops2), object(this.functions));
			},

			substitute: function (variable, expr) {
				if (!(expr instanceof Expression)) {
					expr = new Parser().parse(String(expr));
				}
				var newexpression = [];
				var L = this.tokens.length;
				var item;
				var i = 0;
				for (i = 0; i < L; i++) {
					item = this.tokens[i];
					var type_ = item.type_;
					if (type_ === TVAR && item.index_ === variable) {
						for (var j = 0; j < expr.tokens.length; j++) {
							var expritem = expr.tokens[j];
							var replitem = new Token(expritem.type_, expritem.index_, expritem.prio_, expritem.number_);
							newexpression.push(replitem);
						}
					}
					else {
						newexpression.push(item);
					}
				}

				var ret = new Expression(newexpression, object(this.ops1), object(this.ops2), object(this.functions));
				return ret;
			},

			evaluate: function (values) {
				values = values || {};
				var nstack = [];
				var n1;
				var n2;
				var f;
				var L = this.tokens.length;
				var item;
				var i = 0;
				for (i = 0; i < L; i++) {
					item = this.tokens[i];
					var type_ = item.type_;
					if (type_ === TNUMBER) {
						nstack.push(item.number_);
					}
					else if (type_ === TOP2) {
						n2 = nstack.pop();
						n1 = nstack.pop();
						f = this.ops2[item.index_];
						nstack.push(f(n1, n2));
					}
					else if (type_ === TVAR) {
						var handled = false;
						if (typeof values === "function") {
							var vvalue = values(item.index_);
							if (vvalue !== undefined) {
								nstack.push(values(item.index_));
								handled = true;
							}
						}
						if (!handled && item.index_ in values) {
							nstack.push(values[item.index_]);
						}
						else if (!handled && item.index_ in this.functions) {
							nstack.push(this.functions[item.index_]);
						}
						else if (!handled) {
							throw new Error("undefined variable: " + item.index_);
						}
					}
					else if (type_ === TOP1) {
						n1 = nstack.pop();
						f = this.ops1[item.index_];
						nstack.push(f(n1));
					}
					else if (type_ === TFUNCALL) {
						n1 = nstack.pop();
						f = nstack.pop();
						if (f.apply && f.call) {
							if (Object.prototype.toString.call(n1) == "[object Array]") {
								nstack.push(f.apply(undefined, n1));
							}
							else {
								nstack.push(f.call(undefined, n1));
							}
						}
						else {
							throw new Error(f + " is not a function");
						}
					}
					else {
						throw new Error("invalid Expression");
					}
				}
				if (nstack.length > 1) {
					throw new Error("invalid Expression (parity)");
				}
				return nstack[0];
			},

			toString: function (toJS) {
				var nstack = [];
				var n1;
				var n2;
				var f;
				var L = this.tokens.length;
				var item;
				var i = 0;
				for (i = 0; i < L; i++) {
					item = this.tokens[i];
					var type_ = item.type_;
					if (type_ === TNUMBER) {
						nstack.push(escapeValue(item.number_));
					}
					else if (type_ === TOP2) {
						n2 = nstack.pop();
						n1 = nstack.pop();
						f = item.index_;
						if (toJS && f == "^") {
							nstack.push("Math.pow(" + n1 + "," + n2 + ")");
						}
						else {
							nstack.push("(" + n1 + f + n2 + ")");
						}
					}
					else if (type_ === TVAR) {
						nstack.push(item.index_);
					}
					else if (type_ === TOP1) {
						n1 = nstack.pop();
						f = item.index_;
						if (f === "-") {
							nstack.push("(" + f + n1 + ")");
						}
						else {
							nstack.push(f + "(" + n1 + ")");
						}
					}
					else if (type_ === TFUNCALL) {
						n1 = nstack.pop();
						f = nstack.pop();
						nstack.push(f + "(" + n1 + ")");
					}
					else {
						throw new Error("invalid Expression");
					}
				}
				if (nstack.length > 1) {
					throw new Error("invalid Expression (parity)");
				}
				return nstack[0];
			},

			variables: function () {
				var L = this.tokens.length;
				var vars = [];
				for (var i = 0; i < L; i++) {
					var item = this.tokens[i];
					if (item.type_ === TVAR && (vars.indexOf(item.index_) == -1)) {
						vars.push(item.index_);
					}
				}

				return vars;
			},

			toJSFunction: function (param, variables) {
				var f = new Function(param, "with(Parser.values) { return " + this.simplify(variables).toString(true) + "; }");
				return f;
			}
		};

		function add(a, b) {
			return Number(a) + Number(b);
		}
		function sub(a, b) {
			return a - b; 
		}
		function mul(a, b) {
			return a * b;
		}
		function div(a, b) {
			return a / b;
		}
		function mod(a, b) {
			return a % b;
		}
		function concat(a, b) {
			return "" + a + b;
		}
		function less(a,b) {
			return a < b;
		}
		function greater(a,b) {
			return a > b;
		}
		function equals(a,b) {
			return a == b;
		}
		function lessOrEquals(a,b) {
			return a <= b;
		}
		function greaterOrEquals(a,b) {
			return a >= b;
		}
		function log10(a) {
		      return Math.log(a) * Math.LOG10E;
		}
		function neg(a) {
			return -a;
		}

		function random(a) {
			return Math.random() * (a || 1);
		}

		function trim(a) {
			if (typeof a === "string") {
				return a.trim();
			}
			return a;
		}

		function lowercase(a) {
			if (typeof a === "string") {
				return a.toLowerCase();
			}
			return a;
		}

		function uppercase(a) {
			if (typeof a === "string") {
				return a.toUpperCase();
			}
			return a;
		}

		function replace(a, b, c) {
			if (typeof a === "string") {
				return a.replace(b, c);
			}
			return a;
		}

		function fac(a) { //a!
			a = Math.floor(a);
			var b = a;
			while (a > 1) {
				b = b * (--a);
			}
			return b;
		}

		// TODO: use hypot that doesn't overflow
		function pyt(a, b) {
			return Math.sqrt(a * a + b * b);
		}

		function append(a, b) {
			if (Object.prototype.toString.call(a) != "[object Array]") {
				return [a, b];
			}
			a = a.slice();
			a.push(b);
			return a;
		}

		function Parser() {
			this.success = false;
			this.errormsg = "";
			this.expression = "";

			this.pos = 0;

			this.tokennumber = 0;
			this.tokenprio = 0;
			this.tokenindex = 0;
			this.tmpprio = 0;

			this.ops1 = {
				"sin": Math.sin,
				"cos": Math.cos,
				"tan": Math.tan,
				"asin": Math.asin,
				"acos": Math.acos,
				"atan": Math.atan,
				"sqrt": Math.sqrt,
				"log": Math.log,
				"lg" : log10,
				"log10" : log10,
				"abs": Math.abs,
				"ceil": Math.ceil,
				"floor": Math.floor,
				"round": dojoNumber.round,
				"-": neg,
				"exp": Math.exp
			};

			this.ops2 = {
				"+": add,
				"-": sub,
				"*": mul,
				"/": div,
				"%": mod,
				"^": Math.pow,
				",": append,
				"||": concat,
				">": greater,
				"<": less,
				"=": equals,
				"<=": lessOrEquals,
				">=": greaterOrEquals
			};

			this.functions = {
				"random": random,
				"fac": fac,
				"min": Math.min,
				"max": Math.max,
				"pyt": pyt,
				"pow": Math.pow,
				"atan2": Math.atan2,
				"lowercase": lowercase,
				"uppercase": uppercase,
				"trim": trim,
				"replace": replace,
				"concat": concat
			};

			this.consts = {
				"E": Math.E,
				"PI": Math.PI
			};

			this.allowedVarChars = ['_','.',':','[',']'];
		}

		Parser.parse = function (expr) {
			return new Parser().parse(expr);
		};

		Parser.evaluate = function (expr, variables) {
			return Parser.parse(expr).evaluate(variables);
		};

		Parser.Expression = Expression;

		Parser.values = {
			sin: Math.sin,
			cos: Math.cos,
			tan: Math.tan,
			asin: Math.asin,
			acos: Math.acos,
			atan: Math.atan,
			sqrt: Math.sqrt,
			log: Math.log,
			lg: log10,
			log10: log10,
			abs: Math.abs,
			ceil: Math.ceil,
			floor: Math.floor,
			round: dojoNumber.round,
			random: random,
			fac: fac,
			exp: Math.exp,
			min: Math.min,
			max: Math.max,
			pyt: pyt,
			pow: Math.pow,
			atan2: Math.atan2,
			E: Math.E,
			PI: Math.PI,
			uppercase: uppercase,
			lowercase: lowercase,
			replace: replace,
			trim: trim
		};

		var PRIMARY      = 1 << 0;
		var OPERATOR     = 1 << 1;
		var FUNCTION     = 1 << 2;
		var LPAREN       = 1 << 3;
		var RPAREN       = 1 << 4;
		var COMMA        = 1 << 5;
		var SIGN         = 1 << 6;
		var CALL         = 1 << 7;
		var NULLARY_CALL = 1 << 8;

		Parser.prototype = {
			parse: function (expr) {
				this.errormsg = "";
				this.success = true;
				var operstack = [];
				var tokenstack = [];
				this.tmpprio = 0;
				var expected = (PRIMARY | LPAREN | FUNCTION | SIGN);
				var noperators = 0;
				this.expression = expr;
				this.pos = 0;

				while (this.pos < this.expression.length) {
					if (this.isOperator()) {
						if (this.isSign() && (expected & SIGN)) {
							if (this.isNegativeSign()) {
								this.tokenprio = 2;
								this.tokenindex = "-";
								noperators++;
								this.addfunc(tokenstack, operstack, TOP1);
							}
							expected = (PRIMARY | LPAREN | FUNCTION | SIGN);
						}
						else if (this.isComment()) {

						}
						else {
							if ((expected & OPERATOR) === 0) {
								this.error_parsing(this.pos, "unexpected operator");
							}
							noperators += 2;
							this.addfunc(tokenstack, operstack, TOP2);
							expected = (PRIMARY | LPAREN | FUNCTION | SIGN);
						}
					}
					else if (this.isNumber()) {
						if ((expected & PRIMARY) === 0) {
							this.error_parsing(this.pos, "unexpected number");
						}
						var token = new Token(TNUMBER, 0, 0, this.tokennumber);
						tokenstack.push(token);

						expected = (OPERATOR | RPAREN | COMMA);
					}
					else if (this.isString()) {
						if ((expected & PRIMARY) === 0) {
							this.error_parsing(this.pos, "unexpected string");
						}
						var token = new Token(TNUMBER, 0, 0, this.tokennumber);
						tokenstack.push(token);

						expected = (OPERATOR | RPAREN | COMMA);
					}
					else if (this.isLeftParenth()) {
						if ((expected & LPAREN) === 0) {
							this.error_parsing(this.pos, "unexpected \"(\"");
						}

						if (expected & CALL) {
							noperators += 2;
							this.tokenprio = -2;
							this.tokenindex = -1;
							this.addfunc(tokenstack, operstack, TFUNCALL);
						}

						expected = (PRIMARY | LPAREN | FUNCTION | SIGN | NULLARY_CALL);
					}
					else if (this.isRightParenth()) {
					    if (expected & NULLARY_CALL) {
							var token = new Token(TNUMBER, 0, 0, []);
							tokenstack.push(token);
						}
						else if ((expected & RPAREN) === 0) {
							this.error_parsing(this.pos, "unexpected \")\"");
						}

						expected = (OPERATOR | RPAREN | COMMA | LPAREN | CALL);
					}
					else if (this.isComma()) {
						if ((expected & COMMA) === 0) {
							this.error_parsing(this.pos, "unexpected \",\"");
						}
						this.addfunc(tokenstack, operstack, TOP2);
						noperators += 2;
						expected = (PRIMARY | LPAREN | FUNCTION | SIGN);
					}
					else if (this.isConst()) {
						if ((expected & PRIMARY) === 0) {
							this.error_parsing(this.pos, "unexpected constant");
						}
						var consttoken = new Token(TNUMBER, 0, 0, this.tokennumber);
						tokenstack.push(consttoken);
						expected = (OPERATOR | RPAREN | COMMA);
					}
					else if (this.isOp2()) {
						if ((expected & FUNCTION) === 0) {
							this.error_parsing(this.pos, "unexpected function");
						}
						this.addfunc(tokenstack, operstack, TOP2);
						noperators += 2;
						expected = (LPAREN);
					}
					else if (this.isOp1()) {
						if ((expected & FUNCTION) === 0) {
							this.error_parsing(this.pos, "unexpected function");
						}
						this.addfunc(tokenstack, operstack, TOP1);
						noperators++;
						expected = (LPAREN);
					}
					else if (this.isVar()) {
						if ((expected & PRIMARY) === 0) {
							this.error_parsing(this.pos, "unexpected variable");
						}
						var vartoken = new Token(TVAR, this.tokenindex, 0, 0);
						tokenstack.push(vartoken);

						expected = (OPERATOR | RPAREN | COMMA | LPAREN | CALL);
					}
					else if (this.isWhite()) {
					}
					else {
						if (this.errormsg === "") {
							this.error_parsing(this.pos, "unknown character");
						}
						else {
							this.error_parsing(this.pos, this.errormsg);
						}
					}
				}
				if (this.tmpprio < 0 || this.tmpprio >= 10) {
					this.error_parsing(this.pos, "unmatched \"()\"");
				}
				while (operstack.length > 0) {
					var tmp = operstack.pop();
					tokenstack.push(tmp);
				}
				if (noperators + 1 !== tokenstack.length) {
					//print(noperators + 1);
					//print(tokenstack);
					this.error_parsing(this.pos, "parity");
				}

				return new Expression(tokenstack, object(this.ops1), object(this.ops2), object(this.functions));
			},

			evaluate: function (expr, variables) {
				return this.parse(expr).evaluate(variables);
			},

			error_parsing: function (column, msg) {
				this.success = false;
				this.errormsg = "parse error [column " + (column) + "]: " + msg;
				throw new Error(this.errormsg);
			},

	//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\

			addfunc: function (tokenstack, operstack, type_) {
				var operator = new Token(type_, this.tokenindex, this.tokenprio + this.tmpprio, 0);
				while (operstack.length > 0) {
					if (operator.prio_ <= operstack[operstack.length - 1].prio_) {
						tokenstack.push(operstack.pop());
					}
					else {
						break;
					}
				}
				operstack.push(operator);
			},

			isNumber: function () {
				var r = false;
				var str = "";
				while (this.pos < this.expression.length) {
					var code = this.expression.charCodeAt(this.pos);
					if ((code >= 48 && code <= 57) || code === 46) {
						str += this.expression.charAt(this.pos);
						this.pos++;
						this.tokennumber = parseFloat(str);
						r = true;
					}
					else {
						break;
					}
				}
				return r;
			},

			// Ported from the yajjl JSON parser at http://code.google.com/p/yajjl/
			unescape: function(v, pos) {
				var buffer = [];
				var escaping = false;

				for (var i = 0; i < v.length; i++) {
					var c = v.charAt(i);
		
					if (escaping) {
						switch (c) {
						case "'":
							buffer.push("'");
							break;
						case '\\':
							buffer.push('\\');
							break;
						case '/':
							buffer.push('/');
							break;
						case 'b':
							buffer.push('\b');
							break;
						case 'f':
							buffer.push('\f');
							break;
						case 'n':
							buffer.push('\n');
							break;
						case 'r':
							buffer.push('\r');
							break;
						case 't':
							buffer.push('\t');
							break;
						case 'u':
							// interpret the following 4 characters as the hex of the unicode code point
							var codePoint = parseInt(v.substring(i + 1, i + 5), 16);
							buffer.push(String.fromCharCode(codePoint));
							i += 4;
							break;
						default:
							throw this.error_parsing(pos + i, "Illegal escape sequence: '\\" + c + "'");
						}
						escaping = false;
					} else {
						if (c == '\\') {
							escaping = true;
						} else {
							buffer.push(c);
						}
					}
				}
		
				return buffer.join('');
			},

			isString: function () {
				var r = false;
				var str = "";
				var startpos = this.pos;
				if (this.pos < this.expression.length && this.expression.charAt(this.pos) == "'") {
					this.pos++;
					while (this.pos < this.expression.length) {
						var code = this.expression.charAt(this.pos);
						if (code != "'" || str.slice(-1) == "\\") {
							str += this.expression.charAt(this.pos);
							this.pos++;
						}
						else {
							this.pos++;
							this.tokennumber = this.unescape(str, startpos);
							r = true;
							break;
						}
					}
				}
				return r;
			},

			isConst: function () {
				var str;
				for (var i in this.consts) {
					if (true) {
						var L = i.length;
						str = this.expression.substr(this.pos, L);
						if (i === str) {
							this.tokennumber = this.consts[i];
							this.pos += L;
							return true;
						}
					}
				}
				return false;
			},

			isOperator: function () {
				var code = this.expression.charCodeAt(this.pos);
				if (code === 43) { // +
					this.tokenprio = 0;
					this.tokenindex = "+";
				}
				else if (code === 45) { // -
					this.tokenprio = 0;
					this.tokenindex = "-";
				}
				else if (code === 124) { // |
					if (this.expression.charCodeAt(this.pos + 1) === 124) {
						this.pos++;
						this.tokenprio = 0;
						this.tokenindex = "||";
					}
					else {
						return false;
					}
				}
				else if (code === 42 || code === 8729 || code === 8226) { // * or ∙ or •
					this.tokenprio = 1;
					this.tokenindex = "*";
				}
				else if (code === 47) { // /
					this.tokenprio = 2;
					this.tokenindex = "/";
				}
				else if (code === 37) { // %
					this.tokenprio = 2;
					this.tokenindex = "%";
				}
				else if (code === 94) { // ^
					this.tokenprio = 3;
					this.tokenindex = "^";
				}
				else if (code === 62 ) {
					if (this.expression.charCodeAt(this.pos + 1) === 61) {
						this.pos++;
						this.tokenprio = 0;
						this.tokenindex = ">=";
					} else {
						this.tokenprio = 0;
						this.tokenindex = ">";
					}
				}
				else if (code === 60) {
					if (this.expression.charCodeAt(this.pos + 1) === 61) {
						this.pos++;
						this.tokenprio = 0;
						this.tokenindex = "<=";
					} else {
						this.tokenprio = 0;
						this.tokenindex = "<";
					}
				}
				else if (code === 61) {
					this.tokenprio = 0;
					this.tokenindex = "=";
				}
				else {
					return false;
				}
				this.pos++;
				return true;
			},

			isSign: function () {
				var code = this.expression.charCodeAt(this.pos - 1);
				if (code === 45 || code === 43) { // -
					return true;
				}
				return false;
			},

			isPositiveSign: function () {
				var code = this.expression.charCodeAt(this.pos - 1);
				if (code === 43) { // +
					return true;
				}
				return false;
			},

			isNegativeSign: function () {
				var code = this.expression.charCodeAt(this.pos - 1);
				if (code === 45) { // -
					return true;
				}
				return false;
			},

			isLeftParenth: function () {
				var code = this.expression.charCodeAt(this.pos);
				if (code === 40) { // (
					this.pos++;
					this.tmpprio += 10;
					return true;
				}
				return false;
			},

			isRightParenth: function () {
				var code = this.expression.charCodeAt(this.pos);
				if (code === 41) { // )
					this.pos++;
					this.tmpprio -= 10;
					return true;
				}
				return false;
			},

			isComma: function () {
				var code = this.expression.charCodeAt(this.pos);
				if (code === 44) { // ,
					this.pos++;
					this.tokenprio = -1;
					this.tokenindex = ",";
					return true;
				}
				return false;
			},

			isWhite: function () {
				var code = this.expression.charCodeAt(this.pos);
				if (code === 32 || code === 9 || code === 10 || code === 13) {
					this.pos++;
					return true;
				}
				return false;
			},

			isOp1: function () {
				var str = "";
				for (var i = this.pos; i < this.expression.length; i++) {
					var c = this.expression.charAt(i);
					if (c.toUpperCase() === c.toLowerCase()) {
						if (i === this.pos || (c != '_' && (c < '0' || c > '9'))) {
							break;
						}
					}
					str += c;
				}
				if (str.length > 0 && (str in this.ops1)) {
					this.tokenindex = str;
					this.tokenprio = 5;
					this.pos += str.length;
					return true;
				}
				return false;
			},

			isOp2: function () {
				var str = "";
				for (var i = this.pos; i < this.expression.length; i++) {
					var c = this.expression.charAt(i);
					if (c.toUpperCase() === c.toLowerCase()) {
						if (i === this.pos || (c != '_' && (c < '0' || c > '9'))) {
							break;
						}
					}
					str += c;
				}
				if (str.length > 0 && (str in this.ops2)) {
					this.tokenindex = str;
					this.tokenprio = 5;
					this.pos += str.length;
					return true;
				}
				return false;
			},

			isVar: function () {
				var str = "";
				for (var i = this.pos; i < this.expression.length; i++) {
					var c = this.expression.charAt(i);
					if (c.toUpperCase() === c.toLowerCase()) {
						if (i === this.pos || (this.allowedVarChars.indexOf(c) == -1 && (c < '0' || c > '9'))) {
							break;
						}
					}
					str += c;
				}
				if (str.length > 0) {
					this.tokenindex = str;
					this.tokenprio = 4;
					this.pos += str.length;
					return true;
				}
				return false;
			},

			isComment: function () {
				var code = this.expression.charCodeAt(this.pos - 1);
				if (code === 47 && this.expression.charCodeAt(this.pos) === 42) {
					this.pos = this.expression.indexOf("*/", this.pos) + 2;
					if (this.pos === 1) {
						this.pos = this.expression.length;
					}
					return true;
				}
				return false;
			}
		};

		scope.Parser = Parser;
		return Parser
	})(typeof exports === 'undefined' ? {} : exports);
	
	return Parser;
});

},
'appivo/model/QueryHandle':function(){
/**
 * A query handle allows interaction with a query.
 * @interface QueryHandle
 */
define(['dojo/_base/lang',
        'dojo/_base/declare',
        'dojo/_base/Deferred',
        'dojo/on',
        'dojo/Evented',
        'dojo/date/stamp',
        'appivo/model/QueryResult',
		'appivo/util/AsyncDebounce',
        'appivo/util/Identity',
		'appivo/model/RecordSet',
        'appivo/store/RecordStoreMixin'], function(lang, declare, Deferred, on, Evented, stamp, QueryResult, AsyncDebounce, Identity, RecordSet, RecordStore) {

	function _dateToStr(value, param) {
		value = stamp.toISOString(value);
		if (param && param.type == 'DATE') {
			var idx = value.indexOf('T');
			if (idx > 0) {
				value = value.substring(0, idx);
			}
		}
		return value;
	};

	function _arrayToStr(list) {
		var str = "";
		if (list) {
			for (var i = 0; i < list.length; i++) {
				var val = list[i];
				if (i > 0) {
					str += ",";
				}
				str = str + val;
			}
		}
		return str;
	};

	return declare("appivo.model.QueryHandle", [Evented], {
	
		paramPrefix: '$',
		query: null,
		store: null,
		storeQuery: null,
		oldStoreQuery: null,
		storeOptions: null,
		enabled: true,
		eventScheduled: false,
		queryResult: null,
		oldStoreOptions: null,

		constructor: function(options) {
			lang.mixin(this, options);
			if (!this.storeQuery) {
				this.storeQuery = {};
			}
			this.queryResult = new QueryResult({
				queryHandle: this
			});
			var t = this;
			var pst = this.store;
			if (pst.getParentStore) {
				pst = pst.getParentStore();
				if (!pst) {
					pst = this.store;
				}
			}
			pst.onQueryResult = function(result) {
				t.emit('queryResult', {
					store: result.store,
					result: result.result,
					query: t.query,
					queryHandle: t
				});
			};
		},

		setEnabled: function(enabled) {
			var en = this.enabled;
			this.enabled = enabled;
			this.store.setEnabled(enabled);
			if (this.enabled) {
				this._scheduleUpdate();				
			}
		},

		/**
		 * Sets a query parameter to the specified value.
		 * @param {String} param - The name of the parameter.
		 * @param {Object} value - The desired value.
		 * @param {Boolean} noupdate - If true, the query will not automatically update after the value has been set.
		 * @memberof QueryHandle
		 * @instance
		 *
		 * @LogicMeta {
		 *	"api": "QueryHandle",
		 *	"paramTypes": ["String", "null", "boolean"],
		 *	"tooltip": "$"
		 * }
		 */
		setParameter: function(param, value, noupdate) {
			var qp = this.query ? this.query.getParameter(param) : null;
			if (qp != null) {
				this._setQueryParameter(param, value, noupdate, false, qp);
			} else {
				this._setQueryParameter(param, value, noupdate, true);
			}
		},

		/**
		 * Sets a collection of parameters to their specified values.
		 * @param {Object} params - value pairs.
		 * @param {Boolean} noupdate - If true, the query will not automatically update after the value has been set.
		 * @memberof QueryHandle
		 * @instance
		 *
		 * @LogicMeta {
		 *	"api": "QueryHandle",
		 *	"paramTypes": ["Object", "boolean"],
		 *	"tooltip": "$"
		 * }
		 */
		setParameters: function(params, noupdate) {
			for (var key in params) {
				this.setParameter(key, params[key], noupdate);
			}
		},

		setFullText: function(text, noupdate) {
			this._setQueryParameter('_textsearch_', text, noupdate, false);
		},
		
		setLimit: function(limit, noupdate) {
			this._setQueryParameter('_limit_', limit, noupdate, false);
		},

		setOffset: function(offset, noupdate) {
			this._setQueryParameter('_offset_', offset, noupdate, false);
		},

		/**
		 * Clears the value of specified parameter.
		 * @param {String} param - The name of the parameter to clear.
		 * @param {Boolean} noupdate - If true, the query will not automatically update after the parameter has been removed.
		 * @memberof QueryHandle
		 * @instance
		 *
		 * @LogicMeta {
		 *	"api": "QueryHandle",
		 *	"paramTypes": ["String", "Boolean"],
		 *	"tooltip": "$"
		 * }
		 */
		removeParameter: function(param, noupdate) {
			this.setParameter(param, undefined, noupdate);
		},
		
		/**
		 * Refrehes the query.
		 * @memberof QueryHandle
		 * @param {Boolean} force - Force the query to execute
		 * @instance
		 *
		 * @LogicMeta {
		 *	"api": "QueryHandle",
		 *	"paramTypes": ["Boolean"],
		 *	"tooltip": "$"
		 * }
		 */
		refresh: function(force) {
		    this._emitUpdate(force);
		},

		_scheduleUpdate: function() {
			if (!this.eventScheduled) {
				console.log("Scheduling update of query " + this.query.name + " update in 50ms");
				this.eventScheduled = true;
				setTimeout(lang.hitch(this, this._emitUpdate), 50);
			}
		},

		_emitUpdate: function(force) {
			this.eventScheduled = false;
			if (this._validate()) {
				var eq = this._compare(this.storeQuery, this.oldStoreQuery);
				var eqOps = this._compare(this.storeOptions, this.oldStoreOptions);
				if ((!this.oldStoreQuery || !eq || !eqOps) || force) {
					console.log("Emitting update of query " + this.query.name);
					this.emit("update", {
						store: this.store,
						query: this.query,
						queryOptions: this.storeQuery,
						options: this.storeOptions
					});
				} else {
					console.log("No change in query, skipping emit");
				}
				this.oldStoreQuery = lang.clone(this.storeQuery);
				this.oldStoreOptions = lang.clone(this.storeOptions);
			} else {
				console.log("Skipping update as parameters are missing for query " + this.query.name);
			}
		},

		_setQueryParameter: function(param, value, noupdate, adhoc, paramDef) {
			var name = adhoc ? param : this.paramPrefix + param;
			var oldvalue = this.storeQuery[name];

			if (value instanceof Date) {
				value = _dateToStr(value, paramDef);
			} else if (Array.isArray(value)) {
				value = _arrayToStr(value);
			}
			
			if (value === oldvalue) {
				console.log("No change in value for parameter " + name + " " + value + " = " + oldvalue);
				return;
			}
			
			console.log("Setting parameter " + name + " of query " + this.query.name + " to " + value);
			// REMIND: Should the check be for value === undefined instead ?
			if (value === undefined && !(param.endsWith(":null") || param.endsWith(":isnotnull"))) {
				delete this.storeQuery[name];
			} else {
				this.storeQuery[name] = value;				
			}
			if (!noupdate) {
				this._scheduleUpdate();				
			}
		},

		reset: function() {
			this.storeQuery = {};
			this.oldStoreQuery = {};
		},

		resetParameters: function() {
			console.log("Resetting parameters");
			this.storeQuery = {};
			this._scheduleUpdate();
		},

        resetQueryParameters: function(){
        	console.log("Resetting parameters");
            this.storeQuery = {};
			this.oldStoreQuery = {};
        },

		/**
		 * Sets query parameter values according to the specified map.
		 * @param {Object} qps - Map of query parameter name and value pairs.
		 * @memberof QueryHandle
		 * @instance
		 *
		 * @LogicMeta {
		 *	"api": "QueryHandle",
		 *  "paramTypes": ["Object"],
		 *	"tooltip": "$"
		 * }
		 */
		setQueryParameters: function(qps) {
			if (!this.storeQuery) {
				this.storeQuery = {};				
			}
			if (qps) {
				var params = this.query ? this.query.getParameters() : [];
				for (var i in params) {
					var param = params[i];
					var val = qps[param.name];
					if (val) {
						var qv = val;
						if (qv instanceof Date) {
							qv = _dateToStr(qv, param);
						} else if (Array.isArray(qv)) {
							qv = _arrayToStr(qv);
						}
						this.storeQuery[this.paramPrefix + param.name] = qv;
					}
				}				
			}
			this._scheduleUpdate();
		},

		_validate: function() {
			var valid = true;
			var params = this.query ? this.query.getParameters() : [];
			for (var i in params) {
				var param = params[i];
				var dv = param.defaultValue;
				if (dv == undefined || dv == null || dv == '') {
					var value = this.storeQuery[this.paramPrefix + param.name];
					if (value == undefined) {
						valid = false;
						console.log("Missing query-parameter " + param.name + " for query " + this.query.name);
					}
				}
			}
			return valid;
		},
		
		getStore: function() {
			return this.store;
		},
		
		remove: function(rec) {
			return this.store.remove(rec);
		},

		/**
		 * Returns the result of the query.
		 * @returns {Object} - The query's result set.
		 * @memberof QueryHandle
		 * @instance
		 *
		 * @LogicMeta {
		 *	"api": "QueryHandle",
		 *  "returnType": "Object",
		 *	"tooltip": "$"
		 * }
		 */
		getResult: function() {
			return this.queryResult;
		},

		/**
		 * Executes the query.
		 * @param {Object} options Options object.
		 * @param {Object} options.options Holds query specific configurations.
		 * @param {Boolean} options.options.nested If true, the query will include related objects in its result set.
		 * @param {Number} options.options.count Number of objects to return in the result.
		 * @memberof QueryHandle
		 * @returns {Promise}
		 * @instance
		 *
		 * @LogicMeta {
		 *	"api": "QueryHandle",
		 *  "paramTypes": ["Object"],
		 *  "async": {
		 *  	"onFailure": "onError"
		 *  },
		 *	"tooltip": "$"
		 * }
		 */
		execute: function(options) {
			if (!options) {
				options = {};
			}
			var qopts = {};
			if (this.storeOptions) {
				lang.mixin(qopts, this.storeOptions);
			}
			if (options.relations) {
				qopts.rels = options.relations;
			}
			if (options && options.options) {
				lang.mixin(qopts, options.options);
			}
			if (qopts.nested) {
				if (!qopts.headers) {
					qopts.headers = {};
				}
				lang.mixin(qopts.headers, {
					FetchMode: NESTED
				});
			}
			var t = this;
			var sq = lang.clone(this.storeQuery)	;
			if (options.query) {
				sq = options.query;
				var ssq = {};
				for (var name in sq) {
					var qv = sq[name];
					var p = this.query ? this.query.getParameter(name) : null;
					if (p) {
						name = "$" + name;
					}
					if (qv instanceof Date) {
						qv = _dateToStr(qv, p);
					} else if (Array.isArray(qv)) {
						qv = _arrayToStr(qv);
					}
					ssq[name] = qv;
				}
				sq = ssq;
			}
			if (!sq) {
				sq = {};
			}
			if (options.offset !== undefined) {
				sq['$_offset_'] = options.offset;
			}
			if (options.limit !== undefined) {
				sq['$_limit_'] = options.limit;
			}
			if (!this.__exec && (options.debounce !== false)) {
				this.__exec = AsyncDebounce(function(a, b) {
					return t.store.query(a,b);
				});
			} else {
				this.__exec = t.store.query;
			}
			const qr = this.__exec(sq, qopts);
			qr.then(function(result) {
				t.queryResult.setRecords(result);
				if (options.onSuccess) {
					options.onSuccess(t.queryResult);
				}
				result.asRecordSet = function() {
					return new RecordSet("primary", {
						primary: result
					});
				};
				return result;
			}, function(error) {
				if (options.onError) {
					options.onError(error);
				}
				return error;
			});
			return qr;
		},
		
		executeQuery: function(onSuccess, onError) {
			return this.store.query(this.storeQuery).then(function(result) {
				if (onSuccess) {
					onSuccess(result);
				}
				return result;
			}, function(error) {
				if (onError) {
					onError(error);
				}
				return error;
			});
		},
		
		getQuery: function() {
			return this.query;
		},

		getQueryOptions: function() {
			return this.storeQuery;
		},

		/**
		 * Sets the related records to also load
		 *
		 * @param {String} relations Comma-separated list of relations
		 * @param {Boolean} noupdate If true, don't trigger reloading the query-result
		 *
		 * @memberof QueryHandle
		 * @instance
		 *
		 * @LogicMeta {
		 *	"api": "QueryHandle",
		 *  "paramTypes": ["String", "Boolean"],
		 *	"tooltip": "$"
		 * }
		 */
		setRelations: function(relations, noupdate) {
			if (!this.storeOptions) {
				this.storeOptions = {};
			}
			this.storeOptions.rels = relations;
			
			if (!noupdate) {
				this._scheduleUpdate();
			}
		},
		
		_compare: function() {
			  var i, l, leftChain, rightChain;

			  function compare2Objects (x, y) {
			    var p;

			    // remember that NaN === NaN returns false
			    // and isNaN(undefined) returns true
			    if (isNaN(x) && isNaN(y) && typeof x === 'number' && typeof y === 'number') {
			         return true;
			    }

			    // Compare primitives and functions.     
			    // Check if both arguments link to the same object.
			    // Especially useful on the step where we compare prototypes
			    if (x === y) {
			        return true;
			    }

			    // Works in case when functions are created in constructor.
			    // Comparing dates is a common scenario. Another built-ins?
			    // We can even handle functions passed across iframes
			    if ((typeof x === 'function' && typeof y === 'function') ||
			       (x instanceof Date && y instanceof Date) ||
			       (x instanceof RegExp && y instanceof RegExp) ||
			       (x instanceof String && y instanceof String) ||
			       (x instanceof Number && y instanceof Number)) {
			        return x.toString() === y.toString();
			    }

			    // At last checking prototypes as good as we can
			    if (!(x instanceof Object && y instanceof Object)) {
			        return false;
			    }

			    if (x.isPrototypeOf(y) || y.isPrototypeOf(x)) {
			        return false;
			    }

			    if (x.constructor !== y.constructor) {
			        return false;
			    }

			    if (x.prototype !== y.prototype) {
			        return false;
			    }

			    // Check for infinitive linking loops
			    if (leftChain.indexOf(x) > -1 || rightChain.indexOf(y) > -1) {
			         return false;
			    }

			    // Quick checking of one object being a subset of another.
			    // todo: cache the structure of arguments[0] for performance
			    for (p in y) {
			        if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
			            return false;
			        }
			        else if (typeof y[p] !== typeof x[p]) {
			            return false;
			        }
			    }

			    for (p in x) {
			        if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
			            return false;
			        }
			        else if (typeof y[p] !== typeof x[p]) {
			            return false;
			        }

			        switch (typeof (x[p])) {
			            case 'object':
			            case 'function':

			                leftChain.push(x);
			                rightChain.push(y);

			                if (!compare2Objects (x[p], y[p])) {
			                    return false;
			                }

			                leftChain.pop();
			                rightChain.pop();
			                break;

			            default:
			                if (x[p] !== y[p]) {
			                    return false;
			                }
			                break;
			        }
			    }

			    return true;
			  }

			  if (arguments.length < 1) {
			    return true; //Die silently? Don't know how to handle such case, please help...
			    // throw "Need two or more arguments to compare";
			  }

			  for (i = 1, l = arguments.length; i < l; i++) {

			      leftChain = []; //Todo: this can be cached
			      rightChain = [];

			      if (!compare2Objects(arguments[0], arguments[i])) {
			          return false;
			      }
			  }

			  return true;
			}
	});
});
},
'appivo/model/QueryResult':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'dojo/_base/Deferred',
        'dojo/Evented'], function(lang, declare, Deferred, Evented) {
		
	
	function resolve(obj,ref, value) {
	    if (typeof ref == 'string')
	        return resolve(obj,ref.split('.'), value);
	    else if (ref.length==1 && value!==undefined)
	        return obj[ref[0]] = value;
	    else if (ref.length==0)
	        return obj;
	    else
	        return resolve(obj[ref[0]],ref.slice(1), value);
	};
	
	
	return declare("appivo.model.QueryResult", [Evented], {
	
		queryHandle: null,
		records: null,
		indexes: null,
		
		constructor: function(options) {
			lang.mixin(this, options);
		},
		
		setRecords: function(records) {
			this.records = records;
			this.indexes = null;
			this.emit('update', {
				queryResult: this,
				records: records
			});
		},
		
		getRecords: function() {
			return this.records;
		},
		
		getQueryHandle: function() {
			return this.queryHandle;
		},
		
		getStore: function() {
			return this.queryHandle.getStore();
		},
		
		getIndex: function(key) {
			if (!this.indexes) {
				this.indexes = {};
			}
			var index = this.indexes[key];
			if (!index) {
				index = {};
				this.records.forEach(function(record) {
					var id = resolve(record, key);
					var ex = index[id];
					if (!ex) {
						ex = [];
						index[id] = ex;
					}
					ex.push(record);
				});
				this.indexes[key] = index;
			}
			return index;
		},
		
		byId: function(id) {
			var index = this.getIndex('id');
			return index[id];
		},
		
		getArray: function(key, value) {
			var index = this.getIndex(key);
			return index ? index[value] : null;
		},
		
		get: function(key, value) {
			var index = this.getIndex(key);
			var val = index[value];
			return (val && val.length > 0) ? val[0] : null;
		}
	});
});
},
'appivo/util/AsyncDebounce':function(){
define([], function(_) {

    function createDebounced(func, timeout) {
        if (timeout == undefined) {
            timeout = 250;
        }
        return function() {
            var args = arguments;
            var t = this;
            return new Promise(function (resolve, reject) {
                if (t.timerId) {
                    clearTimeout(t.timerId);
                }
                t.timerId = setTimeout(function () {
                    func.apply(null, args).then(resolve, reject);
                }, timeout);
            });
        }
    }

    return createDebounced;
});
},
'appivo/model/RecordSet':function(){
/**
 * A set of records.
 * @interface RecordSet
 */
define(['appivo/util/ExpressionParser'], function(ExpressionParser) {

    var TMP_PREFIX = "tmp";

    function createSets(sets, name, data) {
        var newSets = Object.assign({}, sets);
        newSets[name] = data;
        return newSets;
    }

    function createIndex(set, key) {
        var index = {};
        var map = {};
        set.forEach(function(row) {
           var val = row[key];
           var list = map[val];
           if (!list) {
               list = [];
               map[val] = list;
           }
           list.push(row);
        });
        index.map = map;
        index.lookup = function(key) {
            var val = undefined;
            var list = map[key];
            if (list && list.length > 0) {
                val = list[0];
            }
            return val;
        };
        index.lookupAll = function(key) {
            return map[key];
        }
        return index;
    }

    function createExpression(rs, filter) {
        var expr = ExpressionParser.parse(filter);
        var resolver = createResolver(rs);
        return function(row, rs) {
            resolver.setRow(row);
            var val = undefined;
            try {
                val = expr.evaluate(resolver.getResolver());
            } catch (err) {
                //console.warn("Failed to evaluate expression", err);
            }
            return val;
        };
    }

    function createResolver(rs) {
        var currentRow = null;

        function resolver(name) {
            var obj = currentRow;
            var value = undefined;
            var parts = name.split(".");
            for (var i = 0; i < parts.length; i++) {
                var name = parts[i];
                var handled = false;
                var idx = name.indexOf("[");
                if (idx !== -1) {
                    var idx2 = name.indexOf("]");
                    if (idx2 !== -1) {
                        var qual = name.substring(idx + 1, idx2);
                        var sep = qual.indexOf(':');
                        if (sep !== -1) {
                            var fk = qual.substring(0, sep);
                            var pk = qual.substring(sep + 1);
                            var setName = name.substring(0, idx);
                            var set = rs.getSet(setName);
                            if (set) {
                                var keyValue = obj[fk];
                                obj = set.find(pk, keyValue);
                            } else {
                                obj = undefined;
                            }
                            handled = true;
                        }
                    }
                }
                if (!handled) {
                    // nosemgrep: prototype-pollution-loop
                    obj = obj[name];
                }
                if (obj === undefined || obj === null) {
                    break;
                }
            }
            value = obj;
            return value;
        };

        return {

            setRow: function(row) {
                currentRow = row;
            },

            getRow: function() {
                return currentRow;
            },

            getResolver: function() {
                return resolver;
            }
        };
    }

    var RecordSet = function(primary, sets, options) {
        this.cnt = 0;
        this.primary = primary;
        if (primary instanceof String && Array.isArray(sets)) {
            var tset = sets;
            sets = {
                primary: tset
            };
        } else if (!sets && Array.isArray(sets)) {
            if (!primary) {
                primary = [];
            }
            sets = {
                primary: primary
            };
            primary = "primary";
        }
        this.sets = sets;
        this.options = options;
        this.set = sets[primary];
        this.qlSets = {};
        this.indices = {};
        for (var name in sets) {
            var set = sets[name];
            var sp = Object.getPrototypeOf(set);
            if (sp === RecordSet.prototype) {
                this.qlSets[name] = set;
            }
        }
    };

    RecordSet.load = function(sets) {
        var list = [];
        var map = {};
        var resolved = {};
        for (var set in sets) {
            var promise = sets[set];
            if (promise && promise.then) {
                map[list.length] = set;
                list.push(promise);
            } else if (promise) {
                resolved[set] = promise;
            }
        }
        return Promises.all(list).then(function(results) {
            results.forEach(function(res, index) {
                var set = map[index];
                resolved[set] = res;
            });
            var rs = new RecordSet(map[0], resolved);
            return rs;
        });
    };

    RecordSet.prototype = {

        /**
         * Gets the name of this set
         * @returns {String}
         */
        getName: function() {
            return this.primary;
        },

        /**
         * Gets a connected RecordSet
         * @param name
         * @returns {RecordSet}
         */
        getSet: function(name) {
            var qls = this.qlSets[name];
            if (!qls) {
                qls = new RecordSet(name, this.sets);
                this.qlSets[name] = qls;
            }
            return qls;
        },

        /**
         * Connects another RecordSet
         * @param {String} name
         * @param {RecordSet} set
         * @returns {RecordSet}
         */
        addSet: function(name, set) {
            if (name && set) {
                var sp = Object.getPrototypeOf(set);
                if (sp === RecordSet.prototype) {
                    this.qlSets[name] = set;
                } else if (Array.isArray(set)) {
                    this.sets[name] = set;
                }
            }
            return this.getSet(name);
        },

        /**
         * Gets an index for this RecordSet
         * @param {String} key Name of attribute to create index for
         * @param {Boolean} nocreate If true, do not create an index of one doesn't exist
         * @returns {*}
         */
        getIndex: function(key, nocreate) {
            var index = this.indices[key];
            if (!index && !nocreate) {
                var index = createIndex(this.set, key);
                this.indices[key] = index;
            }
            return index;
        },

        /**
         * Adds a Record to this set
         * @param row
         */
        add: function(row) {
            this.set.push(row);
        },

        /**
         * Adds a set of Records to this RecordSet
         * @param {Array} rows
         */
        addAll: function(rows) {
            if (Array.isArray(rews)) {
                for (var i = 0; i < rows.length; i++) {
                    this.add(rows[i]);
                }
            } else {
                this.add(rows);
            }
        },

        /**
         * Finds a record with a matching value for the given key
         * @param {String} key
         * @param {*} value
         * @param {Boolean }useIndex
         * @returns {Object}
         */
        find: function(key, value, useIndex) {
            var index = this.getIndex(key, !useIndex);
            var found = undefined;
            if (index) {
                found = index.lookup(value);
            } else {
                for (var i = 0; i < this.set.length; i++) {
                    var row = this.set[i];
                    var val = row[key];
                    if (val == value) {
                        found = row;
                        break;
                    }
                }
            }
            return found;
        },

        /**
         * Merge two RecordSets
         *
         * @param set
         * @returns {RecordSet}
         */
        merge: function(set) {
            var other = this.sets[set];
            var merged = this.set.concat(other);
            var name = TMP_PREFIX + this.cnt++;
            var nsets = createSets(this.sets, name, merged);
            return new RecordSet(name, nsets, this.options);
        },

        /**
         * Pivot
         *
         * @param keys
         * @param aggregations
         * @returns {RecordSet}
         */
        pivot: function(keys, aggregations) {
            if (!Array.isArray((keys))) {
                if (typeof keys === "string") {
                    keys = keys.split(",");
                } else {
                    keys = [keys];
                }
            }
            var result = [];
            var index = {};
            var exprs = [];
            for (var i = 0; i < keys.length; i++) {
                exprs[i] = createExpression(this, keys[i]);
            }
            var defs = {};
            for (var name in aggregations) {
                var aggr = aggregations[name];
                var idx = aggr.indexOf("(");
                if (idx !== -1) {
                    var idx2 = aggr.lastIndexOf(")");
                    if (idx2 === -1) {
                        idx2 = aggr.length;
                    }
                    var func = name.substring(0, idx).toLowerCase();
                    var exprStr = aggr.substring(idx + 1, idx2);
                    var expr = createExpression(this, exprStr);
                    var def = {
                        func: func,
                        expr: expr
                    };
                    defs[name] = def;
                }
            }

            this.set.forEach(function(row) {
                var keyStr = "";
                var irow = {};
                for (var i = 0; i < exprs.length; i++) {
                    var expr = exprs[i];
                    var kv = expr(this, row);
                    var key = keys[i];
                    keyStr += ":" + kv;
                    irow[key] = kv;
                }
                var arow = index[keyStr];
                if (!arow) {
                    arow = irow;
                    index[keyStr] = arow;
                    result.push(arow);
                }
                for (var name in defs) {
                    var def = defs[name];
                    var evalue = arow[name];
                    var val = def.expr(row, this);
                    switch (def.func) {
                        case "sum":
                            if (evalue === undefined) {
                                evalue = 0;
                            }
                            if (!isNaN(val)) {
                                evalue += val;
                            }
                            break;
                        case "count":
                            if (evalue === undefined) {
                                evalue = 0;
                            }
                            if (val !== undefined) {
                                evalue++;
                            }
                            break;
                        case "avg":
                            break;
                        case "min":
                            break;
                        case "max":
                            break;
                        case "concat":
                            if (evalue === undefined) {
                                evalue = "";
                            }
                            evalue += val;
                            break;
                    }
                    arow[name] = evalue;
                }
            });

            var name = TMP_PREFIX + this.cnt++;
            var nsets = createSets(this.sets, name, result);
            return new RecordSet(name, nsets, this.options);
        },

        /**
         * Filter this RecordSet and return a new filtered RecordSet
         * @param filter
         * @returns {RecordSet}
         */
        filter: function(filter) {
            var filtered = [];
            if (typeof filter === "string") {
                filter = createExpression(this, filter);
            }
            this.set.forEach(function(row) {
                if (filter(row, this)) {
                    filtered.push(row);
                }
            });
            var name = TMP_PREFIX + this.cnt++;
            var nsets = createSets(this.sets, name, filtered);
            return new RecordSet(name, nsets, this.options);
        },

        /**
         * Sort this RecordSet and return a new sorted RecordSet
         * @param comparator
         * @returns {RecordSet}
         */
        sort: function(comparator) {
            var sorted = this.set.concat();
            sorted.sort(comparator);
            var name = TMP_PREFIX + this.cnt++;
            var nsets = createSets(this.sets, name, sorted);
            return new RecordSet(name, nsets, this.options);
        },

        /**
         * Select data from this RecordSet and return the results as a new RecordSet
         *
         * @param {Object} transform
         * @returns {RecordSet}
         */
        select: function(transform) {
            var rows = [];
            for (var key in transform) {
                var def = transform[key];
                if (typeof def === "string") {
                    var expr = createExpression(this, def);
                    transform[key] = expr;
                }
            }
            this.set.forEach(function(row) {
                var nrow = {};
                for (var key in transform) {
                    var def = transform[key];
                    var val = def(row, this);
                    if (val !== undefined) {
                        nrow[key] = val;
                    }
                }
                rows.push(nrow);
            });
            var name = TMP_PREFIX + this.cnt++;
            var nsets = createSets(this.sets, name, rows);
            return new RecordSet(name, nsets, this.options);
        },

        /**
         * Iterate over the records in this RecordSet and invoke the provided function for each
         * @param {Function} function
         */
        forEach: function(func) {
            this.set.forEach(func);
        },

        /**
         * Gets the number of records in this RecordSet
         * @returns {Number}
         */
        size: function() {
            return this.set.length;
        },

        [Symbol.iterator]: function() {
            var set = this.set;
            var index = 0;
            return {
                next: function() {
                    var hasMore = index < set.length;
                    var next = {
                        done: true
                    };
                    if (hasMore) {
                        next.done = false;
                        next.value = set[index++];
                    }
                    return next;
                }
            }
        },

        /**
         * Returns an Array representing all the records in this RecordSet
         * @returns {*}
         */
        toArray: function() {
            return this.set;
        }
    };

    return RecordSet;
});
},
'appivo/store/RecordStoreMixin':function(){
define([
        'dojo/_base/lang',
        'dojo/when',
        'dojo/Deferred',
        'appivo/util/Point',
        'appivo/util/Identity',
        'dojo/store/util/QueryResults'
 ], function(lang, when, Deferred, Point, Identity, QueryResults) {

	var RecordStore = function(store, model, disabled, isNew, autoId) {
			
		if (store.__recordStore) {
			return store;
		}
			
		var auto = autoId;
		var orgStore = store;

		store = lang.delegate(store);
		store.__recordStore = true;

		store.getModel = function() {
			return model;
		};

		store.getParentStore = function() {
			return orgStore.getParent ? orgStore.getParent() : orgStore;
		};
				
		var orgGet = store.get;
		
		store.setEnabled = function(enabled) {
			orgStore.setEnabled(enabled);
		};
		
		store.setGenerateIds = function(gen) {
			auto = gen;
		};
		
		store.setStorageMode = function(mode) {
			if (orgStore.setStorageMode) {
				orgStore.setStorageMode(mode);
			}
		};

		store.getStorageMode = function() {
			if (orgStore.getStorageMode) {
				orgStore.getStorageMode();
			}
		};

		store.get = function() {
			var def = new Deferred();
			var s = this;
			var data = orgGet.apply(orgStore, arguments);
			when(data, function(item) {
				if (item) {
					item.__new = false;
					def.resolve(model.createRecord(item, s));					
				} else {
					def.resolve(null);
				}
			});
			return def;
		};
		
		var orgPut = store.put;
		
		store.put = function(item) {
			/*
			if (item.declaredClass != "appivo.model.Record") {
				item = model.createRecord(item, this);
			} else {
				item.setStore(this);				
			}
			*/
			var def = orgPut.apply(orgStore, arguments);
			if (!lang.isFunction(def.then)) {
				def = new Deferred();
				def.resolve(item);
			}
			return def;
		};
		
		store.add = function(object, options){
			(options = options || {}).overwrite = false;
			return store.put(object, options);
		};
		
		var orgQuery = store.query;
		
		store.query = function(query) {
			var result = null;
			if (!isNew) {
				console.log("Fetching results from server for query ");
				result = orgQuery.apply(orgStore, arguments);
			} else {
				console.log("Returning synthetic empty result for query");
				result = new QueryResults([]);
			}
			var s = this;
			var isPromise = !!result.then;
			var ret = null;
			
			var convert = function(resultsArray) {
				if (resultsArray) {
					for (var i = 0; i < resultsArray.length; i++) {
						var item = resultsArray[i];
						if (model) {
							if (auto && !item.id) {
								item.id = i;
							}
							item.__query = query;
							item.__new = false;
							var record = item;
							if (item.__model !== model) {
								record = model.createRecord(item, s);
							}
							resultsArray[i] = record;						
						}
					}									
				} else {
					resultsArray = [];
				}
				return resultsArray;
			};

			if (isPromise) {
				var def = new Deferred();
				var qr = new QueryResults(def);
				when(result, function(resultsArray) {
					resultsArray = convert(resultsArray);
					def.resolve(resultsArray);
				}, function(err) {
					def.reject(err);
				});
				ret = qr;
			} else {
				convert(result);
				ret = result;
			}

			return ret;
		};	
		
		var orgSet = store.setData;
		if (orgSet) {
			store.setData = function (items) {
				for (var i = 0; i < items.length; i++) {
					items[i] = model.createRecord(items[i], this);
				}
				return orgSet.apply(orgStore, arguments);
			};
		}
		
 		store._getTargetId = function(id) {
 			return Identity.isRealId(id) ? id : undefined;
 		},

		store.getLabel = function(item) {
			return model.getLabel(item);
		};
		
		return store;
	};
	
	return RecordStore;
});
},
'appivo/store/PublishingStoreMixin':function(){
define([
        'dojo/_base/lang',
        'dojo/when',
        'dojo/Deferred',
        'dojo/topic'
 ], function(lang, when, Deferred, topic) {

	var PubStore = function(store, topicName, pub, sub) {
	
		if (store.__pubStore) {
			return store;
		}
		
		var orgStore = store;
		
		store = lang.delegate(store);
		
		store.getParentStore = function() {
			return orgStore.getParentStore ? orgStore.getParentStore() : orgStore;
		};
		
		if (sub) {
			var handle = topic.subscribe(topicName, function(event) {
				if  (event.store != store) {
					store.put(event.record);
				}
			});		
			
			store.close = function() {
				handle.remove();
			}
		}
		
		store.__pubStore = true;

		if (pub) {
			var orgPut = store.put;
			store.put = function(record) {
				var s = this;
				var data = orgPut.apply(this, arguments);
				var def = new Deferred();
				data.then(lang.hitch(this, function(rec) {
					topic.publish(topicName, {
						record: rec,
						store: store
					});
					def.resolve(rec);
				}), function(error) {
					def.reject(error);
				});
				return def;
			};			
		}
				
		return store;
	};
	
	return PubStore;
});
},
'appivo/model/SearchIndex':function(){
define([], function() {

    function SearchIndex(opts) {
        if (opts) {
            this.id = opts.id;
            this.ver = opts.ver;
            this.name = opts.name;
            this.type = opts.type;
            this.provider = opts.provider;
            this.data = opts.data;
        }
    }

    SearchIndex.prototype = {

        getId: function() {
            return this.id;
        },

        getName: function() {
            return this.name;
        },

        getType: function() {
            return this.type;
        },

        toJSON: function() {
            let json = {
                id: this.id,
                ver: this.ver,
                name: this.name,
                type: this.type,
                provider: this.provider,
                data: this.data
            };
            return json;
        }
    };

    return SearchIndex;
});
},
'appivo/model/AIAgent':function(){
define([], function() {

    function AIAgent(opts) {
        if (opts) {
            this.id = opts.id;
            this.ver = opts.ver;
            this.name = opts.name;
            this.description = opts.description;
            this.data = opts.data;
        }
    }

    AIAgent.prototype = {

        getId: function() {
            return this.id;
        },

        getName: function() {
            return this.name;
        },

        getDescription: function() {
            return this.description;
        },

        getChain: function() {
            return this.data;
        },

        toJSON: function() {
            let json = {
                id: this.id,
                ver: this.ver,
                name: this.name,
                description: this.description,
                data: this.data
            };
            return json;
        }
    };

    return AIAgent;
});
},
'appivo/model/Param':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'dojo/_base/Deferred',
        'appivo/model/Element'], function(lang, declare, Deferred, Element) {
	
	return declare("appivo.model.Param", [Element], {

		ver: null,
		order: 0,
		label: null,
		description: null,
		category: null,
		required: false,
		type: 'STRING',
		defaultValue: null,
		data: null,
		
		constructor: function() {
			if (this.data && lang.isString(this.data)) {
				this.data = JSON.parse(this.data);
			} else if (this.data && lang.isObject(this.data)) {
				// NOOP
			} else {
				this.data = {};
			}
		},
				
		getLabel: function() {
			return this.label;
		},
		
		getVersion: function() {
			return this.ver;
		},
		
		toJSON: function(options) {
			var json = this.inherited(arguments);
			var paramJson = {
				ver: this.ver,
				order: this.order,
				label: this.label,
				description: this.description,
				category: this.category,
				required: this.required,
				type: this.type,
				defaultValue: this.defaultValue,
				data: JSON.stringify(this.data)
			};
			lang.mixin(json, paramJson);
			return json;
		}
	});		
});
},
'appivo/model/Query':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'dojo/_base/Deferred',
        'appivo/model/Element',
        'appivo/model/Select',
        'appivo/model/From',
        'appivo/model/Where',
        'appivo/model/OrderBy',
        'appivo/model/Criteria',
        'appivo/model/GroupBy',
        'appivo/model/QueryHandle',
        'appivo/model/Status',
        'appivo/util/Identity',
        'appivo/store/RecordStoreMixin'], function(lang, declare, Deferred, Element, Select, From, Where, OrderBy, Criteria, GroupBy, QueryHandle, Status, Identity, RecordStore) {
		
	var clss = declare("appivo.model.Query", [Element], {
	
		ver: 0,
		schema: null,
		name: null,
		type: 'STD',
		query: null,
		select: null,
		from: null,
		joins: null,
		where: null,
		having: null,
		orderBy: null,	
		groupBy: null, 
		parameters: null,
		status: null,
		dynamic: false,
		
		constructor: function(options) {
			this.schema = options.schema;
			var select = null;
			var from = null;
			var where = null;
			var having = null;
			var orderBy = null;
			var groupBy = null;
			var status = null;
			
			if (options.name) {
				this.name = options.name;
			}
			
			if (options.select) {
				if (options.select.declaredClass == 'appivo.model.Select') {
					select = options.select.toJSON();
				} else {
					select = options.select;
				}
			}

			var models = this.schema.getModels();
			var firstModel = models[0].getName();
			
			if (options.from) {
				if (options.from.declaredClass == 'appivo.model.Model') {
					options.from = {
						model: options.from.getName() 	
					};
				}
				if (options.from.declaredClass == 'appivo.model.From') {
					from = options.from.toJSON();
				} else {
					if (options.from.model) {
						from = options.from;						
					} else {
						from = {
							model: firstModel	
						};
					}
				}
			} else {
				var models = this.schema.getModels();
				from = {
					model: firstModel
				};
			}
			if (options.where) {
				if (options.where.declaredClass == 'appivo.model.Where') {
					where = options.where.toJSON();
				} else {
					where = options.where;
				}
			}
			if (options.having) {
				if (options.having.declaredClass == 'appivo.model.Where') {
					having = options.having.toJSON();
				} else {
					having = options.where;
				}
			}
			if (options.orderby) {
				if (lang.isArray(options.orderby)) {
					orderBy = new Array();
					for (var i in options.orderby) {
						var ob = options.orderby[i];
						if (ob.declaredClass == 'appivo.model.OrderBy') {
							ob = ob.toJSON();
						}
						orderBy.push(ob);
					}
				}
			}
			if (options.groupby) {
				if (options.groupby.declaredClass == 'appivo.model.GroupBy') {
					groupBy = options.groupby.toJSON();
				} else {
					groupBy = options.groupby;
				}
			}

			if (options.status) {
				status = options.status;
			}
			
			if (select) {
				this.setSelect(select);
				select = lang.clone(select);
				select.query = this;
				select.schema = this.schema;
				this.select = new Select(select);
			}
			if (from) {
				from = lang.clone(from);
				from.query = this;
				from.schema = this.schema;
				this.from = new From(from);
			}
			if (where) {
				this.setWhere(where);
			}
			if (having) {
				this.setHaving(having);
			}
			if (orderBy) {
				orderBy = lang.clone(orderBy);
				this.orderBy = this._createOrderBy(orderBy);
			}
			if (groupBy) {				
				groupBy = lang.clone(groupBy);
				this.groupBy = this._createGroupBy(groupBy);
			}

			if (status) {
				status = lang.clone (status);
				this.status = new Status (status);
			}
			
			if (options.parameters) {
				this.parameters = lang.clone(options.parameters);
			} else {
				this.parameters = new Array();
			}
		},
		
		setSelect: function(select) {
			select = lang.clone(select);
			select.query = this;
			select.schema = this.schema;
			this.select = new Select(select);			
		},

		setWhere: function(where) {
			if (where.declaredClass == 'appivo.model.Criteria') {
				where = where.toJSON();
			}
			where.schema = this.schema;
			where.query = this;
			this.where = new Where(where);
		},

		setHaving: function(having) {
			if (having) {
				having = having.toJSON ? having.toJSON() : having;
				this.having = new Where(having);
			} else {
				this.having = null;
			}
		},

		setOrderBy: function(orderBy) {
			if (orderBy) {
				orderBy = lang.clone(orderBy);
				this.orderBy = this._createOrderBy(orderBy);						
			}
		},
		
		setGroupBy: function(groupBy) {
			if (groupBy) {
				groupBy = lang.clone(groupBy);
				this.groupBy = this._createGroupBy(groupBy);				
			}
		},
		
		_createOrderBy: function(data) {
			var orderBy = new Array();
			for (var i in data) {
				orderBy.push(new OrderBy(data[i]));
			}
			return orderBy;
		},
		
		_createGroupBy: function(data) {
			return new GroupBy({
				schema: this.schema,
				query: this,
				selectors: data.selectors
			});
		},

		_createWhereNode: function(data) {
			var def = {
				type: data.type,
				schema: this.schema
			};
			
			switch (data.type) {
			case 'EXPR':
				def.lhs = data.lhs;
				def.op = data.op;
				def.rhs = data.rhs;
				break;
			case 'REF':
				def.ref = data.ref;
				break;
			case 'VAL':
				def.val = data.val;
			}
			return new Criteria(def);
		},
		
		setFrom: function(from) {
			if (!from.declaredClass == 'appivo.model.Model') {
				if (lang.iString(from)) {
					from = this.schema.getModel(from);
				}
			}
			var def = {
				schema: this.schema,
				query: this,
				model: from
			};
			this.from = new From(def);
		},

		getURI: function() {
			var base = "/api/app/" + this.schema.getName();
			return this.dynamic ? base + "/query" : base + "/query/" + this.name;
		},
		
		getQueryModel: function() {
			var model = this.from.getFromModel();
			if (this.select) {
				var selectModel = this.select.getSelectModel();
				if (selectModel) {
					model = selectModel;
				}
			}
			return model;
		},

		getSchema: function() {
			return this.schema;
		},
		
		getName: function() {
			return this.name;
		},
		
		getSelect: function() {
			return this.select;
		},
		
		getFrom: function() {
			return this.from;
		},
		
		getJoins: function() {
			return this.joins;
		},

		getWhere: function() {
			return this.where;
		},
		
		getOrderBy: function() {
			return this.orderBy;
		},
		
		getGroupBy: function() {
			return this.groupBy;
		},
		
		getParameters: function() {
			return this.parameters;
		},
		
		setParameters: function(parameters) {
			this.parameters = parameters;
		},
		
		getParameter: function(name) {
			var p = null;
			for (var i in this.parameters) {
				var param = this.parameters[i];
				if (param.name == name) {
					p = param;
					break;
				}
			}
			return p;
		},
		
		getParameterDefault: function(name) {
			var value = null;
			var param = this.getParameter(name);
			if (param) {
				value = param.defaultValue;
			}
			return value;
		},
		
		getResultURI: function() {
			return this.dynamic ? this.getURI() : this.getURI() + '/result/';
		},
		
		getSummaryURI: function() {
			return this.dynamic ? this.getURI() : this.getURI() + '/summary/';			
		},
		
		getStore: function(options) {
			if (!options) {
				options = {};
			}
			var disabled = false;
			if (options) {
				disabled = options.disabled;
			}
			var storageMode = options.storageMode;
			delete options.storageMode;
			var uri = this.getResultURI();
			var storeManager = appivo.store.StoreManager.getInstance();
			var store = storeManager.getStore(uri, undefined, {
				dynamic: this.dynamic,
			}, storageMode);
			store.__query = this;
			store = RecordStore(store, this.getQueryModel(), undefined, undefined, options.autoId);
			store.setEnabled(!disabled);
			store.setTenant(this.schema.getTenant());
			return store;
		},
		
		getSummaryStore: function(options) {
			if (!options) {
				options = {};
			}
			var disabled = false;
			if (options) {
				disabled = options.disabled;
			} 
			var uri = this.getSummaryURI();
			var storeManager = appivo.store.StoreManager.getInstance();
			var store = storeManager.getStore(uri);
			store.__query = this;
			store = RecordStore(store, this.getQueryModel(), undefined, undefined, options.autoId);
			store.setEnabled(!disabled);
			store.setTenant(this.schema.getTenant());
			return store;			
		},
		
		createHandle: function(bootstrapping, options) {
			return this._createHandle('regular', bootstrapping, options);
		},

		createSummaryHandle: function(bootstrapping, options) {
			return this._createHandle('summary', bootstrapping, options);
		},

		_createHandle: function(type, bootstrapping, options) {
			var enabled = true;
			if (bootstrapping != undefined) {
				enabled = !bootstrapping;
			}
			
			var opts = {
				disabled: !enabled,
				autoId: true					
			};
			if (options) {
				lang.mixin(opts, options);
			}
			
			var store = null;
			switch (type) {
			case 'regular':
				store = this.getStore(opts);
				break;
			case 'summary':
				store = this.getSummaryStore(opts);
				break;
			}
	
			return new QueryHandle({
				type: type,
				query: this,
				store: store,
				enabled: enabled
			});
		},
		
		clone: function(id) {
			var json = this.toJSON();
			json.id = id;
			delete json['ver'];
			json.schema = this.schema;
			return new clss(json);
		},
		
		toJSON: function() {
			var json = this.inherited(arguments);
			json.ver = this.ver;
			json.type = this.type;
			json.query = this.query;
			if (this.select) {
				json.select = this.select.toJSON();
			}
			if (this.from) {
				json.from = this.from.toJSON();
			}
			if (this.where) {
				json.where = this.where.toJSON();
			}
			if (this.having) {
				json.having = this.having.toJSON();
			}
			if (this.orderBy) {
				var arr = new Array();
				for (var i in this.orderBy) {
					arr.push(this.orderBy[i].toJSON());
				}
				json.orderby = arr;
			}
			if (this.groupBy) {
				json.groupby = this.groupBy.toJSON();
			}
			if (this.status) {
				json.status = this.status.toJSON();
			}
			json.parameters = lang.clone(this.parameters);
			Identity.cleanItemId(json);
			return json;
		}
	});
	
	return clss;
});
},
'appivo/model/Select':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'dojo/_base/Deferred',
        'appivo/model/Criteria',
        'appivo/model/VirtualModel'], function(lang, declare, Deferred, Criteria, VirtualModel) {
	
	return declare("appivo.model.Select", [], {
		
		query: null,
		schema: null,
		selectors: null,
		distinct: false,
		
		constructor: function(options) {
			lang.mixin(this, options);
			if (this.selectors) {
				for (var i in this.selectors) {
					var args = {
						schema: this.schema	
					};
					lang.mixin(args, this.selectors[i]);
					this.selectors[i] = new Criteria(args);
				}
			}
		},
		
		getQuery: function() {
			return this.query;
		},
		
		getSchema: function() {
			return this.schema;
		},
		
		isDistinct: function() {
			return this.distinct;
		},
		
		getSelectors: function() {
			return this.selectors;
		},

		getSelectModel: function() {
			var model = null;
			if (this.selectors && this.selectors.length > 0) {
				model = new VirtualModel({
				    schema: this.schema,
						getURI: () => {
							return this.query.getURI();
						},
						getRecordURI: () => {
							return this.query.getResultURI();
						},
				});
				model.isNew = false;
				var mainModel = null;
                var no = false;
				var attrs = new Array();
				for (var i in this.selectors) {
					var attr = this.selectors[i].toAttribute();
					attrs.push(attr);
					var m = attr.model;
					if (mainModel == null) {
						mainModel = m;
					} else if (m && mainModel.id != m.id) {
						no =  true;
					}
				}
				model.setAttributes(attrs);
				if (mainModel) {
					var label = mainModel.label;
					if (label && label.indexOf(".") == -1) {
						if (!no || model.getAttribute(label)) {
							model.label = label;
						}
					}
				}
				model.resolve(this.schema);
			}
			return model;
		},
										
		toJSON: function() {
			var selectors = new Array();
			for (var i in this.selectors) {
				selectors.push(this.selectors[i].toJSON());
			}
			var json = {
				distinct: this.distinct,
				selectors: selectors
			};
			return json;
		}
	});
});
},
'appivo/model/Criteria':function(){
/**
 * @interface Criteria
 */
define(['dojo/_base/lang',
        'dojo/_base/declare',
        'dojo/_base/Deferred',
        'appivo/model/Attribute',
        'appivo/model/Element',
        'appivo/util/Identity'], function(lang, declare, Deferred, Attribute, Element, Identity) {
	
	var Criteria = declare("appivo.model.Criteria", [], {
		
		schema: null,
		type: 'EXPR',
		rhs: null,
		op: '=',
		lhs: null,
		val: null,
		alias: null,
		args: null,
		
		constructor: function(options) {
			this.schema = options.schema;
			this.type = options.type;
			this.alias = options.alias;
			this.op = options.op;
			switch (this.type) {
			case 'EXPR':
				if (options.lhs) {
					options.lhs.schema = options.schema;
					this.lhs = new Criteria(options.lhs);
				}
				if (options.rhs) {
					options.rhs.schema = options.schema;
					this.rhs = new Criteria(options.rhs);
				}
				break;
			case 'VAL':
				this.val = options.val;
				break;
			case 'REF':
				this.val = options.val;
				break;
			case 'PARAM':
				this.val = options.val;
				break;
			case 'FUNC':
				this.val = options.val;
				if (options.args) {
					this.args = new Array();
					for (var i in options.args) {
						var arg = {
							schema: this.schema
						};
						lang.mixin(arg, options.args[i]);
						this.args.push(new Criteria(arg));
					}
				}
				break;
			}		
		},
		
		getSchema: function() {
			return this.schema;
		},
				
		getType: function() {
			return this.type;
		},
				
		getValue: function() {
			return this.val;
		},
		
		setValue: function(val) {
			this.val = val;
		},
		
		setType: function(type) {
			this.type = type;
		},

		/**
		 * Gets the left-hand side of this Criteria
		 * @instance
		 * @memberof Criteria
		 */
		getLhs: function() {
			return this.lhs;
		},

		/**
		 * Gets the right-hand side of this Criteria
		 * @instance
		 * @memberof Criteria
		 */
		getRhs: function() {
			return this.rhs;
		},

		/**
		 * Sets the left-hand side of this Criteria
		 * @instance
		 * @memberof Criteria
		 * @param {Object} lhs Left-hand side
		 */
		setLhs: function(lhs) {
			this.lhs = lhs;
		},

		/**
		 * Sets the left-hand side of this Criteria
		 * @instance
		 * @memberof Criteria
		 * @param {Object} rhs Right-hand side
		 */
		setRhs: function(rhs) {
			this.rhs = rhs;
		},

		/**
		 * Sets the operator of this Criteria
		 * @instance
		 * @memberof Criteria
		 * @param {String} op Operator
		 */
		setOperator: function(op) {
			this.op = op;
		},

		/**
		 * Gets the operator of this Criteria
		 * @instance
		 * @memberof Criteria
		 * @returns {String}
		 */
		getOperator: function() {
			return this.op;
		},
		
		getArguments: function() {
			return this.args;
		},
		
		setAlias: function(alias) {
			this.alias = alias;
		},
		
		getAlias: function() {
			return this.alias;
		},
		
		evaluate: function(context, record) {
			var ret = undefined;
			switch (this.type) {
			case 'REF':
				var ref = this.val;
				var idx = ref.indexOf('.');
				if (idx == -1) {
					ret = record[ref];
				}
				break;
			case 'VAL':
				ret = this.val;
				break;
			case 'EXPR':
				var lhsType = this.lhs.toAttribute();
				var rhsType = this.rhs.toAttribute();
				var lhs = this.lhs.evaluate(context, record);
				var rhs = this.rhs.evaluate(context, record);
				switch (this.op) {
				case '=':
					ret = lhs == rhs;
					break;
				case '!=':
					ret = lhs != rhs;
					break;
				case '+':
					ret = lhs + rhs;
					break;
				case '-':
					ret = lhs - rhs;
					break;
				case '*':
					ret = lhs * rhs;
					break;
				case '/':
					ret = lhs / rhs;
					break;
				case 'and':
					ret = lhs && rhs;
					break;
				case 'or':
					ret = lhs || rhs;
					break;
				}
				break;
			case 'FUNC':
				switch (this.val) {
				case 'SUM':
					break;
				}
				break;
			}
			return ret;
		},

		toAttribute: function() {
			var attr = null;
			var type = 'STRING';
			var typeAnnotation = null;
			var typeEnums = null;
			switch (this.type) {
				case 'REF':
				attr = this.schema.resolveReference(this.val);
				break;
				case 'VAL':
				break;
				case 'EXPR':
				switch (this.op) {
					case 'AND':
					case 'OR':
						type = 'BOOLEAN';
					break;
					case '+':
					case '-':
					case '/':
					case '*':
						type = 'INTEGER';
						var lhType = this.lhs.toAttribute().getType();
						var rhType = this.rhs.toAttribute().getType();
						if (lhType == 'FLOAT' || rhType == 'FLOAT') {
							type = 'FLOAT';
						}
					break;
				}
				break;
				case 'FUNC':
				var inherit = false;
				typeAnnotation = this.val;
				switch (this.val) {
					case 'SUM':
					case 'AVG':
					case 'MIN':
					case 'MAX':
						inherit = true;
					break;
					case 'COUNT':
					case 'DISTINCT_COUNT':
					case 'MONTH':
					case 'YEAR':
						type = 'INTEGER';
					break;
					case 'MONTHNAME':
						type = 'STRING';
					break;
				}
				if (inherit) {
					if (this.args && this.args.length > 0) {
						var arg = this.args[0];
						var fattr = arg.toAttribute();
						type = fattr.getType();
						if (type == 'ENUM') {
							typeEnums = fattr.enumValues;
						}
					}
				}
				break;
			}

			if (attr) {
				var json = attr.toJSON();
				json.name = this.alias;
				json.model = attr.model;
				json.localeData = attr.localeData;
				attr = new Attribute(json);
			} else {
				attr = new Attribute({
					type: type,
					typeAnnotation: typeAnnotation,
					name: this.alias,
					enumValues: typeEnums
				});
			}
			return attr;
		},
		
		and: function(expr) {
			return new Criteria({
				type: 'EXPR',
				op: 'AND',
				lhs: this.toJSON(),
				rhs: expr
			});
		},
		
		or: function(expr) {
			return new Criteria({
				type: 'EXPR',
				op: 'OR',
				lhs: this.toJSON(),
				rhs: expr
			});
		},		
		
		toJSON: function() {
			var json = {
				type: this.type,
				alias: this.alias
			};
			switch (this.type) {
			case 'EXPR':
				json.lhs = this.lhs.toJSON();
				json.op = this.op;
				if (this.rhs) {
					json.rhs = this.rhs.toJSON();					
				}
				break;
			case 'VAL':
			case 'REF':
			case 'PARAM':
				json.val = this.val;
				break;
			case 'FUNC':
				json.val = this.val;
				if (this.args) {
					var args = new Array();
					for (var i in this.args) {
						args.push(this.args[i].toJSON());
					}
					json.args = args;
				}
				break;
			}
			return json;
		}
	});
	
	return Criteria;
});
},
'appivo/model/VirtualModel':function(){
define(['dojo/_base/lang',
        'dojo/_base/declare',
        'appivo/model/Model'], function(lang, declare, Model) {

    var VirtualModelClass = declare('appivo.model.VirtualModel', Model, {
        setAttribute: function(attr) {
            var oldName = null;
            for (var name in this.attrIndex) {
                var oldAttr = this.attrIndex[name];
                if (oldAttr.name == attr.name) {
                    oldName = name;
                    break;
                }
            }
            if (oldName != null) {
                delete this.attrIndex[oldName];
            }
            this.attrIndex[attr.name] = attr;
        }
    });

    return VirtualModelClass;
});
},
'appivo/model/From':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'dojo/_base/Deferred',
        'appivo/model/Model',
        'appivo/model/VirtualSchema'], function(lang, declare, Deferred, Model, VirtualSchema) {
	
	var FromModel = declare("appivo.model.SelectModel", [Model], {
		
		from: null,
		
		constructor: function(options) {
			lang.mixin(options);
		},
		
		getRecordURI: function() {
			return this.from.getQuery().getResultURI();
		}
	});

	return declare("appivo.model.From", [], {
		
		query: null,
		schema: null,
		model: null,
		
		constructor: function(options) {
			lang.mixin(this, options);
		},
		
		getQuery: function() {
			return this.query;
		},
		
		getSchema: function() {
			return this.schema;
		},
		
		getFromSchema: function() {
			var vs = new VirtualSchema({
				schemaFilter: [this.model],
				schema: this.schema
			});
			return vs;
		},
		
		getModelName: function() {
			return this.model;
		},
		
		getModel: function() {
			return this.schema.getModel(this.model);
		},
		
		getFromModel: function() {
			var model = this.getModel();
			var modelDef = model.toJSON(true);
			modelDef.from = this;
			var fromModel = new FromModel(modelDef);
			fromModel._localize(model.locale);
			fromModel.resolve(this.schema);
			return fromModel;
		},
						
		toJSON: function() {
			var json = {
				model: this.model
			};
			return json;
		}
	});
});
},
'appivo/model/VirtualSchema':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'dojo/_base/Deferred',
        'appivo/store/Memory'], function(lang, declare, Deferred, Memory) {
	
	var VirtualSchema = declare("appivo.model.VirtualSchema", [], {
		
		schema: null,
		schemaFilter: null,
		models: null,
		modelIndex: null,
		modelStore: null,
		
		constructor: function(options) {
			lang.mixin(this, options);
			this.modelIndex = {};
			var modelArray = new Array();
			if (this.schema) {
				if (this.schemaFilter) {
					for (var i in this.schemaFilter) {
						var name = this.schemaFilter[i];
						this.modelIndex[name] = this.schema.getModel(name);
						modelArray.push(this.modelIndex[name]);
					}
				}
			} else if (this.models) {
				for (var i in this.models) {
					var model = this.models[i];
					var mdl = model.model.clone();
					mdl.name = model.name;
					this.modelIndex[model.name] = mdl;
					modelArray.push(mdl);
				}
			}
			this.modelStore = new Memory({
				data: modelArray
			});
		},
		
		getModel: function(name) {
			return this.modelIndex[name];
		},
		
		getModels: function() {
			return this.modelStore.query();
		}
	});
	
	return VirtualSchema
});
},
'appivo/model/Where':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'dojo/_base/Deferred',
        'appivo/model/Model',
        'appivo/model/Criteria',
        'appivo/model/VirtualSchema'], function(lang, declare, Deferred, Model, Criteria, VirtualSchema) {
	
	return declare("appivo.model.Where", [], {
		
		query: null,
		schema: null,
		criteria: null,
		
		constructor: function(options) {
			lang.mixin(this, options);
			if (this.criteria) {
				var args = {
					schema: this.schema
				};
				lang.mixin(args, this.criteria);
				this.criteria = new Criteria(args);
			}
		},
		
		getQuery: function() {
			return this.query;
		},
		
		getSchema: function() {
			return this.schema;
		},
		
		getCriteria: function() {
			return this.criteria;
		},
								
		toJSON: function() {
			var json = {
			};
			if (this.criteria) {
				json.criteria = this.criteria.toJSON();
			}
			return json;
		}
	});
});
},
'appivo/model/OrderBy':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare'], function(lang, declare) {
	
	return declare("appivo.model.OrderBy", [], {
		
		query: null,
		schema: null,
		path: null,
		direction: 'ASC',
		
		constructor: function(options) {
			lang.mixin(this, options);
		},
		
		getQuery: function() {
			return this.query;
		},
		
		getSchema: function() {
			return this.schema;
		},
		
		getPath: function() {
			return this.path;
		},
		
		getDirection: function() {
			return this.direction;
		},
						
		toJSON: function() {
			var json = {
				path: this.path,
				direction: this.direction
			};
			return json;
		}
	});
});
},
'appivo/model/GroupBy':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'dojo/_base/Deferred',
        'appivo/model/Criteria'], function(lang, declare, Deferred, Criteria) {
	
	return declare("appivo.model.GroupBy", [], {
		
		query: null,
		schema: null,
		selectors: null,
		
		constructor: function(options) {
			lang.mixin(this, options);
			if (this.selectors) {
				for (var i in this.selectors) {
					var args = {
						schema: this.schema	
					};
					lang.mixin(args, this.selectors[i]);
					this.selectors[i] = new Criteria(args);
				}
			}
		},
		
		getQuery: function() {
			return this.query;
		},
		
		getSchema: function() {
			return this.schema;
		},
		
		getSelectors: function() {
			return this.selectors;
		},
								
		toJSON: function() {
			var selectors = new Array();
			for (var i in this.selectors) {
				selectors.push(this.selectors[i].toJSON());
			}
			var json = {
				selectors: selectors
			};
			return json;
		}
	});
});
},
'appivo/model/Status':function(){
define(['dojo/_base/lang',
        'dojo/_base/declare'
], function(lang, declare) {

	return declare("appivo.model.Status", [], {
		status: null,
		statusMessage: null,
		constructor: function (options) {
            lang.mixin (this, options);
        },
        getStatus: function() {
            return this.status;
        },
        getStatusMessage: function() {
            return this.statusMessage;
        },
        toJSON: function() {
            var json =  {
                status: this.status,
                statusMessage: this.statusMessage
            };
            return json;
        }
	});
});
},
'appivo/model/Rule':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'dojo/_base/Deferred',
        'appivo/model/Element',
        'appivo/model/SchemaManager',
        'appivo/model/Criteria',
        'appivo/util/Identity'], function(lang, declare, Deferred, Element, Identity, Criteria) {
	return declare("appivo.model.Rule", [Element], {

		ver: 0,
		pre: false,
		type: 'DATA',
		event: 'Create',
		model: null,
		data: null,
		trigger: null,
		actions: null,
		schema: null,
		
		constructor: function(options) {
			lang.mixin(this, options);
			if (this.actions == null) {
				this.actions = new Array();				
			}
			
			// Temporary - fix potentially messed up rules
			var alist = new Array();
			for (var i = 0; i < this.actions.length; i++) {
				var action = this.actions[i];
				if (alist.indexOf(action) == -1) {
					alist.push(action);
				}
			}
			this.actions = alist;
			
			switch (this.type) {
			case 'DATA':
				this.initDataRule();
				break;
			case 'REST':
				this.initRESTRule();
				break;
			case 'SCHEDULED':
				this.initScheduledRule();
				break;
			case 'MESSAGE':
			    this.initMessageRule();
			    break;
			case 'MAIL':
			    this.initMailRule();
			    break;
			}
		},
		
		initDataRule: function() {
			if (this.data && this.data.trigger) {
				var def = this.data.trigger;
				def.schema = this.schema;
				this.trigger = new Criteria(def);
			}			
		},
		
		initScheduledRule: function() {
			if (this.data && this.data.schedule) {
				this.schedule = this.data.schedule;
			}
		},
		
		initRESTRule: function() {
			if (this.data && this.data.method) {
				this.method = this.data.method;
				this.endpoint = this.data.endpoint;
				this.public = this.data.public;
			}
		},

		initMessageRule: function() {
		    if (this.data && this.data.topic) {
		        this.topic = this.data.topic;
		    }
		},

		initMailRule: function() {
		    if (this.data && this.data.key) {
		        this.key = this.data.key;
		    }
		},
		
		addAction: function(action) {
			if (this.actions.indexOf(action) == -1) {
				this.actions.push(action);								
			}
		},
		
		removeAction: function(action) {
			if (!lang.isString(action)) {
				action = action.id;
			}
			for (var i in this.actions) {
				if (this.actions[i] == action) {
					this.actions.splice(i, 1);
					break;
				}
			}
		},
		
		getType: function() {
			return this.type;
		},
		
		getActions: function() {
			return this.actions;
		},
		
		resolve: function(schema) {
			for (var i in this.actions) {
				var actionName = this.actions[i];
				var action = schema.getActionByName(actionName);
				this.actions[i] = action;
			}
		},
		
		serializeDataRule: function(json) {
			json.event = this.event;
			json.pre = this.pre;
			json.model = this.model;
			if (this.trigger) {
				json.data = {
					trigger: this.trigger.toJSON()
				};
			}
		},
		
		serializeScheduledRule: function(json) {
			json.data = {
				schedule: this.schedule	
			};
		},
		
		serializeRESTRule: function(json) {
			json.data = {
				method: this.method,
				endpoint: this.endpoint,
				public: this.public
			};
		},

		serializeMessageRule: function(json) {
		    json.data = {
		        topic: this.topic
		    };
		},

		serializeMailRule: function(json) {
		    json.data = {
		        key: this.key
		    };
		},
		
		toJSON: function() {
			var json = this.inherited(arguments);
			json.ver = this.ver;
			json.type = this.type;
			var actionNames = new Array();
			for (var i in this.actions) {
				actionNames.push(this.actions[i].getName());
			}	
			actionNames = this._removeDuplicates(actionNames);
			json.actions = actionNames;
			
			switch (this.type) {
			case 'DATA':
				this.serializeDataRule(json);
				break;
			case 'REST':
				this.serializeRESTRule(json);
				break;
			case 'SCHEDULED':
				this.serializeScheduledRule(json);
				break;
			case 'MESSAGE':
			    this.serializeMessageRule(json);
			    break;
			case 'MAIL':
			    this.serializeMailRule(json);
			    break;
			}
			return json;
		}	
	});
});

},
'appivo/model/SchemaManager':function(){
define(['dojo/_base/lang',
        'dojo/_base/declare',
        'dojo/_base/Deferred',
        'dojo/Evented',
        'appivo/model/Model',
        'appivo/model/Schema',
        'appivo/client/Client',
        'appivo/util/Identity',
        'dojo/text!../util/LocaleOptions.json'], function(lang, declare, Deferred, Evented, Model, Schema, Client, Identity, localeOptions) {

	localeOptions = JSON.parse(localeOptions);
	var client = Client.getInstance();

	var clss = declare("appivo.model.SchemaManager", [Evented], {

		uri: null,
		store: null,
		tenantId: null,
		storeManager: null,

		constructor: function(options) {
			declare.safeMixin(this, options);
			this.models = new Array();
			this.uri = '/api/app/';
			this.storeManager = appivo.store.StoreManager.getInstance();
			this.store = this.storeManager.getStore(this.uri);
		},
		
		subscribe: function(name, subscription) {
			var def = null;
			if (subscription.id) {
				def = this.updateSubscription(name, subscription);
			} else {
				def = client.sendRequest(client.getURI('/api/app/' + name + '/subscription'), {
					method: 'POST',
					data: JSON.stringify(subscription),
					handleAs: 'json',
					headers: {
						"Content-Type": "application/json"
					}
				});
			}
			return def;
		},
		
		updateSubscription: function(name, subscription) {
			return client.sendRequest(client.getURI('/api/app/' + name + '/subscription'), {
				method: 'PUT',
				handleAs: 'json',
				data: JSON.stringify(subscription),
				headers: {
					"Content-Type": "application/json"
				}
			});
		},
		
		getSubscription: function(name) {
			return client.sendRequest(client.getURI('/api/app/' + name + '/subscription'), {
				method: 'GET',
				handleAs: 'json'
			});
		},

		getLicense: function(name) {
		    return client.sendRequest(client.getURI('/api/app/' + name + '/license'), {
		    	method: 'GET',
		        handleAs: 'json'
		    });
		},

		unsubscribe: function(name) {
			var def = new Deferred();
	       	client.sendRequest(client.getURI('/api/app/' + name + '/subscription'), {
	       		method: 'DELETE',
	    		handleAs: 'json',
	    		headers: {
	    			"Content-Type": "application/json"
	    		}
	    	}).then(function() {
	    		def.resolve(true);
	    	}, function(error) {
	    		def.reject(error);
	    	});
	       	return def;
		},
		
		getExtendableSchemas: function() {
			return client.sendRequest('/api/app/?extendable=true', {
				method: 'GET',
				handleAs: 'json',
				headers: {
	    			"Content-Type": "application/json"					
				}
			});
		},

		getExportSchemas: function() {
            return client.sendRequest('/api/app/?exportmodels=true', {
            	method: 'GET',
                handleAs: 'json',
                headers: {
                    "Content-Type": "application/json"
                }
            });
        },

		newSchema: function(name) {
			var validLocalesArray = Object.keys(localeOptions);
			var lang = client.getPreferredLanguages().substring(0,2);
			var locale = "en";
			if (lang && validLocalesArray.includes(lang)) {
				locale = lang;
			}
			return new appivo.model.Schema({
				name: name,
				tenantId: client.getTenantId(),
				models: [],
				relations: [],
				searchIndexes: [],
				agents: [],
				actions: [],
				rules: [],
				roles: [],
				queries: [],
				locale: locale,
				locales: [
				   {
					   name: "default",
					   data: {
					        custom: []
					   }
				   }
				],
				features: [],
				integrations: [],
				mobilePlugins: [],
				mobilePrivileges: [],
				whiteLabel: null
			});
		},

		getSchema: function(name, complete, localized, hybrid) {
			var t = this;
			var def = new Deferred();
			var rs = null;
			var headers = {};
			if (complete) {
				headers = {
					'X-Complete' : 'Yes'
				};
			}
			if (localized) {
				headers = {
					'X-Language' : client.getPreferredLanguages()
				};
			}
			if (hybrid) {
				headers['X-Hybrid'] = 'Yes';
			}
			rs = new Deferred();
			var req = client.sendRequest(client.getURI('/api/app/' + name), {
				method: 'GET',
				headers: headers,
				handleAs: 'json'
			});
			req.response.then(function(response) {
				var data = response.data;
				var lang = response.getHeader('X-Language');
				data.selectedLocale = lang;
				var SWController = client.getServiceWorkerController();
				if (SWController) {
					SWController.install(data);
				}
				rs.resolve(data);
			}, function(error) {
				rs.reject(error);
			});
			
			Deferred.when(rs, lang.hitch(this, function(schema) {
				try {
					schema.hybrid = hybrid;
					schema.complete = complete;
					schema.localized = true;
					var rawSchema = JSON.parse(JSON.stringify(schema));
					var sc = new appivo.model.Schema(rawSchema);
					sc.schemaManager = t;
					def.resolve(sc);
				} catch (error) {
					def.reject(error);
				}
			}), lang.hitch(this, function(err) {
				def.reject(err);
			}));				
			return def;
		},

		destroySchema: function(name) {
			var def = new Deferred();
			this.store.remove(name).then(function() {
				def.resolve(true);
			}, function(error) {
				def.reject(error);
			});
			return def;
		},

		saveSchema: function(schema) {
			var t = this;
			var def = new Deferred();
			this.store.put(schema, {
				idCheck: false
			}).then(function(savedSchema) {
				if (!schema.id) {
					t.emit('schemaCreated', {
						name: schema.name
					});
				} else if (schema.id != schema.name) {
					t.emit('schemaRename', {
						name: schema.name,
						oldName: schema.id
					});
				}
				var sc = new appivo.model.Schema(savedSchema);
				sc.schemaManager = t;
				def.resolve(sc);
			}, function(error) {
				def.reject(error);
			});
			return def;
		},

		cloneSchema: function(name, cloneName) {
			var t = this;
			var def = new Deferred();
			client.sendRequest(client.getURI('/api/app/' + name + '/fork'), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				data: {
					type: 'CLONE',
					name: cloneName
				}
			}).then(function() {
				t.emit('schemaForked', {
					source: name,
					name: cloneName
				})
				def.resolve({
					name: cloneName
				});
			}, function(error) {
				def.reject(error);
			});
			return def;
		},

		forkSchema: function(name, forkName, forkDescription) {
			var t = this;
			var def = new Deferred();
			client.sendRequest(client.getURI('/api/app/' + name + '/fork'), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				data: {
					type: 'FORK',
					name: forkName,
					description: forkDescription
				}
			}).then(function() {
				t.emit('schemaForked', {
					source: name,
					name: forkName
				})
				def.resolve({
					name: forkName
				});
			}, function(error) {
				def.reject(error);
			});
			return def;
		},
		
		upmergeSchema: function(name) {
			var t = this;
			var def = new Deferred();
			client.sendRequest(client.getURI('/api/app/' + name + '/upmerge'), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				data: {
				}
			}).then(function() {
				t.emit('schemaMerged', {
					name: name
				})
				def.resolve();
			}, function(error) {
				def.reject(error);
			});
			return def;
		},

		getSchemas: function() {
			return this.store.query({});
		}
	});

	clss.getInstance = function() {
		if (clss._instance == null) {
			clss._instance = new clss();
		}
		return clss._instance;
	};

	return clss;
});

},
'appivo/model/Action':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'dojo/_base/Deferred',
        'appivo/model/Element',
        'appivo/util/Identity'], function(lang, declare, Deferred, Element, Identity) {
	return declare("appivo.model.Action", [Element], {

		type: null,
		ver: 0,
		weight: 100,
		data: null,
		
		constructor: function(options) {
			lang.mixin(this, options);
			if (this.data == null) {
				this.data = {
					to: '',
					subject: '',
					body: '',
					html: false
				};
			} 
		},

		toJSON: function() {
			var json = this.inherited(arguments);
			var data = {
				type : this.type,
				ver: this.ver,
				weight: this.weight,
				data: this.data
			};
			lang.mixin(json, data);
			return json;
		}	
	});
});
},
'appivo/model/Locale':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'dojo/_base/Deferred',
        'appivo/model/Element',
        'appivo/builder/LocaleBuilder'], function(lang, declare, Deferred, Element, LocaleBuilder) {
	
	return declare("appivo.model.Locale", [Element], {

		ver: null,
		name: null,
		data: null,
		displayName: null,
		
		constructor: function(opts) {
			if (opts.name) {
				this.setName(opts.name);
			}
		},
				
		getVersion: function() {
			return this.ver;
		},
		
		getDisplayName: function() {
			return this.displayName;
		},
		
		setName: function(name) {
			this.name = name;
			if (name) {
				this.displayName = LocaleBuilder.getInstance().getLocaleName(name);
			}
		},
		
		toJSON: function(options) {
			var json = this.inherited(arguments);
			var localeJson = {
				ver: this.ver,	
				name: this.name,
				data: this.data
			};
			lang.mixin(json, localeJson);
			return json;
		},
		
		resolve: function(schema) {
		}
	});		
});
},
'appivo/builder/LocaleBuilder':function(){
define([
        'dojo/_base/lang',
        'dojo/_base/declare',
        'dojo/text!../util/LocaleOptions.json'
	], function(lang, declare, localeOptions) {

	var map= JSON.parse(localeOptions);
	
	var clss = declare("appivo.builder.LocaleBuilder", [], {

		getLocaleMap: function() {
			return map;
		},

		getLocaleName: function(code) {
			return map[code];
		},

		getLocaleSelectOptions: function() {
			var opts = new Array();
			var map = this.getLocaleMap();
			if (map != null) {
				for (var i in map) {
					opts.push({
						label: map[i],
						value: i
					})
				};
			}
			return opts;
		}

	});

	clss.getInstance = function() {
		if (clss._instance == null) {
			clss._instance = new clss();
		}
		return clss._instance;
	};

	return clss;
});

},
'appivo/model/Feature':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'dojo/_base/Deferred',
        'appivo/model/Element'], function(lang, declare, Deferred, Element) {
	
	return declare("appivo.model.Feature", [Element], {

		ver: null,
		name: null,
		label: null,
		descr: null,
		locale: null,
		
		constructor: function(opts) {
			if (opts.name) {
				this.setName(opts.name);
			}
		},
				
		getVersion: function() {
			return this.ver;
		},
		
		getLabel: function() {
			return this.label;
		},
		
		getDescription: function() {
			return this.descr;
		},
		
		getLocale: function() {
			return this.locale;
		},
		
		setName: function(name) {
			this.name = name;
		},
		
		setLabel: function(label) {
			this.label = label;
		},
		
		setDescription: function(descr) {
			this.descr = descr;
		},
		
		setLocale: function(locale) {
			this.locale = locale;
		},
		
		toJSON: function(options) {
			var json = this.inherited(arguments);
			json.ver = this.ver;
			json.label = this.label;
			json.descr = this.descr;
			json.locale = this.locale;
			return json;
		}
	});		
});
},
'appivo/model/Template':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'dojo/_base/Deferred',
        'appivo/model/Element'], function(lang, declare, Deferred, Element) {
	
	return declare("appivo.model.Template", [Element], {

		ver: null,
		name: null,
		description: null,
		data: null,
		
		constructor: function(opts) {
			if (opts.name) {
				this.setName(opts.name);
			}
		},
				
		getVersion: function() {
			return this.ver;
		},
		
		getDescription: function() {
			return this.descr;
		},
		
		getContentType: function() {
			return this.contenttype;
		},
		
		setName: function(name) {
			this.name = name;
		},
			
		setDescription: function(descr) {
			this.description = descr;
		},
		
		getData: function() {
			return this.data;
		},
		
		toJSON: function(options) {
			var json = this.inherited(arguments);
			json.ver = this.ver;
			json.description = this.description;
			json.contenttype = this.contenttype;
			json.data = this.data;
			return json;
		}
	});		
});
},
'appivo/util/StringFormatters':function(){
define([], function() {
	return {
        toUpperCase: function(value) {
        	if (typeof value === "string") {
        		return value.toUpperCase();
        	} else {
        		return value;
        	}
        },
        toLowerCase: function(value) {
        	if (typeof value === "string") {
        		return value.toLowerCase();
        	} else {
        		return value;
        	}
        },
        capitalize: function(value) {
        	if (typeof value === "string") {
        		return value.charAt(0).toUpperCase() + value.slice(1);
        	} else {
        		return value;
        	}
        },
        decapitalize: function(value) {
        	if (typeof value === "string") {
        		return value.charAt(0).toLowerCase() + value.slice(1);
        	} else {
        		return value;
        	}
        }
	};
});
},
'appivo/model/SampleModel':function(){
define(['dojo/_base/lang',
        'dojo/_base/declare',
        'dojo/_base/Deferred',
        'dojo/store/Observable',
        'appivo/store/Memory',
        'appivo/util/Identity',
        'appivo/model/Model',
        'appivo/store/RecordStoreMixin',
        'appivo/store/PublishingStoreMixin',
        'dojo/text!./SampleModel.json'
    ], function(lang, declare, Deferred, Observable, Memory, Identity, Model, RecordStoreMixin, PublishingStoreMixin, SampleModelJSON) {
    var sampleData = JSON.parse(SampleModelJSON);

	var ModelClass = declare("appivo.model.SampleModel", [Model], {
		constructor: function() {
			this.inherited(arguments);
			var store = new Memory({ data : sampleData.records});
			store = Observable(store);
			store = RecordStoreMixin(store, this, false, this.isNew);
			store = PublishingStoreMixin(store, this.getRecordURI(), false, true);

			var tenant = this.schema.getTenant();
			if (tenant) {
				store.setTenant(tenant);
			}
			this.store = store;
		},

        getStore: function(options) {
  			return this.store;
        }
    });

    return ModelClass;
});

},
'appivo/model/Functions':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'dojo/_base/Deferred',
        'appivo/util/Identity'], function(lang, declare, Deferred, Identity) {
	return {

		FUNCTIONS: [
		    {
		    	name: 'SUM',
		    	returnType: 'INTEGER'
		    },
		    {
		    	name: 'AVG',
		    	returnType: 'INTEGER'
		    },		    
		    {
		    	name: 'MIN',
		    	returnType: 'INTEGER'
		    },		    
		    {
		    	name: 'MAX',
		    	returnType: 'INTEGER'
		    },		    
		    {
		    	name: 'COUNT',
		    	returnType: 'INTEGER'
		    },		    
		    {
		    	name: 'DISTINCT_COUNT',
		    	returnType: 'INTEGER'
		    },
			{
				name: 'GROUP_CONCAT',
				returnType: 'STRING'
			},
		    {
		    	name: 'DAYOFWEEK',
		    	returnType: 'INTEGER'
		    },		    
		    {
		    	name: 'DAYOFMONTH',
		    	returnType: 'INTEGER'
		    },		    
		    {
		    	name: 'DAYOFYEAR',
		    	returnType: 'INTEGER'
		    },	
		    {
		    	name: 'HOUR',
		    	returnType: 'INTEGER'	    	
		    },
		    {
		    	name: 'MINUTE',
		    	returnType: 'INTEGER'	    	
		    },
		    {
		    	name: 'SECOND',
		    	returnType: 'INTEGER'	    	
		    },
		    {
		    	name: 'MONTH',
		    	returnType: 'INTEGER'
		    },		    
		    {
		    	name: 'YEAR',
		    	returnType: 'INTEGER'
		    },
		    {
		    	name: 'DATE',
		    	returnType: 'DATE'
		    },
		    {
		    	name: 'MONTHNAME',
		    	returnType: 'STRING'
		    }, 
		    {
		    	name: 'DAYNAME',
		    	returnType: 'STRING'
		    },
		    {
		    	name: 'WEEK',
		    	returnType: 'INTEGER'
		    },
		    {
		    	name: 'WEEKDAY',
		    	returnType: 'INTEGER'
		    },
		    {
		    	name: 'WEEKOFYEAR',
		    	returnType: 'INTEGER'
		    },
		    {
		    	name: 'QUARTER',
		    	returnType: 'INTEGER'
		    }
		],
		
		index: null,

		getFunctionNames: function() {
			var names = new Array();
			for (var i in this.FUNCTIONS) {
				names.push(this.FUNCTIONS[i].name);
			}
			return names;
		},

		_createIndex: function() {
			this.index = {};
			for (var i in this.FUNCTIONS) {
				var func = this.FUNCTIONS[i];
				this.index[func.name] = func;
			}
		},
		
		isFunction: function(name) {
			var f = this.getFunction(name);
			return f != null;
		},

		getFunction: function(name) {
			if (!this.index) {
				this._createIndex();
			}
			return this.index[name];
		}
	};
});
},
'appivo/model/Variables':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'dojo/_base/Deferred',
        'appivo/client/Client',
        'appivo/util/Identity',
        'appivo/mvc/DateFunctions',
        'dojo/i18n!appivo/nls/Variables'], function(lang, declare, Deferred, Client, Identity, DateFunctions, messages) {
	
	var dateFunctions = new DateFunctions();
	
	return {
		
		VARIABLES: [
		            {
		            	id: 'userId',
		            	label: messages.currentUser,
		            	resolve: function() {
		            		return Client.getInstance().getUser().id;
		            	}
		            },
		            {
		            	id: 'currentDate',
		            	label: messages.currentDate,
		            	resolve: function() {
		            		return dateFunctions.getDate();
		            	}
		            },
		            {
		            	id: 'currentDay',
		            	label: messages.currentDay,
		            	resolve: function() {
		            		var d = dateFunctions.getDate();
		            		d.setHours(0,0,0,0);
		            		return d;
		            	}
		            },
		            {
		            	id: 'currentYear',
		            	label: messages.currentYear,
		            	resolve: function() {
		            		return dateFunctions.getYear();
		            	}
		            	
		            },
		            {
		            	id: 'currentMonth',
		            	label: messages.currentMonth,
		            	resolve: function() {
		            		return dateFunctions.getMonth();
		            	}
		            },		  
		            {
		            	id: 'currentDayOfMonth',
		            	label: messages.currentDayOfMonth,
			            resolve: function() {
			            	return dateFunctions.getDayInMonth();
			            }
		            },
		            {
		            	id: 'currentDayOfWeek',
		            	label: messages.currentDayOfWeek,
			            resolve: function() {
			            		return dateFunctions.getDayInWeek();
			            }
		            },
					{
						id: 'currentWeek',
						label: messages.currentWeek,
						resolve: function() {
							return dateFunctions.getWeek();
						}
					},
					{
		            	id: 'currentHour',
		            	label: messages.currentHour,
		            	resolve: function() {
		            		return dateFunctions.getHour();
		            	}
		            },		 
		            {
		            	id: 'currentMin',
		            	label: messages.currentMin,
		            	resolve: function() {
		            		return dateFunctions.getMinute();
		            	}
		            },		 
		            {
		            	id: 'currentSec',
		            	label: messages.currentSec,
		            	resolve: function() {
		            		return dateFunctions.getSecond();
		            	}
		            }
		],
		
		index: null,

		getVARIABLENames: function() {
			var names = new Array();
			for (var i in this.VARIABLES) {
				names.push(this.VARIABLES[i].label);
			}
			return names;
		},

		_createIndex: function() {
			this.index = {};
			for (var i in this.VARIABLES) {
				var func = this.VARIABLES[i];
				this.index[func.id] = func;
			}
		},

		getVariable: function(id) {
			if (!this.index) {
				this._createIndex();
			}
			return this.index[id];
		},
		
		getOptions: function(includeNone) {
			var opts = new Array();
			for (var i = 0; i < this.VARIABLES.length; i++) {
				var v = this.VARIABLES[i];
				opts.push({
					label: v.label,
					value: v.id
				});
			}
			return opts;
		},
		
		getVariables: function() {
			return lang.clone(this.VARIABLES);
		},
		
		resolveVariable: function(name) {
			var value = null;
			var variable = this.getVariable(name);
			if (variable != null) {
				value = variable.resolve();
			}
			return value;
		}
	};
});
},
'appivo/mvc/DateFunctions':function(){
/**
*	@namespace DateFunctions
*/
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'dojo/date/locale',
        'moment-timezone/moment-timezone',
        'appivo/util/Date'], function(lang, declare, locale, moment, ASDate) {
	
	return declare("appivo.mvc.DateFunctions", null, {
		
		_fixDate: function(date) {
			if (!date) {
				date = this.getDate();
			} else if (typeof(date) == 'date' || date instanceof Date) {
				// already a date
				date = new Date(date.valueOf());
			} else if (lang.isString(date)) {
				if(date.indexOf('T')==0){
					date = ASDate.fromTimeStrToDate(date);
				} else {
					date = ASDate.fromStrToDate(date);
				}
			} else {
				date = this.getDate();
			}
			return date;
		},

		/**
		 * @memberof DateFunctions
		 * @param {Date} date - Date to get year from (optional - current date is used if omitted)
		 * @returns {number}
		 * @instance
		 *	@LogicMeta {
		 *     "api":"DateFunctions",
		 *     "returnType":"Number",
		 *     "paramTypes":["String,Date"]
		 * 	}
		 */
		getYear: function(date) {
			date = this._fixDate(date);
			return date.getFullYear();
		},

        /**
		 * @memberof DateFunctions
		 * @param {Date} date - Date to get Month from (optional - current date is used if omitted)
		 * @returns {number}
		 * @instance
        *	@LogicMeta {
        *     "api":"DateFunctions",
        *     "returnType":"Number",
        *     "paramTypes":["String,Date"]
        * 	}
        */
		getMonth: function(date) {
			date = this._fixDate(date);
			return date.getMonth() + 1;
		},

        /**
		 * @memberof DateFunctions
		 * @param {Date} date - Date to get end of month from (optional - current date is used if omitted)
		 * @instance
        *	@LogicMeta {
        *     "api":"DateFunctions",
        *     "returnType":"Date",
        *     "paramTypes":["String,Date"]
        * 	}
        */
		getEndOfMonth: function(date) {
			date = this._fixDate(date);
			return new Date(date.getFullYear(), date.getMonth()+1, 0);
		},

        /**
		 * @memberof DateFunctions
		 * @param {Date} date - Date to get last day in month from (optional - current date is used if omitted)
		 * @instance
        *	@LogicMeta {
        *     "api":"DateFunctions",
        *     "returnType":"Number",
        *     "paramTypes":["String,Date"]
        * 	}
        */
		getLastDayInMonth: function(date) {
			date = this.getEndOfMonth(date);
			return date.getDate();
		},

        /**
		 * @memberof DateFunctions
		 * @param {Date} date - Date to get day from (optional - current date is used if omitted)
		 * @returns {number}
		 * @instance
        *	@LogicMeta {
        *     "api":"DateFunctions",
        *     "returnType":"Number",
        *     "paramTypes":["String,Date"]
        * 	}
        */
		getDayInMonth: function(date) {
			date = this._fixDate(date);
			return date.getDate();
		},

        /**
		 * @memberof DateFunctions
		 * @param {Date} date - Date to get day in week from (optional - current date is used if omitted)
		 * @returns {number}
		 * @instance
        *	@LogicMeta {
        *     "api":"DateFunctions",
        *     "returnType":"Number",
        *     "paramTypes":["String,Date"]
        * 	}
        */
		getDayInWeek: function(date) {
			date = this._fixDate(date);
			var day = date.getDay();
			if (day == 0) {
				day = 6;
			} else {
				day = day - 1;
			}
			return day;
		},

        /**
		 * @memberof DateFunctions
		 * @param {Date} date - Date to get hour from (optional - current date is used if omitted)
		 * @returns {number}
		 * @instance
        *	@LogicMeta {
        *     "api":"DateFunctions",
        *     "returnType":"Number",
        *     "paramTypes":["String,Date"]
        * 	}
        */
		getHour: function(date) {
			date = this._fixDate(date);
			return date.getHours();
		},

        /**
		 * @memberof DateFunctions
		 * @param {Date} date - Date to get hour from (optional - current date is used if omitted)
		 * @returns {number}
		 * @instance
        *	@LogicMeta {
        *     "api":"DateFunctions",
        *     "returnType":"Number",
        *     "paramTypes":["String,Date"]
        * 	}
        */
		getMinute: function(date) {
			date = this._fixDate(date);
			return date.getMinutes();
		},

        /**
		 * @memberof DateFunctions
		 * @param {Date} date - Date to get hour from (optional - current date is used if omitted)
		 * @returns {number}
		 * @instance
        *  @LogicMeta {
        *     "api":"DateFunctions",
        *     "returnType":"Number",
        *     "paramTypes":["String,Date"]
        * 	}
        */
		getSecond: function(date) {
			date = this._fixDate(date);
			return date.getSeconds();
		},

		/**
		 * @memberof DateFunctions
		 * @param {Date} date - Date to use as base when setting the year (optional - current date is used if omitted)
		 * @param {Number} year - year to set
		 * @returns {number}
		 * @instance
		 *  @LogicMeta {
		 *     "api":"DateFunctions",
		 *     "returnType":"Number",
		 *     "paramTypes":["String,Date", "Number"]
		 * 	}
		 */
		setYear: function(date, year) {
			date = this._fixDate();
			var m = moment(date).set('year', year);
			return m.toDate();
		},

		/**
		 * @memberof DateFunctions
		 * @param {Date} date - Date to use as base when setting the month (optional - current date is used if omitted)
		 * @param {Number} month - month to set
		 * @returns {number}
		 * @instance
		 *  @LogicMeta {
		 *     "api":"DateFunctions",
		 *     "returnType":"Number",
		 *     "paramTypes":["String,Date", "Number"]
		 * 	}
		 */
		setMonth: function(date, month) {
			date = this._fixDate(date);
			var m = moment(date).set('month', month);
			return m.toDate();
		},

		/**
		 * @memberof DateFunctions
		 * @param {Date} date - Date to use as base when setting the day of the month (optional - current date is used if omitted)
		 * @param {Number} day - day of month to set
		 * @returns {number}
		 * @instance
		 *  @LogicMeta {
		 *     "api":"DateFunctions",
		 *     "returnType":"Number",
		 *     "paramTypes":["String,Date", "Number"]
		 * 	}
		 */
		setDayInMonth: function(date, day) {
			date = this._fixDate(date);
			var m = moment(date).set('date', day);
			return m.toDate();
		},

		/**
		 * @memberof DateFunctions
		 * @param {Date} date - Date to use as base when setting the hour of the day (optional - current date is used if omitted)
		 * @param {Number} hour - hour to set
		 * @returns {number}
		 * @instance
		 *  @LogicMeta {
		 *     "api":"DateFunctions",
		 *     "returnType":"Number",
		 *     "paramTypes":["String,Date", "Number"]
		 * 	}
		 */
		setHour: function(date, hour) {
			date = this._fixDate(date);
			var m = moment(date).set('hour', hour);
			return m.toDate();
		},

		/**
		 * @memberof DateFunctions
		 * @param {Date} date - Date to use as base when setting the minute of the hour (optional - current date is used if omitted)
		 * @param {Number} minute - minutes to set
		 * @returns {number}
		 * @instance
		 *  @LogicMeta {
		 *     "api":"DateFunctions",
		 *     "returnType":"Number",
		 *     "paramTypes":["String,Date", "Number"]
		 * 	}
		 */
		setMinute: function(date, minute) {
			date = this._fixDate(date);
			var m = moment(date).set('minute', minute);
			return m.toDate();
		},

		/**
		 * @memberof DateFunctions
		 * @param {Date} date - Date to use as base when setting the seconds (optional - current date is used if omitted)
		 * @param {Number} second - seconds to set
		 * @returns {number}
		 * @instance
		 *  @LogicMeta {
		 *     "api":"DateFunctions",
		 *     "returnType":"Number",
		 *     "paramTypes":["String,Date", "Number"]
		 * 	}
		 */
		setSecond: function(date, second) {
			date = this._fixDate(date);
			var m = moment(date).set('second', second);
			return m.toDate();
		},

		/**
		 * @memberof DateFunctions
		 * @param {Date} date - Date to use as base when adding seconds (optional - current date is used if omitted)
		 * @param {Number} seconds - Seconds to add
		 * @returns {number}
		 * @instance
		 *  @LogicMeta {
		 *     "api":"DateFunctions",
		 *     "returnType":"Number",
		 *     "paramTypes":["String,Date", "Number"]
		 * 	}
		 */
		addSeconds: function(date, seconds) {
			date = this._fixDate(date);
			var m = moment(date).add(seconds, 'seconds');
			return m.toDate();
		},

		/**
		 * @memberof DateFunctions
		 * @param {Date} date - Date to use as base when adding minutes (optional - current date is used if omitted)
		 * @param {Number} minutes - minutes to add
		 * @returns {number}
		 * @instance
		 *  @LogicMeta {
		 *     "api":"DateFunctions",
		 *     "returnType":"Number",
		 *     "paramTypes":["String,Date", "Number"]
		 * 	}
		 */
		addMinutes: function(date, minutes) {
			date = this._fixDate(date);
			var m = moment(date).add(minutes, 'minutes');
			return m.toDate();
		},

		/**
		 * @memberof DateFunctions
		 * @param {Date} date - Date to use as base when adding hours (optional - current date is used if omitted)
		 * @param {Number} hours - hours to add
		 * @returns {number}
		 * @instance
		 *  @LogicMeta {
		 *     "api":"DateFunctions",
		 *     "returnType":"Number",
		 *     "paramTypes":["String,Date", "Number"]
		 * 	}
		 */
		addHours: function(date, hours) {
			date = this._fixDate(date);
			var m = moment(date).add(hours, 'hours');
			return m.toDate();
		},

		/**
		 * @memberof DateFunctions
		 * @param {Date} date - Date to use as base when adding days (optional - current date is used if omitted)
		 * @param {Number} days - days to add
		 * @returns {number}
		 * @instance
		 *  @LogicMeta {
		 *     "api":"DateFunctions",
		 *     "returnType":"Number",
		 *     "paramTypes":["String,Date", "Number"]
		 * 	}
		 */
		addDays: function(date, days) {
			date = this._fixDate(date);
			var m = moment(date).add(days, 'days');
			return m.toDate();
		},

		/**
		 * @memberof DateFunctions
		 * @param {Date} date - Date to use as base when adding weeks (optional - current date is used if omitted)
		 * @param {Number} weeks - weeks to add
		 * @returns {number}
		 * @instance
		 *  @LogicMeta {
		 *     "api":"DateFunctions",
		 *     "returnType":"Number",
		 *     "paramTypes":["String,Date", "Number"]
		 * 	}
		 */
		addWeeks: function(date, weeks) {
			date = this._fixDate(date);
			var m = moment(date).add(weeks, 'weeks');
			return m.toDate();
		},

		/**
		 * @memberof DateFunctions
		 * @param {Date} date - Date to use as base when adding months (optional - current date is used if omitted)
		 * @param {Number} months - months to add
		 * @returns {number}
		 * @instance
		 *  @LogicMeta {
		 *     "api":"DateFunctions",
		 *     "returnType":"Number",
		 *     "paramTypes":["String,Date", "Number"]
		 * 	}
		 */
		addMonths: function(date, months) {
			date = this._fixDate(date);
			var m = moment(date).add(months, 'months');
			return m.toDate();
		},

		/**
		 * @memberof DateFunctions
		 * @param {Date} date - Date to use as base when adding years (optional - current date is used if omitted)
		 * @param {Number} year - years to add
		 * @returns {number}
		 * @instance
		 *  @LogicMeta {
		 *     "api":"DateFunctions",
		 *     "returnType":"Number",
		 *     "paramTypes":["String,Date", "Number"]
		 * 	}
		 */
		addYears: function(date, years) {
			date = this._fixDate(date);
			var m = moment(date).add(years, 'years');
			return m.toDate();
		},

		/**
		 * @memberof DateFunctions
		 * @instance
        *	@LogicMeta {
        *     "api":"DateFunctions",
        *     "returnType":"Date"
        * 	}
        */
		getDate: function() {
			return new Date();
		},

        /**
		 * @memberof DateFunctions
		 * @param {Date} date - Date(optional - current date is used if omitted)
		 * @param {String} timezone - String timezone (optional - current timezone is used if omitted)
		 * @instance
         *	@LogicMeta {
         *     "api":"DateFunctions",
         *     "paramTypes":["String,Date","String"],
         *     "returnType":"Date"
         * }
         */
		newDate: function(date, timezone) {
			return ASDate.newDate(date, timezone);
		},

		/**
		 * @memberof DateFunctions
		 * @param {Date} date1 - First date
		 * @param {Date} date2 - Second date
		 * @param {String} unit - The unit of the result can be either ms, s, m, h or d (default is ms)
		 * @instance
		 * @returns {number}
		 *	@LogicMeta {
		 *     "api":"DateFunctions",
		 *     "paramTypes":["String,Date","String,Date", "String"],
		 *     "returnType":"Number"
		 *  }
		 */
		diff: function(date1, date2, unit) {
			date1 = this._fixDate(date1);
			date2 = this._fixDate(date2);
			var delta = date2 - date1;
			if (!unit) {
				unit = "ms";
			}
			switch (unit) {
				case "ms":
					break;
				case "s":
					delta = delta / 1000;
					break;
				case "m":
					delta = delta / (60 * 1000);
					break;
				case "h":
					delta = delta / (60 * 60 * 1000);
					break;
				case "d":
					delta = delta / (24 * 60 * 60 * 1000);
					break;
			}
			return delta;
		},

        /**
		 * @memberof DateFunctions
		 * @param {Date} date - Date to get week from (optional - current date is used if omitted)
		 * @instance
        *	@LogicMeta {
        *     "api":"DateFunctions",
        *     "returnType":"Number",
        *     "paramTypes":["String,Date"]
        * 	}
        */
		getWeek: function(date) {
			var wdate = this._fixDate(date);
			wdate.setHours(0, 0, 0, 0);
			// Thursday in current week decides the year.
			wdate.setDate(wdate.getDate() + 3 - (wdate.getDay() + 6) % 7);
			// January 4 is always in week 1.
			var week1 = new Date(wdate.getFullYear(), 0, 4);
			// Adjust to Thursday in week 1 and count number of weeks from date to week1. 8640000 = milliseconds for 24h
			return 1 + Math.round(((wdate.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
		},

		/**
		 * @memberof DateFunctions
		 * @param {Number} week - Number Week week to get monday for
		 * @param {Number} year - Year year to get monday for
		 * @instance
        *	@LogicMeta {
        *     "api":"DateFunctions",
        *     "returnType":"Date",
        *     "paramTypes":["Number","Number"]
        * 	}
        */
		getMondayFromWeek: function(week, year) {
			var date = null;
			if (!week && !year) {
				date = moment();
			} else {
				if (!year) {
					year = moment().year();
				}
				var date = moment(year + "-01-04");
			}

			var tzOffset = date.utcOffset();
			if (week) {
				date.isoWeek(week);
			}
			var nTzOffset = date.utcOffset();
			if (tzOffset !== nTzOffset) {
				date.utcOffset(tzOffset, true);
			}
			return date.startOf("isoWeek").toDate();
		},

        /**
		 * @memberof DateFunctions
		 * @param {Date} date - Date to get monday of week from (optional - current date is used if omitted)
		 * @instance
        *	@LogicMeta {
        *     "api":"DateFunctions",
        *     "returnType":"Date",
        *     "paramTypes":["String,Date"]
        * 	}
        */
		getLastMondayFromDate: function(date){
            var lmdate = moment(date);
			return lmdate.startOf("isoWeek").toDate();
		},

		/**
		 * @memberof DateFunctions
		 * @param {Number} time - Number of seconds
		 * @instance
		 *	@LogicMeta {
		 *     "api":"DateFunctions",
		 *     "returnType":"String",
		 *     "paramTypes":["Number"]
		 * 	}
		 */
		intToTime: function(time) {
			var hours = Math.floor(time / (60 * 60));
			var rem = time % (60 * 60);
			var min = Math.floor(rem / 60);
			rem = rem % 60;
			var str = hours.toString().padStart(2, "0") + ":" + min.toString().padStart(2, "0") + ":" + rem.toString().padStart(2, "0");
			return str;
		},

		/**
		 * @memberof DateFunctions
		 * @param {String} time - Time string to parse to seconds
		 * @instance
		 *	@LogicMeta {
		 *     "api":"DateFunctions",
		 *     "returnType":"Number",
		 *     "paramTypes":["String"]
		 * 	}
		 */
		timeToInt: function(time) {
			var t = 0;
			if (typeof(time) == "string") {
				time = time.trim();
				if (time.startsWith("T")) {
					time = time.substring(1);
				}
				var parts = time.split(":");
				if (parts.length > 0) {
					t = parseInt(parts[0]) * 60 * 60;
					if (parts.length > 1) {
						t += parseInt(parts[1]) * 60;
						if (parts.length > 2) {
							t += parseInt(parts[2]);
						}
					}
				}
			}
			return t;
		},

		/**
		 * @memberof DateFunctions
		 * @param {Date} date - Date to format (optional - current date is used if omitted)
		 * @param {String} pattern - Dateformat pattern (e.g. "yyyy-MM-dd")
		 * @returns {String}
		 * @instance
		 *	@LogicMeta {
		 *     "api":"DateFunctions",
		 *     "returnType":"String",
		 *     "paramTypes":["String,Date","String"]
		 * 	}
		 */
		format: function(date, pattern) {
			date = this._fixDate(date);
			return moment(date).format(pattern);
		},

		/**
		 * @memberof DateFunctions
		 * @param {Date} str - Date-string
		 * @param {String} pattern - Dateformat pattern (e.g. "yyyy-MM-dd")
		 * @returns {Date}
		 * @instance
		 *	@LogicMeta {
		 *     "api":"DateFunctions",
		 *     "returnType":"String",
		 *     "paramTypes":["String,Date","String"]
		 * 	}
		 */
		parse: function(str, pattern) {
			var date = moment(str, pattern).toDate();
			return date;
		},

        /**
		 * @memberof DateFunctions
		 * @param {Date} date - Date to format (optional - current date is used if omitted)
		 * @param {String} timePattern - Pattern to format time according to
		 * @instance
        *	@LogicMeta {
        *     "api":"DateFunctions",
        *     "returnType":"String",
        *     "paramTypes":["String,Date","String"]
        * 	}
        */
		formatTime: function(date, timePattern) {
		    date = this._fixDate(date);
		    var selector = "time";
		    return locale.format(date, {
                timePattern: timePattern,
                selector: "time"
            });
		},

        /**
		 * @memberof DateFunctions
		 * @instance
		 * @param {Date/String} date - Date to format (optional - current date is used if omitted)
		 * @param {String} datePattern - Date formatting-pattern
		 * @param {String} timePattern - Time formatting-pattern
		 * @returns {String} formatted date
        *	@LogicMeta {
        *     "api":"DateFunctions",
        *     "returnType":"String",
        *     "paramTypes":["String,Date", "String", "String"]
        * 	}
        */
		formatDate: function(date, datePattern, timePattern) {
			date = this._fixDate(date);
			var selector = undefined;
			var formatLength = undefined;
			if (!datePattern && !timePattern) {
				formatLength = "medium";
			}
			switch (datePattern) {
			case 'short':
			case 'medium':
			case 'long':
			case 'full':
				formatLength = datePattern;
				selector = timePattern ? undefined : 'date';
				datePattern = undefined;
				timePattern = undefined;
				break;
			default:
				selector = 'date';
				timePattern = undefined;
				break;
			}

			if (!datePattern && timePattern) {
				selector = 'time';
			}

			if (date === null || date === undefined || date === "") {
				return "";
			} else {
				return locale.format(date, {
					datePattern: datePattern,
					timePattern: timePattern,
					formatLength: formatLength,
					selector: selector
				});
			}
		},

        /**
		 * @memberof DateFunctions
		 * @param {Date/String} date - Date to add days to (optional - if omitted the current date is used)
		 * @param {Number} days - Days to add
		 * @instance
        *	@LogicMeta {
        *     "api":"DateFunctions",
        *     "returnType":"Date",
        *     "paramTypes":["String,Date", "Number"]
        * 	}
        */
		addDaysToDate: function(date, days) {
			date = this._fixDate(date);
			var result = new Date(date);
			result.setDate(date.getDate() + days);
			return result;
		},

        /**
		 * @memberof DateFunctions
		 * @param {Date/String} date - Date to add hours to (optional - if omitted the current date is used)
		 * @param {Number} hours - Hours to add
		 * @instance
		 *	@LogicMeta {
		 *     "api":"DateFunctions",
		 *     "returnType":"Date",
		 *     "paramTypes":["String,Date", "Number"]
		 * 	}
		 */
		addHoursToDate: function(date, hours) {
			date = this._fixDate(date);
			var m = moment(date);
			var ed = m.add(hours, 'hours');
			var result = m.toDate();
			return result;
		},

		/**
		 * @memberof DateFunctions
		 * @param {Date/String} date - Date to add hours to (optional - if omitted the current date is used)
		 * @param {Number} minutes - Hours to add
		 * @instance
		 *	@LogicMeta {
		 *     "api":"DateFunctions",
		 *     "returnType":"Date",
		 *     "paramTypes":["String,Date", "Number"]
		 * 	}
		 */
		addMinutesToDate: function(date, minutes) {
			date = this._fixDate(date);
			var m = moment(date);
			var ed = m.add(minutes, 'minutes');
			var result = m.toDate();
			return result;
		},

        /**
		 * @memberof DateFunctions
		 * @param {Date/String} date - Date to get midnight for (optional - if omitted the current date is used)
		 * @instance
        *	@LogicMeta {
        *     "api":"DateFunctions",
        *     "returnType":"Date",
        *     "paramTypes":["String,Date"]
        * 	}
        */
		toMidnight: function(date) {
			date = this._fixDate(date);
			date.setHours(0,0,0,0);
			return date;
		}
	});
});

},
'appivo/mvc/ActionEngine':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'dojo/_base/Deferred',
        'appivo/ui/Alertify',
        'stacktrace/error-stack-parser',
        'dojo/string',
        'dojo/i18n!../nls/ActionEngine',
        'dojo/text!./html/ScriptErrorDialog.html'], function(lang, declare, Deferred, Alertify, ErrorStackParser, string, messages, errorTemplate) {
	return declare("appivo.mvc.ActionEngine", null, {

		actions: null,
		context: null,
		view: null,
		_nextId: 0,
		started: null,
		stack: null,

		constructor: function(options) {
			declare.safeMixin(this, options);
			this.actions = new Array();
			this.started = new Deferred();
			this.stack = new Array();
			if (this.context) {
				this.context.engine = this;
			}
		},

		setContext: function(context) {
			this.context = context;
			context.engine = this;
		},

		defineAction: function(code, event, widget) {
		    try {
				var id = this._generateId();
				var action = {
					actionId: id,
					event: event
				};
				if (code && typeof code == "string") {
				    console.warn("Event should be object, not string", code);
				    code = {
				        script: {
				            script: code
				        }
				    };
				}
				if (code && typeof code.script == "string") {
				    console.warn("Event script should be object containing script", code);
				    code = {
                        script: {
                            script: code.script
                        }
                    };
				}
				if (code && code.script) {
					var js = code.script;
					action.script = js.script;
					action.compiled = lang.isFunction(js.script) ? js.script : this._compile(js.script, widget, event);
				} else if (typeof code === "function") {
					action.script = code.toString();
					action.compiled = code;
				}
				this.actions[id] = action;				
			} catch (error) {
				console.error("Failed to compile script");
				console.error(error);
				console.error("Script: ");
				console.error(script);
			}
			return id;
		},
		
		getContext: function() {
			return this.context;
		},
		
		start: function() {
			this.started.resolve(true);
		},

		executeAction: function(peer, actionId, event) {
			var t = this;
		    var action = this.actions[actionId];
			var schema = this.context.getSchema();
			if (action != null) {
				if (action.compiled) {
					var func = lang.hitch(peer, action.compiled);
					try {
						var widgets = this.view.getWidgetPeerRegistry();
						var forms = this.view.getFormRegistry();
						var scope = 'CommonView';
						if (peer && peer.widget) {
							scope = peer.widget;
						}
						this.started.then(function() {
							t.pushFrame({
								scope: scope,
								action: actionId,
								event: action.event
							});
							try {
								StyleManager.setTemp(true);
								StyleManager.setView(t.view.id);
								func(t.context, widgets, forms, event);
							} catch (error) {
								try {
									t.logError(error);
								} finally {
									t._errorDialog(action.script, error);									
								}
							} finally {
								StyleManager.setTemp(false);
								StyleManager.setView(null);
								t.popFrame();
							}
						});
					} catch (error) {
						this._errorDialog(action.script, error);
						console.error("Error executing script");
						console.error(error);
					}
				} else {
					// Fail !
				}
			}
		},
		
		logError: function(error) {
			var t = this;
			try {
				var schema = this.context.getSchema();
				var frame = t.peekFrame();
				var desc = 'unknown';
				if (frame) {
					if (frame.scope && frame.scope.getScopeDescriptor) {
						desc = frame.scope.getScopeDescriptor();											
					} else {
						desc = frame.scope;
					}
				}
				var stacktrace = ErrorStackParser.parse(error);
				var line = 0;
				var col = 0;
				let entry_id = frame.event;
				let entry_name = desc;
				let scopeParts = desc ? desc.split("/") : [];
				if (stacktrace && stacktrace.length > 0) {
					for (var i = 0; i < stacktrace.length; i++) {
						var trace = stacktrace[i];
						if (trace.fileName.startsWith("appivo://")) {
							let file = trace.fileName.substring(9);
							if (file.startsWith("functions/")) {
								entry_name = scopeParts[0] + "/" + scopeParts[1];
								entry_id = "function/" + file.substring(10);
							} else {
								let parts = trace.fileName.substring(9).split("/");
								entry_id = parts[parts.length - 1];
								if (parts[2] && parts[2].startsWith("appivo_ui")) {
									parts[2] = parts[2].substring(10);
								}
								entry_name = scopeParts[0] + "/" + parts[1] + "/" + parts[2];
							}
							if (entry_id.endsWith(".js")) {
								entry_id = entry_id.substring(0, entry_id.length - 3);
							}
							line = trace.lineNumber - 2;
							col = trace.columnNumber;
							break;
						}
					}
				}
				console.error("Error executing script: " + desc);
				console.error(error);	
				schema.logEntry({
					level: 'ERROR',
					message: error.message,
					entry_type: 'UI',
					entry_name: entry_name,
					entry_id: entry_id,
					line: line,
					column: col
				});		
			} catch (logerror) {
				console.error(logerror);
			}
		},
		
		pushFrame: function(frame) {
			this.stack.push(frame);
		},
		
		popFrame: function() {
			return this.stack.pop();
		},
		
		peekFrame: function() {
			return this.stack[this.stack.length-1];
		},
		
		_errorDialog: function(script, error) {
			if (error && error.error) {
				error = error.error;
			}
			var ctx = {
				script: script,
				error: error,
				messages: messages
			};
			
			var content = string.substitute(errorTemplate, ctx);

		    Alertify.alert(messages.scriptError, content);
		},

		_generateId: function() {
			var ret = this._nextId;
			this._nextId = this._nextId + 1;
			return ret;
		},

		_createComment: function(view, widget, event) {
			let link = "\n//# sourceURL=appivo://" + view.schema.name + "/" + view.id + "/" + widget.id + "/" + event + ".js";
			return link;
		},

		_compile: function(script, widget, event) {
			try {
				return new Function("return function exec(context, widgets, forms, event) {" +  script + "\n}" + this._createComment(this.view, widget, event))();
			} catch (e) {
				var opts = {
					message: messages.failedToCompile + ' : ' + e.message
				};

				return function(context, widgets, forms, event) {
					context.log("ERROR", "Failed to compile script: " + e.message);
					context.alert(opts);
				};
			}
		},

		destroy: function() {
			this.actions.length = 0;
		}
	})
});
},
'stacktrace/error-stack-parser':function(){
define(['./stackframe'], function(StackFrame) {
    'use strict';

    var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+:\d+/;
    var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+:\d+|\(native\))/m;
    var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code])?$/;

    return {
        /**
         * Given an Error object, extract the most information from it.
         *
         * @param {Error} error object
         * @return {Array} of StackFrames
         */
        parse: function ErrorStackParser$$parse(error) {
            if (typeof error.stacktrace !== 'undefined' || typeof error['opera#sourceloc'] !== 'undefined') {
                return this.parseOpera(error);
            } else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) {
                return this.parseV8OrIE(error);
            } else if (error.stack) {
                return this.parseFFOrSafari(error);
            } else {
                throw new Error('Cannot parse given Error object');
            }
        },

        // Separate line and column numbers from a string of the form: (URI:Line:Column)
        extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
            // Fail-fast but return locations like "(native)"
            if (urlLike.indexOf(':') === -1) {
                return [urlLike];
            }

            var regExp = /(.+?)(?::(\d+))?(?::(\d+))?$/;
            var parts = regExp.exec(urlLike.replace(/[()]/g, ''));
            return [parts[1], parts[2] || undefined, parts[3] || undefined];
        },

        parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
            var filtered = error.stack.split('\n').filter(function(line) {
                return !!line.match(CHROME_IE_STACK_REGEXP);
            }, this);

            return filtered.map(function(line) {
                if (line.indexOf('(eval ') > -1) {
                    // Throw away eval information until we implement stacktrace.js/stackframe#8
                    line = line.replace(/eval code/g, 'eval').replace(/(\(eval at [^()]*)|(,.*$)/g, '');
                }
                var sanitizedLine = line.replace(/^\s+/, '').replace(/\(eval code/g, '(').replace(/^.*?\s+/, '');

                // capture and preseve the parenthesized location "(/foo/my bar.js:12:87)" in
                // case it has spaces in it, as the string is split on \s+ later on
                var location = sanitizedLine.match(/ (\(.+\)$)/);

                // remove the parenthesized location from the line, if it was matched
                sanitizedLine = location ? sanitizedLine.replace(location[0], '') : sanitizedLine;

                // if a location was matched, pass it to extractLocation() otherwise pass all sanitizedLine
                // because this line doesn't have function name
                var locationParts = this.extractLocation(location ? location[1] : sanitizedLine);
                var functionName = location && sanitizedLine || undefined;
                var fileName = ['eval', '<anonymous>'].indexOf(locationParts[0]) > -1 ? undefined : locationParts[0];

                return new StackFrame({
                    functionName: functionName,
                    fileName: fileName,
                    lineNumber: locationParts[1],
                    columnNumber: locationParts[2],
                    source: line
                });
            }, this);
        },

        parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
            var filtered = error.stack.split('\n').filter(function(line) {
                return !line.match(SAFARI_NATIVE_CODE_REGEXP);
            }, this);

            return filtered.map(function(line) {
                // Throw away eval information until we implement stacktrace.js/stackframe#8
                if (line.indexOf(' > eval') > -1) {
                    line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ':$1');
                }

                if (line.indexOf('@') === -1 && line.indexOf(':') === -1) {
                    // Safari eval frames only have function names and nothing else
                    return new StackFrame({
                        functionName: line
                    });
                } else {
                    var functionNameRegex = /((.*".+"[^@]*)?[^@]*)(?:@)/;
                    var matches = line.match(functionNameRegex);
                    var functionName = matches && matches[1] ? matches[1] : undefined;
                    var locationParts = this.extractLocation(line.replace(functionNameRegex, ''));

                    return new StackFrame({
                        functionName: functionName,
                        fileName: locationParts[0],
                        lineNumber: locationParts[1],
                        columnNumber: locationParts[2],
                        source: line
                    });
                }
            }, this);
        },

        parseOpera: function ErrorStackParser$$parseOpera(e) {
            if (!e.stacktrace || (e.message.indexOf('\n') > -1 &&
                    e.message.split('\n').length > e.stacktrace.split('\n').length)) {
                return this.parseOpera9(e);
            } else if (!e.stack) {
                return this.parseOpera10(e);
            } else {
                return this.parseOpera11(e);
            }
        },

        parseOpera9: function ErrorStackParser$$parseOpera9(e) {
            var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
            var lines = e.message.split('\n');
            var result = [];

            for (var i = 2, len = lines.length; i < len; i += 2) {
                var match = lineRE.exec(lines[i]);
                if (match) {
                    result.push(new StackFrame({
                        fileName: match[2],
                        lineNumber: match[1],
                        source: lines[i]
                    }));
                }
            }

            return result;
        },

        parseOpera10: function ErrorStackParser$$parseOpera10(e) {
            var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
            var lines = e.stacktrace.split('\n');
            var result = [];

            for (var i = 0, len = lines.length; i < len; i += 2) {
                var match = lineRE.exec(lines[i]);
                if (match) {
                    result.push(
                            new StackFrame({
                                functionName: match[3] || undefined,
                                fileName: match[2],
                                lineNumber: match[1],
                                source: lines[i]
                            })
                    );
                }
            }

            return result;
        },

        // Opera 10.65+ Error.stack very similar to FF/Safari
        parseOpera11: function ErrorStackParser$$parseOpera11(error) {
            var filtered = error.stack.split('\n').filter(function(line) {
                return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
            }, this);

            return filtered.map(function(line) {
                var tokens = line.split('@');
                var locationParts = this.extractLocation(tokens.pop());
                var functionCall = (tokens.shift() || '');
                var functionName = functionCall
                        .replace(/<anonymous function(: (\w+))?>/, '$2')
                        .replace(/\([^)]*\)/g, '') || undefined;
                var argsRaw;
                if (functionCall.match(/\(([^)]*)\)/)) {
                    argsRaw = functionCall.replace(/^[^(]+\(([^)]*)\)$/, '$1');
                }
                var args = (argsRaw === undefined || argsRaw === '[arguments not available]') ?
                        undefined : argsRaw.split(',');

                return new StackFrame({
                    functionName: functionName,
                    args: args,
                    fileName: locationParts[0],
                    lineNumber: locationParts[1],
                    columnNumber: locationParts[2],
                    source: line
                });
            }, this);
        }
    };
});
},
'stacktrace/stackframe':function(){
define([], function() {
    'use strict';
    function _isNumber(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }

    function _capitalize(str) {
        return str.charAt(0).toUpperCase() + str.substring(1);
    }

    function _getter(p) {
        return function() {
            return this[p];
        };
    }

    var booleanProps = ['isConstructor', 'isEval', 'isNative', 'isToplevel'];
    var numericProps = ['columnNumber', 'lineNumber'];
    var stringProps = ['fileName', 'functionName', 'source'];
    var arrayProps = ['args'];
    var objectProps = ['evalOrigin'];

    var props = booleanProps.concat(numericProps, stringProps, arrayProps, objectProps);

    function StackFrame(obj) {
        if (!obj) return;
        for (var i = 0; i < props.length; i++) {
            if (obj[props[i]] !== undefined) {
                this['set' + _capitalize(props[i])](obj[props[i]]);
            }
        }
    }

    StackFrame.prototype = {
        getArgs: function() {
            return this.args;
        },
        setArgs: function(v) {
            if (Object.prototype.toString.call(v) !== '[object Array]') {
                throw new TypeError('Args must be an Array');
            }
            this.args = v;
        },

        getEvalOrigin: function() {
            return this.evalOrigin;
        },
        setEvalOrigin: function(v) {
            if (v instanceof StackFrame) {
                this.evalOrigin = v;
            } else if (v instanceof Object) {
                this.evalOrigin = new StackFrame(v);
            } else {
                throw new TypeError('Eval Origin must be an Object or StackFrame');
            }
        },

        toString: function() {
            var fileName = this.getFileName() || '';
            var lineNumber = this.getLineNumber() || '';
            var columnNumber = this.getColumnNumber() || '';
            var functionName = this.getFunctionName() || '';
            if (this.getIsEval()) {
                if (fileName) {
                    return '[eval] (' + fileName + ':' + lineNumber + ':' + columnNumber + ')';
                }
                return '[eval]:' + lineNumber + ':' + columnNumber;
            }
            if (functionName) {
                return functionName + ' (' + fileName + ':' + lineNumber + ':' + columnNumber + ')';
            }
            return fileName + ':' + lineNumber + ':' + columnNumber;
        }
    };

    StackFrame.fromString = function StackFrame$$fromString(str) {
        var argsStartIndex = str.indexOf('(');
        var argsEndIndex = str.lastIndexOf(')');

        var functionName = str.substring(0, argsStartIndex);
        var args = str.substring(argsStartIndex + 1, argsEndIndex).split(',');
        var locationString = str.substring(argsEndIndex + 1);

        if (locationString.indexOf('@') === 0) {
            var parts = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(locationString, '');
            var fileName = parts[1];
            var lineNumber = parts[2];
            var columnNumber = parts[3];
        }

        return new StackFrame({
            functionName: functionName,
            args: args || undefined,
            fileName: fileName,
            lineNumber: lineNumber || undefined,
            columnNumber: columnNumber || undefined
        });
    };

    for (var i = 0; i < booleanProps.length; i++) {
        StackFrame.prototype['get' + _capitalize(booleanProps[i])] = _getter(booleanProps[i]);
        StackFrame.prototype['set' + _capitalize(booleanProps[i])] = (function(p) {
            return function(v) {
                this[p] = Boolean(v);
            };
        })(booleanProps[i]);
    }

    for (var j = 0; j < numericProps.length; j++) {
        StackFrame.prototype['get' + _capitalize(numericProps[j])] = _getter(numericProps[j]);
        StackFrame.prototype['set' + _capitalize(numericProps[j])] = (function(p) {
            return function(v) {
                if (!_isNumber(v)) {
                    throw new TypeError(p + ' must be a Number');
                }
                this[p] = Number(v);
            };
        })(numericProps[j]);
    }

    for (var k = 0; k < stringProps.length; k++) {
        StackFrame.prototype['get' + _capitalize(stringProps[k])] = _getter(stringProps[k]);
        StackFrame.prototype['set' + _capitalize(stringProps[k])] = (function(p) {
            return function(v) {
                this[p] = String(v);
            };
        })(stringProps[k]);
    }

    return StackFrame;
});
},
'appivo/mvc/ActionContext':function(){
/**
 *    The main API for interacting with the app.
 *    @namespace context
 */
define([
    'dojo/_base/lang',
    'dojo/_base/declare',
    'dojo/_base/Deferred',
    'dojo/_base/window',
    'dojo/_base/config',
    'dojo/request/xhr',
    'dojo/dom-construct',
    'dojo/dom-class',
    'dojo/io-query',
    'dojo/string',
    'dojo/when',
    'dojo/on',
    'dojo/promise/all',
    'lodash',
    "jsonpath/jsonpath",
    './Transaction',
    'appivo/client/Client',
    'appivo/client/Bus',
    'appivo/ui/Alertify',
    'appivo/util/Date',
    'appivo/util/Global',
    'appivo/util/GeoLocation',
    'appivo/mvc/TemplateContextFactory',
    'appivo/mvc/DateFunctions',
    'appivo/mvc/DataFunctions',
    'appivo/mvc/StringFunctions',
    'appivo/mvc/PaymentFunctions',
    'appivo/mvc/NumericFunctions',
    'appivo/mvc/GeneralFunctions',
    'appivo/mvc/QueryBuilder',
    'appivo/mvc/integration/ProxyFactory',
    'appivo/model/CalendarEventManager',
    'appivo/ui/Icons',
    'dojo/i18n!../nls/ActionContext',
    'appivo/util/Handlebars',
    'appivo/util/native/Camera',
    'appivo/util/native/BackgroundMode',
    'appivo/util/native/File',
    'appivo/util/Holydays',
    'appivo/util/Identity',
    'appivo/util/CommunicationBus',
    'appivo/model/RecordSet',
    './audio/AudioPlayer',
    './audio/AudioRecorder',
    'sanitize-html/sanitize-html',
    'dojo/i18n!../vue/nls/AlertBox'
], function (lang, declare, Deferred, win, baseConfig, xhr, domConstruct, domClass, ioQuery, string, when, on, allPromises, _, jsonpath, Transaction, Client, Bus, Alertify, ASDate, Global, GeoLocation,
             TemplateContextFactory, DateFunctions, DataFunctions, StringFunctions, PaymentFunctions, NumericFunctions, GeneralFunctions, QueryBuilder, ProxyFactory, CEM, Icons, messages,
             Handlebars, Camera, BackgroundMode, File, Holydays, Identity, CommunicationBus, RecordSet, AudioPlayer, AudioRecorder, sanitizeHtml, alertmsgs) {

    var CONTENT_TYPE = 'Content-Type';
    var ANONYMOUS_ID = "00000000000000000000000000040001";
    var LINKIFY_REGEX =/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
    var dateFunctions = new DateFunctions();
    var paymentFunctions = new PaymentFunctions();
    var numericFunctions = new NumericFunctions();
    var generalFunctions = new GeneralFunctions();

    var client = Client.getInstance();
    var SWController = client.getServiceWorkerController();

    const USER_AGENT = window.navigator.userAgent;
    const IS_IOS = USER_AGENT.match(/iPad/i) || USER_AGENT.match(/iPhone/i);
    const IS_WEBKIT = USER_AGENT.match(/WebKit/i);
    const IS_IOS_SAFARI = IS_IOS && IS_WEBKIT && !USER_AGENT.match(/CriOS/i);

    function makeid(length) {
        let result = '';
        const characters = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < length) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            counter += 1;
        }
        return result;
    }

    function nanoid() {
        return makeid(22);
    }

    function traceid() {
        return nanoid() + ":" + nanoid();
    }

    return declare("appivo.mvc.ActionContext", null, {

        page: null,
        view: null,
        viewManager: null,
        schema: null,
        booting: true,
        config: null,
        strings: null,
        globalData: null,
        features: null,
        timers: null,
        timerName: 0,
        nativeAPI: null,
        audioNodes: null,
        dialogOpening: false,
        handlebars: null,
        syncPromise: null,
        globalRegistry: null,
        subscriptions: null,
        listenerMap: null,
        comBus: null,

        constructor: function (options) {
            declare.safeMixin(this, options);
            this.globalData = {};
            this.listenerMap = {};
            this.config = client.getAppConfig();
            this.strings = this.schema.getStrings();
            this.features = this.schema.getAvailableFeatures();
            this.timers = {};
            this.nativeAPI = this._getNativeAPI();
            this.audioNodes = [];
            this.proxyFactory = new ProxyFactory();
            this.handlebars = Handlebars.getHandlebars(this.schema, undefined, this.viewManager ? this.viewManager.getMetaProperty("handlebars") : 4);
            this.dataFunctions = new DataFunctions(this.schema);
            this.subscriptions = [];
            Handlebars.strings = this.strings;
            Handlebars.context = this;
            var t = this;
            this.comBus = CommunicationBus.createBus({});
            this.bus = {
                /**
                 *    Publish a message to a topic
                 *  @param {String} topic The topic to publish the message to
                 *  @param {Object} message The message to be sent
                 *  @param {Object} opts Options
                 *    @instance
                 *    @memberof MessageBus
                 */
                publish: function (topic, message, opts) {
                    topic = t._prepareTopic(topic, true);
                    Bus.publish(topic, message, opts);
                },

                /**
                 *    Subscribe to a topic
                 *
                 *    @param {String} topic The topic to subscribe to.
                 *    @param {Function} callback The callback-function that will handle the messages received
                 *    @param {Object} opts Options
                 *  @returns {Consumer}
                 *    @instance
                 *    @memberof MessageBus
                 */
                subscribe: function (topic, callback, opts) {
                    topic = t._prepareTopic(topic, false);
                    var handle = Bus.subscribe(topic, callback, opts);
                    t.subscriptions.push(handle);
                    return handle;
                }
            };
        },

        /**
         * Login a user
         * @instance
         * @memberof context
         * @param {Object} opts Options
         * @param {String} opts.username User name
         * @param {String} opts.password Users password
         * @param {String} opts.code Users Two Factor Code
         * @param {Boolean} opts.remember Whether to remember this user
         * @param {Boolean} opts.restricted Only allow logins to the current tenant (defaults to true)
         * @param {Object} opts.path Application-path to navigate to ("app", "ui", "view" and "record" properties can be passed)
         * @returns {Promise}
         */
        login: function (opts) {
            var t = this;
            opts = opts || {};
            var user = this.getUser();
            var tenant = this.getTenantId();
            if (user && user.id === ANONYMOUS_ID) {
                tenant = null;
            }
            if (opts.restricted === false) {
                tenant = undefined;
            }
            var promise = client.login(opts.username, opts.password, opts.code, opts.remember, tenant, opts.path);
            promise.then(function () {
                t.schema.getUserPrivileges().then(function () {
                    // REMIND: Need to re-render view here
                    if (opts.onSuccess) {
                        opts.onSuccess();
                    }
                }, function (error) {
                    if (opts.onError) {
                        opts.onError(error);
                    }
                });
            }, function (error) {
                if (opts.onError) {
                    opts.onError(error);
                }
            });
            return promise;
        },

        /**
         * Logout the user
         * @memberof context
         * @returns {Promise}
         */
        logout: function () {
            return this.page.getPageManager().doLogout();
        },

        /**
         * Issue a password reset for a user
         *
         * @param email Email of user to reset password for
         * @returns {Promise}
         */
        resetPassword: function (email) {
            return client.resetPassword(email);
        },

        /**
         * Create a RecordSet
         *
         * @param {String} primary Name of the primary recordset
         * @param {Object} sets Set of named data-arrays (the recordsets)
         * @returns {RecordSet}
         */
        /**
         * Creates a RecordSet object.
         * 
         * @instance
         * @memberof context
         * @param {String} primary Name of the primary recordset
         * @param {Object} sets Set of named data-arrays (the recordsets)
         * @returns {RecordSet} The created RecordSet object
         * @example
         * // Create a RecordSet with a primary set named "users"
         * const users = [{id: 1, name: "John"}, {id: 2, name: "Jane"}];
         * const recordSet = context.createRecordSet("users", {users: users});
         */
        createRecordSet: function (primary, sets) {
            if (sets === undefined || sets === null) {
                if (!primary) {
                    primary = [];
                }
                sets = {
                    primary: primary
                };
                primary = "primary";
            } else if (primary instanceof String && Array.isArray(sets)) {
                let s = {};
                s[primary] = sets;
                sets = s;
            }
            return new RecordSet(primary, sets);
        },
        
        /**
         * Closes the menu in mobile view.
         * 
         * @instance
         * @memberof context
         * @param {Object} data Additional data to pass to the close menu function
         * @example
         * // Close the mobile menu
         * context.closeMenu();
         */
        closeMenu: function (data) {
            if (this.isMobile()) {
                this.viewManager.closeMenu(data);
            }
        },
        
        /**
         * Toggles the menu in mobile view.
         * 
         * @instance
         * @memberof context
         * @param {Object|String} options Options object or view name
         * @param {String} [side] Side of the menu (if options is a string)
         * @param {Object} [data] Additional data to pass to the toggle menu function
         * @example
         * // Toggle the menu with options
         * context.toggleMenu({view: "mainMenu", location: "left", data: {highlight: true}});
         * // Or toggle the menu with separate parameters
         * context.toggleMenu("mainMenu", "left", {highlight: true});
         */
        toggleMenu: function (options, side, data) {
            if (this.isMobile()) {
                if (typeof options === "object") {
                    this.viewManager.toggleMenu(options.view, options.location, options.data, options.width, options.uiMenu);
                } else {
                    this.viewManager.toggleMenu(options, side, data);
                }
            }
        },
        
        /**
         * Checks if the current user has a specific privilege.
         * 
         * @instance
         * @memberof context
         * @param {Object} options Options for checking privileges
         * @param {String} options.model The model to check privileges for
         * @param {String} options.privilege The specific privilege to check
         * @returns {Promise<boolean>} A promise that resolves to true if the user has the privilege, false otherwise
         * @example
         * // Check if the user has 'read' privilege for the 'User' model
         * context.hasPrivilege({model: "User", privilege: "read"})
         *   .then(hasPrivilege => {
         *     if (hasPrivilege) {
         *       console.log("User has read privilege");
         *     } else {
         *       console.log("User does not have read privilege");
         *     }
         *   });
         */
        hasPrivilege: function (options) {
            var t = this;
            return new Promise(function (resolve, reject) {
                try {
                    var has = t.schema.hasUserPrivileges([{
                        has: true,
                        model: options.model,
                        privilege: options.privilege
                    }]);
                    resolve(has);
                } catch (err) {
                    reject(err);
                }
            });
        },

        _prepareTopic: function (topic, inbound) {
            if (topic.indexOf("#") === 0) {
                topic = 'app.' + this.schema.name + '.topic.' + topic.substring(1);
            } else if (topic.indexOf("<") === 0) {
                var end = topic.indexOf(">");
                if (end > 0) {
                    var model = topic.substring(1, end);
                    var remainder = topic.substring(end + 1);
                    if (remainder) {
                        remainder = remainder.trim();
                    }
                    topic = 'app.' + this.schema.name + '.' + (inbound ? 'in' : 'out') + '.model.' + model;
                    if (remainder) {
                        topic += remainder;
                    } else if (!inbound) {
                        topic += ".*";
                    }
                }
            }
            return topic;
        },

        _getNativeAPI: function () {
            var api = {};
            if (client.isHybrid()) {
                api = window._appivoMobile ? window._appivoMobile : {};
                lang.mixin(api, {
                    BackgroundMode: BackgroundMode._isSupported ? BackgroundMode : undefined,
                    Camera: Camera._isSupported ? Camera : undefined,
                    File: File._isSupported ? File : undefined
                });
            }
            return api;
        },

        _completeBootstrapping: function () {
            this.booting = false;
        },

        _getFirstLanguage: function (plangs) {
            var lang = null;
            if (plangs) {
                var langs = plangs.split(",");
                lang = langs[0];
                var parts = lang.split(";");
                lang = parts[0];
            }
            return lang;
        },
        
        /**
         * Returns the language preferred by the current user.
         *
         * @instance
         * @memberof context
         * @returns {String} ISO 639-1 language code
         * @example
         * // Get the user's preferred language
         * const language = context.getLanguage();
         * console.log("User's preferred language:", language);
         */
        getLanguage: function () {
            var lang = null;
            var plangs = client.getPreferredLanguages();
            if (plangs) {
                lang = this._getFirstLanguage(plangs);
            }
            if (!lang) {
                var blangs = client.getBrowserLanguages();
                lang = this._getFirstLanguage(blangs);
            }
            return lang;
        },
        
        /**
         * Returns the country of the current user.
         *
         * @instance
         * @memberof context
         * @returns {String} ISO 3166-1 country code
         * @example
         * // Get the user's country
         * const country = context.getCountry();
         * console.log("User's country:", country);
         */
        getCountry: function () {
            return client.getCountry();
        },
        
        /**
         * Returns the country from where the current user is logged on.
         *
         * @instance
         * @memberof context
         * @returns {String} ISO 3166-1 country code
         * @example
         * // Get the user's origin country
         * const originCountry = context.getOriginCountry();
         * console.log("User's origin country:", originCountry);
         */
        getOriginCountry: function() {
            return client.getOriginCountry();
        },
        
        /**
         * Returns the city from where the current user is logged on.
         *
         * @instance
         * @memberof context
         * @returns {String} Name of city
         * @example
         * // Get the user's origin city
         * const originCity = context.getOriginCity();
         * console.log("User's origin city:", originCity);
         */
        getOriginCity: function() {
            return client.getOriginCity();
        },
        
        /**
         * Returns the current user.
         *
         * @instance
         * @memberof context
         * @param {Boolean} [load=false] Force loading user from backend. This will make the function return a promise.
         * @returns {User|Promise<User>} The current user object or a promise that resolves to the user object
         * @example
         * // Get the current user
         * const user = context.getUser();
         * console.log("Current user:", user);
         * 
         * // Force load user from backend
         * context.getUser(true).then(user => {
         *   console.log("Loaded user:", user);
         * });
         */
        getUser: function (load) {
            if (!load) {
                return client.getUser();
            } else {
                return client.sendRequest("/api/app/System/model/user/record/" + client.getUser().id, {
                    uriComplete: true,
                    method: "GET",
                    handleAs: 'json',
                    withCredentials: true
                });
            }
        },
        
        /**
         * Gets the amount of time the user has been inactive (in ms).
         * 
         * @instance
         * @memberof context
         * @returns {Number} The amount of time the user has been inactive in milliseconds
         * @example
         * // Get the user's inactive time
         * const inactiveTime = context.getInactiveFor();
         * console.log("User has been inactive for", inactiveTime, "ms");
         */
        getInactiveFor: function() {
            return client.getInactiveTime();
        },
        
        /**
         * Returns the current client ID.
         *
         * @instance
         * @memberof context
         * @returns {String} The current client ID
         * @example
         * // Get the current client ID
         * const clientId = context.getClientId();
         * console.log("Current client ID:", clientId);
         */
        getClientId: function() {
            return client.getClientId();
        },
        
        /**
         * Checks whether the user is logged in or not.
         *
         * @instance
         * @memberof context
         * @returns {Promise<Boolean>} A promise that resolves to true if the user is logged in, false otherwise
         * @example
         * // Check if the user is logged in
         * context.isLoggedIn().then(loggedIn => {
         *   if (loggedIn) {
         *     console.log("User is logged in");
         *   } else {
         *     console.log("User is not logged in");
         *   }
         * });
         */
        isLoggedIn: function () {
            return client.isLoggedIn();
        },
        
        /**
         * Checks whether the current user is anonymous.
         *
         * @instance
         * @memberof context
         * @returns {Boolean} True if the current user is anonymous, false otherwise
         * @example
         * // Check if the current user is anonymous
         * const isAnonymous = context.isAnonymous();
         * console.log("Is user anonymous?", isAnonymous);
         */
        isAnonymous: function() {
            return client.isAnonymous();
        },

        /**
         * Authorizes a user with a token.
         *
         * @instance
         * @memberof context
         * @param {String} token The authorization token
         * @returns {Promise<User>} A promise that resolves to the authorized user object
         * @example
         * // Authorize a user with a token
         * const token = "user_auth_token";
         * context.authorizeUser(token)
         *   .then(user => {
         *     console.log("Authorized user:", user);
         *   })
         *   .catch(error => {
         *     console.error("Authorization failed:", error);
         *   });
         */
        authorizeUser: function(token) {
            return new Promise(function(resolve, reject) {
                if (token) {
                    client.setRefreshToken(token);
                    // Need to allow token to propagate to serviceworker
                    setTimeout(function() {
                        client.sendStatusRequest().then(function(user) {
                            resolve(user);
                        }, function(err) {
                            reject(err);
                        })
                    }, 1);
                } else {
                    reject("Missing token");
                }
            });
        },
        
        /**
         * Returns the current organization.
         *
         * @instance
         * @memberof context
         * @returns {Object} The current organization object
         * @example
         * // Get the current organization
         * const organization = context.getOrganization();
         * console.log("Current organization:", organization);
         */
        getOrganization: function () {
            return client.getTenantInfo();
        },
        
        /**
         * Returns the ID of the current user's tenant.
         *
         * @instance
         * @memberof context
         * @returns {String} The tenant ID
         * @example
         * // Get the current tenant ID
         * const tenantId = context.getTenantId();
         * console.log("Current tenant ID:", tenantId);
         */
        getTenantId: function () {
            return client.getTenantId();
        },
        
        /**
         * Returns the name of the current user's tenant.
         *
         * @instance
         * @memberof context
         * @returns {String} The tenant name
         * @example
         * // Get the current tenant name
         * const tenantName = context.getTenantName();
         * console.log("Current tenant name:", tenantName);
         */
        getTenantName: function () {
            return client.getTenantName();
        },
        
        /**
         * Returns the shortcode of the current user's tenant.
         *
         * @instance
         * @memberof context
         * @returns {String} The tenant shortcode
         * @example
         * // Get the current tenant shortcode
         * const tenantShortcode = context.getTenantShortcode();
         * console.log("Current tenant shortcode:", tenantShortcode);
         */
        getTenantShortcode: function () {
            return client.getTenantShortcode();
        },
        
        /**
         * Check if an upgrade is available for the application.
         *
         * @instance
         * @memberof context
         * @returns {Promise<Boolean>} A promise that resolves to true if an update is available, false otherwise
         * @example
         * // Check for available updates
         * context.isUpdateAvailable()
         *   .then(updateAvailable => {
         *     if (updateAvailable) {
         *       console.log("An update is available");
         *     } else {
         *       console.log("No updates available");
         *     }
         *   });
         */
        isUpdateAvailable: function () {
            return this.schema.isUpdateAvailable();
        },
        
        /**
         * Upgrade the application to the latest version.
         *
         * @instance
         * @memberof context
         * @returns {Promise} A promise that resolves when the update is complete
         * @example
         * // Update the application
         * context.updateApp()
         *   .then(() => {
         *     console.log("Application updated successfully");
         *   })
         *   .catch(error => {
         *     console.error("Update failed:", error);
         *   });
         */
        updateApp: function () {
            return this.schema.update();
        },
        
        /**
         * Gets the current schema.
         *
         * @instance
         * @memberof context
         * @returns {Object} The current schema object
         * @example
         * // Get the current schema
         * const schema = context.getSchema();
         * console.log("Current schema:", schema);
         */
        getSchema: function () {
            return this.schema;
        },
        
        /**
         * Gets the current application.
         *
         * @instance
         * @memberof context
         * @returns {Object} The current application object
         * @example
         * // Get the current application
         * const app = context.getApp();
         * console.log("Current application:", app);
         */
        getApp: function () {
            return this.schema;
        },
        
        /**
         * Sets the logo for the application.
         *
         * @instance
         * @memberof context
         * @param {String|Object} logo The logo to set (can be a string checksum or an object with a checksum property)
         * @example
         * // Set the logo using a checksum string
         * context.setLogo("abc123");
         * 
         * // Set the logo using an object
         * context.setLogo({ checksum: "abc123" });
         */
        setLogo: function (logo) {
            var checksum = logo;
            if (logo) {
                if (_.isObject(logo)) {
                    if (logo.checksum) {
                        checksum = logo.checksum;
                    }
                }
            }
            this.page.getPageManager().setLogo(checksum);
        },
        
        /**
         * Gets the version of the application.
         *
         * @instance
         * @memberof context
         * @returns {Number} The application version
         * @example
         * // Get the application version
         * const version = context.getAppVersion();
         * console.log("Application version:", version);
         */
        getAppVersion: function () {
            return this.schema.ver;
        },
        
        /**
         * Gets the version of the Appivo platform.
         *
         * @instance
         * @memberof context
         * @returns {String} The Appivo platform version
         * @example
         * // Get the Appivo platform version
         * const platformVersion = context.getPlatformVersion();
         * console.log("Appivo platform version:", platformVersion);
         */
        getPlatformVersion: function () {
            return baseConfig.appivoVersion;
        },
        
        /**
         * Checks whether the current user is on a mobile device.
         *
         * @instance
         * @memberof context
         * @returns {Boolean} True if the current user is on a mobile device, otherwise false
         * @example
         * // Check if the user is on a mobile device
         * const isMobile = context.isMobile();
         * console.log("Is user on mobile?", isMobile);
         */
        isMobile: function () {
            return client.isMobile();
        },
        
        /**
         * Checks whether we are running in the context of a hybrid mobile app.
         *
         * @instance
         * @memberof context
         * @returns {Boolean} True if the current user is in the context of hybrid mobile app
         * @example
         * // Check if running in a hybrid mobile app
         * const isHybrid = context.isHybrid();
         * console.log("Is hybrid mobile app?", isHybrid);
         */
        isHybrid: function () {
            return client.isHybrid();
        },
        
        /**
         * Checks whether the device is currently offline.
         *
         * @instance
         * @memberof context
         * @returns {Boolean} True if the device is offline
         * @example
         * // Check if the device is offline
         * const isOffline = context.isOffline();
         * console.log("Is device offline?", isOffline);
         */
        isOffline: function () {
            return client.isOffline();
        },
        
        /**
         * Checks whether the device is currently forced offline.
         *
         * @instance
         * @memberof context
         * @returns {Boolean} True if the device is forced offline
         * @example
         * // Check if the device is forced offline
         * const isForcedOffline = context.isForcedOffline();
         * console.log("Is device forced offline?", isForcedOffline);
         */
        isForcedOffline: function () {
            return client.isForcedOffline();
        },
        
        /**
         * Force the device to act as if offline.
         *
         * @instance
         * @memberof context
         * @param {Boolean} offline True to force offline behavior, false to disable it
         * @example
         * // Force the device to act as if offline
         * context.setOffline(true);
         * 
         * // Disable forced offline behavior
         * context.setOffline(false);
         */
        setOffline: function (offline) {
            client.forceOffline(offline);
        },
        
        /**
         * Clears the offline storage.
         *
         * @instance
         * @memberof context
         * @example
         * // Clear the offline storage
         * context.clearOfflineStorage();
         */
        clearOfflineStorage: function () {
            var sw = client.getServiceWorkerController();
            if (sw) {
                sw.clear(this.schema.name);
            }
        },
        
        /**
         * Stores records offline.
         *
         * @instance
         * @memberof context
         * @param {Array|Object} records The record or array of records to store offline
         * @example
         * // Store a single record offline
         * const record = { id: 1, name: "John Doe" };
         * context.storeOffline(record);
         * 
         * // Store multiple records offline
         * const records = [
         *   { id: 1, name: "John Doe" },
         *   { id: 2, name: "Jane Doe" }
         * ];
         * context.storeOffline(records);
         */
        storeOffline: function (records) {
            SWController.store(schema.name, records);
        },
        
        /**
         * Publishes a message to a topic.
         *
         * @instance
         * @memberof context
         * @param {String} topic The topic to publish to
         * @param {*} message The message to publish
         * @param {Object} [options] Additional options for publishing
         * @example
         * // Publish a message to a topic
         * context.publish("user.created", { id: 1, name: "John Doe" });
         */
        publish: function (topic, message, options) {
            this.comBus.publish(topic, message, options);
        },
        
        /**
         * Subscribes to a topic.
         *
         * @instance
         * @memberof context
         * @param {String} topic The topic to subscribe to
         * @param {Function} callback The callback function to handle messages
         * @param {Object} [options] Additional options for subscribing
         * @returns {Object} A subscription object
         * @example
         * // Subscribe to a topic
         * const subscription = context.subscribe("user.created", (message) => {
         *   console.log("New user created:", message);
         * });
         */
        subscribe: function(topic, callback, options) {
            return this.comBus.subscribe(topic, callback, options);
        },
        
        /**
         * Unsubscribes from a topic.
         *
         * @instance
         * @memberof context
         * @param {String} topic The topic to unsubscribe from
         * @param {String|Object} id The subscription ID or subscription object
         * @returns {Boolean} True if unsubscription was successful, false otherwise
         * @example
         * // Unsubscribe from a topic using the subscription object
         * const subscription = context.subscribe("user.created", callback);
         * context.unsubscribe("user.created", subscription);
         */
         unsubscribe: function(topic, id) {
            return this.comBus.unsubscribe(topic, id);
         },

        /**
         * Gets the message bus.
         *
         * @instance
         * @memberof context
         * @returns {MessageBus} The message bus object
         * @example
         * // Get the message bus
         * const messageBus = context.getMessageBus();
         * messageBus.publish("user.updated", { id: 1, name: "John Doe" });
         */
        getMessageBus: function () {
            return this.bus;
        },

        /**
         * Creates a Record object.
         *
         * @instance
         * @memberof context
         * @param {String} modelName Name of model to create record of
         * @param {Object} data Data for record attributes and related records
         * @param {Object} [file] File options for Document-records
         * @param {*} file.data File contents
         * @param {String} file.filename Filename
         * @param {String} file.contentType File content-type
         * @returns {Record} The created Record object
         * @example
         * // Create a new user record
         * const userData = { name: "John Doe", email: "john@example.com" };
         * const userRecord = context.createRecord("User", userData);
         *
         * // Create a document record with a file
         * const docData = { title: "My Document" };
         * const fileData = { data: fileBlob, filename: "document.pdf", contentType: "application/pdf" };
         * const docRecord = context.createRecord("Document", docData, fileData);
         */
        createRecord: function (modelName, data, file) {
            var record = null;
            var model = this.schema.getModel(modelName);
            if (model) {
                record = model.createRecord(data);
            }
            return record;
        },

        /**
         * Creates a DocumentRecord object, uploading the associated file data and then creating a DocumentRecord object.
         *
         * @instance
         * @memberof context
         * @param {String} modelName Name of model to create record of
         * @param {Object} data Data for record attributes and related records
         * @param {Object} file File options
         * @param {String|Blob} file.data File contents (String or Blob)
         * @param {String} file.filename Filename
         * @param {String} file.contentType File content-type
         * @returns {Promise<DocumentRecord>} A promise that resolves to the created DocumentRecord
         * @example
         * // Create a document record
         * const docData = { title: "My Document" };
         * const fileData = { data: fileBlob, filename: "document.pdf", contentType: "application/pdf" };
         * context.createDocumentRecord("Document", docData, fileData)
         *   .then(documentRecord => {
         *     console.log("Document created:", documentRecord);
         *   })
         *   .catch(error => {
         *     console.error("Error creating document:", error);
         *   });
         */
        createDocumentRecord: function (modelName, data, file) {
            var def = new Deferred();
            var model = this.schema.getModel(modelName);
            if (model) {
                switch (model.getType()) {
                    case 'Document':
                        model.createDocumentRecord(data, undefined, file).then(function (rec) {
                            def.resolve(rec);
                        }, function (err) {
                            def.reject(err);
                        });
                        break;
                    default:
                        def.reject("Not a document-model");
                        break;
                }
            } else {
                def.reject("Unknown model");
            }
            return def;
        },

        /**
         * Get all privileges for a certain record.
         *
         * @instance
         * @memberof context
         * @param {Record|String} record Record or record ID to get privileges for
         * @param {Object} [opts] Options
         * @param {Function} [opts.onSuccess] Callback function for success
         * @param {Function} [opts.onError] Callback function for error
         * @param {String|Model} [opts.model] Model of the record (required if record is an ID)
         * @example
         * // Get privileges for a record object
         * const record = someRecordObject;
         * context.getPrivilegesFor(record, {
         *   onSuccess: (privileges, rawPrivileges) => {
         *     console.log("Privileges:", privileges);
         *   },
         *   onError: (error) => {
         *     console.error("Error fetching privileges:", error);
         *   }
         * });
         *
         * // Get privileges for a record ID
         * const recordId = "123456";
         * context.getPrivilegesFor(recordId, {
         *   model: "User",
         *   onSuccess: (privileges, rawPrivileges) => {
         *     console.log("Privileges:", privileges);
         *   },
         *   onError: (error) => {
         *     console.error("Error fetching privileges:", error);
         *   }
         * });
         */
        getPrivilegesFor: function (record, opts) {
            var fail = false;
            opts = opts || {};
            if (record) {
                var model = opts.model;
                if (lang.isString(model)) {
                    model = this.schema.getModel(model);
                }
                var id = null;
                if (lang.isObject(record)) {
                    id = record.id;
                    if (!model) {
                        model = record.__model;
                    }
                } else if (lang.isString(record)) {
                    id = record;
                }

                if (id && model) {
                    var url = "/api/app/" + this.schema.getName() + "/model/" + model.getName() + "/record/" + id + "/privileges";
                    this.sendRequest({
                        url: url,
                        method: 'GET',
                        handleAs: 'json',
                        data: record,
                        onSuccess: function (result) {
                            if (opts.onSuccess) {
                                var map = {};
                                for (var i = 0; i < result.length; i++) {
                                    map[result[i].name] = true;
                                }
                                opts.onSuccess(map, result);
                            }
                        },
                        onError: opts.onError
                    });
                } else {
                    fail = true;
                }
            } else {
                fail = true;
            }

            if (fail && opts.onError) {
                opts.onError("Invalid arguments");
            }
        },

        /**
         * Execute a query to get an array of results.
         *
         * @instance
         * @memberof context
         * @param {String|Object} name Name or ID of query to execute
         * @param {Object} [params] Query parameters
         * @param {Number} [offset] Result offset
         * @param {Number} [limit] Result limit
         * @returns {Promise<Array>} A promise that resolves to an array of query results
         * @example
         * // Execute a query named "getAllUsers"
         * context.queryForArray("getAllUsers", { status: "active" }, 0, 10)
         *   .then(results => {
         *     console.log("Query results:", results);
         *   })
         *   .catch(error => {
         *     console.error("Query error:", error);
         *   });
         */
        queryForArray: function (name, params, offset, limit) {
            var def = new Deferred();
            var query = this.schema.getQueryByName(name);
            if (query) {
                var qh = this.getQueryHandle(name);
                qh.execute({
                    query: params,
                    offset: offset,
                    limit: limit
                }).then(function (result) {
                    def.resolve(result);
                }, function (error) {
                    def.reject(error);
                })
            } else {
                def.reject("No such query '" + name + "'");
            }
            return def;
        },

        /**
         * Execute a query to get a single record.
         *
         * @instance
         * @memberof context
         * @param {String|Object} name Name or ID of query to execute
         * @param {Object} [params] Query parameters
         * @param {Number} [offset] Result offset
         * @param {Array<String>} [relations] List of relationships to load
         * @returns {Promise<Object|null>} A promise that resolves to the single record or null if not found
         * @example
         * // Execute a query named "getUserById" to get a single user
         * context.queryForSingle("getUserById", { id: 123 }, 0, ["profile", "orders"])
         *   .then(user => {
         *     if (user) {
         *       console.log("User found:", user);
         *     } else {
         *       console.log("User not found");
         *     }
         *   })
         *   .catch(error => {
         *     console.error("Query error:", error);
         *   });
         */
        queryForSingle: function (name, params, offset, relations) {
            var def = new Deferred();
            var query = this.schema.getQueryByName(name);
            if (query) {
                var qh = this.getQueryHandle(name);
                qh.execute({
                    query: params,
                    offset: offset,
                    limit: 1,
                    relations: relations
                }).then(function (result) {
                    var record = result.length > 0 ? result[0] : null;
                    def.resolve(record);
                }, function (error) {
                    def.reject(error);
                })
            } else {
                def.reject("No such query '" + name + "'");
            }
            return def;
        },

        /**
         * Get a record by its ID.
         *
         * @instance
         * @memberof context
         * @param {String|Model} model Model or model name to get record of
         * @param {String} id ID of record to get
         * @param {Object} [options] Options
         * @param {String} [options.relations] Comma-separated list of relations to load
         * @returns {Promise<Record>} A promise that resolves to the requested record
         * @example
         * // Get a user record by ID
         * context.get("User", "123", { relations: "profile,orders" })
         *   .then(user => {
         *     console.log("User found:", user);
         *   })
         *   .catch(error => {
         *     console.error("Error fetching user:", error);
         *   });
         */
        get: function (model, id, options) {
            if (lang.isString(model)) {
                model = this.schema.getModel(model);
            }
            if (model && id) {
                return model.getById(id, options);
            } else {
                var def = new Deferred();
                def.reject("Invalid model or missing ID");
                return def;
            }
        },

        /**
         * Creates a new record in the database.
         *
         * @instance
         * @memberof context
         * @param {Object|Array} record - The record or array of records to create. Each record should be an object containing the data for the new record.
         * @param {Object} [opts] - Options for the create operation.
         * @param {Function} [opts.onSuccess] - Callback function called on successful creation. Receives the created record as an argument.
         * @param {Function} [opts.onError] - Callback function called if an error occurs. Receives the error message as an argument.
         * @param {string} [opts.storageMode='auto'] - Specifies where to store the record. Can be 'auto', 'cloud', or 'local'.
         * @param {boolean} [opts.raw=false] - If true, returns the raw response from the server instead of just the response body.
         * @param {string|Object} [opts.model] - The model name or model object for the record. If not provided, it will be inferred from the record.
         * @returns {Promise} A promise that resolves with the created record or rejects with an error message.
         * @example
         * // Create a new customer record
         * const newCustomer = {
         *   name: "Acme Inc",
         *   email: "invoice@acme.com"
         * };
         * 
         * context.create(newCustomer, {
         *   model: "Customer",
         *   onSuccess: (createdCustomer) => {
         *     console.log("Customer created:", createdCustomer);
         *   },
         *   onError: (error) => {
         *     console.error("Error creating customer:", error);
         *   }
         * }).then((result) => {
         *   console.log("Create operation completed");
         * }).catch((error) => {
         *   console.error("Create operation failed:", error);
         * });
         */
        create: function (record, opts) {
            var fail = false;
            opts = opts || {};
            if (record) {
                var r1 = record;
                if (Array.isArray(record)) {
                    r1 = record[0];
                }
                var model = opts.model;
                if (lang.isString(model)) {
                    model = this.schema.getModel(model);
                }
                if (!model) {
                    model = r1.__model;
                }
                if (model && record) {
                    const url = "/api/app/" + this.schema.getName() + "/model/" + model.getName() + "/record/";
                    const req = {
                        url: url,
                        method: 'POST',
                        handleAs: 'json',
                        data: record,
                        onSuccess: opts.onSuccess,
                        onError: opts.onError
                    };
                    if (opts.raw !== undefined) {
                        req.raw = opts.raw;
                    }
                    if (opts.storageMode) {
                        req.storageMode = opts.storageMode;
                    }
                    return this.sendRequest(req);
                } else {
                    fail = true;
                }
            } else {
                fail = true;
            }

            if (fail && opts.onError) {
                opts.onError("Invalid arguments");
                var def = new Deferred();
                def.reject("Invalid arguments");
                return def;
            }
        },

        /**
         * Update a record
         * @instance
         * @memberof context
         * @param {Record} record to update
         * @param {Object} opts Options
         * @param {Function} opts.onSuccess Callback function for success
         * @param {Function} opts.onError Callback function for error
         * @returns {Promise}
         */
        update: function (record, opts) {
            var fail = false;
            opts = opts || {};
            if (record) {
                var r1 = record;
                if (Array.isArray(record)) {
                    r1 = record[0];
                }
                var model = opts.model;
                if (lang.isString(model)) {
                    model = this.schema.getModel(model);
                }
                if (!model) {
                    model = r1.__model;
                }

                if (model && record) {
                    const url = "/api/app/" + this.schema.getName() + "/model/" + model.getName() + "/record/" + record.id;
                    const req = {
                        url: url,
                        method: 'PUT',
                        handleAs: 'json',
                        data: record,
                        onSuccess: opts.onSuccess,
                        onError: opts.onError
                    };
                    if (opts.raw !== undefined) {
                        req.raw = opts.raw;
                    }
                    if (opts.storageMode) {
                        req.storageMode = opts.storageMode;
                    }
                    return this.sendRequest(req);
                } else {
                    fail = true;
                }
            } else {
                fail = true;
            }

            if (fail && opts.onError) {
                opts.onError("Invalid arguments");
                var def = new Deferred();
                def.reject("Invalid arguments");
                return def;
            }
        },

        /**
         * Delete a record
         * @instance
         * @memberof context
         * @param {Record} record to delete
         * @param {Object} opts Options
         * @param {Function} opts.onSuccess Callback function for success
         * @param {Function} opts.onError Callback function for error
         * @returns {Promise}
         */
        delete: function (record, opts) {
            var fail = false;
            opts = opts || {};
            if (record) {
                var model = opts.model;
                if (lang.isString(model)) {
                    model = this.schema.getModel(model);
                }
                var id = null;
                if (lang.isObject(record)) {
                    id = record.id;
                    if (!model) {
                        model = record.__model;
                    }
                } else if (lang.isString(record)) {
                    id = record;
                }

                if (id && model) {
                    const url = "/api/app/" + this.schema.getName() + "/model/" + model.getName() + "/record/" + id;
                    const req = {
                        url: url,
                        method: 'DELETE',
                        handleAs: 'json',
                        onSuccess: opts.onSuccess,
                        onError: opts.onError
                    };
                    if (opts.raw !== undefined) {
                        req.raw = opts.raw;
                    }
                    if (opts.storageMode) {
                        req.storageMode = opts.storageMode;
                    }
                    return this.sendRequest(req);
                } else {
                    fail = true;
                }
            } else {
                fail = true;
            }

            if (fail && opts.onError) {
                opts.onError("Invalid arguments");
                var def = new Deferred();
                def.reject("Invalid arguments");
                return def;
            }
        },

        /**
         * Copy records to/from the offline database. This method can be used to copy one or all records of a particular model.
         * @param {Object} options Copy options
         * @param {String} options.to Copy-destination (either "device" or "cloud" - defaults to "device")
         * @param {String/Model-ID} options.model Name of model to copy records of
         * @param {String} options.id ID of record to copy. If not provided all records are copied.
         * @param {String} options.relations Relations to include
         * @param {Boolean} options.delete Delete records from the source after copying (only applicable when copy-destination is "cloud")
         * @param {Object} options.filter Object with key/value-pairs used for filtering records
         * @param {String} options.references Comma separated list of models which should be passed as references only
         * @returns {Promise}
         */
        copyRecords: function (options) {
            var t = this;
            var def = new Deferred();
            var model = options.model;
            var mdl = this.getSchema().getModel(model);

            var refModels = options.references ? options.references.split(",") : [];

            function prepareRecord(rec, model) {
                if (refModels.length == 0) {
                    return rec;
                } else {
                    var modelName = model.name;
                    if (refModels.indexOf(modelName) >= 0 && Identity.isRealId(rec.id)) {
                        return {
                            id: rec.id
                        };
                    } else {
                        for (var name in rec) {
                            var attr = model.getAttribute(name);
                            if (!attr) {
                                var rel = model.getRelationship(name, true);
                                if (rel) {
                                    var destModel = rel.getDestination();
                                    if (rel) {
                                        var val = rec[name];
                                        if (Array.isArray(val)) {
                                            for (var i = 0; i < val.length; i++) {
                                                var r = val[i];
                                                val[i] = prepareRecord(r, destModel);
                                            }
                                        } else if (val) {
                                            rec[name] = prepareRecord(val, destModel);
                                        }
                                    }
                                }
                            }
                        }
                    }
                    return rec;
                }
            };

            if (!model) {
                def.reject("model is a required argument");
                return;
            } else {
                function doCopyRecords() {
                    console.log("Begin copying records for model " + model);
                    var url = "/api/app/" + t.schema.getName() + "/model/" + model + "/record/";
                    if (!options.filter) {
                        options.filter = {};
                    }
                    if (options.id) {
                        var ids = options.id;
                        if (Array.isArray(ids)) {
                            options.filter["id:in"] = ids.toString();
                        } else {
                            options.filter["id"] = ids;
                        }
                    }
                    if (options.filter) {
                        var query = ioQuery.objectToQuery(options.filter);
                        if (query) {
                            url = url + "?" + query;
                        }
                    }
                    var dest = options.to ? options.to : "offline";
                    var headers = {};
                    if (options.relations) {
                        headers['Relations'] = options.relations;
                    }
                    if (dest === "offline" || dest === 'device') {
                        console.log("Copying records of model " + model + " to offline database");
                        headers["X-Copy"] = "Yes";
                        t.sendRequest({
                            url: url,
                            headers: headers,
                            method: 'GET',
                            handleAs: 'json'
                        }).then(function (response) {
                            def.resolve(response);
                        }, function (error) {
                            def.reject(error);
                        });
                    } else {
                        console.log("Copying records of model " + model + " to the cloud");
                        headers["X-Offline"] = "Yes";
                        headers["X-Optimize"] = "Yes";
                        t.sendRequest({
                            url: url,
                            headers: headers,
                            method: 'GET',
                            handleAs: 'json'
                        }).then(function (response) {
                            try {
                                if (Array.isArray(response)) {
                                    console.log("Got " + response.length + " records from offline database");
                                    for (var i = 0; i < response.length; i++) {
                                        prepareRecord(response[i], mdl);
                                    }
                                } else {
                                    if (response) {
                                        prepareRecord(response, mdl);
                                    }
                                }
                                url = "/api/app/" + t.schema.getName() + "/model/" + model + "/record/";
                                delete headers["X-Offline"];
                                headers["X-Sync"] = "Yes";
                                if (options.delete) {
                                    headers["X-Delete"] = "Yes";
                                }
                                t.sendRequest({
                                    url: url,
                                    headers: headers,
                                    method: 'POST',
                                    handleAs: 'json',
                                    data: response
                                }).then(function (response) {
                                    if (!options.delete) {
                                        options.to = 'device';
                                        options.delete = false;
                                        if (Array.isArray(options.id)) {
                                            for (var i = 0; i < options.id.length; i++) {
                                                options.id[i] = Identity.toRealId(options.id[i]);
                                            }
                                        } else if (options.id) {
                                            options.id = Identity.toRealId(options.id);
                                        }
                                        console.log("Copying back updated records to device [" + options.id + "]");
                                        options.nowait = true;
                                        t.copyRecords(options).then(function () {
                                            def.resolve(response);
                                        }, function (error) {
                                            def.reject(error);
                                        });
                                    } else {
                                        def.resolve(response);
                                    }
                                }, function (error) {
                                    def.reject(error);
                                });
                            } catch (err) {
                                console.error(err);
                                def.reject(err);
                            }
                        }, function (error) {
                            def.reject(error);
                        });
                    }
                }

                var promises = [];
                if (this.syncPromise && !options.nowait) {
                    console.log("Waiting for previous sync...");
                    promises.push(this.syncPromise);
                }
                this.syncPromise = def;

                allPromises(promises).then(function () {
                    console.log("Previous sync completed");
                    doCopyRecords();
                }, function (error) {
                    console.log("Previous sync failed " + error);
                    doCopyRecords();
                })
            }
            return def;
        },

        /**
         *    Returns a reference to the current view.
         *    @returns {View}
         *    @instance
         *    @memberof context
         *
         *   @LogicMeta {
         *     "api":"UI@Context",
         *     "returnType":"View",
         *     "tooltip": "$"
         *   }
         */
        getView: function () {
            return this.view;
        },

        /**
         * Scrolls a widget into view
         *
         * @param {String/Widget-ID} widget ID of widget to scroll to
         * @param {Number} offset Additional scroll offset in pixels (optional)
         * @instance
         * @memberof context
         */
        scrollTo: function (widget, offset) {
            if (widget) {
                if (typeof (widget) == "string") {
                    widget = this.getWidget(widget);
                    if (widget) {
                        widget = widget.widget.widget;
                    }
                }
                if (widget && widget.domNode) {
                    var node = widget.domNode;
                    if (node) {
                        if (this.view.scrollTo) {
                            this.view.scrollTo(node, true, offset);
                        } else {
                            node.scrollIntoView();
                        }
                    }
                }
            }
        },

        /**
         * Copy text to the clipboard
         *
         * @param {String} text Text to copy to clipboard
         * @memberof context
         * @instance
         */
        copyToClipboard: function (text) {
            if (navigator.clipboard) {
                navigator.clipboard.writeText(text).then(function () {
                }, function (err) {
                    console.error('Failed to copy text to clipboard ', err);
                });
            } else {
                var textArea = document.createElement("textarea");
                textArea.value = text;

                // Avoid scrolling to bottom
                textArea.style.top = "0";
                textArea.style.left = "0";
                textArea.style.position = "fixed";

                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();

                try {
                    var successful = document.execCommand('copy');
                    var msg = successful ? 'successful' : 'unsuccessful';
                    // console.log('Fallback: Copying text command was ' + msg);
                } catch (err) {
                    console.error('Fallback: Oops, unable to copy', err);
                }
                document.body.removeChild(textArea);
            }
        },

        print: function (opts) {
            var printerId;
            if (opts.printer) {
                if (typeof opts.printer === 'string') {
                    printerId = opts.printer;
                } else if (opts.printer.id) {
                    printerId = opts.printer.id;
                } else {
                    throw "No printer specified";
                }
            }
            var data = lang.mixin({}, opts);
            delete data.onSuccess;
            delete data.onError;
            delete data.printer;
            if (opts.model && opts.id) {
                data.record = this.getSchema().getName() + "." + opts.model + "." + opts.id;
                delete data.model;
                delete data.id;
            }
            this.sendRequest({
                url: 'api/printer/' + printerId + '/print',
                method: 'POST',
                handleAs: 'json',
                onSuccess: opts.onSuccess,
                onError: opts.onError,
                data: data
            });
        },

        getPrintJobs: function (opts) {
            var printerId;
            if (opts.printer) {
                if (typeof opts.printer === 'string') {
                    printerId = opts.printer;
                } else if (opts.printer.id) {
                    printerId = opts.printer.id;
                } else {
                    throw "No printer specified";
                }
            }
            this.sendRequest({
                url: 'api/printer/' + printerId + '/print',
                method: 'GET',
                handleAs: 'json',
                onSuccess: opts.onSuccess,
                onError: opts.onError,
                query: {status: opts.status}
            });
        },

        getPrinterInfo: function (opts) {
            var printerId;
            if (opts.printer) {
                if (typeof opts.printer === 'string') {
                    printerId = opts.printer;
                } else if (opts.printer.id) {
                    printerId = opts.printer.id;
                } else {
                    throw "No printer specified";
                }
            }
            return this.sendRequest({
                url: 'api/printer/' + printerId,
                method: 'GET',
                handleAs: 'json',
                onSuccess: opts.onSuccess,
                onError: opts.onError,
                query: {gcpInfo: true}
            });
        },

        /**
         * Generates and downloads a pdf file
         *
         * @memberof context
         * @instance
         * @param {Object} opts Options
         * @paramn {Number} opts.timeout Timeout in ms
         * @param {Function} opts.onSuccess Callback function for success
         * @param {Function} opts.onError Callback function for error
         * @returns {Promise}
         */
        getPdf: function (opts) {
            if (!opts.pdf) {
                opts.pdf = {};
            }
            var pdfOpts = [];
            var headers = {};
            if (opts.timeout) {
                headers['X-Timeout'] = opts.timeout;
            }
            var storeAs = opts.storeAs;
            var req;
            var errorHandler = function (res) {
                var msg = res.response.getHeader('X-Error');
                if (opts.onError) {
                    if (msg) {
                        opts.onError({
                            errorCode: 'PDF',
                            errorMessage: msg
                        });
                    } else {
                        opts.onError(res);
                    }
                }
            };

            if (storeAs === undefined && !opts.pdf.content) {
                for (var opt in opts.pdf) {
                    pdfOpts.push(opt + ":" + opts.pdf[opt]);
                }
                var pdfQuery = pdfOpts.join(";");
                req = {
                    url: "api/app/" + this.schema.getName() + "/model/" + opts.model + "/record/" + opts.recordId,
                    method: "GET",
                    handleAs: opts.pdf.store ? "json" : "blob",
                    onSuccess: opts.onSuccess,
                    onError: errorHandler,
                    query: "template=" + opts.template + "&pdf" + (pdfQuery ? "=" + pdfQuery : "")
                };
            } else {
                var handleAs = opts.pdf.content && !opts.storeAs && !opts.pdf.store ? "blob" : "json";
                var data;
                if (opts.storeAs) {
                    if (opts.recordData) {
                        data = opts.recordData;
                    } else {
                        data = {};
                    }
                    data._pdfParams = opts.pdf;
                } else {
                    data = opts.pdf;
                }
                req = {
                    url: opts.pdf.content && !opts.storeAs ? "api/pdf" : "api/app/" + this.schema.getName() + "/model/" + opts.storeAs + "/pdf",
                    method: "POST",
                    headers: headers,
                    handleAs: handleAs,
                    onSuccess: opts.onSuccess,
                    onError: errorHandler,
                    data: handleAs === "blob" ? JSON.stringify(opts.pdf) : data
                };
            }
            return this.sendRequest(req);
        },

        /**
         *    Returns a handle to a query.
         *    @param {String/Query-ID} name The name of the Query Handle.
         *  @oaram {Object} options Options
         *  @instance
         *    @returns {QueryHandle}
         *    @memberof context
         *
         *   @LogicMeta {
         *     "api":"UI@Context",
         *     "paramTypes": ["String/Query-ID", "Object"],
         *     "returnType":"QueryHandle",
         *     "tooltip": "$"
         *   }
         */
        getQueryHandle: function (name, options) {
            return this.view.getQueryHandle(name, undefined, options);
        },

        /**
         * Creates a query-builder
         *  @instance
         *  @param {Object} options Options
         *  @param {String/Model-ID} options.from Name of model to query
         *    @returns {QueryBuilder}
         *    @memberof context
         */
        createQueryBuilder: function (options) {
            if (lang.isString(options)) {
                options = {
                    from: options
                };
            }
            options = options ? options : {};
            options.schema = this.schema;
            if (!options.from) {
                options.from = this.schema.getModels()[0].name;
            } else if (lang.isString(options.from)) {
                options.from = this.schema.getModel(options.from);
            }
            return new QueryBuilder(options);
        },

        /**
         *    Closes the current dialog.
         *  @instance
         *    @param {Object} data Optional data to pass back.
         *    @memberof context
         *
         *   @LogicMeta {
         *     "api":"UI@Context",
         *     "tooltip": "$",
         *     "paramTypes":["Object"],
         *     "tags": ["Dialog"]
         *   }
         */
        closeDialog: function (data) {
            if (this.view.getType() === "Dialog" || this.view.getType() === 'MDialog') {
                this.view.close(data);
            }
        },

        /**
         *    Closes the current drawer.
         *    @instance
         *    @param {Object} data Optional data to pass back.
         *    @memberof context
         *
         *   @LogicMeta {
         *     "api":"UI@Context",
         *     "tooltip": "$",
         *     "paramTypes":["Object"],
         *     "tags": ["Dialog"]
         *   }
         */
        closeDrawer: function (data) {
            if (this.view.getType() === "View" || this.view.getType() === 'MView') {
                this.view.close(data);
            }
        },

        /**
         *    Returns a configuration parameter using the specified name, or null if no such parameter exists.
         *    @param {String} name - The name of the parameter.
         *    @returns {ConfigurationParameter}
         *   @instance
         *    @memberof context
         *
         *   @LogicMeta {
         *     "api":"Application@Context",
         *     "returnType":"Object",
         *     "paramTypes":["String/ConfigParam-ID"],
         *     "tooltip": "$"
         *   }
         */
        getConfigParam: function (name) {
            var value = this.config[name];
            if (value === undefined) {
                value = this.schema.getConfigDefault(name);
            }
            return value;
        },

        /**
         *    Returns a query parameter using the specified name.
         *    Returns null if no query is present, or undefined the query exists but does not have the specified parameter.
         *    @param {String} name - The name of the parameter.
         *    @returns {QueryParameter}
         *  @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"Application@Context",
         *     "returnType":"Object",
         *     "paramTypes":["String"],
         *     "shadowBlocks": {
         *     		"name": "text#parameter name"
         *     }
         * 	}
         */
        getParameter: function (name) {
            var val = null;
            var query = this.view.getQuery();
            if (query) {
                val = query[name];
            }
            return val;
        },

        getParameters: function() {
            var query = this.view.getQuery();
            var clone = Object.assign({}, query);
            return clone;
        },

        setParameter: function(name, value) {
            var query = this.getParameters();
            query[name] = value;
            this.setParameters(query);
        },

        setParameters: function(parameters) {
            var query = Object.assign({}, parameters);
            this.setView(this.getView().id, undefined, query);
        },

        /**
         *    Gets the custom properties associated with the current subdomain, if any
         *
         *    @returns {Object}
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"Application@Context",
         *     "returnType":"Object"
         * 	}
         */
        getSubdomainMetadata: function () {
            var domain = client.getAppDomain();
            return domain != null ? (domain.properties != null ? domain.properties : {}) : {};
        },

        /**
         * Initiate the authorization of an integration
         *
         * @param {String} name Name of integration to authorize
         * @param {Object} options Options
         * @instance
         * @memberof context
         * @returns {Promise}
         *
         * @LogicMeta {
         *   "api":"Application@Context",
         *   "paramTypes":["String/Integration-ID","Object"],
         *   "returnType":"Promise"
	     * }
         */
        authorizeIntegration: function(name, options) {
            var integration = this.schema.getIntegration(name);
            if (integration) {
                console.log("Initiating authorization code flow for integration " + name);
                options.integration = integration.id,
                options.app = this.schema.id;
                options.appName = this.schema.name;
                options.app_uri = window.location.href;
                if (options.goto) {
                    options.app_uri = this.getAppURL(options.goto);
                }
                const noredirect = (options.redirect === false);
                return new Promise((resolve, reject) => {
                    this.sendRequest({
                        url: '/api/initiate-authorization',
                        method: 'POST',
                        data: options
                    }).then(function (response) {
                        console.log("Authorization-response", response);
                        if (noredirect) {
                            resolve(response.authorization_url);
                        } else {
                            window.location.assign(response.authorization_url);
                        }
                    });
                });
            } else {
                return Promise.reject("No such integration " + name);
            }
        },

        /**
         *    Returns an array of the app's localization strings.
         *    @returns {Array} - An array holding all of the app's strings.
         *    @instance
         *    @memberof context
         *
         *   @LogicMeta {
         *     "api":"Application@Context",
         *     "returnType":"Array",
         *     "tooltip": "$"
         * 	}
         */
        getStrings: function () {
            return this.strings;
        },

        /**
         *    TODO
         *    @param {String} name -
         *    @param {Object} vars -
         *    @memberof context
         *  @instance
         *
         *    @LogicMeta {
         *     "api":"Application@Context",
         *     "returnType":"String",
         *     "paramTypes":["String", "Object"]
         * 	}
         */
        replaceTerm: function (name, vars) {
            return this.schema.replaceTerms(name, vars);
        },

        /**
         *    Returns the localization string of the given name.
         *    @param {String} name The name of the localization string.
         *    @param {Object} vars Variables to use when localizing the string
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"Application@Context",
         *     "returnType":"String",
         *     "paramTypes":["String", "Object"]
         * 	}
         */
        getString: function (name, vars) {
            return this.schema.getString(name, vars);
        },

        /**
         *    TODO
         *    @param {String | Object} template - Template to render
         *    @param {Object} data - Variables to use when rendering the template
         *    @instance
         *    @memberof context
         *    @returns {String}
         *    @LogicMeta {
         *     "api":"UI@Context",
         *     "returnType":"String",
         *     "paramTypes":["String", "Object"],
         *     "toggleReturn":"true"
         * 	}
         */
        renderString: function (template, data) {
            if (typeof template == 'object' && template.data) {
                template = template.data;
            }
            return this.schema.substituteString(template, data);
        },

        /**
         *    Sanitizes a string to prevent XSS attacks.
         *    @param {String} string - String to sanitize
         *    @param {Object} options - Options for sanitization
         *    @param {Array<String>} options.allowedTags - Array of tags (represented as strings) to allow
         *    @param {Object} options.allowedAttributes - Map of attributes to allow for specific tags e.g {"img": ["src"]}, only allow src attributes on img tags.
         *    @param {Array<String>} options.nonBooleanAttributes - Array of attributes which are not boolean. Such as src, placeholder and value etc.
         *    @instance
         *    @memberof context
         *    @returns {String}
         *    @LogicMeta {
         *     "api":"UI@Context",
         *     "returnType":"String",
         *     "paramTypes":["String", "Object"],
         *     "toggleReturn":"true"
         * 	}
         */
        sanitize: function (string, options) {
            if (!options) {
                options = {};
            }

            if (options.allowedTags) {
                sanitizeHtml.default.defaults.allowedTags = options.allowedTags;
            }
            if (options.allowedAttributes) {
                sanitizeHtml.default.defaults.allowedAttributes = options.allowedAttributes;
            }
            if (options.nonBooleanAttributes) {
                sanitizeHtml.default.defaults.allowedAttributes = options.allowedAttributes;
            }

            return sanitizeHtml.default(string);
        },

        _canLeave: function (viewId) {
            var can = true;
            var vid = this.view.id;
            var view = this.view.getWidget(vid);

            var widget = (view && view.widget) ? view.widget._widget : null;

            if (widget) {
                var func = widget.getCodeProperty("canLeave", ["view"]);
                if (func) {
                    var result = func(this, viewId);
                    if (result !== undefined && result !== null) {
                        can = result;
                    }
                }
            }
            return can;
        },

        /**
         *    Changes the currently shown view.
         *    @param {Object} view - View Object
         *    @param {String/View-ID} view.view - View id
         *    @param {String} view.transition - for mobiles
         *    @param {Object} data - An optional record that is used to populate forms in the new view.
         *    @param {Query} query - Optional custom data to pass to the view
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"UI@Context",
         *     "paramTypes":["Object", "null", "String/Query-ID"],
         *     "objectTypeOverride": { "view": { "view":"String/View-ID", "transition":{"type":"String","require":["isMobile"] } } },
         *     "tooltip": "$"
         * 	}
         */
        setView: function (view, data, query) {
            var t = this;
            var id = data;
            var target = null;
            if (lang.isObject(data) && data != null) {
                id = data.id;
                Global.set('dataTransfer.form', data);
            }
            var transition = null;
            if (lang.isObject(view)) {
                var opts = view;
                if (opts.view) {
                    transition = opts.transition;
                    view = opts.view;
                }
                if (opts.target) {
                    target = opts.target;
                }
            }
            if (!target) {
                var ok = this._canLeave(view);
                if (ok && lang.isFunction(ok.then)) {
                    ok.then(function (result) {
                        if (result) {
                            t.page.go({
                                view: view,
                                id: id,
                                query: query,
                                transition: transition
                            });
                        } else {
                            console.log("Navigation request rejected by script");
                        }
                    });
                } else if (ok) {
                    this.page.go({
                        view: view,
                        id: id,
                        query: query,
                        transition: transition
                    });
                } else {
                    console.log("Navigation request rejected by script");
                }
            } else {
                var loc = window.location;
                var url = loc.protocol + "//" + loc.host + loc.pathname;
                url += "#/app/" + this.schema.name + "/" + this.viewManager.ui.name + "/" + view;
                if (id) {
                    url += "/" + id;
                }
                if (query) {
                    var queryStr = ioQuery.objectToQuery(query);
                    url += "?" + queryStr;
                }
                window.open(url, target);
            }
        },

        getAppURL: function(options) {
            const loc = window.location;
            let url = loc.protocol + "//" + loc.host + loc.pathname;
            let app = this.schema.name;
            let ui = this.viewManager.ui;
            let view = this.view.id;
            if (options.app) {
                app = options.app;
            }
            if (options.ui) {
                ui = options.ui;
            }
            if (options.view) {
                view = options.view;
            }

            url += "#/app/" + app + "/" + ui + "/" + view;
            if (options.id) {
                url += "/" + options.id;
            }
            if (options.query) {
                let queryStr = ioQuery.objectToQuery(options.query);
                url += "?" + queryStr;
            }
            return url;
        },

        /**
         *    Changes the currently shown ui.
         *    @param {Object} ui - UI parameters
         *    @param {String/UI-ID} ui.ui - User interface id
         *    @param {String} ui.transition - Transition to use (only for mobile)
         *    @param {String} view - An optional View id that should be navigated to
         *    @param {Object} data - An optional record that is used to populate forms in the new view.
         *    @param {Query} query - Optional custom data to pass to the view
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"UI@Context",
         *     "paramTypes":["Object", "String/View-ID", "null", "String/Query-ID"],
         *     "objectTypeOverride": { "ui": { "ui":"String", "transition":{"type":"String","require":["isMobile"] } } },
         *     "tooltip": "$"
         * 	}
         */
        setUI: function (ui, view, data, query) {
            var id = data;
            if (lang.isObject(data) && data != null) {
                id = data.id;
                Global.set('dataTransfer.form', data);
            }
            var transition = null;
            if (ui && ui.ui) {
                transition = ui.transition;
                ui = ui.ui;
            }
            this.page.go({
                ui: ui,
                view: view,
                id: id,
                query: query,
                transition: transition
            });
        },

        /**
         *    Changes the currently shown view. Uses existing form data as the data for the new view.
         *    @param {String} nextView - The id of the next view.
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"UI@Context",
         *     "paramTypes":["String/View-ID"]
         * 	}
         */
        continueTo: function (nextView) {
            var data = undefined;
            var view = this.getView();
            var forms = view.getForms();
            var form = null;
            if (forms && forms.length > 1) {
                form = forms[0];
            }
            var ok = false;
            if (form) {
                if (form.validate()) {
                    data = form.build();
                    ok = true;
                }
            } else {
                ok = true;
            }
            if (ok) {
                this.setView(nextView, data)
            }
        },

        /**
         *    Ask the user to select one of a set of options
         *  @param {Object} options Options
         *  @param {String} options.title Dialog title
         *  @param {Arrau} options.options Array of options where each option is an object that has a mandatory 'text'-property (String), an optional 'icon'-property (String) and an optional 'onClick'-property (function)
         *    @memberof context
         *    @instance
         *    @LogicMeta {
         *     "api":"UI@Context",
         *     "paramTypes":["Object"]
         * 	}
         */
        ask: function (options) {
            var dialog;
            var alertTitle = (options.header) ? options.header : options.title ? options.title : messages.alertAskDefaultTitle;
            var list = domConstruct.create('ul', {className: 'ask-list'});
            for (var opt in options.options) {
                var option = options.options[opt];
                var item = domConstruct.create('li', {
                    className: 'ask-item'
                }, list);
                var html = option.text;
                if (option.icon) {
                    html = '<i class="ion-' + option.icon + '"></i>&nbsp;' + option.text;
                }
                // nosemgrep: insecure-document-method
                item.innerHTML = html;
                on(item, 'click', lang.partial(function (option, event) {
                    dialog.destroy();
                    delete Alertify.genericDialog;
                    if (option.onClick) {
                        event.option = option;
                        event.preventDefault();
                        event.stopPropagation();
                        option.onClick(event);
                    }
                    return false;
                }, option));
            }

            var buttons = [];
            if (options.displayCancel) {
                buttons = [
                    {
                        text: 'Cancel',
                        invokeOnClose: true,
                        className: Alertify.defaults.theme.cancel,
                    }
                ]
            }

            Alertify.dialog('genericDialog', function () {
                return {
                    main: function (content) {
                        this.setContent(content);
                    },
                    setup: function () {
                        return {
                            buttons: buttons,
                            focus: {
                                element: function () {
                                    return this.elements.body.querySelector(this.get('selector'));
                                },
                                select: true
                            },
                            options: {
                                title: alertTitle,
                                basic: false,
                                message: 'Välj',
                                maximizable: false,
                                resizable: false,
                                padding: false,
                                closable: false
                            }
                        };
                    },
                    settings: {
                        selector: undefined
                    },
                    callback: function (closeEvent) {
                        this.destroy();
                        delete Alertify.genericDialog;
                    }

                };
            });

            dialog = Alertify.genericDialog(list);
        },

        /**
         *    Dial a phone-number
         *    @param {String} number - The phone number to dial.
         *    @memberof context
         *   @instance
         *
         *   @LogicMeta {
         *     "api":"UI@Context",
         *     "paramTypes":["String"],
         *     "tooltip": "$",
         *     "shadowBlocks": {
         *     		"number": "text#123123"
         *     }
         * 	}
         */
        dial: function (number) {
            var link = document.createElement('a');
            link.href = 'tel:' + number;
            link.type = 'submit';
            if (!window.ionic || !ionic || !ionic.Platform.isIOS()) {
                link.target = 'new';
            }
            document.body.appendChild(link);
            try {
                link.click();
            } finally {
                document.body.removeChild(link);
            }
        },

        /**
         *    Sends an SMS to the specified number
         *    @param {String} tel - The phone number to send to.
         *    @instance
         *    @memberof Context
         *
         *    @LogicMeta {
         * 		"api": "UI@Context",
         * 		"paramTypes": ["String"],
         *		"tooltip": "$",
         *		"shadowBlocks": {
         *			"tel": "text#123123"
         *		}
         * 	}
         */
        SMSTo: function (tel) {
            var link = document.createElement('a');
            link.href = 'sms:' + tel;
            link.type = 'submit';
            if (!window.ionic || !ionic || !ionic.Platform.isIOS()) {
                link.target = 'new';
                link.target = 'new';
            }
            document.body.appendChild(link);
            try {
                link.click();
            } finally {
                document.body.removeChild(link);
            }
        },

        /**
         *    Creates and opens a mailto: link.
         *    @param {String} email - The email adress to use for the link.
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"UI@Context",
         *     "paramTypes":["String"],
         *     "tooltip": "$",
         *     "shadowBlocks": {
         *     		"email": "text#email adress"
         *     }
         * 	}
         */
        mailTo: function (email, options) {
            var link = document.createElement('a');
            let href = 'mailto:' + email;
            if (!window.ionic || !ionic || !ionic.Platform.isIOS()) {
                link.target = 'new';
            }
            if (options) {
                for (var key in options) {
                    if (options.hasOwnProperty(key)) {
                        href += (href.indexOf('?') === -1? '?' : '&') + key + '=' + encodeURIComponent(options[key]);
                    }
                }
            }
            link.href = href;
            link.type = 'submit';
            document.body.appendChild(link);
            try {
                link.click();
            } finally {
                document.body.removeChild(link);
            }
        },

        /**
         *    Opens another application
         *    @param {String} app - The name of the application to open
         *  @param {String} ui - The name of the application UI to open
         *  @param {String} view - The name of the application view to open
         *  @param {String/ID} record - The id of the record to open
         *  @param {Object} options - Options that control the open-request
         *  @param {Object} options.parameters - An object with request-parameters
         *  @param {String} options.scheme - The custom URL scheme of the app to open (if it has one). Defaults to https.
         *  @param {Boolean} options.newtab - Opens the application in a new tab. Defaults to false.
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"UI@Context",
         *     "paramTypes":["String", "String", "String", "String", "Object"],
         *     "tooltip": "$"
         * 	}
         */
        openApp: function (app, ui, view, record, options) {
            if (!options) {
                options = {};
            }
            var href = "";
            if (options.scheme) {
                href += options.scheme + "://app/" + app;
            } else {
                href = "/#/app/" + app;
            }

            if (ui) {
                href += "/" + ui;
            }
            if (view) {
                href += "/" + view;
            }
            if (record) {
                href += "/" + record;
            }

            if (options.parameters) {
                href += "?" + ioQuery.objectToQuery(options.parameters);
            }

            var tab = '_self';
            if (options.scheme) {
                tab = "_system";
            } else if (options.newtab) {
                tab = "_blank";
            }

            window.open(href, tab);
        },

        /**
         *    Shows a success/error notification to the user.
         *    @param {Object} options - Contains the configuration for the notification.
         *    @param {string} options.type - The type of notification to display. This value must be either 'success', 'error', 'info' or 'default'. Append '-light' for lighter appearance eg 'success-light'.
         *    @param {string} options.message - The notification message.
         *    @param {string} options.position - The position to display notification. This value must be top/bottom left/center/right with the format of 'bottom-left', 'top-center'.
         *    @param {Number} options.delay - The time in seconds until the notification is automatically closed.
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"UI@Context",
         *     "paramTypes":["Object"],
         *     "objectTypeOverride": { "options": { "type":"String", "message":"String", "delay":"Number", "position":"String"} },
         *     "tooltip": "$",
         *     "shadowBlocks": {
         *     	"type": "text#success",
         *     	"message": "text#message",
         *     	"delay": "number#1"
         *     }
         * 	}
         */
        notify: function (options) {
            if (options) {
                var type = 'info';
                var position = 'bottom-right';
                var delay = undefined;
                if (options.type) {
                    type = options.type;
                }
                if (options.delay != undefined && options.delay != null) {
                    if (!isNaN(parseFloat(options.delay))) {
                        delay = options.delay;
                    } else {
                        console.log("Invalid argument delay");
                    }
                    // This has changed, used to be ms but needs to be in seconds
                    if (delay > 1000) {
                        delay = Math.round(delay / 1000);
                    }
                }
                if (options.position) {
                    position = options.position;
                }
                Alertify.set('notifier', 'position', position);
                Alertify.notify(options.message, type, delay);
            }
        },

        /**
         * Load a file
         * @param file
         * @returns {Promise}
         */
        loadFile: function(file) {
            let url = null;
            if (file instanceof String) {
                url = '/files/' + file;
            } else if (file instanceof Object) {
                if (file.checksum) {
                    url = '/files/' + file.checksum;
                }
            }
            return this.http({
                url: url
            });
        },

        /**
         *  Upload a file
         *  @param {Object} data contents of file to upload
         *  @param {Object} options File-upload options
         *  @param {String} options.filename Name of the file to upload (defaults to file.text)
         *  @param {String} options.contentType Content-type of the file (defaults to text/plain)
         *  @param {String} options.lastModifiedDate
         *  @returns {Promise}
         *  @instance
         *  @memberof context
         */
        uploadFile: function (data, options) {
            if (!options) {
                options = {};
            }
            var filename = options.filename ? options.filename : "file.txt";
            var contentType = options.contentType ? options.contentType : "text/plain";
            var timestamp = data.lastModifiedDate ? data.lastModifiedDate : options.lastModifiedDate ? options.lastModifiedDate : new Date().getTime();
            var headers = {
                "X-Filename": filename,
                "X-LastModified": timestamp,
                "Content-Type": contentType
            };
            var def = new Deferred();
            client.sendRequest("/files", {
                method: 'POST',
                uriComplete: true,
                withCredentials: true,
                headers: headers,
                data: data,
                handleAs: "json"
            }).then(function (res) {
                def.resolve(res[0]);
            }, function (error) {
                def.reject(error);
            });

            return def;
        },

        /**
         *  Download a file
         *  @param {Object} file File-object or checksum of file
         *  @param {Object} options File-download options
         *  @param {String} options.filename Filename
         *  @returns {Promise}
         *  @instance
         *  @memberof context
         */
        downloadFile: function(file, options) {
            let checksum = file;
            let filename = "data.bin";
            if (typeof(file) == "object") {
                checksum = file.checksum;
                filename = file.filename;
            }
            if (options) {
                if (options.filename) {
                    filename = options.filename;
                }
            }

            let link = document.createElement("a");
            link.setAttribute("download", filename);
            link.href = '/files/' + checksum + '?filename=' + encodeURIComponent(filename);
            link.click();
            link.remove();
        },

        /**
         * Exports an array of records in CSV-format
         *
         *  @param {Array} records Array of records
         *  @param {Object} options  Options
         *  @param {String} options.filename  Name of generated file to download. Defaults to 'export.csv'
         *  @param {Boolean} options.download Whether to download a file or just generate the CSV. Defaults to true.
         *  @param {Boolean} options.header Include a header. Default is true.
         *  @param {String} options.delimiter Delimiter to use for separating cells.
         *  @param {String} options.quoteChar Character to use for quoting strings.
         *  @param {String} options.escapeChar Character to use for escaping strings.
         *  @param {String} options.newline Characters to use for separating lines.
         *  @param {Array} options.columns Array of strings that define what columns to write, if omitted all the non-system attributes of the first record in the data-set will be used
         *  @returns {Promise}
         *    @instance
         *    @memberof context
         */
        exportToCSV: function (records, options) {
            var t = this;
            if (!options) {
                options = {};
            }
            if (!options.filename) {
                options.filename = "export.csv";
            }
            if (options.download === undefined) {
                options.download = true;
            }
            var def = new Deferred();
            if (!records || !Array.isArray(records)) {
                def.reject("An array of records must be passed as the first argument");
                return;
            }
            var columns = options.columns;
            if (!columns) {
                if (records && records.length > 0) {
                    var rec = records[0];
                    if (rec.__model) {
                        columns = [];
                        var attrs = rec.__model.getAttributes();
                        attrs.forEach(function (attr) {
                            if (!attr.system) {
                                columns.push(attr.name);
                            }
                        })
                        options.columns = columns;
                    }
                }
            }
            require(["papaparse/papaparse"], function (Papa) {
                try {
                    var csv = Papa.unparse(records, options);
                    if (options.download) {
                        t.downloadVirtualFile({
                            data: csv,
                            fileName: options.filename,
                            fileType: "text/csv"
                        });
                    }
                    def.resolve(csv);
                } catch (error) {
                    def.reject(error);
                }
            });
            return def;
        },

        /**
         * Exports an array of records in Excel-format
         *
         *  @param {Array} records Array of records
         *  @param {Object} opts Options
         *  @param {String} opts.filename Name of generated file to download. Defaults to 'export.xslx'
         *  @returns {Promise}
         *    @instance
         *    @memberof context
         */
        exportToExcel: function (records, opts) {
            var t = this;
            if (!opts) {
                opts = {};
            }
            require(["appivo/util/ExcelExport"], function (ExcelExport) {
                ExcelExport.export(records, opts).then(function (res) {
                    var filename = opts.filename ? opts.filename : "export.xlsx";
                    t.downloadVirtualFile({
                        data: res,
                        fileName: filename,
                        fileType: "application/vnd.ms-excel"
                    });
                });
            });
        },

        /**
         * Imports records from an Excel-file
         *
         *  @param {File} file File to import from
         *  @param {Object} opts Options
         *  @returns {Promise}
         *    @instance
         *    @memberof context
         */
        importFromExcel: function (file, opts) {
            var t = this;
            if (!opts) {
                opts = {};
            }
            var def = new Deferred();
            require(["appivo/util/ExcelImport"], function (ExcelImport) {
                if (opts.metadata) {
                    ExcelImport.readMetadata(file, opts).then(function (meta) {
                        def.resolve(meta);
                    }, function (error) {
                        def.reject(error);
                    });
                } else {
                    ExcelImport.import(file, opts).then(function (records) {
                        if (opts.onSuccess) {
                            opts.onSuccess(records);
                        }
                        def.resolve(records);
                    }, function (error) {
                        if (opts.onFailure) {
                            opts.onFailure(error);
                        }
                        def.reject(error);
                    });
                }
            });
            return def;
        },

        /**
         *    Shows a message notification to the user.
         *    @param {Object} options - Optional parameter for configuring the message.
         *    @param {Number} options.delay  - A delay in milliseconds before the message notification is closed.
         *    @param {String} options.message - The notification message.
         *    @param {Boolean} options.dismissable - Decides if the message is dismissable.
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"UI@Context",
         *     "paramTypes":["Object"],
         *     "objectTypeOverride": { "options": { "message":"String", "delay":"Number" } },
         *     "tooltip": "$",
         *     "shadowBlocks": {
         *     		"message": "text#message",
         *     		"delay": "number#1000"
         *     }
         * 	}
         */
        message: function (options) {
            return this._createMessage(options);
        },

        _createMessage: function (options) {
            if (!options) {
                options = {};
            }
            if (!options.delay) {
                options.delay = 0;
            }
            if (!options.message) {
                options.message = '';
            }

            var message = Alertify.message(options.message, options.delay);

            message.ondismiss = function () {
                if (options.dismissable != null && options.dismissable != undefined) {
                    return options.dismissable;
                } else {
                    return true;
                }
            };

            return {
                close: function () {
                    message.ondismiss = function () {
                        return true;
                    };
                    message.dismiss();
                }
            };
        },

        /**
         *    Shows an alert dialog to the user.
         *    @param {Object} opts - Optional object for configuring the alert.
         *    @param {String} opts.message - The alert message.
         *    @param {Function} opts.ok - Callback function when the dialog is closed.
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"UI@Context",
         *     "paramTypes":["Object"],
         *     "async": {
         *       "objectParam": "opts",
         *       "onSuccess": "ok"
         *     },
         *     "objectTypeOverride": { "opts": { "message":"String" } },
         *     "tooltip": "$",
         *     "shadowBlocks": {
         *     		"message": "text#message"
         *     }
         * 	}
         */
        alert: function (opts) {
            if (lang.isString(opts)) {
                var o = {
                    message: opts
                };
                opts = o;
            }
            var appname = this.getSchema().getName();
            Alertify.alert(opts.header ? opts.header : opts.title ? opts.title : appname, opts.message, opts.ok);
        },

        /**
         *    Shows a Yes/No confirmation dialog to the user.
         *    @param {Object} options - Configuration object.
         *    @param {String} options.message - The message to display in the dialog
         *    @param {String} options.title - The message to title in the dialog
         *    @param {Function} options.ok - Callback function when the user presses 'OK'
         *    @param {Function} options.cancel - Callback function when the user closes the dialog without pressing OK.
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"UI@Context",
         *     "paramTypes":["Object"],
         *     "async": {
         *       "objectParam": "opts",
         *       "onSuccess": "ok",
         *       "onFailure": "cancel"
         *     },
         *     "objectTypeOverride": { "opts": { "message":"String" } },
         *     "tooltip": "$",
         *     "shadowBlocks": {
         *     		"message": "text#message"
         *     }
         * 	}
         */
        confirm: function (options) {
            if (lang.isString(options)) {
                var o = {
                    message: options
                };
                options = o;
            }

            var appname = this.getSchema().getName();
            var dialog = Alertify.confirm(options.header ? options.header : options.title ? options.title : appname, options.message, options.ok, options.cancel);
            if (options) {
                if (options.okLabel || options.cancelLabel) {
                    dialog.set('labels', {
                        ok: options.okLabel,
                        cancel: options.cancelLabel
                    });
                } else {
                    dialog.set('labels', {
                        ok: alertmsgs.ok,
                        cancel: alertmsgs.cancel
                    });
                }
            }
        },

        /**
         *    Shows a prompt dialog to the user. The prompt dialog prompts the user for some information.
         *    @param {Object} opts - Configuration object.
         *    @param {String} opts.message - The message to display in the dialog.
         *    @param {String} opts.value - Default value for the input field.
         *    @param {Function} opts.ok - Callback function when the user presses ok.
         *    @param {Function} opts.cancel - Callback function when the user closes the dialog without pressing ok.
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"UI@Context",
         *     "paramTypes":["Object"],
         *     "async": {
         *       "objectParam": "opts",
         *       "onSuccess": "ok",
         *       "onFailure": "cancel"
         *     },
         *     "objectTypeOverride": { "opts": { "message":"String", "value":"String" } },
         *     "tooltip": "$",
         *     "shadowBlocks": {
         *     		"message": "text#message",
         *     		"value": "text#default value"
         *     }
         * 	}
         */
        prompt: function (opts) {
            var value = opts.value;
            if (!value) {
                value = '';
            }
            var appname = this.getSchema().getName();
            Alertify.prompt(opts.header ? opts.header : opts.title ? opts.title : appname, opts.message, value,
                    function (event, value) {
                        if (opts.ok) {
                            opts.ok(value);
                        }
                    },
                    function (data) {
                        if (opts.cancel) {
                            opts.cancel(data);
                        }
                    }
            );
        },

        /**
         *    Goes back to the previous view.
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"UI@Context",
         *     "paramTypes":["Object"],
         *     "objectTypeOverride": { "view": { "transition":{"type":"String","require":["isMobile"] } } },
         *     "tooltip": "$"
         * 	}
         */
        back: function (opts) {
            if (opts && opts.response) {
                Global.set('responseData', opts.response);
            }
            Global.set('viewChange.direction', 'backwards');
            if (lang.isFunction(this.viewManager.back)) {
                if (opts) {
                    this.viewManager.back(opts.transition);
                } else {
                    this.viewManager.back();
                }
            } else {
                window.history.back();
            }
        },

        /**
         *    Opens a dialog view.
         *    @param {String/Dialog-ID} dialog - The id of the dialog view.
         *    @param {Record} data - An optional record that is used to populate form-connected widgets in the dialog.
         *    @param {Object} opts - An object allowing for additional configurations.
         *    @param {Function} opts.onDone - Callback function when the dialog is closed.
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"UI@Context",
         *     "paramTypes":["String/Dialog-ID", "null", "Object"],
         *     "async": {
         *     	"objectParam": "opts",
         *     	"onSuccess": "onDone"
         *     },
         *     "tooltip": "$"
         * 	}
         */
        openDialog: function (dialog, data, opts) {
            var t = this;
            var options = opts;
            if (lang.isFunction(opts)) {
                options = {
                    onDone: opts
                };
            }
            var promise = null;
            if (!t.dialogOpening) {
                t.dialogOpening = true;
                try {
                    promise = this.viewManager.openDialog(dialog, data, options);
                    promise.then(function () {
                        t.dialogOpening = false;
                    });
                } catch (error) {
                    t.dialogOpening = false;
                    throw error;
                }
            } else {
                promise = Promise.reject();
            }
            return promise;
        },

        /**
         *    Opens a drawe view.
         *    @param {String/View-ID} dialog - The id of the drawer view.
         *    @param {Record} data - An optional record that is used to populate form-connected widgets in the drawer.
         *    @param {Object} opts - An object allowing for additional configurations.
         *    @param {Function} opts.onDone - Callback function when the drawer is closed.
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"UI@Context",
         *     "paramTypes":["String/View-ID", "null", "Object"],
         *     "async": {
         *     	"objectParam": "opts",
         *     	"onSuccess": "onDone"
         *     },
         *     "tooltip": "$"
         * 	}
         */
        openDrawer: function (drawer, data, opts) {
            var t = this;
            var options = opts;
            if (lang.isFunction(opts)) {
                options = {
                    onDone: opts
                };
            }
            var promise = null;
            if (!t.drawerOpening) {
                t.drawerOpening = true;
                try {
                    promise = this.viewManager.openDrawer(drawer, data, options);
                    promise.then(function () {
                        t.drawerOpening = false;
                    });
                } catch (error) {
                    t.drawerOpening = false;
                    throw error;
                }
            } else {
                promise = Promise.reject();
            }
            return promise;
        },

        /**
         *    Creates a HTML dialog window.
         *    @param {Object} opts Configuration object.
         *    @param {String} opts.url
         *    @param {String} opts.content
         *    @param {String} opts.template
         *    @param {Object} opts.data
         *    @param {Array} opts.records
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"UI@Context",
         *     "paramTypes":["Object"],
         *     "objectTypeOverride": { "opts": { "url":"String", "content":"String", "template":"String", "data":"null", "records":"Array" } },
         *     "shadowBlocks": {
         *	     	"content": "text#window content"
         *     }
         * 	}
         */
        createWindow: function (opts) {
            var winContent = '';
            var url = '#';
            try {
                if (opts.url) {
                    url = opts.url;
                } else if (opts.content) {
                    winContent = opts.content;
                } else if (opts.template) {
                    winContent = this.executeTemplate(opts);
                    if (!winContent) {
                        return;
                    }
                }
            } catch (error) {
                this.page.getPageManager().alert("error", 'Failed to render template: ' + error);
                return;
            }

            var win = window.open(url, '_blank', 'location=no, width=800');
            if (win) {
                win.document.writeln(winContent);
                win.document.close();
                if (opts.print) {
                    $(win).on("load", function () {
                        setTimeout(function () {
                            win.print();
                        }, 100);
                    });
                }
            } else {
                this.page.getPageManager().alert("error", messages.errorPopupsDisabled);
            }
        },

        /**
         *    Compiles a template string.
         *    @param {Object} opts - Configuration object
         *    @param {String} opts.template - The template name
         *    @returns {String} - The compiled template.
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"UI@Context",
         *     "paramTypes":["Object"]
         * 	}
         */
        executeTemplate: function (opts) {
            try {
                var template = this.schema.getTemplate(opts.template);
                var templateString = null;
                if (!template) {
                    templateString = opts.templateString;
                } else {
                    templateString = template.data;
                }
                if (templateString) {
                    var ctx = this.createTemplateContext(opts);
                    var compiled = this.handlebars.compile(templateString, this);
                } else {
                    this.page.getPageManager().error("error", "Unknown template: " + opts.template);
                    return;
                }
            } catch (error) {
                this.page.getPageManager().error("error", 'Failed to render template: ' + error);
                return;
            }

            return compiled(ctx);
        },

        /**
         *    Creates and downloads a virtual file using the provided data.
         *    @param {Object} opts - Configuration object
         *    @param {Object} opts.data - The file data
         *    @param {String} opts.fileType - The file type
         *    @param {String} opts.fileName - The filename
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"Runtime@Context",
         *     "paramTypes":["Object"]
         * 	}
         */
        downloadVirtualFile: function (opts) {
            try {
                var data = opts.data;
                var fileType = opts.fileType;
                //Should implement a MIME-mapping function to apply the correct file extension to the file.
                var fileName = opts.fileName ? opts.fileName : 'file.txt';

                var pom = document.createElement('a');
                var bb = (data instanceof Blob) ? data : new Blob([data], {type: fileType});

                pom.setAttribute('href', window.URL.createObjectURL(bb));
                pom.setAttribute('download', fileName);

                pom.dataset.downloadurl = [fileType, pom.download, pom.href].join(':');
                pom.draggable = true;
                pom.classList.add('dragout');

                pom.click();
            } catch (error) {
                this.page.getPageManager().error("error", 'Failed to download file: ' + error);
            }
        },

        /**
         * Trigger downloading of an application resource
         * @param {String} resource resource or ID of resource to download
         * @param {Object} opts Options
         *
         *    @LogicMeta {
         *     "api":"UI@Context",
         *     "returnType":"Boolean",
         *     "paramTypes":["String","Object"],
         *     "tooltip": "$"
         * 	}
         */
        downloadResource: function (resource, opts) {
            var ok = false;
            var rsrc = this.getResource(resource);
            var name = '';
            if (!rsrc) {
                rsrc = this.getResourceById(resource);
            }
            if (rsrc) {
                name = rsrc.filename;
                if (opts && opts.name) {
                    name = opts.name;
                }
                var elm = document.createElement("a");
                elm.setAttribute("href", this.schema.getResourceURI(resource) + "?filename=" + encodeURI(name));
                elm.setAttribute("download", name);
                elm.draggable = true;
                elm.classList.add("dragout");
                elm.click();
                ok = true;
            } else {
                console.error("No such resource: " + resource);
            }
            return ok;
        },

        /**
         *    Returns the template with the specified id.
         *    @param {String|ID} id - The desired template's id.
         *    @instance
         *    @memberof context
         *    @returns {Object}
         *
         *    @LogicMeta {
         *     "api":"UI@Context",
         *     "returnType":"Object",
         *     "paramTypes":["Integer"],
         *     "tooltip": "$"
         * 	}
         */
        getTemplate: function (id) {
            return this.schema.getTemplate(id);
        },

        /**
         *    Creates a template context using the specified data and records.
         *    @param {Object} opts - Optional configuration object
         *    @param {Object} opts.data -
         *    @param {Array} opts.records -
         *    @returns {TemplateContext} - The created context.
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"UI@Context",
         *     "returnType":"Object",
         *     "paramTypes":["Object"]
         * 	}
         */
        createTemplateContext: function (opts) {
            var ctx = TemplateContextFactory.getInstance().createContext(this);
            ctx.config = client.getAppConfig();
            var user = client.getUser();
            ctx.user = user;
            var userPhotoUrl = "/images/unknown_user.jpg";
            if (user && user.profilephoto_id) {
                userPhotoUrl = '/api/app/system/model/profilephoto/record/' + user.profilephoto_id + '/file/0';
            }
            ctx.userPhotoURL = userPhotoUrl;
            if (opts) {
                ctx.config = this.config;
                ctx.features = this.features;
                ctx.data = opts.data;
                ctx.records = opts.records;
                ctx.record = opts.record;
                ctx.string = this.strings;
                ctx.ctxdata = this._createDataContext();
                ctx.cdnURL = window.APPIVO_CDN;
                ctx.cssURL = this.isMobile() ? window.APPIVO_MOBILE_CSS : window.APPIVO_DESKTOP_CSS;
                ctx.now = new Date();
            }
            ctx.__isTemplate = true;
            ctx.global = this.globalData;
            return ctx;
        },

        _createDataContext: function () {
            var t = this;
            var prefix = this.schema.id + "_";
            var keys = Object.keys(localStorage);
            var list = [];
            keys.forEach(function (key) {
                if (key.startsWith(prefix)) {
                    key = key.substring(prefix.length);
                    list.push(key);
                }
            });
            var data = {};
            list.forEach(function (key) {
                data[key] = t.getData(key);
            });
            var global = Global.getData();
            var ret = {};
            lang.mixin(ret, data);
            lang.mixin(ret, global);
            lang.mixin(ret, this.globalData);
            return ret;
        },

        /**
         * Queries a json-document using JSON-path
         *
         * @param {String} path The path to query for
         * @param {Object} json Document to execute query on
         * @param {Object} opts Options
         * @returns {Array} Array elements found
         * @instance
         * @memberof context
         */
        jsonpath: function (path, json, opts) {
            return jsonpath.JSONPath(path, json);
        },

        // Do not annotate for Blockly, this function is hardcoded in the widget blocks.
        /**
         *    Fetches a widget from the current view using the provided widget id.
         *    @param {String/Widget-ID} widgetId - The widget id of the widget to return.
         *    @returns {BaseWidget} - The widget, or null if no widget was found.
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"UI@Context",
         *     "returnType":"Widget",
         *     "paramTypes":["String/Widget-ID"],
         *     "tooltip": "$"
         * 	}
         */
        getWidget: function (widgetId) {
            var peer = null;
            var widget = null;
            if (this.globalRegistry) {
                widget = this.globalRegistry('widget', widgetId);
            }

            if (!widget) {
                widget = this.view.getWidget(widgetId);
            }

            if (widget) {
                peer = widget.peer;
            }
            return peer;
        },

        /**
         *    Fetches a form from the current view using the provided form id.
         *    @param {String/Form-ID} formId - The id of the form to return.
         *    @returns {Form} - The form, or null if no form was found.
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"UI@Context",
         *     "returnType":"Form",
         *     "paramTypes":["String/Form-ID"],
         *     "tooltip": "$"
         * 	}
         */
        getForm: function (formId) {
            var form = null;
            if (this.globalRegistry) {
                form = this.globalRegistry('form', formId);
            }

            if (!form) {
                var forms = this.viewManager.getForms(this.view);
                form = forms[formId];
            }
            return form;
        },

        /**
         * Create a new form in the current view
         *    @instance
         *    @memberof context
         *  @param {Object} options Options
         *  @param {String} options.parent Name of parent form
         *  @param {String} options.relation Name of relation to connect to
         *  @returns {Form}
         */
        createForm: function (options) {
            if (!options) {
                throw new Error("No options specified for form");
            }
            if (options.transactional === undefined) {
                options.transactional = true;
            }
            if (options.enabled === undefined) {
                options.enabled = true;
            }
            var form = this.view.addForm(options);
            if (options.record) {
                form.setData(options.record);
            }
            return form;
        },

        /**
         * Remove a dynamically created form
         *    @instance
         *  @param {String} id ID of form to remove
         *    @memberof context
         */
        removeForm: function (id) {
            this.view.removeTempForm(id);
        },

        /**
         * Remove all dynamically created forms
         *    @instance
         *    @memberof context
         */
        removeAllForms: function () {
            this.view.removeTempForms();
        },

        /**
         * Gets the returned data from the previously visited view (if any)
         *  @returns {Object} data returned from previous view or null if none is available
         *    @instance
         *    @memberof context
         */
        getViewResponse: function () {
            return this.response;
        },

        /**
         * Creates a new transaction wrapping a set of database-operations.
         *  @returns {Transaction}
         *    @instance
         *    @memberof context
         */
        createTransaction: function () {
            return new Transaction({
                schema: this.schema
            });
        },

        /**
         * Gets an object with properties describing the current device
         *  @returns {Object}
         *    @instance
         *    @memberof context
         */
        getDeviceInfo: function () {
            if (window.device) {
                return window.device;
            } else {
                var platform = client.getDeviceType();
                if (platform) {
                    platform = platform.charAt(0).toUpperCase() + platform.substring(1);
                }
                return {
                    platform: platform
                };
            }
        },

        isAndroid: function() {
            return client.isAndroid();
        },

        isIOS: function() {
            return client.isIOS();
        },

        /**
         * Gets the ID of the appliance this application is running on
         *  @returns {String}
         *    @instance
         *    @memberof context
         */
        getApplianceId: function () {
            return client.getApplianceId();
        },

        /**
         * Checks whether this application is running on an appliance
         *  @returns {Boolean}
         *    @instance
         *    @memberof context
         */
        isAppliance: function () {
            return !!client.getApplianceId();
        },

        /**
         * Returns the tags of this appliance (or an empty array if the app is not running on an appliance)
         *  @returns {Array}
         *    @instance
         *    @memberof context
         */
        getApplianceTags: function () {
            return client.getApplianceTags();
        },

        restart: function (force) {
            location.reload(force);
        },

        sendRequest: function (opts) {
            return this.http(opts);
        },

        /**
         * Send an http-request
         *    @param {Object} opts Request options
         *    @param {String} opts.url URL or path to send request to
         *    @param {String} opts.method HTTP-method to use (GET, PUT, POST, DELETE)
         *    @param {String} opts.headers Object holding header key/value-pairs
         *    @param {Object} opts.data Data to put in the request body, if applicable. Can be a string or an object.
         *    @returns {Promise}
         *    @instance
         *    @memberof context
         */
        http: function (opts) {
            var t = this;
            if (opts && opts.url) {
                var url = opts.url;
                var headers = opts.headers ? opts.headers : {};
                if (url.startsWith("http://") || url.startsWith("https://")) {
                    // Extract hostname
                    var hstart = url.indexOf("://");
                    var host = url.substring(hstart + 3);
                    var port = "";
                    var slash = host.indexOf("/");
                    if (slash > 0) {
                        host = host.substring(0, slash);
                    }
                    var colon = host.indexOf(":");
                    if (colon > 0) {
                        port = host.substring(colon + 1);
                        host = host.substring(0, colon);
                    }

                    // Proxy if going to different host
                    if (host !== location.hostname || port !== location.port) {
                        headers['x-url'] = url;
                        opts.url = "/api/proxy";
                    }
                }
                if (!headers[CONTENT_TYPE]) {
                    headers[CONTENT_TYPE] = 'application/json';
                }
                var args = {
                    handleAs: 'json',
                    headers: headers
                };
                lang.mixin(args, opts);
                if (args.data && args.handleAs == 'json') {
                    args.data = JSON.stringify(args.data);
                }
                if (args.file) {
                    args.data = args.file;
                    delete args.file;
                }
                args.url = client.getURI(args.url);
                if (!opts.noSpinner) {
                    this.showSpinner();
                }
                var def = client.sendRequest(args.url, args);
                def.then(function (res) {
                    if (!opts.noSpinner) {
                        t.hideSpinner();
                    }
                }, function (error) {
                    if (!opts.noSpinner) {
                        t.hideSpinner();
                    }
                });
                return def;
            }
        },

        _findRESTRule: function (name) {
            var selected = null;
            var rules = this.schema.getRules();
            for (var i = 0; i < rules.length; i++) {
                var rule = rules[i];
                if (rule.getName() === name && rule.getType() === 'REST') {
                    selected = rule;
                    break;
                }
            }
            return selected;
        },

        /**
         *    Invokes a server-side REST rule.
         *    @param {Object} options - Object holding configurations for the invokation.
         *    @param {String} options.service - The name of the rule to invoke.
         *    @param {Object} options.parameters - Object of query parameters and their values.
         *    @param {Object} options.data - Object containing data to send.
         *    @returns {Promise} - A dojo deferred object (See the {@link http://dojotoolkit.org/reference-guide/1.9/dojo/Deferred.html|Dojo documentation}.
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"Runtime@Context",
         *     "paramTypes":["Object"],
         *	  "objectTypeOverride": {
         *		"options": {
         *			"service":"String/Webhook-ID",
         *			"data":"Object",
         *          "parameters": "Object"
         *		}
         *	  },
         *	  "async": {
         *		"objectParam": "options",
         *		"onSuccess": "callback",
         *		"onFailure": "errorCallback"
         *	  },
         *     "tooltip": "$",
         *     "shadowBlocks": {
         *     	"data": "object#data1#data2",
         *     	"parameters": "object#parameter1#parameter2"
         *     }
         * 	}
         */
        invokeService: function (options) {
            if (options) {
                var name = options.service;
                var app = options.app ? options.app : this.schema.getName();
                var service = name ? this._findRESTRule(name) : null;
                var endpoint = options.endpoint;
                if (service || (app && options.endpoint)) {
                    if (service) {
                        endpoint = service.endpoint;
                        options.method = service.method;
                    }
                    if (!options.method) {
                        options.method = "GET";
                    }
                    var queryString = ioQuery.objectToQuery(options.parameters);
                    options.url = "/api/app/" + app + "/service/" + endpoint + "?" + queryString;
                    if (options.accept) {
                        switch (options.accept) {
                            case 'json':
                            case 'application/json':
                                options.accept = 'application/json';
                                options.handleAs = 'json';
                                break;
                            case 'xml':
                            case 'text/xml':
                            case 'application/xml':
                                options.accept = 'application/xml';
                                options.handleAs = 'xml';
                                break;
                        }
                        options.headers = {
                            'accept': options.accept
                        };
                    }
                    return this.sendRequest(options);
                } else {
                    throw new Error("Unknown service " + name);
                }
            } else {
                throw new Error("Missing options");
            }
        },

        /**
         *    Invokes an action
         *    @param {Object} opts - Object holding configuration for the invokation.
         *    @param {String} opts.action - The name of the action to invoke.
         *    @param {Object} opts.record - The record to send to the action
         *    @param {Object} opts.input - Arbitrary data to send to the action
         *    @param {Object} opts.parameters - Parameters to send to the action
         *    @param {Boolean} opts.async - Execute the action asynchronously
         *    @returns {Promise} - A dojo deferred object (See the {@link http://dojotoolkit.org/reference-guide/1.9/dojo/Deferred.html|Dojo documentation}.
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"Runtime@Context",
         *     "paramTypes":["Object"],
         *	  "objectTypeOverride": {
         *		"opts": {
         *			"action":"String/Action-ID",
         *			"record":"Object",
         *		    "input": "Object"
         *          "parameters": "Object",
         *          "async": "Boolean"
         *		}
         *	  }
         *	  }
         */
        invokeAction: function (opts) {
            var t = this;
            var name = opts.action;
            var action = this.schema.getActionByName(name);
            if (action) {
                var options = {
                    url: "/api/app/" + this.schema.getName() + "/action/" + name + "/invoke",
                    method: 'POST',
                    onSuccess: opts.onSuccess,
                    onError: opts.onError,
                    noSpinner: opts.noSpinner
                };
                options.data = {
                    async: !!opts.async,
                    noSpinner: opts.noSpinner
                };
                if (opts.record) {
                    var record = opts.record;
                    if (record) {
                        if (typeof (record) == "string") {
                            options.data.recordId = record;
                        } else {
                            options.data.record = record;
                        }
                        options.data.recordModel = opts.recordModel;
                        if (record.getModel) {
                            let model = record.getModel();
                            if (model) {
                                options.data.recordModel = model.getName();
                            }
                        }
                        if (!options.data.recordModel) {
                            throw "Missing record-model";
                        }
                    }
                } else {
                    if (opts.input) {
                        options.data.input = opts.input;
                    }
                    if (opts.parameters) {
                        options.data.params = opts.parameters;
                    }
                }
                if (!opts.async) {
                    return this.sendRequest(options);
                } else {
                    var bus = t.getMessageBus();
                    return new Promise(function(resolve, reject) {
                        var ready = null;
                        if (opts.callback) {
                            var traceId = traceid();
                            var colon = traceId.indexOf(':');
                            var processId = traceId.substring(0, colon);
                            var threadId = traceId.substring(colon + 1);
                            options.data.traceid = traceId;
                            var sub = bus.subscribe("app." + t.schema.name + ".job." + processId, function (msg) {
                                var event = msg.content;
                                var type = event.event;
                                var message = event.data;
                                try {
                                    opts.callback(type, message);
                                } finally {
                                    if (type == "success" || type == "failure") {
                                        sub.close();
                                    }
                                }
                            });
                            ready = sub.ready();
                        } else {
                            ready = Promise.resolve();
                        }
                        ready.then(function() {
                            t.sendRequest(options).then(function (res) {
                                resolve(res);
                            }, function (error) {
                                reject(error);
                            });
                        });
                    });
                }
            } else {
                return Promise.reject("No such action '" + opts.action + "'");
            }
        },

        /**
         *    Invokes a platform service
         *    @param {Object} opts - Options
         *    @param {String} opts.service - Name of platform-service to invoke
         *    @param {Number} opts.timeout - Timeout in seconds. Max amount of time to wait for service-response.
         *    @returns {Promise}
         *    @instance
         *    @memberof context
         */
        invokePlatformService: function (opts) {
            var name = opts;
            var timeout = null;
            if (lang.isObject(opts)) {
                name = opts.service;
                timeout = opts.timeout;
            }
            var args = [];
            if (arguments.length > 1) {
                for (var i = 1; i < arguments.length; i++) {
                    args.push(arguments[i]);
                }
            }
            var headers = {};
            if (timeout) {
                headers['X-Timeout'] = timeout;
            }
            var opts = {
                url: "/api/service/" + name,
                method: 'POST',
                headers: headers,
                data: args
            };
            return this.sendRequest(opts);
        },

        invokeIntegration: function (opts) {
            var def = null;
            var integration = schema.getIntegration(opts.name);
            if (integration) {
                var url = '/api/app/' + this.schema.name + "/integration/" + integration.name + "/" + opts['function'];
                var data = {
                    args: opts.args,
                    timeout: opts.timeout
                };
                def = this.sendRequest({
                    url: url,
                    data: data
                });
            } else {
                def = new Deferred();
                def.reject("Uknown integration " + opts.name);
            }
            return def;
        },

        /**
         *    Checks whether the user has the right to view the specified view.
         *    @returns {Boolean} - True if the user is allowed to view the specified view, otherwise false.
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"UI@Context",
         *     "returnType":"Boolean",
         *     "paramTypes":["String/View-ID"],
         *     "tooltip": "$"
         * 	}
         */
        isViewAccessible: function (viewId) {
            return this.viewManager.isViewAccessible(viewId);
        },

        /**
         *    Gets the Date-API
         *
         *    @returns {DateFunctions}
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"UI@Context",
         *     "returnType":"DateFunctions",
         *     "tooltip": "$"
         * 	}
         */
        getDateFunctions: function () {
            return dateFunctions;
        },

        /**
         *    Gets the String-API
         *
         *    @returns {StringFunctions}
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"UI@Context",
         *     "returnType":"StringFunctions",
         *     "tooltip": "$"
         * 	}
         */
        getStringFunctions: function () {
            return StringFunctions;
        },

        /**
         *    Gets the Data-API
         *
         *    @returns {DataFunctions}
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"UI@Context",
         *     "returnType":"DataFunctions",
         *     "tooltip": "$"
         * 	}
         */
        getDataFunctions: function () {
            return this.dataFunctions;
        },

        getPaymentFunctions: function () {
            return paymentFunctions;
        },

        /**
         *    Gets the Numeric API
         *
         *    @returns {NumericFunctions}
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"UI@Context",
         *     "returnType":"NumericFunctions",
         *     "tooltip": "$"
         * 	}
         */
        getNumericFunctions: function () {
            return numericFunctions;
        },

        /**
         *    Gets the General API
         *
         *    @returns {GeneralFunctions}
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"UI@Context",
         *     "returnType":"GeneralFunctions",
         *     "tooltip": "$"
         * 	}
         */
        getGeneralFunctions: function () {
            return generalFunctions;
        },

        /**
         *    Gets the Geo API
         *
         *    @returns {GeoFunctions}
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"UI@Context",
         *     "returnType":"GeoFunctions",
         *     "tooltip": "$"
         * 	}
         */
        getGeoLocation: function () {
            GeoLocation.setContext(this);
            return GeoLocation;
        },

        getHolidays: function () {
            return Holydays;
        },

        getHolydays: function () {
            return Holydays;
        },

        getCalenderEventManager: function (opts) {
            var attrList = ["startAttr", "endAttr", "descriptionAttr", "repeatYearlyAttribute", "repeatMonthlyAttribute", "repeatWeeklyAttribute", "repeatDailyAttribute", "repeatException", "originalStartAttr", "repeatDurationAttribute"]
            var missingOpts = new Array();
            attrList.forEach(function (attrName) {
                if (!opts[attrName]) {
                    missingOpts.push(attrName);
                }
            });
            if (missingOpts.length == 0) {
                return new CEM(opts);
            } else {
                console.error("Missing options", missingOpts);
            }
        },

        /**
         *    Returns the full URI of the specified URL.
         *    @param {String} url -
         *    @returns {String} - The full URI
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"Runtime@Context",
         *     "returnType":"String",
         *     "paramTypes":["String"],
         *     "shadowBlocks": {
         *     	"url": "text#api endpoint"
         *     }
         * 	}
         */
        getURI: function (url) {
            return client.getURI(url);
        },

        redirect: function(url) {
            window.location.href = url;
        },

        getCookie: function(name) {
            var value;
            // nosemgrep: detect-non-literal-regexp
            var regex = new RegExp('(^| )' + name + '=([^;]+)');
            var match = document.cookie.match(regex)
            if (match) {
                value = match[2];
            }
            return value;
        },

        isHubMode: function() {
            var hub = false;
            if (client.isHub()) {
                switch (client.getDomainVendor()) {
                    case "hron":
                        var url = this.getParameter("redirectUrl");
                        hub == !!url;
                        break;
                    case "planday":
                        break;
                }
            }
            return hub;
        },

        returnToVendor: function(success) {
            if (client.isVendorDomain()) {
                var vendor = client.getDomainVendor();
                switch (vendor) {
                    case "hron":
                        var url = this.getParameter("redirectUrl");
                        if (!url) {
                            url = this.getCookie("x-redirect-hron");
                        }
                        if (!url) {
                            url = this.getCookie("x-vendor-from");
                        }
                        if (url) {
                            var rurl = new URL(url);
                            rurl.searchParams.append("final", !!success);
                            if (url) {
                                window.location = rurl;
                            }
                        }
                        break;
                }
            }
        },

        /**
         *    Returns previously stored clientside data.
         *    @param {String} name - The identifier used when storing the data.
         *    @param {Object} def - Default return value if no value is found
         *    @returns {Object} - The data, or the default value if none was found.
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"Runtime@Context",
         *     "returnType":"Object",
         *     "paramTypes":["String", "Object"],
         *     "shadowBlocks": {
         *     	"name": "text#name"
         *     }
         * 	}
         */
        getData: function (name, def) {
            var val = this.globalData[name];
            if (val === undefined) {
                val = Global.get(name);
            }
            if (val === undefined) {
                var json = localStorage.getItem(this.schema.id + '_' + name);
                var val = json;
                try {
                    val = JSON.parse(val);
                } catch (error) {
                    // ignore
                }
            }
            if (val === undefined) {
                val = def;
            }
            return val;
        },

        //@param {("persistent" | "global" | "default")} scope - The availability scope of the data.

        /**
         *    Stores clientside data.
         *    @param {String} name - An identifier for the data. Must be specified when loading the data again.
         *    @param {Object} value - The value to store.
         *    @param {String} scope - The availability scope of the data ('global' or 'persistent'). By default data is scoped to the current view only, global-scope means it will be available in all views but not persisted - persistent means it is global and persisted.
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"Runtime@Context",
         *     "paramTypes":["String", "Object", "String/Data-TYPE"],
         *     "shadowBlocks": {
         *     	"name": "text#name",
         *     	"value": "object#value1#value2"
         *     }
         * 	}
         */
        setData: function (name, value, scope) {
            if (scope == 'persistent') {
                if (value == undefined || value == null) {
                    //console.log("Removing from localStorage " + name);
                    localStorage.removeItem(this.schema.id + '_' + name);
                } else {
                    var json = value;
                    if (lang.isObject(value)) {
                        if (value.toJSON) {
                            var val = value.toJSON();
                            json = JSON.stringify(val);
                        } else {
                            json = JSON.stringify(value);
                        }
                    } else if (value && value.toString) {
                        json = value.toString();
                    }
                    //console.log("Writing to localStorage " + name + " = " + json);
                    localStorage.setItem(this.schema.id + '_' + name, json);
                }
            } else if (scope == 'global') {
                Global.set(name, value);
            } else {
                this.globalData[name] = value;
            }
        },

        /**
         *    Invokes a function defined on the current view.
         *    @param {String} funcName - The name of the function.
         *    @param {Object} args - Object with named arguments to pass to the function. These will be available via the args-parameter passed to the function.
         *    @returns {Object} - The functions return value, if any.
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"Runtime@Context",
         *     "returnType":"Null",
         *     "paramTypes":["String", "null"],
         *     "tooltip": "$",
         *     "toggleReturn":"true",
         *     "shadowBlocks": {
         *     	"funcName": "text#function name"
         *     }
         * 	}
         */
        invoke: function (funcName, args, asyn) {
            var res = undefined;
            var func = undefined;
            if (this.globalRegistry) {
                func = this.globalRegistry('function', funcName);
            }
            if (!func) {
                func = this.view.getFunction(funcName);
            }

            if (!func) {
                var cview = this.viewManager.getCommonView();
                if (cview) {
                    func = cview.getFunction(funcName);
                }
            }

            if (func) {
                var fc = func.getCompiled(asyn);
                var currentFrame = this.engine.peekFrame();
                var scope = funcName;
                if (currentFrame) {
                    if (currentFrame.scope) {
                        var cscope = currentFrame.scope;
                        if (cscope.getScopeDescriptor) {
                            cscope = cscope.getScopeDescriptor();
                            cscope = cscope + "/" + funcName;
                        }
                    }
                } else {
                    currentFrame = {};
                }
                this.engine.pushFrame({
                    scope: cscope,
                    actionId: currentFrame.actionId,
                    event: currentFrame.event

                });
                try {
                    res = fc(this, args);
                } catch (error) {
                    this.engine.logError(error);
                    throw new Error("Error invoking '" + funcName + "'");
                } finally {
                    this.engine.popFrame();
                }
            } else {
                this.log("ERROR", "Attempting to invoke unknown function '" + funcName + "'");
            }
            return res;
        },

        /**
         * Open a file for viewing
         *
         * @instance
         * @param {Record} file - A document-record to view. Can be either a Record object or an object with checksum, contenttype, and filename properties.
         * @memberof context
         * @returns {Promise} A promise that resolves when the file is opened successfully
         * @example
         * // Open a document record
         * const documentRecord = await context.get("Document", "178068dd48307a37bc03fea300000001");
         * context.openFile(documentRecord);
         *
         * // Or open using file metadata
         * context.openFile({
         *   checksum: "abc123def456",
         *   contenttype: "application/pdf",
         *   filename: "report.pdf"
         * });
         */
        openFile: function (file) {
            if (file && file.declaredClass == 'appivo.model.Record') {
                var model = file.getModel();
                if (model.isDocument()) {
                    var url = file.getDocumentURL();
                    return this.downloadFromUrl(url, file.filename, file.contenttype);
                }
            } else if (file && file.checksum && file.contenttype && file.filename) {
                var url = "/files/" + file.checksum;
                return this.downloadFromUrl(url, file.filename, file.contenttype);
            }
            throw new Error("Not a document-record");
        },

        /**
         * Read a file from the device's file system
         *
         * @instance
         * @param {String} filename - The path to the file to read
         * @param {Object} options - Options for reading the file
         * @param {String} [options.encoding="utf-8"] - The encoding to use when reading the file
         * @memberof context
         * @returns {Promise} A promise that resolves with the file content
         * @example
         * // Read a text file
         * context.readFile("/path/to/file.txt")
         *   .then(function(content) {
         *     console.log("File content:", content);
         *   })
         *   .catch(function(error) {
         *     console.error("Error reading file:", error);
         *   });
         *
         * // Read a binary file with specific encoding
         * context.readFile("/path/to/file.bin", { encoding: "binary" });
         */
        readFile: function(filename, options) {
            if (File._readWriteFile) {
                return File.readFile(filename, options);
            } else {
                throw new Error("File-API not available");
            }
        },

        /**
         * Write content to a file in the device's file system
         *
         * @instance
         * @param {String} filename - The path to the file to write
         * @param {String|Blob|ArrayBuffer} content - The content to write to the file
         * @param {Object} options - Options for writing the file
         * @param {String} [options.encoding="utf-8"] - The encoding to use when writing the file
         * @param {Boolean} [options.append=false] - Whether to append to the file instead of overwriting
         * @memberof context
         * @returns {Promise} A promise that resolves when the file is written successfully
         * @example
         * // Write text to a file
         * context.writeFile("/path/to/file.txt", "Hello, world!")
         *   .then(function() {
         *     console.log("File written successfully");
         *   })
         *   .catch(function(error) {
         *     console.error("Error writing file:", error);
         *   });
         *
         * // Append to a file
         * context.writeFile("/path/to/log.txt", "New log entry\n", { append: true });
         */
        writeFile: function(filename, content, options) {
            if (File._readWriteFile) {
                return File.writeFile(filename, content, options);
            } else {
                throw new Error("File-API not available");
            }
        },

        /**
         * Downloads and opens a file from a URL.
         * On mobile devices, this will download the file to the device and open it with an appropriate app.
         * On desktop browsers, this will open the URL in a new browser tab.
         *
         * @param {String} url - The URL of the file to download
         * @param {String} filename - The name to use when saving the file
         * @param {String} mimetype - The MIME type of the file (e.g., "application/pdf", "image/jpeg")
         * @returns {Promise} A promise that resolves when the file is downloaded and opened successfully
         * @memberof context
         * @example
         * // Download and open a PDF document
         * context.downloadFromUrl(
         *   "https://example.com/documents/report.pdf",
         *   "quarterly-report.pdf",
         *   "application/pdf"
         * )
         * .then(function() {
         *   console.log("File downloaded and opened successfully");
         * })
         * .catch(function(error) {
         *   console.error("Failed to download or open file:", error);
         * });
         */
        downloadFromUrl: function (url, filename, mimetype) {
            var def = new Deferred();
            url = window.encodeURI(url);
            if (url.startsWith("/")) {
                url = client.getURI(url);
            }
            var file = this.getNativeAPI("File");
            if (file) {
                var t = this;
                this.showSpinner();
                file.download({
                    url: url,
                    fileName: filename,
                    onSuccess: function (downloadedFile) {
                        t.hideSpinner();
                        file.open({
                            path: downloadedFile.nativeURL,
                            name: downloadedFile.name,
                            mimetype: mimetype,
                            onSuccess: function () {
                                def.resolve();
                            },
                            onError: function (error) {
                                var errorMsg = messages.errorFailedToOpen;
                                if (error) {
                                    errorMsg = errorMsg + " " + error;
                                }
                                t.notify({
                                    type: "error",
                                    message: errorMsg,
                                    delay: 2
                                });
                                def.reject(errorMsg);
                            }
                        });
                    },
                    onError: function (error) {
                        t.hideSpinner();
                        t.notify({
                            type: "error",
                            message: messages.errorFailedDownload,
                            delay: 2
                        });
                        def.reject(error);
                    }
                });
            } else {
                window.open(url, "_blank", "menubar=yes,titlebar=yes,enableViewportScale=yes");
                def.resolve();
            }
            return def;
        },

        /**
         * Get an application resource by name or ID
         *
         * @instance
         * @param {String} name - Name or ID of resource to get
         * @memberof context
         * @returns {Object} The resource object if found, otherwise null
         * @example
         * // Get a resource by name
         * const logoImage = context.getResource("logo");
         *
         * // Get a resource by ID
         * const headerImage = context.getResource("img_12345");
         */
        getResource: function (name) {
            var rsrc = this.schema.getResourceByName(name);
            if (!rsrc) {
                rsrc = this.schema.getResourceById(name);
            }
            return rsrc;
        },

        /**
         * Get an application resource as an audio-object by name or ID
         *
         * @instance
         * @param {String|Blob|Object} name - Name or ID of resource to get, or a Blob object, or an object with a checksum property
         * @memberof context
         * @returns {Audio} An HTML Audio element for the resource
         * @example
         * // Get audio by resource name
         * const notificationSound = context.getAudio("notification_sound");
         * notificationSound.play();
         *
         * // Get audio from a Blob
         * const audioBlob = await context.textToSpeech("Hello world");
         * const audioElement = context.getAudio(audioBlob);
         *
         * // Get audio from a file object with checksum
         * const audioElement = context.getAudio({
         *   checksum: "abc123def456"
         * });
         */
        getAudio: function (name) {
            var audio = null;
            var url = null;
            if (typeof(name) == 'string') {
                var rsrc = this.schema.getResourceByName(name);
                if (rsrc) {
                    url = this.schema.getResourceURI(rsrc);
                }
            } else if (name instanceof Blob) {
                url = URL.createObjectURL(name);
            } else if (name) {
                if (name.checksum) {
                    url = '/files/' + name.checksum;
                }
            }
            if (url) {
                for (var i = 0; i < this.audioNodes.length; i++) {
                    var node = this.audioNodes[i];
                    if (node.src == url) {
                        audio = node;
                        break;
                    }
                }
                if (!audio) {
                    audio = new Audio(url);
                    this.audioNodes.push(audio);
                }
            }
            return audio;
        },

        /**
         * Loads an application resource as a JSON-object
         *
         * @instance
         * @param {Object} options - Options for loading the resource
         * @param {String} options.name - Resource name or ID
         * @param {Function} [options.onSuccess] - Callback function called when the resource is loaded successfully
         * @param {Function} [options.onError] - Callback function called when an error occurs
         * @memberof context
         * @returns {Promise} A promise that resolves with the JSON content of the resource
         * @example
         * // Load a JSON resource
         * context.loadResource({
         *   name: "config",
         *   onSuccess: function(data) {
         *     console.log("Config loaded:", data);
         *   },
         *   onError: function(error) {
         *     console.error("Error loading config:", error);
         *   }
         * });
         *
         * // Using promises
         * context.loadResource({ name: "settings" })
         *   .then(function(settings) {
         *     console.log("Settings loaded:", settings);
         *   })
         *   .catch(function(error) {
         *     console.error("Error loading settings:", error);
         *   });
         */
        loadResource: function (options) {
            return this.getResourceAsObject(options);
        },

        getResourceAsObject: function (options) {
            var def = null;
            if (options && options.name) {
                var resource = this.getResource(options.name);
                if (resource) {
                    if (resource.contenttype && resource.contenttype.indexOf('json') > -1) {
                        def = this.sendRequest({
                            url: this.schema.getResourceURI(resource),
                            onSuccess: options.onSuccess,
                            onError: options.onError
                        });
                    } else {
                        def = new Deferred();
                        def.reject("Resource is not a json-document: " + options.name);
                    }
                } else {
                    def = new Deferred();
                    def.reject("Unknown resource " + options.name);
                }
            } else {
                console.error("Missing resource-name");
                def = new Deferred();
                def.reject("Must provide name of resource");
            }
            return def;
        },

        /**
         * Checks if the current device supports audio recording capabilities
         *
         * @instance
         * @memberof context
         * @returns {boolean} True if audio recording is supported on the current device, false otherwise
         * @example
         * // Check if audio recording is available before attempting to use it
         * if (context.hasAudioRecording()) {
         *   // Audio recording is supported
         *   context.startAudioRecording()
         *     .then(function(success) {
         *       if (success) {
         *         console.log("Audio recording started successfully");
         *       } else {
         *         console.error("Failed to start audio recording");
         *       }
         *     });
         * } else {
         *   console.warn("Audio recording is not supported on this device");
         *   // Provide alternative functionality
         * }
         */
        hasAudioRecording: function() {
            return navigator.mediaDevices && navigator.mediaDevices.getUserMedia;
        },

        /**
         * Starts audio recording on the device
         *
         * @instance
         * @async
         * @param {Function} [callback] - Callback function that will be called with recording status updates
         * @param {Object} [options] - Configuration options for the audio recording
         * @param {string} [options.mimeType='audio/webm'] - The MIME type of the audio recording
         * @param {number} [options.sampleRate=44100] - The sample rate of the audio recording in Hz
         * @param {boolean} [options.echoCancellation=true] - Whether to enable echo cancellation
         * @param {boolean} [options.noiseSuppression=true] - Whether to enable noise suppression
         * @param {boolean} [options.autoGainControl=true] - Whether to enable automatic gain control
         * @memberof context
         * @returns {Promise<boolean>} A promise that resolves to true if recording started successfully, false otherwise
         * @example
         * // Start audio recording with default options
         * context.startAudioRecording()
         *   .then(function(success) {
         *     if (success) {
         *       console.log("Audio recording started successfully");
         *
         *       // Record for 5 seconds then stop
         *       setTimeout(function() {
         *         context.stopAudioRecording()
         *           .then(function(audioBlob) {
         *             console.log("Recording complete, blob size:", audioBlob.size);
         *             // Use the recorded audio blob
         *           });
         *       }, 5000);
         *     } else {
         *       console.error("Failed to start audio recording");
         *     }
         *   });
         *
         * // Start recording with a callback and custom options
         * context.startAudioRecording(
         *   function(status) {
         *     console.log("Recording status:", status);
         *   },
         *   {
         *     mimeType: 'audio/mp4',
         *     sampleRate: 16000,
         *     echoCancellation: false
         *   }
         * );
         */
        startAudioRecording: async function(callback, options) {
            let ok = false;
            if (!this._audioRecorder) {
                this._audioRecorder = new AudioRecorder();
                try {
                    await this._audioRecorder.initialize();

                    this._audioRecorder.startRecording();

                    ok = true;
                } catch (error) {
                    console.error('Failed to initialize audio recorder', error);
                    if (this._audioRecorder) {
                        this._audioRecorder.cleanup();
                        this._audioRecord = null;
                    }
                    return false;
                }
            }
            return ok;
        },

        isAudioRecording: function() {
            return !!this.audioRecorder && this._audioRecorder.isRecording();
        },

        stopAudioRecording: async function() {
            if (this._audioRecorder) {
                const blob = await this._audioRecorder.stopRecording();
                this._audioRecorder.cleanup();
                this._audioRecorder = null;
                return blob;
            } else {
                return Promise.reject();
            }
        },

        speechToText: function(audio) {
            return client.sendRequest('/api/speech-to-text', {
                method: 'POST',
                contentType: audio.type,
                handleAs: 'json',
                data: audio
            });
        },

        textToSpeech: async function(text, options) {
            const t = this;
            const audioPlayer = this.getAudioPlayer();
            options = options || {};
            let lang = options.language || t.getLanguage();
            const data = {
                text: text,
                language: lang,
                voice: options.voice,
                provider: options.provider || 'google',
                gender: options.gender || 'female'
            };
            await audioPlayer.loadAudio("/api/text-to-speech", data);
            if (options.autoPlay || options.autoPlay === undefined) {
                audioPlayer.play();
            }
            if (options.format == "audio") {
                return t.getAudio(audioPlayer.getAudioBlobURL());
            } else {
                return audioPlayer.getAudioBlob();
            }
        },

        /**
         * Checks if speech recognition is supported
         * @returns {boolean}
         */
        hasSpeechRecognition: function() {
            return !!(window.SpeechRecognition || window.webkitSpeechRecognition);
        },

        /**
         * Starts speech recognition
         *
         *  @param {Function} callback - Callback function
         *  @param {Object} options - Options
         */
        startSpeechRecognition: function(callback, options) {
            const t = this;
            const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
            t.speechDetected = false;

            if (t.recognition) {
                console.warn("Speech recognition already started");
                return t.recognition;
            }
            if (SpeechRecognition) {
                let fulltext = "";
                t.recognition = new SpeechRecognition();
                console.log("Starting speech recognition");
                if (options) {
                    t.recognition.continuous = options.continuous || false;
                    t.recognition.interimResults = options.interimResults || false;
                }
                t.recognition.addEventListener('result', function(event) {
                    console.log("GOT SPEECH RESULT: ", event.results);
                    let preview = "";
                    let completed = "";
                    let androidStr = "";
                    for (let i = 0; i < event.results.length; i++) {
                        const str = event.results[i];
                        const isLast = (i + 1) == event.results.length;
                        if (str[0].transcript.startsWith(androidStr) ) {
                            androidStr = str[0].transcript;
                        } else {
                            androidStr = null;
                            break;
                        }
                        if (!isLast) {
                            if (str[0].confidence !== 0) {
                                androidStr = null;
                                break;
                            }
                            if (!str.isFinal) {
                                androidStr = null;
                                break;
                            }
                        }
                    }
                    if (androidStr) {
                        try {
                            callback({
                                type: 'speech',
                                preview: androidStr,
                                text: androidStr
                            });
                            return;
                        } catch (error) {
                            console.error("Speech callback error: ", error);
                        }
                    }

                    for (let i = event.resultIndex; i < event.results.length; i++) {
                        let result = event.results[i];
                        if (result.isFinal) {
                            completed += result[0].transcript + ' ';
                            preview += result[0].transcript + ' ';
                        } else {
                            preview += result[0].transcript + ' ';
                        }
                    }
                    completed = completed.trim();
                    preview = preview.trim();
                    console.log("SPEECH", {
                        completed: completed,
                        preview: preview
                    });

                    let temp = fulltext + (fulltext ? " " : "") + preview;

                    if (completed) {
                        fulltext += (fulltext ? " " : "") + completed;
                        completed = "";
                    }

                    try {
                        callback({
                            type: 'speech',
                            preview: temp,
                            text: fulltext
                        });
                    } catch (error) {
                        console.error("Speech callback error: ", error);
                    }
                    if (preview) {
                        t.speechDetected = true;
                    }
                    if (completed && t.recognition && !t.recognition.continuous ) {
                        t.stopSpeechRecognition();
                    }
                });
                t.recognition.addEventListener('speechstart', function (event) {
                    console.log("Speech recognition started");
                });
                t.recognition.addEventListener('start', function (event) {
                    callback({
                        type: 'start',
                        event: event
                    });
                });
                t.recognition.addEventListener('end', function (event) {
                    callback({
                        type: 'end',
                        event: event
                    });
                    t.recognition = null;
                });
                t.recognition.addEventListener('error', function (event) {
                    console.error("Speech recognition error: ", event.error);
                    callback({
                        type: 'error',
                        event: event,
                        error: event.error
                    });
                });
                t.recognition.start();
            } else {
                console.warn("Speech recognition not supported");
            }
            return t.recognition;
        },

        /**
         * Stops speech recognition
         */
        stopSpeechRecognition: function() {
            const t = this;
            t._stopSpeechRecognition();
            return new Promise((resolve, reject) => {
                if (t.recognition) {
                    if (!t.speechDetected) {
                        let count = 10;
                        let interval = setInterval(function () {
                            if (t.speechDetected || count-- <= 0) {
                                clearInterval(interval);
                                resolve();
                            }
                        }, 100);
                    } else {
                        resolve();
                    }
                } else {
                    resolve();
                }
            });
        },

        _stopSpeechRecognition: function() {
            if (this.recognition) {
                this.recognition.stop();
            }
        },

        /**
         * Plays the specified sound resource
         * @param {String} name - The name of the sound resource.
         * @instance
         * @memberof context
         *
         * @LogicMeta {
         * 	  "api": "UI@Context",
         * 	  "tooltip": "$",
         * 	  "paramTypes": ["String", "Object"]
         * }
         */
        playSound: function (name, opts) {
            var audio = this.getAudio(name);
            if (audio) {
                audio.play();
            }
        },

        initializeAudio: function() {
            return this.getAudioPlayer();
        },

        getAudioPlayer: function() {
            if (!this._audioPlayer) {
                this._audioPlayer = new AudioPlayer();
            }
            return this._audioPlayer;
        },

        /**
         *    Shows the loading indicator
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"UI@Context",
         *     "tooltip": "$",
         *	  "paramTypes":["String"]
         * 	}
         */
        showSpinner: function (loadingMessage) {
            this.view.showLoadingIndicator(loadingMessage);
        },

        /**
         *    Hides the loading indicator
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"UI@Context",
         *     "tooltip": "$"
         * 	}
         */
        hideSpinner: function () {
            this.view.hideLoadingIndicator();
        },

        /**
         *    Creates a new widget using the specified data.
         *    @param {Object} opts - Configuration object.
         *    @param {Object} opts.attachPoint - The point to attach the widget to (optional).
         *    @param {Object} opts.parent - A parent widget (optional).
         *    @param {Object} opts.widget - The widget data.
         *    @param {Object} value - Value to set on the newly created widget
         *    @instance
         *    @memberof context
         *    @returns {Promise}
         *
         *    @LogicMeta {
         *     "api":"UI@Context",
         *     "paramTypes":["Object"],
         *     "tooltip": "$"
         * 	}
         */
        createWidget: function (opts, value) {
            var t = this;
            var def = new Deferred();
            var parent = opts.parent ? opts.parent.widget : null;
            var widgetValue = value;
            when(opts.parent, function (parent) {
                if (parent && parent.getId) {
                    parent = parent.getId();
                }
                if (parent) {
                    parent = t.getWidget(parent);
                }
                if (parent) {
                    parent = parent.widget;
                }

                if (opts.widget) {
                    if (opts.widget.disabled === undefined) {
                        opts.widget.disabled = false;
                    }
                }
                var attachPoint = opts.attachPoint ? opts.attachPoint : null;
                var vl = t.view.getViewLoader();
                vl.loadAndCreateWidget(opts.widget, parent).then(function (w) {
                    w.peer.destroy = function () {
                        t.view.unregisterWidget(w);
                        try {
                            parent.removeChild(w);
                        } catch (error) {
                            console.error(error);
                        }
                        try {
                            w.destroy();
                        } catch (error) {
                            console.error(error);
                        }
                    };
                    t.view.registerWidget(w);
                    w.__dynamicInstance = true;
                    if (parent) {
                        parent.addChild(w, attachPoint);
                    }
                    if (widgetValue) {
                        w.setValue(widgetValue);
                    } else if (opts.widget && opts.widget.formName) {
                        var form = t.getForm(opts.widget.formName);
                        if (form && opts.widget.attributeName) {
                            var attrName = opts.widget.attributeName;
                            var value = form.getValue(attrName, true);
                            if (value) {
                                form.setValue(attrName, value);
                            }
                        } else if (form && elm.relationName) {
                            var relName = opts.widget.relationName;
                            var value = form.getValue(relName, true);
                            if (value) {
                                form.setValue(relName, value);
                            }
                        }
                    }
                    if (opts.onSuccess) {
                        opts.onSuccess(w.peer);
                    }
                    if (w.widget.layout) {
                        w.widget.layout();
                    }
                    def.resolve(w.peer);
                }, function (error) {
                    if (opts.onError) {
                        opts.onError(error);
                    }
                    def.reject(error);
                });
            });
            return def;
        },

		/**
		 *    Detect and create links in plain text
		 *    @param {String} text - The text to linkify
         *    @param {Object} options - Options
         *    @param {Boolean} options.strip - Whether to remove existing HTML tags (including links)
         *    @param {String} options.target - Target for links (e.g. _blank to open up in a new tab)
         *    @instance
         *    @memberof context
         *    @returns {String}
         *
		 *    @LogicMeta {
		 *     "api":"UI@Context",
		 *     "tooltip": "$",
		 *	   "paramTypes":["String", "Object"]
		 * 	}
		 */
		linkify: function(text, options) {
			if (!options) {
				options = {};
			}
			if (options.strip) {
				var tmp = document.createElement('div');
                // nosemgrep: insecure-document-method
				tmp.innerHTML = text;
				text = tmp.innerText;
			}
			return text.replace(LINKIFY_REGEX, function(url) {
				var link = '<a href="' + url + '"';
				if (options.target) {
					link += ' target="' + options.target + '"';
				}
				link += '>' + url + '</a>';
				return link;
			});
		},

        /**
         *    Logs a message to the console.
         *    @param {String} level The message to log.
         *    @param {String} message The message to log.
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"Runtime@Context",
         *     "paramTypes":["null", "String"],
         *     "tooltip": "$",
         *     "shadowBlocks": {
         *     	"log": "text#message"
         *     }
         * 	}
         */
        log: function (level, message) {
            if (!message) {
                message = level;
                level = undefined;
            }
            if (!level) {
                level = 'INFO';
            }
            if (lang.isObject(message) && !lang.isString(message)) {
                try {
                    message = JSON.stringify(message);
                } catch (error) {
                    if (message.toString) {
                        message = message.toString();
                    }
                }
            }
            var frame = this.engine.peekFrame();
            var desc = '';
            var event = 'unknown';
            if (frame) {
                if (frame.scope && frame.scope.getScopeDescriptor) {
                    desc = frame.scope.getScopeDescriptor();
                } else {
                    desc = frame.scope;
                }
                event = frame.event;
            }
            try {
                var lc = 'blue';
                switch (level) {
                    case 'ERROR':
                        lc = 'red';
                        break;
                    case 'WARN':
                        lc = 'orange';
                        break;
                    case 'DEBUG':
                        lc = 'green';
                        break;
                }
                // nosemgrep: unsafe-formatstring
                console.log('%c ' + level + ' %c ' + desc + ' %c  ' + message, 'background: ' + lc + ';color:white;border-radius:3px', 'margin-left:8px;background:green;color:white;border-radius:3px', '');
            } catch (error) {
                // fallback
                console.log(level + ': ' + message);
            }
            this.schema.logEntry({
                level: level,
                message: message,
                entry_type: 'UI',
                entry_name: desc,
                entry_id: event
            });
        },

        /**
         *    Checks if the user has the specified feature enabled.
         *    @param {String} name - The feature name
         *    @returns {Boolean} - True if the user has the feature enabled, otherwise false.
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"Runtime@Context",
         *     "returnType":"Boolean",
         *     "paramTypes":["String"],
         *     "shadowBlocks": {
         *     	"name": "text#feature name"
         *     }
         * 	}
         */
        hasFeature: function (name) {
            var ret = false;
            if (this.features[name]) {
                ret = true;
            }
            return ret;
        },

        getObjectProperty: function (obj, path) {
            var value = obj;
            var props = path.split(".");
            for (var i = 0; i < props.length; i++) {
                // nosemgrep: prototype-pollution-loop
                var p = props[i];
                if (value && value[p]) {
                    value = value[p];
                } else {
                    value = null;
                    break;
                }
            }
            return value;
        },

        /**
         *    Schedules a task to be performed in set intervals
         *    @param {Object} options - Configuration object
         *    @param {Function} options.callback - The task to be performed.
         *    @param {Function} options.cancel - Callback when the task is cancelled.
         *    @param {String} options.name - An identifier for the task.
         *    @param {Number} options.interval - The interval (in milliseconds) between each task run.
         *    @param {Boolean} options.repeat - Specifies whether the task should be repeated after its first run or not.
         *    @returns {String} - The id of the task. This is needed to stop the task.
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"Runtime@Context",
         *     "returnType":"Integer",
         *     "paramTypes":["Object"],
         *     "tooltip": "$"
         * 	}
         */
        scheduleTask: function (options) {
            var tid = null;
            var t = this;
            if (options && options.callback) {
                var name = options.name;
                if (!name) {
                    name = "Timer-" + (t.timerName++);
                }
                var interval = options.interval ? options.interval : 0;
                var task = {
                    name: name,
                    debug: options.debug,
                    interval: interval,
                    repeat: !!options.repeat,
                    cancel: options.cancel
                };
                var callback = function () {
                    if (task.debug) {
                        console.log("Executing task " + t.id + ':' + name);
                    }
                    try {
                        options.callback();
                    } finally {
                        if (!options.repeat) {
                            delete t.timers[task.id];
                        }
                    }
                };
                task.callback = callback;
                task.id = options.repeat ? setInterval(options.callback, interval) : setTimeout(callback, interval);
                tid = task.id;
                this.timers[task.id] = task;
            }
            return tid;
        },

        /**
         *    Stops a scheduled task.
         *    @param {String} tid - The id that was returned when scheduling the task.
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"Runtime@Context",
         *     "paramTypes":["Integer"],
         *     "tooltip": "$"
         * 	}
         */
        unscheduleTask: function (tid) {
            var task = this.timers[tid];
            if (task) {
                this._killTimer(tid);
            }
        },

        _killTimer: function (tid) {
            var task = this.timers[tid];
            if (task) {
                if (task.repeat) {
                    clearInterval(task.id);
                } else {
                    clearTimeout(task.id);
                }
                if (task.cancel) {
                    task.cancel();
                }
                delete this.timers[task.id];
            }
        },

        _killAllTimers: function () {
            if (this.timers) {
                for (var key in this.timers) {
                    this._killTimer(key);
                }
            }
            this.timerName = 0;
        },

        _resetGlobalData: function () {
            this.globalData = {};
        },

        newPromise: function () {
            return new Deferred();
        },

        allPromises: function (promises) {
            return allPromises(promises);
        },

        _createPromise: function () {
            return new Deferred();
        },

        /**
         *    Gets the API of a plugin.
         *    @param {String} plugin - The name of the plugin to get.
         *    @instance
         *    @memberof context
         *
         *    @LogicMeta {
         *     "api":"UI@Context",
         *     "returnType":"Object",
         *     "paramTypes":["String"],
         *     "tooltip": "$"
         * 	}
         */
        getPlugin: function (name) {
            return this.getNativeAPI(name);
        },

        /**
         * Gets the API of an integration-module
         * @param {String/Integration-ID} integration - The name of the integration to get
         * @param {Object} options
         * @param {Number} options.timeout - Timeout for function invocations (in seconds). Default is 120.
         * @instance
         * @memberof context
         *
         *    @LogicMeta {
         *     "api":"UI@Context",
         *     "returnType":"Integration",
         *     "paramTypes":["String/Integration-ID","Object"],
         *     "tooltip": "$"
         * 	}
         */
        getIntegration: function (name, options) {
            var module = null;
            var integration = this.schema.getIntegration(name);
            if (integration) {
                module = this.proxyFactory.createProxy(this, integration, options);
            }
            return module;
        },

        /**
         * Add an event listener to the document.
         * @param {String} type - The event type to listen for.
         * @param {Function} listener - The event listener function.
         * @param {Object} options - Event listener options
         * @returns {String}
         */
        addEventListener: function (type, listener, options) {
            let id = Math.random().toString(36).substr(2, 9);
            let l = {
                type: type,
                listener: listener,
                options: options,
                id: id
            };
            this.listenerMap[id] = l;
            document.addEventListener(type, listener, options);
            return id;
        },

        /**
         * Removes an event listener from the document.
         * @param {String} id - The id of the event listener to remove.
         */
        removeEventListener: function(id) {
            let l = this.listenerMap[id];
            if (l) {
                document.removeEventListener(l.type, l.listener, l.options);
                delete this.listenerMap[id];
            }
        },

        getNativeAPI: function (name) {
            if (client.isHybrid()) {
                var plugin = window._appivoMobile[name];
                var api = null;

                if (plugin) {
                    var location = plugin.location;
                    if (location && typeof location == "string") {
                        // traverse the path until we find the correct object
                        // nosemgrep: prototype-pollution-loop
                        var props = location.split(".");
                        api = window;
                        for (var i = 0; i < props.length; i++) {
                            api = api[props[i]];
                        }
                    } else if (location) {
                        api = location;
                    } else {
                        // backwards compatibility for how this function used to look
                        api = this.nativeAPI[name];
                    }
                }

                return api;
            }

            return null;
        },

        _killAudio: function () {
            if (this.audioNodes) {
                for (var i = 0; i < this.audioNodes.length; i++) {
                    var audio = this.audioNodes[i];
                    audio.pause();
                    audio.remove();
                }
            }
            delete this.audioNodes;
        },

        _killSubscriptions: function () {
            for (var i = 0; i < this.subscriptions.length; i++) {
                var sub = this.subscriptions[i];
                try {
                    sub.close();
                } catch (error) {
                }
                this.subscriptions = [];
            }
        },

        _killListeners: function() {
            for (key in this.listenerMap) {
                var l = this.listenerMap[key];
                this.removeEventListener(l.id);
            }
            this.listenerMap = {};
        },

        _destroy: function () {
            this._killAllTimers();
            this._killAudio();
            this._killSubscriptions();
            this._killListeners();
            this.comBus.clear();
            GeoLocation._clearWatches();
        }
    })
});

},
'lodash/lodash':function(){
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.15';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
      typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
          typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
              typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
                  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
      typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
          typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
              typedArrayTags[errorTag] = typedArrayTags[funcTag] =
                  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
                      typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
                          typedArrayTags[setTag] = typedArrayTags[stringTag] =
                              typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
      cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
          cloneableTags[boolTag] = cloneableTags[dateTag] =
              cloneableTags[float32Tag] = cloneableTags[float64Tag] =
                  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
                      cloneableTags[int32Tag] = cloneableTags[mapTag] =
                          cloneableTags[numberTag] = cloneableTags[objectTag] =
                              cloneableTags[regexpTag] = cloneableTags[setTag] =
                                  cloneableTags[stringTag] = cloneableTags[symbolTag] =
                                      cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
                                          cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
      cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
        ? strictIndexOf(array, value, fromIndex)
        : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
          ? (initAccum = false, value)
          : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
        ? unicodeSize(string)
        : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
        ? unicodeToArray(string)
        : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
        funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
            .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
          while (length-- && resIndex < takeCount) {
            index += dir;

            var iterIndex = -1,
                value = array[index];

            while (++iterIndex < iterLength) {
              var data = iteratees[iterIndex],
                  iteratee = data.iteratee,
                  type = data.type,
                  computed = iteratee(value);

              if (type == LAZY_MAP_FLAG) {
                value = computed;
              } else if (!computed) {
                if (type == LAZY_FILTER_FLAG) {
                  continue outer;
                } else {
                  break outer;
                }
              }
            }
            result[resIndex++] = value;
          }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
                // Safari 9 has enumerable `arguments.length` in strict mode.
                key == 'length' ||
                // Node.js 0.10 has enumerable non-index properties on buffers.
                (isBuff && (key == 'offset' || key == 'parent')) ||
                // PhantomJS 2 has enumerable non-index properties on typed arrays.
                (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
                // Skip index properties.
                isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
                ? copySymbolsIn(value, baseAssignIn(result, value))
                : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
          ? (isFlat ? getAllKeysIn : getAllKeys)
          : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
          while (++index < length) {
            var value = array[index],
                computed = iteratee == null ? value : iteratee(value);

            value = (comparator || value !== 0) ? value : 0;
            if (isCommon && computed === computed) {
              var valuesIndex = valuesLength;
              while (valuesIndex--) {
                if (values[valuesIndex] === computed) {
                  continue outer;
                }
              }
              result.push(value);
            }
            else if (!includes(values, computed, comparator)) {
              result.push(value);
            }
          }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
                ? (current === current && !isSymbol(current))
                : comparator(current, computed)
        )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
          ? getRawTag(value)
          : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
            ? new SetCache(othIndex && array)
            : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
          while (++index < length && result.length < maxLength) {
            var value = array[index],
                computed = iteratee ? iteratee(value) : value;

            value = (comparator || value !== 0) ? value : 0;
            if (!(seen
                    ? cacheHas(seen, computed)
                    : includes(result, computed, comparator)
            )) {
              othIndex = othLength;
              while (--othIndex) {
                var cache = caches[othIndex];
                if (!(cache
                    ? cacheHas(cache, computed)
                    : includes(arrays[othIndex], computed, comparator))
                ) {
                  continue outer;
                }
              }
              if (seen) {
                seen.push(computed);
              }
              result.push(value);
            }
          }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
            ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
            : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
            ? data[1] !== object[data[0]]
            : !(data[0] in object)
        ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                  ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                  : result
          )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
          isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
            ? baseMatchesProperty(value[0], value[1])
            : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
            ? hasIn(object, path)
            : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
              ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
              : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
          ? customizer(objValue, srcValue, (key + ''), object, source, stack)
          : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
                ? objValue
                : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
          while (++index < length) {
            var value = array[index],
                computed = iteratee ? iteratee(value) : value;

            value = (comparator || value !== 0) ? value : 0;
            if (isCommon && computed === computed) {
              var seenIndex = seen.length;
              while (seenIndex--) {
                if (seen[seenIndex] === computed) {
                  continue outer;
                }
              }
              if (iteratee) {
                seen.push(computed);
              }
              result.push(value);
            }
            else if (!includes(seen, computed, comparator)) {
              if (seen !== result) {
                seen.push(computed);
              }
              result.push(value);
            }
          }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
      predicate(array[index], index, array)) {}

      return isDrop
          ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
          : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
            ? customizer(object[key], source[key], key, object, source)
            : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
            ? (length--, customizer)
            : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
            ? stringToArray(string)
            : undefined;

        var chr = strSymbols
            ? strSymbols[0]
            : string.charAt(0);

        var trailing = strSymbols
            ? castSlice(strSymbols, 1).join('')
            : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
            ? []
            : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
              func, bitmask, createHybrid, wrapper.placeholder, undefined,
              args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
              data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
              !data[4].length && data[9] == 1
          ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
                ? wrapper[funcName]()
                : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
              func, bitmask, createHybrid, wrapper.placeholder, thisArg,
              args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
          ? castSlice(stringToArray(result), 0, length).join('')
          : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
          ? (isBindKey ? 0 : func.length)
          : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
              ? customizer(othValue, arrValue, index, other, array, stack)
              : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
            result = false;
            break;
          }
        } else if (!(
            arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
              ? customizer(othValue, objValue, key, other, object, stack)
              : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
                ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
                : compared
        )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
                typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
          ? data[typeof key == 'string' ? 'string' : 'hash']
          : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
          (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
          ? baseCreate(getPrototype(object))
          : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
          !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
          (type == 'number' ||
              (type != 'symbol' && reIsUint.test(value))) &&
          (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
          ? (isArrayLike(object) && isIndex(index, object.length))
          : (type == 'string' && index in object)
      ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
          (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
          ? (value !== '__proto__')
          : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
            (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
          ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
          ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
          ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
          ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
          : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
          ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
          : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
          ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
          : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
          ? baseWhile(array, getIteratee(predicate, 3), true, true)
          : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
          ? baseWhile(array, getIteratee(predicate, 3), true)
          : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
            ? nativeMax(length + index, 0)
            : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
          ? baseIntersection(mapped)
          : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
          ? baseIntersection(mapped, getIteratee(iteratee, 2))
          : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
          ? baseIntersection(mapped, undefined, comparator)
          : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
          ? strictLastIndexOf(array, value, index)
          : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
          ? basePullAll(array, values)
          : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
          ? basePullAll(array, values, getIteratee(iteratee, 2))
          : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
          ? basePullAll(array, values, undefined, comparator)
          : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
          ? baseSortedUniq(array)
          : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
          ? baseSortedUniq(array, getIteratee(iteratee, 2))
          : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
          ? baseWhile(array, getIteratee(predicate, 3), false, true)
          : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
          ? baseWhile(array, getIteratee(predicate, 3))
          : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
          ? baseDifference(array, values)
          : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
          ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
          : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
            ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
            : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
            (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
          ? arrayMap(transforms[0], baseUnary(getIteratee()))
          : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
          !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
          (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
              isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
          (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
          value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
          (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
          funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
          (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
          (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
          ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
          : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
          ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
          : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
          ? object
          : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
          ? object
          : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
          ? length
          : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
          ? string.replace(reUnescapedHtml, escapeHtmlChar)
          : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
          ? string.replace(reRegExpChar, '\\$&')
          : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
          createPadding(nativeFloor(mid), chars) +
          string +
          createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
          ? (string + createPadding(length - strLength, chars))
          : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
          ? (createPadding(length - strLength, chars) + string)
          : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
          typeof separator == 'string' ||
          (separator != null && !isRegExp(separator))
      )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
          ? 0
          : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
          (options.escape || reNoMatch).source + '|' +
          interpolate.source + '|' +
          (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
          (options.evaluate || reNoMatch).source + '|$'
          , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // with lookup (in case of e.g. prototype pollution), and strip newlines if any.
      // A newline wouldn't be a valid sourceURL anyway, and it'd enable code injection.
      var sourceURL = '//# sourceURL=' +
          (hasOwnProperty.call(options, 'sourceURL')
                  ? (options.sourceURL + '').replace(/[\r\n]/g, ' ')
                  : ('lodash.templateSources[' + (++templateCounter) + ']')
          ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      // Like with sourceURL, we take care to not check the option's prototype,
      // as this configuration is a code injection vector.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
          .replace(reEmptyStringMiddle, '$1')
          .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
          (variable
                  ? ''
                  : 'obj || (obj = {});\n'
          ) +
          "var __t, __p = ''" +
          (isEscaping
                  ? ', __e = _.escape'
                  : ''
          ) +
          (isEvaluating
                  ? ', __j = Array.prototype.join;\n' +
                  "function print() { __p += __j.call(arguments, '') }\n"
                  : ';\n'
          ) +
          source +
          'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
            .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
          ? castSlice(strSymbols, 0, end).join('')
          : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
          ? string.replace(reEscapedHtml, unescapeHtmlChar)
          : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
          ? baseExtremum(array, identity, baseGt)
          : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
          ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
          : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
          ? baseExtremum(array, identity, baseLt)
          : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
          ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
          : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
          ? baseSum(array, identity)
          : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
          ? baseSum(array, getIteratee(iteratee, 2))
          : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
            ? new LazyWrapper(this)
            : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    define(function() {
      return _;
    });
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));
},
'appivo/mvc/Transaction':function(){
/**
 * A query handle allows interaction with a query.
 * @interface Transaction
 */
define(['appivo/client/Client'], 

		function(Client) {

	var client = Client.getInstance();

	var OPERATIONS = {
		ADD: true,
		DEL: true,
		UPD: true
	};

	function Transaction(options) {
		this.schema = options.schema;
		this.ops = new Array();
	};

	Transaction.prototype = {
			constructor: Transaction,

			/**
			 * Adds an operation to this transaction
			 * @param {Object} op Operation
			 * @param {Oject/Record} op.record Record
			 * @param {String} op.op Operation, must be one of ADD, DEL, UPD (add, delete, update).
			 * @param {String} op.model Name of the model if a plain JSON-object is passed as the record
		 	 * @memberof Transaction
		     * @instance
			 */
			addOperation: function(op) {
				var wrapper = {};
				var cmd = {
					op: op.op,
					records: [wrapper]
				};
				var rec = op.record;
				var model = op.model;
				if (!model && rec.getModel) {
					model = rec.getModel().getName();
				}
				if (typeof rec === 'string') {
					rec = {
						id: rec	
					};
				}
				switch (op.op) {
				case 'ADD':
				case 'UPD':
				case 'DEL':
					wrapper[model] = rec;
					this.ops.push(cmd);
					break;
				}
			},

			/**
			 * Commits the transaction
			 * @param {Object} opts Options 
			 * @returns {Promise}
		 	 * @memberof Transaction
		     * @instance
			 */
			commit: function(opts) {
				opts = opts ? opts : {};
				var url = this.schema.getTransactionURI();
				var headers = {
					'Content-Type': 'application/json'
				};

				var tenant = this.schema.getTenant();
				if (tenant) {
					headers['X-Tenant'] = tenant;
				}

				var res = client.sendRequest(url, {
					uriComplete: true,
					method: 'POST',
					handleAs: 'json',
					headers: headers,
					withCredentials: true,
					data: JSON.stringify(this.ops)
				}).then(function(res) {
					if (opts.onSuccess) {
						opts.onSuccess(res);
					}
				}, opts.onError);
				return res;
			}
	};

	return Transaction;
});
},
'appivo/util/Global':function(){
define(["dojo/_base/lang"], function(lang) {

	var global = {
		_data: {}
	};
	
	var traverse = function(obj, path, create, value, remove) {
		var val = null;
		var next = path[0];
		if (path.length == 1) {
			if (create) {
				obj[next] = value;
			}
			val = obj[next];
			if (remove) {
				delete obj[next];
			}
		} else {
			var nextObj = obj[next];
			if (!nextObj) {
				if (create) {
					obj[next] = {};
					val = traverse(obj[next], path.slice(1), create, value, remove);											
				} else {
					val = null;
				}
			} else {
				val = traverse(nextObj, path.slice(1), create, value, remove);
			}
		}
		return val;
	};
	
	global.get = function(path) {
		var seg = path.split(".");
		return traverse(global._data, seg, false, null, false);
	};
	
	global.getAndDelete = function(path) {
		var seg = path.split(".");
		return traverse(global._data, seg, false, null, true);
	};
	
	global.set = function(path, value) {
		var seg = path.split(".");
		traverse(global._data, seg, true, value, false);
	};
	
	global.getData = function() {
		return global._data;
	};
		
	return global;
});

},
'appivo/util/GeoLocation':function(){
define(["dojo/_base/lang",
        "dojo/Deferred",
        "dojo/when",
        'appivo/client/Client',
        'appivo/ui/Alertify',
        './GoogleGeoProvider',
        'dojo/i18n!appivo/util/nls/GeoLocation'
], function(lang, Deferred, when, Client, alertify, provider, messages) { 

	var client = Client.getInstance();
	
	var watches = new Array();
	
	var geo = {
		
		context: null,	
		
		_init: function() {
			return provider.init();
		},
		
		setContext: function(context) {
			this.context = context;
		},
		
		/**
		 *	@param {opts} options
		 *	@LogicMeta {
		 *     "api":"GeoFunctions",
		 *     "returnType":"Object",
		 *     "paramTypes":["Object"]
		 * 	}
	     */
		getCurrentPosition: function(opts) {
			opts = opts ? opts : {};
			return this._getCurrentPosition(opts).then(opts.onSuccess, opts.onError);
		},
		
		getAccuratePosition: function(opts) {
			opts = opts ? opts : {};
			return this._getAccuratePosition(opts);			
		},
		
		/**
		 *	@param {opts} options
		 *	@LogicMeta {
		 *     "api":"GeoFunctions",
		 *     "returnType":"Object",
		 *     "paramTypes":["Object"]
		 * 	}
	     */
		watchPosition: function(opts) {
			opts = opts ? opts : {};
			return this._watchPosition(opts);
		},
		
		_watchPosition: function(opts) {
			var handle = null;
			if (navigator.geolocation && opts.onChange) {
				var watch = navigator.geolocation.watchPosition(function(pos) {
					var point = {
						lat: pos.coords.latitude,
						lng: pos.coords.longitude,
						alt: pos.coords.altitude,
						heading: pos.coords.heading,
						speed: pos.coords.speed,
						accuracy: pos.coords.accuracy
					};
					opts.onChange(point);
				}, function(error) { 
					if (opts.onError) {
						opts.onError(error);
					}
				}, 
				opts.options);
				handle = {
					_watch: watch,
					_options: opts,
					stop: function() {
						navigator.geolocation.clearWatch(watch);
						watches.splice(watches.indexOf(handle), 1);
					}
				};
				watches.push(watch);
			}
			return handle;
		},
		
		/**
		 *	@param {opts} options
		 *	@LogicMeta {
		 *     "api":"GeoFunctions",
		 *     "returnType":"Object",
		 *     "paramTypes":["Object"]
		 * 	}
	     */
		getDistanceBetween: function(opts) {
			var val = -1;
			if (opts.from && opts.to) {
				val = this._getDistanceBetween(opts.from.latitude, opts.from.longitude, opts.to.latitude, opts.to.longitude);
			}
			return val;
		},

		_getDistanceBetween: function(lat1,lon1,lat2,lon2) {
			var R = 6371000; // Radius of the earth in meters
			var dLat = this.deg2rad(lat2-lat1);  // deg2rad below
			var dLon = this.deg2rad(lon2-lon1); 
			var a = 
				Math.sin(dLat/2) * Math.sin(dLat/2) +
				Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) * 
				Math.sin(dLon/2) * Math.sin(dLon/2)
				; 
			var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
			var d = R * c; // Distance in meters
			return d;
		},

		/**
		 *	@LogicMeta {
		 *     "api":"GeoFunctions",
		 *     "returnType":"Number",
		 *     "paramTypes":["Number"]
		 * 	}
	     */
		deg2rad: function(deg) {
			return deg * (Math.PI/180)
		},
		
		_getAccuratePosition: function(opts) {
			var t = this;
			var def = new Deferred();
			var lastCheckedPosition;
			var locationEventCount = 0;
			var watchID;
			var timerID;

			opts = opts || {};

			var checkLocation = function (position) {
				lastCheckedPosition = position;
				locationEventCount = locationEventCount + 1;
				// We ignore the first event unless it's the only one received because some devices seem to send a cached
				// location even when maxaimumAge is set to zero
				if ((position.coords.accuracy <= opts.desiredAccuracy) && (locationEventCount > 1)) {
					clearTimeout(timerID);
					navigator.geolocation.clearWatch(watchID);
					foundPosition(position);
				} else {
					var point = toPoint(position);
					def.progress(point);
					if (opts.onProgress) {
						opts.onProgress(point);
					}
				}
			};
			
			var toPoint = function(pos) {
				var point = {
					lat: pos.coords.latitude,
					lng: pos.coords.longitude,
					alt: pos.coords.altitude,
					accuracy: pos.coords.accuracy,
					header: pos.coords.heading,
					speed: pos.coords.speed
				};
				return point;
			};

			var stopTrying = function () {
				navigator.geolocation.clearWatch(watchID);
				foundPosition(lastCheckedPosition);
			};

			var onError = function (error) {
				t.context.hideSpinner();
				clearTimeout(timerID);
				navigator.geolocation.clearWatch(watchID);
				def.reject(error);
				if (opts.onError) {
					opts.onError(error);
				}
			};

			var foundPosition = function (pos) {
				t.context.hideSpinner();
				var point = toPoint(pos);

				def.resolve(point);
				if (opts.onSuccess) {
					opts.onSuccess(point);
				}
			};

			if (!opts.maxWait)            opts.maxWait = 10000; // Default 10 seconds
			if (!opts.desiredAccuracy)    opts.desiredAccuracy = 20; // Default 20 meters
			if (!opts.timeout)            opts.timeout = opts.maxWait; // Default to maxWait

			opts.maximumAge = 0; // Force current locations only
			opts.enableHighAccuracy = true; // Force high accuracy (otherwise, why are you using this function?)

			this.context.showSpinner();
			watchID = navigator.geolocation.watchPosition(checkLocation, onError, opts);
			timerID = setTimeout(stopTrying, opts.maxWait); // Set a timeout that will abandon the location loop
			
			return def;
		},

		_getCurrentPosition: function(opts) {
			var def = new Deferred();
			if (!opts) {
				opts = {};
			}
			if (!opts.maximumAge) {
				opts.maximumAge = 10000;
			}
			if (!opts.timeout) {
				opts.timeout = 25000;
			}
			if (opts.enableHighAccuracy === undefined) {
				opts.enableHighAccuracy = true;
			}
			if (navigator.geolocation){
				this._init().then(function() {
					navigator.geolocation.getCurrentPosition(
						function(pos) {
							console.log("Got position: "+ pos.coords.latitude + " , " + pos.coords.longitude);
							var point = {
								lat: pos.coords.latitude,
								lng: pos.coords.longitude,
								alt: pos.coords.altitude,
								accuracy: pos.coords.accuracy
							};
							def.resolve(point);
						},
						function(error) {
						    var messageName = 'error' + error.code;
						    if (error.code == 1) {
						        messageName += client.getDeviceType();
						    }
						    var msg = messages[messageName];
                            def.reject(msg);
						},
						{ 
							maximumAge: opts.maximumAge, 
							timeout: opts.timeout, 
							enableHighAccuracy: opts.enableHighAccuracy 
						}
					);
				});
			} else {
				def.reject(messages.nosupport);
			} 
			return def;			
		},
				
		/**
		 *	@param {opts} options
		 *	@LogicMeta {
		 *     "api":"GeoFunctions",
		 *     "returnType":"Object",
		 *     "paramTypes":["Object"]
		 * 	}
	     */
		getCurrentAddress: function(opts) {
			opts = opts ? opts : {};
			this._getCurrentAddress(opts.pos).then(opts.onSuccess, opts.onError);
		},

		/**
		 *	@LogicMeta {
		 *     "api":"GeoFunctions",
		 *     "returnType":"Object",
		 *     "paramTypes":["Object"]
		 * 	}
	     */
		searchAddress: function(opts) {
		    if (navigator.geolocation) {
                this._init().then(function() {
                    provider.searchAddress(opts.address).then(opts.onSuccess, opts.onError);
                });
            }
		},
		
		_getCurrentAddress: function(pos) {
			var t = this;
			if (!pos) {
				pos = this._getCurrentPosition();
			}
			var def = new Deferred();
			when(pos).then(function(pos) {
				provider.getCurrentAddress(pos).then(function(res) {
					def.resolve(res);
				}, function(error) {
					def.reject(error);
				});				
			}, function(error) {
				def.reject(error);
			});
			return def;
		},
		
		/**
		 *	@param {opts} options
		 *	@param {opts.from} - Location to navigate to
		 *	@param {opts.to} - Location to navigate to
		 *	@param {opts.onSuccess} - On success callback
		 *	@param {opts.onError} - On success callback
		 *	@LogicMeta {
		 *     "api":"GeoFunctions",
		 *     "returnType":"Object",
		 *     "paramTypes":["Object"]
		 * 	}
	     */
		getDirections: function(opts) {
			var t = this;
			opts = opts ? opts : {};
			var from = opts.from;
			var to = opts.to;
			this.context.showSpinner();
			this._init().then(function() {
				if (!from) {
					if (opts.useAddress) {
						from = t._getCurrentAddress();
					} else {
						from = t._getCurrentPosition();						
					}
				}
				when(from, function(from) {
					if (!lang.isString(from)) {
						if (from.address) {
							from = from.address;							
							console.log("Using source address " + from);
						} else if (from.lat) {
							from = from.lat + ',' + from.lng;
							console.log("Using source position " + from);
						}
					}
					provider.getDirections(from, to, function(res) {
						t.context.hideSpinner();
						if (opts.onSuccess) {
							opts.onSuccess(res);
						}
					}, function(error) {
						t.context.hideSpinner();
						if (opts.onError) {
							opts.onError(error);
						}
					});
				}, function(error) {
					t.context.hideSpinner();
					if (opts.onError) {
						opts.onError(error);						
					}
				});				
			});
		},
		
		/**
		 *	@param {Object} from - Location to navigate from
		 *	@param {Object} to - Location to navigate to
		 *	@LogicMeta {
		 *     "api":"GeoFunctions",
		 *     "returnType":"Object",
		 *     "paramTypes":["Object", "Object"]
		 * 	}
	     */
		createNavigatorLink: function(from, to) {
			var link = null;
			var device = client.getDeviceType();
			var fromAddress = from ? encodeURIComponent(from.address) : '';
			var toAddress = to ? encodeURIComponent(to.address) : '';
			switch (device) {
			case 'ios':
			case 'mac':
				link = 'https://maps.apple.com/?daddr=' + toAddress  + '&saddr=' + fromAddress;
				break;
			case 'android':
				link = 'https://maps.google.com?daddr=' + toAddress + '&saddr=' + fromAddress;
				break;
			case 'unknown':
				link = 'https://maps.google.com?daddr=' + toAddress + '&saddr=' + fromAddress;
				break;
			}
			return link;
		},
		
		/**
		 *	@param {Object} from - Location to navigate from
		 *	@param {Object} to - Location to navigate to
		 *	@LogicMeta {
		 *     "api":"GeoFunctions",
		 *     "returnType":"Object",
		 *     "paramTypes":["Object", "Object"]
		 * 	}
	     */
		openNavigator: function(from, to) {
			this.context.showSpinner();
			if (!from) {
				var t = this;
				from = new Deferred();
				this.getCurrentAddress({
					onSuccess: function(res) {
						t.context.hideSpinner();
						from.resolve(res);
					},
					onError: function(error) {
						t.context.hideSpinner();
						from.reject(error);	
						alertify.alert(messages.posError, error);
					}
				});
			}
			var t = this;
			when(from).then(function(res) {
				var link = t.createNavigatorLink(res, to);
				var device = client.getDeviceType();
				if (window.cordova && window.launchnavigator) {
					var fromAddress, toAddress;
					switch (device) {
					case 'ios': //Fixes an issue where the location and destination would become unknown location because of URI encoding.
						fromAddress = res ? res.address : '';
						toAddress = to ? to.address : '';
						break;
					default:
						fromAddress = res ? encodeURIComponent(res.address) : '';
						toAddress = to ? encodeURIComponent(to.address) : '';
						break;
					}
					
					window.launchnavigator.navigate(toAddress, fromAddress, function() {
						console.log("Opened navigation app");
					}, function(error) {
						alert("Could not open navigation app: " + error);
					}, {
						transportMode: 'driving',
						disableAutoGeolocation: fromAddress ? true : false
					});
				} else {
					switch (device) {
					case 'android':
					case 'ios':
						window.location = link;			
						break;
					default:
						window.open(link);
						break;
					}
				}
			});
		},
		
		_clearWatches: function() {
			var list = watches.slice(0);
			for (var i = 0; i < list.length; i++) {
				var watch = list[i];
				watch.stop();
			}
		}
	};
		
	return geo;
});

},
'appivo/util/GoogleGeoProvider':function(){
define(["dojo/_base/lang",
        "dojo/Deferred",
        "dojo/when",
        'dojo/i18n!appivo/util/nls/GeoLocation'
], function(lang, Deferred, when, messages) { 

	var API_KEY = "AIzaSyBzA8JVXJ7GDLfvpuTLPMEmwZKVfNC82gY"; // nosemgrep: detected-generic-api-key
	
	var geo = {
		
		init: function() {
			var def = new Deferred();
			var t = this;
			if (!this._loaded) {
				require(["appivo/util/GoogleMapsLoader!https://maps.google.com/maps/api/js?v=3&key=" + API_KEY + "&sensor=true"], function(maps) {
					t._loaded = true;
					def.resolve(true);
				});				
			} else {
				def.resolve(true);
			}
			return def;
		},
				
		getCurrentAddress: function(pos) {
			var def = new Deferred();
			var t = this;
			this.init().then(function() {
				var lat = pos.lat;
				var lng = pos.lng;
				var geocoder = new google.maps.Geocoder();
				var latLng = new google.maps.LatLng(lat, lng);
				geocoder.geocode({
					'latLng': latLng
				}, function(results, status) {
					console.log("After getting address");
					console.log(results);
					if (status == google.maps.GeocoderStatus.OK) {
						if (results[0]) {
							try {						
								var r = results[0];
								var ac = r.address_components;
								console.log("Got address: " + r.formatted_address);
								var res = {
										address: r.formatted_address,
										parts: {
										}
								};

								if (ac[0].long_name) {
									res.parts.houseNumber = ac[0].long_name;
								}
								if (ac.length > 1 && ac[1].long_name) {
									res.parts.street = ac[1].long_name;
								}
								if (ac.length > 4 && ac[4].long_name) {
									res.parts.city = ac[4].long_name;
								}
								if (ac.length > 7 && ac[7].long_name) {
									res.parts.zip = ac[7].long_name;
								}
								if (ac.length > 6 && ac[6].long_name) {
									res.parts.country = ac[6].long_name;
									res.parts.countryCode = ac[6].short_name;
								}
								if (ac.length > 5 && ac[5].long_name) {
									res.parts.area = ac[5].long_name;
								}

								def.resolve(res);
							} catch (error) {
								console.error(error);
								def.reject("Failed to process adress-response");
							}
						} else {
							def.reject(messages.noAddress);
						}
					} else {
						def.reject(messages.failedToLookupAddress);
					}
				});
			}, function(error) {
				def.reject(error);
			});
			return def;
		},

		searchAddress: function(address) {
		    var def = new Deferred();
            var t = this;
            this.init().then(function() {
                var geocoder = new google.maps.Geocoder();
                geocoder.geocode({
                    'address': address
                }, function(results, status) {
                    console.log("After getting address");
                    console.log(results);
                    if (status == google.maps.GeocoderStatus.OK) {
                        var result = [];
                        for (var i = 0; i < results.length; i++) {
                            try {
                                var r = results[i];
                                var ac = r.address_components;
                                console.log("Got address: " + r.formatted_address);
                                var res = {
                                    address: r.formatted_address,
                                    parts: {
                                    },
                                    coordinates: {
                                        lat: r.geometry.location.lat(),
                                        lng: r.geometry.location.lng()
                                    }
                                };
                                result.push(res);

                                if (ac[0].long_name) {
                                    res.parts.houseNumber = ac[0].long_name;
                                }
                                if (ac.length > 1 && ac[1].long_name) {
                                    res.parts.street = ac[1].long_name;
                                }
                                if (ac.length > 4 && ac[4].long_name) {
                                    res.parts.city = ac[4].long_name;
                                }
                                if (ac.length > 7 && ac[7].long_name) {
                                    res.parts.zip = ac[7].long_name;
                                }
                                if (ac.length > 6 && ac[6].long_name) {
                                    res.parts.country = ac[6].long_name;
                                    res.parts.countryCode = ac[6].short_name;
                                }
                                if (ac.length > 5 && ac[5].long_name) {
                                    res.parts.area = ac[5].long_name;
                                }
                            } catch (error) {
                                console.error(error);
                                def.reject("Failed to process address-response");
                            }
                        }
                        if (result.length > 0) {
                                def.resolve(result);
                        } else {
                            def.reject(messages.noAddress);
                        }
                    } else {
                        def.reject(messages.failedToLookupAddress);
                    }
                });
            }, function(error) {
                def.reject(error);
            });
            return def;
		},
				
		_getDirectionService: function() {
			if (!this.dirService) {
				this.dirService = new google.maps.DirectionsService();
			}
			return this.dirService;
		},
		
		getDirections: function(from, to, callback, errback) {
			var t = this;
			this.init().then(function() {
				if (!lang.isString(from)) {
					from = from.address;
				}

				var directionsService = t._getDirectionService();
				var request = {
					origin:from,
					destination:to,
					travelMode: google.maps.TravelMode.DRIVING
				};
				directionsService.route(request, function(response, status) {
					if (status == google.maps.DirectionsStatus.OK) {
						if (callback) {
							var leg = response.routes[0].legs[0];
							var res = {
								from: from,
								to: to,
								distance: leg.distance.value,
								distanceText: leg.distance.text,
								time: leg.duration.value,
								timeText: leg.duration.text
							};
							callback(res);							
						}
					} else {
						if (errback) {
							errback('Google Maps-request failed')
						}
					}
				});				
			});
		}
	};
	
	return geo;
});

},
'appivo/mvc/TemplateContextFactory':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'dojo/_base/Deferred'], function(lang, declare, Deferred) {
	
	var clss = declare("appivo.mvc.TemplateContextFactory", [], {

		createContext: function(actionContext) {				
			var cache = {
				query: {},
				form: {}
			};

			var tc = {
				user: actionContext.getUser(),
				query: {},
				form: {}
			};

			var queryFunc = function(query, text, render) {
				var records = [];
				var records = cache.query[query.getName()];
				if (records == null) {
					var qh = query.createHandle();
					if (text && text.length > 0) {
						var params = text.split(',');
					}
					var store = qh.getStore();
					records = store.query();
					cache.query[query.getName()] == records;
				}
				return records;
			};

			var formFunc = function(form, text, render) {
				var data = cache.form[form.getId()];
				if (!data) {
					data = form.createRecord();
					cache.form[form.getId()] = data;
				}
				return data;
			};

			var schema = actionContext.getSchema();
			var queries = schema.getQueries();
			for (var i = 0; i < queries.length; i++) {
				var query = queries[i];
				tc.query[query.getName()] = lang.hitch(tc, queryFunc, query);
			}
			var forms = actionContext.getView().getForms();
			for (var name in forms) {
				var form = forms[name];
				tc.form[form.getId()] = lang.hitch(tc, formFunc, form);
			}
			
			return tc;
		}
	});

	clss.getInstance = function() {
		if (clss._instance == null) {
			clss._instance = new clss();
		}
		return clss._instance;
	};

	return clss;
});

},
'appivo/mvc/DataFunctions':function(){
/**
 *	@namespace DataFunctions
 */
define(['dojo/_base/lang',
        'appivo/util/Equals'], function(lang, Equals) {

	var CHARACTERS = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';

	function DataFunctions(schema) {
		this.schema = schema;
	}

	DataFunctions.prototype = {
		constructor: DataFunctions,

		/**
		 * Generates a random ID.
		 * @param {Number} length Number of characters (if omitted default is 8)
		 * @param {Object} opts Options
		 * @param {String} opts.chars A string containing all valid characters in the ID (by default all alphanumeric characters are included)
		 * @instance
		 * @memberof DataFunctions
		 * @returns {String}
		 *	@LogicMeta {
		 *     "api":"DataFunctions",
		 *     "returnType":"String",
		 *     "paramTypes":["Number","Object"]
		 * 	}
		 */
		generateId: function(length, opts) {
			if (!length) {
				length = 8;
			}
			var result = '';
			var chars = CHARACTERS;
			if (opts && opts.chars) {
				chars = opts.chars;
			}
			for (var i = length; i > 0; --i) {
				result += chars[Math.floor(Math.random() * chars.length)];
			}
			return result;
		},

		/**
		 * Compares two objects, returns true if they are equal
		 *
		 * @param {Object} value1 First value
		 * @param {Object} value2 Second value
		 * @param {Object} options Options
		 * @param {Array} options.include Array of fields to explicitly include
		 * @param {Array} options.exclude Array of fields to explicitly exclude
		 * @instance
		 * @memberof DataFunctions
		 * @returns {String}
		 *	@LogicMeta {
		 *     "api":"DataFunctions",
		 *     "returnType":"Boolean",
		 *     "paramTypes":["Object","Object", "Object"]
		 * 	}
		 */
		compare: function(value1, value2, options) {
			if (!options) {
				options = {};
			}
			return Equals(value1, value2, options.exclude, options.include);
		},

		/**
		 * Import records from an application resource
		 *
		 * @param {String} Name of model to import to
		 * @param {String} resource Name or ID of resource to read records from
		 * @param {Object} opts
		 * @memberof DataFunctions
		 * @returns {Promise}
		 *
		 *	@LogicMeta {
		 *     "api":"DataFunctions",
		 *     "returnType":"Promise",
		 *     "paramTypes":["String","String","Object"],
		 *     "tooltip": "$"
		 * 	}
		 */
		importRecords: function(model, resource, opts) {
			var mdl = this.schema.getModel(model);
			if (mdl) {
				var url = mdl.getURI() + "/import/" + resource;
				return client.sendRequest(url);
			} else {
				console.error("Unknown model: " + model);
			}
		},

		/**
		 * Parse an XML-document
		 *
		 * @param {String} text String to parse
		 * @memberof DataFunctions
		 * @returns {Document}
		 */
		parseXML: function(text) {
			var parser = new DOMParser();
			var doc = parser.parseFromString(text, "application/xml");
			return doc;
		},

		/**
		 * Serialize an XML-document
		 *
		 * @param {Document} doc Document to serialize
		 * @memberof DataFunctions
		 * @returns {String}
		 */
		serializeXML: function(doc) {
			var ser = new XMLSerializer();
			var str = ser.serializeToString(doc);
			return str;
		},

		/**
		 * Transposes an array of objects/records
		 * @param {Array} records
		 * @param {Object} options
		 * @instance
		 * @memberof DataFunctions
		 * @returns {Array}
		 *	@LogicMeta {
		 *     "api":"DataFunctions",
		 *     "returnType":"Array",
		 *     "paramTypes":["Array","Object"]
		 * 	}
		 */
		transpose: function(records, options) {
			var list = [];
			var keys = [];
			var id = null;
			if (options && options.key) {
				id = options.key;
			}

			if (records && records.length > 0) {
				for (var key in records[0]) {
					keys.push(key);
				}
			}

			for (var i = 0; i < keys.length; i++) {
				var key = keys[i];
				var rec = {};
				for (var j = 0; j < records.length; j++) {
					var row = records[j];
					var rid = id ? row[id] : j.toString();
					rec[rid] = row[key];
				}
				list.push(rec);
			}

			return list;
		}
	};

	return DataFunctions;
});
},
'appivo/mvc/StringFunctions':function(){
/**
*	@namespace StringFunctions
*/
define([
	'appivo/util/Levenshtein',
	'appivo/util/TextDiff',
	'fuzzyset/fuzzyset'
], function(Levenshtein, TextDiff, FuzzySet) {

	function searchToRegex(str) {
		// nosemgrep: detect-non-literal-regexp
		return new RegExp(pregQuote(str).replace(/\\\*/g, '.*').replace(/\\\?/g, '.'), 'g');
	}

	function pregQuote (str) {
		return (str + '').replace(/[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\-]/g, '\\$&');
	}

	return {

		htmlEscape: function(str){
			const el = document.createElement("div");
			el.innerText = el.textContent = s;
			s = el.innerHTML;
			return s;
		},

		match: function(pattern, string) {
			const regex = searchToRegex(pattern);
			if (Array.isArray(string)) {
				const result = [];
				string.forEach(function(str) {
					if (str.match(regex)) {
						result.push(str);
					}
				})
			} else if (typeof(string) === "string") {
				return string.match(regex);
			}
			return false;
		},

		replaceWithPrefix: function(string, prefix, lookup) {
			const find = function (match) {
				const key = match.substring(prefix.length);
				let val = undefined;
				if (typeof(lookup) === "function") {
					val = lookup(key);
				} else if (typeof(lookup) === "object") {
					val = lookup[key];
				}
				return val;
			}

			if (prefix instanceof RegExp) {
				return string.replace(prefix, find);
			} else {
				// nosemgrep: detect-non-literal-regexp
				return string.replace(new RegExp("\\b" + prefix + '\\w*', 'gi'), find);
			}
		},

		/**
		 * Computes the levenshtein distance between two strings
		 *
		 * @memberof StringFunctions
		 * @param {String} str1 - First string
		 * @param {String} str2 - Second string
		 * @returns {number}
		 * @instance
		 *	@LogicMeta {
		 *     "api":"StringFunctions",
		 *     "returnType":"Number",
		 *     "paramTypes":["String","String"]
		 * 	}
		 */
		levenshtein: function(str1, str2) {
			return Levenshtein(str1, str2);
		},

		/**
		 * Creates a fuzzy set
		 *
		 * @memberof StringFunctions
		 * @param {Object} options
		 * @returns {Object}
		 * @instance
		 * @LogicMeta {
    	 *  "api":"StringFunctions",
         *  "returnType":"Number",
         *  "paramTypes":["Object"]
         *	}
		 */
		createFuzzySet: function(options) {
			if (!options) {
				options = {};
			}
			var array = options.data || [];
			var gramSizeLower = options.gramSizeLower || 2;
			var gramSizeUpper = options.gramSizeUpper || 3;
			return new FuzzySet(array, true, gramSizeLower, gramSizeUpper);
		},

		diffText: function(str1, str2, options) {
			return TextDiff(str1, str2, options);
		}
	};
});

},
'appivo/util/Levenshtein':function(){
/**
 * js-levenshtein - https://github.com/gustf/js-levenshtein
 */
define([], function() {

    function _min(d0, d1, d2, bx, ay) {
        return d0 < d1 || d2 < d1
            ? d0 > d2
                ? d2 + 1
                : d0 + 1
            : bx === ay
                ? d1
                : d1 + 1;
    };

    return function (a, b) {
        if (a === b) {
            return 0;
        }

        if (a.length > b.length) {
            var tmp = a;
            a = b;
            b = tmp;
        }

        var la = a.length;
        var lb = b.length;

        while (la > 0 && (a.charCodeAt(la - 1) === b.charCodeAt(lb - 1))) {
            la--;
            lb--;
        }

        var offset = 0;

        while (offset < la && (a.charCodeAt(offset) === b.charCodeAt(offset))) {
            offset++;
        }

        la -= offset;
        lb -= offset;

        if (la === 0 || lb < 3) {
            return lb;
        }

        var x = 0;
        var y;
        var d0;
        var d1;
        var d2;
        var d3;
        var dd;
        var dy;
        var ay;
        var bx0;
        var bx1;
        var bx2;
        var bx3;

        var vector = [];

        for (y = 0; y < la; y++) {
            vector.push(y + 1);
            vector.push(a.charCodeAt(offset + y));
        }

        var len = vector.length - 1;

        for (; x < lb - 3;) {
            bx0 = b.charCodeAt(offset + (d0 = x));
            bx1 = b.charCodeAt(offset + (d1 = x + 1));
            bx2 = b.charCodeAt(offset + (d2 = x + 2));
            bx3 = b.charCodeAt(offset + (d3 = x + 3));
            dd = (x += 4);
            for (y = 0; y < len; y += 2) {
                dy = vector[y];
                ay = vector[y + 1];
                d0 = _min(dy, d0, d1, bx0, ay);
                d1 = _min(d0, d1, d2, bx1, ay);
                d2 = _min(d1, d2, d3, bx2, ay);
                dd = _min(d2, d3, dd, bx3, ay);
                vector[y] = dd;
                d3 = d2;
                d2 = d1;
                d1 = d0;
                d0 = dy;
            }
        }

        for (; x < lb;) {
            bx0 = b.charCodeAt(offset + (d0 = x));
            dd = ++x;
            for (y = 0; y < len; y += 2) {
                dy = vector[y];
                vector[y] = dd = _min(dy, d0, dd, bx0, vector[y + 1]);
                d0 = dy;
            }
        }

        return dd;
    }
});
},
'appivo/util/TextDiff':function(){
define([], function() {

    function diffText(str1, str2, options = {}) {
        // Default styles
        const defaultStyles = {
            added: { 'background-color': '#90EE90' },
            removed: { 'background-color': '#FFB6C6' },
            modified: { 'background-color': '#87CEEB' }
        };

        // Merge default styles with provided styles
        const styles = Object.assign({}, defaultStyles, options.styles);

        // Generate inline style strings
        const getStyleString = (styleObj) => {
            return Object.entries(styleObj)
                    .map(([prop, value]) => `${prop}: ${value}`)
                    .join('; ');
        };

        // Initialize HTML content
        let htmlContent = `<span>`;

        // Split strings into words, preserving newlines
        const words1 = str1.split(/(\s+)/).filter(w => w.length > 0);
        const words2 = str2.split(/(\s+)/).filter(w => w.length > 0);

        let i = 0;
        let j = 0;
        const result = [];

        // Process both strings simultaneously
        while (i < words1.length || j < words2.length) {
            if (i >= words1.length) {
                // All words from str1 processed, add remaining words from str2
                result.push({ word: words2[j], type: 'added' });
                j++;
            } else if (j >= words2.length) {
                // All words from str2 processed, add remaining words from str1
                result.push({ word: words1[i], type: 'removed' });
                i++;
            } else {
                const word1 = words1[i];
                const word2 = words2[j];

                if (word1 === word2) {
                    // Words match exactly
                    result.push({ word: word1, type: 'same' });
                    i++;
                    j++;
                } else if (isSimilar(word1, word2)) {
                    // Words are similar (modified)
                    result.push({ word: word2, type: 'modified' });
                    i++;
                    j++;
                } else {
                    // Look ahead in both strings to find next match
                    let matchFound = false;
                    const lookAheadLimit = 3;

                    // Look ahead in str2 for word1
                    for (let k = 1; k < lookAheadLimit && j + k < words2.length; k++) {
                        if (words1[i] === words2[j + k] || isSimilar(words1[i], words2[j + k])) {
                            // Word1 found later in str2, add intermediate words from str2 as additions
                            for (let l = 0; l < k; l++) {
                                result.push({ word: words2[j + l], type: 'added' });
                            }
                            j += k;
                            matchFound = true;
                            break;
                        }
                    }

                    if (!matchFound) {
                        // Look ahead in str1 for word2
                        for (let k = 1; k < lookAheadLimit && i + k < words1.length; k++) {
                            if (words2[j] === words1[i + k] || isSimilar(words2[j], words1[i + k])) {
                                // Word2 found later in str1, add intermediate words from str1 as removals
                                for (let l = 0; l < k; l++) {
                                    result.push({ word: words1[i + l], type: 'removed' });
                                }
                                i += k;
                                matchFound = true;
                                break;
                            }
                        }
                    }

                    if (!matchFound) {
                        // No match found within lookahead, treat as removal and addition
                        result.push({ word: word1, type: 'removed' });
                        result.push({ word: word2, type: 'added' });
                        i++;
                        j++;
                    }
                }
            }
        }

        // Generate HTML content
        result.forEach(({ word, type }) => {
            if (type === 'same') {
                htmlContent += word;
            } else {
                const styleString = getStyleString(styles[type]);
                htmlContent += `<span style="${styleString}">${word}</span>`;
            }
        });

        // Close HTML tags
        htmlContent += `</span>`;

        return htmlContent;
    }

    // Helper function to determine if two words are similar
    function isSimilar(word1, word2) {
        // Simple similarity check: words are similar if they share
        // more than 60% of their characters
        const longer = word1.length > word2.length ? word1 : word2;
        const shorter = word1.length > word2.length ? word2 : word1;

        // If length difference is too great, words are not similar
        if (shorter.length < longer.length * 0.7) {
            return false;
        }

        let matches = 0;
        for (let i = 0; i < shorter.length; i++) {
            if (shorter[i] === longer[i]) {
                matches++;
            }
        }

        return matches / longer.length > 0.6;
    }

    return diffText;
});
},
'fuzzyset/fuzzyset':function(){
define([], function() {

    'use strict';

    const FuzzySet = function(arr, useLevenshtein, gramSizeLower, gramSizeUpper) {
        var fuzzyset = {

        };

        // default options
        arr = arr || [];
        fuzzyset.gramSizeLower = gramSizeLower || 2;
        fuzzyset.gramSizeUpper = gramSizeUpper || 3;
        fuzzyset.useLevenshtein = (typeof useLevenshtein !== 'boolean') ? true : useLevenshtein;

        // define all the object functions and attributes
        fuzzyset.exactSet = {};
        fuzzyset.matchDict = {};
        fuzzyset.items = {};

        // helper functions
        var levenshtein = function(str1, str2) {
            var current = [], prev, value;

            for (var i = 0; i <= str2.length; i++)
                for (var j = 0; j <= str1.length; j++) {
                    if (i && j)
                        if (str1.charAt(j - 1) === str2.charAt(i - 1))
                            value = prev;
                        else
                            value = Math.min(current[j], current[j - 1], prev) + 1;
                    else
                        value = i + j;

                    prev = current[j];
                    current[j] = value;
                }

            return current.pop();
        };

        // return an edit distance from 0 to 1
        var _distance = function(str1, str2) {
            if (str1 === null && str2 === null) throw 'Trying to compare two null values';
            if (str1 === null || str2 === null) return 0;
            str1 = String(str1); str2 = String(str2);

            var distance = levenshtein(str1, str2);
            if (str1.length > str2.length) {
                return 1 - distance / str1.length;
            } else {
                return 1 - distance / str2.length;
            }
        };

        // u00C0-u00FF is latin characters
        // u0621-u064a is arabic letters
        // u0660-u0669 is arabic numerals
        // TODO: figure out way to do this for more languages
        var _nonWordRe = /[^a-zA-Z0-9\u00C0-\u00FF\u0621-\u064A\u0660-\u0669, ]+/g;

        var _iterateGrams = function(value, gramSize) {
            gramSize = gramSize || 2;
            var simplified = '-' + value.toLowerCase().replace(_nonWordRe, '') + '-',
                lenDiff = gramSize - simplified.length,
                results = [];
            if (lenDiff > 0) {
                for (var i = 0; i < lenDiff; ++i) {
                    simplified += '-';
                }
            }
            for (var i = 0; i < simplified.length - gramSize + 1; ++i) {
                results.push(simplified.slice(i, i + gramSize));
            }
            return results;
        };

        var _gramCounter = function(value, gramSize) {
            // return an object where key=gram, value=number of occurrences
            gramSize = gramSize || 2;
            var result = {},
                grams = _iterateGrams(value, gramSize),
                i = 0;
            for (i; i < grams.length; ++i) {
                if (grams[i] in result) {
                    result[grams[i]] += 1;
                } else {
                    result[grams[i]] = 1;
                }
            }
            return result;
        };

        // the main functions
        fuzzyset.get = function(value, defaultValue, minMatchScore) {
            // check for value in set, returning defaultValue or null if none found
            if (minMatchScore === undefined) {
                minMatchScore = .33;
            }
            var result = this._get(value, minMatchScore);
            if (!result && typeof defaultValue !== 'undefined') {
                return defaultValue;
            }
            return result;
        };

        fuzzyset._get = function(value, minMatchScore) {
            var results = [];
            // start with high gram size and if there are no results, go to lower gram sizes
            for (var gramSize = this.gramSizeUpper; gramSize >= this.gramSizeLower; --gramSize) {
                results = this.__get(value, gramSize, minMatchScore);
                if (results && results.length > 0) {
                    return results;
                }
            }
            return null;
        };

        fuzzyset.__get = function(value, gramSize, minMatchScore) {
            var normalizedValue = this._normalizeStr(value),
                matches = {},
                gramCounts = _gramCounter(normalizedValue, gramSize),
                items = this.items[gramSize],
                sumOfSquareGramCounts = 0,
                gram,
                gramCount,
                i,
                index,
                otherGramCount;

            for (gram in gramCounts) {
                gramCount = gramCounts[gram];
                sumOfSquareGramCounts += Math.pow(gramCount, 2);
                if (gram in this.matchDict) {
                    for (i = 0; i < this.matchDict[gram].length; ++i) {
                        index = this.matchDict[gram][i][0];
                        otherGramCount = this.matchDict[gram][i][1];
                        if (index in matches) {
                            matches[index] += gramCount * otherGramCount;
                        } else {
                            matches[index] = gramCount * otherGramCount;
                        }
                    }
                }
            }

            function isEmptyObject(obj) {
                for(var prop in obj) {
                    if(obj.hasOwnProperty(prop))
                        return false;
                }
                return true;
            }

            if (isEmptyObject(matches)) {
                return null;
            }

            var vectorNormal = Math.sqrt(sumOfSquareGramCounts),
                results = [],
                matchScore;
            // build a results list of [score, str]
            for (var matchIndex in matches) {
                matchScore = matches[matchIndex];
                results.push([matchScore / (vectorNormal * items[matchIndex][0]), items[matchIndex][1]]);
            }
            var sortDescending = function(a, b) {
                if (a[0] < b[0]) {
                    return 1;
                } else if (a[0] > b[0]) {
                    return -1;
                } else {
                    return 0;
                }
            };
            results.sort(sortDescending);
            if (this.useLevenshtein) {
                var newResults = [],
                    endIndex = Math.min(50, results.length);
                // truncate somewhat arbitrarily to 50
                for (var i = 0; i < endIndex; ++i) {
                    newResults.push([_distance(results[i][1], normalizedValue), results[i][1]]);
                }
                results = newResults;
                results.sort(sortDescending);
            }
            newResults = [];
            results.forEach(function(scoreWordPair) {
                if (scoreWordPair[0] >= minMatchScore) {
                    newResults.push([scoreWordPair[0], this.exactSet[scoreWordPair[1]]]);
                }
            }.bind(this));
            return newResults;
        };

        fuzzyset.add = function(value) {
            var normalizedValue = this._normalizeStr(value);
            if (normalizedValue in this.exactSet) {
                return false;
            }

            var i = this.gramSizeLower;
            for (i; i < this.gramSizeUpper + 1; ++i) {
                this._add(value, i);
            }
        };

        fuzzyset._add = function(value, gramSize) {
            var normalizedValue = this._normalizeStr(value),
                items = this.items[gramSize] || [],
                index = items.length;

            items.push(0);
            var gramCounts = _gramCounter(normalizedValue, gramSize),
                sumOfSquareGramCounts = 0,
                gram, gramCount;
            for (gram in gramCounts) {
                gramCount = gramCounts[gram];
                sumOfSquareGramCounts += Math.pow(gramCount, 2);
                if (gram in this.matchDict) {
                    this.matchDict[gram].push([index, gramCount]);
                } else {
                    this.matchDict[gram] = [[index, gramCount]];
                }
            }
            var vectorNormal = Math.sqrt(sumOfSquareGramCounts);
            items[index] = [vectorNormal, normalizedValue];
            this.items[gramSize] = items;
            this.exactSet[normalizedValue] = value;
        };

        fuzzyset._normalizeStr = function(str) {
            if (Object.prototype.toString.call(str) !== '[object String]') throw 'Must use a string as argument to FuzzySet functions';
            return str.toLowerCase();
        };

        // return length of items in set
        fuzzyset.length = function() {
            var count = 0,
                prop;
            for (prop in this.exactSet) {
                if (this.exactSet.hasOwnProperty(prop)) {
                    count += 1;
                }
            }
            return count;
        };

        // return is set is empty
        fuzzyset.isEmpty = function() {
            for (var prop in this.exactSet) {
                if (this.exactSet.hasOwnProperty(prop)) {
                    return false;
                }
            }
            return true;
        };

        // return list of values loaded into set
        fuzzyset.values = function() {
            var values = [],
                prop;
            for (prop in this.exactSet) {
                if (this.exactSet.hasOwnProperty(prop)) {
                    values.push(this.exactSet[prop]);
                }
            }
            return values;
        };


        // initialization
        var i = fuzzyset.gramSizeLower;
        for (i; i < fuzzyset.gramSizeUpper + 1; ++i) {
            fuzzyset.items[i] = [];
        }
        // add all the items to the set
        for (i = 0; i < arr.length; ++i) {
            fuzzyset.add(arr[i]);
        }

        return fuzzyset;
    };

    return FuzzySet;
});
},
'appivo/mvc/PaymentFunctions':function(){
define(['dojo/_base/lang',
        'dojo/_base/declare',
        "dojo/Deferred",
        'dojo/request/xhr',
        "appivo/util/StripeLoader"
       ], function(lang, declare, Deferred, xhr, StripeLoader) {
    return declare("appivo.mvc.PaymentFunctions", null, {
        saveCard: function(token, account, email, description, callback, onError){
            return xhr("/api/system-integration/stripe/charge", {
                method: "POST",
                handleAs: "json",
                query: {
                    action: "savecard",
                    account: account,
                    cardtoken: token,
                    email: email,
                    description: description
                }
            });
        },
        createCardToken: function(cardinfo) {
            var def = new Deferred();
            StripeLoader.getStripe().then(function(stripe) {
                stripe.card.createToken(cardinfo, function(status, response){
                    if (response.error) {
                        def.reject(response.error);
                    } else {
                        def.resolve(response.id);
                    }
                });
            });
            return def;
        },
        charge: function(cardtoken, customertoken, account, currency, amount, fee) {
            return xhr("/api/system-integration/stripe/charge", {
                method: "POST",
                handleAs: "json",
                query: {
                    account: account,
                    token: cardtoken,
                    customer: customertoken,
                    amount: amount,
                    currency: currency,
                    fee: fee
                }
            });
        }

    });
});
},
'appivo/util/StripeLoader':function(){
define([
    "dojo/Deferred"
], function(Deferred) {
    return {
        getStripe: function() {
            var def = new Deferred();
            if (window.Stripe) {
                def.resolve(window.Stripe);
            } else {
                require(["https://js.stripe.com/v3/"], function() {
                    def.resolve(window.Stripe);
                });
            }
            return def;
        }
    };
});

},
'appivo/mvc/NumericFunctions':function(){
/**
*	@namespace NumericFunctions
*/
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'dojo/number',
        "dojo/currency"], function(lang, declare, number, currency) {
	
	return declare("appivo.mvc.NumberFunctions", null, {
		
		/**
		 *	@memberof NumericFunctions
		 *	@instance
		 *	@LogicMeta {
		 *     "api":"NumericFunctions",
		 *     "returnType":"String",
		 *     "paramTypes":["Number","Number"]
		 * 	}
	     */
		formatFloat: function(value, decimals) {
			if (!decimals) {
				decimals = 2;
			}
			return number.format(value, {places: decimals});
		},
		
		/**
		 *	@memberof NumericFunctions
		 *	@instance
		 *	@LogicMeta {
		 *     "api":"NumericFunctions",
		 *     "returnType":"String",
		 *     "paramTypes":["Number","String"]
		 * 	}
	     */
		formatNumber: function(value, pattern) {
			return number.format(value, {pattern: pattern});
		},
		
		/**
		 *	@memberof NumericFunctions
		 *	@instance
		 *	@LogicMeta {
		 *     "api":"NumericFunctions",
		 *     "returnType":"Number",
		 *     "paramTypes":["Number","Number"]
		 * 	}
	     */
		round: function(value, places) {
			return number.round(value, places);
		},

		/**
		 * @param {Number} numval Number to format
		 * @param {Object} options Formatting options
		 * @param {Integer} options.decimals Number of decimals to use. Defaults to 2.
		 * @param {String} options.currency Currency to use (e.g. USD, EUR etc). If omitted the default currency for the current locale is used.
		 *	@memberof NumericFunctions
		 *	@instance
		 *  @returns {String}
		 *	@LogicMeta {
		 *     "api":"NumericFunctions",
		 *     "returnType":"String",
		 *     "paramTypes":["Number","Object"]
		 * 	}
	     */
		formatCurrency: function(numval, options){
		    if (numval == null || numval == undefined) {
                numval = 0;
            }
            return currency.format(numval, options);
		}
	});
});

},
'appivo/mvc/GeneralFunctions':function(){
/**
*	@namespace GeneralFunctions
*/
define(['dojo/_base/lang', 
        'dojo/_base/declare'], function(lang, declare) {
	
	return declare("appivo.mvc.GeneralFunctions", null, {
		
		/**
		 * @memberof GeneralFunctions
		 * @instance
		 * @param {Object} object Object to clone
		 * @returns {Object} clone
		 *	@LogicMeta {
		 *     "api":"GeneralFunctions",
		 *     "returnType":"Object",
		 *     "paramTypes":["Object"]
		 * 	}
	     */
		clone: function(object) {
			return lang.clone(object);
		}
	
	});
});

},
'appivo/mvc/QueryBuilder':function(){
/**
 * @interface QueryBuilder
 */
define([
		'dojo/_base/lang',
		'dojo/_base/Deferred',
	    'appivo/client/Client',
	    '../model/Query',
	    '../model/Criteria',
	    '../model/Select',
	    '../model/Where',
	    '../model/OrderBy',
	    '../model/GroupBy',
	    '../model/Functions'
], function(lang, Deferred, Client, Query, Criteria, Select, Where, OrderBy, GroupBy, Functions) {
	
	var client = Client.getInstance();
	
	function QueryBuilder(options) {
		options = options || {};
		this.options = options;
		if (!options.select) {
			options.select = {
				distinct: false
			};
		}
		options.dynamic = true;
		this.query = new Query(options);
		this.queryHandle = this.query.createHandle();
	};

	QueryBuilder.prototype = {
		constructor: QueryBuilder,
		
		load: function(options) {
			options = options || {};
			var def = new Deferred();
			this.query.setSelect(this.options.select);
			this.query.setOrderBy(this.options.orderBy);
			this.query.setGroupBy(this.options.groupBy);
			var json = this.query.toJSON();
			client.sendRequest('/api/app/' + this.options.schema.getName() + '/query/', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},				
				data: JSON.stringify(json),
				handleAs: 'json'
			}).then(function(result) {
				def.resolve(result)
				if (options.onSuccess) {
					options.onSuccess(result);
				}
			}, function(error) {
				def.reject(error);
				if (options.onError) {
					options.onError(error);
				}
			});
			return def;
		},
	
		/**
		 * Executes the query
		 * @instance
		 * @memberof QueryBuilder
 		 */	
		execute:  function() {
			return this.queryHandle.refresh();
		},
		
		getQuery: function() {
			return this.query;
		},

		/**
		 * Gets the QueryHandle for this QueryBuilder
		 * @instance
		 * @memberof QueryBuilder
		 * @returns {QueryHandle}
		 */
		getQueryHandle: function() {
			return this.queryHandle;
		},
		
		/**
		 * Sets the model to query from
		 * @instance
		 * @memberof QueryBuilder
		 * @param {String/Model-ID} model Name of model to query from
 		 */
		from: function(model) {
			this.query.setFrom(model);
		},
		
		/**
		 * Selects an attribute
		 * @instance
		 * @memberof QueryBuilder
		 * @param {String} select Path of attribute to select
		 * @param {String} alias Alias of selected attribute
 		 */
		select: function(select, alias) {
			var selector = select;
			if (!alias) {
				if (lang.isString(select)) {
					var idx = select.lastIndexOf('.');
					if (idx > -1) {
						alias = select.substring(idx + 1);						
					} else {
						alias = select;
					}
				}
			}
			
			if (!this.options.select.selectors) {
				this.options.select.selectors = [];
			}
			
			if (lang.isString(select)) {
				var model = this.query.getFrom().getModel();
				if (model.checkReference(select)) {
					this.options.select.selectors.push({
						type: 'REF',
						val: model.getName() + "." + select,
						alias: alias
					});
				}
			} else if (select.declaredClass == 'appivo.model.Criteria') {
				var ser = select.toJSON();
				var sel = {
					type: ser.type,
					val: ser.val,
					alias: alias
				};
				if (ser.type == 'FUNC') {
					sel.args = ser.args;
				}
				this.options.select.selectors.push(sel);
			}
		},

		/**
		 * Clears the select-clause
		 * @instance
		 * @memberof QueryBuilder
		 */
		clearSelect: function() {
			delete this.options.select.selectors; 
		},
		
		distinct: function(distinct) {
			this.options.select.distinct = distinct;
		},
		
		join: function(join) {
			
		},

		/**
		 * Sets the where-clause expression
		 * @instance
		 * @memberof QueryBuilder
		 * @param {Object} where Expression to filter on
		 */
		where: function(where) {
			this.query.setWhere({
				criteria: where
			});
		},

		/**
		 * Clear the where-clause
		 * @instance
		 * @memberof QueryBuilder
		 */
		clearWhere: function() {
			this.query.setWhere(null);
		},

		/**
		 * Sets the having-clause expression
		 * @instance
		 * @memberof QueryBuilder
		 * @param {Object} having Expression
		 */
		having: function(having) {
			this.query.setHaving({
				criteria: having
			});
		},

		/**
		 * Clears the having-clause
		 * @instance
		 * @memberof QueryBuilder
		 */
		clearHaving: function() {
			this.query.setHaving(null);
		},

		/**
		 * Adds an attribute to group the result by
		 * @instance
		 * @memberof QueryBuilder
		 * @param {String} path Path of attribute to group by
		 */
		groupBy: function(path) {
			if (!this.options.groupBy) {
				this.options.groupBy = {
					selectors: []
				};
			}
			if (this.query.getFrom().getModel().checkReference(path)) {
				this.options.groupBy.selectors.push({
					type: 'REF',
					val: path
				});				
			}
		},

		/**
		 * Clears the group by-clause
		 * @instance
		 * @memberof QueryBuilder
		 */
		clearGroupBy: function() {
			delete this.options.groupBy;
		},

		/**
		 * Adds an attribute to order the result by
		 * @instance
		 * @memberof QueryBuilder
		 * @param {String} path Path of attribute to order by
		 * @param {Boolean} desc Sort the result descending or not
		 */
		orderBy: function(path, desc) {
			if (!this.options.orderBy) {
				this.options.orderBy = [];
			}
			if (this.query.getFrom().getModel().checkReference(path)) {
				this.options.orderBy.push({
					path: path,
					desc: desc ? 'DESC' : 'ASC'
				});
			}
		},

		/**
		 * Clears the order by-clause
		 * @instance
		 * @memberof QueryBuilder
		 */
		clearOrderBy: function() {
			delete this.options.orderBy;
		},

		/**
		 * Creates a reference from a path
		 * @instance
		 * @memberof QueryBuilder
		 * @param {String} path Path of reference
		 * @returns {Object}
 		 */
		reference: function(path) {
			var ref = null;
			if (this.query.getFrom().getModel().checkReference(path)) {
				ref = new Criteria({
					type: 'REF',
					val: path
				});
			} 
			return ref;
		},
		
		/**
		 * Creates a value 
		 * @instance
		 * @memberof QueryBuilder
		 * @param {Object} value Value to be wrapped
		 * @returns {Object}
 		 */
		value: function(value) {
			return new Criteria({
				type: 'VAL',
				val: value
			});
		},
		
		/**
		 * Creates a function-invocation 
		 * @instance
		 * @memberof QueryBuilder
		 * @param {String} name Name of function to invoke
		 * @param {Array} args Array of arguments to pass to the function
		 * @returns {Object}
 		 */
		func: function(name, args) {
			name = name ? name.toUpperCase() : name;
			if (!Functions.isFunction(name)) {
				throw new Error("Unknown function '" + name + "'");
			}
			
			if (args) {
				if (!lang.isArray(args)) {
					args = [args];
				}
				for (var i = 0; i < args.length; i++) {
					var arg = args[i];
					if (arg.declaredClass == 'appivo.model.Criteria') {
						arg = arg.toJSON();
					}
					args[i] = arg;
				}
 			}
			
			return new Criteria({
				type: 'FUNC',
				val: name,
				args: args
			});
		},
		
		/**
		 * Create an expression
		 * @instance
		 * @memberof QueryBuilder
		 * @param {Object} lhs Lefthand side of the expression
		 * @param {String} Operator
		 * @param {Object} rhs Righthand side of the expression
		 * @returns {Criteria}
 		 */
		expression: function(lhs, op, rhs) {
			lhs = this._convert(lhs);
			rhs = this._convert(rhs);
			return new Criteria({
				schema: this.options.schema,
				type: 'EXPR',
				lhs: lhs.toJSON(),
				op: op,
				rhs: rhs.toJSON()
			});
		},
						
		_convert: function(val) {
			var crit = val;
			var type = typeof(val);
			switch (type) {
				case "boolean":
				case "string":
				case "number":
					crit = this.value(val); 
					break;
				default:
					if (lang.isArray(val)) {
						crit = this.value(val);
					}
					break;
			}
			return crit;
		}
	};

	return QueryBuilder;
});
},
'appivo/mvc/integration/ProxyFactory':function(){
define(['dojo/_base/Deferred'],
		
  function(Deferred) {
	
	function ProxyFactory() {
		this.modules = {};
		this.timeout = 120;
	};
	
	ProxyFactory.prototype = {
		
		constructor: ProxyFactory,
		
		createProxy: function(context, id, options) {
			var module = this.modules[id.id];
			if (!module) {
				if (!options) {
					options = {};
				}
				var timeout = this.timeout;
				if (options.timeout) {
					timeout = options.timeout;
				}
				module = {};
				var integration = id.integration;
				var data = integration.data;
				if (data && data.functions) {
					var functions = data.functions;
					for (var i = 0; i < functions.length; i++) {
						var func = functions[i];
						if (func.visibility == 'Public') {
							module[func.name] = this._createFunction(func, context, id, timeout);
						}
					}
				}
				this.modules[integration.id] = module;
			}
			return module;
		},
		
		_createFunction: function(func, context, id, timeout) {
			var t = this;
			return function() {
				var args = Array.prototype.slice.call(arguments);
				if (func.args) {
					for (var i = 0; i < func.args.length; i++) {
						var argdef = func.args[i];
						var arg = args[i];
						if (argdef && arg) {
							if (argdef.type === 'Record') {
								if (arg.declaredClass == 'appivo.model.Record') {
									var rec = arg.toJSON();
									rec.__model = arg.__model.id;
									args[i] = rec;
								} else if (arg.__model) {
									if (arg.__model.id) {
										arg.__model = arg.__model.id;
									}
								}
							}
						}
					}
				}
				var data = {
					args: args
				};

				var body = JSON.stringify(data);
				var headers = {
					"Content-Type": "application/json",
					"X-Timeout": timeout
				};

				var def = new Deferred();
				context.sendRequest({
					url: '/api/app/' + context.getSchema().getName() + '/integration/' + id.name + '/' + func.name,
					method: 'POST',
					data: body,
					headers: headers,
					handleAs: "text"
				}).then(function(data) {
					var res = data;
					switch (func.returnType) {
					case "Float":
						res = parseFloat(data);
						break;
					case "Integer":
						res = parseInt(data);
						break;
					case "Boolean":
						res = (data === "true");
						break;
					case "Object":
					case "Promise":
					case "Array":
						res = JSON.parse(data);
						break;
					case 'Record':
						res = JSON.parse(data);
						if (res && res.__model) {
							var schema = context.getSchema();
							var model = schema.getModelById(res.__model);
							if (model) {
								res = model.createRecord(res);
							}
						}
						break;
					}
					def.resolve(res);
					return res;
				}, function(error) {
					def.reject(error);
				});

				return def;
			};
		}
	};
	
	return ProxyFactory;
});
},
'appivo/model/CalendarEventManager':function(){
define(['dojo/_base/lang',
        'dojo/_base/declare',
        'dojo/_base/Deferred',
        'moment/moment'
        ], function(lang, declare, Deferred, moment) {

	var CEM = declare("appivo.model.CalendarEventManager", [], {
		startAttr: null, //datetime attr when the event starts
        endAttr: null, //datetime attr when event stops, if repeating this is when the series stops, could be null
        descriptionAttr: null, //String attr with display/title value of the event
        repeatYearlyAttribute: null, //Integer attr to repeat every x year
        repeatMonthlyAttribute: null, //Integer attr to repeat every x month
        repeatWeeklyAttribute: null, //Integer attr to repeat every x week
        repeatDailyAttribute: null, //Integer attr ro repeat evety x day
        repeatException: null, //relation attr used for exception to point att overridden serie
        originalStartAttr: null, //datetime attr for the time an exception should override in a serie
        repeatDurationAttribute: null,//float attr to decide the length in hours of each event in
        holidays: null, //Holydays instance to check if holiday (let it be null to avoid checking holidays)
        labelFunction: null, //function to get event label
		constructor: function(options) {
			lang.mixin(this, options);
		},
		recordsToEvents: function (result, to, from) {
			var exceptions = {};
            for ( var i = 0 ; i < result.length; i++){
                var storeRec = result[i];
                exceptions = this._getExceptionsFromStoreRec(storeRec, exceptions);
            }
            var items = [];
            for ( var i = 0 ; i < result.length; i++){
                var storeRec = result[i];
                if (storeRec[this.originalStartAttr]){
                    continue;
                }
                var itemsForRec = this._getItemsFromStoreRec(storeRec, to);
                for (var i2 = 0; i2 < itemsForRec.length; i2++){
                    var item = itemsForRec[i2];
                    var exceptionsForRec = exceptions[storeRec.id];
                    var add = true;
                    if(exceptionsForRec){
                        for (var n = 0; n < exceptionsForRec.length; n++){
                            var recFound = false;
                            if(moment(exceptionsForRec[n].originalStart).isSame(item.start)){
                                item = exceptionsForRec[n].item;
                                add = false;
                                break;
                            }
                        }
                    }
                    if (add && (!from || moment(from).isBefore(item.start)) && (!to || moment(to).isAfter(item.start))) {
                        items.push(item);
                    }
                }

            }
            for (var id in exceptions){
                var idExc = exceptions[id];
                idExc.forEach(function(obj){
                    items.push(obj.item);
                });
            }
            return items;
		},
		filterByTimeframe: function(records, from, to) {
		    var res = [];
		    var exceptions = [];
		    for (var i = 0; i < records.length; i++) {
		        var record = records[i];
		        var startIsBeforeTo = record.start.isBefore(to);
                var endIsAfterFrom = record.end.isAfter(from);
                if (startIsBeforeTo && endIsAfterFrom) {
                    res.push(record);
                }
                if (record.storeRec[this.originalStartAttr]) {
                    var originalStart = new Date(record.storeRec[this.originalStartAttr]);
                    if (originalStart < to && originalStart > from) {
                        exceptions.push(record);
                    }
                }
		    }
		    return res;
		},
		getRepeatOptions: function(){
		    return [
                {label: "Never", value: "none"},
                {label: "Daily", value: "day"},
                {label: "Weekly", value: "week"},
                {label: "Every other week", value: "week2"},
                {label: "Every month", value: "month"}
		    ]
		},
		recordToWidgetValues: function (record){
            var endDate = record[this.endAttr]
            var startDate = record[this.startAttr];
            var repeatUntil = null;
            var repeat = null;
            if (record[this.repeatDailyAttribute]) {
                repeat = "day";
            } else if (record[this.repeatWeeklyAttribute]) {
                if (record[this.repeatWeeklyAttribute] == 2) {
                    repeat = "week2";
                } else {
                    repeat ="week";
                }
            } else if (record[this.repeatMonthlyAttribute]) {
                repeat = "month";
            }
            if (repeat != null) {
                if (endDate && new Date(endDate) > new Date(1000)) {
                    repeatUntil = record[this.endAttr];
                }
                var duration = record[this.repeatDurationAttribute];
                var endDate = new Date(new Date(startDate).getTime() + (duration * 60 * 60 * 1000));
            } else {
                repeat = "none"
            }
		    return {
		        start: startDate,
		        stop: endDate,
		        repeat: repeat,
		        until: repeatUntil
		    };
		},
	    _addAvailable: function(item){
	        if(!this.available){
	            this.available = new Array();
	        }
            this.available.push(item);
        },
		_getItemsFromStoreRec: function (storeRec, to) {
			var items = [];
            var repeteraAr = storeRec[this.repeatYearlyAttribute];
            var repeteraManad = storeRec[this.repeatMonthlyAttribute];
            var repeteraVecka = storeRec[this.repeatWeeklyAttribute];
            var repeteraDag = storeRec[this.repeatDailyAttribute];
            var repeteraLangd = storeRec[this.repeatDurationAttribute];
            var values = [repeteraDag, repeteraAr, repeteraManad, repeteraVecka];
            var name = storeRec[this.descriptionAttr];
            var start = storeRec[this.startAttr];
            var end = storeRec[this.endAttr];
            var id = storeRec.id;
            if(this._allValuesAreEmpty(values)){
                //a single event
                if(start && end){
                    var item = this._createItem(name, start, end, id, storeRec, repeteraLangd);
                    items.push(item);
                    this._addAvailable(item);
                }
            } else {
                //a reoccuring event
                if (this._valueIsEmpty(repeteraLangd) || repeteraLangd <= 0){
                    return items;
                }
                var checkTime = moment(start);
                count = 0;
                while(!checkTime.isAfter(to) && count < 1000){
                    var nextTime = this._getTimeOfNextOccurence(storeRec, checkTime, to);
                    if(nextTime!=null){
                        count++;
                        checkTime = moment(nextTime).add(repeteraLangd, 'hours');
                        if (this._checkHoliday(checkTime)){
                            var item = this._createItem(name, nextTime, checkTime, id+"_"+count, storeRec, repeteraLangd);
                            this._addAvailable(item);
                            items.push(item);
                        }
                    } else {
                        break;
                    }
                }
                if(count > 995){
                    count = 0;
                    alert('Invalid data warning');
                }
            }
            return items;
		},
		_getTimeOfNextOccurence: function(storeRec, checkFromDate, checkToDate){
			try{
                var repeteraLangd = storeRec[this.repeatDurationAttribute];
                var checkFrom = moment(checkFromDate).subtract(repeteraLangd, 'hours');
                var checkTo = moment(checkToDate);
                var repeteraAr = storeRec[this.repeatYearlyAttribute];
                var repeteraManad = storeRec[this.repeatMonthlyAttribute];
                var repeteraVecka = storeRec[this.repeatWeeklyAttribute];
                var repeteraDag = storeRec[this.repeatDailyAttribute];
                var startDate = storeRec[this.startAttr];
                var start = moment(startDate);
                var endDate = storeRec[this.endAttr];
                var end = moment(endDate);
                if(start.isAfter(checkTo)){
                    return null;
                }
                if(start.isAfter(checkFrom)){
                    return start;
                }
                var testDate = start;
                if (!this._valueIsEmpty(repeteraAr)) {
                    while (testDate.isBefore(checkToDate)) {
                        if(isNaN(repeteraAr)){
                            console.error('NaN repetera år');
                        }
                        testDate.add(repeteraAr, 'years');
                        if (!testDate.isAfter(checkTo) && !testDate.isAfter(end)) {
                            if (testDate.isAfter(checkFrom)) {
                                return testDate;
                            }
                        }
                    }
                    return null;
                }
                if (!this._valueIsEmpty(repeteraManad)) {
                   while (testDate.isBefore(checkTo)){
                       testDate.add(repeteraManad, 'months');
                       if (!testDate.isAfter(checkTo) && !testDate.isAfter(end)) {
                           if (testDate.isAfter(checkFrom)) {
                               return testDate;
                           }
                       }

                   }
                   return null;
                }
                if (!this._valueIsEmpty(repeteraVecka)) {
                   while (testDate.isBefore(checkTo) ){
                       testDate.add(repeteraVecka, 'weeks');
                       if (!testDate.isAfter(checkTo) && !testDate.isAfter(end)) {
                           if (testDate.isAfter(checkFrom)) {
                                return testDate;
                           }
                       }
                   }
                   return null;
                }
                if (!this._valueIsEmpty(repeteraDag)) {
                   while (testDate.isBefore(checkTo) ){
                       testDate.add(repeteraDag, 'days');
                       if (!testDate.isAfter(checkTo) && !testDate.isAfter(end)) {
                           if (testDate.isAfter(checkFrom)) {
                               return testDate;
                           }
                       }
                   }
                   return null;
                }
            } catch (exception) {
                console.error(exception);
                return null;
            }
        },
        _checkHoliday: function (testDate) {
            var isOk = true;
            if (this.holidays) {
                var res = this.holidays.get(testDate);
                if(res != null){
                    isOk = false;
                }
            }
            return isOk;
        },
        _allValuesAreEmpty: function(values){
            for (var i = 0; i < values.length; i++){
                if(!this._valueIsEmpty(values[i])){
                    return false;
                }
            }
            return true;
        },
		_valueIsEmpty: function(val){
                return (val===undefined || val === null || val === "" || isNaN(val));
            },
		_getExceptionsFromStoreRec: function (storeRec, exceptions) {
			var originalStart = storeRec[this.originalStartAttr];
            var exception = storeRec[this.repeatException];
            if (exception && originalStart) {
                var name = storeRec[this.descriptionAttr];
                var start = storeRec[this.startAttr];
                var end = storeRec[this.endAttr];
                var repeteraLangd = storeRec[this.repeatDurationAttribute];
                var id = storeRec.id;
                var item = this._createItem(name, start, end, id, storeRec, repeteraLangd);
                if(!exceptions[exception]){
                    exceptions[exception] = [];
                }
                exceptions[exception].push({originalStart: originalStart, item: item});
            }
            return exceptions;
		},
		_createItem: function (name, start, end, id, storeRec, repeteraLangd) {
			var label = name;
			if (this.labelFunction) {
				var fn = Function("label", "data", typeof this.labelFunction == "string" ? this.labelFunction : this.labelFunction.script.script);
                label = fn(name, storeRec);
			}
            var item = {
                name: label,
                title: label,
                start: moment(start),
                end: moment(end),
                duration: repeteraLangd,
                events: [],
                id: id,
                storeRec: storeRec
            };
            return item;
		}
	});
	return CEM;
});
},
'appivo/ui/Icons':function(){
define(["dojo/_base/lang"], function(lang) {

	var icons = {};
	
	var list = [
	    {
	    	name: 'Adjust',
	    	mblClass: 'FA_Adjust',
	    	faClass: 'icon-adjust'
	    },
	    {
	    	name: 'Anchor',
	    	mblClass: 'FA_Anchor',
	    	faClass: 'icon-anchor'
	    },
	    {
	    	name: 'Archive',
	    	mblClass: 'FA_Archive',
	    	faClass: 'icon-archive'
	    },
	    {
	    	name: 'Asterisk',
	    	mblClass: 'FA_Asterisk',
	    	faClass: 'icon-asterisk'
	    },
	    {
	    	name: 'Bar-chart',
	    	mblClass: 'FA_Barchart',
	    	faClass: 'icon-bar-chart'
	    },
	    {
	    	name: 'Barcode',
	    	mblClass: 'FA_Barcode',
	    	faClass: 'icon-barcode'
	    },
	    {
	    	name: 'Beaker',
	    	mblClass: 'FA_Beaker',
	    	faClass: 'icon-beaker'
	    },
	    {
	    	name: 'Beer',
	    	mblClass: 'FA_Beer',
	    	faClass: 'icon-beer'
	    },
	    {
	    	name: 'Bell',
	    	mblClass: 'FA_Bell',
	    	faClass: 'icon-bell'
	    },
	    {
	    	name: 'Bolt',
	    	mblClass: 'FA_Bolt',
	    	faClass: 'icon-bolt'
	    },
	    {
	    	name: 'Book',
	    	mblClass: 'FA_Book',
	    	faClass: 'icon-book'
	    },
	    {
	    	name: 'Bookmark',
	    	mblClass: 'FA_Bookmark',
	    	faClass: 'icon-bookmark'
	    },
	    {
	    	name: 'Briefcase',
	    	mblClass: 'FA_Briefcase',
	    	faClass: 'icon-briefcase'
	    },
	    {
	    	name: 'Bug',
	    	mblClass: 'FA_Bug',
	    	faClass: 'icon-bug'
	    },
	    {
	    	name: 'Building',
	    	mblClass: 'FA_Building',
	    	faClass: 'icon-building'
	    },
	    {
	    	name: 'Calendar',
	    	mblClass: 'FA_Calendar',
	    	faClass: 'icon-calendar'
	    },
	    {
	    	name: 'Calendar Empty',
	    	mblClass: 'FA_CalendarEmpty',
	    	faClass: 'icon-calendar-empty'
	    },
	    {
	    	name: 'Camera',
	    	mblClass: 'FA_Camera',
	    	faClass: 'icon-camera'
	    },
	    {
	    	name: 'Cog',
	    	mblClass: 'FA_Cog',
	    	faClass: 'icon-cog'
	    },
	    {
	    	name: 'Cogs',
	    	mblClass: 'FA_Cogs',
	    	faClass: 'icon-cogs'
	    },
	    {
	    	name: 'Comment',
	    	mblClass: 'FA_Comment',
	    	faClass: 'icon-comment'
	    },
	    {
	    	name: 'Dollar',
	    	mblClass: 'FA_Dollar',
	    	faClass: 'icon-dollar'
	    },
	    {
	    	name: 'Globe',
	    	mblClass: 'FA_Globe',
	    	faClass: 'icon-globe'
	    },
	    {
	    	name: 'Group',
	    	mblClass: 'FA_Group',
	    	faClass: 'icon-group'
	    },
	    {
	    	name: 'File',
	    	mblClass: 'FA_File',
	    	faClass: 'icon-file'
	    },
	    {
	    	name: 'Flag',
	    	mblClass: 'FA_Flag',
	    	faClass: 'icon-flag'
	    },
	    {
	    	name: 'FolderOpen',
	    	mblClass: 'FA_FolderOpen',
	    	faClass: 'icon-folder-open'
	    },
	    {
	    	name: 'Heart',
	    	mblClass: 'FA_Heart',
	    	faClass: 'icon-heart'
	    },
	    {
	    	name: 'Home',
	    	mblClass: 'FA_Home',
	    	faClass: 'icon-home'
	    },
	    {
	    	name: 'Inbox',
	    	mblClass: 'FA_Inbox',
	    	faClass: 'icon-inbox'
	    },
	    {
	    	name: 'Info',
	    	mblClass: 'FA_Info',
	    	faClass: 'icon-info'
	    },
	    {
	    	name: 'InfoSign',
	    	mblClass: 'FA_InfoSign',
	    	faClass: 'icon-info-sign'
	    },
	    {
	    	name: 'Laptop',
	    	mblClass: 'FA_Laptop',
	    	faClass: 'icon-laptop'
	    },
	    {
	    	name: 'Lock',
	    	mblClass: 'FA_Lock',
	    	faClass: 'icon-lock'
	    },
	    {
	    	name: 'Lightbulb',
	    	mblClass: 'FA_Lightbulb',
	    	faClass: 'icon-lightbulb'
	    },
	    {
	    	name: 'Pencil',
	    	mblClass: 'FA_Pencil',
	    	faClass: 'icon-pencil'
	    },
	    {
	    	name: 'Phone',
	    	mblClass: 'FA_Phone',
	    	faClass: 'icon-phone'
	    },
	    {
	    	name: 'Plus',
	    	mblClass: 'FA_Plus',
	    	faClass: 'icon-plus'
	    },
	    {
	    	name: 'Plus-sign',
	    	mblClass: 'FA_PlusSign',
	    	faClass: 'icon-plus-sign'
	    },
	    {
	    	name: 'Print',
	    	mblClass: 'FA_Print',
	    	faClass: 'icon-print'
	    },
	    {
	    	name: 'Rocket',
	    	mblClass: 'FA_Rocket',
	    	faClass: 'icon-rocket'
	    },
	    {
	    	name: 'Star',
	    	mblClass: 'FA_Star',
	    	faClass: 'icon-star'
	    },
	    {
	    	name: 'Search',
	    	mblClass: 'FA_Search',
	    	faClass: 'icon-search'
	    },
	    {
	    	name: 'Tag',
	    	mblClass: 'FA_Tag',
	    	faClass: 'icon-tag'
	    },
	    {
	    	name: 'Time',
	    	mblClass: 'FA_Time',
	    	faClass: 'icon-time'
	    },
	    {
	    	name: 'Truck',
	    	mblClass: 'FA_Truck',
	    	faClass: 'icon-truck'
	    },
	    {
	    	name: 'User',
	    	mblClass: 'FA_User',
	    	faClass: 'icon-user'
	    },
	    {
	    	name: 'Wrench',
	    	mblClass: 'FA_Wrench',
	    	faClass: 'icon-wrench'
	    }
	];
	
	var sizeOptions = [
	    {
	    	label: 'Normal',
	    	value: ''
	    },
	    {
	    	label: '2x',
	    	value: '2x'
	    },
	    {
	    	label: '3x',
	    	value: '3x'
	    },
	    {
	    	label: '4x',
	    	value: '4x'
	    }
	];
	
	var index = {};
	var opts = new Array();
	for (var i in list) {
		var icon = list[i];
		opts.push({
			label: "<i class='" + icon.faClass + "'/> " +  icon.name,
			value: icon.name
		});
		index[icon.name] = icon;
	}
	
	icons.icons = list;
	
	var cloneOpts = function(opts) {
		var list = new Array();
		for (var i in opts) {
			var opt = opts[i];
			list.push({
				label: opt.label,
				value: opt.value
			});
		}
		return list;		
	};
	
	icons.getIconOptions = function() {
		return cloneOpts(opts);
	};
	
	icons.getClassName = function(icon) {
		var metadata = index[icon];
		var cls = null;
		if (metadata) {
			cls = metadata.faClass;
		}
		return cls;
	};
	
	icons.getIconHtml = function(icon, size) {
		var sizeClass = '';
		var metadata = index[icon];
		if (size && size != '') {
			sizeClass = ' ' + 'icon-' + size;
		}
		return "<i class='" + metadata.faClass + sizeClass + "'></i>";
	};
	
	icons.getMobileClassName = function(icon) {
		var metadata = index[icon];
		var cls = null;
		if (metadata) {
			cls = 'mblDomButton' + metadata.mblClass;
		}
		return cls;
	};
	
	icons.getIconSizeOptions = function() {
		return cloneOpts(sizeOptions);
	};	
	
	return icons;
});
},
'appivo/util/Handlebars':function(){
define(["dojo/_base/lang",
		"dojo/number", 
        "handlebars/handlebars",
		"handlebars4/handlebars",
        "./Date",
		"./TextDiff",
        "sanitize-html/sanitize-html",
        "dojo/date/stamp",
        "dojo/date/locale",
        "dojo/io-query",
        "../client/Client",
        "../mvc/DateFunctions",
        "dojo/currency",
        "dojo/i18n!appivo/util/nls/Handlebars"], function(lang, number, hbs, hbs4, AMDate, textDiff, sanitizeHtml, stamp, locale, ioQuery, Client, DateFunctions, currency, messages) {
	
	var client = Client.getInstance();
	var dateFunctions = new DateFunctions();
	var hbsInstance = null;
	var hbsInstance4 = null;

    var _pad = function(number) {
        var s = '' + number;
        if (s.length < 2) {
            s = '0' + s;
        }
        return s;
    };
    
    var _toNumber = function(val) {
    	if (lang.isString(val)) {
    		val = val * 1;
    	} else if (typeof val == "object" && (val && val.string)) {
    		val = val.string * 1;
    	}
    	return val;
    };

	var context = {
		clear: function() {
			hbsInstance = null;
		},
		compile: function(template, context, version) {
			var t = this;
			var compiled = this.getHandlebars(null, null, version).compile(template);
			if (context) {
				var wrapped = function (data) {
					t.context = context;
					return compiled(data);
				}
				return wrapped;
			} else {
				return compiled;
			}
		},
		getHandlebars: function(schema, force, version) {
			if (!version) {
				version = 2;
			}
			var prepare = !!force;
			var inst = (version >= 4) ? hbsInstance4 : hbsInstance;
			if (inst && !force) {
				return inst;
			} else {
				prepare = true;
				hbsInstance = hbs.create();
				prepareInstance(hbsInstance, 2);
				hbsInstance4 = hbs4.create();
				prepareInstance(hbsInstance4, 4);
				if (version < 4) {
					inst = hbsInstance;
				} else if (version >= 4) {
					inst = hbsInstance4;
				}
			}
			if (schema && prepare) {
				var tpls = schema.templates;
				if (tpls) {
					tpls.forEach(function(tpl) {
						try {
							hbsInstance.registerPartial(tpl.name, tpl.data);
							hbsInstance4.registerPartial(tpl.name, tpl.data);
						} catch (error) {
							console.error("Invalid template " + tpl.name);
							console.error(error);
						}
					});
				}
			}
			return inst;
		}
	};

	function prepareInstance(handlebars, version) {
		handlebars.registerHelper('app', function (key, options) {
			var schema = context.context.getSchema();
			var val = null;
			switch (key) {
				case 'name':
					val = schema.getName();
					break;
				case 'url':
					val = window.location.protocol + '//' + window.location.hostname + '/api/app/' + schema.getName();
					break;
			}
			return val;
		});

		handlebars.registerHelper('split', function(str, separator) {
			var values = str.split(separator);
			return values.map(function(value) {
				return value.split(";")[0];
			});
		});

		handlebars.registerHelper("statevalue", function(value, options) {
			var schema = context.context.getSchema();
			if (options.hash && options.hash.model) {
				var model = schema.getModel(options.hash.model);
				if (model) {
					var attr = model.getAttribute(options.hash.attr);
					if (attr) {
						value = attr.getEnumLabel(value);
					}
				}
			}
			return value;
		});

		handlebars.registerHelper('jsonEscape', function (str, options) {
			var value = str ? str.replace(/\n/g, "\\\\n").replace(/\r/g, "\\\\r").replace(/\t/g, "\\\\t") : str;
			return value;
		});

		handlebars.registerHelper('string', function (name, options) {
			var value = null;
			if (context.context) {
				var opts = options ? options.hash : {};
				value = context.context.getString(name, opts);
			} else {
				value = '#' + name;
			}
			return value;
		});

		handlebars.registerHelper('sanitize', function (html, options) {
			if (typeof (html) === "string") {
				var clean = sanitizeHtml.default(html);
				return new handlebars.SafeString(clean);
			} else {
				return "";
			}
		});

		handlebars.registerHelper('formatNumber', function (numval, format, options) {
			var opts = {};
			if (options === undefined && typeof format === "object") {
				options = format;
				format = undefined;
			}
			if (options && options.hash) {
				var hash = options.hash;
				opts.places = hash.decimals;
				opts.pattern = hash.pattern;
				opts.locale = hash.locale;
			}
			if (format) {
				opts.pattern = format;
			}
			if (numval == null || numval == undefined) {
				numval = 0;
			}
			var value = !isNaN(numval) ? number.format(numval, opts) : "";
			return new handlebars.SafeString(value);
		});

		handlebars.registerHelper('formatCurrency', function (numval, options) {
			var opts = {};
			if (options && options.hash) {
				var hash = options.hash;
				opts.places = hash.decimals;
				opts.pattern = hash.pattern;
				opts.locale = hash.locale;
			}
			if (numval == null || numval == undefined) {
				numval = 0;
			}
			var value = currency.format(numval, opts);
			return new handlebars.SafeString(value);
		});

		handlebars.registerHelper('startsWith', function (value, lookFor, block) {
			if (value && value.startsWith(lookFor)) {
				return block.fn(this);
			} else {
				return block.inverse(this);
			}
		});

		handlebars.registerHelper('notNullOrEmpty', function (value, block) {
			if (value !== null && value !== undefined && value !== '') {
				return block.fn(this);
			} else {
				return block.inverse(this);
			}
		});

		handlebars.registerHelper('subString', function (obj, startIndex, endIndex, opts) {
			if (opts === undefined) {
				opts = endIndex;
				endIndex = undefined;
			}
			return ('' + obj).substr(startIndex, endIndex);
		});

		handlebars.registerHelper('compare', function (lvalue, operator, rvalue, options) {
			var operators, result;

			if (arguments.length < 3) {
				throw new Error("Handlerbars Helper 'compare' needs 2 parameters");
			}

			if (options === undefined) {
				options = rvalue;
				rvalue = operator;
				operator = "===";
			}

			switch (operator) {
				case 'eq':
					operator = '==';
					break;
				case 'neq':
					operator = '!=';
					break;
				case 'gt':
					operator = '>';
					break;
				case 'lt':
					operator = '<';
				case 'gte':
					operator = '>=';
					break;
				case 'lte':
					operator = '<=';
					break;
			}

			operators = {
				'==': function (l, r) {
					return l == r;
				},
				'===': function (l, r) {
					return l === r;
				},
				'!=': function (l, r) {
					return l != r;
				},
				'!==': function (l, r) {
					return l !== r;
				},
				'<': function (l, r) {
					l = _toNumber(l);
					r = _toNumber(r);
					return l < r;
				},
				'>': function (l, r) {
					l = _toNumber(l);
					r = _toNumber(r);
					return l > r;
				},
				'<=': function (l, r) {
					l = _toNumber(l);
					r = _toNumber(r);
					return l <= r;
				},
				'>=': function (l, r) {
					l = _toNumber(l);
					r = _toNumber(r);
					return l >= r;
				},
				'typeof': function (l, r) {
					return typeof l == r;
				}
			};

			if (!operators[operator]) {
				throw new Error("Handlerbars Helper 'compare' doesn't know the operator " + operator);
			}

			result = operators[operator](lvalue, rvalue);

			if (result) {
				return options.fn(this);
			} else {
				return options.inverse(this);
			}
		});

		handlebars.registerHelper('logicalOperator', function (lvalue, operator, rvalue) {
			var res = false;
			switch (operator) {
				case '&&':
					res = lvalue && rvalue;
					break;
				case '||':
					res = lvalue || rvalue;
					break;
				case '!':
					res = !lvalue;
					break;
				case '==':
					res = lvalue == rvalue;
					break;
				case '===':
					res = lvalue === rvalue;
					break;
				case '!=':
					res = lvalue != rvalue;
					break;
				case '!==':
					res = lvalue !== rvalue;
					break;
				default:
					throw new Error("Handlebars Helper 'logicOperator' doesn't know the operator " + operator);
			}
			return !!res;
		});

		handlebars.registerHelper('arithmeticOperator', function (lvalue, operator, rvalue) {
			var operators, result;

			if (arguments.length < 3) {
				throw new Error("Handlebars Helper 'arithmeticOperator' needs 2 parameters");
			}

			if (lvalue == undefined || rvalue == undefined) {
				return "";
			}


			operators = {
				'+': function (l, r) {
					return l + r;
				},
				'-': function (l, r) {
					return l - r;
				},
				'/': function (l, r) {
					return l / r;
				},
				'*': function (l, r) {
					return l * r;
				},
				'%': function (l, r) {
					return l % r;
				}
			};

			if (!operators[operator]) {
				throw new Error("Handlerbars Helper 'arithmeticOperator' doesn't know the operator " + operator);
			}

			lvalue = _toNumber(lvalue);
			rvalue = _toNumber(rvalue);

			result = operators[operator](lvalue, rvalue);
			if (arguments.length > 5) {
				switch (arguments[4]) {
					case 'up':
						result = Math.ceil(result);
						break;
					case 'down':
						result = Math.floor(result);
						break;
					case 'default':
						result = Math.round(result);
						break;
				}
			}

			if (arguments.length > 4) {
				result = number.format(result, {pattern: arguments[3]});
			}
			result = !isNaN(result) ? result : "";

			return new handlebars.SafeString(result);
		});

		handlebars.registerHelper('formatDate', function (str, datePattern, timePattern, invalidMsg, options) {
			if (!options) {
				if (lang.isObject(invalidMsg)) {
					options = invalidMsg;
					invalidMsg = undefined;
				} else if (lang.isObject(timePattern)) {
					options = timePattern;
					timePattern = undefined;
					invalidMsg = undefined;
				} else if (lang.isObject(datePattern)) {
					options = datePattern;
					datePattern = undefined;
					timePattern = undefined;
					invalidMsg = undefined;
				}
			}

			if (!(typeof (str) == 'string' || typeof (str) == 'date' || str instanceof Date || str instanceof String)) {
				str = undefined;
			}

			if (!invalidMsg) {
				invalidMsg = "";
			}

			var dpattern = datePattern;
			var tpattern = timePattern;
			if (dpattern) {
				switch (dpattern) {
					case 'short':
					case 'medium':
					case 'long':
					case 'full':
						break;
					default:
						tpattern = undefined;
						break;
				}
			}

			var res = invalidMsg;
			var opts = {};

			if (str) {
				res = dateFunctions.formatDate(str, dpattern, tpattern);
			}
			return res;
		});

		handlebars.registerHelper('getWeekDay', function (str) {
			var res = "invalid";
			if (str) {
				var date = AMDate.fromStrToDate(str);
				res = locale.format(date, {selector: 'date', formatLength: 'medium', datePattern: 'EEEE'})
			}
			return res;
		});

		handlebars.registerHelper('formatTime', function (str, invalidMsg) {
			var res = invalidMsg ? invalidMsg : "invalid";
			if (str) {
				var date = AMDate.fromTimeStrToDate(str);
				res = AMDate.fromDateToLocalTimeStr(date);
			}
			return res;
		});

		handlebars.registerHelper('formatTimeAgo', function (date, now) {
			if (date && !(date instanceof Date)) {
				date = AMDate.fromTimeStrToDate(date);
			}
			if (now && !(now instanceof Date)) {
				now = AMDate.fromTimeStrToDate(now);
			}
			if (!now) {
				now = new Date();
			}

			var seconds = Math.floor((now - date) / 1000);
			var intervalType;

			var interval = Math.floor(seconds / 31536000);
			if (interval >= 1) {
				intervalType = 'year';
			} else {
				interval = Math.floor(seconds / 2592000);
				if (interval >= 1) {
					intervalType = 'month';
				} else {
					interval = Math.floor(seconds / 86400);
					if (interval >= 1) {
						intervalType = 'day';
					} else {
						interval = Math.floor(seconds / 3600);
						if (interval >= 1) {
							intervalType = "hour";
						} else {
							interval = Math.floor(seconds / 60);
							if (interval >= 1) {
								intervalType = "minute";
							} else {
								interval = seconds;
								intervalType = "second";
							}
						}
					}
				}
			}

			if (interval > 1 || interval === 0) {
				intervalType += 's';
			}
			var name = messages[intervalType];

			return interval + ' ' + name + ' ' + messages.ago;
		});

		handlebars.registerHelper('file', function () {
			if (arguments.length > 1) {
				var url = arguments[0];
				if (url != undefined && url != null && typeof url !== "string") {
					throw new Error("Handlerbars Helper 'file' expected argument 'url' to be of type 'string'");
				}
			}
			return client.getURI(url);
		});

		handlebars.registerHelper('hostURL', function() {
			return client.getURI("/");
		});

		handlebars.registerHelper('documentUrl', function() {
			var url = 'unknown';
			if (arguments.length > 2) {
				var model = arguments[0];
				var rec = arguments[1];
				if (!lang.isObject(model)) {
					model = context.context.getSchema().getModel(model);
				}
				if (model && rec) {
						url = model.getDocumentURI(rec, true);
				}
			} else if (arguments.length > 1) {
				var rec = arguments[0];
				if (rec) {
					if (rec.getDocumentURL) {
						url = rec.getDocumentURL(undefined, true);
					} else if (rec.__model) {
						var schema = context.context.getSchema();
						var model = rec.__model;
						if (typeof model == "string") {
							model = schema.getModel(model);
						}
						if (model && model.getDocumentURI) {
							url = model.getDocumentURI(rec, true);
						}
					}
				}
			}
			return url;
		});

		handlebars.registerHelper('thumbnailUrl', function () {
			var url = 'unknown';
			if (arguments.length > 2) {
				var model = arguments[0];
				var rec = arguments[1];
				var options = arguments[2];
				var format = options ? options.hash['format'] : undefined;
				if (!lang.isObject(model)) {
					model = context.context.getSchema().getModel(model);
				}
				if (model && rec) {
					url = model.getThumbnailURI(rec, format);
				}
			} else if (arguments.length > 1) {
				var rec = arguments[0];
				var options = arguments[1];
				var format = options ? options.hash['format'] : undefined;
				if (rec) {
					if (rec.getThumbnailURL) {
						url = rec.getThumbnailURL(format);
					} else if (rec.__model) {
						var schema = context.context.getSchema();
						var model = rec.__model;
						if (typeof model == "string") {
							model = schema.getModel(model);
						}

						if (model && model.getThumbnailURI) {
							url = model.getThumbnailURI(rec, format);
						}
					}
				}
			}
			return url;
		});

		handlebars.registerHelper('resource', function () {
			var url = 'unknown';
			if (arguments.length > 1) {
				var rsrc = arguments[0];
				if (rsrc != undefined && rsrc != null && typeof rsrc !== "string" && typeof rsrc !== "object") {
					throw new Error("Handlerbars Helper 'resource' expected argument 'resource' to be of type 'string' or 'object'");
				}
				if (context.context) {
					if (typeof rsrc === "string") {
						rsrc = context.context.getResource(rsrc);
					}
					url = context.context.getSchema().getResourceURI(rsrc);
				}
			}
			return url;
		});

		handlebars.registerHelper('configResource', function () {
			var url = 'unknown';
			if (arguments.length > 1) {
				var param = arguments[0];
				if (param != undefined && param != null && typeof param !== "string") {
					throw new Error("Handlerbars Helper 'configResource' expected argument 'param' to be of type 'string'");
				}
				if (context.context) {
					if (typeof param === "string") {
						url = "/files/" + context.context.getConfigParam(param);
					}
					url = client.getURI(url);
				}
			}
			return url;
		});

		handlebars.registerHelper('invoke', function (func, options) {
			if (context.context) {
				var str = new handlebars.SafeString(context.context.invoke(func, options.hash));
			} else {
				var str = '$' + func;
			}
			return str;
		});

		handlebars.registerHelper('concat', function () {
			var outStr = '';
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (typeof arg !== 'object' && arg !== undefined) {
					outStr += arg;
				}
			}
			return outStr;
		});

		handlebars.registerHelper('capitalize', function (str) {
			if (typeof str === "string" && str) {
				return str.charAt(0).toUpperCase() + str.slice(1);
			} else {
				return str;
			}
		});

		handlebars.registerHelper('decapitalize', function (str) {
			if (typeof str === "string" && str) {
				return str.charAt(0).toLowerCase() + str.slice(1);
			} else {
				return str;
			}
		});

		handlebars.registerHelper('toUpperCase', function (str) {
			return ("" + str).toUpperCase();
		});

		handlebars.registerHelper('toLowerCase', function (str) {
			if (typeof str === "string" && str) {
				return str.toLowerCase();
			} else {
				return str;
			}
		});

		handlebars.registerHelper('monthname', function (date) {
			if (date) {
				var monthIndex = new Date(date).getMonth();
				if (!this.monthNames) {
					this.monthNames = locale.getNames('months', 'abbr');
				}
				return this.monthNames[monthIndex];
			} else {
				return "";
			}
		});

		handlebars.registerHelper('inlineImage', function (record) {
			if (typeof record === 'object' && record.id && record.filename) {
				return "cid:" + record.id + "_" + record.filename;
			} else {
				return "";
			}
		});

		handlebars.registerHelper('barcode', function(options) {
			var url = "/api/service/barcode/generate";
			if (options && options.hash) {
				url = url + "?" + ioQuery.objectToQuery(options.hash);
			}
			return url;
		});

		handlebars.registerHelper('formatTimestamp', function (timeMs, options) {
			if (!options) {
				options = {};
			} else {
				options = options.hash;
			}
			var t = Math.floor((timeMs / 100) % 10);
			var s = Math.floor(timeMs / 1000);
			var m = Math.floor(s / 60);
			s = s % 60;
			var h = Math.floor(m / 60);
			m = m % 60;
			if (options.digital) {
				return (options.noH ? '' : _pad(h) + ':') + (options.noM ? '' : _pad(m) + ':') + (options.noS ? '' : _pad(s)) + (options.tenths ? '.' + t : '');
			} else {
				return (h > 0 ? h + 'h ' : '') + (m > 0 ? m + 'm ' : '') + s + 's';
			}
		});

		handlebars.registerHelper('loop', function (from, to, step, block) {
			var accum = '';
			if (!block) {
				block = step;
				step = 1;
			}
			if (!step) {
				step = 1;
			} else {
				step = parseInt(step);
			}
			from = parseInt(from);
			to = parseInt(to);

			for (var i = from; i <= to; i += step) {
				block.data.index = i;
				block.data.first = i === from;
				block.data.last = i === to;
				accum += block.fn(this);
			}
			return accum;
		});

		handlebars.registerHelper('jsonStringify', function (json) {
			return JSON.stringify(json);
		});

		handlebars.registerHelper('preventLink', function (val) {
			var str = "" + val;
			if (str) {
				var s1 = str.substring(0, 1);
				var s2 = "&zwnj;";
				if (str.length > 1) {
					s2 = s2 + str.substring(1);
				}
				str = s1 + s2;
			}
			return new handlebars.SafeString(str);
		});

		handlebars.registerHelper('viewerLink', function(document, options) {
			var docurl = document;
			var thumburl = document;
			if (document.declaredClass === 'appivo.model.Record') {
				docurl = document.getDocumentURL();
				thumburl = document.getThumbnailURL();
			}
			var html = '<a href="' + docurl + '"';
			var linkattrs = options.hash['linkattrs'];
			if (linkattrs) {
				var keys = Object.keys(linkattrs);
				for (var attr in keys) {
					html = html + ' ' + attr + '="';
					html = html + linkattrs[attr];
					html = html + '"';
				}
			}
			var html = '><img src="' + thumburl + '"';
			var imgattrs = options.hash['imageattrs'];
			if (imgattrs) {
				var keys = Object.keys(imgattrs);
				for (var attr in keys) {
					html = html + ' ' + attr + '="';
					html = html + imgattrs[attr];
					html = html + '"';
				}
			}
			html = html + '></a>';
			return new handlebars.SafeString(html);
		});

		handlebars.registerHelper('linkify', function(text) {
			var html = text;
			if (text) {
				var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
				html = text.replace(urlRegex, function (url) {
					var hyperlink = url;
					if (!hyperlink.match('^https?:\/\/')) {
						hyperlink = 'https://' + hyperlink;
					}
					return '<a href="' + hyperlink + '" target="_blank" rel="noopener noreferrer">' + url + '</a>'
				});
				html = new handlebars.SafeString(html);
			}
			return html;
		});

		handlebars.registerHelper('diff', function(text1, text2, options) {
			const html = textDiff(text1, text2, options);
			return new handlebars.SafeString(html);
        });

		handlebars.registerHelper('uriencode', function(text) {
			return encodeURIComponent(text);
		});

		handlebars.registerHelper('uridecode', function(text) {
			return decodeURIComponent(text);
		});

		handlebars.registerHelper('template', function (tplname, data) {
			var str = "";
			var actionContext = context.context;
			var template = actionContext.getTemplate(tplname);
			if (template) {
				var content = actionContext.executeTemplate({
					template: tplname,
					data: data
				});
				str = new handlebars.SafeString(content);
			} else {
				str = "- unknown template -";
			}
			return str;
		});
	};

	return context;
});
},
'handlebars/handlebars':function(){
/*!

 handlebars v2.0.0

Copyright (C) 2011-2014 by Yehuda Katz

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

@license
*/
/* exported Handlebars */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define([], factory);
  } else if (typeof exports === 'object') {
    module.exports = factory();
  } else {
    root.Handlebars = root.Handlebars || factory();
  }
}(this, function () {
// handlebars/safe-string.js
var __module4__ = (function() {
  "use strict";
  var __exports__;
  // Build out our basic SafeString type
  function SafeString(string) {
    this.string = string;
  }

  SafeString.prototype.toString = function() {
    return "" + this.string;
  };

  __exports__ = SafeString;
  return __exports__;
})();

// handlebars/utils.js
var __module3__ = (function(__dependency1__) {
  "use strict";
  var __exports__ = {};
  /*jshint -W004 */
  var SafeString = __dependency1__;

  var escape = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#x27;",
    "`": "&#x60;"
  };

  var badChars = /[&<>"'`]/g;
  var possible = /[&<>"'`]/;

  function escapeChar(chr) {
    return escape[chr];
  }

  function extend(obj /* , ...source */) {
    for (var i = 1; i < arguments.length; i++) {
      for (var key in arguments[i]) {
        if (Object.prototype.hasOwnProperty.call(arguments[i], key)) {
          obj[key] = arguments[i][key];
        }
      }
    }

    return obj;
  }

  __exports__.extend = extend;var toString = Object.prototype.toString;
  __exports__.toString = toString;
  // Sourced from lodash
  // https://github.com/bestiejs/lodash/blob/master/LICENSE.txt
  var isFunction = function(value) {
    return typeof value === 'function';
  };
  // fallback for older versions of Chrome and Safari
  /* istanbul ignore next */
  if (isFunction(/x/)) {
    isFunction = function(value) {
      return typeof value === 'function' && toString.call(value) === '[object Function]';
    };
  }
  var isFunction;
  __exports__.isFunction = isFunction;
  /* istanbul ignore next */
  var isArray = Array.isArray || function(value) {
    return (value && typeof value === 'object') ? toString.call(value) === '[object Array]' : false;
  };
  __exports__.isArray = isArray;

  function escapeExpression(string) {
    // don't escape SafeStrings, since they're already safe
    if (string instanceof SafeString) {
      return string.toString();
    } else if (string == null) {
      return "";
    } else if (!string) {
      return string + '';
    }

    // Force a string conversion as this will be done by the append regardless and
    // the regex test will do this transparently behind the scenes, causing issues if
    // an object's to string has escaped characters in it.
    string = "" + string;

    if(!possible.test(string)) { return string; }
    return string.replace(badChars, escapeChar);
  }

  __exports__.escapeExpression = escapeExpression;function isEmpty(value) {
    if (!value && value !== 0) {
      return true;
    } else if (isArray(value) && value.length === 0) {
      return true;
    } else {
      return false;
    }
  }

  __exports__.isEmpty = isEmpty;function appendContextPath(contextPath, id) {
    return (contextPath ? contextPath + '.' : '') + id;
  }

  __exports__.appendContextPath = appendContextPath;
  return __exports__;
})(__module4__);

// handlebars/exception.js
var __module5__ = (function() {
  "use strict";
  var __exports__;

  var errorProps = ['description', 'fileName', 'lineNumber', 'message', 'name', 'number', 'stack'];

  function Exception(message, node) {
    var line;
    if (node && node.firstLine) {
      line = node.firstLine;

      message += ' - ' + line + ':' + node.firstColumn;
    }

    var tmp = Error.prototype.constructor.call(this, message);

    // Unfortunately errors are not enumerable in Chrome (at least), so `for prop in tmp` doesn't work.
    for (var idx = 0; idx < errorProps.length; idx++) {
      this[errorProps[idx]] = tmp[errorProps[idx]];
    }

    if (line) {
      this.lineNumber = line;
      this.column = node.firstColumn;
    }
  }

  Exception.prototype = new Error();

  __exports__ = Exception;
  return __exports__;
})();

// handlebars/base.js
var __module2__ = (function(__dependency1__, __dependency2__) {
  "use strict";
  var __exports__ = {};
  var Utils = __dependency1__;
  var Exception = __dependency2__;

  var VERSION = "2.0.0";
  __exports__.VERSION = VERSION;var COMPILER_REVISION = 6;
  __exports__.COMPILER_REVISION = COMPILER_REVISION;
  var REVISION_CHANGES = {
    1: '<= 1.0.rc.2', // 1.0.rc.2 is actually rev2 but doesn't report it
    2: '== 1.0.0-rc.3',
    3: '== 1.0.0-rc.4',
    4: '== 1.x.x',
    5: '== 2.0.0-alpha.x',
    6: '>= 2.0.0-beta.1'
  };
  __exports__.REVISION_CHANGES = REVISION_CHANGES;
  var isArray = Utils.isArray,
      isFunction = Utils.isFunction,
      toString = Utils.toString,
      objectType = '[object Object]';

  function HandlebarsEnvironment(helpers, partials) {
    this.helpers = helpers || {};
    this.partials = partials || {};

    registerDefaultHelpers(this);
  }

  __exports__.HandlebarsEnvironment = HandlebarsEnvironment;HandlebarsEnvironment.prototype = {
    constructor: HandlebarsEnvironment,

    logger: logger,
    log: log,

    registerHelper: function(name, fn) {
      if (toString.call(name) === objectType) {
        if (fn) { throw new Exception('Arg not supported with multiple helpers'); }
        Utils.extend(this.helpers, name);
      } else {
        this.helpers[name] = fn;
      }
    },
    unregisterHelper: function(name) {
      delete this.helpers[name];
    },

    registerPartial: function(name, partial) {
      if (toString.call(name) === objectType) {
        Utils.extend(this.partials,  name);
      } else {
        this.partials[name] = partial;
      }
    },
    unregisterPartial: function(name) {
      delete this.partials[name];
    }
  };

  function registerDefaultHelpers(instance) {
    instance.registerHelper('helperMissing', function(/* [args, ]options */) {
      if(arguments.length === 1) {
        // A missing field in a {{foo}} constuct.
        return undefined;
      } else {
        // Someone is actually trying to call something, blow up.
        throw new Exception("Missing helper: '" + arguments[arguments.length-1].name + "'");
      }
    });

    instance.registerHelper('blockHelperMissing', function(context, options) {
      var inverse = options.inverse,
          fn = options.fn;

      if(context === true) {
        return fn(this);
      } else if(context === false || context == null) {
        return inverse(this);
      } else if (isArray(context)) {
        if(context.length > 0) {
          if (options.ids) {
            options.ids = [options.name];
          }

          return instance.helpers.each(context, options);
        } else {
          return inverse(this);
        }
      } else {
        if (options.data && options.ids) {
          var data = createFrame(options.data);
          data.contextPath = Utils.appendContextPath(options.data.contextPath, options.name);
          options = {data: data};
        }

        return fn(context, options);
      }
    });

    instance.registerHelper('each', function(context, options) {
      if (!options) {
        throw new Exception('Must pass iterator to #each');
      }

      var fn = options.fn, inverse = options.inverse;
      var i = 0, ret = "", data;

      var contextPath;
      if (options.data && options.ids) {
        contextPath = Utils.appendContextPath(options.data.contextPath, options.ids[0]) + '.';
      }

      if (isFunction(context)) { context = context.call(this); }

      if (options.data) {
        data = createFrame(options.data);
      }

      if(context && typeof context === 'object') {
        if (isArray(context)) {
          for(var j = context.length; i<j; i++) {
            if (data) {
              data.index = i;
              data.first = (i === 0);
              data.last  = (i === (context.length-1));

              if (contextPath) {
                data.contextPath = contextPath + i;
              }
            }
            ret = ret + fn(context[i], { data: data });
          }
        } else {
          for(var key in context) {
            if(context.hasOwnProperty(key)) {
              if(data) {
                data.key = key;
                data.index = i;
                data.first = (i === 0);

                if (contextPath) {
                  data.contextPath = contextPath + key;
                }
              }
              ret = ret + fn(context[key], {data: data});
              i++;
            }
          }
        }
      }

      if(i === 0){
        ret = inverse(this);
      }

      return ret;
    });

    instance.registerHelper('if', function(conditional, options) {
      if (isFunction(conditional)) { conditional = conditional.call(this); }

      // Default behavior is to render the positive path if the value is truthy and not empty.
      // The `includeZero` option may be set to treat the condtional as purely not empty based on the
      // behavior of isEmpty. Effectively this determines if 0 is handled by the positive path or negative.
      if ((!options.hash.includeZero && !conditional) || Utils.isEmpty(conditional)) {
        return options.inverse(this);
      } else {
        return options.fn(this);
      }
    });

    instance.registerHelper('unless', function(conditional, options) {
      return instance.helpers['if'].call(this, conditional, {fn: options.inverse, inverse: options.fn, hash: options.hash});
    });

    instance.registerHelper('with', function(context, options) {
      if (isFunction(context)) { context = context.call(this); }

      var fn = options.fn;

      if (!Utils.isEmpty(context)) {
        if (options.data && options.ids) {
          var data = createFrame(options.data);
          data.contextPath = Utils.appendContextPath(options.data.contextPath, options.ids[0]);
          options = {data:data};
        }

        return fn(context, options);
      } else {
        return options.inverse(this);
      }
    });

    instance.registerHelper('log', function(message, options) {
      var level = options.data && options.data.level != null ? parseInt(options.data.level, 10) : 1;
      instance.log(level, message);
    });

    instance.registerHelper('lookup', function(obj, field) {
      return obj && obj[field];
    });
  }

  var logger = {
    methodMap: { 0: 'debug', 1: 'info', 2: 'warn', 3: 'error' },

    // State enum
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3,
    level: 3,

    // can be overridden in the host environment
    log: function(level, message) {
      if (logger.level <= level) {
        var method = logger.methodMap[level];
        if (typeof console !== 'undefined' && console[method]) {
          console[method].call(console, message);
        }
      }
    }
  };
  __exports__.logger = logger;
  var log = logger.log;
  __exports__.log = log;
  var createFrame = function(object) {
    var frame = Utils.extend({}, object);
    frame._parent = object;
    return frame;
  };
  __exports__.createFrame = createFrame;
  return __exports__;
})(__module3__, __module5__);

// handlebars/runtime.js
var __module6__ = (function(__dependency1__, __dependency2__, __dependency3__) {
  "use strict";
  var __exports__ = {};
  var Utils = __dependency1__;
  var Exception = __dependency2__;
  var COMPILER_REVISION = __dependency3__.COMPILER_REVISION;
  var REVISION_CHANGES = __dependency3__.REVISION_CHANGES;
  var createFrame = __dependency3__.createFrame;

  function checkRevision(compilerInfo) {
    var compilerRevision = compilerInfo && compilerInfo[0] || 1,
        currentRevision = COMPILER_REVISION;

    if (compilerRevision !== currentRevision) {
      if (compilerRevision < currentRevision) {
        var runtimeVersions = REVISION_CHANGES[currentRevision],
            compilerVersions = REVISION_CHANGES[compilerRevision];
        throw new Exception("Template was precompiled with an older version of Handlebars than the current runtime. "+
              "Please update your precompiler to a newer version ("+runtimeVersions+") or downgrade your runtime to an older version ("+compilerVersions+").");
      } else {
        // Use the embedded version info since the runtime doesn't know about this revision yet
        throw new Exception("Template was precompiled with a newer version of Handlebars than the current runtime. "+
              "Please update your runtime to a newer version ("+compilerInfo[1]+").");
      }
    }
  }

  __exports__.checkRevision = checkRevision;// TODO: Remove this line and break up compilePartial

  function template(templateSpec, env) {
    /* istanbul ignore next */
    if (!env) {
      throw new Exception("No environment passed to template");
    }
    if (!templateSpec || !templateSpec.main) {
      throw new Exception('Unknown template object: ' + typeof templateSpec);
    }

    // Note: Using env.VM references rather than local var references throughout this section to allow
    // for external users to override these as psuedo-supported APIs.
    env.VM.checkRevision(templateSpec.compiler);

    var invokePartialWrapper = function(partial, indent, name, context, hash, helpers, partials, data, depths) {
      if (hash) {
        context = Utils.extend({}, context, hash);
      }

      var result = env.VM.invokePartial.call(this, partial, name, context, helpers, partials, data, depths);

      if (result == null && env.compile) {
        var options = { helpers: helpers, partials: partials, data: data, depths: depths };
        partials[name] = env.compile(partial, { data: data !== undefined, compat: templateSpec.compat }, env);
        result = partials[name](context, options);
      }
      if (result != null) {
        if (indent) {
          var lines = result.split('\n');
          for (var i = 0, l = lines.length; i < l; i++) {
            if (!lines[i] && i + 1 === l) {
              break;
            }

            lines[i] = indent + lines[i];
          }
          result = lines.join('\n');
        }
        return result;
      } else {
        throw new Exception("The partial " + name + " could not be compiled when running in runtime-only mode");
      }
    };

    // Just add water
    var container = {
      lookup: function(depths, name) {
        var len = depths.length;
        for (var i = 0; i < len; i++) {
          if (depths[i] && depths[i][name] != null) {
            return depths[i][name];
          }
        }
      },
      lambda: function(current, context) {
        return typeof current === 'function' ? current.call(context) : current;
      },

      escapeExpression: Utils.escapeExpression,
      invokePartial: invokePartialWrapper,

      fn: function(i) {
        return templateSpec[i];
      },

      programs: [],
      program: function(i, data, depths) {
        var programWrapper = this.programs[i],
            fn = this.fn(i);
        if (data || depths) {
          programWrapper = program(this, i, fn, data, depths);
        } else if (!programWrapper) {
          programWrapper = this.programs[i] = program(this, i, fn);
        }
        return programWrapper;
      },

      data: function(data, depth) {
        while (data && depth--) {
          data = data._parent;
        }
        return data;
      },
      merge: function(param, common) {
        var ret = param || common;

        if (param && common && (param !== common)) {
          ret = Utils.extend({}, common, param);
        }

        return ret;
      },

      noop: env.VM.noop,
      compilerInfo: templateSpec.compiler
    };

    var ret = function(context, options) {
      options = options || {};
      var data = options.data;

      ret._setup(options);
      if (!options.partial && templateSpec.useData) {
        data = initData(context, data);
      }
      var depths;
      if (templateSpec.useDepths) {
        depths = options.depths ? [context].concat(options.depths) : [context];
      }

      return templateSpec.main.call(container, context, container.helpers, container.partials, data, depths);
    };
    ret.isTop = true;

    ret._setup = function(options) {
      if (!options.partial) {
        container.helpers = container.merge(options.helpers, env.helpers);

        if (templateSpec.usePartial) {
          container.partials = container.merge(options.partials, env.partials);
        }
      } else {
        container.helpers = options.helpers;
        container.partials = options.partials;
      }
    };

    ret._child = function(i, data, depths) {
      if (templateSpec.useDepths && !depths) {
        throw new Exception('must pass parent depths');
      }

      return program(container, i, templateSpec[i], data, depths);
    };
    return ret;
  }

  __exports__.template = template;function program(container, i, fn, data, depths) {
    var prog = function(context, options) {
      options = options || {};

      return fn.call(container, context, container.helpers, container.partials, options.data || data, depths && [context].concat(depths));
    };
    prog.program = i;
    prog.depth = depths ? depths.length : 0;
    return prog;
  }

  __exports__.program = program;function invokePartial(partial, name, context, helpers, partials, data, depths) {
    var options = { partial: true, helpers: helpers, partials: partials, data: data, depths: depths };

    if(partial === undefined) {
      throw new Exception("The partial " + name + " could not be found");
    } else if(partial instanceof Function) {
      return partial(context, options);
    }
  }

  __exports__.invokePartial = invokePartial;function noop() { return ""; }

  __exports__.noop = noop;function initData(context, data) {
    if (!data || !('root' in data)) {
      data = data ? createFrame(data) : {};
      data.root = context;
    }
    return data;
  }
  return __exports__;
})(__module3__, __module5__, __module2__);

// handlebars.runtime.js
var __module1__ = (function(__dependency1__, __dependency2__, __dependency3__, __dependency4__, __dependency5__) {
  "use strict";
  var __exports__;
  /*globals Handlebars: true */
  var base = __dependency1__;

  // Each of these augment the Handlebars object. No need to setup here.
  // (This is done to easily share code between commonjs and browse envs)
  var SafeString = __dependency2__;
  var Exception = __dependency3__;
  var Utils = __dependency4__;
  var runtime = __dependency5__;

  // For compatibility and usage outside of module systems, make the Handlebars object a namespace
  var create = function() {
    var hb = new base.HandlebarsEnvironment();

    Utils.extend(hb, base);
    hb.SafeString = SafeString;
    hb.Exception = Exception;
    hb.Utils = Utils;
    hb.escapeExpression = Utils.escapeExpression;

    hb.VM = runtime;
    hb.template = function(spec) {
      return runtime.template(spec, hb);
    };

    return hb;
  };

  var Handlebars = create();
  Handlebars.create = create;

  Handlebars['default'] = Handlebars;

  __exports__ = Handlebars;
  return __exports__;
})(__module2__, __module4__, __module5__, __module3__, __module6__);

// handlebars/compiler/ast.js
var __module7__ = (function(__dependency1__) {
  "use strict";
  var __exports__;
  var Exception = __dependency1__;

  function LocationInfo(locInfo) {
    locInfo = locInfo || {};
    this.firstLine   = locInfo.first_line;
    this.firstColumn = locInfo.first_column;
    this.lastColumn  = locInfo.last_column;
    this.lastLine    = locInfo.last_line;
  }

  var AST = {
    ProgramNode: function(statements, strip, locInfo) {
      LocationInfo.call(this, locInfo);
      this.type = "program";
      this.statements = statements;
      this.strip = strip;
    },

    MustacheNode: function(rawParams, hash, open, strip, locInfo) {
      LocationInfo.call(this, locInfo);
      this.type = "mustache";
      this.strip = strip;

      // Open may be a string parsed from the parser or a passed boolean flag
      if (open != null && open.charAt) {
        // Must use charAt to support IE pre-10
        var escapeFlag = open.charAt(3) || open.charAt(2);
        this.escaped = escapeFlag !== '{' && escapeFlag !== '&';
      } else {
        this.escaped = !!open;
      }

      if (rawParams instanceof AST.SexprNode) {
        this.sexpr = rawParams;
      } else {
        // Support old AST API
        this.sexpr = new AST.SexprNode(rawParams, hash);
      }

      // Support old AST API that stored this info in MustacheNode
      this.id = this.sexpr.id;
      this.params = this.sexpr.params;
      this.hash = this.sexpr.hash;
      this.eligibleHelper = this.sexpr.eligibleHelper;
      this.isHelper = this.sexpr.isHelper;
    },

    SexprNode: function(rawParams, hash, locInfo) {
      LocationInfo.call(this, locInfo);

      this.type = "sexpr";
      this.hash = hash;

      var id = this.id = rawParams[0];
      var params = this.params = rawParams.slice(1);

      // a mustache is definitely a helper if:
      // * it is an eligible helper, and
      // * it has at least one parameter or hash segment
      this.isHelper = !!(params.length || hash);

      // a mustache is an eligible helper if:
      // * its id is simple (a single part, not `this` or `..`)
      this.eligibleHelper = this.isHelper || id.isSimple;

      // if a mustache is an eligible helper but not a definite
      // helper, it is ambiguous, and will be resolved in a later
      // pass or at runtime.
    },

    PartialNode: function(partialName, context, hash, strip, locInfo) {
      LocationInfo.call(this, locInfo);
      this.type         = "partial";
      this.partialName  = partialName;
      this.context      = context;
      this.hash = hash;
      this.strip = strip;

      this.strip.inlineStandalone = true;
    },

    BlockNode: function(mustache, program, inverse, strip, locInfo) {
      LocationInfo.call(this, locInfo);

      this.type = 'block';
      this.mustache = mustache;
      this.program  = program;
      this.inverse  = inverse;
      this.strip = strip;

      if (inverse && !program) {
        this.isInverse = true;
      }
    },

    RawBlockNode: function(mustache, content, close, locInfo) {
      LocationInfo.call(this, locInfo);

      if (mustache.sexpr.id.original !== close) {
        throw new Exception(mustache.sexpr.id.original + " doesn't match " + close, this);
      }

      content = new AST.ContentNode(content, locInfo);

      this.type = 'block';
      this.mustache = mustache;
      this.program = new AST.ProgramNode([content], {}, locInfo);
    },

    ContentNode: function(string, locInfo) {
      LocationInfo.call(this, locInfo);
      this.type = "content";
      this.original = this.string = string;
    },

    HashNode: function(pairs, locInfo) {
      LocationInfo.call(this, locInfo);
      this.type = "hash";
      this.pairs = pairs;
    },

    IdNode: function(parts, locInfo) {
      LocationInfo.call(this, locInfo);
      this.type = "ID";

      var original = "",
          dig = [],
          depth = 0,
          depthString = '';

      for(var i=0,l=parts.length; i<l; i++) {
        var part = parts[i].part;
        original += (parts[i].separator || '') + part;

        if (part === ".." || part === "." || part === "this") {
          if (dig.length > 0) {
            throw new Exception("Invalid path: " + original, this);
          } else if (part === "..") {
            depth++;
            depthString += '../';
          } else {
            this.isScoped = true;
          }
        } else {
          dig.push(part);
        }
      }

      this.original = original;
      this.parts    = dig;
      this.string   = dig.join('.');
      this.depth    = depth;
      this.idName   = depthString + this.string;

      // an ID is simple if it only has one part, and that part is not
      // `..` or `this`.
      this.isSimple = parts.length === 1 && !this.isScoped && depth === 0;

      this.stringModeValue = this.string;
    },

    PartialNameNode: function(name, locInfo) {
      LocationInfo.call(this, locInfo);
      this.type = "PARTIAL_NAME";
      this.name = name.original;
    },

    DataNode: function(id, locInfo) {
      LocationInfo.call(this, locInfo);
      this.type = "DATA";
      this.id = id;
      this.stringModeValue = id.stringModeValue;
      this.idName = '@' + id.stringModeValue;
    },

    StringNode: function(string, locInfo) {
      LocationInfo.call(this, locInfo);
      this.type = "STRING";
      this.original =
        this.string =
        this.stringModeValue = string;
    },

    NumberNode: function(number, locInfo) {
      LocationInfo.call(this, locInfo);
      this.type = "NUMBER";
      this.original =
        this.number = number;
      this.stringModeValue = Number(number);
    },

    BooleanNode: function(bool, locInfo) {
      LocationInfo.call(this, locInfo);
      this.type = "BOOLEAN";
      this.bool = bool;
      this.stringModeValue = bool === "true";
    },

    CommentNode: function(comment, locInfo) {
      LocationInfo.call(this, locInfo);
      this.type = "comment";
      this.comment = comment;

      this.strip = {
        inlineStandalone: true
      };
    }
  };


  // Must be exported as an object rather than the root of the module as the jison lexer
  // most modify the object to operate properly.
  __exports__ = AST;
  return __exports__;
})(__module5__);

// handlebars/compiler/parser.js
var __module9__ = (function() {
  "use strict";
  var __exports__;
  /* jshint ignore:start */
  /* istanbul ignore next */
  /* Jison generated parser */
  var handlebars = (function(){
  var parser = {trace: function trace() { },
  yy: {},
  symbols_: {"error":2,"root":3,"program":4,"EOF":5,"program_repetition0":6,"statement":7,"mustache":8,"block":9,"rawBlock":10,"partial":11,"CONTENT":12,"COMMENT":13,"openRawBlock":14,"END_RAW_BLOCK":15,"OPEN_RAW_BLOCK":16,"sexpr":17,"CLOSE_RAW_BLOCK":18,"openBlock":19,"block_option0":20,"closeBlock":21,"openInverse":22,"block_option1":23,"OPEN_BLOCK":24,"CLOSE":25,"OPEN_INVERSE":26,"inverseAndProgram":27,"INVERSE":28,"OPEN_ENDBLOCK":29,"path":30,"OPEN":31,"OPEN_UNESCAPED":32,"CLOSE_UNESCAPED":33,"OPEN_PARTIAL":34,"partialName":35,"param":36,"partial_option0":37,"partial_option1":38,"sexpr_repetition0":39,"sexpr_option0":40,"dataName":41,"STRING":42,"NUMBER":43,"BOOLEAN":44,"OPEN_SEXPR":45,"CLOSE_SEXPR":46,"hash":47,"hash_repetition_plus0":48,"hashSegment":49,"ID":50,"EQUALS":51,"DATA":52,"pathSegments":53,"SEP":54,"$accept":0,"$end":1},
  terminals_: {2:"error",5:"EOF",12:"CONTENT",13:"COMMENT",15:"END_RAW_BLOCK",16:"OPEN_RAW_BLOCK",18:"CLOSE_RAW_BLOCK",24:"OPEN_BLOCK",25:"CLOSE",26:"OPEN_INVERSE",28:"INVERSE",29:"OPEN_ENDBLOCK",31:"OPEN",32:"OPEN_UNESCAPED",33:"CLOSE_UNESCAPED",34:"OPEN_PARTIAL",42:"STRING",43:"NUMBER",44:"BOOLEAN",45:"OPEN_SEXPR",46:"CLOSE_SEXPR",50:"ID",51:"EQUALS",52:"DATA",54:"SEP"},
  productions_: [0,[3,2],[4,1],[7,1],[7,1],[7,1],[7,1],[7,1],[7,1],[10,3],[14,3],[9,4],[9,4],[19,3],[22,3],[27,2],[21,3],[8,3],[8,3],[11,5],[11,4],[17,3],[17,1],[36,1],[36,1],[36,1],[36,1],[36,1],[36,3],[47,1],[49,3],[35,1],[35,1],[35,1],[41,2],[30,1],[53,3],[53,1],[6,0],[6,2],[20,0],[20,1],[23,0],[23,1],[37,0],[37,1],[38,0],[38,1],[39,0],[39,2],[40,0],[40,1],[48,1],[48,2]],
  performAction: function anonymous(yytext,yyleng,yylineno,yy,yystate,$$,_$) {

  var $0 = $$.length - 1;
  switch (yystate) {
  case 1: yy.prepareProgram($$[$0-1].statements, true); return $$[$0-1]; 
  break;
  case 2:this.$ = new yy.ProgramNode(yy.prepareProgram($$[$0]), {}, this._$);
  break;
  case 3:this.$ = $$[$0];
  break;
  case 4:this.$ = $$[$0];
  break;
  case 5:this.$ = $$[$0];
  break;
  case 6:this.$ = $$[$0];
  break;
  case 7:this.$ = new yy.ContentNode($$[$0], this._$);
  break;
  case 8:this.$ = new yy.CommentNode($$[$0], this._$);
  break;
  case 9:this.$ = new yy.RawBlockNode($$[$0-2], $$[$0-1], $$[$0], this._$);
  break;
  case 10:this.$ = new yy.MustacheNode($$[$0-1], null, '', '', this._$);
  break;
  case 11:this.$ = yy.prepareBlock($$[$0-3], $$[$0-2], $$[$0-1], $$[$0], false, this._$);
  break;
  case 12:this.$ = yy.prepareBlock($$[$0-3], $$[$0-2], $$[$0-1], $$[$0], true, this._$);
  break;
  case 13:this.$ = new yy.MustacheNode($$[$0-1], null, $$[$0-2], yy.stripFlags($$[$0-2], $$[$0]), this._$);
  break;
  case 14:this.$ = new yy.MustacheNode($$[$0-1], null, $$[$0-2], yy.stripFlags($$[$0-2], $$[$0]), this._$);
  break;
  case 15:this.$ = { strip: yy.stripFlags($$[$0-1], $$[$0-1]), program: $$[$0] };
  break;
  case 16:this.$ = {path: $$[$0-1], strip: yy.stripFlags($$[$0-2], $$[$0])};
  break;
  case 17:this.$ = new yy.MustacheNode($$[$0-1], null, $$[$0-2], yy.stripFlags($$[$0-2], $$[$0]), this._$);
  break;
  case 18:this.$ = new yy.MustacheNode($$[$0-1], null, $$[$0-2], yy.stripFlags($$[$0-2], $$[$0]), this._$);
  break;
  case 19:this.$ = new yy.PartialNode($$[$0-3], $$[$0-2], $$[$0-1], yy.stripFlags($$[$0-4], $$[$0]), this._$);
  break;
  case 20:this.$ = new yy.PartialNode($$[$0-2], undefined, $$[$0-1], yy.stripFlags($$[$0-3], $$[$0]), this._$);
  break;
  case 21:this.$ = new yy.SexprNode([$$[$0-2]].concat($$[$0-1]), $$[$0], this._$);
  break;
  case 22:this.$ = new yy.SexprNode([$$[$0]], null, this._$);
  break;
  case 23:this.$ = $$[$0];
  break;
  case 24:this.$ = new yy.StringNode($$[$0], this._$);
  break;
  case 25:this.$ = new yy.NumberNode($$[$0], this._$);
  break;
  case 26:this.$ = new yy.BooleanNode($$[$0], this._$);
  break;
  case 27:this.$ = $$[$0];
  break;
  case 28:$$[$0-1].isHelper = true; this.$ = $$[$0-1];
  break;
  case 29:this.$ = new yy.HashNode($$[$0], this._$);
  break;
  case 30:this.$ = [$$[$0-2], $$[$0]];
  break;
  case 31:this.$ = new yy.PartialNameNode($$[$0], this._$);
  break;
  case 32:this.$ = new yy.PartialNameNode(new yy.StringNode($$[$0], this._$), this._$);
  break;
  case 33:this.$ = new yy.PartialNameNode(new yy.NumberNode($$[$0], this._$));
  break;
  case 34:this.$ = new yy.DataNode($$[$0], this._$);
  break;
  case 35:this.$ = new yy.IdNode($$[$0], this._$);
  break;
  case 36: $$[$0-2].push({part: $$[$0], separator: $$[$0-1]}); this.$ = $$[$0-2]; 
  break;
  case 37:this.$ = [{part: $$[$0]}];
  break;
  case 38:this.$ = [];
  break;
  case 39:$$[$0-1].push($$[$0]);
  break;
  case 48:this.$ = [];
  break;
  case 49:$$[$0-1].push($$[$0]);
  break;
  case 52:this.$ = [$$[$0]];
  break;
  case 53:$$[$0-1].push($$[$0]);
  break;
  }
  },
  table: [{3:1,4:2,5:[2,38],6:3,12:[2,38],13:[2,38],16:[2,38],24:[2,38],26:[2,38],31:[2,38],32:[2,38],34:[2,38]},{1:[3]},{5:[1,4]},{5:[2,2],7:5,8:6,9:7,10:8,11:9,12:[1,10],13:[1,11],14:16,16:[1,20],19:14,22:15,24:[1,18],26:[1,19],28:[2,2],29:[2,2],31:[1,12],32:[1,13],34:[1,17]},{1:[2,1]},{5:[2,39],12:[2,39],13:[2,39],16:[2,39],24:[2,39],26:[2,39],28:[2,39],29:[2,39],31:[2,39],32:[2,39],34:[2,39]},{5:[2,3],12:[2,3],13:[2,3],16:[2,3],24:[2,3],26:[2,3],28:[2,3],29:[2,3],31:[2,3],32:[2,3],34:[2,3]},{5:[2,4],12:[2,4],13:[2,4],16:[2,4],24:[2,4],26:[2,4],28:[2,4],29:[2,4],31:[2,4],32:[2,4],34:[2,4]},{5:[2,5],12:[2,5],13:[2,5],16:[2,5],24:[2,5],26:[2,5],28:[2,5],29:[2,5],31:[2,5],32:[2,5],34:[2,5]},{5:[2,6],12:[2,6],13:[2,6],16:[2,6],24:[2,6],26:[2,6],28:[2,6],29:[2,6],31:[2,6],32:[2,6],34:[2,6]},{5:[2,7],12:[2,7],13:[2,7],16:[2,7],24:[2,7],26:[2,7],28:[2,7],29:[2,7],31:[2,7],32:[2,7],34:[2,7]},{5:[2,8],12:[2,8],13:[2,8],16:[2,8],24:[2,8],26:[2,8],28:[2,8],29:[2,8],31:[2,8],32:[2,8],34:[2,8]},{17:21,30:22,41:23,50:[1,26],52:[1,25],53:24},{17:27,30:22,41:23,50:[1,26],52:[1,25],53:24},{4:28,6:3,12:[2,38],13:[2,38],16:[2,38],24:[2,38],26:[2,38],28:[2,38],29:[2,38],31:[2,38],32:[2,38],34:[2,38]},{4:29,6:3,12:[2,38],13:[2,38],16:[2,38],24:[2,38],26:[2,38],28:[2,38],29:[2,38],31:[2,38],32:[2,38],34:[2,38]},{12:[1,30]},{30:32,35:31,42:[1,33],43:[1,34],50:[1,26],53:24},{17:35,30:22,41:23,50:[1,26],52:[1,25],53:24},{17:36,30:22,41:23,50:[1,26],52:[1,25],53:24},{17:37,30:22,41:23,50:[1,26],52:[1,25],53:24},{25:[1,38]},{18:[2,48],25:[2,48],33:[2,48],39:39,42:[2,48],43:[2,48],44:[2,48],45:[2,48],46:[2,48],50:[2,48],52:[2,48]},{18:[2,22],25:[2,22],33:[2,22],46:[2,22]},{18:[2,35],25:[2,35],33:[2,35],42:[2,35],43:[2,35],44:[2,35],45:[2,35],46:[2,35],50:[2,35],52:[2,35],54:[1,40]},{30:41,50:[1,26],53:24},{18:[2,37],25:[2,37],33:[2,37],42:[2,37],43:[2,37],44:[2,37],45:[2,37],46:[2,37],50:[2,37],52:[2,37],54:[2,37]},{33:[1,42]},{20:43,27:44,28:[1,45],29:[2,40]},{23:46,27:47,28:[1,45],29:[2,42]},{15:[1,48]},{25:[2,46],30:51,36:49,38:50,41:55,42:[1,52],43:[1,53],44:[1,54],45:[1,56],47:57,48:58,49:60,50:[1,59],52:[1,25],53:24},{25:[2,31],42:[2,31],43:[2,31],44:[2,31],45:[2,31],50:[2,31],52:[2,31]},{25:[2,32],42:[2,32],43:[2,32],44:[2,32],45:[2,32],50:[2,32],52:[2,32]},{25:[2,33],42:[2,33],43:[2,33],44:[2,33],45:[2,33],50:[2,33],52:[2,33]},{25:[1,61]},{25:[1,62]},{18:[1,63]},{5:[2,17],12:[2,17],13:[2,17],16:[2,17],24:[2,17],26:[2,17],28:[2,17],29:[2,17],31:[2,17],32:[2,17],34:[2,17]},{18:[2,50],25:[2,50],30:51,33:[2,50],36:65,40:64,41:55,42:[1,52],43:[1,53],44:[1,54],45:[1,56],46:[2,50],47:66,48:58,49:60,50:[1,59],52:[1,25],53:24},{50:[1,67]},{18:[2,34],25:[2,34],33:[2,34],42:[2,34],43:[2,34],44:[2,34],45:[2,34],46:[2,34],50:[2,34],52:[2,34]},{5:[2,18],12:[2,18],13:[2,18],16:[2,18],24:[2,18],26:[2,18],28:[2,18],29:[2,18],31:[2,18],32:[2,18],34:[2,18]},{21:68,29:[1,69]},{29:[2,41]},{4:70,6:3,12:[2,38],13:[2,38],16:[2,38],24:[2,38],26:[2,38],29:[2,38],31:[2,38],32:[2,38],34:[2,38]},{21:71,29:[1,69]},{29:[2,43]},{5:[2,9],12:[2,9],13:[2,9],16:[2,9],24:[2,9],26:[2,9],28:[2,9],29:[2,9],31:[2,9],32:[2,9],34:[2,9]},{25:[2,44],37:72,47:73,48:58,49:60,50:[1,74]},{25:[1,75]},{18:[2,23],25:[2,23],33:[2,23],42:[2,23],43:[2,23],44:[2,23],45:[2,23],46:[2,23],50:[2,23],52:[2,23]},{18:[2,24],25:[2,24],33:[2,24],42:[2,24],43:[2,24],44:[2,24],45:[2,24],46:[2,24],50:[2,24],52:[2,24]},{18:[2,25],25:[2,25],33:[2,25],42:[2,25],43:[2,25],44:[2,25],45:[2,25],46:[2,25],50:[2,25],52:[2,25]},{18:[2,26],25:[2,26],33:[2,26],42:[2,26],43:[2,26],44:[2,26],45:[2,26],46:[2,26],50:[2,26],52:[2,26]},{18:[2,27],25:[2,27],33:[2,27],42:[2,27],43:[2,27],44:[2,27],45:[2,27],46:[2,27],50:[2,27],52:[2,27]},{17:76,30:22,41:23,50:[1,26],52:[1,25],53:24},{25:[2,47]},{18:[2,29],25:[2,29],33:[2,29],46:[2,29],49:77,50:[1,74]},{18:[2,37],25:[2,37],33:[2,37],42:[2,37],43:[2,37],44:[2,37],45:[2,37],46:[2,37],50:[2,37],51:[1,78],52:[2,37],54:[2,37]},{18:[2,52],25:[2,52],33:[2,52],46:[2,52],50:[2,52]},{12:[2,13],13:[2,13],16:[2,13],24:[2,13],26:[2,13],28:[2,13],29:[2,13],31:[2,13],32:[2,13],34:[2,13]},{12:[2,14],13:[2,14],16:[2,14],24:[2,14],26:[2,14],28:[2,14],29:[2,14],31:[2,14],32:[2,14],34:[2,14]},{12:[2,10]},{18:[2,21],25:[2,21],33:[2,21],46:[2,21]},{18:[2,49],25:[2,49],33:[2,49],42:[2,49],43:[2,49],44:[2,49],45:[2,49],46:[2,49],50:[2,49],52:[2,49]},{18:[2,51],25:[2,51],33:[2,51],46:[2,51]},{18:[2,36],25:[2,36],33:[2,36],42:[2,36],43:[2,36],44:[2,36],45:[2,36],46:[2,36],50:[2,36],52:[2,36],54:[2,36]},{5:[2,11],12:[2,11],13:[2,11],16:[2,11],24:[2,11],26:[2,11],28:[2,11],29:[2,11],31:[2,11],32:[2,11],34:[2,11]},{30:79,50:[1,26],53:24},{29:[2,15]},{5:[2,12],12:[2,12],13:[2,12],16:[2,12],24:[2,12],26:[2,12],28:[2,12],29:[2,12],31:[2,12],32:[2,12],34:[2,12]},{25:[1,80]},{25:[2,45]},{51:[1,78]},{5:[2,20],12:[2,20],13:[2,20],16:[2,20],24:[2,20],26:[2,20],28:[2,20],29:[2,20],31:[2,20],32:[2,20],34:[2,20]},{46:[1,81]},{18:[2,53],25:[2,53],33:[2,53],46:[2,53],50:[2,53]},{30:51,36:82,41:55,42:[1,52],43:[1,53],44:[1,54],45:[1,56],50:[1,26],52:[1,25],53:24},{25:[1,83]},{5:[2,19],12:[2,19],13:[2,19],16:[2,19],24:[2,19],26:[2,19],28:[2,19],29:[2,19],31:[2,19],32:[2,19],34:[2,19]},{18:[2,28],25:[2,28],33:[2,28],42:[2,28],43:[2,28],44:[2,28],45:[2,28],46:[2,28],50:[2,28],52:[2,28]},{18:[2,30],25:[2,30],33:[2,30],46:[2,30],50:[2,30]},{5:[2,16],12:[2,16],13:[2,16],16:[2,16],24:[2,16],26:[2,16],28:[2,16],29:[2,16],31:[2,16],32:[2,16],34:[2,16]}],
  defaultActions: {4:[2,1],44:[2,41],47:[2,43],57:[2,47],63:[2,10],70:[2,15],73:[2,45]},
  parseError: function parseError(str, hash) {
      throw new Error(str);
  },
  parse: function parse(input) {
      var self = this, stack = [0], vstack = [null], lstack = [], table = this.table, yytext = "", yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
      this.lexer.setInput(input);
      this.lexer.yy = this.yy;
      this.yy.lexer = this.lexer;
      this.yy.parser = this;
      if (typeof this.lexer.yylloc == "undefined")
          this.lexer.yylloc = {};
      var yyloc = this.lexer.yylloc;
      lstack.push(yyloc);
      var ranges = this.lexer.options && this.lexer.options.ranges;
      if (typeof this.yy.parseError === "function")
          this.parseError = this.yy.parseError;
      function popStack(n) {
          stack.length = stack.length - 2 * n;
          vstack.length = vstack.length - n;
          lstack.length = lstack.length - n;
      }
      function lex() {
          var token;
          token = self.lexer.lex() || 1;
          if (typeof token !== "number") {
              token = self.symbols_[token] || token;
          }
          return token;
      }
      var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
      while (true) {
          state = stack[stack.length - 1];
          if (this.defaultActions[state]) {
              action = this.defaultActions[state];
          } else {
              if (symbol === null || typeof symbol == "undefined") {
                  symbol = lex();
              }
              action = table[state] && table[state][symbol];
          }
          if (typeof action === "undefined" || !action.length || !action[0]) {
              var errStr = "";
              if (!recovering) {
                  expected = [];
                  for (p in table[state])
                      if (this.terminals_[p] && p > 2) {
                          expected.push("'" + this.terminals_[p] + "'");
                      }
                  if (this.lexer.showPosition) {
                      errStr = "Parse error on line " + (yylineno + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + expected.join(", ") + ", got '" + (this.terminals_[symbol] || symbol) + "'";
                  } else {
                      errStr = "Parse error on line " + (yylineno + 1) + ": Unexpected " + (symbol == 1?"end of input":"'" + (this.terminals_[symbol] || symbol) + "'");
                  }
                  this.parseError(errStr, {text: this.lexer.match, token: this.terminals_[symbol] || symbol, line: this.lexer.yylineno, loc: yyloc, expected: expected});
              }
          }
          if (action[0] instanceof Array && action.length > 1) {
              throw new Error("Parse Error: multiple actions possible at state: " + state + ", token: " + symbol);
          }
          switch (action[0]) {
          case 1:
              stack.push(symbol);
              vstack.push(this.lexer.yytext);
              lstack.push(this.lexer.yylloc);
              stack.push(action[1]);
              symbol = null;
              if (!preErrorSymbol) {
                  yyleng = this.lexer.yyleng;
                  yytext = this.lexer.yytext;
                  yylineno = this.lexer.yylineno;
                  yyloc = this.lexer.yylloc;
                  if (recovering > 0)
                      recovering--;
              } else {
                  symbol = preErrorSymbol;
                  preErrorSymbol = null;
              }
              break;
          case 2:
              len = this.productions_[action[1]][1];
              yyval.$ = vstack[vstack.length - len];
              yyval._$ = {first_line: lstack[lstack.length - (len || 1)].first_line, last_line: lstack[lstack.length - 1].last_line, first_column: lstack[lstack.length - (len || 1)].first_column, last_column: lstack[lstack.length - 1].last_column};
              if (ranges) {
                  yyval._$.range = [lstack[lstack.length - (len || 1)].range[0], lstack[lstack.length - 1].range[1]];
              }
              r = this.performAction.call(yyval, yytext, yyleng, yylineno, this.yy, action[1], vstack, lstack);
              if (typeof r !== "undefined") {
                  return r;
              }
              if (len) {
                  stack = stack.slice(0, -1 * len * 2);
                  vstack = vstack.slice(0, -1 * len);
                  lstack = lstack.slice(0, -1 * len);
              }
              stack.push(this.productions_[action[1]][0]);
              vstack.push(yyval.$);
              lstack.push(yyval._$);
              newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
              stack.push(newState);
              break;
          case 3:
              return true;
          }
      }
      return true;
  }
  };
  /* Jison generated lexer */
  var lexer = (function(){
  var lexer = ({EOF:1,
  parseError:function parseError(str, hash) {
          if (this.yy.parser) {
              this.yy.parser.parseError(str, hash);
          } else {
              throw new Error(str);
          }
      },
  setInput:function (input) {
          this._input = input;
          this._more = this._less = this.done = false;
          this.yylineno = this.yyleng = 0;
          this.yytext = this.matched = this.match = '';
          this.conditionStack = ['INITIAL'];
          this.yylloc = {first_line:1,first_column:0,last_line:1,last_column:0};
          if (this.options.ranges) this.yylloc.range = [0,0];
          this.offset = 0;
          return this;
      },
  input:function () {
          var ch = this._input[0];
          this.yytext += ch;
          this.yyleng++;
          this.offset++;
          this.match += ch;
          this.matched += ch;
          var lines = ch.match(/(?:\r\n?|\n).*/g);
          if (lines) {
              this.yylineno++;
              this.yylloc.last_line++;
          } else {
              this.yylloc.last_column++;
          }
          if (this.options.ranges) this.yylloc.range[1]++;

          this._input = this._input.slice(1);
          return ch;
      },
  unput:function (ch) {
          var len = ch.length;
          var lines = ch.split(/(?:\r\n?|\n)/g);

          this._input = ch + this._input;
          this.yytext = this.yytext.substr(0, this.yytext.length-len-1);
          //this.yyleng -= len;
          this.offset -= len;
          var oldLines = this.match.split(/(?:\r\n?|\n)/g);
          this.match = this.match.substr(0, this.match.length-1);
          this.matched = this.matched.substr(0, this.matched.length-1);

          if (lines.length-1) this.yylineno -= lines.length-1;
          var r = this.yylloc.range;

          this.yylloc = {first_line: this.yylloc.first_line,
            last_line: this.yylineno+1,
            first_column: this.yylloc.first_column,
            last_column: lines ?
                (lines.length === oldLines.length ? this.yylloc.first_column : 0) + oldLines[oldLines.length - lines.length].length - lines[0].length:
                this.yylloc.first_column - len
            };

          if (this.options.ranges) {
              this.yylloc.range = [r[0], r[0] + this.yyleng - len];
          }
          return this;
      },
  more:function () {
          this._more = true;
          return this;
      },
  less:function (n) {
          this.unput(this.match.slice(n));
      },
  pastInput:function () {
          var past = this.matched.substr(0, this.matched.length - this.match.length);
          return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
      },
  upcomingInput:function () {
          var next = this.match;
          if (next.length < 20) {
              next += this._input.substr(0, 20-next.length);
          }
          return (next.substr(0,20)+(next.length > 20 ? '...':'')).replace(/\n/g, "");
      },
  showPosition:function () {
          var pre = this.pastInput();
          var c = new Array(pre.length + 1).join("-");
          return pre + this.upcomingInput() + "\n" + c+"^";
      },
  next:function () {
          if (this.done) {
              return this.EOF;
          }
          if (!this._input) this.done = true;

          var token,
              match,
              tempMatch,
              index,
              col,
              lines;
          if (!this._more) {
              this.yytext = '';
              this.match = '';
          }
          var rules = this._currentRules();
          for (var i=0;i < rules.length; i++) {
              tempMatch = this._input.match(this.rules[rules[i]]);
              if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                  match = tempMatch;
                  index = i;
                  if (!this.options.flex) break;
              }
          }
          if (match) {
              lines = match[0].match(/(?:\r\n?|\n).*/g);
              if (lines) this.yylineno += lines.length;
              this.yylloc = {first_line: this.yylloc.last_line,
                             last_line: this.yylineno+1,
                             first_column: this.yylloc.last_column,
                             last_column: lines ? lines[lines.length-1].length-lines[lines.length-1].match(/\r?\n?/)[0].length : this.yylloc.last_column + match[0].length};
              this.yytext += match[0];
              this.match += match[0];
              this.matches = match;
              this.yyleng = this.yytext.length;
              if (this.options.ranges) {
                  this.yylloc.range = [this.offset, this.offset += this.yyleng];
              }
              this._more = false;
              this._input = this._input.slice(match[0].length);
              this.matched += match[0];
              token = this.performAction.call(this, this.yy, this, rules[index],this.conditionStack[this.conditionStack.length-1]);
              if (this.done && this._input) this.done = false;
              if (token) return token;
              else return;
          }
          if (this._input === "") {
              return this.EOF;
          } else {
              return this.parseError('Lexical error on line '+(this.yylineno+1)+'. Unrecognized text.\n'+this.showPosition(),
                      {text: "", token: null, line: this.yylineno});
          }
      },
  lex:function lex() {
          var r = this.next();
          if (typeof r !== 'undefined') {
              return r;
          } else {
              return this.lex();
          }
      },
  begin:function begin(condition) {
          this.conditionStack.push(condition);
      },
  popState:function popState() {
          return this.conditionStack.pop();
      },
  _currentRules:function _currentRules() {
          return this.conditions[this.conditionStack[this.conditionStack.length-1]].rules;
      },
  topState:function () {
          return this.conditionStack[this.conditionStack.length-2];
      },
  pushState:function begin(condition) {
          this.begin(condition);
      }});
  lexer.options = {};
  lexer.performAction = function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {


  function strip(start, end) {
    return yy_.yytext = yy_.yytext.substr(start, yy_.yyleng-end);
  }


  var YYSTATE=YY_START
  switch($avoiding_name_collisions) {
  case 0:
                                     if(yy_.yytext.slice(-2) === "\\\\") {
                                       strip(0,1);
                                       this.begin("mu");
                                     } else if(yy_.yytext.slice(-1) === "\\") {
                                       strip(0,1);
                                       this.begin("emu");
                                     } else {
                                       this.begin("mu");
                                     }
                                     if(yy_.yytext) return 12;
                                   
  break;
  case 1:return 12;
  break;
  case 2:
                                     this.popState();
                                     return 12;
                                   
  break;
  case 3:
                                    yy_.yytext = yy_.yytext.substr(5, yy_.yyleng-9);
                                    this.popState();
                                    return 15;
                                   
  break;
  case 4: return 12; 
  break;
  case 5:strip(0,4); this.popState(); return 13;
  break;
  case 6:return 45;
  break;
  case 7:return 46;
  break;
  case 8: return 16; 
  break;
  case 9:
                                    this.popState();
                                    this.begin('raw');
                                    return 18;
                                   
  break;
  case 10:return 34;
  break;
  case 11:return 24;
  break;
  case 12:return 29;
  break;
  case 13:this.popState(); return 28;
  break;
  case 14:this.popState(); return 28;
  break;
  case 15:return 26;
  break;
  case 16:return 26;
  break;
  case 17:return 32;
  break;
  case 18:return 31;
  break;
  case 19:this.popState(); this.begin('com');
  break;
  case 20:strip(3,5); this.popState(); return 13;
  break;
  case 21:return 31;
  break;
  case 22:return 51;
  break;
  case 23:return 50;
  break;
  case 24:return 50;
  break;
  case 25:return 54;
  break;
  case 26:// ignore whitespace
  break;
  case 27:this.popState(); return 33;
  break;
  case 28:this.popState(); return 25;
  break;
  case 29:yy_.yytext = strip(1,2).replace(/\\"/g,'"'); return 42;
  break;
  case 30:yy_.yytext = strip(1,2).replace(/\\'/g,"'"); return 42;
  break;
  case 31:return 52;
  break;
  case 32:return 44;
  break;
  case 33:return 44;
  break;
  case 34:return 43;
  break;
  case 35:return 50;
  break;
  case 36:yy_.yytext = strip(1,2); return 50;
  break;
  case 37:return 'INVALID';
  break;
  case 38:return 5;
  break;
  }
  };
  lexer.rules = [/^(?:[^\x00]*?(?=(\{\{)))/,/^(?:[^\x00]+)/,/^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/,/^(?:\{\{\{\{\/[^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=[=}\s\/.])\}\}\}\})/,/^(?:[^\x00]*?(?=(\{\{\{\{\/)))/,/^(?:[\s\S]*?--\}\})/,/^(?:\()/,/^(?:\))/,/^(?:\{\{\{\{)/,/^(?:\}\}\}\})/,/^(?:\{\{(~)?>)/,/^(?:\{\{(~)?#)/,/^(?:\{\{(~)?\/)/,/^(?:\{\{(~)?\^\s*(~)?\}\})/,/^(?:\{\{(~)?\s*else\s*(~)?\}\})/,/^(?:\{\{(~)?\^)/,/^(?:\{\{(~)?\s*else\b)/,/^(?:\{\{(~)?\{)/,/^(?:\{\{(~)?&)/,/^(?:\{\{!--)/,/^(?:\{\{![\s\S]*?\}\})/,/^(?:\{\{(~)?)/,/^(?:=)/,/^(?:\.\.)/,/^(?:\.(?=([=~}\s\/.)])))/,/^(?:[\/.])/,/^(?:\s+)/,/^(?:\}(~)?\}\})/,/^(?:(~)?\}\})/,/^(?:"(\\["]|[^"])*")/,/^(?:'(\\[']|[^'])*')/,/^(?:@)/,/^(?:true(?=([~}\s)])))/,/^(?:false(?=([~}\s)])))/,/^(?:-?[0-9]+(?:\.[0-9]+)?(?=([~}\s)])))/,/^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)]))))/,/^(?:\[[^\]]*\])/,/^(?:.)/,/^(?:$)/];
  lexer.conditions = {"mu":{"rules":[6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38],"inclusive":false},"emu":{"rules":[2],"inclusive":false},"com":{"rules":[5],"inclusive":false},"raw":{"rules":[3,4],"inclusive":false},"INITIAL":{"rules":[0,1,38],"inclusive":true}};
  return lexer;})()
  parser.lexer = lexer;
  function Parser () { this.yy = {}; }Parser.prototype = parser;parser.Parser = Parser;
  return new Parser;
  })();__exports__ = handlebars;
  /* jshint ignore:end */
  return __exports__;
})();

// handlebars/compiler/helpers.js
var __module10__ = (function(__dependency1__) {
  "use strict";
  var __exports__ = {};
  var Exception = __dependency1__;

  function stripFlags(open, close) {
    return {
      left: open.charAt(2) === '~',
      right: close.charAt(close.length-3) === '~'
    };
  }

  __exports__.stripFlags = stripFlags;
  function prepareBlock(mustache, program, inverseAndProgram, close, inverted, locInfo) {
    /*jshint -W040 */
    if (mustache.sexpr.id.original !== close.path.original) {
      throw new Exception(mustache.sexpr.id.original + ' doesn\'t match ' + close.path.original, mustache);
    }

    var inverse = inverseAndProgram && inverseAndProgram.program;

    var strip = {
      left: mustache.strip.left,
      right: close.strip.right,

      // Determine the standalone candiacy. Basically flag our content as being possibly standalone
      // so our parent can determine if we actually are standalone
      openStandalone: isNextWhitespace(program.statements),
      closeStandalone: isPrevWhitespace((inverse || program).statements)
    };

    if (mustache.strip.right) {
      omitRight(program.statements, null, true);
    }

    if (inverse) {
      var inverseStrip = inverseAndProgram.strip;

      if (inverseStrip.left) {
        omitLeft(program.statements, null, true);
      }
      if (inverseStrip.right) {
        omitRight(inverse.statements, null, true);
      }
      if (close.strip.left) {
        omitLeft(inverse.statements, null, true);
      }

      // Find standalone else statments
      if (isPrevWhitespace(program.statements)
          && isNextWhitespace(inverse.statements)) {

        omitLeft(program.statements);
        omitRight(inverse.statements);
      }
    } else {
      if (close.strip.left) {
        omitLeft(program.statements, null, true);
      }
    }

    if (inverted) {
      return new this.BlockNode(mustache, inverse, program, strip, locInfo);
    } else {
      return new this.BlockNode(mustache, program, inverse, strip, locInfo);
    }
  }

  __exports__.prepareBlock = prepareBlock;
  function prepareProgram(statements, isRoot) {
    for (var i = 0, l = statements.length; i < l; i++) {
      var current = statements[i],
          strip = current.strip;

      if (!strip) {
        continue;
      }

      var _isPrevWhitespace = isPrevWhitespace(statements, i, isRoot, current.type === 'partial'),
          _isNextWhitespace = isNextWhitespace(statements, i, isRoot),

          openStandalone = strip.openStandalone && _isPrevWhitespace,
          closeStandalone = strip.closeStandalone && _isNextWhitespace,
          inlineStandalone = strip.inlineStandalone && _isPrevWhitespace && _isNextWhitespace;

      if (strip.right) {
        omitRight(statements, i, true);
      }
      if (strip.left) {
        omitLeft(statements, i, true);
      }

      if (inlineStandalone) {
        omitRight(statements, i);

        if (omitLeft(statements, i)) {
          // If we are on a standalone node, save the indent info for partials
          if (current.type === 'partial') {
            current.indent = (/([ \t]+$)/).exec(statements[i-1].original) ? RegExp.$1 : '';
          }
        }
      }
      if (openStandalone) {
        omitRight((current.program || current.inverse).statements);

        // Strip out the previous content node if it's whitespace only
        omitLeft(statements, i);
      }
      if (closeStandalone) {
        // Always strip the next node
        omitRight(statements, i);

        omitLeft((current.inverse || current.program).statements);
      }
    }

    return statements;
  }

  __exports__.prepareProgram = prepareProgram;function isPrevWhitespace(statements, i, isRoot) {
    if (i === undefined) {
      i = statements.length;
    }

    // Nodes that end with newlines are considered whitespace (but are special
    // cased for strip operations)
    var prev = statements[i-1],
        sibling = statements[i-2];
    if (!prev) {
      return isRoot;
    }

    if (prev.type === 'content') {
      return (sibling || !isRoot ? (/\r?\n\s*?$/) : (/(^|\r?\n)\s*?$/)).test(prev.original);
    }
  }
  function isNextWhitespace(statements, i, isRoot) {
    if (i === undefined) {
      i = -1;
    }

    var next = statements[i+1],
        sibling = statements[i+2];
    if (!next) {
      return isRoot;
    }

    if (next.type === 'content') {
      return (sibling || !isRoot ? (/^\s*?\r?\n/) : (/^\s*?(\r?\n|$)/)).test(next.original);
    }
  }

  // Marks the node to the right of the position as omitted.
  // I.e. {{foo}}' ' will mark the ' ' node as omitted.
  //
  // If i is undefined, then the first child will be marked as such.
  //
  // If mulitple is truthy then all whitespace will be stripped out until non-whitespace
  // content is met.
  function omitRight(statements, i, multiple) {
    var current = statements[i == null ? 0 : i + 1];
    if (!current || current.type !== 'content' || (!multiple && current.rightStripped)) {
      return;
    }

    var original = current.string;
    current.string = current.string.replace(multiple ? (/^\s+/) : (/^[ \t]*\r?\n?/), '');
    current.rightStripped = current.string !== original;
  }

  // Marks the node to the left of the position as omitted.
  // I.e. ' '{{foo}} will mark the ' ' node as omitted.
  //
  // If i is undefined then the last child will be marked as such.
  //
  // If mulitple is truthy then all whitespace will be stripped out until non-whitespace
  // content is met.
  function omitLeft(statements, i, multiple) {
    var current = statements[i == null ? statements.length - 1 : i - 1];
    if (!current || current.type !== 'content' || (!multiple && current.leftStripped)) {
      return;
    }

    // We omit the last node if it's whitespace only and not preceeded by a non-content node.
    var original = current.string;
    current.string = current.string.replace(multiple ? (/\s+$/) : (/[ \t]+$/), '');
    current.leftStripped = current.string !== original;
    return current.leftStripped;
  }
  return __exports__;
})(__module5__);

// handlebars/compiler/base.js
var __module8__ = (function(__dependency1__, __dependency2__, __dependency3__, __dependency4__) {
  "use strict";
  var __exports__ = {};
  var parser = __dependency1__;
  var AST = __dependency2__;
  var Helpers = __dependency3__;
  var extend = __dependency4__.extend;

  __exports__.parser = parser;

  var yy = {};
  extend(yy, Helpers, AST);

  function parse(input) {
    // Just return if an already-compile AST was passed in.
    if (input.constructor === AST.ProgramNode) { return input; }

    parser.yy = yy;

    return parser.parse(input);
  }

  __exports__.parse = parse;
  return __exports__;
})(__module9__, __module7__, __module10__, __module3__);

// handlebars/compiler/compiler.js
var __module11__ = (function(__dependency1__, __dependency2__) {
  "use strict";
  var __exports__ = {};
  var Exception = __dependency1__;
  var isArray = __dependency2__.isArray;

  var slice = [].slice;

  function Compiler() {}

  __exports__.Compiler = Compiler;// the foundHelper register will disambiguate helper lookup from finding a
  // function in a context. This is necessary for mustache compatibility, which
  // requires that context functions in blocks are evaluated by blockHelperMissing,
  // and then proceed as if the resulting value was provided to blockHelperMissing.

  Compiler.prototype = {
    compiler: Compiler,

    equals: function(other) {
      var len = this.opcodes.length;
      if (other.opcodes.length !== len) {
        return false;
      }

      for (var i = 0; i < len; i++) {
        var opcode = this.opcodes[i],
            otherOpcode = other.opcodes[i];
        if (opcode.opcode !== otherOpcode.opcode || !argEquals(opcode.args, otherOpcode.args)) {
          return false;
        }
      }

      // We know that length is the same between the two arrays because they are directly tied
      // to the opcode behavior above.
      len = this.children.length;
      for (i = 0; i < len; i++) {
        if (!this.children[i].equals(other.children[i])) {
          return false;
        }
      }

      return true;
    },

    guid: 0,

    compile: function(program, options) {
      this.opcodes = [];
      this.children = [];
      this.depths = {list: []};
      this.options = options;
      this.stringParams = options.stringParams;
      this.trackIds = options.trackIds;

      // These changes will propagate to the other compiler components
      var knownHelpers = this.options.knownHelpers;
      this.options.knownHelpers = {
        'helperMissing': true,
        'blockHelperMissing': true,
        'each': true,
        'if': true,
        'unless': true,
        'with': true,
        'log': true,
        'lookup': true
      };
      if (knownHelpers) {
        for (var name in knownHelpers) {
          this.options.knownHelpers[name] = knownHelpers[name];
        }
      }

      return this.accept(program);
    },

    accept: function(node) {
      return this[node.type](node);
    },

    program: function(program) {
      var statements = program.statements;

      for(var i=0, l=statements.length; i<l; i++) {
        this.accept(statements[i]);
      }
      this.isSimple = l === 1;

      this.depths.list = this.depths.list.sort(function(a, b) {
        return a - b;
      });

      return this;
    },

    compileProgram: function(program) {
      var result = new this.compiler().compile(program, this.options);
      var guid = this.guid++, depth;

      this.usePartial = this.usePartial || result.usePartial;

      this.children[guid] = result;

      for(var i=0, l=result.depths.list.length; i<l; i++) {
        depth = result.depths.list[i];

        if(depth < 2) { continue; }
        else { this.addDepth(depth - 1); }
      }

      return guid;
    },

    block: function(block) {
      var mustache = block.mustache,
          program = block.program,
          inverse = block.inverse;

      if (program) {
        program = this.compileProgram(program);
      }

      if (inverse) {
        inverse = this.compileProgram(inverse);
      }

      var sexpr = mustache.sexpr;
      var type = this.classifySexpr(sexpr);

      if (type === "helper") {
        this.helperSexpr(sexpr, program, inverse);
      } else if (type === "simple") {
        this.simpleSexpr(sexpr);

        // now that the simple mustache is resolved, we need to
        // evaluate it by executing `blockHelperMissing`
        this.opcode('pushProgram', program);
        this.opcode('pushProgram', inverse);
        this.opcode('emptyHash');
        this.opcode('blockValue', sexpr.id.original);
      } else {
        this.ambiguousSexpr(sexpr, program, inverse);

        // now that the simple mustache is resolved, we need to
        // evaluate it by executing `blockHelperMissing`
        this.opcode('pushProgram', program);
        this.opcode('pushProgram', inverse);
        this.opcode('emptyHash');
        this.opcode('ambiguousBlockValue');
      }

      this.opcode('append');
    },

    hash: function(hash) {
      var pairs = hash.pairs, i, l;

      this.opcode('pushHash');

      for(i=0, l=pairs.length; i<l; i++) {
        this.pushParam(pairs[i][1]);
      }
      while(i--) {
        this.opcode('assignToHash', pairs[i][0]);
      }
      this.opcode('popHash');
    },

    partial: function(partial) {
      var partialName = partial.partialName;
      this.usePartial = true;

      if (partial.hash) {
        this.accept(partial.hash);
      } else {
        this.opcode('push', 'undefined');
      }

      if (partial.context) {
        this.accept(partial.context);
      } else {
        this.opcode('getContext', 0);
        this.opcode('pushContext');
      }

      this.opcode('invokePartial', partialName.name, partial.indent || '');
      this.opcode('append');
    },

    content: function(content) {
      if (content.string) {
        this.opcode('appendContent', content.string);
      }
    },

    mustache: function(mustache) {
      this.sexpr(mustache.sexpr);

      if(mustache.escaped && !this.options.noEscape) {
        this.opcode('appendEscaped');
      } else {
        this.opcode('append');
      }
    },

    ambiguousSexpr: function(sexpr, program, inverse) {
      var id = sexpr.id,
          name = id.parts[0],
          isBlock = program != null || inverse != null;

      this.opcode('getContext', id.depth);

      this.opcode('pushProgram', program);
      this.opcode('pushProgram', inverse);

      this.ID(id);

      this.opcode('invokeAmbiguous', name, isBlock);
    },

    simpleSexpr: function(sexpr) {
      var id = sexpr.id;

      if (id.type === 'DATA') {
        this.DATA(id);
      } else if (id.parts.length) {
        this.ID(id);
      } else {
        // Simplified ID for `this`
        this.addDepth(id.depth);
        this.opcode('getContext', id.depth);
        this.opcode('pushContext');
      }

      this.opcode('resolvePossibleLambda');
    },

    helperSexpr: function(sexpr, program, inverse) {
      var params = this.setupFullMustacheParams(sexpr, program, inverse),
          id = sexpr.id,
          name = id.parts[0];

      if (this.options.knownHelpers[name]) {
        this.opcode('invokeKnownHelper', params.length, name);
      } else if (this.options.knownHelpersOnly) {
        throw new Exception("You specified knownHelpersOnly, but used the unknown helper " + name, sexpr);
      } else {
        id.falsy = true;

        this.ID(id);
        this.opcode('invokeHelper', params.length, id.original, id.isSimple);
      }
    },

    sexpr: function(sexpr) {
      var type = this.classifySexpr(sexpr);

      if (type === "simple") {
        this.simpleSexpr(sexpr);
      } else if (type === "helper") {
        this.helperSexpr(sexpr);
      } else {
        this.ambiguousSexpr(sexpr);
      }
    },

    ID: function(id) {
      this.addDepth(id.depth);
      this.opcode('getContext', id.depth);

      var name = id.parts[0];
      if (!name) {
        // Context reference, i.e. `{{foo .}}` or `{{foo ..}}`
        this.opcode('pushContext');
      } else {
        this.opcode('lookupOnContext', id.parts, id.falsy, id.isScoped);
      }
    },

    DATA: function(data) {
      this.options.data = true;
      this.opcode('lookupData', data.id.depth, data.id.parts);
    },

    STRING: function(string) {
      this.opcode('pushString', string.string);
    },

    NUMBER: function(number) {
      this.opcode('pushLiteral', number.number);
    },

    BOOLEAN: function(bool) {
      this.opcode('pushLiteral', bool.bool);
    },

    comment: function() {},

    // HELPERS
    opcode: function(name) {
      this.opcodes.push({ opcode: name, args: slice.call(arguments, 1) });
    },

    addDepth: function(depth) {
      if(depth === 0) { return; }

      if(!this.depths[depth]) {
        this.depths[depth] = true;
        this.depths.list.push(depth);
      }
    },

    classifySexpr: function(sexpr) {
      var isHelper   = sexpr.isHelper;
      var isEligible = sexpr.eligibleHelper;
      var options    = this.options;

      // if ambiguous, we can possibly resolve the ambiguity now
      // An eligible helper is one that does not have a complex path, i.e. `this.foo`, `../foo` etc.
      if (isEligible && !isHelper) {
        var name = sexpr.id.parts[0];

        if (options.knownHelpers[name]) {
          isHelper = true;
        } else if (options.knownHelpersOnly) {
          isEligible = false;
        }
      }

      if (isHelper) { return "helper"; }
      else if (isEligible) { return "ambiguous"; }
      else { return "simple"; }
    },

    pushParams: function(params) {
      for(var i=0, l=params.length; i<l; i++) {
        this.pushParam(params[i]);
      }
    },

    pushParam: function(val) {
      if (this.stringParams) {
        if(val.depth) {
          this.addDepth(val.depth);
        }
        this.opcode('getContext', val.depth || 0);
        this.opcode('pushStringParam', val.stringModeValue, val.type);

        if (val.type === 'sexpr') {
          // Subexpressions get evaluated and passed in
          // in string params mode.
          this.sexpr(val);
        }
      } else {
        if (this.trackIds) {
          this.opcode('pushId', val.type, val.idName || val.stringModeValue);
        }
        this.accept(val);
      }
    },

    setupFullMustacheParams: function(sexpr, program, inverse) {
      var params = sexpr.params;
      this.pushParams(params);

      this.opcode('pushProgram', program);
      this.opcode('pushProgram', inverse);

      if (sexpr.hash) {
        this.hash(sexpr.hash);
      } else {
        this.opcode('emptyHash');
      }

      return params;
    }
  };

  function precompile(input, options, env) {
    if (input == null || (typeof input !== 'string' && input.constructor !== env.AST.ProgramNode)) {
      throw new Exception("You must pass a string or Handlebars AST to Handlebars.precompile. You passed " + input);
    }

    options = options || {};
    if (!('data' in options)) {
      options.data = true;
    }
    if (options.compat) {
      options.useDepths = true;
    }

    var ast = env.parse(input);
    var environment = new env.Compiler().compile(ast, options);
    return new env.JavaScriptCompiler().compile(environment, options);
  }

  __exports__.precompile = precompile;function compile(input, options, env) {
    if (input == null || (typeof input !== 'string' && input.constructor !== env.AST.ProgramNode)) {
      throw new Exception("You must pass a string or Handlebars AST to Handlebars.compile. You passed " + input);
    }

    options = options || {};

    if (!('data' in options)) {
      options.data = true;
    }
    if (options.compat) {
      options.useDepths = true;
    }

    var compiled;

    function compileInput() {
      var ast = env.parse(input);
      var environment = new env.Compiler().compile(ast, options);
      var templateSpec = new env.JavaScriptCompiler().compile(environment, options, undefined, true);
      return env.template(templateSpec);
    }

    // Template is only compiled on first use and cached after that point.
    var ret = function(context, options) {
      if (!compiled) {
        compiled = compileInput();
      }
      return compiled.call(this, context, options);
    };
    ret._setup = function(options) {
      if (!compiled) {
        compiled = compileInput();
      }
      return compiled._setup(options);
    };
    ret._child = function(i, data, depths) {
      if (!compiled) {
        compiled = compileInput();
      }
      return compiled._child(i, data, depths);
    };
    return ret;
  }

  __exports__.compile = compile;function argEquals(a, b) {
    if (a === b) {
      return true;
    }

    if (isArray(a) && isArray(b) && a.length === b.length) {
      for (var i = 0; i < a.length; i++) {
        if (!argEquals(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }
  }
  return __exports__;
})(__module5__, __module3__);

// handlebars/compiler/javascript-compiler.js
var __module12__ = (function(__dependency1__, __dependency2__) {
  "use strict";
  var __exports__;
  var COMPILER_REVISION = __dependency1__.COMPILER_REVISION;
  var REVISION_CHANGES = __dependency1__.REVISION_CHANGES;
  var Exception = __dependency2__;

  function Literal(value) {
    this.value = value;
  }

  function JavaScriptCompiler() {}

  JavaScriptCompiler.prototype = {
    // PUBLIC API: You can override these methods in a subclass to provide
    // alternative compiled forms for name lookup and buffering semantics
    nameLookup: function(parent, name /* , type*/) {
      if (JavaScriptCompiler.isValidJavaScriptVariableName(name)) {
        return parent + "." + name;
      } else {
        return parent + "['" + name + "']";
      }
    },
    depthedLookup: function(name) {
      this.aliases.lookup = 'this.lookup';

      return 'lookup(depths, "' + name + '")';
    },

    compilerInfo: function() {
      var revision = COMPILER_REVISION,
          versions = REVISION_CHANGES[revision];
      return [revision, versions];
    },

    appendToBuffer: function(string) {
      if (this.environment.isSimple) {
        return "return " + string + ";";
      } else {
        return {
          appendToBuffer: true,
          content: string,
          toString: function() { return "buffer += " + string + ";"; }
        };
      }
    },

    initializeBuffer: function() {
      return this.quotedString("");
    },

    namespace: "Handlebars",
    // END PUBLIC API

    compile: function(environment, options, context, asObject) {
      this.environment = environment;
      this.options = options;
      this.stringParams = this.options.stringParams;
      this.trackIds = this.options.trackIds;
      this.precompile = !asObject;

      this.name = this.environment.name;
      this.isChild = !!context;
      this.context = context || {
        programs: [],
        environments: []
      };

      this.preamble();

      this.stackSlot = 0;
      this.stackVars = [];
      this.aliases = {};
      this.registers = { list: [] };
      this.hashes = [];
      this.compileStack = [];
      this.inlineStack = [];

      this.compileChildren(environment, options);

      this.useDepths = this.useDepths || environment.depths.list.length || this.options.compat;

      var opcodes = environment.opcodes,
          opcode,
          i,
          l;

      for (i = 0, l = opcodes.length; i < l; i++) {
        opcode = opcodes[i];

        this[opcode.opcode].apply(this, opcode.args);
      }

      // Flush any trailing content that might be pending.
      this.pushSource('');

      /* istanbul ignore next */
      if (this.stackSlot || this.inlineStack.length || this.compileStack.length) {
        throw new Exception('Compile completed with content left on stack');
      }

      var fn = this.createFunctionContext(asObject);
      if (!this.isChild) {
        var ret = {
          compiler: this.compilerInfo(),
          main: fn
        };
        var programs = this.context.programs;
        for (i = 0, l = programs.length; i < l; i++) {
          if (programs[i]) {
            ret[i] = programs[i];
          }
        }

        if (this.environment.usePartial) {
          ret.usePartial = true;
        }
        if (this.options.data) {
          ret.useData = true;
        }
        if (this.useDepths) {
          ret.useDepths = true;
        }
        if (this.options.compat) {
          ret.compat = true;
        }

        if (!asObject) {
          ret.compiler = JSON.stringify(ret.compiler);
          ret = this.objectLiteral(ret);
        }

        return ret;
      } else {
        return fn;
      }
    },

    preamble: function() {
      // track the last context pushed into place to allow skipping the
      // getContext opcode when it would be a noop
      this.lastContext = 0;
      this.source = [];
    },

    createFunctionContext: function(asObject) {
      var varDeclarations = '';

      var locals = this.stackVars.concat(this.registers.list);
      if(locals.length > 0) {
        varDeclarations += ", " + locals.join(", ");
      }

      // Generate minimizer alias mappings
      for (var alias in this.aliases) {
        if (this.aliases.hasOwnProperty(alias)) {
          varDeclarations += ', ' + alias + '=' + this.aliases[alias];
        }
      }

      var params = ["depth0", "helpers", "partials", "data"];

      if (this.useDepths) {
        params.push('depths');
      }

      // Perform a second pass over the output to merge content when possible
      var source = this.mergeSource(varDeclarations);

      if (asObject) {
        params.push(source);

        return Function.apply(this, params);
      } else {
        return 'function(' + params.join(',') + ') {\n  ' + source + '}';
      }
    },
    mergeSource: function(varDeclarations) {
      var source = '',
          buffer,
          appendOnly = !this.forceBuffer,
          appendFirst;

      for (var i = 0, len = this.source.length; i < len; i++) {
        var line = this.source[i];
        if (line.appendToBuffer) {
          if (buffer) {
            buffer = buffer + '\n    + ' + line.content;
          } else {
            buffer = line.content;
          }
        } else {
          if (buffer) {
            if (!source) {
              appendFirst = true;
              source = buffer + ';\n  ';
            } else {
              source += 'buffer += ' + buffer + ';\n  ';
            }
            buffer = undefined;
          }
          source += line + '\n  ';

          if (!this.environment.isSimple) {
            appendOnly = false;
          }
        }
      }

      if (appendOnly) {
        if (buffer || !source) {
          source += 'return ' + (buffer || '""') + ';\n';
        }
      } else {
        varDeclarations += ", buffer = " + (appendFirst ? '' : this.initializeBuffer());
        if (buffer) {
          source += 'return buffer + ' + buffer + ';\n';
        } else {
          source += 'return buffer;\n';
        }
      }

      if (varDeclarations) {
        source = 'var ' + varDeclarations.substring(2) + (appendFirst ? '' : ';\n  ') + source;
      }

      return source;
    },

    // [blockValue]
    //
    // On stack, before: hash, inverse, program, value
    // On stack, after: return value of blockHelperMissing
    //
    // The purpose of this opcode is to take a block of the form
    // `{{#this.foo}}...{{/this.foo}}`, resolve the value of `foo`, and
    // replace it on the stack with the result of properly
    // invoking blockHelperMissing.
    blockValue: function(name) {
      this.aliases.blockHelperMissing = 'helpers.blockHelperMissing';

      var params = [this.contextName(0)];
      this.setupParams(name, 0, params);

      var blockName = this.popStack();
      params.splice(1, 0, blockName);

      this.push('blockHelperMissing.call(' + params.join(', ') + ')');
    },

    // [ambiguousBlockValue]
    //
    // On stack, before: hash, inverse, program, value
    // Compiler value, before: lastHelper=value of last found helper, if any
    // On stack, after, if no lastHelper: same as [blockValue]
    // On stack, after, if lastHelper: value
    ambiguousBlockValue: function() {
      this.aliases.blockHelperMissing = 'helpers.blockHelperMissing';

      // We're being a bit cheeky and reusing the options value from the prior exec
      var params = [this.contextName(0)];
      this.setupParams('', 0, params, true);

      this.flushInline();

      var current = this.topStack();
      params.splice(1, 0, current);

      this.pushSource("if (!" + this.lastHelper + ") { " + current + " = blockHelperMissing.call(" + params.join(", ") + "); }");
    },

    // [appendContent]
    //
    // On stack, before: ...
    // On stack, after: ...
    //
    // Appends the string value of `content` to the current buffer
    appendContent: function(content) {
      if (this.pendingContent) {
        content = this.pendingContent + content;
      }

      this.pendingContent = content;
    },

    // [append]
    //
    // On stack, before: value, ...
    // On stack, after: ...
    //
    // Coerces `value` to a String and appends it to the current buffer.
    //
    // If `value` is truthy, or 0, it is coerced into a string and appended
    // Otherwise, the empty string is appended
    append: function() {
      // Force anything that is inlined onto the stack so we don't have duplication
      // when we examine local
      this.flushInline();
      var local = this.popStack();
      this.pushSource('if (' + local + ' != null) { ' + this.appendToBuffer(local) + ' }');
      if (this.environment.isSimple) {
        this.pushSource("else { " + this.appendToBuffer("''") + " }");
      }
    },

    // [appendEscaped]
    //
    // On stack, before: value, ...
    // On stack, after: ...
    //
    // Escape `value` and append it to the buffer
    appendEscaped: function() {
      this.aliases.escapeExpression = 'this.escapeExpression';

      this.pushSource(this.appendToBuffer("escapeExpression(" + this.popStack() + ")"));
    },

    // [getContext]
    //
    // On stack, before: ...
    // On stack, after: ...
    // Compiler value, after: lastContext=depth
    //
    // Set the value of the `lastContext` compiler value to the depth
    getContext: function(depth) {
      this.lastContext = depth;
    },

    // [pushContext]
    //
    // On stack, before: ...
    // On stack, after: currentContext, ...
    //
    // Pushes the value of the current context onto the stack.
    pushContext: function() {
      this.pushStackLiteral(this.contextName(this.lastContext));
    },

    // [lookupOnContext]
    //
    // On stack, before: ...
    // On stack, after: currentContext[name], ...
    //
    // Looks up the value of `name` on the current context and pushes
    // it onto the stack.
    lookupOnContext: function(parts, falsy, scoped) {
      /*jshint -W083 */
      var i = 0,
          len = parts.length;

      if (!scoped && this.options.compat && !this.lastContext) {
        // The depthed query is expected to handle the undefined logic for the root level that
        // is implemented below, so we evaluate that directly in compat mode
        this.push(this.depthedLookup(parts[i++]));
      } else {
        this.pushContext();
      }

      for (; i < len; i++) {
        this.replaceStack(function(current) {
          var lookup = this.nameLookup(current, parts[i], 'context');
          // We want to ensure that zero and false are handled properly if the context (falsy flag)
          // needs to have the special handling for these values.
          if (!falsy) {
            return ' != null ? ' + lookup + ' : ' + current;
          } else {
            // Otherwise we can use generic falsy handling
            return ' && ' + lookup;
          }
        });
      }
    },

    // [lookupData]
    //
    // On stack, before: ...
    // On stack, after: data, ...
    //
    // Push the data lookup operator
    lookupData: function(depth, parts) {
      /*jshint -W083 */
      if (!depth) {
        this.pushStackLiteral('data');
      } else {
        this.pushStackLiteral('this.data(data, ' + depth + ')');
      }

      var len = parts.length;
      for (var i = 0; i < len; i++) {
        this.replaceStack(function(current) {
          return ' && ' + this.nameLookup(current, parts[i], 'data');
        });
      }
    },

    // [resolvePossibleLambda]
    //
    // On stack, before: value, ...
    // On stack, after: resolved value, ...
    //
    // If the `value` is a lambda, replace it on the stack by
    // the return value of the lambda
    resolvePossibleLambda: function() {
      this.aliases.lambda = 'this.lambda';

      this.push('lambda(' + this.popStack() + ', ' + this.contextName(0) + ')');
    },

    // [pushStringParam]
    //
    // On stack, before: ...
    // On stack, after: string, currentContext, ...
    //
    // This opcode is designed for use in string mode, which
    // provides the string value of a parameter along with its
    // depth rather than resolving it immediately.
    pushStringParam: function(string, type) {
      this.pushContext();
      this.pushString(type);

      // If it's a subexpression, the string result
      // will be pushed after this opcode.
      if (type !== 'sexpr') {
        if (typeof string === 'string') {
          this.pushString(string);
        } else {
          this.pushStackLiteral(string);
        }
      }
    },

    emptyHash: function() {
      this.pushStackLiteral('{}');

      if (this.trackIds) {
        this.push('{}'); // hashIds
      }
      if (this.stringParams) {
        this.push('{}'); // hashContexts
        this.push('{}'); // hashTypes
      }
    },
    pushHash: function() {
      if (this.hash) {
        this.hashes.push(this.hash);
      }
      this.hash = {values: [], types: [], contexts: [], ids: []};
    },
    popHash: function() {
      var hash = this.hash;
      this.hash = this.hashes.pop();

      if (this.trackIds) {
        this.push('{' + hash.ids.join(',') + '}');
      }
      if (this.stringParams) {
        this.push('{' + hash.contexts.join(',') + '}');
        this.push('{' + hash.types.join(',') + '}');
      }

      this.push('{\n    ' + hash.values.join(',\n    ') + '\n  }');
    },

    // [pushString]
    //
    // On stack, before: ...
    // On stack, after: quotedString(string), ...
    //
    // Push a quoted version of `string` onto the stack
    pushString: function(string) {
      this.pushStackLiteral(this.quotedString(string));
    },

    // [push]
    //
    // On stack, before: ...
    // On stack, after: expr, ...
    //
    // Push an expression onto the stack
    push: function(expr) {
      this.inlineStack.push(expr);
      return expr;
    },

    // [pushLiteral]
    //
    // On stack, before: ...
    // On stack, after: value, ...
    //
    // Pushes a value onto the stack. This operation prevents
    // the compiler from creating a temporary variable to hold
    // it.
    pushLiteral: function(value) {
      this.pushStackLiteral(value);
    },

    // [pushProgram]
    //
    // On stack, before: ...
    // On stack, after: program(guid), ...
    //
    // Push a program expression onto the stack. This takes
    // a compile-time guid and converts it into a runtime-accessible
    // expression.
    pushProgram: function(guid) {
      if (guid != null) {
        this.pushStackLiteral(this.programExpression(guid));
      } else {
        this.pushStackLiteral(null);
      }
    },

    // [invokeHelper]
    //
    // On stack, before: hash, inverse, program, params..., ...
    // On stack, after: result of helper invocation
    //
    // Pops off the helper's parameters, invokes the helper,
    // and pushes the helper's return value onto the stack.
    //
    // If the helper is not found, `helperMissing` is called.
    invokeHelper: function(paramSize, name, isSimple) {
      this.aliases.helperMissing = 'helpers.helperMissing';

      var nonHelper = this.popStack();
      var helper = this.setupHelper(paramSize, name);

      var lookup = (isSimple ? helper.name + ' || ' : '') + nonHelper + ' || helperMissing';
      this.push('((' + lookup + ').call(' + helper.callParams + '))');
    },

    // [invokeKnownHelper]
    //
    // On stack, before: hash, inverse, program, params..., ...
    // On stack, after: result of helper invocation
    //
    // This operation is used when the helper is known to exist,
    // so a `helperMissing` fallback is not required.
    invokeKnownHelper: function(paramSize, name) {
      var helper = this.setupHelper(paramSize, name);
      this.push(helper.name + ".call(" + helper.callParams + ")");
    },

    // [invokeAmbiguous]
    //
    // On stack, before: hash, inverse, program, params..., ...
    // On stack, after: result of disambiguation
    //
    // This operation is used when an expression like `{{foo}}`
    // is provided, but we don't know at compile-time whether it
    // is a helper or a path.
    //
    // This operation emits more code than the other options,
    // and can be avoided by passing the `knownHelpers` and
    // `knownHelpersOnly` flags at compile-time.
    invokeAmbiguous: function(name, helperCall) {
      this.aliases.functionType = '"function"';
      this.aliases.helperMissing = 'helpers.helperMissing';
      this.useRegister('helper');

      var nonHelper = this.popStack();

      this.emptyHash();
      var helper = this.setupHelper(0, name, helperCall);

      var helperName = this.lastHelper = this.nameLookup('helpers', name, 'helper');

      this.push(
        '((helper = (helper = ' + helperName + ' || ' + nonHelper + ') != null ? helper : helperMissing'
          + (helper.paramsInit ? '),(' + helper.paramsInit : '') + '),'
        + '(typeof helper === functionType ? helper.call(' + helper.callParams + ') : helper))');
    },

    // [invokePartial]
    //
    // On stack, before: context, ...
    // On stack after: result of partial invocation
    //
    // This operation pops off a context, invokes a partial with that context,
    // and pushes the result of the invocation back.
    invokePartial: function(name, indent) {
      var params = [this.nameLookup('partials', name, 'partial'), "'" + indent + "'", "'" + name + "'", this.popStack(), this.popStack(), "helpers", "partials"];

      if (this.options.data) {
        params.push("data");
      } else if (this.options.compat) {
        params.push('undefined');
      }
      if (this.options.compat) {
        params.push('depths');
      }

      this.push("this.invokePartial(" + params.join(", ") + ")");
    },

    // [assignToHash]
    //
    // On stack, before: value, ..., hash, ...
    // On stack, after: ..., hash, ...
    //
    // Pops a value off the stack and assigns it to the current hash
    assignToHash: function(key) {
      var value = this.popStack(),
          context,
          type,
          id;

      if (this.trackIds) {
        id = this.popStack();
      }
      if (this.stringParams) {
        type = this.popStack();
        context = this.popStack();
      }

      var hash = this.hash;
      if (context) {
        hash.contexts.push("'" + key + "': " + context);
      }
      if (type) {
        hash.types.push("'" + key + "': " + type);
      }
      if (id) {
        hash.ids.push("'" + key + "': " + id);
      }
      hash.values.push("'" + key + "': (" + value + ")");
    },

    pushId: function(type, name) {
      if (type === 'ID' || type === 'DATA') {
        this.pushString(name);
      } else if (type === 'sexpr') {
        this.pushStackLiteral('true');
      } else {
        this.pushStackLiteral('null');
      }
    },

    // HELPERS

    compiler: JavaScriptCompiler,

    compileChildren: function(environment, options) {
      var children = environment.children, child, compiler;

      for(var i=0, l=children.length; i<l; i++) {
        child = children[i];
        compiler = new this.compiler();

        var index = this.matchExistingProgram(child);

        if (index == null) {
          this.context.programs.push('');     // Placeholder to prevent name conflicts for nested children
          index = this.context.programs.length;
          child.index = index;
          child.name = 'program' + index;
          this.context.programs[index] = compiler.compile(child, options, this.context, !this.precompile);
          this.context.environments[index] = child;

          this.useDepths = this.useDepths || compiler.useDepths;
        } else {
          child.index = index;
          child.name = 'program' + index;
        }
      }
    },
    matchExistingProgram: function(child) {
      for (var i = 0, len = this.context.environments.length; i < len; i++) {
        var environment = this.context.environments[i];
        if (environment && environment.equals(child)) {
          return i;
        }
      }
    },

    programExpression: function(guid) {
      var child = this.environment.children[guid],
          depths = child.depths.list,
          useDepths = this.useDepths,
          depth;

      var programParams = [child.index, 'data'];

      if (useDepths) {
        programParams.push('depths');
      }

      return 'this.program(' + programParams.join(', ') + ')';
    },

    useRegister: function(name) {
      if(!this.registers[name]) {
        this.registers[name] = true;
        this.registers.list.push(name);
      }
    },

    pushStackLiteral: function(item) {
      return this.push(new Literal(item));
    },

    pushSource: function(source) {
      if (this.pendingContent) {
        this.source.push(this.appendToBuffer(this.quotedString(this.pendingContent)));
        this.pendingContent = undefined;
      }

      if (source) {
        this.source.push(source);
      }
    },

    pushStack: function(item) {
      this.flushInline();

      var stack = this.incrStack();
      this.pushSource(stack + " = " + item + ";");
      this.compileStack.push(stack);
      return stack;
    },

    replaceStack: function(callback) {
      var prefix = '',
          inline = this.isInline(),
          stack,
          createdStack,
          usedLiteral;

      /* istanbul ignore next */
      if (!this.isInline()) {
        throw new Exception('replaceStack on non-inline');
      }

      // We want to merge the inline statement into the replacement statement via ','
      var top = this.popStack(true);

      if (top instanceof Literal) {
        // Literals do not need to be inlined
        prefix = stack = top.value;
        usedLiteral = true;
      } else {
        // Get or create the current stack name for use by the inline
        createdStack = !this.stackSlot;
        var name = !createdStack ? this.topStackName() : this.incrStack();

        prefix = '(' + this.push(name) + ' = ' + top + ')';
        stack = this.topStack();
      }

      var item = callback.call(this, stack);

      if (!usedLiteral) {
        this.popStack();
      }
      if (createdStack) {
        this.stackSlot--;
      }
      this.push('(' + prefix + item + ')');
    },

    incrStack: function() {
      this.stackSlot++;
      if(this.stackSlot > this.stackVars.length) { this.stackVars.push("stack" + this.stackSlot); }
      return this.topStackName();
    },
    topStackName: function() {
      return "stack" + this.stackSlot;
    },
    flushInline: function() {
      var inlineStack = this.inlineStack;
      if (inlineStack.length) {
        this.inlineStack = [];
        for (var i = 0, len = inlineStack.length; i < len; i++) {
          var entry = inlineStack[i];
          if (entry instanceof Literal) {
            this.compileStack.push(entry);
          } else {
            this.pushStack(entry);
          }
        }
      }
    },
    isInline: function() {
      return this.inlineStack.length;
    },

    popStack: function(wrapped) {
      var inline = this.isInline(),
          item = (inline ? this.inlineStack : this.compileStack).pop();

      if (!wrapped && (item instanceof Literal)) {
        return item.value;
      } else {
        if (!inline) {
          /* istanbul ignore next */
          if (!this.stackSlot) {
            throw new Exception('Invalid stack pop');
          }
          this.stackSlot--;
        }
        return item;
      }
    },

    topStack: function() {
      var stack = (this.isInline() ? this.inlineStack : this.compileStack),
          item = stack[stack.length - 1];

      if (item instanceof Literal) {
        return item.value;
      } else {
        return item;
      }
    },

    contextName: function(context) {
      if (this.useDepths && context) {
        return 'depths[' + context + ']';
      } else {
        return 'depth' + context;
      }
    },

    quotedString: function(str) {
      return '"' + str
        .replace(/\\/g, '\\\\')
        .replace(/"/g, '\\"')
        .replace(/\n/g, '\\n')
        .replace(/\r/g, '\\r')
        .replace(/\u2028/g, '\\u2028')   // Per Ecma-262 7.3 + 7.8.4
        .replace(/\u2029/g, '\\u2029') + '"';
    },

    objectLiteral: function(obj) {
      var pairs = [];

      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          pairs.push(this.quotedString(key) + ':' + obj[key]);
        }
      }

      return '{' + pairs.join(',') + '}';
    },

    setupHelper: function(paramSize, name, blockHelper) {
      var params = [],
          paramsInit = this.setupParams(name, paramSize, params, blockHelper);
      var foundHelper = this.nameLookup('helpers', name, 'helper');

      return {
        params: params,
        paramsInit: paramsInit,
        name: foundHelper,
        callParams: [this.contextName(0)].concat(params).join(", ")
      };
    },

    setupOptions: function(helper, paramSize, params) {
      var options = {}, contexts = [], types = [], ids = [], param, inverse, program;

      options.name = this.quotedString(helper);
      options.hash = this.popStack();

      if (this.trackIds) {
        options.hashIds = this.popStack();
      }
      if (this.stringParams) {
        options.hashTypes = this.popStack();
        options.hashContexts = this.popStack();
      }

      inverse = this.popStack();
      program = this.popStack();

      // Avoid setting fn and inverse if neither are set. This allows
      // helpers to do a check for `if (options.fn)`
      if (program || inverse) {
        if (!program) {
          program = 'this.noop';
        }

        if (!inverse) {
          inverse = 'this.noop';
        }

        options.fn = program;
        options.inverse = inverse;
      }

      // The parameters go on to the stack in order (making sure that they are evaluated in order)
      // so we need to pop them off the stack in reverse order
      var i = paramSize;
      while (i--) {
        param = this.popStack();
        params[i] = param;

        if (this.trackIds) {
          ids[i] = this.popStack();
        }
        if (this.stringParams) {
          types[i] = this.popStack();
          contexts[i] = this.popStack();
        }
      }

      if (this.trackIds) {
        options.ids = "[" + ids.join(",") + "]";
      }
      if (this.stringParams) {
        options.types = "[" + types.join(",") + "]";
        options.contexts = "[" + contexts.join(",") + "]";
      }

      if (this.options.data) {
        options.data = "data";
      }

      return options;
    },

    // the params and contexts arguments are passed in arrays
    // to fill in
    setupParams: function(helperName, paramSize, params, useRegister) {
      var options = this.objectLiteral(this.setupOptions(helperName, paramSize, params));

      if (useRegister) {
        this.useRegister('options');
        params.push('options');
        return 'options=' + options;
      } else {
        params.push(options);
        return '';
      }
    }
  };

  var reservedWords = (
    "break else new var" +
    " case finally return void" +
    " catch for switch while" +
    " continue function this with" +
    " default if throw" +
    " delete in try" +
    " do instanceof typeof" +
    " abstract enum int short" +
    " boolean export interface static" +
    " byte extends long super" +
    " char final native synchronized" +
    " class float package throws" +
    " const goto private transient" +
    " debugger implements protected volatile" +
    " double import public let yield"
  ).split(" ");

  var compilerWords = JavaScriptCompiler.RESERVED_WORDS = {};

  for(var i=0, l=reservedWords.length; i<l; i++) {
    compilerWords[reservedWords[i]] = true;
  }

  JavaScriptCompiler.isValidJavaScriptVariableName = function(name) {
    return !JavaScriptCompiler.RESERVED_WORDS[name] && /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(name);
  };

  __exports__ = JavaScriptCompiler;
  return __exports__;
})(__module2__, __module5__);

// handlebars.js
var __module0__ = (function(__dependency1__, __dependency2__, __dependency3__, __dependency4__, __dependency5__) {
  "use strict";
  var __exports__;
  /*globals Handlebars: true */
  var Handlebars = __dependency1__;

  // Compiler imports
  var AST = __dependency2__;
  var Parser = __dependency3__.parser;
  var parse = __dependency3__.parse;
  var Compiler = __dependency4__.Compiler;
  var compile = __dependency4__.compile;
  var precompile = __dependency4__.precompile;
  var JavaScriptCompiler = __dependency5__;

  var _create = Handlebars.create;
  var create = function() {
    var hb = _create();

    hb.compile = function(input, options) {
      return compile(input, options, hb);
    };
    hb.precompile = function (input, options) {
      return precompile(input, options, hb);
    };

    hb.AST = AST;
    hb.Compiler = Compiler;
    hb.JavaScriptCompiler = JavaScriptCompiler;
    hb.Parser = Parser;
    hb.parse = parse;

    return hb;
  };

  Handlebars = create();
  Handlebars.create = create;

  Handlebars['default'] = Handlebars;

  __exports__ = Handlebars;
  return __exports__;
})(__module1__, __module7__, __module8__, __module11__, __module12__);

  return __module0__;
}));

},
'handlebars4/handlebars':function(){
/**!

 @license
 handlebars v4.7.7

Copyright (C) 2011-2019 by Yehuda Katz

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Handlebars"] = factory();
	else
		root["Handlebars"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;

	var _handlebarsRuntime = __webpack_require__(2);

	var _handlebarsRuntime2 = _interopRequireDefault(_handlebarsRuntime);

	// Compiler imports

	var _handlebarsCompilerAst = __webpack_require__(45);

	var _handlebarsCompilerAst2 = _interopRequireDefault(_handlebarsCompilerAst);

	var _handlebarsCompilerBase = __webpack_require__(46);

	var _handlebarsCompilerCompiler = __webpack_require__(51);

	var _handlebarsCompilerJavascriptCompiler = __webpack_require__(52);

	var _handlebarsCompilerJavascriptCompiler2 = _interopRequireDefault(_handlebarsCompilerJavascriptCompiler);

	var _handlebarsCompilerVisitor = __webpack_require__(49);

	var _handlebarsCompilerVisitor2 = _interopRequireDefault(_handlebarsCompilerVisitor);

	var _handlebarsNoConflict = __webpack_require__(44);

	var _handlebarsNoConflict2 = _interopRequireDefault(_handlebarsNoConflict);

	var _create = _handlebarsRuntime2['default'].create;
	function create() {
	  var hb = _create();

	  hb.compile = function (input, options) {
	    return _handlebarsCompilerCompiler.compile(input, options, hb);
	  };
	  hb.precompile = function (input, options) {
	    return _handlebarsCompilerCompiler.precompile(input, options, hb);
	  };

	  hb.AST = _handlebarsCompilerAst2['default'];
	  hb.Compiler = _handlebarsCompilerCompiler.Compiler;
	  hb.JavaScriptCompiler = _handlebarsCompilerJavascriptCompiler2['default'];
	  hb.Parser = _handlebarsCompilerBase.parser;
	  hb.parse = _handlebarsCompilerBase.parse;
	  hb.parseWithoutProcessing = _handlebarsCompilerBase.parseWithoutProcessing;

	  return hb;
	}

	var inst = create();
	inst.create = create;

	_handlebarsNoConflict2['default'](inst);

	inst.Visitor = _handlebarsCompilerVisitor2['default'];

	inst['default'] = inst;

	exports['default'] = inst;
	module.exports = exports['default'];

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";

	exports["default"] = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	};

	exports.__esModule = true;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireWildcard = __webpack_require__(3)['default'];

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;

	var _handlebarsBase = __webpack_require__(4);

	var base = _interopRequireWildcard(_handlebarsBase);

	// Each of these augment the Handlebars object. No need to setup here.
	// (This is done to easily share code between commonjs and browse envs)

	var _handlebarsSafeString = __webpack_require__(37);

	var _handlebarsSafeString2 = _interopRequireDefault(_handlebarsSafeString);

	var _handlebarsException = __webpack_require__(6);

	var _handlebarsException2 = _interopRequireDefault(_handlebarsException);

	var _handlebarsUtils = __webpack_require__(5);

	var Utils = _interopRequireWildcard(_handlebarsUtils);

	var _handlebarsRuntime = __webpack_require__(38);

	var runtime = _interopRequireWildcard(_handlebarsRuntime);

	var _handlebarsNoConflict = __webpack_require__(44);

	var _handlebarsNoConflict2 = _interopRequireDefault(_handlebarsNoConflict);

	// For compatibility and usage outside of module systems, make the Handlebars object a namespace
	function create() {
	  var hb = new base.HandlebarsEnvironment();

	  Utils.extend(hb, base);
	  hb.SafeString = _handlebarsSafeString2['default'];
	  hb.Exception = _handlebarsException2['default'];
	  hb.Utils = Utils;
	  hb.escapeExpression = Utils.escapeExpression;

	  hb.VM = runtime;
	  hb.template = function (spec) {
	    return runtime.template(spec, hb);
	  };

	  return hb;
	}

	var inst = create();
	inst.create = create;

	_handlebarsNoConflict2['default'](inst);

	inst['default'] = inst;

	exports['default'] = inst;
	module.exports = exports['default'];

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	"use strict";

	exports["default"] = function (obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};

	    if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
	      }
	    }

	    newObj["default"] = obj;
	    return newObj;
	  }
	};

	exports.__esModule = true;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;
	exports.HandlebarsEnvironment = HandlebarsEnvironment;

	var _utils = __webpack_require__(5);

	var _exception = __webpack_require__(6);

	var _exception2 = _interopRequireDefault(_exception);

	var _helpers = __webpack_require__(10);

	var _decorators = __webpack_require__(30);

	var _logger = __webpack_require__(32);

	var _logger2 = _interopRequireDefault(_logger);

	var _internalProtoAccess = __webpack_require__(33);

	var VERSION = '4.7.7';
	exports.VERSION = VERSION;
	var COMPILER_REVISION = 8;
	exports.COMPILER_REVISION = COMPILER_REVISION;
	var LAST_COMPATIBLE_COMPILER_REVISION = 7;

	exports.LAST_COMPATIBLE_COMPILER_REVISION = LAST_COMPATIBLE_COMPILER_REVISION;
	var REVISION_CHANGES = {
	  1: '<= 1.0.rc.2', // 1.0.rc.2 is actually rev2 but doesn't report it
	  2: '== 1.0.0-rc.3',
	  3: '== 1.0.0-rc.4',
	  4: '== 1.x.x',
	  5: '== 2.0.0-alpha.x',
	  6: '>= 2.0.0-beta.1',
	  7: '>= 4.0.0 <4.3.0',
	  8: '>= 4.3.0'
	};

	exports.REVISION_CHANGES = REVISION_CHANGES;
	var objectType = '[object Object]';

	function HandlebarsEnvironment(helpers, partials, decorators) {
	  this.helpers = helpers || {};
	  this.partials = partials || {};
	  this.decorators = decorators || {};

	  _helpers.registerDefaultHelpers(this);
	  _decorators.registerDefaultDecorators(this);
	}

	HandlebarsEnvironment.prototype = {
	  constructor: HandlebarsEnvironment,

	  logger: _logger2['default'],
	  log: _logger2['default'].log,

	  registerHelper: function registerHelper(name, fn) {
	    if (_utils.toString.call(name) === objectType) {
	      if (fn) {
	        throw new _exception2['default']('Arg not supported with multiple helpers');
	      }
	      _utils.extend(this.helpers, name);
	    } else {
	      this.helpers[name] = fn;
	    }
	  },
	  unregisterHelper: function unregisterHelper(name) {
	    delete this.helpers[name];
	  },

	  registerPartial: function registerPartial(name, partial) {
	    if (_utils.toString.call(name) === objectType) {
	      _utils.extend(this.partials, name);
	    } else {
	      if (typeof partial === 'undefined') {
	        throw new _exception2['default']('Attempting to register a partial called "' + name + '" as undefined');
	      }
	      this.partials[name] = partial;
	    }
	  },
	  unregisterPartial: function unregisterPartial(name) {
	    delete this.partials[name];
	  },

	  registerDecorator: function registerDecorator(name, fn) {
	    if (_utils.toString.call(name) === objectType) {
	      if (fn) {
	        throw new _exception2['default']('Arg not supported with multiple decorators');
	      }
	      _utils.extend(this.decorators, name);
	    } else {
	      this.decorators[name] = fn;
	    }
	  },
	  unregisterDecorator: function unregisterDecorator(name) {
	    delete this.decorators[name];
	  },
	  /**
	   * Reset the memory of illegal property accesses that have already been logged.
	   * @deprecated should only be used in handlebars test-cases
	   */
	  resetLoggedPropertyAccesses: function resetLoggedPropertyAccesses() {
	    _internalProtoAccess.resetLoggedProperties();
	  }
	};

	var log = _logger2['default'].log;

	exports.log = log;
	exports.createFrame = _utils.createFrame;
	exports.logger = _logger2['default'];

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';

	exports.__esModule = true;
	exports.extend = extend;
	exports.indexOf = indexOf;
	exports.escapeExpression = escapeExpression;
	exports.isEmpty = isEmpty;
	exports.createFrame = createFrame;
	exports.blockParams = blockParams;
	exports.appendContextPath = appendContextPath;
	var escape = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;',
	  "'": '&#x27;',
	  '`': '&#x60;',
	  '=': '&#x3D;'
	};

	var badChars = /[&<>"'`=]/g,
	    possible = /[&<>"'`=]/;

	function escapeChar(chr) {
	  return escape[chr];
	}

	function extend(obj /* , ...source */) {
	  for (var i = 1; i < arguments.length; i++) {
	    for (var key in arguments[i]) {
	      if (Object.prototype.hasOwnProperty.call(arguments[i], key)) {
	        obj[key] = arguments[i][key];
	      }
	    }
	  }

	  return obj;
	}

	var toString = Object.prototype.toString;

	exports.toString = toString;
	// Sourced from lodash
	// https://github.com/bestiejs/lodash/blob/master/LICENSE.txt
	/* eslint-disable func-style */
	var isFunction = function isFunction(value) {
	  return typeof value === 'function';
	};
	// fallback for older versions of Chrome and Safari
	/* istanbul ignore next */
	if (isFunction(/x/)) {
	  exports.isFunction = isFunction = function (value) {
	    return typeof value === 'function' && toString.call(value) === '[object Function]';
	  };
	}
	exports.isFunction = isFunction;

	/* eslint-enable func-style */

	/* istanbul ignore next */
	var isArray = Array.isArray || function (value) {
	  return value && typeof value === 'object' ? toString.call(value) === '[object Array]' : false;
	};

	exports.isArray = isArray;
	// Older IE versions do not directly support indexOf so we must implement our own, sadly.

	function indexOf(array, value) {
	  for (var i = 0, len = array.length; i < len; i++) {
	    if (array[i] === value) {
	      return i;
	    }
	  }
	  return -1;
	}

	function escapeExpression(string) {
	  if (typeof string !== 'string') {
	    // don't escape SafeStrings, since they're already safe
	    if (string && string.toHTML) {
	      return string.toHTML();
	    } else if (string == null) {
	      return '';
	    } else if (!string) {
	      return string + '';
	    }

	    // Force a string conversion as this will be done by the append regardless and
	    // the regex test will do this transparently behind the scenes, causing issues if
	    // an object's to string has escaped characters in it.
	    string = '' + string;
	  }

	  if (!possible.test(string)) {
	    return string;
	  }
	  return string.replace(badChars, escapeChar);
	}

	function isEmpty(value) {
	  if (!value && value !== 0) {
	    return true;
	  } else if (isArray(value) && value.length === 0) {
	    return true;
	  } else {
	    return false;
	  }
	}

	function createFrame(object) {
	  var frame = extend({}, object);
	  frame._parent = object;
	  return frame;
	}

	function blockParams(params, ids) {
	  params.path = ids;
	  return params;
	}

	function appendContextPath(contextPath, id) {
	  return (contextPath ? contextPath + '.' : '') + id;
	}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(7)['default'];

	exports.__esModule = true;
	var errorProps = ['description', 'fileName', 'lineNumber', 'endLineNumber', 'message', 'name', 'number', 'stack'];

	function Exception(message, node) {
	  var loc = node && node.loc,
	      line = undefined,
	      endLineNumber = undefined,
	      column = undefined,
	      endColumn = undefined;

	  if (loc) {
	    line = loc.start.line;
	    endLineNumber = loc.end.line;
	    column = loc.start.column;
	    endColumn = loc.end.column;

	    message += ' - ' + line + ':' + column;
	  }

	  var tmp = Error.prototype.constructor.call(this, message);

	  // Unfortunately errors are not enumerable in Chrome (at least), so `for prop in tmp` doesn't work.
	  for (var idx = 0; idx < errorProps.length; idx++) {
	    this[errorProps[idx]] = tmp[errorProps[idx]];
	  }

	  /* istanbul ignore else */
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, Exception);
	  }

	  try {
	    if (loc) {
	      this.lineNumber = line;
	      this.endLineNumber = endLineNumber;

	      // Work around issue under safari where we can't directly set the column value
	      /* istanbul ignore next */
	      if (_Object$defineProperty) {
	        Object.defineProperty(this, 'column', {
	          value: column,
	          enumerable: true
	        });
	        Object.defineProperty(this, 'endColumn', {
	          value: endColumn,
	          enumerable: true
	        });
	      } else {
	        this.column = column;
	        this.endColumn = endColumn;
	      }
	    }
	  } catch (nop) {
	    /* Ignore if the browser is very particular */
	  }
	}

	Exception.prototype = new Error();

	exports['default'] = Exception;
	module.exports = exports['default'];

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(8), __esModule: true };

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(9);
	module.exports = function defineProperty(it, key, desc){
	  return $.setDesc(it, key, desc);
	};

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	var $Object = Object;
	module.exports = {
	  create:     $Object.create,
	  getProto:   $Object.getPrototypeOf,
	  isEnum:     {}.propertyIsEnumerable,
	  getDesc:    $Object.getOwnPropertyDescriptor,
	  setDesc:    $Object.defineProperty,
	  setDescs:   $Object.defineProperties,
	  getKeys:    $Object.keys,
	  getNames:   $Object.getOwnPropertyNames,
	  getSymbols: $Object.getOwnPropertySymbols,
	  each:       [].forEach
	};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;
	exports.registerDefaultHelpers = registerDefaultHelpers;
	exports.moveHelperToHooks = moveHelperToHooks;

	var _helpersBlockHelperMissing = __webpack_require__(11);

	var _helpersBlockHelperMissing2 = _interopRequireDefault(_helpersBlockHelperMissing);

	var _helpersEach = __webpack_require__(12);

	var _helpersEach2 = _interopRequireDefault(_helpersEach);

	var _helpersHelperMissing = __webpack_require__(25);

	var _helpersHelperMissing2 = _interopRequireDefault(_helpersHelperMissing);

	var _helpersIf = __webpack_require__(26);

	var _helpersIf2 = _interopRequireDefault(_helpersIf);

	var _helpersLog = __webpack_require__(27);

	var _helpersLog2 = _interopRequireDefault(_helpersLog);

	var _helpersLookup = __webpack_require__(28);

	var _helpersLookup2 = _interopRequireDefault(_helpersLookup);

	var _helpersWith = __webpack_require__(29);

	var _helpersWith2 = _interopRequireDefault(_helpersWith);

	function registerDefaultHelpers(instance) {
	  _helpersBlockHelperMissing2['default'](instance);
	  _helpersEach2['default'](instance);
	  _helpersHelperMissing2['default'](instance);
	  _helpersIf2['default'](instance);
	  _helpersLog2['default'](instance);
	  _helpersLookup2['default'](instance);
	  _helpersWith2['default'](instance);
	}

	function moveHelperToHooks(instance, helperName, keepHelper) {
	  if (instance.helpers[helperName]) {
	    instance.hooks[helperName] = instance.helpers[helperName];
	    if (!keepHelper) {
	      delete instance.helpers[helperName];
	    }
	  }
	}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _utils = __webpack_require__(5);

	exports['default'] = function (instance) {
	  instance.registerHelper('blockHelperMissing', function (context, options) {
	    var inverse = options.inverse,
	        fn = options.fn;

	    if (context === true) {
	      return fn(this);
	    } else if (context === false || context == null) {
	      return inverse(this);
	    } else if (_utils.isArray(context)) {
	      if (context.length > 0) {
	        if (options.ids) {
	          options.ids = [options.name];
	        }

	        return instance.helpers.each(context, options);
	      } else {
	        return inverse(this);
	      }
	    } else {
	      if (options.data && options.ids) {
	        var data = _utils.createFrame(options.data);
	        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.name);
	        options = { data: data };
	      }

	      return fn(context, options);
	    }
	  });
	};

	module.exports = exports['default'];

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';

	var _Object$keys = __webpack_require__(13)['default'];

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;

	var _utils = __webpack_require__(5);

	var _exception = __webpack_require__(6);

	var _exception2 = _interopRequireDefault(_exception);

	exports['default'] = function (instance) {
	  instance.registerHelper('each', function (context, options) {
	    if (!options) {
	      throw new _exception2['default']('Must pass iterator to #each');
	    }

	    var fn = options.fn,
	        inverse = options.inverse,
	        i = 0,
	        ret = '',
	        data = undefined,
	        contextPath = undefined;

	    if (options.data && options.ids) {
	      contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]) + '.';
	    }

	    if (_utils.isFunction(context)) {
	      context = context.call(this);
	    }

	    if (options.data) {
	      data = _utils.createFrame(options.data);
	    }

	    function execIteration(field, index, last) {
	      if (data) {
	        data.key = field;
	        data.index = index;
	        data.first = index === 0;
	        data.last = !!last;

	        if (contextPath) {
	          data.contextPath = contextPath + field;
	        }
	      }

	      ret = ret + fn(context[field], {
	        data: data,
	        blockParams: _utils.blockParams([context[field], field], [contextPath + field, null])
	      });
	    }

	    if (context && typeof context === 'object') {
	      if (_utils.isArray(context)) {
	        for (var j = context.length; i < j; i++) {
	          if (i in context) {
	            execIteration(i, i, i === context.length - 1);
	          }
	        }
	      } else if (global.Symbol && context[global.Symbol.iterator]) {
	        var newContext = [];
	        var iterator = context[global.Symbol.iterator]();
	        for (var it = iterator.next(); !it.done; it = iterator.next()) {
	          newContext.push(it.value);
	        }
	        context = newContext;
	        for (var j = context.length; i < j; i++) {
	          execIteration(i, i, i === context.length - 1);
	        }
	      } else {
	        (function () {
	          var priorKey = undefined;

	          _Object$keys(context).forEach(function (key) {
	            // We're running the iterations one step out of sync so we can detect
	            // the last iteration without have to scan the object twice and create
	            // an itermediate keys array.
	            if (priorKey !== undefined) {
	              execIteration(priorKey, i - 1);
	            }
	            priorKey = key;
	            i++;
	          });
	          if (priorKey !== undefined) {
	            execIteration(priorKey, i - 1, true);
	          }
	        })();
	      }
	    }

	    if (i === 0) {
	      ret = inverse(this);
	    }

	    return ret;
	  });
	};

	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(14), __esModule: true };

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(15);
	module.exports = __webpack_require__(21).Object.keys;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(16);

	__webpack_require__(18)('keys', function($keys){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(17);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(19)
	  , core    = __webpack_require__(21)
	  , fails   = __webpack_require__(24);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(20)
	  , core      = __webpack_require__(21)
	  , ctx       = __webpack_require__(22)
	  , PROTOTYPE = 'prototype';

	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && key in target;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(param){
	        return this instanceof C ? new C(param) : C(param);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    if(IS_PROTO)(exports[PROTOTYPE] || (exports[PROTOTYPE] = {}))[key] = out;
	  }
	};
	// type bitmap
	$export.F = 1;  // forced
	$export.G = 2;  // global
	$export.S = 4;  // static
	$export.P = 8;  // proto
	$export.B = 16; // bind
	$export.W = 32; // wrap
	module.exports = $export;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	var core = module.exports = {version: '1.2.6'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(23);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;

	var _exception = __webpack_require__(6);

	var _exception2 = _interopRequireDefault(_exception);

	exports['default'] = function (instance) {
	  instance.registerHelper('helperMissing', function () /* [args, ]options */{
	    if (arguments.length === 1) {
	      // A missing field in a {{foo}} construct.
	      return undefined;
	    } else {
	      // Someone is actually trying to call something, blow up.
	      throw new _exception2['default']('Missing helper: "' + arguments[arguments.length - 1].name + '"');
	    }
	  });
	};

	module.exports = exports['default'];

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;

	var _utils = __webpack_require__(5);

	var _exception = __webpack_require__(6);

	var _exception2 = _interopRequireDefault(_exception);

	exports['default'] = function (instance) {
	  instance.registerHelper('if', function (conditional, options) {
	    if (arguments.length != 2) {
	      throw new _exception2['default']('#if requires exactly one argument');
	    }
	    if (_utils.isFunction(conditional)) {
	      conditional = conditional.call(this);
	    }

	    // Default behavior is to render the positive path if the value is truthy and not empty.
	    // The `includeZero` option may be set to treat the condtional as purely not empty based on the
	    // behavior of isEmpty. Effectively this determines if 0 is handled by the positive path or negative.
	    if (!options.hash.includeZero && !conditional || _utils.isEmpty(conditional)) {
	      return options.inverse(this);
	    } else {
	      return options.fn(this);
	    }
	  });

	  instance.registerHelper('unless', function (conditional, options) {
	    if (arguments.length != 2) {
	      throw new _exception2['default']('#unless requires exactly one argument');
	    }
	    return instance.helpers['if'].call(this, conditional, {
	      fn: options.inverse,
	      inverse: options.fn,
	      hash: options.hash
	    });
	  });
	};

	module.exports = exports['default'];

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	'use strict';

	exports.__esModule = true;

	exports['default'] = function (instance) {
	  instance.registerHelper('log', function () /* message, options */{
	    var args = [undefined],
	        options = arguments[arguments.length - 1];
	    for (var i = 0; i < arguments.length - 1; i++) {
	      args.push(arguments[i]);
	    }

	    var level = 1;
	    if (options.hash.level != null) {
	      level = options.hash.level;
	    } else if (options.data && options.data.level != null) {
	      level = options.data.level;
	    }
	    args[0] = level;

	    instance.log.apply(instance, args);
	  });
	};

	module.exports = exports['default'];

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	'use strict';

	exports.__esModule = true;

	exports['default'] = function (instance) {
	  instance.registerHelper('lookup', function (obj, field, options) {
	    if (!obj) {
	      // Note for 5.0: Change to "obj == null" in 5.0
	      return obj;
	    }
	    return options.lookupProperty(obj, field);
	  });
	};

	module.exports = exports['default'];

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;

	var _utils = __webpack_require__(5);

	var _exception = __webpack_require__(6);

	var _exception2 = _interopRequireDefault(_exception);

	exports['default'] = function (instance) {
	  instance.registerHelper('with', function (context, options) {
	    if (arguments.length != 2) {
	      throw new _exception2['default']('#with requires exactly one argument');
	    }
	    if (_utils.isFunction(context)) {
	      context = context.call(this);
	    }

	    var fn = options.fn;

	    if (!_utils.isEmpty(context)) {
	      var data = options.data;
	      if (options.data && options.ids) {
	        data = _utils.createFrame(options.data);
	        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]);
	      }

	      return fn(context, {
	        data: data,
	        blockParams: _utils.blockParams([context], [data && data.contextPath])
	      });
	    } else {
	      return options.inverse(this);
	    }
	  });
	};

	module.exports = exports['default'];

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;
	exports.registerDefaultDecorators = registerDefaultDecorators;

	var _decoratorsInline = __webpack_require__(31);

	var _decoratorsInline2 = _interopRequireDefault(_decoratorsInline);

	function registerDefaultDecorators(instance) {
	  _decoratorsInline2['default'](instance);
	}

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _utils = __webpack_require__(5);

	exports['default'] = function (instance) {
	  instance.registerDecorator('inline', function (fn, props, container, options) {
	    var ret = fn;
	    if (!props.partials) {
	      props.partials = {};
	      ret = function (context, options) {
	        // Create a new partials stack frame prior to exec.
	        var original = container.partials;
	        container.partials = _utils.extend({}, original, props.partials);
	        var ret = fn(context, options);
	        container.partials = original;
	        return ret;
	      };
	    }

	    props.partials[options.args[0]] = options.fn;

	    return ret;
	  });
	};

	module.exports = exports['default'];

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _utils = __webpack_require__(5);

	var logger = {
	  methodMap: ['debug', 'info', 'warn', 'error'],
	  level: 'info',

	  // Maps a given level value to the `methodMap` indexes above.
	  lookupLevel: function lookupLevel(level) {
	    if (typeof level === 'string') {
	      var levelMap = _utils.indexOf(logger.methodMap, level.toLowerCase());
	      if (levelMap >= 0) {
	        level = levelMap;
	      } else {
	        level = parseInt(level, 10);
	      }
	    }

	    return level;
	  },

	  // Can be overridden in the host environment
	  log: function log(level) {
	    level = logger.lookupLevel(level);

	    if (typeof console !== 'undefined' && logger.lookupLevel(logger.level) <= level) {
	      var method = logger.methodMap[level];
	      // eslint-disable-next-line no-console
	      if (!console[method]) {
	        method = 'log';
	      }

	      for (var _len = arguments.length, message = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        message[_key - 1] = arguments[_key];
	      }

	      console[method].apply(console, message); // eslint-disable-line no-console
	    }
	  }
	};

	exports['default'] = logger;
	module.exports = exports['default'];

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$create = __webpack_require__(34)['default'];

	var _Object$keys = __webpack_require__(13)['default'];

	var _interopRequireWildcard = __webpack_require__(3)['default'];

	exports.__esModule = true;
	exports.createProtoAccessControl = createProtoAccessControl;
	exports.resultIsAllowed = resultIsAllowed;
	exports.resetLoggedProperties = resetLoggedProperties;

	var _createNewLookupObject = __webpack_require__(36);

	var _logger = __webpack_require__(32);

	var logger = _interopRequireWildcard(_logger);

	var loggedProperties = _Object$create(null);

	function createProtoAccessControl(runtimeOptions) {
	  var defaultMethodWhiteList = _Object$create(null);
	  defaultMethodWhiteList['constructor'] = false;
	  defaultMethodWhiteList['__defineGetter__'] = false;
	  defaultMethodWhiteList['__defineSetter__'] = false;
	  defaultMethodWhiteList['__lookupGetter__'] = false;

	  var defaultPropertyWhiteList = _Object$create(null);
	  // eslint-disable-next-line no-proto
	  defaultPropertyWhiteList['__proto__'] = false;

	  return {
	    properties: {
	      whitelist: _createNewLookupObject.createNewLookupObject(defaultPropertyWhiteList, runtimeOptions.allowedProtoProperties),
	      defaultValue: runtimeOptions.allowProtoPropertiesByDefault
	    },
	    methods: {
	      whitelist: _createNewLookupObject.createNewLookupObject(defaultMethodWhiteList, runtimeOptions.allowedProtoMethods),
	      defaultValue: runtimeOptions.allowProtoMethodsByDefault
	    }
	  };
	}

	function resultIsAllowed(result, protoAccessControl, propertyName) {
	  if (typeof result === 'function') {
	    return checkWhiteList(protoAccessControl.methods, propertyName);
	  } else {
	    return checkWhiteList(protoAccessControl.properties, propertyName);
	  }
	}

	function checkWhiteList(protoAccessControlForType, propertyName) {
	  if (protoAccessControlForType.whitelist[propertyName] !== undefined) {
	    return protoAccessControlForType.whitelist[propertyName] === true;
	  }
	  if (protoAccessControlForType.defaultValue !== undefined) {
	    return protoAccessControlForType.defaultValue;
	  }
	  logUnexpecedPropertyAccessOnce(propertyName);
	  return false;
	}

	function logUnexpecedPropertyAccessOnce(propertyName) {
	  if (loggedProperties[propertyName] !== true) {
	    loggedProperties[propertyName] = true;
	    logger.log('error', 'Handlebars: Access has been denied to resolve the property "' + propertyName + '" because it is not an "own property" of its parent.\n' + 'You can add a runtime option to disable the check or this warning:\n' + 'See https://handlebarsjs.com/api-reference/runtime-options.html#options-to-control-prototype-access for details');
	  }
	}

	function resetLoggedProperties() {
	  _Object$keys(loggedProperties).forEach(function (propertyName) {
	    delete loggedProperties[propertyName];
	  });
	}

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(35), __esModule: true };

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(9);
	module.exports = function create(P, D){
	  return $.create(P, D);
	};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$create = __webpack_require__(34)['default'];

	exports.__esModule = true;
	exports.createNewLookupObject = createNewLookupObject;

	var _utils = __webpack_require__(5);

	/**
	 * Create a new object with "null"-prototype to avoid truthy results on prototype properties.
	 * The resulting object can be used with "object[property]" to check if a property exists
	 * @param {...object} sources a varargs parameter of source objects that will be merged
	 * @returns {object}
	 */

	function createNewLookupObject() {
	  for (var _len = arguments.length, sources = Array(_len), _key = 0; _key < _len; _key++) {
	    sources[_key] = arguments[_key];
	  }

	  return _utils.extend.apply(undefined, [_Object$create(null)].concat(sources));
	}

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	// Build out our basic SafeString type
	'use strict';

	exports.__esModule = true;
	function SafeString(string) {
	  this.string = string;
	}

	SafeString.prototype.toString = SafeString.prototype.toHTML = function () {
	  return '' + this.string;
	};

	exports['default'] = SafeString;
	module.exports = exports['default'];

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$seal = __webpack_require__(39)['default'];

	var _Object$keys = __webpack_require__(13)['default'];

	var _interopRequireWildcard = __webpack_require__(3)['default'];

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;
	exports.checkRevision = checkRevision;
	exports.template = template;
	exports.wrapProgram = wrapProgram;
	exports.resolvePartial = resolvePartial;
	exports.invokePartial = invokePartial;
	exports.noop = noop;

	var _utils = __webpack_require__(5);

	var Utils = _interopRequireWildcard(_utils);

	var _exception = __webpack_require__(6);

	var _exception2 = _interopRequireDefault(_exception);

	var _base = __webpack_require__(4);

	var _helpers = __webpack_require__(10);

	var _internalWrapHelper = __webpack_require__(43);

	var _internalProtoAccess = __webpack_require__(33);

	function checkRevision(compilerInfo) {
	  var compilerRevision = compilerInfo && compilerInfo[0] || 1,
	      currentRevision = _base.COMPILER_REVISION;

	  if (compilerRevision >= _base.LAST_COMPATIBLE_COMPILER_REVISION && compilerRevision <= _base.COMPILER_REVISION) {
	    return;
	  }

	  if (compilerRevision < _base.LAST_COMPATIBLE_COMPILER_REVISION) {
	    var runtimeVersions = _base.REVISION_CHANGES[currentRevision],
	        compilerVersions = _base.REVISION_CHANGES[compilerRevision];
	    throw new _exception2['default']('Template was precompiled with an older version of Handlebars than the current runtime. ' + 'Please update your precompiler to a newer version (' + runtimeVersions + ') or downgrade your runtime to an older version (' + compilerVersions + ').');
	  } else {
	    // Use the embedded version info since the runtime doesn't know about this revision yet
	    throw new _exception2['default']('Template was precompiled with a newer version of Handlebars than the current runtime. ' + 'Please update your runtime to a newer version (' + compilerInfo[1] + ').');
	  }
	}

	function template(templateSpec, env) {
	  /* istanbul ignore next */
	  if (!env) {
	    throw new _exception2['default']('No environment passed to template');
	  }
	  if (!templateSpec || !templateSpec.main) {
	    throw new _exception2['default']('Unknown template object: ' + typeof templateSpec);
	  }

	  templateSpec.main.decorator = templateSpec.main_d;

	  // Note: Using env.VM references rather than local var references throughout this section to allow
	  // for external users to override these as pseudo-supported APIs.
	  env.VM.checkRevision(templateSpec.compiler);

	  // backwards compatibility for precompiled templates with compiler-version 7 (<4.3.0)
	  var templateWasPrecompiledWithCompilerV7 = templateSpec.compiler && templateSpec.compiler[0] === 7;

	  function invokePartialWrapper(partial, context, options) {
	    if (options.hash) {
	      context = Utils.extend({}, context, options.hash);
	      if (options.ids) {
	        options.ids[0] = true;
	      }
	    }
	    partial = env.VM.resolvePartial.call(this, partial, context, options);

	    var extendedOptions = Utils.extend({}, options, {
	      hooks: this.hooks,
	      protoAccessControl: this.protoAccessControl
	    });

	    var result = env.VM.invokePartial.call(this, partial, context, extendedOptions);

	    if (result == null && env.compile) {
	      options.partials[options.name] = env.compile(partial, templateSpec.compilerOptions, env);
	      result = options.partials[options.name](context, extendedOptions);
	    }
	    if (result != null) {
	      if (options.indent) {
	        var lines = result.split('\n');
	        for (var i = 0, l = lines.length; i < l; i++) {
	          if (!lines[i] && i + 1 === l) {
	            break;
	          }

	          lines[i] = options.indent + lines[i];
	        }
	        result = lines.join('\n');
	      }
	      return result;
	    } else {
	      throw new _exception2['default']('The partial ' + options.name + ' could not be compiled when running in runtime-only mode');
	    }
	  }

	  // Just add water
	  var container = {
	    strict: function strict(obj, name, loc) {
	      if (!obj || !(name in obj)) {
	        throw new _exception2['default']('"' + name + '" not defined in ' + obj, {
	          loc: loc
	        });
	      }
	      return container.lookupProperty(obj, name);
	    },
	    lookupProperty: function lookupProperty(parent, propertyName) {
	      var result = parent[propertyName];
	      if (result == null) {
	        return result;
	      }
	      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	        return result;
	      }

	      if (_internalProtoAccess.resultIsAllowed(result, container.protoAccessControl, propertyName)) {
	        return result;
	      }
	      return undefined;
	    },
	    lookup: function lookup(depths, name) {
	      var len = depths.length;
	      for (var i = 0; i < len; i++) {
	        var result = depths[i] && container.lookupProperty(depths[i], name);
	        if (result != null) {
	          return depths[i][name];
	        }
	      }
	    },
	    lambda: function lambda(current, context) {
	      return typeof current === 'function' ? current.call(context) : current;
	    },

	    escapeExpression: Utils.escapeExpression,
	    invokePartial: invokePartialWrapper,

	    fn: function fn(i) {
	      var ret = templateSpec[i];
	      ret.decorator = templateSpec[i + '_d'];
	      return ret;
	    },

	    programs: [],
	    program: function program(i, data, declaredBlockParams, blockParams, depths) {
	      var programWrapper = this.programs[i],
	          fn = this.fn(i);
	      if (data || depths || blockParams || declaredBlockParams) {
	        programWrapper = wrapProgram(this, i, fn, data, declaredBlockParams, blockParams, depths);
	      } else if (!programWrapper) {
	        programWrapper = this.programs[i] = wrapProgram(this, i, fn);
	      }
	      return programWrapper;
	    },

	    data: function data(value, depth) {
	      while (value && depth--) {
	        value = value._parent;
	      }
	      return value;
	    },
	    mergeIfNeeded: function mergeIfNeeded(param, common) {
	      var obj = param || common;

	      if (param && common && param !== common) {
	        obj = Utils.extend({}, common, param);
	      }

	      return obj;
	    },
	    // An empty object to use as replacement for null-contexts
	    nullContext: _Object$seal({}),

	    noop: env.VM.noop,
	    compilerInfo: templateSpec.compiler
	  };

	  function ret(context) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	    var data = options.data;

	    ret._setup(options);
	    if (!options.partial && templateSpec.useData) {
	      data = initData(context, data);
	    }
	    var depths = undefined,
	        blockParams = templateSpec.useBlockParams ? [] : undefined;
	    if (templateSpec.useDepths) {
	      if (options.depths) {
	        depths = context != options.depths[0] ? [context].concat(options.depths) : options.depths;
	      } else {
	        depths = [context];
	      }
	    }

	    function main(context /*, options*/) {
	      return '' + templateSpec.main(container, context, container.helpers, container.partials, data, blockParams, depths);
	    }

	    main = executeDecorators(templateSpec.main, main, container, options.depths || [], data, blockParams);
	    return main(context, options);
	  }

	  ret.isTop = true;

	  ret._setup = function (options) {
	    if (!options.partial) {
	      var mergedHelpers = Utils.extend({}, env.helpers, options.helpers);
	      wrapHelpersToPassLookupProperty(mergedHelpers, container);
	      container.helpers = mergedHelpers;

	      if (templateSpec.usePartial) {
	        // Use mergeIfNeeded here to prevent compiling global partials multiple times
	        container.partials = container.mergeIfNeeded(options.partials, env.partials);
	      }
	      if (templateSpec.usePartial || templateSpec.useDecorators) {
	        container.decorators = Utils.extend({}, env.decorators, options.decorators);
	      }

	      container.hooks = {};
	      container.protoAccessControl = _internalProtoAccess.createProtoAccessControl(options);

	      var keepHelperInHelpers = options.allowCallsToHelperMissing || templateWasPrecompiledWithCompilerV7;
	      _helpers.moveHelperToHooks(container, 'helperMissing', keepHelperInHelpers);
	      _helpers.moveHelperToHooks(container, 'blockHelperMissing', keepHelperInHelpers);
	    } else {
	      container.protoAccessControl = options.protoAccessControl; // internal option
	      container.helpers = options.helpers;
	      container.partials = options.partials;
	      container.decorators = options.decorators;
	      container.hooks = options.hooks;
	    }
	  };

	  ret._child = function (i, data, blockParams, depths) {
	    if (templateSpec.useBlockParams && !blockParams) {
	      throw new _exception2['default']('must pass block params');
	    }
	    if (templateSpec.useDepths && !depths) {
	      throw new _exception2['default']('must pass parent depths');
	    }

	    return wrapProgram(container, i, templateSpec[i], data, 0, blockParams, depths);
	  };
	  return ret;
	}

	function wrapProgram(container, i, fn, data, declaredBlockParams, blockParams, depths) {
	  function prog(context) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	    var currentDepths = depths;
	    if (depths && context != depths[0] && !(context === container.nullContext && depths[0] === null)) {
	      currentDepths = [context].concat(depths);
	    }

	    return fn(container, context, container.helpers, container.partials, options.data || data, blockParams && [options.blockParams].concat(blockParams), currentDepths);
	  }

	  prog = executeDecorators(fn, prog, container, depths, data, blockParams);

	  prog.program = i;
	  prog.depth = depths ? depths.length : 0;
	  prog.blockParams = declaredBlockParams || 0;
	  return prog;
	}

	/**
	 * This is currently part of the official API, therefore implementation details should not be changed.
	 */

	function resolvePartial(partial, context, options) {
	  if (!partial) {
	    if (options.name === '@partial-block') {
	      partial = options.data['partial-block'];
	    } else {
	      partial = options.partials[options.name];
	    }
	  } else if (!partial.call && !options.name) {
	    // This is a dynamic partial that returned a string
	    options.name = partial;
	    partial = options.partials[partial];
	  }
	  return partial;
	}

	function invokePartial(partial, context, options) {
	  // Use the current closure context to save the partial-block if this partial
	  var currentPartialBlock = options.data && options.data['partial-block'];
	  options.partial = true;
	  if (options.ids) {
	    options.data.contextPath = options.ids[0] || options.data.contextPath;
	  }

	  var partialBlock = undefined;
	  if (options.fn && options.fn !== noop) {
	    (function () {
	      options.data = _base.createFrame(options.data);
	      // Wrapper function to get access to currentPartialBlock from the closure
	      var fn = options.fn;
	      partialBlock = options.data['partial-block'] = function partialBlockWrapper(context) {
	        var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	        // Restore the partial-block from the closure for the execution of the block
	        // i.e. the part inside the block of the partial call.
	        options.data = _base.createFrame(options.data);
	        options.data['partial-block'] = currentPartialBlock;
	        return fn(context, options);
	      };
	      if (fn.partials) {
	        options.partials = Utils.extend({}, options.partials, fn.partials);
	      }
	    })();
	  }

	  if (partial === undefined && partialBlock) {
	    partial = partialBlock;
	  }

	  if (partial === undefined) {
	    throw new _exception2['default']('The partial ' + options.name + ' could not be found');
	  } else if (partial instanceof Function) {
	    return partial(context, options);
	  }
	}

	function noop() {
	  return '';
	}

	function initData(context, data) {
	  if (!data || !('root' in data)) {
	    data = data ? _base.createFrame(data) : {};
	    data.root = context;
	  }
	  return data;
	}

	function executeDecorators(fn, prog, container, depths, data, blockParams) {
	  if (fn.decorator) {
	    var props = {};
	    prog = fn.decorator(prog, props, container, depths && depths[0], data, blockParams, depths);
	    Utils.extend(prog, props);
	  }
	  return prog;
	}

	function wrapHelpersToPassLookupProperty(mergedHelpers, container) {
	  _Object$keys(mergedHelpers).forEach(function (helperName) {
	    var helper = mergedHelpers[helperName];
	    mergedHelpers[helperName] = passLookupPropertyOption(helper, container);
	  });
	}

	function passLookupPropertyOption(helper, container) {
	  var lookupProperty = container.lookupProperty;
	  return _internalWrapHelper.wrapHelper(helper, function (options) {
	    return Utils.extend({ lookupProperty: lookupProperty }, options);
	  });
	}

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(40), __esModule: true };

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(41);
	module.exports = __webpack_require__(21).Object.seal;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(42);

	__webpack_require__(18)('seal', function($seal){
	  return function seal(it){
	    return $seal && isObject(it) ? $seal(it) : it;
	  };
	});

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	'use strict';

	exports.__esModule = true;
	exports.wrapHelper = wrapHelper;

	function wrapHelper(helper, transformOptionsFn) {
	  if (typeof helper !== 'function') {
	    // This should not happen, but apparently it does in https://github.com/wycats/handlebars.js/issues/1639
	    // We try to make the wrapper least-invasive by not wrapping it, if the helper is not a function.
	    return helper;
	  }
	  var wrapper = function wrapper() /* dynamic arguments */{
	    var options = arguments[arguments.length - 1];
	    arguments[arguments.length - 1] = transformOptionsFn(options);
	    return helper.apply(this, arguments);
	  };
	  return wrapper;
	}

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';

	exports.__esModule = true;

	exports['default'] = function (Handlebars) {
	  /* istanbul ignore next */
	  var root = typeof global !== 'undefined' ? global : window,
	      $Handlebars = root.Handlebars;
	  /* istanbul ignore next */
	  Handlebars.noConflict = function () {
	    if (root.Handlebars === Handlebars) {
	      root.Handlebars = $Handlebars;
	    }
	    return Handlebars;
	  };
	};

	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	'use strict';

	exports.__esModule = true;
	var AST = {
	  // Public API used to evaluate derived attributes regarding AST nodes
	  helpers: {
	    // a mustache is definitely a helper if:
	    // * it is an eligible helper, and
	    // * it has at least one parameter or hash segment
	    helperExpression: function helperExpression(node) {
	      return node.type === 'SubExpression' || (node.type === 'MustacheStatement' || node.type === 'BlockStatement') && !!(node.params && node.params.length || node.hash);
	    },

	    scopedId: function scopedId(path) {
	      return (/^\.|this\b/.test(path.original)
	      );
	    },

	    // an ID is simple if it only has one part, and that part is not
	    // `..` or `this`.
	    simpleId: function simpleId(path) {
	      return path.parts.length === 1 && !AST.helpers.scopedId(path) && !path.depth;
	    }
	  }
	};

	// Must be exported as an object rather than the root of the module as the jison lexer
	// must modify the object to operate properly.
	exports['default'] = AST;
	module.exports = exports['default'];

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(1)['default'];

	var _interopRequireWildcard = __webpack_require__(3)['default'];

	exports.__esModule = true;
	exports.parseWithoutProcessing = parseWithoutProcessing;
	exports.parse = parse;

	var _parser = __webpack_require__(47);

	var _parser2 = _interopRequireDefault(_parser);

	var _whitespaceControl = __webpack_require__(48);

	var _whitespaceControl2 = _interopRequireDefault(_whitespaceControl);

	var _helpers = __webpack_require__(50);

	var Helpers = _interopRequireWildcard(_helpers);

	var _utils = __webpack_require__(5);

	exports.parser = _parser2['default'];

	var yy = {};
	_utils.extend(yy, Helpers);

	function parseWithoutProcessing(input, options) {
	  // Just return if an already-compiled AST was passed in.
	  if (input.type === 'Program') {
	    return input;
	  }

	  _parser2['default'].yy = yy;

	  // Altering the shared object here, but this is ok as parser is a sync operation
	  yy.locInfo = function (locInfo) {
	    return new yy.SourceLocation(options && options.srcName, locInfo);
	  };

	  var ast = _parser2['default'].parse(input);

	  return ast;
	}

	function parse(input, options) {
	  var ast = parseWithoutProcessing(input, options);
	  var strip = new _whitespaceControl2['default'](options);

	  return strip.accept(ast);
	}

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	// File ignored in coverage tests via setting in .istanbul.yml
	/* Jison generated parser */
	"use strict";

	exports.__esModule = true;
	var handlebars = (function () {
	    var parser = { trace: function trace() {},
	        yy: {},
	        symbols_: { "error": 2, "root": 3, "program": 4, "EOF": 5, "program_repetition0": 6, "statement": 7, "mustache": 8, "block": 9, "rawBlock": 10, "partial": 11, "partialBlock": 12, "content": 13, "COMMENT": 14, "CONTENT": 15, "openRawBlock": 16, "rawBlock_repetition0": 17, "END_RAW_BLOCK": 18, "OPEN_RAW_BLOCK": 19, "helperName": 20, "openRawBlock_repetition0": 21, "openRawBlock_option0": 22, "CLOSE_RAW_BLOCK": 23, "openBlock": 24, "block_option0": 25, "closeBlock": 26, "openInverse": 27, "block_option1": 28, "OPEN_BLOCK": 29, "openBlock_repetition0": 30, "openBlock_option0": 31, "openBlock_option1": 32, "CLOSE": 33, "OPEN_INVERSE": 34, "openInverse_repetition0": 35, "openInverse_option0": 36, "openInverse_option1": 37, "openInverseChain": 38, "OPEN_INVERSE_CHAIN": 39, "openInverseChain_repetition0": 40, "openInverseChain_option0": 41, "openInverseChain_option1": 42, "inverseAndProgram": 43, "INVERSE": 44, "inverseChain": 45, "inverseChain_option0": 46, "OPEN_ENDBLOCK": 47, "OPEN": 48, "mustache_repetition0": 49, "mustache_option0": 50, "OPEN_UNESCAPED": 51, "mustache_repetition1": 52, "mustache_option1": 53, "CLOSE_UNESCAPED": 54, "OPEN_PARTIAL": 55, "partialName": 56, "partial_repetition0": 57, "partial_option0": 58, "openPartialBlock": 59, "OPEN_PARTIAL_BLOCK": 60, "openPartialBlock_repetition0": 61, "openPartialBlock_option0": 62, "param": 63, "sexpr": 64, "OPEN_SEXPR": 65, "sexpr_repetition0": 66, "sexpr_option0": 67, "CLOSE_SEXPR": 68, "hash": 69, "hash_repetition_plus0": 70, "hashSegment": 71, "ID": 72, "EQUALS": 73, "blockParams": 74, "OPEN_BLOCK_PARAMS": 75, "blockParams_repetition_plus0": 76, "CLOSE_BLOCK_PARAMS": 77, "path": 78, "dataName": 79, "STRING": 80, "NUMBER": 81, "BOOLEAN": 82, "UNDEFINED": 83, "NULL": 84, "DATA": 85, "pathSegments": 86, "SEP": 87, "$accept": 0, "$end": 1 },
	        terminals_: { 2: "error", 5: "EOF", 14: "COMMENT", 15: "CONTENT", 18: "END_RAW_BLOCK", 19: "OPEN_RAW_BLOCK", 23: "CLOSE_RAW_BLOCK", 29: "OPEN_BLOCK", 33: "CLOSE", 34: "OPEN_INVERSE", 39: "OPEN_INVERSE_CHAIN", 44: "INVERSE", 47: "OPEN_ENDBLOCK", 48: "OPEN", 51: "OPEN_UNESCAPED", 54: "CLOSE_UNESCAPED", 55: "OPEN_PARTIAL", 60: "OPEN_PARTIAL_BLOCK", 65: "OPEN_SEXPR", 68: "CLOSE_SEXPR", 72: "ID", 73: "EQUALS", 75: "OPEN_BLOCK_PARAMS", 77: "CLOSE_BLOCK_PARAMS", 80: "STRING", 81: "NUMBER", 82: "BOOLEAN", 83: "UNDEFINED", 84: "NULL", 85: "DATA", 87: "SEP" },
	        productions_: [0, [3, 2], [4, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [13, 1], [10, 3], [16, 5], [9, 4], [9, 4], [24, 6], [27, 6], [38, 6], [43, 2], [45, 3], [45, 1], [26, 3], [8, 5], [8, 5], [11, 5], [12, 3], [59, 5], [63, 1], [63, 1], [64, 5], [69, 1], [71, 3], [74, 3], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [56, 1], [56, 1], [79, 2], [78, 1], [86, 3], [86, 1], [6, 0], [6, 2], [17, 0], [17, 2], [21, 0], [21, 2], [22, 0], [22, 1], [25, 0], [25, 1], [28, 0], [28, 1], [30, 0], [30, 2], [31, 0], [31, 1], [32, 0], [32, 1], [35, 0], [35, 2], [36, 0], [36, 1], [37, 0], [37, 1], [40, 0], [40, 2], [41, 0], [41, 1], [42, 0], [42, 1], [46, 0], [46, 1], [49, 0], [49, 2], [50, 0], [50, 1], [52, 0], [52, 2], [53, 0], [53, 1], [57, 0], [57, 2], [58, 0], [58, 1], [61, 0], [61, 2], [62, 0], [62, 1], [66, 0], [66, 2], [67, 0], [67, 1], [70, 1], [70, 2], [76, 1], [76, 2]],
	        performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$) {

	            var $0 = $$.length - 1;
	            switch (yystate) {
	                case 1:
	                    return $$[$0 - 1];
	                    break;
	                case 2:
	                    this.$ = yy.prepareProgram($$[$0]);
	                    break;
	                case 3:
	                    this.$ = $$[$0];
	                    break;
	                case 4:
	                    this.$ = $$[$0];
	                    break;
	                case 5:
	                    this.$ = $$[$0];
	                    break;
	                case 6:
	                    this.$ = $$[$0];
	                    break;
	                case 7:
	                    this.$ = $$[$0];
	                    break;
	                case 8:
	                    this.$ = $$[$0];
	                    break;
	                case 9:
	                    this.$ = {
	                        type: 'CommentStatement',
	                        value: yy.stripComment($$[$0]),
	                        strip: yy.stripFlags($$[$0], $$[$0]),
	                        loc: yy.locInfo(this._$)
	                    };

	                    break;
	                case 10:
	                    this.$ = {
	                        type: 'ContentStatement',
	                        original: $$[$0],
	                        value: $$[$0],
	                        loc: yy.locInfo(this._$)
	                    };

	                    break;
	                case 11:
	                    this.$ = yy.prepareRawBlock($$[$0 - 2], $$[$0 - 1], $$[$0], this._$);
	                    break;
	                case 12:
	                    this.$ = { path: $$[$0 - 3], params: $$[$0 - 2], hash: $$[$0 - 1] };
	                    break;
	                case 13:
	                    this.$ = yy.prepareBlock($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0], false, this._$);
	                    break;
	                case 14:
	                    this.$ = yy.prepareBlock($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0], true, this._$);
	                    break;
	                case 15:
	                    this.$ = { open: $$[$0 - 5], path: $$[$0 - 4], params: $$[$0 - 3], hash: $$[$0 - 2], blockParams: $$[$0 - 1], strip: yy.stripFlags($$[$0 - 5], $$[$0]) };
	                    break;
	                case 16:
	                    this.$ = { path: $$[$0 - 4], params: $$[$0 - 3], hash: $$[$0 - 2], blockParams: $$[$0 - 1], strip: yy.stripFlags($$[$0 - 5], $$[$0]) };
	                    break;
	                case 17:
	                    this.$ = { path: $$[$0 - 4], params: $$[$0 - 3], hash: $$[$0 - 2], blockParams: $$[$0 - 1], strip: yy.stripFlags($$[$0 - 5], $$[$0]) };
	                    break;
	                case 18:
	                    this.$ = { strip: yy.stripFlags($$[$0 - 1], $$[$0 - 1]), program: $$[$0] };
	                    break;
	                case 19:
	                    var inverse = yy.prepareBlock($$[$0 - 2], $$[$0 - 1], $$[$0], $$[$0], false, this._$),
	                        program = yy.prepareProgram([inverse], $$[$0 - 1].loc);
	                    program.chained = true;

	                    this.$ = { strip: $$[$0 - 2].strip, program: program, chain: true };

	                    break;
	                case 20:
	                    this.$ = $$[$0];
	                    break;
	                case 21:
	                    this.$ = { path: $$[$0 - 1], strip: yy.stripFlags($$[$0 - 2], $$[$0]) };
	                    break;
	                case 22:
	                    this.$ = yy.prepareMustache($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0 - 4], yy.stripFlags($$[$0 - 4], $$[$0]), this._$);
	                    break;
	                case 23:
	                    this.$ = yy.prepareMustache($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0 - 4], yy.stripFlags($$[$0 - 4], $$[$0]), this._$);
	                    break;
	                case 24:
	                    this.$ = {
	                        type: 'PartialStatement',
	                        name: $$[$0 - 3],
	                        params: $$[$0 - 2],
	                        hash: $$[$0 - 1],
	                        indent: '',
	                        strip: yy.stripFlags($$[$0 - 4], $$[$0]),
	                        loc: yy.locInfo(this._$)
	                    };

	                    break;
	                case 25:
	                    this.$ = yy.preparePartialBlock($$[$0 - 2], $$[$0 - 1], $$[$0], this._$);
	                    break;
	                case 26:
	                    this.$ = { path: $$[$0 - 3], params: $$[$0 - 2], hash: $$[$0 - 1], strip: yy.stripFlags($$[$0 - 4], $$[$0]) };
	                    break;
	                case 27:
	                    this.$ = $$[$0];
	                    break;
	                case 28:
	                    this.$ = $$[$0];
	                    break;
	                case 29:
	                    this.$ = {
	                        type: 'SubExpression',
	                        path: $$[$0 - 3],
	                        params: $$[$0 - 2],
	                        hash: $$[$0 - 1],
	                        loc: yy.locInfo(this._$)
	                    };

	                    break;
	                case 30:
	                    this.$ = { type: 'Hash', pairs: $$[$0], loc: yy.locInfo(this._$) };
	                    break;
	                case 31:
	                    this.$ = { type: 'HashPair', key: yy.id($$[$0 - 2]), value: $$[$0], loc: yy.locInfo(this._$) };
	                    break;
	                case 32:
	                    this.$ = yy.id($$[$0 - 1]);
	                    break;
	                case 33:
	                    this.$ = $$[$0];
	                    break;
	                case 34:
	                    this.$ = $$[$0];
	                    break;
	                case 35:
	                    this.$ = { type: 'StringLiteral', value: $$[$0], original: $$[$0], loc: yy.locInfo(this._$) };
	                    break;
	                case 36:
	                    this.$ = { type: 'NumberLiteral', value: Number($$[$0]), original: Number($$[$0]), loc: yy.locInfo(this._$) };
	                    break;
	                case 37:
	                    this.$ = { type: 'BooleanLiteral', value: $$[$0] === 'true', original: $$[$0] === 'true', loc: yy.locInfo(this._$) };
	                    break;
	                case 38:
	                    this.$ = { type: 'UndefinedLiteral', original: undefined, value: undefined, loc: yy.locInfo(this._$) };
	                    break;
	                case 39:
	                    this.$ = { type: 'NullLiteral', original: null, value: null, loc: yy.locInfo(this._$) };
	                    break;
	                case 40:
	                    this.$ = $$[$0];
	                    break;
	                case 41:
	                    this.$ = $$[$0];
	                    break;
	                case 42:
	                    this.$ = yy.preparePath(true, $$[$0], this._$);
	                    break;
	                case 43:
	                    this.$ = yy.preparePath(false, $$[$0], this._$);
	                    break;
	                case 44:
	                    $$[$0 - 2].push({ part: yy.id($$[$0]), original: $$[$0], separator: $$[$0 - 1] });this.$ = $$[$0 - 2];
	                    break;
	                case 45:
	                    this.$ = [{ part: yy.id($$[$0]), original: $$[$0] }];
	                    break;
	                case 46:
	                    this.$ = [];
	                    break;
	                case 47:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 48:
	                    this.$ = [];
	                    break;
	                case 49:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 50:
	                    this.$ = [];
	                    break;
	                case 51:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 58:
	                    this.$ = [];
	                    break;
	                case 59:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 64:
	                    this.$ = [];
	                    break;
	                case 65:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 70:
	                    this.$ = [];
	                    break;
	                case 71:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 78:
	                    this.$ = [];
	                    break;
	                case 79:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 82:
	                    this.$ = [];
	                    break;
	                case 83:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 86:
	                    this.$ = [];
	                    break;
	                case 87:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 90:
	                    this.$ = [];
	                    break;
	                case 91:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 94:
	                    this.$ = [];
	                    break;
	                case 95:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 98:
	                    this.$ = [$$[$0]];
	                    break;
	                case 99:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 100:
	                    this.$ = [$$[$0]];
	                    break;
	                case 101:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	            }
	        },
	        table: [{ 3: 1, 4: 2, 5: [2, 46], 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 1: [3] }, { 5: [1, 4] }, { 5: [2, 2], 7: 5, 8: 6, 9: 7, 10: 8, 11: 9, 12: 10, 13: 11, 14: [1, 12], 15: [1, 20], 16: 17, 19: [1, 23], 24: 15, 27: 16, 29: [1, 21], 34: [1, 22], 39: [2, 2], 44: [2, 2], 47: [2, 2], 48: [1, 13], 51: [1, 14], 55: [1, 18], 59: 19, 60: [1, 24] }, { 1: [2, 1] }, { 5: [2, 47], 14: [2, 47], 15: [2, 47], 19: [2, 47], 29: [2, 47], 34: [2, 47], 39: [2, 47], 44: [2, 47], 47: [2, 47], 48: [2, 47], 51: [2, 47], 55: [2, 47], 60: [2, 47] }, { 5: [2, 3], 14: [2, 3], 15: [2, 3], 19: [2, 3], 29: [2, 3], 34: [2, 3], 39: [2, 3], 44: [2, 3], 47: [2, 3], 48: [2, 3], 51: [2, 3], 55: [2, 3], 60: [2, 3] }, { 5: [2, 4], 14: [2, 4], 15: [2, 4], 19: [2, 4], 29: [2, 4], 34: [2, 4], 39: [2, 4], 44: [2, 4], 47: [2, 4], 48: [2, 4], 51: [2, 4], 55: [2, 4], 60: [2, 4] }, { 5: [2, 5], 14: [2, 5], 15: [2, 5], 19: [2, 5], 29: [2, 5], 34: [2, 5], 39: [2, 5], 44: [2, 5], 47: [2, 5], 48: [2, 5], 51: [2, 5], 55: [2, 5], 60: [2, 5] }, { 5: [2, 6], 14: [2, 6], 15: [2, 6], 19: [2, 6], 29: [2, 6], 34: [2, 6], 39: [2, 6], 44: [2, 6], 47: [2, 6], 48: [2, 6], 51: [2, 6], 55: [2, 6], 60: [2, 6] }, { 5: [2, 7], 14: [2, 7], 15: [2, 7], 19: [2, 7], 29: [2, 7], 34: [2, 7], 39: [2, 7], 44: [2, 7], 47: [2, 7], 48: [2, 7], 51: [2, 7], 55: [2, 7], 60: [2, 7] }, { 5: [2, 8], 14: [2, 8], 15: [2, 8], 19: [2, 8], 29: [2, 8], 34: [2, 8], 39: [2, 8], 44: [2, 8], 47: [2, 8], 48: [2, 8], 51: [2, 8], 55: [2, 8], 60: [2, 8] }, { 5: [2, 9], 14: [2, 9], 15: [2, 9], 19: [2, 9], 29: [2, 9], 34: [2, 9], 39: [2, 9], 44: [2, 9], 47: [2, 9], 48: [2, 9], 51: [2, 9], 55: [2, 9], 60: [2, 9] }, { 20: 25, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 36, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 4: 37, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 39: [2, 46], 44: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 4: 38, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 44: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 15: [2, 48], 17: 39, 18: [2, 48] }, { 20: 41, 56: 40, 64: 42, 65: [1, 43], 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 4: 44, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 5: [2, 10], 14: [2, 10], 15: [2, 10], 18: [2, 10], 19: [2, 10], 29: [2, 10], 34: [2, 10], 39: [2, 10], 44: [2, 10], 47: [2, 10], 48: [2, 10], 51: [2, 10], 55: [2, 10], 60: [2, 10] }, { 20: 45, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 46, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 47, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 41, 56: 48, 64: 42, 65: [1, 43], 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 33: [2, 78], 49: 49, 65: [2, 78], 72: [2, 78], 80: [2, 78], 81: [2, 78], 82: [2, 78], 83: [2, 78], 84: [2, 78], 85: [2, 78] }, { 23: [2, 33], 33: [2, 33], 54: [2, 33], 65: [2, 33], 68: [2, 33], 72: [2, 33], 75: [2, 33], 80: [2, 33], 81: [2, 33], 82: [2, 33], 83: [2, 33], 84: [2, 33], 85: [2, 33] }, { 23: [2, 34], 33: [2, 34], 54: [2, 34], 65: [2, 34], 68: [2, 34], 72: [2, 34], 75: [2, 34], 80: [2, 34], 81: [2, 34], 82: [2, 34], 83: [2, 34], 84: [2, 34], 85: [2, 34] }, { 23: [2, 35], 33: [2, 35], 54: [2, 35], 65: [2, 35], 68: [2, 35], 72: [2, 35], 75: [2, 35], 80: [2, 35], 81: [2, 35], 82: [2, 35], 83: [2, 35], 84: [2, 35], 85: [2, 35] }, { 23: [2, 36], 33: [2, 36], 54: [2, 36], 65: [2, 36], 68: [2, 36], 72: [2, 36], 75: [2, 36], 80: [2, 36], 81: [2, 36], 82: [2, 36], 83: [2, 36], 84: [2, 36], 85: [2, 36] }, { 23: [2, 37], 33: [2, 37], 54: [2, 37], 65: [2, 37], 68: [2, 37], 72: [2, 37], 75: [2, 37], 80: [2, 37], 81: [2, 37], 82: [2, 37], 83: [2, 37], 84: [2, 37], 85: [2, 37] }, { 23: [2, 38], 33: [2, 38], 54: [2, 38], 65: [2, 38], 68: [2, 38], 72: [2, 38], 75: [2, 38], 80: [2, 38], 81: [2, 38], 82: [2, 38], 83: [2, 38], 84: [2, 38], 85: [2, 38] }, { 23: [2, 39], 33: [2, 39], 54: [2, 39], 65: [2, 39], 68: [2, 39], 72: [2, 39], 75: [2, 39], 80: [2, 39], 81: [2, 39], 82: [2, 39], 83: [2, 39], 84: [2, 39], 85: [2, 39] }, { 23: [2, 43], 33: [2, 43], 54: [2, 43], 65: [2, 43], 68: [2, 43], 72: [2, 43], 75: [2, 43], 80: [2, 43], 81: [2, 43], 82: [2, 43], 83: [2, 43], 84: [2, 43], 85: [2, 43], 87: [1, 50] }, { 72: [1, 35], 86: 51 }, { 23: [2, 45], 33: [2, 45], 54: [2, 45], 65: [2, 45], 68: [2, 45], 72: [2, 45], 75: [2, 45], 80: [2, 45], 81: [2, 45], 82: [2, 45], 83: [2, 45], 84: [2, 45], 85: [2, 45], 87: [2, 45] }, { 52: 52, 54: [2, 82], 65: [2, 82], 72: [2, 82], 80: [2, 82], 81: [2, 82], 82: [2, 82], 83: [2, 82], 84: [2, 82], 85: [2, 82] }, { 25: 53, 38: 55, 39: [1, 57], 43: 56, 44: [1, 58], 45: 54, 47: [2, 54] }, { 28: 59, 43: 60, 44: [1, 58], 47: [2, 56] }, { 13: 62, 15: [1, 20], 18: [1, 61] }, { 33: [2, 86], 57: 63, 65: [2, 86], 72: [2, 86], 80: [2, 86], 81: [2, 86], 82: [2, 86], 83: [2, 86], 84: [2, 86], 85: [2, 86] }, { 33: [2, 40], 65: [2, 40], 72: [2, 40], 80: [2, 40], 81: [2, 40], 82: [2, 40], 83: [2, 40], 84: [2, 40], 85: [2, 40] }, { 33: [2, 41], 65: [2, 41], 72: [2, 41], 80: [2, 41], 81: [2, 41], 82: [2, 41], 83: [2, 41], 84: [2, 41], 85: [2, 41] }, { 20: 64, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 26: 65, 47: [1, 66] }, { 30: 67, 33: [2, 58], 65: [2, 58], 72: [2, 58], 75: [2, 58], 80: [2, 58], 81: [2, 58], 82: [2, 58], 83: [2, 58], 84: [2, 58], 85: [2, 58] }, { 33: [2, 64], 35: 68, 65: [2, 64], 72: [2, 64], 75: [2, 64], 80: [2, 64], 81: [2, 64], 82: [2, 64], 83: [2, 64], 84: [2, 64], 85: [2, 64] }, { 21: 69, 23: [2, 50], 65: [2, 50], 72: [2, 50], 80: [2, 50], 81: [2, 50], 82: [2, 50], 83: [2, 50], 84: [2, 50], 85: [2, 50] }, { 33: [2, 90], 61: 70, 65: [2, 90], 72: [2, 90], 80: [2, 90], 81: [2, 90], 82: [2, 90], 83: [2, 90], 84: [2, 90], 85: [2, 90] }, { 20: 74, 33: [2, 80], 50: 71, 63: 72, 64: 75, 65: [1, 43], 69: 73, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 72: [1, 79] }, { 23: [2, 42], 33: [2, 42], 54: [2, 42], 65: [2, 42], 68: [2, 42], 72: [2, 42], 75: [2, 42], 80: [2, 42], 81: [2, 42], 82: [2, 42], 83: [2, 42], 84: [2, 42], 85: [2, 42], 87: [1, 50] }, { 20: 74, 53: 80, 54: [2, 84], 63: 81, 64: 75, 65: [1, 43], 69: 82, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 26: 83, 47: [1, 66] }, { 47: [2, 55] }, { 4: 84, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 39: [2, 46], 44: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 47: [2, 20] }, { 20: 85, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 4: 86, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 26: 87, 47: [1, 66] }, { 47: [2, 57] }, { 5: [2, 11], 14: [2, 11], 15: [2, 11], 19: [2, 11], 29: [2, 11], 34: [2, 11], 39: [2, 11], 44: [2, 11], 47: [2, 11], 48: [2, 11], 51: [2, 11], 55: [2, 11], 60: [2, 11] }, { 15: [2, 49], 18: [2, 49] }, { 20: 74, 33: [2, 88], 58: 88, 63: 89, 64: 75, 65: [1, 43], 69: 90, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 65: [2, 94], 66: 91, 68: [2, 94], 72: [2, 94], 80: [2, 94], 81: [2, 94], 82: [2, 94], 83: [2, 94], 84: [2, 94], 85: [2, 94] }, { 5: [2, 25], 14: [2, 25], 15: [2, 25], 19: [2, 25], 29: [2, 25], 34: [2, 25], 39: [2, 25], 44: [2, 25], 47: [2, 25], 48: [2, 25], 51: [2, 25], 55: [2, 25], 60: [2, 25] }, { 20: 92, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 74, 31: 93, 33: [2, 60], 63: 94, 64: 75, 65: [1, 43], 69: 95, 70: 76, 71: 77, 72: [1, 78], 75: [2, 60], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 74, 33: [2, 66], 36: 96, 63: 97, 64: 75, 65: [1, 43], 69: 98, 70: 76, 71: 77, 72: [1, 78], 75: [2, 66], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 74, 22: 99, 23: [2, 52], 63: 100, 64: 75, 65: [1, 43], 69: 101, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 74, 33: [2, 92], 62: 102, 63: 103, 64: 75, 65: [1, 43], 69: 104, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 33: [1, 105] }, { 33: [2, 79], 65: [2, 79], 72: [2, 79], 80: [2, 79], 81: [2, 79], 82: [2, 79], 83: [2, 79], 84: [2, 79], 85: [2, 79] }, { 33: [2, 81] }, { 23: [2, 27], 33: [2, 27], 54: [2, 27], 65: [2, 27], 68: [2, 27], 72: [2, 27], 75: [2, 27], 80: [2, 27], 81: [2, 27], 82: [2, 27], 83: [2, 27], 84: [2, 27], 85: [2, 27] }, { 23: [2, 28], 33: [2, 28], 54: [2, 28], 65: [2, 28], 68: [2, 28], 72: [2, 28], 75: [2, 28], 80: [2, 28], 81: [2, 28], 82: [2, 28], 83: [2, 28], 84: [2, 28], 85: [2, 28] }, { 23: [2, 30], 33: [2, 30], 54: [2, 30], 68: [2, 30], 71: 106, 72: [1, 107], 75: [2, 30] }, { 23: [2, 98], 33: [2, 98], 54: [2, 98], 68: [2, 98], 72: [2, 98], 75: [2, 98] }, { 23: [2, 45], 33: [2, 45], 54: [2, 45], 65: [2, 45], 68: [2, 45], 72: [2, 45], 73: [1, 108], 75: [2, 45], 80: [2, 45], 81: [2, 45], 82: [2, 45], 83: [2, 45], 84: [2, 45], 85: [2, 45], 87: [2, 45] }, { 23: [2, 44], 33: [2, 44], 54: [2, 44], 65: [2, 44], 68: [2, 44], 72: [2, 44], 75: [2, 44], 80: [2, 44], 81: [2, 44], 82: [2, 44], 83: [2, 44], 84: [2, 44], 85: [2, 44], 87: [2, 44] }, { 54: [1, 109] }, { 54: [2, 83], 65: [2, 83], 72: [2, 83], 80: [2, 83], 81: [2, 83], 82: [2, 83], 83: [2, 83], 84: [2, 83], 85: [2, 83] }, { 54: [2, 85] }, { 5: [2, 13], 14: [2, 13], 15: [2, 13], 19: [2, 13], 29: [2, 13], 34: [2, 13], 39: [2, 13], 44: [2, 13], 47: [2, 13], 48: [2, 13], 51: [2, 13], 55: [2, 13], 60: [2, 13] }, { 38: 55, 39: [1, 57], 43: 56, 44: [1, 58], 45: 111, 46: 110, 47: [2, 76] }, { 33: [2, 70], 40: 112, 65: [2, 70], 72: [2, 70], 75: [2, 70], 80: [2, 70], 81: [2, 70], 82: [2, 70], 83: [2, 70], 84: [2, 70], 85: [2, 70] }, { 47: [2, 18] }, { 5: [2, 14], 14: [2, 14], 15: [2, 14], 19: [2, 14], 29: [2, 14], 34: [2, 14], 39: [2, 14], 44: [2, 14], 47: [2, 14], 48: [2, 14], 51: [2, 14], 55: [2, 14], 60: [2, 14] }, { 33: [1, 113] }, { 33: [2, 87], 65: [2, 87], 72: [2, 87], 80: [2, 87], 81: [2, 87], 82: [2, 87], 83: [2, 87], 84: [2, 87], 85: [2, 87] }, { 33: [2, 89] }, { 20: 74, 63: 115, 64: 75, 65: [1, 43], 67: 114, 68: [2, 96], 69: 116, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 33: [1, 117] }, { 32: 118, 33: [2, 62], 74: 119, 75: [1, 120] }, { 33: [2, 59], 65: [2, 59], 72: [2, 59], 75: [2, 59], 80: [2, 59], 81: [2, 59], 82: [2, 59], 83: [2, 59], 84: [2, 59], 85: [2, 59] }, { 33: [2, 61], 75: [2, 61] }, { 33: [2, 68], 37: 121, 74: 122, 75: [1, 120] }, { 33: [2, 65], 65: [2, 65], 72: [2, 65], 75: [2, 65], 80: [2, 65], 81: [2, 65], 82: [2, 65], 83: [2, 65], 84: [2, 65], 85: [2, 65] }, { 33: [2, 67], 75: [2, 67] }, { 23: [1, 123] }, { 23: [2, 51], 65: [2, 51], 72: [2, 51], 80: [2, 51], 81: [2, 51], 82: [2, 51], 83: [2, 51], 84: [2, 51], 85: [2, 51] }, { 23: [2, 53] }, { 33: [1, 124] }, { 33: [2, 91], 65: [2, 91], 72: [2, 91], 80: [2, 91], 81: [2, 91], 82: [2, 91], 83: [2, 91], 84: [2, 91], 85: [2, 91] }, { 33: [2, 93] }, { 5: [2, 22], 14: [2, 22], 15: [2, 22], 19: [2, 22], 29: [2, 22], 34: [2, 22], 39: [2, 22], 44: [2, 22], 47: [2, 22], 48: [2, 22], 51: [2, 22], 55: [2, 22], 60: [2, 22] }, { 23: [2, 99], 33: [2, 99], 54: [2, 99], 68: [2, 99], 72: [2, 99], 75: [2, 99] }, { 73: [1, 108] }, { 20: 74, 63: 125, 64: 75, 65: [1, 43], 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 5: [2, 23], 14: [2, 23], 15: [2, 23], 19: [2, 23], 29: [2, 23], 34: [2, 23], 39: [2, 23], 44: [2, 23], 47: [2, 23], 48: [2, 23], 51: [2, 23], 55: [2, 23], 60: [2, 23] }, { 47: [2, 19] }, { 47: [2, 77] }, { 20: 74, 33: [2, 72], 41: 126, 63: 127, 64: 75, 65: [1, 43], 69: 128, 70: 76, 71: 77, 72: [1, 78], 75: [2, 72], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 5: [2, 24], 14: [2, 24], 15: [2, 24], 19: [2, 24], 29: [2, 24], 34: [2, 24], 39: [2, 24], 44: [2, 24], 47: [2, 24], 48: [2, 24], 51: [2, 24], 55: [2, 24], 60: [2, 24] }, { 68: [1, 129] }, { 65: [2, 95], 68: [2, 95], 72: [2, 95], 80: [2, 95], 81: [2, 95], 82: [2, 95], 83: [2, 95], 84: [2, 95], 85: [2, 95] }, { 68: [2, 97] }, { 5: [2, 21], 14: [2, 21], 15: [2, 21], 19: [2, 21], 29: [2, 21], 34: [2, 21], 39: [2, 21], 44: [2, 21], 47: [2, 21], 48: [2, 21], 51: [2, 21], 55: [2, 21], 60: [2, 21] }, { 33: [1, 130] }, { 33: [2, 63] }, { 72: [1, 132], 76: 131 }, { 33: [1, 133] }, { 33: [2, 69] }, { 15: [2, 12], 18: [2, 12] }, { 14: [2, 26], 15: [2, 26], 19: [2, 26], 29: [2, 26], 34: [2, 26], 47: [2, 26], 48: [2, 26], 51: [2, 26], 55: [2, 26], 60: [2, 26] }, { 23: [2, 31], 33: [2, 31], 54: [2, 31], 68: [2, 31], 72: [2, 31], 75: [2, 31] }, { 33: [2, 74], 42: 134, 74: 135, 75: [1, 120] }, { 33: [2, 71], 65: [2, 71], 72: [2, 71], 75: [2, 71], 80: [2, 71], 81: [2, 71], 82: [2, 71], 83: [2, 71], 84: [2, 71], 85: [2, 71] }, { 33: [2, 73], 75: [2, 73] }, { 23: [2, 29], 33: [2, 29], 54: [2, 29], 65: [2, 29], 68: [2, 29], 72: [2, 29], 75: [2, 29], 80: [2, 29], 81: [2, 29], 82: [2, 29], 83: [2, 29], 84: [2, 29], 85: [2, 29] }, { 14: [2, 15], 15: [2, 15], 19: [2, 15], 29: [2, 15], 34: [2, 15], 39: [2, 15], 44: [2, 15], 47: [2, 15], 48: [2, 15], 51: [2, 15], 55: [2, 15], 60: [2, 15] }, { 72: [1, 137], 77: [1, 136] }, { 72: [2, 100], 77: [2, 100] }, { 14: [2, 16], 15: [2, 16], 19: [2, 16], 29: [2, 16], 34: [2, 16], 44: [2, 16], 47: [2, 16], 48: [2, 16], 51: [2, 16], 55: [2, 16], 60: [2, 16] }, { 33: [1, 138] }, { 33: [2, 75] }, { 33: [2, 32] }, { 72: [2, 101], 77: [2, 101] }, { 14: [2, 17], 15: [2, 17], 19: [2, 17], 29: [2, 17], 34: [2, 17], 39: [2, 17], 44: [2, 17], 47: [2, 17], 48: [2, 17], 51: [2, 17], 55: [2, 17], 60: [2, 17] }],
	        defaultActions: { 4: [2, 1], 54: [2, 55], 56: [2, 20], 60: [2, 57], 73: [2, 81], 82: [2, 85], 86: [2, 18], 90: [2, 89], 101: [2, 53], 104: [2, 93], 110: [2, 19], 111: [2, 77], 116: [2, 97], 119: [2, 63], 122: [2, 69], 135: [2, 75], 136: [2, 32] },
	        parseError: function parseError(str, hash) {
	            throw new Error(str);
	        },
	        parse: function parse(input) {
	            var self = this,
	                stack = [0],
	                vstack = [null],
	                lstack = [],
	                table = this.table,
	                yytext = "",
	                yylineno = 0,
	                yyleng = 0,
	                recovering = 0,
	                TERROR = 2,
	                EOF = 1;
	            this.lexer.setInput(input);
	            this.lexer.yy = this.yy;
	            this.yy.lexer = this.lexer;
	            this.yy.parser = this;
	            if (typeof this.lexer.yylloc == "undefined") this.lexer.yylloc = {};
	            var yyloc = this.lexer.yylloc;
	            lstack.push(yyloc);
	            var ranges = this.lexer.options && this.lexer.options.ranges;
	            if (typeof this.yy.parseError === "function") this.parseError = this.yy.parseError;
	            function popStack(n) {
	                stack.length = stack.length - 2 * n;
	                vstack.length = vstack.length - n;
	                lstack.length = lstack.length - n;
	            }
	            function lex() {
	                var token;
	                token = self.lexer.lex() || 1;
	                if (typeof token !== "number") {
	                    token = self.symbols_[token] || token;
	                }
	                return token;
	            }
	            var symbol,
	                preErrorSymbol,
	                state,
	                action,
	                a,
	                r,
	                yyval = {},
	                p,
	                len,
	                newState,
	                expected;
	            while (true) {
	                state = stack[stack.length - 1];
	                if (this.defaultActions[state]) {
	                    action = this.defaultActions[state];
	                } else {
	                    if (symbol === null || typeof symbol == "undefined") {
	                        symbol = lex();
	                    }
	                    action = table[state] && table[state][symbol];
	                }
	                if (typeof action === "undefined" || !action.length || !action[0]) {
	                    var errStr = "";
	                    if (!recovering) {
	                        expected = [];
	                        for (p in table[state]) if (this.terminals_[p] && p > 2) {
	                            expected.push("'" + this.terminals_[p] + "'");
	                        }
	                        if (this.lexer.showPosition) {
	                            errStr = "Parse error on line " + (yylineno + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + expected.join(", ") + ", got '" + (this.terminals_[symbol] || symbol) + "'";
	                        } else {
	                            errStr = "Parse error on line " + (yylineno + 1) + ": Unexpected " + (symbol == 1 ? "end of input" : "'" + (this.terminals_[symbol] || symbol) + "'");
	                        }
	                        this.parseError(errStr, { text: this.lexer.match, token: this.terminals_[symbol] || symbol, line: this.lexer.yylineno, loc: yyloc, expected: expected });
	                    }
	                }
	                if (action[0] instanceof Array && action.length > 1) {
	                    throw new Error("Parse Error: multiple actions possible at state: " + state + ", token: " + symbol);
	                }
	                switch (action[0]) {
	                    case 1:
	                        stack.push(symbol);
	                        vstack.push(this.lexer.yytext);
	                        lstack.push(this.lexer.yylloc);
	                        stack.push(action[1]);
	                        symbol = null;
	                        if (!preErrorSymbol) {
	                            yyleng = this.lexer.yyleng;
	                            yytext = this.lexer.yytext;
	                            yylineno = this.lexer.yylineno;
	                            yyloc = this.lexer.yylloc;
	                            if (recovering > 0) recovering--;
	                        } else {
	                            symbol = preErrorSymbol;
	                            preErrorSymbol = null;
	                        }
	                        break;
	                    case 2:
	                        len = this.productions_[action[1]][1];
	                        yyval.$ = vstack[vstack.length - len];
	                        yyval._$ = { first_line: lstack[lstack.length - (len || 1)].first_line, last_line: lstack[lstack.length - 1].last_line, first_column: lstack[lstack.length - (len || 1)].first_column, last_column: lstack[lstack.length - 1].last_column };
	                        if (ranges) {
	                            yyval._$.range = [lstack[lstack.length - (len || 1)].range[0], lstack[lstack.length - 1].range[1]];
	                        }
	                        r = this.performAction.call(yyval, yytext, yyleng, yylineno, this.yy, action[1], vstack, lstack);
	                        if (typeof r !== "undefined") {
	                            return r;
	                        }
	                        if (len) {
	                            stack = stack.slice(0, -1 * len * 2);
	                            vstack = vstack.slice(0, -1 * len);
	                            lstack = lstack.slice(0, -1 * len);
	                        }
	                        stack.push(this.productions_[action[1]][0]);
	                        vstack.push(yyval.$);
	                        lstack.push(yyval._$);
	                        newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
	                        stack.push(newState);
	                        break;
	                    case 3:
	                        return true;
	                }
	            }
	            return true;
	        }
	    };
	    /* Jison generated lexer */
	    var lexer = (function () {
	        var lexer = { EOF: 1,
	            parseError: function parseError(str, hash) {
	                if (this.yy.parser) {
	                    this.yy.parser.parseError(str, hash);
	                } else {
	                    throw new Error(str);
	                }
	            },
	            setInput: function setInput(input) {
	                this._input = input;
	                this._more = this._less = this.done = false;
	                this.yylineno = this.yyleng = 0;
	                this.yytext = this.matched = this.match = '';
	                this.conditionStack = ['INITIAL'];
	                this.yylloc = { first_line: 1, first_column: 0, last_line: 1, last_column: 0 };
	                if (this.options.ranges) this.yylloc.range = [0, 0];
	                this.offset = 0;
	                return this;
	            },
	            input: function input() {
	                var ch = this._input[0];
	                this.yytext += ch;
	                this.yyleng++;
	                this.offset++;
	                this.match += ch;
	                this.matched += ch;
	                var lines = ch.match(/(?:\r\n?|\n).*/g);
	                if (lines) {
	                    this.yylineno++;
	                    this.yylloc.last_line++;
	                } else {
	                    this.yylloc.last_column++;
	                }
	                if (this.options.ranges) this.yylloc.range[1]++;

	                this._input = this._input.slice(1);
	                return ch;
	            },
	            unput: function unput(ch) {
	                var len = ch.length;
	                var lines = ch.split(/(?:\r\n?|\n)/g);

	                this._input = ch + this._input;
	                this.yytext = this.yytext.substr(0, this.yytext.length - len - 1);
	                //this.yyleng -= len;
	                this.offset -= len;
	                var oldLines = this.match.split(/(?:\r\n?|\n)/g);
	                this.match = this.match.substr(0, this.match.length - 1);
	                this.matched = this.matched.substr(0, this.matched.length - 1);

	                if (lines.length - 1) this.yylineno -= lines.length - 1;
	                var r = this.yylloc.range;

	                this.yylloc = { first_line: this.yylloc.first_line,
	                    last_line: this.yylineno + 1,
	                    first_column: this.yylloc.first_column,
	                    last_column: lines ? (lines.length === oldLines.length ? this.yylloc.first_column : 0) + oldLines[oldLines.length - lines.length].length - lines[0].length : this.yylloc.first_column - len
	                };

	                if (this.options.ranges) {
	                    this.yylloc.range = [r[0], r[0] + this.yyleng - len];
	                }
	                return this;
	            },
	            more: function more() {
	                this._more = true;
	                return this;
	            },
	            less: function less(n) {
	                this.unput(this.match.slice(n));
	            },
	            pastInput: function pastInput() {
	                var past = this.matched.substr(0, this.matched.length - this.match.length);
	                return (past.length > 20 ? '...' : '') + past.substr(-20).replace(/\n/g, "");
	            },
	            upcomingInput: function upcomingInput() {
	                var next = this.match;
	                if (next.length < 20) {
	                    next += this._input.substr(0, 20 - next.length);
	                }
	                return (next.substr(0, 20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
	            },
	            showPosition: function showPosition() {
	                var pre = this.pastInput();
	                var c = new Array(pre.length + 1).join("-");
	                return pre + this.upcomingInput() + "\n" + c + "^";
	            },
	            next: function next() {
	                if (this.done) {
	                    return this.EOF;
	                }
	                if (!this._input) this.done = true;

	                var token, match, tempMatch, index, col, lines;
	                if (!this._more) {
	                    this.yytext = '';
	                    this.match = '';
	                }
	                var rules = this._currentRules();
	                for (var i = 0; i < rules.length; i++) {
	                    tempMatch = this._input.match(this.rules[rules[i]]);
	                    if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
	                        match = tempMatch;
	                        index = i;
	                        if (!this.options.flex) break;
	                    }
	                }
	                if (match) {
	                    lines = match[0].match(/(?:\r\n?|\n).*/g);
	                    if (lines) this.yylineno += lines.length;
	                    this.yylloc = { first_line: this.yylloc.last_line,
	                        last_line: this.yylineno + 1,
	                        first_column: this.yylloc.last_column,
	                        last_column: lines ? lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + match[0].length };
	                    this.yytext += match[0];
	                    this.match += match[0];
	                    this.matches = match;
	                    this.yyleng = this.yytext.length;
	                    if (this.options.ranges) {
	                        this.yylloc.range = [this.offset, this.offset += this.yyleng];
	                    }
	                    this._more = false;
	                    this._input = this._input.slice(match[0].length);
	                    this.matched += match[0];
	                    token = this.performAction.call(this, this.yy, this, rules[index], this.conditionStack[this.conditionStack.length - 1]);
	                    if (this.done && this._input) this.done = false;
	                    if (token) return token;else return;
	                }
	                if (this._input === "") {
	                    return this.EOF;
	                } else {
	                    return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), { text: "", token: null, line: this.yylineno });
	                }
	            },
	            lex: function lex() {
	                var r = this.next();
	                if (typeof r !== 'undefined') {
	                    return r;
	                } else {
	                    return this.lex();
	                }
	            },
	            begin: function begin(condition) {
	                this.conditionStack.push(condition);
	            },
	            popState: function popState() {
	                return this.conditionStack.pop();
	            },
	            _currentRules: function _currentRules() {
	                return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
	            },
	            topState: function topState() {
	                return this.conditionStack[this.conditionStack.length - 2];
	            },
	            pushState: function begin(condition) {
	                this.begin(condition);
	            } };
	        lexer.options = {};
	        lexer.performAction = function anonymous(yy, yy_, $avoiding_name_collisions, YY_START) {

	            function strip(start, end) {
	                return yy_.yytext = yy_.yytext.substring(start, yy_.yyleng - end + start);
	            }

	            var YYSTATE = YY_START;
	            switch ($avoiding_name_collisions) {
	                case 0:
	                    if (yy_.yytext.slice(-2) === "\\\\") {
	                        strip(0, 1);
	                        this.begin("mu");
	                    } else if (yy_.yytext.slice(-1) === "\\") {
	                        strip(0, 1);
	                        this.begin("emu");
	                    } else {
	                        this.begin("mu");
	                    }
	                    if (yy_.yytext) return 15;

	                    break;
	                case 1:
	                    return 15;
	                    break;
	                case 2:
	                    this.popState();
	                    return 15;

	                    break;
	                case 3:
	                    this.begin('raw');return 15;
	                    break;
	                case 4:
	                    this.popState();
	                    // Should be using `this.topState()` below, but it currently
	                    // returns the second top instead of the first top. Opened an
	                    // issue about it at https://github.com/zaach/jison/issues/291
	                    if (this.conditionStack[this.conditionStack.length - 1] === 'raw') {
	                        return 15;
	                    } else {
	                        strip(5, 9);
	                        return 'END_RAW_BLOCK';
	                    }

	                    break;
	                case 5:
	                    return 15;
	                    break;
	                case 6:
	                    this.popState();
	                    return 14;

	                    break;
	                case 7:
	                    return 65;
	                    break;
	                case 8:
	                    return 68;
	                    break;
	                case 9:
	                    return 19;
	                    break;
	                case 10:
	                    this.popState();
	                    this.begin('raw');
	                    return 23;

	                    break;
	                case 11:
	                    return 55;
	                    break;
	                case 12:
	                    return 60;
	                    break;
	                case 13:
	                    return 29;
	                    break;
	                case 14:
	                    return 47;
	                    break;
	                case 15:
	                    this.popState();return 44;
	                    break;
	                case 16:
	                    this.popState();return 44;
	                    break;
	                case 17:
	                    return 34;
	                    break;
	                case 18:
	                    return 39;
	                    break;
	                case 19:
	                    return 51;
	                    break;
	                case 20:
	                    return 48;
	                    break;
	                case 21:
	                    this.unput(yy_.yytext);
	                    this.popState();
	                    this.begin('com');

	                    break;
	                case 22:
	                    this.popState();
	                    return 14;

	                    break;
	                case 23:
	                    return 48;
	                    break;
	                case 24:
	                    return 73;
	                    break;
	                case 25:
	                    return 72;
	                    break;
	                case 26:
	                    return 72;
	                    break;
	                case 27:
	                    return 87;
	                    break;
	                case 28:
	                    // ignore whitespace
	                    break;
	                case 29:
	                    this.popState();return 54;
	                    break;
	                case 30:
	                    this.popState();return 33;
	                    break;
	                case 31:
	                    yy_.yytext = strip(1, 2).replace(/\\"/g, '"');return 80;
	                    break;
	                case 32:
	                    yy_.yytext = strip(1, 2).replace(/\\'/g, "'");return 80;
	                    break;
	                case 33:
	                    return 85;
	                    break;
	                case 34:
	                    return 82;
	                    break;
	                case 35:
	                    return 82;
	                    break;
	                case 36:
	                    return 83;
	                    break;
	                case 37:
	                    return 84;
	                    break;
	                case 38:
	                    return 81;
	                    break;
	                case 39:
	                    return 75;
	                    break;
	                case 40:
	                    return 77;
	                    break;
	                case 41:
	                    return 72;
	                    break;
	                case 42:
	                    yy_.yytext = yy_.yytext.replace(/\\([\\\]])/g, '$1');return 72;
	                    break;
	                case 43:
	                    return 'INVALID';
	                    break;
	                case 44:
	                    return 5;
	                    break;
	            }
	        };
	        lexer.rules = [/^(?:[^\x00]*?(?=(\{\{)))/, /^(?:[^\x00]+)/, /^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/, /^(?:\{\{\{\{(?=[^\/]))/, /^(?:\{\{\{\{\/[^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=[=}\s\/.])\}\}\}\})/, /^(?:[^\x00]+?(?=(\{\{\{\{)))/, /^(?:[\s\S]*?--(~)?\}\})/, /^(?:\()/, /^(?:\))/, /^(?:\{\{\{\{)/, /^(?:\}\}\}\})/, /^(?:\{\{(~)?>)/, /^(?:\{\{(~)?#>)/, /^(?:\{\{(~)?#\*?)/, /^(?:\{\{(~)?\/)/, /^(?:\{\{(~)?\^\s*(~)?\}\})/, /^(?:\{\{(~)?\s*else\s*(~)?\}\})/, /^(?:\{\{(~)?\^)/, /^(?:\{\{(~)?\s*else\b)/, /^(?:\{\{(~)?\{)/, /^(?:\{\{(~)?&)/, /^(?:\{\{(~)?!--)/, /^(?:\{\{(~)?![\s\S]*?\}\})/, /^(?:\{\{(~)?\*?)/, /^(?:=)/, /^(?:\.\.)/, /^(?:\.(?=([=~}\s\/.)|])))/, /^(?:[\/.])/, /^(?:\s+)/, /^(?:\}(~)?\}\})/, /^(?:(~)?\}\})/, /^(?:"(\\["]|[^"])*")/, /^(?:'(\\[']|[^'])*')/, /^(?:@)/, /^(?:true(?=([~}\s)])))/, /^(?:false(?=([~}\s)])))/, /^(?:undefined(?=([~}\s)])))/, /^(?:null(?=([~}\s)])))/, /^(?:-?[0-9]+(?:\.[0-9]+)?(?=([~}\s)])))/, /^(?:as\s+\|)/, /^(?:\|)/, /^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)|]))))/, /^(?:\[(\\\]|[^\]])*\])/, /^(?:.)/, /^(?:$)/];
	        lexer.conditions = { "mu": { "rules": [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44], "inclusive": false }, "emu": { "rules": [2], "inclusive": false }, "com": { "rules": [6], "inclusive": false }, "raw": { "rules": [3, 4, 5], "inclusive": false }, "INITIAL": { "rules": [0, 1, 44], "inclusive": true } };
	        return lexer;
	    })();
	    parser.lexer = lexer;
	    function Parser() {
	        this.yy = {};
	    }Parser.prototype = parser;parser.Parser = Parser;
	    return new Parser();
	})();exports["default"] = handlebars;
	module.exports = exports["default"];

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;

	var _visitor = __webpack_require__(49);

	var _visitor2 = _interopRequireDefault(_visitor);

	function WhitespaceControl() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

	  this.options = options;
	}
	WhitespaceControl.prototype = new _visitor2['default']();

	WhitespaceControl.prototype.Program = function (program) {
	  var doStandalone = !this.options.ignoreStandalone;

	  var isRoot = !this.isRootSeen;
	  this.isRootSeen = true;

	  var body = program.body;
	  for (var i = 0, l = body.length; i < l; i++) {
	    var current = body[i],
	        strip = this.accept(current);

	    if (!strip) {
	      continue;
	    }

	    var _isPrevWhitespace = isPrevWhitespace(body, i, isRoot),
	        _isNextWhitespace = isNextWhitespace(body, i, isRoot),
	        openStandalone = strip.openStandalone && _isPrevWhitespace,
	        closeStandalone = strip.closeStandalone && _isNextWhitespace,
	        inlineStandalone = strip.inlineStandalone && _isPrevWhitespace && _isNextWhitespace;

	    if (strip.close) {
	      omitRight(body, i, true);
	    }
	    if (strip.open) {
	      omitLeft(body, i, true);
	    }

	    if (doStandalone && inlineStandalone) {
	      omitRight(body, i);

	      if (omitLeft(body, i)) {
	        // If we are on a standalone node, save the indent info for partials
	        if (current.type === 'PartialStatement') {
	          // Pull out the whitespace from the final line
	          current.indent = /([ \t]+$)/.exec(body[i - 1].original)[1];
	        }
	      }
	    }
	    if (doStandalone && openStandalone) {
	      omitRight((current.program || current.inverse).body);

	      // Strip out the previous content node if it's whitespace only
	      omitLeft(body, i);
	    }
	    if (doStandalone && closeStandalone) {
	      // Always strip the next node
	      omitRight(body, i);

	      omitLeft((current.inverse || current.program).body);
	    }
	  }

	  return program;
	};

	WhitespaceControl.prototype.BlockStatement = WhitespaceControl.prototype.DecoratorBlock = WhitespaceControl.prototype.PartialBlockStatement = function (block) {
	  this.accept(block.program);
	  this.accept(block.inverse);

	  // Find the inverse program that is involed with whitespace stripping.
	  var program = block.program || block.inverse,
	      inverse = block.program && block.inverse,
	      firstInverse = inverse,
	      lastInverse = inverse;

	  if (inverse && inverse.chained) {
	    firstInverse = inverse.body[0].program;

	    // Walk the inverse chain to find the last inverse that is actually in the chain.
	    while (lastInverse.chained) {
	      lastInverse = lastInverse.body[lastInverse.body.length - 1].program;
	    }
	  }

	  var strip = {
	    open: block.openStrip.open,
	    close: block.closeStrip.close,

	    // Determine the standalone candiacy. Basically flag our content as being possibly standalone
	    // so our parent can determine if we actually are standalone
	    openStandalone: isNextWhitespace(program.body),
	    closeStandalone: isPrevWhitespace((firstInverse || program).body)
	  };

	  if (block.openStrip.close) {
	    omitRight(program.body, null, true);
	  }

	  if (inverse) {
	    var inverseStrip = block.inverseStrip;

	    if (inverseStrip.open) {
	      omitLeft(program.body, null, true);
	    }

	    if (inverseStrip.close) {
	      omitRight(firstInverse.body, null, true);
	    }
	    if (block.closeStrip.open) {
	      omitLeft(lastInverse.body, null, true);
	    }

	    // Find standalone else statments
	    if (!this.options.ignoreStandalone && isPrevWhitespace(program.body) && isNextWhitespace(firstInverse.body)) {
	      omitLeft(program.body);
	      omitRight(firstInverse.body);
	    }
	  } else if (block.closeStrip.open) {
	    omitLeft(program.body, null, true);
	  }

	  return strip;
	};

	WhitespaceControl.prototype.Decorator = WhitespaceControl.prototype.MustacheStatement = function (mustache) {
	  return mustache.strip;
	};

	WhitespaceControl.prototype.PartialStatement = WhitespaceControl.prototype.CommentStatement = function (node) {
	  /* istanbul ignore next */
	  var strip = node.strip || {};
	  return {
	    inlineStandalone: true,
	    open: strip.open,
	    close: strip.close
	  };
	};

	function isPrevWhitespace(body, i, isRoot) {
	  if (i === undefined) {
	    i = body.length;
	  }

	  // Nodes that end with newlines are considered whitespace (but are special
	  // cased for strip operations)
	  var prev = body[i - 1],
	      sibling = body[i - 2];
	  if (!prev) {
	    return isRoot;
	  }

	  if (prev.type === 'ContentStatement') {
	    return (sibling || !isRoot ? /\r?\n\s*?$/ : /(^|\r?\n)\s*?$/).test(prev.original);
	  }
	}
	function isNextWhitespace(body, i, isRoot) {
	  if (i === undefined) {
	    i = -1;
	  }

	  var next = body[i + 1],
	      sibling = body[i + 2];
	  if (!next) {
	    return isRoot;
	  }

	  if (next.type === 'ContentStatement') {
	    return (sibling || !isRoot ? /^\s*?\r?\n/ : /^\s*?(\r?\n|$)/).test(next.original);
	  }
	}

	// Marks the node to the right of the position as omitted.
	// I.e. {{foo}}' ' will mark the ' ' node as omitted.
	//
	// If i is undefined, then the first child will be marked as such.
	//
	// If mulitple is truthy then all whitespace will be stripped out until non-whitespace
	// content is met.
	function omitRight(body, i, multiple) {
	  var current = body[i == null ? 0 : i + 1];
	  if (!current || current.type !== 'ContentStatement' || !multiple && current.rightStripped) {
	    return;
	  }

	  var original = current.value;
	  current.value = current.value.replace(multiple ? /^\s+/ : /^[ \t]*\r?\n?/, '');
	  current.rightStripped = current.value !== original;
	}

	// Marks the node to the left of the position as omitted.
	// I.e. ' '{{foo}} will mark the ' ' node as omitted.
	//
	// If i is undefined then the last child will be marked as such.
	//
	// If mulitple is truthy then all whitespace will be stripped out until non-whitespace
	// content is met.
	function omitLeft(body, i, multiple) {
	  var current = body[i == null ? body.length - 1 : i - 1];
	  if (!current || current.type !== 'ContentStatement' || !multiple && current.leftStripped) {
	    return;
	  }

	  // We omit the last node if it's whitespace only and not preceded by a non-content node.
	  var original = current.value;
	  current.value = current.value.replace(multiple ? /\s+$/ : /[ \t]+$/, '');
	  current.leftStripped = current.value !== original;
	  return current.leftStripped;
	}

	exports['default'] = WhitespaceControl;
	module.exports = exports['default'];

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;

	var _exception = __webpack_require__(6);

	var _exception2 = _interopRequireDefault(_exception);

	function Visitor() {
	  this.parents = [];
	}

	Visitor.prototype = {
	  constructor: Visitor,
	  mutating: false,

	  // Visits a given value. If mutating, will replace the value if necessary.
	  acceptKey: function acceptKey(node, name) {
	    var value = this.accept(node[name]);
	    if (this.mutating) {
	      // Hacky sanity check: This may have a few false positives for type for the helper
	      // methods but will generally do the right thing without a lot of overhead.
	      if (value && !Visitor.prototype[value.type]) {
	        throw new _exception2['default']('Unexpected node type "' + value.type + '" found when accepting ' + name + ' on ' + node.type);
	      }
	      node[name] = value;
	    }
	  },

	  // Performs an accept operation with added sanity check to ensure
	  // required keys are not removed.
	  acceptRequired: function acceptRequired(node, name) {
	    this.acceptKey(node, name);

	    if (!node[name]) {
	      throw new _exception2['default'](node.type + ' requires ' + name);
	    }
	  },

	  // Traverses a given array. If mutating, empty respnses will be removed
	  // for child elements.
	  acceptArray: function acceptArray(array) {
	    for (var i = 0, l = array.length; i < l; i++) {
	      this.acceptKey(array, i);

	      if (!array[i]) {
	        array.splice(i, 1);
	        i--;
	        l--;
	      }
	    }
	  },

	  accept: function accept(object) {
	    if (!object) {
	      return;
	    }

	    /* istanbul ignore next: Sanity code */
	    if (!this[object.type]) {
	      throw new _exception2['default']('Unknown type: ' + object.type, object);
	    }

	    if (this.current) {
	      this.parents.unshift(this.current);
	    }
	    this.current = object;

	    var ret = this[object.type](object);

	    this.current = this.parents.shift();

	    if (!this.mutating || ret) {
	      return ret;
	    } else if (ret !== false) {
	      return object;
	    }
	  },

	  Program: function Program(program) {
	    this.acceptArray(program.body);
	  },

	  MustacheStatement: visitSubExpression,
	  Decorator: visitSubExpression,

	  BlockStatement: visitBlock,
	  DecoratorBlock: visitBlock,

	  PartialStatement: visitPartial,
	  PartialBlockStatement: function PartialBlockStatement(partial) {
	    visitPartial.call(this, partial);

	    this.acceptKey(partial, 'program');
	  },

	  ContentStatement: function ContentStatement() /* content */{},
	  CommentStatement: function CommentStatement() /* comment */{},

	  SubExpression: visitSubExpression,

	  PathExpression: function PathExpression() /* path */{},

	  StringLiteral: function StringLiteral() /* string */{},
	  NumberLiteral: function NumberLiteral() /* number */{},
	  BooleanLiteral: function BooleanLiteral() /* bool */{},
	  UndefinedLiteral: function UndefinedLiteral() /* literal */{},
	  NullLiteral: function NullLiteral() /* literal */{},

	  Hash: function Hash(hash) {
	    this.acceptArray(hash.pairs);
	  },
	  HashPair: function HashPair(pair) {
	    this.acceptRequired(pair, 'value');
	  }
	};

	function visitSubExpression(mustache) {
	  this.acceptRequired(mustache, 'path');
	  this.acceptArray(mustache.params);
	  this.acceptKey(mustache, 'hash');
	}
	function visitBlock(block) {
	  visitSubExpression.call(this, block);

	  this.acceptKey(block, 'program');
	  this.acceptKey(block, 'inverse');
	}
	function visitPartial(partial) {
	  this.acceptRequired(partial, 'name');
	  this.acceptArray(partial.params);
	  this.acceptKey(partial, 'hash');
	}

	exports['default'] = Visitor;
	module.exports = exports['default'];

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;
	exports.SourceLocation = SourceLocation;
	exports.id = id;
	exports.stripFlags = stripFlags;
	exports.stripComment = stripComment;
	exports.preparePath = preparePath;
	exports.prepareMustache = prepareMustache;
	exports.prepareRawBlock = prepareRawBlock;
	exports.prepareBlock = prepareBlock;
	exports.prepareProgram = prepareProgram;
	exports.preparePartialBlock = preparePartialBlock;

	var _exception = __webpack_require__(6);

	var _exception2 = _interopRequireDefault(_exception);

	function validateClose(open, close) {
	  close = close.path ? close.path.original : close;

	  if (open.path.original !== close) {
	    var errorNode = { loc: open.path.loc };

	    throw new _exception2['default'](open.path.original + " doesn't match " + close, errorNode);
	  }
	}

	function SourceLocation(source, locInfo) {
	  this.source = source;
	  this.start = {
	    line: locInfo.first_line,
	    column: locInfo.first_column
	  };
	  this.end = {
	    line: locInfo.last_line,
	    column: locInfo.last_column
	  };
	}

	function id(token) {
	  if (/^\[.*\]$/.test(token)) {
	    return token.substring(1, token.length - 1);
	  } else {
	    return token;
	  }
	}

	function stripFlags(open, close) {
	  return {
	    open: open.charAt(2) === '~',
	    close: close.charAt(close.length - 3) === '~'
	  };
	}

	function stripComment(comment) {
	  return comment.replace(/^\{\{~?!-?-?/, '').replace(/-?-?~?\}\}$/, '');
	}

	function preparePath(data, parts, loc) {
	  loc = this.locInfo(loc);

	  var original = data ? '@' : '',
	      dig = [],
	      depth = 0;

	  for (var i = 0, l = parts.length; i < l; i++) {
	    var part = parts[i].part,

	    // If we have [] syntax then we do not treat path references as operators,
	    // i.e. foo.[this] resolves to approximately context.foo['this']
	    isLiteral = parts[i].original !== part;
	    original += (parts[i].separator || '') + part;

	    if (!isLiteral && (part === '..' || part === '.' || part === 'this')) {
	      if (dig.length > 0) {
	        throw new _exception2['default']('Invalid path: ' + original, { loc: loc });
	      } else if (part === '..') {
	        depth++;
	      }
	    } else {
	      dig.push(part);
	    }
	  }

	  return {
	    type: 'PathExpression',
	    data: data,
	    depth: depth,
	    parts: dig,
	    original: original,
	    loc: loc
	  };
	}

	function prepareMustache(path, params, hash, open, strip, locInfo) {
	  // Must use charAt to support IE pre-10
	  var escapeFlag = open.charAt(3) || open.charAt(2),
	      escaped = escapeFlag !== '{' && escapeFlag !== '&';

	  var decorator = /\*/.test(open);
	  return {
	    type: decorator ? 'Decorator' : 'MustacheStatement',
	    path: path,
	    params: params,
	    hash: hash,
	    escaped: escaped,
	    strip: strip,
	    loc: this.locInfo(locInfo)
	  };
	}

	function prepareRawBlock(openRawBlock, contents, close, locInfo) {
	  validateClose(openRawBlock, close);

	  locInfo = this.locInfo(locInfo);
	  var program = {
	    type: 'Program',
	    body: contents,
	    strip: {},
	    loc: locInfo
	  };

	  return {
	    type: 'BlockStatement',
	    path: openRawBlock.path,
	    params: openRawBlock.params,
	    hash: openRawBlock.hash,
	    program: program,
	    openStrip: {},
	    inverseStrip: {},
	    closeStrip: {},
	    loc: locInfo
	  };
	}

	function prepareBlock(openBlock, program, inverseAndProgram, close, inverted, locInfo) {
	  if (close && close.path) {
	    validateClose(openBlock, close);
	  }

	  var decorator = /\*/.test(openBlock.open);

	  program.blockParams = openBlock.blockParams;

	  var inverse = undefined,
	      inverseStrip = undefined;

	  if (inverseAndProgram) {
	    if (decorator) {
	      throw new _exception2['default']('Unexpected inverse block on decorator', inverseAndProgram);
	    }

	    if (inverseAndProgram.chain) {
	      inverseAndProgram.program.body[0].closeStrip = close.strip;
	    }

	    inverseStrip = inverseAndProgram.strip;
	    inverse = inverseAndProgram.program;
	  }

	  if (inverted) {
	    inverted = inverse;
	    inverse = program;
	    program = inverted;
	  }

	  return {
	    type: decorator ? 'DecoratorBlock' : 'BlockStatement',
	    path: openBlock.path,
	    params: openBlock.params,
	    hash: openBlock.hash,
	    program: program,
	    inverse: inverse,
	    openStrip: openBlock.strip,
	    inverseStrip: inverseStrip,
	    closeStrip: close && close.strip,
	    loc: this.locInfo(locInfo)
	  };
	}

	function prepareProgram(statements, loc) {
	  if (!loc && statements.length) {
	    var firstLoc = statements[0].loc,
	        lastLoc = statements[statements.length - 1].loc;

	    /* istanbul ignore else */
	    if (firstLoc && lastLoc) {
	      loc = {
	        source: firstLoc.source,
	        start: {
	          line: firstLoc.start.line,
	          column: firstLoc.start.column
	        },
	        end: {
	          line: lastLoc.end.line,
	          column: lastLoc.end.column
	        }
	      };
	    }
	  }

	  return {
	    type: 'Program',
	    body: statements,
	    strip: {},
	    loc: loc
	  };
	}

	function preparePartialBlock(open, program, close, locInfo) {
	  validateClose(open, close);

	  return {
	    type: 'PartialBlockStatement',
	    name: open.path,
	    params: open.params,
	    hash: open.hash,
	    program: program,
	    openStrip: open.strip,
	    closeStrip: close && close.strip,
	    loc: this.locInfo(locInfo)
	  };
	}

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable new-cap */

	'use strict';

	var _Object$create = __webpack_require__(34)['default'];

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;
	exports.Compiler = Compiler;
	exports.precompile = precompile;
	exports.compile = compile;

	var _exception = __webpack_require__(6);

	var _exception2 = _interopRequireDefault(_exception);

	var _utils = __webpack_require__(5);

	var _ast = __webpack_require__(45);

	var _ast2 = _interopRequireDefault(_ast);

	var slice = [].slice;

	function Compiler() {}

	// the foundHelper register will disambiguate helper lookup from finding a
	// function in a context. This is necessary for mustache compatibility, which
	// requires that context functions in blocks are evaluated by blockHelperMissing,
	// and then proceed as if the resulting value was provided to blockHelperMissing.

	Compiler.prototype = {
	  compiler: Compiler,

	  equals: function equals(other) {
	    var len = this.opcodes.length;
	    if (other.opcodes.length !== len) {
	      return false;
	    }

	    for (var i = 0; i < len; i++) {
	      var opcode = this.opcodes[i],
	          otherOpcode = other.opcodes[i];
	      if (opcode.opcode !== otherOpcode.opcode || !argEquals(opcode.args, otherOpcode.args)) {
	        return false;
	      }
	    }

	    // We know that length is the same between the two arrays because they are directly tied
	    // to the opcode behavior above.
	    len = this.children.length;
	    for (var i = 0; i < len; i++) {
	      if (!this.children[i].equals(other.children[i])) {
	        return false;
	      }
	    }

	    return true;
	  },

	  guid: 0,

	  compile: function compile(program, options) {
	    this.sourceNode = [];
	    this.opcodes = [];
	    this.children = [];
	    this.options = options;
	    this.stringParams = options.stringParams;
	    this.trackIds = options.trackIds;

	    options.blockParams = options.blockParams || [];

	    options.knownHelpers = _utils.extend(_Object$create(null), {
	      helperMissing: true,
	      blockHelperMissing: true,
	      each: true,
	      'if': true,
	      unless: true,
	      'with': true,
	      log: true,
	      lookup: true
	    }, options.knownHelpers);

	    return this.accept(program);
	  },

	  compileProgram: function compileProgram(program) {
	    var childCompiler = new this.compiler(),
	        // eslint-disable-line new-cap
	    result = childCompiler.compile(program, this.options),
	        guid = this.guid++;

	    this.usePartial = this.usePartial || result.usePartial;

	    this.children[guid] = result;
	    this.useDepths = this.useDepths || result.useDepths;

	    return guid;
	  },

	  accept: function accept(node) {
	    /* istanbul ignore next: Sanity code */
	    if (!this[node.type]) {
	      throw new _exception2['default']('Unknown type: ' + node.type, node);
	    }

	    this.sourceNode.unshift(node);
	    var ret = this[node.type](node);
	    this.sourceNode.shift();
	    return ret;
	  },

	  Program: function Program(program) {
	    this.options.blockParams.unshift(program.blockParams);

	    var body = program.body,
	        bodyLength = body.length;
	    for (var i = 0; i < bodyLength; i++) {
	      this.accept(body[i]);
	    }

	    this.options.blockParams.shift();

	    this.isSimple = bodyLength === 1;
	    this.blockParams = program.blockParams ? program.blockParams.length : 0;

	    return this;
	  },

	  BlockStatement: function BlockStatement(block) {
	    transformLiteralToPath(block);

	    var program = block.program,
	        inverse = block.inverse;

	    program = program && this.compileProgram(program);
	    inverse = inverse && this.compileProgram(inverse);

	    var type = this.classifySexpr(block);

	    if (type === 'helper') {
	      this.helperSexpr(block, program, inverse);
	    } else if (type === 'simple') {
	      this.simpleSexpr(block);

	      // now that the simple mustache is resolved, we need to
	      // evaluate it by executing `blockHelperMissing`
	      this.opcode('pushProgram', program);
	      this.opcode('pushProgram', inverse);
	      this.opcode('emptyHash');
	      this.opcode('blockValue', block.path.original);
	    } else {
	      this.ambiguousSexpr(block, program, inverse);

	      // now that the simple mustache is resolved, we need to
	      // evaluate it by executing `blockHelperMissing`
	      this.opcode('pushProgram', program);
	      this.opcode('pushProgram', inverse);
	      this.opcode('emptyHash');
	      this.opcode('ambiguousBlockValue');
	    }

	    this.opcode('append');
	  },

	  DecoratorBlock: function DecoratorBlock(decorator) {
	    var program = decorator.program && this.compileProgram(decorator.program);
	    var params = this.setupFullMustacheParams(decorator, program, undefined),
	        path = decorator.path;

	    this.useDecorators = true;
	    this.opcode('registerDecorator', params.length, path.original);
	  },

	  PartialStatement: function PartialStatement(partial) {
	    this.usePartial = true;

	    var program = partial.program;
	    if (program) {
	      program = this.compileProgram(partial.program);
	    }

	    var params = partial.params;
	    if (params.length > 1) {
	      throw new _exception2['default']('Unsupported number of partial arguments: ' + params.length, partial);
	    } else if (!params.length) {
	      if (this.options.explicitPartialContext) {
	        this.opcode('pushLiteral', 'undefined');
	      } else {
	        params.push({ type: 'PathExpression', parts: [], depth: 0 });
	      }
	    }

	    var partialName = partial.name.original,
	        isDynamic = partial.name.type === 'SubExpression';
	    if (isDynamic) {
	      this.accept(partial.name);
	    }

	    this.setupFullMustacheParams(partial, program, undefined, true);

	    var indent = partial.indent || '';
	    if (this.options.preventIndent && indent) {
	      this.opcode('appendContent', indent);
	      indent = '';
	    }

	    this.opcode('invokePartial', isDynamic, partialName, indent);
	    this.opcode('append');
	  },
	  PartialBlockStatement: function PartialBlockStatement(partialBlock) {
	    this.PartialStatement(partialBlock);
	  },

	  MustacheStatement: function MustacheStatement(mustache) {
	    this.SubExpression(mustache);

	    if (mustache.escaped && !this.options.noEscape) {
	      this.opcode('appendEscaped');
	    } else {
	      this.opcode('append');
	    }
	  },
	  Decorator: function Decorator(decorator) {
	    this.DecoratorBlock(decorator);
	  },

	  ContentStatement: function ContentStatement(content) {
	    if (content.value) {
	      this.opcode('appendContent', content.value);
	    }
	  },

	  CommentStatement: function CommentStatement() {},

	  SubExpression: function SubExpression(sexpr) {
	    transformLiteralToPath(sexpr);
	    var type = this.classifySexpr(sexpr);

	    if (type === 'simple') {
	      this.simpleSexpr(sexpr);
	    } else if (type === 'helper') {
	      this.helperSexpr(sexpr);
	    } else {
	      this.ambiguousSexpr(sexpr);
	    }
	  },
	  ambiguousSexpr: function ambiguousSexpr(sexpr, program, inverse) {
	    var path = sexpr.path,
	        name = path.parts[0],
	        isBlock = program != null || inverse != null;

	    this.opcode('getContext', path.depth);

	    this.opcode('pushProgram', program);
	    this.opcode('pushProgram', inverse);

	    path.strict = true;
	    this.accept(path);

	    this.opcode('invokeAmbiguous', name, isBlock);
	  },

	  simpleSexpr: function simpleSexpr(sexpr) {
	    var path = sexpr.path;
	    path.strict = true;
	    this.accept(path);
	    this.opcode('resolvePossibleLambda');
	  },

	  helperSexpr: function helperSexpr(sexpr, program, inverse) {
	    var params = this.setupFullMustacheParams(sexpr, program, inverse),
	        path = sexpr.path,
	        name = path.parts[0];

	    if (this.options.knownHelpers[name]) {
	      this.opcode('invokeKnownHelper', params.length, name);
	    } else if (this.options.knownHelpersOnly) {
	      throw new _exception2['default']('You specified knownHelpersOnly, but used the unknown helper ' + name, sexpr);
	    } else {
	      path.strict = true;
	      path.falsy = true;

	      this.accept(path);
	      this.opcode('invokeHelper', params.length, path.original, _ast2['default'].helpers.simpleId(path));
	    }
	  },

	  PathExpression: function PathExpression(path) {
	    this.addDepth(path.depth);
	    this.opcode('getContext', path.depth);

	    var name = path.parts[0],
	        scoped = _ast2['default'].helpers.scopedId(path),
	        blockParamId = !path.depth && !scoped && this.blockParamIndex(name);

	    if (blockParamId) {
	      this.opcode('lookupBlockParam', blockParamId, path.parts);
	    } else if (!name) {
	      // Context reference, i.e. `{{foo .}}` or `{{foo ..}}`
	      this.opcode('pushContext');
	    } else if (path.data) {
	      this.options.data = true;
	      this.opcode('lookupData', path.depth, path.parts, path.strict);
	    } else {
	      this.opcode('lookupOnContext', path.parts, path.falsy, path.strict, scoped);
	    }
	  },

	  StringLiteral: function StringLiteral(string) {
	    this.opcode('pushString', string.value);
	  },

	  NumberLiteral: function NumberLiteral(number) {
	    this.opcode('pushLiteral', number.value);
	  },

	  BooleanLiteral: function BooleanLiteral(bool) {
	    this.opcode('pushLiteral', bool.value);
	  },

	  UndefinedLiteral: function UndefinedLiteral() {
	    this.opcode('pushLiteral', 'undefined');
	  },

	  NullLiteral: function NullLiteral() {
	    this.opcode('pushLiteral', 'null');
	  },

	  Hash: function Hash(hash) {
	    var pairs = hash.pairs,
	        i = 0,
	        l = pairs.length;

	    this.opcode('pushHash');

	    for (; i < l; i++) {
	      this.pushParam(pairs[i].value);
	    }
	    while (i--) {
	      this.opcode('assignToHash', pairs[i].key);
	    }
	    this.opcode('popHash');
	  },

	  // HELPERS
	  opcode: function opcode(name) {
	    this.opcodes.push({
	      opcode: name,
	      args: slice.call(arguments, 1),
	      loc: this.sourceNode[0].loc
	    });
	  },

	  addDepth: function addDepth(depth) {
	    if (!depth) {
	      return;
	    }

	    this.useDepths = true;
	  },

	  classifySexpr: function classifySexpr(sexpr) {
	    var isSimple = _ast2['default'].helpers.simpleId(sexpr.path);

	    var isBlockParam = isSimple && !!this.blockParamIndex(sexpr.path.parts[0]);

	    // a mustache is an eligible helper if:
	    // * its id is simple (a single part, not `this` or `..`)
	    var isHelper = !isBlockParam && _ast2['default'].helpers.helperExpression(sexpr);

	    // if a mustache is an eligible helper but not a definite
	    // helper, it is ambiguous, and will be resolved in a later
	    // pass or at runtime.
	    var isEligible = !isBlockParam && (isHelper || isSimple);

	    // if ambiguous, we can possibly resolve the ambiguity now
	    // An eligible helper is one that does not have a complex path, i.e. `this.foo`, `../foo` etc.
	    if (isEligible && !isHelper) {
	      var _name = sexpr.path.parts[0],
	          options = this.options;
	      if (options.knownHelpers[_name]) {
	        isHelper = true;
	      } else if (options.knownHelpersOnly) {
	        isEligible = false;
	      }
	    }

	    if (isHelper) {
	      return 'helper';
	    } else if (isEligible) {
	      return 'ambiguous';
	    } else {
	      return 'simple';
	    }
	  },

	  pushParams: function pushParams(params) {
	    for (var i = 0, l = params.length; i < l; i++) {
	      this.pushParam(params[i]);
	    }
	  },

	  pushParam: function pushParam(val) {
	    var value = val.value != null ? val.value : val.original || '';

	    if (this.stringParams) {
	      if (value.replace) {
	        value = value.replace(/^(\.?\.\/)*/g, '').replace(/\//g, '.');
	      }

	      if (val.depth) {
	        this.addDepth(val.depth);
	      }
	      this.opcode('getContext', val.depth || 0);
	      this.opcode('pushStringParam', value, val.type);

	      if (val.type === 'SubExpression') {
	        // SubExpressions get evaluated and passed in
	        // in string params mode.
	        this.accept(val);
	      }
	    } else {
	      if (this.trackIds) {
	        var blockParamIndex = undefined;
	        if (val.parts && !_ast2['default'].helpers.scopedId(val) && !val.depth) {
	          blockParamIndex = this.blockParamIndex(val.parts[0]);
	        }
	        if (blockParamIndex) {
	          var blockParamChild = val.parts.slice(1).join('.');
	          this.opcode('pushId', 'BlockParam', blockParamIndex, blockParamChild);
	        } else {
	          value = val.original || value;
	          if (value.replace) {
	            value = value.replace(/^this(?:\.|$)/, '').replace(/^\.\//, '').replace(/^\.$/, '');
	          }

	          this.opcode('pushId', val.type, value);
	        }
	      }
	      this.accept(val);
	    }
	  },

	  setupFullMustacheParams: function setupFullMustacheParams(sexpr, program, inverse, omitEmpty) {
	    var params = sexpr.params;
	    this.pushParams(params);

	    this.opcode('pushProgram', program);
	    this.opcode('pushProgram', inverse);

	    if (sexpr.hash) {
	      this.accept(sexpr.hash);
	    } else {
	      this.opcode('emptyHash', omitEmpty);
	    }

	    return params;
	  },

	  blockParamIndex: function blockParamIndex(name) {
	    for (var depth = 0, len = this.options.blockParams.length; depth < len; depth++) {
	      var blockParams = this.options.blockParams[depth],
	          param = blockParams && _utils.indexOf(blockParams, name);
	      if (blockParams && param >= 0) {
	        return [depth, param];
	      }
	    }
	  }
	};

	function precompile(input, options, env) {
	  if (input == null || typeof input !== 'string' && input.type !== 'Program') {
	    throw new _exception2['default']('You must pass a string or Handlebars AST to Handlebars.precompile. You passed ' + input);
	  }

	  options = options || {};
	  if (!('data' in options)) {
	    options.data = true;
	  }
	  if (options.compat) {
	    options.useDepths = true;
	  }

	  var ast = env.parse(input, options),
	      environment = new env.Compiler().compile(ast, options);
	  return new env.JavaScriptCompiler().compile(environment, options);
	}

	function compile(input, options, env) {
	  if (options === undefined) options = {};

	  if (input == null || typeof input !== 'string' && input.type !== 'Program') {
	    throw new _exception2['default']('You must pass a string or Handlebars AST to Handlebars.compile. You passed ' + input);
	  }

	  options = _utils.extend({}, options);
	  if (!('data' in options)) {
	    options.data = true;
	  }
	  if (options.compat) {
	    options.useDepths = true;
	  }

	  var compiled = undefined;

	  function compileInput() {
	    var ast = env.parse(input, options),
	        environment = new env.Compiler().compile(ast, options),
	        templateSpec = new env.JavaScriptCompiler().compile(environment, options, undefined, true);
	    return env.template(templateSpec);
	  }

	  // Template is only compiled on first use and cached after that point.
	  function ret(context, execOptions) {
	    if (!compiled) {
	      compiled = compileInput();
	    }
	    return compiled.call(this, context, execOptions);
	  }
	  ret._setup = function (setupOptions) {
	    if (!compiled) {
	      compiled = compileInput();
	    }
	    return compiled._setup(setupOptions);
	  };
	  ret._child = function (i, data, blockParams, depths) {
	    if (!compiled) {
	      compiled = compileInput();
	    }
	    return compiled._child(i, data, blockParams, depths);
	  };
	  return ret;
	}

	function argEquals(a, b) {
	  if (a === b) {
	    return true;
	  }

	  if (_utils.isArray(a) && _utils.isArray(b) && a.length === b.length) {
	    for (var i = 0; i < a.length; i++) {
	      if (!argEquals(a[i], b[i])) {
	        return false;
	      }
	    }
	    return true;
	  }
	}

	function transformLiteralToPath(sexpr) {
	  if (!sexpr.path.parts) {
	    var literal = sexpr.path;
	    // Casting to string here to make false and 0 literal values play nicely with the rest
	    // of the system.
	    sexpr.path = {
	      type: 'PathExpression',
	      data: false,
	      depth: 0,
	      parts: [literal.original + ''],
	      original: literal.original + '',
	      loc: literal.loc
	    };
	  }
	}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$keys = __webpack_require__(13)['default'];

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;

	var _base = __webpack_require__(4);

	var _exception = __webpack_require__(6);

	var _exception2 = _interopRequireDefault(_exception);

	var _utils = __webpack_require__(5);

	var _codeGen = __webpack_require__(53);

	var _codeGen2 = _interopRequireDefault(_codeGen);

	function Literal(value) {
	  this.value = value;
	}

	function JavaScriptCompiler() {}

	JavaScriptCompiler.prototype = {
	  // PUBLIC API: You can override these methods in a subclass to provide
	  // alternative compiled forms for name lookup and buffering semantics
	  nameLookup: function nameLookup(parent, name /*,  type */) {
	    return this.internalNameLookup(parent, name);
	  },
	  depthedLookup: function depthedLookup(name) {
	    return [this.aliasable('container.lookup'), '(depths, ', JSON.stringify(name), ')'];
	  },

	  compilerInfo: function compilerInfo() {
	    var revision = _base.COMPILER_REVISION,
	        versions = _base.REVISION_CHANGES[revision];
	    return [revision, versions];
	  },

	  appendToBuffer: function appendToBuffer(source, location, explicit) {
	    // Force a source as this simplifies the merge logic.
	    if (!_utils.isArray(source)) {
	      source = [source];
	    }
	    source = this.source.wrap(source, location);

	    if (this.environment.isSimple) {
	      return ['return ', source, ';'];
	    } else if (explicit) {
	      // This is a case where the buffer operation occurs as a child of another
	      // construct, generally braces. We have to explicitly output these buffer
	      // operations to ensure that the emitted code goes in the correct location.
	      return ['buffer += ', source, ';'];
	    } else {
	      source.appendToBuffer = true;
	      return source;
	    }
	  },

	  initializeBuffer: function initializeBuffer() {
	    return this.quotedString('');
	  },
	  // END PUBLIC API
	  internalNameLookup: function internalNameLookup(parent, name) {
	    this.lookupPropertyFunctionIsUsed = true;
	    return ['lookupProperty(', parent, ',', JSON.stringify(name), ')'];
	  },

	  lookupPropertyFunctionIsUsed: false,

	  compile: function compile(environment, options, context, asObject) {
	    this.environment = environment;
	    this.options = options;
	    this.stringParams = this.options.stringParams;
	    this.trackIds = this.options.trackIds;
	    this.precompile = !asObject;

	    this.name = this.environment.name;
	    this.isChild = !!context;
	    this.context = context || {
	      decorators: [],
	      programs: [],
	      environments: []
	    };

	    this.preamble();

	    this.stackSlot = 0;
	    this.stackVars = [];
	    this.aliases = {};
	    this.registers = { list: [] };
	    this.hashes = [];
	    this.compileStack = [];
	    this.inlineStack = [];
	    this.blockParams = [];

	    this.compileChildren(environment, options);

	    this.useDepths = this.useDepths || environment.useDepths || environment.useDecorators || this.options.compat;
	    this.useBlockParams = this.useBlockParams || environment.useBlockParams;

	    var opcodes = environment.opcodes,
	        opcode = undefined,
	        firstLoc = undefined,
	        i = undefined,
	        l = undefined;

	    for (i = 0, l = opcodes.length; i < l; i++) {
	      opcode = opcodes[i];

	      this.source.currentLocation = opcode.loc;
	      firstLoc = firstLoc || opcode.loc;
	      this[opcode.opcode].apply(this, opcode.args);
	    }

	    // Flush any trailing content that might be pending.
	    this.source.currentLocation = firstLoc;
	    this.pushSource('');

	    /* istanbul ignore next */
	    if (this.stackSlot || this.inlineStack.length || this.compileStack.length) {
	      throw new _exception2['default']('Compile completed with content left on stack');
	    }

	    if (!this.decorators.isEmpty()) {
	      this.useDecorators = true;

	      this.decorators.prepend(['var decorators = container.decorators, ', this.lookupPropertyFunctionVarDeclaration(), ';\n']);
	      this.decorators.push('return fn;');

	      if (asObject) {
	        this.decorators = Function.apply(this, ['fn', 'props', 'container', 'depth0', 'data', 'blockParams', 'depths', this.decorators.merge()]);
	      } else {
	        this.decorators.prepend('function(fn, props, container, depth0, data, blockParams, depths) {\n');
	        this.decorators.push('}\n');
	        this.decorators = this.decorators.merge();
	      }
	    } else {
	      this.decorators = undefined;
	    }

	    var fn = this.createFunctionContext(asObject);
	    if (!this.isChild) {
	      var ret = {
	        compiler: this.compilerInfo(),
	        main: fn
	      };

	      if (this.decorators) {
	        ret.main_d = this.decorators; // eslint-disable-line camelcase
	        ret.useDecorators = true;
	      }

	      var _context = this.context;
	      var programs = _context.programs;
	      var decorators = _context.decorators;

	      for (i = 0, l = programs.length; i < l; i++) {
	        if (programs[i]) {
	          ret[i] = programs[i];
	          if (decorators[i]) {
	            ret[i + '_d'] = decorators[i];
	            ret.useDecorators = true;
	          }
	        }
	      }

	      if (this.environment.usePartial) {
	        ret.usePartial = true;
	      }
	      if (this.options.data) {
	        ret.useData = true;
	      }
	      if (this.useDepths) {
	        ret.useDepths = true;
	      }
	      if (this.useBlockParams) {
	        ret.useBlockParams = true;
	      }
	      if (this.options.compat) {
	        ret.compat = true;
	      }

	      if (!asObject) {
	        ret.compiler = JSON.stringify(ret.compiler);

	        this.source.currentLocation = { start: { line: 1, column: 0 } };
	        ret = this.objectLiteral(ret);

	        if (options.srcName) {
	          ret = ret.toStringWithSourceMap({ file: options.destName });
	          ret.map = ret.map && ret.map.toString();
	        } else {
	          ret = ret.toString();
	        }
	      } else {
	        ret.compilerOptions = this.options;
	      }

	      return ret;
	    } else {
	      return fn;
	    }
	  },

	  preamble: function preamble() {
	    // track the last context pushed into place to allow skipping the
	    // getContext opcode when it would be a noop
	    this.lastContext = 0;
	    this.source = new _codeGen2['default'](this.options.srcName);
	    this.decorators = new _codeGen2['default'](this.options.srcName);
	  },

	  createFunctionContext: function createFunctionContext(asObject) {
	    // istanbul ignore next

	    var _this = this;

	    var varDeclarations = '';

	    var locals = this.stackVars.concat(this.registers.list);
	    if (locals.length > 0) {
	      varDeclarations += ', ' + locals.join(', ');
	    }

	    // Generate minimizer alias mappings
	    //
	    // When using true SourceNodes, this will update all references to the given alias
	    // as the source nodes are reused in situ. For the non-source node compilation mode,
	    // aliases will not be used, but this case is already being run on the client and
	    // we aren't concern about minimizing the template size.
	    var aliasCount = 0;
	    _Object$keys(this.aliases).forEach(function (alias) {
	      var node = _this.aliases[alias];
	      if (node.children && node.referenceCount > 1) {
	        varDeclarations += ', alias' + ++aliasCount + '=' + alias;
	        node.children[0] = 'alias' + aliasCount;
	      }
	    });

	    if (this.lookupPropertyFunctionIsUsed) {
	      varDeclarations += ', ' + this.lookupPropertyFunctionVarDeclaration();
	    }

	    var params = ['container', 'depth0', 'helpers', 'partials', 'data'];

	    if (this.useBlockParams || this.useDepths) {
	      params.push('blockParams');
	    }
	    if (this.useDepths) {
	      params.push('depths');
	    }

	    // Perform a second pass over the output to merge content when possible
	    var source = this.mergeSource(varDeclarations);

	    if (asObject) {
	      params.push(source);

	      return Function.apply(this, params);
	    } else {
	      return this.source.wrap(['function(', params.join(','), ') {\n  ', source, '}']);
	    }
	  },
	  mergeSource: function mergeSource(varDeclarations) {
	    var isSimple = this.environment.isSimple,
	        appendOnly = !this.forceBuffer,
	        appendFirst = undefined,
	        sourceSeen = undefined,
	        bufferStart = undefined,
	        bufferEnd = undefined;
	    this.source.each(function (line) {
	      if (line.appendToBuffer) {
	        if (bufferStart) {
	          line.prepend('  + ');
	        } else {
	          bufferStart = line;
	        }
	        bufferEnd = line;
	      } else {
	        if (bufferStart) {
	          if (!sourceSeen) {
	            appendFirst = true;
	          } else {
	            bufferStart.prepend('buffer += ');
	          }
	          bufferEnd.add(';');
	          bufferStart = bufferEnd = undefined;
	        }

	        sourceSeen = true;
	        if (!isSimple) {
	          appendOnly = false;
	        }
	      }
	    });

	    if (appendOnly) {
	      if (bufferStart) {
	        bufferStart.prepend('return ');
	        bufferEnd.add(';');
	      } else if (!sourceSeen) {
	        this.source.push('return "";');
	      }
	    } else {
	      varDeclarations += ', buffer = ' + (appendFirst ? '' : this.initializeBuffer());

	      if (bufferStart) {
	        bufferStart.prepend('return buffer + ');
	        bufferEnd.add(';');
	      } else {
	        this.source.push('return buffer;');
	      }
	    }

	    if (varDeclarations) {
	      this.source.prepend('var ' + varDeclarations.substring(2) + (appendFirst ? '' : ';\n'));
	    }

	    return this.source.merge();
	  },

	  lookupPropertyFunctionVarDeclaration: function lookupPropertyFunctionVarDeclaration() {
	    return '\n      lookupProperty = container.lookupProperty || function(parent, propertyName) {\n        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {\n          return parent[propertyName];\n        }\n        return undefined\n    }\n    '.trim();
	  },

	  // [blockValue]
	  //
	  // On stack, before: hash, inverse, program, value
	  // On stack, after: return value of blockHelperMissing
	  //
	  // The purpose of this opcode is to take a block of the form
	  // `{{#this.foo}}...{{/this.foo}}`, resolve the value of `foo`, and
	  // replace it on the stack with the result of properly
	  // invoking blockHelperMissing.
	  blockValue: function blockValue(name) {
	    var blockHelperMissing = this.aliasable('container.hooks.blockHelperMissing'),
	        params = [this.contextName(0)];
	    this.setupHelperArgs(name, 0, params);

	    var blockName = this.popStack();
	    params.splice(1, 0, blockName);

	    this.push(this.source.functionCall(blockHelperMissing, 'call', params));
	  },

	  // [ambiguousBlockValue]
	  //
	  // On stack, before: hash, inverse, program, value
	  // Compiler value, before: lastHelper=value of last found helper, if any
	  // On stack, after, if no lastHelper: same as [blockValue]
	  // On stack, after, if lastHelper: value
	  ambiguousBlockValue: function ambiguousBlockValue() {
	    // We're being a bit cheeky and reusing the options value from the prior exec
	    var blockHelperMissing = this.aliasable('container.hooks.blockHelperMissing'),
	        params = [this.contextName(0)];
	    this.setupHelperArgs('', 0, params, true);

	    this.flushInline();

	    var current = this.topStack();
	    params.splice(1, 0, current);

	    this.pushSource(['if (!', this.lastHelper, ') { ', current, ' = ', this.source.functionCall(blockHelperMissing, 'call', params), '}']);
	  },

	  // [appendContent]
	  //
	  // On stack, before: ...
	  // On stack, after: ...
	  //
	  // Appends the string value of `content` to the current buffer
	  appendContent: function appendContent(content) {
	    if (this.pendingContent) {
	      content = this.pendingContent + content;
	    } else {
	      this.pendingLocation = this.source.currentLocation;
	    }

	    this.pendingContent = content;
	  },

	  // [append]
	  //
	  // On stack, before: value, ...
	  // On stack, after: ...
	  //
	  // Coerces `value` to a String and appends it to the current buffer.
	  //
	  // If `value` is truthy, or 0, it is coerced into a string and appended
	  // Otherwise, the empty string is appended
	  append: function append() {
	    if (this.isInline()) {
	      this.replaceStack(function (current) {
	        return [' != null ? ', current, ' : ""'];
	      });

	      this.pushSource(this.appendToBuffer(this.popStack()));
	    } else {
	      var local = this.popStack();
	      this.pushSource(['if (', local, ' != null) { ', this.appendToBuffer(local, undefined, true), ' }']);
	      if (this.environment.isSimple) {
	        this.pushSource(['else { ', this.appendToBuffer("''", undefined, true), ' }']);
	      }
	    }
	  },

	  // [appendEscaped]
	  //
	  // On stack, before: value, ...
	  // On stack, after: ...
	  //
	  // Escape `value` and append it to the buffer
	  appendEscaped: function appendEscaped() {
	    this.pushSource(this.appendToBuffer([this.aliasable('container.escapeExpression'), '(', this.popStack(), ')']));
	  },

	  // [getContext]
	  //
	  // On stack, before: ...
	  // On stack, after: ...
	  // Compiler value, after: lastContext=depth
	  //
	  // Set the value of the `lastContext` compiler value to the depth
	  getContext: function getContext(depth) {
	    this.lastContext = depth;
	  },

	  // [pushContext]
	  //
	  // On stack, before: ...
	  // On stack, after: currentContext, ...
	  //
	  // Pushes the value of the current context onto the stack.
	  pushContext: function pushContext() {
	    this.pushStackLiteral(this.contextName(this.lastContext));
	  },

	  // [lookupOnContext]
	  //
	  // On stack, before: ...
	  // On stack, after: currentContext[name], ...
	  //
	  // Looks up the value of `name` on the current context and pushes
	  // it onto the stack.
	  lookupOnContext: function lookupOnContext(parts, falsy, strict, scoped) {
	    var i = 0;

	    if (!scoped && this.options.compat && !this.lastContext) {
	      // The depthed query is expected to handle the undefined logic for the root level that
	      // is implemented below, so we evaluate that directly in compat mode
	      this.push(this.depthedLookup(parts[i++]));
	    } else {
	      this.pushContext();
	    }

	    this.resolvePath('context', parts, i, falsy, strict);
	  },

	  // [lookupBlockParam]
	  //
	  // On stack, before: ...
	  // On stack, after: blockParam[name], ...
	  //
	  // Looks up the value of `parts` on the given block param and pushes
	  // it onto the stack.
	  lookupBlockParam: function lookupBlockParam(blockParamId, parts) {
	    this.useBlockParams = true;

	    this.push(['blockParams[', blockParamId[0], '][', blockParamId[1], ']']);
	    this.resolvePath('context', parts, 1);
	  },

	  // [lookupData]
	  //
	  // On stack, before: ...
	  // On stack, after: data, ...
	  //
	  // Push the data lookup operator
	  lookupData: function lookupData(depth, parts, strict) {
	    if (!depth) {
	      this.pushStackLiteral('data');
	    } else {
	      this.pushStackLiteral('container.data(data, ' + depth + ')');
	    }

	    this.resolvePath('data', parts, 0, true, strict);
	  },

	  resolvePath: function resolvePath(type, parts, i, falsy, strict) {
	    // istanbul ignore next

	    var _this2 = this;

	    if (this.options.strict || this.options.assumeObjects) {
	      this.push(strictLookup(this.options.strict && strict, this, parts, type));
	      return;
	    }

	    var len = parts.length;
	    for (; i < len; i++) {
	      /* eslint-disable no-loop-func */
	      this.replaceStack(function (current) {
	        var lookup = _this2.nameLookup(current, parts[i], type);
	        // We want to ensure that zero and false are handled properly if the context (falsy flag)
	        // needs to have the special handling for these values.
	        if (!falsy) {
	          return [' != null ? ', lookup, ' : ', current];
	        } else {
	          // Otherwise we can use generic falsy handling
	          return [' && ', lookup];
	        }
	      });
	      /* eslint-enable no-loop-func */
	    }
	  },

	  // [resolvePossibleLambda]
	  //
	  // On stack, before: value, ...
	  // On stack, after: resolved value, ...
	  //
	  // If the `value` is a lambda, replace it on the stack by
	  // the return value of the lambda
	  resolvePossibleLambda: function resolvePossibleLambda() {
	    this.push([this.aliasable('container.lambda'), '(', this.popStack(), ', ', this.contextName(0), ')']);
	  },

	  // [pushStringParam]
	  //
	  // On stack, before: ...
	  // On stack, after: string, currentContext, ...
	  //
	  // This opcode is designed for use in string mode, which
	  // provides the string value of a parameter along with its
	  // depth rather than resolving it immediately.
	  pushStringParam: function pushStringParam(string, type) {
	    this.pushContext();
	    this.pushString(type);

	    // If it's a subexpression, the string result
	    // will be pushed after this opcode.
	    if (type !== 'SubExpression') {
	      if (typeof string === 'string') {
	        this.pushString(string);
	      } else {
	        this.pushStackLiteral(string);
	      }
	    }
	  },

	  emptyHash: function emptyHash(omitEmpty) {
	    if (this.trackIds) {
	      this.push('{}'); // hashIds
	    }
	    if (this.stringParams) {
	      this.push('{}'); // hashContexts
	      this.push('{}'); // hashTypes
	    }
	    this.pushStackLiteral(omitEmpty ? 'undefined' : '{}');
	  },
	  pushHash: function pushHash() {
	    if (this.hash) {
	      this.hashes.push(this.hash);
	    }
	    this.hash = { values: {}, types: [], contexts: [], ids: [] };
	  },
	  popHash: function popHash() {
	    var hash = this.hash;
	    this.hash = this.hashes.pop();

	    if (this.trackIds) {
	      this.push(this.objectLiteral(hash.ids));
	    }
	    if (this.stringParams) {
	      this.push(this.objectLiteral(hash.contexts));
	      this.push(this.objectLiteral(hash.types));
	    }

	    this.push(this.objectLiteral(hash.values));
	  },

	  // [pushString]
	  //
	  // On stack, before: ...
	  // On stack, after: quotedString(string), ...
	  //
	  // Push a quoted version of `string` onto the stack
	  pushString: function pushString(string) {
	    this.pushStackLiteral(this.quotedString(string));
	  },

	  // [pushLiteral]
	  //
	  // On stack, before: ...
	  // On stack, after: value, ...
	  //
	  // Pushes a value onto the stack. This operation prevents
	  // the compiler from creating a temporary variable to hold
	  // it.
	  pushLiteral: function pushLiteral(value) {
	    this.pushStackLiteral(value);
	  },

	  // [pushProgram]
	  //
	  // On stack, before: ...
	  // On stack, after: program(guid), ...
	  //
	  // Push a program expression onto the stack. This takes
	  // a compile-time guid and converts it into a runtime-accessible
	  // expression.
	  pushProgram: function pushProgram(guid) {
	    if (guid != null) {
	      this.pushStackLiteral(this.programExpression(guid));
	    } else {
	      this.pushStackLiteral(null);
	    }
	  },

	  // [registerDecorator]
	  //
	  // On stack, before: hash, program, params..., ...
	  // On stack, after: ...
	  //
	  // Pops off the decorator's parameters, invokes the decorator,
	  // and inserts the decorator into the decorators list.
	  registerDecorator: function registerDecorator(paramSize, name) {
	    var foundDecorator = this.nameLookup('decorators', name, 'decorator'),
	        options = this.setupHelperArgs(name, paramSize);

	    this.decorators.push(['fn = ', this.decorators.functionCall(foundDecorator, '', ['fn', 'props', 'container', options]), ' || fn;']);
	  },

	  // [invokeHelper]
	  //
	  // On stack, before: hash, inverse, program, params..., ...
	  // On stack, after: result of helper invocation
	  //
	  // Pops off the helper's parameters, invokes the helper,
	  // and pushes the helper's return value onto the stack.
	  //
	  // If the helper is not found, `helperMissing` is called.
	  invokeHelper: function invokeHelper(paramSize, name, isSimple) {
	    var nonHelper = this.popStack(),
	        helper = this.setupHelper(paramSize, name);

	    var possibleFunctionCalls = [];

	    if (isSimple) {
	      // direct call to helper
	      possibleFunctionCalls.push(helper.name);
	    }
	    // call a function from the input object
	    possibleFunctionCalls.push(nonHelper);
	    if (!this.options.strict) {
	      possibleFunctionCalls.push(this.aliasable('container.hooks.helperMissing'));
	    }

	    var functionLookupCode = ['(', this.itemsSeparatedBy(possibleFunctionCalls, '||'), ')'];
	    var functionCall = this.source.functionCall(functionLookupCode, 'call', helper.callParams);
	    this.push(functionCall);
	  },

	  itemsSeparatedBy: function itemsSeparatedBy(items, separator) {
	    var result = [];
	    result.push(items[0]);
	    for (var i = 1; i < items.length; i++) {
	      result.push(separator, items[i]);
	    }
	    return result;
	  },
	  // [invokeKnownHelper]
	  //
	  // On stack, before: hash, inverse, program, params..., ...
	  // On stack, after: result of helper invocation
	  //
	  // This operation is used when the helper is known to exist,
	  // so a `helperMissing` fallback is not required.
	  invokeKnownHelper: function invokeKnownHelper(paramSize, name) {
	    var helper = this.setupHelper(paramSize, name);
	    this.push(this.source.functionCall(helper.name, 'call', helper.callParams));
	  },

	  // [invokeAmbiguous]
	  //
	  // On stack, before: hash, inverse, program, params..., ...
	  // On stack, after: result of disambiguation
	  //
	  // This operation is used when an expression like `{{foo}}`
	  // is provided, but we don't know at compile-time whether it
	  // is a helper or a path.
	  //
	  // This operation emits more code than the other options,
	  // and can be avoided by passing the `knownHelpers` and
	  // `knownHelpersOnly` flags at compile-time.
	  invokeAmbiguous: function invokeAmbiguous(name, helperCall) {
	    this.useRegister('helper');

	    var nonHelper = this.popStack();

	    this.emptyHash();
	    var helper = this.setupHelper(0, name, helperCall);

	    var helperName = this.lastHelper = this.nameLookup('helpers', name, 'helper');

	    var lookup = ['(', '(helper = ', helperName, ' || ', nonHelper, ')'];
	    if (!this.options.strict) {
	      lookup[0] = '(helper = ';
	      lookup.push(' != null ? helper : ', this.aliasable('container.hooks.helperMissing'));
	    }

	    this.push(['(', lookup, helper.paramsInit ? ['),(', helper.paramsInit] : [], '),', '(typeof helper === ', this.aliasable('"function"'), ' ? ', this.source.functionCall('helper', 'call', helper.callParams), ' : helper))']);
	  },

	  // [invokePartial]
	  //
	  // On stack, before: context, ...
	  // On stack after: result of partial invocation
	  //
	  // This operation pops off a context, invokes a partial with that context,
	  // and pushes the result of the invocation back.
	  invokePartial: function invokePartial(isDynamic, name, indent) {
	    var params = [],
	        options = this.setupParams(name, 1, params);

	    if (isDynamic) {
	      name = this.popStack();
	      delete options.name;
	    }

	    if (indent) {
	      options.indent = JSON.stringify(indent);
	    }
	    options.helpers = 'helpers';
	    options.partials = 'partials';
	    options.decorators = 'container.decorators';

	    if (!isDynamic) {
	      params.unshift(this.nameLookup('partials', name, 'partial'));
	    } else {
	      params.unshift(name);
	    }

	    if (this.options.compat) {
	      options.depths = 'depths';
	    }
	    options = this.objectLiteral(options);
	    params.push(options);

	    this.push(this.source.functionCall('container.invokePartial', '', params));
	  },

	  // [assignToHash]
	  //
	  // On stack, before: value, ..., hash, ...
	  // On stack, after: ..., hash, ...
	  //
	  // Pops a value off the stack and assigns it to the current hash
	  assignToHash: function assignToHash(key) {
	    var value = this.popStack(),
	        context = undefined,
	        type = undefined,
	        id = undefined;

	    if (this.trackIds) {
	      id = this.popStack();
	    }
	    if (this.stringParams) {
	      type = this.popStack();
	      context = this.popStack();
	    }

	    var hash = this.hash;
	    if (context) {
	      hash.contexts[key] = context;
	    }
	    if (type) {
	      hash.types[key] = type;
	    }
	    if (id) {
	      hash.ids[key] = id;
	    }
	    hash.values[key] = value;
	  },

	  pushId: function pushId(type, name, child) {
	    if (type === 'BlockParam') {
	      this.pushStackLiteral('blockParams[' + name[0] + '].path[' + name[1] + ']' + (child ? ' + ' + JSON.stringify('.' + child) : ''));
	    } else if (type === 'PathExpression') {
	      this.pushString(name);
	    } else if (type === 'SubExpression') {
	      this.pushStackLiteral('true');
	    } else {
	      this.pushStackLiteral('null');
	    }
	  },

	  // HELPERS

	  compiler: JavaScriptCompiler,

	  compileChildren: function compileChildren(environment, options) {
	    var children = environment.children,
	        child = undefined,
	        compiler = undefined;

	    for (var i = 0, l = children.length; i < l; i++) {
	      child = children[i];
	      compiler = new this.compiler(); // eslint-disable-line new-cap

	      var existing = this.matchExistingProgram(child);

	      if (existing == null) {
	        this.context.programs.push(''); // Placeholder to prevent name conflicts for nested children
	        var index = this.context.programs.length;
	        child.index = index;
	        child.name = 'program' + index;
	        this.context.programs[index] = compiler.compile(child, options, this.context, !this.precompile);
	        this.context.decorators[index] = compiler.decorators;
	        this.context.environments[index] = child;

	        this.useDepths = this.useDepths || compiler.useDepths;
	        this.useBlockParams = this.useBlockParams || compiler.useBlockParams;
	        child.useDepths = this.useDepths;
	        child.useBlockParams = this.useBlockParams;
	      } else {
	        child.index = existing.index;
	        child.name = 'program' + existing.index;

	        this.useDepths = this.useDepths || existing.useDepths;
	        this.useBlockParams = this.useBlockParams || existing.useBlockParams;
	      }
	    }
	  },
	  matchExistingProgram: function matchExistingProgram(child) {
	    for (var i = 0, len = this.context.environments.length; i < len; i++) {
	      var environment = this.context.environments[i];
	      if (environment && environment.equals(child)) {
	        return environment;
	      }
	    }
	  },

	  programExpression: function programExpression(guid) {
	    var child = this.environment.children[guid],
	        programParams = [child.index, 'data', child.blockParams];

	    if (this.useBlockParams || this.useDepths) {
	      programParams.push('blockParams');
	    }
	    if (this.useDepths) {
	      programParams.push('depths');
	    }

	    return 'container.program(' + programParams.join(', ') + ')';
	  },

	  useRegister: function useRegister(name) {
	    if (!this.registers[name]) {
	      this.registers[name] = true;
	      this.registers.list.push(name);
	    }
	  },

	  push: function push(expr) {
	    if (!(expr instanceof Literal)) {
	      expr = this.source.wrap(expr);
	    }

	    this.inlineStack.push(expr);
	    return expr;
	  },

	  pushStackLiteral: function pushStackLiteral(item) {
	    this.push(new Literal(item));
	  },

	  pushSource: function pushSource(source) {
	    if (this.pendingContent) {
	      this.source.push(this.appendToBuffer(this.source.quotedString(this.pendingContent), this.pendingLocation));
	      this.pendingContent = undefined;
	    }

	    if (source) {
	      this.source.push(source);
	    }
	  },

	  replaceStack: function replaceStack(callback) {
	    var prefix = ['('],
	        stack = undefined,
	        createdStack = undefined,
	        usedLiteral = undefined;

	    /* istanbul ignore next */
	    if (!this.isInline()) {
	      throw new _exception2['default']('replaceStack on non-inline');
	    }

	    // We want to merge the inline statement into the replacement statement via ','
	    var top = this.popStack(true);

	    if (top instanceof Literal) {
	      // Literals do not need to be inlined
	      stack = [top.value];
	      prefix = ['(', stack];
	      usedLiteral = true;
	    } else {
	      // Get or create the current stack name for use by the inline
	      createdStack = true;
	      var _name = this.incrStack();

	      prefix = ['((', this.push(_name), ' = ', top, ')'];
	      stack = this.topStack();
	    }

	    var item = callback.call(this, stack);

	    if (!usedLiteral) {
	      this.popStack();
	    }
	    if (createdStack) {
	      this.stackSlot--;
	    }
	    this.push(prefix.concat(item, ')'));
	  },

	  incrStack: function incrStack() {
	    this.stackSlot++;
	    if (this.stackSlot > this.stackVars.length) {
	      this.stackVars.push('stack' + this.stackSlot);
	    }
	    return this.topStackName();
	  },
	  topStackName: function topStackName() {
	    return 'stack' + this.stackSlot;
	  },
	  flushInline: function flushInline() {
	    var inlineStack = this.inlineStack;
	    this.inlineStack = [];
	    for (var i = 0, len = inlineStack.length; i < len; i++) {
	      var entry = inlineStack[i];
	      /* istanbul ignore if */
	      if (entry instanceof Literal) {
	        this.compileStack.push(entry);
	      } else {
	        var stack = this.incrStack();
	        this.pushSource([stack, ' = ', entry, ';']);
	        this.compileStack.push(stack);
	      }
	    }
	  },
	  isInline: function isInline() {
	    return this.inlineStack.length;
	  },

	  popStack: function popStack(wrapped) {
	    var inline = this.isInline(),
	        item = (inline ? this.inlineStack : this.compileStack).pop();

	    if (!wrapped && item instanceof Literal) {
	      return item.value;
	    } else {
	      if (!inline) {
	        /* istanbul ignore next */
	        if (!this.stackSlot) {
	          throw new _exception2['default']('Invalid stack pop');
	        }
	        this.stackSlot--;
	      }
	      return item;
	    }
	  },

	  topStack: function topStack() {
	    var stack = this.isInline() ? this.inlineStack : this.compileStack,
	        item = stack[stack.length - 1];

	    /* istanbul ignore if */
	    if (item instanceof Literal) {
	      return item.value;
	    } else {
	      return item;
	    }
	  },

	  contextName: function contextName(context) {
	    if (this.useDepths && context) {
	      return 'depths[' + context + ']';
	    } else {
	      return 'depth' + context;
	    }
	  },

	  quotedString: function quotedString(str) {
	    return this.source.quotedString(str);
	  },

	  objectLiteral: function objectLiteral(obj) {
	    return this.source.objectLiteral(obj);
	  },

	  aliasable: function aliasable(name) {
	    var ret = this.aliases[name];
	    if (ret) {
	      ret.referenceCount++;
	      return ret;
	    }

	    ret = this.aliases[name] = this.source.wrap(name);
	    ret.aliasable = true;
	    ret.referenceCount = 1;

	    return ret;
	  },

	  setupHelper: function setupHelper(paramSize, name, blockHelper) {
	    var params = [],
	        paramsInit = this.setupHelperArgs(name, paramSize, params, blockHelper);
	    var foundHelper = this.nameLookup('helpers', name, 'helper'),
	        callContext = this.aliasable(this.contextName(0) + ' != null ? ' + this.contextName(0) + ' : (container.nullContext || {})');

	    return {
	      params: params,
	      paramsInit: paramsInit,
	      name: foundHelper,
	      callParams: [callContext].concat(params)
	    };
	  },

	  setupParams: function setupParams(helper, paramSize, params) {
	    var options = {},
	        contexts = [],
	        types = [],
	        ids = [],
	        objectArgs = !params,
	        param = undefined;

	    if (objectArgs) {
	      params = [];
	    }

	    options.name = this.quotedString(helper);
	    options.hash = this.popStack();

	    if (this.trackIds) {
	      options.hashIds = this.popStack();
	    }
	    if (this.stringParams) {
	      options.hashTypes = this.popStack();
	      options.hashContexts = this.popStack();
	    }

	    var inverse = this.popStack(),
	        program = this.popStack();

	    // Avoid setting fn and inverse if neither are set. This allows
	    // helpers to do a check for `if (options.fn)`
	    if (program || inverse) {
	      options.fn = program || 'container.noop';
	      options.inverse = inverse || 'container.noop';
	    }

	    // The parameters go on to the stack in order (making sure that they are evaluated in order)
	    // so we need to pop them off the stack in reverse order
	    var i = paramSize;
	    while (i--) {
	      param = this.popStack();
	      params[i] = param;

	      if (this.trackIds) {
	        ids[i] = this.popStack();
	      }
	      if (this.stringParams) {
	        types[i] = this.popStack();
	        contexts[i] = this.popStack();
	      }
	    }

	    if (objectArgs) {
	      options.args = this.source.generateArray(params);
	    }

	    if (this.trackIds) {
	      options.ids = this.source.generateArray(ids);
	    }
	    if (this.stringParams) {
	      options.types = this.source.generateArray(types);
	      options.contexts = this.source.generateArray(contexts);
	    }

	    if (this.options.data) {
	      options.data = 'data';
	    }
	    if (this.useBlockParams) {
	      options.blockParams = 'blockParams';
	    }
	    return options;
	  },

	  setupHelperArgs: function setupHelperArgs(helper, paramSize, params, useRegister) {
	    var options = this.setupParams(helper, paramSize, params);
	    options.loc = JSON.stringify(this.source.currentLocation);
	    options = this.objectLiteral(options);
	    if (useRegister) {
	      this.useRegister('options');
	      params.push('options');
	      return ['options=', options];
	    } else if (params) {
	      params.push(options);
	      return '';
	    } else {
	      return options;
	    }
	  }
	};

	(function () {
	  var reservedWords = ('break else new var' + ' case finally return void' + ' catch for switch while' + ' continue function this with' + ' default if throw' + ' delete in try' + ' do instanceof typeof' + ' abstract enum int short' + ' boolean export interface static' + ' byte extends long super' + ' char final native synchronized' + ' class float package throws' + ' const goto private transient' + ' debugger implements protected volatile' + ' double import public let yield await' + ' null true false').split(' ');

	  var compilerWords = JavaScriptCompiler.RESERVED_WORDS = {};

	  for (var i = 0, l = reservedWords.length; i < l; i++) {
	    compilerWords[reservedWords[i]] = true;
	  }
	})();

	/**
	 * @deprecated May be removed in the next major version
	 */
	JavaScriptCompiler.isValidJavaScriptVariableName = function (name) {
	  return !JavaScriptCompiler.RESERVED_WORDS[name] && /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(name);
	};

	function strictLookup(requireTerminal, compiler, parts, type) {
	  var stack = compiler.popStack(),
	      i = 0,
	      len = parts.length;
	  if (requireTerminal) {
	    len--;
	  }

	  for (; i < len; i++) {
	    stack = compiler.nameLookup(stack, parts[i], type);
	  }

	  if (requireTerminal) {
	    return [compiler.aliasable('container.strict'), '(', stack, ', ', compiler.quotedString(parts[i]), ', ', JSON.stringify(compiler.source.currentLocation), ' )'];
	  } else {
	    return stack;
	  }
	}

	exports['default'] = JavaScriptCompiler;
	module.exports = exports['default'];

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	/* global define */
	'use strict';

	var _Object$keys = __webpack_require__(13)['default'];

	exports.__esModule = true;

	var _utils = __webpack_require__(5);

	var SourceNode = undefined;

	try {
	  /* istanbul ignore next */
	  if (false) {
	    // We don't support this in AMD environments. For these environments, we asusme that
	    // they are running on the browser and thus have no need for the source-map library.
	    var SourceMap = require('source-map');
	    SourceNode = SourceMap.SourceNode;
	  }
	} catch (err) {}
	/* NOP */

	/* istanbul ignore if: tested but not covered in istanbul due to dist build  */
	if (!SourceNode) {
	  SourceNode = function (line, column, srcFile, chunks) {
	    this.src = '';
	    if (chunks) {
	      this.add(chunks);
	    }
	  };
	  /* istanbul ignore next */
	  SourceNode.prototype = {
	    add: function add(chunks) {
	      if (_utils.isArray(chunks)) {
	        chunks = chunks.join('');
	      }
	      this.src += chunks;
	    },
	    prepend: function prepend(chunks) {
	      if (_utils.isArray(chunks)) {
	        chunks = chunks.join('');
	      }
	      this.src = chunks + this.src;
	    },
	    toStringWithSourceMap: function toStringWithSourceMap() {
	      return { code: this.toString() };
	    },
	    toString: function toString() {
	      return this.src;
	    }
	  };
	}

	function castChunk(chunk, codeGen, loc) {
	  if (_utils.isArray(chunk)) {
	    var ret = [];

	    for (var i = 0, len = chunk.length; i < len; i++) {
	      ret.push(codeGen.wrap(chunk[i], loc));
	    }
	    return ret;
	  } else if (typeof chunk === 'boolean' || typeof chunk === 'number') {
	    // Handle primitives that the SourceNode will throw up on
	    return chunk + '';
	  }
	  return chunk;
	}

	function CodeGen(srcFile) {
	  this.srcFile = srcFile;
	  this.source = [];
	}

	CodeGen.prototype = {
	  isEmpty: function isEmpty() {
	    return !this.source.length;
	  },
	  prepend: function prepend(source, loc) {
	    this.source.unshift(this.wrap(source, loc));
	  },
	  push: function push(source, loc) {
	    this.source.push(this.wrap(source, loc));
	  },

	  merge: function merge() {
	    var source = this.empty();
	    this.each(function (line) {
	      source.add(['  ', line, '\n']);
	    });
	    return source;
	  },

	  each: function each(iter) {
	    for (var i = 0, len = this.source.length; i < len; i++) {
	      iter(this.source[i]);
	    }
	  },

	  empty: function empty() {
	    var loc = this.currentLocation || { start: {} };
	    return new SourceNode(loc.start.line, loc.start.column, this.srcFile);
	  },
	  wrap: function wrap(chunk) {
	    var loc = arguments.length <= 1 || arguments[1] === undefined ? this.currentLocation || { start: {} } : arguments[1];

	    if (chunk instanceof SourceNode) {
	      return chunk;
	    }

	    chunk = castChunk(chunk, this, loc);

	    return new SourceNode(loc.start.line, loc.start.column, this.srcFile, chunk);
	  },

	  functionCall: function functionCall(fn, type, params) {
	    params = this.generateList(params);
	    return this.wrap([fn, type ? '.' + type + '(' : '(', params, ')']);
	  },

	  quotedString: function quotedString(str) {
	    return '"' + (str + '').replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\u2028/g, '\\u2028') // Per Ecma-262 7.3 + 7.8.4
	    .replace(/\u2029/g, '\\u2029') + '"';
	  },

	  objectLiteral: function objectLiteral(obj) {
	    // istanbul ignore next

	    var _this = this;

	    var pairs = [];

	    _Object$keys(obj).forEach(function (key) {
	      var value = castChunk(obj[key], _this);
	      if (value !== 'undefined') {
	        pairs.push([_this.quotedString(key), ':', value]);
	      }
	    });

	    var ret = this.generateList(pairs);
	    ret.prepend('{');
	    ret.add('}');
	    return ret;
	  },

	  generateList: function generateList(entries) {
	    var ret = this.empty();

	    for (var i = 0, len = entries.length; i < len; i++) {
	      if (i) {
	        ret.add(',');
	      }

	      ret.add(castChunk(entries[i], this));
	    }

	    return ret;
	  },

	  generateArray: function generateArray(entries) {
	    var ret = this.generateList(entries);
	    ret.prepend('[');
	    ret.add(']');

	    return ret;
	  }
	};

	exports['default'] = CodeGen;
	module.exports = exports['default'];

/***/ })
/******/ ])
});
;
},
'sanitize-html/sanitize-html':function(){
define(["./config", "./sanitize-html-lib"], function (config, sanitizeHtml) {
	sanitizeHtml.default.defaults.allowedTags = config.allowedTags;
	sanitizeHtml.default.defaults.allowedAttributes = config.allowedAttributes;
	sanitizeHtml.default.defaults.nonBooleanAttributes = config.nonBooleanAttributes;
	return sanitizeHtml;
});
},
'sanitize-html/config':function(){
define(["./sanitize-html"], function (sanitizeHtml) {
	const allowedTags = [
		"a", "abbr", "acronym", "address", "applet", "area", "article", 
		"aside", "audio", "b", "base", "basefont", "bdi", "bdo", 
		"bgsound", "big", "blink", "blockquote", "body", "br", "button", 
		"canvas", "caption", "center", "cite", "code", "col", "colgroup", 
		"content", "data", "datalist", "dd", "decorator", "del", "details", 
		"dfn", "dir", "div", "dl", "dt", "element", "em", "embed", 
		"fieldset", "figcaption", "figure", "font", "footer", "form", 
		"frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", 
		"header", "hgroup", "hr", "html", "i", "iframe", "img", "input", 
		"ins", "isindex", "kbd", "keygen", "label", "legend", "li", "link", 
		"listing", "main", "map", "mark", "marquee", "menu", "menuitem", 
		"meta", "meter", "nav", "nobr", "noframes", "noscript", "object", 
		"ol", "optgroup", "option", "output", "p", "param", "plaintext", 
		"pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", 
		"section"
	]
	const nonBooleanAttributes = [
		'abbr', 'accept', 'accept-charset', 'accesskey', 'action',
		'allow', 'alt', 'as', 'autocapitalize', 'autocomplete',
		'blocking', 'charset', 'cite', 'class', 'color', 'cols',
		'colspan', 'content', 'contenteditable', 'coords', 'crossorigin',
		'data', 'datetime', 'decoding', 'dir', 'dirname', 'download',
		'draggable', 'enctype', 'enterkeyhint', 'fetchpriority', 'for',
		'form', 'formaction', 'formenctype', 'formmethod', 'formtarget',
		'headers', 'height', 'hidden', 'high', 'href', 'hreflang',
		'http-equiv', 'id', 'imagesizes', 'imagesrcset', 'inputmode',
		'integrity', 'is', 'itemid', 'itemprop', 'itemref', 'itemtype',
		'kind', 'label', 'lang', 'list', 'loading', 'low', 'max',
		'maxlength', 'media', 'method', 'min', 'minlength', 'name',
		'nonce', 'optimum', 'pattern', 'ping', 'placeholder', 'popover',
		'popovertarget', 'popovertargetaction', 'poster', 'preload',
		'referrerpolicy', 'rel', 'rows', 'rowspan', 'sandbox', 'scope',
		'shape', 'size', 'sizes', 'slot', 'span', 'spellcheck', 'src',
		'srcdoc', 'srclang', 'srcset', 'start', 'step', 'style',
		'tabindex', 'target', 'title', 'translate', 'type', 'usemap',
		'value', 'width', 'wrap',
		// Event handlers
		/*
		'onauxclick', 'onafterprint', 'onbeforematch', 'onbeforeprint',
		'onbeforeunload', 'onbeforetoggle', 'onblur', 'oncancel',
		'oncanplay', 'oncanplaythrough', 'onchange', 'onclick', 'onclose',
		'oncontextlost', 'oncontextmenu', 'oncontextrestored', 'oncopy',
		'oncuechange', 'oncut', 'ondblclick', 'ondrag', 'ondragend',
		'ondragenter', 'ondragleave', 'ondragover', 'ondragstart',
		'ondrop', 'ondurationchange', 'onemptied', 'onended',
		'onerror', 'onfocus', 'onformdata', 'onhashchange', 'oninput',
		'oninvalid', 'onkeydown', 'onkeypress', 'onkeyup',
		'onlanguagechange', 'onload', 'onloadeddata', 'onloadedmetadata',
		'onloadstart', 'onmessage', 'onmessageerror', 'onmousedown',
		'onmouseenter', 'onmouseleave', 'onmousemove', 'onmouseout',
		'onmouseover', 'onmouseup', 'onoffline', 'ononline', 'onpagehide',
		'onpageshow', 'onpaste', 'onpause', 'onplay', 'onplaying',
		'onpopstate', 'onprogress', 'onratechange', 'onreset', 'onresize',
		'onrejectionhandled', 'onscroll', 'onscrollend',
		'onsecuritypolicyviolation', 'onseeked', 'onseeking', 'onselect',
		'onslotchange', 'onstalled', 'onstorage', 'onsubmit', 'onsuspend',
		'ontimeupdate', 'ontoggle', 'onunhandledrejection', 'onunload',
		'onvolumechange', 'onwaiting', 'onwheel'
		*/
	];

	const allowedAttributes = {
		// We don't currently allow img itself by default, but
		// these attributes would make sense if we did.
		"*": ["*"]
	}

	return {allowedTags, allowedAttributes, nonBooleanAttributes};
})
},
'sanitize-html/sanitize-html-lib':function(){
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(self, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/deepmerge/dist/cjs.js":
/*!********************************************!*\
  !*** ./node_modules/deepmerge/dist/cjs.js ***!
  \********************************************/
/***/ ((module) => {

"use strict";


var isMergeableObject = function isMergeableObject(value) {
  return isNonNullObject(value) && !isSpecial(value);
};
function isNonNullObject(value) {
  return !!value && typeof value === 'object';
}
function isSpecial(value) {
  var stringValue = Object.prototype.toString.call(value);
  return stringValue === '[object RegExp]' || stringValue === '[object Date]' || isReactElement(value);
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;
function isReactElement(value) {
  return value.$$typeof === REACT_ELEMENT_TYPE;
}
function emptyTarget(val) {
  return Array.isArray(val) ? [] : {};
}
function cloneUnlessOtherwiseSpecified(value, options) {
  return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
}
function defaultArrayMerge(target, source, options) {
  return target.concat(source).map(function (element) {
    return cloneUnlessOtherwiseSpecified(element, options);
  });
}
function getMergeFunction(key, options) {
  if (!options.customMerge) {
    return deepmerge;
  }
  var customMerge = options.customMerge(key);
  return typeof customMerge === 'function' ? customMerge : deepmerge;
}
function getEnumerableOwnPropertySymbols(target) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function (symbol) {
    return Object.propertyIsEnumerable.call(target, symbol);
  }) : [];
}
function getKeys(target) {
  return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
}
function propertyIsOnObject(object, property) {
  try {
    return property in object;
  } catch (_) {
    return false;
  }
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
  return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
  && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
  && Object.propertyIsEnumerable.call(target, key)); // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
  var destination = {};
  if (options.isMergeableObject(target)) {
    getKeys(target).forEach(function (key) {
      destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
    });
  }
  getKeys(source).forEach(function (key) {
    if (propertyIsUnsafe(target, key)) {
      return;
    }
    if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
      destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
    } else {
      destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
    }
  });
  return destination;
}
function deepmerge(target, source, options) {
  options = options || {};
  options.arrayMerge = options.arrayMerge || defaultArrayMerge;
  options.isMergeableObject = options.isMergeableObject || isMergeableObject;
  // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
  // implementations can use it. The caller may not replace it.
  options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
  var sourceIsArray = Array.isArray(source);
  var targetIsArray = Array.isArray(target);
  var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
  if (!sourceAndTargetTypesMatch) {
    return cloneUnlessOtherwiseSpecified(source, options);
  } else if (sourceIsArray) {
    return options.arrayMerge(target, source, options);
  } else {
    return mergeObject(target, source, options);
  }
}
deepmerge.all = function deepmergeAll(array, options) {
  if (!Array.isArray(array)) {
    throw new Error('first argument should be an array');
  }
  return array.reduce(function (prev, next) {
    return deepmerge(prev, next, options);
  }, {});
};
var deepmerge_1 = deepmerge;
module.exports = deepmerge_1;

/***/ }),

/***/ "./node_modules/dom-serializer/lib/foreignNames.js":
/*!*********************************************************!*\
  !*** ./node_modules/dom-serializer/lib/foreignNames.js ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.attributeNames = exports.elementNames = void 0;
exports.elementNames = new Map(["altGlyph", "altGlyphDef", "altGlyphItem", "animateColor", "animateMotion", "animateTransform", "clipPath", "feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "foreignObject", "glyphRef", "linearGradient", "radialGradient", "textPath"].map(function (val) {
  return [val.toLowerCase(), val];
}));
exports.attributeNames = new Map(["definitionURL", "attributeName", "attributeType", "baseFrequency", "baseProfile", "calcMode", "clipPathUnits", "diffuseConstant", "edgeMode", "filterUnits", "glyphRef", "gradientTransform", "gradientUnits", "kernelMatrix", "kernelUnitLength", "keyPoints", "keySplines", "keyTimes", "lengthAdjust", "limitingConeAngle", "markerHeight", "markerUnits", "markerWidth", "maskContentUnits", "maskUnits", "numOctaves", "pathLength", "patternContentUnits", "patternTransform", "patternUnits", "pointsAtX", "pointsAtY", "pointsAtZ", "preserveAlpha", "preserveAspectRatio", "primitiveUnits", "refX", "refY", "repeatCount", "repeatDur", "requiredExtensions", "requiredFeatures", "specularConstant", "specularExponent", "spreadMethod", "startOffset", "stdDeviation", "stitchTiles", "surfaceScale", "systemLanguage", "tableValues", "targetX", "targetY", "textLength", "viewBox", "viewTarget", "xChannelSelector", "yChannelSelector", "zoomAndPan"].map(function (val) {
  return [val.toLowerCase(), val];
}));

/***/ }),

/***/ "./node_modules/dom-serializer/lib/index.js":
/*!**************************************************!*\
  !*** ./node_modules/dom-serializer/lib/index.js ***!
  \**************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.render = void 0;
/*
 * Module dependencies
 */
var ElementType = __importStar(__webpack_require__(/*! domelementtype */ "./node_modules/domelementtype/lib/index.js"));
var entities_1 = __webpack_require__(/*! entities */ "./node_modules/entities/lib/index.js");
/**
 * Mixed-case SVG and MathML tags & attributes
 * recognized by the HTML parser.
 *
 * @see https://html.spec.whatwg.org/multipage/parsing.html#parsing-main-inforeign
 */
var foreignNames_js_1 = __webpack_require__(/*! ./foreignNames.js */ "./node_modules/dom-serializer/lib/foreignNames.js");
var unencodedElements = new Set(["style", "script", "xmp", "iframe", "noembed", "noframes", "plaintext", "noscript"]);
function replaceQuotes(value) {
  return value.replace(/"/g, "&quot;");
}
/**
 * Format attributes
 */
function formatAttributes(attributes, opts) {
  var _a;
  if (!attributes) return;
  var encode = ((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) === false ? replaceQuotes : opts.xmlMode || opts.encodeEntities !== "utf8" ? entities_1.encodeXML : entities_1.escapeAttribute;
  return Object.keys(attributes).map(function (key) {
    var _a, _b;
    var value = (_a = attributes[key]) !== null && _a !== void 0 ? _a : "";
    if (opts.xmlMode === "foreign") {
      /* Fix up mixed-case attribute names */
      key = (_b = foreignNames_js_1.attributeNames.get(key)) !== null && _b !== void 0 ? _b : key;
    }
    if (!opts.emptyAttrs && !opts.xmlMode && value === "") {
      return key;
    }
    return "".concat(key, "=\"").concat(encode(value), "\"");
  }).join(" ");
}
/**
 * Self-enclosing tags
 */
var singleTag = new Set(["area", "base", "basefont", "br", "col", "command", "embed", "frame", "hr", "img", "input", "isindex", "keygen", "link", "meta", "param", "source", "track", "wbr"]);
/**
 * Renders a DOM node or an array of DOM nodes to a string.
 *
 * Can be thought of as the equivalent of the `outerHTML` of the passed node(s).
 *
 * @param node Node to be rendered.
 * @param options Changes serialization behavior
 */
function render(node, options) {
  if (options === void 0) {
    options = {};
  }
  var nodes = "length" in node ? node : [node];
  var output = "";
  for (var i = 0; i < nodes.length; i++) {
    output += renderNode(nodes[i], options);
  }
  return output;
}
exports.render = render;
exports["default"] = render;
function renderNode(node, options) {
  switch (node.type) {
    case ElementType.Root:
      return render(node.children, options);
    // @ts-expect-error We don't use `Doctype` yet
    case ElementType.Doctype:
    case ElementType.Directive:
      return renderDirective(node);
    case ElementType.Comment:
      return renderComment(node);
    case ElementType.CDATA:
      return renderCdata(node);
    case ElementType.Script:
    case ElementType.Style:
    case ElementType.Tag:
      return renderTag(node, options);
    case ElementType.Text:
      return renderText(node, options);
  }
}
var foreignModeIntegrationPoints = new Set(["mi", "mo", "mn", "ms", "mtext", "annotation-xml", "foreignObject", "desc", "title"]);
var foreignElements = new Set(["svg", "math"]);
function renderTag(elem, opts) {
  var _a;
  // Handle SVG / MathML in HTML
  if (opts.xmlMode === "foreign") {
    /* Fix up mixed-case element names */
    elem.name = (_a = foreignNames_js_1.elementNames.get(elem.name)) !== null && _a !== void 0 ? _a : elem.name;
    /* Exit foreign mode at integration points */
    if (elem.parent && foreignModeIntegrationPoints.has(elem.parent.name)) {
      opts = __assign(__assign({}, opts), {
        xmlMode: false
      });
    }
  }
  if (!opts.xmlMode && foreignElements.has(elem.name)) {
    opts = __assign(__assign({}, opts), {
      xmlMode: "foreign"
    });
  }
  var tag = "<".concat(elem.name);
  var attribs = formatAttributes(elem.attribs, opts);
  if (attribs) {
    tag += " ".concat(attribs);
  }
  if (elem.children.length === 0 && (opts.xmlMode ?
  // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
  opts.selfClosingTags !== false :
  // User explicitly asked for self-closing tags, even in HTML mode
  opts.selfClosingTags && singleTag.has(elem.name))) {
    if (!opts.xmlMode) tag += " ";
    tag += "/>";
  } else {
    tag += ">";
    if (elem.children.length > 0) {
      tag += render(elem.children, opts);
    }
    if (opts.xmlMode || !singleTag.has(elem.name)) {
      tag += "</".concat(elem.name, ">");
    }
  }
  return tag;
}
function renderDirective(elem) {
  return "<".concat(elem.data, ">");
}
function renderText(elem, opts) {
  var _a;
  var data = elem.data || "";
  // If entities weren't decoded, no need to encode them back
  if (((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) !== false && !(!opts.xmlMode && elem.parent && unencodedElements.has(elem.parent.name))) {
    data = opts.xmlMode || opts.encodeEntities !== "utf8" ? (0, entities_1.encodeXML)(data) : (0, entities_1.escapeText)(data);
  }
  return data;
}
function renderCdata(elem) {
  return "<![CDATA[".concat(elem.children[0].data, "]]>");
}
function renderComment(elem) {
  return "<!--".concat(elem.data, "-->");
}

/***/ }),

/***/ "./node_modules/domelementtype/lib/index.js":
/*!**************************************************!*\
  !*** ./node_modules/domelementtype/lib/index.js ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Doctype = exports.CDATA = exports.Tag = exports.Style = exports.Script = exports.Comment = exports.Directive = exports.Text = exports.Root = exports.isTag = exports.ElementType = void 0;
/** Types of elements found in htmlparser2's DOM */
var ElementType;
(function (ElementType) {
  /** Type for the root element of a document */
  ElementType["Root"] = "root";
  /** Type for Text */
  ElementType["Text"] = "text";
  /** Type for <? ... ?> */
  ElementType["Directive"] = "directive";
  /** Type for <!-- ... --> */
  ElementType["Comment"] = "comment";
  /** Type for <script> tags */
  ElementType["Script"] = "script";
  /** Type for <style> tags */
  ElementType["Style"] = "style";
  /** Type for Any tag */
  ElementType["Tag"] = "tag";
  /** Type for <![CDATA[ ... ]]> */
  ElementType["CDATA"] = "cdata";
  /** Type for <!doctype ...> */
  ElementType["Doctype"] = "doctype";
})(ElementType = exports.ElementType || (exports.ElementType = {}));
/**
 * Tests whether an element is a tag or not.
 *
 * @param elem Element to test
 */
function isTag(elem) {
  return elem.type === ElementType.Tag || elem.type === ElementType.Script || elem.type === ElementType.Style;
}
exports.isTag = isTag;
// Exports for backwards compatibility
/** Type for the root element of a document */
exports.Root = ElementType.Root;
/** Type for Text */
exports.Text = ElementType.Text;
/** Type for <? ... ?> */
exports.Directive = ElementType.Directive;
/** Type for <!-- ... --> */
exports.Comment = ElementType.Comment;
/** Type for <script> tags */
exports.Script = ElementType.Script;
/** Type for <style> tags */
exports.Style = ElementType.Style;
/** Type for Any tag */
exports.Tag = ElementType.Tag;
/** Type for <![CDATA[ ... ]]> */
exports.CDATA = ElementType.CDATA;
/** Type for <!doctype ...> */
exports.Doctype = ElementType.Doctype;

/***/ }),

/***/ "./node_modules/domhandler/lib/index.js":
/*!**********************************************!*\
  !*** ./node_modules/domhandler/lib/index.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.DomHandler = void 0;
var domelementtype_1 = __webpack_require__(/*! domelementtype */ "./node_modules/domelementtype/lib/index.js");
var node_js_1 = __webpack_require__(/*! ./node.js */ "./node_modules/domhandler/lib/node.js");
__exportStar(__webpack_require__(/*! ./node.js */ "./node_modules/domhandler/lib/node.js"), exports);
// Default options
var defaultOpts = {
  withStartIndices: false,
  withEndIndices: false,
  xmlMode: false
};
var DomHandler = /** @class */function () {
  /**
   * @param callback Called once parsing has completed.
   * @param options Settings for the handler.
   * @param elementCB Callback whenever a tag is closed.
   */
  function DomHandler(callback, options, elementCB) {
    /** The elements of the DOM */
    this.dom = [];
    /** The root element for the DOM */
    this.root = new node_js_1.Document(this.dom);
    /** Indicated whether parsing has been completed. */
    this.done = false;
    /** Stack of open tags. */
    this.tagStack = [this.root];
    /** A data node that is still being written to. */
    this.lastNode = null;
    /** Reference to the parser instance. Used for location information. */
    this.parser = null;
    // Make it possible to skip arguments, for backwards-compatibility
    if (typeof options === "function") {
      elementCB = options;
      options = defaultOpts;
    }
    if (typeof callback === "object") {
      options = callback;
      callback = undefined;
    }
    this.callback = callback !== null && callback !== void 0 ? callback : null;
    this.options = options !== null && options !== void 0 ? options : defaultOpts;
    this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
  }
  DomHandler.prototype.onparserinit = function (parser) {
    this.parser = parser;
  };
  // Resets the handler back to starting state
  DomHandler.prototype.onreset = function () {
    this.dom = [];
    this.root = new node_js_1.Document(this.dom);
    this.done = false;
    this.tagStack = [this.root];
    this.lastNode = null;
    this.parser = null;
  };
  // Signals the handler that parsing is done
  DomHandler.prototype.onend = function () {
    if (this.done) return;
    this.done = true;
    this.parser = null;
    this.handleCallback(null);
  };
  DomHandler.prototype.onerror = function (error) {
    this.handleCallback(error);
  };
  DomHandler.prototype.onclosetag = function () {
    this.lastNode = null;
    var elem = this.tagStack.pop();
    if (this.options.withEndIndices) {
      elem.endIndex = this.parser.endIndex;
    }
    if (this.elementCB) this.elementCB(elem);
  };
  DomHandler.prototype.onopentag = function (name, attribs) {
    var type = this.options.xmlMode ? domelementtype_1.ElementType.Tag : undefined;
    var element = new node_js_1.Element(name, attribs, undefined, type);
    this.addNode(element);
    this.tagStack.push(element);
  };
  DomHandler.prototype.ontext = function (data) {
    var lastNode = this.lastNode;
    if (lastNode && lastNode.type === domelementtype_1.ElementType.Text) {
      lastNode.data += data;
      if (this.options.withEndIndices) {
        lastNode.endIndex = this.parser.endIndex;
      }
    } else {
      var node = new node_js_1.Text(data);
      this.addNode(node);
      this.lastNode = node;
    }
  };
  DomHandler.prototype.oncomment = function (data) {
    if (this.lastNode && this.lastNode.type === domelementtype_1.ElementType.Comment) {
      this.lastNode.data += data;
      return;
    }
    var node = new node_js_1.Comment(data);
    this.addNode(node);
    this.lastNode = node;
  };
  DomHandler.prototype.oncommentend = function () {
    this.lastNode = null;
  };
  DomHandler.prototype.oncdatastart = function () {
    var text = new node_js_1.Text("");
    var node = new node_js_1.CDATA([text]);
    this.addNode(node);
    text.parent = node;
    this.lastNode = text;
  };
  DomHandler.prototype.oncdataend = function () {
    this.lastNode = null;
  };
  DomHandler.prototype.onprocessinginstruction = function (name, data) {
    var node = new node_js_1.ProcessingInstruction(name, data);
    this.addNode(node);
  };
  DomHandler.prototype.handleCallback = function (error) {
    if (typeof this.callback === "function") {
      this.callback(error, this.dom);
    } else if (error) {
      throw error;
    }
  };
  DomHandler.prototype.addNode = function (node) {
    var parent = this.tagStack[this.tagStack.length - 1];
    var previousSibling = parent.children[parent.children.length - 1];
    if (this.options.withStartIndices) {
      node.startIndex = this.parser.startIndex;
    }
    if (this.options.withEndIndices) {
      node.endIndex = this.parser.endIndex;
    }
    parent.children.push(node);
    if (previousSibling) {
      node.prev = previousSibling;
      previousSibling.next = node;
    }
    node.parent = parent;
    this.lastNode = null;
  };
  return DomHandler;
}();
exports.DomHandler = DomHandler;
exports["default"] = DomHandler;

/***/ }),

/***/ "./node_modules/domhandler/lib/node.js":
/*!*********************************************!*\
  !*** ./node_modules/domhandler/lib/node.js ***!
  \*********************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.cloneNode = exports.hasChildren = exports.isDocument = exports.isDirective = exports.isComment = exports.isText = exports.isCDATA = exports.isTag = exports.Element = exports.Document = exports.CDATA = exports.NodeWithChildren = exports.ProcessingInstruction = exports.Comment = exports.Text = exports.DataNode = exports.Node = void 0;
var domelementtype_1 = __webpack_require__(/*! domelementtype */ "./node_modules/domelementtype/lib/index.js");
/**
 * This object will be used as the prototype for Nodes when creating a
 * DOM-Level-1-compliant structure.
 */
var Node = /** @class */function () {
  function Node() {
    /** Parent of the node */
    this.parent = null;
    /** Previous sibling */
    this.prev = null;
    /** Next sibling */
    this.next = null;
    /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */
    this.startIndex = null;
    /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */
    this.endIndex = null;
  }
  Object.defineProperty(Node.prototype, "parentNode", {
    // Read-write aliases for properties
    /**
     * Same as {@link parent}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */
    get: function () {
      return this.parent;
    },
    set: function (parent) {
      this.parent = parent;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Node.prototype, "previousSibling", {
    /**
     * Same as {@link prev}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */
    get: function () {
      return this.prev;
    },
    set: function (prev) {
      this.prev = prev;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Node.prototype, "nextSibling", {
    /**
     * Same as {@link next}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */
    get: function () {
      return this.next;
    },
    set: function (next) {
      this.next = next;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * Clone this node, and optionally its children.
   *
   * @param recursive Clone child nodes as well.
   * @returns A clone of the node.
   */
  Node.prototype.cloneNode = function (recursive) {
    if (recursive === void 0) {
      recursive = false;
    }
    return cloneNode(this, recursive);
  };
  return Node;
}();
exports.Node = Node;
/**
 * A node that contains some data.
 */
var DataNode = /** @class */function (_super) {
  __extends(DataNode, _super);
  /**
   * @param data The content of the data node
   */
  function DataNode(data) {
    var _this = _super.call(this) || this;
    _this.data = data;
    return _this;
  }
  Object.defineProperty(DataNode.prototype, "nodeValue", {
    /**
     * Same as {@link data}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */
    get: function () {
      return this.data;
    },
    set: function (data) {
      this.data = data;
    },
    enumerable: false,
    configurable: true
  });
  return DataNode;
}(Node);
exports.DataNode = DataNode;
/**
 * Text within the document.
 */
var Text = /** @class */function (_super) {
  __extends(Text, _super);
  function Text() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.type = domelementtype_1.ElementType.Text;
    return _this;
  }
  Object.defineProperty(Text.prototype, "nodeType", {
    get: function () {
      return 3;
    },
    enumerable: false,
    configurable: true
  });
  return Text;
}(DataNode);
exports.Text = Text;
/**
 * Comments within the document.
 */
var Comment = /** @class */function (_super) {
  __extends(Comment, _super);
  function Comment() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.type = domelementtype_1.ElementType.Comment;
    return _this;
  }
  Object.defineProperty(Comment.prototype, "nodeType", {
    get: function () {
      return 8;
    },
    enumerable: false,
    configurable: true
  });
  return Comment;
}(DataNode);
exports.Comment = Comment;
/**
 * Processing instructions, including doc types.
 */
var ProcessingInstruction = /** @class */function (_super) {
  __extends(ProcessingInstruction, _super);
  function ProcessingInstruction(name, data) {
    var _this = _super.call(this, data) || this;
    _this.name = name;
    _this.type = domelementtype_1.ElementType.Directive;
    return _this;
  }
  Object.defineProperty(ProcessingInstruction.prototype, "nodeType", {
    get: function () {
      return 1;
    },
    enumerable: false,
    configurable: true
  });
  return ProcessingInstruction;
}(DataNode);
exports.ProcessingInstruction = ProcessingInstruction;
/**
 * A `Node` that can have children.
 */
var NodeWithChildren = /** @class */function (_super) {
  __extends(NodeWithChildren, _super);
  /**
   * @param children Children of the node. Only certain node types can have children.
   */
  function NodeWithChildren(children) {
    var _this = _super.call(this) || this;
    _this.children = children;
    return _this;
  }
  Object.defineProperty(NodeWithChildren.prototype, "firstChild", {
    // Aliases
    /** First child of the node. */
    get: function () {
      var _a;
      return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(NodeWithChildren.prototype, "lastChild", {
    /** Last child of the node. */
    get: function () {
      return this.children.length > 0 ? this.children[this.children.length - 1] : null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(NodeWithChildren.prototype, "childNodes", {
    /**
     * Same as {@link children}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */
    get: function () {
      return this.children;
    },
    set: function (children) {
      this.children = children;
    },
    enumerable: false,
    configurable: true
  });
  return NodeWithChildren;
}(Node);
exports.NodeWithChildren = NodeWithChildren;
var CDATA = /** @class */function (_super) {
  __extends(CDATA, _super);
  function CDATA() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.type = domelementtype_1.ElementType.CDATA;
    return _this;
  }
  Object.defineProperty(CDATA.prototype, "nodeType", {
    get: function () {
      return 4;
    },
    enumerable: false,
    configurable: true
  });
  return CDATA;
}(NodeWithChildren);
exports.CDATA = CDATA;
/**
 * The root node of the document.
 */
var Document = /** @class */function (_super) {
  __extends(Document, _super);
  function Document() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.type = domelementtype_1.ElementType.Root;
    return _this;
  }
  Object.defineProperty(Document.prototype, "nodeType", {
    get: function () {
      return 9;
    },
    enumerable: false,
    configurable: true
  });
  return Document;
}(NodeWithChildren);
exports.Document = Document;
/**
 * An element within the DOM.
 */
var Element = /** @class */function (_super) {
  __extends(Element, _super);
  /**
   * @param name Name of the tag, eg. `div`, `span`.
   * @param attribs Object mapping attribute names to attribute values.
   * @param children Children of the node.
   */
  function Element(name, attribs, children, type) {
    if (children === void 0) {
      children = [];
    }
    if (type === void 0) {
      type = name === "script" ? domelementtype_1.ElementType.Script : name === "style" ? domelementtype_1.ElementType.Style : domelementtype_1.ElementType.Tag;
    }
    var _this = _super.call(this, children) || this;
    _this.name = name;
    _this.attribs = attribs;
    _this.type = type;
    return _this;
  }
  Object.defineProperty(Element.prototype, "nodeType", {
    get: function () {
      return 1;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Element.prototype, "tagName", {
    // DOM Level 1 aliases
    /**
     * Same as {@link name}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */
    get: function () {
      return this.name;
    },
    set: function (name) {
      this.name = name;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Element.prototype, "attributes", {
    get: function () {
      var _this = this;
      return Object.keys(this.attribs).map(function (name) {
        var _a, _b;
        return {
          name: name,
          value: _this.attribs[name],
          namespace: (_a = _this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
          prefix: (_b = _this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
        };
      });
    },
    enumerable: false,
    configurable: true
  });
  return Element;
}(NodeWithChildren);
exports.Element = Element;
/**
 * @param node Node to check.
 * @returns `true` if the node is a `Element`, `false` otherwise.
 */
function isTag(node) {
  return (0, domelementtype_1.isTag)(node);
}
exports.isTag = isTag;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `CDATA`, `false` otherwise.
 */
function isCDATA(node) {
  return node.type === domelementtype_1.ElementType.CDATA;
}
exports.isCDATA = isCDATA;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Text`, `false` otherwise.
 */
function isText(node) {
  return node.type === domelementtype_1.ElementType.Text;
}
exports.isText = isText;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Comment`, `false` otherwise.
 */
function isComment(node) {
  return node.type === domelementtype_1.ElementType.Comment;
}
exports.isComment = isComment;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */
function isDirective(node) {
  return node.type === domelementtype_1.ElementType.Directive;
}
exports.isDirective = isDirective;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */
function isDocument(node) {
  return node.type === domelementtype_1.ElementType.Root;
}
exports.isDocument = isDocument;
/**
 * @param node Node to check.
 * @returns `true` if the node has children, `false` otherwise.
 */
function hasChildren(node) {
  return Object.prototype.hasOwnProperty.call(node, "children");
}
exports.hasChildren = hasChildren;
/**
 * Clone a node, and optionally its children.
 *
 * @param recursive Clone child nodes as well.
 * @returns A clone of the node.
 */
function cloneNode(node, recursive) {
  if (recursive === void 0) {
    recursive = false;
  }
  var result;
  if (isText(node)) {
    result = new Text(node.data);
  } else if (isComment(node)) {
    result = new Comment(node.data);
  } else if (isTag(node)) {
    var children = recursive ? cloneChildren(node.children) : [];
    var clone_1 = new Element(node.name, __assign({}, node.attribs), children);
    children.forEach(function (child) {
      return child.parent = clone_1;
    });
    if (node.namespace != null) {
      clone_1.namespace = node.namespace;
    }
    if (node["x-attribsNamespace"]) {
      clone_1["x-attribsNamespace"] = __assign({}, node["x-attribsNamespace"]);
    }
    if (node["x-attribsPrefix"]) {
      clone_1["x-attribsPrefix"] = __assign({}, node["x-attribsPrefix"]);
    }
    result = clone_1;
  } else if (isCDATA(node)) {
    var children = recursive ? cloneChildren(node.children) : [];
    var clone_2 = new CDATA(children);
    children.forEach(function (child) {
      return child.parent = clone_2;
    });
    result = clone_2;
  } else if (isDocument(node)) {
    var children = recursive ? cloneChildren(node.children) : [];
    var clone_3 = new Document(children);
    children.forEach(function (child) {
      return child.parent = clone_3;
    });
    if (node["x-mode"]) {
      clone_3["x-mode"] = node["x-mode"];
    }
    result = clone_3;
  } else if (isDirective(node)) {
    var instruction = new ProcessingInstruction(node.name, node.data);
    if (node["x-name"] != null) {
      instruction["x-name"] = node["x-name"];
      instruction["x-publicId"] = node["x-publicId"];
      instruction["x-systemId"] = node["x-systemId"];
    }
    result = instruction;
  } else {
    throw new Error("Not implemented yet: ".concat(node.type));
  }
  result.startIndex = node.startIndex;
  result.endIndex = node.endIndex;
  if (node.sourceCodeLocation != null) {
    result.sourceCodeLocation = node.sourceCodeLocation;
  }
  return result;
}
exports.cloneNode = cloneNode;
function cloneChildren(childs) {
  var children = childs.map(function (child) {
    return cloneNode(child, true);
  });
  for (var i = 1; i < children.length; i++) {
    children[i].prev = children[i - 1];
    children[i - 1].next = children[i];
  }
  return children;
}

/***/ }),

/***/ "./node_modules/domutils/lib/feeds.js":
/*!********************************************!*\
  !*** ./node_modules/domutils/lib/feeds.js ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getFeed = void 0;
var stringify_js_1 = __webpack_require__(/*! ./stringify.js */ "./node_modules/domutils/lib/stringify.js");
var legacy_js_1 = __webpack_require__(/*! ./legacy.js */ "./node_modules/domutils/lib/legacy.js");
/**
 * Get the feed object from the root of a DOM tree.
 *
 * @category Feeds
 * @param doc - The DOM to to extract the feed from.
 * @returns The feed.
 */
function getFeed(doc) {
  var feedRoot = getOneElement(isValidFeed, doc);
  return !feedRoot ? null : feedRoot.name === "feed" ? getAtomFeed(feedRoot) : getRssFeed(feedRoot);
}
exports.getFeed = getFeed;
/**
 * Parse an Atom feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */
function getAtomFeed(feedRoot) {
  var _a;
  var childs = feedRoot.children;
  var feed = {
    type: "atom",
    items: (0, legacy_js_1.getElementsByTagName)("entry", childs).map(function (item) {
      var _a;
      var children = item.children;
      var entry = {
        media: getMediaElements(children)
      };
      addConditionally(entry, "id", "id", children);
      addConditionally(entry, "title", "title", children);
      var href = (_a = getOneElement("link", children)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
      if (href) {
        entry.link = href;
      }
      var description = fetch("summary", children) || fetch("content", children);
      if (description) {
        entry.description = description;
      }
      var pubDate = fetch("updated", children);
      if (pubDate) {
        entry.pubDate = new Date(pubDate);
      }
      return entry;
    })
  };
  addConditionally(feed, "id", "id", childs);
  addConditionally(feed, "title", "title", childs);
  var href = (_a = getOneElement("link", childs)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
  if (href) {
    feed.link = href;
  }
  addConditionally(feed, "description", "subtitle", childs);
  var updated = fetch("updated", childs);
  if (updated) {
    feed.updated = new Date(updated);
  }
  addConditionally(feed, "author", "email", childs, true);
  return feed;
}
/**
 * Parse a RSS feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */
function getRssFeed(feedRoot) {
  var _a, _b;
  var childs = (_b = (_a = getOneElement("channel", feedRoot.children)) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : [];
  var feed = {
    type: feedRoot.name.substr(0, 3),
    id: "",
    items: (0, legacy_js_1.getElementsByTagName)("item", feedRoot.children).map(function (item) {
      var children = item.children;
      var entry = {
        media: getMediaElements(children)
      };
      addConditionally(entry, "id", "guid", children);
      addConditionally(entry, "title", "title", children);
      addConditionally(entry, "link", "link", children);
      addConditionally(entry, "description", "description", children);
      var pubDate = fetch("pubDate", children) || fetch("dc:date", children);
      if (pubDate) entry.pubDate = new Date(pubDate);
      return entry;
    })
  };
  addConditionally(feed, "title", "title", childs);
  addConditionally(feed, "link", "link", childs);
  addConditionally(feed, "description", "description", childs);
  var updated = fetch("lastBuildDate", childs);
  if (updated) {
    feed.updated = new Date(updated);
  }
  addConditionally(feed, "author", "managingEditor", childs, true);
  return feed;
}
var MEDIA_KEYS_STRING = ["url", "type", "lang"];
var MEDIA_KEYS_INT = ["fileSize", "bitrate", "framerate", "samplingrate", "channels", "duration", "height", "width"];
/**
 * Get all media elements of a feed item.
 *
 * @param where Nodes to search in.
 * @returns Media elements.
 */
function getMediaElements(where) {
  return (0, legacy_js_1.getElementsByTagName)("media:content", where).map(function (elem) {
    var attribs = elem.attribs;
    var media = {
      medium: attribs["medium"],
      isDefault: !!attribs["isDefault"]
    };
    for (var _i = 0, MEDIA_KEYS_STRING_1 = MEDIA_KEYS_STRING; _i < MEDIA_KEYS_STRING_1.length; _i++) {
      var attrib = MEDIA_KEYS_STRING_1[_i];
      if (attribs[attrib]) {
        media[attrib] = attribs[attrib];
      }
    }
    for (var _a = 0, MEDIA_KEYS_INT_1 = MEDIA_KEYS_INT; _a < MEDIA_KEYS_INT_1.length; _a++) {
      var attrib = MEDIA_KEYS_INT_1[_a];
      if (attribs[attrib]) {
        media[attrib] = parseInt(attribs[attrib], 10);
      }
    }
    if (attribs["expression"]) {
      media.expression = attribs["expression"];
    }
    return media;
  });
}
/**
 * Get one element by tag name.
 *
 * @param tagName Tag name to look for
 * @param node Node to search in
 * @returns The element or null
 */
function getOneElement(tagName, node) {
  return (0, legacy_js_1.getElementsByTagName)(tagName, node, true, 1)[0];
}
/**
 * Get the text content of an element with a certain tag name.
 *
 * @param tagName Tag name to look for.
 * @param where Node to search in.
 * @param recurse Whether to recurse into child nodes.
 * @returns The text content of the element.
 */
function fetch(tagName, where, recurse) {
  if (recurse === void 0) {
    recurse = false;
  }
  return (0, stringify_js_1.textContent)((0, legacy_js_1.getElementsByTagName)(tagName, where, recurse, 1)).trim();
}
/**
 * Adds a property to an object if it has a value.
 *
 * @param obj Object to be extended
 * @param prop Property name
 * @param tagName Tag name that contains the conditionally added property
 * @param where Element to search for the property
 * @param recurse Whether to recurse into child nodes.
 */
function addConditionally(obj, prop, tagName, where, recurse) {
  if (recurse === void 0) {
    recurse = false;
  }
  var val = fetch(tagName, where, recurse);
  if (val) obj[prop] = val;
}
/**
 * Checks if an element is a feed root node.
 *
 * @param value The name of the element to check.
 * @returns Whether an element is a feed root node.
 */
function isValidFeed(value) {
  return value === "rss" || value === "feed" || value === "rdf:RDF";
}

/***/ }),

/***/ "./node_modules/domutils/lib/helpers.js":
/*!**********************************************!*\
  !*** ./node_modules/domutils/lib/helpers.js ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.uniqueSort = exports.compareDocumentPosition = exports.DocumentPosition = exports.removeSubsets = void 0;
var domhandler_1 = __webpack_require__(/*! domhandler */ "./node_modules/domhandler/lib/index.js");
/**
 * Given an array of nodes, remove any member that is contained by another
 * member.
 *
 * @category Helpers
 * @param nodes Nodes to filter.
 * @returns Remaining nodes that aren't contained by other nodes.
 */
function removeSubsets(nodes) {
  var idx = nodes.length;
  /*
   * Check if each node (or one of its ancestors) is already contained in the
   * array.
   */
  while (--idx >= 0) {
    var node = nodes[idx];
    /*
     * Remove the node if it is not unique.
     * We are going through the array from the end, so we only
     * have to check nodes that preceed the node under consideration in the array.
     */
    if (idx > 0 && nodes.lastIndexOf(node, idx - 1) >= 0) {
      nodes.splice(idx, 1);
      continue;
    }
    for (var ancestor = node.parent; ancestor; ancestor = ancestor.parent) {
      if (nodes.includes(ancestor)) {
        nodes.splice(idx, 1);
        break;
      }
    }
  }
  return nodes;
}
exports.removeSubsets = removeSubsets;
/**
 * @category Helpers
 * @see {@link http://dom.spec.whatwg.org/#dom-node-comparedocumentposition}
 */
var DocumentPosition;
(function (DocumentPosition) {
  DocumentPosition[DocumentPosition["DISCONNECTED"] = 1] = "DISCONNECTED";
  DocumentPosition[DocumentPosition["PRECEDING"] = 2] = "PRECEDING";
  DocumentPosition[DocumentPosition["FOLLOWING"] = 4] = "FOLLOWING";
  DocumentPosition[DocumentPosition["CONTAINS"] = 8] = "CONTAINS";
  DocumentPosition[DocumentPosition["CONTAINED_BY"] = 16] = "CONTAINED_BY";
})(DocumentPosition = exports.DocumentPosition || (exports.DocumentPosition = {}));
/**
 * Compare the position of one node against another node in any other document,
 * returning a bitmask with the values from {@link DocumentPosition}.
 *
 * Document order:
 * > There is an ordering, document order, defined on all the nodes in the
 * > document corresponding to the order in which the first character of the
 * > XML representation of each node occurs in the XML representation of the
 * > document after expansion of general entities. Thus, the document element
 * > node will be the first node. Element nodes occur before their children.
 * > Thus, document order orders element nodes in order of the occurrence of
 * > their start-tag in the XML (after expansion of entities). The attribute
 * > nodes of an element occur after the element and before its children. The
 * > relative order of attribute nodes is implementation-dependent.
 *
 * Source:
 * http://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-document-order
 *
 * @category Helpers
 * @param nodeA The first node to use in the comparison
 * @param nodeB The second node to use in the comparison
 * @returns A bitmask describing the input nodes' relative position.
 *
 * See http://dom.spec.whatwg.org/#dom-node-comparedocumentposition for
 * a description of these values.
 */
function compareDocumentPosition(nodeA, nodeB) {
  var aParents = [];
  var bParents = [];
  if (nodeA === nodeB) {
    return 0;
  }
  var current = (0, domhandler_1.hasChildren)(nodeA) ? nodeA : nodeA.parent;
  while (current) {
    aParents.unshift(current);
    current = current.parent;
  }
  current = (0, domhandler_1.hasChildren)(nodeB) ? nodeB : nodeB.parent;
  while (current) {
    bParents.unshift(current);
    current = current.parent;
  }
  var maxIdx = Math.min(aParents.length, bParents.length);
  var idx = 0;
  while (idx < maxIdx && aParents[idx] === bParents[idx]) {
    idx++;
  }
  if (idx === 0) {
    return DocumentPosition.DISCONNECTED;
  }
  var sharedParent = aParents[idx - 1];
  var siblings = sharedParent.children;
  var aSibling = aParents[idx];
  var bSibling = bParents[idx];
  if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
    if (sharedParent === nodeB) {
      return DocumentPosition.FOLLOWING | DocumentPosition.CONTAINED_BY;
    }
    return DocumentPosition.FOLLOWING;
  }
  if (sharedParent === nodeA) {
    return DocumentPosition.PRECEDING | DocumentPosition.CONTAINS;
  }
  return DocumentPosition.PRECEDING;
}
exports.compareDocumentPosition = compareDocumentPosition;
/**
 * Sort an array of nodes based on their relative position in the document,
 * removing any duplicate nodes. If the array contains nodes that do not belong
 * to the same document, sort order is unspecified.
 *
 * @category Helpers
 * @param nodes Array of DOM nodes.
 * @returns Collection of unique nodes, sorted in document order.
 */
function uniqueSort(nodes) {
  nodes = nodes.filter(function (node, i, arr) {
    return !arr.includes(node, i + 1);
  });
  nodes.sort(function (a, b) {
    var relative = compareDocumentPosition(a, b);
    if (relative & DocumentPosition.PRECEDING) {
      return -1;
    } else if (relative & DocumentPosition.FOLLOWING) {
      return 1;
    }
    return 0;
  });
  return nodes;
}
exports.uniqueSort = uniqueSort;

/***/ }),

/***/ "./node_modules/domutils/lib/index.js":
/*!********************************************!*\
  !*** ./node_modules/domutils/lib/index.js ***!
  \********************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.hasChildren = exports.isDocument = exports.isComment = exports.isText = exports.isCDATA = exports.isTag = void 0;
__exportStar(__webpack_require__(/*! ./stringify.js */ "./node_modules/domutils/lib/stringify.js"), exports);
__exportStar(__webpack_require__(/*! ./traversal.js */ "./node_modules/domutils/lib/traversal.js"), exports);
__exportStar(__webpack_require__(/*! ./manipulation.js */ "./node_modules/domutils/lib/manipulation.js"), exports);
__exportStar(__webpack_require__(/*! ./querying.js */ "./node_modules/domutils/lib/querying.js"), exports);
__exportStar(__webpack_require__(/*! ./legacy.js */ "./node_modules/domutils/lib/legacy.js"), exports);
__exportStar(__webpack_require__(/*! ./helpers.js */ "./node_modules/domutils/lib/helpers.js"), exports);
__exportStar(__webpack_require__(/*! ./feeds.js */ "./node_modules/domutils/lib/feeds.js"), exports);
/** @deprecated Use these methods from `domhandler` directly. */
var domhandler_1 = __webpack_require__(/*! domhandler */ "./node_modules/domhandler/lib/index.js");
Object.defineProperty(exports, "isTag", ({
  enumerable: true,
  get: function () {
    return domhandler_1.isTag;
  }
}));
Object.defineProperty(exports, "isCDATA", ({
  enumerable: true,
  get: function () {
    return domhandler_1.isCDATA;
  }
}));
Object.defineProperty(exports, "isText", ({
  enumerable: true,
  get: function () {
    return domhandler_1.isText;
  }
}));
Object.defineProperty(exports, "isComment", ({
  enumerable: true,
  get: function () {
    return domhandler_1.isComment;
  }
}));
Object.defineProperty(exports, "isDocument", ({
  enumerable: true,
  get: function () {
    return domhandler_1.isDocument;
  }
}));
Object.defineProperty(exports, "hasChildren", ({
  enumerable: true,
  get: function () {
    return domhandler_1.hasChildren;
  }
}));

/***/ }),

/***/ "./node_modules/domutils/lib/legacy.js":
/*!*********************************************!*\
  !*** ./node_modules/domutils/lib/legacy.js ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getElementsByTagType = exports.getElementsByTagName = exports.getElementById = exports.getElements = exports.testElement = void 0;
var domhandler_1 = __webpack_require__(/*! domhandler */ "./node_modules/domhandler/lib/index.js");
var querying_js_1 = __webpack_require__(/*! ./querying.js */ "./node_modules/domutils/lib/querying.js");
/**
 * A map of functions to check nodes against.
 */
var Checks = {
  tag_name: function (name) {
    if (typeof name === "function") {
      return function (elem) {
        return (0, domhandler_1.isTag)(elem) && name(elem.name);
      };
    } else if (name === "*") {
      return domhandler_1.isTag;
    }
    return function (elem) {
      return (0, domhandler_1.isTag)(elem) && elem.name === name;
    };
  },
  tag_type: function (type) {
    if (typeof type === "function") {
      return function (elem) {
        return type(elem.type);
      };
    }
    return function (elem) {
      return elem.type === type;
    };
  },
  tag_contains: function (data) {
    if (typeof data === "function") {
      return function (elem) {
        return (0, domhandler_1.isText)(elem) && data(elem.data);
      };
    }
    return function (elem) {
      return (0, domhandler_1.isText)(elem) && elem.data === data;
    };
  }
};
/**
 * Returns a function to check whether a node has an attribute with a particular
 * value.
 *
 * @param attrib Attribute to check.
 * @param value Attribute value to look for.
 * @returns A function to check whether the a node has an attribute with a
 *   particular value.
 */
function getAttribCheck(attrib, value) {
  if (typeof value === "function") {
    return function (elem) {
      return (0, domhandler_1.isTag)(elem) && value(elem.attribs[attrib]);
    };
  }
  return function (elem) {
    return (0, domhandler_1.isTag)(elem) && elem.attribs[attrib] === value;
  };
}
/**
 * Returns a function that returns `true` if either of the input functions
 * returns `true` for a node.
 *
 * @param a First function to combine.
 * @param b Second function to combine.
 * @returns A function taking a node and returning `true` if either of the input
 *   functions returns `true` for the node.
 */
function combineFuncs(a, b) {
  return function (elem) {
    return a(elem) || b(elem);
  };
}
/**
 * Returns a function that executes all checks in `options` and returns `true`
 * if any of them match a node.
 *
 * @param options An object describing nodes to look for.
 * @returns A function that executes all checks in `options` and returns `true`
 *   if any of them match a node.
 */
function compileTest(options) {
  var funcs = Object.keys(options).map(function (key) {
    var value = options[key];
    return Object.prototype.hasOwnProperty.call(Checks, key) ? Checks[key](value) : getAttribCheck(key, value);
  });
  return funcs.length === 0 ? null : funcs.reduce(combineFuncs);
}
/**
 * Checks whether a node matches the description in `options`.
 *
 * @category Legacy Query Functions
 * @param options An object describing nodes to look for.
 * @param node The element to test.
 * @returns Whether the element matches the description in `options`.
 */
function testElement(options, node) {
  var test = compileTest(options);
  return test ? test(node) : true;
}
exports.testElement = testElement;
/**
 * Returns all nodes that match `options`.
 *
 * @category Legacy Query Functions
 * @param options An object describing nodes to look for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes that match `options`.
 */
function getElements(options, nodes, recurse, limit) {
  if (limit === void 0) {
    limit = Infinity;
  }
  var test = compileTest(options);
  return test ? (0, querying_js_1.filter)(test, nodes, recurse, limit) : [];
}
exports.getElements = getElements;
/**
 * Returns the node with the supplied ID.
 *
 * @category Legacy Query Functions
 * @param id The unique ID attribute value to look for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @returns The node with the supplied ID.
 */
function getElementById(id, nodes, recurse) {
  if (recurse === void 0) {
    recurse = true;
  }
  if (!Array.isArray(nodes)) nodes = [nodes];
  return (0, querying_js_1.findOne)(getAttribCheck("id", id), nodes, recurse);
}
exports.getElementById = getElementById;
/**
 * Returns all nodes with the supplied `tagName`.
 *
 * @category Legacy Query Functions
 * @param tagName Tag name to search for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes with the supplied `tagName`.
 */
function getElementsByTagName(tagName, nodes, recurse, limit) {
  if (recurse === void 0) {
    recurse = true;
  }
  if (limit === void 0) {
    limit = Infinity;
  }
  return (0, querying_js_1.filter)(Checks["tag_name"](tagName), nodes, recurse, limit);
}
exports.getElementsByTagName = getElementsByTagName;
/**
 * Returns all nodes with the supplied `type`.
 *
 * @category Legacy Query Functions
 * @param type Element type to look for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes with the supplied `type`.
 */
function getElementsByTagType(type, nodes, recurse, limit) {
  if (recurse === void 0) {
    recurse = true;
  }
  if (limit === void 0) {
    limit = Infinity;
  }
  return (0, querying_js_1.filter)(Checks["tag_type"](type), nodes, recurse, limit);
}
exports.getElementsByTagType = getElementsByTagType;

/***/ }),

/***/ "./node_modules/domutils/lib/manipulation.js":
/*!***************************************************!*\
  !*** ./node_modules/domutils/lib/manipulation.js ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.prepend = exports.prependChild = exports.append = exports.appendChild = exports.replaceElement = exports.removeElement = void 0;
/**
 * Remove an element from the dom
 *
 * @category Manipulation
 * @param elem The element to be removed
 */
function removeElement(elem) {
  if (elem.prev) elem.prev.next = elem.next;
  if (elem.next) elem.next.prev = elem.prev;
  if (elem.parent) {
    var childs = elem.parent.children;
    var childsIndex = childs.lastIndexOf(elem);
    if (childsIndex >= 0) {
      childs.splice(childsIndex, 1);
    }
  }
  elem.next = null;
  elem.prev = null;
  elem.parent = null;
}
exports.removeElement = removeElement;
/**
 * Replace an element in the dom
 *
 * @category Manipulation
 * @param elem The element to be replaced
 * @param replacement The element to be added
 */
function replaceElement(elem, replacement) {
  var prev = replacement.prev = elem.prev;
  if (prev) {
    prev.next = replacement;
  }
  var next = replacement.next = elem.next;
  if (next) {
    next.prev = replacement;
  }
  var parent = replacement.parent = elem.parent;
  if (parent) {
    var childs = parent.children;
    childs[childs.lastIndexOf(elem)] = replacement;
    elem.parent = null;
  }
}
exports.replaceElement = replaceElement;
/**
 * Append a child to an element.
 *
 * @category Manipulation
 * @param parent The element to append to.
 * @param child The element to be added as a child.
 */
function appendChild(parent, child) {
  removeElement(child);
  child.next = null;
  child.parent = parent;
  if (parent.children.push(child) > 1) {
    var sibling = parent.children[parent.children.length - 2];
    sibling.next = child;
    child.prev = sibling;
  } else {
    child.prev = null;
  }
}
exports.appendChild = appendChild;
/**
 * Append an element after another.
 *
 * @category Manipulation
 * @param elem The element to append after.
 * @param next The element be added.
 */
function append(elem, next) {
  removeElement(next);
  var parent = elem.parent;
  var currNext = elem.next;
  next.next = currNext;
  next.prev = elem;
  elem.next = next;
  next.parent = parent;
  if (currNext) {
    currNext.prev = next;
    if (parent) {
      var childs = parent.children;
      childs.splice(childs.lastIndexOf(currNext), 0, next);
    }
  } else if (parent) {
    parent.children.push(next);
  }
}
exports.append = append;
/**
 * Prepend a child to an element.
 *
 * @category Manipulation
 * @param parent The element to prepend before.
 * @param child The element to be added as a child.
 */
function prependChild(parent, child) {
  removeElement(child);
  child.parent = parent;
  child.prev = null;
  if (parent.children.unshift(child) !== 1) {
    var sibling = parent.children[1];
    sibling.prev = child;
    child.next = sibling;
  } else {
    child.next = null;
  }
}
exports.prependChild = prependChild;
/**
 * Prepend an element before another.
 *
 * @category Manipulation
 * @param elem The element to prepend before.
 * @param prev The element be added.
 */
function prepend(elem, prev) {
  removeElement(prev);
  var parent = elem.parent;
  if (parent) {
    var childs = parent.children;
    childs.splice(childs.indexOf(elem), 0, prev);
  }
  if (elem.prev) {
    elem.prev.next = prev;
  }
  prev.parent = parent;
  prev.prev = elem.prev;
  prev.next = elem;
  elem.prev = prev;
}
exports.prepend = prepend;

/***/ }),

/***/ "./node_modules/domutils/lib/querying.js":
/*!***********************************************!*\
  !*** ./node_modules/domutils/lib/querying.js ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.findAll = exports.existsOne = exports.findOne = exports.findOneChild = exports.find = exports.filter = void 0;
var domhandler_1 = __webpack_require__(/*! domhandler */ "./node_modules/domhandler/lib/index.js");
/**
 * Search a node and its children for nodes passing a test function. If `node` is not an array, it will be wrapped in one.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param node Node to search. Will be included in the result set if it matches.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes passing `test`.
 */
function filter(test, node, recurse, limit) {
  if (recurse === void 0) {
    recurse = true;
  }
  if (limit === void 0) {
    limit = Infinity;
  }
  return find(test, Array.isArray(node) ? node : [node], recurse, limit);
}
exports.filter = filter;
/**
 * Search an array of nodes and their children for nodes passing a test function.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes passing `test`.
 */
function find(test, nodes, recurse, limit) {
  var result = [];
  /** Stack of the arrays we are looking at. */
  var nodeStack = [nodes];
  /** Stack of the indices within the arrays. */
  var indexStack = [0];
  for (;;) {
    // First, check if the current array has any more elements to look at.
    if (indexStack[0] >= nodeStack[0].length) {
      // If we have no more arrays to look at, we are done.
      if (indexStack.length === 1) {
        return result;
      }
      // Otherwise, remove the current array from the stack.
      nodeStack.shift();
      indexStack.shift();
      // Loop back to the start to continue with the next array.
      continue;
    }
    var elem = nodeStack[0][indexStack[0]++];
    if (test(elem)) {
      result.push(elem);
      if (--limit <= 0) return result;
    }
    if (recurse && (0, domhandler_1.hasChildren)(elem) && elem.children.length > 0) {
      /*
       * Add the children to the stack. We are depth-first, so this is
       * the next array we look at.
       */
      indexStack.unshift(0);
      nodeStack.unshift(elem.children);
    }
  }
}
exports.find = find;
/**
 * Finds the first element inside of an array that matches a test function. This is an alias for `Array.prototype.find`.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @returns The first node in the array that passes `test`.
 * @deprecated Use `Array.prototype.find` directly.
 */
function findOneChild(test, nodes) {
  return nodes.find(test);
}
exports.findOneChild = findOneChild;
/**
 * Finds one element in a tree that passes a test.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param nodes Node or array of nodes to search.
 * @param recurse Also consider child nodes.
 * @returns The first node that passes `test`.
 */
function findOne(test, nodes, recurse) {
  if (recurse === void 0) {
    recurse = true;
  }
  var elem = null;
  for (var i = 0; i < nodes.length && !elem; i++) {
    var node = nodes[i];
    if (!(0, domhandler_1.isTag)(node)) {
      continue;
    } else if (test(node)) {
      elem = node;
    } else if (recurse && node.children.length > 0) {
      elem = findOne(test, node.children, true);
    }
  }
  return elem;
}
exports.findOne = findOne;
/**
 * Checks if a tree of nodes contains at least one node passing a test.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @returns Whether a tree of nodes contains at least one node passing the test.
 */
function existsOne(test, nodes) {
  return nodes.some(function (checked) {
    return (0, domhandler_1.isTag)(checked) && (test(checked) || existsOne(test, checked.children));
  });
}
exports.existsOne = existsOne;
/**
 * Search an array of nodes and their children for elements passing a test function.
 *
 * Same as `find`, but limited to elements and with less options, leading to reduced complexity.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @returns All nodes passing `test`.
 */
function findAll(test, nodes) {
  var result = [];
  var nodeStack = [nodes];
  var indexStack = [0];
  for (;;) {
    if (indexStack[0] >= nodeStack[0].length) {
      if (nodeStack.length === 1) {
        return result;
      }
      // Otherwise, remove the current array from the stack.
      nodeStack.shift();
      indexStack.shift();
      // Loop back to the start to continue with the next array.
      continue;
    }
    var elem = nodeStack[0][indexStack[0]++];
    if (!(0, domhandler_1.isTag)(elem)) continue;
    if (test(elem)) result.push(elem);
    if (elem.children.length > 0) {
      indexStack.unshift(0);
      nodeStack.unshift(elem.children);
    }
  }
}
exports.findAll = findAll;

/***/ }),

/***/ "./node_modules/domutils/lib/stringify.js":
/*!************************************************!*\
  !*** ./node_modules/domutils/lib/stringify.js ***!
  \************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.innerText = exports.textContent = exports.getText = exports.getInnerHTML = exports.getOuterHTML = void 0;
var domhandler_1 = __webpack_require__(/*! domhandler */ "./node_modules/domhandler/lib/index.js");
var dom_serializer_1 = __importDefault(__webpack_require__(/*! dom-serializer */ "./node_modules/dom-serializer/lib/index.js"));
var domelementtype_1 = __webpack_require__(/*! domelementtype */ "./node_modules/domelementtype/lib/index.js");
/**
 * @category Stringify
 * @deprecated Use the `dom-serializer` module directly.
 * @param node Node to get the outer HTML of.
 * @param options Options for serialization.
 * @returns `node`'s outer HTML.
 */
function getOuterHTML(node, options) {
  return (0, dom_serializer_1.default)(node, options);
}
exports.getOuterHTML = getOuterHTML;
/**
 * @category Stringify
 * @deprecated Use the `dom-serializer` module directly.
 * @param node Node to get the inner HTML of.
 * @param options Options for serialization.
 * @returns `node`'s inner HTML.
 */
function getInnerHTML(node, options) {
  return (0, domhandler_1.hasChildren)(node) ? node.children.map(function (node) {
    return getOuterHTML(node, options);
  }).join("") : "";
}
exports.getInnerHTML = getInnerHTML;
/**
 * Get a node's inner text. Same as `textContent`, but inserts newlines for `<br>` tags. Ignores comments.
 *
 * @category Stringify
 * @deprecated Use `textContent` instead.
 * @param node Node to get the inner text of.
 * @returns `node`'s inner text.
 */
function getText(node) {
  if (Array.isArray(node)) return node.map(getText).join("");
  if ((0, domhandler_1.isTag)(node)) return node.name === "br" ? "\n" : getText(node.children);
  if ((0, domhandler_1.isCDATA)(node)) return getText(node.children);
  if ((0, domhandler_1.isText)(node)) return node.data;
  return "";
}
exports.getText = getText;
/**
 * Get a node's text content. Ignores comments.
 *
 * @category Stringify
 * @param node Node to get the text content of.
 * @returns `node`'s text content.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Node/textContent}
 */
function textContent(node) {
  if (Array.isArray(node)) return node.map(textContent).join("");
  if ((0, domhandler_1.hasChildren)(node) && !(0, domhandler_1.isComment)(node)) {
    return textContent(node.children);
  }
  if ((0, domhandler_1.isText)(node)) return node.data;
  return "";
}
exports.textContent = textContent;
/**
 * Get a node's inner text, ignoring `<script>` and `<style>` tags. Ignores comments.
 *
 * @category Stringify
 * @param node Node to get the inner text of.
 * @returns `node`'s inner text.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Node/innerText}
 */
function innerText(node) {
  if (Array.isArray(node)) return node.map(innerText).join("");
  if ((0, domhandler_1.hasChildren)(node) && (node.type === domelementtype_1.ElementType.Tag || (0, domhandler_1.isCDATA)(node))) {
    return innerText(node.children);
  }
  if ((0, domhandler_1.isText)(node)) return node.data;
  return "";
}
exports.innerText = innerText;

/***/ }),

/***/ "./node_modules/domutils/lib/traversal.js":
/*!************************************************!*\
  !*** ./node_modules/domutils/lib/traversal.js ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.prevElementSibling = exports.nextElementSibling = exports.getName = exports.hasAttrib = exports.getAttributeValue = exports.getSiblings = exports.getParent = exports.getChildren = void 0;
var domhandler_1 = __webpack_require__(/*! domhandler */ "./node_modules/domhandler/lib/index.js");
/**
 * Get a node's children.
 *
 * @category Traversal
 * @param elem Node to get the children of.
 * @returns `elem`'s children, or an empty array.
 */
function getChildren(elem) {
  return (0, domhandler_1.hasChildren)(elem) ? elem.children : [];
}
exports.getChildren = getChildren;
/**
 * Get a node's parent.
 *
 * @category Traversal
 * @param elem Node to get the parent of.
 * @returns `elem`'s parent node, or `null` if `elem` is a root node.
 */
function getParent(elem) {
  return elem.parent || null;
}
exports.getParent = getParent;
/**
 * Gets an elements siblings, including the element itself.
 *
 * Attempts to get the children through the element's parent first. If we don't
 * have a parent (the element is a root node), we walk the element's `prev` &
 * `next` to get all remaining nodes.
 *
 * @category Traversal
 * @param elem Element to get the siblings of.
 * @returns `elem`'s siblings, including `elem`.
 */
function getSiblings(elem) {
  var _a, _b;
  var parent = getParent(elem);
  if (parent != null) return getChildren(parent);
  var siblings = [elem];
  var prev = elem.prev,
    next = elem.next;
  while (prev != null) {
    siblings.unshift(prev);
    _a = prev, prev = _a.prev;
  }
  while (next != null) {
    siblings.push(next);
    _b = next, next = _b.next;
  }
  return siblings;
}
exports.getSiblings = getSiblings;
/**
 * Gets an attribute from an element.
 *
 * @category Traversal
 * @param elem Element to check.
 * @param name Attribute name to retrieve.
 * @returns The element's attribute value, or `undefined`.
 */
function getAttributeValue(elem, name) {
  var _a;
  return (_a = elem.attribs) === null || _a === void 0 ? void 0 : _a[name];
}
exports.getAttributeValue = getAttributeValue;
/**
 * Checks whether an element has an attribute.
 *
 * @category Traversal
 * @param elem Element to check.
 * @param name Attribute name to look for.
 * @returns Returns whether `elem` has the attribute `name`.
 */
function hasAttrib(elem, name) {
  return elem.attribs != null && Object.prototype.hasOwnProperty.call(elem.attribs, name) && elem.attribs[name] != null;
}
exports.hasAttrib = hasAttrib;
/**
 * Get the tag name of an element.
 *
 * @category Traversal
 * @param elem The element to get the name for.
 * @returns The tag name of `elem`.
 */
function getName(elem) {
  return elem.name;
}
exports.getName = getName;
/**
 * Returns the next element sibling of a node.
 *
 * @category Traversal
 * @param elem The element to get the next sibling of.
 * @returns `elem`'s next sibling that is a tag, or `null` if there is no next
 * sibling.
 */
function nextElementSibling(elem) {
  var _a;
  var next = elem.next;
  while (next !== null && !(0, domhandler_1.isTag)(next)) _a = next, next = _a.next;
  return next;
}
exports.nextElementSibling = nextElementSibling;
/**
 * Returns the previous element sibling of a node.
 *
 * @category Traversal
 * @param elem The element to get the previous sibling of.
 * @returns `elem`'s previous sibling that is a tag, or `null` if there is no
 * previous sibling.
 */
function prevElementSibling(elem) {
  var _a;
  var prev = elem.prev;
  while (prev !== null && !(0, domhandler_1.isTag)(prev)) _a = prev, prev = _a.prev;
  return prev;
}
exports.prevElementSibling = prevElementSibling;

/***/ }),

/***/ "./node_modules/entities/lib/decode.js":
/*!*********************************************!*\
  !*** ./node_modules/entities/lib/decode.js ***!
  \*********************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.decodeXML = exports.decodeHTMLStrict = exports.decodeHTMLAttribute = exports.decodeHTML = exports.determineBranch = exports.EntityDecoder = exports.DecodingMode = exports.BinTrieFlags = exports.fromCodePoint = exports.replaceCodePoint = exports.decodeCodePoint = exports.xmlDecodeTree = exports.htmlDecodeTree = void 0;
var decode_data_html_js_1 = __importDefault(__webpack_require__(/*! ./generated/decode-data-html.js */ "./node_modules/entities/lib/generated/decode-data-html.js"));
exports.htmlDecodeTree = decode_data_html_js_1.default;
var decode_data_xml_js_1 = __importDefault(__webpack_require__(/*! ./generated/decode-data-xml.js */ "./node_modules/entities/lib/generated/decode-data-xml.js"));
exports.xmlDecodeTree = decode_data_xml_js_1.default;
var decode_codepoint_js_1 = __importStar(__webpack_require__(/*! ./decode_codepoint.js */ "./node_modules/entities/lib/decode_codepoint.js"));
exports.decodeCodePoint = decode_codepoint_js_1.default;
var decode_codepoint_js_2 = __webpack_require__(/*! ./decode_codepoint.js */ "./node_modules/entities/lib/decode_codepoint.js");
Object.defineProperty(exports, "replaceCodePoint", ({
  enumerable: true,
  get: function () {
    return decode_codepoint_js_2.replaceCodePoint;
  }
}));
Object.defineProperty(exports, "fromCodePoint", ({
  enumerable: true,
  get: function () {
    return decode_codepoint_js_2.fromCodePoint;
  }
}));
var CharCodes;
(function (CharCodes) {
  CharCodes[CharCodes["NUM"] = 35] = "NUM";
  CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
  CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
  CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
  CharCodes[CharCodes["NINE"] = 57] = "NINE";
  CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
  CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
  CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
  CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
  CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
  CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
  CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})(CharCodes || (CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */
var TO_LOWER_BIT = 32;
var BinTrieFlags;
(function (BinTrieFlags) {
  BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
  BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
  BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})(BinTrieFlags = exports.BinTrieFlags || (exports.BinTrieFlags = {}));
function isNumber(code) {
  return code >= CharCodes.ZERO && code <= CharCodes.NINE;
}
function isHexadecimalCharacter(code) {
  return code >= CharCodes.UPPER_A && code <= CharCodes.UPPER_F || code >= CharCodes.LOWER_A && code <= CharCodes.LOWER_F;
}
function isAsciiAlphaNumeric(code) {
  return code >= CharCodes.UPPER_A && code <= CharCodes.UPPER_Z || code >= CharCodes.LOWER_A && code <= CharCodes.LOWER_Z || isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */
function isEntityInAttributeInvalidEnd(code) {
  return code === CharCodes.EQUALS || isAsciiAlphaNumeric(code);
}
var EntityDecoderState;
(function (EntityDecoderState) {
  EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
  EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
  EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
  EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
  EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})(EntityDecoderState || (EntityDecoderState = {}));
var DecodingMode;
(function (DecodingMode) {
  /** Entities in text nodes that can end with any character. */
  DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
  /** Only allow entities terminated with a semicolon. */
  DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
  /** Entities in attributes have limitations on ending characters. */
  DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})(DecodingMode = exports.DecodingMode || (exports.DecodingMode = {}));
/**
 * Token decoder with support of writing partial entities.
 */
var EntityDecoder = /** @class */function () {
  function EntityDecoder( /** The tree used to decode entities. */
  decodeTree,
  /**
   * The function that is called when a codepoint is decoded.
   *
   * For multi-byte named entities, this will be called multiple times,
   * with the second codepoint, and the same `consumed` value.
   *
   * @param codepoint The decoded codepoint.
   * @param consumed The number of bytes consumed by the decoder.
   */
  emitCodePoint, /** An object that is used to produce errors. */
  errors) {
    this.decodeTree = decodeTree;
    this.emitCodePoint = emitCodePoint;
    this.errors = errors;
    /** The current state of the decoder. */
    this.state = EntityDecoderState.EntityStart;
    /** Characters that were consumed while parsing an entity. */
    this.consumed = 1;
    /**
     * The result of the entity.
     *
     * Either the result index of a numeric entity, or the codepoint of a
     * numeric entity.
     */
    this.result = 0;
    /** The current index in the decode tree. */
    this.treeIndex = 0;
    /** The number of characters that were consumed in excess. */
    this.excess = 1;
    /** The mode in which the decoder is operating. */
    this.decodeMode = DecodingMode.Strict;
  }
  /** Resets the instance to make it reusable. */
  EntityDecoder.prototype.startEntity = function (decodeMode) {
    this.decodeMode = decodeMode;
    this.state = EntityDecoderState.EntityStart;
    this.result = 0;
    this.treeIndex = 0;
    this.excess = 1;
    this.consumed = 1;
  };
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   *
   * @param string The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  EntityDecoder.prototype.write = function (str, offset) {
    switch (this.state) {
      case EntityDecoderState.EntityStart:
        {
          if (str.charCodeAt(offset) === CharCodes.NUM) {
            this.state = EntityDecoderState.NumericStart;
            this.consumed += 1;
            return this.stateNumericStart(str, offset + 1);
          }
          this.state = EntityDecoderState.NamedEntity;
          return this.stateNamedEntity(str, offset);
        }
      case EntityDecoderState.NumericStart:
        {
          return this.stateNumericStart(str, offset);
        }
      case EntityDecoderState.NumericDecimal:
        {
          return this.stateNumericDecimal(str, offset);
        }
      case EntityDecoderState.NumericHex:
        {
          return this.stateNumericHex(str, offset);
        }
      case EntityDecoderState.NamedEntity:
        {
          return this.stateNamedEntity(str, offset);
        }
    }
  };
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  EntityDecoder.prototype.stateNumericStart = function (str, offset) {
    if (offset >= str.length) {
      return -1;
    }
    if ((str.charCodeAt(offset) | TO_LOWER_BIT) === CharCodes.LOWER_X) {
      this.state = EntityDecoderState.NumericHex;
      this.consumed += 1;
      return this.stateNumericHex(str, offset + 1);
    }
    this.state = EntityDecoderState.NumericDecimal;
    return this.stateNumericDecimal(str, offset);
  };
  EntityDecoder.prototype.addToNumericResult = function (str, start, end, base) {
    if (start !== end) {
      var digitCount = end - start;
      this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
      this.consumed += digitCount;
    }
  };
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  EntityDecoder.prototype.stateNumericHex = function (str, offset) {
    var startIdx = offset;
    while (offset < str.length) {
      var char = str.charCodeAt(offset);
      if (isNumber(char) || isHexadecimalCharacter(char)) {
        offset += 1;
      } else {
        this.addToNumericResult(str, startIdx, offset, 16);
        return this.emitNumericEntity(char, 3);
      }
    }
    this.addToNumericResult(str, startIdx, offset, 16);
    return -1;
  };
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  EntityDecoder.prototype.stateNumericDecimal = function (str, offset) {
    var startIdx = offset;
    while (offset < str.length) {
      var char = str.charCodeAt(offset);
      if (isNumber(char)) {
        offset += 1;
      } else {
        this.addToNumericResult(str, startIdx, offset, 10);
        return this.emitNumericEntity(char, 2);
      }
    }
    this.addToNumericResult(str, startIdx, offset, 10);
    return -1;
  };
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   *
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  EntityDecoder.prototype.emitNumericEntity = function (lastCp, expectedLength) {
    var _a;
    // Ensure we consumed at least one digit.
    if (this.consumed <= expectedLength) {
      (_a = this.errors) === null || _a === void 0 ? void 0 : _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
      return 0;
    }
    // Figure out if this is a legit end of the entity
    if (lastCp === CharCodes.SEMI) {
      this.consumed += 1;
    } else if (this.decodeMode === DecodingMode.Strict) {
      return 0;
    }
    this.emitCodePoint((0, decode_codepoint_js_1.replaceCodePoint)(this.result), this.consumed);
    if (this.errors) {
      if (lastCp !== CharCodes.SEMI) {
        this.errors.missingSemicolonAfterCharacterReference();
      }
      this.errors.validateNumericCharacterReference(this.result);
    }
    return this.consumed;
  };
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  EntityDecoder.prototype.stateNamedEntity = function (str, offset) {
    var decodeTree = this.decodeTree;
    var current = decodeTree[this.treeIndex];
    // The mask is the number of bytes of the value, including the current byte.
    var valueLength = (current & BinTrieFlags.VALUE_LENGTH) >> 14;
    for (; offset < str.length; offset++, this.excess++) {
      var char = str.charCodeAt(offset);
      this.treeIndex = determineBranch(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
      if (this.treeIndex < 0) {
        return this.result === 0 ||
        // If we are parsing an attribute
        this.decodeMode === DecodingMode.Attribute && (
        // We shouldn't have consumed any characters after the entity,
        valueLength === 0 ||
        // And there should be no invalid characters.
        isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
      }
      current = decodeTree[this.treeIndex];
      valueLength = (current & BinTrieFlags.VALUE_LENGTH) >> 14;
      // If the branch is a value, store it and continue
      if (valueLength !== 0) {
        // If the entity is terminated by a semicolon, we are done.
        if (char === CharCodes.SEMI) {
          return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
        }
        // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
        if (this.decodeMode !== DecodingMode.Strict) {
          this.result = this.treeIndex;
          this.consumed += this.excess;
          this.excess = 0;
        }
      }
    }
    return -1;
  };
  /**
   * Emit a named entity that was not terminated with a semicolon.
   *
   * @returns The number of characters consumed.
   */
  EntityDecoder.prototype.emitNotTerminatedNamedEntity = function () {
    var _a;
    var _b = this,
      result = _b.result,
      decodeTree = _b.decodeTree;
    var valueLength = (decodeTree[result] & BinTrieFlags.VALUE_LENGTH) >> 14;
    this.emitNamedEntityData(result, valueLength, this.consumed);
    (_a = this.errors) === null || _a === void 0 ? void 0 : _a.missingSemicolonAfterCharacterReference();
    return this.consumed;
  };
  /**
   * Emit a named entity.
   *
   * @param result The index of the entity in the decode tree.
   * @param valueLength The number of bytes in the entity.
   * @param consumed The number of characters consumed.
   *
   * @returns The number of characters consumed.
   */
  EntityDecoder.prototype.emitNamedEntityData = function (result, valueLength, consumed) {
    var decodeTree = this.decodeTree;
    this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~BinTrieFlags.VALUE_LENGTH : decodeTree[result + 1], consumed);
    if (valueLength === 3) {
      // For multi-byte values, we need to emit the second byte.
      this.emitCodePoint(decodeTree[result + 2], consumed);
    }
    return consumed;
  };
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   *
   * @returns The number of characters consumed.
   */
  EntityDecoder.prototype.end = function () {
    var _a;
    switch (this.state) {
      case EntityDecoderState.NamedEntity:
        {
          // Emit a named entity if we have one.
          return this.result !== 0 && (this.decodeMode !== DecodingMode.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
        }
      // Otherwise, emit a numeric entity if we have one.
      case EntityDecoderState.NumericDecimal:
        {
          return this.emitNumericEntity(0, 2);
        }
      case EntityDecoderState.NumericHex:
        {
          return this.emitNumericEntity(0, 3);
        }
      case EntityDecoderState.NumericStart:
        {
          (_a = this.errors) === null || _a === void 0 ? void 0 : _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
          return 0;
        }
      case EntityDecoderState.EntityStart:
        {
          // Return 0 if we have no entity.
          return 0;
        }
    }
  };
  return EntityDecoder;
}();
exports.EntityDecoder = EntityDecoder;
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */
function getDecoder(decodeTree) {
  var ret = "";
  var decoder = new EntityDecoder(decodeTree, function (str) {
    return ret += (0, decode_codepoint_js_1.fromCodePoint)(str);
  });
  return function decodeWithTrie(str, decodeMode) {
    var lastIndex = 0;
    var offset = 0;
    while ((offset = str.indexOf("&", offset)) >= 0) {
      ret += str.slice(lastIndex, offset);
      decoder.startEntity(decodeMode);
      var len = decoder.write(str,
      // Skip the "&"
      offset + 1);
      if (len < 0) {
        lastIndex = offset + decoder.end();
        break;
      }
      lastIndex = offset + len;
      // If `len` is 0, skip the current `&` and continue.
      offset = len === 0 ? lastIndex + 1 : lastIndex;
    }
    var result = ret + str.slice(lastIndex);
    // Make sure we don't keep a reference to the final string.
    ret = "";
    return result;
  };
}
/**
 * Determines the branch of the current node that is taken given the current
 * character. This function is used to traverse the trie.
 *
 * @param decodeTree The trie.
 * @param current The current node.
 * @param nodeIdx The index right after the current node and its value.
 * @param char The current character.
 * @returns The index of the next node, or -1 if no branch is taken.
 */
function determineBranch(decodeTree, current, nodeIdx, char) {
  var branchCount = (current & BinTrieFlags.BRANCH_LENGTH) >> 7;
  var jumpOffset = current & BinTrieFlags.JUMP_TABLE;
  // Case 1: Single branch encoded in jump offset
  if (branchCount === 0) {
    return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
  }
  // Case 2: Multiple branches encoded in jump table
  if (jumpOffset) {
    var value = char - jumpOffset;
    return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
  }
  // Case 3: Multiple branches encoded in dictionary
  // Binary search for the character.
  var lo = nodeIdx;
  var hi = lo + branchCount - 1;
  while (lo <= hi) {
    var mid = lo + hi >>> 1;
    var midVal = decodeTree[mid];
    if (midVal < char) {
      lo = mid + 1;
    } else if (midVal > char) {
      hi = mid - 1;
    } else {
      return decodeTree[mid + branchCount];
    }
  }
  return -1;
}
exports.determineBranch = determineBranch;
var htmlDecoder = getDecoder(decode_data_html_js_1.default);
var xmlDecoder = getDecoder(decode_data_xml_js_1.default);
/**
 * Decodes an HTML string.
 *
 * @param str The string to decode.
 * @param mode The decoding mode.
 * @returns The decoded string.
 */
function decodeHTML(str, mode) {
  if (mode === void 0) {
    mode = DecodingMode.Legacy;
  }
  return htmlDecoder(str, mode);
}
exports.decodeHTML = decodeHTML;
/**
 * Decodes an HTML string in an attribute.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */
function decodeHTMLAttribute(str) {
  return htmlDecoder(str, DecodingMode.Attribute);
}
exports.decodeHTMLAttribute = decodeHTMLAttribute;
/**
 * Decodes an HTML string, requiring all entities to be terminated by a semicolon.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */
function decodeHTMLStrict(str) {
  return htmlDecoder(str, DecodingMode.Strict);
}
exports.decodeHTMLStrict = decodeHTMLStrict;
/**
 * Decodes an XML string, requiring all entities to be terminated by a semicolon.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */
function decodeXML(str) {
  return xmlDecoder(str, DecodingMode.Strict);
}
exports.decodeXML = decodeXML;

/***/ }),

/***/ "./node_modules/entities/lib/decode_codepoint.js":
/*!*******************************************************!*\
  !*** ./node_modules/entities/lib/decode_codepoint.js ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";


// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var _a;
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.replaceCodePoint = exports.fromCodePoint = void 0;
var decodeMap = new Map([[0, 65533],
// C1 Unicode control character reference replacements
[128, 8364], [130, 8218], [131, 402], [132, 8222], [133, 8230], [134, 8224], [135, 8225], [136, 710], [137, 8240], [138, 352], [139, 8249], [140, 338], [142, 381], [145, 8216], [146, 8217], [147, 8220], [148, 8221], [149, 8226], [150, 8211], [151, 8212], [152, 732], [153, 8482], [154, 353], [155, 8250], [156, 339], [158, 382], [159, 376]]);
/**
 * Polyfill for `String.fromCodePoint`. It is used to create a string from a Unicode code point.
 */
exports.fromCodePoint =
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
(_a = String.fromCodePoint) !== null && _a !== void 0 ? _a : function (codePoint) {
  var output = "";
  if (codePoint > 0xffff) {
    codePoint -= 0x10000;
    output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
    codePoint = 0xdc00 | codePoint & 0x3ff;
  }
  output += String.fromCharCode(codePoint);
  return output;
};
/**
 * Replace the given code point with a replacement character if it is a
 * surrogate or is outside the valid range. Otherwise return the code
 * point unchanged.
 */
function replaceCodePoint(codePoint) {
  var _a;
  if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) {
    return 0xfffd;
  }
  return (_a = decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
exports.replaceCodePoint = replaceCodePoint;
/**
 * Replace the code point if relevant, then convert it to a string.
 *
 * @deprecated Use `fromCodePoint(replaceCodePoint(codePoint))` instead.
 * @param codePoint The code point to decode.
 * @returns The decoded code point.
 */
function decodeCodePoint(codePoint) {
  return (0, exports.fromCodePoint)(replaceCodePoint(codePoint));
}
exports["default"] = decodeCodePoint;

/***/ }),

/***/ "./node_modules/entities/lib/encode.js":
/*!*********************************************!*\
  !*** ./node_modules/entities/lib/encode.js ***!
  \*********************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.encodeNonAsciiHTML = exports.encodeHTML = void 0;
var encode_html_js_1 = __importDefault(__webpack_require__(/*! ./generated/encode-html.js */ "./node_modules/entities/lib/generated/encode-html.js"));
var escape_js_1 = __webpack_require__(/*! ./escape.js */ "./node_modules/entities/lib/escape.js");
var htmlReplacer = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
/**
 * Encodes all characters in the input using HTML entities. This includes
 * characters that are valid ASCII characters in HTML documents, such as `#`.
 *
 * To get a more compact output, consider using the `encodeNonAsciiHTML`
 * function, which will only encode characters that are not valid in HTML
 * documents, as well as non-ASCII characters.
 *
 * If a character has no equivalent entity, a numeric hexadecimal reference
 * (eg. `&#xfc;`) will be used.
 */
function encodeHTML(data) {
  return encodeHTMLTrieRe(htmlReplacer, data);
}
exports.encodeHTML = encodeHTML;
/**
 * Encodes all non-ASCII characters, as well as characters not valid in HTML
 * documents using HTML entities. This function will not encode characters that
 * are valid in HTML documents, such as `#`.
 *
 * If a character has no equivalent entity, a numeric hexadecimal reference
 * (eg. `&#xfc;`) will be used.
 */
function encodeNonAsciiHTML(data) {
  return encodeHTMLTrieRe(escape_js_1.xmlReplacer, data);
}
exports.encodeNonAsciiHTML = encodeNonAsciiHTML;
function encodeHTMLTrieRe(regExp, str) {
  var ret = "";
  var lastIdx = 0;
  var match;
  while ((match = regExp.exec(str)) !== null) {
    var i = match.index;
    ret += str.substring(lastIdx, i);
    var char = str.charCodeAt(i);
    var next = encode_html_js_1.default.get(char);
    if (typeof next === "object") {
      // We are in a branch. Try to match the next char.
      if (i + 1 < str.length) {
        var nextChar = str.charCodeAt(i + 1);
        var value = typeof next.n === "number" ? next.n === nextChar ? next.o : undefined : next.n.get(nextChar);
        if (value !== undefined) {
          ret += value;
          lastIdx = regExp.lastIndex += 1;
          continue;
        }
      }
      next = next.v;
    }
    // We might have a tree node without a value; skip and use a numeric entity.
    if (next !== undefined) {
      ret += next;
      lastIdx = i + 1;
    } else {
      var cp = (0, escape_js_1.getCodePoint)(str, i);
      ret += "&#x".concat(cp.toString(16), ";");
      // Increase by 1 if we have a surrogate pair
      lastIdx = regExp.lastIndex += Number(cp !== char);
    }
  }
  return ret + str.substr(lastIdx);
}

/***/ }),

/***/ "./node_modules/entities/lib/escape.js":
/*!*********************************************!*\
  !*** ./node_modules/entities/lib/escape.js ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.escapeText = exports.escapeAttribute = exports.escapeUTF8 = exports.escape = exports.encodeXML = exports.getCodePoint = exports.xmlReplacer = void 0;
exports.xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
var xmlCodeMap = new Map([[34, "&quot;"], [38, "&amp;"], [39, "&apos;"], [60, "&lt;"], [62, "&gt;"]]);
// For compatibility with node < 4, we wrap `codePointAt`
exports.getCodePoint =
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt != null ? function (str, index) {
  return str.codePointAt(index);
} :
// http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
function (c, index) {
  return (c.charCodeAt(index) & 0xfc00) === 0xd800 ? (c.charCodeAt(index) - 0xd800) * 0x400 + c.charCodeAt(index + 1) - 0xdc00 + 0x10000 : c.charCodeAt(index);
};
/**
 * Encodes all non-ASCII characters, as well as characters not valid in XML
 * documents using XML entities.
 *
 * If a character has no equivalent entity, a
 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
 */
function encodeXML(str) {
  var ret = "";
  var lastIdx = 0;
  var match;
  while ((match = exports.xmlReplacer.exec(str)) !== null) {
    var i = match.index;
    var char = str.charCodeAt(i);
    var next = xmlCodeMap.get(char);
    if (next !== undefined) {
      ret += str.substring(lastIdx, i) + next;
      lastIdx = i + 1;
    } else {
      ret += "".concat(str.substring(lastIdx, i), "&#x").concat((0, exports.getCodePoint)(str, i).toString(16), ";");
      // Increase by 1 if we have a surrogate pair
      lastIdx = exports.xmlReplacer.lastIndex += Number((char & 0xfc00) === 0xd800);
    }
  }
  return ret + str.substr(lastIdx);
}
exports.encodeXML = encodeXML;
/**
 * Encodes all non-ASCII characters, as well as characters not valid in XML
 * documents using numeric hexadecimal reference (eg. `&#xfc;`).
 *
 * Have a look at `escapeUTF8` if you want a more concise output at the expense
 * of reduced transportability.
 *
 * @param data String to escape.
 */
exports.escape = encodeXML;
/**
 * Creates a function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 *
 * @param regex Regular expression to match characters to escape.
 * @param map Map of characters to escape to their entities.
 *
 * @returns Function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 */
function getEscaper(regex, map) {
  return function escape(data) {
    var match;
    var lastIdx = 0;
    var result = "";
    while (match = regex.exec(data)) {
      if (lastIdx !== match.index) {
        result += data.substring(lastIdx, match.index);
      }
      // We know that this character will be in the map.
      result += map.get(match[0].charCodeAt(0));
      // Every match will be of length 1
      lastIdx = match.index + 1;
    }
    return result + data.substring(lastIdx);
  };
}
/**
 * Encodes all characters not valid in XML documents using XML entities.
 *
 * Note that the output will be character-set dependent.
 *
 * @param data String to escape.
 */
exports.escapeUTF8 = getEscaper(/[&<>'"]/g, xmlCodeMap);
/**
 * Encodes all characters that have to be escaped in HTML attributes,
 * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
 *
 * @param data String to escape.
 */
exports.escapeAttribute = getEscaper(/["&\u00A0]/g, new Map([[34, "&quot;"], [38, "&amp;"], [160, "&nbsp;"]]));
/**
 * Encodes all characters that have to be escaped in HTML text,
 * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
 *
 * @param data String to escape.
 */
exports.escapeText = getEscaper(/[&<>\u00A0]/g, new Map([[38, "&amp;"], [60, "&lt;"], [62, "&gt;"], [160, "&nbsp;"]]));

/***/ }),

/***/ "./node_modules/entities/lib/generated/decode-data-html.js":
/*!*****************************************************************!*\
  !*** ./node_modules/entities/lib/generated/decode-data-html.js ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";


// Generated using scripts/write-decode-map.ts
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = new Uint16Array(
// prettier-ignore
"\u1d41<\xd5\u0131\u028a\u049d\u057b\u05d0\u0675\u06de\u07a2\u07d6\u080f\u0a4a\u0a91\u0da1\u0e6d\u0f09\u0f26\u10ca\u1228\u12e1\u1415\u149d\u14c3\u14df\u1525\0\0\0\0\0\0\u156b\u16cd\u198d\u1c12\u1ddd\u1f7e\u2060\u21b0\u228d\u23c0\u23fb\u2442\u2824\u2912\u2d08\u2e48\u2fce\u3016\u32ba\u3639\u37ac\u38fe\u3a28\u3a71\u3ae0\u3b2e\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803b\xc6\u40c6P\u803b&\u4026cute\u803b\xc1\u40c1reve;\u4102\u0100iyx}rc\u803b\xc2\u40c2;\u4410r;\uc000\ud835\udd04rave\u803b\xc0\u40c0pha;\u4391acr;\u4100d;\u6a53\u0100gp\x9d\xa1on;\u4104f;\uc000\ud835\udd38plyFunction;\u6061ing\u803b\xc5\u40c5\u0100cs\xbe\xc3r;\uc000\ud835\udc9cign;\u6254ilde\u803b\xc3\u40c3ml\u803b\xc4\u40c4\u0400aceforsu\xe5\xfb\xfe\u0117\u011c\u0122\u0127\u012a\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6ae7ed;\u6306y;\u4411\u0180crt\u0105\u010b\u0114ause;\u6235noullis;\u612ca;\u4392r;\uc000\ud835\udd05pf;\uc000\ud835\udd39eve;\u42d8c\xf2\u0113mpeq;\u624e\u0700HOacdefhilorsu\u014d\u0151\u0156\u0180\u019e\u01a2\u01b5\u01b7\u01ba\u01dc\u0215\u0273\u0278\u027ecy;\u4427PY\u803b\xa9\u40a9\u0180cpy\u015d\u0162\u017aute;\u4106\u0100;i\u0167\u0168\u62d2talDifferentialD;\u6145leys;\u612d\u0200aeio\u0189\u018e\u0194\u0198ron;\u410cdil\u803b\xc7\u40c7rc;\u4108nint;\u6230ot;\u410a\u0100dn\u01a7\u01adilla;\u40b8terDot;\u40b7\xf2\u017fi;\u43a7rcle\u0200DMPT\u01c7\u01cb\u01d1\u01d6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01e2\u01f8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020foubleQuote;\u601duote;\u6019\u0200lnpu\u021e\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6a74\u0180git\u022f\u0236\u023aruent;\u6261nt;\u622fourIntegral;\u622e\u0100fr\u024c\u024e;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6a2fcr;\uc000\ud835\udc9ep\u0100;C\u0284\u0285\u62d3ap;\u624d\u0580DJSZacefios\u02a0\u02ac\u02b0\u02b4\u02b8\u02cb\u02d7\u02e1\u02e6\u0333\u048d\u0100;o\u0179\u02a5trahd;\u6911cy;\u4402cy;\u4405cy;\u440f\u0180grs\u02bf\u02c4\u02c7ger;\u6021r;\u61a1hv;\u6ae4\u0100ay\u02d0\u02d5ron;\u410e;\u4414l\u0100;t\u02dd\u02de\u6207a;\u4394r;\uc000\ud835\udd07\u0100af\u02eb\u0327\u0100cm\u02f0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031ccute;\u40b4o\u0174\u030b\u030d;\u42d9bleAcute;\u42ddrave;\u4060ilde;\u42dcond;\u62c4ferentialD;\u6146\u0470\u033d\0\0\0\u0342\u0354\0\u0405f;\uc000\ud835\udd3b\u0180;DE\u0348\u0349\u034d\u40a8ot;\u60dcqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03cf\u03e2\u03f8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037b\xbb\u0349nArrow;\u61d3\u0100eo\u0387\u03a4ft\u0180ART\u0390\u0396\u03a1rrow;\u61d0ightArrow;\u61d4e\xe5\u02cang\u0100LR\u03ab\u03c4eft\u0100AR\u03b3\u03b9rrow;\u67f8ightArrow;\u67faightArrow;\u67f9ight\u0100AT\u03d8\u03derrow;\u61d2ee;\u62a8p\u0241\u03e9\0\0\u03efrrow;\u61d1ownArrow;\u61d5erticalBar;\u6225n\u0300ABLRTa\u0412\u042a\u0430\u045e\u047f\u037crrow\u0180;BU\u041d\u041e\u0422\u6193ar;\u6913pArrow;\u61f5reve;\u4311eft\u02d2\u043a\0\u0446\0\u0450ightVector;\u6950eeVector;\u695eector\u0100;B\u0459\u045a\u61bdar;\u6956ight\u01d4\u0467\0\u0471eeVector;\u695fector\u0100;B\u047a\u047b\u61c1ar;\u6957ee\u0100;A\u0486\u0487\u62a4rrow;\u61a7\u0100ct\u0492\u0497r;\uc000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04bd\u04c0\u04c4\u04cb\u04de\u04e2\u04e7\u04ee\u04f5\u0521\u052f\u0536\u0552\u055d\u0560\u0565G;\u414aH\u803b\xd0\u40d0cute\u803b\xc9\u40c9\u0180aiy\u04d2\u04d7\u04dcron;\u411arc\u803b\xca\u40ca;\u442dot;\u4116r;\uc000\ud835\udd08rave\u803b\xc8\u40c8ement;\u6208\u0100ap\u04fa\u04fecr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65fberySmallSquare;\u65ab\u0100gp\u0526\u052aon;\u4118f;\uc000\ud835\udd3csilon;\u4395u\u0100ai\u053c\u0549l\u0100;T\u0542\u0543\u6a75ilde;\u6242librium;\u61cc\u0100ci\u0557\u055ar;\u6130m;\u6a73a;\u4397ml\u803b\xcb\u40cb\u0100ip\u056a\u056fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058d\u05b2\u05ccy;\u4424r;\uc000\ud835\udd09lled\u0253\u0597\0\0\u05a3mallSquare;\u65fcerySmallSquare;\u65aa\u0370\u05ba\0\u05bf\0\0\u05c4f;\uc000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05cb\u0600JTabcdfgorst\u05e8\u05ec\u05ef\u05fa\u0600\u0612\u0616\u061b\u061d\u0623\u066c\u0672cy;\u4403\u803b>\u403emma\u0100;d\u05f7\u05f8\u4393;\u43dcreve;\u411e\u0180eiy\u0607\u060c\u0610dil;\u4122rc;\u411c;\u4413ot;\u4120r;\uc000\ud835\udd0a;\u62d9pf;\uc000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064e\u0656\u065b\u0666qual\u0100;L\u063e\u063f\u6265ess;\u62dbullEqual;\u6267reater;\u6aa2ess;\u6277lantEqual;\u6a7eilde;\u6273cr;\uc000\ud835\udca2;\u626b\u0400Aacfiosu\u0685\u068b\u0696\u069b\u069e\u06aa\u06be\u06caRDcy;\u442a\u0100ct\u0690\u0694ek;\u42c7;\u405eirc;\u4124r;\u610clbertSpace;\u610b\u01f0\u06af\0\u06b2f;\u610dizontalLine;\u6500\u0100ct\u06c3\u06c5\xf2\u06a9rok;\u4126mp\u0144\u06d0\u06d8ownHum\xf0\u012fqual;\u624f\u0700EJOacdfgmnostu\u06fa\u06fe\u0703\u0707\u070e\u071a\u071e\u0721\u0728\u0744\u0778\u078b\u078f\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803b\xcd\u40cd\u0100iy\u0713\u0718rc\u803b\xce\u40ce;\u4418ot;\u4130r;\u6111rave\u803b\xcc\u40cc\u0180;ap\u0720\u072f\u073f\u0100cg\u0734\u0737r;\u412ainaryI;\u6148lie\xf3\u03dd\u01f4\u0749\0\u0762\u0100;e\u074d\u074e\u622c\u0100gr\u0753\u0758ral;\u622bsection;\u62c2isible\u0100CT\u076c\u0772omma;\u6063imes;\u6062\u0180gpt\u077f\u0783\u0788on;\u412ef;\uc000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01eb\u079a\0\u079ecy;\u4406l\u803b\xcf\u40cf\u0280cfosu\u07ac\u07b7\u07bc\u07c2\u07d0\u0100iy\u07b1\u07b5rc;\u4134;\u4419r;\uc000\ud835\udd0dpf;\uc000\ud835\udd41\u01e3\u07c7\0\u07ccr;\uc000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07e4\u07e8\u07ec\u07f1\u07fd\u0802\u0808cy;\u4425cy;\u440cppa;\u439a\u0100ey\u07f6\u07fbdil;\u4136;\u441ar;\uc000\ud835\udd0epf;\uc000\ud835\udd42cr;\uc000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082c\u0850\u0863\u09b3\u09b8\u09c7\u09cd\u0a37\u0a47cy;\u4409\u803b<\u403c\u0280cmnpr\u0837\u083c\u0841\u0844\u084dute;\u4139bda;\u439bg;\u67ealacetrf;\u6112r;\u619e\u0180aey\u0857\u085c\u0861ron;\u413ddil;\u413b;\u441b\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087e\u08a9\u08b1\u08e0\u08e6\u08fc\u092f\u095b\u0390\u096a\u0100nr\u0883\u088fgleBracket;\u67e8row\u0180;BR\u0899\u089a\u089e\u6190ar;\u61e4ightArrow;\u61c6eiling;\u6308o\u01f5\u08b7\0\u08c3bleBracket;\u67e6n\u01d4\u08c8\0\u08d2eeVector;\u6961ector\u0100;B\u08db\u08dc\u61c3ar;\u6959loor;\u630aight\u0100AV\u08ef\u08f5rrow;\u6194ector;\u694e\u0100er\u0901\u0917e\u0180;AV\u0909\u090a\u0910\u62a3rrow;\u61a4ector;\u695aiangle\u0180;BE\u0924\u0925\u0929\u62b2ar;\u69cfqual;\u62b4p\u0180DTV\u0937\u0942\u094cownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61bfar;\u6958ector\u0100;B\u0965\u0966\u61bcar;\u6952ight\xe1\u039cs\u0300EFGLST\u097e\u098b\u0995\u099d\u09a2\u09adqualGreater;\u62daullEqual;\u6266reater;\u6276ess;\u6aa1lantEqual;\u6a7dilde;\u6272r;\uc000\ud835\udd0f\u0100;e\u09bd\u09be\u62d8ftarrow;\u61daidot;\u413f\u0180npw\u09d4\u0a16\u0a1bg\u0200LRlr\u09de\u09f7\u0a02\u0a10eft\u0100AR\u09e6\u09ecrrow;\u67f5ightArrow;\u67f7ightArrow;\u67f6eft\u0100ar\u03b3\u0a0aight\xe1\u03bfight\xe1\u03caf;\uc000\ud835\udd43er\u0100LR\u0a22\u0a2ceftArrow;\u6199ightArrow;\u6198\u0180cht\u0a3e\u0a40\u0a42\xf2\u084c;\u61b0rok;\u4141;\u626a\u0400acefiosu\u0a5a\u0a5d\u0a60\u0a77\u0a7c\u0a85\u0a8b\u0a8ep;\u6905y;\u441c\u0100dl\u0a65\u0a6fiumSpace;\u605flintrf;\u6133r;\uc000\ud835\udd10nusPlus;\u6213pf;\uc000\ud835\udd44c\xf2\u0a76;\u439c\u0480Jacefostu\u0aa3\u0aa7\u0aad\u0ac0\u0b14\u0b19\u0d91\u0d97\u0d9ecy;\u440acute;\u4143\u0180aey\u0ab4\u0ab9\u0aberon;\u4147dil;\u4145;\u441d\u0180gsw\u0ac7\u0af0\u0b0eative\u0180MTV\u0ad3\u0adf\u0ae8ediumSpace;\u600bhi\u0100cn\u0ae6\u0ad8\xeb\u0ad9eryThi\xee\u0ad9ted\u0100GL\u0af8\u0b06reaterGreate\xf2\u0673essLes\xf3\u0a48Line;\u400ar;\uc000\ud835\udd11\u0200Bnpt\u0b22\u0b28\u0b37\u0b3areak;\u6060BreakingSpace;\u40a0f;\u6115\u0680;CDEGHLNPRSTV\u0b55\u0b56\u0b6a\u0b7c\u0ba1\u0beb\u0c04\u0c5e\u0c84\u0ca6\u0cd8\u0d61\u0d85\u6aec\u0100ou\u0b5b\u0b64ngruent;\u6262pCap;\u626doubleVerticalBar;\u6226\u0180lqx\u0b83\u0b8a\u0b9bement;\u6209ual\u0100;T\u0b92\u0b93\u6260ilde;\uc000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0bb6\u0bb7\u0bbd\u0bc9\u0bd3\u0bd8\u0be5\u626fqual;\u6271ullEqual;\uc000\u2267\u0338reater;\uc000\u226b\u0338ess;\u6279lantEqual;\uc000\u2a7e\u0338ilde;\u6275ump\u0144\u0bf2\u0bfdownHump;\uc000\u224e\u0338qual;\uc000\u224f\u0338e\u0100fs\u0c0a\u0c27tTriangle\u0180;BE\u0c1a\u0c1b\u0c21\u62eaar;\uc000\u29cf\u0338qual;\u62ecs\u0300;EGLST\u0c35\u0c36\u0c3c\u0c44\u0c4b\u0c58\u626equal;\u6270reater;\u6278ess;\uc000\u226a\u0338lantEqual;\uc000\u2a7d\u0338ilde;\u6274ested\u0100GL\u0c68\u0c79reaterGreater;\uc000\u2aa2\u0338essLess;\uc000\u2aa1\u0338recedes\u0180;ES\u0c92\u0c93\u0c9b\u6280qual;\uc000\u2aaf\u0338lantEqual;\u62e0\u0100ei\u0cab\u0cb9verseElement;\u620cghtTriangle\u0180;BE\u0ccb\u0ccc\u0cd2\u62ebar;\uc000\u29d0\u0338qual;\u62ed\u0100qu\u0cdd\u0d0cuareSu\u0100bp\u0ce8\u0cf9set\u0100;E\u0cf0\u0cf3\uc000\u228f\u0338qual;\u62e2erset\u0100;E\u0d03\u0d06\uc000\u2290\u0338qual;\u62e3\u0180bcp\u0d13\u0d24\u0d4eset\u0100;E\u0d1b\u0d1e\uc000\u2282\u20d2qual;\u6288ceeds\u0200;EST\u0d32\u0d33\u0d3b\u0d46\u6281qual;\uc000\u2ab0\u0338lantEqual;\u62e1ilde;\uc000\u227f\u0338erset\u0100;E\u0d58\u0d5b\uc000\u2283\u20d2qual;\u6289ilde\u0200;EFT\u0d6e\u0d6f\u0d75\u0d7f\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uc000\ud835\udca9ilde\u803b\xd1\u40d1;\u439d\u0700Eacdfgmoprstuv\u0dbd\u0dc2\u0dc9\u0dd5\u0ddb\u0de0\u0de7\u0dfc\u0e02\u0e20\u0e22\u0e32\u0e3f\u0e44lig;\u4152cute\u803b\xd3\u40d3\u0100iy\u0dce\u0dd3rc\u803b\xd4\u40d4;\u441eblac;\u4150r;\uc000\ud835\udd12rave\u803b\xd2\u40d2\u0180aei\u0dee\u0df2\u0df6cr;\u414cga;\u43a9cron;\u439fpf;\uc000\ud835\udd46enCurly\u0100DQ\u0e0e\u0e1aoubleQuote;\u601cuote;\u6018;\u6a54\u0100cl\u0e27\u0e2cr;\uc000\ud835\udcaaash\u803b\xd8\u40d8i\u016c\u0e37\u0e3cde\u803b\xd5\u40d5es;\u6a37ml\u803b\xd6\u40d6er\u0100BP\u0e4b\u0e60\u0100ar\u0e50\u0e53r;\u603eac\u0100ek\u0e5a\u0e5c;\u63deet;\u63b4arenthesis;\u63dc\u0480acfhilors\u0e7f\u0e87\u0e8a\u0e8f\u0e92\u0e94\u0e9d\u0eb0\u0efcrtialD;\u6202y;\u441fr;\uc000\ud835\udd13i;\u43a6;\u43a0usMinus;\u40b1\u0100ip\u0ea2\u0eadncareplan\xe5\u069df;\u6119\u0200;eio\u0eb9\u0eba\u0ee0\u0ee4\u6abbcedes\u0200;EST\u0ec8\u0ec9\u0ecf\u0eda\u627aqual;\u6aaflantEqual;\u627cilde;\u627eme;\u6033\u0100dp\u0ee9\u0eeeuct;\u620fortion\u0100;a\u0225\u0ef9l;\u621d\u0100ci\u0f01\u0f06r;\uc000\ud835\udcab;\u43a8\u0200Ufos\u0f11\u0f16\u0f1b\u0f1fOT\u803b\"\u4022r;\uc000\ud835\udd14pf;\u611acr;\uc000\ud835\udcac\u0600BEacefhiorsu\u0f3e\u0f43\u0f47\u0f60\u0f73\u0fa7\u0faa\u0fad\u1096\u10a9\u10b4\u10bearr;\u6910G\u803b\xae\u40ae\u0180cnr\u0f4e\u0f53\u0f56ute;\u4154g;\u67ebr\u0100;t\u0f5c\u0f5d\u61a0l;\u6916\u0180aey\u0f67\u0f6c\u0f71ron;\u4158dil;\u4156;\u4420\u0100;v\u0f78\u0f79\u611cerse\u0100EU\u0f82\u0f99\u0100lq\u0f87\u0f8eement;\u620builibrium;\u61cbpEquilibrium;\u696fr\xbb\u0f79o;\u43a1ght\u0400ACDFTUVa\u0fc1\u0feb\u0ff3\u1022\u1028\u105b\u1087\u03d8\u0100nr\u0fc6\u0fd2gleBracket;\u67e9row\u0180;BL\u0fdc\u0fdd\u0fe1\u6192ar;\u61e5eftArrow;\u61c4eiling;\u6309o\u01f5\u0ff9\0\u1005bleBracket;\u67e7n\u01d4\u100a\0\u1014eeVector;\u695dector\u0100;B\u101d\u101e\u61c2ar;\u6955loor;\u630b\u0100er\u102d\u1043e\u0180;AV\u1035\u1036\u103c\u62a2rrow;\u61a6ector;\u695biangle\u0180;BE\u1050\u1051\u1055\u62b3ar;\u69d0qual;\u62b5p\u0180DTV\u1063\u106e\u1078ownVector;\u694feeVector;\u695cector\u0100;B\u1082\u1083\u61bear;\u6954ector\u0100;B\u1091\u1092\u61c0ar;\u6953\u0100pu\u109b\u109ef;\u611dndImplies;\u6970ightarrow;\u61db\u0100ch\u10b9\u10bcr;\u611b;\u61b1leDelayed;\u69f4\u0680HOacfhimoqstu\u10e4\u10f1\u10f7\u10fd\u1119\u111e\u1151\u1156\u1161\u1167\u11b5\u11bb\u11bf\u0100Cc\u10e9\u10eeHcy;\u4429y;\u4428FTcy;\u442ccute;\u415a\u0280;aeiy\u1108\u1109\u110e\u1113\u1117\u6abcron;\u4160dil;\u415erc;\u415c;\u4421r;\uc000\ud835\udd16ort\u0200DLRU\u112a\u1134\u113e\u1149ownArrow\xbb\u041eeftArrow\xbb\u089aightArrow\xbb\u0fddpArrow;\u6191gma;\u43a3allCircle;\u6218pf;\uc000\ud835\udd4a\u0272\u116d\0\0\u1170t;\u621aare\u0200;ISU\u117b\u117c\u1189\u11af\u65a1ntersection;\u6293u\u0100bp\u118f\u119eset\u0100;E\u1197\u1198\u628fqual;\u6291erset\u0100;E\u11a8\u11a9\u6290qual;\u6292nion;\u6294cr;\uc000\ud835\udcaear;\u62c6\u0200bcmp\u11c8\u11db\u1209\u120b\u0100;s\u11cd\u11ce\u62d0et\u0100;E\u11cd\u11d5qual;\u6286\u0100ch\u11e0\u1205eeds\u0200;EST\u11ed\u11ee\u11f4\u11ff\u627bqual;\u6ab0lantEqual;\u627dilde;\u627fTh\xe1\u0f8c;\u6211\u0180;es\u1212\u1213\u1223\u62d1rset\u0100;E\u121c\u121d\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123e\u1244\u1249\u1255\u125e\u1271\u1276\u129f\u12c2\u12c8\u12d1ORN\u803b\xde\u40deADE;\u6122\u0100Hc\u124e\u1252cy;\u440by;\u4426\u0100bu\u125a\u125c;\u4009;\u43a4\u0180aey\u1265\u126a\u126fron;\u4164dil;\u4162;\u4422r;\uc000\ud835\udd17\u0100ei\u127b\u1289\u01f2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128e\u1298kSpace;\uc000\u205f\u200aSpace;\u6009lde\u0200;EFT\u12ab\u12ac\u12b2\u12bc\u623cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uc000\ud835\udd4bipleDot;\u60db\u0100ct\u12d6\u12dbr;\uc000\ud835\udcafrok;\u4166\u0ae1\u12f7\u130e\u131a\u1326\0\u132c\u1331\0\0\0\0\0\u1338\u133d\u1377\u1385\0\u13ff\u1404\u140a\u1410\u0100cr\u12fb\u1301ute\u803b\xda\u40dar\u0100;o\u1307\u1308\u619fcir;\u6949r\u01e3\u1313\0\u1316y;\u440eve;\u416c\u0100iy\u131e\u1323rc\u803b\xdb\u40db;\u4423blac;\u4170r;\uc000\ud835\udd18rave\u803b\xd9\u40d9acr;\u416a\u0100di\u1341\u1369er\u0100BP\u1348\u135d\u0100ar\u134d\u1350r;\u405fac\u0100ek\u1357\u1359;\u63dfet;\u63b5arenthesis;\u63ddon\u0100;P\u1370\u1371\u62c3lus;\u628e\u0100gp\u137b\u137fon;\u4172f;\uc000\ud835\udd4c\u0400ADETadps\u1395\u13ae\u13b8\u13c4\u03e8\u13d2\u13d7\u13f3rrow\u0180;BD\u1150\u13a0\u13a4ar;\u6912ownArrow;\u61c5ownArrow;\u6195quilibrium;\u696eee\u0100;A\u13cb\u13cc\u62a5rrow;\u61a5own\xe1\u03f3er\u0100LR\u13de\u13e8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13f9\u13fa\u43d2on;\u43a5ing;\u416ecr;\uc000\ud835\udcb0ilde;\u4168ml\u803b\xdc\u40dc\u0480Dbcdefosv\u1427\u142c\u1430\u1433\u143e\u1485\u148a\u1490\u1496ash;\u62abar;\u6aeby;\u4412ash\u0100;l\u143b\u143c\u62a9;\u6ae6\u0100er\u1443\u1445;\u62c1\u0180bty\u144c\u1450\u147aar;\u6016\u0100;i\u144f\u1455cal\u0200BLST\u1461\u1465\u146a\u1474ar;\u6223ine;\u407ceparator;\u6758ilde;\u6240ThinSpace;\u600ar;\uc000\ud835\udd19pf;\uc000\ud835\udd4dcr;\uc000\ud835\udcb1dash;\u62aa\u0280cefos\u14a7\u14ac\u14b1\u14b6\u14bcirc;\u4174dge;\u62c0r;\uc000\ud835\udd1apf;\uc000\ud835\udd4ecr;\uc000\ud835\udcb2\u0200fios\u14cb\u14d0\u14d2\u14d8r;\uc000\ud835\udd1b;\u439epf;\uc000\ud835\udd4fcr;\uc000\ud835\udcb3\u0480AIUacfosu\u14f1\u14f5\u14f9\u14fd\u1504\u150f\u1514\u151a\u1520cy;\u442fcy;\u4407cy;\u442ecute\u803b\xdd\u40dd\u0100iy\u1509\u150drc;\u4176;\u442br;\uc000\ud835\udd1cpf;\uc000\ud835\udd50cr;\uc000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153f\u154b\u154f\u155d\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417d;\u4417ot;\u417b\u01f2\u1554\0\u155boWidt\xe8\u0ad9a;\u4396r;\u6128pf;\u6124cr;\uc000\ud835\udcb5\u0be1\u1583\u158a\u1590\0\u15b0\u15b6\u15bf\0\0\0\0\u15c6\u15db\u15eb\u165f\u166d\0\u1695\u169b\u16b2\u16b9\0\u16becute\u803b\xe1\u40e1reve;\u4103\u0300;Ediuy\u159c\u159d\u15a1\u15a3\u15a8\u15ad\u623e;\uc000\u223e\u0333;\u623frc\u803b\xe2\u40e2te\u80bb\xb4\u0306;\u4430lig\u803b\xe6\u40e6\u0100;r\xb2\u15ba;\uc000\ud835\udd1erave\u803b\xe0\u40e0\u0100ep\u15ca\u15d6\u0100fp\u15cf\u15d4sym;\u6135\xe8\u15d3ha;\u43b1\u0100ap\u15dfc\u0100cl\u15e4\u15e7r;\u4101g;\u6a3f\u0264\u15f0\0\0\u160a\u0280;adsv\u15fa\u15fb\u15ff\u1601\u1607\u6227nd;\u6a55;\u6a5clope;\u6a58;\u6a5a\u0380;elmrsz\u1618\u1619\u161b\u161e\u163f\u164f\u1659\u6220;\u69a4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163a\u163c\u163e;\u69a8;\u69a9;\u69aa;\u69ab;\u69ac;\u69ad;\u69ae;\u69aft\u0100;v\u1645\u1646\u621fb\u0100;d\u164c\u164d\u62be;\u699d\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637c\u0100gp\u1663\u1667on;\u4105f;\uc000\ud835\udd52\u0380;Eaeiop\u12c1\u167b\u167d\u1682\u1684\u1687\u168a;\u6a70cir;\u6a6f;\u624ad;\u624bs;\u4027rox\u0100;e\u12c1\u1692\xf1\u1683ing\u803b\xe5\u40e5\u0180cty\u16a1\u16a6\u16a8r;\uc000\ud835\udcb6;\u402amp\u0100;e\u12c1\u16af\xf1\u0288ilde\u803b\xe3\u40e3ml\u803b\xe4\u40e4\u0100ci\u16c2\u16c8onin\xf4\u0272nt;\u6a11\u0800Nabcdefiklnoprsu\u16ed\u16f1\u1730\u173c\u1743\u1748\u1778\u177d\u17e0\u17e6\u1839\u1850\u170d\u193d\u1948\u1970ot;\u6aed\u0100cr\u16f6\u171ek\u0200ceps\u1700\u1705\u170d\u1713ong;\u624cpsilon;\u43f6rime;\u6035im\u0100;e\u171a\u171b\u623dq;\u62cd\u0176\u1722\u1726ee;\u62bded\u0100;g\u172c\u172d\u6305e\xbb\u172drk\u0100;t\u135c\u1737brk;\u63b6\u0100oy\u1701\u1741;\u4431quo;\u601e\u0280cmprt\u1753\u175b\u1761\u1764\u1768aus\u0100;e\u010a\u0109ptyv;\u69b0s\xe9\u170cno\xf5\u0113\u0180ahw\u176f\u1771\u1773;\u43b2;\u6136een;\u626cr;\uc000\ud835\udd1fg\u0380costuvw\u178d\u179d\u17b3\u17c1\u17d5\u17db\u17de\u0180aiu\u1794\u1796\u179a\xf0\u0760rc;\u65efp\xbb\u1371\u0180dpt\u17a4\u17a8\u17adot;\u6a00lus;\u6a01imes;\u6a02\u0271\u17b9\0\0\u17becup;\u6a06ar;\u6605riangle\u0100du\u17cd\u17d2own;\u65bdp;\u65b3plus;\u6a04e\xe5\u1444\xe5\u14adarow;\u690d\u0180ako\u17ed\u1826\u1835\u0100cn\u17f2\u1823k\u0180lst\u17fa\u05ab\u1802ozenge;\u69ebriangle\u0200;dlr\u1812\u1813\u1818\u181d\u65b4own;\u65beeft;\u65c2ight;\u65b8k;\u6423\u01b1\u182b\0\u1833\u01b2\u182f\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183e\u184d\u0100;q\u1843\u1846\uc000=\u20e5uiv;\uc000\u2261\u20e5t;\u6310\u0200ptwx\u1859\u185e\u1867\u186cf;\uc000\ud835\udd53\u0100;t\u13cb\u1863om\xbb\u13cctie;\u62c8\u0600DHUVbdhmptuv\u1885\u1896\u18aa\u18bb\u18d7\u18db\u18ec\u18ff\u1905\u190a\u1910\u1921\u0200LRlr\u188e\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18a1\u18a2\u18a4\u18a6\u18a8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18b3\u18b5\u18b7\u18b9;\u655d;\u655a;\u655c;\u6559\u0380;HLRhlr\u18ca\u18cb\u18cd\u18cf\u18d1\u18d3\u18d5\u6551;\u656c;\u6563;\u6560;\u656b;\u6562;\u655fox;\u69c9\u0200LRlr\u18e4\u18e6\u18e8\u18ea;\u6555;\u6552;\u6510;\u650c\u0280;DUdu\u06bd\u18f7\u18f9\u18fb\u18fd;\u6565;\u6568;\u652c;\u6534inus;\u629flus;\u629eimes;\u62a0\u0200LRlr\u1919\u191b\u191d\u191f;\u655b;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193b\u6502;\u656a;\u6561;\u655e;\u653c;\u6524;\u651c\u0100ev\u0123\u1942bar\u803b\xa6\u40a6\u0200ceio\u1951\u1956\u195a\u1960r;\uc000\ud835\udcb7mi;\u604fm\u0100;e\u171a\u171cl\u0180;bh\u1968\u1969\u196b\u405c;\u69c5sub;\u67c8\u016c\u1974\u197el\u0100;e\u1979\u197a\u6022t\xbb\u197ap\u0180;Ee\u012f\u1985\u1987;\u6aae\u0100;q\u06dc\u06db\u0ce1\u19a7\0\u19e8\u1a11\u1a15\u1a32\0\u1a37\u1a50\0\0\u1ab4\0\0\u1ac1\0\0\u1b21\u1b2e\u1b4d\u1b52\0\u1bfd\0\u1c0c\u0180cpr\u19ad\u19b2\u19ddute;\u4107\u0300;abcds\u19bf\u19c0\u19c4\u19ca\u19d5\u19d9\u6229nd;\u6a44rcup;\u6a49\u0100au\u19cf\u19d2p;\u6a4bp;\u6a47ot;\u6a40;\uc000\u2229\ufe00\u0100eo\u19e2\u19e5t;\u6041\xee\u0693\u0200aeiu\u19f0\u19fb\u1a01\u1a05\u01f0\u19f5\0\u19f8s;\u6a4don;\u410ddil\u803b\xe7\u40e7rc;\u4109ps\u0100;s\u1a0c\u1a0d\u6a4cm;\u6a50ot;\u410b\u0180dmn\u1a1b\u1a20\u1a26il\u80bb\xb8\u01adptyv;\u69b2t\u8100\xa2;e\u1a2d\u1a2e\u40a2r\xe4\u01b2r;\uc000\ud835\udd20\u0180cei\u1a3d\u1a40\u1a4dy;\u4447ck\u0100;m\u1a47\u1a48\u6713ark\xbb\u1a48;\u43c7r\u0380;Ecefms\u1a5f\u1a60\u1a62\u1a6b\u1aa4\u1aaa\u1aae\u65cb;\u69c3\u0180;el\u1a69\u1a6a\u1a6d\u42c6q;\u6257e\u0261\u1a74\0\0\u1a88rrow\u0100lr\u1a7c\u1a81eft;\u61baight;\u61bb\u0280RSacd\u1a92\u1a94\u1a96\u1a9a\u1a9f\xbb\u0f47;\u64c8st;\u629birc;\u629aash;\u629dnint;\u6a10id;\u6aefcir;\u69c2ubs\u0100;u\u1abb\u1abc\u6663it\xbb\u1abc\u02ec\u1ac7\u1ad4\u1afa\0\u1b0aon\u0100;e\u1acd\u1ace\u403a\u0100;q\xc7\xc6\u026d\u1ad9\0\0\u1ae2a\u0100;t\u1ade\u1adf\u402c;\u4040\u0180;fl\u1ae8\u1ae9\u1aeb\u6201\xee\u1160e\u0100mx\u1af1\u1af6ent\xbb\u1ae9e\xf3\u024d\u01e7\u1afe\0\u1b07\u0100;d\u12bb\u1b02ot;\u6a6dn\xf4\u0246\u0180fry\u1b10\u1b14\u1b17;\uc000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1b1dr;\u6117\u0100ao\u1b25\u1b29rr;\u61b5ss;\u6717\u0100cu\u1b32\u1b37r;\uc000\ud835\udcb8\u0100bp\u1b3c\u1b44\u0100;e\u1b41\u1b42\u6acf;\u6ad1\u0100;e\u1b49\u1b4a\u6ad0;\u6ad2dot;\u62ef\u0380delprvw\u1b60\u1b6c\u1b77\u1b82\u1bac\u1bd4\u1bf9arr\u0100lr\u1b68\u1b6a;\u6938;\u6935\u0270\u1b72\0\0\u1b75r;\u62dec;\u62dfarr\u0100;p\u1b7f\u1b80\u61b6;\u693d\u0300;bcdos\u1b8f\u1b90\u1b96\u1ba1\u1ba5\u1ba8\u622arcap;\u6a48\u0100au\u1b9b\u1b9ep;\u6a46p;\u6a4aot;\u628dr;\u6a45;\uc000\u222a\ufe00\u0200alrv\u1bb5\u1bbf\u1bde\u1be3rr\u0100;m\u1bbc\u1bbd\u61b7;\u693cy\u0180evw\u1bc7\u1bd4\u1bd8q\u0270\u1bce\0\0\u1bd2re\xe3\u1b73u\xe3\u1b75ee;\u62ceedge;\u62cfen\u803b\xa4\u40a4earrow\u0100lr\u1bee\u1bf3eft\xbb\u1b80ight\xbb\u1bbde\xe4\u1bdd\u0100ci\u1c01\u1c07onin\xf4\u01f7nt;\u6231lcty;\u632d\u0980AHabcdefhijlorstuwz\u1c38\u1c3b\u1c3f\u1c5d\u1c69\u1c75\u1c8a\u1c9e\u1cac\u1cb7\u1cfb\u1cff\u1d0d\u1d7b\u1d91\u1dab\u1dbb\u1dc6\u1dcdr\xf2\u0381ar;\u6965\u0200glrs\u1c48\u1c4d\u1c52\u1c54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1c5a\u1c5b\u6010\xbb\u090a\u016b\u1c61\u1c67arow;\u690fa\xe3\u0315\u0100ay\u1c6e\u1c73ron;\u410f;\u4434\u0180;ao\u0332\u1c7c\u1c84\u0100gr\u02bf\u1c81r;\u61catseq;\u6a77\u0180glm\u1c91\u1c94\u1c98\u803b\xb0\u40b0ta;\u43b4ptyv;\u69b1\u0100ir\u1ca3\u1ca8sht;\u697f;\uc000\ud835\udd21ar\u0100lr\u1cb3\u1cb5\xbb\u08dc\xbb\u101e\u0280aegsv\u1cc2\u0378\u1cd6\u1cdc\u1ce0m\u0180;os\u0326\u1cca\u1cd4nd\u0100;s\u0326\u1cd1uit;\u6666amma;\u43ddin;\u62f2\u0180;io\u1ce7\u1ce8\u1cf8\u40f7de\u8100\xf7;o\u1ce7\u1cf0ntimes;\u62c7n\xf8\u1cf7cy;\u4452c\u026f\u1d06\0\0\u1d0arn;\u631eop;\u630d\u0280lptuw\u1d18\u1d1d\u1d22\u1d49\u1d55lar;\u4024f;\uc000\ud835\udd55\u0280;emps\u030b\u1d2d\u1d37\u1d3d\u1d42q\u0100;d\u0352\u1d33ot;\u6251inus;\u6238lus;\u6214quare;\u62a1blebarwedg\xe5\xfan\u0180adh\u112e\u1d5d\u1d67ownarrow\xf3\u1c83arpoon\u0100lr\u1d72\u1d76ef\xf4\u1cb4igh\xf4\u1cb6\u0162\u1d7f\u1d85karo\xf7\u0f42\u026f\u1d8a\0\0\u1d8ern;\u631fop;\u630c\u0180cot\u1d98\u1da3\u1da6\u0100ry\u1d9d\u1da1;\uc000\ud835\udcb9;\u4455l;\u69f6rok;\u4111\u0100dr\u1db0\u1db4ot;\u62f1i\u0100;f\u1dba\u1816\u65bf\u0100ah\u1dc0\u1dc3r\xf2\u0429a\xf2\u0fa6angle;\u69a6\u0100ci\u1dd2\u1dd5y;\u445fgrarr;\u67ff\u0900Dacdefglmnopqrstux\u1e01\u1e09\u1e19\u1e38\u0578\u1e3c\u1e49\u1e61\u1e7e\u1ea5\u1eaf\u1ebd\u1ee1\u1f2a\u1f37\u1f44\u1f4e\u1f5a\u0100Do\u1e06\u1d34o\xf4\u1c89\u0100cs\u1e0e\u1e14ute\u803b\xe9\u40e9ter;\u6a6e\u0200aioy\u1e22\u1e27\u1e31\u1e36ron;\u411br\u0100;c\u1e2d\u1e2e\u6256\u803b\xea\u40ealon;\u6255;\u444dot;\u4117\u0100Dr\u1e41\u1e45ot;\u6252;\uc000\ud835\udd22\u0180;rs\u1e50\u1e51\u1e57\u6a9aave\u803b\xe8\u40e8\u0100;d\u1e5c\u1e5d\u6a96ot;\u6a98\u0200;ils\u1e6a\u1e6b\u1e72\u1e74\u6a99nters;\u63e7;\u6113\u0100;d\u1e79\u1e7a\u6a95ot;\u6a97\u0180aps\u1e85\u1e89\u1e97cr;\u4113ty\u0180;sv\u1e92\u1e93\u1e95\u6205et\xbb\u1e93p\u01001;\u1e9d\u1ea4\u0133\u1ea1\u1ea3;\u6004;\u6005\u6003\u0100gs\u1eaa\u1eac;\u414bp;\u6002\u0100gp\u1eb4\u1eb8on;\u4119f;\uc000\ud835\udd56\u0180als\u1ec4\u1ece\u1ed2r\u0100;s\u1eca\u1ecb\u62d5l;\u69e3us;\u6a71i\u0180;lv\u1eda\u1edb\u1edf\u43b5on\xbb\u1edb;\u43f5\u0200csuv\u1eea\u1ef3\u1f0b\u1f23\u0100io\u1eef\u1e31rc\xbb\u1e2e\u0269\u1ef9\0\0\u1efb\xed\u0548ant\u0100gl\u1f02\u1f06tr\xbb\u1e5dess\xbb\u1e7a\u0180aei\u1f12\u1f16\u1f1als;\u403dst;\u625fv\u0100;D\u0235\u1f20D;\u6a78parsl;\u69e5\u0100Da\u1f2f\u1f33ot;\u6253rr;\u6971\u0180cdi\u1f3e\u1f41\u1ef8r;\u612fo\xf4\u0352\u0100ah\u1f49\u1f4b;\u43b7\u803b\xf0\u40f0\u0100mr\u1f53\u1f57l\u803b\xeb\u40ebo;\u60ac\u0180cip\u1f61\u1f64\u1f67l;\u4021s\xf4\u056e\u0100eo\u1f6c\u1f74ctatio\xee\u0559nential\xe5\u0579\u09e1\u1f92\0\u1f9e\0\u1fa1\u1fa7\0\0\u1fc6\u1fcc\0\u1fd3\0\u1fe6\u1fea\u2000\0\u2008\u205allingdotse\xf1\u1e44y;\u4444male;\u6640\u0180ilr\u1fad\u1fb3\u1fc1lig;\u8000\ufb03\u0269\u1fb9\0\0\u1fbdg;\u8000\ufb00ig;\u8000\ufb04;\uc000\ud835\udd23lig;\u8000\ufb01lig;\uc000fj\u0180alt\u1fd9\u1fdc\u1fe1t;\u666dig;\u8000\ufb02ns;\u65b1of;\u4192\u01f0\u1fee\0\u1ff3f;\uc000\ud835\udd57\u0100ak\u05bf\u1ff7\u0100;v\u1ffc\u1ffd\u62d4;\u6ad9artint;\u6a0d\u0100ao\u200c\u2055\u0100cs\u2011\u2052\u03b1\u201a\u2030\u2038\u2045\u2048\0\u2050\u03b2\u2022\u2025\u2027\u202a\u202c\0\u202e\u803b\xbd\u40bd;\u6153\u803b\xbc\u40bc;\u6155;\u6159;\u615b\u01b3\u2034\0\u2036;\u6154;\u6156\u02b4\u203e\u2041\0\0\u2043\u803b\xbe\u40be;\u6157;\u615c5;\u6158\u01b6\u204c\0\u204e;\u615a;\u615d8;\u615el;\u6044wn;\u6322cr;\uc000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209f\u20a5\u20b0\u20b4\u20f0\u20f5\u20fa\u20ff\u2103\u2112\u2138\u0317\u213e\u2152\u219e\u0100;l\u064d\u2087;\u6a8c\u0180cmp\u2090\u2095\u209dute;\u41f5ma\u0100;d\u209c\u1cda\u43b3;\u6a86reve;\u411f\u0100iy\u20aa\u20aerc;\u411d;\u4433ot;\u4121\u0200;lqs\u063e\u0642\u20bd\u20c9\u0180;qs\u063e\u064c\u20c4lan\xf4\u0665\u0200;cdl\u0665\u20d2\u20d5\u20e5c;\u6aa9ot\u0100;o\u20dc\u20dd\u6a80\u0100;l\u20e2\u20e3\u6a82;\u6a84\u0100;e\u20ea\u20ed\uc000\u22db\ufe00s;\u6a94r;\uc000\ud835\udd24\u0100;g\u0673\u061bmel;\u6137cy;\u4453\u0200;Eaj\u065a\u210c\u210e\u2110;\u6a92;\u6aa5;\u6aa4\u0200Eaes\u211b\u211d\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6a8arox\xbb\u2124\u0100;q\u212e\u212f\u6a88\u0100;q\u212e\u211bim;\u62e7pf;\uc000\ud835\udd58\u0100ci\u2143\u2146r;\u610am\u0180;el\u066b\u214e\u2150;\u6a8e;\u6a90\u8300>;cdlqr\u05ee\u2160\u216a\u216e\u2173\u2179\u0100ci\u2165\u2167;\u6aa7r;\u6a7aot;\u62d7Par;\u6995uest;\u6a7c\u0280adels\u2184\u216a\u2190\u0656\u219b\u01f0\u2189\0\u218epro\xf8\u209er;\u6978q\u0100lq\u063f\u2196les\xf3\u2088i\xed\u066b\u0100en\u21a3\u21adrtneqq;\uc000\u2269\ufe00\xc5\u21aa\u0500Aabcefkosy\u21c4\u21c7\u21f1\u21f5\u21fa\u2218\u221d\u222f\u2268\u227dr\xf2\u03a0\u0200ilmr\u21d0\u21d4\u21d7\u21dbrs\xf0\u1484f\xbb\u2024il\xf4\u06a9\u0100dr\u21e0\u21e4cy;\u444a\u0180;cw\u08f4\u21eb\u21efir;\u6948;\u61adar;\u610firc;\u4125\u0180alr\u2201\u220e\u2213rts\u0100;u\u2209\u220a\u6665it\xbb\u220alip;\u6026con;\u62b9r;\uc000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223a\u223e\u2243\u225e\u2263rr;\u61fftht;\u623bk\u0100lr\u2249\u2253eftarrow;\u61a9ightarrow;\u61aaf;\uc000\ud835\udd59bar;\u6015\u0180clt\u226f\u2274\u2278r;\uc000\ud835\udcbdas\xe8\u21f4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1c5b\u0ae1\u22a3\0\u22aa\0\u22b8\u22c5\u22ce\0\u22d5\u22f3\0\0\u22f8\u2322\u2367\u2362\u237f\0\u2386\u23aa\u23b4cute\u803b\xed\u40ed\u0180;iy\u0771\u22b0\u22b5rc\u803b\xee\u40ee;\u4438\u0100cx\u22bc\u22bfy;\u4435cl\u803b\xa1\u40a1\u0100fr\u039f\u22c9;\uc000\ud835\udd26rave\u803b\xec\u40ec\u0200;ino\u073e\u22dd\u22e9\u22ee\u0100in\u22e2\u22e6nt;\u6a0ct;\u622dfin;\u69dcta;\u6129lig;\u4133\u0180aop\u22fe\u231a\u231d\u0180cgt\u2305\u2308\u2317r;\u412b\u0180elp\u071f\u230f\u2313in\xe5\u078ear\xf4\u0720h;\u4131f;\u62b7ed;\u41b5\u0280;cfot\u04f4\u232c\u2331\u233d\u2341are;\u6105in\u0100;t\u2338\u2339\u621eie;\u69dddo\xf4\u2319\u0280;celp\u0757\u234c\u2350\u235b\u2361al;\u62ba\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234darhk;\u6a17rod;\u6a3c\u0200cgpt\u236f\u2372\u2376\u237by;\u4451on;\u412ff;\uc000\ud835\udd5aa;\u43b9uest\u803b\xbf\u40bf\u0100ci\u238a\u238fr;\uc000\ud835\udcben\u0280;Edsv\u04f4\u239b\u239d\u23a1\u04f3;\u62f9ot;\u62f5\u0100;v\u23a6\u23a7\u62f4;\u62f3\u0100;i\u0777\u23aelde;\u4129\u01eb\u23b8\0\u23bccy;\u4456l\u803b\xef\u40ef\u0300cfmosu\u23cc\u23d7\u23dc\u23e1\u23e7\u23f5\u0100iy\u23d1\u23d5rc;\u4135;\u4439r;\uc000\ud835\udd27ath;\u4237pf;\uc000\ud835\udd5b\u01e3\u23ec\0\u23f1r;\uc000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240b\u2416\u2422\u2427\u242d\u2431\u2435\u243bppa\u0100;v\u2413\u2414\u43ba;\u43f0\u0100ey\u241b\u2420dil;\u4137;\u443ar;\uc000\ud835\udd28reen;\u4138cy;\u4445cy;\u445cpf;\uc000\ud835\udd5ccr;\uc000\ud835\udcc0\u0b80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248d\u2491\u250e\u253d\u255a\u2580\u264e\u265e\u2665\u2679\u267d\u269a\u26b2\u26d8\u275d\u2768\u278b\u27c0\u2801\u2812\u0180art\u2477\u247a\u247cr\xf2\u09c6\xf2\u0395ail;\u691barr;\u690e\u0100;g\u0994\u248b;\u6a8bar;\u6962\u0963\u24a5\0\u24aa\0\u24b1\0\0\0\0\0\u24b5\u24ba\0\u24c6\u24c8\u24cd\0\u24f9ute;\u413amptyv;\u69b4ra\xee\u084cbda;\u43bbg\u0180;dl\u088e\u24c1\u24c3;\u6991\xe5\u088e;\u6a85uo\u803b\xab\u40abr\u0400;bfhlpst\u0899\u24de\u24e6\u24e9\u24eb\u24ee\u24f1\u24f5\u0100;f\u089d\u24e3s;\u691fs;\u691d\xeb\u2252p;\u61abl;\u6939im;\u6973l;\u61a2\u0180;ae\u24ff\u2500\u2504\u6aabil;\u6919\u0100;s\u2509\u250a\u6aad;\uc000\u2aad\ufe00\u0180abr\u2515\u2519\u251drr;\u690crk;\u6772\u0100ak\u2522\u252cc\u0100ek\u2528\u252a;\u407b;\u405b\u0100es\u2531\u2533;\u698bl\u0100du\u2539\u253b;\u698f;\u698d\u0200aeuy\u2546\u254b\u2556\u2558ron;\u413e\u0100di\u2550\u2554il;\u413c\xec\u08b0\xe2\u2529;\u443b\u0200cqrs\u2563\u2566\u256d\u257da;\u6936uo\u0100;r\u0e19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694bh;\u61b2\u0280;fgqs\u258b\u258c\u0989\u25f3\u25ff\u6264t\u0280ahlrt\u2598\u25a4\u25b7\u25c2\u25e8rrow\u0100;t\u0899\u25a1a\xe9\u24f6arpoon\u0100du\u25af\u25b4own\xbb\u045ap\xbb\u0966eftarrows;\u61c7ight\u0180ahs\u25cd\u25d6\u25derrow\u0100;s\u08f4\u08a7arpoon\xf3\u0f98quigarro\xf7\u21f0hreetimes;\u62cb\u0180;qs\u258b\u0993\u25falan\xf4\u09ac\u0280;cdgs\u09ac\u260a\u260d\u261d\u2628c;\u6aa8ot\u0100;o\u2614\u2615\u6a7f\u0100;r\u261a\u261b\u6a81;\u6a83\u0100;e\u2622\u2625\uc000\u22da\ufe00s;\u6a93\u0280adegs\u2633\u2639\u263d\u2649\u264bppro\xf8\u24c6ot;\u62d6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248c\xf4\u099bi\xed\u09b2\u0180ilr\u2655\u08e1\u265asht;\u697c;\uc000\ud835\udd29\u0100;E\u099c\u2663;\u6a91\u0161\u2669\u2676r\u0100du\u25b2\u266e\u0100;l\u0965\u2673;\u696alk;\u6584cy;\u4459\u0280;acht\u0a48\u2688\u268b\u2691\u2696r\xf2\u25c1orne\xf2\u1d08ard;\u696bri;\u65fa\u0100io\u269f\u26a4dot;\u4140ust\u0100;a\u26ac\u26ad\u63b0che\xbb\u26ad\u0200Eaes\u26bb\u26bd\u26c9\u26d4;\u6268p\u0100;p\u26c3\u26c4\u6a89rox\xbb\u26c4\u0100;q\u26ce\u26cf\u6a87\u0100;q\u26ce\u26bbim;\u62e6\u0400abnoptwz\u26e9\u26f4\u26f7\u271a\u272f\u2741\u2747\u2750\u0100nr\u26ee\u26f1g;\u67ecr;\u61fdr\xeb\u08c1g\u0180lmr\u26ff\u270d\u2714eft\u0100ar\u09e6\u2707ight\xe1\u09f2apsto;\u67fcight\xe1\u09fdparrow\u0100lr\u2725\u2729ef\xf4\u24edight;\u61ac\u0180afl\u2736\u2739\u273dr;\u6985;\uc000\ud835\udd5dus;\u6a2dimes;\u6a34\u0161\u274b\u274fst;\u6217\xe1\u134e\u0180;ef\u2757\u2758\u1800\u65cange\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277c\u2785\u2787r\xf2\u08a8orne\xf2\u1d8car\u0100;d\u0f98\u2783;\u696d;\u600eri;\u62bf\u0300achiqt\u2798\u279d\u0a40\u27a2\u27ae\u27bbquo;\u6039r;\uc000\ud835\udcc1m\u0180;eg\u09b2\u27aa\u27ac;\u6a8d;\u6a8f\u0100bu\u252a\u27b3o\u0100;r\u0e1f\u27b9;\u601arok;\u4142\u8400<;cdhilqr\u082b\u27d2\u2639\u27dc\u27e0\u27e5\u27ea\u27f0\u0100ci\u27d7\u27d9;\u6aa6r;\u6a79re\xe5\u25f2mes;\u62c9arr;\u6976uest;\u6a7b\u0100Pi\u27f5\u27f9ar;\u6996\u0180;ef\u2800\u092d\u181b\u65c3r\u0100du\u2807\u280dshar;\u694ahar;\u6966\u0100en\u2817\u2821rtneqq;\uc000\u2268\ufe00\xc5\u281e\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288e\u2893\u28a0\u28a5\u28a8\u28da\u28e2\u28e4\u0a83\u28f3\u2902Dot;\u623a\u0200clpr\u284e\u2852\u2863\u287dr\u803b\xaf\u40af\u0100et\u2857\u2859;\u6642\u0100;e\u285e\u285f\u6720se\xbb\u285f\u0100;s\u103b\u2868to\u0200;dlu\u103b\u2873\u2877\u287bow\xee\u048cef\xf4\u090f\xf0\u13d1ker;\u65ae\u0100oy\u2887\u288cmma;\u6a29;\u443cash;\u6014asuredangle\xbb\u1626r;\uc000\ud835\udd2ao;\u6127\u0180cdn\u28af\u28b4\u28c9ro\u803b\xb5\u40b5\u0200;acd\u1464\u28bd\u28c0\u28c4s\xf4\u16a7ir;\u6af0ot\u80bb\xb7\u01b5us\u0180;bd\u28d2\u1903\u28d3\u6212\u0100;u\u1d3c\u28d8;\u6a2a\u0163\u28de\u28e1p;\u6adb\xf2\u2212\xf0\u0a81\u0100dp\u28e9\u28eeels;\u62a7f;\uc000\ud835\udd5e\u0100ct\u28f8\u28fdr;\uc000\ud835\udcc2pos\xbb\u159d\u0180;lm\u2909\u290a\u290d\u43bctimap;\u62b8\u0c00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297e\u2989\u2998\u29da\u29e9\u2a15\u2a1a\u2a58\u2a5d\u2a83\u2a95\u2aa4\u2aa8\u2b04\u2b07\u2b44\u2b7f\u2bae\u2c34\u2c67\u2c7c\u2ce9\u0100gt\u2947\u294b;\uc000\u22d9\u0338\u0100;v\u2950\u0bcf\uc000\u226b\u20d2\u0180elt\u295a\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61cdightarrow;\u61ce;\uc000\u22d8\u0338\u0100;v\u297b\u0c47\uc000\u226a\u20d2ightarrow;\u61cf\u0100Dd\u298e\u2993ash;\u62afash;\u62ae\u0280bcnpt\u29a3\u29a7\u29ac\u29b1\u29ccla\xbb\u02deute;\u4144g;\uc000\u2220\u20d2\u0280;Eiop\u0d84\u29bc\u29c0\u29c5\u29c8;\uc000\u2a70\u0338d;\uc000\u224b\u0338s;\u4149ro\xf8\u0d84ur\u0100;a\u29d3\u29d4\u666el\u0100;s\u29d3\u0b38\u01f3\u29df\0\u29e3p\u80bb\xa0\u0b37mp\u0100;e\u0bf9\u0c00\u0280aeouy\u29f4\u29fe\u2a03\u2a10\u2a13\u01f0\u29f9\0\u29fb;\u6a43on;\u4148dil;\u4146ng\u0100;d\u0d7e\u2a0aot;\uc000\u2a6d\u0338p;\u6a42;\u443dash;\u6013\u0380;Aadqsx\u0b92\u2a29\u2a2d\u2a3b\u2a41\u2a45\u2a50rr;\u61d7r\u0100hr\u2a33\u2a36k;\u6924\u0100;o\u13f2\u13f0ot;\uc000\u2250\u0338ui\xf6\u0b63\u0100ei\u2a4a\u2a4ear;\u6928\xed\u0b98ist\u0100;s\u0ba0\u0b9fr;\uc000\ud835\udd2b\u0200Eest\u0bc5\u2a66\u2a79\u2a7c\u0180;qs\u0bbc\u2a6d\u0be1\u0180;qs\u0bbc\u0bc5\u2a74lan\xf4\u0be2i\xed\u0bea\u0100;r\u0bb6\u2a81\xbb\u0bb7\u0180Aap\u2a8a\u2a8d\u2a91r\xf2\u2971rr;\u61aear;\u6af2\u0180;sv\u0f8d\u2a9c\u0f8c\u0100;d\u2aa1\u2aa2\u62fc;\u62facy;\u445a\u0380AEadest\u2ab7\u2aba\u2abe\u2ac2\u2ac5\u2af6\u2af9r\xf2\u2966;\uc000\u2266\u0338rr;\u619ar;\u6025\u0200;fqs\u0c3b\u2ace\u2ae3\u2aeft\u0100ar\u2ad4\u2ad9rro\xf7\u2ac1ightarro\xf7\u2a90\u0180;qs\u0c3b\u2aba\u2aealan\xf4\u0c55\u0100;s\u0c55\u2af4\xbb\u0c36i\xed\u0c5d\u0100;r\u0c35\u2afei\u0100;e\u0c1a\u0c25i\xe4\u0d90\u0100pt\u2b0c\u2b11f;\uc000\ud835\udd5f\u8180\xac;in\u2b19\u2b1a\u2b36\u40acn\u0200;Edv\u0b89\u2b24\u2b28\u2b2e;\uc000\u22f9\u0338ot;\uc000\u22f5\u0338\u01e1\u0b89\u2b33\u2b35;\u62f7;\u62f6i\u0100;v\u0cb8\u2b3c\u01e1\u0cb8\u2b41\u2b43;\u62fe;\u62fd\u0180aor\u2b4b\u2b63\u2b69r\u0200;ast\u0b7b\u2b55\u2b5a\u2b5flle\xec\u0b7bl;\uc000\u2afd\u20e5;\uc000\u2202\u0338lint;\u6a14\u0180;ce\u0c92\u2b70\u2b73u\xe5\u0ca5\u0100;c\u0c98\u2b78\u0100;e\u0c92\u2b7d\xf1\u0c98\u0200Aait\u2b88\u2b8b\u2b9d\u2ba7r\xf2\u2988rr\u0180;cw\u2b94\u2b95\u2b99\u619b;\uc000\u2933\u0338;\uc000\u219d\u0338ghtarrow\xbb\u2b95ri\u0100;e\u0ccb\u0cd6\u0380chimpqu\u2bbd\u2bcd\u2bd9\u2b04\u0b78\u2be4\u2bef\u0200;cer\u0d32\u2bc6\u0d37\u2bc9u\xe5\u0d45;\uc000\ud835\udcc3ort\u026d\u2b05\0\0\u2bd6ar\xe1\u2b56m\u0100;e\u0d6e\u2bdf\u0100;q\u0d74\u0d73su\u0100bp\u2beb\u2bed\xe5\u0cf8\xe5\u0d0b\u0180bcp\u2bf6\u2c11\u2c19\u0200;Ees\u2bff\u2c00\u0d22\u2c04\u6284;\uc000\u2ac5\u0338et\u0100;e\u0d1b\u2c0bq\u0100;q\u0d23\u2c00c\u0100;e\u0d32\u2c17\xf1\u0d38\u0200;Ees\u2c22\u2c23\u0d5f\u2c27\u6285;\uc000\u2ac6\u0338et\u0100;e\u0d58\u2c2eq\u0100;q\u0d60\u2c23\u0200gilr\u2c3d\u2c3f\u2c45\u2c47\xec\u0bd7lde\u803b\xf1\u40f1\xe7\u0c43iangle\u0100lr\u2c52\u2c5ceft\u0100;e\u0c1a\u2c5a\xf1\u0c26ight\u0100;e\u0ccb\u2c65\xf1\u0cd7\u0100;m\u2c6c\u2c6d\u43bd\u0180;es\u2c74\u2c75\u2c79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2c8f\u2c94\u2c99\u2c9e\u2ca3\u2cb0\u2cb6\u2cd3\u2ce3ash;\u62adarr;\u6904p;\uc000\u224d\u20d2ash;\u62ac\u0100et\u2ca8\u2cac;\uc000\u2265\u20d2;\uc000>\u20d2nfin;\u69de\u0180Aet\u2cbd\u2cc1\u2cc5rr;\u6902;\uc000\u2264\u20d2\u0100;r\u2cca\u2ccd\uc000<\u20d2ie;\uc000\u22b4\u20d2\u0100At\u2cd8\u2cdcrr;\u6903rie;\uc000\u22b5\u20d2im;\uc000\u223c\u20d2\u0180Aan\u2cf0\u2cf4\u2d02rr;\u61d6r\u0100hr\u2cfa\u2cfdk;\u6923\u0100;o\u13e7\u13e5ear;\u6927\u1253\u1a95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2d2d\0\u2d38\u2d48\u2d60\u2d65\u2d72\u2d84\u1b07\0\0\u2d8d\u2dab\0\u2dc8\u2dce\0\u2ddc\u2e19\u2e2b\u2e3e\u2e43\u0100cs\u2d31\u1a97ute\u803b\xf3\u40f3\u0100iy\u2d3c\u2d45r\u0100;c\u1a9e\u2d42\u803b\xf4\u40f4;\u443e\u0280abios\u1aa0\u2d52\u2d57\u01c8\u2d5alac;\u4151v;\u6a38old;\u69bclig;\u4153\u0100cr\u2d69\u2d6dir;\u69bf;\uc000\ud835\udd2c\u036f\u2d79\0\0\u2d7c\0\u2d82n;\u42dbave\u803b\xf2\u40f2;\u69c1\u0100bm\u2d88\u0df4ar;\u69b5\u0200acit\u2d95\u2d98\u2da5\u2da8r\xf2\u1a80\u0100ir\u2d9d\u2da0r;\u69beoss;\u69bbn\xe5\u0e52;\u69c0\u0180aei\u2db1\u2db5\u2db9cr;\u414dga;\u43c9\u0180cdn\u2dc0\u2dc5\u01cdron;\u43bf;\u69b6pf;\uc000\ud835\udd60\u0180ael\u2dd4\u2dd7\u01d2r;\u69b7rp;\u69b9\u0380;adiosv\u2dea\u2deb\u2dee\u2e08\u2e0d\u2e10\u2e16\u6228r\xf2\u1a86\u0200;efm\u2df7\u2df8\u2e02\u2e05\u6a5dr\u0100;o\u2dfe\u2dff\u6134f\xbb\u2dff\u803b\xaa\u40aa\u803b\xba\u40bagof;\u62b6r;\u6a56lope;\u6a57;\u6a5b\u0180clo\u2e1f\u2e21\u2e27\xf2\u2e01ash\u803b\xf8\u40f8l;\u6298i\u016c\u2e2f\u2e34de\u803b\xf5\u40f5es\u0100;a\u01db\u2e3as;\u6a36ml\u803b\xf6\u40f6bar;\u633d\u0ae1\u2e5e\0\u2e7d\0\u2e80\u2e9d\0\u2ea2\u2eb9\0\0\u2ecb\u0e9c\0\u2f13\0\0\u2f2b\u2fbc\0\u2fc8r\u0200;ast\u0403\u2e67\u2e72\u0e85\u8100\xb6;l\u2e6d\u2e6e\u40b6le\xec\u0403\u0269\u2e78\0\0\u2e7bm;\u6af3;\u6afdy;\u443fr\u0280cimpt\u2e8b\u2e8f\u2e93\u1865\u2e97nt;\u4025od;\u402eil;\u6030enk;\u6031r;\uc000\ud835\udd2d\u0180imo\u2ea8\u2eb0\u2eb4\u0100;v\u2ead\u2eae\u43c6;\u43d5ma\xf4\u0a76ne;\u660e\u0180;tv\u2ebf\u2ec0\u2ec8\u43c0chfork\xbb\u1ffd;\u43d6\u0100au\u2ecf\u2edfn\u0100ck\u2ed5\u2eddk\u0100;h\u21f4\u2edb;\u610e\xf6\u21f4s\u0480;abcdemst\u2ef3\u2ef4\u1908\u2ef9\u2efd\u2f04\u2f06\u2f0a\u2f0e\u402bcir;\u6a23ir;\u6a22\u0100ou\u1d40\u2f02;\u6a25;\u6a72n\u80bb\xb1\u0e9dim;\u6a26wo;\u6a27\u0180ipu\u2f19\u2f20\u2f25ntint;\u6a15f;\uc000\ud835\udd61nd\u803b\xa3\u40a3\u0500;Eaceinosu\u0ec8\u2f3f\u2f41\u2f44\u2f47\u2f81\u2f89\u2f92\u2f7e\u2fb6;\u6ab3p;\u6ab7u\xe5\u0ed9\u0100;c\u0ece\u2f4c\u0300;acens\u0ec8\u2f59\u2f5f\u2f66\u2f68\u2f7eppro\xf8\u2f43urlye\xf1\u0ed9\xf1\u0ece\u0180aes\u2f6f\u2f76\u2f7approx;\u6ab9qq;\u6ab5im;\u62e8i\xed\u0edfme\u0100;s\u2f88\u0eae\u6032\u0180Eas\u2f78\u2f90\u2f7a\xf0\u2f75\u0180dfp\u0eec\u2f99\u2faf\u0180als\u2fa0\u2fa5\u2faalar;\u632eine;\u6312urf;\u6313\u0100;t\u0efb\u2fb4\xef\u0efbrel;\u62b0\u0100ci\u2fc0\u2fc5r;\uc000\ud835\udcc5;\u43c8ncsp;\u6008\u0300fiopsu\u2fda\u22e2\u2fdf\u2fe5\u2feb\u2ff1r;\uc000\ud835\udd2epf;\uc000\ud835\udd62rime;\u6057cr;\uc000\ud835\udcc6\u0180aeo\u2ff8\u3009\u3013t\u0100ei\u2ffe\u3005rnion\xf3\u06b0nt;\u6a16st\u0100;e\u3010\u3011\u403f\xf1\u1f19\xf4\u0f14\u0a80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30e0\u310e\u312b\u3147\u3162\u3172\u318e\u3206\u3215\u3224\u3229\u3258\u326e\u3272\u3290\u32b0\u32b7\u0180art\u3047\u304a\u304cr\xf2\u10b3\xf2\u03ddail;\u691car\xf2\u1c65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307f\u308f\u3094\u30cc\u0100eu\u306d\u3071;\uc000\u223d\u0331te;\u4155i\xe3\u116emptyv;\u69b3g\u0200;del\u0fd1\u3089\u308b\u308d;\u6992;\u69a5\xe5\u0fd1uo\u803b\xbb\u40bbr\u0580;abcfhlpstw\u0fdc\u30ac\u30af\u30b7\u30b9\u30bc\u30be\u30c0\u30c3\u30c7\u30cap;\u6975\u0100;f\u0fe0\u30b4s;\u6920;\u6933s;\u691e\xeb\u225d\xf0\u272el;\u6945im;\u6974l;\u61a3;\u619d\u0100ai\u30d1\u30d5il;\u691ao\u0100;n\u30db\u30dc\u6236al\xf3\u0f1e\u0180abr\u30e7\u30ea\u30eer\xf2\u17e5rk;\u6773\u0100ak\u30f3\u30fdc\u0100ek\u30f9\u30fb;\u407d;\u405d\u0100es\u3102\u3104;\u698cl\u0100du\u310a\u310c;\u698e;\u6990\u0200aeuy\u3117\u311c\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0ff2\xe2\u30fa;\u4440\u0200clqs\u3134\u3137\u313d\u3144a;\u6937dhar;\u6969uo\u0100;r\u020e\u020dh;\u61b3\u0180acg\u314e\u315f\u0f44l\u0200;ips\u0f78\u3158\u315b\u109cn\xe5\u10bbar\xf4\u0fa9t;\u65ad\u0180ilr\u3169\u1023\u316esht;\u697d;\uc000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317d\u317f\xbb\u047b\u0100;l\u1091\u3184;\u696c\u0100;v\u318b\u318c\u43c1;\u43f1\u0180gns\u3195\u31f9\u31fcht\u0300ahlrst\u31a4\u31b0\u31c2\u31d8\u31e4\u31eerrow\u0100;t\u0fdc\u31ada\xe9\u30c8arpoon\u0100du\u31bb\u31bfow\xee\u317ep\xbb\u1092eft\u0100ah\u31ca\u31d0rrow\xf3\u0feaarpoon\xf3\u0551ightarrows;\u61c9quigarro\xf7\u30cbhreetimes;\u62ccg;\u42daingdotse\xf1\u1f32\u0180ahm\u320d\u3210\u3213r\xf2\u0feaa\xf2\u0551;\u600foust\u0100;a\u321e\u321f\u63b1che\xbb\u321fmid;\u6aee\u0200abpt\u3232\u323d\u3240\u3252\u0100nr\u3237\u323ag;\u67edr;\u61fer\xeb\u1003\u0180afl\u3247\u324a\u324er;\u6986;\uc000\ud835\udd63us;\u6a2eimes;\u6a35\u0100ap\u325d\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6a12ar\xf2\u31e3\u0200achq\u327b\u3280\u10bc\u3285quo;\u603ar;\uc000\ud835\udcc7\u0100bu\u30fb\u328ao\u0100;r\u0214\u0213\u0180hir\u3297\u329b\u32a0re\xe5\u31f8mes;\u62cai\u0200;efl\u32aa\u1059\u1821\u32ab\u65b9tri;\u69celuhar;\u6968;\u611e\u0d61\u32d5\u32db\u32df\u332c\u3338\u3371\0\u337a\u33a4\0\0\u33ec\u33f0\0\u3428\u3448\u345a\u34ad\u34b1\u34ca\u34f1\0\u3616\0\0\u3633cute;\u415bqu\xef\u27ba\u0500;Eaceinpsy\u11ed\u32f3\u32f5\u32ff\u3302\u330b\u330f\u331f\u3326\u3329;\u6ab4\u01f0\u32fa\0\u32fc;\u6ab8on;\u4161u\xe5\u11fe\u0100;d\u11f3\u3307il;\u415frc;\u415d\u0180Eas\u3316\u3318\u331b;\u6ab6p;\u6abaim;\u62e9olint;\u6a13i\xed\u1204;\u4441ot\u0180;be\u3334\u1d47\u3335\u62c5;\u6a66\u0380Aacmstx\u3346\u334a\u3357\u335b\u335e\u3363\u336drr;\u61d8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0a36\u0a34t\u803b\xa7\u40a7i;\u403bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uc000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33a0rp;\u666f\u0100hy\u338b\u338fcy;\u4449;\u4448rt\u026d\u3399\0\0\u339ci\xe4\u1464ara\xec\u2e6f\u803b\xad\u40ad\u0100gm\u33a8\u33b4ma\u0180;fv\u33b1\u33b2\u33b2\u43c3;\u43c2\u0400;deglnpr\u12ab\u33c5\u33c9\u33ce\u33d6\u33de\u33e1\u33e6ot;\u6a6a\u0100;q\u12b1\u12b0\u0100;E\u33d3\u33d4\u6a9e;\u6aa0\u0100;E\u33db\u33dc\u6a9d;\u6a9fe;\u6246lus;\u6a24arr;\u6972ar\xf2\u113d\u0200aeit\u33f8\u3408\u340f\u3417\u0100ls\u33fd\u3404lsetm\xe9\u336ahp;\u6a33parsl;\u69e4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341c\u341d\u6aaa\u0100;s\u3422\u3423\u6aac;\uc000\u2aac\ufe00\u0180flp\u342e\u3433\u3442tcy;\u444c\u0100;b\u3438\u3439\u402f\u0100;a\u343e\u343f\u69c4r;\u633ff;\uc000\ud835\udd64a\u0100dr\u344d\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349f\u0100au\u3465\u346fp\u0100;s\u1188\u346b;\uc000\u2293\ufe00p\u0100;s\u11b4\u3475;\uc000\u2294\ufe00u\u0100bp\u347f\u348f\u0180;es\u1197\u119c\u3486et\u0100;e\u1197\u348d\xf1\u119d\u0180;es\u11a8\u11ad\u3496et\u0100;e\u11a8\u349d\xf1\u11ae\u0180;af\u117b\u34a6\u05b0r\u0165\u34ab\u05b1\xbb\u117car\xf2\u1148\u0200cemt\u34b9\u34be\u34c2\u34c5r;\uc000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11be\u0100ar\u34ce\u34d5r\u0100;f\u34d4\u17bf\u6606\u0100an\u34da\u34edight\u0100ep\u34e3\u34eapsilo\xee\u1ee0h\xe9\u2eafs\xbb\u2852\u0280bcmnp\u34fb\u355e\u1209\u358b\u358e\u0480;Edemnprs\u350e\u350f\u3511\u3515\u351e\u3523\u352c\u3531\u3536\u6282;\u6ac5ot;\u6abd\u0100;d\u11da\u351aot;\u6ac3ult;\u6ac1\u0100Ee\u3528\u352a;\u6acb;\u628alus;\u6abfarr;\u6979\u0180eiu\u353d\u3552\u3555t\u0180;en\u350e\u3545\u354bq\u0100;q\u11da\u350feq\u0100;q\u352b\u3528m;\u6ac7\u0100bp\u355a\u355c;\u6ad5;\u6ad3c\u0300;acens\u11ed\u356c\u3572\u3579\u357b\u3326ppro\xf8\u32faurlye\xf1\u11fe\xf1\u11f3\u0180aes\u3582\u3588\u331bppro\xf8\u331aq\xf1\u3317g;\u666a\u0680123;Edehlmnps\u35a9\u35ac\u35af\u121c\u35b2\u35b4\u35c0\u35c9\u35d5\u35da\u35df\u35e8\u35ed\u803b\xb9\u40b9\u803b\xb2\u40b2\u803b\xb3\u40b3;\u6ac6\u0100os\u35b9\u35bct;\u6abeub;\u6ad8\u0100;d\u1222\u35c5ot;\u6ac4s\u0100ou\u35cf\u35d2l;\u67c9b;\u6ad7arr;\u697bult;\u6ac2\u0100Ee\u35e4\u35e6;\u6acc;\u628blus;\u6ac0\u0180eiu\u35f4\u3609\u360ct\u0180;en\u121c\u35fc\u3602q\u0100;q\u1222\u35b2eq\u0100;q\u35e7\u35e4m;\u6ac8\u0100bp\u3611\u3613;\u6ad4;\u6ad6\u0180Aan\u361c\u3620\u362drr;\u61d9r\u0100hr\u3626\u3628\xeb\u222e\u0100;o\u0a2b\u0a29war;\u692alig\u803b\xdf\u40df\u0be1\u3651\u365d\u3660\u12ce\u3673\u3679\0\u367e\u36c2\0\0\0\0\0\u36db\u3703\0\u3709\u376c\0\0\0\u3787\u0272\u3656\0\0\u365bget;\u6316;\u43c4r\xeb\u0e5f\u0180aey\u3666\u366b\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uc000\ud835\udd31\u0200eiko\u3686\u369d\u36b5\u36bc\u01f2\u368b\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369b\u43b8ym;\u43d1\u0100cn\u36a2\u36b2k\u0100as\u36a8\u36aeppro\xf8\u12c1im\xbb\u12acs\xf0\u129e\u0100as\u36ba\u36ae\xf0\u12c1rn\u803b\xfe\u40fe\u01ec\u031f\u36c6\u22e7es\u8180\xd7;bd\u36cf\u36d0\u36d8\u40d7\u0100;a\u190f\u36d5r;\u6a31;\u6a30\u0180eps\u36e1\u36e3\u3700\xe1\u2a4d\u0200;bcf\u0486\u36ec\u36f0\u36f4ot;\u6336ir;\u6af1\u0100;o\u36f9\u36fc\uc000\ud835\udd65rk;\u6ada\xe1\u3362rime;\u6034\u0180aip\u370f\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374d\u3740\u3751\u3757\u375c\u375fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65b5own\xbb\u1dbbeft\u0100;e\u2800\u373e\xf1\u092e;\u625cight\u0100;e\u32aa\u374b\xf1\u105aot;\u65ecinus;\u6a3alus;\u6a39b;\u69cdime;\u6a3bezium;\u63e2\u0180cht\u3772\u377d\u3781\u0100ry\u3777\u377b;\uc000\ud835\udcc9;\u4446cy;\u445brok;\u4167\u0100io\u378b\u378ex\xf4\u1777head\u0100lr\u3797\u37a0eftarro\xf7\u084fightarrow\xbb\u0f5d\u0900AHabcdfghlmoprstuw\u37d0\u37d3\u37d7\u37e4\u37f0\u37fc\u380e\u381c\u3823\u3834\u3851\u385d\u386b\u38a9\u38cc\u38d2\u38ea\u38f6r\xf2\u03edar;\u6963\u0100cr\u37dc\u37e2ute\u803b\xfa\u40fa\xf2\u1150r\u01e3\u37ea\0\u37edy;\u445eve;\u416d\u0100iy\u37f5\u37farc\u803b\xfb\u40fb;\u4443\u0180abh\u3803\u3806\u380br\xf2\u13adlac;\u4171a\xf2\u13c3\u0100ir\u3813\u3818sht;\u697e;\uc000\ud835\udd32rave\u803b\xf9\u40f9\u0161\u3827\u3831r\u0100lr\u382c\u382e\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384d\u026f\u383f\0\0\u384arn\u0100;e\u3845\u3846\u631cr\xbb\u3846op;\u630fri;\u65f8\u0100al\u3856\u385acr;\u416b\u80bb\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uc000\ud835\udd66\u0300adhlsu\u114b\u3878\u387d\u1372\u3891\u38a0own\xe1\u13b3arpoon\u0100lr\u3888\u388cef\xf4\u382digh\xf4\u382fi\u0180;hl\u3899\u389a\u389c\u43c5\xbb\u13faon\xbb\u389aparrows;\u61c8\u0180cit\u38b0\u38c4\u38c8\u026f\u38b6\0\0\u38c1rn\u0100;e\u38bc\u38bd\u631dr\xbb\u38bdop;\u630eng;\u416fri;\u65f9cr;\uc000\ud835\udcca\u0180dir\u38d9\u38dd\u38e2ot;\u62f0lde;\u4169i\u0100;f\u3730\u38e8\xbb\u1813\u0100am\u38ef\u38f2r\xf2\u38a8l\u803b\xfc\u40fcangle;\u69a7\u0780ABDacdeflnoprsz\u391c\u391f\u3929\u392d\u39b5\u39b8\u39bd\u39df\u39e4\u39e8\u39f3\u39f9\u39fd\u3a01\u3a20r\xf2\u03f7ar\u0100;v\u3926\u3927\u6ae8;\u6ae9as\xe8\u03e1\u0100nr\u3932\u3937grt;\u699c\u0380eknprst\u34e3\u3946\u394b\u3952\u395d\u3964\u3996app\xe1\u2415othin\xe7\u1e96\u0180hir\u34eb\u2ec8\u3959op\xf4\u2fb5\u0100;h\u13b7\u3962\xef\u318d\u0100iu\u3969\u396dgm\xe1\u33b3\u0100bp\u3972\u3984setneq\u0100;q\u397d\u3980\uc000\u228a\ufe00;\uc000\u2acb\ufe00setneq\u0100;q\u398f\u3992\uc000\u228b\ufe00;\uc000\u2acc\ufe00\u0100hr\u399b\u399fet\xe1\u369ciangle\u0100lr\u39aa\u39afeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39c4\u39d2\u39d7\u0180;be\u2dea\u39cb\u39cfar;\u62bbq;\u625alip;\u62ee\u0100bt\u39dc\u1468a\xf2\u1469r;\uc000\ud835\udd33tr\xe9\u39aesu\u0100bp\u39ef\u39f1\xbb\u0d1c\xbb\u0d59pf;\uc000\ud835\udd67ro\xf0\u0efbtr\xe9\u39b4\u0100cu\u3a06\u3a0br;\uc000\ud835\udccb\u0100bp\u3a10\u3a18n\u0100Ee\u3980\u3a16\xbb\u397en\u0100Ee\u3992\u3a1e\xbb\u3990igzag;\u699a\u0380cefoprs\u3a36\u3a3b\u3a56\u3a5b\u3a54\u3a61\u3a6airc;\u4175\u0100di\u3a40\u3a51\u0100bg\u3a45\u3a49ar;\u6a5fe\u0100;q\u15fa\u3a4f;\u6259erp;\u6118r;\uc000\ud835\udd34pf;\uc000\ud835\udd68\u0100;e\u1479\u3a66at\xe8\u1479cr;\uc000\ud835\udccc\u0ae3\u178e\u3a87\0\u3a8b\0\u3a90\u3a9b\0\0\u3a9d\u3aa8\u3aab\u3aaf\0\0\u3ac3\u3ace\0\u3ad8\u17dc\u17dftr\xe9\u17d1r;\uc000\ud835\udd35\u0100Aa\u3a94\u3a97r\xf2\u03c3r\xf2\u09f6;\u43be\u0100Aa\u3aa1\u3aa4r\xf2\u03b8r\xf2\u09eba\xf0\u2713is;\u62fb\u0180dpt\u17a4\u3ab5\u3abe\u0100fl\u3aba\u17a9;\uc000\ud835\udd69im\xe5\u17b2\u0100Aa\u3ac7\u3acar\xf2\u03cer\xf2\u0a01\u0100cq\u3ad2\u17b8r;\uc000\ud835\udccd\u0100pt\u17d6\u3adcr\xe9\u17d4\u0400acefiosu\u3af0\u3afd\u3b08\u3b0c\u3b11\u3b15\u3b1b\u3b21c\u0100uy\u3af6\u3afbte\u803b\xfd\u40fd;\u444f\u0100iy\u3b02\u3b06rc;\u4177;\u444bn\u803b\xa5\u40a5r;\uc000\ud835\udd36cy;\u4457pf;\uc000\ud835\udd6acr;\uc000\ud835\udcce\u0100cm\u3b26\u3b29y;\u444el\u803b\xff\u40ff\u0500acdefhiosw\u3b42\u3b48\u3b54\u3b58\u3b64\u3b69\u3b6d\u3b74\u3b7a\u3b80cute;\u417a\u0100ay\u3b4d\u3b52ron;\u417e;\u4437ot;\u417c\u0100et\u3b5d\u3b61tr\xe6\u155fa;\u43b6r;\uc000\ud835\udd37cy;\u4436grarr;\u61ddpf;\uc000\ud835\udd6bcr;\uc000\ud835\udccf\u0100jn\u3b85\u3b87;\u600dj;\u600c".split("").map(function (c) {
  return c.charCodeAt(0);
}));

/***/ }),

/***/ "./node_modules/entities/lib/generated/decode-data-xml.js":
/*!****************************************************************!*\
  !*** ./node_modules/entities/lib/generated/decode-data-xml.js ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";


// Generated using scripts/write-decode-map.ts
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = new Uint16Array(
// prettier-ignore
"\u0200aglq\t\x15\x18\x1b\u026d\x0f\0\0\x12p;\u4026os;\u4027t;\u403et;\u403cuot;\u4022".split("").map(function (c) {
  return c.charCodeAt(0);
}));

/***/ }),

/***/ "./node_modules/entities/lib/generated/encode-html.js":
/*!************************************************************!*\
  !*** ./node_modules/entities/lib/generated/encode-html.js ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";


// Generated using scripts/write-encode-map.ts
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
function restoreDiff(arr) {
  for (var i = 1; i < arr.length; i++) {
    arr[i][0] += arr[i - 1][0] + 1;
  }
  return arr;
}
// prettier-ignore
exports["default"] = new Map( /* #__PURE__ */restoreDiff([[9, "&Tab;"], [0, "&NewLine;"], [22, "&excl;"], [0, "&quot;"], [0, "&num;"], [0, "&dollar;"], [0, "&percnt;"], [0, "&amp;"], [0, "&apos;"], [0, "&lpar;"], [0, "&rpar;"], [0, "&ast;"], [0, "&plus;"], [0, "&comma;"], [1, "&period;"], [0, "&sol;"], [10, "&colon;"], [0, "&semi;"], [0, {
  v: "&lt;",
  n: 8402,
  o: "&nvlt;"
}], [0, {
  v: "&equals;",
  n: 8421,
  o: "&bne;"
}], [0, {
  v: "&gt;",
  n: 8402,
  o: "&nvgt;"
}], [0, "&quest;"], [0, "&commat;"], [26, "&lbrack;"], [0, "&bsol;"], [0, "&rbrack;"], [0, "&Hat;"], [0, "&lowbar;"], [0, "&DiacriticalGrave;"], [5, {
  n: 106,
  o: "&fjlig;"
}], [20, "&lbrace;"], [0, "&verbar;"], [0, "&rbrace;"], [34, "&nbsp;"], [0, "&iexcl;"], [0, "&cent;"], [0, "&pound;"], [0, "&curren;"], [0, "&yen;"], [0, "&brvbar;"], [0, "&sect;"], [0, "&die;"], [0, "&copy;"], [0, "&ordf;"], [0, "&laquo;"], [0, "&not;"], [0, "&shy;"], [0, "&circledR;"], [0, "&macr;"], [0, "&deg;"], [0, "&PlusMinus;"], [0, "&sup2;"], [0, "&sup3;"], [0, "&acute;"], [0, "&micro;"], [0, "&para;"], [0, "&centerdot;"], [0, "&cedil;"], [0, "&sup1;"], [0, "&ordm;"], [0, "&raquo;"], [0, "&frac14;"], [0, "&frac12;"], [0, "&frac34;"], [0, "&iquest;"], [0, "&Agrave;"], [0, "&Aacute;"], [0, "&Acirc;"], [0, "&Atilde;"], [0, "&Auml;"], [0, "&angst;"], [0, "&AElig;"], [0, "&Ccedil;"], [0, "&Egrave;"], [0, "&Eacute;"], [0, "&Ecirc;"], [0, "&Euml;"], [0, "&Igrave;"], [0, "&Iacute;"], [0, "&Icirc;"], [0, "&Iuml;"], [0, "&ETH;"], [0, "&Ntilde;"], [0, "&Ograve;"], [0, "&Oacute;"], [0, "&Ocirc;"], [0, "&Otilde;"], [0, "&Ouml;"], [0, "&times;"], [0, "&Oslash;"], [0, "&Ugrave;"], [0, "&Uacute;"], [0, "&Ucirc;"], [0, "&Uuml;"], [0, "&Yacute;"], [0, "&THORN;"], [0, "&szlig;"], [0, "&agrave;"], [0, "&aacute;"], [0, "&acirc;"], [0, "&atilde;"], [0, "&auml;"], [0, "&aring;"], [0, "&aelig;"], [0, "&ccedil;"], [0, "&egrave;"], [0, "&eacute;"], [0, "&ecirc;"], [0, "&euml;"], [0, "&igrave;"], [0, "&iacute;"], [0, "&icirc;"], [0, "&iuml;"], [0, "&eth;"], [0, "&ntilde;"], [0, "&ograve;"], [0, "&oacute;"], [0, "&ocirc;"], [0, "&otilde;"], [0, "&ouml;"], [0, "&div;"], [0, "&oslash;"], [0, "&ugrave;"], [0, "&uacute;"], [0, "&ucirc;"], [0, "&uuml;"], [0, "&yacute;"], [0, "&thorn;"], [0, "&yuml;"], [0, "&Amacr;"], [0, "&amacr;"], [0, "&Abreve;"], [0, "&abreve;"], [0, "&Aogon;"], [0, "&aogon;"], [0, "&Cacute;"], [0, "&cacute;"], [0, "&Ccirc;"], [0, "&ccirc;"], [0, "&Cdot;"], [0, "&cdot;"], [0, "&Ccaron;"], [0, "&ccaron;"], [0, "&Dcaron;"], [0, "&dcaron;"], [0, "&Dstrok;"], [0, "&dstrok;"], [0, "&Emacr;"], [0, "&emacr;"], [2, "&Edot;"], [0, "&edot;"], [0, "&Eogon;"], [0, "&eogon;"], [0, "&Ecaron;"], [0, "&ecaron;"], [0, "&Gcirc;"], [0, "&gcirc;"], [0, "&Gbreve;"], [0, "&gbreve;"], [0, "&Gdot;"], [0, "&gdot;"], [0, "&Gcedil;"], [1, "&Hcirc;"], [0, "&hcirc;"], [0, "&Hstrok;"], [0, "&hstrok;"], [0, "&Itilde;"], [0, "&itilde;"], [0, "&Imacr;"], [0, "&imacr;"], [2, "&Iogon;"], [0, "&iogon;"], [0, "&Idot;"], [0, "&imath;"], [0, "&IJlig;"], [0, "&ijlig;"], [0, "&Jcirc;"], [0, "&jcirc;"], [0, "&Kcedil;"], [0, "&kcedil;"], [0, "&kgreen;"], [0, "&Lacute;"], [0, "&lacute;"], [0, "&Lcedil;"], [0, "&lcedil;"], [0, "&Lcaron;"], [0, "&lcaron;"], [0, "&Lmidot;"], [0, "&lmidot;"], [0, "&Lstrok;"], [0, "&lstrok;"], [0, "&Nacute;"], [0, "&nacute;"], [0, "&Ncedil;"], [0, "&ncedil;"], [0, "&Ncaron;"], [0, "&ncaron;"], [0, "&napos;"], [0, "&ENG;"], [0, "&eng;"], [0, "&Omacr;"], [0, "&omacr;"], [2, "&Odblac;"], [0, "&odblac;"], [0, "&OElig;"], [0, "&oelig;"], [0, "&Racute;"], [0, "&racute;"], [0, "&Rcedil;"], [0, "&rcedil;"], [0, "&Rcaron;"], [0, "&rcaron;"], [0, "&Sacute;"], [0, "&sacute;"], [0, "&Scirc;"], [0, "&scirc;"], [0, "&Scedil;"], [0, "&scedil;"], [0, "&Scaron;"], [0, "&scaron;"], [0, "&Tcedil;"], [0, "&tcedil;"], [0, "&Tcaron;"], [0, "&tcaron;"], [0, "&Tstrok;"], [0, "&tstrok;"], [0, "&Utilde;"], [0, "&utilde;"], [0, "&Umacr;"], [0, "&umacr;"], [0, "&Ubreve;"], [0, "&ubreve;"], [0, "&Uring;"], [0, "&uring;"], [0, "&Udblac;"], [0, "&udblac;"], [0, "&Uogon;"], [0, "&uogon;"], [0, "&Wcirc;"], [0, "&wcirc;"], [0, "&Ycirc;"], [0, "&ycirc;"], [0, "&Yuml;"], [0, "&Zacute;"], [0, "&zacute;"], [0, "&Zdot;"], [0, "&zdot;"], [0, "&Zcaron;"], [0, "&zcaron;"], [19, "&fnof;"], [34, "&imped;"], [63, "&gacute;"], [65, "&jmath;"], [142, "&circ;"], [0, "&caron;"], [16, "&breve;"], [0, "&DiacriticalDot;"], [0, "&ring;"], [0, "&ogon;"], [0, "&DiacriticalTilde;"], [0, "&dblac;"], [51, "&DownBreve;"], [127, "&Alpha;"], [0, "&Beta;"], [0, "&Gamma;"], [0, "&Delta;"], [0, "&Epsilon;"], [0, "&Zeta;"], [0, "&Eta;"], [0, "&Theta;"], [0, "&Iota;"], [0, "&Kappa;"], [0, "&Lambda;"], [0, "&Mu;"], [0, "&Nu;"], [0, "&Xi;"], [0, "&Omicron;"], [0, "&Pi;"], [0, "&Rho;"], [1, "&Sigma;"], [0, "&Tau;"], [0, "&Upsilon;"], [0, "&Phi;"], [0, "&Chi;"], [0, "&Psi;"], [0, "&ohm;"], [7, "&alpha;"], [0, "&beta;"], [0, "&gamma;"], [0, "&delta;"], [0, "&epsi;"], [0, "&zeta;"], [0, "&eta;"], [0, "&theta;"], [0, "&iota;"], [0, "&kappa;"], [0, "&lambda;"], [0, "&mu;"], [0, "&nu;"], [0, "&xi;"], [0, "&omicron;"], [0, "&pi;"], [0, "&rho;"], [0, "&sigmaf;"], [0, "&sigma;"], [0, "&tau;"], [0, "&upsi;"], [0, "&phi;"], [0, "&chi;"], [0, "&psi;"], [0, "&omega;"], [7, "&thetasym;"], [0, "&Upsi;"], [2, "&phiv;"], [0, "&piv;"], [5, "&Gammad;"], [0, "&digamma;"], [18, "&kappav;"], [0, "&rhov;"], [3, "&epsiv;"], [0, "&backepsilon;"], [10, "&IOcy;"], [0, "&DJcy;"], [0, "&GJcy;"], [0, "&Jukcy;"], [0, "&DScy;"], [0, "&Iukcy;"], [0, "&YIcy;"], [0, "&Jsercy;"], [0, "&LJcy;"], [0, "&NJcy;"], [0, "&TSHcy;"], [0, "&KJcy;"], [1, "&Ubrcy;"], [0, "&DZcy;"], [0, "&Acy;"], [0, "&Bcy;"], [0, "&Vcy;"], [0, "&Gcy;"], [0, "&Dcy;"], [0, "&IEcy;"], [0, "&ZHcy;"], [0, "&Zcy;"], [0, "&Icy;"], [0, "&Jcy;"], [0, "&Kcy;"], [0, "&Lcy;"], [0, "&Mcy;"], [0, "&Ncy;"], [0, "&Ocy;"], [0, "&Pcy;"], [0, "&Rcy;"], [0, "&Scy;"], [0, "&Tcy;"], [0, "&Ucy;"], [0, "&Fcy;"], [0, "&KHcy;"], [0, "&TScy;"], [0, "&CHcy;"], [0, "&SHcy;"], [0, "&SHCHcy;"], [0, "&HARDcy;"], [0, "&Ycy;"], [0, "&SOFTcy;"], [0, "&Ecy;"], [0, "&YUcy;"], [0, "&YAcy;"], [0, "&acy;"], [0, "&bcy;"], [0, "&vcy;"], [0, "&gcy;"], [0, "&dcy;"], [0, "&iecy;"], [0, "&zhcy;"], [0, "&zcy;"], [0, "&icy;"], [0, "&jcy;"], [0, "&kcy;"], [0, "&lcy;"], [0, "&mcy;"], [0, "&ncy;"], [0, "&ocy;"], [0, "&pcy;"], [0, "&rcy;"], [0, "&scy;"], [0, "&tcy;"], [0, "&ucy;"], [0, "&fcy;"], [0, "&khcy;"], [0, "&tscy;"], [0, "&chcy;"], [0, "&shcy;"], [0, "&shchcy;"], [0, "&hardcy;"], [0, "&ycy;"], [0, "&softcy;"], [0, "&ecy;"], [0, "&yucy;"], [0, "&yacy;"], [1, "&iocy;"], [0, "&djcy;"], [0, "&gjcy;"], [0, "&jukcy;"], [0, "&dscy;"], [0, "&iukcy;"], [0, "&yicy;"], [0, "&jsercy;"], [0, "&ljcy;"], [0, "&njcy;"], [0, "&tshcy;"], [0, "&kjcy;"], [1, "&ubrcy;"], [0, "&dzcy;"], [7074, "&ensp;"], [0, "&emsp;"], [0, "&emsp13;"], [0, "&emsp14;"], [1, "&numsp;"], [0, "&puncsp;"], [0, "&ThinSpace;"], [0, "&hairsp;"], [0, "&NegativeMediumSpace;"], [0, "&zwnj;"], [0, "&zwj;"], [0, "&lrm;"], [0, "&rlm;"], [0, "&dash;"], [2, "&ndash;"], [0, "&mdash;"], [0, "&horbar;"], [0, "&Verbar;"], [1, "&lsquo;"], [0, "&CloseCurlyQuote;"], [0, "&lsquor;"], [1, "&ldquo;"], [0, "&CloseCurlyDoubleQuote;"], [0, "&bdquo;"], [1, "&dagger;"], [0, "&Dagger;"], [0, "&bull;"], [2, "&nldr;"], [0, "&hellip;"], [9, "&permil;"], [0, "&pertenk;"], [0, "&prime;"], [0, "&Prime;"], [0, "&tprime;"], [0, "&backprime;"], [3, "&lsaquo;"], [0, "&rsaquo;"], [3, "&oline;"], [2, "&caret;"], [1, "&hybull;"], [0, "&frasl;"], [10, "&bsemi;"], [7, "&qprime;"], [7, {
  v: "&MediumSpace;",
  n: 8202,
  o: "&ThickSpace;"
}], [0, "&NoBreak;"], [0, "&af;"], [0, "&InvisibleTimes;"], [0, "&ic;"], [72, "&euro;"], [46, "&tdot;"], [0, "&DotDot;"], [37, "&complexes;"], [2, "&incare;"], [4, "&gscr;"], [0, "&hamilt;"], [0, "&Hfr;"], [0, "&Hopf;"], [0, "&planckh;"], [0, "&hbar;"], [0, "&imagline;"], [0, "&Ifr;"], [0, "&lagran;"], [0, "&ell;"], [1, "&naturals;"], [0, "&numero;"], [0, "&copysr;"], [0, "&weierp;"], [0, "&Popf;"], [0, "&Qopf;"], [0, "&realine;"], [0, "&real;"], [0, "&reals;"], [0, "&rx;"], [3, "&trade;"], [1, "&integers;"], [2, "&mho;"], [0, "&zeetrf;"], [0, "&iiota;"], [2, "&bernou;"], [0, "&Cayleys;"], [1, "&escr;"], [0, "&Escr;"], [0, "&Fouriertrf;"], [1, "&Mellintrf;"], [0, "&order;"], [0, "&alefsym;"], [0, "&beth;"], [0, "&gimel;"], [0, "&daleth;"], [12, "&CapitalDifferentialD;"], [0, "&dd;"], [0, "&ee;"], [0, "&ii;"], [10, "&frac13;"], [0, "&frac23;"], [0, "&frac15;"], [0, "&frac25;"], [0, "&frac35;"], [0, "&frac45;"], [0, "&frac16;"], [0, "&frac56;"], [0, "&frac18;"], [0, "&frac38;"], [0, "&frac58;"], [0, "&frac78;"], [49, "&larr;"], [0, "&ShortUpArrow;"], [0, "&rarr;"], [0, "&darr;"], [0, "&harr;"], [0, "&updownarrow;"], [0, "&nwarr;"], [0, "&nearr;"], [0, "&LowerRightArrow;"], [0, "&LowerLeftArrow;"], [0, "&nlarr;"], [0, "&nrarr;"], [1, {
  v: "&rarrw;",
  n: 824,
  o: "&nrarrw;"
}], [0, "&Larr;"], [0, "&Uarr;"], [0, "&Rarr;"], [0, "&Darr;"], [0, "&larrtl;"], [0, "&rarrtl;"], [0, "&LeftTeeArrow;"], [0, "&mapstoup;"], [0, "&map;"], [0, "&DownTeeArrow;"], [1, "&hookleftarrow;"], [0, "&hookrightarrow;"], [0, "&larrlp;"], [0, "&looparrowright;"], [0, "&harrw;"], [0, "&nharr;"], [1, "&lsh;"], [0, "&rsh;"], [0, "&ldsh;"], [0, "&rdsh;"], [1, "&crarr;"], [0, "&cularr;"], [0, "&curarr;"], [2, "&circlearrowleft;"], [0, "&circlearrowright;"], [0, "&leftharpoonup;"], [0, "&DownLeftVector;"], [0, "&RightUpVector;"], [0, "&LeftUpVector;"], [0, "&rharu;"], [0, "&DownRightVector;"], [0, "&dharr;"], [0, "&dharl;"], [0, "&RightArrowLeftArrow;"], [0, "&udarr;"], [0, "&LeftArrowRightArrow;"], [0, "&leftleftarrows;"], [0, "&upuparrows;"], [0, "&rightrightarrows;"], [0, "&ddarr;"], [0, "&leftrightharpoons;"], [0, "&Equilibrium;"], [0, "&nlArr;"], [0, "&nhArr;"], [0, "&nrArr;"], [0, "&DoubleLeftArrow;"], [0, "&DoubleUpArrow;"], [0, "&DoubleRightArrow;"], [0, "&dArr;"], [0, "&DoubleLeftRightArrow;"], [0, "&DoubleUpDownArrow;"], [0, "&nwArr;"], [0, "&neArr;"], [0, "&seArr;"], [0, "&swArr;"], [0, "&lAarr;"], [0, "&rAarr;"], [1, "&zigrarr;"], [6, "&larrb;"], [0, "&rarrb;"], [15, "&DownArrowUpArrow;"], [7, "&loarr;"], [0, "&roarr;"], [0, "&hoarr;"], [0, "&forall;"], [0, "&comp;"], [0, {
  v: "&part;",
  n: 824,
  o: "&npart;"
}], [0, "&exist;"], [0, "&nexist;"], [0, "&empty;"], [1, "&Del;"], [0, "&Element;"], [0, "&NotElement;"], [1, "&ni;"], [0, "&notni;"], [2, "&prod;"], [0, "&coprod;"], [0, "&sum;"], [0, "&minus;"], [0, "&MinusPlus;"], [0, "&dotplus;"], [1, "&Backslash;"], [0, "&lowast;"], [0, "&compfn;"], [1, "&radic;"], [2, "&prop;"], [0, "&infin;"], [0, "&angrt;"], [0, {
  v: "&ang;",
  n: 8402,
  o: "&nang;"
}], [0, "&angmsd;"], [0, "&angsph;"], [0, "&mid;"], [0, "&nmid;"], [0, "&DoubleVerticalBar;"], [0, "&NotDoubleVerticalBar;"], [0, "&and;"], [0, "&or;"], [0, {
  v: "&cap;",
  n: 65024,
  o: "&caps;"
}], [0, {
  v: "&cup;",
  n: 65024,
  o: "&cups;"
}], [0, "&int;"], [0, "&Int;"], [0, "&iiint;"], [0, "&conint;"], [0, "&Conint;"], [0, "&Cconint;"], [0, "&cwint;"], [0, "&ClockwiseContourIntegral;"], [0, "&awconint;"], [0, "&there4;"], [0, "&becaus;"], [0, "&ratio;"], [0, "&Colon;"], [0, "&dotminus;"], [1, "&mDDot;"], [0, "&homtht;"], [0, {
  v: "&sim;",
  n: 8402,
  o: "&nvsim;"
}], [0, {
  v: "&backsim;",
  n: 817,
  o: "&race;"
}], [0, {
  v: "&ac;",
  n: 819,
  o: "&acE;"
}], [0, "&acd;"], [0, "&VerticalTilde;"], [0, "&NotTilde;"], [0, {
  v: "&eqsim;",
  n: 824,
  o: "&nesim;"
}], [0, "&sime;"], [0, "&NotTildeEqual;"], [0, "&cong;"], [0, "&simne;"], [0, "&ncong;"], [0, "&ap;"], [0, "&nap;"], [0, "&ape;"], [0, {
  v: "&apid;",
  n: 824,
  o: "&napid;"
}], [0, "&backcong;"], [0, {
  v: "&asympeq;",
  n: 8402,
  o: "&nvap;"
}], [0, {
  v: "&bump;",
  n: 824,
  o: "&nbump;"
}], [0, {
  v: "&bumpe;",
  n: 824,
  o: "&nbumpe;"
}], [0, {
  v: "&doteq;",
  n: 824,
  o: "&nedot;"
}], [0, "&doteqdot;"], [0, "&efDot;"], [0, "&erDot;"], [0, "&Assign;"], [0, "&ecolon;"], [0, "&ecir;"], [0, "&circeq;"], [1, "&wedgeq;"], [0, "&veeeq;"], [1, "&triangleq;"], [2, "&equest;"], [0, "&ne;"], [0, {
  v: "&Congruent;",
  n: 8421,
  o: "&bnequiv;"
}], [0, "&nequiv;"], [1, {
  v: "&le;",
  n: 8402,
  o: "&nvle;"
}], [0, {
  v: "&ge;",
  n: 8402,
  o: "&nvge;"
}], [0, {
  v: "&lE;",
  n: 824,
  o: "&nlE;"
}], [0, {
  v: "&gE;",
  n: 824,
  o: "&ngE;"
}], [0, {
  v: "&lnE;",
  n: 65024,
  o: "&lvertneqq;"
}], [0, {
  v: "&gnE;",
  n: 65024,
  o: "&gvertneqq;"
}], [0, {
  v: "&ll;",
  n: new Map( /* #__PURE__ */restoreDiff([[824, "&nLtv;"], [7577, "&nLt;"]]))
}], [0, {
  v: "&gg;",
  n: new Map( /* #__PURE__ */restoreDiff([[824, "&nGtv;"], [7577, "&nGt;"]]))
}], [0, "&between;"], [0, "&NotCupCap;"], [0, "&nless;"], [0, "&ngt;"], [0, "&nle;"], [0, "&nge;"], [0, "&lesssim;"], [0, "&GreaterTilde;"], [0, "&nlsim;"], [0, "&ngsim;"], [0, "&LessGreater;"], [0, "&gl;"], [0, "&NotLessGreater;"], [0, "&NotGreaterLess;"], [0, "&pr;"], [0, "&sc;"], [0, "&prcue;"], [0, "&sccue;"], [0, "&PrecedesTilde;"], [0, {
  v: "&scsim;",
  n: 824,
  o: "&NotSucceedsTilde;"
}], [0, "&NotPrecedes;"], [0, "&NotSucceeds;"], [0, {
  v: "&sub;",
  n: 8402,
  o: "&NotSubset;"
}], [0, {
  v: "&sup;",
  n: 8402,
  o: "&NotSuperset;"
}], [0, "&nsub;"], [0, "&nsup;"], [0, "&sube;"], [0, "&supe;"], [0, "&NotSubsetEqual;"], [0, "&NotSupersetEqual;"], [0, {
  v: "&subne;",
  n: 65024,
  o: "&varsubsetneq;"
}], [0, {
  v: "&supne;",
  n: 65024,
  o: "&varsupsetneq;"
}], [1, "&cupdot;"], [0, "&UnionPlus;"], [0, {
  v: "&sqsub;",
  n: 824,
  o: "&NotSquareSubset;"
}], [0, {
  v: "&sqsup;",
  n: 824,
  o: "&NotSquareSuperset;"
}], [0, "&sqsube;"], [0, "&sqsupe;"], [0, {
  v: "&sqcap;",
  n: 65024,
  o: "&sqcaps;"
}], [0, {
  v: "&sqcup;",
  n: 65024,
  o: "&sqcups;"
}], [0, "&CirclePlus;"], [0, "&CircleMinus;"], [0, "&CircleTimes;"], [0, "&osol;"], [0, "&CircleDot;"], [0, "&circledcirc;"], [0, "&circledast;"], [1, "&circleddash;"], [0, "&boxplus;"], [0, "&boxminus;"], [0, "&boxtimes;"], [0, "&dotsquare;"], [0, "&RightTee;"], [0, "&dashv;"], [0, "&DownTee;"], [0, "&bot;"], [1, "&models;"], [0, "&DoubleRightTee;"], [0, "&Vdash;"], [0, "&Vvdash;"], [0, "&VDash;"], [0, "&nvdash;"], [0, "&nvDash;"], [0, "&nVdash;"], [0, "&nVDash;"], [0, "&prurel;"], [1, "&LeftTriangle;"], [0, "&RightTriangle;"], [0, {
  v: "&LeftTriangleEqual;",
  n: 8402,
  o: "&nvltrie;"
}], [0, {
  v: "&RightTriangleEqual;",
  n: 8402,
  o: "&nvrtrie;"
}], [0, "&origof;"], [0, "&imof;"], [0, "&multimap;"], [0, "&hercon;"], [0, "&intcal;"], [0, "&veebar;"], [1, "&barvee;"], [0, "&angrtvb;"], [0, "&lrtri;"], [0, "&bigwedge;"], [0, "&bigvee;"], [0, "&bigcap;"], [0, "&bigcup;"], [0, "&diam;"], [0, "&sdot;"], [0, "&sstarf;"], [0, "&divideontimes;"], [0, "&bowtie;"], [0, "&ltimes;"], [0, "&rtimes;"], [0, "&leftthreetimes;"], [0, "&rightthreetimes;"], [0, "&backsimeq;"], [0, "&curlyvee;"], [0, "&curlywedge;"], [0, "&Sub;"], [0, "&Sup;"], [0, "&Cap;"], [0, "&Cup;"], [0, "&fork;"], [0, "&epar;"], [0, "&lessdot;"], [0, "&gtdot;"], [0, {
  v: "&Ll;",
  n: 824,
  o: "&nLl;"
}], [0, {
  v: "&Gg;",
  n: 824,
  o: "&nGg;"
}], [0, {
  v: "&leg;",
  n: 65024,
  o: "&lesg;"
}], [0, {
  v: "&gel;",
  n: 65024,
  o: "&gesl;"
}], [2, "&cuepr;"], [0, "&cuesc;"], [0, "&NotPrecedesSlantEqual;"], [0, "&NotSucceedsSlantEqual;"], [0, "&NotSquareSubsetEqual;"], [0, "&NotSquareSupersetEqual;"], [2, "&lnsim;"], [0, "&gnsim;"], [0, "&precnsim;"], [0, "&scnsim;"], [0, "&nltri;"], [0, "&NotRightTriangle;"], [0, "&nltrie;"], [0, "&NotRightTriangleEqual;"], [0, "&vellip;"], [0, "&ctdot;"], [0, "&utdot;"], [0, "&dtdot;"], [0, "&disin;"], [0, "&isinsv;"], [0, "&isins;"], [0, {
  v: "&isindot;",
  n: 824,
  o: "&notindot;"
}], [0, "&notinvc;"], [0, "&notinvb;"], [1, {
  v: "&isinE;",
  n: 824,
  o: "&notinE;"
}], [0, "&nisd;"], [0, "&xnis;"], [0, "&nis;"], [0, "&notnivc;"], [0, "&notnivb;"], [6, "&barwed;"], [0, "&Barwed;"], [1, "&lceil;"], [0, "&rceil;"], [0, "&LeftFloor;"], [0, "&rfloor;"], [0, "&drcrop;"], [0, "&dlcrop;"], [0, "&urcrop;"], [0, "&ulcrop;"], [0, "&bnot;"], [1, "&profline;"], [0, "&profsurf;"], [1, "&telrec;"], [0, "&target;"], [5, "&ulcorn;"], [0, "&urcorn;"], [0, "&dlcorn;"], [0, "&drcorn;"], [2, "&frown;"], [0, "&smile;"], [9, "&cylcty;"], [0, "&profalar;"], [7, "&topbot;"], [6, "&ovbar;"], [1, "&solbar;"], [60, "&angzarr;"], [51, "&lmoustache;"], [0, "&rmoustache;"], [2, "&OverBracket;"], [0, "&bbrk;"], [0, "&bbrktbrk;"], [37, "&OverParenthesis;"], [0, "&UnderParenthesis;"], [0, "&OverBrace;"], [0, "&UnderBrace;"], [2, "&trpezium;"], [4, "&elinters;"], [59, "&blank;"], [164, "&circledS;"], [55, "&boxh;"], [1, "&boxv;"], [9, "&boxdr;"], [3, "&boxdl;"], [3, "&boxur;"], [3, "&boxul;"], [3, "&boxvr;"], [7, "&boxvl;"], [7, "&boxhd;"], [7, "&boxhu;"], [7, "&boxvh;"], [19, "&boxH;"], [0, "&boxV;"], [0, "&boxdR;"], [0, "&boxDr;"], [0, "&boxDR;"], [0, "&boxdL;"], [0, "&boxDl;"], [0, "&boxDL;"], [0, "&boxuR;"], [0, "&boxUr;"], [0, "&boxUR;"], [0, "&boxuL;"], [0, "&boxUl;"], [0, "&boxUL;"], [0, "&boxvR;"], [0, "&boxVr;"], [0, "&boxVR;"], [0, "&boxvL;"], [0, "&boxVl;"], [0, "&boxVL;"], [0, "&boxHd;"], [0, "&boxhD;"], [0, "&boxHD;"], [0, "&boxHu;"], [0, "&boxhU;"], [0, "&boxHU;"], [0, "&boxvH;"], [0, "&boxVh;"], [0, "&boxVH;"], [19, "&uhblk;"], [3, "&lhblk;"], [3, "&block;"], [8, "&blk14;"], [0, "&blk12;"], [0, "&blk34;"], [13, "&square;"], [8, "&blacksquare;"], [0, "&EmptyVerySmallSquare;"], [1, "&rect;"], [0, "&marker;"], [2, "&fltns;"], [1, "&bigtriangleup;"], [0, "&blacktriangle;"], [0, "&triangle;"], [2, "&blacktriangleright;"], [0, "&rtri;"], [3, "&bigtriangledown;"], [0, "&blacktriangledown;"], [0, "&dtri;"], [2, "&blacktriangleleft;"], [0, "&ltri;"], [6, "&loz;"], [0, "&cir;"], [32, "&tridot;"], [2, "&bigcirc;"], [8, "&ultri;"], [0, "&urtri;"], [0, "&lltri;"], [0, "&EmptySmallSquare;"], [0, "&FilledSmallSquare;"], [8, "&bigstar;"], [0, "&star;"], [7, "&phone;"], [49, "&female;"], [1, "&male;"], [29, "&spades;"], [2, "&clubs;"], [1, "&hearts;"], [0, "&diamondsuit;"], [3, "&sung;"], [2, "&flat;"], [0, "&natural;"], [0, "&sharp;"], [163, "&check;"], [3, "&cross;"], [8, "&malt;"], [21, "&sext;"], [33, "&VerticalSeparator;"], [25, "&lbbrk;"], [0, "&rbbrk;"], [84, "&bsolhsub;"], [0, "&suphsol;"], [28, "&LeftDoubleBracket;"], [0, "&RightDoubleBracket;"], [0, "&lang;"], [0, "&rang;"], [0, "&Lang;"], [0, "&Rang;"], [0, "&loang;"], [0, "&roang;"], [7, "&longleftarrow;"], [0, "&longrightarrow;"], [0, "&longleftrightarrow;"], [0, "&DoubleLongLeftArrow;"], [0, "&DoubleLongRightArrow;"], [0, "&DoubleLongLeftRightArrow;"], [1, "&longmapsto;"], [2, "&dzigrarr;"], [258, "&nvlArr;"], [0, "&nvrArr;"], [0, "&nvHarr;"], [0, "&Map;"], [6, "&lbarr;"], [0, "&bkarow;"], [0, "&lBarr;"], [0, "&dbkarow;"], [0, "&drbkarow;"], [0, "&DDotrahd;"], [0, "&UpArrowBar;"], [0, "&DownArrowBar;"], [2, "&Rarrtl;"], [2, "&latail;"], [0, "&ratail;"], [0, "&lAtail;"], [0, "&rAtail;"], [0, "&larrfs;"], [0, "&rarrfs;"], [0, "&larrbfs;"], [0, "&rarrbfs;"], [2, "&nwarhk;"], [0, "&nearhk;"], [0, "&hksearow;"], [0, "&hkswarow;"], [0, "&nwnear;"], [0, "&nesear;"], [0, "&seswar;"], [0, "&swnwar;"], [8, {
  v: "&rarrc;",
  n: 824,
  o: "&nrarrc;"
}], [1, "&cudarrr;"], [0, "&ldca;"], [0, "&rdca;"], [0, "&cudarrl;"], [0, "&larrpl;"], [2, "&curarrm;"], [0, "&cularrp;"], [7, "&rarrpl;"], [2, "&harrcir;"], [0, "&Uarrocir;"], [0, "&lurdshar;"], [0, "&ldrushar;"], [2, "&LeftRightVector;"], [0, "&RightUpDownVector;"], [0, "&DownLeftRightVector;"], [0, "&LeftUpDownVector;"], [0, "&LeftVectorBar;"], [0, "&RightVectorBar;"], [0, "&RightUpVectorBar;"], [0, "&RightDownVectorBar;"], [0, "&DownLeftVectorBar;"], [0, "&DownRightVectorBar;"], [0, "&LeftUpVectorBar;"], [0, "&LeftDownVectorBar;"], [0, "&LeftTeeVector;"], [0, "&RightTeeVector;"], [0, "&RightUpTeeVector;"], [0, "&RightDownTeeVector;"], [0, "&DownLeftTeeVector;"], [0, "&DownRightTeeVector;"], [0, "&LeftUpTeeVector;"], [0, "&LeftDownTeeVector;"], [0, "&lHar;"], [0, "&uHar;"], [0, "&rHar;"], [0, "&dHar;"], [0, "&luruhar;"], [0, "&ldrdhar;"], [0, "&ruluhar;"], [0, "&rdldhar;"], [0, "&lharul;"], [0, "&llhard;"], [0, "&rharul;"], [0, "&lrhard;"], [0, "&udhar;"], [0, "&duhar;"], [0, "&RoundImplies;"], [0, "&erarr;"], [0, "&simrarr;"], [0, "&larrsim;"], [0, "&rarrsim;"], [0, "&rarrap;"], [0, "&ltlarr;"], [1, "&gtrarr;"], [0, "&subrarr;"], [1, "&suplarr;"], [0, "&lfisht;"], [0, "&rfisht;"], [0, "&ufisht;"], [0, "&dfisht;"], [5, "&lopar;"], [0, "&ropar;"], [4, "&lbrke;"], [0, "&rbrke;"], [0, "&lbrkslu;"], [0, "&rbrksld;"], [0, "&lbrksld;"], [0, "&rbrkslu;"], [0, "&langd;"], [0, "&rangd;"], [0, "&lparlt;"], [0, "&rpargt;"], [0, "&gtlPar;"], [0, "&ltrPar;"], [3, "&vzigzag;"], [1, "&vangrt;"], [0, "&angrtvbd;"], [6, "&ange;"], [0, "&range;"], [0, "&dwangle;"], [0, "&uwangle;"], [0, "&angmsdaa;"], [0, "&angmsdab;"], [0, "&angmsdac;"], [0, "&angmsdad;"], [0, "&angmsdae;"], [0, "&angmsdaf;"], [0, "&angmsdag;"], [0, "&angmsdah;"], [0, "&bemptyv;"], [0, "&demptyv;"], [0, "&cemptyv;"], [0, "&raemptyv;"], [0, "&laemptyv;"], [0, "&ohbar;"], [0, "&omid;"], [0, "&opar;"], [1, "&operp;"], [1, "&olcross;"], [0, "&odsold;"], [1, "&olcir;"], [0, "&ofcir;"], [0, "&olt;"], [0, "&ogt;"], [0, "&cirscir;"], [0, "&cirE;"], [0, "&solb;"], [0, "&bsolb;"], [3, "&boxbox;"], [3, "&trisb;"], [0, "&rtriltri;"], [0, {
  v: "&LeftTriangleBar;",
  n: 824,
  o: "&NotLeftTriangleBar;"
}], [0, {
  v: "&RightTriangleBar;",
  n: 824,
  o: "&NotRightTriangleBar;"
}], [11, "&iinfin;"], [0, "&infintie;"], [0, "&nvinfin;"], [4, "&eparsl;"], [0, "&smeparsl;"], [0, "&eqvparsl;"], [5, "&blacklozenge;"], [8, "&RuleDelayed;"], [1, "&dsol;"], [9, "&bigodot;"], [0, "&bigoplus;"], [0, "&bigotimes;"], [1, "&biguplus;"], [1, "&bigsqcup;"], [5, "&iiiint;"], [0, "&fpartint;"], [2, "&cirfnint;"], [0, "&awint;"], [0, "&rppolint;"], [0, "&scpolint;"], [0, "&npolint;"], [0, "&pointint;"], [0, "&quatint;"], [0, "&intlarhk;"], [10, "&pluscir;"], [0, "&plusacir;"], [0, "&simplus;"], [0, "&plusdu;"], [0, "&plussim;"], [0, "&plustwo;"], [1, "&mcomma;"], [0, "&minusdu;"], [2, "&loplus;"], [0, "&roplus;"], [0, "&Cross;"], [0, "&timesd;"], [0, "&timesbar;"], [1, "&smashp;"], [0, "&lotimes;"], [0, "&rotimes;"], [0, "&otimesas;"], [0, "&Otimes;"], [0, "&odiv;"], [0, "&triplus;"], [0, "&triminus;"], [0, "&tritime;"], [0, "&intprod;"], [2, "&amalg;"], [0, "&capdot;"], [1, "&ncup;"], [0, "&ncap;"], [0, "&capand;"], [0, "&cupor;"], [0, "&cupcap;"], [0, "&capcup;"], [0, "&cupbrcap;"], [0, "&capbrcup;"], [0, "&cupcup;"], [0, "&capcap;"], [0, "&ccups;"], [0, "&ccaps;"], [2, "&ccupssm;"], [2, "&And;"], [0, "&Or;"], [0, "&andand;"], [0, "&oror;"], [0, "&orslope;"], [0, "&andslope;"], [1, "&andv;"], [0, "&orv;"], [0, "&andd;"], [0, "&ord;"], [1, "&wedbar;"], [6, "&sdote;"], [3, "&simdot;"], [2, {
  v: "&congdot;",
  n: 824,
  o: "&ncongdot;"
}], [0, "&easter;"], [0, "&apacir;"], [0, {
  v: "&apE;",
  n: 824,
  o: "&napE;"
}], [0, "&eplus;"], [0, "&pluse;"], [0, "&Esim;"], [0, "&Colone;"], [0, "&Equal;"], [1, "&ddotseq;"], [0, "&equivDD;"], [0, "&ltcir;"], [0, "&gtcir;"], [0, "&ltquest;"], [0, "&gtquest;"], [0, {
  v: "&leqslant;",
  n: 824,
  o: "&nleqslant;"
}], [0, {
  v: "&geqslant;",
  n: 824,
  o: "&ngeqslant;"
}], [0, "&lesdot;"], [0, "&gesdot;"], [0, "&lesdoto;"], [0, "&gesdoto;"], [0, "&lesdotor;"], [0, "&gesdotol;"], [0, "&lap;"], [0, "&gap;"], [0, "&lne;"], [0, "&gne;"], [0, "&lnap;"], [0, "&gnap;"], [0, "&lEg;"], [0, "&gEl;"], [0, "&lsime;"], [0, "&gsime;"], [0, "&lsimg;"], [0, "&gsiml;"], [0, "&lgE;"], [0, "&glE;"], [0, "&lesges;"], [0, "&gesles;"], [0, "&els;"], [0, "&egs;"], [0, "&elsdot;"], [0, "&egsdot;"], [0, "&el;"], [0, "&eg;"], [2, "&siml;"], [0, "&simg;"], [0, "&simlE;"], [0, "&simgE;"], [0, {
  v: "&LessLess;",
  n: 824,
  o: "&NotNestedLessLess;"
}], [0, {
  v: "&GreaterGreater;",
  n: 824,
  o: "&NotNestedGreaterGreater;"
}], [1, "&glj;"], [0, "&gla;"], [0, "&ltcc;"], [0, "&gtcc;"], [0, "&lescc;"], [0, "&gescc;"], [0, "&smt;"], [0, "&lat;"], [0, {
  v: "&smte;",
  n: 65024,
  o: "&smtes;"
}], [0, {
  v: "&late;",
  n: 65024,
  o: "&lates;"
}], [0, "&bumpE;"], [0, {
  v: "&PrecedesEqual;",
  n: 824,
  o: "&NotPrecedesEqual;"
}], [0, {
  v: "&sce;",
  n: 824,
  o: "&NotSucceedsEqual;"
}], [2, "&prE;"], [0, "&scE;"], [0, "&precneqq;"], [0, "&scnE;"], [0, "&prap;"], [0, "&scap;"], [0, "&precnapprox;"], [0, "&scnap;"], [0, "&Pr;"], [0, "&Sc;"], [0, "&subdot;"], [0, "&supdot;"], [0, "&subplus;"], [0, "&supplus;"], [0, "&submult;"], [0, "&supmult;"], [0, "&subedot;"], [0, "&supedot;"], [0, {
  v: "&subE;",
  n: 824,
  o: "&nsubE;"
}], [0, {
  v: "&supE;",
  n: 824,
  o: "&nsupE;"
}], [0, "&subsim;"], [0, "&supsim;"], [2, {
  v: "&subnE;",
  n: 65024,
  o: "&varsubsetneqq;"
}], [0, {
  v: "&supnE;",
  n: 65024,
  o: "&varsupsetneqq;"
}], [2, "&csub;"], [0, "&csup;"], [0, "&csube;"], [0, "&csupe;"], [0, "&subsup;"], [0, "&supsub;"], [0, "&subsub;"], [0, "&supsup;"], [0, "&suphsub;"], [0, "&supdsub;"], [0, "&forkv;"], [0, "&topfork;"], [0, "&mlcp;"], [8, "&Dashv;"], [1, "&Vdashl;"], [0, "&Barv;"], [0, "&vBar;"], [0, "&vBarv;"], [1, "&Vbar;"], [0, "&Not;"], [0, "&bNot;"], [0, "&rnmid;"], [0, "&cirmid;"], [0, "&midcir;"], [0, "&topcir;"], [0, "&nhpar;"], [0, "&parsim;"], [9, {
  v: "&parsl;",
  n: 8421,
  o: "&nparsl;"
}], [44343, {
  n: new Map( /* #__PURE__ */restoreDiff([[56476, "&Ascr;"], [1, "&Cscr;"], [0, "&Dscr;"], [2, "&Gscr;"], [2, "&Jscr;"], [0, "&Kscr;"], [2, "&Nscr;"], [0, "&Oscr;"], [0, "&Pscr;"], [0, "&Qscr;"], [1, "&Sscr;"], [0, "&Tscr;"], [0, "&Uscr;"], [0, "&Vscr;"], [0, "&Wscr;"], [0, "&Xscr;"], [0, "&Yscr;"], [0, "&Zscr;"], [0, "&ascr;"], [0, "&bscr;"], [0, "&cscr;"], [0, "&dscr;"], [1, "&fscr;"], [1, "&hscr;"], [0, "&iscr;"], [0, "&jscr;"], [0, "&kscr;"], [0, "&lscr;"], [0, "&mscr;"], [0, "&nscr;"], [1, "&pscr;"], [0, "&qscr;"], [0, "&rscr;"], [0, "&sscr;"], [0, "&tscr;"], [0, "&uscr;"], [0, "&vscr;"], [0, "&wscr;"], [0, "&xscr;"], [0, "&yscr;"], [0, "&zscr;"], [52, "&Afr;"], [0, "&Bfr;"], [1, "&Dfr;"], [0, "&Efr;"], [0, "&Ffr;"], [0, "&Gfr;"], [2, "&Jfr;"], [0, "&Kfr;"], [0, "&Lfr;"], [0, "&Mfr;"], [0, "&Nfr;"], [0, "&Ofr;"], [0, "&Pfr;"], [0, "&Qfr;"], [1, "&Sfr;"], [0, "&Tfr;"], [0, "&Ufr;"], [0, "&Vfr;"], [0, "&Wfr;"], [0, "&Xfr;"], [0, "&Yfr;"], [1, "&afr;"], [0, "&bfr;"], [0, "&cfr;"], [0, "&dfr;"], [0, "&efr;"], [0, "&ffr;"], [0, "&gfr;"], [0, "&hfr;"], [0, "&ifr;"], [0, "&jfr;"], [0, "&kfr;"], [0, "&lfr;"], [0, "&mfr;"], [0, "&nfr;"], [0, "&ofr;"], [0, "&pfr;"], [0, "&qfr;"], [0, "&rfr;"], [0, "&sfr;"], [0, "&tfr;"], [0, "&ufr;"], [0, "&vfr;"], [0, "&wfr;"], [0, "&xfr;"], [0, "&yfr;"], [0, "&zfr;"], [0, "&Aopf;"], [0, "&Bopf;"], [1, "&Dopf;"], [0, "&Eopf;"], [0, "&Fopf;"], [0, "&Gopf;"], [1, "&Iopf;"], [0, "&Jopf;"], [0, "&Kopf;"], [0, "&Lopf;"], [0, "&Mopf;"], [1, "&Oopf;"], [3, "&Sopf;"], [0, "&Topf;"], [0, "&Uopf;"], [0, "&Vopf;"], [0, "&Wopf;"], [0, "&Xopf;"], [0, "&Yopf;"], [1, "&aopf;"], [0, "&bopf;"], [0, "&copf;"], [0, "&dopf;"], [0, "&eopf;"], [0, "&fopf;"], [0, "&gopf;"], [0, "&hopf;"], [0, "&iopf;"], [0, "&jopf;"], [0, "&kopf;"], [0, "&lopf;"], [0, "&mopf;"], [0, "&nopf;"], [0, "&oopf;"], [0, "&popf;"], [0, "&qopf;"], [0, "&ropf;"], [0, "&sopf;"], [0, "&topf;"], [0, "&uopf;"], [0, "&vopf;"], [0, "&wopf;"], [0, "&xopf;"], [0, "&yopf;"], [0, "&zopf;"]]))
}], [8906, "&fflig;"], [0, "&filig;"], [0, "&fllig;"], [0, "&ffilig;"], [0, "&ffllig;"]]));

/***/ }),

/***/ "./node_modules/entities/lib/index.js":
/*!********************************************!*\
  !*** ./node_modules/entities/lib/index.js ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.decodeXMLStrict = exports.decodeHTML5Strict = exports.decodeHTML4Strict = exports.decodeHTML5 = exports.decodeHTML4 = exports.decodeHTMLAttribute = exports.decodeHTMLStrict = exports.decodeHTML = exports.decodeXML = exports.DecodingMode = exports.EntityDecoder = exports.encodeHTML5 = exports.encodeHTML4 = exports.encodeNonAsciiHTML = exports.encodeHTML = exports.escapeText = exports.escapeAttribute = exports.escapeUTF8 = exports.escape = exports.encodeXML = exports.encode = exports.decodeStrict = exports.decode = exports.EncodingMode = exports.EntityLevel = void 0;
var decode_js_1 = __webpack_require__(/*! ./decode.js */ "./node_modules/entities/lib/decode.js");
var encode_js_1 = __webpack_require__(/*! ./encode.js */ "./node_modules/entities/lib/encode.js");
var escape_js_1 = __webpack_require__(/*! ./escape.js */ "./node_modules/entities/lib/escape.js");
/** The level of entities to support. */
var EntityLevel;
(function (EntityLevel) {
  /** Support only XML entities. */
  EntityLevel[EntityLevel["XML"] = 0] = "XML";
  /** Support HTML entities, which are a superset of XML entities. */
  EntityLevel[EntityLevel["HTML"] = 1] = "HTML";
})(EntityLevel = exports.EntityLevel || (exports.EntityLevel = {}));
var EncodingMode;
(function (EncodingMode) {
  /**
   * The output is UTF-8 encoded. Only characters that need escaping within
   * XML will be escaped.
   */
  EncodingMode[EncodingMode["UTF8"] = 0] = "UTF8";
  /**
   * The output consists only of ASCII characters. Characters that need
   * escaping within HTML, and characters that aren't ASCII characters will
   * be escaped.
   */
  EncodingMode[EncodingMode["ASCII"] = 1] = "ASCII";
  /**
   * Encode all characters that have an equivalent entity, as well as all
   * characters that are not ASCII characters.
   */
  EncodingMode[EncodingMode["Extensive"] = 2] = "Extensive";
  /**
   * Encode all characters that have to be escaped in HTML attributes,
   * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
   */
  EncodingMode[EncodingMode["Attribute"] = 3] = "Attribute";
  /**
   * Encode all characters that have to be escaped in HTML text,
   * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
   */
  EncodingMode[EncodingMode["Text"] = 4] = "Text";
})(EncodingMode = exports.EncodingMode || (exports.EncodingMode = {}));
/**
 * Decodes a string with entities.
 *
 * @param data String to decode.
 * @param options Decoding options.
 */
function decode(data, options) {
  if (options === void 0) {
    options = EntityLevel.XML;
  }
  var level = typeof options === "number" ? options : options.level;
  if (level === EntityLevel.HTML) {
    var mode = typeof options === "object" ? options.mode : undefined;
    return (0, decode_js_1.decodeHTML)(data, mode);
  }
  return (0, decode_js_1.decodeXML)(data);
}
exports.decode = decode;
/**
 * Decodes a string with entities. Does not allow missing trailing semicolons for entities.
 *
 * @param data String to decode.
 * @param options Decoding options.
 * @deprecated Use `decode` with the `mode` set to `Strict`.
 */
function decodeStrict(data, options) {
  var _a;
  if (options === void 0) {
    options = EntityLevel.XML;
  }
  var opts = typeof options === "number" ? {
    level: options
  } : options;
  (_a = opts.mode) !== null && _a !== void 0 ? _a : opts.mode = decode_js_1.DecodingMode.Strict;
  return decode(data, opts);
}
exports.decodeStrict = decodeStrict;
/**
 * Encodes a string with entities.
 *
 * @param data String to encode.
 * @param options Encoding options.
 */
function encode(data, options) {
  if (options === void 0) {
    options = EntityLevel.XML;
  }
  var opts = typeof options === "number" ? {
    level: options
  } : options;
  // Mode `UTF8` just escapes XML entities
  if (opts.mode === EncodingMode.UTF8) return (0, escape_js_1.escapeUTF8)(data);
  if (opts.mode === EncodingMode.Attribute) return (0, escape_js_1.escapeAttribute)(data);
  if (opts.mode === EncodingMode.Text) return (0, escape_js_1.escapeText)(data);
  if (opts.level === EntityLevel.HTML) {
    if (opts.mode === EncodingMode.ASCII) {
      return (0, encode_js_1.encodeNonAsciiHTML)(data);
    }
    return (0, encode_js_1.encodeHTML)(data);
  }
  // ASCII and Extensive are equivalent
  return (0, escape_js_1.encodeXML)(data);
}
exports.encode = encode;
var escape_js_2 = __webpack_require__(/*! ./escape.js */ "./node_modules/entities/lib/escape.js");
Object.defineProperty(exports, "encodeXML", ({
  enumerable: true,
  get: function () {
    return escape_js_2.encodeXML;
  }
}));
Object.defineProperty(exports, "escape", ({
  enumerable: true,
  get: function () {
    return escape_js_2.escape;
  }
}));
Object.defineProperty(exports, "escapeUTF8", ({
  enumerable: true,
  get: function () {
    return escape_js_2.escapeUTF8;
  }
}));
Object.defineProperty(exports, "escapeAttribute", ({
  enumerable: true,
  get: function () {
    return escape_js_2.escapeAttribute;
  }
}));
Object.defineProperty(exports, "escapeText", ({
  enumerable: true,
  get: function () {
    return escape_js_2.escapeText;
  }
}));
var encode_js_2 = __webpack_require__(/*! ./encode.js */ "./node_modules/entities/lib/encode.js");
Object.defineProperty(exports, "encodeHTML", ({
  enumerable: true,
  get: function () {
    return encode_js_2.encodeHTML;
  }
}));
Object.defineProperty(exports, "encodeNonAsciiHTML", ({
  enumerable: true,
  get: function () {
    return encode_js_2.encodeNonAsciiHTML;
  }
}));
// Legacy aliases (deprecated)
Object.defineProperty(exports, "encodeHTML4", ({
  enumerable: true,
  get: function () {
    return encode_js_2.encodeHTML;
  }
}));
Object.defineProperty(exports, "encodeHTML5", ({
  enumerable: true,
  get: function () {
    return encode_js_2.encodeHTML;
  }
}));
var decode_js_2 = __webpack_require__(/*! ./decode.js */ "./node_modules/entities/lib/decode.js");
Object.defineProperty(exports, "EntityDecoder", ({
  enumerable: true,
  get: function () {
    return decode_js_2.EntityDecoder;
  }
}));
Object.defineProperty(exports, "DecodingMode", ({
  enumerable: true,
  get: function () {
    return decode_js_2.DecodingMode;
  }
}));
Object.defineProperty(exports, "decodeXML", ({
  enumerable: true,
  get: function () {
    return decode_js_2.decodeXML;
  }
}));
Object.defineProperty(exports, "decodeHTML", ({
  enumerable: true,
  get: function () {
    return decode_js_2.decodeHTML;
  }
}));
Object.defineProperty(exports, "decodeHTMLStrict", ({
  enumerable: true,
  get: function () {
    return decode_js_2.decodeHTMLStrict;
  }
}));
Object.defineProperty(exports, "decodeHTMLAttribute", ({
  enumerable: true,
  get: function () {
    return decode_js_2.decodeHTMLAttribute;
  }
}));
// Legacy aliases (deprecated)
Object.defineProperty(exports, "decodeHTML4", ({
  enumerable: true,
  get: function () {
    return decode_js_2.decodeHTML;
  }
}));
Object.defineProperty(exports, "decodeHTML5", ({
  enumerable: true,
  get: function () {
    return decode_js_2.decodeHTML;
  }
}));
Object.defineProperty(exports, "decodeHTML4Strict", ({
  enumerable: true,
  get: function () {
    return decode_js_2.decodeHTMLStrict;
  }
}));
Object.defineProperty(exports, "decodeHTML5Strict", ({
  enumerable: true,
  get: function () {
    return decode_js_2.decodeHTMLStrict;
  }
}));
Object.defineProperty(exports, "decodeXMLStrict", ({
  enumerable: true,
  get: function () {
    return decode_js_2.decodeXML;
  }
}));

/***/ }),

/***/ "./node_modules/escape-string-regexp/index.js":
/*!****************************************************!*\
  !*** ./node_modules/escape-string-regexp/index.js ***!
  \****************************************************/
/***/ ((module) => {

"use strict";


module.exports = string => {
  if (typeof string !== 'string') {
    throw new TypeError('Expected a string');
  }

  // Escape characters with special meaning either inside or outside character sets.
  // Use a simple backslash escape when it’s always valid, and a \unnnn escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
  return string.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
};

/***/ }),

/***/ "./node_modules/htmlparser2/lib/Parser.js":
/*!************************************************!*\
  !*** ./node_modules/htmlparser2/lib/Parser.js ***!
  \************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Parser = void 0;
var Tokenizer_js_1 = __importStar(__webpack_require__(/*! ./Tokenizer.js */ "./node_modules/htmlparser2/lib/Tokenizer.js"));
var decode_js_1 = __webpack_require__(/*! entities/lib/decode.js */ "./node_modules/entities/lib/decode.js");
var formTags = new Set(["input", "option", "optgroup", "select", "button", "datalist", "textarea"]);
var pTag = new Set(["p"]);
var tableSectionTags = new Set(["thead", "tbody"]);
var ddtTags = new Set(["dd", "dt"]);
var rtpTags = new Set(["rt", "rp"]);
var openImpliesClose = new Map([["tr", new Set(["tr", "th", "td"])], ["th", new Set(["th"])], ["td", new Set(["thead", "th", "td"])], ["body", new Set(["head", "link", "script"])], ["li", new Set(["li"])], ["p", pTag], ["h1", pTag], ["h2", pTag], ["h3", pTag], ["h4", pTag], ["h5", pTag], ["h6", pTag], ["select", formTags], ["input", formTags], ["output", formTags], ["button", formTags], ["datalist", formTags], ["textarea", formTags], ["option", new Set(["option"])], ["optgroup", new Set(["optgroup", "option"])], ["dd", ddtTags], ["dt", ddtTags], ["address", pTag], ["article", pTag], ["aside", pTag], ["blockquote", pTag], ["details", pTag], ["div", pTag], ["dl", pTag], ["fieldset", pTag], ["figcaption", pTag], ["figure", pTag], ["footer", pTag], ["form", pTag], ["header", pTag], ["hr", pTag], ["main", pTag], ["nav", pTag], ["ol", pTag], ["pre", pTag], ["section", pTag], ["table", pTag], ["ul", pTag], ["rt", rtpTags], ["rp", rtpTags], ["tbody", tableSectionTags], ["tfoot", tableSectionTags]]);
var voidElements = new Set(["area", "base", "basefont", "br", "col", "command", "embed", "frame", "hr", "img", "input", "isindex", "keygen", "link", "meta", "param", "source", "track", "wbr"]);
var foreignContextElements = new Set(["math", "svg"]);
var htmlIntegrationElements = new Set(["mi", "mo", "mn", "ms", "mtext", "annotation-xml", "foreignobject", "desc", "title"]);
var reNameEnd = /\s|\//;
var Parser = /** @class */function () {
  function Parser(cbs, options) {
    if (options === void 0) {
      options = {};
    }
    var _a, _b, _c, _d, _e;
    this.options = options;
    /** The start index of the last event. */
    this.startIndex = 0;
    /** The end index of the last event. */
    this.endIndex = 0;
    /**
     * Store the start index of the current open tag,
     * so we can update the start index for attributes.
     */
    this.openTagStart = 0;
    this.tagname = "";
    this.attribname = "";
    this.attribvalue = "";
    this.attribs = null;
    this.stack = [];
    this.foreignContext = [];
    this.buffers = [];
    this.bufferOffset = 0;
    /** The index of the last written buffer. Used when resuming after a `pause()`. */
    this.writeIndex = 0;
    /** Indicates whether the parser has finished running / `.end` has been called. */
    this.ended = false;
    this.cbs = cbs !== null && cbs !== void 0 ? cbs : {};
    this.lowerCaseTagNames = (_a = options.lowerCaseTags) !== null && _a !== void 0 ? _a : !options.xmlMode;
    this.lowerCaseAttributeNames = (_b = options.lowerCaseAttributeNames) !== null && _b !== void 0 ? _b : !options.xmlMode;
    this.tokenizer = new ((_c = options.Tokenizer) !== null && _c !== void 0 ? _c : Tokenizer_js_1.default)(this.options, this);
    (_e = (_d = this.cbs).onparserinit) === null || _e === void 0 ? void 0 : _e.call(_d, this);
  }
  // Tokenizer event handlers
  /** @internal */
  Parser.prototype.ontext = function (start, endIndex) {
    var _a, _b;
    var data = this.getSlice(start, endIndex);
    this.endIndex = endIndex - 1;
    (_b = (_a = this.cbs).ontext) === null || _b === void 0 ? void 0 : _b.call(_a, data);
    this.startIndex = endIndex;
  };
  /** @internal */
  Parser.prototype.ontextentity = function (cp) {
    var _a, _b;
    /*
     * Entities can be emitted on the character, or directly after.
     * We use the section start here to get accurate indices.
     */
    var index = this.tokenizer.getSectionStart();
    this.endIndex = index - 1;
    (_b = (_a = this.cbs).ontext) === null || _b === void 0 ? void 0 : _b.call(_a, (0, decode_js_1.fromCodePoint)(cp));
    this.startIndex = index;
  };
  Parser.prototype.isVoidElement = function (name) {
    return !this.options.xmlMode && voidElements.has(name);
  };
  /** @internal */
  Parser.prototype.onopentagname = function (start, endIndex) {
    this.endIndex = endIndex;
    var name = this.getSlice(start, endIndex);
    if (this.lowerCaseTagNames) {
      name = name.toLowerCase();
    }
    this.emitOpenTag(name);
  };
  Parser.prototype.emitOpenTag = function (name) {
    var _a, _b, _c, _d;
    this.openTagStart = this.startIndex;
    this.tagname = name;
    var impliesClose = !this.options.xmlMode && openImpliesClose.get(name);
    if (impliesClose) {
      while (this.stack.length > 0 && impliesClose.has(this.stack[this.stack.length - 1])) {
        var element = this.stack.pop();
        (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 ? void 0 : _b.call(_a, element, true);
      }
    }
    if (!this.isVoidElement(name)) {
      this.stack.push(name);
      if (foreignContextElements.has(name)) {
        this.foreignContext.push(true);
      } else if (htmlIntegrationElements.has(name)) {
        this.foreignContext.push(false);
      }
    }
    (_d = (_c = this.cbs).onopentagname) === null || _d === void 0 ? void 0 : _d.call(_c, name);
    if (this.cbs.onopentag) this.attribs = {};
  };
  Parser.prototype.endOpenTag = function (isImplied) {
    var _a, _b;
    this.startIndex = this.openTagStart;
    if (this.attribs) {
      (_b = (_a = this.cbs).onopentag) === null || _b === void 0 ? void 0 : _b.call(_a, this.tagname, this.attribs, isImplied);
      this.attribs = null;
    }
    if (this.cbs.onclosetag && this.isVoidElement(this.tagname)) {
      this.cbs.onclosetag(this.tagname, true);
    }
    this.tagname = "";
  };
  /** @internal */
  Parser.prototype.onopentagend = function (endIndex) {
    this.endIndex = endIndex;
    this.endOpenTag(false);
    // Set `startIndex` for next node
    this.startIndex = endIndex + 1;
  };
  /** @internal */
  Parser.prototype.onclosetag = function (start, endIndex) {
    var _a, _b, _c, _d, _e, _f;
    this.endIndex = endIndex;
    var name = this.getSlice(start, endIndex);
    if (this.lowerCaseTagNames) {
      name = name.toLowerCase();
    }
    if (foreignContextElements.has(name) || htmlIntegrationElements.has(name)) {
      this.foreignContext.pop();
    }
    if (!this.isVoidElement(name)) {
      var pos = this.stack.lastIndexOf(name);
      if (pos !== -1) {
        if (this.cbs.onclosetag) {
          var count = this.stack.length - pos;
          while (count--) {
            // We know the stack has sufficient elements.
            this.cbs.onclosetag(this.stack.pop(), count !== 0);
          }
        } else this.stack.length = pos;
      } else if (!this.options.xmlMode && name === "p") {
        // Implicit open before close
        this.emitOpenTag("p");
        this.closeCurrentTag(true);
      }
    } else if (!this.options.xmlMode && name === "br") {
      // We can't use `emitOpenTag` for implicit open, as `br` would be implicitly closed.
      (_b = (_a = this.cbs).onopentagname) === null || _b === void 0 ? void 0 : _b.call(_a, "br");
      (_d = (_c = this.cbs).onopentag) === null || _d === void 0 ? void 0 : _d.call(_c, "br", {}, true);
      (_f = (_e = this.cbs).onclosetag) === null || _f === void 0 ? void 0 : _f.call(_e, "br", false);
    }
    // Set `startIndex` for next node
    this.startIndex = endIndex + 1;
  };
  /** @internal */
  Parser.prototype.onselfclosingtag = function (endIndex) {
    this.endIndex = endIndex;
    if (this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1]) {
      this.closeCurrentTag(false);
      // Set `startIndex` for next node
      this.startIndex = endIndex + 1;
    } else {
      // Ignore the fact that the tag is self-closing.
      this.onopentagend(endIndex);
    }
  };
  Parser.prototype.closeCurrentTag = function (isOpenImplied) {
    var _a, _b;
    var name = this.tagname;
    this.endOpenTag(isOpenImplied);
    // Self-closing tags will be on the top of the stack
    if (this.stack[this.stack.length - 1] === name) {
      // If the opening tag isn't implied, the closing tag has to be implied.
      (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 ? void 0 : _b.call(_a, name, !isOpenImplied);
      this.stack.pop();
    }
  };
  /** @internal */
  Parser.prototype.onattribname = function (start, endIndex) {
    this.startIndex = start;
    var name = this.getSlice(start, endIndex);
    this.attribname = this.lowerCaseAttributeNames ? name.toLowerCase() : name;
  };
  /** @internal */
  Parser.prototype.onattribdata = function (start, endIndex) {
    this.attribvalue += this.getSlice(start, endIndex);
  };
  /** @internal */
  Parser.prototype.onattribentity = function (cp) {
    this.attribvalue += (0, decode_js_1.fromCodePoint)(cp);
  };
  /** @internal */
  Parser.prototype.onattribend = function (quote, endIndex) {
    var _a, _b;
    this.endIndex = endIndex;
    (_b = (_a = this.cbs).onattribute) === null || _b === void 0 ? void 0 : _b.call(_a, this.attribname, this.attribvalue, quote === Tokenizer_js_1.QuoteType.Double ? '"' : quote === Tokenizer_js_1.QuoteType.Single ? "'" : quote === Tokenizer_js_1.QuoteType.NoValue ? undefined : null);
    if (this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname)) {
      this.attribs[this.attribname] = this.attribvalue;
    }
    this.attribvalue = "";
  };
  Parser.prototype.getInstructionName = function (value) {
    var index = value.search(reNameEnd);
    var name = index < 0 ? value : value.substr(0, index);
    if (this.lowerCaseTagNames) {
      name = name.toLowerCase();
    }
    return name;
  };
  /** @internal */
  Parser.prototype.ondeclaration = function (start, endIndex) {
    this.endIndex = endIndex;
    var value = this.getSlice(start, endIndex);
    if (this.cbs.onprocessinginstruction) {
      var name = this.getInstructionName(value);
      this.cbs.onprocessinginstruction("!".concat(name), "!".concat(value));
    }
    // Set `startIndex` for next node
    this.startIndex = endIndex + 1;
  };
  /** @internal */
  Parser.prototype.onprocessinginstruction = function (start, endIndex) {
    this.endIndex = endIndex;
    var value = this.getSlice(start, endIndex);
    if (this.cbs.onprocessinginstruction) {
      var name = this.getInstructionName(value);
      this.cbs.onprocessinginstruction("?".concat(name), "?".concat(value));
    }
    // Set `startIndex` for next node
    this.startIndex = endIndex + 1;
  };
  /** @internal */
  Parser.prototype.oncomment = function (start, endIndex, offset) {
    var _a, _b, _c, _d;
    this.endIndex = endIndex;
    (_b = (_a = this.cbs).oncomment) === null || _b === void 0 ? void 0 : _b.call(_a, this.getSlice(start, endIndex - offset));
    (_d = (_c = this.cbs).oncommentend) === null || _d === void 0 ? void 0 : _d.call(_c);
    // Set `startIndex` for next node
    this.startIndex = endIndex + 1;
  };
  /** @internal */
  Parser.prototype.oncdata = function (start, endIndex, offset) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    this.endIndex = endIndex;
    var value = this.getSlice(start, endIndex - offset);
    if (this.options.xmlMode || this.options.recognizeCDATA) {
      (_b = (_a = this.cbs).oncdatastart) === null || _b === void 0 ? void 0 : _b.call(_a);
      (_d = (_c = this.cbs).ontext) === null || _d === void 0 ? void 0 : _d.call(_c, value);
      (_f = (_e = this.cbs).oncdataend) === null || _f === void 0 ? void 0 : _f.call(_e);
    } else {
      (_h = (_g = this.cbs).oncomment) === null || _h === void 0 ? void 0 : _h.call(_g, "[CDATA[".concat(value, "]]"));
      (_k = (_j = this.cbs).oncommentend) === null || _k === void 0 ? void 0 : _k.call(_j);
    }
    // Set `startIndex` for next node
    this.startIndex = endIndex + 1;
  };
  /** @internal */
  Parser.prototype.onend = function () {
    var _a, _b;
    if (this.cbs.onclosetag) {
      // Set the end index for all remaining tags
      this.endIndex = this.startIndex;
      for (var index = this.stack.length; index > 0; this.cbs.onclosetag(this.stack[--index], true));
    }
    (_b = (_a = this.cbs).onend) === null || _b === void 0 ? void 0 : _b.call(_a);
  };
  /**
   * Resets the parser to a blank state, ready to parse a new HTML document
   */
  Parser.prototype.reset = function () {
    var _a, _b, _c, _d;
    (_b = (_a = this.cbs).onreset) === null || _b === void 0 ? void 0 : _b.call(_a);
    this.tokenizer.reset();
    this.tagname = "";
    this.attribname = "";
    this.attribs = null;
    this.stack.length = 0;
    this.startIndex = 0;
    this.endIndex = 0;
    (_d = (_c = this.cbs).onparserinit) === null || _d === void 0 ? void 0 : _d.call(_c, this);
    this.buffers.length = 0;
    this.bufferOffset = 0;
    this.writeIndex = 0;
    this.ended = false;
  };
  /**
   * Resets the parser, then parses a complete document and
   * pushes it to the handler.
   *
   * @param data Document to parse.
   */
  Parser.prototype.parseComplete = function (data) {
    this.reset();
    this.end(data);
  };
  Parser.prototype.getSlice = function (start, end) {
    while (start - this.bufferOffset >= this.buffers[0].length) {
      this.shiftBuffer();
    }
    var slice = this.buffers[0].slice(start - this.bufferOffset, end - this.bufferOffset);
    while (end - this.bufferOffset > this.buffers[0].length) {
      this.shiftBuffer();
      slice += this.buffers[0].slice(0, end - this.bufferOffset);
    }
    return slice;
  };
  Parser.prototype.shiftBuffer = function () {
    this.bufferOffset += this.buffers[0].length;
    this.writeIndex--;
    this.buffers.shift();
  };
  /**
   * Parses a chunk of data and calls the corresponding callbacks.
   *
   * @param chunk Chunk to parse.
   */
  Parser.prototype.write = function (chunk) {
    var _a, _b;
    if (this.ended) {
      (_b = (_a = this.cbs).onerror) === null || _b === void 0 ? void 0 : _b.call(_a, new Error(".write() after done!"));
      return;
    }
    this.buffers.push(chunk);
    if (this.tokenizer.running) {
      this.tokenizer.write(chunk);
      this.writeIndex++;
    }
  };
  /**
   * Parses the end of the buffer and clears the stack, calls onend.
   *
   * @param chunk Optional final chunk to parse.
   */
  Parser.prototype.end = function (chunk) {
    var _a, _b;
    if (this.ended) {
      (_b = (_a = this.cbs).onerror) === null || _b === void 0 ? void 0 : _b.call(_a, new Error(".end() after done!"));
      return;
    }
    if (chunk) this.write(chunk);
    this.ended = true;
    this.tokenizer.end();
  };
  /**
   * Pauses parsing. The parser won't emit events until `resume` is called.
   */
  Parser.prototype.pause = function () {
    this.tokenizer.pause();
  };
  /**
   * Resumes parsing after `pause` was called.
   */
  Parser.prototype.resume = function () {
    this.tokenizer.resume();
    while (this.tokenizer.running && this.writeIndex < this.buffers.length) {
      this.tokenizer.write(this.buffers[this.writeIndex++]);
    }
    if (this.ended) this.tokenizer.end();
  };
  /**
   * Alias of `write`, for backwards compatibility.
   *
   * @param chunk Chunk to parse.
   * @deprecated
   */
  Parser.prototype.parseChunk = function (chunk) {
    this.write(chunk);
  };
  /**
   * Alias of `end`, for backwards compatibility.
   *
   * @param chunk Optional final chunk to parse.
   * @deprecated
   */
  Parser.prototype.done = function (chunk) {
    this.end(chunk);
  };
  return Parser;
}();
exports.Parser = Parser;

/***/ }),

/***/ "./node_modules/htmlparser2/lib/Tokenizer.js":
/*!***************************************************!*\
  !*** ./node_modules/htmlparser2/lib/Tokenizer.js ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.QuoteType = void 0;
var decode_js_1 = __webpack_require__(/*! entities/lib/decode.js */ "./node_modules/entities/lib/decode.js");
var CharCodes;
(function (CharCodes) {
  CharCodes[CharCodes["Tab"] = 9] = "Tab";
  CharCodes[CharCodes["NewLine"] = 10] = "NewLine";
  CharCodes[CharCodes["FormFeed"] = 12] = "FormFeed";
  CharCodes[CharCodes["CarriageReturn"] = 13] = "CarriageReturn";
  CharCodes[CharCodes["Space"] = 32] = "Space";
  CharCodes[CharCodes["ExclamationMark"] = 33] = "ExclamationMark";
  CharCodes[CharCodes["Number"] = 35] = "Number";
  CharCodes[CharCodes["Amp"] = 38] = "Amp";
  CharCodes[CharCodes["SingleQuote"] = 39] = "SingleQuote";
  CharCodes[CharCodes["DoubleQuote"] = 34] = "DoubleQuote";
  CharCodes[CharCodes["Dash"] = 45] = "Dash";
  CharCodes[CharCodes["Slash"] = 47] = "Slash";
  CharCodes[CharCodes["Zero"] = 48] = "Zero";
  CharCodes[CharCodes["Nine"] = 57] = "Nine";
  CharCodes[CharCodes["Semi"] = 59] = "Semi";
  CharCodes[CharCodes["Lt"] = 60] = "Lt";
  CharCodes[CharCodes["Eq"] = 61] = "Eq";
  CharCodes[CharCodes["Gt"] = 62] = "Gt";
  CharCodes[CharCodes["Questionmark"] = 63] = "Questionmark";
  CharCodes[CharCodes["UpperA"] = 65] = "UpperA";
  CharCodes[CharCodes["LowerA"] = 97] = "LowerA";
  CharCodes[CharCodes["UpperF"] = 70] = "UpperF";
  CharCodes[CharCodes["LowerF"] = 102] = "LowerF";
  CharCodes[CharCodes["UpperZ"] = 90] = "UpperZ";
  CharCodes[CharCodes["LowerZ"] = 122] = "LowerZ";
  CharCodes[CharCodes["LowerX"] = 120] = "LowerX";
  CharCodes[CharCodes["OpeningSquareBracket"] = 91] = "OpeningSquareBracket";
})(CharCodes || (CharCodes = {}));
/** All the states the tokenizer can be in. */
var State;
(function (State) {
  State[State["Text"] = 1] = "Text";
  State[State["BeforeTagName"] = 2] = "BeforeTagName";
  State[State["InTagName"] = 3] = "InTagName";
  State[State["InSelfClosingTag"] = 4] = "InSelfClosingTag";
  State[State["BeforeClosingTagName"] = 5] = "BeforeClosingTagName";
  State[State["InClosingTagName"] = 6] = "InClosingTagName";
  State[State["AfterClosingTagName"] = 7] = "AfterClosingTagName";
  // Attributes
  State[State["BeforeAttributeName"] = 8] = "BeforeAttributeName";
  State[State["InAttributeName"] = 9] = "InAttributeName";
  State[State["AfterAttributeName"] = 10] = "AfterAttributeName";
  State[State["BeforeAttributeValue"] = 11] = "BeforeAttributeValue";
  State[State["InAttributeValueDq"] = 12] = "InAttributeValueDq";
  State[State["InAttributeValueSq"] = 13] = "InAttributeValueSq";
  State[State["InAttributeValueNq"] = 14] = "InAttributeValueNq";
  // Declarations
  State[State["BeforeDeclaration"] = 15] = "BeforeDeclaration";
  State[State["InDeclaration"] = 16] = "InDeclaration";
  // Processing instructions
  State[State["InProcessingInstruction"] = 17] = "InProcessingInstruction";
  // Comments & CDATA
  State[State["BeforeComment"] = 18] = "BeforeComment";
  State[State["CDATASequence"] = 19] = "CDATASequence";
  State[State["InSpecialComment"] = 20] = "InSpecialComment";
  State[State["InCommentLike"] = 21] = "InCommentLike";
  // Special tags
  State[State["BeforeSpecialS"] = 22] = "BeforeSpecialS";
  State[State["SpecialStartSequence"] = 23] = "SpecialStartSequence";
  State[State["InSpecialTag"] = 24] = "InSpecialTag";
  State[State["BeforeEntity"] = 25] = "BeforeEntity";
  State[State["BeforeNumericEntity"] = 26] = "BeforeNumericEntity";
  State[State["InNamedEntity"] = 27] = "InNamedEntity";
  State[State["InNumericEntity"] = 28] = "InNumericEntity";
  State[State["InHexEntity"] = 29] = "InHexEntity";
})(State || (State = {}));
function isWhitespace(c) {
  return c === CharCodes.Space || c === CharCodes.NewLine || c === CharCodes.Tab || c === CharCodes.FormFeed || c === CharCodes.CarriageReturn;
}
function isEndOfTagSection(c) {
  return c === CharCodes.Slash || c === CharCodes.Gt || isWhitespace(c);
}
function isNumber(c) {
  return c >= CharCodes.Zero && c <= CharCodes.Nine;
}
function isASCIIAlpha(c) {
  return c >= CharCodes.LowerA && c <= CharCodes.LowerZ || c >= CharCodes.UpperA && c <= CharCodes.UpperZ;
}
function isHexDigit(c) {
  return c >= CharCodes.UpperA && c <= CharCodes.UpperF || c >= CharCodes.LowerA && c <= CharCodes.LowerF;
}
var QuoteType;
(function (QuoteType) {
  QuoteType[QuoteType["NoValue"] = 0] = "NoValue";
  QuoteType[QuoteType["Unquoted"] = 1] = "Unquoted";
  QuoteType[QuoteType["Single"] = 2] = "Single";
  QuoteType[QuoteType["Double"] = 3] = "Double";
})(QuoteType = exports.QuoteType || (exports.QuoteType = {}));
/**
 * Sequences used to match longer strings.
 *
 * We don't have `Script`, `Style`, or `Title` here. Instead, we re-use the *End
 * sequences with an increased offset.
 */
var Sequences = {
  Cdata: new Uint8Array([0x43, 0x44, 0x41, 0x54, 0x41, 0x5b]),
  CdataEnd: new Uint8Array([0x5d, 0x5d, 0x3e]),
  CommentEnd: new Uint8Array([0x2d, 0x2d, 0x3e]),
  ScriptEnd: new Uint8Array([0x3c, 0x2f, 0x73, 0x63, 0x72, 0x69, 0x70, 0x74]),
  StyleEnd: new Uint8Array([0x3c, 0x2f, 0x73, 0x74, 0x79, 0x6c, 0x65]),
  TitleEnd: new Uint8Array([0x3c, 0x2f, 0x74, 0x69, 0x74, 0x6c, 0x65]) // `</title`
};

var Tokenizer = /** @class */function () {
  function Tokenizer(_a, cbs) {
    var _b = _a.xmlMode,
      xmlMode = _b === void 0 ? false : _b,
      _c = _a.decodeEntities,
      decodeEntities = _c === void 0 ? true : _c;
    this.cbs = cbs;
    /** The current state the tokenizer is in. */
    this.state = State.Text;
    /** The read buffer. */
    this.buffer = "";
    /** The beginning of the section that is currently being read. */
    this.sectionStart = 0;
    /** The index within the buffer that we are currently looking at. */
    this.index = 0;
    /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */
    this.baseState = State.Text;
    /** For special parsing behavior inside of script and style tags. */
    this.isSpecial = false;
    /** Indicates whether the tokenizer has been paused. */
    this.running = true;
    /** The offset of the current buffer. */
    this.offset = 0;
    this.currentSequence = undefined;
    this.sequenceIndex = 0;
    this.trieIndex = 0;
    this.trieCurrent = 0;
    /** For named entities, the index of the value. For numeric entities, the code point. */
    this.entityResult = 0;
    this.entityExcess = 0;
    this.xmlMode = xmlMode;
    this.decodeEntities = decodeEntities;
    this.entityTrie = xmlMode ? decode_js_1.xmlDecodeTree : decode_js_1.htmlDecodeTree;
  }
  Tokenizer.prototype.reset = function () {
    this.state = State.Text;
    this.buffer = "";
    this.sectionStart = 0;
    this.index = 0;
    this.baseState = State.Text;
    this.currentSequence = undefined;
    this.running = true;
    this.offset = 0;
  };
  Tokenizer.prototype.write = function (chunk) {
    this.offset += this.buffer.length;
    this.buffer = chunk;
    this.parse();
  };
  Tokenizer.prototype.end = function () {
    if (this.running) this.finish();
  };
  Tokenizer.prototype.pause = function () {
    this.running = false;
  };
  Tokenizer.prototype.resume = function () {
    this.running = true;
    if (this.index < this.buffer.length + this.offset) {
      this.parse();
    }
  };
  /**
   * The current index within all of the written data.
   */
  Tokenizer.prototype.getIndex = function () {
    return this.index;
  };
  /**
   * The start of the current section.
   */
  Tokenizer.prototype.getSectionStart = function () {
    return this.sectionStart;
  };
  Tokenizer.prototype.stateText = function (c) {
    if (c === CharCodes.Lt || !this.decodeEntities && this.fastForwardTo(CharCodes.Lt)) {
      if (this.index > this.sectionStart) {
        this.cbs.ontext(this.sectionStart, this.index);
      }
      this.state = State.BeforeTagName;
      this.sectionStart = this.index;
    } else if (this.decodeEntities && c === CharCodes.Amp) {
      this.state = State.BeforeEntity;
    }
  };
  Tokenizer.prototype.stateSpecialStartSequence = function (c) {
    var isEnd = this.sequenceIndex === this.currentSequence.length;
    var isMatch = isEnd ?
    // If we are at the end of the sequence, make sure the tag name has ended
    isEndOfTagSection(c) :
    // Otherwise, do a case-insensitive comparison
    (c | 0x20) === this.currentSequence[this.sequenceIndex];
    if (!isMatch) {
      this.isSpecial = false;
    } else if (!isEnd) {
      this.sequenceIndex++;
      return;
    }
    this.sequenceIndex = 0;
    this.state = State.InTagName;
    this.stateInTagName(c);
  };
  /** Look for an end tag. For <title> tags, also decode entities. */
  Tokenizer.prototype.stateInSpecialTag = function (c) {
    if (this.sequenceIndex === this.currentSequence.length) {
      if (c === CharCodes.Gt || isWhitespace(c)) {
        var endOfText = this.index - this.currentSequence.length;
        if (this.sectionStart < endOfText) {
          // Spoof the index so that reported locations match up.
          var actualIndex = this.index;
          this.index = endOfText;
          this.cbs.ontext(this.sectionStart, endOfText);
          this.index = actualIndex;
        }
        this.isSpecial = false;
        this.sectionStart = endOfText + 2; // Skip over the `</`
        this.stateInClosingTagName(c);
        return; // We are done; skip the rest of the function.
      }

      this.sequenceIndex = 0;
    }
    if ((c | 0x20) === this.currentSequence[this.sequenceIndex]) {
      this.sequenceIndex += 1;
    } else if (this.sequenceIndex === 0) {
      if (this.currentSequence === Sequences.TitleEnd) {
        // We have to parse entities in <title> tags.
        if (this.decodeEntities && c === CharCodes.Amp) {
          this.state = State.BeforeEntity;
        }
      } else if (this.fastForwardTo(CharCodes.Lt)) {
        // Outside of <title> tags, we can fast-forward.
        this.sequenceIndex = 1;
      }
    } else {
      // If we see a `<`, set the sequence index to 1; useful for eg. `<</script>`.
      this.sequenceIndex = Number(c === CharCodes.Lt);
    }
  };
  Tokenizer.prototype.stateCDATASequence = function (c) {
    if (c === Sequences.Cdata[this.sequenceIndex]) {
      if (++this.sequenceIndex === Sequences.Cdata.length) {
        this.state = State.InCommentLike;
        this.currentSequence = Sequences.CdataEnd;
        this.sequenceIndex = 0;
        this.sectionStart = this.index + 1;
      }
    } else {
      this.sequenceIndex = 0;
      this.state = State.InDeclaration;
      this.stateInDeclaration(c); // Reconsume the character
    }
  };
  /**
   * When we wait for one specific character, we can speed things up
   * by skipping through the buffer until we find it.
   *
   * @returns Whether the character was found.
   */
  Tokenizer.prototype.fastForwardTo = function (c) {
    while (++this.index < this.buffer.length + this.offset) {
      if (this.buffer.charCodeAt(this.index - this.offset) === c) {
        return true;
      }
    }
    /*
     * We increment the index at the end of the `parse` loop,
     * so set it to `buffer.length - 1` here.
     *
     * Refactor `parse` to increment index before calling states.
     */
    this.index = this.buffer.length + this.offset - 1;
    return false;
  };
  /**
   * Comments and CDATA end with `-->` and `]]>`.
   *
   * Their common qualities are:
   * - Their end sequences have a distinct character they start with.
   * - That character is then repeated, so we have to check multiple repeats.
   * - All characters but the start character of the sequence can be skipped.
   */
  Tokenizer.prototype.stateInCommentLike = function (c) {
    if (c === this.currentSequence[this.sequenceIndex]) {
      if (++this.sequenceIndex === this.currentSequence.length) {
        if (this.currentSequence === Sequences.CdataEnd) {
          this.cbs.oncdata(this.sectionStart, this.index, 2);
        } else {
          this.cbs.oncomment(this.sectionStart, this.index, 2);
        }
        this.sequenceIndex = 0;
        this.sectionStart = this.index + 1;
        this.state = State.Text;
      }
    } else if (this.sequenceIndex === 0) {
      // Fast-forward to the first character of the sequence
      if (this.fastForwardTo(this.currentSequence[0])) {
        this.sequenceIndex = 1;
      }
    } else if (c !== this.currentSequence[this.sequenceIndex - 1]) {
      // Allow long sequences, eg. --->, ]]]>
      this.sequenceIndex = 0;
    }
  };
  /**
   * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
   *
   * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
   * We allow anything that wouldn't end the tag.
   */
  Tokenizer.prototype.isTagStartChar = function (c) {
    return this.xmlMode ? !isEndOfTagSection(c) : isASCIIAlpha(c);
  };
  Tokenizer.prototype.startSpecial = function (sequence, offset) {
    this.isSpecial = true;
    this.currentSequence = sequence;
    this.sequenceIndex = offset;
    this.state = State.SpecialStartSequence;
  };
  Tokenizer.prototype.stateBeforeTagName = function (c) {
    if (c === CharCodes.ExclamationMark) {
      this.state = State.BeforeDeclaration;
      this.sectionStart = this.index + 1;
    } else if (c === CharCodes.Questionmark) {
      this.state = State.InProcessingInstruction;
      this.sectionStart = this.index + 1;
    } else if (this.isTagStartChar(c)) {
      var lower = c | 0x20;
      this.sectionStart = this.index;
      if (!this.xmlMode && lower === Sequences.TitleEnd[2]) {
        this.startSpecial(Sequences.TitleEnd, 3);
      } else {
        this.state = !this.xmlMode && lower === Sequences.ScriptEnd[2] ? State.BeforeSpecialS : State.InTagName;
      }
    } else if (c === CharCodes.Slash) {
      this.state = State.BeforeClosingTagName;
    } else {
      this.state = State.Text;
      this.stateText(c);
    }
  };
  Tokenizer.prototype.stateInTagName = function (c) {
    if (isEndOfTagSection(c)) {
      this.cbs.onopentagname(this.sectionStart, this.index);
      this.sectionStart = -1;
      this.state = State.BeforeAttributeName;
      this.stateBeforeAttributeName(c);
    }
  };
  Tokenizer.prototype.stateBeforeClosingTagName = function (c) {
    if (isWhitespace(c)) {
      // Ignore
    } else if (c === CharCodes.Gt) {
      this.state = State.Text;
    } else {
      this.state = this.isTagStartChar(c) ? State.InClosingTagName : State.InSpecialComment;
      this.sectionStart = this.index;
    }
  };
  Tokenizer.prototype.stateInClosingTagName = function (c) {
    if (c === CharCodes.Gt || isWhitespace(c)) {
      this.cbs.onclosetag(this.sectionStart, this.index);
      this.sectionStart = -1;
      this.state = State.AfterClosingTagName;
      this.stateAfterClosingTagName(c);
    }
  };
  Tokenizer.prototype.stateAfterClosingTagName = function (c) {
    // Skip everything until ">"
    if (c === CharCodes.Gt || this.fastForwardTo(CharCodes.Gt)) {
      this.state = State.Text;
      this.baseState = State.Text;
      this.sectionStart = this.index + 1;
    }
  };
  Tokenizer.prototype.stateBeforeAttributeName = function (c) {
    if (c === CharCodes.Gt) {
      this.cbs.onopentagend(this.index);
      if (this.isSpecial) {
        this.state = State.InSpecialTag;
        this.sequenceIndex = 0;
      } else {
        this.state = State.Text;
      }
      this.baseState = this.state;
      this.sectionStart = this.index + 1;
    } else if (c === CharCodes.Slash) {
      this.state = State.InSelfClosingTag;
    } else if (!isWhitespace(c)) {
      this.state = State.InAttributeName;
      this.sectionStart = this.index;
    }
  };
  Tokenizer.prototype.stateInSelfClosingTag = function (c) {
    if (c === CharCodes.Gt) {
      this.cbs.onselfclosingtag(this.index);
      this.state = State.Text;
      this.baseState = State.Text;
      this.sectionStart = this.index + 1;
      this.isSpecial = false; // Reset special state, in case of self-closing special tags
    } else if (!isWhitespace(c)) {
      this.state = State.BeforeAttributeName;
      this.stateBeforeAttributeName(c);
    }
  };
  Tokenizer.prototype.stateInAttributeName = function (c) {
    if (c === CharCodes.Eq || isEndOfTagSection(c)) {
      this.cbs.onattribname(this.sectionStart, this.index);
      this.sectionStart = -1;
      this.state = State.AfterAttributeName;
      this.stateAfterAttributeName(c);
    }
  };
  Tokenizer.prototype.stateAfterAttributeName = function (c) {
    if (c === CharCodes.Eq) {
      this.state = State.BeforeAttributeValue;
    } else if (c === CharCodes.Slash || c === CharCodes.Gt) {
      this.cbs.onattribend(QuoteType.NoValue, this.index);
      this.state = State.BeforeAttributeName;
      this.stateBeforeAttributeName(c);
    } else if (!isWhitespace(c)) {
      this.cbs.onattribend(QuoteType.NoValue, this.index);
      this.state = State.InAttributeName;
      this.sectionStart = this.index;
    }
  };
  Tokenizer.prototype.stateBeforeAttributeValue = function (c) {
    if (c === CharCodes.DoubleQuote) {
      this.state = State.InAttributeValueDq;
      this.sectionStart = this.index + 1;
    } else if (c === CharCodes.SingleQuote) {
      this.state = State.InAttributeValueSq;
      this.sectionStart = this.index + 1;
    } else if (!isWhitespace(c)) {
      this.sectionStart = this.index;
      this.state = State.InAttributeValueNq;
      this.stateInAttributeValueNoQuotes(c); // Reconsume token
    }
  };

  Tokenizer.prototype.handleInAttributeValue = function (c, quote) {
    if (c === quote || !this.decodeEntities && this.fastForwardTo(quote)) {
      this.cbs.onattribdata(this.sectionStart, this.index);
      this.sectionStart = -1;
      this.cbs.onattribend(quote === CharCodes.DoubleQuote ? QuoteType.Double : QuoteType.Single, this.index);
      this.state = State.BeforeAttributeName;
    } else if (this.decodeEntities && c === CharCodes.Amp) {
      this.baseState = this.state;
      this.state = State.BeforeEntity;
    }
  };
  Tokenizer.prototype.stateInAttributeValueDoubleQuotes = function (c) {
    this.handleInAttributeValue(c, CharCodes.DoubleQuote);
  };
  Tokenizer.prototype.stateInAttributeValueSingleQuotes = function (c) {
    this.handleInAttributeValue(c, CharCodes.SingleQuote);
  };
  Tokenizer.prototype.stateInAttributeValueNoQuotes = function (c) {
    if (isWhitespace(c) || c === CharCodes.Gt) {
      this.cbs.onattribdata(this.sectionStart, this.index);
      this.sectionStart = -1;
      this.cbs.onattribend(QuoteType.Unquoted, this.index);
      this.state = State.BeforeAttributeName;
      this.stateBeforeAttributeName(c);
    } else if (this.decodeEntities && c === CharCodes.Amp) {
      this.baseState = this.state;
      this.state = State.BeforeEntity;
    }
  };
  Tokenizer.prototype.stateBeforeDeclaration = function (c) {
    if (c === CharCodes.OpeningSquareBracket) {
      this.state = State.CDATASequence;
      this.sequenceIndex = 0;
    } else {
      this.state = c === CharCodes.Dash ? State.BeforeComment : State.InDeclaration;
    }
  };
  Tokenizer.prototype.stateInDeclaration = function (c) {
    if (c === CharCodes.Gt || this.fastForwardTo(CharCodes.Gt)) {
      this.cbs.ondeclaration(this.sectionStart, this.index);
      this.state = State.Text;
      this.sectionStart = this.index + 1;
    }
  };
  Tokenizer.prototype.stateInProcessingInstruction = function (c) {
    if (c === CharCodes.Gt || this.fastForwardTo(CharCodes.Gt)) {
      this.cbs.onprocessinginstruction(this.sectionStart, this.index);
      this.state = State.Text;
      this.sectionStart = this.index + 1;
    }
  };
  Tokenizer.prototype.stateBeforeComment = function (c) {
    if (c === CharCodes.Dash) {
      this.state = State.InCommentLike;
      this.currentSequence = Sequences.CommentEnd;
      // Allow short comments (eg. <!-->)
      this.sequenceIndex = 2;
      this.sectionStart = this.index + 1;
    } else {
      this.state = State.InDeclaration;
    }
  };
  Tokenizer.prototype.stateInSpecialComment = function (c) {
    if (c === CharCodes.Gt || this.fastForwardTo(CharCodes.Gt)) {
      this.cbs.oncomment(this.sectionStart, this.index, 0);
      this.state = State.Text;
      this.sectionStart = this.index + 1;
    }
  };
  Tokenizer.prototype.stateBeforeSpecialS = function (c) {
    var lower = c | 0x20;
    if (lower === Sequences.ScriptEnd[3]) {
      this.startSpecial(Sequences.ScriptEnd, 4);
    } else if (lower === Sequences.StyleEnd[3]) {
      this.startSpecial(Sequences.StyleEnd, 4);
    } else {
      this.state = State.InTagName;
      this.stateInTagName(c); // Consume the token again
    }
  };

  Tokenizer.prototype.stateBeforeEntity = function (c) {
    // Start excess with 1 to include the '&'
    this.entityExcess = 1;
    this.entityResult = 0;
    if (c === CharCodes.Number) {
      this.state = State.BeforeNumericEntity;
    } else if (c === CharCodes.Amp) {
      // We have two `&` characters in a row. Stay in the current state.
    } else {
      this.trieIndex = 0;
      this.trieCurrent = this.entityTrie[0];
      this.state = State.InNamedEntity;
      this.stateInNamedEntity(c);
    }
  };
  Tokenizer.prototype.stateInNamedEntity = function (c) {
    this.entityExcess += 1;
    this.trieIndex = (0, decode_js_1.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, c);
    if (this.trieIndex < 0) {
      this.emitNamedEntity();
      this.index--;
      return;
    }
    this.trieCurrent = this.entityTrie[this.trieIndex];
    var masked = this.trieCurrent & decode_js_1.BinTrieFlags.VALUE_LENGTH;
    // If the branch is a value, store it and continue
    if (masked) {
      // The mask is the number of bytes of the value, including the current byte.
      var valueLength = (masked >> 14) - 1;
      // If we have a legacy entity while parsing strictly, just skip the number of bytes
      if (!this.allowLegacyEntity() && c !== CharCodes.Semi) {
        this.trieIndex += valueLength;
      } else {
        // Add 1 as we have already incremented the excess
        var entityStart = this.index - this.entityExcess + 1;
        if (entityStart > this.sectionStart) {
          this.emitPartial(this.sectionStart, entityStart);
        }
        // If this is a surrogate pair, consume the next two bytes
        this.entityResult = this.trieIndex;
        this.trieIndex += valueLength;
        this.entityExcess = 0;
        this.sectionStart = this.index + 1;
        if (valueLength === 0) {
          this.emitNamedEntity();
        }
      }
    }
  };
  Tokenizer.prototype.emitNamedEntity = function () {
    this.state = this.baseState;
    if (this.entityResult === 0) {
      return;
    }
    var valueLength = (this.entityTrie[this.entityResult] & decode_js_1.BinTrieFlags.VALUE_LENGTH) >> 14;
    switch (valueLength) {
      case 1:
        {
          this.emitCodePoint(this.entityTrie[this.entityResult] & ~decode_js_1.BinTrieFlags.VALUE_LENGTH);
          break;
        }
      case 2:
        {
          this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
          break;
        }
      case 3:
        {
          this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
          this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
        }
    }
  };
  Tokenizer.prototype.stateBeforeNumericEntity = function (c) {
    if ((c | 0x20) === CharCodes.LowerX) {
      this.entityExcess++;
      this.state = State.InHexEntity;
    } else {
      this.state = State.InNumericEntity;
      this.stateInNumericEntity(c);
    }
  };
  Tokenizer.prototype.emitNumericEntity = function (strict) {
    var entityStart = this.index - this.entityExcess - 1;
    var numberStart = entityStart + 2 + Number(this.state === State.InHexEntity);
    if (numberStart !== this.index) {
      // Emit leading data if any
      if (entityStart > this.sectionStart) {
        this.emitPartial(this.sectionStart, entityStart);
      }
      this.sectionStart = this.index + Number(strict);
      this.emitCodePoint((0, decode_js_1.replaceCodePoint)(this.entityResult));
    }
    this.state = this.baseState;
  };
  Tokenizer.prototype.stateInNumericEntity = function (c) {
    if (c === CharCodes.Semi) {
      this.emitNumericEntity(true);
    } else if (isNumber(c)) {
      this.entityResult = this.entityResult * 10 + (c - CharCodes.Zero);
      this.entityExcess++;
    } else {
      if (this.allowLegacyEntity()) {
        this.emitNumericEntity(false);
      } else {
        this.state = this.baseState;
      }
      this.index--;
    }
  };
  Tokenizer.prototype.stateInHexEntity = function (c) {
    if (c === CharCodes.Semi) {
      this.emitNumericEntity(true);
    } else if (isNumber(c)) {
      this.entityResult = this.entityResult * 16 + (c - CharCodes.Zero);
      this.entityExcess++;
    } else if (isHexDigit(c)) {
      this.entityResult = this.entityResult * 16 + ((c | 0x20) - CharCodes.LowerA + 10);
      this.entityExcess++;
    } else {
      if (this.allowLegacyEntity()) {
        this.emitNumericEntity(false);
      } else {
        this.state = this.baseState;
      }
      this.index--;
    }
  };
  Tokenizer.prototype.allowLegacyEntity = function () {
    return !this.xmlMode && (this.baseState === State.Text || this.baseState === State.InSpecialTag);
  };
  /**
   * Remove data that has already been consumed from the buffer.
   */
  Tokenizer.prototype.cleanup = function () {
    // If we are inside of text or attributes, emit what we already have.
    if (this.running && this.sectionStart !== this.index) {
      if (this.state === State.Text || this.state === State.InSpecialTag && this.sequenceIndex === 0) {
        this.cbs.ontext(this.sectionStart, this.index);
        this.sectionStart = this.index;
      } else if (this.state === State.InAttributeValueDq || this.state === State.InAttributeValueSq || this.state === State.InAttributeValueNq) {
        this.cbs.onattribdata(this.sectionStart, this.index);
        this.sectionStart = this.index;
      }
    }
  };
  Tokenizer.prototype.shouldContinue = function () {
    return this.index < this.buffer.length + this.offset && this.running;
  };
  /**
   * Iterates through the buffer, calling the function corresponding to the current state.
   *
   * States that are more likely to be hit are higher up, as a performance improvement.
   */
  Tokenizer.prototype.parse = function () {
    while (this.shouldContinue()) {
      var c = this.buffer.charCodeAt(this.index - this.offset);
      switch (this.state) {
        case State.Text:
          {
            this.stateText(c);
            break;
          }
        case State.SpecialStartSequence:
          {
            this.stateSpecialStartSequence(c);
            break;
          }
        case State.InSpecialTag:
          {
            this.stateInSpecialTag(c);
            break;
          }
        case State.CDATASequence:
          {
            this.stateCDATASequence(c);
            break;
          }
        case State.InAttributeValueDq:
          {
            this.stateInAttributeValueDoubleQuotes(c);
            break;
          }
        case State.InAttributeName:
          {
            this.stateInAttributeName(c);
            break;
          }
        case State.InCommentLike:
          {
            this.stateInCommentLike(c);
            break;
          }
        case State.InSpecialComment:
          {
            this.stateInSpecialComment(c);
            break;
          }
        case State.BeforeAttributeName:
          {
            this.stateBeforeAttributeName(c);
            break;
          }
        case State.InTagName:
          {
            this.stateInTagName(c);
            break;
          }
        case State.InClosingTagName:
          {
            this.stateInClosingTagName(c);
            break;
          }
        case State.BeforeTagName:
          {
            this.stateBeforeTagName(c);
            break;
          }
        case State.AfterAttributeName:
          {
            this.stateAfterAttributeName(c);
            break;
          }
        case State.InAttributeValueSq:
          {
            this.stateInAttributeValueSingleQuotes(c);
            break;
          }
        case State.BeforeAttributeValue:
          {
            this.stateBeforeAttributeValue(c);
            break;
          }
        case State.BeforeClosingTagName:
          {
            this.stateBeforeClosingTagName(c);
            break;
          }
        case State.AfterClosingTagName:
          {
            this.stateAfterClosingTagName(c);
            break;
          }
        case State.BeforeSpecialS:
          {
            this.stateBeforeSpecialS(c);
            break;
          }
        case State.InAttributeValueNq:
          {
            this.stateInAttributeValueNoQuotes(c);
            break;
          }
        case State.InSelfClosingTag:
          {
            this.stateInSelfClosingTag(c);
            break;
          }
        case State.InDeclaration:
          {
            this.stateInDeclaration(c);
            break;
          }
        case State.BeforeDeclaration:
          {
            this.stateBeforeDeclaration(c);
            break;
          }
        case State.BeforeComment:
          {
            this.stateBeforeComment(c);
            break;
          }
        case State.InProcessingInstruction:
          {
            this.stateInProcessingInstruction(c);
            break;
          }
        case State.InNamedEntity:
          {
            this.stateInNamedEntity(c);
            break;
          }
        case State.BeforeEntity:
          {
            this.stateBeforeEntity(c);
            break;
          }
        case State.InHexEntity:
          {
            this.stateInHexEntity(c);
            break;
          }
        case State.InNumericEntity:
          {
            this.stateInNumericEntity(c);
            break;
          }
        default:
          {
            // `this._state === State.BeforeNumericEntity`
            this.stateBeforeNumericEntity(c);
          }
      }
      this.index++;
    }
    this.cleanup();
  };
  Tokenizer.prototype.finish = function () {
    if (this.state === State.InNamedEntity) {
      this.emitNamedEntity();
    }
    // If there is remaining data, emit it in a reasonable way
    if (this.sectionStart < this.index) {
      this.handleTrailingData();
    }
    this.cbs.onend();
  };
  /** Handle any trailing data. */
  Tokenizer.prototype.handleTrailingData = function () {
    var endIndex = this.buffer.length + this.offset;
    if (this.state === State.InCommentLike) {
      if (this.currentSequence === Sequences.CdataEnd) {
        this.cbs.oncdata(this.sectionStart, endIndex, 0);
      } else {
        this.cbs.oncomment(this.sectionStart, endIndex, 0);
      }
    } else if (this.state === State.InNumericEntity && this.allowLegacyEntity()) {
      this.emitNumericEntity(false);
      // All trailing data will have been consumed
    } else if (this.state === State.InHexEntity && this.allowLegacyEntity()) {
      this.emitNumericEntity(false);
      // All trailing data will have been consumed
    } else if (this.state === State.InTagName || this.state === State.BeforeAttributeName || this.state === State.BeforeAttributeValue || this.state === State.AfterAttributeName || this.state === State.InAttributeName || this.state === State.InAttributeValueSq || this.state === State.InAttributeValueDq || this.state === State.InAttributeValueNq || this.state === State.InClosingTagName) {
      /*
       * If we are currently in an opening or closing tag, us not calling the
       * respective callback signals that the tag should be ignored.
       */
    } else {
      this.cbs.ontext(this.sectionStart, endIndex);
    }
  };
  Tokenizer.prototype.emitPartial = function (start, endIndex) {
    if (this.baseState !== State.Text && this.baseState !== State.InSpecialTag) {
      this.cbs.onattribdata(start, endIndex);
    } else {
      this.cbs.ontext(start, endIndex);
    }
  };
  Tokenizer.prototype.emitCodePoint = function (cp) {
    if (this.baseState !== State.Text && this.baseState !== State.InSpecialTag) {
      this.cbs.onattribentity(cp);
    } else {
      this.cbs.ontextentity(cp);
    }
  };
  return Tokenizer;
}();
exports["default"] = Tokenizer;

/***/ }),

/***/ "./node_modules/htmlparser2/lib/index.js":
/*!***********************************************!*\
  !*** ./node_modules/htmlparser2/lib/index.js ***!
  \***********************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.DomUtils = exports.parseFeed = exports.getFeed = exports.ElementType = exports.Tokenizer = exports.createDomStream = exports.parseDOM = exports.parseDocument = exports.DefaultHandler = exports.DomHandler = exports.Parser = void 0;
var Parser_js_1 = __webpack_require__(/*! ./Parser.js */ "./node_modules/htmlparser2/lib/Parser.js");
var Parser_js_2 = __webpack_require__(/*! ./Parser.js */ "./node_modules/htmlparser2/lib/Parser.js");
Object.defineProperty(exports, "Parser", ({
  enumerable: true,
  get: function () {
    return Parser_js_2.Parser;
  }
}));
var domhandler_1 = __webpack_require__(/*! domhandler */ "./node_modules/domhandler/lib/index.js");
var domhandler_2 = __webpack_require__(/*! domhandler */ "./node_modules/domhandler/lib/index.js");
Object.defineProperty(exports, "DomHandler", ({
  enumerable: true,
  get: function () {
    return domhandler_2.DomHandler;
  }
}));
// Old name for DomHandler
Object.defineProperty(exports, "DefaultHandler", ({
  enumerable: true,
  get: function () {
    return domhandler_2.DomHandler;
  }
}));
// Helper methods
/**
 * Parses the data, returns the resulting document.
 *
 * @param data The data that should be parsed.
 * @param options Optional options for the parser and DOM builder.
 */
function parseDocument(data, options) {
  var handler = new domhandler_1.DomHandler(undefined, options);
  new Parser_js_1.Parser(handler, options).end(data);
  return handler.root;
}
exports.parseDocument = parseDocument;
/**
 * Parses data, returns an array of the root nodes.
 *
 * Note that the root nodes still have a `Document` node as their parent.
 * Use `parseDocument` to get the `Document` node instead.
 *
 * @param data The data that should be parsed.
 * @param options Optional options for the parser and DOM builder.
 * @deprecated Use `parseDocument` instead.
 */
function parseDOM(data, options) {
  return parseDocument(data, options).children;
}
exports.parseDOM = parseDOM;
/**
 * Creates a parser instance, with an attached DOM handler.
 *
 * @param callback A callback that will be called once parsing has been completed.
 * @param options Optional options for the parser and DOM builder.
 * @param elementCallback An optional callback that will be called every time a tag has been completed inside of the DOM.
 */
function createDomStream(callback, options, elementCallback) {
  var handler = new domhandler_1.DomHandler(callback, options, elementCallback);
  return new Parser_js_1.Parser(handler, options);
}
exports.createDomStream = createDomStream;
var Tokenizer_js_1 = __webpack_require__(/*! ./Tokenizer.js */ "./node_modules/htmlparser2/lib/Tokenizer.js");
Object.defineProperty(exports, "Tokenizer", ({
  enumerable: true,
  get: function () {
    return __importDefault(Tokenizer_js_1).default;
  }
}));
/*
 * All of the following exports exist for backwards-compatibility.
 * They should probably be removed eventually.
 */
exports.ElementType = __importStar(__webpack_require__(/*! domelementtype */ "./node_modules/domelementtype/lib/index.js"));
var domutils_1 = __webpack_require__(/*! domutils */ "./node_modules/domutils/lib/index.js");
var domutils_2 = __webpack_require__(/*! domutils */ "./node_modules/domutils/lib/index.js");
Object.defineProperty(exports, "getFeed", ({
  enumerable: true,
  get: function () {
    return domutils_2.getFeed;
  }
}));
var parseFeedDefaultOptions = {
  xmlMode: true
};
/**
 * Parse a feed.
 *
 * @param feed The feed that should be parsed, as a string.
 * @param options Optionally, options for parsing. When using this, you should set `xmlMode` to `true`.
 */
function parseFeed(feed, options) {
  if (options === void 0) {
    options = parseFeedDefaultOptions;
  }
  return (0, domutils_1.getFeed)(parseDOM(feed, options));
}
exports.parseFeed = parseFeed;
exports.DomUtils = __importStar(__webpack_require__(/*! domutils */ "./node_modules/domutils/lib/index.js"));

/***/ }),

/***/ "./node_modules/parse-srcset/src/parse-srcset.js":
/*!*******************************************************!*\
  !*** ./node_modules/parse-srcset/src/parse-srcset.js ***!
  \*******************************************************/
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Srcset Parser
 *
 * By Alex Bell |  MIT License
 *
 * JS Parser for the string value that appears in markup <img srcset="here">
 *
 * @returns Array [{url: _, d: _, w: _, h:_}, ...]
 *
 * Based super duper closely on the reference algorithm at:
 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-srcset-attribute
 *
 * Most comments are copied in directly from the spec
 * (except for comments in parens).
 */

(function (root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})(this, function () {
  // 1. Let input be the value passed to this algorithm.
  return function (input) {
    // UTILITY FUNCTIONS

    // Manual is faster than RegEx
    // http://bjorn.tipling.com/state-and-regular-expressions-in-javascript
    // http://jsperf.com/whitespace-character/5
    function isSpace(c) {
      return c === "\u0020" ||
      // space
      c === "\u0009" ||
      // horizontal tab
      c === "\u000A" ||
      // new line
      c === "\u000C" ||
      // form feed
      c === "\u000D"; // carriage return
    }

    function collectCharacters(regEx) {
      var chars,
        match = regEx.exec(input.substring(pos));
      if (match) {
        chars = match[0];
        pos += chars.length;
        return chars;
      }
    }
    var inputLength = input.length,
      // (Don't use \s, to avoid matching non-breaking space)
      regexLeadingSpaces = /^[ \t\n\r\u000c]+/,
      regexLeadingCommasOrSpaces = /^[, \t\n\r\u000c]+/,
      regexLeadingNotSpaces = /^[^ \t\n\r\u000c]+/,
      regexTrailingCommas = /[,]+$/,
      regexNonNegativeInteger = /^\d+$/,
      // ( Positive or negative or unsigned integers or decimals, without or without exponents.
      // Must include at least one digit.
      // According to spec tests any decimal point must be followed by a digit.
      // No leading plus sign is allowed.)
      // https://html.spec.whatwg.org/multipage/infrastructure.html#valid-floating-point-number
      regexFloatingPoint = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/,
      url,
      descriptors,
      currentDescriptor,
      state,
      c,
      // 2. Let position be a pointer into input, initially pointing at the start
      //    of the string.
      pos = 0,
      // 3. Let candidates be an initially empty source set.
      candidates = [];

    // 4. Splitting loop: Collect a sequence of characters that are space
    //    characters or U+002C COMMA characters. If any U+002C COMMA characters
    //    were collected, that is a parse error.
    while (true) {
      collectCharacters(regexLeadingCommasOrSpaces);

      // 5. If position is past the end of input, return candidates and abort these steps.
      if (pos >= inputLength) {
        return candidates; // (we're done, this is the sole return path)
      }

      // 6. Collect a sequence of characters that are not space characters,
      //    and let that be url.
      url = collectCharacters(regexLeadingNotSpaces);

      // 7. Let descriptors be a new empty list.
      descriptors = [];

      // 8. If url ends with a U+002C COMMA character (,), follow these substeps:
      //		(1). Remove all trailing U+002C COMMA characters from url. If this removed
      //         more than one character, that is a parse error.
      if (url.slice(-1) === ",") {
        url = url.replace(regexTrailingCommas, "");
        // (Jump ahead to step 9 to skip tokenization and just push the candidate).
        parseDescriptors();

        //	Otherwise, follow these substeps:
      } else {
        tokenize();
      } // (close else of step 8)

      // 16. Return to the step labeled splitting loop.
    } // (Close of big while loop.)

    /**
     * Tokenizes descriptor properties prior to parsing
     * Returns undefined.
     */
    function tokenize() {
      // 8.1. Descriptor tokeniser: Skip whitespace
      collectCharacters(regexLeadingSpaces);

      // 8.2. Let current descriptor be the empty string.
      currentDescriptor = "";

      // 8.3. Let state be in descriptor.
      state = "in descriptor";
      while (true) {
        // 8.4. Let c be the character at position.
        c = input.charAt(pos);

        //  Do the following depending on the value of state.
        //  For the purpose of this step, "EOF" is a special character representing
        //  that position is past the end of input.

        // In descriptor
        if (state === "in descriptor") {
          // Do the following, depending on the value of c:

          // Space character
          // If current descriptor is not empty, append current descriptor to
          // descriptors and let current descriptor be the empty string.
          // Set state to after descriptor.
          if (isSpace(c)) {
            if (currentDescriptor) {
              descriptors.push(currentDescriptor);
              currentDescriptor = "";
              state = "after descriptor";
            }

            // U+002C COMMA (,)
            // Advance position to the next character in input. If current descriptor
            // is not empty, append current descriptor to descriptors. Jump to the step
            // labeled descriptor parser.
          } else if (c === ",") {
            pos += 1;
            if (currentDescriptor) {
              descriptors.push(currentDescriptor);
            }
            parseDescriptors();
            return;

            // U+0028 LEFT PARENTHESIS (()
            // Append c to current descriptor. Set state to in parens.
          } else if (c === "\u0028") {
            currentDescriptor = currentDescriptor + c;
            state = "in parens";

            // EOF
            // If current descriptor is not empty, append current descriptor to
            // descriptors. Jump to the step labeled descriptor parser.
          } else if (c === "") {
            if (currentDescriptor) {
              descriptors.push(currentDescriptor);
            }
            parseDescriptors();
            return;

            // Anything else
            // Append c to current descriptor.
          } else {
            currentDescriptor = currentDescriptor + c;
          }
          // (end "in descriptor"

          // In parens
        } else if (state === "in parens") {
          // U+0029 RIGHT PARENTHESIS ())
          // Append c to current descriptor. Set state to in descriptor.
          if (c === ")") {
            currentDescriptor = currentDescriptor + c;
            state = "in descriptor";

            // EOF
            // Append current descriptor to descriptors. Jump to the step labeled
            // descriptor parser.
          } else if (c === "") {
            descriptors.push(currentDescriptor);
            parseDescriptors();
            return;

            // Anything else
            // Append c to current descriptor.
          } else {
            currentDescriptor = currentDescriptor + c;
          }

          // After descriptor
        } else if (state === "after descriptor") {
          // Do the following, depending on the value of c:
          // Space character: Stay in this state.
          if (isSpace(c)) {

            // EOF: Jump to the step labeled descriptor parser.
          } else if (c === "") {
            parseDescriptors();
            return;

            // Anything else
            // Set state to in descriptor. Set position to the previous character in input.
          } else {
            state = "in descriptor";
            pos -= 1;
          }
        }

        // Advance position to the next character in input.
        pos += 1;

        // Repeat this step.
      } // (close while true loop)
    }

    /**
     * Adds descriptor properties to a candidate, pushes to the candidates array
     * @return undefined
     */
    // Declared outside of the while loop so that it's only created once.
    function parseDescriptors() {
      // 9. Descriptor parser: Let error be no.
      var pError = false,
        // 10. Let width be absent.
        // 11. Let density be absent.
        // 12. Let future-compat-h be absent. (We're implementing it now as h)
        w,
        d,
        h,
        i,
        candidate = {},
        desc,
        lastChar,
        value,
        intVal,
        floatVal;

      // 13. For each descriptor in descriptors, run the appropriate set of steps
      // from the following list:
      for (i = 0; i < descriptors.length; i++) {
        desc = descriptors[i];
        lastChar = desc[desc.length - 1];
        value = desc.substring(0, desc.length - 1);
        intVal = parseInt(value, 10);
        floatVal = parseFloat(value);

        // If the descriptor consists of a valid non-negative integer followed by
        // a U+0077 LATIN SMALL LETTER W character
        if (regexNonNegativeInteger.test(value) && lastChar === "w") {
          // If width and density are not both absent, then let error be yes.
          if (w || d) {
            pError = true;
          }

          // Apply the rules for parsing non-negative integers to the descriptor.
          // If the result is zero, let error be yes.
          // Otherwise, let width be the result.
          if (intVal === 0) {
            pError = true;
          } else {
            w = intVal;
          }

          // If the descriptor consists of a valid floating-point number followed by
          // a U+0078 LATIN SMALL LETTER X character
        } else if (regexFloatingPoint.test(value) && lastChar === "x") {
          // If width, density and future-compat-h are not all absent, then let error
          // be yes.
          if (w || d || h) {
            pError = true;
          }

          // Apply the rules for parsing floating-point number values to the descriptor.
          // If the result is less than zero, let error be yes. Otherwise, let density
          // be the result.
          if (floatVal < 0) {
            pError = true;
          } else {
            d = floatVal;
          }

          // If the descriptor consists of a valid non-negative integer followed by
          // a U+0068 LATIN SMALL LETTER H character
        } else if (regexNonNegativeInteger.test(value) && lastChar === "h") {
          // If height and density are not both absent, then let error be yes.
          if (h || d) {
            pError = true;
          }

          // Apply the rules for parsing non-negative integers to the descriptor.
          // If the result is zero, let error be yes. Otherwise, let future-compat-h
          // be the result.
          if (intVal === 0) {
            pError = true;
          } else {
            h = intVal;
          }

          // Anything else, Let error be yes.
        } else {
          pError = true;
        }
      } // (close step 13 for loop)

      // 15. If error is still no, then append a new image source to candidates whose
      // URL is url, associated with a width width if not absent and a pixel
      // density density if not absent. Otherwise, there is a parse error.
      if (!pError) {
        candidate.url = url;
        if (w) {
          candidate.w = w;
        }
        if (d) {
          candidate.d = d;
        }
        if (h) {
          candidate.h = h;
        }
        candidates.push(candidate);
      } else if (console && console.log) {
        console.log("Invalid srcset descriptor found in '" + input + "' at '" + desc + "'.");
      }
    } // (close parseDescriptors fn)
  };
});

/***/ }),

/***/ "./node_modules/picocolors/picocolors.browser.js":
/*!*******************************************************!*\
  !*** ./node_modules/picocolors/picocolors.browser.js ***!
  \*******************************************************/
/***/ ((module) => {

var x = String;
var create = function () {
  return {
    isColorSupported: false,
    reset: x,
    bold: x,
    dim: x,
    italic: x,
    underline: x,
    inverse: x,
    hidden: x,
    strikethrough: x,
    black: x,
    red: x,
    green: x,
    yellow: x,
    blue: x,
    magenta: x,
    cyan: x,
    white: x,
    gray: x,
    bgBlack: x,
    bgRed: x,
    bgGreen: x,
    bgYellow: x,
    bgBlue: x,
    bgMagenta: x,
    bgCyan: x,
    bgWhite: x
  };
};
module.exports = create();
module.exports.createColors = create;

/***/ }),

/***/ "./node_modules/postcss/lib/at-rule.js":
/*!*********************************************!*\
  !*** ./node_modules/postcss/lib/at-rule.js ***!
  \*********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


let Container = __webpack_require__(/*! ./container */ "./node_modules/postcss/lib/container.js");
class AtRule extends Container {
  constructor(defaults) {
    super(defaults);
    this.type = 'atrule';
  }
  append(...children) {
    if (!this.proxyOf.nodes) this.nodes = [];
    return super.append(...children);
  }
  prepend(...children) {
    if (!this.proxyOf.nodes) this.nodes = [];
    return super.prepend(...children);
  }
}
module.exports = AtRule;
AtRule.default = AtRule;
Container.registerAtRule(AtRule);

/***/ }),

/***/ "./node_modules/postcss/lib/comment.js":
/*!*********************************************!*\
  !*** ./node_modules/postcss/lib/comment.js ***!
  \*********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


let Node = __webpack_require__(/*! ./node */ "./node_modules/postcss/lib/node.js");
class Comment extends Node {
  constructor(defaults) {
    super(defaults);
    this.type = 'comment';
  }
}
module.exports = Comment;
Comment.default = Comment;

/***/ }),

/***/ "./node_modules/postcss/lib/container.js":
/*!***********************************************!*\
  !*** ./node_modules/postcss/lib/container.js ***!
  \***********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


let {
  isClean,
  my
} = __webpack_require__(/*! ./symbols */ "./node_modules/postcss/lib/symbols.js");
let Declaration = __webpack_require__(/*! ./declaration */ "./node_modules/postcss/lib/declaration.js");
let Comment = __webpack_require__(/*! ./comment */ "./node_modules/postcss/lib/comment.js");
let Node = __webpack_require__(/*! ./node */ "./node_modules/postcss/lib/node.js");
let parse, Rule, AtRule, Root;
function cleanSource(nodes) {
  return nodes.map(i => {
    if (i.nodes) i.nodes = cleanSource(i.nodes);
    delete i.source;
    return i;
  });
}
function markDirtyUp(node) {
  node[isClean] = false;
  if (node.proxyOf.nodes) {
    for (let i of node.proxyOf.nodes) {
      markDirtyUp(i);
    }
  }
}
class Container extends Node {
  append(...children) {
    for (let child of children) {
      let nodes = this.normalize(child, this.last);
      for (let node of nodes) this.proxyOf.nodes.push(node);
    }
    this.markDirty();
    return this;
  }
  cleanRaws(keepBetween) {
    super.cleanRaws(keepBetween);
    if (this.nodes) {
      for (let node of this.nodes) node.cleanRaws(keepBetween);
    }
  }
  each(callback) {
    if (!this.proxyOf.nodes) return undefined;
    let iterator = this.getIterator();
    let index, result;
    while (this.indexes[iterator] < this.proxyOf.nodes.length) {
      index = this.indexes[iterator];
      result = callback(this.proxyOf.nodes[index], index);
      if (result === false) break;
      this.indexes[iterator] += 1;
    }
    delete this.indexes[iterator];
    return result;
  }
  every(condition) {
    return this.nodes.every(condition);
  }
  getIterator() {
    if (!this.lastEach) this.lastEach = 0;
    if (!this.indexes) this.indexes = {};
    this.lastEach += 1;
    let iterator = this.lastEach;
    this.indexes[iterator] = 0;
    return iterator;
  }
  getProxyProcessor() {
    return {
      get(node, prop) {
        if (prop === 'proxyOf') {
          return node;
        } else if (!node[prop]) {
          return node[prop];
        } else if (prop === 'each' || typeof prop === 'string' && prop.startsWith('walk')) {
          return (...args) => {
            return node[prop](...args.map(i => {
              if (typeof i === 'function') {
                return (child, index) => i(child.toProxy(), index);
              } else {
                return i;
              }
            }));
          };
        } else if (prop === 'every' || prop === 'some') {
          return cb => {
            return node[prop]((child, ...other) => cb(child.toProxy(), ...other));
          };
        } else if (prop === 'root') {
          return () => node.root().toProxy();
        } else if (prop === 'nodes') {
          return node.nodes.map(i => i.toProxy());
        } else if (prop === 'first' || prop === 'last') {
          return node[prop].toProxy();
        } else {
          return node[prop];
        }
      },
      set(node, prop, value) {
        if (node[prop] === value) return true;
        node[prop] = value;
        if (prop === 'name' || prop === 'params' || prop === 'selector') {
          node.markDirty();
        }
        return true;
      }
    };
  }
  index(child) {
    if (typeof child === 'number') return child;
    if (child.proxyOf) child = child.proxyOf;
    return this.proxyOf.nodes.indexOf(child);
  }
  insertAfter(exist, add) {
    let existIndex = this.index(exist);
    let nodes = this.normalize(add, this.proxyOf.nodes[existIndex]).reverse();
    existIndex = this.index(exist);
    for (let node of nodes) this.proxyOf.nodes.splice(existIndex + 1, 0, node);
    let index;
    for (let id in this.indexes) {
      index = this.indexes[id];
      if (existIndex < index) {
        this.indexes[id] = index + nodes.length;
      }
    }
    this.markDirty();
    return this;
  }
  insertBefore(exist, add) {
    let existIndex = this.index(exist);
    let type = existIndex === 0 ? 'prepend' : false;
    let nodes = this.normalize(add, this.proxyOf.nodes[existIndex], type).reverse();
    existIndex = this.index(exist);
    for (let node of nodes) this.proxyOf.nodes.splice(existIndex, 0, node);
    let index;
    for (let id in this.indexes) {
      index = this.indexes[id];
      if (existIndex <= index) {
        this.indexes[id] = index + nodes.length;
      }
    }
    this.markDirty();
    return this;
  }
  normalize(nodes, sample) {
    if (typeof nodes === 'string') {
      nodes = cleanSource(parse(nodes).nodes);
    } else if (Array.isArray(nodes)) {
      nodes = nodes.slice(0);
      for (let i of nodes) {
        if (i.parent) i.parent.removeChild(i, 'ignore');
      }
    } else if (nodes.type === 'root' && this.type !== 'document') {
      nodes = nodes.nodes.slice(0);
      for (let i of nodes) {
        if (i.parent) i.parent.removeChild(i, 'ignore');
      }
    } else if (nodes.type) {
      nodes = [nodes];
    } else if (nodes.prop) {
      if (typeof nodes.value === 'undefined') {
        throw new Error('Value field is missed in node creation');
      } else if (typeof nodes.value !== 'string') {
        nodes.value = String(nodes.value);
      }
      nodes = [new Declaration(nodes)];
    } else if (nodes.selector) {
      nodes = [new Rule(nodes)];
    } else if (nodes.name) {
      nodes = [new AtRule(nodes)];
    } else if (nodes.text) {
      nodes = [new Comment(nodes)];
    } else {
      throw new Error('Unknown node type in node creation');
    }
    let processed = nodes.map(i => {
      /* c8 ignore next */
      if (!i[my]) Container.rebuild(i);
      i = i.proxyOf;
      if (i.parent) i.parent.removeChild(i);
      if (i[isClean]) markDirtyUp(i);
      if (typeof i.raws.before === 'undefined') {
        if (sample && typeof sample.raws.before !== 'undefined') {
          i.raws.before = sample.raws.before.replace(/\S/g, '');
        }
      }
      i.parent = this.proxyOf;
      return i;
    });
    return processed;
  }
  prepend(...children) {
    children = children.reverse();
    for (let child of children) {
      let nodes = this.normalize(child, this.first, 'prepend').reverse();
      for (let node of nodes) this.proxyOf.nodes.unshift(node);
      for (let id in this.indexes) {
        this.indexes[id] = this.indexes[id] + nodes.length;
      }
    }
    this.markDirty();
    return this;
  }
  push(child) {
    child.parent = this;
    this.proxyOf.nodes.push(child);
    return this;
  }
  removeAll() {
    for (let node of this.proxyOf.nodes) node.parent = undefined;
    this.proxyOf.nodes = [];
    this.markDirty();
    return this;
  }
  removeChild(child) {
    child = this.index(child);
    this.proxyOf.nodes[child].parent = undefined;
    this.proxyOf.nodes.splice(child, 1);
    let index;
    for (let id in this.indexes) {
      index = this.indexes[id];
      if (index >= child) {
        this.indexes[id] = index - 1;
      }
    }
    this.markDirty();
    return this;
  }
  replaceValues(pattern, opts, callback) {
    if (!callback) {
      callback = opts;
      opts = {};
    }
    this.walkDecls(decl => {
      if (opts.props && !opts.props.includes(decl.prop)) return;
      if (opts.fast && !decl.value.includes(opts.fast)) return;
      decl.value = decl.value.replace(pattern, callback);
    });
    this.markDirty();
    return this;
  }
  some(condition) {
    return this.nodes.some(condition);
  }
  walk(callback) {
    return this.each((child, i) => {
      let result;
      try {
        result = callback(child, i);
      } catch (e) {
        throw child.addToError(e);
      }
      if (result !== false && child.walk) {
        result = child.walk(callback);
      }
      return result;
    });
  }
  walkAtRules(name, callback) {
    if (!callback) {
      callback = name;
      return this.walk((child, i) => {
        if (child.type === 'atrule') {
          return callback(child, i);
        }
      });
    }
    if (name instanceof RegExp) {
      return this.walk((child, i) => {
        if (child.type === 'atrule' && name.test(child.name)) {
          return callback(child, i);
        }
      });
    }
    return this.walk((child, i) => {
      if (child.type === 'atrule' && child.name === name) {
        return callback(child, i);
      }
    });
  }
  walkComments(callback) {
    return this.walk((child, i) => {
      if (child.type === 'comment') {
        return callback(child, i);
      }
    });
  }
  walkDecls(prop, callback) {
    if (!callback) {
      callback = prop;
      return this.walk((child, i) => {
        if (child.type === 'decl') {
          return callback(child, i);
        }
      });
    }
    if (prop instanceof RegExp) {
      return this.walk((child, i) => {
        if (child.type === 'decl' && prop.test(child.prop)) {
          return callback(child, i);
        }
      });
    }
    return this.walk((child, i) => {
      if (child.type === 'decl' && child.prop === prop) {
        return callback(child, i);
      }
    });
  }
  walkRules(selector, callback) {
    if (!callback) {
      callback = selector;
      return this.walk((child, i) => {
        if (child.type === 'rule') {
          return callback(child, i);
        }
      });
    }
    if (selector instanceof RegExp) {
      return this.walk((child, i) => {
        if (child.type === 'rule' && selector.test(child.selector)) {
          return callback(child, i);
        }
      });
    }
    return this.walk((child, i) => {
      if (child.type === 'rule' && child.selector === selector) {
        return callback(child, i);
      }
    });
  }
  get first() {
    if (!this.proxyOf.nodes) return undefined;
    return this.proxyOf.nodes[0];
  }
  get last() {
    if (!this.proxyOf.nodes) return undefined;
    return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
  }
}
Container.registerParse = dependant => {
  parse = dependant;
};
Container.registerRule = dependant => {
  Rule = dependant;
};
Container.registerAtRule = dependant => {
  AtRule = dependant;
};
Container.registerRoot = dependant => {
  Root = dependant;
};
module.exports = Container;
Container.default = Container;

/* c8 ignore start */
Container.rebuild = node => {
  if (node.type === 'atrule') {
    Object.setPrototypeOf(node, AtRule.prototype);
  } else if (node.type === 'rule') {
    Object.setPrototypeOf(node, Rule.prototype);
  } else if (node.type === 'decl') {
    Object.setPrototypeOf(node, Declaration.prototype);
  } else if (node.type === 'comment') {
    Object.setPrototypeOf(node, Comment.prototype);
  } else if (node.type === 'root') {
    Object.setPrototypeOf(node, Root.prototype);
  }
  node[my] = true;
  if (node.nodes) {
    node.nodes.forEach(child => {
      Container.rebuild(child);
    });
  }
};
/* c8 ignore stop */

/***/ }),

/***/ "./node_modules/postcss/lib/css-syntax-error.js":
/*!******************************************************!*\
  !*** ./node_modules/postcss/lib/css-syntax-error.js ***!
  \******************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


let pico = __webpack_require__(/*! picocolors */ "./node_modules/picocolors/picocolors.browser.js");
let terminalHighlight = __webpack_require__(/*! ./terminal-highlight */ "?5580");
class CssSyntaxError extends Error {
  constructor(message, line, column, source, file, plugin) {
    super(message);
    this.name = 'CssSyntaxError';
    this.reason = message;
    if (file) {
      this.file = file;
    }
    if (source) {
      this.source = source;
    }
    if (plugin) {
      this.plugin = plugin;
    }
    if (typeof line !== 'undefined' && typeof column !== 'undefined') {
      if (typeof line === 'number') {
        this.line = line;
        this.column = column;
      } else {
        this.line = line.line;
        this.column = line.column;
        this.endLine = column.line;
        this.endColumn = column.column;
      }
    }
    this.setMessage();
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, CssSyntaxError);
    }
  }
  setMessage() {
    this.message = this.plugin ? this.plugin + ': ' : '';
    this.message += this.file ? this.file : '<css input>';
    if (typeof this.line !== 'undefined') {
      this.message += ':' + this.line + ':' + this.column;
    }
    this.message += ': ' + this.reason;
  }
  showSourceCode(color) {
    if (!this.source) return '';
    let css = this.source;
    if (color == null) color = pico.isColorSupported;
    if (terminalHighlight) {
      if (color) css = terminalHighlight(css);
    }
    let lines = css.split(/\r?\n/);
    let start = Math.max(this.line - 3, 0);
    let end = Math.min(this.line + 2, lines.length);
    let maxWidth = String(end).length;
    let mark, aside;
    if (color) {
      let {
        bold,
        gray,
        red
      } = pico.createColors(true);
      mark = text => bold(red(text));
      aside = text => gray(text);
    } else {
      mark = aside = str => str;
    }
    return lines.slice(start, end).map((line, index) => {
      let number = start + 1 + index;
      let gutter = ' ' + (' ' + number).slice(-maxWidth) + ' | ';
      if (number === this.line) {
        let spacing = aside(gutter.replace(/\d/g, ' ')) + line.slice(0, this.column - 1).replace(/[^\t]/g, ' ');
        return mark('>') + aside(gutter) + line + '\n ' + spacing + mark('^');
      }
      return ' ' + aside(gutter) + line;
    }).join('\n');
  }
  toString() {
    let code = this.showSourceCode();
    if (code) {
      code = '\n\n' + code + '\n';
    }
    return this.name + ': ' + this.message + code;
  }
}
module.exports = CssSyntaxError;
CssSyntaxError.default = CssSyntaxError;

/***/ }),

/***/ "./node_modules/postcss/lib/declaration.js":
/*!*************************************************!*\
  !*** ./node_modules/postcss/lib/declaration.js ***!
  \*************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


let Node = __webpack_require__(/*! ./node */ "./node_modules/postcss/lib/node.js");
class Declaration extends Node {
  constructor(defaults) {
    if (defaults && typeof defaults.value !== 'undefined' && typeof defaults.value !== 'string') {
      defaults = {
        ...defaults,
        value: String(defaults.value)
      };
    }
    super(defaults);
    this.type = 'decl';
  }
  get variable() {
    return this.prop.startsWith('--') || this.prop[0] === '$';
  }
}
module.exports = Declaration;
Declaration.default = Declaration;

/***/ }),

/***/ "./node_modules/postcss/lib/document.js":
/*!**********************************************!*\
  !*** ./node_modules/postcss/lib/document.js ***!
  \**********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


let Container = __webpack_require__(/*! ./container */ "./node_modules/postcss/lib/container.js");
let LazyResult, Processor;
class Document extends Container {
  constructor(defaults) {
    // type needs to be passed to super, otherwise child roots won't be normalized correctly
    super({
      type: 'document',
      ...defaults
    });
    if (!this.nodes) {
      this.nodes = [];
    }
  }
  toResult(opts = {}) {
    let lazy = new LazyResult(new Processor(), this, opts);
    return lazy.stringify();
  }
}
Document.registerLazyResult = dependant => {
  LazyResult = dependant;
};
Document.registerProcessor = dependant => {
  Processor = dependant;
};
module.exports = Document;
Document.default = Document;

/***/ }),

/***/ "./node_modules/postcss/lib/fromJSON.js":
/*!**********************************************!*\
  !*** ./node_modules/postcss/lib/fromJSON.js ***!
  \**********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


let Declaration = __webpack_require__(/*! ./declaration */ "./node_modules/postcss/lib/declaration.js");
let PreviousMap = __webpack_require__(/*! ./previous-map */ "./node_modules/postcss/lib/previous-map.js");
let Comment = __webpack_require__(/*! ./comment */ "./node_modules/postcss/lib/comment.js");
let AtRule = __webpack_require__(/*! ./at-rule */ "./node_modules/postcss/lib/at-rule.js");
let Input = __webpack_require__(/*! ./input */ "./node_modules/postcss/lib/input.js");
let Root = __webpack_require__(/*! ./root */ "./node_modules/postcss/lib/root.js");
let Rule = __webpack_require__(/*! ./rule */ "./node_modules/postcss/lib/rule.js");
function fromJSON(json, inputs) {
  if (Array.isArray(json)) return json.map(n => fromJSON(n));
  let {
    inputs: ownInputs,
    ...defaults
  } = json;
  if (ownInputs) {
    inputs = [];
    for (let input of ownInputs) {
      let inputHydrated = {
        ...input,
        __proto__: Input.prototype
      };
      if (inputHydrated.map) {
        inputHydrated.map = {
          ...inputHydrated.map,
          __proto__: PreviousMap.prototype
        };
      }
      inputs.push(inputHydrated);
    }
  }
  if (defaults.nodes) {
    defaults.nodes = json.nodes.map(n => fromJSON(n, inputs));
  }
  if (defaults.source) {
    let {
      inputId,
      ...source
    } = defaults.source;
    defaults.source = source;
    if (inputId != null) {
      defaults.source.input = inputs[inputId];
    }
  }
  if (defaults.type === 'root') {
    return new Root(defaults);
  } else if (defaults.type === 'decl') {
    return new Declaration(defaults);
  } else if (defaults.type === 'rule') {
    return new Rule(defaults);
  } else if (defaults.type === 'comment') {
    return new Comment(defaults);
  } else if (defaults.type === 'atrule') {
    return new AtRule(defaults);
  } else {
    throw new Error('Unknown node type: ' + json.type);
  }
}
module.exports = fromJSON;
fromJSON.default = fromJSON;

/***/ }),

/***/ "./node_modules/postcss/lib/input.js":
/*!*******************************************!*\
  !*** ./node_modules/postcss/lib/input.js ***!
  \*******************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


let {
  SourceMapConsumer,
  SourceMapGenerator
} = __webpack_require__(/*! source-map-js */ "?b8cb");
let {
  fileURLToPath,
  pathToFileURL
} = __webpack_require__(/*! url */ "?c717");
let {
  isAbsolute,
  resolve
} = __webpack_require__(/*! path */ "?6197");
let {
  nanoid
} = __webpack_require__(/*! nanoid/non-secure */ "./node_modules/nanoid/non-secure/index.cjs");
let terminalHighlight = __webpack_require__(/*! ./terminal-highlight */ "?5580");
let CssSyntaxError = __webpack_require__(/*! ./css-syntax-error */ "./node_modules/postcss/lib/css-syntax-error.js");
let PreviousMap = __webpack_require__(/*! ./previous-map */ "./node_modules/postcss/lib/previous-map.js");
let fromOffsetCache = Symbol('fromOffsetCache');
let sourceMapAvailable = Boolean(SourceMapConsumer && SourceMapGenerator);
let pathAvailable = Boolean(resolve && isAbsolute);
class Input {
  constructor(css, opts = {}) {
    if (css === null || typeof css === 'undefined' || typeof css === 'object' && !css.toString) {
      throw new Error(`PostCSS received ${css} instead of CSS string`);
    }
    this.css = css.toString();
    if (this.css[0] === '\uFEFF' || this.css[0] === '\uFFFE') {
      this.hasBOM = true;
      this.css = this.css.slice(1);
    } else {
      this.hasBOM = false;
    }
    if (opts.from) {
      if (!pathAvailable || /^\w+:\/\//.test(opts.from) || isAbsolute(opts.from)) {
        this.file = opts.from;
      } else {
        this.file = resolve(opts.from);
      }
    }
    if (pathAvailable && sourceMapAvailable) {
      let map = new PreviousMap(this.css, opts);
      if (map.text) {
        this.map = map;
        let file = map.consumer().file;
        if (!this.file && file) this.file = this.mapResolve(file);
      }
    }
    if (!this.file) {
      this.id = '<input css ' + nanoid(6) + '>';
    }
    if (this.map) this.map.file = this.from;
  }
  error(message, line, column, opts = {}) {
    let result, endLine, endColumn;
    if (line && typeof line === 'object') {
      let start = line;
      let end = column;
      if (typeof start.offset === 'number') {
        let pos = this.fromOffset(start.offset);
        line = pos.line;
        column = pos.col;
      } else {
        line = start.line;
        column = start.column;
      }
      if (typeof end.offset === 'number') {
        let pos = this.fromOffset(end.offset);
        endLine = pos.line;
        endColumn = pos.col;
      } else {
        endLine = end.line;
        endColumn = end.column;
      }
    } else if (!column) {
      let pos = this.fromOffset(line);
      line = pos.line;
      column = pos.col;
    }
    let origin = this.origin(line, column, endLine, endColumn);
    if (origin) {
      result = new CssSyntaxError(message, origin.endLine === undefined ? origin.line : {
        column: origin.column,
        line: origin.line
      }, origin.endLine === undefined ? origin.column : {
        column: origin.endColumn,
        line: origin.endLine
      }, origin.source, origin.file, opts.plugin);
    } else {
      result = new CssSyntaxError(message, endLine === undefined ? line : {
        column,
        line
      }, endLine === undefined ? column : {
        column: endColumn,
        line: endLine
      }, this.css, this.file, opts.plugin);
    }
    result.input = {
      column,
      endColumn,
      endLine,
      line,
      source: this.css
    };
    if (this.file) {
      if (pathToFileURL) {
        result.input.url = pathToFileURL(this.file).toString();
      }
      result.input.file = this.file;
    }
    return result;
  }
  fromOffset(offset) {
    let lastLine, lineToIndex;
    if (!this[fromOffsetCache]) {
      let lines = this.css.split('\n');
      lineToIndex = new Array(lines.length);
      let prevIndex = 0;
      for (let i = 0, l = lines.length; i < l; i++) {
        lineToIndex[i] = prevIndex;
        prevIndex += lines[i].length + 1;
      }
      this[fromOffsetCache] = lineToIndex;
    } else {
      lineToIndex = this[fromOffsetCache];
    }
    lastLine = lineToIndex[lineToIndex.length - 1];
    let min = 0;
    if (offset >= lastLine) {
      min = lineToIndex.length - 1;
    } else {
      let max = lineToIndex.length - 2;
      let mid;
      while (min < max) {
        mid = min + (max - min >> 1);
        if (offset < lineToIndex[mid]) {
          max = mid - 1;
        } else if (offset >= lineToIndex[mid + 1]) {
          min = mid + 1;
        } else {
          min = mid;
          break;
        }
      }
    }
    return {
      col: offset - lineToIndex[min] + 1,
      line: min + 1
    };
  }
  mapResolve(file) {
    if (/^\w+:\/\//.test(file)) {
      return file;
    }
    return resolve(this.map.consumer().sourceRoot || this.map.root || '.', file);
  }
  origin(line, column, endLine, endColumn) {
    if (!this.map) return false;
    let consumer = this.map.consumer();
    let from = consumer.originalPositionFor({
      column,
      line
    });
    if (!from.source) return false;
    let to;
    if (typeof endLine === 'number') {
      to = consumer.originalPositionFor({
        column: endColumn,
        line: endLine
      });
    }
    let fromUrl;
    if (isAbsolute(from.source)) {
      fromUrl = pathToFileURL(from.source);
    } else {
      fromUrl = new URL(from.source, this.map.consumer().sourceRoot || pathToFileURL(this.map.mapFile));
    }
    let result = {
      column: from.column,
      endColumn: to && to.column,
      endLine: to && to.line,
      line: from.line,
      url: fromUrl.toString()
    };
    if (fromUrl.protocol === 'file:') {
      if (fileURLToPath) {
        result.file = fileURLToPath(fromUrl);
      } else {
        /* c8 ignore next 2 */
        throw new Error(`file: protocol is not available in this PostCSS build`);
      }
    }
    let source = consumer.sourceContentFor(from.source);
    if (source) result.source = source;
    return result;
  }
  toJSON() {
    let json = {};
    for (let name of ['hasBOM', 'css', 'file', 'id']) {
      if (this[name] != null) {
        json[name] = this[name];
      }
    }
    if (this.map) {
      json.map = {
        ...this.map
      };
      if (json.map.consumerCache) {
        json.map.consumerCache = undefined;
      }
    }
    return json;
  }
  get from() {
    return this.file || this.id;
  }
}
module.exports = Input;
Input.default = Input;
if (terminalHighlight && terminalHighlight.registerInput) {
  terminalHighlight.registerInput(Input);
}

/***/ }),

/***/ "./node_modules/postcss/lib/lazy-result.js":
/*!*************************************************!*\
  !*** ./node_modules/postcss/lib/lazy-result.js ***!
  \*************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


let {
  isClean,
  my
} = __webpack_require__(/*! ./symbols */ "./node_modules/postcss/lib/symbols.js");
let MapGenerator = __webpack_require__(/*! ./map-generator */ "./node_modules/postcss/lib/map-generator.js");
let stringify = __webpack_require__(/*! ./stringify */ "./node_modules/postcss/lib/stringify.js");
let Container = __webpack_require__(/*! ./container */ "./node_modules/postcss/lib/container.js");
let Document = __webpack_require__(/*! ./document */ "./node_modules/postcss/lib/document.js");
let warnOnce = __webpack_require__(/*! ./warn-once */ "./node_modules/postcss/lib/warn-once.js");
let Result = __webpack_require__(/*! ./result */ "./node_modules/postcss/lib/result.js");
let parse = __webpack_require__(/*! ./parse */ "./node_modules/postcss/lib/parse.js");
let Root = __webpack_require__(/*! ./root */ "./node_modules/postcss/lib/root.js");
const TYPE_TO_CLASS_NAME = {
  atrule: 'AtRule',
  comment: 'Comment',
  decl: 'Declaration',
  document: 'Document',
  root: 'Root',
  rule: 'Rule'
};
const PLUGIN_PROPS = {
  AtRule: true,
  AtRuleExit: true,
  Comment: true,
  CommentExit: true,
  Declaration: true,
  DeclarationExit: true,
  Document: true,
  DocumentExit: true,
  Once: true,
  OnceExit: true,
  postcssPlugin: true,
  prepare: true,
  Root: true,
  RootExit: true,
  Rule: true,
  RuleExit: true
};
const NOT_VISITORS = {
  Once: true,
  postcssPlugin: true,
  prepare: true
};
const CHILDREN = 0;
function isPromise(obj) {
  return typeof obj === 'object' && typeof obj.then === 'function';
}
function getEvents(node) {
  let key = false;
  let type = TYPE_TO_CLASS_NAME[node.type];
  if (node.type === 'decl') {
    key = node.prop.toLowerCase();
  } else if (node.type === 'atrule') {
    key = node.name.toLowerCase();
  }
  if (key && node.append) {
    return [type, type + '-' + key, CHILDREN, type + 'Exit', type + 'Exit-' + key];
  } else if (key) {
    return [type, type + '-' + key, type + 'Exit', type + 'Exit-' + key];
  } else if (node.append) {
    return [type, CHILDREN, type + 'Exit'];
  } else {
    return [type, type + 'Exit'];
  }
}
function toStack(node) {
  let events;
  if (node.type === 'document') {
    events = ['Document', CHILDREN, 'DocumentExit'];
  } else if (node.type === 'root') {
    events = ['Root', CHILDREN, 'RootExit'];
  } else {
    events = getEvents(node);
  }
  return {
    eventIndex: 0,
    events,
    iterator: 0,
    node,
    visitorIndex: 0,
    visitors: []
  };
}
function cleanMarks(node) {
  node[isClean] = false;
  if (node.nodes) node.nodes.forEach(i => cleanMarks(i));
  return node;
}
let postcss = {};
class LazyResult {
  constructor(processor, css, opts) {
    this.stringified = false;
    this.processed = false;
    let root;
    if (typeof css === 'object' && css !== null && (css.type === 'root' || css.type === 'document')) {
      root = cleanMarks(css);
    } else if (css instanceof LazyResult || css instanceof Result) {
      root = cleanMarks(css.root);
      if (css.map) {
        if (typeof opts.map === 'undefined') opts.map = {};
        if (!opts.map.inline) opts.map.inline = false;
        opts.map.prev = css.map;
      }
    } else {
      let parser = parse;
      if (opts.syntax) parser = opts.syntax.parse;
      if (opts.parser) parser = opts.parser;
      if (parser.parse) parser = parser.parse;
      try {
        root = parser(css, opts);
      } catch (error) {
        this.processed = true;
        this.error = error;
      }
      if (root && !root[my]) {
        /* c8 ignore next 2 */
        Container.rebuild(root);
      }
    }
    this.result = new Result(processor, root, opts);
    this.helpers = {
      ...postcss,
      postcss,
      result: this.result
    };
    this.plugins = this.processor.plugins.map(plugin => {
      if (typeof plugin === 'object' && plugin.prepare) {
        return {
          ...plugin,
          ...plugin.prepare(this.result)
        };
      } else {
        return plugin;
      }
    });
  }
  async() {
    if (this.error) return Promise.reject(this.error);
    if (this.processed) return Promise.resolve(this.result);
    if (!this.processing) {
      this.processing = this.runAsync();
    }
    return this.processing;
  }
  catch(onRejected) {
    return this.async().catch(onRejected);
  }
  finally(onFinally) {
    return this.async().then(onFinally, onFinally);
  }
  getAsyncError() {
    throw new Error('Use process(css).then(cb) to work with async plugins');
  }
  handleError(error, node) {
    let plugin = this.result.lastPlugin;
    try {
      if (node) node.addToError(error);
      this.error = error;
      if (error.name === 'CssSyntaxError' && !error.plugin) {
        error.plugin = plugin.postcssPlugin;
        error.setMessage();
      } else if (plugin.postcssVersion) {
        if (true) {
          let pluginName = plugin.postcssPlugin;
          let pluginVer = plugin.postcssVersion;
          let runtimeVer = this.result.processor.version;
          let a = pluginVer.split('.');
          let b = runtimeVer.split('.');
          if (a[0] !== b[0] || parseInt(a[1]) > parseInt(b[1])) {
            // eslint-disable-next-line no-console
            console.error('Unknown error from PostCSS plugin. Your current PostCSS ' + 'version is ' + runtimeVer + ', but ' + pluginName + ' uses ' + pluginVer + '. Perhaps this is the source of the error below.');
          }
        }
      }
    } catch (err) {
      /* c8 ignore next 3 */
      // eslint-disable-next-line no-console
      if (console && console.error) console.error(err);
    }
    return error;
  }
  prepareVisitors() {
    this.listeners = {};
    let add = (plugin, type, cb) => {
      if (!this.listeners[type]) this.listeners[type] = [];
      this.listeners[type].push([plugin, cb]);
    };
    for (let plugin of this.plugins) {
      if (typeof plugin === 'object') {
        for (let event in plugin) {
          if (!PLUGIN_PROPS[event] && /^[A-Z]/.test(event)) {
            throw new Error(`Unknown event ${event} in ${plugin.postcssPlugin}. ` + `Try to update PostCSS (${this.processor.version} now).`);
          }
          if (!NOT_VISITORS[event]) {
            if (typeof plugin[event] === 'object') {
              for (let filter in plugin[event]) {
                if (filter === '*') {
                  add(plugin, event, plugin[event][filter]);
                } else {
                  add(plugin, event + '-' + filter.toLowerCase(), plugin[event][filter]);
                }
              }
            } else if (typeof plugin[event] === 'function') {
              add(plugin, event, plugin[event]);
            }
          }
        }
      }
    }
    this.hasListener = Object.keys(this.listeners).length > 0;
  }
  async runAsync() {
    this.plugin = 0;
    for (let i = 0; i < this.plugins.length; i++) {
      let plugin = this.plugins[i];
      let promise = this.runOnRoot(plugin);
      if (isPromise(promise)) {
        try {
          await promise;
        } catch (error) {
          throw this.handleError(error);
        }
      }
    }
    this.prepareVisitors();
    if (this.hasListener) {
      let root = this.result.root;
      while (!root[isClean]) {
        root[isClean] = true;
        let stack = [toStack(root)];
        while (stack.length > 0) {
          let promise = this.visitTick(stack);
          if (isPromise(promise)) {
            try {
              await promise;
            } catch (e) {
              let node = stack[stack.length - 1].node;
              throw this.handleError(e, node);
            }
          }
        }
      }
      if (this.listeners.OnceExit) {
        for (let [plugin, visitor] of this.listeners.OnceExit) {
          this.result.lastPlugin = plugin;
          try {
            if (root.type === 'document') {
              let roots = root.nodes.map(subRoot => visitor(subRoot, this.helpers));
              await Promise.all(roots);
            } else {
              await visitor(root, this.helpers);
            }
          } catch (e) {
            throw this.handleError(e);
          }
        }
      }
    }
    this.processed = true;
    return this.stringify();
  }
  runOnRoot(plugin) {
    this.result.lastPlugin = plugin;
    try {
      if (typeof plugin === 'object' && plugin.Once) {
        if (this.result.root.type === 'document') {
          let roots = this.result.root.nodes.map(root => plugin.Once(root, this.helpers));
          if (isPromise(roots[0])) {
            return Promise.all(roots);
          }
          return roots;
        }
        return plugin.Once(this.result.root, this.helpers);
      } else if (typeof plugin === 'function') {
        return plugin(this.result.root, this.result);
      }
    } catch (error) {
      throw this.handleError(error);
    }
  }
  stringify() {
    if (this.error) throw this.error;
    if (this.stringified) return this.result;
    this.stringified = true;
    this.sync();
    let opts = this.result.opts;
    let str = stringify;
    if (opts.syntax) str = opts.syntax.stringify;
    if (opts.stringifier) str = opts.stringifier;
    if (str.stringify) str = str.stringify;
    let map = new MapGenerator(str, this.result.root, this.result.opts);
    let data = map.generate();
    this.result.css = data[0];
    this.result.map = data[1];
    return this.result;
  }
  sync() {
    if (this.error) throw this.error;
    if (this.processed) return this.result;
    this.processed = true;
    if (this.processing) {
      throw this.getAsyncError();
    }
    for (let plugin of this.plugins) {
      let promise = this.runOnRoot(plugin);
      if (isPromise(promise)) {
        throw this.getAsyncError();
      }
    }
    this.prepareVisitors();
    if (this.hasListener) {
      let root = this.result.root;
      while (!root[isClean]) {
        root[isClean] = true;
        this.walkSync(root);
      }
      if (this.listeners.OnceExit) {
        if (root.type === 'document') {
          for (let subRoot of root.nodes) {
            this.visitSync(this.listeners.OnceExit, subRoot);
          }
        } else {
          this.visitSync(this.listeners.OnceExit, root);
        }
      }
    }
    return this.result;
  }
  then(onFulfilled, onRejected) {
    if (true) {
      if (!('from' in this.opts)) {
        warnOnce('Without `from` option PostCSS could generate wrong source map ' + 'and will not find Browserslist config. Set it to CSS file path ' + 'or to `undefined` to prevent this warning.');
      }
    }
    return this.async().then(onFulfilled, onRejected);
  }
  toString() {
    return this.css;
  }
  visitSync(visitors, node) {
    for (let [plugin, visitor] of visitors) {
      this.result.lastPlugin = plugin;
      let promise;
      try {
        promise = visitor(node, this.helpers);
      } catch (e) {
        throw this.handleError(e, node.proxyOf);
      }
      if (node.type !== 'root' && node.type !== 'document' && !node.parent) {
        return true;
      }
      if (isPromise(promise)) {
        throw this.getAsyncError();
      }
    }
  }
  visitTick(stack) {
    let visit = stack[stack.length - 1];
    let {
      node,
      visitors
    } = visit;
    if (node.type !== 'root' && node.type !== 'document' && !node.parent) {
      stack.pop();
      return;
    }
    if (visitors.length > 0 && visit.visitorIndex < visitors.length) {
      let [plugin, visitor] = visitors[visit.visitorIndex];
      visit.visitorIndex += 1;
      if (visit.visitorIndex === visitors.length) {
        visit.visitors = [];
        visit.visitorIndex = 0;
      }
      this.result.lastPlugin = plugin;
      try {
        return visitor(node.toProxy(), this.helpers);
      } catch (e) {
        throw this.handleError(e, node);
      }
    }
    if (visit.iterator !== 0) {
      let iterator = visit.iterator;
      let child;
      while (child = node.nodes[node.indexes[iterator]]) {
        node.indexes[iterator] += 1;
        if (!child[isClean]) {
          child[isClean] = true;
          stack.push(toStack(child));
          return;
        }
      }
      visit.iterator = 0;
      delete node.indexes[iterator];
    }
    let events = visit.events;
    while (visit.eventIndex < events.length) {
      let event = events[visit.eventIndex];
      visit.eventIndex += 1;
      if (event === CHILDREN) {
        if (node.nodes && node.nodes.length) {
          node[isClean] = true;
          visit.iterator = node.getIterator();
        }
        return;
      } else if (this.listeners[event]) {
        visit.visitors = this.listeners[event];
        return;
      }
    }
    stack.pop();
  }
  walkSync(node) {
    node[isClean] = true;
    let events = getEvents(node);
    for (let event of events) {
      if (event === CHILDREN) {
        if (node.nodes) {
          node.each(child => {
            if (!child[isClean]) this.walkSync(child);
          });
        }
      } else {
        let visitors = this.listeners[event];
        if (visitors) {
          if (this.visitSync(visitors, node.toProxy())) return;
        }
      }
    }
  }
  warnings() {
    return this.sync().warnings();
  }
  get content() {
    return this.stringify().content;
  }
  get css() {
    return this.stringify().css;
  }
  get map() {
    return this.stringify().map;
  }
  get messages() {
    return this.sync().messages;
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    return this.sync().root;
  }
  get [Symbol.toStringTag]() {
    return 'LazyResult';
  }
}
LazyResult.registerPostcss = dependant => {
  postcss = dependant;
};
module.exports = LazyResult;
LazyResult.default = LazyResult;
Root.registerLazyResult(LazyResult);
Document.registerLazyResult(LazyResult);

/***/ }),

/***/ "./node_modules/postcss/lib/list.js":
/*!******************************************!*\
  !*** ./node_modules/postcss/lib/list.js ***!
  \******************************************/
/***/ ((module) => {

"use strict";


let list = {
  comma(string) {
    return list.split(string, [','], true);
  },
  space(string) {
    let spaces = [' ', '\n', '\t'];
    return list.split(string, spaces);
  },
  split(string, separators, last) {
    let array = [];
    let current = '';
    let split = false;
    let func = 0;
    let inQuote = false;
    let prevQuote = '';
    let escape = false;
    for (let letter of string) {
      if (escape) {
        escape = false;
      } else if (letter === '\\') {
        escape = true;
      } else if (inQuote) {
        if (letter === prevQuote) {
          inQuote = false;
        }
      } else if (letter === '"' || letter === "'") {
        inQuote = true;
        prevQuote = letter;
      } else if (letter === '(') {
        func += 1;
      } else if (letter === ')') {
        if (func > 0) func -= 1;
      } else if (func === 0) {
        if (separators.includes(letter)) split = true;
      }
      if (split) {
        if (current !== '') array.push(current.trim());
        current = '';
        split = false;
      } else {
        current += letter;
      }
    }
    if (last || current !== '') array.push(current.trim());
    return array;
  }
};
module.exports = list;
list.default = list;

/***/ }),

/***/ "./node_modules/postcss/lib/map-generator.js":
/*!***************************************************!*\
  !*** ./node_modules/postcss/lib/map-generator.js ***!
  \***************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


let {
  SourceMapConsumer,
  SourceMapGenerator
} = __webpack_require__(/*! source-map-js */ "?b8cb");
let {
  dirname,
  relative,
  resolve,
  sep
} = __webpack_require__(/*! path */ "?6197");
let {
  pathToFileURL
} = __webpack_require__(/*! url */ "?c717");
let Input = __webpack_require__(/*! ./input */ "./node_modules/postcss/lib/input.js");
let sourceMapAvailable = Boolean(SourceMapConsumer && SourceMapGenerator);
let pathAvailable = Boolean(dirname && resolve && relative && sep);
class MapGenerator {
  constructor(stringify, root, opts, cssString) {
    this.stringify = stringify;
    this.mapOpts = opts.map || {};
    this.root = root;
    this.opts = opts;
    this.css = cssString;
    this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute;
    this.memoizedFileURLs = new Map();
    this.memoizedPaths = new Map();
    this.memoizedURLs = new Map();
  }
  addAnnotation() {
    let content;
    if (this.isInline()) {
      content = 'data:application/json;base64,' + this.toBase64(this.map.toString());
    } else if (typeof this.mapOpts.annotation === 'string') {
      content = this.mapOpts.annotation;
    } else if (typeof this.mapOpts.annotation === 'function') {
      content = this.mapOpts.annotation(this.opts.to, this.root);
    } else {
      content = this.outputFile() + '.map';
    }
    let eol = '\n';
    if (this.css.includes('\r\n')) eol = '\r\n';
    this.css += eol + '/*# sourceMappingURL=' + content + ' */';
  }
  applyPrevMaps() {
    for (let prev of this.previous()) {
      let from = this.toUrl(this.path(prev.file));
      let root = prev.root || dirname(prev.file);
      let map;
      if (this.mapOpts.sourcesContent === false) {
        map = new SourceMapConsumer(prev.text);
        if (map.sourcesContent) {
          map.sourcesContent = map.sourcesContent.map(() => null);
        }
      } else {
        map = prev.consumer();
      }
      this.map.applySourceMap(map, from, this.toUrl(this.path(root)));
    }
  }
  clearAnnotation() {
    if (this.mapOpts.annotation === false) return;
    if (this.root) {
      let node;
      for (let i = this.root.nodes.length - 1; i >= 0; i--) {
        node = this.root.nodes[i];
        if (node.type !== 'comment') continue;
        if (node.text.indexOf('# sourceMappingURL=') === 0) {
          this.root.removeChild(i);
        }
      }
    } else if (this.css) {
      this.css = this.css.replace(/(\n)?\/\*#[\S\s]*?\*\/$/gm, '');
    }
  }
  generate() {
    this.clearAnnotation();
    if (pathAvailable && sourceMapAvailable && this.isMap()) {
      return this.generateMap();
    } else {
      let result = '';
      this.stringify(this.root, i => {
        result += i;
      });
      return [result];
    }
  }
  generateMap() {
    if (this.root) {
      this.generateString();
    } else if (this.previous().length === 1) {
      let prev = this.previous()[0].consumer();
      prev.file = this.outputFile();
      this.map = SourceMapGenerator.fromSourceMap(prev);
    } else {
      this.map = new SourceMapGenerator({
        file: this.outputFile()
      });
      this.map.addMapping({
        generated: {
          column: 0,
          line: 1
        },
        original: {
          column: 0,
          line: 1
        },
        source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : '<no source>'
      });
    }
    if (this.isSourcesContent()) this.setSourcesContent();
    if (this.root && this.previous().length > 0) this.applyPrevMaps();
    if (this.isAnnotation()) this.addAnnotation();
    if (this.isInline()) {
      return [this.css];
    } else {
      return [this.css, this.map];
    }
  }
  generateString() {
    this.css = '';
    this.map = new SourceMapGenerator({
      file: this.outputFile()
    });
    let line = 1;
    let column = 1;
    let noSource = '<no source>';
    let mapping = {
      generated: {
        column: 0,
        line: 0
      },
      original: {
        column: 0,
        line: 0
      },
      source: ''
    };
    let lines, last;
    this.stringify(this.root, (str, node, type) => {
      this.css += str;
      if (node && type !== 'end') {
        mapping.generated.line = line;
        mapping.generated.column = column - 1;
        if (node.source && node.source.start) {
          mapping.source = this.sourcePath(node);
          mapping.original.line = node.source.start.line;
          mapping.original.column = node.source.start.column - 1;
          this.map.addMapping(mapping);
        } else {
          mapping.source = noSource;
          mapping.original.line = 1;
          mapping.original.column = 0;
          this.map.addMapping(mapping);
        }
      }
      lines = str.match(/\n/g);
      if (lines) {
        line += lines.length;
        last = str.lastIndexOf('\n');
        column = str.length - last;
      } else {
        column += str.length;
      }
      if (node && type !== 'start') {
        let p = node.parent || {
          raws: {}
        };
        let childless = node.type === 'decl' || node.type === 'atrule' && !node.nodes;
        if (!childless || node !== p.last || p.raws.semicolon) {
          if (node.source && node.source.end) {
            mapping.source = this.sourcePath(node);
            mapping.original.line = node.source.end.line;
            mapping.original.column = node.source.end.column - 1;
            mapping.generated.line = line;
            mapping.generated.column = column - 2;
            this.map.addMapping(mapping);
          } else {
            mapping.source = noSource;
            mapping.original.line = 1;
            mapping.original.column = 0;
            mapping.generated.line = line;
            mapping.generated.column = column - 1;
            this.map.addMapping(mapping);
          }
        }
      }
    });
  }
  isAnnotation() {
    if (this.isInline()) {
      return true;
    }
    if (typeof this.mapOpts.annotation !== 'undefined') {
      return this.mapOpts.annotation;
    }
    if (this.previous().length) {
      return this.previous().some(i => i.annotation);
    }
    return true;
  }
  isInline() {
    if (typeof this.mapOpts.inline !== 'undefined') {
      return this.mapOpts.inline;
    }
    let annotation = this.mapOpts.annotation;
    if (typeof annotation !== 'undefined' && annotation !== true) {
      return false;
    }
    if (this.previous().length) {
      return this.previous().some(i => i.inline);
    }
    return true;
  }
  isMap() {
    if (typeof this.opts.map !== 'undefined') {
      return !!this.opts.map;
    }
    return this.previous().length > 0;
  }
  isSourcesContent() {
    if (typeof this.mapOpts.sourcesContent !== 'undefined') {
      return this.mapOpts.sourcesContent;
    }
    if (this.previous().length) {
      return this.previous().some(i => i.withContent());
    }
    return true;
  }
  outputFile() {
    if (this.opts.to) {
      return this.path(this.opts.to);
    } else if (this.opts.from) {
      return this.path(this.opts.from);
    } else {
      return 'to.css';
    }
  }
  path(file) {
    if (this.mapOpts.absolute) return file;
    if (file.charCodeAt(0) === 60 /* `<` */) return file;
    if (/^\w+:\/\//.test(file)) return file;
    let cached = this.memoizedPaths.get(file);
    if (cached) return cached;
    let from = this.opts.to ? dirname(this.opts.to) : '.';
    if (typeof this.mapOpts.annotation === 'string') {
      from = dirname(resolve(from, this.mapOpts.annotation));
    }
    let path = relative(from, file);
    this.memoizedPaths.set(file, path);
    return path;
  }
  previous() {
    if (!this.previousMaps) {
      this.previousMaps = [];
      if (this.root) {
        this.root.walk(node => {
          if (node.source && node.source.input.map) {
            let map = node.source.input.map;
            if (!this.previousMaps.includes(map)) {
              this.previousMaps.push(map);
            }
          }
        });
      } else {
        let input = new Input(this.css, this.opts);
        if (input.map) this.previousMaps.push(input.map);
      }
    }
    return this.previousMaps;
  }
  setSourcesContent() {
    let already = {};
    if (this.root) {
      this.root.walk(node => {
        if (node.source) {
          let from = node.source.input.from;
          if (from && !already[from]) {
            already[from] = true;
            let fromUrl = this.usesFileUrls ? this.toFileUrl(from) : this.toUrl(this.path(from));
            this.map.setSourceContent(fromUrl, node.source.input.css);
          }
        }
      });
    } else if (this.css) {
      let from = this.opts.from ? this.toUrl(this.path(this.opts.from)) : '<no source>';
      this.map.setSourceContent(from, this.css);
    }
  }
  sourcePath(node) {
    if (this.mapOpts.from) {
      return this.toUrl(this.mapOpts.from);
    } else if (this.usesFileUrls) {
      return this.toFileUrl(node.source.input.from);
    } else {
      return this.toUrl(this.path(node.source.input.from));
    }
  }
  toBase64(str) {
    if (Buffer) {
      return Buffer.from(str).toString('base64');
    } else {
      return window.btoa(unescape(encodeURIComponent(str)));
    }
  }
  toFileUrl(path) {
    let cached = this.memoizedFileURLs.get(path);
    if (cached) return cached;
    if (pathToFileURL) {
      let fileURL = pathToFileURL(path).toString();
      this.memoizedFileURLs.set(path, fileURL);
      return fileURL;
    } else {
      throw new Error('`map.absolute` option is not available in this PostCSS build');
    }
  }
  toUrl(path) {
    let cached = this.memoizedURLs.get(path);
    if (cached) return cached;
    if (sep === '\\') {
      path = path.replace(/\\/g, '/');
    }
    let url = encodeURI(path).replace(/[#?]/g, encodeURIComponent);
    this.memoizedURLs.set(path, url);
    return url;
  }
}
module.exports = MapGenerator;

/***/ }),

/***/ "./node_modules/postcss/lib/no-work-result.js":
/*!****************************************************!*\
  !*** ./node_modules/postcss/lib/no-work-result.js ***!
  \****************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


let MapGenerator = __webpack_require__(/*! ./map-generator */ "./node_modules/postcss/lib/map-generator.js");
let stringify = __webpack_require__(/*! ./stringify */ "./node_modules/postcss/lib/stringify.js");
let warnOnce = __webpack_require__(/*! ./warn-once */ "./node_modules/postcss/lib/warn-once.js");
let parse = __webpack_require__(/*! ./parse */ "./node_modules/postcss/lib/parse.js");
const Result = __webpack_require__(/*! ./result */ "./node_modules/postcss/lib/result.js");
class NoWorkResult {
  constructor(processor, css, opts) {
    css = css.toString();
    this.stringified = false;
    this._processor = processor;
    this._css = css;
    this._opts = opts;
    this._map = undefined;
    let root;
    let str = stringify;
    this.result = new Result(this._processor, root, this._opts);
    this.result.css = css;
    let self = this;
    Object.defineProperty(this.result, 'root', {
      get() {
        return self.root;
      }
    });
    let map = new MapGenerator(str, root, this._opts, css);
    if (map.isMap()) {
      let [generatedCSS, generatedMap] = map.generate();
      if (generatedCSS) {
        this.result.css = generatedCSS;
      }
      if (generatedMap) {
        this.result.map = generatedMap;
      }
    }
  }
  async() {
    if (this.error) return Promise.reject(this.error);
    return Promise.resolve(this.result);
  }
  catch(onRejected) {
    return this.async().catch(onRejected);
  }
  finally(onFinally) {
    return this.async().then(onFinally, onFinally);
  }
  sync() {
    if (this.error) throw this.error;
    return this.result;
  }
  then(onFulfilled, onRejected) {
    if (true) {
      if (!('from' in this._opts)) {
        warnOnce('Without `from` option PostCSS could generate wrong source map ' + 'and will not find Browserslist config. Set it to CSS file path ' + 'or to `undefined` to prevent this warning.');
      }
    }
    return this.async().then(onFulfilled, onRejected);
  }
  toString() {
    return this._css;
  }
  warnings() {
    return [];
  }
  get content() {
    return this.result.css;
  }
  get css() {
    return this.result.css;
  }
  get map() {
    return this.result.map;
  }
  get messages() {
    return [];
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    if (this._root) {
      return this._root;
    }
    let root;
    let parser = parse;
    try {
      root = parser(this._css, this._opts);
    } catch (error) {
      this.error = error;
    }
    if (this.error) {
      throw this.error;
    } else {
      this._root = root;
      return root;
    }
  }
  get [Symbol.toStringTag]() {
    return 'NoWorkResult';
  }
}
module.exports = NoWorkResult;
NoWorkResult.default = NoWorkResult;

/***/ }),

/***/ "./node_modules/postcss/lib/node.js":
/*!******************************************!*\
  !*** ./node_modules/postcss/lib/node.js ***!
  \******************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


let {
  isClean,
  my
} = __webpack_require__(/*! ./symbols */ "./node_modules/postcss/lib/symbols.js");
let CssSyntaxError = __webpack_require__(/*! ./css-syntax-error */ "./node_modules/postcss/lib/css-syntax-error.js");
let Stringifier = __webpack_require__(/*! ./stringifier */ "./node_modules/postcss/lib/stringifier.js");
let stringify = __webpack_require__(/*! ./stringify */ "./node_modules/postcss/lib/stringify.js");
function cloneNode(obj, parent) {
  let cloned = new obj.constructor();
  for (let i in obj) {
    if (!Object.prototype.hasOwnProperty.call(obj, i)) {
      /* c8 ignore next 2 */
      continue;
    }
    if (i === 'proxyCache') continue;
    let value = obj[i];
    let type = typeof value;
    if (i === 'parent' && type === 'object') {
      if (parent) cloned[i] = parent;
    } else if (i === 'source') {
      cloned[i] = value;
    } else if (Array.isArray(value)) {
      cloned[i] = value.map(j => cloneNode(j, cloned));
    } else {
      if (type === 'object' && value !== null) value = cloneNode(value);
      cloned[i] = value;
    }
  }
  return cloned;
}
class Node {
  constructor(defaults = {}) {
    this.raws = {};
    this[isClean] = false;
    this[my] = true;
    for (let name in defaults) {
      if (name === 'nodes') {
        this.nodes = [];
        for (let node of defaults[name]) {
          if (typeof node.clone === 'function') {
            this.append(node.clone());
          } else {
            this.append(node);
          }
        }
      } else {
        this[name] = defaults[name];
      }
    }
  }
  addToError(error) {
    error.postcssNode = this;
    if (error.stack && this.source && /\n\s{4}at /.test(error.stack)) {
      let s = this.source;
      error.stack = error.stack.replace(/\n\s{4}at /, `$&${s.input.from}:${s.start.line}:${s.start.column}$&`);
    }
    return error;
  }
  after(add) {
    this.parent.insertAfter(this, add);
    return this;
  }
  assign(overrides = {}) {
    for (let name in overrides) {
      this[name] = overrides[name];
    }
    return this;
  }
  before(add) {
    this.parent.insertBefore(this, add);
    return this;
  }
  cleanRaws(keepBetween) {
    delete this.raws.before;
    delete this.raws.after;
    if (!keepBetween) delete this.raws.between;
  }
  clone(overrides = {}) {
    let cloned = cloneNode(this);
    for (let name in overrides) {
      cloned[name] = overrides[name];
    }
    return cloned;
  }
  cloneAfter(overrides = {}) {
    let cloned = this.clone(overrides);
    this.parent.insertAfter(this, cloned);
    return cloned;
  }
  cloneBefore(overrides = {}) {
    let cloned = this.clone(overrides);
    this.parent.insertBefore(this, cloned);
    return cloned;
  }
  error(message, opts = {}) {
    if (this.source) {
      let {
        end,
        start
      } = this.rangeBy(opts);
      return this.source.input.error(message, {
        column: start.column,
        line: start.line
      }, {
        column: end.column,
        line: end.line
      }, opts);
    }
    return new CssSyntaxError(message);
  }
  getProxyProcessor() {
    return {
      get(node, prop) {
        if (prop === 'proxyOf') {
          return node;
        } else if (prop === 'root') {
          return () => node.root().toProxy();
        } else {
          return node[prop];
        }
      },
      set(node, prop, value) {
        if (node[prop] === value) return true;
        node[prop] = value;
        if (prop === 'prop' || prop === 'value' || prop === 'name' || prop === 'params' || prop === 'important' || /* c8 ignore next */
        prop === 'text') {
          node.markDirty();
        }
        return true;
      }
    };
  }
  markDirty() {
    if (this[isClean]) {
      this[isClean] = false;
      let next = this;
      while (next = next.parent) {
        next[isClean] = false;
      }
    }
  }
  next() {
    if (!this.parent) return undefined;
    let index = this.parent.index(this);
    return this.parent.nodes[index + 1];
  }
  positionBy(opts, stringRepresentation) {
    let pos = this.source.start;
    if (opts.index) {
      pos = this.positionInside(opts.index, stringRepresentation);
    } else if (opts.word) {
      stringRepresentation = this.toString();
      let index = stringRepresentation.indexOf(opts.word);
      if (index !== -1) pos = this.positionInside(index, stringRepresentation);
    }
    return pos;
  }
  positionInside(index, stringRepresentation) {
    let string = stringRepresentation || this.toString();
    let column = this.source.start.column;
    let line = this.source.start.line;
    for (let i = 0; i < index; i++) {
      if (string[i] === '\n') {
        column = 1;
        line += 1;
      } else {
        column += 1;
      }
    }
    return {
      column,
      line
    };
  }
  prev() {
    if (!this.parent) return undefined;
    let index = this.parent.index(this);
    return this.parent.nodes[index - 1];
  }
  rangeBy(opts) {
    let start = {
      column: this.source.start.column,
      line: this.source.start.line
    };
    let end = this.source.end ? {
      column: this.source.end.column + 1,
      line: this.source.end.line
    } : {
      column: start.column + 1,
      line: start.line
    };
    if (opts.word) {
      let stringRepresentation = this.toString();
      let index = stringRepresentation.indexOf(opts.word);
      if (index !== -1) {
        start = this.positionInside(index, stringRepresentation);
        end = this.positionInside(index + opts.word.length, stringRepresentation);
      }
    } else {
      if (opts.start) {
        start = {
          column: opts.start.column,
          line: opts.start.line
        };
      } else if (opts.index) {
        start = this.positionInside(opts.index);
      }
      if (opts.end) {
        end = {
          column: opts.end.column,
          line: opts.end.line
        };
      } else if (opts.endIndex) {
        end = this.positionInside(opts.endIndex);
      } else if (opts.index) {
        end = this.positionInside(opts.index + 1);
      }
    }
    if (end.line < start.line || end.line === start.line && end.column <= start.column) {
      end = {
        column: start.column + 1,
        line: start.line
      };
    }
    return {
      end,
      start
    };
  }
  raw(prop, defaultType) {
    let str = new Stringifier();
    return str.raw(this, prop, defaultType);
  }
  remove() {
    if (this.parent) {
      this.parent.removeChild(this);
    }
    this.parent = undefined;
    return this;
  }
  replaceWith(...nodes) {
    if (this.parent) {
      let bookmark = this;
      let foundSelf = false;
      for (let node of nodes) {
        if (node === this) {
          foundSelf = true;
        } else if (foundSelf) {
          this.parent.insertAfter(bookmark, node);
          bookmark = node;
        } else {
          this.parent.insertBefore(bookmark, node);
        }
      }
      if (!foundSelf) {
        this.remove();
      }
    }
    return this;
  }
  root() {
    let result = this;
    while (result.parent && result.parent.type !== 'document') {
      result = result.parent;
    }
    return result;
  }
  toJSON(_, inputs) {
    let fixed = {};
    let emitInputs = inputs == null;
    inputs = inputs || new Map();
    let inputsNextIndex = 0;
    for (let name in this) {
      if (!Object.prototype.hasOwnProperty.call(this, name)) {
        /* c8 ignore next 2 */
        continue;
      }
      if (name === 'parent' || name === 'proxyCache') continue;
      let value = this[name];
      if (Array.isArray(value)) {
        fixed[name] = value.map(i => {
          if (typeof i === 'object' && i.toJSON) {
            return i.toJSON(null, inputs);
          } else {
            return i;
          }
        });
      } else if (typeof value === 'object' && value.toJSON) {
        fixed[name] = value.toJSON(null, inputs);
      } else if (name === 'source') {
        let inputId = inputs.get(value.input);
        if (inputId == null) {
          inputId = inputsNextIndex;
          inputs.set(value.input, inputsNextIndex);
          inputsNextIndex++;
        }
        fixed[name] = {
          end: value.end,
          inputId,
          start: value.start
        };
      } else {
        fixed[name] = value;
      }
    }
    if (emitInputs) {
      fixed.inputs = [...inputs.keys()].map(input => input.toJSON());
    }
    return fixed;
  }
  toProxy() {
    if (!this.proxyCache) {
      this.proxyCache = new Proxy(this, this.getProxyProcessor());
    }
    return this.proxyCache;
  }
  toString(stringifier = stringify) {
    if (stringifier.stringify) stringifier = stringifier.stringify;
    let result = '';
    stringifier(this, i => {
      result += i;
    });
    return result;
  }
  warn(result, text, opts) {
    let data = {
      node: this
    };
    for (let i in opts) data[i] = opts[i];
    return result.warn(text, data);
  }
  get proxyOf() {
    return this;
  }
}
module.exports = Node;
Node.default = Node;

/***/ }),

/***/ "./node_modules/postcss/lib/parse.js":
/*!*******************************************!*\
  !*** ./node_modules/postcss/lib/parse.js ***!
  \*******************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


let Container = __webpack_require__(/*! ./container */ "./node_modules/postcss/lib/container.js");
let Parser = __webpack_require__(/*! ./parser */ "./node_modules/postcss/lib/parser.js");
let Input = __webpack_require__(/*! ./input */ "./node_modules/postcss/lib/input.js");
function parse(css, opts) {
  let input = new Input(css, opts);
  let parser = new Parser(input);
  try {
    parser.parse();
  } catch (e) {
    if (true) {
      if (e.name === 'CssSyntaxError' && opts && opts.from) {
        if (/\.scss$/i.test(opts.from)) {
          e.message += '\nYou tried to parse SCSS with ' + 'the standard CSS parser; ' + 'try again with the postcss-scss parser';
        } else if (/\.sass/i.test(opts.from)) {
          e.message += '\nYou tried to parse Sass with ' + 'the standard CSS parser; ' + 'try again with the postcss-sass parser';
        } else if (/\.less$/i.test(opts.from)) {
          e.message += '\nYou tried to parse Less with ' + 'the standard CSS parser; ' + 'try again with the postcss-less parser';
        }
      }
    }
    throw e;
  }
  return parser.root;
}
module.exports = parse;
parse.default = parse;
Container.registerParse(parse);

/***/ }),

/***/ "./node_modules/postcss/lib/parser.js":
/*!********************************************!*\
  !*** ./node_modules/postcss/lib/parser.js ***!
  \********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


let Declaration = __webpack_require__(/*! ./declaration */ "./node_modules/postcss/lib/declaration.js");
let tokenizer = __webpack_require__(/*! ./tokenize */ "./node_modules/postcss/lib/tokenize.js");
let Comment = __webpack_require__(/*! ./comment */ "./node_modules/postcss/lib/comment.js");
let AtRule = __webpack_require__(/*! ./at-rule */ "./node_modules/postcss/lib/at-rule.js");
let Root = __webpack_require__(/*! ./root */ "./node_modules/postcss/lib/root.js");
let Rule = __webpack_require__(/*! ./rule */ "./node_modules/postcss/lib/rule.js");
const SAFE_COMMENT_NEIGHBOR = {
  empty: true,
  space: true
};
function findLastWithPosition(tokens) {
  for (let i = tokens.length - 1; i >= 0; i--) {
    let token = tokens[i];
    let pos = token[3] || token[2];
    if (pos) return pos;
  }
}
class Parser {
  constructor(input) {
    this.input = input;
    this.root = new Root();
    this.current = this.root;
    this.spaces = '';
    this.semicolon = false;
    this.customProperty = false;
    this.createTokenizer();
    this.root.source = {
      input,
      start: {
        column: 1,
        line: 1,
        offset: 0
      }
    };
  }
  atrule(token) {
    let node = new AtRule();
    node.name = token[1].slice(1);
    if (node.name === '') {
      this.unnamedAtrule(node, token);
    }
    this.init(node, token[2]);
    let type;
    let prev;
    let shift;
    let last = false;
    let open = false;
    let params = [];
    let brackets = [];
    while (!this.tokenizer.endOfFile()) {
      token = this.tokenizer.nextToken();
      type = token[0];
      if (type === '(' || type === '[') {
        brackets.push(type === '(' ? ')' : ']');
      } else if (type === '{' && brackets.length > 0) {
        brackets.push('}');
      } else if (type === brackets[brackets.length - 1]) {
        brackets.pop();
      }
      if (brackets.length === 0) {
        if (type === ';') {
          node.source.end = this.getPosition(token[2]);
          node.source.end.offset++;
          this.semicolon = true;
          break;
        } else if (type === '{') {
          open = true;
          break;
        } else if (type === '}') {
          if (params.length > 0) {
            shift = params.length - 1;
            prev = params[shift];
            while (prev && prev[0] === 'space') {
              prev = params[--shift];
            }
            if (prev) {
              node.source.end = this.getPosition(prev[3] || prev[2]);
              node.source.end.offset++;
            }
          }
          this.end(token);
          break;
        } else {
          params.push(token);
        }
      } else {
        params.push(token);
      }
      if (this.tokenizer.endOfFile()) {
        last = true;
        break;
      }
    }
    node.raws.between = this.spacesAndCommentsFromEnd(params);
    if (params.length) {
      node.raws.afterName = this.spacesAndCommentsFromStart(params);
      this.raw(node, 'params', params);
      if (last) {
        token = params[params.length - 1];
        node.source.end = this.getPosition(token[3] || token[2]);
        node.source.end.offset++;
        this.spaces = node.raws.between;
        node.raws.between = '';
      }
    } else {
      node.raws.afterName = '';
      node.params = '';
    }
    if (open) {
      node.nodes = [];
      this.current = node;
    }
  }
  checkMissedSemicolon(tokens) {
    let colon = this.colon(tokens);
    if (colon === false) return;
    let founded = 0;
    let token;
    for (let j = colon - 1; j >= 0; j--) {
      token = tokens[j];
      if (token[0] !== 'space') {
        founded += 1;
        if (founded === 2) break;
      }
    }
    // If the token is a word, e.g. `!important`, `red` or any other valid property's value.
    // Then we need to return the colon after that word token. [3] is the "end" colon of that word.
    // And because we need it after that one we do +1 to get the next one.
    throw this.input.error('Missed semicolon', token[0] === 'word' ? token[3] + 1 : token[2]);
  }
  colon(tokens) {
    let brackets = 0;
    let token, type, prev;
    for (let [i, element] of tokens.entries()) {
      token = element;
      type = token[0];
      if (type === '(') {
        brackets += 1;
      }
      if (type === ')') {
        brackets -= 1;
      }
      if (brackets === 0 && type === ':') {
        if (!prev) {
          this.doubleColon(token);
        } else if (prev[0] === 'word' && prev[1] === 'progid') {
          continue;
        } else {
          return i;
        }
      }
      prev = token;
    }
    return false;
  }
  comment(token) {
    let node = new Comment();
    this.init(node, token[2]);
    node.source.end = this.getPosition(token[3] || token[2]);
    node.source.end.offset++;
    let text = token[1].slice(2, -2);
    if (/^\s*$/.test(text)) {
      node.text = '';
      node.raws.left = text;
      node.raws.right = '';
    } else {
      let match = text.match(/^(\s*)([^]*\S)(\s*)$/);
      node.text = match[2];
      node.raws.left = match[1];
      node.raws.right = match[3];
    }
  }
  createTokenizer() {
    this.tokenizer = tokenizer(this.input);
  }
  decl(tokens, customProperty) {
    let node = new Declaration();
    this.init(node, tokens[0][2]);
    let last = tokens[tokens.length - 1];
    if (last[0] === ';') {
      this.semicolon = true;
      tokens.pop();
    }
    node.source.end = this.getPosition(last[3] || last[2] || findLastWithPosition(tokens));
    node.source.end.offset++;
    while (tokens[0][0] !== 'word') {
      if (tokens.length === 1) this.unknownWord(tokens);
      node.raws.before += tokens.shift()[1];
    }
    node.source.start = this.getPosition(tokens[0][2]);
    node.prop = '';
    while (tokens.length) {
      let type = tokens[0][0];
      if (type === ':' || type === 'space' || type === 'comment') {
        break;
      }
      node.prop += tokens.shift()[1];
    }
    node.raws.between = '';
    let token;
    while (tokens.length) {
      token = tokens.shift();
      if (token[0] === ':') {
        node.raws.between += token[1];
        break;
      } else {
        if (token[0] === 'word' && /\w/.test(token[1])) {
          this.unknownWord([token]);
        }
        node.raws.between += token[1];
      }
    }
    if (node.prop[0] === '_' || node.prop[0] === '*') {
      node.raws.before += node.prop[0];
      node.prop = node.prop.slice(1);
    }
    let firstSpaces = [];
    let next;
    while (tokens.length) {
      next = tokens[0][0];
      if (next !== 'space' && next !== 'comment') break;
      firstSpaces.push(tokens.shift());
    }
    this.precheckMissedSemicolon(tokens);
    for (let i = tokens.length - 1; i >= 0; i--) {
      token = tokens[i];
      if (token[1].toLowerCase() === '!important') {
        node.important = true;
        let string = this.stringFrom(tokens, i);
        string = this.spacesFromEnd(tokens) + string;
        if (string !== ' !important') node.raws.important = string;
        break;
      } else if (token[1].toLowerCase() === 'important') {
        let cache = tokens.slice(0);
        let str = '';
        for (let j = i; j > 0; j--) {
          let type = cache[j][0];
          if (str.trim().indexOf('!') === 0 && type !== 'space') {
            break;
          }
          str = cache.pop()[1] + str;
        }
        if (str.trim().indexOf('!') === 0) {
          node.important = true;
          node.raws.important = str;
          tokens = cache;
        }
      }
      if (token[0] !== 'space' && token[0] !== 'comment') {
        break;
      }
    }
    let hasWord = tokens.some(i => i[0] !== 'space' && i[0] !== 'comment');
    if (hasWord) {
      node.raws.between += firstSpaces.map(i => i[1]).join('');
      firstSpaces = [];
    }
    this.raw(node, 'value', firstSpaces.concat(tokens), customProperty);
    if (node.value.includes(':') && !customProperty) {
      this.checkMissedSemicolon(tokens);
    }
  }
  doubleColon(token) {
    throw this.input.error('Double colon', {
      offset: token[2]
    }, {
      offset: token[2] + token[1].length
    });
  }
  emptyRule(token) {
    let node = new Rule();
    this.init(node, token[2]);
    node.selector = '';
    node.raws.between = '';
    this.current = node;
  }
  end(token) {
    if (this.current.nodes && this.current.nodes.length) {
      this.current.raws.semicolon = this.semicolon;
    }
    this.semicolon = false;
    this.current.raws.after = (this.current.raws.after || '') + this.spaces;
    this.spaces = '';
    if (this.current.parent) {
      this.current.source.end = this.getPosition(token[2]);
      this.current.source.end.offset++;
      this.current = this.current.parent;
    } else {
      this.unexpectedClose(token);
    }
  }
  endFile() {
    if (this.current.parent) this.unclosedBlock();
    if (this.current.nodes && this.current.nodes.length) {
      this.current.raws.semicolon = this.semicolon;
    }
    this.current.raws.after = (this.current.raws.after || '') + this.spaces;
    this.root.source.end = this.getPosition(this.tokenizer.position());
  }
  freeSemicolon(token) {
    this.spaces += token[1];
    if (this.current.nodes) {
      let prev = this.current.nodes[this.current.nodes.length - 1];
      if (prev && prev.type === 'rule' && !prev.raws.ownSemicolon) {
        prev.raws.ownSemicolon = this.spaces;
        this.spaces = '';
      }
    }
  }

  // Helpers

  getPosition(offset) {
    let pos = this.input.fromOffset(offset);
    return {
      column: pos.col,
      line: pos.line,
      offset
    };
  }
  init(node, offset) {
    this.current.push(node);
    node.source = {
      input: this.input,
      start: this.getPosition(offset)
    };
    node.raws.before = this.spaces;
    this.spaces = '';
    if (node.type !== 'comment') this.semicolon = false;
  }
  other(start) {
    let end = false;
    let type = null;
    let colon = false;
    let bracket = null;
    let brackets = [];
    let customProperty = start[1].startsWith('--');
    let tokens = [];
    let token = start;
    while (token) {
      type = token[0];
      tokens.push(token);
      if (type === '(' || type === '[') {
        if (!bracket) bracket = token;
        brackets.push(type === '(' ? ')' : ']');
      } else if (customProperty && colon && type === '{') {
        if (!bracket) bracket = token;
        brackets.push('}');
      } else if (brackets.length === 0) {
        if (type === ';') {
          if (colon) {
            this.decl(tokens, customProperty);
            return;
          } else {
            break;
          }
        } else if (type === '{') {
          this.rule(tokens);
          return;
        } else if (type === '}') {
          this.tokenizer.back(tokens.pop());
          end = true;
          break;
        } else if (type === ':') {
          colon = true;
        }
      } else if (type === brackets[brackets.length - 1]) {
        brackets.pop();
        if (brackets.length === 0) bracket = null;
      }
      token = this.tokenizer.nextToken();
    }
    if (this.tokenizer.endOfFile()) end = true;
    if (brackets.length > 0) this.unclosedBracket(bracket);
    if (end && colon) {
      if (!customProperty) {
        while (tokens.length) {
          token = tokens[tokens.length - 1][0];
          if (token !== 'space' && token !== 'comment') break;
          this.tokenizer.back(tokens.pop());
        }
      }
      this.decl(tokens, customProperty);
    } else {
      this.unknownWord(tokens);
    }
  }
  parse() {
    let token;
    while (!this.tokenizer.endOfFile()) {
      token = this.tokenizer.nextToken();
      switch (token[0]) {
        case 'space':
          this.spaces += token[1];
          break;
        case ';':
          this.freeSemicolon(token);
          break;
        case '}':
          this.end(token);
          break;
        case 'comment':
          this.comment(token);
          break;
        case 'at-word':
          this.atrule(token);
          break;
        case '{':
          this.emptyRule(token);
          break;
        default:
          this.other(token);
          break;
      }
    }
    this.endFile();
  }
  precheckMissedSemicolon( /* tokens */
  ) {
    // Hook for Safe Parser
  }
  raw(node, prop, tokens, customProperty) {
    let token, type;
    let length = tokens.length;
    let value = '';
    let clean = true;
    let next, prev;
    for (let i = 0; i < length; i += 1) {
      token = tokens[i];
      type = token[0];
      if (type === 'space' && i === length - 1 && !customProperty) {
        clean = false;
      } else if (type === 'comment') {
        prev = tokens[i - 1] ? tokens[i - 1][0] : 'empty';
        next = tokens[i + 1] ? tokens[i + 1][0] : 'empty';
        if (!SAFE_COMMENT_NEIGHBOR[prev] && !SAFE_COMMENT_NEIGHBOR[next]) {
          if (value.slice(-1) === ',') {
            clean = false;
          } else {
            value += token[1];
          }
        } else {
          clean = false;
        }
      } else {
        value += token[1];
      }
    }
    if (!clean) {
      let raw = tokens.reduce((all, i) => all + i[1], '');
      node.raws[prop] = {
        raw,
        value
      };
    }
    node[prop] = value;
  }
  rule(tokens) {
    tokens.pop();
    let node = new Rule();
    this.init(node, tokens[0][2]);
    node.raws.between = this.spacesAndCommentsFromEnd(tokens);
    this.raw(node, 'selector', tokens);
    this.current = node;
  }
  spacesAndCommentsFromEnd(tokens) {
    let lastTokenType;
    let spaces = '';
    while (tokens.length) {
      lastTokenType = tokens[tokens.length - 1][0];
      if (lastTokenType !== 'space' && lastTokenType !== 'comment') break;
      spaces = tokens.pop()[1] + spaces;
    }
    return spaces;
  }

  // Errors

  spacesAndCommentsFromStart(tokens) {
    let next;
    let spaces = '';
    while (tokens.length) {
      next = tokens[0][0];
      if (next !== 'space' && next !== 'comment') break;
      spaces += tokens.shift()[1];
    }
    return spaces;
  }
  spacesFromEnd(tokens) {
    let lastTokenType;
    let spaces = '';
    while (tokens.length) {
      lastTokenType = tokens[tokens.length - 1][0];
      if (lastTokenType !== 'space') break;
      spaces = tokens.pop()[1] + spaces;
    }
    return spaces;
  }
  stringFrom(tokens, from) {
    let result = '';
    for (let i = from; i < tokens.length; i++) {
      result += tokens[i][1];
    }
    tokens.splice(from, tokens.length - from);
    return result;
  }
  unclosedBlock() {
    let pos = this.current.source.start;
    throw this.input.error('Unclosed block', pos.line, pos.column);
  }
  unclosedBracket(bracket) {
    throw this.input.error('Unclosed bracket', {
      offset: bracket[2]
    }, {
      offset: bracket[2] + 1
    });
  }
  unexpectedClose(token) {
    throw this.input.error('Unexpected }', {
      offset: token[2]
    }, {
      offset: token[2] + 1
    });
  }
  unknownWord(tokens) {
    throw this.input.error('Unknown word', {
      offset: tokens[0][2]
    }, {
      offset: tokens[0][2] + tokens[0][1].length
    });
  }
  unnamedAtrule(node, token) {
    throw this.input.error('At-rule without name', {
      offset: token[2]
    }, {
      offset: token[2] + token[1].length
    });
  }
}
module.exports = Parser;

/***/ }),

/***/ "./node_modules/postcss/lib/postcss.js":
/*!*********************************************!*\
  !*** ./node_modules/postcss/lib/postcss.js ***!
  \*********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


let CssSyntaxError = __webpack_require__(/*! ./css-syntax-error */ "./node_modules/postcss/lib/css-syntax-error.js");
let Declaration = __webpack_require__(/*! ./declaration */ "./node_modules/postcss/lib/declaration.js");
let LazyResult = __webpack_require__(/*! ./lazy-result */ "./node_modules/postcss/lib/lazy-result.js");
let Container = __webpack_require__(/*! ./container */ "./node_modules/postcss/lib/container.js");
let Processor = __webpack_require__(/*! ./processor */ "./node_modules/postcss/lib/processor.js");
let stringify = __webpack_require__(/*! ./stringify */ "./node_modules/postcss/lib/stringify.js");
let fromJSON = __webpack_require__(/*! ./fromJSON */ "./node_modules/postcss/lib/fromJSON.js");
let Document = __webpack_require__(/*! ./document */ "./node_modules/postcss/lib/document.js");
let Warning = __webpack_require__(/*! ./warning */ "./node_modules/postcss/lib/warning.js");
let Comment = __webpack_require__(/*! ./comment */ "./node_modules/postcss/lib/comment.js");
let AtRule = __webpack_require__(/*! ./at-rule */ "./node_modules/postcss/lib/at-rule.js");
let Result = __webpack_require__(/*! ./result.js */ "./node_modules/postcss/lib/result.js");
let Input = __webpack_require__(/*! ./input */ "./node_modules/postcss/lib/input.js");
let parse = __webpack_require__(/*! ./parse */ "./node_modules/postcss/lib/parse.js");
let list = __webpack_require__(/*! ./list */ "./node_modules/postcss/lib/list.js");
let Rule = __webpack_require__(/*! ./rule */ "./node_modules/postcss/lib/rule.js");
let Root = __webpack_require__(/*! ./root */ "./node_modules/postcss/lib/root.js");
let Node = __webpack_require__(/*! ./node */ "./node_modules/postcss/lib/node.js");
function postcss(...plugins) {
  if (plugins.length === 1 && Array.isArray(plugins[0])) {
    plugins = plugins[0];
  }
  return new Processor(plugins);
}
postcss.plugin = function plugin(name, initializer) {
  let warningPrinted = false;
  function creator(...args) {
    // eslint-disable-next-line no-console
    if (console && console.warn && !warningPrinted) {
      warningPrinted = true;
      // eslint-disable-next-line no-console
      console.warn(name + ': postcss.plugin was deprecated. Migration guide:\n' + 'https://evilmartians.com/chronicles/postcss-8-plugin-migration');
      if (process.env.LANG && process.env.LANG.startsWith('cn')) {
        /* c8 ignore next 7 */
        // eslint-disable-next-line no-console
        console.warn(name + ': 里面 postcss.plugin 被弃用. 迁移指南:\n' + 'https://www.w3ctech.com/topic/2226');
      }
    }
    let transformer = initializer(...args);
    transformer.postcssPlugin = name;
    transformer.postcssVersion = new Processor().version;
    return transformer;
  }
  let cache;
  Object.defineProperty(creator, 'postcss', {
    get() {
      if (!cache) cache = creator();
      return cache;
    }
  });
  creator.process = function (css, processOpts, pluginOpts) {
    return postcss([creator(pluginOpts)]).process(css, processOpts);
  };
  return creator;
};
postcss.stringify = stringify;
postcss.parse = parse;
postcss.fromJSON = fromJSON;
postcss.list = list;
postcss.comment = defaults => new Comment(defaults);
postcss.atRule = defaults => new AtRule(defaults);
postcss.decl = defaults => new Declaration(defaults);
postcss.rule = defaults => new Rule(defaults);
postcss.root = defaults => new Root(defaults);
postcss.document = defaults => new Document(defaults);
postcss.CssSyntaxError = CssSyntaxError;
postcss.Declaration = Declaration;
postcss.Container = Container;
postcss.Processor = Processor;
postcss.Document = Document;
postcss.Comment = Comment;
postcss.Warning = Warning;
postcss.AtRule = AtRule;
postcss.Result = Result;
postcss.Input = Input;
postcss.Rule = Rule;
postcss.Root = Root;
postcss.Node = Node;
LazyResult.registerPostcss(postcss);
module.exports = postcss;
postcss.default = postcss;

/***/ }),

/***/ "./node_modules/postcss/lib/previous-map.js":
/*!**************************************************!*\
  !*** ./node_modules/postcss/lib/previous-map.js ***!
  \**************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


let {
  SourceMapConsumer,
  SourceMapGenerator
} = __webpack_require__(/*! source-map-js */ "?b8cb");
let {
  existsSync,
  readFileSync
} = __webpack_require__(/*! fs */ "?03fb");
let {
  dirname,
  join
} = __webpack_require__(/*! path */ "?6197");
function fromBase64(str) {
  if (Buffer) {
    return Buffer.from(str, 'base64').toString();
  } else {
    /* c8 ignore next 2 */
    return window.atob(str);
  }
}
class PreviousMap {
  constructor(css, opts) {
    if (opts.map === false) return;
    this.loadAnnotation(css);
    this.inline = this.startWith(this.annotation, 'data:');
    let prev = opts.map ? opts.map.prev : undefined;
    let text = this.loadMap(opts.from, prev);
    if (!this.mapFile && opts.from) {
      this.mapFile = opts.from;
    }
    if (this.mapFile) this.root = dirname(this.mapFile);
    if (text) this.text = text;
  }
  consumer() {
    if (!this.consumerCache) {
      this.consumerCache = new SourceMapConsumer(this.text);
    }
    return this.consumerCache;
  }
  decodeInline(text) {
    let baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
    let baseUri = /^data:application\/json;base64,/;
    let charsetUri = /^data:application\/json;charset=utf-?8,/;
    let uri = /^data:application\/json,/;
    if (charsetUri.test(text) || uri.test(text)) {
      return decodeURIComponent(text.substr(RegExp.lastMatch.length));
    }
    if (baseCharsetUri.test(text) || baseUri.test(text)) {
      return fromBase64(text.substr(RegExp.lastMatch.length));
    }
    let encoding = text.match(/data:application\/json;([^,]+),/)[1];
    throw new Error('Unsupported source map encoding ' + encoding);
  }
  getAnnotationURL(sourceMapString) {
    return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, '').trim();
  }
  isMap(map) {
    if (typeof map !== 'object') return false;
    return typeof map.mappings === 'string' || typeof map._mappings === 'string' || Array.isArray(map.sections);
  }
  loadAnnotation(css) {
    let comments = css.match(/\/\*\s*# sourceMappingURL=/gm);
    if (!comments) return;

    // sourceMappingURLs from comments, strings, etc.
    let start = css.lastIndexOf(comments.pop());
    let end = css.indexOf('*/', start);
    if (start > -1 && end > -1) {
      // Locate the last sourceMappingURL to avoid pickin
      this.annotation = this.getAnnotationURL(css.substring(start, end));
    }
  }
  loadFile(path) {
    this.root = dirname(path);
    if (existsSync(path)) {
      this.mapFile = path;
      return readFileSync(path, 'utf-8').toString().trim();
    }
  }
  loadMap(file, prev) {
    if (prev === false) return false;
    if (prev) {
      if (typeof prev === 'string') {
        return prev;
      } else if (typeof prev === 'function') {
        let prevPath = prev(file);
        if (prevPath) {
          let map = this.loadFile(prevPath);
          if (!map) {
            throw new Error('Unable to load previous source map: ' + prevPath.toString());
          }
          return map;
        }
      } else if (prev instanceof SourceMapConsumer) {
        return SourceMapGenerator.fromSourceMap(prev).toString();
      } else if (prev instanceof SourceMapGenerator) {
        return prev.toString();
      } else if (this.isMap(prev)) {
        return JSON.stringify(prev);
      } else {
        throw new Error('Unsupported previous source map format: ' + prev.toString());
      }
    } else if (this.inline) {
      return this.decodeInline(this.annotation);
    } else if (this.annotation) {
      let map = this.annotation;
      if (file) map = join(dirname(file), map);
      return this.loadFile(map);
    }
  }
  startWith(string, start) {
    if (!string) return false;
    return string.substr(0, start.length) === start;
  }
  withContent() {
    return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
  }
}
module.exports = PreviousMap;
PreviousMap.default = PreviousMap;

/***/ }),

/***/ "./node_modules/postcss/lib/processor.js":
/*!***********************************************!*\
  !*** ./node_modules/postcss/lib/processor.js ***!
  \***********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


let NoWorkResult = __webpack_require__(/*! ./no-work-result */ "./node_modules/postcss/lib/no-work-result.js");
let LazyResult = __webpack_require__(/*! ./lazy-result */ "./node_modules/postcss/lib/lazy-result.js");
let Document = __webpack_require__(/*! ./document */ "./node_modules/postcss/lib/document.js");
let Root = __webpack_require__(/*! ./root */ "./node_modules/postcss/lib/root.js");
class Processor {
  constructor(plugins = []) {
    this.version = '8.4.31';
    this.plugins = this.normalize(plugins);
  }
  normalize(plugins) {
    let normalized = [];
    for (let i of plugins) {
      if (i.postcss === true) {
        i = i();
      } else if (i.postcss) {
        i = i.postcss;
      }
      if (typeof i === 'object' && Array.isArray(i.plugins)) {
        normalized = normalized.concat(i.plugins);
      } else if (typeof i === 'object' && i.postcssPlugin) {
        normalized.push(i);
      } else if (typeof i === 'function') {
        normalized.push(i);
      } else if (typeof i === 'object' && (i.parse || i.stringify)) {
        if (true) {
          throw new Error('PostCSS syntaxes cannot be used as plugins. Instead, please use ' + 'one of the syntax/parser/stringifier options as outlined ' + 'in your PostCSS runner documentation.');
        }
      } else {
        throw new Error(i + ' is not a PostCSS plugin');
      }
    }
    return normalized;
  }
  process(css, opts = {}) {
    if (this.plugins.length === 0 && typeof opts.parser === 'undefined' && typeof opts.stringifier === 'undefined' && typeof opts.syntax === 'undefined') {
      return new NoWorkResult(this, css, opts);
    } else {
      return new LazyResult(this, css, opts);
    }
  }
  use(plugin) {
    this.plugins = this.plugins.concat(this.normalize([plugin]));
    return this;
  }
}
module.exports = Processor;
Processor.default = Processor;
Root.registerProcessor(Processor);
Document.registerProcessor(Processor);

/***/ }),

/***/ "./node_modules/postcss/lib/result.js":
/*!********************************************!*\
  !*** ./node_modules/postcss/lib/result.js ***!
  \********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


let Warning = __webpack_require__(/*! ./warning */ "./node_modules/postcss/lib/warning.js");
class Result {
  constructor(processor, root, opts) {
    this.processor = processor;
    this.messages = [];
    this.root = root;
    this.opts = opts;
    this.css = undefined;
    this.map = undefined;
  }
  toString() {
    return this.css;
  }
  warn(text, opts = {}) {
    if (!opts.plugin) {
      if (this.lastPlugin && this.lastPlugin.postcssPlugin) {
        opts.plugin = this.lastPlugin.postcssPlugin;
      }
    }
    let warning = new Warning(text, opts);
    this.messages.push(warning);
    return warning;
  }
  warnings() {
    return this.messages.filter(i => i.type === 'warning');
  }
  get content() {
    return this.css;
  }
}
module.exports = Result;
Result.default = Result;

/***/ }),

/***/ "./node_modules/postcss/lib/root.js":
/*!******************************************!*\
  !*** ./node_modules/postcss/lib/root.js ***!
  \******************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


let Container = __webpack_require__(/*! ./container */ "./node_modules/postcss/lib/container.js");
let LazyResult, Processor;
class Root extends Container {
  constructor(defaults) {
    super(defaults);
    this.type = 'root';
    if (!this.nodes) this.nodes = [];
  }
  normalize(child, sample, type) {
    let nodes = super.normalize(child);
    if (sample) {
      if (type === 'prepend') {
        if (this.nodes.length > 1) {
          sample.raws.before = this.nodes[1].raws.before;
        } else {
          delete sample.raws.before;
        }
      } else if (this.first !== sample) {
        for (let node of nodes) {
          node.raws.before = sample.raws.before;
        }
      }
    }
    return nodes;
  }
  removeChild(child, ignore) {
    let index = this.index(child);
    if (!ignore && index === 0 && this.nodes.length > 1) {
      this.nodes[1].raws.before = this.nodes[index].raws.before;
    }
    return super.removeChild(child);
  }
  toResult(opts = {}) {
    let lazy = new LazyResult(new Processor(), this, opts);
    return lazy.stringify();
  }
}
Root.registerLazyResult = dependant => {
  LazyResult = dependant;
};
Root.registerProcessor = dependant => {
  Processor = dependant;
};
module.exports = Root;
Root.default = Root;
Container.registerRoot(Root);

/***/ }),

/***/ "./node_modules/postcss/lib/rule.js":
/*!******************************************!*\
  !*** ./node_modules/postcss/lib/rule.js ***!
  \******************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


let Container = __webpack_require__(/*! ./container */ "./node_modules/postcss/lib/container.js");
let list = __webpack_require__(/*! ./list */ "./node_modules/postcss/lib/list.js");
class Rule extends Container {
  constructor(defaults) {
    super(defaults);
    this.type = 'rule';
    if (!this.nodes) this.nodes = [];
  }
  get selectors() {
    return list.comma(this.selector);
  }
  set selectors(values) {
    let match = this.selector ? this.selector.match(/,\s*/) : null;
    let sep = match ? match[0] : ',' + this.raw('between', 'beforeOpen');
    this.selector = values.join(sep);
  }
}
module.exports = Rule;
Rule.default = Rule;
Container.registerRule(Rule);

/***/ }),

/***/ "./node_modules/postcss/lib/stringifier.js":
/*!*************************************************!*\
  !*** ./node_modules/postcss/lib/stringifier.js ***!
  \*************************************************/
/***/ ((module) => {

"use strict";


const DEFAULT_RAW = {
  after: '\n',
  beforeClose: '\n',
  beforeComment: '\n',
  beforeDecl: '\n',
  beforeOpen: ' ',
  beforeRule: '\n',
  colon: ': ',
  commentLeft: ' ',
  commentRight: ' ',
  emptyBody: '',
  indent: '    ',
  semicolon: false
};
function capitalize(str) {
  return str[0].toUpperCase() + str.slice(1);
}
class Stringifier {
  constructor(builder) {
    this.builder = builder;
  }
  atrule(node, semicolon) {
    let name = '@' + node.name;
    let params = node.params ? this.rawValue(node, 'params') : '';
    if (typeof node.raws.afterName !== 'undefined') {
      name += node.raws.afterName;
    } else if (params) {
      name += ' ';
    }
    if (node.nodes) {
      this.block(node, name + params);
    } else {
      let end = (node.raws.between || '') + (semicolon ? ';' : '');
      this.builder(name + params + end, node);
    }
  }
  beforeAfter(node, detect) {
    let value;
    if (node.type === 'decl') {
      value = this.raw(node, null, 'beforeDecl');
    } else if (node.type === 'comment') {
      value = this.raw(node, null, 'beforeComment');
    } else if (detect === 'before') {
      value = this.raw(node, null, 'beforeRule');
    } else {
      value = this.raw(node, null, 'beforeClose');
    }
    let buf = node.parent;
    let depth = 0;
    while (buf && buf.type !== 'root') {
      depth += 1;
      buf = buf.parent;
    }
    if (value.includes('\n')) {
      let indent = this.raw(node, null, 'indent');
      if (indent.length) {
        for (let step = 0; step < depth; step++) value += indent;
      }
    }
    return value;
  }
  block(node, start) {
    let between = this.raw(node, 'between', 'beforeOpen');
    this.builder(start + between + '{', node, 'start');
    let after;
    if (node.nodes && node.nodes.length) {
      this.body(node);
      after = this.raw(node, 'after');
    } else {
      after = this.raw(node, 'after', 'emptyBody');
    }
    if (after) this.builder(after);
    this.builder('}', node, 'end');
  }
  body(node) {
    let last = node.nodes.length - 1;
    while (last > 0) {
      if (node.nodes[last].type !== 'comment') break;
      last -= 1;
    }
    let semicolon = this.raw(node, 'semicolon');
    for (let i = 0; i < node.nodes.length; i++) {
      let child = node.nodes[i];
      let before = this.raw(child, 'before');
      if (before) this.builder(before);
      this.stringify(child, last !== i || semicolon);
    }
  }
  comment(node) {
    let left = this.raw(node, 'left', 'commentLeft');
    let right = this.raw(node, 'right', 'commentRight');
    this.builder('/*' + left + node.text + right + '*/', node);
  }
  decl(node, semicolon) {
    let between = this.raw(node, 'between', 'colon');
    let string = node.prop + between + this.rawValue(node, 'value');
    if (node.important) {
      string += node.raws.important || ' !important';
    }
    if (semicolon) string += ';';
    this.builder(string, node);
  }
  document(node) {
    this.body(node);
  }
  raw(node, own, detect) {
    let value;
    if (!detect) detect = own;

    // Already had
    if (own) {
      value = node.raws[own];
      if (typeof value !== 'undefined') return value;
    }
    let parent = node.parent;
    if (detect === 'before') {
      // Hack for first rule in CSS
      if (!parent || parent.type === 'root' && parent.first === node) {
        return '';
      }

      // `root` nodes in `document` should use only their own raws
      if (parent && parent.type === 'document') {
        return '';
      }
    }

    // Floating child without parent
    if (!parent) return DEFAULT_RAW[detect];

    // Detect style by other nodes
    let root = node.root();
    if (!root.rawCache) root.rawCache = {};
    if (typeof root.rawCache[detect] !== 'undefined') {
      return root.rawCache[detect];
    }
    if (detect === 'before' || detect === 'after') {
      return this.beforeAfter(node, detect);
    } else {
      let method = 'raw' + capitalize(detect);
      if (this[method]) {
        value = this[method](root, node);
      } else {
        root.walk(i => {
          value = i.raws[own];
          if (typeof value !== 'undefined') return false;
        });
      }
    }
    if (typeof value === 'undefined') value = DEFAULT_RAW[detect];
    root.rawCache[detect] = value;
    return value;
  }
  rawBeforeClose(root) {
    let value;
    root.walk(i => {
      if (i.nodes && i.nodes.length > 0) {
        if (typeof i.raws.after !== 'undefined') {
          value = i.raws.after;
          if (value.includes('\n')) {
            value = value.replace(/[^\n]+$/, '');
          }
          return false;
        }
      }
    });
    if (value) value = value.replace(/\S/g, '');
    return value;
  }
  rawBeforeComment(root, node) {
    let value;
    root.walkComments(i => {
      if (typeof i.raws.before !== 'undefined') {
        value = i.raws.before;
        if (value.includes('\n')) {
          value = value.replace(/[^\n]+$/, '');
        }
        return false;
      }
    });
    if (typeof value === 'undefined') {
      value = this.raw(node, null, 'beforeDecl');
    } else if (value) {
      value = value.replace(/\S/g, '');
    }
    return value;
  }
  rawBeforeDecl(root, node) {
    let value;
    root.walkDecls(i => {
      if (typeof i.raws.before !== 'undefined') {
        value = i.raws.before;
        if (value.includes('\n')) {
          value = value.replace(/[^\n]+$/, '');
        }
        return false;
      }
    });
    if (typeof value === 'undefined') {
      value = this.raw(node, null, 'beforeRule');
    } else if (value) {
      value = value.replace(/\S/g, '');
    }
    return value;
  }
  rawBeforeOpen(root) {
    let value;
    root.walk(i => {
      if (i.type !== 'decl') {
        value = i.raws.between;
        if (typeof value !== 'undefined') return false;
      }
    });
    return value;
  }
  rawBeforeRule(root) {
    let value;
    root.walk(i => {
      if (i.nodes && (i.parent !== root || root.first !== i)) {
        if (typeof i.raws.before !== 'undefined') {
          value = i.raws.before;
          if (value.includes('\n')) {
            value = value.replace(/[^\n]+$/, '');
          }
          return false;
        }
      }
    });
    if (value) value = value.replace(/\S/g, '');
    return value;
  }
  rawColon(root) {
    let value;
    root.walkDecls(i => {
      if (typeof i.raws.between !== 'undefined') {
        value = i.raws.between.replace(/[^\s:]/g, '');
        return false;
      }
    });
    return value;
  }
  rawEmptyBody(root) {
    let value;
    root.walk(i => {
      if (i.nodes && i.nodes.length === 0) {
        value = i.raws.after;
        if (typeof value !== 'undefined') return false;
      }
    });
    return value;
  }
  rawIndent(root) {
    if (root.raws.indent) return root.raws.indent;
    let value;
    root.walk(i => {
      let p = i.parent;
      if (p && p !== root && p.parent && p.parent === root) {
        if (typeof i.raws.before !== 'undefined') {
          let parts = i.raws.before.split('\n');
          value = parts[parts.length - 1];
          value = value.replace(/\S/g, '');
          return false;
        }
      }
    });
    return value;
  }
  rawSemicolon(root) {
    let value;
    root.walk(i => {
      if (i.nodes && i.nodes.length && i.last.type === 'decl') {
        value = i.raws.semicolon;
        if (typeof value !== 'undefined') return false;
      }
    });
    return value;
  }
  rawValue(node, prop) {
    let value = node[prop];
    let raw = node.raws[prop];
    if (raw && raw.value === value) {
      return raw.raw;
    }
    return value;
  }
  root(node) {
    this.body(node);
    if (node.raws.after) this.builder(node.raws.after);
  }
  rule(node) {
    this.block(node, this.rawValue(node, 'selector'));
    if (node.raws.ownSemicolon) {
      this.builder(node.raws.ownSemicolon, node, 'end');
    }
  }
  stringify(node, semicolon) {
    /* c8 ignore start */
    if (!this[node.type]) {
      throw new Error('Unknown AST node type ' + node.type + '. ' + 'Maybe you need to change PostCSS stringifier.');
    }
    /* c8 ignore stop */
    this[node.type](node, semicolon);
  }
}
module.exports = Stringifier;
Stringifier.default = Stringifier;

/***/ }),

/***/ "./node_modules/postcss/lib/stringify.js":
/*!***********************************************!*\
  !*** ./node_modules/postcss/lib/stringify.js ***!
  \***********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


let Stringifier = __webpack_require__(/*! ./stringifier */ "./node_modules/postcss/lib/stringifier.js");
function stringify(node, builder) {
  let str = new Stringifier(builder);
  str.stringify(node);
}
module.exports = stringify;
stringify.default = stringify;

/***/ }),

/***/ "./node_modules/postcss/lib/symbols.js":
/*!*********************************************!*\
  !*** ./node_modules/postcss/lib/symbols.js ***!
  \*********************************************/
/***/ ((module) => {

"use strict";


module.exports.isClean = Symbol('isClean');
module.exports.my = Symbol('my');

/***/ }),

/***/ "./node_modules/postcss/lib/tokenize.js":
/*!**********************************************!*\
  !*** ./node_modules/postcss/lib/tokenize.js ***!
  \**********************************************/
/***/ ((module) => {

"use strict";


const SINGLE_QUOTE = "'".charCodeAt(0);
const DOUBLE_QUOTE = '"'.charCodeAt(0);
const BACKSLASH = '\\'.charCodeAt(0);
const SLASH = '/'.charCodeAt(0);
const NEWLINE = '\n'.charCodeAt(0);
const SPACE = ' '.charCodeAt(0);
const FEED = '\f'.charCodeAt(0);
const TAB = '\t'.charCodeAt(0);
const CR = '\r'.charCodeAt(0);
const OPEN_SQUARE = '['.charCodeAt(0);
const CLOSE_SQUARE = ']'.charCodeAt(0);
const OPEN_PARENTHESES = '('.charCodeAt(0);
const CLOSE_PARENTHESES = ')'.charCodeAt(0);
const OPEN_CURLY = '{'.charCodeAt(0);
const CLOSE_CURLY = '}'.charCodeAt(0);
const SEMICOLON = ';'.charCodeAt(0);
const ASTERISK = '*'.charCodeAt(0);
const COLON = ':'.charCodeAt(0);
const AT = '@'.charCodeAt(0);
const RE_AT_END = /[\t\n\f\r "#'()/;[\\\]{}]/g;
const RE_WORD_END = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
const RE_BAD_BRACKET = /.[\r\n"'(/\\]/;
const RE_HEX_ESCAPE = /[\da-f]/i;
module.exports = function tokenizer(input, options = {}) {
  let css = input.css.valueOf();
  let ignore = options.ignoreErrors;
  let code, next, quote, content, escape;
  let escaped, escapePos, prev, n, currentToken;
  let length = css.length;
  let pos = 0;
  let buffer = [];
  let returned = [];
  function position() {
    return pos;
  }
  function unclosed(what) {
    throw input.error('Unclosed ' + what, pos);
  }
  function endOfFile() {
    return returned.length === 0 && pos >= length;
  }
  function nextToken(opts) {
    if (returned.length) return returned.pop();
    if (pos >= length) return;
    let ignoreUnclosed = opts ? opts.ignoreUnclosed : false;
    code = css.charCodeAt(pos);
    switch (code) {
      case NEWLINE:
      case SPACE:
      case TAB:
      case CR:
      case FEED:
        {
          next = pos;
          do {
            next += 1;
            code = css.charCodeAt(next);
          } while (code === SPACE || code === NEWLINE || code === TAB || code === CR || code === FEED);
          currentToken = ['space', css.slice(pos, next)];
          pos = next - 1;
          break;
        }
      case OPEN_SQUARE:
      case CLOSE_SQUARE:
      case OPEN_CURLY:
      case CLOSE_CURLY:
      case COLON:
      case SEMICOLON:
      case CLOSE_PARENTHESES:
        {
          let controlChar = String.fromCharCode(code);
          currentToken = [controlChar, controlChar, pos];
          break;
        }
      case OPEN_PARENTHESES:
        {
          prev = buffer.length ? buffer.pop()[1] : '';
          n = css.charCodeAt(pos + 1);
          if (prev === 'url' && n !== SINGLE_QUOTE && n !== DOUBLE_QUOTE && n !== SPACE && n !== NEWLINE && n !== TAB && n !== FEED && n !== CR) {
            next = pos;
            do {
              escaped = false;
              next = css.indexOf(')', next + 1);
              if (next === -1) {
                if (ignore || ignoreUnclosed) {
                  next = pos;
                  break;
                } else {
                  unclosed('bracket');
                }
              }
              escapePos = next;
              while (css.charCodeAt(escapePos - 1) === BACKSLASH) {
                escapePos -= 1;
                escaped = !escaped;
              }
            } while (escaped);
            currentToken = ['brackets', css.slice(pos, next + 1), pos, next];
            pos = next;
          } else {
            next = css.indexOf(')', pos + 1);
            content = css.slice(pos, next + 1);
            if (next === -1 || RE_BAD_BRACKET.test(content)) {
              currentToken = ['(', '(', pos];
            } else {
              currentToken = ['brackets', content, pos, next];
              pos = next;
            }
          }
          break;
        }
      case SINGLE_QUOTE:
      case DOUBLE_QUOTE:
        {
          quote = code === SINGLE_QUOTE ? "'" : '"';
          next = pos;
          do {
            escaped = false;
            next = css.indexOf(quote, next + 1);
            if (next === -1) {
              if (ignore || ignoreUnclosed) {
                next = pos + 1;
                break;
              } else {
                unclosed('string');
              }
            }
            escapePos = next;
            while (css.charCodeAt(escapePos - 1) === BACKSLASH) {
              escapePos -= 1;
              escaped = !escaped;
            }
          } while (escaped);
          currentToken = ['string', css.slice(pos, next + 1), pos, next];
          pos = next;
          break;
        }
      case AT:
        {
          RE_AT_END.lastIndex = pos + 1;
          RE_AT_END.test(css);
          if (RE_AT_END.lastIndex === 0) {
            next = css.length - 1;
          } else {
            next = RE_AT_END.lastIndex - 2;
          }
          currentToken = ['at-word', css.slice(pos, next + 1), pos, next];
          pos = next;
          break;
        }
      case BACKSLASH:
        {
          next = pos;
          escape = true;
          while (css.charCodeAt(next + 1) === BACKSLASH) {
            next += 1;
            escape = !escape;
          }
          code = css.charCodeAt(next + 1);
          if (escape && code !== SLASH && code !== SPACE && code !== NEWLINE && code !== TAB && code !== CR && code !== FEED) {
            next += 1;
            if (RE_HEX_ESCAPE.test(css.charAt(next))) {
              while (RE_HEX_ESCAPE.test(css.charAt(next + 1))) {
                next += 1;
              }
              if (css.charCodeAt(next + 1) === SPACE) {
                next += 1;
              }
            }
          }
          currentToken = ['word', css.slice(pos, next + 1), pos, next];
          pos = next;
          break;
        }
      default:
        {
          if (code === SLASH && css.charCodeAt(pos + 1) === ASTERISK) {
            next = css.indexOf('*/', pos + 2) + 1;
            if (next === 0) {
              if (ignore || ignoreUnclosed) {
                next = css.length;
              } else {
                unclosed('comment');
              }
            }
            currentToken = ['comment', css.slice(pos, next + 1), pos, next];
            pos = next;
          } else {
            RE_WORD_END.lastIndex = pos + 1;
            RE_WORD_END.test(css);
            if (RE_WORD_END.lastIndex === 0) {
              next = css.length - 1;
            } else {
              next = RE_WORD_END.lastIndex - 2;
            }
            currentToken = ['word', css.slice(pos, next + 1), pos, next];
            buffer.push(currentToken);
            pos = next;
          }
          break;
        }
    }
    pos++;
    return currentToken;
  }
  function back(token) {
    returned.push(token);
  }
  return {
    back,
    endOfFile,
    nextToken,
    position
  };
};

/***/ }),

/***/ "./node_modules/postcss/lib/warn-once.js":
/*!***********************************************!*\
  !*** ./node_modules/postcss/lib/warn-once.js ***!
  \***********************************************/
/***/ ((module) => {

"use strict";
/* eslint-disable no-console */


let printed = {};
module.exports = function warnOnce(message) {
  if (printed[message]) return;
  printed[message] = true;
  if (typeof console !== 'undefined' && console.warn) {
    console.warn(message);
  }
};

/***/ }),

/***/ "./node_modules/postcss/lib/warning.js":
/*!*********************************************!*\
  !*** ./node_modules/postcss/lib/warning.js ***!
  \*********************************************/
/***/ ((module) => {

"use strict";


class Warning {
  constructor(text, opts = {}) {
    this.type = 'warning';
    this.text = text;
    if (opts.node && opts.node.source) {
      let range = opts.node.rangeBy(opts);
      this.line = range.start.line;
      this.column = range.start.column;
      this.endLine = range.end.line;
      this.endColumn = range.end.column;
    }
    for (let opt in opts) this[opt] = opts[opt];
  }
  toString() {
    if (this.node) {
      return this.node.error(this.text, {
        index: this.index,
        plugin: this.plugin,
        word: this.word
      }).message;
    }
    if (this.plugin) {
      return this.plugin + ': ' + this.text;
    }
    return this.text;
  }
}
module.exports = Warning;
Warning.default = Warning;

/***/ }),

/***/ "./node_modules/sanitize-html/index.js":
/*!*********************************************!*\
  !*** ./node_modules/sanitize-html/index.js ***!
  \*********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

const htmlparser = __webpack_require__(/*! htmlparser2 */ "./node_modules/htmlparser2/lib/index.js");
const escapeStringRegexp = __webpack_require__(/*! escape-string-regexp */ "./node_modules/escape-string-regexp/index.js");
const {
  isPlainObject
} = __webpack_require__(/*! is-plain-object */ "./node_modules/sanitize-html/node_modules/is-plain-object/dist/is-plain-object.js");
const deepmerge = __webpack_require__(/*! deepmerge */ "./node_modules/deepmerge/dist/cjs.js");
const parseSrcset = __webpack_require__(/*! parse-srcset */ "./node_modules/parse-srcset/src/parse-srcset.js");
const {
  parse: postcssParse
} = __webpack_require__(/*! postcss */ "./node_modules/postcss/lib/postcss.js");
// Tags that can conceivably represent stand-alone media.
const mediaTags = ['img', 'audio', 'video', 'picture', 'svg', 'object', 'map', 'iframe', 'embed'];
// Tags that are inherently vulnerable to being used in XSS attacks.
const vulnerableTags = ['script', 'style'];
function each(obj, cb) {
  if (obj) {
    Object.keys(obj).forEach(function (key) {
      cb(obj[key], key);
    });
  }
}

// Avoid false positives with .__proto__, .hasOwnProperty, etc.
function has(obj, key) {
  return {}.hasOwnProperty.call(obj, key);
}

// Returns those elements of `a` for which `cb(a)` returns truthy
function filter(a, cb) {
  const n = [];
  each(a, function (v) {
    if (cb(v)) {
      n.push(v);
    }
  });
  return n;
}
function isEmptyObject(obj) {
  for (const key in obj) {
    if (has(obj, key)) {
      return false;
    }
  }
  return true;
}
function stringifySrcset(parsedSrcset) {
  return parsedSrcset.map(function (part) {
    if (!part.url) {
      throw new Error('URL missing');
    }
    return part.url + (part.w ? ` ${part.w}w` : '') + (part.h ? ` ${part.h}h` : '') + (part.d ? ` ${part.d}x` : '');
  }).join(', ');
}
module.exports = sanitizeHtml;

// A valid attribute name.
// We use a tolerant definition based on the set of strings defined by
// html.spec.whatwg.org/multipage/parsing.html#before-attribute-name-state
// and html.spec.whatwg.org/multipage/parsing.html#attribute-name-state .
// The characters accepted are ones which can be appended to the attribute
// name buffer without triggering a parse error:
//   * unexpected-equals-sign-before-attribute-name
//   * unexpected-null-character
//   * unexpected-character-in-attribute-name
// We exclude the empty string because it's impossible to get to the after
// attribute name state with an empty attribute name buffer.
const VALID_HTML_ATTRIBUTE_NAME = /^[^\0\t\n\f\r /<=>]+$/;

// Ignore the _recursing flag; it's there for recursive
// invocation as a guard against this exploit:
// https://github.com/fb55/htmlparser2/issues/105

function sanitizeHtml(html, options, _recursing) {
  if (html == null) {
    return '';
  }
  if (typeof html === 'number') {
    html = html.toString();
  }
  let result = '';
  // Used for hot swapping the result variable with an empty string in order to "capture" the text written to it.
  let tempResult = '';
  function Frame(tag, attribs) {
    const that = this;
    this.tag = tag;
    this.attribs = attribs || {};
    this.tagPosition = result.length;
    this.text = ''; // Node inner text
    this.mediaChildren = [];
    this.updateParentNodeText = function () {
      if (stack.length) {
        const parentFrame = stack[stack.length - 1];
        parentFrame.text += that.text;
      }
    };
    this.updateParentNodeMediaChildren = function () {
      if (stack.length && mediaTags.includes(this.tag)) {
        const parentFrame = stack[stack.length - 1];
        parentFrame.mediaChildren.push(this.tag);
      }
    };
  }
  options = Object.assign({}, sanitizeHtml.defaults, options);
  options.parser = Object.assign({}, htmlParserDefaults, options.parser);
  const tagAllowed = function (name) {
    return options.allowedTags === false || (options.allowedTags || []).indexOf(name) > -1;
  };

  // vulnerableTags
  vulnerableTags.forEach(function (tag) {
    if (tagAllowed(tag) && !options.allowVulnerableTags) {
      console.warn(`\n\n⚠️ Your \`allowedTags\` option includes, \`${tag}\`, which is inherently\nvulnerable to XSS attacks. Please remove it from \`allowedTags\`.\nOr, to disable this warning, add the \`allowVulnerableTags\` option\nand ensure you are accounting for this risk.\n\n`);
    }
  });

  // Tags that contain something other than HTML, or where discarding
  // the text when the tag is disallowed makes sense for other reasons.
  // If we are not allowing these tags, we should drop their content too.
  // For other tags you would drop the tag but keep its content.
  const nonTextTagsArray = options.nonTextTags || ['script', 'style', 'textarea', 'option'];
  let allowedAttributesMap;
  let allowedAttributesGlobMap;
  if (options.allowedAttributes) {
    allowedAttributesMap = {};
    allowedAttributesGlobMap = {};
    each(options.allowedAttributes, function (attributes, tag) {
      allowedAttributesMap[tag] = [];
      const globRegex = [];
      attributes.forEach(function (obj) {
        if (typeof obj === 'string' && obj.indexOf('*') >= 0) {
          globRegex.push(escapeStringRegexp(obj).replace(/\\\*/g, '.*'));
        } else {
          allowedAttributesMap[tag].push(obj);
        }
      });
      if (globRegex.length) {
        allowedAttributesGlobMap[tag] = new RegExp('^(' + globRegex.join('|') + ')$');
      }
    });
  }
  const allowedClassesMap = {};
  const allowedClassesGlobMap = {};
  const allowedClassesRegexMap = {};
  each(options.allowedClasses, function (classes, tag) {
    // Implicitly allows the class attribute
    if (allowedAttributesMap) {
      if (!has(allowedAttributesMap, tag)) {
        allowedAttributesMap[tag] = [];
      }
      allowedAttributesMap[tag].push('class');
    }
    allowedClassesMap[tag] = classes;
    if (Array.isArray(classes)) {
      const globRegex = [];
      allowedClassesMap[tag] = [];
      allowedClassesRegexMap[tag] = [];
      classes.forEach(function (obj) {
        if (typeof obj === 'string' && obj.indexOf('*') >= 0) {
          globRegex.push(escapeStringRegexp(obj).replace(/\\\*/g, '.*'));
        } else if (obj instanceof RegExp) {
          allowedClassesRegexMap[tag].push(obj);
        } else {
          allowedClassesMap[tag].push(obj);
        }
      });
      if (globRegex.length) {
        allowedClassesGlobMap[tag] = new RegExp('^(' + globRegex.join('|') + ')$');
      }
    }
  });
  const transformTagsMap = {};
  let transformTagsAll;
  each(options.transformTags, function (transform, tag) {
    let transFun;
    if (typeof transform === 'function') {
      transFun = transform;
    } else if (typeof transform === 'string') {
      transFun = sanitizeHtml.simpleTransform(transform);
    }
    if (tag === '*') {
      transformTagsAll = transFun;
    } else {
      transformTagsMap[tag] = transFun;
    }
  });
  let depth;
  let stack;
  let skipMap;
  let transformMap;
  let skipText;
  let skipTextDepth;
  let addedText = false;
  initializeState();
  const parser = new htmlparser.Parser({
    onopentag: function (name, attribs) {
      // If `enforceHtmlBoundary` is `true` and this has found the opening
      // `html` tag, reset the state.
      if (options.enforceHtmlBoundary && name === 'html') {
        initializeState();
      }
      if (skipText) {
        skipTextDepth++;
        return;
      }
      const frame = new Frame(name, attribs);
      stack.push(frame);
      let skip = false;
      const hasText = !!frame.text;
      let transformedTag;
      if (has(transformTagsMap, name)) {
        transformedTag = transformTagsMap[name](name, attribs);
        frame.attribs = attribs = transformedTag.attribs;
        if (transformedTag.text !== undefined) {
          frame.innerText = transformedTag.text;
        }
        if (name !== transformedTag.tagName) {
          frame.name = name = transformedTag.tagName;
          transformMap[depth] = transformedTag.tagName;
        }
      }
      if (transformTagsAll) {
        transformedTag = transformTagsAll(name, attribs);
        frame.attribs = attribs = transformedTag.attribs;
        if (name !== transformedTag.tagName) {
          frame.name = name = transformedTag.tagName;
          transformMap[depth] = transformedTag.tagName;
        }
      }
      if (!tagAllowed(name) || options.disallowedTagsMode === 'recursiveEscape' && !isEmptyObject(skipMap) || options.nestingLimit != null && depth >= options.nestingLimit) {
        skip = true;
        skipMap[depth] = true;
        if (options.disallowedTagsMode === 'discard') {
          if (nonTextTagsArray.indexOf(name) !== -1) {
            skipText = true;
            skipTextDepth = 1;
          }
        }
        skipMap[depth] = true;
      }
      depth++;
      if (skip) {
        if (options.disallowedTagsMode === 'discard') {
          // We want the contents but not this tag
          return;
        }
        tempResult = result;
        result = '';
      }
      result += '<' + name;
      if (name === 'script') {
        if (options.allowedScriptHostnames || options.allowedScriptDomains) {
          frame.innerText = '';
        }
      }
      if (!allowedAttributesMap || has(allowedAttributesMap, name) || allowedAttributesMap['*']) {
        each(attribs, function (value, a) {
          if (!VALID_HTML_ATTRIBUTE_NAME.test(a)) {
            // This prevents part of an attribute name in the output from being
            // interpreted as the end of an attribute, or end of a tag.
            delete frame.attribs[a];
            return;
          }
          // If the value is empty, and this is a known non-boolean attribute, delete it
          // List taken from https://html.spec.whatwg.org/multipage/indices.html#attributes-3
          if (value === '' && (options.nonBooleanAttributes.includes(a) || options.nonBooleanAttributes.includes('*'))) {
            delete frame.attribs[a];
            return;
          }
          // check allowedAttributesMap for the element and attribute and modify the value
          // as necessary if there are specific values defined.
          let passedAllowedAttributesMapCheck = false;
          if (!allowedAttributesMap || has(allowedAttributesMap, name) && allowedAttributesMap[name].indexOf(a) !== -1 || allowedAttributesMap['*'] && allowedAttributesMap['*'].indexOf(a) !== -1 || has(allowedAttributesGlobMap, name) && allowedAttributesGlobMap[name].test(a) || allowedAttributesGlobMap['*'] && allowedAttributesGlobMap['*'].test(a)) {
            passedAllowedAttributesMapCheck = true;
          } else if (allowedAttributesMap && allowedAttributesMap[name]) {
            for (const o of allowedAttributesMap[name]) {
              if (isPlainObject(o) && o.name && o.name === a) {
                passedAllowedAttributesMapCheck = true;
                let newValue = '';
                if (o.multiple === true) {
                  // verify the values that are allowed
                  const splitStrArray = value.split(' ');
                  for (const s of splitStrArray) {
                    if (o.values.indexOf(s) !== -1) {
                      if (newValue === '') {
                        newValue = s;
                      } else {
                        newValue += ' ' + s;
                      }
                    }
                  }
                } else if (o.values.indexOf(value) >= 0) {
                  // verified an allowed value matches the entire attribute value
                  newValue = value;
                }
                value = newValue;
              }
            }
          }
          if (passedAllowedAttributesMapCheck) {
            if (options.allowedSchemesAppliedToAttributes.indexOf(a) !== -1) {
              if (naughtyHref(name, value)) {
                delete frame.attribs[a];
                return;
              }
            }
            if (name === 'script' && a === 'src') {
              let allowed = true;
              try {
                const parsed = parseUrl(value);
                if (options.allowedScriptHostnames || options.allowedScriptDomains) {
                  const allowedHostname = (options.allowedScriptHostnames || []).find(function (hostname) {
                    return hostname === parsed.url.hostname;
                  });
                  const allowedDomain = (options.allowedScriptDomains || []).find(function (domain) {
                    return parsed.url.hostname === domain || parsed.url.hostname.endsWith(`.${domain}`);
                  });
                  allowed = allowedHostname || allowedDomain;
                }
              } catch (e) {
                allowed = false;
              }
              if (!allowed) {
                delete frame.attribs[a];
                return;
              }
            }
            if (name === 'iframe' && a === 'src') {
              let allowed = true;
              try {
                const parsed = parseUrl(value);
                if (parsed.isRelativeUrl) {
                  // default value of allowIframeRelativeUrls is true
                  // unless allowedIframeHostnames or allowedIframeDomains specified
                  allowed = has(options, 'allowIframeRelativeUrls') ? options.allowIframeRelativeUrls : !options.allowedIframeHostnames && !options.allowedIframeDomains;
                } else if (options.allowedIframeHostnames || options.allowedIframeDomains) {
                  const allowedHostname = (options.allowedIframeHostnames || []).find(function (hostname) {
                    return hostname === parsed.url.hostname;
                  });
                  const allowedDomain = (options.allowedIframeDomains || []).find(function (domain) {
                    return parsed.url.hostname === domain || parsed.url.hostname.endsWith(`.${domain}`);
                  });
                  allowed = allowedHostname || allowedDomain;
                }
              } catch (e) {
                // Unparseable iframe src
                allowed = false;
              }
              if (!allowed) {
                delete frame.attribs[a];
                return;
              }
            }
            if (a === 'srcset') {
              try {
                let parsed = parseSrcset(value);
                parsed.forEach(function (value) {
                  if (naughtyHref('srcset', value.url)) {
                    value.evil = true;
                  }
                });
                parsed = filter(parsed, function (v) {
                  return !v.evil;
                });
                if (!parsed.length) {
                  delete frame.attribs[a];
                  return;
                } else {
                  value = stringifySrcset(filter(parsed, function (v) {
                    return !v.evil;
                  }));
                  frame.attribs[a] = value;
                }
              } catch (e) {
                // Unparseable srcset
                delete frame.attribs[a];
                return;
              }
            }
            if (a === 'class') {
              const allowedSpecificClasses = allowedClassesMap[name];
              const allowedWildcardClasses = allowedClassesMap['*'];
              const allowedSpecificClassesGlob = allowedClassesGlobMap[name];
              const allowedSpecificClassesRegex = allowedClassesRegexMap[name];
              const allowedWildcardClassesGlob = allowedClassesGlobMap['*'];
              const allowedClassesGlobs = [allowedSpecificClassesGlob, allowedWildcardClassesGlob].concat(allowedSpecificClassesRegex).filter(function (t) {
                return t;
              });
              if (allowedSpecificClasses && allowedWildcardClasses) {
                value = filterClasses(value, deepmerge(allowedSpecificClasses, allowedWildcardClasses), allowedClassesGlobs);
              } else {
                value = filterClasses(value, allowedSpecificClasses || allowedWildcardClasses, allowedClassesGlobs);
              }
              if (!value.length) {
                delete frame.attribs[a];
                return;
              }
            }
            if (a === 'style') {
              if (options.parseStyleAttributes) {
                try {
                  const abstractSyntaxTree = postcssParse(name + ' {' + value + '}');
                  const filteredAST = filterCss(abstractSyntaxTree, options.allowedStyles);
                  value = stringifyStyleAttributes(filteredAST);
                  if (value.length === 0) {
                    delete frame.attribs[a];
                    return;
                  }
                } catch (e) {
                  if (typeof window !== 'undefined') {
                    console.warn('Failed to parse "' + name + ' {' + value + '}' + '", If you\'re running this in a browser, we recommend to disable style parsing: options.parseStyleAttributes: false, since this only works in a node environment due to a postcss dependency, More info: https://github.com/apostrophecms/sanitize-html/issues/547');
                  }
                  delete frame.attribs[a];
                  return;
                }
              } else if (options.allowedStyles) {
                throw new Error('allowedStyles option cannot be used together with parseStyleAttributes: false.');
              }
            }
            result += ' ' + a;
            if (value && value.length) {
              result += '="' + escapeHtml(value, true) + '"';
            }
          } else {
            delete frame.attribs[a];
          }
        });
      }
      if (options.selfClosing.indexOf(name) !== -1) {
        result += ' />';
      } else {
        result += '>';
        if (frame.innerText && !hasText && !options.textFilter) {
          result += escapeHtml(frame.innerText);
          addedText = true;
        }
      }
      if (skip) {
        result = tempResult + escapeHtml(result);
        tempResult = '';
      }
    },
    ontext: function (text) {
      if (skipText) {
        return;
      }
      const lastFrame = stack[stack.length - 1];
      let tag;
      if (lastFrame) {
        tag = lastFrame.tag;
        // If inner text was set by transform function then let's use it
        text = lastFrame.innerText !== undefined ? lastFrame.innerText : text;
      }
      if (options.disallowedTagsMode === 'discard' && (tag === 'script' || tag === 'style')) {
        // htmlparser2 gives us these as-is. Escaping them ruins the content. Allowing
        // script tags is, by definition, game over for XSS protection, so if that's
        // your concern, don't allow them. The same is essentially true for style tags
        // which have their own collection of XSS vectors.
        result += text;
      } else {
        const escaped = escapeHtml(text, false);
        if (options.textFilter && !addedText) {
          result += options.textFilter(escaped, tag);
        } else if (!addedText) {
          result += escaped;
        }
      }
      if (stack.length) {
        const frame = stack[stack.length - 1];
        frame.text += text;
      }
    },
    onclosetag: function (name, isImplied) {
      if (skipText) {
        skipTextDepth--;
        if (!skipTextDepth) {
          skipText = false;
        } else {
          return;
        }
      }
      const frame = stack.pop();
      if (!frame) {
        // Do not crash on bad markup
        return;
      }
      if (frame.tag !== name) {
        // Another case of bad markup.
        // Push to stack, so that it will be used in future closing tags.
        stack.push(frame);
        return;
      }
      skipText = options.enforceHtmlBoundary ? name === 'html' : false;
      depth--;
      const skip = skipMap[depth];
      if (skip) {
        delete skipMap[depth];
        if (options.disallowedTagsMode === 'discard') {
          frame.updateParentNodeText();
          return;
        }
        tempResult = result;
        result = '';
      }
      if (transformMap[depth]) {
        name = transformMap[depth];
        delete transformMap[depth];
      }
      if (options.exclusiveFilter && options.exclusiveFilter(frame)) {
        result = result.substr(0, frame.tagPosition);
        return;
      }
      frame.updateParentNodeMediaChildren();
      frame.updateParentNodeText();
      if (
      // Already output />
      options.selfClosing.indexOf(name) !== -1 ||
      // Escaped tag, closing tag is implied
      isImplied && !tagAllowed(name) && ['escape', 'recursiveEscape'].indexOf(options.disallowedTagsMode) >= 0) {
        if (skip) {
          result = tempResult;
          tempResult = '';
        }
        return;
      }
      result += '</' + name + '>';
      if (skip) {
        result = tempResult + escapeHtml(result);
        tempResult = '';
      }
      addedText = false;
    }
  }, options.parser);
  parser.write(html);
  parser.end();
  return result;
  function initializeState() {
    result = '';
    depth = 0;
    stack = [];
    skipMap = {};
    transformMap = {};
    skipText = false;
    skipTextDepth = 0;
  }
  function escapeHtml(s, quote) {
    if (typeof s !== 'string') {
      s = s + '';
    }
    if (options.parser.decodeEntities) {
      s = s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      if (quote) {
        s = s.replace(/"/g, '&quot;');
      }
    }
    // this is inadequate because it will pass `&0;`. This approach
    // will not work, each & must be considered with regard to whether it
    // is followed by a 100% syntactically valid entity or not, and escaped
    // if it is not. If this bothers you, don't set parser.decodeEntities
    // to false. (The default is true.)
    s = s.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, '&amp;') // Match ampersands not part of existing HTML entity
    .replace(/</g, '&lt;').replace(/>/g, '&gt;');
    if (quote) {
      s = s.replace(/"/g, '&quot;');
    }
    return s;
  }
  function naughtyHref(name, href) {
    // Browsers ignore character codes of 32 (space) and below in a surprising
    // number of situations. Start reading here:
    // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet#Embedded_tab
    // eslint-disable-next-line no-control-regex
    href = href.replace(/[\x00-\x20]+/g, '');
    // Clobber any comments in URLs, which the browser might
    // interpret inside an XML data island, allowing
    // a javascript: URL to be snuck through
    while (true) {
      const firstIndex = href.indexOf('<!--');
      if (firstIndex === -1) {
        break;
      }
      const lastIndex = href.indexOf('-->', firstIndex + 4);
      if (lastIndex === -1) {
        break;
      }
      href = href.substring(0, firstIndex) + href.substring(lastIndex + 3);
    }
    // Case insensitive so we don't get faked out by JAVASCRIPT #1
    // Allow more characters after the first so we don't get faked
    // out by certain schemes browsers accept
    const matches = href.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
    if (!matches) {
      // Protocol-relative URL starting with any combination of '/' and '\'
      if (href.match(/^[/\\]{2}/)) {
        return !options.allowProtocolRelative;
      }

      // No scheme
      return false;
    }
    const scheme = matches[1].toLowerCase();
    if (has(options.allowedSchemesByTag, name)) {
      return options.allowedSchemesByTag[name].indexOf(scheme) === -1;
    }
    return !options.allowedSchemes || options.allowedSchemes.indexOf(scheme) === -1;
  }
  function parseUrl(value) {
    value = value.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, '$1//');
    if (value.startsWith('relative:')) {
      // An attempt to exploit our workaround for base URLs being
      // mandatory for relative URL validation in the WHATWG
      // URL parser, reject it
      throw new Error('relative: exploit attempt');
    }
    // naughtyHref is in charge of whether protocol relative URLs
    // are cool. Here we are concerned just with allowed hostnames and
    // whether to allow relative URLs.
    //
    // Build a placeholder "base URL" against which any reasonable
    // relative URL may be parsed successfully
    let base = 'relative://relative-site';
    for (let i = 0; i < 100; i++) {
      base += `/${i}`;
    }
    const parsed = new URL(value, base);
    const isRelativeUrl = parsed && parsed.hostname === 'relative-site' && parsed.protocol === 'relative:';
    return {
      isRelativeUrl,
      url: parsed
    };
  }
  /**
   * Filters user input css properties by allowlisted regex attributes.
   * Modifies the abstractSyntaxTree object.
   *
   * @param {object} abstractSyntaxTree  - Object representation of CSS attributes.
   * @property {array[Declaration]} abstractSyntaxTree.nodes[0] - Each object cointains prop and value key, i.e { prop: 'color', value: 'red' }.
   * @param {object} allowedStyles       - Keys are properties (i.e color), value is list of permitted regex rules (i.e /green/i).
   * @return {object}                    - The modified tree.
   */
  function filterCss(abstractSyntaxTree, allowedStyles) {
    if (!allowedStyles) {
      return abstractSyntaxTree;
    }
    const astRules = abstractSyntaxTree.nodes[0];
    let selectedRule;

    // Merge global and tag-specific styles into new AST.
    if (allowedStyles[astRules.selector] && allowedStyles['*']) {
      selectedRule = deepmerge(allowedStyles[astRules.selector], allowedStyles['*']);
    } else {
      selectedRule = allowedStyles[astRules.selector] || allowedStyles['*'];
    }
    if (selectedRule) {
      abstractSyntaxTree.nodes[0].nodes = astRules.nodes.reduce(filterDeclarations(selectedRule), []);
    }
    return abstractSyntaxTree;
  }

  /**
   * Extracts the style attributes from an AbstractSyntaxTree and formats those
   * values in the inline style attribute format.
   *
   * @param  {AbstractSyntaxTree} filteredAST
   * @return {string}             - Example: "color:yellow;text-align:center !important;font-family:helvetica;"
   */
  function stringifyStyleAttributes(filteredAST) {
    return filteredAST.nodes[0].nodes.reduce(function (extractedAttributes, attrObject) {
      extractedAttributes.push(`${attrObject.prop}:${attrObject.value}${attrObject.important ? ' !important' : ''}`);
      return extractedAttributes;
    }, []).join(';');
  }

  /**
    * Filters the existing attributes for the given property. Discards any attributes
    * which don't match the allowlist.
    *
    * @param  {object} selectedRule             - Example: { color: red, font-family: helvetica }
    * @param  {array} allowedDeclarationsList   - List of declarations which pass the allowlist.
    * @param  {object} attributeObject          - Object representing the current css property.
    * @property {string} attributeObject.type   - Typically 'declaration'.
    * @property {string} attributeObject.prop   - The CSS property, i.e 'color'.
    * @property {string} attributeObject.value  - The corresponding value to the css property, i.e 'red'.
    * @return {function}                        - When used in Array.reduce, will return an array of Declaration objects
    */
  function filterDeclarations(selectedRule) {
    return function (allowedDeclarationsList, attributeObject) {
      // If this property is allowlisted...
      if (has(selectedRule, attributeObject.prop)) {
        const matchesRegex = selectedRule[attributeObject.prop].some(function (regularExpression) {
          return regularExpression.test(attributeObject.value);
        });
        if (matchesRegex) {
          allowedDeclarationsList.push(attributeObject);
        }
      }
      return allowedDeclarationsList;
    };
  }
  function filterClasses(classes, allowed, allowedGlobs) {
    if (!allowed) {
      // The class attribute is allowed without filtering on this tag
      return classes;
    }
    classes = classes.split(/\s+/);
    return classes.filter(function (clss) {
      return allowed.indexOf(clss) !== -1 || allowedGlobs.some(function (glob) {
        return glob.test(clss);
      });
    }).join(' ');
  }
}

// Defaults are accessible to you so that you can use them as a starting point
// programmatically if you wish

const htmlParserDefaults = {
  decodeEntities: true
};
sanitizeHtml.defaults = {
  allowedTags: [
  // Sections derived from MDN element categories and limited to the more
  // benign categories.
  // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
  // Content sectioning
  'address', 'article', 'aside', 'footer', 'header', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hgroup', 'main', 'nav', 'section',
  // Text content
  'blockquote', 'dd', 'div', 'dl', 'dt', 'figcaption', 'figure', 'hr', 'li', 'main', 'ol', 'p', 'pre', 'ul',
  // Inline text semantics
  'a', 'abbr', 'b', 'bdi', 'bdo', 'br', 'cite', 'code', 'data', 'dfn', 'em', 'i', 'kbd', 'mark', 'q', 'rb', 'rp', 'rt', 'rtc', 'ruby', 's', 'samp', 'small', 'span', 'strong', 'sub', 'sup', 'time', 'u', 'var', 'wbr',
  // Table content
  'caption', 'col', 'colgroup', 'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'tr'],
  // Tags that cannot be boolean
  nonBooleanAttributes: ['abbr', 'accept', 'accept-charset', 'accesskey', 'action', 'allow', 'alt', 'as', 'autocapitalize', 'autocomplete', 'blocking', 'charset', 'cite', 'class', 'color', 'cols', 'colspan', 'content', 'contenteditable', 'coords', 'crossorigin', 'data', 'datetime', 'decoding', 'dir', 'dirname', 'download', 'draggable', 'enctype', 'enterkeyhint', 'fetchpriority', 'for', 'form', 'formaction', 'formenctype', 'formmethod', 'formtarget', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'http-equiv', 'id', 'imagesizes', 'imagesrcset', 'inputmode', 'integrity', 'is', 'itemid', 'itemprop', 'itemref', 'itemtype', 'kind', 'label', 'lang', 'list', 'loading', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'name', 'nonce', 'optimum', 'pattern', 'ping', 'placeholder', 'popover', 'popovertarget', 'popovertargetaction', 'poster', 'preload', 'referrerpolicy', 'rel', 'rows', 'rowspan', 'sandbox', 'scope', 'shape', 'size', 'sizes', 'slot', 'span', 'spellcheck', 'src', 'srcdoc', 'srclang', 'srcset', 'start', 'step', 'style', 'tabindex', 'target', 'title', 'translate', 'type', 'usemap', 'value', 'width', 'wrap',
  // Event handlers
  'onauxclick', 'onafterprint', 'onbeforematch', 'onbeforeprint', 'onbeforeunload', 'onbeforetoggle', 'onblur', 'oncancel', 'oncanplay', 'oncanplaythrough', 'onchange', 'onclick', 'onclose', 'oncontextlost', 'oncontextmenu', 'oncontextrestored', 'oncopy', 'oncuechange', 'oncut', 'ondblclick', 'ondrag', 'ondragend', 'ondragenter', 'ondragleave', 'ondragover', 'ondragstart', 'ondrop', 'ondurationchange', 'onemptied', 'onended', 'onerror', 'onfocus', 'onformdata', 'onhashchange', 'oninput', 'oninvalid', 'onkeydown', 'onkeypress', 'onkeyup', 'onlanguagechange', 'onload', 'onloadeddata', 'onloadedmetadata', 'onloadstart', 'onmessage', 'onmessageerror', 'onmousedown', 'onmouseenter', 'onmouseleave', 'onmousemove', 'onmouseout', 'onmouseover', 'onmouseup', 'onoffline', 'ononline', 'onpagehide', 'onpageshow', 'onpaste', 'onpause', 'onplay', 'onplaying', 'onpopstate', 'onprogress', 'onratechange', 'onreset', 'onresize', 'onrejectionhandled', 'onscroll', 'onscrollend', 'onsecuritypolicyviolation', 'onseeked', 'onseeking', 'onselect', 'onslotchange', 'onstalled', 'onstorage', 'onsubmit', 'onsuspend', 'ontimeupdate', 'ontoggle', 'onunhandledrejection', 'onunload', 'onvolumechange', 'onwaiting', 'onwheel'],
  disallowedTagsMode: 'discard',
  allowedAttributes: {
    a: ['href', 'name', 'target'],
    // We don't currently allow img itself by default, but
    // these attributes would make sense if we did.
    img: ['src', 'srcset', 'alt', 'title', 'width', 'height', 'loading']
  },
  // Lots of these won't come up by default because we don't allow them
  selfClosing: ['img', 'br', 'hr', 'area', 'base', 'basefont', 'input', 'link', 'meta'],
  // URL schemes we permit
  allowedSchemes: ['http', 'https', 'ftp', 'mailto', 'tel'],
  allowedSchemesByTag: {},
  allowedSchemesAppliedToAttributes: ['href', 'src', 'cite'],
  allowProtocolRelative: true,
  enforceHtmlBoundary: false,
  parseStyleAttributes: true
};
sanitizeHtml.simpleTransform = function (newTagName, newAttribs, merge) {
  merge = merge === undefined ? true : merge;
  newAttribs = newAttribs || {};
  return function (tagName, attribs) {
    let attrib;
    if (merge) {
      for (attrib in newAttribs) {
        attribs[attrib] = newAttribs[attrib];
      }
    } else {
      attribs = newAttribs;
    }
    return {
      tagName: newTagName,
      attribs: attribs
    };
  };
};

/***/ }),

/***/ "./node_modules/sanitize-html/node_modules/is-plain-object/dist/is-plain-object.js":
/*!*****************************************************************************************!*\
  !*** ./node_modules/sanitize-html/node_modules/is-plain-object/dist/is-plain-object.js ***!
  \*****************************************************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */

function isObject(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}
function isPlainObject(o) {
  var ctor, prot;
  if (isObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (ctor === undefined) return true;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
}
exports.isPlainObject = isPlainObject;

/***/ }),

/***/ "?5580":
/*!**************************************!*\
  !*** ./terminal-highlight (ignored) ***!
  \**************************************/
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ "?03fb":
/*!********************!*\
  !*** fs (ignored) ***!
  \********************/
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ "?6197":
/*!**********************!*\
  !*** path (ignored) ***!
  \**********************/
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ "?b8cb":
/*!*******************************!*\
  !*** source-map-js (ignored) ***!
  \*******************************/
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ "?c717":
/*!*********************!*\
  !*** url (ignored) ***!
  \*********************/
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ "./node_modules/nanoid/non-secure/index.cjs":
/*!**************************************************!*\
  !*** ./node_modules/nanoid/non-secure/index.cjs ***!
  \**************************************************/
/***/ ((module) => {

let urlAlphabet =
  'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict'
let customAlphabet = (alphabet, defaultSize = 21) => {
  return (size = defaultSize) => {
    let id = ''
    let i = size
    while (i--) {
      id += alphabet[(Math.random() * alphabet.length) | 0]
    }
    return id
  }
}
let nanoid = (size = 21) => {
  let id = ''
  let i = size
  while (i--) {
    id += urlAlphabet[(Math.random() * 64) | 0]
  }
  return id
}
module.exports = { nanoid, customAlphabet }


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! sanitize-html */ "./node_modules/sanitize-html/index.js");
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(sanitize_html__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (sanitize_html__WEBPACK_IMPORTED_MODULE_0__);
})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
},
'appivo/util/native/Camera':function(){
define([
	"dojo/_base/lang"
	], function(lang) {
	var wrapper = {
		_isSupported: false
	};
	var cordova = window.cordova;
	var navigator = window.navigator ? window.navigator : undefined;

	if (cordova && navigator && navigator.camera) {
		var camera = navigator.camera;
		var device = window.device;
		wrapper = {
			_isSupported: true,

			/**
			 * @LogicMeta {
			 * 		"api": "Camera@Native",
			 * 		"paramTypes": ["Object"],
			 *		"tooltip": "$"
			 * }
             */
			getPicture: function(args) {
				if (!args) {
					args = {
						options: {}
					};
				} else if (!args.options) {
					args.options = {};
				}
				var cameraOptions = {
					quality: 50,
					destinationType: Camera.DestinationType.DATA_URL,
					sourceType: Camera.PictureSourceType.CAMERA,
					allowEdit: true,
					encodingType: Camera.EncodingType.JPEG,
					targetWidth: undefined,
					targetHeight: undefined,
					mediaType: Camera.MediaType.PICTURE,
					correctOrientation: (device && device.platform == "Android"),
					saveToPhotoAlbum: false,
					cameraDirection: Camera.Direction.BACK
				};
				
				for (var opt in args.options) {
					if (cameraOptions[opt] && args.options[opt] != null && args.options[opt] != undefined) {
						cameraOptions[opt] = args.options[opt];
					}
				}
				if (device && device.platform == "Android") {
					cameraOptions.allowEdit = false; //Editing a photo can cause the camera plugin to crash on Android
					cameraOptions.cameraDirection = Camera.Direction.BACK; //Only back camera works on Android

					//Fixes an issue where callbacks would not be made because of the Android pipeline would get "clogged"
					setInterval(function () {
						cordova.exec(null, null, '', '', [])
					}, 200);
				}

				camera.getPicture(args.onSuccess, args.onError, cameraOptions);
			},
			PictureSourceType: Camera.PictureSourceType,
			MediaType: Camera.MediaType
		}
	}
	return wrapper;
});

},
'appivo/util/native/BackgroundMode':function(){
define([
	"dojo/_base/lang"
	], function(lang) {
	var wrapper = {
		_isSupported: false	
	};
	var cordova = window.cordova;
	
	if (cordova && cordova.plugins && cordova.plugins.backgroundMode) {
		var backgroundMode = cordova.plugins.backgroundMode;
		wrapper = {
			_isSupported: true,

			/**
			 * @LogicMeta {
			 * 		"api": "BackgroundMode@Native",
			 * 		"paramTypes": ["Object"],
			 *		"tooltip": "$"
			 * }
			 */
			enable: function(opts) {
				if (!opts) {
					opts = {};
				}
				backgroundMode.setDefaults({
					title: opts.title,
					ticker: opts.ticker,
					text: opts.text,
					resume: opts.resume != undefined && opts.resume != null ? opts.resume : true,
					silent: opts.silent
				});
				backgroundMode.enable();
			},

			/**
			 * @LogicMeta {
			 * 		"api": "BackgroundMode@Native",
			 *		"tooltip": "$"
			 * }
			 */
			disable: function() {
				backgroundMode.disable();
			},

			/**
			 * @LogicMeta {
			 * 		"api": "BackgroundMode@Native",
			 * 		"returnType": "boolean",
			 *		"tooltip": "$"
			 * }
			 */
			isActive: function() {
				return backgroundMode.isActive();
			},

			/**
			 * @LogicMeta {
			 * 		"api": "BackgroundMode@Native",
			 * 		"returnType": "boolean",
			 *		"tooltip": "$"
			 * }
			 */
			isEnabled: function() {
				return backgroundMode.isEnabled();
			},


			onActive: function(func) {
				if (lang.isFunction(func)) {
					backgroundMode.onactive(func);
				}
			},
			
			onDeactivate: function(func) {
				if (lang.isFunction(func)) {
					backgroundMode.ondeactivate(func);
				}
			},
			
			onFailure: function(func) {
				if (lang.isFunction(func)) {
					backgroundMode.onfailure(func);
				}
			},

			/**
			 * @LogicMeta {
			 * 		"api": "BackgroundMode@Native",
			 * 		"paramTypes": ["Object"],
			 *		"tooltip": "$"
			 * }
			 */
			configure: function(opts) {
				if (!opts) {
					opts = {};
				}
				backgroundMode.configure({
					title: opts.title,
					ticker: opts.ticker,
					text: opts.text,
					resume: opts.resume,
					silent: opts.silent
				});
			}
		};		
	}
	return wrapper;
});
},
'appivo/util/Holydays':function(){
define(["dojo/_base/lang", "dojo/date/stamp", "dojo/date/locale", "holydate/HolyDate", 'appivo/client/Client','moment/moment'], function(lang, stamp, locale, hd, client, moment) {
    return {
        hd: hd,
        locale: client.getInstance().getLocale(),
        setLocale: function (locale) {
            this.locale = locale;
            this._isInitiated = false;
        },
        getAll: function (year, locale) {
            this._beforeGet(locale);
            return this.hd.getAll(year);
        },
        get: function(date, locale){
            this._beforeGet(locale);
                return this.hd.get(moment(date).format('YYYY-MM-DD'));
        },
        dateToStr: function(date){
            return moment(date).format('YYYY-MM-DD');
        },
        _beforeGet: function (locale) {
            if(locale){
                this.setLocale(locale);
            }
            if (!this._isInitiated){
                this._setHolidays();
            }
        },
        _isInitiated: false,
        _setHolidays: function(locale){

            if (this.locale == "sv"){
                var hd = this.hd;
                // Högtidsdagar på fasta datum
                hd.set('Nyårsdagen').date().month(1).day(1).red();
                //hd.set('Trettondagsafton').date().month(1).day(5);
                hd.set('Trettondedag jul').date().month(1).day(6).red();
                //hd.set('Alla hjärtans dag').date().month(2).day(14);
                //hd.set('Valborgsmässoafton').date().month(4).day(30);
                hd.set('Första maj').date().month(5).day(1).red();
                hd.set('Sveriges nationaldag').date().month(6).day(6).red();
                hd.set('Julafton').date().month(12).day(24).red();
                hd.set('Juldagen').date().month(12).day(25).red();
                hd.set('Annandag jul').date().month(12).day(26).red();
                hd.set('Nyårsafton').date().month(12).day(31).red();
                // Högtidsdagar relaterade till påskdagen
                //hd.set('Fettisdagen').easter().offset(-47);
                //hd.set('Askonsdagen').easter().offset(-46);
                //hd.set('Palmsöndagen').easter().offset(-7);
                //hd.set('Dymmelonsdagen').easter().offset(-4);
                //hd.set('Skärtorsdagen').easter().offset(-3);
                hd.set('Långfredagen').easter().offset(-2).red();
                hd.set('Påskafton').easter().offset(-1).red();
                hd.set('Påskdagen').easter().offset(0).red();
                hd.set('Annandag påsk').easter().offset(1).red();
                hd.set('Kristi himmelfärdsdag').easter().offset(39).red();
                //hd.set('Pingstafton').easter().offset(48);
                hd.set('Pingstdagen').easter().offset(49).red();
                // Högtidsdagar på fasta veckodagar, med rörliga datum
                //hd.set('Jungfru Marie bebådelsedag').weekday(7).month(3).day(22);
                //hd.set('Mors dag').weekday(7).month(5).day(1).last();
                hd.set('Midsommarafton').weekday(5).month(6).day(19).red();
                hd.set('Midsommarafton').weekday(6).month(6).day(20).red();
                //hd.set('Allhelgonaafton').weekday(5).month(10).day(30);
                hd.set('Alla helgons dag').weekday(6).month(10).day(31).red();
                //hd.set('Fars dag').weekday(7).month(11).day(1).interval(2);
                //hd.set('Första advent').weekday(7).month(11).day(27);
                //hd.set('Andra advent').weekday(7).month(12).day(4);
                //hd.set('Tredje advent').weekday(7).month(12).day(11);
                //hd.set('Fjärde advent').weekday(7).month(12).day(18);
            }
            this._isInitiated = true;
        }
    }
});
},
'holydate/HolyDate':function(){
/**
* Based on HolyDate.js https://github.com/jop-io/holydate.js
*/

(function(factory) {
	if (typeof define === 'function' && define.amd) {
		define(['moment/moment'], factory);
	}
	else if (typeof exports === 'object') { // Node/CommonJS
		module.exports = factory();
	}
	else {
		factory();
	}
})(function(moment) {
    return {
        register: {},
        index: '',
        isNum: function(num) {
            return !isNaN(parseFloat(num)) && isFinite(num);
        },
        strToTime: function(date) {
            var regex = [
                ['YMD', /^([0-9]{4})(\W?)(0[1-9]|1[0-2])(\W?)(0[1-9]|[1-2][0-9]|3[0-1])$/],
                ['YDM', /^([0-9]{4})(\W?)(0[1-9]|[1-2][0-9]|3[0-1])(\W?)(0[1-9]|1[0-2])$/],
                ['MDY', /^(0[1-9]|1[0-2])(\W?)(0[1-9]|[1-2][0-9]|3[0-1])(\W?)([0-9]{4})$/],
                ['DMY', /^(0[1-9]|[1-2][0-9]|3[0-1])(\W?)(0[1-9]|1[0-2])(\W?)([0-9]{4})$/]
            ];
            for (var i in regex) {
                var res = date.match(regex[i][1]), y, m, d;
                if (res) {
                    switch (regex[i][0]) {
                        case 'YMD': y = parseInt(res[1],10), m = parseInt(res[3],10), d = parseInt(res[5],10); break;
                        case 'YDM': y = parseInt(res[1],10), m = parseInt(res[5],10), d = parseInt(res[3],10); break;
                        case 'MDY': y = parseInt(res[5],10), m = parseInt(res[1],10), d = parseInt(res[3],10); break;
                        case 'DMY': y = parseInt(res[5],10), m = parseInt(res[3],10), d = parseInt(res[1],10); break;
                    }
                    return new Date(y, m-1, d).getTime();
                }
            }
            return false;
        },
        /**
         * Sätter ett datum till typen 'date'.
         *
         * Används för dagar som infaller på fasta datum, tex. Julafton, Nationaldagen
         * och Första maj.
         *
         * @returns {Holydate.prototype}
         */
        date: function() {
            this.register[this.index].type = 'date';
            return this;
        },
        /**
         * Sätter ett datum till typen 'weekday' och en viss veckodag.
         *
         * Används för dagar som infaller på fasta veckodagar och variabla datum, tex.
         * Midsommarafton, Alla helgons dag och Första advent.
         *
         * @param {type} weekday
         * @returns {undefined|Holydate.prototype}
         */
         weekday: function(weekday) {
             weekday = parseInt(weekday, 10);
             if (!this.isNum(weekday) || weekday < 1) {
                 console.error('Invalid weekday number provided, must be an integer 1 (monday) to 7 (sunday)');
                 return;
             }
             this.register[this.index].type = 'weekday';
             this.register[this.index].weekday = weekday;
             return this;
         },
         /**
          * Sätter ett datum till typen 'easter'.
          *
          * Används för dagar som är relativa till infallande av påskdagen, tex.
          * Långfredagen, Pingstdagen och Kristi himmelfärdsdag.
          *
          * @returns {Holydate.prototype}
          */
          easter: function() {
              this.register[this.index].type = 'easter';
              return this;
          },
          /**
           * Sätter månadsnummer för en dag/datum.
           *
           * @param {Number} month Månadens nummer (1=jan ... 12=dec)
           * @returns {undefined|Holydate.prototype}
           */
          month: function(month) {
              month = parseInt(month, 10);
              if (!this.isNum(month) || month < 1 || month > 12) {
                  console.error('Invalid month provided, must be an integer 1 to 12');
                  return;
              }
              this.register[this.index].month = month;
              return this;
          },
          /**
           * Sätter dagsnummer för en dag/datum.
           *
           * @param {Number} day Dagens nummer (1 ... 31)
           * @returns {Holydate.prototype|undefined}
           */
          day: function(day) {
              day = parseInt(day, 10);
              if (!this.isNum(day) || day < 1 || day > 31) {
                  console.error('Invalid day number provided, must be an integer 1 to 31');
                  return;
              }
              this.register[this.index].day = day;
              return this;
          },
          /**
           * Sätter att den första veckodagen som matchar .weekday(num) ska retuneras.
           *
           * @returns {Holydate.prototype}
           */
          first: function() {
              this.register[this.index].occurrence = 'first';
              return this;
          },
          /**
           * Sätter att den sista veckodagen som matchar .weekday(num) ska retuneras.
           *
           * @returns {Holydate.prototype}
           */
          last: function() {
              this.register[this.index].occurrence = 'last';
              return this;
          },
          /**
           * Sätter ett interval av antal veckor i fram i tiden, i vilken en veckodag ska
           * inträffa.
           *
           * @param {Number} interval Antal veckor (fram i tiden)
           * @returns {Holydate.prototype|undefined}
           */
          interval: function(interval) {
              interval = parseInt(interval, 10);
              if (!this.isNum(interval) || interval < 1) {
                  console.error('Invalid interval provided, must be an integer 1 or greater');
                  return;
              }
              this.register[this.index].interval = interval;
              return this;
          },
          /**
           * Sätter antal avvikande dagar (postivt eller negativt) som ett datum ska
           * avvika ifrån påskdagen.
           *
           * @param {Number} offset Antal dagar (+/-)
           * @returns {undefined|Holydate.prototype}
           */
          offset: function(offset) {
              offset = parseInt(offset, 10);
              if (!this.isNum(offset)) {
                  console.error('Invalid offset number provided, must be an integer');
                  return;
              }
              this.register[this.index].offset = offset;
              return this;
          },
          /**
           * Sätter en högtidsdag till röd helgdag.
           *
           * @returns {Holydate.prototype}
           */
          red: function() {
              this.register[this.index].red = true;
              return this;
          },
          /**
           * Beräkar en tidsstämpel för ett fast datum.
           *
           * @param {String} index Namn på dagen
           * @param {Object} item Registrerat datum som ska beräknas (månad, dag)
           * @param {Number} ts Tidsstämpel för datum som ska beräknas (år)
           * @returns {Number} Beräknad tidsstämpel då datumet infaller
           */
          calcDate: function(index, item, ts) {
              if (!item.month) {
                  console.error('Required month is missing for \''+index+'\', try adding .month(int)');
              } else if (!item.day) {
                  console.error('Required day is missing for \''+index+'\', try adding .day(int)');
              }
              var now = new Date(ts);
              return new Date(now.getFullYear(), item.month-1, item.day).getTime();
          },
          /**
           * Beräknar en tidsstämpel för infallande av påskdagen. Avvikande dagar från
           * påskdagen tas med i beräkningen. Avvikande dagar sätts med funktionen
           * offset().
           *
           * @param {Object} item Registrerat datum som ska beräknas (offset)
           * @param {Number} ts Tidsstämpel för datum som ska beräknas (år)
           * @returns {Number} Beräknad tidsstämpel då datumet infaller
           */
          calcEaster: function(item, ts) {
              if (!this.isNum(item.offset)) {
                  item.offset = 0;
              }
              var year = new Date(ts).getFullYear();
              var a = year % 19,
              b = Math.floor(year / 100),
              c = year % 100,
              d = Math.floor(b / 4),
              e = b % 4,
              f = Math.floor((b + 8) / 25),
              g = Math.floor((b - f + 1) / 3),
              h = (((19*a) + (b - d - g)) + 15) % 30,
              i = Math.floor(c / 4),
              k = c % 4,
              L = (32 + (2*e) + (2*i) - h - k) % 7,
              m = Math.floor((a + (11*h) + (22*L)) / 451),
              M = Math.floor((h + L - (7*m) + 114) / 31),
              D = ((h + L - (7*m) + 114) % 31) + 1;
              return new Date(year, M-1, (D+item.offset)).getTime();
          },
          /**
           * Beräkar en tidsstämpel för när en viss veckodag infaller, ut ifrån givna
           * avgränsningar. Avgränsningar sätts med funktionerna .weekday(), .month(),
           * .day(), .interval(), .first() och .last()
           *
           * @param {String} index Namn på dagen
           * @param {Object} item Registrerat datum som ska beräknas (weekday, month, day, interval, occurrence)
           * @param {Number} ts Tidsstämpel för datum som ska beräknas (månad, dag)
           * @returns {Number|undefined} Beräknad tidsstämpel då datumet infaller, om en dag hittades
           */
          calcWeekday: function(index, item, ts, getAll) {
              if (!this.isNum(item.month)) {
                  console.error('Required month is missing for \''+index+'\', try adding .month(int)');
              }
              item.day        = this.isNum(item.day) ? item.day : 1;
              item.occurrence = ['first','last'].indexOf(item.occurrence) > -1 ? item.occurrence : 'first';
              item.interval   = this.isNum(item.interval) ? item.interval : 1;

              var i, date, weekday;
              var in_date    = new Date(ts);
              var start_date = new Date(in_date.getFullYear(), item.month-1, (item.occurrence === 'first' ? item.day : 1));

              if (item.occurrence === 'first') {
                  var end_date = new Date(start_date.getTime()+(7*item.interval*86400000)),
                      occurrences = 0;
                  for (i = start_date.getTime(); i <= end_date.getTime(); i += 86400000) {
                      date = new Date(i);
                      weekday = date.getDay() === 0 ? 7 : date.getDay();
                      occurrences += weekday === item.weekday ? 1 : 0;
                      if (((in_date.getMonth() === date.getMonth() && in_date.getDate() === date.getDate()) || getAll) && weekday === item.weekday && occurrences === item.interval) {
                          return i;
                      }
                  }
              } else if (item.occurrence === 'last') {
                  var last_day = new Date(start_date.getFullYear(), start_date.getMonth()+1, 0),
                      end_date = new Date(last_day.getTime());
                  var last_occurrence;
                  for (i = start_date.getTime(); i <= end_date.getTime(); i += 86400000) {
                      date = new Date(i);
                      weekday = date.getDay() === 0 ? 7 : date.getDay();
                      last_occurrence = weekday === item.weekday ? date.getTime() : last_occurrence;
                      if (in_date.getMonth() === date.getMonth() && in_date.getDate() === date.getDate() && weekday === item.weekday) {
                          return last_occurrence;
                      }
                  }
              }

              return;
          },
          /**
           * Sätter namn på en dag/datum.
           *
           * @param {type} name Namn på dagen
           * @returns {Holydate.prototype|undefined}
           */
          set: function(name) {
              if (typeof name !== 'string' || name === '') {
                  console.error('Invalid name provided, must be a string');
                  return;
              }
              this.index = name;
              if (!this.register[name]) {
                  this.register[name] = {
                      type: null,
                      weekday: null,
                      interval: null,
                      month: null,
                      day: null,
                      occurrence: null,
                      offset: null,
                      red : false
                  };
              }
              return this;
          },
          /**
          * Hämtar alla högtider för ett specifikt år
          *
          * @param {type} year valt år, defaultar till nuvarande år
          * @returns {Holydate.prototype|undefined}
          */
          getAll: function(year) {
              if (!year) {
                  year = new Date().getFullYear();
              }
              var date = year + "-01-01";
              var ts = this.strToTime(date), index, item, result = {};
              if (!ts) {
                  console.error('Provided year \'' + year + '\' is invalid');
                  return;
              }
              for (index in this.register) {
                  item = this.register[index];
                  var res = null;
                  if (item.type === 'date') {
                      res = this.calcDate(index, item, ts, true);
                  }
                  if (item.type === 'weekday') {
                      res = this.calcWeekday(index, item, ts, true);
                  }
                  if (item.type === 'easter') {
                      res = this.calcEaster(item, ts, true);
                  }
                  if (res){
                      res = moment(new Date(res)).format('YYYY-MM-DD');
                      if (!result[res]){
                          result[res] = new Array();
                      }
                      result[res].push({name:index, red: item.red});
                  }
              }
              result[year + "-12-31"] = this.get(year +"-12-31");
              return result;
          },
          /**
           * Hämtar namn på dag (ett eller flera) för ett angivet datum.
           *
           * @param {type} date Datumsträng
           * @returns {Array|null|undefined} Array med namn på de dagar som matchar angivet datum
           */
          get: function(date) {

              var ts = this.strToTime(date), index, item, result = [];
              if (!ts) {
                  console.error('Provided date \''+date+'\' is invalid');
                  return;
              }
              for (index in this.register) {
                  item = this.register[index];
                  if (item.type === 'date' && ts === this.calcDate(index, item, ts)) {
                      result.push({name: index, red: item.red});
                  }
                  if (item.type === 'weekday' && ts === this.calcWeekday(index, item, ts)) {
                      result.push({name: index, red: item.red});
                  }
                  if (item.type === 'easter' && ts === this.calcEaster(item, ts)) {
                      result.push({name: index, red: item.red});
                  }
              }
              return result.length > 0 ? result : null;
          }
    }
});
},
'appivo/util/CommunicationBus':function(){
/**
 * A lightweight message bus factory module for component communication
 * Implements publish/subscribe pattern with topic filtering and priority
 * Supports creating multiple independent bus instances
 */
define([], function() {
    'use strict';

    /**
     * Creates a new message bus instance
     * @param {object} [options] - Optional configuration for the bus instance
     * @param {string} [options.name] - Name for this bus instance (for debugging)
     * @return {object} A new message bus instance
     */
    function createBus(options) {
        options = options || {};

        // Private properties for this instance
        var topics = {};           // Storage for topics and their subscribers
        var lastMessageByTopic = {}; // Cache of last message sent to each topic
        var patterns = [];          // Storage for topic patterns
        var busName = options.name || 'bus_' + generateId();

        /**
         * Subscribe to a topic
         * @param {string} topic - The topic to subscribe to
         * @param {function} callback - Function to be called when a message is published to this topic
         * @param {object} [options] - Optional configuration
         * @param {number} [options.priority=0] - Priority of the subscriber (higher numbers = higher priority)
         * @param {boolean} [options.receiveLastMessage=false] - Whether to immediately receive the last message
         * @return {object} Subscription handle used for unsubscribing
         */
        function subscribe(topic, callback, options) {
            if (typeof topic !== 'string' || typeof callback !== 'function') {
                throw new Error('Invalid parameters. Topic must be a string and callback must be a function.');
            }

            options = options || {};
            var priority = options.priority || 0;
            var receiveLastMessage = options.receiveLastMessage || false;

            // Create topic if it doesn't exist
            if (!topics[topic]) {
                topics[topic] = [];
                // Notify pattern subscriptions about new topic
                handleNewTopic(topic);
            }

            // Create subscriber object
            var subscriber = {
                callback: callback,
                priority: priority,
                id: generateId()
            };

            // Add subscriber to topic, sorted by priority (highest first)
            topics[topic].push(subscriber);
            topics[topic].sort(function(a, b) {
                return b.priority - a.priority;
            });

            // Send last message if requested and exists
            if (receiveLastMessage && topic in lastMessageByTopic) {
                setTimeout(function() {
                    callback(lastMessageByTopic[topic]);
                }, 0);
            }

            // Return subscription handle
            return {
                topic: topic,
                id: subscriber.id,
                unsubscribe: function() {
                    unsubscribe(topic, subscriber.id);
                }
            };
        }

        /**
         * Unsubscribe from a topic
         * @param {string} topic - The topic to unsubscribe from
         * @param {string} id - The ID of the subscription to remove
         * @return {boolean} True if unsubscribe was successful, false otherwise
         */
        function unsubscribe(topic, id) {
            if (!topics[topic]) {
                return false;
            }

            var initialLength = topics[topic].length;
            topics[topic] = topics[topic].filter(function(subscriber) {
                return subscriber.id !== id;
            });

            // Clean up empty topics
            if (topics[topic].length === 0) {
                delete topics[topic];
            }

            return topics[topic].length < initialLength;
        }

        /**
         * Publish a message to a topic
         * @param {string} topic - The topic to publish to
         * @param {*} message - The message to publish (can be any type)
         * @param {object} [options] - Optional configuration
         * @param {boolean} [options.retain=false] - Whether to store this message for future subscribers
         * @return {number} Number of subscribers that received the message
         */
        function publish(topic, message, options) {
            if (typeof topic !== 'string') {
                throw new Error('Topic must be a string.');
            }

            options = options || {};
            var retain = options.retain || false;

            // If topic doesn't exist, create it (useful for retained messages)
            if (!topics[topic]) {
                topics[topic] = [];
                handleNewTopic(topic);
            }

            // Store message if retain is true
            if (retain) {
                lastMessageByTopic[topic] = message;
            }

            // Notify subscribers
            var subscriberCount = 0;
            topics[topic].forEach(function(subscriber) {
                try {
                    // Use setTimeout to ensure asynchronous execution
                    setTimeout(function() {
                        subscriber.callback(message);
                    }, 0);
                    subscriberCount++;
                } catch (e) {
                    console.error(busName + ': Error in subscriber callback:', e);
                }
            });

            return subscriberCount;
        }

        /**
         * Clear all subscribers for a topic or all topics
         * @param {string} [topic] - The topic to clear. If omitted, all topics are cleared.
         * @return {boolean} True if the operation was successful
         */
        function clear(topic) {
            if (topic) {
                delete topics[topic];
                delete lastMessageByTopic[topic];
                return true;
            } else {
                topics = {};
                lastMessageByTopic = {};
                patterns = [];
                return true;
            }
        }

        /**
         * Get the number of subscribers for a topic or all topics
         * @param {string} [topic] - The topic to count subscribers for. If omitted, counts all subscribers.
         * @return {number} Number of subscribers
         */
        function countSubscribers(topic) {
            if (topic) {
                return topics[topic] ? topics[topic].length : 0;
            } else {
                var count = 0;
                for (var t in topics) {
                    if (topics.hasOwnProperty(t)) {
                        count += topics[t].length;
                    }
                }
                return count;
            }
        }

        /**
         * Generate a unique ID for subscribers
         * @private
         * @return {string} Unique ID
         */
        function generateId() {
            return Math.random().toString(36).substr(2, 9);
        }

        /**
         * Add wildcard support for topic matching
         * @param {string} pattern - The topic pattern to match (can include *)
         * @param {function} callback - Function to be called when a message is published to a matching topic
         * @param {object} [options] - Same options as subscribe
         * @return {object} Subscription handle with multiple subscriptions
         */
        function subscribePattern(pattern, callback, options) {
            // Escape special characters except *
            var regexPattern = pattern.replace(/[-[\]{}()+?.,\\^$|#\s]/g, '\\$&')
                    // Replace * with regex pattern for any characters
                    .replace(/\*/g, '.*');

            var regex = new RegExp('^' + regexPattern + '$');
            var subscriptions = [];

            // Subscribe to all existing matching topics
            for (var topic in topics) {
                if (topics.hasOwnProperty(topic) && regex.test(topic)) {
                    subscriptions.push(subscribe(topic, callback, options));
                }
            }

            // Store pattern for future topic matching
            var patternSubscription = {
                pattern: pattern,
                regex: regex,
                callback: callback,
                options: options,
                subscriptions: subscriptions,
                unsubscribe: function() {
                    subscriptions.forEach(function(subscription) {
                        subscription.unsubscribe();
                    });
                    var patternIndex = patterns.indexOf(patternSubscription);
                    if (patternIndex !== -1) {
                        patterns.splice(patternIndex, 1);
                    }
                }
            };

            patterns.push(patternSubscription);
            return patternSubscription;
        }

        /**
         * Handle new topic creation for pattern matching
         * @private
         * @param {string} topic - Newly created topic
         */
        function handleNewTopic(topic) {
            patterns.forEach(function(patternSub) {
                if (patternSub.regex.test(topic)) {
                    var subscription = subscribe(topic, patternSub.callback, patternSub.options);
                    patternSub.subscriptions.push(subscription);
                }
            });
        }

        /**
         * Get debugging information about this bus instance
         * @return {object} Debug information
         */
        function getDebugInfo() {
            var topicList = Object.keys(topics);
            var retainedTopics = Object.keys(lastMessageByTopic);
            var patternList = patterns.map(function(p) {
                return p.pattern;
            });

            return {
                name: busName,
                topics: topicList,
                topicCount: topicList.length,
                subscriberCount: countSubscribers(),
                retainedTopics: retainedTopics,
                retainedTopicCount: retainedTopics.length,
                patterns: patternList,
                patternCount: patternList.length
            };
        }

        // Public API for this instance
        return {
            name: busName,
            subscribe: subscribe,
            unsubscribe: unsubscribe,
            publish: publish,
            clear: clear,
            countSubscribers: countSubscribers,
            subscribePattern: subscribePattern,
            getDebugInfo: getDebugInfo
        };
    }

    // Create a default bus instance for backward compatibility
    var defaultBus = createBus({ name: 'default' });

    // Public API of the module
    return {
        // Factory method to create new bus instances
        createBus: createBus,

        // Access to the default bus
        defaultBus: defaultBus
    };
});
},
'appivo/mvc/audio/AudioPlayer':function(){
define(['appivo/client/Client'], function(Client) {

    const client = Client.getInstance();

    class AudioPlayer {
        constructor() {
            this.audio = null;
            this._isPlaying = false;
            this.blobUrl = null;
            this.blob = null;

            this.init();
        }

        init() {
            // Create audio element
            this.audio = new Audio();
            this.setupEventListeners();
            this.setupiOSAudioContext();
        }

        setupEventListeners() {
            // Audio element event listeners
            this.audio.addEventListener('canplaythrough', () => {

            });

            this.audio.addEventListener('playing', () => {
                this._isPlaying = true;
            });

            this.audio.addEventListener('pause', () => {
                this._isPlaying = false;
            });

            this.audio.addEventListener('ended', () => {
                this._isPlaying = false;
            });

            this.audio.addEventListener('error', (e) => {
            });
        }

        setupiOSAudioContext() {
            // Initialize AudioContext on first touch (for iOS)
            document.addEventListener('touchstart', () => {
                const AudioContext = window.AudioContext || window.webkitAudioContext;
                if (AudioContext) {
                    const audioContext = new AudioContext();
                    audioContext.resume();
                }
            }, {once: true});
        }

        async fetchAudioBlob(url, body = null) {
            try {
                const options = {
                    method: 'POST',
                    contentType: 'application/json',
                    handleAs: 'blob',
                };

                if (body) {
                    if (body instanceof FormData) {
                        options.data = body;
                    } else {
                        options.data = JSON.stringify(body);
                    }
                } else {
                    options.method = "GET";
                }

                const blob = await client.sendRequest('/api/text-to-speech', options);

                return blob;
            } catch (error) {
                this.handleError(`Failed to fetch audio: ${error.message}`);
                throw error;
            }
        }

        getAudioBlobURL() {
            return this.blobUrl;
        }

        getAudioBlob() {
            return this.blob;
        }

        isPlaying() {
            return this._isPlaying;
        }

        async loadAudio(url, body = null) {
            try {
                // Cleanup previous blob URL if it exists
                if (this.blobUrl) {
                    URL.revokeObjectURL(this.blobUrl);
                    this.blobUrl = null;
                    this.blob = null;
                }

                // Reset audio element
                if (this.audio) {
                    this.audio.pause();
                    this.audio.currentTime = 0;
                }

                let audioUrl = url;
                if (body) {
                    // Fetch new blob
                    this.blob = await this.fetchAudioBlob(url, body);

                    // Create new blob URL
                    this.blobUrl = URL.createObjectURL(this.blob);
                    audioUrl = this.blobUrl;
                }

                // Set new source
                this.audio.src = audioUrl;

                // Important for iOS
                this.audio.load();

            } catch (error) {
                this.handleError('Error loading audio file');
                throw error;
            }
        }

        async play() {
            if (!this.audio.src) {
                await this.loadAudio();
            }

            if (!this._isPlaying) {
                this.audio.load();

                const playPromise = this.audio.play();
                if (playPromise !== undefined) {
                    await playPromise;
                }
            }
        }

        async pause() {
            if (this._isPlaying) {
                await this.audio.pause();
            }
        }

        async togglePlay() {
            if (!this.audio.src) {
                await this.loadAudio();
            }

            try {
                if (this._isPlaying) {
                    await this.audio.pause();
                } else {
                    // Important for iOS: explicitly load before playing
                    this.audio.load();

                    const playPromise = this.audio.play();
                    if (playPromise !== undefined) {
                        await playPromise;
                    }
                }
            } catch (error) {
                this.handleError('Error playing audio');
            }
        }

        showLoading() {

        }

        handleError(message) {
            console.error(message);
        }

        cleanup() {
            // Cleanup blob URL
            if (this.blobUrl) {
                URL.revokeObjectURL(this.blobUrl);
                this.blobUrl = null;
                this.blob = null;
            }

            // Stop audio
            if (this.audio) {
                this.audio.pause();
                this.audio.src = '';
            }
        }
    }

    return AudioPlayer;
});
},
'appivo/mvc/audio/AudioRecorder':function(){
define(['appivo/client/Client'], function(Client) {

    class AudioRecorder {
        constructor() {
            this.audioContext = null;
            this.mediaStream = null;
            this.mediaRecorder = null;
            this.audioChunks = [];
            this.isRecording = false;
            this.recordingData = [];
            this.workletNode = null;
        }

        async initialize() {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
                this.mediaStream = stream;
                this.audioContext = new (window.AudioContext || window.webkitAudioContext)();

                // Check if MediaRecorder is supported
                if (typeof MediaRecorder !== 'undefined' && MediaRecorder.isTypeSupported('audio/webm')) {
                    this.initializeMediaRecorder(stream);
                } else {
                    // Fallback for iOS Safari using Web Audio API with AudioWorklet
                    await this.initializeWebAudioRecorder(stream);
                }
                return true;
            } catch (error) {
                console.error('Error initializing audio recorder:', error);
                throw error;
            }
        }

        createWorkletBlob() {
            const workletCode = `
            class RecorderWorklet extends AudioWorkletProcessor {
                constructor() {
                    super();
                    this._recordingState = false;
                    this.port.onmessage = (event) => {
                        if (event.data.command === 'start') {
                            this._recordingState = true;
                        } else if (event.data.command === 'stop') {
                            this._recordingState = false;
                        }
                    };
                }

                process(inputs) {
                    const input = inputs[0];
                    if (input.length === 0) return true;

                    if (this._recordingState) {
                        // Get the first channel of audio
                        const channelData = input[0];
                        
                        // Send the audio data to the main thread
                        this.port.postMessage({
                            eventType: 'audioData',
                            audioData: channelData.slice()
                        });
                    }

                    return true;
                }
            }

            registerProcessor('recorder-worklet', RecorderWorklet);
        `;

            const blob = new Blob([workletCode], { type: 'application/javascript' });
            return URL.createObjectURL(blob);
        }

        initializeMediaRecorder(stream) {
            this.mediaRecorder = new MediaRecorder(stream, {
                mimeType: 'audio/webm'
            });

            this.mediaRecorder.ondataavailable = (event) => {
                if (event.data.size > 0) {
                    this.audioChunks.push(event.data);
                }
            };
        }

        async initializeWebAudioRecorder(stream) {
            try {
                // Create and load the AudioWorklet
                const workletUrl = this.createWorkletBlob();
                await this.audioContext.audioWorklet.addModule(workletUrl);
                URL.revokeObjectURL(workletUrl);
                console.log("Using WebAudio");
                const source = this.audioContext.createMediaStreamSource(stream);
                this.workletNode = new AudioWorkletNode(this.audioContext, 'recorder-worklet', {
                    numberOfInputs: 1,
                    numberOfOutputs: 1,
                    processorOptions: {
                        sampleRate: this.audioContext.sampleRate
                    }
                });

                // Handle incoming audio data
                this.workletNode.port.onmessage = (event) => {
                    if (event.data.eventType === 'audioData' && this.isRecording) {
                        this.recordingData.push(new Float32Array(event.data.audioData));
                    }
                };

                source.connect(this.workletNode);
                // Don't connect to destination to prevent audio feedback
                // this.workletNode.connect(this.audioContext.destination);

                console.log('WebAudio recorder initialized with sample rate:', this.audioContext.sampleRate);
            } catch (error) {
                console.error('Error initializing AudioWorklet:', error);
                throw error;
            }
        }

        startRecording() {
            this.isRecording = true;
            this.audioChunks = [];
            this.recordingData = [];

            if (this.workletNode) {
                this.workletNode.port.postMessage({ command: 'start' });
                console.log('Started recording with WebAudio');
            } else if (this.mediaRecorder && this.mediaRecorder.state === 'inactive') {
                this.mediaRecorder.start();
                console.log('Started recording with MediaRecorder');
            }
        }

        async stopRecording() {
            this.isRecording = false;

            if (this.workletNode) {
                this.workletNode.port.postMessage({ command: 'stop' });
                console.log('Stopped WebAudio recording, collected chunks:', this.recordingData.length);
                return this.exportWebAudioRecording();
            } else if (this.mediaRecorder && this.mediaRecorder.state === 'recording') {
                return new Promise(resolve => {
                    this.mediaRecorder.onstop = async () => {
                        const blob = new Blob(this.audioChunks, { type: 'audio/webm' });
                        resolve(blob);
                    };
                    this.mediaRecorder.stop();
                });
            }
        }

        async exportWebAudioRecording() {
            // Concatenate all the recorded chunks
            const recordingLength = this.recordingData.reduce((acc, chunk) => acc + chunk.length, 0);
            console.log('Total recording length in samples:', recordingLength);

            const audioData = new Float32Array(recordingLength);
            let offset = 0;

            for (const chunk of this.recordingData) {
                audioData.set(chunk, offset);
                offset += chunk.length;
            }

            // Create WAV file
            const wavFile = this.createWavFile(audioData);
            const blob = new Blob([wavFile], { type: 'audio/wav' });
            console.log('Created WAV blob of size:', blob.size);
            return blob;
        }

        createWavFile(audioData) {
            const numChannels = 1;
            const bitsPerSample = 16;
            const bytesPerSample = bitsPerSample / 8;
            const blockAlign = numChannels * bytesPerSample;
            const byteRate = this.audioContext.sampleRate * blockAlign;
            const dataSize = audioData.length * bytesPerSample;
            const buffer = new ArrayBuffer(44 + dataSize);
            const view = new DataView(buffer);

            const writeString = (offset, string) => {
                for (let i = 0; i < string.length; i++) {
                    view.setUint8(offset + i, string.charCodeAt(i));
                }
            };

            // Write WAV header
            writeString(0, 'RIFF');                                    // ChunkID
            view.setUint32(4, 36 + dataSize, true);                   // ChunkSize
            writeString(8, 'WAVE');                                    // Format
            writeString(12, 'fmt ');                                   // Subchunk1ID
            view.setUint32(16, 16, true);                             // Subchunk1Size
            view.setUint16(20, 1, true);                              // AudioFormat (PCM)
            view.setUint16(22, numChannels, true);                    // NumChannels
            view.setUint32(24, this.audioContext.sampleRate, true);   // SampleRate
            view.setUint32(28, byteRate, true);                       // ByteRate
            view.setUint16(32, blockAlign, true);                     // BlockAlign
            view.setUint16(34, bitsPerSample, true);                  // BitsPerSample
            writeString(36, 'data');                                   // Subchunk2ID
            view.setUint32(40, dataSize, true);                       // Subchunk2Size

            // Write audio data
            const volume = 1.0;
            let offset = 44;
            for (let i = 0; i < audioData.length; i++) {
                const sample = Math.max(-1, Math.min(1, audioData[i])) * volume;
                view.setInt16(offset, sample * 0x7FFF, true);
                offset += 2;
            }

            return buffer;
        }

        cleanup() {
            if (this.mediaStream) {
                this.mediaStream.getTracks().forEach(track => track.stop());
            }
            if (this.workletNode) {
                this.workletNode.disconnect();
            }
            if (this.audioContext) {
                this.audioContext.close();
            }
        }
    }

    return AudioRecorder;
});
},
'papaparse/papaparse':function(){
/* @license
Papa Parse
v5.3.2
https://github.com/mholt/PapaParse
License: MIT
*/

(function(root, factory)
{
	/* globals define */
	if (typeof define === 'function' && define.amd)
	{
		// AMD. Register as an anonymous module.
		define([], factory);
	}
	else if (typeof module === 'object' && typeof exports !== 'undefined')
	{
		// Node. Does not work with strict CommonJS, but
		// only CommonJS-like environments that support module.exports,
		// like Node.
		module.exports = factory();
	}
	else
	{
		// Browser globals (root is window)
		root.Papa = factory();
	}
	// in strict mode we cannot access arguments.callee, so we need a named reference to
	// stringify the factory method for the blob worker
	// eslint-disable-next-line func-name
}(this, function moduleFactory()
{
	'use strict';

	var global = (function() {
		// alternative method, similar to `Function('return this')()`
		// but without using `eval` (which is disabled when
		// using Content Security Policy).

		if (typeof self !== 'undefined') { return self; }
		if (typeof window !== 'undefined') { return window; }
		if (typeof global !== 'undefined') { return global; }

		// When running tests none of the above have been defined
		return {};
	})();


	function getWorkerBlob() {
		var URL = global.URL || global.webkitURL || null;
		var code = moduleFactory.toString();
		return Papa.BLOB_URL || (Papa.BLOB_URL = URL.createObjectURL(new Blob(["var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ", '(', code, ')();'], {type: 'text/javascript'})));
	}

	var IS_WORKER = !global.document && !!global.postMessage,
		IS_PAPA_WORKER = global.IS_PAPA_WORKER || false;

	var workers = {}, workerIdCounter = 0;

	var Papa = {};

	Papa.parse = CsvToJson;
	Papa.unparse = JsonToCsv;

	Papa.RECORD_SEP = String.fromCharCode(30);
	Papa.UNIT_SEP = String.fromCharCode(31);
	Papa.BYTE_ORDER_MARK = '\ufeff';
	Papa.BAD_DELIMITERS = ['\r', '\n', '"', Papa.BYTE_ORDER_MARK];
	Papa.WORKERS_SUPPORTED = !IS_WORKER && !!global.Worker;
	Papa.NODE_STREAM_INPUT = 1;

	// Configurable chunk sizes for local and remote files, respectively
	Papa.LocalChunkSize = 1024 * 1024 * 10;	// 10 MB
	Papa.RemoteChunkSize = 1024 * 1024 * 5;	// 5 MB
	Papa.DefaultDelimiter = ',';			// Used if not specified and detection fails

	// Exposed for testing and development only
	Papa.Parser = Parser;
	Papa.ParserHandle = ParserHandle;
	Papa.NetworkStreamer = NetworkStreamer;
	Papa.FileStreamer = FileStreamer;
	Papa.StringStreamer = StringStreamer;
	Papa.ReadableStreamStreamer = ReadableStreamStreamer;
	if (typeof PAPA_BROWSER_CONTEXT === 'undefined') {
		Papa.DuplexStreamStreamer = DuplexStreamStreamer;
	}

	if (global.jQuery)
	{
		var $ = global.jQuery;
		$.fn.parse = function(options)
		{
			var config = options.config || {};
			var queue = [];

			this.each(function(idx)
			{
				var supported = $(this).prop('tagName').toUpperCase() === 'INPUT'
					&& $(this).attr('type').toLowerCase() === 'file'
					&& global.FileReader;

				if (!supported || !this.files || this.files.length === 0)
					return true;	// continue to next input element

				for (var i = 0; i < this.files.length; i++)
				{
					queue.push({
						file: this.files[i],
						inputElem: this,
						instanceConfig: $.extend({}, config)
					});
				}
			});

			parseNextFile();	// begin parsing
			return this;		// maintains chainability


			function parseNextFile()
			{
				if (queue.length === 0)
				{
					if (isFunction(options.complete))
						options.complete();
					return;
				}

				var f = queue[0];

				if (isFunction(options.before))
				{
					var returned = options.before(f.file, f.inputElem);

					if (typeof returned === 'object')
					{
						if (returned.action === 'abort')
						{
							error('AbortError', f.file, f.inputElem, returned.reason);
							return;	// Aborts all queued files immediately
						}
						else if (returned.action === 'skip')
						{
							fileComplete();	// parse the next file in the queue, if any
							return;
						}
						else if (typeof returned.config === 'object')
							f.instanceConfig = $.extend(f.instanceConfig, returned.config);
					}
					else if (returned === 'skip')
					{
						fileComplete();	// parse the next file in the queue, if any
						return;
					}
				}

				// Wrap up the user's complete callback, if any, so that ours also gets executed
				var userCompleteFunc = f.instanceConfig.complete;
				f.instanceConfig.complete = function(results)
				{
					if (isFunction(userCompleteFunc))
						userCompleteFunc(results, f.file, f.inputElem);
					fileComplete();
				};

				Papa.parse(f.file, f.instanceConfig);
			}

			function error(name, file, elem, reason)
			{
				if (isFunction(options.error))
					options.error({name: name}, file, elem, reason);
			}

			function fileComplete()
			{
				queue.splice(0, 1);
				parseNextFile();
			}
		};
	}


	if (IS_PAPA_WORKER)
	{
		global.onmessage = workerThreadReceivedMessage;
	}




	function CsvToJson(_input, _config)
	{
		_config = _config || {};
		var dynamicTyping = _config.dynamicTyping || false;
		if (isFunction(dynamicTyping)) {
			_config.dynamicTypingFunction = dynamicTyping;
			// Will be filled on first row call
			dynamicTyping = {};
		}
		_config.dynamicTyping = dynamicTyping;

		_config.transform = isFunction(_config.transform) ? _config.transform : false;

		if (_config.worker && Papa.WORKERS_SUPPORTED)
		{
			var w = newWorker();

			w.userStep = _config.step;
			w.userChunk = _config.chunk;
			w.userComplete = _config.complete;
			w.userError = _config.error;

			_config.step = isFunction(_config.step);
			_config.chunk = isFunction(_config.chunk);
			_config.complete = isFunction(_config.complete);
			_config.error = isFunction(_config.error);
			delete _config.worker;	// prevent infinite loop

			w.postMessage({
				input: _input,
				config: _config,
				workerId: w.id
			});

			return;
		}

		var streamer = null;
		if (_input === Papa.NODE_STREAM_INPUT && typeof PAPA_BROWSER_CONTEXT === 'undefined')
		{
			// create a node Duplex stream for use
			// with .pipe
			streamer = new DuplexStreamStreamer(_config);
			return streamer.getStream();
		}
		else if (typeof _input === 'string')
		{
			if (_config.download)
				streamer = new NetworkStreamer(_config);
			else
				streamer = new StringStreamer(_config);
		}
		else if (_input.readable === true && isFunction(_input.read) && isFunction(_input.on))
		{
			streamer = new ReadableStreamStreamer(_config);
		}
		else if ((global.File && _input instanceof File) || _input instanceof Object)	// ...Safari. (see issue #106)
			streamer = new FileStreamer(_config);

		return streamer.stream(_input);
	}






	function JsonToCsv(_input, _config)
	{
		// Default configuration

		/** whether to surround every datum with quotes */
		var _quotes = false;

		/** whether to write headers */
		var _writeHeader = true;

		/** delimiting character(s) */
		var _delimiter = ',';

		/** newline character(s) */
		var _newline = '\r\n';

		/** quote character */
		var _quoteChar = '"';

		/** escaped quote character, either "" or <config.escapeChar>" */
		var _escapedQuote = _quoteChar + _quoteChar;

		/** whether to skip empty lines */
		var _skipEmptyLines = false;

		/** the columns (keys) we expect when we unparse objects */
		var _columns = null;

		/** whether to prevent outputting cells that can be parsed as formulae by spreadsheet software (Excel and LibreOffice) */
		var _escapeFormulae = false;

		unpackConfig();

		var quoteCharRegex = new RegExp(escapeRegExp(_quoteChar), 'g');

		if (typeof _input === 'string')
			_input = JSON.parse(_input);

		if (Array.isArray(_input))
		{
			if (!_input.length || Array.isArray(_input[0]))
				return serialize(null, _input, _skipEmptyLines);
			else if (typeof _input[0] === 'object')
				return serialize(_columns || Object.keys(_input[0]), _input, _skipEmptyLines);
		}
		else if (typeof _input === 'object')
		{
			if (typeof _input.data === 'string')
				_input.data = JSON.parse(_input.data);

			if (Array.isArray(_input.data))
			{
				if (!_input.fields)
					_input.fields = _input.meta && _input.meta.fields || _columns;

				if (!_input.fields)
					_input.fields =  Array.isArray(_input.data[0])
						? _input.fields
						: typeof _input.data[0] === 'object'
							? Object.keys(_input.data[0])
							: [];

				if (!(Array.isArray(_input.data[0])) && typeof _input.data[0] !== 'object')
					_input.data = [_input.data];	// handles input like [1,2,3] or ['asdf']
			}

			return serialize(_input.fields || [], _input.data || [], _skipEmptyLines);
		}

		// Default (any valid paths should return before this)
		throw new Error('Unable to serialize unrecognized input');


		function unpackConfig()
		{
			if (typeof _config !== 'object')
				return;

			if (typeof _config.delimiter === 'string'
				&& !Papa.BAD_DELIMITERS.filter(function(value) { return _config.delimiter.indexOf(value) !== -1; }).length)
			{
				_delimiter = _config.delimiter;
			}

			if (typeof _config.quotes === 'boolean'
				|| typeof _config.quotes === 'function'
				|| Array.isArray(_config.quotes))
				_quotes = _config.quotes;

			if (typeof _config.skipEmptyLines === 'boolean'
				|| typeof _config.skipEmptyLines === 'string')
				_skipEmptyLines = _config.skipEmptyLines;

			if (typeof _config.newline === 'string')
				_newline = _config.newline;

			if (typeof _config.quoteChar === 'string')
				_quoteChar = _config.quoteChar;

			if (typeof _config.header === 'boolean')
				_writeHeader = _config.header;

			if (Array.isArray(_config.columns)) {

				if (_config.columns.length === 0) throw new Error('Option columns is empty');

				_columns = _config.columns;
			}

			if (_config.escapeChar !== undefined) {
				_escapedQuote = _config.escapeChar + _quoteChar;
			}

			if (typeof _config.escapeFormulae === 'boolean' || _config.escapeFormulae instanceof RegExp) {
				_escapeFormulae = _config.escapeFormulae instanceof RegExp ? _config.escapeFormulae : /^[=+\-@\t\r].*$/;
			}
		}

		/** The double for loop that iterates the data and writes out a CSV string including header row */
		function serialize(fields, data, skipEmptyLines)
		{
			var csv = '';

			if (typeof fields === 'string')
				fields = JSON.parse(fields);
			if (typeof data === 'string')
				data = JSON.parse(data);

			var hasHeader = Array.isArray(fields) && fields.length > 0;
			var dataKeyedByField = !(Array.isArray(data[0]));

			// If there a header row, write it first
			if (hasHeader && _writeHeader)
			{
				for (var i = 0; i < fields.length; i++)
				{
					if (i > 0)
						csv += _delimiter;
					csv += safe(fields[i], i);
				}
				if (data.length > 0)
					csv += _newline;
			}

			// Then write out the data
			for (var row = 0; row < data.length; row++)
			{
				var maxCol = hasHeader ? fields.length : data[row].length;

				var emptyLine = false;
				var nullLine = hasHeader ? Object.keys(data[row]).length === 0 : data[row].length === 0;
				if (skipEmptyLines && !hasHeader)
				{
					emptyLine = skipEmptyLines === 'greedy' ? data[row].join('').trim() === '' : data[row].length === 1 && data[row][0].length === 0;
				}
				if (skipEmptyLines === 'greedy' && hasHeader) {
					var line = [];
					for (var c = 0; c < maxCol; c++) {
						var cx = dataKeyedByField ? fields[c] : c;
						line.push(data[row][cx]);
					}
					emptyLine = line.join('').trim() === '';
				}
				if (!emptyLine)
				{
					for (var col = 0; col < maxCol; col++)
					{
						if (col > 0 && !nullLine)
							csv += _delimiter;
						var colIdx = hasHeader && dataKeyedByField ? fields[col] : col;
						csv += safe(data[row][colIdx], col);
					}
					if (row < data.length - 1 && (!skipEmptyLines || (maxCol > 0 && !nullLine)))
					{
						csv += _newline;
					}
				}
			}
			return csv;
		}

		/** Encloses a value around quotes if needed (makes a value safe for CSV insertion) */
		function safe(str, col)
		{
			if (typeof str === 'undefined' || str === null)
				return '';

			if (str.constructor === Date)
				return JSON.stringify(str).slice(1, 25);

			var needsQuotes = false;

			if (_escapeFormulae && typeof str === "string" && _escapeFormulae.test(str)) {
				str = "'" + str;
				needsQuotes = true;
			}

			var escapedQuoteStr = str.toString().replace(quoteCharRegex, _escapedQuote);

			needsQuotes = needsQuotes
				|| _quotes === true
				|| (typeof _quotes === 'function' && _quotes(str, col))
				|| (Array.isArray(_quotes) && _quotes[col])
				|| hasAny(escapedQuoteStr, Papa.BAD_DELIMITERS)
				|| escapedQuoteStr.indexOf(_delimiter) > -1
				|| escapedQuoteStr.charAt(0) === ' '
				|| escapedQuoteStr.charAt(escapedQuoteStr.length - 1) === ' ';

			return needsQuotes ? _quoteChar + escapedQuoteStr + _quoteChar : escapedQuoteStr;
		}

		function hasAny(str, substrings)
		{
			for (var i = 0; i < substrings.length; i++)
				if (str.indexOf(substrings[i]) > -1)
					return true;
			return false;
		}
	}

	/** ChunkStreamer is the base prototype for various streamer implementations. */
	function ChunkStreamer(config)
	{
		this._handle = null;
		this._finished = false;
		this._completed = false;
		this._halted = false;
		this._input = null;
		this._baseIndex = 0;
		this._partialLine = '';
		this._rowCount = 0;
		this._start = 0;
		this._nextChunk = null;
		this.isFirstChunk = true;
		this._completeResults = {
			data: [],
			errors: [],
			meta: {}
		};
		replaceConfig.call(this, config);

		this.parseChunk = function(chunk, isFakeChunk)
		{
			// First chunk pre-processing
			if (this.isFirstChunk && isFunction(this._config.beforeFirstChunk))
			{
				var modifiedChunk = this._config.beforeFirstChunk(chunk);
				if (modifiedChunk !== undefined)
					chunk = modifiedChunk;
			}
			this.isFirstChunk = false;
			this._halted = false;

			// Rejoin the line we likely just split in two by chunking the file
			var aggregate = this._partialLine + chunk;
			this._partialLine = '';

			var results = this._handle.parse(aggregate, this._baseIndex, !this._finished);

			if (this._handle.paused() || this._handle.aborted()) {
				this._halted = true;
				return;
			}

			var lastIndex = results.meta.cursor;

			if (!this._finished)
			{
				this._partialLine = aggregate.substring(lastIndex - this._baseIndex);
				this._baseIndex = lastIndex;
			}

			if (results && results.data)
				this._rowCount += results.data.length;

			var finishedIncludingPreview = this._finished || (this._config.preview && this._rowCount >= this._config.preview);

			if (IS_PAPA_WORKER)
			{
				global.postMessage({
					results: results,
					workerId: Papa.WORKER_ID,
					finished: finishedIncludingPreview
				});
			}
			else if (isFunction(this._config.chunk) && !isFakeChunk)
			{
				this._config.chunk(results, this._handle);
				if (this._handle.paused() || this._handle.aborted()) {
					this._halted = true;
					return;
				}
				results = undefined;
				this._completeResults = undefined;
			}

			if (!this._config.step && !this._config.chunk) {
				this._completeResults.data = this._completeResults.data.concat(results.data);
				this._completeResults.errors = this._completeResults.errors.concat(results.errors);
				this._completeResults.meta = results.meta;
			}

			if (!this._completed && finishedIncludingPreview && isFunction(this._config.complete) && (!results || !results.meta.aborted)) {
				this._config.complete(this._completeResults, this._input);
				this._completed = true;
			}

			if (!finishedIncludingPreview && (!results || !results.meta.paused))
				this._nextChunk();

			return results;
		};

		this._sendError = function(error)
		{
			if (isFunction(this._config.error))
				this._config.error(error);
			else if (IS_PAPA_WORKER && this._config.error)
			{
				global.postMessage({
					workerId: Papa.WORKER_ID,
					error: error,
					finished: false
				});
			}
		};

		function replaceConfig(config)
		{
			// Deep-copy the config so we can edit it
			var configCopy = copy(config);
			configCopy.chunkSize = parseInt(configCopy.chunkSize);	// parseInt VERY important so we don't concatenate strings!
			if (!config.step && !config.chunk)
				configCopy.chunkSize = null;  // disable Range header if not streaming; bad values break IIS - see issue #196
			this._handle = new ParserHandle(configCopy);
			this._handle.streamer = this;
			this._config = configCopy;	// persist the copy to the caller
		}
	}


	function NetworkStreamer(config)
	{
		config = config || {};
		if (!config.chunkSize)
			config.chunkSize = Papa.RemoteChunkSize;
		ChunkStreamer.call(this, config);

		var xhr;

		if (IS_WORKER)
		{
			this._nextChunk = function()
			{
				this._readChunk();
				this._chunkLoaded();
			};
		}
		else
		{
			this._nextChunk = function()
			{
				this._readChunk();
			};
		}

		this.stream = function(url)
		{
			this._input = url;
			this._nextChunk();	// Starts streaming
		};

		this._readChunk = function()
		{
			if (this._finished)
			{
				this._chunkLoaded();
				return;
			}

			xhr = new XMLHttpRequest();

			if (this._config.withCredentials)
			{
				xhr.withCredentials = this._config.withCredentials;
			}

			if (!IS_WORKER)
			{
				xhr.onload = bindFunction(this._chunkLoaded, this);
				xhr.onerror = bindFunction(this._chunkError, this);
			}

			xhr.open(this._config.downloadRequestBody ? 'POST' : 'GET', this._input, !IS_WORKER);
			// Headers can only be set when once the request state is OPENED
			if (this._config.downloadRequestHeaders)
			{
				var headers = this._config.downloadRequestHeaders;

				for (var headerName in headers)
				{
					xhr.setRequestHeader(headerName, headers[headerName]);
				}
			}

			if (this._config.chunkSize)
			{
				var end = this._start + this._config.chunkSize - 1;	// minus one because byte range is inclusive
				xhr.setRequestHeader('Range', 'bytes=' + this._start + '-' + end);
			}

			try {
				xhr.send(this._config.downloadRequestBody);
			}
			catch (err) {
				this._chunkError(err.message);
			}

			if (IS_WORKER && xhr.status === 0)
				this._chunkError();
		};

		this._chunkLoaded = function()
		{
			if (xhr.readyState !== 4)
				return;

			if (xhr.status < 200 || xhr.status >= 400)
			{
				this._chunkError();
				return;
			}

			// Use chunckSize as it may be a diference on reponse lentgh due to characters with more than 1 byte
			this._start += this._config.chunkSize ? this._config.chunkSize : xhr.responseText.length;
			this._finished = !this._config.chunkSize || this._start >= getFileSize(xhr);
			this.parseChunk(xhr.responseText);
		};

		this._chunkError = function(errorMessage)
		{
			var errorText = xhr.statusText || errorMessage;
			this._sendError(new Error(errorText));
		};

		function getFileSize(xhr)
		{
			var contentRange = xhr.getResponseHeader('Content-Range');
			if (contentRange === null) { // no content range, then finish!
				return -1;
			}
			return parseInt(contentRange.substring(contentRange.lastIndexOf('/') + 1));
		}
	}
	NetworkStreamer.prototype = Object.create(ChunkStreamer.prototype);
	NetworkStreamer.prototype.constructor = NetworkStreamer;


	function FileStreamer(config)
	{
		config = config || {};
		if (!config.chunkSize)
			config.chunkSize = Papa.LocalChunkSize;
		ChunkStreamer.call(this, config);

		var reader, slice;

		// FileReader is better than FileReaderSync (even in worker) - see http://stackoverflow.com/q/24708649/1048862
		// But Firefox is a pill, too - see issue #76: https://github.com/mholt/PapaParse/issues/76
		var usingAsyncReader = typeof FileReader !== 'undefined';	// Safari doesn't consider it a function - see issue #105

		this.stream = function(file)
		{
			this._input = file;
			slice = file.slice || file.webkitSlice || file.mozSlice;

			if (usingAsyncReader)
			{
				reader = new FileReader();		// Preferred method of reading files, even in workers
				reader.onload = bindFunction(this._chunkLoaded, this);
				reader.onerror = bindFunction(this._chunkError, this);
			}
			else
				reader = new FileReaderSync();	// Hack for running in a web worker in Firefox

			this._nextChunk();	// Starts streaming
		};

		this._nextChunk = function()
		{
			if (!this._finished && (!this._config.preview || this._rowCount < this._config.preview))
				this._readChunk();
		};

		this._readChunk = function()
		{
			var input = this._input;
			if (this._config.chunkSize)
			{
				var end = Math.min(this._start + this._config.chunkSize, this._input.size);
				input = slice.call(input, this._start, end);
			}
			var txt = reader.readAsText(input, this._config.encoding);
			if (!usingAsyncReader)
				this._chunkLoaded({ target: { result: txt } });	// mimic the async signature
		};

		this._chunkLoaded = function(event)
		{
			// Very important to increment start each time before handling results
			this._start += this._config.chunkSize;
			this._finished = !this._config.chunkSize || this._start >= this._input.size;
			this.parseChunk(event.target.result);
		};

		this._chunkError = function()
		{
			this._sendError(reader.error);
		};

	}
	FileStreamer.prototype = Object.create(ChunkStreamer.prototype);
	FileStreamer.prototype.constructor = FileStreamer;


	function StringStreamer(config)
	{
		config = config || {};
		ChunkStreamer.call(this, config);

		var remaining;
		this.stream = function(s)
		{
			remaining = s;
			return this._nextChunk();
		};
		this._nextChunk = function()
		{
			if (this._finished) return;
			var size = this._config.chunkSize;
			var chunk;
			if(size) {
				chunk = remaining.substring(0, size);
				remaining = remaining.substring(size);
			} else {
				chunk = remaining;
				remaining = '';
			}
			this._finished = !remaining;
			return this.parseChunk(chunk);
		};
	}
	StringStreamer.prototype = Object.create(StringStreamer.prototype);
	StringStreamer.prototype.constructor = StringStreamer;


	function ReadableStreamStreamer(config)
	{
		config = config || {};

		ChunkStreamer.call(this, config);

		var queue = [];
		var parseOnData = true;
		var streamHasEnded = false;

		this.pause = function()
		{
			ChunkStreamer.prototype.pause.apply(this, arguments);
			this._input.pause();
		};

		this.resume = function()
		{
			ChunkStreamer.prototype.resume.apply(this, arguments);
			this._input.resume();
		};

		this.stream = function(stream)
		{
			this._input = stream;

			this._input.on('data', this._streamData);
			this._input.on('end', this._streamEnd);
			this._input.on('error', this._streamError);
		};

		this._checkIsFinished = function()
		{
			if (streamHasEnded && queue.length === 1) {
				this._finished = true;
			}
		};

		this._nextChunk = function()
		{
			this._checkIsFinished();
			if (queue.length)
			{
				this.parseChunk(queue.shift());
			}
			else
			{
				parseOnData = true;
			}
		};

		this._streamData = bindFunction(function(chunk)
		{
			try
			{
				queue.push(typeof chunk === 'string' ? chunk : chunk.toString(this._config.encoding));

				if (parseOnData)
				{
					parseOnData = false;
					this._checkIsFinished();
					this.parseChunk(queue.shift());
				}
			}
			catch (error)
			{
				this._streamError(error);
			}
		}, this);

		this._streamError = bindFunction(function(error)
		{
			this._streamCleanUp();
			this._sendError(error);
		}, this);

		this._streamEnd = bindFunction(function()
		{
			this._streamCleanUp();
			streamHasEnded = true;
			this._streamData('');
		}, this);

		this._streamCleanUp = bindFunction(function()
		{
			this._input.removeListener('data', this._streamData);
			this._input.removeListener('end', this._streamEnd);
			this._input.removeListener('error', this._streamError);
		}, this);
	}
	ReadableStreamStreamer.prototype = Object.create(ChunkStreamer.prototype);
	ReadableStreamStreamer.prototype.constructor = ReadableStreamStreamer;


	function DuplexStreamStreamer(_config) {
		var Duplex = require('stream').Duplex;
		var config = copy(_config);
		var parseOnWrite = true;
		var writeStreamHasFinished = false;
		var parseCallbackQueue = [];
		var stream = null;

		this._onCsvData = function(results)
		{
			var data = results.data;
			if (!stream.push(data) && !this._handle.paused()) {
				// the writeable consumer buffer has filled up
				// so we need to pause until more items
				// can be processed
				this._handle.pause();
			}
		};

		this._onCsvComplete = function()
		{
			// node will finish the read stream when
			// null is pushed
			stream.push(null);
		};

		config.step = bindFunction(this._onCsvData, this);
		config.complete = bindFunction(this._onCsvComplete, this);
		ChunkStreamer.call(this, config);

		this._nextChunk = function()
		{
			if (writeStreamHasFinished && parseCallbackQueue.length === 1) {
				this._finished = true;
			}
			if (parseCallbackQueue.length) {
				parseCallbackQueue.shift()();
			} else {
				parseOnWrite = true;
			}
		};

		this._addToParseQueue = function(chunk, callback)
		{
			// add to queue so that we can indicate
			// completion via callback
			// node will automatically pause the incoming stream
			// when too many items have been added without their
			// callback being invoked
			parseCallbackQueue.push(bindFunction(function() {
				this.parseChunk(typeof chunk === 'string' ? chunk : chunk.toString(config.encoding));
				if (isFunction(callback)) {
					return callback();
				}
			}, this));
			if (parseOnWrite) {
				parseOnWrite = false;
				this._nextChunk();
			}
		};

		this._onRead = function()
		{
			if (this._handle.paused()) {
				// the writeable consumer can handle more data
				// so resume the chunk parsing
				this._handle.resume();
			}
		};

		this._onWrite = function(chunk, encoding, callback)
		{
			this._addToParseQueue(chunk, callback);
		};

		this._onWriteComplete = function()
		{
			writeStreamHasFinished = true;
			// have to write empty string
			// so parser knows its done
			this._addToParseQueue('');
		};

		this.getStream = function()
		{
			return stream;
		};
		stream = new Duplex({
			readableObjectMode: true,
			decodeStrings: false,
			read: bindFunction(this._onRead, this),
			write: bindFunction(this._onWrite, this)
		});
		stream.once('finish', bindFunction(this._onWriteComplete, this));
	}
	if (typeof PAPA_BROWSER_CONTEXT === 'undefined') {
		DuplexStreamStreamer.prototype = Object.create(ChunkStreamer.prototype);
		DuplexStreamStreamer.prototype.constructor = DuplexStreamStreamer;
	}


	// Use one ParserHandle per entire CSV file or string
	function ParserHandle(_config)
	{
		// One goal is to minimize the use of regular expressions...
		var MAX_FLOAT = Math.pow(2, 53);
		var MIN_FLOAT = -MAX_FLOAT;
		var FLOAT = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/;
		var ISO_DATE = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/;
		var self = this;
		var _stepCounter = 0;	// Number of times step was called (number of rows parsed)
		var _rowCounter = 0;	// Number of rows that have been parsed so far
		var _input;				// The input being parsed
		var _parser;			// The core parser being used
		var _paused = false;	// Whether we are paused or not
		var _aborted = false;	// Whether the parser has aborted or not
		var _delimiterError;	// Temporary state between delimiter detection and processing results
		var _fields = [];		// Fields are from the header row of the input, if there is one
		var _results = {		// The last results returned from the parser
			data: [],
			errors: [],
			meta: {}
		};

		if (isFunction(_config.step))
		{
			var userStep = _config.step;
			_config.step = function(results)
			{
				_results = results;

				if (needsHeaderRow())
					processResults();
				else	// only call user's step function after header row
				{
					processResults();

					// It's possbile that this line was empty and there's no row here after all
					if (_results.data.length === 0)
						return;

					_stepCounter += results.data.length;
					if (_config.preview && _stepCounter > _config.preview)
						_parser.abort();
					else {
						_results.data = _results.data[0];
						userStep(_results, self);
					}
				}
			};
		}

		/**
		 * Parses input. Most users won't need, and shouldn't mess with, the baseIndex
		 * and ignoreLastRow parameters. They are used by streamers (wrapper functions)
		 * when an input comes in multiple chunks, like from a file.
		 */
		this.parse = function(input, baseIndex, ignoreLastRow)
		{
			var quoteChar = _config.quoteChar || '"';
			if (!_config.newline)
				_config.newline = guessLineEndings(input, quoteChar);

			_delimiterError = false;
			if (!_config.delimiter)
			{
				var delimGuess = guessDelimiter(input, _config.newline, _config.skipEmptyLines, _config.comments, _config.delimitersToGuess);
				if (delimGuess.successful)
					_config.delimiter = delimGuess.bestDelimiter;
				else
				{
					_delimiterError = true;	// add error after parsing (otherwise it would be overwritten)
					_config.delimiter = Papa.DefaultDelimiter;
				}
				_results.meta.delimiter = _config.delimiter;
			}
			else if(isFunction(_config.delimiter))
			{
				_config.delimiter = _config.delimiter(input);
				_results.meta.delimiter = _config.delimiter;
			}

			var parserConfig = copy(_config);
			if (_config.preview && _config.header)
				parserConfig.preview++;	// to compensate for header row

			_input = input;
			_parser = new Parser(parserConfig);
			_results = _parser.parse(_input, baseIndex, ignoreLastRow);
			processResults();
			return _paused ? { meta: { paused: true } } : (_results || { meta: { paused: false } });
		};

		this.paused = function()
		{
			return _paused;
		};

		this.pause = function()
		{
			_paused = true;
			_parser.abort();

			// If it is streaming via "chunking", the reader will start appending correctly already so no need to substring,
			// otherwise we can get duplicate content within a row
			_input = isFunction(_config.chunk) ? "" : _input.substring(_parser.getCharIndex());
		};

		this.resume = function()
		{
			if(self.streamer._halted) {
				_paused = false;
				self.streamer.parseChunk(_input, true);
			} else {
				// Bugfix: #636 In case the processing hasn't halted yet
				// wait for it to halt in order to resume
				setTimeout(self.resume, 3);
			}
		};

		this.aborted = function()
		{
			return _aborted;
		};

		this.abort = function()
		{
			_aborted = true;
			_parser.abort();
			_results.meta.aborted = true;
			if (isFunction(_config.complete))
				_config.complete(_results);
			_input = '';
		};

		function testEmptyLine(s) {
			return _config.skipEmptyLines === 'greedy' ? s.join('').trim() === '' : s.length === 1 && s[0].length === 0;
		}

		function testFloat(s) {
			if (FLOAT.test(s)) {
				var floatValue = parseFloat(s);
				if (floatValue > MIN_FLOAT && floatValue < MAX_FLOAT) {
					return true;
				}
			}
			return false;
		}

		function processResults()
		{
			if (_results && _delimiterError)
			{
				addError('Delimiter', 'UndetectableDelimiter', 'Unable to auto-detect delimiting character; defaulted to \'' + Papa.DefaultDelimiter + '\'');
				_delimiterError = false;
			}

			if (_config.skipEmptyLines)
			{
				_results.data = _results.data.filter(function(d) {
					return !testEmptyLine(d);
				});
			}

			if (needsHeaderRow())
				fillHeaderFields();

			return applyHeaderAndDynamicTypingAndTransformation();
		}

		function needsHeaderRow()
		{
			return _config.header && _fields.length === 0;
		}

		function fillHeaderFields()
		{
			if (!_results)
				return;

			function addHeader(header, i)
			{
				if (isFunction(_config.transformHeader))
					header = _config.transformHeader(header, i);

				_fields.push(header);
			}

			if (Array.isArray(_results.data[0]))
			{
				for (var i = 0; needsHeaderRow() && i < _results.data.length; i++)
					_results.data[i].forEach(addHeader);

				_results.data.splice(0, 1);
			}
			// if _results.data[0] is not an array, we are in a step where _results.data is the row.
			else
				_results.data.forEach(addHeader);
		}

		function shouldApplyDynamicTyping(field) {
			// Cache function values to avoid calling it for each row
			if (_config.dynamicTypingFunction && _config.dynamicTyping[field] === undefined) {
				_config.dynamicTyping[field] = _config.dynamicTypingFunction(field);
			}
			return (_config.dynamicTyping[field] || _config.dynamicTyping) === true;
		}

		function parseDynamic(field, value)
		{
			if (shouldApplyDynamicTyping(field))
			{
				if (value === 'true' || value === 'TRUE')
					return true;
				else if (value === 'false' || value === 'FALSE')
					return false;
				else if (testFloat(value))
					return parseFloat(value);
				else if (ISO_DATE.test(value))
					return new Date(value);
				else
					return (value === '' ? null : value);
			}
			return value;
		}

		function applyHeaderAndDynamicTypingAndTransformation()
		{
			if (!_results || (!_config.header && !_config.dynamicTyping && !_config.transform))
				return _results;

			function processRow(rowSource, i)
			{
				var row = _config.header ? {} : [];

				var j;
				for (j = 0; j < rowSource.length; j++)
				{
					var field = j;
					var value = rowSource[j];

					if (_config.header)
						field = j >= _fields.length ? '__parsed_extra' : _fields[j];

					if (_config.transform)
						value = _config.transform(value,field);

					value = parseDynamic(field, value);

					if (field === '__parsed_extra')
					{
						row[field] = row[field] || [];
						row[field].push(value);
					}
					else
						row[field] = value;
				}


				if (_config.header)
				{
					if (j > _fields.length)
						addError('FieldMismatch', 'TooManyFields', 'Too many fields: expected ' + _fields.length + ' fields but parsed ' + j, _rowCounter + i);
					else if (j < _fields.length)
						addError('FieldMismatch', 'TooFewFields', 'Too few fields: expected ' + _fields.length + ' fields but parsed ' + j, _rowCounter + i);
				}

				return row;
			}

			var incrementBy = 1;
			if (!_results.data.length || Array.isArray(_results.data[0]))
			{
				_results.data = _results.data.map(processRow);
				incrementBy = _results.data.length;
			}
			else
				_results.data = processRow(_results.data, 0);


			if (_config.header && _results.meta)
				_results.meta.fields = _fields;

			_rowCounter += incrementBy;
			return _results;
		}

		function guessDelimiter(input, newline, skipEmptyLines, comments, delimitersToGuess) {
			var bestDelim, bestDelta, fieldCountPrevRow, maxFieldCount;

			delimitersToGuess = delimitersToGuess || [',', '\t', '|', ';', Papa.RECORD_SEP, Papa.UNIT_SEP];

			for (var i = 0; i < delimitersToGuess.length; i++) {
				var delim = delimitersToGuess[i];
				var delta = 0, avgFieldCount = 0, emptyLinesCount = 0;
				fieldCountPrevRow = undefined;

				var preview = new Parser({
					comments: comments,
					delimiter: delim,
					newline: newline,
					preview: 10
				}).parse(input);

				for (var j = 0; j < preview.data.length; j++) {
					if (skipEmptyLines && testEmptyLine(preview.data[j])) {
						emptyLinesCount++;
						continue;
					}
					var fieldCount = preview.data[j].length;
					avgFieldCount += fieldCount;

					if (typeof fieldCountPrevRow === 'undefined') {
						fieldCountPrevRow = fieldCount;
						continue;
					}
					else if (fieldCount > 0) {
						delta += Math.abs(fieldCount - fieldCountPrevRow);
						fieldCountPrevRow = fieldCount;
					}
				}

				if (preview.data.length > 0)
					avgFieldCount /= (preview.data.length - emptyLinesCount);

				if ((typeof bestDelta === 'undefined' || delta <= bestDelta)
					&& (typeof maxFieldCount === 'undefined' || avgFieldCount > maxFieldCount) && avgFieldCount > 1.99) {
					bestDelta = delta;
					bestDelim = delim;
					maxFieldCount = avgFieldCount;
				}
			}

			_config.delimiter = bestDelim;

			return {
				successful: !!bestDelim,
				bestDelimiter: bestDelim
			};
		}

		function guessLineEndings(input, quoteChar)
		{
			input = input.substring(0, 1024 * 1024);	// max length 1 MB
			// Replace all the text inside quotes
			var re = new RegExp(escapeRegExp(quoteChar) + '([^]*?)' + escapeRegExp(quoteChar), 'gm');
			input = input.replace(re, '');

			var r = input.split('\r');

			var n = input.split('\n');

			var nAppearsFirst = (n.length > 1 && n[0].length < r[0].length);

			if (r.length === 1 || nAppearsFirst)
				return '\n';

			var numWithN = 0;
			for (var i = 0; i < r.length; i++)
			{
				if (r[i][0] === '\n')
					numWithN++;
			}

			return numWithN >= r.length / 2 ? '\r\n' : '\r';
		}

		function addError(type, code, msg, row)
		{
			var error = {
				type: type,
				code: code,
				message: msg
			};
			if(row !== undefined) {
				error.row = row;
			}
			_results.errors.push(error);
		}
	}

	/** https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions */
	function escapeRegExp(string)
	{
		return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
	}

	/** The core parser implements speedy and correct CSV parsing */
	function Parser(config)
	{
		// Unpack the config object
		config = config || {};
		var delim = config.delimiter;
		var newline = config.newline;
		var comments = config.comments;
		var step = config.step;
		var preview = config.preview;
		var fastMode = config.fastMode;
		var quoteChar;
		if (config.quoteChar === undefined || config.quoteChar === null) {
			quoteChar = '"';
		} else {
			quoteChar = config.quoteChar;
		}
		var escapeChar = quoteChar;
		if (config.escapeChar !== undefined) {
			escapeChar = config.escapeChar;
		}

		// Delimiter must be valid
		if (typeof delim !== 'string'
			|| Papa.BAD_DELIMITERS.indexOf(delim) > -1)
			delim = ',';

		// Comment character must be valid
		if (comments === delim)
			throw new Error('Comment character same as delimiter');
		else if (comments === true)
			comments = '#';
		else if (typeof comments !== 'string'
			|| Papa.BAD_DELIMITERS.indexOf(comments) > -1)
			comments = false;

		// Newline must be valid: \r, \n, or \r\n
		if (newline !== '\n' && newline !== '\r' && newline !== '\r\n')
			newline = '\n';

		// We're gonna need these at the Parser scope
		var cursor = 0;
		var aborted = false;

		this.parse = function(input, baseIndex, ignoreLastRow)
		{
			// For some reason, in Chrome, this speeds things up (!?)
			if (typeof input !== 'string')
				throw new Error('Input must be a string');

			// We don't need to compute some of these every time parse() is called,
			// but having them in a more local scope seems to perform better
			var inputLen = input.length,
				delimLen = delim.length,
				newlineLen = newline.length,
				commentsLen = comments.length;
			var stepIsFunction = isFunction(step);

			// Establish starting state
			cursor = 0;
			var data = [], errors = [], row = [], lastCursor = 0;

			if (!input)
				return returnable();

			// Rename headers if there are duplicates
			if (config.header)
			{
				var firstLine = input.split(newline)[0];
				var headers = firstLine.split(delim);
				var separator = '_';
				var headerMap = [];
				var headerCount = {};
				var duplicateHeaders = false;

				for (var j in headers) {
					var header = headers[j];
					if (isFunction(config.transformHeader))
						header = config.transformHeader(header, j);
					var headerName = header;

					var count = headerCount[header] || 0;
					if (count > 0) {
						duplicateHeaders = true;
						headerName = header + separator + count;
					}
					headerCount[header] = count + 1;

					headerMap.push(headerName);
				}
				if (duplicateHeaders) {
					var editedInput = input.split(newline);
					editedInput[0] = headerMap.join(delim);
					input = editedInput.join(newline);
				}
			}
			if (fastMode || (fastMode !== false && input.indexOf(quoteChar) === -1))
			{
				var rows = input.split(newline);
				for (var i = 0; i < rows.length; i++)
				{
					row = rows[i];
					cursor += row.length;
					if (i !== rows.length - 1)
						cursor += newline.length;
					else if (ignoreLastRow)
						return returnable();
					if (comments && row.substring(0, commentsLen) === comments)
						continue;
					if (stepIsFunction)
					{
						data = [];
						pushRow(row.split(delim));
						doStep();
						if (aborted)
							return returnable();
					}
					else
						pushRow(row.split(delim));
					if (preview && i >= preview)
					{
						data = data.slice(0, preview);
						return returnable(true);
					}
				}
				return returnable();
			}

			var nextDelim = input.indexOf(delim, cursor);
			var nextNewline = input.indexOf(newline, cursor);
			var quoteCharRegex = new RegExp(escapeRegExp(escapeChar) + escapeRegExp(quoteChar), 'g');
			var quoteSearch = input.indexOf(quoteChar, cursor);

			// Parser loop
			for (;;)
			{
				// Field has opening quote
				if (input[cursor] === quoteChar)
				{
					// Start our search for the closing quote where the cursor is
					quoteSearch = cursor;

					// Skip the opening quote
					cursor++;

					for (;;)
					{
						// Find closing quote
						quoteSearch = input.indexOf(quoteChar, quoteSearch + 1);

						//No other quotes are found - no other delimiters
						if (quoteSearch === -1)
						{
							if (!ignoreLastRow) {
								// No closing quote... what a pity
								errors.push({
									type: 'Quotes',
									code: 'MissingQuotes',
									message: 'Quoted field unterminated',
									row: data.length,	// row has yet to be inserted
									index: cursor
								});
							}
							return finish();
						}

						// Closing quote at EOF
						if (quoteSearch === inputLen - 1)
						{
							var value = input.substring(cursor, quoteSearch).replace(quoteCharRegex, quoteChar);
							return finish(value);
						}

						// If this quote is escaped, it's part of the data; skip it
						// If the quote character is the escape character, then check if the next character is the escape character
						if (quoteChar === escapeChar &&  input[quoteSearch + 1] === escapeChar)
						{
							quoteSearch++;
							continue;
						}

						// If the quote character is not the escape character, then check if the previous character was the escape character
						if (quoteChar !== escapeChar && quoteSearch !== 0 && input[quoteSearch - 1] === escapeChar)
						{
							continue;
						}

						if(nextDelim !== -1 && nextDelim < (quoteSearch + 1)) {
							nextDelim = input.indexOf(delim, (quoteSearch + 1));
						}
						if(nextNewline !== -1 && nextNewline < (quoteSearch + 1)) {
							nextNewline = input.indexOf(newline, (quoteSearch + 1));
						}
						// Check up to nextDelim or nextNewline, whichever is closest
						var checkUpTo = nextNewline === -1 ? nextDelim : Math.min(nextDelim, nextNewline);
						var spacesBetweenQuoteAndDelimiter = extraSpaces(checkUpTo);

						// Closing quote followed by delimiter or 'unnecessary spaces + delimiter'
						if (input.substr(quoteSearch + 1 + spacesBetweenQuoteAndDelimiter, delimLen) === delim)
						{
							row.push(input.substring(cursor, quoteSearch).replace(quoteCharRegex, quoteChar));
							cursor = quoteSearch + 1 + spacesBetweenQuoteAndDelimiter + delimLen;

							// If char after following delimiter is not quoteChar, we find next quote char position
							if (input[quoteSearch + 1 + spacesBetweenQuoteAndDelimiter + delimLen] !== quoteChar)
							{
								quoteSearch = input.indexOf(quoteChar, cursor);
							}
							nextDelim = input.indexOf(delim, cursor);
							nextNewline = input.indexOf(newline, cursor);
							break;
						}

						var spacesBetweenQuoteAndNewLine = extraSpaces(nextNewline);

						// Closing quote followed by newline or 'unnecessary spaces + newLine'
						if (input.substring(quoteSearch + 1 + spacesBetweenQuoteAndNewLine, quoteSearch + 1 + spacesBetweenQuoteAndNewLine + newlineLen) === newline)
						{
							row.push(input.substring(cursor, quoteSearch).replace(quoteCharRegex, quoteChar));
							saveRow(quoteSearch + 1 + spacesBetweenQuoteAndNewLine + newlineLen);
							nextDelim = input.indexOf(delim, cursor);	// because we may have skipped the nextDelim in the quoted field
							quoteSearch = input.indexOf(quoteChar, cursor);	// we search for first quote in next line

							if (stepIsFunction)
							{
								doStep();
								if (aborted)
									return returnable();
							}

							if (preview && data.length >= preview)
								return returnable(true);

							break;
						}


						// Checks for valid closing quotes are complete (escaped quotes or quote followed by EOF/delimiter/newline) -- assume these quotes are part of an invalid text string
						errors.push({
							type: 'Quotes',
							code: 'InvalidQuotes',
							message: 'Trailing quote on quoted field is malformed',
							row: data.length,	// row has yet to be inserted
							index: cursor
						});

						quoteSearch++;
						continue;

					}

					continue;
				}

				// Comment found at start of new line
				if (comments && row.length === 0 && input.substring(cursor, cursor + commentsLen) === comments)
				{
					if (nextNewline === -1)	// Comment ends at EOF
						return returnable();
					cursor = nextNewline + newlineLen;
					nextNewline = input.indexOf(newline, cursor);
					nextDelim = input.indexOf(delim, cursor);
					continue;
				}

				// Next delimiter comes before next newline, so we've reached end of field
				if (nextDelim !== -1 && (nextDelim < nextNewline || nextNewline === -1))
				{
					row.push(input.substring(cursor, nextDelim));
					cursor = nextDelim + delimLen;
					// we look for next delimiter char
					nextDelim = input.indexOf(delim, cursor);
					continue;
				}

				// End of row
				if (nextNewline !== -1)
				{
					row.push(input.substring(cursor, nextNewline));
					saveRow(nextNewline + newlineLen);

					if (stepIsFunction)
					{
						doStep();
						if (aborted)
							return returnable();
					}

					if (preview && data.length >= preview)
						return returnable(true);

					continue;
				}

				break;
			}


			return finish();


			function pushRow(row)
			{
				data.push(row);
				lastCursor = cursor;
			}

			/**
			 * checks if there are extra spaces after closing quote and given index without any text
			 * if Yes, returns the number of spaces
			 */
			function extraSpaces(index) {
				var spaceLength = 0;
				if (index !== -1) {
					var textBetweenClosingQuoteAndIndex = input.substring(quoteSearch + 1, index);
					if (textBetweenClosingQuoteAndIndex && textBetweenClosingQuoteAndIndex.trim() === '') {
						spaceLength = textBetweenClosingQuoteAndIndex.length;
					}
				}
				return spaceLength;
			}

			/**
			 * Appends the remaining input from cursor to the end into
			 * row, saves the row, calls step, and returns the results.
			 */
			function finish(value)
			{
				if (ignoreLastRow)
					return returnable();
				if (typeof value === 'undefined')
					value = input.substring(cursor);
				row.push(value);
				cursor = inputLen;	// important in case parsing is paused
				pushRow(row);
				if (stepIsFunction)
					doStep();
				return returnable();
			}

			/**
			 * Appends the current row to the results. It sets the cursor
			 * to newCursor and finds the nextNewline. The caller should
			 * take care to execute user's step function and check for
			 * preview and end parsing if necessary.
			 */
			function saveRow(newCursor)
			{
				cursor = newCursor;
				pushRow(row);
				row = [];
				nextNewline = input.indexOf(newline, cursor);
			}

			/** Returns an object with the results, errors, and meta. */
			function returnable(stopped)
			{
				return {
					data: data,
					errors: errors,
					meta: {
						delimiter: delim,
						linebreak: newline,
						aborted: aborted,
						truncated: !!stopped,
						cursor: lastCursor + (baseIndex || 0)
					}
				};
			}

			/** Executes the user's step function and resets data & errors. */
			function doStep()
			{
				step(returnable());
				data = [];
				errors = [];
			}
		};

		/** Sets the abort flag */
		this.abort = function()
		{
			aborted = true;
		};

		/** Gets the cursor position */
		this.getCharIndex = function()
		{
			return cursor;
		};
	}


	function newWorker()
	{
		if (!Papa.WORKERS_SUPPORTED)
			return false;

		var workerUrl = getWorkerBlob();
		var w = new global.Worker(workerUrl);
		w.onmessage = mainThreadReceivedMessage;
		w.id = workerIdCounter++;
		workers[w.id] = w;
		return w;
	}

	/** Callback when main thread receives a message */
	function mainThreadReceivedMessage(e)
	{
		var msg = e.data;
		var worker = workers[msg.workerId];
		var aborted = false;

		if (msg.error)
			worker.userError(msg.error, msg.file);
		else if (msg.results && msg.results.data)
		{
			var abort = function() {
				aborted = true;
				completeWorker(msg.workerId, { data: [], errors: [], meta: { aborted: true } });
			};

			var handle = {
				abort: abort,
				pause: notImplemented,
				resume: notImplemented
			};

			if (isFunction(worker.userStep))
			{
				for (var i = 0; i < msg.results.data.length; i++)
				{
					worker.userStep({
						data: msg.results.data[i],
						errors: msg.results.errors,
						meta: msg.results.meta
					}, handle);
					if (aborted)
						break;
				}
				delete msg.results;	// free memory ASAP
			}
			else if (isFunction(worker.userChunk))
			{
				worker.userChunk(msg.results, handle, msg.file);
				delete msg.results;
			}
		}

		if (msg.finished && !aborted)
			completeWorker(msg.workerId, msg.results);
	}

	function completeWorker(workerId, results) {
		var worker = workers[workerId];
		if (isFunction(worker.userComplete))
			worker.userComplete(results);
		worker.terminate();
		delete workers[workerId];
	}

	function notImplemented() {
		throw new Error('Not implemented.');
	}

	/** Callback when worker thread receives a message */
	function workerThreadReceivedMessage(e)
	{
		var msg = e.data;

		if (typeof Papa.WORKER_ID === 'undefined' && msg)
			Papa.WORKER_ID = msg.workerId;

		if (typeof msg.input === 'string')
		{
			global.postMessage({
				workerId: Papa.WORKER_ID,
				results: Papa.parse(msg.input, msg.config),
				finished: true
			});
		}
		else if ((global.File && msg.input instanceof File) || msg.input instanceof Object)	// thank you, Safari (see issue #106)
		{
			var results = Papa.parse(msg.input, msg.config);
			if (results)
				global.postMessage({
					workerId: Papa.WORKER_ID,
					results: results,
					finished: true
				});
		}
	}

	/** Makes a deep copy of an array or object (mostly) */
	function copy(obj)
	{
		if (typeof obj !== 'object' || obj === null)
			return obj;
		var cpy = Array.isArray(obj) ? [] : {};
		for (var key in obj)
			cpy[key] = copy(obj[key]);
		return cpy;
	}

	function bindFunction(f, self)
	{
		return function() { f.apply(self, arguments); };
	}

	function isFunction(func)
	{
		return typeof func === 'function';
	}

	return Papa;
}));
},
'appivo/util/ExcelExport':function(){
define([
    'dojo/Deferred',
    'sheetjs/xlsx'
], function(Deferred, xlsx) {

    return {
        xlsx: null,

        export: function(records, opts) {
            var t = this;
            if (!opts) {
                opts = {};
            }
            var def = new Deferred();
            t.xlsx = xlsx;
            if (records.length > 0 && records[0].constructor === Array) {
                var res = t._exportAoA(records, opts);
            } else {
                if (!opts.mapping && records.length > 0) {
                    var genHeaders = false;
                    if (!opts.headers) {
                        opts.headers = {
                            'Sheet1': []
                        }
                        genHeaders = true;
                    }
                    opts.mapping = {
                        'Sheet1': {}
                    };
                    var col = 0;
                    var record = records[0];
                    if (record.__model) {
                    	var model = record.__model;
                    	var attrs = model.getAttributes();
                    	for (var i = 0; i < attrs.length; i++) {
                    		var attr = attrs[i];
                    		if (!attr.system) {
                    			opts.mapping.Sheet1[col++] = {
                    				source: attr.name	
                    			};
                    			if (genHeaders) {
                    				opts.headers.Sheet1.push(attr.name);
                    			}
                    		}
                    	}
                    } else {
                    	for (var attr in record) {
                    		if (attr.indexOf("_") != 0) {
	                    		opts.mapping.Sheet1[col++] = {
	                    			source: attr
	                    		};
	                    		if (genHeaders) {
	                    			opts.headers.Sheet1.push(attr);
	                    		}
                    		}
                    	}
                    }
                }
                if (opts.printHeaders === null || opts.printHeaders === undefined) {
                    opts.printHeaders = true;
                }
                if (opts.headers && !genHeaders) {
                    t._resolveMapping(opts);
                }
                if (!opts.dataSet) {
                    opts.dataSet = {
                        col: 0,
                        row: opts.printHeaders ? 1 : 0,
                        headerRow: opts.printHeaders ? 0 : undefined
                    };
                } else if (opts.printHeaders && (opts.dataSet.headerRow === null || opts.dataSet.headerRow === undefined)) {
                    if (opts.dataSet.row > 0) {
                        opts.dataSet.headerRow = opts.dataSet.row - 1;
                    } else {
                        opts.dataSet.headerRow = 0;
                        opts.dataSet.row = 1;
                    }
                }
                var res = t._export(records, opts);
            }
            def.resolve(res);
            return def;
        },

        _export: function(records, opts) {
            var wb = { SheetNames:[], Sheets:{} };
            for (var sheet in opts.mapping) {
                wb.SheetNames.push(sheet);
                wb.Sheets[sheet] = {
                    _range: {
                        s: {
                            c: Number.POSITIVE_INFINITY,
                            r: Number.POSITIVE_INFINITY
                        },
                        e: {
                            c: Number.NEGATIVE_INFINITY,
                            r: Number.NEGATIVE_INFINITY
                        }
                    }
                };
                if (opts.printHeaders) {
                    var row = opts.dataSet.headerRow;
                    var startCol = opts.dataSet.col;
                    wb.Sheets[sheet]._range.s.c = startCol;
                    wb.Sheets[sheet]._range.s.r = row;
                    for (var i = 0; i < opts.headers[sheet].length; i++) {
                        var cellRef = this.xlsx.utils.encode_cell({ c: startCol + i, r: row });
                        wb.Sheets[sheet][cellRef] = {
                            t: 's',
                            v: opts.headers[sheet][i]
                        };
                    }
                }
            }
            var startRow = opts.dataSet.row;
            for (var i = 0; i < records.length; i++) {
                var rec = records[i];
                for (var s in opts.mapping) {
                    var row = startRow + i;
                    if (row < wb.Sheets[s]._range.s.r) {
                        wb.Sheets[s]._range.s.r = row;
                    }
                    if (row > wb.Sheets[s]._range.e.r) {
                        wb.Sheets[s]._range.e.r = row;
                    }
                    var sheet = opts.mapping[s];
                    for (var col in sheet) {
                    	var ncol = parseInt(col);
                        if (col < wb.Sheets[s]._range.s.c) {
                            wb.Sheets[s]._range.s.c = ncol;
                        }
                        if (col > wb.Sheets[s]._range.e.c) {
                            wb.Sheets[s]._range.e.c = ncol;
                        }
                        var cell = this._makeCell(rec, sheet[col]);
                        var cellRef = this.xlsx.utils.encode_cell({ c: ncol, r: row });
                        wb.Sheets[s][cellRef] = cell;
                    }

                    this.autofitColumns(records, wb.Sheets[s], opts.headers ? opts.headers[s] : null, opts.mapping[s]);
                }
            }
            for (var s in wb.Sheets) {
                var sheet = wb.Sheets[s];
                if (sheet._range.e.c === Number.NEGATIVE_INFINITY) {
                    sheet._range.e.c = 0;
                }
                if (sheet._range.e.r === Number.NEGATIVE_INFINITY) {
                    sheet._range.e.r = 0;
                }
                sheet['!ref'] = this.xlsx.utils.encode_range(sheet._range);
                delete sheet._range;
            }
            var fopts = {
                type: "binary"
            };
            if (opts.format) {
                switch (opts.format) {
                    case "csv":
                        delete fopts.type;
                        fopts.bookType = "csv";
                        break;
                    case "tsv":
                        delete fopts.type;
                        fopts.bookType = "csv";
                        fopts.FS = "\t";
                        break;
                }
            }
            var bin = this.xlsx.write(wb, fopts);
            return new Blob([this._binStr2ArrBuff(bin)], {type: ""});
        },

        autofitColumns: function(json, worksheet, headers, mapping) {
            var objectMaxLength = [];
            for (var i = 0; i < headers.length; i++) {
                var header = headers[i];
                objectMaxLength.push(header ? header.length : 2);
            }
            for (var i = 0; i < json.length; i++) {
                var record = json[i];
                for (var k = 0; k < headers.length; k++) {
                    var header = headers[k];
                    var col = mapping[k];
                    var value = null;
                    if (col.source) {
                        value = record[col.source];
                    }
                    if (col.mapping) {
                        if (typeof col.mapping === "function") {
                            value = col.mapping(record);
                        }  else if (typeof col.map === 'object') {
                            value = col.map[value];
                        }
                    }
                    var len = 10;
                    if (typeof value == "number") {
                        len = 10;
                    } else {
                        len = value ? value.length : 0;
                    }
                    objectMaxLength[k] = objectMaxLength[k] >= len ? objectMaxLength[k] : len;
                }
            }

            var wscols = objectMaxLength.map(function(w) {
                return {
                    width: w
                }
            });

            worksheet["!cols"] = wscols;
        },

        _exportAoA: function(rows, opts) {
            var wb = { SheetNames:[], Sheets:{} };
            var sheetName = opts.sheetName || "Sheet1";
            wb.SheetNames.push(sheetName);
            wb.Sheets[sheetName] = this.xlsx.utils.aoa_to_sheet(rows)
            var bin = this.xlsx.write(wb, {type: "binary"});
            return new Blob([this._binStr2ArrBuff(bin)], { type: "" });
        },

        _makeCell: function(record, mapping) {
            var value = null;
            if (mapping.source) {
                value = record[mapping.source];
            }
            if (mapping.map) {
                var func = null;
                if (typeof mapping.map === 'function') {
                    func = mapping.map;
                } else if (typeof mapping.map === 'string') {
                    try {
                        func = new Function('val', 'record', mapping.map);
                    } catch (e) {
                        console.error(e);
                    }
                }
                if (func) {
                    var val = func(value, record);
                    if (val !== undefined) {
                        value = val;
                    }
                } else if (typeof mapping.map === 'object') {
                    value = mapping.map[value];
                }
            }
            var cell = {
                v: value,
                t: 's'
            };
            switch (typeof value) {
            case 'number':
                cell.t = 'n';
                break;
            case 'boolean':
                cell.t = 'b';
                break;
            case 'string':
                if (value && value.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/)) {
                    cell.v = this._getExcelDate(value);
                    cell.t = 'n';
                    cell.z = this.xlsx.SSF._table[14];
                }
                break;
        	default:
        		if (value === null || value === undefined) {
        			cell.v = "";
        		}
            }
            return cell;
        },

        _getExcelDate: function(date) {
            return (new Date(date) - new Date('1900-01-01')) / (24 * 60 * 60 * 1000) + 2;
        },

        _binStr2ArrBuff: function (s) {
            var buf = new ArrayBuffer(s.length);
            var arr = new Uint8Array(buf);
            for (var i = 0; i != s.length; i++){
                arr[i] = s.charCodeAt(i) & 0xFF;
            }
            return buf;
        },

        _resolveMapping: function(opts) {
            for (var sheet in opts.mapping) {
                var headerMap = {};
                if (opts.headers[sheet]) {
                    for (var i = 0; i < opts.headers[sheet].length; i++) {
                        headerMap[opts.headers[sheet][i]] = i;
                    }
                    for (var attr in opts.mapping[sheet]) {
                        var colNum = headerMap[attr];
                        if (colNum !== undefined) {
                            opts.mapping[sheet][colNum] = opts.mapping[sheet][attr];
                        }
                        delete opts.mapping[sheet][attr];
                    }
                }
            }
        }
    };
});
},
'sheetjs/xlsx':function(){
/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */
/* vim: set ts=2: */
/*exported XLSX */
/*global global, exports, module, require:false, process:false, Buffer:false, ArrayBuffer:false, DataView:false, Deno:false, Set:false */
var XLSX = {};
function make_xlsx_lib(XLSX){
XLSX.version = '0.18.12';
var current_codepage = 1200, current_ansi = 1252;
/*global cptable:true, window */
var $cptable;

var VALID_ANSI = [ 874, 932, 936, 949, 950, 1250, 1251, 1252, 1253, 1254, 1255, 1256, 1257, 1258, 10000 ];
/* ECMA-376 Part I 18.4.1 charset to codepage mapping */
var CS2CP = ({
0:    1252, /* ANSI */
1:   65001, /* DEFAULT */
2:   65001, /* SYMBOL */
77:  10000, /* MAC */
128:   932, /* SHIFTJIS */
129:   949, /* HANGUL */
130:  1361, /* JOHAB */
134:   936, /* GB2312 */
136:   950, /* CHINESEBIG5 */
161:  1253, /* GREEK */
162:  1254, /* TURKISH */
163:  1258, /* VIETNAMESE */
177:  1255, /* HEBREW */
178:  1256, /* ARABIC */
186:  1257, /* BALTIC */
204:  1251, /* RUSSIAN */
222:   874, /* THAI */
238:  1250, /* EASTEUROPE */
255:  1252, /* OEM */
69:   6969  /* MISC */
});

var set_ansi = function(cp) { if(VALID_ANSI.indexOf(cp) == -1) return; current_ansi = CS2CP[0] = cp; };
function reset_ansi() { set_ansi(1252); }

var set_cp = function(cp) { current_codepage = cp; set_ansi(cp); };
function reset_cp() { set_cp(1200); reset_ansi(); }

function char_codes(data) { var o = []; for(var i = 0, len = data.length; i < len; ++i) o[i] = data.charCodeAt(i); return o; }

function utf16leread(data) {
	var o = [];
	for(var i = 0; i < (data.length>>1); ++i) o[i] = String.fromCharCode(data.charCodeAt(2*i) + (data.charCodeAt(2*i+1)<<8));
	return o.join("");
}
function utf16beread(data) {
	var o = [];
	for(var i = 0; i < (data.length>>1); ++i) o[i] = String.fromCharCode(data.charCodeAt(2*i+1) + (data.charCodeAt(2*i)<<8));
	return o.join("");
}

var debom = function(data) {
	var c1 = data.charCodeAt(0), c2 = data.charCodeAt(1);
	if(c1 == 0xFF && c2 == 0xFE) return utf16leread(data.slice(2));
	if(c1 == 0xFE && c2 == 0xFF) return utf16beread(data.slice(2));
	if(c1 == 0xFEFF) return data.slice(1);
	return data;
};

var _getchar = function _gc1(x) { return String.fromCharCode(x); };
var _getansi = function _ga1(x) { return String.fromCharCode(x); };

function set_cptable(cptable) {
	$cptable = cptable;
	set_cp = function(cp) { current_codepage = cp; set_ansi(cp); };
	debom = function(data) {
		if(data.charCodeAt(0) === 0xFF && data.charCodeAt(1) === 0xFE) { return $cptable.utils.decode(1200, char_codes(data.slice(2))); }
		return data;
	};
	_getchar = function _gc2(x) {
		if(current_codepage === 1200) return String.fromCharCode(x);
		return $cptable.utils.decode(current_codepage, [x&255,x>>8])[0];
	};
	_getansi = function _ga2(x) {
		return $cptable.utils.decode(current_ansi, [x])[0];
	};
	cpdoit();
}
var DENSE = null;
var DIF_XL = true;
var Base64_map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function Base64_encode(input) {
  var o = "";
  var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
  for (var i = 0; i < input.length; ) {
    c1 = input.charCodeAt(i++);
    e1 = c1 >> 2;
    c2 = input.charCodeAt(i++);
    e2 = (c1 & 3) << 4 | c2 >> 4;
    c3 = input.charCodeAt(i++);
    e3 = (c2 & 15) << 2 | c3 >> 6;
    e4 = c3 & 63;
    if (isNaN(c2)) {
      e3 = e4 = 64;
    } else if (isNaN(c3)) {
      e4 = 64;
    }
    o += Base64_map.charAt(e1) + Base64_map.charAt(e2) + Base64_map.charAt(e3) + Base64_map.charAt(e4);
  }
  return o;
}
function Base64_encode_pass(input) {
  var o = "";
  var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
  for (var i = 0; i < input.length; ) {
    c1 = input.charCodeAt(i++);
    if (c1 > 255)
      c1 = 95;
    e1 = c1 >> 2;
    c2 = input.charCodeAt(i++);
    if (c2 > 255)
      c2 = 95;
    e2 = (c1 & 3) << 4 | c2 >> 4;
    c3 = input.charCodeAt(i++);
    if (c3 > 255)
      c3 = 95;
    e3 = (c2 & 15) << 2 | c3 >> 6;
    e4 = c3 & 63;
    if (isNaN(c2)) {
      e3 = e4 = 64;
    } else if (isNaN(c3)) {
      e4 = 64;
    }
    o += Base64_map.charAt(e1) + Base64_map.charAt(e2) + Base64_map.charAt(e3) + Base64_map.charAt(e4);
  }
  return o;
}
function Base64_decode(input) {
  var o = "";
  var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
  input = input.replace(/^data:([^\/]+\/[^\/]+)?;base64\,/, "").replace(/[^\w\+\/\=]/g, "");
  for (var i = 0; i < input.length; ) {
    e1 = Base64_map.indexOf(input.charAt(i++));
    e2 = Base64_map.indexOf(input.charAt(i++));
    c1 = e1 << 2 | e2 >> 4;
    o += String.fromCharCode(c1);
    e3 = Base64_map.indexOf(input.charAt(i++));
    c2 = (e2 & 15) << 4 | e3 >> 2;
    if (e3 !== 64) {
      o += String.fromCharCode(c2);
    }
    e4 = Base64_map.indexOf(input.charAt(i++));
    c3 = (e3 & 3) << 6 | e4;
    if (e4 !== 64) {
      o += String.fromCharCode(c3);
    }
  }
  return o;
}
var has_buf = (function() { return typeof Buffer !== 'undefined' && typeof process !== 'undefined' && typeof process.versions !== 'undefined' && !!process.versions.node; })();

var Buffer_from = (function() {
	if(typeof Buffer !== 'undefined') {
		var nbfs = !Buffer.from;
		if(!nbfs) try { Buffer.from("foo", "utf8"); } catch(e) { nbfs = true; }
		return nbfs ? function(buf, enc) { return (enc) ? new Buffer(buf, enc) : new Buffer(buf); } : Buffer.from.bind(Buffer);
	}
	return function() {};
})();
var buf_utf16le = (function() {
	if(typeof Buffer === 'undefined') return false;
	var x = Buffer_from([65,0]);
	if(!x) return false;
	var o = x.toString("utf16le");
	return o.length == 1;
})();


function new_raw_buf(len) {
	/* jshint -W056 */
	if(has_buf) return Buffer.alloc ? Buffer.alloc(len) : new Buffer(len);
	return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
	/* jshint +W056 */
}

function new_unsafe_buf(len) {
	/* jshint -W056 */
	if(has_buf) return Buffer.allocUnsafe ? Buffer.allocUnsafe(len) : new Buffer(len);
	return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
	/* jshint +W056 */
}

var s2a = function s2a(s) {
	if(has_buf) return Buffer_from(s, "binary");
	return s.split("").map(function(x){ return x.charCodeAt(0) & 0xff; });
};

function s2ab(s) {
	if(typeof ArrayBuffer === 'undefined') return s2a(s);
	var buf = new ArrayBuffer(s.length), view = new Uint8Array(buf);
	for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
	return buf;
}

function a2s(data) {
	if(Array.isArray(data)) return data.map(function(c) { return String.fromCharCode(c); }).join("");
	var o = []; for(var i = 0; i < data.length; ++i) o[i] = String.fromCharCode(data[i]); return o.join("");
}

function a2u(data) {
	if(typeof Uint8Array === 'undefined') throw new Error("Unsupported");
	return new Uint8Array(data);
}

function ab2a(data) {
	if(typeof ArrayBuffer == 'undefined') throw new Error("Unsupported");
	if(data instanceof ArrayBuffer) return ab2a(new Uint8Array(data));
var o = new Array(data.length);
	for(var i = 0; i < data.length; ++i) o[i] = data[i];
	return o;
}

var bconcat = has_buf ? function(bufs) { return Buffer.concat(bufs.map(function(buf) { return Buffer.isBuffer(buf) ? buf : Buffer_from(buf); })); } : function(bufs) {
	if(typeof Uint8Array !== "undefined") {
		var i = 0, maxlen = 0;
		for(i = 0; i < bufs.length; ++i) maxlen += bufs[i].length;
		var o = new Uint8Array(maxlen);
		var len = 0;
		for(i = 0, maxlen = 0; i < bufs.length; maxlen += len, ++i) {
			len = bufs[i].length;
			if(bufs[i] instanceof Uint8Array) o.set(bufs[i], maxlen);
			else if(typeof bufs[i] == "string") o.set(new Uint8Array(s2a(bufs[i])), maxlen);
			else o.set(new Uint8Array(bufs[i]), maxlen);
		}
		return o;
	}
	return [].concat.apply([], bufs.map(function(buf) { return Array.isArray(buf) ? buf : [].slice.call(buf); }));
};

function utf8decode(content) {
	var out = [], widx = 0, L = content.length + 250;
	var o = new_raw_buf(content.length + 255);
	for(var ridx = 0; ridx < content.length; ++ridx) {
		var c = content.charCodeAt(ridx);
		if(c < 0x80) o[widx++] = c;
		else if(c < 0x800) {
			o[widx++] = (192|((c>>6)&31));
			o[widx++] = (128|(c&63));
		} else if(c >= 0xD800 && c < 0xE000) {
			c = (c&1023)+64;
			var d = content.charCodeAt(++ridx)&1023;
			o[widx++] = (240|((c>>8)&7));
			o[widx++] = (128|((c>>2)&63));
			o[widx++] = (128|((d>>6)&15)|((c&3)<<4));
			o[widx++] = (128|(d&63));
		} else {
			o[widx++] = (224|((c>>12)&15));
			o[widx++] = (128|((c>>6)&63));
			o[widx++] = (128|(c&63));
		}
		if(widx > L) {
			out.push(o.slice(0, widx));
			widx = 0;
			o = new_raw_buf(65535);
			L = 65530;
		}
	}
	out.push(o.slice(0, widx));
	return bconcat(out);
}

var chr0 = /\u0000/g, chr1 = /[\u0001-\u0006]/g;
/* ssf.js (C) 2013-present SheetJS -- http://sheetjs.com */
/*jshint -W041 */
function _strrev(x) { var o = "", i = x.length-1; while(i>=0) o += x.charAt(i--); return o; }
function pad0(v,d){var t=""+v; return t.length>=d?t:fill('0',d-t.length)+t;}
function pad_(v,d){var t=""+v;return t.length>=d?t:fill(' ',d-t.length)+t;}
function rpad_(v,d){var t=""+v; return t.length>=d?t:t+fill(' ',d-t.length);}
function pad0r1(v,d){var t=""+Math.round(v); return t.length>=d?t:fill('0',d-t.length)+t;}
function pad0r2(v,d){var t=""+v; return t.length>=d?t:fill('0',d-t.length)+t;}
var p2_32 = Math.pow(2,32);
function pad0r(v,d){if(v>p2_32||v<-p2_32) return pad0r1(v,d); var i = Math.round(v); return pad0r2(i,d); }
/* yes, in 2022 this is still faster than string compare */
function SSF_isgeneral(s, i) { i = i || 0; return s.length >= 7 + i && (s.charCodeAt(i)|32) === 103 && (s.charCodeAt(i+1)|32) === 101 && (s.charCodeAt(i+2)|32) === 110 && (s.charCodeAt(i+3)|32) === 101 && (s.charCodeAt(i+4)|32) === 114 && (s.charCodeAt(i+5)|32) === 97 && (s.charCodeAt(i+6)|32) === 108; }
var days = [
	['Sun', 'Sunday'],
	['Mon', 'Monday'],
	['Tue', 'Tuesday'],
	['Wed', 'Wednesday'],
	['Thu', 'Thursday'],
	['Fri', 'Friday'],
	['Sat', 'Saturday']
];
var months = [
	['J', 'Jan', 'January'],
	['F', 'Feb', 'February'],
	['M', 'Mar', 'March'],
	['A', 'Apr', 'April'],
	['M', 'May', 'May'],
	['J', 'Jun', 'June'],
	['J', 'Jul', 'July'],
	['A', 'Aug', 'August'],
	['S', 'Sep', 'September'],
	['O', 'Oct', 'October'],
	['N', 'Nov', 'November'],
	['D', 'Dec', 'December']
];
function SSF_init_table(t) {
	if(!t) t = {};
	t[0]=  'General';
	t[1]=  '0';
	t[2]=  '0.00';
	t[3]=  '#,##0';
	t[4]=  '#,##0.00';
	t[9]=  '0%';
	t[10]= '0.00%';
	t[11]= '0.00E+00';
	t[12]= '# ?/?';
	t[13]= '# ??/??';
	t[14]= 'm/d/yy';
	t[15]= 'd-mmm-yy';
	t[16]= 'd-mmm';
	t[17]= 'mmm-yy';
	t[18]= 'h:mm AM/PM';
	t[19]= 'h:mm:ss AM/PM';
	t[20]= 'h:mm';
	t[21]= 'h:mm:ss';
	t[22]= 'm/d/yy h:mm';
	t[37]= '#,##0 ;(#,##0)';
	t[38]= '#,##0 ;[Red](#,##0)';
	t[39]= '#,##0.00;(#,##0.00)';
	t[40]= '#,##0.00;[Red](#,##0.00)';
	t[45]= 'mm:ss';
	t[46]= '[h]:mm:ss';
	t[47]= 'mmss.0';
	t[48]= '##0.0E+0';
	t[49]= '@';
	t[56]= '"上午/下午 "hh"時"mm"分"ss"秒 "';
	return t;
}
/* repeated to satiate webpack */
var table_fmt = {
	0:  'General',
	1:  '0',
	2:  '0.00',
	3:  '#,##0',
	4:  '#,##0.00',
	9:  '0%',
	10: '0.00%',
	11: '0.00E+00',
	12: '# ?/?',
	13: '# ??/??',
	14: 'm/d/yy',
	15: 'd-mmm-yy',
	16: 'd-mmm',
	17: 'mmm-yy',
	18: 'h:mm AM/PM',
	19: 'h:mm:ss AM/PM',
	20: 'h:mm',
	21: 'h:mm:ss',
	22: 'm/d/yy h:mm',
	37: '#,##0 ;(#,##0)',
	38: '#,##0 ;[Red](#,##0)',
	39: '#,##0.00;(#,##0.00)',
	40: '#,##0.00;[Red](#,##0.00)',
	45: 'mm:ss',
	46: '[h]:mm:ss',
	47: 'mmss.0',
	48: '##0.0E+0',
	49: '@',
	56: '"上午/下午 "hh"時"mm"分"ss"秒 "'
};

/* Defaults determined by systematically testing in Excel 2019 */

/* These formats appear to default to other formats in the table */
var SSF_default_map = {
	5:  37, 6:  38, 7:  39, 8:  40,         //  5 -> 37 ...  8 -> 40

	23:  0, 24:  0, 25:  0, 26:  0,         // 23 ->  0 ... 26 ->  0

	27: 14, 28: 14, 29: 14, 30: 14, 31: 14, // 27 -> 14 ... 31 -> 14

	50: 14, 51: 14, 52: 14, 53: 14, 54: 14, // 50 -> 14 ... 58 -> 14
	55: 14, 56: 14, 57: 14, 58: 14,
	59:  1, 60:  2, 61:  3, 62:  4,         // 59 ->  1 ... 62 ->  4

	67:  9, 68: 10,                         // 67 ->  9 ... 68 -> 10
	69: 12, 70: 13, 71: 14,                 // 69 -> 12 ... 71 -> 14
	72: 14, 73: 15, 74: 16, 75: 17,         // 72 -> 14 ... 75 -> 17
	76: 20, 77: 21, 78: 22,                 // 76 -> 20 ... 78 -> 22
	79: 45, 80: 46, 81: 47,                 // 79 -> 45 ... 81 -> 47
	82: 0                                   // 82 ->  0 ... 65536 -> 0 (omitted)
};


/* These formats technically refer to Accounting formats with no equivalent */
var SSF_default_str = {
	//  5 -- Currency,   0 decimal, black negative
	5:  '"$"#,##0_);\\("$"#,##0\\)',
	63: '"$"#,##0_);\\("$"#,##0\\)',

	//  6 -- Currency,   0 decimal, red   negative
	6:  '"$"#,##0_);[Red]\\("$"#,##0\\)',
	64: '"$"#,##0_);[Red]\\("$"#,##0\\)',

	//  7 -- Currency,   2 decimal, black negative
	7:  '"$"#,##0.00_);\\("$"#,##0.00\\)',
	65: '"$"#,##0.00_);\\("$"#,##0.00\\)',

	//  8 -- Currency,   2 decimal, red   negative
	8:  '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
	66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',

	// 41 -- Accounting, 0 decimal, No Symbol
	41: '_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)',

	// 42 -- Accounting, 0 decimal, $  Symbol
	42: '_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)',

	// 43 -- Accounting, 2 decimal, No Symbol
	43: '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)',

	// 44 -- Accounting, 2 decimal, $  Symbol
	44: '_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)'
};

function SSF_frac(x, D, mixed) {
	var sgn = x < 0 ? -1 : 1;
	var B = x * sgn;
	var P_2 = 0, P_1 = 1, P = 0;
	var Q_2 = 1, Q_1 = 0, Q = 0;
	var A = Math.floor(B);
	while(Q_1 < D) {
		A = Math.floor(B);
		P = A * P_1 + P_2;
		Q = A * Q_1 + Q_2;
		if((B - A) < 0.00000005) break;
		B = 1 / (B - A);
		P_2 = P_1; P_1 = P;
		Q_2 = Q_1; Q_1 = Q;
	}
	if(Q > D) { if(Q_1 > D) { Q = Q_2; P = P_2; } else { Q = Q_1; P = P_1; } }
	if(!mixed) return [0, sgn * P, Q];
	var q = Math.floor(sgn * P/Q);
	return [q, sgn*P - q*Q, Q];
}
function SSF_parse_date_code(v,opts,b2) {
	if(v > 2958465 || v < 0) return null;
	var date = (v|0), time = Math.floor(86400 * (v - date)), dow=0;
	var dout=[];
	var out={D:date, T:time, u:86400*(v-date)-time,y:0,m:0,d:0,H:0,M:0,S:0,q:0};
	if(Math.abs(out.u) < 1e-6) out.u = 0;
	if(opts && opts.date1904) date += 1462;
	if(out.u > 0.9999) {
		out.u = 0;
		if(++time == 86400) { out.T = time = 0; ++date; ++out.D; }
	}
	if(date === 60) {dout = b2 ? [1317,10,29] : [1900,2,29]; dow=3;}
	else if(date === 0) {dout = b2 ? [1317,8,29] : [1900,1,0]; dow=6;}
	else {
		if(date > 60) --date;
		/* 1 = Jan 1 1900 in Gregorian */
		var d = new Date(1900, 0, 1);
		d.setDate(d.getDate() + date - 1);
		dout = [d.getFullYear(), d.getMonth()+1,d.getDate()];
		dow = d.getDay();
		if(date < 60) dow = (dow + 6) % 7;
		if(b2) dow = SSF_fix_hijri(d, dout);
	}
	out.y = dout[0]; out.m = dout[1]; out.d = dout[2];
	out.S = time % 60; time = Math.floor(time / 60);
	out.M = time % 60; time = Math.floor(time / 60);
	out.H = time;
	out.q = dow;
	return out;
}
var SSFbasedate = new Date(1899, 11, 31, 0, 0, 0);
var SSFdnthresh = SSFbasedate.getTime();
var SSFbase1904 = new Date(1900, 2, 1, 0, 0, 0);
function datenum_local(v, date1904) {
	var epoch = v.getTime();
	if(date1904) epoch -= 1461*24*60*60*1000;
	else if(v >= SSFbase1904) epoch += 24*60*60*1000;
	return (epoch - (SSFdnthresh + (v.getTimezoneOffset() - SSFbasedate.getTimezoneOffset()) * 60000)) / (24 * 60 * 60 * 1000);
}
/* ECMA-376 18.8.30 numFmt*/
/* Note: `toPrecision` uses standard form when prec > E and E >= -6 */
/* exponent >= -9 and <= 9 */
function SSF_strip_decimal(o) {
	return (o.indexOf(".") == -1) ? o : o.replace(/(?:\.0*|(\.\d*[1-9])0+)$/, "$1");
}

/* General Exponential always shows 2 digits exp and trims the mantissa */
function SSF_normalize_exp(o) {
	if(o.indexOf("E") == -1) return o;
	return o.replace(/(?:\.0*|(\.\d*[1-9])0+)[Ee]/,"$1E").replace(/(E[+-])(\d)$/,"$10$2");
}

/* exponent >= -9 and <= 9 */
function SSF_small_exp(v) {
	var w = (v<0?12:11);
	var o = SSF_strip_decimal(v.toFixed(12)); if(o.length <= w) return o;
	o = v.toPrecision(10); if(o.length <= w) return o;
	return v.toExponential(5);
}

/* exponent >= 11 or <= -10 likely exponential */
function SSF_large_exp(v) {
	var o = SSF_strip_decimal(v.toFixed(11));
	return (o.length > (v<0?12:11) || o === "0" || o === "-0") ? v.toPrecision(6) : o;
}

function SSF_general_num(v) {
	var V = Math.floor(Math.log(Math.abs(v))*Math.LOG10E), o;

	if(V >= -4 && V <= -1) o = v.toPrecision(10+V);
	else if(Math.abs(V) <= 9) o = SSF_small_exp(v);
	else if(V === 10) o = v.toFixed(10).substr(0,12);
	else o = SSF_large_exp(v);

	return SSF_strip_decimal(SSF_normalize_exp(o.toUpperCase()));
}


/*
	"General" rules:
	- text is passed through ("@")
	- booleans are rendered as TRUE/FALSE
	- "up to 11 characters" displayed for numbers
	- Default date format (code 14) used for Dates

	The longest 32-bit integer text is "-2147483648", exactly 11 chars
	TODO: technically the display depends on the width of the cell
*/
function SSF_general(v, opts) {
	switch(typeof v) {
		case 'string': return v;
		case 'boolean': return v ? "TRUE" : "FALSE";
		case 'number': return (v|0) === v ? v.toString(10) : SSF_general_num(v);
		case 'undefined': return "";
		case 'object':
			if(v == null) return "";
			if(v instanceof Date) return SSF_format(14, datenum_local(v, opts && opts.date1904), opts);
	}
	throw new Error("unsupported value in General format: " + v);
}

function SSF_fix_hijri(date, o) {
  /* TODO: properly adjust y/m/d and  */
  o[0] -= 581;
  var dow = date.getDay();
  if(date < 60) dow = (dow + 6) % 7;
  return dow;
}
//var THAI_DIGITS = "\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59".split("");
function SSF_write_date(type, fmt, val, ss0) {
	var o="", ss=0, tt=0, y = val.y, out, outl = 0;
	switch(type) {
		case 98: /* 'b' buddhist year */
			y = val.y + 543;
			/* falls through */
		case 121: /* 'y' year */
		switch(fmt.length) {
			case 1: case 2: out = y % 100; outl = 2; break;
			default: out = y % 10000; outl = 4; break;
		} break;
		case 109: /* 'm' month */
		switch(fmt.length) {
			case 1: case 2: out = val.m; outl = fmt.length; break;
			case 3: return months[val.m-1][1];
			case 5: return months[val.m-1][0];
			default: return months[val.m-1][2];
		} break;
		case 100: /* 'd' day */
		switch(fmt.length) {
			case 1: case 2: out = val.d; outl = fmt.length; break;
			case 3: return days[val.q][0];
			default: return days[val.q][1];
		} break;
		case 104: /* 'h' 12-hour */
		switch(fmt.length) {
			case 1: case 2: out = 1+(val.H+11)%12; outl = fmt.length; break;
			default: throw 'bad hour format: ' + fmt;
		} break;
		case 72: /* 'H' 24-hour */
		switch(fmt.length) {
			case 1: case 2: out = val.H; outl = fmt.length; break;
			default: throw 'bad hour format: ' + fmt;
		} break;
		case 77: /* 'M' minutes */
		switch(fmt.length) {
			case 1: case 2: out = val.M; outl = fmt.length; break;
			default: throw 'bad minute format: ' + fmt;
		} break;
		case 115: /* 's' seconds */
			if(fmt != 's' && fmt != 'ss' && fmt != '.0' && fmt != '.00' && fmt != '.000') throw 'bad second format: ' + fmt;
			if(val.u === 0 && (fmt == "s" || fmt == "ss")) return pad0(val.S, fmt.length);
if(ss0 >= 2) tt = ss0 === 3 ? 1000 : 100;
			else tt = ss0 === 1 ? 10 : 1;
			ss = Math.round((tt)*(val.S + val.u));
			if(ss >= 60*tt) ss = 0;
			if(fmt === 's') return ss === 0 ? "0" : ""+ss/tt;
			o = pad0(ss,2 + ss0);
			if(fmt === 'ss') return o.substr(0,2);
			return "." + o.substr(2,fmt.length-1);
		case 90: /* 'Z' absolute time */
		switch(fmt) {
			case '[h]': case '[hh]': out = val.D*24+val.H; break;
			case '[m]': case '[mm]': out = (val.D*24+val.H)*60+val.M; break;
			case '[s]': case '[ss]': out = ((val.D*24+val.H)*60+val.M)*60+Math.round(val.S+val.u); break;
			default: throw 'bad abstime format: ' + fmt;
		} outl = fmt.length === 3 ? 1 : 2; break;
		case 101: /* 'e' era */
			out = y; outl = 1; break;
	}
	var outstr = outl > 0 ? pad0(out, outl) : "";
	return outstr;
}


/*jshint -W086 */
/*jshint +W086 */
function commaify(s) {
	var w = 3;
	if(s.length <= w) return s;
	var j = (s.length % w), o = s.substr(0,j);
	for(; j!=s.length; j+=w) o+=(o.length > 0 ? "," : "") + s.substr(j,w);
	return o;
}
var pct1 = /%/g;
function write_num_pct(type, fmt, val){
	var sfmt = fmt.replace(pct1,""), mul = fmt.length - sfmt.length;
	return write_num(type, sfmt, val * Math.pow(10,2*mul)) + fill("%",mul);
}

function write_num_cm(type, fmt, val){
	var idx = fmt.length - 1;
	while(fmt.charCodeAt(idx-1) === 44) --idx;
	return write_num(type, fmt.substr(0,idx), val / Math.pow(10,3*(fmt.length-idx)));
}

function write_num_exp(fmt, val){
	var o;
	var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
	if(fmt.match(/^#+0.0E\+0$/)) {
		if(val == 0) return "0.0E+0";
		else if(val < 0) return "-" + write_num_exp(fmt, -val);
		var period = fmt.indexOf("."); if(period === -1) period=fmt.indexOf('E');
		var ee = Math.floor(Math.log(val)*Math.LOG10E)%period;
		if(ee < 0) ee += period;
		o = (val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);
		if(o.indexOf("e") === -1) {
			var fakee = Math.floor(Math.log(val)*Math.LOG10E);
			if(o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length+ee);
			else o += "E+" + (fakee - ee);
			while(o.substr(0,2) === "0.") {
				o = o.charAt(0) + o.substr(2,period) + "." + o.substr(2+period);
				o = o.replace(/^0+([1-9])/,"$1").replace(/^0+\./,"0.");
			}
			o = o.replace(/\+-/,"-");
		}
		o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3) { return $1 + $2 + $3.substr(0,(period+ee)%period) + "." + $3.substr(ee) + "E"; });
	} else o = val.toExponential(idx);
	if(fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0,o.length-1) + "0" + o.charAt(o.length-1);
	if(fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/,"e");
	return o.replace("e","E");
}
var frac1 = /# (\?+)( ?)\/( ?)(\d+)/;
function write_num_f1(r, aval, sign) {
	var den = parseInt(r[4],10), rr = Math.round(aval * den), base = Math.floor(rr/den);
	var myn = (rr - base*den), myd = den;
	return sign + (base === 0 ? "" : ""+base) + " " + (myn === 0 ? fill(" ", r[1].length + 1 + r[4].length) : pad_(myn,r[1].length) + r[2] + "/" + r[3] + pad0(myd,r[4].length));
}
function write_num_f2(r, aval, sign) {
	return sign + (aval === 0 ? "" : ""+aval) + fill(" ", r[1].length + 2 + r[4].length);
}
var dec1 = /^#*0*\.([0#]+)/;
var closeparen = /\).*[0#]/;
var phone = /\(###\) ###\\?-####/;
function hashq(str) {
	var o = "", cc;
	for(var i = 0; i != str.length; ++i) switch((cc=str.charCodeAt(i))) {
		case 35: break;
		case 63: o+= " "; break;
		case 48: o+= "0"; break;
		default: o+= String.fromCharCode(cc);
	}
	return o;
}
function rnd(val, d) { var dd = Math.pow(10,d); return ""+(Math.round(val * dd)/dd); }
function dec(val, d) {
	var _frac = val - Math.floor(val), dd = Math.pow(10,d);
	if (d < ('' + Math.round(_frac * dd)).length) return 0;
	return Math.round(_frac * dd);
}
function carry(val, d) {
	if (d < ('' + Math.round((val-Math.floor(val))*Math.pow(10,d))).length) {
		return 1;
	}
	return 0;
}
function flr(val) {
	if(val < 2147483647 && val > -2147483648) return ""+(val >= 0 ? (val|0) : (val-1|0));
	return ""+Math.floor(val);
}
function write_num_flt(type, fmt, val) {
	if(type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
		var ffmt = fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");
		if(val >= 0) return write_num_flt('n', ffmt, val);
		return '(' + write_num_flt('n', ffmt, -val) + ')';
	}
	if(fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm(type, fmt, val);
	if(fmt.indexOf('%') !== -1) return write_num_pct(type, fmt, val);
	if(fmt.indexOf('E') !== -1) return write_num_exp(fmt, val);
	if(fmt.charCodeAt(0) === 36) return "$"+write_num_flt(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);
	var o;
	var r, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
	if(fmt.match(/^00+$/)) return sign + pad0r(aval,fmt.length);
	if(fmt.match(/^[#?]+$/)) {
		o = pad0r(val,0); if(o === "0") o = "";
		return o.length > fmt.length ? o : hashq(fmt.substr(0,fmt.length-o.length)) + o;
	}
	if((r = fmt.match(frac1))) return write_num_f1(r, aval, sign);
	if(fmt.match(/^#+0+$/)) return sign + pad0r(aval,fmt.length - fmt.indexOf("0"));
	if((r = fmt.match(dec1))) {
		o = rnd(val, r[1].length).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1])).replace(/\.(\d*)$/,function($$, $1) { return "." + $1 + fill("0", hashq(r[1]).length-$1.length); });
		return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./,".");
	}
	fmt = fmt.replace(/^#+([0.])/, "$1");
	if((r = fmt.match(/^(0*)\.(#*)$/))) {
		return sign + rnd(aval, r[2].length).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");
	}
	if((r = fmt.match(/^#{1,3},##0(\.?)$/))) return sign + commaify(pad0r(aval,0));
	if((r = fmt.match(/^#,##0\.([#0]*0)$/))) {
		return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(""+(Math.floor(val) + carry(val, r[1].length))) + "." + pad0(dec(val, r[1].length),r[1].length);
	}
	if((r = fmt.match(/^#,#*,#0/))) return write_num_flt(type,fmt.replace(/^#,#*,/,""),val);
	if((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/))) {
		o = _strrev(write_num_flt(type, fmt.replace(/[\\-]/g,""), val));
		ri = 0;
		return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));
	}
	if(fmt.match(phone)) {
		o = write_num_flt(type, "##########", val);
		return "(" + o.substr(0,3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
	}
	var oa = "";
	if((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))) {
		ri = Math.min(r[4].length,7);
		ff = SSF_frac(aval, Math.pow(10,ri)-1, false);
		o = "" + sign;
		oa = write_num("n", r[1], ff[1]);
		if(oa.charAt(oa.length-1) == " ") oa = oa.substr(0,oa.length-1) + "0";
		o += oa + r[2] + "/" + r[3];
		oa = rpad_(ff[2],ri);
		if(oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length-oa.length)) + oa;
		o += oa;
		return o;
	}
	if((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))) {
		ri = Math.min(Math.max(r[1].length, r[4].length),7);
		ff = SSF_frac(aval, Math.pow(10,ri)-1, true);
		return sign + (ff[0]||(ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1],ri) + r[2] + "/" + r[3] + rpad_(ff[2],ri): fill(" ", 2*ri+1 + r[2].length + r[3].length));
	}
	if((r = fmt.match(/^[#0?]+$/))) {
		o = pad0r(val, 0);
		if(fmt.length <= o.length) return o;
		return hashq(fmt.substr(0,fmt.length-o.length)) + o;
	}
	if((r = fmt.match(/^([#0?]+)\.([#0]+)$/))) {
		o = "" + val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");
		ri = o.indexOf(".");
		var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
		return hashq(fmt.substr(0,lres) + o + fmt.substr(fmt.length-rres));
	}
	if((r = fmt.match(/^00,000\.([#0]*0)$/))) {
		ri = dec(val, r[1].length);
		return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(flr(val)).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$) { return "00," + ($$.length < 3 ? pad0(0,3-$$.length) : "") + $$; }) + "." + pad0(ri,r[1].length);
	}
	switch(fmt) {
		case "###,##0.00": return write_num_flt(type, "#,##0.00", val);
		case "###,###":
		case "##,###":
		case "#,###": var x = commaify(pad0r(aval,0)); return x !== "0" ? sign + x : "";
		case "###,###.00": return write_num_flt(type, "###,##0.00",val).replace(/^0\./,".");
		case "#,###.00": return write_num_flt(type, "#,##0.00",val).replace(/^0\./,".");
		default:
	}
	throw new Error("unsupported format |" + fmt + "|");
}
function write_num_cm2(type, fmt, val){
	var idx = fmt.length - 1;
	while(fmt.charCodeAt(idx-1) === 44) --idx;
	return write_num(type, fmt.substr(0,idx), val / Math.pow(10,3*(fmt.length-idx)));
}
function write_num_pct2(type, fmt, val){
	var sfmt = fmt.replace(pct1,""), mul = fmt.length - sfmt.length;
	return write_num(type, sfmt, val * Math.pow(10,2*mul)) + fill("%",mul);
}
function write_num_exp2(fmt, val){
	var o;
	var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
	if(fmt.match(/^#+0.0E\+0$/)) {
		if(val == 0) return "0.0E+0";
		else if(val < 0) return "-" + write_num_exp2(fmt, -val);
		var period = fmt.indexOf("."); if(period === -1) period=fmt.indexOf('E');
		var ee = Math.floor(Math.log(val)*Math.LOG10E)%period;
		if(ee < 0) ee += period;
		o = (val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);
		if(!o.match(/[Ee]/)) {
			var fakee = Math.floor(Math.log(val)*Math.LOG10E);
			if(o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length+ee);
			else o += "E+" + (fakee - ee);
			o = o.replace(/\+-/,"-");
		}
		o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3) { return $1 + $2 + $3.substr(0,(period+ee)%period) + "." + $3.substr(ee) + "E"; });
	} else o = val.toExponential(idx);
	if(fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0,o.length-1) + "0" + o.charAt(o.length-1);
	if(fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/,"e");
	return o.replace("e","E");
}
function write_num_int(type, fmt, val) {
	if(type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
		var ffmt = fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");
		if(val >= 0) return write_num_int('n', ffmt, val);
		return '(' + write_num_int('n', ffmt, -val) + ')';
	}
	if(fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm2(type, fmt, val);
	if(fmt.indexOf('%') !== -1) return write_num_pct2(type, fmt, val);
	if(fmt.indexOf('E') !== -1) return write_num_exp2(fmt, val);
	if(fmt.charCodeAt(0) === 36) return "$"+write_num_int(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);
	var o;
	var r, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
	if(fmt.match(/^00+$/)) return sign + pad0(aval,fmt.length);
	if(fmt.match(/^[#?]+$/)) {
		o = (""+val); if(val === 0) o = "";
		return o.length > fmt.length ? o : hashq(fmt.substr(0,fmt.length-o.length)) + o;
	}
	if((r = fmt.match(frac1))) return write_num_f2(r, aval, sign);
	if(fmt.match(/^#+0+$/)) return sign + pad0(aval,fmt.length - fmt.indexOf("0"));
	if((r = fmt.match(dec1))) {
o = (""+val).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1]));
		o = o.replace(/\.(\d*)$/,function($$, $1) {
return "." + $1 + fill("0", hashq(r[1]).length-$1.length); });
		return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./,".");
	}
	fmt = fmt.replace(/^#+([0.])/, "$1");
	if((r = fmt.match(/^(0*)\.(#*)$/))) {
		return sign + (""+aval).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");
	}
	if((r = fmt.match(/^#{1,3},##0(\.?)$/))) return sign + commaify((""+aval));
	if((r = fmt.match(/^#,##0\.([#0]*0)$/))) {
		return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify((""+val)) + "." + fill('0',r[1].length);
	}
	if((r = fmt.match(/^#,#*,#0/))) return write_num_int(type,fmt.replace(/^#,#*,/,""),val);
	if((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/))) {
		o = _strrev(write_num_int(type, fmt.replace(/[\\-]/g,""), val));
		ri = 0;
		return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));
	}
	if(fmt.match(phone)) {
		o = write_num_int(type, "##########", val);
		return "(" + o.substr(0,3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
	}
	var oa = "";
	if((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))) {
		ri = Math.min(r[4].length,7);
		ff = SSF_frac(aval, Math.pow(10,ri)-1, false);
		o = "" + sign;
		oa = write_num("n", r[1], ff[1]);
		if(oa.charAt(oa.length-1) == " ") oa = oa.substr(0,oa.length-1) + "0";
		o += oa + r[2] + "/" + r[3];
		oa = rpad_(ff[2],ri);
		if(oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length-oa.length)) + oa;
		o += oa;
		return o;
	}
	if((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))) {
		ri = Math.min(Math.max(r[1].length, r[4].length),7);
		ff = SSF_frac(aval, Math.pow(10,ri)-1, true);
		return sign + (ff[0]||(ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1],ri) + r[2] + "/" + r[3] + rpad_(ff[2],ri): fill(" ", 2*ri+1 + r[2].length + r[3].length));
	}
	if((r = fmt.match(/^[#0?]+$/))) {
		o = "" + val;
		if(fmt.length <= o.length) return o;
		return hashq(fmt.substr(0,fmt.length-o.length)) + o;
	}
	if((r = fmt.match(/^([#0]+)\.([#0]+)$/))) {
		o = "" + val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");
		ri = o.indexOf(".");
		var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
		return hashq(fmt.substr(0,lres) + o + fmt.substr(fmt.length-rres));
	}
	if((r = fmt.match(/^00,000\.([#0]*0)$/))) {
		return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify(""+val).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$) { return "00," + ($$.length < 3 ? pad0(0,3-$$.length) : "") + $$; }) + "." + pad0(0,r[1].length);
	}
	switch(fmt) {
		case "###,###":
		case "##,###":
		case "#,###": var x = commaify(""+aval); return x !== "0" ? sign + x : "";
		default:
			if(fmt.match(/\.[0#?]*$/)) return write_num_int(type, fmt.slice(0,fmt.lastIndexOf(".")), val) + hashq(fmt.slice(fmt.lastIndexOf(".")));
	}
	throw new Error("unsupported format |" + fmt + "|");
}
function write_num(type, fmt, val) {
	return (val|0) === val ? write_num_int(type, fmt, val) : write_num_flt(type, fmt, val);
}
function SSF_split_fmt(fmt) {
	var out = [];
	var in_str = false/*, cc*/;
	for(var i = 0, j = 0; i < fmt.length; ++i) switch((/*cc=*/fmt.charCodeAt(i))) {
		case 34: /* '"' */
			in_str = !in_str; break;
		case 95: case 42: case 92: /* '_' '*' '\\' */
			++i; break;
		case 59: /* ';' */
			out[out.length] = fmt.substr(j,i-j);
			j = i+1;
	}
	out[out.length] = fmt.substr(j);
	if(in_str === true) throw new Error("Format |" + fmt + "| unterminated string ");
	return out;
}

var SSF_abstime = /\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;
function fmt_is_date(fmt) {
	var i = 0, /*cc = 0,*/ c = "", o = "";
	while(i < fmt.length) {
		switch((c = fmt.charAt(i))) {
			case 'G': if(SSF_isgeneral(fmt, i)) i+= 6; i++; break;
			case '"': for(;(/*cc=*/fmt.charCodeAt(++i)) !== 34 && i < fmt.length;){/*empty*/} ++i; break;
			case '\\': i+=2; break;
			case '_': i+=2; break;
			case '@': ++i; break;
			case 'B': case 'b':
				if(fmt.charAt(i+1) === "1" || fmt.charAt(i+1) === "2") return true;
				/* falls through */
			case 'M': case 'D': case 'Y': case 'H': case 'S': case 'E':
				/* falls through */
			case 'm': case 'd': case 'y': case 'h': case 's': case 'e': case 'g': return true;
			case 'A': case 'a': case '上':
				if(fmt.substr(i, 3).toUpperCase() === "A/P") return true;
				if(fmt.substr(i, 5).toUpperCase() === "AM/PM") return true;
				if(fmt.substr(i, 5).toUpperCase() === "上午/下午") return true;
				++i; break;
			case '[':
				o = c;
				while(fmt.charAt(i++) !== ']' && i < fmt.length) o += fmt.charAt(i);
				if(o.match(SSF_abstime)) return true;
				break;
			case '.':
				/* falls through */
			case '0': case '#':
				while(i < fmt.length && ("0#?.,E+-%".indexOf(c=fmt.charAt(++i)) > -1 || (c=='\\' && fmt.charAt(i+1) == "-" && "0#".indexOf(fmt.charAt(i+2))>-1))){/* empty */}
				break;
			case '?': while(fmt.charAt(++i) === c){/* empty */} break;
			case '*': ++i; if(fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i; break;
			case '(': case ')': ++i; break;
			case '1': case '2': case '3': case '4': case '5': case '6': case '7': case '8': case '9':
				while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1){/* empty */} break;
			case ' ': ++i; break;
			default: ++i; break;
		}
	}
	return false;
}

function eval_fmt(fmt, v, opts, flen) {
	var out = [], o = "", i = 0, c = "", lst='t', dt, j, cc;
	var hr='H';
	/* Tokenize */
	while(i < fmt.length) {
		switch((c = fmt.charAt(i))) {
			case 'G': /* General */
				if(!SSF_isgeneral(fmt, i)) throw new Error('unrecognized character ' + c + ' in ' +fmt);
				out[out.length] = {t:'G', v:'General'}; i+=7; break;
			case '"': /* Literal text */
				for(o="";(cc=fmt.charCodeAt(++i)) !== 34 && i < fmt.length;) o += String.fromCharCode(cc);
				out[out.length] = {t:'t', v:o}; ++i; break;
			case '\\': var w = fmt.charAt(++i), t = (w === "(" || w === ")") ? w : 't';
				out[out.length] = {t:t, v:w}; ++i; break;
			case '_': out[out.length] = {t:'t', v:" "}; i+=2; break;
			case '@': /* Text Placeholder */
				out[out.length] = {t:'T', v:v}; ++i; break;
			case 'B': case 'b':
				if(fmt.charAt(i+1) === "1" || fmt.charAt(i+1) === "2") {
					if(dt==null) { dt=SSF_parse_date_code(v, opts, fmt.charAt(i+1) === "2"); if(dt==null) return ""; }
					out[out.length] = {t:'X', v:fmt.substr(i,2)}; lst = c; i+=2; break;
				}
				/* falls through */
			case 'M': case 'D': case 'Y': case 'H': case 'S': case 'E':
				c = c.toLowerCase();
				/* falls through */
			case 'm': case 'd': case 'y': case 'h': case 's': case 'e': case 'g':
				if(v < 0) return "";
				if(dt==null) { dt=SSF_parse_date_code(v, opts); if(dt==null) return ""; }
				o = c; while(++i < fmt.length && fmt.charAt(i).toLowerCase() === c) o+=c;
				if(c === 'm' && lst.toLowerCase() === 'h') c = 'M';
				if(c === 'h') c = hr;
				out[out.length] = {t:c, v:o}; lst = c; break;
			case 'A': case 'a': case '上':
				var q={t:c, v:c};
				if(dt==null) dt=SSF_parse_date_code(v, opts);
				if(fmt.substr(i, 3).toUpperCase() === "A/P") { if(dt!=null) q.v = dt.H >= 12 ? fmt.charAt(i+2) : c; q.t = 'T'; hr='h';i+=3;}
				else if(fmt.substr(i,5).toUpperCase() === "AM/PM") { if(dt!=null) q.v = dt.H >= 12 ? "PM" : "AM"; q.t = 'T'; i+=5; hr='h'; }
				else if(fmt.substr(i,5).toUpperCase() === "上午/下午") { if(dt!=null) q.v = dt.H >= 12 ? "下午" : "上午"; q.t = 'T'; i+=5; hr='h'; }
				else { q.t = "t"; ++i; }
				if(dt==null && q.t === 'T') return "";
				out[out.length] = q; lst = c; break;
			case '[':
				o = c;
				while(fmt.charAt(i++) !== ']' && i < fmt.length) o += fmt.charAt(i);
				if(o.slice(-1) !== ']') throw 'unterminated "[" block: |' + o + '|';
				if(o.match(SSF_abstime)) {
					if(dt==null) { dt=SSF_parse_date_code(v, opts); if(dt==null) return ""; }
					out[out.length] = {t:'Z', v:o.toLowerCase()};
					lst = o.charAt(1);
				} else if(o.indexOf("$") > -1) {
					o = (o.match(/\$([^-\[\]]*)/)||[])[1]||"$";
					if(!fmt_is_date(fmt)) out[out.length] = {t:'t',v:o};
				}
				break;
			/* Numbers */
			case '.':
				if(dt != null) {
					o = c; while(++i < fmt.length && (c=fmt.charAt(i)) === "0") o += c;
					out[out.length] = {t:'s', v:o}; break;
				}
				/* falls through */
			case '0': case '#':
				o = c; while(++i < fmt.length && "0#?.,E+-%".indexOf(c=fmt.charAt(i)) > -1) o += c;
				out[out.length] = {t:'n', v:o}; break;
			case '?':
				o = c; while(fmt.charAt(++i) === c) o+=c;
				out[out.length] = {t:c, v:o}; lst = c; break;
			case '*': ++i; if(fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i; break; // **
			case '(': case ')': out[out.length] = {t:(flen===1?'t':c), v:c}; ++i; break;
			case '1': case '2': case '3': case '4': case '5': case '6': case '7': case '8': case '9':
				o = c; while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1) o+=fmt.charAt(i);
				out[out.length] = {t:'D', v:o}; break;
			case ' ': out[out.length] = {t:c, v:c}; ++i; break;
			case '$': out[out.length] = {t:'t', v:'$'}; ++i; break;
			default:
				if(",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(c) === -1) throw new Error('unrecognized character ' + c + ' in ' + fmt);
				out[out.length] = {t:'t', v:c}; ++i; break;
		}
	}

	/* Scan for date/time parts */
	var bt = 0, ss0 = 0, ssm;
	for(i=out.length-1, lst='t'; i >= 0; --i) {
		switch(out[i].t) {
			case 'h': case 'H': out[i].t = hr; lst='h'; if(bt < 1) bt = 1; break;
			case 's':
				if((ssm=out[i].v.match(/\.0+$/))) ss0=Math.max(ss0,ssm[0].length-1);
				if(bt < 3) bt = 3;
			/* falls through */
			case 'd': case 'y': case 'M': case 'e': lst=out[i].t; break;
			case 'm': if(lst === 's') { out[i].t = 'M'; if(bt < 2) bt = 2; } break;
			case 'X': /*if(out[i].v === "B2");*/
				break;
			case 'Z':
				if(bt < 1 && out[i].v.match(/[Hh]/)) bt = 1;
				if(bt < 2 && out[i].v.match(/[Mm]/)) bt = 2;
				if(bt < 3 && out[i].v.match(/[Ss]/)) bt = 3;
		}
	}
	/* time rounding depends on presence of minute / second / usec fields */
	switch(bt) {
		case 0: break;
		case 1:
if(dt.u >= 0.5) { dt.u = 0; ++dt.S; }
			if(dt.S >=  60) { dt.S = 0; ++dt.M; }
			if(dt.M >=  60) { dt.M = 0; ++dt.H; }
			break;
		case 2:
if(dt.u >= 0.5) { dt.u = 0; ++dt.S; }
			if(dt.S >=  60) { dt.S = 0; ++dt.M; }
			break;
	}

	/* replace fields */
	var nstr = "", jj;
	for(i=0; i < out.length; ++i) {
		switch(out[i].t) {
			case 't': case 'T': case ' ': case 'D': break;
			case 'X': out[i].v = ""; out[i].t = ";"; break;
			case 'd': case 'm': case 'y': case 'h': case 'H': case 'M': case 's': case 'e': case 'b': case 'Z':
out[i].v = SSF_write_date(out[i].t.charCodeAt(0), out[i].v, dt, ss0);
				out[i].t = 't'; break;
			case 'n': case '?':
				jj = i+1;
				while(out[jj] != null && (
					(c=out[jj].t) === "?" || c === "D" ||
					((c === " " || c === "t") && out[jj+1] != null && (out[jj+1].t === '?' || out[jj+1].t === "t" && out[jj+1].v === '/')) ||
					(out[i].t === '(' && (c === ' ' || c === 'n' || c === ')')) ||
					(c === 't' && (out[jj].v === '/' || out[jj].v === ' ' && out[jj+1] != null && out[jj+1].t == '?'))
				)) {
					out[i].v += out[jj].v;
					out[jj] = {v:"", t:";"}; ++jj;
				}
				nstr += out[i].v;
				i = jj-1; break;
			case 'G': out[i].t = 't'; out[i].v = SSF_general(v,opts); break;
		}
	}
	var vv = "", myv, ostr;
	if(nstr.length > 0) {
		if(nstr.charCodeAt(0) == 40) /* '(' */ {
			myv = (v<0&&nstr.charCodeAt(0) === 45 ? -v : v);
			ostr = write_num('n', nstr, myv);
		} else {
			myv = (v<0 && flen > 1 ? -v : v);
			ostr = write_num('n', nstr, myv);
			if(myv < 0 && out[0] && out[0].t == 't') {
				ostr = ostr.substr(1);
				out[0].v = "-" + out[0].v;
			}
		}
		jj=ostr.length-1;
		var decpt = out.length;
		for(i=0; i < out.length; ++i) if(out[i] != null && out[i].t != 't' && out[i].v.indexOf(".") > -1) { decpt = i; break; }
		var lasti=out.length;
		if(decpt === out.length && ostr.indexOf("E") === -1) {
			for(i=out.length-1; i>= 0;--i) {
				if(out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
				if(jj>=out[i].v.length-1) { jj -= out[i].v.length; out[i].v = ostr.substr(jj+1, out[i].v.length); }
				else if(jj < 0) out[i].v = "";
				else { out[i].v = ostr.substr(0, jj+1); jj = -1; }
				out[i].t = 't';
				lasti = i;
			}
			if(jj>=0 && lasti<out.length) out[lasti].v = ostr.substr(0,jj+1) + out[lasti].v;
		}
		else if(decpt !== out.length && ostr.indexOf("E") === -1) {
			jj = ostr.indexOf(".")-1;
			for(i=decpt; i>= 0; --i) {
				if(out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
				j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")-1:out[i].v.length-1;
				vv = out[i].v.substr(j+1);
				for(; j>=0; --j) {
					if(jj>=0 && (out[i].v.charAt(j) === "0" || out[i].v.charAt(j) === "#")) vv = ostr.charAt(jj--) + vv;
				}
				out[i].v = vv;
				out[i].t = 't';
				lasti = i;
			}
			if(jj>=0 && lasti<out.length) out[lasti].v = ostr.substr(0,jj+1) + out[lasti].v;
			jj = ostr.indexOf(".")+1;
			for(i=decpt; i<out.length; ++i) {
				if(out[i] == null || ('n?('.indexOf(out[i].t) === -1 && i !== decpt)) continue;
				j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")+1:0;
				vv = out[i].v.substr(0,j);
				for(; j<out[i].v.length; ++j) {
					if(jj<ostr.length) vv += ostr.charAt(jj++);
				}
				out[i].v = vv;
				out[i].t = 't';
				lasti = i;
			}
		}
	}
	for(i=0; i<out.length; ++i) if(out[i] != null && 'n?'.indexOf(out[i].t)>-1) {
		myv = (flen >1 && v < 0 && i>0 && out[i-1].v === "-" ? -v:v);
		out[i].v = write_num(out[i].t, out[i].v, myv);
		out[i].t = 't';
	}
	var retval = "";
	for(i=0; i !== out.length; ++i) if(out[i] != null) retval += out[i].v;
	return retval;
}

var cfregex2 = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
function chkcond(v, rr) {
	if(rr == null) return false;
	var thresh = parseFloat(rr[2]);
	switch(rr[1]) {
		case "=":  if(v == thresh) return true; break;
		case ">":  if(v >  thresh) return true; break;
		case "<":  if(v <  thresh) return true; break;
		case "<>": if(v != thresh) return true; break;
		case ">=": if(v >= thresh) return true; break;
		case "<=": if(v <= thresh) return true; break;
	}
	return false;
}
function choose_fmt(f, v) {
	var fmt = SSF_split_fmt(f);
	var l = fmt.length, lat = fmt[l-1].indexOf("@");
	if(l<4 && lat>-1) --l;
	if(fmt.length > 4) throw new Error("cannot find right format for |" + fmt.join("|") + "|");
	if(typeof v !== "number") return [4, fmt.length === 4 || lat>-1?fmt[fmt.length-1]:"@"];
	switch(fmt.length) {
		case 1: fmt = lat>-1 ? ["General", "General", "General", fmt[0]] : [fmt[0], fmt[0], fmt[0], "@"]; break;
		case 2: fmt = lat>-1 ? [fmt[0], fmt[0], fmt[0], fmt[1]] : [fmt[0], fmt[1], fmt[0], "@"]; break;
		case 3: fmt = lat>-1 ? [fmt[0], fmt[1], fmt[0], fmt[2]] : [fmt[0], fmt[1], fmt[2], "@"]; break;
		case 4: break;
	}
	var ff = v > 0 ? fmt[0] : v < 0 ? fmt[1] : fmt[2];
	if(fmt[0].indexOf("[") === -1 && fmt[1].indexOf("[") === -1) return [l, ff];
	if(fmt[0].match(/\[[=<>]/) != null || fmt[1].match(/\[[=<>]/) != null) {
		var m1 = fmt[0].match(cfregex2);
		var m2 = fmt[1].match(cfregex2);
		return chkcond(v, m1) ? [l, fmt[0]] : chkcond(v, m2) ? [l, fmt[1]] : [l, fmt[m1 != null && m2 != null ? 2 : 1]];
	}
	return [l, ff];
}
function SSF_format(fmt,v,o) {
	if(o == null) o = {};
	var sfmt = "";
	switch(typeof fmt) {
		case "string":
			if(fmt == "m/d/yy" && o.dateNF) sfmt = o.dateNF;
			else sfmt = fmt;
			break;
		case "number":
			if(fmt == 14 && o.dateNF) sfmt = o.dateNF;
			else sfmt = (o.table != null ? (o.table) : table_fmt)[fmt];
			if(sfmt == null) sfmt = (o.table && o.table[SSF_default_map[fmt]]) || table_fmt[SSF_default_map[fmt]];
			if(sfmt == null) sfmt = SSF_default_str[fmt] || "General";
			break;
	}
	if(SSF_isgeneral(sfmt,0)) return SSF_general(v, o);
	if(v instanceof Date) v = datenum_local(v, o.date1904);
	var f = choose_fmt(sfmt, v);
	if(SSF_isgeneral(f[1])) return SSF_general(v, o);
	if(v === true) v = "TRUE"; else if(v === false) v = "FALSE";
	else if(v === "" || v == null) return "";
	return eval_fmt(f[1], v, o, f[0]);
}
function SSF_load(fmt, idx) {
	if(typeof idx != 'number') {
		idx = +idx || -1;
for(var i = 0; i < 0x0188; ++i) {
if(table_fmt[i] == undefined) { if(idx < 0) idx = i; continue; }
			if(table_fmt[i] == fmt) { idx = i; break; }
		}
if(idx < 0) idx = 0x187;
	}
table_fmt[idx] = fmt;
	return idx;
}
function SSF_load_table(tbl) {
	for(var i=0; i!=0x0188; ++i)
		if(tbl[i] !== undefined) SSF_load(tbl[i], i);
}

function make_ssf() {
	table_fmt = SSF_init_table();
}

var SSF = {
	format: SSF_format,
	load: SSF_load,
	_table: table_fmt,
	load_table: SSF_load_table,
	parse_date_code: SSF_parse_date_code,
	is_date: fmt_is_date,
	get_table: function get_table() { return SSF._table = table_fmt; }
};

var SSFImplicit/*{[number]:string}*/ = ({
	"5": '"$"#,##0_);\\("$"#,##0\\)',
	"6": '"$"#,##0_);[Red]\\("$"#,##0\\)',
	"7": '"$"#,##0.00_);\\("$"#,##0.00\\)',
	"8": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
	"23": 'General', "24": 'General', "25": 'General', "26": 'General',
	"27": 'm/d/yy', "28": 'm/d/yy', "29": 'm/d/yy', "30": 'm/d/yy', "31": 'm/d/yy',
	"32": 'h:mm:ss', "33": 'h:mm:ss', "34": 'h:mm:ss', "35": 'h:mm:ss',
	"36": 'm/d/yy',
	"41": '_(* #,##0_);_(* \(#,##0\);_(* "-"_);_(@_)',
	"42": '_("$"* #,##0_);_("$"* \(#,##0\);_("$"* "-"_);_(@_)',
	"43": '_(* #,##0.00_);_(* \(#,##0.00\);_(* "-"??_);_(@_)',
	"44": '_("$"* #,##0.00_);_("$"* \(#,##0.00\);_("$"* "-"??_);_(@_)',
	"50": 'm/d/yy', "51": 'm/d/yy', "52": 'm/d/yy', "53": 'm/d/yy', "54": 'm/d/yy',
	"55": 'm/d/yy', "56": 'm/d/yy', "57": 'm/d/yy', "58": 'm/d/yy',
	"59": '0',
	"60": '0.00',
	"61": '#,##0',
	"62": '#,##0.00',
	"63": '"$"#,##0_);\\("$"#,##0\\)',
	"64": '"$"#,##0_);[Red]\\("$"#,##0\\)',
	"65": '"$"#,##0.00_);\\("$"#,##0.00\\)',
	"66": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
	"67": '0%',
	"68": '0.00%',
	"69": '# ?/?',
	"70": '# ??/??',
	"71": 'm/d/yy',
	"72": 'm/d/yy',
	"73": 'd-mmm-yy',
	"74": 'd-mmm',
	"75": 'mmm-yy',
	"76": 'h:mm',
	"77": 'h:mm:ss',
	"78": 'm/d/yy h:mm',
	"79": 'mm:ss',
	"80": '[h]:mm:ss',
	"81": 'mmss.0'
});

/* dateNF parse TODO: move to SSF */
var dateNFregex = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
function dateNF_regex(dateNF) {
	var fmt = typeof dateNF == "number" ? table_fmt[dateNF] : dateNF;
	fmt = fmt.replace(dateNFregex, "(\\d+)");
	return new RegExp("^" + fmt + "$");
}
function dateNF_fix(str, dateNF, match) {
	var Y = -1, m = -1, d = -1, H = -1, M = -1, S = -1;
	(dateNF.match(dateNFregex)||[]).forEach(function(n, i) {
		var v = parseInt(match[i+1], 10);
		switch(n.toLowerCase().charAt(0)) {
			case 'y': Y = v; break; case 'd': d = v; break;
			case 'h': H = v; break; case 's': S = v; break;
			case 'm': if(H >= 0) M = v; else m = v; break;
		}
	});
	if(S >= 0 && M == -1 && m >= 0) { M = m; m = -1; }
	var datestr = (("" + (Y>=0?Y: new Date().getFullYear())).slice(-4) + "-" + ("00" + (m>=1?m:1)).slice(-2) + "-" + ("00" + (d>=1?d:1)).slice(-2));
	if(datestr.length == 7) datestr = "0" + datestr;
	if(datestr.length == 8) datestr = "20" + datestr;
	var timestr = (("00" + (H>=0?H:0)).slice(-2) + ":" + ("00" + (M>=0?M:0)).slice(-2) + ":" + ("00" + (S>=0?S:0)).slice(-2));
	if(H == -1 && M == -1 && S == -1) return datestr;
	if(Y == -1 && m == -1 && d == -1) return timestr;
	return datestr + "T" + timestr;
}

/* table of bad formats written by third-party tools */
var bad_formats = {
	"d.m": "d\\.m" // Issue #2571 Google Sheets writes invalid format 'd.m', correct format is 'd"."m' or 'd\\.m'
};

function SSF__load(fmt, idx) {
	return SSF_load(bad_formats[fmt] || fmt, idx);
}

/* cfb.js (C) 2013-present SheetJS -- http://sheetjs.com */
/* vim: set ts=2: */
/*jshint eqnull:true */
/*exported CFB */
/*global Uint8Array:false, Uint16Array:false */

/* crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */
/* vim: set ts=2: */
/*exported CRC32 */
var CRC32 = (function() {
var CRC32 = {};
CRC32.version = '1.2.0';
/* see perf/crc32table.js */
/*global Int32Array */
function signed_crc_table() {
	var c = 0, table = new Array(256);

	for(var n =0; n != 256; ++n){
		c = n;
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		table[n] = c;
	}

	return typeof Int32Array !== 'undefined' ? new Int32Array(table) : table;
}

var T0 = signed_crc_table();
function slice_by_16_tables(T) {
	var c = 0, v = 0, n = 0, table = typeof Int32Array !== 'undefined' ? new Int32Array(4096) : new Array(4096) ;

	for(n = 0; n != 256; ++n) table[n] = T[n];
	for(n = 0; n != 256; ++n) {
		v = T[n];
		for(c = 256 + n; c < 4096; c += 256) v = table[c] = (v >>> 8) ^ T[v & 0xFF];
	}
	var out = [];
	for(n = 1; n != 16; ++n) out[n - 1] = typeof Int32Array !== 'undefined' ? table.subarray(n * 256, n * 256 + 256) : table.slice(n * 256, n * 256 + 256);
	return out;
}
var TT = slice_by_16_tables(T0);
var T1 = TT[0],  T2 = TT[1],  T3 = TT[2],  T4 = TT[3],  T5 = TT[4];
var T6 = TT[5],  T7 = TT[6],  T8 = TT[7],  T9 = TT[8],  Ta = TT[9];
var Tb = TT[10], Tc = TT[11], Td = TT[12], Te = TT[13], Tf = TT[14];
function crc32_bstr(bstr, seed) {
	var C = seed ^ -1;
	for(var i = 0, L = bstr.length; i < L;) C = (C>>>8) ^ T0[(C^bstr.charCodeAt(i++))&0xFF];
	return ~C;
}

function crc32_buf(B, seed) {
	var C = seed ^ -1, L = B.length - 15, i = 0;
	for(; i < L;) C =
		Tf[B[i++] ^ (C & 255)] ^
		Te[B[i++] ^ ((C >> 8) & 255)] ^
		Td[B[i++] ^ ((C >> 16) & 255)] ^
		Tc[B[i++] ^ (C >>> 24)] ^
		Tb[B[i++]] ^ Ta[B[i++]] ^ T9[B[i++]] ^ T8[B[i++]] ^
		T7[B[i++]] ^ T6[B[i++]] ^ T5[B[i++]] ^ T4[B[i++]] ^
		T3[B[i++]] ^ T2[B[i++]] ^ T1[B[i++]] ^ T0[B[i++]];
	L += 15;
	while(i < L) C = (C>>>8) ^ T0[(C^B[i++])&0xFF];
	return ~C;
}

function crc32_str(str, seed) {
	var C = seed ^ -1;
	for(var i = 0, L = str.length, c = 0, d = 0; i < L;) {
		c = str.charCodeAt(i++);
		if(c < 0x80) {
			C = (C>>>8) ^ T0[(C^c)&0xFF];
		} else if(c < 0x800) {
			C = (C>>>8) ^ T0[(C ^ (192|((c>>6)&31)))&0xFF];
			C = (C>>>8) ^ T0[(C ^ (128|(c&63)))&0xFF];
		} else if(c >= 0xD800 && c < 0xE000) {
			c = (c&1023)+64; d = str.charCodeAt(i++)&1023;
			C = (C>>>8) ^ T0[(C ^ (240|((c>>8)&7)))&0xFF];
			C = (C>>>8) ^ T0[(C ^ (128|((c>>2)&63)))&0xFF];
			C = (C>>>8) ^ T0[(C ^ (128|((d>>6)&15)|((c&3)<<4)))&0xFF];
			C = (C>>>8) ^ T0[(C ^ (128|(d&63)))&0xFF];
		} else {
			C = (C>>>8) ^ T0[(C ^ (224|((c>>12)&15)))&0xFF];
			C = (C>>>8) ^ T0[(C ^ (128|((c>>6)&63)))&0xFF];
			C = (C>>>8) ^ T0[(C ^ (128|(c&63)))&0xFF];
		}
	}
	return ~C;
}
CRC32.table = T0;
CRC32.bstr = crc32_bstr;
CRC32.buf = crc32_buf;
CRC32.str = crc32_str;
return CRC32;
})();
/* [MS-CFB] v20171201 */
var CFB = (function _CFB(){
var exports = {};
exports.version = '1.2.2';
/* [MS-CFB] 2.6.4 */
function namecmp(l, r) {
	var L = l.split("/"), R = r.split("/");
	for(var i = 0, c = 0, Z = Math.min(L.length, R.length); i < Z; ++i) {
		if((c = L[i].length - R[i].length)) return c;
		if(L[i] != R[i]) return L[i] < R[i] ? -1 : 1;
	}
	return L.length - R.length;
}
function dirname(p) {
	if(p.charAt(p.length - 1) == "/") return (p.slice(0,-1).indexOf("/") === -1) ? p : dirname(p.slice(0, -1));
	var c = p.lastIndexOf("/");
	return (c === -1) ? p : p.slice(0, c+1);
}

function filename(p) {
	if(p.charAt(p.length - 1) == "/") return filename(p.slice(0, -1));
	var c = p.lastIndexOf("/");
	return (c === -1) ? p : p.slice(c+1);
}
/* -------------------------------------------------------------------------- */
/* DOS Date format:
   high|YYYYYYYm.mmmddddd.HHHHHMMM.MMMSSSSS|low
   add 1980 to stored year
   stored second should be doubled
*/

/* write JS date to buf as a DOS date */
function write_dos_date(buf, date) {
	if(typeof date === "string") date = new Date(date);
	var hms = date.getHours();
	hms = hms << 6 | date.getMinutes();
	hms = hms << 5 | (date.getSeconds()>>>1);
	buf.write_shift(2, hms);
	var ymd = (date.getFullYear() - 1980);
	ymd = ymd << 4 | (date.getMonth()+1);
	ymd = ymd << 5 | date.getDate();
	buf.write_shift(2, ymd);
}

/* read four bytes from buf and interpret as a DOS date */
function parse_dos_date(buf) {
	var hms = buf.read_shift(2) & 0xFFFF;
	var ymd = buf.read_shift(2) & 0xFFFF;
	var val = new Date();
	var d = ymd & 0x1F; ymd >>>= 5;
	var m = ymd & 0x0F; ymd >>>= 4;
	val.setMilliseconds(0);
	val.setFullYear(ymd + 1980);
	val.setMonth(m-1);
	val.setDate(d);
	var S = hms & 0x1F; hms >>>= 5;
	var M = hms & 0x3F; hms >>>= 6;
	val.setHours(hms);
	val.setMinutes(M);
	val.setSeconds(S<<1);
	return val;
}
function parse_extra_field(blob) {
	prep_blob(blob, 0);
	var o = {};
	var flags = 0;
	while(blob.l <= blob.length - 4) {
		var type = blob.read_shift(2);
		var sz = blob.read_shift(2), tgt = blob.l + sz;
		var p = {};
		switch(type) {
			/* UNIX-style Timestamps */
			case 0x5455: {
				flags = blob.read_shift(1);
				if(flags & 1) p.mtime = blob.read_shift(4);
				/* for some reason, CD flag corresponds to LFH */
				if(sz > 5) {
					if(flags & 2) p.atime = blob.read_shift(4);
					if(flags & 4) p.ctime = blob.read_shift(4);
				}
				if(p.mtime) p.mt = new Date(p.mtime*1000);
			} break;
			/* ZIP64 Extended Information Field */
			case 0x0001: {
				var sz1 = blob.read_shift(4), sz2 = blob.read_shift(4);
				p.usz = (sz2 * Math.pow(2,32) + sz1);
				sz1 = blob.read_shift(4); sz2 = blob.read_shift(4);
				p.csz = (sz2 * Math.pow(2,32) + sz1);
				// NOTE: volume fields are skipped
			} break;
		}
		blob.l = tgt;
		o[type] = p;
	}
	return o;
}
var fs;
function get_fs() { return fs || (fs = _fs); }
function parse(file, options) {
if(file[0] == 0x50 && file[1] == 0x4b) return parse_zip(file, options);
if((file[0] | 0x20) == 0x6d && (file[1]|0x20) == 0x69) return parse_mad(file, options);
if(file.length < 512) throw new Error("CFB file size " + file.length + " < 512");
var mver = 3;
var ssz = 512;
var nmfs = 0; // number of mini FAT sectors
var difat_sec_cnt = 0;
var dir_start = 0;
var minifat_start = 0;
var difat_start = 0;

var fat_addrs = []; // locations of FAT sectors

/* [MS-CFB] 2.2 Compound File Header */
var blob = file.slice(0,512);
prep_blob(blob, 0);

/* major version */
var mv = check_get_mver(blob);
mver = mv[0];
switch(mver) {
	case 3: ssz = 512; break; case 4: ssz = 4096; break;
	case 0: if(mv[1] == 0) return parse_zip(file, options);
	/* falls through */
	default: throw new Error("Major Version: Expected 3 or 4 saw " + mver);
}

/* reprocess header */
if(ssz !== 512) { blob = file.slice(0,ssz); prep_blob(blob, 28 /* blob.l */); }
/* Save header for final object */
var header = file.slice(0,ssz);

check_shifts(blob, mver);

// Number of Directory Sectors
var dir_cnt = blob.read_shift(4, 'i');
if(mver === 3 && dir_cnt !== 0) throw new Error('# Directory Sectors: Expected 0 saw ' + dir_cnt);

// Number of FAT Sectors
blob.l += 4;

// First Directory Sector Location
dir_start = blob.read_shift(4, 'i');

// Transaction Signature
blob.l += 4;

// Mini Stream Cutoff Size
blob.chk('00100000', 'Mini Stream Cutoff Size: ');

// First Mini FAT Sector Location
minifat_start = blob.read_shift(4, 'i');

// Number of Mini FAT Sectors
nmfs = blob.read_shift(4, 'i');

// First DIFAT sector location
difat_start = blob.read_shift(4, 'i');

// Number of DIFAT Sectors
difat_sec_cnt = blob.read_shift(4, 'i');

// Grab FAT Sector Locations
for(var q = -1, j = 0; j < 109; ++j) { /* 109 = (512 - blob.l)>>>2; */
	q = blob.read_shift(4, 'i');
	if(q<0) break;
	fat_addrs[j] = q;
}

/** Break the file up into sectors */
var sectors = sectorify(file, ssz);

sleuth_fat(difat_start, difat_sec_cnt, sectors, ssz, fat_addrs);

/** Chains */
var sector_list = make_sector_list(sectors, dir_start, fat_addrs, ssz);

sector_list[dir_start].name = "!Directory";
if(nmfs > 0 && minifat_start !== ENDOFCHAIN) sector_list[minifat_start].name = "!MiniFAT";
sector_list[fat_addrs[0]].name = "!FAT";
sector_list.fat_addrs = fat_addrs;
sector_list.ssz = ssz;

/* [MS-CFB] 2.6.1 Compound File Directory Entry */
var files = {}, Paths = [], FileIndex = [], FullPaths = [];
read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, minifat_start);

build_full_paths(FileIndex, FullPaths, Paths);
Paths.shift();

var o = {
	FileIndex: FileIndex,
	FullPaths: FullPaths
};

// $FlowIgnore
if(options && options.raw) o.raw = {header: header, sectors: sectors};
return o;
} // parse

/* [MS-CFB] 2.2 Compound File Header -- read up to major version */
function check_get_mver(blob) {
	if(blob[blob.l] == 0x50 && blob[blob.l + 1] == 0x4b) return [0, 0];
	// header signature 8
	blob.chk(HEADER_SIGNATURE, 'Header Signature: ');

	// clsid 16
	//blob.chk(HEADER_CLSID, 'CLSID: ');
	blob.l += 16;

	// minor version 2
	var mver = blob.read_shift(2, 'u');

	return [blob.read_shift(2,'u'), mver];
}
function check_shifts(blob, mver) {
	var shift = 0x09;

	// Byte Order
	//blob.chk('feff', 'Byte Order: '); // note: some writers put 0xffff
	blob.l += 2;

	// Sector Shift
	switch((shift = blob.read_shift(2))) {
		case 0x09: if(mver != 3) throw new Error('Sector Shift: Expected 9 saw ' + shift); break;
		case 0x0c: if(mver != 4) throw new Error('Sector Shift: Expected 12 saw ' + shift); break;
		default: throw new Error('Sector Shift: Expected 9 or 12 saw ' + shift);
	}

	// Mini Sector Shift
	blob.chk('0600', 'Mini Sector Shift: ');

	// Reserved
	blob.chk('000000000000', 'Reserved: ');
}

/** Break the file up into sectors */
function sectorify(file, ssz) {
	var nsectors = Math.ceil(file.length/ssz)-1;
	var sectors = [];
	for(var i=1; i < nsectors; ++i) sectors[i-1] = file.slice(i*ssz,(i+1)*ssz);
	sectors[nsectors-1] = file.slice(nsectors*ssz);
	return sectors;
}

/* [MS-CFB] 2.6.4 Red-Black Tree */
function build_full_paths(FI, FP, Paths) {
	var i = 0, L = 0, R = 0, C = 0, j = 0, pl = Paths.length;
	var dad = [], q = [];

	for(; i < pl; ++i) { dad[i]=q[i]=i; FP[i]=Paths[i]; }

	for(; j < q.length; ++j) {
		i = q[j];
		L = FI[i].L; R = FI[i].R; C = FI[i].C;
		if(dad[i] === i) {
			if(L !== -1 /*NOSTREAM*/ && dad[L] !== L) dad[i] = dad[L];
			if(R !== -1 && dad[R] !== R) dad[i] = dad[R];
		}
		if(C !== -1 /*NOSTREAM*/) dad[C] = i;
		if(L !== -1 && i != dad[i]) { dad[L] = dad[i]; if(q.lastIndexOf(L) < j) q.push(L); }
		if(R !== -1 && i != dad[i]) { dad[R] = dad[i]; if(q.lastIndexOf(R) < j) q.push(R); }
	}
	for(i=1; i < pl; ++i) if(dad[i] === i) {
		if(R !== -1 /*NOSTREAM*/ && dad[R] !== R) dad[i] = dad[R];
		else if(L !== -1 && dad[L] !== L) dad[i] = dad[L];
	}

	for(i=1; i < pl; ++i) {
		if(FI[i].type === 0 /* unknown */) continue;
		j = i;
		if(j != dad[j]) do {
			j = dad[j];
			FP[i] = FP[j] + "/" + FP[i];
		} while (j !== 0 && -1 !== dad[j] && j != dad[j]);
		dad[i] = -1;
	}

	FP[0] += "/";
	for(i=1; i < pl; ++i) {
		if(FI[i].type !== 2 /* stream */) FP[i] += "/";
	}
}

function get_mfat_entry(entry, payload, mini) {
	var start = entry.start, size = entry.size;
	//return (payload.slice(start*MSSZ, start*MSSZ + size));
	var o = [];
	var idx = start;
	while(mini && size > 0 && idx >= 0) {
		o.push(payload.slice(idx * MSSZ, idx * MSSZ + MSSZ));
		size -= MSSZ;
		idx = __readInt32LE(mini, idx * 4);
	}
	if(o.length === 0) return (new_buf(0));
	return (bconcat(o).slice(0, entry.size));
}

/** Chase down the rest of the DIFAT chain to build a comprehensive list
    DIFAT chains by storing the next sector number as the last 32 bits */
function sleuth_fat(idx, cnt, sectors, ssz, fat_addrs) {
	var q = ENDOFCHAIN;
	if(idx === ENDOFCHAIN) {
		if(cnt !== 0) throw new Error("DIFAT chain shorter than expected");
	} else if(idx !== -1 /*FREESECT*/) {
		var sector = sectors[idx], m = (ssz>>>2)-1;
		if(!sector) return;
		for(var i = 0; i < m; ++i) {
			if((q = __readInt32LE(sector,i*4)) === ENDOFCHAIN) break;
			fat_addrs.push(q);
		}
		if(cnt >= 1) sleuth_fat(__readInt32LE(sector,ssz-4),cnt - 1, sectors, ssz, fat_addrs);
	}
}

/** Follow the linked list of sectors for a given starting point */
function get_sector_list(sectors, start, fat_addrs, ssz, chkd) {
	var buf = [], buf_chain = [];
	if(!chkd) chkd = [];
	var modulus = ssz - 1, j = 0, jj = 0;
	for(j=start; j>=0;) {
		chkd[j] = true;
		buf[buf.length] = j;
		buf_chain.push(sectors[j]);
		var addr = fat_addrs[Math.floor(j*4/ssz)];
		jj = ((j*4) & modulus);
		if(ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 "+ssz);
		if(!sectors[addr]) break;
		j = __readInt32LE(sectors[addr], jj);
	}
	return {nodes: buf, data:__toBuffer([buf_chain])};
}

/** Chase down the sector linked lists */
function make_sector_list(sectors, dir_start, fat_addrs, ssz) {
	var sl = sectors.length, sector_list = ([]);
	var chkd = [], buf = [], buf_chain = [];
	var modulus = ssz - 1, i=0, j=0, k=0, jj=0;
	for(i=0; i < sl; ++i) {
		buf = ([]);
		k = (i + dir_start); if(k >= sl) k-=sl;
		if(chkd[k]) continue;
		buf_chain = [];
		var seen = [];
		for(j=k; j>=0;) {
			seen[j] = true;
			chkd[j] = true;
			buf[buf.length] = j;
			buf_chain.push(sectors[j]);
			var addr = fat_addrs[Math.floor(j*4/ssz)];
			jj = ((j*4) & modulus);
			if(ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 "+ssz);
			if(!sectors[addr]) break;
			j = __readInt32LE(sectors[addr], jj);
			if(seen[j]) break;
		}
		sector_list[k] = ({nodes: buf, data:__toBuffer([buf_chain])});
	}
	return sector_list;
}

/* [MS-CFB] 2.6.1 Compound File Directory Entry */
function read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, mini) {
	var minifat_store = 0, pl = (Paths.length?2:0);
	var sector = sector_list[dir_start].data;
	var i = 0, namelen = 0, name;
	for(; i < sector.length; i+= 128) {
		var blob = sector.slice(i, i+128);
		prep_blob(blob, 64);
		namelen = blob.read_shift(2);
		name = __utf16le(blob,0,namelen-pl);
		Paths.push(name);
		var o = ({
			name:  name,
			type:  blob.read_shift(1),
			color: blob.read_shift(1),
			L:     blob.read_shift(4, 'i'),
			R:     blob.read_shift(4, 'i'),
			C:     blob.read_shift(4, 'i'),
			clsid: blob.read_shift(16),
			state: blob.read_shift(4, 'i'),
			start: 0,
			size: 0
		});
		var ctime = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
		if(ctime !== 0) o.ct = read_date(blob, blob.l-8);
		var mtime = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
		if(mtime !== 0) o.mt = read_date(blob, blob.l-8);
		o.start = blob.read_shift(4, 'i');
		o.size = blob.read_shift(4, 'i');
		if(o.size < 0 && o.start < 0) { o.size = o.type = 0; o.start = ENDOFCHAIN; o.name = ""; }
		if(o.type === 5) { /* root */
			minifat_store = o.start;
			if(nmfs > 0 && minifat_store !== ENDOFCHAIN) sector_list[minifat_store].name = "!StreamData";
			/*minifat_size = o.size;*/
		} else if(o.size >= 4096 /* MSCSZ */) {
			o.storage = 'fat';
			if(sector_list[o.start] === undefined) sector_list[o.start] = get_sector_list(sectors, o.start, sector_list.fat_addrs, sector_list.ssz);
			sector_list[o.start].name = o.name;
			o.content = (sector_list[o.start].data.slice(0,o.size));
		} else {
			o.storage = 'minifat';
			if(o.size < 0) o.size = 0;
			else if(minifat_store !== ENDOFCHAIN && o.start !== ENDOFCHAIN && sector_list[minifat_store]) {
				o.content = get_mfat_entry(o, sector_list[minifat_store].data, (sector_list[mini]||{}).data);
			}
		}
		if(o.content) prep_blob(o.content, 0);
		files[name] = o;
		FileIndex.push(o);
	}
}

function read_date(blob, offset) {
	return new Date(( ( (__readUInt32LE(blob,offset+4)/1e7)*Math.pow(2,32)+__readUInt32LE(blob,offset)/1e7 ) - 11644473600)*1000);
}

function read_file(filename, options) {
	get_fs();
	return parse(fs.readFileSync(filename), options);
}

function read(blob, options) {
	var type = options && options.type;
	if(!type) {
		if(has_buf && Buffer.isBuffer(blob)) type = "buffer";
	}
	switch(type || "base64") {
		case "file": return read_file(blob, options);
		case "base64": return parse(s2a(Base64_decode(blob)), options);
		case "binary": return parse(s2a(blob), options);
	}
	return parse(blob, options);
}

function init_cfb(cfb, opts) {
	var o = opts || {}, root = o.root || "Root Entry";
	if(!cfb.FullPaths) cfb.FullPaths = [];
	if(!cfb.FileIndex) cfb.FileIndex = [];
	if(cfb.FullPaths.length !== cfb.FileIndex.length) throw new Error("inconsistent CFB structure");
	if(cfb.FullPaths.length === 0) {
		cfb.FullPaths[0] = root + "/";
		cfb.FileIndex[0] = ({ name: root, type: 5 });
	}
	if(o.CLSID) cfb.FileIndex[0].clsid = o.CLSID;
	seed_cfb(cfb);
}
function seed_cfb(cfb) {
	var nm = "\u0001Sh33tJ5";
	if(CFB.find(cfb, "/" + nm)) return;
	var p = new_buf(4); p[0] = 55; p[1] = p[3] = 50; p[2] = 54;
	cfb.FileIndex.push(({ name: nm, type: 2, content:p, size:4, L:69, R:69, C:69 }));
	cfb.FullPaths.push(cfb.FullPaths[0] + nm);
	rebuild_cfb(cfb);
}
function rebuild_cfb(cfb, f) {
	init_cfb(cfb);
	var gc = false, s = false;
	for(var i = cfb.FullPaths.length - 1; i >= 0; --i) {
		var _file = cfb.FileIndex[i];
		switch(_file.type) {
			case 0:
				if(s) gc = true;
				else { cfb.FileIndex.pop(); cfb.FullPaths.pop(); }
				break;
			case 1: case 2: case 5:
				s = true;
				if(isNaN(_file.R * _file.L * _file.C)) gc = true;
				if(_file.R > -1 && _file.L > -1 && _file.R == _file.L) gc = true;
				break;
			default: gc = true; break;
		}
	}
	if(!gc && !f) return;

	var now = new Date(1987, 1, 19), j = 0;
	// Track which names exist
	var fullPaths = Object.create ? Object.create(null) : {};
	var data = [];
	for(i = 0; i < cfb.FullPaths.length; ++i) {
		fullPaths[cfb.FullPaths[i]] = true;
		if(cfb.FileIndex[i].type === 0) continue;
		data.push([cfb.FullPaths[i], cfb.FileIndex[i]]);
	}
	for(i = 0; i < data.length; ++i) {
		var dad = dirname(data[i][0]);
		s = fullPaths[dad];
		while(!s) {
			while(dirname(dad) && !fullPaths[dirname(dad)]) dad = dirname(dad);

			data.push([dad, ({
				name: filename(dad).replace("/",""),
				type: 1,
				clsid: HEADER_CLSID,
				ct: now, mt: now,
				content: null
			})]);

			// Add name to set
			fullPaths[dad] = true;

			dad = dirname(data[i][0]);
			s = fullPaths[dad];
		}
	}

	data.sort(function(x,y) { return namecmp(x[0], y[0]); });
	cfb.FullPaths = []; cfb.FileIndex = [];
	for(i = 0; i < data.length; ++i) { cfb.FullPaths[i] = data[i][0]; cfb.FileIndex[i] = data[i][1]; }
	for(i = 0; i < data.length; ++i) {
		var elt = cfb.FileIndex[i];
		var nm = cfb.FullPaths[i];

		elt.name =  filename(nm).replace("/","");
		elt.L = elt.R = elt.C = -(elt.color = 1);
		elt.size = elt.content ? elt.content.length : 0;
		elt.start = 0;
		elt.clsid = (elt.clsid || HEADER_CLSID);
		if(i === 0) {
			elt.C = data.length > 1 ? 1 : -1;
			elt.size = 0;
			elt.type = 5;
		} else if(nm.slice(-1) == "/") {
			for(j=i+1;j < data.length; ++j) if(dirname(cfb.FullPaths[j])==nm) break;
			elt.C = j >= data.length ? -1 : j;
			for(j=i+1;j < data.length; ++j) if(dirname(cfb.FullPaths[j])==dirname(nm)) break;
			elt.R = j >= data.length ? -1 : j;
			elt.type = 1;
		} else {
			if(dirname(cfb.FullPaths[i+1]||"") == dirname(nm)) elt.R = i + 1;
			elt.type = 2;
		}
	}

}

function _write(cfb, options) {
	var _opts = options || {};
	/* MAD is order-sensitive, skip rebuild and sort */
	if(_opts.fileType == 'mad') return write_mad(cfb, _opts);
	rebuild_cfb(cfb);
	switch(_opts.fileType) {
		case 'zip': return write_zip(cfb, _opts);
		//case 'mad': return write_mad(cfb, _opts);
	}
	var L = (function(cfb){
		var mini_size = 0, fat_size = 0;
		for(var i = 0; i < cfb.FileIndex.length; ++i) {
			var file = cfb.FileIndex[i];
			if(!file.content) continue;
			var flen = file.content.length;
			if(flen > 0){
				if(flen < 0x1000) mini_size += (flen + 0x3F) >> 6;
				else fat_size += (flen + 0x01FF) >> 9;
			}
		}
		var dir_cnt = (cfb.FullPaths.length +3) >> 2;
		var mini_cnt = (mini_size + 7) >> 3;
		var mfat_cnt = (mini_size + 0x7F) >> 7;
		var fat_base = mini_cnt + fat_size + dir_cnt + mfat_cnt;
		var fat_cnt = (fat_base + 0x7F) >> 7;
		var difat_cnt = fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt-109)/0x7F);
		while(((fat_base + fat_cnt + difat_cnt + 0x7F) >> 7) > fat_cnt) difat_cnt = ++fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt-109)/0x7F);
		var L =  [1, difat_cnt, fat_cnt, mfat_cnt, dir_cnt, fat_size, mini_size, 0];
		cfb.FileIndex[0].size = mini_size << 6;
		L[7] = (cfb.FileIndex[0].start=L[0]+L[1]+L[2]+L[3]+L[4]+L[5])+((L[6]+7) >> 3);
		return L;
	})(cfb);
	var o = new_buf(L[7] << 9);
	var i = 0, T = 0;
	{
		for(i = 0; i < 8; ++i) o.write_shift(1, HEADER_SIG[i]);
		for(i = 0; i < 8; ++i) o.write_shift(2, 0);
		o.write_shift(2, 0x003E);
		o.write_shift(2, 0x0003);
		o.write_shift(2, 0xFFFE);
		o.write_shift(2, 0x0009);
		o.write_shift(2, 0x0006);
		for(i = 0; i < 3; ++i) o.write_shift(2, 0);
		o.write_shift(4, 0);
		o.write_shift(4, L[2]);
		o.write_shift(4, L[0] + L[1] + L[2] + L[3] - 1);
		o.write_shift(4, 0);
		o.write_shift(4, 1<<12);
		o.write_shift(4, L[3] ? L[0] + L[1] + L[2] - 1: ENDOFCHAIN);
		o.write_shift(4, L[3]);
		o.write_shift(-4, L[1] ? L[0] - 1: ENDOFCHAIN);
		o.write_shift(4, L[1]);
		for(i = 0; i < 109; ++i) o.write_shift(-4, i < L[2] ? L[1] + i : -1);
	}
	if(L[1]) {
		for(T = 0; T < L[1]; ++T) {
			for(; i < 236 + T * 127; ++i) o.write_shift(-4, i < L[2] ? L[1] + i : -1);
			o.write_shift(-4, T === L[1] - 1 ? ENDOFCHAIN : T + 1);
		}
	}
	var chainit = function(w) {
		for(T += w; i<T-1; ++i) o.write_shift(-4, i+1);
		if(w) { ++i; o.write_shift(-4, ENDOFCHAIN); }
	};
	T = i = 0;
	for(T+=L[1]; i<T; ++i) o.write_shift(-4, consts.DIFSECT);
	for(T+=L[2]; i<T; ++i) o.write_shift(-4, consts.FATSECT);
	chainit(L[3]);
	chainit(L[4]);
	var j = 0, flen = 0;
	var file = cfb.FileIndex[0];
	for(; j < cfb.FileIndex.length; ++j) {
		file = cfb.FileIndex[j];
		if(!file.content) continue;
flen = file.content.length;
		if(flen < 0x1000) continue;
		file.start = T;
		chainit((flen + 0x01FF) >> 9);
	}
	chainit((L[6] + 7) >> 3);
	while(o.l & 0x1FF) o.write_shift(-4, consts.ENDOFCHAIN);
	T = i = 0;
	for(j = 0; j < cfb.FileIndex.length; ++j) {
		file = cfb.FileIndex[j];
		if(!file.content) continue;
flen = file.content.length;
		if(!flen || flen >= 0x1000) continue;
		file.start = T;
		chainit((flen + 0x3F) >> 6);
	}
	while(o.l & 0x1FF) o.write_shift(-4, consts.ENDOFCHAIN);
	for(i = 0; i < L[4]<<2; ++i) {
		var nm = cfb.FullPaths[i];
		if(!nm || nm.length === 0) {
			for(j = 0; j < 17; ++j) o.write_shift(4, 0);
			for(j = 0; j < 3; ++j) o.write_shift(4, -1);
			for(j = 0; j < 12; ++j) o.write_shift(4, 0);
			continue;
		}
		file = cfb.FileIndex[i];
		if(i === 0) file.start = file.size ? file.start - 1 : ENDOFCHAIN;
		var _nm = (i === 0 && _opts.root) || file.name;
		if(_nm.length > 32) {
			console.error("Name " + _nm + " will be truncated to " + _nm.slice(0,32));
			_nm = _nm.slice(0, 32);
		}
		flen = 2*(_nm.length+1);
		o.write_shift(64, _nm, "utf16le");
		o.write_shift(2, flen);
		o.write_shift(1, file.type);
		o.write_shift(1, file.color);
		o.write_shift(-4, file.L);
		o.write_shift(-4, file.R);
		o.write_shift(-4, file.C);
		if(!file.clsid) for(j = 0; j < 4; ++j) o.write_shift(4, 0);
		else o.write_shift(16, file.clsid, "hex");
		o.write_shift(4, file.state || 0);
		o.write_shift(4, 0); o.write_shift(4, 0);
		o.write_shift(4, 0); o.write_shift(4, 0);
		o.write_shift(4, file.start);
		o.write_shift(4, file.size); o.write_shift(4, 0);
	}
	for(i = 1; i < cfb.FileIndex.length; ++i) {
		file = cfb.FileIndex[i];
if(file.size >= 0x1000) {
			o.l = (file.start+1) << 9;
			if (has_buf && Buffer.isBuffer(file.content)) {
				file.content.copy(o, o.l, 0, file.size);
				// o is a 0-filled Buffer so just set next offset
				o.l += (file.size + 511) & -512;
			} else {
				for(j = 0; j < file.size; ++j) o.write_shift(1, file.content[j]);
				for(; j & 0x1FF; ++j) o.write_shift(1, 0);
			}
		}
	}
	for(i = 1; i < cfb.FileIndex.length; ++i) {
		file = cfb.FileIndex[i];
if(file.size > 0 && file.size < 0x1000) {
			if (has_buf && Buffer.isBuffer(file.content)) {
				file.content.copy(o, o.l, 0, file.size);
				// o is a 0-filled Buffer so just set next offset
				o.l += (file.size + 63) & -64;
			} else {
				for(j = 0; j < file.size; ++j) o.write_shift(1, file.content[j]);
				for(; j & 0x3F; ++j) o.write_shift(1, 0);
			}
		}
	}
	if (has_buf) {
		o.l = o.length;
	} else {
		// When using Buffer, already 0-filled
		while(o.l < o.length) o.write_shift(1, 0);
	}
	return o;
}
/* [MS-CFB] 2.6.4 (Unicode 3.0.1 case conversion) */
function find(cfb, path) {
	var UCFullPaths = cfb.FullPaths.map(function(x) { return x.toUpperCase(); });
	var UCPaths = UCFullPaths.map(function(x) { var y = x.split("/"); return y[y.length - (x.slice(-1) == "/" ? 2 : 1)]; });
	var k = false;
	if(path.charCodeAt(0) === 47 /* "/" */) { k = true; path = UCFullPaths[0].slice(0, -1) + path; }
	else k = path.indexOf("/") !== -1;
	var UCPath = path.toUpperCase();
	var w = k === true ? UCFullPaths.indexOf(UCPath) : UCPaths.indexOf(UCPath);
	if(w !== -1) return cfb.FileIndex[w];

	var m = !UCPath.match(chr1);
	UCPath = UCPath.replace(chr0,'');
	if(m) UCPath = UCPath.replace(chr1,'!');
	for(w = 0; w < UCFullPaths.length; ++w) {
		if((m ? UCFullPaths[w].replace(chr1,'!') : UCFullPaths[w]).replace(chr0,'') == UCPath) return cfb.FileIndex[w];
		if((m ? UCPaths[w].replace(chr1,'!') : UCPaths[w]).replace(chr0,'') == UCPath) return cfb.FileIndex[w];
	}
	return null;
}
/** CFB Constants */
var MSSZ = 64; /* Mini Sector Size = 1<<6 */
//var MSCSZ = 4096; /* Mini Stream Cutoff Size */
/* 2.1 Compound File Sector Numbers and Types */
var ENDOFCHAIN = -2;
/* 2.2 Compound File Header */
var HEADER_SIGNATURE = 'd0cf11e0a1b11ae1';
var HEADER_SIG = [0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1];
var HEADER_CLSID = '00000000000000000000000000000000';
var consts = {
	/* 2.1 Compund File Sector Numbers and Types */
	MAXREGSECT: -6,
	DIFSECT: -4,
	FATSECT: -3,
	ENDOFCHAIN: ENDOFCHAIN,
	FREESECT: -1,
	/* 2.2 Compound File Header */
	HEADER_SIGNATURE: HEADER_SIGNATURE,
	HEADER_MINOR_VERSION: '3e00',
	MAXREGSID: -6,
	NOSTREAM: -1,
	HEADER_CLSID: HEADER_CLSID,
	/* 2.6.1 Compound File Directory Entry */
	EntryTypes: ['unknown','storage','stream','lockbytes','property','root']
};

function write_file(cfb, filename, options) {
	get_fs();
	var o = _write(cfb, options);
fs.writeFileSync(filename, o);
}

function a2s(o) {
	var out = new Array(o.length);
	for(var i = 0; i < o.length; ++i) out[i] = String.fromCharCode(o[i]);
	return out.join("");
}

function write(cfb, options) {
	var o = _write(cfb, options);
	switch(options && options.type || "buffer") {
		case "file": get_fs(); fs.writeFileSync(options.filename, (o)); return o;
		case "binary": return typeof o == "string" ? o : a2s(o);
		case "base64": return Base64_encode(typeof o == "string" ? o : a2s(o));
		case "buffer": if(has_buf) return Buffer.isBuffer(o) ? o : Buffer_from(o);
			/* falls through */
		case "array": return typeof o == "string" ? s2a(o) : o;
	}
	return o;
}
/* node < 8.1 zlib does not expose bytesRead, so default to pure JS */
var _zlib;
function use_zlib(zlib) { try {
	var InflateRaw = zlib.InflateRaw;
	var InflRaw = new InflateRaw();
	InflRaw._processChunk(new Uint8Array([3, 0]), InflRaw._finishFlushFlag);
	if(InflRaw.bytesRead) _zlib = zlib;
	else throw new Error("zlib does not expose bytesRead");
} catch(e) {console.error("cannot use native zlib: " + (e.message || e)); } }

function _inflateRawSync(payload, usz) {
	if(!_zlib) return _inflate(payload, usz);
	var InflateRaw = _zlib.InflateRaw;
	var InflRaw = new InflateRaw();
	var out = InflRaw._processChunk(payload.slice(payload.l), InflRaw._finishFlushFlag);
	payload.l += InflRaw.bytesRead;
	return out;
}

function _deflateRawSync(payload) {
	return _zlib ? _zlib.deflateRawSync(payload) : _deflate(payload);
}
var CLEN_ORDER = [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];

/*  LEN_ID = [ 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285 ]; */
var LEN_LN = [   3,   4,   5,   6,   7,   8,   9,  10,  11,  13 , 15,  17,  19,  23,  27,  31,  35,  43,  51,  59,  67,  83,  99, 115, 131, 163, 195, 227, 258 ];

/*  DST_ID = [  0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13,  14,  15,  16,  17,  18,  19,   20,   21,   22,   23,   24,   25,   26,    27,    28,    29 ]; */
var DST_LN = [  1,  2,  3,  4,  5,  7,  9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577 ];

function bit_swap_8(n) { var t = (((((n<<1)|(n<<11)) & 0x22110) | (((n<<5)|(n<<15)) & 0x88440))); return ((t>>16) | (t>>8) |t)&0xFF; }

var use_typed_arrays = typeof Uint8Array !== 'undefined';

var bitswap8 = use_typed_arrays ? new Uint8Array(1<<8) : [];
for(var q = 0; q < (1<<8); ++q) bitswap8[q] = bit_swap_8(q);

function bit_swap_n(n, b) {
	var rev = bitswap8[n & 0xFF];
	if(b <= 8) return rev >>> (8-b);
	rev = (rev << 8) | bitswap8[(n>>8)&0xFF];
	if(b <= 16) return rev >>> (16-b);
	rev = (rev << 8) | bitswap8[(n>>16)&0xFF];
	return rev >>> (24-b);
}

/* helpers for unaligned bit reads */
function read_bits_2(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 6 ? 0 : buf[h+1]<<8))>>>w)& 0x03; }
function read_bits_3(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 5 ? 0 : buf[h+1]<<8))>>>w)& 0x07; }
function read_bits_4(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 4 ? 0 : buf[h+1]<<8))>>>w)& 0x0F; }
function read_bits_5(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 3 ? 0 : buf[h+1]<<8))>>>w)& 0x1F; }
function read_bits_7(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 1 ? 0 : buf[h+1]<<8))>>>w)& 0x7F; }

/* works up to n = 3 * 8 + 1 = 25 */
function read_bits_n(buf, bl, n) {
	var w = (bl&7), h = (bl>>>3), f = ((1<<n)-1);
	var v = buf[h] >>> w;
	if(n < 8 - w) return v & f;
	v |= buf[h+1]<<(8-w);
	if(n < 16 - w) return v & f;
	v |= buf[h+2]<<(16-w);
	if(n < 24 - w) return v & f;
	v |= buf[h+3]<<(24-w);
	return v & f;
}

/* helpers for unaligned bit writes */
function write_bits_3(buf, bl, v) { var w = bl & 7, h = bl >>> 3;
	if(w <= 5) buf[h] |= (v & 7) << w;
	else {
		buf[h] |= (v << w) & 0xFF;
		buf[h+1] = (v&7) >> (8-w);
	}
	return bl + 3;
}

function write_bits_1(buf, bl, v) {
	var w = bl & 7, h = bl >>> 3;
	v = (v&1) << w;
	buf[h] |= v;
	return bl + 1;
}
function write_bits_8(buf, bl, v) {
	var w = bl & 7, h = bl >>> 3;
	v <<= w;
	buf[h] |=  v & 0xFF; v >>>= 8;
	buf[h+1] = v;
	return bl + 8;
}
function write_bits_16(buf, bl, v) {
	var w = bl & 7, h = bl >>> 3;
	v <<= w;
	buf[h] |=  v & 0xFF; v >>>= 8;
	buf[h+1] = v & 0xFF;
	buf[h+2] = v >>> 8;
	return bl + 16;
}

/* until ArrayBuffer#realloc is a thing, fake a realloc */
function realloc(b, sz) {
	var L = b.length, M = 2*L > sz ? 2*L : sz + 5, i = 0;
	if(L >= sz) return b;
	if(has_buf) {
		var o = new_unsafe_buf(M);
		// $FlowIgnore
		if(b.copy) b.copy(o);
		else for(; i < b.length; ++i) o[i] = b[i];
		return o;
	} else if(use_typed_arrays) {
		var a = new Uint8Array(M);
		if(a.set) a.set(b);
		else for(; i < L; ++i) a[i] = b[i];
		return a;
	}
	b.length = M;
	return b;
}

/* zero-filled arrays for older browsers */
function zero_fill_array(n) {
	var o = new Array(n);
	for(var i = 0; i < n; ++i) o[i] = 0;
	return o;
}

/* build tree (used for literals and lengths) */
function build_tree(clens, cmap, MAX) {
	var maxlen = 1, w = 0, i = 0, j = 0, ccode = 0, L = clens.length;

	var bl_count  = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
	for(i = 0; i < 32; ++i) bl_count[i] = 0;

	for(i = L; i < MAX; ++i) clens[i] = 0;
	L = clens.length;

	var ctree = use_typed_arrays ? new Uint16Array(L) : zero_fill_array(L); // []

	/* build code tree */
	for(i = 0; i < L; ++i) {
		bl_count[(w = clens[i])]++;
		if(maxlen < w) maxlen = w;
		ctree[i] = 0;
	}
	bl_count[0] = 0;
	for(i = 1; i <= maxlen; ++i) bl_count[i+16] = (ccode = (ccode + bl_count[i-1])<<1);
	for(i = 0; i < L; ++i) {
		ccode = clens[i];
		if(ccode != 0) ctree[i] = bl_count[ccode+16]++;
	}

	/* cmap[maxlen + 4 bits] = (off&15) + (lit<<4) reverse mapping */
	var cleni = 0;
	for(i = 0; i < L; ++i) {
		cleni = clens[i];
		if(cleni != 0) {
			ccode = bit_swap_n(ctree[i], maxlen)>>(maxlen-cleni);
			for(j = (1<<(maxlen + 4 - cleni)) - 1; j>=0; --j)
				cmap[ccode|(j<<cleni)] = (cleni&15) | (i<<4);
		}
	}
	return maxlen;
}

/* Fixed Huffman */
var fix_lmap = use_typed_arrays ? new Uint16Array(512) : zero_fill_array(512);
var fix_dmap = use_typed_arrays ? new Uint16Array(32)  : zero_fill_array(32);
if(!use_typed_arrays) {
	for(var i = 0; i < 512; ++i) fix_lmap[i] = 0;
	for(i = 0; i < 32; ++i) fix_dmap[i] = 0;
}
(function() {
	var dlens = [];
	var i = 0;
	for(;i<32; i++) dlens.push(5);
	build_tree(dlens, fix_dmap, 32);

	var clens = [];
	i = 0;
	for(; i<=143; i++) clens.push(8);
	for(; i<=255; i++) clens.push(9);
	for(; i<=279; i++) clens.push(7);
	for(; i<=287; i++) clens.push(8);
	build_tree(clens, fix_lmap, 288);
})();var _deflateRaw = (function _deflateRawIIFE() {
	var DST_LN_RE = use_typed_arrays ? new Uint8Array(0x8000) : [];
	var j = 0, k = 0;
	for(; j < DST_LN.length - 1; ++j) {
		for(; k < DST_LN[j+1]; ++k) DST_LN_RE[k] = j;
	}
	for(;k < 32768; ++k) DST_LN_RE[k] = 29;

	var LEN_LN_RE = use_typed_arrays ? new Uint8Array(0x103) : [];
	for(j = 0, k = 0; j < LEN_LN.length - 1; ++j) {
		for(; k < LEN_LN[j+1]; ++k) LEN_LN_RE[k] = j;
	}

	function write_stored(data, out) {
		var boff = 0;
		while(boff < data.length) {
			var L = Math.min(0xFFFF, data.length - boff);
			var h = boff + L == data.length;
			out.write_shift(1, +h);
			out.write_shift(2, L);
			out.write_shift(2, (~L) & 0xFFFF);
			while(L-- > 0) out[out.l++] = data[boff++];
		}
		return out.l;
	}

	/* Fixed Huffman */
	function write_huff_fixed(data, out) {
		var bl = 0;
		var boff = 0;
		var addrs = use_typed_arrays ? new Uint16Array(0x8000) : [];
		while(boff < data.length) {
			var L = /* data.length - boff; */ Math.min(0xFFFF, data.length - boff);

			/* write a stored block for short data */
			if(L < 10) {
				bl = write_bits_3(out, bl, +!!(boff + L == data.length)); // jshint ignore:line
				if(bl & 7) bl += 8 - (bl & 7);
				out.l = (bl / 8) | 0;
				out.write_shift(2, L);
				out.write_shift(2, (~L) & 0xFFFF);
				while(L-- > 0) out[out.l++] = data[boff++];
				bl = out.l * 8;
				continue;
			}

			bl = write_bits_3(out, bl, +!!(boff + L == data.length) + 2); // jshint ignore:line
			var hash = 0;
			while(L-- > 0) {
				var d = data[boff];
				hash = ((hash << 5) ^ d) & 0x7FFF;

				var match = -1, mlen = 0;

				if((match = addrs[hash])) {
					match |= boff & ~0x7FFF;
					if(match > boff) match -= 0x8000;
					if(match < boff) while(data[match + mlen] == data[boff + mlen] && mlen < 250) ++mlen;
				}

				if(mlen > 2) {
					/* Copy Token  */
					d = LEN_LN_RE[mlen];
					if(d <= 22) bl = write_bits_8(out, bl, bitswap8[d+1]>>1) - 1;
					else {
						write_bits_8(out, bl, 3);
						bl += 5;
						write_bits_8(out, bl, bitswap8[d-23]>>5);
						bl += 3;
					}
					var len_eb = (d < 8) ? 0 : ((d - 4)>>2);
					if(len_eb > 0) {
						write_bits_16(out, bl, mlen - LEN_LN[d]);
						bl += len_eb;
					}

					d = DST_LN_RE[boff - match];
					bl = write_bits_8(out, bl, bitswap8[d]>>3);
					bl -= 3;

					var dst_eb = d < 4 ? 0 : (d-2)>>1;
					if(dst_eb > 0) {
						write_bits_16(out, bl, boff - match - DST_LN[d]);
						bl += dst_eb;
					}
					for(var q = 0; q < mlen; ++q) {
						addrs[hash] = boff & 0x7FFF;
						hash = ((hash << 5) ^ data[boff]) & 0x7FFF;
						++boff;
					}
					L-= mlen - 1;
				} else {
					/* Literal Token */
					if(d <= 143) d = d + 48;
					else bl = write_bits_1(out, bl, 1);
					bl = write_bits_8(out, bl, bitswap8[d]);
					addrs[hash] = boff & 0x7FFF;
					++boff;
				}
			}

			bl = write_bits_8(out, bl, 0) - 1;
		}
		out.l = ((bl + 7)/8)|0;
		return out.l;
	}
	return function _deflateRaw(data, out) {
		if(data.length < 8) return write_stored(data, out);
		return write_huff_fixed(data, out);
	};
})();

function _deflate(data) {
	var buf = new_buf(50+Math.floor(data.length*1.1));
	var off = _deflateRaw(data, buf);
	return buf.slice(0, off);
}
/* modified inflate function also moves original read head */

var dyn_lmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
var dyn_dmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
var dyn_cmap = use_typed_arrays ? new Uint16Array(128)   : zero_fill_array(128);
var dyn_len_1 = 1, dyn_len_2 = 1;

/* 5.5.3 Expanding Huffman Codes */
function dyn(data, boff) {
	/* nomenclature from RFC1951 refers to bit values; these are offset by the implicit constant */
	var _HLIT = read_bits_5(data, boff) + 257; boff += 5;
	var _HDIST = read_bits_5(data, boff) + 1; boff += 5;
	var _HCLEN = read_bits_4(data, boff) + 4; boff += 4;
	var w = 0;

	/* grab and store code lengths */
	var clens = use_typed_arrays ? new Uint8Array(19) : zero_fill_array(19);
	var ctree = [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ];
	var maxlen = 1;
	var bl_count =  use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
	var next_code = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
	var L = clens.length; /* 19 */
	for(var i = 0; i < _HCLEN; ++i) {
		clens[CLEN_ORDER[i]] = w = read_bits_3(data, boff);
		if(maxlen < w) maxlen = w;
		bl_count[w]++;
		boff += 3;
	}

	/* build code tree */
	var ccode = 0;
	bl_count[0] = 0;
	for(i = 1; i <= maxlen; ++i) next_code[i] = ccode = (ccode + bl_count[i-1])<<1;
	for(i = 0; i < L; ++i) if((ccode = clens[i]) != 0) ctree[i] = next_code[ccode]++;
	/* cmap[7 bits from stream] = (off&7) + (lit<<3) */
	var cleni = 0;
	for(i = 0; i < L; ++i) {
		cleni = clens[i];
		if(cleni != 0) {
			ccode = bitswap8[ctree[i]]>>(8-cleni);
			for(var j = (1<<(7-cleni))-1; j>=0; --j) dyn_cmap[ccode|(j<<cleni)] = (cleni&7) | (i<<3);
		}
	}

	/* read literal and dist codes at once */
	var hcodes = [];
	maxlen = 1;
	for(; hcodes.length < _HLIT + _HDIST;) {
		ccode = dyn_cmap[read_bits_7(data, boff)];
		boff += ccode & 7;
		switch((ccode >>>= 3)) {
			case 16:
				w = 3 + read_bits_2(data, boff); boff += 2;
				ccode = hcodes[hcodes.length - 1];
				while(w-- > 0) hcodes.push(ccode);
				break;
			case 17:
				w = 3 + read_bits_3(data, boff); boff += 3;
				while(w-- > 0) hcodes.push(0);
				break;
			case 18:
				w = 11 + read_bits_7(data, boff); boff += 7;
				while(w -- > 0) hcodes.push(0);
				break;
			default:
				hcodes.push(ccode);
				if(maxlen < ccode) maxlen = ccode;
				break;
		}
	}

	/* build literal / length trees */
	var h1 = hcodes.slice(0, _HLIT), h2 = hcodes.slice(_HLIT);
	for(i = _HLIT; i < 286; ++i) h1[i] = 0;
	for(i = _HDIST; i < 30; ++i) h2[i] = 0;
	dyn_len_1 = build_tree(h1, dyn_lmap, 286);
	dyn_len_2 = build_tree(h2, dyn_dmap, 30);
	return boff;
}

/* return [ data, bytesRead ] */
function inflate(data, usz) {
	/* shortcircuit for empty buffer [0x03, 0x00] */
	if(data[0] == 3 && !(data[1] & 0x3)) { return [new_raw_buf(usz), 2]; }

	/* bit offset */
	var boff = 0;

	/* header includes final bit and type bits */
	var header = 0;

	var outbuf = new_unsafe_buf(usz ? usz : (1<<18));
	var woff = 0;
	var OL = outbuf.length>>>0;
	var max_len_1 = 0, max_len_2 = 0;

	while((header&1) == 0) {
		header = read_bits_3(data, boff); boff += 3;
		if((header >>> 1) == 0) {
			/* Stored block */
			if(boff & 7) boff += 8 - (boff&7);
			/* 2 bytes sz, 2 bytes bit inverse */
			var sz = data[boff>>>3] | data[(boff>>>3)+1]<<8;
			boff += 32;
			/* push sz bytes */
			if(sz > 0) {
				if(!usz && OL < woff + sz) { outbuf = realloc(outbuf, woff + sz); OL = outbuf.length; }
				while(sz-- > 0) { outbuf[woff++] = data[boff>>>3]; boff += 8; }
			}
			continue;
		} else if((header >> 1) == 1) {
			/* Fixed Huffman */
			max_len_1 = 9; max_len_2 = 5;
		} else {
			/* Dynamic Huffman */
			boff = dyn(data, boff);
			max_len_1 = dyn_len_1; max_len_2 = dyn_len_2;
		}
		for(;;) { // while(true) is apparently out of vogue in modern JS circles
			if(!usz && (OL < woff + 32767)) { outbuf = realloc(outbuf, woff + 32767); OL = outbuf.length; }
			/* ingest code and move read head */
			var bits = read_bits_n(data, boff, max_len_1);
			var code = (header>>>1) == 1 ? fix_lmap[bits] : dyn_lmap[bits];
			boff += code & 15; code >>>= 4;
			/* 0-255 are literals, 256 is end of block token, 257+ are copy tokens */
			if(((code>>>8)&0xFF) === 0) outbuf[woff++] = code;
			else if(code == 256) break;
			else {
				code -= 257;
				var len_eb = (code < 8) ? 0 : ((code-4)>>2); if(len_eb > 5) len_eb = 0;
				var tgt = woff + LEN_LN[code];
				/* length extra bits */
				if(len_eb > 0) {
					tgt += read_bits_n(data, boff, len_eb);
					boff += len_eb;
				}

				/* dist code */
				bits = read_bits_n(data, boff, max_len_2);
				code = (header>>>1) == 1 ? fix_dmap[bits] : dyn_dmap[bits];
				boff += code & 15; code >>>= 4;
				var dst_eb = (code < 4 ? 0 : (code-2)>>1);
				var dst = DST_LN[code];
				/* dist extra bits */
				if(dst_eb > 0) {
					dst += read_bits_n(data, boff, dst_eb);
					boff += dst_eb;
				}

				/* in the common case, manual byte copy is faster than TA set / Buffer copy */
				if(!usz && OL < tgt) { outbuf = realloc(outbuf, tgt + 100); OL = outbuf.length; }
				while(woff < tgt) { outbuf[woff] = outbuf[woff - dst]; ++woff; }
			}
		}
	}
	if(usz) return [outbuf, (boff+7)>>>3];
	return [outbuf.slice(0, woff), (boff+7)>>>3];
}

function _inflate(payload, usz) {
	var data = payload.slice(payload.l||0);
	var out = inflate(data, usz);
	payload.l += out[1];
	return out[0];
}

function warn_or_throw(wrn, msg) {
	if(wrn) { if(typeof console !== 'undefined') console.error(msg); }
	else throw new Error(msg);
}

function parse_zip(file, options) {
	var blob = file;
	prep_blob(blob, 0);

	var FileIndex = [], FullPaths = [];
	var o = {
		FileIndex: FileIndex,
		FullPaths: FullPaths
	};
	init_cfb(o, { root: options.root });

	/* find end of central directory, start just after signature */
	var i = blob.length - 4;
	while((blob[i] != 0x50 || blob[i+1] != 0x4b || blob[i+2] != 0x05 || blob[i+3] != 0x06) && i >= 0) --i;
	blob.l = i + 4;

	/* parse end of central directory */
	blob.l += 4;
	var fcnt = blob.read_shift(2);
	blob.l += 6;
	var start_cd = blob.read_shift(4);

	/* parse central directory */
	blob.l = start_cd;

	for(i = 0; i < fcnt; ++i) {
		/* trust local file header instead of CD entry */
		blob.l += 20;
		var csz = blob.read_shift(4);
		var usz = blob.read_shift(4);
		var namelen = blob.read_shift(2);
		var efsz = blob.read_shift(2);
		var fcsz = blob.read_shift(2);
		blob.l += 8;
		var offset = blob.read_shift(4);
		var EF = parse_extra_field(blob.slice(blob.l+namelen, blob.l+namelen+efsz));
		blob.l += namelen + efsz + fcsz;

		var L = blob.l;
		blob.l = offset + 4;
		/* ZIP64 lengths */
		if(EF && EF[0x0001]) {
			if((EF[0x0001]||{}).usz) usz = EF[0x0001].usz;
			if((EF[0x0001]||{}).csz) csz = EF[0x0001].csz;
		}
		parse_local_file(blob, csz, usz, o, EF);
		blob.l = L;
	}

	return o;
}


/* head starts just after local file header signature */
function parse_local_file(blob, csz, usz, o, EF) {
	/* [local file header] */
	blob.l += 2;
	var flags = blob.read_shift(2);
	var meth = blob.read_shift(2);
	var date = parse_dos_date(blob);

	if(flags & 0x2041) throw new Error("Unsupported ZIP encryption");
	var crc32 = blob.read_shift(4);
	var _csz = blob.read_shift(4);
	var _usz = blob.read_shift(4);

	var namelen = blob.read_shift(2);
	var efsz = blob.read_shift(2);

	// TODO: flags & (1<<11) // UTF8
	var name = ""; for(var i = 0; i < namelen; ++i) name += String.fromCharCode(blob[blob.l++]);
	if(efsz) {
		var ef = parse_extra_field(blob.slice(blob.l, blob.l + efsz));
		if((ef[0x5455]||{}).mt) date = ef[0x5455].mt;
		if((ef[0x0001]||{}).usz) _usz = ef[0x0001].usz;
		if((ef[0x0001]||{}).csz) _csz = ef[0x0001].csz;
		if(EF) {
			if((EF[0x5455]||{}).mt) date = EF[0x5455].mt;
			if((EF[0x0001]||{}).usz) _usz = ef[0x0001].usz;
			if((EF[0x0001]||{}).csz) _csz = ef[0x0001].csz;
		}
	}
	blob.l += efsz;

	/* [encryption header] */

	/* [file data] */
	var data = blob.slice(blob.l, blob.l + _csz);
	switch(meth) {
		case 8: data = _inflateRawSync(blob, _usz); break;
		case 0: break; // TODO: scan for magic number
		default: throw new Error("Unsupported ZIP Compression method " + meth);
	}

	/* [data descriptor] */
	var wrn = false;
	if(flags & 8) {
		crc32 = blob.read_shift(4);
		if(crc32 == 0x08074b50) { crc32 = blob.read_shift(4); wrn = true; }
		_csz = blob.read_shift(4);
		_usz = blob.read_shift(4);
	}

	if(_csz != csz) warn_or_throw(wrn, "Bad compressed size: " + csz + " != " + _csz);
	if(_usz != usz) warn_or_throw(wrn, "Bad uncompressed size: " + usz + " != " + _usz);
	//var _crc32 = CRC32.buf(data, 0);
	//if((crc32>>0) != (_crc32>>0)) warn_or_throw(wrn, "Bad CRC32 checksum: " + crc32 + " != " + _crc32);
	cfb_add(o, name, data, {unsafe: true, mt: date});
}
function write_zip(cfb, options) {
	var _opts = options || {};
	var out = [], cdirs = [];
	var o = new_buf(1);
	var method = (_opts.compression ? 8 : 0), flags = 0;
	var desc = false;
	if(desc) flags |= 8;
	var i = 0, j = 0;

	var start_cd = 0, fcnt = 0;
	var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
	var crcs = [];
	var sz_cd = 0;

	for(i = 1; i < cfb.FullPaths.length; ++i) {
		fp = cfb.FullPaths[i].slice(root.length); fi = cfb.FileIndex[i];
		if(!fi.size || !fi.content || fp == "\u0001Sh33tJ5") continue;
		var start = start_cd;

		/* TODO: CP437 filename */
		var namebuf = new_buf(fp.length);
		for(j = 0; j < fp.length; ++j) namebuf.write_shift(1, fp.charCodeAt(j) & 0x7F);
		namebuf = namebuf.slice(0, namebuf.l);
		crcs[fcnt] = typeof fi.content == "string" ? CRC32.bstr(fi.content, 0) : CRC32.buf(fi.content, 0);

		var outbuf = typeof fi.content == "string" ? s2a(fi.content) : fi.content;
		if(method == 8) outbuf = _deflateRawSync(outbuf);

		/* local file header */
		o = new_buf(30);
		o.write_shift(4, 0x04034b50);
		o.write_shift(2, 20);
		o.write_shift(2, flags);
		o.write_shift(2, method);
		/* TODO: last mod file time/date */
		if(fi.mt) write_dos_date(o, fi.mt);
		else o.write_shift(4, 0);
		o.write_shift(-4, (flags & 8) ? 0 : crcs[fcnt]);
		o.write_shift(4,  (flags & 8) ? 0 : outbuf.length);
		o.write_shift(4,  (flags & 8) ? 0 : fi.content.length);
		o.write_shift(2, namebuf.length);
		o.write_shift(2, 0);

		start_cd += o.length;
		out.push(o);
		start_cd += namebuf.length;
		out.push(namebuf);

		/* TODO: extra fields? */

		/* TODO: encryption header ? */

		start_cd += outbuf.length;
		out.push(outbuf);

		/* data descriptor */
		if(flags & 8) {
			o = new_buf(12);
			o.write_shift(-4, crcs[fcnt]);
			o.write_shift(4, outbuf.length);
			o.write_shift(4, fi.content.length);
			start_cd += o.l;
			out.push(o);
		}

		/* central directory */
		o = new_buf(46);
		o.write_shift(4, 0x02014b50);
		o.write_shift(2, 0);
		o.write_shift(2, 20);
		o.write_shift(2, flags);
		o.write_shift(2, method);
		o.write_shift(4, 0); /* TODO: last mod file time/date */
		o.write_shift(-4, crcs[fcnt]);

		o.write_shift(4, outbuf.length);
		o.write_shift(4, fi.content.length);
		o.write_shift(2, namebuf.length);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(4, 0);
		o.write_shift(4, start);

		sz_cd += o.l;
		cdirs.push(o);
		sz_cd += namebuf.length;
		cdirs.push(namebuf);
		++fcnt;
	}

	/* end of central directory */
	o = new_buf(22);
	o.write_shift(4, 0x06054b50);
	o.write_shift(2, 0);
	o.write_shift(2, 0);
	o.write_shift(2, fcnt);
	o.write_shift(2, fcnt);
	o.write_shift(4, sz_cd);
	o.write_shift(4, start_cd);
	o.write_shift(2, 0);

	return bconcat(([bconcat((out)), bconcat(cdirs), o]));
}
var ContentTypeMap = ({
	"htm": "text/html",
	"xml": "text/xml",

	"gif": "image/gif",
	"jpg": "image/jpeg",
	"png": "image/png",

	"mso": "application/x-mso",
	"thmx": "application/vnd.ms-officetheme",
	"sh33tj5": "application/octet-stream"
});

function get_content_type(fi, fp) {
	if(fi.ctype) return fi.ctype;

	var ext = fi.name || "", m = ext.match(/\.([^\.]+)$/);
	if(m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];

	if(fp) {
		m = (ext = fp).match(/[\.\\]([^\.\\])+$/);
		if(m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
	}

	return "application/octet-stream";
}

/* 76 character chunks TODO: intertwine encoding */
function write_base64_76(bstr) {
	var data = Base64_encode(bstr);
	var o = [];
	for(var i = 0; i < data.length; i+= 76) o.push(data.slice(i, i+76));
	return o.join("\r\n") + "\r\n";
}

/*
Rules for QP:
	- escape =## applies for all non-display characters and literal "="
	- space or tab at end of line must be encoded
	- \r\n newlines can be preserved, but bare \r and \n must be escaped
	- lines must not exceed 76 characters, use soft breaks =\r\n

TODO: Some files from word appear to write line extensions with bare equals:

```
<table class=3DMsoTableGrid border=3D1 cellspacing=3D0 cellpadding=3D0 width=
="70%"
```
*/
function write_quoted_printable(text) {
	var encoded = text.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g, function(c) {
		var w = c.charCodeAt(0).toString(16).toUpperCase();
		return "=" + (w.length == 1 ? "0" + w : w);
	});

	encoded = encoded.replace(/ $/mg, "=20").replace(/\t$/mg, "=09");

	if(encoded.charAt(0) == "\n") encoded = "=0D" + encoded.slice(1);
	encoded = encoded.replace(/\r(?!\n)/mg, "=0D").replace(/\n\n/mg, "\n=0A").replace(/([^\r\n])\n/mg, "$1=0A");

	var o = [], split = encoded.split("\r\n");
	for(var si = 0; si < split.length; ++si) {
		var str = split[si];
		if(str.length == 0) { o.push(""); continue; }
		for(var i = 0; i < str.length;) {
			var end = 76;
			var tmp = str.slice(i, i + end);
			if(tmp.charAt(end - 1) == "=") end --;
			else if(tmp.charAt(end - 2) == "=") end -= 2;
			else if(tmp.charAt(end - 3) == "=") end -= 3;
			tmp = str.slice(i, i + end);
			i += end;
			if(i < str.length) tmp += "=";
			o.push(tmp);
		}
	}

	return o.join("\r\n");
}
function parse_quoted_printable(data) {
	var o = [];

	/* unify long lines */
	for(var di = 0; di < data.length; ++di) {
		var line = data[di];
		while(di <= data.length && line.charAt(line.length - 1) == "=") line = line.slice(0, line.length - 1) + data[++di];
		o.push(line);
	}

	/* decode */
	for(var oi = 0; oi < o.length; ++oi) o[oi] = o[oi].replace(/[=][0-9A-Fa-f]{2}/g, function($$) { return String.fromCharCode(parseInt($$.slice(1), 16)); });
	return s2a(o.join("\r\n"));
}


function parse_mime(cfb, data, root) {
	var fname = "", cte = "", ctype = "", fdata;
	var di = 0;
	for(;di < 10; ++di) {
		var line = data[di];
		if(!line || line.match(/^\s*$/)) break;
		var m = line.match(/^(.*?):\s*([^\s].*)$/);
		if(m) switch(m[1].toLowerCase()) {
			case "content-location": fname = m[2].trim(); break;
			case "content-type": ctype = m[2].trim(); break;
			case "content-transfer-encoding": cte = m[2].trim(); break;
		}
	}
	++di;
	switch(cte.toLowerCase()) {
		case 'base64': fdata = s2a(Base64_decode(data.slice(di).join(""))); break;
		case 'quoted-printable': fdata = parse_quoted_printable(data.slice(di)); break;
		default: throw new Error("Unsupported Content-Transfer-Encoding " + cte);
	}
	var file = cfb_add(cfb, fname.slice(root.length), fdata, {unsafe: true});
	if(ctype) file.ctype = ctype;
}

function parse_mad(file, options) {
	if(a2s(file.slice(0,13)).toLowerCase() != "mime-version:") throw new Error("Unsupported MAD header");
	var root = (options && options.root || "");
	// $FlowIgnore
	var data = (has_buf && Buffer.isBuffer(file) ? file.toString("binary") : a2s(file)).split("\r\n");
	var di = 0, row = "";

	/* if root is not specified, scan for the common prefix */
	for(di = 0; di < data.length; ++di) {
		row = data[di];
		if(!/^Content-Location:/i.test(row)) continue;
		row = row.slice(row.indexOf("file"));
		if(!root) root = row.slice(0, row.lastIndexOf("/") + 1);
		if(row.slice(0, root.length) == root) continue;
		while(root.length > 0) {
			root = root.slice(0, root.length - 1);
			root = root.slice(0, root.lastIndexOf("/") + 1);
			if(row.slice(0,root.length) == root) break;
		}
	}

	var mboundary = (data[1] || "").match(/boundary="(.*?)"/);
	if(!mboundary) throw new Error("MAD cannot find boundary");
	var boundary = "--" + (mboundary[1] || "");

	var FileIndex = [], FullPaths = [];
	var o = {
		FileIndex: FileIndex,
		FullPaths: FullPaths
	};
	init_cfb(o);
	var start_di, fcnt = 0;
	for(di = 0; di < data.length; ++di) {
		var line = data[di];
		if(line !== boundary && line !== boundary + "--") continue;
		if(fcnt++) parse_mime(o, data.slice(start_di, di), root);
		start_di = di;
	}
	return o;
}

function write_mad(cfb, options) {
	var opts = options || {};
	var boundary = opts.boundary || "SheetJS";
	boundary = '------=' + boundary;

	var out = [
		'MIME-Version: 1.0',
		'Content-Type: multipart/related; boundary="' + boundary.slice(2) + '"',
		'',
		'',
		''
	];

	var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
	for(var i = 1; i < cfb.FullPaths.length; ++i) {
		fp = cfb.FullPaths[i].slice(root.length);
		fi = cfb.FileIndex[i];
		if(!fi.size || !fi.content || fp == "\u0001Sh33tJ5") continue;

		/* Normalize filename */
		fp = fp.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g, function(c) {
			return "_x" + c.charCodeAt(0).toString(16) + "_";
		}).replace(/[\u0080-\uFFFF]/g, function(u) {
			return "_u" + u.charCodeAt(0).toString(16) + "_";
		});

		/* Extract content as binary string */
		var ca = fi.content;
		// $FlowIgnore
		var cstr = has_buf && Buffer.isBuffer(ca) ? ca.toString("binary") : a2s(ca);

		/* 4/5 of first 1024 chars ascii -> quoted printable, else base64 */
		var dispcnt = 0, L = Math.min(1024, cstr.length), cc = 0;
		for(var csl = 0; csl <= L; ++csl) if((cc=cstr.charCodeAt(csl)) >= 0x20 && cc < 0x80) ++dispcnt;
		var qp = dispcnt >= L * 4 / 5;

		out.push(boundary);
		out.push('Content-Location: ' + (opts.root || 'file:///C:/SheetJS/') + fp);
		out.push('Content-Transfer-Encoding: ' + (qp ? 'quoted-printable' : 'base64'));
		out.push('Content-Type: ' + get_content_type(fi, fp));
		out.push('');

		out.push(qp ? write_quoted_printable(cstr) : write_base64_76(cstr));
	}
	out.push(boundary + '--\r\n');
	return out.join("\r\n");
}
function cfb_new(opts) {
	var o = ({});
	init_cfb(o, opts);
	return o;
}

function cfb_add(cfb, name, content, opts) {
	var unsafe = opts && opts.unsafe;
	if(!unsafe) init_cfb(cfb);
	var file = !unsafe && CFB.find(cfb, name);
	if(!file) {
		var fpath = cfb.FullPaths[0];
		if(name.slice(0, fpath.length) == fpath) fpath = name;
		else {
			if(fpath.slice(-1) != "/") fpath += "/";
			fpath = (fpath + name).replace("//","/");
		}
		file = ({name: filename(name), type: 2});
		cfb.FileIndex.push(file);
		cfb.FullPaths.push(fpath);
		if(!unsafe) CFB.utils.cfb_gc(cfb);
	}
file.content = (content);
	file.size = content ? content.length : 0;
	if(opts) {
		if(opts.CLSID) file.clsid = opts.CLSID;
		if(opts.mt) file.mt = opts.mt;
		if(opts.ct) file.ct = opts.ct;
	}
	return file;
}

function cfb_del(cfb, name) {
	init_cfb(cfb);
	var file = CFB.find(cfb, name);
	if(file) for(var j = 0; j < cfb.FileIndex.length; ++j) if(cfb.FileIndex[j] == file) {
		cfb.FileIndex.splice(j, 1);
		cfb.FullPaths.splice(j, 1);
		return true;
	}
	return false;
}

function cfb_mov(cfb, old_name, new_name) {
	init_cfb(cfb);
	var file = CFB.find(cfb, old_name);
	if(file) for(var j = 0; j < cfb.FileIndex.length; ++j) if(cfb.FileIndex[j] == file) {
		cfb.FileIndex[j].name = filename(new_name);
		cfb.FullPaths[j] = new_name;
		return true;
	}
	return false;
}

function cfb_gc(cfb) { rebuild_cfb(cfb, true); }

exports.find = find;
exports.read = read;
exports.parse = parse;
exports.write = write;
exports.writeFile = write_file;
exports.utils = {
	cfb_new: cfb_new,
	cfb_add: cfb_add,
	cfb_del: cfb_del,
	cfb_mov: cfb_mov,
	cfb_gc: cfb_gc,
	ReadShift: ReadShift,
	CheckField: CheckField,
	prep_blob: prep_blob,
	bconcat: bconcat,
	use_zlib: use_zlib,
	_deflateRaw: _deflate,
	_inflateRaw: _inflate,
	consts: consts
};

return exports;
})();

var _fs;
function set_fs(fs) { _fs = fs; }

/* normalize data for blob ctor */
function blobify(data) {
	if(typeof data === "string") return s2ab(data);
	if(Array.isArray(data)) return a2u(data);
	return data;
}
/* write or download file */
function write_dl(fname, payload, enc) {
	/*global IE_SaveFile, Blob, navigator, saveAs, document, File, chrome */
	if(typeof _fs !== 'undefined' && _fs.writeFileSync) return enc ? _fs.writeFileSync(fname, payload, enc) : _fs.writeFileSync(fname, payload);
	if(typeof Deno !== 'undefined') {
		/* in this spot, it's safe to assume typed arrays and TextEncoder/TextDecoder exist */
		if(enc && typeof payload == "string") switch(enc) {
			case "utf8": payload = new TextEncoder(enc).encode(payload); break;
			case "binary": payload = s2ab(payload); break;
			/* TODO: binary equivalent */
			default: throw new Error("Unsupported encoding " + enc);
		}
		return Deno.writeFileSync(fname, payload);
	}
	var data = (enc == "utf8") ? utf8write(payload) : payload;
if(typeof IE_SaveFile !== 'undefined') return IE_SaveFile(data, fname);
	if(typeof Blob !== 'undefined') {
		var blob = new Blob([blobify(data)], {type:"application/octet-stream"});
if(typeof navigator !== 'undefined' && navigator.msSaveBlob) return navigator.msSaveBlob(blob, fname);
if(typeof saveAs !== 'undefined') return saveAs(blob, fname);
		if(typeof URL !== 'undefined' && typeof document !== 'undefined' && document.createElement && URL.createObjectURL) {
			var url = URL.createObjectURL(blob);
if(typeof chrome === 'object' && typeof (chrome.downloads||{}).download == "function") {
				if(URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() { URL.revokeObjectURL(url); }, 60000);
				return chrome.downloads.download({ url: url, filename: fname, saveAs: true});
			}
			var a = document.createElement("a");
			if(a.download != null) {
a.download = fname; a.href = url; document.body.appendChild(a); a.click();
document.body.removeChild(a);
				if(URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() { URL.revokeObjectURL(url); }, 60000);
				return url;
			}
		}
	}
	// $FlowIgnore
	if(typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try { // extendscript
		// $FlowIgnore
		var out = File(fname); out.open("w"); out.encoding = "binary";
		if(Array.isArray(payload)) payload = a2s(payload);
		out.write(payload); out.close(); return payload;
	} catch(e) { if(!e.message || !e.message.match(/onstruct/)) throw e; }
	throw new Error("cannot save file " + fname);
}

/* read binary data from file */
function read_binary(path) {
	if(typeof _fs !== 'undefined') return _fs.readFileSync(path);
	if(typeof Deno !== 'undefined') return Deno.readFileSync(path);
	// $FlowIgnore
	if(typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try { // extendscript
		// $FlowIgnore
		var infile = File(path); infile.open("r"); infile.encoding = "binary";
		var data = infile.read(); infile.close();
		return data;
	} catch(e) { if(!e.message || !e.message.match(/onstruct/)) throw e; }
	throw new Error("Cannot access file " + path);
}
function keys(o) {
	var ks = Object.keys(o), o2 = [];
	for(var i = 0; i < ks.length; ++i) if(Object.prototype.hasOwnProperty.call(o, ks[i])) o2.push(ks[i]);
	return o2;
}

function evert_key(obj, key) {
	var o = ([]), K = keys(obj);
	for(var i = 0; i !== K.length; ++i) if(o[obj[K[i]][key]] == null) o[obj[K[i]][key]] = K[i];
	return o;
}

function evert(obj) {
	var o = ([]), K = keys(obj);
	for(var i = 0; i !== K.length; ++i) o[obj[K[i]]] = K[i];
	return o;
}

function evert_num(obj) {
	var o = ([]), K = keys(obj);
	for(var i = 0; i !== K.length; ++i) o[obj[K[i]]] = parseInt(K[i],10);
	return o;
}

function evert_arr(obj) {
	var o = ([]), K = keys(obj);
	for(var i = 0; i !== K.length; ++i) {
		if(o[obj[K[i]]] == null) o[obj[K[i]]] = [];
		o[obj[K[i]]].push(K[i]);
	}
	return o;
}

var basedate = new Date(1899, 11, 30, 0, 0, 0); // 2209161600000
function datenum(v, date1904) {
	var epoch = v.getTime();
	if(date1904) epoch -= 1462*24*60*60*1000;
	var dnthresh = basedate.getTime() + (v.getTimezoneOffset() - basedate.getTimezoneOffset()) * 60000;
	return (epoch - dnthresh) / (24 * 60 * 60 * 1000);
}
var refdate = new Date();
var dnthresh = basedate.getTime() + (refdate.getTimezoneOffset() - basedate.getTimezoneOffset()) * 60000;
var refoffset = refdate.getTimezoneOffset();
function numdate(v) {
	var out = new Date();
	out.setTime(v * 24 * 60 * 60 * 1000 + dnthresh);
	if (out.getTimezoneOffset() !== refoffset) {
		out.setTime(out.getTime() + (out.getTimezoneOffset() - refoffset) * 60000);
	}
	return out;
}

/* ISO 8601 Duration */
function parse_isodur(s) {
	var sec = 0, mt = 0, time = false;
	var m = s.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
	if(!m) throw new Error("|" + s + "| is not an ISO8601 Duration");
	for(var i = 1; i != m.length; ++i) {
		if(!m[i]) continue;
		mt = 1;
		if(i > 3) time = true;
		switch(m[i].slice(m[i].length-1)) {
			case 'Y':
				throw new Error("Unsupported ISO Duration Field: " + m[i].slice(m[i].length-1));
			case 'D': mt *= 24;
				/* falls through */
			case 'H': mt *= 60;
				/* falls through */
			case 'M':
				if(!time) throw new Error("Unsupported ISO Duration Field: M");
				else mt *= 60;
				/* falls through */
			case 'S': break;
		}
		sec += mt * parseInt(m[i], 10);
	}
	return sec;
}

var good_pd_date_1 = new Date('2017-02-19T19:06:09.000Z');
var good_pd_date = isNaN(good_pd_date_1.getFullYear()) ? new Date('2/19/17') : good_pd_date_1;
var good_pd = good_pd_date.getFullYear() == 2017;
/* parses a date as a local date */
function parseDate(str, fixdate) {
	var d = new Date(str);
	if(good_pd) {
if(fixdate > 0) d.setTime(d.getTime() + d.getTimezoneOffset() * 60 * 1000);
		else if(fixdate < 0) d.setTime(d.getTime() - d.getTimezoneOffset() * 60 * 1000);
		return d;
	}
	if(str instanceof Date) return str;
	if(good_pd_date.getFullYear() == 1917 && !isNaN(d.getFullYear())) {
		var s = d.getFullYear();
		if(str.indexOf("" + s) > -1) return d;
		d.setFullYear(d.getFullYear() + 100); return d;
	}
	var n = str.match(/\d+/g)||["2017","2","19","0","0","0"];
	var out = new Date(+n[0], +n[1] - 1, +n[2], (+n[3]||0), (+n[4]||0), (+n[5]||0));
	if(str.indexOf("Z") > -1) out = new Date(out.getTime() - out.getTimezoneOffset() * 60 * 1000);
	return out;
}

function cc2str(arr, debomit) {
	if(has_buf && Buffer.isBuffer(arr)) {
		if(debomit && buf_utf16le) {
			// TODO: temporary patch
			if(arr[0] == 0xFF && arr[1] == 0xFE) return utf8write(arr.slice(2).toString("utf16le"));
			if(arr[1] == 0xFE && arr[2] == 0xFF) return utf8write(utf16beread(arr.slice(2).toString("binary")));
		}
		return arr.toString("binary");
	}

	if(typeof TextDecoder !== "undefined") try {
		if(debomit) {
			if(arr[0] == 0xFF && arr[1] == 0xFE) return utf8write(new TextDecoder("utf-16le").decode(arr.slice(2)));
			if(arr[0] == 0xFE && arr[1] == 0xFF) return utf8write(new TextDecoder("utf-16be").decode(arr.slice(2)));
		}
		var rev = {
			"\u20ac": "\x80", "\u201a": "\x82", "\u0192": "\x83", "\u201e": "\x84",
			"\u2026": "\x85", "\u2020": "\x86", "\u2021": "\x87", "\u02c6": "\x88",
			"\u2030": "\x89", "\u0160": "\x8a", "\u2039": "\x8b", "\u0152": "\x8c",
			"\u017d": "\x8e", "\u2018": "\x91", "\u2019": "\x92", "\u201c": "\x93",
			"\u201d": "\x94", "\u2022": "\x95", "\u2013": "\x96", "\u2014": "\x97",
			"\u02dc": "\x98", "\u2122": "\x99", "\u0161": "\x9a", "\u203a": "\x9b",
			"\u0153": "\x9c", "\u017e": "\x9e", "\u0178": "\x9f"
		};
		if(Array.isArray(arr)) arr = new Uint8Array(arr);
		return new TextDecoder("latin1").decode(arr).replace(/[€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]/g, function(c) { return rev[c] || c; });
	} catch(e) {}

	var o = [];
	for(var i = 0; i != arr.length; ++i) o.push(String.fromCharCode(arr[i]));
	return o.join("");
}

function dup(o) {
	if(typeof JSON != 'undefined' && !Array.isArray(o)) return JSON.parse(JSON.stringify(o));
	if(typeof o != 'object' || o == null) return o;
	if(o instanceof Date) return new Date(o.getTime());
	var out = {};
	for(var k in o) if(Object.prototype.hasOwnProperty.call(o, k)) out[k] = dup(o[k]);
	return out;
}

function fill(c,l) { var o = ""; while(o.length < l) o+=c; return o; }

/* TODO: stress test */
function fuzzynum(s) {
	var v = Number(s);
	if(!isNaN(v)) return isFinite(v) ? v : NaN;
	if(!/\d/.test(s)) return v;
	var wt = 1;
	var ss = s.replace(/([\d]),([\d])/g,"$1$2").replace(/[$]/g,"").replace(/[%]/g, function() { wt *= 100; return "";});
	if(!isNaN(v = Number(ss))) return v / wt;
	ss = ss.replace(/[(](.*)[)]/,function($$, $1) { wt = -wt; return $1;});
	if(!isNaN(v = Number(ss))) return v / wt;
	return v;
}

/* NOTE: Chrome rejects bare times like 1:23 PM */
var FDRE1 = /^(0?\d|1[0-2])(?:|:([0-5]?\d)(?:|(\.\d+)(?:|:([0-5]?\d))|:([0-5]?\d)(|\.\d+)))\s+([ap])m?$/;

function fuzzytime1(M)  {
    /* TODO: 1904 adjustment, keep in sync with base date */
    if(!M[2]) return new Date(1899,11,30,(+M[1]%12) + (M[7] == "p" ? 12 : 0), 0, 0, 0);
    if(M[3]) {
        if(M[4]) return new Date(1899,11,30,(+M[1]%12) + (M[7] == "p" ? 12 : 0), +M[2], +M[4], parseFloat(M[3])*1000);
        else return new Date(1899,11,30,(M[7] == "p" ? 12 : 0), +M[1], +M[2], parseFloat(M[3])*1000);
    }
    else if(M[5]) return new Date(1899,11,30, (+M[1]%12) + (M[7] == "p" ? 12 : 0), +M[2], +M[5], M[6] ? parseFloat(M[6]) * 1000 : 0);
    else return new Date(1899,11,30,(+M[1]%12) + (M[7] == "p" ? 12 : 0), +M[2], 0, 0);
}
var lower_months = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
function fuzzydate(s) {
	var lower = s.toLowerCase();
	var lnos = lower.replace(/\s+/g, " ").trim();
	var M = lnos.match(FDRE1);
	if(M) return fuzzytime1(M);

	var o = new Date(s), n = new Date(NaN);
	var y = o.getYear(), m = o.getMonth(), d = o.getDate();
	if(isNaN(d)) return n;
	if(lower.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) {
		lower = lower.replace(/[^a-z]/g,"").replace(/([^a-z]|^)[ap]m?([^a-z]|$)/,"");
		if(lower.length > 3 && lower_months.indexOf(lower) == -1) return n;
	} else if(lower.replace(/[ap]m?/, "").match(/[a-z]/)) return n;
	if(y < 0 || y > 8099 || s.match(/[^-0-9:,\/\\]/)) return n;
	return o;
}

var split_regex = (function() {
	var safe_split_regex = "abacaba".split(/(:?b)/i).length == 5;
	return function split_regex(str, re, def) {
		if(safe_split_regex || typeof re == "string") return str.split(re);
		var p = str.split(re), o = [p[0]];
		for(var i = 1; i < p.length; ++i) { o.push(def); o.push(p[i]); }
		return o;
	};
})();
function getdatastr(data) {
	if(!data) return null;
	if(data.content && data.type) return cc2str(data.content, true);
	if(data.data) return debom(data.data);
	if(data.asNodeBuffer && has_buf) return debom(data.asNodeBuffer().toString('binary'));
	if(data.asBinary) return debom(data.asBinary());
	if(data._data && data._data.getContent) return debom(cc2str(Array.prototype.slice.call(data._data.getContent(),0)));
	return null;
}

function getdatabin(data) {
	if(!data) return null;
	if(data.data) return char_codes(data.data);
	if(data.asNodeBuffer && has_buf) return data.asNodeBuffer();
	if(data._data && data._data.getContent) {
		var o = data._data.getContent();
		if(typeof o == "string") return char_codes(o);
		return Array.prototype.slice.call(o);
	}
	if(data.content && data.type) return data.content;
	return null;
}

function getdata(data) { return (data && data.name.slice(-4) === ".bin") ? getdatabin(data) : getdatastr(data); }

/* Part 2 Section 10.1.2 "Mapping Content Types" Names are case-insensitive */
/* OASIS does not comment on filename case sensitivity */
function safegetzipfile(zip, file) {
	var k = zip.FullPaths || keys(zip.files);
	var f = file.toLowerCase().replace(/[\/]/g, '\\'), g = f.replace(/\\/g,'\/');
	for(var i=0; i<k.length; ++i) {
		var n = k[i].replace(/^Root Entry[\/]/,"").toLowerCase();
		if(f == n || g == n) return zip.files ? zip.files[k[i]] : zip.FileIndex[i];
	}
	return null;
}

function getzipfile(zip, file) {
	var o = safegetzipfile(zip, file);
	if(o == null) throw new Error("Cannot find file " + file + " in zip");
	return o;
}

function getzipdata(zip, file, safe) {
	if(!safe) return getdata(getzipfile(zip, file));
	if(!file) return null;
	try { return getzipdata(zip, file); } catch(e) { return null; }
}

function getzipstr(zip, file, safe) {
	if(!safe) return getdatastr(getzipfile(zip, file));
	if(!file) return null;
	try { return getzipstr(zip, file); } catch(e) { return null; }
}

function getzipbin(zip, file, safe) {
	if(!safe) return getdatabin(getzipfile(zip, file));
	if(!file) return null;
	try { return getzipbin(zip, file); } catch(e) { return null; }
}

function zipentries(zip) {
	var k = zip.FullPaths || keys(zip.files), o = [];
	for(var i = 0; i < k.length; ++i) if(k[i].slice(-1) != '/') o.push(k[i].replace(/^Root Entry[\/]/, ""));
	return o.sort();
}

function zip_add_file(zip, path, content) {
	if(zip.FullPaths) {
		if(typeof content == "string") {
			var res;
			if(has_buf) res = Buffer_from(content);
			/* TODO: investigate performance in Edge 13 */
			//else if(typeof TextEncoder !== "undefined") res = new TextEncoder().encode(content);
			else res = utf8decode(content);
			return CFB.utils.cfb_add(zip, path, res);
		}
		CFB.utils.cfb_add(zip, path, content);
	}
	else zip.file(path, content);
}

function zip_new() { return CFB.utils.cfb_new(); }

function zip_read(d, o) {
	switch(o.type) {
		case "base64": return CFB.read(d, { type: "base64" });
		case "binary": return CFB.read(d, { type: "binary" });
		case "buffer": case "array": return CFB.read(d, { type: "buffer" });
	}
	throw new Error("Unrecognized type " + o.type);
}

function resolve_path(path, base) {
	if(path.charAt(0) == "/") return path.slice(1);
	var result = base.split('/');
	if(base.slice(-1) != "/") result.pop(); // folder path
	var target = path.split('/');
	while (target.length !== 0) {
		var step = target.shift();
		if (step === '..') result.pop();
		else if (step !== '.') result.push(step);
	}
	return result.join('/');
}
var XML_HEADER = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';
var attregexg=/([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;
var tagregex1=/<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s*[\/\?]?>/mg, tagregex2 = /<[^>]*>/g;
var tagregex = XML_HEADER.match(tagregex1) ? tagregex1 : tagregex2;
var nsregex=/<\w*:/, nsregex2 = /<(\/?)\w+:/;
function parsexmltag(tag, skip_root, skip_LC) {
	var z = ({});
	var eq = 0, c = 0;
	for(; eq !== tag.length; ++eq) if((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
	if(!skip_root) z[0] = tag.slice(0, eq);
	if(eq === tag.length) return z;
	var m = tag.match(attregexg), j=0, v="", i=0, q="", cc="", quot = 1;
	if(m) for(i = 0; i != m.length; ++i) {
		cc = m[i];
		for(c=0; c != cc.length; ++c) if(cc.charCodeAt(c) === 61) break;
		q = cc.slice(0,c).trim();
		while(cc.charCodeAt(c+1) == 32) ++c;
		quot = ((eq=cc.charCodeAt(c+1)) == 34 || eq == 39) ? 1 : 0;
		v = cc.slice(c+1+quot, cc.length-quot);
		for(j=0;j!=q.length;++j) if(q.charCodeAt(j) === 58) break;
		if(j===q.length) {
			if(q.indexOf("_") > 0) q = q.slice(0, q.indexOf("_")); // from ods
			z[q] = v;
			if(!skip_LC) z[q.toLowerCase()] = v;
		}
		else {
			var k = (j===5 && q.slice(0,5)==="xmlns"?"xmlns":"")+q.slice(j+1);
			if(z[k] && q.slice(j-3,j) == "ext") continue; // from ods
			z[k] = v;
			if(!skip_LC) z[k.toLowerCase()] = v;
		}
	}
	return z;
}
function strip_ns(x) { return x.replace(nsregex2, "<$1"); }

var encodings = {
	'&quot;': '"',
	'&apos;': "'",
	'&gt;': '>',
	'&lt;': '<',
	'&amp;': '&'
};
var rencoding = evert(encodings);
//var rencstr = "&<>'\"".split("");

// TODO: CP remap (need to read file version to determine OS)
var unescapexml = (function() {
	/* 22.4.2.4 bstr (Basic String) */
	var encregex = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/ig, coderegex = /_x([\da-fA-F]{4})_/ig;
	function raw_unescapexml(text) {
		var s = text + '', i = s.indexOf("<![CDATA[");
		if(i == -1) return s.replace(encregex, function($$, $1) { return encodings[$$]||String.fromCharCode(parseInt($1,$$.indexOf("x")>-1?16:10))||$$; }).replace(coderegex,function(m,c) {return String.fromCharCode(parseInt(c,16));});
		var j = s.indexOf("]]>");
		return raw_unescapexml(s.slice(0, i)) + s.slice(i+9,j) + raw_unescapexml(s.slice(j+3));
	}
	return function unescapexml(text, xlsx) {
		var out = raw_unescapexml(text);
		return xlsx ? out.replace(/\r\n/g, "\n") : out;
	};
})();

var decregex=/[&<>'"]/g, charegex = /[\u0000-\u0008\u000b-\u001f\uFFFE-\uFFFF]/g;
function escapexml(text){
	var s = text + '';
	return s.replace(decregex, function(y) { return rencoding[y]; }).replace(charegex,function(s) { return "_x" + ("000"+s.charCodeAt(0).toString(16)).slice(-4) + "_";});
}
function escapexmltag(text){ return escapexml(text).replace(/ /g,"_x0020_"); }

var htmlcharegex = /[\u0000-\u001f]/g;
function escapehtml(text){
	var s = text + '';
	return s.replace(decregex, function(y) { return rencoding[y]; }).replace(/\n/g, "<br/>").replace(htmlcharegex,function(s) { return "&#x" + ("000"+s.charCodeAt(0).toString(16)).slice(-4) + ";"; });
}

function escapexlml(text){
	var s = text + '';
	return s.replace(decregex, function(y) { return rencoding[y]; }).replace(htmlcharegex,function(s) { return "&#x" + (s.charCodeAt(0).toString(16)).toUpperCase() + ";"; });
}

/* TODO: handle codepages */
var xlml_fixstr = (function() {
	var entregex = /&#(\d+);/g;
	function entrepl($$,$1) { return String.fromCharCode(parseInt($1,10)); }
	return function xlml_fixstr(str) { return str.replace(entregex,entrepl); };
})();
function xlml_unfixstr(str) { return str.replace(/(\r\n|[\r\n])/g,"\&#10;"); }

/* note: xsd:boolean valid values: true / 1 / false / 0 */
function parsexmlbool(value) {
	switch(value) {
		case 1: case true:  case '1': case 'true':  return true;
		case 0: case false: case '0': case 'false': return false;
		//default: throw new Error("Invalid xsd:boolean " + value);
	}
	return false;
}

function utf8reada(orig) {
	var out = "", i = 0, c = 0, d = 0, e = 0, f = 0, w = 0;
	while (i < orig.length) {
		c = orig.charCodeAt(i++);
		if (c < 128) { out += String.fromCharCode(c); continue; }
		d = orig.charCodeAt(i++);
		if (c>191 && c<224) { f = ((c & 31) << 6); f |= (d & 63); out += String.fromCharCode(f); continue; }
		e = orig.charCodeAt(i++);
		if (c < 240) { out += String.fromCharCode(((c & 15) << 12) | ((d & 63) << 6) | (e & 63)); continue; }
		f = orig.charCodeAt(i++);
		w = (((c & 7) << 18) | ((d & 63) << 12) | ((e & 63) << 6) | (f & 63))-65536;
		out += String.fromCharCode(0xD800 + ((w>>>10)&1023));
		out += String.fromCharCode(0xDC00 + (w&1023));
	}
	return out;
}

function utf8readb(data) {
	var out = new_raw_buf(2*data.length), w, i, j = 1, k = 0, ww=0, c;
	for(i = 0; i < data.length; i+=j) {
		j = 1;
		if((c=data.charCodeAt(i)) < 128) w = c;
		else if(c < 224) { w = (c&31)*64+(data.charCodeAt(i+1)&63); j=2; }
		else if(c < 240) { w=(c&15)*4096+(data.charCodeAt(i+1)&63)*64+(data.charCodeAt(i+2)&63); j=3; }
		else { j = 4;
			w = (c & 7)*262144+(data.charCodeAt(i+1)&63)*4096+(data.charCodeAt(i+2)&63)*64+(data.charCodeAt(i+3)&63);
			w -= 65536; ww = 0xD800 + ((w>>>10)&1023); w = 0xDC00 + (w&1023);
		}
		if(ww !== 0) { out[k++] = ww&255; out[k++] = ww>>>8; ww = 0; }
		out[k++] = w%256; out[k++] = w>>>8;
	}
	return out.slice(0,k).toString('ucs2');
}

function utf8readc(data) { return Buffer_from(data, 'binary').toString('utf8'); }

var utf8corpus = "foo bar baz\u00e2\u0098\u0083\u00f0\u009f\u008d\u00a3";
var utf8read = has_buf && (utf8readc(utf8corpus) == utf8reada(utf8corpus) && utf8readc || utf8readb(utf8corpus) == utf8reada(utf8corpus) && utf8readb) || utf8reada;

var utf8write = has_buf ? function(data) { return Buffer_from(data, 'utf8').toString("binary"); } : function(orig) {
	var out = [], i = 0, c = 0, d = 0;
	while(i < orig.length) {
		c = orig.charCodeAt(i++);
		switch(true) {
			case c < 128: out.push(String.fromCharCode(c)); break;
			case c < 2048:
				out.push(String.fromCharCode(192 + (c >> 6)));
				out.push(String.fromCharCode(128 + (c & 63)));
				break;
			case c >= 55296 && c < 57344:
				c -= 55296; d = orig.charCodeAt(i++) - 56320 + (c<<10);
				out.push(String.fromCharCode(240 + ((d >>18) & 7)));
				out.push(String.fromCharCode(144 + ((d >>12) & 63)));
				out.push(String.fromCharCode(128 + ((d >> 6) & 63)));
				out.push(String.fromCharCode(128 + (d & 63)));
				break;
			default:
				out.push(String.fromCharCode(224 + (c >> 12)));
				out.push(String.fromCharCode(128 + ((c >> 6) & 63)));
				out.push(String.fromCharCode(128 + (c & 63)));
		}
	}
	return out.join("");
};

// matches <foo>...</foo> extracts content
var matchtag = (function() {
	var mtcache = ({});
	return function matchtag(f,g) {
		var t = f+"|"+(g||"");
		if(mtcache[t]) return mtcache[t];
		return (mtcache[t] = new RegExp('<(?:\\w+:)?'+f+'(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?'+f+'>',((g||""))));
	};
})();

var htmldecode = (function() {
	var entities = [
		['nbsp', ' '], ['middot', '·'],
		['quot', '"'], ['apos', "'"], ['gt',   '>'], ['lt',   '<'], ['amp',  '&']
	].map(function(x) { return [new RegExp('&' + x[0] + ';', "ig"), x[1]]; });
	return function htmldecode(str) {
		var o = str
				// Remove new lines and spaces from start of content
				.replace(/^[\t\n\r ]+/, "")
				// Remove new lines and spaces from end of content
				.replace(/[\t\n\r ]+$/,"")
				// Added line which removes any white space characters after and before html tags
				.replace(/>\s+/g,">").replace(/\s+</g,"<")
				// Replace remaining new lines and spaces with space
				.replace(/[\t\n\r ]+/g, " ")
				// Replace <br> tags with new lines
				.replace(/<\s*[bB][rR]\s*\/?>/g,"\n")
				// Strip HTML elements
				.replace(/<[^>]*>/g,"");
		for(var i = 0; i < entities.length; ++i) o = o.replace(entities[i][0], entities[i][1]);
		return o;
	};
})();

var vtregex = (function(){ var vt_cache = {};
	return function vt_regex(bt) {
		if(vt_cache[bt] !== undefined) return vt_cache[bt];
		return (vt_cache[bt] = new RegExp("<(?:vt:)?" + bt + ">([\\s\\S]*?)</(?:vt:)?" + bt + ">", 'g') );
};})();
var vtvregex = /<\/?(?:vt:)?variant>/g, vtmregex = /<(?:vt:)([^>]*)>([\s\S]*)</;
function parseVector(data, opts) {
	var h = parsexmltag(data);

	var matches = data.match(vtregex(h.baseType))||[];
	var res = [];
	if(matches.length != h.size) {
		if(opts.WTF) throw new Error("unexpected vector length " + matches.length + " != " + h.size);
		return res;
	}
	matches.forEach(function(x) {
		var v = x.replace(vtvregex,"").match(vtmregex);
		if(v) res.push({v:utf8read(v[2]), t:v[1]});
	});
	return res;
}

var wtregex = /(^\s|\s$|\n)/;
function writetag(f,g) { return '<' + f + (g.match(wtregex)?' xml:space="preserve"' : "") + '>' + g + '</' + f + '>'; }

function wxt_helper(h) { return keys(h).map(function(k) { return " " + k + '="' + h[k] + '"';}).join(""); }
function writextag(f,g,h) { return '<' + f + ((h != null) ? wxt_helper(h) : "") + ((g != null) ? (g.match(wtregex)?' xml:space="preserve"' : "") + '>' + g + '</' + f : "/") + '>';}

function write_w3cdtf(d, t) { try { return d.toISOString().replace(/\.\d*/,""); } catch(e) { if(t) throw e; } return ""; }

function write_vt(s, xlsx) {
	switch(typeof s) {
		case 'string':
			var o = writextag('vt:lpwstr', escapexml(s));
			if(xlsx) o = o.replace(/&quot;/g, "_x0022_");
			return o;
		case 'number': return writextag((s|0)==s?'vt:i4':'vt:r8', escapexml(String(s)));
		case 'boolean': return writextag('vt:bool',s?'true':'false');
	}
	if(s instanceof Date) return writextag('vt:filetime', write_w3cdtf(s));
	throw new Error("Unable to serialize " + s);
}

function xlml_normalize(d) {
	if(has_buf && Buffer.isBuffer(d)) return d.toString('utf8');
	if(typeof d === 'string') return d;
	/* duktape */
	if(typeof Uint8Array !== 'undefined' && d instanceof Uint8Array) return utf8read(a2s(ab2a(d)));
	throw new Error("Bad input format: expected Buffer or string");
}
/* UOS uses CJK in tags */
var xlmlregex = /<(\/?)([^\s?><!\/:]*:|)([^\s?<>:\/]+)(?:[\s?:\/](?:[^>=]|="[^"]*?")*)?>/mg;
//var xlmlregex = /<(\/?)([a-z0-9]*:|)(\w+)[^>]*>/mg;

var XMLNS = ({
	CORE_PROPS: 'http://schemas.openxmlformats.org/package/2006/metadata/core-properties',
	CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties",
	EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
	CT: 'http://schemas.openxmlformats.org/package/2006/content-types',
	RELS: 'http://schemas.openxmlformats.org/package/2006/relationships',
	TCMNT: 'http://schemas.microsoft.com/office/spreadsheetml/2018/threadedcomments',
	'dc': 'http://purl.org/dc/elements/1.1/',
	'dcterms': 'http://purl.org/dc/terms/',
	'dcmitype': 'http://purl.org/dc/dcmitype/',
	'mx': 'http://schemas.microsoft.com/office/mac/excel/2008/main',
	'r': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships',
	'sjs': 'http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties',
	'vt': 'http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes',
	'xsi': 'http://www.w3.org/2001/XMLSchema-instance',
	'xsd': 'http://www.w3.org/2001/XMLSchema'
});

var XMLNS_main = [
	'http://schemas.openxmlformats.org/spreadsheetml/2006/main',
	'http://purl.oclc.org/ooxml/spreadsheetml/main',
	'http://schemas.microsoft.com/office/excel/2006/main',
	'http://schemas.microsoft.com/office/excel/2006/2'
];

var XLMLNS = ({
	'o':    'urn:schemas-microsoft-com:office:office',
	'x':    'urn:schemas-microsoft-com:office:excel',
	'ss':   'urn:schemas-microsoft-com:office:spreadsheet',
	'dt':   'uuid:C2F41010-65B3-11d1-A29F-00AA00C14882',
	'mv':   'http://macVmlSchemaUri',
	'v':    'urn:schemas-microsoft-com:vml',
	'html': 'http://www.w3.org/TR/REC-html40'
});
function read_double_le(b, idx) {
	var s = 1 - 2 * (b[idx + 7] >>> 7);
	var e = ((b[idx + 7] & 0x7f) << 4) + ((b[idx + 6] >>> 4) & 0x0f);
	var m = (b[idx+6]&0x0f);
	for(var i = 5; i >= 0; --i) m = m * 256 + b[idx + i];
	if(e == 0x7ff) return m == 0 ? (s * Infinity) : NaN;
	if(e == 0) e = -1022;
	else { e -= 1023; m += Math.pow(2,52); }
	return s * Math.pow(2, e - 52) * m;
}

function write_double_le(b, v, idx) {
	var bs = ((((v < 0) || (1/v == -Infinity)) ? 1 : 0) << 7), e = 0, m = 0;
	var av = bs ? (-v) : v;
	if(!isFinite(av)) { e = 0x7ff; m = isNaN(v) ? 0x6969 : 0; }
	else if(av == 0) e = m = 0;
	else {
		e = Math.floor(Math.log(av) / Math.LN2);
		m = av * Math.pow(2, 52 - e);
		if((e <= -1023) && (!isFinite(m) || (m < Math.pow(2,52)))) { e = -1022; }
		else { m -= Math.pow(2,52); e+=1023; }
	}
	for(var i = 0; i <= 5; ++i, m/=256) b[idx + i] = m & 0xff;
	b[idx + 6] = ((e & 0x0f) << 4) | (m & 0xf);
	b[idx + 7] = (e >> 4) | bs;
}

var ___toBuffer = function(bufs) { var x=[],w=10240; for(var i=0;i<bufs[0].length;++i) if(bufs[0][i]) for(var j=0,L=bufs[0][i].length;j<L;j+=w) x.push.apply(x, bufs[0][i].slice(j,j+w)); return x; };
var __toBuffer = has_buf ? function(bufs) { return (bufs[0].length > 0 && Buffer.isBuffer(bufs[0][0])) ? Buffer.concat(bufs[0].map(function(x) { return Buffer.isBuffer(x) ? x : Buffer_from(x); })) : ___toBuffer(bufs);} : ___toBuffer;

var ___utf16le = function(b,s,e) { var ss=[]; for(var i=s; i<e; i+=2) ss.push(String.fromCharCode(__readUInt16LE(b,i))); return ss.join("").replace(chr0,''); };
var __utf16le = has_buf ? function(b,s,e) { if(!Buffer.isBuffer(b) || !buf_utf16le) return ___utf16le(b,s,e); return b.toString('utf16le',s,e).replace(chr0,'')/*.replace(chr1,'!')*/; } : ___utf16le;

var ___hexlify = function(b,s,l) { var ss=[]; for(var i=s; i<s+l; ++i) ss.push(("0" + b[i].toString(16)).slice(-2)); return ss.join(""); };
var __hexlify = has_buf ? function(b,s,l) { return Buffer.isBuffer(b) ? b.toString('hex',s,s+l) : ___hexlify(b,s,l); } : ___hexlify;

var ___utf8 = function(b,s,e) { var ss=[]; for(var i=s; i<e; i++) ss.push(String.fromCharCode(__readUInt8(b,i))); return ss.join(""); };
var __utf8 = has_buf ? function utf8_b(b, s, e) { return (Buffer.isBuffer(b)) ? b.toString('utf8',s,e) : ___utf8(b,s,e); } : ___utf8;

var ___lpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
var __lpstr = ___lpstr;

var ___cpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
var __cpstr = ___cpstr;

var ___lpwstr = function(b,i) { var len = 2*__readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
var __lpwstr = ___lpwstr;

var ___lpp4 = function lpp4_(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf16le(b, i+4,i+4+len) : "";};
var __lpp4 = ___lpp4;

var ___8lpp4 = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len) : "";};
var __8lpp4 = ___8lpp4;

var ___double = function(b, idx) { return read_double_le(b, idx);};
var __double = ___double;

var is_buf = function is_buf_a(a) { return Array.isArray(a) || (typeof Uint8Array !== "undefined" && a instanceof Uint8Array); };

if(has_buf) {
	__lpstr = function lpstr_b(b, i) { if(!Buffer.isBuffer(b)) return ___lpstr(b, i); var len = b.readUInt32LE(i); return len > 0 ? b.toString('utf8',i+4,i+4+len-1) : "";};
	__cpstr = function cpstr_b(b, i) { if(!Buffer.isBuffer(b)) return ___cpstr(b, i); var len = b.readUInt32LE(i); return len > 0 ? b.toString('utf8',i+4,i+4+len-1) : "";};
	__lpwstr = function lpwstr_b(b, i) { if(!Buffer.isBuffer(b) || !buf_utf16le) return ___lpwstr(b, i); var len = 2*b.readUInt32LE(i); return b.toString('utf16le',i+4,i+4+len-1);};
	__lpp4 = function lpp4_b(b, i) { if(!Buffer.isBuffer(b) || !buf_utf16le) return ___lpp4(b, i); var len = b.readUInt32LE(i); return b.toString('utf16le',i+4,i+4+len);};
	__8lpp4 = function lpp4_8b(b, i) { if(!Buffer.isBuffer(b)) return ___8lpp4(b, i); var len = b.readUInt32LE(i); return b.toString('utf8',i+4,i+4+len);};
	__double = function double_(b, i) { if(Buffer.isBuffer(b)) return b.readDoubleLE(i); return ___double(b,i); };
	is_buf = function is_buf_b(a) { return Buffer.isBuffer(a) || Array.isArray(a) || (typeof Uint8Array !== "undefined" && a instanceof Uint8Array); };
}

/* from js-xls */
function cpdoit() {
	__utf16le = function(b,s,e) { return $cptable.utils.decode(1200, b.slice(s,e)).replace(chr0, ''); };
	__utf8 = function(b,s,e) { return $cptable.utils.decode(65001, b.slice(s,e)); };
	__lpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? $cptable.utils.decode(current_ansi, b.slice(i+4, i+4+len-1)) : "";};
	__cpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? $cptable.utils.decode(current_codepage, b.slice(i+4, i+4+len-1)) : "";};
	__lpwstr = function(b,i) { var len = 2*__readUInt32LE(b,i); return len > 0 ? $cptable.utils.decode(1200, b.slice(i+4,i+4+len-1)) : "";};
	__lpp4 = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? $cptable.utils.decode(1200, b.slice(i+4,i+4+len)) : "";};
	__8lpp4 = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? $cptable.utils.decode(65001, b.slice(i+4,i+4+len)) : "";};
}
if(typeof $cptable !== 'undefined') cpdoit();

var __readUInt8 = function(b, idx) { return b[idx]; };
var __readUInt16LE = function(b, idx) { return (b[idx+1]*(1<<8))+b[idx]; };
var __readInt16LE = function(b, idx) { var u = (b[idx+1]*(1<<8))+b[idx]; return (u < 0x8000) ? u : ((0xffff - u + 1) * -1); };
var __readUInt32LE = function(b, idx) { return b[idx+3]*(1<<24)+(b[idx+2]<<16)+(b[idx+1]<<8)+b[idx]; };
var __readInt32LE = function(b, idx) { return (b[idx+3]<<24)|(b[idx+2]<<16)|(b[idx+1]<<8)|b[idx]; };
var __readInt32BE = function(b, idx) { return (b[idx]<<24)|(b[idx+1]<<16)|(b[idx+2]<<8)|b[idx+3]; };

function ReadShift(size, t) {
	var o="", oI, oR, oo=[], w, vv, i, loc;
	switch(t) {
		case 'dbcs':
			loc = this.l;
			if(has_buf && Buffer.isBuffer(this)  && buf_utf16le) o = this.slice(this.l, this.l+2*size).toString("utf16le");
			else for(i = 0; i < size; ++i) { o+=String.fromCharCode(__readUInt16LE(this, loc)); loc+=2; }
			size *= 2;
			break;

		case 'utf8': o = __utf8(this, this.l, this.l + size); break;
		case 'utf16le': size *= 2; o = __utf16le(this, this.l, this.l + size); break;

		case 'wstr':
			if(typeof $cptable !== 'undefined') o = $cptable.utils.decode(current_codepage, this.slice(this.l, this.l+2*size));
			else return ReadShift.call(this, size, 'dbcs');
			size = 2 * size; break;

		/* [MS-OLEDS] 2.1.4 LengthPrefixedAnsiString */
		case 'lpstr-ansi': o = __lpstr(this, this.l); size = 4 + __readUInt32LE(this, this.l); break;
		case 'lpstr-cp': o = __cpstr(this, this.l); size = 4 + __readUInt32LE(this, this.l); break;
		/* [MS-OLEDS] 2.1.5 LengthPrefixedUnicodeString */
		case 'lpwstr': o = __lpwstr(this, this.l); size = 4 + 2 * __readUInt32LE(this, this.l); break;
		/* [MS-OFFCRYPTO] 2.1.2 Length-Prefixed Padded Unicode String (UNICODE-LP-P4) */
		case 'lpp4': size = 4 +  __readUInt32LE(this, this.l); o = __lpp4(this, this.l); if(size & 0x02) size += 2; break;
		/* [MS-OFFCRYPTO] 2.1.3 Length-Prefixed UTF-8 String (UTF-8-LP-P4) */
		case '8lpp4': size = 4 +  __readUInt32LE(this, this.l); o = __8lpp4(this, this.l); if(size & 0x03) size += 4 - (size & 0x03); break;

		case 'cstr': size = 0; o = "";
			while((w=__readUInt8(this, this.l + size++))!==0) oo.push(_getchar(w));
			o = oo.join(""); break;
		case '_wstr': size = 0; o = "";
			while((w=__readUInt16LE(this,this.l +size))!==0){oo.push(_getchar(w));size+=2;}
			size+=2; o = oo.join(""); break;

		/* sbcs and dbcs support continue records in the SST way TODO codepages */
		case 'dbcs-cont': o = ""; loc = this.l;
			for(i = 0; i < size; ++i) {
				if(this.lens && this.lens.indexOf(loc) !== -1) {
					w = __readUInt8(this, loc);
					this.l = loc + 1;
					vv = ReadShift.call(this, size-i, w ? 'dbcs-cont' : 'sbcs-cont');
					return oo.join("") + vv;
				}
				oo.push(_getchar(__readUInt16LE(this, loc)));
				loc+=2;
			} o = oo.join(""); size *= 2; break;

		case 'cpstr':
			if(typeof $cptable !== 'undefined') {
				o = $cptable.utils.decode(current_codepage, this.slice(this.l, this.l + size));
				break;
			}
		/* falls through */
		case 'sbcs-cont': o = ""; loc = this.l;
			for(i = 0; i != size; ++i) {
				if(this.lens && this.lens.indexOf(loc) !== -1) {
					w = __readUInt8(this, loc);
					this.l = loc + 1;
					vv = ReadShift.call(this, size-i, w ? 'dbcs-cont' : 'sbcs-cont');
					return oo.join("") + vv;
				}
				oo.push(_getchar(__readUInt8(this, loc)));
				loc+=1;
			} o = oo.join(""); break;

		default:
	switch(size) {
		case 1: oI = __readUInt8(this, this.l); this.l++; return oI;
		case 2: oI = (t === 'i' ? __readInt16LE : __readUInt16LE)(this, this.l); this.l += 2; return oI;
		case 4: case -4:
			if(t === 'i' || ((this[this.l+3] & 0x80)===0)) { oI = ((size > 0) ? __readInt32LE : __readInt32BE)(this, this.l); this.l += 4; return oI; }
			else { oR = __readUInt32LE(this, this.l); this.l += 4; } return oR;
		case 8: case -8:
			if(t === 'f') {
				if(size == 8) oR = __double(this, this.l);
				else oR = __double([this[this.l+7],this[this.l+6],this[this.l+5],this[this.l+4],this[this.l+3],this[this.l+2],this[this.l+1],this[this.l+0]], 0);
				this.l += 8; return oR;
			} else size = 8;
		/* falls through */
		case 16: o = __hexlify(this, this.l, size); break;
	}}
	this.l+=size; return o;
}

var __writeUInt32LE = function(b, val, idx) { b[idx] = (val & 0xFF); b[idx+1] = ((val >>> 8) & 0xFF); b[idx+2] = ((val >>> 16) & 0xFF); b[idx+3] = ((val >>> 24) & 0xFF); };
var __writeInt32LE  = function(b, val, idx) { b[idx] = (val & 0xFF); b[idx+1] = ((val >> 8) & 0xFF); b[idx+2] = ((val >> 16) & 0xFF); b[idx+3] = ((val >> 24) & 0xFF); };
var __writeUInt16LE = function(b, val, idx) { b[idx] = (val & 0xFF); b[idx+1] = ((val >>> 8) & 0xFF); };

function WriteShift(t, val, f) {
	var size = 0, i = 0;
	if(f === 'dbcs') {
for(i = 0; i != val.length; ++i) __writeUInt16LE(this, val.charCodeAt(i), this.l + 2 * i);
		size = 2 * val.length;
	} else if(f === 'sbcs' || f == 'cpstr') {
		if(typeof $cptable !== 'undefined' && current_ansi == 874) {
			/* TODO: use tables directly, don't encode */
for(i = 0; i != val.length; ++i) {
				var cpp = $cptable.utils.encode(current_ansi, val.charAt(i));
				this[this.l + i] = cpp[0];
			}
			size = val.length;
		} else if(typeof $cptable !== 'undefined' && f == 'cpstr') {
			cpp = $cptable.utils.encode(current_codepage, val);
			/* replace null bytes with _ when relevant */
      if(cpp.length == val.length) for(i = 0; i < val.length; ++i) if(cpp[i] == 0 && val.charCodeAt(i) != 0) cpp[i] = 0x5F;
      if(cpp.length == 2 * val.length) for(i = 0; i < val.length; ++i) if(cpp[2*i] == 0 && cpp[2*i+1] == 0 && val.charCodeAt(i) != 0) cpp[2*i] = 0x5F;
			for(i = 0; i < cpp.length; ++i) this[this.l + i] = cpp[i];
			size = cpp.length;
		} else {
val = val.replace(/[^\x00-\x7F]/g, "_");
for(i = 0; i != val.length; ++i) this[this.l + i] = (val.charCodeAt(i) & 0xFF);
			size = val.length;
		}
	} else if(f === 'hex') {
		for(; i < t; ++i) {
this[this.l++] = (parseInt(val.slice(2*i, 2*i+2), 16)||0);
		} return this;
	} else if(f === 'utf16le') {
var end = Math.min(this.l + t, this.length);
			for(i = 0; i < Math.min(val.length, t); ++i) {
				var cc = val.charCodeAt(i);
				this[this.l++] = (cc & 0xff);
				this[this.l++] = (cc >> 8);
			}
			while(this.l < end) this[this.l++] = 0;
			return this;
	} else  switch(t) {
		case  1: size = 1; this[this.l] = val&0xFF; break;
		case  2: size = 2; this[this.l] = val&0xFF; val >>>= 8; this[this.l+1] = val&0xFF; break;
		case  3: size = 3; this[this.l] = val&0xFF; val >>>= 8; this[this.l+1] = val&0xFF; val >>>= 8; this[this.l+2] = val&0xFF; break;
		case  4: size = 4; __writeUInt32LE(this, val, this.l); break;
		case  8: size = 8; if(f === 'f') { write_double_le(this, val, this.l); break; }
		/* falls through */
		case 16: break;
		case -4: size = 4; __writeInt32LE(this, val, this.l); break;
	}
	this.l += size; return this;
}

function CheckField(hexstr, fld) {
	var m = __hexlify(this,this.l,hexstr.length>>1);
	if(m !== hexstr) throw new Error(fld + 'Expected ' + hexstr + ' saw ' + m);
	this.l += hexstr.length>>1;
}

function prep_blob(blob, pos) {
	blob.l = pos;
	blob.read_shift = ReadShift;
	blob.chk = CheckField;
	blob.write_shift = WriteShift;
}

function parsenoop(blob, length) { blob.l += length; }

function new_buf(sz) {
	var o = new_raw_buf(sz);
	prep_blob(o, 0);
	return o;
}

/* [MS-XLSB] 2.1.4 Record */
function recordhopper(data, cb, opts) {
	if(!data) return;
	var tmpbyte, cntbyte, length;
	prep_blob(data, data.l || 0);
	var L = data.length, RT = 0, tgt = 0;
	while(data.l < L) {
		RT = data.read_shift(1);
		if(RT & 0x80) RT = (RT & 0x7F) + ((data.read_shift(1) & 0x7F)<<7);
		var R = XLSBRecordEnum[RT] || XLSBRecordEnum[0xFFFF];
		tmpbyte = data.read_shift(1);
		length = tmpbyte & 0x7F;
		for(cntbyte = 1; cntbyte <4 && (tmpbyte & 0x80); ++cntbyte) length += ((tmpbyte = data.read_shift(1)) & 0x7F)<<(7*cntbyte);
		tgt = data.l + length;
		var d = R.f && R.f(data, length, opts);
		data.l = tgt;
		if(cb(d, R, RT)) return;
	}
}

/* control buffer usage for fixed-length buffers */
function buf_array() {
	var bufs = [], blksz = has_buf ? 256 : 2048;
	var newblk = function ba_newblk(sz) {
		var o = (new_buf(sz));
		prep_blob(o, 0);
		return o;
	};

	var curbuf = newblk(blksz);

	var endbuf = function ba_endbuf() {
		if(!curbuf) return;
		// workaround for new Buffer(3).slice(0,0) bug in bun 0.1.3
		if(curbuf.l) {
			if(curbuf.length > curbuf.l) { curbuf = curbuf.slice(0, curbuf.l); curbuf.l = curbuf.length; }
			if(curbuf.length > 0) bufs.push(curbuf);
		}
		curbuf = null;
	};

	var next = function ba_next(sz) {
		if(curbuf && (sz < (curbuf.length - curbuf.l))) return curbuf;
		endbuf();
		return (curbuf = newblk(Math.max(sz+1, blksz)));
	};

	var end = function ba_end() {
		endbuf();
		return bconcat(bufs);
	};

	var push = function ba_push(buf) { endbuf(); curbuf = buf; if(curbuf.l == null) curbuf.l = curbuf.length; next(blksz); };

	return ({ next:next, push:push, end:end, _bufs:bufs });
}

function write_record(ba, type, payload, length) {
	var t = +type, l;
	if(isNaN(t)) return; // TODO: throw something here?
	if(!length) length = XLSBRecordEnum[t].p || (payload||[]).length || 0;
	l = 1 + (t >= 0x80 ? 1 : 0) + 1/* + length*/;
	if(length >= 0x80) ++l; if(length >= 0x4000) ++l; if(length >= 0x200000) ++l;
	var o = ba.next(l);
	if(t <= 0x7F) o.write_shift(1, t);
	else {
		o.write_shift(1, (t & 0x7F) + 0x80);
		o.write_shift(1, (t >> 7));
	}
	for(var i = 0; i != 4; ++i) {
		if(length >= 0x80) { o.write_shift(1, (length & 0x7F)+0x80); length >>= 7; }
		else { o.write_shift(1, length); break; }
	}
	if(length > 0 && is_buf(payload)) ba.push(payload);
}
/* XLS ranges enforced */
function shift_cell_xls(cell, tgt, opts) {
	var out = dup(cell);
	if(tgt.s) {
		if(out.cRel) out.c += tgt.s.c;
		if(out.rRel) out.r += tgt.s.r;
	} else {
		if(out.cRel) out.c += tgt.c;
		if(out.rRel) out.r += tgt.r;
	}
	if(!opts || opts.biff < 12) {
		while(out.c >= 0x100) out.c -= 0x100;
		while(out.r >= 0x10000) out.r -= 0x10000;
	}
	return out;
}

function shift_range_xls(cell, range, opts) {
	var out = dup(cell);
	out.s = shift_cell_xls(out.s, range.s, opts);
	out.e = shift_cell_xls(out.e, range.s, opts);
	return out;
}

function encode_cell_xls(c, biff) {
	if(c.cRel && c.c < 0) { c = dup(c); while(c.c < 0) c.c += (biff > 8) ? 0x4000 : 0x100; }
	if(c.rRel && c.r < 0) { c = dup(c); while(c.r < 0) c.r += (biff > 8) ? 0x100000 : ((biff > 5) ? 0x10000 : 0x4000); }
	var s = encode_cell(c);
	if(!c.cRel && c.cRel != null) s = fix_col(s);
	if(!c.rRel && c.rRel != null) s = fix_row(s);
	return s;
}

function encode_range_xls(r, opts) {
	if(r.s.r == 0 && !r.s.rRel) {
		if(r.e.r == (opts.biff >= 12 ? 0xFFFFF : (opts.biff >= 8 ? 0x10000 : 0x4000)) && !r.e.rRel) {
			return (r.s.cRel ? "" : "$") + encode_col(r.s.c) + ":" + (r.e.cRel ? "" : "$") + encode_col(r.e.c);
		}
	}
	if(r.s.c == 0 && !r.s.cRel) {
		if(r.e.c == (opts.biff >= 12 ? 0x3FFF : 0xFF) && !r.e.cRel) {
			return (r.s.rRel ? "" : "$") + encode_row(r.s.r) + ":" + (r.e.rRel ? "" : "$") + encode_row(r.e.r);
		}
	}
	return encode_cell_xls(r.s, opts.biff) + ":" + encode_cell_xls(r.e, opts.biff);
}
if(typeof cptable !== 'undefined') set_cptable(cptable);
else if(typeof module !== "undefined" && typeof require !== 'undefined') {
	set_cptable(require('./dist/cpexcel.js'));
}
function decode_row(rowstr) { return parseInt(unfix_row(rowstr),10) - 1; }
function encode_row(row) { return "" + (row + 1); }
function fix_row(cstr) { return cstr.replace(/([A-Z]|^)(\d+)$/,"$1$$$2"); }
function unfix_row(cstr) { return cstr.replace(/\$(\d+)$/,"$1"); }

function decode_col(colstr) { var c = unfix_col(colstr), d = 0, i = 0; for(; i !== c.length; ++i) d = 26*d + c.charCodeAt(i) - 64; return d - 1; }
function encode_col(col) { if(col < 0) throw new Error("invalid column " + col); var s=""; for(++col; col; col=Math.floor((col-1)/26)) s = String.fromCharCode(((col-1)%26) + 65) + s; return s; }
function fix_col(cstr) { return cstr.replace(/^([A-Z])/,"$$$1"); }
function unfix_col(cstr) { return cstr.replace(/^\$([A-Z])/,"$1"); }

function split_cell(cstr) { return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/,"$1,$2").split(","); }
//function decode_cell(cstr) { var splt = split_cell(cstr); return { c:decode_col(splt[0]), r:decode_row(splt[1]) }; }
function decode_cell(cstr) {
	var R = 0, C = 0;
	for(var i = 0; i < cstr.length; ++i) {
		var cc = cstr.charCodeAt(i);
		if(cc >= 48 && cc <= 57) R = 10 * R + (cc - 48);
		else if(cc >= 65 && cc <= 90) C = 26 * C + (cc - 64);
	}
	return { c: C - 1, r:R - 1 };
}
//function encode_cell(cell) { return encode_col(cell.c) + encode_row(cell.r); }
function encode_cell(cell) {
	var col = cell.c + 1;
	var s="";
	for(; col; col=((col-1)/26)|0) s = String.fromCharCode(((col-1)%26) + 65) + s;
	return s + (cell.r + 1);
}
function decode_range(range) {
	var idx = range.indexOf(":");
	if(idx == -1) return { s: decode_cell(range), e: decode_cell(range) };
	return { s: decode_cell(range.slice(0, idx)), e: decode_cell(range.slice(idx + 1)) };
}
function encode_range(cs,ce) {
	if(typeof ce === 'undefined' || typeof ce === 'number') {
return encode_range(cs.s, cs.e);
	}
if(typeof cs !== 'string') cs = encode_cell((cs));
	if(typeof ce !== 'string') ce = encode_cell((ce));
return cs == ce ? cs : cs + ":" + ce;
}
function fix_range(a1) {
	var s = decode_range(a1);
	return "$" + encode_col(s.s.c) + "$" + encode_row(s.s.r) + ":$" + encode_col(s.e.c) + "$" + encode_row(s.e.r);
}

// List of invalid characters needs to be tested further
function formula_quote_sheet_name(sname, opts) {
	if(!sname && !(opts && opts.biff <= 5 && opts.biff >= 2)) throw new Error("empty sheet name");
	if (/[^\w\u4E00-\u9FFF\u3040-\u30FF]/.test(sname)) return "'" + sname.replace(/'/g, "''") + "'";
	return sname;
}

function safe_decode_range(range) {
	var o = {s:{c:0,r:0},e:{c:0,r:0}};
	var idx = 0, i = 0, cc = 0;
	var len = range.length;
	for(idx = 0; i < len; ++i) {
		if((cc=range.charCodeAt(i)-64) < 1 || cc > 26) break;
		idx = 26*idx + cc;
	}
	o.s.c = --idx;

	for(idx = 0; i < len; ++i) {
		if((cc=range.charCodeAt(i)-48) < 0 || cc > 9) break;
		idx = 10*idx + cc;
	}
	o.s.r = --idx;

	if(i === len || cc != 10) { o.e.c=o.s.c; o.e.r=o.s.r; return o; }
	++i;

	for(idx = 0; i != len; ++i) {
		if((cc=range.charCodeAt(i)-64) < 1 || cc > 26) break;
		idx = 26*idx + cc;
	}
	o.e.c = --idx;

	for(idx = 0; i != len; ++i) {
		if((cc=range.charCodeAt(i)-48) < 0 || cc > 9) break;
		idx = 10*idx + cc;
	}
	o.e.r = --idx;
	return o;
}

function safe_format_cell(cell, v) {
	var q = (cell.t == 'd' && v instanceof Date);
	if(cell.z != null) try { return (cell.w = SSF_format(cell.z, q ? datenum(v) : v)); } catch(e) { }
	try { return (cell.w = SSF_format((cell.XF||{}).numFmtId||(q ? 14 : 0),  q ? datenum(v) : v)); } catch(e) { return ''+v; }
}

function format_cell(cell, v, o) {
	if(cell == null || cell.t == null || cell.t == 'z') return "";
	if(cell.w !== undefined) return cell.w;
	if(cell.t == 'd' && !cell.z && o && o.dateNF) cell.z = o.dateNF;
	if(cell.t == "e") return BErr[cell.v] || cell.v;
	if(v == undefined) return safe_format_cell(cell, cell.v);
	return safe_format_cell(cell, v);
}

function sheet_to_workbook(sheet, opts) {
	var n = opts && opts.sheet ? opts.sheet : "Sheet1";
	var sheets = {}; sheets[n] = sheet;
	return { SheetNames: [n], Sheets: sheets };
}

function sheet_add_aoa(_ws, data, opts) {
	var o = opts || {};
	var dense = _ws ? Array.isArray(_ws) : o.dense;
	if(DENSE != null && dense == null) dense = DENSE;
	var ws = _ws || (dense ? ([]) : ({}));
	var _R = 0, _C = 0;
	if(ws && o.origin != null) {
		if(typeof o.origin == 'number') _R = o.origin;
		else {
			var _origin = typeof o.origin == "string" ? decode_cell(o.origin) : o.origin;
			_R = _origin.r; _C = _origin.c;
		}
		if(!ws["!ref"]) ws["!ref"] = "A1:A1";
	}
	var range = ({s: {c:10000000, r:10000000}, e: {c:0, r:0}});
	if(ws['!ref']) {
		var _range = safe_decode_range(ws['!ref']);
		range.s.c = _range.s.c;
		range.s.r = _range.s.r;
		range.e.c = Math.max(range.e.c, _range.e.c);
		range.e.r = Math.max(range.e.r, _range.e.r);
		if(_R == -1) range.e.r = _R = _range.e.r + 1;
	}
	for(var R = 0; R != data.length; ++R) {
		if(!data[R]) continue;
		if(!Array.isArray(data[R])) throw new Error("aoa_to_sheet expects an array of arrays");
		for(var C = 0; C != data[R].length; ++C) {
			if(typeof data[R][C] === 'undefined') continue;
			var cell = ({v: data[R][C] });
			var __R = _R + R, __C = _C + C;
			if(range.s.r > __R) range.s.r = __R;
			if(range.s.c > __C) range.s.c = __C;
			if(range.e.r < __R) range.e.r = __R;
			if(range.e.c < __C) range.e.c = __C;
			if(data[R][C] && typeof data[R][C] === 'object' && !Array.isArray(data[R][C]) && !(data[R][C] instanceof Date)) cell = data[R][C];
			else {
				if(Array.isArray(cell.v)) { cell.f = data[R][C][1]; cell.v = cell.v[0]; }
				if(cell.v === null) {
					if(cell.f) cell.t = 'n';
					else if(o.nullError) { cell.t = 'e'; cell.v = 0; }
					else if(!o.sheetStubs) continue;
					else cell.t = 'z';
				}
				else if(typeof cell.v === 'number') cell.t = 'n';
				else if(typeof cell.v === 'boolean') cell.t = 'b';
				else if(cell.v instanceof Date) {
					cell.z = o.dateNF || table_fmt[14];
					if(o.cellDates) { cell.t = 'd'; cell.w = SSF_format(cell.z, datenum(cell.v, o.date1904)); }
					else { cell.t = 'n'; cell.v = datenum(cell.v, o.date1904); cell.w = SSF_format(cell.z, cell.v); }
				}
				else cell.t = 's';
			}
			if(dense) {
				if(!ws[__R]) ws[__R] = [];
				if(ws[__R][__C] && ws[__R][__C].z) cell.z = ws[__R][__C].z;
				ws[__R][__C] = cell;
			} else {
				var cell_ref = encode_cell(({c:__C,r:__R}));
				if(ws[cell_ref] && ws[cell_ref].z) cell.z = ws[cell_ref].z;
				ws[cell_ref] = cell;
			}
		}
	}
	if(range.s.c < 10000000) ws['!ref'] = encode_range(range);
	return ws;
}
function aoa_to_sheet(data, opts) { return sheet_add_aoa(null, data, opts); }

function parse_Int32LE(data) {
	return data.read_shift(4, 'i');
}
function write_UInt32LE(x, o) {
	if (!o) o = new_buf(4);
	o.write_shift(4, x);
	return o;
}

/* [MS-XLSB] 2.5.168 */
function parse_XLWideString(data) {
	var cchCharacters = data.read_shift(4);
	return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, 'dbcs');
}
function write_XLWideString(data, o) {
	var _null = false; if (o == null) { _null = true; o = new_buf(4 + 2 * data.length); }
	o.write_shift(4, data.length);
	if (data.length > 0) o.write_shift(0, data, 'dbcs');
	return _null ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.5.91 */
//function parse_LPWideString(data) {
//	var cchCharacters = data.read_shift(2);
//	return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, "utf16le");
//}

/* [MS-XLSB] 2.5.143 */
function parse_StrRun(data) {
	return { ich: data.read_shift(2), ifnt: data.read_shift(2) };
}
function write_StrRun(run, o) {
	if (!o) o = new_buf(4);
	o.write_shift(2, run.ich || 0);
	o.write_shift(2, run.ifnt || 0);
	return o;
}

/* [MS-XLSB] 2.5.121 */
function parse_RichStr(data, length) {
	var start = data.l;
	var flags = data.read_shift(1);
	var str = parse_XLWideString(data);
	var rgsStrRun = [];
	var z = ({ t: str, h: str });
	if ((flags & 1) !== 0) { /* fRichStr */
		/* TODO: formatted string */
		var dwSizeStrRun = data.read_shift(4);
		for (var i = 0; i != dwSizeStrRun; ++i) rgsStrRun.push(parse_StrRun(data));
		z.r = rgsStrRun;
	}
	else z.r = [{ ich: 0, ifnt: 0 }];
	//if((flags & 2) !== 0) { /* fExtStr */
	//	/* TODO: phonetic string */
	//}
	data.l = start + length;
	return z;
}
function write_RichStr(str, o) {
	/* TODO: formatted string */
	var _null = false; if (o == null) { _null = true; o = new_buf(15 + 4 * str.t.length); }
	o.write_shift(1, 0);
	write_XLWideString(str.t, o);
	return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.328 BrtCommentText (RichStr w/1 run) */
var parse_BrtCommentText = parse_RichStr;
function write_BrtCommentText(str, o) {
	/* TODO: formatted string */
	var _null = false; if (o == null) { _null = true; o = new_buf(23 + 4 * str.t.length); }
	o.write_shift(1, 1);
	write_XLWideString(str.t, o);
	o.write_shift(4, 1);
	write_StrRun({ ich: 0, ifnt: 0 }, o);
	return _null ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.5.9 */
function parse_XLSBCell(data) {
	var col = data.read_shift(4);
	var iStyleRef = data.read_shift(2);
	iStyleRef += data.read_shift(1) << 16;
	data.l++; //var fPhShow = data.read_shift(1);
	return { c: col, iStyleRef: iStyleRef };
}
function write_XLSBCell(cell, o) {
	if (o == null) o = new_buf(8);
	o.write_shift(-4, cell.c);
	o.write_shift(3, cell.iStyleRef || cell.s);
	o.write_shift(1, 0); /* fPhShow */
	return o;
}

/* Short XLSB Cell does not include column */
function parse_XLSBShortCell(data) {
	var iStyleRef = data.read_shift(2);
	iStyleRef += data.read_shift(1) <<16;
	data.l++; //var fPhShow = data.read_shift(1);
	return { c:-1, iStyleRef: iStyleRef };
}
function write_XLSBShortCell(cell, o) {
	if(o == null) o = new_buf(4);
	o.write_shift(3, cell.iStyleRef || cell.s);
	o.write_shift(1, 0); /* fPhShow */
	return o;
}

/* [MS-XLSB] 2.5.21 */
var parse_XLSBCodeName = parse_XLWideString;
var write_XLSBCodeName = write_XLWideString;

/* [MS-XLSB] 2.5.166 */
function parse_XLNullableWideString(data) {
	var cchCharacters = data.read_shift(4);
	return cchCharacters === 0 || cchCharacters === 0xFFFFFFFF ? "" : data.read_shift(cchCharacters, 'dbcs');
}
function write_XLNullableWideString(data, o) {
	var _null = false; if (o == null) { _null = true; o = new_buf(127); }
	o.write_shift(4, data.length > 0 ? data.length : 0xFFFFFFFF);
	if (data.length > 0) o.write_shift(0, data, 'dbcs');
	return _null ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.5.165 */
var parse_XLNameWideString = parse_XLWideString;
//var write_XLNameWideString = write_XLWideString;

/* [MS-XLSB] 2.5.114 */
var parse_RelID = parse_XLNullableWideString;
var write_RelID = write_XLNullableWideString;


/* [MS-XLS] 2.5.217 ; [MS-XLSB] 2.5.122 */
function parse_RkNumber(data) {
	var b = data.slice(data.l, data.l + 4);
	var fX100 = (b[0] & 1), fInt = (b[0] & 2);
	data.l += 4;
	var RK = fInt === 0 ? __double([0, 0, 0, 0, (b[0] & 0xFC), b[1], b[2], b[3]], 0) : __readInt32LE(b, 0) >> 2;
	return fX100 ? (RK / 100) : RK;
}
function write_RkNumber(data, o) {
	if (o == null) o = new_buf(4);
	var fX100 = 0, fInt = 0, d100 = data * 100;
	if ((data == (data | 0)) && (data >= -(1 << 29)) && (data < (1 << 29))) { fInt = 1; }
	else if ((d100 == (d100 | 0)) && (d100 >= -(1 << 29)) && (d100 < (1 << 29))) { fInt = 1; fX100 = 1; }
	if (fInt) o.write_shift(-4, ((fX100 ? d100 : data) << 2) + (fX100 + 2));
	else throw new Error("unsupported RkNumber " + data); // TODO
}


/* [MS-XLSB] 2.5.117 RfX */
function parse_RfX(data ) {
	var cell = ({ s: {}, e: {} });
	cell.s.r = data.read_shift(4);
	cell.e.r = data.read_shift(4);
	cell.s.c = data.read_shift(4);
	cell.e.c = data.read_shift(4);
	return cell;
}
function write_RfX(r, o) {
	if (!o) o = new_buf(16);
	o.write_shift(4, r.s.r);
	o.write_shift(4, r.e.r);
	o.write_shift(4, r.s.c);
	o.write_shift(4, r.e.c);
	return o;
}

/* [MS-XLSB] 2.5.153 UncheckedRfX */
var parse_UncheckedRfX = parse_RfX;
var write_UncheckedRfX = write_RfX;

/* [MS-XLSB] 2.5.155 UncheckedSqRfX */
//function parse_UncheckedSqRfX(data) {
//	var cnt = data.read_shift(4);
//	var out = [];
//	for(var i = 0; i < cnt; ++i) {
//		var rng = parse_UncheckedRfX(data);
//		out.push(encode_range(rng));
//	}
//	return out.join(",");
//}
//function write_UncheckedSqRfX(sqrfx) {
//	var parts = sqrfx.split(/\s*,\s*/);
//	var o = new_buf(4); o.write_shift(4, parts.length);
//	var out = [o];
//	parts.forEach(function(rng) {
//		out.push(write_UncheckedRfX(safe_decode_range(rng)));
//	});
//	return bconcat(out);
//}

/* [MS-XLS] 2.5.342 ; [MS-XLSB] 2.5.171 */
/* TODO: error checking, NaN and Infinity values are not valid Xnum */
function parse_Xnum(data) {
	if(data.length - data.l < 8) throw "XLS Xnum Buffer underflow";
	return data.read_shift(8, 'f');
}
function write_Xnum(data, o) { return (o || new_buf(8)).write_shift(8, data, 'f'); }

/* [MS-XLSB] 2.4.324 BrtColor */
function parse_BrtColor(data) {
	var out = {};
	var d = data.read_shift(1);

	//var fValidRGB = d & 1;
	var xColorType = d >>> 1;

	var index = data.read_shift(1);
	var nTS = data.read_shift(2, 'i');
	var bR = data.read_shift(1);
	var bG = data.read_shift(1);
	var bB = data.read_shift(1);
	data.l++; //var bAlpha = data.read_shift(1);

	switch (xColorType) {
		case 0: out.auto = 1; break;
		case 1:
			out.index = index;
			var icv = XLSIcv[index];
			/* automatic pseudo index 81 */
			if (icv) out.rgb = rgb2Hex(icv);
			break;
		case 2:
			/* if(!fValidRGB) throw new Error("invalid"); */
			out.rgb = rgb2Hex([bR, bG, bB]);
			break;
		case 3: out.theme = index; break;
	}
	if (nTS != 0) out.tint = nTS > 0 ? nTS / 32767 : nTS / 32768;

	return out;
}
function write_BrtColor(color, o) {
	if (!o) o = new_buf(8);
	if (!color || color.auto) { o.write_shift(4, 0); o.write_shift(4, 0); return o; }
	if (color.index != null) {
		o.write_shift(1, 0x02);
		o.write_shift(1, color.index);
	} else if (color.theme != null) {
		o.write_shift(1, 0x06);
		o.write_shift(1, color.theme);
	} else {
		o.write_shift(1, 0x05);
		o.write_shift(1, 0);
	}
	var nTS = color.tint || 0;
	if (nTS > 0) nTS *= 32767;
	else if (nTS < 0) nTS *= 32768;
	o.write_shift(2, nTS);
	if (!color.rgb || color.theme != null) {
		o.write_shift(2, 0);
		o.write_shift(1, 0);
		o.write_shift(1, 0);
	} else {
		var rgb = (color.rgb || 'FFFFFF');
		if (typeof rgb == 'number') rgb = ("000000" + rgb.toString(16)).slice(-6);
		o.write_shift(1, parseInt(rgb.slice(0, 2), 16));
		o.write_shift(1, parseInt(rgb.slice(2, 4), 16));
		o.write_shift(1, parseInt(rgb.slice(4, 6), 16));
		o.write_shift(1, 0xFF);
	}
	return o;
}

/* [MS-XLSB] 2.5.52 */
function parse_FontFlags(data) {
	var d = data.read_shift(1);
	data.l++;
	var out = {
		fBold: d & 0x01,
		fItalic: d & 0x02,
		fUnderline: d & 0x04,
		fStrikeout: d & 0x08,
		fOutline: d & 0x10,
		fShadow: d & 0x20,
		fCondense: d & 0x40,
		fExtend: d & 0x80
	};
	return out;
}
function write_FontFlags(font, o) {
	if (!o) o = new_buf(2);
	var grbit =
		(font.italic ? 0x02 : 0) |
		(font.strike ? 0x08 : 0) |
		(font.outline ? 0x10 : 0) |
		(font.shadow ? 0x20 : 0) |
		(font.condense ? 0x40 : 0) |
		(font.extend ? 0x80 : 0);
	o.write_shift(1, grbit);
	o.write_shift(1, 0);
	return o;
}

/* [MS-OLEDS] 2.3.1 and 2.3.2 */
function parse_ClipboardFormatOrString(o, w) {
	// $FlowIgnore
	var ClipFmt = { 2: "BITMAP", 3: "METAFILEPICT", 8: "DIB", 14: "ENHMETAFILE" };
	var m = o.read_shift(4);
	switch (m) {
		case 0x00000000: return "";
		case 0xffffffff: case 0xfffffffe: return ClipFmt[o.read_shift(4)] || "";
	}
	if (m > 0x190) throw new Error("Unsupported Clipboard: " + m.toString(16));
	o.l -= 4;
	return o.read_shift(0, w == 1 ? "lpstr" : "lpwstr");
}
function parse_ClipboardFormatOrAnsiString(o) { return parse_ClipboardFormatOrString(o, 1); }
function parse_ClipboardFormatOrUnicodeString(o) { return parse_ClipboardFormatOrString(o, 2); }

/* [MS-OLEPS] 2.2 PropertyType */
// Note: some tree shakers cannot handle VT_VECTOR | $CONST, hence extra vars
//var VT_EMPTY    = 0x0000;
//var VT_NULL     = 0x0001;
var VT_I2       = 0x0002;
var VT_I4       = 0x0003;
//var VT_R4       = 0x0004;
//var VT_R8       = 0x0005;
//var VT_CY       = 0x0006;
//var VT_DATE     = 0x0007;
//var VT_BSTR     = 0x0008;
//var VT_ERROR    = 0x000A;
var VT_BOOL     = 0x000B;
var VT_VARIANT  = 0x000C;
//var VT_DECIMAL  = 0x000E;
//var VT_I1       = 0x0010;
//var VT_UI1      = 0x0011;
//var VT_UI2      = 0x0012;
var VT_UI4      = 0x0013;
//var VT_I8       = 0x0014;
//var VT_UI8      = 0x0015;
//var VT_INT      = 0x0016;
//var VT_UINT     = 0x0017;
//var VT_LPSTR    = 0x001E;
//var VT_LPWSTR   = 0x001F;
var VT_FILETIME = 0x0040;
var VT_BLOB     = 0x0041;
//var VT_STREAM   = 0x0042;
//var VT_STORAGE  = 0x0043;
//var VT_STREAMED_Object  = 0x0044;
//var VT_STORED_Object    = 0x0045;
//var VT_BLOB_Object      = 0x0046;
var VT_CF       = 0x0047;
//var VT_CLSID    = 0x0048;
//var VT_VERSIONED_STREAM = 0x0049;
//var VT_VECTOR   = 0x1000;
var VT_VECTOR_VARIANT = 0x100C;
var VT_VECTOR_LPSTR   = 0x101E;
//var VT_ARRAY    = 0x2000;

var VT_STRING   = 0x0050; // 2.3.3.1.11 VtString
var VT_USTR     = 0x0051; // 2.3.3.1.12 VtUnalignedString
var VT_CUSTOM   = [VT_STRING, VT_USTR];

/* [MS-OSHARED] 2.3.3.2.2.1 Document Summary Information PIDDSI */
var DocSummaryPIDDSI = {
0x01: { n: 'CodePage', t: VT_I2 },
0x02: { n: 'Category', t: VT_STRING },
0x03: { n: 'PresentationFormat', t: VT_STRING },
0x04: { n: 'ByteCount', t: VT_I4 },
0x05: { n: 'LineCount', t: VT_I4 },
0x06: { n: 'ParagraphCount', t: VT_I4 },
0x07: { n: 'SlideCount', t: VT_I4 },
0x08: { n: 'NoteCount', t: VT_I4 },
0x09: { n: 'HiddenCount', t: VT_I4 },
0x0a: { n: 'MultimediaClipCount', t: VT_I4 },
0x0b: { n: 'ScaleCrop', t: VT_BOOL },
0x0c: { n: 'HeadingPairs', t: VT_VECTOR_VARIANT /* VT_VECTOR | VT_VARIANT */ },
0x0d: { n: 'TitlesOfParts', t: VT_VECTOR_LPSTR /* VT_VECTOR | VT_LPSTR */ },
0x0e: { n: 'Manager', t: VT_STRING },
0x0f: { n: 'Company', t: VT_STRING },
0x10: { n: 'LinksUpToDate', t: VT_BOOL },
0x11: { n: 'CharacterCount', t: VT_I4 },
0x13: { n: 'SharedDoc', t: VT_BOOL },
0x16: { n: 'HyperlinksChanged', t: VT_BOOL },
0x17: { n: 'AppVersion', t: VT_I4, p: 'version' },
0x18: { n: 'DigSig', t: VT_BLOB },
0x1A: { n: 'ContentType', t: VT_STRING },
0x1B: { n: 'ContentStatus', t: VT_STRING },
0x1C: { n: 'Language', t: VT_STRING },
0x1D: { n: 'Version', t: VT_STRING },
0xFF: {},
	/* [MS-OLEPS] 2.18 */
0x80000000: { n: 'Locale', t: VT_UI4 },
0x80000003: { n: 'Behavior', t: VT_UI4 },
0x72627262: {}
};

/* [MS-OSHARED] 2.3.3.2.1.1 Summary Information Property Set PIDSI */
var SummaryPIDSI = {
0x01: { n: 'CodePage', t: VT_I2 },
0x02: { n: 'Title', t: VT_STRING },
0x03: { n: 'Subject', t: VT_STRING },
0x04: { n: 'Author', t: VT_STRING },
0x05: { n: 'Keywords', t: VT_STRING },
0x06: { n: 'Comments', t: VT_STRING },
0x07: { n: 'Template', t: VT_STRING },
0x08: { n: 'LastAuthor', t: VT_STRING },
0x09: { n: 'RevNumber', t: VT_STRING },
0x0A: { n: 'EditTime', t: VT_FILETIME },
0x0B: { n: 'LastPrinted', t: VT_FILETIME },
0x0C: { n: 'CreatedDate', t: VT_FILETIME },
0x0D: { n: 'ModifiedDate', t: VT_FILETIME },
0x0E: { n: 'PageCount', t: VT_I4 },
0x0F: { n: 'WordCount', t: VT_I4 },
0x10: { n: 'CharCount', t: VT_I4 },
0x11: { n: 'Thumbnail', t: VT_CF },
0x12: { n: 'Application', t: VT_STRING },
0x13: { n: 'DocSecurity', t: VT_I4 },
0xFF: {},
	/* [MS-OLEPS] 2.18 */
0x80000000: { n: 'Locale', t: VT_UI4 },
0x80000003: { n: 'Behavior', t: VT_UI4 },
0x72627262: {}
};

/* [MS-XLS] 2.4.63 Country/Region codes */
var CountryEnum = {
0x0001: "US", // United States
0x0002: "CA", // Canada
0x0003: "", // Latin America (except Brazil)
0x0007: "RU", // Russia
0x0014: "EG", // Egypt
0x001E: "GR", // Greece
0x001F: "NL", // Netherlands
0x0020: "BE", // Belgium
0x0021: "FR", // France
0x0022: "ES", // Spain
0x0024: "HU", // Hungary
0x0027: "IT", // Italy
0x0029: "CH", // Switzerland
0x002B: "AT", // Austria
0x002C: "GB", // United Kingdom
0x002D: "DK", // Denmark
0x002E: "SE", // Sweden
0x002F: "NO", // Norway
0x0030: "PL", // Poland
0x0031: "DE", // Germany
0x0034: "MX", // Mexico
0x0037: "BR", // Brazil
0x003d: "AU", // Australia
0x0040: "NZ", // New Zealand
0x0042: "TH", // Thailand
0x0051: "JP", // Japan
0x0052: "KR", // Korea
0x0054: "VN", // Viet Nam
0x0056: "CN", // China
0x005A: "TR", // Turkey
0x0069: "JS", // Ramastan
0x00D5: "DZ", // Algeria
0x00D8: "MA", // Morocco
0x00DA: "LY", // Libya
0x015F: "PT", // Portugal
0x0162: "IS", // Iceland
0x0166: "FI", // Finland
0x01A4: "CZ", // Czech Republic
0x0376: "TW", // Taiwan
0x03C1: "LB", // Lebanon
0x03C2: "JO", // Jordan
0x03C3: "SY", // Syria
0x03C4: "IQ", // Iraq
0x03C5: "KW", // Kuwait
0x03C6: "SA", // Saudi Arabia
0x03CB: "AE", // United Arab Emirates
0x03CC: "IL", // Israel
0x03CE: "QA", // Qatar
0x03D5: "IR", // Iran
0xFFFF: "US"  // United States
};

/* [MS-XLS] 2.5.127 */
var XLSFillPattern = [
	null,
	'solid',
	'mediumGray',
	'darkGray',
	'lightGray',
	'darkHorizontal',
	'darkVertical',
	'darkDown',
	'darkUp',
	'darkGrid',
	'darkTrellis',
	'lightHorizontal',
	'lightVertical',
	'lightDown',
	'lightUp',
	'lightGrid',
	'lightTrellis',
	'gray125',
	'gray0625'
];

function rgbify(arr) { return arr.map(function(x) { return [(x>>16)&255,(x>>8)&255,x&255]; }); }

/* [MS-XLS] 2.5.161 */
/* [MS-XLSB] 2.5.75 Icv */
var _XLSIcv =  rgbify([
	/* Color Constants */
	0x000000,
	0xFFFFFF,
	0xFF0000,
	0x00FF00,
	0x0000FF,
	0xFFFF00,
	0xFF00FF,
	0x00FFFF,

	/* Overridable Defaults */
	0x000000,
	0xFFFFFF,
	0xFF0000,
	0x00FF00,
	0x0000FF,
	0xFFFF00,
	0xFF00FF,
	0x00FFFF,

	0x800000,
	0x008000,
	0x000080,
	0x808000,
	0x800080,
	0x008080,
	0xC0C0C0,
	0x808080,
	0x9999FF,
	0x993366,
	0xFFFFCC,
	0xCCFFFF,
	0x660066,
	0xFF8080,
	0x0066CC,
	0xCCCCFF,

	0x000080,
	0xFF00FF,
	0xFFFF00,
	0x00FFFF,
	0x800080,
	0x800000,
	0x008080,
	0x0000FF,
	0x00CCFF,
	0xCCFFFF,
	0xCCFFCC,
	0xFFFF99,
	0x99CCFF,
	0xFF99CC,
	0xCC99FF,
	0xFFCC99,

	0x3366FF,
	0x33CCCC,
	0x99CC00,
	0xFFCC00,
	0xFF9900,
	0xFF6600,
	0x666699,
	0x969696,
	0x003366,
	0x339966,
	0x003300,
	0x333300,
	0x993300,
	0x993366,
	0x333399,
	0x333333,

	/* Other entries to appease BIFF8/12 */
	0x000000, /* 0x40 icvForeground ?? */
	0xFFFFFF, /* 0x41 icvBackground ?? */
	0x000000, /* 0x42 icvFrame ?? */
	0x000000, /* 0x43 icv3D ?? */
	0x000000, /* 0x44 icv3DText ?? */
	0x000000, /* 0x45 icv3DHilite ?? */
	0x000000, /* 0x46 icv3DShadow ?? */
	0x000000, /* 0x47 icvHilite ?? */
	0x000000, /* 0x48 icvCtlText ?? */
	0x000000, /* 0x49 icvCtlScrl ?? */
	0x000000, /* 0x4A icvCtlInv ?? */
	0x000000, /* 0x4B icvCtlBody ?? */
	0x000000, /* 0x4C icvCtlFrame ?? */
	0x000000, /* 0x4D icvCtlFore ?? */
	0x000000, /* 0x4E icvCtlBack ?? */
	0x000000, /* 0x4F icvCtlNeutral */
	0x000000, /* 0x50 icvInfoBk ?? */
	0x000000 /* 0x51 icvInfoText ?? */
]);
var XLSIcv = dup(_XLSIcv);

/* [MS-XLSB] 2.5.97.2 */
var BErr = {
0x00: "#NULL!",
0x07: "#DIV/0!",
0x0F: "#VALUE!",
0x17: "#REF!",
0x1D: "#NAME?",
0x24: "#NUM!",
0x2A: "#N/A",
0x2B: "#GETTING_DATA",
0xFF: "#WTF?"
};
//var RBErr = evert_num(BErr);
var RBErr = {
	"#NULL!":        0x00,
	"#DIV/0!":       0x07,
	"#VALUE!":       0x0F,
	"#REF!":         0x17,
	"#NAME?":        0x1D,
	"#NUM!":         0x24,
	"#N/A":          0x2A,
	"#GETTING_DATA": 0x2B,
	"#WTF?":         0xFF
};

var XLSLblBuiltIn = [
	"_xlnm.Consolidate_Area",
	"_xlnm.Auto_Open",
	"_xlnm.Auto_Close",
	"_xlnm.Extract",
	"_xlnm.Database",
	"_xlnm.Criteria",
	"_xlnm.Print_Area",
	"_xlnm.Print_Titles",
	"_xlnm.Recorder",
	"_xlnm.Data_Form",
	"_xlnm.Auto_Activate",
	"_xlnm.Auto_Deactivate",
	"_xlnm.Sheet_Title",
	"_xlnm._FilterDatabase"
];

/* Parts enumerated in OPC spec, MS-XLSB and MS-XLSX */
/* 12.3 Part Summary <SpreadsheetML> */
/* 14.2 Part Summary <DrawingML> */
/* [MS-XLSX] 2.1 Part Enumerations ; [MS-XLSB] 2.1.7 Part Enumeration */
var ct2type/*{[string]:string}*/ = ({
	/* Workbook */
	"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
	"application/vnd.ms-excel.sheet.macroEnabled.main+xml": "workbooks",
	"application/vnd.ms-excel.sheet.binary.macroEnabled.main": "workbooks",
	"application/vnd.ms-excel.addin.macroEnabled.main+xml": "workbooks",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": "workbooks",

	/* Worksheet */
	"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": "sheets",
	"application/vnd.ms-excel.worksheet": "sheets",
	"application/vnd.ms-excel.binIndexWs": "TODO", /* Binary Index */

	/* Chartsheet */
	"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": "charts",
	"application/vnd.ms-excel.chartsheet": "charts",

	/* Macrosheet */
	"application/vnd.ms-excel.macrosheet+xml": "macros",
	"application/vnd.ms-excel.macrosheet": "macros",
	"application/vnd.ms-excel.intlmacrosheet": "TODO",
	"application/vnd.ms-excel.binIndexMs": "TODO", /* Binary Index */

	/* Dialogsheet */
	"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": "dialogs",
	"application/vnd.ms-excel.dialogsheet": "dialogs",

	/* Shared Strings */
	"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml": "strs",
	"application/vnd.ms-excel.sharedStrings": "strs",

	/* Styles */
	"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": "styles",
	"application/vnd.ms-excel.styles": "styles",

	/* File Properties */
	"application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
	"application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
	"application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",

	/* Custom Data Properties */
	"application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",

	/* Comments */
	"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": "comments",
	"application/vnd.ms-excel.comments": "comments",
	"application/vnd.ms-excel.threadedcomments+xml": "threadedcomments",
	"application/vnd.ms-excel.person+xml": "people",

	/* Metadata (Stock/Geography and Dynamic Array) */
	"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "metadata",
	"application/vnd.ms-excel.sheetMetadata": "metadata",

	/* PivotTable */
	"application/vnd.ms-excel.pivotTable": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",

	/* Chart Objects */
	"application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",

	/* Chart Colors */
	"application/vnd.ms-office.chartcolorstyle+xml": "TODO",

	/* Chart Style */
	"application/vnd.ms-office.chartstyle+xml": "TODO",

	/* Chart Advanced */
	"application/vnd.ms-office.chartex+xml": "TODO",

	/* Calculation Chain */
	"application/vnd.ms-excel.calcChain": "calcchains",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",

	/* Printer Settings */
	"application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",

	/* ActiveX */
	"application/vnd.ms-office.activeX": "TODO",
	"application/vnd.ms-office.activeX+xml": "TODO",

	/* Custom Toolbars */
	"application/vnd.ms-excel.attachedToolbars": "TODO",

	/* External Data Connections */
	"application/vnd.ms-excel.connections": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",

	/* External Links */
	"application/vnd.ms-excel.externalLink": "links",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",

	/* PivotCache */
	"application/vnd.ms-excel.pivotCacheDefinition": "TODO",
	"application/vnd.ms-excel.pivotCacheRecords": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",

	/* Query Table */
	"application/vnd.ms-excel.queryTable": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",

	/* Shared Workbook */
	"application/vnd.ms-excel.userNames": "TODO",
	"application/vnd.ms-excel.revisionHeaders": "TODO",
	"application/vnd.ms-excel.revisionLog": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",

	/* Single Cell Table */
	"application/vnd.ms-excel.tableSingleCells": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",

	/* Slicer */
	"application/vnd.ms-excel.slicer": "TODO",
	"application/vnd.ms-excel.slicerCache": "TODO",
	"application/vnd.ms-excel.slicer+xml": "TODO",
	"application/vnd.ms-excel.slicerCache+xml": "TODO",

	/* Sort Map */
	"application/vnd.ms-excel.wsSortMap": "TODO",

	/* Table */
	"application/vnd.ms-excel.table": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",

	/* Themes */
	"application/vnd.openxmlformats-officedocument.theme+xml": "themes",

	/* Theme Override */
	"application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",

	/* Timeline */
	"application/vnd.ms-excel.Timeline+xml": "TODO", /* verify */
	"application/vnd.ms-excel.TimelineCache+xml": "TODO", /* verify */

	/* VBA */
	"application/vnd.ms-office.vbaProject": "vba",
	"application/vnd.ms-office.vbaProjectSignature": "TODO",

	/* Volatile Dependencies */
	"application/vnd.ms-office.volatileDependencies": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",

	/* Control Properties */
	"application/vnd.ms-excel.controlproperties+xml": "TODO",

	/* Data Model */
	"application/vnd.openxmlformats-officedocument.model+data": "TODO",

	/* Survey */
	"application/vnd.ms-excel.Survey+xml": "TODO",

	/* Drawing */
	"application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
	"application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",

	/* VML */
	"application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",

	"application/vnd.openxmlformats-package.relationships+xml": "rels",
	"application/vnd.openxmlformats-officedocument.oleObject": "TODO",

	/* Image */
	"image/png": "TODO",

	"sheet": "js"
});

var CT_LIST = {
	workbooks: {
		xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
		xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
		xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
		xlam: "application/vnd.ms-excel.addin.macroEnabled.main+xml",
		xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"
	},
	strs: { /* Shared Strings */
		xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
		xlsb: "application/vnd.ms-excel.sharedStrings"
	},
	comments: { /* Comments */
		xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",
		xlsb: "application/vnd.ms-excel.comments"
	},
	sheets: { /* Worksheet */
		xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
		xlsb: "application/vnd.ms-excel.worksheet"
	},
	charts: { /* Chartsheet */
		xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",
		xlsb: "application/vnd.ms-excel.chartsheet"
	},
	dialogs: { /* Dialogsheet */
		xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",
		xlsb: "application/vnd.ms-excel.dialogsheet"
	},
	macros: { /* Macrosheet (Excel 4.0 Macros) */
		xlsx: "application/vnd.ms-excel.macrosheet+xml",
		xlsb: "application/vnd.ms-excel.macrosheet"
	},
	metadata: { /* Metadata (Stock/Geography and Dynamic Array) */
		xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml",
		xlsb: "application/vnd.ms-excel.sheetMetadata"
	},
	styles: { /* Styles */
		xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
		xlsb: "application/vnd.ms-excel.styles"
	}
};

function new_ct() {
	return ({
		workbooks:[], sheets:[], charts:[], dialogs:[], macros:[],
		rels:[], strs:[], comments:[], threadedcomments:[], links:[],
		coreprops:[], extprops:[], custprops:[], themes:[], styles:[],
		calcchains:[], vba: [], drawings: [], metadata: [], people:[],
		TODO:[], xmlns: "" });
}

function parse_ct(data) {
	var ct = new_ct();
	if(!data || !data.match) return ct;
	var ctext = {};
	(data.match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x);
		switch(y[0].replace(nsregex,"<")) {
			case '<?xml': break;
			case '<Types': ct.xmlns = y['xmlns' + (y[0].match(/<(\w+):/)||["",""])[1] ]; break;
			case '<Default': ctext[y.Extension.toLowerCase()] = y.ContentType; break;
			case '<Override':
				if(ct[ct2type[y.ContentType]] !== undefined) ct[ct2type[y.ContentType]].push(y.PartName);
				break;
		}
	});
	if(ct.xmlns !== XMLNS.CT) throw new Error("Unknown Namespace: " + ct.xmlns);
	ct.calcchain = ct.calcchains.length > 0 ? ct.calcchains[0] : "";
	ct.sst = ct.strs.length > 0 ? ct.strs[0] : "";
	ct.style = ct.styles.length > 0 ? ct.styles[0] : "";
	ct.defaults = ctext;
	delete ct.calcchains;
	return ct;
}

function write_ct(ct, opts, raw) {
	var type2ct/*{[string]:Array<string>}*/ = evert_arr(ct2type);

	var o = [], v;

	if(!raw) {
		o[o.length] = (XML_HEADER);
		o[o.length] = writextag('Types', null, {
			'xmlns': XMLNS.CT,
			'xmlns:xsd': XMLNS.xsd,
			'xmlns:xsi': XMLNS.xsi
		});
		o = o.concat([
			['xml', 'application/xml'],
			['bin', 'application/vnd.ms-excel.sheet.binary.macroEnabled.main'],
			['vml', 'application/vnd.openxmlformats-officedocument.vmlDrawing'],
			['data', 'application/vnd.openxmlformats-officedocument.model+data'],
			/* from test files */
			['bmp', 'image/bmp'],
			['png', 'image/png'],
			['gif', 'image/gif'],
			['emf', 'image/x-emf'],
			['wmf', 'image/x-wmf'],
			['jpg', 'image/jpeg'], ['jpeg', 'image/jpeg'],
			['tif', 'image/tiff'], ['tiff', 'image/tiff'],
			['pdf', 'application/pdf'],
			['rels', 'application/vnd.openxmlformats-package.relationships+xml']
		].map(function(x) {
			return writextag('Default', null, {'Extension':x[0], 'ContentType': x[1]});
		}));
	}

	/* only write first instance */
	var f1 = function(w) {
		if(ct[w] && ct[w].length > 0) {
			v = ct[w][0];
			o[o.length] = (writextag('Override', null, {
				'PartName': (v[0] == '/' ? "":"/") + v,
				'ContentType': CT_LIST[w][opts.bookType] || CT_LIST[w]['xlsx']
			}));
		}
	};

	/* book type-specific */
	var f2 = function(w) {
		(ct[w]||[]).forEach(function(v) {
			o[o.length] = (writextag('Override', null, {
				'PartName': (v[0] == '/' ? "":"/") + v,
				'ContentType': CT_LIST[w][opts.bookType] || CT_LIST[w]['xlsx']
			}));
		});
	};

	/* standard type */
	var f3 = function(t) {
		(ct[t]||[]).forEach(function(v) {
			o[o.length] = (writextag('Override', null, {
				'PartName': (v[0] == '/' ? "":"/") + v,
				'ContentType': type2ct[t][0]
			}));
		});
	};

	f1('workbooks');
	f2('sheets');
	f2('charts');
	f3('themes');
	['strs', 'styles'].forEach(f1);
	['coreprops', 'extprops', 'custprops'].forEach(f3);
	f3('vba');
	f3('comments');
	f3('threadedcomments');
	f3('drawings');
	f2('metadata');
	f3('people');
	if(!raw && o.length>2){ o[o.length] = ('</Types>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* 9.3 Relationships */
var RELS = ({
	WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
	SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
	HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
	VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
	XPATH: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",
	XMISS: "http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",
	XLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",
	CXML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",
	CXMLP: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",
	CMNT: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
	CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
	EXT_PROPS: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties',
	CUST_PROPS: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties',
	SST: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
	STY: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
	THEME: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
	CHART: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart",
	CHARTEX: "http://schemas.microsoft.com/office/2014/relationships/chartEx",
	CS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet",
	WS: [
		"http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
		"http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
	],
	DS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet",
	MS: "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet",
	IMG: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
	DRAW: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
	XLMETA: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sheetMetadata",
	TCMNT: "http://schemas.microsoft.com/office/2017/10/relationships/threadedComment",
	PEOPLE: "http://schemas.microsoft.com/office/2017/10/relationships/person",
	CONN: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/connections",
	VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
});

/* 9.3.3 Representing Relationships */
function get_rels_path(file) {
	var n = file.lastIndexOf("/");
	return file.slice(0,n+1) + '_rels/' + file.slice(n+1) + ".rels";
}

function parse_rels(data, currentFilePath) {
	var rels = {"!id":{}};
	if (!data) return rels;
	if (currentFilePath.charAt(0) !== '/') {
		currentFilePath = '/'+currentFilePath;
	}
	var hash = {};

	(data.match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x);
		/* 9.3.2.2 OPC_Relationships */
		if (y[0] === '<Relationship') {
			var rel = {}; rel.Type = y.Type; rel.Target = y.Target; rel.Id = y.Id; if(y.TargetMode) rel.TargetMode = y.TargetMode;
			var canonictarget = y.TargetMode === 'External' ? y.Target : resolve_path(y.Target, currentFilePath);
			rels[canonictarget] = rel;
			hash[y.Id] = rel;
		}
	});
	rels["!id"] = hash;
	return rels;
}


/* TODO */
function write_rels(rels) {
	var o = [XML_HEADER, writextag('Relationships', null, {
		//'xmlns:ns0': XMLNS.RELS,
		'xmlns': XMLNS.RELS
	})];
	keys(rels['!id']).forEach(function(rid) {
		o[o.length] = (writextag('Relationship', null, rels['!id'][rid]));
	});
	if(o.length>2){ o[o.length] = ('</Relationships>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}

function add_rels(rels, rId, f, type, relobj, targetmode) {
	if(!relobj) relobj = {};
	if(!rels['!id']) rels['!id'] = {};
	if(!rels['!idx']) rels['!idx'] = 1;
	if(rId < 0) for(rId = rels['!idx']; rels['!id']['rId' + rId]; ++rId){/* empty */}
	rels['!idx'] = rId + 1;
	relobj.Id = 'rId' + rId;
	relobj.Type = type;
	relobj.Target = f;
	if(targetmode) relobj.TargetMode = targetmode;
	else if([RELS.HLINK, RELS.XPATH, RELS.XMISS].indexOf(relobj.Type) > -1) relobj.TargetMode = "External";
	if(rels['!id'][relobj.Id]) throw new Error("Cannot rewrite rId " + rId);
	rels['!id'][relobj.Id] = relobj;
	rels[('/' + relobj.Target).replace("//","/")] = relobj;
	return rId;
}
/* Open Document Format for Office Applications (OpenDocument) Version 1.2 */
/* Part 3 Section 4 Manifest File */
var CT_ODS = "application/vnd.oasis.opendocument.spreadsheet";
function parse_manifest(d, opts) {
	var str = xlml_normalize(d);
	var Rn;
	var FEtag;
	while((Rn = xlmlregex.exec(str))) switch(Rn[3]) {
		case 'manifest': break; // 4.2 <manifest:manifest>
		case 'file-entry': // 4.3 <manifest:file-entry>
			FEtag = parsexmltag(Rn[0], false);
			if(FEtag.path == '/' && FEtag.type !== CT_ODS) throw new Error("This OpenDocument is not a spreadsheet");
			break;
		case 'encryption-data': // 4.4 <manifest:encryption-data>
		case 'algorithm': // 4.5 <manifest:algorithm>
		case 'start-key-generation': // 4.6 <manifest:start-key-generation>
		case 'key-derivation': // 4.7 <manifest:key-derivation>
			throw new Error("Unsupported ODS Encryption");
		default: if(opts && opts.WTF) throw Rn;
	}
}

function write_manifest(manifest) {
	var o = [XML_HEADER];
	o.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n');
	o.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');
	for(var i = 0; i < manifest.length; ++i) o.push('  <manifest:file-entry manifest:full-path="' + manifest[i][0] + '" manifest:media-type="' + manifest[i][1] + '"/>\n');
	o.push('</manifest:manifest>');
	return o.join("");
}

/* Part 3 Section 6 Metadata Manifest File */
function write_rdf_type(file, res, tag) {
	return [
		'  <rdf:Description rdf:about="' + file + '">\n',
		'    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' + (tag || "odf") + '#' + res + '"/>\n',
		'  </rdf:Description>\n'
	].join("");
}
function write_rdf_has(base, file) {
	return [
		'  <rdf:Description rdf:about="' + base + '">\n',
		'    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' + file + '"/>\n',
		'  </rdf:Description>\n'
	].join("");
}
function write_rdf(rdf) {
	var o = [XML_HEADER];
	o.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');
	for(var i = 0; i != rdf.length; ++i) {
		o.push(write_rdf_type(rdf[i][0], rdf[i][1]));
		o.push(write_rdf_has("",rdf[i][0]));
	}
	o.push(write_rdf_type("","Document", "pkg"));
	o.push('</rdf:RDF>');
	return o.join("");
}
/* TODO: pull properties */
function write_meta_ods() {
	return '<office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>Sheet' + 'JS ' + XLSX.version + '</meta:generator></office:meta></office:document-meta>';
}

/* ECMA-376 Part II 11.1 Core Properties Part */
/* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */
var CORE_PROPS = [
	["cp:category", "Category"],
	["cp:contentStatus", "ContentStatus"],
	["cp:keywords", "Keywords"],
	["cp:lastModifiedBy", "LastAuthor"],
	["cp:lastPrinted", "LastPrinted"],
	["cp:revision", "RevNumber"],
	["cp:version", "Version"],
	["dc:creator", "Author"],
	["dc:description", "Comments"],
	["dc:identifier", "Identifier"],
	["dc:language", "Language"],
	["dc:subject", "Subject"],
	["dc:title", "Title"],
	["dcterms:created", "CreatedDate", 'date'],
	["dcterms:modified", "ModifiedDate", 'date']
];

var CORE_PROPS_REGEX = (function() {
	var r = new Array(CORE_PROPS.length);
	for(var i = 0; i < CORE_PROPS.length; ++i) {
		var f = CORE_PROPS[i];
		var g = "(?:"+ f[0].slice(0,f[0].indexOf(":")) +":)"+ f[0].slice(f[0].indexOf(":")+1);
		r[i] = new RegExp("<" + g + "[^>]*>([\\s\\S]*?)<\/" + g + ">");
	}
	return r;
})();

function parse_core_props(data) {
	var p = {};
	data = utf8read(data);

	for(var i = 0; i < CORE_PROPS.length; ++i) {
		var f = CORE_PROPS[i], cur = data.match(CORE_PROPS_REGEX[i]);
		if(cur != null && cur.length > 0) p[f[1]] = unescapexml(cur[1]);
		if(f[2] === 'date' && p[f[1]]) p[f[1]] = parseDate(p[f[1]]);
	}

	return p;
}

function cp_doit(f, g, h, o, p) {
	if(p[f] != null || g == null || g === "") return;
	p[f] = g;
	g = escapexml(g);
	o[o.length] = (h ? writextag(f,g,h) : writetag(f,g));
}

function write_core_props(cp, _opts) {
	var opts = _opts || {};
	var o = [XML_HEADER, writextag('cp:coreProperties', null, {
		//'xmlns': XMLNS.CORE_PROPS,
		'xmlns:cp': XMLNS.CORE_PROPS,
		'xmlns:dc': XMLNS.dc,
		'xmlns:dcterms': XMLNS.dcterms,
		'xmlns:dcmitype': XMLNS.dcmitype,
		'xmlns:xsi': XMLNS.xsi
	})], p = {};
	if(!cp && !opts.Props) return o.join("");

	if(cp) {
		if(cp.CreatedDate != null) cp_doit("dcterms:created", typeof cp.CreatedDate === "string" ? cp.CreatedDate : write_w3cdtf(cp.CreatedDate, opts.WTF), {"xsi:type":"dcterms:W3CDTF"}, o, p);
		if(cp.ModifiedDate != null) cp_doit("dcterms:modified", typeof cp.ModifiedDate === "string" ? cp.ModifiedDate : write_w3cdtf(cp.ModifiedDate, opts.WTF), {"xsi:type":"dcterms:W3CDTF"}, o, p);
	}

	for(var i = 0; i != CORE_PROPS.length; ++i) {
		var f = CORE_PROPS[i];
		var v = opts.Props && opts.Props[f[1]] != null ? opts.Props[f[1]] : cp ? cp[f[1]] : null;
		if(v === true) v = "1";
		else if(v === false) v = "0";
		else if(typeof v == "number") v = String(v);
		if(v != null) cp_doit(f[0], v, null, o, p);
	}
	if(o.length>2){ o[o.length] = ('</cp:coreProperties>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* 15.2.12.3 Extended File Properties Part */
/* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */
var EXT_PROPS = [
	["Application", "Application", "string"],
	["AppVersion", "AppVersion", "string"],
	["Company", "Company", "string"],
	["DocSecurity", "DocSecurity", "string"],
	["Manager", "Manager", "string"],
	["HyperlinksChanged", "HyperlinksChanged", "bool"],
	["SharedDoc", "SharedDoc", "bool"],
	["LinksUpToDate", "LinksUpToDate", "bool"],
	["ScaleCrop", "ScaleCrop", "bool"],
	["HeadingPairs", "HeadingPairs", "raw"],
	["TitlesOfParts", "TitlesOfParts", "raw"]
];

var PseudoPropsPairs = [
	"Worksheets",  "SheetNames",
	"NamedRanges", "DefinedNames",
	"Chartsheets", "ChartNames"
];
function load_props_pairs(HP, TOP, props, opts) {
	var v = [];
	if(typeof HP == "string") v = parseVector(HP, opts);
	else for(var j = 0; j < HP.length; ++j) v = v.concat(HP[j].map(function(hp) { return {v:hp}; }));
	var parts = (typeof TOP == "string") ? parseVector(TOP, opts).map(function (x) { return x.v; }) : TOP;
	var idx = 0, len = 0;
	if(parts.length > 0) for(var i = 0; i !== v.length; i += 2) {
		len = +(v[i+1].v);
		switch(v[i].v) {
			case "Worksheets":
			case "工作表":
			case "Листы":
			case "أوراق العمل":
			case "ワークシート":
			case "גליונות עבודה":
			case "Arbeitsblätter":
			case "Çalışma Sayfaları":
			case "Feuilles de calcul":
			case "Fogli di lavoro":
			case "Folhas de cálculo":
			case "Planilhas":
			case "Regneark":
			case "Hojas de cálculo":
			case "Werkbladen":
				props.Worksheets = len;
				props.SheetNames = parts.slice(idx, idx + len);
				break;

			case "Named Ranges":
			case "Rangos con nombre":
			case "名前付き一覧":
			case "Benannte Bereiche":
			case "Navngivne områder":
				props.NamedRanges = len;
				props.DefinedNames = parts.slice(idx, idx + len);
				break;

			case "Charts":
			case "Diagramme":
				props.Chartsheets = len;
				props.ChartNames = parts.slice(idx, idx + len);
				break;
		}
		idx += len;
	}
}

function parse_ext_props(data, p, opts) {
	var q = {}; if(!p) p = {};
	data = utf8read(data);

	EXT_PROPS.forEach(function(f) {
		var xml = (data.match(matchtag(f[0]))||[])[1];
		switch(f[2]) {
			case "string": if(xml) p[f[1]] = unescapexml(xml); break;
			case "bool": p[f[1]] = xml === "true"; break;
			case "raw":
				var cur = data.match(new RegExp("<" + f[0] + "[^>]*>([\\s\\S]*?)<\/" + f[0] + ">"));
				if(cur && cur.length > 0) q[f[1]] = cur[1];
				break;
		}
	});

	if(q.HeadingPairs && q.TitlesOfParts) load_props_pairs(q.HeadingPairs, q.TitlesOfParts, p, opts);

	return p;
}

function write_ext_props(cp) {
	var o = [], W = writextag;
	if(!cp) cp = {};
	cp.Application = "SheetJS";
	o[o.length] = (XML_HEADER);
	o[o.length] = (writextag('Properties', null, {
		'xmlns': XMLNS.EXT_PROPS,
		'xmlns:vt': XMLNS.vt
	}));

	EXT_PROPS.forEach(function(f) {
		if(cp[f[1]] === undefined) return;
		var v;
		switch(f[2]) {
			case 'string': v = escapexml(String(cp[f[1]])); break;
			case 'bool': v = cp[f[1]] ? 'true' : 'false'; break;
		}
		if(v !== undefined) o[o.length] = (W(f[0], v));
	});

	/* TODO: HeadingPairs, TitlesOfParts */
	o[o.length] = (W('HeadingPairs', W('vt:vector', W('vt:variant', '<vt:lpstr>Worksheets</vt:lpstr>')+W('vt:variant', W('vt:i4', String(cp.Worksheets))), {size:2, baseType:"variant"})));
	o[o.length] = (W('TitlesOfParts', W('vt:vector', cp.SheetNames.map(function(s) { return "<vt:lpstr>" + escapexml(s) + "</vt:lpstr>"; }).join(""), {size: cp.Worksheets, baseType:"lpstr"})));
	if(o.length>2){ o[o.length] = ('</Properties>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* 15.2.12.2 Custom File Properties Part */
var custregex = /<[^>]+>[^<]*/g;
function parse_cust_props(data, opts) {
	var p = {}, name = "";
	var m = data.match(custregex);
	if(m) for(var i = 0; i != m.length; ++i) {
		var x = m[i], y = parsexmltag(x);
		switch(strip_ns(y[0])) {
			case '<?xml': break;
			case '<Properties': break;
			case '<property': name = unescapexml(y.name); break;
			case '</property>': name = null; break;
			default: if (x.indexOf('<vt:') === 0) {
				var toks = x.split('>');
				var type = toks[0].slice(4), text = toks[1];
				/* 22.4.2.32 (CT_Variant). Omit the binary types from 22.4 (Variant Types) */
				switch(type) {
					case 'lpstr': case 'bstr': case 'lpwstr':
						p[name] = unescapexml(text);
						break;
					case 'bool':
						p[name] = parsexmlbool(text);
						break;
					case 'i1': case 'i2': case 'i4': case 'i8': case 'int': case 'uint':
						p[name] = parseInt(text, 10);
						break;
					case 'r4': case 'r8': case 'decimal':
						p[name] = parseFloat(text);
						break;
					case 'filetime': case 'date':
						p[name] = parseDate(text);
						break;
					case 'cy': case 'error':
						p[name] = unescapexml(text);
						break;
					default:
						if(type.slice(-1) == '/') break;
						if(opts.WTF && typeof console !== 'undefined') console.warn('Unexpected', x, type, toks);
				}
			} else if(x.slice(0,2) === "</") {/* empty */
			} else if(opts.WTF) throw new Error(x);
		}
	}
	return p;
}

function write_cust_props(cp) {
	var o = [XML_HEADER, writextag('Properties', null, {
		'xmlns': XMLNS.CUST_PROPS,
		'xmlns:vt': XMLNS.vt
	})];
	if(!cp) return o.join("");
	var pid = 1;
	keys(cp).forEach(function custprop(k) { ++pid;
		o[o.length] = (writextag('property', write_vt(cp[k], true), {
			'fmtid': '{D5CDD505-2E9C-101B-9397-08002B2CF9AE}',
			'pid': pid,
			'name': escapexml(k)
		}));
	});
	if(o.length>2){ o[o.length] = '</Properties>'; o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* Common Name -> XLML Name */
var XLMLDocPropsMap = {
	Title: 'Title',
	Subject: 'Subject',
	Author: 'Author',
	Keywords: 'Keywords',
	Comments: 'Description',
	LastAuthor: 'LastAuthor',
	RevNumber: 'Revision',
	Application: 'AppName',
	/* TotalTime: 'TotalTime', */
	LastPrinted: 'LastPrinted',
	CreatedDate: 'Created',
	ModifiedDate: 'LastSaved',
	/* Pages */
	/* Words */
	/* Characters */
	Category: 'Category',
	/* PresentationFormat */
	Manager: 'Manager',
	Company: 'Company',
	/* Guid */
	/* HyperlinkBase */
	/* Bytes */
	/* Lines */
	/* Paragraphs */
	/* CharactersWithSpaces */
	AppVersion: 'Version',

	ContentStatus: 'ContentStatus', /* NOTE: missing from schema */
	Identifier: 'Identifier', /* NOTE: missing from schema */
	Language: 'Language' /* NOTE: missing from schema */
};
var evert_XLMLDPM;

function xlml_set_prop(Props, tag, val) {
	if(!evert_XLMLDPM) evert_XLMLDPM = evert(XLMLDocPropsMap);
	tag = evert_XLMLDPM[tag] || tag;
	Props[tag] = val;
}

function xlml_write_docprops(Props, opts) {
	var o = [];
	keys(XLMLDocPropsMap).map(function(m) {
		for(var i = 0; i < CORE_PROPS.length; ++i) if(CORE_PROPS[i][1] == m) return CORE_PROPS[i];
		for(i = 0; i < EXT_PROPS.length; ++i) if(EXT_PROPS[i][1] == m) return EXT_PROPS[i];
		throw m;
	}).forEach(function(p) {
		if(Props[p[1]] == null) return;
		var m = opts && opts.Props && opts.Props[p[1]] != null ? opts.Props[p[1]] : Props[p[1]];
		switch(p[2]) {
			case 'date': m = new Date(m).toISOString().replace(/\.\d*Z/,"Z"); break;
		}
		if(typeof m == 'number') m = String(m);
		else if(m === true || m === false) { m = m ? "1" : "0"; }
		else if(m instanceof Date) m = new Date(m).toISOString().replace(/\.\d*Z/,"");
		o.push(writetag(XLMLDocPropsMap[p[1]] || p[1], m));
	});
	return writextag('DocumentProperties', o.join(""), {xmlns:XLMLNS.o });
}
function xlml_write_custprops(Props, Custprops) {
	var BLACKLIST = ["Worksheets","SheetNames"];
	var T = 'CustomDocumentProperties';
	var o = [];
	if(Props) keys(Props).forEach(function(k) {
if(!Object.prototype.hasOwnProperty.call(Props, k)) return;
		for(var i = 0; i < CORE_PROPS.length; ++i) if(k == CORE_PROPS[i][1]) return;
		for(i = 0; i < EXT_PROPS.length; ++i) if(k == EXT_PROPS[i][1]) return;
		for(i = 0; i < BLACKLIST.length; ++i) if(k == BLACKLIST[i]) return;

		var m = Props[k];
		var t = "string";
		if(typeof m == 'number') { t = "float"; m = String(m); }
		else if(m === true || m === false) { t = "boolean"; m = m ? "1" : "0"; }
		else m = String(m);
		o.push(writextag(escapexmltag(k), m, {"dt:dt":t}));
	});
	if(Custprops) keys(Custprops).forEach(function(k) {
if(!Object.prototype.hasOwnProperty.call(Custprops, k)) return;
		if(Props && Object.prototype.hasOwnProperty.call(Props, k)) return;
		var m = Custprops[k];
		var t = "string";
		if(typeof m == 'number') { t = "float"; m = String(m); }
		else if(m === true || m === false) { t = "boolean"; m = m ? "1" : "0"; }
		else if(m instanceof Date) { t = "dateTime.tz"; m = m.toISOString(); }
		else m = String(m);
		o.push(writextag(escapexmltag(k), m, {"dt:dt":t}));
	});
	return '<' + T + ' xmlns="' + XLMLNS.o + '">' + o.join("") + '</' + T + '>';
}
/* [MS-DTYP] 2.3.3 FILETIME */
/* [MS-OLEDS] 2.1.3 FILETIME (Packet Version) */
/* [MS-OLEPS] 2.8 FILETIME (Packet Version) */
function parse_FILETIME(blob) {
	var dwLowDateTime = blob.read_shift(4), dwHighDateTime = blob.read_shift(4);
	return new Date(((dwHighDateTime/1e7*Math.pow(2,32) + dwLowDateTime/1e7) - 11644473600)*1000).toISOString().replace(/\.000/,"");
}
function write_FILETIME(time) {
	var date = (typeof time == "string") ? new Date(Date.parse(time)) : time;
	var t = date.getTime() / 1000 + 11644473600;
	var l = t % Math.pow(2,32), h = (t - l) / Math.pow(2,32);
	l *= 1e7; h *= 1e7;
	var w = (l / Math.pow(2,32)) | 0;
	if(w > 0) { l = l % Math.pow(2,32); h += w; }
	var o = new_buf(8); o.write_shift(4, l); o.write_shift(4, h); return o;
}

/* [MS-OSHARED] 2.3.3.1.4 Lpstr */
function parse_lpstr(blob, type, pad) {
	var start = blob.l;
	var str = blob.read_shift(0, 'lpstr-cp');
	if(pad) while((blob.l - start) & 3) ++blob.l;
	return str;
}

/* [MS-OSHARED] 2.3.3.1.6 Lpwstr */
function parse_lpwstr(blob, type, pad) {
	var str = blob.read_shift(0, 'lpwstr');
	if(pad) blob.l += (4 - ((str.length+1) & 3)) & 3;
	return str;
}


/* [MS-OSHARED] 2.3.3.1.11 VtString */
/* [MS-OSHARED] 2.3.3.1.12 VtUnalignedString */
function parse_VtStringBase(blob, stringType, pad) {
	if(stringType === 0x1F /*VT_LPWSTR*/) return parse_lpwstr(blob);
	return parse_lpstr(blob, stringType, pad);
}

function parse_VtString(blob, t, pad) { return parse_VtStringBase(blob, t, pad === false ? 0: 4); }
function parse_VtUnalignedString(blob, t) { if(!t) throw new Error("VtUnalignedString must have positive length"); return parse_VtStringBase(blob, t, 0); }

/* [MS-OSHARED] 2.3.3.1.7 VtVecLpwstrValue */
function parse_VtVecLpwstrValue(blob) {
	var length = blob.read_shift(4);
	var ret = [];
	for(var i = 0; i != length; ++i) {
		var start = blob.l;
		ret[i] = blob.read_shift(0, 'lpwstr').replace(chr0,'');
		if((blob.l - start) & 0x02) blob.l += 2;
	}
	return ret;
}

/* [MS-OSHARED] 2.3.3.1.9 VtVecUnalignedLpstrValue */
function parse_VtVecUnalignedLpstrValue(blob) {
	var length = blob.read_shift(4);
	var ret = [];
	for(var i = 0; i != length; ++i) ret[i] = blob.read_shift(0, 'lpstr-cp').replace(chr0,'');
	return ret;
}


/* [MS-OSHARED] 2.3.3.1.13 VtHeadingPair */
function parse_VtHeadingPair(blob) {
	var start = blob.l;
	var headingString = parse_TypedPropertyValue(blob, VT_USTR);
	if(blob[blob.l] == 0x00 && blob[blob.l+1] == 0x00 && ((blob.l - start) & 0x02)) blob.l += 2;
	var headerParts = parse_TypedPropertyValue(blob, VT_I4);
	return [headingString, headerParts];
}

/* [MS-OSHARED] 2.3.3.1.14 VtVecHeadingPairValue */
function parse_VtVecHeadingPairValue(blob) {
	var cElements = blob.read_shift(4);
	var out = [];
	for(var i = 0; i < cElements / 2; ++i) out.push(parse_VtHeadingPair(blob));
	return out;
}

/* [MS-OLEPS] 2.18.1 Dictionary (uses 2.17, 2.16) */
function parse_dictionary(blob,CodePage) {
	var cnt = blob.read_shift(4);
	var dict = ({});
	for(var j = 0; j != cnt; ++j) {
		var pid = blob.read_shift(4);
		var len = blob.read_shift(4);
		dict[pid] = blob.read_shift(len, (CodePage === 0x4B0 ?'utf16le':'utf8')).replace(chr0,'').replace(chr1,'!');
		if(CodePage === 0x4B0 && (len % 2)) blob.l += 2;
	}
	if(blob.l & 3) blob.l = (blob.l>>2+1)<<2;
	return dict;
}

/* [MS-OLEPS] 2.9 BLOB */
function parse_BLOB(blob) {
	var size = blob.read_shift(4);
	var bytes = blob.slice(blob.l,blob.l+size);
	blob.l += size;
	if((size & 3) > 0) blob.l += (4 - (size & 3)) & 3;
	return bytes;
}

/* [MS-OLEPS] 2.11 ClipboardData */
function parse_ClipboardData(blob) {
	// TODO
	var o = {};
	o.Size = blob.read_shift(4);
	//o.Format = blob.read_shift(4);
	blob.l += o.Size + 3 - (o.Size - 1) % 4;
	return o;
}

/* [MS-OLEPS] 2.15 TypedPropertyValue */
function parse_TypedPropertyValue(blob, type, _opts) {
	var t = blob.read_shift(2), ret, opts = _opts||{};
	blob.l += 2;
	if(type !== VT_VARIANT)
	if(t !== type && VT_CUSTOM.indexOf(type)===-1 && !((type & 0xFFFE) == 0x101E && (t & 0xFFFE) == 0x101E)) throw new Error('Expected type ' + type + ' saw ' + t);
	switch(type === VT_VARIANT ? t : type) {
		case 0x02 /*VT_I2*/: ret = blob.read_shift(2, 'i'); if(!opts.raw) blob.l += 2; return ret;
		case 0x03 /*VT_I4*/: ret = blob.read_shift(4, 'i'); return ret;
		case 0x0B /*VT_BOOL*/: return blob.read_shift(4) !== 0x0;
		case 0x13 /*VT_UI4*/: ret = blob.read_shift(4); return ret;
		case 0x1E /*VT_LPSTR*/: return parse_lpstr(blob, t, 4).replace(chr0,'');
		case 0x1F /*VT_LPWSTR*/: return parse_lpwstr(blob);
		case 0x40 /*VT_FILETIME*/: return parse_FILETIME(blob);
		case 0x41 /*VT_BLOB*/: return parse_BLOB(blob);
		case 0x47 /*VT_CF*/: return parse_ClipboardData(blob);
		case 0x50 /*VT_STRING*/: return parse_VtString(blob, t, !opts.raw).replace(chr0,'');
		case 0x51 /*VT_USTR*/: return parse_VtUnalignedString(blob, t/*, 4*/).replace(chr0,'');
		case 0x100C /*VT_VECTOR|VT_VARIANT*/: return parse_VtVecHeadingPairValue(blob);
		case 0x101E /*VT_VECTOR|VT_LPSTR*/:
		case 0x101F /*VT_VECTOR|VT_LPWSTR*/:
			return t == 0x101F ? parse_VtVecLpwstrValue(blob) : parse_VtVecUnalignedLpstrValue(blob);
		default: throw new Error("TypedPropertyValue unrecognized type " + type + " " + t);
	}
}
function write_TypedPropertyValue(type, value) {
	var o = new_buf(4), p = new_buf(4);
	o.write_shift(4, type == 0x50 ? 0x1F : type);
	switch(type) {
		case 0x03 /*VT_I4*/: p.write_shift(-4, value); break;
		case 0x05 /*VT_I4*/: p = new_buf(8); p.write_shift(8, value, 'f'); break;
		case 0x0B /*VT_BOOL*/: p.write_shift(4, value ? 0x01 : 0x00); break;
		case 0x40 /*VT_FILETIME*/:  p = write_FILETIME(value); break;
		case 0x1F /*VT_LPWSTR*/:
		case 0x50 /*VT_STRING*/:
p = new_buf(4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
			p.write_shift(4, value.length + 1);
			p.write_shift(0, value, "dbcs");
			while(p.l != p.length) p.write_shift(1, 0);
			break;
		default: throw new Error("TypedPropertyValue unrecognized type " + type + " " + value);
	}
	return bconcat([o, p]);
}

/* [MS-OLEPS] 2.20 PropertySet */
function parse_PropertySet(blob, PIDSI) {
	var start_addr = blob.l;
	var size = blob.read_shift(4);
	var NumProps = blob.read_shift(4);
	var Props = [], i = 0;
	var CodePage = 0;
	var Dictionary = -1, DictObj = ({});
	for(i = 0; i != NumProps; ++i) {
		var PropID = blob.read_shift(4);
		var Offset = blob.read_shift(4);
		Props[i] = [PropID, Offset + start_addr];
	}
	Props.sort(function(x,y) { return x[1] - y[1]; });
	var PropH = {};
	for(i = 0; i != NumProps; ++i) {
		if(blob.l !== Props[i][1]) {
			var fail = true;
			if(i>0 && PIDSI) switch(PIDSI[Props[i-1][0]].t) {
				case 0x02 /*VT_I2*/: if(blob.l+2 === Props[i][1]) { blob.l+=2; fail = false; } break;
				case 0x50 /*VT_STRING*/: if(blob.l <= Props[i][1]) { blob.l=Props[i][1]; fail = false; } break;
				case 0x100C /*VT_VECTOR|VT_VARIANT*/: if(blob.l <= Props[i][1]) { blob.l=Props[i][1]; fail = false; } break;
			}
			if((!PIDSI||i==0) && blob.l <= Props[i][1]) { fail=false; blob.l = Props[i][1]; }
			if(fail) throw new Error("Read Error: Expected address " + Props[i][1] + ' at ' + blob.l + ' :' + i);
		}
		if(PIDSI) {
			if(Props[i][0] == 0 && Props.length > i+1 && Props[i][1] == Props[i+1][1]) continue; // R9
			var piddsi = PIDSI[Props[i][0]];
			PropH[piddsi.n] = parse_TypedPropertyValue(blob, piddsi.t, {raw:true});
			if(piddsi.p === 'version') PropH[piddsi.n] = String(PropH[piddsi.n] >> 16) + "." + ("0000" + String(PropH[piddsi.n] & 0xFFFF)).slice(-4);
			if(piddsi.n == "CodePage") switch(PropH[piddsi.n]) {
				case 0: PropH[piddsi.n] = 1252;
					/* falls through */
				case 874:
				case 932:
				case 936:
				case 949:
				case 950:
				case 1250:
				case 1251:
				case 1253:
				case 1254:
				case 1255:
				case 1256:
				case 1257:
				case 1258:
				case 10000:
				case 1200:
				case 1201:
				case 1252:
				case 65000: case -536:
				case 65001: case -535:
					set_cp(CodePage = (PropH[piddsi.n]>>>0) & 0xFFFF); break;
				default: throw new Error("Unsupported CodePage: " + PropH[piddsi.n]);
			}
		} else {
			if(Props[i][0] === 0x1) {
				CodePage = PropH.CodePage = (parse_TypedPropertyValue(blob, VT_I2));
				set_cp(CodePage);
				if(Dictionary !== -1) {
					var oldpos = blob.l;
					blob.l = Props[Dictionary][1];
					DictObj = parse_dictionary(blob,CodePage);
					blob.l = oldpos;
				}
			} else if(Props[i][0] === 0) {
				if(CodePage === 0) { Dictionary = i; blob.l = Props[i+1][1]; continue; }
				DictObj = parse_dictionary(blob,CodePage);
			} else {
				var name = DictObj[Props[i][0]];
				var val;
				/* [MS-OSHARED] 2.3.3.2.3.1.2 + PROPVARIANT */
				switch(blob[blob.l]) {
					case 0x41 /*VT_BLOB*/: blob.l += 4; val = parse_BLOB(blob); break;
					case 0x1E /*VT_LPSTR*/: blob.l += 4; val = parse_VtString(blob, blob[blob.l-4]).replace(/\u0000+$/,""); break;
					case 0x1F /*VT_LPWSTR*/: blob.l += 4; val = parse_VtString(blob, blob[blob.l-4]).replace(/\u0000+$/,""); break;
					case 0x03 /*VT_I4*/: blob.l += 4; val = blob.read_shift(4, 'i'); break;
					case 0x13 /*VT_UI4*/: blob.l += 4; val = blob.read_shift(4); break;
					case 0x05 /*VT_R8*/: blob.l += 4; val = blob.read_shift(8, 'f'); break;
					case 0x0B /*VT_BOOL*/: blob.l += 4; val = parsebool(blob, 4); break;
					case 0x40 /*VT_FILETIME*/: blob.l += 4; val = parseDate(parse_FILETIME(blob)); break;
					default: throw new Error("unparsed value: " + blob[blob.l]);
				}
				PropH[name] = val;
			}
		}
	}
	blob.l = start_addr + size; /* step ahead to skip padding */
	return PropH;
}
var XLSPSSkip = [ "CodePage", "Thumbnail", "_PID_LINKBASE", "_PID_HLINKS", "SystemIdentifier", "FMTID" ];
function guess_property_type(val) {
	switch(typeof val) {
		case "boolean": return 0x0B;
		case "number": return ((val|0)==val) ? 0x03 : 0x05;
		case "string": return 0x1F;
		case "object": if(val instanceof Date) return 0x40; break;
	}
	return -1;
}
function write_PropertySet(entries, RE, PIDSI) {
	var hdr = new_buf(8), piao = [], prop = [];
	var sz = 8, i = 0;

	var pr = new_buf(8), pio = new_buf(8);
	pr.write_shift(4, 0x0002);
	pr.write_shift(4, 0x04B0);
	pio.write_shift(4, 0x0001);
	prop.push(pr); piao.push(pio);
	sz += 8 + pr.length;

	if(!RE) {
		pio = new_buf(8);
		pio.write_shift(4, 0);
		piao.unshift(pio);

		var bufs = [new_buf(4)];
		bufs[0].write_shift(4, entries.length);
		for(i = 0; i < entries.length; ++i) {
			var value = entries[i][0];
			pr = new_buf(4 + 4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
			pr.write_shift(4, i+2);
			pr.write_shift(4, value.length + 1);
			pr.write_shift(0, value, "dbcs");
			while(pr.l != pr.length) pr.write_shift(1, 0);
			bufs.push(pr);
		}
		pr = bconcat(bufs);
		prop.unshift(pr);
		sz += 8 + pr.length;
	}

	for(i = 0; i < entries.length; ++i) {
		if(RE && !RE[entries[i][0]]) continue;
		if(XLSPSSkip.indexOf(entries[i][0]) > -1 || PseudoPropsPairs.indexOf(entries[i][0]) > -1) continue;
		if(entries[i][1] == null) continue;

		var val = entries[i][1], idx = 0;
		if(RE) {
			idx = +RE[entries[i][0]];
			var pinfo = (PIDSI)[idx];
			if(pinfo.p == "version" && typeof val == "string") {
var arr = val.split(".");
				val = ((+arr[0])<<16) + ((+arr[1])||0);
			}
			pr = write_TypedPropertyValue(pinfo.t, val);
		} else {
			var T = guess_property_type(val);
			if(T == -1) { T = 0x1F; val = String(val); }
			pr = write_TypedPropertyValue(T, val);
		}
		prop.push(pr);

		pio = new_buf(8);
		pio.write_shift(4, !RE ? 2+i : idx);
		piao.push(pio);

		sz += 8 + pr.length;
	}

	var w = 8 * (prop.length + 1);
	for(i = 0; i < prop.length; ++i) { piao[i].write_shift(4, w); w += prop[i].length; }
	hdr.write_shift(4, sz);
	hdr.write_shift(4, prop.length);
	return bconcat([hdr].concat(piao).concat(prop));
}

/* [MS-OLEPS] 2.21 PropertySetStream */
function parse_PropertySetStream(file, PIDSI, clsid) {
	var blob = file.content;
	if(!blob) return ({});
	prep_blob(blob, 0);

	var NumSets, FMTID0, FMTID1, Offset0, Offset1 = 0;
	blob.chk('feff', 'Byte Order: ');

	/*var vers = */blob.read_shift(2); // TODO: check version
	var SystemIdentifier = blob.read_shift(4);
	var CLSID = blob.read_shift(16);
	if(CLSID !== CFB.utils.consts.HEADER_CLSID && CLSID !== clsid) throw new Error("Bad PropertySet CLSID " + CLSID);
	NumSets = blob.read_shift(4);
	if(NumSets !== 1 && NumSets !== 2) throw new Error("Unrecognized #Sets: " + NumSets);
	FMTID0 = blob.read_shift(16); Offset0 = blob.read_shift(4);

	if(NumSets === 1 && Offset0 !== blob.l) throw new Error("Length mismatch: " + Offset0 + " !== " + blob.l);
	else if(NumSets === 2) { FMTID1 = blob.read_shift(16); Offset1 = blob.read_shift(4); }
	var PSet0 = parse_PropertySet(blob, PIDSI);

	var rval = ({ SystemIdentifier: SystemIdentifier });
	for(var y in PSet0) rval[y] = PSet0[y];
	//rval.blob = blob;
	rval.FMTID = FMTID0;
	//rval.PSet0 = PSet0;
	if(NumSets === 1) return rval;
	if(Offset1 - blob.l == 2) blob.l += 2;
	if(blob.l !== Offset1) throw new Error("Length mismatch 2: " + blob.l + " !== " + Offset1);
	var PSet1;
	try { PSet1 = parse_PropertySet(blob, null); } catch(e) {/* empty */}
	for(y in PSet1) rval[y] = PSet1[y];
	rval.FMTID = [FMTID0, FMTID1]; // TODO: verify FMTID0/1
	return rval;
}
function write_PropertySetStream(entries, clsid, RE, PIDSI, entries2, clsid2) {
	var hdr = new_buf(entries2 ? 68 : 48);
	var bufs = [hdr];
	hdr.write_shift(2, 0xFFFE);
	hdr.write_shift(2, 0x0000); /* TODO: type 1 props */
	hdr.write_shift(4, 0x32363237);
	hdr.write_shift(16, CFB.utils.consts.HEADER_CLSID, "hex");
	hdr.write_shift(4, (entries2 ? 2 : 1));
	hdr.write_shift(16, clsid, "hex");
	hdr.write_shift(4, (entries2 ? 68 : 48));
	var ps0 = write_PropertySet(entries, RE, PIDSI);
	bufs.push(ps0);

	if(entries2) {
		var ps1 = write_PropertySet(entries2, null, null);
		hdr.write_shift(16, clsid2, "hex");
		hdr.write_shift(4, 68 + ps0.length);
		bufs.push(ps1);
	}
	return bconcat(bufs);
}

function parsenoop2(blob, length) { blob.read_shift(length); return null; }
function writezeroes(n, o) { if(!o) o=new_buf(n); for(var j=0; j<n; ++j) o.write_shift(1, 0); return o; }

function parslurp(blob, length, cb) {
	var arr = [], target = blob.l + length;
	while(blob.l < target) arr.push(cb(blob, target - blob.l));
	if(target !== blob.l) throw new Error("Slurp error");
	return arr;
}

function parsebool(blob, length) { return blob.read_shift(length) === 0x1; }
function writebool(v, o) { if(!o) o=new_buf(2); o.write_shift(2, +!!v); return o; }

function parseuint16(blob) { return blob.read_shift(2, 'u'); }
function writeuint16(v, o) { if(!o) o=new_buf(2); o.write_shift(2, v); return o; }
function parseuint16a(blob, length) { return parslurp(blob,length,parseuint16);}

/* --- 2.5 Structures --- */

/* [MS-XLS] 2.5.10 Bes (boolean or error) */
function parse_Bes(blob) {
	var v = blob.read_shift(1), t = blob.read_shift(1);
	return t === 0x01 ? v : v === 0x01;
}
function write_Bes(v, t, o) {
	if(!o) o = new_buf(2);
	o.write_shift(1, ((t == 'e') ? +v : +!!v));
	o.write_shift(1, ((t == 'e') ? 1 : 0));
	return o;
}

/* [MS-XLS] 2.5.240 ShortXLUnicodeString */
function parse_ShortXLUnicodeString(blob, length, opts) {
	var cch = blob.read_shift(opts && opts.biff >= 12 ? 2 : 1);
	var encoding = 'sbcs-cont';
	var cp = current_codepage;
	if(opts && opts.biff >= 8) current_codepage = 1200;
	if(!opts || opts.biff == 8 ) {
		var fHighByte = blob.read_shift(1);
		if(fHighByte) { encoding = 'dbcs-cont'; }
	} else if(opts.biff == 12) {
		encoding = 'wstr';
	}
	if(opts.biff >= 2 && opts.biff <= 5) encoding = 'cpstr';
	var o = cch ? blob.read_shift(cch, encoding) : "";
	current_codepage = cp;
	return o;
}

/* 2.5.293 XLUnicodeRichExtendedString */
function parse_XLUnicodeRichExtendedString(blob) {
	var cp = current_codepage;
	current_codepage = 1200;
	var cch = blob.read_shift(2), flags = blob.read_shift(1);
	var /*fHighByte = flags & 0x1,*/ fExtSt = flags & 0x4, fRichSt = flags & 0x8;
	var width = 1 + (flags & 0x1); // 0x0 -> utf8, 0x1 -> dbcs
	var cRun = 0, cbExtRst;
	var z = {};
	if(fRichSt) cRun = blob.read_shift(2);
	if(fExtSt) cbExtRst = blob.read_shift(4);
	var encoding = width == 2 ? 'dbcs-cont' : 'sbcs-cont';
	var msg = cch === 0 ? "" : blob.read_shift(cch, encoding);
	if(fRichSt) blob.l += 4 * cRun; //TODO: parse this
	if(fExtSt) blob.l += cbExtRst; //TODO: parse this
	z.t = msg;
	if(!fRichSt) { z.raw = "<t>" + z.t + "</t>"; z.r = z.t; }
	current_codepage = cp;
	return z;
}
function write_XLUnicodeRichExtendedString(xlstr) {
	var str = (xlstr.t||""), nfmts = 1;

	var hdr = new_buf(3 + (nfmts > 1 ? 2 : 0));
	hdr.write_shift(2, str.length);
	hdr.write_shift(1, (nfmts > 1 ? 0x08 : 0x00) | 0x01);
	if(nfmts > 1) hdr.write_shift(2, nfmts);

	var otext = new_buf(2 * str.length);
	otext.write_shift(2 * str.length, str, 'utf16le');

	var out = [hdr, otext];

	return bconcat(out);
}

/* 2.5.296 XLUnicodeStringNoCch */
function parse_XLUnicodeStringNoCch(blob, cch, opts) {
	var retval;
	if(opts) {
		if(opts.biff >= 2 && opts.biff <= 5) return blob.read_shift(cch, 'cpstr');
		if(opts.biff >= 12) return blob.read_shift(cch, 'dbcs-cont');
	}
	var fHighByte = blob.read_shift(1);
	if(fHighByte===0) { retval = blob.read_shift(cch, 'sbcs-cont'); }
	else { retval = blob.read_shift(cch, 'dbcs-cont'); }
	return retval;
}

/* 2.5.294 XLUnicodeString */
function parse_XLUnicodeString(blob, length, opts) {
	var cch = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	if(cch === 0) { blob.l++; return ""; }
	return parse_XLUnicodeStringNoCch(blob, cch, opts);
}
/* BIFF5 override */
function parse_XLUnicodeString2(blob, length, opts) {
	if(opts.biff > 5) return parse_XLUnicodeString(blob, length, opts);
	var cch = blob.read_shift(1);
	if(cch === 0) { blob.l++; return ""; }
	return blob.read_shift(cch, (opts.biff <= 4 || !blob.lens ) ? 'cpstr' : 'sbcs-cont');
}
/* TODO: BIFF5 and lower, codepage awareness */
function write_XLUnicodeString(str, opts, o) {
	if(!o) o = new_buf(3 + 2 * str.length);
	o.write_shift(2, str.length);
	o.write_shift(1, 1);
	o.write_shift(31, str, 'utf16le');
	return o;
}

/* [MS-XLS] 2.5.61 ControlInfo */
function parse_ControlInfo(blob) {
	var flags = blob.read_shift(1);
	blob.l++;
	var accel = blob.read_shift(2);
	blob.l += 2;
	return [flags, accel];
}

/* [MS-OSHARED] 2.3.7.6 URLMoniker TODO: flags */
function parse_URLMoniker(blob) {
	var len = blob.read_shift(4), start = blob.l;
	var extra = false;
	if(len > 24) {
		/* look ahead */
		blob.l += len - 24;
		if(blob.read_shift(16) === "795881f43b1d7f48af2c825dc4852763") extra = true;
		blob.l = start;
	}
	var url = blob.read_shift((extra?len-24:len)>>1, 'utf16le').replace(chr0,"");
	if(extra) blob.l += 24;
	return url;
}

/* [MS-OSHARED] 2.3.7.8 FileMoniker TODO: all fields */
function parse_FileMoniker(blob) {
	var cAnti = blob.read_shift(2);
	var preamble = ""; while(cAnti-- > 0) preamble += "../";
	var ansiPath = blob.read_shift(0, 'lpstr-ansi');
	blob.l += 2; //var endServer = blob.read_shift(2);
	if(blob.read_shift(2) != 0xDEAD) throw new Error("Bad FileMoniker");
	var sz = blob.read_shift(4);
	if(sz === 0) return preamble + ansiPath.replace(/\\/g,"/");
	var bytes = blob.read_shift(4);
	if(blob.read_shift(2) != 3) throw new Error("Bad FileMoniker");
	var unicodePath = blob.read_shift(bytes>>1, 'utf16le').replace(chr0,"");
	return preamble + unicodePath;
}

/* [MS-OSHARED] 2.3.7.2 HyperlinkMoniker TODO: all the monikers */
function parse_HyperlinkMoniker(blob, length) {
	var clsid = blob.read_shift(16); length -= 16;
	switch(clsid) {
		case "e0c9ea79f9bace118c8200aa004ba90b": return parse_URLMoniker(blob, length);
		case "0303000000000000c000000000000046": return parse_FileMoniker(blob, length);
		default: throw new Error("Unsupported Moniker " + clsid);
	}
}

/* [MS-OSHARED] 2.3.7.9 HyperlinkString */
function parse_HyperlinkString(blob) {
	var len = blob.read_shift(4);
	var o = len > 0 ? blob.read_shift(len, 'utf16le').replace(chr0, "") : "";
	return o;
}
function write_HyperlinkString(str, o) {
	if(!o) o = new_buf(6 + str.length * 2);
	o.write_shift(4, 1 + str.length);
	for(var i = 0; i < str.length; ++i) o.write_shift(2, str.charCodeAt(i));
	o.write_shift(2, 0);
	return o;
}

/* [MS-OSHARED] 2.3.7.1 Hyperlink Object */
function parse_Hyperlink(blob, length) {
	var end = blob.l + length;
	var sVer = blob.read_shift(4);
	if(sVer !== 2) throw new Error("Unrecognized streamVersion: " + sVer);
	var flags = blob.read_shift(2);
	blob.l += 2;
	var displayName, targetFrameName, moniker, oleMoniker, Loc="", guid, fileTime;
	if(flags & 0x0010) displayName = parse_HyperlinkString(blob, end - blob.l);
	if(flags & 0x0080) targetFrameName = parse_HyperlinkString(blob, end - blob.l);
	if((flags & 0x0101) === 0x0101) moniker = parse_HyperlinkString(blob, end - blob.l);
	if((flags & 0x0101) === 0x0001) oleMoniker = parse_HyperlinkMoniker(blob, end - blob.l);
	if(flags & 0x0008) Loc = parse_HyperlinkString(blob, end - blob.l);
	if(flags & 0x0020) guid = blob.read_shift(16);
	if(flags & 0x0040) fileTime = parse_FILETIME(blob/*, 8*/);
	blob.l = end;
	var target = targetFrameName||moniker||oleMoniker||"";
	if(target && Loc) target+="#"+Loc;
	if(!target) target = "#" + Loc;
	if((flags & 0x0002) && target.charAt(0) == "/" && target.charAt(1) != "/") target = "file://" + target;
	var out = ({Target:target});
	if(guid) out.guid = guid;
	if(fileTime) out.time = fileTime;
	if(displayName) out.Tooltip = displayName;
	return out;
}
function write_Hyperlink(hl) {
	var out = new_buf(512), i = 0;
	var Target = hl.Target;
	if(Target.slice(0,7) == "file://") Target = Target.slice(7);
	var hashidx = Target.indexOf("#");
	var F = hashidx > -1 ? 0x1f : 0x17;
	switch(Target.charAt(0)) { case "#": F=0x1c; break; case ".": F&=~2; break; }
	out.write_shift(4,2); out.write_shift(4, F);
	var data = [8,6815827,6619237,4849780,83]; for(i = 0; i < data.length; ++i) out.write_shift(4, data[i]);
	if(F == 0x1C) {
		Target = Target.slice(1);
		write_HyperlinkString(Target, out);
	} else if(F & 0x02) {
		data = "e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
		for(i = 0; i < data.length; ++i) out.write_shift(1, parseInt(data[i], 16));
		var Pretarget = hashidx > -1 ? Target.slice(0, hashidx) : Target;
		out.write_shift(4, 2*(Pretarget.length + 1));
		for(i = 0; i < Pretarget.length; ++i) out.write_shift(2, Pretarget.charCodeAt(i));
		out.write_shift(2, 0);
		if(F & 0x08) write_HyperlinkString(hashidx > -1 ? Target.slice(hashidx+1): "", out);
	} else {
		data = "03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" ");
		for(i = 0; i < data.length; ++i) out.write_shift(1, parseInt(data[i], 16));
		var P = 0;
		while(Target.slice(P*3,P*3+3)=="../"||Target.slice(P*3,P*3+3)=="..\\") ++P;
		out.write_shift(2, P);
		out.write_shift(4, Target.length - 3 * P + 1);
		for(i = 0; i < Target.length - 3 * P; ++i) out.write_shift(1, Target.charCodeAt(i + 3 * P) & 0xFF);
		out.write_shift(1, 0);
		out.write_shift(2, 0xFFFF);
		out.write_shift(2, 0xDEAD);
		for(i = 0; i < 6; ++i) out.write_shift(4, 0);
	}
	return out.slice(0, out.l);
}

/* 2.5.178 LongRGBA */
function parse_LongRGBA(blob) { var r = blob.read_shift(1), g = blob.read_shift(1), b = blob.read_shift(1), a = blob.read_shift(1); return [r,g,b,a]; }

/* 2.5.177 LongRGB */
function parse_LongRGB(blob, length) { var x = parse_LongRGBA(blob, length); x[3] = 0; return x; }


/* [MS-XLS] 2.5.19 */
function parse_XLSCell(blob) {
	var rw = blob.read_shift(2); // 0-indexed
	var col = blob.read_shift(2);
	var ixfe = blob.read_shift(2);
	return ({r:rw, c:col, ixfe:ixfe});
}
function write_XLSCell(R, C, ixfe, o) {
	if(!o) o = new_buf(6);
	o.write_shift(2, R);
	o.write_shift(2, C);
	o.write_shift(2, ixfe||0);
	return o;
}

/* [MS-XLS] 2.5.134 */
function parse_frtHeader(blob) {
	var rt = blob.read_shift(2);
	var flags = blob.read_shift(2); // TODO: parse these flags
	blob.l += 8;
	return {type: rt, flags: flags};
}



function parse_OptXLUnicodeString(blob, length, opts) { return length === 0 ? "" : parse_XLUnicodeString2(blob, length, opts); }

/* [MS-XLS] 2.5.344 */
function parse_XTI(blob, length, opts) {
	var w = opts.biff > 8 ? 4 : 2;
	var iSupBook = blob.read_shift(w), itabFirst = blob.read_shift(w,'i'), itabLast = blob.read_shift(w,'i');
	return [iSupBook, itabFirst, itabLast];
}

/* [MS-XLS] 2.5.218 */
function parse_RkRec(blob) {
	var ixfe = blob.read_shift(2);
	var RK = parse_RkNumber(blob);
	return [ixfe, RK];
}

/* [MS-XLS] 2.5.1 */
function parse_AddinUdf(blob, length, opts) {
	blob.l += 4; length -= 4;
	var l = blob.l + length;
	var udfName = parse_ShortXLUnicodeString(blob, length, opts);
	var cb = blob.read_shift(2);
	l -= blob.l;
	if(cb !== l) throw new Error("Malformed AddinUdf: padding = " + l + " != " + cb);
	blob.l += cb;
	return udfName;
}

/* [MS-XLS] 2.5.209 TODO: Check sizes */
function parse_Ref8U(blob) {
	var rwFirst = blob.read_shift(2);
	var rwLast = blob.read_shift(2);
	var colFirst = blob.read_shift(2);
	var colLast = blob.read_shift(2);
	return {s:{c:colFirst, r:rwFirst}, e:{c:colLast,r:rwLast}};
}
function write_Ref8U(r, o) {
	if(!o) o = new_buf(8);
	o.write_shift(2, r.s.r);
	o.write_shift(2, r.e.r);
	o.write_shift(2, r.s.c);
	o.write_shift(2, r.e.c);
	return o;
}

/* [MS-XLS] 2.5.211 */
function parse_RefU(blob) {
	var rwFirst = blob.read_shift(2);
	var rwLast = blob.read_shift(2);
	var colFirst = blob.read_shift(1);
	var colLast = blob.read_shift(1);
	return {s:{c:colFirst, r:rwFirst}, e:{c:colLast,r:rwLast}};
}

/* [MS-XLS] 2.5.207 */
var parse_Ref = parse_RefU;

/* [MS-XLS] 2.5.143 */
function parse_FtCmo(blob) {
	blob.l += 4;
	var ot = blob.read_shift(2);
	var id = blob.read_shift(2);
	var flags = blob.read_shift(2);
	blob.l+=12;
	return [id, ot, flags];
}

/* [MS-XLS] 2.5.149 */
function parse_FtNts(blob) {
	var out = {};
	blob.l += 4;
	blob.l += 16; // GUID TODO
	out.fSharedNote = blob.read_shift(2);
	blob.l += 4;
	return out;
}

/* [MS-XLS] 2.5.142 */
function parse_FtCf(blob) {
	var out = {};
	blob.l += 4;
	blob.cf = blob.read_shift(2);
	return out;
}

/* [MS-XLS] 2.5.140 - 2.5.154 and friends */
function parse_FtSkip(blob) { blob.l += 2; blob.l += blob.read_shift(2); }
var FtTab = {
0x00: parse_FtSkip,      /* FtEnd */
0x04: parse_FtSkip,      /* FtMacro */
0x05: parse_FtSkip,      /* FtButton */
0x06: parse_FtSkip,      /* FtGmo */
0x07: parse_FtCf,        /* FtCf */
0x08: parse_FtSkip,      /* FtPioGrbit */
0x09: parse_FtSkip,      /* FtPictFmla */
0x0A: parse_FtSkip,      /* FtCbls */
0x0B: parse_FtSkip,      /* FtRbo */
0x0C: parse_FtSkip,      /* FtSbs */
0x0D: parse_FtNts,       /* FtNts */
0x0E: parse_FtSkip,      /* FtSbsFmla */
0x0F: parse_FtSkip,      /* FtGboData */
0x10: parse_FtSkip,      /* FtEdoData */
0x11: parse_FtSkip,      /* FtRboData */
0x12: parse_FtSkip,      /* FtCblsData */
0x13: parse_FtSkip,      /* FtLbsData */
0x14: parse_FtSkip,      /* FtCblsFmla */
0x15: parse_FtCmo
};
function parse_FtArray(blob, length) {
	var tgt = blob.l + length;
	var fts = [];
	while(blob.l < tgt) {
		var ft = blob.read_shift(2);
		blob.l-=2;
		try {
			fts.push(FtTab[ft](blob, tgt - blob.l));
		} catch(e) { blob.l = tgt; return fts; }
	}
	if(blob.l != tgt) blob.l = tgt; //throw new Error("bad Object Ft-sequence");
	return fts;
}

/* --- 2.4 Records --- */

/* [MS-XLS] 2.4.21 */
function parse_BOF(blob, length) {
	var o = {BIFFVer:0, dt:0};
	o.BIFFVer = blob.read_shift(2); length -= 2;
	if(length >= 2) { o.dt = blob.read_shift(2); blob.l -= 2; }
	switch(o.BIFFVer) {
		case 0x0600: /* BIFF8 */
		case 0x0500: /* BIFF5 */
		case 0x0400: /* BIFF4 */
		case 0x0300: /* BIFF3 */
		case 0x0200: /* BIFF2 */
		case 0x0002: case 0x0007: /* BIFF2 */
			break;
		default: if(length > 6) throw new Error("Unexpected BIFF Ver " + o.BIFFVer);
	}

	blob.read_shift(length);
	return o;
}
function write_BOF(wb, t, o) {
	var h = 0x0600, w = 16;
	switch(o.bookType) {
		case 'biff8': break;
		case 'biff5': h = 0x0500; w = 8; break;
		case 'biff4': h = 0x0004; w = 6; break;
		case 'biff3': h = 0x0003; w = 6; break;
		case 'biff2': h = 0x0002; w = 4; break;
		case 'xla': break;
		default: throw new Error("unsupported BIFF version");
	}
	var out = new_buf(w);
	out.write_shift(2, h);
	out.write_shift(2, t);
	if(w > 4) out.write_shift(2, 0x7262);
	if(w > 6) out.write_shift(2, 0x07CD);
	if(w > 8) {
		out.write_shift(2, 0xC009);
		out.write_shift(2, 0x0001);
		out.write_shift(2, 0x0706);
		out.write_shift(2, 0x0000);
	}
	return out;
}


/* [MS-XLS] 2.4.146 */
function parse_InterfaceHdr(blob, length) {
	if(length === 0) return 0x04b0;
	if((blob.read_shift(2))!==0x04b0){/* empty */}
	return 0x04b0;
}


/* [MS-XLS] 2.4.349 */
function parse_WriteAccess(blob, length, opts) {
	if(opts.enc) { blob.l += length; return ""; }
	var l = blob.l;
	// TODO: make sure XLUnicodeString doesnt overrun
	var UserName = parse_XLUnicodeString2(blob, 0, opts);
	blob.read_shift(length + l - blob.l);
	return UserName;
}
function write_WriteAccess(s, opts) {
	var b8 = !opts || opts.biff == 8;
	var o = new_buf(b8 ? 112 : 54);
	o.write_shift(opts.biff == 8 ? 2 : 1, 7);
	if(b8) o.write_shift(1, 0);
	o.write_shift(4, 0x33336853);
	o.write_shift(4, (0x00534A74 | (b8 ? 0 : 0x20000000)));
	while(o.l < o.length) o.write_shift(1, (b8 ? 0 : 32));
	return o;
}

/* [MS-XLS] 2.4.351 */
function parse_WsBool(blob, length, opts) {
	var flags = opts && opts.biff == 8 || length == 2 ? blob.read_shift(2) : (blob.l += length, 0);
	return { fDialog: flags & 0x10, fBelow: flags & 0x40, fRight: flags & 0x80 };
}

/* [MS-XLS] 2.4.28 */
function parse_BoundSheet8(blob, length, opts) {
	var pos = blob.read_shift(4);
	var hidden = blob.read_shift(1) & 0x03;
	var dt = blob.read_shift(1);
	switch(dt) {
		case 0: dt = 'Worksheet'; break;
		case 1: dt = 'Macrosheet'; break;
		case 2: dt = 'Chartsheet'; break;
		case 6: dt = 'VBAModule'; break;
	}
	var name = parse_ShortXLUnicodeString(blob, 0, opts);
	if(name.length === 0) name = "Sheet1";
	return { pos:pos, hs:hidden, dt:dt, name:name };
}
function write_BoundSheet8(data, opts) {
	var w = (!opts || opts.biff >= 8 ? 2 : 1);
	var o = new_buf(8 + w * data.name.length);
	o.write_shift(4, data.pos);
	o.write_shift(1, data.hs || 0);
	o.write_shift(1, data.dt);
	o.write_shift(1, data.name.length);
	if(opts.biff >= 8) o.write_shift(1, 1);
	o.write_shift(w * data.name.length, data.name, opts.biff < 8 ? 'sbcs' : 'utf16le');
	var out = o.slice(0, o.l);
	out.l = o.l; return out;
}

/* [MS-XLS] 2.4.265 TODO */
function parse_SST(blob, length) {
	var end = blob.l + length;
	var cnt = blob.read_shift(4);
	var ucnt = blob.read_shift(4);
	var strs = ([]);
	for(var i = 0; i != ucnt && blob.l < end; ++i) {
		strs.push(parse_XLUnicodeRichExtendedString(blob));
	}
	strs.Count = cnt; strs.Unique = ucnt;
	return strs;
}
function write_SST(sst, opts) {
	var header = new_buf(8);
	header.write_shift(4, sst.Count);
	header.write_shift(4, sst.Unique);
	var strs = [];
	for(var j = 0; j < sst.length; ++j) strs[j] = write_XLUnicodeRichExtendedString(sst[j], opts);
	var o = bconcat([header].concat(strs));
o.parts = [header.length].concat(strs.map(function(str) { return str.length; }));
	return o;
}

/* [MS-XLS] 2.4.107 */
function parse_ExtSST(blob, length) {
	var extsst = {};
	extsst.dsst = blob.read_shift(2);
	blob.l += length-2;
	return extsst;
}


/* [MS-XLS] 2.4.221 TODO: check BIFF2-4 */
function parse_Row(blob) {
	var z = ({});
	z.r = blob.read_shift(2);
	z.c = blob.read_shift(2);
	z.cnt = blob.read_shift(2) - z.c;
	var miyRw = blob.read_shift(2);
	blob.l += 4; // reserved(2), unused(2)
	var flags = blob.read_shift(1); // various flags
	blob.l += 3; // reserved(8), ixfe(12), flags(4)
	if(flags & 0x07) z.level = flags & 0x07;
	// collapsed: flags & 0x10
	if(flags & 0x20) z.hidden = true;
	if(flags & 0x40) z.hpt = miyRw / 20;
	return z;
}


/* [MS-XLS] 2.4.125 */
function parse_ForceFullCalculation(blob) {
	var header = parse_frtHeader(blob);
	if(header.type != 0x08A3) throw new Error("Invalid Future Record " + header.type);
	var fullcalc = blob.read_shift(4);
	return fullcalc !== 0x0;
}





/* [MS-XLS] 2.4.215 rt */
function parse_RecalcId(blob) {
	blob.read_shift(2);
	return blob.read_shift(4);
}

/* [MS-XLS] 2.4.87 */
function parse_DefaultRowHeight(blob, length, opts) {
	var f = 0;
	if(!(opts && opts.biff == 2)) {
		f = blob.read_shift(2);
	}
	var miyRw = blob.read_shift(2);
	if((opts && opts.biff == 2)) {
		f = 1 - (miyRw >> 15); miyRw &= 0x7fff;
	}
	var fl = {Unsynced:f&1,DyZero:(f&2)>>1,ExAsc:(f&4)>>2,ExDsc:(f&8)>>3};
	return [fl, miyRw];
}

/* [MS-XLS] 2.4.345 TODO */
function parse_Window1(blob) {
	var xWn = blob.read_shift(2), yWn = blob.read_shift(2), dxWn = blob.read_shift(2), dyWn = blob.read_shift(2);
	var flags = blob.read_shift(2), iTabCur = blob.read_shift(2), iTabFirst = blob.read_shift(2);
	var ctabSel = blob.read_shift(2), wTabRatio = blob.read_shift(2);
	return { Pos: [xWn, yWn], Dim: [dxWn, dyWn], Flags: flags, CurTab: iTabCur,
		FirstTab: iTabFirst, Selected: ctabSel, TabRatio: wTabRatio };
}
function write_Window1() {
	var o = new_buf(18);
	o.write_shift(2, 0);
	o.write_shift(2, 0);
	o.write_shift(2, 0x7260);
	o.write_shift(2, 0x44c0);
	o.write_shift(2, 0x38);
	o.write_shift(2, 0);
	o.write_shift(2, 0);
	o.write_shift(2, 1);
	o.write_shift(2, 0x01f4);
	return o;
}
/* [MS-XLS] 2.4.346 TODO */
function parse_Window2(blob, length, opts) {
	if(opts && opts.biff >= 2 && opts.biff < 5) return {};
	var f = blob.read_shift(2);
	return { RTL: f & 0x40 };
}
function write_Window2(view) {
	var o = new_buf(18), f = 0x6b6;
	if(view && view.RTL) f |= 0x40;
	o.write_shift(2, f);
	o.write_shift(4, 0);
	o.write_shift(4, 64);
	o.write_shift(4, 0);
	o.write_shift(4, 0);
	return o;
}

/* [MS-XLS] 2.4.189 TODO */
function parse_Pane(/*blob, length, opts*/) {
}

/* [MS-XLS] 2.4.122 TODO */
function parse_Font(blob, length, opts) {
	var o = {
		dyHeight: blob.read_shift(2),
		fl: blob.read_shift(2)
	};
	switch((opts && opts.biff) || 8) {
		case 2: break;
		case 3: case 4: blob.l += 2; break;
		default: blob.l += 10; break;
	}
	o.name = parse_ShortXLUnicodeString(blob, 0, opts);
	return o;
}
function write_Font(data, opts) {
	var name = data.name || "Arial";
	var b5 = (opts && (opts.biff == 5)), w = (b5 ? (15 + name.length) : (16 + 2 * name.length));
	var o = new_buf(w);
	o.write_shift(2, (data.sz || 12) * 20);
	o.write_shift(4, 0);
	o.write_shift(2, 400);
	o.write_shift(4, 0);
	o.write_shift(2, 0);
	o.write_shift(1, name.length);
	if(!b5) o.write_shift(1, 1);
	o.write_shift((b5 ? 1 : 2) * name.length, name, (b5 ? "sbcs" : "utf16le"));
	return o;
}

/* [MS-XLS] 2.4.149 */
function parse_LabelSst(blob) {
	var cell = parse_XLSCell(blob);
	cell.isst = blob.read_shift(4);
	return cell;
}
function write_LabelSst(R, C, v, os ) {
	var o = new_buf(10);
	write_XLSCell(R, C, os, o);
	o.write_shift(4, v);
	return o;
}

/* [MS-XLS] 2.4.148 */
function parse_Label(blob, length, opts) {
	if(opts.biffguess && opts.biff == 2) opts.biff = 5;
	var target = blob.l + length;
	var cell = parse_XLSCell(blob, 6);
	if(opts.biff == 2) blob.l++;
	var str = parse_XLUnicodeString(blob, target - blob.l, opts);
	cell.val = str;
	return cell;
}
function write_Label(R, C, v, os, opts) {
	var b8 = !opts || opts.biff == 8;
	var o = new_buf(6 + 2 + (+b8) + (1 + b8) * v.length);
	write_XLSCell(R, C, os, o);
	o.write_shift(2, v.length);
	if(b8) o.write_shift(1, 1);
	o.write_shift((1 + b8) * v.length, v, b8 ? 'utf16le' : 'sbcs');
	return o;
}


/* [MS-XLS] 2.4.126 Number Formats */
function parse_Format(blob, length, opts) {
	var numFmtId = blob.read_shift(2);
	var fmtstr = parse_XLUnicodeString2(blob, 0, opts);
	return [numFmtId, fmtstr];
}
function write_Format(i, f, opts, o) {
	var b5 = (opts && (opts.biff == 5));
	if(!o) o = new_buf(b5 ? (3 + f.length) : (5 + 2 * f.length));
	o.write_shift(2, i);
	o.write_shift((b5 ? 1 : 2), f.length);
	if(!b5) o.write_shift(1, 1);
	o.write_shift((b5 ? 1 : 2) * f.length, f, (b5 ? 'sbcs' : 'utf16le'));
	var out = (o.length > o.l) ? o.slice(0, o.l) : o;
	if(out.l == null) out.l = out.length;
	return out;
}
var parse_BIFF2Format = parse_XLUnicodeString2;

/* [MS-XLS] 2.4.90 */
function parse_Dimensions(blob, length, opts) {
	var end = blob.l + length;
	var w = opts.biff == 8 || !opts.biff ? 4 : 2;
	var r = blob.read_shift(w), R = blob.read_shift(w);
	var c = blob.read_shift(2), C = blob.read_shift(2);
	blob.l = end;
	return {s: {r:r, c:c}, e: {r:R, c:C}};
}
function write_Dimensions(range, opts) {
	var w = opts.biff == 8 || !opts.biff ? 4 : 2;
	var o = new_buf(2*w + 6);
	o.write_shift(w, range.s.r);
	o.write_shift(w, range.e.r + 1);
	o.write_shift(2, range.s.c);
	o.write_shift(2, range.e.c + 1);
	o.write_shift(2, 0);
	return o;
}

/* [MS-XLS] 2.4.220 */
function parse_RK(blob) {
	var rw = blob.read_shift(2), col = blob.read_shift(2);
	var rkrec = parse_RkRec(blob);
	return {r:rw, c:col, ixfe:rkrec[0], rknum:rkrec[1]};
}

/* [MS-XLS] 2.4.175 */
function parse_MulRk(blob, length) {
	var target = blob.l + length - 2;
	var rw = blob.read_shift(2), col = blob.read_shift(2);
	var rkrecs = [];
	while(blob.l < target) rkrecs.push(parse_RkRec(blob));
	if(blob.l !== target) throw new Error("MulRK read error");
	var lastcol = blob.read_shift(2);
	if(rkrecs.length != lastcol - col + 1) throw new Error("MulRK length mismatch");
	return {r:rw, c:col, C:lastcol, rkrec:rkrecs};
}
/* [MS-XLS] 2.4.174 */
function parse_MulBlank(blob, length) {
	var target = blob.l + length - 2;
	var rw = blob.read_shift(2), col = blob.read_shift(2);
	var ixfes = [];
	while(blob.l < target) ixfes.push(blob.read_shift(2));
	if(blob.l !== target) throw new Error("MulBlank read error");
	var lastcol = blob.read_shift(2);
	if(ixfes.length != lastcol - col + 1) throw new Error("MulBlank length mismatch");
	return {r:rw, c:col, C:lastcol, ixfe:ixfes};
}

/* [MS-XLS] 2.5.20 2.5.249 TODO: interpret values here */
function parse_CellStyleXF(blob, length, style, opts) {
	var o = {};
	var a = blob.read_shift(4), b = blob.read_shift(4);
	var c = blob.read_shift(4), d = blob.read_shift(2);
	o.patternType = XLSFillPattern[c >> 26];

	if(!opts.cellStyles) return o;
	o.alc = a & 0x07;
	o.fWrap = (a >> 3) & 0x01;
	o.alcV = (a >> 4) & 0x07;
	o.fJustLast = (a >> 7) & 0x01;
	o.trot = (a >> 8) & 0xFF;
	o.cIndent = (a >> 16) & 0x0F;
	o.fShrinkToFit = (a >> 20) & 0x01;
	o.iReadOrder = (a >> 22) & 0x02;
	o.fAtrNum = (a >> 26) & 0x01;
	o.fAtrFnt = (a >> 27) & 0x01;
	o.fAtrAlc = (a >> 28) & 0x01;
	o.fAtrBdr = (a >> 29) & 0x01;
	o.fAtrPat = (a >> 30) & 0x01;
	o.fAtrProt = (a >> 31) & 0x01;

	o.dgLeft = b & 0x0F;
	o.dgRight = (b >> 4) & 0x0F;
	o.dgTop = (b >> 8) & 0x0F;
	o.dgBottom = (b >> 12) & 0x0F;
	o.icvLeft = (b >> 16) & 0x7F;
	o.icvRight = (b >> 23) & 0x7F;
	o.grbitDiag = (b >> 30) & 0x03;

	o.icvTop = c & 0x7F;
	o.icvBottom = (c >> 7) & 0x7F;
	o.icvDiag = (c >> 14) & 0x7F;
	o.dgDiag = (c >> 21) & 0x0F;

	o.icvFore = d & 0x7F;
	o.icvBack = (d >> 7) & 0x7F;
	o.fsxButton = (d >> 14) & 0x01;
	return o;
}
//function parse_CellXF(blob, length, opts) {return parse_CellStyleXF(blob,length,0, opts);}
//function parse_StyleXF(blob, length, opts) {return parse_CellStyleXF(blob,length,1, opts);}

/* [MS-XLS] 2.4.353 TODO: actually do this right */
function parse_XF(blob, length, opts) {
	var o = {};
	o.ifnt = blob.read_shift(2); o.numFmtId = blob.read_shift(2); o.flags = blob.read_shift(2);
	o.fStyle = (o.flags >> 2) & 0x01;
	length -= 6;
	o.data = parse_CellStyleXF(blob, length, o.fStyle, opts);
	return o;
}
function write_XF(data, ixfeP, opts, o) {
	var b5 = (opts && (opts.biff == 5));
	if(!o) o = new_buf(b5 ? 16 : 20);
	o.write_shift(2, 0);
	if(data.style) {
		o.write_shift(2, (data.numFmtId||0));
		o.write_shift(2, 0xFFF4);
	} else {
		o.write_shift(2, (data.numFmtId||0));
		o.write_shift(2, (ixfeP<<4));
	}
	var f = 0;
	if(data.numFmtId > 0 && b5) f |= 0x0400;
	o.write_shift(4, f);
	o.write_shift(4, 0);
	if(!b5) o.write_shift(4, 0);
	o.write_shift(2, 0);
	return o;
}

/* [MS-XLS] 2.4.134 */
function parse_Guts(blob) {
	blob.l += 4;
	var out = [blob.read_shift(2), blob.read_shift(2)];
	if(out[0] !== 0) out[0]--;
	if(out[1] !== 0) out[1]--;
	if(out[0] > 7 || out[1] > 7) throw new Error("Bad Gutters: " + out.join("|"));
	return out;
}
function write_Guts(guts) {
	var o = new_buf(8);
	o.write_shift(4, 0);
	o.write_shift(2, guts[0] ? guts[0] + 1 : 0);
	o.write_shift(2, guts[1] ? guts[1] + 1 : 0);
	return o;
}

/* [MS-XLS] 2.4.24 */
function parse_BoolErr(blob, length, opts) {
	var cell = parse_XLSCell(blob, 6);
	if(opts.biff == 2 || length == 9) ++blob.l;
	var val = parse_Bes(blob, 2);
	cell.val = val;
	cell.t = (val === true || val === false) ? 'b' : 'e';
	return cell;
}
function write_BoolErr(R, C, v, os, opts, t) {
	var o = new_buf(8);
	write_XLSCell(R, C, os, o);
	write_Bes(v, t, o);
	return o;
}

/* [MS-XLS] 2.4.180 Number */
function parse_Number(blob, length, opts) {
	if(opts.biffguess && opts.biff == 2) opts.biff = 5;
	var cell = parse_XLSCell(blob, 6);
	var xnum = parse_Xnum(blob, 8);
	cell.val = xnum;
	return cell;
}
function write_Number(R, C, v, os) {
	var o = new_buf(14);
	write_XLSCell(R, C, os, o);
	write_Xnum(v, o);
	return o;
}

var parse_XLHeaderFooter = parse_OptXLUnicodeString; // TODO: parse 2.4.136

/* [MS-XLS] 2.4.271 */
function parse_SupBook(blob, length, opts) {
	var end = blob.l + length;
	var ctab = blob.read_shift(2);
	var cch = blob.read_shift(2);
	opts.sbcch = cch;
	if(cch == 0x0401 || cch == 0x3A01) return [cch, ctab];
	if(cch < 0x01 || cch >0xff) throw new Error("Unexpected SupBook type: "+cch);
	var virtPath = parse_XLUnicodeStringNoCch(blob, cch);
	/* TODO: 2.5.277 Virtual Path */
	var rgst = [];
	while(end > blob.l) rgst.push(parse_XLUnicodeString(blob));
	return [cch, ctab, virtPath, rgst];
}

/* [MS-XLS] 2.4.105 TODO */
function parse_ExternName(blob, length, opts) {
	var flags = blob.read_shift(2);
	var body;
	var o = ({
		fBuiltIn: flags & 0x01,
		fWantAdvise: (flags >>> 1) & 0x01,
		fWantPict: (flags >>> 2) & 0x01,
		fOle: (flags >>> 3) & 0x01,
		fOleLink: (flags >>> 4) & 0x01,
		cf: (flags >>> 5) & 0x3FF,
		fIcon: flags >>> 15 & 0x01
	});
	if(opts.sbcch === 0x3A01) body = parse_AddinUdf(blob, length-2, opts);
	//else throw new Error("unsupported SupBook cch: " + opts.sbcch);
	o.body = body || blob.read_shift(length-2);
	if(typeof body === "string") o.Name = body;
	return o;
}

/* [MS-XLS] 2.4.150 TODO */
function parse_Lbl(blob, length, opts) {
	var target = blob.l + length;
	var flags = blob.read_shift(2);
	var chKey = blob.read_shift(1);
	var cch = blob.read_shift(1);
	var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	var itab = 0;
	if(!opts || opts.biff >= 5) {
		if(opts.biff != 5) blob.l += 2;
		itab = blob.read_shift(2);
		if(opts.biff == 5) blob.l += 2;
		blob.l += 4;
	}
	var name = parse_XLUnicodeStringNoCch(blob, cch, opts);
	if(flags & 0x20) name = XLSLblBuiltIn[name.charCodeAt(0)];
	var npflen = target - blob.l; if(opts && opts.biff == 2) --npflen;
	/*jshint -W018 */
	var rgce = (target == blob.l || cce === 0 || !(npflen > 0)) ? [] : parse_NameParsedFormula(blob, npflen, opts, cce);
	/*jshint +W018 */
	return {
		chKey: chKey,
		Name: name,
		itab: itab,
		rgce: rgce
	};
}

/* [MS-XLS] 2.4.106 TODO: verify filename encoding */
function parse_ExternSheet(blob, length, opts) {
	if(opts.biff < 8) return parse_BIFF5ExternSheet(blob, length, opts);
	var o = [], target = blob.l + length, len = blob.read_shift(opts.biff > 8 ? 4 : 2);
	while(len-- !== 0) o.push(parse_XTI(blob, opts.biff > 8 ? 12 : 6, opts));
		// [iSupBook, itabFirst, itabLast];
	if(blob.l != target) throw new Error("Bad ExternSheet: " + blob.l + " != " + target);
	return o;
}
function parse_BIFF5ExternSheet(blob, length, opts) {
	if(blob[blob.l + 1] == 0x03) blob[blob.l]++;
	var o = parse_ShortXLUnicodeString(blob, length, opts);
	return o.charCodeAt(0) == 0x03 ? o.slice(1) : o;
}

/* [MS-XLS] 2.4.176 TODO: check older biff */
function parse_NameCmt(blob, length, opts) {
	if(opts.biff < 8) { blob.l += length; return; }
	var cchName = blob.read_shift(2);
	var cchComment = blob.read_shift(2);
	var name = parse_XLUnicodeStringNoCch(blob, cchName, opts);
	var comment = parse_XLUnicodeStringNoCch(blob, cchComment, opts);
	return [name, comment];
}

/* [MS-XLS] 2.4.260 */
function parse_ShrFmla(blob, length, opts) {
	var ref = parse_RefU(blob, 6);
	blob.l++;
	var cUse = blob.read_shift(1);
	length -= 8;
	return [parse_SharedParsedFormula(blob, length, opts), cUse, ref];
}

/* [MS-XLS] 2.4.4 TODO */
function parse_Array(blob, length, opts) {
	var ref = parse_Ref(blob, 6);
	/* TODO: fAlwaysCalc */
	switch(opts.biff) {
		case 2: blob.l ++; length -= 7; break;
		case 3: case 4: blob.l += 2; length -= 8; break;
		default: blob.l += 6; length -= 12;
	}
	return [ref, parse_ArrayParsedFormula(blob, length, opts, ref)];
}

/* [MS-XLS] 2.4.173 */
function parse_MTRSettings(blob) {
	var fMTREnabled = blob.read_shift(4) !== 0x00;
	var fUserSetThreadCount = blob.read_shift(4) !== 0x00;
	var cUserThreadCount = blob.read_shift(4);
	return [fMTREnabled, fUserSetThreadCount, cUserThreadCount];
}

/* [MS-XLS] 2.5.186 TODO: BIFF5 */
function parse_NoteSh(blob, length, opts) {
	if(opts.biff < 8) return;
	var row = blob.read_shift(2), col = blob.read_shift(2);
	var flags = blob.read_shift(2), idObj = blob.read_shift(2);
	var stAuthor = parse_XLUnicodeString2(blob, 0, opts);
	if(opts.biff < 8) blob.read_shift(1);
	return [{r:row,c:col}, stAuthor, idObj, flags];
}

/* [MS-XLS] 2.4.179 */
function parse_Note(blob, length, opts) {
	/* TODO: Support revisions */
	return parse_NoteSh(blob, length, opts);
}

/* [MS-XLS] 2.4.168 */
function parse_MergeCells(blob, length) {
	var merges = [];
	var cmcs = blob.read_shift(2);
	while (cmcs--) merges.push(parse_Ref8U(blob,length));
	return merges;
}
function write_MergeCells(merges) {
	var o = new_buf(2 + merges.length * 8);
	o.write_shift(2, merges.length);
	for(var i = 0; i < merges.length; ++i) write_Ref8U(merges[i], o);
	return o;
}

/* [MS-XLS] 2.4.181 TODO: parse all the things! */
function parse_Obj(blob, length, opts) {
	if(opts && opts.biff < 8) return parse_BIFF5Obj(blob, length, opts);
	var cmo = parse_FtCmo(blob, 22); // id, ot, flags
	var fts = parse_FtArray(blob, length-22, cmo[1]);
	return { cmo: cmo, ft:fts };
}
/* from older spec */
var parse_BIFF5OT = {
0x08: function(blob, length) {
	var tgt = blob.l + length;
	blob.l += 10; // todo
	var cf = blob.read_shift(2);
	blob.l += 4;
	blob.l += 2; //var cbPictFmla = blob.read_shift(2);
	blob.l += 2;
	blob.l += 2; //var grbit = blob.read_shift(2);
	blob.l += 4;
	var cchName = blob.read_shift(1);
	blob.l += cchName; // TODO: stName
	blob.l = tgt; // TODO: fmla
	return { fmt:cf };
}
};

function parse_BIFF5Obj(blob, length, opts) {
	blob.l += 4; //var cnt = blob.read_shift(4);
	var ot = blob.read_shift(2);
	var id = blob.read_shift(2);
	var grbit = blob.read_shift(2);
	blob.l += 2; //var colL = blob.read_shift(2);
	blob.l += 2; //var dxL = blob.read_shift(2);
	blob.l += 2; //var rwT = blob.read_shift(2);
	blob.l += 2; //var dyT = blob.read_shift(2);
	blob.l += 2; //var colR = blob.read_shift(2);
	blob.l += 2; //var dxR = blob.read_shift(2);
	blob.l += 2; //var rwB = blob.read_shift(2);
	blob.l += 2; //var dyB = blob.read_shift(2);
	blob.l += 2; //var cbMacro = blob.read_shift(2);
	blob.l += 6;
	length -= 36;
	var fts = [];
	fts.push((parse_BIFF5OT[ot]||parsenoop)(blob, length, opts));
	return { cmo: [id, ot, grbit], ft:fts };
}

/* [MS-XLS] 2.4.329 TODO: parse properly */
function parse_TxO(blob, length, opts) {
	var s = blob.l;
	var texts = "";
try {
	blob.l += 4;
	var ot = (opts.lastobj||{cmo:[0,0]}).cmo[1];
	var controlInfo; // eslint-disable-line no-unused-vars
	if([0,5,7,11,12,14].indexOf(ot) == -1) blob.l += 6;
	else controlInfo = parse_ControlInfo(blob, 6, opts); // eslint-disable-line no-unused-vars
	var cchText = blob.read_shift(2);
	/*var cbRuns = */blob.read_shift(2);
	/*var ifntEmpty = */parseuint16(blob, 2);
	var len = blob.read_shift(2);
	blob.l += len;
	//var fmla = parse_ObjFmla(blob, s + length - blob.l);

	for(var i = 1; i < blob.lens.length-1; ++i) {
		if(blob.l-s != blob.lens[i]) throw new Error("TxO: bad continue record");
		var hdr = blob[blob.l];
		var t = parse_XLUnicodeStringNoCch(blob, blob.lens[i+1]-blob.lens[i]-1);
		texts += t;
		if(texts.length >= (hdr ? cchText : 2*cchText)) break;
	}
	if(texts.length !== cchText && texts.length !== cchText*2) {
		throw new Error("cchText: " + cchText + " != " + texts.length);
	}

	blob.l = s + length;
	/* [MS-XLS] 2.5.272 TxORuns */
//	var rgTxoRuns = [];
//	for(var j = 0; j != cbRuns/8-1; ++j) blob.l += 8;
//	var cchText2 = blob.read_shift(2);
//	if(cchText2 !== cchText) throw new Error("TxOLastRun mismatch: " + cchText2 + " " + cchText);
//	blob.l += 6;
//	if(s + length != blob.l) throw new Error("TxO " + (s + length) + ", at " + blob.l);
	return { t: texts };
} catch(e) { blob.l = s + length; return { t: texts }; }
}

/* [MS-XLS] 2.4.140 */
function parse_HLink(blob, length) {
	var ref = parse_Ref8U(blob, 8);
	blob.l += 16; /* CLSID */
	var hlink = parse_Hyperlink(blob, length-24);
	return [ref, hlink];
}
function write_HLink(hl) {
	var O = new_buf(24);
	var ref = decode_cell(hl[0]);
	O.write_shift(2, ref.r); O.write_shift(2, ref.r);
	O.write_shift(2, ref.c); O.write_shift(2, ref.c);
	var clsid = "d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
	for(var i = 0; i < 16; ++i) O.write_shift(1, parseInt(clsid[i], 16));
	return bconcat([O, write_Hyperlink(hl[1])]);
}


/* [MS-XLS] 2.4.141 */
function parse_HLinkTooltip(blob, length) {
	blob.read_shift(2);
	var ref = parse_Ref8U(blob, 8);
	var wzTooltip = blob.read_shift((length-10)/2, 'dbcs-cont');
	wzTooltip = wzTooltip.replace(chr0,"");
	return [ref, wzTooltip];
}
function write_HLinkTooltip(hl) {
	var TT = hl[1].Tooltip;
	var O = new_buf(10 + 2 * (TT.length + 1));
	O.write_shift(2, 0x0800);
	var ref = decode_cell(hl[0]);
	O.write_shift(2, ref.r); O.write_shift(2, ref.r);
	O.write_shift(2, ref.c); O.write_shift(2, ref.c);
	for(var i = 0; i < TT.length; ++i) O.write_shift(2, TT.charCodeAt(i));
	O.write_shift(2, 0);
	return O;
}

/* [MS-XLS] 2.4.63 */
function parse_Country(blob) {
	var o = [0,0], d;
	d = blob.read_shift(2); o[0] = CountryEnum[d] || d;
	d = blob.read_shift(2); o[1] = CountryEnum[d] || d;
	return o;
}
function write_Country(o) {
	if(!o) o = new_buf(4);
	o.write_shift(2, 0x01);
	o.write_shift(2, 0x01);
	return o;
}

/* [MS-XLS] 2.4.50 ClrtClient */
function parse_ClrtClient(blob) {
	var ccv = blob.read_shift(2);
	var o = [];
	while(ccv-->0) o.push(parse_LongRGB(blob, 8));
	return o;
}

/* [MS-XLS] 2.4.188 */
function parse_Palette(blob) {
	var ccv = blob.read_shift(2);
	var o = [];
	while(ccv-->0) o.push(parse_LongRGB(blob, 8));
	return o;
}

/* [MS-XLS] 2.4.354 */
function parse_XFCRC(blob) {
	blob.l += 2;
	var o = {cxfs:0, crc:0};
	o.cxfs = blob.read_shift(2);
	o.crc = blob.read_shift(4);
	return o;
}

/* [MS-XLS] 2.4.53 TODO: parse flags */
/* [MS-XLSB] 2.4.323 TODO: parse flags */
function parse_ColInfo(blob, length, opts) {
	if(!opts.cellStyles) return parsenoop(blob, length);
	var w = opts && opts.biff >= 12 ? 4 : 2;
	var colFirst = blob.read_shift(w);
	var colLast = blob.read_shift(w);
	var coldx = blob.read_shift(w);
	var ixfe = blob.read_shift(w);
	var flags = blob.read_shift(2);
	if(w == 2) blob.l += 2;
	var o = ({s:colFirst, e:colLast, w:coldx, ixfe:ixfe, flags:flags});
	if(opts.biff >= 5 || !opts.biff) o.level = (flags >> 8) & 0x7;
	return o;
}
function write_ColInfo(col, idx) {
	var o = new_buf(12);
	o.write_shift(2, idx);
	o.write_shift(2, idx);
	o.write_shift(2, col.width * 256);
	o.write_shift(2, 0);
	var f = 0;
	if(col.hidden) f |= 1;
	o.write_shift(1, f);
	f = col.level || 0;
	o.write_shift(1, f);
	o.write_shift(2, 0);
	return o;
}

/* [MS-XLS] 2.4.257 */
function parse_Setup(blob, length) {
	var o = {};
	if(length < 32) return o;
	blob.l += 16;
	o.header = parse_Xnum(blob, 8);
	o.footer = parse_Xnum(blob, 8);
	blob.l += 2;
	return o;
}

/* [MS-XLS] 2.4.261 */
function parse_ShtProps(blob, length, opts) {
	var def = {area:false};
	if(opts.biff != 5) { blob.l += length; return def; }
	var d = blob.read_shift(1); blob.l += 3;
	if((d & 0x10)) def.area = true;
	return def;
}

/* [MS-XLS] 2.4.241 */
function write_RRTabId(n) {
	var out = new_buf(2 * n);
	for(var i = 0; i < n; ++i) out.write_shift(2, i+1);
	return out;
}

var parse_Blank = parse_XLSCell; /* [MS-XLS] 2.4.20 Just the cell */
var parse_Scl = parseuint16a; /* [MS-XLS] 2.4.247 num, den */
var parse_String = parse_XLUnicodeString; /* [MS-XLS] 2.4.268 */

/* --- Specific to versions before BIFF8 --- */
function parse_ImData(blob) {
	var cf = blob.read_shift(2);
	var env = blob.read_shift(2);
	var lcb = blob.read_shift(4);
	var o = {fmt:cf, env:env, len:lcb, data:blob.slice(blob.l,blob.l+lcb)};
	blob.l += lcb;
	return o;
}

/* BIFF2_??? where ??? is the name from [XLS] */
function parse_BIFF2STR(blob, length, opts) {
	if(opts.biffguess && opts.biff == 5) opts.biff = 2;
	var cell = parse_XLSCell(blob, 6);
	++blob.l;
	var str = parse_XLUnicodeString2(blob, length-7, opts);
	cell.t = 'str';
	cell.val = str;
	return cell;
}

function parse_BIFF2NUM(blob) {
	var cell = parse_XLSCell(blob, 6);
	++blob.l;
	var num = parse_Xnum(blob, 8);
	cell.t = 'n';
	cell.val = num;
	return cell;
}
function write_BIFF2NUM(r, c, val) {
	var out = new_buf(15);
	write_BIFF2Cell(out, r, c);
	out.write_shift(8, val, 'f');
	return out;
}

function parse_BIFF2INT(blob) {
	var cell = parse_XLSCell(blob, 6);
	++blob.l;
	var num = blob.read_shift(2);
	cell.t = 'n';
	cell.val = num;
	return cell;
}
function write_BIFF2INT(r, c, val) {
	var out = new_buf(9);
	write_BIFF2Cell(out, r, c);
	out.write_shift(2, val);
	return out;
}

function parse_BIFF2STRING(blob) {
	var cch = blob.read_shift(1);
	if(cch === 0) { blob.l++; return ""; }
	return blob.read_shift(cch, 'sbcs-cont');
}

/* TODO: convert to BIFF8 font struct */
function parse_BIFF2FONTXTRA(blob, length) {
	blob.l += 6; // unknown
	blob.l += 2; // font weight "bls"
	blob.l += 1; // charset
	blob.l += 3; // unknown
	blob.l += 1; // font family
	blob.l += length - 13;
}

/* TODO: parse rich text runs */
function parse_RString(blob, length, opts) {
	var end = blob.l + length;
	var cell = parse_XLSCell(blob, 6);
	var cch = blob.read_shift(2);
	var str = parse_XLUnicodeStringNoCch(blob, cch, opts);
	blob.l = end;
	cell.t = 'str';
	cell.val = str;
	return cell;
}
var DBF_SUPPORTED_VERSIONS = [0x02, 0x03, 0x30, 0x31, 0x83, 0x8B, 0x8C, 0xF5];
var DBF = (function() {
var dbf_codepage_map = {
	/* Code Pages Supported by Visual FoxPro */
0x01:   437,           0x02:   850,
0x03:  1252,           0x04: 10000,
0x64:   852,           0x65:   866,
0x66:   865,           0x67:   861,
0x68:   895,           0x69:   620,
0x6A:   737,           0x6B:   857,
0x78:   950,           0x79:   949,
0x7A:   936,           0x7B:   932,
0x7C:   874,           0x7D:  1255,
0x7E:  1256,           0x96: 10007,
0x97: 10029,           0x98: 10006,
0xC8:  1250,           0xC9:  1251,
0xCA:  1254,           0xCB:  1253,

	/* shapefile DBF extension */
0x00: 20127,           0x08:   865,
0x09:   437,           0x0A:   850,
0x0B:   437,           0x0D:   437,
0x0E:   850,           0x0F:   437,
0x10:   850,           0x11:   437,
0x12:   850,           0x13:   932,
0x14:   850,           0x15:   437,
0x16:   850,           0x17:   865,
0x18:   437,           0x19:   437,
0x1A:   850,           0x1B:   437,
0x1C:   863,           0x1D:   850,
0x1F:   852,           0x22:   852,
0x23:   852,           0x24:   860,
0x25:   850,           0x26:   866,
0x37:   850,           0x40:   852,
0x4D:   936,           0x4E:   949,
0x4F:   950,           0x50:   874,
0x57:  1252,           0x58:  1252,
0x59:  1252,           0x6C:   863,
0x86:   737,           0x87:   852,
0x88:   857,           0xCC:  1257,

0xFF: 16969
};
var dbf_reverse_map = evert({
0x01:   437,           0x02:   850,
0x03:  1252,           0x04: 10000,
0x64:   852,           0x65:   866,
0x66:   865,           0x67:   861,
0x68:   895,           0x69:   620,
0x6A:   737,           0x6B:   857,
0x78:   950,           0x79:   949,
0x7A:   936,           0x7B:   932,
0x7C:   874,           0x7D:  1255,
0x7E:  1256,           0x96: 10007,
0x97: 10029,           0x98: 10006,
0xC8:  1250,           0xC9:  1251,
0xCA:  1254,           0xCB:  1253,
0x00: 20127
});
/* TODO: find an actual specification */
function dbf_to_aoa(buf, opts) {
	var out = [];
	var d = (new_raw_buf(1));
	switch(opts.type) {
		case 'base64': d = s2a(Base64_decode(buf)); break;
		case 'binary': d = s2a(buf); break;
		case 'buffer':
		case 'array': d = buf; break;
	}
	prep_blob(d, 0);

	/* header */
	var ft = d.read_shift(1);
	var memo = !!(ft & 0x88);
	var vfp = false, l7 = false;
	switch(ft) {
		case 0x02: break; // dBASE II
		case 0x03: break; // dBASE III
		case 0x30: vfp = true; memo = true; break; // VFP
		case 0x31: vfp = true; memo = true; break; // VFP with autoincrement
		// 0x43 dBASE IV SQL table files
		// 0x63 dBASE IV SQL system files
		case 0x83: break; // dBASE III with memo
		case 0x8B: break; // dBASE IV with memo
		case 0x8C: l7 = true; break; // dBASE Level 7 with memo
		// case 0xCB dBASE IV SQL table files with memo
		case 0xF5: break; // FoxPro 2.x with memo
		// case 0xFB FoxBASE
		default: throw new Error("DBF Unsupported Version: " + ft.toString(16));
	}

	var nrow = 0, fpos = 0x0209;
	if(ft == 0x02) nrow = d.read_shift(2);
	d.l += 3; // dBASE II stores DDMMYY date, others use YYMMDD
	if(ft != 0x02) nrow = d.read_shift(4);
	if(nrow > 1048576) nrow = 1e6;

	if(ft != 0x02) fpos = d.read_shift(2); // header length
	var rlen = d.read_shift(2); // record length

	var /*flags = 0,*/ current_cp = opts.codepage || 1252;
	if(ft != 0x02) { // 20 reserved bytes
		d.l+=16;
		/*flags = */d.read_shift(1);
		//if(memo && ((flags & 0x02) === 0)) throw new Error("DBF Flags " + flags.toString(16) + " ft " + ft.toString(16));

		/* codepage present in FoxPro and dBASE Level 7 */
		if(d[d.l] !== 0) current_cp = dbf_codepage_map[d[d.l]];
		d.l+=1;

		d.l+=2;
	}
	if(l7) d.l += 36; // Level 7: 32 byte "Language driver name", 4 byte reserved

var fields = [], field = ({});
	var hend = Math.min(d.length, (ft == 0x02 ? 0x209 : (fpos - 10 - (vfp ? 264 : 0))));
	var ww = l7 ? 32 : 11;
	while(d.l < hend && d[d.l] != 0x0d) {
		field = ({});
		field.name = (typeof $cptable !== "undefined" ? $cptable.utils.decode(current_cp, d.slice(d.l, d.l+ww)) : a2s(d.slice(d.l, d.l + ww))).replace(/[\u0000\r\n].*$/g,"");
		d.l += ww;
		field.type = String.fromCharCode(d.read_shift(1));
		if(ft != 0x02 && !l7) field.offset = d.read_shift(4);
		field.len = d.read_shift(1);
		if(ft == 0x02) field.offset = d.read_shift(2);
		field.dec = d.read_shift(1);
		if(field.name.length) fields.push(field);
		if(ft != 0x02) d.l += l7 ? 13 : 14;
		switch(field.type) {
			case 'B': // Double (VFP) / Binary (dBASE L7)
				if((!vfp || field.len != 8) && opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
				break;
			case 'G': // General (FoxPro and dBASE L7)
			case 'P': // Picture (FoxPro and dBASE L7)
				if(opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
				break;
			case '+': // Autoincrement (dBASE L7 only)
			case '0': // _NullFlags (VFP only)
			case '@': // Timestamp (dBASE L7 only)
			case 'C': // Character (dBASE II)
			case 'D': // Date (dBASE III)
			case 'F': // Float (dBASE IV)
			case 'I': // Long (VFP and dBASE L7)
			case 'L': // Logical (dBASE II)
			case 'M': // Memo (dBASE III)
			case 'N': // Number (dBASE II)
			case 'O': // Double (dBASE L7 only)
			case 'T': // Datetime (VFP only)
			case 'Y': // Currency (VFP only)
				break;
			default: throw new Error('Unknown Field Type: ' + field.type);
		}
	}

	if(d[d.l] !== 0x0D) d.l = fpos-1;
	if(d.read_shift(1) !== 0x0D) throw new Error("DBF Terminator not found " + d.l + " " + d[d.l]);
	d.l = fpos;

	/* data */
	var R = 0, C = 0;
	out[0] = [];
	for(C = 0; C != fields.length; ++C) out[0][C] = fields[C].name;
	while(nrow-- > 0) {
		if(d[d.l] === 0x2A) {
			// TODO: record marked as deleted -- create a hidden row?
			d.l+=rlen;
			continue;
		}
		++d.l;
		out[++R] = []; C = 0;
		for(C = 0; C != fields.length; ++C) {
			var dd = d.slice(d.l, d.l+fields[C].len); d.l+=fields[C].len;
			prep_blob(dd, 0);
			var s = typeof $cptable !== "undefined" ? $cptable.utils.decode(current_cp, dd) : a2s(dd);
			switch(fields[C].type) {
				case 'C':
					// NOTE: it is conventional to write '  /  /  ' for empty dates
					if(s.trim().length) out[R][C] = s.replace(/\s+$/,"");
					break;
				case 'D':
					if(s.length === 8) out[R][C] = new Date(+s.slice(0,4), +s.slice(4,6)-1, +s.slice(6,8));
					else out[R][C] = s;
					break;
				case 'F': out[R][C] = parseFloat(s.trim()); break;
				case '+': case 'I': out[R][C] = l7 ? dd.read_shift(-4, 'i') ^ 0x80000000 : dd.read_shift(4, 'i'); break;
				case 'L': switch(s.trim().toUpperCase()) {
					case 'Y': case 'T': out[R][C] = true; break;
					case 'N': case 'F': out[R][C] = false; break;
					case '': case '?': break;
					default: throw new Error("DBF Unrecognized L:|" + s + "|");
					} break;
				case 'M': /* TODO: handle memo files */
					if(!memo) throw new Error("DBF Unexpected MEMO for type " + ft.toString(16));
					out[R][C] = "##MEMO##" + (l7 ? parseInt(s.trim(), 10): dd.read_shift(4));
					break;
				case 'N':
					s = s.replace(/\u0000/g,"").trim();
					// NOTE: dBASE II interprets "  .  " as 0
					if(s && s != ".") out[R][C] = +s || 0; break;
				case '@':
					// NOTE: dBASE specs appear to be incorrect
					out[R][C] = new Date(dd.read_shift(-8, 'f') - 0x388317533400);
					break;
				case 'T': out[R][C] = new Date((dd.read_shift(4) - 0x253D8C) * 0x5265C00 + dd.read_shift(4)); break;
				case 'Y': out[R][C] = dd.read_shift(4,'i')/1e4 + (dd.read_shift(4, 'i')/1e4)*Math.pow(2,32); break;
				case 'O': out[R][C] = -dd.read_shift(-8, 'f'); break;
				case 'B': if(vfp && fields[C].len == 8) { out[R][C] = dd.read_shift(8,'f'); break; }
					/* falls through */
				case 'G': case 'P': dd.l += fields[C].len; break;
				case '0':
					if(fields[C].name === '_NullFlags') break;
					/* falls through */
				default: throw new Error("DBF Unsupported data type " + fields[C].type);
			}
		}
	}
	if(ft != 0x02) if(d.l < d.length && d[d.l++] != 0x1A) throw new Error("DBF EOF Marker missing " + (d.l-1) + " of " + d.length + " " + d[d.l-1].toString(16));
	if(opts && opts.sheetRows) out = out.slice(0, opts.sheetRows);
	opts.DBF = fields;
	return out;
}

function dbf_to_sheet(buf, opts) {
	var o = opts || {};
	if(!o.dateNF) o.dateNF = "yyyymmdd";
	var ws = aoa_to_sheet(dbf_to_aoa(buf, o), o);
	ws["!cols"] = o.DBF.map(function(field) { return {
		wch: field.len,
		DBF: field
	};});
	delete o.DBF;
	return ws;
}

function dbf_to_workbook(buf, opts) {
	try {
		var o = sheet_to_workbook(dbf_to_sheet(buf, opts), opts);
		o.bookType = "dbf";
		return o;
	} catch(e) { if(opts && opts.WTF) throw e; }
	return ({SheetNames:[],Sheets:{}});
}

var _RLEN = { 'B': 8, 'C': 250, 'L': 1, 'D': 8, '?': 0, '': 0 };
function sheet_to_dbf(ws, opts) {
	var o = opts || {};
	var old_cp = current_codepage;
	if(+o.codepage >= 0) set_cp(+o.codepage);
	if(o.type == "string") throw new Error("Cannot write DBF to JS string");
	var ba = buf_array();
	var aoa = sheet_to_json(ws, {header:1, raw:true, cellDates:true});
	var headers = aoa[0], data = aoa.slice(1), cols = ws["!cols"] || [];
	var i = 0, j = 0, hcnt = 0, rlen = 1;
	for(i = 0; i < headers.length; ++i) {
		if(((cols[i]||{}).DBF||{}).name) { headers[i] = cols[i].DBF.name; ++hcnt; continue; }
		if(headers[i] == null) continue;
		++hcnt;
		if(typeof headers[i] === 'number') headers[i] = headers[i].toString(10);
		if(typeof headers[i] !== 'string') throw new Error("DBF Invalid column name " + headers[i] + " |" + (typeof headers[i]) + "|");
		if(headers.indexOf(headers[i]) !== i) for(j=0; j<1024;++j)
			if(headers.indexOf(headers[i] + "_" + j) == -1) { headers[i] += "_" + j; break; }
	}
	var range = safe_decode_range(ws['!ref']);
	var coltypes = [];
	var colwidths = [];
	var coldecimals = [];
	for(i = 0; i <= range.e.c - range.s.c; ++i) {
		var guess = '', _guess = '', maxlen = 0;
		var col = [];
		for(j=0; j < data.length; ++j) {
			if(data[j][i] != null) col.push(data[j][i]);
		}
		if(col.length == 0 || headers[i] == null) { coltypes[i] = '?'; continue; }
		for(j = 0; j < col.length; ++j) {
			switch(typeof col[j]) {
				/* TODO: check if L2 compat is desired */
				case 'number': _guess = 'B'; break;
				case 'string': _guess = 'C'; break;
				case 'boolean': _guess = 'L'; break;
				case 'object': _guess = col[j] instanceof Date ? 'D' : 'C'; break;
				default: _guess = 'C';
			}
			/* TODO: cache the values instead of encoding twice */
			maxlen = Math.max(maxlen, (typeof $cptable !== "undefined" && typeof col[j] == "string" ? $cptable.utils.encode(current_ansi, col[j]): String(col[j])).length);
			guess = guess && guess != _guess ? 'C' : _guess;
			//if(guess == 'C') break;
		}
		if(maxlen > 250) maxlen = 250;
		_guess = ((cols[i]||{}).DBF||{}).type;
		/* TODO: more fine grained control over DBF type resolution */
		if(_guess == 'C') {
			if(cols[i].DBF.len > maxlen) maxlen = cols[i].DBF.len;
		}
		if(guess == 'B' && _guess == 'N') {
			guess = 'N';
			coldecimals[i] = cols[i].DBF.dec;
			maxlen = cols[i].DBF.len;
		}
		colwidths[i] = guess == 'C' || _guess == 'N' ? maxlen : (_RLEN[guess] || 0);
		rlen += colwidths[i];
		coltypes[i] = guess;
	}

	var h = ba.next(32);
	h.write_shift(4, 0x13021130);
	h.write_shift(4, data.length);
	h.write_shift(2, 296 + 32 * hcnt);
	h.write_shift(2, rlen);
	for(i=0; i < 4; ++i) h.write_shift(4, 0);
	var cp = +dbf_reverse_map[current_codepage] || 0x03;
	h.write_shift(4, 0x00000000 | (cp<<8));
	if(dbf_codepage_map[cp] != +o.codepage) {
		if(o.codepage) console.error("DBF Unsupported codepage " + current_codepage + ", using 1252");
		current_codepage = 1252;
	}

	for(i = 0, j = 0; i < headers.length; ++i) {
		if(headers[i] == null) continue;
		var hf = ba.next(32);
		/* TODO: test how applications handle non-ASCII field names */
		var _f = (headers[i].slice(-10) + "\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00").slice(0, 11);
		hf.write_shift(1, _f, "sbcs");
		hf.write_shift(1, coltypes[i] == '?' ? 'C' : coltypes[i], "sbcs");
		hf.write_shift(4, j);
		hf.write_shift(1, colwidths[i] || _RLEN[coltypes[i]] || 0);
		hf.write_shift(1, coldecimals[i] || 0);
		hf.write_shift(1, 0x02);
		hf.write_shift(4, 0);
		hf.write_shift(1, 0);
		hf.write_shift(4, 0);
		hf.write_shift(4, 0);
		j += (colwidths[i] || _RLEN[coltypes[i]] || 0);
	}

	var hb = ba.next(264);
	hb.write_shift(4, 0x0000000D);
	for(i=0; i < 65;++i) hb.write_shift(4, 0x00000000);
	for(i=0; i < data.length; ++i) {
		var rout = ba.next(rlen);
		rout.write_shift(1, 0);
		for(j=0; j<headers.length; ++j) {
			if(headers[j] == null) continue;
			switch(coltypes[j]) {
				case 'L': rout.write_shift(1, data[i][j] == null ? 0x3F : data[i][j] ? 0x54 : 0x46); break;
				case 'B': rout.write_shift(8, data[i][j]||0, 'f'); break;
				case 'N':
					var _n = "0";
					if(typeof data[i][j] == "number") _n = data[i][j].toFixed(coldecimals[j]||0);
					for(hcnt=0; hcnt < colwidths[j]-_n.length; ++hcnt) rout.write_shift(1, 0x20);
					rout.write_shift(1, _n, "sbcs");
					break;
				case 'D':
					if(!data[i][j]) rout.write_shift(8, "00000000", "sbcs");
					else {
						rout.write_shift(4, ("0000"+data[i][j].getFullYear()).slice(-4), "sbcs");
						rout.write_shift(2, ("00"+(data[i][j].getMonth()+1)).slice(-2), "sbcs");
						rout.write_shift(2, ("00"+data[i][j].getDate()).slice(-2), "sbcs");
					} break;
				case 'C':
					var _l = rout.l;
					var _s = String(data[i][j] != null ? data[i][j] : "").slice(0, colwidths[j]);
					rout.write_shift(1, _s, "cpstr");
					_l += colwidths[j] - rout.l;
					for(hcnt=0; hcnt < _l; ++hcnt) rout.write_shift(1, 0x20); break;
			}
		}
		// data
	}
	current_codepage = old_cp;
	ba.next(1).write_shift(1, 0x1A);
	return ba.end();
}
	return {
		to_workbook: dbf_to_workbook,
		to_sheet: dbf_to_sheet,
		from_sheet: sheet_to_dbf
	};
})();

var SYLK = (function() {
	/* TODO: stress test sequences */
	var sylk_escapes = ({
		AA:'À', BA:'Á', CA:'Â', DA:195, HA:'Ä', JA:197,
		AE:'È', BE:'É', CE:'Ê',         HE:'Ë',
		AI:'Ì', BI:'Í', CI:'Î',         HI:'Ï',
		AO:'Ò', BO:'Ó', CO:'Ô', DO:213, HO:'Ö',
		AU:'Ù', BU:'Ú', CU:'Û',         HU:'Ü',
		Aa:'à', Ba:'á', Ca:'â', Da:227, Ha:'ä', Ja:229,
		Ae:'è', Be:'é', Ce:'ê',         He:'ë',
		Ai:'ì', Bi:'í', Ci:'î',         Hi:'ï',
		Ao:'ò', Bo:'ó', Co:'ô', Do:245, Ho:'ö',
		Au:'ù', Bu:'ú', Cu:'û',         Hu:'ü',
		KC:'Ç', Kc:'ç', q:'æ',  z:'œ',  a:'Æ',  j:'Œ',
		DN:209, Dn:241, Hy:255,
		S:169,  c:170,  R:174,  "B ":180,
0:176,    1:177,  2:178,
3:179,    5:181,  6:182,
7:183,    Q:185,  k:186,  b:208,  i:216,  l:222,  s:240,  y:248,
		"!":161, '"':162, "#":163, "(":164, "%":165, "'":167, "H ":168,
		"+":171, ";":187, "<":188, "=":189, ">":190, "?":191, "{":223
	});
	var sylk_char_regex = new RegExp("\u001BN(" + keys(sylk_escapes).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g,"\\$1") + "|\\|)", "gm");
	var sylk_char_fn = function(_, $1){ var o = sylk_escapes[$1]; return typeof o == "number" ? _getansi(o) : o; };
	var decode_sylk_char = function($$, $1, $2) { var newcc = (($1.charCodeAt(0) - 0x20)<<4) | ($2.charCodeAt(0) - 0x30); return newcc == 59 ? $$ : _getansi(newcc); };
	sylk_escapes["|"] = 254;
	/* https://oss.sheetjs.com/notes/sylk/ for more details */
	function sylk_to_aoa(d, opts) {
		switch(opts.type) {
			case 'base64': return sylk_to_aoa_str(Base64_decode(d), opts);
			case 'binary': return sylk_to_aoa_str(d, opts);
			case 'buffer': return sylk_to_aoa_str(has_buf && Buffer.isBuffer(d) ? d.toString('binary') : a2s(d), opts);
			case 'array': return sylk_to_aoa_str(cc2str(d), opts);
		}
		throw new Error("Unrecognized type " + opts.type);
	}
	function sylk_to_aoa_str(str, opts) {
		var records = str.split(/[\n\r]+/), R = -1, C = -1, ri = 0, rj = 0, arr = [];
		var formats = [];
		var next_cell_format = null;
		var sht = {}, rowinfo = [], colinfo = [], cw = [];
		var Mval = 0, j;
		var wb = { Workbook: { WBProps: {}, Names: [] } };
		if(+opts.codepage >= 0) set_cp(+opts.codepage);
		for (; ri !== records.length; ++ri) {
			Mval = 0;
			var rstr=records[ri].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, decode_sylk_char).replace(sylk_char_regex, sylk_char_fn);
			var record=rstr.replace(/;;/g, "\u0000").split(";").map(function(x) { return x.replace(/\u0000/g, ";"); });
			var RT=record[0], val;
			if(rstr.length > 0) switch(RT) {
			case 'ID': break; /* header */
			case 'E': break; /* EOF */
			case 'B': break; /* dimensions */
			case 'O': /* workbook options */
			for(rj=1; rj<record.length; ++rj) switch(record[rj].charAt(0)) {
				case 'V': {
					var d1904 = parseInt(record[rj].slice(1), 10);
					// NOTE: it is technically an error if d1904 >= 5 or < 0
					if(d1904 >= 1 && d1904 <= 4) wb.Workbook.WBProps.date1904 = true;
				} break;
			} break;
			case 'W': break; /* window */
			case 'P':
				switch(record[1].charAt(0)){
					case 'P': formats.push(rstr.slice(3).replace(/;;/g, ";")); break;
				} break;
			case 'NN': { /* defined name */
				var nn = {Sheet: 0};
				for(rj=1; rj<record.length; ++rj) switch(record[rj].charAt(0)) {
					case 'N': nn.Name = record[rj].slice(1); break;
					case 'E': nn.Ref = (opts && opts.sheet || "Sheet1") + "!" + rc_to_a1(record[rj].slice(1)); break;
				}
				wb.Workbook.Names.push(nn);
			} break;
			// case 'NE': // ??
			// case 'NU': // ??
			case 'C': /* cell */
			var C_seen_K = false, C_seen_X = false, C_seen_S = false, C_seen_E = false, _R = -1, _C = -1, formula = "", cell_t = "z";
			for(rj=1; rj<record.length; ++rj) switch(record[rj].charAt(0)) {
				case 'A': break; // TODO: comment
				case 'X': C = parseInt(record[rj].slice(1), 10)-1; C_seen_X = true; break;
				case 'Y':
					R = parseInt(record[rj].slice(1), 10)-1; if(!C_seen_X) C = 0;
					for(j = arr.length; j <= R; ++j) arr[j] = [];
					break;
				case 'K':
					val = record[rj].slice(1);
					if(val.charAt(0) === '"') { val = val.slice(1,val.length - 1); cell_t = "s"; }
					else if(val === 'TRUE' || val === 'FALSE') { val = val === 'TRUE'; cell_t = "b"; }
					else if(!isNaN(fuzzynum(val))) {
						val = fuzzynum(val); cell_t = "n";
						if(next_cell_format !== null && fmt_is_date(next_cell_format) && opts.cellDates) { val = numdate(wb.Workbook.WBProps.date1904 ? val + 1462 : val); cell_t = "d"; }
					} else if(!isNaN(fuzzydate(val).getDate())) {
						val = parseDate(val); cell_t = "d";
						if(!opts.cellDates) { cell_t = "n"; val = datenum(val, wb.Workbook.WBProps.date1904); }
					}
					if(typeof $cptable !== 'undefined' && typeof val == "string" && ((opts||{}).type != "string") && (opts||{}).codepage) val = $cptable.utils.decode(opts.codepage, val);
					C_seen_K = true;
					break;
				case 'E':
					C_seen_E = true;
					formula = rc_to_a1(record[rj].slice(1), {r:R,c:C});
					break;
				case 'S':
					C_seen_S = true;
					break;
				case 'G': break; // unknown
				case 'R': _R = parseInt(record[rj].slice(1), 10)-1; break;
				case 'C': _C = parseInt(record[rj].slice(1), 10)-1; break;
				// case 'P': // ??
				// case 'D': // ??
				default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
			}
			if(C_seen_K) {
				if(!arr[R][C]) arr[R][C] = { t: cell_t, v: val };
				else { arr[R][C].t = cell_t; arr[R][C].v = val; }
				if(next_cell_format) arr[R][C].z = next_cell_format;
				if(opts.cellText !== false && next_cell_format) arr[R][C].w = SSF_format(arr[R][C].z, arr[R][C].v, { date1904: wb.Workbook.WBProps.date1904 });
				next_cell_format = null;
			}
			if(C_seen_S) {
				if(C_seen_E) throw new Error("SYLK shared formula cannot have own formula");
				var shrbase = _R > -1 && arr[_R][_C];
				if(!shrbase || !shrbase[1]) throw new Error("SYLK shared formula cannot find base");
				formula = shift_formula_str(shrbase[1], {r: R - _R, c: C - _C});
			}
			if(formula) {
				if(!arr[R][C]) arr[R][C] = { t: 'n', f: formula };
				else arr[R][C].f = formula;
			}
			break;
			case 'F': /* Format */
			var F_seen = 0;
			for(rj=1; rj<record.length; ++rj) switch(record[rj].charAt(0)) {
				case 'X': C = parseInt(record[rj].slice(1), 10)-1; ++F_seen; break;
				case 'Y':
					R = parseInt(record[rj].slice(1), 10)-1; /*C = 0;*/
					for(j = arr.length; j <= R; ++j) arr[j] = [];
					break;
				case 'M': Mval = parseInt(record[rj].slice(1), 10) / 20; break;
				case 'F': break; /* ??? */
				case 'G': break; /* hide grid */
				case 'P':
					next_cell_format = formats[parseInt(record[rj].slice(1), 10)];
					break;
				case 'S': break; /* cell style */
				case 'D': break; /* column */
				case 'N': break; /* font */
				case 'W':
					cw = record[rj].slice(1).split(" ");
					for(j = parseInt(cw[0], 10); j <= parseInt(cw[1], 10); ++j) {
						Mval = parseInt(cw[2], 10);
						colinfo[j-1] = Mval === 0 ? {hidden:true}: {wch:Mval};
					} break;
				case 'C': /* default column format */
					C = parseInt(record[rj].slice(1), 10)-1;
					if(!colinfo[C]) colinfo[C] = {};
					break;
				case 'R': /* row properties */
					R = parseInt(record[rj].slice(1), 10)-1;
					if(!rowinfo[R]) rowinfo[R] = {};
					if(Mval > 0) { rowinfo[R].hpt = Mval; rowinfo[R].hpx = pt2px(Mval); }
					else if(Mval === 0) rowinfo[R].hidden = true;
					break;
				// case 'K': // ??
				// case 'E': // ??
				default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
			}
			if(F_seen < 1) next_cell_format = null; break;
			default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
			}
		}
		if(rowinfo.length > 0) sht['!rows'] = rowinfo;
		if(colinfo.length > 0) sht['!cols'] = colinfo;
		colinfo.forEach(function(col) { process_col(col); });
		if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
		return [arr, sht, wb];
	}

	function sylk_to_workbook(d, opts) {
		var aoasht = sylk_to_aoa(d, opts);
		var aoa = aoasht[0], ws = aoasht[1], wb = aoasht[2];
		var _opts = dup(opts); _opts.date1904 = (((wb||{}).Workbook || {}).WBProps || {}).date1904;
		var o = aoa_to_sheet(aoa, _opts);
		keys(ws).forEach(function(k) { o[k] = ws[k]; });
		var outwb = sheet_to_workbook(o, opts);
		keys(wb).forEach(function(k) { outwb[k] = wb[k]; });
		outwb.bookType = "sylk";
		return outwb;
	}

	function write_ws_cell_sylk(cell, ws, R, C) {
		var o = "C;Y" + (R+1) + ";X" + (C+1) + ";K";
		switch(cell.t) {
			case 'n':
				o += (cell.v||0);
				if(cell.f && !cell.F) o += ";E" + a1_to_rc(cell.f, {r:R, c:C}); break;
			case 'b': o += cell.v ? "TRUE" : "FALSE"; break;
			case 'e': o += cell.w || cell.v; break;
			case 'd': o += '"' + (cell.w || cell.v) + '"'; break;
			case 's': o += '"' + (cell.v == null ? "" : String(cell.v)).replace(/"/g,"").replace(/;/g, ";;") + '"'; break;
		}
		return o;
	}

	function write_ws_cols_sylk(out, cols) {
		cols.forEach(function(col, i) {
			var rec = "F;W" + (i+1) + " " + (i+1) + " ";
			if(col.hidden) rec += "0";
			else {
				if(typeof col.width == 'number' && !col.wpx) col.wpx = width2px(col.width);
				if(typeof col.wpx == 'number' && !col.wch) col.wch = px2char(col.wpx);
				if(typeof col.wch == 'number') rec += Math.round(col.wch);
			}
			if(rec.charAt(rec.length - 1) != " ") out.push(rec);
		});
	}

	function write_ws_rows_sylk(out, rows) {
		rows.forEach(function(row, i) {
			var rec = "F;";
			if(row.hidden) rec += "M0;";
			else if(row.hpt) rec += "M" + 20 * row.hpt + ";";
			else if(row.hpx) rec += "M" + 20 * px2pt(row.hpx) + ";";
			if(rec.length > 2) out.push(rec + "R" + (i+1));
		});
	}

	function sheet_to_sylk(ws, opts, wb) {
		/* TODO: codepage */
		var preamble = ["ID;PSheetJS;N;E"], o = [];
		var r = safe_decode_range(ws['!ref']), cell;
		var dense = Array.isArray(ws);
		var RS = "\r\n";
		var d1904 = (((wb||{}).Workbook||{}).WBProps||{}).date1904;

		preamble.push("P;PGeneral");
		preamble.push("F;P0;DG0G8;M255");
		if(ws['!cols']) write_ws_cols_sylk(preamble, ws['!cols']);
		if(ws['!rows']) write_ws_rows_sylk(preamble, ws['!rows']);

		preamble.push("B;Y" + (r.e.r - r.s.r + 1) + ";X" + (r.e.c - r.s.c + 1) + ";D" + [r.s.c,r.s.r,r.e.c,r.e.r].join(" "));
		preamble.push("O;L;D;B" + (d1904 ? ";V4" : "") + ";K47;G100 0.001");
		for(var R = r.s.r; R <= r.e.r; ++R) {
			var p = [];
			for(var C = r.s.c; C <= r.e.c; ++C) {
				var coord = encode_cell({r:R,c:C});
				cell = dense ? (ws[R]||[])[C]: ws[coord];
				if(!cell || (cell.v == null && (!cell.f || cell.F))) continue;
				p.push(write_ws_cell_sylk(cell, ws, R, C, opts)); // TODO: pass date1904 info
			}
			o.push(p.join(RS));
		}
		return preamble.join(RS) + RS + o.join(RS) + RS + "E" + RS;
	}

	return {
		to_workbook: sylk_to_workbook,
		from_sheet: sheet_to_sylk
	};
})();

var DIF = (function() {
	function dif_to_aoa(d, opts) {
		switch(opts.type) {
			case 'base64': return dif_to_aoa_str(Base64_decode(d), opts);
			case 'binary': return dif_to_aoa_str(d, opts);
			case 'buffer': return dif_to_aoa_str(has_buf && Buffer.isBuffer(d) ? d.toString('binary') : a2s(d), opts);
			case 'array': return dif_to_aoa_str(cc2str(d), opts);
		}
		throw new Error("Unrecognized type " + opts.type);
	}
	function dif_to_aoa_str(str, opts) {
		var records = str.split('\n'), R = -1, C = -1, ri = 0, arr = [];
		for (; ri !== records.length; ++ri) {
			if (records[ri].trim() === 'BOT') { arr[++R] = []; C = 0; continue; }
			if (R < 0) continue;
			var metadata = records[ri].trim().split(",");
			var type = metadata[0], value = metadata[1];
			++ri;
			var data = records[ri] || "";
			while(((data.match(/["]/g)||[]).length & 1) && ri < records.length - 1) data += "\n" + records[++ri];
			data = data.trim();
			switch (+type) {
				case -1:
					if (data === 'BOT') { arr[++R] = []; C = 0; continue; }
					else if (data !== 'EOD') throw new Error("Unrecognized DIF special command " + data);
					break;
				case 0:
					if(data === 'TRUE') arr[R][C] = true;
					else if(data === 'FALSE') arr[R][C] = false;
					else if(!isNaN(fuzzynum(value))) arr[R][C] = fuzzynum(value);
					else if(!isNaN(fuzzydate(value).getDate())) arr[R][C] = parseDate(value);
					else arr[R][C] = value;
					++C; break;
				case 1:
					data = data.slice(1,data.length-1);
					data = data.replace(/""/g, '"');
					if(DIF_XL && data && data.match(/^=".*"$/)) data = data.slice(2, -1);
					arr[R][C++] = data !== '' ? data : null;
					break;
			}
			if (data === 'EOD') break;
		}
		if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
		return arr;
	}

	function dif_to_sheet(str, opts) { return aoa_to_sheet(dif_to_aoa(str, opts), opts); }
	function dif_to_workbook(str, opts) {
		var o = sheet_to_workbook(dif_to_sheet(str, opts), opts);
		o.bookType = "dif";
		return o;
	}

	function make_value(v, s) { return "0," + String(v) + "\r\n" + s; }
	function make_value_str(s) { return "1,0\r\n\"" + s.replace(/"/g,'""') + '"'; }
	function sheet_to_dif(ws) {
		var _DIF_XL = DIF_XL;
		var r = safe_decode_range(ws['!ref']);
		var dense = Array.isArray(ws);
		var o = [
			"TABLE\r\n0,1\r\n\"sheetjs\"\r\n",
			"VECTORS\r\n0," + (r.e.r - r.s.r + 1) + "\r\n\"\"\r\n",
			"TUPLES\r\n0," + (r.e.c - r.s.c + 1) + "\r\n\"\"\r\n",
			"DATA\r\n0,0\r\n\"\"\r\n"
		];
		for(var R = r.s.r; R <= r.e.r; ++R) {
			var p = "-1,0\r\nBOT\r\n";
			for(var C = r.s.c; C <= r.e.c; ++C) {
				var cell = dense ? (ws[R] && ws[R][C]) : ws[encode_cell({r:R,c:C})];
				if(cell == null) { p +=("1,0\r\n\"\"\r\n"); continue;}
				switch(cell.t) {
					case 'n':
						if(_DIF_XL) {
							if(cell.w != null) p +=("0," + cell.w + "\r\nV");
							else if(cell.v != null) p +=(make_value(cell.v, "V")); // TODO: should this call SSF_format?
							else if(cell.f != null && !cell.F) p +=(make_value_str("=" + cell.f));
							else p +=("1,0\r\n\"\"");
						} else {
							if(cell.v == null) p +=("1,0\r\n\"\"");
							else p +=(make_value(cell.v, "V"));
						}
						break;
					case 'b':
						p +=(cell.v ? make_value(1, "TRUE") : make_value(0, "FALSE"));
						break;
					case 's':
						p +=(make_value_str((!_DIF_XL || isNaN(+cell.v)) ? cell.v : '="' + cell.v + '"'));
						break;
					case 'd':
						if(!cell.w) cell.w = SSF_format(cell.z || table_fmt[14], datenum(parseDate(cell.v)));
						if(_DIF_XL) p +=(make_value(cell.w, "V"));
						else p +=(make_value_str(cell.w));
						break;
					default: p +=("1,0\r\n\"\"");
				}
				p += "\r\n";
			}
			o.push(p);
		}
		return o.join("") + "-1,0\r\nEOD";
	}
	return {
		to_workbook: dif_to_workbook,
		to_sheet: dif_to_sheet,
		from_sheet: sheet_to_dif
	};
})();

var ETH = (function() {
	function decode(s) { return s.replace(/\\b/g,"\\").replace(/\\c/g,":").replace(/\\n/g,"\n"); }
	function encode(s) { return s.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g,"\\n"); }

	function eth_to_aoa(str, opts) {
		var records = str.split('\n'), R = -1, C = -1, ri = 0, arr = [];
		for (; ri !== records.length; ++ri) {
			var record = records[ri].trim().split(":");
			if(record[0] !== 'cell') continue;
			var addr = decode_cell(record[1]);
			if(arr.length <= addr.r) for(R = arr.length; R <= addr.r; ++R) if(!arr[R]) arr[R] = [];
			R = addr.r; C = addr.c;
			switch(record[2]) {
				case 't': arr[R][C] = decode(record[3]); break;
				case 'v': arr[R][C] = +record[3]; break;
				case 'vtf': var _f = record[record.length - 1];
					/* falls through */
				case 'vtc':
					switch(record[3]) {
						case 'nl': arr[R][C] = +record[4] ? true : false; break;
						default: arr[R][C] = +record[4]; break;
					}
					if(record[2] == 'vtf') arr[R][C] = [arr[R][C], _f];
			}
		}
		if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
		return arr;
	}

	function eth_to_sheet(d, opts) { return aoa_to_sheet(eth_to_aoa(d, opts), opts); }
	function eth_to_workbook(d, opts) { return sheet_to_workbook(eth_to_sheet(d, opts), opts); }

	var header = [
		"socialcalc:version:1.5",
		"MIME-Version: 1.0",
		"Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
	].join("\n");

	var sep = [
		"--SocialCalcSpreadsheetControlSave",
		"Content-type: text/plain; charset=UTF-8"
	].join("\n") + "\n";

	/* TODO: the other parts */
	var meta = [
		"# SocialCalc Spreadsheet Control Save",
		"part:sheet"
	].join("\n");

	var end = "--SocialCalcSpreadsheetControlSave--";

	function sheet_to_eth_data(ws) {
		if(!ws || !ws['!ref']) return "";
		var o = [], oo = [], cell, coord = "";
		var r = decode_range(ws['!ref']);
		var dense = Array.isArray(ws);
		for(var R = r.s.r; R <= r.e.r; ++R) {
			for(var C = r.s.c; C <= r.e.c; ++C) {
				coord = encode_cell({r:R,c:C});
				cell = dense ? (ws[R]||[])[C] : ws[coord];
				if(!cell || cell.v == null || cell.t === 'z') continue;
				oo = ["cell", coord, 't'];
				switch(cell.t) {
					case 's': case 'str': oo.push(encode(cell.v)); break;
					case 'n':
						if(!cell.f) { oo[2]='v'; oo[3]=cell.v; }
						else { oo[2]='vtf'; oo[3]='n'; oo[4]=cell.v; oo[5]=encode(cell.f); }
						break;
					case 'b':
						oo[2] = 'vt'+(cell.f?'f':'c'); oo[3]='nl'; oo[4]=cell.v?"1":"0";
						oo[5] = encode(cell.f||(cell.v?'TRUE':'FALSE'));
						break;
					case 'd':
						var t = datenum(parseDate(cell.v));
						oo[2] = 'vtc'; oo[3] = 'nd'; oo[4] = ""+t;
						oo[5] = cell.w || SSF_format(cell.z || table_fmt[14], t);
						break;
					case 'e': continue;
				}
				o.push(oo.join(":"));
			}
		}
		o.push("sheet:c:" + (r.e.c-r.s.c+1) + ":r:" + (r.e.r-r.s.r+1) + ":tvf:1");
		o.push("valueformat:1:text-wiki");
		//o.push("copiedfrom:" + ws['!ref']); // clipboard only
		return o.join("\n");
	}

	function sheet_to_eth(ws) {
		return [header, sep, meta, sep, sheet_to_eth_data(ws), end].join("\n");
		// return ["version:1.5", sheet_to_eth_data(ws)].join("\n"); // clipboard form
	}

	return {
		to_workbook: eth_to_workbook,
		to_sheet: eth_to_sheet,
		from_sheet: sheet_to_eth
	};
})();

var PRN = (function() {
	function set_text_arr(data, arr, R, C, o) {
		if(o.raw) arr[R][C] = data;
		else if(data === ""){/* empty */}
		else if(data === 'TRUE') arr[R][C] = true;
		else if(data === 'FALSE') arr[R][C] = false;
		else if(!isNaN(fuzzynum(data))) arr[R][C] = fuzzynum(data);
		else if(!isNaN(fuzzydate(data).getDate())) arr[R][C] = parseDate(data);
		else arr[R][C] = data;
	}

	function prn_to_aoa_str(f, opts) {
		var o = opts || {};
		var arr = ([]);
		if(!f || f.length === 0) return arr;
		var lines = f.split(/[\r\n]/);
		var L = lines.length - 1;
		while(L >= 0 && lines[L].length === 0) --L;
		var start = 10, idx = 0;
		var R = 0;
		for(; R <= L; ++R) {
			idx = lines[R].indexOf(" ");
			if(idx == -1) idx = lines[R].length; else idx++;
			start = Math.max(start, idx);
		}
		for(R = 0; R <= L; ++R) {
			arr[R] = [];
			/* TODO: confirm that widths are always 10 */
			var C = 0;
			set_text_arr(lines[R].slice(0, start).trim(), arr, R, C, o);
			for(C = 1; C <= (lines[R].length - start)/10 + 1; ++C)
				set_text_arr(lines[R].slice(start+(C-1)*10,start+C*10).trim(),arr,R,C,o);
		}
		if(o.sheetRows) arr = arr.slice(0, o.sheetRows);
		return arr;
	}

	// List of accepted CSV separators
	var guess_seps = {
0x2C: ',',
0x09: "\t",
0x3B: ';',
0x7C: '|'
	};

	// CSV separator weights to be used in case of equal numbers
	var guess_sep_weights = {
0x2C: 3,
0x09: 2,
0x3B: 1,
0x7C: 0
	};

	function guess_sep(str) {
		var cnt = {}, instr = false, end = 0, cc = 0;
		for(;end < str.length;++end) {
			if((cc=str.charCodeAt(end)) == 0x22) instr = !instr;
			else if(!instr && cc in guess_seps) cnt[cc] = (cnt[cc]||0)+1;
		}

		cc = [];
		for(end in cnt) if ( Object.prototype.hasOwnProperty.call(cnt, end) ) {
			cc.push([ cnt[end], end ]);
		}

		if ( !cc.length ) {
			cnt = guess_sep_weights;
			for(end in cnt) if ( Object.prototype.hasOwnProperty.call(cnt, end) ) {
				cc.push([ cnt[end], end ]);
			}
		}

		cc.sort(function(a, b) { return a[0] - b[0] || guess_sep_weights[a[1]] - guess_sep_weights[b[1]]; });

		return guess_seps[cc.pop()[1]] || 0x2C;
	}

	function dsv_to_sheet_str(str, opts) {
		var o = opts || {};
		var sep = "";
		if(DENSE != null && o.dense == null) o.dense = DENSE;
		var ws = o.dense ? ([]) : ({});
		var range = ({s: {c:0, r:0}, e: {c:0, r:0}});

		if(str.slice(0,4) == "sep=") {
			// If the line ends in \r\n
			if(str.charCodeAt(5) == 13 && str.charCodeAt(6) == 10 ) {
				sep = str.charAt(4); str = str.slice(7);
			}
			// If line ends in \r OR \n
			else if(str.charCodeAt(5) == 13 || str.charCodeAt(5) == 10 ) {
				sep = str.charAt(4); str = str.slice(6);
			}
			else sep = guess_sep(str.slice(0,1024));
		}
		else if(o && o.FS) sep = o.FS;
		else sep = guess_sep(str.slice(0,1024));
		var R = 0, C = 0, v = 0;
		var start = 0, end = 0, sepcc = sep.charCodeAt(0), instr = false, cc=0, startcc=str.charCodeAt(0);
		var _re = o.dateNF != null ? dateNF_regex(o.dateNF) : null;
		function finish_cell() {
			var s = str.slice(start, end); if(s.slice(-1) == "\r") s = s.slice(0, -1);
			var cell = ({});
			if(s.charAt(0) == '"' && s.charAt(s.length - 1) == '"') s = s.slice(1,-1).replace(/""/g,'"');
			if(s.length === 0) cell.t = 'z';
			else if(o.raw) { cell.t = 's'; cell.v = s; }
			else if(s.trim().length === 0) { cell.t = 's'; cell.v = s; }
			else if(s.charCodeAt(0) == 0x3D) {
				if(s.charCodeAt(1) == 0x22 && s.charCodeAt(s.length - 1) == 0x22) { cell.t = 's'; cell.v = s.slice(2,-1).replace(/""/g,'"'); }
				else if(fuzzyfmla(s)) { cell.t = 'n'; cell.f = s.slice(1); }
				else { cell.t = 's'; cell.v = s; } }
			else if(s == "TRUE") { cell.t = 'b'; cell.v = true; }
			else if(s == "FALSE") { cell.t = 'b'; cell.v = false; }
			else if(!isNaN(v = fuzzynum(s))) { cell.t = 'n'; if(o.cellText !== false) cell.w = s; cell.v = v; }
			else if(!isNaN((v = fuzzydate(s)).getDate()) || _re && s.match(_re)) {
				cell.z = o.dateNF || table_fmt[14];
				var k = 0;
				if(_re && s.match(_re)){ s=dateNF_fix(s, o.dateNF, (s.match(_re)||[])); k=1; v = parseDate(s, k); }
				if(o.cellDates) { cell.t = 'd'; cell.v = v; }
				else { cell.t = 'n'; cell.v = datenum(v); }
				if(o.cellText !== false) cell.w = SSF_format(cell.z, cell.v instanceof Date ? datenum(cell.v):cell.v);
				if(!o.cellNF) delete cell.z;
			} else {
				cell.t = 's';
				cell.v = s;
			}
			if(cell.t == 'z'){}
			else if(o.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = cell; }
			else ws[encode_cell({c:C,r:R})] = cell;
			start = end+1; startcc = str.charCodeAt(start);
			if(range.e.c < C) range.e.c = C;
			if(range.e.r < R) range.e.r = R;
			if(cc == sepcc) ++C; else { C = 0; ++R; if(o.sheetRows && o.sheetRows <= R) return true; }
		}
		outer: for(;end < str.length;++end) switch((cc=str.charCodeAt(end))) {
			case 0x22: if(startcc === 0x22) instr = !instr; break;
			case 0x0d:
				if(instr) break;
				if(str.charCodeAt(end+1) == 0x0a) ++end;
				/* falls through */
			case sepcc: case 0x0a: if(!instr && finish_cell()) break outer; break;
			default: break;
		}
		if(end - start > 0) finish_cell();

		ws['!ref'] = encode_range(range);
		return ws;
	}

	function prn_to_sheet_str(str, opts) {
		if(!(opts && opts.PRN)) return dsv_to_sheet_str(str, opts);
		if(opts.FS) return dsv_to_sheet_str(str, opts);
		if(str.slice(0,4) == "sep=") return dsv_to_sheet_str(str, opts);
		if(str.indexOf("\t") >= 0 || str.indexOf(",") >= 0 || str.indexOf(";") >= 0) return dsv_to_sheet_str(str, opts);
		return aoa_to_sheet(prn_to_aoa_str(str, opts), opts);
	}

	function prn_to_sheet(d, opts) {
		var str = "", bytes = opts.type == 'string' ? [0,0,0,0] : firstbyte(d, opts);
		switch(opts.type) {
			case 'base64': str = Base64_decode(d); break;
			case 'binary': str = d; break;
			case 'buffer':
				if(opts.codepage == 65001) str = d.toString('utf8'); // TODO: test if buf
				else if(opts.codepage && typeof $cptable !== 'undefined') str = $cptable.utils.decode(opts.codepage, d);
				else str = has_buf && Buffer.isBuffer(d) ? d.toString('binary') : a2s(d);
				break;
			case 'array': str = cc2str(d); break;
			case 'string': str = d; break;
			default: throw new Error("Unrecognized type " + opts.type);
		}
		if(bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = utf8read(str.slice(3));
		else if(opts.type != 'string' && opts.type != 'buffer' && opts.codepage == 65001) str = utf8read(str);
		else if((opts.type == 'binary') && typeof $cptable !== 'undefined' && opts.codepage)  str = $cptable.utils.decode(opts.codepage, $cptable.utils.encode(28591,str));
		if(str.slice(0,19) == "socialcalc:version:") return ETH.to_sheet(opts.type == 'string' ? str : utf8read(str), opts);
		return prn_to_sheet_str(str, opts);
	}

	function prn_to_workbook(d, opts) { return sheet_to_workbook(prn_to_sheet(d, opts), opts); }

	function sheet_to_prn(ws) {
		var o = [];
		var r = safe_decode_range(ws['!ref']), cell;
		var dense = Array.isArray(ws);
		for(var R = r.s.r; R <= r.e.r; ++R) {
			var oo = [];
			for(var C = r.s.c; C <= r.e.c; ++C) {
				var coord = encode_cell({r:R,c:C});
				cell = dense ? (ws[R]||[])[C] : ws[coord];
				if(!cell || cell.v == null) { oo.push("          "); continue; }
				var w = (cell.w || (format_cell(cell), cell.w) || "").slice(0,10);
				while(w.length < 10) w += " ";
				oo.push(w + (C === 0 ? " " : ""));
			}
			o.push(oo.join(""));
		}
		return o.join("\n");
	}

	return {
		to_workbook: prn_to_workbook,
		to_sheet: prn_to_sheet,
		from_sheet: sheet_to_prn
	};
})();

/* Excel defaults to SYLK but warns if data is not valid */
function read_wb_ID(d, opts) {
	var o = opts || {}, OLD_WTF = !!o.WTF; o.WTF = true;
	try {
		var out = SYLK.to_workbook(d, o);
		o.WTF = OLD_WTF;
		return out;
	} catch(e) {
		o.WTF = OLD_WTF;
		if(!e.message.match(/SYLK bad record ID/) && OLD_WTF) throw e;
		return PRN.to_workbook(d, opts);
	}
}

var WK_ = (function() {
	function lotushopper(data, cb, opts) {
		if(!data) return;
		prep_blob(data, data.l || 0);
		var Enum = opts.Enum || WK1Enum;
		while(data.l < data.length) {
			var RT = data.read_shift(2);
			var R = Enum[RT] || Enum[0xFFFF];
			var length = data.read_shift(2);
			var tgt = data.l + length;
			var d = R.f && R.f(data, length, opts);
			data.l = tgt;
			if(cb(d, R, RT)) return;
		}
	}

	function lotus_to_workbook(d, opts) {
		switch(opts.type) {
			case 'base64': return lotus_to_workbook_buf(s2a(Base64_decode(d)), opts);
			case 'binary': return lotus_to_workbook_buf(s2a(d), opts);
			case 'buffer':
			case 'array': return lotus_to_workbook_buf(d, opts);
		}
		throw "Unsupported type " + opts.type;
	}

	function lotus_to_workbook_buf(d, opts) {
		if(!d) return d;
		var o = opts || {};
		if(DENSE != null && o.dense == null) o.dense = DENSE;
		var s = ((o.dense ? [] : {})), n = "Sheet1", next_n = "", sidx = 0;
		var sheets = {}, snames = [], realnames = [];

		var refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
		var sheetRows = o.sheetRows || 0;

		if(d[4] == 0x51 && d[5] == 0x50 && d[6] == 0x57) return qpw_to_workbook_buf(d, opts);
		if(d[2] == 0x00) {
			if(d[3] == 0x08 || d[3] == 0x09) {
				if(d.length >= 16 && d[14] == 0x05 && d[15] === 0x6c) throw new Error("Unsupported Works 3 for Mac file");
			}
		}

		if(d[2] == 0x02) {
			o.Enum = WK1Enum;
			lotushopper(d, function(val, R, RT) { switch(RT) {
				case 0x00: /* BOF */
					o.vers = val;
					if(val >= 0x1000) o.qpro = true;
					break;
				case 0xFF: /* BOF (works 3+) */
					o.vers = val;
					o.works = true;
					break;
				case 0x06: refguess = val; break; /* RANGE */
				case 0xCC: if(val) next_n = val; break; /* SHEETNAMECS */
				case 0xDE: next_n = val; break; /* SHEETNAMELP */
				case 0x0F: /* LABEL */
				case 0x33: /* STRING */
					if((!o.qpro && !o.works || RT == 0x33) && val[1].v.charCodeAt(0) < 0x30) val[1].v = val[1].v.slice(1);
					if(o.works || o.works2) val[1].v = val[1].v.replace(/\r\n/g, "\n");
					/* falls through */
				case 0x0D: /* INTEGER */
				case 0x0E: /* NUMBER */
				case 0x10: /* FORMULA */
					/* TODO: actual translation of the format code */
					if(RT == 0x0E && (val[2] & 0x70) == 0x70 && (val[2] & 0x0F) > 1 && (val[2] & 0x0F) < 15) {
						val[1].z = o.dateNF || table_fmt[14];
						if(o.cellDates) { val[1].t = 'd'; val[1].v = numdate(val[1].v); }
					}

					if(o.qpro) {
						if(val[3] > sidx) {
							s["!ref"] = encode_range(refguess);
							sheets[n] = s;
							snames.push(n);
							s = (o.dense ? [] : {});
							refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
							sidx = val[3]; n = next_n || "Sheet" + (sidx + 1); next_n = "";
						}
					}

					var tmpcell = o.dense ? (s[val[0].r]||[])[val[0].c] : s[encode_cell(val[0])];
					if(tmpcell) {
						tmpcell.t = val[1].t; tmpcell.v = val[1].v;
						if(val[1].z != null) tmpcell.z = val[1].z;
						if(val[1].f != null) tmpcell.f = val[1].f;
						break;
					}
					if(o.dense) {
						if(!s[val[0].r]) s[val[0].r] = [];
						s[val[0].r][val[0].c] = val[1];
					} else s[encode_cell(val[0])] = val[1];
					break;
				case 0x5405: o.works2 = true; break;
				default:
			}}, o);
		} else if(d[2] == 0x1A || d[2] == 0x0E) {
			o.Enum = WK3Enum;
			if(d[2] == 0x0E) { o.qpro = true; d.l = 0; }
			lotushopper(d, function(val, R, RT) { switch(RT) {
				case 0xCC: n = val; break; /* SHEETNAMECS */
				case 0x16: /* LABEL16 */
					if(val[1].v.charCodeAt(0) < 0x30) val[1].v = val[1].v.slice(1);
					// TODO: R9 appears to encode control codes this way -- verify against other versions
					val[1].v = val[1].v.replace(/\x0F./g, function($$) { return String.fromCharCode($$.charCodeAt(1) - 0x20); }).replace(/\r\n/g, "\n");
					/* falls through */
				case 0x17: /* NUMBER17 */
				case 0x18: /* NUMBER18 */
				case 0x19: /* FORMULA19 */
				case 0x25: /* NUMBER25 */
				case 0x27: /* NUMBER27 */
				case 0x28: /* FORMULA28 */
					if(val[3] > sidx) {
						s["!ref"] = encode_range(refguess);
						sheets[n] = s;
						snames.push(n);
						s = (o.dense ? [] : {});
						refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
						sidx = val[3]; n = "Sheet" + (sidx + 1);
					}
					if(sheetRows > 0 && val[0].r >= sheetRows) break;
					if(o.dense) {
						if(!s[val[0].r]) s[val[0].r] = [];
						s[val[0].r][val[0].c] = val[1];
					} else s[encode_cell(val[0])] = val[1];
					if(refguess.e.c < val[0].c) refguess.e.c = val[0].c;
					if(refguess.e.r < val[0].r) refguess.e.r = val[0].r;
					break;
				case 0x1B: /* XFORMAT */
					if(val[0x36b0]) realnames[val[0x36b0][0]] = val[0x36b0][1];
					break;
				case 0x0601: /* SHEETINFOQP */
					realnames[val[0]] = val[1]; if(val[0] == sidx) n = val[1]; break;
				default: break;
			}}, o);
		} else throw new Error("Unrecognized LOTUS BOF " + d[2]);
		s["!ref"] = encode_range(refguess);
		sheets[next_n || n] = s;
		snames.push(next_n || n);
		if(!realnames.length) return { SheetNames: snames, Sheets: sheets };
		var osheets = {}, rnames = [];
		/* TODO: verify no collisions */
		for(var i = 0; i < realnames.length; ++i) if(sheets[snames[i]]) {
			rnames.push(realnames[i] || snames[i]);
			osheets[realnames[i]] = sheets[realnames[i]] || sheets[snames[i]];
		} else {
			rnames.push(realnames[i]);
			osheets[realnames[i]] = ({ "!ref": "A1" });
		}
		return { SheetNames: rnames, Sheets: osheets };
	}

	function sheet_to_wk1(ws, opts) {
		var o = opts || {};
		if(+o.codepage >= 0) set_cp(+o.codepage);
		if(o.type == "string") throw new Error("Cannot write WK1 to JS string");
		var ba = buf_array();
		var range = safe_decode_range(ws["!ref"]);
		var dense = Array.isArray(ws);
		var cols = [];

		write_biff_rec(ba, 0x00, write_BOF_WK1(0x0406));
		write_biff_rec(ba, 0x06, write_RANGE(range));
		var max_R = Math.min(range.e.r, 8191);
		for(var R = range.s.r; R <= max_R; ++R) {
			var rr = encode_row(R);
			for(var C = range.s.c; C <= range.e.c; ++C) {
				if(R === range.s.r) cols[C] = encode_col(C);
				var ref = cols[C] + rr;
				var cell = dense ? (ws[R]||[])[C] : ws[ref];
				if(!cell || cell.t == "z") continue;
				/* TODO: formula records */
				if(cell.t == "n") {
					if((cell.v|0)==cell.v && cell.v >= -32768 && cell.v <= 32767) write_biff_rec(ba, 0x0d, write_INTEGER(R, C, cell.v));
					else write_biff_rec(ba, 0x0e, write_NUMBER(R, C, cell.v));
				} else {
					var str = format_cell(cell);
					write_biff_rec(ba, 0x0F, write_LABEL(R, C, str.slice(0, 239)));
				}
			}
		}

		write_biff_rec(ba, 0x01);
		return ba.end();
	}

	function book_to_wk3(wb, opts) {
		var o = opts || {};
		if(+o.codepage >= 0) set_cp(+o.codepage);
		if(o.type == "string") throw new Error("Cannot write WK3 to JS string");
		var ba = buf_array();

		write_biff_rec(ba, 0x00, write_BOF_WK3(wb));

		for(var i = 0, cnt = 0; i < wb.SheetNames.length; ++i) if((wb.Sheets[wb.SheetNames[i]] || {})["!ref"]) write_biff_rec(ba, 0x1b, write_XFORMAT_SHEETNAME(wb.SheetNames[i], cnt++));

		var wsidx = 0;
		for(i = 0; i < wb.SheetNames.length; ++i) {
			var ws = wb.Sheets[wb.SheetNames[i]];
			if(!ws || !ws["!ref"]) continue;
			var range = safe_decode_range(ws["!ref"]);
			var dense = Array.isArray(ws);
			var cols = [];
			var max_R = Math.min(range.e.r, 8191);
			for(var R = range.s.r; R <= max_R; ++R) {
				var rr = encode_row(R);
				for(var C = range.s.c; C <= range.e.c; ++C) {
					if(R === range.s.r) cols[C] = encode_col(C);
					var ref = cols[C] + rr;
					var cell = dense ? (ws[R]||[])[C] : ws[ref];
					if(!cell || cell.t == "z") continue;
					/* TODO: FORMULA19 NUMBER18 records */
					if(cell.t == "n") {
						write_biff_rec(ba, 0x17, write_NUMBER_17(R, C, wsidx, cell.v));
					} else {
						var str = format_cell(cell);
						/* TODO: max len? */
						write_biff_rec(ba, 0x16, write_LABEL_16(R, C, wsidx, str.slice(0, 239)));
					}
				}
			}
			++wsidx;
		}

		write_biff_rec(ba, 0x01);
		return ba.end();
	}


	function write_BOF_WK1(v) {
		var out = new_buf(2);
		out.write_shift(2, v);
		return out;
	}

	function write_BOF_WK3(wb) {
		var out = new_buf(26);
		out.write_shift(2, 0x1000);
		out.write_shift(2, 0x0004);
		out.write_shift(4, 0x0000);
		var rows = 0, cols = 0, wscnt = 0;
		for(var i = 0; i < wb.SheetNames.length; ++i) {
			var name = wb.SheetNames[i];
			var ws = wb.Sheets[name];
			if(!ws || !ws["!ref"]) continue;
			++wscnt;
			var range = decode_range(ws["!ref"]);
			if(rows < range.e.r) rows = range.e.r;
			if(cols < range.e.c) cols = range.e.c;
		}
		if(rows > 8191) rows = 8191;
		out.write_shift(2, rows);
		out.write_shift(1, wscnt);
		out.write_shift(1, cols);
		out.write_shift(2, 0x00);
		out.write_shift(2, 0x00);
		out.write_shift(1, 0x01);
		out.write_shift(1, 0x02);
		out.write_shift(4, 0);
		out.write_shift(4, 0);
		return out;
	}

	function parse_RANGE(blob, length, opts) {
		var o = {s:{c:0,r:0},e:{c:0,r:0}};
		if(length == 8 && opts.qpro) {
			o.s.c = blob.read_shift(1);
			blob.l++;
			o.s.r = blob.read_shift(2);
			o.e.c = blob.read_shift(1);
			blob.l++;
			o.e.r = blob.read_shift(2);
			return o;
		}
		o.s.c = blob.read_shift(2);
		o.s.r = blob.read_shift(2);
		if(length == 12 && opts.qpro) blob.l += 2;
		o.e.c = blob.read_shift(2);
		o.e.r = blob.read_shift(2);
		if(length == 12 && opts.qpro) blob.l += 2;
		if(o.s.c == 0xFFFF) o.s.c = o.e.c = o.s.r = o.e.r = 0;
		return o;
	}
	function write_RANGE(range) {
		var out = new_buf(8);
		out.write_shift(2, range.s.c);
		out.write_shift(2, range.s.r);
		out.write_shift(2, range.e.c);
		out.write_shift(2, range.e.r);
		return out;
	}

	function parse_cell(blob, length, opts) {
		var o = [{c:0,r:0}, {t:'n',v:0}, 0, 0];
		if(opts.qpro && opts.vers != 0x5120) {
			o[0].c = blob.read_shift(1);
			o[3] = blob.read_shift(1);
			o[0].r = blob.read_shift(2);
			blob.l+=2;
		} else if(opts.works) { // TODO: verify with more complex works3-4 examples
			o[0].c = blob.read_shift(2); o[0].r = blob.read_shift(2);
			o[2] = blob.read_shift(2);
		} else {
			o[2] = blob.read_shift(1);
			o[0].c = blob.read_shift(2); o[0].r = blob.read_shift(2);
		}
		return o;
	}

	function parse_LABEL(blob, length, opts) {
		var tgt = blob.l + length;
		var o = parse_cell(blob, length, opts);
		o[1].t = 's';
		if(opts.vers == 0x5120) {
			blob.l++;
			var len = blob.read_shift(1);
			o[1].v = blob.read_shift(len, 'utf8');
			return o;
		}
		if(opts.qpro) blob.l++;
		o[1].v = blob.read_shift(tgt - blob.l, 'cstr');
		return o;
	}
	function write_LABEL(R, C, s) {
		/* TODO: encoding */
		var o = new_buf(7 + s.length);
		o.write_shift(1, 0xFF);
		o.write_shift(2, C);
		o.write_shift(2, R);
		o.write_shift(1, 0x27); // ??
		for(var i = 0; i < o.length; ++i) {
			var cc = s.charCodeAt(i);
			o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
		}
		o.write_shift(1, 0);
		return o;
	}
	function parse_STRING(blob, length, opts) {
		var tgt = blob.l + length;
		var o = parse_cell(blob, length, opts);
		o[1].t = 's';
		if(opts.vers == 0x5120) {
			var len = blob.read_shift(1);
			o[1].v = blob.read_shift(len, 'utf8');
			return o;
		}
		o[1].v = blob.read_shift(tgt - blob.l, 'cstr');
		return o;
	}

	function parse_INTEGER(blob, length, opts) {
		var o = parse_cell(blob, length, opts);
		o[1].v = blob.read_shift(2, 'i');
		return o;
	}
	function write_INTEGER(R, C, v) {
		var o = new_buf(7);
		o.write_shift(1, 0xFF);
		o.write_shift(2, C);
		o.write_shift(2, R);
		o.write_shift(2, v, 'i');
		return o;
	}

	function parse_NUMBER(blob, length, opts) {
		var o = parse_cell(blob, length, opts);
		o[1].v = blob.read_shift(8, 'f');
		return o;
	}
	function write_NUMBER(R, C, v) {
		var o = new_buf(13);
		o.write_shift(1, 0xFF);
		o.write_shift(2, C);
		o.write_shift(2, R);
		o.write_shift(8, v, 'f');
		return o;
	}

	function parse_FORMULA(blob, length, opts) {
		var tgt = blob.l + length;
		var o = parse_cell(blob, length, opts);
		/* TODO: formula */
		o[1].v = blob.read_shift(8, 'f');
		if(opts.qpro) blob.l = tgt;
		else {
			var flen = blob.read_shift(2);
			wk1_fmla_to_csf(blob.slice(blob.l, blob.l + flen), o);
			blob.l += flen;
		}
		return o;
	}

	function wk1_parse_rc(B, V, col) {
		var rel = V & 0x8000;
		V &= ~0x8000;
		V = (rel ? B : 0) + ((V >= 0x2000) ? V - 0x4000 : V);
		return (rel ? "" : "$") + (col ? encode_col(V) : encode_row(V));
	}
	/* var oprec = [
		8, 8, 8, 8, 8, 8, 8, 8, 6, 4, 4, 5, 5, 7, 3, 3,
		3, 3, 3, 3, 1, 1, 2, 6, 8, 8, 8, 8, 8, 8, 8, 8
	]; */
	/* TODO: flesh out */
	var FuncTab = {
		0x1F: ["NA", 0],
		// 0x20: ["ERR", 0],
		0x21: ["ABS", 1],
		0x22: ["TRUNC", 1],
		0x23: ["SQRT", 1],
		0x24: ["LOG", 1],
		0x25: ["LN", 1],
		0x26: ["PI", 0],
		0x27: ["SIN", 1],
		0x28: ["COS", 1],
		0x29: ["TAN", 1],
		0x2A: ["ATAN2", 2],
		0x2B: ["ATAN", 1],
		0x2C: ["ASIN", 1],
		0x2D: ["ACOS", 1],
		0x2E: ["EXP", 1],
		0x2F: ["MOD", 2],
		// 0x30
		0x31: ["ISNA", 1],
		0x32: ["ISERR", 1],
		0x33: ["FALSE", 0],
		0x34: ["TRUE", 0],
		0x35: ["RAND", 0],
		// 0x36 DATE
		// 0x37 NOW
		// 0x38 PMT
		// 0x39 PV
		// 0x3A FV
		// 0x3B IF
		// 0x3C DAY
		// 0x3D MONTH
		// 0x3E YEAR
		0x3F: ["ROUND", 2],
		// 0x40 TIME
		// 0x41 HOUR
		// 0x42 MINUTE
		// 0x43 SECOND
		0x44: ["ISNUMBER", 1],
		0x45: ["ISTEXT", 1],
		0x46: ["LEN", 1],
		0x47: ["VALUE", 1],
		// 0x48: ["FIXED", ?? 1],
		0x49: ["MID", 3],
		0x4A: ["CHAR", 1],
		// 0x4B
		// 0x4C FIND
		// 0x4D DATEVALUE
		// 0x4E TIMEVALUE
		// 0x4F CELL
		0x50: ["SUM", 69],
		0x51: ["AVERAGEA", 69],
		0x52: ["COUNTA", 69],
		0x53: ["MINA", 69],
		0x54: ["MAXA", 69],
		// 0x55 VLOOKUP
		// 0x56 NPV
		// 0x57 VAR
		// 0x58 STD
		// 0x59 IRR
		// 0x5A HLOOKUP
		// 0x5B DSUM
		// 0x5C DAVERAGE
		// 0x5D DCOUNTA
		// 0x5E DMIN
		// 0x5F DMAX
		// 0x60 DVARP
		// 0x61 DSTDEVP
		// 0x62 INDEX
		// 0x63 COLS
		// 0x64 ROWS
		// 0x65 REPEAT
		0x66: ["UPPER", 1],
		0x67: ["LOWER", 1],
		// 0x68 LEFT
		// 0x69 RIGHT
		// 0x6A REPLACE
		0x6B: ["PROPER", 1],
		// 0x6C CELL
		0x6D: ["TRIM", 1],
		// 0x6E CLEAN
		0x6F: ["T", 1]
		// 0x70 V
	};
	var BinOpTab = [
		  "",   "",   "",   "",   "",   "",   "",   "", // eslint-disable-line no-mixed-spaces-and-tabs
		  "",  "+",  "-",  "*",  "/",  "^",  "=", "<>", // eslint-disable-line no-mixed-spaces-and-tabs
		"<=", ">=",  "<",  ">",   "",   "",   "",   "", // eslint-disable-line no-mixed-spaces-and-tabs
		 "&",   "",   "",   "",   "",   "",   "",   ""  // eslint-disable-line no-mixed-spaces-and-tabs
	];

	function wk1_fmla_to_csf(blob, o) {
		prep_blob(blob, 0);
		var out = [], argc = 0, R = "", C = "", argL = "", argR = "";
		while(blob.l < blob.length) {
			var cc = blob[blob.l++];
			switch(cc) {
				case 0x00: out.push(blob.read_shift(8, 'f')); break;
				case 0x01: {
					C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
					R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
					out.push(C + R);
				} break;
				case 0x02: {
					var c = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
					var r = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
					C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
					R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
					out.push(c + r + ":" + C + R);
				} break;
				case 0x03:
					if(blob.l < blob.length) { console.error("WK1 premature formula end"); return; }
					break;
				case 0x04: out.push("(" + out.pop() + ")"); break;
				case 0x05: out.push(blob.read_shift(2)); break;
				case 0x06: {
					/* TODO: text encoding */
					var Z = ""; while((cc = blob[blob.l++])) Z += String.fromCharCode(cc);
					out.push('"' + Z.replace(/"/g, '""') + '"');
				} break;

				case 0x08: out.push("-" + out.pop()); break;
				case 0x17: out.push("+" + out.pop()); break;
				case 0x16: out.push("NOT(" + out.pop() + ")"); break;

				case 0x14: case 0x15: {
					argR = out.pop(); argL = out.pop();
					out.push(["AND", "OR"][cc - 0x14] + "(" + argL + "," + argR + ")");
				} break;

				default:
					if(cc < 0x20 && BinOpTab[cc]) {
						argR = out.pop(); argL = out.pop();
						out.push(argL + BinOpTab[cc] + argR);
					} else if(FuncTab[cc]) {
						argc = FuncTab[cc][1];
						if(argc == 69) argc = blob[blob.l++];
						if(argc > out.length) { console.error("WK1 bad formula parse 0x" + cc.toString(16) + ":|" + out.join("|") + "|"); return; }
						var args = out.slice(-argc);
						out.length -= argc;
						out.push(FuncTab[cc][0] + "(" + args.join(",") + ")");
					}
					else if(cc <= 0x07) return console.error("WK1 invalid opcode " + cc.toString(16));
					else if(cc <= 0x18) return console.error("WK1 unsupported op " + cc.toString(16));
					else if(cc <= 0x1E) return console.error("WK1 invalid opcode " + cc.toString(16));
					else if(cc <= 0x73) return console.error("WK1 unsupported function opcode " + cc.toString(16));
					// possible future functions ??
					else return console.error("WK1 unrecognized opcode " + cc.toString(16));
			}
		}
		if(out.length == 1) o[1].f = "" + out[0];
		else console.error("WK1 bad formula parse |" + out.join("|") + "|");
	}


	function parse_cell_3(blob) {
		var o = [{c:0,r:0}, {t:'n',v:0}, 0];
		o[0].r = blob.read_shift(2); o[3] = blob[blob.l++]; o[0].c = blob[blob.l++];
		return o;
	}

	function parse_LABEL_16(blob, length) {
		var o = parse_cell_3(blob, length);
		o[1].t = 's';
		o[1].v = blob.read_shift(length - 4, 'cstr');
		return o;
	}
	function write_LABEL_16(R, C, wsidx, s) {
		/* TODO: encoding */
		var o = new_buf(6 + s.length);
		o.write_shift(2, R);
		o.write_shift(1, wsidx);
		o.write_shift(1, C);
		o.write_shift(1, 0x27);
		for(var i = 0; i < s.length; ++i) {
			var cc = s.charCodeAt(i);
			o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
		}
		o.write_shift(1, 0);
		return o;
	}

	function parse_NUMBER_18(blob, length) {
		var o = parse_cell_3(blob, length);
		o[1].v = blob.read_shift(2);
		var v = o[1].v >> 1;
		if(o[1].v & 0x1) {
			switch(v & 0x07) {
				case 0: v = (v >> 3) * 5000; break;
				case 1: v = (v >> 3) * 500; break;
				case 2: v = (v >> 3) / 20; break;
				case 3: v = (v >> 3) / 200; break;
				case 4: v = (v >> 3) / 2000; break;
				case 5: v = (v >> 3) / 20000; break;
				case 6: v = (v >> 3) / 16; break;
				case 7: v = (v >> 3) / 64; break;
			}
		}
		o[1].v = v;
		return o;
	}

	function parse_NUMBER_17(blob, length) {
		var o = parse_cell_3(blob, length);
		var v1 = blob.read_shift(4);
		var v2 = blob.read_shift(4);
		var e = blob.read_shift(2);
		if(e == 0xFFFF) {
			if(v1 === 0 && v2 === 0xC0000000) { o[1].t = "e"; o[1].v = 0x0F; } // ERR -> #VALUE!
			else if(v1 === 0 && v2 === 0xD0000000) { o[1].t = "e"; o[1].v = 0x2A; } // NA -> #N/A
			else o[1].v = 0;
			return o;
		}
		var s = e & 0x8000; e = (e&0x7FFF) - 16446;
		o[1].v = (1 - s*2) * (v2 * Math.pow(2, e+32) + v1 * Math.pow(2, e));
		return o;
	}
	function write_NUMBER_17(R, C, wsidx, v) {
		var o = new_buf(14);
		o.write_shift(2, R);
		o.write_shift(1, wsidx);
		o.write_shift(1, C);
		if(v == 0) {
			o.write_shift(4, 0);
			o.write_shift(4, 0);
			o.write_shift(2, 0xFFFF);
			return o;
		}
		var s = 0, e = 0, v1 = 0, v2 = 0;
		if(v < 0) { s = 1; v = -v; }
		e = Math.log2(v) | 0;
		v /= Math.pow(2, e-31);
		v2 = (v)>>>0;
		if((v2&0x80000000) == 0) { v/=2; ++e; v2 = v >>> 0; }
		v -= v2;
		v2 |= 0x80000000;
		v2 >>>= 0;
		v *= Math.pow(2, 32);
		v1 = v>>>0;
		o.write_shift(4, v1);
		o.write_shift(4, v2);
		e += 0x3FFF + (s ? 0x8000 : 0);
		o.write_shift(2, e);
		return o;
	}

	function parse_FORMULA_19(blob, length) {
		var o = parse_NUMBER_17(blob, 14);
		blob.l += length - 14; /* TODO: WK3 formula */
		return o;
	}

	function parse_NUMBER_25(blob, length) {
		var o = parse_cell_3(blob, length);
		var v1 = blob.read_shift(4);
		o[1].v = v1 >> 6;
		return o;
	}

	function parse_NUMBER_27(blob, length) {
		var o = parse_cell_3(blob, length);
		var v1 = blob.read_shift(8,'f');
		o[1].v = v1;
		return o;
	}

	function parse_FORMULA_28(blob, length) {
		var o = parse_NUMBER_27(blob, 12);
		blob.l += length - 12; /* TODO: formula */
		return o;
	}

	function parse_SHEETNAMECS(blob, length) {
		return blob[blob.l + length - 1] == 0 ? blob.read_shift(length, 'cstr') : "";
	}

	function parse_SHEETNAMELP(blob, length) {
		var len = blob[blob.l++];
		if(len > length - 1) len = length - 1;
		var o = ""; while(o.length < len) o += String.fromCharCode(blob[blob.l++]);
		return o;
	}

	function parse_SHEETINFOQP(blob, length, opts) {
		if(!opts.qpro || length < 21) return;
		var id = blob.read_shift(1);
		blob.l += 17;
		blob.l += 1; //var len = blob.read_shift(1);
		blob.l += 2;
		var nm = blob.read_shift(length - 21, 'cstr');
		return [id, nm];
	}

	function parse_XFORMAT(blob, length) {
		var o = {}, tgt = blob.l + length;
		while(blob.l < tgt) {
			var dt = blob.read_shift(2);
			if(dt == 0x36b0) {
				o[dt] = [0, ""];
				o[dt][0] = blob.read_shift(2);
				while(blob[blob.l]) { o[dt][1] += String.fromCharCode(blob[blob.l]); blob.l++; } blob.l++;
			}
			// TODO: 0x3a99 ??
		}
		return o;
	}
	function write_XFORMAT_SHEETNAME(name, wsidx) {
		var out = new_buf(5 + name.length);
		out.write_shift(2, 0x36b0);
		out.write_shift(2, wsidx);
		for(var i = 0; i < name.length; ++i) {
			var cc = name.charCodeAt(i);
			out[out.l++] = cc > 0x7F ? 0x5F : cc;
		}
		out[out.l++] = 0;
		return out;
	}

	var WK1Enum = {
0x0000: { n:"BOF", f:parseuint16 },
0x0001: { n:"EOF" },
0x0002: { n:"CALCMODE" },
0x0003: { n:"CALCORDER" },
0x0004: { n:"SPLIT" },
0x0005: { n:"SYNC" },
0x0006: { n:"RANGE", f:parse_RANGE },
0x0007: { n:"WINDOW1" },
0x0008: { n:"COLW1" },
0x0009: { n:"WINTWO" },
0x000A: { n:"COLW2" },
0x000B: { n:"NAME" },
0x000C: { n:"BLANK" },
0x000D: { n:"INTEGER", f:parse_INTEGER },
0x000E: { n:"NUMBER", f:parse_NUMBER },
0x000F: { n:"LABEL", f:parse_LABEL },
0x0010: { n:"FORMULA", f:parse_FORMULA },
0x0018: { n:"TABLE" },
0x0019: { n:"ORANGE" },
0x001A: { n:"PRANGE" },
0x001B: { n:"SRANGE" },
0x001C: { n:"FRANGE" },
0x001D: { n:"KRANGE1" },
0x0020: { n:"HRANGE" },
0x0023: { n:"KRANGE2" },
0x0024: { n:"PROTEC" },
0x0025: { n:"FOOTER" },
0x0026: { n:"HEADER" },
0x0027: { n:"SETUP" },
0x0028: { n:"MARGINS" },
0x0029: { n:"LABELFMT" },
0x002A: { n:"TITLES" },
0x002B: { n:"SHEETJS" },
0x002D: { n:"GRAPH" },
0x002E: { n:"NGRAPH" },
0x002F: { n:"CALCCOUNT" },
0x0030: { n:"UNFORMATTED" },
0x0031: { n:"CURSORW12" },
0x0032: { n:"WINDOW" },
0x0033: { n:"STRING", f:parse_STRING },
0x0037: { n:"PASSWORD" },
0x0038: { n:"LOCKED" },
0x003C: { n:"QUERY" },
0x003D: { n:"QUERYNAME" },
0x003E: { n:"PRINT" },
0x003F: { n:"PRINTNAME" },
0x0040: { n:"GRAPH2" },
0x0041: { n:"GRAPHNAME" },
0x0042: { n:"ZOOM" },
0x0043: { n:"SYMSPLIT" },
0x0044: { n:"NSROWS" },
0x0045: { n:"NSCOLS" },
0x0046: { n:"RULER" },
0x0047: { n:"NNAME" },
0x0048: { n:"ACOMM" },
0x0049: { n:"AMACRO" },
0x004A: { n:"PARSE" },
0x0066: { n:"PRANGES??" },
0x0067: { n:"RRANGES??" },
0x0068: { n:"FNAME??" },
0x0069: { n:"MRANGES??" },
0x00CC: { n:"SHEETNAMECS", f:parse_SHEETNAMECS },
0x00DE: { n:"SHEETNAMELP", f:parse_SHEETNAMELP },
0x00FF: { n:"BOF", f:parseuint16 },
0xFFFF: { n:"" }
	};

	var WK3Enum = {
0x0000: { n:"BOF" },
0x0001: { n:"EOF" },
0x0002: { n:"PASSWORD" },
0x0003: { n:"CALCSET" },
0x0004: { n:"WINDOWSET" },
0x0005: { n:"SHEETCELLPTR" },
0x0006: { n:"SHEETLAYOUT" },
0x0007: { n:"COLUMNWIDTH" },
0x0008: { n:"HIDDENCOLUMN" },
0x0009: { n:"USERRANGE" },
0x000A: { n:"SYSTEMRANGE" },
0x000B: { n:"ZEROFORCE" },
0x000C: { n:"SORTKEYDIR" },
0x000D: { n:"FILESEAL" },
0x000E: { n:"DATAFILLNUMS" },
0x000F: { n:"PRINTMAIN" },
0x0010: { n:"PRINTSTRING" },
0x0011: { n:"GRAPHMAIN" },
0x0012: { n:"GRAPHSTRING" },
0x0013: { n:"??" },
0x0014: { n:"ERRCELL" },
0x0015: { n:"NACELL" },
0x0016: { n:"LABEL16", f:parse_LABEL_16},
0x0017: { n:"NUMBER17", f:parse_NUMBER_17 },
0x0018: { n:"NUMBER18", f:parse_NUMBER_18 },
0x0019: { n:"FORMULA19", f:parse_FORMULA_19},
0x001A: { n:"FORMULA1A" },
0x001B: { n:"XFORMAT", f:parse_XFORMAT },
0x001C: { n:"DTLABELMISC" },
0x001D: { n:"DTLABELCELL" },
0x001E: { n:"GRAPHWINDOW" },
0x001F: { n:"CPA" },
0x0020: { n:"LPLAUTO" },
0x0021: { n:"QUERY" },
0x0022: { n:"HIDDENSHEET" },
0x0023: { n:"??" },
0x0025: { n:"NUMBER25", f:parse_NUMBER_25 },
0x0026: { n:"??" },
0x0027: { n:"NUMBER27", f:parse_NUMBER_27 },
0x0028: { n:"FORMULA28", f:parse_FORMULA_28 },
0x008E: { n:"??" },
0x0093: { n:"??" },
0x0096: { n:"??" },
0x0097: { n:"??" },
0x0098: { n:"??" },
0x0099: { n:"??" },
0x009A: { n:"??" },
0x009B: { n:"??" },
0x009C: { n:"??" },
0x00A3: { n:"??" },
0x00AE: { n:"??" },
0x00AF: { n:"??" },
0x00B0: { n:"??" },
0x00B1: { n:"??" },
0x00B8: { n:"??" },
0x00B9: { n:"??" },
0x00BA: { n:"??" },
0x00BB: { n:"??" },
0x00BC: { n:"??" },
0x00C3: { n:"??" },
0x00C9: { n:"??" },
0x00CC: { n:"SHEETNAMECS", f:parse_SHEETNAMECS },
0x00CD: { n:"??" },
0x00CE: { n:"??" },
0x00CF: { n:"??" },
0x00D0: { n:"??" },
0x0100: { n:"??" },
0x0103: { n:"??" },
0x0104: { n:"??" },
0x0105: { n:"??" },
0x0106: { n:"??" },
0x0107: { n:"??" },
0x0109: { n:"??" },
0x010A: { n:"??" },
0x010B: { n:"??" },
0x010C: { n:"??" },
0x010E: { n:"??" },
0x010F: { n:"??" },
0x0180: { n:"??" },
0x0185: { n:"??" },
0x0186: { n:"??" },
0x0189: { n:"??" },
0x018C: { n:"??" },
0x0200: { n:"??" },
0x0202: { n:"??" },
0x0201: { n:"??" },
0x0204: { n:"??" },
0x0205: { n:"??" },
0x0280: { n:"??" },
0x0281: { n:"??" },
0x0282: { n:"??" },
0x0283: { n:"??" },
0x0284: { n:"??" },
0x0285: { n:"??" },
0x0286: { n:"??" },
0x0287: { n:"??" },
0x0288: { n:"??" },
0x0292: { n:"??" },
0x0293: { n:"??" },
0x0294: { n:"??" },
0x0295: { n:"??" },
0x0296: { n:"??" },
0x0299: { n:"??" },
0x029A: { n:"??" },
0x0300: { n:"??" },
0x0304: { n:"??" },
0x0601: { n:"SHEETINFOQP", f:parse_SHEETINFOQP },
0x0640: { n:"??" },
0x0642: { n:"??" },
0x0701: { n:"??" },
0x0702: { n:"??" },
0x0703: { n:"??" },
0x0704: { n:"??" },
0x0780: { n:"??" },
0x0800: { n:"??" },
0x0801: { n:"??" },
0x0804: { n:"??" },
0x0A80: { n:"??" },
0x2AF6: { n:"??" },
0x3231: { n:"??" },
0x6E49: { n:"??" },
0x6F44: { n:"??" },
0xFFFF: { n:"" }
	};

	/* QPW uses a different set of record types */
	function qpw_to_workbook_buf(d, opts) {
		prep_blob(d, 0);
		var o = opts || {};
		if(DENSE != null && o.dense == null) o.dense = DENSE;
		var s = ((o.dense ? [] : {}));
		var SST = [], sname = "", formulae = [];
		var range = {s:{r:-1,c:-1}, e:{r:-1,c:-1}};
		var cnt = 0, type = 0, C = 0, R = 0;
		var wb = { SheetNames: [], Sheets: {} };
		outer: while(d.l < d.length) {
			var RT = d.read_shift(2), length = d.read_shift(2);
			var p = d.slice(d.l, d.l + length);
			prep_blob(p, 0);
			switch(RT) {
				case 0x01: /* BOF */
					if(p.read_shift(4) != 0x39575051) throw "Bad QPW9 BOF!";
					break;
				case 0x02: /* EOF */ break outer;

				/* TODO: The behavior here should be consistent with Numbers: QP Notebook ~ .TN.SheetArchive, QP Sheet ~ .TST.TableModelArchive */
				case 0x0401: /* BON */ break;
				case 0x0402: /* EON */ /* TODO: backfill missing sheets based on BON cnt */ break;

				case 0x0407: { /* SST */
					p.l += 12;
					while(p.l < p.length) {
						cnt = p.read_shift(2);
						type = p.read_shift(1);
						SST.push(p.read_shift(cnt, 'cstr'));
					}
				} break;
				case 0x0408: { /* FORMULAE */
					//p.l += 12;
					//while(p.l < p.length) {
					//	cnt = p.read_shift(2);
					//	formulae.push(p.slice(p.l, p.l + cnt + 1)); p.l += cnt + 1;
					//}
				} break;

				case 0x0601: { /* BOS */
					var sidx = p.read_shift(2);
					s = ((o.dense ? [] : {}));
					range.s.c = p.read_shift(2);
					range.e.c = p.read_shift(2);
					range.s.r = p.read_shift(4);
					range.e.r = p.read_shift(4);
					p.l += 4;
					if(p.l + 2 < p.length) {
						cnt = p.read_shift(2);
						type = p.read_shift(1);
						sname = cnt == 0 ? "" : p.read_shift(cnt, 'cstr');
					}
					if(!sname) sname = encode_col(sidx);
					/* TODO: backfill empty sheets */
				} break;
				case 0x0602: { /* EOS */
					/* NOTE: QP valid range A1:IV1000000 */
					if(range.s.c > 0xFF || range.s.r > 999999) break;
					if(range.e.c < range.s.c) range.e.c = range.s.c;
					if(range.e.r < range.s.r) range.e.r = range.s.r;
					s["!ref"] = encode_range(range);
					book_append_sheet(wb, s, sname); // TODO: a barrel roll
				} break;

				case 0x0A01: { /* COL (like XLS Row, modulo the layout transposition) */
					C = p.read_shift(2);
					if(range.e.c < C) range.e.c = C;
					if(range.s.c > C) range.s.c = C;
					R = p.read_shift(4);
					if(range.s.r > R) range.s.r = R;
					R = p.read_shift(4);
					if(range.e.r < R) range.e.r = R;
				} break;

				case 0x0C01: { /* MulCells (like XLS MulRK, but takes advantage of common column data patterns) */
					R = p.read_shift(4), cnt = p.read_shift(4);
					if(range.s.r > R) range.s.r = R;
					if(range.e.r < R + cnt - 1) range.e.r = R + cnt - 1;
					while(p.l < p.length) {
						var cell = { t: "z" };
						var flags = p.read_shift(1);
						if(flags & 0x80) p.l += 2;
						var mul = (flags & 0x40) ? p.read_shift(2) - 1: 0;
						switch(flags & 0x1F) {
							case 1: break;
							case 2: cell = { t: "n", v: p.read_shift(2) }; break;
							case 3: cell = { t: "n", v: p.read_shift(2, 'i') }; break;
							case 5: cell = { t: "n", v: p.read_shift(8, 'f') }; break;
							case 7: cell = { t: "s", v: SST[type = p.read_shift(4) - 1] }; break;
							case 8: cell = { t: "n", v: p.read_shift(8, 'f') }; p.l += 2; /* cell.f = formulae[p.read_shift(4)]; */ p.l += 4; break;
							default: throw "Unrecognized QPW cell type " + (flags & 0x1F);
						}
						var delta = 0;
						if(flags & 0x20) switch(flags & 0x1F) {
							case 2: delta = p.read_shift(2); break;
							case 3: delta = p.read_shift(2, 'i'); break;
							case 7: delta = p.read_shift(2); break;
							default: throw "Unsupported delta for QPW cell type " + (flags & 0x1F);
						}
						if(!(!o.sheetStubs && cell.t == "z")) {
							if(Array.isArray(s)) {
								if(!s[R]) s[R] = [];
								s[R][C] = cell;
							} else s[encode_cell({r:R, c:C})] = cell;
						}
						++R; --cnt;
						while(mul-- > 0 && cnt >= 0) {
							if(flags & 0x20) switch(flags & 0x1F) {
								case 2: cell = { t: "n", v: (cell.v + delta) & 0xFFFF }; break;
								case 3: cell = { t: "n", v: (cell.v + delta) & 0xFFFF }; if(cell.v > 0x7FFF) cell.v -= 0x10000; break;
								case 7: cell = { t: "s", v: SST[type = (type + delta) >>> 0] }; break;
								default: throw "Cannot apply delta for QPW cell type " + (flags & 0x1F);
							} else switch(flags & 0x1F) {
								case 1: cell = { t: "z" }; break;
								case 2: cell = { t: "n", v: p.read_shift(2) }; break;
								case 7: cell = { t: "s", v: SST[type = p.read_shift(4) - 1] }; break;
								default: throw "Cannot apply repeat for QPW cell type " + (flags & 0x1F);
							}
							if(!(!o.sheetStubs && cell.t == "z")) {
								if(Array.isArray(s)) {
									if(!s[R]) s[R] = [];
									s[R][C] = cell;
								} else s[encode_cell({r:R, c:C})] = cell;
							}
							++R; --cnt;
						}
					}
				} break;

				default: break;
			}
			d.l += length;
		}
		return wb;
	}

	return {
		sheet_to_wk1: sheet_to_wk1,
		book_to_wk3: book_to_wk3,
		to_workbook: lotus_to_workbook
	};
})();
/* 18.4.7 rPr CT_RPrElt */
function parse_rpr(rpr) {
	var font = {}, m = rpr.match(tagregex), i = 0;
	var pass = false;
	if(m) for(;i!=m.length; ++i) {
		var y = parsexmltag(m[i]);
		switch(y[0].replace(/\w*:/g,"")) {
			/* 18.8.12 condense CT_BooleanProperty */
			/* ** not required . */
			case '<condense': break;
			/* 18.8.17 extend CT_BooleanProperty */
			/* ** not required . */
			case '<extend': break;
			/* 18.8.36 shadow CT_BooleanProperty */
			/* ** not required . */
			case '<shadow':
				if(!y.val) break;
				/* falls through */
			case '<shadow>':
			case '<shadow/>': font.shadow = 1; break;
			case '</shadow>': break;

			/* 18.4.1 charset CT_IntProperty TODO */
			case '<charset':
				if(y.val == '1') break;
				font.cp = CS2CP[parseInt(y.val, 10)];
				break;

			/* 18.4.2 outline CT_BooleanProperty TODO */
			case '<outline':
				if(!y.val) break;
				/* falls through */
			case '<outline>':
			case '<outline/>': font.outline = 1; break;
			case '</outline>': break;

			/* 18.4.5 rFont CT_FontName */
			case '<rFont': font.name = y.val; break;

			/* 18.4.11 sz CT_FontSize */
			case '<sz': font.sz = y.val; break;

			/* 18.4.10 strike CT_BooleanProperty */
			case '<strike':
				if(!y.val) break;
				/* falls through */
			case '<strike>':
			case '<strike/>': font.strike = 1; break;
			case '</strike>': break;

			/* 18.4.13 u CT_UnderlineProperty */
			case '<u':
				if(!y.val) break;
				switch(y.val) {
					case 'double': font.uval = "double"; break;
					case 'singleAccounting': font.uval = "single-accounting"; break;
					case 'doubleAccounting': font.uval = "double-accounting"; break;
				}
				/* falls through */
			case '<u>':
			case '<u/>': font.u = 1; break;
			case '</u>': break;

			/* 18.8.2 b */
			case '<b':
				if(y.val == '0') break;
				/* falls through */
			case '<b>':
			case '<b/>': font.b = 1; break;
			case '</b>': break;

			/* 18.8.26 i */
			case '<i':
				if(y.val == '0') break;
				/* falls through */
			case '<i>':
			case '<i/>': font.i = 1; break;
			case '</i>': break;

			/* 18.3.1.15 color CT_Color TODO: tint, theme, auto, indexed */
			case '<color':
				if(y.rgb) font.color = y.rgb.slice(2,8);
				break;
			case '<color>': case '<color/>': case '</color>': break;

			/* 18.8.18 family ST_FontFamily */
			case '<family': font.family = y.val; break;
			case '<family>': case '<family/>': case '</family>': break;

			/* 18.4.14 vertAlign CT_VerticalAlignFontProperty TODO */
			case '<vertAlign': font.valign = y.val; break;
			case '<vertAlign>': case '<vertAlign/>': case '</vertAlign>': break;

			/* 18.8.35 scheme CT_FontScheme TODO */
			case '<scheme': break;
			case '<scheme>': case '<scheme/>': case '</scheme>': break;

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': break;
			case '<ext': pass = true; break;
			case '</ext>': pass = false; break;
			default:
				if(y[0].charCodeAt(1) !== 47 && !pass) throw new Error('Unrecognized rich format ' + y[0]);
		}
	}
	return font;
}

var parse_rs = (function() {
	var tregex = matchtag("t"), rpregex = matchtag("rPr");
	/* 18.4.4 r CT_RElt */
	function parse_r(r) {
		/* 18.4.12 t ST_Xstring */
		var t = r.match(tregex)/*, cp = 65001*/;
		if(!t) return {t:"s", v:""};

		var o = ({t:'s', v:unescapexml(t[1])});
		var rpr = r.match(rpregex);
		if(rpr) o.s = parse_rpr(rpr[1]);
		return o;
	}
	var rregex = /<(?:\w+:)?r>/g, rend = /<\/(?:\w+:)?r>/;
	return function parse_rs(rs) {
		return rs.replace(rregex,"").split(rend).map(parse_r).filter(function(r) { return r.v; });
	};
})();


/* Parse a list of <r> tags */
var rs_to_html = (function parse_rs_factory() {
	var nlregex = /(\r\n|\n)/g;
	function parse_rpr2(font, intro, outro) {
		var style = [];

		if(font.u) style.push("text-decoration: underline;");
		if(font.uval) style.push("text-underline-style:" + font.uval + ";");
		if(font.sz) style.push("font-size:" + font.sz + "pt;");
		if(font.outline) style.push("text-effect: outline;");
		if(font.shadow) style.push("text-shadow: auto;");
		intro.push('<span style="' + style.join("") + '">');

		if(font.b) { intro.push("<b>"); outro.push("</b>"); }
		if(font.i) { intro.push("<i>"); outro.push("</i>"); }
		if(font.strike) { intro.push("<s>"); outro.push("</s>"); }

		var align = font.valign || "";
		if(align == "superscript" || align == "super") align = "sup";
		else if(align == "subscript") align = "sub";
		if(align != "") { intro.push("<" + align + ">"); outro.push("</" + align + ">"); }

		outro.push("</span>");
		return font;
	}

	/* 18.4.4 r CT_RElt */
	function r_to_html(r) {
		var terms = [[],r.v,[]];
		if(!r.v) return "";

		if(r.s) parse_rpr2(r.s, terms[0], terms[2]);

		return terms[0].join("") + terms[1].replace(nlregex,'<br/>') + terms[2].join("");
	}

	return function parse_rs(rs) {
		return rs.map(r_to_html).join("");
	};
})();

/* 18.4.8 si CT_Rst */
var sitregex = /<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g, sirregex = /<(?:\w+:)?r>/;
var sirphregex = /<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;
function parse_si(x, opts) {
	var html = opts ? opts.cellHTML : true;
	var z = {};
	if(!x) return { t: "" };
	//var y;
	/* 18.4.12 t ST_Xstring (Plaintext String) */
	// TODO: is whitespace actually valid here?
	if(x.match(/^\s*<(?:\w+:)?t[^>]*>/)) {
		z.t = unescapexml(utf8read(x.slice(x.indexOf(">")+1).split(/<\/(?:\w+:)?t>/)[0]||""), true);
		z.r = utf8read(x);
		if(html) z.h = escapehtml(z.t);
	}
	/* 18.4.4 r CT_RElt (Rich Text Run) */
	else if((/*y = */x.match(sirregex))) {
		z.r = utf8read(x);
		z.t = unescapexml(utf8read((x.replace(sirphregex, '').match(sitregex)||[]).join("").replace(tagregex,"")), true);
		if(html) z.h = rs_to_html(parse_rs(z.r));
	}
	/* 18.4.3 phoneticPr CT_PhoneticPr (TODO: needed for Asian support) */
	/* 18.4.6 rPh CT_PhoneticRun (TODO: needed for Asian support) */
	return z;
}

/* 18.4 Shared String Table */
var sstr0 = /<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/;
var sstr1 = /<(?:\w+:)?(?:si|sstItem)>/g;
var sstr2 = /<\/(?:\w+:)?(?:si|sstItem)>/;
function parse_sst_xml(data, opts) {
	var s = ([]), ss = "";
	if(!data) return s;
	/* 18.4.9 sst CT_Sst */
	var sst = data.match(sstr0);
	if(sst) {
		ss = sst[2].replace(sstr1,"").split(sstr2);
		for(var i = 0; i != ss.length; ++i) {
			var o = parse_si(ss[i].trim(), opts);
			if(o != null) s[s.length] = o;
		}
		sst = parsexmltag(sst[1]); s.Count = sst.count; s.Unique = sst.uniqueCount;
	}
	return s;
}

var straywsregex = /^\s|\s$|[\t\n\r]/;
function write_sst_xml(sst, opts) {
	if(!opts.bookSST) return "";
	var o = [XML_HEADER];
	o[o.length] = (writextag('sst', null, {
		xmlns: XMLNS_main[0],
		count: sst.Count,
		uniqueCount: sst.Unique
	}));
	for(var i = 0; i != sst.length; ++i) { if(sst[i] == null) continue;
		var s = sst[i];
		var sitag = "<si>";
		if(s.r) sitag += s.r;
		else {
			sitag += "<t";
			if(!s.t) s.t = "";
			if(typeof s.t !== "string") s.t = String(s.t);
			if(s.t.match(straywsregex)) sitag += ' xml:space="preserve"';
			sitag += ">" + escapexml(s.t) + "</t>";
		}
		sitag += "</si>";
		o[o.length] = (sitag);
	}
	if(o.length>2){ o[o.length] = ('</sst>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* [MS-XLSB] 2.4.221 BrtBeginSst */
function parse_BrtBeginSst(data) {
	return [data.read_shift(4), data.read_shift(4)];
}

/* [MS-XLSB] 2.1.7.45 Shared Strings */
function parse_sst_bin(data, opts) {
	var s = ([]);
	var pass = false;
	recordhopper(data, function hopper_sst(val, R, RT) {
		switch(RT) {
			case 0x009F: /* BrtBeginSst */
				s.Count = val[0]; s.Unique = val[1]; break;
			case 0x0013: /* BrtSSTItem */
				s.push(val); break;
			case 0x00A0: /* BrtEndSst */
				return true;

			case 0x0023: /* BrtFRTBegin */
				pass = true; break;
			case 0x0024: /* BrtFRTEnd */
				pass = false; break;

			default:
				if(R.T){}
				if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
		}
	});
	return s;
}

function write_BrtBeginSst(sst, o) {
	if(!o) o = new_buf(8);
	o.write_shift(4, sst.Count);
	o.write_shift(4, sst.Unique);
	return o;
}

var write_BrtSSTItem = write_RichStr;

function write_sst_bin(sst) {
	var ba = buf_array();
	write_record(ba, 0x009F /* BrtBeginSst */, write_BrtBeginSst(sst));
	for(var i = 0; i < sst.length; ++i) write_record(ba, 0x0013 /* BrtSSTItem */, write_BrtSSTItem(sst[i]));
	/* FRTSST */
	write_record(ba, 0x00A0 /* BrtEndSst */);
	return ba.end();
}
function _JS2ANSI(str) {
	if(typeof $cptable !== 'undefined') return $cptable.utils.encode(current_ansi, str);
	var o = [], oo = str.split("");
	for(var i = 0; i < oo.length; ++i) o[i] = oo[i].charCodeAt(0);
	return o;
}

/* [MS-OFFCRYPTO] 2.1.4 Version */
function parse_CRYPTOVersion(blob, length) {
	var o = {};
	o.Major = blob.read_shift(2);
	o.Minor = blob.read_shift(2);
if(length >= 4) blob.l += length - 4;
	return o;
}

/* [MS-OFFCRYPTO] 2.1.5 DataSpaceVersionInfo */
function parse_DataSpaceVersionInfo(blob) {
	var o = {};
	o.id = blob.read_shift(0, 'lpp4');
	o.R = parse_CRYPTOVersion(blob, 4);
	o.U = parse_CRYPTOVersion(blob, 4);
	o.W = parse_CRYPTOVersion(blob, 4);
	return o;
}

/* [MS-OFFCRYPTO] 2.1.6.1 DataSpaceMapEntry Structure */
function parse_DataSpaceMapEntry(blob) {
	var len = blob.read_shift(4);
	var end = blob.l + len - 4;
	var o = {};
	var cnt = blob.read_shift(4);
	var comps = [];
	/* [MS-OFFCRYPTO] 2.1.6.2 DataSpaceReferenceComponent Structure */
	while(cnt-- > 0) comps.push({ t: blob.read_shift(4), v: blob.read_shift(0, 'lpp4') });
	o.name = blob.read_shift(0, 'lpp4');
	o.comps = comps;
	if(blob.l != end) throw new Error("Bad DataSpaceMapEntry: " + blob.l + " != " + end);
	return o;
}

/* [MS-OFFCRYPTO] 2.1.6 DataSpaceMap */
function parse_DataSpaceMap(blob) {
	var o = [];
	blob.l += 4; // must be 0x8
	var cnt = blob.read_shift(4);
	while(cnt-- > 0) o.push(parse_DataSpaceMapEntry(blob));
	return o;
}

/* [MS-OFFCRYPTO] 2.1.7 DataSpaceDefinition */
function parse_DataSpaceDefinition(blob) {
	var o = [];
	blob.l += 4; // must be 0x8
	var cnt = blob.read_shift(4);
	while(cnt-- > 0) o.push(blob.read_shift(0, 'lpp4'));
	return o;
}

/* [MS-OFFCRYPTO] 2.1.8 DataSpaceDefinition */
function parse_TransformInfoHeader(blob) {
	var o = {};
	/*var len = */blob.read_shift(4);
	blob.l += 4; // must be 0x1
	o.id = blob.read_shift(0, 'lpp4');
	o.name = blob.read_shift(0, 'lpp4');
	o.R = parse_CRYPTOVersion(blob, 4);
	o.U = parse_CRYPTOVersion(blob, 4);
	o.W = parse_CRYPTOVersion(blob, 4);
	return o;
}

function parse_Primary(blob) {
	/* [MS-OFFCRYPTO] 2.2.6 IRMDSTransformInfo */
	var hdr = parse_TransformInfoHeader(blob);
	/* [MS-OFFCRYPTO] 2.1.9 EncryptionTransformInfo */
	hdr.ename = blob.read_shift(0, '8lpp4');
	hdr.blksz = blob.read_shift(4);
	hdr.cmode = blob.read_shift(4);
	if(blob.read_shift(4) != 0x04) throw new Error("Bad !Primary record");
	return hdr;
}

/* [MS-OFFCRYPTO] 2.3.2 Encryption Header */
function parse_EncryptionHeader(blob, length) {
	var tgt = blob.l + length;
	var o = {};
	o.Flags = (blob.read_shift(4) & 0x3F);
	blob.l += 4;
	o.AlgID = blob.read_shift(4);
	var valid = false;
	switch(o.AlgID) {
		case 0x660E: case 0x660F: case 0x6610: valid = (o.Flags == 0x24); break;
		case 0x6801: valid = (o.Flags == 0x04); break;
		case 0: valid = (o.Flags == 0x10 || o.Flags == 0x04 || o.Flags == 0x24); break;
		default: throw 'Unrecognized encryption algorithm: ' + o.AlgID;
	}
	if(!valid) throw new Error("Encryption Flags/AlgID mismatch");
	o.AlgIDHash = blob.read_shift(4);
	o.KeySize = blob.read_shift(4);
	o.ProviderType = blob.read_shift(4);
	blob.l += 8;
	o.CSPName = blob.read_shift((tgt-blob.l)>>1, 'utf16le');
	blob.l = tgt;
	return o;
}

/* [MS-OFFCRYPTO] 2.3.3 Encryption Verifier */
function parse_EncryptionVerifier(blob, length) {
	var o = {}, tgt = blob.l + length;
	blob.l += 4; // SaltSize must be 0x10
	o.Salt = blob.slice(blob.l, blob.l+16); blob.l += 16;
	o.Verifier = blob.slice(blob.l, blob.l+16); blob.l += 16;
	/*var sz = */blob.read_shift(4);
	o.VerifierHash = blob.slice(blob.l, tgt); blob.l = tgt;
	return o;
}

/* [MS-OFFCRYPTO] 2.3.4.* EncryptionInfo Stream */
function parse_EncryptionInfo(blob) {
	var vers = parse_CRYPTOVersion(blob);
	switch(vers.Minor) {
		case 0x02: return [vers.Minor, parse_EncInfoStd(blob, vers)];
		case 0x03: return [vers.Minor, parse_EncInfoExt(blob, vers)];
		case 0x04: return [vers.Minor, parse_EncInfoAgl(blob, vers)];
	}
	throw new Error("ECMA-376 Encrypted file unrecognized Version: " + vers.Minor);
}

/* [MS-OFFCRYPTO] 2.3.4.5  EncryptionInfo Stream (Standard Encryption) */
function parse_EncInfoStd(blob) {
	var flags = blob.read_shift(4);
	if((flags & 0x3F) != 0x24) throw new Error("EncryptionInfo mismatch");
	var sz = blob.read_shift(4);
	//var tgt = blob.l + sz;
	var hdr = parse_EncryptionHeader(blob, sz);
	var verifier = parse_EncryptionVerifier(blob, blob.length - blob.l);
	return { t:"Std", h:hdr, v:verifier };
}
/* [MS-OFFCRYPTO] 2.3.4.6  EncryptionInfo Stream (Extensible Encryption) */
function parse_EncInfoExt() { throw new Error("File is password-protected: ECMA-376 Extensible"); }
/* [MS-OFFCRYPTO] 2.3.4.10 EncryptionInfo Stream (Agile Encryption) */
function parse_EncInfoAgl(blob) {
	var KeyData = ["saltSize","blockSize","keyBits","hashSize","cipherAlgorithm","cipherChaining","hashAlgorithm","saltValue"];
	blob.l+=4;
	var xml = blob.read_shift(blob.length - blob.l, 'utf8');
	var o = {};
	xml.replace(tagregex, function xml_agile(x) {
		var y = parsexmltag(x);
		switch(strip_ns(y[0])) {
			case '<?xml': break;
			case '<encryption': case '</encryption>': break;
			case '<keyData': KeyData.forEach(function(k) { o[k] = y[k]; }); break;
			case '<dataIntegrity': o.encryptedHmacKey = y.encryptedHmacKey; o.encryptedHmacValue = y.encryptedHmacValue; break;
			case '<keyEncryptors>': case '<keyEncryptors': o.encs = []; break;
			case '</keyEncryptors>': break;

			case '<keyEncryptor': o.uri = y.uri; break;
			case '</keyEncryptor>': break;
			case '<encryptedKey': o.encs.push(y); break;
			default: throw y[0];
		}
	});
	return o;
}

/* [MS-OFFCRYPTO] 2.3.5.1 RC4 CryptoAPI Encryption Header */
function parse_RC4CryptoHeader(blob, length) {
	var o = {};
	var vers = o.EncryptionVersionInfo = parse_CRYPTOVersion(blob, 4); length -= 4;
	if(vers.Minor != 2) throw new Error('unrecognized minor version code: ' + vers.Minor);
	if(vers.Major > 4 || vers.Major < 2) throw new Error('unrecognized major version code: ' + vers.Major);
	o.Flags = blob.read_shift(4); length -= 4;
	var sz = blob.read_shift(4); length -= 4;
	o.EncryptionHeader = parse_EncryptionHeader(blob, sz); length -= sz;
	o.EncryptionVerifier = parse_EncryptionVerifier(blob, length);
	return o;
}
/* [MS-OFFCRYPTO] 2.3.6.1 RC4 Encryption Header */
function parse_RC4Header(blob) {
	var o = {};
	var vers = o.EncryptionVersionInfo = parse_CRYPTOVersion(blob, 4);
	if(vers.Major != 1 || vers.Minor != 1) throw 'unrecognized version code ' + vers.Major + ' : ' + vers.Minor;
	o.Salt = blob.read_shift(16);
	o.EncryptedVerifier = blob.read_shift(16);
	o.EncryptedVerifierHash = blob.read_shift(16);
	return o;
}

/* [MS-OFFCRYPTO] 2.3.7.1 Binary Document Password Verifier Derivation */
function crypto_CreatePasswordVerifier_Method1(Password) {
	var Verifier = 0x0000, PasswordArray;
	var PasswordDecoded = _JS2ANSI(Password);
	var len = PasswordDecoded.length + 1, i, PasswordByte;
	var Intermediate1, Intermediate2, Intermediate3;
	PasswordArray = new_raw_buf(len);
	PasswordArray[0] = PasswordDecoded.length;
	for(i = 1; i != len; ++i) PasswordArray[i] = PasswordDecoded[i-1];
	for(i = len-1; i >= 0; --i) {
		PasswordByte = PasswordArray[i];
		Intermediate1 = ((Verifier & 0x4000) === 0x0000) ? 0 : 1;
		Intermediate2 = (Verifier << 1) & 0x7FFF;
		Intermediate3 = Intermediate1 | Intermediate2;
		Verifier = Intermediate3 ^ PasswordByte;
	}
	return Verifier ^ 0xCE4B;
}

/* [MS-OFFCRYPTO] 2.3.7.2 Binary Document XOR Array Initialization */
var crypto_CreateXorArray_Method1 = (function() {
	var PadArray = [0xBB, 0xFF, 0xFF, 0xBA, 0xFF, 0xFF, 0xB9, 0x80, 0x00, 0xBE, 0x0F, 0x00, 0xBF, 0x0F, 0x00];
	var InitialCode = [0xE1F0, 0x1D0F, 0xCC9C, 0x84C0, 0x110C, 0x0E10, 0xF1CE, 0x313E, 0x1872, 0xE139, 0xD40F, 0x84F9, 0x280C, 0xA96A, 0x4EC3];
	var XorMatrix = [0xAEFC, 0x4DD9, 0x9BB2, 0x2745, 0x4E8A, 0x9D14, 0x2A09, 0x7B61, 0xF6C2, 0xFDA5, 0xEB6B, 0xC6F7, 0x9DCF, 0x2BBF, 0x4563, 0x8AC6, 0x05AD, 0x0B5A, 0x16B4, 0x2D68, 0x5AD0, 0x0375, 0x06EA, 0x0DD4, 0x1BA8, 0x3750, 0x6EA0, 0xDD40, 0xD849, 0xA0B3, 0x5147, 0xA28E, 0x553D, 0xAA7A, 0x44D5, 0x6F45, 0xDE8A, 0xAD35, 0x4A4B, 0x9496, 0x390D, 0x721A, 0xEB23, 0xC667, 0x9CEF, 0x29FF, 0x53FE, 0xA7FC, 0x5FD9, 0x47D3, 0x8FA6, 0x0F6D, 0x1EDA, 0x3DB4, 0x7B68, 0xF6D0, 0xB861, 0x60E3, 0xC1C6, 0x93AD, 0x377B, 0x6EF6, 0xDDEC, 0x45A0, 0x8B40, 0x06A1, 0x0D42, 0x1A84, 0x3508, 0x6A10, 0xAA51, 0x4483, 0x8906, 0x022D, 0x045A, 0x08B4, 0x1168, 0x76B4, 0xED68, 0xCAF1, 0x85C3, 0x1BA7, 0x374E, 0x6E9C, 0x3730, 0x6E60, 0xDCC0, 0xA9A1, 0x4363, 0x86C6, 0x1DAD, 0x3331, 0x6662, 0xCCC4, 0x89A9, 0x0373, 0x06E6, 0x0DCC, 0x1021, 0x2042, 0x4084, 0x8108, 0x1231, 0x2462, 0x48C4];
	var Ror = function(Byte) { return ((Byte/2) | (Byte*128)) & 0xFF; };
	var XorRor = function(byte1, byte2) { return Ror(byte1 ^ byte2); };
	var CreateXorKey_Method1 = function(Password) {
		var XorKey = InitialCode[Password.length - 1];
		var CurrentElement = 0x68;
		for(var i = Password.length-1; i >= 0; --i) {
			var Char = Password[i];
			for(var j = 0; j != 7; ++j) {
				if(Char & 0x40) XorKey ^= XorMatrix[CurrentElement];
				Char *= 2; --CurrentElement;
			}
		}
		return XorKey;
	};
	return function(password) {
		var Password = _JS2ANSI(password);
		var XorKey = CreateXorKey_Method1(Password);
		var Index = Password.length;
		var ObfuscationArray = new_raw_buf(16);
		for(var i = 0; i != 16; ++i) ObfuscationArray[i] = 0x00;
		var Temp, PasswordLastChar, PadIndex;
		if((Index & 1) === 1) {
			Temp = XorKey >> 8;
			ObfuscationArray[Index] = XorRor(PadArray[0], Temp);
			--Index;
			Temp = XorKey & 0xFF;
			PasswordLastChar = Password[Password.length - 1];
			ObfuscationArray[Index] = XorRor(PasswordLastChar, Temp);
		}
		while(Index > 0) {
			--Index;
			Temp = XorKey >> 8;
			ObfuscationArray[Index] = XorRor(Password[Index], Temp);
			--Index;
			Temp = XorKey & 0xFF;
			ObfuscationArray[Index] = XorRor(Password[Index], Temp);
		}
		Index = 15;
		PadIndex = 15 - Password.length;
		while(PadIndex > 0) {
			Temp = XorKey >> 8;
			ObfuscationArray[Index] = XorRor(PadArray[PadIndex], Temp);
			--Index;
			--PadIndex;
			Temp = XorKey & 0xFF;
			ObfuscationArray[Index] = XorRor(Password[Index], Temp);
			--Index;
			--PadIndex;
		}
		return ObfuscationArray;
	};
})();

/* [MS-OFFCRYPTO] 2.3.7.3 Binary Document XOR Data Transformation Method 1 */
var crypto_DecryptData_Method1 = function(password, Data, XorArrayIndex, XorArray, O) {
	/* If XorArray is set, use it; if O is not set, make changes in-place */
	if(!O) O = Data;
	if(!XorArray) XorArray = crypto_CreateXorArray_Method1(password);
	var Index, Value;
	for(Index = 0; Index != Data.length; ++Index) {
		Value = Data[Index];
		Value ^= XorArray[XorArrayIndex];
		Value = ((Value>>5) | (Value<<3)) & 0xFF;
		O[Index] = Value;
		++XorArrayIndex;
	}
	return [O, XorArrayIndex, XorArray];
};

var crypto_MakeXorDecryptor = function(password) {
	var XorArrayIndex = 0, XorArray = crypto_CreateXorArray_Method1(password);
	return function(Data) {
		var O = crypto_DecryptData_Method1("", Data, XorArrayIndex, XorArray);
		XorArrayIndex = O[1];
		return O[0];
	};
};

/* 2.5.343 */
function parse_XORObfuscation(blob, length, opts, out) {
	var o = ({ key: parseuint16(blob), verificationBytes: parseuint16(blob) });
	if(opts.password) o.verifier = crypto_CreatePasswordVerifier_Method1(opts.password);
	out.valid = o.verificationBytes === o.verifier;
	if(out.valid) out.insitu = crypto_MakeXorDecryptor(opts.password);
	return o;
}

/* 2.4.117 */
function parse_FilePassHeader(blob, length, oo) {
	var o = oo || {}; o.Info = blob.read_shift(2); blob.l -= 2;
	if(o.Info === 1) o.Data = parse_RC4Header(blob, length);
	else o.Data = parse_RC4CryptoHeader(blob, length);
	return o;
}
function parse_FilePass(blob, length, opts) {
	var o = ({ Type: opts.biff >= 8 ? blob.read_shift(2) : 0 }); /* wEncryptionType */
	if(o.Type) parse_FilePassHeader(blob, length-2, o);
	else parse_XORObfuscation(blob, opts.biff >= 8 ? length : length - 2, opts, o);
	return o;
}


function rtf_to_sheet(d, opts) {
  switch (opts.type) {
    case "base64":
      return rtf_to_sheet_str(Base64_decode(d), opts);
    case "binary":
      return rtf_to_sheet_str(d, opts);
    case "buffer":
      return rtf_to_sheet_str(has_buf && Buffer.isBuffer(d) ? d.toString("binary") : a2s(d), opts);
    case "array":
      return rtf_to_sheet_str(cc2str(d), opts);
  }
  throw new Error("Unrecognized type " + opts.type);
}
function rtf_to_sheet_str(str, opts) {
  var o = opts || {};
  var ws = o.dense ? [] : {};
  var rows = str.match(/\\trowd[\s\S]*?\\row\b/g);
  if (!rows)
    throw new Error("RTF missing table");
  var range = { s: { c: 0, r: 0 }, e: { c: 0, r: rows.length - 1 } };
  rows.forEach(function(rowtf, R) {
    if (Array.isArray(ws))
      ws[R] = [];
    var rtfre = /\\[\w\-]+\b/g;
    var last_index = 0;
    var res;
    var C = -1;
    var payload = [];
    while ((res = rtfre.exec(rowtf)) != null) {
      var data = rowtf.slice(last_index, rtfre.lastIndex - res[0].length);
      if (data.charCodeAt(0) == 32)
        data = data.slice(1);
      if (data.length)
        payload.push(data);
      switch (res[0]) {
        case "\\cell":
          ++C;
          if (payload.length) {
            var cell = { v: payload.join(""), t: "s" };
            if (cell.v == "TRUE" || cell.v == "FALSE") {
              cell.v = cell.v == "TRUE";
              cell.t = "b";
            } else if (!isNaN(fuzzynum(cell.v))) {
              cell.t = "n";
              if (o.cellText !== false)
                cell.w = cell.v;
              cell.v = fuzzynum(cell.v);
            }
            if (Array.isArray(ws))
              ws[R][C] = cell;
            else
              ws[encode_cell({ r: R, c: C })] = cell;
          }
          payload = [];
          break;
        case "\\par":
          payload.push("\n");
          break;
      }
      last_index = rtfre.lastIndex;
    }
    if (C > range.e.c)
      range.e.c = C;
  });
  ws["!ref"] = encode_range(range);
  return ws;
}
function rtf_to_workbook(d, opts) {
  var wb = sheet_to_workbook(rtf_to_sheet(d, opts), opts);
  wb.bookType = "rtf";
  return wb;
}
function sheet_to_rtf(ws, opts) {
  var o = ["{\\rtf1\\ansi"];
  if (!ws["!ref"])
    return o[0] + "}";
  var r = safe_decode_range(ws["!ref"]), cell;
  var dense = Array.isArray(ws);
  for (var R = r.s.r; R <= r.e.r; ++R) {
    o.push("\\trowd\\trautofit1");
    for (var C = r.s.c; C <= r.e.c; ++C)
      o.push("\\cellx" + (C + 1));
    o.push("\\pard\\intbl");
    for (C = r.s.c; C <= r.e.c; ++C) {
      var coord = encode_cell({ r: R, c: C });
      cell = dense ? (ws[R] || [])[C] : ws[coord];
      if (!cell || cell.v == null && (!cell.f || cell.F)) {
        o.push(" \\cell");
        continue;
      }
      o.push(" " + (cell.w || (format_cell(cell), cell.w) || "").replace(/[\r\n]/g, "\\par "));
      o.push("\\cell");
    }
    o.push("\\pard\\intbl\\row");
  }
  return o.join("") + "}";
}
function hex2RGB(h) {
	var o = h.slice(h[0]==="#"?1:0).slice(0,6);
	return [parseInt(o.slice(0,2),16),parseInt(o.slice(2,4),16),parseInt(o.slice(4,6),16)];
}
function rgb2Hex(rgb) {
	for(var i=0,o=1; i!=3; ++i) o = o*256 + (rgb[i]>255?255:rgb[i]<0?0:rgb[i]);
	return o.toString(16).toUpperCase().slice(1);
}

function rgb2HSL(rgb) {
	var R = rgb[0]/255, G = rgb[1]/255, B=rgb[2]/255;
	var M = Math.max(R, G, B), m = Math.min(R, G, B), C = M - m;
	if(C === 0) return [0, 0, R];

	var H6 = 0, S = 0, L2 = (M + m);
	S = C / (L2 > 1 ? 2 - L2 : L2);
	switch(M){
		case R: H6 = ((G - B) / C + 6)%6; break;
		case G: H6 = ((B - R) / C + 2); break;
		case B: H6 = ((R - G) / C + 4); break;
	}
	return [H6 / 6, S, L2 / 2];
}

function hsl2RGB(hsl){
	var H = hsl[0], S = hsl[1], L = hsl[2];
	var C = S * 2 * (L < 0.5 ? L : 1 - L), m = L - C/2;
	var rgb = [m,m,m], h6 = 6*H;

	var X;
	if(S !== 0) switch(h6|0) {
		case 0: case 6: X = C * h6; rgb[0] += C; rgb[1] += X; break;
		case 1: X = C * (2 - h6);   rgb[0] += X; rgb[1] += C; break;
		case 2: X = C * (h6 - 2);   rgb[1] += C; rgb[2] += X; break;
		case 3: X = C * (4 - h6);   rgb[1] += X; rgb[2] += C; break;
		case 4: X = C * (h6 - 4);   rgb[2] += C; rgb[0] += X; break;
		case 5: X = C * (6 - h6);   rgb[2] += X; rgb[0] += C; break;
	}
	for(var i = 0; i != 3; ++i) rgb[i] = Math.round(rgb[i]*255);
	return rgb;
}

/* 18.8.3 bgColor tint algorithm */
function rgb_tint(hex, tint) {
	if(tint === 0) return hex;
	var hsl = rgb2HSL(hex2RGB(hex));
	if (tint < 0) hsl[2] = hsl[2] * (1 + tint);
	else hsl[2] = 1 - (1 - hsl[2]) * (1 - tint);
	return rgb2Hex(hsl2RGB(hsl));
}

/* 18.3.1.13 width calculations */
/* [MS-OI29500] 2.1.595 Column Width & Formatting */
var DEF_MDW = 6, MAX_MDW = 15, MIN_MDW = 1, MDW = DEF_MDW;
function width2px(width) { return Math.floor(( width + (Math.round(128/MDW))/256 )* MDW ); }
function px2char(px) { return (Math.floor((px - 5)/MDW * 100 + 0.5))/100; }
function char2width(chr) { return (Math.round((chr * MDW + 5)/MDW*256))/256; }
//function px2char_(px) { return (((px - 5)/MDW * 100 + 0.5))/100; }
//function char2width_(chr) { return (((chr * MDW + 5)/MDW*256))/256; }
function cycle_width(collw) { return char2width(px2char(width2px(collw))); }
/* XLSX/XLSB/XLS specify width in units of MDW */
function find_mdw_colw(collw) {
	var delta = Math.abs(collw - cycle_width(collw)), _MDW = MDW;
	if(delta > 0.005) for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) if(Math.abs(collw - cycle_width(collw)) <= delta) { delta = Math.abs(collw - cycle_width(collw)); _MDW = MDW; }
	MDW = _MDW;
}
/* XLML specifies width in terms of pixels */
/*function find_mdw_wpx(wpx) {
	var delta = Infinity, guess = 0, _MDW = MIN_MDW;
	for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) {
		guess = char2width_(px2char_(wpx))*256;
		guess = (guess) % 1;
		if(guess > 0.5) guess--;
		if(Math.abs(guess) < delta) { delta = Math.abs(guess); _MDW = MDW; }
	}
	MDW = _MDW;
}*/

function process_col(coll) {
	if(coll.width) {
		coll.wpx = width2px(coll.width);
		coll.wch = px2char(coll.wpx);
		coll.MDW = MDW;
	} else if(coll.wpx) {
		coll.wch = px2char(coll.wpx);
		coll.width = char2width(coll.wch);
		coll.MDW = MDW;
	} else if(typeof coll.wch == 'number') {
		coll.width = char2width(coll.wch);
		coll.wpx = width2px(coll.width);
		coll.MDW = MDW;
	}
	if(coll.customWidth) delete coll.customWidth;
}

var DEF_PPI = 96, PPI = DEF_PPI;
function px2pt(px) { return px * 96 / PPI; }
function pt2px(pt) { return pt * PPI / 96; }

/* [MS-EXSPXML3] 2.4.54 ST_enmPattern */
var XLMLPatternTypeMap = {
	"None": "none",
	"Solid": "solid",
	"Gray50": "mediumGray",
	"Gray75": "darkGray",
	"Gray25": "lightGray",
	"HorzStripe": "darkHorizontal",
	"VertStripe": "darkVertical",
	"ReverseDiagStripe": "darkDown",
	"DiagStripe": "darkUp",
	"DiagCross": "darkGrid",
	"ThickDiagCross": "darkTrellis",
	"ThinHorzStripe": "lightHorizontal",
	"ThinVertStripe": "lightVertical",
	"ThinReverseDiagStripe": "lightDown",
	"ThinHorzCross": "lightGrid"
};

/* 18.8.5 borders CT_Borders */
function parse_borders(t, styles, themes, opts) {
	styles.Borders = [];
	var border = {};
	var pass = false;
	(t[0].match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x);
		switch(strip_ns(y[0])) {
			case '<borders': case '<borders>': case '</borders>': break;

			/* 18.8.4 border CT_Border */
			case '<border': case '<border>': case '<border/>':
				border = {};
				if(y.diagonalUp) border.diagonalUp = parsexmlbool(y.diagonalUp);
				if(y.diagonalDown) border.diagonalDown = parsexmlbool(y.diagonalDown);
				styles.Borders.push(border);
				break;
			case '</border>': break;

			/* note: not in spec, appears to be CT_BorderPr */
			case '<left/>': break;
			case '<left': case '<left>': break;
			case '</left>': break;

			/* note: not in spec, appears to be CT_BorderPr */
			case '<right/>': break;
			case '<right': case '<right>': break;
			case '</right>': break;

			/* 18.8.43 top CT_BorderPr */
			case '<top/>': break;
			case '<top': case '<top>': break;
			case '</top>': break;

			/* 18.8.6 bottom CT_BorderPr */
			case '<bottom/>': break;
			case '<bottom': case '<bottom>': break;
			case '</bottom>': break;

			/* 18.8.13 diagonal CT_BorderPr */
			case '<diagonal': case '<diagonal>': case '<diagonal/>': break;
			case '</diagonal>': break;

			/* 18.8.25 horizontal CT_BorderPr */
			case '<horizontal': case '<horizontal>': case '<horizontal/>': break;
			case '</horizontal>': break;

			/* 18.8.44 vertical CT_BorderPr */
			case '<vertical': case '<vertical>': case '<vertical/>': break;
			case '</vertical>': break;

			/* 18.8.37 start CT_BorderPr */
			case '<start': case '<start>': case '<start/>': break;
			case '</start>': break;

			/* 18.8.16 end CT_BorderPr */
			case '<end': case '<end>': case '<end/>': break;
			case '</end>': break;

			/* 18.8.? color CT_Color */
			case '<color': case '<color>':
				break;
			case '<color/>': case '</color>': break;

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': break;
			case '<ext': pass = true; break;
			case '</ext>': pass = false; break;
			default: if(opts && opts.WTF) {
				if(!pass) throw new Error('unrecognized ' + y[0] + ' in borders');
			}
		}
	});
}

/* 18.8.21 fills CT_Fills */
function parse_fills(t, styles, themes, opts) {
	styles.Fills = [];
	var fill = {};
	var pass = false;
	(t[0].match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x);
		switch(strip_ns(y[0])) {
			case '<fills': case '<fills>': case '</fills>': break;

			/* 18.8.20 fill CT_Fill */
			case '<fill>': case '<fill': case '<fill/>':
				fill = {}; styles.Fills.push(fill); break;
			case '</fill>': break;

			/* 18.8.24 gradientFill CT_GradientFill */
			case '<gradientFill>': break;
			case '<gradientFill':
			case '</gradientFill>': styles.Fills.push(fill); fill = {}; break;

			/* 18.8.32 patternFill CT_PatternFill */
			case '<patternFill': case '<patternFill>':
				if(y.patternType) fill.patternType = y.patternType;
				break;
			case '<patternFill/>': case '</patternFill>': break;

			/* 18.8.3 bgColor CT_Color */
			case '<bgColor':
				if(!fill.bgColor) fill.bgColor = {};
				if(y.indexed) fill.bgColor.indexed = parseInt(y.indexed, 10);
				if(y.theme) fill.bgColor.theme = parseInt(y.theme, 10);
				if(y.tint) fill.bgColor.tint = parseFloat(y.tint);
				/* Excel uses ARGB strings */
				if(y.rgb) fill.bgColor.rgb = y.rgb.slice(-6);
				break;
			case '<bgColor/>': case '</bgColor>': break;

			/* 18.8.19 fgColor CT_Color */
			case '<fgColor':
				if(!fill.fgColor) fill.fgColor = {};
				if(y.theme) fill.fgColor.theme = parseInt(y.theme, 10);
				if(y.tint) fill.fgColor.tint = parseFloat(y.tint);
				/* Excel uses ARGB strings */
				if(y.rgb != null) fill.fgColor.rgb = y.rgb.slice(-6);
				break;
			case '<fgColor/>': case '</fgColor>': break;

			/* 18.8.38 stop CT_GradientStop */
			case '<stop': case '<stop/>': break;
			case '</stop>': break;

			/* 18.8.? color CT_Color */
			case '<color': case '<color/>': break;
			case '</color>': break;

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': break;
			case '<ext': pass = true; break;
			case '</ext>': pass = false; break;
			default: if(opts && opts.WTF) {
				if(!pass) throw new Error('unrecognized ' + y[0] + ' in fills');
			}
		}
	});
}

/* 18.8.23 fonts CT_Fonts */
function parse_fonts(t, styles, themes, opts) {
	styles.Fonts = [];
	var font = {};
	var pass = false;
	(t[0].match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x);
		switch(strip_ns(y[0])) {
			case '<fonts': case '<fonts>': case '</fonts>': break;

			/* 18.8.22 font CT_Font */
			case '<font': case '<font>': break;
			case '</font>': case '<font/>':
				styles.Fonts.push(font);
				font = {};
				break;

			/* 18.8.29 name CT_FontName */
			case '<name': if(y.val) font.name = utf8read(y.val); break;
			case '<name/>': case '</name>': break;

			/* 18.8.2  b CT_BooleanProperty */
			case '<b': font.bold = y.val ? parsexmlbool(y.val) : 1; break;
			case '<b/>': font.bold = 1; break;

			/* 18.8.26 i CT_BooleanProperty */
			case '<i': font.italic = y.val ? parsexmlbool(y.val) : 1; break;
			case '<i/>': font.italic = 1; break;

			/* 18.4.13 u CT_UnderlineProperty */
			case '<u':
				switch(y.val) {
					case "none": font.underline = 0x00; break;
					case "single": font.underline = 0x01; break;
					case "double": font.underline = 0x02; break;
					case "singleAccounting": font.underline = 0x21; break;
					case "doubleAccounting": font.underline = 0x22; break;
				} break;
			case '<u/>': font.underline = 1; break;

			/* 18.4.10 strike CT_BooleanProperty */
			case '<strike': font.strike = y.val ? parsexmlbool(y.val) : 1; break;
			case '<strike/>': font.strike = 1; break;

			/* 18.4.2  outline CT_BooleanProperty */
			case '<outline': font.outline = y.val ? parsexmlbool(y.val) : 1; break;
			case '<outline/>': font.outline = 1; break;

			/* 18.8.36 shadow CT_BooleanProperty */
			case '<shadow': font.shadow = y.val ? parsexmlbool(y.val) : 1; break;
			case '<shadow/>': font.shadow = 1; break;

			/* 18.8.12 condense CT_BooleanProperty */
			case '<condense': font.condense = y.val ? parsexmlbool(y.val) : 1; break;
			case '<condense/>': font.condense = 1; break;

			/* 18.8.17 extend CT_BooleanProperty */
			case '<extend': font.extend = y.val ? parsexmlbool(y.val) : 1; break;
			case '<extend/>': font.extend = 1; break;

			/* 18.4.11 sz CT_FontSize */
			case '<sz': if(y.val) font.sz = +y.val; break;
			case '<sz/>': case '</sz>': break;

			/* 18.4.14 vertAlign CT_VerticalAlignFontProperty */
			case '<vertAlign': if(y.val) font.vertAlign = y.val; break;
			case '<vertAlign/>': case '</vertAlign>': break;

			/* 18.8.18 family CT_FontFamily */
			case '<family': if(y.val) font.family = parseInt(y.val,10); break;
			case '<family/>': case '</family>': break;

			/* 18.8.35 scheme CT_FontScheme */
			case '<scheme': if(y.val) font.scheme = y.val; break;
			case '<scheme/>': case '</scheme>': break;

			/* 18.4.1 charset CT_IntProperty */
			case '<charset':
				if(y.val == '1') break;
				y.codepage = CS2CP[parseInt(y.val, 10)];
				break;

			/* 18.?.? color CT_Color */
			case '<color':
				if(!font.color) font.color = {};
				if(y.auto) font.color.auto = parsexmlbool(y.auto);

				if(y.rgb) font.color.rgb = y.rgb.slice(-6);
				else if(y.indexed) {
					font.color.index = parseInt(y.indexed, 10);
					var icv = XLSIcv[font.color.index];
					if(font.color.index == 81) icv = XLSIcv[1];
					if(!icv) icv = XLSIcv[1]; //throw new Error(x); // note: 206 is valid
					font.color.rgb = icv[0].toString(16) + icv[1].toString(16) + icv[2].toString(16);
				} else if(y.theme) {
					font.color.theme = parseInt(y.theme, 10);
					if(y.tint) font.color.tint = parseFloat(y.tint);
					if(y.theme && themes.themeElements && themes.themeElements.clrScheme) {
						font.color.rgb = rgb_tint(themes.themeElements.clrScheme[font.color.theme].rgb, font.color.tint || 0);
					}
				}

				break;
			case '<color/>': case '</color>': break;

			/* note: sometimes mc:AlternateContent appears bare */
			case '<AlternateContent': pass = true; break;
			case '</AlternateContent>': pass = false; break;

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': break;
			case '<ext': pass = true; break;
			case '</ext>': pass = false; break;
			default: if(opts && opts.WTF) {
				if(!pass) throw new Error('unrecognized ' + y[0] + ' in fonts');
			}
		}
	});
}

/* 18.8.31 numFmts CT_NumFmts */
function parse_numFmts(t, styles, opts) {
	styles.NumberFmt = [];
	var k/*Array<number>*/ = (keys(table_fmt));
	for(var i=0; i < k.length; ++i) styles.NumberFmt[k[i]] = table_fmt[k[i]];
	var m = t[0].match(tagregex);
	if(!m) return;
	for(i=0; i < m.length; ++i) {
		var y = parsexmltag(m[i]);
		switch(strip_ns(y[0])) {
			case '<numFmts': case '</numFmts>': case '<numFmts/>': case '<numFmts>': break;
			case '<numFmt': {
				var f=unescapexml(utf8read(y.formatCode)), j=parseInt(y.numFmtId,10);
				styles.NumberFmt[j] = f;
				if(j>0) {
					if(j > 0x188) {
						for(j = 0x188; j > 0x3c; --j) if(styles.NumberFmt[j] == null) break;
						styles.NumberFmt[j] = f;
					}
					SSF__load(f,j);
				}
			} break;
			case '</numFmt>': break;
			default: if(opts.WTF) throw new Error('unrecognized ' + y[0] + ' in numFmts');
		}
	}
}

function write_numFmts(NF) {
	var o = ["<numFmts>"];
	[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
		for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) o[o.length] = (writextag('numFmt',null,{numFmtId:i,formatCode:escapexml(NF[i])}));
	});
	if(o.length === 1) return "";
	o[o.length] = ("</numFmts>");
	o[0] = writextag('numFmts', null, { count:o.length-2 }).replace("/>", ">");
	return o.join("");
}

/* 18.8.10 cellXfs CT_CellXfs */
var cellXF_uint = [ "numFmtId", "fillId", "fontId", "borderId", "xfId" ];
var cellXF_bool = [ "applyAlignment", "applyBorder", "applyFill", "applyFont", "applyNumberFormat", "applyProtection", "pivotButton", "quotePrefix" ];
function parse_cellXfs(t, styles, opts) {
	styles.CellXf = [];
	var xf;
	var pass = false;
	(t[0].match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x), i = 0;
		switch(strip_ns(y[0])) {
			case '<cellXfs': case '<cellXfs>': case '<cellXfs/>': case '</cellXfs>': break;

			/* 18.8.45 xf CT_Xf */
			case '<xf': case '<xf/>':
				xf = y;
				delete xf[0];
				for(i = 0; i < cellXF_uint.length; ++i) if(xf[cellXF_uint[i]])
					xf[cellXF_uint[i]] = parseInt(xf[cellXF_uint[i]], 10);
				for(i = 0; i < cellXF_bool.length; ++i) if(xf[cellXF_bool[i]])
					xf[cellXF_bool[i]] = parsexmlbool(xf[cellXF_bool[i]]);
				if(styles.NumberFmt && xf.numFmtId > 0x188) {
					for(i = 0x188; i > 0x3c; --i) if(styles.NumberFmt[xf.numFmtId] == styles.NumberFmt[i]) { xf.numFmtId = i; break; }
				}
				styles.CellXf.push(xf); break;
			case '</xf>': break;

			/* 18.8.1 alignment CT_CellAlignment */
			case '<alignment': case '<alignment/>':
				var alignment = {};
				if(y.vertical) alignment.vertical = y.vertical;
				if(y.horizontal) alignment.horizontal = y.horizontal;
				if(y.textRotation != null) alignment.textRotation = y.textRotation;
				if(y.indent) alignment.indent = y.indent;
				if(y.wrapText) alignment.wrapText = parsexmlbool(y.wrapText);
				xf.alignment = alignment;
				break;
			case '</alignment>': break;

			/* 18.8.33 protection CT_CellProtection */
			case '<protection':
				break;
			case '</protection>': case '<protection/>': break;

			/* note: sometimes mc:AlternateContent appears bare */
			case '<AlternateContent': pass = true; break;
			case '</AlternateContent>': pass = false; break;

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': break;
			case '<ext': pass = true; break;
			case '</ext>': pass = false; break;
			default: if(opts && opts.WTF) {
				if(!pass) throw new Error('unrecognized ' + y[0] + ' in cellXfs');
			}
		}
	});
}

function write_cellXfs(cellXfs) {
	var o = [];
	o[o.length] = (writextag('cellXfs',null));
	cellXfs.forEach(function(c) {
		o[o.length] = (writextag('xf', null, c));
	});
	o[o.length] = ("</cellXfs>");
	if(o.length === 2) return "";
	o[0] = writextag('cellXfs',null, {count:o.length-2}).replace("/>",">");
	return o.join("");
}

/* 18.8 Styles CT_Stylesheet*/
var parse_sty_xml= (function make_pstyx() {
var numFmtRegex = /<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/;
var cellXfRegex = /<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/;
var fillsRegex = /<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/;
var fontsRegex = /<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/;
var bordersRegex = /<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/;

return function parse_sty_xml(data, themes, opts) {
	var styles = {};
	if(!data) return styles;
	data = data.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");
	/* 18.8.39 styleSheet CT_Stylesheet */
	var t;

	/* 18.8.31 numFmts CT_NumFmts ? */
	if((t=data.match(numFmtRegex))) parse_numFmts(t, styles, opts);

	/* 18.8.23 fonts CT_Fonts ? */
	if((t=data.match(fontsRegex))) parse_fonts(t, styles, themes, opts);

	/* 18.8.21 fills CT_Fills ? */
	if((t=data.match(fillsRegex))) parse_fills(t, styles, themes, opts);

	/* 18.8.5  borders CT_Borders ? */
	if((t=data.match(bordersRegex))) parse_borders(t, styles, themes, opts);

	/* 18.8.9  cellStyleXfs CT_CellStyleXfs ? */
	/* 18.8.8  cellStyles CT_CellStyles ? */

	/* 18.8.10 cellXfs CT_CellXfs ? */
	if((t=data.match(cellXfRegex))) parse_cellXfs(t, styles, opts);

	/* 18.8.15 dxfs CT_Dxfs ? */
	/* 18.8.42 tableStyles CT_TableStyles ? */
	/* 18.8.11 colors CT_Colors ? */
	/* 18.2.10 extLst CT_ExtensionList ? */

	return styles;
};
})();

function write_sty_xml(wb, opts) {
	var o = [XML_HEADER, writextag('styleSheet', null, {
		'xmlns': XMLNS_main[0],
		'xmlns:vt': XMLNS.vt
	})], w;
	if(wb.SSF && (w = write_numFmts(wb.SSF)) != null) o[o.length] = w;
	o[o.length] = ('<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>');
	o[o.length] = ('<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>');
	o[o.length] = ('<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>');
	o[o.length] = ('<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>');
	if((w = write_cellXfs(opts.cellXfs))) o[o.length] = (w);
	o[o.length] = ('<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>');
	o[o.length] = ('<dxfs count="0"/>');
	o[o.length] = ('<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>');

	if(o.length>2){ o[o.length] = ('</styleSheet>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* [MS-XLSB] 2.4.657 BrtFmt */
function parse_BrtFmt(data, length) {
	var numFmtId = data.read_shift(2);
	var stFmtCode = parse_XLWideString(data,length-2);
	return [numFmtId, stFmtCode];
}
function write_BrtFmt(i, f, o) {
	if(!o) o = new_buf(6 + 4 * f.length);
	o.write_shift(2, i);
	write_XLWideString(f, o);
	var out = (o.length > o.l) ? o.slice(0, o.l) : o;
	if(o.l == null) o.l = o.length;
	return out;
}

/* [MS-XLSB] 2.4.659 BrtFont TODO */
function parse_BrtFont(data, length, opts) {
	var out = ({});

	out.sz = data.read_shift(2) / 20;

	var grbit = parse_FontFlags(data, 2, opts);
	if(grbit.fItalic) out.italic = 1;
	if(grbit.fCondense) out.condense = 1;
	if(grbit.fExtend) out.extend = 1;
	if(grbit.fShadow) out.shadow = 1;
	if(grbit.fOutline) out.outline = 1;
	if(grbit.fStrikeout) out.strike = 1;

	var bls = data.read_shift(2);
	if(bls === 0x02BC) out.bold = 1;

	switch(data.read_shift(2)) {
		/* case 0: out.vertAlign = "baseline"; break; */
		case 1: out.vertAlign = "superscript"; break;
		case 2: out.vertAlign = "subscript"; break;
	}

	var underline = data.read_shift(1);
	if(underline != 0) out.underline = underline;

	var family = data.read_shift(1);
	if(family > 0) out.family = family;

	var bCharSet = data.read_shift(1);
	if(bCharSet > 0) out.charset = bCharSet;

	data.l++;
	out.color = parse_BrtColor(data, 8);

	switch(data.read_shift(1)) {
		/* case 0: out.scheme = "none": break; */
		case 1: out.scheme = "major"; break;
		case 2: out.scheme = "minor"; break;
	}

	out.name = parse_XLWideString(data, length - 21);

	return out;
}
function write_BrtFont(font, o) {
	if(!o) o = new_buf(25+4*32);
	o.write_shift(2, font.sz * 20);
	write_FontFlags(font, o);
	o.write_shift(2, font.bold ? 0x02BC : 0x0190);
	var sss = 0;
	if(font.vertAlign == "superscript") sss = 1;
	else if(font.vertAlign == "subscript") sss = 2;
	o.write_shift(2, sss);
	o.write_shift(1, font.underline || 0);
	o.write_shift(1, font.family || 0);
	o.write_shift(1, font.charset || 0);
	o.write_shift(1, 0);
	write_BrtColor(font.color, o);
	var scheme = 0;
	if(font.scheme == "major") scheme = 1;
	if(font.scheme == "minor") scheme = 2;
	o.write_shift(1, scheme);
	write_XLWideString(font.name, o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.650 BrtFill */
var XLSBFillPTNames = [
	"none",
	"solid",
	"mediumGray",
	"darkGray",
	"lightGray",
	"darkHorizontal",
	"darkVertical",
	"darkDown",
	"darkUp",
	"darkGrid",
	"darkTrellis",
	"lightHorizontal",
	"lightVertical",
	"lightDown",
	"lightUp",
	"lightGrid",
	"lightTrellis",
	"gray125",
	"gray0625"
];
var rev_XLSBFillPTNames;
/* TODO: gradient fill representation */
var parse_BrtFill = parsenoop;
function write_BrtFill(fill, o) {
	if(!o) o = new_buf(4*3 + 8*7 + 16*1);
	if(!rev_XLSBFillPTNames) rev_XLSBFillPTNames = (evert(XLSBFillPTNames));
	var fls = rev_XLSBFillPTNames[fill.patternType];
	if(fls == null) fls = 0x28;
	o.write_shift(4, fls);
	var j = 0;
	if(fls != 0x28) {
		/* TODO: custom FG Color */
		write_BrtColor({auto:1}, o);
		/* TODO: custom BG Color */
		write_BrtColor({auto:1}, o);

		for(; j < 12; ++j) o.write_shift(4, 0);
	} else {
		for(; j < 4; ++j) o.write_shift(4, 0);

		for(; j < 12; ++j) o.write_shift(4, 0); /* TODO */
		/* iGradientType */
		/* xnumDegree */
		/* xnumFillToLeft */
		/* xnumFillToRight */
		/* xnumFillToTop */
		/* xnumFillToBottom */
		/* cNumStop */
		/* xfillGradientStop */
	}
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.824 BrtXF */
function parse_BrtXF(data, length) {
	var tgt = data.l + length;
	var ixfeParent = data.read_shift(2);
	var ifmt = data.read_shift(2);
	data.l = tgt;
	return {ixfe:ixfeParent, numFmtId:ifmt };
}
function write_BrtXF(data, ixfeP, o) {
	if(!o) o = new_buf(16);
	o.write_shift(2, ixfeP||0);
	o.write_shift(2, data.numFmtId||0);
	o.write_shift(2, 0); /* iFont */
	o.write_shift(2, 0); /* iFill */
	o.write_shift(2, 0); /* ixBorder */
	o.write_shift(1, 0); /* trot */
	o.write_shift(1, 0); /* indent */
	var flow = 0;
	o.write_shift(1, flow); /* flags */
	o.write_shift(1, 0); /* flags */
	o.write_shift(1, 0); /* xfGrbitAtr */
	o.write_shift(1, 0);
	return o;
}

/* [MS-XLSB] 2.5.4 Blxf TODO */
function write_Blxf(data, o) {
	if(!o) o = new_buf(10);
	o.write_shift(1, 0); /* dg */
	o.write_shift(1, 0);
	o.write_shift(4, 0); /* color */
	o.write_shift(4, 0); /* color */
	return o;
}
/* [MS-XLSB] 2.4.302 BrtBorder TODO */
var parse_BrtBorder = parsenoop;
function write_BrtBorder(border, o) {
	if(!o) o = new_buf(51);
	o.write_shift(1, 0); /* diagonal */
	write_Blxf(null, o); /* top */
	write_Blxf(null, o); /* bottom */
	write_Blxf(null, o); /* left */
	write_Blxf(null, o); /* right */
	write_Blxf(null, o); /* diag */
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.763 BrtStyle TODO */
function write_BrtStyle(style, o) {
	if(!o) o = new_buf(12+4*10);
	o.write_shift(4, style.xfId);
	o.write_shift(2, 1);
	o.write_shift(1, +style.builtinId);
	o.write_shift(1, 0); /* iLevel */
	write_XLNullableWideString(style.name || "", o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.272 BrtBeginTableStyles */
function write_BrtBeginTableStyles(cnt, defTableStyle, defPivotStyle) {
	var o = new_buf(4+256*2*4);
	o.write_shift(4, cnt);
	write_XLNullableWideString(defTableStyle, o);
	write_XLNullableWideString(defPivotStyle, o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.1.7.50 Styles */
function parse_sty_bin(data, themes, opts) {
	var styles = {};
	styles.NumberFmt = ([]);
	for(var y in table_fmt) styles.NumberFmt[y] = table_fmt[y];

	styles.CellXf = [];
	styles.Fonts = [];
	var state = [];
	var pass = false;
	recordhopper(data, function hopper_sty(val, R, RT) {
		switch(RT) {
			case 0x002C: /* BrtFmt */
				styles.NumberFmt[val[0]] = val[1]; SSF__load(val[1], val[0]);
				break;
			case 0x002B: /* BrtFont */
				styles.Fonts.push(val);
				if(val.color.theme != null && themes && themes.themeElements && themes.themeElements.clrScheme) {
					val.color.rgb = rgb_tint(themes.themeElements.clrScheme[val.color.theme].rgb, val.color.tint || 0);
				}
				break;
			case 0x0401: /* BrtKnownFonts */ break;
			case 0x002D: /* BrtFill */
				break;
			case 0x002E: /* BrtBorder */
				break;
			case 0x002F: /* BrtXF */
				if(state[state.length - 1] == 0x0269 /* BrtBeginCellXFs */) {
					styles.CellXf.push(val);
				}
				break;
			case 0x0030: /* BrtStyle */
			case 0x01FB: /* BrtDXF */
			case 0x023C: /* BrtMRUColor */
			case 0x01DB: /* BrtIndexedColor */
				break;

			case 0x0493: /* BrtDXF14 */
			case 0x0836: /* BrtDXF15 */
			case 0x046A: /* BrtSlicerStyleElement */
			case 0x0200: /* BrtTableStyleElement */
			case 0x082F: /* BrtTimelineStyleElement */
			case 0x0C00: /* BrtUid */
				break;

			case 0x0023: /* BrtFRTBegin */
				pass = true; break;
			case 0x0024: /* BrtFRTEnd */
				pass = false; break;
			case 0x0025: /* BrtACBegin */
				state.push(RT); pass = true; break;
			case 0x0026: /* BrtACEnd */
				state.pop(); pass = false; break;

			default:
				if(R.T > 0) state.push(RT);
				else if(R.T < 0) state.pop();
				else if(!pass || (opts.WTF && state[state.length-1] != 0x0025 /* BrtACBegin */)) throw new Error("Unexpected record 0x" + RT.toString(16));
		}
	});
	return styles;
}

function write_FMTS_bin(ba, NF) {
	if(!NF) return;
	var cnt = 0;
	[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) ++cnt;
	});

	if(cnt == 0) return;
	write_record(ba, 0x0267 /* BrtBeginFmts */, write_UInt32LE(cnt));
	[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) write_record(ba, 0x002C /* BrtFmt */, write_BrtFmt(i, NF[i]));
	});
	write_record(ba, 0x0268 /* BrtEndFmts */);
}

function write_FONTS_bin(ba) {
	var cnt = 1;

	if(cnt == 0) return;
	write_record(ba, 0x0263 /* BrtBeginFonts */, write_UInt32LE(cnt));
	write_record(ba, 0x002B /* BrtFont */, write_BrtFont({
		sz:12,
		color: {theme:1},
		name: "Calibri",
		family: 2,
		scheme: "minor"
	}));
	/* 1*65491BrtFont [ACFONTS] */
	write_record(ba, 0x0264 /* BrtEndFonts */);
}

function write_FILLS_bin(ba) {
	var cnt = 2;

	if(cnt == 0) return;
	write_record(ba, 0x025B /* BrtBeginFills */, write_UInt32LE(cnt));
	write_record(ba, 0x002D /* BrtFill */, write_BrtFill({patternType:"none"}));
	write_record(ba, 0x002D /* BrtFill */, write_BrtFill({patternType:"gray125"}));
	/* 1*65431BrtFill */
	write_record(ba, 0x025C /* BrtEndFills */);
}

function write_BORDERS_bin(ba) {
	var cnt = 1;

	if(cnt == 0) return;
	write_record(ba, 0x0265 /* BrtBeginBorders */, write_UInt32LE(cnt));
	write_record(ba, 0x002E /* BrtBorder */, write_BrtBorder({}));
	/* 1*65430BrtBorder */
	write_record(ba, 0x0266 /* BrtEndBorders */);
}

function write_CELLSTYLEXFS_bin(ba) {
	var cnt = 1;
	write_record(ba, 0x0272 /* BrtBeginCellStyleXFs */, write_UInt32LE(cnt));
	write_record(ba, 0x002F /* BrtXF */, write_BrtXF({
		numFmtId: 0,
		fontId:   0,
		fillId:   0,
		borderId: 0
	}, 0xFFFF));
	/* 1*65430(BrtXF *FRT) */
	write_record(ba, 0x0273 /* BrtEndCellStyleXFs */);
}

function write_CELLXFS_bin(ba, data) {
	write_record(ba, 0x0269 /* BrtBeginCellXFs */, write_UInt32LE(data.length));
	data.forEach(function(c) { write_record(ba, 0x002F /* BrtXF */, write_BrtXF(c,0)); });
	/* 1*65430(BrtXF *FRT) */
	write_record(ba, 0x026A /* BrtEndCellXFs */);
}

function write_STYLES_bin(ba) {
	var cnt = 1;

	write_record(ba, 0x026B /* BrtBeginStyles */, write_UInt32LE(cnt));
	write_record(ba, 0x0030 /* BrtStyle */, write_BrtStyle({
		xfId:0,
		builtinId:0,
		name:"Normal"
	}));
	/* 1*65430(BrtStyle *FRT) */
	write_record(ba, 0x026C /* BrtEndStyles */);
}

function write_DXFS_bin(ba) {
	var cnt = 0;

	write_record(ba, 0x01F9 /* BrtBeginDXFs */, write_UInt32LE(cnt));
	/* *2147483647(BrtDXF *FRT) */
	write_record(ba, 0x01FA /* BrtEndDXFs */);
}

function write_TABLESTYLES_bin(ba) {
	var cnt = 0;

	write_record(ba, 0x01FC /* BrtBeginTableStyles */, write_BrtBeginTableStyles(cnt, "TableStyleMedium9", "PivotStyleMedium4"));
	/* *TABLESTYLE */
	write_record(ba, 0x01FD /* BrtEndTableStyles */);
}

function write_COLORPALETTE_bin() {
	return;
	/* BrtBeginColorPalette [INDEXEDCOLORS] [MRUCOLORS] BrtEndColorPalette */
}

/* [MS-XLSB] 2.1.7.50 Styles */
function write_sty_bin(wb, opts) {
	var ba = buf_array();
	write_record(ba, 0x0116 /* BrtBeginStyleSheet */);
	write_FMTS_bin(ba, wb.SSF);
	write_FONTS_bin(ba, wb);
	write_FILLS_bin(ba, wb);
	write_BORDERS_bin(ba, wb);
	write_CELLSTYLEXFS_bin(ba, wb);
	write_CELLXFS_bin(ba, opts.cellXfs);
	write_STYLES_bin(ba, wb);
	write_DXFS_bin(ba, wb);
	write_TABLESTYLES_bin(ba, wb);
	write_COLORPALETTE_bin(ba, wb);
	/* FRTSTYLESHEET*/
	write_record(ba, 0x0117 /* BrtEndStyleSheet */);
	return ba.end();
}
/* Even though theme layout is dk1 lt1 dk2 lt2, true order is lt1 dk1 lt2 dk2 */
var XLSXThemeClrScheme = [
	'</a:lt1>', '</a:dk1>', '</a:lt2>', '</a:dk2>',
	'</a:accent1>', '</a:accent2>', '</a:accent3>',
	'</a:accent4>', '</a:accent5>', '</a:accent6>',
	'</a:hlink>', '</a:folHlink>'
];
/* 20.1.6.2 clrScheme CT_ColorScheme */
function parse_clrScheme(t, themes, opts) {
	themes.themeElements.clrScheme = [];
	var color = {};
	(t[0].match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x);
		switch(y[0]) {
			/* 20.1.6.2 clrScheme (Color Scheme) CT_ColorScheme */
			case '<a:clrScheme': case '</a:clrScheme>': break;

			/* 20.1.2.3.32 srgbClr CT_SRgbColor */
			case '<a:srgbClr':
				color.rgb = y.val; break;

			/* 20.1.2.3.33 sysClr CT_SystemColor */
			case '<a:sysClr':
				color.rgb = y.lastClr; break;

			/* 20.1.4.1.1 accent1 (Accent 1) */
			/* 20.1.4.1.2 accent2 (Accent 2) */
			/* 20.1.4.1.3 accent3 (Accent 3) */
			/* 20.1.4.1.4 accent4 (Accent 4) */
			/* 20.1.4.1.5 accent5 (Accent 5) */
			/* 20.1.4.1.6 accent6 (Accent 6) */
			/* 20.1.4.1.9 dk1 (Dark 1) */
			/* 20.1.4.1.10 dk2 (Dark 2) */
			/* 20.1.4.1.15 folHlink (Followed Hyperlink) */
			/* 20.1.4.1.19 hlink (Hyperlink) */
			/* 20.1.4.1.22 lt1 (Light 1) */
			/* 20.1.4.1.23 lt2 (Light 2) */
			case '<a:dk1>': case '</a:dk1>':
			case '<a:lt1>': case '</a:lt1>':
			case '<a:dk2>': case '</a:dk2>':
			case '<a:lt2>': case '</a:lt2>':
			case '<a:accent1>': case '</a:accent1>':
			case '<a:accent2>': case '</a:accent2>':
			case '<a:accent3>': case '</a:accent3>':
			case '<a:accent4>': case '</a:accent4>':
			case '<a:accent5>': case '</a:accent5>':
			case '<a:accent6>': case '</a:accent6>':
			case '<a:hlink>': case '</a:hlink>':
			case '<a:folHlink>': case '</a:folHlink>':
				if (y[0].charAt(1) === '/') {
					themes.themeElements.clrScheme[XLSXThemeClrScheme.indexOf(y[0])] = color;
					color = {};
				} else {
					color.name = y[0].slice(3, y[0].length - 1);
				}
				break;

			default: if(opts && opts.WTF) throw new Error('Unrecognized ' + y[0] + ' in clrScheme');
		}
	});
}

/* 20.1.4.1.18 fontScheme CT_FontScheme */
function parse_fontScheme() { }

/* 20.1.4.1.15 fmtScheme CT_StyleMatrix */
function parse_fmtScheme() { }

var clrsregex = /<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/;
var fntsregex = /<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/;
var fmtsregex = /<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;

/* 20.1.6.10 themeElements CT_BaseStyles */
function parse_themeElements(data, themes, opts) {
	themes.themeElements = {};

	var t;

	[
		/* clrScheme CT_ColorScheme */
		['clrScheme', clrsregex, parse_clrScheme],
		/* fontScheme CT_FontScheme */
		['fontScheme', fntsregex, parse_fontScheme],
		/* fmtScheme CT_StyleMatrix */
		['fmtScheme', fmtsregex, parse_fmtScheme]
	].forEach(function(m) {
		if(!(t=data.match(m[1]))) throw new Error(m[0] + ' not found in themeElements');
		m[2](t, themes, opts);
	});
}

var themeltregex = /<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;

/* 14.2.7 Theme Part */
function parse_theme_xml(data, opts) {
	/* 20.1.6.9 theme CT_OfficeStyleSheet */
	if(!data || data.length === 0) data = write_theme();

	var t;
	var themes = {};

	/* themeElements CT_BaseStyles */
	if(!(t=data.match(themeltregex))) throw new Error('themeElements not found in theme');
	parse_themeElements(t[0], themes, opts);
	themes.raw = data;
	return themes;
}

function write_theme(Themes, opts) {
	if(opts && opts.themeXLSX) return opts.themeXLSX;
	if(Themes && typeof Themes.raw == "string") return Themes.raw;
	var o = [XML_HEADER];
	o[o.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';
	o[o.length] =  '<a:themeElements>';

	o[o.length] =   '<a:clrScheme name="Office">';
	o[o.length] =    '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';
	o[o.length] =    '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';
	o[o.length] =    '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';
	o[o.length] =    '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';
	o[o.length] =    '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';
	o[o.length] =    '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';
	o[o.length] =    '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';
	o[o.length] =    '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';
	o[o.length] =    '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';
	o[o.length] =    '<a:accent6><a:srgbClr val="F79646"/></a:accent6>';
	o[o.length] =    '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';
	o[o.length] =    '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';
	o[o.length] =   '</a:clrScheme>';

	o[o.length] =   '<a:fontScheme name="Office">';
	o[o.length] =    '<a:majorFont>';
	o[o.length] =     '<a:latin typeface="Cambria"/>';
	o[o.length] =     '<a:ea typeface=""/>';
	o[o.length] =     '<a:cs typeface=""/>';
	o[o.length] =     '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
	o[o.length] =     '<a:font script="Hang" typeface="맑은 고딕"/>';
	o[o.length] =     '<a:font script="Hans" typeface="宋体"/>';
	o[o.length] =     '<a:font script="Hant" typeface="新細明體"/>';
	o[o.length] =     '<a:font script="Arab" typeface="Times New Roman"/>';
	o[o.length] =     '<a:font script="Hebr" typeface="Times New Roman"/>';
	o[o.length] =     '<a:font script="Thai" typeface="Tahoma"/>';
	o[o.length] =     '<a:font script="Ethi" typeface="Nyala"/>';
	o[o.length] =     '<a:font script="Beng" typeface="Vrinda"/>';
	o[o.length] =     '<a:font script="Gujr" typeface="Shruti"/>';
	o[o.length] =     '<a:font script="Khmr" typeface="MoolBoran"/>';
	o[o.length] =     '<a:font script="Knda" typeface="Tunga"/>';
	o[o.length] =     '<a:font script="Guru" typeface="Raavi"/>';
	o[o.length] =     '<a:font script="Cans" typeface="Euphemia"/>';
	o[o.length] =     '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
	o[o.length] =     '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
	o[o.length] =     '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
	o[o.length] =     '<a:font script="Thaa" typeface="MV Boli"/>';
	o[o.length] =     '<a:font script="Deva" typeface="Mangal"/>';
	o[o.length] =     '<a:font script="Telu" typeface="Gautami"/>';
	o[o.length] =     '<a:font script="Taml" typeface="Latha"/>';
	o[o.length] =     '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
	o[o.length] =     '<a:font script="Orya" typeface="Kalinga"/>';
	o[o.length] =     '<a:font script="Mlym" typeface="Kartika"/>';
	o[o.length] =     '<a:font script="Laoo" typeface="DokChampa"/>';
	o[o.length] =     '<a:font script="Sinh" typeface="Iskoola Pota"/>';
	o[o.length] =     '<a:font script="Mong" typeface="Mongolian Baiti"/>';
	o[o.length] =     '<a:font script="Viet" typeface="Times New Roman"/>';
	o[o.length] =     '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
	o[o.length] =     '<a:font script="Geor" typeface="Sylfaen"/>';
	o[o.length] =    '</a:majorFont>';
	o[o.length] =    '<a:minorFont>';
	o[o.length] =     '<a:latin typeface="Calibri"/>';
	o[o.length] =     '<a:ea typeface=""/>';
	o[o.length] =     '<a:cs typeface=""/>';
	o[o.length] =     '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
	o[o.length] =     '<a:font script="Hang" typeface="맑은 고딕"/>';
	o[o.length] =     '<a:font script="Hans" typeface="宋体"/>';
	o[o.length] =     '<a:font script="Hant" typeface="新細明體"/>';
	o[o.length] =     '<a:font script="Arab" typeface="Arial"/>';
	o[o.length] =     '<a:font script="Hebr" typeface="Arial"/>';
	o[o.length] =     '<a:font script="Thai" typeface="Tahoma"/>';
	o[o.length] =     '<a:font script="Ethi" typeface="Nyala"/>';
	o[o.length] =     '<a:font script="Beng" typeface="Vrinda"/>';
	o[o.length] =     '<a:font script="Gujr" typeface="Shruti"/>';
	o[o.length] =     '<a:font script="Khmr" typeface="DaunPenh"/>';
	o[o.length] =     '<a:font script="Knda" typeface="Tunga"/>';
	o[o.length] =     '<a:font script="Guru" typeface="Raavi"/>';
	o[o.length] =     '<a:font script="Cans" typeface="Euphemia"/>';
	o[o.length] =     '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
	o[o.length] =     '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
	o[o.length] =     '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
	o[o.length] =     '<a:font script="Thaa" typeface="MV Boli"/>';
	o[o.length] =     '<a:font script="Deva" typeface="Mangal"/>';
	o[o.length] =     '<a:font script="Telu" typeface="Gautami"/>';
	o[o.length] =     '<a:font script="Taml" typeface="Latha"/>';
	o[o.length] =     '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
	o[o.length] =     '<a:font script="Orya" typeface="Kalinga"/>';
	o[o.length] =     '<a:font script="Mlym" typeface="Kartika"/>';
	o[o.length] =     '<a:font script="Laoo" typeface="DokChampa"/>';
	o[o.length] =     '<a:font script="Sinh" typeface="Iskoola Pota"/>';
	o[o.length] =     '<a:font script="Mong" typeface="Mongolian Baiti"/>';
	o[o.length] =     '<a:font script="Viet" typeface="Arial"/>';
	o[o.length] =     '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
	o[o.length] =     '<a:font script="Geor" typeface="Sylfaen"/>';
	o[o.length] =    '</a:minorFont>';
	o[o.length] =   '</a:fontScheme>';

	o[o.length] =   '<a:fmtScheme name="Office">';
	o[o.length] =    '<a:fillStyleLst>';
	o[o.length] =     '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
	o[o.length] =     '<a:gradFill rotWithShape="1">';
	o[o.length] =      '<a:gsLst>';
	o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
	o[o.length] =      '</a:gsLst>';
	o[o.length] =      '<a:lin ang="16200000" scaled="1"/>';
	o[o.length] =     '</a:gradFill>';
	o[o.length] =     '<a:gradFill rotWithShape="1">';
	o[o.length] =      '<a:gsLst>';
	o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
	o[o.length] =      '</a:gsLst>';
	o[o.length] =      '<a:lin ang="16200000" scaled="0"/>';
	o[o.length] =     '</a:gradFill>';
	o[o.length] =    '</a:fillStyleLst>';
	o[o.length] =    '<a:lnStyleLst>';
	o[o.length] =     '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';
	o[o.length] =     '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
	o[o.length] =     '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
	o[o.length] =    '</a:lnStyleLst>';
	o[o.length] =    '<a:effectStyleLst>';
	o[o.length] =     '<a:effectStyle>';
	o[o.length] =      '<a:effectLst>';
	o[o.length] =       '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';
	o[o.length] =      '</a:effectLst>';
	o[o.length] =     '</a:effectStyle>';
	o[o.length] =     '<a:effectStyle>';
	o[o.length] =      '<a:effectLst>';
	o[o.length] =       '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
	o[o.length] =      '</a:effectLst>';
	o[o.length] =     '</a:effectStyle>';
	o[o.length] =     '<a:effectStyle>';
	o[o.length] =      '<a:effectLst>';
	o[o.length] =       '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
	o[o.length] =      '</a:effectLst>';
	o[o.length] =      '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';
	o[o.length] =      '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';
	o[o.length] =     '</a:effectStyle>';
	o[o.length] =    '</a:effectStyleLst>';
	o[o.length] =    '<a:bgFillStyleLst>';
	o[o.length] =     '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
	o[o.length] =     '<a:gradFill rotWithShape="1">';
	o[o.length] =      '<a:gsLst>';
	o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';
	o[o.length] =      '</a:gsLst>';
	o[o.length] =      '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';
	o[o.length] =     '</a:gradFill>';
	o[o.length] =     '<a:gradFill rotWithShape="1">';
	o[o.length] =      '<a:gsLst>';
	o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';
	o[o.length] =      '</a:gsLst>';
	o[o.length] =      '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';
	o[o.length] =     '</a:gradFill>';
	o[o.length] =    '</a:bgFillStyleLst>';
	o[o.length] =   '</a:fmtScheme>';
	o[o.length] =  '</a:themeElements>';

	o[o.length] =  '<a:objectDefaults>';
	o[o.length] =   '<a:spDef>';
	o[o.length] =    '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';
	o[o.length] =   '</a:spDef>';
	o[o.length] =   '<a:lnDef>';
	o[o.length] =    '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';
	o[o.length] =   '</a:lnDef>';
	o[o.length] =  '</a:objectDefaults>';
	o[o.length] =  '<a:extraClrSchemeLst/>';
	o[o.length] = '</a:theme>';
	return o.join("");
}
/* [MS-XLS] 2.4.326 TODO: payload is a zip file */
function parse_Theme(blob, length, opts) {
	var end = blob.l + length;
	var dwThemeVersion = blob.read_shift(4);
	if(dwThemeVersion === 124226) return;
	if(!opts.cellStyles) { blob.l = end; return; }
	var data = blob.slice(blob.l);
	blob.l = end;
	var zip; try { zip = zip_read(data, {type: "array"}); } catch(e) { return; }
	var themeXML = getzipstr(zip, "theme/theme/theme1.xml", true);
	if(!themeXML) return;
	return parse_theme_xml(themeXML, opts);
}

/* 2.5.49 */
function parse_ColorTheme(blob) { return blob.read_shift(4); }

/* 2.5.155 */
function parse_FullColorExt(blob) {
	var o = {};
	o.xclrType = blob.read_shift(2);
	o.nTintShade = blob.read_shift(2);
	switch(o.xclrType) {
		case 0: blob.l += 4; break;
		case 1: o.xclrValue = parse_IcvXF(blob, 4); break;
		case 2: o.xclrValue = parse_LongRGBA(blob, 4); break;
		case 3: o.xclrValue = parse_ColorTheme(blob, 4); break;
		case 4: blob.l += 4; break;
	}
	blob.l += 8;
	return o;
}

/* 2.5.164 TODO: read 7 bits*/
function parse_IcvXF(blob, length) {
	return parsenoop(blob, length);
}

/* 2.5.280 */
function parse_XFExtGradient(blob, length) {
	return parsenoop(blob, length);
}

/* [MS-XLS] 2.5.108 */
function parse_ExtProp(blob) {
	var extType = blob.read_shift(2);
	var cb = blob.read_shift(2) - 4;
	var o = [extType];
	switch(extType) {
		case 0x04: case 0x05: case 0x07: case 0x08:
		case 0x09: case 0x0A: case 0x0B: case 0x0D:
			o[1] = parse_FullColorExt(blob, cb); break;
		case 0x06: o[1] = parse_XFExtGradient(blob, cb); break;
		case 0x0E: case 0x0F: o[1] = blob.read_shift(cb === 1 ? 1 : 2); break;
		default: throw new Error("Unrecognized ExtProp type: " + extType + " " + cb);
	}
	return o;
}

/* 2.4.355 */
function parse_XFExt(blob, length) {
	var end = blob.l + length;
	blob.l += 2;
	var ixfe = blob.read_shift(2);
	blob.l += 2;
	var cexts = blob.read_shift(2);
	var ext = [];
	while(cexts-- > 0) ext.push(parse_ExtProp(blob, end-blob.l));
	return {ixfe:ixfe, ext:ext};
}

/* xf is an XF, see parse_XFExt for xfext */
function update_xfext(xf, xfext) {
	xfext.forEach(function(xfe) {
		switch(xfe[0]) { /* 2.5.108 extPropData */
			case 0x04: break; /* foreground color */
			case 0x05: break; /* background color */
			case 0x06: break; /* gradient fill */
			case 0x07: break; /* top cell border color */
			case 0x08: break; /* bottom cell border color */
			case 0x09: break; /* left cell border color */
			case 0x0a: break; /* right cell border color */
			case 0x0b: break; /* diagonal cell border color */
			case 0x0d: /* text color */
				break;
			case 0x0e: break; /* font scheme */
			case 0x0f: break; /* indentation level */
		}
	});
}

function parse_BrtMdtinfo(data, length) {
  return {
    flags: data.read_shift(4),
    version: data.read_shift(4),
    name: parse_XLWideString(data, length - 8)
  };
}
function write_BrtMdtinfo(data) {
  var o = new_buf(12 + 2 * data.name.length);
  o.write_shift(4, data.flags);
  o.write_shift(4, data.version);
  write_XLWideString(data.name, o);
  return o.slice(0, o.l);
}
function parse_BrtMdb(data) {
  var out = [];
  var cnt = data.read_shift(4);
  while (cnt-- > 0)
    out.push([data.read_shift(4), data.read_shift(4)]);
  return out;
}
function write_BrtMdb(mdb) {
  var o = new_buf(4 + 8 * mdb.length);
  o.write_shift(4, mdb.length);
  for (var i = 0; i < mdb.length; ++i) {
    o.write_shift(4, mdb[i][0]);
    o.write_shift(4, mdb[i][1]);
  }
  return o;
}
function write_BrtBeginEsfmd(cnt, name) {
  var o = new_buf(8 + 2 * name.length);
  o.write_shift(4, cnt);
  write_XLWideString(name, o);
  return o.slice(0, o.l);
}
function parse_BrtBeginEsmdb(data) {
  data.l += 4;
  return data.read_shift(4) != 0;
}
function write_BrtBeginEsmdb(cnt, cm) {
  var o = new_buf(8);
  o.write_shift(4, cnt);
  o.write_shift(4, cm ? 1 : 0);
  return o;
}
function parse_xlmeta_bin(data, name, _opts) {
  var out = { Types: [], Cell: [], Value: [] };
  var opts = _opts || {};
  var state = [];
  var pass = false;
  var metatype = 2;
  recordhopper(data, function(val, R, RT) {
    switch (RT) {
      case 335:
        out.Types.push({ name: val.name });
        break;
      case 51:
        val.forEach(function(r) {
          if (metatype == 1)
            out.Cell.push({ type: out.Types[r[0] - 1].name, index: r[1] });
          else if (metatype == 0)
            out.Value.push({ type: out.Types[r[0] - 1].name, index: r[1] });
        });
        break;
      case 337:
        metatype = val ? 1 : 0;
        break;
      case 338:
        metatype = 2;
        break;
      case 35:
        state.push(RT);
        pass = true;
        break;
      case 36:
        state.pop();
        pass = false;
        break;
      default:
        if (R.T) {
        } else if (!pass || opts.WTF && state[state.length - 1] != 35)
          throw new Error("Unexpected record 0x" + RT.toString(16));
    }
  });
  return out;
}
function write_xlmeta_bin() {
  var ba = buf_array();
  write_record(ba, 332);
  write_record(ba, 334, write_UInt32LE(1));
  write_record(ba, 335, write_BrtMdtinfo({
    name: "XLDAPR",
    version: 12e4,
    flags: 3496657072
  }));
  write_record(ba, 336);
  write_record(ba, 339, write_BrtBeginEsfmd(1, "XLDAPR"));
  write_record(ba, 52);
  write_record(ba, 35, write_UInt32LE(514));
  write_record(ba, 4096, write_UInt32LE(0));
  write_record(ba, 4097, writeuint16(1));
  write_record(ba, 36);
  write_record(ba, 53);
  write_record(ba, 340);
  write_record(ba, 337, write_BrtBeginEsmdb(1, true));
  write_record(ba, 51, write_BrtMdb([[1, 0]]));
  write_record(ba, 338);
  write_record(ba, 333);
  return ba.end();
}
function parse_xlmeta_xml(data, name, opts) {
  var out = { Types: [], Cell: [], Value: [] };
  if (!data)
    return out;
  var pass = false;
  var metatype = 2;
  var lastmeta;
  data.replace(tagregex, function(x) {
    var y = parsexmltag(x);
    switch (strip_ns(y[0])) {
      case "<?xml":
        break;
      case "<metadata":
      case "</metadata>":
        break;
      case "<metadataTypes":
      case "</metadataTypes>":
        break;
      case "<metadataType":
        out.Types.push({ name: y.name });
        break;
      case "</metadataType>":
        break;
      case "<futureMetadata":
        for (var j = 0; j < out.Types.length; ++j)
          if (out.Types[j].name == y.name)
            lastmeta = out.Types[j];
        break;
      case "</futureMetadata>":
        break;
      case "<bk>":
        break;
      case "</bk>":
        break;
      case "<rc":
        if (metatype == 1)
          out.Cell.push({ type: out.Types[y.t - 1].name, index: +y.v });
        else if (metatype == 0)
          out.Value.push({ type: out.Types[y.t - 1].name, index: +y.v });
        break;
      case "</rc>":
        break;
      case "<cellMetadata":
        metatype = 1;
        break;
      case "</cellMetadata>":
        metatype = 2;
        break;
      case "<valueMetadata":
        metatype = 0;
        break;
      case "</valueMetadata>":
        metatype = 2;
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
      case "<extLst/>":
        break;
      case "<ext":
        pass = true;
        break;
      case "</ext>":
        pass = false;
        break;
      case "<rvb":
        if (!lastmeta)
          break;
        if (!lastmeta.offsets)
          lastmeta.offsets = [];
        lastmeta.offsets.push(+y.i);
        break;
      default:
        if (!pass && (opts == null ? void 0 : opts.WTF))
          throw new Error("unrecognized " + y[0] + " in metadata");
    }
    return x;
  });
  return out;
}
function write_xlmeta_xml() {
  var o = [XML_HEADER];
  o.push('<metadata xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:xlrd="http://schemas.microsoft.com/office/spreadsheetml/2017/richdata" xmlns:xda="http://schemas.microsoft.com/office/spreadsheetml/2017/dynamicarray">\n  <metadataTypes count="1">\n    <metadataType name="XLDAPR" minSupportedVersion="120000" copy="1" pasteAll="1" pasteValues="1" merge="1" splitFirst="1" rowColShift="1" clearFormats="1" clearComments="1" assign="1" coerce="1" cellMeta="1"/>\n  </metadataTypes>\n  <futureMetadata name="XLDAPR" count="1">\n    <bk>\n      <extLst>\n        <ext uri="{bdbb8cdc-fa1e-496e-a857-3c3f30c029c3}">\n          <xda:dynamicArrayProperties fDynamic="1" fCollapsed="0"/>\n        </ext>\n      </extLst>\n    </bk>\n  </futureMetadata>\n  <cellMetadata count="1">\n    <bk>\n      <rc t="1" v="0"/>\n    </bk>\n  </cellMetadata>\n</metadata>');
  return o.join("");
}
/* 18.6 Calculation Chain */
function parse_cc_xml(data) {
	var d = [];
	if(!data) return d;
	var i = 1;
	(data.match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x);
		switch(y[0]) {
			case '<?xml': break;
			/* 18.6.2  calcChain CT_CalcChain 1 */
			case '<calcChain': case '<calcChain>': case '</calcChain>': break;
			/* 18.6.1  c CT_CalcCell 1 */
			case '<c': delete y[0]; if(y.i) i = y.i; else y.i = i; d.push(y); break;
		}
	});
	return d;
}

//function write_cc_xml(data, opts) { }

/* [MS-XLSB] 2.6.4.1 */
function parse_BrtCalcChainItem$(data) {
	var out = {};
	out.i = data.read_shift(4);
	var cell = {};
	cell.r = data.read_shift(4);
	cell.c = data.read_shift(4);
	out.r = encode_cell(cell);
	var flags = data.read_shift(1);
	if(flags & 0x2) out.l = '1';
	if(flags & 0x8) out.a = '1';
	return out;
}

/* 18.6 Calculation Chain */
function parse_cc_bin(data, name, opts) {
	var out = [];
	var pass = false;
	recordhopper(data, function hopper_cc(val, R, RT) {
		switch(RT) {
			case 0x003F: /* 'BrtCalcChainItem$' */
				out.push(val); break;

			default:
				if(R.T){/* empty */}
				else if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
		}
	});
	return out;
}

//function write_cc_bin(data, opts) { }
/* 18.14 Supplementary Workbook Data */
function parse_xlink_xml() {
	//var opts = _opts || {};
	//if(opts.WTF) throw "XLSX External Link";
}

/* [MS-XLSB] 2.1.7.25 External Link */
function parse_xlink_bin(data, rel, name, _opts) {
	if(!data) return data;
	var opts = _opts || {};

	var pass = false, end = false;

	recordhopper(data, function xlink_parse(val, R, RT) {
		if(end) return;
		switch(RT) {
			case 0x0167: /* 'BrtSupTabs' */
			case 0x016B: /* 'BrtExternTableStart' */
			case 0x016C: /* 'BrtExternTableEnd' */
			case 0x016E: /* 'BrtExternRowHdr' */
			case 0x016F: /* 'BrtExternCellBlank' */
			case 0x0170: /* 'BrtExternCellReal' */
			case 0x0171: /* 'BrtExternCellBool' */
			case 0x0172: /* 'BrtExternCellError' */
			case 0x0173: /* 'BrtExternCellString' */
			case 0x01D8: /* 'BrtExternValueMeta' */
			case 0x0241: /* 'BrtSupNameStart' */
			case 0x0242: /* 'BrtSupNameValueStart' */
			case 0x0243: /* 'BrtSupNameValueEnd' */
			case 0x0244: /* 'BrtSupNameNum' */
			case 0x0245: /* 'BrtSupNameErr' */
			case 0x0246: /* 'BrtSupNameSt' */
			case 0x0247: /* 'BrtSupNameNil' */
			case 0x0248: /* 'BrtSupNameBool' */
			case 0x0249: /* 'BrtSupNameFmla' */
			case 0x024A: /* 'BrtSupNameBits' */
			case 0x024B: /* 'BrtSupNameEnd' */
				break;

			case 0x0023: /* 'BrtFRTBegin' */
				pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				pass = false; break;

			default:
				if(R.T){/* empty */}
				else if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
		}
	}, opts);
}
/* 20.5 DrawingML - SpreadsheetML Drawing */
/* 20.5.2.35 wsDr CT_Drawing */
function parse_drawing(data, rels) {
	if(!data) return "??";
	/*
	  Chartsheet Drawing:
	   - 20.5.2.35 wsDr CT_Drawing
	    - 20.5.2.1  absoluteAnchor CT_AbsoluteAnchor
	     - 20.5.2.16 graphicFrame CT_GraphicalObjectFrame
	      - 20.1.2.2.16 graphic CT_GraphicalObject
	       - 20.1.2.2.17 graphicData CT_GraphicalObjectData
          - chart reference
	   the actual type is based on the URI of the graphicData
		TODO: handle embedded charts and other types of graphics
	*/
	var id = (data.match(/<c:chart [^>]*r:id="([^"]*)"/)||["",""])[1];

	return rels['!id'][id].Target;
}

/* L.5.5.2 SpreadsheetML Comments + VML Schema */
function write_vml(rId, comments) {
	var csize = [21600, 21600];
	/* L.5.2.1.2 Path Attribute */
	var bbox = ["m0,0l0",csize[1],csize[0],csize[1],csize[0],"0xe"].join(",");
	var o = [
		writextag("xml", null, { 'xmlns:v': XLMLNS.v, 'xmlns:o': XLMLNS.o, 'xmlns:x': XLMLNS.x, 'xmlns:mv': XLMLNS.mv }).replace(/\/>/,">"),
		writextag("o:shapelayout", writextag("o:idmap", null, {'v:ext':"edit", 'data':rId}), {'v:ext':"edit"})
	];

	var _shapeid = 65536 * rId;

	var _comments = comments || [];
	if(_comments.length > 0) o.push(writextag("v:shapetype", [
		writextag("v:stroke", null, {joinstyle:"miter"}),
		writextag("v:path", null, {gradientshapeok:"t", 'o:connecttype':"rect"})
	].join(""), {id:"_x0000_t202", coordsize:csize.join(","), 'o:spt':202, path:bbox}));

	_comments.forEach(function(x) { ++_shapeid; o.push(write_vml_comment(x, _shapeid)); });
	o.push('</xml>');
	return o.join("");
}

function write_vml_comment(x, _shapeid) {
	var c = decode_cell(x[0]);
	var fillopts = {'color2':"#BEFF82", 'type':"gradient"};
	if(fillopts.type == "gradient") fillopts.angle = "-180";
	var fillparm = fillopts.type == "gradient" ? writextag("o:fill", null, {type:"gradientUnscaled", 'v:ext':"view"}) : null;
	var fillxml = writextag('v:fill', fillparm, fillopts);

	var shadata = ({on:"t", 'obscured':"t"});

	return [
	'<v:shape' + wxt_helper({
		id:'_x0000_s' + _shapeid,
		type:"#_x0000_t202",
		style:"position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10" + (x[1].hidden ? ";visibility:hidden" : "") ,
		fillcolor:"#ECFAD4",
		strokecolor:"#edeaa1"
	}) + '>',
		fillxml,
		writextag("v:shadow", null, shadata),
		writextag("v:path", null, {'o:connecttype':"none"}),
		'<v:textbox><div style="text-align:left"></div></v:textbox>',
		'<x:ClientData ObjectType="Note">',
			'<x:MoveWithCells/>',
			'<x:SizeWithCells/>',
			/* Part 4 19.4.2.3 Anchor (Anchor) */
			writetag('x:Anchor', [c.c+1, 0, c.r+1, 0, c.c+3, 20, c.r+5, 20].join(",")),
			writetag('x:AutoFill', "False"),
			writetag('x:Row', String(c.r)),
			writetag('x:Column', String(c.c)),
			x[1].hidden ? '' : '<x:Visible/>',
		'</x:ClientData>',
	'</v:shape>'
	].join("");
}
function sheet_insert_comments(sheet, comments, threaded, people) {
	var dense = Array.isArray(sheet);
	var cell;
	comments.forEach(function(comment) {
		var r = decode_cell(comment.ref);
		if(dense) {
			if(!sheet[r.r]) sheet[r.r] = [];
			cell = sheet[r.r][r.c];
		} else cell = sheet[comment.ref];
		if (!cell) {
			cell = ({t:"z"});
			if(dense) sheet[r.r][r.c] = cell;
			else sheet[comment.ref] = cell;
			var range = safe_decode_range(sheet["!ref"]||"BDWGO1000001:A1");
			if(range.s.r > r.r) range.s.r = r.r;
			if(range.e.r < r.r) range.e.r = r.r;
			if(range.s.c > r.c) range.s.c = r.c;
			if(range.e.c < r.c) range.e.c = r.c;
			var encoded = encode_range(range);
			if (encoded !== sheet["!ref"]) sheet["!ref"] = encoded;
		}

		if (!cell.c) cell.c = [];
		var o = ({a: comment.author, t: comment.t, r: comment.r, T: threaded});
		if(comment.h) o.h = comment.h;

		/* threaded comments always override */
		for(var i = cell.c.length - 1; i >= 0; --i) {
			if(!threaded && cell.c[i].T) return;
			if(threaded && !cell.c[i].T) cell.c.splice(i, 1);
		}
		if(threaded && people) for(i = 0; i < people.length; ++i) {
			if(o.a == people[i].id) { o.a = people[i].name || o.a; break; }
		}
		cell.c.push(o);
	});
}

/* 18.7 Comments */
function parse_comments_xml(data, opts) {
	/* 18.7.6 CT_Comments */
	if(data.match(/<(?:\w+:)?comments *\/>/)) return [];
	var authors = [];
	var commentList = [];
	var authtag = data.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);
	if(authtag && authtag[1]) authtag[1].split(/<\/\w*:?author>/).forEach(function(x) {
		if(x === "" || x.trim() === "") return;
		var a = x.match(/<(?:\w+:)?author[^>]*>(.*)/);
		if(a) authors.push(a[1]);
	});
	var cmnttag = data.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);
	if(cmnttag && cmnttag[1]) cmnttag[1].split(/<\/\w*:?comment>/).forEach(function(x) {
		if(x === "" || x.trim() === "") return;
		var cm = x.match(/<(?:\w+:)?comment[^>]*>/);
		if(!cm) return;
		var y = parsexmltag(cm[0]);
		var comment = ({ author: y.authorId && authors[y.authorId] || "sheetjsghost", ref: y.ref, guid: y.guid });
		var cell = decode_cell(y.ref);
		if(opts.sheetRows && opts.sheetRows <= cell.r) return;
		var textMatch = x.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/);
		var rt = !!textMatch && !!textMatch[1] && parse_si(textMatch[1]) || {r:"",t:"",h:""};
		comment.r = rt.r;
		if(rt.r == "<t></t>") rt.t = rt.h = "";
		comment.t = (rt.t||"").replace(/\r\n/g,"\n").replace(/\r/g,"\n");
		if(opts.cellHTML) comment.h = rt.h;
		commentList.push(comment);
	});
	return commentList;
}

function write_comments_xml(data) {
	var o = [XML_HEADER, writextag('comments', null, { 'xmlns': XMLNS_main[0] })];

	var iauthor = [];
	o.push("<authors>");
	data.forEach(function(x) { x[1].forEach(function(w) { var a = escapexml(w.a);
		if(iauthor.indexOf(a) == -1) {
			iauthor.push(a);
			o.push("<author>" + a + "</author>");
		}
		if(w.T && w.ID && iauthor.indexOf("tc=" + w.ID) == -1) {
			iauthor.push("tc=" + w.ID);
			o.push("<author>" + "tc=" + w.ID + "</author>");
		}
	}); });
	if(iauthor.length == 0) { iauthor.push("SheetJ5"); o.push("<author>SheetJ5</author>"); }
	o.push("</authors>");
	o.push("<commentList>");
	data.forEach(function(d) {
		/* 18.7.3 CT_Comment */
		var lastauthor = 0, ts = [], tcnt = 0;
		if(d[1][0] && d[1][0].T && d[1][0].ID) lastauthor = iauthor.indexOf("tc=" + d[1][0].ID);
		d[1].forEach(function(c) {
			if(c.a) lastauthor = iauthor.indexOf(escapexml(c.a));
			if(c.T) ++tcnt;
			ts.push(c.t == null ? "" : escapexml(c.t));
		});
		if(tcnt === 0) {
			d[1].forEach(function(c) {
				o.push('<comment ref="' + d[0] + '" authorId="' + iauthor.indexOf(escapexml(c.a)) + '"><text>');
				o.push(writetag("t", c.t == null ? "" : escapexml(c.t)));
				o.push('</text></comment>');
			});
		} else {
			/* based on Threaded Comments -> Comments projection */
			o.push('<comment ref="' + d[0] + '" authorId="' + lastauthor + '"><text>');
			var t = "Comment:\n    " + (ts[0]) + "\n";
			for(var i = 1; i < ts.length; ++i) t += "Reply:\n    " + ts[i] + "\n";
			o.push(writetag("t", escapexml(t)));
			o.push('</text></comment>');
		}
	});
	o.push("</commentList>");
	if(o.length>2) { o[o.length] = ('</comments>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}

/* [MS-XLSX] 2.1.17 */
function parse_tcmnt_xml(data, opts) {
	var out = [];
	var pass = false, comment = {}, tidx = 0;
	data.replace(tagregex, function xml_tcmnt(x, idx) {
		var y = parsexmltag(x);
		switch(strip_ns(y[0])) {
			case '<?xml': break;

			/* 2.6.207 ThreadedComments CT_ThreadedComments */
			case '<ThreadedComments': break;
			case '</ThreadedComments>': break;

			/* 2.6.205 threadedComment CT_ThreadedComment */
			case '<threadedComment': comment = {author: y.personId, guid: y.id, ref: y.ref, T: 1}; break;
			case '</threadedComment>': if(comment.t != null) out.push(comment); break;

			case '<text>': case '<text': tidx = idx + x.length; break;
			case '</text>': comment.t = data.slice(tidx, idx).replace(/\r\n/g, "\n").replace(/\r/g, "\n"); break;

			/* 2.6.206 mentions CT_ThreadedCommentMentions TODO */
			case '<mentions': case '<mentions>': pass = true; break;
			case '</mentions>': pass = false; break;

			/* 2.6.202 mention CT_Mention TODO */

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': case '<extLst/>': break;
			/* 18.2.7  ext CT_Extension + */
			case '<ext': pass=true; break;
			case '</ext>': pass=false; break;

			default: if(!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in threaded comments');
		}
		return x;
	});
	return out;
}

function write_tcmnt_xml(comments, people, opts) {
	var o = [XML_HEADER, writextag('ThreadedComments', null, { 'xmlns': XMLNS.TCMNT }).replace(/[\/]>/, ">")];
	comments.forEach(function(carr) {
		var rootid = "";
		(carr[1] || []).forEach(function(c, idx) {
			if(!c.T) { delete c.ID; return; }
			if(c.a && people.indexOf(c.a) == -1) people.push(c.a);
			var tcopts = {
				ref: carr[0],
				id: "{54EE7951-7262-4200-6969-" + ("000000000000" + opts.tcid++).slice(-12) + "}"
			};
			if(idx == 0) rootid = tcopts.id;
			else tcopts.parentId = rootid;
			c.ID = tcopts.id;
			if(c.a) tcopts.personId = "{54EE7950-7262-4200-6969-" + ("000000000000" + people.indexOf(c.a)).slice(-12) + "}";
			o.push(writextag('threadedComment', writetag('text', c.t||""), tcopts));
		});
	});
	o.push('</ThreadedComments>');
	return o.join("");
}

/* [MS-XLSX] 2.1.18 */
function parse_people_xml(data, opts) {
	var out = [];
	var pass = false;
	data.replace(tagregex, function xml_tcmnt(x) {
		var y = parsexmltag(x);
		switch(strip_ns(y[0])) {
			case '<?xml': break;

			/* 2.4.85 personList CT_PersonList */
			case '<personList': break;
			case '</personList>': break;

			/* 2.6.203 person CT_Person TODO: providers */
			case '<person': out.push({name: y.displayname, id: y.id }); break;
			case '</person>': break;

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': case '<extLst/>': break;
			/* 18.2.7  ext CT_Extension + */
			case '<ext': pass=true; break;
			case '</ext>': pass=false; break;

			default: if(!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in threaded comments');
		}
		return x;
	});
	return out;
}
function write_people_xml(people/*, opts*/) {
	var o = [XML_HEADER, writextag('personList', null, {
		'xmlns': XMLNS.TCMNT,
		'xmlns:x': XMLNS_main[0]
	}).replace(/[\/]>/, ">")];
	people.forEach(function(person, idx) {
		o.push(writextag('person', null, {
			displayName: person,
			id: "{54EE7950-7262-4200-6969-" + ("000000000000" + idx).slice(-12) + "}",
			userId: person,
			providerId: "None"
		}));
	});
	o.push("</personList>");
	return o.join("");
}
/* [MS-XLSB] 2.4.28 BrtBeginComment */
function parse_BrtBeginComment(data) {
	var out = {};
	out.iauthor = data.read_shift(4);
	var rfx = parse_UncheckedRfX(data, 16);
	out.rfx = rfx.s;
	out.ref = encode_cell(rfx.s);
	data.l += 16; /*var guid = parse_GUID(data); */
	return out;
}
function write_BrtBeginComment(data, o) {
	if(o == null) o = new_buf(36);
	o.write_shift(4, data[1].iauthor);
	write_UncheckedRfX((data[0]), o);
	o.write_shift(4, 0);
	o.write_shift(4, 0);
	o.write_shift(4, 0);
	o.write_shift(4, 0);
	return o;
}

/* [MS-XLSB] 2.4.327 BrtCommentAuthor */
var parse_BrtCommentAuthor = parse_XLWideString;
function write_BrtCommentAuthor(data) { return write_XLWideString(data.slice(0, 54)); }

/* [MS-XLSB] 2.1.7.8 Comments */
function parse_comments_bin(data, opts) {
	var out = [];
	var authors = [];
	var c = {};
	var pass = false;
	recordhopper(data, function hopper_cmnt(val, R, RT) {
		switch(RT) {
			case 0x0278: /* 'BrtCommentAuthor' */
				authors.push(val); break;
			case 0x027B: /* 'BrtBeginComment' */
				c = val; break;
			case 0x027D: /* 'BrtCommentText' */
				c.t = val.t; c.h = val.h; c.r = val.r; break;
			case 0x027C: /* 'BrtEndComment' */
				c.author = authors[c.iauthor];
				delete (c).iauthor;
				if(opts.sheetRows && c.rfx && opts.sheetRows <= c.rfx.r) break;
				if(!c.t) c.t = "";
				delete c.rfx; out.push(c); break;

			case 0x0C00: /* 'BrtUid' */
				break;

			case 0x0023: /* 'BrtFRTBegin' */
				pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				pass = false; break;
			case 0x0025: /* 'BrtACBegin' */ break;
			case 0x0026: /* 'BrtACEnd' */ break;


			default:
				if(R.T){/* empty */}
				else if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
		}
	});
	return out;
}

function write_comments_bin(data) {
	var ba = buf_array();
	var iauthor = [];
	write_record(ba, 0x0274 /* BrtBeginComments */);

	write_record(ba, 0x0276 /* BrtBeginCommentAuthors */);
	data.forEach(function(comment) {
		comment[1].forEach(function(c) {
			if(iauthor.indexOf(c.a) > -1) return;
			iauthor.push(c.a.slice(0,54));
			write_record(ba, 0x0278 /* BrtCommentAuthor */, write_BrtCommentAuthor(c.a));
		});
	});
	write_record(ba, 0x0277 /* BrtEndCommentAuthors */);

	write_record(ba, 0x0279 /* BrtBeginCommentList */);
	data.forEach(function(comment) {
		comment[1].forEach(function(c) {
			c.iauthor = iauthor.indexOf(c.a);
			var range = {s:decode_cell(comment[0]),e:decode_cell(comment[0])};
			write_record(ba, 0x027B /* BrtBeginComment */, write_BrtBeginComment([range, c]));
			if(c.t && c.t.length > 0) write_record(ba, 0x027D /* BrtCommentText */, write_BrtCommentText(c));
			write_record(ba, 0x027C /* BrtEndComment */);
			delete c.iauthor;
		});
	});
	write_record(ba, 0x027A /* BrtEndCommentList */);

	write_record(ba, 0x0275 /* BrtEndComments */);
	return ba.end();
}
var CT_VBA = "application/vnd.ms-office.vbaProject";
function make_vba_xls(cfb) {
  var newcfb = CFB.utils.cfb_new({ root: "R" });
  cfb.FullPaths.forEach(function(p, i) {
    if (p.slice(-1) === "/" || !p.match(/_VBA_PROJECT_CUR/))
      return;
    var newpath = p.replace(/^[^\/]*/, "R").replace(/\/_VBA_PROJECT_CUR\u0000*/, "");
    CFB.utils.cfb_add(newcfb, newpath, cfb.FileIndex[i].content);
  });
  return CFB.write(newcfb);
}
function fill_vba_xls(cfb, vba) {
  vba.FullPaths.forEach(function(p, i) {
    if (i == 0)
      return;
    var newpath = p.replace(/[^\/]*[\/]/, "/_VBA_PROJECT_CUR/");
    if (newpath.slice(-1) !== "/")
      CFB.utils.cfb_add(cfb, newpath, vba.FileIndex[i].content);
  });
}
var VBAFMTS = ["xlsb", "xlsm", "xlam", "biff8", "xla"];
/* macro and dialog sheet stubs */
function parse_ds_bin() { return {'!type':'dialog'}; }
function parse_ds_xml() { return {'!type':'dialog'}; }
function parse_ms_bin() { return {'!type':'macro'}; }
function parse_ms_xml() { return {'!type':'macro'}; }
/* TODO: it will be useful to parse the function str */
var rc_to_a1 = (function(){
	var rcregex = /(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g;
	var rcbase = ({r:0,c:0});
	function rcfunc($$,$1,$2,$3) {
		var cRel = false, rRel = false;

		if($2.length == 0) rRel = true;
		else if($2.charAt(0) == "[") { rRel = true; $2 = $2.slice(1, -1); }

		if($3.length == 0) cRel = true;
		else if($3.charAt(0) == "[") { cRel = true; $3 = $3.slice(1, -1); }

		var R = $2.length>0?parseInt($2,10)|0:0, C = $3.length>0?parseInt($3,10)|0:0;

		if(cRel) C += rcbase.c; else --C;
		if(rRel) R += rcbase.r; else --R;
		return $1 + (cRel ? "" : "$") + encode_col(C) + (rRel ? "" : "$") + encode_row(R);
	}
	return function rc_to_a1(fstr, base) {
		rcbase = base;
		return fstr.replace(rcregex, rcfunc);
	};
})();

var crefregex = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g;
var a1_to_rc = (function(){
	return function a1_to_rc(fstr, base) {
		return fstr.replace(crefregex, function($0, $1, $2, $3, $4, $5) {
			var c = decode_col($3) - ($2 ? 0 : base.c);
			var r = decode_row($5) - ($4 ? 0 : base.r);
			var R = $4 == "$" ? (r+1) : (r == 0 ? "" : "[" + r + "]");
			var C = $2 == "$" ? (c+1) : (c == 0 ? "" : "[" + c + "]");
			return $1 + "R" + R + "C" + C;
		});
	};
})();

/* no defined name can collide with a valid cell address A1:XFD1048576 ... except LOG10! */
function shift_formula_str(f, delta) {
	return f.replace(crefregex, function($0, $1, $2, $3, $4, $5) {
		return $1+($2=="$" ? $2+$3 : encode_col(decode_col($3)+delta.c))+($4=="$" ? $4+$5 : encode_row(decode_row($5) + delta.r));
	});
}

function shift_formula_xlsx(f, range, cell) {
	var r = decode_range(range), s = r.s, c = decode_cell(cell);
	var delta = {r:c.r - s.r, c:c.c - s.c};
	return shift_formula_str(f, delta);
}

/* TODO: parse formula */
function fuzzyfmla(f) {
	if(f.length == 1) return false;
	return true;
}

function _xlfn(f) {
	return f.replace(/_xlfn\./g,"");
}
function parseread1(blob) { blob.l+=1; return; }

/* [MS-XLS] 2.5.51 */
function parse_ColRelU(blob, length) {
	var c = blob.read_shift(length == 1 ? 1 : 2);
	return [c & 0x3FFF, (c >> 14) & 1, (c >> 15) & 1];
}

/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.89 */
function parse_RgceArea(blob, length, opts) {
	var w = 2;
	if(opts) {
		if(opts.biff >= 2 && opts.biff <= 5) return parse_RgceArea_BIFF2(blob, length, opts);
		else if(opts.biff == 12) w = 4;
	}
	var r=blob.read_shift(w), R=blob.read_shift(w);
	var c=parse_ColRelU(blob, 2);
	var C=parse_ColRelU(blob, 2);
	return { s:{r:r, c:c[0], cRel:c[1], rRel:c[2]}, e:{r:R, c:C[0], cRel:C[1], rRel:C[2]} };
}
/* BIFF 2-5 encodes flags in the row field */
function parse_RgceArea_BIFF2(blob) {
	var r=parse_ColRelU(blob, 2), R=parse_ColRelU(blob, 2);
	var c=blob.read_shift(1);
	var C=blob.read_shift(1);
	return { s:{r:r[0], c:c, cRel:r[1], rRel:r[2]}, e:{r:R[0], c:C, cRel:R[1], rRel:R[2]} };
}

/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.90 */
function parse_RgceAreaRel(blob, length, opts) {
	if(opts.biff < 8) return parse_RgceArea_BIFF2(blob, length, opts);
	var r=blob.read_shift(opts.biff == 12 ? 4 : 2), R=blob.read_shift(opts.biff == 12 ? 4 : 2);
	var c=parse_ColRelU(blob, 2);
	var C=parse_ColRelU(blob, 2);
	return { s:{r:r, c:c[0], cRel:c[1], rRel:c[2]}, e:{r:R, c:C[0], cRel:C[1], rRel:C[2]} };
}

/* [MS-XLS] 2.5.198.109 ; [MS-XLSB] 2.5.97.91 */
function parse_RgceLoc(blob, length, opts) {
	if(opts && opts.biff >= 2 && opts.biff <= 5) return parse_RgceLoc_BIFF2(blob, length, opts);
	var r = blob.read_shift(opts && opts.biff == 12 ? 4 : 2);
	var c = parse_ColRelU(blob, 2);
	return {r:r, c:c[0], cRel:c[1], rRel:c[2]};
}
function parse_RgceLoc_BIFF2(blob) {
	var r = parse_ColRelU(blob, 2);
	var c = blob.read_shift(1);
	return {r:r[0], c:c, cRel:r[1], rRel:r[2]};
}

/* [MS-XLS] 2.5.198.107, 2.5.47 */
function parse_RgceElfLoc(blob) {
	var r = blob.read_shift(2);
	var c = blob.read_shift(2);
	return {r:r, c:c & 0xFF, fQuoted:!!(c & 0x4000), cRel:c>>15, rRel:c>>15 };
}

/* [MS-XLS] 2.5.198.111 ; [MS-XLSB] 2.5.97.92 TODO */
function parse_RgceLocRel(blob, length, opts) {
	var biff = opts && opts.biff ? opts.biff : 8;
	if(biff >= 2 && biff <= 5) return parse_RgceLocRel_BIFF2(blob, length, opts);
	var r = blob.read_shift(biff >= 12 ? 4 : 2);
	var cl = blob.read_shift(2);
	var cRel = (cl & 0x4000) >> 14, rRel = (cl & 0x8000) >> 15;
	cl &= 0x3FFF;
	if(rRel == 1) while(r > 0x7FFFF) r -= 0x100000;
	if(cRel == 1) while(cl > 0x1FFF) cl = cl - 0x4000;
	return {r:r,c:cl,cRel:cRel,rRel:rRel};
}
function parse_RgceLocRel_BIFF2(blob) {
	var rl = blob.read_shift(2);
	var c = blob.read_shift(1);
	var rRel = (rl & 0x8000) >> 15, cRel = (rl & 0x4000) >> 14;
	rl &= 0x3FFF;
	if(rRel == 1 && rl >= 0x2000) rl = rl - 0x4000;
	if(cRel == 1 && c >= 0x80) c = c - 0x100;
	return {r:rl,c:c,cRel:cRel,rRel:rRel};
}

/* [MS-XLS] 2.5.198.27 ; [MS-XLSB] 2.5.97.18 */
function parse_PtgArea(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	var area = parse_RgceArea(blob, opts.biff >= 2 && opts.biff <= 5 ? 6 : 8, opts);
	return [type, area];
}

/* [MS-XLS] 2.5.198.28 ; [MS-XLSB] 2.5.97.19 */
function parse_PtgArea3d(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	var ixti = blob.read_shift(2, 'i');
	var w = 8;
	if(opts) switch(opts.biff) {
		case 5: blob.l += 12; w = 6; break;
		case 12: w = 12; break;
	}
	var area = parse_RgceArea(blob, w, opts);
	return [type, ixti, area];
}

/* [MS-XLS] 2.5.198.29 ; [MS-XLSB] 2.5.97.20 */
function parse_PtgAreaErr(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	blob.l += opts && (opts.biff > 8) ? 12 : (opts.biff < 8 ? 6 : 8);
	return [type];
}
/* [MS-XLS] 2.5.198.30 ; [MS-XLSB] 2.5.97.21 */
function parse_PtgAreaErr3d(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	var ixti = blob.read_shift(2);
	var w = 8;
	if(opts) switch(opts.biff) {
		case 5: blob.l += 12; w = 6; break;
		case 12: w = 12; break;
	}
	blob.l += w;
	return [type, ixti];
}

/* [MS-XLS] 2.5.198.31 ; [MS-XLSB] 2.5.97.22 */
function parse_PtgAreaN(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	var area = parse_RgceAreaRel(blob, length - 1, opts);
	return [type, area];
}

/* [MS-XLS] 2.5.198.32 ; [MS-XLSB] 2.5.97.23 */
function parse_PtgArray(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	blob.l += opts.biff == 2 ? 6 : opts.biff == 12 ? 14 : 7;
	return [type];
}

/* [MS-XLS] 2.5.198.33 ; [MS-XLSB] 2.5.97.24 */
function parse_PtgAttrBaxcel(blob) {
	var bitSemi = blob[blob.l+1] & 0x01; /* 1 = volatile */
	var bitBaxcel = 1;
	blob.l += 4;
	return [bitSemi, bitBaxcel];
}

/* [MS-XLS] 2.5.198.34 ; [MS-XLSB] 2.5.97.25 */
function parse_PtgAttrChoose(blob, length, opts) {
	blob.l +=2;
	var offset = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	var o = [];
	/* offset is 1 less than the number of elements */
	for(var i = 0; i <= offset; ++i) o.push(blob.read_shift(opts && opts.biff == 2 ? 1 : 2));
	return o;
}

/* [MS-XLS] 2.5.198.35 ; [MS-XLSB] 2.5.97.26 */
function parse_PtgAttrGoto(blob, length, opts) {
	var bitGoto = (blob[blob.l+1] & 0xFF) ? 1 : 0;
	blob.l += 2;
	return [bitGoto, blob.read_shift(opts && opts.biff == 2 ? 1 : 2)];
}

/* [MS-XLS] 2.5.198.36 ; [MS-XLSB] 2.5.97.27 */
function parse_PtgAttrIf(blob, length, opts) {
	var bitIf = (blob[blob.l+1] & 0xFF) ? 1 : 0;
	blob.l += 2;
	return [bitIf, blob.read_shift(opts && opts.biff == 2 ? 1 : 2)];
}

/* [MS-XLSB] 2.5.97.28 */
function parse_PtgAttrIfError(blob) {
	var bitIf = (blob[blob.l+1] & 0xFF) ? 1 : 0;
	blob.l += 2;
	return [bitIf, blob.read_shift(2)];
}

/* [MS-XLS] 2.5.198.37 ; [MS-XLSB] 2.5.97.29 */
function parse_PtgAttrSemi(blob, length, opts) {
	var bitSemi = (blob[blob.l+1] & 0xFF) ? 1 : 0;
	blob.l += opts && opts.biff == 2 ? 3 : 4;
	return [bitSemi];
}

/* [MS-XLS] 2.5.198.40 ; [MS-XLSB] 2.5.97.32 */
function parse_PtgAttrSpaceType(blob) {
	var type = blob.read_shift(1), cch = blob.read_shift(1);
	return [type, cch];
}

/* [MS-XLS] 2.5.198.38 ; [MS-XLSB] 2.5.97.30 */
function parse_PtgAttrSpace(blob) {
	blob.read_shift(2);
	return parse_PtgAttrSpaceType(blob, 2);
}

/* [MS-XLS] 2.5.198.39 ; [MS-XLSB] 2.5.97.31 */
function parse_PtgAttrSpaceSemi(blob) {
	blob.read_shift(2);
	return parse_PtgAttrSpaceType(blob, 2);
}

/* [MS-XLS] 2.5.198.84 ; [MS-XLSB] 2.5.97.68 TODO */
function parse_PtgRef(blob, length, opts) {
	//var ptg = blob[blob.l] & 0x1F;
	var type = (blob[blob.l] & 0x60)>>5;
	blob.l += 1;
	var loc = parse_RgceLoc(blob, 0, opts);
	return [type, loc];
}

/* [MS-XLS] 2.5.198.88 ; [MS-XLSB] 2.5.97.72 TODO */
function parse_PtgRefN(blob, length, opts) {
	var type = (blob[blob.l] & 0x60)>>5;
	blob.l += 1;
	var loc = parse_RgceLocRel(blob, 0, opts);
	return [type, loc];
}

/* [MS-XLS] 2.5.198.85 ; [MS-XLSB] 2.5.97.69 TODO */
function parse_PtgRef3d(blob, length, opts) {
	var type = (blob[blob.l] & 0x60)>>5;
	blob.l += 1;
	var ixti = blob.read_shift(2); // XtiIndex
	if(opts && opts.biff == 5) blob.l += 12;
	var loc = parse_RgceLoc(blob, 0, opts); // TODO: or RgceLocRel
	return [type, ixti, loc];
}


/* [MS-XLS] 2.5.198.62 ; [MS-XLSB] 2.5.97.45 TODO */
function parse_PtgFunc(blob, length, opts) {
	//var ptg = blob[blob.l] & 0x1F;
	var type = (blob[blob.l] & 0x60)>>5;
	blob.l += 1;
	var iftab = blob.read_shift(opts && opts.biff <= 3 ? 1 : 2);
	return [FtabArgc[iftab], Ftab[iftab], type];
}
/* [MS-XLS] 2.5.198.63 ; [MS-XLSB] 2.5.97.46 TODO */
function parse_PtgFuncVar(blob, length, opts) {
	var type = blob[blob.l++];
	var cparams = blob.read_shift(1), tab = opts && opts.biff <= 3 ? [(type == 0x58 ? -1 : 0), blob.read_shift(1)]: parsetab(blob);
	return [cparams, (tab[0] === 0 ? Ftab : Cetab)[tab[1]]];
}

function parsetab(blob) {
	return [blob[blob.l+1]>>7, blob.read_shift(2) & 0x7FFF];
}

/* [MS-XLS] 2.5.198.41 ; [MS-XLSB] 2.5.97.33 */
function parse_PtgAttrSum(blob, length, opts) {
	blob.l += opts && opts.biff == 2 ? 3 : 4; return;
}

/* [MS-XLS] 2.5.198.58 ; [MS-XLSB] 2.5.97.40 */
function parse_PtgExp(blob, length, opts) {
	blob.l++;
	if(opts && opts.biff == 12) return [blob.read_shift(4, 'i'), 0];
	var row = blob.read_shift(2);
	var col = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	return [row, col];
}

/* [MS-XLS] 2.5.198.57 ; [MS-XLSB] 2.5.97.39 */
function parse_PtgErr(blob) { blob.l++; return BErr[blob.read_shift(1)]; }

/* [MS-XLS] 2.5.198.66 ; [MS-XLSB] 2.5.97.49 */
function parse_PtgInt(blob) { blob.l++; return blob.read_shift(2); }

/* [MS-XLS] 2.5.198.42 ; [MS-XLSB] 2.5.97.34 */
function parse_PtgBool(blob) { blob.l++; return blob.read_shift(1)!==0;}

/* [MS-XLS] 2.5.198.79 ; [MS-XLSB] 2.5.97.63 */
function parse_PtgNum(blob) { blob.l++; return parse_Xnum(blob, 8); }

/* [MS-XLS] 2.5.198.89 ; [MS-XLSB] 2.5.97.74 */
function parse_PtgStr(blob, length, opts) { blob.l++; return parse_ShortXLUnicodeString(blob, length-1, opts); }

/* [MS-XLS] 2.5.192.112 + 2.5.192.11{3,4,5,6,7} */
/* [MS-XLSB] 2.5.97.93 + 2.5.97.9{4,5,6,7} */
function parse_SerAr(blob, biff) {
	var val = [blob.read_shift(1)];
	if(biff == 12) switch(val[0]) {
		case 0x02: val[0] = 0x04; break; /* SerBool */
		case 0x04: val[0] = 0x10; break; /* SerErr */
		case 0x00: val[0] = 0x01; break; /* SerNum */
		case 0x01: val[0] = 0x02; break; /* SerStr */
	}
	switch(val[0]) {
		case 0x04: /* SerBool -- boolean */
			val[1] = parsebool(blob, 1) ? 'TRUE' : 'FALSE';
			if(biff != 12) blob.l += 7; break;
		case 0x25: /* appears to be an alias */
		case 0x10: /* SerErr -- error */
			val[1] = BErr[blob[blob.l]];
			blob.l += ((biff == 12) ? 4 : 8); break;
		case 0x00: /* SerNil -- honestly, I'm not sure how to reproduce this */
			blob.l += 8; break;
		case 0x01: /* SerNum -- Xnum */
			val[1] = parse_Xnum(blob, 8); break;
		case 0x02: /* SerStr -- XLUnicodeString (<256 chars) */
			val[1] = parse_XLUnicodeString2(blob, 0, {biff:biff > 0 && biff < 8 ? 2 : biff}); break;
		default: throw new Error("Bad SerAr: " + val[0]); /* Unreachable */
	}
	return val;
}

/* [MS-XLS] 2.5.198.61 ; [MS-XLSB] 2.5.97.44 */
function parse_PtgExtraMem(blob, cce, opts) {
	var count = blob.read_shift((opts.biff == 12) ? 4 : 2);
	var out = [];
	for(var i = 0; i != count; ++i) out.push(((opts.biff == 12) ? parse_UncheckedRfX : parse_Ref8U)(blob, 8));
	return out;
}

/* [MS-XLS] 2.5.198.59 ; [MS-XLSB] 2.5.97.41 */
function parse_PtgExtraArray(blob, length, opts) {
	var rows = 0, cols = 0;
	if(opts.biff == 12) {
		rows = blob.read_shift(4); // DRw
		cols = blob.read_shift(4); // DCol
	} else {
		cols = 1 + blob.read_shift(1); //DColByteU
		rows = 1 + blob.read_shift(2); //DRw
	}
	if(opts.biff >= 2 && opts.biff < 8) { --rows; if(--cols == 0) cols = 0x100; }
	// $FlowIgnore
	for(var i = 0, o = []; i != rows && (o[i] = []); ++i)
		for(var j = 0; j != cols; ++j) o[i][j] = parse_SerAr(blob, opts.biff);
	return o;
}

/* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 */
function parse_PtgName(blob, length, opts) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var w = (!opts || (opts.biff >= 8)) ? 4 : 2;
	var nameindex = blob.read_shift(w);
	switch(opts.biff) {
		case 2: blob.l += 5; break;
		case 3: case 4: blob.l += 8; break;
		case 5: blob.l += 12; break;
	}
	return [type, 0, nameindex];
}

/* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 */
function parse_PtgNameX(blob, length, opts) {
	if(opts.biff == 5) return parse_PtgNameX_BIFF5(blob, length, opts);
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var ixti = blob.read_shift(2); // XtiIndex
	var nameindex = blob.read_shift(4);
	return [type, ixti, nameindex];
}
function parse_PtgNameX_BIFF5(blob) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var ixti = blob.read_shift(2, 'i'); // XtiIndex
	blob.l += 8;
	var nameindex = blob.read_shift(2);
	blob.l += 12;
	return [type, ixti, nameindex];
}

/* [MS-XLS] 2.5.198.70 ; [MS-XLSB] 2.5.97.54 */
function parse_PtgMemArea(blob, length, opts) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	blob.l += (opts && opts.biff == 2 ? 3 : 4);
	var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	return [type, cce];
}

/* [MS-XLS] 2.5.198.72 ; [MS-XLSB] 2.5.97.56 */
function parse_PtgMemFunc(blob, length, opts) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	return [type, cce];
}


/* [MS-XLS] 2.5.198.86 ; [MS-XLSB] 2.5.97.69 */
function parse_PtgRefErr(blob, length, opts) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	blob.l += 4;
	if(opts.biff < 8) blob.l--;
	if(opts.biff == 12) blob.l += 2;
	return [type];
}

/* [MS-XLS] 2.5.198.87 ; [MS-XLSB] 2.5.97.71 */
function parse_PtgRefErr3d(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	var ixti = blob.read_shift(2);
	var w = 4;
	if(opts) switch(opts.biff) {
		case 5: w = 15; break;
		case 12: w = 6; break;
	}
	blob.l += w;
	return [type, ixti];
}

/* [MS-XLS] 2.5.198.71 ; [MS-XLSB] 2.5.97.55 */
var parse_PtgMemErr = parsenoop;
/* [MS-XLS] 2.5.198.73  ; [MS-XLSB] 2.5.97.57 */
var parse_PtgMemNoMem = parsenoop;
/* [MS-XLS] 2.5.198.92 */
var parse_PtgTbl = parsenoop;

function parse_PtgElfLoc(blob, length, opts) {
	blob.l += 2;
	return [parse_RgceElfLoc(blob, 4, opts)];
}
function parse_PtgElfNoop(blob) {
	blob.l += 6;
	return [];
}
/* [MS-XLS] 2.5.198.46 */
var parse_PtgElfCol = parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.47 */
var parse_PtgElfColS = parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.48 */
var parse_PtgElfColSV = parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.49 */
var parse_PtgElfColV = parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.50 */
function parse_PtgElfLel(blob) {
	blob.l += 2;
	return [parseuint16(blob), blob.read_shift(2) & 0x01];
}
/* [MS-XLS] 2.5.198.51 */
var parse_PtgElfRadical = parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.52 */
var parse_PtgElfRadicalLel = parse_PtgElfLel;
/* [MS-XLS] 2.5.198.53 */
var parse_PtgElfRadicalS = parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.54 */
var parse_PtgElfRw = parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.55 */
var parse_PtgElfRwV = parse_PtgElfLoc;

/* [MS-XLSB] 2.5.97.52 TODO */
var PtgListRT = [
	"Data",
	"All",
	"Headers",
	"??",
	"?Data2",
	"??",
	"?DataHeaders",
	"??",
	"Totals",
	"??",
	"??",
	"??",
	"?DataTotals",
	"??",
	"??",
	"??",
	"?Current"
];
function parse_PtgList(blob) {
	blob.l += 2;
	var ixti = blob.read_shift(2);
	var flags = blob.read_shift(2);
	var idx = blob.read_shift(4);
	var c = blob.read_shift(2);
	var C = blob.read_shift(2);
	var rt = PtgListRT[(flags >> 2) & 0x1F];
	return {ixti: ixti, coltype:(flags&0x3), rt:rt, idx:idx, c:c, C:C};
}
/* [MS-XLS] 2.5.198.91 ; [MS-XLSB] 2.5.97.76 */
function parse_PtgSxName(blob) {
	blob.l += 2;
	return [blob.read_shift(4)];
}

/* [XLS] old spec */
function parse_PtgSheet(blob, length, opts) {
	blob.l += 5;
	blob.l += 2;
	blob.l += (opts.biff == 2 ? 1 : 4);
	return ["PTGSHEET"];
}
function parse_PtgEndSheet(blob, length, opts) {
	blob.l += (opts.biff == 2 ? 4 : 5);
	return ["PTGENDSHEET"];
}
function parse_PtgMemAreaN(blob) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var cce = blob.read_shift(2);
	return [type, cce];
}
function parse_PtgMemNoMemN(blob) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var cce = blob.read_shift(2);
	return [type, cce];
}
function parse_PtgAttrNoop(blob) {
	blob.l += 4;
	return [0, 0];
}

/* [MS-XLS] 2.5.198.25 ; [MS-XLSB] 2.5.97.16 */
var PtgTypes = {
0x01: { n:'PtgExp', f:parse_PtgExp },
0x02: { n:'PtgTbl', f:parse_PtgTbl },
0x03: { n:'PtgAdd', f:parseread1 },
0x04: { n:'PtgSub', f:parseread1 },
0x05: { n:'PtgMul', f:parseread1 },
0x06: { n:'PtgDiv', f:parseread1 },
0x07: { n:'PtgPower', f:parseread1 },
0x08: { n:'PtgConcat', f:parseread1 },
0x09: { n:'PtgLt', f:parseread1 },
0x0A: { n:'PtgLe', f:parseread1 },
0x0B: { n:'PtgEq', f:parseread1 },
0x0C: { n:'PtgGe', f:parseread1 },
0x0D: { n:'PtgGt', f:parseread1 },
0x0E: { n:'PtgNe', f:parseread1 },
0x0F: { n:'PtgIsect', f:parseread1 },
0x10: { n:'PtgUnion', f:parseread1 },
0x11: { n:'PtgRange', f:parseread1 },
0x12: { n:'PtgUplus', f:parseread1 },
0x13: { n:'PtgUminus', f:parseread1 },
0x14: { n:'PtgPercent', f:parseread1 },
0x15: { n:'PtgParen', f:parseread1 },
0x16: { n:'PtgMissArg', f:parseread1 },
0x17: { n:'PtgStr', f:parse_PtgStr },
0x1A: { n:'PtgSheet', f:parse_PtgSheet },
0x1B: { n:'PtgEndSheet', f:parse_PtgEndSheet },
0x1C: { n:'PtgErr', f:parse_PtgErr },
0x1D: { n:'PtgBool', f:parse_PtgBool },
0x1E: { n:'PtgInt', f:parse_PtgInt },
0x1F: { n:'PtgNum', f:parse_PtgNum },
0x20: { n:'PtgArray', f:parse_PtgArray },
0x21: { n:'PtgFunc', f:parse_PtgFunc },
0x22: { n:'PtgFuncVar', f:parse_PtgFuncVar },
0x23: { n:'PtgName', f:parse_PtgName },
0x24: { n:'PtgRef', f:parse_PtgRef },
0x25: { n:'PtgArea', f:parse_PtgArea },
0x26: { n:'PtgMemArea', f:parse_PtgMemArea },
0x27: { n:'PtgMemErr', f:parse_PtgMemErr },
0x28: { n:'PtgMemNoMem', f:parse_PtgMemNoMem },
0x29: { n:'PtgMemFunc', f:parse_PtgMemFunc },
0x2A: { n:'PtgRefErr', f:parse_PtgRefErr },
0x2B: { n:'PtgAreaErr', f:parse_PtgAreaErr },
0x2C: { n:'PtgRefN', f:parse_PtgRefN },
0x2D: { n:'PtgAreaN', f:parse_PtgAreaN },
0x2E: { n:'PtgMemAreaN', f:parse_PtgMemAreaN },
0x2F: { n:'PtgMemNoMemN', f:parse_PtgMemNoMemN },
0x39: { n:'PtgNameX', f:parse_PtgNameX },
0x3A: { n:'PtgRef3d', f:parse_PtgRef3d },
0x3B: { n:'PtgArea3d', f:parse_PtgArea3d },
0x3C: { n:'PtgRefErr3d', f:parse_PtgRefErr3d },
0x3D: { n:'PtgAreaErr3d', f:parse_PtgAreaErr3d },
0xFF: {}
};
/* These are duplicated in the PtgTypes table */
var PtgDupes = {
0x40: 0x20, 0x60: 0x20,
0x41: 0x21, 0x61: 0x21,
0x42: 0x22, 0x62: 0x22,
0x43: 0x23, 0x63: 0x23,
0x44: 0x24, 0x64: 0x24,
0x45: 0x25, 0x65: 0x25,
0x46: 0x26, 0x66: 0x26,
0x47: 0x27, 0x67: 0x27,
0x48: 0x28, 0x68: 0x28,
0x49: 0x29, 0x69: 0x29,
0x4A: 0x2A, 0x6A: 0x2A,
0x4B: 0x2B, 0x6B: 0x2B,
0x4C: 0x2C, 0x6C: 0x2C,
0x4D: 0x2D, 0x6D: 0x2D,
0x4E: 0x2E, 0x6E: 0x2E,
0x4F: 0x2F, 0x6F: 0x2F,
0x58: 0x22, 0x78: 0x22,
0x59: 0x39, 0x79: 0x39,
0x5A: 0x3A, 0x7A: 0x3A,
0x5B: 0x3B, 0x7B: 0x3B,
0x5C: 0x3C, 0x7C: 0x3C,
0x5D: 0x3D, 0x7D: 0x3D
};

var Ptg18 = {
0x01: { n:'PtgElfLel', f:parse_PtgElfLel },
0x02: { n:'PtgElfRw', f:parse_PtgElfRw },
0x03: { n:'PtgElfCol', f:parse_PtgElfCol },
0x06: { n:'PtgElfRwV', f:parse_PtgElfRwV },
0x07: { n:'PtgElfColV', f:parse_PtgElfColV },
0x0A: { n:'PtgElfRadical', f:parse_PtgElfRadical },
0x0B: { n:'PtgElfRadicalS', f:parse_PtgElfRadicalS },
0x0D: { n:'PtgElfColS', f:parse_PtgElfColS },
0x0F: { n:'PtgElfColSV', f:parse_PtgElfColSV },
0x10: { n:'PtgElfRadicalLel', f:parse_PtgElfRadicalLel },
0x19: { n:'PtgList', f:parse_PtgList },
0x1D: { n:'PtgSxName', f:parse_PtgSxName },
0xFF: {}
};
var Ptg19 = {
0x00: { n:'PtgAttrNoop', f:parse_PtgAttrNoop },
0x01: { n:'PtgAttrSemi', f:parse_PtgAttrSemi },
0x02: { n:'PtgAttrIf', f:parse_PtgAttrIf },
0x04: { n:'PtgAttrChoose', f:parse_PtgAttrChoose },
0x08: { n:'PtgAttrGoto', f:parse_PtgAttrGoto },
0x10: { n:'PtgAttrSum', f:parse_PtgAttrSum },
0x20: { n:'PtgAttrBaxcel', f:parse_PtgAttrBaxcel },
0x21: { n:'PtgAttrBaxcel', f:parse_PtgAttrBaxcel },
0x40: { n:'PtgAttrSpace', f:parse_PtgAttrSpace },
0x41: { n:'PtgAttrSpaceSemi', f:parse_PtgAttrSpaceSemi },
0x80: { n:'PtgAttrIfError', f:parse_PtgAttrIfError },
0xFF: {}
};

/* [MS-XLS] 2.5.198.103 ; [MS-XLSB] 2.5.97.87 */
function parse_RgbExtra(blob, length, rgce, opts) {
	if(opts.biff < 8) return parsenoop(blob, length);
	var target = blob.l + length;
	var o = [];
	for(var i = 0; i !== rgce.length; ++i) {
		switch(rgce[i][0]) {
			case 'PtgArray': /* PtgArray -> PtgExtraArray */
				rgce[i][1] = parse_PtgExtraArray(blob, 0, opts);
				o.push(rgce[i][1]);
				break;
			case 'PtgMemArea': /* PtgMemArea -> PtgExtraMem */
				rgce[i][2] = parse_PtgExtraMem(blob, rgce[i][1], opts);
				o.push(rgce[i][2]);
				break;
			case 'PtgExp': /* PtgExp -> PtgExtraCol */
				if(opts && opts.biff == 12) {
					rgce[i][1][1] = blob.read_shift(4);
					o.push(rgce[i][1]);
				} break;
			case 'PtgList': /* TODO: PtgList -> PtgExtraList */
			case 'PtgElfRadicalS': /* TODO: PtgElfRadicalS -> PtgExtraElf */
			case 'PtgElfColS': /* TODO: PtgElfColS -> PtgExtraElf */
			case 'PtgElfColSV': /* TODO: PtgElfColSV -> PtgExtraElf */
				throw "Unsupported " + rgce[i][0];
			default: break;
		}
	}
	length = target - blob.l;
	/* note: this is technically an error but Excel disregards */
	//if(target !== blob.l && blob.l !== target - length) throw new Error(target + " != " + blob.l);
	if(length !== 0) o.push(parsenoop(blob, length));
	return o;
}

/* [MS-XLS] 2.5.198.104 ; [MS-XLSB] 2.5.97.88 */
function parse_Rgce(blob, length, opts) {
	var target = blob.l + length;
	var R, id, ptgs = [];
	while(target != blob.l) {
		length = target - blob.l;
		id = blob[blob.l];
		R = PtgTypes[id] || PtgTypes[PtgDupes[id]];
		if(id === 0x18 || id === 0x19) R = (id === 0x18 ? Ptg18 : Ptg19)[blob[blob.l + 1]];
		if(!R || !R.f) { /*ptgs.push*/(parsenoop(blob, length)); }
		else { ptgs.push([R.n, R.f(blob, length, opts)]); }
	}
	return ptgs;
}

function stringify_array(f) {
	var o = [];
	for(var i = 0; i < f.length; ++i) {
		var x = f[i], r = [];
		for(var j = 0; j < x.length; ++j) {
			var y = x[j];
			if(y) switch(y[0]) {
				// TODO: handle embedded quotes
				case 0x02:
r.push('"' + y[1].replace(/"/g,'""') + '"'); break;
				default: r.push(y[1]);
			} else r.push("");
		}
		o.push(r.join(","));
	}
	return o.join(";");
}

/* [MS-XLS] 2.2.2 ; [MS-XLSB] 2.2.2 TODO */
var PtgBinOp = {
	PtgAdd: "+",
	PtgConcat: "&",
	PtgDiv: "/",
	PtgEq: "=",
	PtgGe: ">=",
	PtgGt: ">",
	PtgLe: "<=",
	PtgLt: "<",
	PtgMul: "*",
	PtgNe: "<>",
	PtgPower: "^",
	PtgSub: "-"
};

// TODO: explore space
function make_3d_range(start, end) {
	var s = start.lastIndexOf("!"), e = end.lastIndexOf("!");
	if(s == -1 && e == -1) return start + ":" + end;
	if(s > 0 && e > 0 && start.slice(0, s).toLowerCase() == end.slice(0, e).toLowerCase()) return start + ":" + end.slice(e+1);
	console.error("Cannot hydrate range", start, end);
	return start + ":" + end;
}

function get_ixti_raw(supbooks, ixti, opts) {
	if(!supbooks) return "SH33TJSERR0";
	if(opts.biff > 8 && (!supbooks.XTI || !supbooks.XTI[ixti])) return supbooks.SheetNames[ixti];
	if(!supbooks.XTI) return "SH33TJSERR6";
	var XTI = supbooks.XTI[ixti];
	if(opts.biff < 8) {
		if(ixti > 10000) ixti-= 65536;
		if(ixti < 0) ixti = -ixti;
		return ixti == 0 ? "" : supbooks.XTI[ixti - 1];
	}
	if(!XTI) return "SH33TJSERR1";
	var o = "";
	if(opts.biff > 8) switch(supbooks[XTI[0]][0]) {
		case 0x0165: /* 'BrtSupSelf' */
			o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]];
			return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
		case 0x0166: /* 'BrtSupSame' */
			if(opts.SID != null) return supbooks.SheetNames[opts.SID];
			return "SH33TJSSAME" + supbooks[XTI[0]][0];
		case 0x0163: /* 'BrtSupBookSrc' */
			/* falls through */
		default: return "SH33TJSSRC" + supbooks[XTI[0]][0];
	}
	switch(supbooks[XTI[0]][0][0]) {
		case 0x0401:
			o = XTI[1] == -1 ? "#REF" : (supbooks.SheetNames[XTI[1]] || "SH33TJSERR3");
			return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
		case 0x3A01: return supbooks[XTI[0]].slice(1).map(function(name) { return name.Name; }).join(";;"); //return "SH33TJSERR8";
		default:
			if(!supbooks[XTI[0]][0][3]) return "SH33TJSERR2";
			o = XTI[1] == -1 ? "#REF" : (supbooks[XTI[0]][0][3][XTI[1]] || "SH33TJSERR4");
			return XTI[1] == XTI[2] ? o : o + ":" + supbooks[XTI[0]][0][3][XTI[2]];
	}
}
function get_ixti(supbooks, ixti, opts) {
	var ixtiraw = get_ixti_raw(supbooks, ixti, opts);
	return ixtiraw == "#REF" ? ixtiraw : formula_quote_sheet_name(ixtiraw, opts);
}
function stringify_formula(formula/*Array<any>*/, range, cell, supbooks, opts) {
	var biff = (opts && opts.biff) || 8;
	var _range = /*range != null ? range :*/ {s:{c:0, r:0},e:{c:0, r:0}};
	var stack = [], e1, e2,  c, ixti=0, nameidx=0, r, sname="";
	if(!formula[0] || !formula[0][0]) return "";
	var last_sp = -1, sp = "";
	for(var ff = 0, fflen = formula[0].length; ff < fflen; ++ff) {
		var f = formula[0][ff];
		switch(f[0]) {
			case 'PtgUminus': /* [MS-XLS] 2.5.198.93 */
				stack.push("-" + stack.pop()); break;
			case 'PtgUplus': /* [MS-XLS] 2.5.198.95 */
				stack.push("+" + stack.pop()); break;
			case 'PtgPercent': /* [MS-XLS] 2.5.198.81 */
				stack.push(stack.pop() + "%"); break;

			case 'PtgAdd':    /* [MS-XLS] 2.5.198.26 */
			case 'PtgConcat': /* [MS-XLS] 2.5.198.43 */
			case 'PtgDiv':    /* [MS-XLS] 2.5.198.45 */
			case 'PtgEq':     /* [MS-XLS] 2.5.198.56 */
			case 'PtgGe':     /* [MS-XLS] 2.5.198.64 */
			case 'PtgGt':     /* [MS-XLS] 2.5.198.65 */
			case 'PtgLe':     /* [MS-XLS] 2.5.198.68 */
			case 'PtgLt':     /* [MS-XLS] 2.5.198.69 */
			case 'PtgMul':    /* [MS-XLS] 2.5.198.75 */
			case 'PtgNe':     /* [MS-XLS] 2.5.198.78 */
			case 'PtgPower':  /* [MS-XLS] 2.5.198.82 */
			case 'PtgSub':    /* [MS-XLS] 2.5.198.90 */
				e1 = stack.pop(); e2 = stack.pop();
				if(last_sp >= 0) {
					switch(formula[0][last_sp][1][0]) {
						case 0:
							// $FlowIgnore
							sp = fill(" ", formula[0][last_sp][1][1]); break;
						case 1:
							// $FlowIgnore
							sp = fill("\r", formula[0][last_sp][1][1]); break;
						default:
							sp = "";
							// $FlowIgnore
							if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
					}
					e2 = e2 + sp;
					last_sp = -1;
				}
				stack.push(e2+PtgBinOp[f[0]]+e1);
				break;

			case 'PtgIsect': /* [MS-XLS] 2.5.198.67 */
				e1 = stack.pop(); e2 = stack.pop();
				stack.push(e2+" "+e1);
				break;
			case 'PtgUnion': /* [MS-XLS] 2.5.198.94 */
				e1 = stack.pop(); e2 = stack.pop();
				stack.push(e2+","+e1);
				break;
			case 'PtgRange': /* [MS-XLS] 2.5.198.83 */
				e1 = stack.pop(); e2 = stack.pop();
				stack.push(make_3d_range(e2,e1));
				break;

			case 'PtgAttrChoose': /* [MS-XLS] 2.5.198.34 */
				break;
			case 'PtgAttrGoto': /* [MS-XLS] 2.5.198.35 */
				break;
			case 'PtgAttrIf': /* [MS-XLS] 2.5.198.36 */
				break;
			case 'PtgAttrIfError': /* [MS-XLSB] 2.5.97.28 */
				break;


			case 'PtgRef': /* [MS-XLS] 2.5.198.84 */
c = shift_cell_xls((f[1][1]), _range, opts);
				stack.push(encode_cell_xls(c, biff));
				break;
			case 'PtgRefN': /* [MS-XLS] 2.5.198.88 */
c = cell ? shift_cell_xls((f[1][1]), cell, opts) : (f[1][1]);
				stack.push(encode_cell_xls(c, biff));
				break;
			case 'PtgRef3d': /* [MS-XLS] 2.5.198.85 */
ixti = f[1][1]; c = shift_cell_xls((f[1][2]), _range, opts);
				sname = get_ixti(supbooks, ixti, opts);
				var w = sname; /* IE9 fails on defined names */ // eslint-disable-line no-unused-vars
				stack.push(sname + "!" + encode_cell_xls(c, biff));
				break;

			case 'PtgFunc': /* [MS-XLS] 2.5.198.62 */
			case 'PtgFuncVar': /* [MS-XLS] 2.5.198.63 */
				/* f[1] = [argc, func, type] */
				var argc = (f[1][0]), func = (f[1][1]);
				if(!argc) argc = 0;
				argc &= 0x7F;
				var args = argc == 0 ? [] : stack.slice(-argc);
				stack.length -= argc;
				if(func === 'User') func = args.shift();
				stack.push(func + "(" + args.join(",") + ")");
				break;

			case 'PtgBool': /* [MS-XLS] 2.5.198.42 */
				stack.push(f[1] ? "TRUE" : "FALSE"); break;
			case 'PtgInt': /* [MS-XLS] 2.5.198.66 */
				stack.push(f[1]); break;
			case 'PtgNum': /* [MS-XLS] 2.5.198.79 TODO: precision? */
				stack.push(String(f[1])); break;
			case 'PtgStr': /* [MS-XLS] 2.5.198.89 */
				// $FlowIgnore
				stack.push('"' + f[1].replace(/"/g, '""') + '"'); break;
			case 'PtgErr': /* [MS-XLS] 2.5.198.57 */
				stack.push(f[1]); break;
			case 'PtgAreaN': /* [MS-XLS] 2.5.198.31 TODO */
r = shift_range_xls(f[1][1], cell ? {s:cell} : _range, opts);
				stack.push(encode_range_xls((r), opts));
				break;
			case 'PtgArea': /* [MS-XLS] 2.5.198.27 TODO: fixed points */
r = shift_range_xls(f[1][1], _range, opts);
				stack.push(encode_range_xls((r), opts));
				break;
			case 'PtgArea3d': /* [MS-XLS] 2.5.198.28 TODO */
ixti = f[1][1]; r = f[1][2];
				sname = get_ixti(supbooks, ixti, opts);
				stack.push(sname + "!" + encode_range_xls((r), opts));
				break;
			case 'PtgAttrSum': /* [MS-XLS] 2.5.198.41 */
				stack.push("SUM(" + stack.pop() + ")");
				break;

			case 'PtgAttrBaxcel': /* [MS-XLS] 2.5.198.33 */
			case 'PtgAttrSemi': /* [MS-XLS] 2.5.198.37 */
				break;

			case 'PtgName': /* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 TODO: revisions */
				/* f[1] = type, 0, nameindex */
				nameidx = (f[1][2]);
				var lbl = (supbooks.names||[])[nameidx-1] || (supbooks[0]||[])[nameidx];
				var name = lbl ? lbl.Name : "SH33TJSNAME" + String(nameidx);
				/* [MS-XLSB] 2.5.97.10 Ftab -- last verified 20220204 */
				if(name && name.slice(0,6) == "_xlfn." && !opts.xlfn) name = name.slice(6);
				stack.push(name);
				break;

			case 'PtgNameX': /* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 TODO: revisions */
				/* f[1] = type, ixti, nameindex */
				var bookidx = (f[1][1]); nameidx = (f[1][2]); var externbook;
				/* TODO: Properly handle missing values -- this should be using get_ixti_raw primarily */
				if(opts.biff <= 5) {
					if(bookidx < 0) bookidx = -bookidx;
					if(supbooks[bookidx]) externbook = supbooks[bookidx][nameidx];
				} else {
					var o = "";
					if(((supbooks[bookidx]||[])[0]||[])[0] == 0x3A01){/* empty */}
					else if(((supbooks[bookidx]||[])[0]||[])[0] == 0x0401){
						if(supbooks[bookidx][nameidx] && supbooks[bookidx][nameidx].itab > 0) {
							o = supbooks.SheetNames[supbooks[bookidx][nameidx].itab-1] + "!";
						}
					}
					else o = supbooks.SheetNames[nameidx-1]+ "!";
					if(supbooks[bookidx] && supbooks[bookidx][nameidx]) o += supbooks[bookidx][nameidx].Name;
					else if(supbooks[0] && supbooks[0][nameidx]) o += supbooks[0][nameidx].Name;
					else {
						var ixtidata = (get_ixti_raw(supbooks, bookidx, opts)||"").split(";;");
						if(ixtidata[nameidx - 1]) o = ixtidata[nameidx - 1]; // TODO: confirm this is correct
						else o += "SH33TJSERRX";
					}
					stack.push(o);
					break;
				}
				if(!externbook) externbook = {Name: "SH33TJSERRY"};
				stack.push(externbook.Name);
				break;

			case 'PtgParen': /* [MS-XLS] 2.5.198.80 */
				var lp = '(', rp = ')';
				if(last_sp >= 0) {
					sp = "";
					switch(formula[0][last_sp][1][0]) {
						// $FlowIgnore
						case 2: lp = fill(" ", formula[0][last_sp][1][1]) + lp; break;
						// $FlowIgnore
						case 3: lp = fill("\r", formula[0][last_sp][1][1]) + lp; break;
						// $FlowIgnore
						case 4: rp = fill(" ", formula[0][last_sp][1][1]) + rp; break;
						// $FlowIgnore
						case 5: rp = fill("\r", formula[0][last_sp][1][1]) + rp; break;
						default:
							// $FlowIgnore
							if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
					}
					last_sp = -1;
				}
				stack.push(lp + stack.pop() + rp); break;

			case 'PtgRefErr': /* [MS-XLS] 2.5.198.86 */
				stack.push('#REF!'); break;

			case 'PtgRefErr3d': /* [MS-XLS] 2.5.198.87 */
				stack.push('#REF!'); break;

			case 'PtgExp': /* [MS-XLS] 2.5.198.58 TODO */
				c = {c:(f[1][1]),r:(f[1][0])};
				var q = ({c: cell.c, r:cell.r});
				if(supbooks.sharedf[encode_cell(c)]) {
					var parsedf = (supbooks.sharedf[encode_cell(c)]);
					stack.push(stringify_formula(parsedf, _range, q, supbooks, opts));
				} else {
					var fnd = false;
					for(e1=0;e1!=supbooks.arrayf.length; ++e1) {
						/* TODO: should be something like range_has */
						e2 = supbooks.arrayf[e1];
						if(c.c < e2[0].s.c || c.c > e2[0].e.c) continue;
						if(c.r < e2[0].s.r || c.r > e2[0].e.r) continue;
						stack.push(stringify_formula(e2[1], _range, q, supbooks, opts));
						fnd = true;
						break;
					}
					if(!fnd) stack.push(f[1]);
				}
				break;

			case 'PtgArray': /* [MS-XLS] 2.5.198.32 TODO */
				stack.push("{" + stringify_array(f[1]) + "}");
				break;

			case 'PtgMemArea': /* [MS-XLS] 2.5.198.70 TODO: confirm this is a non-display */
				//stack.push("(" + f[2].map(encode_range).join(",") + ")");
				break;

			case 'PtgAttrSpace': /* [MS-XLS] 2.5.198.38 */
			case 'PtgAttrSpaceSemi': /* [MS-XLS] 2.5.198.39 */
				last_sp = ff;
				break;

			case 'PtgTbl': /* [MS-XLS] 2.5.198.92 TODO */
				break;

			case 'PtgMemErr': /* [MS-XLS] 2.5.198.71 */
				break;

			case 'PtgMissArg': /* [MS-XLS] 2.5.198.74 */
				stack.push("");
				break;

			case 'PtgAreaErr': /* [MS-XLS] 2.5.198.29 */
				stack.push("#REF!"); break;

			case 'PtgAreaErr3d': /* [MS-XLS] 2.5.198.30 */
				stack.push("#REF!"); break;

			case 'PtgList': /* [MS-XLSB] 2.5.97.52 */
				// $FlowIgnore
				stack.push("Table" + f[1].idx + "[#" + f[1].rt + "]");
				break;

			case 'PtgMemAreaN':
			case 'PtgMemNoMemN':
			case 'PtgAttrNoop':
			case 'PtgSheet':
			case 'PtgEndSheet':
				break;

			case 'PtgMemFunc': /* [MS-XLS] 2.5.198.72 TODO */
				break;
			case 'PtgMemNoMem': /* [MS-XLS] 2.5.198.73 TODO */
				break;

			case 'PtgElfCol': /* [MS-XLS] 2.5.198.46 */
			case 'PtgElfColS': /* [MS-XLS] 2.5.198.47 */
			case 'PtgElfColSV': /* [MS-XLS] 2.5.198.48 */
			case 'PtgElfColV': /* [MS-XLS] 2.5.198.49 */
			case 'PtgElfLel': /* [MS-XLS] 2.5.198.50 */
			case 'PtgElfRadical': /* [MS-XLS] 2.5.198.51 */
			case 'PtgElfRadicalLel': /* [MS-XLS] 2.5.198.52 */
			case 'PtgElfRadicalS': /* [MS-XLS] 2.5.198.53 */
			case 'PtgElfRw': /* [MS-XLS] 2.5.198.54 */
			case 'PtgElfRwV': /* [MS-XLS] 2.5.198.55 */
				throw new Error("Unsupported ELFs");

			case 'PtgSxName': /* [MS-XLS] 2.5.198.91 TODO -- find a test case */
				throw new Error('Unrecognized Formula Token: ' + String(f));
			default: throw new Error('Unrecognized Formula Token: ' + String(f));
		}
		var PtgNonDisp = ['PtgAttrSpace', 'PtgAttrSpaceSemi', 'PtgAttrGoto'];
		if(opts.biff != 3) if(last_sp >= 0 && PtgNonDisp.indexOf(formula[0][ff][0]) == -1) {
			f = formula[0][last_sp];
			var _left = true;
			switch(f[1][0]) {
				/* note: some bad XLSB files omit the PtgParen */
				case 4: _left = false;
				/* falls through */
				case 0:
					// $FlowIgnore
					sp = fill(" ", f[1][1]); break;
				case 5: _left = false;
				/* falls through */
				case 1:
					// $FlowIgnore
					sp = fill("\r", f[1][1]); break;
				default:
					sp = "";
					// $FlowIgnore
					if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + f[1][0]);
			}
			stack.push((_left ? sp : "") + stack.pop() + (_left ? "" : sp));
			last_sp = -1;
		}
	}
	if(stack.length > 1 && opts.WTF) throw new Error("bad formula stack");
	if(stack[0] == "TRUE") return true; if(stack[0] == "FALSE") return false;
	return stack[0];
}

/* [MS-XLS] 2.5.198.1 TODO */
function parse_ArrayParsedFormula(blob, length, opts) {
	var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
	var rgcb, cce = blob.read_shift(len); // length of rgce
	if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
	var rgce = parse_Rgce(blob, cce, opts);
	if(length !== cce + len) rgcb = parse_RgbExtra(blob, length - cce - len, rgce, opts);
	blob.l = target;
	return [rgce, rgcb];
}

/* [MS-XLS] 2.5.198.3 TODO */
function parse_XLSCellParsedFormula(blob, length, opts) {
	var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
	var rgcb, cce = blob.read_shift(len); // length of rgce
	if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
	var rgce = parse_Rgce(blob, cce, opts);
	if(length !== cce + len) rgcb = parse_RgbExtra(blob, length - cce - len, rgce, opts);
	blob.l = target;
	return [rgce, rgcb];
}

/* [MS-XLS] 2.5.198.21 */
function parse_NameParsedFormula(blob, length, opts, cce) {
	var target = blob.l + length;
	var rgce = parse_Rgce(blob, cce, opts);
	var rgcb;
	if(target !== blob.l) rgcb = parse_RgbExtra(blob, target - blob.l, rgce, opts);
	return [rgce, rgcb];
}

/* [MS-XLS] 2.5.198.118 TODO */
function parse_SharedParsedFormula(blob, length, opts) {
	var target = blob.l + length;
	var rgcb, cce = blob.read_shift(2); // length of rgce
	var rgce = parse_Rgce(blob, cce, opts);
	if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
	if(length !== cce + 2) rgcb = parse_RgbExtra(blob, target - cce - 2, rgce, opts);
	return [rgce, rgcb];
}

/* [MS-XLS] 2.5.133 TODO: how to emit empty strings? */
function parse_FormulaValue(blob) {
	var b;
	if(__readUInt16LE(blob,blob.l + 6) !== 0xFFFF) return [parse_Xnum(blob),'n'];
	switch(blob[blob.l]) {
		case 0x00: blob.l += 8; return ["String", 's'];
		case 0x01: b = blob[blob.l+2] === 0x1; blob.l += 8; return [b,'b'];
		case 0x02: b = blob[blob.l+2]; blob.l += 8; return [b,'e'];
		case 0x03: blob.l += 8; return ["",'s'];
	}
	return [];
}
function write_FormulaValue(value) {
	if(value == null) {
		// Blank String Value
		var o = new_buf(8);
		o.write_shift(1, 0x03);
		o.write_shift(1, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 0xFFFF);
		return o;
	} else if(typeof value == "number") return write_Xnum(value);
	return write_Xnum(0);
}

/* [MS-XLS] 2.4.127 TODO */
function parse_Formula(blob, length, opts) {
	var end = blob.l + length;
	var cell = parse_XLSCell(blob, 6);
	if(opts.biff == 2) ++blob.l;
	var val = parse_FormulaValue(blob,8);
	var flags = blob.read_shift(1);
	if(opts.biff != 2) {
		blob.read_shift(1);
		if(opts.biff >= 5) {
			/*var chn = */blob.read_shift(4);
		}
	}
	var cbf = parse_XLSCellParsedFormula(blob, end - blob.l, opts);
	return {cell:cell, val:val[0], formula:cbf, shared: (flags >> 3) & 1, tt:val[1]};
}
function write_Formula(cell, R, C, opts, os) {
	// Cell
	var o1 = write_XLSCell(R, C, os);

	// FormulaValue
	var o2 = write_FormulaValue(cell.v);

	// flags + cache
	var o3 = new_buf(6);
	var flags = 0x01 | 0x20;
	o3.write_shift(2, flags);
	o3.write_shift(4, 0);

	// CellParsedFormula
	var bf = new_buf(cell.bf.length);
	for(var i = 0; i < cell.bf.length; ++i) bf[i] = cell.bf[i];

	var out = bconcat([o1, o2, o3, bf]);
	return out;
}


/* XLSB Parsed Formula records have the same shape */
function parse_XLSBParsedFormula(data, length, opts) {
	var cce = data.read_shift(4);
	var rgce = parse_Rgce(data, cce, opts);
	var cb = data.read_shift(4);
	var rgcb = cb > 0 ? parse_RgbExtra(data, cb, rgce, opts) : null;
	return [rgce, rgcb];
}

/* [MS-XLSB] 2.5.97.1 ArrayParsedFormula */
var parse_XLSBArrayParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.4 CellParsedFormula */
var parse_XLSBCellParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.8 DVParsedFormula */
//var parse_XLSBDVParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.9 FRTParsedFormula */
//var parse_XLSBFRTParsedFormula = parse_XLSBParsedFormula2;
/* [MS-XLSB] 2.5.97.12 NameParsedFormula */
var parse_XLSBNameParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.98 SharedParsedFormula */
var parse_XLSBSharedParsedFormula = parse_XLSBParsedFormula;

/* Writes a PtgNum or PtgInt */
function write_XLSBFormulaNum(val) {
	if((val | 0) == val && val < Math.pow(2,16) && val >= 0) {
		var oint = new_buf(11);
		oint.write_shift(4, 3);
		oint.write_shift(1, 0x1e);
		oint.write_shift(2, val);
		oint.write_shift(4, 0);
		return oint;
	}

	var num = new_buf(17);
	num.write_shift(4, 11);
	num.write_shift(1, 0x1f);
	num.write_shift(8, val);
	num.write_shift(4, 0);
	return num;
}
/* Writes a PtgErr */
function write_XLSBFormulaErr(val) {
	var oint = new_buf(10);
	oint.write_shift(4, 2);
	oint.write_shift(1, 0x1C);
	oint.write_shift(1, val);
	oint.write_shift(4, 0);
	return oint;
}
/* Writes a PtgBool */
function write_XLSBFormulaBool(val) {
	var oint = new_buf(10);
	oint.write_shift(4, 2);
	oint.write_shift(1, 0x1D);
	oint.write_shift(1, val?1:0);
	oint.write_shift(4, 0);
	return oint;
}

/* Writes a PtgStr */
function write_XLSBFormulaStr(val) {
	var preamble = new_buf(7);
	preamble.write_shift(4, 3 + 2 * val.length);
	preamble.write_shift(1, 0x17);
	preamble.write_shift(2, val.length);

	var body = new_buf(2 * val.length);
	body.write_shift(2 * val.length, val, "utf16le");

	var postamble = new_buf(4);
	postamble.write_shift(4, 0);

	return bconcat([preamble, body, postamble]);
}

/* Writes a PtgRef */
function write_XLSBFormulaRef(str) {
	var cell = decode_cell(str);
	var out = new_buf(15);
	out.write_shift(4, 7);
	out.write_shift(1, 0x04 | ((1)<<5));
	out.write_shift(4, cell.r);
	out.write_shift(2, cell.c | ((str.charAt(0) == "$" ? 0 : 1)<<14) | ((str.match(/\$\d/) ? 0 : 1)<<15)); // <== ColRelShort
	out.write_shift(4, 0);

	return out;
}

/* Writes a PtgRef3d */
function write_XLSBFormulaRef3D(str, wb) {
	var lastbang = str.lastIndexOf("!");
	var sname = str.slice(0, lastbang);
	str = str.slice(lastbang+1);
	var cell = decode_cell(str);
	if(sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");

	var out = new_buf(17);
	out.write_shift(4, 9);
	out.write_shift(1, 0x1A | ((1)<<5));
	out.write_shift(2, 2 + wb.SheetNames.map(function(n) { return n.toLowerCase(); }).indexOf(sname.toLowerCase()));
	out.write_shift(4, cell.r);
	out.write_shift(2, cell.c | ((str.charAt(0) == "$" ? 0 : 1)<<14) | ((str.match(/\$\d/) ? 0 : 1)<<15)); // <== ColRelShort
	out.write_shift(4, 0);

	return out;
}

/* Writes a PtgRefErr3d */
function write_XLSBFormulaRefErr3D(str, wb) {
	var lastbang = str.lastIndexOf("!");
	var sname = str.slice(0, lastbang);
	str = str.slice(lastbang+1);
	if(sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");

	var out = new_buf(17);
	out.write_shift(4, 9);
	out.write_shift(1, 0x1C | ((1)<<5));
	out.write_shift(2, 2 + wb.SheetNames.map(function(n) { return n.toLowerCase(); }).indexOf(sname.toLowerCase()));
	out.write_shift(4, 0);
	out.write_shift(2, 0); // <== ColRelShort
	out.write_shift(4, 0);

	return out;
}

/* Writes a single sheet range [PtgRef PtgRef PtgRange] */
function write_XLSBFormulaRange(_str) {
	var parts = _str.split(":"), str = parts[0];

	var out = new_buf(23);
	out.write_shift(4, 15);

	/* start cell */
	str = parts[0]; var cell = decode_cell(str);
	out.write_shift(1, 0x04 | ((1)<<5));
	out.write_shift(4, cell.r);
	out.write_shift(2, cell.c | ((str.charAt(0) == "$" ? 0 : 1)<<14) | ((str.match(/\$\d/) ? 0 : 1)<<15)); // <== ColRelShort
	out.write_shift(4, 0);

	/* end cell */
	str = parts[1]; cell = decode_cell(str);
	out.write_shift(1, 0x04 | ((1)<<5));
	out.write_shift(4, cell.r);
	out.write_shift(2, cell.c | ((str.charAt(0) == "$" ? 0 : 1)<<14) | ((str.match(/\$\d/) ? 0 : 1)<<15)); // <== ColRelShort
	out.write_shift(4, 0);

	/* PtgRange */
	out.write_shift(1, 0x11);

	out.write_shift(4, 0);

	return out;
}

/* Writes a range with explicit sheet name [PtgRef3D PtgRef3D PtgRange] */
function write_XLSBFormulaRangeWS(_str, wb) {
	var lastbang = _str.lastIndexOf("!");
	var sname = _str.slice(0, lastbang);
	_str = _str.slice(lastbang+1);
	if(sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
	var parts = _str.split(":"); str = parts[0];

	var out = new_buf(27);
	out.write_shift(4, 19);

	/* start cell */
	var str = parts[0], cell = decode_cell(str);
	out.write_shift(1, 0x1A | ((1)<<5));
	out.write_shift(2, 2 + wb.SheetNames.map(function(n) { return n.toLowerCase(); }).indexOf(sname.toLowerCase()));
	out.write_shift(4, cell.r);
	out.write_shift(2, cell.c | ((str.charAt(0) == "$" ? 0 : 1)<<14) | ((str.match(/\$\d/) ? 0 : 1)<<15)); // <== ColRelShort

	/* end cell */
	str = parts[1]; cell = decode_cell(str);
	out.write_shift(1, 0x1A | ((1)<<5));
	out.write_shift(2, 2 + wb.SheetNames.map(function(n) { return n.toLowerCase(); }).indexOf(sname.toLowerCase()));
	out.write_shift(4, cell.r);
	out.write_shift(2, cell.c | ((str.charAt(0) == "$" ? 0 : 1)<<14) | ((str.match(/\$\d/) ? 0 : 1)<<15)); // <== ColRelShort

	/* PtgRange */
	out.write_shift(1, 0x11);

	out.write_shift(4, 0);

	return out;
}

/* Writes a range with explicit sheet name [PtgArea3d] */
function write_XLSBFormulaArea3D(_str, wb) {
	var lastbang = _str.lastIndexOf("!");
	var sname = _str.slice(0, lastbang);
	_str = _str.slice(lastbang+1);
	if(sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
	var range = decode_range(_str);

	var out = new_buf(23);
	out.write_shift(4, 15);

	out.write_shift(1, 0x1B | ((1)<<5));
	out.write_shift(2, 2 + wb.SheetNames.map(function(n) { return n.toLowerCase(); }).indexOf(sname.toLowerCase()));
	out.write_shift(4, range.s.r);
	out.write_shift(4, range.e.r);
	out.write_shift(2, range.s.c);
	out.write_shift(2, range.e.c);

	out.write_shift(4, 0);

	return out;
}


/* General Formula */
function write_XLSBFormula(val, wb) {
	if(typeof val == "number") return write_XLSBFormulaNum(val);
	if(typeof val == "boolean") return write_XLSBFormulaBool(val);
	if(/^#(DIV\/0!|GETTING_DATA|N\/A|NAME\?|NULL!|NUM!|REF!|VALUE!)$/.test(val)) return write_XLSBFormulaErr(+RBErr[val]);
	if(val.match(/^\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return write_XLSBFormulaRef(val);
	if(val.match(/^\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5}):\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return write_XLSBFormulaRange(val);
	if(val.match(/^#REF!\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5}):\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return write_XLSBFormulaArea3D(val, wb);
	if(val.match(/^(?:'[^\\\/?*\[\]:]*'|[^'][^\\\/?*\[\]:'`~!@#$%^()\-=+{}|;,<.>]*)!\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return write_XLSBFormulaRef3D(val, wb);
	if(val.match(/^(?:'[^\\\/?*\[\]:]*'|[^'][^\\\/?*\[\]:'`~!@#$%^()\-=+{}|;,<.>]*)!\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5}):\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return write_XLSBFormulaRangeWS(val, wb);
	if(/^(?:'[^\\\/?*\[\]:]*'|[^'][^\\\/?*\[\]:'`~!@#$%^()\-=+{}|;,<.>]*)!#REF!$/.test(val)) return write_XLSBFormulaRefErr3D(val, wb);
	if(/^".*"$/.test(val)) return write_XLSBFormulaStr(val);
	if(/^[+-]\d+$/.test(val)) return write_XLSBFormulaNum(parseInt(val, 10));
	throw "Formula |" + val + "| not supported for XLSB";
}
var write_XLSBNameParsedFormula = write_XLSBFormula;
var Cetab = {
  0: "BEEP",
  1: "OPEN",
  2: "OPEN.LINKS",
  3: "CLOSE.ALL",
  4: "SAVE",
  5: "SAVE.AS",
  6: "FILE.DELETE",
  7: "PAGE.SETUP",
  8: "PRINT",
  9: "PRINTER.SETUP",
  10: "QUIT",
  11: "NEW.WINDOW",
  12: "ARRANGE.ALL",
  13: "WINDOW.SIZE",
  14: "WINDOW.MOVE",
  15: "FULL",
  16: "CLOSE",
  17: "RUN",
  22: "SET.PRINT.AREA",
  23: "SET.PRINT.TITLES",
  24: "SET.PAGE.BREAK",
  25: "REMOVE.PAGE.BREAK",
  26: "FONT",
  27: "DISPLAY",
  28: "PROTECT.DOCUMENT",
  29: "PRECISION",
  30: "A1.R1C1",
  31: "CALCULATE.NOW",
  32: "CALCULATION",
  34: "DATA.FIND",
  35: "EXTRACT",
  36: "DATA.DELETE",
  37: "SET.DATABASE",
  38: "SET.CRITERIA",
  39: "SORT",
  40: "DATA.SERIES",
  41: "TABLE",
  42: "FORMAT.NUMBER",
  43: "ALIGNMENT",
  44: "STYLE",
  45: "BORDER",
  46: "CELL.PROTECTION",
  47: "COLUMN.WIDTH",
  48: "UNDO",
  49: "CUT",
  50: "COPY",
  51: "PASTE",
  52: "CLEAR",
  53: "PASTE.SPECIAL",
  54: "EDIT.DELETE",
  55: "INSERT",
  56: "FILL.RIGHT",
  57: "FILL.DOWN",
  61: "DEFINE.NAME",
  62: "CREATE.NAMES",
  63: "FORMULA.GOTO",
  64: "FORMULA.FIND",
  65: "SELECT.LAST.CELL",
  66: "SHOW.ACTIVE.CELL",
  67: "GALLERY.AREA",
  68: "GALLERY.BAR",
  69: "GALLERY.COLUMN",
  70: "GALLERY.LINE",
  71: "GALLERY.PIE",
  72: "GALLERY.SCATTER",
  73: "COMBINATION",
  74: "PREFERRED",
  75: "ADD.OVERLAY",
  76: "GRIDLINES",
  77: "SET.PREFERRED",
  78: "AXES",
  79: "LEGEND",
  80: "ATTACH.TEXT",
  81: "ADD.ARROW",
  82: "SELECT.CHART",
  83: "SELECT.PLOT.AREA",
  84: "PATTERNS",
  85: "MAIN.CHART",
  86: "OVERLAY",
  87: "SCALE",
  88: "FORMAT.LEGEND",
  89: "FORMAT.TEXT",
  90: "EDIT.REPEAT",
  91: "PARSE",
  92: "JUSTIFY",
  93: "HIDE",
  94: "UNHIDE",
  95: "WORKSPACE",
  96: "FORMULA",
  97: "FORMULA.FILL",
  98: "FORMULA.ARRAY",
  99: "DATA.FIND.NEXT",
  100: "DATA.FIND.PREV",
  101: "FORMULA.FIND.NEXT",
  102: "FORMULA.FIND.PREV",
  103: "ACTIVATE",
  104: "ACTIVATE.NEXT",
  105: "ACTIVATE.PREV",
  106: "UNLOCKED.NEXT",
  107: "UNLOCKED.PREV",
  108: "COPY.PICTURE",
  109: "SELECT",
  110: "DELETE.NAME",
  111: "DELETE.FORMAT",
  112: "VLINE",
  113: "HLINE",
  114: "VPAGE",
  115: "HPAGE",
  116: "VSCROLL",
  117: "HSCROLL",
  118: "ALERT",
  119: "NEW",
  120: "CANCEL.COPY",
  121: "SHOW.CLIPBOARD",
  122: "MESSAGE",
  124: "PASTE.LINK",
  125: "APP.ACTIVATE",
  126: "DELETE.ARROW",
  127: "ROW.HEIGHT",
  128: "FORMAT.MOVE",
  129: "FORMAT.SIZE",
  130: "FORMULA.REPLACE",
  131: "SEND.KEYS",
  132: "SELECT.SPECIAL",
  133: "APPLY.NAMES",
  134: "REPLACE.FONT",
  135: "FREEZE.PANES",
  136: "SHOW.INFO",
  137: "SPLIT",
  138: "ON.WINDOW",
  139: "ON.DATA",
  140: "DISABLE.INPUT",
  142: "OUTLINE",
  143: "LIST.NAMES",
  144: "FILE.CLOSE",
  145: "SAVE.WORKBOOK",
  146: "DATA.FORM",
  147: "COPY.CHART",
  148: "ON.TIME",
  149: "WAIT",
  150: "FORMAT.FONT",
  151: "FILL.UP",
  152: "FILL.LEFT",
  153: "DELETE.OVERLAY",
  155: "SHORT.MENUS",
  159: "SET.UPDATE.STATUS",
  161: "COLOR.PALETTE",
  162: "DELETE.STYLE",
  163: "WINDOW.RESTORE",
  164: "WINDOW.MAXIMIZE",
  166: "CHANGE.LINK",
  167: "CALCULATE.DOCUMENT",
  168: "ON.KEY",
  169: "APP.RESTORE",
  170: "APP.MOVE",
  171: "APP.SIZE",
  172: "APP.MINIMIZE",
  173: "APP.MAXIMIZE",
  174: "BRING.TO.FRONT",
  175: "SEND.TO.BACK",
  185: "MAIN.CHART.TYPE",
  186: "OVERLAY.CHART.TYPE",
  187: "SELECT.END",
  188: "OPEN.MAIL",
  189: "SEND.MAIL",
  190: "STANDARD.FONT",
  191: "CONSOLIDATE",
  192: "SORT.SPECIAL",
  193: "GALLERY.3D.AREA",
  194: "GALLERY.3D.COLUMN",
  195: "GALLERY.3D.LINE",
  196: "GALLERY.3D.PIE",
  197: "VIEW.3D",
  198: "GOAL.SEEK",
  199: "WORKGROUP",
  200: "FILL.GROUP",
  201: "UPDATE.LINK",
  202: "PROMOTE",
  203: "DEMOTE",
  204: "SHOW.DETAIL",
  206: "UNGROUP",
  207: "OBJECT.PROPERTIES",
  208: "SAVE.NEW.OBJECT",
  209: "SHARE",
  210: "SHARE.NAME",
  211: "DUPLICATE",
  212: "APPLY.STYLE",
  213: "ASSIGN.TO.OBJECT",
  214: "OBJECT.PROTECTION",
  215: "HIDE.OBJECT",
  216: "SET.EXTRACT",
  217: "CREATE.PUBLISHER",
  218: "SUBSCRIBE.TO",
  219: "ATTRIBUTES",
  220: "SHOW.TOOLBAR",
  222: "PRINT.PREVIEW",
  223: "EDIT.COLOR",
  224: "SHOW.LEVELS",
  225: "FORMAT.MAIN",
  226: "FORMAT.OVERLAY",
  227: "ON.RECALC",
  228: "EDIT.SERIES",
  229: "DEFINE.STYLE",
  240: "LINE.PRINT",
  243: "ENTER.DATA",
  249: "GALLERY.RADAR",
  250: "MERGE.STYLES",
  251: "EDITION.OPTIONS",
  252: "PASTE.PICTURE",
  253: "PASTE.PICTURE.LINK",
  254: "SPELLING",
  256: "ZOOM",
  259: "INSERT.OBJECT",
  260: "WINDOW.MINIMIZE",
  265: "SOUND.NOTE",
  266: "SOUND.PLAY",
  267: "FORMAT.SHAPE",
  268: "EXTEND.POLYGON",
  269: "FORMAT.AUTO",
  272: "GALLERY.3D.BAR",
  273: "GALLERY.3D.SURFACE",
  274: "FILL.AUTO",
  276: "CUSTOMIZE.TOOLBAR",
  277: "ADD.TOOL",
  278: "EDIT.OBJECT",
  279: "ON.DOUBLECLICK",
  280: "ON.ENTRY",
  281: "WORKBOOK.ADD",
  282: "WORKBOOK.MOVE",
  283: "WORKBOOK.COPY",
  284: "WORKBOOK.OPTIONS",
  285: "SAVE.WORKSPACE",
  288: "CHART.WIZARD",
  289: "DELETE.TOOL",
  290: "MOVE.TOOL",
  291: "WORKBOOK.SELECT",
  292: "WORKBOOK.ACTIVATE",
  293: "ASSIGN.TO.TOOL",
  295: "COPY.TOOL",
  296: "RESET.TOOL",
  297: "CONSTRAIN.NUMERIC",
  298: "PASTE.TOOL",
  302: "WORKBOOK.NEW",
  305: "SCENARIO.CELLS",
  306: "SCENARIO.DELETE",
  307: "SCENARIO.ADD",
  308: "SCENARIO.EDIT",
  309: "SCENARIO.SHOW",
  310: "SCENARIO.SHOW.NEXT",
  311: "SCENARIO.SUMMARY",
  312: "PIVOT.TABLE.WIZARD",
  313: "PIVOT.FIELD.PROPERTIES",
  314: "PIVOT.FIELD",
  315: "PIVOT.ITEM",
  316: "PIVOT.ADD.FIELDS",
  318: "OPTIONS.CALCULATION",
  319: "OPTIONS.EDIT",
  320: "OPTIONS.VIEW",
  321: "ADDIN.MANAGER",
  322: "MENU.EDITOR",
  323: "ATTACH.TOOLBARS",
  324: "VBAActivate",
  325: "OPTIONS.CHART",
  328: "VBA.INSERT.FILE",
  330: "VBA.PROCEDURE.DEFINITION",
  336: "ROUTING.SLIP",
  338: "ROUTE.DOCUMENT",
  339: "MAIL.LOGON",
  342: "INSERT.PICTURE",
  343: "EDIT.TOOL",
  344: "GALLERY.DOUGHNUT",
  350: "CHART.TREND",
  352: "PIVOT.ITEM.PROPERTIES",
  354: "WORKBOOK.INSERT",
  355: "OPTIONS.TRANSITION",
  356: "OPTIONS.GENERAL",
  370: "FILTER.ADVANCED",
  373: "MAIL.ADD.MAILER",
  374: "MAIL.DELETE.MAILER",
  375: "MAIL.REPLY",
  376: "MAIL.REPLY.ALL",
  377: "MAIL.FORWARD",
  378: "MAIL.NEXT.LETTER",
  379: "DATA.LABEL",
  380: "INSERT.TITLE",
  381: "FONT.PROPERTIES",
  382: "MACRO.OPTIONS",
  383: "WORKBOOK.HIDE",
  384: "WORKBOOK.UNHIDE",
  385: "WORKBOOK.DELETE",
  386: "WORKBOOK.NAME",
  388: "GALLERY.CUSTOM",
  390: "ADD.CHART.AUTOFORMAT",
  391: "DELETE.CHART.AUTOFORMAT",
  392: "CHART.ADD.DATA",
  393: "AUTO.OUTLINE",
  394: "TAB.ORDER",
  395: "SHOW.DIALOG",
  396: "SELECT.ALL",
  397: "UNGROUP.SHEETS",
  398: "SUBTOTAL.CREATE",
  399: "SUBTOTAL.REMOVE",
  400: "RENAME.OBJECT",
  412: "WORKBOOK.SCROLL",
  413: "WORKBOOK.NEXT",
  414: "WORKBOOK.PREV",
  415: "WORKBOOK.TAB.SPLIT",
  416: "FULL.SCREEN",
  417: "WORKBOOK.PROTECT",
  420: "SCROLLBAR.PROPERTIES",
  421: "PIVOT.SHOW.PAGES",
  422: "TEXT.TO.COLUMNS",
  423: "FORMAT.CHARTTYPE",
  424: "LINK.FORMAT",
  425: "TRACER.DISPLAY",
  430: "TRACER.NAVIGATE",
  431: "TRACER.CLEAR",
  432: "TRACER.ERROR",
  433: "PIVOT.FIELD.GROUP",
  434: "PIVOT.FIELD.UNGROUP",
  435: "CHECKBOX.PROPERTIES",
  436: "LABEL.PROPERTIES",
  437: "LISTBOX.PROPERTIES",
  438: "EDITBOX.PROPERTIES",
  439: "PIVOT.REFRESH",
  440: "LINK.COMBO",
  441: "OPEN.TEXT",
  442: "HIDE.DIALOG",
  443: "SET.DIALOG.FOCUS",
  444: "ENABLE.OBJECT",
  445: "PUSHBUTTON.PROPERTIES",
  446: "SET.DIALOG.DEFAULT",
  447: "FILTER",
  448: "FILTER.SHOW.ALL",
  449: "CLEAR.OUTLINE",
  450: "FUNCTION.WIZARD",
  451: "ADD.LIST.ITEM",
  452: "SET.LIST.ITEM",
  453: "REMOVE.LIST.ITEM",
  454: "SELECT.LIST.ITEM",
  455: "SET.CONTROL.VALUE",
  456: "SAVE.COPY.AS",
  458: "OPTIONS.LISTS.ADD",
  459: "OPTIONS.LISTS.DELETE",
  460: "SERIES.AXES",
  461: "SERIES.X",
  462: "SERIES.Y",
  463: "ERRORBAR.X",
  464: "ERRORBAR.Y",
  465: "FORMAT.CHART",
  466: "SERIES.ORDER",
  467: "MAIL.LOGOFF",
  468: "CLEAR.ROUTING.SLIP",
  469: "APP.ACTIVATE.MICROSOFT",
  470: "MAIL.EDIT.MAILER",
  471: "ON.SHEET",
  472: "STANDARD.WIDTH",
  473: "SCENARIO.MERGE",
  474: "SUMMARY.INFO",
  475: "FIND.FILE",
  476: "ACTIVE.CELL.FONT",
  477: "ENABLE.TIPWIZARD",
  478: "VBA.MAKE.ADDIN",
  480: "INSERTDATATABLE",
  481: "WORKGROUP.OPTIONS",
  482: "MAIL.SEND.MAILER",
  485: "AUTOCORRECT",
  489: "POST.DOCUMENT",
  491: "PICKLIST",
  493: "VIEW.SHOW",
  494: "VIEW.DEFINE",
  495: "VIEW.DELETE",
  509: "SHEET.BACKGROUND",
  510: "INSERT.MAP.OBJECT",
  511: "OPTIONS.MENONO",
  517: "MSOCHECKS",
  518: "NORMAL",
  519: "LAYOUT",
  520: "RM.PRINT.AREA",
  521: "CLEAR.PRINT.AREA",
  522: "ADD.PRINT.AREA",
  523: "MOVE.BRK",
  545: "HIDECURR.NOTE",
  546: "HIDEALL.NOTES",
  547: "DELETE.NOTE",
  548: "TRAVERSE.NOTES",
  549: "ACTIVATE.NOTES",
  620: "PROTECT.REVISIONS",
  621: "UNPROTECT.REVISIONS",
  647: "OPTIONS.ME",
  653: "WEB.PUBLISH",
  667: "NEWWEBQUERY",
  673: "PIVOT.TABLE.CHART",
  753: "OPTIONS.SAVE",
  755: "OPTIONS.SPELL",
  808: "HIDEALL.INKANNOTS"
};
var Ftab = {
  0: "COUNT",
  1: "IF",
  2: "ISNA",
  3: "ISERROR",
  4: "SUM",
  5: "AVERAGE",
  6: "MIN",
  7: "MAX",
  8: "ROW",
  9: "COLUMN",
  10: "NA",
  11: "NPV",
  12: "STDEV",
  13: "DOLLAR",
  14: "FIXED",
  15: "SIN",
  16: "COS",
  17: "TAN",
  18: "ATAN",
  19: "PI",
  20: "SQRT",
  21: "EXP",
  22: "LN",
  23: "LOG10",
  24: "ABS",
  25: "INT",
  26: "SIGN",
  27: "ROUND",
  28: "LOOKUP",
  29: "INDEX",
  30: "REPT",
  31: "MID",
  32: "LEN",
  33: "VALUE",
  34: "TRUE",
  35: "FALSE",
  36: "AND",
  37: "OR",
  38: "NOT",
  39: "MOD",
  40: "DCOUNT",
  41: "DSUM",
  42: "DAVERAGE",
  43: "DMIN",
  44: "DMAX",
  45: "DSTDEV",
  46: "VAR",
  47: "DVAR",
  48: "TEXT",
  49: "LINEST",
  50: "TREND",
  51: "LOGEST",
  52: "GROWTH",
  53: "GOTO",
  54: "HALT",
  55: "RETURN",
  56: "PV",
  57: "FV",
  58: "NPER",
  59: "PMT",
  60: "RATE",
  61: "MIRR",
  62: "IRR",
  63: "RAND",
  64: "MATCH",
  65: "DATE",
  66: "TIME",
  67: "DAY",
  68: "MONTH",
  69: "YEAR",
  70: "WEEKDAY",
  71: "HOUR",
  72: "MINUTE",
  73: "SECOND",
  74: "NOW",
  75: "AREAS",
  76: "ROWS",
  77: "COLUMNS",
  78: "OFFSET",
  79: "ABSREF",
  80: "RELREF",
  81: "ARGUMENT",
  82: "SEARCH",
  83: "TRANSPOSE",
  84: "ERROR",
  85: "STEP",
  86: "TYPE",
  87: "ECHO",
  88: "SET.NAME",
  89: "CALLER",
  90: "DEREF",
  91: "WINDOWS",
  92: "SERIES",
  93: "DOCUMENTS",
  94: "ACTIVE.CELL",
  95: "SELECTION",
  96: "RESULT",
  97: "ATAN2",
  98: "ASIN",
  99: "ACOS",
  100: "CHOOSE",
  101: "HLOOKUP",
  102: "VLOOKUP",
  103: "LINKS",
  104: "INPUT",
  105: "ISREF",
  106: "GET.FORMULA",
  107: "GET.NAME",
  108: "SET.VALUE",
  109: "LOG",
  110: "EXEC",
  111: "CHAR",
  112: "LOWER",
  113: "UPPER",
  114: "PROPER",
  115: "LEFT",
  116: "RIGHT",
  117: "EXACT",
  118: "TRIM",
  119: "REPLACE",
  120: "SUBSTITUTE",
  121: "CODE",
  122: "NAMES",
  123: "DIRECTORY",
  124: "FIND",
  125: "CELL",
  126: "ISERR",
  127: "ISTEXT",
  128: "ISNUMBER",
  129: "ISBLANK",
  130: "T",
  131: "N",
  132: "FOPEN",
  133: "FCLOSE",
  134: "FSIZE",
  135: "FREADLN",
  136: "FREAD",
  137: "FWRITELN",
  138: "FWRITE",
  139: "FPOS",
  140: "DATEVALUE",
  141: "TIMEVALUE",
  142: "SLN",
  143: "SYD",
  144: "DDB",
  145: "GET.DEF",
  146: "REFTEXT",
  147: "TEXTREF",
  148: "INDIRECT",
  149: "REGISTER",
  150: "CALL",
  151: "ADD.BAR",
  152: "ADD.MENU",
  153: "ADD.COMMAND",
  154: "ENABLE.COMMAND",
  155: "CHECK.COMMAND",
  156: "RENAME.COMMAND",
  157: "SHOW.BAR",
  158: "DELETE.MENU",
  159: "DELETE.COMMAND",
  160: "GET.CHART.ITEM",
  161: "DIALOG.BOX",
  162: "CLEAN",
  163: "MDETERM",
  164: "MINVERSE",
  165: "MMULT",
  166: "FILES",
  167: "IPMT",
  168: "PPMT",
  169: "COUNTA",
  170: "CANCEL.KEY",
  171: "FOR",
  172: "WHILE",
  173: "BREAK",
  174: "NEXT",
  175: "INITIATE",
  176: "REQUEST",
  177: "POKE",
  178: "EXECUTE",
  179: "TERMINATE",
  180: "RESTART",
  181: "HELP",
  182: "GET.BAR",
  183: "PRODUCT",
  184: "FACT",
  185: "GET.CELL",
  186: "GET.WORKSPACE",
  187: "GET.WINDOW",
  188: "GET.DOCUMENT",
  189: "DPRODUCT",
  190: "ISNONTEXT",
  191: "GET.NOTE",
  192: "NOTE",
  193: "STDEVP",
  194: "VARP",
  195: "DSTDEVP",
  196: "DVARP",
  197: "TRUNC",
  198: "ISLOGICAL",
  199: "DCOUNTA",
  200: "DELETE.BAR",
  201: "UNREGISTER",
  204: "USDOLLAR",
  205: "FINDB",
  206: "SEARCHB",
  207: "REPLACEB",
  208: "LEFTB",
  209: "RIGHTB",
  210: "MIDB",
  211: "LENB",
  212: "ROUNDUP",
  213: "ROUNDDOWN",
  214: "ASC",
  215: "DBCS",
  216: "RANK",
  219: "ADDRESS",
  220: "DAYS360",
  221: "TODAY",
  222: "VDB",
  223: "ELSE",
  224: "ELSE.IF",
  225: "END.IF",
  226: "FOR.CELL",
  227: "MEDIAN",
  228: "SUMPRODUCT",
  229: "SINH",
  230: "COSH",
  231: "TANH",
  232: "ASINH",
  233: "ACOSH",
  234: "ATANH",
  235: "DGET",
  236: "CREATE.OBJECT",
  237: "VOLATILE",
  238: "LAST.ERROR",
  239: "CUSTOM.UNDO",
  240: "CUSTOM.REPEAT",
  241: "FORMULA.CONVERT",
  242: "GET.LINK.INFO",
  243: "TEXT.BOX",
  244: "INFO",
  245: "GROUP",
  246: "GET.OBJECT",
  247: "DB",
  248: "PAUSE",
  251: "RESUME",
  252: "FREQUENCY",
  253: "ADD.TOOLBAR",
  254: "DELETE.TOOLBAR",
  255: "User",
  256: "RESET.TOOLBAR",
  257: "EVALUATE",
  258: "GET.TOOLBAR",
  259: "GET.TOOL",
  260: "SPELLING.CHECK",
  261: "ERROR.TYPE",
  262: "APP.TITLE",
  263: "WINDOW.TITLE",
  264: "SAVE.TOOLBAR",
  265: "ENABLE.TOOL",
  266: "PRESS.TOOL",
  267: "REGISTER.ID",
  268: "GET.WORKBOOK",
  269: "AVEDEV",
  270: "BETADIST",
  271: "GAMMALN",
  272: "BETAINV",
  273: "BINOMDIST",
  274: "CHIDIST",
  275: "CHIINV",
  276: "COMBIN",
  277: "CONFIDENCE",
  278: "CRITBINOM",
  279: "EVEN",
  280: "EXPONDIST",
  281: "FDIST",
  282: "FINV",
  283: "FISHER",
  284: "FISHERINV",
  285: "FLOOR",
  286: "GAMMADIST",
  287: "GAMMAINV",
  288: "CEILING",
  289: "HYPGEOMDIST",
  290: "LOGNORMDIST",
  291: "LOGINV",
  292: "NEGBINOMDIST",
  293: "NORMDIST",
  294: "NORMSDIST",
  295: "NORMINV",
  296: "NORMSINV",
  297: "STANDARDIZE",
  298: "ODD",
  299: "PERMUT",
  300: "POISSON",
  301: "TDIST",
  302: "WEIBULL",
  303: "SUMXMY2",
  304: "SUMX2MY2",
  305: "SUMX2PY2",
  306: "CHITEST",
  307: "CORREL",
  308: "COVAR",
  309: "FORECAST",
  310: "FTEST",
  311: "INTERCEPT",
  312: "PEARSON",
  313: "RSQ",
  314: "STEYX",
  315: "SLOPE",
  316: "TTEST",
  317: "PROB",
  318: "DEVSQ",
  319: "GEOMEAN",
  320: "HARMEAN",
  321: "SUMSQ",
  322: "KURT",
  323: "SKEW",
  324: "ZTEST",
  325: "LARGE",
  326: "SMALL",
  327: "QUARTILE",
  328: "PERCENTILE",
  329: "PERCENTRANK",
  330: "MODE",
  331: "TRIMMEAN",
  332: "TINV",
  334: "MOVIE.COMMAND",
  335: "GET.MOVIE",
  336: "CONCATENATE",
  337: "POWER",
  338: "PIVOT.ADD.DATA",
  339: "GET.PIVOT.TABLE",
  340: "GET.PIVOT.FIELD",
  341: "GET.PIVOT.ITEM",
  342: "RADIANS",
  343: "DEGREES",
  344: "SUBTOTAL",
  345: "SUMIF",
  346: "COUNTIF",
  347: "COUNTBLANK",
  348: "SCENARIO.GET",
  349: "OPTIONS.LISTS.GET",
  350: "ISPMT",
  351: "DATEDIF",
  352: "DATESTRING",
  353: "NUMBERSTRING",
  354: "ROMAN",
  355: "OPEN.DIALOG",
  356: "SAVE.DIALOG",
  357: "VIEW.GET",
  358: "GETPIVOTDATA",
  359: "HYPERLINK",
  360: "PHONETIC",
  361: "AVERAGEA",
  362: "MAXA",
  363: "MINA",
  364: "STDEVPA",
  365: "VARPA",
  366: "STDEVA",
  367: "VARA",
  368: "BAHTTEXT",
  369: "THAIDAYOFWEEK",
  370: "THAIDIGIT",
  371: "THAIMONTHOFYEAR",
  372: "THAINUMSOUND",
  373: "THAINUMSTRING",
  374: "THAISTRINGLENGTH",
  375: "ISTHAIDIGIT",
  376: "ROUNDBAHTDOWN",
  377: "ROUNDBAHTUP",
  378: "THAIYEAR",
  379: "RTD",
  380: "CUBEVALUE",
  381: "CUBEMEMBER",
  382: "CUBEMEMBERPROPERTY",
  383: "CUBERANKEDMEMBER",
  384: "HEX2BIN",
  385: "HEX2DEC",
  386: "HEX2OCT",
  387: "DEC2BIN",
  388: "DEC2HEX",
  389: "DEC2OCT",
  390: "OCT2BIN",
  391: "OCT2HEX",
  392: "OCT2DEC",
  393: "BIN2DEC",
  394: "BIN2OCT",
  395: "BIN2HEX",
  396: "IMSUB",
  397: "IMDIV",
  398: "IMPOWER",
  399: "IMABS",
  400: "IMSQRT",
  401: "IMLN",
  402: "IMLOG2",
  403: "IMLOG10",
  404: "IMSIN",
  405: "IMCOS",
  406: "IMEXP",
  407: "IMARGUMENT",
  408: "IMCONJUGATE",
  409: "IMAGINARY",
  410: "IMREAL",
  411: "COMPLEX",
  412: "IMSUM",
  413: "IMPRODUCT",
  414: "SERIESSUM",
  415: "FACTDOUBLE",
  416: "SQRTPI",
  417: "QUOTIENT",
  418: "DELTA",
  419: "GESTEP",
  420: "ISEVEN",
  421: "ISODD",
  422: "MROUND",
  423: "ERF",
  424: "ERFC",
  425: "BESSELJ",
  426: "BESSELK",
  427: "BESSELY",
  428: "BESSELI",
  429: "XIRR",
  430: "XNPV",
  431: "PRICEMAT",
  432: "YIELDMAT",
  433: "INTRATE",
  434: "RECEIVED",
  435: "DISC",
  436: "PRICEDISC",
  437: "YIELDDISC",
  438: "TBILLEQ",
  439: "TBILLPRICE",
  440: "TBILLYIELD",
  441: "PRICE",
  442: "YIELD",
  443: "DOLLARDE",
  444: "DOLLARFR",
  445: "NOMINAL",
  446: "EFFECT",
  447: "CUMPRINC",
  448: "CUMIPMT",
  449: "EDATE",
  450: "EOMONTH",
  451: "YEARFRAC",
  452: "COUPDAYBS",
  453: "COUPDAYS",
  454: "COUPDAYSNC",
  455: "COUPNCD",
  456: "COUPNUM",
  457: "COUPPCD",
  458: "DURATION",
  459: "MDURATION",
  460: "ODDLPRICE",
  461: "ODDLYIELD",
  462: "ODDFPRICE",
  463: "ODDFYIELD",
  464: "RANDBETWEEN",
  465: "WEEKNUM",
  466: "AMORDEGRC",
  467: "AMORLINC",
  468: "CONVERT",
  724: "SHEETJS",
  469: "ACCRINT",
  470: "ACCRINTM",
  471: "WORKDAY",
  472: "NETWORKDAYS",
  473: "GCD",
  474: "MULTINOMIAL",
  475: "LCM",
  476: "FVSCHEDULE",
  477: "CUBEKPIMEMBER",
  478: "CUBESET",
  479: "CUBESETCOUNT",
  480: "IFERROR",
  481: "COUNTIFS",
  482: "SUMIFS",
  483: "AVERAGEIF",
  484: "AVERAGEIFS"
};
var FtabArgc = {
  2: 1,
  3: 1,
  10: 0,
  15: 1,
  16: 1,
  17: 1,
  18: 1,
  19: 0,
  20: 1,
  21: 1,
  22: 1,
  23: 1,
  24: 1,
  25: 1,
  26: 1,
  27: 2,
  30: 2,
  31: 3,
  32: 1,
  33: 1,
  34: 0,
  35: 0,
  38: 1,
  39: 2,
  40: 3,
  41: 3,
  42: 3,
  43: 3,
  44: 3,
  45: 3,
  47: 3,
  48: 2,
  53: 1,
  61: 3,
  63: 0,
  65: 3,
  66: 3,
  67: 1,
  68: 1,
  69: 1,
  70: 1,
  71: 1,
  72: 1,
  73: 1,
  74: 0,
  75: 1,
  76: 1,
  77: 1,
  79: 2,
  80: 2,
  83: 1,
  85: 0,
  86: 1,
  89: 0,
  90: 1,
  94: 0,
  95: 0,
  97: 2,
  98: 1,
  99: 1,
  101: 3,
  102: 3,
  105: 1,
  106: 1,
  108: 2,
  111: 1,
  112: 1,
  113: 1,
  114: 1,
  117: 2,
  118: 1,
  119: 4,
  121: 1,
  126: 1,
  127: 1,
  128: 1,
  129: 1,
  130: 1,
  131: 1,
  133: 1,
  134: 1,
  135: 1,
  136: 2,
  137: 2,
  138: 2,
  140: 1,
  141: 1,
  142: 3,
  143: 4,
  144: 4,
  161: 1,
  162: 1,
  163: 1,
  164: 1,
  165: 2,
  172: 1,
  175: 2,
  176: 2,
  177: 3,
  178: 2,
  179: 1,
  184: 1,
  186: 1,
  189: 3,
  190: 1,
  195: 3,
  196: 3,
  197: 1,
  198: 1,
  199: 3,
  201: 1,
  207: 4,
  210: 3,
  211: 1,
  212: 2,
  213: 2,
  214: 1,
  215: 1,
  225: 0,
  229: 1,
  230: 1,
  231: 1,
  232: 1,
  233: 1,
  234: 1,
  235: 3,
  244: 1,
  247: 4,
  252: 2,
  257: 1,
  261: 1,
  271: 1,
  273: 4,
  274: 2,
  275: 2,
  276: 2,
  277: 3,
  278: 3,
  279: 1,
  280: 3,
  281: 3,
  282: 3,
  283: 1,
  284: 1,
  285: 2,
  286: 4,
  287: 3,
  288: 2,
  289: 4,
  290: 3,
  291: 3,
  292: 3,
  293: 4,
  294: 1,
  295: 3,
  296: 1,
  297: 3,
  298: 1,
  299: 2,
  300: 3,
  301: 3,
  302: 4,
  303: 2,
  304: 2,
  305: 2,
  306: 2,
  307: 2,
  308: 2,
  309: 3,
  310: 2,
  311: 2,
  312: 2,
  313: 2,
  314: 2,
  315: 2,
  316: 4,
  325: 2,
  326: 2,
  327: 2,
  328: 2,
  331: 2,
  332: 2,
  337: 2,
  342: 1,
  343: 1,
  346: 2,
  347: 1,
  350: 4,
  351: 3,
  352: 1,
  353: 2,
  360: 1,
  368: 1,
  369: 1,
  370: 1,
  371: 1,
  372: 1,
  373: 1,
  374: 1,
  375: 1,
  376: 1,
  377: 1,
  378: 1,
  382: 3,
  385: 1,
  392: 1,
  393: 1,
  396: 2,
  397: 2,
  398: 2,
  399: 1,
  400: 1,
  401: 1,
  402: 1,
  403: 1,
  404: 1,
  405: 1,
  406: 1,
  407: 1,
  408: 1,
  409: 1,
  410: 1,
  414: 4,
  415: 1,
  416: 1,
  417: 2,
  420: 1,
  421: 1,
  422: 2,
  424: 1,
  425: 2,
  426: 2,
  427: 2,
  428: 2,
  430: 3,
  438: 3,
  439: 3,
  440: 3,
  443: 2,
  444: 2,
  445: 2,
  446: 2,
  447: 6,
  448: 6,
  449: 2,
  450: 2,
  464: 2,
  468: 3,
  476: 2,
  479: 1,
  480: 2,
  65535: 0
};
/* Part 3 TODO: actually parse formulae */
function ods_to_csf_formula(f) {
	if(f.slice(0,3) == "of:") f = f.slice(3);
	/* 5.2 Basic Expressions */
	if(f.charCodeAt(0) == 61) {
		f = f.slice(1);
		if(f.charCodeAt(0) == 61) f = f.slice(1);
	}
	f = f.replace(/COM\.MICROSOFT\./g, "");
	/* Part 3 Section 5.8 References */
	f = f.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function($$, $1) { return $1.replace(/\./g,""); });
	f = f.replace(/\$'([^']|'')+'/g, function($$) { return $$.slice(1); });
	f = f.replace(/\$([^\]\. #$]+)/g, function($$, $1) { return ($1).match(/^([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])?(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})?$/) ? $$ : $1; });
	/* TODO: something other than this */
	f = f.replace(/\[.(#[A-Z]*[?!])\]/g, "$1");
	return f.replace(/[;~]/g,",").replace(/\|/g,";");
}

function csf_to_ods_formula(f) {
	var o = "of:=" + f.replace(crefregex, "$1[.$2$3$4$5]").replace(/\]:\[/g,":");
	/* TODO: something other than this */
	return o.replace(/;/g, "|").replace(/,/g,";");
}

function ods_to_csf_3D(r) {
	r = r.replace(/\$'([^']|'')+'/g, function($$) { return $$.slice(1); });
	r = r.replace(/\$([^\]\. #$]+)/g, function($$, $1) { return ($1).match(/^([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])?(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})?$/) ? $$ : $1; });
	var a = r.split(":");
	var s = a[0].split(".")[0];
	return [s, a[0].split(".")[1] + (a.length > 1 ? (":" + (a[1].split(".")[1] || a[1].split(".")[0])) : "")];
}

function csf_to_ods_3D(r) {
	return r.replace(/!/,".");
}

var strs = {}; // shared strings
var _ssfopts = {}; // spreadsheet formatting options


/*global Map */
var browser_has_Map = typeof Map !== 'undefined';

function get_sst_id(sst, str, rev) {
	var i = 0, len = sst.length;
	if(rev) {
		if(browser_has_Map ? rev.has(str) : Object.prototype.hasOwnProperty.call(rev, str)) {
			var revarr = browser_has_Map ? rev.get(str) : rev[str];
			for(; i < revarr.length; ++i) {
				if(sst[revarr[i]].t === str) { sst.Count ++; return revarr[i]; }
			}
		}
	} else for(; i < len; ++i) {
		if(sst[i].t === str) { sst.Count ++; return i; }
	}
	sst[len] = ({t:str}); sst.Count ++; sst.Unique ++;
	if(rev) {
		if(browser_has_Map) {
			if(!rev.has(str)) rev.set(str, []);
			rev.get(str).push(len);
		} else {
			if(!Object.prototype.hasOwnProperty.call(rev, str)) rev[str] = [];
			rev[str].push(len);
		}
	}
	return len;
}

function col_obj_w(C, col) {
	var p = ({min:C+1,max:C+1});
	/* wch (chars), wpx (pixels) */
	var wch = -1;
	if(col.MDW) MDW = col.MDW;
	if(col.width != null) p.customWidth = 1;
	else if(col.wpx != null) wch = px2char(col.wpx);
	else if(col.wch != null) wch = col.wch;
	if(wch > -1) { p.width = char2width(wch); p.customWidth = 1; }
	else if(col.width != null) p.width = col.width;
	if(col.hidden) p.hidden = true;
	if(col.level != null) { p.outlineLevel = p.level = col.level; }
	return p;
}

function default_margins(margins, mode) {
	if(!margins) return;
	var defs = [0.7, 0.7, 0.75, 0.75, 0.3, 0.3];
	if(mode == 'xlml') defs = [1, 1, 1, 1, 0.5, 0.5];
	if(margins.left   == null) margins.left   = defs[0];
	if(margins.right  == null) margins.right  = defs[1];
	if(margins.top    == null) margins.top    = defs[2];
	if(margins.bottom == null) margins.bottom = defs[3];
	if(margins.header == null) margins.header = defs[4];
	if(margins.footer == null) margins.footer = defs[5];
}

function get_cell_style(styles, cell, opts) {
	var z = opts.revssf[cell.z != null ? cell.z : "General"];
	var i = 0x3c, len = styles.length;
	if(z == null && opts.ssf) {
		for(; i < 0x188; ++i) if(opts.ssf[i] == null) {
			SSF__load(cell.z, i);
			// $FlowIgnore
			opts.ssf[i] = cell.z;
			opts.revssf[cell.z] = z = i;
			break;
		}
	}
	for(i = 0; i != len; ++i) if(styles[i].numFmtId === z) return i;
	styles[len] = {
		numFmtId:z,
		fontId:0,
		fillId:0,
		borderId:0,
		xfId:0,
		applyNumberFormat:1
	};
	return len;
}

function safe_format(p, fmtid, fillid, opts, themes, styles) {
	try {
		if(opts.cellNF) p.z = table_fmt[fmtid];
	} catch(e) { if(opts.WTF) throw e; }
	if(p.t === 'z' && !opts.cellStyles) return;
	if(p.t === 'd' && typeof p.v === 'string') p.v = parseDate(p.v);
	if((!opts || opts.cellText !== false) && p.t !== 'z') try {
		if(table_fmt[fmtid] == null) SSF__load(SSFImplicit[fmtid] || "General", fmtid);
		if(p.t === 'e') p.w = p.w || BErr[p.v];
		else if(fmtid === 0) {
			if(p.t === 'n') {
				if((p.v|0) === p.v) p.w = p.v.toString(10);
				else p.w = SSF_general_num(p.v);
			}
			else if(p.t === 'd') {
				var dd = datenum(p.v);
				if((dd|0) === dd) p.w = dd.toString(10);
				else p.w = SSF_general_num(dd);
			}
			else if(p.v === undefined) return "";
			else p.w = SSF_general(p.v,_ssfopts);
		}
		else if(p.t === 'd') p.w = SSF_format(fmtid,datenum(p.v),_ssfopts);
		else p.w = SSF_format(fmtid,p.v,_ssfopts);
	} catch(e) { if(opts.WTF) throw e; }
	if(!opts.cellStyles) return;
	if(fillid != null) try {
		p.s = styles.Fills[fillid];
		if (p.s.fgColor && p.s.fgColor.theme && !p.s.fgColor.rgb) {
			p.s.fgColor.rgb = rgb_tint(themes.themeElements.clrScheme[p.s.fgColor.theme].rgb, p.s.fgColor.tint || 0);
			if(opts.WTF) p.s.fgColor.raw_rgb = themes.themeElements.clrScheme[p.s.fgColor.theme].rgb;
		}
		if (p.s.bgColor && p.s.bgColor.theme) {
			p.s.bgColor.rgb = rgb_tint(themes.themeElements.clrScheme[p.s.bgColor.theme].rgb, p.s.bgColor.tint || 0);
			if(opts.WTF) p.s.bgColor.raw_rgb = themes.themeElements.clrScheme[p.s.bgColor.theme].rgb;
		}
	} catch(e) { if(opts.WTF && styles.Fills) throw e; }
}

function check_ws(ws, sname, i) {
	if(ws && ws['!ref']) {
		var range = safe_decode_range(ws['!ref']);
		if(range.e.c < range.s.c || range.e.r < range.s.r) throw new Error("Bad range (" + i + "): " + ws['!ref']);
	}
}
function parse_ws_xml_dim(ws, s) {
	var d = safe_decode_range(s);
	if(d.s.r<=d.e.r && d.s.c<=d.e.c && d.s.r>=0 && d.s.c>=0) ws["!ref"] = encode_range(d);
}
var mergecregex = /<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g;
var sheetdataregex = /<(?:\w+:)?sheetData[^>]*>([\s\S]*)<\/(?:\w+:)?sheetData>/;
var hlinkregex = /<(?:\w:)?hyperlink [^>]*>/mg;
var dimregex = /"(\w*:\w*)"/;
var colregex = /<(?:\w:)?col\b[^>]*[\/]?>/g;
var afregex = /<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g;
var marginregex= /<(?:\w:)?pageMargins[^>]*\/>/g;
var sheetprregex = /<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/;
var sheetprregex2= /<(?:\w:)?sheetPr[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetPr)>/;
var svsregex = /<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;

/* 18.3 Worksheets */
function parse_ws_xml(data, opts, idx, rels, wb, themes, styles) {
	if(!data) return data;
	if(!rels) rels = {'!id':{}};
	if(DENSE != null && opts.dense == null) opts.dense = DENSE;

	/* 18.3.1.99 worksheet CT_Worksheet */
	var s = opts.dense ? ([]) : ({});
	var refguess = ({s: {r:2000000, c:2000000}, e: {r:0, c:0} });

	var data1 = "", data2 = "";
	var mtch = data.match(sheetdataregex);
	if(mtch) {
		data1 = data.slice(0, mtch.index);
		data2 = data.slice(mtch.index + mtch[0].length);
	} else data1 = data2 = data;

	/* 18.3.1.82 sheetPr CT_SheetPr */
	var sheetPr = data1.match(sheetprregex);
	if(sheetPr) parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
	else if((sheetPr = data1.match(sheetprregex2))) parse_ws_xml_sheetpr2(sheetPr[0], sheetPr[1]||"", s, wb, idx, styles, themes);

	/* 18.3.1.35 dimension CT_SheetDimension */
	var ridx = (data1.match(/<(?:\w*:)?dimension/)||{index:-1}).index;
	if(ridx > 0) {
		var ref = data1.slice(ridx,ridx+50).match(dimregex);
		if(ref) parse_ws_xml_dim(s, ref[1]);
	}

	/* 18.3.1.88 sheetViews CT_SheetViews */
	var svs = data1.match(svsregex);
	if(svs && svs[1]) parse_ws_xml_sheetviews(svs[1], wb);

	/* 18.3.1.17 cols CT_Cols */
	var columns = [];
	if(opts.cellStyles) {
		/* 18.3.1.13 col CT_Col */
		var cols = data1.match(colregex);
		if(cols) parse_ws_xml_cols(columns, cols);
	}

	/* 18.3.1.80 sheetData CT_SheetData ? */
	if(mtch) parse_ws_xml_data(mtch[1], s, opts, refguess, themes, styles);

	/* 18.3.1.2  autoFilter CT_AutoFilter */
	var afilter = data2.match(afregex);
	if(afilter) s['!autofilter'] = parse_ws_xml_autofilter(afilter[0]);

	/* 18.3.1.55 mergeCells CT_MergeCells */
	var merges = [];
	var _merge = data2.match(mergecregex);
	if(_merge) for(ridx = 0; ridx != _merge.length; ++ridx)
		merges[ridx] = safe_decode_range(_merge[ridx].slice(_merge[ridx].indexOf("\"")+1));

	/* 18.3.1.48 hyperlinks CT_Hyperlinks */
	var hlink = data2.match(hlinkregex);
	if(hlink) parse_ws_xml_hlinks(s, hlink, rels);

	/* 18.3.1.62 pageMargins CT_PageMargins */
	var margins = data2.match(marginregex);
	if(margins) s['!margins'] = parse_ws_xml_margins(parsexmltag(margins[0]));

	if(!s["!ref"] && refguess.e.c >= refguess.s.c && refguess.e.r >= refguess.s.r) s["!ref"] = encode_range(refguess);
	if(opts.sheetRows > 0 && s["!ref"]) {
		var tmpref = safe_decode_range(s["!ref"]);
		if(opts.sheetRows <= +tmpref.e.r) {
			tmpref.e.r = opts.sheetRows - 1;
			if(tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
			if(tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
			if(tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
			if(tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
			s["!fullref"] = s["!ref"];
			s["!ref"] = encode_range(tmpref);
		}
	}
	if(columns.length > 0) s["!cols"] = columns;
	if(merges.length > 0) s["!merges"] = merges;
	return s;
}

function write_ws_xml_merges(merges) {
	if(merges.length === 0) return "";
	var o = '<mergeCells count="' + merges.length + '">';
	for(var i = 0; i != merges.length; ++i) o += '<mergeCell ref="' + encode_range(merges[i]) + '"/>';
	return o + '</mergeCells>';
}

/* 18.3.1.82-3 sheetPr CT_ChartsheetPr / CT_SheetPr */
function parse_ws_xml_sheetpr(sheetPr, s, wb, idx) {
	var data = parsexmltag(sheetPr);
	if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
	if(data.codeName) wb.Sheets[idx].CodeName = unescapexml(utf8read(data.codeName));
}
function parse_ws_xml_sheetpr2(sheetPr, body, s, wb, idx) {
	parse_ws_xml_sheetpr(sheetPr.slice(0, sheetPr.indexOf(">")), s, wb, idx);
}
function write_ws_xml_sheetpr(ws, wb, idx, opts, o) {
	var needed = false;
	var props = {}, payload = null;
	if(opts.bookType !== 'xlsx' && wb.vbaraw) {
		var cname = wb.SheetNames[idx];
		try { if(wb.Workbook) cname = wb.Workbook.Sheets[idx].CodeName || cname; } catch(e) {}
		needed = true;
		props.codeName = utf8write(escapexml(cname));
	}

	if(ws && ws["!outline"]) {
		var outlineprops = {summaryBelow:1, summaryRight:1};
		if(ws["!outline"].above) outlineprops.summaryBelow = 0;
		if(ws["!outline"].left) outlineprops.summaryRight = 0;
		payload = (payload||"") + writextag('outlinePr', null, outlineprops);
	}

	if(!needed && !payload) return;
	o[o.length] = (writextag('sheetPr', payload, props));
}

/* 18.3.1.85 sheetProtection CT_SheetProtection */
var sheetprot_deffalse = ["objects", "scenarios", "selectLockedCells", "selectUnlockedCells"];
var sheetprot_deftrue = [
	"formatColumns", "formatRows", "formatCells",
	"insertColumns", "insertRows", "insertHyperlinks",
	"deleteColumns", "deleteRows",
	"sort", "autoFilter", "pivotTables"
];
function write_ws_xml_protection(sp) {
	// algorithmName, hashValue, saltValue, spinCount
	var o = ({sheet:1});
	sheetprot_deffalse.forEach(function(n) { if(sp[n] != null && sp[n]) o[n] = "1"; });
	sheetprot_deftrue.forEach(function(n) { if(sp[n] != null && !sp[n]) o[n] = "0"; });
	/* TODO: algorithm */
	if(sp.password) o.password = crypto_CreatePasswordVerifier_Method1(sp.password).toString(16).toUpperCase();
	return writextag('sheetProtection', null, o);
}

function parse_ws_xml_hlinks(s, data, rels) {
	var dense = Array.isArray(s);
	for(var i = 0; i != data.length; ++i) {
		var val = parsexmltag(utf8read(data[i]), true);
		if(!val.ref) return;
		var rel = ((rels || {})['!id']||[])[val.id];
		if(rel) {
			val.Target = rel.Target;
			if(val.location) val.Target += "#"+unescapexml(val.location);
		} else {
			val.Target = "#" + unescapexml(val.location);
			rel = {Target: val.Target, TargetMode: 'Internal'};
		}
		val.Rel = rel;
		if(val.tooltip) { val.Tooltip = val.tooltip; delete val.tooltip; }
		var rng = safe_decode_range(val.ref);
		for(var R=rng.s.r;R<=rng.e.r;++R) for(var C=rng.s.c;C<=rng.e.c;++C) {
			var addr = encode_cell({c:C,r:R});
			if(dense) {
				if(!s[R]) s[R] = [];
				if(!s[R][C]) s[R][C] = {t:"z",v:undefined};
				s[R][C].l = val;
			} else {
				if(!s[addr]) s[addr] = {t:"z",v:undefined};
				s[addr].l = val;
			}
		}
	}
}

function parse_ws_xml_margins(margin) {
	var o = {};
	["left", "right", "top", "bottom", "header", "footer"].forEach(function(k) {
		if(margin[k]) o[k] = parseFloat(margin[k]);
	});
	return o;
}
function write_ws_xml_margins(margin) {
	default_margins(margin);
	return writextag('pageMargins', null, margin);
}

function parse_ws_xml_cols(columns, cols) {
	var seencol = false;
	for(var coli = 0; coli != cols.length; ++coli) {
		var coll = parsexmltag(cols[coli], true);
		if(coll.hidden) coll.hidden = parsexmlbool(coll.hidden);
		var colm=parseInt(coll.min, 10)-1, colM=parseInt(coll.max,10)-1;
		if(coll.outlineLevel) coll.level = (+coll.outlineLevel || 0);
		delete coll.min; delete coll.max; coll.width = +coll.width;
		if(!seencol && coll.width) { seencol = true; find_mdw_colw(coll.width); }
		process_col(coll);
		while(colm <= colM) columns[colm++] = dup(coll);
	}
}
function write_ws_xml_cols(ws, cols) {
	var o = ["<cols>"], col;
	for(var i = 0; i != cols.length; ++i) {
		if(!(col = cols[i])) continue;
		o[o.length] = (writextag('col', null, col_obj_w(i, col)));
	}
	o[o.length] = "</cols>";
	return o.join("");
}

function parse_ws_xml_autofilter(data) {
	var o = { ref: (data.match(/ref="([^"]*)"/)||[])[1]};
	return o;
}
function write_ws_xml_autofilter(data, ws, wb, idx) {
	var ref = typeof data.ref == "string" ? data.ref : encode_range(data.ref);
	if(!wb.Workbook) wb.Workbook = ({Sheets:[]});
	if(!wb.Workbook.Names) wb.Workbook.Names = [];
	var names = wb.Workbook.Names;
	var range = decode_range(ref);
	if(range.s.r == range.e.r) { range.e.r = decode_range(ws["!ref"]).e.r; ref = encode_range(range); }
	for(var i = 0; i < names.length; ++i) {
		var name = names[i];
		if(name.Name != '_xlnm._FilterDatabase') continue;
		if(name.Sheet != idx) continue;
		name.Ref = formula_quote_sheet_name(wb.SheetNames[idx]) + "!" + fix_range(ref); break;
	}
	if(i == names.length) names.push({ Name: '_xlnm._FilterDatabase', Sheet: idx, Ref: "'" + wb.SheetNames[idx] + "'!" + ref  });
	return writextag("autoFilter", null, {ref:ref});
}

/* 18.3.1.88 sheetViews CT_SheetViews */
/* 18.3.1.87 sheetView CT_SheetView */
var sviewregex = /<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/?>/g;
function parse_ws_xml_sheetviews(data, wb) {
	if(!wb.Views) wb.Views = [{}];
	(data.match(sviewregex)||[]).forEach(function(r, i) {
		var tag = parsexmltag(r);
		// $FlowIgnore
		if(!wb.Views[i]) wb.Views[i] = {};
		// $FlowIgnore
		if(+tag.zoomScale) wb.Views[i].zoom = +tag.zoomScale;
		// $FlowIgnore
		if(tag.rightToLeft && parsexmlbool(tag.rightToLeft)) wb.Views[i].RTL = true;
	});
}
function write_ws_xml_sheetviews(ws, opts, idx, wb) {
	var sview = ({workbookViewId:"0"});
	// $FlowIgnore
	if((((wb||{}).Workbook||{}).Views||[])[0]) sview.rightToLeft = wb.Workbook.Views[0].RTL ? "1" : "0";
	return writextag("sheetViews", writextag("sheetView", null, sview), {});
}

function write_ws_xml_cell(cell, ref, ws, opts) {
	if(cell.c) ws['!comments'].push([ref, cell.c]);
	if((cell.v === undefined || cell.t === "z" && !(opts||{}).sheetStubs) && typeof cell.f !== "string" && typeof cell.z == "undefined") return "";
	var vv = "";
	var oldt = cell.t, oldv = cell.v;
	if(cell.t !== "z") switch(cell.t) {
		case 'b': vv = cell.v ? "1" : "0"; break;
		case 'n': vv = ''+cell.v; break;
		case 'e': vv = BErr[cell.v]; break;
		case 'd':
			if(opts && opts.cellDates) vv = parseDate(cell.v, -1).toISOString();
			else {
				cell = dup(cell);
				cell.t = 'n';
				vv = ''+(cell.v = datenum(parseDate(cell.v)));
			}
			if(typeof cell.z === 'undefined') cell.z = table_fmt[14];
			break;
		default: vv = cell.v; break;
	}
	var v = (cell.t == "z" || cell.v == null)? "" : writetag('v', escapexml(vv)), o = ({r:ref});
	/* TODO: cell style */
	var os = get_cell_style(opts.cellXfs, cell, opts);
	if(os !== 0) o.s = os;
	switch(cell.t) {
		case 'n': break;
		case 'd': o.t = "d"; break;
		case 'b': o.t = "b"; break;
		case 'e': o.t = "e"; break;
		case 'z': break;
		default: if(cell.v == null) { delete cell.t; break; }
			if(cell.v.length > 32767) throw new Error("Text length must not exceed 32767 characters");
			if(opts && opts.bookSST) {
				v = writetag('v', ''+get_sst_id(opts.Strings, cell.v, opts.revStrings));
				o.t = "s"; break;
			}
			else o.t = "str"; break;
	}
	if(cell.t != oldt) { cell.t = oldt; cell.v = oldv; }
	if(typeof cell.f == "string" && cell.f) {
		var ff = cell.F && cell.F.slice(0, ref.length) == ref ? {t:"array", ref:cell.F} : null;
		v = writextag('f', escapexml(cell.f), ff) + (cell.v != null ? v : "");
	}
	if(cell.l) {
		cell.l.display = escapexml(vv);
		ws['!links'].push([ref, cell.l]);
	}
	if(cell.D) o.cm = 1;
	return writextag('c', v, o);
}

var parse_ws_xml_data = (function() {
	var cellregex = /<(?:\w+:)?c[ \/>]/, rowregex = /<\/(?:\w+:)?row>/;
	var rregex = /r=["']([^"']*)["']/, isregex = /<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/;
	var refregex = /ref=["']([^"']*)["']/;
	var match_v = matchtag("v"), match_f = matchtag("f");

return function parse_ws_xml_data(sdata, s, opts, guess, themes, styles) {
	var ri = 0, x = "", cells = [], cref = [], idx=0, i=0, cc=0, d="", p;
	var tag, tagr = 0, tagc = 0;
	var sstr, ftag;
	var fmtid = 0, fillid = 0;
	var do_format = Array.isArray(styles.CellXf), cf;
	var arrayf = [];
	var sharedf = [];
	var dense = Array.isArray(s);
	var rows = [], rowobj = {}, rowrite = false;
	var sheetStubs = !!opts.sheetStubs;
	for(var marr = sdata.split(rowregex), mt = 0, marrlen = marr.length; mt != marrlen; ++mt) {
		x = marr[mt].trim();
		var xlen = x.length;
		if(xlen === 0) continue;

		/* 18.3.1.73 row CT_Row */
		var rstarti = 0;
		outa: for(ri = 0; ri < xlen; ++ri) switch(/*x.charCodeAt(ri)*/x[ri]) {
			case ">" /*62*/:
				if(/*x.charCodeAt(ri-1) != 47*/x[ri-1] != "/") { ++ri; break outa; }
				if(opts && opts.cellStyles) {
					// TODO: avoid duplication
					tag = parsexmltag(x.slice(rstarti,ri), true);
					tagr = tag.r != null ? parseInt(tag.r, 10) : tagr+1; tagc = -1;
					if(opts.sheetRows && opts.sheetRows < tagr) continue;
					rowobj = {}; rowrite = false;
					if(tag.ht) { rowrite = true; rowobj.hpt = parseFloat(tag.ht); rowobj.hpx = pt2px(rowobj.hpt); }
					if(tag.hidden && parsexmlbool(tag.hidden)) { rowrite = true; rowobj.hidden = true; }
					if(tag.outlineLevel != null) { rowrite = true; rowobj.level = +tag.outlineLevel; }
					if(rowrite) rows[tagr-1] = rowobj;
				}
				break;
			case "<" /*60*/: rstarti = ri; break;
		}
		if(rstarti >= ri) break;
		tag = parsexmltag(x.slice(rstarti,ri), true);
		tagr = tag.r != null ? parseInt(tag.r, 10) : tagr+1; tagc = -1;
		if(opts.sheetRows && opts.sheetRows < tagr) continue;
		if(guess.s.r > tagr - 1) guess.s.r = tagr - 1;
		if(guess.e.r < tagr - 1) guess.e.r = tagr - 1;

		if(opts && opts.cellStyles) {
			rowobj = {}; rowrite = false;
			if(tag.ht) { rowrite = true; rowobj.hpt = parseFloat(tag.ht); rowobj.hpx = pt2px(rowobj.hpt); }
			if(tag.hidden && parsexmlbool(tag.hidden)) { rowrite = true; rowobj.hidden = true; }
			if(tag.outlineLevel != null) { rowrite = true; rowobj.level = +tag.outlineLevel; }
			if(rowrite) rows[tagr-1] = rowobj;
		}

		/* 18.3.1.4 c CT_Cell */
		cells = x.slice(ri).split(cellregex);
		for(var rslice = 0; rslice != cells.length; ++rslice) if(cells[rslice].trim().charAt(0) != "<") break;
		cells = cells.slice(rslice);
		for(ri = 0; ri != cells.length; ++ri) {
			x = cells[ri].trim();
			if(x.length === 0) continue;
			cref = x.match(rregex); idx = ri; i=0; cc=0;
			x = "<c " + (x.slice(0,1)=="<"?">":"") + x;
			if(cref != null && cref.length === 2) {
				idx = 0; d=cref[1];
				for(i=0; i != d.length; ++i) {
					if((cc=d.charCodeAt(i)-64) < 1 || cc > 26) break;
					idx = 26*idx + cc;
				}
				--idx;
				tagc = idx;
			} else ++tagc;
			for(i = 0; i != x.length; ++i) if(x.charCodeAt(i) === 62) break; ++i;
			tag = parsexmltag(x.slice(0,i), true);
			if(!tag.r) tag.r = encode_cell({r:tagr-1, c:tagc});
			d = x.slice(i);
			p = ({t:""});

			if((cref=d.match(match_v))!= null && cref[1] !== '') p.v=unescapexml(cref[1]);
			if(opts.cellFormula) {
				if((cref=d.match(match_f))!= null && cref[1] !== '') {
					/* TODO: match against XLSXFutureFunctions */
					p.f=unescapexml(utf8read(cref[1]), true);
					if(!opts.xlfn) p.f = _xlfn(p.f);
					if(cref[0].indexOf('t="array"') > -1) {
						p.F = (d.match(refregex)||[])[1];
						if(p.F.indexOf(":") > -1) arrayf.push([safe_decode_range(p.F), p.F]);
					} else if(cref[0].indexOf('t="shared"') > -1) {
						// TODO: parse formula
						ftag = parsexmltag(cref[0]);
						var ___f = unescapexml(utf8read(cref[1]));
						if(!opts.xlfn) ___f = _xlfn(___f);
						sharedf[parseInt(ftag.si, 10)] = [ftag, ___f, tag.r];
					}
				} else if((cref=d.match(/<f[^>]*\/>/))) {
					ftag = parsexmltag(cref[0]);
					if(sharedf[ftag.si]) p.f = shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][2]/*[0].ref*/, tag.r);
				}
				/* TODO: factor out contains logic */
				var _tag = decode_cell(tag.r);
				for(i = 0; i < arrayf.length; ++i)
					if(_tag.r >= arrayf[i][0].s.r && _tag.r <= arrayf[i][0].e.r)
						if(_tag.c >= arrayf[i][0].s.c && _tag.c <= arrayf[i][0].e.c)
							p.F = arrayf[i][1];
			}

			if(tag.t == null && p.v === undefined) {
				if(p.f || p.F) {
					p.v = 0; p.t = "n";
				} else if(!sheetStubs) continue;
				else p.t = "z";
			}
			else p.t = tag.t || "n";
			if(guess.s.c > tagc) guess.s.c = tagc;
			if(guess.e.c < tagc) guess.e.c = tagc;
			/* 18.18.11 t ST_CellType */
			switch(p.t) {
				case 'n':
					if(p.v == "" || p.v == null) {
						if(!sheetStubs) continue;
						p.t = 'z';
					} else p.v = parseFloat(p.v);
					break;
				case 's':
					if(typeof p.v == 'undefined') {
						if(!sheetStubs) continue;
						p.t = 'z';
					} else {
						sstr = strs[parseInt(p.v, 10)];
						p.v = sstr.t;
						p.r = sstr.r;
						if(opts.cellHTML) p.h = sstr.h;
					}
					break;
				case 'str':
					p.t = "s";
					p.v = (p.v!=null) ? unescapexml(utf8read(p.v), true) : '';
					if(opts.cellHTML) p.h = escapehtml(p.v);
					break;
				case 'inlineStr':
					cref = d.match(isregex);
					p.t = 's';
					if(cref != null && (sstr = parse_si(cref[1]))) {
						p.v = sstr.t;
						if(opts.cellHTML) p.h = sstr.h;
					} else p.v = "";
					break;
				case 'b': p.v = parsexmlbool(p.v); break;
				case 'd':
					if(opts.cellDates) p.v = parseDate(p.v, 1);
					else { p.v = datenum(parseDate(p.v, 1)); p.t = 'n'; }
					break;
				/* error string in .w, number in .v */
				case 'e':
					if(!opts || opts.cellText !== false) p.w = p.v;
					p.v = RBErr[p.v]; break;
			}
			/* formatting */
			fmtid = fillid = 0;
			cf = null;
			if(do_format && tag.s !== undefined) {
				cf = styles.CellXf[tag.s];
				if(cf != null) {
					if(cf.numFmtId != null) fmtid = cf.numFmtId;
					if(opts.cellStyles) {
						if(cf.fillId != null) fillid = cf.fillId;
					}
				}
			}
			safe_format(p, fmtid, fillid, opts, themes, styles);
			if(opts.cellDates && do_format && p.t == 'n' && fmt_is_date(table_fmt[fmtid])) { p.t = 'd'; p.v = numdate(p.v); }
			if(tag.cm && opts.xlmeta) {
				var cm = (opts.xlmeta.Cell||[])[+tag.cm-1];
				if(cm && cm.type == 'XLDAPR') p.D = true;
			}
			if(dense) {
				var _r = decode_cell(tag.r);
				if(!s[_r.r]) s[_r.r] = [];
				s[_r.r][_r.c] = p;
			} else s[tag.r] = p;
		}
	}
	if(rows.length > 0) s['!rows'] = rows;
}; })();

function write_ws_xml_data(ws, opts, idx, wb) {
	var o = [], r = [], range = safe_decode_range(ws['!ref']), cell="", ref, rr = "", cols = [], R=0, C=0, rows = ws['!rows'];
	var dense = Array.isArray(ws);
	var params = ({r:rr}), row, height = -1;
	for(C = range.s.c; C <= range.e.c; ++C) cols[C] = encode_col(C);
	for(R = range.s.r; R <= range.e.r; ++R) {
		r = [];
		rr = encode_row(R);
		for(C = range.s.c; C <= range.e.c; ++C) {
			ref = cols[C] + rr;
			var _cell = dense ? (ws[R]||[])[C]: ws[ref];
			if(_cell === undefined) continue;
			if((cell = write_ws_xml_cell(_cell, ref, ws, opts, idx, wb)) != null) r.push(cell);
		}
		if(r.length > 0 || (rows && rows[R])) {
			params = ({r:rr});
			if(rows && rows[R]) {
				row = rows[R];
				if(row.hidden) params.hidden = 1;
				height = -1;
				if(row.hpx) height = px2pt(row.hpx);
				else if(row.hpt) height = row.hpt;
				if(height > -1) { params.ht = height; params.customHeight = 1; }
				if(row.level) { params.outlineLevel = row.level; }
			}
			o[o.length] = (writextag('row', r.join(""), params));
		}
	}
	if(rows) for(; R < rows.length; ++R) {
		if(rows && rows[R]) {
			params = ({r:R+1});
			row = rows[R];
			if(row.hidden) params.hidden = 1;
			height = -1;
			if (row.hpx) height = px2pt(row.hpx);
			else if (row.hpt) height = row.hpt;
			if (height > -1) { params.ht = height; params.customHeight = 1; }
			if (row.level) { params.outlineLevel = row.level; }
			o[o.length] = (writextag('row', "", params));
		}
	}
	return o.join("");
}

function write_ws_xml(idx, opts, wb, rels) {
	var o = [XML_HEADER, writextag('worksheet', null, {
		'xmlns': XMLNS_main[0],
		'xmlns:r': XMLNS.r
	})];
	var s = wb.SheetNames[idx], sidx = 0, rdata = "";
	var ws = wb.Sheets[s];
	if(ws == null) ws = {};
	var ref = ws['!ref'] || 'A1';
	var range = safe_decode_range(ref);
	if(range.e.c > 0x3FFF || range.e.r > 0xFFFFF) {
		if(opts.WTF) throw new Error("Range " + ref + " exceeds format limit A1:XFD1048576");
		range.e.c = Math.min(range.e.c, 0x3FFF);
		range.e.r = Math.min(range.e.c, 0xFFFFF);
		ref = encode_range(range);
	}
	if(!rels) rels = {};
	ws['!comments'] = [];
	var _drawing = [];

	write_ws_xml_sheetpr(ws, wb, idx, opts, o);

	o[o.length] = (writextag('dimension', null, {'ref': ref}));

	o[o.length] = write_ws_xml_sheetviews(ws, opts, idx, wb);

	/* TODO: store in WB, process styles */
	if(opts.sheetFormat) o[o.length] = (writextag('sheetFormatPr', null, {
		defaultRowHeight:opts.sheetFormat.defaultRowHeight||'16',
		baseColWidth:opts.sheetFormat.baseColWidth||'10',
		outlineLevelRow:opts.sheetFormat.outlineLevelRow||'7'
	}));

	if(ws['!cols'] != null && ws['!cols'].length > 0) o[o.length] = (write_ws_xml_cols(ws, ws['!cols']));

	o[sidx = o.length] = '<sheetData/>';
	ws['!links'] = [];
	if(ws['!ref'] != null) {
		rdata = write_ws_xml_data(ws, opts, idx, wb, rels);
		if(rdata.length > 0) o[o.length] = (rdata);
	}
	if(o.length>sidx+1) { o[o.length] = ('</sheetData>'); o[sidx]=o[sidx].replace("/>",">"); }

	/* sheetCalcPr */

	if(ws['!protect']) o[o.length] = write_ws_xml_protection(ws['!protect']);

	/* protectedRanges */
	/* scenarios */

	if(ws['!autofilter'] != null) o[o.length] = write_ws_xml_autofilter(ws['!autofilter'], ws, wb, idx);

	/* sortState */
	/* dataConsolidate */
	/* customSheetViews */

	if(ws['!merges'] != null && ws['!merges'].length > 0) o[o.length] = (write_ws_xml_merges(ws['!merges']));

	/* phoneticPr */
	/* conditionalFormatting */
	/* dataValidations */

	var relc = -1, rel, rId = -1;
	if(ws['!links'].length > 0) {
		o[o.length] = "<hyperlinks>";
ws['!links'].forEach(function(l) {
			if(!l[1].Target) return;
			rel = ({"ref":l[0]});
			if(l[1].Target.charAt(0) != "#") {
				rId = add_rels(rels, -1, escapexml(l[1].Target).replace(/#.*$/, ""), RELS.HLINK);
				rel["r:id"] = "rId"+rId;
			}
			if((relc = l[1].Target.indexOf("#")) > -1) rel.location = escapexml(l[1].Target.slice(relc+1));
			if(l[1].Tooltip) rel.tooltip = escapexml(l[1].Tooltip);
			rel.display = l[1].display;
			o[o.length] = writextag("hyperlink",null,rel);
		});
		o[o.length] = "</hyperlinks>";
	}
	delete ws['!links'];

	/* printOptions */

	if(ws['!margins'] != null) o[o.length] =  write_ws_xml_margins(ws['!margins']);

	/* pageSetup */
	/* headerFooter */
	/* rowBreaks */
	/* colBreaks */
	/* customProperties */
	/* cellWatches */

	if(!opts || opts.ignoreEC || (opts.ignoreEC == (void 0))) o[o.length] = writetag("ignoredErrors", writextag("ignoredError", null, {numberStoredAsText:1, sqref:ref}));

	/* smartTags */

	if(_drawing.length > 0) {
		rId = add_rels(rels, -1, "../drawings/drawing" + (idx+1) + ".xml", RELS.DRAW);
		o[o.length] = writextag("drawing", null, {"r:id":"rId" + rId});
		ws['!drawing'] = _drawing;
	}

	if(ws['!comments'].length > 0) {
		rId = add_rels(rels, -1, "../drawings/vmlDrawing" + (idx+1) + ".vml", RELS.VML);
		o[o.length] = writextag("legacyDrawing", null, {"r:id":"rId" + rId});
		ws['!legacy'] = rId;
	}

	/* legacyDrawingHF */
	/* picture */
	/* oleObjects */
	/* controls */
	/* webPublishItems */
	/* tableParts */
	/* extLst */

	if(o.length>1) { o[o.length] = ('</worksheet>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}

/* [MS-XLSB] 2.4.726 BrtRowHdr */
function parse_BrtRowHdr(data, length) {
	var z = ({});
	var tgt = data.l + length;
	z.r = data.read_shift(4);
	data.l += 4; // TODO: ixfe
	var miyRw = data.read_shift(2);
	data.l += 1; // TODO: top/bot padding
	var flags = data.read_shift(1);
	data.l = tgt;
	if(flags & 0x07) z.level = flags & 0x07;
	if(flags & 0x10) z.hidden = true;
	if(flags & 0x20) z.hpt = miyRw / 20;
	return z;
}
function write_BrtRowHdr(R, range, ws) {
	var o = new_buf(17+8*16);
	var row = (ws['!rows']||[])[R]||{};
	o.write_shift(4, R);

	o.write_shift(4, 0); /* TODO: ixfe */

	var miyRw = 0x0140;
	if(row.hpx) miyRw = px2pt(row.hpx) * 20;
	else if(row.hpt) miyRw = row.hpt * 20;
	o.write_shift(2, miyRw);

	o.write_shift(1, 0); /* top/bot padding */

	var flags = 0x0;
	if(row.level) flags |= row.level;
	if(row.hidden) flags |= 0x10;
	if(row.hpx || row.hpt) flags |= 0x20;
	o.write_shift(1, flags);

	o.write_shift(1, 0); /* phonetic guide */

	/* [MS-XLSB] 2.5.8 BrtColSpan explains the mechanism */
	var ncolspan = 0, lcs = o.l;
	o.l += 4;

	var caddr = {r:R, c:0};
	for(var i = 0; i < 16; ++i) {
		if((range.s.c > ((i+1) << 10)) || (range.e.c < (i << 10))) continue;
		var first = -1, last = -1;
		for(var j = (i<<10); j < ((i+1)<<10); ++j) {
			caddr.c = j;
			var cell = Array.isArray(ws) ? (ws[caddr.r]||[])[caddr.c] : ws[encode_cell(caddr)];
			if(cell) { if(first < 0) first = j; last = j; }
		}
		if(first < 0) continue;
		++ncolspan;
		o.write_shift(4, first);
		o.write_shift(4, last);
	}

	var l = o.l;
	o.l = lcs;
	o.write_shift(4, ncolspan);
	o.l = l;

	return o.length > o.l ? o.slice(0, o.l) : o;
}
function write_row_header(ba, ws, range, R) {
	var o = write_BrtRowHdr(R, range, ws);
	if((o.length > 17) || (ws['!rows']||[])[R]) write_record(ba, 0x0000 /* BrtRowHdr */, o);
}

/* [MS-XLSB] 2.4.820 BrtWsDim */
var parse_BrtWsDim = parse_UncheckedRfX;
var write_BrtWsDim = write_UncheckedRfX;

/* [MS-XLSB] 2.4.821 BrtWsFmtInfo */
function parse_BrtWsFmtInfo() {
}
//function write_BrtWsFmtInfo(ws, o) { }

/* [MS-XLSB] 2.4.823 BrtWsProp */
function parse_BrtWsProp(data, length) {
	var z = {};
	var f = data[data.l]; ++data.l;
	z.above = !(f & 0x40);
	z.left  = !(f & 0x80);
	/* TODO: pull flags */
	data.l += 18;
	z.name = parse_XLSBCodeName(data, length - 19);
	return z;
}
function write_BrtWsProp(str, outl, o) {
	if(o == null) o = new_buf(84+4*str.length);
	var f = 0xC0;
	if(outl) {
		if(outl.above) f &= ~0x40;
		if(outl.left)  f &= ~0x80;
	}
	o.write_shift(1, f);
	for(var i = 1; i < 3; ++i) o.write_shift(1,0);
	write_BrtColor({auto:1}, o);
	o.write_shift(-4,-1);
	o.write_shift(-4,-1);
	write_XLSBCodeName(str, o);
	return o.slice(0, o.l);
}

/* [MS-XLSB] 2.4.306 BrtCellBlank */
function parse_BrtCellBlank(data) {
	var cell = parse_XLSBCell(data);
	return [cell];
}
function write_BrtCellBlank(cell, ncell, o) {
	if(o == null) o = new_buf(8);
	return write_XLSBCell(ncell, o);
}
function parse_BrtShortBlank(data) {
	var cell = parse_XLSBShortCell(data);
	return [cell];
}
function write_BrtShortBlank(cell, ncell, o) {
	if(o == null) o = new_buf(4);
	return write_XLSBShortCell(ncell, o);
}

/* [MS-XLSB] 2.4.307 BrtCellBool */
function parse_BrtCellBool(data) {
	var cell = parse_XLSBCell(data);
	var fBool = data.read_shift(1);
	return [cell, fBool, 'b'];
}
function write_BrtCellBool(cell, ncell, o) {
	if(o == null) o = new_buf(9);
	write_XLSBCell(ncell, o);
	o.write_shift(1, cell.v ? 1 : 0);
	return o;
}
function parse_BrtShortBool(data) {
	var cell = parse_XLSBShortCell(data);
	var fBool = data.read_shift(1);
	return [cell, fBool, 'b'];
}
function write_BrtShortBool(cell, ncell, o) {
	if(o == null) o = new_buf(5);
	write_XLSBShortCell(ncell, o);
	o.write_shift(1, cell.v ? 1 : 0);
	return o;
}

/* [MS-XLSB] 2.4.308 BrtCellError */
function parse_BrtCellError(data) {
	var cell = parse_XLSBCell(data);
	var bError = data.read_shift(1);
	return [cell, bError, 'e'];
}
function write_BrtCellError(cell, ncell, o) {
	if(o == null) o = new_buf(9);
	write_XLSBCell(ncell, o);
	o.write_shift(1, cell.v);
	return o;
}
function parse_BrtShortError(data) {
	var cell = parse_XLSBShortCell(data);
	var bError = data.read_shift(1);
	return [cell, bError, 'e'];
}
function write_BrtShortError(cell, ncell, o) {
	if(o == null) o = new_buf(8);
	write_XLSBShortCell(ncell, o);
	o.write_shift(1, cell.v);
	o.write_shift(2, 0);
	o.write_shift(1, 0);
	return o;
}


/* [MS-XLSB] 2.4.311 BrtCellIsst */
function parse_BrtCellIsst(data) {
	var cell = parse_XLSBCell(data);
	var isst = data.read_shift(4);
	return [cell, isst, 's'];
}
function write_BrtCellIsst(cell, ncell, o) {
	if(o == null) o = new_buf(12);
	write_XLSBCell(ncell, o);
	o.write_shift(4, ncell.v);
	return o;
}
function parse_BrtShortIsst(data) {
	var cell = parse_XLSBShortCell(data);
	var isst = data.read_shift(4);
	return [cell, isst, 's'];
}
function write_BrtShortIsst(cell, ncell, o) {
	if(o == null) o = new_buf(8);
	write_XLSBShortCell(ncell, o);
	o.write_shift(4, ncell.v);
	return o;
}

/* [MS-XLSB] 2.4.313 BrtCellReal */
function parse_BrtCellReal(data) {
	var cell = parse_XLSBCell(data);
	var value = parse_Xnum(data);
	return [cell, value, 'n'];
}
function write_BrtCellReal(cell, ncell, o) {
	if(o == null) o = new_buf(16);
	write_XLSBCell(ncell, o);
	write_Xnum(cell.v, o);
	return o;
}
function parse_BrtShortReal(data) {
	var cell = parse_XLSBShortCell(data);
	var value = parse_Xnum(data);
	return [cell, value, 'n'];
}
function write_BrtShortReal(cell, ncell, o) {
	if(o == null) o = new_buf(12);
	write_XLSBShortCell(ncell, o);
	write_Xnum(cell.v, o);
	return o;
}

/* [MS-XLSB] 2.4.314 BrtCellRk */
function parse_BrtCellRk(data) {
	var cell = parse_XLSBCell(data);
	var value = parse_RkNumber(data);
	return [cell, value, 'n'];
}
function write_BrtCellRk(cell, ncell, o) {
	if(o == null) o = new_buf(12);
	write_XLSBCell(ncell, o);
	write_RkNumber(cell.v, o);
	return o;
}
function parse_BrtShortRk(data) {
	var cell = parse_XLSBShortCell(data);
	var value = parse_RkNumber(data);
	return [cell, value, 'n'];
}
function write_BrtShortRk(cell, ncell, o) {
	if(o == null) o = new_buf(8);
	write_XLSBShortCell(ncell, o);
	write_RkNumber(cell.v, o);
	return o;
}

/* [MS-XLSB] 2.4.323 BrtCellRString */
function parse_BrtCellRString(data) {
	var cell = parse_XLSBCell(data);
	var value = parse_RichStr(data);
	return [cell, value, 'is'];
}

/* [MS-XLSB] 2.4.317 BrtCellSt */
function parse_BrtCellSt(data) {
	var cell = parse_XLSBCell(data);
	var value = parse_XLWideString(data);
	return [cell, value, 'str'];
}
function write_BrtCellSt(cell, ncell, o) {
	var data = cell.v == null ? "" : String(cell.v);
	if(o == null) o = new_buf(12 + 4 * cell.v.length);
	write_XLSBCell(ncell, o);
	write_XLWideString(data, o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}
function parse_BrtShortSt(data) {
	var cell = parse_XLSBShortCell(data);
	var value = parse_XLWideString(data);
	return [cell, value, 'str'];
}
function write_BrtShortSt(cell, ncell, o) {
	var data = cell.v == null ? "" : String(cell.v);
	if(o == null) o = new_buf(8 + 4 * data.length);
	write_XLSBShortCell(ncell, o);
	write_XLWideString(data, o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.653 BrtFmlaBool */
function parse_BrtFmlaBool(data, length, opts) {
	var end = data.l + length;
	var cell = parse_XLSBCell(data);
	cell.r = opts['!row'];
	var value = data.read_shift(1);
	var o = [cell, value, 'b'];
	if(opts.cellFormula) {
		data.l += 2;
		var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
		o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
	}
	else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.654 BrtFmlaError */
function parse_BrtFmlaError(data, length, opts) {
	var end = data.l + length;
	var cell = parse_XLSBCell(data);
	cell.r = opts['!row'];
	var value = data.read_shift(1);
	var o = [cell, value, 'e'];
	if(opts.cellFormula) {
		data.l += 2;
		var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
		o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
	}
	else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.655 BrtFmlaNum */
function parse_BrtFmlaNum(data, length, opts) {
	var end = data.l + length;
	var cell = parse_XLSBCell(data);
	cell.r = opts['!row'];
	var value = parse_Xnum(data);
	var o = [cell, value, 'n'];
	if(opts.cellFormula) {
		data.l += 2;
		var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
		o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
	}
	else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.656 BrtFmlaString */
function parse_BrtFmlaString(data, length, opts) {
	var end = data.l + length;
	var cell = parse_XLSBCell(data);
	cell.r = opts['!row'];
	var value = parse_XLWideString(data);
	var o = [cell, value, 'str'];
	if(opts.cellFormula) {
		data.l += 2;
		var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
		o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
	}
	else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.682 BrtMergeCell */
var parse_BrtMergeCell = parse_UncheckedRfX;
var write_BrtMergeCell = write_UncheckedRfX;
/* [MS-XLSB] 2.4.107 BrtBeginMergeCells */
function write_BrtBeginMergeCells(cnt, o) {
	if(o == null) o = new_buf(4);
	o.write_shift(4, cnt);
	return o;
}

/* [MS-XLSB] 2.4.662 BrtHLink */
function parse_BrtHLink(data, length) {
	var end = data.l + length;
	var rfx = parse_UncheckedRfX(data, 16);
	var relId = parse_XLNullableWideString(data);
	var loc = parse_XLWideString(data);
	var tooltip = parse_XLWideString(data);
	var display = parse_XLWideString(data);
	data.l = end;
	var o = ({rfx:rfx, relId:relId, loc:loc, display:display});
	if(tooltip) o.Tooltip = tooltip;
	return o;
}
function write_BrtHLink(l, rId) {
	var o = new_buf(50+4*(l[1].Target.length + (l[1].Tooltip || "").length));
	write_UncheckedRfX({s:decode_cell(l[0]), e:decode_cell(l[0])}, o);
	write_RelID("rId" + rId, o);
	var locidx = l[1].Target.indexOf("#");
	var loc = locidx == -1 ? "" : l[1].Target.slice(locidx+1);
	write_XLWideString(loc || "", o);
	write_XLWideString(l[1].Tooltip || "", o);
	write_XLWideString("", o);
	return o.slice(0, o.l);
}

/* [MS-XLSB] 2.4.692 BrtPane */
function parse_BrtPane(/*data, length, opts*/) {
}

/* [MS-XLSB] 2.4.6 BrtArrFmla */
function parse_BrtArrFmla(data, length, opts) {
	var end = data.l + length;
	var rfx = parse_RfX(data, 16);
	var fAlwaysCalc = data.read_shift(1);
	var o = [rfx]; o[2] = fAlwaysCalc;
	if(opts.cellFormula) {
		var formula = parse_XLSBArrayParsedFormula(data, end - data.l, opts);
		o[1] = formula;
	} else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.750 BrtShrFmla */
function parse_BrtShrFmla(data, length, opts) {
	var end = data.l + length;
	var rfx = parse_UncheckedRfX(data, 16);
	var o = [rfx];
	if(opts.cellFormula) {
		var formula = parse_XLSBSharedParsedFormula(data, end - data.l, opts);
		o[1] = formula;
		data.l = end;
	} else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.323 BrtColInfo */
/* TODO: once XLS ColInfo is set, combine the functions */
function write_BrtColInfo(C, col, o) {
	if(o == null) o = new_buf(18);
	var p = col_obj_w(C, col);
	o.write_shift(-4, C);
	o.write_shift(-4, C);
	o.write_shift(4, (p.width || 10) * 256);
	o.write_shift(4, 0/*ixfe*/); // style
	var flags = 0;
	if(col.hidden) flags |= 0x01;
	if(typeof p.width == 'number') flags |= 0x02;
	if(col.level) flags |= (col.level << 8);
	o.write_shift(2, flags); // bit flag
	return o;
}

/* [MS-XLSB] 2.4.678 BrtMargins */
var BrtMarginKeys = ["left","right","top","bottom","header","footer"];
function parse_BrtMargins(data) {
	var margins = ({});
	BrtMarginKeys.forEach(function(k) { margins[k] = parse_Xnum(data, 8); });
	return margins;
}
function write_BrtMargins(margins, o) {
	if(o == null) o = new_buf(6*8);
	default_margins(margins);
	BrtMarginKeys.forEach(function(k) { write_Xnum((margins)[k], o); });
	return o;
}

/* [MS-XLSB] 2.4.299 BrtBeginWsView */
function parse_BrtBeginWsView(data) {
	var f = data.read_shift(2);
	data.l += 28;
	return { RTL: f & 0x20 };
}
function write_BrtBeginWsView(ws, Workbook, o) {
	if(o == null) o = new_buf(30);
	var f = 0x39c;
	if((((Workbook||{}).Views||[])[0]||{}).RTL) f |= 0x20;
	o.write_shift(2, f); // bit flag
	o.write_shift(4, 0);
	o.write_shift(4, 0); // view first row
	o.write_shift(4, 0); // view first col
	o.write_shift(1, 0); // gridline color ICV
	o.write_shift(1, 0);
	o.write_shift(2, 0);
	o.write_shift(2, 100); // zoom scale
	o.write_shift(2, 0);
	o.write_shift(2, 0);
	o.write_shift(2, 0);
	o.write_shift(4, 0); // workbook view id
	return o;
}

/* [MS-XLSB] 2.4.309 BrtCellIgnoreEC */
function write_BrtCellIgnoreEC(ref) {
	var o = new_buf(24);
	o.write_shift(4, 4);
	o.write_shift(4, 1);
	write_UncheckedRfX(ref, o);
	return o;
}

/* [MS-XLSB] 2.4.748 BrtSheetProtection */
function write_BrtSheetProtection(sp, o) {
	if(o == null) o = new_buf(16*4+2);
	o.write_shift(2, sp.password ? crypto_CreatePasswordVerifier_Method1(sp.password) : 0);
	o.write_shift(4, 1); // this record should not be written if no protection
	[
		["objects",             false], // fObjects
		["scenarios",           false], // fScenarios
		["formatCells",          true], // fFormatCells
		["formatColumns",        true], // fFormatColumns
		["formatRows",           true], // fFormatRows
		["insertColumns",        true], // fInsertColumns
		["insertRows",           true], // fInsertRows
		["insertHyperlinks",     true], // fInsertHyperlinks
		["deleteColumns",        true], // fDeleteColumns
		["deleteRows",           true], // fDeleteRows
		["selectLockedCells",   false], // fSelLockedCells
		["sort",                 true], // fSort
		["autoFilter",           true], // fAutoFilter
		["pivotTables",          true], // fPivotTables
		["selectUnlockedCells", false]  // fSelUnlockedCells
	].forEach(function(n) {
if(n[1]) o.write_shift(4, sp[n[0]] != null && !sp[n[0]] ? 1 : 0);
		else      o.write_shift(4, sp[n[0]] != null && sp[n[0]] ? 0 : 1);
	});
	return o;
}

function parse_BrtDVal(/*data, length, opts*/) {
}
function parse_BrtDVal14(/*data, length, opts*/) {
}
/* [MS-XLSB] 2.1.7.61 Worksheet */
function parse_ws_bin(data, _opts, idx, rels, wb, themes, styles) {
	if(!data) return data;
	var opts = _opts || {};
	if(!rels) rels = {'!id':{}};
	if(DENSE != null && opts.dense == null) opts.dense = DENSE;
	var s = (opts.dense ? [] : {});

	var ref;
	var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };

	var state = [];
	var pass = false, end = false;
	var row, p, cf, R, C, addr, sstr, rr, cell;
	var merges = [];
	opts.biff = 12;
	opts['!row'] = 0;

	var ai = 0, af = false;

	var arrayf = [];
	var sharedf = {};
	var supbooks = opts.supbooks || wb.supbooks || ([[]]);
	supbooks.sharedf = sharedf;
	supbooks.arrayf = arrayf;
	supbooks.SheetNames = wb.SheetNames || wb.Sheets.map(function(x) { return x.name; });
	if(!opts.supbooks) {
		opts.supbooks = supbooks;
		if(wb.Names) for(var i = 0; i < wb.Names.length; ++i) supbooks[0][i+1] = wb.Names[i];
	}

	var colinfo = [], rowinfo = [];
	var seencol = false;

	XLSBRecordEnum[0x0010] = { n:"BrtShortReal", f:parse_BrtShortReal };

	var cm, vm;

	recordhopper(data, function ws_parse(val, RR, RT) {
		if(end) return;
		switch(RT) {
			case 0x0094: /* 'BrtWsDim' */
				ref = val; break;
			case 0x0000: /* 'BrtRowHdr' */
				row = val;
				if(opts.sheetRows && opts.sheetRows <= row.r) end=true;
				rr = encode_row(R = row.r);
				opts['!row'] = row.r;
				if(val.hidden || val.hpt || val.level != null) {
					if(val.hpt) val.hpx = pt2px(val.hpt);
					rowinfo[val.r] = val;
				}
				break;

			case 0x0002: /* 'BrtCellRk' */
			case 0x0003: /* 'BrtCellError' */
			case 0x0004: /* 'BrtCellBool' */
			case 0x0005: /* 'BrtCellReal' */
			case 0x0006: /* 'BrtCellSt' */
			case 0x0007: /* 'BrtCellIsst' */
			case 0x0008: /* 'BrtFmlaString' */
			case 0x0009: /* 'BrtFmlaNum' */
			case 0x000A: /* 'BrtFmlaBool' */
			case 0x000B: /* 'BrtFmlaError' */
			case 0x000D: /* 'BrtShortRk' */
			case 0x000E: /* 'BrtShortError' */
			case 0x000F: /* 'BrtShortBool' */
			case 0x0010: /* 'BrtShortReal' */
			case 0x0011: /* 'BrtShortSt' */
			case 0x0012: /* 'BrtShortIsst' */
			case 0x003E: /* 'BrtCellRString' */
				p = ({t:val[2]});
				switch(val[2]) {
					case 'n': p.v = val[1]; break;
					case 's': sstr = strs[val[1]]; p.v = sstr.t; p.r = sstr.r; break;
					case 'b': p.v = val[1] ? true : false; break;
					case 'e': p.v = val[1]; if(opts.cellText !== false) p.w = BErr[p.v]; break;
					case 'str': p.t = 's'; p.v = val[1]; break;
					case 'is': p.t = 's'; p.v = val[1].t; break;
				}
				if((cf = styles.CellXf[val[0].iStyleRef])) safe_format(p,cf.numFmtId,null,opts, themes, styles);
				C = val[0].c == -1 ? C + 1 : val[0].c;
				if(opts.dense) { if(!s[R]) s[R] = []; s[R][C] = p; }
				else s[encode_col(C) + rr] = p;
				if(opts.cellFormula) {
					af = false;
					for(ai = 0; ai < arrayf.length; ++ai) {
						var aii = arrayf[ai];
						if(row.r >= aii[0].s.r && row.r <= aii[0].e.r)
							if(C >= aii[0].s.c && C <= aii[0].e.c) {
								p.F = encode_range(aii[0]); af = true;
							}
					}
					if(!af && val.length > 3) p.f = val[3];
				}

				if(refguess.s.r > row.r) refguess.s.r = row.r;
				if(refguess.s.c > C) refguess.s.c = C;
				if(refguess.e.r < row.r) refguess.e.r = row.r;
				if(refguess.e.c < C) refguess.e.c = C;
				if(opts.cellDates && cf && p.t == 'n' && fmt_is_date(table_fmt[cf.numFmtId])) {
					var _d = SSF_parse_date_code(p.v); if(_d) { p.t = 'd'; p.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
				}
				if(cm) {
					if(cm.type == 'XLDAPR') p.D = true;
					cm = void 0;
				}
				if(vm) vm = void 0;
				break;

			case 0x0001: /* 'BrtCellBlank' */
			case 0x000C: /* 'BrtShortBlank' */
				if(!opts.sheetStubs || pass) break;
				p = ({t:'z',v:void 0});
				C = val[0].c == -1 ? C + 1 : val[0].c;
				if(opts.dense) { if(!s[R]) s[R] = []; s[R][C] = p; }
				else s[encode_col(C) + rr] = p;
				if(refguess.s.r > row.r) refguess.s.r = row.r;
				if(refguess.s.c > C) refguess.s.c = C;
				if(refguess.e.r < row.r) refguess.e.r = row.r;
				if(refguess.e.c < C) refguess.e.c = C;
				if(cm) {
					if(cm.type == 'XLDAPR') p.D = true;
					cm = void 0;
				}
				if(vm) vm = void 0;
				break;

			case 0x00B0: /* 'BrtMergeCell' */
				merges.push(val); break;

			case 0x0031: { /* 'BrtCellMeta' */
				cm = ((opts.xlmeta||{}).Cell||[])[val-1];
			} break;

			case 0x01EE: /* 'BrtHLink' */
				var rel = rels['!id'][val.relId];
				if(rel) {
					val.Target = rel.Target;
					if(val.loc) val.Target += "#"+val.loc;
					val.Rel = rel;
				} else if(val.relId == '') {
					val.Target = "#" + val.loc;
				}
				for(R=val.rfx.s.r;R<=val.rfx.e.r;++R) for(C=val.rfx.s.c;C<=val.rfx.e.c;++C) {
					if(opts.dense) {
						if(!s[R]) s[R] = [];
						if(!s[R][C]) s[R][C] = {t:'z',v:undefined};
						s[R][C].l = val;
					} else {
						addr = encode_cell({c:C,r:R});
						if(!s[addr]) s[addr] = {t:'z',v:undefined};
						s[addr].l = val;
					}
				}
				break;

			case 0x01AA: /* 'BrtArrFmla' */
				if(!opts.cellFormula) break;
				arrayf.push(val);
				cell = ((opts.dense ? s[R][C] : s[encode_col(C) + rr]));
				cell.f = stringify_formula(val[1], refguess, {r:row.r, c:C}, supbooks, opts);
				cell.F = encode_range(val[0]);
				break;
			case 0x01AB: /* 'BrtShrFmla' */
				if(!opts.cellFormula) break;
				sharedf[encode_cell(val[0].s)] = val[1];
				cell = (opts.dense ? s[R][C] : s[encode_col(C) + rr]);
				cell.f = stringify_formula(val[1], refguess, {r:row.r, c:C}, supbooks, opts);
				break;

			/* identical to 'ColInfo' in XLS */
			case 0x003C: /* 'BrtColInfo' */
				if(!opts.cellStyles) break;
				while(val.e >= val.s) {
					colinfo[val.e--] = { width: val.w/256, hidden: !!(val.flags & 0x01), level: val.level };
					if(!seencol) { seencol = true; find_mdw_colw(val.w/256); }
					process_col(colinfo[val.e+1]);
				}
				break;

			case 0x00A1: /* 'BrtBeginAFilter' */
				s['!autofilter'] = { ref:encode_range(val) };
				break;

			case 0x01DC: /* 'BrtMargins' */
				s['!margins'] = val;
				break;

			case 0x0093: /* 'BrtWsProp' */
				if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
				if(val.name) wb.Sheets[idx].CodeName = val.name;
				if(val.above || val.left) s['!outline'] = { above: val.above, left: val.left };
				break;

			case 0x0089: /* 'BrtBeginWsView' */
				if(!wb.Views) wb.Views = [{}];
				if(!wb.Views[0]) wb.Views[0] = {};
				if(val.RTL) wb.Views[0].RTL = true;
				break;

			case 0x01E5: /* 'BrtWsFmtInfo' */
				break;

			case 0x0040: /* 'BrtDVal' */
			case 0x041D: /* 'BrtDVal14' */
				break;

			case 0x0097: /* 'BrtPane' */
				break;
			case 0x0098: /* 'BrtSel' */
			case 0x00AF: /* 'BrtAFilterDateGroupItem' */
			case 0x0284: /* 'BrtActiveX' */
			case 0x0271: /* 'BrtBigName' */
			case 0x0232: /* 'BrtBkHim' */
			case 0x018C: /* 'BrtBrk' */
			case 0x0458: /* 'BrtCFIcon' */
			case 0x047A: /* 'BrtCFRuleExt' */
			case 0x01D7: /* 'BrtCFVO' */
			case 0x041A: /* 'BrtCFVO14' */
			case 0x0289: /* 'BrtCellIgnoreEC' */
			case 0x0451: /* 'BrtCellIgnoreEC14' */
			case 0x024D: /* 'BrtCellSmartTagProperty' */
			case 0x025F: /* 'BrtCellWatch' */
			case 0x0234: /* 'BrtColor' */
			case 0x041F: /* 'BrtColor14' */
			case 0x00A8: /* 'BrtColorFilter' */
			case 0x00AE: /* 'BrtCustomFilter' */
			case 0x049C: /* 'BrtCustomFilter14' */
			case 0x01F3: /* 'BrtDRef' */
			case 0x01FB: /* 'BrtDXF' */
			case 0x0226: /* 'BrtDrawing' */
			case 0x00AB: /* 'BrtDynamicFilter' */
			case 0x00A7: /* 'BrtFilter' */
			case 0x0499: /* 'BrtFilter14' */
			case 0x00A9: /* 'BrtIconFilter' */
			case 0x049D: /* 'BrtIconFilter14' */
			case 0x0227: /* 'BrtLegacyDrawing' */
			case 0x0228: /* 'BrtLegacyDrawingHF' */
			case 0x0295: /* 'BrtListPart' */
			case 0x027F: /* 'BrtOleObject' */
			case 0x01DE: /* 'BrtPageSetup' */
			case 0x0219: /* 'BrtPhoneticInfo' */
			case 0x01DD: /* 'BrtPrintOptions' */
			case 0x0218: /* 'BrtRangeProtection' */
			case 0x044F: /* 'BrtRangeProtection14' */
			case 0x02A8: /* 'BrtRangeProtectionIso' */
			case 0x0450: /* 'BrtRangeProtectionIso14' */
			case 0x0400: /* 'BrtRwDescent' */
			case 0x0297: /* 'BrtSheetCalcProp' */
			case 0x0217: /* 'BrtSheetProtection' */
			case 0x02A6: /* 'BrtSheetProtectionIso' */
			case 0x01F8: /* 'BrtSlc' */
			case 0x0413: /* 'BrtSparkline' */
			case 0x01AC: /* 'BrtTable' */
			case 0x00AA: /* 'BrtTop10Filter' */
			case 0x0C00: /* 'BrtUid' */
			case 0x0032: /* 'BrtValueMeta' */
			case 0x0816: /* 'BrtWebExtension' */
			case 0x0415: /* 'BrtWsFmtInfoEx14' */
				break;

			case 0x0023: /* 'BrtFRTBegin' */
				pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				pass = false; break;
			case 0x0025: /* 'BrtACBegin' */
				state.push(RT); pass = true; break;
			case 0x0026: /* 'BrtACEnd' */
				state.pop(); pass = false; break;

			default:
				if(RR.T){/* empty */}
				else if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
		}
	}, opts);

	delete opts.supbooks;
	delete opts['!row'];

	if(!s["!ref"] && (refguess.s.r < 2000000 || ref && (ref.e.r > 0 || ref.e.c > 0 || ref.s.r > 0 || ref.s.c > 0))) s["!ref"] = encode_range(ref || refguess);
	if(opts.sheetRows && s["!ref"]) {
		var tmpref = safe_decode_range(s["!ref"]);
		if(opts.sheetRows <= +tmpref.e.r) {
			tmpref.e.r = opts.sheetRows - 1;
			if(tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
			if(tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
			if(tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
			if(tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
			s["!fullref"] = s["!ref"];
			s["!ref"] = encode_range(tmpref);
		}
	}
	if(merges.length > 0) s["!merges"] = merges;
	if(colinfo.length > 0) s["!cols"] = colinfo;
	if(rowinfo.length > 0) s["!rows"] = rowinfo;
	return s;
}

/* TODO: something useful -- this is a stub */
function write_ws_bin_cell(ba, cell, R, C, opts, ws, last_seen) {
	var o = ({r:R, c:C});
	if(cell.c) ws['!comments'].push([encode_cell(o), cell.c]);
	if(cell.v === undefined) return false;
	var vv = "";
	switch(cell.t) {
		case 'b': vv = cell.v ? "1" : "0"; break;
		case 'd': // no BrtCellDate :(
			cell = dup(cell);
			cell.z = cell.z || table_fmt[14];
			cell.v = datenum(parseDate(cell.v)); cell.t = 'n';
			break;
		/* falls through */
		case 'n': case 'e': vv = ''+cell.v; break;
		default: vv = cell.v; break;
	}
	/* TODO: cell style */
	o.s = get_cell_style(opts.cellXfs, cell, opts);
	if(cell.l) ws['!links'].push([encode_cell(o), cell.l]);
	switch(cell.t) {
		case 's': case 'str':
			if(opts.bookSST) {
				vv = get_sst_id(opts.Strings, (cell.v == null ? "" : String(cell.v)), opts.revStrings);
				o.t = "s"; o.v = vv;
				if(last_seen) write_record(ba, 0x0012 /* BrtShortIsst */, write_BrtShortIsst(cell, o));
				else write_record(ba, 0x0007 /* BrtCellIsst */, write_BrtCellIsst(cell, o));
			} else {
				o.t = "str";
				if(last_seen) write_record(ba, 0x0011 /* BrtShortSt */, write_BrtShortSt(cell, o));
				else write_record(ba, 0x0006 /* BrtCellSt */, write_BrtCellSt(cell, o));
			}
			return true;
		case 'n':
			/* TODO: determine threshold for Real vs RK */
			if(cell.v == (cell.v | 0) && cell.v > -1000 && cell.v < 1000) {
				if(last_seen) write_record(ba, 0x000D /* BrtShortRk */, write_BrtShortRk(cell, o));
				else write_record(ba, 0x0002 /* BrtCellRk */, write_BrtCellRk(cell, o));
			} else {
				if(last_seen) write_record(ba, 0x0010 /* BrtShortReal */, write_BrtShortReal(cell, o));
				else write_record(ba, 0x0005 /* BrtCellReal */, write_BrtCellReal(cell, o));
			} return true;
		case 'b':
			o.t = "b";
			if(last_seen) write_record(ba, 0x000F /* BrtShortBool */, write_BrtShortBool(cell, o));
			else write_record(ba, 0x0004 /* BrtCellBool */, write_BrtCellBool(cell, o));
			return true;
		case 'e':
			o.t = "e";
			if(last_seen) write_record(ba, 0x000E /* BrtShortError */, write_BrtShortError(cell, o));
			else write_record(ba, 0x0003 /* BrtCellError */, write_BrtCellError(cell, o));
			return true;
	}
	if(last_seen) write_record(ba, 0x000C /* BrtShortBlank */, write_BrtShortBlank(cell, o));
	else write_record(ba, 0x0001 /* BrtCellBlank */, write_BrtCellBlank(cell, o));
	return true;
}

function write_CELLTABLE(ba, ws, idx, opts) {
	var range = safe_decode_range(ws['!ref'] || "A1"), ref, rr = "", cols = [];
	write_record(ba, 0x0091 /* BrtBeginSheetData */);
	var dense = Array.isArray(ws);
	var cap = range.e.r;
	if(ws['!rows']) cap = Math.max(range.e.r, ws['!rows'].length - 1);
	for(var R = range.s.r; R <= cap; ++R) {
		rr = encode_row(R);
		/* [ACCELLTABLE] */
		/* BrtRowHdr */
		write_row_header(ba, ws, range, R);
		var last_seen = false;
		if(R <= range.e.r) for(var C = range.s.c; C <= range.e.c; ++C) {
			/* *16384CELL */
			if(R === range.s.r) cols[C] = encode_col(C);
			ref = cols[C] + rr;
			var cell = dense ? (ws[R]||[])[C] : ws[ref];
			if(!cell) { last_seen = false; continue; }
			/* write cell */
			last_seen = write_ws_bin_cell(ba, cell, R, C, opts, ws, last_seen);
		}
	}
	write_record(ba, 0x0092 /* BrtEndSheetData */);
}

function write_MERGECELLS(ba, ws) {
	if(!ws || !ws['!merges']) return;
	write_record(ba, 0x00B1 /* BrtBeginMergeCells */, write_BrtBeginMergeCells(ws['!merges'].length));
	ws['!merges'].forEach(function(m) { write_record(ba, 0x00B0 /* BrtMergeCell */, write_BrtMergeCell(m)); });
	write_record(ba, 0x00B2 /* BrtEndMergeCells */);
}

function write_COLINFOS(ba, ws) {
	if(!ws || !ws['!cols']) return;
	write_record(ba, 0x0186 /* BrtBeginColInfos */);
	ws['!cols'].forEach(function(m, i) { if(m) write_record(ba, 0x003C /* 'BrtColInfo' */, write_BrtColInfo(i, m)); });
	write_record(ba, 0x0187 /* BrtEndColInfos */);
}

function write_IGNOREECS(ba, ws) {
	if(!ws || !ws['!ref']) return;
	write_record(ba, 0x0288 /* BrtBeginCellIgnoreECs */);
	write_record(ba, 0x0289 /* BrtCellIgnoreEC */, write_BrtCellIgnoreEC(safe_decode_range(ws['!ref'])));
	write_record(ba, 0x028A /* BrtEndCellIgnoreECs */);
}

function write_HLINKS(ba, ws, rels) {
	/* *BrtHLink */
	ws['!links'].forEach(function(l) {
		if(!l[1].Target) return;
		var rId = add_rels(rels, -1, l[1].Target.replace(/#.*$/, ""), RELS.HLINK);
		write_record(ba, 0x01EE /* BrtHLink */, write_BrtHLink(l, rId));
	});
	delete ws['!links'];
}
function write_LEGACYDRAWING(ba, ws, idx, rels) {
	/* [BrtLegacyDrawing] */
	if(ws['!comments'].length > 0) {
		var rId = add_rels(rels, -1, "../drawings/vmlDrawing" + (idx+1) + ".vml", RELS.VML);
		write_record(ba, 0x0227 /* BrtLegacyDrawing */, write_RelID("rId" + rId));
		ws['!legacy'] = rId;
	}
}

function write_AUTOFILTER(ba, ws, wb, idx) {
	if(!ws['!autofilter']) return;
	var data = ws['!autofilter'];
	var ref = typeof data.ref === "string" ? data.ref : encode_range(data.ref);

	/* Update FilterDatabase defined name for the worksheet */
	if(!wb.Workbook) wb.Workbook = ({Sheets:[]});
	if(!wb.Workbook.Names) wb.Workbook.Names = [];
	var names = wb.Workbook.Names;
	var range = decode_range(ref);
	if(range.s.r == range.e.r) { range.e.r = decode_range(ws["!ref"]).e.r; ref = encode_range(range); }
	for(var i = 0; i < names.length; ++i) {
		var name = names[i];
		if(name.Name != '_xlnm._FilterDatabase') continue;
		if(name.Sheet != idx) continue;
		name.Ref = formula_quote_sheet_name(wb.SheetNames[idx]) + "!" + fix_range(ref); break;
	}
	if(i == names.length) names.push({ Name: '_xlnm._FilterDatabase', Sheet: idx, Ref: formula_quote_sheet_name(wb.SheetNames[idx]) + "!" + fix_range(ref)  });

	write_record(ba, 0x00A1 /* BrtBeginAFilter */, write_UncheckedRfX(safe_decode_range(ref)));
	/* *FILTERCOLUMN */
	/* [SORTSTATE] */
	/* BrtEndAFilter */
	write_record(ba, 0x00A2 /* BrtEndAFilter */);
}

function write_WSVIEWS2(ba, ws, Workbook) {
	write_record(ba, 0x0085 /* BrtBeginWsViews */);
	{ /* 1*WSVIEW2 */
		/* [ACUID] */
		write_record(ba, 0x0089 /* BrtBeginWsView */, write_BrtBeginWsView(ws, Workbook));
		/* [BrtPane] */
		/* *4BrtSel */
		/* *4SXSELECT */
		/* *FRT */
		write_record(ba, 0x008A /* BrtEndWsView */);
	}
	/* *FRT */
	write_record(ba, 0x0086 /* BrtEndWsViews */);
}

function write_WSFMTINFO() {
	/* [ACWSFMTINFO] */
	// write_record(ba, 0x01E5 /* BrtWsFmtInfo */, write_BrtWsFmtInfo(ws));
}

function write_SHEETPROTECT(ba, ws) {
	if(!ws['!protect']) return;
	/* [BrtSheetProtectionIso] */
	write_record(ba, 0x0217 /* BrtSheetProtection */, write_BrtSheetProtection(ws['!protect']));
}

function write_ws_bin(idx, opts, wb, rels) {
	var ba = buf_array();
	var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
	var c = s; try { if(wb && wb.Workbook) c = wb.Workbook.Sheets[idx].CodeName || c; } catch(e) {}
	var r = safe_decode_range(ws['!ref'] || "A1");
	if(r.e.c > 0x3FFF || r.e.r > 0xFFFFF) {
		if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:XFD1048576");
		r.e.c = Math.min(r.e.c, 0x3FFF);
		r.e.r = Math.min(r.e.c, 0xFFFFF);
	}
	ws['!links'] = [];
	/* passed back to write_zip and removed there */
	ws['!comments'] = [];
	write_record(ba, 0x0081 /* BrtBeginSheet */);
	if(wb.vbaraw || ws['!outline']) write_record(ba, 0x0093 /* BrtWsProp */, write_BrtWsProp(c, ws['!outline']));
	write_record(ba, 0x0094 /* BrtWsDim */, write_BrtWsDim(r));
	write_WSVIEWS2(ba, ws, wb.Workbook);
	write_WSFMTINFO(ba, ws);
	write_COLINFOS(ba, ws, idx, opts, wb);
	write_CELLTABLE(ba, ws, idx, opts, wb);
	/* [BrtSheetCalcProp] */
	write_SHEETPROTECT(ba, ws);
	/* *([BrtRangeProtectionIso] BrtRangeProtection) */
	/* [SCENMAN] */
	write_AUTOFILTER(ba, ws, wb, idx);
	/* [SORTSTATE] */
	/* [DCON] */
	/* [USERSHVIEWS] */
	write_MERGECELLS(ba, ws);
	/* [BrtPhoneticInfo] */
	/* *CONDITIONALFORMATTING */
	/* [DVALS] */
	write_HLINKS(ba, ws, rels);
	/* [BrtPrintOptions] */
	if(ws['!margins']) write_record(ba, 0x01DC /* BrtMargins */, write_BrtMargins(ws['!margins']));
	/* [BrtPageSetup] */
	/* [HEADERFOOTER] */
	/* [RWBRK] */
	/* [COLBRK] */
	/* *BrtBigName */
	/* [CELLWATCHES] */
	if(!opts || opts.ignoreEC || (opts.ignoreEC == (void 0))) write_IGNOREECS(ba, ws);
	/* [SMARTTAGS] */
	/* [BrtDrawing] */
	write_LEGACYDRAWING(ba, ws, idx, rels);
	/* [BrtLegacyDrawingHF] */
	/* [BrtBkHim] */
	/* [OLEOBJECTS] */
	/* [ACTIVEXCONTROLS] */
	/* [WEBPUBITEMS] */
	/* [LISTPARTS] */
	/* FRTWORKSHEET */
	write_record(ba, 0x0082 /* BrtEndSheet */);
	return ba.end();
}
function parse_Cache(data) {
	var col = [];
	var num = data.match(/^<c:numCache>/);
	var f;

	/* 21.2.2.150 pt CT_NumVal */
	(data.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/mg)||[]).forEach(function(pt) {
		var q = pt.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);
		if(!q) return;
		col[+q[1]] = num ? +q[2] : q[2];
	});

	/* 21.2.2.71 formatCode CT_Xstring */
	var nf = unescapexml((data.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/) || ["","General"])[1]);

	(data.match(/<c:f>(.*?)<\/c:f>/mg)||[]).forEach(function(F) { f = F.replace(/<.*?>/g,""); });

	return [col, nf, f];
}

/* 21.2 DrawingML - Charts */
function parse_chart(data, name, opts, rels, wb, csheet) {
	var cs = ((csheet || {"!type":"chart"}));
	if(!data) return csheet;
	/* 21.2.2.27 chart CT_Chart */

	var C = 0, R = 0, col = "A";
	var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };

	/* 21.2.2.120 numCache CT_NumData */
	(data.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm)||[]).forEach(function(nc) {
		var cache = parse_Cache(nc);
		refguess.s.r = refguess.s.c = 0;
		refguess.e.c = C;
		col = encode_col(C);
		cache[0].forEach(function(n,i) {
			cs[col + encode_row(i)] = {t:'n', v:n, z:cache[1] };
			R = i;
		});
		if(refguess.e.r < R) refguess.e.r = R;
		++C;
	});
	if(C > 0) cs["!ref"] = encode_range(refguess);
	return cs;
}
/* 18.3 Worksheets also covers Chartsheets */
function parse_cs_xml(data, opts, idx, rels, wb) {
	if(!data) return data;
	/* 18.3.1.12 chartsheet CT_ChartSheet */
	if(!rels) rels = {'!id':{}};
	var s = ({'!type':"chart", '!drawel':null, '!rel':""});
	var m;

	/* 18.3.1.83 sheetPr CT_ChartsheetPr */
	var sheetPr = data.match(sheetprregex);
	if(sheetPr) parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);

	/* 18.3.1.36 drawing CT_Drawing */
	if((m = data.match(/drawing r:id="(.*?)"/))) s['!rel'] = m[1];

	if(rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
	return s;
}
//function write_cs_xml(idx, opts, wb, rels) {
//	var o = [XML_HEADER, writextag('chartsheet', null, {
//		'xmlns': XMLNS_main[0],
//		'xmlns:r': XMLNS.r
//	})];
//	o[o.length] = writextag("drawing", null, {"r:id": "rId1"});
//	add_rels(rels, -1, "../drawings/drawing" + (idx+1) + ".xml", RELS.DRAW);
//	if(o.length>2) { o[o.length] = ('</chartsheet>'); o[1]=o[1].replace("/>",">"); }
//	return o.join("");
//}

/* [MS-XLSB] 2.4.331 BrtCsProp */
function parse_BrtCsProp(data, length) {
	data.l += 10;
	var name = parse_XLWideString(data, length - 10);
	return { name: name };
}

/* [MS-XLSB] 2.1.7.7 Chart Sheet */
function parse_cs_bin(data, opts, idx, rels, wb) {
	if(!data) return data;
	if(!rels) rels = {'!id':{}};
	var s = {'!type':"chart", '!drawel':null, '!rel':""};
	var state = [];
	var pass = false;
	recordhopper(data, function cs_parse(val, R, RT) {
		switch(RT) {

			case 0x0226: /* 'BrtDrawing' */
				s['!rel'] = val; break;

			case 0x028B: /* 'BrtCsProp' */
				if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
				if(val.name) wb.Sheets[idx].CodeName = val.name;
				break;

			case 0x0232: /* 'BrtBkHim' */
			case 0x028C: /* 'BrtCsPageSetup' */
			case 0x029D: /* 'BrtCsProtection' */
			case 0x02A7: /* 'BrtCsProtectionIso' */
			case 0x0227: /* 'BrtLegacyDrawing' */
			case 0x0228: /* 'BrtLegacyDrawingHF' */
			case 0x01DC: /* 'BrtMargins' */
			case 0x0C00: /* 'BrtUid' */
				break;

			case 0x0023: /* 'BrtFRTBegin' */
				pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				pass = false; break;
			case 0x0025: /* 'BrtACBegin' */
				state.push(RT); break;
			case 0x0026: /* 'BrtACEnd' */
				state.pop(); break;

			default:
				if(R.T > 0) state.push(RT);
				else if(R.T < 0) state.pop();
				else if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
		}
	}, opts);

	if(rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
	return s;
}
//function write_cs_bin() {
//	var ba = buf_array();
//	write_record(ba, 0x0081 /* BrtBeginSheet */);
//	/* [BrtCsProp] */
//	/* CSVIEWS */
//	/* [[BrtCsProtectionIso] BrtCsProtection] */
//	/* [USERCSVIEWS] */
//	/* [BrtMargins] */
//	/* [BrtCsPageSetup] */
//	/* [HEADERFOOTER] */
//	/* BrtDrawing */
//	/* [BrtLegacyDrawing] */
//	/* [BrtLegacyDrawingHF] */
//	/* [BrtBkHim] */
//	/* [WEBPUBITEMS] */
//	/* FRTCHARTSHEET */
//	write_record(ba, 0x0082 /* BrtEndSheet */);
//	return ba.end();
//}
/* 18.2.28 (CT_WorkbookProtection) Defaults */
var WBPropsDef = [
	['allowRefreshQuery',           false, "bool"],
	['autoCompressPictures',        true,  "bool"],
	['backupFile',                  false, "bool"],
	['checkCompatibility',          false, "bool"],
	['CodeName',                    ''],
	['date1904',                    false, "bool"],
	['defaultThemeVersion',         0,      "int"],
	['filterPrivacy',               false, "bool"],
	['hidePivotFieldList',          false, "bool"],
	['promptedSolutions',           false, "bool"],
	['publishItems',                false, "bool"],
	['refreshAllConnections',       false, "bool"],
	['saveExternalLinkValues',      true,  "bool"],
	['showBorderUnselectedTables',  true,  "bool"],
	['showInkAnnotation',           true,  "bool"],
	['showObjects',                 'all'],
	['showPivotChartFilter',        false, "bool"],
	['updateLinks', 'userSet']
];

/* 18.2.30 (CT_BookView) Defaults */
var WBViewDef = [
	['activeTab',                   0,      "int"],
	['autoFilterDateGrouping',      true,  "bool"],
	['firstSheet',                  0,      "int"],
	['minimized',                   false, "bool"],
	['showHorizontalScroll',        true,  "bool"],
	['showSheetTabs',               true,  "bool"],
	['showVerticalScroll',          true,  "bool"],
	['tabRatio',                    600,    "int"],
	['visibility',                  'visible']
	//window{Height,Width}, {x,y}Window
];

/* 18.2.19 (CT_Sheet) Defaults */
var SheetDef = [
	//['state', 'visible']
];

/* 18.2.2  (CT_CalcPr) Defaults */
var CalcPrDef = [
	['calcCompleted', 'true'],
	['calcMode', 'auto'],
	['calcOnSave', 'true'],
	['concurrentCalc', 'true'],
	['fullCalcOnLoad', 'false'],
	['fullPrecision', 'true'],
	['iterate', 'false'],
	['iterateCount', '100'],
	['iterateDelta', '0.001'],
	['refMode', 'A1']
];

/* 18.2.3 (CT_CustomWorkbookView) Defaults */
/*var CustomWBViewDef = [
	['autoUpdate', 'false'],
	['changesSavedWin', 'false'],
	['includeHiddenRowCol', 'true'],
	['includePrintSettings', 'true'],
	['maximized', 'false'],
	['minimized', 'false'],
	['onlySync', 'false'],
	['personalView', 'false'],
	['showComments', 'commIndicator'],
	['showFormulaBar', 'true'],
	['showHorizontalScroll', 'true'],
	['showObjects', 'all'],
	['showSheetTabs', 'true'],
	['showStatusbar', 'true'],
	['showVerticalScroll', 'true'],
	['tabRatio', '600'],
	['xWindow', '0'],
	['yWindow', '0']
];*/

function push_defaults_array(target, defaults) {
	for(var j = 0; j != target.length; ++j) { var w = target[j];
		for(var i=0; i != defaults.length; ++i) { var z = defaults[i];
			if(w[z[0]] == null) w[z[0]] = z[1];
			else switch(z[2]) {
			case "bool": if(typeof w[z[0]] == "string") w[z[0]] = parsexmlbool(w[z[0]]); break;
			case "int": if(typeof w[z[0]] == "string") w[z[0]] = parseInt(w[z[0]], 10); break;
			}
		}
	}
}
function push_defaults(target, defaults) {
	for(var i = 0; i != defaults.length; ++i) { var z = defaults[i];
		if(target[z[0]] == null) target[z[0]] = z[1];
		else switch(z[2]) {
			case "bool": if(typeof target[z[0]] == "string") target[z[0]] = parsexmlbool(target[z[0]]); break;
			case "int": if(typeof target[z[0]] == "string") target[z[0]] = parseInt(target[z[0]], 10); break;
		}
	}
}

function parse_wb_defaults(wb) {
	push_defaults(wb.WBProps, WBPropsDef);
	push_defaults(wb.CalcPr, CalcPrDef);

	push_defaults_array(wb.WBView, WBViewDef);
	push_defaults_array(wb.Sheets, SheetDef);

	_ssfopts.date1904 = parsexmlbool(wb.WBProps.date1904);
}

function safe1904(wb) {
	/* TODO: store date1904 somewhere else */
	if(!wb.Workbook) return "false";
	if(!wb.Workbook.WBProps) return "false";
	return parsexmlbool(wb.Workbook.WBProps.date1904) ? "true" : "false";
}

var badchars = ":][*?\/\\".split("");
function check_ws_name(n, safe) {
	if(n.length > 31) { if(safe) return false; throw new Error("Sheet names cannot exceed 31 chars"); }
	var _good = true;
	badchars.forEach(function(c) {
		if(n.indexOf(c) == -1) return;
		if(!safe) throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
		_good = false;
	});
	return _good;
}
function check_wb_names(N, S, codes) {
	N.forEach(function(n,i) {
		check_ws_name(n);
		for(var j = 0; j < i; ++j) if(n == N[j]) throw new Error("Duplicate Sheet Name: " + n);
		if(codes) {
			var cn = (S && S[i] && S[i].CodeName) || n;
			if(cn.charCodeAt(0) == 95 && cn.length > 22) throw new Error("Bad Code Name: Worksheet" + cn);
		}
	});
}
function check_wb(wb) {
	if(!wb || !wb.SheetNames || !wb.Sheets) throw new Error("Invalid Workbook");
	if(!wb.SheetNames.length) throw new Error("Workbook is empty");
	var Sheets = (wb.Workbook && wb.Workbook.Sheets) || [];
	check_wb_names(wb.SheetNames, Sheets, !!wb.vbaraw);
	for(var i = 0; i < wb.SheetNames.length; ++i) check_ws(wb.Sheets[wb.SheetNames[i]], wb.SheetNames[i], i);
	wb.SheetNames.forEach(function(n, i) {
		var ws = wb.Sheets[n];
		if(!ws || !ws["!autofilter"]) return;
		var DN;
		if(!wb.Workbook) wb.Workbook = {};
		if(!wb.Workbook.Names) wb.Workbook.Names = [];
		wb.Workbook.Names.forEach(function(dn) { if(dn.Name == "_xlnm._FilterDatabase" && dn.Sheet == i) DN = dn; });
		var nn = formula_quote_sheet_name(n) + "!" + fix_range(ws["!autofilter"].ref);
		if(DN) DN.Ref = nn;
		else wb.Workbook.Names.push({Name: "_xlnm._FilterDatabase", Sheet: i, Ref: nn});
	});
	/* TODO: validate workbook */
}
/* 18.2 Workbook */
var wbnsregex = /<\w+:workbook/;
function parse_wb_xml(data, opts) {
	if(!data) throw new Error("Could not find file");
	var wb = { AppVersion:{}, WBProps:{}, WBView:[], Sheets:[], CalcPr:{}, Names:[], xmlns: "" };
	var pass = false, xmlns = "xmlns";
	var dname = {}, dnstart = 0;
	data.replace(tagregex, function xml_wb(x, idx) {
		var y = parsexmltag(x);
		switch(strip_ns(y[0])) {
			case '<?xml': break;

			/* 18.2.27 workbook CT_Workbook 1 */
			case '<workbook':
				if(x.match(wbnsregex)) xmlns = "xmlns" + x.match(/<(\w+):/)[1];
				wb.xmlns = y[xmlns];
				break;
			case '</workbook>': break;

			/* 18.2.13 fileVersion CT_FileVersion ? */
			case '<fileVersion': delete y[0]; wb.AppVersion = y; break;
			case '<fileVersion/>': case '</fileVersion>': break;

			/* 18.2.12 fileSharing CT_FileSharing ? */
			case '<fileSharing':
				break;
			case '<fileSharing/>': break;

			/* 18.2.28 workbookPr CT_WorkbookPr ? */
			case '<workbookPr':
			case '<workbookPr/>':
				WBPropsDef.forEach(function(w) {
					if(y[w[0]] == null) return;
					switch(w[2]) {
						case "bool": wb.WBProps[w[0]] = parsexmlbool(y[w[0]]); break;
						case "int": wb.WBProps[w[0]] = parseInt(y[w[0]], 10); break;
						default: wb.WBProps[w[0]] = y[w[0]];
					}
				});
				if(y.codeName) wb.WBProps.CodeName = utf8read(y.codeName);
				break;
			case '</workbookPr>': break;

			/* 18.2.29 workbookProtection CT_WorkbookProtection ? */
			case '<workbookProtection':
				break;
			case '<workbookProtection/>': break;

			/* 18.2.1  bookViews CT_BookViews ? */
			case '<bookViews': case '<bookViews>': case '</bookViews>': break;
			/* 18.2.30   workbookView CT_BookView + */
			case '<workbookView': case '<workbookView/>': delete y[0]; wb.WBView.push(y); break;
			case '</workbookView>': break;

			/* 18.2.20 sheets CT_Sheets 1 */
			case '<sheets': case '<sheets>': case '</sheets>': break; // aggregate sheet
			/* 18.2.19   sheet CT_Sheet + */
			case '<sheet':
				switch(y.state) {
					case "hidden": y.Hidden = 1; break;
					case "veryHidden": y.Hidden = 2; break;
					default: y.Hidden = 0;
				}
				delete y.state;
				y.name = unescapexml(utf8read(y.name));
				delete y[0]; wb.Sheets.push(y); break;
			case '</sheet>': break;

			/* 18.2.15 functionGroups CT_FunctionGroups ? */
			case '<functionGroups': case '<functionGroups/>': break;
			/* 18.2.14   functionGroup CT_FunctionGroup + */
			case '<functionGroup': break;

			/* 18.2.9  externalReferences CT_ExternalReferences ? */
			case '<externalReferences': case '</externalReferences>': case '<externalReferences>': break;
			/* 18.2.8    externalReference CT_ExternalReference + */
			case '<externalReference': break;

			/* 18.2.6  definedNames CT_DefinedNames ? */
			case '<definedNames/>': break;
			case '<definedNames>': case '<definedNames': pass=true; break;
			case '</definedNames>': pass=false; break;
			/* 18.2.5    definedName CT_DefinedName + */
			case '<definedName': {
				dname = {};
				dname.Name = utf8read(y.name);
				if(y.comment) dname.Comment = y.comment;
				if(y.localSheetId) dname.Sheet = +y.localSheetId;
				if(parsexmlbool(y.hidden||"0")) dname.Hidden = true;
				dnstart = idx + x.length;
			}	break;
			case '</definedName>': {
				dname.Ref = unescapexml(utf8read(data.slice(dnstart, idx)));
				wb.Names.push(dname);
			} break;
			case '<definedName/>': break;

			/* 18.2.2  calcPr CT_CalcPr ? */
			case '<calcPr': delete y[0]; wb.CalcPr = y; break;
			case '<calcPr/>': delete y[0]; wb.CalcPr = y; break;
			case '</calcPr>': break;

			/* 18.2.16 oleSize CT_OleSize ? (ref required) */
			case '<oleSize': break;

			/* 18.2.4  customWorkbookViews CT_CustomWorkbookViews ? */
			case '<customWorkbookViews>': case '</customWorkbookViews>': case '<customWorkbookViews': break;
			/* 18.2.3  customWorkbookView CT_CustomWorkbookView + */
			case '<customWorkbookView': case '</customWorkbookView>': break;

			/* 18.2.18 pivotCaches CT_PivotCaches ? */
			case '<pivotCaches>': case '</pivotCaches>': case '<pivotCaches': break;
			/* 18.2.17 pivotCache CT_PivotCache ? */
			case '<pivotCache': break;

			/* 18.2.21 smartTagPr CT_SmartTagPr ? */
			case '<smartTagPr': case '<smartTagPr/>': break;

			/* 18.2.23 smartTagTypes CT_SmartTagTypes ? */
			case '<smartTagTypes': case '<smartTagTypes>': case '</smartTagTypes>': break;
			/* 18.2.22 smartTagType CT_SmartTagType ? */
			case '<smartTagType': break;

			/* 18.2.24 webPublishing CT_WebPublishing ? */
			case '<webPublishing': case '<webPublishing/>': break;

			/* 18.2.11 fileRecoveryPr CT_FileRecoveryPr ? */
			case '<fileRecoveryPr': case '<fileRecoveryPr/>': break;

			/* 18.2.26 webPublishObjects CT_WebPublishObjects ? */
			case '<webPublishObjects>': case '<webPublishObjects': case '</webPublishObjects>': break;
			/* 18.2.25 webPublishObject CT_WebPublishObject ? */
			case '<webPublishObject': break;

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': case '<extLst/>': break;
			/* 18.2.7  ext CT_Extension + */
			case '<ext': pass=true; break; //TODO: check with versions of excel
			case '</ext>': pass=false; break;

			/* Others */
			case '<ArchID': break;
			case '<AlternateContent':
			case '<AlternateContent>': pass=true; break;
			case '</AlternateContent>': pass=false; break;

			/* TODO */
			case '<revisionPtr': break;

			default: if(!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in workbook');
		}
		return x;
	});
	if(XMLNS_main.indexOf(wb.xmlns) === -1) throw new Error("Unknown Namespace: " + wb.xmlns);

	parse_wb_defaults(wb);

	return wb;
}

function write_wb_xml(wb) {
	var o = [XML_HEADER];
	o[o.length] = writextag('workbook', null, {
		'xmlns': XMLNS_main[0],
		//'xmlns:mx': XMLNS.mx,
		//'xmlns:s': XMLNS_main[0],
		'xmlns:r': XMLNS.r
	});

	var write_names = (wb.Workbook && (wb.Workbook.Names||[]).length > 0);

	/* fileVersion */
	/* fileSharing */

	var workbookPr = ({codeName:"ThisWorkbook"});
	if(wb.Workbook && wb.Workbook.WBProps) {
		WBPropsDef.forEach(function(x) {
if((wb.Workbook.WBProps[x[0]]) == null) return;
			if((wb.Workbook.WBProps[x[0]]) == x[1]) return;
			workbookPr[x[0]] = (wb.Workbook.WBProps[x[0]]);
		});
if(wb.Workbook.WBProps.CodeName) { workbookPr.codeName = wb.Workbook.WBProps.CodeName; delete workbookPr.CodeName; }
	}
	o[o.length] = (writextag('workbookPr', null, workbookPr));

	/* workbookProtection */

	var sheets = wb.Workbook && wb.Workbook.Sheets || [];
	var i = 0;

	/* bookViews only written if first worksheet is hidden */
	if(sheets && sheets[0] && !!sheets[0].Hidden) {
		o[o.length] = "<bookViews>";
		for(i = 0; i != wb.SheetNames.length; ++i) {
			if(!sheets[i]) break;
			if(!sheets[i].Hidden) break;
		}
		if(i == wb.SheetNames.length) i = 0;
		o[o.length] = '<workbookView firstSheet="' + i + '" activeTab="' + i + '"/>';
		o[o.length] = "</bookViews>";
	}

	o[o.length] = "<sheets>";
	for(i = 0; i != wb.SheetNames.length; ++i) {
		var sht = ({name:escapexml(wb.SheetNames[i].slice(0,31))});
		sht.sheetId = ""+(i+1);
		sht["r:id"] = "rId"+(i+1);
		if(sheets[i]) switch(sheets[i].Hidden) {
			case 1: sht.state = "hidden"; break;
			case 2: sht.state = "veryHidden"; break;
		}
		o[o.length] = (writextag('sheet',null,sht));
	}
	o[o.length] = "</sheets>";

	/* functionGroups */
	/* externalReferences */

	if(write_names) {
		o[o.length] = "<definedNames>";
		if(wb.Workbook && wb.Workbook.Names) wb.Workbook.Names.forEach(function(n) {
			var d = {name:n.Name};
			if(n.Comment) d.comment = n.Comment;
			if(n.Sheet != null) d.localSheetId = ""+n.Sheet;
			if(n.Hidden) d.hidden = "1";
			if(!n.Ref) return;
			o[o.length] = writextag('definedName', escapexml(n.Ref), d);
		});
		o[o.length] = "</definedNames>";
	}

	/* calcPr */
	/* oleSize */
	/* customWorkbookViews */
	/* pivotCaches */
	/* smartTagPr */
	/* smartTagTypes */
	/* webPublishing */
	/* fileRecoveryPr */
	/* webPublishObjects */
	/* extLst */

	if(o.length>2){ o[o.length] = '</workbook>'; o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* [MS-XLSB] 2.4.304 BrtBundleSh */
function parse_BrtBundleSh(data, length) {
	var z = {};
	z.Hidden = data.read_shift(4); //hsState ST_SheetState
	z.iTabID = data.read_shift(4);
	z.strRelID = parse_RelID(data,length-8);
	z.name = parse_XLWideString(data);
	return z;
}
function write_BrtBundleSh(data, o) {
	if(!o) o = new_buf(127);
	o.write_shift(4, data.Hidden);
	o.write_shift(4, data.iTabID);
	write_RelID(data.strRelID, o);
	write_XLWideString(data.name.slice(0,31), o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.815 BrtWbProp */
function parse_BrtWbProp(data, length) {
	var o = ({});
	var flags = data.read_shift(4);
	o.defaultThemeVersion = data.read_shift(4);
	var strName = (length > 8) ? parse_XLWideString(data) : "";
	if(strName.length > 0) o.CodeName = strName;
	o.autoCompressPictures = !!(flags & 0x10000);
	o.backupFile = !!(flags & 0x40);
	o.checkCompatibility = !!(flags & 0x1000);
	o.date1904 = !!(flags & 0x01);
	o.filterPrivacy = !!(flags & 0x08);
	o.hidePivotFieldList = !!(flags & 0x400);
	o.promptedSolutions = !!(flags & 0x10);
	o.publishItems = !!(flags & 0x800);
	o.refreshAllConnections = !!(flags & 0x40000);
	o.saveExternalLinkValues = !!(flags & 0x80);
	o.showBorderUnselectedTables = !!(flags & 0x04);
	o.showInkAnnotation = !!(flags & 0x20);
	o.showObjects = ["all", "placeholders", "none"][(flags >> 13) & 0x03];
	o.showPivotChartFilter = !!(flags & 0x8000);
	o.updateLinks = ["userSet", "never", "always"][(flags >> 8) & 0x03];
	return o;
}
function write_BrtWbProp(data, o) {
	if(!o) o = new_buf(72);
	var flags = 0;
	if(data) {
		/* TODO: mirror parse_BrtWbProp fields */
		if(data.date1904) flags |= 0x01;
		if(data.filterPrivacy) flags |= 0x08;
	}
	o.write_shift(4, flags);
	o.write_shift(4, 0);
	write_XLSBCodeName(data && data.CodeName || "ThisWorkbook", o);
	return o.slice(0, o.l);
}

function parse_BrtFRTArchID$(data, length) {
	var o = {};
	data.read_shift(4);
	o.ArchID = data.read_shift(4);
	data.l += length - 8;
	return o;
}

/* [MS-XLSB] 2.4.687 BrtName */
function parse_BrtName(data, length, opts) {
	var end = data.l + length;
	var flags = data.read_shift(4);
	data.l += 1; //var chKey = data.read_shift(1);
	var itab = data.read_shift(4);
	var name = parse_XLNameWideString(data);
	var formula = parse_XLSBNameParsedFormula(data, 0, opts);
	var comment = parse_XLNullableWideString(data);
	if(flags & 0x20) name = "_xlnm." + name;
	//if(0 /* fProc */) {
		// unusedstring1: XLNullableWideString
		// description: XLNullableWideString
		// helpTopic: XLNullableWideString
		// unusedstring2: XLNullableWideString
	//}
	data.l = end;
	var out = ({Name:name, Ptg:formula, Flags: flags});
	if(itab < 0xFFFFFFF) out.Sheet = itab;
	if(comment) out.Comment = comment;
	return out;
}
function write_BrtName(name, wb) {
	var o = new_buf(9);
	var flags = 0;
	var dname = name.Name;
	if(XLSLblBuiltIn.indexOf(dname) > -1) { flags |= 0x20; dname = dname.slice(6); }
	o.write_shift(4, flags); // flags
	o.write_shift(1, 0); // chKey
	o.write_shift(4, name.Sheet == null ? 0xFFFFFFFF : name.Sheet);

	var arr = [
		o,
		write_XLWideString(dname),
		write_XLSBNameParsedFormula(name.Ref, wb)
	];
	if(name.Comment) arr.push(write_XLNullableWideString(name.Comment));
	else {
		var x = new_buf(4);
		x.write_shift(4, 0xFFFFFFFF);
		arr.push(x);
	}

	// if macro (flags & 0x0F):
	// write_shift(4, 0xFFFFFFFF);
	// write_XLNullableWideString(description)
	// write_XLNullableWideString(helpTopic)
	// write_shift(4, 0xFFFFFFFF);

	return bconcat(arr);
}

/* [MS-XLSB] 2.1.7.61 Workbook */
function parse_wb_bin(data, opts) {
	var wb = { AppVersion:{}, WBProps:{}, WBView:[], Sheets:[], CalcPr:{}, xmlns: "" };
	var state = [];
	var pass = false;

	if(!opts) opts = {};
	opts.biff = 12;

	var Names = [];
	var supbooks = ([[]]);
	supbooks.SheetNames = [];
	supbooks.XTI = [];

	XLSBRecordEnum[0x0010] = { n:"BrtFRTArchID$", f:parse_BrtFRTArchID$ };

	recordhopper(data, function hopper_wb(val, R, RT) {
		switch(RT) {
			case 0x009C: /* 'BrtBundleSh' */
				supbooks.SheetNames.push(val.name);
				wb.Sheets.push(val); break;

			case 0x0099: /* 'BrtWbProp' */
				wb.WBProps = val; break;

			case 0x0027: /* 'BrtName' */
				if(val.Sheet != null) opts.SID = val.Sheet;
				val.Ref = stringify_formula(val.Ptg, null, null, supbooks, opts);
				delete opts.SID;
				delete val.Ptg;
				Names.push(val);
				break;
			case 0x040C: /* 'BrtNameExt' */ break;

			case 0x0165: /* 'BrtSupSelf' */
			case 0x0166: /* 'BrtSupSame' */
			case 0x0163: /* 'BrtSupBookSrc' */
			case 0x029B: /* 'BrtSupAddin' */
				if(!supbooks[0].length) supbooks[0] = [RT, val];
				else supbooks.push([RT, val]);
				supbooks[supbooks.length - 1].XTI = [];
				break;
			case 0x016A: /* 'BrtExternSheet' */
				if(supbooks.length === 0) { supbooks[0] = []; supbooks[0].XTI = []; }
				supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val);
				supbooks.XTI = supbooks.XTI.concat(val);
				break;
			case 0x0169: /* 'BrtPlaceholderName' */
				break;

			case 0x0817: /* 'BrtAbsPath15' */
			case 0x009E: /* 'BrtBookView' */
			case 0x008F: /* 'BrtBeginBundleShs' */
			case 0x0298: /* 'BrtBeginFnGroup' */
			case 0x0161: /* 'BrtBeginExternals' */
				break;

			/* case 'BrtModelTimeGroupingCalcCol' */
			case 0x0C00: /* 'BrtUid' */
			case 0x0C01: /* 'BrtRevisionPtr' */
			case 0x0216: /* 'BrtBookProtection' */
			case 0x02A5: /* 'BrtBookProtectionIso' */
			case 0x009D: /* 'BrtCalcProp' */
			case 0x0262: /* 'BrtCrashRecErr' */
			case 0x0802: /* 'BrtDecoupledPivotCacheID' */
			case 0x009B: /* 'BrtFileRecover' */
			case 0x0224: /* 'BrtFileSharing' */
			case 0x02A4: /* 'BrtFileSharingIso' */
			case 0x0080: /* 'BrtFileVersion' */
			case 0x0299: /* 'BrtFnGroup' */
			case 0x0850: /* 'BrtModelRelationship' */
			case 0x084D: /* 'BrtModelTable' */
			case 0x0225: /* 'BrtOleSize' */
			case 0x0805: /* 'BrtPivotTableRef' */
			case 0x0254: /* 'BrtSmartTagType' */
			case 0x081C: /* 'BrtTableSlicerCacheID' */
			case 0x081B: /* 'BrtTableSlicerCacheIDs' */
			case 0x0822: /* 'BrtTimelineCachePivotCacheID' */
			case 0x018D: /* 'BrtUserBookView' */
			case 0x009A: /* 'BrtWbFactoid' */
			case 0x045D: /* 'BrtWbProp14' */
			case 0x0229: /* 'BrtWebOpt' */
			case 0x082B: /* 'BrtWorkBookPr15' */
				break;

			case 0x0023: /* 'BrtFRTBegin' */
				state.push(RT); pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				state.pop(); pass = false; break;
			case 0x0025: /* 'BrtACBegin' */
				state.push(RT); pass = true; break;
			case 0x0026: /* 'BrtACEnd' */
				state.pop(); pass = false; break;

			case 0x0010: /* 'BrtFRTArchID$' */ break;

			default:
				if(R.T){/* empty */}
				else if(!pass || (opts.WTF && state[state.length-1] != 0x0025 /* BrtACBegin */ && state[state.length-1] != 0x0023 /* BrtFRTBegin */)) throw new Error("Unexpected record 0x" + RT.toString(16));
		}
	}, opts);

	parse_wb_defaults(wb);

	// $FlowIgnore
	wb.Names = Names;

	(wb).supbooks = supbooks;
	return wb;
}

function write_BUNDLESHS(ba, wb) {
	write_record(ba, 0x008F /* BrtBeginBundleShs */);
	for(var idx = 0; idx != wb.SheetNames.length; ++idx) {
		var viz = wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx] && wb.Workbook.Sheets[idx].Hidden || 0;
		var d = { Hidden: viz, iTabID: idx+1, strRelID: 'rId' + (idx+1), name: wb.SheetNames[idx] };
		write_record(ba, 0x009C /* BrtBundleSh */, write_BrtBundleSh(d));
	}
	write_record(ba, 0x0090 /* BrtEndBundleShs */);
}

/* [MS-XLSB] 2.4.649 BrtFileVersion */
function write_BrtFileVersion(data, o) {
	if(!o) o = new_buf(127);
	for(var i = 0; i != 4; ++i) o.write_shift(4, 0);
	write_XLWideString("SheetJS", o);
	write_XLWideString(XLSX.version, o);
	write_XLWideString(XLSX.version, o);
	write_XLWideString("7262", o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.301 BrtBookView */
function write_BrtBookView(idx, o) {
	if(!o) o = new_buf(29);
	o.write_shift(-4, 0);
	o.write_shift(-4, 460);
	o.write_shift(4,  28800);
	o.write_shift(4,  17600);
	o.write_shift(4,  500);
	o.write_shift(4,  idx);
	o.write_shift(4,  idx);
	var flags = 0x78;
	o.write_shift(1,  flags);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

function write_BOOKVIEWS(ba, wb) {
	/* required if hidden tab appears before visible tab */
	if(!wb.Workbook || !wb.Workbook.Sheets) return;
	var sheets = wb.Workbook.Sheets;
	var i = 0, vistab = -1, hidden = -1;
	for(; i < sheets.length; ++i) {
		if(!sheets[i] || !sheets[i].Hidden && vistab == -1) vistab = i;
		else if(sheets[i].Hidden == 1 && hidden == -1) hidden = i;
	}
	if(hidden > vistab) return;
	write_record(ba, 0x0087 /* BrtBeginBookViews */);
	write_record(ba, 0x009E /* BrtBookView */, write_BrtBookView(vistab));
	/* 1*(BrtBookView *FRT) */
	write_record(ba, 0x0088 /* BrtEndBookViews */);
}

function write_BRTNAMES(ba, wb) {
	if(!wb.Workbook || !wb.Workbook.Names) return;
	wb.Workbook.Names.forEach(function(name) { try {
		if(name.Flags & 0x0e) return; // TODO: macro name write
		write_record(ba, 0x0027 /* BrtName */, write_BrtName(name, wb));
	} catch(e) {
		console.error("Could not serialize defined name " + JSON.stringify(name));
	} });
}

function write_SELF_EXTERNS_xlsb(wb) {
	var L = wb.SheetNames.length;
	var o = new_buf(12 * L + 28);
	o.write_shift(4, L + 2);
	o.write_shift(4, 0); o.write_shift(4, -2); o.write_shift(4, -2); // workbook-level reference
	o.write_shift(4, 0); o.write_shift(4, -1); o.write_shift(4, -1); // #REF!...
	for(var i = 0; i < L; ++i) {
		o.write_shift(4, 0); o.write_shift(4, i); o.write_shift(4, i);
	}
	return o;
}
function write_EXTERNALS_xlsb(ba, wb) {
	write_record(ba, 0x0161 /* BrtBeginExternals */);
	write_record(ba, 0x0165 /* BrtSupSelf */);
	write_record(ba, 0x016A /* BrtExternSheet */, write_SELF_EXTERNS_xlsb(wb, 0));
	write_record(ba, 0x0162 /* BrtEndExternals */);
}

/* [MS-XLSB] 2.4.305 BrtCalcProp */
/*function write_BrtCalcProp(data, o) {
	if(!o) o = new_buf(26);
	o.write_shift(4,0); // force recalc
	o.write_shift(4,1);
	o.write_shift(4,0);
	write_Xnum(0, o);
	o.write_shift(-4, 1023);
	o.write_shift(1, 0x33);
	o.write_shift(1, 0x00);
	return o;
}*/

/* [MS-XLSB] 2.4.646 BrtFileRecover */
/*function write_BrtFileRecover(data, o) {
	if(!o) o = new_buf(1);
	o.write_shift(1,0);
	return o;
}*/

/* [MS-XLSB] 2.1.7.61 Workbook */
function write_wb_bin(wb, opts) {
	var ba = buf_array();
	write_record(ba, 0x0083 /* BrtBeginBook */);
	write_record(ba, 0x0080 /* BrtFileVersion */, write_BrtFileVersion());
	/* [[BrtFileSharingIso] BrtFileSharing] */
	write_record(ba, 0x0099 /* BrtWbProp */, write_BrtWbProp(wb.Workbook && wb.Workbook.WBProps || null));
	/* [ACABSPATH] */
	/* [[BrtBookProtectionIso] BrtBookProtection] */
	write_BOOKVIEWS(ba, wb, opts);
	write_BUNDLESHS(ba, wb, opts);
	/* [FNGROUP] */
	write_EXTERNALS_xlsb(ba, wb);
	if((wb.Workbook||{}).Names) write_BRTNAMES(ba, wb);
	/* write_record(ba, 0x009D BrtCalcProp, write_BrtCalcProp()); */
	/* [BrtOleSize] */
	/* *(BrtUserBookView *FRT) */
	/* [PIVOTCACHEIDS] */
	/* [BrtWbFactoid] */
	/* [SMARTTAGTYPES] */
	/* [BrtWebOpt] */
	/* write_record(ba, 0x009B BrtFileRecover, write_BrtFileRecover()); */
	/* [WEBPUBITEMS] */
	/* [CRERRS] */
	/* FRTWORKBOOK */
	write_record(ba, 0x0084 /* BrtEndBook */);

	return ba.end();
}
function parse_wb(data, name, opts) {
	if(name.slice(-4)===".bin") return parse_wb_bin((data), opts);
	return parse_wb_xml((data), opts);
}

function parse_ws(data, name, idx, opts, rels, wb, themes, styles) {
	if(name.slice(-4)===".bin") return parse_ws_bin((data), opts, idx, rels, wb, themes, styles);
	return parse_ws_xml((data), opts, idx, rels, wb, themes, styles);
}

function parse_cs(data, name, idx, opts, rels, wb, themes, styles) {
	if(name.slice(-4)===".bin") return parse_cs_bin((data), opts, idx, rels, wb, themes, styles);
	return parse_cs_xml((data), opts, idx, rels, wb, themes, styles);
}

function parse_ms(data, name, idx, opts, rels, wb, themes, styles) {
	if(name.slice(-4)===".bin") return parse_ms_bin((data), opts, idx, rels, wb, themes, styles);
	return parse_ms_xml((data), opts, idx, rels, wb, themes, styles);
}

function parse_ds(data, name, idx, opts, rels, wb, themes, styles) {
	if(name.slice(-4)===".bin") return parse_ds_bin((data), opts, idx, rels, wb, themes, styles);
	return parse_ds_xml((data), opts, idx, rels, wb, themes, styles);
}

function parse_sty(data, name, themes, opts) {
	if(name.slice(-4)===".bin") return parse_sty_bin((data), themes, opts);
	return parse_sty_xml((data), themes, opts);
}

function parse_sst(data, name, opts) {
	if(name.slice(-4)===".bin") return parse_sst_bin((data), opts);
	return parse_sst_xml((data), opts);
}

function parse_cmnt(data, name, opts) {
	if(name.slice(-4)===".bin") return parse_comments_bin((data), opts);
	return parse_comments_xml((data), opts);
}

function parse_cc(data, name, opts) {
	if(name.slice(-4)===".bin") return parse_cc_bin((data), name, opts);
	return parse_cc_xml((data), name, opts);
}

function parse_xlink(data, rel, name, opts) {
	if(name.slice(-4)===".bin") return parse_xlink_bin((data), rel, name, opts);
	return parse_xlink_xml((data), rel, name, opts);
}

function parse_xlmeta(data, name, opts) {
	if(name.slice(-4)===".bin") return parse_xlmeta_bin((data), name, opts);
	return parse_xlmeta_xml((data), name, opts);
}
var attregexg2=/([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;
var attregex2=/([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
function xlml_parsexmltag(tag, skip_root) {
	var words = tag.split(/\s+/);
	var z = ([]); if(!skip_root) z[0] = words[0];
	if(words.length === 1) return z;
	var m = tag.match(attregexg2), y, j, w, i;
	if(m) for(i = 0; i != m.length; ++i) {
		y = m[i].match(attregex2);
if((j=y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1,y[2].length-1);
		else {
			if(y[1].slice(0,6) === "xmlns:") w = "xmlns"+y[1].slice(6);
			else w = y[1].slice(j+1);
			z[w] = y[2].slice(1,y[2].length-1);
		}
	}
	return z;
}
function xlml_parsexmltagobj(tag) {
	var words = tag.split(/\s+/);
	var z = {};
	if(words.length === 1) return z;
	var m = tag.match(attregexg2), y, j, w, i;
	if(m) for(i = 0; i != m.length; ++i) {
		y = m[i].match(attregex2);
if((j=y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1,y[2].length-1);
		else {
			if(y[1].slice(0,6) === "xmlns:") w = "xmlns"+y[1].slice(6);
			else w = y[1].slice(j+1);
			z[w] = y[2].slice(1,y[2].length-1);
		}
	}
	return z;
}

// ----

/* map from xlml named formats to SSF TODO: localize */
var XLMLFormatMap;

function xlml_format(format, value) {
	var fmt = XLMLFormatMap[format] || unescapexml(format);
	if(fmt === "General") return SSF_general(value);
	return SSF_format(fmt, value);
}

function xlml_set_custprop(Custprops, key, cp, val) {
	var oval = val;
	switch((cp[0].match(/dt:dt="([\w.]+)"/)||["",""])[1]) {
		case "boolean": oval = parsexmlbool(val); break;
		case "i2": case "int": oval = parseInt(val, 10); break;
		case "r4": case "float": oval = parseFloat(val); break;
		case "date": case "dateTime.tz": oval = parseDate(val); break;
		case "i8": case "string": case "fixed": case "uuid": case "bin.base64": break;
		default: throw new Error("bad custprop:" + cp[0]);
	}
	Custprops[unescapexml(key)] = oval;
}

function safe_format_xlml(cell, nf, o) {
	if(cell.t === 'z') return;
	if(!o || o.cellText !== false) try {
		if(cell.t === 'e') { cell.w = cell.w || BErr[cell.v]; }
		else if(nf === "General") {
			if(cell.t === 'n') {
				if((cell.v|0) === cell.v) cell.w = cell.v.toString(10);
				else cell.w = SSF_general_num(cell.v);
			}
			else cell.w = SSF_general(cell.v);
		}
		else cell.w = xlml_format(nf||"General", cell.v);
	} catch(e) { if(o.WTF) throw e; }
	try {
		var z = XLMLFormatMap[nf]||nf||"General";
		if(o.cellNF) cell.z = z;
		if(o.cellDates && cell.t == 'n' && fmt_is_date(z)) {
			var _d = SSF_parse_date_code(cell.v); if(_d) { cell.t = 'd'; cell.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
		}
	} catch(e) { if(o.WTF) throw e; }
}

function process_style_xlml(styles, stag, opts) {
	if(opts.cellStyles) {
		if(stag.Interior) {
			var I = stag.Interior;
			if(I.Pattern) I.patternType = XLMLPatternTypeMap[I.Pattern] || I.Pattern;
		}
	}
	styles[stag.ID] = stag;
}

/* TODO: there must exist some form of OSP-blessed spec */
function parse_xlml_data(xml, ss, data, cell, base, styles, csty, row, arrayf, o) {
	var nf = "General", sid = cell.StyleID, S = {}; o = o || {};
	var interiors = [];
	var i = 0;
	if(sid === undefined && row) sid = row.StyleID;
	if(sid === undefined && csty) sid = csty.StyleID;
	while(styles[sid] !== undefined) {
		if(styles[sid].nf) nf = styles[sid].nf;
		if(styles[sid].Interior) interiors.push(styles[sid].Interior);
		if(!styles[sid].Parent) break;
		sid = styles[sid].Parent;
	}
	switch(data.Type) {
		case 'Boolean':
			cell.t = 'b';
			cell.v = parsexmlbool(xml);
			break;
		case 'String':
			cell.t = 's'; cell.r = xlml_fixstr(unescapexml(xml));
			cell.v = (xml.indexOf("<") > -1 ? unescapexml(ss||xml).replace(/<.*?>/g, "") : cell.r); // todo: BR etc
			break;
		case 'DateTime':
			if(xml.slice(-1) != "Z") xml += "Z";
			cell.v = (parseDate(xml) - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
			if(cell.v !== cell.v) cell.v = unescapexml(xml);
			else if(cell.v<60) cell.v = cell.v -1;
			if(!nf || nf == "General") nf = "yyyy-mm-dd";
			/* falls through */
		case 'Number':
			if(cell.v === undefined) cell.v=+xml;
			if(!cell.t) cell.t = 'n';
			break;
		case 'Error': cell.t = 'e'; cell.v = RBErr[xml]; if(o.cellText !== false) cell.w = xml; break;
		default:
			if(xml == "" && ss == "") { cell.t = 'z'; }
			else { cell.t = 's'; cell.v = xlml_fixstr(ss||xml); }
			break;
	}
	safe_format_xlml(cell, nf, o);
	if(o.cellFormula !== false) {
		if(cell.Formula) {
			var fstr = unescapexml(cell.Formula);
			/* strictly speaking, the leading = is required but some writers omit */
			if(fstr.charCodeAt(0) == 61 /* = */) fstr = fstr.slice(1);
			cell.f = rc_to_a1(fstr, base);
			delete cell.Formula;
			if(cell.ArrayRange == "RC") cell.F = rc_to_a1("RC:RC", base);
			else if(cell.ArrayRange) {
				cell.F = rc_to_a1(cell.ArrayRange, base);
				arrayf.push([safe_decode_range(cell.F), cell.F]);
			}
		} else {
			for(i = 0; i < arrayf.length; ++i)
				if(base.r >= arrayf[i][0].s.r && base.r <= arrayf[i][0].e.r)
					if(base.c >= arrayf[i][0].s.c && base.c <= arrayf[i][0].e.c)
						cell.F = arrayf[i][1];
		}
	}
	if(o.cellStyles) {
		interiors.forEach(function(x) {
			if(!S.patternType && x.patternType) S.patternType = x.patternType;
		});
		cell.s = S;
	}
	if(cell.StyleID !== undefined) cell.ixfe = cell.StyleID;
}

function xlml_prefix_dname(dname) {
	return XLSLblBuiltIn.indexOf("_xlnm." + dname) > -1 ? "_xlnm." + dname : dname;
}

function xlml_clean_comment(comment) {
	comment.t = comment.v || "";
	comment.t = comment.t.replace(/\r\n/g,"\n").replace(/\r/g,"\n");
	comment.v = comment.w = comment.ixfe = undefined;
}

/* TODO: Everything */
function parse_xlml_xml(d, _opts) {
	var opts = _opts || {};
	make_ssf();
	var str = debom(xlml_normalize(d));
	if(opts.type == 'binary' || opts.type == 'array' || opts.type == 'base64') {
		if(typeof $cptable !== 'undefined') str = $cptable.utils.decode(65001, char_codes(str));
		else str = utf8read(str);
	}
	var opening = str.slice(0, 1024).toLowerCase(), ishtml = false;
	opening = opening.replace(/".*?"/g, "");
	if((opening.indexOf(">") & 1023) > Math.min((opening.indexOf(",") & 1023), (opening.indexOf(";")&1023))) { var _o = dup(opts); _o.type = "string"; return PRN.to_workbook(str, _o); }
	if(opening.indexOf("<?xml") == -1) ["html", "table", "head", "meta", "script", "style", "div"].forEach(function(tag) { if(opening.indexOf("<" + tag) >= 0) ishtml = true; });
	if(ishtml) return html_to_workbook(str, opts);

	XLMLFormatMap = ({
		"General Number": "General",
		"General Date": table_fmt[22],
		"Long Date": "dddd, mmmm dd, yyyy",
		"Medium Date": table_fmt[15],
		"Short Date": table_fmt[14],
		"Long Time": table_fmt[19],
		"Medium Time": table_fmt[18],
		"Short Time": table_fmt[20],
		"Currency": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
		"Fixed": table_fmt[2],
		"Standard": table_fmt[4],
		"Percent": table_fmt[10],
		"Scientific": table_fmt[11],
		"Yes/No": '"Yes";"Yes";"No";@',
		"True/False": '"True";"True";"False";@',
		"On/Off": '"Yes";"Yes";"No";@'
	});


	var Rn;
	var state = [], tmp;
	if(DENSE != null && opts.dense == null) opts.dense = DENSE;
	var sheets = {}, sheetnames = [], cursheet = (opts.dense ? [] : {}), sheetname = "";
	var cell = ({}), row = {};// eslint-disable-line no-unused-vars
	var dtag = xlml_parsexmltag('<Data ss:Type="String">'), didx = 0;
	var c = 0, r = 0;
	var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
	var styles = {}, stag = {};
	var ss = "", fidx = 0;
	var merges = [];
	var Props = {}, Custprops = {}, pidx = 0, cp = [];
	var comments = [], comment = ({});
	var cstys = [], csty, seencol = false;
	var arrayf = [];
	var rowinfo = [], rowobj = {}, cc = 0, rr = 0;
	var Workbook = ({ Sheets:[], WBProps:{date1904:false} }), wsprops = {};
	xlmlregex.lastIndex = 0;
	str = str.replace(/<!--([\s\S]*?)-->/mg,"");
	var raw_Rn3 = "";
	while((Rn = xlmlregex.exec(str))) switch((Rn[3] = (raw_Rn3 = Rn[3]).toLowerCase())) {
		case 'data' /*case 'Data'*/:
			if(raw_Rn3 == "data") {
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
				break;
			}
			if(state[state.length-1][1]) break;
			if(Rn[1]==='/') parse_xlml_data(str.slice(didx, Rn.index), ss, dtag, state[state.length-1][0]==/*"Comment"*/"comment"?comment:cell, {c:c,r:r}, styles, cstys[c], row, arrayf, opts);
			else { ss = ""; dtag = xlml_parsexmltag(Rn[0]); didx = Rn.index + Rn[0].length; }
			break;
		case 'cell' /*case 'Cell'*/:
			if(Rn[1]==='/'){
				if(comments.length > 0) cell.c = comments;
				if((!opts.sheetRows || opts.sheetRows > r) && cell.v !== void 0) {
					if(opts.dense) {
						if(!cursheet[r]) cursheet[r] = [];
						cursheet[r][c] = cell;
					} else cursheet[encode_col(c) + encode_row(r)] = cell;
				}
				if(cell.HRef) {
					cell.l = ({Target:unescapexml(cell.HRef)});
					if(cell.HRefScreenTip) cell.l.Tooltip = cell.HRefScreenTip;
					delete cell.HRef; delete cell.HRefScreenTip;
				}
				if(cell.MergeAcross || cell.MergeDown) {
					cc = c + (parseInt(cell.MergeAcross,10)|0);
					rr = r + (parseInt(cell.MergeDown,10)|0);
					if(cc > c || rr > r) merges.push({s:{c:c,r:r},e:{c:cc,r:rr}});
				}
				if(!opts.sheetStubs) { if(cell.MergeAcross) c = cc + 1; else ++c; }
				else if(cell.MergeAcross || cell.MergeDown) {
for(var cma = c; cma <= cc; ++cma) {
						for(var cmd = r; cmd <= rr; ++cmd) {
							if(cma > c || cmd > r) {
								if(opts.dense) {
									if(!cursheet[cmd]) cursheet[cmd] = [];
									cursheet[cmd][cma] = {t:'z'};
								} else cursheet[encode_col(cma) + encode_row(cmd)] = {t:'z'};
							}
						}
					}
					c = cc + 1;
				}
				else ++c;
			} else {
				cell = xlml_parsexmltagobj(Rn[0]);
				if(cell.Index) c = +cell.Index - 1;
				if(c < refguess.s.c) refguess.s.c = c;
				if(c > refguess.e.c) refguess.e.c = c;
				if(Rn[0].slice(-2) === "/>") ++c;
				comments = [];
			}
			break;
		case 'row' /*case 'Row'*/:
			if(Rn[1]==='/' || Rn[0].slice(-2) === "/>") {
				if(r < refguess.s.r) refguess.s.r = r;
				if(r > refguess.e.r) refguess.e.r = r;
				if(Rn[0].slice(-2) === "/>") {
					row = xlml_parsexmltag(Rn[0]);
					if(row.Index) r = +row.Index - 1;
				}
				c = 0; ++r;
			} else {
				row = xlml_parsexmltag(Rn[0]);
				if(row.Index) r = +row.Index - 1;
				rowobj = {};
				if(row.AutoFitHeight == "0" || row.Height) {
					rowobj.hpx = parseInt(row.Height, 10); rowobj.hpt = px2pt(rowobj.hpx);
					rowinfo[r] = rowobj;
				}
				if(row.Hidden == "1") { rowobj.hidden = true; rowinfo[r] = rowobj; }
			}
			break;
		case 'worksheet' /*case 'Worksheet'*/: /* TODO: read range from FullRows/FullColumns */
			if(Rn[1]==='/'){
				if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
				sheetnames.push(sheetname);
				if(refguess.s.r <= refguess.e.r && refguess.s.c <= refguess.e.c) {
					cursheet["!ref"] = encode_range(refguess);
					if(opts.sheetRows && opts.sheetRows <= refguess.e.r) {
						cursheet["!fullref"] = cursheet["!ref"];
						refguess.e.r = opts.sheetRows - 1;
						cursheet["!ref"] = encode_range(refguess);
					}
				}
				if(merges.length) cursheet["!merges"] = merges;
				if(cstys.length > 0) cursheet["!cols"] = cstys;
				if(rowinfo.length > 0) cursheet["!rows"] = rowinfo;
				sheets[sheetname] = cursheet;
			} else {
				refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
				r = c = 0;
				state.push([Rn[3], false]);
				tmp = xlml_parsexmltag(Rn[0]);
				sheetname = unescapexml(tmp.Name);
				cursheet = (opts.dense ? [] : {});
				merges = [];
				arrayf = [];
				rowinfo = [];
				wsprops = {name:sheetname, Hidden:0};
				Workbook.Sheets.push(wsprops);
			}
			break;
		case 'table' /*case 'Table'*/:
			if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
			else if(Rn[0].slice(-2) == "/>") break;
			else {
				state.push([Rn[3], false]);
				cstys = []; seencol = false;
			}
			break;

		case 'style' /*case 'Style'*/:
			if(Rn[1]==='/') process_style_xlml(styles, stag, opts);
			else stag = xlml_parsexmltag(Rn[0]);
			break;

		case 'numberformat' /*case 'NumberFormat'*/:
			stag.nf = unescapexml(xlml_parsexmltag(Rn[0]).Format || "General");
			if(XLMLFormatMap[stag.nf]) stag.nf = XLMLFormatMap[stag.nf];
			for(var ssfidx = 0; ssfidx != 0x188; ++ssfidx) if(table_fmt[ssfidx] == stag.nf) break;
			if(ssfidx == 0x188) for(ssfidx = 0x39; ssfidx != 0x188; ++ssfidx) if(table_fmt[ssfidx] == null) { SSF__load(stag.nf, ssfidx); break; }
			break;

		case 'column' /*case 'Column'*/:
			if(state[state.length-1][0] !== /*'Table'*/'table') break;
			if(Rn[1]==='/') break;
			csty = xlml_parsexmltag(Rn[0]);
			if(csty.Hidden) { csty.hidden = true; delete csty.Hidden; }
			if(csty.Width) csty.wpx = parseInt(csty.Width, 10);
			if(!seencol && csty.wpx > 10) {
				seencol = true; MDW = DEF_MDW; //find_mdw_wpx(csty.wpx);
				for(var _col = 0; _col < cstys.length; ++_col) if(cstys[_col]) process_col(cstys[_col]);
			}
			if(seencol) process_col(csty);
			cstys[(csty.Index-1||cstys.length)] = csty;
			for(var i = 0; i < +csty.Span; ++i) cstys[cstys.length] = dup(csty);
			break;

		case 'namedrange' /*case 'NamedRange'*/:
			if(Rn[1]==='/') break;
			if(!Workbook.Names) Workbook.Names = [];
			var _NamedRange = parsexmltag(Rn[0]);
			var _DefinedName = ({
				Name: xlml_prefix_dname(_NamedRange.Name),
				Ref: rc_to_a1(_NamedRange.RefersTo.slice(1), {r:0, c:0})
			});
			if(Workbook.Sheets.length>0) _DefinedName.Sheet=Workbook.Sheets.length-1;
Workbook.Names.push(_DefinedName);
			break;

		case 'namedcell' /*case 'NamedCell'*/: break;
		case 'b' /*case 'B'*/: break;
		case 'i' /*case 'I'*/: break;
		case 'u' /*case 'U'*/: break;
		case 's' /*case 'S'*/: break;
		case 'em' /*case 'EM'*/: break;
		case 'h2' /*case 'H2'*/: break;
		case 'h3' /*case 'H3'*/: break;
		case 'sub' /*case 'Sub'*/: break;
		case 'sup' /*case 'Sup'*/: break;
		case 'span' /*case 'Span'*/: break;
		case 'alignment' /*case 'Alignment'*/:
			break;
		case 'borders' /*case 'Borders'*/: break;
		case 'border' /*case 'Border'*/: break;
		case 'font' /*case 'Font'*/:
			if(Rn[0].slice(-2) === "/>") break;
			else if(Rn[1]==="/") ss += str.slice(fidx, Rn.index);
			else fidx = Rn.index + Rn[0].length;
			break;
		case 'interior' /*case 'Interior'*/:
			if(!opts.cellStyles) break;
			stag.Interior = xlml_parsexmltag(Rn[0]);
			break;
		case 'protection' /*case 'Protection'*/: break;

		case 'author' /*case 'Author'*/:
		case 'title' /*case 'Title'*/:
		case 'description' /*case 'Description'*/:
		case 'created' /*case 'Created'*/:
		case 'keywords' /*case 'Keywords'*/:
		case 'subject' /*case 'Subject'*/:
		case 'category' /*case 'Category'*/:
		case 'company' /*case 'Company'*/:
		case 'lastauthor' /*case 'LastAuthor'*/:
		case 'lastsaved' /*case 'LastSaved'*/:
		case 'lastprinted' /*case 'LastPrinted'*/:
		case 'version' /*case 'Version'*/:
		case 'revision' /*case 'Revision'*/:
		case 'totaltime' /*case 'TotalTime'*/:
		case 'hyperlinkbase' /*case 'HyperlinkBase'*/:
		case 'manager' /*case 'Manager'*/:
		case 'contentstatus' /*case 'ContentStatus'*/:
		case 'identifier' /*case 'Identifier'*/:
		case 'language' /*case 'Language'*/:
		case 'appname' /*case 'AppName'*/:
			if(Rn[0].slice(-2) === "/>") break;
			else if(Rn[1]==="/") xlml_set_prop(Props, raw_Rn3, str.slice(pidx, Rn.index));
			else pidx = Rn.index + Rn[0].length;
			break;
		case 'paragraphs' /*case 'Paragraphs'*/: break;

		case 'styles' /*case 'Styles'*/:
		case 'workbook' /*case 'Workbook'*/:
			if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
			else state.push([Rn[3], false]);
			break;

		case 'comment' /*case 'Comment'*/:
			if(Rn[1]==='/'){
				if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
				xlml_clean_comment(comment);
				comments.push(comment);
			} else {
				state.push([Rn[3], false]);
				tmp = xlml_parsexmltag(Rn[0]);
				comment = ({a:tmp.Author});
			}
			break;

		case 'autofilter' /*case 'AutoFilter'*/:
			if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
			else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
				var AutoFilter = xlml_parsexmltag(Rn[0]);
				cursheet['!autofilter'] = { ref:rc_to_a1(AutoFilter.Range).replace(/\$/g,"") };
				state.push([Rn[3], true]);
			}
			break;

		case 'name' /*case 'Name'*/: break;

		case 'datavalidation' /*case 'DataValidation'*/:
			if(Rn[1]==='/'){
				if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
			} else {
				if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
			}
			break;

		case 'pixelsperinch' /*case 'PixelsPerInch'*/:
			break;
		case 'componentoptions' /*case 'ComponentOptions'*/:
		case 'documentproperties' /*case 'DocumentProperties'*/:
		case 'customdocumentproperties' /*case 'CustomDocumentProperties'*/:
		case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/:
		case 'pivottable' /*case 'PivotTable'*/:
		case 'pivotcache' /*case 'PivotCache'*/:
		case 'names' /*case 'Names'*/:
		case 'mapinfo' /*case 'MapInfo'*/:
		case 'pagebreaks' /*case 'PageBreaks'*/:
		case 'querytable' /*case 'QueryTable'*/:
		case 'sorting' /*case 'Sorting'*/:
		case 'schema' /*case 'Schema'*/: //case 'data' /*case 'data'*/:
		case 'conditionalformatting' /*case 'ConditionalFormatting'*/:
		case 'smarttagtype' /*case 'SmartTagType'*/:
		case 'smarttags' /*case 'SmartTags'*/:
		case 'excelworkbook' /*case 'ExcelWorkbook'*/:
		case 'workbookoptions' /*case 'WorkbookOptions'*/:
		case 'worksheetoptions' /*case 'WorksheetOptions'*/:
			if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
			else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
			break;

		case 'null' /*case 'Null'*/: break;

		default:
			/* FODS file root is <office:document> */
			if(state.length == 0 && Rn[3] == "document") return parse_fods(str, opts);
			/* UOS file root is <uof:UOF> */
			if(state.length == 0 && Rn[3] == "uof"/*"UOF"*/) return parse_fods(str, opts);

			var seen = true;
			switch(state[state.length-1][0]) {
				/* OfficeDocumentSettings */
				case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/: switch(Rn[3]) {
					case 'allowpng' /*case 'AllowPNG'*/: break;
					case 'removepersonalinformation' /*case 'RemovePersonalInformation'*/: break;
					case 'downloadcomponents' /*case 'DownloadComponents'*/: break;
					case 'locationofcomponents' /*case 'LocationOfComponents'*/: break;
					case 'colors' /*case 'Colors'*/: break;
					case 'color' /*case 'Color'*/: break;
					case 'index' /*case 'Index'*/: break;
					case 'rgb' /*case 'RGB'*/: break;
					case 'targetscreensize' /*case 'TargetScreenSize'*/: break;
					case 'readonlyrecommended' /*case 'ReadOnlyRecommended'*/: break;
					default: seen = false;
				} break;

				/* ComponentOptions */
				case 'componentoptions' /*case 'ComponentOptions'*/: switch(Rn[3]) {
					case 'toolbar' /*case 'Toolbar'*/: break;
					case 'hideofficelogo' /*case 'HideOfficeLogo'*/: break;
					case 'spreadsheetautofit' /*case 'SpreadsheetAutoFit'*/: break;
					case 'label' /*case 'Label'*/: break;
					case 'caption' /*case 'Caption'*/: break;
					case 'maxheight' /*case 'MaxHeight'*/: break;
					case 'maxwidth' /*case 'MaxWidth'*/: break;
					case 'nextsheetnumber' /*case 'NextSheetNumber'*/: break;
					default: seen = false;
				} break;

				/* ExcelWorkbook */
				case 'excelworkbook' /*case 'ExcelWorkbook'*/: switch(Rn[3]) {
					case 'date1904' /*case 'Date1904'*/:
Workbook.WBProps.date1904 = true;
						break;
					case 'windowheight' /*case 'WindowHeight'*/: break;
					case 'windowwidth' /*case 'WindowWidth'*/: break;
					case 'windowtopx' /*case 'WindowTopX'*/: break;
					case 'windowtopy' /*case 'WindowTopY'*/: break;
					case 'tabratio' /*case 'TabRatio'*/: break;
					case 'protectstructure' /*case 'ProtectStructure'*/: break;
					case 'protectwindow' /*case 'ProtectWindow'*/: break;
					case 'protectwindows' /*case 'ProtectWindows'*/: break;
					case 'activesheet' /*case 'ActiveSheet'*/: break;
					case 'displayinknotes' /*case 'DisplayInkNotes'*/: break;
					case 'firstvisiblesheet' /*case 'FirstVisibleSheet'*/: break;
					case 'supbook' /*case 'SupBook'*/: break;
					case 'sheetname' /*case 'SheetName'*/: break;
					case 'sheetindex' /*case 'SheetIndex'*/: break;
					case 'sheetindexfirst' /*case 'SheetIndexFirst'*/: break;
					case 'sheetindexlast' /*case 'SheetIndexLast'*/: break;
					case 'dll' /*case 'Dll'*/: break;
					case 'acceptlabelsinformulas' /*case 'AcceptLabelsInFormulas'*/: break;
					case 'donotsavelinkvalues' /*case 'DoNotSaveLinkValues'*/: break;
					case 'iteration' /*case 'Iteration'*/: break;
					case 'maxiterations' /*case 'MaxIterations'*/: break;
					case 'maxchange' /*case 'MaxChange'*/: break;
					case 'path' /*case 'Path'*/: break;
					case 'xct' /*case 'Xct'*/: break;
					case 'count' /*case 'Count'*/: break;
					case 'selectedsheets' /*case 'SelectedSheets'*/: break;
					case 'calculation' /*case 'Calculation'*/: break;
					case 'uncalced' /*case 'Uncalced'*/: break;
					case 'startupprompt' /*case 'StartupPrompt'*/: break;
					case 'crn' /*case 'Crn'*/: break;
					case 'externname' /*case 'ExternName'*/: break;
					case 'formula' /*case 'Formula'*/: break;
					case 'colfirst' /*case 'ColFirst'*/: break;
					case 'collast' /*case 'ColLast'*/: break;
					case 'wantadvise' /*case 'WantAdvise'*/: break;
					case 'boolean' /*case 'Boolean'*/: break;
					case 'error' /*case 'Error'*/: break;
					case 'text' /*case 'Text'*/: break;
					case 'ole' /*case 'OLE'*/: break;
					case 'noautorecover' /*case 'NoAutoRecover'*/: break;
					case 'publishobjects' /*case 'PublishObjects'*/: break;
					case 'donotcalculatebeforesave' /*case 'DoNotCalculateBeforeSave'*/: break;
					case 'number' /*case 'Number'*/: break;
					case 'refmoder1c1' /*case 'RefModeR1C1'*/: break;
					case 'embedsavesmarttags' /*case 'EmbedSaveSmartTags'*/: break;
					default: seen = false;
				} break;

				/* WorkbookOptions */
				case 'workbookoptions' /*case 'WorkbookOptions'*/: switch(Rn[3]) {
					case 'owcversion' /*case 'OWCVersion'*/: break;
					case 'height' /*case 'Height'*/: break;
					case 'width' /*case 'Width'*/: break;
					default: seen = false;
				} break;

				/* WorksheetOptions */
				case 'worksheetoptions' /*case 'WorksheetOptions'*/: switch(Rn[3]) {
					case 'visible' /*case 'Visible'*/:
						if(Rn[0].slice(-2) === "/>"){/* empty */}
						else if(Rn[1]==="/") switch(str.slice(pidx, Rn.index)) {
							case "SheetHidden": wsprops.Hidden = 1; break;
							case "SheetVeryHidden": wsprops.Hidden = 2; break;
						}
						else pidx = Rn.index + Rn[0].length;
						break;
					case 'header' /*case 'Header'*/:
						if(!cursheet['!margins']) default_margins(cursheet['!margins']={}, 'xlml');
						if(!isNaN(+parsexmltag(Rn[0]).Margin)) cursheet['!margins'].header = +parsexmltag(Rn[0]).Margin;
						break;
					case 'footer' /*case 'Footer'*/:
						if(!cursheet['!margins']) default_margins(cursheet['!margins']={}, 'xlml');
						if(!isNaN(+parsexmltag(Rn[0]).Margin)) cursheet['!margins'].footer = +parsexmltag(Rn[0]).Margin;
						break;
					case 'pagemargins' /*case 'PageMargins'*/:
						var pagemargins = parsexmltag(Rn[0]);
						if(!cursheet['!margins']) default_margins(cursheet['!margins']={},'xlml');
						if(!isNaN(+pagemargins.Top)) cursheet['!margins'].top = +pagemargins.Top;
						if(!isNaN(+pagemargins.Left)) cursheet['!margins'].left = +pagemargins.Left;
						if(!isNaN(+pagemargins.Right)) cursheet['!margins'].right = +pagemargins.Right;
						if(!isNaN(+pagemargins.Bottom)) cursheet['!margins'].bottom = +pagemargins.Bottom;
						break;
					case 'displayrighttoleft' /*case 'DisplayRightToLeft'*/:
						if(!Workbook.Views) Workbook.Views = [];
						if(!Workbook.Views[0]) Workbook.Views[0] = {};
						Workbook.Views[0].RTL = true;
						break;

					case 'freezepanes' /*case 'FreezePanes'*/: break;
					case 'frozennosplit' /*case 'FrozenNoSplit'*/: break;

					case 'splithorizontal' /*case 'SplitHorizontal'*/:
					case 'splitvertical' /*case 'SplitVertical'*/:
						break;

					case 'donotdisplaygridlines' /*case 'DoNotDisplayGridlines'*/:
						break;

					case 'activerow' /*case 'ActiveRow'*/: break;
					case 'activecol' /*case 'ActiveCol'*/: break;
					case 'toprowbottompane' /*case 'TopRowBottomPane'*/: break;
					case 'leftcolumnrightpane' /*case 'LeftColumnRightPane'*/: break;

					case 'unsynced' /*case 'Unsynced'*/: break;
					case 'print' /*case 'Print'*/: break;
					case 'printerrors' /*case 'PrintErrors'*/: break;
					case 'panes' /*case 'Panes'*/: break;
					case 'scale' /*case 'Scale'*/: break;
					case 'pane' /*case 'Pane'*/: break;
					case 'number' /*case 'Number'*/: break;
					case 'layout' /*case 'Layout'*/: break;
					case 'pagesetup' /*case 'PageSetup'*/: break;
					case 'selected' /*case 'Selected'*/: break;
					case 'protectobjects' /*case 'ProtectObjects'*/: break;
					case 'enableselection' /*case 'EnableSelection'*/: break;
					case 'protectscenarios' /*case 'ProtectScenarios'*/: break;
					case 'validprinterinfo' /*case 'ValidPrinterInfo'*/: break;
					case 'horizontalresolution' /*case 'HorizontalResolution'*/: break;
					case 'verticalresolution' /*case 'VerticalResolution'*/: break;
					case 'numberofcopies' /*case 'NumberofCopies'*/: break;
					case 'activepane' /*case 'ActivePane'*/: break;
					case 'toprowvisible' /*case 'TopRowVisible'*/: break;
					case 'leftcolumnvisible' /*case 'LeftColumnVisible'*/: break;
					case 'fittopage' /*case 'FitToPage'*/: break;
					case 'rangeselection' /*case 'RangeSelection'*/: break;
					case 'papersizeindex' /*case 'PaperSizeIndex'*/: break;
					case 'pagelayoutzoom' /*case 'PageLayoutZoom'*/: break;
					case 'pagebreakzoom' /*case 'PageBreakZoom'*/: break;
					case 'filteron' /*case 'FilterOn'*/: break;
					case 'fitwidth' /*case 'FitWidth'*/: break;
					case 'fitheight' /*case 'FitHeight'*/: break;
					case 'commentslayout' /*case 'CommentsLayout'*/: break;
					case 'zoom' /*case 'Zoom'*/: break;
					case 'lefttoright' /*case 'LeftToRight'*/: break;
					case 'gridlines' /*case 'Gridlines'*/: break;
					case 'allowsort' /*case 'AllowSort'*/: break;
					case 'allowfilter' /*case 'AllowFilter'*/: break;
					case 'allowinsertrows' /*case 'AllowInsertRows'*/: break;
					case 'allowdeleterows' /*case 'AllowDeleteRows'*/: break;
					case 'allowinsertcols' /*case 'AllowInsertCols'*/: break;
					case 'allowdeletecols' /*case 'AllowDeleteCols'*/: break;
					case 'allowinserthyperlinks' /*case 'AllowInsertHyperlinks'*/: break;
					case 'allowformatcells' /*case 'AllowFormatCells'*/: break;
					case 'allowsizecols' /*case 'AllowSizeCols'*/: break;
					case 'allowsizerows' /*case 'AllowSizeRows'*/: break;
					case 'nosummaryrowsbelowdetail' /*case 'NoSummaryRowsBelowDetail'*/:
						if(!cursheet["!outline"]) cursheet["!outline"] = {};
						cursheet["!outline"].above = true;
						break;
					case 'tabcolorindex' /*case 'TabColorIndex'*/: break;
					case 'donotdisplayheadings' /*case 'DoNotDisplayHeadings'*/: break;
					case 'showpagelayoutzoom' /*case 'ShowPageLayoutZoom'*/: break;
					case 'nosummarycolumnsrightdetail' /*case 'NoSummaryColumnsRightDetail'*/:
						if(!cursheet["!outline"]) cursheet["!outline"] = {};
						cursheet["!outline"].left = true;
						break;
					case 'blackandwhite' /*case 'BlackAndWhite'*/: break;
					case 'donotdisplayzeros' /*case 'DoNotDisplayZeros'*/: break;
					case 'displaypagebreak' /*case 'DisplayPageBreak'*/: break;
					case 'rowcolheadings' /*case 'RowColHeadings'*/: break;
					case 'donotdisplayoutline' /*case 'DoNotDisplayOutline'*/: break;
					case 'noorientation' /*case 'NoOrientation'*/: break;
					case 'allowusepivottables' /*case 'AllowUsePivotTables'*/: break;
					case 'zeroheight' /*case 'ZeroHeight'*/: break;
					case 'viewablerange' /*case 'ViewableRange'*/: break;
					case 'selection' /*case 'Selection'*/: break;
					case 'protectcontents' /*case 'ProtectContents'*/: break;
					default: seen = false;
				} break;

				/* PivotTable */
				case 'pivottable' /*case 'PivotTable'*/: case 'pivotcache' /*case 'PivotCache'*/: switch(Rn[3]) {
					case 'immediateitemsondrop' /*case 'ImmediateItemsOnDrop'*/: break;
					case 'showpagemultipleitemlabel' /*case 'ShowPageMultipleItemLabel'*/: break;
					case 'compactrowindent' /*case 'CompactRowIndent'*/: break;
					case 'location' /*case 'Location'*/: break;
					case 'pivotfield' /*case 'PivotField'*/: break;
					case 'orientation' /*case 'Orientation'*/: break;
					case 'layoutform' /*case 'LayoutForm'*/: break;
					case 'layoutsubtotallocation' /*case 'LayoutSubtotalLocation'*/: break;
					case 'layoutcompactrow' /*case 'LayoutCompactRow'*/: break;
					case 'position' /*case 'Position'*/: break;
					case 'pivotitem' /*case 'PivotItem'*/: break;
					case 'datatype' /*case 'DataType'*/: break;
					case 'datafield' /*case 'DataField'*/: break;
					case 'sourcename' /*case 'SourceName'*/: break;
					case 'parentfield' /*case 'ParentField'*/: break;
					case 'ptlineitems' /*case 'PTLineItems'*/: break;
					case 'ptlineitem' /*case 'PTLineItem'*/: break;
					case 'countofsameitems' /*case 'CountOfSameItems'*/: break;
					case 'item' /*case 'Item'*/: break;
					case 'itemtype' /*case 'ItemType'*/: break;
					case 'ptsource' /*case 'PTSource'*/: break;
					case 'cacheindex' /*case 'CacheIndex'*/: break;
					case 'consolidationreference' /*case 'ConsolidationReference'*/: break;
					case 'filename' /*case 'FileName'*/: break;
					case 'reference' /*case 'Reference'*/: break;
					case 'nocolumngrand' /*case 'NoColumnGrand'*/: break;
					case 'norowgrand' /*case 'NoRowGrand'*/: break;
					case 'blanklineafteritems' /*case 'BlankLineAfterItems'*/: break;
					case 'hidden' /*case 'Hidden'*/: break;
					case 'subtotal' /*case 'Subtotal'*/: break;
					case 'basefield' /*case 'BaseField'*/: break;
					case 'mapchilditems' /*case 'MapChildItems'*/: break;
					case 'function' /*case 'Function'*/: break;
					case 'refreshonfileopen' /*case 'RefreshOnFileOpen'*/: break;
					case 'printsettitles' /*case 'PrintSetTitles'*/: break;
					case 'mergelabels' /*case 'MergeLabels'*/: break;
					case 'defaultversion' /*case 'DefaultVersion'*/: break;
					case 'refreshname' /*case 'RefreshName'*/: break;
					case 'refreshdate' /*case 'RefreshDate'*/: break;
					case 'refreshdatecopy' /*case 'RefreshDateCopy'*/: break;
					case 'versionlastrefresh' /*case 'VersionLastRefresh'*/: break;
					case 'versionlastupdate' /*case 'VersionLastUpdate'*/: break;
					case 'versionupdateablemin' /*case 'VersionUpdateableMin'*/: break;
					case 'versionrefreshablemin' /*case 'VersionRefreshableMin'*/: break;
					case 'calculation' /*case 'Calculation'*/: break;
					default: seen = false;
				} break;

				/* PageBreaks */
				case 'pagebreaks' /*case 'PageBreaks'*/: switch(Rn[3]) {
					case 'colbreaks' /*case 'ColBreaks'*/: break;
					case 'colbreak' /*case 'ColBreak'*/: break;
					case 'rowbreaks' /*case 'RowBreaks'*/: break;
					case 'rowbreak' /*case 'RowBreak'*/: break;
					case 'colstart' /*case 'ColStart'*/: break;
					case 'colend' /*case 'ColEnd'*/: break;
					case 'rowend' /*case 'RowEnd'*/: break;
					default: seen = false;
				} break;

				/* AutoFilter */
				case 'autofilter' /*case 'AutoFilter'*/: switch(Rn[3]) {
					case 'autofiltercolumn' /*case 'AutoFilterColumn'*/: break;
					case 'autofiltercondition' /*case 'AutoFilterCondition'*/: break;
					case 'autofilterand' /*case 'AutoFilterAnd'*/: break;
					case 'autofilteror' /*case 'AutoFilterOr'*/: break;
					default: seen = false;
				} break;

				/* QueryTable */
				case 'querytable' /*case 'QueryTable'*/: switch(Rn[3]) {
					case 'id' /*case 'Id'*/: break;
					case 'autoformatfont' /*case 'AutoFormatFont'*/: break;
					case 'autoformatpattern' /*case 'AutoFormatPattern'*/: break;
					case 'querysource' /*case 'QuerySource'*/: break;
					case 'querytype' /*case 'QueryType'*/: break;
					case 'enableredirections' /*case 'EnableRedirections'*/: break;
					case 'refreshedinxl9' /*case 'RefreshedInXl9'*/: break;
					case 'urlstring' /*case 'URLString'*/: break;
					case 'htmltables' /*case 'HTMLTables'*/: break;
					case 'connection' /*case 'Connection'*/: break;
					case 'commandtext' /*case 'CommandText'*/: break;
					case 'refreshinfo' /*case 'RefreshInfo'*/: break;
					case 'notitles' /*case 'NoTitles'*/: break;
					case 'nextid' /*case 'NextId'*/: break;
					case 'columninfo' /*case 'ColumnInfo'*/: break;
					case 'overwritecells' /*case 'OverwriteCells'*/: break;
					case 'donotpromptforfile' /*case 'DoNotPromptForFile'*/: break;
					case 'textwizardsettings' /*case 'TextWizardSettings'*/: break;
					case 'source' /*case 'Source'*/: break;
					case 'number' /*case 'Number'*/: break;
					case 'decimal' /*case 'Decimal'*/: break;
					case 'thousandseparator' /*case 'ThousandSeparator'*/: break;
					case 'trailingminusnumbers' /*case 'TrailingMinusNumbers'*/: break;
					case 'formatsettings' /*case 'FormatSettings'*/: break;
					case 'fieldtype' /*case 'FieldType'*/: break;
					case 'delimiters' /*case 'Delimiters'*/: break;
					case 'tab' /*case 'Tab'*/: break;
					case 'comma' /*case 'Comma'*/: break;
					case 'autoformatname' /*case 'AutoFormatName'*/: break;
					case 'versionlastedit' /*case 'VersionLastEdit'*/: break;
					case 'versionlastrefresh' /*case 'VersionLastRefresh'*/: break;
					default: seen = false;
				} break;

				case 'datavalidation' /*case 'DataValidation'*/:
				switch(Rn[3]) {
					case 'range' /*case 'Range'*/: break;

					case 'type' /*case 'Type'*/: break;
					case 'min' /*case 'Min'*/: break;
					case 'max' /*case 'Max'*/: break;
					case 'sort' /*case 'Sort'*/: break;
					case 'descending' /*case 'Descending'*/: break;
					case 'order' /*case 'Order'*/: break;
					case 'casesensitive' /*case 'CaseSensitive'*/: break;
					case 'value' /*case 'Value'*/: break;
					case 'errorstyle' /*case 'ErrorStyle'*/: break;
					case 'errormessage' /*case 'ErrorMessage'*/: break;
					case 'errortitle' /*case 'ErrorTitle'*/: break;
					case 'inputmessage' /*case 'InputMessage'*/: break;
					case 'inputtitle' /*case 'InputTitle'*/: break;
					case 'combohide' /*case 'ComboHide'*/: break;
					case 'inputhide' /*case 'InputHide'*/: break;
					case 'condition' /*case 'Condition'*/: break;
					case 'qualifier' /*case 'Qualifier'*/: break;
					case 'useblank' /*case 'UseBlank'*/: break;
					case 'value1' /*case 'Value1'*/: break;
					case 'value2' /*case 'Value2'*/: break;
					case 'format' /*case 'Format'*/: break;

					case 'cellrangelist' /*case 'CellRangeList'*/: break;
					default: seen = false;
				} break;

				case 'sorting' /*case 'Sorting'*/:
				case 'conditionalformatting' /*case 'ConditionalFormatting'*/:
				switch(Rn[3]) {
					case 'range' /*case 'Range'*/: break;
					case 'type' /*case 'Type'*/: break;
					case 'min' /*case 'Min'*/: break;
					case 'max' /*case 'Max'*/: break;
					case 'sort' /*case 'Sort'*/: break;
					case 'descending' /*case 'Descending'*/: break;
					case 'order' /*case 'Order'*/: break;
					case 'casesensitive' /*case 'CaseSensitive'*/: break;
					case 'value' /*case 'Value'*/: break;
					case 'errorstyle' /*case 'ErrorStyle'*/: break;
					case 'errormessage' /*case 'ErrorMessage'*/: break;
					case 'errortitle' /*case 'ErrorTitle'*/: break;
					case 'cellrangelist' /*case 'CellRangeList'*/: break;
					case 'inputmessage' /*case 'InputMessage'*/: break;
					case 'inputtitle' /*case 'InputTitle'*/: break;
					case 'combohide' /*case 'ComboHide'*/: break;
					case 'inputhide' /*case 'InputHide'*/: break;
					case 'condition' /*case 'Condition'*/: break;
					case 'qualifier' /*case 'Qualifier'*/: break;
					case 'useblank' /*case 'UseBlank'*/: break;
					case 'value1' /*case 'Value1'*/: break;
					case 'value2' /*case 'Value2'*/: break;
					case 'format' /*case 'Format'*/: break;
					default: seen = false;
				} break;

				/* MapInfo (schema) */
				case 'mapinfo' /*case 'MapInfo'*/: case 'schema' /*case 'Schema'*/: case 'data' /*case 'data'*/: switch(Rn[3]) {
					case 'map' /*case 'Map'*/: break;
					case 'entry' /*case 'Entry'*/: break;
					case 'range' /*case 'Range'*/: break;
					case 'xpath' /*case 'XPath'*/: break;
					case 'field' /*case 'Field'*/: break;
					case 'xsdtype' /*case 'XSDType'*/: break;
					case 'filteron' /*case 'FilterOn'*/: break;
					case 'aggregate' /*case 'Aggregate'*/: break;
					case 'elementtype' /*case 'ElementType'*/: break;
					case 'attributetype' /*case 'AttributeType'*/: break;
				/* These are from xsd (XML Schema Definition) */
					case 'schema' /*case 'schema'*/:
					case 'element' /*case 'element'*/:
					case 'complextype' /*case 'complexType'*/:
					case 'datatype' /*case 'datatype'*/:
					case 'all' /*case 'all'*/:
					case 'attribute' /*case 'attribute'*/:
					case 'extends' /*case 'extends'*/: break;

					case 'row' /*case 'row'*/: break;
					default: seen = false;
				} break;

				/* SmartTags (can be anything) */
				case 'smarttags' /*case 'SmartTags'*/: break;

				default: seen = false; break;
			}
			if(seen) break;
			/* CustomDocumentProperties */
			if(Rn[3].match(/!\[CDATA/)) break;
			if(!state[state.length-1][1]) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
			if(state[state.length-1][0]===/*'CustomDocumentProperties'*/'customdocumentproperties') {
				if(Rn[0].slice(-2) === "/>") break;
				else if(Rn[1]==="/") xlml_set_custprop(Custprops, raw_Rn3, cp, str.slice(pidx, Rn.index));
				else { cp = Rn; pidx = Rn.index + Rn[0].length; }
				break;
			}
			if(opts.WTF) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
	}
	var out = ({});
	if(!opts.bookSheets && !opts.bookProps) out.Sheets = sheets;
	out.SheetNames = sheetnames;
	out.Workbook = Workbook;
	out.SSF = dup(table_fmt);
	out.Props = Props;
	out.Custprops = Custprops;
	out.bookType = "xlml";
	return out;
}

function parse_xlml(data, opts) {
	fix_read_opts(opts=opts||{});
	switch(opts.type||"base64") {
		case "base64": return parse_xlml_xml(Base64_decode(data), opts);
		case "binary": case "buffer": case "file": return parse_xlml_xml(data, opts);
		case "array": return parse_xlml_xml(a2s(data), opts);
	}
}

/* TODO */
function write_props_xlml(wb, opts) {
	var o = [];
	/* DocumentProperties */
	if(wb.Props) o.push(xlml_write_docprops(wb.Props, opts));
	/* CustomDocumentProperties */
	if(wb.Custprops) o.push(xlml_write_custprops(wb.Props, wb.Custprops, opts));
	return o.join("");
}
/* TODO */
function write_wb_xlml(wb) {
	/* OfficeDocumentSettings */
	/* ExcelWorkbook */
	if((((wb||{}).Workbook||{}).WBProps||{}).date1904) return '<ExcelWorkbook xmlns="urn:schemas-microsoft-com:office:excel"><Date1904/></ExcelWorkbook>';
	return "";
}
/* TODO */
function write_sty_xlml(wb, opts) {
	/* Styles */
	var styles = ['<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'];
	opts.cellXfs.forEach(function(xf, id) {
		var payload = [];
		payload.push(writextag('NumberFormat', null, {"ss:Format": escapexml(table_fmt[xf.numFmtId])}));

		var o = {"ss:ID": "s" + (21+id)};
		styles.push(writextag('Style', payload.join(""), o));
	});
	return writextag("Styles", styles.join(""));
}
function write_name_xlml(n) { return writextag("NamedRange", null, {"ss:Name": n.Name.slice(0,6) == "_xlnm." ? n.Name.slice(6) : n.Name, "ss:RefersTo":"=" + a1_to_rc(n.Ref, {r:0,c:0})}); }
function write_names_xlml(wb) {
	if(!((wb||{}).Workbook||{}).Names) return "";
var names = wb.Workbook.Names;
	var out = [];
	for(var i = 0; i < names.length; ++i) {
		var n = names[i];
		if(n.Sheet != null) continue;
		if(n.Name.match(/^_xlfn\./)) continue;
		out.push(write_name_xlml(n));
	}
	return writextag("Names", out.join(""));
}
function write_ws_xlml_names(ws, opts, idx, wb) {
	if(!ws) return "";
	if(!((wb||{}).Workbook||{}).Names) return "";
var names = wb.Workbook.Names;
	var out = [];
	for(var i = 0; i < names.length; ++i) {
		var n = names[i];
		if(n.Sheet != idx) continue;
		/*switch(n.Name) {
			case "_": continue;
		}*/
		if(n.Name.match(/^_xlfn\./)) continue;
		out.push(write_name_xlml(n));
	}
	return out.join("");
}
/* WorksheetOptions */
function write_ws_xlml_wsopts(ws, opts, idx, wb) {
	if(!ws) return "";
	var o = [];
	/* NOTE: spec technically allows any order, but stick with implied order */

	/* FitToPage */
	/* DoNotDisplayColHeaders */
	/* DoNotDisplayRowHeaders */
	/* ViewableRange */
	/* Selection */
	/* GridlineColor */
	/* Name */
	/* ExcelWorksheetType */
	/* IntlMacro */
	/* Unsynced */
	/* Selected */
	/* CodeName */

	if(ws['!margins']) {
		o.push("<PageSetup>");
		if(ws['!margins'].header) o.push(writextag("Header", null, {'x:Margin':ws['!margins'].header}));
		if(ws['!margins'].footer) o.push(writextag("Footer", null, {'x:Margin':ws['!margins'].footer}));
		o.push(writextag("PageMargins", null, {
			'x:Bottom': ws['!margins'].bottom || "0.75",
			'x:Left': ws['!margins'].left || "0.7",
			'x:Right': ws['!margins'].right || "0.7",
			'x:Top': ws['!margins'].top || "0.75"
		}));
		o.push("</PageSetup>");
	}

	/* PageSetup */
	/* DisplayPageBreak */
	/* TransitionExpressionEvaluation */
	/* TransitionFormulaEntry */
	/* Print */
	/* Zoom */
	/* PageLayoutZoom */
	/* PageBreakZoom */
	/* ShowPageBreakZoom */
	/* DefaultRowHeight */
	/* DefaultColumnWidth */
	/* StandardWidth */

	if(wb && wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx]) {
		/* Visible */
		if(wb.Workbook.Sheets[idx].Hidden) o.push(writextag("Visible", (wb.Workbook.Sheets[idx].Hidden == 1 ? "SheetHidden" : "SheetVeryHidden"), {}));
		else {
			/* Selected */
			for(var i = 0; i < idx; ++i) if(wb.Workbook.Sheets[i] && !wb.Workbook.Sheets[i].Hidden) break;
			if(i == idx) o.push("<Selected/>");
		}
	}

	/* LeftColumnVisible */

	if(((((wb||{}).Workbook||{}).Views||[])[0]||{}).RTL) o.push("<DisplayRightToLeft/>");

	/* GridlineColorIndex */
	/* DisplayFormulas */
	/* DoNotDisplayGridlines */
	/* DoNotDisplayHeadings */
	/* DoNotDisplayOutline */
	/* ApplyAutomaticOutlineStyles */
	/* NoSummaryRowsBelowDetail */
	/* NoSummaryColumnsRightDetail */
	/* DoNotDisplayZeros */
	/* ActiveRow */
	/* ActiveColumn */
	/* FilterOn */
	/* RangeSelection */
	/* TopRowVisible */
	/* TopRowBottomPane */
	/* LeftColumnRightPane */
	/* ActivePane */
	/* SplitHorizontal */
	/* SplitVertical */
	/* FreezePanes */
	/* FrozenNoSplit */
	/* TabColorIndex */
	/* Panes */

	/* NOTE: Password not supported in XLML Format */
	if(ws['!protect']) {
		o.push(writetag("ProtectContents", "True"));
		if(ws['!protect'].objects) o.push(writetag("ProtectObjects", "True"));
		if(ws['!protect'].scenarios) o.push(writetag("ProtectScenarios", "True"));
		if(ws['!protect'].selectLockedCells != null && !ws['!protect'].selectLockedCells) o.push(writetag("EnableSelection", "NoSelection"));
		else if(ws['!protect'].selectUnlockedCells != null && !ws['!protect'].selectUnlockedCells) o.push(writetag("EnableSelection", "UnlockedCells"));
	[
		[ "formatCells", "AllowFormatCells" ],
		[ "formatColumns", "AllowSizeCols" ],
		[ "formatRows", "AllowSizeRows" ],
		[ "insertColumns", "AllowInsertCols" ],
		[ "insertRows", "AllowInsertRows" ],
		[ "insertHyperlinks", "AllowInsertHyperlinks" ],
		[ "deleteColumns", "AllowDeleteCols" ],
		[ "deleteRows", "AllowDeleteRows" ],
		[ "sort", "AllowSort" ],
		[ "autoFilter", "AllowFilter" ],
		[ "pivotTables", "AllowUsePivotTables" ]
	].forEach(function(x) { if(ws['!protect'][x[0]]) o.push("<"+x[1]+"/>"); });
	}

	if(o.length == 0) return "";
	return writextag("WorksheetOptions", o.join(""), {xmlns:XLMLNS.x});
}
function write_ws_xlml_comment(comments) {
	return comments.map(function(c) {
		// TODO: formatted text
		var t = xlml_unfixstr(c.t||"");
		var d =writextag("ss:Data", t, {"xmlns":"http://www.w3.org/TR/REC-html40"});
		return writextag("Comment", d, {"ss:Author":c.a});
	}).join("");
}
function write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr){
	if(!cell || (cell.v == undefined && cell.f == undefined)) return "";

	var attr = {};
	if(cell.f) attr["ss:Formula"] = "=" + escapexml(a1_to_rc(cell.f, addr));
	if(cell.F && cell.F.slice(0, ref.length) == ref) {
		var end = decode_cell(cell.F.slice(ref.length + 1));
		attr["ss:ArrayRange"] = "RC:R" + (end.r == addr.r ? "" : "[" + (end.r - addr.r) + "]") + "C" + (end.c == addr.c ? "" : "[" + (end.c - addr.c) + "]");
	}

	if(cell.l && cell.l.Target) {
		attr["ss:HRef"] = escapexml(cell.l.Target);
		if(cell.l.Tooltip) attr["x:HRefScreenTip"] = escapexml(cell.l.Tooltip);
	}

	if(ws['!merges']) {
		var marr = ws['!merges'];
		for(var mi = 0; mi != marr.length; ++mi) {
			if(marr[mi].s.c != addr.c || marr[mi].s.r != addr.r) continue;
			if(marr[mi].e.c > marr[mi].s.c) attr['ss:MergeAcross'] = marr[mi].e.c - marr[mi].s.c;
			if(marr[mi].e.r > marr[mi].s.r) attr['ss:MergeDown'] = marr[mi].e.r - marr[mi].s.r;
		}
	}

	var t = "", p = "";
	switch(cell.t) {
		case 'z': if(!opts.sheetStubs) return ""; break;
		case 'n': t = 'Number'; p = String(cell.v); break;
		case 'b': t = 'Boolean'; p = (cell.v ? "1" : "0"); break;
		case 'e': t = 'Error'; p = BErr[cell.v]; break;
		case 'd': t = 'DateTime'; p = new Date(cell.v).toISOString(); if(cell.z == null) cell.z = cell.z || table_fmt[14]; break;
		case 's': t = 'String'; p = escapexlml(cell.v||""); break;
	}
	/* TODO: cell style */
	var os = get_cell_style(opts.cellXfs, cell, opts);
	attr["ss:StyleID"] = "s" + (21+os);
	attr["ss:Index"] = addr.c + 1;
	var _v = (cell.v != null ? p : "");
	var m = cell.t == 'z' ? "" : ('<Data ss:Type="' + t + '">' + _v + '</Data>');

	if((cell.c||[]).length > 0) m += write_ws_xlml_comment(cell.c);

	return writextag("Cell", m, attr);
}
function write_ws_xlml_row(R, row) {
	var o = '<Row ss:Index="' + (R+1) + '"';
	if(row) {
		if(row.hpt && !row.hpx) row.hpx = pt2px(row.hpt);
		if(row.hpx) o += ' ss:AutoFitHeight="0" ss:Height="' + row.hpx + '"';
		if(row.hidden) o += ' ss:Hidden="1"';
	}
	return o + '>';
}
/* TODO */
function write_ws_xlml_table(ws, opts, idx, wb) {
	if(!ws['!ref']) return "";
	var range = safe_decode_range(ws['!ref']);
	var marr = ws['!merges'] || [], mi = 0;
	var o = [];
	if(ws['!cols']) ws['!cols'].forEach(function(n, i) {
		process_col(n);
		var w = !!n.width;
		var p = col_obj_w(i, n);
		var k = {"ss:Index":i+1};
		if(w) k['ss:Width'] = width2px(p.width);
		if(n.hidden) k['ss:Hidden']="1";
		o.push(writextag("Column",null,k));
	});
	var dense = Array.isArray(ws);
	for(var R = range.s.r; R <= range.e.r; ++R) {
		var row = [write_ws_xlml_row(R, (ws['!rows']||[])[R])];
		for(var C = range.s.c; C <= range.e.c; ++C) {
			var skip = false;
			for(mi = 0; mi != marr.length; ++mi) {
				if(marr[mi].s.c > C) continue;
				if(marr[mi].s.r > R) continue;
				if(marr[mi].e.c < C) continue;
				if(marr[mi].e.r < R) continue;
				if(marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
				break;
			}
			if(skip) continue;
			var addr = {r:R,c:C};
			var ref = encode_cell(addr), cell = dense ? (ws[R]||[])[C] : ws[ref];
			row.push(write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr));
		}
		row.push("</Row>");
		if(row.length > 2) o.push(row.join(""));
	}
	return o.join("");
}
function write_ws_xlml(idx, opts, wb) {
	var o = [];
	var s = wb.SheetNames[idx];
	var ws = wb.Sheets[s];

	var t = ws ? write_ws_xlml_names(ws, opts, idx, wb) : "";
	if(t.length > 0) o.push("<Names>" + t + "</Names>");

	/* Table */
	t = ws ? write_ws_xlml_table(ws, opts, idx, wb) : "";
	if(t.length > 0) o.push("<Table>" + t + "</Table>");

	/* WorksheetOptions */
	o.push(write_ws_xlml_wsopts(ws, opts, idx, wb));

	if(ws["!autofilter"]) o.push('<AutoFilter x:Range="' + a1_to_rc(fix_range(ws["!autofilter"].ref), {r:0,c:0}) + '" xmlns="urn:schemas-microsoft-com:office:excel"></AutoFilter>');

	return o.join("");
}
function write_xlml(wb, opts) {
	if(!opts) opts = {};
	if(!wb.SSF) wb.SSF = dup(table_fmt);
	if(wb.SSF) {
		make_ssf(); SSF_load_table(wb.SSF);
		// $FlowIgnore
		opts.revssf = evert_num(wb.SSF); opts.revssf[wb.SSF[65535]] = 0;
		opts.ssf = wb.SSF;
		opts.cellXfs = [];
		get_cell_style(opts.cellXfs, {}, {revssf:{"General":0}});
	}
	var d = [];
	d.push(write_props_xlml(wb, opts));
	d.push(write_wb_xlml(wb, opts));
	d.push("");
	d.push("");
	for(var i = 0; i < wb.SheetNames.length; ++i)
		d.push(writextag("Worksheet", write_ws_xlml(i, opts, wb), {"ss:Name":escapexml(wb.SheetNames[i])}));
	d[2] = write_sty_xlml(wb, opts);
	d[3] = write_names_xlml(wb, opts);
	return XML_HEADER + writextag("Workbook", d.join(""), {
		'xmlns':      XLMLNS.ss,
		'xmlns:o':    XLMLNS.o,
		'xmlns:x':    XLMLNS.x,
		'xmlns:ss':   XLMLNS.ss,
		'xmlns:dt':   XLMLNS.dt,
		'xmlns:html': XLMLNS.html
	});
}
/* [MS-OLEDS] 2.3.8 CompObjStream */
function parse_compobj(obj) {
	var v = {};
	var o = obj.content;
/* [MS-OLEDS] 2.3.7 CompObjHeader -- All fields MUST be ignored */
	o.l = 28;

	v.AnsiUserType = o.read_shift(0, "lpstr-ansi");
	v.AnsiClipboardFormat = parse_ClipboardFormatOrAnsiString(o);

	if(o.length - o.l <= 4) return v;

	var m = o.read_shift(4);
	if(m == 0 || m > 40) return v;
	o.l-=4; v.Reserved1 = o.read_shift(0, "lpstr-ansi");

	if(o.length - o.l <= 4) return v;
	m = o.read_shift(4);
	if(m !== 0x71b239f4) return v;
	v.UnicodeClipboardFormat = parse_ClipboardFormatOrUnicodeString(o);

	m = o.read_shift(4);
	if(m == 0 || m > 40) return v;
	o.l-=4; v.Reserved2 = o.read_shift(0, "lpwstr");
}

/*
	Continue logic for:
	- 2.4.58 Continue          0x003c
	- 2.4.59 ContinueBigName   0x043c
	- 2.4.60 ContinueFrt       0x0812
	- 2.4.61 ContinueFrt11     0x0875
	- 2.4.62 ContinueFrt12     0x087f
*/
var CONTINUE_RT = [ 0x003c, 0x043c, 0x0812, 0x0875, 0x087f ];
function slurp(RecordType, R, blob, length, opts) {
	var l = length;
	var bufs = [];
	var d = blob.slice(blob.l,blob.l+l);
	if(opts && opts.enc && opts.enc.insitu && d.length > 0) switch(RecordType) {
	case 0x0009: case 0x0209: case 0x0409: case 0x0809/* BOF */: case 0x002F /* FilePass */: case 0x0195 /* FileLock */: case 0x00E1 /* InterfaceHdr */: case 0x0196 /* RRDInfo */: case 0x0138 /* RRDHead */: case 0x0194 /* UsrExcl */: case 0x000a /* EOF */:
		break;
	case 0x0085 /* BoundSheet8 */:
		break;
	default:
		opts.enc.insitu(d);
	}
	bufs.push(d);
	blob.l += l;
	var nextrt = __readUInt16LE(blob,blob.l), next = XLSRecordEnum[nextrt];
	var start = 0;
	while(next != null && CONTINUE_RT.indexOf(nextrt) > -1) {
		l = __readUInt16LE(blob,blob.l+2);
		start = blob.l + 4;
		if(nextrt == 0x0812 /* ContinueFrt */) start += 4;
		else if(nextrt == 0x0875 || nextrt == 0x087f) {
			start += 12;
		}
		d = blob.slice(start,blob.l+4+l);
		bufs.push(d);
		blob.l += 4+l;
		next = (XLSRecordEnum[nextrt = __readUInt16LE(blob, blob.l)]);
	}
	var b = (bconcat(bufs));
	prep_blob(b, 0);
	var ll = 0; b.lens = [];
	for(var j = 0; j < bufs.length; ++j) { b.lens.push(ll); ll += bufs[j].length; }
	if(b.length < length) throw "XLS Record 0x" + RecordType.toString(16) + " Truncated: " + b.length + " < " + length;
	return R.f(b, b.length, opts);
}

function safe_format_xf(p, opts, date1904) {
	if(p.t === 'z') return;
	if(!p.XF) return;
	var fmtid = 0;
	try {
		fmtid = p.z || p.XF.numFmtId || 0;
		if(opts.cellNF) p.z = table_fmt[fmtid];
	} catch(e) { if(opts.WTF) throw e; }
	if(!opts || opts.cellText !== false) try {
		if(p.t === 'e') { p.w = p.w || BErr[p.v]; }
		else if(fmtid === 0 || fmtid == "General") {
			if(p.t === 'n') {
				if((p.v|0) === p.v) p.w = p.v.toString(10);
				else p.w = SSF_general_num(p.v);
			}
			else p.w = SSF_general(p.v);
		}
		else p.w = SSF_format(fmtid,p.v, {date1904:!!date1904, dateNF: opts && opts.dateNF});
	} catch(e) { if(opts.WTF) throw e; }
	if(opts.cellDates && fmtid && p.t == 'n' && fmt_is_date(table_fmt[fmtid] || String(fmtid))) {
		var _d = SSF_parse_date_code(p.v); if(_d) { p.t = 'd'; p.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
	}
}

function make_cell(val, ixfe, t) {
	return ({v:val, ixfe:ixfe, t:t});
}

// 2.3.2
function parse_workbook(blob, options) {
	var wb = ({opts:{}});
	var Sheets = {};
	if(DENSE != null && options.dense == null) options.dense = DENSE;
	var out = ((options.dense ? [] : {}));
	var Directory = {};
	var range = ({});
	var last_formula = null;
	var sst = ([]);
	var cur_sheet = "";
	var Preamble = {};
	var lastcell, last_cell = "", cc, cmnt, rngC, rngR;
	var sharedf = {};
	var arrayf = [];
	var temp_val;
	var country;
	var XFs = []; /* XF records */
	var palette = [];
	var Workbook = ({ Sheets:[], WBProps:{date1904:false}, Views:[{}] }), wsprops = {};
	var get_rgb = function getrgb(icv) {
		if(icv < 8) return XLSIcv[icv];
		if(icv < 64) return palette[icv-8] || XLSIcv[icv];
		return XLSIcv[icv];
	};
	var process_cell_style = function pcs(cell, line, options) {
		var xfd = line.XF.data;
		if(!xfd || !xfd.patternType || !options || !options.cellStyles) return;
		line.s = ({});
		line.s.patternType = xfd.patternType;
		var t;
		if((t = rgb2Hex(get_rgb(xfd.icvFore)))) { line.s.fgColor = {rgb:t}; }
		if((t = rgb2Hex(get_rgb(xfd.icvBack)))) { line.s.bgColor = {rgb:t}; }
	};
	var addcell = function addcell(cell, line, options) {
		if(file_depth > 1) return;
		if(options.sheetRows && cell.r >= options.sheetRows) return;
		if(options.cellStyles && line.XF && line.XF.data) process_cell_style(cell, line, options);
		delete line.ixfe; delete line.XF;
		lastcell = cell;
		last_cell = encode_cell(cell);
		if(!range || !range.s || !range.e) range = {s:{r:0,c:0},e:{r:0,c:0}};
		if(cell.r < range.s.r) range.s.r = cell.r;
		if(cell.c < range.s.c) range.s.c = cell.c;
		if(cell.r + 1 > range.e.r) range.e.r = cell.r + 1;
		if(cell.c + 1 > range.e.c) range.e.c = cell.c + 1;
		if(options.cellFormula && line.f) {
			for(var afi = 0; afi < arrayf.length; ++afi) {
				if(arrayf[afi][0].s.c > cell.c || arrayf[afi][0].s.r > cell.r) continue;
				if(arrayf[afi][0].e.c < cell.c || arrayf[afi][0].e.r < cell.r) continue;
				line.F = encode_range(arrayf[afi][0]);
				if(arrayf[afi][0].s.c != cell.c || arrayf[afi][0].s.r != cell.r) delete line.f;
				if(line.f) line.f = "" + stringify_formula(arrayf[afi][1], range, cell, supbooks, opts);
				break;
			}
		}
		{
			if(options.dense) {
				if(!out[cell.r]) out[cell.r] = [];
				out[cell.r][cell.c] = line;
			} else out[last_cell] = line;
		}
	};
	var opts = ({
		enc: false, // encrypted
		sbcch: 0, // cch in the preceding SupBook
		snames: [], // sheetnames
		sharedf: sharedf, // shared formulae by address
		arrayf: arrayf, // array formulae array
		rrtabid: [], // RRTabId
		lastuser: "", // Last User from WriteAccess
		biff: 8, // BIFF version
		codepage: 0, // CP from CodePage record
		winlocked: 0, // fLockWn from WinProtect
		cellStyles: !!options && !!options.cellStyles,
		WTF: !!options && !!options.wtf
	});
	if(options.password) opts.password = options.password;
	var themes;
	var merges = [];
	var objects = [];
	var colinfo = [], rowinfo = [];
	var seencol = false;
	var supbooks = ([]); // 1-indexed, will hold extern names
	supbooks.SheetNames = opts.snames;
	supbooks.sharedf = opts.sharedf;
	supbooks.arrayf = opts.arrayf;
	supbooks.names = [];
	supbooks.XTI = [];
	var last_RT = 0;
	var file_depth = 0; /* TODO: make a real stack */
	var BIFF2Fmt = 0, BIFF2FmtTable = [];
	var FilterDatabases = []; /* TODO: sort out supbooks and process elsewhere */
	var last_lbl;

	/* explicit override for some broken writers */
	opts.codepage = 1200;
	set_cp(1200);
	var seen_codepage = false;
	while(blob.l < blob.length - 1) {
		var s = blob.l;
		var RecordType = blob.read_shift(2);
		if(RecordType === 0 && last_RT === 0x000a /* EOF */) break;
		var length = (blob.l === blob.length ? 0 : blob.read_shift(2));
		var R = XLSRecordEnum[RecordType];
		if(file_depth == 0 && [0x0009, 0x0209, 0x0409, 0x0809].indexOf(RecordType) == -1 /* BOF */) break;
		//console.log(RecordType.toString(16), RecordType, R, blob.l, length, blob.length);
		//if(!R) console.log(blob.slice(blob.l, blob.l + length));
		if(R && R.f) {
			if(options.bookSheets) {
				if(last_RT === 0x0085 /* BoundSheet8 */ && RecordType !== 0x0085 /* R.n !== 'BoundSheet8' */) break;
			}
			last_RT = RecordType;
			if(R.r === 2 || R.r == 12) {
				var rt = blob.read_shift(2); length -= 2;
				if(!opts.enc && rt !== RecordType && (((rt&0xFF)<<8)|(rt>>8)) !== RecordType) throw new Error("rt mismatch: " + rt + "!=" + RecordType);
				if(R.r == 12){
					blob.l += 10; length -= 10;
				} // skip FRT
			}
			//console.error(R,blob.l,length,blob.length);
			var val = ({});
			if(RecordType === 0x000a /* EOF */) val = R.f(blob, length, opts);
			else val = slurp(RecordType, R, blob, length, opts);
if(file_depth == 0 && [0x0009, 0x0209, 0x0409, 0x0809].indexOf(last_RT) === -1 /* BOF */) continue;
			switch(RecordType) {
				case 0x0022 /* Date1904 */:
wb.opts.Date1904 = Workbook.WBProps.date1904 = val; break;
				case 0x0086 /* WriteProtect */: wb.opts.WriteProtect = true; break;
				case 0x002f /* FilePass */:
					if(!opts.enc) blob.l = 0;
					opts.enc = val;
					if(!options.password) throw new Error("File is password-protected");
					if(val.valid == null) throw new Error("Encryption scheme unsupported");
					if(!val.valid) throw new Error("Password is incorrect");
					break;
				case 0x005c /* WriteAccess */: opts.lastuser = val; break;
				case 0x0042 /* CodePage */:
					var cpval = Number(val);
					/* overrides based on test cases */
					switch(cpval) {
						case 0x5212: cpval =  1200; break;
						case 0x8000: cpval = 10000; break;
						case 0x8001: cpval =  1252; break;
					}
					set_cp(opts.codepage = cpval);
					seen_codepage = true;
					break;
				case 0x013d /* RRTabId */: opts.rrtabid = val; break;
				case 0x0019 /* WinProtect */: opts.winlocked = val; break;
				case 0x01b7 /* RefreshAll */: wb.opts["RefreshAll"] = val; break;
				case 0x000c /* CalcCount */: wb.opts["CalcCount"] = val; break;
				case 0x0010 /* CalcDelta */: wb.opts["CalcDelta"] = val; break;
				case 0x0011 /* CalcIter */: wb.opts["CalcIter"] = val; break;
				case 0x000d /* CalcMode */: wb.opts["CalcMode"] = val; break;
				case 0x000e /* CalcPrecision */: wb.opts["CalcPrecision"] = val; break;
				case 0x005f /* CalcSaveRecalc */: wb.opts["CalcSaveRecalc"] = val; break;
				case 0x000f /* CalcRefMode */: opts.CalcRefMode = val; break; // TODO: implement R1C1
				case 0x08a3 /* ForceFullCalculation */: wb.opts.FullCalc = val; break;
				case 0x0081 /* WsBool */:
					if(val.fDialog) out["!type"] = "dialog";
					if(!val.fBelow) (out["!outline"] || (out["!outline"] = {})).above = true;
					if(!val.fRight) (out["!outline"] || (out["!outline"] = {})).left = true;
					break; // TODO
				case 0x00e0 /* XF */:
					XFs.push(val); break;
				case 0x01ae /* SupBook */:
					supbooks.push([val]);
					supbooks[supbooks.length-1].XTI = [];
					break;
				case 0x0023: case 0x0223 /* ExternName */:
					supbooks[supbooks.length-1].push(val);
					break;
				case 0x0018: case 0x0218 /* Lbl */:
					last_lbl = ({
						Name: val.Name,
						Ref: stringify_formula(val.rgce,range,null,supbooks,opts)
					});
					if(val.itab > 0) last_lbl.Sheet = val.itab - 1;
					supbooks.names.push(last_lbl);
					if(!supbooks[0]) { supbooks[0] = []; supbooks[0].XTI = []; }
					supbooks[supbooks.length-1].push(val);
					if(val.Name == "_xlnm._FilterDatabase" && val.itab > 0)
						if(val.rgce && val.rgce[0] && val.rgce[0][0] && val.rgce[0][0][0] == 'PtgArea3d')
							FilterDatabases[val.itab - 1] = { ref: encode_range(val.rgce[0][0][1][2]) };
					break;
				case 0x0016 /* ExternCount */: opts.ExternCount = val; break;
				case 0x0017 /* ExternSheet */:
					if(supbooks.length == 0) { supbooks[0] = []; supbooks[0].XTI = []; }
					supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val); supbooks.XTI = supbooks.XTI.concat(val); break;
				case 0x0894 /* NameCmt */:
					/* TODO: search for correct name */
					if(opts.biff < 8) break;
					if(last_lbl != null) last_lbl.Comment = val[1];
					break;
				case 0x0012 /* Protect */: out["!protect"] = val; break; /* for sheet or book */
				case 0x0013 /* Password */: if(val !== 0 && opts.WTF) console.error("Password verifier: " + val); break;
				case 0x0085 /* BoundSheet8 */: {
					Directory[val.pos] = val;
					opts.snames.push(val.name);
				} break;
				case 0x000a /* EOF */: {
					if(--file_depth) break;
					if(range.e) {
						if(range.e.r > 0 && range.e.c > 0) {
							range.e.r--; range.e.c--;
							out["!ref"] = encode_range(range);
							if(options.sheetRows && options.sheetRows <= range.e.r) {
								var tmpri = range.e.r;
								range.e.r = options.sheetRows - 1;
								out["!fullref"] = out["!ref"];
								out["!ref"] = encode_range(range);
								range.e.r = tmpri;
							}
							range.e.r++; range.e.c++;
						}
						if(merges.length > 0) out["!merges"] = merges;
						if(objects.length > 0) out["!objects"] = objects;
						if(colinfo.length > 0) out["!cols"] = colinfo;
						if(rowinfo.length > 0) out["!rows"] = rowinfo;
						Workbook.Sheets.push(wsprops);
					}
					if(cur_sheet === "") Preamble = out; else Sheets[cur_sheet] = out;
					out = ((options.dense ? [] : {}));
				} break;
				case 0x0009: case 0x0209: case 0x0409: case 0x0809 /* BOF */: {
					if(opts.biff === 8) opts.biff = {
0x0009:2,
0x0209:3,
0x0409:4
					}[RecordType] || {
0x0200:2,
0x0300:3,
0x0400:4,
0x0500:5,
0x0600:8,
0x0002:2,
0x0007:2
					}[val.BIFFVer] || 8;
					opts.biffguess = val.BIFFVer == 0;
					if(val.BIFFVer == 0 && val.dt == 0x1000) { opts.biff = 5; seen_codepage = true; set_cp(opts.codepage = 28591); }
					if(opts.biff == 8 && val.BIFFVer == 0 && val.dt == 16) opts.biff = 2;
					if(file_depth++) break;
					out = ((options.dense ? [] : {}));

					if(opts.biff < 8 && !seen_codepage) { seen_codepage = true; set_cp(opts.codepage = options.codepage || 1252); }

					if(opts.biff < 5 || val.BIFFVer == 0 && val.dt == 0x1000) {
						if(cur_sheet === "") cur_sheet = "Sheet1";
						range = {s:{r:0,c:0},e:{r:0,c:0}};
						/* fake BoundSheet8 */
						var fakebs8 = {pos: blob.l - length, name:cur_sheet};
						Directory[fakebs8.pos] = fakebs8;
						opts.snames.push(cur_sheet);
					}
					else cur_sheet = (Directory[s] || {name:""}).name;
					if(val.dt == 0x20) out["!type"] = "chart";
					if(val.dt == 0x40) out["!type"] = "macro";
					merges = [];
					objects = [];
					opts.arrayf = arrayf = [];
					colinfo = []; rowinfo = [];
					seencol = false;
					wsprops = {Hidden:(Directory[s]||{hs:0}).hs, name:cur_sheet };
				} break;
				case 0x0203 /* Number */: case 0x0003 /* BIFF2NUM */: case 0x0002 /* BIFF2INT */: {
					if(out["!type"] == "chart") if(options.dense ? (out[val.r]||[])[val.c]: out[encode_cell({c:val.c, r:val.r})]) ++val.c;
					temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe]||{}, v:val.val, t:'n'});
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
				} break;
				case 0x0005: case 0x0205 /* BoolErr */: {
					temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], v:val.val, t:val.t});
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
				} break;
				case 0x027e /* RK */: {
					temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], v:val.rknum, t:'n'});
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
				} break;
				case 0x00bd /* MulRk */: {
					for(var j = val.c; j <= val.C; ++j) {
						var ixfe = val.rkrec[j-val.c][0];
						temp_val= ({ixfe:ixfe, XF:XFs[ixfe], v:val.rkrec[j-val.c][1], t:'n'});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:j, r:val.r}, temp_val, options);
					}
				} break;
				case 0x0006: case 0x0206: case 0x0406 /* Formula */: {
					if(val.val == 'String') { last_formula = val; break; }
					temp_val = make_cell(val.val, val.cell.ixfe, val.tt);
					temp_val.XF = XFs[temp_val.ixfe];
					if(options.cellFormula) {
						var _f = val.formula;
						if(_f && _f[0] && _f[0][0] && _f[0][0][0] == 'PtgExp') {
							var _fr = _f[0][0][1][0], _fc = _f[0][0][1][1];
							var _fe = encode_cell({r:_fr, c:_fc});
							if(sharedf[_fe]) temp_val.f = ""+stringify_formula(val.formula,range,val.cell,supbooks, opts);
							else temp_val.F = ((options.dense ? (out[_fr]||[])[_fc]: out[_fe]) || {}).F;
						} else temp_val.f = ""+stringify_formula(val.formula,range,val.cell,supbooks, opts);
					}
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell(val.cell, temp_val, options);
					last_formula = val;
				} break;
				case 0x0007: case 0x0207 /* String */: {
					if(last_formula) { /* technically always true */
						last_formula.val = val;
						temp_val = make_cell(val, last_formula.cell.ixfe, 's');
						temp_val.XF = XFs[temp_val.ixfe];
						if(options.cellFormula) {
							temp_val.f = ""+stringify_formula(last_formula.formula, range, last_formula.cell, supbooks, opts);
						}
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell(last_formula.cell, temp_val, options);
						last_formula = null;
					} else throw new Error("String record expects Formula");
				} break;
				case 0x0021: case 0x0221 /* Array */: {
					arrayf.push(val);
					var _arraystart = encode_cell(val[0].s);
					cc = options.dense ? (out[val[0].s.r]||[])[val[0].s.c] : out[_arraystart];
					if(options.cellFormula && cc) {
						if(!last_formula) break; /* technically unreachable */
						if(!_arraystart || !cc) break;
						cc.f = ""+stringify_formula(val[1], range, val[0], supbooks, opts);
						cc.F = encode_range(val[0]);
					}
				} break;
				case 0x04bc /* ShrFmla */: {
					if(!options.cellFormula) break;
					if(last_cell) {
						/* TODO: capture range */
						if(!last_formula) break; /* technically unreachable */
						sharedf[encode_cell(last_formula.cell)]= val[0];
						cc = options.dense ? (out[last_formula.cell.r]||[])[last_formula.cell.c] : out[encode_cell(last_formula.cell)];
						(cc||{}).f = ""+stringify_formula(val[0], range, lastcell, supbooks, opts);
					}
				} break;
				case 0x00fd /* LabelSst */:
					temp_val=make_cell(sst[val.isst].t, val.ixfe, 's');
					if(sst[val.isst].h) temp_val.h = sst[val.isst].h;
					temp_val.XF = XFs[temp_val.ixfe];
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
					break;
				case 0x0201 /* Blank */: if(options.sheetStubs) {
					temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], t:'z'});
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
				} break;
				case 0x00be /* MulBlank */: if(options.sheetStubs) {
					for(var _j = val.c; _j <= val.C; ++_j) {
						var _ixfe = val.ixfe[_j-val.c];
						temp_val= ({ixfe:_ixfe, XF:XFs[_ixfe], t:'z'});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:_j, r:val.r}, temp_val, options);
					}
				} break;
				case 0x00d6 /* RString */:
				case 0x0204 /* Label */: case 0x0004 /* BIFF2STR */:
					temp_val=make_cell(val.val, val.ixfe, 's');
					temp_val.XF = XFs[temp_val.ixfe];
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
					break;

				case 0x0000: case 0x0200 /* Dimensions */: {
					if(file_depth === 1) range = val; /* TODO: stack */
				} break;
				case 0x00fc /* SST */: {
					sst = val;
				} break;
				case 0x041e /* Format */: { /* val = [id, fmt] */
					if(opts.biff == 4) {
						BIFF2FmtTable[BIFF2Fmt++] = val[1];
						for(var b4idx = 0; b4idx < BIFF2Fmt + 163; ++b4idx) if(table_fmt[b4idx] == val[1]) break;
						if(b4idx >= 163) SSF__load(val[1], BIFF2Fmt + 163);
					}
					else SSF__load(val[1], val[0]);
				} break;
				case 0x001e /* BIFF2FORMAT */: {
					BIFF2FmtTable[BIFF2Fmt++] = val;
					for(var b2idx = 0; b2idx < BIFF2Fmt + 163; ++b2idx) if(table_fmt[b2idx] == val) break;
					if(b2idx >= 163) SSF__load(val, BIFF2Fmt + 163);
				} break;

				case 0x00e5 /* MergeCells */: merges = merges.concat(val); break;

				case 0x005d /* Obj */: objects[val.cmo[0]] = opts.lastobj = val; break;
				case 0x01b6 /* TxO */: opts.lastobj.TxO = val; break;
				case 0x007f /* ImData */: opts.lastobj.ImData = val; break;

				case 0x01b8 /* HLink */: {
					for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)
						for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC) {
							cc = options.dense ? (out[rngR]||[])[rngC] : out[encode_cell({c:rngC,r:rngR})];
							if(cc) cc.l = val[1];
						}
				} break;
				case 0x0800 /* HLinkTooltip */: {
					for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)
						for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC) {
							cc = options.dense ? (out[rngR]||[])[rngC] : out[encode_cell({c:rngC,r:rngR})];
							if(cc && cc.l) cc.l.Tooltip = val[1];
							}
				} break;
				case 0x001c /* Note */: {
					if(opts.biff <= 5 && opts.biff >= 2) break; /* TODO: BIFF5 */
					cc = options.dense ? (out[val[0].r]||[])[val[0].c] : out[encode_cell(val[0])];
					var noteobj = objects[val[2]];
					if(!cc) {
						if(options.dense) {
							if(!out[val[0].r]) out[val[0].r] = [];
							cc = out[val[0].r][val[0].c] = ({t:"z"});
						} else {
							cc = out[encode_cell(val[0])] = ({t:"z"});
						}
						range.e.r = Math.max(range.e.r, val[0].r);
						range.s.r = Math.min(range.s.r, val[0].r);
						range.e.c = Math.max(range.e.c, val[0].c);
						range.s.c = Math.min(range.s.c, val[0].c);
					}
					if(!cc.c) cc.c = [];
					cmnt = {a:val[1],t:noteobj.TxO.t};
					cc.c.push(cmnt);
				} break;
				case 0x087d /* XFExt */: update_xfext(XFs[val.ixfe], val.ext); break;
				case 0x007d /* ColInfo */: {
					if(!opts.cellStyles) break;
					while(val.e >= val.s) {
						colinfo[val.e--] = { width: val.w/256, level: (val.level || 0), hidden: !!(val.flags & 1) };
						if(!seencol) { seencol = true; find_mdw_colw(val.w/256); }
						process_col(colinfo[val.e+1]);
					}
				} break;
				case 0x0208 /* Row */: {
					var rowobj = {};
					if(val.level != null) { rowinfo[val.r] = rowobj; rowobj.level = val.level; }
					if(val.hidden) { rowinfo[val.r] = rowobj; rowobj.hidden = true; }
					if(val.hpt) {
						rowinfo[val.r] = rowobj;
						rowobj.hpt = val.hpt; rowobj.hpx = pt2px(val.hpt);
					}
				} break;
				case 0x0026 /* LeftMargin */:
				case 0x0027 /* RightMargin */:
				case 0x0028 /* TopMargin */:
				case 0x0029 /* BottomMargin */:
					if(!out['!margins']) default_margins(out['!margins'] = {});
					out['!margins'][({0x26: "left", 0x27:"right", 0x28:"top", 0x29:"bottom"})[RecordType]] = val;
					break;
				case 0x00a1 /* Setup */: // TODO
					if(!out['!margins']) default_margins(out['!margins'] = {});
					out['!margins'].header = val.header;
					out['!margins'].footer = val.footer;
					break;
				case 0x023e /* Window2 */: // TODO
					// $FlowIgnore
					if(val.RTL) Workbook.Views[0].RTL = true;
					break;
				case 0x0092 /* Palette */: palette = val; break;
				case 0x0896 /* Theme */: themes = val; break;
				case 0x008c /* Country */: country = val; break;
				case 0x01ba /* CodeName */: {
if(!cur_sheet) Workbook.WBProps.CodeName = val || "ThisWorkbook";
					else wsprops.CodeName = val || wsprops.name;
				} break;
			}
		} else {
			if(!R) console.error("Missing Info for XLS Record 0x" + RecordType.toString(16));
			blob.l += length;
		}
	}
	wb.SheetNames=keys(Directory).sort(function(a,b) { return Number(a) - Number(b); }).map(function(x){return Directory[x].name;});
	if(!options.bookSheets) wb.Sheets=Sheets;
	if(!wb.SheetNames.length && Preamble["!ref"]) {
		wb.SheetNames.push("Sheet1");
		/*jshint -W069 */
		if(wb.Sheets) wb.Sheets["Sheet1"] = Preamble;
		/*jshint +W069 */
	} else wb.Preamble=Preamble;
	if(wb.Sheets) FilterDatabases.forEach(function(r,i) { wb.Sheets[wb.SheetNames[i]]['!autofilter'] = r; });
	wb.Strings = sst;
	wb.SSF = dup(table_fmt);
	if(opts.enc) wb.Encryption = opts.enc;
	if(themes) wb.Themes = themes;
	wb.Metadata = {};
	if(country !== undefined) wb.Metadata.Country = country;
	if(supbooks.names.length > 0) Workbook.Names = supbooks.names;
	wb.Workbook = Workbook;
	return wb;
}

/* TODO: split props*/
var PSCLSID = {
	SI: "e0859ff2f94f6810ab9108002b27b3d9",
	DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
	UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
};
function parse_xls_props(cfb, props, o) {
	/* [MS-OSHARED] 2.3.3.2.2 Document Summary Information Property Set */
	var DSI = CFB.find(cfb, '/!DocumentSummaryInformation');
	if(DSI && DSI.size > 0) try {
		var DocSummary = parse_PropertySetStream(DSI, DocSummaryPIDDSI, PSCLSID.DSI);
		for(var d in DocSummary) props[d] = DocSummary[d];
	} catch(e) {if(o.WTF) throw e;/* empty */}

	/* [MS-OSHARED] 2.3.3.2.1 Summary Information Property Set*/
	var SI = CFB.find(cfb, '/!SummaryInformation');
	if(SI && SI.size > 0) try {
		var Summary = parse_PropertySetStream(SI, SummaryPIDSI, PSCLSID.SI);
		for(var s in Summary) if(props[s] == null) props[s] = Summary[s];
	} catch(e) {if(o.WTF) throw e;/* empty */}

	if(props.HeadingPairs && props.TitlesOfParts) {
		load_props_pairs(props.HeadingPairs, props.TitlesOfParts, props, o);
		delete props.HeadingPairs; delete props.TitlesOfParts;
	}
}
function write_xls_props(wb, cfb) {
	var DSEntries = [], SEntries = [], CEntries = [];
	var i = 0, Keys;
	var DocSummaryRE = evert_key(DocSummaryPIDDSI, "n");
	var SummaryRE = evert_key(SummaryPIDSI, "n");
	if(wb.Props) {
		Keys = keys(wb.Props);
		// $FlowIgnore
		for(i = 0; i < Keys.length; ++i) (Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([Keys[i], wb.Props[Keys[i]]]);
	}
	if(wb.Custprops) {
		Keys = keys(wb.Custprops);
		// $FlowIgnore
		for(i = 0; i < Keys.length; ++i) if(!Object.prototype.hasOwnProperty.call((wb.Props||{}), Keys[i])) (Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([Keys[i], wb.Custprops[Keys[i]]]);
	}
	var CEntries2 = [];
	for(i = 0; i < CEntries.length; ++i) {
		if(XLSPSSkip.indexOf(CEntries[i][0]) > -1 || PseudoPropsPairs.indexOf(CEntries[i][0]) > -1) continue;
		if(CEntries[i][1] == null) continue;
		CEntries2.push(CEntries[i]);
	}
	if(SEntries.length) CFB.utils.cfb_add(cfb, "/\u0005SummaryInformation", write_PropertySetStream(SEntries, PSCLSID.SI, SummaryRE, SummaryPIDSI));
	if(DSEntries.length || CEntries2.length) CFB.utils.cfb_add(cfb, "/\u0005DocumentSummaryInformation", write_PropertySetStream(DSEntries, PSCLSID.DSI, DocSummaryRE, DocSummaryPIDDSI, CEntries2.length ? CEntries2 : null, PSCLSID.UDI));
}

function parse_xlscfb(cfb, options) {
if(!options) options = {};
fix_read_opts(options);
reset_cp();
if(options.codepage) set_ansi(options.codepage);
var CompObj, WB;
if(cfb.FullPaths) {
	if(CFB.find(cfb, '/encryption')) throw new Error("File is password-protected");
	CompObj = CFB.find(cfb, '!CompObj');
	WB = CFB.find(cfb, '/Workbook') || CFB.find(cfb, '/Book');
} else {
	switch(options.type) {
		case 'base64': cfb = s2a(Base64_decode(cfb)); break;
		case 'binary': cfb = s2a(cfb); break;
		case 'buffer': break;
		case 'array': if(!Array.isArray(cfb)) cfb = Array.prototype.slice.call(cfb); break;
	}
	prep_blob(cfb, 0);
	WB = ({content: cfb});
}
var WorkbookP;

var _data;
if(CompObj) parse_compobj(CompObj);
if(options.bookProps && !options.bookSheets) WorkbookP = ({});
else {
	var T = has_buf ? 'buffer' : 'array';
	if(WB && WB.content) WorkbookP = parse_workbook(WB.content, options);
	/* Quattro Pro 7-8 */
	else if((_data=CFB.find(cfb, 'PerfectOffice_MAIN')) && _data.content) WorkbookP = WK_.to_workbook(_data.content, (options.type = T, options));
	/* Quattro Pro 9 */
	else if((_data=CFB.find(cfb, 'NativeContent_MAIN')) && _data.content) WorkbookP = WK_.to_workbook(_data.content, (options.type = T, options));
	/* Works 4 for Mac */
	else if((_data=CFB.find(cfb, 'MN0')) && _data.content) throw new Error("Unsupported Works 4 for Mac file");
	else throw new Error("Cannot find Workbook stream");
	if(options.bookVBA && cfb.FullPaths && CFB.find(cfb, '/_VBA_PROJECT_CUR/VBA/dir')) WorkbookP.vbaraw = make_vba_xls(cfb);
}

var props = {};
if(cfb.FullPaths) parse_xls_props(cfb, props, options);

WorkbookP.Props = WorkbookP.Custprops = props; /* TODO: split up properties */
if(options.bookFiles) WorkbookP.cfb = cfb;
/*WorkbookP.CompObjP = CompObjP; // TODO: storage? */
return WorkbookP;
}


function write_xlscfb(wb, opts) {
	var o = opts || {};
	var cfb = CFB.utils.cfb_new({root:"R"});
	var wbpath = "/Workbook";
	switch(o.bookType || "xls") {
		case "xls": o.bookType = "biff8";
		/* falls through */
		case "xla": if(!o.bookType) o.bookType = "xla";
		/* falls through */
		case "biff8": wbpath = "/Workbook"; o.biff = 8; break;
		case "biff5": wbpath = "/Book"; o.biff = 5; break;
		default: throw new Error("invalid type " + o.bookType + " for XLS CFB");
	}
	CFB.utils.cfb_add(cfb, wbpath, write_biff_buf(wb, o));
	if(o.biff == 8 && (wb.Props || wb.Custprops)) write_xls_props(wb, cfb);
	// TODO: SI, DSI, CO
	if(o.biff == 8 && wb.vbaraw) fill_vba_xls(cfb, CFB.read(wb.vbaraw, {type: typeof wb.vbaraw == "string" ? "binary" : "buffer"}));
	return cfb;
}
/* [MS-XLSB] 2.3 Record Enumeration */
var XLSBRecordEnum = {
0x0000: { /* n:"BrtRowHdr", */ f:parse_BrtRowHdr },
0x0001: { /* n:"BrtCellBlank", */ f:parse_BrtCellBlank },
0x0002: { /* n:"BrtCellRk", */ f:parse_BrtCellRk },
0x0003: { /* n:"BrtCellError", */ f:parse_BrtCellError },
0x0004: { /* n:"BrtCellBool", */ f:parse_BrtCellBool },
0x0005: { /* n:"BrtCellReal", */ f:parse_BrtCellReal },
0x0006: { /* n:"BrtCellSt", */ f:parse_BrtCellSt },
0x0007: { /* n:"BrtCellIsst", */ f:parse_BrtCellIsst },
0x0008: { /* n:"BrtFmlaString", */ f:parse_BrtFmlaString },
0x0009: { /* n:"BrtFmlaNum", */ f:parse_BrtFmlaNum },
0x000A: { /* n:"BrtFmlaBool", */ f:parse_BrtFmlaBool },
0x000B: { /* n:"BrtFmlaError", */ f:parse_BrtFmlaError },
0x000C: { /* n:"BrtShortBlank", */ f:parse_BrtShortBlank },
0x000D: { /* n:"BrtShortRk", */ f:parse_BrtShortRk },
0x000E: { /* n:"BrtShortError", */ f:parse_BrtShortError },
0x000F: { /* n:"BrtShortBool", */ f:parse_BrtShortBool },
0x0010: { /* n:"BrtShortReal", */ f:parse_BrtShortReal },
0x0011: { /* n:"BrtShortSt", */ f:parse_BrtShortSt },
0x0012: { /* n:"BrtShortIsst", */ f:parse_BrtShortIsst },
0x0013: { /* n:"BrtSSTItem", */ f:parse_RichStr },
0x0014: { /* n:"BrtPCDIMissing" */ },
0x0015: { /* n:"BrtPCDINumber" */ },
0x0016: { /* n:"BrtPCDIBoolean" */ },
0x0017: { /* n:"BrtPCDIError" */ },
0x0018: { /* n:"BrtPCDIString" */ },
0x0019: { /* n:"BrtPCDIDatetime" */ },
0x001A: { /* n:"BrtPCDIIndex" */ },
0x001B: { /* n:"BrtPCDIAMissing" */ },
0x001C: { /* n:"BrtPCDIANumber" */ },
0x001D: { /* n:"BrtPCDIABoolean" */ },
0x001E: { /* n:"BrtPCDIAError" */ },
0x001F: { /* n:"BrtPCDIAString" */ },
0x0020: { /* n:"BrtPCDIADatetime" */ },
0x0021: { /* n:"BrtPCRRecord" */ },
0x0022: { /* n:"BrtPCRRecordDt" */ },
0x0023: { /* n:"BrtFRTBegin", */ T:1 },
0x0024: { /* n:"BrtFRTEnd", */ T:-1 },
0x0025: { /* n:"BrtACBegin", */ T:1 },
0x0026: { /* n:"BrtACEnd", */ T:-1 },
0x0027: { /* n:"BrtName", */ f:parse_BrtName },
0x0028: { /* n:"BrtIndexRowBlock" */ },
0x002A: { /* n:"BrtIndexBlock" */ },
0x002B: { /* n:"BrtFont", */ f:parse_BrtFont },
0x002C: { /* n:"BrtFmt", */ f:parse_BrtFmt },
0x002D: { /* n:"BrtFill", */ f:parse_BrtFill },
0x002E: { /* n:"BrtBorder", */ f:parse_BrtBorder },
0x002F: { /* n:"BrtXF", */ f:parse_BrtXF },
0x0030: { /* n:"BrtStyle" */ },
0x0031: { /* n:"BrtCellMeta", */ f:parse_Int32LE },
0x0032: { /* n:"BrtValueMeta" */ },
0x0033: { /* n:"BrtMdb" */ f:parse_BrtMdb },
0x0034: { /* n:"BrtBeginFmd", */ T:1 },
0x0035: { /* n:"BrtEndFmd", */ T:-1 },
0x0036: { /* n:"BrtBeginMdx", */ T:1 },
0x0037: { /* n:"BrtEndMdx", */ T:-1 },
0x0038: { /* n:"BrtBeginMdxTuple", */ T:1 },
0x0039: { /* n:"BrtEndMdxTuple", */ T:-1 },
0x003A: { /* n:"BrtMdxMbrIstr" */ },
0x003B: { /* n:"BrtStr" */ },
0x003C: { /* n:"BrtColInfo", */ f:parse_ColInfo },
0x003E: { /* n:"BrtCellRString", */ f:parse_BrtCellRString },
0x003F: { /* n:"BrtCalcChainItem$", */ f:parse_BrtCalcChainItem$ },
0x0040: { /* n:"BrtDVal", */ f:parse_BrtDVal },
0x0041: { /* n:"BrtSxvcellNum" */ },
0x0042: { /* n:"BrtSxvcellStr" */ },
0x0043: { /* n:"BrtSxvcellBool" */ },
0x0044: { /* n:"BrtSxvcellErr" */ },
0x0045: { /* n:"BrtSxvcellDate" */ },
0x0046: { /* n:"BrtSxvcellNil" */ },
0x0080: { /* n:"BrtFileVersion" */ },
0x0081: { /* n:"BrtBeginSheet", */ T:1 },
0x0082: { /* n:"BrtEndSheet", */ T:-1 },
0x0083: { /* n:"BrtBeginBook", */ T:1, f:parsenoop, p:0 },
0x0084: { /* n:"BrtEndBook", */ T:-1 },
0x0085: { /* n:"BrtBeginWsViews", */ T:1 },
0x0086: { /* n:"BrtEndWsViews", */ T:-1 },
0x0087: { /* n:"BrtBeginBookViews", */ T:1 },
0x0088: { /* n:"BrtEndBookViews", */ T:-1 },
0x0089: { /* n:"BrtBeginWsView", */ T:1, f:parse_BrtBeginWsView },
0x008A: { /* n:"BrtEndWsView", */ T:-1 },
0x008B: { /* n:"BrtBeginCsViews", */ T:1 },
0x008C: { /* n:"BrtEndCsViews", */ T:-1 },
0x008D: { /* n:"BrtBeginCsView", */ T:1 },
0x008E: { /* n:"BrtEndCsView", */ T:-1 },
0x008F: { /* n:"BrtBeginBundleShs", */ T:1 },
0x0090: { /* n:"BrtEndBundleShs", */ T:-1 },
0x0091: { /* n:"BrtBeginSheetData", */ T:1 },
0x0092: { /* n:"BrtEndSheetData", */ T:-1 },
0x0093: { /* n:"BrtWsProp", */ f:parse_BrtWsProp },
0x0094: { /* n:"BrtWsDim", */ f:parse_BrtWsDim, p:16 },
0x0097: { /* n:"BrtPane", */ f:parse_BrtPane },
0x0098: { /* n:"BrtSel" */ },
0x0099: { /* n:"BrtWbProp", */ f:parse_BrtWbProp },
0x009A: { /* n:"BrtWbFactoid" */ },
0x009B: { /* n:"BrtFileRecover" */ },
0x009C: { /* n:"BrtBundleSh", */ f:parse_BrtBundleSh },
0x009D: { /* n:"BrtCalcProp" */ },
0x009E: { /* n:"BrtBookView" */ },
0x009F: { /* n:"BrtBeginSst", */ T:1, f:parse_BrtBeginSst },
0x00A0: { /* n:"BrtEndSst", */ T:-1 },
0x00A1: { /* n:"BrtBeginAFilter", */ T:1, f:parse_UncheckedRfX },
0x00A2: { /* n:"BrtEndAFilter", */ T:-1 },
0x00A3: { /* n:"BrtBeginFilterColumn", */ T:1 },
0x00A4: { /* n:"BrtEndFilterColumn", */ T:-1 },
0x00A5: { /* n:"BrtBeginFilters", */ T:1 },
0x00A6: { /* n:"BrtEndFilters", */ T:-1 },
0x00A7: { /* n:"BrtFilter" */ },
0x00A8: { /* n:"BrtColorFilter" */ },
0x00A9: { /* n:"BrtIconFilter" */ },
0x00AA: { /* n:"BrtTop10Filter" */ },
0x00AB: { /* n:"BrtDynamicFilter" */ },
0x00AC: { /* n:"BrtBeginCustomFilters", */ T:1 },
0x00AD: { /* n:"BrtEndCustomFilters", */ T:-1 },
0x00AE: { /* n:"BrtCustomFilter" */ },
0x00AF: { /* n:"BrtAFilterDateGroupItem" */ },
0x00B0: { /* n:"BrtMergeCell", */ f:parse_BrtMergeCell },
0x00B1: { /* n:"BrtBeginMergeCells", */ T:1 },
0x00B2: { /* n:"BrtEndMergeCells", */ T:-1 },
0x00B3: { /* n:"BrtBeginPivotCacheDef", */ T:1 },
0x00B4: { /* n:"BrtEndPivotCacheDef", */ T:-1 },
0x00B5: { /* n:"BrtBeginPCDFields", */ T:1 },
0x00B6: { /* n:"BrtEndPCDFields", */ T:-1 },
0x00B7: { /* n:"BrtBeginPCDField", */ T:1 },
0x00B8: { /* n:"BrtEndPCDField", */ T:-1 },
0x00B9: { /* n:"BrtBeginPCDSource", */ T:1 },
0x00BA: { /* n:"BrtEndPCDSource", */ T:-1 },
0x00BB: { /* n:"BrtBeginPCDSRange", */ T:1 },
0x00BC: { /* n:"BrtEndPCDSRange", */ T:-1 },
0x00BD: { /* n:"BrtBeginPCDFAtbl", */ T:1 },
0x00BE: { /* n:"BrtEndPCDFAtbl", */ T:-1 },
0x00BF: { /* n:"BrtBeginPCDIRun", */ T:1 },
0x00C0: { /* n:"BrtEndPCDIRun", */ T:-1 },
0x00C1: { /* n:"BrtBeginPivotCacheRecords", */ T:1 },
0x00C2: { /* n:"BrtEndPivotCacheRecords", */ T:-1 },
0x00C3: { /* n:"BrtBeginPCDHierarchies", */ T:1 },
0x00C4: { /* n:"BrtEndPCDHierarchies", */ T:-1 },
0x00C5: { /* n:"BrtBeginPCDHierarchy", */ T:1 },
0x00C6: { /* n:"BrtEndPCDHierarchy", */ T:-1 },
0x00C7: { /* n:"BrtBeginPCDHFieldsUsage", */ T:1 },
0x00C8: { /* n:"BrtEndPCDHFieldsUsage", */ T:-1 },
0x00C9: { /* n:"BrtBeginExtConnection", */ T:1 },
0x00CA: { /* n:"BrtEndExtConnection", */ T:-1 },
0x00CB: { /* n:"BrtBeginECDbProps", */ T:1 },
0x00CC: { /* n:"BrtEndECDbProps", */ T:-1 },
0x00CD: { /* n:"BrtBeginECOlapProps", */ T:1 },
0x00CE: { /* n:"BrtEndECOlapProps", */ T:-1 },
0x00CF: { /* n:"BrtBeginPCDSConsol", */ T:1 },
0x00D0: { /* n:"BrtEndPCDSConsol", */ T:-1 },
0x00D1: { /* n:"BrtBeginPCDSCPages", */ T:1 },
0x00D2: { /* n:"BrtEndPCDSCPages", */ T:-1 },
0x00D3: { /* n:"BrtBeginPCDSCPage", */ T:1 },
0x00D4: { /* n:"BrtEndPCDSCPage", */ T:-1 },
0x00D5: { /* n:"BrtBeginPCDSCPItem", */ T:1 },
0x00D6: { /* n:"BrtEndPCDSCPItem", */ T:-1 },
0x00D7: { /* n:"BrtBeginPCDSCSets", */ T:1 },
0x00D8: { /* n:"BrtEndPCDSCSets", */ T:-1 },
0x00D9: { /* n:"BrtBeginPCDSCSet", */ T:1 },
0x00DA: { /* n:"BrtEndPCDSCSet", */ T:-1 },
0x00DB: { /* n:"BrtBeginPCDFGroup", */ T:1 },
0x00DC: { /* n:"BrtEndPCDFGroup", */ T:-1 },
0x00DD: { /* n:"BrtBeginPCDFGItems", */ T:1 },
0x00DE: { /* n:"BrtEndPCDFGItems", */ T:-1 },
0x00DF: { /* n:"BrtBeginPCDFGRange", */ T:1 },
0x00E0: { /* n:"BrtEndPCDFGRange", */ T:-1 },
0x00E1: { /* n:"BrtBeginPCDFGDiscrete", */ T:1 },
0x00E2: { /* n:"BrtEndPCDFGDiscrete", */ T:-1 },
0x00E3: { /* n:"BrtBeginPCDSDTupleCache", */ T:1 },
0x00E4: { /* n:"BrtEndPCDSDTupleCache", */ T:-1 },
0x00E5: { /* n:"BrtBeginPCDSDTCEntries", */ T:1 },
0x00E6: { /* n:"BrtEndPCDSDTCEntries", */ T:-1 },
0x00E7: { /* n:"BrtBeginPCDSDTCEMembers", */ T:1 },
0x00E8: { /* n:"BrtEndPCDSDTCEMembers", */ T:-1 },
0x00E9: { /* n:"BrtBeginPCDSDTCEMember", */ T:1 },
0x00EA: { /* n:"BrtEndPCDSDTCEMember", */ T:-1 },
0x00EB: { /* n:"BrtBeginPCDSDTCQueries", */ T:1 },
0x00EC: { /* n:"BrtEndPCDSDTCQueries", */ T:-1 },
0x00ED: { /* n:"BrtBeginPCDSDTCQuery", */ T:1 },
0x00EE: { /* n:"BrtEndPCDSDTCQuery", */ T:-1 },
0x00EF: { /* n:"BrtBeginPCDSDTCSets", */ T:1 },
0x00F0: { /* n:"BrtEndPCDSDTCSets", */ T:-1 },
0x00F1: { /* n:"BrtBeginPCDSDTCSet", */ T:1 },
0x00F2: { /* n:"BrtEndPCDSDTCSet", */ T:-1 },
0x00F3: { /* n:"BrtBeginPCDCalcItems", */ T:1 },
0x00F4: { /* n:"BrtEndPCDCalcItems", */ T:-1 },
0x00F5: { /* n:"BrtBeginPCDCalcItem", */ T:1 },
0x00F6: { /* n:"BrtEndPCDCalcItem", */ T:-1 },
0x00F7: { /* n:"BrtBeginPRule", */ T:1 },
0x00F8: { /* n:"BrtEndPRule", */ T:-1 },
0x00F9: { /* n:"BrtBeginPRFilters", */ T:1 },
0x00FA: { /* n:"BrtEndPRFilters", */ T:-1 },
0x00FB: { /* n:"BrtBeginPRFilter", */ T:1 },
0x00FC: { /* n:"BrtEndPRFilter", */ T:-1 },
0x00FD: { /* n:"BrtBeginPNames", */ T:1 },
0x00FE: { /* n:"BrtEndPNames", */ T:-1 },
0x00FF: { /* n:"BrtBeginPName", */ T:1 },
0x0100: { /* n:"BrtEndPName", */ T:-1 },
0x0101: { /* n:"BrtBeginPNPairs", */ T:1 },
0x0102: { /* n:"BrtEndPNPairs", */ T:-1 },
0x0103: { /* n:"BrtBeginPNPair", */ T:1 },
0x0104: { /* n:"BrtEndPNPair", */ T:-1 },
0x0105: { /* n:"BrtBeginECWebProps", */ T:1 },
0x0106: { /* n:"BrtEndECWebProps", */ T:-1 },
0x0107: { /* n:"BrtBeginEcWpTables", */ T:1 },
0x0108: { /* n:"BrtEndECWPTables", */ T:-1 },
0x0109: { /* n:"BrtBeginECParams", */ T:1 },
0x010A: { /* n:"BrtEndECParams", */ T:-1 },
0x010B: { /* n:"BrtBeginECParam", */ T:1 },
0x010C: { /* n:"BrtEndECParam", */ T:-1 },
0x010D: { /* n:"BrtBeginPCDKPIs", */ T:1 },
0x010E: { /* n:"BrtEndPCDKPIs", */ T:-1 },
0x010F: { /* n:"BrtBeginPCDKPI", */ T:1 },
0x0110: { /* n:"BrtEndPCDKPI", */ T:-1 },
0x0111: { /* n:"BrtBeginDims", */ T:1 },
0x0112: { /* n:"BrtEndDims", */ T:-1 },
0x0113: { /* n:"BrtBeginDim", */ T:1 },
0x0114: { /* n:"BrtEndDim", */ T:-1 },
0x0115: { /* n:"BrtIndexPartEnd" */ },
0x0116: { /* n:"BrtBeginStyleSheet", */ T:1 },
0x0117: { /* n:"BrtEndStyleSheet", */ T:-1 },
0x0118: { /* n:"BrtBeginSXView", */ T:1 },
0x0119: { /* n:"BrtEndSXVI", */ T:-1 },
0x011A: { /* n:"BrtBeginSXVI", */ T:1 },
0x011B: { /* n:"BrtBeginSXVIs", */ T:1 },
0x011C: { /* n:"BrtEndSXVIs", */ T:-1 },
0x011D: { /* n:"BrtBeginSXVD", */ T:1 },
0x011E: { /* n:"BrtEndSXVD", */ T:-1 },
0x011F: { /* n:"BrtBeginSXVDs", */ T:1 },
0x0120: { /* n:"BrtEndSXVDs", */ T:-1 },
0x0121: { /* n:"BrtBeginSXPI", */ T:1 },
0x0122: { /* n:"BrtEndSXPI", */ T:-1 },
0x0123: { /* n:"BrtBeginSXPIs", */ T:1 },
0x0124: { /* n:"BrtEndSXPIs", */ T:-1 },
0x0125: { /* n:"BrtBeginSXDI", */ T:1 },
0x0126: { /* n:"BrtEndSXDI", */ T:-1 },
0x0127: { /* n:"BrtBeginSXDIs", */ T:1 },
0x0128: { /* n:"BrtEndSXDIs", */ T:-1 },
0x0129: { /* n:"BrtBeginSXLI", */ T:1 },
0x012A: { /* n:"BrtEndSXLI", */ T:-1 },
0x012B: { /* n:"BrtBeginSXLIRws", */ T:1 },
0x012C: { /* n:"BrtEndSXLIRws", */ T:-1 },
0x012D: { /* n:"BrtBeginSXLICols", */ T:1 },
0x012E: { /* n:"BrtEndSXLICols", */ T:-1 },
0x012F: { /* n:"BrtBeginSXFormat", */ T:1 },
0x0130: { /* n:"BrtEndSXFormat", */ T:-1 },
0x0131: { /* n:"BrtBeginSXFormats", */ T:1 },
0x0132: { /* n:"BrtEndSxFormats", */ T:-1 },
0x0133: { /* n:"BrtBeginSxSelect", */ T:1 },
0x0134: { /* n:"BrtEndSxSelect", */ T:-1 },
0x0135: { /* n:"BrtBeginISXVDRws", */ T:1 },
0x0136: { /* n:"BrtEndISXVDRws", */ T:-1 },
0x0137: { /* n:"BrtBeginISXVDCols", */ T:1 },
0x0138: { /* n:"BrtEndISXVDCols", */ T:-1 },
0x0139: { /* n:"BrtEndSXLocation", */ T:-1 },
0x013A: { /* n:"BrtBeginSXLocation", */ T:1 },
0x013B: { /* n:"BrtEndSXView", */ T:-1 },
0x013C: { /* n:"BrtBeginSXTHs", */ T:1 },
0x013D: { /* n:"BrtEndSXTHs", */ T:-1 },
0x013E: { /* n:"BrtBeginSXTH", */ T:1 },
0x013F: { /* n:"BrtEndSXTH", */ T:-1 },
0x0140: { /* n:"BrtBeginISXTHRws", */ T:1 },
0x0141: { /* n:"BrtEndISXTHRws", */ T:-1 },
0x0142: { /* n:"BrtBeginISXTHCols", */ T:1 },
0x0143: { /* n:"BrtEndISXTHCols", */ T:-1 },
0x0144: { /* n:"BrtBeginSXTDMPS", */ T:1 },
0x0145: { /* n:"BrtEndSXTDMPs", */ T:-1 },
0x0146: { /* n:"BrtBeginSXTDMP", */ T:1 },
0x0147: { /* n:"BrtEndSXTDMP", */ T:-1 },
0x0148: { /* n:"BrtBeginSXTHItems", */ T:1 },
0x0149: { /* n:"BrtEndSXTHItems", */ T:-1 },
0x014A: { /* n:"BrtBeginSXTHItem", */ T:1 },
0x014B: { /* n:"BrtEndSXTHItem", */ T:-1 },
0x014C: { /* n:"BrtBeginMetadata", */ T:1 },
0x014D: { /* n:"BrtEndMetadata", */ T:-1 },
0x014E: { /* n:"BrtBeginEsmdtinfo", */ T:1 },
0x014F: { /* n:"BrtMdtinfo", */ f:parse_BrtMdtinfo },
0x0150: { /* n:"BrtEndEsmdtinfo", */ T:-1 },
0x0151: { /* n:"BrtBeginEsmdb", */ f:parse_BrtBeginEsmdb, T:1 },
0x0152: { /* n:"BrtEndEsmdb", */ T:-1 },
0x0153: { /* n:"BrtBeginEsfmd", */ T:1 },
0x0154: { /* n:"BrtEndEsfmd", */ T:-1 },
0x0155: { /* n:"BrtBeginSingleCells", */ T:1 },
0x0156: { /* n:"BrtEndSingleCells", */ T:-1 },
0x0157: { /* n:"BrtBeginList", */ T:1 },
0x0158: { /* n:"BrtEndList", */ T:-1 },
0x0159: { /* n:"BrtBeginListCols", */ T:1 },
0x015A: { /* n:"BrtEndListCols", */ T:-1 },
0x015B: { /* n:"BrtBeginListCol", */ T:1 },
0x015C: { /* n:"BrtEndListCol", */ T:-1 },
0x015D: { /* n:"BrtBeginListXmlCPr", */ T:1 },
0x015E: { /* n:"BrtEndListXmlCPr", */ T:-1 },
0x015F: { /* n:"BrtListCCFmla" */ },
0x0160: { /* n:"BrtListTrFmla" */ },
0x0161: { /* n:"BrtBeginExternals", */ T:1 },
0x0162: { /* n:"BrtEndExternals", */ T:-1 },
0x0163: { /* n:"BrtSupBookSrc", */ f:parse_RelID},
0x0165: { /* n:"BrtSupSelf" */ },
0x0166: { /* n:"BrtSupSame" */ },
0x0167: { /* n:"BrtSupTabs" */ },
0x0168: { /* n:"BrtBeginSupBook", */ T:1 },
0x0169: { /* n:"BrtPlaceholderName" */ },
0x016A: { /* n:"BrtExternSheet", */ f:parse_ExternSheet },
0x016B: { /* n:"BrtExternTableStart" */ },
0x016C: { /* n:"BrtExternTableEnd" */ },
0x016E: { /* n:"BrtExternRowHdr" */ },
0x016F: { /* n:"BrtExternCellBlank" */ },
0x0170: { /* n:"BrtExternCellReal" */ },
0x0171: { /* n:"BrtExternCellBool" */ },
0x0172: { /* n:"BrtExternCellError" */ },
0x0173: { /* n:"BrtExternCellString" */ },
0x0174: { /* n:"BrtBeginEsmdx", */ T:1 },
0x0175: { /* n:"BrtEndEsmdx", */ T:-1 },
0x0176: { /* n:"BrtBeginMdxSet", */ T:1 },
0x0177: { /* n:"BrtEndMdxSet", */ T:-1 },
0x0178: { /* n:"BrtBeginMdxMbrProp", */ T:1 },
0x0179: { /* n:"BrtEndMdxMbrProp", */ T:-1 },
0x017A: { /* n:"BrtBeginMdxKPI", */ T:1 },
0x017B: { /* n:"BrtEndMdxKPI", */ T:-1 },
0x017C: { /* n:"BrtBeginEsstr", */ T:1 },
0x017D: { /* n:"BrtEndEsstr", */ T:-1 },
0x017E: { /* n:"BrtBeginPRFItem", */ T:1 },
0x017F: { /* n:"BrtEndPRFItem", */ T:-1 },
0x0180: { /* n:"BrtBeginPivotCacheIDs", */ T:1 },
0x0181: { /* n:"BrtEndPivotCacheIDs", */ T:-1 },
0x0182: { /* n:"BrtBeginPivotCacheID", */ T:1 },
0x0183: { /* n:"BrtEndPivotCacheID", */ T:-1 },
0x0184: { /* n:"BrtBeginISXVIs", */ T:1 },
0x0185: { /* n:"BrtEndISXVIs", */ T:-1 },
0x0186: { /* n:"BrtBeginColInfos", */ T:1 },
0x0187: { /* n:"BrtEndColInfos", */ T:-1 },
0x0188: { /* n:"BrtBeginRwBrk", */ T:1 },
0x0189: { /* n:"BrtEndRwBrk", */ T:-1 },
0x018A: { /* n:"BrtBeginColBrk", */ T:1 },
0x018B: { /* n:"BrtEndColBrk", */ T:-1 },
0x018C: { /* n:"BrtBrk" */ },
0x018D: { /* n:"BrtUserBookView" */ },
0x018E: { /* n:"BrtInfo" */ },
0x018F: { /* n:"BrtCUsr" */ },
0x0190: { /* n:"BrtUsr" */ },
0x0191: { /* n:"BrtBeginUsers", */ T:1 },
0x0193: { /* n:"BrtEOF" */ },
0x0194: { /* n:"BrtUCR" */ },
0x0195: { /* n:"BrtRRInsDel" */ },
0x0196: { /* n:"BrtRREndInsDel" */ },
0x0197: { /* n:"BrtRRMove" */ },
0x0198: { /* n:"BrtRREndMove" */ },
0x0199: { /* n:"BrtRRChgCell" */ },
0x019A: { /* n:"BrtRREndChgCell" */ },
0x019B: { /* n:"BrtRRHeader" */ },
0x019C: { /* n:"BrtRRUserView" */ },
0x019D: { /* n:"BrtRRRenSheet" */ },
0x019E: { /* n:"BrtRRInsertSh" */ },
0x019F: { /* n:"BrtRRDefName" */ },
0x01A0: { /* n:"BrtRRNote" */ },
0x01A1: { /* n:"BrtRRConflict" */ },
0x01A2: { /* n:"BrtRRTQSIF" */ },
0x01A3: { /* n:"BrtRRFormat" */ },
0x01A4: { /* n:"BrtRREndFormat" */ },
0x01A5: { /* n:"BrtRRAutoFmt" */ },
0x01A6: { /* n:"BrtBeginUserShViews", */ T:1 },
0x01A7: { /* n:"BrtBeginUserShView", */ T:1 },
0x01A8: { /* n:"BrtEndUserShView", */ T:-1 },
0x01A9: { /* n:"BrtEndUserShViews", */ T:-1 },
0x01AA: { /* n:"BrtArrFmla", */ f:parse_BrtArrFmla },
0x01AB: { /* n:"BrtShrFmla", */ f:parse_BrtShrFmla },
0x01AC: { /* n:"BrtTable" */ },
0x01AD: { /* n:"BrtBeginExtConnections", */ T:1 },
0x01AE: { /* n:"BrtEndExtConnections", */ T:-1 },
0x01AF: { /* n:"BrtBeginPCDCalcMems", */ T:1 },
0x01B0: { /* n:"BrtEndPCDCalcMems", */ T:-1 },
0x01B1: { /* n:"BrtBeginPCDCalcMem", */ T:1 },
0x01B2: { /* n:"BrtEndPCDCalcMem", */ T:-1 },
0x01B3: { /* n:"BrtBeginPCDHGLevels", */ T:1 },
0x01B4: { /* n:"BrtEndPCDHGLevels", */ T:-1 },
0x01B5: { /* n:"BrtBeginPCDHGLevel", */ T:1 },
0x01B6: { /* n:"BrtEndPCDHGLevel", */ T:-1 },
0x01B7: { /* n:"BrtBeginPCDHGLGroups", */ T:1 },
0x01B8: { /* n:"BrtEndPCDHGLGroups", */ T:-1 },
0x01B9: { /* n:"BrtBeginPCDHGLGroup", */ T:1 },
0x01BA: { /* n:"BrtEndPCDHGLGroup", */ T:-1 },
0x01BB: { /* n:"BrtBeginPCDHGLGMembers", */ T:1 },
0x01BC: { /* n:"BrtEndPCDHGLGMembers", */ T:-1 },
0x01BD: { /* n:"BrtBeginPCDHGLGMember", */ T:1 },
0x01BE: { /* n:"BrtEndPCDHGLGMember", */ T:-1 },
0x01BF: { /* n:"BrtBeginQSI", */ T:1 },
0x01C0: { /* n:"BrtEndQSI", */ T:-1 },
0x01C1: { /* n:"BrtBeginQSIR", */ T:1 },
0x01C2: { /* n:"BrtEndQSIR", */ T:-1 },
0x01C3: { /* n:"BrtBeginDeletedNames", */ T:1 },
0x01C4: { /* n:"BrtEndDeletedNames", */ T:-1 },
0x01C5: { /* n:"BrtBeginDeletedName", */ T:1 },
0x01C6: { /* n:"BrtEndDeletedName", */ T:-1 },
0x01C7: { /* n:"BrtBeginQSIFs", */ T:1 },
0x01C8: { /* n:"BrtEndQSIFs", */ T:-1 },
0x01C9: { /* n:"BrtBeginQSIF", */ T:1 },
0x01CA: { /* n:"BrtEndQSIF", */ T:-1 },
0x01CB: { /* n:"BrtBeginAutoSortScope", */ T:1 },
0x01CC: { /* n:"BrtEndAutoSortScope", */ T:-1 },
0x01CD: { /* n:"BrtBeginConditionalFormatting", */ T:1 },
0x01CE: { /* n:"BrtEndConditionalFormatting", */ T:-1 },
0x01CF: { /* n:"BrtBeginCFRule", */ T:1 },
0x01D0: { /* n:"BrtEndCFRule", */ T:-1 },
0x01D1: { /* n:"BrtBeginIconSet", */ T:1 },
0x01D2: { /* n:"BrtEndIconSet", */ T:-1 },
0x01D3: { /* n:"BrtBeginDatabar", */ T:1 },
0x01D4: { /* n:"BrtEndDatabar", */ T:-1 },
0x01D5: { /* n:"BrtBeginColorScale", */ T:1 },
0x01D6: { /* n:"BrtEndColorScale", */ T:-1 },
0x01D7: { /* n:"BrtCFVO" */ },
0x01D8: { /* n:"BrtExternValueMeta" */ },
0x01D9: { /* n:"BrtBeginColorPalette", */ T:1 },
0x01DA: { /* n:"BrtEndColorPalette", */ T:-1 },
0x01DB: { /* n:"BrtIndexedColor" */ },
0x01DC: { /* n:"BrtMargins", */ f:parse_BrtMargins },
0x01DD: { /* n:"BrtPrintOptions" */ },
0x01DE: { /* n:"BrtPageSetup" */ },
0x01DF: { /* n:"BrtBeginHeaderFooter", */ T:1 },
0x01E0: { /* n:"BrtEndHeaderFooter", */ T:-1 },
0x01E1: { /* n:"BrtBeginSXCrtFormat", */ T:1 },
0x01E2: { /* n:"BrtEndSXCrtFormat", */ T:-1 },
0x01E3: { /* n:"BrtBeginSXCrtFormats", */ T:1 },
0x01E4: { /* n:"BrtEndSXCrtFormats", */ T:-1 },
0x01E5: { /* n:"BrtWsFmtInfo", */ f:parse_BrtWsFmtInfo },
0x01E6: { /* n:"BrtBeginMgs", */ T:1 },
0x01E7: { /* n:"BrtEndMGs", */ T:-1 },
0x01E8: { /* n:"BrtBeginMGMaps", */ T:1 },
0x01E9: { /* n:"BrtEndMGMaps", */ T:-1 },
0x01EA: { /* n:"BrtBeginMG", */ T:1 },
0x01EB: { /* n:"BrtEndMG", */ T:-1 },
0x01EC: { /* n:"BrtBeginMap", */ T:1 },
0x01ED: { /* n:"BrtEndMap", */ T:-1 },
0x01EE: { /* n:"BrtHLink", */ f:parse_BrtHLink },
0x01EF: { /* n:"BrtBeginDCon", */ T:1 },
0x01F0: { /* n:"BrtEndDCon", */ T:-1 },
0x01F1: { /* n:"BrtBeginDRefs", */ T:1 },
0x01F2: { /* n:"BrtEndDRefs", */ T:-1 },
0x01F3: { /* n:"BrtDRef" */ },
0x01F4: { /* n:"BrtBeginScenMan", */ T:1 },
0x01F5: { /* n:"BrtEndScenMan", */ T:-1 },
0x01F6: { /* n:"BrtBeginSct", */ T:1 },
0x01F7: { /* n:"BrtEndSct", */ T:-1 },
0x01F8: { /* n:"BrtSlc" */ },
0x01F9: { /* n:"BrtBeginDXFs", */ T:1 },
0x01FA: { /* n:"BrtEndDXFs", */ T:-1 },
0x01FB: { /* n:"BrtDXF" */ },
0x01FC: { /* n:"BrtBeginTableStyles", */ T:1 },
0x01FD: { /* n:"BrtEndTableStyles", */ T:-1 },
0x01FE: { /* n:"BrtBeginTableStyle", */ T:1 },
0x01FF: { /* n:"BrtEndTableStyle", */ T:-1 },
0x0200: { /* n:"BrtTableStyleElement" */ },
0x0201: { /* n:"BrtTableStyleClient" */ },
0x0202: { /* n:"BrtBeginVolDeps", */ T:1 },
0x0203: { /* n:"BrtEndVolDeps", */ T:-1 },
0x0204: { /* n:"BrtBeginVolType", */ T:1 },
0x0205: { /* n:"BrtEndVolType", */ T:-1 },
0x0206: { /* n:"BrtBeginVolMain", */ T:1 },
0x0207: { /* n:"BrtEndVolMain", */ T:-1 },
0x0208: { /* n:"BrtBeginVolTopic", */ T:1 },
0x0209: { /* n:"BrtEndVolTopic", */ T:-1 },
0x020A: { /* n:"BrtVolSubtopic" */ },
0x020B: { /* n:"BrtVolRef" */ },
0x020C: { /* n:"BrtVolNum" */ },
0x020D: { /* n:"BrtVolErr" */ },
0x020E: { /* n:"BrtVolStr" */ },
0x020F: { /* n:"BrtVolBool" */ },
0x0210: { /* n:"BrtBeginCalcChain$", */ T:1 },
0x0211: { /* n:"BrtEndCalcChain$", */ T:-1 },
0x0212: { /* n:"BrtBeginSortState", */ T:1 },
0x0213: { /* n:"BrtEndSortState", */ T:-1 },
0x0214: { /* n:"BrtBeginSortCond", */ T:1 },
0x0215: { /* n:"BrtEndSortCond", */ T:-1 },
0x0216: { /* n:"BrtBookProtection" */ },
0x0217: { /* n:"BrtSheetProtection" */ },
0x0218: { /* n:"BrtRangeProtection" */ },
0x0219: { /* n:"BrtPhoneticInfo" */ },
0x021A: { /* n:"BrtBeginECTxtWiz", */ T:1 },
0x021B: { /* n:"BrtEndECTxtWiz", */ T:-1 },
0x021C: { /* n:"BrtBeginECTWFldInfoLst", */ T:1 },
0x021D: { /* n:"BrtEndECTWFldInfoLst", */ T:-1 },
0x021E: { /* n:"BrtBeginECTwFldInfo", */ T:1 },
0x0224: { /* n:"BrtFileSharing" */ },
0x0225: { /* n:"BrtOleSize" */ },
0x0226: { /* n:"BrtDrawing", */ f:parse_RelID },
0x0227: { /* n:"BrtLegacyDrawing" */ },
0x0228: { /* n:"BrtLegacyDrawingHF" */ },
0x0229: { /* n:"BrtWebOpt" */ },
0x022A: { /* n:"BrtBeginWebPubItems", */ T:1 },
0x022B: { /* n:"BrtEndWebPubItems", */ T:-1 },
0x022C: { /* n:"BrtBeginWebPubItem", */ T:1 },
0x022D: { /* n:"BrtEndWebPubItem", */ T:-1 },
0x022E: { /* n:"BrtBeginSXCondFmt", */ T:1 },
0x022F: { /* n:"BrtEndSXCondFmt", */ T:-1 },
0x0230: { /* n:"BrtBeginSXCondFmts", */ T:1 },
0x0231: { /* n:"BrtEndSXCondFmts", */ T:-1 },
0x0232: { /* n:"BrtBkHim" */ },
0x0234: { /* n:"BrtColor" */ },
0x0235: { /* n:"BrtBeginIndexedColors", */ T:1 },
0x0236: { /* n:"BrtEndIndexedColors", */ T:-1 },
0x0239: { /* n:"BrtBeginMRUColors", */ T:1 },
0x023A: { /* n:"BrtEndMRUColors", */ T:-1 },
0x023C: { /* n:"BrtMRUColor" */ },
0x023D: { /* n:"BrtBeginDVals", */ T:1 },
0x023E: { /* n:"BrtEndDVals", */ T:-1 },
0x0241: { /* n:"BrtSupNameStart" */ },
0x0242: { /* n:"BrtSupNameValueStart" */ },
0x0243: { /* n:"BrtSupNameValueEnd" */ },
0x0244: { /* n:"BrtSupNameNum" */ },
0x0245: { /* n:"BrtSupNameErr" */ },
0x0246: { /* n:"BrtSupNameSt" */ },
0x0247: { /* n:"BrtSupNameNil" */ },
0x0248: { /* n:"BrtSupNameBool" */ },
0x0249: { /* n:"BrtSupNameFmla" */ },
0x024A: { /* n:"BrtSupNameBits" */ },
0x024B: { /* n:"BrtSupNameEnd" */ },
0x024C: { /* n:"BrtEndSupBook", */ T:-1 },
0x024D: { /* n:"BrtCellSmartTagProperty" */ },
0x024E: { /* n:"BrtBeginCellSmartTag", */ T:1 },
0x024F: { /* n:"BrtEndCellSmartTag", */ T:-1 },
0x0250: { /* n:"BrtBeginCellSmartTags", */ T:1 },
0x0251: { /* n:"BrtEndCellSmartTags", */ T:-1 },
0x0252: { /* n:"BrtBeginSmartTags", */ T:1 },
0x0253: { /* n:"BrtEndSmartTags", */ T:-1 },
0x0254: { /* n:"BrtSmartTagType" */ },
0x0255: { /* n:"BrtBeginSmartTagTypes", */ T:1 },
0x0256: { /* n:"BrtEndSmartTagTypes", */ T:-1 },
0x0257: { /* n:"BrtBeginSXFilters", */ T:1 },
0x0258: { /* n:"BrtEndSXFilters", */ T:-1 },
0x0259: { /* n:"BrtBeginSXFILTER", */ T:1 },
0x025A: { /* n:"BrtEndSXFilter", */ T:-1 },
0x025B: { /* n:"BrtBeginFills", */ T:1 },
0x025C: { /* n:"BrtEndFills", */ T:-1 },
0x025D: { /* n:"BrtBeginCellWatches", */ T:1 },
0x025E: { /* n:"BrtEndCellWatches", */ T:-1 },
0x025F: { /* n:"BrtCellWatch" */ },
0x0260: { /* n:"BrtBeginCRErrs", */ T:1 },
0x0261: { /* n:"BrtEndCRErrs", */ T:-1 },
0x0262: { /* n:"BrtCrashRecErr" */ },
0x0263: { /* n:"BrtBeginFonts", */ T:1 },
0x0264: { /* n:"BrtEndFonts", */ T:-1 },
0x0265: { /* n:"BrtBeginBorders", */ T:1 },
0x0266: { /* n:"BrtEndBorders", */ T:-1 },
0x0267: { /* n:"BrtBeginFmts", */ T:1 },
0x0268: { /* n:"BrtEndFmts", */ T:-1 },
0x0269: { /* n:"BrtBeginCellXFs", */ T:1 },
0x026A: { /* n:"BrtEndCellXFs", */ T:-1 },
0x026B: { /* n:"BrtBeginStyles", */ T:1 },
0x026C: { /* n:"BrtEndStyles", */ T:-1 },
0x0271: { /* n:"BrtBigName" */ },
0x0272: { /* n:"BrtBeginCellStyleXFs", */ T:1 },
0x0273: { /* n:"BrtEndCellStyleXFs", */ T:-1 },
0x0274: { /* n:"BrtBeginComments", */ T:1 },
0x0275: { /* n:"BrtEndComments", */ T:-1 },
0x0276: { /* n:"BrtBeginCommentAuthors", */ T:1 },
0x0277: { /* n:"BrtEndCommentAuthors", */ T:-1 },
0x0278: { /* n:"BrtCommentAuthor", */ f:parse_BrtCommentAuthor },
0x0279: { /* n:"BrtBeginCommentList", */ T:1 },
0x027A: { /* n:"BrtEndCommentList", */ T:-1 },
0x027B: { /* n:"BrtBeginComment", */ T:1, f:parse_BrtBeginComment},
0x027C: { /* n:"BrtEndComment", */ T:-1 },
0x027D: { /* n:"BrtCommentText", */ f:parse_BrtCommentText },
0x027E: { /* n:"BrtBeginOleObjects", */ T:1 },
0x027F: { /* n:"BrtOleObject" */ },
0x0280: { /* n:"BrtEndOleObjects", */ T:-1 },
0x0281: { /* n:"BrtBeginSxrules", */ T:1 },
0x0282: { /* n:"BrtEndSxRules", */ T:-1 },
0x0283: { /* n:"BrtBeginActiveXControls", */ T:1 },
0x0284: { /* n:"BrtActiveX" */ },
0x0285: { /* n:"BrtEndActiveXControls", */ T:-1 },
0x0286: { /* n:"BrtBeginPCDSDTCEMembersSortBy", */ T:1 },
0x0288: { /* n:"BrtBeginCellIgnoreECs", */ T:1 },
0x0289: { /* n:"BrtCellIgnoreEC" */ },
0x028A: { /* n:"BrtEndCellIgnoreECs", */ T:-1 },
0x028B: { /* n:"BrtCsProp", */ f:parse_BrtCsProp },
0x028C: { /* n:"BrtCsPageSetup" */ },
0x028D: { /* n:"BrtBeginUserCsViews", */ T:1 },
0x028E: { /* n:"BrtEndUserCsViews", */ T:-1 },
0x028F: { /* n:"BrtBeginUserCsView", */ T:1 },
0x0290: { /* n:"BrtEndUserCsView", */ T:-1 },
0x0291: { /* n:"BrtBeginPcdSFCIEntries", */ T:1 },
0x0292: { /* n:"BrtEndPCDSFCIEntries", */ T:-1 },
0x0293: { /* n:"BrtPCDSFCIEntry" */ },
0x0294: { /* n:"BrtBeginListParts", */ T:1 },
0x0295: { /* n:"BrtListPart" */ },
0x0296: { /* n:"BrtEndListParts", */ T:-1 },
0x0297: { /* n:"BrtSheetCalcProp" */ },
0x0298: { /* n:"BrtBeginFnGroup", */ T:1 },
0x0299: { /* n:"BrtFnGroup" */ },
0x029A: { /* n:"BrtEndFnGroup", */ T:-1 },
0x029B: { /* n:"BrtSupAddin" */ },
0x029C: { /* n:"BrtSXTDMPOrder" */ },
0x029D: { /* n:"BrtCsProtection" */ },
0x029F: { /* n:"BrtBeginWsSortMap", */ T:1 },
0x02A0: { /* n:"BrtEndWsSortMap", */ T:-1 },
0x02A1: { /* n:"BrtBeginRRSort", */ T:1 },
0x02A2: { /* n:"BrtEndRRSort", */ T:-1 },
0x02A3: { /* n:"BrtRRSortItem" */ },
0x02A4: { /* n:"BrtFileSharingIso" */ },
0x02A5: { /* n:"BrtBookProtectionIso" */ },
0x02A6: { /* n:"BrtSheetProtectionIso" */ },
0x02A7: { /* n:"BrtCsProtectionIso" */ },
0x02A8: { /* n:"BrtRangeProtectionIso" */ },
0x02A9: { /* n:"BrtDValList" */ },
0x0400: { /* n:"BrtRwDescent" */ },
0x0401: { /* n:"BrtKnownFonts" */ },
0x0402: { /* n:"BrtBeginSXTupleSet", */ T:1 },
0x0403: { /* n:"BrtEndSXTupleSet", */ T:-1 },
0x0404: { /* n:"BrtBeginSXTupleSetHeader", */ T:1 },
0x0405: { /* n:"BrtEndSXTupleSetHeader", */ T:-1 },
0x0406: { /* n:"BrtSXTupleSetHeaderItem" */ },
0x0407: { /* n:"BrtBeginSXTupleSetData", */ T:1 },
0x0408: { /* n:"BrtEndSXTupleSetData", */ T:-1 },
0x0409: { /* n:"BrtBeginSXTupleSetRow", */ T:1 },
0x040A: { /* n:"BrtEndSXTupleSetRow", */ T:-1 },
0x040B: { /* n:"BrtSXTupleSetRowItem" */ },
0x040C: { /* n:"BrtNameExt" */ },
0x040D: { /* n:"BrtPCDH14" */ },
0x040E: { /* n:"BrtBeginPCDCalcMem14", */ T:1 },
0x040F: { /* n:"BrtEndPCDCalcMem14", */ T:-1 },
0x0410: { /* n:"BrtSXTH14" */ },
0x0411: { /* n:"BrtBeginSparklineGroup", */ T:1 },
0x0412: { /* n:"BrtEndSparklineGroup", */ T:-1 },
0x0413: { /* n:"BrtSparkline" */ },
0x0414: { /* n:"BrtSXDI14" */ },
0x0415: { /* n:"BrtWsFmtInfoEx14" */ },
0x0416: { /* n:"BrtBeginConditionalFormatting14", */ T:1 },
0x0417: { /* n:"BrtEndConditionalFormatting14", */ T:-1 },
0x0418: { /* n:"BrtBeginCFRule14", */ T:1 },
0x0419: { /* n:"BrtEndCFRule14", */ T:-1 },
0x041A: { /* n:"BrtCFVO14" */ },
0x041B: { /* n:"BrtBeginDatabar14", */ T:1 },
0x041C: { /* n:"BrtBeginIconSet14", */ T:1 },
0x041D: { /* n:"BrtDVal14", */ f: parse_BrtDVal14 },
0x041E: { /* n:"BrtBeginDVals14", */ T:1 },
0x041F: { /* n:"BrtColor14" */ },
0x0420: { /* n:"BrtBeginSparklines", */ T:1 },
0x0421: { /* n:"BrtEndSparklines", */ T:-1 },
0x0422: { /* n:"BrtBeginSparklineGroups", */ T:1 },
0x0423: { /* n:"BrtEndSparklineGroups", */ T:-1 },
0x0425: { /* n:"BrtSXVD14" */ },
0x0426: { /* n:"BrtBeginSXView14", */ T:1 },
0x0427: { /* n:"BrtEndSXView14", */ T:-1 },
0x0428: { /* n:"BrtBeginSXView16", */ T:1 },
0x0429: { /* n:"BrtEndSXView16", */ T:-1 },
0x042A: { /* n:"BrtBeginPCD14", */ T:1 },
0x042B: { /* n:"BrtEndPCD14", */ T:-1 },
0x042C: { /* n:"BrtBeginExtConn14", */ T:1 },
0x042D: { /* n:"BrtEndExtConn14", */ T:-1 },
0x042E: { /* n:"BrtBeginSlicerCacheIDs", */ T:1 },
0x042F: { /* n:"BrtEndSlicerCacheIDs", */ T:-1 },
0x0430: { /* n:"BrtBeginSlicerCacheID", */ T:1 },
0x0431: { /* n:"BrtEndSlicerCacheID", */ T:-1 },
0x0433: { /* n:"BrtBeginSlicerCache", */ T:1 },
0x0434: { /* n:"BrtEndSlicerCache", */ T:-1 },
0x0435: { /* n:"BrtBeginSlicerCacheDef", */ T:1 },
0x0436: { /* n:"BrtEndSlicerCacheDef", */ T:-1 },
0x0437: { /* n:"BrtBeginSlicersEx", */ T:1 },
0x0438: { /* n:"BrtEndSlicersEx", */ T:-1 },
0x0439: { /* n:"BrtBeginSlicerEx", */ T:1 },
0x043A: { /* n:"BrtEndSlicerEx", */ T:-1 },
0x043B: { /* n:"BrtBeginSlicer", */ T:1 },
0x043C: { /* n:"BrtEndSlicer", */ T:-1 },
0x043D: { /* n:"BrtSlicerCachePivotTables" */ },
0x043E: { /* n:"BrtBeginSlicerCacheOlapImpl", */ T:1 },
0x043F: { /* n:"BrtEndSlicerCacheOlapImpl", */ T:-1 },
0x0440: { /* n:"BrtBeginSlicerCacheLevelsData", */ T:1 },
0x0441: { /* n:"BrtEndSlicerCacheLevelsData", */ T:-1 },
0x0442: { /* n:"BrtBeginSlicerCacheLevelData", */ T:1 },
0x0443: { /* n:"BrtEndSlicerCacheLevelData", */ T:-1 },
0x0444: { /* n:"BrtBeginSlicerCacheSiRanges", */ T:1 },
0x0445: { /* n:"BrtEndSlicerCacheSiRanges", */ T:-1 },
0x0446: { /* n:"BrtBeginSlicerCacheSiRange", */ T:1 },
0x0447: { /* n:"BrtEndSlicerCacheSiRange", */ T:-1 },
0x0448: { /* n:"BrtSlicerCacheOlapItem" */ },
0x0449: { /* n:"BrtBeginSlicerCacheSelections", */ T:1 },
0x044A: { /* n:"BrtSlicerCacheSelection" */ },
0x044B: { /* n:"BrtEndSlicerCacheSelections", */ T:-1 },
0x044C: { /* n:"BrtBeginSlicerCacheNative", */ T:1 },
0x044D: { /* n:"BrtEndSlicerCacheNative", */ T:-1 },
0x044E: { /* n:"BrtSlicerCacheNativeItem" */ },
0x044F: { /* n:"BrtRangeProtection14" */ },
0x0450: { /* n:"BrtRangeProtectionIso14" */ },
0x0451: { /* n:"BrtCellIgnoreEC14" */ },
0x0457: { /* n:"BrtList14" */ },
0x0458: { /* n:"BrtCFIcon" */ },
0x0459: { /* n:"BrtBeginSlicerCachesPivotCacheIDs", */ T:1 },
0x045A: { /* n:"BrtEndSlicerCachesPivotCacheIDs", */ T:-1 },
0x045B: { /* n:"BrtBeginSlicers", */ T:1 },
0x045C: { /* n:"BrtEndSlicers", */ T:-1 },
0x045D: { /* n:"BrtWbProp14" */ },
0x045E: { /* n:"BrtBeginSXEdit", */ T:1 },
0x045F: { /* n:"BrtEndSXEdit", */ T:-1 },
0x0460: { /* n:"BrtBeginSXEdits", */ T:1 },
0x0461: { /* n:"BrtEndSXEdits", */ T:-1 },
0x0462: { /* n:"BrtBeginSXChange", */ T:1 },
0x0463: { /* n:"BrtEndSXChange", */ T:-1 },
0x0464: { /* n:"BrtBeginSXChanges", */ T:1 },
0x0465: { /* n:"BrtEndSXChanges", */ T:-1 },
0x0466: { /* n:"BrtSXTupleItems" */ },
0x0468: { /* n:"BrtBeginSlicerStyle", */ T:1 },
0x0469: { /* n:"BrtEndSlicerStyle", */ T:-1 },
0x046A: { /* n:"BrtSlicerStyleElement" */ },
0x046B: { /* n:"BrtBeginStyleSheetExt14", */ T:1 },
0x046C: { /* n:"BrtEndStyleSheetExt14", */ T:-1 },
0x046D: { /* n:"BrtBeginSlicerCachesPivotCacheID", */ T:1 },
0x046E: { /* n:"BrtEndSlicerCachesPivotCacheID", */ T:-1 },
0x046F: { /* n:"BrtBeginConditionalFormattings", */ T:1 },
0x0470: { /* n:"BrtEndConditionalFormattings", */ T:-1 },
0x0471: { /* n:"BrtBeginPCDCalcMemExt", */ T:1 },
0x0472: { /* n:"BrtEndPCDCalcMemExt", */ T:-1 },
0x0473: { /* n:"BrtBeginPCDCalcMemsExt", */ T:1 },
0x0474: { /* n:"BrtEndPCDCalcMemsExt", */ T:-1 },
0x0475: { /* n:"BrtPCDField14" */ },
0x0476: { /* n:"BrtBeginSlicerStyles", */ T:1 },
0x0477: { /* n:"BrtEndSlicerStyles", */ T:-1 },
0x0478: { /* n:"BrtBeginSlicerStyleElements", */ T:1 },
0x0479: { /* n:"BrtEndSlicerStyleElements", */ T:-1 },
0x047A: { /* n:"BrtCFRuleExt" */ },
0x047B: { /* n:"BrtBeginSXCondFmt14", */ T:1 },
0x047C: { /* n:"BrtEndSXCondFmt14", */ T:-1 },
0x047D: { /* n:"BrtBeginSXCondFmts14", */ T:1 },
0x047E: { /* n:"BrtEndSXCondFmts14", */ T:-1 },
0x0480: { /* n:"BrtBeginSortCond14", */ T:1 },
0x0481: { /* n:"BrtEndSortCond14", */ T:-1 },
0x0482: { /* n:"BrtEndDVals14", */ T:-1 },
0x0483: { /* n:"BrtEndIconSet14", */ T:-1 },
0x0484: { /* n:"BrtEndDatabar14", */ T:-1 },
0x0485: { /* n:"BrtBeginColorScale14", */ T:1 },
0x0486: { /* n:"BrtEndColorScale14", */ T:-1 },
0x0487: { /* n:"BrtBeginSxrules14", */ T:1 },
0x0488: { /* n:"BrtEndSxrules14", */ T:-1 },
0x0489: { /* n:"BrtBeginPRule14", */ T:1 },
0x048A: { /* n:"BrtEndPRule14", */ T:-1 },
0x048B: { /* n:"BrtBeginPRFilters14", */ T:1 },
0x048C: { /* n:"BrtEndPRFilters14", */ T:-1 },
0x048D: { /* n:"BrtBeginPRFilter14", */ T:1 },
0x048E: { /* n:"BrtEndPRFilter14", */ T:-1 },
0x048F: { /* n:"BrtBeginPRFItem14", */ T:1 },
0x0490: { /* n:"BrtEndPRFItem14", */ T:-1 },
0x0491: { /* n:"BrtBeginCellIgnoreECs14", */ T:1 },
0x0492: { /* n:"BrtEndCellIgnoreECs14", */ T:-1 },
0x0493: { /* n:"BrtDxf14" */ },
0x0494: { /* n:"BrtBeginDxF14s", */ T:1 },
0x0495: { /* n:"BrtEndDxf14s", */ T:-1 },
0x0499: { /* n:"BrtFilter14" */ },
0x049A: { /* n:"BrtBeginCustomFilters14", */ T:1 },
0x049C: { /* n:"BrtCustomFilter14" */ },
0x049D: { /* n:"BrtIconFilter14" */ },
0x049E: { /* n:"BrtPivotCacheConnectionName" */ },
0x0800: { /* n:"BrtBeginDecoupledPivotCacheIDs", */ T:1 },
0x0801: { /* n:"BrtEndDecoupledPivotCacheIDs", */ T:-1 },
0x0802: { /* n:"BrtDecoupledPivotCacheID" */ },
0x0803: { /* n:"BrtBeginPivotTableRefs", */ T:1 },
0x0804: { /* n:"BrtEndPivotTableRefs", */ T:-1 },
0x0805: { /* n:"BrtPivotTableRef" */ },
0x0806: { /* n:"BrtSlicerCacheBookPivotTables" */ },
0x0807: { /* n:"BrtBeginSxvcells", */ T:1 },
0x0808: { /* n:"BrtEndSxvcells", */ T:-1 },
0x0809: { /* n:"BrtBeginSxRow", */ T:1 },
0x080A: { /* n:"BrtEndSxRow", */ T:-1 },
0x080C: { /* n:"BrtPcdCalcMem15" */ },
0x0813: { /* n:"BrtQsi15" */ },
0x0814: { /* n:"BrtBeginWebExtensions", */ T:1 },
0x0815: { /* n:"BrtEndWebExtensions", */ T:-1 },
0x0816: { /* n:"BrtWebExtension" */ },
0x0817: { /* n:"BrtAbsPath15" */ },
0x0818: { /* n:"BrtBeginPivotTableUISettings", */ T:1 },
0x0819: { /* n:"BrtEndPivotTableUISettings", */ T:-1 },
0x081B: { /* n:"BrtTableSlicerCacheIDs" */ },
0x081C: { /* n:"BrtTableSlicerCacheID" */ },
0x081D: { /* n:"BrtBeginTableSlicerCache", */ T:1 },
0x081E: { /* n:"BrtEndTableSlicerCache", */ T:-1 },
0x081F: { /* n:"BrtSxFilter15" */ },
0x0820: { /* n:"BrtBeginTimelineCachePivotCacheIDs", */ T:1 },
0x0821: { /* n:"BrtEndTimelineCachePivotCacheIDs", */ T:-1 },
0x0822: { /* n:"BrtTimelineCachePivotCacheID" */ },
0x0823: { /* n:"BrtBeginTimelineCacheIDs", */ T:1 },
0x0824: { /* n:"BrtEndTimelineCacheIDs", */ T:-1 },
0x0825: { /* n:"BrtBeginTimelineCacheID", */ T:1 },
0x0826: { /* n:"BrtEndTimelineCacheID", */ T:-1 },
0x0827: { /* n:"BrtBeginTimelinesEx", */ T:1 },
0x0828: { /* n:"BrtEndTimelinesEx", */ T:-1 },
0x0829: { /* n:"BrtBeginTimelineEx", */ T:1 },
0x082A: { /* n:"BrtEndTimelineEx", */ T:-1 },
0x082B: { /* n:"BrtWorkBookPr15" */ },
0x082C: { /* n:"BrtPCDH15" */ },
0x082D: { /* n:"BrtBeginTimelineStyle", */ T:1 },
0x082E: { /* n:"BrtEndTimelineStyle", */ T:-1 },
0x082F: { /* n:"BrtTimelineStyleElement" */ },
0x0830: { /* n:"BrtBeginTimelineStylesheetExt15", */ T:1 },
0x0831: { /* n:"BrtEndTimelineStylesheetExt15", */ T:-1 },
0x0832: { /* n:"BrtBeginTimelineStyles", */ T:1 },
0x0833: { /* n:"BrtEndTimelineStyles", */ T:-1 },
0x0834: { /* n:"BrtBeginTimelineStyleElements", */ T:1 },
0x0835: { /* n:"BrtEndTimelineStyleElements", */ T:-1 },
0x0836: { /* n:"BrtDxf15" */ },
0x0837: { /* n:"BrtBeginDxfs15", */ T:1 },
0x0838: { /* n:"BrtEndDxfs15", */ T:-1 },
0x0839: { /* n:"BrtSlicerCacheHideItemsWithNoData" */ },
0x083A: { /* n:"BrtBeginItemUniqueNames", */ T:1 },
0x083B: { /* n:"BrtEndItemUniqueNames", */ T:-1 },
0x083C: { /* n:"BrtItemUniqueName" */ },
0x083D: { /* n:"BrtBeginExtConn15", */ T:1 },
0x083E: { /* n:"BrtEndExtConn15", */ T:-1 },
0x083F: { /* n:"BrtBeginOledbPr15", */ T:1 },
0x0840: { /* n:"BrtEndOledbPr15", */ T:-1 },
0x0841: { /* n:"BrtBeginDataFeedPr15", */ T:1 },
0x0842: { /* n:"BrtEndDataFeedPr15", */ T:-1 },
0x0843: { /* n:"BrtTextPr15" */ },
0x0844: { /* n:"BrtRangePr15" */ },
0x0845: { /* n:"BrtDbCommand15" */ },
0x0846: { /* n:"BrtBeginDbTables15", */ T:1 },
0x0847: { /* n:"BrtEndDbTables15", */ T:-1 },
0x0848: { /* n:"BrtDbTable15" */ },
0x0849: { /* n:"BrtBeginDataModel", */ T:1 },
0x084A: { /* n:"BrtEndDataModel", */ T:-1 },
0x084B: { /* n:"BrtBeginModelTables", */ T:1 },
0x084C: { /* n:"BrtEndModelTables", */ T:-1 },
0x084D: { /* n:"BrtModelTable" */ },
0x084E: { /* n:"BrtBeginModelRelationships", */ T:1 },
0x084F: { /* n:"BrtEndModelRelationships", */ T:-1 },
0x0850: { /* n:"BrtModelRelationship" */ },
0x0851: { /* n:"BrtBeginECTxtWiz15", */ T:1 },
0x0852: { /* n:"BrtEndECTxtWiz15", */ T:-1 },
0x0853: { /* n:"BrtBeginECTWFldInfoLst15", */ T:1 },
0x0854: { /* n:"BrtEndECTWFldInfoLst15", */ T:-1 },
0x0855: { /* n:"BrtBeginECTWFldInfo15", */ T:1 },
0x0856: { /* n:"BrtFieldListActiveItem" */ },
0x0857: { /* n:"BrtPivotCacheIdVersion" */ },
0x0858: { /* n:"BrtSXDI15" */ },
0x0859: { /* n:"BrtBeginModelTimeGroupings", */ T:1 },
0x085A: { /* n:"BrtEndModelTimeGroupings", */ T:-1 },
0x085B: { /* n:"BrtBeginModelTimeGrouping", */ T:1 },
0x085C: { /* n:"BrtEndModelTimeGrouping", */ T:-1 },
0x085D: { /* n:"BrtModelTimeGroupingCalcCol" */ },
0x0C00: { /* n:"BrtUid" */ },
0x0C01: { /* n:"BrtRevisionPtr" */ },
0x1000: { /* n:"BrtBeginDynamicArrayPr", */ T:1 },
0x1001: { /* n:"BrtEndDynamicArrayPr", */ T:-1 },
0x138A: { /* n:"BrtBeginRichValueBlock", */ T:1 },
0x138B: { /* n:"BrtEndRichValueBlock", */ T:-1 },
0x13D9: { /* n:"BrtBeginRichFilters", */ T:1 },
0x13DA: { /* n:"BrtEndRichFilters", */ T:-1 },
0x13DB: { /* n:"BrtRichFilter" */ },
0x13DC: { /* n:"BrtBeginRichFilterColumn", */ T:1 },
0x13DD: { /* n:"BrtEndRichFilterColumn", */ T:-1 },
0x13DE: { /* n:"BrtBeginCustomRichFilters", */ T:1 },
0x13DF: { /* n:"BrtEndCustomRichFilters", */ T:-1 },
0x13E0: { /* n:"BrtCustomRichFilter" */ },
0x13E1: { /* n:"BrtTop10RichFilter" */ },
0x13E2: { /* n:"BrtDynamicRichFilter" */ },
0x13E4: { /* n:"BrtBeginRichSortCondition", */ T:1 },
0x13E5: { /* n:"BrtEndRichSortCondition", */ T:-1 },
0x13E6: { /* n:"BrtRichFilterDateGroupItem" */ },
0x13E7: { /* n:"BrtBeginCalcFeatures", */ T:1 },
0x13E8: { /* n:"BrtEndCalcFeatures", */ T:-1 },
0x13E9: { /* n:"BrtCalcFeature" */ },
0x13EB: { /* n:"BrtExternalLinksPr" */ },
0xFFFF: { n:"" }
};

/* [MS-XLS] 2.3 Record Enumeration (and other sources) */
var XLSRecordEnum = {
	/* [MS-XLS] 2.3 Record Enumeration 2021-08-17 */
0x0006: { /* n:"Formula", */ f:parse_Formula },
0x000a: { /* n:"EOF", */ f:parsenoop2 },
0x000c: { /* n:"CalcCount", */ f:parseuint16 }, //
0x000d: { /* n:"CalcMode", */ f:parseuint16 }, //
0x000e: { /* n:"CalcPrecision", */ f:parsebool }, //
0x000f: { /* n:"CalcRefMode", */ f:parsebool }, //
0x0010: { /* n:"CalcDelta", */ f:parse_Xnum }, //
0x0011: { /* n:"CalcIter", */ f:parsebool }, //
0x0012: { /* n:"Protect", */ f:parsebool },
0x0013: { /* n:"Password", */ f:parseuint16 },
0x0014: { /* n:"Header", */ f:parse_XLHeaderFooter },
0x0015: { /* n:"Footer", */ f:parse_XLHeaderFooter },
0x0017: { /* n:"ExternSheet", */ f:parse_ExternSheet },
0x0018: { /* n:"Lbl", */ f:parse_Lbl },
0x0019: { /* n:"WinProtect", */ f:parsebool },
0x001a: { /* n:"VerticalPageBreaks", */ },
0x001b: { /* n:"HorizontalPageBreaks", */ },
0x001c: { /* n:"Note", */ f:parse_Note },
0x001d: { /* n:"Selection", */ },
0x0022: { /* n:"Date1904", */ f:parsebool },
0x0023: { /* n:"ExternName", */ f:parse_ExternName },
0x0026: { /* n:"LeftMargin", */ f:parse_Xnum }, // *
0x0027: { /* n:"RightMargin", */ f:parse_Xnum }, // *
0x0028: { /* n:"TopMargin", */ f:parse_Xnum }, // *
0x0029: { /* n:"BottomMargin", */ f:parse_Xnum }, // *
0x002a: { /* n:"PrintRowCol", */ f:parsebool },
0x002b: { /* n:"PrintGrid", */ f:parsebool },
0x002f: { /* n:"FilePass", */ f:parse_FilePass },
0x0031: { /* n:"Font", */ f:parse_Font },
0x0033: { /* n:"PrintSize", */ f:parseuint16 },
0x003c: { /* n:"Continue", */ },
0x003d: { /* n:"Window1", */ f:parse_Window1 },
0x0040: { /* n:"Backup", */ f:parsebool },
0x0041: { /* n:"Pane", */ f:parse_Pane },
0x0042: { /* n:"CodePage", */ f:parseuint16 },
0x004d: { /* n:"Pls", */ },
0x0050: { /* n:"DCon", */ },
0x0051: { /* n:"DConRef", */ },
0x0052: { /* n:"DConName", */ },
0x0055: { /* n:"DefColWidth", */ f:parseuint16 },
0x0059: { /* n:"XCT", */ },
0x005a: { /* n:"CRN", */ },
0x005b: { /* n:"FileSharing", */ },
0x005c: { /* n:"WriteAccess", */ f:parse_WriteAccess },
0x005d: { /* n:"Obj", */ f:parse_Obj },
0x005e: { /* n:"Uncalced", */ },
0x005f: { /* n:"CalcSaveRecalc", */ f:parsebool }, //
0x0060: { /* n:"Template", */ },
0x0061: { /* n:"Intl", */ },
0x0063: { /* n:"ObjProtect", */ f:parsebool },
0x007d: { /* n:"ColInfo", */ f:parse_ColInfo },
0x0080: { /* n:"Guts", */ f:parse_Guts },
0x0081: { /* n:"WsBool", */ f:parse_WsBool },
0x0082: { /* n:"GridSet", */ f:parseuint16 },
0x0083: { /* n:"HCenter", */ f:parsebool },
0x0084: { /* n:"VCenter", */ f:parsebool },
0x0085: { /* n:"BoundSheet8", */ f:parse_BoundSheet8 },
0x0086: { /* n:"WriteProtect", */ },
0x008c: { /* n:"Country", */ f:parse_Country },
0x008d: { /* n:"HideObj", */ f:parseuint16 },
0x0090: { /* n:"Sort", */ },
0x0092: { /* n:"Palette", */ f:parse_Palette },
0x0097: { /* n:"Sync", */ },
0x0098: { /* n:"LPr", */ },
0x0099: { /* n:"DxGCol", */ },
0x009a: { /* n:"FnGroupName", */ },
0x009b: { /* n:"FilterMode", */ },
0x009c: { /* n:"BuiltInFnGroupCount", */ f:parseuint16 },
0x009d: { /* n:"AutoFilterInfo", */ },
0x009e: { /* n:"AutoFilter", */ },
0x00a0: { /* n:"Scl", */ f:parse_Scl },
0x00a1: { /* n:"Setup", */ f:parse_Setup },
0x00ae: { /* n:"ScenMan", */ },
0x00af: { /* n:"SCENARIO", */ },
0x00b0: { /* n:"SxView", */ },
0x00b1: { /* n:"Sxvd", */ },
0x00b2: { /* n:"SXVI", */ },
0x00b4: { /* n:"SxIvd", */ },
0x00b5: { /* n:"SXLI", */ },
0x00b6: { /* n:"SXPI", */ },
0x00b8: { /* n:"DocRoute", */ },
0x00b9: { /* n:"RecipName", */ },
0x00bd: { /* n:"MulRk", */ f:parse_MulRk },
0x00be: { /* n:"MulBlank", */ f:parse_MulBlank },
0x00c1: { /* n:"Mms", */ f:parsenoop2 },
0x00c5: { /* n:"SXDI", */ },
0x00c6: { /* n:"SXDB", */ },
0x00c7: { /* n:"SXFDB", */ },
0x00c8: { /* n:"SXDBB", */ },
0x00c9: { /* n:"SXNum", */ },
0x00ca: { /* n:"SxBool", */ f:parsebool },
0x00cb: { /* n:"SxErr", */ },
0x00cc: { /* n:"SXInt", */ },
0x00cd: { /* n:"SXString", */ },
0x00ce: { /* n:"SXDtr", */ },
0x00cf: { /* n:"SxNil", */ },
0x00d0: { /* n:"SXTbl", */ },
0x00d1: { /* n:"SXTBRGIITM", */ },
0x00d2: { /* n:"SxTbpg", */ },
0x00d3: { /* n:"ObProj", */ },
0x00d5: { /* n:"SXStreamID", */ },
0x00d7: { /* n:"DBCell", */ },
0x00d8: { /* n:"SXRng", */ },
0x00d9: { /* n:"SxIsxoper", */ },
0x00da: { /* n:"BookBool", */ f:parseuint16 },
0x00dc: { /* n:"DbOrParamQry", */ },
0x00dd: { /* n:"ScenarioProtect", */ f:parsebool },
0x00de: { /* n:"OleObjectSize", */ },
0x00e0: { /* n:"XF", */ f:parse_XF },
0x00e1: { /* n:"InterfaceHdr", */ f:parse_InterfaceHdr },
0x00e2: { /* n:"InterfaceEnd", */ f:parsenoop2 },
0x00e3: { /* n:"SXVS", */ },
0x00e5: { /* n:"MergeCells", */ f:parse_MergeCells },
0x00e9: { /* n:"BkHim", */ },
0x00eb: { /* n:"MsoDrawingGroup", */ },
0x00ec: { /* n:"MsoDrawing", */ },
0x00ed: { /* n:"MsoDrawingSelection", */ },
0x00ef: { /* n:"PhoneticInfo", */ },
0x00f0: { /* n:"SxRule", */ },
0x00f1: { /* n:"SXEx", */ },
0x00f2: { /* n:"SxFilt", */ },
0x00f4: { /* n:"SxDXF", */ },
0x00f5: { /* n:"SxItm", */ },
0x00f6: { /* n:"SxName", */ },
0x00f7: { /* n:"SxSelect", */ },
0x00f8: { /* n:"SXPair", */ },
0x00f9: { /* n:"SxFmla", */ },
0x00fb: { /* n:"SxFormat", */ },
0x00fc: { /* n:"SST", */ f:parse_SST },
0x00fd: { /* n:"LabelSst", */ f:parse_LabelSst },
0x00ff: { /* n:"ExtSST", */ f:parse_ExtSST },
0x0100: { /* n:"SXVDEx", */ },
0x0103: { /* n:"SXFormula", */ },
0x0122: { /* n:"SXDBEx", */ },
0x0137: { /* n:"RRDInsDel", */ },
0x0138: { /* n:"RRDHead", */ },
0x013b: { /* n:"RRDChgCell", */ },
0x013d: { /* n:"RRTabId", */ f:parseuint16a },
0x013e: { /* n:"RRDRenSheet", */ },
0x013f: { /* n:"RRSort", */ },
0x0140: { /* n:"RRDMove", */ },
0x014a: { /* n:"RRFormat", */ },
0x014b: { /* n:"RRAutoFmt", */ },
0x014d: { /* n:"RRInsertSh", */ },
0x014e: { /* n:"RRDMoveBegin", */ },
0x014f: { /* n:"RRDMoveEnd", */ },
0x0150: { /* n:"RRDInsDelBegin", */ },
0x0151: { /* n:"RRDInsDelEnd", */ },
0x0152: { /* n:"RRDConflict", */ },
0x0153: { /* n:"RRDDefName", */ },
0x0154: { /* n:"RRDRstEtxp", */ },
0x015f: { /* n:"LRng", */ },
0x0160: { /* n:"UsesELFs", */ f:parsebool },
0x0161: { /* n:"DSF", */ f:parsenoop2 },
0x0191: { /* n:"CUsr", */ },
0x0192: { /* n:"CbUsr", */ },
0x0193: { /* n:"UsrInfo", */ },
0x0194: { /* n:"UsrExcl", */ },
0x0195: { /* n:"FileLock", */ },
0x0196: { /* n:"RRDInfo", */ },
0x0197: { /* n:"BCUsrs", */ },
0x0198: { /* n:"UsrChk", */ },
0x01a9: { /* n:"UserBView", */ },
0x01aa: { /* n:"UserSViewBegin", */ },
0x01ab: { /* n:"UserSViewEnd", */ },
0x01ac: { /* n:"RRDUserView", */ },
0x01ad: { /* n:"Qsi", */ },
0x01ae: { /* n:"SupBook", */ f:parse_SupBook },
0x01af: { /* n:"Prot4Rev", */ f:parsebool },
0x01b0: { /* n:"CondFmt", */ },
0x01b1: { /* n:"CF", */ },
0x01b2: { /* n:"DVal", */ },
0x01b5: { /* n:"DConBin", */ },
0x01b6: { /* n:"TxO", */ f:parse_TxO },
0x01b7: { /* n:"RefreshAll", */ f:parsebool }, //
0x01b8: { /* n:"HLink", */ f:parse_HLink },
0x01b9: { /* n:"Lel", */ },
0x01ba: { /* n:"CodeName", */ f:parse_XLUnicodeString },
0x01bb: { /* n:"SXFDBType", */ },
0x01bc: { /* n:"Prot4RevPass", */ f:parseuint16 },
0x01bd: { /* n:"ObNoMacros", */ },
0x01be: { /* n:"Dv", */ },
0x01c0: { /* n:"Excel9File", */ f:parsenoop2 },
0x01c1: { /* n:"RecalcId", */ f:parse_RecalcId, r:2},
0x01c2: { /* n:"EntExU2", */ f:parsenoop2 },
0x0200: { /* n:"Dimensions", */ f:parse_Dimensions },
0x0201: { /* n:"Blank", */ f:parse_Blank },
0x0203: { /* n:"Number", */ f:parse_Number },
0x0204: { /* n:"Label", */ f:parse_Label },
0x0205: { /* n:"BoolErr", */ f:parse_BoolErr },
0x0207: { /* n:"String", */ f:parse_String },
0x0208: { /* n:"Row", */ f:parse_Row },
0x020b: { /* n:"Index", */ },
0x0221: { /* n:"Array", */ f:parse_Array },
0x0225: { /* n:"DefaultRowHeight", */ f:parse_DefaultRowHeight },
0x0236: { /* n:"Table", */ },
0x023e: { /* n:"Window2", */ f:parse_Window2 },
0x027e: { /* n:"RK", */ f:parse_RK },
0x0293: { /* n:"Style", */ },
0x0418: { /* n:"BigName", */ },
0x041e: { /* n:"Format", */ f:parse_Format },
0x043c: { /* n:"ContinueBigName", */ },
0x04bc: { /* n:"ShrFmla", */ f:parse_ShrFmla },
0x0800: { /* n:"HLinkTooltip", */ f:parse_HLinkTooltip },
0x0801: { /* n:"WebPub", */ },
0x0802: { /* n:"QsiSXTag", */ },
0x0803: { /* n:"DBQueryExt", */ },
0x0804: { /* n:"ExtString", */ },
0x0805: { /* n:"TxtQry", */ },
0x0806: { /* n:"Qsir", */ },
0x0807: { /* n:"Qsif", */ },
0x0808: { /* n:"RRDTQSIF", */ },
0x0809: { /* n:"BOF", */ f:parse_BOF },
0x080a: { /* n:"OleDbConn", */ },
0x080b: { /* n:"WOpt", */ },
0x080c: { /* n:"SXViewEx", */ },
0x080d: { /* n:"SXTH", */ },
0x080e: { /* n:"SXPIEx", */ },
0x080f: { /* n:"SXVDTEx", */ },
0x0810: { /* n:"SXViewEx9", */ },
0x0812: { /* n:"ContinueFrt", */ },
0x0813: { /* n:"RealTimeData", */ },
0x0850: { /* n:"ChartFrtInfo", */ },
0x0851: { /* n:"FrtWrapper", */ },
0x0852: { /* n:"StartBlock", */ },
0x0853: { /* n:"EndBlock", */ },
0x0854: { /* n:"StartObject", */ },
0x0855: { /* n:"EndObject", */ },
0x0856: { /* n:"CatLab", */ },
0x0857: { /* n:"YMult", */ },
0x0858: { /* n:"SXViewLink", */ },
0x0859: { /* n:"PivotChartBits", */ },
0x085a: { /* n:"FrtFontList", */ },
0x0862: { /* n:"SheetExt", */ },
0x0863: { /* n:"BookExt", */ r:12},
0x0864: { /* n:"SXAddl", */ },
0x0865: { /* n:"CrErr", */ },
0x0866: { /* n:"HFPicture", */ },
0x0867: { /* n:"FeatHdr", */ f:parsenoop2 },
0x0868: { /* n:"Feat", */ },
0x086a: { /* n:"DataLabExt", */ },
0x086b: { /* n:"DataLabExtContents", */ },
0x086c: { /* n:"CellWatch", */ },
0x0871: { /* n:"FeatHdr11", */ },
0x0872: { /* n:"Feature11", */ },
0x0874: { /* n:"DropDownObjIds", */ },
0x0875: { /* n:"ContinueFrt11", */ },
0x0876: { /* n:"DConn", */ },
0x0877: { /* n:"List12", */ },
0x0878: { /* n:"Feature12", */ },
0x0879: { /* n:"CondFmt12", */ },
0x087a: { /* n:"CF12", */ },
0x087b: { /* n:"CFEx", */ },
0x087c: { /* n:"XFCRC", */ f:parse_XFCRC, r:12 },
0x087d: { /* n:"XFExt", */ f:parse_XFExt, r:12 },
0x087e: { /* n:"AutoFilter12", */ },
0x087f: { /* n:"ContinueFrt12", */ },
0x0884: { /* n:"MDTInfo", */ },
0x0885: { /* n:"MDXStr", */ },
0x0886: { /* n:"MDXTuple", */ },
0x0887: { /* n:"MDXSet", */ },
0x0888: { /* n:"MDXProp", */ },
0x0889: { /* n:"MDXKPI", */ },
0x088a: { /* n:"MDB", */ },
0x088b: { /* n:"PLV", */ },
0x088c: { /* n:"Compat12", */ f:parsebool, r:12 },
0x088d: { /* n:"DXF", */ },
0x088e: { /* n:"TableStyles", */ r:12 },
0x088f: { /* n:"TableStyle", */ },
0x0890: { /* n:"TableStyleElement", */ },
0x0892: { /* n:"StyleExt", */ },
0x0893: { /* n:"NamePublish", */ },
0x0894: { /* n:"NameCmt", */ f:parse_NameCmt, r:12 },
0x0895: { /* n:"SortData", */ },
0x0896: { /* n:"Theme", */ f:parse_Theme, r:12 },
0x0897: { /* n:"GUIDTypeLib", */ },
0x0898: { /* n:"FnGrp12", */ },
0x0899: { /* n:"NameFnGrp12", */ },
0x089a: { /* n:"MTRSettings", */ f:parse_MTRSettings, r:12 },
0x089b: { /* n:"CompressPictures", */ f:parsenoop2 },
0x089c: { /* n:"HeaderFooter", */ },
0x089d: { /* n:"CrtLayout12", */ },
0x089e: { /* n:"CrtMlFrt", */ },
0x089f: { /* n:"CrtMlFrtContinue", */ },
0x08a3: { /* n:"ForceFullCalculation", */ f:parse_ForceFullCalculation },
0x08a4: { /* n:"ShapePropsStream", */ },
0x08a5: { /* n:"TextPropsStream", */ },
0x08a6: { /* n:"RichTextStream", */ },
0x08a7: { /* n:"CrtLayout12A", */ },
0x1001: { /* n:"Units", */ },
0x1002: { /* n:"Chart", */ },
0x1003: { /* n:"Series", */ },
0x1006: { /* n:"DataFormat", */ },
0x1007: { /* n:"LineFormat", */ },
0x1009: { /* n:"MarkerFormat", */ },
0x100a: { /* n:"AreaFormat", */ },
0x100b: { /* n:"PieFormat", */ },
0x100c: { /* n:"AttachedLabel", */ },
0x100d: { /* n:"SeriesText", */ },
0x1014: { /* n:"ChartFormat", */ },
0x1015: { /* n:"Legend", */ },
0x1016: { /* n:"SeriesList", */ },
0x1017: { /* n:"Bar", */ },
0x1018: { /* n:"Line", */ },
0x1019: { /* n:"Pie", */ },
0x101a: { /* n:"Area", */ },
0x101b: { /* n:"Scatter", */ },
0x101c: { /* n:"CrtLine", */ },
0x101d: { /* n:"Axis", */ },
0x101e: { /* n:"Tick", */ },
0x101f: { /* n:"ValueRange", */ },
0x1020: { /* n:"CatSerRange", */ },
0x1021: { /* n:"AxisLine", */ },
0x1022: { /* n:"CrtLink", */ },
0x1024: { /* n:"DefaultText", */ },
0x1025: { /* n:"Text", */ },
0x1026: { /* n:"FontX", */ f:parseuint16 },
0x1027: { /* n:"ObjectLink", */ },
0x1032: { /* n:"Frame", */ },
0x1033: { /* n:"Begin", */ },
0x1034: { /* n:"End", */ },
0x1035: { /* n:"PlotArea", */ },
0x103a: { /* n:"Chart3d", */ },
0x103c: { /* n:"PicF", */ },
0x103d: { /* n:"DropBar", */ },
0x103e: { /* n:"Radar", */ },
0x103f: { /* n:"Surf", */ },
0x1040: { /* n:"RadarArea", */ },
0x1041: { /* n:"AxisParent", */ },
0x1043: { /* n:"LegendException", */ },
0x1044: { /* n:"ShtProps", */ f:parse_ShtProps },
0x1045: { /* n:"SerToCrt", */ },
0x1046: { /* n:"AxesUsed", */ },
0x1048: { /* n:"SBaseRef", */ },
0x104a: { /* n:"SerParent", */ },
0x104b: { /* n:"SerAuxTrend", */ },
0x104e: { /* n:"IFmtRecord", */ },
0x104f: { /* n:"Pos", */ },
0x1050: { /* n:"AlRuns", */ },
0x1051: { /* n:"BRAI", */ },
0x105b: { /* n:"SerAuxErrBar", */ },
0x105c: { /* n:"ClrtClient", */ f:parse_ClrtClient },
0x105d: { /* n:"SerFmt", */ },
0x105f: { /* n:"Chart3DBarShape", */ },
0x1060: { /* n:"Fbi", */ },
0x1061: { /* n:"BopPop", */ },
0x1062: { /* n:"AxcExt", */ },
0x1063: { /* n:"Dat", */ },
0x1064: { /* n:"PlotGrowth", */ },
0x1065: { /* n:"SIIndex", */ },
0x1066: { /* n:"GelFrame", */ },
0x1067: { /* n:"BopPopCustom", */ },
0x1068: { /* n:"Fbi2", */ },

0x0000: { /* n:"Dimensions", */ f:parse_Dimensions },
0x0001: { /* n:"BIFF2BLANK", */ },
0x0002: { /* n:"BIFF2INT", */ f:parse_BIFF2INT },
0x0003: { /* n:"BIFF2NUM", */ f:parse_BIFF2NUM },
0x0004: { /* n:"BIFF2STR", */ f:parse_BIFF2STR },
0x0005: { /* n:"BoolErr", */ f:parse_BoolErr },
0x0007: { /* n:"String", */ f:parse_BIFF2STRING },
0x0008: { /* n:"BIFF2ROW", */ },
0x0009: { /* n:"BOF", */ f:parse_BOF },
0x000b: { /* n:"Index", */ },
0x0016: { /* n:"ExternCount", */ f:parseuint16 },
0x001e: { /* n:"BIFF2FORMAT", */ f:parse_BIFF2Format },
0x001f: { /* n:"BIFF2FMTCNT", */ }, /* 16-bit cnt of BIFF2FORMAT records */
0x0020: { /* n:"BIFF2COLINFO", */ },
0x0021: { /* n:"Array", */ f:parse_Array },
0x0024: { /* n:"COLWIDTH", */ },
0x0025: { /* n:"DefaultRowHeight", */ f:parse_DefaultRowHeight },
	// 0x2c ??
	// 0x2d ??
	// 0x2e ??
	// 0x30 FONTCOUNT: number of fonts
0x0032: { /* n:"BIFF2FONTXTRA", */ f:parse_BIFF2FONTXTRA },
	// 0x35: INFOOPTS
	// 0x36: TABLE (BIFF2 only)
	// 0x37: TABLE2 (BIFF2 only)
	// 0x38: WNDESK
	// 0x39 ??
	// 0x3a: BEGINPREF
	// 0x3b: ENDPREF
0x003e: { /* n:"BIFF2WINDOW2", */ },
	// 0x3f ??
	// 0x46: SHOWSCROLL
	// 0x47: SHOWFORMULA
	// 0x48: STATUSBAR
	// 0x49: SHORTMENUS
	// 0x4A:
	// 0x4B:
	// 0x4C:
	// 0x4E:
	// 0x4F:
	// 0x58: TOOLBAR (BIFF3)

	/* - - - */
0x0034: { /* n:"DDEObjName", */ },
0x0043: { /* n:"BIFF2XF", */ },
0x0044: { /* n:"BIFF2XFINDEX", */ f:parseuint16 },
0x0045: { /* n:"BIFF2FONTCLR", */ },
0x0056: { /* n:"BIFF4FMTCNT", */ }, /* 16-bit cnt, similar to BIFF2 */
0x007e: { /* n:"RK", */ }, /* Not necessarily same as 0x027e */
0x007f: { /* n:"ImData", */ f:parse_ImData },
0x0087: { /* n:"Addin", */ },
0x0088: { /* n:"Edg", */ },
0x0089: { /* n:"Pub", */ },
	// 0x8A
	// 0x8B LH: alternate menu key flag (BIFF3/4)
	// 0x8E
	// 0x8F
0x0091: { /* n:"Sub", */ },
	// 0x93 STYLE
0x0094: { /* n:"LHRecord", */ },
0x0095: { /* n:"LHNGraph", */ },
0x0096: { /* n:"Sound", */ },
	// 0xA2 FNPROTO: function prototypes (BIFF4)
	// 0xA3
	// 0xA8
0x00a9: { /* n:"CoordList", */ },
0x00ab: { /* n:"GCW", */ },
0x00bc: { /* n:"ShrFmla", */ }, /* Not necessarily same as 0x04bc */
0x00bf: { /* n:"ToolbarHdr", */ },
0x00c0: { /* n:"ToolbarEnd", */ },
0x00c2: { /* n:"AddMenu", */ },
0x00c3: { /* n:"DelMenu", */ },
0x00d6: { /* n:"RString", */ f:parse_RString },
0x00df: { /* n:"UDDesc", */ },
0x00ea: { /* n:"TabIdConf", */ },
0x0162: { /* n:"XL5Modify", */ },
0x01a5: { /* n:"FileSharing2", */ },
0x0206: { /* n:"Formula", */ f:parse_Formula },
0x0209: { /* n:"BOF", */ f:parse_BOF },
0x0218: { /* n:"Lbl", */ f:parse_Lbl },
0x0223: { /* n:"ExternName", */ f:parse_ExternName },
0x0231: { /* n:"Font", */ },
0x0243: { /* n:"BIFF3XF", */ },
0x0406: { /* n:"Formula", */ f:parse_Formula },
0x0409: { /* n:"BOF", */ f:parse_BOF },
0x0443: { /* n:"BIFF4XF", */ },
0x086d: { /* n:"FeatInfo", */ },
0x0873: { /* n:"FeatInfo11", */ },
0x0881: { /* n:"SXAddl12", */ },
0x08c0: { /* n:"AutoWebPub", */ },
0x08c1: { /* n:"ListObj", */ },
0x08c2: { /* n:"ListField", */ },
0x08c3: { /* n:"ListDV", */ },
0x08c4: { /* n:"ListCondFmt", */ },
0x08c5: { /* n:"ListCF", */ },
0x08c6: { /* n:"FMQry", */ },
0x08c7: { /* n:"FMSQry", */ },
0x08c8: { /* n:"PLV", */ },
0x08c9: { /* n:"LnExt", */ },
0x08ca: { /* n:"MkrExt", */ },
0x08cb: { /* n:"CrtCoopt", */ },
0x08d6: { /* n:"FRTArchId$", */ r:12 },

	/* --- multiplan 4 records --- */
0x0065: { /* n:"", */ }, // one per window
0x0066: { /* n:"", */ }, // calc settings
0x0069: { /* n:"", */ }, // print header
0x006a: { /* n:"", */ }, // print footer
0x006b: { /* n:"", */ }, // print settings
0x006d: { /* n:"", */ }, // one per window
0x0070: { /* n:"", */ }, // includes default col width
0x0072: { /* n:"", */ }, // includes selected cell

0x7262: {}
};

function write_biff_rec(ba, type, payload, length) {
	var t = type;
	if(isNaN(t)) return;
	var len = length || (payload||[]).length || 0;
	var o = ba.next(4);
	o.write_shift(2, t);
	o.write_shift(2, len);
	if(len > 0 && is_buf(payload)) ba.push(payload);
}

function write_biff_continue(ba, type, payload, length) {
	var len = length || (payload||[]).length || 0;
	if(len <= 8224) return write_biff_rec(ba, type, payload, len);
	var t = type;
	if(isNaN(t)) return;
	var parts = payload.parts || [], sidx = 0;
	var i = 0, w = 0;
	while(w + (parts[sidx] || 8224) <= 8224) { w+= (parts[sidx] || 8224); sidx++; }
	var o = ba.next(4);
	o.write_shift(2, t);
	o.write_shift(2, w);
	ba.push(payload.slice(i, i + w));
	i += w;
	while(i < len) {
		o = ba.next(4);
		o.write_shift(2, 0x3c); // TODO: figure out correct continue type
		w = 0;
		while(w + (parts[sidx] || 8224) <= 8224) { w+= (parts[sidx] || 8224); sidx++; }
		o.write_shift(2, w);
		ba.push(payload.slice(i, i+w)); i+= w;
	}
}

function write_BIFF2Cell(out, r, c) {
	if(!out) out = new_buf(7);
	out.write_shift(2, r);
	out.write_shift(2, c);
	out.write_shift(2, 0);
	out.write_shift(1, 0);
	return out;
}

function write_BIFF2BERR(r, c, val, t) {
	var out = new_buf(9);
	write_BIFF2Cell(out, r, c);
	write_Bes(val, t || 'b', out);
	return out;
}

/* TODO: codepage, large strings */
function write_BIFF2LABEL(r, c, val) {
	var out = new_buf(8 + 2*val.length);
	write_BIFF2Cell(out, r, c);
	out.write_shift(1, val.length);
	out.write_shift(val.length, val, 'sbcs');
	return out.l < out.length ? out.slice(0, out.l) : out;
}

function write_ws_biff2_cell(ba, cell, R, C) {
	if(cell.v != null) switch(cell.t) {
		case 'd': case 'n':
			var v = cell.t == 'd' ? datenum(parseDate(cell.v)) : cell.v;
			if((v == (v|0)) && (v >= 0) && (v < 65536))
				write_biff_rec(ba, 0x0002, write_BIFF2INT(R, C, v));
			else
				write_biff_rec(ba, 0x0003, write_BIFF2NUM(R,C, v));
			return;
		case 'b': case 'e': write_biff_rec(ba, 0x0005, write_BIFF2BERR(R, C, cell.v, cell.t)); return;
		/* TODO: codepage, sst */
		case 's': case 'str':
			write_biff_rec(ba, 0x0004, write_BIFF2LABEL(R, C, cell.v == null ? "" : String(cell.v).slice(0,255)));
			return;
	}
	write_biff_rec(ba, 0x0001, write_BIFF2Cell(null, R, C));
}

function write_ws_biff2(ba, ws, idx, opts) {
	var dense = Array.isArray(ws);
	var range = safe_decode_range(ws['!ref'] || "A1"), ref, rr = "", cols = [];
	if(range.e.c > 0xFF || range.e.r > 0x3FFF) {
		if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
		range.e.c = Math.min(range.e.c, 0xFF);
		range.e.r = Math.min(range.e.c, 0x3FFF);
		ref = encode_range(range);
	}
	for(var R = range.s.r; R <= range.e.r; ++R) {
		rr = encode_row(R);
		for(var C = range.s.c; C <= range.e.c; ++C) {
			if(R === range.s.r) cols[C] = encode_col(C);
			ref = cols[C] + rr;
			var cell = dense ? (ws[R]||[])[C] : ws[ref];
			if(!cell) continue;
			/* write cell */
			write_ws_biff2_cell(ba, cell, R, C, opts);
		}
	}
}

/* Based on test files */
function write_biff2_buf(wb, opts) {
	var o = opts || {};
	if(DENSE != null && o.dense == null) o.dense = DENSE;
	var ba = buf_array();
	var idx = 0;
	for(var i=0;i<wb.SheetNames.length;++i) if(wb.SheetNames[i] == o.sheet) idx=i;
	if(idx == 0 && !!o.sheet && wb.SheetNames[0] != o.sheet) throw new Error("Sheet not found: " + o.sheet);
	write_biff_rec(ba, (o.biff == 4 ? 0x0409 : (o.biff == 3 ? 0x0209 : 0x0009)), write_BOF(wb, 0x10, o));
	/* ... */
	write_ws_biff2(ba, wb.Sheets[wb.SheetNames[idx]], idx, o, wb);
	/* ... */
	write_biff_rec(ba, 0x000A);
	return ba.end();
}

function write_FONTS_biff8(ba, data, opts) {
	write_biff_rec(ba, 0x0031 /* Font */, write_Font({
		sz:12,
		color: {theme:1},
		name: "Arial",
		family: 2,
		scheme: "minor"
	}, opts));
}


function write_FMTS_biff8(ba, NF, opts) {
	if(!NF) return;
	[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) write_biff_rec(ba, 0x041E /* Format */, write_Format(i, NF[i], opts));
	});
}

function write_FEAT(ba, ws) {
	/* [MS-XLS] 2.4.112 */
	var o = new_buf(19);
	o.write_shift(4, 0x867); o.write_shift(4, 0); o.write_shift(4, 0);
	o.write_shift(2, 3); o.write_shift(1, 1); o.write_shift(4, 0);
	write_biff_rec(ba, 0x0867 /* FeatHdr */, o);
	/* [MS-XLS] 2.4.111 */
	o = new_buf(39);
	o.write_shift(4, 0x868); o.write_shift(4, 0); o.write_shift(4, 0);
	o.write_shift(2, 3); o.write_shift(1, 0); o.write_shift(4, 0);
	o.write_shift(2, 1); o.write_shift(4, 4); o.write_shift(2, 0);
	write_Ref8U(safe_decode_range(ws['!ref']||"A1"), o);
	o.write_shift(4, 4);
	write_biff_rec(ba, 0x0868 /* Feat */, o);
}

function write_CELLXFS_biff8(ba, opts) {
	for(var i = 0; i < 16; ++i) write_biff_rec(ba, 0x00e0 /* XF */, write_XF({numFmtId:0, style:true}, 0, opts));
	opts.cellXfs.forEach(function(c) {
		write_biff_rec(ba, 0x00e0 /* XF */, write_XF(c, 0, opts));
	});
}

function write_ws_biff8_hlinks(ba, ws) {
	for(var R=0; R<ws['!links'].length; ++R) {
		var HL = ws['!links'][R];
		write_biff_rec(ba, 0x01b8 /* HLink */, write_HLink(HL));
		if(HL[1].Tooltip) write_biff_rec(ba, 0x0800 /* HLinkTooltip */, write_HLinkTooltip(HL));
	}
	delete ws['!links'];
}

function write_ws_cols_biff8(ba, cols) {
	if(!cols) return;
	var cnt = 0;
	cols.forEach(function(col, idx) {
		if(++cnt <= 256 && col) {
			write_biff_rec(ba, 0x007d /* ColInfo */, write_ColInfo(col_obj_w(idx, col), idx));
		}
	});
}

function write_ws_biff8_cell(ba, cell, R, C, opts) {
	var os = 16 + get_cell_style(opts.cellXfs, cell, opts);
	if(cell.v == null && !cell.bf) {
		write_biff_rec(ba, 0x0201 /* Blank */, write_XLSCell(R, C, os));
		return;
	}
	if(cell.bf) write_biff_rec(ba, 0x0006 /* Formula */, write_Formula(cell, R, C, opts, os));
	else switch(cell.t) {
		case 'd': case 'n':
			var v = cell.t == 'd' ? datenum(parseDate(cell.v)) : cell.v;
			/* TODO: emit RK as appropriate */
			write_biff_rec(ba, 0x0203 /* Number */, write_Number(R, C, v, os, opts));
			break;
		case 'b': case 'e':
			write_biff_rec(ba, 0x0205 /* BoolErr */, write_BoolErr(R, C, cell.v, os, opts, cell.t));
			break;
		/* TODO: codepage, sst */
		case 's': case 'str':
			if(opts.bookSST) {
				var isst = get_sst_id(opts.Strings, cell.v == null ? "" : String(cell.v), opts.revStrings);
				write_biff_rec(ba, 0x00fd /* LabelSst */, write_LabelSst(R, C, isst, os, opts));
			} else write_biff_rec(ba, 0x0204 /* Label */, write_Label(R, C, (cell.v == null ? "" : String(cell.v)).slice(0,255), os, opts));
			break;
		default:
			write_biff_rec(ba, 0x0201 /* Blank */, write_XLSCell(R, C, os));
	}
}

/* [MS-XLS] 2.1.7.20.5 */
function write_ws_biff8(idx, opts, wb) {
	var ba = buf_array();
	var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
	var _WB = ((wb||{}).Workbook||{});
	var _sheet = ((_WB.Sheets||[])[idx]||{});
	var dense = Array.isArray(ws);
	var b8 = opts.biff == 8;
	var ref, rr = "", cols = [];
	var range = safe_decode_range(ws['!ref'] || "A1");
	var MAX_ROWS = b8 ? 65536 : 16384;
	if(range.e.c > 0xFF || range.e.r >= MAX_ROWS) {
		if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
		range.e.c = Math.min(range.e.c, 0xFF);
		range.e.r = Math.min(range.e.c, MAX_ROWS-1);
	}

	write_biff_rec(ba, 0x0809, write_BOF(wb, 0x10, opts));
	/* [Uncalced] Index */
	write_biff_rec(ba, 0x000d /* CalcMode */, writeuint16(1));
	write_biff_rec(ba, 0x000c /* CalcCount */, writeuint16(100));
	write_biff_rec(ba, 0x000f /* CalcRefMode */, writebool(true));
	write_biff_rec(ba, 0x0011 /* CalcIter */, writebool(false));
	write_biff_rec(ba, 0x0010 /* CalcDelta */, write_Xnum(0.001));
	write_biff_rec(ba, 0x005f /* CalcSaveRecalc */, writebool(true));
	write_biff_rec(ba, 0x002a /* PrintRowCol */, writebool(false));
	write_biff_rec(ba, 0x002b /* PrintGrid */, writebool(false));
	write_biff_rec(ba, 0x0082 /* GridSet */, writeuint16(1));
	write_biff_rec(ba, 0x0080 /* Guts */, write_Guts([0,0]));
	/* DefaultRowHeight WsBool [Sync] [LPr] [HorizontalPageBreaks] [VerticalPageBreaks] */
	/* Header (string) */
	/* Footer (string) */
	write_biff_rec(ba, 0x0083 /* HCenter */, writebool(false));
	write_biff_rec(ba, 0x0084 /* VCenter */, writebool(false));
	/* ... */
	if(b8) write_ws_cols_biff8(ba, ws["!cols"]);
	/* ... */
	write_biff_rec(ba, 0x0200 /* Dimensions */, write_Dimensions(range, opts));
	/* ... */

	if(b8) ws['!links'] = [];
	var comments = [];
	for(var R = range.s.r; R <= range.e.r; ++R) {
		rr = encode_row(R);
		for(var C = range.s.c; C <= range.e.c; ++C) {
			if(R === range.s.r) cols[C] = encode_col(C);
			ref = cols[C] + rr;
			var cell = dense ? (ws[R]||[])[C] : ws[ref];
			if(!cell) continue;
			/* write cell */
			write_ws_biff8_cell(ba, cell, R, C, opts);
			if(b8 && cell.l) ws['!links'].push([ref, cell.l]);
			if(b8 && cell.c) comments.push([ref, cell.c]);
		}
	}
	var cname = _sheet.CodeName || _sheet.name || s;
	/* ... */
	// if(b8) comments.forEach(function(comment) { write_biff_rec(ba, 0x001c /* Note */, write_NoteSh(comment)); });
	/* ... */
	if(b8) write_biff_rec(ba, 0x023e /* Window2 */, write_Window2((_WB.Views||[])[0]));
	/* ... */
	if(b8 && (ws['!merges']||[]).length) write_biff_rec(ba, 0x00e5 /* MergeCells */, write_MergeCells(ws['!merges']));
	/* [LRng] *QUERYTABLE [PHONETICINFO] CONDFMTS */
	if(b8) write_ws_biff8_hlinks(ba, ws);
	/* [DVAL] */
	write_biff_rec(ba, 0x01ba /* CodeName */, write_XLUnicodeString(cname, opts));
	/* *WebPub *CellWatch [SheetExt] */
	if(b8) write_FEAT(ba, ws);
	/* *FEAT11 *RECORD12 */
	write_biff_rec(ba, 0x000a /* EOF */);
	return ba.end();
}

/* [MS-XLS] 2.1.7.20.3 */
function write_biff8_global(wb, bufs, opts) {
	var A = buf_array();
	var _WB = ((wb||{}).Workbook||{});
	var _sheets = (_WB.Sheets||[]);
	var _wb = _WB.WBProps||{};
	var b8 = opts.biff == 8, b5 = opts.biff == 5;
	write_biff_rec(A, 0x0809, write_BOF(wb, 0x05, opts));
	if(opts.bookType == "xla") write_biff_rec(A, 0x0087 /* Addin */);
	write_biff_rec(A, 0x00e1 /* InterfaceHdr */, b8 ? writeuint16(0x04b0) : null);
	write_biff_rec(A, 0x00c1 /* Mms */, writezeroes(2));
	if(b5) write_biff_rec(A, 0x00bf /* ToolbarHdr */);
	if(b5) write_biff_rec(A, 0x00c0 /* ToolbarEnd */);
	write_biff_rec(A, 0x00e2 /* InterfaceEnd */);
	write_biff_rec(A, 0x005c /* WriteAccess */, write_WriteAccess("SheetJS", opts));
	/* [FileSharing] */
	write_biff_rec(A, 0x0042 /* CodePage */, writeuint16(b8 ? 0x04b0 : 0x04E4));
	/* *2047 Lel */
	if(b8) write_biff_rec(A, 0x0161 /* DSF */, writeuint16(0));
	if(b8) write_biff_rec(A, 0x01c0 /* Excel9File */);
	write_biff_rec(A, 0x013d /* RRTabId */, write_RRTabId(wb.SheetNames.length));
	if(b8 && wb.vbaraw) write_biff_rec(A, 0x00d3 /* ObProj */);
	/* [ObNoMacros] */
	if(b8 && wb.vbaraw) {
		var cname = _wb.CodeName || "ThisWorkbook";
		write_biff_rec(A, 0x01ba /* CodeName */, write_XLUnicodeString(cname, opts));
	}
	write_biff_rec(A, 0x009c /* BuiltInFnGroupCount */, writeuint16(0x11));
	/* *FnGroupName *FnGrp12 */
	/* *Lbl */
	/* [OleObjectSize] */
	write_biff_rec(A, 0x0019 /* WinProtect */, writebool(false));
	write_biff_rec(A, 0x0012 /* Protect */, writebool(false));
	write_biff_rec(A, 0x0013 /* Password */, writeuint16(0));
	if(b8) write_biff_rec(A, 0x01af /* Prot4Rev */, writebool(false));
	if(b8) write_biff_rec(A, 0x01bc /* Prot4RevPass */, writeuint16(0));
	write_biff_rec(A, 0x003d /* Window1 */, write_Window1(opts));
	write_biff_rec(A, 0x0040 /* Backup */, writebool(false));
	write_biff_rec(A, 0x008d /* HideObj */, writeuint16(0));
	write_biff_rec(A, 0x0022 /* Date1904 */, writebool(safe1904(wb)=="true"));
	write_biff_rec(A, 0x000e /* CalcPrecision */, writebool(true));
	if(b8) write_biff_rec(A, 0x01b7 /* RefreshAll */, writebool(false));
	write_biff_rec(A, 0x00DA /* BookBool */, writeuint16(0));
	/* ... */
	write_FONTS_biff8(A, wb, opts);
	write_FMTS_biff8(A, wb.SSF, opts);
	write_CELLXFS_biff8(A, opts);
	/* ... */
	if(b8) write_biff_rec(A, 0x0160 /* UsesELFs */, writebool(false));
	var a = A.end();

	var C = buf_array();
	/* METADATA [MTRSettings] [ForceFullCalculation] */
	if(b8) write_biff_rec(C, 0x008C /* Country */, write_Country());
	/* *SUPBOOK *LBL *RTD [RecalcId] *HFPicture *MSODRAWINGGROUP */

	/* BIFF8: [SST *Continue] ExtSST */
	if(b8 && opts.Strings) write_biff_continue(C, 0x00FC /* SST */, write_SST(opts.Strings, opts));

	/* *WebPub [WOpt] [CrErr] [BookExt] *FeatHdr *DConn [THEME] [CompressPictures] [Compat12] [GUIDTypeLib] */
	write_biff_rec(C, 0x000A /* EOF */);
	var c = C.end();

	var B = buf_array();
	var blen = 0, j = 0;
	for(j = 0; j < wb.SheetNames.length; ++j) blen += (b8 ? 12 : 11) + (b8 ? 2 : 1) * wb.SheetNames[j].length;
	var start = a.length + blen + c.length;
	for(j = 0; j < wb.SheetNames.length; ++j) {
		var _sheet = _sheets[j] || ({});
		write_biff_rec(B, 0x0085 /* BoundSheet8 */, write_BoundSheet8({pos:start, hs:_sheet.Hidden||0, dt:0, name:wb.SheetNames[j]}, opts));
		start += bufs[j].length;
	}
	/* 1*BoundSheet8 */
	var b = B.end();
	if(blen != b.length) throw new Error("BS8 " + blen + " != " + b.length);

	var out = [];
	if(a.length) out.push(a);
	if(b.length) out.push(b);
	if(c.length) out.push(c);
	return bconcat(out);
}

/* [MS-XLS] 2.1.7.20 Workbook Stream */
function write_biff8_buf(wb, opts) {
	var o = opts || {};
	var bufs = [];

	if(wb && !wb.SSF) {
		wb.SSF = dup(table_fmt);
	}
	if(wb && wb.SSF) {
		make_ssf(); SSF_load_table(wb.SSF);
		// $FlowIgnore
		o.revssf = evert_num(wb.SSF); o.revssf[wb.SSF[65535]] = 0;
		o.ssf = wb.SSF;
	}

	o.Strings = []; o.Strings.Count = 0; o.Strings.Unique = 0;
	fix_write_opts(o);

	o.cellXfs = [];
	get_cell_style(o.cellXfs, {}, {revssf:{"General":0}});

	if(!wb.Props) wb.Props = {};

	for(var i = 0; i < wb.SheetNames.length; ++i) bufs[bufs.length] = write_ws_biff8(i, o, wb);
	bufs.unshift(write_biff8_global(wb, bufs, o));
	return bconcat(bufs);
}

function write_biff_buf(wb, opts) {
	for(var i = 0; i <= wb.SheetNames.length; ++i) {
		var ws = wb.Sheets[wb.SheetNames[i]];
		if(!ws || !ws["!ref"]) continue;
		var range = decode_range(ws["!ref"]);
		if(range.e.c > 255) { // note: 255 is IV
			if(typeof console != "undefined" && console.error) console.error("Worksheet '" + wb.SheetNames[i] + "' extends beyond column IV (255).  Data may be lost.");
		}
	}

	var o = opts || {};
	switch(o.biff || 2) {
		case 8: case 5: return write_biff8_buf(wb, opts);
		case 4: case 3: case 2: return write_biff2_buf(wb, opts);
	}
	throw new Error("invalid type " + o.bookType + " for BIFF");
}
/* note: browser DOM element cannot see mso- style attrs, must parse */
function html_to_sheet(str, _opts) {
	var opts = _opts || {};
	if(DENSE != null && opts.dense == null) opts.dense = DENSE;
	var ws = opts.dense ? ([]) : ({});
	str = str.replace(/<!--.*?-->/g, "");
	var mtch = str.match(/<table/i);
	if(!mtch) throw new Error("Invalid HTML: could not find <table>");
	var mtch2 = str.match(/<\/table/i);
	var i = mtch.index, j = mtch2 && mtch2.index || str.length;
	var rows = split_regex(str.slice(i, j), /(:?<tr[^>]*>)/i, "<tr>");
	var R = -1, C = 0, RS = 0, CS = 0;
	var range = {s:{r:10000000, c:10000000},e:{r:0,c:0}};
	var merges = [];
	for(i = 0; i < rows.length; ++i) {
		var row = rows[i].trim();
		var hd = row.slice(0,3).toLowerCase();
		if(hd == "<tr") { ++R; if(opts.sheetRows && opts.sheetRows <= R) { --R; break; } C = 0; continue; }
		if(hd != "<td" && hd != "<th") continue;
		var cells = row.split(/<\/t[dh]>/i);
		for(j = 0; j < cells.length; ++j) {
			var cell = cells[j].trim();
			if(!cell.match(/<t[dh]/i)) continue;
			var m = cell, cc = 0;
			/* TODO: parse styles etc */
			while(m.charAt(0) == "<" && (cc = m.indexOf(">")) > -1) m = m.slice(cc+1);
			for(var midx = 0; midx < merges.length; ++midx) {
				var _merge = merges[midx];
				if(_merge.s.c == C && _merge.s.r < R && R <= _merge.e.r) { C = _merge.e.c + 1; midx = -1; }
			}
			var tag = parsexmltag(cell.slice(0, cell.indexOf(">")));
			CS = tag.colspan ? +tag.colspan : 1;
			if((RS = +tag.rowspan)>1 || CS>1) merges.push({s:{r:R,c:C},e:{r:R + (RS||1) - 1, c:C + CS - 1}});
			var _t = tag.t || tag["data-t"] || "";
			/* TODO: generate stub cells */
			if(!m.length) { C += CS; continue; }
			m = htmldecode(m);
			if(range.s.r > R) range.s.r = R; if(range.e.r < R) range.e.r = R;
			if(range.s.c > C) range.s.c = C; if(range.e.c < C) range.e.c = C;
			if(!m.length) { C += CS; continue; }
			var o = {t:'s', v:m};
			if(opts.raw || !m.trim().length || _t == 's'){}
			else if(m === 'TRUE') o = {t:'b', v:true};
			else if(m === 'FALSE') o = {t:'b', v:false};
			else if(!isNaN(fuzzynum(m))) o = {t:'n', v:fuzzynum(m)};
			else if(!isNaN(fuzzydate(m).getDate())) {
				o = ({t:'d', v:parseDate(m)});
				if(!opts.cellDates) o = ({t:'n', v:datenum(o.v)});
				o.z = opts.dateNF || table_fmt[14];
			}
			if(opts.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = o; }
			else ws[encode_cell({r:R, c:C})] = o;
			C += CS;
		}
	}
	ws['!ref'] = encode_range(range);
	if(merges.length) ws["!merges"] = merges;
	return ws;
}
function make_html_row(ws, r, R, o) {
	var M = (ws['!merges'] ||[]);
	var oo = [];
	var sp = ({});
	for(var C = r.s.c; C <= r.e.c; ++C) {
		var RS = 0, CS = 0;
		for(var j = 0; j < M.length; ++j) {
			if(M[j].s.r > R || M[j].s.c > C) continue;
			if(M[j].e.r < R || M[j].e.c < C) continue;
			if(M[j].s.r < R || M[j].s.c < C) { RS = -1; break; }
			RS = M[j].e.r - M[j].s.r + 1; CS = M[j].e.c - M[j].s.c + 1; break;
		}
		if(RS < 0) continue;
		var coord = encode_cell({r:R,c:C});
		var cell = o.dense ? (ws[R]||[])[C] : ws[coord];
		/* TODO: html entities */
		var w = (cell && cell.v != null) && (cell.h || escapehtml(cell.w || (format_cell(cell), cell.w) || "")) || "";
		sp = ({});
		if(RS > 1) sp.rowspan = RS;
		if(CS > 1) sp.colspan = CS;
		if(o.editable) w = '<span contenteditable="true">' + w + '</span>';
		else if(cell) {
			sp["data-t"] = cell && cell.t || 'z';
			if(cell.v != null) sp["data-v"] = cell.v;
			if(cell.z != null) sp["data-z"] = cell.z;
			if(cell.l && (cell.l.Target || "#").charAt(0) != "#") w = '<a href="' + cell.l.Target +'">' + w + '</a>';
		}
		sp.id = (o.id || "sjs") + "-" + coord;
		oo.push(writextag('td', w, sp));
	}
	var preamble = "<tr>";
	return preamble + oo.join("") + "</tr>";
}

var HTML_BEGIN = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';
var HTML_END = '</body></html>';

function html_to_workbook(str, opts) {
	var mtch = str.match(/<table[\s\S]*?>[\s\S]*?<\/table>/gi);
	if(!mtch || mtch.length == 0) throw new Error("Invalid HTML: could not find <table>");
	if(mtch.length == 1) {
		var w = sheet_to_workbook(html_to_sheet(mtch[0], opts), opts);
		w.bookType = "html";
		return w;
	}
	var wb = book_new();
	mtch.forEach(function(s, idx) { book_append_sheet(wb, html_to_sheet(s, opts), "Sheet" + (idx+1)); });
	wb.bookType = "html";
	return wb;
}

function make_html_preamble(ws, R, o) {
	var out = [];
	return out.join("") + '<table' + (o && o.id ? ' id="' + o.id + '"' : "") + '>';
}

function sheet_to_html(ws, opts/*, wb:?Workbook*/) {
	var o = opts || {};
	var header = o.header != null ? o.header : HTML_BEGIN;
	var footer = o.footer != null ? o.footer : HTML_END;
	var out = [header];
	var r = decode_range(ws['!ref']);
	o.dense = Array.isArray(ws);
	out.push(make_html_preamble(ws, r, o));
	for(var R = r.s.r; R <= r.e.r; ++R) out.push(make_html_row(ws, r, R, o));
	out.push("</table>" + footer);
	return out.join("");
}

function sheet_add_dom(ws, table, _opts) {
	var rows = table.rows;
	if(!rows) {
		/* not an HTML TABLE */
		throw "Unsupported origin when " + table.tagName + " is not a TABLE";
	}

	var opts = _opts || {};
	if(DENSE != null) opts.dense = DENSE;
	var or_R = 0, or_C = 0;
	if(opts.origin != null) {
		if(typeof opts.origin == 'number') or_R = opts.origin;
		else {
			var _origin = typeof opts.origin == "string" ? decode_cell(opts.origin) : opts.origin;
			or_R = _origin.r; or_C = _origin.c;
		}
	}

	var sheetRows = Math.min(opts.sheetRows||10000000, rows.length);
	var range = {s:{r:0,c:0},e:{r:or_R,c:or_C}};
	if(ws["!ref"]) {
		var _range = decode_range(ws["!ref"]);
		range.s.r = Math.min(range.s.r, _range.s.r);
		range.s.c = Math.min(range.s.c, _range.s.c);
		range.e.r = Math.max(range.e.r, _range.e.r);
		range.e.c = Math.max(range.e.c, _range.e.c);
		if(or_R == -1) range.e.r = or_R = _range.e.r + 1;
	}
	var merges = [], midx = 0;
	var rowinfo = ws["!rows"] || (ws["!rows"] = []);
	var _R = 0, R = 0, _C = 0, C = 0, RS = 0, CS = 0;
	if(!ws["!cols"]) ws['!cols'] = [];
	for(; _R < rows.length && R < sheetRows; ++_R) {
		var row = rows[_R];
		if (is_dom_element_hidden(row)) {
			if (opts.display) continue;
			rowinfo[R] = {hidden: true};
		}
		var elts = (row.cells);
		for(_C = C = 0; _C < elts.length; ++_C) {
			var elt = elts[_C];
			if (opts.display && is_dom_element_hidden(elt)) continue;
			var v = elt.hasAttribute('data-v') ? elt.getAttribute('data-v') : elt.hasAttribute('v') ? elt.getAttribute('v') : htmldecode(elt.innerHTML);
			var z = elt.getAttribute('data-z') || elt.getAttribute('z');
			for(midx = 0; midx < merges.length; ++midx) {
				var m = merges[midx];
				if(m.s.c == C + or_C && m.s.r < R + or_R && R + or_R <= m.e.r) { C = m.e.c+1 - or_C; midx = -1; }
			}
			/* TODO: figure out how to extract nonstandard mso- style */
			CS = +elt.getAttribute("colspan") || 1;
			if( ((RS = (+elt.getAttribute("rowspan") || 1)))>1 || CS>1) merges.push({s:{r:R + or_R,c:C + or_C},e:{r:R + or_R + (RS||1) - 1, c:C + or_C + (CS||1) - 1}});
			var o = {t:'s', v:v};
			var _t = elt.getAttribute("data-t") || elt.getAttribute("t") || "";
			if(v != null) {
				if(v.length == 0) o.t = _t || 'z';
				else if(opts.raw || v.trim().length == 0 || _t == "s"){}
				else if(v === 'TRUE') o = {t:'b', v:true};
				else if(v === 'FALSE') o = {t:'b', v:false};
				else if(!isNaN(fuzzynum(v))) o = {t:'n', v:fuzzynum(v)};
				else if(!isNaN(fuzzydate(v).getDate())) {
					o = ({t:'d', v:parseDate(v)});
					if(!opts.cellDates) o = ({t:'n', v:datenum(o.v)});
					o.z = opts.dateNF || table_fmt[14];
				}
			}
			if(o.z === undefined && z != null) o.z = z;
			/* The first link is used.  Links are assumed to be fully specified.
			 * TODO: The right way to process relative links is to make a new <a> */
			var l = "", Aelts = elt.getElementsByTagName("A");
			if(Aelts && Aelts.length) for(var Aelti = 0; Aelti < Aelts.length; ++Aelti)	if(Aelts[Aelti].hasAttribute("href")) {
				l = Aelts[Aelti].getAttribute("href"); if(l.charAt(0) != "#") break;
			}
			if(l && l.charAt(0) != "#" &&	l.slice(0, 11).toLowerCase() != 'javascript:') o.l = ({ Target: l });
			if(opts.dense) { if(!ws[R + or_R]) ws[R + or_R] = []; ws[R + or_R][C + or_C] = o; }
			else ws[encode_cell({c:C + or_C, r:R + or_R})] = o;
			if(range.e.c < C + or_C) range.e.c = C + or_C;
			C += CS;
		}
		++R;
	}
	if(merges.length) ws['!merges'] = (ws["!merges"] || []).concat(merges);
	range.e.r = Math.max(range.e.r, R - 1 + or_R);
	ws['!ref'] = encode_range(range);
	if(R >= sheetRows) ws['!fullref'] = encode_range((range.e.r = rows.length-_R+R-1 + or_R,range)); // We can count the real number of rows to parse but we don't to improve the performance
	return ws;
}

function parse_dom_table(table, _opts) {
	var opts = _opts || {};
	var ws = opts.dense ? ([]) : ({});
	return sheet_add_dom(ws, table, _opts);
}

function table_to_book(table, opts) {
	var o = sheet_to_workbook(parse_dom_table(table, opts), opts);
	//o.bookType = "dom"; // TODO: define a type for this
	return o;
}

function is_dom_element_hidden(element) {
	var display = '';
	var get_computed_style = get_get_computed_style_function(element);
	if(get_computed_style) display = get_computed_style(element).getPropertyValue('display');
	if(!display) display = element.style && element.style.display;
	return display === 'none';
}

/* global getComputedStyle */
function get_get_computed_style_function(element) {
	// The proper getComputedStyle implementation is the one defined in the element window
	if(element.ownerDocument.defaultView && typeof element.ownerDocument.defaultView.getComputedStyle === 'function') return element.ownerDocument.defaultView.getComputedStyle;
	// If it is not available, try to get one from the global namespace
	if(typeof getComputedStyle === 'function') return getComputedStyle;
	return null;
}
/* OpenDocument */
function parse_text_p(text) {
	/* 6.1.2 White Space Characters */
	var fixed = text
		.replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ")
		.replace(/<text:s\/>/g," ")
		.replace(/<text:s text:c="(\d+)"\/>/g, function($$,$1) { return Array(parseInt($1,10)+1).join(" "); })
		.replace(/<text:tab[^>]*\/>/g,"\t")
		.replace(/<text:line-break\/>/g,"\n");
	var v = unescapexml(fixed.replace(/<[^>]*>/g,""));

	return [v];
}

/* Note: ODS can stick styles in content.xml or styles.xml, FODS blurs lines */
function parse_ods_styles(d, _opts, _nfm) {
	var number_format_map = _nfm || {};
	var str = xlml_normalize(d);
	xlmlregex.lastIndex = 0;
	str = str.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");
	var Rn, NFtag, NF = "", tNF = "", y, etpos = 0, tidx = -1, infmt = false, payload = "";
	while((Rn = xlmlregex.exec(str))) {
		switch((Rn[3]=Rn[3].replace(/_.*$/,""))) {
		/* Number Format Definitions */
		case 'number-style': // <number:number-style> 16.29.2
		case 'currency-style': // <number:currency-style> 16.29.8
		case 'percentage-style': // <number:percentage-style> 16.29.10
		case 'date-style': // <number:date-style> 16.29.11
		case 'time-style': // <number:time-style> 16.29.19
		case 'text-style': // <number:text-style> 16.29.26
			if(Rn[1]==='/') {
				infmt = false;
				if(NFtag['truncate-on-overflow'] == "false") {
					if(NF.match(/h/)) NF = NF.replace(/h+/, "[$&]");
					else if(NF.match(/m/)) NF = NF.replace(/m+/, "[$&]");
					else if(NF.match(/s/)) NF = NF.replace(/s+/, "[$&]");
				}
				number_format_map[NFtag.name] = NF;
				NF = "";
			} else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
				infmt = true;
				NF = "";
				NFtag = parsexmltag(Rn[0], false);
			} break;

		// LibreOffice bug https://bugs.documentfoundation.org/show_bug.cgi?id=149484
		case 'boolean-style': // <number:boolean-style> 16.29.24
			if(Rn[1]==='/') {
				infmt = false;
				number_format_map[NFtag.name] = "General";
				NF = "";
			} else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
				infmt = true;
				NF = "";
				NFtag = parsexmltag(Rn[0], false);
			} break;

		/* Number Format Elements */
		case 'boolean': // <number:boolean> 16.29.25
			NF += "General"; // ODF spec is unfortunately underspecified here
			break;

		case 'text': // <number:text> 16.29.27
			if(Rn[1]==='/') {
				payload = str.slice(tidx, xlmlregex.lastIndex - Rn[0].length);
				// NOTE: Excel has a different interpretation of "%%" and friends
				if(payload == "%" && NFtag[0] == '<number:percentage-style') NF += "%";
				else NF += '"' + payload.replace(/"/g, '""') + '"';
			} else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
				tidx = xlmlregex.lastIndex;
			} break;


		case 'day': { // <number:day> 16.29.12
			y = parsexmltag(Rn[0], false);
			switch(y["style"]) {
				case "short": NF += "d"; break;
				case "long": NF += "dd"; break;
				default: NF += "dd"; break; // TODO: error condition
			}
		} break;

		case 'day-of-week': { // <number:day-of-week> 16.29.16
			y = parsexmltag(Rn[0], false);
			switch(y["style"]) {
				case "short": NF += "ddd"; break;
				case "long": NF += "dddd"; break;
				default: NF += "ddd"; break;
			}
		} break;

		case 'era': { // <number:era> 16.29.15 TODO: proper mapping
			y = parsexmltag(Rn[0], false);
			switch(y["style"]) {
				case "short": NF += "ee"; break;
				case "long": NF += "eeee"; break;
				default: NF += "eeee"; break; // TODO: error condition
			}
		} break;

		case 'hours': { // <number:hours> 16.29.20
			y = parsexmltag(Rn[0], false);
			switch(y["style"]) {
				case "short": NF += "h"; break;
				case "long": NF += "hh"; break;
				default: NF += "hh"; break; // TODO: error condition
			}
		} break;

		case 'minutes': { // <number:minutes> 16.29.21
			y = parsexmltag(Rn[0], false);
			switch(y["style"]) {
				case "short": NF += "m"; break;
				case "long": NF += "mm"; break;
				default: NF += "mm"; break; // TODO: error condition
			}
		} break;

		case 'month': { // <number:month> 16.29.13
			y = parsexmltag(Rn[0], false);
			if(y["textual"]) NF += "mm";
			switch(y["style"]) {
				case "short": NF += "m"; break;
				case "long": NF += "mm"; break;
				default: NF += "m"; break;
			}
		} break;

		case 'seconds': { // <number:seconds> 16.29.22
			y = parsexmltag(Rn[0], false);
			switch(y["style"]) {
				case "short": NF += "s"; break;
				case "long": NF += "ss"; break;
				default: NF += "ss"; break; // TODO: error condition
			}
			if(y["decimal-places"]) NF += "." + fill("0", +y["decimal-places"]);
		} break;

		case 'year': { // <number:year> 16.29.14
			y = parsexmltag(Rn[0], false);
			switch(y["style"]) {
				case "short": NF += "yy"; break;
				case "long": NF += "yyyy"; break;
				default: NF += "yy"; break; // TODO: error condition
			}
		} break;

		case 'am-pm': // <number:am-pm> 16.29.23
			NF += "AM/PM"; // LO autocorrects A/P -> AM/PM
			break;

		case 'week-of-year': // <number:week-of-year> 16.29.17
		case 'quarter': // <number:quarter> 16.29.18
			console.error("Excel does not support ODS format token " + Rn[3]);
			break;

		case 'fill-character': // <number:fill-character> 16.29.5
			if(Rn[1]==='/') {
				payload = str.slice(tidx, xlmlregex.lastIndex - Rn[0].length);
				// NOTE: Excel has a different interpretation of "%%" and friends
				NF += '"' + payload.replace(/"/g, '""') + '"*';
			} else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
				tidx = xlmlregex.lastIndex;
			} break;

		case 'scientific-number': // <number:scientific-number> 16.29.6
			// TODO: find a mapping for all parameters
			y = parsexmltag(Rn[0], false);
			NF += "0." + fill("0", +y["min-decimal-places"] || +y["decimal-places"] || 2) + fill("?", +y["decimal-places"] - +y["min-decimal-places"] || 0) + "E" + (parsexmlbool(y["forced-exponent-sign"]) ? "+" : "") + fill("0", +y["min-exponent-digits"] || 2);
			break;

		case 'fraction': // <number:fraction> 16.29.7
			// TODO: find a mapping for all parameters
			y = parsexmltag(Rn[0], false);
			if(!+y["min-integer-digits"]) NF += "#";
			else NF += fill("0", +y["min-integer-digits"]);
			NF += " ";
			NF += fill("?", +y["min-numerator-digits"] || 1);
			NF += "/";
			if(+y["denominator-value"]) NF += y["denominator-value"];
			else NF += fill("?", +y["min-denominator-digits"] || 1);
			break;

		case 'currency-symbol': // <number:currency-symbol> 16.29.9
			// TODO: localization with [$-...]
			if(Rn[1]==='/') {
				NF += '"' + str.slice(tidx, xlmlregex.lastIndex - Rn[0].length).replace(/"/g, '""') + '"';
			} else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
				tidx = xlmlregex.lastIndex;
			} else NF += "$";
			break;

		case 'text-properties': // <style:text-properties> 16.29.29
			y = parsexmltag(Rn[0], false);
			switch((y["color"]||"").toLowerCase().replace("#", "")) {
				case "ff0000": case "red": NF = "[Red]" + NF; break;
			}
			break;

		case 'text-content': // <number:text-content> 16.29.28
			NF += "@";
			break;

		case 'map': // <style:map> 16.3
			// TODO: handle more complex maps
			y = parsexmltag(Rn[0], false);
			if(unescapexml(y["condition"]) == "value()>=0") NF = number_format_map[y["apply-style-name"]] + ";" + NF;
			else console.error("ODS number format may be incorrect: " + y["condition"]);
			break;

		case 'number': // <number:number> 16.29.3
			// TODO: handle all the attributes
			if(Rn[1]==='/') break;
			y = parsexmltag(Rn[0], false);
			tNF = "";
			tNF += fill("0", +y["min-integer-digits"] || 1);
			if(parsexmlbool(y["grouping"])) tNF = commaify(fill("#", Math.max(0, 4 - tNF.length)) + tNF);
			if(+y["min-decimal-places"] || +y["decimal-places"]) tNF += ".";
			if(+y["min-decimal-places"]) tNF += fill("0", +y["min-decimal-places"] || 1);
			if(+y["decimal-places"] - (+y["min-decimal-places"]||0)) tNF += fill("0", +y["decimal-places"] - (+y["min-decimal-places"]||0)); // TODO: should this be "#" ?
			NF += tNF;
			break;

		case 'embedded-text': // <number:embedded-text> 16.29.4
			// TODO: verify interplay with grouping et al
			if(Rn[1]==='/') {
				if(etpos == 0) NF += '"' + str.slice(tidx, xlmlregex.lastIndex - Rn[0].length).replace(/"/g, '""') + '"';
				else NF = NF.slice(0, etpos) + '"' + str.slice(tidx, xlmlregex.lastIndex - Rn[0].length).replace(/"/g, '""') + '"' + NF.slice(etpos);
			} else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
				tidx = xlmlregex.lastIndex;
				etpos = -+parsexmltag(Rn[0], false)["position"] || 0;
			} break;

	}}
	return number_format_map;
}

function parse_content_xml(d, _opts, _nfm) {
		var opts = _opts || {};
		if(DENSE != null && opts.dense == null) opts.dense = DENSE;
		var str = xlml_normalize(d);
		var state = [], tmp;
		var tag;
		var nfidx, NF = "", pidx = 0;
		var sheetag;
		var rowtag;
		var Sheets = {}, SheetNames = [];
		var ws = opts.dense ? ([]) : ({});
		var Rn, q;
		var ctag = ({value:""});
		var textp = "", textpidx = 0, textptag;
		var textR = [];
		var R = -1, C = -1, range = {s: {r:1000000,c:10000000}, e: {r:0, c:0}};
		var row_ol = 0;
		var number_format_map = _nfm || {}, styles = {};
		var merges = [], mrange = {}, mR = 0, mC = 0;
		var rowinfo = [], rowpeat = 1, colpeat = 1;
		var arrayf = [];
		var WB = {Names:[], WBProps:{}};
		var atag = ({});
		var _Ref = ["", ""];
		var comments = [], comment = ({});
		var creator = "", creatoridx = 0;
		var isstub = false, intable = false;
		var i = 0;
		var baddate = 0;
		xlmlregex.lastIndex = 0;
		str = str.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");
		while((Rn = xlmlregex.exec(str))) switch((Rn[3]=Rn[3].replace(/_.*$/,""))) {

			case 'table': case '工作表': // 9.1.2 <table:table>
				if(Rn[1]==='/') {
					if(range.e.c >= range.s.c && range.e.r >= range.s.r) ws['!ref'] = encode_range(range);
					else ws['!ref'] = "A1:A1";
					if(opts.sheetRows > 0 && opts.sheetRows <= range.e.r) {
						ws['!fullref'] = ws['!ref'];
						range.e.r = opts.sheetRows - 1;
						ws['!ref'] = encode_range(range);
					}
					if(merges.length) ws['!merges'] = merges;
					if(rowinfo.length) ws["!rows"] = rowinfo;
					sheetag.name = sheetag['名称'] || sheetag.name;
					if(typeof JSON !== 'undefined') JSON.stringify(sheetag);
					SheetNames.push(sheetag.name);
					Sheets[sheetag.name] = ws;
					intable = false;
				}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
					sheetag = parsexmltag(Rn[0], false);
					R = C = -1;
					range.s.r = range.s.c = 10000000; range.e.r = range.e.c = 0;
					ws = opts.dense ? ([]) : ({}); merges = [];
					rowinfo = [];
					intable = true;
				}
				break;

			case 'table-row-group': // 9.1.9 <table:table-row-group>
				if(Rn[1] === "/") --row_ol; else ++row_ol;
				break;
			case 'table-row': case '行': // 9.1.3 <table:table-row>
				if(Rn[1] === '/') { R+=rowpeat; rowpeat = 1; break; }
				rowtag = parsexmltag(Rn[0], false);
				if(rowtag['行号']) R = rowtag['行号'] - 1; else if(R == -1) R = 0;
				rowpeat = +rowtag['number-rows-repeated'] || 1;
				/* TODO: remove magic */
				if(rowpeat < 10) for(i = 0; i < rowpeat; ++i) if(row_ol > 0) rowinfo[R + i] = {level: row_ol};
				C = -1; break;
			case 'covered-table-cell': // 9.1.5 <table:covered-table-cell>
				if(Rn[1] !== '/') ++C;
				if(opts.sheetStubs) {
					if(opts.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = {t:'z'}; }
					else ws[encode_cell({r:R,c:C})] = {t:'z'};
				}
				textp = ""; textR = [];
				break; /* stub */
			case 'table-cell': case '数据':
				if(Rn[0].charAt(Rn[0].length-2) === '/') {
					++C;
					ctag = parsexmltag(Rn[0], false);
					colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
					q = ({t:'z', v:null});
					if(ctag.formula && opts.cellFormula != false) q.f = ods_to_csf_formula(unescapexml(ctag.formula));
					if(ctag["style-name"] && styles[ctag["style-name"]]) q.z = styles[ctag["style-name"]];
					if((ctag['数据类型'] || ctag['value-type']) == "string") {
						q.t = "s"; q.v = unescapexml(ctag['string-value'] || "");
						if(opts.dense) {
							if(!ws[R]) ws[R] = [];
							ws[R][C] = q;
						} else {
							ws[encode_cell({r:R,c:C})] = q;
						}
					}
					C+= colpeat-1;
				} else if(Rn[1]!=='/') {
					++C;
					textp = ""; textpidx = 0; textR = [];
					colpeat = 1;
					var rptR = rowpeat ? R + rowpeat - 1 : R;
					if(C > range.e.c) range.e.c = C;
					if(C < range.s.c) range.s.c = C;
					if(R < range.s.r) range.s.r = R;
					if(rptR > range.e.r) range.e.r = rptR;
					ctag = parsexmltag(Rn[0], false);
					comments = []; comment = ({});
					q = ({t:ctag['数据类型'] || ctag['value-type'], v:null});
					if(ctag["style-name"] && styles[ctag["style-name"]]) q.z = styles[ctag["style-name"]];
					if(opts.cellFormula) {
						if(ctag.formula) ctag.formula = unescapexml(ctag.formula);
						if(ctag['number-matrix-columns-spanned'] && ctag['number-matrix-rows-spanned']) {
							mR = parseInt(ctag['number-matrix-rows-spanned'],10) || 0;
							mC = parseInt(ctag['number-matrix-columns-spanned'],10) || 0;
							mrange = {s: {r:R,c:C}, e:{r:R + mR-1,c:C + mC-1}};
							q.F = encode_range(mrange);
							arrayf.push([mrange, q.F]);
						}
						if(ctag.formula) q.f = ods_to_csf_formula(ctag.formula);
						else for(i = 0; i < arrayf.length; ++i)
							if(R >= arrayf[i][0].s.r && R <= arrayf[i][0].e.r)
								if(C >= arrayf[i][0].s.c && C <= arrayf[i][0].e.c)
									q.F = arrayf[i][1];
					}
					if(ctag['number-columns-spanned'] || ctag['number-rows-spanned']) {
						mR = parseInt(ctag['number-rows-spanned'],10) || 0;
						mC = parseInt(ctag['number-columns-spanned'],10) || 0;
						mrange = {s: {r:R,c:C}, e:{r:R + mR-1,c:C + mC-1}};
						merges.push(mrange);
					}

					/* 19.675.2 table:number-columns-repeated */
					if(ctag['number-columns-repeated']) colpeat = parseInt(ctag['number-columns-repeated'], 10);

					/* 19.385 office:value-type */
					switch(q.t) {
						case 'boolean': q.t = 'b'; q.v = parsexmlbool(ctag['boolean-value']) || (+ctag['boolean-value'] >= 1); break;
						case 'float': q.t = 'n'; q.v = parseFloat(ctag.value); break;
						case 'percentage': q.t = 'n'; q.v = parseFloat(ctag.value); break;
						case 'currency': q.t = 'n'; q.v = parseFloat(ctag.value); break;
						case 'date': q.t = 'd'; q.v = parseDate(ctag['date-value']);
							if(!opts.cellDates) { q.t = 'n'; q.v = datenum(q.v, WB.WBProps.date1904) - baddate; }
							if(!q.z) q.z = 'm/d/yy'; break;
						case 'time': q.t = 'n'; q.v = parse_isodur(ctag['time-value'])/86400;
							if(opts.cellDates) { q.t = 'd'; q.v = numdate(q.v); }
							if(!q.z) q.z = 'HH:MM:SS'; break;
						case 'number': q.t = 'n'; q.v = parseFloat(ctag['数据数值']); break;
						default:
							if(q.t === 'string' || q.t === 'text' || !q.t) {
								q.t = 's';
								if(ctag['string-value'] != null) { textp = unescapexml(ctag['string-value']); textR = []; }
							} else throw new Error('Unsupported value type ' + q.t);
					}
				} else {
					isstub = false;
					if(q.t === 's') {
						q.v = textp || '';
						if(textR.length) q.R = textR;
						isstub = textpidx == 0;
					}
					if(atag.Target) q.l = atag;
					if(comments.length > 0) { q.c = comments; comments = []; }
					if(textp && opts.cellText !== false) q.w = textp;
					if(isstub) { q.t = "z"; delete q.v; }
					if(!isstub || opts.sheetStubs) {
						if(!(opts.sheetRows && opts.sheetRows <= R)) {
							for(var rpt = 0; rpt < rowpeat; ++rpt) {
								colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
								if(opts.dense) {
									if(!ws[R + rpt]) ws[R + rpt] = [];
									ws[R + rpt][C] = rpt == 0 ? q : dup(q);
									while(--colpeat > 0) ws[R + rpt][C + colpeat] = dup(q);
								} else {
									ws[encode_cell({r:R + rpt,c:C})] = q;
									while(--colpeat > 0) ws[encode_cell({r:R + rpt,c:C + colpeat})] = dup(q);
								}
								if(range.e.c <= C) range.e.c = C;
							}
						}
					}
					colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
					C += colpeat-1; colpeat = 0;
					q = {};
					textp = ""; textR = [];
				}
				atag = ({});
				break; // 9.1.4 <table:table-cell>

			/* pure state */
			case 'document': // TODO: <office:document> is the root for FODS
			case 'document-content': case '电子表格文档': // 3.1.3.2 <office:document-content>
			case 'spreadsheet': case '主体': // 3.7 <office:spreadsheet>
			case 'scripts': // 3.12 <office:scripts>
			case 'styles': // TODO <office:styles>
			case 'font-face-decls': // 3.14 <office:font-face-decls>
			case 'master-styles': // 3.15.4 <office:master-styles> -- relevant for FODS
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
				break;

			case 'annotation': // 14.1 <office:annotation>
				if(Rn[1]==='/'){
					if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;
					comment.t = textp;
					if(textR.length) comment.R = textR;
					comment.a = creator;
					comments.push(comment);
				}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') {state.push([Rn[3], false]);}
				creator = ""; creatoridx = 0;
				textp = ""; textpidx = 0; textR = [];
				break;

			case 'creator': // 4.3.2.7 <dc:creator>
				if(Rn[1]==='/') { creator = str.slice(creatoridx,Rn.index); }
				else creatoridx = Rn.index + Rn[0].length;
				break;

			/* ignore state */
			case 'meta': case '元数据': // TODO: <office:meta> <uof:元数据> FODS/UOF
			case 'settings': // TODO: <office:settings>
			case 'config-item-set': // TODO: <office:config-item-set>
			case 'config-item-map-indexed': // TODO: <office:config-item-map-indexed>
			case 'config-item-map-entry': // TODO: <office:config-item-map-entry>
			case 'config-item-map-named': // TODO: <office:config-item-map-entry>
			case 'shapes': // 9.2.8 <table:shapes>
			case 'frame': // 10.4.2 <draw:frame>
			case 'text-box': // 10.4.3 <draw:text-box>
			case 'image': // 10.4.4 <draw:image>
			case 'data-pilot-tables': // 9.6.2 <table:data-pilot-tables>
			case 'list-style': // 16.30 <text:list-style>
			case 'form': // 13.13 <form:form>
			case 'dde-links': // 9.8 <table:dde-links>
			case 'event-listeners': // TODO
			case 'chart': // TODO
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], false]);
				textp = ""; textpidx = 0; textR = [];
				break;

			case 'scientific-number': // <number:scientific-number>
			case 'currency-symbol': // <number:currency-symbol>
			case 'fill-character': // 16.29.5 <number:fill-character>
				break;

			case 'text-style': // 16.27.25 <number:text-style>
			case 'boolean-style': // 16.27.23 <number:boolean-style>
			case 'number-style': // 16.27.2 <number:number-style>
			case 'currency-style': // 16.29.8 <number:currency-style>
			case 'percentage-style': // 16.27.9 <number:percentage-style>
			case 'date-style': // 16.27.10 <number:date-style>
			case 'time-style': // 16.27.18 <number:time-style>
				if(Rn[1]==='/'){
					var xlmlidx = xlmlregex.lastIndex;
					parse_ods_styles(str.slice(nfidx, xlmlregex.lastIndex), _opts, number_format_map);
					xlmlregex.lastIndex = xlmlidx;
				} else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
					nfidx = xlmlregex.lastIndex - Rn[0].length;
				} break;

			case 'script': break; // 3.13 <office:script>
			case 'libraries': break; // TODO: <ooo:libraries>
			case 'automatic-styles': break; // 3.15.3 <office:automatic-styles>

			case 'default-style': // TODO: <style:default-style>
			case 'page-layout': break; // TODO: <style:page-layout>
			case 'style': { // 16.2 <style:style>
				var styletag = parsexmltag(Rn[0], false);
				if(styletag["family"] == "table-cell" && number_format_map[styletag["data-style-name"]]) styles[styletag["name"]] = number_format_map[styletag["data-style-name"]];
			} break;
			case 'map': break; // 16.3 <style:map>
			case 'font-face': break; // 16.21 <style:font-face>

			case 'paragraph-properties': break; // 17.6 <style:paragraph-properties>
			case 'table-properties': break; // 17.15 <style:table-properties>
			case 'table-column-properties': break; // 17.16 <style:table-column-properties>
			case 'table-row-properties': break; // 17.17 <style:table-row-properties>
			case 'table-cell-properties': break; // 17.18 <style:table-cell-properties>

			case 'number': // 16.27.3 <number:number>
				break;

			case 'fraction': break; // TODO 16.27.6 <number:fraction>

			case 'day': // 16.27.11 <number:day>
			case 'month': // 16.27.12 <number:month>
			case 'year': // 16.27.13 <number:year>
			case 'era': // 16.27.14 <number:era>
			case 'day-of-week': // 16.27.15 <number:day-of-week>
			case 'week-of-year': // 16.27.16 <number:week-of-year>
			case 'quarter': // 16.27.17 <number:quarter>
			case 'hours': // 16.27.19 <number:hours>
			case 'minutes': // 16.27.20 <number:minutes>
			case 'seconds': // 16.27.21 <number:seconds>
			case 'am-pm': // 16.27.22 <number:am-pm>
				break;

			case 'boolean': break; // 16.27.24 <number:boolean>
			case 'text': // 16.27.26 <number:text>
				if(Rn[0].slice(-2) === "/>") break;
				else if(Rn[1]==="/") switch(state[state.length-1][0]) {
					case 'number-style':
					case 'date-style':
					case 'time-style':
						NF += str.slice(pidx, Rn.index);
						break;
				}
				else pidx = Rn.index + Rn[0].length;
				break;

			case 'named-range': // 9.4.12 <table:named-range>
				tag = parsexmltag(Rn[0], false);
				_Ref = ods_to_csf_3D(tag['cell-range-address']);
				var nrange = ({Name:tag.name, Ref:_Ref[0] + '!' + _Ref[1]});
				if(intable) nrange.Sheet = SheetNames.length;
				WB.Names.push(nrange);
				break;

			case 'text-content': break; // 16.27.27 <number:text-content>
			case 'text-properties': break; // 16.27.27 <style:text-properties>
			case 'embedded-text': break; // 16.27.4 <number:embedded-text>

			case 'body': case '电子表格': break; // 3.3 16.9.6 19.726.3

			case 'forms': break; // 12.25.2 13.2
			case 'table-column': break; // 9.1.6 <table:table-column>
			case 'table-header-rows': break; // 9.1.7 <table:table-header-rows>
			case 'table-rows': break; // 9.1.12 <table:table-rows>
			/* TODO: outline levels */
			case 'table-column-group': break; // 9.1.10 <table:table-column-group>
			case 'table-header-columns': break; // 9.1.11 <table:table-header-columns>
			case 'table-columns': break; // 9.1.12 <table:table-columns>

			case 'null-date': // 9.4.2 <table:null-date>
				tag = parsexmltag(Rn[0], false);
				switch(tag["date-value"]) {
					case "1904-01-01": WB.WBProps.date1904 = true;
					/* falls through */
					case "1900-01-01": baddate = 0;
				}
				break;

			case 'graphic-properties': break; // 17.21 <style:graphic-properties>
			case 'calculation-settings': break; // 9.4.1 <table:calculation-settings>
			case 'named-expressions': break; // 9.4.11 <table:named-expressions>
			case 'label-range': break; // 9.4.9 <table:label-range>
			case 'label-ranges': break; // 9.4.10 <table:label-ranges>
			case 'named-expression': break; // 9.4.13 <table:named-expression>
			case 'sort': break; // 9.4.19 <table:sort>
			case 'sort-by': break; // 9.4.20 <table:sort-by>
			case 'sort-groups': break; // 9.4.22 <table:sort-groups>

			case 'tab': break; // 6.1.4 <text:tab>
			case 'line-break': break; // 6.1.5 <text:line-break>
			case 'span': break; // 6.1.7 <text:span>
			case 'p': case '文本串': // 5.1.3 <text:p>
				if(['master-styles'].indexOf(state[state.length-1][0]) > -1) break;
				if(Rn[1]==='/' && (!ctag || !ctag['string-value'])) {
					var ptp = parse_text_p(str.slice(textpidx,Rn.index), textptag);
					textp = (textp.length > 0 ? textp + "\n" : "") + ptp[0];
				} else { textptag = parsexmltag(Rn[0], false); textpidx = Rn.index + Rn[0].length; }
				break; // <text:p>
			case 's': break; // <text:s>

			case 'database-range': // 9.4.15 <table:database-range>
				if(Rn[1]==='/') break;
				try {
					_Ref = ods_to_csf_3D(parsexmltag(Rn[0])['target-range-address']);
					Sheets[_Ref[0]]['!autofilter'] = { ref:_Ref[1] };
				} catch(e) {/* empty */}
				break;

			case 'date': break; // <*:date>

			case 'object': break; // 10.4.6.2 <draw:object>
			case 'title': case '标题': break; // <*:title> OR <uof:标题>
			case 'desc': break; // <*:desc>
			case 'binary-data': break; // 10.4.5 TODO: b64 blob

			/* 9.2 Advanced Tables */
			case 'table-source': break; // 9.2.6
			case 'scenario': break; // 9.2.6

			case 'iteration': break; // 9.4.3 <table:iteration>
			case 'content-validations': break; // 9.4.4 <table:
			case 'content-validation': break; // 9.4.5 <table:
			case 'help-message': break; // 9.4.6 <table:
			case 'error-message': break; // 9.4.7 <table:
			case 'database-ranges': break; // 9.4.14 <table:database-ranges>
			case 'filter': break; // 9.5.2 <table:filter>
			case 'filter-and': break; // 9.5.3 <table:filter-and>
			case 'filter-or': break; // 9.5.4 <table:filter-or>
			case 'filter-condition': break; // 9.5.5 <table:filter-condition>

			case 'list-level-style-bullet': break; // 16.31 <text:
			case 'list-level-style-number': break; // 16.32 <text:
			case 'list-level-properties': break; // 17.19 <style:

			/* 7.3 Document Fields */
			case 'sender-firstname': // 7.3.6.2
			case 'sender-lastname': // 7.3.6.3
			case 'sender-initials': // 7.3.6.4
			case 'sender-title': // 7.3.6.5
			case 'sender-position': // 7.3.6.6
			case 'sender-email': // 7.3.6.7
			case 'sender-phone-private': // 7.3.6.8
			case 'sender-fax': // 7.3.6.9
			case 'sender-company': // 7.3.6.10
			case 'sender-phone-work': // 7.3.6.11
			case 'sender-street': // 7.3.6.12
			case 'sender-city': // 7.3.6.13
			case 'sender-postal-code': // 7.3.6.14
			case 'sender-country': // 7.3.6.15
			case 'sender-state-or-province': // 7.3.6.16
			case 'author-name': // 7.3.7.1
			case 'author-initials': // 7.3.7.2
			case 'chapter': // 7.3.8
			case 'file-name': // 7.3.9
			case 'template-name': // 7.3.9
			case 'sheet-name': // 7.3.9
				break;

			case 'event-listener':
				break;
			/* TODO: FODS Properties */
			case 'initial-creator':
			case 'creation-date':
			case 'print-date':
			case 'generator':
			case 'document-statistic':
			case 'user-defined':
			case 'editing-duration':
			case 'editing-cycles':
				break;

			/* TODO: FODS Config */
			case 'config-item':
				break;

			/* TODO: style tokens */
			case 'page-number': break; // TODO <text:page-number>
			case 'page-count': break; // TODO <text:page-count>
			case 'time': break; // TODO <text:time>

			/* 9.3 Advanced Table Cells */
			case 'cell-range-source': break; // 9.3.1 <table:
			case 'detective': break; // 9.3.2 <table:
			case 'operation': break; // 9.3.3 <table:
			case 'highlighted-range': break; // 9.3.4 <table:

			/* 9.6 Data Pilot Tables <table: */
			case 'data-pilot-table': // 9.6.3
			case 'source-cell-range': // 9.6.5
			case 'source-service': // 9.6.6
			case 'data-pilot-field': // 9.6.7
			case 'data-pilot-level': // 9.6.8
			case 'data-pilot-subtotals': // 9.6.9
			case 'data-pilot-subtotal': // 9.6.10
			case 'data-pilot-members': // 9.6.11
			case 'data-pilot-member': // 9.6.12
			case 'data-pilot-display-info': // 9.6.13
			case 'data-pilot-sort-info': // 9.6.14
			case 'data-pilot-layout-info': // 9.6.15
			case 'data-pilot-field-reference': // 9.6.16
			case 'data-pilot-groups': // 9.6.17
			case 'data-pilot-group': // 9.6.18
			case 'data-pilot-group-member': // 9.6.19
				break;

			/* 10.3 Drawing Shapes */
			case 'rect': // 10.3.2
				break;

			/* 14.6 DDE Connections */
			case 'dde-connection-decls': // 14.6.2 <text:
			case 'dde-connection-decl': // 14.6.3 <text:
			case 'dde-link': // 14.6.4 <table:
			case 'dde-source': // 14.6.5 <office:
				break;

			case 'properties': break; // 13.7 <form:properties>
			case 'property': break; // 13.8 <form:property>

			case 'a': // 6.1.8 hyperlink
				if(Rn[1]!== '/') {
					atag = parsexmltag(Rn[0], false);
					if(!atag.href) break;
					atag.Target = unescapexml(atag.href); delete atag.href;
					if(atag.Target.charAt(0) == "#" && atag.Target.indexOf(".") > -1) {
						_Ref = ods_to_csf_3D(atag.Target.slice(1));
						atag.Target = "#" + _Ref[0] + "!" + _Ref[1];
					} else if(atag.Target.match(/^\.\.[\\\/]/)) atag.Target = atag.Target.slice(3);
				}
				break;

			/* non-standard */
			case 'table-protection': break;
			case 'data-pilot-grand-total': break; // <table:
			case 'office-document-common-attrs': break; // bare
			default: switch(Rn[2]) {
				case 'dc:':       // TODO: properties
				case 'calcext:':  // ignore undocumented extensions
				case 'loext:':    // ignore undocumented extensions
				case 'ooo:':      // ignore undocumented extensions
				case 'chartooo:': // ignore undocumented extensions
				case 'draw:':     // TODO: drawing
				case 'style:':    // TODO: styles
				case 'chart:':    // TODO: charts
				case 'form:':     // TODO: forms
				case 'uof:':      // TODO: uof
				case '表:':       // TODO: uof
				case '字:':       // TODO: uof
					break;
				default: if(opts.WTF) throw new Error(Rn);
			}
		}
		var out = ({
			Sheets: Sheets,
			SheetNames: SheetNames,
			Workbook: WB
		});
		if(opts.bookSheets) delete out.Sheets;
		return out;
}

function parse_ods(zip, opts) {
	opts = opts || ({});
	if(safegetzipfile(zip, 'META-INF/manifest.xml')) parse_manifest(getzipdata(zip, 'META-INF/manifest.xml'), opts);
	var styles = getzipstr(zip, 'styles.xml');
	var Styles = styles && parse_ods_styles(utf8read(styles), opts);
	var content = getzipstr(zip, 'content.xml');
	if(!content) throw new Error("Missing content.xml in ODS / UOF file");
	var wb = parse_content_xml(utf8read(content), opts, Styles);
	if(safegetzipfile(zip, 'meta.xml')) wb.Props = parse_core_props(getzipdata(zip, 'meta.xml'));
	wb.bookType = "ods";
	return wb;
}
function parse_fods(data, opts) {
	var wb = parse_content_xml(data, opts);
	wb.bookType = "fods";
	return wb;
}

/* OpenDocument */
var write_styles_ods = /* @__PURE__ */(function() {
	var master_styles = [
		'<office:master-styles>',
			'<style:master-page style:name="mp1" style:page-layout-name="mp1">',
				'<style:header/>',
				'<style:header-left style:display="false"/>',
				'<style:footer/>',
				'<style:footer-left style:display="false"/>',
			'</style:master-page>',
		'</office:master-styles>'
	].join("");

	var payload = '<office:document-styles ' + wxt_helper({
		'xmlns:office':   "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
		'xmlns:table':    "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
		'xmlns:style':    "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
		'xmlns:text':     "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
		'xmlns:draw':     "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
		'xmlns:fo':       "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
		'xmlns:xlink':    "http://www.w3.org/1999/xlink",
		'xmlns:dc':       "http://purl.org/dc/elements/1.1/",
		'xmlns:number':   "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
		'xmlns:svg':      "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
		'xmlns:of':       "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
		'office:version': "1.2"
	}) + '>' + master_styles + '</office:document-styles>';

	return function wso() {
		return XML_HEADER + payload;
	};
})();

// TODO: find out if anyone actually read the spec.  LO has some wild errors
function write_number_format_ods(nf, nfidx) {
	var type = "number", payload = "", nopts = { "style:name": nfidx }, c = "", i = 0;
	nf = nf.replace(/"[$]"/g, "$");
	/* TODO: replace with an actual parser based on a real grammar */
	j: {
		// TODO: support style maps
		if(nf.indexOf(";") > -1) {
			console.error("Unsupported ODS Style Map exported.  Using first branch of " + nf);
			nf = nf.slice(0, nf.indexOf(";"));
		}

		if(nf == "@") { type = "text"; payload = "<number:text-content/>"; break j; }

		/* currency flag */
		if(nf.indexOf(/\$/) > -1) { type = "currency"; }

		/* opening string literal */
		if(nf[i] == '"') {
			c = "";
			while(nf[++i] != '"' || nf[++i] == '"') c += nf[i]; --i;
			if(nf[i+1] == "*") {
				i++;
				payload += '<number:fill-character>' + escapexml(c.replace(/""/g, '"')) + '</number:fill-character>';
			} else {
				payload += '<number:text>' + escapexml(c.replace(/""/g, '"')) + '</number:text>';
			}
			nf = nf.slice(i+1); i = 0;
		}

		/* fractions */
		var t = nf.match(/# (\?+)\/(\?+)/);
		if(t) { payload += writextag("number:fraction", null, {"number:min-integer-digits":0, "number:min-numerator-digits": t[1].length, "number:max-denominator-value": Math.max(+(t[1].replace(/./g, "9")), +(t[2].replace(/./g, "9"))) }); break j; }
		if((t=nf.match(/# (\?+)\/(\d+)/))) { payload += writextag("number:fraction", null, {"number:min-integer-digits":0, "number:min-numerator-digits": t[1].length, "number:denominator-value": +t[2]}); break j; }

		/* percentages */
		if((t=nf.match(/(\d+)(|\.\d+)%/))) { type = "percentage"; payload += writextag("number:number", null, {"number:decimal-places": t[2] && t.length - 1 || 0, "number:min-decimal-places": t[2] && t.length - 1 || 0, "number:min-integer-digits": t[1].length }) + "<number:text>%</number:text>"; break j; }

		/* datetime */
		var has_time = false;
		if(["y","m","d"].indexOf(nf[0]) > -1) {
			type = "date";
			k: for(; i < nf.length; ++i) switch((c = nf[i].toLowerCase())) {
				case "h": case "s": has_time = true; --i; break k;
				case "m":
					l: for(var h = i+1; h < nf.length; ++h) switch(nf[h]) {
						case "y": case "d": break l;
						case "h": case "s": has_time = true; --i; break k;
					}
					/* falls through */
				case "y": case "d":
					while((nf[++i]||"").toLowerCase() == c[0]) c += c[0]; --i;
					switch(c) {
						case "y": case "yy": payload += "<number:year/>"; break;
						case "yyy": case "yyyy": payload += '<number:year number:style="long"/>'; break;
						case "mmmmm": console.error("ODS has no equivalent of format |mmmmm|");
							/* falls through */
						case "m": case "mm": case "mmm": case "mmmm":
							payload += '<number:month number:style="' + (c.length % 2 ? "short" : "long") + '" number:textual="' + (c.length >= 3 ? "true" : "false") + '"/>';
							break;
						case "d": case "dd": payload += '<number:day number:style="' + (c.length % 2 ? "short" : "long") + '"/>'; break;
						case "ddd": case "dddd": payload += '<number:day-of-week number:style="' + (c.length % 2 ? "short" : "long") + '"/>'; break;
					}
					break;
				case '"':
					while(nf[++i] != '"' || nf[++i] == '"') c += nf[i]; --i;
					payload += '<number:text>' + escapexml(c.slice(1).replace(/""/g, '"')) + '</number:text>';
					break;
				case '/': payload += '<number:text>' + escapexml(c) + '</number:text>'; break;
				default: console.error("unrecognized character " + c + " in ODF format " + nf);
			}
			if(!has_time) break j;
			nf = nf.slice(i+1); i = 0;
		}
		if(nf.match(/^\[?[hms]/)) {
			if(type == "number") type = "time";
			if(nf.match(/\[/)) {
				nf = nf.replace(/[\[\]]/g, "");
				nopts['number:truncate-on-overflow'] = "false";
			}
			for(; i < nf.length; ++i) switch((c = nf[i].toLowerCase())) {
				case "h": case "m": case "s":
					while((nf[++i]||"").toLowerCase() == c[0]) c += c[0]; --i;
					switch(c) {
						case "h": case "hh": payload += '<number:hours number:style="' + (c.length % 2 ? "short" : "long") + '"/>'; break;
						case "m": case "mm": payload += '<number:minutes number:style="' + (c.length % 2 ? "short" : "long") + '"/>'; break;
						case "s": case "ss":
							if(nf[i+1] == ".") do { c += nf[i+1]; ++i; } while(nf[i+1] == "0");
							payload += '<number:seconds number:style="' + (c.match("ss") ? "long" : "short") + '"' + (c.match(/\./) ? ' number:decimal-places="' + (c.match(/0+/)||[""])[0].length + '"' : "")+ '/>'; break;
					}
					break;
				case '"':
					while(nf[++i] != '"' || nf[++i] == '"') c += nf[i]; --i;
					payload += '<number:text>' + escapexml(c.slice(1).replace(/""/g, '"')) + '</number:text>';
					break;
				case '/': payload += '<number:text>' + escapexml(c) + '</number:text>'; break;
				case "a":
					if(nf.slice(i, i+3).toLowerCase() == "a/p") { payload += '<number:am-pm/>'; i += 2; break; } // Note: ODF does not support A/P
					if(nf.slice(i, i+5).toLowerCase() == "am/pm")  { payload += '<number:am-pm/>'; i += 4; break; }
					/* falls through */
				default: console.error("unrecognized character " + c + " in ODF format " + nf);
			}
			break j;
		}

		/* currency flag */
		if(nf.indexOf(/\$/) > -1) { type = "currency"; }

		/* should be in a char loop */
		if(nf[0] == "$") { payload += '<number:currency-symbol number:language="en" number:country="US">$</number:currency-symbol>'; nf = nf.slice(1); i = 0; }
		i = 0; if(nf[i] == '"') {
			while(nf[++i] != '"' || nf[++i] == '"') c += nf[i]; --i;
			if(nf[i+1] == "*") {
				i++;
				payload += '<number:fill-character>' + escapexml(c.replace(/""/g, '"')) + '</number:fill-character>';
			} else {
				payload += '<number:text>' + escapexml(c.replace(/""/g, '"')) + '</number:text>';
			}
			nf = nf.slice(i+1); i = 0;
		}

		/* number TODO: interstitial text e.g. 000)000-0000 */
		var np = nf.match(/([#0][0#,]*)(\.[0#]*|)(E[+]?0*|)/i);
		if(!np || !np[0]) console.error("Could not find numeric part of " + nf);
		else {
			var base = np[1].replace(/,/g, "");
			payload += '<number:' + (np[3] ? "scientific-" : "")+ 'number' +
				' number:min-integer-digits="' + (base.indexOf("0") == -1 ? "0" : base.length - base.indexOf("0")) + '"' +
				(np[0].indexOf(",") > -1 ? ' number:grouping="true"' : "") +
				(np[2] && ' number:decimal-places="' + (np[2].length - 1) + '"' || ' number:decimal-places="0"') +
				(np[3] && np[3].indexOf("+") > -1 ? ' number:forced-exponent-sign="true"' : "" ) +
				(np[3] ? ' number:min-exponent-digits="' + np[3].match(/0+/)[0].length + '"' : "" ) +
				'>' +
				/* TODO: interstitial text placeholders */
				'</number:' + (np[3] ? "scientific-" : "") + 'number>';
			i = np.index + np[0].length;
		}

		/* residual text */
		if(nf[i] == '"') {
			c = "";
			while(nf[++i] != '"' || nf[++i] == '"') c += nf[i]; --i;
			payload += '<number:text>' + escapexml(c.replace(/""/g, '"')) + '</number:text>';
		}
	}

	if(!payload) { console.error("Could not generate ODS number format for |" + nf + "|"); return ""; }
	return writextag("number:" + type + "-style", payload, nopts);
}

function write_names_ods(Names, SheetNames, idx) {
	var scoped = Names.filter(function(name) { return name.Sheet == (idx == -1 ? null : idx); });
	if(!scoped.length) return "";
	return "      <table:named-expressions>\n" + scoped.map(function(name) {
		var odsref =  csf_to_ods_3D(name.Ref);
		return "        " + writextag("table:named-range", null, {
			"table:name": name.Name,
			"table:cell-range-address": odsref,
			"table:base-cell-address": odsref.replace(/[\.]?[^\.]*$/, ".$A$1")
		});
	}).join("\n") + "\n      </table:named-expressions>\n";
}
var write_content_ods = /* @__PURE__ */(function() {
	/* 6.1.2 White Space Characters */
	var write_text_p = function(text) {
		return escapexml(text)
			.replace(/  +/g, function($$){return '<text:s text:c="'+$$.length+'"/>';})
			.replace(/\t/g, "<text:tab/>")
			.replace(/\n/g, "</text:p><text:p>")
			.replace(/^ /, "<text:s/>").replace(/ $/, "<text:s/>");
	};

	var null_cell_xml = '          <table:table-cell />\n';
	var covered_cell_xml = '          <table:covered-table-cell/>\n';
	var write_ws = function(ws, wb, i, opts, nfs) {
		/* Section 9 Tables */
		var o = [];
		o.push('      <table:table table:name="' + escapexml(wb.SheetNames[i]) + '" table:style-name="ta1">\n');
		var R=0,C=0, range = decode_range(ws['!ref']||"A1");
		var marr = ws['!merges'] || [], mi = 0;
		var dense = Array.isArray(ws);
		if(ws["!cols"]) {
			for(C = 0; C <= range.e.c; ++C) o.push('        <table:table-column' + (ws["!cols"][C] ? ' table:style-name="co' + ws["!cols"][C].ods + '"' : '') + '></table:table-column>\n');
		}
		var H = "", ROWS = ws["!rows"]||[];
		for(R = 0; R < range.s.r; ++R) {
			H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
			o.push('        <table:table-row' + H + '></table:table-row>\n');
		}
		for(; R <= range.e.r; ++R) {
			H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
			o.push('        <table:table-row' + H + '>\n');
			for(C=0; C < range.s.c; ++C) o.push(null_cell_xml);
			for(; C <= range.e.c; ++C) {
				var skip = false, ct = {}, textp = "";
				for(mi = 0; mi != marr.length; ++mi) {
					if(marr[mi].s.c > C) continue;
					if(marr[mi].s.r > R) continue;
					if(marr[mi].e.c < C) continue;
					if(marr[mi].e.r < R) continue;
					if(marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
					ct['table:number-columns-spanned'] = (marr[mi].e.c - marr[mi].s.c + 1);
					ct['table:number-rows-spanned'] =    (marr[mi].e.r - marr[mi].s.r + 1);
					break;
				}
				if(skip) { o.push(covered_cell_xml); continue; }
				var ref = encode_cell({r:R, c:C}), cell = dense ? (ws[R]||[])[C]: ws[ref];
				if(cell && cell.f) {
					ct['table:formula'] = escapexml(csf_to_ods_formula(cell.f));
					if(cell.F) {
						if(cell.F.slice(0, ref.length) == ref) {
							var _Fref = decode_range(cell.F);
							ct['table:number-matrix-columns-spanned'] = (_Fref.e.c - _Fref.s.c + 1);
							ct['table:number-matrix-rows-spanned'] =    (_Fref.e.r - _Fref.s.r + 1);
						}
					}
				}
				if(!cell) { o.push(null_cell_xml); continue; }
				switch(cell.t) {
					case 'b':
						textp = (cell.v ? 'TRUE' : 'FALSE');
						ct['office:value-type'] = "boolean";
						ct['office:boolean-value'] = (cell.v ? 'true' : 'false');
						break;
					case 'n':
						textp = (cell.w||String(cell.v||0));
						ct['office:value-type'] = "float";
						ct['office:value'] = (cell.v||0);
						break;
					case 's': case 'str':
						textp = cell.v == null ? "" : cell.v;
						ct['office:value-type'] = "string";
						break;
					case 'd':
						textp = (cell.w||(parseDate(cell.v).toISOString()));
						ct['office:value-type'] = "date";
						ct['office:date-value'] = (parseDate(cell.v).toISOString());
						ct['table:style-name'] = "ce1";
						break;
					//case 'e':
					default: o.push(null_cell_xml); continue;
				}
				var text_p = write_text_p(textp);
				if(cell.l && cell.l.Target) {
					var _tgt = cell.l.Target;
					_tgt = _tgt.charAt(0) == "#" ? "#" + csf_to_ods_3D(_tgt.slice(1)) : _tgt;
					// TODO: choose correct parent path format based on link delimiters
					if(_tgt.charAt(0) != "#" && !_tgt.match(/^\w+:/)) _tgt = '../' + _tgt;
					text_p = writextag('text:a', text_p, {'xlink:href': _tgt.replace(/&/g, "&amp;")});
				}
				if(nfs[cell.z]) ct["table:style-name"] = "ce" + nfs[cell.z].slice(1);
				o.push('          ' + writextag('table:table-cell', writextag('text:p', text_p, {}), ct) + '\n');
			}
			o.push('        </table:table-row>\n');
		}
		if((wb.Workbook||{}).Names) o.push(write_names_ods(wb.Workbook.Names, wb.SheetNames, i));
		o.push('      </table:table>\n');
		return o.join("");
	};

	var write_automatic_styles_ods = function(o, wb) {
		o.push(' <office:automatic-styles>\n');

		/* column styles */
		var cidx = 0;
		wb.SheetNames.map(function(n) { return wb.Sheets[n]; }).forEach(function(ws) {
			if(!ws) return;
			if(ws["!cols"]) {
				for(var C = 0; C < ws["!cols"].length; ++C) if(ws["!cols"][C]) {
					var colobj = ws["!cols"][C];
					if(colobj.width == null && colobj.wpx == null && colobj.wch == null) continue;
					process_col(colobj);
					colobj.ods = cidx;
					var w = ws["!cols"][C].wpx + "px";
					o.push('  <style:style style:name="co' + cidx + '" style:family="table-column">\n');
					o.push('   <style:table-column-properties fo:break-before="auto" style:column-width="' + w + '"/>\n');
					o.push('  </style:style>\n');
					++cidx;
				}
			}
		});

		/* row styles */
		var ridx = 0;
		wb.SheetNames.map(function(n) { return wb.Sheets[n]; }).forEach(function(ws) {
			if(!ws) return;
			if(ws["!rows"]) {
				for(var R = 0; R < ws["!rows"].length; ++R) if(ws["!rows"][R]) {
					ws["!rows"][R].ods = ridx;
					var h = ws["!rows"][R].hpx + "px";
					o.push('  <style:style style:name="ro' + ridx + '" style:family="table-row">\n');
					o.push('   <style:table-row-properties fo:break-before="auto" style:row-height="' + h + '"/>\n');
					o.push('  </style:style>\n');
					++ridx;
				}
			}
		});

		/* table */
		o.push('  <style:style style:name="ta1" style:family="table" style:master-page-name="mp1">\n');
		o.push('   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>\n');
		o.push('  </style:style>\n');

		o.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');
		o.push('   <number:month number:style="long"/>\n');
		o.push('   <number:text>/</number:text>\n');
		o.push('   <number:day number:style="long"/>\n');
		o.push('   <number:text>/</number:text>\n');
		o.push('   <number:year/>\n');
		o.push('  </number:date-style>\n');

		/* number formats, table cells, text */
		var nfs = {};
		var nfi = 69;
		wb.SheetNames.map(function(n) { return wb.Sheets[n]; }).forEach(function(ws) {
			if(!ws) return;
			var range = decode_range(ws["!ref"]);
			for(var R = 0; R <= range.e.r; ++R) for(var C = 0; C <= range.e.c; ++C) {
				var c = Array.isArray(ws) ? (ws[R]||[])[C] : ws[encode_cell({r:R,c:C})];
				if(!c || !c.z || c.z.toLowerCase() == "general") continue;
				if(!nfs[c.z]) {
					var out = write_number_format_ods(c.z, "N" + nfi);
					if(out) { nfs[c.z] = "N" + nfi; ++nfi; o.push(out + "\n"); }
				}
			}
		});
		o.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');
		keys(nfs).forEach(function(nf) {
			o.push('<style:style style:name="ce' + nfs[nf].slice(1) + '" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="' + nfs[nf] + '"/>\n');
		});

		/* page-layout */

		o.push(' </office:automatic-styles>\n');
		return nfs;
	};

	return function wcx(wb, opts) {
		var o = [XML_HEADER];
		/* 3.1.3.2 */
		var attr = wxt_helper({
			'xmlns:office':       "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
			'xmlns:table':        "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
			'xmlns:style':        "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
			'xmlns:text':         "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
			'xmlns:draw':         "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
			'xmlns:fo':           "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
			'xmlns:xlink':        "http://www.w3.org/1999/xlink",
			'xmlns:dc':           "http://purl.org/dc/elements/1.1/",
			'xmlns:meta':         "urn:oasis:names:tc:opendocument:xmlns:meta:1.0",
			'xmlns:number':       "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
			'xmlns:presentation': "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
			'xmlns:svg':          "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
			'xmlns:chart':        "urn:oasis:names:tc:opendocument:xmlns:chart:1.0",
			'xmlns:dr3d':         "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",
			'xmlns:math':         "http://www.w3.org/1998/Math/MathML",
			'xmlns:form':         "urn:oasis:names:tc:opendocument:xmlns:form:1.0",
			'xmlns:script':       "urn:oasis:names:tc:opendocument:xmlns:script:1.0",
			'xmlns:ooo':          "http://openoffice.org/2004/office",
			'xmlns:ooow':         "http://openoffice.org/2004/writer",
			'xmlns:oooc':         "http://openoffice.org/2004/calc",
			'xmlns:dom':          "http://www.w3.org/2001/xml-events",
			'xmlns:xforms':       "http://www.w3.org/2002/xforms",
			'xmlns:xsd':          "http://www.w3.org/2001/XMLSchema",
			'xmlns:xsi':          "http://www.w3.org/2001/XMLSchema-instance",
			'xmlns:sheet':        "urn:oasis:names:tc:opendocument:sh33tjs:1.0",
			'xmlns:rpt':          "http://openoffice.org/2005/report",
			'xmlns:of':           "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
			'xmlns:xhtml':        "http://www.w3.org/1999/xhtml",
			'xmlns:grddl':        "http://www.w3.org/2003/g/data-view#",
			'xmlns:tableooo':     "http://openoffice.org/2009/table",
			'xmlns:drawooo':      "http://openoffice.org/2010/draw",
			'xmlns:calcext':      "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",
			'xmlns:loext':        "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",
			'xmlns:field':        "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",
			'xmlns:formx':        "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",
			'xmlns:css3t':        "http://www.w3.org/TR/css3-text/",
			'office:version':     "1.2"
		});

		var fods = wxt_helper({
			'xmlns:config':    "urn:oasis:names:tc:opendocument:xmlns:config:1.0",
			'office:mimetype': "application/vnd.oasis.opendocument.spreadsheet"
		});

		if(opts.bookType == "fods") {
			o.push('<office:document' + attr + fods + '>\n');
			o.push(write_meta_ods().replace(/<office:document-meta.*?>/, "").replace(/<\/office:document-meta>/, "") + "\n");
			// TODO: settings (equiv of settings.xml for ODS)
		} else o.push('<office:document-content' + attr  + '>\n');
		// o.push('  <office:scripts/>\n');
		var nfs = write_automatic_styles_ods(o, wb);
		o.push('  <office:body>\n');
		o.push('    <office:spreadsheet>\n');
		if(((wb.Workbook||{}).WBProps||{}).date1904) o.push('      <table:calculation-settings table:case-sensitive="false" table:search-criteria-must-apply-to-whole-cell="true" table:use-wildcards="true" table:use-regular-expressions="false" table:automatic-find-labels="false">\n        <table:null-date table:date-value="1904-01-01"/>\n      </table:calculation-settings>\n');
		for(var i = 0; i != wb.SheetNames.length; ++i) o.push(write_ws(wb.Sheets[wb.SheetNames[i]], wb, i, opts, nfs));
		if((wb.Workbook||{}).Names) o.push(write_names_ods(wb.Workbook.Names, wb.SheetNames, -1));
		o.push('    </office:spreadsheet>\n');
		o.push('  </office:body>\n');
		if(opts.bookType == "fods") o.push('</office:document>');
		else o.push('</office:document-content>');
		return o.join("");
	};
})();

function write_ods(wb, opts) {
	if(opts.bookType == "fods") return write_content_ods(wb, opts);

	var zip = zip_new();
	var f = "";

	var manifest = [];
	var rdf = [];

	/* Part 3 Section 3.3 MIME Media Type */
	f = "mimetype";
	zip_add_file(zip, f, "application/vnd.oasis.opendocument.spreadsheet");

	/* Part 1 Section 2.2 Documents */
	f = "content.xml";
	zip_add_file(zip, f, write_content_ods(wb, opts));
	manifest.push([f, "text/xml"]);
	rdf.push([f, "ContentFile"]);

	/* TODO: these are hard-coded styles to satiate excel */
	f = "styles.xml";
	zip_add_file(zip, f, write_styles_ods(wb, opts));
	manifest.push([f, "text/xml"]);
	rdf.push([f, "StylesFile"]);

	/* TODO: this is hard-coded to satiate excel */
	f = "meta.xml";
	zip_add_file(zip, f, XML_HEADER + write_meta_ods());
	manifest.push([f, "text/xml"]);
	rdf.push([f, "MetadataFile"]);

	/* Part 3 Section 6 Metadata Manifest File */
	f = "manifest.rdf";
	zip_add_file(zip, f, write_rdf(rdf/*, opts*/));
	manifest.push([f, "application/rdf+xml"]);

	/* Part 3 Section 4 Manifest File */
	f = "META-INF/manifest.xml";
	zip_add_file(zip, f, write_manifest(manifest/*, opts*/));

	return zip;
}

/*! sheetjs (C) 2013-present SheetJS -- http://sheetjs.com */
var subarray = function() {
  try {
    if (typeof Uint8Array == "undefined")
      return "slice";
    if (typeof Uint8Array.prototype.subarray == "undefined")
      return "slice";
    if (typeof Buffer !== "undefined") {
      if (typeof Buffer.prototype.subarray == "undefined")
        return "slice";
      if ((typeof Buffer.from == "function" ? Buffer.from([72, 62]) : new Buffer([72, 62])) instanceof Uint8Array)
        return "subarray";
      return "slice";
    }
    return "subarray";
  } catch (e) {
    return "slice";
  }
}();
function u8_to_dataview(array) {
  return new DataView(array.buffer, array.byteOffset, array.byteLength);
}
function u8str(u8) {
  return typeof TextDecoder != "undefined" ? new TextDecoder().decode(u8) : utf8read(a2s(u8));
}
function stru8(str) {
  return typeof TextEncoder != "undefined" ? new TextEncoder().encode(str) : s2a(utf8write(str));
}
function u8contains(body, search) {
  var L = body.indexOf(search[0]);
  if (L == -1)
    return false;
  outer:
    for (; L <= body.length - search.length; ++L) {
      for (var j = 0; j < search.length; ++j)
        if (body[L + j] != search[j])
          continue outer;
      return true;
    }
  return false;
}
function u8concat(u8a) {
  var len = u8a.reduce(function(acc, x) {
    return acc + x.length;
  }, 0);
  var out = new Uint8Array(len);
  var off = 0;
  u8a.forEach(function(u8) {
    out.set(u8, off);
    off += u8.length;
  });
  return out;
}
function popcnt(x) {
  x -= x >> 1 & 1431655765;
  x = (x & 858993459) + (x >> 2 & 858993459);
  return (x + (x >> 4) & 252645135) * 16843009 >>> 24;
}
function readDecimal128LE(buf, offset) {
  var exp = (buf[offset + 15] & 127) << 7 | buf[offset + 14] >> 1;
  var mantissa = buf[offset + 14] & 1;
  for (var j = offset + 13; j >= offset; --j)
    mantissa = mantissa * 256 + buf[j];
  return (buf[offset + 15] & 128 ? -mantissa : mantissa) * Math.pow(10, exp - 6176);
}
function writeDecimal128LE(buf, offset, value) {
  var exp = Math.floor(value == 0 ? 0 : Math.LOG10E * Math.log(Math.abs(value))) + 6176 - 16;
  var mantissa = value / Math.pow(10, exp - 6176);
  buf[offset + 15] |= exp >> 7;
  buf[offset + 14] |= (exp & 127) << 1;
  for (var i = 0; mantissa >= 1; ++i, mantissa /= 256)
    buf[offset + i] = mantissa & 255;
  buf[offset + 15] |= value >= 0 ? 0 : 128;
}
function parse_varint49(buf, ptr) {
  var l = ptr ? ptr[0] : 0;
  var usz = buf[l] & 127;
  varint:
    if (buf[l++] >= 128) {
      usz |= (buf[l] & 127) << 7;
      if (buf[l++] < 128)
        break varint;
      usz |= (buf[l] & 127) << 14;
      if (buf[l++] < 128)
        break varint;
      usz |= (buf[l] & 127) << 21;
      if (buf[l++] < 128)
        break varint;
      usz += (buf[l] & 127) * Math.pow(2, 28);
      ++l;
      if (buf[l++] < 128)
        break varint;
      usz += (buf[l] & 127) * Math.pow(2, 35);
      ++l;
      if (buf[l++] < 128)
        break varint;
      usz += (buf[l] & 127) * Math.pow(2, 42);
      ++l;
      if (buf[l++] < 128)
        break varint;
    }
  if (ptr)
    ptr[0] = l;
  return usz;
}
function write_varint49(v) {
  var usz = new Uint8Array(7);
  usz[0] = v & 127;
  var L = 1;
  sz:
    if (v > 127) {
      usz[L - 1] |= 128;
      usz[L] = v >> 7 & 127;
      ++L;
      if (v <= 16383)
        break sz;
      usz[L - 1] |= 128;
      usz[L] = v >> 14 & 127;
      ++L;
      if (v <= 2097151)
        break sz;
      usz[L - 1] |= 128;
      usz[L] = v >> 21 & 127;
      ++L;
      if (v <= 268435455)
        break sz;
      usz[L - 1] |= 128;
      usz[L] = v / 256 >>> 21 & 127;
      ++L;
      if (v <= 34359738367)
        break sz;
      usz[L - 1] |= 128;
      usz[L] = v / 65536 >>> 21 & 127;
      ++L;
      if (v <= 4398046511103)
        break sz;
      usz[L - 1] |= 128;
      usz[L] = v / 16777216 >>> 21 & 127;
      ++L;
    }
  return usz[subarray](0, L);
}
function parse_packed_varints(buf) {
  var ptr = [0];
  var out = [];
  while (ptr[0] < buf.length)
    out.push(parse_varint49(buf, ptr));
  return out;
}
function write_packed_varints(nums) {
  return u8concat(nums.map(function(x) {
    return write_varint49(x);
  }));
}
function varint_to_i32(buf) {
  var l = 0, i32 = buf[l] & 127;
  varint:
    if (buf[l++] >= 128) {
      i32 |= (buf[l] & 127) << 7;
      if (buf[l++] < 128)
        break varint;
      i32 |= (buf[l] & 127) << 14;
      if (buf[l++] < 128)
        break varint;
      i32 |= (buf[l] & 127) << 21;
      if (buf[l++] < 128)
        break varint;
      i32 |= (buf[l] & 127) << 28;
    }
  return i32;
}
function varint_to_u64(buf) {
  var l = 0, lo = buf[l] & 127, hi = 0;
  varint:
    if (buf[l++] >= 128) {
      lo |= (buf[l] & 127) << 7;
      if (buf[l++] < 128)
        break varint;
      lo |= (buf[l] & 127) << 14;
      if (buf[l++] < 128)
        break varint;
      lo |= (buf[l] & 127) << 21;
      if (buf[l++] < 128)
        break varint;
      lo |= (buf[l] & 127) << 28;
      hi = buf[l] >> 4 & 7;
      if (buf[l++] < 128)
        break varint;
      hi |= (buf[l] & 127) << 3;
      if (buf[l++] < 128)
        break varint;
      hi |= (buf[l] & 127) << 10;
      if (buf[l++] < 128)
        break varint;
      hi |= (buf[l] & 127) << 17;
      if (buf[l++] < 128)
        break varint;
      hi |= (buf[l] & 127) << 24;
      if (buf[l++] < 128)
        break varint;
      hi |= (buf[l] & 127) << 31;
    }
  return [lo >>> 0, hi >>> 0];
}
function parse_shallow(buf) {
  var out = [], ptr = [0];
  while (ptr[0] < buf.length) {
    var off = ptr[0];
    var num = parse_varint49(buf, ptr);
    var type = num & 7;
    num = Math.floor(num / 8);
    var len = 0;
    var res;
    if (num == 0)
      break;
    switch (type) {
      case 0:
        {
          var l = ptr[0];
          while (buf[ptr[0]++] >= 128)
            ;
          res = buf[subarray](l, ptr[0]);
        }
        break;
      case 5:
        len = 4;
        res = buf[subarray](ptr[0], ptr[0] + len);
        ptr[0] += len;
        break;
      case 1:
        len = 8;
        res = buf[subarray](ptr[0], ptr[0] + len);
        ptr[0] += len;
        break;
      case 2:
        len = parse_varint49(buf, ptr);
        res = buf[subarray](ptr[0], ptr[0] + len);
        ptr[0] += len;
        break;
      case 3:
      case 4:
      default:
        throw new Error("PB Type ".concat(type, " for Field ").concat(num, " at offset ").concat(off));
    }
    var v = { data: res, type: type };
    if (out[num] == null)
      out[num] = [v];
    else
      out[num].push(v);
  }
  return out;
}
function write_shallow(proto) {
  var out = [];
  proto.forEach(function(field, idx) {
    if (idx == 0)
      return;
    field.forEach(function(item) {
      if (!item.data)
        return;
      out.push(write_varint49(idx * 8 + item.type));
      if (item.type == 2)
        out.push(write_varint49(item.data.length));
      out.push(item.data);
    });
  });
  return u8concat(out);
}
function mappa(data, cb) {
  return (data == null ? void 0 : data.map(function(d) {
    return cb(d.data);
  })) || [];
}
function parse_iwa_file(buf) {
  var _a;
  var out = [], ptr = [0];
  while (ptr[0] < buf.length) {
    var len = parse_varint49(buf, ptr);
    var ai = parse_shallow(buf[subarray](ptr[0], ptr[0] + len));
    ptr[0] += len;
    var res = {
      id: varint_to_i32(ai[1][0].data),
      messages: []
    };
    ai[2].forEach(function(b) {
      var mi = parse_shallow(b.data);
      var fl = varint_to_i32(mi[3][0].data);
      res.messages.push({
        meta: mi,
        data: buf[subarray](ptr[0], ptr[0] + fl)
      });
      ptr[0] += fl;
    });
    if ((_a = ai[3]) == null ? void 0 : _a[0])
      res.merge = varint_to_i32(ai[3][0].data) >>> 0 > 0;
    out.push(res);
  }
  return out;
}
function write_iwa_file(ias) {
  var bufs = [];
  ias.forEach(function(ia) {
    var ai = [
      [],
      [{ data: write_varint49(ia.id), type: 0 }],
      []
    ];
    if (ia.merge != null)
      ai[3] = [{ data: write_varint49(+!!ia.merge), type: 0 }];
    var midata = [];
    ia.messages.forEach(function(mi) {
      midata.push(mi.data);
      mi.meta[3] = [{ type: 0, data: write_varint49(mi.data.length) }];
      ai[2].push({ data: write_shallow(mi.meta), type: 2 });
    });
    var aipayload = write_shallow(ai);
    bufs.push(write_varint49(aipayload.length));
    bufs.push(aipayload);
    midata.forEach(function(mid) {
      return bufs.push(mid);
    });
  });
  return u8concat(bufs);
}
function parse_snappy_chunk(type, buf) {
  if (type != 0)
    throw new Error("Unexpected Snappy chunk type ".concat(type));
  var ptr = [0];
  var usz = parse_varint49(buf, ptr);
  var chunks = [];
  while (ptr[0] < buf.length) {
    var tag = buf[ptr[0]] & 3;
    if (tag == 0) {
      var len = buf[ptr[0]++] >> 2;
      if (len < 60)
        ++len;
      else {
        var c = len - 59;
        len = buf[ptr[0]];
        if (c > 1)
          len |= buf[ptr[0] + 1] << 8;
        if (c > 2)
          len |= buf[ptr[0] + 2] << 16;
        if (c > 3)
          len |= buf[ptr[0] + 3] << 24;
        len >>>= 0;
        len++;
        ptr[0] += c;
      }
      chunks.push(buf[subarray](ptr[0], ptr[0] + len));
      ptr[0] += len;
      continue;
    } else {
      var offset = 0, length = 0;
      if (tag == 1) {
        length = (buf[ptr[0]] >> 2 & 7) + 4;
        offset = (buf[ptr[0]++] & 224) << 3;
        offset |= buf[ptr[0]++];
      } else {
        length = (buf[ptr[0]++] >> 2) + 1;
        if (tag == 2) {
          offset = buf[ptr[0]] | buf[ptr[0] + 1] << 8;
          ptr[0] += 2;
        } else {
          offset = (buf[ptr[0]] | buf[ptr[0] + 1] << 8 | buf[ptr[0] + 2] << 16 | buf[ptr[0] + 3] << 24) >>> 0;
          ptr[0] += 4;
        }
      }
      if (offset == 0)
        throw new Error("Invalid offset 0");
      var j = chunks.length - 1, off = offset;
      while (j >= 0 && off >= chunks[j].length) {
        off -= chunks[j].length;
        --j;
      }
      if (j < 0) {
        if (off == 0)
          off = chunks[j = 0].length;
        else
          throw new Error("Invalid offset beyond length");
      }
      if (length < off)
        chunks.push(chunks[j][subarray](chunks[j].length - off, chunks[j].length - off + length));
      else {
        if (off > 0) {
          chunks.push(chunks[j][subarray](chunks[j].length - off));
          length -= off;
        }
        ++j;
        while (length >= chunks[j].length) {
          chunks.push(chunks[j]);
          length -= chunks[j].length;
          ++j;
        }
        if (length)
          chunks.push(chunks[j][subarray](0, length));
      }
      if (chunks.length > 100)
        chunks = [u8concat(chunks)];
    }
  }
  if (chunks.reduce(function(acc, u8) {
    return acc + u8.length;
  }, 0) != usz)
    throw new Error("Unexpected length: ".concat(chunks.reduce(function(acc, u8) {
      return acc + u8.length;
    }, 0), " != ").concat(usz));
  return chunks;
}
function decompress_iwa_file(buf) {
  if (Array.isArray(buf))
    buf = new Uint8Array(buf);
  var out = [];
  var l = 0;
  while (l < buf.length) {
    var t = buf[l++];
    var len = buf[l] | buf[l + 1] << 8 | buf[l + 2] << 16;
    l += 3;
    out.push.apply(out, parse_snappy_chunk(t, buf[subarray](l, l + len)));
    l += len;
  }
  if (l !== buf.length)
    throw new Error("data is not a valid framed stream!");
  return u8concat(out);
}
function compress_iwa_file(buf) {
  var out = [];
  var l = 0;
  while (l < buf.length) {
    var c = Math.min(buf.length - l, 268435455);
    var frame = new Uint8Array(4);
    out.push(frame);
    var usz = write_varint49(c);
    var L = usz.length;
    out.push(usz);
    if (c <= 60) {
      L++;
      out.push(new Uint8Array([c - 1 << 2]));
    } else if (c <= 256) {
      L += 2;
      out.push(new Uint8Array([240, c - 1 & 255]));
    } else if (c <= 65536) {
      L += 3;
      out.push(new Uint8Array([244, c - 1 & 255, c - 1 >> 8 & 255]));
    } else if (c <= 16777216) {
      L += 4;
      out.push(new Uint8Array([248, c - 1 & 255, c - 1 >> 8 & 255, c - 1 >> 16 & 255]));
    } else if (c <= 4294967296) {
      L += 5;
      out.push(new Uint8Array([252, c - 1 & 255, c - 1 >> 8 & 255, c - 1 >> 16 & 255, c - 1 >>> 24 & 255]));
    }
    out.push(buf[subarray](l, l + c));
    L += c;
    frame[0] = 0;
    frame[1] = L & 255;
    frame[2] = L >> 8 & 255;
    frame[3] = L >> 16 & 255;
    l += c;
  }
  return u8concat(out);
}
var numbers_lut_new = function() {
  return { sst: [], rsst: [], ofmt: [], nfmt: [] };
};
function numbers_format_cell(cell, t, flags, ofmt, nfmt) {
  var _a, _b, _c, _d;
  var ctype = t & 255, ver = t >> 8;
  var fmt = ver >= 5 ? nfmt : ofmt;
  dur:
    if (flags & (ver > 4 ? 8 : 4) && cell.t == "n" && ctype == 7) {
      var dstyle = ((_a = fmt[7]) == null ? void 0 : _a[0]) ? parse_varint49(fmt[7][0].data) : -1;
      if (dstyle == -1)
        break dur;
      var dmin = ((_b = fmt[15]) == null ? void 0 : _b[0]) ? parse_varint49(fmt[15][0].data) : -1;
      var dmax = ((_c = fmt[16]) == null ? void 0 : _c[0]) ? parse_varint49(fmt[16][0].data) : -1;
      var auto = ((_d = fmt[40]) == null ? void 0 : _d[0]) ? parse_varint49(fmt[40][0].data) : -1;
      var d = cell.v, dd = d;
      autodur:
        if (auto) {
          if (d == 0) {
            dmin = dmax = 2;
            break autodur;
          }
          if (d >= 604800)
            dmin = 1;
          else if (d >= 86400)
            dmin = 2;
          else if (d >= 3600)
            dmin = 4;
          else if (d >= 60)
            dmin = 8;
          else if (d >= 1)
            dmin = 16;
          else
            dmin = 32;
          if (Math.floor(d) != d)
            dmax = 32;
          else if (d % 60)
            dmax = 16;
          else if (d % 3600)
            dmax = 8;
          else if (d % 86400)
            dmax = 4;
          else if (d % 604800)
            dmax = 2;
          if (dmax < dmin)
            dmax = dmin;
        }
      if (dmin == -1 || dmax == -1)
        break dur;
      var dstr = [], zstr = [];
      if (dmin == 1) {
        dd = d / 604800;
        if (dmax == 1) {
          zstr.push('d"d"');
        } else {
          dd |= 0;
          d -= 604800 * dd;
        }
        dstr.push(dd + (dstyle == 2 ? " week" + (dd == 1 ? "" : "s") : dstyle == 1 ? "w" : ""));
      }
      if (dmin <= 2 && dmax >= 2) {
        dd = d / 86400;
        if (dmax > 2) {
          dd |= 0;
          d -= 86400 * dd;
        }
        zstr.push('d"d"');
        dstr.push(dd + (dstyle == 2 ? " day" + (dd == 1 ? "" : "s") : dstyle == 1 ? "d" : ""));
      }
      if (dmin <= 4 && dmax >= 4) {
        dd = d / 3600;
        if (dmax > 4) {
          dd |= 0;
          d -= 3600 * dd;
        }
        zstr.push((dmin >= 4 ? "[h]" : "h") + '"h"');
        dstr.push(dd + (dstyle == 2 ? " hour" + (dd == 1 ? "" : "s") : dstyle == 1 ? "h" : ""));
      }
      if (dmin <= 8 && dmax >= 8) {
        dd = d / 60;
        if (dmax > 8) {
          dd |= 0;
          d -= 60 * dd;
        }
        zstr.push((dmin >= 8 ? "[m]" : "m") + '"m"');
        if (dstyle == 0)
          dstr.push((dmin == 8 && dmax == 8 || dd >= 10 ? "" : "0") + dd);
        else
          dstr.push(dd + (dstyle == 2 ? " minute" + (dd == 1 ? "" : "s") : dstyle == 1 ? "m" : ""));
      }
      if (dmin <= 16 && dmax >= 16) {
        dd = d;
        if (dmax > 16) {
          dd |= 0;
          d -= dd;
        }
        zstr.push((dmin >= 16 ? "[s]" : "s") + '"s"');
        if (dstyle == 0)
          dstr.push((dmax == 16 && dmin == 16 || dd >= 10 ? "" : "0") + dd);
        else
          dstr.push(dd + (dstyle == 2 ? " second" + (dd == 1 ? "" : "s") : dstyle == 1 ? "s" : ""));
      }
      if (dmax >= 32) {
        dd = Math.round(1e3 * d);
        if (dmin < 32)
          zstr.push('.000"ms"');
        if (dstyle == 0)
          dstr.push((dd >= 100 ? "" : dd >= 10 ? "0" : "00") + dd);
        else
          dstr.push(dd + (dstyle == 2 ? " millisecond" + (dd == 1 ? "" : "s") : dstyle == 1 ? "ms" : ""));
      }
      cell.w = dstr.join(dstyle == 0 ? ":" : " ");
      cell.z = zstr.join(dstyle == 0 ? '":"' : " ");
      if (dstyle == 0)
        cell.w = cell.w.replace(/:(\d\d\d)$/, ".$1");
    }
}
function parse_old_storage(buf, lut, v) {
  var dv = u8_to_dataview(buf);
  var flags = dv.getUint32(4, true);
  var ridx = -1, sidx = -1, zidx = -1, ieee = NaN, dt = new Date(2001, 0, 1);
  var doff = v > 1 ? 12 : 8;
  if (flags & 2) {
    zidx = dv.getUint32(doff, true);
    doff += 4;
  }
  doff += popcnt(flags & (v > 1 ? 3468 : 396)) * 4;
  if (flags & 512) {
    ridx = dv.getUint32(doff, true);
    doff += 4;
  }
  doff += popcnt(flags & (v > 1 ? 12288 : 4096)) * 4;
  if (flags & 16) {
    sidx = dv.getUint32(doff, true);
    doff += 4;
  }
  if (flags & 32) {
    ieee = dv.getFloat64(doff, true);
    doff += 8;
  }
  if (flags & 64) {
    dt.setTime(dt.getTime() + dv.getFloat64(doff, true) * 1e3);
    doff += 8;
  }
  if (v > 1) {
    flags = dv.getUint32(8, true) >>> 16;
    if (flags & 255) {
      if (zidx == -1)
        zidx = dv.getUint32(doff, true);
      doff += 4;
    }
  }
  var ret;
  var t = buf[v >= 4 ? 1 : 2];
  switch (t) {
    case 0:
      return void 0;
    case 2:
      ret = { t: "n", v: ieee };
      break;
    case 3:
      ret = { t: "s", v: lut.sst[sidx] };
      break;
    case 5:
      ret = { t: "d", v: dt };
      break;
    case 6:
      ret = { t: "b", v: ieee > 0 };
      break;
    case 7:
      ret = { t: "n", v: ieee };
      break;
    case 8:
      ret = { t: "e", v: 0 };
      break;
    case 9:
      {
        if (ridx > -1)
          ret = { t: "s", v: lut.rsst[ridx] };
        else
          throw new Error("Unsupported cell type ".concat(buf[subarray](0, 4)));
      }
      break;
    default:
      throw new Error("Unsupported cell type ".concat(buf[subarray](0, 4)));
  }
  if (zidx > -1)
    numbers_format_cell(ret, t | v << 8, flags, lut.ofmt[zidx], lut.nfmt[zidx]);
  if (t == 7)
    ret.v /= 86400;
  return ret;
}
function parse_new_storage(buf, lut) {
  var dv = u8_to_dataview(buf);
  var flags = dv.getUint32(4, true);
  var fields = dv.getUint32(8, true);
  var doff = 12;
  var ridx = -1, sidx = -1, zidx = -1, d128 = NaN, ieee = NaN, dt = new Date(2001, 0, 1);
  if (fields & 1) {
    d128 = readDecimal128LE(buf, doff);
    doff += 16;
  }
  if (fields & 2) {
    ieee = dv.getFloat64(doff, true);
    doff += 8;
  }
  if (fields & 4) {
    dt.setTime(dt.getTime() + dv.getFloat64(doff, true) * 1e3);
    doff += 8;
  }
  if (fields & 8) {
    sidx = dv.getUint32(doff, true);
    doff += 4;
  }
  if (fields & 16) {
    ridx = dv.getUint32(doff, true);
    doff += 4;
  }
  var ret;
  var t = buf[1];
  switch (t) {
    case 0:
      return void 0;
    case 2:
      ret = { t: "n", v: d128 };
      break;
    case 3:
      ret = { t: "s", v: lut.sst[sidx] };
      break;
    case 5:
      ret = { t: "d", v: dt };
      break;
    case 6:
      ret = { t: "b", v: ieee > 0 };
      break;
    case 7:
      ret = { t: "n", v: ieee };
      break;
    case 8:
      ret = { t: "e", v: 0 };
      break;
    case 9:
      ret = { t: "s", v: lut.rsst[ridx] };
      break;
    case 10:
      ret = { t: "n", v: d128 };
      break;
    default:
      throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(fields & 31, " : ").concat(buf[subarray](0, 4)));
  }
  doff += popcnt(fields & 8160) * 4;
  if (fields & 516096) {
    if (zidx == -1)
      zidx = dv.getUint32(doff, true);
    doff += 4;
  }
  if (zidx > -1)
    numbers_format_cell(ret, t | 5 << 8, fields >> 13, lut.ofmt[zidx], lut.nfmt[zidx]);
  if (t == 7)
    ret.v /= 86400;
  return ret;
}
function write_new_storage(cell, sst) {
  var out = new Uint8Array(32), dv = u8_to_dataview(out), l = 12, flags = 0;
  out[0] = 5;
  switch (cell.t) {
    case "n":
      out[1] = 2;
      writeDecimal128LE(out, l, cell.v);
      flags |= 1;
      l += 16;
      break;
    case "b":
      out[1] = 6;
      dv.setFloat64(l, cell.v ? 1 : 0, true);
      flags |= 2;
      l += 8;
      break;
    case "s":
      var s = cell.v == null ? "" : String(cell.v);
      var isst = sst.indexOf(s);
      if (isst == -1)
        sst[isst = sst.length] = s;
      out[1] = 3;
      dv.setUint32(l, isst, true);
      flags |= 8;
      l += 4;
      break;
    default:
      throw "unsupported cell type " + cell.t;
  }
  dv.setUint32(8, flags, true);
  return out[subarray](0, l);
}
function write_old_storage(cell, sst) {
  var out = new Uint8Array(32), dv = u8_to_dataview(out), l = 12, flags = 0;
  out[0] = 4;
  switch (cell.t) {
    case "n":
      out[2] = 2;
      dv.setFloat64(l, cell.v, true);
      flags |= 32;
      l += 8;
      break;
    case "b":
      out[2] = 6;
      dv.setFloat64(l, cell.v ? 1 : 0, true);
      flags |= 32;
      l += 8;
      break;
    case "s":
      var s = cell.v == null ? "" : String(cell.v);
      var isst = sst.indexOf(s);
      if (isst == -1)
        sst[isst = sst.length] = s;
      out[2] = 3;
      dv.setUint32(l, isst, true);
      flags |= 16;
      l += 4;
      break;
    default:
      throw "unsupported cell type " + cell.t;
  }
  dv.setUint32(8, flags, true);
  return out[subarray](0, l);
}
function parse_cell_storage(buf, lut) {
  switch (buf[0]) {
    case 0:
    case 1:
    case 2:
    case 3:
    case 4:
      return parse_old_storage(buf, lut, buf[0]);
    case 5:
      return parse_new_storage(buf, lut);
    default:
      throw new Error("Unsupported payload version ".concat(buf[0]));
  }
}
function parse_TSP_Reference(buf) {
  var pb = parse_shallow(buf);
  return parse_varint49(pb[1][0].data);
}
function write_TSP_Reference(idx) {
  return write_shallow([
    [],
    [{ type: 0, data: write_varint49(idx) }]
  ]);
}
function numbers_add_oref(iwa, ref) {
  var _a;
  var orefs = ((_a = iwa.messages[0].meta[5]) == null ? void 0 : _a[0]) ? parse_packed_varints(iwa.messages[0].meta[5][0].data) : [];
  var orefidx = orefs.indexOf(ref);
  if (orefidx == -1) {
    orefs.push(ref);
    iwa.messages[0].meta[5] = [{ type: 2, data: write_packed_varints(orefs) }];
  }
}
function numbers_del_oref(iwa, ref) {
  var _a;
  var orefs = ((_a = iwa.messages[0].meta[5]) == null ? void 0 : _a[0]) ? parse_packed_varints(iwa.messages[0].meta[5][0].data) : [];
  iwa.messages[0].meta[5] = [{ type: 2, data: write_packed_varints(orefs.filter(function(r) {
    return r != ref;
  })) }];
}
function parse_TST_TableDataList(M, root) {
  var pb = parse_shallow(root.data);
  var type = varint_to_i32(pb[1][0].data);
  var entries = pb[3];
  var data = [];
  (entries || []).forEach(function(entry) {
    var le = parse_shallow(entry.data);
    if (!le[1])
      return;
    var key = varint_to_i32(le[1][0].data) >>> 0;
    switch (type) {
      case 1:
        data[key] = u8str(le[3][0].data);
        break;
      case 8:
        {
          var rt = M[parse_TSP_Reference(le[9][0].data)][0];
          var rtp = parse_shallow(rt.data);
          var rtpref = M[parse_TSP_Reference(rtp[1][0].data)][0];
          var mtype = varint_to_i32(rtpref.meta[1][0].data);
          if (mtype != 2001)
            throw new Error("2000 unexpected reference to ".concat(mtype));
          var tswpsa = parse_shallow(rtpref.data);
          data[key] = tswpsa[3].map(function(x) {
            return u8str(x.data);
          }).join("");
        }
        break;
      case 2:
        data[key] = parse_shallow(le[6][0].data);
        break;
      default:
        throw type;
    }
  });
  return data;
}
function parse_TST_TileRowInfo(u8, type) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
  var pb = parse_shallow(u8);
  var R = varint_to_i32(pb[1][0].data) >>> 0;
  var cnt = varint_to_i32(pb[2][0].data) >>> 0;
  var wide_offsets = ((_b = (_a = pb[8]) == null ? void 0 : _a[0]) == null ? void 0 : _b.data) && varint_to_i32(pb[8][0].data) > 0 || false;
  var used_storage_u8, used_storage;
  if (((_d = (_c = pb[7]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) && type != 0) {
    used_storage_u8 = (_f = (_e = pb[7]) == null ? void 0 : _e[0]) == null ? void 0 : _f.data;
    used_storage = (_h = (_g = pb[6]) == null ? void 0 : _g[0]) == null ? void 0 : _h.data;
  } else if (((_j = (_i = pb[4]) == null ? void 0 : _i[0]) == null ? void 0 : _j.data) && type != 1) {
    used_storage_u8 = (_l = (_k = pb[4]) == null ? void 0 : _k[0]) == null ? void 0 : _l.data;
    used_storage = (_n = (_m = pb[3]) == null ? void 0 : _m[0]) == null ? void 0 : _n.data;
  } else
    throw "NUMBERS Tile missing ".concat(type, " cell storage");
  var width = wide_offsets ? 4 : 1;
  var used_storage_offsets = u8_to_dataview(used_storage_u8);
  var offsets = [];
  for (var C = 0; C < used_storage_u8.length / 2; ++C) {
    var off = used_storage_offsets.getUint16(C * 2, true);
    if (off < 65535)
      offsets.push([C, off]);
  }
  if (offsets.length != cnt)
    throw "Expected ".concat(cnt, " cells, found ").concat(offsets.length);
  var cells = [];
  for (C = 0; C < offsets.length - 1; ++C)
    cells[offsets[C][0]] = used_storage[subarray](offsets[C][1] * width, offsets[C + 1][1] * width);
  if (offsets.length >= 1)
    cells[offsets[offsets.length - 1][0]] = used_storage[subarray](offsets[offsets.length - 1][1] * width);
  return { R: R, cells: cells };
}
function parse_TST_Tile(M, root) {
  var _a;
  var pb = parse_shallow(root.data);
  var storage = -1;
  if ((_a = pb == null ? void 0 : pb[7]) == null ? void 0 : _a[0]) {
    if (varint_to_i32(pb[7][0].data) >>> 0)
      storage = 1;
    else
      storage = 0;
  }
  var ri = mappa(pb[5], function(u8) {
    return parse_TST_TileRowInfo(u8, storage);
  });
  return {
    nrows: varint_to_i32(pb[4][0].data) >>> 0,
    data: ri.reduce(function(acc, x) {
      if (!acc[x.R])
        acc[x.R] = [];
      x.cells.forEach(function(cell, C) {
        if (acc[x.R][C])
          throw new Error("Duplicate cell r=".concat(x.R, " c=").concat(C));
        acc[x.R][C] = cell;
      });
      return acc;
    }, [])
  };
}
function parse_TST_TableModelArchive(M, root, ws) {
  var _a, _b, _c, _d, _e, _f;
  var pb = parse_shallow(root.data);
  var range = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } };
  range.e.r = (varint_to_i32(pb[6][0].data) >>> 0) - 1;
  if (range.e.r < 0)
    throw new Error("Invalid row varint ".concat(pb[6][0].data));
  range.e.c = (varint_to_i32(pb[7][0].data) >>> 0) - 1;
  if (range.e.c < 0)
    throw new Error("Invalid col varint ".concat(pb[7][0].data));
  ws["!ref"] = encode_range(range);
  var dense = Array.isArray(ws);
  var store = parse_shallow(pb[4][0].data);
  var lut = numbers_lut_new();
  if ((_a = store[4]) == null ? void 0 : _a[0])
    lut.sst = parse_TST_TableDataList(M, M[parse_TSP_Reference(store[4][0].data)][0]);
  if ((_b = store[11]) == null ? void 0 : _b[0])
    lut.ofmt = parse_TST_TableDataList(M, M[parse_TSP_Reference(store[11][0].data)][0]);
  if ((_c = store[17]) == null ? void 0 : _c[0])
    lut.rsst = parse_TST_TableDataList(M, M[parse_TSP_Reference(store[17][0].data)][0]);
  if ((_d = store[22]) == null ? void 0 : _d[0])
    lut.nfmt = parse_TST_TableDataList(M, M[parse_TSP_Reference(store[22][0].data)][0]);
  var tile = parse_shallow(store[3][0].data);
  var _R = 0;
  tile[1].forEach(function(t) {
    var tl = parse_shallow(t.data);
    var ref2 = M[parse_TSP_Reference(tl[2][0].data)][0];
    var mtype2 = varint_to_i32(ref2.meta[1][0].data);
    if (mtype2 != 6002)
      throw new Error("6001 unexpected reference to ".concat(mtype2));
    var _tile = parse_TST_Tile(M, ref2);
    _tile.data.forEach(function(row, R) {
      row.forEach(function(buf, C) {
        var res = parse_cell_storage(buf, lut);
        if (res) {
          if (dense) {
            if (!ws[_R + R])
              ws[_R + R] = [];
            ws[_R + R][C] = res;
          } else {
            var addr = encode_cell({ r: _R + R, c: C });
            ws[addr] = res;
          }
        }
      });
    });
    _R += _tile.nrows;
  });
  if ((_e = store[13]) == null ? void 0 : _e[0]) {
    var ref = M[parse_TSP_Reference(store[13][0].data)][0];
    var mtype = varint_to_i32(ref.meta[1][0].data);
    if (mtype != 6144)
      throw new Error("Expected merge type 6144, found ".concat(mtype));
    ws["!merges"] = (_f = parse_shallow(ref.data)) == null ? void 0 : _f[1].map(function(pi) {
      var merge = parse_shallow(pi.data);
      var origin = u8_to_dataview(parse_shallow(merge[1][0].data)[1][0].data), size = u8_to_dataview(parse_shallow(merge[2][0].data)[1][0].data);
      return {
        s: { r: origin.getUint16(0, true), c: origin.getUint16(2, true) },
        e: {
          r: origin.getUint16(0, true) + size.getUint16(0, true) - 1,
          c: origin.getUint16(2, true) + size.getUint16(2, true) - 1
        }
      };
    });
  }
}
function parse_TST_TableInfoArchive(M, root, opts) {
  var pb = parse_shallow(root.data);
  var out;
  if (!(opts == null ? void 0 : opts.dense))
    out = { "!ref": "A1" };
  else
    out = [];
  out["!ref"] = "A1";
  var tableref = M[parse_TSP_Reference(pb[2][0].data)];
  var mtype = varint_to_i32(tableref[0].meta[1][0].data);
  if (mtype != 6001)
    throw new Error("6000 unexpected reference to ".concat(mtype));
  parse_TST_TableModelArchive(M, tableref[0], out);
  return out;
}
function parse_TN_SheetArchive(M, root, opts) {
  var _a;
  var pb = parse_shallow(root.data);
  var out = {
    name: ((_a = pb[1]) == null ? void 0 : _a[0]) ? u8str(pb[1][0].data) : "",
    sheets: []
  };
  var shapeoffs = mappa(pb[2], parse_TSP_Reference);
  shapeoffs.forEach(function(off) {
    M[off].forEach(function(m) {
      var mtype = varint_to_i32(m.meta[1][0].data);
      if (mtype == 6e3)
        out.sheets.push(parse_TST_TableInfoArchive(M, m, opts));
    });
  });
  return out;
}
function parse_TN_DocumentArchive(M, root, opts) {
  var _a;
  var out = book_new();
  var pb = parse_shallow(root.data);
  if ((_a = pb[2]) == null ? void 0 : _a[0])
    throw new Error("Keynote presentations are not supported");
  var sheetoffs = mappa(pb[1], parse_TSP_Reference);
  sheetoffs.forEach(function(off) {
    M[off].forEach(function(m) {
      var mtype = varint_to_i32(m.meta[1][0].data);
      if (mtype == 2) {
        var root2 = parse_TN_SheetArchive(M, m, opts);
        root2.sheets.forEach(function(sheet, idx) {
          book_append_sheet(out, sheet, idx == 0 ? root2.name : root2.name + "_" + idx, true);
        });
      }
    });
  });
  if (out.SheetNames.length == 0)
    throw new Error("Empty NUMBERS file");
  out.bookType = "numbers";
  return out;
}
function parse_numbers_iwa(cfb, opts) {
  var _a, _b, _c, _d, _e, _f, _g;
  var M = {}, indices = [];
  cfb.FullPaths.forEach(function(p) {
    if (p.match(/\.iwpv2/))
      throw new Error("Unsupported password protection");
  });
  cfb.FileIndex.forEach(function(s) {
    if (!s.name.match(/\.iwa$/))
      return;
    if (s.content[0] == 98)
      return;
    var o;
    try {
      o = decompress_iwa_file(s.content);
    } catch (e) {
      return console.log("?? " + s.content.length + " " + (e.message || e));
    }
    var packets;
    try {
      packets = parse_iwa_file(o);
    } catch (e) {
      return console.log("## " + (e.message || e));
    }
    packets.forEach(function(packet) {
      M[packet.id] = packet.messages;
      indices.push(packet.id);
    });
  });
  if (!indices.length)
    throw new Error("File has no messages");
  if (((_c = (_b = (_a = M == null ? void 0 : M[1]) == null ? void 0 : _a[0].meta) == null ? void 0 : _b[1]) == null ? void 0 : _c[0].data) && varint_to_i32(M[1][0].meta[1][0].data) == 1e4)
    throw new Error("Pages documents are not supported");
  var docroot = ((_g = (_f = (_e = (_d = M == null ? void 0 : M[1]) == null ? void 0 : _d[0]) == null ? void 0 : _e.meta) == null ? void 0 : _f[1]) == null ? void 0 : _g[0].data) && varint_to_i32(M[1][0].meta[1][0].data) == 1 && M[1][0];
  if (!docroot)
    indices.forEach(function(idx) {
      M[idx].forEach(function(iwam) {
        var mtype = varint_to_i32(iwam.meta[1][0].data) >>> 0;
        if (mtype == 1) {
          if (!docroot)
            docroot = iwam;
          else
            throw new Error("Document has multiple roots");
        }
      });
    });
  if (!docroot)
    throw new Error("Cannot find Document root");
  return parse_TN_DocumentArchive(M, docroot, opts);
}
function write_TST_TileRowInfo(data, SST, wide) {
  var _a, _b;
  var tri = [
    [],
    [{ type: 0, data: write_varint49(0) }],
    [{ type: 0, data: write_varint49(0) }],
    [{ type: 2, data: new Uint8Array([]) }],
    [{ type: 2, data: new Uint8Array(Array.from({ length: 510 }, function() {
      return 255;
    })) }],
    [{ type: 0, data: write_varint49(5) }],
    [{ type: 2, data: new Uint8Array([]) }],
    [{ type: 2, data: new Uint8Array(Array.from({ length: 510 }, function() {
      return 255;
    })) }],
    [{ type: 0, data: write_varint49(1) }]
  ];
  if (!((_a = tri[6]) == null ? void 0 : _a[0]) || !((_b = tri[7]) == null ? void 0 : _b[0]))
    throw "Mutation only works on post-BNC storages!";
  var cnt = 0;
  if (tri[7][0].data.length < 2 * data.length) {
    var new_7 = new Uint8Array(2 * data.length);
    new_7.set(tri[7][0].data);
    tri[7][0].data = new_7;
  }
  if (tri[4][0].data.length < 2 * data.length) {
    var new_4 = new Uint8Array(2 * data.length);
    new_4.set(tri[4][0].data);
    tri[4][0].data = new_4;
  }
  var dv = u8_to_dataview(tri[7][0].data), last_offset = 0, cell_storage = [];
  var _dv = u8_to_dataview(tri[4][0].data), _last_offset = 0, _cell_storage = [];
  var width = wide ? 4 : 1;
  for (var C = 0; C < data.length; ++C) {
    if (data[C] == null) {
      dv.setUint16(C * 2, 65535, true);
      _dv.setUint16(C * 2, 65535);
      continue;
    }
    dv.setUint16(C * 2, last_offset / width, true);
    _dv.setUint16(C * 2, _last_offset / width, true);
    var celload, _celload;
    switch (typeof data[C]) {
      case "string":
        celload = write_new_storage({ t: "s", v: data[C] }, SST);
        _celload = write_old_storage({ t: "s", v: data[C] }, SST);
        break;
      case "number":
        celload = write_new_storage({ t: "n", v: data[C] }, SST);
        _celload = write_old_storage({ t: "n", v: data[C] }, SST);
        break;
      case "boolean":
        celload = write_new_storage({ t: "b", v: data[C] }, SST);
        _celload = write_old_storage({ t: "b", v: data[C] }, SST);
        break;
      default:
        if (data[C] instanceof Date) {
          celload = write_new_storage({ t: "s", v: data[C].toISOString() }, SST);
          _celload = write_old_storage({ t: "s", v: data[C].toISOString() }, SST);
          break;
        }
        throw new Error("Unsupported value " + data[C]);
    }
    cell_storage.push(celload);
    last_offset += celload.length;
    {
      _cell_storage.push(_celload);
      _last_offset += _celload.length;
    }
    ++cnt;
  }
  tri[2][0].data = write_varint49(cnt);
  tri[5][0].data = write_varint49(5);
  for (; C < tri[7][0].data.length / 2; ++C) {
    dv.setUint16(C * 2, 65535, true);
    _dv.setUint16(C * 2, 65535, true);
  }
  tri[6][0].data = u8concat(cell_storage);
  tri[3][0].data = u8concat(_cell_storage);
  tri[8] = [{ type: 0, data: write_varint49(wide ? 1 : 0) }];
  return tri;
}
function write_iwam(type, payload) {
  return {
    meta: [
      [],
      [{ type: 0, data: write_varint49(type) }]
    ],
    data: payload
  };
}
function get_unique_msgid(dep, dependents) {
  if (!dependents.last)
    dependents.last = 927262;
  for (var i = dependents.last; i < 2e6; ++i)
    if (!dependents[i]) {
      dependents[dependents.last = i] = dep;
      return i;
    }
  throw new Error("Too many messages");
}
function build_numbers_deps(cfb) {
  var dependents = {};
  var indices = [];
  cfb.FileIndex.map(function(fi, idx) {
    return [fi, cfb.FullPaths[idx]];
  }).forEach(function(row) {
    var fi = row[0], fp = row[1];
    if (fi.type != 2)
      return;
    if (!fi.name.match(/\.iwa/))
      return;
    if (fi.name.match(/OperationStorage/))
      return;
    parse_iwa_file(decompress_iwa_file(fi.content)).forEach(function(packet) {
      indices.push(packet.id);
      dependents[packet.id] = { deps: [], location: fp, type: varint_to_i32(packet.messages[0].meta[1][0].data) };
    });
  });
  indices.sort(function(x, y) {
    return x - y;
  });
  var indices_varint = indices.filter(function(x) {
    return x > 1;
  }).map(function(x) {
    return [x, write_varint49(x)];
  });
  cfb.FileIndex.forEach(function(fi) {
    if (!fi.name.match(/\.iwa/))
      return;
    if (fi.name.match(/OperationStorage/))
      return;
    parse_iwa_file(decompress_iwa_file(fi.content)).forEach(function(ia) {
      indices_varint.forEach(function(ivi) {
        if (ia.messages.some(function(mess) {
          return varint_to_i32(mess.meta[1][0].data) != 11006 && u8contains(mess.data, ivi[1]);
        })) {
          dependents[ivi[0]].deps.push(ia.id);
        }
      });
    });
  });
  return dependents;
}
function write_numbers_iwa(wb, opts) {
  if (!opts || !opts.numbers)
    throw new Error("Must pass a `numbers` option -- check the README");
  var cfb = CFB.read(opts.numbers, { type: "base64" });
  var deps = build_numbers_deps(cfb);
  var docroot = numbers_iwa_find(cfb, deps, 1);
  if (docroot == null)
    throw "Could not find message ".concat(1, " in Numbers template");
  var sheetrefs = mappa(parse_shallow(docroot.messages[0].data)[1], parse_TSP_Reference);
  if (sheetrefs.length > 1)
    throw new Error("Template NUMBERS file must have exactly one sheet");
  wb.SheetNames.forEach(function(name, idx) {
    if (idx >= 1) {
      numbers_add_ws(cfb, deps, idx + 1);
      docroot = numbers_iwa_find(cfb, deps, 1);
      sheetrefs = mappa(parse_shallow(docroot.messages[0].data)[1], parse_TSP_Reference);
    }
    write_numbers_ws(cfb, deps, wb.Sheets[name], name, idx, sheetrefs[idx]);
  });
  return cfb;
}
function numbers_iwa_doit(cfb, deps, id, cb) {
  var entry = CFB.find(cfb, deps[id].location);
  if (!entry)
    throw "Could not find ".concat(deps[id].location, " in Numbers template");
  var x = parse_iwa_file(decompress_iwa_file(entry.content));
  var ainfo = x.find(function(packet) {
    return packet.id == id;
  });
  cb(ainfo, x);
  entry.content = compress_iwa_file(write_iwa_file(x));
  entry.size = entry.content.length;
}
function numbers_iwa_find(cfb, deps, id) {
  var entry = CFB.find(cfb, deps[id].location);
  if (!entry)
    throw "Could not find ".concat(deps[id].location, " in Numbers template");
  var x = parse_iwa_file(decompress_iwa_file(entry.content));
  var ainfo = x.find(function(packet) {
    return packet.id == id;
  });
  return ainfo;
}
function numbers_add_ws(cfb, deps, wsidx) {
  var sheetref = -1, newsheetref = -1;
  var remap = {};
  numbers_iwa_doit(cfb, deps, 1, function(docroot, arch) {
    var doc = parse_shallow(docroot.messages[0].data);
    sheetref = parse_TSP_Reference(parse_shallow(docroot.messages[0].data)[1][0].data);
    newsheetref = get_unique_msgid({ deps: [1], location: deps[sheetref].location, type: 2 }, deps);
    remap[sheetref] = newsheetref;
    numbers_add_oref(docroot, newsheetref);
    doc[1].push({ type: 2, data: write_TSP_Reference(newsheetref) });
    var sheet = numbers_iwa_find(cfb, deps, sheetref);
    sheet.id = newsheetref;
    if (deps[1].location == deps[newsheetref].location)
      arch.push(sheet);
    else
      numbers_iwa_doit(cfb, deps, newsheetref, function(_, x) {
        return x.push(sheet);
      });
    docroot.messages[0].data = write_shallow(doc);
  });
  var tiaref = -1;
  numbers_iwa_doit(cfb, deps, newsheetref, function(sheetroot, arch) {
    var sa = parse_shallow(sheetroot.messages[0].data);
    for (var i = 3; i <= 69; ++i)
      delete sa[i];
    var drawables = mappa(sa[2], parse_TSP_Reference);
    drawables.forEach(function(n) {
      return numbers_del_oref(sheetroot, n);
    });
    tiaref = get_unique_msgid({ deps: [newsheetref], location: deps[drawables[0]].location, type: deps[drawables[0]].type }, deps);
    numbers_add_oref(sheetroot, tiaref);
    remap[drawables[0]] = tiaref;
    sa[2] = [{ type: 2, data: write_TSP_Reference(tiaref) }];
    var tia = numbers_iwa_find(cfb, deps, drawables[0]);
    tia.id = tiaref;
    if (deps[drawables[0]].location == deps[newsheetref].location)
      arch.push(tia);
    else {
      var loc2 = deps[newsheetref].location;
      loc2 = loc2.replace(/^Root Entry\//, "");
      loc2 = loc2.replace(/^Index\//, "").replace(/\.iwa$/, "");
      numbers_iwa_doit(cfb, deps, 2, function(ai) {
        var mlist = parse_shallow(ai.messages[0].data);
        var parentidx = mlist[3].findIndex(function(m) {
          var _a, _b;
          var mm = parse_shallow(m.data);
          if ((_a = mm[3]) == null ? void 0 : _a[0])
            return u8str(mm[3][0].data) == loc2;
          if (((_b = mm[2]) == null ? void 0 : _b[0]) && u8str(mm[2][0].data) == loc2)
            return true;
          return false;
        });
        var parent = parse_shallow(mlist[3][parentidx].data);
        if (!parent[6])
          parent[6] = [];
        parent[6].push({
          type: 2,
          data: write_shallow([
            [],
            [{ type: 0, data: write_varint49(tiaref) }]
          ])
        });
        mlist[3][parentidx].data = write_shallow(parent);
        ai.messages[0].data = write_shallow(mlist);
      });
      numbers_iwa_doit(cfb, deps, tiaref, function(_, x) {
        return x.push(tia);
      });
    }
    sheetroot.messages[0].data = write_shallow(sa);
  });
  var tmaref = -1;
  numbers_iwa_doit(cfb, deps, tiaref, function(tiaroot, arch) {
    var tia = parse_shallow(tiaroot.messages[0].data);
    var da = parse_shallow(tia[1][0].data);
    for (var i = 3; i <= 69; ++i)
      delete da[i];
    var dap = parse_TSP_Reference(da[2][0].data);
    da[2][0].data = write_TSP_Reference(remap[dap]);
    tia[1][0].data = write_shallow(da);
    var oldtmaref = parse_TSP_Reference(tia[2][0].data);
    numbers_del_oref(tiaroot, oldtmaref);
    tmaref = get_unique_msgid({ deps: [tiaref], location: deps[oldtmaref].location, type: deps[oldtmaref].type }, deps);
    numbers_add_oref(tiaroot, tmaref);
    remap[oldtmaref] = tmaref;
    tia[2][0].data = write_TSP_Reference(tmaref);
    var tma = numbers_iwa_find(cfb, deps, oldtmaref);
    tma.id = tmaref;
    if (deps[tiaref].location == deps[tmaref].location)
      arch.push(tma);
    else
      numbers_iwa_doit(cfb, deps, tmaref, function(_, x) {
        return x.push(tma);
      });
    tiaroot.messages[0].data = write_shallow(tia);
  });
  var loc = deps[tmaref].location;
  loc = loc.replace(/^Root Entry\//, "");
  loc = loc.replace(/^Index\//, "").replace(/\.iwa$/, "");
  numbers_iwa_doit(cfb, deps, tmaref, function(tmaroot, arch) {
    var _a, _b;
    var tma = parse_shallow(tmaroot.messages[0].data);
    var uuid = u8str(tma[1][0].data), new_uuid = uuid.replace(/-[A-Z0-9]*/, "-".concat(wsidx.toString(16).padStart(4, "0")));
    tma[1][0].data = stru8(new_uuid);
    [12, 13, 29, 31, 32, 33, 39, 44, 47, 81, 82, 84].forEach(function(n) {
      return delete tma[n];
    });
    if (tma[45]) {
      var srrta = parse_shallow(tma[45][0].data);
      var ref = parse_TSP_Reference(srrta[1][0].data);
      numbers_del_oref(tmaroot, ref);
      delete tma[45];
    }
    if (tma[70]) {
      var hsoa = parse_shallow(tma[70][0].data);
      (_a = hsoa[2]) == null ? void 0 : _a.forEach(function(item) {
        var hsa = parse_shallow(item.data);
        [2, 3].map(function(n) {
          return hsa[n][0];
        }).forEach(function(hseadata) {
          var hsea = parse_shallow(hseadata.data);
          if (!hsea[8])
            return;
          var ref2 = parse_TSP_Reference(hsea[8][0].data);
          numbers_del_oref(tmaroot, ref2);
        });
      });
      delete tma[70];
    }
    [
      46,
      30,
      34,
      35,
      36,
      38,
      48,
      49,
      60,
      61,
      62,
      63,
      64,
      71,
      72,
      73,
      74,
      75,
      85,
      86,
      87,
      88,
      89
    ].forEach(function(n) {
      if (!tma[n])
        return;
      var ref2 = parse_TSP_Reference(tma[n][0].data);
      delete tma[n];
      numbers_del_oref(tmaroot, ref2);
    });
    var store = parse_shallow(tma[4][0].data);
    {
      [2, 4, 5, 6, 11, 12, 13, 15, 16, 17, 18, 19, 20, 21, 22].forEach(function(n) {
        var _a2;
        if (!((_a2 = store[n]) == null ? void 0 : _a2[0]))
          return;
        var oldref = parse_TSP_Reference(store[n][0].data);
        var newref = get_unique_msgid({ deps: [tmaref], location: deps[oldref].location, type: deps[oldref].type }, deps);
        numbers_del_oref(tmaroot, oldref);
        numbers_add_oref(tmaroot, newref);
        remap[oldref] = newref;
        var msg = numbers_iwa_find(cfb, deps, oldref);
        msg.id = newref;
        if (deps[oldref].location == deps[tmaref].location)
          arch.push(msg);
        else {
          deps[newref].location = deps[oldref].location.replace(oldref.toString(), newref.toString());
          if (deps[newref].location == deps[oldref].location)
            deps[newref].location = deps[newref].location.replace(/\.iwa/, "-".concat(newref, ".iwa"));
          CFB.utils.cfb_add(cfb, deps[newref].location, compress_iwa_file(write_iwa_file([msg])));
          var newloc = deps[newref].location;
          newloc = newloc.replace(/^Root Entry\//, "");
          newloc = newloc.replace(/^Index\//, "").replace(/\.iwa$/, "");
          numbers_iwa_doit(cfb, deps, 2, function(ai) {
            var mlist = parse_shallow(ai.messages[0].data);
            mlist[3].push({ type: 2, data: write_shallow([
              [],
              [{ type: 0, data: write_varint49(newref) }],
              [{ type: 2, data: stru8(newloc.replace(/-.*$/, "")) }],
              [{ type: 2, data: stru8(newloc) }],
              [{ type: 2, data: new Uint8Array([2, 0, 0]) }],
              [{ type: 2, data: new Uint8Array([2, 0, 0]) }],
              [],
              [],
              [],
              [],
              [{ type: 0, data: write_varint49(0) }],
              [],
              [{ type: 0, data: write_varint49(0) }]
            ]) });
            mlist[1] = [{ type: 0, data: write_varint49(Math.max(newref + 1, parse_varint49(mlist[1][0].data))) }];
            var parentidx = mlist[3].findIndex(function(m) {
              var _a3, _b2;
              var mm = parse_shallow(m.data);
              if ((_a3 = mm[3]) == null ? void 0 : _a3[0])
                return u8str(mm[3][0].data) == loc;
              if (((_b2 = mm[2]) == null ? void 0 : _b2[0]) && u8str(mm[2][0].data) == loc)
                return true;
              return false;
            });
            var parent = parse_shallow(mlist[3][parentidx].data);
            if (!parent[6])
              parent[6] = [];
            parent[6].push({
              type: 2,
              data: write_shallow([
                [],
                [{ type: 0, data: write_varint49(newref) }]
              ])
            });
            mlist[3][parentidx].data = write_shallow(parent);
            ai.messages[0].data = write_shallow(mlist);
          });
        }
        store[n][0].data = write_TSP_Reference(newref);
      });
      var row_headers = parse_shallow(store[1][0].data);
      {
        (_b = row_headers[2]) == null ? void 0 : _b.forEach(function(tspref) {
          var oldref = parse_TSP_Reference(tspref.data);
          var newref = get_unique_msgid({ deps: [tmaref], location: deps[oldref].location, type: deps[oldref].type }, deps);
          numbers_del_oref(tmaroot, oldref);
          numbers_add_oref(tmaroot, newref);
          remap[oldref] = newref;
          var msg = numbers_iwa_find(cfb, deps, oldref);
          msg.id = newref;
          if (deps[oldref].location == deps[tmaref].location) {
            arch.push(msg);
          } else {
            deps[newref].location = deps[oldref].location.replace(oldref.toString(), newref.toString());
            if (deps[newref].location == deps[oldref].location)
              deps[newref].location = deps[newref].location.replace(/\.iwa/, "-".concat(newref, ".iwa"));
            CFB.utils.cfb_add(cfb, deps[newref].location, compress_iwa_file(write_iwa_file([msg])));
            var newloc = deps[newref].location;
            newloc = newloc.replace(/^Root Entry\//, "");
            newloc = newloc.replace(/^Index\//, "").replace(/\.iwa$/, "");
            numbers_iwa_doit(cfb, deps, 2, function(ai) {
              var mlist = parse_shallow(ai.messages[0].data);
              mlist[3].push({ type: 2, data: write_shallow([
                [],
                [{ type: 0, data: write_varint49(newref) }],
                [{ type: 2, data: stru8(newloc.replace(/-.*$/, "")) }],
                [{ type: 2, data: stru8(newloc) }],
                [{ type: 2, data: new Uint8Array([2, 0, 0]) }],
                [{ type: 2, data: new Uint8Array([2, 0, 0]) }],
                [],
                [],
                [],
                [],
                [{ type: 0, data: write_varint49(0) }],
                [],
                [{ type: 0, data: write_varint49(0) }]
              ]) });
              mlist[1] = [{ type: 0, data: write_varint49(Math.max(newref + 1, parse_varint49(mlist[1][0].data))) }];
              var parentidx = mlist[3].findIndex(function(m) {
                var _a2, _b2;
                var mm = parse_shallow(m.data);
                if ((_a2 = mm[3]) == null ? void 0 : _a2[0])
                  return u8str(mm[3][0].data) == loc;
                if (((_b2 = mm[2]) == null ? void 0 : _b2[0]) && u8str(mm[2][0].data) == loc)
                  return true;
                return false;
              });
              var parent = parse_shallow(mlist[3][parentidx].data);
              if (!parent[6])
                parent[6] = [];
              parent[6].push({
                type: 2,
                data: write_shallow([
                  [],
                  [{ type: 0, data: write_varint49(newref) }]
                ])
              });
              mlist[3][parentidx].data = write_shallow(parent);
              ai.messages[0].data = write_shallow(mlist);
            });
          }
          tspref.data = write_TSP_Reference(newref);
        });
      }
      store[1][0].data = write_shallow(row_headers);
      var tiles = parse_shallow(store[3][0].data);
      {
        tiles[1].forEach(function(t) {
          var tst = parse_shallow(t.data);
          var oldtileref = parse_TSP_Reference(tst[2][0].data);
          var newtileref = remap[oldtileref];
          if (!remap[oldtileref]) {
            newtileref = get_unique_msgid({ deps: [tmaref], location: "", type: deps[oldtileref].type }, deps);
            deps[newtileref].location = "Root Entry/Index/Tables/Tile-".concat(newtileref, ".iwa");
            remap[oldtileref] = newtileref;
            var oldtile = numbers_iwa_find(cfb, deps, oldtileref);
            oldtile.id = newtileref;
            numbers_del_oref(tmaroot, oldtileref);
            numbers_add_oref(tmaroot, newtileref);
            CFB.utils.cfb_add(cfb, "/Index/Tables/Tile-".concat(newtileref, ".iwa"), compress_iwa_file(write_iwa_file([oldtile])));
            numbers_iwa_doit(cfb, deps, 2, function(ai) {
              var mlist = parse_shallow(ai.messages[0].data);
              mlist[3].push({ type: 2, data: write_shallow([
                [],
                [{ type: 0, data: write_varint49(newtileref) }],
                [{ type: 2, data: stru8("Tables/Tile") }],
                [{ type: 2, data: stru8("Tables/Tile-".concat(newtileref)) }],
                [{ type: 2, data: new Uint8Array([2, 0, 0]) }],
                [{ type: 2, data: new Uint8Array([2, 0, 0]) }],
                [],
                [],
                [],
                [],
                [{ type: 0, data: write_varint49(0) }],
                [],
                [{ type: 0, data: write_varint49(0) }]
              ]) });
              mlist[1] = [{ type: 0, data: write_varint49(Math.max(newtileref + 1, parse_varint49(mlist[1][0].data))) }];
              var parentidx = mlist[3].findIndex(function(m) {
                var _a2, _b2;
                var mm = parse_shallow(m.data);
                if ((_a2 = mm[3]) == null ? void 0 : _a2[0])
                  return u8str(mm[3][0].data) == loc;
                if (((_b2 = mm[2]) == null ? void 0 : _b2[0]) && u8str(mm[2][0].data) == loc)
                  return true;
                return false;
              });
              var parent = parse_shallow(mlist[3][parentidx].data);
              if (!parent[6])
                parent[6] = [];
              parent[6].push({
                type: 2,
                data: write_shallow([
                  [],
                  [{ type: 0, data: write_varint49(newtileref) }]
                ])
              });
              mlist[3][parentidx].data = write_shallow(parent);
              ai.messages[0].data = write_shallow(mlist);
            });
          }
          tst[2][0].data = write_TSP_Reference(newtileref);
          t.data = write_shallow(tst);
        });
      }
      store[3][0].data = write_shallow(tiles);
    }
    tma[4][0].data = write_shallow(store);
    tmaroot.messages[0].data = write_shallow(tma);
  });
}
function write_numbers_ws(cfb, deps, ws, wsname, sheetidx, rootref) {
  var drawables = [];
  numbers_iwa_doit(cfb, deps, rootref, function(docroot) {
    var sheetref = parse_shallow(docroot.messages[0].data);
    {
      sheetref[1] = [{ type: 2, data: stru8(wsname) }];
      drawables = mappa(sheetref[2], parse_TSP_Reference);
    }
    docroot.messages[0].data = write_shallow(sheetref);
  });
  var tia = numbers_iwa_find(cfb, deps, drawables[0]);
  var tmaref = parse_TSP_Reference(parse_shallow(tia.messages[0].data)[2][0].data);
  numbers_iwa_doit(cfb, deps, tmaref, function(docroot, x) {
    return write_numbers_tma(cfb, deps, ws, docroot, x, tmaref);
  });
}
var USE_WIDE_ROWS = true;
function write_numbers_tma(cfb, deps, ws, tmaroot, tmafile, tmaref) {
  var range = decode_range(ws["!ref"]);
  range.s.r = range.s.c = 0;
  var trunc = false;
  if (range.e.c > 999) {
    trunc = true;
    range.e.c = 999;
  }
  if (range.e.r > 999999) {
    trunc = true;
    range.e.r = 999999;
  }
  if (trunc)
    console.error("Truncating to ".concat(encode_range(range)));
  var data = sheet_to_json(ws, { range: range, header: 1 });
  var SST = ["~Sh33tJ5~"];
  var loc = deps[tmaref].location;
  loc = loc.replace(/^Root Entry\//, "");
  loc = loc.replace(/^Index\//, "").replace(/\.iwa$/, "");
  var pb = parse_shallow(tmaroot.messages[0].data);
  {
    pb[6][0].data = write_varint49(range.e.r + 1);
    pb[7][0].data = write_varint49(range.e.c + 1);
    delete pb[46];
    var store = parse_shallow(pb[4][0].data);
    {
      var row_header_ref = parse_TSP_Reference(parse_shallow(store[1][0].data)[2][0].data);
      numbers_iwa_doit(cfb, deps, row_header_ref, function(rowhead, _x) {
        var _a;
        var base_bucket = parse_shallow(rowhead.messages[0].data);
        if ((_a = base_bucket == null ? void 0 : base_bucket[2]) == null ? void 0 : _a[0])
          for (var R2 = 0; R2 < data.length; ++R2) {
            var _bucket = parse_shallow(base_bucket[2][0].data);
            _bucket[1][0].data = write_varint49(R2);
            _bucket[4][0].data = write_varint49(data[R2].length);
            base_bucket[2][R2] = { type: base_bucket[2][0].type, data: write_shallow(_bucket) };
          }
        rowhead.messages[0].data = write_shallow(base_bucket);
      });
      var col_header_ref = parse_TSP_Reference(store[2][0].data);
      numbers_iwa_doit(cfb, deps, col_header_ref, function(colhead, _x) {
        var base_bucket = parse_shallow(colhead.messages[0].data);
        for (var C = 0; C <= range.e.c; ++C) {
          var _bucket = parse_shallow(base_bucket[2][0].data);
          _bucket[1][0].data = write_varint49(C);
          _bucket[4][0].data = write_varint49(range.e.r + 1);
          base_bucket[2][C] = { type: base_bucket[2][0].type, data: write_shallow(_bucket) };
        }
        colhead.messages[0].data = write_shallow(base_bucket);
      });
      var rbtree = parse_shallow(store[9][0].data);
      rbtree[1] = [];
      var tilestore = parse_shallow(store[3][0].data);
      {
        var tstride = 256;
        tilestore[2] = [{ type: 0, data: write_varint49(tstride) }];
        var tileref = parse_TSP_Reference(parse_shallow(tilestore[1][0].data)[2][0].data);
        var save_token = function() {
          var metadata = numbers_iwa_find(cfb, deps, 2);
          var mlist = parse_shallow(metadata.messages[0].data);
          var mlst = mlist[3].filter(function(m) {
            return parse_varint49(parse_shallow(m.data)[1][0].data) == tileref;
          });
          return (mlst == null ? void 0 : mlst.length) ? parse_varint49(parse_shallow(mlst[0].data)[12][0].data) : 0;
        }();
        {
          CFB.utils.cfb_del(cfb, deps[tileref].location);
          numbers_iwa_doit(cfb, deps, 2, function(ai) {
            var mlist = parse_shallow(ai.messages[0].data);
            mlist[3] = mlist[3].filter(function(m) {
              return parse_varint49(parse_shallow(m.data)[1][0].data) != tileref;
            });
            var parentidx = mlist[3].findIndex(function(m) {
              var _a, _b;
              var mm = parse_shallow(m.data);
              if ((_a = mm[3]) == null ? void 0 : _a[0])
                return u8str(mm[3][0].data) == loc;
              if (((_b = mm[2]) == null ? void 0 : _b[0]) && u8str(mm[2][0].data) == loc)
                return true;
              return false;
            });
            var parent = parse_shallow(mlist[3][parentidx].data);
            if (!parent[6])
              parent[6] = [];
            parent[6] = parent[6].filter(function(m) {
              return parse_varint49(parse_shallow(m.data)[1][0].data) != tileref;
            });
            mlist[3][parentidx].data = write_shallow(parent);
            ai.messages[0].data = write_shallow(mlist);
          });
          numbers_del_oref(tmaroot, tileref);
        }
        tilestore[1] = [];
        var ntiles = Math.ceil((range.e.r + 1) / tstride);
        for (var tidx = 0; tidx < ntiles; ++tidx) {
          var newtileid = get_unique_msgid({
            deps: [],
            location: "",
            type: 6002
          }, deps);
          deps[newtileid].location = "Root Entry/Index/Tables/Tile-".concat(newtileid, ".iwa");
          var tiledata = [
            [],
            [{ type: 0, data: write_varint49(0) }],
            [{ type: 0, data: write_varint49(Math.min(range.e.r + 1, (tidx + 1) * tstride)) }],
            [{ type: 0, data: write_varint49(0) }],
            [{ type: 0, data: write_varint49(Math.min((tidx + 1) * tstride, range.e.r + 1) - tidx * tstride) }],
            [],
            [{ type: 0, data: write_varint49(5) }],
            [{ type: 0, data: write_varint49(1) }],
            [{ type: 0, data: write_varint49(USE_WIDE_ROWS ? 1 : 0) }]
          ];
          for (var R = tidx * tstride; R <= Math.min(range.e.r, (tidx + 1) * tstride - 1); ++R) {
            var tilerow = write_TST_TileRowInfo(data[R], SST, USE_WIDE_ROWS);
            tilerow[1][0].data = write_varint49(R - tidx * tstride);
            tiledata[5].push({ data: write_shallow(tilerow), type: 2 });
          }
          tilestore[1].push({ type: 2, data: write_shallow([
            [],
            [{ type: 0, data: write_varint49(tidx) }],
            [{ type: 2, data: write_TSP_Reference(newtileid) }]
          ]) });
          var newtile = {
            id: newtileid,
            messages: [write_iwam(6002, write_shallow(tiledata))]
          };
          var tilecontent = compress_iwa_file(write_iwa_file([newtile]));
          CFB.utils.cfb_add(cfb, "/Index/Tables/Tile-".concat(newtileid, ".iwa"), tilecontent);
          numbers_iwa_doit(cfb, deps, 2, function(ai) {
            var mlist = parse_shallow(ai.messages[0].data);
            mlist[3].push({ type: 2, data: write_shallow([
              [],
              [{ type: 0, data: write_varint49(newtileid) }],
              [{ type: 2, data: stru8("Tables/Tile") }],
              [{ type: 2, data: stru8("Tables/Tile-".concat(newtileid)) }],
              [{ type: 2, data: new Uint8Array([2, 0, 0]) }],
              [{ type: 2, data: new Uint8Array([2, 0, 0]) }],
              [],
              [],
              [],
              [],
              [{ type: 0, data: write_varint49(0) }],
              [],
              [{ type: 0, data: write_varint49(save_token) }]
            ]) });
            mlist[1] = [{ type: 0, data: write_varint49(Math.max(newtileid + 1, parse_varint49(mlist[1][0].data))) }];
            var parentidx = mlist[3].findIndex(function(m) {
              var _a, _b;
              var mm = parse_shallow(m.data);
              if ((_a = mm[3]) == null ? void 0 : _a[0])
                return u8str(mm[3][0].data) == loc;
              if (((_b = mm[2]) == null ? void 0 : _b[0]) && u8str(mm[2][0].data) == loc)
                return true;
              return false;
            });
            var parent = parse_shallow(mlist[3][parentidx].data);
            if (!parent[6])
              parent[6] = [];
            parent[6].push({
              type: 2,
              data: write_shallow([
                [],
                [{ type: 0, data: write_varint49(newtileid) }]
              ])
            });
            mlist[3][parentidx].data = write_shallow(parent);
            ai.messages[0].data = write_shallow(mlist);
          });
          numbers_add_oref(tmaroot, newtileid);
          rbtree[1].push({ type: 2, data: write_shallow([
            [],
            [{ type: 0, data: write_varint49(tidx * tstride) }],
            [{ type: 0, data: write_varint49(tidx) }]
          ]) });
        }
      }
      store[3][0].data = write_shallow(tilestore);
      store[9][0].data = write_shallow(rbtree);
      store[10] = [{ type: 2, data: new Uint8Array([]) }];
      if (ws["!merges"]) {
        var mergeid = get_unique_msgid({
          type: 6144,
          deps: [tmaref],
          location: deps[tmaref].location
        }, deps);
        tmafile.push({
          id: mergeid,
          messages: [write_iwam(6144, write_shallow([
            [],
            ws["!merges"].map(function(m) {
              return { type: 2, data: write_shallow([
                [],
                [{ type: 2, data: write_shallow([
                  [],
                  [{ type: 5, data: new Uint8Array(new Uint16Array([m.s.r, m.s.c]).buffer) }]
                ]) }],
                [{ type: 2, data: write_shallow([
                  [],
                  [{ type: 5, data: new Uint8Array(new Uint16Array([m.e.r - m.s.r + 1, m.e.c - m.s.c + 1]).buffer) }]
                ]) }]
              ]) };
            })
          ]))]
        });
        store[13] = [{ type: 2, data: write_TSP_Reference(mergeid) }];
        numbers_iwa_doit(cfb, deps, 2, function(ai) {
          var mlist = parse_shallow(ai.messages[0].data);
          var parentidx = mlist[3].findIndex(function(m) {
            var _a, _b;
            var mm = parse_shallow(m.data);
            if ((_a = mm[3]) == null ? void 0 : _a[0])
              return u8str(mm[3][0].data) == loc;
            if (((_b = mm[2]) == null ? void 0 : _b[0]) && u8str(mm[2][0].data) == loc)
              return true;
            return false;
          });
          var parent = parse_shallow(mlist[3][parentidx].data);
          if (!parent[6])
            parent[6] = [];
          parent[6].push({
            type: 2,
            data: write_shallow([
              [],
              [{ type: 0, data: write_varint49(mergeid) }]
            ])
          });
          mlist[3][parentidx].data = write_shallow(parent);
          ai.messages[0].data = write_shallow(mlist);
        });
        numbers_add_oref(tmaroot, mergeid);
      } else
        delete store[13];
      var sstref = parse_TSP_Reference(store[4][0].data);
      numbers_iwa_doit(cfb, deps, sstref, function(sstroot) {
        var sstdata = parse_shallow(sstroot.messages[0].data);
        {
          sstdata[3] = [];
          SST.forEach(function(str, i) {
            if (i == 0)
              return;
            sstdata[3].push({ type: 2, data: write_shallow([
              [],
              [{ type: 0, data: write_varint49(i) }],
              [{ type: 0, data: write_varint49(1) }],
              [{ type: 2, data: stru8(str) }]
            ]) });
          });
        }
        sstroot.messages[0].data = write_shallow(sstdata);
      });
    }
    pb[4][0].data = write_shallow(store);
  }
  tmaroot.messages[0].data = write_shallow(pb);
}
function fix_opts_func(defaults) {
	return function fix_opts(opts) {
		for(var i = 0; i != defaults.length; ++i) {
			var d = defaults[i];
			if(opts[d[0]] === undefined) opts[d[0]] = d[1];
			if(d[2] === 'n') opts[d[0]] = Number(opts[d[0]]);
		}
	};
}

function fix_read_opts(opts) {
fix_opts_func([
	['cellNF', false], /* emit cell number format string as .z */
	['cellHTML', true], /* emit html string as .h */
	['cellFormula', true], /* emit formulae as .f */
	['cellStyles', false], /* emits style/theme as .s */
	['cellText', true], /* emit formatted text as .w */
	['cellDates', false], /* emit date cells with type `d` */

	['sheetStubs', false], /* emit empty cells */
	['sheetRows', 0, 'n'], /* read n rows (0 = read all rows) */

	['bookDeps', false], /* parse calculation chains */
	['bookSheets', false], /* only try to get sheet names (no Sheets) */
	['bookProps', false], /* only try to get properties (no Sheets) */
	['bookFiles', false], /* include raw file structure (keys, files, cfb) */
	['bookVBA', false], /* include vba raw data (vbaraw) */

	['password',''], /* password */
	['WTF', false] /* WTF mode (throws errors) */
])(opts);
}

function fix_write_opts(opts) {
fix_opts_func([
	['cellDates', false], /* write date cells with type `d` */

	['bookSST', false], /* Generate Shared String Table */

	['bookType', 'xlsx'], /* Type of workbook (xlsx/m/b) */

	['compression', false], /* Use file compression */

	['WTF', false] /* WTF mode (throws errors) */
])(opts);
}
function get_sheet_type(n) {
	if(RELS.WS.indexOf(n) > -1) return "sheet";
	if(RELS.CS && n == RELS.CS) return "chart";
	if(RELS.DS && n == RELS.DS) return "dialog";
	if(RELS.MS && n == RELS.MS) return "macro";
	return (n && n.length) ? n : "sheet";
}
function safe_parse_wbrels(wbrels, sheets) {
	if(!wbrels) return 0;
	try {
		wbrels = sheets.map(function pwbr(w) { if(!w.id) w.id = w.strRelID; return [w.name, wbrels['!id'][w.id].Target, get_sheet_type(wbrels['!id'][w.id].Type)]; });
	} catch(e) { return null; }
	return !wbrels || wbrels.length === 0 ? null : wbrels;
}

function safe_parse_sheet(zip, path, relsPath, sheet, idx, sheetRels, sheets, stype, opts, wb, themes, styles) {
	try {
		sheetRels[sheet]=parse_rels(getzipstr(zip, relsPath, true), path);
		var data = getzipdata(zip, path);
		var _ws;
		switch(stype) {
			case 'sheet':  _ws = parse_ws(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
			case 'chart':  _ws = parse_cs(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
				if(!_ws || !_ws['!drawel']) break;
				var dfile = resolve_path(_ws['!drawel'].Target, path);
				var drelsp = get_rels_path(dfile);
				var draw = parse_drawing(getzipstr(zip, dfile, true), parse_rels(getzipstr(zip, drelsp, true), dfile));
				var chartp = resolve_path(draw, dfile);
				var crelsp = get_rels_path(chartp);
				_ws = parse_chart(getzipstr(zip, chartp, true), chartp, opts, parse_rels(getzipstr(zip, crelsp, true), chartp), wb, _ws);
				break;
			case 'macro':  _ws = parse_ms(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
			case 'dialog': _ws = parse_ds(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
			default: throw new Error("Unrecognized sheet type " + stype);
		}
		sheets[sheet] = _ws;

		/* scan rels for comments and threaded comments */
		var comments = [], tcomments = [];
		if(sheetRels && sheetRels[sheet]) keys(sheetRels[sheet]).forEach(function(n) {
			var dfile = "";
			if(sheetRels[sheet][n].Type == RELS.CMNT) {
				dfile = resolve_path(sheetRels[sheet][n].Target, path);
				comments = parse_cmnt(getzipdata(zip, dfile, true), dfile, opts);
				if(!comments || !comments.length) return;
				sheet_insert_comments(_ws, comments, false);
			}
			if(sheetRels[sheet][n].Type == RELS.TCMNT) {
				dfile = resolve_path(sheetRels[sheet][n].Target, path);
				tcomments = tcomments.concat(parse_tcmnt_xml(getzipdata(zip, dfile, true), opts));
			}
		});
		if(tcomments && tcomments.length) sheet_insert_comments(_ws, tcomments, true, opts.people || []);
	} catch(e) { if(opts.WTF) throw e; }
}

function strip_front_slash(x) { return x.charAt(0) == '/' ? x.slice(1) : x; }

function parse_zip(zip, opts) {
	make_ssf();
	opts = opts || {};
	fix_read_opts(opts);

	/* OpenDocument Part 3 Section 2.2.1 OpenDocument Package */
	if(safegetzipfile(zip, 'META-INF/manifest.xml')) return parse_ods(zip, opts);
	/* UOC */
	if(safegetzipfile(zip, 'objectdata.xml')) return parse_ods(zip, opts);
	/* Numbers */
	if(safegetzipfile(zip, 'Index/Document.iwa')) {
		if(typeof Uint8Array == "undefined") throw new Error('NUMBERS file parsing requires Uint8Array support');
		if(typeof parse_numbers_iwa != "undefined") {
			if(zip.FileIndex) return parse_numbers_iwa(zip, opts);
			var _zip = CFB.utils.cfb_new();
			zipentries(zip).forEach(function(e) { zip_add_file(_zip, e, getzipbin(zip, e)); });
			return parse_numbers_iwa(_zip, opts);
		}
		throw new Error('Unsupported NUMBERS file');
	}
	if(!safegetzipfile(zip, '[Content_Types].xml')) {
		if(safegetzipfile(zip, 'index.xml.gz')) throw new Error('Unsupported NUMBERS 08 file');
		if(safegetzipfile(zip, 'index.xml')) throw new Error('Unsupported NUMBERS 09 file');
		var index_zip = CFB.find(zip, 'Index.zip');
		if(index_zip) {
			opts = dup(opts);
			delete opts.type;
			if(typeof index_zip.content == "string") opts.type = "binary";
			// TODO: Bun buffer bug
			if(typeof Bun !== "undefined" && Buffer.isBuffer(index_zip.content)) return readSync(new Uint8Array(index_zip.content), opts);
			return readSync(index_zip.content, opts);
		}
		throw new Error('Unsupported ZIP file');
	}

	var entries = zipentries(zip);
	var dir = parse_ct((getzipstr(zip, '[Content_Types].xml')));
	var xlsb = false;
	var sheets, binname;
	if(dir.workbooks.length === 0) {
		binname = "xl/workbook.xml";
		if(getzipdata(zip,binname, true)) dir.workbooks.push(binname);
	}
	if(dir.workbooks.length === 0) {
		binname = "xl/workbook.bin";
		if(!getzipdata(zip,binname,true)) throw new Error("Could not find workbook");
		dir.workbooks.push(binname);
		xlsb = true;
	}
	if(dir.workbooks[0].slice(-3) == "bin") xlsb = true;

	var themes = ({});
	var styles = ({});
	if(!opts.bookSheets && !opts.bookProps) {
		strs = [];
		if(dir.sst) try { strs=parse_sst(getzipdata(zip, strip_front_slash(dir.sst)), dir.sst, opts); } catch(e) { if(opts.WTF) throw e; }

		if(opts.cellStyles && dir.themes.length) themes = parse_theme_xml(getzipstr(zip, dir.themes[0].replace(/^\//,''), true)||"", opts);

		if(dir.style) styles = parse_sty(getzipdata(zip, strip_front_slash(dir.style)), dir.style, themes, opts);
	}

	/*var externbooks = */dir.links.map(function(link) {
		try {
			var rels = parse_rels(getzipstr(zip, get_rels_path(strip_front_slash(link))), link);
			return parse_xlink(getzipdata(zip, strip_front_slash(link)), rels, link, opts);
		} catch(e) {}
	});

	var wb = parse_wb(getzipdata(zip, strip_front_slash(dir.workbooks[0])), dir.workbooks[0], opts);

	var props = {}, propdata = "";

	if(dir.coreprops.length) {
		propdata = getzipdata(zip, strip_front_slash(dir.coreprops[0]), true);
		if(propdata) props = parse_core_props(propdata);
		if(dir.extprops.length !== 0) {
			propdata = getzipdata(zip, strip_front_slash(dir.extprops[0]), true);
			if(propdata) parse_ext_props(propdata, props, opts);
		}
	}

	var custprops = {};
	if(!opts.bookSheets || opts.bookProps) {
		if (dir.custprops.length !== 0) {
			propdata = getzipstr(zip, strip_front_slash(dir.custprops[0]), true);
			if(propdata) custprops = parse_cust_props(propdata, opts);
		}
	}

	var out = ({});
	if(opts.bookSheets || opts.bookProps) {
		if(wb.Sheets) sheets = wb.Sheets.map(function pluck(x){ return x.name; });
		else if(props.Worksheets && props.SheetNames.length > 0) sheets=props.SheetNames;
		if(opts.bookProps) { out.Props = props; out.Custprops = custprops; }
		if(opts.bookSheets && typeof sheets !== 'undefined') out.SheetNames = sheets;
		if(opts.bookSheets ? out.SheetNames : opts.bookProps) return out;
	}
	sheets = {};

	var deps = {};
	if(opts.bookDeps && dir.calcchain) deps=parse_cc(getzipdata(zip, strip_front_slash(dir.calcchain)),dir.calcchain,opts);

	var i=0;
	var sheetRels = ({});
	var path, relsPath;

	{
		var wbsheets = wb.Sheets;
		props.Worksheets = wbsheets.length;
		props.SheetNames = [];
		for(var j = 0; j != wbsheets.length; ++j) {
			props.SheetNames[j] = wbsheets[j].name;
		}
	}

	var wbext = xlsb ? "bin" : "xml";
	var wbrelsi = dir.workbooks[0].lastIndexOf("/");
	var wbrelsfile = (dir.workbooks[0].slice(0, wbrelsi+1) + "_rels/" + dir.workbooks[0].slice(wbrelsi+1) + ".rels").replace(/^\//,"");
	if(!safegetzipfile(zip, wbrelsfile)) wbrelsfile = 'xl/_rels/workbook.' + wbext + '.rels';
	var wbrels = parse_rels(getzipstr(zip, wbrelsfile, true), wbrelsfile.replace(/_rels.*/, "s5s"));

	if((dir.metadata || []).length >= 1) {
		/* TODO: MDX and other types of metadata */
		opts.xlmeta = parse_xlmeta(getzipdata(zip, strip_front_slash(dir.metadata[0])),dir.metadata[0],opts);
	}

	if((dir.people || []).length >= 1) {
		opts.people = parse_people_xml(getzipdata(zip, strip_front_slash(dir.people[0])),opts);
	}

	if(wbrels) wbrels = safe_parse_wbrels(wbrels, wb.Sheets);

	/* Numbers iOS hack */
	var nmode = (getzipdata(zip,"xl/worksheets/sheet.xml",true))?1:0;
	wsloop: for(i = 0; i != props.Worksheets; ++i) {
		var stype = "sheet";
		if(wbrels && wbrels[i]) {
			path = 'xl/' + (wbrels[i][1]).replace(/[\/]?xl\//, "");
			if(!safegetzipfile(zip, path)) path = wbrels[i][1];
			if(!safegetzipfile(zip, path)) path = wbrelsfile.replace(/_rels\/.*$/,"") + wbrels[i][1];
			stype = wbrels[i][2];
		} else {
			path = 'xl/worksheets/sheet'+(i+1-nmode)+"." + wbext;
			path = path.replace(/sheet0\./,"sheet.");
		}
		relsPath = path.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels");
		if(opts && opts.sheets != null) switch(typeof opts.sheets) {
			case "number": if(i != opts.sheets) continue wsloop; break;
			case "string": if(props.SheetNames[i].toLowerCase() != opts.sheets.toLowerCase()) continue wsloop; break;
			default: if(Array.isArray && Array.isArray(opts.sheets)) {
				var snjseen = false;
				for(var snj = 0; snj != opts.sheets.length; ++snj) {
					if(typeof opts.sheets[snj] == "number" && opts.sheets[snj] == i) snjseen=1;
					if(typeof opts.sheets[snj] == "string" && opts.sheets[snj].toLowerCase() == props.SheetNames[i].toLowerCase()) snjseen = 1;
				}
				if(!snjseen) continue wsloop;
			}
		}
		safe_parse_sheet(zip, path, relsPath, props.SheetNames[i], i, sheetRels, sheets, stype, opts, wb, themes, styles);
	}

	out = ({
		Directory: dir,
		Workbook: wb,
		Props: props,
		Custprops: custprops,
		Deps: deps,
		Sheets: sheets,
		SheetNames: props.SheetNames,
		Strings: strs,
		Styles: styles,
		Themes: themes,
		SSF: dup(table_fmt)
	});
	if(opts && opts.bookFiles) {
		if(zip.files) {
			out.keys = entries;
			out.files = zip.files;
		} else {
			out.keys = [];
			out.files = {};
			zip.FullPaths.forEach(function(p, idx) {
				p = p.replace(/^Root Entry[\/]/, "");
				out.keys.push(p);
				out.files[p] = zip.FileIndex[idx];
			});
		}
	}
	if(opts && opts.bookVBA) {
		if(dir.vba.length > 0) out.vbaraw = getzipdata(zip,strip_front_slash(dir.vba[0]),true);
		else if(dir.defaults && dir.defaults.bin === CT_VBA) out.vbaraw = getzipdata(zip, 'xl/vbaProject.bin',true);
	}
	// TODO: pass back content types metdata for xlsm/xlsx resolution
	out.bookType = xlsb ? "xlsb" : "xlsx";
	return out;
}

/* [MS-OFFCRYPTO] 2.1.1 */
function parse_xlsxcfb(cfb, _opts) {
	var opts = _opts || {};
	var f = 'Workbook', data = CFB.find(cfb, f);
	try {
	f = '/!DataSpaces/Version';
	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	/*var version = */parse_DataSpaceVersionInfo(data.content);

	/* 2.3.4.1 */
	f = '/!DataSpaces/DataSpaceMap';
	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	var dsm = parse_DataSpaceMap(data.content);
	if(dsm.length !== 1 || dsm[0].comps.length !== 1 || dsm[0].comps[0].t !== 0 || dsm[0].name !== "StrongEncryptionDataSpace" || dsm[0].comps[0].v !== "EncryptedPackage")
		throw new Error("ECMA-376 Encrypted file bad " + f);

	/* 2.3.4.2 */
	f = '/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace';
	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	var seds = parse_DataSpaceDefinition(data.content);
	if(seds.length != 1 || seds[0] != "StrongEncryptionTransform")
		throw new Error("ECMA-376 Encrypted file bad " + f);

	/* 2.3.4.3 */
	f = '/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary';
	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	/*var hdr = */parse_Primary(data.content);
	} catch(e) {}

	f = '/EncryptionInfo';
	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	var einfo = parse_EncryptionInfo(data.content);

	/* 2.3.4.4 */
	f = '/EncryptedPackage';
	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);

/*global decrypt_agile */
if(einfo[0] == 0x04 && typeof decrypt_agile !== 'undefined') return decrypt_agile(einfo[1], data.content, opts.password || "", opts);
/*global decrypt_std76 */
if(einfo[0] == 0x02 && typeof decrypt_std76 !== 'undefined') return decrypt_std76(einfo[1], data.content, opts.password || "", opts);
	throw new Error("File is password-protected");
}

function write_zip_xlsb(wb, opts) {
	if(wb && !wb.SSF) {
		wb.SSF = dup(table_fmt);
	}
	if(wb && wb.SSF) {
		make_ssf(); SSF_load_table(wb.SSF);
		// $FlowIgnore
		opts.revssf = evert_num(wb.SSF); opts.revssf[wb.SSF[65535]] = 0;
		opts.ssf = wb.SSF;
	}
	opts.rels = {}; opts.wbrels = {};
	opts.Strings = []; opts.Strings.Count = 0; opts.Strings.Unique = 0;
	if(browser_has_Map) opts.revStrings = new Map();
	else { opts.revStrings = {}; opts.revStrings.foo = []; delete opts.revStrings.foo; }
	var wbext = "bin";
	var vbafmt = true;
	var ct = new_ct();
	fix_write_opts(opts = opts || {});
	var zip = zip_new();
	var f = "", rId = 0;

	opts.cellXfs = [];
	get_cell_style(opts.cellXfs, {}, {revssf:{"General":0}});

	if(!wb.Props) wb.Props = {};

	f = "docProps/core.xml";
	zip_add_file(zip, f, write_core_props(wb.Props, opts));
	ct.coreprops.push(f);
	add_rels(opts.rels, 2, f, RELS.CORE_PROPS);

f = "docProps/app.xml";
	if(wb.Props && wb.Props.SheetNames){/* empty */}
	else if(!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
	else {
		var _sn = [];
		for(var _i = 0; _i < wb.SheetNames.length; ++_i)
			if((wb.Workbook.Sheets[_i]||{}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
		wb.Props.SheetNames = _sn;
	}
	wb.Props.Worksheets = wb.Props.SheetNames.length;
	zip_add_file(zip, f, write_ext_props(wb.Props, opts));
	ct.extprops.push(f);
	add_rels(opts.rels, 3, f, RELS.EXT_PROPS);

	if(wb.Custprops !== wb.Props && keys(wb.Custprops||{}).length > 0) {
		f = "docProps/custom.xml";
		zip_add_file(zip, f, write_cust_props(wb.Custprops, opts));
		ct.custprops.push(f);
		add_rels(opts.rels, 4, f, RELS.CUST_PROPS);
	}

	for(rId=1;rId <= wb.SheetNames.length; ++rId) {
		var wsrels = {'!id':{}};
		var ws = wb.Sheets[wb.SheetNames[rId-1]];
		var _type = (ws || {})["!type"] || "sheet";
		switch(_type) {
		case "chart":
			/* falls through */
		default:
			f = "xl/worksheets/sheet" + rId + "." + wbext;
			zip_add_file(zip, f, write_ws_bin(rId-1, opts, wb, wsrels));
			ct.sheets.push(f);
			add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, RELS.WS[0]);
		}

		if(ws) {
			var comments = ws['!comments'];
			var need_vml = false;
			var cf = "";
			if(comments && comments.length > 0) {
				cf = "xl/comments" + rId + "." + wbext;
				zip_add_file(zip, cf, write_comments_bin(comments, opts));
				ct.comments.push(cf);
				add_rels(wsrels, -1, "../comments" + rId + "." + wbext, RELS.CMNT);
				need_vml = true;
			}
			if(ws['!legacy']) {
				if(need_vml) zip_add_file(zip, "xl/drawings/vmlDrawing" + (rId) + ".vml", write_vml(rId, ws['!comments']));
			}
			delete ws['!comments'];
			delete ws['!legacy'];
		}

		if(wsrels['!id'].rId1) zip_add_file(zip, get_rels_path(f), write_rels(wsrels));
	}

	if(opts.Strings != null && opts.Strings.length > 0) {
		f = "xl/sharedStrings." + wbext;
		zip_add_file(zip, f, write_sst_bin(opts.Strings, opts));
		ct.strs.push(f);
		add_rels(opts.wbrels, -1, "sharedStrings." + wbext, RELS.SST);
	}

	f = "xl/workbook." + wbext;
	zip_add_file(zip, f, write_wb_bin(wb, opts));
	ct.workbooks.push(f);
	add_rels(opts.rels, 1, f, RELS.WB);

	/* TODO: something more intelligent with themes */

	f = "xl/theme/theme1.xml";
	var ww = write_theme(wb.Themes, opts);
	zip_add_file(zip, f, ww);
	ct.themes.push(f);
	add_rels(opts.wbrels, -1, "theme/theme1.xml", RELS.THEME);

	/* TODO: something more intelligent with styles */

	f = "xl/styles." + wbext;
	zip_add_file(zip, f, write_sty_bin(wb, opts));
	ct.styles.push(f);
	add_rels(opts.wbrels, -1, "styles." + wbext, RELS.STY);

	if(wb.vbaraw && vbafmt) {
		f = "xl/vbaProject.bin";
		zip_add_file(zip, f, wb.vbaraw);
		ct.vba.push(f);
		add_rels(opts.wbrels, -1, "vbaProject.bin", RELS.VBA);
	}

	f = "xl/metadata." + wbext;
	zip_add_file(zip, f, write_xlmeta_bin());
	ct.metadata.push(f);
	add_rels(opts.wbrels, -1, "metadata." + wbext, RELS.XLMETA);

	zip_add_file(zip, "[Content_Types].xml", write_ct(ct, opts));
	zip_add_file(zip, '_rels/.rels', write_rels(opts.rels));
	zip_add_file(zip, 'xl/_rels/workbook.' + wbext + '.rels', write_rels(opts.wbrels));

	delete opts.revssf; delete opts.ssf;
	return zip;
}

function write_zip_xlsx(wb, opts) {
	if(wb && !wb.SSF) {
		wb.SSF = dup(table_fmt);
	}
	if(wb && wb.SSF) {
		make_ssf(); SSF_load_table(wb.SSF);
		// $FlowIgnore
		opts.revssf = evert_num(wb.SSF); opts.revssf[wb.SSF[65535]] = 0;
		opts.ssf = wb.SSF;
	}
	opts.rels = {}; opts.wbrels = {};
	opts.Strings = []; opts.Strings.Count = 0; opts.Strings.Unique = 0;
	if(browser_has_Map) opts.revStrings = new Map();
	else { opts.revStrings = {}; opts.revStrings.foo = []; delete opts.revStrings.foo; }
	var wbext = "xml";
	var vbafmt = VBAFMTS.indexOf(opts.bookType) > -1;
	var ct = new_ct();
	fix_write_opts(opts = opts || {});
	var zip = zip_new();
	var f = "", rId = 0;

	opts.cellXfs = [];
	get_cell_style(opts.cellXfs, {}, {revssf:{"General":0}});

	if(!wb.Props) wb.Props = {};

	f = "docProps/core.xml";
	zip_add_file(zip, f, write_core_props(wb.Props, opts));
	ct.coreprops.push(f);
	add_rels(opts.rels, 2, f, RELS.CORE_PROPS);

f = "docProps/app.xml";
	if(wb.Props && wb.Props.SheetNames){/* empty */}
	else if(!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
	else {
		var _sn = [];
		for(var _i = 0; _i < wb.SheetNames.length; ++_i)
			if((wb.Workbook.Sheets[_i]||{}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
		wb.Props.SheetNames = _sn;
	}
	wb.Props.Worksheets = wb.Props.SheetNames.length;
	zip_add_file(zip, f, write_ext_props(wb.Props, opts));
	ct.extprops.push(f);
	add_rels(opts.rels, 3, f, RELS.EXT_PROPS);

	if(wb.Custprops !== wb.Props && keys(wb.Custprops||{}).length > 0) {
		f = "docProps/custom.xml";
		zip_add_file(zip, f, write_cust_props(wb.Custprops, opts));
		ct.custprops.push(f);
		add_rels(opts.rels, 4, f, RELS.CUST_PROPS);
	}

	var people = ["SheetJ5"];
	opts.tcid = 0;

	for(rId=1;rId <= wb.SheetNames.length; ++rId) {
		var wsrels = {'!id':{}};
		var ws = wb.Sheets[wb.SheetNames[rId-1]];
		var _type = (ws || {})["!type"] || "sheet";
		switch(_type) {
		case "chart":
			/* falls through */
		default:
			f = "xl/worksheets/sheet" + rId + "." + wbext;
			zip_add_file(zip, f, write_ws_xml(rId-1, opts, wb, wsrels));
			ct.sheets.push(f);
			add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, RELS.WS[0]);
		}

		if(ws) {
			var comments = ws['!comments'];
			var need_vml = false;
			var cf = "";
			if(comments && comments.length > 0) {
				var needtc = false;
				comments.forEach(function(carr) {
					carr[1].forEach(function(c) { if(c.T == true) needtc = true; });
				});
				if(needtc) {
					cf = "xl/threadedComments/threadedComment" + rId + ".xml";
					zip_add_file(zip, cf, write_tcmnt_xml(comments, people, opts));
					ct.threadedcomments.push(cf);
					add_rels(wsrels, -1, "../threadedComments/threadedComment" + rId + ".xml", RELS.TCMNT);
				}

				cf = "xl/comments" + rId + "." + wbext;
				zip_add_file(zip, cf, write_comments_xml(comments, opts));
				ct.comments.push(cf);
				add_rels(wsrels, -1, "../comments" + rId + "." + wbext, RELS.CMNT);
				need_vml = true;
			}
			if(ws['!legacy']) {
				if(need_vml) zip_add_file(zip, "xl/drawings/vmlDrawing" + (rId) + ".vml", write_vml(rId, ws['!comments']));
			}
			delete ws['!comments'];
			delete ws['!legacy'];
		}

		if(wsrels['!id'].rId1) zip_add_file(zip, get_rels_path(f), write_rels(wsrels));
	}

	if(opts.Strings != null && opts.Strings.length > 0) {
		f = "xl/sharedStrings." + wbext;
		zip_add_file(zip, f, write_sst_xml(opts.Strings, opts));
		ct.strs.push(f);
		add_rels(opts.wbrels, -1, "sharedStrings." + wbext, RELS.SST);
	}

	f = "xl/workbook." + wbext;
	zip_add_file(zip, f, write_wb_xml(wb, opts));
	ct.workbooks.push(f);
	add_rels(opts.rels, 1, f, RELS.WB);

	/* TODO: something more intelligent with themes */

	f = "xl/theme/theme1.xml";
	zip_add_file(zip, f, write_theme(wb.Themes, opts));
	ct.themes.push(f);
	add_rels(opts.wbrels, -1, "theme/theme1.xml", RELS.THEME);

	/* TODO: something more intelligent with styles */

	f = "xl/styles." + wbext;
	zip_add_file(zip, f, write_sty_xml(wb, opts));
	ct.styles.push(f);
	add_rels(opts.wbrels, -1, "styles." + wbext, RELS.STY);

	if(wb.vbaraw && vbafmt) {
		f = "xl/vbaProject.bin";
		zip_add_file(zip, f, wb.vbaraw);
		ct.vba.push(f);
		add_rels(opts.wbrels, -1, "vbaProject.bin", RELS.VBA);
	}

	f = "xl/metadata." + wbext;
	zip_add_file(zip, f, write_xlmeta_xml());
	ct.metadata.push(f);
	add_rels(opts.wbrels, -1, "metadata." + wbext, RELS.XLMETA);

	if(people.length > 1) {
		f = "xl/persons/person.xml";
		zip_add_file(zip, f, write_people_xml(people, opts));
		ct.people.push(f);
		add_rels(opts.wbrels, -1, "persons/person.xml", RELS.PEOPLE);
	}

	zip_add_file(zip, "[Content_Types].xml", write_ct(ct, opts));
	zip_add_file(zip, '_rels/.rels', write_rels(opts.rels));
	zip_add_file(zip, 'xl/_rels/workbook.' + wbext + '.rels', write_rels(opts.wbrels));

	delete opts.revssf; delete opts.ssf;
	return zip;
}

function firstbyte(f,o) {
	var x = "";
	switch((o||{}).type || "base64") {
		case 'buffer': return [f[0], f[1], f[2], f[3], f[4], f[5], f[6], f[7]];
		case 'base64': x = Base64_decode(f.slice(0,12)); break;
		case 'binary': x = f; break;
		case 'array':  return [f[0], f[1], f[2], f[3], f[4], f[5], f[6], f[7]];
		default: throw new Error("Unrecognized type " + (o && o.type || "undefined"));
	}
	return [x.charCodeAt(0), x.charCodeAt(1), x.charCodeAt(2), x.charCodeAt(3), x.charCodeAt(4), x.charCodeAt(5), x.charCodeAt(6), x.charCodeAt(7)];
}

function read_cfb(cfb, opts) {
	if(CFB.find(cfb, "EncryptedPackage")) return parse_xlsxcfb(cfb, opts);
	return parse_xlscfb(cfb, opts);
}

function read_zip(data, opts) {
	var zip, d = data;
	var o = opts||{};
	if(!o.type) o.type = (has_buf && Buffer.isBuffer(data)) ? "buffer" : "base64";
	zip = zip_read(d, o);
	return parse_zip(zip, o);
}

function read_plaintext(data, o) {
	var i = 0;
	main: while(i < data.length) switch(data.charCodeAt(i)) {
		case 0x0A: case 0x0D: case 0x20: ++i; break;
		case 0x3C: return parse_xlml(data.slice(i),o);
		default: break main;
	}
	return PRN.to_workbook(data, o);
}

function read_plaintext_raw(data, o) {
	var str = "", bytes = firstbyte(data, o);
	switch(o.type) {
		case 'base64': str = Base64_decode(data); break;
		case 'binary': str = data; break;
		case 'buffer': str = data.toString('binary'); break;
		case 'array': str = cc2str(data); break;
		default: throw new Error("Unrecognized type " + o.type);
	}
	if(bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = utf8read(str);
	o.type = "binary";
	return read_plaintext(str, o);
}

function read_utf16(data, o) {
	var d = data;
	if(o.type == 'base64') d = Base64_decode(d);
	d = typeof $cptable !== "undefined" ? $cptable.utils.decode(1200, d.slice(2), 'str') : utf16leread(d.slice(2));
	o.type = "binary";
	return read_plaintext(d, o);
}

function bstrify(data) {
	return !data.match(/[^\x00-\x7F]/) ? data : utf8write(data);
}

function read_prn(data, d, o, str) {
	if(str) { o.type = "string"; return PRN.to_workbook(data, o); }
	return PRN.to_workbook(d, o);
}

function readSync(data, opts) {
	reset_cp();
	var o = opts||{};
	if(o.codepage && typeof $cptable === "undefined") console.error("Codepage tables are not loaded.  Non-ASCII characters may not give expected results");
	if(typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) return readSync(new Uint8Array(data), (o = dup(o), o.type = "array", o));
	if(typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && !o.type) o.type = typeof Deno !== "undefined" ? "buffer" : "array";
	var d = data, n = [0,0,0,0], str = false;
	if(o.cellStyles) { o.cellNF = true; o.sheetStubs = true; }
	_ssfopts = {};
	if(o.dateNF) _ssfopts.dateNF = o.dateNF;
	if(!o.type) o.type = (has_buf && Buffer.isBuffer(data)) ? "buffer" : "base64";
	if(o.type == "file") { o.type = has_buf ? "buffer" : "binary"; d = read_binary(data); if(typeof Uint8Array !== 'undefined' && !has_buf) o.type = "array"; }
	if(o.type == "string") { str = true; o.type = "binary"; o.codepage = 65001; d = bstrify(data); }
	if(o.type == 'array' && typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && typeof ArrayBuffer !== 'undefined') {
		// $FlowIgnore
		var ab=new ArrayBuffer(3), vu=new Uint8Array(ab); vu.foo="bar";
		// $FlowIgnore
		if(!vu.foo) {o=dup(o); o.type='array'; return readSync(ab2a(d), o);}
	}
	switch((n = firstbyte(d, o))[0]) {
		case 0xD0: if(n[1] === 0xCF && n[2] === 0x11 && n[3] === 0xE0 && n[4] === 0xA1 && n[5] === 0xB1 && n[6] === 0x1A && n[7] === 0xE1) return read_cfb(CFB.read(d, o), o); break;
		case 0x09: if(n[1] <= 0x08) return parse_xlscfb(d, o); break;
		case 0x3C: return parse_xlml(d, o);
		case 0x49:
			if(n[1] === 0x49 && n[2] === 0x2a && n[3] === 0x00) throw new Error("TIFF Image File is not a spreadsheet");
			if(n[1] === 0x44) return read_wb_ID(d, o);
			break;
		case 0x54: if(n[1] === 0x41 && n[2] === 0x42 && n[3] === 0x4C) return DIF.to_workbook(d, o); break;
		case 0x50: return (n[1] === 0x4B && n[2] < 0x09 && n[3] < 0x09) ? read_zip(d, o) : read_prn(data, d, o, str);
		case 0xEF: return n[3] === 0x3C ? parse_xlml(d, o) : read_prn(data, d, o, str);
		case 0xFF:
			if(n[1] === 0xFE) { return read_utf16(d, o); }
			else if(n[1] === 0x00 && n[2] === 0x02 && n[3] === 0x00) return WK_.to_workbook(d, o);
			break;
		case 0x00:
			if(n[1] === 0x00) {
				if(n[2] >= 0x02 && n[3] === 0x00) return WK_.to_workbook(d, o);
				if(n[2] === 0x00 && (n[3] === 0x08 || n[3] === 0x09)) return WK_.to_workbook(d, o);
			}
			break;
		case 0x03: case 0x83: case 0x8B: case 0x8C: return DBF.to_workbook(d, o);
		case 0x7B: if(n[1] === 0x5C && n[2] === 0x72 && n[3] === 0x74) return rtf_to_workbook(d, o); break;
		case 0x0A: case 0x0D: case 0x20: return read_plaintext_raw(d, o);
		case 0x89: if(n[1] === 0x50 && n[2] === 0x4E && n[3] === 0x47) throw new Error("PNG Image File is not a spreadsheet"); break;
		case 0x08: if(n[1] === 0xE7) throw new Error("Unsupported Multiplan 1.x file!"); break;
		case 0x0C:
			if(n[1] === 0xEC) throw new Error("Unsupported Multiplan 2.x file!");
			if(n[1] === 0xED) throw new Error("Unsupported Multiplan 3.x file!");
			break;
	}
	if(DBF_SUPPORTED_VERSIONS.indexOf(n[0]) > -1 && n[2] <= 12 && n[3] <= 31) return DBF.to_workbook(d, o);
	return read_prn(data, d, o, str);
}

function readFileSync(filename, opts) {
	var o = opts||{}; o.type = 'file';
	return readSync(filename, o);
}
function write_cfb_ctr(cfb, o) {
	switch(o.type) {
		case "base64": case "binary": break;
		case "buffer": case "array": o.type = ""; break;
		case "file": return write_dl(o.file, CFB.write(cfb, {type:has_buf ? 'buffer' : ""}));
		case "string": throw new Error("'string' output type invalid for '" + o.bookType + "' files");
		default: throw new Error("Unrecognized type " + o.type);
	}
	return CFB.write(cfb, o);
}

function write_zip(wb, opts) {
	switch(opts.bookType) {
		case "ods": return write_ods(wb, opts);
		case "numbers": return write_numbers_iwa(wb, opts);
		case "xlsb": return write_zip_xlsb(wb, opts);
		default: return write_zip_xlsx(wb, opts);
	}
}

function write_zip_type(wb, opts) {
	var o = dup(opts||{});
	var z = write_zip(wb, o);
	return write_zip_denouement(z, o);
}
function write_zip_typeXLSX(wb, opts) {
	var o = dup(opts||{});
	var z = write_zip_xlsx(wb, o);
	return write_zip_denouement(z, o);
}
function write_zip_denouement(z, o) {
	var oopts = {};
	var ftype = has_buf ? "nodebuffer" : (typeof Uint8Array !== "undefined" ? "array" : "string");
	if(o.compression) oopts.compression = 'DEFLATE';
	if(o.password) oopts.type = ftype;
	else switch(o.type) {
		case "base64": oopts.type = "base64"; break;
		case "binary": oopts.type = "string"; break;
		case "string": throw new Error("'string' output type invalid for '" + o.bookType + "' files");
		case "buffer":
		case "file": oopts.type = ftype; break;
		default: throw new Error("Unrecognized type " + o.type);
	}
	var out = z.FullPaths ? CFB.write(z, {fileType:"zip", type: {"nodebuffer": "buffer", "string": "binary"}[oopts.type] || oopts.type, compression: !!o.compression}) : z.generate(oopts);
	if(typeof Deno !== "undefined") {
		if(typeof out == "string") {
			if(o.type == "binary" || o.type == "base64") return out;
			out = new Uint8Array(s2ab(out));
		}
	}
/*jshint -W083 */
	if(o.password && typeof encrypt_agile !== 'undefined') return write_cfb_ctr(encrypt_agile(out, o.password), o); // eslint-disable-line no-undef
/*jshint +W083 */
	if(o.type === "file") return write_dl(o.file, out);
	return o.type == "string" ? utf8read(out) : out;
}

function write_cfb_type(wb, opts) {
	var o = opts||{};
	var cfb = write_xlscfb(wb, o);
	return write_cfb_ctr(cfb, o);
}

function write_string_type(out, opts, bom) {
	if(!bom) bom = "";
	var o = bom + out;
	switch(opts.type) {
		case "base64": return Base64_encode(utf8write(o));
		case "binary": return utf8write(o);
		case "string": return out;
		case "file": return write_dl(opts.file, o, 'utf8');
		case "buffer": {
			if(has_buf) return Buffer_from(o, 'utf8');
			else if(typeof TextEncoder !== "undefined") return new TextEncoder().encode(o);
			else return write_string_type(o, {type:'binary'}).split("").map(function(c) { return c.charCodeAt(0); });
		}
	}
	throw new Error("Unrecognized type " + opts.type);
}

function write_stxt_type(out, opts) {
	switch(opts.type) {
		case "base64": return Base64_encode_pass(out);
		case "binary": return out;
		case "string": return out; /* override in sheet_to_txt */
		case "file": return write_dl(opts.file, out, 'binary');
		case "buffer": {
			if(has_buf) return Buffer_from(out, 'binary');
			else return out.split("").map(function(c) { return c.charCodeAt(0); });
		}
	}
	throw new Error("Unrecognized type " + opts.type);
}

/* TODO: test consistency */
function write_binary_type(out, opts) {
	switch(opts.type) {
		case "string":
		case "base64":
		case "binary":
			var bstr = "";
			// $FlowIgnore
			for(var i = 0; i < out.length; ++i) bstr += String.fromCharCode(out[i]);
			return opts.type == 'base64' ? Base64_encode(bstr) : opts.type == 'string' ? utf8read(bstr) : bstr;
		case "file": return write_dl(opts.file, out);
		case "buffer": return out;
		default: throw new Error("Unrecognized type " + opts.type);
	}
}

function writeSyncXLSX(wb, opts) {
	reset_cp();
	check_wb(wb);
	var o = dup(opts||{});
	if(o.cellStyles) { o.cellNF = true; o.sheetStubs = true; }
	if(o.type == "array") { o.type = "binary"; var out = (writeSyncXLSX(wb, o)); o.type = "array"; return s2ab(out); }
	return write_zip_typeXLSX(wb, o);
}

function writeSync(wb, opts) {
	reset_cp();
	check_wb(wb);
	var o = dup(opts||{});
	if(o.cellStyles) { o.cellNF = true; o.sheetStubs = true; }
	if(o.type == "array") { o.type = "binary"; var out = (writeSync(wb, o)); o.type = "array"; return s2ab(out); }
	var idx = 0;
	if(o.sheet) {
		if(typeof o.sheet == "number") idx = o.sheet;
		else idx = wb.SheetNames.indexOf(o.sheet);
		if(!wb.SheetNames[idx]) throw new Error("Sheet not found: " + o.sheet + " : " + (typeof o.sheet));
	}
	switch(o.bookType || 'xlsb') {
		case 'xml':
		case 'xlml': return write_string_type(write_xlml(wb, o), o);
		case 'slk':
		case 'sylk': return write_string_type(SYLK.from_sheet(wb.Sheets[wb.SheetNames[idx]], o, wb), o);
		case 'htm':
		case 'html': return write_string_type(sheet_to_html(wb.Sheets[wb.SheetNames[idx]], o), o);
		case 'txt': return write_stxt_type(sheet_to_txt(wb.Sheets[wb.SheetNames[idx]], o), o);
		case 'csv': return write_string_type(sheet_to_csv(wb.Sheets[wb.SheetNames[idx]], o), o, "\ufeff");
		case 'dif': return write_string_type(DIF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
		case 'dbf': return write_binary_type(DBF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
		case 'prn': return write_string_type(PRN.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
		case 'rtf': return write_string_type(sheet_to_rtf(wb.Sheets[wb.SheetNames[idx]], o), o);
		case 'eth': return write_string_type(ETH.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
		case 'fods': return write_string_type(write_ods(wb, o), o);
		case 'wk1': return write_binary_type(WK_.sheet_to_wk1(wb.Sheets[wb.SheetNames[idx]], o), o);
		case 'wk3': return write_binary_type(WK_.book_to_wk3(wb, o), o);
		case 'biff2': if(!o.biff) o.biff = 2; /* falls through */
		case 'biff3': if(!o.biff) o.biff = 3; /* falls through */
		case 'biff4': if(!o.biff) o.biff = 4; return write_binary_type(write_biff_buf(wb, o), o);
		case 'biff5': if(!o.biff) o.biff = 5; /* falls through */
		case 'biff8':
		case 'xla':
		case 'xls': if(!o.biff) o.biff = 8; return write_cfb_type(wb, o);
		case 'xlsx':
		case 'xlsm':
		case 'xlam':
		case 'xlsb':
		case 'numbers':
		case 'ods': return write_zip_type(wb, o);
		default: throw new Error ("Unrecognized bookType |" + o.bookType + "|");
	}
}

function resolve_book_type(o) {
	if(o.bookType) return;
	var _BT = {
		"xls": "biff8",
		"htm": "html",
		"slk": "sylk",
		"socialcalc": "eth",
		"Sh33tJS": "WTF"
	};
	var ext = o.file.slice(o.file.lastIndexOf(".")).toLowerCase();
	if(ext.match(/^\.[a-z]+$/)) o.bookType = ext.slice(1);
	o.bookType = _BT[o.bookType] || o.bookType;
}

function writeFileSync(wb, filename, opts) {
	var o = opts||{}; o.type = 'file';
	o.file = filename;
	resolve_book_type(o);
	return writeSync(wb, o);
}

function writeFileSyncXLSX(wb, filename, opts) {
	var o = opts||{}; o.type = 'file';
	o.file = filename;
	resolve_book_type(o);
	return writeSyncXLSX(wb, o);
}


function writeFileAsync(filename, wb, opts, cb) {
	var o = opts||{}; o.type = 'file';
	o.file = filename;
	resolve_book_type(o);
	o.type = 'buffer';
	var _cb = cb; if(!(_cb instanceof Function)) _cb = (opts);
	return _fs.writeFile(filename, writeSync(wb, o), _cb);
}
function make_json_row(sheet, r, R, cols, header, hdr, dense, o) {
	var rr = encode_row(R);
	var defval = o.defval, raw = o.raw || !Object.prototype.hasOwnProperty.call(o, "raw");
	var isempty = true;
	var row = (header === 1) ? [] : {};
	if(header !== 1) {
		if(Object.defineProperty) try { Object.defineProperty(row, '__rowNum__', {value:R, enumerable:false}); } catch(e) { row.__rowNum__ = R; }
		else row.__rowNum__ = R;
	}
	if(!dense || sheet[R]) for (var C = r.s.c; C <= r.e.c; ++C) {
		var val = dense ? sheet[R][C] : sheet[cols[C] + rr];
		if(val === undefined || val.t === undefined) {
			if(defval === undefined) continue;
			if(hdr[C] != null) { row[hdr[C]] = defval; }
			continue;
		}
		var v = val.v;
		switch(val.t){
			case 'z': if(v == null) break; continue;
			case 'e': v = (v == 0 ? null : void 0); break;
			case 's': case 'd': case 'b': case 'n': break;
			default: throw new Error('unrecognized type ' + val.t);
		}
		if(hdr[C] != null) {
			if(v == null) {
				if(val.t == "e" && v === null) row[hdr[C]] = null;
				else if(defval !== undefined) row[hdr[C]] = defval;
				else if(raw && v === null) row[hdr[C]] = null;
				else continue;
			} else {
				row[hdr[C]] = raw && (val.t !== "n" || (val.t === "n" && o.rawNumbers !== false)) ? v : format_cell(val,v,o);
			}
			if(v != null) isempty = false;
		}
	}
	return { row: row, isempty: isempty };
}


function sheet_to_json(sheet, opts) {
	if(sheet == null || sheet["!ref"] == null) return [];
	var val = {t:'n',v:0}, header = 0, offset = 1, hdr = [], v=0, vv="";
	var r = {s:{r:0,c:0},e:{r:0,c:0}};
	var o = opts || {};
	var range = o.range != null ? o.range : sheet["!ref"];
	if(o.header === 1) header = 1;
	else if(o.header === "A") header = 2;
	else if(Array.isArray(o.header)) header = 3;
	else if(o.header == null) header = 0;
	switch(typeof range) {
		case 'string': r = safe_decode_range(range); break;
		case 'number': r = safe_decode_range(sheet["!ref"]); r.s.r = range; break;
		default: r = range;
	}
	if(header > 0) offset = 0;
	var rr = encode_row(r.s.r);
	var cols = [];
	var out = [];
	var outi = 0, counter = 0;
	var dense = Array.isArray(sheet);
	var R = r.s.r, C = 0;
	var header_cnt = {};
	if(dense && !sheet[R]) sheet[R] = [];
	var colinfo = o.skipHidden && sheet["!cols"] || [];
	var rowinfo = o.skipHidden && sheet["!rows"] || [];
	for(C = r.s.c; C <= r.e.c; ++C) {
		if(((colinfo[C]||{}).hidden)) continue;
		cols[C] = encode_col(C);
		val = dense ? sheet[R][C] : sheet[cols[C] + rr];
		switch(header) {
			case 1: hdr[C] = C - r.s.c; break;
			case 2: hdr[C] = cols[C]; break;
			case 3: hdr[C] = o.header[C - r.s.c]; break;
			default:
				if(val == null) val = {w: "__EMPTY", t: "s"};
				vv = v = format_cell(val, null, o);
				counter = header_cnt[v] || 0;
				if(!counter) header_cnt[v] = 1;
				else {
					do { vv = v + "_" + (counter++); } while(header_cnt[vv]); header_cnt[v] = counter;
					header_cnt[vv] = 1;
				}
				hdr[C] = vv;
		}
	}
	for (R = r.s.r + offset; R <= r.e.r; ++R) {
		if ((rowinfo[R]||{}).hidden) continue;
		var row = make_json_row(sheet, r, R, cols, header, hdr, dense, o);
		if((row.isempty === false) || (header === 1 ? o.blankrows !== false : !!o.blankrows)) out[outi++] = row.row;
	}
	out.length = outi;
	return out;
}

var qreg = /"/g;
function make_csv_row(sheet, r, R, cols, fs, rs, FS, o) {
	var isempty = true;
	var row = [], txt = "", rr = encode_row(R);
	for(var C = r.s.c; C <= r.e.c; ++C) {
		if (!cols[C]) continue;
		var val = o.dense ? (sheet[R]||[])[C]: sheet[cols[C] + rr];
		if(val == null) txt = "";
		else if(val.v != null) {
			isempty = false;
			txt = ''+(o.rawNumbers && val.t == "n" ? val.v : format_cell(val, null, o));
			for(var i = 0, cc = 0; i !== txt.length; ++i) if((cc = txt.charCodeAt(i)) === fs || cc === rs || cc === 34 || o.forceQuotes) {txt = "\"" + txt.replace(qreg, '""') + "\""; break; }
			if(txt == "ID") txt = '"ID"';
		} else if(val.f != null && !val.F) {
			isempty = false;
			txt = '=' + val.f; if(txt.indexOf(",") >= 0) txt = '"' + txt.replace(qreg, '""') + '"';
		} else txt = "";
		/* NOTE: Excel CSV does not support array formulae */
		row.push(txt);
	}
	if(o.blankrows === false && isempty) return null;
	return row.join(FS);
}

function sheet_to_csv(sheet, opts) {
	var out = [];
	var o = opts == null ? {} : opts;
	if(sheet == null || sheet["!ref"] == null) return "";
	var r = safe_decode_range(sheet["!ref"]);
	var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
	var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
	var endregex = new RegExp((FS=="|" ? "\\|" : FS)+"+$");
	var row = "", cols = [];
	o.dense = Array.isArray(sheet);
	var colinfo = o.skipHidden && sheet["!cols"] || [];
	var rowinfo = o.skipHidden && sheet["!rows"] || [];
	for(var C = r.s.c; C <= r.e.c; ++C) if (!((colinfo[C]||{}).hidden)) cols[C] = encode_col(C);
	var w = 0;
	for(var R = r.s.r; R <= r.e.r; ++R) {
		if ((rowinfo[R]||{}).hidden) continue;
		row = make_csv_row(sheet, r, R, cols, fs, rs, FS, o);
		if(row == null) { continue; }
		if(o.strip) row = row.replace(endregex,"");
		if(row || (o.blankrows !== false)) out.push((w++ ? RS : "") + row);
	}
	delete o.dense;
	return out.join("");
}

function sheet_to_txt(sheet, opts) {
	if(!opts) opts = {}; opts.FS = "\t"; opts.RS = "\n";
	var s = sheet_to_csv(sheet, opts);
	if(typeof $cptable == 'undefined' || opts.type == 'string') return s;
	var o = $cptable.utils.encode(1200, s, 'str');
	return String.fromCharCode(255) + String.fromCharCode(254) + o;
}

function sheet_to_formulae(sheet) {
	var y = "", x, val="";
	if(sheet == null || sheet["!ref"] == null) return [];
	var r = safe_decode_range(sheet['!ref']), rr = "", cols = [], C;
	var cmds = [];
	var dense = Array.isArray(sheet);
	for(C = r.s.c; C <= r.e.c; ++C) cols[C] = encode_col(C);
	for(var R = r.s.r; R <= r.e.r; ++R) {
		rr = encode_row(R);
		for(C = r.s.c; C <= r.e.c; ++C) {
			y = cols[C] + rr;
			x = dense ? (sheet[R]||[])[C] : sheet[y];
			val = "";
			if(x === undefined) continue;
			else if(x.F != null) {
				y = x.F;
				if(!x.f) continue;
				val = x.f;
				if(y.indexOf(":") == -1) y = y + ":" + y;
			}
			if(x.f != null) val = x.f;
			else if(x.t == 'z') continue;
			else if(x.t == 'n' && x.v != null) val = "" + x.v;
			else if(x.t == 'b') val = x.v ? "TRUE" : "FALSE";
			else if(x.w !== undefined) val = "'" + x.w;
			else if(x.v === undefined) continue;
			else if(x.t == 's') val = "'" + x.v;
			else val = ""+x.v;
			cmds[cmds.length] = y + "=" + val;
		}
	}
	return cmds;
}

function sheet_add_json(_ws, js, opts) {
	var o = opts || {};
	var dense = _ws ? Array.isArray(_ws) : o.dense;
	if(DENSE != null && dense == null) dense = DENSE;
	var offset = +!o.skipHeader;
	var ws = _ws || (dense ? ([]) : ({}));
	var _R = 0, _C = 0;
	if(ws && o.origin != null) {
		if(typeof o.origin == 'number') _R = o.origin;
		else {
			var _origin = typeof o.origin == "string" ? decode_cell(o.origin) : o.origin;
			_R = _origin.r; _C = _origin.c;
		}
	}
	var range = ({s: {c:0, r:0}, e: {c:_C, r:_R + js.length - 1 + offset}});
	if(ws['!ref']) {
		var _range = safe_decode_range(ws['!ref']);
		range.e.c = Math.max(range.e.c, _range.e.c);
		range.e.r = Math.max(range.e.r, _range.e.r);
		if(_R == -1) { _R = _range.e.r + 1; range.e.r = _R + js.length - 1 + offset; }
	} else {
		if(_R == -1) { _R = 0; range.e.r = js.length - 1 + offset; }
	}
	var hdr = o.header || [], C = 0;
	var ROW = [];
	js.forEach(function (JS, R) {
		if(dense && !ws[_R + R + offset]) ws[_R + R + offset] = [];
		if(dense) ROW = ws[_R + R + offset];
		keys(JS).forEach(function(k) {
			if((C=hdr.indexOf(k)) == -1) hdr[C=hdr.length] = k;
			var v = JS[k];
			var t = 'z';
			var z = "";
			var ref = dense ? "" : encode_cell({c:_C + C,r:_R + R + offset});
			var cell = dense ? ROW[_C + C] : ws[ref];
			if(v && typeof v === 'object' && !(v instanceof Date)){
				ws[ref] = v;
			} else {
				if(typeof v == 'number') t = 'n';
				else if(typeof v == 'boolean') t = 'b';
				else if(typeof v == 'string') t = 's';
				else if(v instanceof Date) {
					t = 'd';
					if(!o.cellDates) { t = 'n'; v = datenum(v); }
					z = (cell != null && cell.z && fmt_is_date(cell.z)) ? cell.z : (o.dateNF || table_fmt[14]);
				}
				else if(v === null && o.nullError) { t = 'e'; v = 0; }
				if(!cell) {
					if(!dense) ws[ref] = cell = ({t:t, v:v});
					else ROW[_C + C] = cell = ({t:t, v:v});
				} else {
					cell.t = t; cell.v = v;
					delete cell.w; delete cell.R;
					if(z) cell.z = z;
				}
				if(z) cell.z = z;
			}
		});
	});
	range.e.c = Math.max(range.e.c, _C + hdr.length - 1);
	var __R = encode_row(_R);
	if(dense && !ws[_R]) ws[_R] = [];
	if(offset) for(C = 0; C < hdr.length; ++C) {
		if(dense) ws[_R][C + _C] = {t:'s', v:hdr[C]};
		else ws[encode_col(C + _C) + __R] = {t:'s', v:hdr[C]};
	}
	ws['!ref'] = encode_range(range);
	return ws;
}
function json_to_sheet(js, opts) { return sheet_add_json(null, js, opts); }

/* get cell, creating a stub if necessary */
function ws_get_cell_stub(ws, R, C) {
	/* A1 cell address */
	if(typeof R == "string") {
		/* dense */
		if(Array.isArray(ws)) {
			var RC = decode_cell(R);
			if(!ws[RC.r]) ws[RC.r] = [];
			return ws[RC.r][RC.c] || (ws[RC.r][RC.c] = {t:'z'});
		}
		return ws[R] || (ws[R] = {t:'z'});
	}
	/* cell address object */
	if(typeof R != "number") return ws_get_cell_stub(ws, encode_cell(R));
	/* R and C are 0-based indices */
	return ws_get_cell_stub(ws, encode_cell({r:R,c:C||0}));
}

/* find sheet index for given name / validate index */
function wb_sheet_idx(wb, sh) {
	if(typeof sh == "number") {
		if(sh >= 0 && wb.SheetNames.length > sh) return sh;
		throw new Error("Cannot find sheet # " + sh);
	} else if(typeof sh == "string") {
		var idx = wb.SheetNames.indexOf(sh);
		if(idx > -1) return idx;
		throw new Error("Cannot find sheet name |" + sh + "|");
	} else throw new Error("Cannot find sheet |" + sh + "|");
}

/* simple blank workbook object */
function book_new() {
	return { SheetNames: [], Sheets: {} };
}

/* add a worksheet to the end of a given workbook */
function book_append_sheet(wb, ws, name, roll) {
	var i = 1;
	if(!name) for(; i <= 0xFFFF; ++i, name = undefined) if(wb.SheetNames.indexOf(name = "Sheet" + i) == -1) break;
	if(!name || wb.SheetNames.length >= 0xFFFF) throw new Error("Too many worksheets");
	if(roll && wb.SheetNames.indexOf(name) >= 0) {
		var m = name.match(/(^.*?)(\d+)$/);
		i = m && +m[2] || 0;
		var root = m && m[1] || name;
		for(++i; i <= 0xFFFF; ++i) if(wb.SheetNames.indexOf(name = root + i) == -1) break;
	}
	check_ws_name(name);
	if(wb.SheetNames.indexOf(name) >= 0) throw new Error("Worksheet with name |" + name + "| already exists!");

	wb.SheetNames.push(name);
	wb.Sheets[name] = ws;
	return name;
}

/* set sheet visibility (visible/hidden/very hidden) */
function book_set_sheet_visibility(wb, sh, vis) {
	if(!wb.Workbook) wb.Workbook = {};
	if(!wb.Workbook.Sheets) wb.Workbook.Sheets = [];

	var idx = wb_sheet_idx(wb, sh);
	// $FlowIgnore
	if(!wb.Workbook.Sheets[idx]) wb.Workbook.Sheets[idx] = {};

	switch(vis) {
		case 0: case 1: case 2: break;
		default: throw new Error("Bad sheet visibility setting " + vis);
	}
	// $FlowIgnore
	wb.Workbook.Sheets[idx].Hidden = vis;
}

/* set number format */
function cell_set_number_format(cell, fmt) {
	cell.z = fmt;
	return cell;
}

/* set cell hyperlink */
function cell_set_hyperlink(cell, target, tooltip) {
	if(!target) {
		delete cell.l;
	} else {
		cell.l = ({ Target: target });
		if(tooltip) cell.l.Tooltip = tooltip;
	}
	return cell;
}
function cell_set_internal_link(cell, range, tooltip) { return cell_set_hyperlink(cell, "#" + range, tooltip); }

/* add to cell comments */
function cell_add_comment(cell, text, author) {
	if(!cell.c) cell.c = [];
	cell.c.push({t:text, a:author||"SheetJS"});
}

/* set array formula and flush related cells */
function sheet_set_array_formula(ws, range, formula, dynamic) {
	var rng = typeof range != "string" ? range : safe_decode_range(range);
	var rngstr = typeof range == "string" ? range : encode_range(range);
	for(var R = rng.s.r; R <= rng.e.r; ++R) for(var C = rng.s.c; C <= rng.e.c; ++C) {
		var cell = ws_get_cell_stub(ws, R, C);
		cell.t = 'n';
		cell.F = rngstr;
		delete cell.v;
		if(R == rng.s.r && C == rng.s.c) {
			cell.f = formula;
			if(dynamic) cell.D = true;
		}
	}
	var wsr = decode_range(ws["!ref"]);
	if(wsr.s.r > rng.s.r) wsr.s.r = rng.s.r;
	if(wsr.s.c > rng.s.c) wsr.s.c = rng.s.c;
	if(wsr.e.r < rng.e.r) wsr.e.r = rng.e.r;
	if(wsr.e.c < rng.e.c) wsr.e.c = rng.e.c;
	ws["!ref"] = encode_range(wsr);
	return ws;
}

var utils = {
	encode_col: encode_col,
	encode_row: encode_row,
	encode_cell: encode_cell,
	encode_range: encode_range,
	decode_col: decode_col,
	decode_row: decode_row,
	split_cell: split_cell,
	decode_cell: decode_cell,
	decode_range: decode_range,
	format_cell: format_cell,
	sheet_add_aoa: sheet_add_aoa,
	sheet_add_json: sheet_add_json,
	sheet_add_dom: sheet_add_dom,
	aoa_to_sheet: aoa_to_sheet,
	json_to_sheet: json_to_sheet,
	table_to_sheet: parse_dom_table,
	table_to_book: table_to_book,
	sheet_to_csv: sheet_to_csv,
	sheet_to_txt: sheet_to_txt,
	sheet_to_json: sheet_to_json,
	sheet_to_html: sheet_to_html,
	sheet_to_formulae: sheet_to_formulae,
	sheet_to_row_object_array: sheet_to_json,
	sheet_get_cell: ws_get_cell_stub,
	book_new: book_new,
	book_append_sheet: book_append_sheet,
	book_set_sheet_visibility: book_set_sheet_visibility,
	cell_set_number_format: cell_set_number_format,
	cell_set_hyperlink: cell_set_hyperlink,
	cell_set_internal_link: cell_set_internal_link,
	cell_add_comment: cell_add_comment,
	sheet_set_array_formula: sheet_set_array_formula,
	consts: {
		SHEET_VISIBLE: 0,
		SHEET_HIDDEN: 1,
		SHEET_VERY_HIDDEN: 2
	}
};

var _Readable;
function set_readable(R) { _Readable = R; }

function write_csv_stream(sheet, opts) {
	var stream = _Readable();
	var o = opts == null ? {} : opts;
	if(sheet == null || sheet["!ref"] == null) { stream.push(null); return stream; }
	var r = safe_decode_range(sheet["!ref"]);
	var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
	var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
	var endregex = new RegExp((FS=="|" ? "\\|" : FS)+"+$");
	var row = "", cols = [];
	o.dense = Array.isArray(sheet);
	var colinfo = o.skipHidden && sheet["!cols"] || [];
	var rowinfo = o.skipHidden && sheet["!rows"] || [];
	for(var C = r.s.c; C <= r.e.c; ++C) if (!((colinfo[C]||{}).hidden)) cols[C] = encode_col(C);
	var R = r.s.r;
	var BOM = false, w = 0;
	stream._read = function() {
		if(!BOM) { BOM = true; return stream.push("\uFEFF"); }
		while(R <= r.e.r) {
			++R;
			if ((rowinfo[R-1]||{}).hidden) continue;
			row = make_csv_row(sheet, r, R-1, cols, fs, rs, FS, o);
			if(row != null) {
				if(o.strip) row = row.replace(endregex,"");
				if(row || (o.blankrows !== false)) return stream.push((w++ ? RS : "") + row);
			}
		}
		return stream.push(null);
	};
	return stream;
}

function write_html_stream(ws, opts) {
	var stream = _Readable();

	var o = opts || {};
	var header = o.header != null ? o.header : HTML_BEGIN;
	var footer = o.footer != null ? o.footer : HTML_END;
	stream.push(header);
	var r = decode_range(ws['!ref']);
	o.dense = Array.isArray(ws);
	stream.push(make_html_preamble(ws, r, o));
	var R = r.s.r;
	var end = false;
	stream._read = function() {
		if(R > r.e.r) {
			if(!end) { end = true; stream.push("</table>" + footer); }
			return stream.push(null);
		}
		while(R <= r.e.r) {
			stream.push(make_html_row(ws, r, R, o));
			++R;
			break;
		}
	};
	return stream;
}

function write_json_stream(sheet, opts) {
	var stream = _Readable({objectMode:true});

	if(sheet == null || sheet["!ref"] == null) { stream.push(null); return stream; }
	var val = {t:'n',v:0}, header = 0, offset = 1, hdr = [], v=0, vv="";
	var r = {s:{r:0,c:0},e:{r:0,c:0}};
	var o = opts || {};
	var range = o.range != null ? o.range : sheet["!ref"];
	if(o.header === 1) header = 1;
	else if(o.header === "A") header = 2;
	else if(Array.isArray(o.header)) header = 3;
	switch(typeof range) {
		case 'string': r = safe_decode_range(range); break;
		case 'number': r = safe_decode_range(sheet["!ref"]); r.s.r = range; break;
		default: r = range;
	}
	if(header > 0) offset = 0;
	var rr = encode_row(r.s.r);
	var cols = [];
	var counter = 0;
	var dense = Array.isArray(sheet);
	var R = r.s.r, C = 0;
	var header_cnt = {};
	if(dense && !sheet[R]) sheet[R] = [];
	var colinfo = o.skipHidden && sheet["!cols"] || [];
	var rowinfo = o.skipHidden && sheet["!rows"] || [];
	for(C = r.s.c; C <= r.e.c; ++C) {
		if(((colinfo[C]||{}).hidden)) continue;
		cols[C] = encode_col(C);
		val = dense ? sheet[R][C] : sheet[cols[C] + rr];
		switch(header) {
			case 1: hdr[C] = C - r.s.c; break;
			case 2: hdr[C] = cols[C]; break;
			case 3: hdr[C] = o.header[C - r.s.c]; break;
			default:
				if(val == null) val = {w: "__EMPTY", t: "s"};
				vv = v = format_cell(val, null, o);
				counter = header_cnt[v] || 0;
				if(!counter) header_cnt[v] = 1;
				else {
					do { vv = v + "_" + (counter++); } while(header_cnt[vv]); header_cnt[v] = counter;
					header_cnt[vv] = 1;
				}
				hdr[C] = vv;
		}
	}
	R = r.s.r + offset;
	stream._read = function() {
		while(R <= r.e.r) {
			if ((rowinfo[R-1]||{}).hidden) continue;
			var row = make_json_row(sheet, r, R, cols, header, hdr, dense, o);
			++R;
			if((row.isempty === false) || (header === 1 ? o.blankrows !== false : !!o.blankrows)) {
				stream.push(row.row);
				return;
			}
		}
		return stream.push(null);
	};
	return stream;
}

var __stream = {
	to_json: write_json_stream,
	to_html: write_html_stream,
	to_csv: write_csv_stream,
	set_readable: set_readable
};
if(typeof parse_xlscfb !== "undefined") XLSX.parse_xlscfb = parse_xlscfb;
XLSX.parse_zip = parse_zip;
XLSX.read = readSync; //xlsread
XLSX.readFile = readFileSync; //readFile
XLSX.readFileSync = readFileSync;
XLSX.write = writeSync;
XLSX.writeFile = writeFileSync;
XLSX.writeFileSync = writeFileSync;
XLSX.writeFileAsync = writeFileAsync;
XLSX.utils = utils;
XLSX.writeXLSX = writeSyncXLSX;
XLSX.writeFileXLSX = writeFileSyncXLSX;
XLSX.SSF = SSF;
if(typeof __stream !== "undefined") XLSX.stream = __stream;
if(typeof CFB !== "undefined") XLSX.CFB = CFB;

}
/*global define */
if(typeof exports !== 'undefined') make_xlsx_lib(exports);
else if(typeof module !== 'undefined' && module.exports) make_xlsx_lib(module.exports);
else if(typeof define === 'function' && define.amd) {
	define([], function () {
		if (!XLSX.version) {
			make_xlsx_lib(XLSX);
		}
		return XLSX;
	});
} else make_xlsx_lib(XLSX);
/* NOTE: the following extra line is needed for "Lightning Locker Service" */
if(typeof window !== 'undefined' && !window.XLSX) try { window.XLSX = XLSX; } catch(e) {}

},
'appivo/util/ExcelImport':function(){
define([
    "dojo/Deferred",
    "moment/moment",
    "./ExcelImportHelper",
    "sheetjs/xlsx"
], function (Deferred, moment, ExcelImportHelper, SheetJS) {
    //Constants when searching for the biggest data set in a sheet
    var MAX_EMPTY_ROWS = 2;
    var MAX_EMPTY_COLS = 2;

    //Constant offset to normalise column distances
    var COL_DIST_OFFSET = 'A'.charCodeAt(0);

    //Constants for weighting different parameters when calculating likelihood that a row is the header row
    var PRESENCE_WEIGHT = 2;
    var STYLE_WEIGHT = 1;
    var ROW_WEIGHT = 0.2;
    var DATA_WEIGHT = 1;
    var ROW_STYLE_WEIGHT = 1;
    var CAND_PRESENCE_MIN = 0.5;
    return {

        import: function (file, opts) {
            var t = this;
            var def = new Deferred();
            if (!file) {
                def.reject("No file provided");
            }

            var isCsv = ExcelImportHelper._isCsv(file);
            ExcelImportHelper.parseFile(file).then(function (response) {
                var data = null
                var result = null;
                if (isCsv) {
                    result = t._parseCsvData(response);
                    result.records = result.sheets.Default.rows;
                    delete result.sheets;
                    result = t._importCSVData(result, opts);
                } else {
                    data = t._parseXlsData(response, opts.readAsUTC);
                    result = t._importData(data, opts)
                }
                def.resolve(result);
            });
            return def;
        },

        readMetadata: function (file, opts) {
            var t = this;
            var def = new Deferred();
            if (!file) {
                def.reject("No file provided");
            }

            var isCsv = ExcelImportHelper._isCsv(file);
            ExcelImportHelper.parseFile(file).then(function (response) {
                var data = null
                var result = null;
                if (isCsv) {
                    result = t._parseCsvData(response);
                } else {
                    data = t._parseXlsData(response, opts.readAsUTC);
                    result = t._createMetadata(data);
                }
                def.resolve(result);
            });
            return def;
        },

        _parseCsvData: function(response) {
            var data = response.data;
            var result = {
                sheetNames: ["Default"],
                sheets: {
                    "Default": {
                        name: "Default",
                        types: [],
                        columns: []
                    }
                },
            };
            if (data && data.length > 0) {
                var header = data[0];
                var records = [];
                result.sheets.Default.columns = header;
                for (var i = 1; i < data.length; i++) {
                    var row = data[i];
                    var rec = {};
                    for (var j = 0; j < header.length; j++) {
                        var col = header[j];
                        var value = row[j];
                        rec[col] = value;
                    }
                    records.push(rec);
                }
                result.sheets.Default.rows = records;
            }
            return result;
        },

        _parseXlsData: function (data, readAsUTC) {
            var result = {};
            for (var i = 0; i < data.SheetNames.length; i++) {
                result[data.SheetNames[i]] = {};
            }
            for (var sheet in result) {
                var sheetData = data.Sheets[sheet];
                for (var cell in sheetData) {
                    var match = cell.match(/^(\D+)(\d+)$/);
                    if (match) {
                        if (!result[sheet][match[1]]) {
                            result[sheet][match[1]] = {};
                        }
                        var value = sheetData[cell].v;
                        var type = this._getType(sheetData[cell].t, sheetData[cell].v);
                        if (readAsUTC && value && value.constructor === Date) {
                            var utcDate = Date.UTC(value.getUTCFullYear(), value.getUTCMonth(), value.getUTCDate(), value.getUTCHours(), value.getUTCMinutes(), value.getUTCSeconds());
                            value = utcDate;
                        }
                        result[sheet][match[1]][match[2]] = {
                            value: value,
                            style: sheetData[cell].s,
                            type: type
                        };
                    }
                }
            }
            this._normalizeTypes(result);
            return result;
        },

        _createMetadata: function (data, opts) {
            var result = {
                sheets: {},
                sheetNames: []
            };
            var noSheets = Object.keys(data).length;
            for (var name in data) {
                result.sheetNames.push(name);
                var sheet = data[name];
                this._findDataSet(sheet);
                this._findColumnMeta(sheet);
                var sheetData = {
                    name: name,
                    columns: [],
                    rows: sheet._dataSet.bottom - sheet._dataSet.top - 1
                };
                var typeMap = {};
                for (var i = 0; i < sheet._dataSet.columns.length; i++) {
                    var col = sheet._dataSet.columns[i];
                    var types = sheet._dataSet.columnTypes[i];
                    var list = this.toTypeList(types);
                    typeMap[col] = list;
                }
                sheetData.types = [];
                for (var cname in sheet._headers) {
                    var col = sheet._headers[cname];
                    sheetData.columns.push(cname);
                    sheetData.types.push(typeMap[col]);
                }
                result.sheets[name] = sheetData;
            }

            return result;
        },

        toTypeList: function(typeMap) {
          var list = [];
          for (var type in typeMap) {
              var data = typeMap[type];
              list.push({
                  type: type,
                  count: data.count
              });
          }
          list.sort(function(a,b) {
              return a.count - b.count;
          });
          list = list.map(function(a) {
              return a.type;
          });
          return list;
        },

        _importData: function (data, opts, csv) {
            var result = {
                records: [],
                data: {}
            };

            var noMappings = opts.mapping ? Object.keys(opts.mapping).length : 0;
            var noSheets = data ? Object.keys(data).length : 0;

            for (var sheet in data) {
                var m = null;
                if (noMappings == 1 && noSheets == 1) {
                    m = opts.mapping[Object.keys(opts.mapping)[0]];
                } else if (opts.mapping) {
                    m = opts.mapping[sheet];
                }
                var s = data[sheet];
                this._findDataSet(s);
                this._findColumnMeta(s);
                if ((!m && !opts.meta && noMappings == 0) || (m && noMappings == 1 && Object.keys(m).length == 0)) {
                    result.records = this._generateRawRecords(s, opts);
                }
                if (m) {
                    result.records = result.records.concat(this._generateRecords(s, m, result.data));
                }
            }
            this._createSheetDataObj(result, data);
            return opts.meta ? data : result;
        },

        _importCSVData: function(data, opts) {
            var records = data.records;
            var map = opts.mapping.Default;
            var recs = [];
            for (var i = 0; i < records.length; i++) {
                var record = records[i];
                var rec = {};
                for (var key in map) {
                    var m = map[key];
                    if (m.source) {
                        var value = record[m.source];
                        rec[key] = value;
                    }
                }
                recs.push(rec);
            }
            return {
                records: recs
            };
        },

        _createSheetDataObj: function (obj, data) {
            obj._data = data;
            obj.getSheetNames = function () {
                return Object.keys(this._data);
            };
            obj.getSheet = function (sheet) {
                return {
                    data: this._data[sheet],

                    getRow: function (row) {
                        var rowObj = {
                            getColumn: function (col) {
                                return this[col];
                            },
                            getColumnValue: function (col) {
                                return this.getColumn(col).value;
                            }
                        };
                        for (var c in this.data) {
                            if (this.data[c][row] !== undefined) {
                                rowObj[c] = this.data[c][row];
                            }
                        }
                        return rowObj;
                    },

                    getColumn: function (col) {
                        var colObj = {
                            getRow: function (row) {
                                return this[row];
                            },
                            getRowValue: function (row) {
                                return this.getRow(row).value;
                            }
                        };
                        for (var r in this.data[col]) {
                            colObj[r] = this.data[col][r];
                        }
                        return colObj;
                    },

                    getCell: function (col, row) {
                        var value;
                        if (this.data[col] && this.data[col][row]) {
                            value = this.data[col][row];
                        }
                        return value;
                    },

                    getCellValue: function (col, row) {
                        var val = this.getCell(col, row);
                        if (val !== undefined) {
                            val = val.value;
                        }
                        return val;
                    }
                };
            };
        },

        _generateRawRecords: function(data, opts) {
            var min = -1;
            var max = -1;
            var columns = Object.keys(data).sort();
            columns.length = columns.length - 2;
            columns.forEach(function(column) {
                var coldata = data[column];
                var keys = Object.keys(coldata).sort();
                keys.forEach(function(row) {
                    row = parseInt(row);
                    if (min == -1) {
                        min = row;
                    }
                    if (max == -1) {
                        max = row;
                    }
                    if (row < min) {
                        min = row;
                    }
                    if (row > max) {
                        max = row;
                    }
                });
            });

            console.log("data starts at row " + min);

            var header = null;
            var headerRow = null;
            if (opts.headerRow) {
                var head = opts.headerRow;
                if (head >= min && head < max) {
                    headerRow = head;
                }
            }

            var records = [];
            var recordStart = -1;
            if (min > -1 && max > -1) {
                for (var i = min; i <= max; i++) {
                    var rec = {};
                    columns.forEach(function(column) {
                        var coldata = data[column];
                        var value = coldata[i];
                        if (value) {
                            rec[column] = value.value;
                        }
                    });
                    if (i === headerRow) {
                        header = rec;
                        recordStart = records.length + 1;
                    }
                    records.push(rec);
                }
            }

            if (header) {
                var recs = [];
                for (var i = recordStart; i < records.length; i++) {
                    var record = records[i];
                    var rec = {};
                    for (var key in record) {
                        var attr = header[key];
                        if (attr !== undefined) {
                            rec[attr] = record[key];
                        }
                    }
                    recs.push(rec);
                }
                records = recs;
            }

            return records;
        },

        _generateRecords: function (sheet, mapping, data) {
            var records = [];
            for (var i = sheet._dataSet.headerRow + 1; i <= sheet._dataSet.bottom; i++) {
                var record = {};
                var row = null;
                for (var key in mapping) {
                    var mapper = mapping[key];
                    if (typeof mapper === 'string') {
                        var cell = sheet[sheet._headers[mapper]][i];
                    } else if (mapper.source) {
                        var cell = sheet[sheet._headers[mapper.source]][i];
                    } else {
                        var cell = null;
                    }
                    var value = cell ? cell.value : null;
                    record[key] = value;
                    if (mapper.map && row === null) {
                        row = {};
                        for (var c in sheet._dataSet.columns) {
                            var col = sheet._dataSet.columns[c];
                            var c = sheet[col][i];
                            if (c) {
                                row[sheet[col]._name] = c.value;
                            }
                        }
                    }
                }

                var vcount = 0;
                for (var attr in record) {
                    var m = mapping[attr];
                    var value = record[attr];
                    if (m.map) {
                        var func = null;
                        if (typeof m.map === 'function') {
                            func = m.map;
                        } else if (typeof m.map === 'string') {
                            try {
                                func = new Function('val', 'row', 'data', m.map);
                                m.map = func;
                            } catch (e) {
                                console.error(e);
                            }
                        }
                        if (func) {
                            value = func(record[attr], row, data);
                        } else if (typeof m.map === 'object') {
                            value = m.map[record[attr]];
                        }
                        if (value !== undefined) {
                            record[attr] = value;
                        }
                    }
                    if (value !== undefined && value !== null) {
                        vcount++;
                    }
                }

                if (vcount > 0) {
                    records.push(record);
                }
            }
            return records;
        },

        _findColumnMeta: function (sheet) {
            var t = this;
            var dataSet = sheet._dataSet;
            var colsInSet = [];
            var cols = Object.keys(sheet).sort();

            for (var col in sheet) {
                if (this._calcColDist(dataSet.left, col, cols) >= 0 && this._calcColDist(dataSet.right, col, cols) <= 0) {
                    colsInSet.push(col);
                }
            }
            dataSet.columns = colsInSet;
            dataSet.columnTypes = [];
            var candidateRows = [];
            var cntPOne = 0;
            var lastRow = null;
            for (var i = dataSet.top; i <= dataSet.bottom && i < dataSet.top + 10; i++) {
                var presence = 0;
                var styleSimilarity = 0;
                var cellStyle = null;
                var rowData = '';
                var rowStyle = '';
                for (var j in colsInSet) {
                    var cell = sheet[colsInSet[j]][i];
                    var types = dataSet.columnTypes[j];
                    if (!types) {
                        types = {};
                        dataSet.columnTypes[j] = types;
                    }

                    if (cell) {
                        if (cell.type) {
                            cell.type.forEach(function(type) {
                                var val = types[type];
                                if (val === undefined) {
                                    val = {
                                        first: i,
                                        count: 0
                                    };
                                    types[type] = val;
                                }
                                val.count++;
                            });
                        }
                        if (cell.style) {
                            if (cellStyle !== null && cellStyle !== undefined) {
                                styleSimilarity += this._checkSimilarity(cellStyle, JSON.stringify(cell.style), true);
                            } else if (cellStyle !== undefined) {
                                styleSimilarity += 1;
                            }
                            cellStyle = JSON.stringify(cell.style);
                        } else {
                            if (cellStyle === undefined || cellStyle === null) {
                                styleSimilarity += 1;
                            }
                            cellStyle = cell.style;
                        }
                        presence++;
                        rowData += cell.value;
                        rowStyle += JSON.stringify(cell.style);
                    }
                }
                styleSimilarity = styleSimilarity / colsInSet.length;
                presence = presence / colsInSet.length;
                var candidate = {
                    row: i,
                    presence: presence,
                    styleSimilarity: styleSimilarity,
                    data: rowData,
                    style: rowStyle
                };
                if (lastRow) {
                    lastRow.dataSimilarity = this._checkSimilarity(rowData, lastRow.data, true);
                    lastRow.rowStyleSimilarity = this._checkSimilarity(rowStyle, lastRow.style, true);
                    delete lastRow.data;
                    delete lastRow.style;
                }
                lastRow = candidate;
                candidateRows.push(candidate);
                if (presence === 1) {
                    if (++cntPOne === 5) {
                        break;
                    }
                }
            }
            var headerRow = candidateRows.slice(0, -1).sort(function (a, b) {
                return t._rowIsHeaderLikelihood(b, dataSet.top) - t._rowIsHeaderLikelihood(a, dataSet.top);
            }).filter(function (a) {
                return a.presence > CAND_PRESENCE_MIN;
            })[0];
            sheet._headers = {};
            var seenHeaders = {};
            for (var i in colsInSet) {
                var col = colsInSet[i];
                var cell = sheet[col][headerRow.row];
                var types = dataSet.columnTypes[i];
                for (var key in types) {
                    var data = types[key];
                    if (data.first <= headerRow.row && data.count == 1) {
                        delete types[key];
                    }
                }
                if (cell) {
                    var header = cell.value;
                    if (seenHeaders[header]) {
                        if (!seenHeaders[header].fixed) {
                            var c = sheet._headers[header];
                            var newName = header + '(' + c + ')';
                            sheet[c]._name = newName;
                            sheet._headers[newName] = c;
                            //delete sheet._headers[header];
                        }
                        header += '(' + col + ')';
                    } else {
                        seenHeaders[header] = {fixed: false};
                    }
                    sheet._headers[header] = col;
                    sheet[col]._name = header;
                    dataSet.headerRow = headerRow.row;
                }
            }
        },

        _rowIsHeaderLikelihood: function (row, firstRow) {
            return PRESENCE_WEIGHT * row.presence
                + STYLE_WEIGHT * row.styleSimilarity
                + ROW_WEIGHT * (firstRow - row.row)
                - DATA_WEIGHT * row.dataSimilarity
                - ROW_STYLE_WEIGHT * row.rowStyleSimilarity;
        },

        _findDataSet: function (sheet) {
            var columnData = {};
            for (var col in sheet) {
                colData = {};
                var lastRow = 0;
                var startRow = 1;
                var max = 0;
                var count = 0;
                for (var row in sheet[col]) {
                    row = parseInt(row);
                    var empty = row - lastRow - 1;
                    if (empty > MAX_EMPTY_ROWS) {
                        if (count > max) {
                            max = count;
                            colData.setStart = startRow;
                            colData.setEnd = lastRow;
                            colData.setSize = count;
                            startRow = row;
                        }
                        count = 0;
                    }
                    lastRow = row;
                    count++;
                }
                if (count > max) {
                    max = count;
                    colData.setStart = startRow;
                    colData.setEnd = lastRow;
                    colData.setSize = count;
                }
                columnData[col] = colData;
            }

            var biggestSet = {size: -1};
            var curSet = null;
            var lastCol = null;
            var cols = Object.keys(columnData).sort();
            for (var i = 0; i < cols.length; i++) {
                var col = cols[i];
                var colData = columnData[col];
                if (lastCol !== null) {
                    var empty = this._calcColDist(lastCol, col, cols) - 1;
                    if (empty > MAX_EMPTY_COLS) {
                        if (curSet.size > biggestSet.size) {
                            biggestSet = curSet;
                        }
                        curSet = null;
                    }
                }
                if (curSet == null) {
                    curSet = {
                        top: colData.setStart,
                        bottom: colData.setEnd,
                        left: col,
                        right: col
                    };
                } else {
                    if (this._setsOverlap({setStart: curSet.top, setEnd: curSet.bottom}, colData)) {
                        curSet.right = col;
                        curSet.top = Math.min(curSet.top, colData.setStart);
                        curSet.bottom = Math.max(curSet.bottom, colData.setEnd);
                    } else {
                        if (curSet.size > biggestSet.size) {
                            biggestSet = curSet;
                        }
                        curSet = {
                            top: colData.setStart,
                            bottom: colData.setEnd,
                            left: col,
                            right: col
                        };
                    }
                }
                this._calcSetSize(curSet, cols);
                lastCol = col;
                if (curSet.size > biggestSet.size) {
                    biggestSet = curSet;
                }
            }
            sheet._dataSet = biggestSet;
        },

        _setsOverlap: function (a, b) {
            return !(a.setStart > b.setEnd || b.setStart > a.setEnd);
        },

        _calcSetSize: function (set, cols) {
            set.size = (set.bottom - set.top + 1) * (this._calcColDist(set.left, set.right, cols) + 1);
        },

        _calcColDist: function (a, b, cols) {
            /*
            a = (a + '').toUpperCase();
            b = (b + '').toUpperCase();
            var aVal = 0;
            var bVal = 0;
            for (var i = 0; i < a.length; i++) {
                aVal += a.charCodeAt(i) - COL_DIST_OFFSET + 26 * i;
            }
            for (var i = 0; i < b.length; i++) {
                bVal += b.charCodeAt(i) - COL_DIST_OFFSET + 26 * i;
            }
            */
            var aidx = cols.indexOf(a);
            var bidx = cols.indexOf(b);
            return bidx - aidx;
        },

        _checkSimilarity: function (a, b, percent) {
            //origin:  http://phpjs.org/functions/similar_text
            if (a === null || b === null || typeof a === 'undefined' || typeof b === 'undefined') {
                return 0;
            }
            a += '';
            b += '';
            var pos1 = 0;
            var pos2 = 0;
            var max = 0;
            var aLength = a.length;
            var bLength = b.length;
            for (var p = 0; p < aLength; p++) {
                for (var q = 0; q < aLength; q++) {
                    for (var l = 0; (p + l < aLength) && (q + l < bLength); l++) {
                        if (a.charAt(p + l) !== b.charAt(q + l)) {
                            break;
                        }
                    }
                    if (l > max) {
                        max = l;
                        pos1 = p;
                        pos2 = q;
                    }
                }
            }
            var sum = max;
            if (sum) {
                if (pos1 && pos2) {
                    sum += this._checkSimilarity(a.substr(0, pos1), b.substr(0, pos2));
                }
                if ((pos1 + max < aLength) && (pos2 + max < bLength)) {
                    sum += this._checkSimilarity(a.substr(pos1 + max, aLength - pos1 - max), b.substr(pos2 + max, bLength - pos2 - max));
                }
            }
            if (!percent) {
                return sum;
            }
            return (sum * 2) / (aLength + bLength);
        },

        _findColumnType: function (column) {
            for (var cell in column) {
                var c = column[cell]

            }
        },

        //Hooray for standards
        _convertExcelDate: function (dateVal, is1904) {
            if (is1904) {
                var startDate = "1904-01-01";
                var offset = 1; //Excel counts from 1904-01-00..
            } else {
                var startDate = "1900-01-01";
                var offset = dateVal >= 60 ? 2 : 1; //Excel counts from 1900-01-00 AND wrongly sees 1900 as a leap year
            }
            var date = new Date(startDate);
            date.setSeconds(date.getSeconds() + Math.round((86400 * (dateVal - offset)) + (date.getTimezoneOffset() * 60)));
            return date.toISOString();
        },

        _normalizeTypes: function (dataSet) {

        },

        _getType: function (type, value) {
            var t;
            switch (type) {
                case 'b': //Boolean
                    t = ["BOOLEAN"];
                    break;
                case 'n': //Number
                    t = ["FLOAT"];
                    if (parseInt(value) === parseFloat(value)) {
                        t = ["INTEGER"];
                    }
                    break;
                case 'd': //Date
                    t = ["DATE", "DATETIME", "TIME"];
                    break;
                default: //String & error
                    t = ["STRING"];
                    break;
            }
            return t;
        }
    };
});
},
'appivo/util/ExcelImportHelper':function(){
define([
    "dojo/Deferred",
    "moment/moment",
    "papaparse/papaparse",
    "sheetjs/xlsx"
], function(Deferred, moment, PapaParse, xlsx) {
    return {
        parseFile:function(file){
            var isCSV = this._isCsv(file);
            if (isCSV) {
                return this._readCsv(file);
            } else {
                return this._readFile(file);
            }
        },

        _isCsv: function (file) {
            var fileEnd = "csv";
             return file.name.indexOf(fileEnd, this.length - fileEnd.length) !== -1;
        },

        _readCsv: function(file) {
            var def = new Deferred();
            PapaParse.parse(file, {
                dynamicTyping: true,
                skipEmptyLines: true,
                complete: function (result) {
                    if (result != null) {
                        def.resolve(result);
                    } else {
                        def.reject("Error importing data");
                    }
                }
            });
            return def;
        },

        _readFile: function(file) {
            var def = new Deferred();
            var reader = new FileReader();
            reader.onload = function (e) {
                var data = e.target.result;
                var xlsData = xlsx.read(data, {
                    type: 'binary',
                    cellDates: true
                });
                if (data != null) {
                    def.resolve(xlsData);
                } else {
                    def.reject("Error importing data");
                }
            };
            reader.readAsBinaryString(file);
            return def;
        },

        _parseTimeString: function (timeString) {
            if (timeString == '' || typeof timeString != "string") {
                return null;
            }
            var time = timeString.match(/^(\d+)(:(\d\d))?\s*((a|(p))m?)?$/i);
            if (time == null) {
                time = timeString.match(/(\d\d)(:(\d\d))?(:(\d\d))?\s*((a|(p))m?)?/i);
                if(time == null){
                    return null;
                }
            }
            var hours = parseInt(time[1], 10);
            if (hours == 12 && !time[6]) {
                 hours = 0;
            }
            else {
               hours += (hours < 12 && time[6]) ? 12 : 0;
            }
            var d = new Date();
            d.setHours(hours);
            d.setMinutes(parseInt(time[3], 10) || 0);
            d.setSeconds(0, 0);
            if (isNaN(d.getTime())) {
                d = null;
            }
            return d;
        },

        _isTimeString: function(timeString) {
            var d = this._parseTimeString(timeString);
            return (d != null && !isNaN(d.getTime ()));
        }
    };
});

},
'appivo/mvc/Function':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'appivo/mvc/Argument'], function(lang, declare, Argument) {
	return declare("appivo.mvc.Function", [], {

		name: null,
		script: null,
		arguments: null,
		
		constructor: function(options) {
			lang.mixin(this, options);
			if (this.arguments) {
				var args = new Array();
				for (var i = 0; i < this.arguments.length; i++) {
					args.push(new Argument(this.arguments[i]));
				}
				this.arguments = args;
			}
			if (!this.arguments) {
				this.arguments = new Array()
			}
			if (!this.script) {
				this.script = {
                    script: {
                    	script: undefined
                    },
                    quick: undefined,
                    logic: undefined
                };
			}
		},

		getName: function() {
			return this.name;
		},
		
		getArguments: function() {
			return this.arguments;
		},
		
		getScript: function() {
			if (typeof this.script == "string") {
				return this.script;
			} else {
				return this.script.script.script;
			}
		},
			
		execute: function(context, args) {
			return this.getCompiled(context, args);
		},
		
		getCompiled: function(asyn) {
			var func = asyn ? this._asyncCompiled : this._compiled;
			var compiled = null;
			if (!func) {
				if (asyn) {
					this._asyncCompiled = this._compile(true);
					compiled = this._asyncCompiled;
				} else {
					this._compiled = this._compile(false);
					compiled = this._compiled;
				}
				func = compiled;
			}
			return func;
		},
		
		_compile: function(asyn) {
			var script;
			if (this.script != undefined && this.script != null) {
				if (typeof this.script == 'string') {
					script = this.script;
				} else if (this.script.script != undefined && this.script.script != null) {
					script = this.script.script.script;
				}
			}
			const AsyncFunction = async function () {}.constructor;
			const argNames = ["context", "args"];
			var func = null;
			try {
				const body = script + this._getSourceUrl(this.name);
			    func = asyn ? new AsyncFunction(argNames, body) : new Function(argNames, body);
			} catch (error) {
				console.error("Failed to compile: " + script);
                console.error(error);
				var message = {
					message: "Failed to compile script: " + error.message+ script + "\n\nScript:\n\n " + script,
				}
				str = "context.alert(" + JSON.stringify(message) + ");" + this._getSourceUrl(this.name);
				func = asyn ? AsyncFunction(argNames, str) : new Function(argNames, str);
			}
			return func;
		},

		_getSourceUrl: function (name) {
			return "\n//# sourceURL=appivo://functions/" + name + ".js\n";
		},

		toJSON: function() {
			var script = "";
			if (this.script != undefined && this.script != null) {
				script = this.script;
			}
			var json = {
				name: this.name,
				script: script
			};
			if (this.arguments) {
				var args = new Array();
				for (var i = 0; i < this.arguments.length; i++) {
					var arg = this.arguments[i];
					args.push(arg.toJSON());
				}
				json.arguments = args;
			}
			return json;
		}
	});
});
},
'appivo/mvc/Argument':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare'], function(lang, declare) {
	return declare("appivo.mvc.Argument", [], {

		name: null,
		type: null,
		required: true,
		
		constructor: function(options) {
			lang.mixin(this, options);
		},

		getName: function() {
			return this.name;
		},

		getType: function() {
			return this.type;
		},
		
		isRequired: function() {
			return this.required;
		},
				
		toJSON: function() {
			var json = {
				name: this.name,
				type: this.type,
				required: this.required
			};
			return json;
		}
	});
});
},
'appivo/mvc/Form':function(){
/**
 * @interface Form
 */
define(['dojo/_base/lang',
        'dojo/_base/declare',
        'dojo/_base/Deferred',
        'dojo/Evented',
        'dojo/topic',
        'dojo/string',
        'dojo/date/stamp',
        'dojo/i18n!appivo/nls/Form',
        'appivo/util/Date',
        'appivo/util/Identity',
		'appivo/ui/Alertify',
		'appivo/client/Client'], function(lang, declare, Deferred, Evented, topic, string, stamp, messages, AMDate, Identity, Alertify, Client) {

	var client = Client.getInstance();
	
	return declare("appivo.mvc.Form", [Evented], {

		model: null,
		id: null,
		org: null,
		item: null,
		view: null,
		onSubmit: null,
		onValidate: null,
		attributes: null,
		relations: null,
		documents: null,
		datas: null,
		fixedFields: null,
		parent: null,
		relation: null,
		transactional: false,
		closed: false,
		enabled: true,
		suppress: false,
		loadedRelations: null,
		validationError: null,
		vue: null,
		submitting: false,
		tmp: false,
		features: null,
		observing: null,
		observers: null,
		observerHandle: null,
		modified: null,
		ignoreChanges: false,
		lastError: null,

		constructor: function(options) {
			declare.safeMixin(this, options);
			if (this.enabled === undefined) {
				this.enabled = true;
			}
			if (this.suppress === undefined) {
				this.suppress = false;
			}
			if (!this.fixedFields) {
				this.fixedFields = {};
			}
			if (!this.features) {
				this.features = [];
			}
			this.observers = [];
			this.idCounters = [];
		},
		
		init: function(view) {
			this.attributes = [];
			this.relations = [];
			this.documents = [];
			this.datas = [];
			this.modified = {};
			if (this.parent) {
				var parent = view.getForm(this.parent);
				this.setParent(parent);
			}
		},

		/**
		 * Gets the ID of this form
		 * 
		 * @memberof Form
		 * @instance
		 * @returns {String} ID of this form
		 */
		getId: function() {
			return this.id;
		},

		/**
		 * Gets the ID of the Record held by this form
		 * @memberof Form
		 * @instance
		 * @returns {ID} ID of the Record in the form
		 *   "api":"Form",
		 *   "returntype":"ID"
		 * }
		 */
		getRecordId: function() {
			return this.item ? this.item.id : undefined;
		},
		
	    /**
		*	Check whether this form is holding a new record or not
		*	@returns {Boolean} true if the form represents a new record
	 	*	@instance
		*	@memberof Form
		*/
		isCreate: function() {
			var id = this.getRecordId();
			return id === undefined || id === null || Identity.isTempId(id);
		},
		
	    /**
		*	Check whether this form is holding an existing record or not
		*	@returns {Boolean} true if the form represents an existing record
	 	*	@instance
		*	@memberof Form
		*/
		isEdit: function() {
			return !this.isCreate();
		},
		
	    /**
		*	Check whether this is a child-form
		*	@returns {Boolean} true if the form is a child-form
	 	*	@instance
		*	@memberof Form
		*/
		isChild: function() {
			return this.parent != null && this.parent != undefined;
		},
		
	    /**
		*	Check whether this is a temporary form (i.e. a dynamically created one)
		*	@returns {Boolean} true if the form is temporary
	 	*	@instance
		*	@memberof Form
		*/
		isTemporary: function() {
			return this.tmp;
		},

		/**
		 * Checks whether the user has a certain privilege on the record held by this form (note: for this to be 100% accurate the form must be configured to laod privileges, otherwise only blanket privileges are considered)
		 * @param {String} privilege  - Name of privilege to check for
		 * @returns {Boolean} true if the user has the requested privilege
		 *	@instance
		 *	@memberof Form
		 */
		hasPrivilege: function(privilege) {
			var has = undefined;
			var model = this.model;
			if (this.item && this.item._hasPrivilege && this.isEdit()) {
				has = this.item._hasPrivilege(privilege);
			} else {
				var schema = model.getSchema();
				has = schema.hasUserPrivileges([{
					has: true,
					model: model.getName(),
					privilege: privilege
				}]);
			}
			return has;
		},

	    /**
		*	Gets the parent of this form
		*	@returns {Form}
	 	*	@instance
		*	@memberof Form
		*/
		getParent: function() {
			return this.parent;
		},

		/**
		 * Gets the child forms of this form (if any)
		 * @returns {Array | *[]}
		 *	@instance
		 *	@memberof Form
		 */
		getChildren: function() {
			return this.view.getChildForms(this);
		},
		
		getRelation: function() {
			return this.relation;
		},
		
		setParent: function(parent) {
			this.parent = parent;
			var parentModel = parent.getModel();
			this.relation = parentModel.getRelationship(this.relation, true);
			if (this.relation) {
				this.model = this.relation.getDestination();				
			}
		},
		
		setLoadedRelations: function(rels) {
			this.loadedRelations = rels;
		},
		
		getLoadedRelations: function() {
			return this.loadedRelations;
		},

        /**
         * Loads (or reloads) a relation of the record held by this form.
         * @param {String} name - Name of relation to load
         * @param {Boolean} add - Pass true to update the contents of the form
		 * @param {Boolean} labels - Pass true to load labels of the related records
		 * @returns {Promise<Array>}
		 * @instance
		 * @memberof Form
		 */
		loadRelation: function(name, add, labels) {
			var t = this;
			if (this.isEdit()) {
				if (labels === undefined) {
					labels = true;
				}
                return this.item.loadRelatedRecords(name, {
                	add: add,
					labels: labels
				}).then(function (records) {
                    if (add) {
                        t.setValue(name, records);
                    }
                });
            } else {
			    var def = new Deferred();
			    var records = t.getValue(name);
			    def.resolve(records);
			    return def;
            }
		},

		addFeature: function(feature) {
			if (feature) {
				feature = feature.toLowerCase();
				if (this.features.indexOf(feature) < 0) {
					this.features.push(feature);
				}
			}
		},

		removeFeature: function(feature) {
			if (feature) {
				feature = feature.toLowerCase();
				var idx = this.features.indexOf(feature);
				if (idx >= 0) {
					this.features.splice(idx, 1);
				}
			}
		},

		getFeaturesAsString: function() {
			var str = "";
			for (var i = 0; i < this.features.length; i++) {
				var feature = this.features[i];
				if (i > 0) {
					str = str + ",";
				}
				str = str + feature;
			}
			return str;
		},
		
	    /**
		*	Check whether this form is in transactional mode
		*	@returns {Boolean} true if the form is in transactional mode
	 	*	@instance
		*	@memberof Form
		*/
		isTransactional: function() {
			return this.transactional;
		},

		/**
		 * Enables/disables transactional mode
		 * @param {Boolean} transactional - True if the form should be transactional
		 * @instance
		 * @memberof Form
 		 */
		setTransactional: function(transactional) {
			this.transactional = transactional;
		},


		/**
		 * Submits the form.
		 * @param {Object} options - Configuration object.
		 * @param {String} options.successMessage - Message to display on success.
		 * @param {String} options.errorMessage - Message to display on error.
		 * @param {Array} options.exclude - List of attributes and/or relations to exclude from the submission
		 * @param {Object} options.metadata - Metadata to include as part of the submitted record
		 * @param {Boolean} options.full - If included, the submission will also include child forms.
		 * @param {Boolean} options.preventReset - Instead of resetting, the form will be loaded with the new data after submission.
		 * @param {Boolean} options.suppressNotifications - Set to true to suppress any notifications displayed as a result of this submission.
		 * @param {Object} options.override - Object with attribute-values to override the form contents with upon submission
		 * @returns {Boolean} - A boolean indicating whether the form was actually submitted to the server or not.
		 * @memberof Form
		 * @instance
		 *
		 * @LogicMeta {
		 *   "api":"Form",
		 *   "paramtypes":["Object"],
		 *   "returntype":"Boolean",
		 *   "toggleReturn":"true",
		 *   "async":{
		 *		"onFailure":"onError"
		 *	},
		 *   "objectTypeOverride": { "options": { "successMessage":"String", "errorMessage":"String", "full":"Boolean" } },
		 *   "tooltip": "$",
		 *   "shadowBlocks": {
		 *   	"full": "boolean#false"
		 *   }
		 * }*/
		submit: function(options) {
			var t = this;
			var opts = options || {};
			var ok = false;
			if (this.submitting) {
				return false;
			}
			this.submitting = true;
			if (this.validate()) {
				ok = true;
				var record = null;
				if (opts.record) {
					record = opts.record;
				} else {
					record = this.build({
						full: opts.full,
						override: opts.override
					});

					if (opts.exclude) {
						var excludes = opts.exclude;
						delete opts.exclude;
						if (excludes instanceof String) {
							excludes = excludes.split(",");
						}
						if (Array.isArray(excludes)) {
							for (var i = 0; i < excludes.length; i++) {
								var attr = excludes[i].trim();
								delete record[attr];
							}
						}
					}
				}
				this.view.showLoadingIndicator();
				var headers = {
				};
                var refs = this.scanReferences();
                var refStr = this._refsToString(refs);
                headers.Relations = refStr;
				var saveOpts = {
					headers: headers,
					sync: opts.sync
				};
				if (opts.metadata) {
					record._setMetadata(options.metadata);
				}
				var doOptimize = opts.optimize;
				if (doOptimize === undefined || doOptimize === null) {
					doOptimize = true;
				}
				var optimized = doOptimize ? record._optimize(this.org) : record;
				var def = optimized.save(false, saveOpts).then(function(newData) {
						t.submitting = false;
						t.view.hideLoadingIndicator();
						console.log("Submitted form OK");
						var message = null;
						if (Identity.hasTempId(record)) {
							message = string.substitute(messages.created, {model: t.model.getLocalizedName()});
							if (!t.closed) {
								if (opts.preventReset) {
									t.setData(newData);
								} else {
									t.reset();
								}
							}
						} else {
							message = string.substitute(messages.updated, {model: t.model.getLocalizedName()});
							try {
								if (!t.closed) {
									t.setData(newData);																			
								}
							} catch (error) {
								console.log("Error updating form");
								console.error(error);
							}
						}
						if (opts.successMessage) {
							message = opts.successMessage;
						}
						if(!opts.supressNotifications && !opts.suppressNotifications){
							t.view.getPageManager().alert('success',message);
						}
						if (lang.isFunction(opts.onSuccess)) {
							opts.onSuccess(newData);
						}
					},
					function(requestError) {
						t.submitting = false;
						t.view.hideLoadingIndicator();
						var error = requestError.error ? requestError.error : JSON.parse(requestError.responseText);
						if (error.error) {
						    var message = 'Failed to create ' + t.model.getLocalizedName() + ': ' + error.error;
						} else {
						    var message = error;
						}
						if (opts.errorMessage) {
							message = opts.errorMessage;
						}
						if (!opts.suppressNotifications){
						    t.view.getPageManager().alert('error', message);
						}
						if (lang.isFunction(opts.onError)) {
							opts.onError(requestError);
						}
					}
				);
			} else {
				t.submitting = false;
				var msg = this.validationError;
				this.validationError = null;
				if (!msg) {
					msg = messages.formValidationFailed;
				}
				this.view.getPageManager().alert('error', msg, null, messages.formValidationFailedTitle);
			}
			return ok;
		},

		getRelatedStore: function(item) {
			var store = null;
			if (this.parent) {
				if (!this.transactional) {
					var parentId = this.parent.getRecordId();
					var model = this.parent.getModel();
					store = model.getRelatedStore({
						id: parentId,
						relation: this.relation.getName(),
						transactional: this.transactional,
						fetchMode: 'NESTED|LABELS'
					});					
				} else {
					store = this.parent._getRelatedStore(this.relation.getName());
				}
			}
			return store;
		},
		
		_getRelatedStore: function(rel) {
			var store = null;
			for (var i = 0; i < this.relations.length; i++) {
				var r = this.relations[i];
				if (r.getName() == rel) {
					store = r.store;
				}
			}
			return store;
		},
		
		build: function(opts) {
			opts = opts ? opts : {};
			opts.submit = true;
			return this.createRecord(opts);
		},

        /**
		 *  Creates a record using the form's data.
		 *  @param {Object} opts - Configuration object.
		 *  @param {Boolean} opts.submit -
		 *  @param {Boolean} opts.keepIds -
		 *  @param {Boolean} opts.full - If true, any child forms' data are used to create related records.
		 *  @param {Boolean} opts.nodelete 
		 *  @returns {Record}
		 *  @memberof Form
		 *  @instance
		 *
		 *  @LogicMeta {
        *   "api":"Form",
        *   "paramtypes":["Object"],
        *   "returntype":"Record",
        *   "tooltip": "$"
        * }*/
		createRecord: function(opts) {
			opts = opts ? opts : {};
			if (opts.submit) {
				opts.keepIds = true;
			}
			var data = null;
			var nodelete = !!opts.nodelete || !!opts.noOptimize;
			
			var item = this.item;
			if (item) {
				if (item.__model) {
					var clone = item._clone();
					clone.__store = item.__store;
					item = clone;
				} else {
					item = lang.clone(item);
				}
			}
			
			if (item && item.__store) {
				data = this.model.createRecord(item, item.__store);				
			} else {
				var store = undefined;
				if (this.parent && this.relation && this.transactional) {
					store = this.getRelatedStore();
				}
				data = this.model.createRecord(item, store);
			}
			
			var rid = this.getRecordId();
			if (Identity.isRealId(rid) || opts.submit) {
				data.id = rid;
			}
				
			if ((opts && !opts.keepIds) && !opts.submit) {
				Identity.cleanItemId(data);
			}
			
			if (this.parent && this.relation) {
				// Inject reference
				var relName = this.relation.getRemoteName();
				var relAttr = this.model.getAttributeForRelation(relName);
				if (relAttr) {
					var parentId = this.parent.getRecordId();
					if (parentId) {
						data[relAttr.getName()] = parentId;
					}
				} else {
					var parentId = this.parent.getRecordId();
					if (parentId) {
						data[relName] = {
							id: parentId
						};
					}
				}
			}
			
			var store = this.getRelatedStore();
			if (store) {
				data.setStore(store);
			}
			for (var i = 0; i < this.attributes.length; i++) {
				var attr = this.attributes[i];
				if (!attr.relation) {
					var value = this.getValue(attr.getName());
					data[attr.getName()] = value;
				}
			}
			
			for (var i = 0; i < this.relations.length; i++) {
				var rel = this.relations[i];
				var attr = this.model.getAttributeForRelation(rel.getName());
				if (attr) {
					var relName = rel.getName();
					var attrName = attr.getName();
					var valItem = rel.getItemValue(); 
					var valId = rel.getValue();
					var exItem = data[relName];
					var lblName = relName + '_label';
					if (nodelete && (valId && !valItem) && exItem && exItem.id == valId) {
						valItem = exItem;
					}
					if (valItem) {
						if (valItem.id) {
							data[attrName] = valItem.id;
							data[lblName] = rel.getRelation().getDestination().getLabel(valItem);
							if (nodelete) {
								data[relName] = valItem;
							} else {
								if (valItem._compare && !valItem._compare(exItem)) {
									data[relName] = valItem;
								} else {
									delete data[relName];
								}
							}
						} else {
							if (!nodelete) {
								delete data[attrName];
								delete data[lblName];
							}
							data[relName] = valItem;
						}
					} else {
						var relid = rel.getValue();
						if (relid == '') {
							relid = null;
						}
						if (relid) {
							data[attrName] = relid;
							if (!nodelete) {
								delete data[lblName];
								delete data[rel.getName()];
							}
						} else {
							data[attrName] = null;
							if (!nodelete) {
								delete data[lblName];
								delete data[rel.getName()];
							}
						}
					}
				} else {
					var records = rel.getValues(opts);
					this._processRecords(records, opts, {});
					data[rel.getName()] = records;
				}
			}
			
			for (var name in this.fixedFields) {
				var value = this.fixedFields[name];
				if (lang.isObject(value)) {
					data['$' + name] = value.variable;
				} else {
					var attr = this.model.getAttribute(name);
					if (attr.isEnum()) {
						var ename = attr.intToEnum(value);
						if (ename) {
							value = ename;
						}
					}
					data[name] = value;
				}
			}
			
			var attrs = this.model.getAttributes();
			for (var i in attrs) {
				var attr = attrs[i];
				switch (attr.getType()) {
				case 'TIME':
					var name = attr.getName();
					var val = data[name];
					if (val) {
						var date = stamp.fromISOString(val);
						data[name] = AMDate.fromDateToTimeStr(date);
					}
					break;
				}
			}
			
			if (opts && opts.full) {
				var children = this.getChildren();
				var relations = {};
				for (var i = 0; i < children.length; i++) {
					var cf = children[i];
					if (cf.isEnabled()) {
						var crel = cf.getRelation();
						var rel = this._findRelation(crel.getName());
						if (cf.isTransactional() && !rel) {
							var relName = crel.getName();
							var remoteName = crel.getRemoteName();
							var list = relations[relName];
							if (!list) {
								list = [];
								relations[relName] = list;
							}
							var cr = cf.createRecord({
								full: true
							});
							delete cr[remoteName];
							switch (crel.getCardinality()) {
							case 'ZERO_OR_ONE':
							case 'ONE':
								list[0] = cr;
								break;
							case 'ZERO_TO_MANY':
							case 'ONE_TO_MANY':
								list.push(cr);
								break;
							}
						}						
					}
				}
				lang.mixin(data, relations);
			}
			
			if (this.model.isDocument() && this.documents.length > 0) {
				for (var i = 0; i < this.documents.length; i++) {
					var doc = this.documents[i];
					if (doc.getDocument(data)) {
						break;
					}
				}
			}

			var rels = this.model.getRelationships();
			for (var i = 0; i < rels.length; i++) {
				var rel = rels[i];
				var relName = rel.getName();
				var attr = this.model.getAttributeForRelation(relName);
				if (attr) {
					var attrName = attr.getName();
					var records = data[relName];
					var rec = null;
					if (lang.isArray(records) && records.length == 1) {
						rec = records[0];
					} else if (lang.isObject(records)) {
						rec = records;
					}
					if (rec) {
						delete data[attrName];
					}
				}
			}

			for (var i = 0; i < this.datas.length; i++) {
				var dat = this.datas[i];
				var wdata = dat.build();
				data = lang.mixin(data, wdata);
			}

			this._cleanRecord(data);

			if (opts.override && lang.isObject(opts.override)) {
				lang.mixin(data, opts.override);
			}

			return data;
		},
		
		_cleanRecord: function(data) {
			var del = new Array();
			for (var name in data) {
				if (name.indexOf('$') == 0) {
					var key = name.substring(1);
					var val = data[key];
					if (val !== undefined && val !== null && val != "") {
						del.push(name);
					}
				}
			}
			
			for (var i = 0; i < del.length; i++) {
				delete data[del[i]];
			}
		},

		_findRelation: function(name) {
			var ret = null;
			for (var i in this.relations) {
				var w = this.relations[i];
				var rel = w.getRelation();
				if (rel.getName() == name) {
					ret = rel;
					break;
				}
			}
			return ret;
		},
		
	    /**
		*	Enable this form. This enables all widgets connected to this form.
	 	*	@instance
		*	@memberof Form
		*/
		enable: function() {
			this._setEnabled(true);
		},
		
	    /**
		*	Disable this form. This disables all widgets connected to this form.
	 	*	@instance
		*	@memberof Form
		*/
		disable: function() {
			this._setEnabled(false);			
		},
		
	    /**
		*	Check if this form is enabled or not
		*	@returns {Boolean} true if this form is enabled
	 	*	@instance
		*	@memberof Form
		*/
		isEnabled: function() {
			return this.enabled;
		},

		isLoadFailed: function() {
			return this.lastError != null;
		},

		getErrorDetails: function() {
			var details = null;
			var lastError = this.lastError;
			if (lastError) {
				var msg = lastError.error ? lastError.error.error : lastError;
				details = {
					status: lastError.response.status,
					message: msg
				};
			}
			return details;
		},

		isSuppressingErrors: function() {
			return this.suppress;
		},

		setSuppressErrors: function(suppress) {
			this.suppress = suppress;
		},
		
		_setEnabled: function(enabled) {
			this.enabled = enabled;
			for (var i in this.attributes) {
				var attr = this.attributes[i];
				var peer = attr.peer;
				if (lang.isFunction(peer.setEnabled)) {
					peer.setEnabled(enabled);
				}
			}
			for (var i in this.relations) {
				var rel = this.relations[i];
				var peer = rel.peer;
				if (lang.isFunction(peer.setEnabled)) {
					peer.setEnabled(enabled);
				}
			}
		},

		/**
		 * Validates the form's data.
		 * @param {Object} options - Configuration object.
		 * @param {Boolean} options.alert - If included an alert will be displayed if errors are found
		 * @returns {Boolean} - True if the form's data was valid, otherwise false.
		 * @memberof Form
		 * @instance
		 *
		 * @LogicMeta {
		 * 		"api": "Form",
		 *   	"paramtypes":["Object"],
		 * 		"returntype": "Boolean",
		 * 	"tooltip": "$"
		 * }
         */
		validate: function(opts) {
		    var ok = true;
			var firstInvalid = null;
			for (var i in this.documents) {
				var doc = this.documents[i];
				if (!doc.validate()) {
				    ok = false;
					this.validationError = doc._getValidationError();
					console.log("Form-document " + doc.getId() + " fails validation");
					firstInvalid = doc;
					break;
				}
			}
			
			if (ok) {
				for (var i in this.attributes) {
					var attr = this.attributes[i];
					if (!attr.validate()) {
						ok = false;
						console.log("Form-field " + attr.getName() + " fails validation");
						if (firstInvalid == null) {
							firstInvalid = attr;						
						}
					}
				}   
				
				if (ok) {
					for (var i in this.relations) {
						var rel = this.relations[i];
						if (!rel.validate()) {
							ok = false;
							console.log("Form-relation " + rel.getName() + " fails validation");
							if (firstInvalid == null) {
								firstInvalid = rel;						
							}

						}
					}
				}

                if(ok){
                    var childForms = this.getChildren();
                    if(childForms){
                        for (var i = 0; i < childForms.length; i++){
                            var childForm = childForms[i];
                            if(!childForm.validate()){
                                console.log("Childform " + childForm.getId() + " fails validation");
                                this.validationError = childForm.validationError;
                                ok = false;
                                break;
                            }
                        }
                    }
                }
                if (firstInvalid != null) {
                    firstInvalid.displayErrorMessage();
                }
			}

			if (!ok && opts && opts.alert) {
				var msg = this.validationError;
				if (!msg) {
					msg = messages.formValidationFailed;
				}
				this.view.getPageManager().alert('error', msg, null, messages.formValidationFailedTitle);
			}

            return ok;
		},

		/**
		 * Reset this form back to its default values
		 * @param {Boolean} focused - If set to true the form will focus the first input-field
		 * @memberof Form
		 * @instance
		 */
		reset: function(focused) {
		    this.item = this.model.createRecord({});
            for (var i = 0; i < this.documents.length; i++) {
				var doc = this.documents[i];
				doc.setDocument(null);
			}

			for (var i = 0; i < this.attributes.length; i++) {
				var attr = this.attributes[i];
				try {
					attr.reset();
					var def = this.model.getAttribute(attr.getName());
					if (def) {
						var dv = def.getDefaultValue();
						if (typeof(dv) !== "undefined") { 
							var val = dv;
							switch (def.getType()) {
							case 'INTEGER':
								val = parseInt(dv);
								break;
							case 'FLOAT':
								val = parseFloat(dv);
								break;
							}
							attr.setValue(dv);
						} else {
							attr.setValue(null);
						}
					} else {
						attr.setValue(null);
					}
				} catch (error) {
					console.error("Error resetting widget: " + attr.id);
				}
			}

			for (var i = 0; i < this.relations.length; i++) {
				var rel = this.relations[i];
				var attr = this.model.getAttributeForRelation(rel.name);
				if (attr) {
					rel.setValues(null);
				} else {
					rel.setValues(new Array());
					this.idCounters[rel.name] = 0;
				}
			}

			if (!focused) {
				var field = this._findFirstFocusField();
				if (this.view.focusFirst && field && !(client.isMobile() || client.isHybrid())) {
					console.log("View " + this.view.id + " focusing on " + field.id);
					field.focus();
					focused = true;
				} 				
			}
			
			var children = this.getChildren();
			if (children) {
				for (var i = 0; i < children.length; i++) {
					var cf = children[i];
					focused = cf.reset(focused);
				}
			}
			this.modified = {};
			return focused;
		},

		mustLoad: function(item) {
			var load = false;
			if (item && item.id && !Identity.hasTempId(item)) {
				for (var i = 0; i < this.relations.length; i++) {
					var felm = this.relations[i];
					var rel = felm.getRelation();
					if (rel != null) {
						var relName = rel.getName();
						var attr = this.model.getAttributeForRelation(relName);
						var attrVal = undefined;
						if (attr) {
							attrVal = item[attr.getName()];
						}
						if (!item[relName] && !(attr && (attrVal || attrVal == null))) {
							load = true;
						}
					}
				}
			}
			return load;
		},
		
		scanReferences: function() {
			var refs = this.loadedRelations;
			if (!refs) {
				refs = {};
			} else if (lang.isString(refs)) {
				var list = refs.split(/[ ,]+/);
				refs = {};
				for (var i = 0; i < list.length; i++) {
					refs[list[i]] = true;
				}
			}
			
			for (var i = 0; i < this.relations.length; i++) {
				var rel = this.relations[i];
				refs[rel.getName()] = true;
			}
			
			var children = this.getChildren();
			if (children) {
				for (var i = 0; i < children.length; i++) {
					var cf = children[i];
					refs[cf.relation.getName()] = true;
					var crefs = cf.scanReferences();
					for (var ref in crefs) {
						refs[cf.relation.getName() + '.' + ref] = true;
					}
				}				
			}
			return refs;
		},
		
		_refsToString: function(refs) {
			var str = null;
			var i = 0; 
			for (var ref in refs) {
				if (i > 0) {
					str = str + ",";
				} else {
					str = "";
				}
				str = str + ref; 
				i++;
			}
			return str;
		},

		/**
		 * @ignore
		 *
	 	*  Utility function for blockly.
	 	*  @LogicMeta {
        *   "api":"Form",
        *   "paramtypes":["String,ID", "Object"],
        *	"async":{}
        * }
	 	*/
		blocklyLoad: function(id, options) {
			this.load(id, options.onSuccess);
		},

		/**
		 * Loads the record with the specified id into the form.
		 * @param {ID | String} id - The ID of the record to load.
		 * @param {Function} callback - Callback when the load is completed.
		 * @memberof Form
		 * @instance
         */
		load: function(id, callback) {
			var t = this;
			t.lastError = null;
			if (!id && this.item) {
				id = this.item.id;
			}
			var featureStr = this.getFeaturesAsString();
			var orecord = null;
			if (lang.isObject(id) && id !== null) {
				orecord = id;
				id = orecord.id;
				if (!orecord.__model) {
					orecord = this.model.createRecord(orecord);
				}
			}
			var refs = this.scanReferences();
			var refStr = this._refsToString(refs);
			var def = null;
			if (!id) {
				def = new Deferred();
				def.reject("Invalid id: " + id);
			} else if (Identity.isTempId(id)) {
				var record = {
					id: id	
				};
				t.setData(record);
				def = new Deferred();
				def.resolve(record);
				if (callback) {
					callback(record);
				}
			} else {
				def = this.model.getById(id, {
					features: featureStr,
					relations: refStr
				}).then(function(record) {
					if (orecord) {
						record = orecord._merge(record);
					}
					t.setData(record);
					if (callback) {
						callback(record);
					}
					return record;
				}, function(error) {
					t.lastError = error;
					if (!t.suppress) {
						message = string.substitute(messages.failedToLoadRecord, {
							id: id,
							model: t.model.getLocalizedName()
						});
						t.view.getPageManager().alert('error', message + ": " + error);
					}
				});
			}
			return def;
		},
			
		_processValue: function(def, value) {
			if (def.type == "TIMESTAMP") {
				value = this._formatDate(value);
			} else if (value == undefined) {
				value = def.getDefaultValue();
			}
			return value;
		},

		observe: function(callback, options) {
			var t = this;
			this.observing = true;
			var observer = {
				callback: callback,
				options: options
			};
			this.observers.push(observer);
			this._startObserver();
			return {
				close: function() {
					var idx = this.observers.indexOf(observer);
					if (idx !== -1) {
						this.observers.splice(idx, 1);
						if (observers.length === 0) {
							t._stopObserver();
						}
					}
				}
			}
		},

		_startObserver: function() {
			var t = this;
			if (this.observerHandle) {
				this.observerHandle.close();
				this.observerHandle = null;
			}
			if (this.item.observe) {
				this.observerHandle = this.item.observe(function(message) {
					var rec = t.model.createRecord(message.content);
					t._onMessage(rec, message.headers);
					t.observers.forEach(function(observer) {
						try {
							if (observer.callback) {
								observer.callback(rec, message.headers);
							}
						} catch (error) {
							console.error(error);
						}
					});
				});
			}
		},

		_onMessage: function(record, headers) {
			var t = this;
			// nosemgrep: unsafe-formatstring
			console.log("Form[" + this.id + "] recevied message", record);
			debugger;
			var user = {
				id: headers['x-user'],
				name: headers['x-user-label']
			};
			var nrec = this.createRecord();
			var diff1 = this.org._diff(nrec);
			var diff2 = this.org._diff(record);
			var delta = diff1.diff(diff2);
			var attrs = delta.getAttributes();
			this.ignoreChanges = true;
			try {
				attrs.forEach(function (attr) {
					var diff = delta.getValueDiff(attr);
					console.log("Attribute " + attr + " original: " + t.org[attr]);
					console.log("Current: " + diff.oldValue + " New: " + diff.newValue);
					if (!t.modified[attr]) {
						t.setValue(attr, diff.newValue);
					} else {
						console.log("Conflict detected for attribute " + attr + ": " + diff.oldValue + " != " + diff.newValue);
					}
				});
			} finally {
				this.ignoreChanges = false;
			}
			var mname = this.model.getLocalizedName();
			var message = mname + " was updated by " + user.name;
			Alertify.set('notifier','position', 'bottom-right');
			Alertify.notify(message, "info", 2000);
		},

		_stopObserver: function() {
			if (this.observerHandle) {
				this.observerHandle.close();
			}
			this.observerHandle = null;
		},

		/**
		 * Sets the form's data to the specified record.
		 * @param {Record | Object} item - The record to use as the form's data.
		 * @memberof Form
		 * @instance
		 *
		 * @LogicMeta {
		 * 		"api": "Form",
		 * 		"paramtypes": ["Record, Object"],
		 * 		"tooltip": "$"
		 * }
         */
		setData: function(item) {
			console.log("Form: setData called for form " + this.id);
			if(!item) {
				item = this.model.createRecord({});
			} else {
				if (!item.__model) {
					item = this.model.createRecord(item);
				}
				for (var i = 0; i < this.documents.length; i++) {
					var doc = this.documents[i];
					doc.setDocument(item);
				}
			}
			this.org = item._clone();
			if (this.observing) {
				this._startObserver();
			}
			console.log(item);
			if (item != null) {
				for (var i = 0; i < this.attributes.length; i++) {
					var field = this.attributes[i];
					var name = field.getName();
					var value = item[name];
					this.setValue(name, value, [{
						field: field,
						rel: false
					}]);
				}
				
				for (var i = 0; i < this.relations.length; i++) {
					var field = this.relations[i];
					var name = field.getName();
					var value = item[name];
					if (!value) {
						var attr = this.model.getAttributeForRelation(name);
						if (attr) {
							name = attr.getName();
							value = item[name];
						}
					}
					try {
						this.setValue(name, value, [{
							field: field,
							rel: true
						}]);
					} catch (error) {
						console.error(error);
					}
				}
				this.item = item;
				this._setChildFormData(this, item, false);
			}
			this.modified = {};
			this.emit('update', this.item);
		}, 
		
		_setChildFormData: function(form, record, set) {
			if (set) {
				form.setData(record);				
			}
			var childForms = form.getChildren();
			if (childForms.length > 0) {
				var relatedForms = {};
				var relations = [];
				for (var i = 0; i < childForms.length; i++) {
					var cf = childForms[i];
					var relName = cf.getRelation().getName();
					var list = relatedForms[relName];
					if (!list) {
						list = [];
						relatedForms[relName] = list;
						relations.push(relName);
					}
					list.push(cf);
				}
				
				for (var i = 0; i < relations.length; i++) {
					var relation = relations[i];
					var childRecords = record[relation];
					var forms = relatedForms[relation];
					console.log("Found " + forms.length + " forms for relation " + relation);
					console.log("Found " + (Array.isArray(childRecords) ? childRecords.length : 1) + " records for relation " + relation);
					for (var j = 0; j < forms.length; j++) {
						var cf = forms[j];
						var rel = cf.getRelation();
						var relName = rel.getName();
						var childRecord = Array.isArray(childRecords) ? childRecords[j] : childRecords;					
						if (childRecord) {
							if (childRecord.id && cf.mustLoad(childRecord)) {
								cf.load(childRecord);
							} else {
								this._setChildFormData(cf, childRecord, true);								
							}
						} else {
							if (rel.getCardinality() == 'ZERO_OR_ONE' || rel.getCardinality() == 'ONE') {
								var childId = record[relName + '_id'];
								if (childId) {
									cf.load(childId);
								}
							} else {
								var revName = rel.getRemoteName() + '_id';
								if (cf.model.getAttribute(revName)) {
									var rec = {};
									rec[revName] = record.id;
									this._setChildFormData(cf, rec, true);						
								}						
							}
						}					
						
						/*
						if ((rel.getCardinality() == 'ZERO_OR_ONE' || rel.getCardinality() == 'ONE') || (lang.isObject(childRecord) && !lang.isArray(childRecord))) {
							if (childRecord) {
								if (lang.isArray(childRecord)) {
									childRecord = childRecord[0];
								}
								if (childRecord) {
									if (childRecord.id && cf.mustLoad(childRecord)) {
										cf.load(childRecord);
									} else {
										this._setChildFormData(cf, childRecord, true);								
									}
								}
							} else {
								var childId = record[relName + '_id'];
								if (childId) {
									cf.load(childId);
								}
							}
						} else {
							var revName = rel.getRemoteName() + '_id';
							if (cf.model.getAttribute(revName)) {
								var rec = {};
								rec[revName] = record.id;
								this._setChildFormData(cf, rec, true);						
							}
		 				}
		 				*/
		 			}
				}	
			}		
		},

		_prepareRecords: function(relation, records) {
			if (records) {
				if (lang.isArray(records)) {
					for (var i = 0; i < records.length; i++) {
						records[i] = this._prepareRecord(relation, records[i]);
					}
				} else {
					records = this._prepareRecord(relation, records);
				}				
			}
			return records;
		},
		
		_prepareRecord: function(relation, record) {
			if (record && record.declaredClass == 'appivo.model.Record') {
				//record = record.toJSON();
			} else if (lang.isObject(record)) {
				Identity.prepareItemId(record);	
				if (!record.__model) {
					record = relation.getDestination().createRecord(record);
				}
			}
			return record;
		},
		
		_processRecords: function(records, opts, ids, map) {
			if (!map) {
				try {
					map = new Set();
				} catch (err) {
					console.error("Set is not supported!");
				}
			}
			if (records) {
				if (lang.isArray(records)) {
					for (var i = 0; i < records.length; i++) {
						this._processRecord(records[i], opts, ids, map);
					}
				} else {
					this._processRecord(records, opts, ids, map);
				}							
			}
		},
		
		_processRecord: function(record, opts, ids, map) {
			if (map && map.has(record)) {
				return;
			} else if (map) {
				map.add(record);
			}

			if ((opts.keepIds || opts.submit) && ids[record.id]) {
				return;
			}
			if (!opts.keepIds && !opts.submit) {
				Identity.cleanItemId(record);							
			} else {
				ids[record.id] = true;
			}
			for (var key in record) {
				var val = record[key];
				if (lang.isArray(val)) {
					for (var i = 0; i < val.length; i++) {
						var sr = val[i];
						this._processRecord(sr, opts, ids, map);
					}
				}
			}
		},

		startAssistant: function() {
			var t = this;
			require(["appivo/ui/FormAssistant"], function(FormAssistant) {
				var fa = new FormAssistant({
					form: t
				});
				fa.start();
			});
		},

		mergeData: function(data, lenient) {
			var current = this.createRecord();
			var ldata = {};
			for (key in data) {
				var lkey = lenient ? key.toLowerCase() : key;
				ldata[lkey] = data[key];
			}
			for (key in current) {
				var lkey = lenient ? key.toLowerCase() : key;
				var nval = ldata[lkey];
				if (nval) {
					current[key] = nval;
				}
			}

			this.setData(current);
		},

		getFillInstructions: function() {
			var instructions = {};
			for (var i = 0; i < this.attributes.length; i++) {
				var entry = this.attributes[i];
				var def = null;
				if (!entry.relation) {
					var attr = entry.getAttribute();
					if (attr) {
						def = {
							type: attr.getType()
						};
						switch (attr.getType()) {
							case "ENUM":
								var opts = attr.getEnumOptions();
								var vals = [];
								opts.forEach(function(opt) {
									vals.push(opt.label);
								});
								break;
						}
						instructions[attr.getName()] = def;
					}
				}
			}
			return instructions;
		},

		/**
		 * Returns the model used by the form.
		 * @returns {Model} - The form's model
		 * @memberof Form
		 * @instance
		 *
		 * @LogicMeta {
		 * 		"api": "Form",
		 * 		"returntype": "Model",
		 * 		"tooltip": "$"
		 * 	}
         */
		getModel: function() {
			return this.model;
		},

		_formatDate: function(value) {
			if (value && lang.isString(value)) {
				//var end = value.length - 5;
				//value = value.substring(0, end) + 'Z';
				value = stamp.fromISOString(value);
			}
			return value;
		},

		getNextId: function(relation) {
			var id = this.idCounters[relation];
			if (id === undefined) {
				id = 0;
			} else {
				id = id + 1;
			}
			this.idCounters[relation] = id;
			return id;
		},

		_onMonitorEvent: function(name, event) {
			// nosemgrep: unsafe-formatstring
			console.log("Field " + name + " changed", event);
			if (!this.ignoreChanges) {
				this.modified[name] = true;
			}
		},
		
		addChild: function(attr) {
			var t = this;
			if (attr instanceof appivo.mvc.FormAttribute) {
				attr.setForm(this);
				if (attr instanceof appivo.mvc.FormRelation) {
					this.relations.push(attr);
				} else {
					this.attributes.push(attr);
					attr.watch('value', function(event) {
						t._onMonitorEvent(attr.attribute.name, event);
					});
				}
			} else if (attr instanceof appivo.mvc.FormDocument) {
				attr.setForm(this);
				this.documents.push(attr);
			} else if (attr instanceof appivo.mvc.FormData) {
				attr.setForm(this);
				this.datas.push(attr);
			}
		},

		addRelation: function(name, grid, store) {
			this.relations.push({name: name, grid: grid, store: store});
		},

		addAttribute: function(name, field) {
			this.attributes.push({name: name, field: field});
		},
				
		_findFirstFocusField: function() {
			var attr = null;
			var index = 65536;
			for (var i = 0; i < this.attributes.length; i++) {
				var widget = this.attributes[i];
				if (attr == null) {
					attr = widget;
				}
				var idx = widget.get('tabIndex');
				if (idx < index) {
					index = idx;
					attr = widget;
				}
			}
			return attr;
		},
	
		/**
		 * Change the original (loaded) value of a field in this form
		 * @param {String} name - Name of field to set
		 * @param {String | Number | Boolean | Object} value - Value to set
		 * @memberof Form
		 * @instance
		 */
		setOriginalValue: function(name, value) {
			if (!this.item) {
				this.item = {};
			}
			this.item[name] = value;
		},

		/**
		 * Gets the original value of a field in this form
		 * @param {String} name - Name of field to get value for
		 * @returns {*|undefined}
		 */
		getOriginalValue: function(name) {
			return this.item ? this.item[name] : undefined;
		},

		getOriginalRecord: function() {
			return JSON.parse(JSON.stringify(this.org));
		},
		
		setRawValue: function(name, value) {
			if (!this.item) {
				this.item = {};
			}
			this.item[name] = value;
		},
		
		_findField: function(name, read) {
			var field = new Array();
			for (var i in this.attributes) {
				var attr = this.attributes[i];
				if (attr.getName() == name) {
					if (read) {
						if (!attr.readOnly) {
							field.push({
								rel: false,
								field: attr
							});
						}
					} else {
						field.push({
							rel: false,
							field: attr
						});
					}
				}
			}
			if (field.length == 0) {
				for (var i in this.relations) {
					if (this.relations[i].getName() == name) {
						field.push({
							rel: true,
							field: this.relations[i]
						});
					}
				}
			}
			return field;
		},
		
		/**
		 * Set a value on this form
		 * @param {String} name - Name of field to set
		 * @param {String | Number | Boolean | Object} value - Value to set
		 * @memberof Form
		 * @instance
		 */
		setValue: function(name, value, fields) {
			if (!fields) {
				fields = this._findField(name, false);
			}
			if (!fields || fields.length === 0) {
				var attr = this.model.getAttribute(name);
				if (attr) {
					var rel = attr.getRelationship();
					if (rel) {
						fields = this._findField(rel.getName(), false);
					}
				}
			}
			if (fields && fields.length > 0) {
				for (var i = 0; i < fields.length; i++) {
					var field = fields[i];
					if (!field.rel) {
						var def = field.field.attribute;
						if (def) {
							value = this._processValue(def, value);
							field.field.setValue(value);
						}
					} else {
						var rel = field.field.getRelation();
						var relName = rel.getName();
						var attr = this.model.getAttributeForRelation(relName);
						if (!field.field.setValues) {
							if (value && value.length && !lang.isString(value) && value.length > 0) {
								value = value[0];
							}
							if (lang.isObject(value) && value != null) {
								if (typeof(value.id) !== undefined) {
									value = value.id;
								}
							}
							if (value != null) {
								value = value.toString();
							}
							field.field.setValue(value);
						} else {
							if (value && lang.isString(value)) {
								value = {
									id: value
								};
							}
							value = this._prepareRecords(rel, value);
							if (value) {
								field.field.setValues(value);
							} else {
								field.field.setValues([]);
							}
						}
					}
				}
			} else {
				if (!this.item) {
					this.item = {};
				}
				this.item[name] = value;
			}
		},
		
		/**
		 * Check if a value has changed in this form since it was loaded
		 * @param {String} name - Name of field to check
		 * @memberof Form
		 * @instance
		 */
		hasChanged: function(name) {
			var val = this.org[name];
			var nval = this.getValue(name);
			if (val === null && nval === null) {
				return false;
			} else if (val === null || nval === null) {
				return true;
			} else if (val === undefined && nval === undefined) {
				return false;
			} else if (val == undefined || nval === undefined) {
				return true;
			} else {
				return val != nval;
			}
		},

		/**
		 * Get a value from this form
		 * @param {String} name - Name of field to get
		 * @param {Boolean} original - If true it will get the original value of this field
		 * @memberof Form
		 * @instance
		 */
		getValue: function(name, original, keepIds) {
			var value = null;
			var fields = null;
			if (!original) {
				fields = this._findField(name, true);
			}
			var sumValue;
			if (fields && fields.length > 0) {
				for (var i = 0; i < fields.length; i++){
					var field = fields[i];
					if (field.rel) {
						var attr = this.model.getAttributeForRelation(field.field.getName());
						if (attr) {
							var relid = field.field.getValue();
							if (relid) {
								value = relid;
							}
						} else {
							var records = field.field.getValues();
							this._processRecords(records, {keepIds: keepIds}, {});
							value = records;
						}
					} else {
						var value = field.field.getValue();
						var def = field.field.getAttribute();
						if (typeof(def) !== "undefined") {
							switch (def.type) {
							case 'FLOAT':
								if (lang.isString(value)) {
									value = parseFloat(value);
								}
								break;
							case 'INTEGER':
								if (lang.isString(value)) {
									value = parseInt(value);
								}
								break;
							case 'DATE':
							case 'TIME':
							case 'TIMESTAMP':
								if (value) {
									var widgetDef = field.field.getWidgetDefinition();
									var oldValue = this.item ? this.item[name] : null;
									if (lang.isString(value)) {
										value = stamp.fromISOString(value);
									}
									var comp = stamp.toISOString(value, {selector: widgetDef.timeComponent});
									var newDate = stamp.fromISOString(comp, oldValue);

									if (sumValue){
                                        var sumDate = stamp.fromISOString(sumValue);
                                        if (widgetDef.timeComponent == 'time'){
                                            newDate.setFullYear(sumDate.getFullYear());
                                            newDate.setMonth(sumDate.getMonth());
                                            newDate.setDate(sumDate.getDate());
                                        }
                                        if (widgetDef.timeComponent == "date"){
											newDate.setHours(sumDate.getHours());
											newDate.setMinutes(sumDate.getMinutes());
											newDate.setSeconds(sumDate.getSeconds());
                                        }
                                    }
                                    value = stamp.toISOString(newDate);
                                    sumValue = value;
								}
								break;
							case 'ENUM':
								value = def.intToEnum(value);
								break;
							}
						}
					}
				}
			} else if (this.item) {
				value = this.item[name];
			}
			
			var modelAttr = this.model.getAttribute(name);
			if (modelAttr && value) {
				if (modelAttr.getType() == 'DATE') {
					var idx = value.indexOf('T');
					if (idx > 0) {
						value = value.substring(0, idx);
					}
				}
			}
			
			return value;
		},
		
		serialize: function() {
			var json = {
				id: this.id,
				fixedFields: this.fixedFields,
				enabled: this.isEnabled(),
				suppress: this.isSuppressingErrors()
			};
			if (this.loadedRelations) {
				json.loadedRelations = this.loadedRelations;
			}
			if (this.features && this.features.length > 0) {
				json.features = this.features;
			}
			if (this.parent != null) {
				json.parent = this.parent.getId();
				json.relation = this.relation ? this.relation.getName() : null;
				json.transactional = this.isTransactional();
			} else if (this.model != null) {
				json.modelName = this.model.getName();
			}
			return json;
		},
		
		destroy: function() {
			this.closed = true;
			this._stopObserver();
		}
	})
});

},
'appivo/ui/FormAssistant':function(){
define([
    "appivo/client/Client"
], function(Client) {
    const client = Client.getInstance();
    const FormFillURL = "/api/service/ai-runtime/fillForm";
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    const SpeechGrammarList = window.SpeechGrammarList || window.webkitSpeechGrammarList;
    const SpeechRecognitionEvent = window.SpeechRecognitionEvent || window.webkitSpeechRecognitionEvent;

    function FormAssistant(options) {
        this.state = "stopped";
        this.recognition = new SpeechRecognition();
        if (options) {
            this.form = options.form;
            this.recognition.continuous = false;
        }
    }

    FormAssistant.prototype = {

        start: function() {
            var t = this;
            t.state = "listening";
            console.log("starting...");
            var p = new Promise(function(resolve, reject) {
                t.promise = {
                    resolve: resolve,
                    reject: reject
                };
                t.recognition.addEventListener("result", function (event) {
                    debugger;
                    if (typeof event.results === "undefined") {
                        return;
                    }
                    const result = event.results[event.results.length - 1];
                    if (result.isFinal) {
                        const transcript = result[0].transcript.trim();
                        console.log("TRANSCRIPT: " + transcript);
                        if (t.state != 'waiting') {
                            t.fill(transcript);
                        }
                    }
                });
                t.recognition.onspeechend = function (event) {
                    t.recognition.stop();
                };
                t.recognition.start();
            });
            return p;
        },

        getState: function() {
            return this.state;
        },

        stop: function() {
            this.recognition.stop();
            this.state = "stopped";
        },

        fill: function(transcript) {
            var t = this;
            var instructions = this.form.getFillInstructions();
            var args = [instructions, transcript];
            this.state = "waiting";
            client.sendRequest(FormFillURL, {
                method: 'POST',
                contentType: 'application/json',
                data: args
            }).then(function(reply) {
                t.state = "stopped";
                if (reply.status == "ok") {
                    t.form.mergeData(reply.form, true);
                } else {
                    console.error(reply.response);
                }
                if (t.promise) {
                    t.promise.resolve(reply);
                    t.promise = null;
                }
            },function(error) {
                t.state = "stopped";
                alert("An error occured: " + error);
                t.promise.reject(error);
                t.promise = null;
            });
        }
    };

    return FormAssistant;
});
},
'appivo/mvc/FormAttribute':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'appivo/mvc/Widget'], function(lang, declare, Widget) {
	return declare("appivo.mvc.FormAttribute", [appivo.mvc.Widget], {

		attribute: null,
		readOnly: false,
		
		constructor: function(options) {
			lang.mixin(this, options);
			this.children = new Array();
			this.widgetType = 'ATTRIBUTE';
		},

		isReadOnly: function() {
			return this.readOnly;
		},
		
		getAttribute: function() {
			return this.attribute;
		},
		
		getName: function() {
			return this.attribute.getName();
		},
				
		serialize: function() {
			var json = this.inherited(arguments);
			if (this.attribute) {
				json.attributeName = this.attribute.getName();
			}
			return json;
		}
	});
});
},
'appivo/mvc/Widget':function(){
define(['dojo/_base/lang',
        'dojo/_base/declare',
        'dojo/Deferred',
        'dojo/on',
        'dojo/Evented',
		'appivo/util/Handlebars',
		'appivo/util/Equals',
		'appivo/theme/StyleManager',
        'appivo/util/Identity'], function(lang, declare, Deferred, on, Evented, Handlebars, Equals, StyleManager, Identity) {
	return declare("appivo.mvc.Widget", [Evented], {

		id: null,
		type: null,
		parent: null,
		widget: null,
		style: null,
		form: null,
		features: null,
		privs: null,
		children: null,
		supporting: null,
		actionEngine: null,
		isContainer: false,
		widgetType: null,
		widgetDef: null,
		model: null,
		properties: null,
		handlers: null,
		intrinsicHandlers: null,
		resizableChildren: true,
		draggableChildren: true,
		droppableChildren: true,
		maximizable: false,
		maximized: "no",
		resizable: undefined,
		draggable: true,
		droppable: true,
		onDestroy: null,
		overlay: null,
		scriptScope: null,
		view: null,
		overlayListeners: null,
		_setValue: null,
		_getValue: null,
		fixedChildren: false,
		monitors: null,
		monitorId: 0,
		errorMsg: null,
		styleProps: undefined,
		oldStyle: null,
		hidden: false,
		onHide: null,
		rendered: false,
		destroyed: false,
		isVisible: false,

		constructor: function(options) {
			this.properties = {};
			this.widgetType = 'NONE';
			this.handlers = {};
			this.monitors = {};
			this.overlayListeners = new Array();
			this.listenerHandles = {};
			lang.mixin(this, options);
			if (this.widget) {
				this.widget._widget = this;
			}
			this.children = new Array();
			this.supporting = new Array();
			if (!this.styleManager) {
				this.styleManager = StyleManager;
			}
		},

		setView: function(view) {
			this.view = view;
		},

		getId: function() {
			return this.id;
		},

		getParent: function() {
			return this.parent;
		},

		getWidget: function() {
			return this.widget;
		},

		getWidgetType: function() {
			return this.widgetType;
		},

		getWidgetDefinition: function() {
			return this.widgetDef;
		},

		setWidgetDefinition: function(widgetDef) {
			this.widgetDef = widgetDef;
		},

		getType: function() {
			return this.widgetDef.name;
		},

		getAttribute: function() {
			return null;
		},

		hasResizableChildren: function() {
			return this.resizableChildren;
		},

		hasDraggableChildren: function() {
			return this.draggableChildren;
		},

		isDroppable: function() {
			return this.droppable;
		},

		observeVisibility: function(view) {
			var t =  this;
			t.intersectionObserver = new IntersectionObserver(function (entries, opts) {
				entries.forEach(function (entry) {
					var node = entry.target;
					t.isVisible = entry.isIntersecting;
					t.emitSyntheticEvent('viewable', {
						viewable: t.isVisible
					});
				});
			}, {
				root: view.widget.domNode,
				threshold: 0.75
			});
			t.intersectionObserver.observe(t.widget.domNode);
		},

		isMaximizable: function() {
		    return this.maximizable;
		},

		isMaximized: function() {
			var max = false;
			switch (this.maximized) {
				case "yes":
				case "ver":
				case "hor":
					max = true;
					break;
			}
			return max;
		},

		getMaximizationMode: function() {
			return this.maximized;
		},

		getMaxSize: function() {
			var margin = this.styleProps ? this.styleProps.margin : undefined;
			var maxSize = "100%";
			if (margin) {
				maxSize = "calc(100% - " + (2 * margin) + "px)";
			}
			return maxSize;
		},

		maximize: function(mode) {
			if (mode == true) {
				mode = "yes";
			} else if (mode == false) {
				mode = "no";
			} else if (mode === "hor" || mode === "ver") {
				// Do nothing
			} else if (mode !== "no") {
				mode = "yes";
			} else {
				mode = "no";
			}
			this.maximized = mode;
			this.maxi = mode;
			maxSize = this.getMaxSize();
			switch (mode) {
				case "yes":
					$(this.widget.domNode).css({
						top: '0px',
						left: '0px',
						width:  maxSize,
						height: maxSize
					});
					break;
				case "hor":
					var height = (this.properties.position.height * 8) + "px";
					if (!this.widget._editMode && this.properties.autoHeight) {
						height = "auto";
					}
					$(this.widget.domNode).css({
						left: '0px',
						width:  maxSize,
						height: height
					});
					break;
				case "ver":
					var width = (this.properties.position.width * 8) + "px";
					$(this.widget.domNode).css({
						top: '0px',
						height: maxSize,
						width: width
					});
					break;
			}
			this._onMaximize(mode);
		},

		_onMaximize: function() {
		},

		setHidden: function() {
			this.hidden = true;
			this.peer.hide();
		},

		showOverlay: function(show) {
			if (this.overlay) {
				$(this.overlay).css({
					display: show ? 'block' : 'none'
				});
			}
		},

		isContainerWidgetWithOverlay : function functionName() {
			//return this.isSplitPane() || this.isSplitPaneContainer();

			return (this.isTabPane() || this.isSplitPane() || this.isTabPaneChildren() || this.isSplitPaneContainer());
		},

		isContainerWidgetWrapper: function () {
			return (this.isTabPaneChildren() || this.isSplitPaneContainer());
		},

		isHeightMaximized: function() {
			var max = false;
			switch (this.maximized) {
				case "yes":
				case "ver":
					max = true;
					break;
			}
			return max;
		},

		isWidthMaximized: function() {
			var max = false;
			switch (this.maximized) {
				case "yes":
				case "hor":
					max = true;
					break;
			}
			return max;
		},

		maximizedWidth: function() {
			var mx = this.maxi;
			if (mx == "no" || mx == "ver") {
				var w = this.properties && this.properties.position ? this.properties.position.width : 32;
				return (w * 8) + "px";
			} else {
				return this.getMaxSize();
			}
		},

		maximizedHeight: function() {
			var mx = this.maxi;
			if (mx == "no" || mx == "hor") {
				var h = this.properties && this.properties.position ? this.properties.position.height : 32;
				return (h * 8) + "px";
			} else {
				return this.getMaxSize();
			}
		},

		offsetChildrenOverlays: function (x, y) {
			for (const child of this.getChildren()) {
				const oldTop = parseInt(child.overlay.style.top);
				child.overlay.style.top = (oldTop - y) + "px";
			}
		},

		createOverlay: function(defaultParent) {
			var widgetDef = this.widgetDef;
			var w = this.widget;
			var orgNode = w.domNode;
			var parent = this.getParent();
			var parentNode = orgNode.parentNode;
			if (parent != null) {
				var parentNode = parent.getOverlay();
				if (parentNode == null) {
					parentNode = defaultParent;
				}
			}

			var node = null;

			if (parentNode) {
				if (false) {
				//if (widgetDef.category == 'container' && this.isContainerWidgetWithOverlay()) {
					node = orgNode;
					$(node).addClass('editOverlay');
					this.overlay = orgNode;
					if (widgetDef.name == "SplitPane") {
						$(w.compOne).addClass('editOverlay');
						$(w.compTwo).addClass('editOverlay');
					}
				} else {
					node = document.createElement('div');
					parentNode.appendChild(node);

					var bodyNode = document.createElement('div');
					$(bodyNode).css({
						'width': '100%',
						'height': '100%'
					});
					node.appendChild(bodyNode);
					node.id = this.id + '_ovl';
					$(node).addClass('editOverlay');
					bodyNode._widget = this;
					var style = window.getComputedStyle(orgNode);
					var height = style.height;
					var width = style.width;
					if (style.overflow === "visible") {
						height = orgNode.scrollHeight + 'px';
						width = orgNode.scrollWidth + 'px';
					}
					if (style.overflowX === 'visible') {
						width = orgNode.scrollWidth + 'px';
					}
					if (style.overflowY === 'visible') {
						height = orgNode.scrollHeight + 'px';
					}
					var css = {
						'position': 'absolute',
						'z-index': 5 + (w.position && w.position.z !== null && w.position.z !== undefined ? w.position.z - 2 : 0),
						'overflow': 'hidden',
						'width': this.isWidthMaximized() ? this.maximizedWidth() : width,
						'height': this.isHeightMaximized() ? this.maximizedHeight() : height
					};
					$(node).css(css);
					$(node).offset($(orgNode).offset());
					$(orgNode).css({
						transition: "all 0s ease 0s"
					});

					this.overlay = node;
				}
			}
			//console.log("creating overlay for widget :: ", w.id, node);
			return node;
		},

		resizeOverlay: function(resizeChildren) {
			if (this.overlay) {
				var orgNode = this.widget.domNode;
				var style = window.getComputedStyle(orgNode);
				var height = style.height;
				var width = style.width;
				if (style.overflow === "visible") {
					height = orgNode.scrollHeight + 'px';
					width = orgNode.scrollWidth + 'px';
				}
				if (style.overflowX === 'visible') {
					width = orgNode.scrollWidth + 'px';
				}
				if (style.overflowY === 'visible') {
					height = orgNode.scrollHeight + 'px';
				}
				if (this.isContainerWidgetWrapper()) {
					// check if this is immediate child of SplitPane
					$(this.overlay).css({
						'width': '100%',
						'height': '100%'
					});
				} else {
					$(this.overlay).css({
						'width': this.isWidthMaximized() ? this.maximizedWidth() : width,
						'height': this.isHeightMaximized() ? this.maximizedHeight() : height
					});
				}
				$(this.overlay).offset($(orgNode).offset());
				if (resizeChildren === true && this.children.length > 0) {
				    for (var i = 0; i < this.children.length; i++) {
				        this.children[i].resizeOverlay(resizeChildren);
				    }
				}
			}
		},

		removeOverlay: function() {
			if (this.overlay) {
				this.overlay.parentNode.removeChild(this.overlay);
				this.overlay = null;
			}
		},

		getOverlay: function() {
			return this.overlay;
		},

		setOverlay: function(overlay) {
			this.overlay = overlay;
		},

		setForm: function(form) {
			this.form = form;
		},

		getForm: function() {
			return this.form;
		},

		getModel: function() {
			return this.model;
		},

		getPreviousSibling: function() {
			var sibling = null;
			var i = -1;
			if (this.parent) {
				var idx = this.parent.getChildIndex(this);
				if (idx > 0) {
					sibling = this.parent.getChildByIndex(idx - 1);
				}
			}
			return sibling;
		},

		getNextSibling: function() {
			var sibling = null;
			var i = -1;
			if (this.parent) {
				var idx = this.parent.getChildIndex(this);
				if ((idx  + 1) < this.parent.getChildCount()) {
					sibling = this.parent.getChildByIndex(idx + 1);
				}
			}
			return sibling;
		},

		addChild: function(widget, index) {
			widget.parent = this;
			if (index != undefined) {
				this.children.splice(index, 0, widget);
			} else {
				this.children.push(widget);
			}
			this._addChild(widget, index);
		},

        moveChild:function (widget, currentIndex, newIndex) {
            this.children = this.widget.array_move(this.children, currentIndex, newIndex);
            this.widget._moveChild(widget,currentIndex, newIndex);
        },



		getChildCount: function() {
			return this.children.length;
		},

		getChildByIndex: function(index) {
			var child = null;
			if (index >= 0 && index < this.children.length) {
				child = this.children[index];
			}
			return child;
		},

		getChildIndex: function(widget) {
			var index = this.children.indexOf(widget);
			if (index == -1) {
				index = undefined;
			}
			return index;
		},

		_addChild: function(widget, index) {
			if (this.widget) {
				if (this.widgetDef.addChild) {
					this.widgetDef.addChild(this, widget, index);
				} else if (this.widget.addChild) {
					this.widget.addChild(widget.widget, index);
				}
			}
		},

		addSupporting: function(widget) {
			console.log("Adding support-widget " + widget.id + " to " + this.id);
			if (widget.getChildren) {
				var children = widget.getChildren();
				for (var i in children) {
					console.log("Adding child support-widget " + children[i].id);
				}
			}
			this.supporting.push(widget);
		},

		removeChild: function(widget) {
			var index = -1;
			for (var i in this.children) {
				if (this.children[i].id == widget.id) {
					index = i;
					break;
				}
			}
			var found = index != -1
			if (found) {
				this.children.splice(index, 1);
				this._removeChild(widget);
			}
			return found;
		},

		_removeChild: function(widget) {
			if (this.widget && this.widget.removeChild) {
				this.widget.removeChild(widget.widget);
			}
		},

		resize: function() {
			if (this.widget && this.widget.resize) {
				this.widget.resize();
			}
			this.resizeOverlay();
			this.emit('resize', {});

			for (var i in this.children) {
				this.children[i].resize();
			}
		},

		isSplitPane: function () {
			return (this.widgetDef.name == "SplitPane");
		},

		isTabPane: function () {
			return (this.widgetDef.name == "TabContainer");
		},

		isSplitPaneContainer: function () {
			var parent = this.getParent();
			return (parent && (this.widgetDef.name == "GridContainer") && parent.widgetDef.name == "SplitPane");
		},

		isTabPaneChildren: function () {
			var parent = this.getParent();
			if (parent && (this.widgetDef.name == "TabItemContainer" || this.widgetDef.name == "GridContainer")) {
				return (parent.widgetDef.name == "TabContainer");
			}
			return false;
		},

		highlight: function(on, bg) {
		    if (this.overlay) {
		        var node = $(this.overlay);
		    } else {
		        var node = $(this.widget.domNode);
		    }
			if (this.isSplitPane() || this.isSplitPaneContainer()) {
				if (on) {
					node.addClass('split-hover');
				} else {
					node.removeClass('split-hover');
				}
			} else {
				if (on) {
					this.oldStyle = node.css(['background']);
					this.oldStyle.outline = 'none';
					if (!bg) {
						bg = (this.view.uiType === 'mobile' ? 'rgba(0, 153, 204, 0.5)' : 'rgba(51, 204, 51, 0.5)')
					}
					node.css({
						'outline': this.view.uiType === 'mobile' ? '1px solid #09c' : '2px dashed #33cc33',
						'background': bg
					});
				} else {
					node.css(this.oldStyle);
					this.oldStyle = null;
				}
			}
		},

		createPeer: function() {
			var widgetPeer = {
				widget: this
			};
			lang.mixin(widgetPeer, this.widgetDef.peer);
			this.peer = widgetPeer;
			return widgetPeer;
		},

		getCodeProperty: function(key, args) {
			var func = null;
			var obj = this.properties[key];
			if (obj) {
				if (obj && obj.script) {
					try {
						var script = obj.script;
						if (obj.script.script) {
							script = obj.script.script;
						}
						var arr = ["context"];
						if (args && Array.isArray(args)) {
							arr = arr.concat(args);
						}
						arr.push(script);
						func = Function.apply(this, arr);
					} catch (error) {
						console.error(error);
					}
				}
			}
			return func;
		},

		getChildren: function() {
			return this.children;
		},

		_findFunc: function(props, name, type, cache) {
			var func = null;
			var prop = props[name];
			if (prop) {
				if (prop[type]) {
					func = lang.hitch(this, prop[type]);
				} else if (type == 'get' && cache) {
					if (prop['set']) {
						func = lang.hitch(this, function() {
							return this.properties[name];
						});
					}
				}
			}
			return func;
		},

		_getFunc: function(name, type) {
			var func = null;
			if (this.widgetDef) {
				if (this.widgetDef.typeProperties) {
					var props = this.widgetDef.typeProperties[this.widgetType];
					if (props) {
						func = this._findFunc(props, name, type, false);
					}
				}
				if (!func && this.widgetDef.properties) {
					func = this._findFunc(this.widgetDef.properties, name, type, true);
				}
			}
			return func;
		},

		watch: function(attribute, handler) {
			return this.widget.watch(attribute, handler);
		},

		monitor: function(attribute, handler) {
			var handlers = this.monitors[attribute];
			if (!handlers) {
				handlers = new Array();
				this.monitors[attribute] = handlers;
			}
			var handle = {
				id: this.monitorId++,
				handler: handler
			};
			handle.remove = lang.hitch(this, this._removeMonitor, attribute, handle);

			handlers.push(handle);
			return handle;
		},

		_removeMonitor: function(attribute, toRemove) {
			var handlers = this.monitors[attribute];
			if (handlers) {
				for (var i = 0; i < handlers.length; i++) {
					var handle = handlers[i];
					if (handle.id == toRemove.id) {
						handlers.splice(i, 1);
						break;
					}
				}
			}
		},

		_notifyMonitors: function(attribute, value) {
			var handlers = this.monitors[attribute];
			if (handlers) {
				for (var i = 0; i < handlers.length; i++) {
					var handle = handlers[i];
					try {
						handle.handler(attribute, value);
					} catch (error) {
						console.error(this.id + " failed to notify monitor of attr " + attribute);
						console.error(error);
					}
				}
			}
		},

		getHandler: function(event) {
			return this.handlers[typeof event === 'string' ? event : event.name];
		},

		setHandler: function(handler, intrinsic) {
			this.disconnectEventHandler(handler.event);
			if (handler.script) {
			    if (handler.script.script && typeof handler.script.script == "string") {
			        var script = handler.script.script;
			        handler.script.script = {
			            script: script
			        };
			    }
				this.connectEventHandler(this.widget, handler.event.toLowerCase(), handler.script);
				if (!intrinsic) {
					this.handlers[handler.event] = handler;
				}
			} else {
				// REMOVE
				delete this.handlers[handler.event];
			}
		},

		setScriptScope: function(scope) {
			this.scriptScope = scope;
			for (var i in this.children) {
				var child = this.children[i];
				child.setScriptScope(scope);
			}
		},

		clearEventHandlers: function() {
			if (this.listenerHandles) {
				for (var handle in this.listerHandles) {
					handle.remove();
				}
				this.listenerHandles = {};
				this.handlers = {};
			}
		},

		disconnectEventHandler: function(event) {
			var handle = this.listenerHandles[event];
			if (handle) {
				handle.remove();
				delete this.listenerHandles[event];
			}
		},

		getScopeDescriptor: function() {
			var ui = this.view.viewManager.getUserInterfaceName();
			var view = this.view.id;
			var widget = this.id;
			return ui + "/" + view + "/" + widget;
		},

		connectEventHandler: function(widget, event, script) {
			var actionId = this.actionEngine.defineAction(script, event, widget);
			var scope = this.peer;
			if (this.scriptScope) {
				scope = this.scriptScope;
			}

            var eventDef = this.widgetDef.events.find(function(item) {
                return (item.name && item.name.toLowerCase() === event);
            });


			var t = this;
			var func = function(event) {
				if (!t.view.closed) {
					t.actionEngine.executeAction(scope, actionId, event);
				} else {
					console.log("Ignoring event as view is closed");
				}
			};

			//var func = lang.hitch(this.actionEngine, lang.partial(this.actionEngine.executeAction, scope, actionId));
			var handle = null;
			if (this.customBindEvent) {
				handle = this.customBindEvent(widget, event, func);
			}

            if (handle == null && eventDef && eventDef.handler) {
                handle = this.bindEvent(widget, event, eventDef.handler);
            }


			if (handle == null) {
				handle = this.bindEvent(widget, event, func);
			}
			this.listenerHandles[event] = handle;
		},

		bindEvent: function(widget, event, handler) {
			return widget.on(event, handler);
		},

		recordEvent: function(event) {
			if (this.view && this.view.viewManager && !this.view.booting) {
				this.view.viewManager.recordEvent(event);
			}
		},

		setHandlers: function(handlers) {
			var t = this;
			if (handlers) {
				this.clearEventHandlers();
				this.handlers = lang.clone(handlers);
				for (var event in handlers) {
					var script = handlers[event];
					if (typeof script == "string") {
						script = {
							script: script
						};
					}
					this.setHandler({
						event: event,
						script: script
					}, false);
				}
			}
			if (this.intrinsicHandlers) {
				for (var event in this.intrinsicHandlers) {
					var script = this.intrinsicHandlers[event];
					this.setHandler({
						event: event,
						script: script.script
					}, true);
				}
			}
		},

		emitSyntheticEvent: function(event, data) {
			if (this.widget) {
				this.widget.emit(event, data);
			} else {
				console.warn("Attempt at emitting event " + event + " for destroyed widget " + this.id);
			}
		},

		setProperties: function(properties) {
			this.properties = properties;
		},

		set: function(name, value) {
			var func = this._getFunc(name, 'set');
			if (func) {
				var ret = func(value);
				if (ret != undefined) {
					value = ret;
				}
			} else {
				this.widget.set(name, value);
			}
			this.properties[name] = value;
			on.emit(this, {
				property: name,
				value: value
			});
		},

		get: function(name) {
			var value = null;
			var func = this._getFunc(name, 'get');
			if (func) {
				value = func();
			} else if (this.widget) {
				value = this.widget.get(name);
			}
			if (value == null || value == undefined) {
				value = this.properties[name];
			}
			return value;
		},

		ready: function() {
			if (this.widget.onLoadDeferred) {
				return this.widget.onLoadDeferred;
			}
			var def = new Deferred();
			def.resolve(this);
			return def;
		},

		setValue: function(value) {
			if (this._setValue) {
				this._setValue(value);
				this._notifyMonitors('value', value);
			} else {
				if (this.widget.onLoadDeferred) {
					this.widget.set('value', value);
					this.widget.onLoadDeferred.then(lang.hitch(this, function() {
						this.widget.set('value', value);
						this._notifyMonitors('value', value);
					}));
				} else {
					this.widget.set('value', value);
					this._notifyMonitors('value', value);
				}
			}
		},

		getValue: function() {
			var val = null;
			if (this._getValue) {
				val = this._getValue();
			} else if (this.widget) {
				var val = this.widget.get('value');
				if (this.widget.declaredClass == "dijit.form.CheckBox") {
					val = (val == 'on');
				}
			}
			return val;
		},

		getItemValue: function() {
			var item = null;
			if (this._getItemValue) {
				item = this._getItemValue();
				Identity.cleanItemId(item);
			}
			return item;
		},

		focus: function() {
			if (lang.isFunction(this.widget.focus)) {
				this.widget.focus();
			}
		},

		blur: function() {
			if (lang.isFunction(this.widget.blur)) {
				this.widget.blur();
			} else if (this.widget.domNode) {
				this.widget.domNode.blur();
			}
		},

		reset: function() {
			if (lang.isFunction(this.widget.reset)) {
				try {
					this.widget.reset();
				} catch (error) {
					console.log(error);
				}
			}
		},

		displayErrorMessage: function() {
			this.focus();
			if (this.widget.getErrorMessage) {
				var msg = this.widget.getErrorMessage(true);
				this.widget.displayMessage(msg);
			}
		},

		validate: function() {
			var ok = false;
			if (this.widget.validate) {
				this.focus();
				ok = this.widget.validate(true);
			} else if (this._validate) {
				ok = this._validate();
			} else if (this.widget._validate){
			    ok = this.widget._validate();
			} else {
				ok = true;
			}
			return ok;
		},

		_getActionContext: function() {
			return this.actionEngine.getContext();
		},

		_setValidationError: function(errorMsg) {
			this.errorMsg = errorMsg;
		},

		_getValidationError: function() {
			var msg = this.errorMsg;
			this.errorMsg = null;
			return msg;
		},

		_setSize: function(pos) {

		},

		_getRealSize: function() {
			return undefined;
		},

		_getStyleDocument: function() {
			return document;
		},

		resetStyle: function() {
			var sm = this.styleManager;
			sm.unsetWidgetStyle(this);
			this.setStyleProps(this.orgStyleProps);
		},

		setStyleProps: function(styleProps) {
			var themeStyles = {};
			var merged = this.widgetDef._getDefaultStyle();
			if (this.orgStyleProps) {
				lang.mixin(merged, this.orgStyleProps);
			}
			if (styleProps) {
				lang.mixin(merged, styleProps);
			}
			var styleStr = JSON.stringify(merged);
			var compiled = Handlebars.compile(styleStr);
			var updatedStyleStr = compiled(this._selectedTheme);
			var computed = JSON.parse(updatedStyleStr);
			this.styleProps = styleProps;

            //to-do fix this
			var sm = this.styleManager;
			if (computed) {
				sm.setWidgetStyle(this, computed);
			} else {
				sm.unsetWidgetStyle(this);
			}
			this.resizeOverlay(true);
		},
		
		setStyleProp: function (styleProp, value) {
			let props = this.getStyleProps();
			if (!props) {
				props = {};
			}
			props[styleProp] = value;
			this.setStyleProps(props);
		},

		getStyleProps: function(styleProps) {
			return this.styleProps;
		},

		serialize: function(options) {
			options = options || {};
			var json = {
				id: this.id,
				widgetType: this.widgetDef.name
			};

			var features = this.get('features');
			if (features && features.length > 0) {
				json.features = features;
			}
			var privs = this.get('privs');
			if (privs && privs.length > 0) {
				json.privs = privs;
			}
			if (this.form) {
				json.formName = this.form.getId();
			}
			var props = this.widgetDef.properties;
			if (props) {
				for (var key in props) {
					var val = this.get(key);
					var orgVal = this.get(key + ".org");
					if (orgVal !== undefined) {
						val = orgVal;
					}
					var propDef = props[key];
					if (val !== undefined) {
						var dv = propDef.defaultValue;
						if (dv !== undefined) {
							if (!Equals(val,dv)) {
								json[key] = val;
							} else if (options.verbose) {
								json[key] = dv;
							}
						} else {
							json[key] = val;
						}
					}
				}
			}
			if (this.widgetDef.typeProperties) {
				var tprops = this.widgetDef.typeProperties[this.widgetType];
				if (tprops) {
					for (var key in tprops) {
						var val = this.get(key);
						var orgVal = this.get(key + ".org");
						if (orgVal !== undefined) {
							val = orgVal;
						}
						var propDef = tprops[key];
						var dv = propDef.defaultValue;
						if (dv !== undefined && dv !== null) {
							if (!Equals(val, dv)) {
								json[key] = val;
							} else if (options.verbose) {
								json[key] = dv;
							}
						} else {
							json[key] = val;
						}
					}
				}
			}
			if (this._countProps(this.handlers) > 0) {
				json.handlers = {};
				for (var event in this.handlers) {
					var handler = this.handlers[event];
					json.handlers[event] = handler.script;
				}
			}
			if (lang.isObject(this.style)) {
				this.style = null;
			}
			if (this.styleProps) {
				json.styleProps = lang.clone(this.styleProps);
				delete json.styleProps['widgetId'];
				if (this.widgetDef.styleProperties) {
					for (var key in this.widgetDef.styleProperties) {
						var sp = this.widgetDef.styleProperties[key];
						if (sp.defaultValue !== undefined) {
							if (json.styleProps[key] == sp.defaultValue) {
								delete json.styleProps[key];
							}
						}
					}
				}
				if (Object.keys(json.styleProps).length == 0) {
					delete json.styleProps;
				}
			}
			if (this.style) {
				if (this.style.trim().length == 0) {
					this.style = null;
				}
				if (this.style) {
					json.style = this.style;
				}
			}
			if (lang.isObject(json.style)) {
				delete json.style;
			}
 			if (this.children && this.children.length > 0) {
				json.children = new Array();
				for (var i in this.children) {
					var child = this.children[i];
					json.children.push(child.serialize());
				}
			}
 			delete json.__resolved;
			return json;
		},

		_countProps: function(obj) {
			var count = 0;
			for (k in obj) {
				if (obj.hasOwnProperty(k)) {
					count++;
				}
			}
			return count;
		},

		onShow: function() {
		    if (!this.rendered) {
		        this.rendered = true;
                if (this.widget._renderComplete) {
                    this.widget._renderComplete();
                }
		    }

			if (this.widget._onShow) {
				this.widget._onShow();
			}
			for (var i in this.children) {
				this.children[i].onShow();
			}
		},

		preUpdateChild: function(child) {

		},

		postUpdateChild: function(child) {

		},

		canDeleteChild: function(child) {
			return true;
		},

		allowDeleteChild: function(child) {
			return true;
		},

		addOverlayHandler: function(event, callback) {
			var handle = on(this.overlay, event, callback);
			this.overlayListeners.push(handle);
		},

		resolve: function(view) {
			var t = this;
			var resolve = this.widgetDef.resolve;
			if (resolve) {
				var func = lang.hitch(this.widgetDef, resolve);
				try {
					func(this, view);
				} catch (error) {
					console.error(error);
				}
			}

			if (this.widget.watch) {
				this.widget.watch('value', function(attr, oldval, newval) {
					t._notifyMonitors('value', newval);
				})
			}
		},

		destroy: function(keepDomNode) {
			this.destroyed = true;
			try {
				if (this.intersectionObserver) {
					this.intersectionObserver.disconnect();
					this.intersectionObserver = null;
				}
				if (this.overlayListeners) {
					for (var i in this.overlayListeners) {
						var handle = this.overlayListeners[i];
						if (handle) {
							handle.remove();
						}
					}
					this.overlayListeners = null;
				}

				if (this.overlay && this.overlay.parentNode) {
					this.overlay.parentNode.removeChild(this.overlay);
				}

        		if (this.widget && this.widget._widget && this.widget._widget._designMenu){
                    this.widget._widget._designMenu.destroyRecursive();
                }

				this.overlay = null;
				for (var i in this.supporting) {
					this.supporting[i].destroyRecursive(false);
				}

				var children = new Array();
				if (this.children && this.children.length > 0) {
					children = this.children;
				} else if (this.widget && this.widget.getChildren) {
					var list = this.widget.getChildren();
					for (var i = 0; i < list.length; i++) {
						var widget = list[i];
						if (widget._widget) {
							children.push(widget._widget);
						} else {
							widget.destroy();
						}
					}
				}

				while (children.length > 0) {
					var child = children[0];
					var removed = this.removeChild(child);
					child.destroy();
					if (!removed) {
					    children.splice(children.indexOf(child), 1);
					}
				}

				delete this.children;
				if (this.widget) {
					if (this.styleProps) {
						StyleManager.unsetWidgetStyle(this.widget);
					}
					if (this.widget.destroyRecursive) {
						this.widget.destroyRecursive(keepDomNode);
					} else {
						this.widget.destroy(keepDomNode);
					}
					delete this.widget;
				}
				if (this.onDestroy) {
					this.onDestroy(this);
				}
			} catch (err) {
				console.error(err);
			}
		}
	});
});
},
'appivo/theme/StyleManager':function(){
define(['appivo/util/Handlebars'],

  function(Handlebars) {

	var doc = document;
	var head = document.getElementsByTagName('head')[0];

	var templateCache = {};
	var current = null;
	var temp = false;

	StyleManager = {
		widgets: {},
		tempStyles: {},
		oldViewWidgets: {},
		oldViewTemp: {},

		setView: function(currentId) {
			current = currentId;
		},

		isTemp: function() {
			return temp;
		},

		next: function(view) {
			if (view) {
				this.oldViewWidgets = this.widgets[view];
				this.oldViewTemp = this.tempStyles[view];
				this.widgets[view] = {};
				this.tempStyles[view] = {};
			}
		},

		clearPrevious: function() {
			for (var key in this.oldViewWidgets) {
				var node = this.oldViewWidgets[key];
				if (node && node.node && node.node.parentNode) {
					node.node.parentNode.removeChild(node.node);
				}
			}
			for (var key in this.oldViewTemp) {
				var node = this.oldViewTemp[key];
				if (node && node.node && node.node.parentNode) {
					node.node.parentNode.removeChild(node.node);
				}
			}
			this.oldViewWidgets = {};
			this.oldViewTemp = {};
		},

		setTemp: function(temporary) {
			temp = 	temporary;
		},

		getNode: function(widget) {
			var viewId = widget.view.id;
			var cache = temp ? this.tempStyles[viewId] : this.widgets[viewId];
			if (!cache) {
				cache = {};
				if (temp) {
					this.tempStyles[viewId] = cache;
				} else {
					this.widgets[viewId] = cache;
				}
			}
			return cache[widget.id];
		},

		setNode: function(widget, node) {
			var viewId = widget.view.id;
			var cache = temp ? this.tempStyles[viewId] : this.widgets[viewId];
			if (!cache) {
				cache = {};
				if (temp) {
					this.tempStyles[viewId] = cache;
				} else {
					this.widgets[viewId] = cache;
				}
			}

			if (!node) {
				delete cache[widget.id];
			} else {
				cache[widget.id] = node;
			}
		},

		setWidgetStyle: function(widget, style) {
			var t = this;
			var node = this.getNode(widget);
			style.widgetId = widget.widget.id;
			if (!node) {
				var document = widget._getStyleDocument();
				if (document.then) {
					document.then(function(doc) {
						var node = t._createNode(doc, widget);
						t._renderNode(widget, node, style);
					});
				} else {
					node = this._createNode(document, widget);
					this._renderNode(widget, node, style);
				}
			} else {
				this._renderNode(widget, node, style);
			}
		},

		_createNode: function(docs, widget) {
			if (!Array.isArray(docs)) {
				docs = [docs];
			}
			var nodes = [];
			for (var i = 0; i < docs.length; i++) {
				var doc = docs[i];
				if (doc.mobilepreview) {
					doc = doc.mobilepreview.document;
				}
				var head = doc.getElementsByTagName('head')[0];
				var node = {
					document: doc,
					root: doc === document
				};
				var n = doc.createElement('style');
				if (widget.view) {
					n.setAttribute('data-view', widget.view.id);
				}
				n.type = 'text/css';
				head.appendChild(n);
				node.node = n;
				node.widget = widget.id;
				nodes.push(node);
			}
			this.setNode(widget, nodes);
			return nodes;
		},

		unsetWidgetStyle: function(widget) {
			if (widget.widget && widget.widget.id) {
				var node = this.getNode(widget);
				if (node) {
					node.node.parentNode.removeChild(node.node);
					this.setNode(widget, null);
				}
			}
		},

		clearAll: function() {
			var viewCache = temp ? this.tempStyles : this.widgets;
			for (var name in viewCache) {
				this.clearView(name);
			}
		},

		clearView: function(view) {
			var oldCurrent = current;
			current = view;
			try {
				var viewCache = temp ? this.tempStyles : this.widgets;
				var cache = viewCache[view];
				for (var name in cache) {
					var node = cache[name];
					if (node.node && node.node.parentNode) {
						var vid = node.node.getAttribute("data-view");
						if (!view || vid == view) {
							node.node.parentNode.removeChild(node.node);
							delete cache[name];
						}
					}
				}
				if (!view) {
					if (temp) {
						this.tempStyles = {};
					} else {
						this.widgets = {};
					}
				}
			} finally {
				current = oldCurrent;
			}
		},

		_processVars: function(vars) {
		    var bgoption = 'bg' + vars.bgoption;
			var v = {};
			for (var key in vars) {
				var val = vars[key];
				if (val) {
					if (key.indexOf('image') >= 0 && !(val.indexOf('/files/') == 0)) {
						val = '/files/' + val;
					}
				}
				if ((key != 'bgimage' && key != 'bggradient' && key != 'bgcolor') || key == bgoption) {
				    v[key] = val;
				}
 			}
			return v;
		},

		_renderNode: function(widget, node, vars) {
			var nodes = node;
			if (!Array.isArray(node)) {
				nodes = [node];
			}
			var t = this;
			nodes.forEach(function(n) {
				t._render(widget, n, vars);
			});
		},

		_render: function(widget, node, vars) {
			var wdef = widget.widgetDef;
			var template = templateCache[wdef.name];
			try {
				if (!template) {
					var handlebars = Handlebars.getHandlebars();
					template = handlebars.compile(wdef.styleTemplate);
					templateCache[wdef.name] = template;
				}

				vars._root = node.root;
				var css = template(vars);
				if (!node.root) {
					var styleTag = document.createElement("style");
					styleTag.setAttribute("data-view", widget.view.id);
					node.node = styleTag;
					var iframeDoc = document.querySelector("[data-wid="+node.widget+"] iframe");
					if(!iframeDoc) {
						window.addEventListener("message", (evt) => {
							if (evt.data == "iframeLoaded" && evt.origin == window.location.origin) {
								document.querySelector("[data-wid="+node.widget+"] iframe").contentDocument.head.append(node.node);
							}
						});
					} else {
						iframeDoc.contentDocument.head.append(node.node);
					}
				}
				// nosemgrep: insecure-document-method
				node.node.innerHTML = css;
			} catch (error) {
				console.error(error);
				console.log(wdef.name + " style-template: " + wdef.styleTemplate);
			}
		},

        setWidgetStyleByClass:function (widget, style) {
            var node = this.widgets[widget.id];
            style.className = widget.class;
            if (!node) {
                node = {};
                var n = doc.createElement('style');
                n.type = 'text/css';
                head.appendChild(n);
                node.node = n;
                node.widget = widget.id;
                this.widgets[widget.id] = node;
            }
            this._render(widget, node, style);
        },

		unsetWidgetStyleByClass: function(widget) {
			var node = this.widgets[widget.id];
			if (node) {
				node.node.parentNode.removeChild(node.node);
				delete this.widgets[widget.id];
			}
		}
	};

	return StyleManager;
  }
);

},
'appivo/mvc/FormRelation':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'appivo/mvc/FormAttribute'], function(lang, declare, Widget) {
	return declare("appivo.mvc.FormRelation", [appivo.mvc.FormAttribute], {

		relation: null,
		store: null,
		_getValues: null,
		_setValues: null,
		_idCounter: 0,

		constructor: function(options) {
			lang.mixin(this, options);
			this._idCounter = 0;
			this.widgetType = 'RELATION';
		},
		
		getName: function() {
			return this.relation.getName();
		},
		
		getRelation: function() {
			return this.relation;
		},
		
		getStore: function() {
			return this.store;
		},

		getItemValue: function() {
			var item = this.inherited(arguments);
			if (item && item.declaredClass !== "appivo.model.Record") {
				var model = this.relation.getDestination();
				if (model) {
					item = model.createRecord(item);
				}
			}
			return item;
		},

		_processRecords: function(records) {
			var recs = new Array();
			for (var i = 0; i < records.length; i++) {
				recs.push(this._processRecord(records[i]));
			}
			return recs;
		},
		
		_processRecord: function(record) {
			if (lang.isString(record)) {
				var model = this.relation.getDestination();
				record = model.createRecord({
					id: record
				});
			}
			return record;
		},
		
		getValues: function(opts) {
			var vals = null;
			if (this._getValues) {
				vals = this._getValues(opts);
				if (lang.isArray(vals)) {
					vals = this._processRecords(vals);
				} else {
					vals = this._processRecord(vals);
				}
			} else if (this.store) {
				vals = this.store.query({});
			}
			return vals;
		},

		setValues: function(items) {
			var idc = 0;
			if (items && !lang.isArray(items)) {
				var list = new Array();
				list.push(items);
				items = list;
			}
			for (var i in items) {
				var item = items[i];
				if (item.id) {
					if (item.id > idc) {
						idc = item.id;
					}
				}
			}
			this._idCounter = idc;
			if (this._setValues) {
				this._setValues(items);
			} else {
				this.store.setData(items);
			}
		},

		getNextId: function() {
			this._idCounter = this._idCounter + 1;
			return this._idCounter;
		},
		
		validate: function() {
			var ok = true;
			var card = this.relation.getCardinality();
			switch (card) {
			case "ONE":
				var val = this.getValue();
				if (!val) {
					ok = false;
				}
				break;
			case "ONE_TO_MANY":
				var vals = this.getValues();
				if (!vals || vals.length == 0) {
					ok =  false;
				}
				break;
			}
			if (ok && this._validate) {
				ok = this._validate();
			}
			return ok;
		},
		
		serialize: function() {
			var json = this.inherited(arguments);
			json.relationName = this.getName();
			return json;
		}
	});
});
},
'appivo/mvc/FormDocument':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'appivo/mvc/Widget'], function(lang, declare, Widget) {
	return declare("appivo.mvc.FormDocument", [appivo.mvc.Widget], {
		
		document: null,
		
		constructor: function(options) {
			lang.mixin(this, options);
			this.children = new Array();
			this.widgetType = 'DOCUMENT';
		},
		
		setDocument: function(document) {
			this.document = document;
			if (this._setDocument) {
				this._setDocument(document);
			}
		},
		
		getDocument: function(document) {
			var ok = false;
			var doc = null;
			if (this._getDocument) {
				doc = this._getDocument();
			}
			if (doc) {
				ok = true;
				document['@text'] = doc['@text'];
				document.filename = doc.filename;
				document.size = doc.size;
				document.checksum = doc.checksum;
				document.contenttype = doc.contenttype;
				document.width = doc.width;
				document.height = doc.height;				
			} else {
			    delete document['@text'];
			    delete document.filename;
				delete document.size;
				delete document.checksum;
				delete document.contenttype;
				delete document.width;
				delete document.height;
			}
			return ok;
		}
	});
});
},
'appivo/mvc/QueryParameter':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'dojo/on',
        'appivo/mvc/Widget'], function(lang, declare, on, Widget) {
	return declare("appivo.mvc.QueryParameter", [appivo.mvc.Widget], {

		queryParam: null,
		query: null,
		queryHandle: null,
		qpDef: null,
		parameter: null,
		_setValue: null,
		_getValue: null,
		handle: null,

		constructor: function(options) {
			lang.mixin(this, options);
			this.children = new Array();
			this.widgetType = 'QUERYPARAM';
			//this.widget.watch("value", lang.hitch(this, this.valueChange))
			on(this.widget, 'change', lang.hitch(this, this.valueChange));
		},
		
		bindQuery: function() {
			var value = this.getValue();
			//this.queryHandle._setQueryParameter(this.parameter, value, true);
			if (this.parameter && this.query) {
				console.log("Binding query-parameter " + this.parameter + " with initial value " + value + " to query " + this.query.name);
				//this.valueChange(this.parameter, null, value);
				this.widget.reset();
				var queryData = this.view.getQuery();
				if (queryData) {
					var qvalue = queryData[this.parameter];
					if (qvalue) {
						value = qvalue;
					}							
				}
				this.widget.set('value', value);				
			} else {
				console.error("Unable to bind query-parameter " + this.id);
			}
 		},
		
		setView: function(view) {
			this.inherited(arguments);
			var dot = this.queryParam.indexOf('.');
			var qname = this.queryParam.substring(0, dot);
			var pname = this.queryParam.substring(dot + 1);
			var schema = this.view.getSchema();
			if (schema) {
				this.query = this.view.getSchema().getQueryByName(qname);
				if (this.query) {
					this.qpDef = this.query.getParameter(pname);
					if (this.qpDef) {
						this.parameter = pname;
						this.queryHandle = view.getQueryHandle(qname);
					}
				}			
			}
		},

		getQuery: function() {
			return this.query;
		},
		
		getQueryParameterDefinition: function() {
			return this.qpDef;
		},
		
		getName: function() {
			return this.queryParam;
		},
		
		valueChange: function(value) {
			if (lang.isObject(value) && !(value instanceof Date)) {
				value = value.value;
			}
			if (this.queryHandle) {
				console.log("Value of query-parameter " + this.parameter + " changed to " + value);
				this.queryHandle.setParameter(this.parameter, value);
			}
		},
		
		setValue: function(value) {
			if (this._setValue) {
				this._setValue(value);
			} else {
				if (this.widget.onLoadDeferred) {
					this.widget.onLoadDeferred.then(lang.hitch(this, function() {
						this.widget.set('value', value);
					})); 
				} else {
					this.widget.set('value', value);					
				}
			}
		},

		getValue: function() {
			var val = null;
			if (this._getValue) {
				val = this._getValue();
			} else {
				var val = this.widget.get('value');
				if (this.widget.declaredClass == "dijit.form.CheckBox") {
					val = (val == 'on');
				}
			}
			return val;
		},
		
		focus: function() {
			this.widget.focus();
		},
		
		displayErrorMessage: function() {
			this.focus();
			if (this.widget.getErrorMessage) {
				var msg = this.widget.getErrorMessage(true);
				this.widget.displayMessage(msg);
			}
		},
		
		validate: function() {
			var ok = false;
			if (this.widget.validate) {
				this.focus();
				ok = this.widget.validate(true);
			} else {
				ok = true;
			}
			return ok;
		},
		
		serialize: function() {
			var json = this.inherited(arguments);
			console.log(json);
			if (this.queryParam) {
				json.queryParam = this.queryParam;
			}
			return json;
		},
		
		destroy: function() {
			this.inherited(arguments);
		}
	});
});
},
'appivo/mvc/QueryDisplay':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'dojo/on',
        'appivo/mvc/Widget'], function(lang, declare, on, Widget) {
	return declare("appivo.mvc.QueryDisplay", [appivo.mvc.Widget], {

		queryHandle: null,
		
		constructor: function(options) {
			lang.mixin(this, options);
			this.widgetType = 'QUERYDISPLAY';
		},
						
		getQueryHandle: function() {
			return this.queryHandle;
		},

		getName: function() {
			return this.queryHandle.getQuery().getName();
		},
						
		serialize: function() {
			var json = this.inherited(arguments);
			if (this.queryHandle) {
				json.queryName = this.getName();
			}
			return json;
		},
		
		destroy: function() {
			this.inherited(arguments);
		}
	});
});
},
'appivo/mvc/BaseView':function(){
define(['dojo/_base/lang',
        'dojo/_base/declare',
        'dojo/_base/Deferred',
        'dojo/_base/array',
        'appivo/model/Variables',
        'appivo/mvc/Function',
        'appivo/mvc/Widget',
        'appivo/mvc/WidgetDefinitions',
        'appivo/client/Client',
        'appivo/theme/StyleManager',
        'appivo/store/StoreManager'],

        function(lang, declare, Deferred, dojoArray, Variables, Function, Widget, WidgetDefinitions, Client, StyleManager, StoreManager) {
	return declare("appivo.mvc.BaseView", [Widget], {

		label: null,
		description: null,
		menu: null,
		idMap: null,
		forms: null,
		queries: null,
		functions: null,
		uiType: 'desktop',
		widgets: null,
		widgetPeers: null,
		schema: null,
		storeManager: null,
		queryHandles: null,
		queryParameters: null,
		queryResults: null,
		booting: true,
		query: null,
		customEventHandlers: null,
		viewLoader: null,
        themeListing: null,
		tabMode: '',
		fcount: 0,
		
		constructor: function(options) {
			this.idMap = {};
			this.widgets = {};
			this.widgetPeers = {};
			this.forms = {};
			this.functions = {};
			this.queries = new Array();
			this.queryHandles = {};
			this.queryParameters = new Array();
			this.queryResults = {};
			this.customEventHandlers = new Array();
			this.storeManager = StoreManager.getInstance();
			this.fcount = 0;
			
			var wd = WidgetDefinitions;

			if (options.data) {
				this._scanWidgets(options.data);
				this._createForms(options.data.forms);
				if (options.data.widgetType) {
					this.widgetType = options.data.widgetType;
				}
				if (options.data.functions) {
					this.functions = {};
					for (var name in options.data.functions) {
						var fdef = options.data.functions[name];
						this.functions[name] = new Function(fdef);
					}
				}
				if (options.data.queries) {
					this.queries = lang.clone(options.data.queries);
				}
				if (options.data.tabMode) {
					this.tabMode = options.data.tabMode;
				}
			}
			if (options.privs) {
				this.privs = options.privs;
			} else if (options.requiredPrivileges) {
				this.privs = options.requiredPrivileges;
			}
			if (!this.privs) {
				this.privs = [];
			}
			if (options.position) {
				this.properties['position'] = options.position;
			}
			if (options.style) {
				this.properties['style'] = options.style;
			}
			this.widgetDef = wd.getWidgetDef(this.widgetType, this.uiType);
		},

		_completeBootstrapping: function(args) {
			this.booting = false;
			console.log("Completing View-bootstrapping");

			var done = this._setAutoQueries(args);

			for (var name in this.queryHandles) {
				var qh = this.queryHandles[name];
				qh.setQueryParameters(this.query);
			}

			for (var i in this.queryParameters) {
				var qp = this.queryParameters[i];
				qp.bindQuery();
			}

			for (var name in this.queryHandles) {
				var qh = this.queryHandles[name];
				qh.setEnabled(true);
			}

			for (var name in this.widgets) {
				var widget = this.widgets[name];
				widget.resolve(this);
			}

			if (done) {
				if (args && args.onDone) {
					args.onDone();
				}
			}
		},

		setQuery: function(query) {
			this.query = query;
		},

		getQuery: function() {
			return this.query;
		},

		resetQueryHandles: function() {
			for (var name in this.queryHandles) {
				var qh = this.queryHandles[name];
				qh.reset();
			}
		},

		updateQueryParameters: function() {
			for (var name in this.queryHandles) {
				var qh = this.queryHandles[name];
				qh.setQueryParameters(this.query);
			}

			var data = this.query;
			if (!data) {
				data = {};
			}
			for (var i in this.queryParameters) {
				var qp = this.queryParameters[i];
				var value = data[qp.parameter];
				if (!value) {
					var def = qp.getQueryParameterDefinition();
					if (def.defaultValue) {
						if (def.defaultVariable) {
							value = Variables.resolveVariable(def.defaultValue);
						} else {
							value = def.defaultValue;
						}
					}
				}
				if (value) {
					qp.setValue(value);
				}
			}
		},

		resetQueryParameters: function() {
			for (var i in this.queryParameters) {
				var qp = this.queryParameters[i];
				qp.bindQuery();
			}
		},

		_setAutoQueries: function(args) {
			var done = true;
			if (this.queries) {
				this.queryCount = this.queries.length;
				for (var i = 0; i < this.queries.length; i++) {
					done = false;
					var qname = this.queries[i];
					var t = this;
					this._executeQuery(qname, function(result) {
						t._queryCountDown(args);
					}, function(error) {
						t._queryCountDown(args);
					});
				}
			}
			return done;
		},

		_executeQuery: function(qname, onSuccess, onError) {
			var qh = this.getQueryHandle(qname);
			if (qh) {
				var t = this;
				qh.execute({
					onSuccess: function(result) {
						t.queryResults[qname] = result;
						if (onSuccess) {
							onSuccess(result);
						}
					},
					onError: onError
				});
			} else {
				alert("View is bound to an unknown query named " + qname);
			}
		},

		_queryCountDown: function(args) {
			this.queryCount--;
			if (this.queryCount == 0) {
				if (args.onDone) {
					args.onDone();
				}
			}
		},

		refreshQuery: function(opts) {
			if (opts && opts.query) {
				this._executeQuery(opts.query, opts.onSuccess, opts.onError);
			}
		},

		getLabel: function() {
			return this.label;
		},

		getDescription: function() {
			return this.description;
		},

		getType: function() {
			return this.widgetDef.name;
		},

		getSchema: function() {
			return this.schema;
		},

		getMenu: function() {
			return this.menu;
		},

		getForm: function(id) {
			return this.forms[id];
		},

		getForms: function() {
			return this.forms;
		},

		getFunction: function(name) {
			return this.functions[name];
		},

		getCompiledFunctions: function() {
			var funcs = {};
			var name = null;
			for (name in this.functions) {
				var func = this.functions[name];
				funcs[name] = func.getCompiled();
			}
			return funcs;
		},

		getQueryResult: function(name) {
			return this.queryResults[name];
		},

		findWidgets: function(types) {
			var list = new Array();
			for (var id in this.widgets) {
				var w = this.widgets[id];
				var def = w.widgetDef.name;
				if (dojoArray.indexOf(types, def) != -1) {
					list.push(w);
				}
			}
			return list;
		},

		getWidget: function(id) {
			return this.widgets[id];
		},

		registerWidget: function(widget) {
			this.widgets[widget.getId()] = widget;
			this.widgetPeers[widget.getId()] = widget.peer;
			widget.setView(this);
			if (widget.declaredClass == 'appivo.mvc.QueryParameter') {
				this.queryParameters.push(widget);
			}
		},

		unregisterWidget: function(widget) {
			if (widget) {
				delete this.widgets[widget.getId()];
				delete this.widgetPeers[widget.getId()];
			}
		},

		generateId: function(widgetType) {
			return widgetType + Math.random();
		},

        generateIntegerId: function(widgetType) {
			return widgetType + Math.floor(Math.random() * 10000000);
		},

		getQueryHandle: function(name, force, options) {
			var as = name;
			if (options && options.as) {
				as = options.as;
			}
			var qh = this.queryHandles[as];
			if (!qh) {
				var query = this.schema.getQueryByName(name);
				if (query) {
					var disabled = force ? false : this.booting;
					qh = query.createHandle(disabled, options);
					console.log("View " + this.id + " created new query-handle for query " + name + " (as=" + as + ")");
					this.queryHandles[as] = qh;
				}
			}
			return qh;
		},

		getWidgetRegistry: function() {
			return this.widgets;
		},

		getWidgetPeerRegistry: function() {
			return this.widgetPeers;
		},

		createRecordURI: function(model) {
			var client = appivo.client.Client.getInstance();
			var uri = '/api/app/' + this.schema.getName() + '/model/' + model + '/record/';
			return uri;
		},

 		_scanWidgets: function(elm) {
			if (elm.id) {
				var us = elm.id.indexOf('_');
				if (us != -1) {
					var type = elm.id.substr(0, us);
					var idx = parseInt(elm.id.substr(us + 1));
					var old = this.idMap[type];
					if (old == null || idx > old) {
						this.idMap[type] = idx;
					}
				}
			}
			if (elm.children) {
				this._scanChildren(elm.children);
			}
			if (elm.widgetType == 'DataGrid') {
				if (elm.rowMenu) {
					this._scanChildren(elm.rowMenu);
				}
				if (elm.gridMenu) {
					this._scanChildren(elm.gridMenu);
				}
			}
		},

		_scanChildren: function(list) {
			if (lang.isArray(list)) {
				for (var i in list) {
					var child = list[i];
					if (child) {
						this._scanWidgets(child);
					}
				}
			} else if (list) {
				this._scanWidgets(list);
			}
		},

		reset: function() {
			this.resetForms();
			this.resetQueryParameters();
		},

		resetNonFormWidgets: function() {
			for (wid in this.widgets) {
				var widget = this.widgets[wid];
				if (widget && !widget.getForm()) {
					widget.reset();
				}
			}
		},

		_createForms: function(formData) {
			if (formData) {
				for (var i in formData) {
					var fd = formData[i];
					var form = this._createForm(fd);
					this.forms[fd.id] = form;
				}
			}
			this.initForms();
			return this.forms;
		},

		initForms: function() {
			for (var i in this.forms) {
				var form = this.forms[i];
				form.init(this);
			}
		},

		resetForms: function() {
			var focused = false;
			for (var i in this.forms) {
				var form = this.forms[i];
				if (!form.getParent()) {
					focused = form.reset(focused);
				}
			}
		},

		destroyForms: function() {
			for (var i in this.forms) {
				var form = this.forms[i];
				form.destroy();
			}
		},

		getFormRegistry: function() {
			return this.forms;
		},

		addEventHandler: function(node, event, func) {
			var handle = on(node, event, func);
			this.customEventHandlers.push({
				node: node,
				event: event,
				func: func,
				handle: handle
			});
		},

		findForm: function(model) {
			var selected = null;
			for (var i in this.forms) {
				var form = this.forms[i];
				if (form.getModel().getId() == model.getId()) {
					selected = form;
					break;
				}
			}

			if (!selected) {
				if (Object.keys(this.forms).length == 1) {
					selected = this.getFirstForm();
				}
			}

			return selected;
		},

		getFirstForm: function() {
			var form = null;
			for (var name in this.forms) {
				var f = this.forms[name];
				if (!f.isChild()) {
					form = f;
					break;
				}
			}
			return form;
		},

		getChildForms: function(form) {
			var children = new Array();
			var formId = form.getId();
			for (var name in this.forms) {
				var f = this.forms[name];
				var p = f.getParent();
				if (p && p.id == formId) {
					children.push(f);
				}
			}
			return children;
		},

		_createForm: function(elm) {
			var model = null;
			if (elm.modelName) {
				var modelName = elm.modelName;
				var modelURI = this.createRecordURI(modelName);
				model = this.schema.getModel(modelName);
			}
			var form = new appivo.mvc.Form({
				id: elm.id,
				model: model,
				view: this,
				parent: elm.parent,
				relation: elm.relation,
				features: elm.features,
				transactional: elm.transactional,
				enabled: elm.enabled,
				suppress: elm.suppress,
				levels: elm.levels,
				loadedRelations: elm.loadedRelations,
				fixedFields: elm.fixedFields
			});
			this.forms[elm.id] = form;
			return form;
		},
		
		addForm: function(options) {
			if (!options) {
				options = {};
			}
			
			if (!options.id) {
				options.id = "Form_" + (this.fcount++);
			}
			
			if (options.model && !options.modelName) {
				options.modelName = options.model;
				delete options.model;
			}
					
			var form = this._createForm(options);
			form._tmp = true;
			form.init(this);
			return form;
		},
		
		removeTempForm: function(id) {
			var form = this.forms[id];
			if (form && form._tmp) {
				delete this.forms[id];
			} else {
				throw new Error(id + " is not a temporary form and cannot be deleted");
			}
		},
		
		removeTempForms: function() {
			var list = [];
			for (var id in this.forms) {
				var form = this.forms[id];
				if (form._tmp) {
					list.push(id);
				}
			}
			
			for (var i = 0; i < list.length; i++) {
				var id = list[i];
				console.log("Removing temporary form " + id);
				delete this.forms[id];
			}
		},

		getViewLoader: function() {
			return this.viewLoader;
		},

		blur: function() {
			for (var name in this.widgets) {
				var w = this.widgets[name];
				w.blur();
			}
		},

		resetCustomStyling: function() {
			var oldTemp = StyleManager.isTemp();
			StyleManager.setTemp(false);
			try {
				for (var wid in this.widgets) {
					var widget = this.widgets[wid];
					if (widget) {
						widget.resetStyle();
					}
				}
			} finally {
				StyleManager.setTemp(oldTemp);
			}
		},

		removeDynamicWidgets: function() {
			var deleted = [];
			for (var wid in this.widgets) {
				var widget = this.widgets[wid];
				if (widget.__dynamicInstance) {
					var peer = this.widgetPeers[wid];
					if (peer) {
						peer.destroy();
					}
					deleted.push(wid);
				}
			}
			
			for (var i = 0; i < deleted.length; i++) {
				delete this.widgets[wid];
			}
		},

		resetDisplayState: function() {
			for (var wid in this.widgets) {
				var widget = this.widgets[wid];
				var hidden = widget._hidden;
				if (!widget.hidden && hidden) {
					widget.peer.hide();
				} else if (widget.hidden && !hidden) {
					widget.peer.show();
				}
			}
		},

        getBaseTheme:function () {
            var selectedTheme = {};
            if (this.themeListing && this.themeListing.length > 0) {
                var t = this;
                var pageTheme = this.theme;
                // if page theme is not defined
                if (!pageTheme) {
                    if (this.viewLoader.editor) {
                        pageTheme = this.viewLoader.editor.ui.baseTheme;
                    } else {
                        pageTheme = this.context.viewManager.ui.baseTheme;
                    }
                }
                selectedTheme = this.themeListing.find(function(themeItem) {
                    if (pageTheme) {
                        return (themeItem.id === pageTheme);
                    } else {
                        return (themeItem.data && themeItem.data.type === "default");
                    }
                });
                if (selectedTheme) {
                    selectedTheme = selectedTheme.data;
                }
            }
            return selectedTheme;
        },

		destroy: function() {
			var i = 0;
			for (i = 0; i < this.customEventHandlers.length; i++) {
				var ceh = this.customEventHandlers[i];
				ceh.handle.remove();
			}
			this.destroyForms();
			this.inherited(arguments);
		}
	});
});

},
'appivo/mvc/WidgetDefinitions':function(){
define(['lodash',
		'dojo/_base/window',
        'dojo/dom-construct',
        'dojo/dom-geometry',
        'dojo/dom-style',
        'appivo/mvc/widgets/BaseWidget',
        'appivo/mvc/widgets/BaseView',
        'appivo/mvc/widgets/ContainerWidget',
        'appivo/mvc/widgets/ColoredWidget',
        'appivo/mvc/widgets/DataWidget',
        'dojo/i18n!../nls/WidgetDefinitions'
        ], function(_, win, domConstruct, domGeom, domStyle, BaseWidget, BaseView, ContainerWidget, ColoredWidget, DataWidget, messages) {

	function WidgetDefinitions() {
		this.widgets = {};
		this._widgetIndex = {};
		this._widgetsByType = {};
	};

	WidgetDefinitions.prototype = {
		parentClasses: {
			ColoredWidget: ColoredWidget,
			FormWidget: {
				getValues: function() {
					var vals = null;
					if (_.isFunction(this.widget._getValues)) {
						vals = this.widget._getValues();
					}
					return vals;
				},
				setValues: function(vals) {
					if (_.isFunction(this.widget._setValues)) {
						this.widget._setValues(vals);
					}
				},
				getValue: function() {
					return this.widget.getValue();
				},
				setValue: function(value) {
					this.widget.setValue(value);
				},
				validate: function() {
                    if (this.widget.validate) {
                        return this.widget.validate();
                    } else {
                        console.warn("missing validation for widget", this.widget);
                        return undefined;
                    }
                }
			}
		},

		peerTemplate: {
		},

		type: 'desktop',
		widgets: null,
		_widgetIndex: null,
		_widgetsByType: null,

		_baseClasses: {
			BaseWidget: BaseWidget,
			ContainerWidget: ContainerWidget,
			BaseView: BaseView,
			ColoredWidget: ColoredWidget,
			DataWidget: DataWidget
		},

		_getBaseClass: function(name) {
			return this._baseClasses[name];
		},

		_inherit: function(baseClass, def) {
			if (!baseClass) {
				return;
			}
			var bc = this._getBaseClass(baseClass.inherits);
			if (bc) {
				this._inherit(bc, def);
			}
			for (var key in baseClass) {
				var f = baseClass[key];
				if (typeof f === "function") {
					def[key] = f;
				}
			}

			if (def.properties) {
				for (var prop in baseClass.properties) {
					var tplVal = baseClass.properties[prop];
					var val = def.properties[prop];
					if (val) {
						def.properties[prop] = _.assign(val, tplVal);
					} else {
						def.properties[prop] = tplVal;
					}
				}
			} else {
				def.properties = baseClass.properties;
			}

			if (def.styleProperties) {
				for (var prop in baseClass.styleProperties) {
					var tplVal = baseClass.styleProperties[prop];
					var val = def.styleProperties[prop];
					if (val) {
						def.styleProperties[prop] = _.assign(val, tplVal);
					} else {
						def.styleProperties[prop] = tplVal;
					}
				}
			} else {
				def.styleProperties = baseClass.styleProperties;
			}
			if (def.styleProperties) {
				for (var prop in def.styleProperties) {
					var obj = def.styleProperties[prop];
					obj.name = prop;
				}
			}

			if (def.functions) {
				for (var prop in baseClass.functions) {
					var tplVal = baseClass.functions[prop];
					tplVal.__source = baseClass.name;
					var val = def.functions[prop];
					if (!val) {
						def.functions[prop] = tplVal;
					}
				}
			} else {
				def.functions = baseClass.functions;
				for (var prop in def.functions) {
					var tplVal = def.functions[prop];
					tplVal.__source = baseClass.name;
				}
			}

			if (def.events) {
				var events = new Array();
				for (var k in baseClass.events) {
					events.push(baseClass.events[k]);
				}
				for (var k in def.events) {
                    var toAdd = def.events[k];
                    var pidx = -1;
                    for (var l in events) {
                    	if ((events[l].name && toAdd.name && events[l].name === toAdd.name) || (events[l].name && events[l].name === toAdd)  || (toAdd.name && events[l] === toAdd.name) || events[l] === toAdd) {
                    		pidx = l;
                    		break;
                    	}
                    }
                    if (pidx !== -1){
                        events[pidx] = toAdd;
                    } else {
                        events.push(toAdd);
                    }
				}
				def.events = JSON.parse(JSON.stringify(events));
			} else if (baseClass.events) {
				def.events = JSON.parse(JSON.stringify(baseClass.events));
			} else {
				def.events = undefined;
			}

			if (def.maximizable === undefined) {
				def.maximizable = baseClass.maximizable;
			}
			if (def.resizable === undefined) {
				def.resizable = baseClass.resizable;
			}
			if (def.draggable === undefined) {
				def.draggable = baseClass.draggable;
			}
			if (!def.styleTemplate) {
				def.styleTemplate = baseClass.styleTemplate;
			}
			this.resolveEventDocsPathRefs(def);
		},

		resolveEventDocsPathRefs: function(def) {
			if (!def.events) {
				return;
			}

			def.events.forEach(function(event) {
				if (event.parameters) {
					event.parameters.forEach(function(param) {
						if (param.docsPath) {
							param.docsPath = param.docsPath.replace(/\$\w+/g, function (ref) {
								switch (ref) {
									case '$widgetName':
										return def.name.toLowerCase();
									default:
										throw "Unknown reference " + ref;
								}
							});
						}
					});
				}
			});
		},

		addWidgets: function(type, widgets) {
			if (!this.widgets[type]) {
				this.widgets[type] = new Array();
				this._widgetIndex[type] = {};
				this._widgetsByType[type] = {};
			}
			var widgetIndex = this._widgetIndex[type];
			var widgetsByType = this._widgetsByType[type];

			for (var i in widgets) {
				var widget = widgets[i];
				var label = messages[widget.name];
				if (!label) {
					label = widget.name;
				}
				widget.label = label;
				widget.TYPE = 'WidgetDef';
				this.widgets[type].push(widget);
				widgetIndex[widget.name] = widget;
				if (widget.dataTypes) {
					for (var j in widget.dataTypes) {
						var stype = widget.dataTypes[j];
						var supporting = widgetsByType[stype];
						if (supporting == undefined || supporting == null) {
							supporting = new Array();
						}
						supporting.push(widget);
						widgetsByType[stype] = supporting;
					}
				}

				if (widget.peer) {
					continue;
				}

				if (!widget.inherits) {
					widget.inherits = 'BaseWidget';
				}
				if (_.isArray(widget.inherits)) {
					for (var j = 0; j < widget.inherits.length; j++) {
						var baseClass = this._getBaseClass(widget.inherits[j]);
						this._inherit(baseClass, widget);
					}
				} else {
					var baseClass = this._getBaseClass(widget.inherits);
					this._inherit(baseClass, widget);
				}

				var peer = {};
				var parents = new Array();
				parents.push(this.peerTemplate);
				if (widget.parents) {
					for (var i in widget.parents) {
						var parent = widget.parents[i];
						var template = this._getTemplate(parent);
						if (template) {
							parents.push(template);
						} else {
							console.log(widget.name + " has an invalid parent: " + parent);
						}
					}
				}
				for (var i in parents) {
					_.assign(peer, parents[i]);
				}

				if (widget.functions) {
					for (var action in widget.functions) {
						peer[action] = widget.functions[action].script;
					}
				}

				widget.peer = peer;
				widget.createPeer = _.bind(this._createWidgetPeer, widget);
				//this.resolveEventDocsPathRefs(widget);
			}
		},

		applyDefaults: function(uiType, widget, prefix) {
			var wd = this.getWidgetDef(widget.widgetType, uiType );
			if  (wd) {
				var props = wd.properties;
				var tprops = null;
				if (wd.typeProperties) {
					tprops = wd.typeProperties[this.widgetType];
				}
				this._applyDefaults(uiType, props, widget, prefix);
				this._applyDefaults(uiType, tprops, widget, prefix);
			}
		},

		_applyDefaults: function(uiType, props, widget, prefix) {
			if (props) {
				for (var key in props) {
					var def = props[key];
					var val = prefix ? widget[prefix + key] : widget[key];
					if (val === undefined || val === null) {
						var dv = def.defaultValue;
						var apply = true;
						if (dv && dv._for) {
							apply = dv._for === uiType;
						}
						if (dv !== undefined && dv !== null && apply) {
							if (prefix) {
								widget[prefix + key] = dv;
							} else {
								widget[key] = dv;
							}
						}
					}
				}
			}
		},

		_getTemplate: function(name) {
			return this.parentClasses[name];
		},

		_createWidgetPeer: function(widget) {
			var peer = {
				widget: widget
			};
			_.assign(peer, this.peer);
			return peer;
		},

		supportsType: function(def, type) {

		},

		setType: function(type) {
			this.type = type;
		},

		getDefinitions: function(type) {
			var t = type ? type : this.type;
			return this.widgets[t];
		},

		getWidgetDef: function(id, type) {
			var t = type ? type : this.type;
			var widget = null;
			if (id != null) {
				widget = this._widgetIndex[t][id];
			}
			if (!widget) {
				widget = this._baseClasses[id];
			}
			return widget;
		},

		getWidgetsSupportingType: function(wtype, type) {
			var t = type ? type : this.type;
			return this._widgetsByType[t][wtype];
		}
	};

	var defs = new WidgetDefinitions();
	return defs;
});

},
'appivo/mvc/widgets/BaseWidget':function(){
/**
 * @interface BaseWidget
 */
define (['dojo/_base/lang',
		'dojo/dom-style',
		'appivo/util/Handlebars',
		'animejs/animejs',
		'dojo/text!../style/Widget.txt',
	], function(lang, domStyle, Handlebars, animejs, StyleTemplate) {

	var strToObj = function(cssText) {
		var regex = /([\w-]*)\s*:\s*([^;]*)/g;
		var match, properties={};
		while (match=regex.exec(cssText)) {
			properties[match[1]] = match[2].trim();
		}
		return properties;
	};

	return {
		name: 'BaseWidget',
		events: [{
                name: 'Click',
                parameters: [{
                    name: "event",
                    description: "The event that triggered the handler",
					docsPath: '/widgets/$widgetName/#click'
                }]
            },{
                name: 'DblClick',
                parameters: [{
                    name: "event",
                    description: "The event that triggered the handler",
					docsPath: '/widgets/$widgetName/#dblclick'
                }]
            },
            'Focus', 'Blur',
			{
				name: 'Viewable',
				parameters: [{
					name: "event",
					description: "The event that triggered the handler"
				}]
			}
        ],
		draggable: true,
		styleTemplate: StyleTemplate,

		determineType: function(elm) {
			var type = 'NONE';
			if (elm.attributeName) {
				type = "ATTRIBUTE";
			} else if (elm.relationName) {
				type = "RELATION"
			} else if (elm.queryParam) {
				type = "QUERYPARAM";
			}
			return type;
		},

		_getDefaultStyle: function() {
			var style = {};
			var props = this.styleProperties;

			if (props) {
				for (var key in props) {
					var prop = props[key];
					if (prop.defaultValue !== undefined) {
						style[prop.name] = prop.defaultValue;
					}
				}
			}
			return style;
		},

		_createGhostStyle: function(elm, attrs) {
			var style = elm.style;
			if (!style) {
				style = "";
			}
			if (attrs) {
				for (var key in attrs) {
					if (style.length > 0) {
						style += ";";
					}
					style += key + ': ' + attrs[key];
				}
			}
			elm.style = style;
		},

		createGhost: function(mode) {
			var elm = {
				widgetType: this.name,
				_ghost: true
			};

			var ghostStyle = {};
			if (this.minHeight) {
				ghostStyle['min-height'] = this.minHeight;
			}
			if (this.minWidth) {
				ghostStyle['min-width'] = this.minWidth;
			}
			if (mode == 'mobile') {
				if (this.mobileMinHeight) {
					ghostStyle['min-height'] = this.mobileMinHeight;
				}
				if (this.mobileMinWidth) {
					ghostStyle['min-width'] = this.mobileMinWidth;
				}
			}
			ghostStyle['border'] = 'dashed 2px #00cc00';

			for (var name in this.properties) {
				var val = undefined;
				var prop = this.properties[name];
				if (prop.defaultValue) {
                    if (!prop.defaultValue._for || prop.defaultValue._for === mode) {
                        val = lang.clone(prop.defaultValue);
                        if (val._for) {
                            delete val._for;
                        }
                    }
				} else if (prop.type == 'OPTION') {
					val = prop.options[0].value;
				}
				if (val !== undefined) {
					elm[name] = val;
				}
			}

			this._createGhostStyle(elm, ghostStyle);

			return elm;
		},

		hasEvent: function(event) {
			if (!this._eventMap) {
				this._eventMap = {};
				for (var i = 0; i < this.events.length; i++) {
					var event = this.events[i];
					this._eventMap[event.name] = event;
				}
			}
			return !!this._eventMap[event];
		},

		styleProperties: {
			marginPadding: {
				type: "MARGINPADDING",
				label: "Margin and padding",
				order: -1200
			},
			responsive: {
				type: "RESPONSIVE",
				label: "Responsive",
				order: -1100
			},
			bgcolor: {
				type: 'COLOR',
				label: 'Background-color',
				order: -1000
			},
			color: {
				type: 'COLOR',
				label: 'Color',
				order: -900
			},
			fontSize: {
				type: 'RANGE',
				label: 'Font Size',
				min: 8,
				max: 100,
				step: 1,
				unit: 'px',
				order: -800
			},
			fontFamily: {
				type: 'FONT',
				label: 'Font family',
				order: -600
			},
			textalign: {
				type: 'OPTION',
				label: 'Text-alignment',
				options: [
				   {
					   label: 'Center',
					   value: 'center'
				   },
				   {
					   label: 'Left',
					   value: 'left'
				   },
				   {
					   label: 'Right',
					   value: 'right'
				   },
				   {
					   label: 'Justified',
					   value: 'justify'
				   }
				],
				order: -700
			},
			margin: {
				type: 'RANGE',
				label: 'Margin',
				min: 0,
				max: 100,
				step: 1,
				unit: 'px',
				order: -997
			},
			boxShadow: {
				type: 'SHADOW',
				label: 'Box shadow',
				order: -995
			},
		},

		properties: {
			tabIndex: {
				type: 'INTEGER',
				required: false,
				defaultValue: 0
			},
			hidden: {
				type: 'BOOLEAN',
				defaultValue: false
			},
			styleProps: {
				type: 'CUSTOM',
				set: function(value) {
					this.properties['styleProps'] = value;
				},
				get: function() {
					return this.properties['styleProps'];
				}
			},
			style: {
				type: 'CUSTOM',
				required: false,

				set: function(value, override) {
					var style = this.widget ? this.widget.domNode.style : null;
					if (!this.orgCss) {
						this.orgCss = style.cssText;
						this.orgCss = strToObj(this.orgCss);
						if (this.orgCss['opacity'] == '0') {
							delete this.orgCss['opacity'];
						}
					}
					var cssObj = {};
					this.style = value;
					var selectedTheme = {};
					if(this.actionEngine.view){
						selectedTheme = this.actionEngine.view.getBaseTheme();
					}
					if (this.style) {
						var ac = this._getActionContext();
						var tctx = ac.createTemplateContext({});
						lang.mixin(tctx,selectedTheme);
					    var compliedStyle = Handlebars.compile(this.style.toString())(tctx);
					    cssObj = strToObj(compliedStyle);
					} else {
						this.style = '';
					}

					var defaultStyle = this.widgetDef._getDefaultStyle();
					var css = lang.mixin(defaultStyle, this.orgCss);
					lang.mixin(css, cssObj);

					var cssStr = '';
					var i = 0;
					for (var key in css) {
						if  (i > 0) {
							cssStr += ';';
						}
						i++;
						var val = css[key];
						cssStr += key + ": ";
						cssStr += val;
					}

					style.cssText = cssStr;
				},

				get: function() {
					return this.style;
				}
			},
			position: {
				type: 'CUSTOM',
				set: function(value) {
					var old = this.get('position');
					if (old) {
						if (value.col != null && value.col != undefined) {
							old.col = value.col;
						}
						if (value.row != null && value.row != undefined) {
							old.row = value.row;
						}
						if (value.width) {
							old.width = value.width;
						}
						if (value.height) {
							old.height = value.height;
						}
						if (value.z !== null && value.z !== undefined) {
						    old.z = value.z
						}
					} else {
						old = value;
					}
					if (this.noSize) {
						delete old.width;
						delete old.height;
					}
					if (this.widget) {
						this.widget.position = old;
					}
					if (old) {
						if (old.col) {
							var xpos = (old.col * 8) + 'px';
							domStyle.set(this.widget.domNode, 'left', xpos);
						} else {
							domStyle.set(this.widget.domNode, 'left', '');
						}
						if (old.row) {
							var ypos = (old.row * 8) + 'px';
							domStyle.set(this.widget.domNode, 'top', ypos);
						} else {
							domStyle.set(this.widget.domNode, 'top', '');
						}
						var rsize = this.widget._widget._getRealSize();
						if (old.height) {
							domStyle.set(this.widget.domNode, 'height', (old.height * 8) + 'px');
						} else {
							var h = (rsize && rsize.h) ? rsize.h + 'px' : '';
							domStyle.set(this.widget.domNode, 'height', h);
						}
						if (old.width) {
							domStyle.set(this.widget.domNode, 'width', (old.width * 8) + 'px');
						} else {
							if (this.widgetDef.noSizeXMobile) {
								domStyle.set(this.widget.domNode, 'width', '100%');
							} else {
								var w = (rsize && rsize.w) ? rsize.w  + 'px': '';
								domStyle.set(this.widget.domNode, 'width', w);
							}
						}
						if (old.z !== null && old.z !== undefined) {
                            domStyle.set(this.widget.domNode, 'z-index', old.z);
						} else {
						    domStyle.set(this.widget.domNode, 'z-index', 2);
						}
					}
					if (this.widgetDef.onSetPosition) {
						this.widgetDef.onSetPosition(this.widget, this.widget.position);
					}
					return old;
				},
				get: function() {
					var pos = undefined;
					if (this.noSize) {
						if (this.widget && this.widget.position) {
							delete this.widget.position.width;
							delete this.widget.position.height;
						}
					} else {
						if (this.widget && this.widget.position) {
							pos = this.widget.position;
						} else if (this.properties && this.properties.position) {
							pos = this.properties.position;
						}
					}
					return pos;
				}
			},
			disabled: {
				type: 'BOOLEAN',
				required: true,
				order: 100,
				defaultValue: false
			}
		},
		functions: {
			/**
			 * Returns the ID of the widget.
			 * @function
			 * @instance
			 * @returns {ID} - The ID of the widget
			 * @memberof BaseWidget
			 */
			getId: {
				script: function() {
					return this.widget.getId();
				},
				meta: {
					returntype: "String"
				}
			},

			/**
			 * Enables/disables the widget.
			 * @function
			 * @instance
			 * @param {Boolean} Enabled - True to enable the widget, false to disable.
			 * @memberof BaseWidget
			 */
			setEnabled: {
				script: function(enabled) {
					this.widget.set('disabled', !enabled);
				},
				meta: {
					params: [{ name:"enabled", type:"boolean" }],
					shadowblocks: { enabled: "boolean#true" }
				}
			},

			/**
			 * Returns true if the widget is enabled.
			 * @function
			 * @instance
			 * @returns {Boolean} - True if enabled, otherwise false.
			 * @memberof BaseWidget
			 */
			isEnabled: {
				script: function() {
					return !this.widget.get('disabled');
				},
				meta: {
					returntype: "boolean"
				}
			},

			/**
			 * Sets the value of the specified property.
			 * @function
			 * @instance
			 * @param {String} name - The name of the property.
			 * @param {Object} value - The new value.
			 * @memberof BaseWidget
			 */
			set: {
				script: function(name, value) {
					this.widget.set(name, value);
				},
				meta: {
					params: [{name: "name", "type": "String"}, {name: "value", type:"null"}],
					shadowblocks: {
						name: "text",
						value: "number"
					}
				}
			},

			/**
			 * Gets the value of the specified property.
			 * @function
			 * @instance
			 * @param {String} name - The name of the property.
			 * @returns {Object} - The property's value.
			 * @memberof BaseWidget
			 */
			get: {
				script: function(name) {
					return this.widget.get(name);
				},
				meta: {
					returntype: "null",
					shadowblocks: {
						name: "text"
					}
				}
			},

			/**
			 * Returns the widget's value.
			 * @function
			 * @instance
			 * @returns {Object} - The widget's value.
			 * @memberof BaseWidget
			 */
			getValue: {
				script: function() {
				    var val = null;
                    if (this.widget && this.widget._getValue) {
                        val = this.widget._getValue();
                    } else {
                        var val = this.widget.widget.get('value');
                        if (this.widget.widget.declaredClass == "dijit.form.CheckBox") {
                            val = (val == 'on');
                        }
                    }
                    return val;

				},
				meta: {
					returntype: "null"
				}
			},

			/**
			 * Sets the widget's value.
			 * @function
			 * @instance
			 * @param {Object} value - The new value.
			 * @memberof BaseWidget
			 */
			setValue: {
				script: function(value) {
				    if (this.widget._setValue) {
                        this.widget._setValue(value);
                        this.widget._notifyMonitors('value', value);
                    } else {
                        if (this.widget.widget.onLoadDeferred) {
                            this.widget.widget.set('value', value);
                            this.widget.widget.onLoadDeferred.then(lang.hitch(this, function() {
                                this.widget.widget.set('value', value);
                                this.widget._notifyMonitors('value', value);
                            }));
                        } else {
                            this.widget.widget.set('value', value);
                            this.widget._notifyMonitors('value', value);
                        }
                    }
				},
				meta: {
					params: [{name: "value", type: "String"}]
				}
			},

			/**
			 * Triggers the focus event.
			 * @function
			 * @instance
			 * @memberof BaseWidget
			 */
			focus: {
				script: function() {
					if (this.widget.widget.focus) {
						this.widget.widget.focus();
					} else if (this.widget.widget.focusNode) {
						this.widget.widget.focusNode.focus();
					} else {
						this.widget.widget.domNode.focus();
					}
				},
				meta: {}
			},

			/**
			 * Triggers the blur event.
			 * @function
			 * @instance
			 * @memberof BaseWidget
			 */
			blur: {
				script: function() {
					if (this.widget.widget.blur) {
						this.widget.widget.blur();
					} else if (this.widget.widget.focusNode) {
						this.widget.widget.focusNode.blur();
					} else {
						this.widget.widget.domNode.blur();
					}
				},
				meta: {}
			},

			/**
			 * Scrolls the widget into view
			 * @function
			 * @instance
			 * @memberof BaseWidget
			 */
			scrollTo: {
				script: function(offset) {
					var ac = this.widget.actionEngine.context;
					ac.scrollTo(this.widget.widget, offset);
				}
			},

			/**
			 * Animte the widget.
			 * @function
			 * @instance
			 * @param {Object|String} props - Either a String or Object.
			 * @param {Function} endCallback - Callback called when the animation has been performed.
			 * @param {Function} beginCallback - Callback called when the animation has started.
			 * @memberof BaseWidget
			 */
			animate: {
				script: function (props, endCallback, beginCallback) {
					const node = this.widget.widget.domNode;
					const animeOptions = {
						targets: [node],
						begin: beginCallback,
						complete: endCallback,
						duration: 500,
					};
					if (typeof props == "string") {
						props = {
							preset: props
						}
					}
					const preset = props.preset || "custom";
					delete animeOptions.preset;

					if (typeof props.target === "string") {
						props.targets = [props.target];
					} else if (Array.isArray(props.target)) {
						props.targets = props.target;
					}
					delete props.target;

					switch (preset) {
						case "fadeIn": 
							animeOptions.opacity = [0, 1];
							animeOptions.duration = 500;
							break;
						case "fadeOut":
							animeOptions.opacity = [1, 0];
							animeOptions.duration = 500;
							break;
						case "shimmer":
							for (let target of (props.targets || animeOptions.targets)) {
								if (typeof target == "string") {
									target = document.querySelector(target);
								}
								if (target) {
									const shimmerEl = document.createElement("div");
									const bb = target.getBoundingClientRect();
									if (props.lineHeight || props.lineSpacing) {
										shimmerEl.setAttribute("style", "height: " + bb.height + "px; width: " + bb.width + "; position: absolute; display: flex; flex-direction: column; z-index: 900;")
										shimmerEl.classList.add("shimmer-cont")
										for (let i = 0; i < Math.floor(target.clientHeight / (props.lineHeight + props.lineSpacing)); i++) {
											const line = document.createElement("div");
											line.setAttribute("style", "height: " + (props.lineHeight || 14) + "px; width: calc(100% - " + (props.variation ? Math.ceil(Math.random() * props.variation) : 0) + "px); margin-bottom: " + (props.lineSpacing || 10) + "px; border-radius: " + (props.borderRadius || 4) + "px; ");
											line.classList.add("shimmer-bg");
											shimmerEl.appendChild(line);
										}
									} else {
										shimmerEl.classList.add("shimmer-bg");
										shimmerEl.setAttribute("style", "height: " + bb.height + "px; width: " + bb.width + "px; position: absolute; top: 0; left: 0; border-radius: " + (props.borderRadius || 5) + "px; z-index: 900;")
									}
									target.appendChild(shimmerEl);
								}
							}
							break;
						case "unShimmer":
							for (let target of (props.targets || animeOptions.targets)) {
								if (typeof target == "string") {
									target = document.querySelector(target);
								}
								if (target) {
									for (const element of target.querySelectorAll(".shimmer-bg, .shimmer-cont")) {
										element.remove();
									}
								}
							}
							break;
						case "fullscreen":
							animeOptions.width = '100vw';
							animeOptions.height = '100vh';
							animeOptions.top = "50%";
							animeOptions.translateY = "-50%";
							animeOptions.left = "50%";
							animeOptions.translateX = "-50%";
							// Use the old margin to not make it "snap upwards"
							animeOptions.marginTop = [node.style.marginTop, node.style.marginTop];
							animeOptions.marginBottom = [node.style.marginBottom, node.style.marginBottom];
							node.style.zIndex = "2000";
							node.style.position = "fixed";
							animeOptions.easing = "easeInOutQuad";
							break;
						case "maximize": 
						case "maximise":
							animeOptions.width = '100%';
							animeOptions.height = '100%';
							break;
						case "maximizeHeight": 
						case "maximiseHeight":
							animeOptions.height = '100%';
							break;
						case "maximizeWidth": 
						case "maximiseWidth":
							animeOptions.width = '100%';
							break;
						case "wiggle":
							animeOptions.rotate = [5, -5, 0];
							animeOptions.easing = "linear"
							animeOptions.duration = 200;
							animeOptions.loop = 3;
							break;
						case "pulse":
							animeOptions.opacity = [1, 0.6, 1];
							animeOptions.scale = [1, 1.1, 1]
							animeOptions.delay = 100;
							animeOptions.loop = 2;
							animeOptions.easing = "easeInOutQuad";
							break;
						case "reverse":
							if (props.type) {
								for (const animation of node.animeAnimations[props.type]) {
									animation.reverse();
									animation.play();
								}
								return;
							}
							if (node.animeAnimations) {
								for (const animationArr in node.animeAnimations) {
									for (const animation of node.animeAnimations[animationArr]) {
										animation.reverse();
										animation.play();
									}
									delete node.animeAnimations[animationArr];
								}
								return;
							}
						case "custom":
							// NOOP
							break;
						default: 
							console.error(preset, "is not a recognized preset");
							break;
					}

					for (const key in props) {
						animeOptions[key] = props[key];
					}
					if (!node.animeAnimations) {
						node.animeAnimations = {};
					}
					if (!node.animeAnimations[preset]) {
						node.animeAnimations[preset] = [];
					}
					node.animeAnimations[preset].push(animejs(animeOptions));
				},
				meta: {}
			},

			/**
			 * Removes all animations from the widget
			 * @param {String} preset - The preset to remove, leave empty to remove all.
			 */
			removeAnimation: {
				script: function(preset) {
					const node = this.widget.widget.domNode;
					if (node && node.animeAnimations) {
						if (preset && node.animeAnimations[preset]) {
							for (const animation of node.animeAnimations[preset]) {
								animation.restart();
								animation.pause();
								animation.remove();
							}
							delete node.animeAnimations[preset];
						} else {
							for (const animationPreset in node.animeAnimations) {
								for (const animation of node.animeAnimations[animationPreset]) {
									animation.restart();
									animation.pause();
									animation.remove();
								}
								delete node.animeAnimations[animationPreset];
							}
						}
					}
				}
			},

			/**
			 * Hides the widget.
			 * @function
			 * @instance
			 * @param {Object} opts - Options, set opts.fade to true for the widget to fade out.
			 * @memberof BaseWidget
			 */
			hide: {
				script: function(opts) {
					this.widget.hidden = true;
					var node = this.widget.widget.domNode;
					if (!opts) {
						opts = {};
					}
					if (opts.fade) {
						const animeOptions = {
							targets: [node],
							opacity: [1, 0],
							duration: 1000,
							complete: () => {
								var old = domStyle.get(node, 'display');
								if (!old) {
									old = 'block';
								}
								this.widget.widget.__oldDisplay = old;
								domStyle.set(node, 'display', 'none');
								if (this.widget.onHide) {
									this.widget.onHide(true);
								}
							}
						};
						if (typeof opts.fade == "object") {
							for (const key in opts.fade) {
								animeOptions[key] = opts.fade[key];
							}
						}
						animejs(animeOptions);
					} else {
						var old = domStyle.get(node, 'display');
						if (!old) {
							old = 'block';
						}
						this.widget.widget.__oldDisplay = old;
						domStyle.set(node, 'display', 'none');
						if (this.widget.onHide) {
							this.widget.onHide(true);
						}
					}
				},
				meta: {}
			},

			/**
			 * Shows the widget.
			 * @function
			 * @instance
			 * @param {Object} opts - Options, set opts.fade to true for the widget to fade in.
			 * @memberof BaseWidget
			 */
			show: {
				script: function(opts) {
					if (this.widget.hidden) {
						this.widget.hidden = false;
						var node = this.widget.widget.domNode;
						if (!opts) {
							opts = {};
						}
						if (opts.fade) {
							const animeOptions = {
								targets: [node],
								opacity: [0, 1],
								duration: 1000,
								begin: () => {
									var old = domStyle.get(node, 'display');
									if (!old) {
										old = 'block';
									}
									this.widget.widget.__oldDisplay = old;
									domStyle.set(node, 'display', 'none');
									if (this.widget.onHide) {
										this.widget.onHide(true);
									}
								}
							};
							if (typeof opts.fade == "object") {
								for (const key in opts.fade) {
									animeOptions[key] = opts.fade[key];
								}
							}
							animejs(animeOptions);
						} else {
								var display = this.widget.widget.__oldDisplay;
								if (!display || display == "none") {
									display = "block";
								}
								domStyle.set(node, 'display', display);
								if (this.widget.onHide) {
									this.widget.onHide(false);
								}
						}
					}
				},
				meta: {}
			},
			
			/**
			 * Returns true if the widget is hidden.
			 * @function
			 * @instance
			 * @returns {Boolean} - True if hidden, otherwise false.
			 * @memberof BaseWidget
			 */
			isHidden: {
				script: function() {
					return this.widget.hidden;
				},
				meta: {}				
			},

			/**
			 * Set the widget-style
			 * @function
			 * @instance
			 * @param {Object} style - Object with style-properties
			 * @memberof BaseWidget
			 */
			setStyle: {
				script: function(style) {
					var selectedTheme = {};

					if (this.widget && this.widget.view) {
						selectedTheme = this.widget.view.getBaseTheme();
					}

					var themeStyles = {};
					var styleStr = JSON.stringify(style);
					var compiled = Handlebars.compile(styleStr);
					var updatedStyleStr = compiled(selectedTheme);
					themeStyles = JSON.parse(updatedStyleStr);
					this.widget.setStyleProps(themeStyles);
				}
			}
		}
	};
});

},
'animejs/animejs':function(){
/*
 * anime.js v3.2.2
 * (c) 2023 Julian Garnier
 * Released under the MIT license
 * animejs.com
 */

!(function (n, e) {
  "object" == typeof exports && "undefined" != typeof module
    ? (module.exports = e())
    : "function" == typeof define && define.amd
    ? define(e)
    : (n.anime = e());
})(this, function () {
  "use strict";
  var i = {
      update: null,
      begin: null,
      loopBegin: null,
      changeBegin: null,
      change: null,
      changeComplete: null,
      loopComplete: null,
      complete: null,
      loop: 1,
      direction: "normal",
      autoplay: !0,
      timelineOffset: 0,
    },
    M = {
      duration: 1e3,
      delay: 0,
      endDelay: 0,
      easing: "easeOutElastic(1, .5)",
      round: 0,
    },
    j = [
      "translateX",
      "translateY",
      "translateZ",
      "rotate",
      "rotateX",
      "rotateY",
      "rotateZ",
      "scale",
      "scaleX",
      "scaleY",
      "scaleZ",
      "skew",
      "skewX",
      "skewY",
      "perspective",
      "matrix",
      "matrix3d",
    ],
    l = { CSS: {}, springs: {} };
  function C(n, e, t) {
    return Math.min(Math.max(n, e), t);
  }
  function u(n, e) {
    return -1 < n.indexOf(e);
  }
  function o(n, e) {
    return n.apply(null, e);
  }
  var w = {
    arr: function (n) {
      return Array.isArray(n);
    },
    obj: function (n) {
      return u(Object.prototype.toString.call(n), "Object");
    },
    pth: function (n) {
      return w.obj(n) && n.hasOwnProperty("totalLength");
    },
    svg: function (n) {
      return n instanceof SVGElement;
    },
    inp: function (n) {
      return n instanceof HTMLInputElement;
    },
    dom: function (n) {
      return n.nodeType || w.svg(n);
    },
    str: function (n) {
      return "string" == typeof n;
    },
    fnc: function (n) {
      return "function" == typeof n;
    },
    und: function (n) {
      return void 0 === n;
    },
    nil: function (n) {
      return w.und(n) || null === n;
    },
    hex: function (n) {
      return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(n);
    },
    rgb: function (n) {
      return /^rgb/.test(n);
    },
    hsl: function (n) {
      return /^hsl/.test(n);
    },
    col: function (n) {
      return w.hex(n) || w.rgb(n) || w.hsl(n);
    },
    key: function (n) {
      return (
        !i.hasOwnProperty(n) &&
        !M.hasOwnProperty(n) &&
        "targets" !== n &&
        "keyframes" !== n
      );
    },
  };
  function d(n) {
    n = /\(([^)]+)\)/.exec(n);
    return n
      ? n[1].split(",").map(function (n) {
          return parseFloat(n);
        })
      : [];
  }
  function c(r, t) {
    var n = d(r),
      e = C(w.und(n[0]) ? 1 : n[0], 0.1, 100),
      a = C(w.und(n[1]) ? 100 : n[1], 0.1, 100),
      o = C(w.und(n[2]) ? 10 : n[2], 0.1, 100),
      n = C(w.und(n[3]) ? 0 : n[3], 0.1, 100),
      u = Math.sqrt(a / e),
      i = o / (2 * Math.sqrt(a * e)),
      c = i < 1 ? u * Math.sqrt(1 - i * i) : 0,
      s = i < 1 ? (i * u - n) / c : -n + u;
    function f(n) {
      var e = t ? (t * n) / 1e3 : n,
        e =
          i < 1
            ? Math.exp(-e * i * u) * (+Math.cos(c * e) + s * Math.sin(c * e))
            : (1 + s * e) * Math.exp(-e * u);
      return 0 === n || 1 === n ? n : 1 - e;
    }
    return t
      ? f
      : function () {
          var n = l.springs[r];
          if (n) return n;
          for (var e = 0, t = 0; ; )
            if (1 === f((e += 1 / 6))) {
              if (16 <= ++t) break;
            } else t = 0;
          return (n = e * (1 / 6) * 1e3), (l.springs[r] = n);
        };
  }
  function q(e) {
    return (
      void 0 === e && (e = 10),
      function (n) {
        return Math.ceil(C(n, 1e-6, 1) * e) * (1 / e);
      }
    );
  }
  var H = function (b, e, M, t) {
    if (0 <= b && b <= 1 && 0 <= M && M <= 1) {
      var x = new Float32Array(11);
      if (b !== e || M !== t)
        for (var n = 0; n < 11; ++n) x[n] = k(0.1 * n, b, M);
      return function (n) {
        return (b === e && M === t) || 0 === n || 1 === n ? n : k(r(n), e, t);
      };
    }
    function r(n) {
      for (var e = 0, t = 1; 10 !== t && x[t] <= n; ++t) e += 0.1;
      var r = e + 0.1 * ((n - x[--t]) / (x[t + 1] - x[t])),
        a = O(r, b, M);
      if (0.001 <= a) {
        for (var o = n, u = r, i = b, c = M, s = 0; s < 4; ++s) {
          var f = O(u, i, c);
          if (0 === f) return u;
          u -= (k(u, i, c) - o) / f;
        }
        return u;
      }
      if (0 === a) return r;
      for (
        var l, d, p = n, h = e, g = e + 0.1, m = b, v = M, y = 0;
        0 < (l = k((d = h + (g - h) / 2), m, v) - p) ? (g = d) : (h = d),
          1e-7 < Math.abs(l) && ++y < 10;

      );
      return d;
    }
  };
  function r(n, e) {
    return 1 - 3 * e + 3 * n;
  }
  function k(n, e, t) {
    return ((r(e, t) * n + (3 * t - 6 * e)) * n + 3 * e) * n;
  }
  function O(n, e, t) {
    return 3 * r(e, t) * n * n + 2 * (3 * t - 6 * e) * n + 3 * e;
  }
  (e = {
    linear: function () {
      return function (n) {
        return n;
      };
    },
  }),
    (t = {
      Sine: function () {
        return function (n) {
          return 1 - Math.cos((n * Math.PI) / 2);
        };
      },
      Expo: function () {
        return function (n) {
          return n ? Math.pow(2, 10 * n - 10) : 0;
        };
      },
      Circ: function () {
        return function (n) {
          return 1 - Math.sqrt(1 - n * n);
        };
      },
      Back: function () {
        return function (n) {
          return n * n * (3 * n - 2);
        };
      },
      Bounce: function () {
        return function (n) {
          for (var e, t = 4; n < ((e = Math.pow(2, --t)) - 1) / 11; );
          return (
            1 / Math.pow(4, 3 - t) - 7.5625 * Math.pow((3 * e - 2) / 22 - n, 2)
          );
        };
      },
      Elastic: function (n, e) {
        void 0 === e && (e = 0.5);
        var t = C((n = void 0 === n ? 1 : n), 1, 10),
          r = C(e, 0.1, 2);
        return function (n) {
          return 0 === n || 1 === n
            ? n
            : -t *
                Math.pow(2, 10 * (n - 1)) *
                Math.sin(
                  ((n - 1 - (r / (2 * Math.PI)) * Math.asin(1 / t)) *
                    (2 * Math.PI)) /
                    r
                );
        };
      },
    }),
    ["Quad", "Cubic", "Quart", "Quint"].forEach(function (n, e) {
      t[n] = function () {
        return function (n) {
          return Math.pow(n, e + 2);
        };
      };
    }),
    Object.keys(t).forEach(function (n) {
      var r = t[n];
      (e["easeIn" + n] = r),
        (e["easeOut" + n] = function (e, t) {
          return function (n) {
            return 1 - r(e, t)(1 - n);
          };
        }),
        (e["easeInOut" + n] = function (e, t) {
          return function (n) {
            return n < 0.5 ? r(e, t)(2 * n) / 2 : 1 - r(e, t)(-2 * n + 2) / 2;
          };
        }),
        (e["easeOutIn" + n] = function (e, t) {
          return function (n) {
            return n < 0.5
              ? (1 - r(e, t)(1 - 2 * n)) / 2
              : (r(e, t)(2 * n - 1) + 1) / 2;
          };
        });
    });
  var e,
    t,
    s = e;
  function P(n, e) {
    if (w.fnc(n)) return n;
    var t = n.split("(")[0],
      r = s[t],
      a = d(n);
    switch (t) {
      case "spring":
        return c(n, e);
      case "cubicBezier":
        return o(H, a);
      case "steps":
        return o(q, a);
      default:
        return o(r, a);
    }
  }
  function a(n) {
    try {
      return document.querySelectorAll(n);
    } catch (n) {}
  }
  function I(n, e) {
    for (
      var t,
        r = n.length,
        a = 2 <= arguments.length ? e : void 0,
        o = [],
        u = 0;
      u < r;
      u++
    )
      u in n && ((t = n[u]), e.call(a, t, u, n)) && o.push(t);
    return o;
  }
  function f(n) {
    return n.reduce(function (n, e) {
      return n.concat(w.arr(e) ? f(e) : e);
    }, []);
  }
  function p(n) {
    return w.arr(n)
      ? n
      : (n = w.str(n) ? a(n) || n : n) instanceof NodeList ||
        n instanceof HTMLCollection
      ? [].slice.call(n)
      : [n];
  }
  function h(n, e) {
    return n.some(function (n) {
      return n === e;
    });
  }
  function g(n) {
    var e,
      t = {};
    for (e in n) t[e] = n[e];
    return t;
  }
  function x(n, e) {
    var t,
      r = g(n);
    for (t in n) r[t] = (e.hasOwnProperty(t) ? e : n)[t];
    return r;
  }
  function D(n, e) {
    var t,
      r = g(n);
    for (t in e) r[t] = (w.und(n[t]) ? e : n)[t];
    return r;
  }
  function V(n) {
    var e, t, r, a, o, u, i;
    return w.rgb(n)
      ? (e = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec((t = n)))
        ? "rgba(" + e[1] + ",1)"
        : t
      : w.hex(n)
      ? ((e = (e = n).replace(
          /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
          function (n, e, t, r) {
            return e + e + t + t + r + r;
          }
        )),
        (e = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e)),
        "rgba(" +
          parseInt(e[1], 16) +
          "," +
          parseInt(e[2], 16) +
          "," +
          parseInt(e[3], 16) +
          ",1)")
      : w.hsl(n)
      ? ((t =
          /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec((t = n)) ||
          /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(t)),
        (n = parseInt(t[1], 10) / 360),
        (u = parseInt(t[2], 10) / 100),
        (i = parseInt(t[3], 10) / 100),
        (t = t[4] || 1),
        0 == u
          ? (r = a = o = i)
          : ((r = c(
              (u = 2 * i - (i = i < 0.5 ? i * (1 + u) : i + u - i * u)),
              i,
              n + 1 / 3
            )),
            (a = c(u, i, n)),
            (o = c(u, i, n - 1 / 3))),
        "rgba(" + 255 * r + "," + 255 * a + "," + 255 * o + "," + t + ")")
      : void 0;
    function c(n, e, t) {
      return (
        t < 0 && (t += 1),
        1 < t && --t,
        t < 1 / 6
          ? n + 6 * (e - n) * t
          : t < 0.5
          ? e
          : t < 2 / 3
          ? n + (e - n) * (2 / 3 - t) * 6
          : n
      );
    }
  }
  function B(n) {
    n =
      /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(
        n
      );
    if (n) return n[1];
  }
  function m(n, e) {
    return w.fnc(n) ? n(e.target, e.id, e.total) : n;
  }
  function v(n, e) {
    return n.getAttribute(e);
  }
  function y(n, e, t) {
    var r, a, o;
    return h([t, "deg", "rad", "turn"], B(e))
      ? e
      : ((r = l.CSS[e + t]),
        w.und(r)
          ? ((a = document.createElement(n.tagName)),
            (n =
              n.parentNode && n.parentNode !== document
                ? n.parentNode
                : document.body).appendChild(a),
            (a.style.position = "absolute"),
            (a.style.width = 100 + t),
            (o = 100 / a.offsetWidth),
            n.removeChild(a),
            (n = o * parseFloat(e)),
            (l.CSS[e + t] = n))
          : r);
  }
  function $(n, e, t) {
    var r;
    if (e in n.style)
      return (
        (r = e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()),
        (e = n.style[e] || getComputedStyle(n).getPropertyValue(r) || "0"),
        t ? y(n, e, t) : e
      );
  }
  function b(n, e) {
    return w.dom(n) && !w.inp(n) && (!w.nil(v(n, e)) || (w.svg(n) && n[e]))
      ? "attribute"
      : w.dom(n) && h(j, e)
      ? "transform"
      : w.dom(n) && "transform" !== e && $(n, e)
      ? "css"
      : null != n[e]
      ? "object"
      : void 0;
  }
  function W(n) {
    if (w.dom(n)) {
      for (
        var e,
          t = n.style.transform || "",
          r = /(\w+)\(([^)]*)\)/g,
          a = new Map();
        (e = r.exec(t));

      )
        a.set(e[1], e[2]);
      return a;
    }
  }
  function X(n, e, t, r) {
    var a = u(e, "scale")
        ? 1
        : 0 +
          (u((a = e), "translate") || "perspective" === a
            ? "px"
            : u(a, "rotate") || u(a, "skew")
            ? "deg"
            : void 0),
      o = W(n).get(e) || a;
    return (
      t && (t.transforms.list.set(e, o), (t.transforms.last = e)),
      r ? y(n, o, r) : o
    );
  }
  function T(n, e, t, r) {
    switch (b(n, e)) {
      case "transform":
        return X(n, e, r, t);
      case "css":
        return $(n, e, t);
      case "attribute":
        return v(n, e);
      default:
        return n[e] || 0;
    }
  }
  function E(n, e) {
    var t = /^(\*=|\+=|-=)/.exec(n);
    if (!t) return n;
    var r = B(n) || 0,
      a = parseFloat(e),
      o = parseFloat(n.replace(t[0], ""));
    switch (t[0][0]) {
      case "+":
        return a + o + r;
      case "-":
        return a - o + r;
      case "*":
        return a * o + r;
    }
  }
  function Y(n, e) {
    var t;
    return w.col(n)
      ? V(n)
      : /\s/g.test(n)
      ? n
      : ((t = (t = B(n)) ? n.substr(0, n.length - t.length) : n),
        e ? t + e : t);
  }
  function F(n, e) {
    return Math.sqrt(Math.pow(e.x - n.x, 2) + Math.pow(e.y - n.y, 2));
  }
  function Z(n) {
    for (var e, t = n.points, r = 0, a = 0; a < t.numberOfItems; a++) {
      var o = t.getItem(a);
      0 < a && (r += F(e, o)), (e = o);
    }
    return r;
  }
  function G(n) {
    if (n.getTotalLength) return n.getTotalLength();
    switch (n.tagName.toLowerCase()) {
      case "circle":
        return 2 * Math.PI * v(n, "r");
      case "rect":
        return 2 * v((t = n), "width") + 2 * v(t, "height");
      case "line":
        return F(
          { x: v((t = n), "x1"), y: v(t, "y1") },
          { x: v(t, "x2"), y: v(t, "y2") }
        );
      case "polyline":
        return Z(n);
      case "polygon":
        return (
          (e = n.points), Z(n) + F(e.getItem(e.numberOfItems - 1), e.getItem(0))
        );
    }
    var e, t;
  }
  function Q(n, e) {
    var e = e || {},
      n =
        e.el ||
        (function (n) {
          for (var e = n.parentNode; w.svg(e) && w.svg(e.parentNode); )
            e = e.parentNode;
          return e;
        })(n),
      t = n.getBoundingClientRect(),
      r = v(n, "viewBox"),
      a = t.width,
      t = t.height,
      e = e.viewBox || (r ? r.split(" ") : [0, 0, a, t]);
    return {
      el: n,
      viewBox: e,
      x: +e[0],
      y: +e[1],
      w: a,
      h: t,
      vW: e[2],
      vH: e[3],
    };
  }
  function z(n, e) {
    var t = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g,
      r = Y(w.pth(n) ? n.totalLength : n, e) + "";
    return {
      original: r,
      numbers: r.match(t) ? r.match(t).map(Number) : [0],
      strings: w.str(n) || e ? r.split(t) : [],
    };
  }
  function A(n) {
    return I(n ? f(w.arr(n) ? n.map(p) : p(n)) : [], function (n, e, t) {
      return t.indexOf(n) === e;
    });
  }
  function _(n) {
    var t = A(n);
    return t.map(function (n, e) {
      return { target: n, id: e, total: t.length, transforms: { list: W(n) } };
    });
  }
  function R(e) {
    for (
      var t = I(
          f(
            e.map(function (n) {
              return Object.keys(n);
            })
          ),
          function (n) {
            return w.key(n);
          }
        ).reduce(function (n, e) {
          return n.indexOf(e) < 0 && n.push(e), n;
        }, []),
        a = {},
        n = 0;
      n < t.length;
      n++
    )
      !(function (n) {
        var r = t[n];
        a[r] = e.map(function (n) {
          var e,
            t = {};
          for (e in n) w.key(e) ? e == r && (t.value = n[e]) : (t[e] = n[e]);
          return t;
        });
      })(n);
    return a;
  }
  function J(n, e) {
    var t,
      r = [],
      a = e.keyframes;
    for (t in (e = a ? D(R(a), e) : e))
      w.key(t) &&
        r.push({
          name: t,
          tweens: (function (n, t) {
            var e,
              r = g(t),
              a =
                (/^spring/.test(r.easing) && (r.duration = c(r.easing)),
                w.arr(n) &&
                  (2 === (e = n.length) && !w.obj(n[0])
                    ? (n = { value: n })
                    : w.fnc(t.duration) || (r.duration = t.duration / e)),
                w.arr(n) ? n : [n]);
            return a
              .map(function (n, e) {
                n = w.obj(n) && !w.pth(n) ? n : { value: n };
                return (
                  w.und(n.delay) && (n.delay = e ? 0 : t.delay),
                  w.und(n.endDelay) &&
                    (n.endDelay = e === a.length - 1 ? t.endDelay : 0),
                  n
                );
              })
              .map(function (n) {
                return D(n, r);
              });
          })(e[t], n),
        });
    return r;
  }
  function K(i, c) {
    var s;
    return i.tweens.map(function (n) {
      var n = (function (n, e) {
          var t,
            r = {};
          for (t in n) {
            var a = m(n[t], e);
            w.arr(a) &&
              1 ===
                (a = a.map(function (n) {
                  return m(n, e);
                })).length &&
              (a = a[0]),
              (r[t] = a);
          }
          return (
            (r.duration = parseFloat(r.duration)),
            (r.delay = parseFloat(r.delay)),
            r
          );
        })(n, c),
        e = n.value,
        t = w.arr(e) ? e[1] : e,
        r = B(t),
        a = T(c.target, i.name, r, c),
        o = s ? s.to.original : a,
        u = w.arr(e) ? e[0] : o,
        a = B(u) || B(a),
        r = r || a;
      return (
        w.und(t) && (t = o),
        (n.from = z(u, r)),
        (n.to = z(E(t, u), r)),
        (n.start = s ? s.end : 0),
        (n.end = n.start + n.delay + n.duration + n.endDelay),
        (n.easing = P(n.easing, n.duration)),
        (n.isPath = w.pth(e)),
        (n.isPathTargetInsideSVG = n.isPath && w.svg(c.target)),
        (n.isColor = w.col(n.from.original)),
        n.isColor && (n.round = 1),
        (s = n)
      );
    });
  }
  var U = {
    css: function (n, e, t) {
      return (n.style[e] = t);
    },
    attribute: function (n, e, t) {
      return n.setAttribute(e, t);
    },
    object: function (n, e, t) {
      return (n[e] = t);
    },
    transform: function (n, e, t, r, a) {
      var o;
      r.list.set(e, t),
        (e !== r.last && !a) ||
          ((o = ""),
          r.list.forEach(function (n, e) {
            o += e + "(" + n + ") ";
          }),
          (n.style.transform = o));
    },
  };
  function nn(n, u) {
    _(n).forEach(function (n) {
      for (var e in u) {
        var t = m(u[e], n),
          r = n.target,
          a = B(t),
          o = T(r, e, a, n),
          t = E(Y(t, a || B(o)), o),
          a = b(r, e);
        U[a](r, e, t, n.transforms, !0);
      }
    });
  }
  function en(n, e) {
    return I(
      f(
        n.map(function (o) {
          return e.map(function (n) {
            var e,
              t,
              r = o,
              a = b(r.target, n.name);
            if (a)
              return (
                (t = (e = K(n, r))[e.length - 1]),
                {
                  type: a,
                  property: n.name,
                  animatable: r,
                  tweens: e,
                  duration: t.end,
                  delay: e[0].delay,
                  endDelay: t.endDelay,
                }
              );
          });
        })
      ),
      function (n) {
        return !w.und(n);
      }
    );
  }
  function tn(n, e) {
    function t(n) {
      return n.timelineOffset || 0;
    }
    var r = n.length,
      a = {};
    return (
      (a.duration = r
        ? Math.max.apply(
            Math,
            n.map(function (n) {
              return t(n) + n.duration;
            })
          )
        : e.duration),
      (a.delay = r
        ? Math.min.apply(
            Math,
            n.map(function (n) {
              return t(n) + n.delay;
            })
          )
        : e.delay),
      (a.endDelay = r
        ? a.duration -
          Math.max.apply(
            Math,
            n.map(function (n) {
              return t(n) + n.duration - n.endDelay;
            })
          )
        : e.endDelay),
      a
    );
  }
  var rn = 0;
  var N,
    S = [],
    an =
      ("undefined" != typeof document &&
        document.addEventListener("visibilitychange", function () {
          L.suspendWhenDocumentHidden &&
            (n()
              ? (N = cancelAnimationFrame(N))
              : (S.forEach(function (n) {
                  return n._onDocumentVisibility();
                }),
                an()));
        }),
      function () {
        !(N || (n() && L.suspendWhenDocumentHidden)) &&
          0 < S.length &&
          (N = requestAnimationFrame(on));
      });
  function on(n) {
    for (var e = S.length, t = 0; t < e; ) {
      var r = S[t];
      r.paused ? (S.splice(t, 1), e--) : (r.tick(n), t++);
    }
    N = 0 < t ? requestAnimationFrame(on) : void 0;
  }
  function n() {
    return document && document.hidden;
  }
  function L(n) {
    var c,
      s = 0,
      f = 0,
      l = 0,
      d = 0,
      p = null;
    function h(n) {
      var e =
        window.Promise &&
        new Promise(function (n) {
          return (p = n);
        });
      return (n.finished = e);
    }
    (e = x(i, (n = n = void 0 === n ? {} : n))),
      (t = J((r = x(M, n)), n)),
      (n = _(n.targets)),
      (r = tn((t = en(n, t)), r)),
      (a = rn),
      rn++;
    var e,
      t,
      r,
      a,
      k = D(e, {
        id: a,
        children: [],
        animatables: n,
        animations: t,
        duration: r.duration,
        delay: r.delay,
        endDelay: r.endDelay,
      });
    h(k);
    function g() {
      var n = k.direction;
      "alternate" !== n &&
        (k.direction = "normal" !== n ? "normal" : "reverse"),
        (k.reversed = !k.reversed),
        c.forEach(function (n) {
          return (n.reversed = k.reversed);
        });
    }
    function m(n) {
      return k.reversed ? k.duration - n : n;
    }
    function o() {
      (s = 0), (f = m(k.currentTime) * (1 / L.speed));
    }
    function v(n, e) {
      e && e.seek(n - e.timelineOffset);
    }
    function y(e) {
      for (var n = 0, t = k.animations, r = t.length; n < r; ) {
        for (
          var a = t[n],
            o = a.animatable,
            u = a.tweens,
            i = u.length - 1,
            c = u[i],
            i =
              (i &&
                (c =
                  I(u, function (n) {
                    return e < n.end;
                  })[0] || c),
              C(e - c.start - c.delay, 0, c.duration) / c.duration),
            s = isNaN(i) ? 1 : c.easing(i),
            f = c.to.strings,
            l = c.round,
            d = [],
            p = c.to.numbers.length,
            h = void 0,
            g = 0;
          g < p;
          g++
        ) {
          var m = void 0,
            v = c.to.numbers[g],
            y = c.from.numbers[g] || 0,
            m = c.isPath
              ? (function (e, t, n) {
                  function r(n) {
                    return e.el.getPointAtLength(
                      1 <= t + (n = void 0 === n ? 0 : n) ? t + n : 0
                    );
                  }
                  var a = Q(e.el, e.svg),
                    o = r(),
                    u = r(-1),
                    i = r(1),
                    c = n ? 1 : a.w / a.vW,
                    s = n ? 1 : a.h / a.vH;
                  switch (e.property) {
                    case "x":
                      return (o.x - a.x) * c;
                    case "y":
                      return (o.y - a.y) * s;
                    case "angle":
                      return (180 * Math.atan2(i.y - u.y, i.x - u.x)) / Math.PI;
                  }
                })(c.value, s * v, c.isPathTargetInsideSVG)
              : y + s * (v - y);
          !l || (c.isColor && 2 < g) || (m = Math.round(m * l) / l), d.push(m);
        }
        var b = f.length;
        if (b)
          for (var h = f[0], M = 0; M < b; M++) {
            f[M];
            var x = f[M + 1],
              w = d[M];
            isNaN(w) || (h += x ? w + x : w + " ");
          }
        else h = d[0];
        U[a.type](o.target, a.property, h, o.transforms),
          (a.currentValue = h),
          n++;
      }
    }
    function b(n) {
      k[n] && !k.passThrough && k[n](k);
    }
    function u(n) {
      var e = k.duration,
        t = k.delay,
        r = e - k.endDelay,
        a = m(n);
      if (
        ((k.progress = C((a / e) * 100, 0, 100)),
        (k.reversePlayback = a < k.currentTime),
        c)
      ) {
        var o = a;
        if (k.reversePlayback) for (var u = d; u--; ) v(o, c[u]);
        else for (var i = 0; i < d; i++) v(o, c[i]);
      }
      !k.began && 0 < k.currentTime && ((k.began = !0), b("begin")),
        !k.loopBegan &&
          0 < k.currentTime &&
          ((k.loopBegan = !0), b("loopBegin")),
        a <= t && 0 !== k.currentTime && y(0),
        ((r <= a && k.currentTime !== e) || !e) && y(e),
        t < a && a < r
          ? (k.changeBegan ||
              ((k.changeBegan = !0),
              (k.changeCompleted = !1),
              b("changeBegin")),
            b("change"),
            y(a))
          : k.changeBegan &&
            ((k.changeCompleted = !0),
            (k.changeBegan = !1),
            b("changeComplete")),
        (k.currentTime = C(a, 0, e)),
        k.began && b("update"),
        e <= n &&
          ((f = 0),
          k.remaining && !0 !== k.remaining && k.remaining--,
          k.remaining
            ? ((s = l),
              b("loopComplete"),
              (k.loopBegan = !1),
              "alternate" === k.direction && g())
            : ((k.paused = !0),
              k.completed ||
                ((k.completed = !0),
                b("loopComplete"),
                b("complete"),
                !k.passThrough && "Promise" in window && (p(), h(k)))));
    }
    return (
      (k.reset = function () {
        var n = k.direction;
        (k.passThrough = !1),
          (k.currentTime = 0),
          (k.progress = 0),
          (k.paused = !0),
          (k.began = !1),
          (k.loopBegan = !1),
          (k.changeBegan = !1),
          (k.completed = !1),
          (k.changeCompleted = !1),
          (k.reversePlayback = !1),
          (k.reversed = "reverse" === n),
          (k.remaining = k.loop),
          (c = k.children);
        for (var e = (d = c.length); e--; ) k.children[e].reset();
        ((k.reversed && !0 !== k.loop) ||
          ("alternate" === n && 1 === k.loop)) &&
          k.remaining++,
          y(k.reversed ? k.duration : 0);
      }),
      (k._onDocumentVisibility = o),
      (k.set = function (n, e) {
        return nn(n, e), k;
      }),
      (k.tick = function (n) {
        u(((l = n) + (f - (s = s || l))) * L.speed);
      }),
      (k.seek = function (n) {
        u(m(n));
      }),
      (k.pause = function () {
        (k.paused = !0), o();
      }),
      (k.play = function () {
        k.paused &&
          (k.completed && k.reset(), (k.paused = !1), S.push(k), o(), an());
      }),
      (k.reverse = function () {
        g(), (k.completed = !k.reversed), o();
      }),
      (k.restart = function () {
        k.reset(), k.play();
      }),
      (k.remove = function (n) {
        cn(A(n), k);
      }),
      k.reset(),
      k.autoplay && k.play(),
      k
    );
  }
  function un(n, e) {
    for (var t = e.length; t--; )
      h(n, e[t].animatable.target) && e.splice(t, 1);
  }
  function cn(n, e) {
    var t = e.animations,
      r = e.children;
    un(n, t);
    for (var a = r.length; a--; ) {
      var o = r[a],
        u = o.animations;
      un(n, u), u.length || o.children.length || r.splice(a, 1);
    }
    t.length || r.length || e.pause();
  }
  return (
    (L.version = "3.2.2"),
    (L.speed = 1),
    (L.suspendWhenDocumentHidden = !0),
    (L.running = S),
    (L.remove = function (n) {
      for (var e = A(n), t = S.length; t--; ) cn(e, S[t]);
    }),
    (L.get = T),
    (L.set = nn),
    (L.convertPx = y),
    (L.path = function (n, e) {
      var t = w.str(n) ? a(n)[0] : n,
        r = e || 100;
      return function (n) {
        return { property: n, el: t, svg: Q(t), totalLength: G(t) * (r / 100) };
      };
    }),
    (L.setDashoffset = function (n) {
      var e = G(n);
      return n.setAttribute("stroke-dasharray", e), e;
    }),
    (L.stagger = function (n, e) {
      var i = (e = void 0 === e ? {} : e).direction || "normal",
        c = e.easing ? P(e.easing) : null,
        s = e.grid,
        f = e.axis,
        l = e.from || 0,
        d = "first" === l,
        p = "center" === l,
        h = "last" === l,
        g = w.arr(n),
        m = g ? parseFloat(n[0]) : parseFloat(n),
        v = g ? parseFloat(n[1]) : 0,
        y = B(g ? n[1] : n) || 0,
        b = e.start || 0 + (g ? m : 0),
        M = [],
        x = 0;
      return function (n, e, t) {
        if (
          (d && (l = 0), p && (l = (t - 1) / 2), h && (l = t - 1), !M.length)
        ) {
          for (var r, a, o, u = 0; u < t; u++)
            s
              ? ((r = p ? (s[0] - 1) / 2 : l % s[0]),
                (a = p ? (s[1] - 1) / 2 : Math.floor(l / s[0])),
                (r = r - (u % s[0])),
                (a = a - Math.floor(u / s[0])),
                (o = Math.sqrt(r * r + a * a)),
                "x" === f && (o = -r),
                M.push((o = "y" === f ? -a : o)))
              : M.push(Math.abs(l - u)),
              (x = Math.max.apply(Math, M));
          c &&
            (M = M.map(function (n) {
              return c(n / x) * x;
            })),
            "reverse" === i &&
              (M = M.map(function (n) {
                return f ? (n < 0 ? -1 * n : -n) : Math.abs(x - n);
              }));
        }
        return b + (g ? (v - m) / x : m) * (Math.round(100 * M[e]) / 100) + y;
      };
    }),
    (L.timeline = function (u) {
      var i = L((u = void 0 === u ? {} : u));
      return (
        (i.duration = 0),
        (i.add = function (n, e) {
          var t = S.indexOf(i),
            r = i.children;
          function a(n) {
            n.passThrough = !0;
          }
          -1 < t && S.splice(t, 1);
          for (var o = 0; o < r.length; o++) a(r[o]);
          (t = D(n, x(M, u))),
            (t.targets = t.targets || u.targets),
            (n = i.duration),
            (t.autoplay = !1),
            (t.direction = i.direction),
            (t.timelineOffset = w.und(e) ? n : E(e, n)),
            a(i),
            i.seek(t.timelineOffset),
            (e = L(t)),
            a(e),
            r.push(e),
            (n = tn(r, u));
          return (
            (i.delay = n.delay),
            (i.endDelay = n.endDelay),
            (i.duration = n.duration),
            i.seek(0),
            i.reset(),
            i.autoplay && i.play(),
            i
          );
        }),
        i
      );
    }),
    (L.easing = P),
    (L.penner = s),
    (L.random = function (n, e) {
      return Math.floor(Math.random() * (e - n + 1)) + n;
    }),
    L
  );
});

},
'appivo/mvc/widgets/BaseView':function(){
define (['dojo/_base/lang',
         'dojo/Deferred',
		 'dojo/i18n!../../nls/Widgets',
         'appivo/mvc/Function'], function(lang, Deferred, messages) {
	return {
		name: 'BaseView',
		inherits: 'BaseWidget',
		properties: {
			functions: {
				type: 'CUSTOM',
				get: function() {
					return this.properties['functions'];
				}
			},
			queries: {
				type: 'CUSTOM',
				get: function() {
					return this.properties['queries'];
				}
			},
			tabMode: {
				type: 'OPTION',
				options: [
				    {
				    	label:  messages.manualTabIndex,
				    	value: 'custom'
				    },
					{
						label: messages.autoLTRTabIndex,
						value: 'LTR'
					},
				    {
				    	label: messages.autoRTLTabIndex,
				    	value: 'RTL'
				    }
				],
				defaultValue: 'LTR',
				get: function() {
					var type = this.properties['tabMode'];
					if (!type) {
						type = 'custom';
					}
					return type;
				},
				displayWhen: {
			        field: "uiType",
			        value: "desktop"
                }
			}
		},
		events: [
		    'SessionStart',
		    {
                name: 'ViewLoad',
                parameters: [{
                    name: "event",
                    description: "The event that triggered the handler"
                }]
            },
            {
                name: 'ViewUnLoad',
                parameters: [{
                    name: "event",
                    description: "The event that triggered the handler"
                }]
            },
			{
				name: 'Offline',
				parameters: [{
					name: "event"
				}]
			},
			{
				name: "Online",
				parameters: [{
					name: "event"
				}]
			}
		],
		editor: function(widgetEditor) {
			var def = new Deferred();
			require(['appivo/mvc/widgets/BaseViewEditor'], function(BaseViewEditor) {
				var editor = new BaseViewEditor();
				var ok = editor.createEditor(widgetEditor);
				def.resolve(ok);
			});
			return def;
		}
	}	
});
},
'appivo/mvc/widgets/BaseViewEditor':function(){
define (['vue/vue',
         'dojo/_base/lang',
         'dijit/form/Button',
         'dijit/form/TextBox',
         'dijit/Tooltip',
         'appivo/mvc/Function',
         'dojo/i18n!appivo/builder/nls/Builder',
         'dojo/i18n!appivo/nls/WidgetEditor',
         'appivo/builder/components/CodeDialog',
         'appivo/builder/components/DialogManager'], function(Vue, lang, Button, TextBox, Tooltip, Function, BuilderMessages, Messages, CodeDialog, DialogManager) {

    function BaseViewEditor(options) {
        lang.mixin(this, options);
    };

    BaseViewEditor.prototype = {

		createEditor: function(widgetEditor) {
			// this._createFuncEditor(widgetEditor);
			this._createQueryEditor(widgetEditor);
			return true;
		},

		_createQueryEditor: function(widgetEditor) {
			var queryStore = new dojo.store.Observable(new dojo.store.Memory({
				idProperty: 'idx'
			}));

			var options = new Array();
			var first = null;
			var qlist = widgetEditor.state.data.app.queries;
            if (qlist.length < 1) {
                qlist = [];
            }
			for (var i = 0; i < qlist.length; i++) {
				var q = qlist[i];
				if (!first) {
					first = q.name;
				}
				options.push({
					label: q.name,
					value: q.name
				});
			}

			var columns = [
			   {
				   field: 'name',
				   name: 'Query',
				   editable: true,
				   editor: "dijit.form.Select",
				   editorArgs: {
						props: 'options: ' + JSON.stringify(options)
				   }
			   }
			 ];

			var widget = widgetEditor.widget;
			var queries = [];
			var idx = 0;
			if (lang.isObject(widget)) {
				var list = widget.get('queries');
				if (list) {
					for (var i = 0; i < list.length; i++) {
						var query = list[i];
						queries.push({
							idx: i,
							name: query
						});
					}
					idx = i;
				} else {
					queries = [];
				}
				queryStore.setData(queries);
			}

			var addButton = new Button({
				label: 'Add Query',
                disabled: qlist.length < 1,
				onClick: lang.hitch(this, function() {
					if (first) {
						var id = ++idx;
						queryStore.add({
							idx: id,
							name: first
						});
					}
				})
			});

            var addTooltip = new Tooltip({
                label: qlist.length < 1 ? 'No queries available' : 'Click to add a query to the view',
                connectId: [addButton.domNode]
            });

			var queryGrid = null;
			var rowMenu = new Array();
			rowMenu.push({
				label: 'Delete',
				onClick: function() {
					var item = queryGrid.menu.context.row.rawData();
					queryStore.remove(item.idx);
				}
			});

			queryGrid = widgetEditor._createGrid({
				store: queryStore,
				structure: columns,
				rowMenu: rowMenu,
				sort: true,
				edit: true
			});

			queryGrid.startup();
	    	queryGrid.model.sort({colId: 'idx'});
	    	queryGrid.body.refresh();

			var queryPane = new dijit.layout.ContentPane({
				title: 'Queries',
				content: queryGrid,
				_buttons: [addButton],
				getValues: function() {
					var values = {};
					var queries = new Array();
					var store = queryGrid.store;
	    			var result = store.query({}, {
	    				sort: [
	    				   {
	    					   attribute: 'idx'
	    				   }
	    				]
	    			});

					for (var i = 0; i < result.length; i++) {
						var q = result[i];
						queries.push(q.name);
					}
					values['widget.queries'] = queries;
					return values;
				}
			});

			widgetEditor.addPane(queryPane);
		},

		_createFuncEditor: function(widgetEditor) {
            var t = this;
            var funcColumns = [
               {
                   field: 'name',
                   name: 'Name'
               },
               {
                   field: 'script',
                   name: 'Script',
                   widgetsInCell: true,
                   navigable: true,
                   decorator: function() {
                        //Generate cell widget template string
                        return [
                                '<div><button data-dojo-type="dijit.form.Button" ',
                                'data-dojo-attach-point="btn" ',
                                'data-dojo-props="onClick: function() {',
                                'this.editFunc();}">',
                                'Edit</button> <button data-dojo-type="dijit.form.Button" ',
                                'data-dojo-attach-point="del" data-dojo-props="onClick: function()',
                                '{ this.delFunc();}">Delete</button></div>'
                                ].join('');
                    },
                    setCellValue: function (data) {
                        var _this = this;
                        if (data != undefined && data != null) {
                            if (typeof data == "string") {
                                data = {
                                    script: {
                                        script: data
                                    },
                                    quick: undefined,
                                    logic: undefined
                                };
                            } else if (data.script) {
                                data = {
                                    script:{
                                        script: data.script.script
                                    },
                                    quick: data.quick,
                                    logic: data.logic
                                };
                            }
                        } else {
                            data = {
                                script: {
                                    script: undefined
                                },
                                quick: undefined,
                                logic: undefined
                            };
                        }
                        this.btn.editFunc = lang.hitch(this, function() {
                            var raw = _this.cell.row.rawData();
                            var validation = function(name, oldName, result) {
                            	var res = true;
                            	var viewFunctions = funcStore.query({});
                            	for (var i = 0; i < viewFunctions.length; i++) {
									var func = viewFunctions[i];
									if (func.name === name && func.name !== raw.name) {
                            			res = false;
                            			result.msg = dialog.$t('CodeEditorFunctionNameMustBeUnique');
                            		}
								}
                            	return res;
                            };
                            var dialog = new Vue({
                                data: {
                                	code: data,
                                	itemname: raw.name,
                                	itemvalidation: {'custom': validation, 'required': true, 'alphaNumeric': true, 'maxLength': 25}
                                },
                                template: '<dialog :code.sync="code" :itemname.sync="itemname" :itemvalidation="itemvalidation" ></dialog>',
                                state: widgetEditor.state,
                                locale: BuilderMessages,
                                components: {
                                    'dialog': CodeDialog
                                },
                                events: {
                                    'done': function() {
                                    	raw.name = dialog.itemname;
                                        raw.script = JSON.parse(JSON.stringify(dialog.code));
                                        DialogManager.closeDialog(dialog);
                                        _this.cell.row.setRawData(raw);
                                    },
                                    'cancel': function() {
                                        DialogManager.closeDialog(dialog);
                                    }
                                }
                            });
                            DialogManager.openDialog(dialog);
                        });
                        if (data == undefined || data == null || data.script == undefined || data.script == null || data.script.script == undefined || data.script.script == null) {
                            this.btn.set('label', Messages.add);
                            this.del.set('disabled', true);
                        } else {
                            this.btn.set('label', Messages.edit);
                            this.del.set('disabled', false);
                        }
                        this.del.delFunc = lang.hitch(this, function() {
                            _this.cell.setRawData(null);
                        });
                    }
                }
            ];

            var funcStore = new dojo.store.Observable(new dojo.store.Memory({
                idProperty: 'idx'
            }));

            var widget = widgetEditor.widget;
            var functions = [];
            var idx = 0;
            if (lang.isObject(widget)) {
                var list = widget.get('functions');
                if (list) {
                    var i = 0;
                    for (var key in list) {
                        var func = list[key];
                        if (func.toJSON) {
                            func = func.toJSON();
                        } else {
                            func = lang.clone(func);
                        }
                        func.idx = i++;
                        functions.push(func);
                    }
                    idx = i;
                } else {
                    functions = [];
                }

                functions.sort(function(a,b) {
                    return a.name.localeCompare(b.name);
                });
                funcStore.setData(functions);
            }

            var widget = widgetEditor.widget;

            var addButton = new Button({
                label: 'Add Function',
                onClick: lang.hitch(this, function() {
                    var id = ++idx;
                    var func = new Function({
                        name: 'Function' + id
                    });
                    func.idx = id;
                    functions.push(func);
                    // sort functions on adding new function
                    functions.sort(function(a,b) {
                        return a.name.localeCompare(b.name);
                    });
                    funcStore.setData(functions);
                    funcStore.notify();
                })
            });

            var funcGrid = null;
            var rowMenu = new Array();
            rowMenu.push({
                label: 'Delete',
                onClick: function() {
                    var item = funcGrid.menu.context.row.rawData();
                    funcStore.remove(item.idx);
                }
            });

            funcGrid = widgetEditor._createGrid({
                store: funcStore,
                structure: funcColumns,
                rowMenu: rowMenu,
                sort: true,
                edit: true,
                filter: true
            });

            funcGrid.startup();
            funcGrid.model.sort({colId: 'idx'});
            funcGrid.body.refresh();

            var searchInput = new TextBox({
                value: "",
                class:"function-search-input",
                style:"margin:0.2em;",
                placeHolder: Messages.searchFunction,
                onChange:lang.hitch(this,function(value){
                    funcGrid.filter.setFilter(function(rowCache, rowId){
                        var item = rowCache.item
                        var isPresent = item.name.toLowerCase().indexOf(value.toLowerCase());
                        return (isPresent !== -1);
                    });
                }),
                intermediateChanges:true
            });
            searchInput.startup();

            var funcPane = new dijit.layout.ContentPane({
                title: 'Functions',
                content: funcGrid,
                _buttons: [addButton, searchInput],
                getValues: function() {
                    var values = {};
                    var funcs = {};
                    var store = funcGrid.store;
                    var result = store.query({}, {
                        sort: [
                           {
                               attribute: 'idx'
                           }
                        ]
                    });

                    for (var i = 0; i < result.length; i++) {
                        var func = result[i];
                        if (func.toJSON) {
                            func = func.toJSON();
                        }
                        delete func.idx;
                        funcs[func.name] = func;
                    }
                    values['widget.functions'] = funcs;
                    return values;
                }
            });

            widgetEditor.addPane(funcPane);
        }
	};

    return BaseViewEditor;
});

},
'dijit/form/Button':function(){
define([
	"require",
	"dojo/_base/declare", // declare
	"dojo/dom-class", // domClass.toggle
	"dojo/has", // has("dijit-legacy-requires")
	"dojo/_base/kernel", // kernel.deprecated
	"dojo/_base/lang", // lang.trim
	"dojo/ready",
	"./_FormWidget",
	"./_ButtonMixin",
	"dojo/text!./templates/Button.html",
	"../a11yclick"	// template uses ondijitclick
], function(require, declare, domClass, has, kernel, lang, ready, _FormWidget, _ButtonMixin, template){

	// module:
	//		dijit/form/Button

	// Back compat w/1.6, remove for 2.0
	if(has("dijit-legacy-requires")){
		ready(0, function(){
			var requires = ["dijit/form/DropDownButton", "dijit/form/ComboButton", "dijit/form/ToggleButton"];
			require(requires);	// use indirection so modules not rolled into a build
		});
	}

	var Button = declare("dijit.form.Button" + (has("dojo-bidi") ? "_NoBidi" : ""), [_FormWidget, _ButtonMixin], {
		// summary:
		//		Basically the same thing as a normal HTML button, but with special styling.
		// description:
		//		Buttons can display a label, an icon, or both.
		//		A label should always be specified (through innerHTML) or the label
		//		attribute.  It can be hidden via showLabel=false.
		// example:
		// |	<button data-dojo-type="dijit/form/Button" onClick="...">Hello world</button>
		//
		// example:
		// |	var button1 = new Button({label: "hello world", onClick: foo});
		// |	dojo.body().appendChild(button1.domNode);

		// showLabel: Boolean
		//		Set this to true to hide the label text and display only the icon.
		//		(If showLabel=false then iconClass must be specified.)
		//		Especially useful for toolbars.
		//		If showLabel=true, the label will become the title (a.k.a. tooltip/hint) of the icon.
		//
		//		The exception case is for computers in high-contrast mode, where the label
		//		will still be displayed, since the icon doesn't appear.
		showLabel: true,

		// iconClass: String
		//		Class to apply to DOMNode in button to make it display an icon
		iconClass: "dijitNoIcon",
		_setIconClassAttr: { node: "iconNode", type: "class" },

		baseClass: "dijitButton",

		templateString: template,

		// Map widget attributes to DOMNode attributes.
		_setValueAttr: "valueNode",
		_setNameAttr: function(name){
			// avoid breaking existing subclasses where valueNode undefined.  Perhaps in 2.0 require it to be defined?
			if(this.valueNode){
				this.valueNode.setAttribute("name", name);
			}
		},

		postCreate: function(){
			this.inherited(arguments);
			this._setLabelFromContainer();
		},

		_setLabelFromContainer: function(){
			if(this.containerNode && !this.label){
				// When markup was set as srcNodeRef.innerHTML, copy it to this.label, in case someone tries to
				// reference that variable.  Alternately, could have a _getLabelAttr() method to return
				// this.containerNode.innerHTML.
				this.label = lang.trim(this.containerNode.innerHTML);
				this.onLabelSet();		// set this.titleNode.title etc. according to label
			}
		},

		_setShowLabelAttr: function(val){
			if(this.containerNode){
				domClass.toggle(this.containerNode, "dijitDisplayNone", !val);
			}
			this._set("showLabel", val);
		},

		setLabel: function(/*String*/ content){
			// summary:
			//		Deprecated.  Use set('label', ...) instead.
			kernel.deprecated("dijit.form.Button.setLabel() is deprecated.  Use set('label', ...) instead.", "", "2.0");
			this.set("label", content);
		},

		onLabelSet: function(){
			this.inherited(arguments);
			if(!this.showLabel && !("title" in this.params)){
				this.titleNode.title = lang.trim(this.containerNode.innerText || this.containerNode.textContent || '');
			}
		}
	});

	if(has("dojo-bidi")){
		Button = declare("dijit.form.Button", Button, {
			onLabelSet: function(){
				this.inherited(arguments);
				if(this.titleNode.title){
					this.applyTextDir(this.titleNode, this.titleNode.title);
				}
			},

			_setTextDirAttr: function(/*String*/ textDir){
				if(this._created && this.textDir != textDir){
					this._set("textDir", textDir);
					this._setLabelAttr(this.label); // call applyTextDir on both focusNode and titleNode
				}
			}
		});
	}

	return Button;
});

},
'dijit/form/_FormWidget':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/sniff", // has("dijit-legacy-requires"), has("msapp")
	"dojo/_base/kernel", // kernel.deprecated
	"dojo/ready",
	"../_Widget",
	"../_CssStateMixin",
	"../_TemplatedMixin",
	"./_FormWidgetMixin"
], function(declare, has, kernel, ready, _Widget, _CssStateMixin, _TemplatedMixin, _FormWidgetMixin){

	// module:
	//		dijit/form/_FormWidget

	// Back compat w/1.6, remove for 2.0
	if(has("dijit-legacy-requires")){
		ready(0, function(){
			var requires = ["dijit/form/_FormValueWidget"];
			require(requires);	// use indirection so modules not rolled into a build
		});
	}

	return declare("dijit.form._FormWidget", [_Widget, _TemplatedMixin, _CssStateMixin, _FormWidgetMixin], {
		// summary:
		//		Base class for widgets corresponding to native HTML elements such as `<checkbox>` or `<button>`,
		//		which can be children of a `<form>` node or a `dijit/form/Form` widget.
		//
		// description:
		//		Represents a single HTML element.
		//		All these widgets should have these attributes just like native HTML input elements.
		//		You can set them during widget construction or afterwards, via `dijit/_WidgetBase.set()`.
		//
		//		They also share some common methods.

		setDisabled: function(/*Boolean*/ disabled){
			// summary:
			//		Deprecated.  Use set('disabled', ...) instead.
			kernel.deprecated("setDisabled(" + disabled + ") is deprecated. Use set('disabled'," + disabled + ") instead.", "", "2.0");
			this.set('disabled', disabled);
		},

		setValue: function(/*String*/ value){
			// summary:
			//		Deprecated.  Use set('value', ...) instead.
			kernel.deprecated("dijit.form._FormWidget:setValue(" + value + ") is deprecated.  Use set('value'," + value + ") instead.", "", "2.0");
			this.set('value', value);
		},

		getValue: function(){
			// summary:
			//		Deprecated.  Use get('value') instead.
			kernel.deprecated(this.declaredClass + "::getValue() is deprecated. Use get('value') instead.", "", "2.0");
			return this.get('value');
		},

		postMixInProperties: function(){
			// Setup name=foo string to be referenced from the template (but only if a name has been specified).
			// Unfortunately we can't use _setNameAttr to set the name in IE due to IE limitations, see #8484, #8660.
			// But when IE6 and IE7 are desupported, then we probably don't need this anymore, so should remove it in 2.0.
			// Also, don't do this for Windows 8 Store Apps because it causes a security exception (see #16452).
			// Regarding escaping, see heading "Attribute values" in
			// http://www.w3.org/TR/REC-html40/appendix/notes.html#h-B.3.2
			this.nameAttrSetting = (this.name && !has("msapp")) ? ('name="' + this.name.replace(/"/g, "&quot;") + '"') : '';
			this.inherited(arguments);
		}
	});
});

},
'dijit/form/_FormWidgetMixin':function(){
define([
	"dojo/_base/array", // array.forEach
	"dojo/_base/declare", // declare
	"dojo/dom-attr", // domAttr.set
	"dojo/dom-style", // domStyle.get
	"dojo/_base/lang", // lang.hitch lang.isArray
	"dojo/mouse", // mouse.isLeft
	"dojo/on",
	"dojo/sniff", // has("webkit")
	"dojo/window", // winUtils.scrollIntoView
	"../a11y"    // a11y.hasDefaultTabStop
], function(array, declare, domAttr, domStyle, lang, mouse, on, has, winUtils, a11y){

	// module:
	//		dijit/form/_FormWidgetMixin

	return declare("dijit.form._FormWidgetMixin", null, {
		// summary:
		//		Mixin for widgets corresponding to native HTML elements such as `<checkbox>` or `<button>`,
		//		which can be children of a `<form>` node or a `dijit/form/Form` widget.
		//
		// description:
		//		Represents a single HTML element.
		//		All these widgets should have these attributes just like native HTML input elements.
		//		You can set them during widget construction or afterwards, via `dijit/_WidgetBase.set()`.
		//
		//		They also share some common methods.

		// name: [const] String
		//		Name used when submitting form; same as "name" attribute or plain HTML elements
		name: "",

		// alt: String
		//		Corresponds to the native HTML `<input>` element's attribute.
		alt: "",

		// value: String
		//		Corresponds to the native HTML `<input>` element's attribute.
		value: "",

		// type: [const] String
		//		Corresponds to the native HTML `<input>` element's attribute.
		type: "text",

		// type: String
		//		Apply aria-label in markup to the widget's focusNode
		"aria-label": "focusNode",

		// tabIndex: String
		//		Order fields are traversed when user hits the tab key
		tabIndex: "0",
		_setTabIndexAttr: "focusNode", // force copy even when tabIndex default value, needed since Button is <span>

		// disabled: Boolean
		//		Should this widget respond to user input?
		//		In markup, this is specified as "disabled='disabled'", or just "disabled".
		disabled: false,

		// intermediateChanges: Boolean
		//		Fires onChange for each value change or only on demand
		intermediateChanges: false,

		// scrollOnFocus: Boolean
		//		On focus, should this widget scroll into view?
		scrollOnFocus: true,

		// Override _WidgetBase mapping id to this.domNode, needs to be on focusNode so <label> etc.
		// works with screen reader
		_setIdAttr: "focusNode",

		_setDisabledAttr: function(/*Boolean*/ value){
			this._set("disabled", value);

			// Set disabled property if focusNode is an <input>, but aria-disabled attribute if focusNode is a <span>.
			// Can't use "disabled" in this.focusNode as a test because on IE, that's true for all nodes.
			if(/^(button|input|select|textarea|optgroup|option|fieldset)$/i.test(this.focusNode.tagName)){
				domAttr.set(this.focusNode, 'disabled', value);
				// IE has a Caret Browsing mode (hit F7 to activate) where disabled textboxes can be modified
				// textboxes marked readonly if disabled to avoid this issue.
				if (has('trident') && 'readOnly' in this) {
					domAttr.set(this.focusNode, 'readonly', value || this.readOnly);
				}
			}else{
				this.focusNode.setAttribute("aria-disabled", value ? "true" : "false");
			}

			// And also set disabled on the hidden <input> node
			if(this.valueNode){
				domAttr.set(this.valueNode, 'disabled', value);
			}

			if(value){
				// reset these, because after the domNode is disabled, we can no longer receive
				// mouse related events, see #4200
				this._set("hovering", false);
				this._set("active", false);

				// clear tab stop(s) on this widget's focusable node(s)  (ComboBox has two focusable nodes)
				var attachPointNames = "tabIndex" in this.attributeMap ? this.attributeMap.tabIndex :
					("_setTabIndexAttr" in this) ? this._setTabIndexAttr : "focusNode";
				array.forEach(lang.isArray(attachPointNames) ? attachPointNames : [attachPointNames], function(attachPointName){
					var node = this[attachPointName];
					// complex code because tabIndex=-1 on a <div> doesn't work on FF
					if(has("webkit") || a11y.hasDefaultTabStop(node)){    // see #11064 about webkit bug
						node.setAttribute('tabIndex', "-1");
					}else{
						node.removeAttribute('tabIndex');
					}
				}, this);
			}else{
				if(this.tabIndex != ""){
					this.set('tabIndex', this.tabIndex);
				}
			}
		},

		_onFocus: function(/*String*/ by){
			// If user clicks on the widget, even if the mouse is released outside of it,
			// this widget's focusNode should get focus (to mimic native browser behavior).
			// Browsers often need help to make sure the focus via mouse actually gets to the focusNode.
			// TODO: consider removing all of this for 2.0 or sooner, see #16622 etc.
			if(by == "mouse" && this.isFocusable()){
				// IE exhibits strange scrolling behavior when refocusing a node so only do it when !focused.
				var focusHandle = this.own(on(this.focusNode, "focus", function(){
					mouseUpHandle.remove();
					focusHandle.remove();
				}))[0];
				// Set a global event to handle mouseup, so it fires properly
				// even if the cursor leaves this.domNode before the mouse up event.
				var event = has("pointer-events") ? "pointerup" : has("MSPointer") ? "MSPointerUp" :
					has("touch-events") ? "touchend, mouseup" :		// seems like overkill but see #16622, #16725
					"mouseup";
				var mouseUpHandle = this.own(on(this.ownerDocumentBody, event, lang.hitch(this, function(evt){
					mouseUpHandle.remove();
					focusHandle.remove();
					// if here, then the mousedown did not focus the focusNode as the default action
					if(this.focused){
						if(evt.type == "touchend"){
							this.defer("focus"); // native focus hasn't occurred yet
						}else{
							this.focus(); // native focus already occurred on mousedown
						}
					}
				})))[0];
			}
			if(this.scrollOnFocus){
				this.defer(function(){
					winUtils.scrollIntoView(this.domNode);
				}); // without defer, the input caret position can change on mouse click
			}
			this.inherited(arguments);
		},

		isFocusable: function(){
			// summary:
			//		Tells if this widget is focusable or not.  Used internally by dijit.
			// tags:
			//		protected
			return !this.disabled && this.focusNode && (domStyle.get(this.domNode, "display") != "none");
		},

		focus: function(){
			// summary:
			//		Put focus on this widget
			if(!this.disabled && this.focusNode.focus){
				try{
					this.focusNode.focus();
				}catch(e){
				}
				/*squelch errors from hidden nodes*/
			}
		},

		compare: function(/*anything*/ val1, /*anything*/ val2){
			// summary:
			//		Compare 2 values (as returned by get('value') for this widget).
			// tags:
			//		protected
			if(typeof val1 == "number" && typeof val2 == "number"){
				return (isNaN(val1) && isNaN(val2)) ? 0 : val1 - val2;
			}else if(val1 > val2){
				return 1;
			}else if(val1 < val2){
				return -1;
			}else{
				return 0;
			}
		},

		onChange: function(/*===== newValue =====*/){
			// summary:
			//		Callback when this widget's value is changed.
			// tags:
			//		callback
		},

		// _onChangeActive: [private] Boolean
		//		Indicates that changes to the value should call onChange() callback.
		//		This is false during widget initialization, to avoid calling onChange()
		//		when the initial value is set.
		_onChangeActive: false,

		_handleOnChange: function(/*anything*/ newValue, /*Boolean?*/ priorityChange){
			// summary:
			//		Called when the value of the widget is set.  Calls onChange() if appropriate
			// newValue:
			//		the new value
			// priorityChange:
			//		For a slider, for example, dragging the slider is priorityChange==false,
			//		but on mouse up, it's priorityChange==true.  If intermediateChanges==false,
			//		onChange is only called form priorityChange=true events.
			// tags:
			//		private
			if(this._lastValueReported == undefined && (priorityChange === null || !this._onChangeActive)){
				// this block executes not for a change, but during initialization,
				// and is used to store away the original value (or for ToggleButton, the original checked state)
				this._resetValue = this._lastValueReported = newValue;
			}
			this._pendingOnChange = this._pendingOnChange
				|| (typeof newValue != typeof this._lastValueReported)
				|| (this.compare(newValue, this._lastValueReported) != 0);
			if((this.intermediateChanges || priorityChange || priorityChange === undefined) && this._pendingOnChange){
				this._lastValueReported = newValue;
				this._pendingOnChange = false;
				if(this._onChangeActive){
					if(this._onChangeHandle){
						this._onChangeHandle.remove();
					}
					// defer allows hidden value processing to run and
					// also the onChange handler can safely adjust focus, etc
					this._onChangeHandle = this.defer(
						function(){
							this._onChangeHandle = null;
							this.onChange(newValue);
						}); // try to collapse multiple onChange's fired faster than can be processed
				}
			}
		},

		create: function(){
			// Overrides _Widget.create()
			this.inherited(arguments);
			this._onChangeActive = true;
		},

		destroy: function(){
			if(this._onChangeHandle){ // destroy called before last onChange has fired
				this._onChangeHandle.remove();
				this.onChange(this._lastValueReported);
			}
			this.inherited(arguments);
		}
	});
});

},
'dijit/form/_ButtonMixin':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/dom", // dom.setSelectable
	"dojo/has",
	"../registry"        // registry.byNode
], function(declare, dom, has, registry){

	// module:
	//		dijit/form/_ButtonMixin

	var ButtonMixin = declare("dijit.form._ButtonMixin" + (has("dojo-bidi") ? "_NoBidi" : ""), null, {
		// summary:
		//		A mixin to add a thin standard API wrapper to a normal HTML button
		// description:
		//		A label should always be specified (through innerHTML) or the label attribute.
		//
		//		Attach points:
		//
		//		- focusNode (required): this node receives focus
		//		- valueNode (optional): this node's value gets submitted with FORM elements
		//		- containerNode (optional): this node gets the innerHTML assignment for label
		// example:
		// |	<button data-dojo-type="dijit/form/Button" onClick="...">Hello world</button>
		// example:
		// |	var button1 = new Button({label: "hello world", onClick: foo});
		// |	dojo.body().appendChild(button1.domNode);

		// label: HTML String
		//		Content to display in button.
		label: "",

		// type: [const] String
		//		Type of button (submit, reset, button, checkbox, radio)
		type: "button",

		__onClick: function(/*Event*/ e){
			// summary:
			//		Internal function to divert the real click onto the hidden INPUT that has a native default action associated with it
			// type:
			//		private
			e.stopPropagation();
			e.preventDefault();
			if(!this.disabled){
				// cannot use on.emit since button default actions won't occur
				this.valueNode.click(e);
			}
			return false;
		},

		_onClick: function(/*Event*/ e){
			// summary:
			//		Internal function to handle click actions
			if(this.disabled){
				e.stopPropagation();
				e.preventDefault();
				return false;
			}
			if(this.onClick(e) === false){
				e.preventDefault();
			}
			var cancelled = e.defaultPrevented;

			// Signal Form/Dialog to submit/close.  For 2.0, consider removing this code and instead making the Form/Dialog
			// listen for bubbled click events where evt.target.type == "submit" && !evt.defaultPrevented.
			if(!cancelled && this.type == "submit" && !(this.valueNode || this.focusNode).form){
				for(var node = this.domNode; node.parentNode; node = node.parentNode){
					var widget = registry.byNode(node);
					if(widget && typeof widget._onSubmit == "function"){
						widget._onSubmit(e);
						e.preventDefault(); // action has already occurred
						cancelled = true;
						break;
					}
				}
			}

			return !cancelled;
		},

		postCreate: function(){
			this.inherited(arguments);
			dom.setSelectable(this.focusNode, false);
		},

		onClick: function(/*Event*/ /*===== e =====*/){
			// summary:
			//		Callback for when button is clicked.
			//		If type="submit", return true to perform submit, or false to cancel it.
			// type:
			//		callback
			return true;		// Boolean
		},

		_setLabelAttr: function(/*String*/ content){
			// summary:
			//		Hook for set('label', ...) to work.
			// description:
			//		Set the label (text) of the button; takes an HTML string.
			this._set("label", content);
			var labelNode = this.containerNode || this.focusNode;
			labelNode.innerHTML = content;
			this.onLabelSet();
		},

		onLabelSet: function(){
		}
	});

	if(has("dojo-bidi")){
		ButtonMixin = declare("dijit.form._ButtonMixin", ButtonMixin, {
			onLabelSet: function(){
				this.inherited(arguments);
				var labelNode = this.containerNode || this.focusNode;
				this.applyTextDir(labelNode);
			}
		});
	}

	return ButtonMixin;
});

},
'dijit/form/TextBox':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/dom-construct", // domConstruct.create
	"dojo/dom-style", // domStyle.getComputedStyle
	"dojo/_base/kernel", // kernel.deprecated
	"dojo/_base/lang", // lang.hitch
	"dojo/on",
	"dojo/sniff", // has("ie") has("mozilla")
	"./_FormValueWidget",
	"./_TextBoxMixin",
	"dojo/text!./templates/TextBox.html",
	"../main"	// to export dijit._setSelectionRange, remove in 2.0
], function(declare, domConstruct, domStyle, kernel, lang, on, has,
			_FormValueWidget, _TextBoxMixin, template, dijit){

	// module:
	//		dijit/form/TextBox

	var TextBox = declare("dijit.form.TextBox" + (has("dojo-bidi") ? "_NoBidi" : ""), [_FormValueWidget, _TextBoxMixin], {
		// summary:
		//		A base class for textbox form inputs

		templateString: template,
		_singleNodeTemplate: '<input class="dijit dijitReset dijitLeft dijitInputField" data-dojo-attach-point="textbox,focusNode" autocomplete="off" type="${type}" ${!nameAttrSetting} />',

		_buttonInputDisabled: has("ie") ? "disabled" : "", // allows IE to disallow focus, but Firefox cannot be disabled for mousedown events

		baseClass: "dijitTextBox",

		postMixInProperties: function(){
			var type = this.type.toLowerCase();
			if(this.templateString && this.templateString.toLowerCase() == "input" || ((type == "hidden" || type == "file") && this.templateString == this.constructor.prototype.templateString)){
				this.templateString = this._singleNodeTemplate;
			}
			this.inherited(arguments);
		},

		postCreate: function(){
			this.inherited(arguments);

			if(has("ie") < 9){
				// IE INPUT tag fontFamily has to be set directly using STYLE
				// the defer gives IE a chance to render the TextBox and to deal with font inheritance
				this.defer(function(){
					try{
						var s = domStyle.getComputedStyle(this.domNode); // can throw an exception if widget is immediately destroyed
						if(s){
							var ff = s.fontFamily;
							if(ff){
								var inputs = this.domNode.getElementsByTagName("INPUT");
								if(inputs){
									for(var i=0; i < inputs.length; i++){
										inputs[i].style.fontFamily = ff;
									}
								}
							}
						}
					}catch(e){/*when used in a Dialog, and this is called before the dialog is
					 shown, s.fontFamily would trigger "Invalid Argument" error.*/}
				});
			}
		},

		_setPlaceHolderAttr: function(v){
			this._set("placeHolder", v);
			if(!this._phspan){
				this._attachPoints.push('_phspan');
				this._phspan = domConstruct.create('span', {
					// dijitInputField class gives placeHolder same padding as the input field
					// parent node already has dijitInputField class but it doesn't affect this <span>
					// since it's position: absolute.
					className: 'dijitPlaceHolder dijitInputField'
				}, this.textbox, 'after');
				this.own(
					on(this._phspan, "mousedown", function(evt){ evt.preventDefault(); }),
					on(this._phspan, "touchend, pointerup, MSPointerUp", lang.hitch(this, function(){
						// If the user clicks placeholder rather than the <input>, need programmatic focus.  Normally this
						// is done in _FormWidgetMixin._onFocus() but after [30663] it's done on a delay, which is ineffective.
						this.focus();
					}))
				);
			}

			// --- MODIFICATION START ---
			// Directly set the innerHTML of the placeholder span with the provided value 'v'.
			// This will render any HTML tags present in 'v'.
			this._phspan.innerHTML = v;
			// --- MODIFICATION END ---

			this._updatePlaceHolder();
		},

		_onInput: function(/*Event*/ evt){
			// summary:
			//		Called AFTER the input event has happened
			//		See if the placeHolder text should be removed or added while editing.
			this.inherited(arguments);
			this._updatePlaceHolder();
		},

		_updatePlaceHolder: function(){
			if(this._phspan){
				this._phspan.style.display = (this.placeHolder && !this.textbox.value) ? "" : "none";
			}
		},

		_setValueAttr: function(value, /*Boolean?*/ priorityChange, /*String?*/ formattedValue){
			this.inherited(arguments);
			this._updatePlaceHolder();
		},

		getDisplayedValue: function(){
			// summary:
			//		Deprecated.  Use get('displayedValue') instead.
			// tags:
			//		deprecated
			kernel.deprecated(this.declaredClass+"::getDisplayedValue() is deprecated. Use get('displayedValue') instead.", "", "2.0");
			return this.get('displayedValue');
		},

		setDisplayedValue: function(/*String*/ value){
			// summary:
			//		Deprecated.  Use set('displayedValue', ...) instead.
			// tags:
			//		deprecated
			kernel.deprecated(this.declaredClass+"::setDisplayedValue() is deprecated. Use set('displayedValue', ...) instead.", "", "2.0");
			this.set('displayedValue', value);
		},

		_onBlur: function(e){
			if(this.disabled){ return; }
			this.inherited(arguments);
			this._updatePlaceHolder();

			if(has("mozilla")){
				if(this.selectOnClick){
					// clear selection so that the next mouse click doesn't reselect
					this.textbox.selectionStart = this.textbox.selectionEnd = undefined;
				}
			}
		},

		_onFocus: function(/*String*/ by){
			if(this.disabled || this.readOnly){ return; }
			this.inherited(arguments);
			this._updatePlaceHolder();
		}
	});

	if(has("ie") < 9){
		TextBox.prototype._isTextSelected = function(){
			var range = this.ownerDocument.selection.createRange();
			var parent = range.parentElement();
			return parent == this.textbox && range.text.length > 0;
		};

		// Overrides definition of _setSelectionRange from _TextBoxMixin (TODO: move to _TextBoxMixin.js?)
		dijit._setSelectionRange = _TextBoxMixin._setSelectionRange = function(/*DomNode*/ element, /*Number?*/ start, /*Number?*/ stop){
			if(element.createTextRange){
				var r = element.createTextRange();
				r.collapse(true);
				r.moveStart("character", -99999); // move to 0
				r.moveStart("character", start); // delta from 0 is the correct position
				r.moveEnd("character", stop-start);
				r.select();
			}
		}
	}

	if(has("dojo-bidi")){
		TextBox = declare("dijit.form.TextBox", TextBox, {
			_setPlaceHolderAttr: function(v){
				this.inherited(arguments);
				this.applyTextDir(this._phspan);
			}
		});
	}

	return TextBox;
});

},
'dijit/form/_FormValueWidget':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/sniff", // has("ie")
	"./_FormWidget",
	"./_FormValueMixin"
], function(declare, has, _FormWidget, _FormValueMixin){

	// module:
	//		dijit/form/_FormValueWidget

	return declare("dijit.form._FormValueWidget", [_FormWidget, _FormValueMixin], {
		// summary:
		//		Base class for widgets corresponding to native HTML elements such as `<input>` or `<select>`
		//		that have user changeable values.
		// description:
		//		Each _FormValueWidget represents a single input value, and has a (possibly hidden) `<input>` element,
		//		to which it serializes it's input value, so that form submission (either normal submission or via FormBind?)
		//		works as expected.

		// Don't attempt to mixin the 'type', 'name' attributes here programatically -- they must be declared
		// directly in the template as read by the parser in order to function. IE is known to specifically
		// require the 'name' attribute at element creation time.  See #8484, #8660.

		_layoutHackIE7: function(){
			// summary:
			//		Work around table sizing bugs on IE7 by forcing redraw

			if(has("ie") == 7){ // fix IE7 layout bug when the widget is scrolled out of sight
				var domNode = this.domNode;
				var parent = domNode.parentNode;
				var pingNode = domNode.firstChild || domNode; // target node most unlikely to have a custom filter
				var origFilter = pingNode.style.filter; // save custom filter, most likely nothing
				var _this = this;
				while(parent && parent.clientHeight == 0){ // search for parents that haven't rendered yet
					(function ping(){
						var disconnectHandle = _this.connect(parent, "onscroll",
							function(){
								_this.disconnect(disconnectHandle); // only call once
								pingNode.style.filter = (new Date()).getMilliseconds(); // set to anything that's unique
								_this.defer(function(){
									pingNode.style.filter = origFilter;
								}); // restore custom filter, if any
							}
						);
					})();
					parent = parent.parentNode;
				}
			}
		}
	});
});

},
'dijit/form/_FormValueMixin':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/dom-attr", // domAttr.set
	"dojo/keys", // keys.ESCAPE
	"dojo/_base/lang",
	"dojo/on",
	"dojo/sniff", // has("webkit")
	"./_FormWidgetMixin"
], function(declare, domAttr, keys, lang, on, has, _FormWidgetMixin){

	// module:
	//		dijit/form/_FormValueMixin

	return declare("dijit.form._FormValueMixin", _FormWidgetMixin, {
		// summary:
		//		Mixin for widgets corresponding to native HTML elements such as `<input>` or `<select>`
		//		that have user changeable values.
		// description:
		//		Each _FormValueMixin represents a single input value, and has a (possibly hidden) `<input>` element,
		//		to which it serializes it's input value, so that form submission (either normal submission or via FormBind?)
		//		works as expected.

		// readOnly: Boolean
		//		Should this widget respond to user input?
		//		In markup, this is specified as "readOnly".
		//		Similar to disabled except readOnly form values are submitted.
		readOnly: false,

		_setReadOnlyAttr: function(/*Boolean*/ value){
			// IE has a Caret Browsing mode (hit F7 to activate) where disabled textboxes can be modified
			// focusNode enforced readonly if currently disabled to avoid this issue.
			if (has('trident') && 'disabled' in this) {
				domAttr.set(this.focusNode, 'readOnly', value || this.disabled);
			} else {
				domAttr.set(this.focusNode, 'readOnly', value);
			}
			this._set("readOnly", value);
		},

		postCreate: function(){
			this.inherited(arguments);

			// Update our reset value if it hasn't yet been set (because this.set()
			// is only called when there *is* a value)
			if(this._resetValue === undefined){
				this._lastValueReported = this._resetValue = this.value;
			}
		},

		_setValueAttr: function(/*anything*/ newValue, /*Boolean?*/ priorityChange){
			// summary:
			//		Hook so set('value', value) works.
			// description:
			//		Sets the value of the widget.
			//		If the value has changed, then fire onChange event, unless priorityChange
			//		is specified as null (or false?)
			this._handleOnChange(newValue, priorityChange);
		},

		_handleOnChange: function(/*anything*/ newValue, /*Boolean?*/ priorityChange){
			// summary:
			//		Called when the value of the widget has changed.  Saves the new value in this.value,
			//		and calls onChange() if appropriate.   See _FormWidget._handleOnChange() for details.
			this._set("value", newValue);
			this.inherited(arguments);
		},

		undo: function(){
			// summary:
			//		Restore the value to the last value passed to onChange
			this._setValueAttr(this._lastValueReported, false);
		},

		reset: function(){
			// summary:
			//		Reset the widget's value to what it was at initialization time
			this._hasBeenBlurred = false;
			this._setValueAttr(this._resetValue, true);
		}
	});
});

},
'dijit/form/_TextBoxMixin':function(){
define([
	"dojo/_base/array", // array.forEach
	"dojo/_base/declare", // declare
	"dojo/dom", // dom.byId
	"dojo/sniff",	// has("ie"), has("dojo-bidi")
	"dojo/keys", // keys.ALT keys.CAPS_LOCK keys.CTRL keys.META keys.SHIFT
	"dojo/_base/lang", // lang.mixin
	"dojo/on", // on
	"../main"    // for exporting dijit._setSelectionRange, dijit.selectInputText
], function(array, declare, dom, has, keys, lang, on, dijit){

	// module:
	//		dijit/form/_TextBoxMixin

	var _TextBoxMixin = declare("dijit.form._TextBoxMixin" + (has("dojo-bidi") ? "_NoBidi" : ""), null, {
		// summary:
		//		A mixin for textbox form input widgets

		// trim: Boolean
		//		Removes leading and trailing whitespace if true.  Default is false.
		trim: false,

		// uppercase: Boolean
		//		Converts all characters to uppercase if true.  Default is false.
		uppercase: false,

		// lowercase: Boolean
		//		Converts all characters to lowercase if true.  Default is false.
		lowercase: false,

		// propercase: Boolean
		//		Converts the first character of each word to uppercase if true.
		propercase: false,

		// maxLength: String
		//		HTML INPUT tag maxLength declaration.
		maxLength: "",

		// selectOnClick: [const] Boolean
		//		If true, all text will be selected when focused with mouse
		selectOnClick: false,

		// placeHolder: String
		//		Defines a hint to help users fill out the input field (as defined in HTML 5).
		//		This should only contain plain text (no html markup).
		placeHolder: "",

		_getValueAttr: function(){
			// summary:
			//		Hook so get('value') works as we like.
			// description:
			//		For `dijit/form/TextBox` this basically returns the value of the `<input>`.
			//
			//		For `dijit/form/MappedTextBox` subclasses, which have both
			//		a "displayed value" and a separate "submit value",
			//		This treats the "displayed value" as the master value, computing the
			//		submit value from it via this.parse().
			return this.parse(this.get('displayedValue'), this.constraints);
		},

		_setValueAttr: function(value, /*Boolean?*/ priorityChange, /*String?*/ formattedValue){
			// summary:
			//		Hook so set('value', ...) works.
			//
			// description:
			//		Sets the value of the widget to "value" which can be of
			//		any type as determined by the widget.
			//
			// value:
			//		The visual element value is also set to a corresponding,
			//		but not necessarily the same, value.
			//
			// formattedValue:
			//		If specified, used to set the visual element value,
			//		otherwise a computed visual value is used.
			//
			// priorityChange:
			//		If true, an onChange event is fired immediately instead of
			//		waiting for the next blur event.

			var filteredValue;
			if(value !== undefined){
				// TODO: this is calling filter() on both the display value and the actual value.
				// I added a comment to the filter() definition about this, but it should be changed.
				filteredValue = this.filter(value);
				if(typeof formattedValue != "string"){
					if(filteredValue !== null && ((typeof filteredValue != "number") || !isNaN(filteredValue))){
						formattedValue = this.filter(this.format(filteredValue, this.constraints));
					}else{
						formattedValue = '';
					}
					// Ensure the filtered value does not change after being formatted. See track #17955.
					//
					// This check is only applied when the formatted value is not specified by the caller in order to allow the 
					// behavior to be overriden. This is needed whenever value synonyms cannot be determined using parse/compare. For
					// example, dijit/form/FilteringSelect determines the formatted value asynchronously and applies it using a 
					// callback to this method.
					//
					// TODO: Should developers be warned that they broke the round trip on format?
					if (this.compare(filteredValue, this.filter(this.parse(formattedValue, this.constraints))) != 0){
						formattedValue = null;
					}
				}
			}
			if(formattedValue != null /* and !undefined */ && ((typeof formattedValue) != "number" || !isNaN(formattedValue)) && this.textbox.value != formattedValue){
				this.textbox.value = formattedValue;
				this._set("displayedValue", this.get("displayedValue"));
			}

			this.inherited(arguments, [filteredValue, priorityChange]);
		},

		// displayedValue: String
		//		For subclasses like ComboBox where the displayed value
		//		(ex: Kentucky) and the serialized value (ex: KY) are different,
		//		this represents the displayed value.
		//
		//		Setting 'displayedValue' through set('displayedValue', ...)
		//		updates 'value', and vice-versa.  Otherwise 'value' is updated
		//		from 'displayedValue' periodically, like onBlur etc.
		//
		//		TODO: move declaration to MappedTextBox?
		//		Problem is that ComboBox references displayedValue,
		//		for benefit of FilteringSelect.
		displayedValue: "",

		_getDisplayedValueAttr: function(){
			// summary:
			//		Hook so get('displayedValue') works.
			// description:
			//		Returns the displayed value (what the user sees on the screen),
			//		after filtering (ie, trimming spaces etc.).
			//
			//		For some subclasses of TextBox (like ComboBox), the displayed value
			//		is different from the serialized value that's actually
			//		sent to the server (see `dijit/form/ValidationTextBox.serialize()`)

			// TODO: maybe we should update this.displayedValue on every keystroke so that we don't need
			// this method
			// TODO: this isn't really the displayed value when the user is typing
			return this.filter(this.textbox.value);
		},

		_setDisplayedValueAttr: function(/*String*/ value){
			// summary:
			//		Hook so set('displayedValue', ...) works.
			// description:
			//		Sets the value of the visual element to the string "value".
			//		The widget value is also set to a corresponding,
			//		but not necessarily the same, value.

			if(value == null /* or undefined */){
				value = ''
			}
			else if(typeof value != "string"){
				value = String(value)
			}

			this.textbox.value = value;

			// sets the serialized value to something corresponding to specified displayedValue
			// (if possible), and also updates the textbox.value, for example converting "123"
			// to "123.00"
			this._setValueAttr(this.get('value'), undefined);

			this._set("displayedValue", this.get('displayedValue'));
		},

		format: function(value /*=====, constraints =====*/){
			// summary:
			//		Replaceable function to convert a value to a properly formatted string.
			// value: String
			// constraints: Object
			// tags:
			//		protected extension
			return value == null /* or undefined */ ? "" : (value.toString ? value.toString() : value);
		},

		parse: function(value /*=====, constraints =====*/){
			// summary:
			//		Replaceable function to convert a formatted string to a value
			// value: String
			// constraints: Object
			// tags:
			//		protected extension

			return value;	// String
		},

		_refreshState: function(){
			// summary:
			//		After the user types some characters, etc., this method is
			//		called to check the field for validity etc.  The base method
			//		in `dijit/form/TextBox` does nothing, but subclasses override.
			// tags:
			//		protected
		},

		 onInput: function(/*Event*/ /*===== evt =====*/){
			 // summary:
			 //		Connect to this function to receive notifications of various user data-input events.
			 //		Return false to cancel the event and prevent it from being processed.
			 //		Note that although for historical reasons this method is called `onInput()`, it doesn't
			 //		correspond to the standard DOM "input" event, because it occurs before the input has been processed.
			 // event:
			 //		keydown | keypress | cut | paste | compositionend
			 // tags:
			 //		callback
		 },

		_onInput: function(/*Event*/ evt){
			// summary:
			//		Called AFTER the input event has happened and this.textbox.value has new value.

			this._lastInputEventValue = this.textbox.value;

			// For Combobox, this needs to be called w/the keydown/keypress event that was passed to onInput().
			// As a backup, use the "input" event itself.
			this._processInput(this._lastInputProducingEvent || evt);
			delete this._lastInputProducingEvent;

			if(this.intermediateChanges){
				this._handleOnChange(this.get('value'), false);
			}
		},

		_processInput: function(/*Event*/ /*===== evt =====*/){
			// summary:
			//		Default action handler for user input events.
			//		Called after the "input" event (i.e. after this.textbox.value has been updated),
			//		but `evt` is the keydown/keypress/etc. event that triggered the "input" event.
			// tags:
			//		protected

			this._refreshState();

			// In case someone is watch()'ing for changes to displayedValue
			this._set("displayedValue", this.get("displayedValue"));
		},

		postCreate: function(){
			// setting the value here is needed since value="" in the template causes "undefined"
			// and setting in the DOM (instead of the JS object) helps with form reset actions
			this.textbox.setAttribute("value", this.textbox.value); // DOM and JS values should be the same

			this.inherited(arguments);

			// normalize input events to reduce spurious event processing
			//	keydown: do not forward modifier keys
			//		       set charOrCode to numeric keycode
			//	keypress: do not forward numeric charOrCode keys (already sent through onkeydown)
			//	paste, cut, compositionend: set charOrCode to 229 (IME)
			function handleEvent(e){
				var charOrCode;

				// Filter out keydown events that will be followed by keypress events.  Note that chrome/android
				// w/word suggestion has keydown/229 events on typing with no corresponding keypress events.
				if(e.type == "keydown" && e.keyCode != 229){
					charOrCode = e.keyCode;
					switch(charOrCode){ // ignore state keys
						case keys.SHIFT:
						case keys.ALT:
						case keys.CTRL:
						case keys.META:
						case keys.CAPS_LOCK:
						case keys.NUM_LOCK:
						case keys.SCROLL_LOCK:
							return;
					}
					if(!e.ctrlKey && !e.metaKey && !e.altKey){ // no modifiers
						switch(charOrCode){ // ignore location keys
							case keys.NUMPAD_0:
							case keys.NUMPAD_1:
							case keys.NUMPAD_2:
							case keys.NUMPAD_3:
							case keys.NUMPAD_4:
							case keys.NUMPAD_5:
							case keys.NUMPAD_6:
							case keys.NUMPAD_7:
							case keys.NUMPAD_8:
							case keys.NUMPAD_9:
							case keys.NUMPAD_MULTIPLY:
							case keys.NUMPAD_PLUS:
							case keys.NUMPAD_ENTER:
							case keys.NUMPAD_MINUS:
							case keys.NUMPAD_PERIOD:
							case keys.NUMPAD_DIVIDE:
								return;
						}
						if((charOrCode >= 65 && charOrCode <= 90) || (charOrCode >= 48 && charOrCode <= 57) || charOrCode == keys.SPACE){
							return; // keypress will handle simple non-modified printable keys
						}
						var named = false;
						for(var i in keys){
							if(keys[i] === e.keyCode){
								named = true;
								break;
							}
						}
						if(!named){
							return;
						} // only allow named ones through
					}
				}

				charOrCode = e.charCode >= 32 ? String.fromCharCode(e.charCode) : e.charCode;
				if(!charOrCode){
					charOrCode = (e.keyCode >= 65 && e.keyCode <= 90) || (e.keyCode >= 48 && e.keyCode <= 57) || e.keyCode == keys.SPACE ? String.fromCharCode(e.keyCode) : e.keyCode;
				}
				if(!charOrCode){
					charOrCode = 229; // IME
				}
				if(e.type == "keypress"){
					if(typeof charOrCode != "string"){
						return;
					}
					if((charOrCode >= 'a' && charOrCode <= 'z') || (charOrCode >= 'A' && charOrCode <= 'Z') || (charOrCode >= '0' && charOrCode <= '9') || (charOrCode === ' ')){
						if(e.ctrlKey || e.metaKey || e.altKey){
							return;
						} // can only be stopped reliably in keydown
					}
				}

				// create fake event to set charOrCode and to know if preventDefault() was called
				var faux = { faux: true }, attr;
				for(attr in e){
					if(!/^(layer[XY]|returnValue|keyLocation)$/.test(attr)){ // prevent WebKit warnings
						var v = e[attr];
						if(typeof v != "function" && typeof v != "undefined"){
							faux[attr] = v;
						}
					}
				}
				lang.mixin(faux, {
					charOrCode: charOrCode,
					_wasConsumed: false,
					preventDefault: function(){
						faux._wasConsumed = true;
						e.preventDefault();
					},
					stopPropagation: function(){
						e.stopPropagation();
					}
				});

				this._lastInputProducingEvent = faux;

				// Give web page author a chance to consume the event.  Note that onInput() may be called multiple times
				// for same keystroke: once for keypress event and once for input event.
				//console.log(faux.type + ', charOrCode = (' + (typeof charOrCode) + ') ' + charOrCode + ', ctrl ' + !!faux.ctrlKey + ', alt ' + !!faux.altKey + ', meta ' + !!faux.metaKey + ', shift ' + !!faux.shiftKey);
				if(this.onInput(faux) === false){ // return false means stop
					faux.preventDefault();
					faux.stopPropagation();
				}
				if(faux._wasConsumed){
					return;
				} // if preventDefault was called

				// IE8 doesn't emit the "input" event at all, and IE9 doesn't emit it for backspace, delete, cut, etc.
				// Since the code below (and perhaps user code) depends on that event, emit it synthetically.
				// See http://benalpert.com/2013/06/18/a-near-perfect-oninput-shim-for-ie-8-and-9.html.
				if(has("ie") <= 9){
					switch(e.keyCode){
					case keys.TAB:
					case keys.ESCAPE:
					case keys.DOWN_ARROW:
					case keys.UP_ARROW:
					case keys.LEFT_ARROW:
					case keys.RIGHT_ARROW:
						// These keys may alter the <input>'s value indirectly, but we don't want to emit an "input"
						// event.  For example, the up/down arrows in TimeTextBox or ComboBox will cause the next
						// dropdown item's value to be copied to the <input>.
						break;
					default:
						if(e.keyCode == keys.ENTER && this.textbox.tagName.toLowerCase() != "textarea"){
							break;
						}
						this.defer(function(){
							if(this.textbox.value !== this._lastInputEventValue){
								on.emit(this.textbox, "input", {bubbles: true});
							}
						});
					}
				}
			}
			this.own(
				on(this.textbox, "keydown, keypress, paste, cut, compositionend", lang.hitch(this, handleEvent)),
				on(this.textbox, "input", lang.hitch(this, "_onInput")),

				// Allow keypress to bubble to this.domNode, so that TextBox.on("keypress", ...) works,
				// but prevent it from further propagating, so that typing into a TextBox inside a Toolbar doesn't
				// trigger the Toolbar's letter key navigation.
				on(this.domNode, "keypress", function(e){ e.stopPropagation(); })
			);
		},

		_blankValue: '', // if the textbox is blank, what value should be reported
		filter: function(val){
			// summary:
			//		Auto-corrections (such as trimming) that are applied to textbox
			//		value on blur or form submit.
			// description:
			//		For MappedTextBox subclasses, this is called twice
			//
			//		- once with the display value
			//		- once the value as set/returned by set('value', ...)
			//
			//		and get('value'), ex: a Number for NumberTextBox.
			//
			//		In the latter case it does corrections like converting null to NaN.  In
			//		the former case the NumberTextBox.filter() method calls this.inherited()
			//		to execute standard trimming code in TextBox.filter().
			//
			//		TODO: break this into two methods in 2.0
			//
			// tags:
			//		protected extension
			if(val === null){
				return this._blankValue;
			}
			if(typeof val != "string"){
				return val;
			}
			if(this.trim){
				val = lang.trim(val);
			}
			if(this.uppercase){
				val = val.toUpperCase();
			}
			if(this.lowercase){
				val = val.toLowerCase();
			}
			if(this.propercase){
				val = val.replace(/[^\s]+/g, function(word){
					return word.substring(0, 1).toUpperCase() + word.substring(1);
				});
			}
			return val;
		},

		_setBlurValue: function(){
			// Format the displayed value, for example (for NumberTextBox) convert 1.4 to 1.400,
			// or (for CurrencyTextBox) 2.50 to $2.50

			this._setValueAttr(this.get('value'), true);
		},

		_onBlur: function(e){
			if(this.disabled){
				return;
			}
			this._setBlurValue();
			this.inherited(arguments);
		},

		_isTextSelected: function(){
			return this.textbox.selectionStart != this.textbox.selectionEnd;
		},

		_onFocus: function(/*String*/ by){
			if(this.disabled || this.readOnly){
				return;
			}

			// Select all text on focus via click if nothing already selected.
			// Since mouse-up will clear the selection, need to defer selection until after mouse-up.
			// Don't do anything on focus by tabbing into the widget since there's no associated mouse-up event.
			if(this.selectOnClick && by == "mouse"){
				// Use on.once() to only select all text on first click only; otherwise users would have no way to clear
				// the selection.
				this._selectOnClickHandle = on.once(this.domNode, "mouseup, touchend", lang.hitch(this, function(evt){
					// Check if the user selected some text manually (mouse-down, mouse-move, mouse-up)
					// and if not, then select all the text
					if(!this._isTextSelected()){
						_TextBoxMixin.selectInputText(this.textbox);
					}
				}));
				this.own(this._selectOnClickHandle);

				// in case the mouseup never comes
				this.defer(function(){
					if(this._selectOnClickHandle){
						this._selectOnClickHandle.remove();
						this._selectOnClickHandle = null;
					}
				}, 500); // if mouseup not received soon, then treat it as some gesture
			}
			// call this.inherited() before refreshState(), since this.inherited() will possibly scroll the viewport
			// (to scroll the TextBox into view), which will affect how _refreshState() positions the tooltip
			this.inherited(arguments);

			this._refreshState();
		},

		reset: function(){
			// Overrides `dijit/_FormWidget/reset()`.
			// Additionally resets the displayed textbox value to ''
			this.textbox.value = '';
			this.inherited(arguments);
		}
	});

	if(has("dojo-bidi")){
		_TextBoxMixin = declare("dijit.form._TextBoxMixin", _TextBoxMixin, {
			_setValueAttr: function(){
				this.inherited(arguments);
				this.applyTextDir(this.focusNode);
			},
			_setDisplayedValueAttr: function(){
				this.inherited(arguments);
				this.applyTextDir(this.focusNode);
			},
			_onInput: function(){
				this.applyTextDir(this.focusNode);
				this.inherited(arguments);
			}
		});
	}

	_TextBoxMixin._setSelectionRange = dijit._setSelectionRange = function(/*DomNode*/ element, /*Number?*/ start, /*Number?*/ stop){
		if(element.setSelectionRange){
			element.setSelectionRange(start, stop);
		}
	};

	_TextBoxMixin.selectInputText = dijit.selectInputText = function(/*DomNode*/ element, /*Number?*/ start, /*Number?*/ stop){
		// summary:
		//		Select text in the input element argument, from start (default 0), to stop (default end).

		// TODO: use functions in _editor/selection.js?
		element = dom.byId(element);
		if(isNaN(start)){
			start = 0;
		}
		if(isNaN(stop)){
			stop = element.value ? element.value.length : 0;
		}
		try{
			element.focus();
			_TextBoxMixin._setSelectionRange(element, start, stop);
		}catch(e){ /* squelch random errors (esp. on IE) from unexpected focus changes or DOM nodes being hidden */
		}
	};

	return _TextBoxMixin;
});

},
'dijit/Tooltip':function(){
define([
	"dojo/_base/array", // array.forEach array.indexOf array.map
	"dojo/_base/declare", // declare
	"dojo/_base/fx", // fx.fadeIn fx.fadeOut
	"dojo/dom", // dom.byId
	"dojo/dom-class", // domClass.add
	"dojo/dom-geometry", // domGeometry.position
	"dojo/dom-style", // domStyle.set, domStyle.get
	"dojo/_base/lang", // lang.hitch lang.isArrayLike
	"dojo/mouse",
	"dojo/on",
	"dojo/sniff", // has("ie"), has("trident")
	"./_base/manager",	// manager.defaultDuration
	"./place",
	"./_Widget",
	"./_TemplatedMixin",
	"./BackgroundIframe",
	"dojo/text!./templates/Tooltip.html",
	"./main"		// sets dijit.showTooltip etc. for back-compat
], function(array, declare, fx, dom, domClass, domGeometry, domStyle, lang, mouse, on, has,
			manager, place, _Widget, _TemplatedMixin, BackgroundIframe, template, dijit){

	// module:
	//		dijit/Tooltip


	// TODO: Tooltip should really share more positioning code with TooltipDialog, like:
	//		- the orient() method
	//		- the connector positioning code in show()
	//		- the dijitTooltip[Dialog] class
	//
	// The problem is that Tooltip's implementation supplies it's own <iframe> and interacts directly
	// with dijit/place, rather than going through dijit/popup like TooltipDialog and other popups (ex: Menu).

	var MasterTooltip = declare("dijit._MasterTooltip", [_Widget, _TemplatedMixin], {
		// summary:
		//		Internal widget that holds the actual tooltip markup,
		//		which occurs once per page.
		//		Called by Tooltip widgets which are just containers to hold
		//		the markup
		// tags:
		//		protected

		// duration: Integer
		//		Milliseconds to fade in/fade out
		duration: manager.defaultDuration,

		templateString: template,

		postCreate: function(){
			this.ownerDocumentBody.appendChild(this.domNode);

			this.bgIframe = new BackgroundIframe(this.domNode);

			// Setup fade-in and fade-out functions.
			this.fadeIn = fx.fadeIn({ node: this.domNode, duration: this.duration, onEnd: lang.hitch(this, "_onShow") });
			this.fadeOut = fx.fadeOut({ node: this.domNode, duration: this.duration, onEnd: lang.hitch(this, "_onHide") });
		},

		show: function(innerHTML, aroundNode, position, rtl, textDir, onMouseEnter, onMouseLeave){
			// summary:
			//		Display tooltip w/specified contents to right of specified node
			//		(To left if there's no space on the right, or if rtl == true)
			// innerHTML: String
			//		Contents of the tooltip
			// aroundNode: DomNode|dijit/place.__Rectangle
			//		Specifies that tooltip should be next to this node / area
			// position: String[]?
			//		List of positions to try to position tooltip (ex: ["right", "above"])
			// rtl: Boolean?
			//		Corresponds to `WidgetBase.dir` attribute, where false means "ltr" and true
			//		means "rtl"; specifies GUI direction, not text direction.
			// textDir: String?
			//		Corresponds to `WidgetBase.textdir` attribute; specifies direction of text.
			// onMouseEnter: Function?
			//		Callback function for mouse enter on tooltip
			// onMouseLeave: Function?
			//		Callback function for mouse leave on tooltip

			if(this.aroundNode && this.aroundNode === aroundNode && this.containerNode.innerHTML == innerHTML){
				return;
			}

			if(this.fadeOut.status() == "playing"){
				// previous tooltip is being hidden; wait until the hide completes then show new one
				this._onDeck=arguments;
				return;
			}
			this.containerNode.innerHTML=innerHTML;

			if(textDir){
				this.set("textDir", textDir);
			}

			this.containerNode.align = rtl? "right" : "left"; //fix the text alignment

			var pos = place.around(this.domNode, aroundNode,
				position && position.length ? position : Tooltip.defaultPosition, !rtl, lang.hitch(this, "orient"));

			// Position the tooltip connector for middle alignment.
			// This could not have been done in orient() since the tooltip wasn't positioned at that time.
			var aroundNodeCoords = pos.aroundNodePos;
			if(pos.corner.charAt(0) == 'M' && pos.aroundCorner.charAt(0) == 'M'){
				this.connectorNode.style.top = aroundNodeCoords.y + ((aroundNodeCoords.h - this.connectorNode.offsetHeight) >> 1) - pos.y + "px";
				this.connectorNode.style.left = "";
			}else if(pos.corner.charAt(1) == 'M' && pos.aroundCorner.charAt(1) == 'M'){
				this.connectorNode.style.left = aroundNodeCoords.x + ((aroundNodeCoords.w - this.connectorNode.offsetWidth) >> 1) - pos.x + "px";
			}else{
				// Not *-centered, but just above/below/after/before
				this.connectorNode.style.left = "";
				this.connectorNode.style.top = "";
			}

			// show it
			domStyle.set(this.domNode, "opacity", 0);
			this.fadeIn.play();
			this.isShowingNow = true;
			this.aroundNode = aroundNode;

			this.onMouseEnter = onMouseEnter || noop;
			this.onMouseLeave = onMouseLeave || noop;
		},

		orient: function(/*DomNode*/ node, /*String*/ aroundCorner, /*String*/ tooltipCorner, /*Object*/ spaceAvailable, /*Object*/ aroundNodeCoords){
			// summary:
			//		Private function to set CSS for tooltip node based on which position it's in.
			//		This is called by the dijit popup code.   It will also reduce the tooltip's
			//		width to whatever width is available
			// tags:
			//		protected

			this.connectorNode.style.top = ""; //reset to default

			var heightAvailable = spaceAvailable.h,
				widthAvailable = spaceAvailable.w;

			node.className = "dijitTooltip " +
				{
					"MR-ML": "dijitTooltipRight",
					"ML-MR": "dijitTooltipLeft",
					"TM-BM": "dijitTooltipAbove",
					"BM-TM": "dijitTooltipBelow",
					"BL-TL": "dijitTooltipBelow dijitTooltipABLeft",
					"TL-BL": "dijitTooltipAbove dijitTooltipABLeft",
					"BR-TR": "dijitTooltipBelow dijitTooltipABRight",
					"TR-BR": "dijitTooltipAbove dijitTooltipABRight",
					"BR-BL": "dijitTooltipRight",
					"BL-BR": "dijitTooltipLeft"
				}[aroundCorner + "-" + tooltipCorner];

			// reset width; it may have been set by orient() on a previous tooltip show()
			this.domNode.style.width = "auto";

			// Reduce tooltip's width to the amount of width available, so that it doesn't overflow screen.
			// Note that sometimes widthAvailable is negative, but we guard against setting style.width to a
			// negative number since that causes an exception on IE.
			var size = domGeometry.position(this.domNode);
			if(has("ie") || has("trident")){
				// workaround strange IE bug where setting width to offsetWidth causes words to wrap
				size.w += 2;
			}

			var width = Math.min((Math.max(widthAvailable,1)), size.w);

			domGeometry.setMarginBox(this.domNode, {w: width});

			// Reposition the tooltip connector.
			if(tooltipCorner.charAt(0) == 'B' && aroundCorner.charAt(0) == 'B'){
				var bb = domGeometry.position(node);
				var tooltipConnectorHeight = this.connectorNode.offsetHeight;
				if(bb.h > heightAvailable){
					// The tooltip starts at the top of the page and will extend past the aroundNode
					var aroundNodePlacement = heightAvailable - ((aroundNodeCoords.h + tooltipConnectorHeight) >> 1);
					this.connectorNode.style.top = aroundNodePlacement + "px";
					this.connectorNode.style.bottom = "";
				}else{
					// Align center of connector with center of aroundNode, except don't let bottom
					// of connector extend below bottom of tooltip content, or top of connector
					// extend past top of tooltip content
					this.connectorNode.style.bottom = Math.min(
						Math.max(aroundNodeCoords.h/2 - tooltipConnectorHeight/2, 0),
						bb.h - tooltipConnectorHeight) + "px";
					this.connectorNode.style.top = "";
				}
			}else{
				// reset the tooltip back to the defaults
				this.connectorNode.style.top = "";
				this.connectorNode.style.bottom = "";
			}

			return Math.max(0, size.w - widthAvailable);
		},

		_onShow: function(){
			// summary:
			//		Called at end of fade-in operation
			// tags:
			//		protected
			if(has("ie")){
				// the arrow won't show up on a node w/an opacity filter
				this.domNode.style.filter="";
			}
		},

		hide: function(aroundNode){
			// summary:
			//		Hide the tooltip

			if(this._onDeck && this._onDeck[1] == aroundNode){
				// this hide request is for a show() that hasn't even started yet;
				// just cancel the pending show()
				this._onDeck=null;
			}else if(this.aroundNode === aroundNode){
				// this hide request is for the currently displayed tooltip
				this.fadeIn.stop();
				this.isShowingNow = false;
				this.aroundNode = null;
				this.fadeOut.play();
			}else{
				// just ignore the call, it's for a tooltip that has already been erased
			}

			this.onMouseEnter = this.onMouseLeave = noop;
		},

		_onHide: function(){
			// summary:
			//		Called at end of fade-out operation
			// tags:
			//		protected

			this.domNode.style.cssText="";	// to position offscreen again
			this.containerNode.innerHTML="";
			if(this._onDeck){
				// a show request has been queued up; do it now
				this.show.apply(this, this._onDeck);
				this._onDeck=null;
			}
		}
	});

	if(has("dojo-bidi")){
		MasterTooltip.extend({
			_setAutoTextDir: function(/*Object*/node){
				// summary:
				//		Resolve "auto" text direction for children nodes
				// tags:
				//		private

				this.applyTextDir(node);
				array.forEach(node.children, function(child){ this._setAutoTextDir(child); }, this);
			},

			_setTextDirAttr: function(/*String*/ textDir){
				// summary:
				//		Setter for textDir.
				// description:
				//		Users shouldn't call this function; they should be calling
				//		set('textDir', value)
				// tags:
				//		private

				this._set("textDir", textDir);

				if (textDir == "auto"){
					this._setAutoTextDir(this.containerNode);
				}else{
					this.containerNode.dir = this.textDir;
				}
			}
		});
	}

	dijit.showTooltip = function(innerHTML, aroundNode, position, rtl, textDir, onMouseEnter, onMouseLeave){
		// summary:
		//		Static method to display tooltip w/specified contents in specified position.
		//		See description of dijit/Tooltip.defaultPosition for details on position parameter.
		//		If position is not specified then dijit/Tooltip.defaultPosition is used.
		// innerHTML: String
		//		Contents of the tooltip
		// aroundNode: place.__Rectangle
		//		Specifies that tooltip should be next to this node / area
		// position: String[]?
		//		List of positions to try to position tooltip (ex: ["right", "above"])
		// rtl: Boolean?
		//		Corresponds to `WidgetBase.dir` attribute, where false means "ltr" and true
		//		means "rtl"; specifies GUI direction, not text direction.
		// textDir: String?
		//		Corresponds to `WidgetBase.textdir` attribute; specifies direction of text.
		// onMouseEnter: Function?
		//		Callback function for mouse over on tooltip
		// onMouseLeave: Function?
		//		Callback function for mouse leave on tooltip

		// After/before don't work, but for back-compat convert them to the working after-centered, before-centered.
		// Possibly remove this in 2.0.   Alternately, get before/after to work.
		if(position){
			position = array.map(position, function(val){
				return {after: "after-centered", before: "before-centered"}[val] || val;
			});
		}

		if(!Tooltip._masterTT){ dijit._masterTT = Tooltip._masterTT = new MasterTooltip(); }
		return Tooltip._masterTT.show(innerHTML, aroundNode, position, rtl, textDir, onMouseEnter, onMouseLeave);
	};

	dijit.hideTooltip = function(aroundNode){
		// summary:
		//		Static method to hide the tooltip displayed via showTooltip()
		return Tooltip._masterTT && Tooltip._masterTT.hide(aroundNode);
	};

	// Possible states for a tooltip, see Tooltip.state property for definitions
	var DORMANT = "DORMANT",
		SHOW_TIMER = "SHOW TIMER",
		SHOWING = "SHOWING",
		HIDE_TIMER = "HIDE TIMER";

	function noop(){}

	var Tooltip = declare("dijit.Tooltip", _Widget, {
		// summary:
		//		Pops up a tooltip (a help message) when you hover over a node.
		//		Also provides static show() and hide() methods that can be used without instantiating a dijit/Tooltip.

		// label: String
		//		HTML to display in the tooltip.
		//		Specified as innerHTML when creating the widget from markup.
		label: "",

		// showDelay: Integer
		//		Number of milliseconds to wait after hovering over/focusing on the object, before
		//		the tooltip is displayed.
		showDelay: 400,

		// hideDelay: Integer
		//		Number of milliseconds to wait after unhovering the object, before
		//		the tooltip is hidden.  Note that blurring an object hides the tooltip immediately.
		hideDelay: 400,

		// connectId: String|String[]|DomNode|DomNode[]
		//		Id of domNode(s) to attach the tooltip to.
		//		When user hovers over specified dom node(s), the tooltip will appear.
		connectId: [],

		// position: String[]
		//		See description of `dijit/Tooltip.defaultPosition` for details on position parameter.
		position: [],

		// selector: String?
		//		CSS expression to apply this Tooltip to descendants of connectIds, rather than to
		//		the nodes specified by connectIds themselves.    Useful for applying a Tooltip to
		//		a range of rows in a table, tree, etc.   Use in conjunction with getContent() parameter.
		//		Ex: connectId: myTable, selector: "tr", getContent: function(node){ return ...; }
		//
		//		The application must require() an appropriate level of dojo/query to handle the selector.
		selector: "",

		// TODO: in 2.0 remove support for multiple connectIds.   selector gives the same effect.
		// So, change connectId to a "", remove addTarget()/removeTarget(), etc.

		_setConnectIdAttr: function(/*String|String[]|DomNode|DomNode[]*/ newId){
			// summary:
			//		Connect to specified node(s)

			// Remove connections to old nodes (if there are any)
			array.forEach(this._connections || [], function(nested){
				array.forEach(nested, function(handle){ handle.remove(); });
			}, this);

			// Make array of id's to connect to, excluding entries for nodes that don't exist yet, see startup()
			this._connectIds = array.filter(lang.isArrayLike(newId) ? newId : (newId ? [newId] : []),
					function(id){ return dom.byId(id, this.ownerDocument); }, this);

			// Make connections
			this._connections = array.map(this._connectIds, function(id){
				var node = dom.byId(id, this.ownerDocument),
					selector = this.selector,
					delegatedEvent = selector ?
						function(eventType){ return on.selector(selector, eventType); } :
						function(eventType){ return eventType; },
					self = this;
				return [
					on(node, delegatedEvent(mouse.enter), function(){
						self._onHover(this);
					}),
					on(node, delegatedEvent("focusin"), function(){
						self._onHover(this);
					}),
					on(node, delegatedEvent(mouse.leave), lang.hitch(self, "_onUnHover")),
					on(node, delegatedEvent("focusout"), lang.hitch(self, "set", "state", DORMANT))
				];
			}, this);

			this._set("connectId", newId);
		},

		addTarget: function(/*DomNode|String*/ node){
			// summary:
			//		Attach tooltip to specified node if it's not already connected

			// TODO: remove in 2.0 and just use set("connectId", ...) interface

			var id = node.id || node;
			if(array.indexOf(this._connectIds, id) == -1){
				this.set("connectId", this._connectIds.concat(id));
			}
		},

		removeTarget: function(/*DomNode|String*/ node){
			// summary:
			//		Detach tooltip from specified node

			// TODO: remove in 2.0 and just use set("connectId", ...) interface

			var id = node.id || node,	// map from DOMNode back to plain id string
				idx = array.indexOf(this._connectIds, id);
			if(idx >= 0){
				// remove id (modifies original this._connectIds but that's OK in this case)
				this._connectIds.splice(idx, 1);
				this.set("connectId", this._connectIds);
			}
		},

		buildRendering: function(){
			this.inherited(arguments);
			domClass.add(this.domNode,"dijitTooltipData");
		},

		startup: function(){
			this.inherited(arguments);

			// If this tooltip was created in a template, or for some other reason the specified connectId[s]
			// didn't exist during the widget's initialization, then connect now.
			var ids = this.connectId;
			array.forEach(lang.isArrayLike(ids) ? ids : [ids], this.addTarget, this);
		},

		getContent: function(/*DomNode*/ node){
			// summary:
			//		User overridable function that return the text to display in the tooltip.
			// tags:
			//		extension
			return this.label || this.domNode.innerHTML;
		},

		// state: [private readonly] String
		//		One of:
		//
		//		- DORMANT: tooltip not SHOWING
		//		- SHOW TIMER: tooltip not SHOWING but timer set to show it
		//		- SHOWING: tooltip displayed
		//		- HIDE TIMER: tooltip displayed, but timer set to hide it
		state: DORMANT,
		_setStateAttr: function(val){
			if(this.state == val ||
				(val == SHOW_TIMER && this.state == SHOWING) ||
				(val == HIDE_TIMER && this.state == DORMANT)){
				return;
			}

			if(this._hideTimer){
				this._hideTimer.remove();
				delete this._hideTimer;
			}
			if(this._showTimer){
				this._showTimer.remove();
				delete this._showTimer;
			}

			switch(val){
				case DORMANT:
					if(this._connectNode){
						Tooltip.hide(this._connectNode);
						delete this._connectNode;
						this.onHide();
					}
					break;
				case SHOW_TIMER:	 // set timer to show tooltip
					// should only get here from a DORMANT state, i.e. tooltip can't be already SHOWING
					if(this.state != SHOWING){
						this._showTimer = this.defer(function(){ this.set("state", SHOWING); }, this.showDelay);
					}
					break;
				case SHOWING:		// show tooltip and clear timers
					var content = this.getContent(this._connectNode);
					if(!content){
						this.set("state", DORMANT);
						return;
					}

					// Show tooltip and setup callbacks for mouseenter/mouseleave of tooltip itself
					Tooltip.show(content, this._connectNode, this.position, !this.isLeftToRight(), this.textDir,
						lang.hitch(this, "set", "state", SHOWING), lang.hitch(this, "set", "state", HIDE_TIMER));

					this.onShow(this._connectNode, this.position);
					break;
				case HIDE_TIMER:	// set timer set to hide tooltip
					this._hideTimer = this.defer(function(){ this.set("state", DORMANT); }, this.hideDelay);
					break;
			}

			this._set("state", val);
		},

		_onHover: function(/*DomNode*/ target){
			// summary:
			//		Despite the name of this method, it actually handles both hover and focus
			//		events on the target node, setting a timer to show the tooltip.
			// tags:
			//		private

			if(this._connectNode && target != this._connectNode){
				// Tooltip is displaying for another node
				this.set("state", DORMANT);
			}
			this._connectNode = target;		// _connectNode means "tooltip currently displayed for this node"

			this.set("state", SHOW_TIMER);	// no-op if show-timer already set, or if already showing
		},

		_onUnHover: function(/*DomNode*/ target){
			// summary:
			//		Handles mouseleave event on the target node, hiding the tooltip.
			// tags:
			//		private

			this.set("state", HIDE_TIMER);		// no-op if already dormant, or if hide-timer already set
		},

		// open() and close() aren't used anymore, except from the _BidiSupport/misc/Tooltip test.
		// Should probably remove for 2.0, but leaving for now.
		open: function(/*DomNode*/ target){
			// summary:
			//		Display the tooltip; usually not called directly.
			// tags:
			//		private

			this.set("state", DORMANT);
			this._connectNode = target;		// _connectNode means "tooltip currently displayed for this node"
			this.set("state", SHOWING);
		},

		close: function(){
			// summary:
			//		Hide the tooltip or cancel timer for show of tooltip
			// tags:
			//		private

			this.set("state", DORMANT);
		},

		onShow: function(/*===== target, position =====*/){
			// summary:
			//		Called when the tooltip is shown
			// tags:
			//		callback
		},

		onHide: function(){
			// summary:
			//		Called when the tooltip is hidden
			// tags:
			//		callback
		},

		destroy: function(){
			this.set("state", DORMANT);

			// Remove connections manually since they aren't registered to be removed by _WidgetBase
			array.forEach(this._connections || [], function(nested){
				array.forEach(nested, function(handle){ handle.remove(); });
			}, this);

			this.inherited(arguments);
		}
	});

	Tooltip._MasterTooltip = MasterTooltip;		// for monkey patching
	Tooltip.show = dijit.showTooltip;		// export function through module return value
	Tooltip.hide = dijit.hideTooltip;		// export function through module return value

	Tooltip.defaultPosition = ["after-centered", "before-centered"];

	/*=====
	lang.mixin(Tooltip, {
		 // defaultPosition: String[]
		 //		This variable controls the position of tooltips, if the position is not specified to
		 //		the Tooltip widget or *TextBox widget itself.  It's an array of strings with the values
		 //		possible for `dijit/place.around()`.   The recommended values are:
		 //
		 //		- before-centered: centers tooltip to the left of the anchor node/widget, or to the right
		 //		  in the case of RTL scripts like Hebrew and Arabic
		 //		- after-centered: centers tooltip to the right of the anchor node/widget, or to the left
		 //		  in the case of RTL scripts like Hebrew and Arabic
		 //		- above-centered: tooltip is centered above anchor node
		 //		- below-centered: tooltip is centered above anchor node
		 //
		 //		The list is positions is tried, in order, until a position is found where the tooltip fits
		 //		within the viewport.
		 //
		 //		Be careful setting this parameter.  A value of "above-centered" may work fine until the user scrolls
		 //		the screen so that there's no room above the target node.   Nodes with drop downs, like
		 //		DropDownButton or FilteringSelect, are especially problematic, in that you need to be sure
		 //		that the drop down and tooltip don't overlap, even when the viewport is scrolled so that there
		 //		is only room below (or above) the target node, but not both.
	 });
	=====*/
	return Tooltip;
});

},
'dijit/_base/manager':function(){
define([
	"dojo/_base/array",
	"dojo/_base/config", // defaultDuration
	"dojo/_base/lang",
	"../registry",
	"../main"	// for setting exports to dijit namespace
], function(array, config, lang, registry, dijit){

	// module:
	//		dijit/_base/manager

	var exports = {
		// summary:
		//		Deprecated.  Shim to methods on registry, plus a few other declarations.
		//		New code should access dijit/registry directly when possible.
	};

	array.forEach(["byId", "getUniqueId", "findWidgets", "_destroyAll", "byNode", "getEnclosingWidget"], function(name){
		exports[name] = registry[name];
	});

	 lang.mixin(exports, {
		 // defaultDuration: Integer
		 //		The default fx.animation speed (in ms) to use for all Dijit
		 //		transitional fx.animations, unless otherwise specified
		 //		on a per-instance basis. Defaults to 200, overrided by
		 //		`djConfig.defaultDuration`
		 defaultDuration: config["defaultDuration"] || 200
	 });

	lang.mixin(dijit, exports);

	/*===== return exports; =====*/
	return dijit;	// for back compat :-(
});

},
'appivo/builder/components/CodeDialog':function(){
define([
  'vue/vue',
  './DialogMixin',
  './DialogFrame',
  './ScriptEditor',
  'appivo/vue/components/InlineTextBox',
  'dojo/text!../html/CodeDialog.html'
], function(Vue, DialogMixin, DialogFrame, ScriptEditor, InlineTextBox, template) {

	return Vue.extend({
		template: template,
		mixins: [DialogMixin],
		props: {
		    env: {
		        type: Object,
		        default: function() {
		            return {
		                environment: 'client'
		            }
		        }
		    },
			code: {
			    type: Object,
			    default: function() {
			        return {};
			    }
			},
			codemode: {
                type: String,
                default: 'quick'
            },
			title: String,
			itemname: String,
			itemtype: String,
			itemvalidation: {
				type: Object,
				default: function() {
					return {};
				}
			},
			itemicon: {
				type: String,
				default: 'ion-code orange-txt'
			}
		},
		data: function() {
			return {
				dialogWidth: 36
			}
		},
		methods: {
			ok: function() {
				this.$dispatch('done');
			},
			cancel: function() {
				this.$dispatch('cancel');
			},
			updateItemName: function(event) {
				this.itemname = event.value;
			},
			toggleFullScreen: function() {
				this.$refs.scriptEditor.toggleFullscreen();
			}
		},
		events: {
		    'scriptchange': function(code) {
		        this.code = code;
		    }
		},
		watch: {
			codemode: function(mode) {
				if (mode === 'quick') {
					this.dialogWidth = 36;
				} else {
					this.dialogWidth = 50;
				}
			}
		},
		components: {
			'dialogframe': DialogFrame,
			'scripteditor': ScriptEditor,
			'inlinetextbox': InlineTextBox
		},
		ready: function() {
			if (!this.code) {
				this.code = {
					quick: {}
				};
			}
		}
	});
});

},
'appivo/builder/components/DialogMixin':function(){
define([
  'vue/vue',
  './DialogManager'
], function(Vue, DialogManager) {

	return {
		props: {
			fullscreen: {
				type: Boolean,
				"default": false
			}
		},
		ready: function() {
		},
		methods: {
			toggleFullscreen: function() {
				this.fullscreen = !this.fullscreen;
			},
			close: function() {
				DialogManager.close(this);
			}
		}
	};
});
},
'appivo/builder/components/DialogManager':function(){
define([
  'vue/vue'
], function(Vue) {

	var showing = false;
	var body = document.body;
	var node = document.createElement('div');
	body.appendChild(node);
	
	return {
		show: function() {
			$(node).addClass('fullscreen');
		},
		
		hide: function() {
			$(node).removeClass('fullscreen');
		},
				
		openDialog: function(dialog) {
			if (!showing) {
				this.show();
			}
			var d = document.createElement('div');
			node.prepend(d);
			dialog.$mount(d);
		},
		
		closeDialog: function(dialog) {
			dialog.$destroy(true);
			if (!node.lastChild) {
				this.hide();
			}
		},
		
		closeAll: function() {
			while (node.lastChild) {
				node.removeChild(node.lastChild);
			}
			this.hide();
		},

		getDomNode: function() {
            return node;
		}
	};
	
});

},
'appivo/builder/components/DialogFrame':function(){
define([
  'vue/vue',
  'vue/vue-strap',
  'dojo/text!../html/DialogFrame.html'
], function(Vue, VueStrap, template) {

	return Vue.extend({
		template: template,
		props: {
			fullscreen: {
				type: Boolean,
				default: false
			},
			width: {
				type: Number,
				default: 80
			},
			height: {
				type: Number,
				default: 80
			},
			headerheight: {
				type: String,
				default: "2em"
			},
			footerheight: {
				type: String,
				default: "3em"
			}
		},
		computed: {
			heightUnit: function() {
				var len = this.headerheight.length;
				var suffix = this.headerheight.substring(len - 2, len);
				return suffix;
			},
			headerStyle: function() {
				return {
					"height": this.headerheight
				};
			},
			mainStyle: function() {
				var suffix = this.heightUnit;
				var hhidx = this.headerheight.indexOf(suffix);
				var fhidx = this.footerheight.indexOf(suffix);
				var hh = this.headerheight.substring(0, hhidx);
				var fh = this.footerheight.substring(0, fhidx);
				var sum = parseFloat(hh) + parseFloat(fh);
				return {
					"height": "calc(80vh - " + sum + suffix + ")" /*changed from 100% to 80vh*/
				};
			},
			footerStyle: function() {
				return {
					"height": this.footerheight
				};				
			},
			dialogStyle: function() {
				return {
					width: (this.fullscreen ? 100 : this.width) + "vw",
					minHeight: (this.fullscreen ? 100 : this.height) + "%"
				};
			},
			dialogClasses: function() {
				return {
					"fullscreen": this.fullscreen
				};
			}
		},
		components: {
			'button': VueStrap.button
		},
		ready: function() {
			if (!this.code) {
				this.code = {
					quick: {}
				};
			}
		}
	});
});

},
'appivo/builder/components/ScriptEditor':function(){
define([
  'vue/vue',
  'vue/vue-strap',
  'appivo/vue/components/CodeEditor',
  './MacroSelect',
  'dojo/text!../html/ScriptEditor.html',
  'dojo/i18n!../../builder/nls/Builder',
], function(Vue, VueStrap, CodeEditor, MacroSelect, template, messages) {

	return Vue.extend({
		template: template,
        props: {
            attribute: String,
            mode: {
            	type: String,
                default: 'quick'
            },
            env: Object,
            data: Object,
            name: String,
            hidefullscreen: Boolean,
            fullscreen: {
                type: Boolean,
                "default": false
            },
            mini:{
                type: Boolean,
                "default": false
            },
            title: String
        },
        data: function() {
            return {
                isDeleting: false,
                showParameterInfo: false,
                toDisplay: null,
                showIssuesPane: false,
                issues: {
                    warnings: [],
                    errors: []
                }
            };
        },
        computed: {
            code: function(){
                if (!this.data) {
                    this.data = {
                        script: {}
                    }
                }
                return this.data;
            },
            scriptContext: function(){
                return {
                    script: this.name,
                    schema: this.$state.data.app.id
                };
            },
            displayMode: function() {
            	var label = this.$t('actionScriptQuick');
            	switch (this.mode) {
            	case 'script':
            		label = this.$t('actionScriptJavascript');
            		break;
            	}
            	return label;
            },
            parameters: function() {
                var params = [{
                    name: "context",
                    description: messages.contextParamDescription,
                    docsPath: this.env.environment === "client" ? "/apis/context/" : "/apis/backend/context/"
                }];
                if (this.env.parameters) {
                    params = params.concat(this.env.parameters);
                }
                return params;
            },
            allIssues: function() {
                return this.issues.errors.concat(this.issues.warnings);
            }
        },
        events: {
            'macrochange': function (obj) {
                var d = $.extend({}, obj);
                this.updateData(d);
            },
            'logicchange': function (obj) {
                var d = $.extend({}, obj);
                d.quick = {};
                this.updateData(d);
            },
            'codechange': function (obj) {
                var d = $.extend({}, this.data);
                if(!d.script){
                    d.script = new Object();
                }
                d.script.script = obj.value;
                d.quick = {};
                d.logic = {};
                this.updateData(d);
            },
            'code-editor-delete': function() {
                this.isDeleting = true;
            },
            'code-issues': function(obj) {
                var issues = obj.issues.reduce(function(acc, val) {
                    if (val.type === "error") {
                        acc.errors.push(val);
                    } else if (val.type === "warning") {
                        acc.warnings.push(val);
                    }
                    return acc;
                }, { errors: [], warnings: [] });

                this.$set('issues', issues);
            }
        },
        methods: {
            updateData: function(data) {
                this.$set('data', data);
                this.$dispatch('scriptchange', data);
            },
            toggleFullscreen: function() {
                this.fullscreen = !this.fullscreen;
    			this.$broadcast('fullscreen', {
    				fullscreen: this.fullscreen
    			});
            },
            beautify: function() {
                this.$broadcast('beautify');
            },
            displayEvent:function(propsValue) {
                if(propsValue){
                    this.showParameterInfo = true;
                    this.toDisplay = propsValue;
                }
            },
            removeParameterInfo:function () {
                this.showParameterInfo = false;
            },
            updateMode: function(event){
                this.mode = event.target.value;
            },
            updateHelpPath: function() {
                switch (this.mode) {
                case 'quick':
                    this.$state.setHelpPath('SCRIPT/QUICK');
                    break;
                case 'script':
                    this.$state.setHelpPath('SCRIPT/SCRIPT');
                   break;
               }
            },
            detectMode: function() {
                if (this.isDeleting) {
                    this.isDeleting = false;
                    return;
                }
                if (this.data) {
                    if (typeof this.data.script == "string" ) {
                        var js = this.data.script;
                        var clone = JSON.parse(JSON.stringify(this.data));
                        clone.script = {script:js};
                        this.$set('data', clone);
                    }
                    if (this.data.quick && this.data.quick.action) {
                        this.mode = 'quick';
                    } else if (this.data.logic && this.data.logic.xml) {
                        this.mode = 'logic';
                    } else if (this.data.script && this.data.script.script) {
                        this.mode = 'script';
                    }
                }
                this.updateHelpPath();
            },
            toggleIssuesPane: function() {
                this.showIssuesPane = !this.showIssuesPane;
            },
            navigateToIssue: function(issue) {
                this.$broadcast('goto-code', {
                    row: issue.row,
                    col: issue.col
                });
            }
        },
        watch: {
            'mode': function() {
                this.updateHelpPath();
            },
            'data': function(val,oldVal) {
                if (this.$refs.codeEditor) {
                    var script = (val && val.script !== undefined ? (val.script.script !== undefined ? val.script.script : val.script) : '');
                    if (script !== this.$refs.codeEditor.getValue()) {
                        this.$refs.codeEditor.setValue(script);
                    }
                }
                this.detectMode();
            }
        },
        created: function() {
            if (!this.data) {
                this.data = {};
            }
            this.detectMode();
        },
        components: {
            'codeeditor' : CodeEditor,
            'macroselect' : MacroSelect,
            'modal' : VueStrap.modal
        }
    });
});

},
'appivo/vue/components/CodeEditor':function(){
define([
	'dojo/_base/lang',
	'vue/vue',
	'vue/vue-strap',
	'appivo/mvc/ActionContext',
	'appivo/util/BuilderAssistant',
	'dojo/_base/array',
	"dojo/_base/config",
	"dojo/Deferred",
	"dojo/DeferredList",
	'dojo/text!./autocompletion/meta.json',
	'dojo/text!./autocompletion/appivo.json',
	'dojo/text!./autocompletion/context.json',
	'dojo/text!../html/CodeEditor.html',
	'sanitize-html/sanitize-html',
	'highlight/highlight',
	'appivo/util/Handlebars',
	'highlight/languages/xml',
], function(lang, Vue, VueStrap, ActionContext, BuilderAssistant, array, config, Deferred, DeferredList, jsmeta, appivoJson , autocompleteJson, template, sanitizeHtml, Highlight, Handlebars, xmlLanguage) {
	return Vue.extend({
		template: template,
		data: function() {
			return {
				comments: [],
				aceLoading: false,
                showRuntimeErrorHelp: false,
                runtimeErrorSuggestionCache: {},
				assistantChat: [{
					from: "ai",
					message: `👋 Hi there!\nHow can I assist you today?`
				}],
				messageHistory: [],
				showDots: false
			};
		},
		props: {
			env: Object,
			mode: String,
			fullscreen: {
				type: Boolean,
				"default": false
			},
			value: {
				required: false,
				type: String
			},
			attribute: {
				required: false,
				type: String
			},
			linenumbers: {
				type: Boolean,
				"default": true
			},
			context: {
				type: Object
			}
		},
		computed: {
			_getQueriesList:function () {
				var queryList = [];
				if (this.$state.data.app) {
					queryList = this.$state.data.app.queries.map(function (queryItem) {
						return queryItem.name;
					});
				}
				return queryList.sort();
			},

			viewListing: function () {
				var viewList = [];
				if (this.$state.data.editUI && this.$state.data.editUI.views) {
					viewList = viewList.concat(this.$state.data.editUI.views);
				} else if (this.$state.data.app && this.$state.data.app.userInterfaces) {
					this.$state.data.app.userInterfaces.forEach(function(uiItem) {
						viewList = viewList.concat(uiItem.views);
					});
				}
				return viewList;
			},

			_getViewList: function () {
				var viewList = [];
				this.viewListing.forEach(function (viewItem) {
					if (viewItem.widgetType === 'View') {
						viewList.push(viewItem.id);
					}
				});
				return viewList.sort();
			},

			_getDialogList: function () {
				var viewList = [];
				this.viewListing.forEach(function (viewItem) {
					if (viewItem.widgetType === 'Dialog') {
						viewList.push(viewItem.id);
					}
				});
				return viewList.sort();
			},

			_getFormListing: function () {
				var formsObj = {}
				if (this.$state.editView && this.$state.editView.forms) {
					formsObj = this.$state.editView.forms;
				}
				var list = Object.keys(formsObj);
				return list.sort();
			},

			_getModelListing: function () {
				var toReturn = [];
				if (this.$state.data.app) {
					this.$state.data.app.models.forEach(function(modelItem) {
						toReturn.push(modelItem.name);
					});
				}
				return toReturn.sort();
			},

			_getWidgetListing: function () {
				var widgetIds = [];
				if (this.$state.editView && this.$state.editView.widgets) {
					var widgetObj = this.$state.editView.widgets;
					for (var widgetId in widgetObj) {
						var widgetItem = widgetObj[widgetId];
						if (widgetItem.widgetDef.category !== "view") {
							widgetIds.push(widgetId);
						}
					}
				}
				return widgetIds.sort();
			},

			_getIntegrationListing: function () {
				var toReturn = [];
				if (this.$state.data.app && this.$state.data.app.integrations) {
					this.$state.data.app.integrations.forEach(function(integrationItem){
						toReturn.push(integrationItem.name);
					});
				}
				return toReturn.sort();
			},

			_getWebhookListing: function() {
				var rules = [];
				if (this.$state.data.app && this.$state.data.app.rules) {
					this.$state.data.app.rules.forEach(function(rule) {
						if (rule.type === "REST") {
							rules.push(rule.name);
						}
					});
				}
				return rules.sort();
			},

			_getConfigParamListing: function() {
				var params = [];
				if (this.$state.data.app && this.$state.data.app.params) {
					this.$state.data.app.params.forEach(function(param) {
						params.push(param.name);
					});
				}
				return params.sort();
			},

			_getRuleListing: function() {
				var rules = [];
				if (this.$state.data.app && this.$state.data.app.rules) {
					this.$state.data.app.rules.forEach(function(rule) {
						rules.push(rule.name);
					});
				}
				return rules.sort();
			},

			_getActionListing: function() {
				var actions = [];
				if (this.$state.data.app && this.$state.data.app.actions) {
					this.$state.data.app.actions.forEach(function(action) {
						actions.push(action.name);
					});
				}
				return actions.sort();
			},

			_getWidgetDefs:function () {
				var widgets = [];
				if (this.$state.editView && this.$state.editView.widgets) {
					var widgetObj = this.$state.editView.widgets;
					for (var widgetId in widgetObj) {
						var widgetItem = widgetObj[widgetId];
						if (widgetItem.widgetDef.category !== "view") {
							widgets.push({id:widgetId, type:widgetItem.widgetDef.name})
						}
					}
				}
				return widgets;
			},

			autoCompleter: function() {
				var completer = {
					getCompletions: function(editor, session, pos, prefix, callback) {
						var completions = [];

						var displayFrom = [];
						var previewTypeTag = 'appivo';
						var sel = editor.getSelectedText();
						if (sel.startsWith("'") && sel.endsWith("'")) {
							sel = sel.slice(1, -1);
						}
						switch (sel) {
							case "String/Query-ID":
								//suggest queries
								displayFrom = this.queries;
								previewTypeTag = "Query";
								break;
							case "String/View-ID":
								//suggest views
								displayFrom = this.viewListing;
								previewTypeTag = "View";
								break;
							case "String/Dialog-ID":
								//suggest dialogs
								displayFrom = this.dialogListing;
								previewTypeTag = "Dialog";
								break;
							case "String/Form-ID":
								//suggest forms
								displayFrom = this.formListing;
								previewTypeTag = "Form";
								break;
							case "String/Widget-ID":
								//suggest widgets
								displayFrom = this.widgetListing;
								previewTypeTag = "Widget";
								break;
							case "String/Model-ID":
								//suggest model
								displayFrom = this.modelListing;
								previewTypeTag = "Model";
								break;
							case "String/Webhook-ID":
								displayFrom = this.webhooks;
								previewTypeTag = "Rule";
								break;
							case "String/Data-TYPE":
								displayFrom = ["STRING", "INTEGER", "FLOAT", "BOOLEAN", "DATE", "TIME", "TIMESTAMP", "ENUM", "POINT", "ID"];
								previewTypeTag = "DataType";
								break;
							case "String/ConfigParam-ID":
								displayFrom = this.paramListing;
								previewTypeTag = "Param";
								break;
							case "String/Integration-ID":
								displayFrom = this.integrationListing;
								previewTypeTag = "Integration";
								break;
							case "String/Action-ID":
								displayFrom = this.actions;
								previewTypeTag = "Action";
								break;
							case "String/Rule-ID":
								displayFrom = this.rules;
								previewTypeTag = "Rule";
								break;
							case "String/HTTP-Method":
								displayFrom = ["GET","POST","PUT"];
								previewTypeTag = "HTTP Method Types";
								break;
						}
						for (var i = 0; i < displayFrom.length; i++) {
							var queryItem = displayFrom[i];
							completions.push({
								caption: queryItem,
								value: queryItem,
								doc: '',
								score: 99999,
								meta: previewTypeTag,
								parameters: [],
								returnType: null,
								metaData: null,
								iconClass: " Ace-Tern-completion Ace-Tern-completion-object",
								isAppivoContext: true
							});
						}
						callback(null, completions);
					}
				};
				completer.queries = JSON.parse(JSON.stringify(this._getQueriesList));
				completer.viewListing = JSON.parse(JSON.stringify(this._getViewList));
				completer.dialogListing = JSON.parse(JSON.stringify(this._getDialogList));
				completer.formListing = JSON.parse(JSON.stringify(this._getFormListing));
				completer.widgetListing = JSON.parse(JSON.stringify(this._getWidgetListing));
				completer.modelListing = JSON.parse(JSON.stringify(this._getModelListing));
				completer.paramListing = JSON.parse(JSON.stringify(this._getConfigParamListing));
				completer.rules = JSON.parse(JSON.stringify(this._getRuleListing));
				completer.webhooks = JSON.parse(JSON.stringify(this._getWebhookListing));
				completer.actions = JSON.parse(JSON.stringify(this._getActionListing));
				completer.integrationListing = JSON.parse(JSON.stringify(this._getIntegrationListing));
				completer.context = this;
				return completer;
			},

			contextSnippets:function () {
				var snippets = [];
				if (this.comments) {
					this.comments.forEach(function (commentItem) {
						if (commentItem.functionName) {
							snippets.push(
								{
									name: commentItem.functionName,
									tabTrigger: commentItem.tabTrigger,
									content: commentItem.snippetContent
								}
							);
							switch (commentItem.functionName) {
								case 'getWidget':
									// reopening widgetids popup
									var endIndex = commentItem.snippetContent.indexOf(')');
									snippets.push(
										{
											name: commentItem.functionName + "(",
											tabTrigger: commentItem.tabTrigger + "(",
											content: commentItem.snippetContent.substring(0, endIndex)
										}
									);
									break;
								default:

							}

						}
					});
				}
				return snippets;
			},

			templateModels: function () {
				return this.$state.data.app.models;
			},

			templateQueries: function () {
				return this.$state.data.app.queries;
			},

			autocompleteEnabled: function() {
				return this.mode === 'javascript' || this.mode === 'text/css' || this.mode === 'text/html';
			},

			customAutocompleteEnabled: function() {
				return this.mode === 'javascript';
			},

			beautifyEnabled: function() {
				return this.mode === 'javascript' || this.mode === 'text/css' || this.mode === 'text/html' || this.mode == 'text/json';
			},

			isClientContext: function() {
				return this.env.environment === "client";
			},

			isDeviceContext: function() {
				return this.env.environment === "device";
			}
		},
		watch: {
			'mode': function() {
				this._setMode(this.mode);
			}
		},
		events: {
			'fullscreen': function() {
				var t = this;
				if (this.$aceEditor) {
					Vue.nextTick(function() {
						t.$aceEditor.resize(true);
					});
				}
			},
			'beautify': function() {
				if (this.$beautify) {
					var pos = this.$aceEditor.getCursorPosition();
					this.setValue(this.$beautify(this.value));
					this.$aceEditor.gotoLine(pos.row + 1, pos.column + 1);
				}
			},
			'goto-code': function(obj) {
				if (this.$aceEditor) {
					this.$aceEditor.gotoLine(obj.row, obj.col, true);
				}
			},
			CodeEditor: function(opts) {
				switch (opts.cmd) {
					case 'refresh':
						if (this.$aceEditor) {
							this.$aceEditor.resize(true);
						}
						break;
				}
			}
		},
		ready: function () {
			var t = this;
			window.t = this;
			t.getAce().then(function() {
				if (t.autocompleteEnabled) {
					t.$ternTools = window.ace.require('ace/ext/tern');
					if (!t.$ternTools) {
						t.$ternTools = window.ace.require('ace/tern/tern');
					}
				}
				if (t.beautifyEnabled) {
					switch (t.mode) {
					case "javascript":
						t.$beautify = window.js_beautify;
						break;
					case "text/html":
						t.$beautify = window.html_beautify;
						break;
					case "text/css":
						t.$beautify = window.css_beautify;
						break;
					}
				}
				t.initEditor();
			});
			// this.initHighlight();
		},
		destroyed: function() {
			if (this.$aceEditor) {
				if (this.$aceEditor.ternServer && this.$aceEditor.ternServer.server) {
					this.$aceEditor.ternServer.server.closeServer();
					this.$aceEditor.ternServer.server.closeAllTooltip();
				}
				if (this.$aceEditor.completer) {
				    this.$aceEditor.completer.detach();
				}
				this.$aceEditor.destroy();
				this.$aceEditor = null;
			}
		},
		methods: {
			getAce: function() {
				var t = this;
				var def = new Deferred();
				if (!this.aceLoading) {
					this.aceLoading = true;
					this.loadComponent('/js/lib/ace/ace.js').then(function() {
						var base = "/" + config.appivoEnv + '/' + config.appivoVersion + '/js/lib/ace';
						window.ace.config.set('basePath', base);
						t.getAceComponents().then(function() {
							def.resolve();
						});
					});
				} else {
					def.resolve();
				}
				return def;
			},

			loadComponent: function(url) {
				var def = new Deferred();
				$.ajax({
					dataType: 'script',
					cache: true,
					url: url
				}).done(function() {
					def.resolve();
				});
				return def
			},

			getAceComponents: function() {
				var defList = [];
				if (this.autocompleteEnabled) {
					defList.push(this.loadComponent('/js/lib/ace/ext-tern.js'));
				}
				if (this.beautifyEnabled) {
					defList.push(this.loadComponent('/js/lib/jsbeautify/jsbeautify.js'));
					if (this.mode === "text/css") {
						defList.push(this.loadComponent('/js/lib/jsbeautify/jsbeautify-css.js'));
					}
					if (this.mode === "text/html") {
						defList.push(this.loadComponent('/js/lib/jsbeautify/jsbeautify-html.js'));
					}
				}
				return new DeferredList(defList);
			},

			initEditor: function() {
				var t = this;
				t.$aceEditor = window.ace.edit(t.$els.editor);
				t.$aceEditor.getSession().setUseWorker(true);
				var result = [];
				if (this.customAutocompleteEnabled) {
					result = this.prepareDefs();
				}
				t.$aceEditor.$blockScrolling = Infinity;
				t.$aceEditor.setOptions({
					enableTern: {
						defs: JSON.parse(JSON.stringify(result)),
						plugins: {
							doc_comment: {
								fullDocs: true
							}
						},
						widgetDefs: JSON.parse(JSON.stringify(t._getWidgetDefs)),
						useWorker: true,
						startedCb: function () {
							console.log('ternServer started');
							if (t.$ternTools) {
								t.$ternTools.setCompleters([]);
								if (t.autocompleteEnabled){
									t.$ternTools.addCompleter(t.autoCompleter);
								}
							}
						}
					},
					enableBasicAutocompletion: t.autocompleteEnabled,
					enableLiveAutocompletion: t.autocompleteEnabled,
					enableSnippets: t.autocompleteEnabled
				});

				if (this.autocompleteEnabled) {
					var snippetManager = window.ace.require("ace/snippets").snippetManager;
					window.ace.config.loadModule("ace/snippets/javascript", function(m) {
						if (m) {
							snippetManager.files.xml = m;
							m.snippets = snippetManager.parseSnippetFile(m.snippetText);
							var nsoa_snippets = t.contextSnippets;
							nsoa_snippets.forEach(function (s) { m.snippets.push(s); });
							snippetManager.register(m.snippets, m.scope);
						}

					});
				}

				t.setupEditor();
				if (t.value) {
					t.setValue(t.value);
				}
			},

			executeHandlebars: function (templateString, data) {
				const compiled = Handlebars.compile(templateString, {}, 2);
                if (compiled) {
                    return compiled(data);
                } else {
					console.error("Could not compile Hanldebars");
                    return templateString;
                }
			},

			getSampleData: async function (sampleName) {
				const [ type, name ] = sampleName.split("__");
				switch (type) {
					case "model":
						return await client.sendRequest(client.getURI() + "api/app/" + t.$state.data.app.name + "/model/" + name + "/record");
					case "query":
						return await client.sendRequest(client.getURI() + "api/app/" + t.$state.data.app.name + "/query/" + name + "/result");
				}
			},

			setupPreviewHandlers: function() {
				const modelSelectEl = document.querySelector("#preview-model");
				const isArrayEl = document.querySelector("#preview-is-array");

				modelSelectEl.addEventListener("sl-change", this.setPreview);
				isArrayEl.addEventListener("sl-change", this.setPreview);
			},

			setPreview: async function () {
				const editorValue = this.$aceEditor.getValue();
				const preview = document.querySelector('#code-preview');
				const sampleName = document.querySelector("#preview-model").value;
				const modelName = sampleName.split("__")[1];
				const isArray = document.querySelector("#preview-is-array").checked;
				const records = sampleName ? await this.getSampleData(sampleName) : [];
				const record = records[Math.floor(Math.random() * records.length)];
				if (preview) {
					if (record) {
						if (isArray) {
							const data = {};
							data[modelName] = records;
							const result = this.executeHandlebars(editorValue, { data });
							preview.setAttribute("html", encodeURIComponent(result));
						} else {
							const result = this.executeHandlebars(editorValue, { data: record });
							preview.setAttribute("html", encodeURIComponent(result));
						}
					} else {
						preview.setAttribute("html", encodeURIComponent(editorValue));
					}
				}
			},

			setupEditor: function() {
				var t = this;
				this.$aceEditor.setTheme("ace/theme/monokai");
				this._setMode(this.mode);
				if (t.mode == "html" || t.mode == "xml") {
					t.setPreview();
				}
				this.setupPreviewHandlers();
				this.$aceEditor.on('change', async function(e) {
					if (t.autocompleteEnabled && !t.$aceEditor.completer) {
						t.$aceEditor.execCommand("startAutocomplete");
					}
					const type = t.mode.split('/').at(-1);
					var editorValue = t.$aceEditor.getValue();
					if (type == "html" || type == "xml") {
						t.setPreview();
					}
					t.$dispatch('codechange', {
						attribute: t.attribute,
						value: editorValue
					});
				});
				this.$aceEditor.on('gutterdblclick', function(event) {
					var row = parseInt(event.domEvent.target.textContent);
					var annotations = t.getAnnotationsForLine(row-1);
                    if(t.runtimeErrorSuggestionCache.hasOwnProperty(row-1) && JSON.stringify(t.runtimeErrorSuggestionCache[row-1].annotations) == JSON.stringify(annotations)) {
						t.explainBug(annotations[0], row-1);
                        return;
                    }
                    t.runtimeErrorSuggestionCache[row-1] = {
                        annotations,
                        suggestion: null,
                    };
					if (annotations.length > 0) {
						t.explainBug(annotations[0], row-1);
					}
				});

				this.loadErrors();

				this.$aceEditor.session.on('changeAnnotation', function(_, session) {
					t.$dispatch("code-issues", {
						issues: session.getAnnotations().map(function(annotation) {
							return {
								row: annotation.row + 1,
								col: annotation.column + 1,
								text: annotation.text,
								type: annotation.type
							}
						})
					});
				});

				this.$aceEditor.commands.on("afterExec", function(e){
					if (t.autocompleteEnabled && e.command.name === "Tab" || e.command.name === "Return") {
						// check and apply snippet
						e.editor.expandSnippet();
						var selectedText = e.editor.getSelectedText();
						if (selectedText) {
							var isPresentIndex = selectedText.indexOf('String/');
							if (isPresentIndex !== -1) {
								e.editor.execCommand("startAutocomplete");
							}
						}
					}
					if (t.autocompleteEnabled && e.command.name === "expandSnippet") {
						var selectedText = e.editor.getSelectedText();
						if (selectedText) {
							var isPresentIndex = selectedText.indexOf('String/');
							if (isPresentIndex !== -1) {
								e.editor.execCommand("startAutocomplete");
							}
						}
					}
					if (e.command.name == "insertstring" && e.args === "#") {
						var cursorPos = e.editor.getCursorPosition();
						var range = {
							start: {
								column: 0,
								row: cursorPos.row
							},
							end: {
								column: cursorPos.column,
								row: cursorPos.row
							}
						};
						var content = e.editor.session.getTextRange(range);
						if (content.endsWith("###")) {
							range.start.row = 0;
							var full = e.editor.session.getTextRange(range);
							var begin = full.lastIndexOf("###", full.length - 4);
							if (begin > -1) {
								var raw = full.substring(begin, full.length).trim();
								if (raw.length > 7) {
									var request = raw.substring(3, raw.length - 3).trim();
									var replaceRange = e.editor.find(raw, {
										wrap: true,
										preventScroll: true,
										caseSensitive: true
									});
									replaceRange.end.column++;
									t.getCodeSuggestion(e.editor, request, replaceRange);
								}
							}
						}
					}
				});
			},

			getAnnotationsForLine: function(row) {
				var annotations = this.$aceEditor.getSession().getAnnotations();
				var selected = [];
				annotations.forEach(function(ann) {
					if (ann.row === row) {
						selected.push(ann);
					}
				});
				return selected;
			},

			explainBug: function(annotation, lineNumber) {
				var t = this;
				var script = this.$aceEditor.getValue();
				if (script.length > 800) {
					var startRow = annotation.row - 10;
					var endRow = annotation.row + 3;
					if (startRow < 0) {
						startRow = 0;
					}
					var range = {
						start: {
							row: startRow,
							column: 0
						},
						end: {
							row: endRow,
							column: 0
						}
					};
					script = this.$aceEditor.session.getTextRange(range);
					var lines = script.split("\n");
					var nscript = "";
					var no = startRow + 1;
					lines.forEach(function(line) {
						nscript += (no++) + " " + line + "\n";
					});
					script = nscript;
				}

                if (t.runtimeErrorSuggestionCache[lineNumber] && t.runtimeErrorSuggestionCache[lineNumber].suggestion != null) {
                    t.showSuggestion(t.runtimeErrorSuggestionCache[lineNumber].suggestion.message);
                    return;
                }

				if (!this.waitingForSuggestion) {
					t.waitingForSuggestion = true;
					t.$state.pageManager.showLoadingIndicator(null, "Asking assistant...");
					var msg = annotation.text;
					if (msg.startsWith("RUNTIME: ")) {
						msg = msg.substring(9);
					}
					BuilderAssistant.explainBug({
						code: script,
						error: {
							line: annotation.row + 1,
							message: msg
						}
					}).then(function (reply) {
						t.waitingForSuggestion = false;
						t.$state.pageManager.hideLoadingIndicator();
						if (reply.status == "ok") {
                            t.showRuntimeErrorHelp = true;
                            t.showSuggestion(reply.message);
                            t.runtimeErrorSuggestionCache[lineNumber].suggestion = reply;
						}
					}, function (error) {
						t.$state.pageManager.hideLoadingIndicator();
						t.waitingForSuggestion = false;
					});
				}
			},

			notify: function (message, variant = 'primary', icon = 'info-circle', duration = 3000) {
				const alert = Object.assign(document.createElement('sl-alert'), {
				variant,
				closable: true,
				duration: duration,
				style: "z-index: 999999; margin-top: 60px;",
				innerHTML: `
					<sl-icon name="${icon}" slot="icon"></sl-icon>
					${message}
				`
				});

				document.body.append(alert);
				return alert.toast();
			},

			getDataDefinition: function (definitionName) {
				const [ type, name ] = definitionName.split("__");
				const isArray = document.querySelector("#template-model-is-array").checked;
				let dataMap = {};
				let model;

				switch (type) {
					case "model":
						model = this.$state.data.app.models.find(el => el.name == name);
						for (const attribute of model.attributes.filter(el => !el.relation).filter(el => !["id", "ver"].includes(el.name))) {
							dataMap[attribute.name] = `<is of type ${attribute.type}${attribute.size ? ('and has a size of ' + attribute.size + ' characters') : ''}>`;
						}
						if (isArray) {
							const temp = {};
							temp[name] = [dataMap];
							dataMap = temp;
						}
						break;
					case "query":
						model = this.$state.data.app.queries.find(el => el.name == name);
						for (const attribute of model.select.selectors.filter(el => !el.relation)) {
							dataMap[attribute.alias] = `<is of type string>`;
						}
						if (isArray) {
							const temp = {};
							temp[name] = [dataMap];
							dataMap = temp;
						}
						break;
				}
				return JSON.stringify(dataMap);
			},

			askAi: async function () {
				const promptElement = document.querySelector("#ai-prompt");
				const modelInput = document.querySelector("#template-model");
				const prompt = promptElement.value;
				promptElement.value = "";
				let templateModel = modelInput.value;
				const model = this.getDataDefinition(templateModel);

				switch (this.$aceEditor.getSession().$modeId) {
					case "ace/mode/html":
						this.askHtml(prompt, model, templateModel);
						break;
					default:
						console.error("Content type not supported for AI prompting");
						break;
				}

			},

			askHtml: async function (prompt, model, dataName) {
				let response = client.callAgent("html-assistant", {
					codeSnippet: this.$aceEditor.getSelectedText(),
					contentType: "html/css",
					prompt,
					model
				}, {
					history: this.messageHistory,
					app: this.$state.data.appId
				});

				this.addUserMessage(prompt);
				this.showDots = true;
				try {
					response = await response;
				} catch (e) {
					this.notify("Error, request failed" + e.message, "danger", "exclamation-octagon");
					return;
				}

				this.showDots = false;

				if (response.success && response.result) {
					const value = response.result;

					this.addSystemMessage({ message: value.comment }, value);
					setTimeout(async () => {
						const sampleData = await this.getSampleData(dataName);
						if (document.querySelector("#template-model-is-array").checked) {
							const arrayProperty = dataName.split("__")[1];
							const data = {};
							data[arrayProperty] = [...sampleData];
							this.addSystemMessage({ 
								code: value.code, 
								preview: encodeURIComponent(this.executeHandlebars(value.code, { data }))
							});
						} else {
							this.addSystemMessage({ 
								code: value.code, 
								preview: encodeURIComponent(this.executeHandlebars(value.code, { data: (sampleData && (sampleData.length > 0)) ? sampleData[0] : {} }))
							});
						}
					}, 200);
				} else {
					this.notify("Error, could not complete request, response empty", "danger", "exclamation-octagon");
				}
			},

			addUserMessage: function (message) {
				this.assistantChat.unshift({
					from: 'user',
					message
				});
				this.messageHistory.push({
					role: 'user',
					message
				});
			},

			addSystemMessage: function (message, value) {
				this.assistantChat.unshift({
					from: 'ai', 
					...message
				});
				if (message.message && value) {
					this.messageHistory.push({ 
						role: "ai", 
						message: JSON.stringify(value)
					});
				}
			},

			insert: function (message) {
				this.$aceEditor.insert(message);
			},

            showSuggestion: function (str) {
				this.showRuntimeErrorHelp = true;
				var t = this;
				// nosemgrep: insecure-document-method
                t.$els.runtimehelp.innerHTML = sanitizeHtml.default(t.parseSuggestion(str));
                for (const el of t.$els.runtimehelp.querySelectorAll(".code")) {
                    var codeBlockLength = el.innerHTML.split("\n").length;
                    el.style.maxHeight = ((codeBlockLength) * 16)+"px";
                    var editor = window.ace.edit(el);
                    editor.session.setMode(el.getAttribute("ace-mode"));
                    editor.setOption("maxLines", (codeBlockLength > 15 ? 15 : codeBlockLength));
                    editor.resize(true);
                    editor.setReadOnly(true);
                    window.ed = editor;
                }
				this.$aceEditor.resize(true);
            },

            parseSuggestion: function(str) {
                return String(str)
                    .replace(/</g, "&lt;")
                    .replace(/>/g, "&gt;")
                    .replace(/^```([\S]*)\n([\s\S]*?)\n```$/gm, '<pre class="code suggestion-code" ace-mode="ace/mode/$1" ace-theme="ace/theme/chrome" style="margin-bottom: -20px;">$2</pre>')
                    .replace(/`([^`\n]+)`/gm, '<span class="snippet">$1</span>')
                    .replace(/\*([^\*\n]+)\*/gm, '<strong>$1</strong>')
            },

			getCodeSuggestion: function(editor, request, replaceRange) {
				var t = this;
				if (!this.waitingForSuggestion) {
					t.waitingForSuggestion = true;
					t.$state.pageManager.showLoadingIndicator(null,"Asking assistant...");
					BuilderAssistant.suggestCode({
						request: request
					}).then(function (reply) {
						t.waitingForSuggestion = false;
						t.$state.pageManager.hideLoadingIndicator();
						if (reply.status === "ok") {
							let code = reply.code;
							editor.session.replace(replaceRange, code);
						}
					}, function(error) {
						t.$state.pageManager.hideLoadingIndicator();
						t.waitingForSuggestion = false;
					});
				}
			},

			onKeyUpDelete: function() {
				if (this.value !== "") {
					this.$dispatch("code-editor-delete");
				}
			},

			_setMode: function(mode) {
				var session = this.$aceEditor.getSession();
				switch (this.mode) {
					case "javascript":
						session.setMode("ace/mode/javascript");
						break;
					case "text/html":
						session.setMode("ace/mode/html");
						break;
					case "text/json":
						session.setMode("ace/mode/json");
						mode = "application/json";
						break;
					case "text/xml":
						session.setMode("ace/mode/xml");
						break;
					case "text/plain":
						session.setMode("ace/mode/plain_text");
						break;
					case "css":
						session.setMode("ace/mode/css");
						break;
				}
			},

			// Returns an object of functions available on ActionContext.java or DeviceContext.java
			// Uses the blockly annotations to get the functions.
			_getServerSideContextFunctions: function(deviceContext) {
				var functions = [];
				var meta = JSON.parse(jsmeta);
				for (var i in meta) {
					var api = meta[i].api;
					var isContext = api.endsWith("Context");
					var isDeviceCtx = (api === "serversideDevice@Context");
					if (isContext) {
						if (deviceContext) {
							if (deviceContext === isDeviceCtx) {
								functions.push(meta[i]);
							}
						} else {
							var data = meta[i];
							var isServerSide = (data.api.indexOf('serverside') > -1);
							if (isServerSide && data.tags){
								var isValid = this.env.tags.some(function(tagItem){
									return (data.tags.indexOf(tagItem) >= 0);
								});
								if (isValid) {
									functions.push(data);
								}
							}
						}
					}
				}
				return functions;
			},

			_getServerSideClasses:function () {
				var classMetaData = {};
				var meta = JSON.parse(jsmeta);
				for (var i in meta) {
					var api = meta[i].api;
					var toAdd = meta[i];
					var array = api.split('@');
					var className = array[1];
					var isServerSideFunction = array[0].toLowerCase() === 'serverside';
					if (isServerSideFunction && className) {
						if (!classMetaData[className]) {
							classMetaData[className] = [];
						}
						classMetaData[className].push(toAdd);
					}
				}
				return classMetaData;
			},

			setValue: function(value) {
				if (this.$aceEditor) {
					this.$aceEditor.setValue(value, -1);
				}
			},

			getValue: function() {
				return this.$aceEditor ? this.$aceEditor.getValue() : null;
			},

			loadErrors: function() {
				const t = this;
				const editor = this.$aceEditor;
                window.e = editor;
                setTimeout(() => {
                    if (this.context && this.context.schema) {
                        const url = "/api/app/" + this.context.schema + "/log/?level=ERROR&entry_type=ACTION&entry_name=" + this.context.script;
                        client.sendRequest(url, {
                            method: 'GET'
                        }).then(function(errors) {
                            const annotations = editor.getSession().getAnnotations();
                            for (let i = 0; i < errors.length; i++) {
                                let error = errors[i];
                                annotations.push({
                                    row: parseInt(error.line) - 1,
                                    column: parseInt(error.column),
                                    text: "RUNTIME: " + error.message,
                                    type: 'error'
                                });
                            }
                            editor.getSession().setAnnotations(annotations);
                        });
                    }
                }, 500)
			},

			prepareDefs:function () {
				var supportedType = JSON.parse(appivoJson);
				var toReturn = ['jquery','ecma6'];

				var integrationDefs = this.prepareIntegrationDefs();
				var context = JSON.parse(autocompleteJson);

				if (this.isClientContext) {
					// promise class added
					context['!define'] = Vue.util.extend(context['!define'], supportedType['!define']);
					toReturn.push(context);
				} else {
					var functions = this._getServerSideContextFunctions(this.isDeviceContext);
					context.context = this.prepareServerDefs(functions, 'context');
					// promise and integration classes added
					context['!define'] = Vue.util.extend({}, integrationDefs['!define']);
					context['!define'] = Vue.util.extend(context['!define'], supportedType['!define']);
					var serverClasses = this._getServerSideClasses();
					for (var className in serverClasses) {
						var value = this.prepareServerDefs(serverClasses[className], className);
						value["!name"] = className;
						context["!define"][className] = value;
					}
					toReturn.push(context);
				}

				this.comments = this.getComments(context);
				toReturn = toReturn.concat(this.getParameters());

				return toReturn;
			},

			getComments: function(context) {
				var classes = {};
				classes["context"] = context["context"];
				classes = Object.assign(classes, context["!define"]);
				var otherComments = [];
				var contextComments = [];
				for (var classKey in classes) {
					var classItem = classes[classKey];
					for (var key in classItem) {
						var item = classItem[key];
						if (item['!type']) {
							var tabTrigger = item.functionName;
							var snippetContent = item.snippetContent;
							if (classKey === 'context') {
								tabTrigger = "context."+item.functionName;
								snippetContent = "context."+item.snippetContent;
								contextComments.push({
									tabTrigger: tabTrigger,
									snippetContent: snippetContent,
									functionName: item.functionName
								});
							} else {
								if (tabTrigger) {
									otherComments.push({
										tabTrigger: tabTrigger,
										snippetContent: snippetContent,
										functionName: item.functionName
									});
								}
							}
						}
					}
				}
				return otherComments.concat(contextComments);
			},

			getParameters: function() {
				var parameters = [];
				if (this.env.parameters && this.env.parameters.length > 0) {
					this.env.parameters.forEach(function (parameterItem) {
						var data = {
							"!name": parameterItem.name,
							"!define": {},
							"!doc": parameterItem.description
						};
						data[parameterItem.name] = {};
						if (parameterItem.properties && parameterItem.properties.length > 0) {
							parameterItem.properties.forEach(function (paramItem) {
								var name = paramItem.name;
								var type = paramItem.type;
								switch (type) {
									case 'Object':
										type = 'object';
										break;
									case 'String':
										type = 'string';
										break;
									case 'Number':
										type = 'number';
										break;
									case 'Boolean':
										type = 'bool';
										break;
								}
								data[parameterItem.name][name] = {
									"!doc": paramItem.desc,
									"!type": type
								}
							});
						}
						parameters.push(data);
					});
				}
				return parameters;
			},

			prepareServerDefs:function (functions, className) {
				var ac = {};
                //var docsBaseUrl = "https://docs.appivo.com/apis/server/";
				for (var i = 0; i < functions.length; i++) {
					var functionItem = functions[i];5
					var type = this.getFunctionTypeString(functionItem);
					var snippetContent = this.getFunctionSnippetContent(functionItem);

					var description = type;
					if (functionItem.description) {
						description = functionItem.description;
					}
					if (functionItem.descr) {
						description = functionItem.descr;
					}
                    var docUrl = "";
                    if (className) {
                        // commentout for timebeing
                        // docUrl = docsBaseUrl + className.toLowerCase() + "/#"+functionItem.functionname.toLowerCase();
                    }
					ac[functionItem.functionname] = {
						"!type": type,
						"!doc": description,
						"!url": docUrl,
						"functionName": functionItem.functionname,
						"snippetContent": snippetContent,
						"parameterSignature": functionItem.params
					};
				}
				return ac;
			},

			getFunctionTypeString: function(functionItem) {
				var paramString = this.getFunctionParamString(functionItem);
				var type = "fn("+paramString+")";
				if (functionItem.returntype) {
					switch (functionItem.returntype) {
						case 'String':
							functionItem.returntype = 'string';
							break;
						case 'Object':
							functionItem.returntype = 'object';
							break;
						case 'Integer':
						case 'int':
							functionItem.returntype = 'number';
							break;
						case 'Boolean':
						case 'boolean':
							functionItem.returntype = 'bool';
							break;
						case 'Array':
							functionItem.returntype = '[]';
							break;
						default:
					}
					type += " -> " + functionItem.returntype;
				}
				return type;
			},

			getFunctionParamString: function(functionItem) {
				var paramString = "";
				if (functionItem.params && functionItem.params.length > 0) {
					paramString = functionItem.params.map(function (item) {
						var type = item.type;
						if (type.indexOf(',') > -1) {
							type = type.split(",")[0]
						}

						switch (type) {
							case 'null':
								type = '?';
								break;
							case 'Object[]':
							case 'Object':
								type = 'obj';
								break;
							case 'String':
							case 'String/Dialog-ID':
							case 'String/Query-ID':
							case 'String/ConfigParam-ID':
							case 'String/View-ID':
							case 'String/ID':
							case 'String/Form-ID':
							case 'String/Data-TYPE':
							case 'String/Role-ID':
							case 'String/Model-ID':
							case 'String/Integration-ID':
							case 'String/Widget-ID':
							case 'String/Rule-ID':
							case 'String/Action-ID':
								type = 'string';
								break;
							case 'Boolean':
								type = 'bool';
								break;
							case 'Array':
								type = '[]';
								break;
							case 'Float':
								type = 'number';
								break;
							case 'Integer':
								type = 'number';
								break;
						}
						return item.name + ": " + type;
					}).join(", ");
				}
				return paramString;
			},

			getFunctionSnippetContent: function(functionItem) {
				var snippetIndex = 0;
				var snippetContent = "";
				if (functionItem.params) {
					snippetIndex = 0;
					snippetContent = functionItem.params.map(function (paramItem) {
						snippetIndex++;
						paramItem.name = paramItem.name.trim();
						paramItem.type = paramItem.type.trim();
						if (paramItem.type.indexOf('String/') !== -1) {
							return '"${'+(snippetIndex)+':'+paramItem.type+ '}"';
						} else if (paramItem.type === 'Map') {
							if (functionItem.objecttypeoverride) {
								var paramMetaData = functionItem.objecttypeoverride[paramItem.name];
								var objectKeys = [];
								for (var attribute in paramMetaData) {
									var mapItemType = paramMetaData[attribute];
									if (mapItemType.indexOf('String/') !== -1) {
										objectKeys.push("\n\t'"+attribute+"' : '${"+(snippetIndex)+":"+mapItemType+"}'");
									} else {
										switch (mapItemType) {
											case "String":
												objectKeys.push("\n\t'"+attribute+"' : '${"+(snippetIndex)+":string}'");
												break;
											case "Object":
												objectKeys.push("\n\t'"+attribute+"' : ${"+(snippetIndex)+": {}}");
												break;
											case "Array":
												objectKeys.push("\n\t'"+attribute+"' : ${"+(snippetIndex)+": {}}");
												break;
											default:
												objectKeys.push("\n\t'"+attribute+"' : ${"+(snippetIndex)+": '"+ mapItemType +"'}");
										}
									}
									snippetIndex ++;
								}

								var value = objectKeys.join(", ");
								if (objectKeys.length > 1) {
									return "{"+value+"\n}";
								} else {
									return "${"+(snippetIndex) +":{"+value+"}\n}";
								}
							} else {
								return "${"+(snippetIndex) +":"+ paramItem.name +"}";
							}
						} else {
							// all unknown types
							return "${"+(snippetIndex) +":"+ paramItem.name +"}";
						}

					}).join(", ");
				}
				return functionItem.functionname + "("+snippetContent+");";
			},

			prepareIntegrationDefs: function () {
				var t = this;
				var context = {
					"!define": {}
				};
				if (this.$state.data.app && this.$state.data.app.integrations) {
					this.$state.data.app.integrations.forEach(function (integrationItem) {
						var name = integrationItem.name
						var value = {};
						if (integrationItem.integration.data && integrationItem.integration.data.functions) {
							var integrationFunctions = integrationItem.integration.data.functions;

							integrationFunctions.forEach(function (functionItem) {
								functionItem.params = functionItem.arguments;
								if (!functionItem.params) {
									functionItem.params = functionItem.args;
								}
								functionItem.params.forEach(function (argumentItem) {
									argumentItem.description = argumentItem.description ? argumentItem.description : "";
								});
								functionItem.functionname = functionItem.name;
								functionItem.returntype = "Promise[:t=" + functionItem.returnType + "]";
							});
							value = t.prepareServerDefs(integrationFunctions);
						}
						value["!name"] = name;
						context["!define"][name] = value;
					});
				}
				return context;
			}
		}
	});
});

},
'appivo/util/BuilderAssistant':function(){
define([
    "appivo/client/Client"
], function(Client) {
    const client = Client.getInstance();
    const baseURL = "/api/service/ai-buildtime/";

    function execute(func, input) {
        const t = this;
        const args = [input];
        return client.sendRequest(baseURL + func, {
            method: 'POST',
            contentType: 'application/json',
            data: args
        });
    };

    return {

        suggestCode: function(input) {
            return execute('suggestCode', input);
        },

        explainBug: function(input) {
            return execute('explainBug', input)

        }
    };

    return BuildtimeAssistant;
});
},
'highlight/highlight':function(){
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
  Highlight.js v11.9.0 (git: b7ec4bfafc)
  (c) 2006-2023 undefined and other contributors
  License: BSD-3-Clause
 */
define([], function () {
  var hljs = function () {
    'use strict';

    /* eslint-disable no-multi-assign */

    function deepFreeze(obj) {
      if (obj instanceof Map) {
        obj.clear = obj.delete = obj.set = function () {
          throw new Error('map is read-only');
        };
      } else if (obj instanceof Set) {
        obj.add = obj.clear = obj.delete = function () {
          throw new Error('set is read-only');
        };
      }

      // Freeze self
      Object.freeze(obj);

      Object.getOwnPropertyNames(obj).forEach(function (name) {
        var prop = obj[name];
        var type = typeof prop === 'undefined' ? 'undefined' : _typeof(prop);

        // Freeze prop if it is an object or function and also not already frozen
        if ((type === 'object' || type === 'function') && !Object.isFrozen(prop)) {
          deepFreeze(prop);
        }
      });

      return obj;
    }

    /** @typedef {import('highlight.js').CallbackResponse} CallbackResponse */
    /** @typedef {import('highlight.js').CompiledMode} CompiledMode */
    /** @implements CallbackResponse */

    var Response = function () {
      /**
       * @param {CompiledMode} mode
       */
      function Response(mode) {
        _classCallCheck(this, Response);

        // eslint-disable-next-line no-undefined
        if (mode.data === undefined) mode.data = {};

        this.data = mode.data;
        this.isMatchIgnored = false;
      }

      _createClass(Response, [{
        key: 'ignoreMatch',
        value: function ignoreMatch() {
          this.isMatchIgnored = true;
        }
      }]);

      return Response;
    }();

    /**
     * @param {string} value
     * @returns {string}
     */


    function escapeHTML(value) {
      return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;');
    }

    /**
     * performs a shallow merge of multiple objects into one
     *
     * @template T
     * @param {T} original
     * @param {Record<string,any>[]} objects
     * @returns {T} a single new object
     */
    function inherit$1(original) {
      /** @type Record<string,any> */
      var result = Object.create(null);

      for (var key in original) {
        result[key] = original[key];
      }

      for (var _len = arguments.length, objects = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        objects[_key - 1] = arguments[_key];
      }

      objects.forEach(function (obj) {
        for (var _key2 in obj) {
          result[_key2] = obj[_key2];
        }
      });
      return (/** @type {T} */result
      );
    }

    /**
     * @typedef {object} Renderer
     * @property {(text: string) => void} addText
     * @property {(node: Node) => void} openNode
     * @property {(node: Node) => void} closeNode
     * @property {() => string} value
     */

    /** @typedef {{scope?: string, language?: string, sublanguage?: boolean}} Node */
    /** @typedef {{walk: (r: Renderer) => void}} Tree */
    /** */

    var SPAN_CLOSE = '</span>';

    /**
     * Determines if a node needs to be wrapped in <span>
     *
     * @param {Node} node */
    var emitsWrappingTags = function emitsWrappingTags(node) {
      // rarely we can have a sublanguage where language is undefined
      // TODO: track down why
      return !!node.scope;
    };

    /**
     *
     * @param {string} name
     * @param {{prefix:string}} options
     */
    var scopeToCSSClass = function scopeToCSSClass(name, _ref) {
      var prefix = _ref.prefix;

      // sub-language
      if (name.startsWith("language:")) {
        return name.replace("language:", "language-");
      }
      // tiered scope: comment.line
      if (name.includes(".")) {
        var pieces = name.split(".");
        return ['' + prefix + pieces.shift()].concat(_toConsumableArray(pieces.map(function (x, i) {
          return '' + x + "_".repeat(i + 1);
        }))).join(" ");
      }
      // simple scope
      return '' + prefix + name;
    };

    /** @type {Renderer} */

    var HTMLRenderer = function () {
      /**
       * Creates a new HTMLRenderer
       *
       * @param {Tree} parseTree - the parse tree (must support `walk` API)
       * @param {{classPrefix: string}} options
       */
      function HTMLRenderer(parseTree, options) {
        _classCallCheck(this, HTMLRenderer);

        this.buffer = "";
        this.classPrefix = options.classPrefix;
        parseTree.walk(this);
      }

      /**
       * Adds texts to the output stream
       *
       * @param {string} text */


      _createClass(HTMLRenderer, [{
        key: 'addText',
        value: function addText(text) {
          this.buffer += escapeHTML(text);
        }

        /**
         * Adds a node open to the output stream (if needed)
         *
         * @param {Node} node */

      }, {
        key: 'openNode',
        value: function openNode(node) {
          if (!emitsWrappingTags(node)) return;

          var className = scopeToCSSClass(node.scope, { prefix: this.classPrefix });
          this.span(className);
        }

        /**
         * Adds a node close to the output stream (if needed)
         *
         * @param {Node} node */

      }, {
        key: 'closeNode',
        value: function closeNode(node) {
          if (!emitsWrappingTags(node)) return;

          this.buffer += SPAN_CLOSE;
        }

        /**
         * returns the accumulated buffer
        */

      }, {
        key: 'value',
        value: function value() {
          return this.buffer;
        }

        // helpers

        /**
         * Builds a span element
         *
         * @param {string} className */

      }, {
        key: 'span',
        value: function span(className) {
          this.buffer += '<span class="' + className + '">';
        }
      }]);

      return HTMLRenderer;
    }();

    /** @typedef {{scope?: string, language?: string, children: Node[]} | string} Node */
    /** @typedef {{scope?: string, language?: string, children: Node[]} } DataNode */
    /** @typedef {import('highlight.js').Emitter} Emitter */
    /**  */

    /** @returns {DataNode} */


    var newNode = function newNode() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      /** @type DataNode */
      var result = { children: [] };
      Object.assign(result, opts);
      return result;
    };

    var TokenTree = function () {
      function TokenTree() {
        _classCallCheck(this, TokenTree);

        /** @type DataNode */
        this.rootNode = newNode();
        this.stack = [this.rootNode];
      }

      _createClass(TokenTree, [{
        key: 'add',


        /** @param {Node} node */
        value: function add(node) {
          this.top.children.push(node);
        }

        /** @param {string} scope */

      }, {
        key: 'openNode',
        value: function openNode(scope) {
          /** @type Node */
          var node = newNode({ scope: scope });
          this.add(node);
          this.stack.push(node);
        }
      }, {
        key: 'closeNode',
        value: function closeNode() {
          if (this.stack.length > 1) {
            return this.stack.pop();
          }
          // eslint-disable-next-line no-undefined
          return undefined;
        }
      }, {
        key: 'closeAllNodes',
        value: function closeAllNodes() {
          while (this.closeNode()) {}
        }
      }, {
        key: 'toJSON',
        value: function toJSON() {
          return JSON.stringify(this.rootNode, null, 4);
        }

        /**
         * @typedef { import("./html_renderer").Renderer } Renderer
         * @param {Renderer} builder
         */

      }, {
        key: 'walk',
        value: function walk(builder) {
          // this does not
          return this.constructor._walk(builder, this.rootNode);
          // this works
          // return TokenTree._walk(builder, this.rootNode);
        }

        /**
         * @param {Renderer} builder
         * @param {Node} node
         */

      }, {
        key: 'top',
        get: function get() {
          return this.stack[this.stack.length - 1];
        }
      }, {
        key: 'root',
        get: function get() {
          return this.rootNode;
        }
      }], [{
        key: '_walk',
        value: function _walk(builder, node) {
          var _this = this;

          if (typeof node === "string") {
            builder.addText(node);
          } else if (node.children) {
            builder.openNode(node);
            node.children.forEach(function (child) {
              return _this._walk(builder, child);
            });
            builder.closeNode(node);
          }
          return builder;
        }

        /**
         * @param {Node} node
         */

      }, {
        key: '_collapse',
        value: function _collapse(node) {
          if (typeof node === "string") return;
          if (!node.children) return;

          if (node.children.every(function (el) {
            return typeof el === "string";
          })) {
            // node.text = node.children.join("");
            // delete node.children;
            node.children = [node.children.join("")];
          } else {
            node.children.forEach(function (child) {
              TokenTree._collapse(child);
            });
          }
        }
      }]);

      return TokenTree;
    }();

    /**
      Currently this is all private API, but this is the minimal API necessary
      that an Emitter must implement to fully support the parser.
       Minimal interface:
       - addText(text)
      - __addSublanguage(emitter, subLanguageName)
      - startScope(scope)
      - endScope()
      - finalize()
      - toHTML()
     */

    /**
     * @implements {Emitter}
     */


    var TokenTreeEmitter = function (_TokenTree) {
      _inherits(TokenTreeEmitter, _TokenTree);

      /**
       * @param {*} options
       */
      function TokenTreeEmitter(options) {
        _classCallCheck(this, TokenTreeEmitter);

        var _this2 = _possibleConstructorReturn(this, (TokenTreeEmitter.__proto__ || Object.getPrototypeOf(TokenTreeEmitter)).call(this));

        _this2.options = options;
        return _this2;
      }

      /**
       * @param {string} text
       */


      _createClass(TokenTreeEmitter, [{
        key: 'addText',
        value: function addText(text) {
          if (text === "") {
            return;
          }

          this.add(text);
        }

        /** @param {string} scope */

      }, {
        key: 'startScope',
        value: function startScope(scope) {
          this.openNode(scope);
        }
      }, {
        key: 'endScope',
        value: function endScope() {
          this.closeNode();
        }

        /**
         * @param {Emitter & {root: DataNode}} emitter
         * @param {string} name
         */

      }, {
        key: '__addSublanguage',
        value: function __addSublanguage(emitter, name) {
          /** @type DataNode */
          var node = emitter.root;
          if (name) node.scope = 'language:' + name;

          this.add(node);
        }
      }, {
        key: 'toHTML',
        value: function toHTML() {
          var renderer = new HTMLRenderer(this, this.options);
          return renderer.value();
        }
      }, {
        key: 'finalize',
        value: function finalize() {
          this.closeAllNodes();
          return true;
        }
      }]);

      return TokenTreeEmitter;
    }(TokenTree);

    /**
     * @param {string} value
     * @returns {RegExp}
     * */

    /**
     * @param {RegExp | string } re
     * @returns {string}
     */


    function source(re) {
      if (!re) return null;
      if (typeof re === "string") return re;

      return re.source;
    }

    /**
     * @param {RegExp | string } re
     * @returns {string}
     */
    function lookahead(re) {
      return concat('(?=', re, ')');
    }

    /**
     * @param {RegExp | string } re
     * @returns {string}
     */
    function anyNumberOfTimes(re) {
      return concat('(?:', re, ')*');
    }

    /**
     * @param {RegExp | string } re
     * @returns {string}
     */
    function optional(re) {
      return concat('(?:', re, ')?');
    }

    /**
     * @param {...(RegExp | string) } args
     * @returns {string}
     */
    function concat() {
      for (var _len2 = arguments.length, args = Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
        args[_key3] = arguments[_key3];
      }

      var joined = args.map(function (x) {
        return source(x);
      }).join("");
      return joined;
    }

    /**
     * @param { Array<string | RegExp | Object> } args
     * @returns {object}
     */
    function stripOptionsFromArgs(args) {
      var opts = args[args.length - 1];

      if ((typeof opts === 'undefined' ? 'undefined' : _typeof(opts)) === 'object' && opts.constructor === Object) {
        args.splice(args.length - 1, 1);
        return opts;
      } else {
        return {};
      }
    }

    /** @typedef { {capture?: boolean} } RegexEitherOptions */

    /**
     * Any of the passed expresssions may match
     *
     * Creates a huge this | this | that | that match
     * @param {(RegExp | string)[] | [...(RegExp | string)[], RegexEitherOptions]} args
     * @returns {string}
     */
    function either() {
      for (var _len3 = arguments.length, args = Array(_len3), _key4 = 0; _key4 < _len3; _key4++) {
        args[_key4] = arguments[_key4];
      }

      /** @type { object & {capture?: boolean} }  */
      var opts = stripOptionsFromArgs(args);
      var joined = '(' + (opts.capture ? "" : "?:") + args.map(function (x) {
        return source(x);
      }).join("|") + ")";
      return joined;
    }

    /**
     * @param {RegExp | string} re
     * @returns {number}
     */
    function countMatchGroups(re) {
      return new RegExp(re.toString() + '|').exec('').length - 1;
    }

    /**
     * Does lexeme start with a regular expression match at the beginning
     * @param {RegExp} re
     * @param {string} lexeme
     */
    function startsWith(re, lexeme) {
      var match = re && re.exec(lexeme);
      return match && match.index === 0;
    }

    // BACKREF_RE matches an open parenthesis or backreference. To avoid
    // an incorrect parse, it additionally matches the following:
    // - [...] elements, where the meaning of parentheses and escapes change
    // - other escape sequences, so we do not misparse escape sequences as
    //   interesting elements
    // - non-matching or lookahead parentheses, which do not capture. These
    //   follow the '(' with a '?'.
    var BACKREF_RE = /\[(?:[^\\\]]|\\.)*\]|\(\??|\\([1-9][0-9]*)|\\./;

    // **INTERNAL** Not intended for outside usage
    // join logically computes regexps.join(separator), but fixes the
    // backreferences so they continue to match.
    // it also places each individual regular expression into it's own
    // match group, keeping track of the sequencing of those match groups
    // is currently an exercise for the caller. :-)
    /**
     * @param {(string | RegExp)[]} regexps
     * @param {{joinWith: string}} opts
     * @returns {string}
     */
    function _rewriteBackreferences(regexps, _ref2) {
      var joinWith = _ref2.joinWith;

      var numCaptures = 0;

      return regexps.map(function (regex) {
        numCaptures += 1;
        var offset = numCaptures;
        var re = source(regex);
        var out = '';

        while (re.length > 0) {
          var match = BACKREF_RE.exec(re);
          if (!match) {
            out += re;
            break;
          }
          out += re.substring(0, match.index);
          re = re.substring(match.index + match[0].length);
          if (match[0][0] === '\\' && match[1]) {
            // Adjust the backreference.
            out += '\\' + String(Number(match[1]) + offset);
          } else {
            out += match[0];
            if (match[0] === '(') {
              numCaptures++;
            }
          }
        }
        return out;
      }).map(function (re) {
        return '(' + re + ')';
      }).join(joinWith);
    }

    /** @typedef {import('highlight.js').Mode} Mode */
    /** @typedef {import('highlight.js').ModeCallback} ModeCallback */

    // Common regexps
    var MATCH_NOTHING_RE = /\b\B/;
    var IDENT_RE = '[a-zA-Z]\\w*';
    var UNDERSCORE_IDENT_RE = '[a-zA-Z_]\\w*';
    var NUMBER_RE = '\\b\\d+(\\.\\d+)?';
    var C_NUMBER_RE = '(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)'; // 0x..., 0..., decimal, float
    var BINARY_NUMBER_RE = '\\b(0b[01]+)'; // 0b...
    var RE_STARTERS_RE = '!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~';

    /**
    * @param { Partial<Mode> & {binary?: string | RegExp} } opts
    */
    var SHEBANG = function SHEBANG() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var beginShebang = /^#![ ]*\//;
      if (opts.binary) {
        opts.begin = concat(beginShebang, /.*\b/, opts.binary, /\b.*/);
      }
      return inherit$1({
        scope: 'meta',
        begin: beginShebang,
        end: /$/,
        relevance: 0,
        /** @type {ModeCallback} */
        "on:begin": function onBegin(m, resp) {
          if (m.index !== 0) resp.ignoreMatch();
        }
      }, opts);
    };

    // Common modes
    var BACKSLASH_ESCAPE = {
      begin: '\\\\[\\s\\S]', relevance: 0
    };
    var APOS_STRING_MODE = {
      scope: 'string',
      begin: '\'',
      end: '\'',
      illegal: '\\n',
      contains: [BACKSLASH_ESCAPE]
    };
    var QUOTE_STRING_MODE = {
      scope: 'string',
      begin: '"',
      end: '"',
      illegal: '\\n',
      contains: [BACKSLASH_ESCAPE]
    };
    var PHRASAL_WORDS_MODE = {
      begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/
    };
    /**
     * Creates a comment mode
     *
     * @param {string | RegExp} begin
     * @param {string | RegExp} end
     * @param {Mode | {}} [modeOptions]
     * @returns {Partial<Mode>}
     */
    var COMMENT = function COMMENT(begin, end) {
      var modeOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var mode = inherit$1({
        scope: 'comment',
        begin: begin,
        end: end,
        contains: []
      }, modeOptions);
      mode.contains.push({
        scope: 'doctag',
        // hack to avoid the space from being included. the space is necessary to
        // match here to prevent the plain text rule below from gobbling up doctags
        begin: '[ ]*(?=(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):)',
        end: /(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):/,
        excludeBegin: true,
        relevance: 0
      });
      var ENGLISH_WORD = either(
      // list of common 1 and 2 letter words in English
      "I", "a", "is", "so", "us", "to", "at", "if", "in", "it", "on",
      // note: this is not an exhaustive list of contractions, just popular ones
      /[A-Za-z]+['](d|ve|re|ll|t|s|n)/, // contractions - can't we'd they're let's, etc
      /[A-Za-z]+[-][a-z]+/, // `no-way`, etc.
      /[A-Za-z][a-z]{2,}/ // allow capitalized words at beginning of sentences
      );
      // looking like plain text, more likely to be a comment
      mode.contains.push({
        // TODO: how to include ", (, ) without breaking grammars that use these for
        // comment delimiters?
        // begin: /[ ]+([()"]?([A-Za-z'-]{3,}|is|a|I|so|us|[tT][oO]|at|if|in|it|on)[.]?[()":]?([.][ ]|[ ]|\))){3}/
        // ---

        // this tries to find sequences of 3 english words in a row (without any
        // "programming" type syntax) this gives us a strong signal that we've
        // TRULY found a comment - vs perhaps scanning with the wrong language.
        // It's possible to find something that LOOKS like the start of the
        // comment - but then if there is no readable text - good chance it is a
        // false match and not a comment.
        //
        // for a visual example please see:
        // https://github.com/highlightjs/highlight.js/issues/2827

        begin: concat(/[ ]+/, // necessary to prevent us gobbling up doctags like /* @author Bob Mcgill */
        '(', ENGLISH_WORD, /[.]?[:]?([.][ ]|[ ])/, '){3}') // look for 3 words in a row
      });
      return mode;
    };
    var C_LINE_COMMENT_MODE = COMMENT('//', '$');
    var C_BLOCK_COMMENT_MODE = COMMENT('/\\*', '\\*/');
    var HASH_COMMENT_MODE = COMMENT('#', '$');
    var NUMBER_MODE = {
      scope: 'number',
      begin: NUMBER_RE,
      relevance: 0
    };
    var C_NUMBER_MODE = {
      scope: 'number',
      begin: C_NUMBER_RE,
      relevance: 0
    };
    var BINARY_NUMBER_MODE = {
      scope: 'number',
      begin: BINARY_NUMBER_RE,
      relevance: 0
    };
    var REGEXP_MODE = {
      scope: "regexp",
      begin: /\/(?=[^/\n]*\/)/,
      end: /\/[gimuy]*/,
      contains: [BACKSLASH_ESCAPE, {
        begin: /\[/,
        end: /\]/,
        relevance: 0,
        contains: [BACKSLASH_ESCAPE]
      }]
    };
    var TITLE_MODE = {
      scope: 'title',
      begin: IDENT_RE,
      relevance: 0
    };
    var UNDERSCORE_TITLE_MODE = {
      scope: 'title',
      begin: UNDERSCORE_IDENT_RE,
      relevance: 0
    };
    var METHOD_GUARD = {
      // excludes method names from keyword processing
      begin: '\\.\\s*' + UNDERSCORE_IDENT_RE,
      relevance: 0
    };

    /**
     * Adds end same as begin mechanics to a mode
     *
     * Your mode must include at least a single () match group as that first match
     * group is what is used for comparison
     * @param {Partial<Mode>} mode
     */
    var END_SAME_AS_BEGIN = function END_SAME_AS_BEGIN(mode) {
      return Object.assign(mode, {
        /** @type {ModeCallback} */
        'on:begin': function onBegin(m, resp) {
          resp.data._beginMatch = m[1];
        },
        /** @type {ModeCallback} */
        'on:end': function onEnd(m, resp) {
          if (resp.data._beginMatch !== m[1]) resp.ignoreMatch();
        }
      });
    };

    var MODES = /*#__PURE__*/Object.freeze({
      __proto__: null,
      APOS_STRING_MODE: APOS_STRING_MODE,
      BACKSLASH_ESCAPE: BACKSLASH_ESCAPE,
      BINARY_NUMBER_MODE: BINARY_NUMBER_MODE,
      BINARY_NUMBER_RE: BINARY_NUMBER_RE,
      COMMENT: COMMENT,
      C_BLOCK_COMMENT_MODE: C_BLOCK_COMMENT_MODE,
      C_LINE_COMMENT_MODE: C_LINE_COMMENT_MODE,
      C_NUMBER_MODE: C_NUMBER_MODE,
      C_NUMBER_RE: C_NUMBER_RE,
      END_SAME_AS_BEGIN: END_SAME_AS_BEGIN,
      HASH_COMMENT_MODE: HASH_COMMENT_MODE,
      IDENT_RE: IDENT_RE,
      MATCH_NOTHING_RE: MATCH_NOTHING_RE,
      METHOD_GUARD: METHOD_GUARD,
      NUMBER_MODE: NUMBER_MODE,
      NUMBER_RE: NUMBER_RE,
      PHRASAL_WORDS_MODE: PHRASAL_WORDS_MODE,
      QUOTE_STRING_MODE: QUOTE_STRING_MODE,
      REGEXP_MODE: REGEXP_MODE,
      RE_STARTERS_RE: RE_STARTERS_RE,
      SHEBANG: SHEBANG,
      TITLE_MODE: TITLE_MODE,
      UNDERSCORE_IDENT_RE: UNDERSCORE_IDENT_RE,
      UNDERSCORE_TITLE_MODE: UNDERSCORE_TITLE_MODE
    });

    /**
    @typedef {import('highlight.js').CallbackResponse} CallbackResponse
    @typedef {import('highlight.js').CompilerExt} CompilerExt
    */

    // Grammar extensions / plugins
    // See: https://github.com/highlightjs/highlight.js/issues/2833

    // Grammar extensions allow "syntactic sugar" to be added to the grammar modes
    // without requiring any underlying changes to the compiler internals.

    // `compileMatch` being the perfect small example of now allowing a grammar
    // author to write `match` when they desire to match a single expression rather
    // than being forced to use `begin`.  The extension then just moves `match` into
    // `begin` when it runs.  Ie, no features have been added, but we've just made
    // the experience of writing (and reading grammars) a little bit nicer.

    // ------

    // TODO: We need negative look-behind support to do this properly
    /**
     * Skip a match if it has a preceding dot
     *
     * This is used for `beginKeywords` to prevent matching expressions such as
     * `bob.keyword.do()`. The mode compiler automatically wires this up as a
     * special _internal_ 'on:begin' callback for modes with `beginKeywords`
     * @param {RegExpMatchArray} match
     * @param {CallbackResponse} response
     */
    function skipIfHasPrecedingDot(match, response) {
      var before = match.input[match.index - 1];
      if (before === ".") {
        response.ignoreMatch();
      }
    }

    /**
     *
     * @type {CompilerExt}
     */
    function scopeClassName(mode, _parent) {
      // eslint-disable-next-line no-undefined
      if (mode.className !== undefined) {
        mode.scope = mode.className;
        delete mode.className;
      }
    }

    /**
     * `beginKeywords` syntactic sugar
     * @type {CompilerExt}
     */
    function beginKeywords(mode, parent) {
      if (!parent) return;
      if (!mode.beginKeywords) return;

      // for languages with keywords that include non-word characters checking for
      // a word boundary is not sufficient, so instead we check for a word boundary
      // or whitespace - this does no harm in any case since our keyword engine
      // doesn't allow spaces in keywords anyways and we still check for the boundary
      // first
      mode.begin = '\\b(' + mode.beginKeywords.split(' ').join('|') + ')(?!\\.)(?=\\b|\\s)';
      mode.__beforeBegin = skipIfHasPrecedingDot;
      mode.keywords = mode.keywords || mode.beginKeywords;
      delete mode.beginKeywords;

      // prevents double relevance, the keywords themselves provide
      // relevance, the mode doesn't need to double it
      // eslint-disable-next-line no-undefined
      if (mode.relevance === undefined) mode.relevance = 0;
    }

    /**
     * Allow `illegal` to contain an array of illegal values
     * @type {CompilerExt}
     */
    function compileIllegal(mode, _parent) {
      if (!Array.isArray(mode.illegal)) return;

      mode.illegal = either.apply(undefined, _toConsumableArray(mode.illegal));
    }

    /**
     * `match` to match a single expression for readability
     * @type {CompilerExt}
     */
    function compileMatch(mode, _parent) {
      if (!mode.match) return;
      if (mode.begin || mode.end) throw new Error("begin & end are not supported with match");

      mode.begin = mode.match;
      delete mode.match;
    }

    /**
     * provides the default 1 relevance to all modes
     * @type {CompilerExt}
     */
    function compileRelevance(mode, _parent) {
      // eslint-disable-next-line no-undefined
      if (mode.relevance === undefined) mode.relevance = 1;
    }

    // allow beforeMatch to act as a "qualifier" for the match
    // the full match begin must be [beforeMatch][begin]
    var beforeMatchExt = function beforeMatchExt(mode, parent) {
      if (!mode.beforeMatch) return;
      // starts conflicts with endsParent which we need to make sure the child
      // rule is not matched multiple times
      if (mode.starts) throw new Error("beforeMatch cannot be used with starts");

      var originalMode = Object.assign({}, mode);
      Object.keys(mode).forEach(function (key) {
        delete mode[key];
      });

      mode.keywords = originalMode.keywords;
      mode.begin = concat(originalMode.beforeMatch, lookahead(originalMode.begin));
      mode.starts = {
        relevance: 0,
        contains: [Object.assign(originalMode, { endsParent: true })]
      };
      mode.relevance = 0;

      delete originalMode.beforeMatch;
    };

    // keywords that should have no default relevance value
    var COMMON_KEYWORDS = ['of', 'and', 'for', 'in', 'not', 'or', 'if', 'then', 'parent', // common variable name
    'list', // common variable name
    'value' // common variable name
    ];

    var DEFAULT_KEYWORD_SCOPE = "keyword";

    /**
     * Given raw keywords from a language definition, compile them.
     *
     * @param {string | Record<string,string|string[]> | Array<string>} rawKeywords
     * @param {boolean} caseInsensitive
     */
    function compileKeywords(rawKeywords, caseInsensitive) {
      var scopeName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_KEYWORD_SCOPE;

      /** @type {import("highlight.js/private").KeywordDict} */
      var compiledKeywords = Object.create(null);

      // input can be a string of keywords, an array of keywords, or a object with
      // named keys representing scopeName (which can then point to a string or array)
      if (typeof rawKeywords === 'string') {
        compileList(scopeName, rawKeywords.split(" "));
      } else if (Array.isArray(rawKeywords)) {
        compileList(scopeName, rawKeywords);
      } else {
        Object.keys(rawKeywords).forEach(function (scopeName) {
          // collapse all our objects back into the parent object
          Object.assign(compiledKeywords, compileKeywords(rawKeywords[scopeName], caseInsensitive, scopeName));
        });
      }
      return compiledKeywords;

      // ---

      /**
       * Compiles an individual list of keywords
       *
       * Ex: "for if when while|5"
       *
       * @param {string} scopeName
       * @param {Array<string>} keywordList
       */
      function compileList(scopeName, keywordList) {
        if (caseInsensitive) {
          keywordList = keywordList.map(function (x) {
            return x.toLowerCase();
          });
        }
        keywordList.forEach(function (keyword) {
          var pair = keyword.split('|');
          compiledKeywords[pair[0]] = [scopeName, scoreForKeyword(pair[0], pair[1])];
        });
      }
    }

    /**
     * Returns the proper score for a given keyword
     *
     * Also takes into account comment keywords, which will be scored 0 UNLESS
     * another score has been manually assigned.
     * @param {string} keyword
     * @param {string} [providedScore]
     */
    function scoreForKeyword(keyword, providedScore) {
      // manual scores always win over common keywords
      // so you can force a score of 1 if you really insist
      if (providedScore) {
        return Number(providedScore);
      }

      return commonKeyword(keyword) ? 0 : 1;
    }

    /**
     * Determines if a given keyword is common or not
     *
     * @param {string} keyword */
    function commonKeyword(keyword) {
      return COMMON_KEYWORDS.includes(keyword.toLowerCase());
    }

    /*
     For the reasoning behind this please see:
    https://github.com/highlightjs/highlight.js/issues/2880#issuecomment-747275419
     */

    /**
     * @type {Record<string, boolean>}
     */
    var seenDeprecations = {};

    /**
     * @param {string} message
     */
    var error = function error(message) {
      console.error(message);
    };

    /**
     * @param {string} message
     * @param {any} args
     */
    var warn = function warn(message) {
      var _console;

      for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key5 = 1; _key5 < _len4; _key5++) {
        args[_key5 - 1] = arguments[_key5];
      }

      (_console = console).log.apply(_console, ['WARN: ' + message].concat(args));
    };

    /**
     * @param {string} version
     * @param {string} message
     */
    var deprecated = function deprecated(version, message) {
      if (seenDeprecations[version + '/' + message]) return;

      console.log('Deprecated as of ' + version + '. ' + message);
      seenDeprecations[version + '/' + message] = true;
    };

    /* eslint-disable no-throw-literal */

    /**
    @typedef {import('highlight.js').CompiledMode} CompiledMode
    */

    var MultiClassError = new Error();

    /**
     * Renumbers labeled scope names to account for additional inner match
     * groups that otherwise would break everything.
     *
     * Lets say we 3 match scopes:
     *
     *   { 1 => ..., 2 => ..., 3 => ... }
     *
     * So what we need is a clean match like this:
     *
     *   (a)(b)(c) => [ "a", "b", "c" ]
     *
     * But this falls apart with inner match groups:
     *
     * (a)(((b)))(c) => ["a", "b", "b", "b", "c" ]
     *
     * Our scopes are now "out of alignment" and we're repeating `b` 3 times.
     * What needs to happen is the numbers are remapped:
     *
     *   { 1 => ..., 2 => ..., 5 => ... }
     *
     * We also need to know that the ONLY groups that should be output
     * are 1, 2, and 5.  This function handles this behavior.
     *
     * @param {CompiledMode} mode
     * @param {Array<RegExp | string>} regexes
     * @param {{key: "beginScope"|"endScope"}} opts
     */
    function remapScopeNames(mode, regexes, _ref3) {
      var key = _ref3.key;

      var offset = 0;
      var scopeNames = mode[key];
      /** @type Record<number,boolean> */
      var emit = {};
      /** @type Record<number,string> */
      var positions = {};

      for (var i = 1; i <= regexes.length; i++) {
        positions[i + offset] = scopeNames[i];
        emit[i + offset] = true;
        offset += countMatchGroups(regexes[i - 1]);
      }
      // we use _emit to keep track of which match groups are "top-level" to avoid double
      // output from inside match groups
      mode[key] = positions;
      mode[key]._emit = emit;
      mode[key]._multi = true;
    }

    /**
     * @param {CompiledMode} mode
     */
    function beginMultiClass(mode) {
      if (!Array.isArray(mode.begin)) return;

      if (mode.skip || mode.excludeBegin || mode.returnBegin) {
        error("skip, excludeBegin, returnBegin not compatible with beginScope: {}");
        throw MultiClassError;
      }

      if (_typeof(mode.beginScope) !== "object" || mode.beginScope === null) {
        error("beginScope must be object");
        throw MultiClassError;
      }

      remapScopeNames(mode, mode.begin, { key: "beginScope" });
      mode.begin = _rewriteBackreferences(mode.begin, { joinWith: "" });
    }

    /**
     * @param {CompiledMode} mode
     */
    function endMultiClass(mode) {
      if (!Array.isArray(mode.end)) return;

      if (mode.skip || mode.excludeEnd || mode.returnEnd) {
        error("skip, excludeEnd, returnEnd not compatible with endScope: {}");
        throw MultiClassError;
      }

      if (_typeof(mode.endScope) !== "object" || mode.endScope === null) {
        error("endScope must be object");
        throw MultiClassError;
      }

      remapScopeNames(mode, mode.end, { key: "endScope" });
      mode.end = _rewriteBackreferences(mode.end, { joinWith: "" });
    }

    /**
     * this exists only to allow `scope: {}` to be used beside `match:`
     * Otherwise `beginScope` would necessary and that would look weird
       {
        match: [ /def/, /\w+/ ]
        scope: { 1: "keyword" , 2: "title" }
      }
      * @param {CompiledMode} mode
     */
    function scopeSugar(mode) {
      if (mode.scope && _typeof(mode.scope) === "object" && mode.scope !== null) {
        mode.beginScope = mode.scope;
        delete mode.scope;
      }
    }

    /**
     * @param {CompiledMode} mode
     */
    function MultiClass(mode) {
      scopeSugar(mode);

      if (typeof mode.beginScope === "string") {
        mode.beginScope = { _wrap: mode.beginScope };
      }
      if (typeof mode.endScope === "string") {
        mode.endScope = { _wrap: mode.endScope };
      }

      beginMultiClass(mode);
      endMultiClass(mode);
    }

    /**
    @typedef {import('highlight.js').Mode} Mode
    @typedef {import('highlight.js').CompiledMode} CompiledMode
    @typedef {import('highlight.js').Language} Language
    @typedef {import('highlight.js').HLJSPlugin} HLJSPlugin
    @typedef {import('highlight.js').CompiledLanguage} CompiledLanguage
    */

    // compilation

    /**
     * Compiles a language definition result
     *
     * Given the raw result of a language definition (Language), compiles this so
     * that it is ready for highlighting code.
     * @param {Language} language
     * @returns {CompiledLanguage}
     */
    function compileLanguage(language) {
      /**
       * Builds a regex with the case sensitivity of the current language
       *
       * @param {RegExp | string} value
       * @param {boolean} [global]
       */
      function langRe(value, global) {
        return new RegExp(source(value), 'm' + (language.case_insensitive ? 'i' : '') + (language.unicodeRegex ? 'u' : '') + (global ? 'g' : ''));
      }

      /**
        Stores multiple regular expressions and allows you to quickly search for
        them all in a string simultaneously - returning the first match.  It does
        this by creating a huge (a|b|c) regex - each individual item wrapped with ()
        and joined by `|` - using match groups to track position.  When a match is
        found checking which position in the array has content allows us to figure
        out which of the original regexes / match groups triggered the match.
         The match object itself (the result of `Regex.exec`) is returned but also
        enhanced by merging in any meta-data that was registered with the regex.
        This is how we keep track of which mode matched, and what type of rule
        (`illegal`, `begin`, end, etc).
      */

      var MultiRegex = function () {
        function MultiRegex() {
          _classCallCheck(this, MultiRegex);

          this.matchIndexes = {};
          // @ts-ignore
          this.regexes = [];
          this.matchAt = 1;
          this.position = 0;
        }

        // @ts-ignore


        _createClass(MultiRegex, [{
          key: 'addRule',
          value: function addRule(re, opts) {
            opts.position = this.position++;
            // @ts-ignore
            this.matchIndexes[this.matchAt] = opts;
            this.regexes.push([opts, re]);
            this.matchAt += countMatchGroups(re) + 1;
          }
        }, {
          key: 'compile',
          value: function compile() {
            if (this.regexes.length === 0) {
              // avoids the need to check length every time exec is called
              // @ts-ignore
              this.exec = function () {
                return null;
              };
            }
            var terminators = this.regexes.map(function (el) {
              return el[1];
            });
            this.matcherRe = langRe(_rewriteBackreferences(terminators, { joinWith: '|' }), true);
            this.lastIndex = 0;
          }

          /** @param {string} s */

        }, {
          key: 'exec',
          value: function exec(s) {
            this.matcherRe.lastIndex = this.lastIndex;
            var match = this.matcherRe.exec(s);
            if (!match) {
              return null;
            }

            // eslint-disable-next-line no-undefined
            var i = match.findIndex(function (el, i) {
              return i > 0 && el !== undefined;
            });
            // @ts-ignore
            var matchData = this.matchIndexes[i];
            // trim off any earlier non-relevant match groups (ie, the other regex
            // match groups that make up the multi-matcher)
            match.splice(0, i);

            return Object.assign(match, matchData);
          }
        }]);

        return MultiRegex;
      }();

      /*
        Created to solve the key deficiently with MultiRegex - there is no way to
        test for multiple matches at a single location.  Why would we need to do
        that?  In the future a more dynamic engine will allow certain matches to be
        ignored.  An example: if we matched say the 3rd regex in a large group but
        decided to ignore it - we'd need to started testing again at the 4th
        regex... but MultiRegex itself gives us no real way to do that.
         So what this class creates MultiRegexs on the fly for whatever search
        position they are needed.
         NOTE: These additional MultiRegex objects are created dynamically.  For most
        grammars most of the time we will never actually need anything more than the
        first MultiRegex - so this shouldn't have too much overhead.
         Say this is our search group, and we match regex3, but wish to ignore it.
           regex1 | regex2 | regex3 | regex4 | regex5    ' ie, startAt = 0
         What we need is a new MultiRegex that only includes the remaining
        possibilities:
           regex4 | regex5                               ' ie, startAt = 3
         This class wraps all that complexity up in a simple API... `startAt` decides
        where in the array of expressions to start doing the matching. It
        auto-increments, so if a match is found at position 2, then startAt will be
        set to 3.  If the end is reached startAt will return to 0.
         MOST of the time the parser will be setting startAt manually to 0.
      */


      var ResumableMultiRegex = function () {
        function ResumableMultiRegex() {
          _classCallCheck(this, ResumableMultiRegex);

          // @ts-ignore
          this.rules = [];
          // @ts-ignore
          this.multiRegexes = [];
          this.count = 0;

          this.lastIndex = 0;
          this.regexIndex = 0;
        }

        // @ts-ignore


        _createClass(ResumableMultiRegex, [{
          key: 'getMatcher',
          value: function getMatcher(index) {
            if (this.multiRegexes[index]) return this.multiRegexes[index];

            var matcher = new MultiRegex();
            this.rules.slice(index).forEach(function (_ref4) {
              var _ref5 = _slicedToArray(_ref4, 2),
                  re = _ref5[0],
                  opts = _ref5[1];

              return matcher.addRule(re, opts);
            });
            matcher.compile();
            this.multiRegexes[index] = matcher;
            return matcher;
          }
        }, {
          key: 'resumingScanAtSamePosition',
          value: function resumingScanAtSamePosition() {
            return this.regexIndex !== 0;
          }
        }, {
          key: 'considerAll',
          value: function considerAll() {
            this.regexIndex = 0;
          }

          // @ts-ignore

        }, {
          key: 'addRule',
          value: function addRule(re, opts) {
            this.rules.push([re, opts]);
            if (opts.type === "begin") this.count++;
          }

          /** @param {string} s */

        }, {
          key: 'exec',
          value: function exec(s) {
            var m = this.getMatcher(this.regexIndex);
            m.lastIndex = this.lastIndex;
            var result = m.exec(s);

            // The following is because we have no easy way to say "resume scanning at the
            // existing position but also skip the current rule ONLY". What happens is
            // all prior rules are also skipped which can result in matching the wrong
            // thing. Example of matching "booger":

            // our matcher is [string, "booger", number]
            //
            // ....booger....

            // if "booger" is ignored then we'd really need a regex to scan from the
            // SAME position for only: [string, number] but ignoring "booger" (if it
            // was the first match), a simple resume would scan ahead who knows how
            // far looking only for "number", ignoring potential string matches (or
            // future "booger" matches that might be valid.)

            // So what we do: We execute two matchers, one resuming at the same
            // position, but the second full matcher starting at the position after:

            //     /--- resume first regex match here (for [number])
            //     |/---- full match here for [string, "booger", number]
            //     vv
            // ....booger....

            // Which ever results in a match first is then used. So this 3-4 step
            // process essentially allows us to say "match at this position, excluding
            // a prior rule that was ignored".
            //
            // 1. Match "booger" first, ignore. Also proves that [string] does non match.
            // 2. Resume matching for [number]
            // 3. Match at index + 1 for [string, "booger", number]
            // 4. If #2 and #3 result in matches, which came first?
            if (this.resumingScanAtSamePosition()) {
              if (result && result.index === this.lastIndex) ;else {
                // use the second matcher result
                var m2 = this.getMatcher(0);
                m2.lastIndex = this.lastIndex + 1;
                result = m2.exec(s);
              }
            }

            if (result) {
              this.regexIndex += result.position + 1;
              if (this.regexIndex === this.count) {
                // wrap-around to considering all matches again
                this.considerAll();
              }
            }

            return result;
          }
        }]);

        return ResumableMultiRegex;
      }();

      /**
       * Given a mode, builds a huge ResumableMultiRegex that can be used to walk
       * the content and find matches.
       *
       * @param {CompiledMode} mode
       * @returns {ResumableMultiRegex}
       */


      function buildModeRegex(mode) {
        var mm = new ResumableMultiRegex();

        mode.contains.forEach(function (term) {
          return mm.addRule(term.begin, { rule: term, type: "begin" });
        });

        if (mode.terminatorEnd) {
          mm.addRule(mode.terminatorEnd, { type: "end" });
        }
        if (mode.illegal) {
          mm.addRule(mode.illegal, { type: "illegal" });
        }

        return mm;
      }

      /** skip vs abort vs ignore
       *
       * @skip   - The mode is still entered and exited normally (and contains rules apply),
       *           but all content is held and added to the parent buffer rather than being
       *           output when the mode ends.  Mostly used with `sublanguage` to build up
       *           a single large buffer than can be parsed by sublanguage.
       *
       *             - The mode begin ands ends normally.
       *             - Content matched is added to the parent mode buffer.
       *             - The parser cursor is moved forward normally.
       *
       * @abort  - A hack placeholder until we have ignore.  Aborts the mode (as if it
       *           never matched) but DOES NOT continue to match subsequent `contains`
       *           modes.  Abort is bad/suboptimal because it can result in modes
       *           farther down not getting applied because an earlier rule eats the
       *           content but then aborts.
       *
       *             - The mode does not begin.
       *             - Content matched by `begin` is added to the mode buffer.
       *             - The parser cursor is moved forward accordingly.
       *
       * @ignore - Ignores the mode (as if it never matched) and continues to match any
       *           subsequent `contains` modes.  Ignore isn't technically possible with
       *           the current parser implementation.
       *
       *             - The mode does not begin.
       *             - Content matched by `begin` is ignored.
       *             - The parser cursor is not moved forward.
       */

      /**
       * Compiles an individual mode
       *
       * This can raise an error if the mode contains certain detectable known logic
       * issues.
       * @param {Mode} mode
       * @param {CompiledMode | null} [parent]
       * @returns {CompiledMode | never}
       */
      function compileMode(mode, parent) {
        var _ref6;

        var cmode = /** @type CompiledMode */mode;
        if (mode.isCompiled) return cmode;

        [scopeClassName,
        // do this early so compiler extensions generally don't have to worry about
        // the distinction between match/begin
        compileMatch, MultiClass, beforeMatchExt].forEach(function (ext) {
          return ext(mode, parent);
        });

        language.compilerExtensions.forEach(function (ext) {
          return ext(mode, parent);
        });

        // __beforeBegin is considered private API, internal use only
        mode.__beforeBegin = null;

        [beginKeywords,
        // do this later so compiler extensions that come earlier have access to the
        // raw array if they wanted to perhaps manipulate it, etc.
        compileIllegal,
        // default to 1 relevance if not specified
        compileRelevance].forEach(function (ext) {
          return ext(mode, parent);
        });

        mode.isCompiled = true;

        var keywordPattern = null;
        if (_typeof(mode.keywords) === "object" && mode.keywords.$pattern) {
          // we need a copy because keywords might be compiled multiple times
          // so we can't go deleting $pattern from the original on the first
          // pass
          mode.keywords = Object.assign({}, mode.keywords);
          keywordPattern = mode.keywords.$pattern;
          delete mode.keywords.$pattern;
        }
        keywordPattern = keywordPattern || /\w+/;

        if (mode.keywords) {
          mode.keywords = compileKeywords(mode.keywords, language.case_insensitive);
        }

        cmode.keywordPatternRe = langRe(keywordPattern, true);

        if (parent) {
          if (!mode.begin) mode.begin = /\B|\b/;
          cmode.beginRe = langRe(cmode.begin);
          if (!mode.end && !mode.endsWithParent) mode.end = /\B|\b/;
          if (mode.end) cmode.endRe = langRe(cmode.end);
          cmode.terminatorEnd = source(cmode.end) || '';
          if (mode.endsWithParent && parent.terminatorEnd) {
            cmode.terminatorEnd += (mode.end ? '|' : '') + parent.terminatorEnd;
          }
        }
        if (mode.illegal) cmode.illegalRe = langRe( /** @type {RegExp | string} */mode.illegal);
        if (!mode.contains) mode.contains = [];

        mode.contains = (_ref6 = []).concat.apply(_ref6, _toConsumableArray(mode.contains.map(function (c) {
          return expandOrCloneMode(c === 'self' ? mode : c);
        })));
        mode.contains.forEach(function (c) {
          compileMode( /** @type Mode */c, cmode);
        });

        if (mode.starts) {
          compileMode(mode.starts, parent);
        }

        cmode.matcher = buildModeRegex(cmode);
        return cmode;
      }

      if (!language.compilerExtensions) language.compilerExtensions = [];

      // self is not valid at the top-level
      if (language.contains && language.contains.includes('self')) {
        throw new Error("ERR: contains `self` is not supported at the top-level of a language.  See documentation.");
      }

      // we need a null object, which inherit will guarantee
      language.classNameAliases = inherit$1(language.classNameAliases || {});

      return compileMode( /** @type Mode */language);
    }

    /**
     * Determines if a mode has a dependency on it's parent or not
     *
     * If a mode does have a parent dependency then often we need to clone it if
     * it's used in multiple places so that each copy points to the correct parent,
     * where-as modes without a parent can often safely be re-used at the bottom of
     * a mode chain.
     *
     * @param {Mode | null} mode
     * @returns {boolean} - is there a dependency on the parent?
     * */
    function dependencyOnParent(mode) {
      if (!mode) return false;

      return mode.endsWithParent || dependencyOnParent(mode.starts);
    }

    /**
     * Expands a mode or clones it if necessary
     *
     * This is necessary for modes with parental dependenceis (see notes on
     * `dependencyOnParent`) and for nodes that have `variants` - which must then be
     * exploded into their own individual modes at compile time.
     *
     * @param {Mode} mode
     * @returns {Mode | Mode[]}
     * */
    function expandOrCloneMode(mode) {
      if (mode.variants && !mode.cachedVariants) {
        mode.cachedVariants = mode.variants.map(function (variant) {
          return inherit$1(mode, { variants: null }, variant);
        });
      }

      // EXPAND
      // if we have variants then essentially "replace" the mode with the variants
      // this happens in compileMode, where this function is called from
      if (mode.cachedVariants) {
        return mode.cachedVariants;
      }

      // CLONE
      // if we have dependencies on parents then we need a unique
      // instance of ourselves, so we can be reused with many
      // different parents without issue
      if (dependencyOnParent(mode)) {
        return inherit$1(mode, { starts: mode.starts ? inherit$1(mode.starts) : null });
      }

      if (Object.isFrozen(mode)) {
        return inherit$1(mode);
      }

      // no special dependency issues, just return ourselves
      return mode;
    }

    var version = "11.9.0";

    var HTMLInjectionError = function (_Error) {
      _inherits(HTMLInjectionError, _Error);

      function HTMLInjectionError(reason, html) {
        _classCallCheck(this, HTMLInjectionError);

        var _this3 = _possibleConstructorReturn(this, (HTMLInjectionError.__proto__ || Object.getPrototypeOf(HTMLInjectionError)).call(this, reason));

        _this3.name = "HTMLInjectionError";
        _this3.html = html;
        return _this3;
      }

      return HTMLInjectionError;
    }(Error);

    /*
    Syntax highlighting with language autodetection.
    https://highlightjs.org/
    */

    /**
    @typedef {import('highlight.js').Mode} Mode
    @typedef {import('highlight.js').CompiledMode} CompiledMode
    @typedef {import('highlight.js').CompiledScope} CompiledScope
    @typedef {import('highlight.js').Language} Language
    @typedef {import('highlight.js').HLJSApi} HLJSApi
    @typedef {import('highlight.js').HLJSPlugin} HLJSPlugin
    @typedef {import('highlight.js').PluginEvent} PluginEvent
    @typedef {import('highlight.js').HLJSOptions} HLJSOptions
    @typedef {import('highlight.js').LanguageFn} LanguageFn
    @typedef {import('highlight.js').HighlightedHTMLElement} HighlightedHTMLElement
    @typedef {import('highlight.js').BeforeHighlightContext} BeforeHighlightContext
    @typedef {import('highlight.js/private').MatchType} MatchType
    @typedef {import('highlight.js/private').KeywordData} KeywordData
    @typedef {import('highlight.js/private').EnhancedMatch} EnhancedMatch
    @typedef {import('highlight.js/private').AnnotatedError} AnnotatedError
    @typedef {import('highlight.js').AutoHighlightResult} AutoHighlightResult
    @typedef {import('highlight.js').HighlightOptions} HighlightOptions
    @typedef {import('highlight.js').HighlightResult} HighlightResult
    */

    var escape = escapeHTML;
    var inherit = inherit$1;
    var NO_MATCH = Symbol("nomatch");
    var MAX_KEYWORD_HITS = 7;

    /**
     * @param {any} hljs - object that is extended (legacy)
     * @returns {HLJSApi}
     */
    var HLJS = function HLJS(hljs) {
      // Global internal variables used within the highlight.js library.
      /** @type {Record<string, Language>} */
      var languages = Object.create(null);
      /** @type {Record<string, string>} */
      var aliases = Object.create(null);
      /** @type {HLJSPlugin[]} */
      var plugins = [];

      // safe/production mode - swallows more errors, tries to keep running
      // even if a single syntax or parse hits a fatal error
      var SAFE_MODE = true;
      var LANGUAGE_NOT_FOUND = "Could not find the language '{}', did you forget to load/include a language module?";
      /** @type {Language} */
      var PLAINTEXT_LANGUAGE = { disableAutodetect: true, name: 'Plain text', contains: [] };

      // Global options used when within external APIs. This is modified when
      // calling the `hljs.configure` function.
      /** @type HLJSOptions */
      var options = {
        ignoreUnescapedHTML: false,
        throwUnescapedHTML: false,
        noHighlightRe: /^(no-?highlight)$/i,
        languageDetectRe: /\blang(?:uage)?-([\w-]+)\b/i,
        classPrefix: 'hljs-',
        cssSelector: 'pre code',
        languages: null,
        // beta configuration options, subject to change, welcome to discuss
        // https://github.com/highlightjs/highlight.js/issues/1086
        __emitter: TokenTreeEmitter
      };

      /* Utility functions */

      /**
       * Tests a language name to see if highlighting should be skipped
       * @param {string} languageName
       */
      function shouldNotHighlight(languageName) {
        return options.noHighlightRe.test(languageName);
      }

      /**
       * @param {HighlightedHTMLElement} block - the HTML element to determine language for
       */
      function blockLanguage(block) {
        var classes = block.className + ' ';

        classes += block.parentNode ? block.parentNode.className : '';

        // language-* takes precedence over non-prefixed class names.
        var match = options.languageDetectRe.exec(classes);
        if (match) {
          var language = getLanguage(match[1]);
          if (!language) {
            warn(LANGUAGE_NOT_FOUND.replace("{}", match[1]));
            warn("Falling back to no-highlight mode for this block.", block);
          }
          return language ? match[1] : 'no-highlight';
        }

        return classes.split(/\s+/).find(function (_class) {
          return shouldNotHighlight(_class) || getLanguage(_class);
        });
      }

      /**
       * Core highlighting function.
       *
       * OLD API
       * highlight(lang, code, ignoreIllegals, continuation)
       *
       * NEW API
       * highlight(code, {lang, ignoreIllegals})
       *
       * @param {string} codeOrLanguageName - the language to use for highlighting
       * @param {string | HighlightOptions} optionsOrCode - the code to highlight
       * @param {boolean} [ignoreIllegals] - whether to ignore illegal matches, default is to bail
       *
       * @returns {HighlightResult} Result - an object that represents the result
       * @property {string} language - the language name
       * @property {number} relevance - the relevance score
       * @property {string} value - the highlighted HTML code
       * @property {string} code - the original raw code
       * @property {CompiledMode} top - top of the current mode stack
       * @property {boolean} illegal - indicates whether any illegal matches were found
      */
      function highlight(codeOrLanguageName, optionsOrCode, ignoreIllegals) {
        var code = "";
        var languageName = "";
        if ((typeof optionsOrCode === 'undefined' ? 'undefined' : _typeof(optionsOrCode)) === "object") {
          code = codeOrLanguageName;
          ignoreIllegals = optionsOrCode.ignoreIllegals;
          languageName = optionsOrCode.language;
        } else {
          // old API
          deprecated("10.7.0", "highlight(lang, code, ...args) has been deprecated.");
          deprecated("10.7.0", "Please use highlight(code, options) instead.\nhttps://github.com/highlightjs/highlight.js/issues/2277");
          languageName = codeOrLanguageName;
          code = optionsOrCode;
        }

        // https://github.com/highlightjs/highlight.js/issues/3149
        // eslint-disable-next-line no-undefined
        if (ignoreIllegals === undefined) {
          ignoreIllegals = true;
        }

        /** @type {BeforeHighlightContext} */
        var context = {
          code: code,
          language: languageName
        };
        // the plugin can change the desired language or the code to be highlighted
        // just be changing the object it was passed
        fire("before:highlight", context);

        // a before plugin can usurp the result completely by providing it's own
        // in which case we don't even need to call highlight
        var result = context.result ? context.result : _highlight(context.language, context.code, ignoreIllegals);

        result.code = context.code;
        // the plugin can change anything in result to suite it
        fire("after:highlight", result);

        return result;
      }

      /**
       * private highlight that's used internally and does not fire callbacks
       *
       * @param {string} languageName - the language to use for highlighting
       * @param {string} codeToHighlight - the code to highlight
       * @param {boolean?} [ignoreIllegals] - whether to ignore illegal matches, default is to bail
       * @param {CompiledMode?} [continuation] - current continuation mode, if any
       * @returns {HighlightResult} - result of the highlight operation
      */
      function _highlight(languageName, codeToHighlight, ignoreIllegals, continuation) {
        var keywordHits = Object.create(null);

        /**
         * Return keyword data if a match is a keyword
         * @param {CompiledMode} mode - current mode
         * @param {string} matchText - the textual match
         * @returns {KeywordData | false}
         */
        function keywordData(mode, matchText) {
          return mode.keywords[matchText];
        }

        function processKeywords() {
          if (!top.keywords) {
            emitter.addText(modeBuffer);
            return;
          }

          var lastIndex = 0;
          top.keywordPatternRe.lastIndex = 0;
          var match = top.keywordPatternRe.exec(modeBuffer);
          var buf = "";

          while (match) {
            buf += modeBuffer.substring(lastIndex, match.index);
            var word = language.case_insensitive ? match[0].toLowerCase() : match[0];
            var data = keywordData(top, word);
            if (data) {
              var _data = _slicedToArray(data, 2),
                  kind = _data[0],
                  keywordRelevance = _data[1];

              emitter.addText(buf);
              buf = "";

              keywordHits[word] = (keywordHits[word] || 0) + 1;
              if (keywordHits[word] <= MAX_KEYWORD_HITS) relevance += keywordRelevance;
              if (kind.startsWith("_")) {
                // _ implied for relevance only, do not highlight
                // by applying a class name
                buf += match[0];
              } else {
                var cssClass = language.classNameAliases[kind] || kind;
                emitKeyword(match[0], cssClass);
              }
            } else {
              buf += match[0];
            }
            lastIndex = top.keywordPatternRe.lastIndex;
            match = top.keywordPatternRe.exec(modeBuffer);
          }
          buf += modeBuffer.substring(lastIndex);
          emitter.addText(buf);
        }

        function processSubLanguage() {
          if (modeBuffer === "") return;
          /** @type HighlightResult */
          var result = null;

          if (typeof top.subLanguage === 'string') {
            if (!languages[top.subLanguage]) {
              emitter.addText(modeBuffer);
              return;
            }
            result = _highlight(top.subLanguage, modeBuffer, true, continuations[top.subLanguage]);
            continuations[top.subLanguage] = /** @type {CompiledMode} */result._top;
          } else {
            result = highlightAuto(modeBuffer, top.subLanguage.length ? top.subLanguage : null);
          }

          // Counting embedded language score towards the host language may be disabled
          // with zeroing the containing mode relevance. Use case in point is Markdown that
          // allows XML everywhere and makes every XML snippet to have a much larger Markdown
          // score.
          if (top.relevance > 0) {
            relevance += result.relevance;
          }
          emitter.__addSublanguage(result._emitter, result.language);
        }

        function processBuffer() {
          if (top.subLanguage != null) {
            processSubLanguage();
          } else {
            processKeywords();
          }
          modeBuffer = '';
        }

        /**
         * @param {string} text
         * @param {string} scope
         */
        function emitKeyword(keyword, scope) {
          if (keyword === "") return;

          emitter.startScope(scope);
          emitter.addText(keyword);
          emitter.endScope();
        }

        /**
         * @param {CompiledScope} scope
         * @param {RegExpMatchArray} match
         */
        function emitMultiClass(scope, match) {
          var i = 1;
          var max = match.length - 1;
          while (i <= max) {
            if (!scope._emit[i]) {
              i++;continue;
            }
            var klass = language.classNameAliases[scope[i]] || scope[i];
            var text = match[i];
            if (klass) {
              emitKeyword(text, klass);
            } else {
              modeBuffer = text;
              processKeywords();
              modeBuffer = "";
            }
            i++;
          }
        }

        /**
         * @param {CompiledMode} mode - new mode to start
         * @param {RegExpMatchArray} match
         */
        function startNewMode(mode, match) {
          if (mode.scope && typeof mode.scope === "string") {
            emitter.openNode(language.classNameAliases[mode.scope] || mode.scope);
          }
          if (mode.beginScope) {
            // beginScope just wraps the begin match itself in a scope
            if (mode.beginScope._wrap) {
              emitKeyword(modeBuffer, language.classNameAliases[mode.beginScope._wrap] || mode.beginScope._wrap);
              modeBuffer = "";
            } else if (mode.beginScope._multi) {
              // at this point modeBuffer should just be the match
              emitMultiClass(mode.beginScope, match);
              modeBuffer = "";
            }
          }

          top = Object.create(mode, { parent: { value: top } });
          return top;
        }

        /**
         * @param {CompiledMode } mode - the mode to potentially end
         * @param {RegExpMatchArray} match - the latest match
         * @param {string} matchPlusRemainder - match plus remainder of content
         * @returns {CompiledMode | void} - the next mode, or if void continue on in current mode
         */
        function endOfMode(mode, match, matchPlusRemainder) {
          var matched = startsWith(mode.endRe, matchPlusRemainder);

          if (matched) {
            if (mode["on:end"]) {
              var resp = new Response(mode);
              mode["on:end"](match, resp);
              if (resp.isMatchIgnored) matched = false;
            }

            if (matched) {
              while (mode.endsParent && mode.parent) {
                mode = mode.parent;
              }
              return mode;
            }
          }
          // even if on:end fires an `ignore` it's still possible
          // that we might trigger the end node because of a parent mode
          if (mode.endsWithParent) {
            return endOfMode(mode.parent, match, matchPlusRemainder);
          }
        }

        /**
         * Handle matching but then ignoring a sequence of text
         *
         * @param {string} lexeme - string containing full match text
         */
        function doIgnore(lexeme) {
          if (top.matcher.regexIndex === 0) {
            // no more regexes to potentially match here, so we move the cursor forward one
            // space
            modeBuffer += lexeme[0];
            return 1;
          } else {
            // no need to move the cursor, we still have additional regexes to try and
            // match at this very spot
            resumeScanAtSamePosition = true;
            return 0;
          }
        }

        /**
         * Handle the start of a new potential mode match
         *
         * @param {EnhancedMatch} match - the current match
         * @returns {number} how far to advance the parse cursor
         */
        function doBeginMatch(match) {
          var lexeme = match[0];
          var newMode = match.rule;

          var resp = new Response(newMode);
          // first internal before callbacks, then the public ones
          var beforeCallbacks = [newMode.__beforeBegin, newMode["on:begin"]];
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = beforeCallbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var cb = _step.value;

              if (!cb) continue;
              cb(match, resp);
              if (resp.isMatchIgnored) return doIgnore(lexeme);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          if (newMode.skip) {
            modeBuffer += lexeme;
          } else {
            if (newMode.excludeBegin) {
              modeBuffer += lexeme;
            }
            processBuffer();
            if (!newMode.returnBegin && !newMode.excludeBegin) {
              modeBuffer = lexeme;
            }
          }
          startNewMode(newMode, match);
          return newMode.returnBegin ? 0 : lexeme.length;
        }

        /**
         * Handle the potential end of mode
         *
         * @param {RegExpMatchArray} match - the current match
         */
        function doEndMatch(match) {
          var lexeme = match[0];
          var matchPlusRemainder = codeToHighlight.substring(match.index);

          var endMode = endOfMode(top, match, matchPlusRemainder);
          if (!endMode) {
            return NO_MATCH;
          }

          var origin = top;
          if (top.endScope && top.endScope._wrap) {
            processBuffer();
            emitKeyword(lexeme, top.endScope._wrap);
          } else if (top.endScope && top.endScope._multi) {
            processBuffer();
            emitMultiClass(top.endScope, match);
          } else if (origin.skip) {
            modeBuffer += lexeme;
          } else {
            if (!(origin.returnEnd || origin.excludeEnd)) {
              modeBuffer += lexeme;
            }
            processBuffer();
            if (origin.excludeEnd) {
              modeBuffer = lexeme;
            }
          }
          do {
            if (top.scope) {
              emitter.closeNode();
            }
            if (!top.skip && !top.subLanguage) {
              relevance += top.relevance;
            }
            top = top.parent;
          } while (top !== endMode.parent);
          if (endMode.starts) {
            startNewMode(endMode.starts, match);
          }
          return origin.returnEnd ? 0 : lexeme.length;
        }

        function processContinuations() {
          var list = [];
          for (var current = top; current !== language; current = current.parent) {
            if (current.scope) {
              list.unshift(current.scope);
            }
          }
          list.forEach(function (item) {
            return emitter.openNode(item);
          });
        }

        /** @type {{type?: MatchType, index?: number, rule?: Mode}}} */
        var lastMatch = {};

        /**
         *  Process an individual match
         *
         * @param {string} textBeforeMatch - text preceding the match (since the last match)
         * @param {EnhancedMatch} [match] - the match itself
         */
        function processLexeme(textBeforeMatch, match) {
          var lexeme = match && match[0];

          // add non-matched text to the current mode buffer
          modeBuffer += textBeforeMatch;

          if (lexeme == null) {
            processBuffer();
            return 0;
          }

          // we've found a 0 width match and we're stuck, so we need to advance
          // this happens when we have badly behaved rules that have optional matchers to the degree that
          // sometimes they can end up matching nothing at all
          // Ref: https://github.com/highlightjs/highlight.js/issues/2140
          if (lastMatch.type === "begin" && match.type === "end" && lastMatch.index === match.index && lexeme === "") {
            // spit the "skipped" character that our regex choked on back into the output sequence
            modeBuffer += codeToHighlight.slice(match.index, match.index + 1);
            if (!SAFE_MODE) {
              /** @type {AnnotatedError} */
              var err = new Error('0 width match regex (' + languageName + ')');
              err.languageName = languageName;
              err.badRule = lastMatch.rule;
              throw err;
            }
            return 1;
          }
          lastMatch = match;

          if (match.type === "begin") {
            return doBeginMatch(match);
          } else if (match.type === "illegal" && !ignoreIllegals) {
            // illegal match, we do not continue processing
            /** @type {AnnotatedError} */
            var _err = new Error('Illegal lexeme "' + lexeme + '" for mode "' + (top.scope || '<unnamed>') + '"');
            _err.mode = top;
            throw _err;
          } else if (match.type === "end") {
            var processed = doEndMatch(match);
            if (processed !== NO_MATCH) {
              return processed;
            }
          }

          // edge case for when illegal matches $ (end of line) which is technically
          // a 0 width match but not a begin/end match so it's not caught by the
          // first handler (when ignoreIllegals is true)
          if (match.type === "illegal" && lexeme === "") {
            // advance so we aren't stuck in an infinite loop
            return 1;
          }

          // infinite loops are BAD, this is a last ditch catch all. if we have a
          // decent number of iterations yet our index (cursor position in our
          // parsing) still 3x behind our index then something is very wrong
          // so we bail
          if (iterations > 100000 && iterations > match.index * 3) {
            var _err2 = new Error('potential infinite loop, way more iterations than matches');
            throw _err2;
          }

          /*
          Why might be find ourselves here?  An potential end match that was
          triggered but could not be completed.  IE, `doEndMatch` returned NO_MATCH.
          (this could be because a callback requests the match be ignored, etc)
           This causes no real harm other than stopping a few times too many.
          */

          modeBuffer += lexeme;
          return lexeme.length;
        }

        var language = getLanguage(languageName);
        if (!language) {
          error(LANGUAGE_NOT_FOUND.replace("{}", languageName));
          throw new Error('Unknown language: "' + languageName + '"');
        }

        var md = compileLanguage(language);
        var result = '';
        /** @type {CompiledMode} */
        var top = continuation || md;
        /** @type Record<string,CompiledMode> */
        var continuations = {}; // keep continuations for sub-languages
        var emitter = new options.__emitter(options);
        processContinuations();
        var modeBuffer = '';
        var relevance = 0;
        var index = 0;
        var iterations = 0;
        var resumeScanAtSamePosition = false;

        try {
          if (!language.__emitTokens) {
            top.matcher.considerAll();

            for (;;) {
              iterations++;
              if (resumeScanAtSamePosition) {
                // only regexes not matched previously will now be
                // considered for a potential match
                resumeScanAtSamePosition = false;
              } else {
                top.matcher.considerAll();
              }
              top.matcher.lastIndex = index;

              var match = top.matcher.exec(codeToHighlight);
              // console.log("match", match[0], match.rule && match.rule.begin)

              if (!match) break;

              var beforeMatch = codeToHighlight.substring(index, match.index);
              var processedCount = processLexeme(beforeMatch, match);
              index = match.index + processedCount;
            }
            processLexeme(codeToHighlight.substring(index));
          } else {
            language.__emitTokens(codeToHighlight, emitter);
          }

          emitter.finalize();
          result = emitter.toHTML();

          return {
            language: languageName,
            value: result,
            relevance: relevance,
            illegal: false,
            _emitter: emitter,
            _top: top
          };
        } catch (err) {
          if (err.message && err.message.includes('Illegal')) {
            return {
              language: languageName,
              value: escape(codeToHighlight),
              illegal: true,
              relevance: 0,
              _illegalBy: {
                message: err.message,
                index: index,
                context: codeToHighlight.slice(index - 100, index + 100),
                mode: err.mode,
                resultSoFar: result
              },
              _emitter: emitter
            };
          } else if (SAFE_MODE) {
            return {
              language: languageName,
              value: escape(codeToHighlight),
              illegal: false,
              relevance: 0,
              errorRaised: err,
              _emitter: emitter,
              _top: top
            };
          } else {
            throw err;
          }
        }
      }

      /**
       * returns a valid highlight result, without actually doing any actual work,
       * auto highlight starts with this and it's possible for small snippets that
       * auto-detection may not find a better match
       * @param {string} code
       * @returns {HighlightResult}
       */
      function justTextHighlightResult(code) {
        var result = {
          value: escape(code),
          illegal: false,
          relevance: 0,
          _top: PLAINTEXT_LANGUAGE,
          _emitter: new options.__emitter(options)
        };
        result._emitter.addText(code);
        return result;
      }

      /**
      Highlighting with language detection. Accepts a string with the code to
      highlight. Returns an object with the following properties:
       - language (detected language)
      - relevance (int)
      - value (an HTML string with highlighting markup)
      - secondBest (object with the same structure for second-best heuristically
        detected language, may be absent)
         @param {string} code
        @param {Array<string>} [languageSubset]
        @returns {AutoHighlightResult}
      */
      function highlightAuto(code, languageSubset) {
        languageSubset = languageSubset || options.languages || Object.keys(languages);
        var plaintext = justTextHighlightResult(code);

        var results = languageSubset.filter(getLanguage).filter(autoDetection).map(function (name) {
          return _highlight(name, code, false);
        });
        results.unshift(plaintext); // plaintext is always an option

        var sorted = results.sort(function (a, b) {
          // sort base on relevance
          if (a.relevance !== b.relevance) return b.relevance - a.relevance;

          // always award the tie to the base language
          // ie if C++ and Arduino are tied, it's more likely to be C++
          if (a.language && b.language) {
            if (getLanguage(a.language).supersetOf === b.language) {
              return 1;
            } else if (getLanguage(b.language).supersetOf === a.language) {
              return -1;
            }
          }

          // otherwise say they are equal, which has the effect of sorting on
          // relevance while preserving the original ordering - which is how ties
          // have historically been settled, ie the language that comes first always
          // wins in the case of a tie
          return 0;
        });

        var _sorted = _slicedToArray(sorted, 2),
            best = _sorted[0],
            secondBest = _sorted[1];

        /** @type {AutoHighlightResult} */


        var result = best;
        result.secondBest = secondBest;

        return result;
      }

      /**
       * Builds new class name for block given the language name
       *
       * @param {HTMLElement} element
       * @param {string} [currentLang]
       * @param {string} [resultLang]
       */
      function updateClassName(element, currentLang, resultLang) {
        var language = currentLang && aliases[currentLang] || resultLang;

        element.classList.add("hljs");
        element.classList.add('language-' + language);
      }

      /**
       * Applies highlighting to a DOM node containing code.
       *
       * @param {HighlightedHTMLElement} element - the HTML element to highlight
      */
      function highlightElement(element) {
        /** @type HTMLElement */
        var node = null;
        var language = blockLanguage(element);

        if (shouldNotHighlight(language)) return;

        fire("before:highlightElement", { el: element, language: language });

        if (element.dataset.highlighted) {
          console.log("Element previously highlighted. To highlight again, first unset `dataset.highlighted`.", element);
          return;
        }

        // we should be all text, no child nodes (unescaped HTML) - this is possibly
        // an HTML injection attack - it's likely too late if this is already in
        // production (the code has likely already done its damage by the time
        // we're seeing it)... but we yell loudly about this so that hopefully it's
        // more likely to be caught in development before making it to production
        if (element.children.length > 0) {
          if (!options.ignoreUnescapedHTML) {
            console.warn("One of your code blocks includes unescaped HTML. This is a potentially serious security risk.");
            console.warn("https://github.com/highlightjs/highlight.js/wiki/security");
            console.warn("The element with unescaped HTML:");
            console.warn(element);
          }
          if (options.throwUnescapedHTML) {
            var err = new HTMLInjectionError("One of your code blocks includes unescaped HTML.", element.innerHTML);
            throw err;
          }
        }

        node = element;
        var text = node.textContent;
        var result = language ? highlight(text, { language: language, ignoreIllegals: true }) : highlightAuto(text);

        element.innerHTML = result.value;
        element.dataset.highlighted = "yes";
        updateClassName(element, language, result.language);
        element.result = {
          language: result.language,
          // TODO: remove with version 11.0
          re: result.relevance,
          relevance: result.relevance
        };
        if (result.secondBest) {
          element.secondBest = {
            language: result.secondBest.language,
            relevance: result.secondBest.relevance
          };
        }

        fire("after:highlightElement", { el: element, result: result, text: text });
      }

      /**
       * Updates highlight.js global options with the passed options
       *
       * @param {Partial<HLJSOptions>} userOptions
       */
      function configure(userOptions) {
        options = inherit(options, userOptions);
      }

      // TODO: remove v12, deprecated
      var initHighlighting = function initHighlighting() {
        highlightAll();
        deprecated("10.6.0", "initHighlighting() deprecated.  Use highlightAll() now.");
      };

      // TODO: remove v12, deprecated
      function initHighlightingOnLoad() {
        highlightAll();
        deprecated("10.6.0", "initHighlightingOnLoad() deprecated.  Use highlightAll() now.");
      }

      var wantsHighlight = false;

      /**
       * auto-highlights all pre>code elements on the page
       */
      function highlightAll() {
        // if we are called too early in the loading process
        if (document.readyState === "loading") {
          wantsHighlight = true;
          return;
        }

        var blocks = document.querySelectorAll(options.cssSelector);
        blocks.forEach(highlightElement);
      }

      function boot() {
        // if a highlight was requested before DOM was loaded, do now
        if (wantsHighlight) highlightAll();
      }

      // make sure we are in the browser environment
      if (typeof window !== 'undefined' && window.addEventListener) {
        window.addEventListener('DOMContentLoaded', boot, false);
      }

      /**
       * Register a language grammar module
       *
       * @param {string} languageName
       * @param {LanguageFn} languageDefinition
       */
      function registerLanguage(languageName, languageDefinition) {
        var lang = null;
        try {
          lang = languageDefinition(hljs);
        } catch (error$1) {
          error("Language definition for '{}' could not be registered.".replace("{}", languageName));
          // hard or soft error
          if (!SAFE_MODE) {
            throw error$1;
          } else {
            error(error$1);
          }
          // languages that have serious errors are replaced with essentially a
          // "plaintext" stand-in so that the code blocks will still get normal
          // css classes applied to them - and one bad language won't break the
          // entire highlighter
          lang = PLAINTEXT_LANGUAGE;
        }
        // give it a temporary name if it doesn't have one in the meta-data
        if (!lang.name) lang.name = languageName;
        languages[languageName] = lang;
        lang.rawDefinition = languageDefinition.bind(null, hljs);

        if (lang.aliases) {
          registerAliases(lang.aliases, { languageName: languageName });
        }
      }

      /**
       * Remove a language grammar module
       *
       * @param {string} languageName
       */
      function unregisterLanguage(languageName) {
        delete languages[languageName];
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = Object.keys(aliases)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var alias = _step2.value;

            if (aliases[alias] === languageName) {
              delete aliases[alias];
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }

      /**
       * @returns {string[]} List of language internal names
       */
      function listLanguages() {
        return Object.keys(languages);
      }

      /**
       * @param {string} name - name of the language to retrieve
       * @returns {Language | undefined}
       */
      function getLanguage(name) {
        name = (name || '').toLowerCase();
        return languages[name] || languages[aliases[name]];
      }

      /**
       *
       * @param {string|string[]} aliasList - single alias or list of aliases
       * @param {{languageName: string}} opts
       */
      function registerAliases(aliasList, _ref7) {
        var languageName = _ref7.languageName;

        if (typeof aliasList === 'string') {
          aliasList = [aliasList];
        }
        aliasList.forEach(function (alias) {
          aliases[alias.toLowerCase()] = languageName;
        });
      }

      /**
       * Determines if a given language has auto-detection enabled
       * @param {string} name - name of the language
       */
      function autoDetection(name) {
        var lang = getLanguage(name);
        return lang && !lang.disableAutodetect;
      }

      /**
       * Upgrades the old highlightBlock plugins to the new
       * highlightElement API
       * @param {HLJSPlugin} plugin
       */
      function upgradePluginAPI(plugin) {
        // TODO: remove with v12
        if (plugin["before:highlightBlock"] && !plugin["before:highlightElement"]) {
          plugin["before:highlightElement"] = function (data) {
            plugin["before:highlightBlock"](Object.assign({ block: data.el }, data));
          };
        }
        if (plugin["after:highlightBlock"] && !plugin["after:highlightElement"]) {
          plugin["after:highlightElement"] = function (data) {
            plugin["after:highlightBlock"](Object.assign({ block: data.el }, data));
          };
        }
      }

      /**
       * @param {HLJSPlugin} plugin
       */
      function addPlugin(plugin) {
        upgradePluginAPI(plugin);
        plugins.push(plugin);
      }

      /**
       * @param {HLJSPlugin} plugin
       */
      function removePlugin(plugin) {
        var index = plugins.indexOf(plugin);
        if (index !== -1) {
          plugins.splice(index, 1);
        }
      }

      /**
       *
       * @param {PluginEvent} event
       * @param {any} args
       */
      function fire(event, args) {
        var cb = event;
        plugins.forEach(function (plugin) {
          if (plugin[cb]) {
            plugin[cb](args);
          }
        });
      }

      /**
       * DEPRECATED
       * @param {HighlightedHTMLElement} el
       */
      function deprecateHighlightBlock(el) {
        deprecated("10.7.0", "highlightBlock will be removed entirely in v12.0");
        deprecated("10.7.0", "Please use highlightElement now.");

        return highlightElement(el);
      }

      /* Interface definition */
      Object.assign(hljs, {
        highlight: highlight,
        highlightAuto: highlightAuto,
        highlightAll: highlightAll,
        highlightElement: highlightElement,
        // TODO: Remove with v12 API
        highlightBlock: deprecateHighlightBlock,
        configure: configure,
        initHighlighting: initHighlighting,
        initHighlightingOnLoad: initHighlightingOnLoad,
        registerLanguage: registerLanguage,
        unregisterLanguage: unregisterLanguage,
        listLanguages: listLanguages,
        getLanguage: getLanguage,
        registerAliases: registerAliases,
        autoDetection: autoDetection,
        inherit: inherit,
        addPlugin: addPlugin,
        removePlugin: removePlugin
      });

      hljs.debugMode = function () {
        SAFE_MODE = false;
      };
      hljs.safeMode = function () {
        SAFE_MODE = true;
      };
      hljs.versionString = version;

      hljs.regex = {
        concat: concat,
        lookahead: lookahead,
        either: either,
        optional: optional,
        anyNumberOfTimes: anyNumberOfTimes
      };

      for (var key in MODES) {
        // @ts-ignore
        if (_typeof(MODES[key]) === "object") {
          // @ts-ignore
          deepFreeze(MODES[key]);
        }
      }

      // merge all the modes/regexes into our main object
      Object.assign(hljs, MODES);

      return hljs;
    };

    // Other names for the variable may break build script
    var highlight = HLJS({});

    // returns a new instance of the highlighter to be used for extensions
    // check https://github.com/wooorm/lowlight/issues/47
    highlight.newInstance = function () {
      return HLJS({});
    };

    return highlight;
  }();
  if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined') {
    module.exports = hljs;
  }
  /*! `javascript` grammar compiled for Highlight.js 11.9.0 */
  (function () {
    var hljsGrammar = function () {
      'use strict';

      var IDENT_RE = '[A-Za-z$_][0-9A-Za-z$_]*';
      var KEYWORDS = ["as", // for exports
      "in", "of", "if", "for", "while", "finally", "var", "new", "function", "do", "return", "void", "else", "break", "catch", "instanceof", "with", "throw", "case", "default", "try", "switch", "continue", "typeof", "delete", "let", "yield", "const", "class",
      // JS handles these with a special rule
      // "get",
      // "set",
      "debugger", "async", "await", "static", "import", "from", "export", "extends"];
      var LITERALS = ["true", "false", "null", "undefined", "NaN", "Infinity"];

      // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects
      var TYPES = [
      // Fundamental objects
      "Object", "Function", "Boolean", "Symbol",
      // numbers and dates
      "Math", "Date", "Number", "BigInt",
      // text
      "String", "RegExp",
      // Indexed collections
      "Array", "Float32Array", "Float64Array", "Int8Array", "Uint8Array", "Uint8ClampedArray", "Int16Array", "Int32Array", "Uint16Array", "Uint32Array", "BigInt64Array", "BigUint64Array",
      // Keyed collections
      "Set", "Map", "WeakSet", "WeakMap",
      // Structured data
      "ArrayBuffer", "SharedArrayBuffer", "Atomics", "DataView", "JSON",
      // Control abstraction objects
      "Promise", "Generator", "GeneratorFunction", "AsyncFunction",
      // Reflection
      "Reflect", "Proxy",
      // Internationalization
      "Intl",
      // WebAssembly
      "WebAssembly"];

      var ERROR_TYPES = ["Error", "EvalError", "InternalError", "RangeError", "ReferenceError", "SyntaxError", "TypeError", "URIError"];

      var BUILT_IN_GLOBALS = ["setInterval", "setTimeout", "clearInterval", "clearTimeout", "require", "exports", "eval", "isFinite", "isNaN", "parseFloat", "parseInt", "decodeURI", "decodeURIComponent", "encodeURI", "encodeURIComponent", "escape", "unescape"];

      var BUILT_IN_VARIABLES = ["arguments", "this", "super", "console", "window", "document", "localStorage", "sessionStorage", "module", "global" // Node.js
      ];

      var BUILT_INS = [].concat(BUILT_IN_GLOBALS, TYPES, ERROR_TYPES);

      /*
      Language: JavaScript
      Description: JavaScript (JS) is a lightweight, interpreted, or just-in-time compiled programming language with first-class functions.
      Category: common, scripting, web
      Website: https://developer.mozilla.org/en-US/docs/Web/JavaScript
      */

      /** @type LanguageFn */
      function javascript(hljs) {
        var regex = hljs.regex;
        /**
         * Takes a string like "<Booger" and checks to see
         * if we can find a matching "</Booger" later in the
         * content.
         * @param {RegExpMatchArray} match
         * @param {{after:number}} param1
         */
        var hasClosingTag = function hasClosingTag(match, _ref8) {
          var after = _ref8.after;

          var tag = "</" + match[0].slice(1);
          var pos = match.input.indexOf(tag, after);
          return pos !== -1;
        };

        var IDENT_RE$1 = IDENT_RE;
        var FRAGMENT = {
          begin: '<>',
          end: '</>'
        };
        // to avoid some special cases inside isTrulyOpeningTag
        var XML_SELF_CLOSING = /<[A-Za-z0-9\\._:-]+\s*\/>/;
        var XML_TAG = {
          begin: /<[A-Za-z0-9\\._:-]+/,
          end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
          /**
           * @param {RegExpMatchArray} match
           * @param {CallbackResponse} response
           */
          isTrulyOpeningTag: function isTrulyOpeningTag(match, response) {
            var afterMatchIndex = match[0].length + match.index;
            var nextChar = match.input[afterMatchIndex];
            if (
            // HTML should not include another raw `<` inside a tag
            // nested type?
            // `<Array<Array<number>>`, etc.
            nextChar === "<" ||
            // the , gives away that this is not HTML
            // `<T, A extends keyof T, V>`
            nextChar === ",") {
              response.ignoreMatch();
              return;
            }

            // `<something>`
            // Quite possibly a tag, lets look for a matching closing tag...
            if (nextChar === ">") {
              // if we cannot find a matching closing tag, then we
              // will ignore it
              if (!hasClosingTag(match, { after: afterMatchIndex })) {
                response.ignoreMatch();
              }
            }

            // `<blah />` (self-closing)
            // handled by simpleSelfClosing rule

            var m = void 0;
            var afterMatch = match.input.substring(afterMatchIndex);

            // some more template typing stuff
            //  <T = any>(key?: string) => Modify<
            if (m = afterMatch.match(/^\s*=/)) {
              response.ignoreMatch();
              return;
            }

            // `<From extends string>`
            // technically this could be HTML, but it smells like a type
            // NOTE: This is ugh, but added specifically for https://github.com/highlightjs/highlight.js/issues/3276
            if (m = afterMatch.match(/^\s+extends\s+/)) {
              if (m.index === 0) {
                response.ignoreMatch();
                // eslint-disable-next-line no-useless-return
                return;
              }
            }
          }
        };
        var KEYWORDS$1 = {
          $pattern: IDENT_RE,
          keyword: KEYWORDS,
          literal: LITERALS,
          built_in: BUILT_INS,
          "variable.language": BUILT_IN_VARIABLES
        };

        // https://tc39.es/ecma262/#sec-literals-numeric-literals
        var decimalDigits = '[0-9](_?[0-9])*';
        var frac = '\\.(' + decimalDigits + ')';
        // DecimalIntegerLiteral, including Annex B NonOctalDecimalIntegerLiteral
        // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
        var decimalInteger = '0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*';
        var NUMBER = {
          className: 'number',
          variants: [
          // DecimalLiteral
          { begin: '(\\b(' + decimalInteger + ')((' + frac + ')|\\.)?|(' + frac + '))' + ('[eE][+-]?(' + decimalDigits + ')\\b') }, { begin: '\\b(' + decimalInteger + ')\\b((' + frac + ')\\b|\\.)?|(' + frac + ')\\b' },

          // DecimalBigIntegerLiteral
          { begin: '\\b(0|[1-9](_?[0-9])*)n\\b' },

          // NonDecimalIntegerLiteral
          { begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b" }, { begin: "\\b0[bB][0-1](_?[0-1])*n?\\b" }, { begin: "\\b0[oO][0-7](_?[0-7])*n?\\b" },

          // LegacyOctalIntegerLiteral (does not include underscore separators)
          // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
          { begin: "\\b0[0-7]+n?\\b" }],
          relevance: 0
        };

        var SUBST = {
          className: 'subst',
          begin: '\\$\\{',
          end: '\\}',
          keywords: KEYWORDS$1,
          contains: [] // defined later
        };
        var HTML_TEMPLATE = {
          begin: 'html`',
          end: '',
          starts: {
            end: '`',
            returnEnd: false,
            contains: [hljs.BACKSLASH_ESCAPE, SUBST],
            subLanguage: 'xml'
          }
        };
        var CSS_TEMPLATE = {
          begin: 'css`',
          end: '',
          starts: {
            end: '`',
            returnEnd: false,
            contains: [hljs.BACKSLASH_ESCAPE, SUBST],
            subLanguage: 'css'
          }
        };
        var GRAPHQL_TEMPLATE = {
          begin: 'gql`',
          end: '',
          starts: {
            end: '`',
            returnEnd: false,
            contains: [hljs.BACKSLASH_ESCAPE, SUBST],
            subLanguage: 'graphql'
          }
        };
        var TEMPLATE_STRING = {
          className: 'string',
          begin: '`',
          end: '`',
          contains: [hljs.BACKSLASH_ESCAPE, SUBST]
        };
        var JSDOC_COMMENT = hljs.COMMENT(/\/\*\*(?!\/)/, '\\*/', {
          relevance: 0,
          contains: [{
            begin: '(?=@[A-Za-z]+)',
            relevance: 0,
            contains: [{
              className: 'doctag',
              begin: '@[A-Za-z]+'
            }, {
              className: 'type',
              begin: '\\{',
              end: '\\}',
              excludeEnd: true,
              excludeBegin: true,
              relevance: 0
            }, {
              className: 'variable',
              begin: IDENT_RE$1 + '(?=\\s*(-)|$)',
              endsParent: true,
              relevance: 0
            },
            // eat spaces (not newlines) so we can find
            // types or variables
            {
              begin: /(?=[^\n])\s/,
              relevance: 0
            }]
          }]
        });
        var COMMENT = {
          className: "comment",
          variants: [JSDOC_COMMENT, hljs.C_BLOCK_COMMENT_MODE, hljs.C_LINE_COMMENT_MODE]
        };
        var SUBST_INTERNALS = [hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, HTML_TEMPLATE, CSS_TEMPLATE, GRAPHQL_TEMPLATE, TEMPLATE_STRING,
        // Skip numbers when they are part of a variable name
        { match: /\$\d+/ }, NUMBER];
        SUBST.contains = SUBST_INTERNALS.concat({
          // we need to pair up {} inside our subst to prevent
          // it from ending too early by matching another }
          begin: /\{/,
          end: /\}/,
          keywords: KEYWORDS$1,
          contains: ["self"].concat(SUBST_INTERNALS)
        });
        var SUBST_AND_COMMENTS = [].concat(COMMENT, SUBST.contains);
        var PARAMS_CONTAINS = SUBST_AND_COMMENTS.concat([
        // eat recursive parens in sub expressions
        {
          begin: /\(/,
          end: /\)/,
          keywords: KEYWORDS$1,
          contains: ["self"].concat(SUBST_AND_COMMENTS)
        }]);
        var PARAMS = {
          className: 'params',
          begin: /\(/,
          end: /\)/,
          excludeBegin: true,
          excludeEnd: true,
          keywords: KEYWORDS$1,
          contains: PARAMS_CONTAINS
        };

        // ES6 classes
        var CLASS_OR_EXTENDS = {
          variants: [
          // class Car extends vehicle
          {
            match: [/class/, /\s+/, IDENT_RE$1, /\s+/, /extends/, /\s+/, regex.concat(IDENT_RE$1, "(", regex.concat(/\./, IDENT_RE$1), ")*")],
            scope: {
              1: "keyword",
              3: "title.class",
              5: "keyword",
              7: "title.class.inherited"
            }
          },
          // class Car
          {
            match: [/class/, /\s+/, IDENT_RE$1],
            scope: {
              1: "keyword",
              3: "title.class"
            }
          }]
        };

        var CLASS_REFERENCE = {
          relevance: 0,
          match: regex.either(
          // Hard coded exceptions
          /\bJSON/,
          // Float32Array, OutT
          /\b[A-Z][a-z]+([A-Z][a-z]*|\d)*/,
          // CSSFactory, CSSFactoryT
          /\b[A-Z]{2,}([A-Z][a-z]+|\d)+([A-Z][a-z]*)*/,
          // FPs, FPsT
          /\b[A-Z]{2,}[a-z]+([A-Z][a-z]+|\d)*([A-Z][a-z]*)*/
          // P
          // single letters are not highlighted
          // BLAH
          // this will be flagged as a UPPER_CASE_CONSTANT instead
          ),
          className: "title.class",
          keywords: {
            _: [].concat(TYPES, ERROR_TYPES)
          }
        };

        var USE_STRICT = {
          label: "use_strict",
          className: 'meta',
          relevance: 10,
          begin: /^\s*['"]use (strict|asm)['"]/
        };

        var FUNCTION_DEFINITION = {
          variants: [{
            match: [/function/, /\s+/, IDENT_RE$1, /(?=\s*\()/]
          },
          // anonymous function
          {
            match: [/function/, /\s*(?=\()/]
          }],
          className: {
            1: "keyword",
            3: "title.function"
          },
          label: "func.def",
          contains: [PARAMS],
          illegal: /%/
        };

        var UPPER_CASE_CONSTANT = {
          relevance: 0,
          match: /\b[A-Z][A-Z_0-9]+\b/,
          className: "variable.constant"
        };

        function noneOf(list) {
          return regex.concat("(?!", list.join("|"), ")");
        }

        var FUNCTION_CALL = {
          match: regex.concat(/\b/, noneOf([].concat(BUILT_IN_GLOBALS, ["super", "import"])), IDENT_RE$1, regex.lookahead(/\(/)),
          className: "title.function",
          relevance: 0
        };

        var PROPERTY_ACCESS = {
          begin: regex.concat(/\./, regex.lookahead(regex.concat(IDENT_RE$1, /(?![0-9A-Za-z$_(])/))),
          end: IDENT_RE$1,
          excludeBegin: true,
          keywords: "prototype",
          className: "property",
          relevance: 0
        };

        var GETTER_OR_SETTER = {
          match: [/get|set/, /\s+/, IDENT_RE$1, /(?=\()/],
          className: {
            1: "keyword",
            3: "title.function"
          },
          contains: [{ // eat to avoid empty params
            begin: /\(\)/
          }, PARAMS]
        };

        var FUNC_LEAD_IN_RE = '(\\(' + '[^()]*(\\(' + '[^()]*(\\(' + '[^()]*' + '\\)[^()]*)*' + '\\)[^()]*)*' + '\\)|' + hljs.UNDERSCORE_IDENT_RE + ')\\s*=>';

        var FUNCTION_VARIABLE = {
          match: [/const|var|let/, /\s+/, IDENT_RE$1, /\s*/, /=\s*/, /(async\s*)?/, // async is optional
          regex.lookahead(FUNC_LEAD_IN_RE)],
          keywords: "async",
          className: {
            1: "keyword",
            3: "title.function"
          },
          contains: [PARAMS]
        };

        return {
          name: 'JavaScript',
          aliases: ['js', 'jsx', 'mjs', 'cjs'],
          keywords: KEYWORDS$1,
          // this will be extended by TypeScript
          exports: { PARAMS_CONTAINS: PARAMS_CONTAINS, CLASS_REFERENCE: CLASS_REFERENCE },
          illegal: /#(?![$_A-z])/,
          contains: [hljs.SHEBANG({
            label: "shebang",
            binary: "node",
            relevance: 5
          }), USE_STRICT, hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE, HTML_TEMPLATE, CSS_TEMPLATE, GRAPHQL_TEMPLATE, TEMPLATE_STRING, COMMENT,
          // Skip numbers when they are part of a variable name
          { match: /\$\d+/ }, NUMBER, CLASS_REFERENCE, {
            className: 'attr',
            begin: IDENT_RE$1 + regex.lookahead(':'),
            relevance: 0
          }, FUNCTION_VARIABLE, { // "value" container
            begin: '(' + hljs.RE_STARTERS_RE + '|\\b(case|return|throw)\\b)\\s*',
            keywords: 'return throw case',
            relevance: 0,
            contains: [COMMENT, hljs.REGEXP_MODE, {
              className: 'function',
              // we have to count the parens to make sure we actually have the
              // correct bounding ( ) before the =>.  There could be any number of
              // sub-expressions inside also surrounded by parens.
              begin: FUNC_LEAD_IN_RE,
              returnBegin: true,
              end: '\\s*=>',
              contains: [{
                className: 'params',
                variants: [{
                  begin: hljs.UNDERSCORE_IDENT_RE,
                  relevance: 0
                }, {
                  className: null,
                  begin: /\(\s*\)/,
                  skip: true
                }, {
                  begin: /\(/,
                  end: /\)/,
                  excludeBegin: true,
                  excludeEnd: true,
                  keywords: KEYWORDS$1,
                  contains: PARAMS_CONTAINS
                }]
              }]
            }, { // could be a comma delimited list of params to a function call
              begin: /,/,
              relevance: 0
            }, {
              match: /\s+/,
              relevance: 0
            }, { // JSX
              variants: [{ begin: FRAGMENT.begin, end: FRAGMENT.end }, { match: XML_SELF_CLOSING }, {
                begin: XML_TAG.begin,
                // we carefully check the opening tag to see if it truly
                // is a tag and not a false positive
                'on:begin': XML_TAG.isTrulyOpeningTag,
                end: XML_TAG.end
              }],
              subLanguage: 'xml',
              contains: [{
                begin: XML_TAG.begin,
                end: XML_TAG.end,
                skip: true,
                contains: ['self']
              }]
            }]
          }, FUNCTION_DEFINITION, {
            // prevent this from getting swallowed up by function
            // since they appear "function like"
            beginKeywords: "while if switch catch for"
          }, {
            // we have to count the parens to make sure we actually have the correct
            // bounding ( ).  There could be any number of sub-expressions inside
            // also surrounded by parens.
            begin: '\\b(?!function)' + hljs.UNDERSCORE_IDENT_RE + '\\(' + // first parens
            '[^()]*(\\(' + '[^()]*(\\(' + '[^()]*' + '\\)[^()]*)*' + '\\)[^()]*)*' + '\\)\\s*\\{', // end parens
            returnBegin: true,
            label: "func.def",
            contains: [PARAMS, hljs.inherit(hljs.TITLE_MODE, { begin: IDENT_RE$1, className: "title.function" })]
          },
          // catch ... so it won't trigger the property rule below
          {
            match: /\.\.\./,
            relevance: 0
          }, PROPERTY_ACCESS,
          // hack: prevents detection of keywords in some circumstances
          // .keyword()
          // $keyword = x
          {
            match: '\\$' + IDENT_RE$1,
            relevance: 0
          }, {
            match: [/\bconstructor(?=\s*\()/],
            className: { 1: "title.function" },
            contains: [PARAMS]
          }, FUNCTION_CALL, UPPER_CASE_CONSTANT, CLASS_OR_EXTENDS, GETTER_OR_SETTER, {
            match: /\$[(.]/ // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
          }]
        };
      }

      return javascript;
    }();

    hljs.registerLanguage('javascript', hljsGrammar);
  })(); /*! `json` grammar compiled for Highlight.js 11.9.0 */
  (function () {
    var hljsGrammar = function () {
      'use strict';

      /*
      Language: JSON
      Description: JSON (JavaScript Object Notation) is a lightweight data-interchange format.
      Author: Ivan Sagalaev <maniac@softwaremaniacs.org>
      Website: http://www.json.org
      Category: common, protocols, web
      */

      function json(hljs) {
        var ATTRIBUTE = {
          className: 'attr',
          begin: /"(\\.|[^\\"\r\n])*"(?=\s*:)/,
          relevance: 1.01
        };
        var PUNCTUATION = {
          match: /[{}[\],:]/,
          className: "punctuation",
          relevance: 0
        };
        var LITERALS = ["true", "false", "null"];
        // NOTE: normally we would rely on `keywords` for this but using a mode here allows us
        // - to use the very tight `illegal: \S` rule later to flag any other character
        // - as illegal indicating that despite looking like JSON we do not truly have
        // - JSON and thus improve false-positively greatly since JSON will try and claim
        // - all sorts of JSON looking stuff
        var LITERALS_MODE = {
          scope: "literal",
          beginKeywords: LITERALS.join(" ")
        };

        return {
          name: 'JSON',
          keywords: {
            literal: LITERALS
          },
          contains: [ATTRIBUTE, PUNCTUATION, hljs.QUOTE_STRING_MODE, LITERALS_MODE, hljs.C_NUMBER_MODE, hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE],
          illegal: '\\S'
        };
      }

      return json;
    }();

    hljs.registerLanguage('json', hljsGrammar);
  })();
  return hljs;
});

},
'highlight/languages/xml':function(){
/*! `xml` grammar compiled for Highlight.js 11.10.0 */
require([], function () {
return (function () {
	'use strict';

	/*
	Language: HTML, XML
	Website: https://www.w3.org/XML/
	Category: common, web
	Audit: 2020
	*/

	/** @type LanguageFn */
	function xml(hljs) {
		const regex = hljs.regex;
		// XML names can have the following additional letters: https://www.w3.org/TR/xml/#NT-NameChar
		// OTHER_NAME_CHARS = /[:\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]/;
		// Element names start with NAME_START_CHAR followed by optional other Unicode letters, ASCII digits, hyphens, underscores, and periods
		// const TAG_NAME_RE = regex.concat(/[A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, regex.optional(/[A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*:/), /[A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*/);;
		// const XML_IDENT_RE = /[A-Z_a-z:\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]+/;
		// const TAG_NAME_RE = regex.concat(/[A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, regex.optional(/[A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*:/), /[A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*/);
		// however, to cater for performance and more Unicode support rely simply on the Unicode letter class
		const TAG_NAME_RE = regex.concat(/[\p{L}_]/u, regex.optional(/[\p{L}0-9_.-]*:/u), /[\p{L}0-9_.-]*/u);
		const XML_IDENT_RE = /[\p{L}0-9._:-]+/u;
		const XML_ENTITIES = {
		className: 'symbol',
		begin: /&[a-z]+;|&#[0-9]+;|&#x[a-f0-9]+;/
		};
		const XML_META_KEYWORDS = {
		begin: /\s/,
		contains: [
			{
			className: 'keyword',
			begin: /#?[a-z_][a-z1-9_-]+/,
			illegal: /\n/
			}
		]
		};
		const XML_META_PAR_KEYWORDS = hljs.inherit(XML_META_KEYWORDS, {
		begin: /\(/,
		end: /\)/
		});
		const APOS_META_STRING_MODE = hljs.inherit(hljs.APOS_STRING_MODE, { className: 'string' });
		const QUOTE_META_STRING_MODE = hljs.inherit(hljs.QUOTE_STRING_MODE, { className: 'string' });
		const TAG_INTERNALS = {
		endsWithParent: true,
		illegal: /</,
		relevance: 0,
		contains: [
			{
			className: 'attr',
			begin: XML_IDENT_RE,
			relevance: 0
			},
			{
			begin: /=\s*/,
			relevance: 0,
			contains: [
				{
				className: 'string',
				endsParent: true,
				variants: [
					{
					begin: /"/,
					end: /"/,
					contains: [ XML_ENTITIES ]
					},
					{
					begin: /'/,
					end: /'/,
					contains: [ XML_ENTITIES ]
					},
					{ begin: /[^\s"'=<>`]+/ }
				]
				}
			]
			}
		]
		};
		return {
		name: 'HTML, XML',
		aliases: [
			'html',
			'xhtml',
			'rss',
			'atom',
			'xjb',
			'xsd',
			'xsl',
			'plist',
			'wsf',
			'svg'
		],
		case_insensitive: true,
		unicodeRegex: true,
		contains: [
			{
			className: 'meta',
			begin: /<![a-z]/,
			end: />/,
			relevance: 10,
			contains: [
				XML_META_KEYWORDS,
				QUOTE_META_STRING_MODE,
				APOS_META_STRING_MODE,
				XML_META_PAR_KEYWORDS,
				{
				begin: /\[/,
				end: /\]/,
				contains: [
					{
					className: 'meta',
					begin: /<![a-z]/,
					end: />/,
					contains: [
						XML_META_KEYWORDS,
						XML_META_PAR_KEYWORDS,
						QUOTE_META_STRING_MODE,
						APOS_META_STRING_MODE
					]
					}
				]
				}
			]
			},
			hljs.COMMENT(
			/<!--/,
			/-->/,
			{ relevance: 10 }
			),
			{
			begin: /<!\[CDATA\[/,
			end: /\]\]>/,
			relevance: 10
			},
			XML_ENTITIES,
			// xml processing instructions
			{
			className: 'meta',
			end: /\?>/,
			variants: [
				{
				begin: /<\?xml/,
				relevance: 10,
				contains: [
					QUOTE_META_STRING_MODE
				]
				},
				{
				begin: /<\?[a-z][a-z0-9]+/,
				}
			]

			},
			{
			className: 'tag',
			/*
			The lookahead pattern (?=...) ensures that 'begin' only matches
			'<style' as a single word, followed by a whitespace or an
			ending bracket.
			*/
			begin: /<style(?=\s|>)/,
			end: />/,
			keywords: { name: 'style' },
			contains: [ TAG_INTERNALS ],
			starts: {
				end: /<\/style>/,
				returnEnd: true,
				subLanguage: [
				'css',
				'xml'
				]
			}
			},
			{
			className: 'tag',
			// See the comment in the <style tag about the lookahead pattern
			begin: /<script(?=\s|>)/,
			end: />/,
			keywords: { name: 'script' },
			contains: [ TAG_INTERNALS ],
			starts: {
				end: /<\/script>/,
				returnEnd: true,
				subLanguage: [
				'javascript',
				'handlebars',
				'xml'
				]
			}
			},
			// we need this for now for jSX
			{
			className: 'tag',
			begin: /<>|<\/>/
			},
			// open tag
			{
			className: 'tag',
			begin: regex.concat(
				/</,
				regex.lookahead(regex.concat(
				TAG_NAME_RE,
				// <tag/>
				// <tag>
				// <tag ...
				regex.either(/\/>/, />/, /\s/)
				))
			),
			end: /\/?>/,
			contains: [
				{
				className: 'name',
				begin: TAG_NAME_RE,
				relevance: 0,
				starts: TAG_INTERNALS
				}
			]
			},
			// close tag
			{
			className: 'tag',
			begin: regex.concat(
				/<\//,
				regex.lookahead(regex.concat(
				TAG_NAME_RE, />/
				))
			),
			contains: [
				{
				className: 'name',
				begin: TAG_NAME_RE,
				relevance: 0
				},
				{
				begin: />/,
				relevance: 0,
				endsParent: true
				}
			]
			}
		]
		};
	}

	return xml;
	});
})
},
'appivo/builder/components/MacroSelect':function(){
define([
    "vue/vue",
    "vue/vue-strap",
    "dojo/_base/lang",
    "appivo/util/Handlebars",
    "../meta/AppivoMacros",
    "../meta/MacroDataFuncs",
    "../meta/MacroRequirementFuncs",
    "appivo/vue/components/TextBox",
    "appivo/vue/components/Selector",
    "dojo/text!../html/MacroSelect.html"
], function(Vue, VueStrap, lang, Handlebars, AppivoMacros, DataFuncs, RequirementFuncs, TextBox, Selector, template) {

    var uidCounter = 0;

    return Vue.extend({
        template: template,
        props: {
            env: {
                type: Object,
                default: function() {
                    return {
                        tags: []
                    };
                }
            },
            value: Object
        },
        data: function() {
            return {
                selectedAction: null,
                inputGenData: {}, //Data used to generate data options
                inputValue: {}, //Value of the input
                inputData: {}, //Data options available for the input
                watches: [],
                inputs: []
            };
        },
        computed: {
            availableActions: function() {
                var t = this;
                var macros = [];
                AppivoMacros.forEach(function(macro) {
                    var include = true;
                    if (t.env.tags) {
                        include = macro.environment.every(function(item) {
                            return (t.env.tags.indexOf(item) !== -1);
                        });
                    }
                    if (include && t.env.environment) {
                        include = macro.environment.indexOf(t.env.environment) !== -1;
                    }
                    if (include && t.checkRequirements(macro)) {
                        macros.push(macro);
                    }
                });
                return macros;
            },
            generator: function() {
                var gen = null;
                if (this.selectedAction && this.selectedAction.generator) {
                    if (!this.selectedAction.generator.generate) {
                        var scriptTemplate = "";
                        if (this.selectedAction.generator.scriptImpl) {
                            scriptTemplate = this.selectedAction.generator.scriptImpl;
                        } else {
                            scriptTemplate = this.selectedAction.generator.impl;
                        }
                        this.selectedAction.generator.generate = Handlebars.compile(scriptTemplate);
                    }
                    gen = this.selectedAction.generator;
                }
                if (gen === null) {
                    gen = {
                        generate: function() {
                            return null;
                        },
                        type: 'N/A'
                    };
                }
                return gen;
            },
            dataContext: function() {
                return {
                    schema: JSON.parse(JSON.stringify(this.$state.data.app)),
                    userInterface: JSON.parse(JSON.stringify(this.$state.data.editUI)),
                    view: this.$state.editView ? this.$state.editView : undefined,
                    editObject: JSON.parse(JSON.stringify(this.$state.data.editObject)),
                    parameters: this.env.parameters ? JSON.parse(JSON.stringify(this.env.parameters)) : undefined
                };
            }
        },
        methods: {
            genInputs: function(action) {
                this.unwatchInputs();
                var inputs = [];
                Vue.set(this, 'inputGenData', {});
                Vue.set(this, 'inputValue', {});
                Vue.set(this, 'inputData', {});
                if (action) {
                    var vars = action.variables;
                    if (vars) {
                        var displayDeps = [];
                        for (var i = 0; i < vars.length; i++) {
                            var v = vars[i];
                            if (v.input) {
                                var input = this.processInput(v);
                                inputs.push(input);
                                if (v.displayWhen && v.displayWhen.length > 0) {
                                    displayDeps.push({
                                        v: v,
                                        i: input
                                    });
                                }
                            }
                        }
                        this.hookInputDeps();
                        this.hookDisplayDeps(displayDeps);
                    }
                }
                Vue.set(this, 'inputs', inputs);
            },
            processInput: function(variable) {
                var input = variable.input;
                var t = this;
                var inputField = {
                    name: variable.name,
                    label: (variable.label !== undefined ? variable.label : variable.name),
                    type: input.type,
                    required: variable.required,
                    missing: variable.required,
                    enabled: input.displayWhen === undefined,
                    optional: input.optional !== undefined ? input.optional : true
                };
                var inputParams = {};
                if (input.params) {
                    for (var i = 0; i < input.params.length; i++) {
                        var param = input.params[i];
                        inputParams[param.name] = param.value;
                    }
                }
                Vue.set(this.inputGenData, variable.name, inputParams);
                Vue.set(this.inputValue, variable.name, (input.defaultValue !== undefined ? input.defaultValue : null));
                Vue.set(this.inputData, variable.name, {});
                this.watches.push(this.$watch('inputGenData.' + variable.name, (function(func, field, additionalOpts, inputOpts, dataSource) {
                    return function(params) {
                        var opts = func(t.dataContext, params);
                        t.mutateOptions(opts, dataSource, inputOpts);
                        if (additionalOpts) {
                            opts = additionalOpts.concat(opts);
                        }
                        Vue.set(t.inputData, field, opts);
                    };
                })(this.getDataFunc(input.data, input.params, input.options), variable.name, input.additionalOptions, input.options, input.data), {
                    immediate: true,
                    deep: true
                }));
                return inputField;
            },
            mutateOptions: function(dataOpts, dataSource, opts) {
                if (opts && (opts.prefixLabels || opts.prefixValues) && dataSource.startsWith('$') && dataSource.indexOf(',') == -1) {
                    for (var i = 0; i < dataOpts.length; i++) {
                        var opt = dataOpts[i];
                        var ds = dataSource.substr(1);
                        if (opts.prefixLabels) {
                            opt.label = DataFuncs.prefixes[ds].label + opt.label;
                        }
                        if (opts.prefixValues) {
                            opt.value = DataFuncs.prefixes[ds].value + opt.value;
                        }
                    }
                }
                return dataOpts;
            },
            getDataFunc: function(dataOpts, paramList, inputOpts) {
                var t = this;
                var func = null;
                if (lang.isArray(dataOpts)) {
                    func = function() {
                        return dataOpts;
                    };
                } else if (typeof dataOpts === 'string') {
                    if (dataOpts.startsWith('$')) {
                        if (dataOpts.indexOf(',') != -1) {
                            var split = dataOpts.substr(1).split(',');
                            func = (function(funcs, inputOpts) {
                                return function(state, opts) {
                                    var arr = [];
                                    for (var i = 0; i < funcs.length; i++) {
                                        var a = DataFuncs.funcs[funcs[i]](state, opts);
                                        t.mutateOptions(a, '$' + funcs[i], inputOpts);
                                        arr = arr.concat(a);
                                        if (inputOpts.separateSets && i < (funcs.length - 1)) {
                                            arr.push({ "divider": true });
                                        }
                                    }
                                    return arr;
                                };
                            })(split, inputOpts);
                        } else {
                            func = DataFuncs.funcs[dataOpts.substr(1)];
                        }
                    } else {
                        var params = ['state'];
                        if (paramList) {
                            paramList.forEach(function(param) {
                                params.push(param.name);
                            });
                        }
                        try {
                            func = new Function(params.join(','), dataOpts);
                        } catch (e) {
                            console.log(e);
                        }
                    }
                }
                if (typeof func !== 'function') {
                    func = function() {
                        return ["BROKEN DATA FUNCTION, CONTACT SUPPORT"];
                    }
                }
                return func;
            },
            hookInputDeps: function() {
                for (var i in this.inputGenData) {
                    var input = this.inputGenData[i];
                    for (var param in input) {
                        var value = input[param];
                        if (value.startsWith("$")) {
                            var ref = value.substr(1);
                            this.watches.push(this.$watch('inputValue.' + ref, (function(input, param) {
                                return function(val) {
                                    var value;
                                    if (val !== undefined) {
                                        value = JSON.parse(JSON.stringify(val));
                                    }
                                    Vue.set(input, param, value);
                                };
                            })(input, param), {
                                immediate: true
                            }));
                        }
                    }
                }
            },
            hookDisplayDeps: function(deps) {
                var t = this;
                for (var i = 0; i < deps.length; i++) {
                    var dep = deps[i];
                    var hooks = [];
                    dep.i.enabled  = true;
                    for (var j = 0; j < dep.v.displayWhen.length; j++) {
                        var criteria = dep.v.displayWhen[j];
                        if (criteria.variable) {
                            hooks.push(criteria.variable);
                        } else if (criteria.requirement) {
                            if (!RequirementFuncs[criteria.requirement](this.dataContext)) {
                                dep.i.enabled = false;
                                break;
                            }
                        }
                    }
                    if (dep.i.enabled) {
                        while (hooks.length > 0) {
                            var hook = hooks.pop();
                            this.watches.push(this.$watch('inputValue.' + hook, (function(dep) {
                                return function() {
                                    t.checkDisplay(dep);
                                };
                            })(dep)));
                        }
                        this.checkDisplay(dep);
                    }
                }
            },
            checkDisplay: function(dep) {
                var t = this;
                dep.i.enabled = dep.v.displayWhen.every(function(criteria) {
                    return (!criteria.variable || criteria.value.indexOf(t.inputValue[criteria.variable]) != -1);
                });
            },
            unwatchInputs: function() {
                while(this.watches.length > 0) {
                    (this.watches.pop())();
                }
            },
            updateValue: function(input, event) {
                var value = null;
                if (event !== null && event !== undefined) {
                    if (event.target) {
                        switch (event.target.type) {
                        case 'checkbox':
                            value = event.target.checked;
                            break;
                        case 'number':
                            value = event.target.valueAsNumber;
                            break;
                        default:
                            if (event.target.value) {
                                value = event.target.value;
                            } else {
                                value = event.value;
                            }

                            break;
                        }
                    } else if (event.value != null && event.value != undefined) {
                        value = event.value;
                    } else {
                        value = event;
                    }
                }
                Vue.set(this.inputValue, input, value);
            },
            genScript: function() {
                if (this.isValid()) {
                    var t = this;
                    var ctx = {
                        'var': this.inputValue,
                        'state': this.dataContext
                    };
                    this.registerHelpers();
                    var script = this.generator.generate(ctx);
                    this.unregisterHelpers();
                    var codeObj = {
                        quick: {
                            action: this.selectedAction.name,
                            input: JSON.parse(JSON.stringify(this.inputValue))
                        },
                        logic: {},
                        script: {
                            script: ''
                        }
                    };
                    codeObj.script.script = script
                    this.$dispatch('macrochange', codeObj);
                } else {
                    this.$dispatch('macrochange', null);
                }
            },
            isValid: function() {
                var valid = true;
                for (var i = 0; i < this.inputs.length; i++) {
                    var input = this.inputs[i];
                    if (input.required) {
                        var val = this.inputValue[input.name];
                        if (val === null || val === undefined || val === '' || val === 'null') {
                            if (input.enabled) {
                                valid = false;
                            }
                            input.missing = true;
                        } else {
                            input.missing = false;
                        }
                    }
                }
                return valid;
            },
            registerHelpers: function() {
                var t = this;
                var handlebars = Handlebars.getHandlebars();
                handlebars.registerHelper('getWidgetType', function(widgetId, opts) {
                    var type = null;
                    if (t.$state.editView) {
                        type = t.$state.editView.getWidget(widgetId).widgetDef.name;
                    }
                    return type;
                });
                handlebars.registerHelper('genUid', function(opts) {
                    return "uid" + (uidCounter++);
                });
            },
            unregisterHelpers: function() {
                var handlebars = Handlebars.getHandlebars();
                handlebars.unregisterHelper('getWidgetType');
                handlebars.unregisterHelper('genUid');
            },
            checkRequirements: function(macro) {
                var ok = true;
                var reqs = macro.requirements;
                for (var i = 0; ok && i < reqs.length; i++) {
                    var req = reqs[i];
                    if (RequirementFuncs[req]) {
                        ok = RequirementFuncs[req](this.dataContext);
                    } else {
                        console.error("Invalid requirement " + req + " for macro " + macro.name + ", treating as fulfilled requirement");
                    }
                }
                return ok;
            },
            convert4selector: function(dataSet) {
                var data = [];
                dataSet.forEach(function(item) {
                    data.push({
                        id: item.value,
                        text: item.label
                    });
                });
                return data;
            }
        },
        ready: function() {
            var t = this;
            if (this.value && this.value.quick) {
                var action = this.availableActions.find(function(a) {
                    return a.name === t.value.quick.action;
                });
                if (action) {
                    var input = this.value.quick.input;
                    Vue.set(this, 'selectedAction', action);
                    Vue.nextTick(function() {
                        for (var param in input) {
                            var value = input[param];
                            //The following section can be removed in the future, it is only for
                            //making old quick actions compatible with the new macro system
                            var type = null;
                            for (var i = 0; i < t.inputs.length; i++) {
                                if (t.inputs[i].name === param) {
                                    type = t.inputs[i].type;
                                    break;
                                }
                            }
                            if (type === 'BOOLEAN' && typeof value === 'string') {
                                value = value === 'true';
                            } else if (type === 'MULTISELECT' && !lang.isArray(value)) {
                                var arr = [];
                                for (var key in value) {
                                    if (value[key]) {
                                        arr.push(key);
                                    }
                                }
                                value = arr;
                            }
                            if (action.name === 'submitForm' && param === 'closeAfterSubmit') {
                                param = 'afterSubmit';
                                if (value === "false") {
                                    value = "nothing";
                                } else {
                                    value = "close";
                                }
                            }
                            //End of section that can be removed
                            Vue.set(t.inputValue, param, value);
                        }
                    });
                }
            }
            //require(["blockly/msg/js/en"], function() {

           // });
        },
        watch: {
            'selectedAction': function(val) {
                this.genInputs(val)
            },
            'inputValue': {
                handler: function () {
                	try {
                		this.genScript();
                	} catch (error) {
                		console.error(error);
                	}
                },
                deep: true
            },
            'generator': function () {
            	try {
            		this.genScript();
            	} catch (error) {
            		console.error(error);
            	}
            }
        },
        components: {
            'textbox': TextBox,
            'tooltip': VueStrap.tooltip,
            'selector': Selector
        }
    });
});
},
'appivo/builder/meta/AppivoMacros':function(){
define([
    "dojo/i18n!../nls/QuickAction"
], function(messages) {

    var actions = [
        {
            "name": "setView",
            "label": messages.setView,
            "description": messages.setViewDesc,
            "environment": ["client", "view"],
            "requirements": [],
            "variables": [
                {
                    "name": "view",
                    "label": messages.selectView,
                    "required": true,
                    "input": {
                        "type": "SELECT",
                        "data": "$views",
                        "params": []
                    }
                },
                {
                    "name": "editObject",
                    "label": messages.editRecord,
                    "required": false,
                    "input": {
                        "type": "SELECT",
                        "data": "$widgets,forms",
                        "options": {
                            "prefixLabels": true,
                            "prefixValues": true,
                            "separateSets": true
                        },
                        "params": [{
                            "name": "filter",
                            "value": "#recordWidgets"
                        }]
                    }
                },
                {
                    "name": "transition",
                    "label": messages.transition,
                    "required": true,
                    "displayWhen": [{
                        "requirement": "isMobileView"
                    }],
                    "input": {
                        "type": "SELECT",
                        "data": "$transitions",
                        "defaultValue": "__default__",
                        "optional": false,
                        "additionalOptions": [{
                            "label": messages.defaultTransition,
                            "value": "__default__"
                        }]
                    }
                }
            ],
            "generator": {
                "type": "logic",
                "impl": "<xml xmlns=\"http://www.w3.org/1999/xhtml\"><block type=\"api_clientsideUI_Context\" id=\"%0h]?w0WjLW9ulQ8la.y\" x=\"263\" y=\"163\"><mutation returnvaluetoggle=\"TRUE\" option=\"SETVIEW\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"FUNC\">SETVIEW</field><field name=\"VIEW\">{{var.view}}</field><field name=\"QUERY\"></field>{{#compare var.transition '!=' '__default__'}}<value name=\"TRANSITION\"><block type=\"text\" id=\"LpafpH`Rsgc4kX`ktmah\"><field name=\"TEXT\">{{var.transition}}</field></block></value>{{/compare}}{{#if var.editObject}}<value name=\"DATA\">{{#startsWith var.editObject 'widget.'}}<block type=\"api_{{#if (logicalOperator state.view.widgetType '==' 'MView')}}mobileWidget{{else}}desktopWidget{{/if}}_widget\" id=\"u||)t9OBt^qo(sJ(Jfaw\" inline=\"false\"><mutation type=\"{{subString var.editObject 7}}@{{getWidgetType (subString var.editObject 7)}}\" returnvaluetoggle=\"TRUE\" option=\"{{toUpperCase (getWidgetType (subString var.editObject 7))}}_{{#if (logicalOperator (getWidgetType (subString var.editObject 7)) '==' 'DataGrid')}}GETACTIVERECORD{{else}}GETSELECTEDRECORD{{/if}}\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"TYPE\">{{subString var.editObject 7}}@{{getWidgetType (subString var.editObject 7)}}</field><field name=\"FUNC\">{{toUpperCase (getWidgetType (subString var.editObject 7))}}_{{#if (logicalOperator (getWidgetType (subString var.editObject 7)) '==' 'DataGrid')}}GETACTIVERECORD{{else}}GETSELECTEDRECORD{{/if}}</field></block>{{/startsWith}}{{#startsWith var.editObject 'form.'}}<block type=\"api_clientside_Form\" id=\"`p^33l(^)LKpEV[^?8bV\"><mutation returnvaluetoggle=\"TRUE\" option=\"GETRECORDID\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"FUNC\">GETRECORDID</field><value name=\"API_OBJECT\"><block type=\"api_clientsideUI_Context\" id=\"6/{szV-JRwFK~/mUFy|7\"><mutation returnvaluetoggle=\"TRUE\" option=\"GETFORM\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"FUNC\">GETFORM</field><field name=\"FORMID\">{{subString var.editObject 5}}</field></block></value></block>{{/startsWith}}</value>{{/if}}</block></xml>",
                "scriptImpl": "{{#startsWith var.editObject \"widget.\"}}var widget = context.getWidget(\"{{subString var.editObject 7}}\");\nvar record;\nif(widget.getActiveRecord) {\n\trecord = widget.getActiveRecord();\n} else {\n\trecord = widget.getSelectedRecord();\n}\n{{/startsWith}}{{#startsWith var.editObject \"form.\"}}var form = context.getForm(\"{{subString var.editObject 5}}\");\n{{/startsWith}}context.setView({{#compare var.transition '!=' \"__default__\"}}{\n\t\"transition\":\"{{var.transition}}\",\n\t\"view\": {{/compare}}\"{{var.view}}\"{{#compare var.transition \"!=\" \"__default__\"}}\n}{{/compare}}{{#startsWith var.editObject \"widget.\"}}, record.id ? record.id : record{{/startsWith}}{{#startsWith var.editObject \"form.\"}}, form.getRecordId(){{/startsWith}});"
            }
        },
        {
            "name": "setUI",
            "label": messages.setUI,
            "description": messages.setUIDesc,
            "environment": ["client", "view"],
            "requirements": [],
            "variables": [
                {
                    "name": "ui",
                    "label": messages.selectUI,
                    "required": true,
                    "input": {
                        "type": "SELECT",
                        "data": "$uis",
                        "params": []
                    }
                },
                {
                    "name": "view",
                    "label": messages.selectView,
                    "required": false,
                    "input": {
                        "type": "SELECT",
                        "data": "$views",
                        "params": [{
                            "name": "uiName",
                            "value": "$ui"
                        }]
                    }
                },
                {
                    "name": "editObject",
                    "label": messages.editRecord,
                    "required": false,
                    "input": {
                        "type": "SELECT",
                        "data": "$widgets,forms",
                        "options": {
                            "prefixLabels": true,
                            "prefixValues": true,
                            "separateSets": true
                        },
                        "params": [{
                            "name": "filter",
                            "value": "#recordWidgets"
                        }]
                    }
                },
                {
                    "name": "transition",
                    "label": messages.transition,
                    "required": true,
                    "displayWhen": [{
                        "requirement": "isMobileView"
                    }],
                    "input": {
                        "type": "SELECT",
                        "data": "$transitions",
                        "defaultValue": "__default__",
                        "optional": false,
                        "additionalOptions": [{
                            "label": messages.defaultTransition,
                            "value": "__default__"
                        }]
                    }
                }
            ],
            "generator": {
                "type": "script",
                "impl": "{{#startsWith var.editObject \"widget.\"}}var widget = context.getWidget(\"{{subString var.editObject 7}}\");\nvar record;\nif (widget.getActiveRecord) {\n\trecord = widget.getActiveRecord();\n} else {\n\trecord = widget.getSelectedRecord();\n}\n\n{{/startsWith}}{{#startsWith var.editObject \"form.\"}}var form = context.getForm(\"{{subString var.editObject 5}}\");\n\n{{/startsWith}}context.setUI({{#compare var.transition '!=' \"__default__\"}}{\n\t\"transition\": \"{{var.transition}}\",\n\t\"ui\": {{/compare}}\"{{var.ui}}\"{{#compare var.transition '!=' \"__default__\"}}\n}{{/compare}}{{#notNullOrEmpty var.view}}, \"{{var.view}}\"{{#startsWith var.editObject \"widget.\"}}, record.id ? record.id : record{{/startsWith}}{{#startsWith var.editObject \"form.\"}}, form.getRecordId(){{/startsWith}}{{/notNullOrEmpty}});"
            }
        },
        {
            "name": "goBack",
            "label": messages.goBack,
            "description": messages.goBackDesc,
            "environment": ["client", "view"],
            "requirements": [],
            "variables": [
                {
                    "name": "transition",
                    "label": messages.transition,
                    "required": false,
                    "displayWhen": [{
                        "requirement": "isMobileView"
                    }],
                    "input": {
                        "type": "SELECT",
                        "data": "$transitions",
                        "defaultValue": "__default__",
                        "optional": false,
                        "additionalOptions": [{
                            "label": messages.defaultTransition,
                            "value": "__default__"
                        }]
                    }
                }
            ],
            "generator": {
                "type": "logic",
                "impl": "<xml xmlns=\"http://www.w3.org/1999/xhtml\"><block type=\"api_clientsideUI_Context\"><mutation returnvaluetoggle=\"TRUE\" option=\"BACK\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"FUNC\">BACK</field>{{#compare var.transition '!=' '__default__'}}<value name=\"OPTS\"><block type=\"dicts_create_with\"><mutation items=\"1\"></mutation><field name=\"KEY0\">transition</field><value name=\"VALUE0\"><block type=\"text\"><field name=\"TEXT\">{{var.transition}}</field></block></value></block></value>{{/compare}}</block></xml>",
                "scriptImpl": "context.back({{#compare var.transition '!=' \"__default__\"}}{\n\t\"transition\":\"{{var.transition}}\"\n}{{/compare}});"
            }
        },
        {
            "name": "invoke",
            "label": messages.invoke,
            "description": messages.invokeDesc,
            "environment": ["client", "view"],
            "requirements": ["hasInvokableFunctions"],
            "variables": [
                {
                    "name": "func",
                    "label": "Function to invoke",
                    "required": true,
                    "input": {
                        "type": "SELECT",
                        "data": "$invokableFunctions",
                        "params": []
                    }
                }
            ],
            "generator": {
                "type": "logic",
                "impl": "<xml xmlns=\"http://www.w3.org/1999/xhtml\"><block type=\"api_clientsideRuntime_Context\" id=\"~9egn{+2alub7a}FlZ1A\" x=\"-103\" y=\"-38\"><mutation returnvaluetoggle=\"FALSE\" option=\"INVOKE\"></mutation><field name=\"ReturnValue\">FALSE</field><field name=\"FUNC\">INVOKE</field><value name=\"FUNCNAME\"><shadow type=\"text\" id=\"xmnqXpCpE}zbuM(:Lg@.\"><field name=\"TEXT\">{{var.func}}</field></shadow></value><value name=\"ARGS\"><block type=\"dicts_create_with\" id=\"T-^U*7M#rL7EiF}C[SlN\"><mutation items=\"0\"></mutation></block></value></block></xml>"
            }
        },
        {
            "name": "submitForm",
            "label": messages.submitForm,
            "description": messages.submitFormDesc,
            "environment": ["client", "view"],
            "requirements": ["hasForm"],
            "variables": [
                {
                    "name": "form",
                    "label": messages.formToSubmit,
                    "required": true,
                    "input": {
                        "type": "SELECT",
                        "data": "$forms",
                        "params": []
                    }
                },
                {
                    "name": "full",
                    "label": messages.submitFull,
                    "required": false,
                    "input": {
                        "defaultValue": false,
                        "type": "BOOLEAN"
                    }
                },
                {
                    "name": "afterSubmit",
                    "label": messages.afterSubmit,
                    "required": false,
                    "input": {
                        "type": "SELECT",
                        "optional": false,
                        "data": [{
                            "value": "nothing",
                            "label": messages.doNothing
                        },{
                            "value": "close",
                            "label": messages.goBackClose
                        },{
                            "value": "refresh",
                            "label": messages.refreshWidget
                        }],
                        "defaultValue": "nothing"
                    }
                },
                {
                    "name": "widget",
                    "label": messages.widgetRefresh,
                    "required": true,
                    "displayWhen": [{
                        "variable": "afterSubmit",
                        "value": ["refresh"]
                    }],
                    "input": {
                        "type": "SELECT",
                        "data": "$widgets",
                        "params": [{
                            "name": "filter",
                            "value": "#refreshable"
                        }]
                    }
                }
            ],
            "generator": {
                "type": "logic",
                "impl": "<xml xmlns=\"http://www.w3.org/1999/xhtml\"><block type=\"api_clientside_Form\" id=\"}QUbP(4{M4M0N5EwLqMG\" x=\"94\" y=\"137\"><mutation returnvaluetoggle=\"FALSE\" option=\"SUBMIT\"></mutation><field name=\"ReturnValue\">FALSE</field><field name=\"FUNC\">SUBMIT</field><field name=\"_SPARAM\">data</field><field name=\"_FPARAM\">error</field><value name=\"API_OBJECT\"><block type=\"api_clientsideUI_Context\" id=\"5tvYN#U9QaZVq;QR-(Uf\"><mutation returnvaluetoggle=\"TRUE\" option=\"GETFORM\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"FUNC\">GETFORM</field><field name=\"FORMID\">{{var.form}}</field></block></value><value name=\"FULL\"><shadow type=\"logic_boolean\" id=\";X]F72=x,.]mS!5!yP]1\"><field name=\"BOOL\">{{toUpperCase var.full}}</field></shadow></value>{{#compare var.afterSubmit '!=' 'nothing'}}<statement name=\"_ONSUCCESS\">{{#compare var.afterSubmit '==' 'close'}}{{#compare state.view.widgetType '==' 'Dialog'}}<block type=\"api_clientsideUI_Context\" id=\"qsqXj2W4K!jBiC}C91)m\"><mutation returnvaluetoggle=\"TRUE\" option=\"CLOSEDIALOG\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"FUNC\">CLOSEDIALOG</field></block>{{/compare}}{{#compare state.view.widgetType '!=' 'Dialog'}}<block type=\"api_clientsideUI_Context\" id=\")uatf!8^UarJ6af|Ev}S\"><mutation returnvaluetoggle=\"TRUE\" option=\"BACK\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"FUNC\">BACK</field></block>{{/compare}}{{/compare}}{{#compare var.afterSubmit '==' 'refresh'}}<block type=\"{{#compare state.view.widgetType '==' 'MView'}}api_mobileWidget_widget{{/compare}}{{#compare state.view.widgetType '==' 'View'}}api_desktopWidget_widget{{/compare}}{{#compare state.view.widgetType '==' 'Dialog'}}api_desktopWidget_widget{{/compare}}\" id=\"/peoSnQU;8O89F(cRsf6\" inline=\"false\"><mutation type=\"{{var.widget}}@{{getWidgetType var.widget}}\" returnvaluetoggle=\"TRUE\" option=\"{{toUpperCase (getWidgetType var.widget)}}_{{#if (logicalOperator (logicalOperator (getWidgetType var.widget) '==' 'MSelect') '||' (logicalOperator (getWidgetType var.widget) '==' 'Select'))}}RELOAD{{else}}REFRESH{{/if}}\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"TYPE\">{{var.widget}}@{{getWidgetType var.widget}}</field><field name=\"FUNC\">{{toUpperCase (getWidgetType var.widget)}}_{{#if (logicalOperator (logicalOperator (getWidgetType var.widget) '==' 'MSelect') '||' (logicalOperator (getWidgetType var.widget) '==' 'Select'))}}RELOAD{{else}}REFRESH{{/if}}</field></block>{{/compare}}</statement>{{/compare}}</block></xml>",
                "scriptImpl": "var form = context.getForm(\"{{var.form}}\");\nform.submit({{#if (logicalOperator (logicalOperator var.afterSubmit '!=' 'nothing') '||' var.full)}}{ {{#compare var.afterSubmit '!=' 'nothing'}}\n\tonSuccess: function(res) {\n\t\t{{#compare var.afterSubmit '==' 'close'}}var view = context.getView();\n\t\tif (view.widgetType == 'Dialog') {\n\t\t\tview.close();\n\t\t} else {\n\t\t\tcontext.back();\n\t\t}{{/compare}}{{#compare var.afterSubmit '==' 'refresh'}}var widget = context.getWidget(\"{{var.widget}}\");\n\t\twidget.refresh();{{/compare}}\n\t}{{#if var.full}},{{/if}}{{/compare}}{{#if var.full}}\n\tfull: true{{/if}}\n}{{/if}});"
            }
        },
        {
            "name": "openDialog",
            "label": messages.openDialog,
            "description": messages.openDialogDesc,
            "environment": ["client", "view", "desktop"],
            "requirements": [],
            "variables": [
                {
                    "name": "dialog",
                    "label": messages.selectDialog,
                    "required": true,
                    "input": {
                        "type": "SELECT",
                        "data": "$views",
                        "params": [{
                            "name": "type",
                            "value": "Dialog"
                        }]
                    }
                },
                {
                    "name": "editObject",
                    "label": messages.editRecordFromWid,
                    "required": false,
                    "input": {
                        "type": "SELECT",
                        "data": "$widgets,forms",
                        "options": {
                            "prefixLabels": true,
                            "prefixValues": true,
                            "separateSets": true
                        },
                        "params": [{
                            "name": "filter",
                            "value": "#recordWidgets"
                        }]
                    }
                }
            ],
            "generator": {
                "type": "logic",
                "impl":"<xml xmlns=\"http://www.w3.org/1999/xhtml\"><block type=\"api_clientsideUI_Context\" id=\"=22.ek;Xe+TTFBe.w!?u\" x=\"163\" y=\"137\"><mutation returnvaluetoggle=\"TRUE\" option=\"OPENDIALOG\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"FUNC\">OPENDIALOG</field><field name=\"DIALOG\">{{var.dialog}}</field><field name=\"_SPARAM\">data</field><field name=\"_FPARAM\">error</field>{{#if var.editObject}}<value name=\"DATA\">{{#startsWith var.editObject 'widget.'}}<block type=\"api_{{#if (logicalOperator state.view.widgetType '==' 'MView')}}mobileWidget{{else}}desktopWidget{{/if}}_widget\" id=\"u||)t9OBt^qo(sJ(Jfaw\" inline=\"false\"><mutation type=\"{{subString var.editObject 7}}@{{getWidgetType (subString var.editObject 7)}}\" returnvaluetoggle=\"TRUE\" option=\"{{toUpperCase (getWidgetType (subString var.editObject 7))}}_{{#if (logicalOperator (getWidgetType (subString var.editObject 7)) '==' 'DataGrid')}}GETACTIVERECORD{{else}}GETSELECTEDRECORD{{/if}}\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"TYPE\">{{subString var.editObject 7}}@{{getWidgetType (subString var.editObject 7)}}</field><field name=\"FUNC\">{{toUpperCase (getWidgetType (subString var.editObject 7))}}_{{#if (logicalOperator (getWidgetType (subString var.editObject 7)) '==' 'DataGrid')}}GETACTIVERECORD{{else}}GETSELECTEDRECORD{{/if}}</field></block>{{/startsWith}}{{#startsWith var.editObject 'form.'}}<block type=\"api_clientside_Form\" id=\"`p^33l(^)LKpEV[^?8bV\"><mutation returnvaluetoggle=\"TRUE\" option=\"GETRECORDID\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"FUNC\">GETRECORDID</field><value name=\"API_OBJECT\"><block type=\"api_clientsideUI_Context\" id=\"6/{szV-JRwFK~/mUFy|7\"><mutation returnvaluetoggle=\"TRUE\" option=\"GETFORM\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"FUNC\">GETFORM</field><field name=\"FORMID\">{{subString var.editObject 5}}</field></block></value></block>{{/startsWith}}</value>{{/if}}</block></xml>",
                "scriptImpl": "{{#if var.editObject}}var widget = context.getWidget(\"{{var.editObject}}\");\nvar record;\nif(widget.getActiveRecord) {\n\trecord = widget.getActiveRecord();\n} else {\n\trecord = widget.getSelectedRecord();\n}\n{{/if}}context.openDialog(\"{{var.dialog}}\"{{#if var.editObject}}, record.id ? record.id : record{{/if}});",
            }
        },
        {
            "name": "closeDialog",
            "label": messages.closeDialog,
            "description": messages.closeDialogDesc,
            "environment": ["client", "view", "Dialog"],
            "requirements": [],
            "variables": [
                {
                    "name": "formSave",
                    "label": messages.formsToSave,
                    "required": false,
                    "input": {
                        "type": "SELECT",
                        "data": "$forms",
                        "params": [],
                        "optional": true
                    }
                }
            ],
            "generator": {
                "type": "logic",
                "impl": "<xml xmlns=\"http://www.w3.org/1999/xhtml\">{{#if var.formSave}}<block type=\"api_clientside_Form\" id=\"jn64VM5Kg]IARaJ^7?*]\" x=\"138\" y=\"38\"><mutation returnvaluetoggle=\"FALSE\" option=\"SUBMIT\"></mutation><field name=\"ReturnValue\">FALSE</field><field name=\"FUNC\">SUBMIT</field><field name=\"_SPARAM\">data</field><field name=\"_FPARAM\">error</field><value name=\"API_OBJECT\"><block type=\"api_clientsideUI_Context\" id=\"vuayxpz|vjAA:=akKI|Y\"><mutation returnvaluetoggle=\"TRUE\" option=\"GETFORM\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"FUNC\">GETFORM</field><field name=\"FORMID\">{{var.formSave}}</field></block></value><value name=\"FULL\"><shadow type=\"logic_boolean\" id=\"}u[pE1rtTpE~B1p=qUH)\"><field name=\"BOOL\">FALSE</field></shadow></value><statement name=\"_ONSUCCESS\">{{/if}}<block type=\"api_clientsideUI_Context\" id=\"t}@v3Bv0E5ivM[H~Gf4%\" x=\"238\" y=\"138\"><mutation returnvaluetoggle=\"TRUE\" option=\"CLOSEDIALOG\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"FUNC\">CLOSEDIALOG</field></block>{{#if var.formSave}}</statement></block>{{/if}}</xml>",
                "scriptImpl": "{{#if var.formSave}}\nvar form = context.getForm(\"{{var.formSave}}\");\nform.submit({\n\tonSuccess: function(result) {\n\t\t{{/if}}context.getView().close({{#if var.formSave}}result);\n\t}\n});{{else}});{{/if}}"
            }
        },
        {
            "name": "createWindow",
            "label": messages.createWindow,
            "description": messages.createWindowDesc,
            "environment": ["client", "view"],
            "requirements": ["hasRecordWidget"],
            "variables": [
                {
                    "name": "recordWid",
                    "label": messages.recordIdWid,
                    "required": true,
                    "input": {
                        "type": "SELECT",
                        "data": "$widgets",
                        "params": [{
                            "name": "filter",
                            "value": "#recordWidgets"
                        }]
                    }
                },
                {
                    "name": "template",
                    "label": messages.selTemplate,
                    "required": true,
                    "input": {
                        "type": "SELECT",
                        "data": "$templates",
                        "params": []
                    }
                }
            ],
            "generator": {
                "type": "logic",
                "impl": "<xml xmlns=\"http://www.w3.org/1999/xhtml\"><block type=\"api_clientsideUI_Context\" id=\"1UHblr=]ivOdg)u9=A_D\" x=\"163\" y=\"88\"><mutation returnvaluetoggle=\"TRUE\" option=\"CREATEWINDOW\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"FUNC\">CREATEWINDOW</field><value name=\"TEMPLATE\"><block type=\"text\" id=\"P?)![1[EOwFh*8~X)|a5\"><field name=\"TEXT\">{{var.template}}</field></block></value><value name=\"DATA\"><block type=\"api_{{#if (logicalOperator state.view.widgetType '==' 'MView')}}mobileWidget{{else}}desktopWidget{{/if}}_widget\" id=\"u||)t9OBt^qo(sJ(Jfaw\" inline=\"false\"><mutation type=\"{{var.recordWid}}@{{getWidgetType var.recordWid}}\" returnvaluetoggle=\"TRUE\" option=\"{{toUpperCase (getWidgetType var.recordWid)}}_{{#if (logicalOperator (getWidgetType var.recordWid) '==' 'DataGrid')}}GETACTIVERECORD{{else}}GETSELECTEDRECORD{{/if}}\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"TYPE\">{{var.recordWid}}@{{getWidgetType var.recordWid}}</field><field name=\"FUNC\">{{toUpperCase (getWidgetType var.recordWid)}}_{{#if (logicalOperator (getWidgetType var.recordWid) '==' 'DataGrid')}}GETACTIVERECORD{{else}}GETSELECTEDRECORD{{/if}}</field></block></value><value name=\"CONTENT\"><shadow type=\"text\" id=\"hqgInx=}sVDlE,+4};!i\"><field name=\"TEXT\">window content</field></shadow></value></block></xml>",
                "scriptImpl": "var widget = context.getWidget(\"{{var.recordWid}}\");\nvar record;\nif (widget.getActiveRecord) {\n\trecord = widget.getActiveRecord();\n} else {\n\trecord = widget.getSelectedRecord();\n}\ncontext.createWindow({\n\ttemplate: \"{{var.template}}\",\n\tdata: record\n});"
            }
        },
        {
            "name": "loadRecordToForm",
            "label": messages.loadRecordToForm,
            "description": messages.loadRecordDesc,
            "environment": ["client", "view"],
            "requirements": ["hasRecordWidget", "hasForm"],
            "variables": [
                {
                    "name": "recordWid",
                    "label": messages.recordIdWid,
                    "required": true,
                    "input": {
                        "type": "SELECT",
                        "data": "$widgets",
                        "params": [{
                            "name": "filter",
                            "value": "#recordWidgets"
                        }]
                    }
                },
                {
                    "name": "form",
                    "label": messages.selectForm,
                    "required": true,
                    "input": {
                        "type": "SELECT",
                        "data": "$forms",
                        "params": []
                    }
                }
            ],
            "generator": {
                "type": "logic",
                "impl": "<xml xmlns=\"http://www.w3.org/1999/xhtml\"><block type=\"api_clientside_Form\" id=\"7kHOMlR`czZR`2W,^FqH\" x=\"213\" y=\"37\"><mutation returnvaluetoggle=\"TRUE\" option=\"BLOCKLYLOAD\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"FUNC\">BLOCKLYLOAD</field><field name=\"_SPARAM\">data</field><field name=\"_FPARAM\">error</field><value name=\"API_OBJECT\"><block type=\"api_clientsideUI_Context\" id=\"fZNGh3A_r:O~dVd0Kl-D\"><mutation returnvaluetoggle=\"TRUE\" option=\"GETFORM\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"FUNC\">GETFORM</field><field name=\"FORMID\">{{var.form}}</field></block></value><value name=\"ID\"><block type=\"api_clientside_Record\" id=\"Bcx.vyvH(o?aarK{y0g_\"><mutation returnvaluetoggle=\"TRUE\" option=\"GETID\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"FUNC\">GETID</field><value name=\"API_OBJECT\"><block type=\"api_{{#if (logicalOperator state.view.widgetType '==' 'MView')}}mobileWidget{{else}}desktopWidget{{/if}}_widget\" id=\"u||)t9OBt^qo(sJ(Jfaw\" inline=\"false\"><mutation type=\"{{var.recordWid}}@{{getWidgetType var.recordWid}}\" returnvaluetoggle=\"TRUE\" option=\"{{toUpperCase (getWidgetType var.recordWid)}}_{{#if (logicalOperator (getWidgetType var.recordWid) '==' 'DataGrid')}}GETACTIVERECORD{{else}}GETSELECTEDRECORD{{/if}}\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"TYPE\">{{var.recordWid}}@{{getWidgetType var.recordWid}}</field><field name=\"FUNC\">{{toUpperCase (getWidgetType var.recordWid)}}_{{#if (logicalOperator (getWidgetType var.recordWid) '==' 'DataGrid')}}GETACTIVERECORD{{else}}GETSELECTEDRECORD{{/if}}</field></block></value></block></value></block></xml>",
                "scriptImpl": "var widget = context.getWidget(\"{{var.recordWid}}\");\nvar record;\nif (widget.getActiveRecord) {\n\trecord = widget.getActiveRecord();\n} else {\n\trecord = widget.getSelectedRecord();\n}\nvar form = context.getForm(\"{{var.form}}\");\nform.load(record.id ? record.id : record);"
            }
        },
        {
            "name": "notify",
            "label": messages.notify,
            "description": messages.notifyDesc,
            "environment": ["client", "view"],
            "requirements": [],
            "variables": [
                {
                    "name": "string",
                    "label": messages.notifyText,
                    "required": true,
                    "input": {
                        "type": "SELECT",
                        "data": "$strings",
                        "defaultValue": "custom",
                        "optional": false,
                        "additionalOptions": [{
                            "value": "custom",
                            "label": "-- " + messages.customText + " --"
                        }]
                    }
                },
                {
                    "name": "text",
                    "label": messages.customText,
                    "required": true,
                    "displayWhen": [{
                        "variable": "string",
                        "value": "custom"
                    }],
                    "input": {
                        "type": "TEXT"
                    }
                },
                {
                    "name": "type",
                    "label": messages.notifyType,
                    "required": true,
                    "input": {
                        "type": "SELECT",
                        "data": [{
                            label: messages.error,
                            value: "error"
                        },{
                            label: messages.info,
                            value: "info"
                        },
                        {
                            label: messages.success,
                            value: "success"
                        }]
                    }
                }
            ],
            "generator": {
                "type": "logic",
                "impl": "<xml xmlns=\"http://www.w3.org/1999/xhtml\"><block type=\"api_clientsideUI_Context\" id=\"#a!Od1Ia=m2L|6gUvH!8\" x=\"313\" y=\"63\"><mutation returnvaluetoggle=\"TRUE\" option=\"NOTIFY\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"FUNC\">NOTIFY</field><value name=\"DELAY\"><shadow type=\"math_number\" id=\"kIU=2:Zw,LAX~q-!L@gE\"><field name=\"NUM\">1</field></shadow></value><value name=\"TYPE\"><shadow type=\"text\" id=\"8`_x0sXr{b#}wJX~iM|,\"><field name=\"TEXT\">{{var.type}}</field></shadow></value><value name=\"MESSAGE\"><shadow type=\"text\" id=\"]=,!{YohKsnINqn-t;vE\"><field name=\"TEXT\">{{#compare var.string '==' 'custom'}}{{var.text}}{{/compare}}{{#compare var.string '!=' 'custom'}}message{{/compare}}</field></shadow>{{#compare var.string '!=' 'custom'}}<block type=\"api_clientsideApplication_Context\" id=\"ocATN}90vUK|_3(oH~_)\"><mutation returnvaluetoggle=\"TRUE\" option=\"GETSTRING\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"FUNC\">GETSTRING</field><value name=\"NAME\"><block type=\"text\" id=\"A^xU=L4LOv-tJLpMCgb8\"><field name=\"TEXT\">{{var.string}}</field></block></value></block>{{/compare}}</value></block></xml>",
                "scriptImpl": "context.notify({\n\tmessage: {{#compare var.string '==' 'custom'}}\"{{var.text}}\"{{/compare}}{{#compare var.string '!=' 'custom'}}context.getString(\"{{var.string}}\"){{/compare}},\n\ttype: \"{{var.type}}\"\n});"
            }
        },
        {
            "name": "playSound",
            "label": messages.playSound,
            "description": messages.playSoundDesc,
            "environment": ["client", "view"],
            "requirements": [],
            "variables": [
                {
                    "name": "sound",
                    "label": messages.soundName,
                    "required": true,
                    "input": {
                        "type": "SELECT",
                        "data": "$resources",
                        "params": [{
                            "name": "contenttype",
                            "value": "audio/"
                        }]
                    }
                }
            ],
            "generator": {
                "type": "logic",
                "impl": "<xml xmlns=\"http://www.w3.org/1999/xhtml\"><block type=\"api_clientsideUI_Context\" id=\"zxaDiNSL;/gfBo9ODh|l\" x=\"438\" y=\"163\"><mutation returnvaluetoggle=\"TRUE\" option=\"PLAYSOUND\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"FUNC\">PLAYSOUND</field><value name=\"NAME\"><block type=\"text\" id=\"!:Mu;9WJ2KD.(Up)F|h]\"><field name=\"TEXT\">{{var.sound}}</field></block></value></block></xml>",
                "scriptImpl": "context.playSound(\"{{var.sound}}\");"
            }
        },
        {
            "name": "setAttributeValue",
            "label": messages.setAttrValue,
            "description": messages.setAttrValDesc,
            "environment": ["server", "action", "SCRIPT"],
            "requirements": [],
            "variables": [
                {
                    "name": "record",
                    "label": messages.forRecord,
                    "required": true,
                    "input": {
                        "type": "SELECT",
                        "data": "$records"
                    }
                },
                {
                    "name": "attribute",
                    "label": messages.attribute,
                    "required": true,
                    "input": {
                        "type": "TEXT"
                    }
                },
                {
                    "name": "value",
                    "label": messages.value,
                    "required": true,
                    "input": {
                        "type": "TEXT"
                    }
                }
            ],
            "generator": {
                "type": "logic",
                "impl": "<xml xmlns=\"http://www.w3.org/1999/xhtml\"><block type=\"api_serverside_Record\" id=\"swTMK/m.+a67gHNCb5;G\" x=\"38\" y=\"113\"><mutation returnvaluetoggle=\"FALSE\" option=\"SETATTRIBUTEVALUE\"></mutation><field name=\"ReturnValue\">FALSE</field><field name=\"FUNC\">SETATTRIBUTEVALUE</field><value name=\"API_OBJECT\">{{#compare var.record '==' 'CurrentRecord'}}<block type=\"api_serversideRuntime_Context\" id=\"a5?Or2!SWs%]|q4)CU3J\"><mutation returnvaluetoggle=\"TRUE\" option=\"GETRECORD\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"FUNC\">GETRECORD</field></block>{{/compare}}{{#compare var.record '==' 'CurrentUser'}}<block type=\"api_serversideRuntime_Context\" id=\"E+%~sfQx}AZbouH0.A.H\" x=\"62\" y=\"238\"><mutation returnvaluetoggle=\"TRUE\" option=\"GETUSER\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"FUNC\">GETUSER</field></block>{{/compare}}</value><value name=\"ARG0\"><shadow type=\"text\" id=\"R[tNhStL8s1F+e~we0+I\"><field name=\"TEXT\">{{var.attribute}}</field></shadow></value><value name=\"ARG1\"><block type=\"text\" id=\"/I39CiQR^0G8?I8IG,qn\"><field name=\"TEXT\">{{var.value}}</field></block></value></block></xml>",
                "scriptImpl": "var record = {{#compare var.record '==' 'CurrentRecord'}}context.getRecord(){{/compare}}{{#compare var.record '==' 'CurrentUser'}}context.getUser(){{/compare}};\nrecord.setAttributeValue(\"{{var.attribute}}\", \"{{var.value}}\");"
            }
        },
        {
            "name": "assignToRole",
            "label": messages.assignToRole,
            "description": messages.assignRoleDesc,
            "environment": ["server", "action", "SCRIPT"],
            "requirements": [],
            "variables": [
                {
                    "name": "right",
                    "label": messages.assignPriv,
                    "required": true,
                    "input": {
                        "type": "MULTISELECT",
                        "data": "$rights"
                    }
                },
                {
                    "name": "record",
                    "label": messages.forRecord,
                    "required": true,
                    "input": {
                        "type": "SELECT",
                        "data": "$records"
                    }
                },
                {
                    "name": "role",
                    "label": messages.toRole,
                    "required": true,
                    "input": {
                        "type": "SELECT",
                        "data": "$roles"
                    }
                }
            ],
            "generator": {
                "type": "logic",
                "impl": "<xml xmlns=\"http://www.w3.org/1999/xhtml\"><block type=\"appivo_declare\" id=\"AU*LkUz2[yg+|/:gk~.W\" x=\"238\" y=\"137\"><mutation datatype=\"Record\"></mutation><field name=\"VAR\">record</field><field name=\"TYPE\">Record</field><value name=\"VALUE\">{{#compare var.record '==' 'CurrentRecord'}}<block type=\"api_serversideRuntime_Context\" id=\"a5?Or2!SWs%]|q4)CU3J\"><mutation returnvaluetoggle=\"TRUE\" option=\"GETRECORD\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"FUNC\">GETRECORD</field></block>{{/compare}}{{#compare var.record '==' 'CurrentUser'}}<block type=\"api_serversideRuntime_Context\" id=\"E+%~sfQx}AZbouH0.A.H\" x=\"62\" y=\"238\"><mutation returnvaluetoggle=\"TRUE\" option=\"GETUSER\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"FUNC\">GETUSER</field></block>{{/compare}}</value><next>{{#each var.right}}<block type=\"api_serversideApplication_Context\" id=\"{{genUid}}\"><mutation returnvaluetoggle=\"TRUE\" option=\"ASSIGNTOROLE\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"FUNC\">ASSIGNTOROLE</field><field name=\"ARG1\">{{var.role}}</field><value name=\"ARG0\"><block type=\"variables_get\" id=\"{{genUid}}\"><mutation futureop=\"false\" datatype=\"Record\"></mutation><field name=\"VAR\">record</field></block></value><value name=\"ARG2\"><shadow type=\"text\" id=\"{{genUid}}\"><field name=\"TEXT\">{{this}}</field></shadow></value>{{#unless @last}}<next>{{/unless}}{{/each}}{{#each var.right}}</block>{{#unless @last}}</next>{{/unless}}{{/each}}</next></block></xml>",
                "scriptImpl": "var role = \"{{var.role}}\";\nvar record = {{#compare var.record '==' 'CurrentRecord'}}context.getRecord(){{/compare}}{{#compare var.record '==' 'CurrentUser'}}context.getUser(){{/compare}};\n{{#each var.right}}context.assignToRole(record, role, \"{{this}}\");{{#unless @last}}\n{{/unless}}{{/each}}"
            }
        },
        {
            "name": "assignToUser",
            "label": messages.assignToUser,
            "description": messages.assignDesc,
            "environment": ["server", "action", "SCRIPT"],
            "requirements": [],
            "variables": [
                {
                    "name": "right",
                    "label": messages.assignPriv,
                    "required": true,
                    "input": {
                        "type": "MULTISELECT",
                        "data": "$rights"
                    }
                },
                {
                    "name": "record",
                    "label": messages.forRecord,
                    "required": true,
                    "input": {
                        "type": "SELECT",
                        "data": "$records"
                    }
                },
                {
                    "name": "user",
                    "label": messages.toUser,
                    "required": true,
                    "input": {
                        "type": "SELECT",
                        "data": "$records"
                    }
                }
            ],
            "generator": {
                "type": "logic",
                "impl": "<xml xmlns=\"http://www.w3.org/1999/xhtml\"><block type=\"appivo_declare\" id=\"AU*LkUz2[yg+|/:gk~.W\" x=\"238\" y=\"137\"><mutation datatype=\"Record\"></mutation><field name=\"VAR\">record</field><field name=\"TYPE\">Record</field><value name=\"VALUE\">{{#compare var.record '==' 'CurrentRecord'}}<block type=\"api_serversideRuntime_Context\" id=\"a5?Or2!SWs%]|q4)CU3J\"><mutation returnvaluetoggle=\"TRUE\" option=\"GETRECORD\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"FUNC\">GETRECORD</field></block>{{/compare}}{{#compare var.record '==' 'CurrentUser'}}<block type=\"api_serversideRuntime_Context\" id=\"E+%~sfQx}AZbouH0.A.H\" x=\"62\" y=\"238\"><mutation returnvaluetoggle=\"TRUE\" option=\"GETUSER\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"FUNC\">GETUSER</field></block>{{/compare}}</value><next>{{#each var.right}}<block type=\"api_serversideApplication_Context\" id=\"{{genUid}}\"><mutation returnvaluetoggle=\"TRUE\" option=\"ASSIGNTOUSER\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"FUNC\">ASSIGNTOUSER</field><value name=\"ARG0\"><block type=\"variables_get\" id=\"{{genUid}}\"><mutation futureop=\"false\" datatype=\"Record\"></mutation><field name=\"VAR\">record</field></block></value><value name=\"ARG1\">{{#compare @root.var.user '==' 'CurrentRecord'}}<block type=\"api_serversideRuntime_Context\" id=\"{{genUid}}\"><mutation returnvaluetoggle=\"TRUE\" option=\"GETRECORD\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"FUNC\">GETRECORD</field></block>{{/compare}}{{#compare @root.var.user '==' 'CurrentUser'}}<block type=\"api_serversideRuntime_Context\" id=\"{{genUid}}\" x=\"62\" y=\"238\"><mutation returnvaluetoggle=\"TRUE\" option=\"GETUSER\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"FUNC\">GETUSER</field></block>{{/compare}}</value><value name=\"ARG2\"><shadow type=\"text\" id=\"{{genUid}}\"><field name=\"TEXT\">{{this}}</field></shadow></value>{{#unless @last}}<next>{{/unless}}{{/each}}{{#each var.right}}</block>{{#unless @last}}</next>{{/unless}}{{/each}}</next></block></xml>",
                "scriptImpl": "var user = {{#compare var.user '==' 'CurrentRecord'}}context.getRecord(){{/compare}}{{#compare var.user '==' 'CurrentUser'}}context.getUser(){{/compare}};\nvar record = {{#compare var.record '==' 'CurrentRecord'}}context.getRecord(){{/compare}}{{#compare var.record '==' 'CurrentUser'}}context.getUser(){{/compare}};\n{{#each var.right}}context.assignToUser(record, user, \"{{this}}\");{{#unless @last}}\n{{/unless}}{{/each}}"
            }
        },
        {
            "name": "fail",
            "label": messages.failOperation,
            "description": messages.failOpDesc,
            "environment": ["server", "action", "SCRIPT"],
            "requirements": [],
            "variables": [],
            "generator": {
                "type": "logic",
                "impl": "<xml xmlns=\"http://www.w3.org/1999/xhtml\"><block type=\"appivo_return\" id=\",adB8/{lJfsaGZitYI1I\" x=\"138\" y=\"87\"><value name=\"RETURNVALUE\"><block type=\"logic_boolean\" id=\"X#-hy6lk1jvmNzKZtTMS\"><field name=\"BOOL\">FALSE</field></block></value></block></xml>"
            }
        },
        {
            "name": "numberLiteral",
            "label": messages.numberLiteral,
            "description": messages.numberLiteralDesc,
            "environment": ["pushBadge", "push", "badge"],
            "requirements": [],
            "variables": [
                {
                    "name": "number",
                    "label": messages.number,
                    "required": true,
                    "input": {
                        "type": "TEXT"
                    }
                }
            ],
            "generator": {
                "type": "logic",
                "impl": "<xml xmlns=\"http://www.w3.org/1999/xhtml\"><block type=\"appivo_return\" id=\",adB8/{lJfsaGZitYI1I\" x=\"138\" y=\"87\"><value name=\"RETURNVALUE\"><block type=\"math_number\" id=\"31Vllmt99:~3)}f-5:!=\"><field name=\"NUM\">{{var.number}}</field></block></value></block></xml>"
            }
        },
        {
            "name": "queryResult",
            "label": messages.queryResult,
            "description": messages.queryResultDesc,
            "environment": ["pushBadge", "push", "badge"],
            "requirements": [],
            "variables": [
                {
                    "name": "query",
                    "label": messages.query,
                    "required": true,
                    "input": {
                        "type": "SELECT",
                        "data": "$queries"
                    }
                },
                {
                    "name": "attribute",
                    "label": messages.attribute,
                    "required": true,
                    "input": {
                        "type": "SELECT",
                        "data": "$queryAttributes",
                        "params": [{
                            "name": "query",
                            "value": "$query"
                        }]
                    }
                }
            ],
            "generator": {
                "type": "logic",
                "impl": "<xml xmlns=\"http://www.w3.org/1999/xhtml\"><block type=\"appivo_declare\" id=\"LQs:lu./;#%I[Io#)YWA\" x=\"137\" y=\"88\"><mutation datatype=\"Number\"></mutation><field name=\"VAR\">badgeNumber</field><field name=\"TYPE\">Number</field><value name=\"VALUE\"><block type=\"math_number\" id=\"Rtz*KyisHsQ`GWu:0Cgf\"><field name=\"NUM\">0</field></block></value><next><block type=\"appivo_declare\" id=\"XPgFcQx+?3g[QL*#m{mO\"><mutation datatype=\"Record\"></mutation><field name=\"VAR\">record</field><field name=\"TYPE\">Record</field><value name=\"VALUE\"><block type=\"api_serversideRuntime_Context\" id=\"d%QBG0Zqqy-;JQujQwT[\"><mutation returnvaluetoggle=\"TRUE\" option=\"QUERYFORSINGLE\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"FUNC\">QUERYFORSINGLE</field><value name=\"ARG0\"><block type=\"text\" id=\"8R:IQ/dAu8:yMH?[.!cM\"><field name=\"TEXT\">#{{var.query}}</field></block></value></block></value><next><block type=\"controls_if\" id=\"hU*}79@V%csa{rVrycsd\"><value name=\"IF0\"><block type=\"logic_compare\" id=\"j:rbc^3~|~ptr1Ke=7O(\"><field name=\"OP\">NEQ</field><value name=\"A\"><block type=\"variables_get\" id=\"n:`}6{n@W5X{j,Ys9aRM\"><mutation futureop=\"false\" datatype=\"Record\"></mutation><field name=\"VAR\">record</field></block></value><value name=\"B\"><block type=\"logic_null\" id=\"-oMhw;rsCQpYzfB)_|z8\"></block></value></block></value><statement name=\"DO0\"><block type=\"variables_set\" id=\"4PO6s{OxZ)ZR/LQ(dZpw\"><mutation datatype=\"Number\"></mutation><field name=\"VAR\">badgeNumber</field><value name=\"VALUE\"><block type=\"api_serverside_Record\" id=\"tEIginyEBD2dx-Hi0D/r\"><mutation returnvaluetoggle=\"TRUE\" option=\"GETINTVALUE\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"FUNC\">GETINTVALUE</field><value name=\"API_OBJECT\"><block type=\"variables_get\" id=\"XvR3Cv{MG[vPiiAai!#_\"><mutation futureop=\"false\" datatype=\"Record\"></mutation><field name=\"VAR\">record</field></block></value><value name=\"ARG0\"><shadow type=\"text\" id=\"g_6nq}Snjpe73Ah/%9Xj\"><field name=\"TEXT\">{{var.attribute}}</field></shadow></value></block></value></block></statement><next><block type=\"appivo_return\" id=\"-i?q`73C1X^zZ@KaWO#x\"><value name=\"RETURNVALUE\"><block type=\"variables_get\" id=\"ZBq[~BY(5sWeGLpWDhgo\"><mutation futureop=\"false\" datatype=\"Number\"></mutation><field name=\"VAR\">badgeNumber</field></block></value></block></next></block></next></block></next></block></xml>",
                "scriptImpl": "var badgeNumber = 0;\nvar record = context.queryForSingle(\"#{{var.query}}\");\nif (record !== null) {\n\tbadgeNumber = record.getIntValue(\"{{var.attribute}}\");\n}\nreturn badgeNumber;"
            }
        },
        {
            "name": "formatDate",
            "label": messages.formatDate,
            "description": messages.formatDateDesc,
            "environment": ["client", "dataFormatting"],
            "requirements": [],
            "variables": [
                {
                    "name": "value",
                    "label": messages.formatValue,
                    "required": true,
                    "input": {
                        "type": "SELECT",
                        "data": "$params"
                    }
                },
                {
                    "name": "pattern",
                    "label": messages.formatPattern,
                    "required": true,
                    "input": {
                        "type": "SELECT",
                        "optional": false,
                        "defaultValue": "yyy-MM-dd HH:mm",
                        "data": [{
                            "label": "-- " + messages.formatCustomOption + " --",
                            "value": "__custom__"
                        },{
                            "label": "2017-01-31 13:15",
                            "value": "yyy-MM-dd HH:mm"
                        },{
                            "label": "01-31-2017 01:15 PM",
                            "value": "MM-dd-yyy hh:mm a"
                        },{
                            "label": "Tuesday January 31",
                            "value": "EEEE MMMM dd"
                        }]
                    }
                },
                {
                    "name": "customPattern",
                    "label": messages.customPattern,
                    "required": true,
                    "displayWhen": [{
                        "variable": "pattern",
                        "value": ["__custom__"]
                    }],
                    "input": {
                        "type": "TEXT"
                    }
                }
            ],
            "generator": {
                "type": "logic",
                "impl": "<xml xmlns=\"http://www.w3.org/1999/xhtml\"><block type=\"appivo_empty\" id=\"tG}R[n9RYm^7.y}tk-!-\" deletable=\"false\" movable=\"false\" x=\"0\" y=\"0\"><mutation field-data=\"{&quot;0&quot;:[&quot;Predefined Variables&quot;],&quot;1&quot;:[&quot;value, data&quot;]}\" next-statement=\"true\" colour=\"#a5a55b\"></mutation><next><block type=\"appivo_return\" id=\"mmhwp^HV!rdJ[qKXIk[r\"><value name=\"RETURNVALUE\"><block type=\"api_clientside_DateFunctions\" id=\"Bt%z=Zn[izLvEK_6jdRD\"><mutation returnvaluetoggle=\"TRUE\" option=\"FORMATDATE\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"FUNC\">FORMATDATE</field><value name=\"DATE\"><block type=\"variables_get\" id=\"5Ci;[IYI6E9wn:IR`m9-\"><mutation futureop=\"false\"></mutation><field name=\"VAR\">{{var.value}}</field></block></value><value name=\"DATEPATTERN\"><block type=\"text\" id=\"f-V[TNQ#4S_r?cQ+XH!a\"><field name=\"TEXT\">{{#compare var.pattern '!=' '__custom__'}}{{var.pattern}}{{/compare}}{{#compare var.pattern '==' '__custom__'}}{{var.customPattern}}{{/compare}}</field></block></value></block></value></block></next></block></xml>",
                "scriptImpl": "var dateFunctions = context.getDateFunctions();\nreturn dateFunctions.formatDate({{var.value}}, \"{{#compare var.pattern '!=' '__custom__'}}{{var.pattern}}{{/compare}}{{#compare var.pattern '==' '__custom__'}}{{var.customPattern}}{{/compare}}\");"
            }
        },
        {
            "name": "setPinValue",
            "label": "Set Pin Value",
            "description": "Sets the value of a gpio pin",
            "environment": ["device", "gpio"],
            "requirements": ["hasOutputPin"],
            "variables": [
                {
                    "name": "pin",
                    "label": "Pin",
                    "required": true,
                    "input": {
                        "type": "SELECT",
                        "data": "$gpioPins",
                        "params": [{
                            "name": "mode",
                            "value": "OUTPUT,INPUT_OUTPUT"
                         }]
                    }
                },
                {
                    "name": "value",
                    "label": "Value of the pin",
                    "required": true,
                    "input": {
                        "type": "BOOLEAN",
                        "defaultValue": false
                    }
                }
            ],
            "generator": {
                "type": "logic",
                "impl": "<xml xmlns=\"http://www.w3.org/1999/xhtml\"><block type=\"multiApi_GPIOPin\" id=\"{C7*W)]i#Z)~GN)+cT.h\" x=\"21\" y=\"23\"><mutation returnvaluetoggle=\"TRUE\" option=\"GPIOPIN_SETVALUE\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"FUNC\">GPIOPIN_SETVALUE</field><value name=\"API_OBJECT\"><block type=\"multiApi_Device\" id=\"l0ehVtq||h=6M)Iny%6o\" inline=\"false\"><mutation type=\"gpio\" returnvaluetoggle=\"TRUE\" option=\"GPIO_GETPIN\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"TYPE\">gpio</field><field name=\"FUNC\">GPIO_GETPIN</field><value name=\"PINNAME\"><block type=\"text\" id=\"fpapKaaJM-zViS!k,Dl/\"><field name=\"TEXT\">{{var.pin}}</field></block></value></block></value><value name=\"VALUE\"><block type=\"logic_boolean\" id=\"/)Y)zWfaAtowM[9H1#T5\"><field name=\"BOOL\">{{toUpperCase var.value}}</field></block></value></block></xml>"
            }
        },
        {
            "name": "refreshBrowser",
            "label": "Refresh Browser",
            "description": "Refreshes the browser window",
            "environment": ["device", "browser-control"],
            "requirements": [],
            "variables": [],
            "generator": {
                "type": "logic",
                "impl": "<xml xmlns=\"http://www.w3.org/1999/xhtml\"><block type=\"multiApi_Device\" id=\"7@yvDG;ume|g2ouziy17\" inline=\"false\" x=\"-12\" y=\"13\"><mutation type=\"browser-control\" returnvaluetoggle=\"TRUE\" option=\"BROWSER-CONTROL_REFRESH\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"TYPE\">browser-control</field><field name=\"FUNC\">BROWSER-CONTROL_REFRESH</field></block></xml>"
            }
        },
        {
            "name": "navigateTo",
            "label": "Navigate Browser",
            "description": "Navigates the browser to the given url",
            "environment": ["device", "browser-control"],
            "requirements": [],
            "variables": [{
                "name": "url",
                "label": "URL",
                "required": true,
                "input": {
                    "type": "TEXT"
                }
            }],
            "generator": {
                "type": "logic",
                "impl": "<xml xmlns=\"http://www.w3.org/1999/xhtml\"><block type=\"multiApi_Device\" id=\"vD(X9cd0P#6-.w.?o_~P\" inline=\"false\" x=\"-12\" y=\"88\"><mutation type=\"browser-control\" returnvaluetoggle=\"TRUE\" option=\"BROWSER-CONTROL_NAVIGATETO\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"TYPE\">browser-control</field><field name=\"FUNC\">BROWSER-CONTROL_NAVIGATETO</field><value name=\"URL\"><block type=\"text\" id=\"E@,9fwJ6nzWyjVX,q?L+\"><field name=\"TEXT\">{{var.url}}</field></block></value></block></xml>"
            }
        },
        {
            "name": "navigateAsUser",
            "label": "Navigate Browser To App",
            "description": "Navigates the browser to a view in the app as a user",
            "environment": ["device", "browser-control"],
            "requirements": [],
            "variables": [
                {
                    "name": "user",
                    "label": "User",
                    "required": true,
                    "input": {
                        "type": "TEXT"
                    }
                },{
                    "name": "password",
                    "label": "Password",
                    "required": true,
                    "input": {
                        "type": "TEXT"
                    }
                },{
                    "name": "ui",
                    "label": "User Interface",
                    "required": false,
                    "input": {
                        "type": "TEXT"
                    }
                },{
                    "name": "view",
                    "label": "View",
                    "required": false,
                    "input": {
                        "type": "TEXT"
                    }
                },{
                    "name": "lang",
                    "label": "Language Override",
                    "required": false,
                    "input": {
                        "type": "TEXT"
                    }
                }
            ],
            "generator": {
                "type": "logic",
                "impl": "<xml xmlns=\"http://www.w3.org/1999/xhtml\"><block type=\"multiApi_Device\" id=\"jWal*D!XNKYQBXLUGJUp\" inline=\"false\" x=\"-12\" y=\"188\"><mutation type=\"browser-control\" returnvaluetoggle=\"TRUE\" option=\"BROWSER-CONTROL_NAVIGATEASUSER\"></mutation><field name=\"ReturnValue\">TRUE</field><field name=\"TYPE\">browser-control</field><field name=\"FUNC\">BROWSER-CONTROL_NAVIGATEASUSER</field><value name=\"APP\"><block type=\"text\" id=\"I`#)BmR^7Y@)?@_lIx]|\"><field name=\"TEXT\">{{state.schema.id}}</field></block></value>{{#if var.view}}<value name=\"VIEW\"><block type=\"text\" id=\":p^^bP1d;A4cY`QGt@*P\"><field name=\"TEXT\">{{var.view}}</field></block></value>{{/if}}<value name=\"PASSWORD\"><block type=\"text\" id=\"r?]YS36q4{pI|JDh}{1L\"><field name=\"TEXT\">{{var.password}}</field></block></value>{{#if var.ui}}<value name=\"UI\"><block type=\"text\" id=\"Y,~Ymd;U`.2zLDkO3%CE\"><field name=\"TEXT\">{{var.ui}}</field></block></value>{{/if}}{{#if var.lang}}<value name=\"LANG\"><block type=\"text\" id=\"}5TeW4WwYkJS4|}CXwep\"><field name=\"TEXT\">{{var.lang}}</field></block></value>{{/if}}<value name=\"USER\"><block type=\"text\" id=\"oVhV)vBWMuXAHePXLJ`1\"><field name=\"TEXT\">{{var.user}}</field></block></value></block></xml>"
            }
        },
        {
        		"name": "deleteActiveRecord",
        		"label": "Delete the active record",
        		"description": "Deletes the currently active record in this datagrid",
        		"environment": ["client","view","DataGrid"],
                "requirements": [],
                "variables":[
                    {
                        "name": "showConfirmation",
                        "label": messages.showConfirmation,
                        "required": false,
                        "input": {
                            "defaultValue": false,
                            "type": "BOOLEAN"
                        }
                    },
                    {
                        "name": "confirmationMessage",
                        "label": messages.confirmationMessage,
                        "required": false,
                        "displayWhen": [{
                            "variable": "showConfirmation",
                            "value": "true"
                        }],
                        "input": {
                            "defaultValue": messages.defaultConfirmationMessage,
                            "type": "TEXT"
                        }
                    }
                ],
        		"generator": {
        			"type": "script",
        			"impl": "{{#if var.showConfirmation}}\n var grid = this;\n context.confirm({message:\"{{var.confirmationMessage}}\",ok:function(){grid.deleteRecord(grid.getActiveRecord());}}); {{else}} this.deleteRecord(this.getActiveRecord()); {{/if}}"
        		}
        }
    ];

    return actions;
});

},
'appivo/builder/meta/MacroDataFuncs':function(){
define([
    "appivo/mobile/ViewTransitions",
    "dojo/i18n!../nls/ViewTransitions",
    "dojo/i18n!../nls/QuickAction"
], function(ViewTransitions, transitionMessages, messages) {

    var widgetFilters = {
        recordWidgets: ['DataGrid', 'Select', 'MSelect'],
        refreshable: ['DataList', 'MList', 'HTML', 'DataGrid', 'Select', 'MSelect']
    };

    var getPropertyByPath = function(object, path) {
        var split = path.split(".").reverse();
        var obj = object;
        while (split.length > 0) {
            var attr = split.pop();
            // nosemgrep: prototype-pollution-loop
            obj = obj[attr];
            if (obj === null || obj === undefined) {
                break;
            }
        }
        return obj;
    };
    
    var sortOptions = function(options) {
    	options.sort(function(a, b) {
    		return a.label.localeCompare(b.label);
    	});
    };

    var obj = {
        prefixes: {
            views: { value: "view.", label: 'View: ' },
            forms: { value: "form.", label: 'Form: ' },
            widgets: { value: "widget.", label: 'Widget: ' },
            templates: { value: "template.", label: 'Template: ' },
            resources: { value: "resource.", label: 'Resource: ' },
            roles: { value: "role.", label: 'Role: ' },
            strings: { value: "string.", label: 'String: ' },
            queryAttributes: { value: "queryAttr.", label: 'Query Attribute: ' },
            records: { value: "record.", label: 'Record: ' },
            rights: { value: "right.", label: 'Right: ' },
            params: { value: "param.", label: 'Param: ' },
            transitions: { value: "transition.", label: 'Transition: ' },
            uis: { value: "ui.", label: 'User Interface: ' },
        },
        funcs: {
            views: function(state, opts) {
                if (opts && opts.type) {
                    var type = opts.type;
                } else {
                    var type = false;
                }
                if (opts && opts.uiName !== undefined) {
                    var ui = state.schema.userInterfaces.find(function(ui) { return ui.name === opts.uiName });
                } else {
                    var ui = state.userInterface;
                }
                var views = [];
                if (ui != null) {
                    ui.views.forEach(function (view) {
                        if (!type || view.widgetType === type) {
                            views.push({
                                value: view.id,
                                label: view.id
                            });
                        }
                    });
                    sortOptions(views);
                }
                return views;
            },
            uis: function(state, opts) {
                var uis = [];
                var type = state.userInterface.type;
                var userInterfaces = state.schema.userInterfaces
                if (userInterfaces) {
                    userInterfaces.filter(function(ui){ return ui.type === type }).forEach(function(ui) {
                        uis.push({
                            value: ui.name,
                            label: ui.name
                        })
                    });
                }
                sortOptions(uis);
                return uis;
            },
            forms: function(state, opts) {
                var forms = [];
                var viewForms = state.view.getForms();
                if (viewForms) {
                    viewForms.forEach(function(form) {
                        forms.push({
                            value: form.id,
                            label: form.id
                        });
                    });
                }
                sortOptions(forms);
                return forms;
            },
            widgets: function(state, opts) {
                if (opts && opts.filter) {
                    var filter = opts.filter;
                    if (filter.startsWith("#")) {
                        var filter = filter.substr(1);
                        if (widgetFilters[filter]) {
                            filter = widgetFilters[filter];
                        } else {
                            filter = false;
                            console.error("Invalid filter reference " + filter);
                        }
                    } else {
                        filter = filter.split(",");
                    }
                } else {
                    var filter = false;
                }
                var widgets = [];
                if (state.view && (state.view.getType() === 'View' || state.view.getType() === 'MView') && state.view.widgets) {
                    for (widgetId in state.view.widgets) {
                        if (!filter || filter.indexOf(state.view.widgets[widgetId].widgetDef.name) != -1) {
                            widgets.push({
                                value: widgetId,
                                label: widgetId
                            });
                        }
                    }
                }
                sortOptions(widgets);
                return widgets;
            },
            templates: function(state, opts) {
                var templates = [];
                if (state.schema.templates) {
                    state.schema.templates.forEach(function(template) {
                        templates.push({
                            value: template.name,
                            label: template.name
                        });
                    });
                }
                sortOptions(templates);
                return templates;
            },
            resources: function(state, opts) {
                var resources = [];
                var contenttype = "";
                if (opts && opts.contenttype) {
                    contenttype = opts.contenttype;
                }
                if (state.schema.resources) {
                    state.schema.resources.forEach(function(resource) {
                        if (resource.contenttype.startsWith(contenttype)) {
                            resources.push({
                                value: resource.filename,
                                label: resource.filename
                            });
                        }
                    });
                }
                sortOptions(resources);
                return resources;
            },
            roles: function(state, opts) {
                var roles = [];
                if (state.schema.roles) {
                    state.schema.roles.forEach(function(role) {
                        roles.push({
                            value: role.name,
                            label: role.name
                        });
                    });
                }
                sortOptions(roles);
                return roles;
            },
            queries: function(state, opts) {
                var queries = [];
                if (state.schema.queries) {
                    state.schema.queries.forEach(function(query) {
                        queries.push({
                            value: query.name,
                            label: query.name
                        });
                    });
                }
                sortOptions(queries);
                return queries;
            },
            strings: function(state, opts) {
                var strings = [];
                if (state.schema.locales) {
                    var locale = null;
                    for (var i = 0; i < state.schema.locales.length; i++) {
                        var l = state.schema.locales[i];
                        if (l.name === 'default') {
                            locale = l;
                            break;
                        }
                    }
                    if (locale !== null && locale.data && locale.data.custom) {
                        locale.data.custom.forEach(function(string) {
                            strings.push({
                                value: string.name,
                                label: string.name
                            });
                        });
                    }
                }
                sortOptions(strings);
                return strings;
            },
            queryAttributes: function(state, opts) {
                var attrs = [];
                if (opts && opts.query) {
                    var query = null;
                    for (var i = 0; i < state.schema.queries.length; i++) {
                        var q = state.schema.queries[i];
                        if (q.name === opts.query) {
                            query = q;
                            break;
                        }
                    }
                    if (query !== null) {
                        if (query.select.selectors !== null && query.select.selectors.length > 0) {
                            query.select.selectors.forEach(function(sel) {
                                attrs.push({
                                    value: sel.alias,
                                    label: sel.alias
                                });
                            });
                        } else {
                            var model = null;
                            for (var i = 0; i < state.schema.models.length; i++) {
                                var m = state.schema.models[i];
                                if (m.name === query.from.model) {
                                    model = m;
                                    break;
                                }
                            }
                            if (model !== null) {
                                model.attributes.forEach(function(attr) {
                                    attrs.push({
                                        value: attr.name,
                                        label: attr.name
                                    });
                                });
                            }
                        }
                    }
                }
                sortOptions(attrs);
                return attrs;
            },
            records: function() {
                return [{
                    value: "CurrentRecord",
                    label: messages.currentRec
                },{
                    value: "CurrentUser",
                    label: messages.currentUser
                }];
            },
            rights: function() {
                return [{
                    label: messages.create,
                    value: "Create"
                },{
                    label: messages.read,
                    value: "Read"
                },{
                    label: messages.update,
                    value: "Update"
                },{
                    label: messages.del,
                    value: "Delete"
                }];
            },
            params: function(state, opts) {
                var params = [];
                if (state.parameters) {
                    state.parameters.forEach(function(param) {
                        params.push({
                            label: param.name,
                            value: param.name
                        });
                    });
                    sortOptions(params);
                }
                return params;
            },
            transitions: function(state, opts) {
                var transitions = [];
                for (transition in ViewTransitions) {
                    transitions.push({
                        label: transitionMessages[transition],
                        value: transition
                    });
                }
                sortOptions(transitions);
                return transitions;
            },
            invokableFunctions: function(state, opts) {
                var funcs = [];
                if (state.view) {
                    for (var func in state.view.data.functions) {
                        funcs.push({
                            label: func,
                            value: func
                        });
                    }
                }
                sortOptions(funcs);
                return funcs;
            },
            gpioPins: function(state, opts) {
                var pins = [];
                var pinConfigs = getPropertyByPath(state, "editObject.data.modules.gpio.params.pinConfigs");
                if (pinConfigs) {
                    var mode = false;
                    if (opts.mode) {
                        mode = opts.mode.split(",");
                    }
                    for (var i in pinConfigs) {
                        var pin = pinConfigs[i];
                        if (!mode || mode.indexOf(pin.mode) !== -1) {
                            pins.push({
                                label: pin.pin,
                                value: pin.pin
                            });
                        }
                    }
                }
                sortOptions(pins);
                return pins;
            }
        }
    }

    return obj;
});
},
'appivo/mobile/ViewTransitions':function(){
define([], function() {

    var transitions = {
        "fade": {
            "in": "fadeIn",
            "out": "fadeOut"
        },
        "fade-up": {
            "in": "fadeInUp",
            "out": "fadeOutUp"
        },
        "fade-up-quick": {
             "in": "fadeInUpBig",
             "out": "fadeOutUpBig"
        },
        "fade-right": {
            "in": "fadeInLeft",
            "out": "fadeOutRight"
        },
        "fade-right-quick": {
            "in": "fadeInLeftBig",
            "out": "fadeOutRightBig"
        },
        "fade-down": {
            "in": "fadeInDown",
            "out": "fadeOutDown"
        },
        "fade-down-quick": {
            "in": "fadeInDownBig",
            "out": "fadeOutDownBig"
        },
        "fade-left": {
            "in": "fadeInRight",
            "out": "fadeOutLeft"
        },
        "fade-left-quick": {
            "in": "fadeInRightBig",
            "out": "fadeOutLeftBig"
        },
        "slide-up": {
             "in": "slideInUp",
             "out": "slideOutUp"
        },
        "slide-right": {
            "in": "slideInLeft",
            "out": "slideOutRight"
        },
        "slide-down": {
            "in": "slideInDown",
            "out": "slideOutDown"
        },
        "slide-left": {
            "in": "slideInRight",
            "out": "slideOutLeft"
        },
        "zoom": {
            "in": "zoomIn",
            "out": "zoomOut"
        },
        "zoom-up": {
            "in": "zoomInUp",
            "out": "zoomOutUp"
        },
        "zoom-right": {
            "in": "zoomInLeft",
            "out": "zoomOutRight"
        },
        "zoom-down": {
            "in": "zoomInDown",
            "out": "zoomOutDown"
        },
        "zoom-left": {
            "in": "zoomInRight",
            "out": "zoomOutLeft"
        },
        "roll": {
            "in": "rollIn",
            "out": "rollOut"
        },
        "lightSpeed": {
            "in": "lightSpeedIn",
            "out": "lightSpeedOut"
        },
        "flipX": {
            "in": "flipInX",
            "out": "flipOutX"
        },
        "flipY": {
            "in": "flipInY",
            "out": "flipOutY"
        },
        "bounce": {
            "in": "bounceIn",
            "out": "bounceOut"
        },
        "bounce-up": {
            "in": "bounceInUp",
            "out": "bounceOutUp"
        },
        "bounce-right": {
            "in": "bounceInLeft",
            "out": "bounceOutRight"
        },
        "bounce-down": {
            "in": "bounceInDown",
            "out": "bounceOutDown"
        },
        "bounce-left": {
            "in": "bounceInRight",
            "out": "bounceOutLeft"
        },
        "rotate": {
            "in": "rotateIn",
            "out": "rotateOut"
        },
        "rotate-down-left": {
            "in": "rotateInDownLeft",
            "out": "rotateOutDownLeft"
        },
        "rotate-down-right": {
            "in": "rotateInDownRight",
            "out": "rotateOutDownRight"
        },
        "rotate-up-left": {
            "in": "rotateInUpLeft",
            "out": "rotateOutUpLeft"
        },
        "rotate-up-right": {
            "in": "rotateInUpRight",
            "out": "rotateOutUpRight"
        },
        "hinge": {
            "in": null,
            "out": "hinge bring-to-front"
        },
        "wobble": {
            "in": "wobble bring-to-front",
            "out": null
        },
        "tada": {
            "in": "tada bring-to-front",
            "out": null
        },
        "rubberband": {
            "in": "rubberBand bring-to-front",
            "out": null
        },
        "pulse": {
            "in": "pulse bring-to-front",
            "out": null
        },
        "shake": {
            "in": "shake bring-to-front",
            "out": null
        },
        "swing": {
            "in": "swing bring-to-front",
            "out": null
        },
        "jack-in-the-box": {
            "in": "jackInTheBox bring-to-front",
            "out": null
        },
        "jello": {
            "in": "jello bring-to-front",
            "out": null
        },
        "heart-beat": {
            "in": "heartBeat bring-to-front",
            "out": null
        }
    };

    return transitions;

});
},
'appivo/builder/meta/MacroRequirementFuncs':function(){
define([], function() {
    var getPropertyByPath = function(object, path) {
        var split = path.split(".").reverse();
        var obj = object;
        while (split.length > 0) {
            var attr = split.pop();
            // nosemgrep: prototype-pollution-loop
            obj = obj[attr];
            if (obj === null || obj === undefined) {
                break;
            }
        }
        return obj;
    };

    var funcs = {
        isView: function(state) {
            return this.isDesktopView(state) || this.isMobileView(state);
        },
        isDesktopView: function(state) {
            return !!(state.view && state.view.getType() === 'View');
        },
        isMobileView: function(state) {
            return !!(state.view && state.view.getType() === 'MView');
        },
        isDialog: function(state) {
            return !!(state.view && state.view.getType() === 'Dialog');
        },
        hasForm: function(state) {
            var ok = false;
            if (this.isView(state) || this.isDialog(state)) {
                ok = !!(state.view.getForms() && state.view.getForms().length > 0);
            }
            return ok;
        },
        hasRecordWidget: function(state) {
            var ok = false;
            if (this.isView(state)) {
                for (var widgetId in state.view.widgets) {
                    var child = state.view.widgets[widgetId];
                    if (child.widgetDef.name === 'Select' || child.widgetDef.name === 'DataGrid' || child.widgetDef.name === 'MSelect') {
                        ok = true;
                        break;
                    }
                }
            }
            return ok;
        },
        hasInvokableFunctions: function(state) {
            return !!state.view && state.view.data.functions && Object.keys(state.view.data.functions).length > 0;
        },
        hasOutputPin: function(state) {
            var hasPin = false;
            var pinConfigs = getPropertyByPath(state, "editObject.data.modules.gpio.params.pinConfigs");
            if (pinConfigs) {
                for (var i in pinConfigs) {
                    var pin = pinConfigs[i];
                    if (pin.mode !== "INPUT") {
                        hasPin = true;
                        break;
                    }
                }
            }
            return hasPin;
        }
    };

    return funcs;
});
},
'appivo/vue/components/Selector':function(){
define([
  'vue/vue',
  'vue/vue-strap',
  'select2/js/select2',
  'dojo/text!../html/Selector.html'
], function(Vue, VueStrap, select2, template) {
	var select = null;
	return Vue.extend({
		template: template,
		props: {
			data: [Object],//available options with id and text attributes: [{id:'someid', text:'somelabel'}]
			xhr: Object, //xhr object for loading data
			startswith: Boolean,
			val: String, //selected value
			multiVal: Array, //array with all selected values
			placeholder: String, //placeholder for no selection
			formatter: Function, // formatter for options in dropdown
			selFormatter: Function, // formatter for selected option, what you see when select is closed
			searchMinimum: Number, // only use search if number of options is more than this. Infinity = never use search
			multiSelect: Boolean, //whether this is a multi select or not
			maxMultiSelect: Number, //Maximum number of options that can be selected
			disabled: Boolean,
			specificOrder: Boolean,
            blankOption: {
                type: Boolean,
                'default': false
            },
			blankOptionObject: Object,
			width: {
			    type: String,
			    'default': '50%'
			},
            nullOption:{
                type: Boolean,
                'default': false
            }
		},
		data: function() {
		    return {
		        selObject: {},
		        defaultValues: []
		    };
		},
		ready: function() {
			this.initSelect2();
		},
		computed:{
			sortedData: function(){
				if (this.specificOrder && this.multiSelect && this.multiVal) {
					var result = new Array();
					var selected = new Array();
					var t = this;
					this.data.forEach(function(opt){
						var index = t.multiVal.indexOf(opt.id);
						if (index > -1) {
							selected[index] = opt;
						} else {
							result.push(opt);
						}
					});
					selected.forEach(function(opt){
						result.push(opt);
					});
					return result;
				} else {
					return this.data ? this.data: [];
				}
			}
		},
		methods: {
		    initSelect2: function() {
		        var t = this;
                var opts = this._createOpts();
				if (this.nullOption) {
					opts.allowClear = true;
				}
                this.selObject = $(this.$el).select2(opts);
                this.selObject.on('change', function (evt) {
                    t.updateVal(evt);
                });

                if (this.blankOption) {
					if (this.blankOptionObject && (this.blankOptionObject.value !== undefined) && this.blankOptionObject.text) {
						this.selObject.prepend('<option selected value="' + String(this.blankOptionObject.value) + '">' + String(this.blankOptionObject.text) + '</option>');
					} else {
						this.selObject.prepend('<option selected value="">All</option>');
					}
                }

                if (this.specificOrder) {
                    this.selObject.on('select2:select', function(e){
                        var elm = e.params.data.element;
                        $elm = jQuery(elm);
                        $t = jQuery(this);
                        $t.append($elm);
                        $t.trigger('change.select2');
                    });
                }
                if (!this.xhr ) {
                    if (this.val && !this.multiSelect) {
                        this.selObject.val(this.val).trigger('change');
                    } else if (!this.val && !this.multiSelect && this.data && this.data.length == 1) {
                        this.selObject.val(this.data[0].id).trigger('change');
                    } else if (this.multiVal) {
                        this.selObject.val(this.multiVal).trigger('change');
                    }
                }
		    },
		    getValue: function() {
		    	return this.selObject.val();
		    },
			updateVal: function(evt){
			    if (this.multiSelect) {
			        var newVal = this.selObject.val();
			        if (!this.multiVal || (!newVal && this.multiVal.length != 0) || (newVal && this.multiVal.length != newVal.length) || (this.specificOrder && newVal && this.multiVal[this.multiVal.length -1] != newVal[this.multiVal.length -1])) {
				        this.$set('multiVal', newVal != null ? newVal : []);
				    }
			    } else {
                    var newVal = evt.target.value;
                    if (this.val !== newVal) {
                        this.$set('val', evt.target.value);
                    }
				}
			},
			setValue: function(value) {
				if (value) {
					this.$set('val',value);
				}
			},
			_createOpts: function () {
				var opts = {};
				if (this.startswith) {
				    opts.matcher = function(query, selObj){
				        var ret = true;
				        if (query.term && selObj.text) {
				            if (selObj.text.toLowerCase().indexOf(query.term.toLowerCase()) != 0) {
				                ret = false;
				            }
				        }
				        return ret ? selObj : null;
				    }
				}
				if (this.sortedData.length > 0 && !this.xhr) {
				    opts.data = this.sortedData;
				} else if (this.xhr) {
				    opts.minimumInputLength = this.xhr.minInput;
				    opts.ajax = {
				        url: this.xhr.url,
				        dataType: this.xhr.dataType ? this.xhr.dataType : 'json',
				        delay: this.xhr.delay ? this.xhr.delay : 250,
				        data: this.xhr.data,
				        processResults: this.xhr.res,
				        cache: this.xhr.cache ? this.xhr.cache : true
				    }
				    if (this.xhr.defaultValues) {
				        this.defaultValues = this.xhr.defaultValues;
				    }
				}
                if (this.formatter != null) {
                    opts.templateResult = this.formatter;
                }
                if (this.selFormatter != null) {
                    opts.templateSelection = this.selFormatter;
                }
                if (this.placeholder) {
                    opts.placeholder = this.placeholder;
                }
                if (this.searchMinimum) {
                    opts.minimumResultsForSearch = this.searchMinimum;
                }
                if (this.multiSelect) {
                    opts.multiple = 'multiple';
                }
                if (this.maxMultiSelect) {
                    opts.maximumSelectionLength = this.maxMultiSelect;
                }
                if (this.disabled) {
                    opts.disabled = this.disabled;
                }
                opts.dropdownAutoWidth = true;
                return opts;
			}
		},
		watch: {
			'val': function(val, oldVal){
				if (val != oldVal) {
					this.selObject.val(val).trigger('change');
					this.$dispatch('change', {target:{value:val}});
				}
			},
			'multiVal': function(val) {
			    this.selObject.val(val).trigger('change');
			    this.$dispatch('change', {target:{value:val}});
			},
			'disabled': function(val) {
			    this.selObject.prop('disabled', val);
			},
			'data': function(val) {
                this.selObject.empty();
                this.initSelect2();
			}
		}
	});
});

},
'select2/js/select2':function(){
/*!
 * Select2 4.0.13
 * https://select2.github.io
 *
 * Released under the MIT license
 * https://github.com/select2/select2/blob/master/LICENSE.md
 */
;(function (factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['jquery'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // Node/CommonJS
    module.exports = function (root, jQuery) {
      if (jQuery === undefined) {
        // require('jQuery') returns a factory that requires window to
        // build a jQuery instance, we normalize how we use modules
        // that require this pattern but the window provided is a noop
        // if it's defined (how jquery works)
        if (typeof window !== 'undefined') {
          jQuery = require('jquery');
        }
        else {
          jQuery = require('jquery')(root);
        }
      }
      factory(jQuery);
      return jQuery;
    };
  } else {
    // Browser globals
    factory(jQuery);
  }
} (function (jQuery) {
  // This is needed so we can catch the AMD loader configuration and use it
  // The inner file should be wrapped (by `banner.start.js`) in a function that
  // returns the AMD loader references.
  var S2 =(function () {
  // Restore the Select2 AMD loader so it can be used
  // Needed mostly in the language files, where the loader is not inserted
  if (jQuery && jQuery.fn && jQuery.fn.select2 && jQuery.fn.select2.amd) {
    var S2 = jQuery.fn.select2.amd;
  }
var S2;(function () { if (!S2 || !S2.requirejs) {
if (!S2) { S2 = {}; } else { require = S2; }
/**
 * @license almond 0.3.3 Copyright jQuery Foundation and other contributors.
 * Released under MIT license, http://github.com/requirejs/almond/LICENSE
 */
//Going sloppy to avoid 'use strict' string cost, but strict practices should
//be followed.
/*global setTimeout: false */

var requirejs, require, define;
(function (undef) {
    var main, req, makeMap, handlers,
        defined = {},
        waiting = {},
        config = {},
        defining = {},
        hasOwn = Object.prototype.hasOwnProperty,
        aps = [].slice,
        jsSuffixRegExp = /\.js$/;

    function hasProp(obj, prop) {
        return hasOwn.call(obj, prop);
    }

    /**
     * Given a relative module name, like ./something, normalize it to
     * a real name that can be mapped to a path.
     * @param {String} name the relative name
     * @param {String} baseName a real name that the name arg is relative
     * to.
     * @returns {String} normalized name
     */
    function normalize(name, baseName) {
        var nameParts, nameSegment, mapValue, foundMap, lastIndex,
            foundI, foundStarMap, starI, i, j, part, normalizedBaseParts,
            baseParts = baseName && baseName.split("/"),
            map = config.map,
            starMap = (map && map['*']) || {};

        //Adjust any relative paths.
        if (name) {
            name = name.split('/');
            lastIndex = name.length - 1;

            // If wanting node ID compatibility, strip .js from end
            // of IDs. Have to do this here, and not in nameToUrl
            // because node allows either .js or non .js to map
            // to same file.
            if (config.nodeIdCompat && jsSuffixRegExp.test(name[lastIndex])) {
                name[lastIndex] = name[lastIndex].replace(jsSuffixRegExp, '');
            }

            // Starts with a '.' so need the baseName
            if (name[0].charAt(0) === '.' && baseParts) {
                //Convert baseName to array, and lop off the last part,
                //so that . matches that 'directory' and not name of the baseName's
                //module. For instance, baseName of 'one/two/three', maps to
                //'one/two/three.js', but we want the directory, 'one/two' for
                //this normalization.
                normalizedBaseParts = baseParts.slice(0, baseParts.length - 1);
                name = normalizedBaseParts.concat(name);
            }

            //start trimDots
            for (i = 0; i < name.length; i++) {
                part = name[i];
                if (part === '.') {
                    name.splice(i, 1);
                    i -= 1;
                } else if (part === '..') {
                    // If at the start, or previous value is still ..,
                    // keep them so that when converted to a path it may
                    // still work when converted to a path, even though
                    // as an ID it is less than ideal. In larger point
                    // releases, may be better to just kick out an error.
                    if (i === 0 || (i === 1 && name[2] === '..') || name[i - 1] === '..') {
                        continue;
                    } else if (i > 0) {
                        name.splice(i - 1, 2);
                        i -= 2;
                    }
                }
            }
            //end trimDots

            name = name.join('/');
        }

        //Apply map config if available.
        if ((baseParts || starMap) && map) {
            nameParts = name.split('/');

            for (i = nameParts.length; i > 0; i -= 1) {
                nameSegment = nameParts.slice(0, i).join("/");

                if (baseParts) {
                    //Find the longest baseName segment match in the config.
                    //So, do joins on the biggest to smallest lengths of baseParts.
                    for (j = baseParts.length; j > 0; j -= 1) {
                        mapValue = map[baseParts.slice(0, j).join('/')];

                        //baseName segment has  config, find if it has one for
                        //this name.
                        if (mapValue) {
                            mapValue = mapValue[nameSegment];
                            if (mapValue) {
                                //Match, update name to the new value.
                                foundMap = mapValue;
                                foundI = i;
                                break;
                            }
                        }
                    }
                }

                if (foundMap) {
                    break;
                }

                //Check for a star map match, but just hold on to it,
                //if there is a shorter segment match later in a matching
                //config, then favor over this star map.
                if (!foundStarMap && starMap && starMap[nameSegment]) {
                    foundStarMap = starMap[nameSegment];
                    starI = i;
                }
            }

            if (!foundMap && foundStarMap) {
                foundMap = foundStarMap;
                foundI = starI;
            }

            if (foundMap) {
                nameParts.splice(0, foundI, foundMap);
                name = nameParts.join('/');
            }
        }

        return name;
    }

    function makeRequire(relName, forceSync) {
        return function () {
            //A version of a require function that passes a moduleName
            //value for items that may need to
            //look up paths relative to the moduleName
            var args = aps.call(arguments, 0);

            //If first arg is not require('string'), and there is only
            //one arg, it is the array form without a callback. Insert
            //a null so that the following concat is correct.
            if (typeof args[0] !== 'string' && args.length === 1) {
                args.push(null);
            }
            return req.apply(undef, args.concat([relName, forceSync]));
        };
    }

    function makeNormalize(relName) {
        return function (name) {
            return normalize(name, relName);
        };
    }

    function makeLoad(depName) {
        return function (value) {
            defined[depName] = value;
        };
    }

    function callDep(name) {
        if (hasProp(waiting, name)) {
            var args = waiting[name];
            delete waiting[name];
            defining[name] = true;
            main.apply(undef, args);
        }

        if (!hasProp(defined, name) && !hasProp(defining, name)) {
            throw new Error('No ' + name);
        }
        return defined[name];
    }

    //Turns a plugin!resource to [plugin, resource]
    //with the plugin being undefined if the name
    //did not have a plugin prefix.
    function splitPrefix(name) {
        var prefix,
            index = name ? name.indexOf('!') : -1;
        if (index > -1) {
            prefix = name.substring(0, index);
            name = name.substring(index + 1, name.length);
        }
        return [prefix, name];
    }

    //Creates a parts array for a relName where first part is plugin ID,
    //second part is resource ID. Assumes relName has already been normalized.
    function makeRelParts(relName) {
        return relName ? splitPrefix(relName) : [];
    }

    /**
     * Makes a name map, normalizing the name, and using a plugin
     * for normalization if necessary. Grabs a ref to plugin
     * too, as an optimization.
     */
    makeMap = function (name, relParts) {
        var plugin,
            parts = splitPrefix(name),
            prefix = parts[0],
            relResourceName = relParts[1];

        name = parts[1];

        if (prefix) {
            prefix = normalize(prefix, relResourceName);
            plugin = callDep(prefix);
        }

        //Normalize according
        if (prefix) {
            if (plugin && plugin.normalize) {
                name = plugin.normalize(name, makeNormalize(relResourceName));
            } else {
                name = normalize(name, relResourceName);
            }
        } else {
            name = normalize(name, relResourceName);
            parts = splitPrefix(name);
            prefix = parts[0];
            name = parts[1];
            if (prefix) {
                plugin = callDep(prefix);
            }
        }

        //Using ridiculous property names for space reasons
        return {
            f: prefix ? prefix + '!' + name : name, //fullName
            n: name,
            pr: prefix,
            p: plugin
        };
    };

    function makeConfig(name) {
        return function () {
            return (config && config.config && config.config[name]) || {};
        };
    }

    handlers = {
        require: function (name) {
            return makeRequire(name);
        },
        exports: function (name) {
            var e = defined[name];
            if (typeof e !== 'undefined') {
                return e;
            } else {
                return (defined[name] = {});
            }
        },
        module: function (name) {
            return {
                id: name,
                uri: '',
                exports: defined[name],
                config: makeConfig(name)
            };
        }
    };

    main = function (name, deps, callback, relName) {
        var cjsModule, depName, ret, map, i, relParts,
            args = [],
            callbackType = typeof callback,
            usingExports;

        //Use name if no relName
        relName = relName || name;
        relParts = makeRelParts(relName);

        //Call the callback to define the module, if necessary.
        if (callbackType === 'undefined' || callbackType === 'function') {
            //Pull out the defined dependencies and pass the ordered
            //values to the callback.
            //Default to [require, exports, module] if no deps
            deps = !deps.length && callback.length ? ['require', 'exports', 'module'] : deps;
            for (i = 0; i < deps.length; i += 1) {
                map = makeMap(deps[i], relParts);
                depName = map.f;

                //Fast path CommonJS standard dependencies.
                if (depName === "require") {
                    args[i] = handlers.require(name);
                } else if (depName === "exports") {
                    //CommonJS module spec 1.1
                    args[i] = handlers.exports(name);
                    usingExports = true;
                } else if (depName === "module") {
                    //CommonJS module spec 1.1
                    cjsModule = args[i] = handlers.module(name);
                } else if (hasProp(defined, depName) ||
                           hasProp(waiting, depName) ||
                           hasProp(defining, depName)) {
                    args[i] = callDep(depName);
                } else if (map.p) {
                    map.p.load(map.n, makeRequire(relName, true), makeLoad(depName), {});
                    args[i] = defined[depName];
                } else {
                    throw new Error(name + ' missing ' + depName);
                }
            }

            ret = callback ? callback.apply(defined[name], args) : undefined;

            if (name) {
                //If setting exports via "module" is in play,
                //favor that over return value and exports. After that,
                //favor a non-undefined return value over exports use.
                if (cjsModule && cjsModule.exports !== undef &&
                        cjsModule.exports !== defined[name]) {
                    defined[name] = cjsModule.exports;
                } else if (ret !== undef || !usingExports) {
                    //Use the return value from the function.
                    defined[name] = ret;
                }
            }
        } else if (name) {
            //May just be an object definition for the module. Only
            //worry about defining if have a module name.
            defined[name] = callback;
        }
    };

    requirejs = require = req = function (deps, callback, relName, forceSync, alt) {
        if (typeof deps === "string") {
            if (handlers[deps]) {
                //callback in this case is really relName
                return handlers[deps](callback);
            }
            //Just return the module wanted. In this scenario, the
            //deps arg is the module name, and second arg (if passed)
            //is just the relName.
            //Normalize module name, if it contains . or ..
            return callDep(makeMap(deps, makeRelParts(callback)).f);
        } else if (!deps.splice) {
            //deps is a config object, not an array.
            config = deps;
            if (config.deps) {
                req(config.deps, config.callback);
            }
            if (!callback) {
                return;
            }

            if (callback.splice) {
                //callback is an array, which means it is a dependency list.
                //Adjust args if there are dependencies
                deps = callback;
                callback = relName;
                relName = null;
            } else {
                deps = undef;
            }
        }

        //Support require(['a'])
        callback = callback || function () {};

        //If relName is a function, it is an errback handler,
        //so remove it.
        if (typeof relName === 'function') {
            relName = forceSync;
            forceSync = alt;
        }

        //Simulate async callback;
        if (forceSync) {
            main(undef, deps, callback, relName);
        } else {
            //Using a non-zero value because of concern for what old browsers
            //do, and latest browsers "upgrade" to 4 if lower value is used:
            //http://www.whatwg.org/specs/web-apps/current-work/multipage/timers.html#dom-windowtimers-settimeout:
            //If want a value immediately, use require('id') instead -- something
            //that works in almond on the global level, but not guaranteed and
            //unlikely to work in other AMD implementations.
            setTimeout(function () {
                main(undef, deps, callback, relName);
            }, 4);
        }

        return req;
    };

    /**
     * Just drops the config on the floor, but returns req in case
     * the config return value is used.
     */
    req.config = function (cfg) {
        return req(cfg);
    };

    /**
     * Expose module registry for debugging and tooling
     */
    requirejs._defined = defined;

    define = function (name, deps, callback) {
        if (typeof name !== 'string') {
            throw new Error('See almond README: incorrect module build, no module name');
        }

        //This module may not have dependencies
        if (!deps.splice) {
            //deps is not an array, so probably means
            //an object literal or factory function for
            //the value. Adjust args.
            callback = deps;
            deps = [];
        }

        if (!hasProp(defined, name) && !hasProp(waiting, name)) {
            waiting[name] = [name, deps, callback];
        }
    };

    define.amd = {
        jQuery: true
    };
}());

S2.requirejs = requirejs;S2.require = require;S2.define = define;
}
}());
S2.define("almond", function(){});

/* global jQuery:false, $:false */
S2.define('jquery',[],function () {
  var _$ = jQuery || $;

  if (_$ == null && console && console.error) {
    console.error(
      'Select2: An instance of jQuery or a jQuery-compatible library was not ' +
      'found. Make sure that you are including jQuery before Select2 on your ' +
      'web page.'
    );
  }

  return _$;
});

S2.define('select2/utils',[
  'jquery'
], function ($) {
  var Utils = {};

  Utils.Extend = function (ChildClass, SuperClass) {
    var __hasProp = {}.hasOwnProperty;

    function BaseConstructor () {
      this.constructor = ChildClass;
    }

    for (var key in SuperClass) {
      if (__hasProp.call(SuperClass, key)) {
        ChildClass[key] = SuperClass[key];
      }
    }

    BaseConstructor.prototype = SuperClass.prototype;
    ChildClass.prototype = new BaseConstructor();
    ChildClass.__super__ = SuperClass.prototype;

    return ChildClass;
  };

  function getMethods (theClass) {
    var proto = theClass.prototype;

    var methods = [];

    for (var methodName in proto) {
      var m = proto[methodName];

      if (typeof m !== 'function') {
        continue;
      }

      if (methodName === 'constructor') {
        continue;
      }

      methods.push(methodName);
    }

    return methods;
  }

  Utils.Decorate = function (SuperClass, DecoratorClass) {
    var decoratedMethods = getMethods(DecoratorClass);
    var superMethods = getMethods(SuperClass);

    function DecoratedClass () {
      var unshift = Array.prototype.unshift;

      var argCount = DecoratorClass.prototype.constructor.length;

      var calledConstructor = SuperClass.prototype.constructor;

      if (argCount > 0) {
        unshift.call(arguments, SuperClass.prototype.constructor);

        calledConstructor = DecoratorClass.prototype.constructor;
      }

      calledConstructor.apply(this, arguments);
    }

    DecoratorClass.displayName = SuperClass.displayName;

    function ctr () {
      this.constructor = DecoratedClass;
    }

    DecoratedClass.prototype = new ctr();

    for (var m = 0; m < superMethods.length; m++) {
      var superMethod = superMethods[m];

      DecoratedClass.prototype[superMethod] =
        SuperClass.prototype[superMethod];
    }

    var calledMethod = function (methodName) {
      // Stub out the original method if it's not decorating an actual method
      var originalMethod = function () {};

      if (methodName in DecoratedClass.prototype) {
        originalMethod = DecoratedClass.prototype[methodName];
      }

      var decoratedMethod = DecoratorClass.prototype[methodName];

      return function () {
        var unshift = Array.prototype.unshift;

        unshift.call(arguments, originalMethod);

        return decoratedMethod.apply(this, arguments);
      };
    };

    for (var d = 0; d < decoratedMethods.length; d++) {
      var decoratedMethod = decoratedMethods[d];

      DecoratedClass.prototype[decoratedMethod] = calledMethod(decoratedMethod);
    }

    return DecoratedClass;
  };

  var Observable = function () {
    this.listeners = {};
  };

  Observable.prototype.on = function (event, callback) {
    this.listeners = this.listeners || {};

    if (event in this.listeners) {
      this.listeners[event].push(callback);
    } else {
      this.listeners[event] = [callback];
    }
  };

  Observable.prototype.trigger = function (event) {
    var slice = Array.prototype.slice;
    var params = slice.call(arguments, 1);

    this.listeners = this.listeners || {};

    // Params should always come in as an array
    if (params == null) {
      params = [];
    }

    // If there are no arguments to the event, use a temporary object
    if (params.length === 0) {
      params.push({});
    }

    // Set the `_type` of the first object to the event
    params[0]._type = event;

    if (event in this.listeners) {
      this.invoke(this.listeners[event], slice.call(arguments, 1));
    }

    if ('*' in this.listeners) {
      this.invoke(this.listeners['*'], arguments);
    }
  };

  Observable.prototype.invoke = function (listeners, params) {
    for (var i = 0, len = listeners.length; i < len; i++) {
      listeners[i].apply(this, params);
    }
  };

  Utils.Observable = Observable;

  Utils.generateChars = function (length) {
    var chars = '';

    for (var i = 0; i < length; i++) {
      var randomChar = Math.floor(Math.random() * 36);
      chars += randomChar.toString(36);
    }

    return chars;
  };

  Utils.bind = function (func, context) {
    return function () {
      func.apply(context, arguments);
    };
  };

  Utils._convertData = function (data) {
    for (var originalKey in data) {
      var keys = originalKey.split('-');

      var dataLevel = data;

      if (keys.length === 1) {
        continue;
      }

      for (var k = 0; k < keys.length; k++) {
        var key = keys[k];

        // Lowercase the first letter
        // By default, dash-separated becomes camelCase
        key = key.substring(0, 1).toLowerCase() + key.substring(1);

        if (!(key in dataLevel)) {
          dataLevel[key] = {};
        }

        if (k == keys.length - 1) {
          dataLevel[key] = data[originalKey];
        }

        dataLevel = dataLevel[key];
      }

      delete data[originalKey];
    }

    return data;
  };

  Utils.hasScroll = function (index, el) {
    // Adapted from the function created by @ShadowScripter
    // and adapted by @BillBarry on the Stack Exchange Code Review website.
    // The original code can be found at
    // http://codereview.stackexchange.com/q/13338
    // and was designed to be used with the Sizzle selector engine.

    var $el = $(el);
    var overflowX = el.style.overflowX;
    var overflowY = el.style.overflowY;

    //Check both x and y declarations
    if (overflowX === overflowY &&
        (overflowY === 'hidden' || overflowY === 'visible')) {
      return false;
    }

    if (overflowX === 'scroll' || overflowY === 'scroll') {
      return true;
    }

    return ($el.innerHeight() < el.scrollHeight ||
      $el.innerWidth() < el.scrollWidth);
  };

  Utils.escapeMarkup = function (markup) {
    var replaceMap = {
      '\\': '&#92;',
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      '\'': '&#39;',
      '/': '&#47;'
    };

    // Do not try to escape the markup if it's not a string
    if (typeof markup !== 'string') {
      return markup;
    }

    return String(markup).replace(/[&<>"'\/\\]/g, function (match) {
      return replaceMap[match];
    });
  };

  // Append an array of jQuery nodes to a given element.
  Utils.appendMany = function ($element, $nodes) {
    // jQuery 1.7.x does not support $.fn.append() with an array
    // Fall back to a jQuery object collection using $.fn.add()
    if ($.fn.jquery.substr(0, 3) === '1.7') {
      var $jqNodes = $();

      $.map($nodes, function (node) {
        $jqNodes = $jqNodes.add(node);
      });

      $nodes = $jqNodes;
    }

    $element.append($nodes);
  };

  // Cache objects in Utils.__cache instead of $.data (see #4346)
  Utils.__cache = {};

  var id = 0;
  Utils.GetUniqueElementId = function (element) {
    // Get a unique element Id. If element has no id,
    // creates a new unique number, stores it in the id
    // attribute and returns the new id.
    // If an id already exists, it simply returns it.

    var select2Id = element.getAttribute('data-select2-id');
    if (select2Id == null) {
      // If element has id, use it.
      if (element.id) {
        select2Id = element.id;
        element.setAttribute('data-select2-id', select2Id);
      } else {
        element.setAttribute('data-select2-id', ++id);
        select2Id = id.toString();
      }
    }
    return select2Id;
  };

  Utils.StoreData = function (element, name, value) {
    // Stores an item in the cache for a specified element.
    // name is the cache key.
    var id = Utils.GetUniqueElementId(element);
    if (!Utils.__cache[id]) {
      Utils.__cache[id] = {};
    }

    Utils.__cache[id][name] = value;
  };

  Utils.GetData = function (element, name) {
    // Retrieves a value from the cache by its key (name)
    // name is optional. If no name specified, return
    // all cache items for the specified element.
    // and for a specified element.
    var id = Utils.GetUniqueElementId(element);
    if (name) {
      if (Utils.__cache[id]) {
        if (Utils.__cache[id][name] != null) {
          return Utils.__cache[id][name];
        }
        return $(element).data(name); // Fallback to HTML5 data attribs.
      }
      return $(element).data(name); // Fallback to HTML5 data attribs.
    } else {
      return Utils.__cache[id];
    }
  };

  Utils.RemoveData = function (element) {
    // Removes all cached items for a specified element.
    var id = Utils.GetUniqueElementId(element);
    if (Utils.__cache[id] != null) {
      delete Utils.__cache[id];
    }

    element.removeAttribute('data-select2-id');
  };

  return Utils;
});

S2.define('select2/results',[
  'jquery',
  './utils'
], function ($, Utils) {
  function Results ($element, options, dataAdapter) {
    this.$element = $element;
    this.data = dataAdapter;
    this.options = options;

    Results.__super__.constructor.call(this);
  }

  Utils.Extend(Results, Utils.Observable);

  Results.prototype.render = function () {
    var $results = $(
      '<ul class="select2-results__options" role="listbox"></ul>'
    );

    if (this.options.get('multiple')) {
      $results.attr('aria-multiselectable', 'true');
    }

    this.$results = $results;

    return $results;
  };

  Results.prototype.clear = function () {
    this.$results.empty();
  };

  Results.prototype.displayMessage = function (params) {
    var escapeMarkup = this.options.get('escapeMarkup');

    this.clear();
    this.hideLoading();

    var $message = $(
      '<li role="alert" aria-live="assertive"' +
      ' class="select2-results__option"></li>'
    );

    var message = this.options.get('translations').get(params.message);

    $message.append(
      escapeMarkup(
        message(params.args)
      )
    );

    $message[0].className += ' select2-results__message';

    this.$results.append($message);
  };

  Results.prototype.hideMessages = function () {
    this.$results.find('.select2-results__message').remove();
  };

  Results.prototype.append = function (data) {
    this.hideLoading();

    var $options = [];

    if (data.results == null || data.results.length === 0) {
      if (this.$results.children().length === 0) {
        this.trigger('results:message', {
          message: 'noResults'
        });
      }

      return;
    }

    data.results = this.sort(data.results);

    for (var d = 0; d < data.results.length; d++) {
      var item = data.results[d];

      var $option = this.option(item);

      $options.push($option);
    }

    this.$results.append($options);
  };

  Results.prototype.position = function ($results, $dropdown) {
    var $resultsContainer = $dropdown.find('.select2-results');
    $resultsContainer.append($results);
  };

  Results.prototype.sort = function (data) {
    var sorter = this.options.get('sorter');

    return sorter(data);
  };

  Results.prototype.highlightFirstItem = function () {
    var $options = this.$results
      .find('.select2-results__option[aria-selected]');

    var $selected = $options.filter('[aria-selected=true]');

    // Check if there are any selected options
    if ($selected.length > 0) {
      // If there are selected options, highlight the first
      $selected.first().trigger('mouseenter');
    } else {
      // If there are no selected options, highlight the first option
      // in the dropdown
      $options.first().trigger('mouseenter');
    }

    this.ensureHighlightVisible();
  };

  Results.prototype.setClasses = function () {
    var self = this;

    this.data.current(function (selected) {
      var selectedIds = $.map(selected, function (s) {
        return s.id.toString();
      });

      var $options = self.$results
        .find('.select2-results__option[aria-selected]');

      $options.each(function () {
        var $option = $(this);

        var item = Utils.GetData(this, 'data');

        // id needs to be converted to a string when comparing
        var id = '' + item.id;

        if ((item.element != null && item.element.selected) ||
            (item.element == null && $.inArray(id, selectedIds) > -1)) {
          $option.attr('aria-selected', 'true');
        } else {
          $option.attr('aria-selected', 'false');
        }
      });

    });
  };

  Results.prototype.showLoading = function (params) {
    this.hideLoading();

    var loadingMore = this.options.get('translations').get('searching');

    var loading = {
      disabled: true,
      loading: true,
      text: loadingMore(params)
    };
    var $loading = this.option(loading);
    $loading.className += ' loading-results';

    this.$results.prepend($loading);
  };

  Results.prototype.hideLoading = function () {
    this.$results.find('.loading-results').remove();
  };

  Results.prototype.option = function (data) {
    var option = document.createElement('li');
    option.className = 'select2-results__option';

    var attrs = {
      'role': 'option',
      'aria-selected': 'false'
    };

    var matches = window.Element.prototype.matches ||
      window.Element.prototype.msMatchesSelector ||
      window.Element.prototype.webkitMatchesSelector;

    if ((data.element != null && matches.call(data.element, ':disabled')) ||
        (data.element == null && data.disabled)) {
      delete attrs['aria-selected'];
      attrs['aria-disabled'] = 'true';
    }

    if (data.id == null) {
      delete attrs['aria-selected'];
    }

    if (data._resultId != null) {
      option.id = data._resultId;
    }

    if (data.title) {
      option.title = data.title;
    }

    if (data.children) {
      attrs.role = 'group';
      attrs['aria-label'] = data.text;
      delete attrs['aria-selected'];
    }

    for (var attr in attrs) {
      var val = attrs[attr];

      option.setAttribute(attr, val);
    }

    if (data.children) {
      var $option = $(option);

      var label = document.createElement('strong');
      label.className = 'select2-results__group';

      var $label = $(label);
      this.template(data, label);

      var $children = [];

      for (var c = 0; c < data.children.length; c++) {
        var child = data.children[c];

        var $child = this.option(child);

        $children.push($child);
      }

      var $childrenContainer = $('<ul></ul>', {
        'class': 'select2-results__options select2-results__options--nested'
      });

      $childrenContainer.append($children);

      $option.append(label);
      $option.append($childrenContainer);
    } else {
      this.template(data, option);
    }

    Utils.StoreData(option, 'data', data);

    return option;
  };

  Results.prototype.bind = function (container, $container) {
    var self = this;

    var id = container.id + '-results';

    this.$results.attr('id', id);

    container.on('results:all', function (params) {
      self.clear();
      self.append(params.data);

      if (container.isOpen()) {
        self.setClasses();
        self.highlightFirstItem();
      }
    });

    container.on('results:append', function (params) {
      self.append(params.data);

      if (container.isOpen()) {
        self.setClasses();
      }
    });

    container.on('query', function (params) {
      self.hideMessages();
      self.showLoading(params);
    });

    container.on('select', function () {
      if (!container.isOpen()) {
        return;
      }

      self.setClasses();

      if (self.options.get('scrollAfterSelect')) {
        self.highlightFirstItem();
      }
    });

    container.on('unselect', function () {
      if (!container.isOpen()) {
        return;
      }

      self.setClasses();

      if (self.options.get('scrollAfterSelect')) {
        self.highlightFirstItem();
      }
    });

    container.on('open', function () {
      // When the dropdown is open, aria-expended="true"
      self.$results.attr('aria-expanded', 'true');
      self.$results.attr('aria-hidden', 'false');

      self.setClasses();
      self.ensureHighlightVisible();
    });

    container.on('close', function () {
      // When the dropdown is closed, aria-expended="false"
      self.$results.attr('aria-expanded', 'false');
      self.$results.attr('aria-hidden', 'true');
      self.$results.removeAttr('aria-activedescendant');
    });

    container.on('results:toggle', function () {
      var $highlighted = self.getHighlightedResults();

      if ($highlighted.length === 0) {
        return;
      }

      $highlighted.trigger('mouseup');
    });

    container.on('results:select', function () {
      var $highlighted = self.getHighlightedResults();

      if ($highlighted.length === 0) {
        return;
      }

      var data = Utils.GetData($highlighted[0], 'data');

      if ($highlighted.attr('aria-selected') == 'true') {
        self.trigger('close', {});
      } else {
        self.trigger('select', {
          data: data
        });
      }
    });

    container.on('results:previous', function () {
      var $highlighted = self.getHighlightedResults();

      var $options = self.$results.find('[aria-selected]');

      var currentIndex = $options.index($highlighted);

      // If we are already at the top, don't move further
      // If no options, currentIndex will be -1
      if (currentIndex <= 0) {
        return;
      }

      var nextIndex = currentIndex - 1;

      // If none are highlighted, highlight the first
      if ($highlighted.length === 0) {
        nextIndex = 0;
      }

      var $next = $options.eq(nextIndex);

      $next.trigger('mouseenter');

      var currentOffset = self.$results.offset().top;
      var nextTop = $next.offset().top;
      var nextOffset = self.$results.scrollTop() + (nextTop - currentOffset);

      if (nextIndex === 0) {
        self.$results.scrollTop(0);
      } else if (nextTop - currentOffset < 0) {
        self.$results.scrollTop(nextOffset);
      }
    });

    container.on('results:next', function () {
      var $highlighted = self.getHighlightedResults();

      var $options = self.$results.find('[aria-selected]');

      var currentIndex = $options.index($highlighted);

      var nextIndex = currentIndex + 1;

      // If we are at the last option, stay there
      if (nextIndex >= $options.length) {
        return;
      }

      var $next = $options.eq(nextIndex);

      $next.trigger('mouseenter');

      var currentOffset = self.$results.offset().top +
        self.$results.outerHeight(false);
      var nextBottom = $next.offset().top + $next.outerHeight(false);
      var nextOffset = self.$results.scrollTop() + nextBottom - currentOffset;

      if (nextIndex === 0) {
        self.$results.scrollTop(0);
      } else if (nextBottom > currentOffset) {
        self.$results.scrollTop(nextOffset);
      }
    });

    container.on('results:focus', function (params) {
      params.element.addClass('select2-results__option--highlighted');
    });

    container.on('results:message', function (params) {
      self.displayMessage(params);
    });

    if ($.fn.mousewheel) {
      this.$results.on('mousewheel', function (e) {
        var top = self.$results.scrollTop();

        var bottom = self.$results.get(0).scrollHeight - top + e.deltaY;

        var isAtTop = e.deltaY > 0 && top - e.deltaY <= 0;
        var isAtBottom = e.deltaY < 0 && bottom <= self.$results.height();

        if (isAtTop) {
          self.$results.scrollTop(0);

          e.preventDefault();
          e.stopPropagation();
        } else if (isAtBottom) {
          self.$results.scrollTop(
            self.$results.get(0).scrollHeight - self.$results.height()
          );

          e.preventDefault();
          e.stopPropagation();
        }
      });
    }

    this.$results.on('mouseup', '.select2-results__option[aria-selected]',
      function (evt) {
      var $this = $(this);

      var data = Utils.GetData(this, 'data');

      if ($this.attr('aria-selected') === 'true') {
        if (self.options.get('multiple')) {
          self.trigger('unselect', {
            originalEvent: evt,
            data: data
          });
        } else {
          self.trigger('close', {});
        }

        return;
      }

      self.trigger('select', {
        originalEvent: evt,
        data: data
      });
    });

    this.$results.on('mouseenter', '.select2-results__option[aria-selected]',
      function (evt) {
      var data = Utils.GetData(this, 'data');

      self.getHighlightedResults()
          .removeClass('select2-results__option--highlighted');

      self.trigger('results:focus', {
        data: data,
        element: $(this)
      });
    });
  };

  Results.prototype.getHighlightedResults = function () {
    var $highlighted = this.$results
    .find('.select2-results__option--highlighted');

    return $highlighted;
  };

  Results.prototype.destroy = function () {
    this.$results.remove();
  };

  Results.prototype.ensureHighlightVisible = function () {
    var $highlighted = this.getHighlightedResults();

    if ($highlighted.length === 0) {
      return;
    }

    var $options = this.$results.find('[aria-selected]');

    var currentIndex = $options.index($highlighted);

    var currentOffset = this.$results.offset().top;
    var nextTop = $highlighted.offset().top;
    var nextOffset = this.$results.scrollTop() + (nextTop - currentOffset);

    var offsetDelta = nextTop - currentOffset;
    nextOffset -= $highlighted.outerHeight(false) * 2;

    if (currentIndex <= 2) {
      this.$results.scrollTop(0);
    } else if (offsetDelta > this.$results.outerHeight() || offsetDelta < 0) {
      this.$results.scrollTop(nextOffset);
    }
  };

  Results.prototype.template = function (result, container) {
    var template = this.options.get('templateResult');
    var escapeMarkup = this.options.get('escapeMarkup');

    var content = template(result, container);

    if (content == null) {
      container.style.display = 'none';
    } else if (typeof content === 'string') {
      container.innerHTML = escapeMarkup(content);
    } else {
      $(container).append(content);
    }
  };

  return Results;
});

S2.define('select2/keys',[

], function () {
  var KEYS = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    ESC: 27,
    SPACE: 32,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    END: 35,
    HOME: 36,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    DELETE: 46
  };

  return KEYS;
});

S2.define('select2/selection/base',[
  'jquery',
  '../utils',
  '../keys'
], function ($, Utils, KEYS) {
  function BaseSelection ($element, options) {
    this.$element = $element;
    this.options = options;

    BaseSelection.__super__.constructor.call(this);
  }

  Utils.Extend(BaseSelection, Utils.Observable);

  BaseSelection.prototype.render = function () {
    var $selection = $(
      '<span class="select2-selection" role="combobox" ' +
      ' aria-haspopup="true" aria-expanded="false">' +
      '</span>'
    );

    this._tabindex = 0;

    if (Utils.GetData(this.$element[0], 'old-tabindex') != null) {
      this._tabindex = Utils.GetData(this.$element[0], 'old-tabindex');
    } else if (this.$element.attr('tabindex') != null) {
      this._tabindex = this.$element.attr('tabindex');
    }

    $selection.attr('title', this.$element.attr('title'));
    $selection.attr('tabindex', this._tabindex);
    $selection.attr('aria-disabled', 'false');

    this.$selection = $selection;

    return $selection;
  };

  BaseSelection.prototype.bind = function (container, $container) {
    var self = this;

    var resultsId = container.id + '-results';

    this.container = container;

    this.$selection.on('focus', function (evt) {
      self.trigger('focus', evt);
    });

    this.$selection.on('blur', function (evt) {
      self._handleBlur(evt);
    });

    this.$selection.on('keydown', function (evt) {
      self.trigger('keypress', evt);

      if (evt.which === KEYS.SPACE) {
        evt.preventDefault();
      }
    });

    container.on('results:focus', function (params) {
      self.$selection.attr('aria-activedescendant', params.data._resultId);
    });

    container.on('selection:update', function (params) {
      self.update(params.data);
    });

    container.on('open', function () {
      // When the dropdown is open, aria-expanded="true"
      self.$selection.attr('aria-expanded', 'true');
      self.$selection.attr('aria-owns', resultsId);

      self._attachCloseHandler(container);
    });

    container.on('close', function () {
      // When the dropdown is closed, aria-expanded="false"
      self.$selection.attr('aria-expanded', 'false');
      self.$selection.removeAttr('aria-activedescendant');
      self.$selection.removeAttr('aria-owns');

      self.$selection.trigger('focus');

      self._detachCloseHandler(container);
    });

    container.on('enable', function () {
      self.$selection.attr('tabindex', self._tabindex);
      self.$selection.attr('aria-disabled', 'false');
    });

    container.on('disable', function () {
      self.$selection.attr('tabindex', '-1');
      self.$selection.attr('aria-disabled', 'true');
    });
  };

  BaseSelection.prototype._handleBlur = function (evt) {
    var self = this;

    // This needs to be delayed as the active element is the body when the tab
    // key is pressed, possibly along with others.
    window.setTimeout(function () {
      // Don't trigger `blur` if the focus is still in the selection
      if (
        (document.activeElement == self.$selection[0]) ||
        ($.contains(self.$selection[0], document.activeElement))
      ) {
        return;
      }

      self.trigger('blur', evt);
    }, 1);
  };

  BaseSelection.prototype._attachCloseHandler = function (container) {

    $(document.body).on('mousedown.select2.' + container.id, function (e) {
      var $target = $(e.target);

      var $select = $target.closest('.select2');

      var $all = $('.select2.select2-container--open');

      $all.each(function () {
        if (this == $select[0]) {
          return;
        }

        var $element = Utils.GetData(this, 'element');

        $element.select2('close');
      });
    });
  };

  BaseSelection.prototype._detachCloseHandler = function (container) {
    $(document.body).off('mousedown.select2.' + container.id);
  };

  BaseSelection.prototype.position = function ($selection, $container) {
    var $selectionContainer = $container.find('.selection');
    $selectionContainer.append($selection);
  };

  BaseSelection.prototype.destroy = function () {
    this._detachCloseHandler(this.container);
  };

  BaseSelection.prototype.update = function (data) {
    throw new Error('The `update` method must be defined in child classes.');
  };

  /**
   * Helper method to abstract the "enabled" (not "disabled") state of this
   * object.
   *
   * @return {true} if the instance is not disabled.
   * @return {false} if the instance is disabled.
   */
  BaseSelection.prototype.isEnabled = function () {
    return !this.isDisabled();
  };

  /**
   * Helper method to abstract the "disabled" state of this object.
   *
   * @return {true} if the disabled option is true.
   * @return {false} if the disabled option is false.
   */
  BaseSelection.prototype.isDisabled = function () {
    return this.options.get('disabled');
  };

  return BaseSelection;
});

S2.define('select2/selection/single',[
  'jquery',
  './base',
  '../utils',
  '../keys'
], function ($, BaseSelection, Utils, KEYS) {
  function SingleSelection () {
    SingleSelection.__super__.constructor.apply(this, arguments);
  }

  Utils.Extend(SingleSelection, BaseSelection);

  SingleSelection.prototype.render = function () {
    var $selection = SingleSelection.__super__.render.call(this);

    $selection.addClass('select2-selection--single');

    $selection.html(
      '<span class="select2-selection__rendered"></span>' +
      '<span class="select2-selection__arrow" role="presentation">' +
        '<b role="presentation"></b>' +
      '</span>'
    );

    return $selection;
  };

  SingleSelection.prototype.bind = function (container, $container) {
    var self = this;

    SingleSelection.__super__.bind.apply(this, arguments);

    var id = container.id + '-container';

    this.$selection.find('.select2-selection__rendered')
      .attr('id', id)
      .attr('role', 'textbox')
      .attr('aria-readonly', 'true');
    this.$selection.attr('aria-labelledby', id);

    this.$selection.on('mousedown', function (evt) {
      // Only respond to left clicks
      if (evt.which !== 1) {
        return;
      }

      self.trigger('toggle', {
        originalEvent: evt
      });
    });

    this.$selection.on('focus', function (evt) {
      // User focuses on the container
    });

    this.$selection.on('blur', function (evt) {
      // User exits the container
    });

    container.on('focus', function (evt) {
      if (!container.isOpen()) {
        self.$selection.trigger('focus');
      }
    });
  };

  SingleSelection.prototype.clear = function () {
    var $rendered = this.$selection.find('.select2-selection__rendered');
    $rendered.empty();
    $rendered.removeAttr('title'); // clear tooltip on empty
  };

  SingleSelection.prototype.display = function (data, container) {
    var template = this.options.get('templateSelection');
    var escapeMarkup = this.options.get('escapeMarkup');

    return escapeMarkup(template(data, container));
  };

  SingleSelection.prototype.selectionContainer = function () {
    return $('<span></span>');
  };

  SingleSelection.prototype.update = function (data) {
    if (data.length === 0) {
      this.clear();
      return;
    }

    var selection = data[0];

    var $rendered = this.$selection.find('.select2-selection__rendered');
    var formatted = this.display(selection, $rendered);

    $rendered.empty().append(formatted);

    var title = selection.title || selection.text;

    if (title) {
      $rendered.attr('title', title);
    } else {
      $rendered.removeAttr('title');
    }
  };

  return SingleSelection;
});

S2.define('select2/selection/multiple',[
  'jquery',
  './base',
  '../utils'
], function ($, BaseSelection, Utils) {
  function MultipleSelection ($element, options) {
    MultipleSelection.__super__.constructor.apply(this, arguments);
  }

  Utils.Extend(MultipleSelection, BaseSelection);

  MultipleSelection.prototype.render = function () {
    var $selection = MultipleSelection.__super__.render.call(this);

    $selection.addClass('select2-selection--multiple');

    $selection.html(
      '<ul class="select2-selection__rendered"></ul>'
    );

    return $selection;
  };

  MultipleSelection.prototype.bind = function (container, $container) {
    var self = this;

    MultipleSelection.__super__.bind.apply(this, arguments);

    this.$selection.on('click', function (evt) {
      self.trigger('toggle', {
        originalEvent: evt
      });
    });

    this.$selection.on(
      'click',
      '.select2-selection__choice__remove',
      function (evt) {
        // Ignore the event if it is disabled
        if (self.isDisabled()) {
          return;
        }

        var $remove = $(this);
        var $selection = $remove.parent();

        var data = Utils.GetData($selection[0], 'data');

        self.trigger('unselect', {
          originalEvent: evt,
          data: data
        });
      }
    );
  };

  MultipleSelection.prototype.clear = function () {
    var $rendered = this.$selection.find('.select2-selection__rendered');
    $rendered.empty();
    $rendered.removeAttr('title');
  };

  MultipleSelection.prototype.display = function (data, container) {
    var template = this.options.get('templateSelection');
    var escapeMarkup = this.options.get('escapeMarkup');

    return escapeMarkup(template(data, container));
  };

  MultipleSelection.prototype.selectionContainer = function () {
    var $container = $(
      '<li class="select2-selection__choice">' +
        '<span class="select2-selection__choice__remove" role="presentation">' +
          '&times;' +
        '</span>' +
      '</li>'
    );

    return $container;
  };

  MultipleSelection.prototype.update = function (data) {
    this.clear();

    if (data.length === 0) {
      return;
    }

    var $selections = [];

    for (var d = 0; d < data.length; d++) {
      var selection = data[d];

      var $selection = this.selectionContainer();
      var formatted = this.display(selection, $selection);

      $selection.append(formatted);

      var title = selection.title || selection.text;

      if (title) {
        $selection.attr('title', title);
      }

      Utils.StoreData($selection[0], 'data', selection);

      $selections.push($selection);
    }

    var $rendered = this.$selection.find('.select2-selection__rendered');

    Utils.appendMany($rendered, $selections);
  };

  return MultipleSelection;
});

S2.define('select2/selection/placeholder',[
  '../utils'
], function (Utils) {
  function Placeholder (decorated, $element, options) {
    this.placeholder = this.normalizePlaceholder(options.get('placeholder'));

    decorated.call(this, $element, options);
  }

  Placeholder.prototype.normalizePlaceholder = function (_, placeholder) {
    if (typeof placeholder === 'string') {
      placeholder = {
        id: '',
        text: placeholder
      };
    }

    return placeholder;
  };

  Placeholder.prototype.createPlaceholder = function (decorated, placeholder) {
    var $placeholder = this.selectionContainer();

    $placeholder.html(this.display(placeholder));
    $placeholder.addClass('select2-selection__placeholder')
                .removeClass('select2-selection__choice');

    return $placeholder;
  };

  Placeholder.prototype.update = function (decorated, data) {
    var singlePlaceholder = (
      data.length == 1 && data[0].id != this.placeholder.id
    );
    var multipleSelections = data.length > 1;

    if (multipleSelections || singlePlaceholder) {
      return decorated.call(this, data);
    }

    this.clear();

    var $placeholder = this.createPlaceholder(this.placeholder);

    this.$selection.find('.select2-selection__rendered').append($placeholder);
  };

  return Placeholder;
});

S2.define('select2/selection/allowClear',[
  'jquery',
  '../keys',
  '../utils'
], function ($, KEYS, Utils) {
  function AllowClear () { }

  AllowClear.prototype.bind = function (decorated, container, $container) {
    var self = this;

    decorated.call(this, container, $container);

    if (this.placeholder == null) {
      if (this.options.get('debug') && window.console && console.error) {
        console.error(
          'Select2: The `allowClear` option should be used in combination ' +
          'with the `placeholder` option.'
        );
      }
    }

    this.$selection.on('mousedown', '.select2-selection__clear',
      function (evt) {
        self._handleClear(evt);
    });

    container.on('keypress', function (evt) {
      self._handleKeyboardClear(evt, container);
    });
  };

  AllowClear.prototype._handleClear = function (_, evt) {
    // Ignore the event if it is disabled
    if (this.isDisabled()) {
      return;
    }

    var $clear = this.$selection.find('.select2-selection__clear');

    // Ignore the event if nothing has been selected
    if ($clear.length === 0) {
      return;
    }

    evt.stopPropagation();

    var data = Utils.GetData($clear[0], 'data');

    var previousVal = this.$element.val();
    this.$element.val(this.placeholder.id);

    var unselectData = {
      data: data
    };
    this.trigger('clear', unselectData);
    if (unselectData.prevented) {
      this.$element.val(previousVal);
      return;
    }

    for (var d = 0; d < data.length; d++) {
      unselectData = {
        data: data[d]
      };

      // Trigger the `unselect` event, so people can prevent it from being
      // cleared.
      this.trigger('unselect', unselectData);

      // If the event was prevented, don't clear it out.
      if (unselectData.prevented) {
        this.$element.val(previousVal);
        return;
      }
    }

    this.$element.trigger('input').trigger('change');

    this.trigger('toggle', {});
  };

  AllowClear.prototype._handleKeyboardClear = function (_, evt, container) {
    if (container.isOpen()) {
      return;
    }

    if (evt.which == KEYS.DELETE || evt.which == KEYS.BACKSPACE) {
      this._handleClear(evt);
    }
  };

  AllowClear.prototype.update = function (decorated, data) {
    decorated.call(this, data);

    if (this.$selection.find('.select2-selection__placeholder').length > 0 ||
        data.length === 0) {
      return;
    }

    var removeAll = this.options.get('translations').get('removeAllItems');

    var $remove = $(
      '<span class="select2-selection__clear" title="' + removeAll() +'">' +
        '&times;' +
      '</span>'
    );
    Utils.StoreData($remove[0], 'data', data);

    this.$selection.find('.select2-selection__rendered').prepend($remove);
  };

  return AllowClear;
});

S2.define('select2/selection/search',[
  'jquery',
  '../utils',
  '../keys'
], function ($, Utils, KEYS) {
  function Search (decorated, $element, options) {
    decorated.call(this, $element, options);
  }

  Search.prototype.render = function (decorated) {
    var $search = $(
      '<li class="select2-search select2-search--inline">' +
        '<input class="select2-search__field" type="search" tabindex="-1"' +
        ' autocomplete="off" autocorrect="off" autocapitalize="none"' +
        ' spellcheck="false" role="searchbox" aria-autocomplete="list" />' +
      '</li>'
    );

    this.$searchContainer = $search;
    this.$search = $search.find('input');

    var $rendered = decorated.call(this);

    this._transferTabIndex();

    return $rendered;
  };

  Search.prototype.bind = function (decorated, container, $container) {
    var self = this;

    var resultsId = container.id + '-results';

    decorated.call(this, container, $container);

    container.on('open', function () {
      self.$search.attr('aria-controls', resultsId);
	  setTimeout(function () {
		  self.$search.trigger('focus');
	  }, 1);
    });

    container.on('close', function () {
      self.$search.val('');
      self.$search.removeAttr('aria-controls');
      self.$search.removeAttr('aria-activedescendant');
      self.$search.trigger('focus');
    });

    container.on('enable', function () {
      self.$search.prop('disabled', false);

      self._transferTabIndex();
    });

    container.on('disable', function () {
      self.$search.prop('disabled', true);
    });

    container.on('focus', function (evt) {
		setTimeout(function () {
			self.$search.trigger('focus');
		}, 1);

    });

    container.on('results:focus', function (params) {
      if (params.data._resultId) {
        self.$search.attr('aria-activedescendant', params.data._resultId);
      } else {
        self.$search.removeAttr('aria-activedescendant');
      }
    });

    this.$selection.on('focusin', '.select2-search--inline', function (evt) {
      self.trigger('focus', evt);
    });

    this.$selection.on('focusout', '.select2-search--inline', function (evt) {
      self._handleBlur(evt);
    });

    this.$selection.on('keydown', '.select2-search--inline', function (evt) {
      evt.stopPropagation();

      self.trigger('keypress', evt);

      self._keyUpPrevented = evt.isDefaultPrevented();

      var key = evt.which;

      if (key === KEYS.BACKSPACE && self.$search.val() === '') {
        var $previousChoice = self.$searchContainer
          .prev('.select2-selection__choice');

        if ($previousChoice.length > 0) {
          var item = Utils.GetData($previousChoice[0], 'data');

          self.searchRemoveChoice(item);

          evt.preventDefault();
        }
      }
    });

    this.$selection.on('click', '.select2-search--inline', function (evt) {
      if (self.$search.val()) {
        evt.stopPropagation();
      }
    });

    // Try to detect the IE version should the `documentMode` property that
    // is stored on the document. This is only implemented in IE and is
    // slightly cleaner than doing a user agent check.
    // This property is not available in Edge, but Edge also doesn't have
    // this bug.
    var msie = document.documentMode;
    var disableInputEvents = msie && msie <= 11;

    // Workaround for browsers which do not support the `input` event
    // This will prevent double-triggering of events for browsers which support
    // both the `keyup` and `input` events.
    this.$selection.on(
      'input.searchcheck',
      '.select2-search--inline',
      function (evt) {
        // IE will trigger the `input` event when a placeholder is used on a
        // search box. To get around this issue, we are forced to ignore all
        // `input` events in IE and keep using `keyup`.
        if (disableInputEvents) {
          self.$selection.off('input.search input.searchcheck');
          return;
        }

        // Unbind the duplicated `keyup` event
        self.$selection.off('keyup.search');
      }
    );

    this.$selection.on(
      'keyup.search input.search',
      '.select2-search--inline',
      function (evt) {
        // IE will trigger the `input` event when a placeholder is used on a
        // search box. To get around this issue, we are forced to ignore all
        // `input` events in IE and keep using `keyup`.
        if (disableInputEvents && evt.type === 'input') {
          self.$selection.off('input.search input.searchcheck');
          return;
        }

        var key = evt.which;

        // We can freely ignore events from modifier keys
        if (key == KEYS.SHIFT || key == KEYS.CTRL || key == KEYS.ALT) {
          return;
        }

        // Tabbing will be handled during the `keydown` phase
        if (key == KEYS.TAB) {
          return;
        }

        self.handleSearch(evt);
      }
    );
  };

  /**
   * This method will transfer the tabindex attribute from the rendered
   * selection to the search box. This allows for the search box to be used as
   * the primary focus instead of the selection container.
   *
   * @private
   */
  Search.prototype._transferTabIndex = function (decorated) {
    this.$search.attr('tabindex', this.$selection.attr('tabindex'));
    this.$selection.attr('tabindex', '-1');
  };

  Search.prototype.createPlaceholder = function (decorated, placeholder) {
    this.$search.attr('placeholder', placeholder.text);
  };

  Search.prototype.update = function (decorated, data) {
    var searchHadFocus = this.$search[0] == document.activeElement;

    this.$search.attr('placeholder', '');

    decorated.call(this, data);

    this.$selection.find('.select2-selection__rendered')
                   .append(this.$searchContainer);

    this.resizeSearch();
    if (searchHadFocus) {
      this.$search.trigger('focus');
    }
  };

  Search.prototype.handleSearch = function () {
    this.resizeSearch();

    if (!this._keyUpPrevented) {
      var input = this.$search.val();

      this.trigger('query', {
        term: input
      });
    }

    this._keyUpPrevented = false;
  };

  Search.prototype.searchRemoveChoice = function (decorated, item) {
    this.trigger('unselect', {
      data: item
    });

    this.$search.val(item.text);
    this.handleSearch();
  };

  Search.prototype.resizeSearch = function () {
    this.$search.css('width', '25px');

    var width = '';

    if (this.$search.attr('placeholder') !== '') {
      width = this.$selection.find('.select2-selection__rendered').width();
    } else {
      var minimumWidth = this.$search.val().length + 1;

      width = (minimumWidth * 0.75) + 'em';
    }

    this.$search.css('width', width);
  };

  return Search;
});

S2.define('select2/selection/eventRelay',[
  'jquery'
], function ($) {
  function EventRelay () { }

  EventRelay.prototype.bind = function (decorated, container, $container) {
    var self = this;
    var relayEvents = [
      'open', 'opening',
      'close', 'closing',
      'select', 'selecting',
      'unselect', 'unselecting',
      'clear', 'clearing'
    ];

    var preventableEvents = [
      'opening', 'closing', 'selecting', 'unselecting', 'clearing'
    ];

    decorated.call(this, container, $container);

    container.on('*', function (name, params) {
      // Ignore events that should not be relayed
      if ($.inArray(name, relayEvents) === -1) {
        return;
      }

      // The parameters should always be an object
      params = params || {};

      // Generate the jQuery event for the Select2 event
      var evt = $.Event('select2:' + name, {
        params: params
      });

      self.$element.trigger(evt);

      // Only handle preventable events if it was one
      if ($.inArray(name, preventableEvents) === -1) {
        return;
      }

      params.prevented = evt.isDefaultPrevented();
    });
  };

  return EventRelay;
});

S2.define('select2/translation',[
  'jquery',
  'require'
], function ($, require) {
  function Translation (dict) {
    this.dict = dict || {};
  }

  Translation.prototype.all = function () {
    return this.dict;
  };

  Translation.prototype.get = function (key) {
    return this.dict[key];
  };

  Translation.prototype.extend = function (translation) {
    this.dict = $.extend({}, translation.all(), this.dict);
  };

  // Static functions

  Translation._cache = {};

  Translation.loadPath = function (path) {
    if (!(path in Translation._cache)) {
      var translations = require(path);

      Translation._cache[path] = translations;
    }

    return new Translation(Translation._cache[path]);
  };

  return Translation;
});

S2.define('select2/diacritics',[

], function () {
  var diacritics = {
    '\u24B6': 'A',
    '\uFF21': 'A',
    '\u00C0': 'A',
    '\u00C1': 'A',
    '\u00C2': 'A',
    '\u1EA6': 'A',
    '\u1EA4': 'A',
    '\u1EAA': 'A',
    '\u1EA8': 'A',
    '\u00C3': 'A',
    '\u0100': 'A',
    '\u0102': 'A',
    '\u1EB0': 'A',
    '\u1EAE': 'A',
    '\u1EB4': 'A',
    '\u1EB2': 'A',
    '\u0226': 'A',
    '\u01E0': 'A',
    '\u00C4': 'A',
    '\u01DE': 'A',
    '\u1EA2': 'A',
    '\u00C5': 'A',
    '\u01FA': 'A',
    '\u01CD': 'A',
    '\u0200': 'A',
    '\u0202': 'A',
    '\u1EA0': 'A',
    '\u1EAC': 'A',
    '\u1EB6': 'A',
    '\u1E00': 'A',
    '\u0104': 'A',
    '\u023A': 'A',
    '\u2C6F': 'A',
    '\uA732': 'AA',
    '\u00C6': 'AE',
    '\u01FC': 'AE',
    '\u01E2': 'AE',
    '\uA734': 'AO',
    '\uA736': 'AU',
    '\uA738': 'AV',
    '\uA73A': 'AV',
    '\uA73C': 'AY',
    '\u24B7': 'B',
    '\uFF22': 'B',
    '\u1E02': 'B',
    '\u1E04': 'B',
    '\u1E06': 'B',
    '\u0243': 'B',
    '\u0182': 'B',
    '\u0181': 'B',
    '\u24B8': 'C',
    '\uFF23': 'C',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010A': 'C',
    '\u010C': 'C',
    '\u00C7': 'C',
    '\u1E08': 'C',
    '\u0187': 'C',
    '\u023B': 'C',
    '\uA73E': 'C',
    '\u24B9': 'D',
    '\uFF24': 'D',
    '\u1E0A': 'D',
    '\u010E': 'D',
    '\u1E0C': 'D',
    '\u1E10': 'D',
    '\u1E12': 'D',
    '\u1E0E': 'D',
    '\u0110': 'D',
    '\u018B': 'D',
    '\u018A': 'D',
    '\u0189': 'D',
    '\uA779': 'D',
    '\u01F1': 'DZ',
    '\u01C4': 'DZ',
    '\u01F2': 'Dz',
    '\u01C5': 'Dz',
    '\u24BA': 'E',
    '\uFF25': 'E',
    '\u00C8': 'E',
    '\u00C9': 'E',
    '\u00CA': 'E',
    '\u1EC0': 'E',
    '\u1EBE': 'E',
    '\u1EC4': 'E',
    '\u1EC2': 'E',
    '\u1EBC': 'E',
    '\u0112': 'E',
    '\u1E14': 'E',
    '\u1E16': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u00CB': 'E',
    '\u1EBA': 'E',
    '\u011A': 'E',
    '\u0204': 'E',
    '\u0206': 'E',
    '\u1EB8': 'E',
    '\u1EC6': 'E',
    '\u0228': 'E',
    '\u1E1C': 'E',
    '\u0118': 'E',
    '\u1E18': 'E',
    '\u1E1A': 'E',
    '\u0190': 'E',
    '\u018E': 'E',
    '\u24BB': 'F',
    '\uFF26': 'F',
    '\u1E1E': 'F',
    '\u0191': 'F',
    '\uA77B': 'F',
    '\u24BC': 'G',
    '\uFF27': 'G',
    '\u01F4': 'G',
    '\u011C': 'G',
    '\u1E20': 'G',
    '\u011E': 'G',
    '\u0120': 'G',
    '\u01E6': 'G',
    '\u0122': 'G',
    '\u01E4': 'G',
    '\u0193': 'G',
    '\uA7A0': 'G',
    '\uA77D': 'G',
    '\uA77E': 'G',
    '\u24BD': 'H',
    '\uFF28': 'H',
    '\u0124': 'H',
    '\u1E22': 'H',
    '\u1E26': 'H',
    '\u021E': 'H',
    '\u1E24': 'H',
    '\u1E28': 'H',
    '\u1E2A': 'H',
    '\u0126': 'H',
    '\u2C67': 'H',
    '\u2C75': 'H',
    '\uA78D': 'H',
    '\u24BE': 'I',
    '\uFF29': 'I',
    '\u00CC': 'I',
    '\u00CD': 'I',
    '\u00CE': 'I',
    '\u0128': 'I',
    '\u012A': 'I',
    '\u012C': 'I',
    '\u0130': 'I',
    '\u00CF': 'I',
    '\u1E2E': 'I',
    '\u1EC8': 'I',
    '\u01CF': 'I',
    '\u0208': 'I',
    '\u020A': 'I',
    '\u1ECA': 'I',
    '\u012E': 'I',
    '\u1E2C': 'I',
    '\u0197': 'I',
    '\u24BF': 'J',
    '\uFF2A': 'J',
    '\u0134': 'J',
    '\u0248': 'J',
    '\u24C0': 'K',
    '\uFF2B': 'K',
    '\u1E30': 'K',
    '\u01E8': 'K',
    '\u1E32': 'K',
    '\u0136': 'K',
    '\u1E34': 'K',
    '\u0198': 'K',
    '\u2C69': 'K',
    '\uA740': 'K',
    '\uA742': 'K',
    '\uA744': 'K',
    '\uA7A2': 'K',
    '\u24C1': 'L',
    '\uFF2C': 'L',
    '\u013F': 'L',
    '\u0139': 'L',
    '\u013D': 'L',
    '\u1E36': 'L',
    '\u1E38': 'L',
    '\u013B': 'L',
    '\u1E3C': 'L',
    '\u1E3A': 'L',
    '\u0141': 'L',
    '\u023D': 'L',
    '\u2C62': 'L',
    '\u2C60': 'L',
    '\uA748': 'L',
    '\uA746': 'L',
    '\uA780': 'L',
    '\u01C7': 'LJ',
    '\u01C8': 'Lj',
    '\u24C2': 'M',
    '\uFF2D': 'M',
    '\u1E3E': 'M',
    '\u1E40': 'M',
    '\u1E42': 'M',
    '\u2C6E': 'M',
    '\u019C': 'M',
    '\u24C3': 'N',
    '\uFF2E': 'N',
    '\u01F8': 'N',
    '\u0143': 'N',
    '\u00D1': 'N',
    '\u1E44': 'N',
    '\u0147': 'N',
    '\u1E46': 'N',
    '\u0145': 'N',
    '\u1E4A': 'N',
    '\u1E48': 'N',
    '\u0220': 'N',
    '\u019D': 'N',
    '\uA790': 'N',
    '\uA7A4': 'N',
    '\u01CA': 'NJ',
    '\u01CB': 'Nj',
    '\u24C4': 'O',
    '\uFF2F': 'O',
    '\u00D2': 'O',
    '\u00D3': 'O',
    '\u00D4': 'O',
    '\u1ED2': 'O',
    '\u1ED0': 'O',
    '\u1ED6': 'O',
    '\u1ED4': 'O',
    '\u00D5': 'O',
    '\u1E4C': 'O',
    '\u022C': 'O',
    '\u1E4E': 'O',
    '\u014C': 'O',
    '\u1E50': 'O',
    '\u1E52': 'O',
    '\u014E': 'O',
    '\u022E': 'O',
    '\u0230': 'O',
    '\u00D6': 'O',
    '\u022A': 'O',
    '\u1ECE': 'O',
    '\u0150': 'O',
    '\u01D1': 'O',
    '\u020C': 'O',
    '\u020E': 'O',
    '\u01A0': 'O',
    '\u1EDC': 'O',
    '\u1EDA': 'O',
    '\u1EE0': 'O',
    '\u1EDE': 'O',
    '\u1EE2': 'O',
    '\u1ECC': 'O',
    '\u1ED8': 'O',
    '\u01EA': 'O',
    '\u01EC': 'O',
    '\u00D8': 'O',
    '\u01FE': 'O',
    '\u0186': 'O',
    '\u019F': 'O',
    '\uA74A': 'O',
    '\uA74C': 'O',
    '\u0152': 'OE',
    '\u01A2': 'OI',
    '\uA74E': 'OO',
    '\u0222': 'OU',
    '\u24C5': 'P',
    '\uFF30': 'P',
    '\u1E54': 'P',
    '\u1E56': 'P',
    '\u01A4': 'P',
    '\u2C63': 'P',
    '\uA750': 'P',
    '\uA752': 'P',
    '\uA754': 'P',
    '\u24C6': 'Q',
    '\uFF31': 'Q',
    '\uA756': 'Q',
    '\uA758': 'Q',
    '\u024A': 'Q',
    '\u24C7': 'R',
    '\uFF32': 'R',
    '\u0154': 'R',
    '\u1E58': 'R',
    '\u0158': 'R',
    '\u0210': 'R',
    '\u0212': 'R',
    '\u1E5A': 'R',
    '\u1E5C': 'R',
    '\u0156': 'R',
    '\u1E5E': 'R',
    '\u024C': 'R',
    '\u2C64': 'R',
    '\uA75A': 'R',
    '\uA7A6': 'R',
    '\uA782': 'R',
    '\u24C8': 'S',
    '\uFF33': 'S',
    '\u1E9E': 'S',
    '\u015A': 'S',
    '\u1E64': 'S',
    '\u015C': 'S',
    '\u1E60': 'S',
    '\u0160': 'S',
    '\u1E66': 'S',
    '\u1E62': 'S',
    '\u1E68': 'S',
    '\u0218': 'S',
    '\u015E': 'S',
    '\u2C7E': 'S',
    '\uA7A8': 'S',
    '\uA784': 'S',
    '\u24C9': 'T',
    '\uFF34': 'T',
    '\u1E6A': 'T',
    '\u0164': 'T',
    '\u1E6C': 'T',
    '\u021A': 'T',
    '\u0162': 'T',
    '\u1E70': 'T',
    '\u1E6E': 'T',
    '\u0166': 'T',
    '\u01AC': 'T',
    '\u01AE': 'T',
    '\u023E': 'T',
    '\uA786': 'T',
    '\uA728': 'TZ',
    '\u24CA': 'U',
    '\uFF35': 'U',
    '\u00D9': 'U',
    '\u00DA': 'U',
    '\u00DB': 'U',
    '\u0168': 'U',
    '\u1E78': 'U',
    '\u016A': 'U',
    '\u1E7A': 'U',
    '\u016C': 'U',
    '\u00DC': 'U',
    '\u01DB': 'U',
    '\u01D7': 'U',
    '\u01D5': 'U',
    '\u01D9': 'U',
    '\u1EE6': 'U',
    '\u016E': 'U',
    '\u0170': 'U',
    '\u01D3': 'U',
    '\u0214': 'U',
    '\u0216': 'U',
    '\u01AF': 'U',
    '\u1EEA': 'U',
    '\u1EE8': 'U',
    '\u1EEE': 'U',
    '\u1EEC': 'U',
    '\u1EF0': 'U',
    '\u1EE4': 'U',
    '\u1E72': 'U',
    '\u0172': 'U',
    '\u1E76': 'U',
    '\u1E74': 'U',
    '\u0244': 'U',
    '\u24CB': 'V',
    '\uFF36': 'V',
    '\u1E7C': 'V',
    '\u1E7E': 'V',
    '\u01B2': 'V',
    '\uA75E': 'V',
    '\u0245': 'V',
    '\uA760': 'VY',
    '\u24CC': 'W',
    '\uFF37': 'W',
    '\u1E80': 'W',
    '\u1E82': 'W',
    '\u0174': 'W',
    '\u1E86': 'W',
    '\u1E84': 'W',
    '\u1E88': 'W',
    '\u2C72': 'W',
    '\u24CD': 'X',
    '\uFF38': 'X',
    '\u1E8A': 'X',
    '\u1E8C': 'X',
    '\u24CE': 'Y',
    '\uFF39': 'Y',
    '\u1EF2': 'Y',
    '\u00DD': 'Y',
    '\u0176': 'Y',
    '\u1EF8': 'Y',
    '\u0232': 'Y',
    '\u1E8E': 'Y',
    '\u0178': 'Y',
    '\u1EF6': 'Y',
    '\u1EF4': 'Y',
    '\u01B3': 'Y',
    '\u024E': 'Y',
    '\u1EFE': 'Y',
    '\u24CF': 'Z',
    '\uFF3A': 'Z',
    '\u0179': 'Z',
    '\u1E90': 'Z',
    '\u017B': 'Z',
    '\u017D': 'Z',
    '\u1E92': 'Z',
    '\u1E94': 'Z',
    '\u01B5': 'Z',
    '\u0224': 'Z',
    '\u2C7F': 'Z',
    '\u2C6B': 'Z',
    '\uA762': 'Z',
    '\u24D0': 'a',
    '\uFF41': 'a',
    '\u1E9A': 'a',
    '\u00E0': 'a',
    '\u00E1': 'a',
    '\u00E2': 'a',
    '\u1EA7': 'a',
    '\u1EA5': 'a',
    '\u1EAB': 'a',
    '\u1EA9': 'a',
    '\u00E3': 'a',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u1EB1': 'a',
    '\u1EAF': 'a',
    '\u1EB5': 'a',
    '\u1EB3': 'a',
    '\u0227': 'a',
    '\u01E1': 'a',
    '\u00E4': 'a',
    '\u01DF': 'a',
    '\u1EA3': 'a',
    '\u00E5': 'a',
    '\u01FB': 'a',
    '\u01CE': 'a',
    '\u0201': 'a',
    '\u0203': 'a',
    '\u1EA1': 'a',
    '\u1EAD': 'a',
    '\u1EB7': 'a',
    '\u1E01': 'a',
    '\u0105': 'a',
    '\u2C65': 'a',
    '\u0250': 'a',
    '\uA733': 'aa',
    '\u00E6': 'ae',
    '\u01FD': 'ae',
    '\u01E3': 'ae',
    '\uA735': 'ao',
    '\uA737': 'au',
    '\uA739': 'av',
    '\uA73B': 'av',
    '\uA73D': 'ay',
    '\u24D1': 'b',
    '\uFF42': 'b',
    '\u1E03': 'b',
    '\u1E05': 'b',
    '\u1E07': 'b',
    '\u0180': 'b',
    '\u0183': 'b',
    '\u0253': 'b',
    '\u24D2': 'c',
    '\uFF43': 'c',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010B': 'c',
    '\u010D': 'c',
    '\u00E7': 'c',
    '\u1E09': 'c',
    '\u0188': 'c',
    '\u023C': 'c',
    '\uA73F': 'c',
    '\u2184': 'c',
    '\u24D3': 'd',
    '\uFF44': 'd',
    '\u1E0B': 'd',
    '\u010F': 'd',
    '\u1E0D': 'd',
    '\u1E11': 'd',
    '\u1E13': 'd',
    '\u1E0F': 'd',
    '\u0111': 'd',
    '\u018C': 'd',
    '\u0256': 'd',
    '\u0257': 'd',
    '\uA77A': 'd',
    '\u01F3': 'dz',
    '\u01C6': 'dz',
    '\u24D4': 'e',
    '\uFF45': 'e',
    '\u00E8': 'e',
    '\u00E9': 'e',
    '\u00EA': 'e',
    '\u1EC1': 'e',
    '\u1EBF': 'e',
    '\u1EC5': 'e',
    '\u1EC3': 'e',
    '\u1EBD': 'e',
    '\u0113': 'e',
    '\u1E15': 'e',
    '\u1E17': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u00EB': 'e',
    '\u1EBB': 'e',
    '\u011B': 'e',
    '\u0205': 'e',
    '\u0207': 'e',
    '\u1EB9': 'e',
    '\u1EC7': 'e',
    '\u0229': 'e',
    '\u1E1D': 'e',
    '\u0119': 'e',
    '\u1E19': 'e',
    '\u1E1B': 'e',
    '\u0247': 'e',
    '\u025B': 'e',
    '\u01DD': 'e',
    '\u24D5': 'f',
    '\uFF46': 'f',
    '\u1E1F': 'f',
    '\u0192': 'f',
    '\uA77C': 'f',
    '\u24D6': 'g',
    '\uFF47': 'g',
    '\u01F5': 'g',
    '\u011D': 'g',
    '\u1E21': 'g',
    '\u011F': 'g',
    '\u0121': 'g',
    '\u01E7': 'g',
    '\u0123': 'g',
    '\u01E5': 'g',
    '\u0260': 'g',
    '\uA7A1': 'g',
    '\u1D79': 'g',
    '\uA77F': 'g',
    '\u24D7': 'h',
    '\uFF48': 'h',
    '\u0125': 'h',
    '\u1E23': 'h',
    '\u1E27': 'h',
    '\u021F': 'h',
    '\u1E25': 'h',
    '\u1E29': 'h',
    '\u1E2B': 'h',
    '\u1E96': 'h',
    '\u0127': 'h',
    '\u2C68': 'h',
    '\u2C76': 'h',
    '\u0265': 'h',
    '\u0195': 'hv',
    '\u24D8': 'i',
    '\uFF49': 'i',
    '\u00EC': 'i',
    '\u00ED': 'i',
    '\u00EE': 'i',
    '\u0129': 'i',
    '\u012B': 'i',
    '\u012D': 'i',
    '\u00EF': 'i',
    '\u1E2F': 'i',
    '\u1EC9': 'i',
    '\u01D0': 'i',
    '\u0209': 'i',
    '\u020B': 'i',
    '\u1ECB': 'i',
    '\u012F': 'i',
    '\u1E2D': 'i',
    '\u0268': 'i',
    '\u0131': 'i',
    '\u24D9': 'j',
    '\uFF4A': 'j',
    '\u0135': 'j',
    '\u01F0': 'j',
    '\u0249': 'j',
    '\u24DA': 'k',
    '\uFF4B': 'k',
    '\u1E31': 'k',
    '\u01E9': 'k',
    '\u1E33': 'k',
    '\u0137': 'k',
    '\u1E35': 'k',
    '\u0199': 'k',
    '\u2C6A': 'k',
    '\uA741': 'k',
    '\uA743': 'k',
    '\uA745': 'k',
    '\uA7A3': 'k',
    '\u24DB': 'l',
    '\uFF4C': 'l',
    '\u0140': 'l',
    '\u013A': 'l',
    '\u013E': 'l',
    '\u1E37': 'l',
    '\u1E39': 'l',
    '\u013C': 'l',
    '\u1E3D': 'l',
    '\u1E3B': 'l',
    '\u017F': 'l',
    '\u0142': 'l',
    '\u019A': 'l',
    '\u026B': 'l',
    '\u2C61': 'l',
    '\uA749': 'l',
    '\uA781': 'l',
    '\uA747': 'l',
    '\u01C9': 'lj',
    '\u24DC': 'm',
    '\uFF4D': 'm',
    '\u1E3F': 'm',
    '\u1E41': 'm',
    '\u1E43': 'm',
    '\u0271': 'm',
    '\u026F': 'm',
    '\u24DD': 'n',
    '\uFF4E': 'n',
    '\u01F9': 'n',
    '\u0144': 'n',
    '\u00F1': 'n',
    '\u1E45': 'n',
    '\u0148': 'n',
    '\u1E47': 'n',
    '\u0146': 'n',
    '\u1E4B': 'n',
    '\u1E49': 'n',
    '\u019E': 'n',
    '\u0272': 'n',
    '\u0149': 'n',
    '\uA791': 'n',
    '\uA7A5': 'n',
    '\u01CC': 'nj',
    '\u24DE': 'o',
    '\uFF4F': 'o',
    '\u00F2': 'o',
    '\u00F3': 'o',
    '\u00F4': 'o',
    '\u1ED3': 'o',
    '\u1ED1': 'o',
    '\u1ED7': 'o',
    '\u1ED5': 'o',
    '\u00F5': 'o',
    '\u1E4D': 'o',
    '\u022D': 'o',
    '\u1E4F': 'o',
    '\u014D': 'o',
    '\u1E51': 'o',
    '\u1E53': 'o',
    '\u014F': 'o',
    '\u022F': 'o',
    '\u0231': 'o',
    '\u00F6': 'o',
    '\u022B': 'o',
    '\u1ECF': 'o',
    '\u0151': 'o',
    '\u01D2': 'o',
    '\u020D': 'o',
    '\u020F': 'o',
    '\u01A1': 'o',
    '\u1EDD': 'o',
    '\u1EDB': 'o',
    '\u1EE1': 'o',
    '\u1EDF': 'o',
    '\u1EE3': 'o',
    '\u1ECD': 'o',
    '\u1ED9': 'o',
    '\u01EB': 'o',
    '\u01ED': 'o',
    '\u00F8': 'o',
    '\u01FF': 'o',
    '\u0254': 'o',
    '\uA74B': 'o',
    '\uA74D': 'o',
    '\u0275': 'o',
    '\u0153': 'oe',
    '\u01A3': 'oi',
    '\u0223': 'ou',
    '\uA74F': 'oo',
    '\u24DF': 'p',
    '\uFF50': 'p',
    '\u1E55': 'p',
    '\u1E57': 'p',
    '\u01A5': 'p',
    '\u1D7D': 'p',
    '\uA751': 'p',
    '\uA753': 'p',
    '\uA755': 'p',
    '\u24E0': 'q',
    '\uFF51': 'q',
    '\u024B': 'q',
    '\uA757': 'q',
    '\uA759': 'q',
    '\u24E1': 'r',
    '\uFF52': 'r',
    '\u0155': 'r',
    '\u1E59': 'r',
    '\u0159': 'r',
    '\u0211': 'r',
    '\u0213': 'r',
    '\u1E5B': 'r',
    '\u1E5D': 'r',
    '\u0157': 'r',
    '\u1E5F': 'r',
    '\u024D': 'r',
    '\u027D': 'r',
    '\uA75B': 'r',
    '\uA7A7': 'r',
    '\uA783': 'r',
    '\u24E2': 's',
    '\uFF53': 's',
    '\u00DF': 's',
    '\u015B': 's',
    '\u1E65': 's',
    '\u015D': 's',
    '\u1E61': 's',
    '\u0161': 's',
    '\u1E67': 's',
    '\u1E63': 's',
    '\u1E69': 's',
    '\u0219': 's',
    '\u015F': 's',
    '\u023F': 's',
    '\uA7A9': 's',
    '\uA785': 's',
    '\u1E9B': 's',
    '\u24E3': 't',
    '\uFF54': 't',
    '\u1E6B': 't',
    '\u1E97': 't',
    '\u0165': 't',
    '\u1E6D': 't',
    '\u021B': 't',
    '\u0163': 't',
    '\u1E71': 't',
    '\u1E6F': 't',
    '\u0167': 't',
    '\u01AD': 't',
    '\u0288': 't',
    '\u2C66': 't',
    '\uA787': 't',
    '\uA729': 'tz',
    '\u24E4': 'u',
    '\uFF55': 'u',
    '\u00F9': 'u',
    '\u00FA': 'u',
    '\u00FB': 'u',
    '\u0169': 'u',
    '\u1E79': 'u',
    '\u016B': 'u',
    '\u1E7B': 'u',
    '\u016D': 'u',
    '\u00FC': 'u',
    '\u01DC': 'u',
    '\u01D8': 'u',
    '\u01D6': 'u',
    '\u01DA': 'u',
    '\u1EE7': 'u',
    '\u016F': 'u',
    '\u0171': 'u',
    '\u01D4': 'u',
    '\u0215': 'u',
    '\u0217': 'u',
    '\u01B0': 'u',
    '\u1EEB': 'u',
    '\u1EE9': 'u',
    '\u1EEF': 'u',
    '\u1EED': 'u',
    '\u1EF1': 'u',
    '\u1EE5': 'u',
    '\u1E73': 'u',
    '\u0173': 'u',
    '\u1E77': 'u',
    '\u1E75': 'u',
    '\u0289': 'u',
    '\u24E5': 'v',
    '\uFF56': 'v',
    '\u1E7D': 'v',
    '\u1E7F': 'v',
    '\u028B': 'v',
    '\uA75F': 'v',
    '\u028C': 'v',
    '\uA761': 'vy',
    '\u24E6': 'w',
    '\uFF57': 'w',
    '\u1E81': 'w',
    '\u1E83': 'w',
    '\u0175': 'w',
    '\u1E87': 'w',
    '\u1E85': 'w',
    '\u1E98': 'w',
    '\u1E89': 'w',
    '\u2C73': 'w',
    '\u24E7': 'x',
    '\uFF58': 'x',
    '\u1E8B': 'x',
    '\u1E8D': 'x',
    '\u24E8': 'y',
    '\uFF59': 'y',
    '\u1EF3': 'y',
    '\u00FD': 'y',
    '\u0177': 'y',
    '\u1EF9': 'y',
    '\u0233': 'y',
    '\u1E8F': 'y',
    '\u00FF': 'y',
    '\u1EF7': 'y',
    '\u1E99': 'y',
    '\u1EF5': 'y',
    '\u01B4': 'y',
    '\u024F': 'y',
    '\u1EFF': 'y',
    '\u24E9': 'z',
    '\uFF5A': 'z',
    '\u017A': 'z',
    '\u1E91': 'z',
    '\u017C': 'z',
    '\u017E': 'z',
    '\u1E93': 'z',
    '\u1E95': 'z',
    '\u01B6': 'z',
    '\u0225': 'z',
    '\u0240': 'z',
    '\u2C6C': 'z',
    '\uA763': 'z',
    '\u0386': '\u0391',
    '\u0388': '\u0395',
    '\u0389': '\u0397',
    '\u038A': '\u0399',
    '\u03AA': '\u0399',
    '\u038C': '\u039F',
    '\u038E': '\u03A5',
    '\u03AB': '\u03A5',
    '\u038F': '\u03A9',
    '\u03AC': '\u03B1',
    '\u03AD': '\u03B5',
    '\u03AE': '\u03B7',
    '\u03AF': '\u03B9',
    '\u03CA': '\u03B9',
    '\u0390': '\u03B9',
    '\u03CC': '\u03BF',
    '\u03CD': '\u03C5',
    '\u03CB': '\u03C5',
    '\u03B0': '\u03C5',
    '\u03CE': '\u03C9',
    '\u03C2': '\u03C3',
    '\u2019': '\''
  };

  return diacritics;
});

S2.define('select2/data/base',[
  '../utils'
], function (Utils) {
  function BaseAdapter ($element, options) {
    BaseAdapter.__super__.constructor.call(this);
  }

  Utils.Extend(BaseAdapter, Utils.Observable);

  BaseAdapter.prototype.current = function (callback) {
    throw new Error('The `current` method must be defined in child classes.');
  };

  BaseAdapter.prototype.query = function (params, callback) {
    throw new Error('The `query` method must be defined in child classes.');
  };

  BaseAdapter.prototype.bind = function (container, $container) {
    // Can be implemented in subclasses
  };

  BaseAdapter.prototype.destroy = function () {
    // Can be implemented in subclasses
  };

  BaseAdapter.prototype.generateResultId = function (container, data) {
    var id = container.id + '-result-';

    id += Utils.generateChars(4);

    if (data.id != null) {
      id += '-' + data.id.toString();
    } else {
      id += '-' + Utils.generateChars(4);
    }
    return id;
  };

  return BaseAdapter;
});

S2.define('select2/data/select',[
  './base',
  '../utils',
  'jquery'
], function (BaseAdapter, Utils, $) {
  function SelectAdapter ($element, options) {
    this.$element = $element;
    this.options = options;

    SelectAdapter.__super__.constructor.call(this);
  }

  Utils.Extend(SelectAdapter, BaseAdapter);

  SelectAdapter.prototype.current = function (callback) {
    var data = [];
    var self = this;

    this.$element.find(':selected').each(function () {
      var $option = $(this);

      var option = self.item($option);

      data.push(option);
    });

    callback(data);
  };

  SelectAdapter.prototype.select = function (data) {
    var self = this;

    data.selected = true;

    // If data.element is a DOM node, use it instead
    if ($(data.element).is('option')) {
      data.element.selected = true;

      this.$element.trigger('input').trigger('change');

      return;
    }

    if (this.$element.prop('multiple')) {
      this.current(function (currentData) {
        var val = [];

        data = [data];
        data.push.apply(data, currentData);

        for (var d = 0; d < data.length; d++) {
          var id = data[d].id;

          if ($.inArray(id, val) === -1) {
            val.push(id);
          }
        }

        self.$element.val(val);
        self.$element.trigger('input').trigger('change');
      });
    } else {
      var val = data.id;

      this.$element.val(val);
      this.$element.trigger('input').trigger('change');
    }
  };

  SelectAdapter.prototype.unselect = function (data) {
    var self = this;

    if (!this.$element.prop('multiple')) {
      return;
    }

    data.selected = false;

    if ($(data.element).is('option')) {
      data.element.selected = false;

      this.$element.trigger('input').trigger('change');

      return;
    }

    this.current(function (currentData) {
      var val = [];

      for (var d = 0; d < currentData.length; d++) {
        var id = currentData[d].id;

        if (id !== data.id && $.inArray(id, val) === -1) {
          val.push(id);
        }
      }

      self.$element.val(val);

      self.$element.trigger('input').trigger('change');
    });
  };

  SelectAdapter.prototype.bind = function (container, $container) {
    var self = this;

    this.container = container;

    container.on('select', function (params) {
      self.select(params.data);
    });

    container.on('unselect', function (params) {
      self.unselect(params.data);
    });
  };

  SelectAdapter.prototype.destroy = function () {
    // Remove anything added to child elements
    this.$element.find('*').each(function () {
      // Remove any custom data set by Select2
      Utils.RemoveData(this);
    });
  };

  SelectAdapter.prototype.query = function (params, callback) {
    var data = [];
    var self = this;

    var $options = this.$element.children();

    $options.each(function () {
      var $option = $(this);

      if (!$option.is('option') && !$option.is('optgroup')) {
        return;
      }

      var option = self.item($option);

      var matches = self.matches(params, option);

      if (matches !== null) {
        data.push(matches);
      }
    });

    callback({
      results: data
    });
  };

  SelectAdapter.prototype.addOptions = function ($options) {
    Utils.appendMany(this.$element, $options);
  };

  SelectAdapter.prototype.option = function (data) {
    var option;

    if (data.children) {
      option = document.createElement('optgroup');
      option.label = data.text;
    } else {
      option = document.createElement('option');

      if (option.textContent !== undefined) {
        option.textContent = data.text;
      } else {
        option.innerText = data.text;
      }
    }

    if (data.id !== undefined) {
      option.value = data.id;
    }

    if (data.disabled) {
      option.disabled = true;
    }

    if (data.selected) {
      option.selected = true;
    }

    if (data.title) {
      option.title = data.title;
    }

    var $option = $(option);

    var normalizedData = this._normalizeItem(data);
    normalizedData.element = option;

    // Override the option's data with the combined data
    Utils.StoreData(option, 'data', normalizedData);

    return $option;
  };

  SelectAdapter.prototype.item = function ($option) {
    var data = {};

    data = Utils.GetData($option[0], 'data');

    if (data != null) {
      return data;
    }

    if ($option.is('option')) {
      data = {
        id: $option.val(),
        text: $option.text(),
        disabled: $option.prop('disabled'),
        selected: $option.prop('selected'),
        title: $option.prop('title')
      };
    } else if ($option.is('optgroup')) {
      data = {
        text: $option.prop('label'),
        children: [],
        title: $option.prop('title')
      };

      var $children = $option.children('option');
      var children = [];

      for (var c = 0; c < $children.length; c++) {
        var $child = $($children[c]);

        var child = this.item($child);

        children.push(child);
      }

      data.children = children;
    }

    data = this._normalizeItem(data);
    data.element = $option[0];

    Utils.StoreData($option[0], 'data', data);

    return data;
  };

  SelectAdapter.prototype._normalizeItem = function (item) {
    if (item !== Object(item)) {
      item = {
        id: item,
        text: item
      };
    }

    item = $.extend({}, {
      text: ''
    }, item);

    var defaults = {
      selected: false,
      disabled: false
    };

    if (item.id != null) {
      item.id = item.id.toString();
    }

    if (item.text != null) {
      item.text = item.text.toString();
    }

    if (item._resultId == null && item.id && this.container != null) {
      item._resultId = this.generateResultId(this.container, item);
    }

    return $.extend({}, defaults, item);
  };

  SelectAdapter.prototype.matches = function (params, data) {
    var matcher = this.options.get('matcher');

    return matcher(params, data);
  };

  return SelectAdapter;
});

S2.define('select2/data/array',[
  './select',
  '../utils',
  'jquery'
], function (SelectAdapter, Utils, $) {
  function ArrayAdapter ($element, options) {
    this._dataToConvert = options.get('data') || [];

    ArrayAdapter.__super__.constructor.call(this, $element, options);
  }

  Utils.Extend(ArrayAdapter, SelectAdapter);

  ArrayAdapter.prototype.bind = function (container, $container) {
    ArrayAdapter.__super__.bind.call(this, container, $container);

    this.addOptions(this.convertToOptions(this._dataToConvert));
  };

  ArrayAdapter.prototype.select = function (data) {
    var $option = this.$element.find('option').filter(function (i, elm) {
      return elm.value == data.id.toString();
    });

    if ($option.length === 0) {
      $option = this.option(data);

      this.addOptions($option);
    }

    ArrayAdapter.__super__.select.call(this, data);
  };

  ArrayAdapter.prototype.convertToOptions = function (data) {
    var self = this;

    var $existing = this.$element.find('option');
    var existingIds = $existing.map(function () {
      return self.item($(this)).id;
    }).get();

    var $options = [];

    // Filter out all items except for the one passed in the argument
    function onlyItem (item) {
      return function () {
        return $(this).val() == item.id;
      };
    }

    for (var d = 0; d < data.length; d++) {
      var item = this._normalizeItem(data[d]);

      // Skip items which were pre-loaded, only merge the data
      if ($.inArray(item.id, existingIds) >= 0) {
        var $existingOption = $existing.filter(onlyItem(item));

        var existingData = this.item($existingOption);
        var newData = $.extend(true, {}, item, existingData);

        var $newOption = this.option(newData);

        $existingOption.replaceWith($newOption);

        continue;
      }

      var $option = this.option(item);

      if (item.children) {
        var $children = this.convertToOptions(item.children);

        Utils.appendMany($option, $children);
      }

      $options.push($option);
    }

    return $options;
  };

  return ArrayAdapter;
});

S2.define('select2/data/ajax',[
  './array',
  '../utils',
  'jquery'
], function (ArrayAdapter, Utils, $) {
  function AjaxAdapter ($element, options) {
    this.ajaxOptions = this._applyDefaults(options.get('ajax'));

    if (this.ajaxOptions.processResults != null) {
      this.processResults = this.ajaxOptions.processResults;
    }

    AjaxAdapter.__super__.constructor.call(this, $element, options);
  }

  Utils.Extend(AjaxAdapter, ArrayAdapter);

  AjaxAdapter.prototype._applyDefaults = function (options) {
    var defaults = {
      data: function (params) {
        return $.extend({}, params, {
          q: params.term
        });
      },
      transport: function (params, success, failure) {
        var $request = $.ajax(params);

        $request.then(success);
        $request.fail(failure);

        return $request;
      }
    };

    return $.extend({}, defaults, options, true);
  };

  AjaxAdapter.prototype.processResults = function (results) {
    return results;
  };

  AjaxAdapter.prototype.query = function (params, callback) {
    var matches = [];
    var self = this;

    if (this._request != null) {
      // JSONP requests cannot always be aborted
      if ($.isFunction(this._request.abort)) {
        this._request.abort();
      }

      this._request = null;
    }

    var options = $.extend({
      type: 'GET'
    }, this.ajaxOptions);

    if (typeof options.url === 'function') {
      options.url = options.url.call(this.$element, params);
    }

    if (typeof options.data === 'function') {
      options.data = options.data.call(this.$element, params);
    }

    function request () {
      var $request = options.transport(options, function (data) {
        var results = self.processResults(data, params);

        if (self.options.get('debug') && window.console && console.error) {
          // Check to make sure that the response included a `results` key.
          if (!results || !results.results || !$.isArray(results.results)) {
            console.error(
              'Select2: The AJAX results did not return an array in the ' +
              '`results` key of the response.'
            );
          }
        }

        callback(results);
      }, function () {
        // Attempt to detect if a request was aborted
        // Only works if the transport exposes a status property
        if ('status' in $request &&
            ($request.status === 0 || $request.status === '0')) {
          return;
        }

        self.trigger('results:message', {
          message: 'errorLoading'
        });
      });

      self._request = $request;
    }

    if (this.ajaxOptions.delay && params.term != null) {
      if (this._queryTimeout) {
        window.clearTimeout(this._queryTimeout);
      }

      this._queryTimeout = window.setTimeout(request, this.ajaxOptions.delay);
    } else {
      request();
    }
  };

  return AjaxAdapter;
});

S2.define('select2/data/tags',[
  'jquery'
], function ($) {
  function Tags (decorated, $element, options) {
    var tags = options.get('tags');

    var createTag = options.get('createTag');

    if (createTag !== undefined) {
      this.createTag = createTag;
    }

    var insertTag = options.get('insertTag');

    if (insertTag !== undefined) {
        this.insertTag = insertTag;
    }

    decorated.call(this, $element, options);

    if ($.isArray(tags)) {
      for (var t = 0; t < tags.length; t++) {
        var tag = tags[t];
        var item = this._normalizeItem(tag);

        var $option = this.option(item);

        this.$element.append($option);
      }
    }
  }

  Tags.prototype.query = function (decorated, params, callback) {
    var self = this;

    this._removeOldTags();

    if (params.term == null || params.page != null) {
      decorated.call(this, params, callback);
      return;
    }

    function wrapper (obj, child) {
      var data = obj.results;

      for (var i = 0; i < data.length; i++) {
        var option = data[i];

        var checkChildren = (
          option.children != null &&
          !wrapper({
            results: option.children
          }, true)
        );

        var optionText = (option.text || '').toUpperCase();
        var paramsTerm = (params.term || '').toUpperCase();

        var checkText = optionText === paramsTerm;

        if (checkText || checkChildren) {
          if (child) {
            return false;
          }

          obj.data = data;
          callback(obj);

          return;
        }
      }

      if (child) {
        return true;
      }

      var tag = self.createTag(params);

      if (tag != null) {
        var $option = self.option(tag);
        $option.attr('data-select2-tag', true);

        self.addOptions([$option]);

        self.insertTag(data, tag);
      }

      obj.results = data;

      callback(obj);
    }

    decorated.call(this, params, wrapper);
  };

  Tags.prototype.createTag = function (decorated, params) {
    var term = $.trim(params.term);

    if (term === '') {
      return null;
    }

    return {
      id: term,
      text: term
    };
  };

  Tags.prototype.insertTag = function (_, data, tag) {
    data.unshift(tag);
  };

  Tags.prototype._removeOldTags = function (_) {
    var $options = this.$element.find('option[data-select2-tag]');

    $options.each(function () {
      if (this.selected) {
        return;
      }

      $(this).remove();
    });
  };

  return Tags;
});

S2.define('select2/data/tokenizer',[
  'jquery'
], function ($) {
  function Tokenizer (decorated, $element, options) {
    var tokenizer = options.get('tokenizer');

    if (tokenizer !== undefined) {
      this.tokenizer = tokenizer;
    }

    decorated.call(this, $element, options);
  }

  Tokenizer.prototype.bind = function (decorated, container, $container) {
    decorated.call(this, container, $container);

    this.$search =  container.dropdown.$search || container.selection.$search ||
      $container.find('.select2-search__field');
  };

  Tokenizer.prototype.query = function (decorated, params, callback) {
    var self = this;

    function createAndSelect (data) {
      // Normalize the data object so we can use it for checks
      var item = self._normalizeItem(data);

      // Check if the data object already exists as a tag
      // Select it if it doesn't
      var $existingOptions = self.$element.find('option').filter(function () {
        return $(this).val() === item.id;
      });

      // If an existing option wasn't found for it, create the option
      if (!$existingOptions.length) {
        var $option = self.option(item);
        $option.attr('data-select2-tag', true);

        self._removeOldTags();
        self.addOptions([$option]);
      }

      // Select the item, now that we know there is an option for it
      select(item);
    }

    function select (data) {
      self.trigger('select', {
        data: data
      });
    }

    params.term = params.term || '';

    var tokenData = this.tokenizer(params, this.options, createAndSelect);

    if (tokenData.term !== params.term) {
      // Replace the search term if we have the search box
      if (this.$search.length) {
        this.$search.val(tokenData.term);
        this.$search.trigger('focus');
      }

      params.term = tokenData.term;
    }

    decorated.call(this, params, callback);
  };

  Tokenizer.prototype.tokenizer = function (_, params, options, callback) {
    var separators = options.get('tokenSeparators') || [];
    var term = params.term;
    var i = 0;

    var createTag = this.createTag || function (params) {
      return {
        id: params.term,
        text: params.term
      };
    };

    while (i < term.length) {
      var termChar = term[i];

      if ($.inArray(termChar, separators) === -1) {
        i++;

        continue;
      }

      var part = term.substr(0, i);
      var partParams = $.extend({}, params, {
        term: part
      });

      var data = createTag(partParams);

      if (data == null) {
        i++;
        continue;
      }

      callback(data);

      // Reset the term to not include the tokenized portion
      term = term.substr(i + 1) || '';
      i = 0;
    }

    return {
      term: term
    };
  };

  return Tokenizer;
});

S2.define('select2/data/minimumInputLength',[

], function () {
  function MinimumInputLength (decorated, $e, options) {
    this.minimumInputLength = options.get('minimumInputLength');

    decorated.call(this, $e, options);
  }

  MinimumInputLength.prototype.query = function (decorated, params, callback) {
    params.term = params.term || '';

    if (params.term.length < this.minimumInputLength) {
      this.trigger('results:message', {
        message: 'inputTooShort',
        args: {
          minimum: this.minimumInputLength,
          input: params.term,
          params: params
        }
      });

      return;
    }

    decorated.call(this, params, callback);
  };

  return MinimumInputLength;
});

S2.define('select2/data/maximumInputLength',[

], function () {
  function MaximumInputLength (decorated, $e, options) {
    this.maximumInputLength = options.get('maximumInputLength');

    decorated.call(this, $e, options);
  }

  MaximumInputLength.prototype.query = function (decorated, params, callback) {
    params.term = params.term || '';

    if (this.maximumInputLength > 0 &&
        params.term.length > this.maximumInputLength) {
      this.trigger('results:message', {
        message: 'inputTooLong',
        args: {
          maximum: this.maximumInputLength,
          input: params.term,
          params: params
        }
      });

      return;
    }

    decorated.call(this, params, callback);
  };

  return MaximumInputLength;
});

S2.define('select2/data/maximumSelectionLength',[

], function (){
  function MaximumSelectionLength (decorated, $e, options) {
    this.maximumSelectionLength = options.get('maximumSelectionLength');

    decorated.call(this, $e, options);
  }

  MaximumSelectionLength.prototype.bind =
    function (decorated, container, $container) {
      var self = this;

      decorated.call(this, container, $container);

      container.on('select', function () {
        self._checkIfMaximumSelected();
      });
  };

  MaximumSelectionLength.prototype.query =
    function (decorated, params, callback) {
      var self = this;

      this._checkIfMaximumSelected(function () {
        decorated.call(self, params, callback);
      });
  };

  MaximumSelectionLength.prototype._checkIfMaximumSelected =
    function (_, successCallback) {
      var self = this;

      this.current(function (currentData) {
        var count = currentData != null ? currentData.length : 0;
        if (self.maximumSelectionLength > 0 &&
          count >= self.maximumSelectionLength) {
          self.trigger('results:message', {
            message: 'maximumSelected',
            args: {
              maximum: self.maximumSelectionLength
            }
          });
          return;
        }

        if (successCallback) {
          successCallback();
        }
      });
  };

  return MaximumSelectionLength;
});

S2.define('select2/dropdown',[
  'jquery',
  './utils'
], function ($, Utils) {
  function Dropdown ($element, options) {
    this.$element = $element;
    this.options = options;

    Dropdown.__super__.constructor.call(this);
  }

  Utils.Extend(Dropdown, Utils.Observable);

  Dropdown.prototype.render = function () {
    var $dropdown = $(
      '<span class="select2-dropdown">' +
        '<span class="select2-results"></span>' +
      '</span>'
    );

    $dropdown.attr('dir', this.options.get('dir'));

    this.$dropdown = $dropdown;

    return $dropdown;
  };

  Dropdown.prototype.bind = function () {
    // Should be implemented in subclasses
  };

  Dropdown.prototype.position = function ($dropdown, $container) {
    // Should be implemented in subclasses
  };

  Dropdown.prototype.destroy = function () {
    // Remove the dropdown from the DOM
    this.$dropdown.remove();
  };

  return Dropdown;
});

S2.define('select2/dropdown/search',[
  'jquery',
  '../utils'
], function ($, Utils) {
  function Search () { }

  Search.prototype.render = function (decorated) {
    var $rendered = decorated.call(this);

    var $search = $(
      '<span class="select2-search select2-search--dropdown">' +
        '<input class="select2-search__field" type="search" tabindex="-1"' +
        ' autocomplete="off" autocorrect="off" autocapitalize="none"' +
        ' spellcheck="false" role="searchbox" aria-autocomplete="list" />' +
      '</span>'
    );

    this.$searchContainer = $search;
    this.$search = $search.find('input');

    $rendered.prepend($search);

    return $rendered;
  };

  Search.prototype.bind = function (decorated, container, $container) {
    var self = this;

    var resultsId = container.id + '-results';

    decorated.call(this, container, $container);

    this.$search.on('keydown', function (evt) {
      self.trigger('keypress', evt);

      self._keyUpPrevented = evt.isDefaultPrevented();
    });

    // Workaround for browsers which do not support the `input` event
    // This will prevent double-triggering of events for browsers which support
    // both the `keyup` and `input` events.
    this.$search.on('input', function (evt) {
      // Unbind the duplicated `keyup` event
      $(this).off('keyup');
    });

    this.$search.on('keyup input', function (evt) {
      self.handleSearch(evt);
    });

    container.on('open', function () {
      self.$search.attr('tabindex', 0);
      self.$search.attr('aria-controls', resultsId);
      // possible fix for AP-3440
      // self.$search.trigger('focus');
      window.setTimeout(function () {
        self.$search.trigger('focus');
      }, 1);
    });

    container.on('close', function () {
      self.$search.attr('tabindex', -1);
      self.$search.removeAttr('aria-controls');
      self.$search.removeAttr('aria-activedescendant');

      self.$search.val('');
      self.$search.trigger('blur');
    });

    container.on('focus', function () {
      if (!container.isOpen()) {
        self.$search.trigger('focus');
      }
    });

    container.on('results:all', function (params) {
      if (params.query.term == null || params.query.term === '') {
        var showSearch = self.showSearch(params);

        if (showSearch) {
          self.$searchContainer.removeClass('select2-search--hide');
        } else {
          self.$searchContainer.addClass('select2-search--hide');
        }
      }
    });

    container.on('results:focus', function (params) {
      if (params.data._resultId) {
        self.$search.attr('aria-activedescendant', params.data._resultId);
      } else {
        self.$search.removeAttr('aria-activedescendant');
      }
    });
  };

  Search.prototype.handleSearch = function (evt) {
    if (!this._keyUpPrevented) {
      var input = this.$search.val();

      this.trigger('query', {
        term: input
      });
    }

    this._keyUpPrevented = false;
  };

  Search.prototype.showSearch = function (_, params) {
    return true;
  };

  return Search;
});

S2.define('select2/dropdown/hidePlaceholder',[

], function () {
  function HidePlaceholder (decorated, $element, options, dataAdapter) {
    this.placeholder = this.normalizePlaceholder(options.get('placeholder'));

    decorated.call(this, $element, options, dataAdapter);
  }

  HidePlaceholder.prototype.append = function (decorated, data) {
    data.results = this.removePlaceholder(data.results);

    decorated.call(this, data);
  };

  HidePlaceholder.prototype.normalizePlaceholder = function (_, placeholder) {
    if (typeof placeholder === 'string') {
      placeholder = {
        id: '',
        text: placeholder
      };
    }

    return placeholder;
  };

  HidePlaceholder.prototype.removePlaceholder = function (_, data) {
    var modifiedData = data.slice(0);

    for (var d = data.length - 1; d >= 0; d--) {
      var item = data[d];

      if (this.placeholder.id === item.id) {
        modifiedData.splice(d, 1);
      }
    }

    return modifiedData;
  };

  return HidePlaceholder;
});

S2.define('select2/dropdown/infiniteScroll',[
  'jquery'
], function ($) {
  function InfiniteScroll (decorated, $element, options, dataAdapter) {
    this.lastParams = {};

    decorated.call(this, $element, options, dataAdapter);

    this.$loadingMore = this.createLoadingMore();
    this.loading = false;
  }

  InfiniteScroll.prototype.append = function (decorated, data) {
    this.$loadingMore.remove();
    this.loading = false;

    decorated.call(this, data);

    if (this.showLoadingMore(data)) {
      this.$results.append(this.$loadingMore);
      this.loadMoreIfNeeded();
    }
  };

  InfiniteScroll.prototype.bind = function (decorated, container, $container) {
    var self = this;

    decorated.call(this, container, $container);

    container.on('query', function (params) {
      self.lastParams = params;
      self.loading = true;
    });

    container.on('query:append', function (params) {
      self.lastParams = params;
      self.loading = true;
    });

    this.$results.on('scroll', this.loadMoreIfNeeded.bind(this));
  };

  InfiniteScroll.prototype.loadMoreIfNeeded = function () {
    var isLoadMoreVisible = $.contains(
      document.documentElement,
      this.$loadingMore[0]
    );

    if (this.loading || !isLoadMoreVisible) {
      return;
    }

    var currentOffset = this.$results.offset().top +
      this.$results.outerHeight(false);
    var loadingMoreOffset = this.$loadingMore.offset().top +
      this.$loadingMore.outerHeight(false);

    if (currentOffset + 50 >= loadingMoreOffset) {
      this.loadMore();
    }
  };

  InfiniteScroll.prototype.loadMore = function () {
    this.loading = true;

    var params = $.extend({}, {page: 1}, this.lastParams);

    params.page++;

    this.trigger('query:append', params);
  };

  InfiniteScroll.prototype.showLoadingMore = function (_, data) {
    return data.pagination && data.pagination.more;
  };

  InfiniteScroll.prototype.createLoadingMore = function () {
    var $option = $(
      '<li ' +
      'class="select2-results__option select2-results__option--load-more"' +
      'role="option" aria-disabled="true"></li>'
    );

    var message = this.options.get('translations').get('loadingMore');

    $option.html(message(this.lastParams));

    return $option;
  };

  return InfiniteScroll;
});

S2.define('select2/dropdown/attachBody',[
  'jquery',
  '../utils'
], function ($, Utils) {
  function AttachBody (decorated, $element, options) {
    this.$dropdownParent = $(options.get('dropdownParent') || document.body);

    decorated.call(this, $element, options);
  }

  AttachBody.prototype.bind = function (decorated, container, $container) {
    var self = this;

    decorated.call(this, container, $container);

    container.on('open', function () {
      self._showDropdown();
      self._attachPositioningHandler(container);

      // Must bind after the results handlers to ensure correct sizing
      self._bindContainerResultHandlers(container);
    });

    container.on('close', function () {
      self._hideDropdown();
      self._detachPositioningHandler(container);
    });

    this.$dropdownContainer.on('mousedown', function (evt) {
      evt.stopPropagation();
    });
  };

  AttachBody.prototype.destroy = function (decorated) {
    decorated.call(this);

    this.$dropdownContainer.remove();
  };

  AttachBody.prototype.position = function (decorated, $dropdown, $container) {
    // Clone all of the container classes
    $dropdown.attr('class', $container.attr('class'));

    $dropdown.removeClass('select2');
    $dropdown.addClass('select2-container--open');

    $dropdown.css({
      position: 'absolute',
      top: -999999
    });

    this.$container = $container;
  };

  AttachBody.prototype.render = function (decorated) {
    var $container = $('<span></span>');

    var $dropdown = decorated.call(this);
    $container.append($dropdown);

    this.$dropdownContainer = $container;

    return $container;
  };

  AttachBody.prototype._hideDropdown = function (decorated) {
    this.$dropdownContainer.detach();
  };

  AttachBody.prototype._bindContainerResultHandlers =
      function (decorated, container) {

    // These should only be bound once
    if (this._containerResultsHandlersBound) {
      return;
    }

    var self = this;

    container.on('results:all', function () {
      self._positionDropdown();
      self._resizeDropdown();
    });

    container.on('results:append', function () {
      self._positionDropdown();
      self._resizeDropdown();
    });

    container.on('results:message', function () {
      self._positionDropdown();
      self._resizeDropdown();
    });

    container.on('select', function () {
      self._positionDropdown();
      self._resizeDropdown();
    });

    container.on('unselect', function () {
      self._positionDropdown();
      self._resizeDropdown();
    });

    this._containerResultsHandlersBound = true;
  };

  AttachBody.prototype._attachPositioningHandler =
      function (decorated, container) {
    var self = this;

    var scrollEvent = 'scroll.select2.' + container.id;
    var resizeEvent = 'resize.select2.' + container.id;
    var orientationEvent = 'orientationchange.select2.' + container.id;

    var $watchers = this.$container.parents().filter(Utils.hasScroll);
    $watchers.each(function () {
      Utils.StoreData(this, 'select2-scroll-position', {
        x: $(this).scrollLeft(),
        y: $(this).scrollTop()
      });
    });

    $watchers.on(scrollEvent, function (ev) {
      var position = Utils.GetData(this, 'select2-scroll-position');
      $(this).scrollTop(position.y);
    });

    $(window).on(scrollEvent + ' ' + resizeEvent + ' ' + orientationEvent,
      function (e) {
      self._positionDropdown();
      self._resizeDropdown();
    });
  };

  AttachBody.prototype._detachPositioningHandler =
      function (decorated, container) {
    var scrollEvent = 'scroll.select2.' + container.id;
    var resizeEvent = 'resize.select2.' + container.id;
    var orientationEvent = 'orientationchange.select2.' + container.id;

    var $watchers = this.$container.parents().filter(Utils.hasScroll);
    $watchers.off(scrollEvent);

    $(window).off(scrollEvent + ' ' + resizeEvent + ' ' + orientationEvent);
  };

  AttachBody.prototype._positionDropdown = function () {
    var $window = $(window);

    var isCurrentlyAbove = this.$dropdown.hasClass('select2-dropdown--above');
    var isCurrentlyBelow = this.$dropdown.hasClass('select2-dropdown--below');

    var newDirection = null;

    var offset = this.$container.offset();

    offset.bottom = offset.top + this.$container.outerHeight(false);

    var container = {
      height: this.$container.outerHeight(false)
    };

    container.top = offset.top;
    container.bottom = offset.top + container.height;

    var dropdown = {
      height: this.$dropdown.outerHeight(false)
    };

    var viewport = {
      top: $window.scrollTop(),
      bottom: $window.scrollTop() + $window.height()
    };

    var enoughRoomAbove = viewport.top < (offset.top - dropdown.height);
    var enoughRoomBelow = viewport.bottom > (offset.bottom + dropdown.height);

    var css = {
      left: offset.left,
      top: container.bottom
    };

    // Determine what the parent element is to use for calculating the offset
    var $offsetParent = this.$dropdownParent;

    // For statically positioned elements, we need to get the element
    // that is determining the offset
    if ($offsetParent.css('position') === 'static') {
      $offsetParent = $offsetParent.offsetParent();
    }

    var parentOffset = {
      top: 0,
      left: 0
    };

    if (
      $.contains(document.body, $offsetParent[0]) ||
      $offsetParent[0].isConnected
      ) {
      parentOffset = $offsetParent.offset();
    }

    css.top -= parentOffset.top;
    css.left -= parentOffset.left;

    if (!isCurrentlyAbove && !isCurrentlyBelow) {
      newDirection = 'below';
    }

    if (!enoughRoomBelow && enoughRoomAbove && !isCurrentlyAbove) {
      newDirection = 'above';
    } else if (!enoughRoomAbove && enoughRoomBelow && isCurrentlyAbove) {
      newDirection = 'below';
    }

    if (newDirection == 'above' ||
      (isCurrentlyAbove && newDirection !== 'below')) {
      css.top = container.top - parentOffset.top - dropdown.height;
    }

    if (newDirection != null) {
      this.$dropdown
        .removeClass('select2-dropdown--below select2-dropdown--above')
        .addClass('select2-dropdown--' + newDirection);
      this.$container
        .removeClass('select2-container--below select2-container--above')
        .addClass('select2-container--' + newDirection);
    }

    this.$dropdownContainer.css(css);
  };

  AttachBody.prototype._resizeDropdown = function () {
    var css = {
      width: this.$container.outerWidth(false) + 'px'
    };

    if (this.options.get('dropdownAutoWidth')) {
      css.minWidth = css.width;
      css.position = 'relative';
      css.width = 'auto';
    }

    this.$dropdown.css(css);
  };

  AttachBody.prototype._showDropdown = function (decorated) {
    this.$dropdownContainer.appendTo(this.$dropdownParent);

    this._positionDropdown();
    this._resizeDropdown();
  };

  return AttachBody;
});

S2.define('select2/dropdown/minimumResultsForSearch',[

], function () {
  function countResults (data) {
    var count = 0;

    for (var d = 0; d < data.length; d++) {
      var item = data[d];

      if (item.children) {
        count += countResults(item.children);
      } else {
        count++;
      }
    }

    return count;
  }

  function MinimumResultsForSearch (decorated, $element, options, dataAdapter) {
    this.minimumResultsForSearch = options.get('minimumResultsForSearch');

    if (this.minimumResultsForSearch < 0) {
      this.minimumResultsForSearch = Infinity;
    }

    decorated.call(this, $element, options, dataAdapter);
  }

  MinimumResultsForSearch.prototype.showSearch = function (decorated, params) {
    if (countResults(params.data.results) < this.minimumResultsForSearch) {
      return false;
    }

    return decorated.call(this, params);
  };

  return MinimumResultsForSearch;
});

S2.define('select2/dropdown/selectOnClose',[
  '../utils'
], function (Utils) {
  function SelectOnClose () { }

  SelectOnClose.prototype.bind = function (decorated, container, $container) {
    var self = this;

    decorated.call(this, container, $container);

    container.on('close', function (params) {
      self._handleSelectOnClose(params);
    });
  };

  SelectOnClose.prototype._handleSelectOnClose = function (_, params) {
    if (params && params.originalSelect2Event != null) {
      var event = params.originalSelect2Event;

      // Don't select an item if the close event was triggered from a select or
      // unselect event
      if (event._type === 'select' || event._type === 'unselect') {
        return;
      }
    }

    var $highlightedResults = this.getHighlightedResults();

    // Only select highlighted results
    if ($highlightedResults.length < 1) {
      return;
    }

    var data = Utils.GetData($highlightedResults[0], 'data');

    // Don't re-select already selected resulte
    if (
      (data.element != null && data.element.selected) ||
      (data.element == null && data.selected)
    ) {
      return;
    }

    this.trigger('select', {
        data: data
    });
  };

  return SelectOnClose;
});

S2.define('select2/dropdown/closeOnSelect',[

], function () {
  function CloseOnSelect () { }

  CloseOnSelect.prototype.bind = function (decorated, container, $container) {
    var self = this;

    decorated.call(this, container, $container);

    container.on('select', function (evt) {
      self._selectTriggered(evt);
    });

    container.on('unselect', function (evt) {
      self._selectTriggered(evt);
    });
  };

  CloseOnSelect.prototype._selectTriggered = function (_, evt) {
    var originalEvent = evt.originalEvent;

    // Don't close if the control key is being held
    if (originalEvent && (originalEvent.ctrlKey || originalEvent.metaKey)) {
      return;
    }

    this.trigger('close', {
      originalEvent: originalEvent,
      originalSelect2Event: evt
    });
  };

  return CloseOnSelect;
});

S2.define('select2/i18n/en',[],function () {
  // English
  return {
    errorLoading: function () {
      return 'The results could not be loaded.';
    },
    inputTooLong: function (args) {
      var overChars = args.input.length - args.maximum;

      var message = 'Please delete ' + overChars + ' character';

      if (overChars != 1) {
        message += 's';
      }

      return message;
    },
    inputTooShort: function (args) {
      var remainingChars = args.minimum - args.input.length;

      var message = 'Please enter ' + remainingChars + ' or more characters';

      return message;
    },
    loadingMore: function () {
      return 'Loading more results…';
    },
    maximumSelected: function (args) {
      var message = 'You can only select ' + args.maximum + ' item';

      if (args.maximum != 1) {
        message += 's';
      }

      return message;
    },
    noResults: function () {
      return 'No results found';
    },
    searching: function () {
      return 'Searching…';
    },
    removeAllItems: function () {
      return 'Remove all items';
    }
  };
});

S2.define('select2/defaults',[
  'jquery',
  'require',

  './results',

  './selection/single',
  './selection/multiple',
  './selection/placeholder',
  './selection/allowClear',
  './selection/search',
  './selection/eventRelay',

  './utils',
  './translation',
  './diacritics',

  './data/select',
  './data/array',
  './data/ajax',
  './data/tags',
  './data/tokenizer',
  './data/minimumInputLength',
  './data/maximumInputLength',
  './data/maximumSelectionLength',

  './dropdown',
  './dropdown/search',
  './dropdown/hidePlaceholder',
  './dropdown/infiniteScroll',
  './dropdown/attachBody',
  './dropdown/minimumResultsForSearch',
  './dropdown/selectOnClose',
  './dropdown/closeOnSelect',

  './i18n/en'
], function ($, require,

             ResultsList,

             SingleSelection, MultipleSelection, Placeholder, AllowClear,
             SelectionSearch, EventRelay,

             Utils, Translation, DIACRITICS,

             SelectData, ArrayData, AjaxData, Tags, Tokenizer,
             MinimumInputLength, MaximumInputLength, MaximumSelectionLength,

             Dropdown, DropdownSearch, HidePlaceholder, InfiniteScroll,
             AttachBody, MinimumResultsForSearch, SelectOnClose, CloseOnSelect,

             EnglishTranslation) {
  function Defaults () {
    this.reset();
  }

  Defaults.prototype.apply = function (options) {
    options = $.extend(true, {}, this.defaults, options);

    if (options.dataAdapter == null) {
      if (options.ajax != null) {
        options.dataAdapter = AjaxData;
      } else if (options.data != null) {
        options.dataAdapter = ArrayData;
      } else {
        options.dataAdapter = SelectData;
      }

      if (options.minimumInputLength > 0) {
        options.dataAdapter = Utils.Decorate(
          options.dataAdapter,
          MinimumInputLength
        );
      }

      if (options.maximumInputLength > 0) {
        options.dataAdapter = Utils.Decorate(
          options.dataAdapter,
          MaximumInputLength
        );
      }

      if (options.maximumSelectionLength > 0) {
        options.dataAdapter = Utils.Decorate(
          options.dataAdapter,
          MaximumSelectionLength
        );
      }

      if (options.tags) {
        options.dataAdapter = Utils.Decorate(options.dataAdapter, Tags);
      }

      if (options.tokenSeparators != null || options.tokenizer != null) {
        options.dataAdapter = Utils.Decorate(
          options.dataAdapter,
          Tokenizer
        );
      }

      if (options.query != null) {
        var Query = require(options.amdBase + 'compat/query');

        options.dataAdapter = Utils.Decorate(
          options.dataAdapter,
          Query
        );
      }

      if (options.initSelection != null) {
        var InitSelection = require(options.amdBase + 'compat/initSelection');

        options.dataAdapter = Utils.Decorate(
          options.dataAdapter,
          InitSelection
        );
      }
    }

    if (options.resultsAdapter == null) {
      options.resultsAdapter = ResultsList;

      if (options.ajax != null) {
        options.resultsAdapter = Utils.Decorate(
          options.resultsAdapter,
          InfiniteScroll
        );
      }

      if (options.placeholder != null) {
        options.resultsAdapter = Utils.Decorate(
          options.resultsAdapter,
          HidePlaceholder
        );
      }

      if (options.selectOnClose) {
        options.resultsAdapter = Utils.Decorate(
          options.resultsAdapter,
          SelectOnClose
        );
      }
    }

    if (options.dropdownAdapter == null) {
      if (options.multiple) {
        options.dropdownAdapter = Dropdown;
      } else {
        var SearchableDropdown = Utils.Decorate(Dropdown, DropdownSearch);

        options.dropdownAdapter = SearchableDropdown;
      }

      if (options.minimumResultsForSearch !== 0) {
        options.dropdownAdapter = Utils.Decorate(
          options.dropdownAdapter,
          MinimumResultsForSearch
        );
      }

      if (options.closeOnSelect) {
        options.dropdownAdapter = Utils.Decorate(
          options.dropdownAdapter,
          CloseOnSelect
        );
      }

      if (
        options.dropdownCssClass != null ||
        options.dropdownCss != null ||
        options.adaptDropdownCssClass != null
      ) {
        var DropdownCSS = require(options.amdBase + 'compat/dropdownCss');

        options.dropdownAdapter = Utils.Decorate(
          options.dropdownAdapter,
          DropdownCSS
        );
      }

      options.dropdownAdapter = Utils.Decorate(
        options.dropdownAdapter,
        AttachBody
      );
    }

    if (options.selectionAdapter == null) {
      if (options.multiple) {
        options.selectionAdapter = MultipleSelection;
      } else {
        options.selectionAdapter = SingleSelection;
      }

      // Add the placeholder mixin if a placeholder was specified
      if (options.placeholder != null) {
        options.selectionAdapter = Utils.Decorate(
          options.selectionAdapter,
          Placeholder
        );
      }

      if (options.allowClear) {
        options.selectionAdapter = Utils.Decorate(
          options.selectionAdapter,
          AllowClear
        );
      }

      if (options.multiple) {
        options.selectionAdapter = Utils.Decorate(
          options.selectionAdapter,
          SelectionSearch
        );
      }

      if (
        options.containerCssClass != null ||
        options.containerCss != null ||
        options.adaptContainerCssClass != null
      ) {
        var ContainerCSS = require(options.amdBase + 'compat/containerCss');

        options.selectionAdapter = Utils.Decorate(
          options.selectionAdapter,
          ContainerCSS
        );
      }

      options.selectionAdapter = Utils.Decorate(
        options.selectionAdapter,
        EventRelay
      );
    }

    // If the defaults were not previously applied from an element, it is
    // possible for the language option to have not been resolved
    options.language = this._resolveLanguage(options.language);

    // Always fall back to English since it will always be complete
    options.language.push('en');

    var uniqueLanguages = [];

    for (var l = 0; l < options.language.length; l++) {
      var language = options.language[l];

      if (uniqueLanguages.indexOf(language) === -1) {
        uniqueLanguages.push(language);
      }
    }

    options.language = uniqueLanguages;

    options.translations = this._processTranslations(
      options.language,
      options.debug
    );

    return options;
  };

  Defaults.prototype.reset = function () {
    function stripDiacritics (text) {
      // Used 'uni range + named function' from http://jsperf.com/diacritics/18
      function match(a) {
        return DIACRITICS[a] || a;
      }

      return text.replace(/[^\u0000-\u007E]/g, match);
    }

    function matcher (params, data) {
      // Always return the object if there is nothing to compare
      if ($.trim(params.term) === '') {
        return data;
      }

      // Do a recursive check for options with children
      if (data.children && data.children.length > 0) {
        // Clone the data object if there are children
        // This is required as we modify the object to remove any non-matches
        var match = $.extend(true, {}, data);

        // Check each child of the option
        for (var c = data.children.length - 1; c >= 0; c--) {
          var child = data.children[c];

          var matches = matcher(params, child);

          // If there wasn't a match, remove the object in the array
          if (matches == null) {
            match.children.splice(c, 1);
          }
        }

        // If any children matched, return the new object
        if (match.children.length > 0) {
          return match;
        }

        // If there were no matching children, check just the plain object
        return matcher(params, match);
      }

      var original = stripDiacritics(data.text).toUpperCase();
      var term = stripDiacritics(params.term).toUpperCase();

      // Check if the text contains the term
      if (original.indexOf(term) > -1) {
        return data;
      }

      // If it doesn't contain the term, don't return anything
      return null;
    }

    this.defaults = {
      amdBase: './',
      amdLanguageBase: './i18n/',
      closeOnSelect: true,
      debug: false,
      dropdownAutoWidth: false,
      escapeMarkup: Utils.escapeMarkup,
      language: {},
      matcher: matcher,
      minimumInputLength: 0,
      maximumInputLength: 0,
      maximumSelectionLength: 0,
      minimumResultsForSearch: 0,
      selectOnClose: false,
      scrollAfterSelect: false,
      sorter: function (data) {
        return data;
      },
      templateResult: function (result) {
        return result.text;
      },
      templateSelection: function (selection) {
        return selection.text;
      },
      theme: 'default',
      width: 'resolve'
    };
  };

  Defaults.prototype.applyFromElement = function (options, $element) {
    var optionLanguage = options.language;
    var defaultLanguage = this.defaults.language;
    var elementLanguage = $element.prop('lang');
    var parentLanguage = $element.closest('[lang]').prop('lang');

    var languages = Array.prototype.concat.call(
      this._resolveLanguage(elementLanguage),
      this._resolveLanguage(optionLanguage),
      this._resolveLanguage(defaultLanguage),
      this._resolveLanguage(parentLanguage)
    );

    options.language = languages;

    return options;
  };

  Defaults.prototype._resolveLanguage = function (language) {
    if (!language) {
      return [];
    }

    if ($.isEmptyObject(language)) {
      return [];
    }

    if ($.isPlainObject(language)) {
      return [language];
    }

    var languages;

    if (!$.isArray(language)) {
      languages = [language];
    } else {
      languages = language;
    }

    var resolvedLanguages = [];

    for (var l = 0; l < languages.length; l++) {
      resolvedLanguages.push(languages[l]);

      if (typeof languages[l] === 'string' && languages[l].indexOf('-') > 0) {
        // Extract the region information if it is included
        var languageParts = languages[l].split('-');
        var baseLanguage = languageParts[0];

        resolvedLanguages.push(baseLanguage);
      }
    }

    return resolvedLanguages;
  };

  Defaults.prototype._processTranslations = function (languages, debug) {
    var translations = new Translation();

    for (var l = 0; l < languages.length; l++) {
      var languageData = new Translation();

      var language = languages[l];

      if (typeof language === 'string') {
        try {
          // Try to load it with the original name
          languageData = Translation.loadPath(language);
        } catch (e) {
          try {
            // If we couldn't load it, check if it wasn't the full path
            language = this.defaults.amdLanguageBase + language;
            languageData = Translation.loadPath(language);
          } catch (ex) {
            // The translation could not be loaded at all. Sometimes this is
            // because of a configuration problem, other times this can be
            // because of how Select2 helps load all possible translation files
            if (debug && window.console && console.warn) {
              console.warn(
                'Select2: The language file for "' + language + '" could ' +
                'not be automatically loaded. A fallback will be used instead.'
              );
            }
          }
        }
      } else if ($.isPlainObject(language)) {
        languageData = new Translation(language);
      } else {
        languageData = language;
      }

      translations.extend(languageData);
    }

    return translations;
  };

  Defaults.prototype.set = function (key, value) {
    var camelKey = $.camelCase(key);

    var data = {};
    data[camelKey] = value;

    var convertedData = Utils._convertData(data);

    $.extend(true, this.defaults, convertedData);
  };

  var defaults = new Defaults();

  return defaults;
});

S2.define('select2/options',[
  'require',
  'jquery',
  './defaults',
  './utils'
], function (require, $, Defaults, Utils) {
  function Options (options, $element) {
    this.options = options;

    if ($element != null) {
      this.fromElement($element);
    }

    if ($element != null) {
      this.options = Defaults.applyFromElement(this.options, $element);
    }

    this.options = Defaults.apply(this.options);

    if ($element && $element.is('input')) {
      var InputCompat = require(this.get('amdBase') + 'compat/inputData');

      this.options.dataAdapter = Utils.Decorate(
        this.options.dataAdapter,
        InputCompat
      );
    }
  }

  Options.prototype.fromElement = function ($e) {
    var excludedData = ['select2'];

    if (this.options.multiple == null) {
      this.options.multiple = $e.prop('multiple');
    }

    if (this.options.disabled == null) {
      this.options.disabled = $e.prop('disabled');
    }

    if (this.options.dir == null) {
      if ($e.prop('dir')) {
        this.options.dir = $e.prop('dir');
      } else if ($e.closest('[dir]').prop('dir')) {
        this.options.dir = $e.closest('[dir]').prop('dir');
      } else {
        this.options.dir = 'ltr';
      }
    }

    $e.prop('disabled', this.options.disabled);
    $e.prop('multiple', this.options.multiple);

    if (Utils.GetData($e[0], 'select2Tags')) {
      if (this.options.debug && window.console && console.warn) {
        console.warn(
          'Select2: The `data-select2-tags` attribute has been changed to ' +
          'use the `data-data` and `data-tags="true"` attributes and will be ' +
          'removed in future versions of Select2.'
        );
      }

      Utils.StoreData($e[0], 'data', Utils.GetData($e[0], 'select2Tags'));
      Utils.StoreData($e[0], 'tags', true);
    }

    if (Utils.GetData($e[0], 'ajaxUrl')) {
      if (this.options.debug && window.console && console.warn) {
        console.warn(
          'Select2: The `data-ajax-url` attribute has been changed to ' +
          '`data-ajax--url` and support for the old attribute will be removed' +
          ' in future versions of Select2.'
        );
      }

      $e.attr('ajax--url', Utils.GetData($e[0], 'ajaxUrl'));
      Utils.StoreData($e[0], 'ajax-Url', Utils.GetData($e[0], 'ajaxUrl'));
    }

    var dataset = {};

    function upperCaseLetter(_, letter) {
      return letter.toUpperCase();
    }

    // Pre-load all of the attributes which are prefixed with `data-`
    for (var attr = 0; attr < $e[0].attributes.length; attr++) {
      var attributeName = $e[0].attributes[attr].name;
      var prefix = 'data-';

      if (attributeName.substr(0, prefix.length) == prefix) {
        // Get the contents of the attribute after `data-`
        var dataName = attributeName.substring(prefix.length);

        // Get the data contents from the consistent source
        // This is more than likely the jQuery data helper
        var dataValue = Utils.GetData($e[0], dataName);

        // camelCase the attribute name to match the spec
        var camelDataName = dataName.replace(/-([a-z])/g, upperCaseLetter);

        // Store the data attribute contents into the dataset since
        dataset[camelDataName] = dataValue;
      }
    }

    // Prefer the element's `dataset` attribute if it exists
    // jQuery 1.x does not correctly handle data attributes with multiple dashes
    if ($.fn.jquery && $.fn.jquery.substr(0, 2) == '1.' && $e[0].dataset) {
      dataset = $.extend(true, {}, $e[0].dataset, dataset);
    }

    // Prefer our internal data cache if it exists
    var data = $.extend(true, {}, Utils.GetData($e[0]), dataset);

    data = Utils._convertData(data);

    for (var key in data) {
      if ($.inArray(key, excludedData) > -1) {
        continue;
      }

      if ($.isPlainObject(this.options[key])) {
        $.extend(this.options[key], data[key]);
      } else {
        this.options[key] = data[key];
      }
    }

    return this;
  };

  Options.prototype.get = function (key) {
    return this.options[key];
  };

  Options.prototype.set = function (key, val) {
    this.options[key] = val;
  };

  return Options;
});

S2.define('select2/core',[
  'jquery',
  './options',
  './utils',
  './keys'
], function ($, Options, Utils, KEYS) {
  var Select2 = function ($element, options) {
    if (Utils.GetData($element[0], 'select2') != null) {
      Utils.GetData($element[0], 'select2').destroy();
    }

    this.$element = $element;

    this.id = this._generateId($element);

    options = options || {};

    this.options = new Options(options, $element);

    Select2.__super__.constructor.call(this);

    // Set up the tabindex

    var tabindex = $element.attr('tabindex') || 0;
    Utils.StoreData($element[0], 'old-tabindex', tabindex);
    $element.attr('tabindex', '-1');

    // Set up containers and adapters

    var DataAdapter = this.options.get('dataAdapter');
    this.dataAdapter = new DataAdapter($element, this.options);

    var $container = this.render();

    this._placeContainer($container);

    var SelectionAdapter = this.options.get('selectionAdapter');
    this.selection = new SelectionAdapter($element, this.options);
    this.$selection = this.selection.render();

    this.selection.position(this.$selection, $container);

    var DropdownAdapter = this.options.get('dropdownAdapter');
    this.dropdown = new DropdownAdapter($element, this.options);
    this.$dropdown = this.dropdown.render();

    this.dropdown.position(this.$dropdown, $container);

    var ResultsAdapter = this.options.get('resultsAdapter');
    this.results = new ResultsAdapter($element, this.options, this.dataAdapter);
    this.$results = this.results.render();

    this.results.position(this.$results, this.$dropdown);

    // Bind events

    var self = this;

    // Bind the container to all of the adapters
    this._bindAdapters();

    // Register any DOM event handlers
    this._registerDomEvents();

    // Register any internal event handlers
    this._registerDataEvents();
    this._registerSelectionEvents();
    this._registerDropdownEvents();
    this._registerResultsEvents();
    this._registerEvents();

    // Set the initial state
    this.dataAdapter.current(function (initialData) {
      self.trigger('selection:update', {
        data: initialData
      });
    });

    // Hide the original select
    $element.addClass('select2-hidden-accessible');
    $element.attr('aria-hidden', 'true');

    // Synchronize any monitored attributes
    this._syncAttributes();

    Utils.StoreData($element[0], 'select2', this);

    // Ensure backwards compatibility with $element.data('select2').
    $element.data('select2', this);
  };

  Utils.Extend(Select2, Utils.Observable);

  Select2.prototype._generateId = function ($element) {
    var id = '';

    if ($element.attr('id') != null) {
      id = $element.attr('id');
    } else if ($element.attr('name') != null) {
      id = $element.attr('name') + '-' + Utils.generateChars(2);
    } else {
      id = Utils.generateChars(4);
    }

    id = id.replace(/(:|\.|\[|\]|,)/g, '');
    id = 'select2-' + id;

    return id;
  };

  Select2.prototype._placeContainer = function ($container) {
    $container.insertAfter(this.$element);

    var width = this._resolveWidth(this.$element, this.options.get('width'));

    if (width != null) {
      $container.css('width', width);
    }
  };

  Select2.prototype._resolveWidth = function ($element, method) {
    var WIDTH = /^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i;

    if (method == 'resolve') {
      var styleWidth = this._resolveWidth($element, 'style');

      if (styleWidth != null) {
        return styleWidth;
      }

      return this._resolveWidth($element, 'element');
    }

    if (method == 'element') {
      var elementWidth = $element.outerWidth(false);

      if (elementWidth <= 0) {
        return 'auto';
      }

      return elementWidth + 'px';
    }

    if (method == 'style') {
      var style = $element.attr('style');

      if (typeof(style) !== 'string') {
        return null;
      }

      var attrs = style.split(';');

      for (var i = 0, l = attrs.length; i < l; i = i + 1) {
        var attr = attrs[i].replace(/\s/g, '');
        var matches = attr.match(WIDTH);

        if (matches !== null && matches.length >= 1) {
          return matches[1];
        }
      }

      return null;
    }

    if (method == 'computedstyle') {
      var computedStyle = window.getComputedStyle($element[0]);

      return computedStyle.width;
    }

    return method;
  };

  Select2.prototype._bindAdapters = function () {
    this.dataAdapter.bind(this, this.$container);
    this.selection.bind(this, this.$container);

    this.dropdown.bind(this, this.$container);
    this.results.bind(this, this.$container);
  };

  Select2.prototype._registerDomEvents = function () {
    var self = this;

    this.$element.on('change.select2', function () {
      self.dataAdapter.current(function (data) {
        self.trigger('selection:update', {
          data: data
        });
      });
    });

    this.$element.on('focus.select2', function (evt) {
      self.trigger('focus', evt);
    });

    this._syncA = Utils.bind(this._syncAttributes, this);
    this._syncS = Utils.bind(this._syncSubtree, this);

    if (this.$element[0].attachEvent) {
      this.$element[0].attachEvent('onpropertychange', this._syncA);
    }

    var observer = window.MutationObserver ||
      window.WebKitMutationObserver ||
      window.MozMutationObserver
    ;

    if (observer != null) {
      this._observer = new observer(function (mutations) {
        self._syncA();
        self._syncS(null, mutations);
      });
      this._observer.observe(this.$element[0], {
        attributes: true,
        childList: true,
        subtree: false
      });
    } else if (this.$element[0].addEventListener) {
      this.$element[0].addEventListener(
        'DOMAttrModified',
        self._syncA,
        false
      );
      this.$element[0].addEventListener(
        'DOMNodeInserted',
        self._syncS,
        false
      );
      this.$element[0].addEventListener(
        'DOMNodeRemoved',
        self._syncS,
        false
      );
    }
  };

  Select2.prototype._registerDataEvents = function () {
    var self = this;

    this.dataAdapter.on('*', function (name, params) {
      self.trigger(name, params);
    });
  };

  Select2.prototype._registerSelectionEvents = function () {
    var self = this;
    var nonRelayEvents = ['toggle', 'focus'];

    this.selection.on('toggle', function () {
      self.toggleDropdown();
    });

    this.selection.on('focus', function (params) {
      self.focus(params);
    });

    this.selection.on('*', function (name, params) {
      if ($.inArray(name, nonRelayEvents) !== -1) {
        return;
      }

      self.trigger(name, params);
    });
  };

  Select2.prototype._registerDropdownEvents = function () {
    var self = this;

    this.dropdown.on('*', function (name, params) {
      self.trigger(name, params);
    });
  };

  Select2.prototype._registerResultsEvents = function () {
    var self = this;

    this.results.on('*', function (name, params) {
      self.trigger(name, params);
    });
  };

  Select2.prototype._registerEvents = function () {
    var self = this;

    this.on('open', function () {
      self.$container.addClass('select2-container--open');
    });

    this.on('close', function () {
      self.$container.removeClass('select2-container--open');
    });

    this.on('enable', function () {
      self.$container.removeClass('select2-container--disabled');
    });

    this.on('disable', function () {
      self.$container.addClass('select2-container--disabled');
    });

    this.on('blur', function () {
      self.$container.removeClass('select2-container--focus');
    });

    this.on('query', function (params) {
      if (!self.isOpen()) {
        self.trigger('open', {});
      }

      this.dataAdapter.query(params, function (data) {
        self.trigger('results:all', {
          data: data,
          query: params
        });
      });
    });

    this.on('query:append', function (params) {
      this.dataAdapter.query(params, function (data) {
        self.trigger('results:append', {
          data: data,
          query: params
        });
      });
    });

    this.on('keypress', function (evt) {
      var key = evt.which;

      if (self.isOpen()) {
        if (key === KEYS.ESC ||
            (key === KEYS.UP && evt.altKey)) {
          self.close(evt);

          evt.preventDefault();
        } else if (key === KEYS.ENTER || key === KEYS.TAB) {
            var isAjaxEnabled = self.options.options.ajax != null;
            if (isAjaxEnabled) {
                evt.preventDefault();
                setTimeout(function() {
                    self.trigger('results:select', {});
                }, 500);
                return;
            } else {
                self.trigger('results:select', {});
                evt.preventDefault();
            }
        } else if ((key === KEYS.SPACE && evt.ctrlKey)) {
          self.trigger('results:toggle', {});

          evt.preventDefault();
        } else if (key === KEYS.UP) {
          self.trigger('results:previous', {});

          evt.preventDefault();
        } else if (key === KEYS.DOWN) {
          self.trigger('results:next', {});

          evt.preventDefault();
        }
      } else {
        if (key === KEYS.ENTER || key === KEYS.SPACE ||
            (key === KEYS.DOWN && evt.altKey)) {
          self.open();

          evt.preventDefault();
        }
      }
    });
  };

  Select2.prototype._syncAttributes = function () {
    this.options.set('disabled', this.$element.prop('disabled'));

    if (this.isDisabled()) {
      if (this.isOpen()) {
        this.close();
      }

      this.trigger('disable', {});
    } else {
      this.trigger('enable', {});
    }
  };

  Select2.prototype._isChangeMutation = function (evt, mutations) {
    var changed = false;
    var self = this;

    // Ignore any mutation events raised for elements that aren't options or
    // optgroups. This handles the case when the select element is destroyed
    if (
      evt && evt.target && (
        evt.target.nodeName !== 'OPTION' && evt.target.nodeName !== 'OPTGROUP'
      )
    ) {
      return;
    }

    if (!mutations) {
      // If mutation events aren't supported, then we can only assume that the
      // change affected the selections
      changed = true;
    } else if (mutations.addedNodes && mutations.addedNodes.length > 0) {
      for (var n = 0; n < mutations.addedNodes.length; n++) {
        var node = mutations.addedNodes[n];

        if (node.selected) {
          changed = true;
        }
      }
    } else if (mutations.removedNodes && mutations.removedNodes.length > 0) {
      changed = true;
    } else if ($.isArray(mutations)) {
      $.each(mutations, function(evt, mutation) {
        if (self._isChangeMutation(evt, mutation)) {
          // We've found a change mutation.
          // Let's escape from the loop and continue
          changed = true;
          return false;
        }
      });
    }
    return changed;
  };

  Select2.prototype._syncSubtree = function (evt, mutations) {
    var changed = this._isChangeMutation(evt, mutations);
    var self = this;

    // Only re-pull the data if we think there is a change
    if (changed) {
      this.dataAdapter.current(function (currentData) {
        self.trigger('selection:update', {
          data: currentData
        });
      });
    }
  };

  /**
   * Override the trigger method to automatically trigger pre-events when
   * there are events that can be prevented.
   */
  Select2.prototype.trigger = function (name, args) {
    var actualTrigger = Select2.__super__.trigger;
    var preTriggerMap = {
      'open': 'opening',
      'close': 'closing',
      'select': 'selecting',
      'unselect': 'unselecting',
      'clear': 'clearing'
    };

    if (args === undefined) {
      args = {};
    }

    if (name in preTriggerMap) {
      var preTriggerName = preTriggerMap[name];
      var preTriggerArgs = {
        prevented: false,
        name: name,
        args: args
      };

      actualTrigger.call(this, preTriggerName, preTriggerArgs);

      if (preTriggerArgs.prevented) {
        args.prevented = true;

        return;
      }
    }

    actualTrigger.call(this, name, args);
  };

  Select2.prototype.toggleDropdown = function () {
    if (this.isDisabled()) {
      return;
    }

    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  };

  Select2.prototype.open = function () {
    if (this.isOpen()) {
      return;
    }

    if (this.isDisabled()) {
      return;
    }

    this.trigger('query', {});
  };

  Select2.prototype.close = function (evt) {
    if (!this.isOpen()) {
      return;
    }

    this.trigger('close', { originalEvent : evt });
  };

  /**
   * Helper method to abstract the "enabled" (not "disabled") state of this
   * object.
   *
   * @return {true} if the instance is not disabled.
   * @return {false} if the instance is disabled.
   */
  Select2.prototype.isEnabled = function () {
    return !this.isDisabled();
  };

  /**
   * Helper method to abstract the "disabled" state of this object.
   *
   * @return {true} if the disabled option is true.
   * @return {false} if the disabled option is false.
   */
  Select2.prototype.isDisabled = function () {
    return this.options.get('disabled');
  };

  Select2.prototype.isOpen = function () {
    return this.$container.hasClass('select2-container--open');
  };

  Select2.prototype.hasFocus = function () {
    return this.$container.hasClass('select2-container--focus');
  };

  Select2.prototype.focus = function (data) {
    // No need to re-trigger focus events if we are already focused
    if (this.hasFocus()) {
      return;
    }

    this.$container.addClass('select2-container--focus');
    this.trigger('focus', {});
  };

  Select2.prototype.enable = function (args) {
    if (this.options.get('debug') && window.console && console.warn) {
      console.warn(
        'Select2: The `select2("enable")` method has been deprecated and will' +
        ' be removed in later Select2 versions. Use $element.prop("disabled")' +
        ' instead.'
      );
    }

    if (args == null || args.length === 0) {
      args = [true];
    }

    var disabled = !args[0];

    this.$element.prop('disabled', disabled);
  };

  Select2.prototype.data = function () {
    if (this.options.get('debug') &&
        arguments.length > 0 && window.console && console.warn) {
      console.warn(
        'Select2: Data can no longer be set using `select2("data")`. You ' +
        'should consider setting the value instead using `$element.val()`.'
      );
    }

    var data = [];

    this.dataAdapter.current(function (currentData) {
      data = currentData;
    });

    return data;
  };

  Select2.prototype.val = function (args) {
    if (this.options.get('debug') && window.console && console.warn) {
      console.warn(
        'Select2: The `select2("val")` method has been deprecated and will be' +
        ' removed in later Select2 versions. Use $element.val() instead.'
      );
    }

    if (args == null || args.length === 0) {
      return this.$element.val();
    }

    var newVal = args[0];

    if ($.isArray(newVal)) {
      newVal = $.map(newVal, function (obj) {
        return obj.toString();
      });
    }

    this.$element.val(newVal).trigger('input').trigger('change');
  };

  Select2.prototype.destroy = function () {
    this.$container.remove();

    if (this.$element[0].detachEvent) {
      this.$element[0].detachEvent('onpropertychange', this._syncA);
    }

    if (this._observer != null) {
      this._observer.disconnect();
      this._observer = null;
    } else if (this.$element[0].removeEventListener) {
      this.$element[0]
        .removeEventListener('DOMAttrModified', this._syncA, false);
      this.$element[0]
        .removeEventListener('DOMNodeInserted', this._syncS, false);
      this.$element[0]
        .removeEventListener('DOMNodeRemoved', this._syncS, false);
    }

    this._syncA = null;
    this._syncS = null;

    this.$element.off('.select2');
    this.$element.attr('tabindex',
    Utils.GetData(this.$element[0], 'old-tabindex'));

    this.$element.removeClass('select2-hidden-accessible');
    this.$element.attr('aria-hidden', 'false');
    Utils.RemoveData(this.$element[0]);
    this.$element.removeData('select2');

    this.dataAdapter.destroy();
    this.selection.destroy();
    this.dropdown.destroy();
    this.results.destroy();

    this.dataAdapter = null;
    this.selection = null;
    this.dropdown = null;
    this.results = null;
  };

  Select2.prototype.render = function () {
    var $container = $(
      '<span class="select2 select2-container">' +
        '<span class="selection"></span>' +
        '<span class="dropdown-wrapper" aria-hidden="true"></span>' +
      '</span>'
    );

    $container.attr('dir', this.options.get('dir'));

    this.$container = $container;

    this.$container.addClass('select2-container--' + this.options.get('theme'));

    Utils.StoreData($container[0], 'element', this.$element);

    return $container;
  };

  return Select2;
});

S2.define('jquery-mousewheel',[
  'jquery'
], function ($) {
  // Used to shim jQuery.mousewheel for non-full builds.
  return $;
});

S2.define('jquery.select2',[
  'jquery',
  'jquery-mousewheel',

  './select2/core',
  './select2/defaults',
  './select2/utils'
], function ($, _, Select2, Defaults, Utils) {
  if ($.fn.select2 == null) {
    // All methods that should return the element
    var thisMethods = ['open', 'close', 'destroy'];

    $.fn.select2 = function (options) {
      options = options || {};

      if (typeof options === 'object') {
        this.each(function () {
          var instanceOptions = $.extend(true, {}, options);

          var instance = new Select2($(this), instanceOptions);
        });

        return this;
      } else if (typeof options === 'string') {
        var ret;
        var args = Array.prototype.slice.call(arguments, 1);

        this.each(function () {
          var instance = Utils.GetData(this, 'select2');

          if (instance == null && window.console && console.error) {
            console.error(
              'The select2(\'' + options + '\') method was called on an ' +
              'element that is not using Select2.'
            );
          }

          ret = instance[options].apply(instance, args);
        });

        // Check if we should be returning `this`
        if ($.inArray(options, thisMethods) > -1) {
          return this;
        }

        return ret;
      } else {
        throw new Error('Invalid arguments for Select2: ' + options);
      }
    };
  }

  if ($.fn.select2.defaults == null) {
    $.fn.select2.defaults = Defaults;
  }

  return Select2;
});

  // Return the AMD loader configuration so it can be used outside of this file
  return {
    define: S2.define,
    require: S2.require
  };
}());

  // Autoload the jQuery bindings
  // We know that all of the modules exist above this, so we're safe
  var select2 = S2.require('jquery.select2');

  // Hold the AMD module references on the jQuery function that was just loaded
  // This allows Select2 to use the internal loader outside of this file, such
  // as in the language files.
  jQuery.fn.select2.amd = S2;

  // Return the Select2 instance for anyone who is importing it.
  return select2;
}));

},
'appivo/vue/components/InlineTextBox':function(){
define([
  'vue/vue',
  'appivo/vue/components/ValidationMixin',
  'dojo/text!../html/InlineTextBox.html'
], function(Vue, ValidationMixin, template) {
	
	return Vue.extend({
		template: template,
		mixins: [ValidationMixin],
		data: function() {
			return {
				editing: false,
				editValue: ""
			};
		},
		props: {
			value: String,
			disabled: Boolean,
			placeholder: String,
			errorposition: String,
			style: Object,
			dispstyle: Object,
			classes: {
				type: String,
				'default': ""
			},
			editClasses: {
				type: Array,
				'default': function() {
					return [];
				}
			}
		},		
		computed: {
			displayClasses: function() {
				var cls = this.classes;
				if (this.editValue == undefined || this.editValue == null || this.editValue.length == 0) {
					cls = 'placeholder ';
					if (this.classes) {
						cls += this.classes;
					}
				}
				return cls;
			},
			displayValue: function() {
				if (this.editValue != undefined && this.editValue != null && this.editValue.length > 0) {
					return this.editValue;
				} else {
					return this.placeholder;
				}
			},
		    dispstyles: function() {
                var s = this.dispstyle ? this.dispstyle : {};
                return Vue.util.extend({
                    minHeight: '1.2em'
                }, s);
            },
			styles: function() {
			    var s = this.style ? this.style : {};
				return Vue.util.extend({
					display: 'inline'
				}, s);
			},
			internalClasses: function() {
				var obj = {};
				for (var i = 0; i < this.editClasses.length; i++) {
					var cls = this.editClasses[i];
					this.obj[cls] = true
				}
				obj.invalid = !this.valid;
				return obj;
			},
			maxLength: function() {
				var len = "";
				if (this.validation && this.validation.maxLength) {
					len = this.validation.maxLength;
				}
				return len;
			}
		},
		ready: function() {
			this.editValue = this.value;
			this.validate(this.value);
		},
		watch: {
			'value': function() {
				this.editValue = this.value;
			}
		},
		methods: {
			setValue: function(value) {
				this.editValue = value;
			},
			setFocus: function() {
			    this.toggleEdit(true);
			},
			removeFocus: function() {
				this.$els.input.blur();
			},
			toggleEdit: function(value) {
				this.editing = value;
				var t = this;
				if (value) {
					Vue.nextTick(function () {
						t.value = t.editValue;
						t.$els.input.focus();
					});
				} else {
                    if (!this.valid) {
                        this.validate(this.editValue, this.editValue);
                    } else {
                    	var currentValue = t.$els.input.value;
                        this.value = currentValue;
                        var event = document.createEvent('Event');
                        event.initEvent('update', true, true);
                        event.value = currentValue;
                        this.$el.dispatchEvent(event);
                    }
				}
			}
		}
	});
});
},
'appivo/mvc/widgets/ContainerWidget':function(){
define (['dojo/_base/lang', 
         'dojo/Deferred'], function(lang, Deferred) {
	return {
		name: 'ContainerWidget',
		maximizable: true,
		resizable: true,
		styleProperties: {
		},
		properties: {
			maxi: {
				type: 'OPTION',
				options: [
					{
						label: 'No',
						value: 'no'
					},
					{
						label: 'Yes',
						value: 'yes'
					},
					{
						label: 'Horizontal',
						value: 'hor'
					},
					{
						label: 'Vertical',
						value: 'ver'
					}
				],
				defaultValue: 'no'
			}
		},
		functions: {
			/**
			 * Enables/disables the widget.
			 * @function
			 * @instance
			 * @param {Boolean} Enabled - True to enable the widget and all its children, false to disable.
			 * @memberof ContainerWidget
			 */
			setEnabled: {
				script: function(enabled) {
					var widget = this.widget;
					if (widget.getChildren) {
						var children = widget.getChildren();
						for (var i = 0; i < children.length; i++) {
							var child = children[i];
							if (lang.isFunction(child.peer.setEnabled)) {
								child.peer.setEnabled(enabled);
							}
						}
					}
				},
				meta: {
					params: [{ name:"enabled", type:"boolean" }],
					shadowblocks: { enabled: "boolean#true" }
				}
			},
			
			/**
			 * Destroy any dynamically created widgets present in this container
			 * @function
			 * @instance
			 * @memberof ContainerWidget
			 */
			destroyDynamicWidgets: {
				script: function() {
					var widget = this.widget;
					if (widget.getChildren) {
						var children = widget.getChildren();
						for (var i = 0; i < children.length; i++) {
							var child = children[i];
							if (child.__dynamicInstance) {
								child.destroy();
							}
						}
					}
					
				}
			}
		}
	};
});
},
'appivo/mvc/widgets/ColoredWidget':function(){
define (['dojo/_base/lang', 'dojo/dom-style'], function(lang, domStyle) {
	return {
		name: 'ColoredWidget',
		properties: {
			color: {
				type: 'OPTION',
				required: false,
				options: [
				   {
					   label: 'None',
					   value: 'none'
				   },
				   {
					   label: 'Light',
					   value: 'light'
				   },
				   {
					   label: 'Stable',
					   value: 'stable'
				   },
				   {
					   label: 'Positive',
					   value: 'positive'
				   },
				   {
					   label: 'Calm',
					   value: 'calm'
				   },
				   {
					   label: 'Balanced',
					   value: 'balanced'
				   },
				   {
					   label: 'Energized',
					   value: 'energized'
				   },
				   {
					   label: 'Assertive',
					   value: 'assertive'
				   },
				   {
					   label: 'Royal',
					   value: 'royal'
				   },
				   {
					   label: 'Dark',
					   value: 'dark'
				   }
				]
			}
		}
	};
});
},
'appivo/mvc/widgets/DataWidget':function(){
define (['dojo/_base/lang', 
         'dojo/Deferred',
		 'dojo/i18n!../../nls/Widgets'
], function(lang, Deferred, messages) {
	return {
		name: 'DataWidget',
		properties: {
			storageMode: {
				type: 'OPTION',
				defaultValue: "inherit",
				options: [
					{
						label: messages.widget_storageMode_inherit,
						value: 'inherit'
					},
				   {
					   label: messages.widget_storageMode_sync,
					   value: 'sync'
				   },
				   {
					   label: messages.widget_storageMode_cloud,
					   value: 'cloud'
				   },
				   {
					   label: messages.widget_storageMode_local,
					   value: 'local'
					   }
				],
				order: 9000
			}
		},
		functions: {
			/**
			 * Sets the storage type of this widget
			 * @function
			 * @instance
			 * @param {String} cloud|local|sync
			 * @memberof DataWidget
			 */
			setStorageMode: {
				script: function(storage) {
					var widget = this.widget;
					if (widget.store && widget.store.setStorageMode) {
						widget.store.setStorageMode(storage);
					}
				},
				meta: {
					params: [{ name:"type", type:"string" }],
					shadowblocks: { enabled: "string#local" }
				}
			},
			
			/**
			 * Gets the storage type of this widget
			 * @function
			 * @instance
			 * @return {String} cloud|local|sync
			 * @memberof DataWidget
			 */
			getStorageMode: {
				script: function() {
					var widget = this.widget;
					if (widget.store && widget.store.getStorageMode) {
						widget.store.getStorageMode();
					}					
				}
			}
		}
	};
});
},
'appivo/store/StoreManager':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'dojo/_base/Deferred',
        'dojo/store/Observable',
        'appivo/store/JsonRest',
        'appivo/store/Memory',
        'appivo/client/Client',
        'dojo/store/Cache',
        'dojo/data/ObjectStore'], 

        function(lang, declare, Deferred, Observable, JsonRest, Memory, Client, Cache, ObjectStore) {
        
	var clss = declare("appivo.store.StoreManager", null, {

		stores: null,
		dataStores: null,
		caches: null,
		nextStoreId: 0,
		cell: null,
		client: null,
		defaultStorageMode: 'cloud',
		
		constructor: function(options) {
			declare.safeMixin(this, options);
			this.stores = {};
			this.dataStores = {};
			this.caches = {};
			this.client = Client.getInstance();
		},   

		reset: function(defaultStorageMode) {
			this.stores = {};
			if (defaultStorageMode) {
				this.defaultStorageMode = defaultStorageMode;
			} else {
				this.defaultStorageMode = 'cloud';
			}
		},
		
		_getNextId: function() {
			return this.nextStoreId++;
		},

		_getCache: function(uri) {
			var cache = this.caches[uri];
			if (!cache) {
				cache = new Memory({idAttribute: "id"});
				this.caches[uri] = cache;
			}
			return cache;
		},
		
		_createURI: function(url) {
			return this.client.getURI(url);
		},

		getStore: function (uri, fetchMode, options, storageMode) {
			uri = this._createURI(uri);
			if (!storageMode || storageMode === 'inherit') {
				storageMode = this.defaultStorageMode;
			}
			var store = null;
			var headers = {
				"Content-Type": "application/json;charset=UTF-8"
			};
			if (fetchMode) {
				headers.FetchMode = fetchMode;
			}
			
			if (!options) {
				var storeKey = uri + ':' + fetchMode + ':' + storageMode;
				store = this.stores[storeKey];
				if (!store) {
					var jsonrest = new JsonRest({
						target: uri, 
						idAttribute:"id", 
						headers: headers,
					});
					if (storageMode) {
						jsonrest.setStorageMode(storageMode);
					}
					store = Observable(jsonrest);
					store._fetchMode = fetchMode;
					store._storeId = this._getNextId() + "(" + uri +")";
					this.stores[storeKey] = store;
				}
			} else {
				var parms = {
					target: uri, 
					idAttribute: 'id', 
					headers: headers
				};
				lang.mixin(parms, options);
				var jsonrest = new JsonRest(parms);
				if (storageMode) {
					jsonrest.setStorageMode(storageMode);
				}
				store = Observable(jsonrest);
				store._storeId = this._getNextId() + "(options/" + uri + ")";
			}
			return store;
		},

		getDataStore: function(uri, fetchMode, options) {
			var dataStore = null;
			if (!options) {
				dataStore = this.dataStores[uri];
				if (!dataStore) {
					var store = this.getStore(uri, fetchMode);
					dataStore = new ObjectStore({objectStore: store, idAttribute: "id"});
					this.dataStores[uri] = dataStore;
				}
			} else {
				var store = this.getStore(uri, fetchMode, options);
				var opts = {
						objectStore: store,
						idAttribute: "id"
				};
				if (options.labelAttribute) {
					opts.labelProperty = options.labelAttribute;
				}
				dataStore = new ObjectStore(opts);
			}
			return dataStore;
		},

		createMemoryStore: function() {
			var mstore = new Memory();
			var ostore = new ObjectStore({objectStore:mstore});
			return ostore;
		}
	});

	clss.getInstance = function() {
		if (clss._instance == null) {
			clss._instance = new clss();
		}
		return clss._instance;
	};

	return clss;
});
},
'appivo/store/JsonRest':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'dojo/_base/xhr',
        'dojo/json',
        'dojo/Deferred',
        'dojo/topic',
        'dojo/store/util/QueryResults',
        'appivo/client/Client',
        'appivo/util/Identity',
        'dojo/i18n!appivo/nls/Client'],

        function(lang, declare, xhr, JSON, Deferred, topic, QueryResults, Client, Identity, messages) {
	
	var client = Client.getInstance();
	
	return declare("appivo.store.JsonRest", null, {

		tenant: null,
		enabled: true,
		withCredentials: true,
		dynamic: false,
		type: 'rest',
		storageMode: 'cloud',

		constructor: function(options){
			// summary:
			//		This is a basic store for RESTful communicating with a server through JSON
			//		formatted data.
			// options: dojo/store/JsonRest
			//		This provides any configuration information that will be mixed into the store
			this.headers = {};
			this.storePath += options.target;				
			declare.safeMixin(this, options);
			this.setTenant(this.tenant);
		},

		queryOptions: null,
		queryExtras: null,
		
		// headers: Object
		//		Additional headers to pass in all requests to the server. These can be overridden
		//		by passing additional headers to calls to the store.
		headers: {},

		// target: String
		//		The target base URL to use for all requests to the server. This string will be
		//		prepended to the id to generate the URL (relative or absolute) for requests
		//		sent to the server
		target: "",

		// idProperty: String
		//		Indicates the property to use as the identity property. The values of this
		//		property should be unique.
		idProperty: "id",

		// rangeParam: String
		//		Use a query parameter for the requested range. If this is omitted, than the
		//		Range header will be used. Independent of this, the X-Range header is always set.

		// sortParam: String
		//		The query parameter to used for holding sort information. If this is omitted, than
		//		the sort information is included in a functional query token to avoid colliding
		//		with the set of name/value pairs.

		// ascendingPrefix: String
		//		The prefix to apply to sort attribute names that are ascending
		ascendingPrefix: "+",

		// descendingPrefix: String
		//		The prefix to apply to sort attribute names that are ascending
		descendingPrefix: "-",
		
		setEnabled: function(enabled) {
			this.enabled = enabled;
		},
		
		setStorageMode: function(mode) {
			this.storageMode = mode;
		},
		
		getStorageMode: function() {
			return this.storageMode;
		},
		
		_getTargetId: function(id) {
			return id;
		},
		
		_getTarget: function(id) {
			// summary:
			//		If the target has no trailing '/', then append it.
			// id: Number
			//		The identity of the requested target
			var id = this._getTargetId(id);
			var target = this.target;
			if (typeof id != "undefined" && typeof id != "null" && !(id.indexOf("cid_") == 0)) {
				if (target.charAt(target.length-1) == '/') {
					target += id;
				} else {
					target += '/' + id;
				}
			}
			return target;
		},
		
		setTenant: function(tenant) {
			if (tenant) {
				this.headers['X-Tenant'] = tenant;				
			} else {
				delete this.headers['X-Tenant'];
			}
		},
		
		_setOfflineHeaders: function(headers) {
			switch (this.storageMode) {
			case 'local':
				headers['X-Offline'] = "Yes";
				break;
			case 'sync':
				headers['X-Sync'] = "Yes";
				break;
			}
		},

		get: function(id, options){
			// summary:
			//		Retrieves an object by its identity. This will trigger a GET request to the server using
			//		the url `this.target + id`.
			// id: Number
			//		The identity to use to lookup the object
			// options: Object?
			//		HTTP headers. For consistency with other methods, if a `headers` key exists on this object, it will be
			//		used to provide HTTP headers instead.
			// returns: Object
			//		The object in the store that matches the given id.
			
			if (!navigator.onLine) {
				var def = new Deferred();
				def.reject(messages.offlineWarning);
				return def;
			}
			
			options = options || {};
			var headers = lang.mixin({ Accept: this.accepts }, this.headers, options.headers || options);			
			return client.sendRequest(this._getTarget(id), {
				method: 'GET',
				withCredentials: this.withCredentials,
				storageMode: this.storageMode,
				handleAs: "json",
				headers: headers
			});
		},

		// accepts: String
		//		Defines the Accept header to use on HTTP requests
		accepts: "application/javascript, application/json",

		getIdentity: function(object){
			// summary:
			//		Returns an object's identity
			// object: Object
			//		The object to get the identity from
			// returns: Number
			return object[this.idProperty];
		},

		add: function(object, options){
			// summary:
			//		Adds an object. This will trigger a PUT request to the server
			//		if the object has an id, otherwise it will trigger a POST request.
			// object: Object
			//		The object to store.
			// options: __PutDirectives?
			//		Additional metadata for storing the data.  Includes an "id"
			//		property if a specific id is to be used.
			options = options || {};
			options.overwrite = false;
			return this.put(object, options);
		},

		remove: function(id, options){
			// summary:
			//		Deletes an object by its identity. This will trigger a DELETE request to the server.
			// id: Number
			//		The identity to use to delete the object
			// options: __HeaderOptions?
			//		HTTP headers.
			
			options = options || {};			
			return client.sendRequest(this._getTarget(id), {
				method: 'DELETE',
				handleAs: 'json',
				withCredentials: this.withCredentials,
				storageMode: this.storageMode,
				headers: lang.mixin({}, this.headers, options.headers)				
			});
		},

		put: function(record, options) {
			// summary:
			//		Stores an object. This will trigger a PUT request to the server
			//		if the object has an id, otherwise it will trigger a POST request.
			// object: Object
			//		The object to store.
			// options: __PutDirectives?
			//		Additional metadata for storing the data.  Includes an "id"
			//		property if a specific id is to be used.
			// returns: dojo/_base/Deferred
			/*
			if (!navigator.onLine) {
				var def = new Deferred();
				def.reject(messages.offlineWarning);
				return def;
			}
			*/

			if (record.__shallow) {
				delete record.__shallow;
				return Promise.resolve(record);
			}
			
			options = options || {};
			var idCheck = true;
			if (options.idCheck !== undefined) {
				idCheck = options.idCheck;
			}
			var id = ("id" in options) ? options.id : this.getIdentity(record);
			var hasId = idCheck ? Identity.isRealId(id) : typeof id != "undefined";
			var url = this._getTarget(id);
			var query = null;
			if (record.__query) {
				query = record.__query;
				var hasQuestionMark = this.target.indexOf("?") > -1;
				if(query && typeof query == "object"){
					query = xhr.objectToQuery(query);
				}
				if (query) {
					query = query ? (hasQuestionMark ? "&" : "?") + query: "";
					url = url + query;
				}
			}
			var clone = JSON.parse(JSON.stringify(record));
			if (clone.__query) {
			    delete clone.__query;
			}		
			var def = client.sendRequest(url, {
				method: hasId && !options.incremental ? "PUT" : "POST",
				handleAs: 'json',
				withCredentials: this.withCredentials,
				storageMode: this.storageMode,
				data: JSON.stringify(clone),
				headers: lang.mixin({
					"Content-Type": "application/json",
					"Accept": this.accepts,
					"If-Match": options.overwrite === true ? "*" : null,
					"If-None-Match": options.overwrite === false ? "*" : null
				}, this.headers, options.headers)
			});

			var isNew = (record.id == undefined);

			var def2 = new Deferred();
			def.then(function(rec) {
				if (isNew) {
					rec._isNew = isNew;
				}
				if (rec != null) {
					rec.__query = record.__query;
				}
				def2.resolve(rec);
			}, function(error) {
				def2.reject(error);
			});

			return def2;
		},

		setQueryOptions: function(options) {
			this.queryOptions = options;
		},
		
		setQueryExtras: function(extras) {
			this.queryExtras = extras;
		},
		
		onQueryResult: function(result) {			
		},
		
		_splitQueryProps: function(query){
			if (query) {
                var deletables = new Array();
                var newProps = new Array();
                for (var prop in query) {
                    var originalProp = prop;
                    if (prop.indexOf(",") > -1) {
                        var isOr = prop.indexOf('!') > -1;
                        if (isOr) {
                            prop = prop.replace("!","");
                        }
                        var index = "";
                        if (prop.indexOf("/") > -1) {
                            index = prop.substring(0, prop.indexOf("/") + 1);
                            prop = prop.substring(prop.indexOf("/") + 1);
                        }
                        var arr = prop.split(",");
                        var add = 0.0;
                        arr.forEach(function(newProp){
                            if (index != ""){
                                var targetIndex = parseInt(index) + add;
                                add += 0.1;
                                newProp = targetIndex + (isOr ? "/!" : "/") + newProp;
                                isOr = true;
                            }  else {
                                newProp = "!" + newProp;
                            }
                            newProps.push({key: newProp, value: query[prop]});
                        });
                        deletables.push(originalProp);
                    }
                }
                newProps.forEach(function(newProp){
                    query[newProp.key] = newProp.value;
                });
                deletables.forEach(function(delMe){
                    delete query[delMe];
                });
            }
            return query;
		},
		
		query: function(query, options){
			// summary:
			//		Queries the store for objects. This will trigger a GET request to the server, with the
			//		query added as a query string.
			// query: Object
			//		The query to use for retrieving objects from the store.
			// options: __QueryOptions?
			//		The optional arguments to apply to the resultset.
			// returns: dojo/store/api/Store.QueryResults
			//		The results of the query, extended with iterative methods.			
			query = this._splitQueryProps(query);
			options = options || {};
			if (this.queryOptions) {
	 			options = lang.mixin(this.queryOptions, options);				
			}
			if (this.queryExtras) {
				options = lang.mixin(options, this.queryExtras);
			}

			var headers = lang.mixin({ Accept: this.accepts }, this.headers, options.headers);
			headers['Authorization'] = client.getAccessToken();
			var hasQuestionMark = this.target.indexOf("?") > -1;
			if(query && typeof query == "object"){
				query = xhr.objectToQuery(query);
			}
			if (query) {
				query = query ? (hasQuestionMark ? "&" : "?") + query: "";				
			}
			if (options.start >= 0 || options.count >= 0){
				headers["X-Range"] = "items=" + (options.start || '0') + '-' +
				(("count" in options && options.count != Infinity) ?
						(options.count + (options.start || 0) - 1) : '');
				if(this.rangeParam){
					query += (query || hasQuestionMark ? "&" : "?") + this.rangeParam + "=" + headers["X-Range"];
					hasQuestionMark = true;
				}else{
					headers.Range = headers["X-Range"];
				}
			}
			if (options && options.sort){
				var sortParam = this.sortParam;
				query += (query || hasQuestionMark ? "&" : "?") + (sortParam ? sortParam + '=' : "sort(");
				for(var i = 0; i<options.sort.length; i++){
					var sort = options.sort[i];
					query += (i > 0 ? "," : "") + (sort.descending ? this.descendingPrefix : this.ascendingPrefix) + encodeURIComponent(sort.attribute);
				}
				if(!sortParam){
					query += ")";
				}
				hasQuestionMark = true;
			}
			if (options && options.rels) {
				query += (query || hasQuestionMark ? "&" : "?") + "rel(" + options.rels + ")";
				hasQuestionMark = true;
			}
			
			this._setOfflineHeaders(headers);
			
			var results = null;
			if (this.enabled) {
				if (this.dynamic) {
					results = client.sendRequest(this.target + (query || ""), {
						method: 'POST',
						handleAs: "json",
						headers: headers,
						withCredentials: true,
						storageMode: this.storageMode,
						data: JSON.stringify(this.__query.toJSON())
					});
				} else {
					results = client.sendRequest(this.target + (query || ""), {
						handleAs: "json",
						headers: headers,
						storageMode: this.storageMode,
						withCredentials: true
					});
				}

				results.total = results.then(function() {
					return results.response.then(function(response) {
						var range = response.getHeader("Content-Range");
						if (!range){
							// At least Chrome drops the Content-Range header from cached replies.
							range = response.getHeader("X-Content-Range");
						}
						return range && (range = range.match(/\/(.*)/)) && +range[1];
					});
				});

				var t = this;
				results.then(function(records) {
					results.total.then(function(total) {

						Object.defineProperty(records, 'total', {
							value: total,
							enumerable: false,
							writable: false,
							configurable: true
						});

						t.onQueryResult({
							store: t,
							result: records
						});
					});
				});
			} else {
				results = new Deferred();
				results.resolve(new Array());
			}
			var qr = QueryResults(results);
			qr.response = results.response;
			return qr;
		}
	});
});
},
'dojo/store/Cache':function(){
define(["../_base/lang","../when" /*=====, "../_base/declare", "./api/Store" =====*/],
function(lang, when /*=====, declare, Store =====*/){

// module:
//		dojo/store/Cache

var Cache = function(masterStore, cachingStore, options){
	options = options || {};
	return lang.delegate(masterStore, {
		query: function(query, directives){
			var results = masterStore.query(query, directives);
			results.forEach(function(object){
				if(!options.isLoaded || options.isLoaded(object)){
					cachingStore.put(object);
				}
			});
			return results;
		},
		// look for a queryEngine in either store
		queryEngine: masterStore.queryEngine || cachingStore.queryEngine,
		get: function(id, directives){
			return when(cachingStore.get(id), function(result){
				return result || when(masterStore.get(id, directives), function(result){
					if(result){
						cachingStore.put(result, {id: id});
					}
					return result;
				});
			});
		},
		add: function(object, directives){
			return when(masterStore.add(object, directives), function(result){
				// now put result in cache
				cachingStore.add(result && typeof result == "object" ? result : object, directives);
				return result; // the result from the add should be dictated by the masterStore and be unaffected by the cachingStore
			});
		},
		put: function(object, directives){
			// first remove from the cache, so it is empty until we get a response from the master store
			cachingStore.remove((directives && directives.id) || this.getIdentity(object));
			return when(masterStore.put(object, directives), function(result){
				// now put result in cache
				cachingStore.put(result && typeof result == "object" ? result : object, directives);
				return result; // the result from the put should be dictated by the masterStore and be unaffected by the cachingStore
			});
		},
		remove: function(id, directives){
			return when(masterStore.remove(id, directives), function(result){
				return cachingStore.remove(id, directives);
			});
		},
		evict: function(id){
			return cachingStore.remove(id);
		}
	});
};
lang.setObject("dojo.store.Cache", Cache);

/*=====
var __CacheArgs = {
	// summary:
	//		These are additional options for how caching is handled.
	// isLoaded: Function?
	//		This is a function that will be called for each item in a query response to determine
	//		if it is cacheable. If isLoaded returns true, the item will be cached, otherwise it
	//		will not be cached. If isLoaded is not provided, all items will be cached.
};

Cache = declare(Store, {
	// summary:
	//		The Cache store wrapper takes a master store and a caching store,
	//		caches data from the master into the caching store for faster
	//		lookup. Normally one would use a memory store for the caching
	//		store and a server store like JsonRest for the master store.
	// example:
	//	|	var master = new Memory(data);
	//	|	var cacher = new Memory();
	//	|	var store = new Cache(master, cacher);
	//
	constructor: function(masterStore, cachingStore, options){
		// masterStore:
		//		This is the authoritative store, all uncached requests or non-safe requests will
		//		be made against this store.
		// cachingStore:
		//		This is the caching store that will be used to store responses for quick access.
		//		Typically this should be a local store.
		// options: __CacheArgs?
		//		These are additional options for how caching is handled.
	},
	query: function(query, directives){
		// summary:
		//		Query the underlying master store and cache any results.
		// query: Object|String
		//		The object or string containing query information. Dependent on the query engine used.
		// directives: dojo/store/api/Store.QueryOptions?
		//		An optional keyword arguments object with additional parameters describing the query.
		// returns: dojo/store/api/Store.QueryResults
		//		A QueryResults object that can be used to iterate over.
	},
	get: function(id, directives){
		// summary:
		//		Get the object with the specific id.
		// id: Number
		//		The identifier for the object in question.
		// directives: Object?
		//		Any additional parameters needed to describe how the get should be performed.
		// returns: dojo/store/api/Store.QueryResults
		//		A QueryResults object.
	},
	add: function(object, directives){
		// summary:
		//		Add the given object to the store.
		// object: Object
		//		The object to add to the store.
		// directives: dojo/store/api/Store.AddOptions?
		//		Any additional parameters needed to describe how the add should be performed.
		// returns: Number
		//		The new id for the object.
	},
	put: function(object, directives){
		// summary:
		//		Put the object into the store (similar to an HTTP PUT).
		// object: Object
		//		The object to put to the store.
		// directives: dojo/store/api/Store.PutDirectives?
		//		Any additional parameters needed to describe how the put should be performed.
		// returns: Number
		//		The new id for the object.
	},
	remove: function(id){
		// summary:
		//		Remove the object with the specific id.
		// id: Number
		//		The identifier for the object in question.
	},
	evict: function(id){
		// summary:
		//		Remove the object with the given id from the underlying caching store.
		// id: Number
		//		The identifier for the object in question.
	}
});
=====*/

return Cache;
});

},
'dojo/data/ObjectStore':function(){
define(["../_base/lang", "../Evented", "../_base/declare", "../_base/Deferred",
	"../promise/all", "../_base/array", "../_base/connect", "../regexp"
], function(lang, Evented, declare, Deferred, all, array, connect, regexp){

// module:
//		dojo/data/ObjectStore

function convertRegex(character){
	return character == '*' ? '.*' : character == '?' ? '.' : character;
}
return declare("dojo.data.ObjectStore", [Evented],{
		// summary:
		//		A Dojo Data implementation that wraps Dojo object stores for backwards
		//		compatibility.

		objectStore: null,
		constructor: function(options){
			// options:
			//		The configuration information to pass into the data store.
			//
			//		- options.objectStore:
			//
			//		The object store to use as the source provider for this data store

			this._dirtyObjects = [];
			if(options.labelAttribute){
				// accept the old labelAttribute to make it easier to switch from old data stores
				options.labelProperty = options.labelAttribute;
			}
			lang.mixin(this, options);
		},
		labelProperty: "label",

		getValue: function(/*Object*/ item, /*String*/property, /*value?*/defaultValue){
			// summary:
			//		Gets the value of an item's 'property'
			// item:
			//		The item to get the value from
			// property:
			//		property to look up value for
			// defaultValue:
			//		the default value

			return typeof item.get === "function" ? item.get(property) :
				property in item ?
					item[property] : defaultValue;
		},
		getValues: function(item, property){
			// summary:
			//		Gets the value of an item's 'property' and returns
			//		it. If this value is an array it is just returned,
			//		if not, the value is added to an array and that is returned.
			// item: Object
			// property: String
			//		property to look up value for

			var val = this.getValue(item,property);
			return val instanceof Array ? val : val === undefined ? [] : [val];
		},

		getAttributes: function(item){
			// summary:
			//		Gets the available attributes of an item's 'property' and returns
			//		it as an array.
			// item: Object

			var res = [];
			for(var i in item){
				if(item.hasOwnProperty(i) && !(i.charAt(0) == '_' && i.charAt(1) == '_')){
					res.push(i);
				}
			}
			return res;
		},

		hasAttribute: function(item,attribute){
			// summary:
			//		Checks to see if item has attribute
			// item: Object
			//		The item to check
			// attribute: String
			//		The attribute to check
			return attribute in item;
		},

		containsValue: function(item, attribute, value){
			// summary:
			//		Checks to see if 'item' has 'value' at 'attribute'
			// item: Object
			//		The item to check
			// attribute: String
			//		The attribute to check
			// value: Anything
			//		The value to look for
			return array.indexOf(this.getValues(item,attribute),value) > -1;
		},


		isItem: function(item){
			// summary:
			//		Checks to see if the argument is an item
			// item: Object
			//		The item to check

			// we have no way of determining if it belongs, we just have object returned from
			// service queries
			return (typeof item == 'object') && item && !(item instanceof Date);
		},

		isItemLoaded: function(item){
			// summary:
			//		Checks to see if the item is loaded.
			// item: Object
			//		The item to check

			return item && typeof item.load !== "function";
		},

		loadItem: function(args){
			// summary:
			//		Loads an item and calls the callback handler. Note, that this will call the callback
			//		handler even if the item is loaded. Consequently, you can use loadItem to ensure
			//		that an item is loaded is situations when the item may or may not be loaded yet.
			//		If you access a value directly through property access, you can use this to load
			//		a lazy value as well (doesn't need to be an item).
			// args: Object
			//		See dojo/data/api/Read.fetch()
			// example:
			//	|	store.loadItem({
			//	|		item: item, // this item may or may not be loaded
			//	|		onItem: function(item){
			//	|			// do something with the item
			//	|		}
			//	|	});

			var item;
			if(typeof args.item.load === "function"){
				Deferred.when(args.item.load(), function(result){
					item = result; // in synchronous mode this can allow loadItem to return the value
					var func = result instanceof Error ? args.onError : args.onItem;
					if(func){
						func.call(args.scope, result);
					}
				});
			}else if(args.onItem){
				// even if it is already loaded, we will use call the callback, this makes it easier to
				// use when it is not known if the item is loaded (you can always safely call loadItem).
				args.onItem.call(args.scope, args.item);
			}
			return item;
		},
		close: function(request){
			// summary:
			// 		See dojo/data/api/Read.close()
			return request && request.abort && request.abort();
		},
		fetch: function(args){
			// summary:
			//		See dojo/data/api/Read.fetch()

			args = lang.delegate(args, args && args.queryOptions);
			var self = this;
			var scope = args.scope || self;
			var query = args.query;
			if(typeof query == "object"){ // can be null, but that is ignore by for-in
				query = lang.delegate(query); // don't modify the original
				for(var i in query){
					// find any strings and convert them to regular expressions for wildcard support
					var required = query[i];
					if(typeof required == "string"){
						query[i] = RegExp("^" + regexp.escapeString(required, "*?\\").replace(/\\.|\*|\?/g, convertRegex) + "$", args.ignoreCase ? "mi" : "m");
						query[i].toString = (function(original){
							return function(){
								return original;
							};
						})(required);
					}
				}
			}

			var results = this.objectStore.query(query, args);
			Deferred.when(results.total, function(totalCount){
				Deferred.when(results, function(results){
					if(args.onBegin){
						args.onBegin.call(scope, totalCount || results.length, args);
					}
					if(args.onItem){
						for(var i=0; i<results.length;i++){
							args.onItem.call(scope, results[i], args);
						}
					}
					if(args.onComplete){
						args.onComplete.call(scope, args.onItem ? null : results, args);
					}
					return results;
				}, errorHandler);
			}, errorHandler);
			function errorHandler(error){
				if(args.onError){
					args.onError.call(scope, error, args);
				}
			}
			args.abort = function(){
				// abort the request
				if(results.cancel){
					results.cancel();
				}
			};
			if(results.observe){
				if(this.observing){
					// if we were previously observing, cancel the last time to avoid multiple notifications. Just the best we can do for the impedance mismatch between APIs
					this.observing.cancel();
				}
				this.observing = results.observe(function(object, removedFrom, insertedInto){
					if(array.indexOf(self._dirtyObjects, object) == -1){
						if(removedFrom == -1){
							self.onNew(object);
						}
						else if(insertedInto == -1){
							self.onDelete(object);
						}
						else{
							for(var i in object){
								if(i != self.objectStore.idProperty){
									self.onSet(object, i, null, object[i]);
								}
							}
						}
					}
				}, true);
			}
			this.onFetch(results);
			args.store = this;
			return args;
		},
		getFeatures: function(){
			// summary:
			//		return the store feature set

			return {
				"dojo.data.api.Read": !!this.objectStore.get,
				"dojo.data.api.Identity": true,
				"dojo.data.api.Write": !!this.objectStore.put,
				"dojo.data.api.Notification": true
			};
		},

		getLabel: function(/* dojo/data/api/Item */ item){
			// summary:
			//		See dojo/data/api/Read.getLabel()
			if(this.isItem(item)){
				return this.getValue(item,this.labelProperty); //String
			}
			return undefined; //undefined
		},

		getLabelAttributes: function(/* dojo/data/api/Item */ item){
			// summary:
			//		See dojo/data/api/Read.getLabelAttributes()
			return [this.labelProperty]; //array
		},

		//Identity API Support


		getIdentity: function(item){
			// summary:
			//		returns the identity of the given item
			//		See dojo/data/api/Read.getIdentity()
			return this.objectStore.getIdentity ? this.objectStore.getIdentity(item) : item[this.objectStore.idProperty || "id"];
		},

		getIdentityAttributes: function(item){
			// summary:
			//		returns the attributes which are used to make up the
			//		identity of an item.	Basically returns this.objectStore.idProperty
			//		See dojo/data/api/Read.getIdentityAttributes()

			return [this.objectStore.idProperty];
		},

		fetchItemByIdentity: function(args){
			// summary:
			//		fetch an item by its identity, by looking in our index of what we have loaded
			var item;
			Deferred.when(this.objectStore.get(args.identity),
				function(result){
					item = result;
					args.onItem.call(args.scope, result);
				},
				function(error){
					args.onError.call(args.scope, error);
				}
			);
			return item;
		},

		newItem: function(data, parentInfo){
			// summary:
			//		adds a new item to the store at the specified point.
			//		Takes two parameters, data, and options.
			// data: Object
			//		The data to be added in as an item.
			// data: Object
			//		See dojo/data/api/Write.newItem()

			if(parentInfo){
				// get the previous value or any empty array
				var values = this.getValue(parentInfo.parent,parentInfo.attribute,[]);
				// set the new value
				values = values.concat([data]);
				data.__parent = values;
				this.setValue(parentInfo.parent, parentInfo.attribute, values);
			}
			this._dirtyObjects.push({object:data, save: true});
			this.onNew(data);
			return data;
		},
		deleteItem: function(item){
			// summary:
			//		deletes item and any references to that item from the store.
			// item:
			//		item to delete

			// If the desire is to delete only one reference, unsetAttribute or
			// setValue is the way to go.
			this.changing(item, true);

			this.onDelete(item);
		},
		setValue: function(item, attribute, value){
			// summary:
			//		sets 'attribute' on 'item' to 'value'
			//		See dojo/data/api/Write.setValue()

			var old = item[attribute];
			this.changing(item);
			item[attribute]=value;
			this.onSet(item,attribute,old,value);
		},
		setValues: function(item, attribute, values){
			// summary:
			//		sets 'attribute' on 'item' to 'value' value
			//		must be an array.
			//		See dojo/data/api/Write.setValues()

			if(!lang.isArray(values)){
				throw new Error("setValues expects to be passed an Array object as its value");
			}
			this.setValue(item,attribute,values);
		},

		unsetAttribute: function(item, attribute){
			// summary:
			//		unsets 'attribute' on 'item'
			//		See dojo/data/api/Write.unsetAttribute()

			this.changing(item);
			var old = item[attribute];
			delete item[attribute];
			this.onSet(item,attribute,old,undefined);
		},

		changing: function(object,_deleting){
			// summary:
			//		adds an object to the list of dirty objects.  This object
			//		contains a reference to the object itself as well as a
			//		cloned and trimmed version of old object for use with
			//		revert.
			// object: Object
			//		Indicates that the given object is changing and should be marked as
			// 		dirty for the next save
			// _deleting: [private] Boolean

			object.__isDirty = true;
			//if an object is already in the list of dirty objects, don't add it again
			//or it will overwrite the premodification data set.
			for(var i=0; i<this._dirtyObjects.length; i++){
				var dirty = this._dirtyObjects[i];
				if(object==dirty.object){
					if(_deleting){
						// we are deleting, no object is an indicator of deletiong
						dirty.object = false;
						if(!this._saveNotNeeded){
							dirty.save = true;
						}
					}
					return;
				}
			}
			var old = object instanceof Array ? [] : {};
			for(i in object){
				if(object.hasOwnProperty(i)){
					old[i] = object[i];
				}
			}
			this._dirtyObjects.push({object: !_deleting && object, old: old, save: !this._saveNotNeeded});
		},

		save: function(kwArgs){
			// summary:
			//		Saves the dirty data using object store provider. See dojo/data/api/Write for API.
			// kwArgs:
			//		- kwArgs.global:
			//		  This will cause the save to commit the dirty data for all
			//		  ObjectStores as a single transaction.
			//
			//		- kwArgs.revertOnError:
			//		  This will cause the changes to be reverted if there is an
			//		  error on the save. By default a revert is executed unless
			//		  a value of false is provide for this parameter.
			//
			//		- kwArgs.onError:
			//		  Called when an error occurs in the commit
			//
			//		- kwArgs.onComplete:
			//		  Called when an the save/commit is completed

			kwArgs = kwArgs || {};
			var result, actions = [];
			var savingObjects = [];
			var self = this;
			var dirtyObjects = this._dirtyObjects;
			var left = dirtyObjects.length;// this is how many changes are remaining to be received from the server
			try{
				connect.connect(kwArgs,"onError",function(){
					if(kwArgs.revertOnError !== false){
						var postCommitDirtyObjects = dirtyObjects;
						dirtyObjects = savingObjects;
						self.revert(); // revert if there was an error
						self._dirtyObjects = postCommitDirtyObjects;
					}
					else{
						self._dirtyObjects = dirtyObjects.concat(savingObjects);
					}
				});
				var transaction;
				if(this.objectStore.transaction){
					transaction = this.objectStore.transaction();
				}
				for(var i = 0; i < dirtyObjects.length; i++){
					var dirty = dirtyObjects[i];
					var object = dirty.object;
					var old = dirty.old;
					delete object.__isDirty;
					if(object){
						result = this.objectStore.put(object, {overwrite: !!old});
						actions.push(result);
					}
					else if(typeof old != "undefined"){
						result = this.objectStore.remove(this.getIdentity(old));
						actions.push(result);
					}
					savingObjects.push(dirty);
					dirtyObjects.splice(i--,1);

				}
				all(actions).then(function(value){
					if(kwArgs.onComplete){
						kwArgs.onComplete.call(kwArgs.scope, value);
					}
				}, function(error){
					if(kwArgs.onError) {
						kwArgs.onError.call(kwArgs.scope, error);
					}
				});

				if(transaction){
					transaction.commit();
				}

			}catch(e){
				kwArgs.onError.call(kwArgs.scope, value);
			}
		},

		revert: function(){
			// summary:
			//		returns any modified data to its original state prior to a save();

			var dirtyObjects = this._dirtyObjects;
			for(var i = dirtyObjects.length; i > 0;){
				i--;
				var dirty = dirtyObjects[i];
				var object = dirty.object;
				var old = dirty.old;
				if(object && old){
					// changed
					for(var j in old){
						if(old.hasOwnProperty(j) && object[j] !== old[j]){
							this.onSet(object, j, object[j], old[j]);
							object[j] = old[j];
						}
					}
					for(j in object){
						if(!old.hasOwnProperty(j)){
							this.onSet(object, j, object[j]);
							delete object[j];
						}
					}
				}else if(!old){
					// was an addition, remove it
					this.onDelete(object);
				}else{
					// was a deletion, we will add it back
					this.onNew(old);
				}
				delete (object || old).__isDirty;
				dirtyObjects.splice(i, 1);
			}

		},
		isDirty: function(item){
			// summary:
			//		returns true if the item is marked as dirty or true if there are any dirty items
			// item: Object
			//		The item to check
			if(!item){
				return !!this._dirtyObjects.length;
			}
			return item.__isDirty;
		},

		// Notification Support

		onSet: function(){
			// summary:
			// 		See dojo/data/api/Notification.onSet()
		},
		onNew: function(){
			// summary:
			// 		See dojo/data/api/Notification.onNew()
		},
		onDelete:	function(){
			// summary:
			// 		See dojo/data/api/Notification.onDelete()
		},
		// an extra to get result sets
		onFetch: function(results){
			// summary:
			// 		Called when a fetch occurs
		}

	}
);
});

},
'appivo/mvc/View':function(){
define(['dojo/_base/lang',
        'dojo/_base/declare',
        'dojo/_base/Deferred',
        'dojo/_base/fx',
        'dojo/fx',
        'dojo/fx/easing',
        'dojo/promise/all',
        'dojo/on',
        'dojo/io-query',
        'dojo/dom-construct',
        'dojo/dom-style',
        'appivo/model/Variables',
        'appivo/ui/GridContainer',
        'appivo/mvc/ActionEngine',
        'appivo/mvc/ActionContext',
        'appivo/mvc/Form',
        'appivo/mvc/Widget',
        'appivo/mvc/FormAttribute',
        'appivo/mvc/FormRelation',
        'appivo/mvc/BaseView',
        'appivo/mvc/ViewState',
        'appivo/mvc/ViewLoader',
        'appivo/builder/LocaleLoader'],

        function(lang, declare, Deferred, baseFx, fx, easing, all, on, ioQuery, domConstruct, domStyle, Variables,
        		 GridContainer, ActionEngine, ActionContext, Form, Widget, FormAttribute, FormRelation, BaseView, ViewState, ViewLoader, LocaleLoader) {
	return declare("appivo.mvc.View", [BaseView], {

		tenantId: null,
		data: null,
		storeManager: null,
		viewManager: null,
		menus: null,
		domNode: null,
		context: null,
		actionEngine: null,
		page: null,
		record: null,
		state: null,
		dynamicStyle: false,
		monitors: null,
		localeData: null,
		closed: false,
		focusFirst: true,
		statusbarColor: null,
		hideStatusBar: null,
		response: null,
		globalRegistry: null,

		constructor: function(options) {
			declare.safeMixin(this, options);
			var t = this;
			this.menus = new Array();
			this.monitors = {};
			this.context = new ActionContext({
				view: this,
				viewManager: this.viewManager,
				page: this.page,
				schema: this.schema,
				response: this.response,
				globalRegistry: function(type, name) {
					return t.globalRegistry ? t.globalRegistry(t, type, name) : null;
				}
			});
			this.actionEngine = new ActionEngine({
				view: this,
				context: this.context
			});

            if (!this.dynamicStyle && this.viewManager.commonView) {
                var cv = this.viewManager.commonView;
                if (cv.data && cv.data.style) {
                    var style = new String(this.data.style);
                    if (style && this.widgetType != "Dialog") {
                        style = cv.data.style + ';' + style;
                    }
                    this.data.style = style;
                }
            }

			var localeLoader = LocaleLoader.getInstance();
			var ld = this.schema.getLocaleData();
			if (ld && ld.data) {
                this.localeData = localeLoader.getProperty('ui.' + this.viewManager.getUserInterfaceName() + '.' + this.data.id, ld.data);
            }
            if (this.data && this.data.label && this.localeData && this.localeData.ViewLabel) {
                this.data.label = this.localeData.ViewLabel;
            }

			this.viewLoader = new ViewLoader({
				actionEngine: this.actionEngine,
				data: this.data,
				uiType: this.uiType,
				schema: this.schema,
				storeManager: this.storeManager,
				localeData: this.localeData,
				tabIndexOffset: this.getTabIndexOffset(),
				visibilityFunc: lang.hitch(this, this._determineVisibility),
				globalStatusBarColor: this.globalStatusBarColor,
				hbsVersion: this.viewManager.getMetaProperty("hbs", 2)
			});
		},

		getTabIndexOffset: function() {
			return 0;
		},

		_completeBootstrapping: function() {
			this.inherited(arguments);
			this.context._completeBootstrapping();
		},

		getPageManager: function() {
			return this.page.getPageManager();
		},

		prepare: function() {
			return this.viewLoader.prepare();
		},

		setState: function(state) {
			this.state = state;
		},

		getState: function() {
			return this.state;
		},

		applyState: function() {
			if (this.viewManager.persistent) {
				console.log("View - applyState");
				var forms = this.state.getForms();
				for (var name in forms) {
					var formData = forms[name];
					var form = this.getForm(name);
					if (form) {
						form.setData(formData);
					}
				}
				var data = this.state.getWidgetValues();
				for (var name in data) {
					var value = data[name];
					var widget = this.widgets[name];
					if (widget) {
						widget.setValue(value);
					}
				}
			}
		},

		updateState: function(info, noupdate) {
			if (!info) {
				info = this.viewManager.page.getRoutingInfo();
			}
			this.state.setRoutingInfo(info, noupdate);
			if (this.viewManager.persistent) {
				for (var name in this.forms) {
					var form = this.forms[name];
					try {
						var data = form.createRecord({
							includeLabels: true,
							keepIds: true,
							nodelete: true
						}).toJSON({
							includeLabels: true,
							resolve: false
						});
						this.state.setFormData(name, data);
					} catch (error) {
						console.error("Failed to persist view-state");
						console.error(error);
					}
				}
				for (var name in this.widgets) {
					var widget = this.widgets[name];
					if (widget.declaredClass == 'appivo.mvc.FormAttribute' ||
						widget.declaredClass == 'appivo.mvc.FormRelation' ||
						widget.declaredClass == 'appivo.mvc.QueryParameter') {
						this.state.setWidgetValue(name, widget.getValue());
						//this._monitorWidget(name, widget);
					}
				}
			}
			return this.state;
		},

		persistState: function(info) {
			this.updateState(info, true);
			this.state.persist();
		},

		monitorState: function() {
			if (this.state && this.viewManager.persistent) {
				for (var name in this.widgets) {
					var widget = this.widgets[name];
					if (widget.declaredClass == 'appivo.mvc.FormAttribute' ||
						widget.declaredClass == 'appivo.mvc.FormRelation' ||
						widget.declaredClass == 'appivo.mvc.QueryParameter') {
						this._monitorWidget(name, widget);
					}
				}
			}
		},

		stopMonitoring: function() {
			for (var key in this.monitors) {
				var handle = this.monitors[key];
				if (handle) {
					handle.unwatch();
				}
			}
			this.monitors = {};
		},

		render: function(domNode, formData, defOverrides, noprepare, options) {
			var ret = new Deferred();
			try {
				this.domNode = domNode;

				var viewDef = this.data;
				if (defOverrides) {
					viewDef = lang.mixin(this.data, defOverrides);
				}

				if (this.dynamicStyle && this.viewManager.commonView) {
					viewDef = lang.clone(viewDef);
					var cv = this.viewManager.commonView;
					if (cv.data && cv.data.style) {
						var style = viewDef.style;
						if (style) {
							style = cv.data.style + ';' + style;
						} else {
							style = cv.data.style;
						}
						viewDef.style = style;
					}
				}

				if (!noprepare) {
					this.viewLoader.prepared = true;
				}

				this.viewLoader.build(viewDef, this, options).then(lang.hitch(this, function (widget) {
					this.widget = widget.widget;
					if (this._viewPort) {
						this.widget._viewPort = this._viewPort;
					}
					this.resetForms();
					if (formData) {
						this.setData(formData).then(lang.hitch(this, function () {
							this._startView();
							ret.resolve(widget);
						}));
					} else {
						this._startView();
						ret.resolve(widget);
					}
				}));
			} catch (error) {
				console.error(error);
				ret.reject(error);
			}
			return ret;
		},

		createWidget: function(elm) {
			this.viewLoader.view = this;
			return this.viewLoader.loadAndCreateWidget(elm, this);
		},

		createContainer: function() {
			this.widget = new GridContainer({
				height: "inherit",
				width: "100%"
			}, this.domNode);
			domStyle.set(this.widget.domNode, 'overflow-y', 'auto');
		},

		goBack: function() {
			return this.viewManager.back();
		},

		_startView: function() {
			console.log("startView: " + this.data.id);
			this.set('style', this.properties['style']);
			if (!this.isCommon && !this.viewManager.isMobile()) {
	 			this.widget.domNode.style.opacity = 0;
			}
			this.widget.startup();
			this.actionEngine.start();
			for (var fn in this.forms) {
				var form = this.forms[fn];
				if (!form.enabled) {
					form._setEnabled(form.enabled);
				}
			}
		},

		_monitorWidget: function(name, widget) {
			var handle = widget.watch('value', lang.hitch(this, function() {
				this.state.setWidgetValue(name, widget.getValue());
			}));
			this.monitors[name] = handle;
		},

		showLoadingIndicator: function(message) {
			this.viewManager.page.pageManager.showLoadingIndicator(null,message);
		},

		hideLoadingIndicator: function() {
			this.viewManager.page.pageManager.hideLoadingIndicator();
		},

		fadeIn: function(duration) {
			var def = new Deferred();
			var anim = baseFx.fadeIn({
				node: this.widget.domNode,
				easing: easing.sineIn,
				duration: duration
			});

			on(anim, "End", function() {
				def.resolve();
			});
			anim.play();
			return def;
		},

		fadeOut: function(duration) {
			var def = new Deferred();
			var anim = baseFx.fadeOut({
				node: this.widget.domNode,
				easing: easing.sineOut,
				duration: duration
			});

			on(anim, "End", function() {
				def.resolve();
			});
			anim.play();
			return def;
		},

		_countProperties: function(obj) {
			var count = 0;
			if (obj) {
				for (var k in obj) {
				    if (obj.hasOwnProperty(k)) {
				       ++count;
				    }
				}
			}
			return count;
		},

		_isId: function(data) {
			var isId = false;
			var propCount = this._countProperties(data);
			if (data && propCount == 1 && data.id) {
				isId = true;
			} else if (data != null && !lang.isObject(data)) {
				isId = true;
			}
			return isId;
		},

		_getId: function(data) {
			var id = null;
			if (lang.isObject(data)) {
				id = data.id;
			} else {
				id = data;
			}
			return id;
		},

		_isRecord: function(data) {
			var ok = false;
			if (data) {
				ok = data.declaredClass == 'appivo.model.Record';
			}
			return ok;
		},

		diffData: function(data) {
			var diff = false;
			if (this._isRecord(data)) {
				diff = true;
			} else if (this.record) {
				diff =  (this.record.id != data.id);
			}
			return diff;
		},

		prepareViewUnload: function () {
			var widgets = this.objectValues(this.widgets);
			for (var i = 0; i < widgets.length; i++) {
				var widget = widgets[i];
				if (widget.prepareViewUnload) {
					try {
						widget.prepareViewUnload();
					} catch (error) {
						console.error(error);
					}
				}
			}
		},

		objectValues: function(obj) {
			var res = [];
			for (var i in obj) {
				if (Object.prototype.hasOwnProperty.call(obj, i)) {
					res.push(obj[i]);
				}
			}
			return res;
		},

		diffQuery: function(query) {
			var diff = false;
			if (query && !this.query) {
				diff = true;
			} else if (!query && this.query) {
				diff = true;
			} else {
				var q1 = ioQuery.objectToQuery(query);
				var q2 = ioQuery.objectToQuery(this.query);
				diff = q1 != q2;
			}
			return diff;
		},

		_isEmpty: function(obj) {
			if (obj) {
			    for(var prop in obj) {
			        if (obj.hasOwnProperty(prop)) {
						return false;
					}
			    }
			}
		    return true;
		},

		setData: function(record) {
			console.log("View: setData called for view " + this.data.id);
			console.log(record);
			var def = new Deferred();
			try {
				var isId = this._isId(record);
				var empty = this._isEmpty(record);
				var form = null;
				if (!empty && !isId) {
					if (record && record.__model) {
						form = this.findForm(record.__model);
					} else {
						form = this.getFirstForm();
					}
					if (form) {
						if (!record.id || !form.mustLoad(record)) {
							form.setData(record);
							def.resolve(record);
						} else {
							form.load(record.id).then(function (record) {
								def.resolve(record);
							}, function(error) {
								def.reject(error);
							});
						}
					} else {
						def.resolve();
					}
				} else if (this.forms != null && !empty) {
					var itemId = this._getId(record);
					form = this.getFirstForm();
					if (form) {
						form.load(itemId).then(function(rec) {
							def.resolve(rec);
						}, function(error) {
							def.reject(error);
						});
					} else {
						def.resolve();
					}
				} else if (empty) {
					form = this.getFirstForm();
					if (form) {
						form.setData({});
					}
					def.resolve();
				} else {
					def.resolve();
				}
				this.record = record;
			} catch (error) {
				console.error(error);
				def.reject(error);
			}
			return def;
		},

		_determineVisibility: function(elm) {
			var visible = true;
			if (elm.features && elm.features.length > 0) {
				for (var i = 0; i < elm.features.length; i++) {
					if (!this.context.hasFeature(elm.features[i])) {
						visible = false;
						break;
					}
				}
			}
			if (visible && elm.privs && elm.privs.length > 0) {
				visible = this.schema.hasUserPrivileges(elm.privs);
			}
			return visible;
		},

		remove: function() {
			this.destroy();
			this.menus = new Array();
			this.children = new Array();
		},

		resize: function() {
			if (this.widget.resize) {
				this.widget.resize();
			}
		},

		scrollTo: function(domNode, animate, offset) {
			if (this.widget.scrollTo) {
				this.widget.scrollTo(domNode, animate, offset);
			}
		},

		resetContext: function() {
			this.context._killAllTimers();
			this.context._resetGlobalData();
		},

		/**
		 * Enables/disables all widgets in the view
		 * @instance
		 * @memberof View
		 * @param {Boolean} enable
		 * @param {Object} opts
		 * @param {Array} opts.included IDs of all widgets to include for enablement/disablement
		 * @param {Array} opts.excluded IDs of all widgets to exclude for enablement/disablement
 		 */
		setEnabled: function(enabled, opts) {
			for (var name in this.widgets) {
				var widget = this.widgets[name];
				if (widget && widget.peer) {
					widget = widget.peer;
					var handle = true;
					if (opts && Array.isArray(opts.included)) {
						handle = opts.included.indexOf(name) >= 0;
					}
					if (opts && Array.isArray(opts.excluded)) {
						handle = !(opts.excluded.indexOf(name) >= 0);
					}
					if (handle && widget && lang.isFunction(widget.setEnabled)) {
						widget.setEnabled(enabled);
					}
				}
			}
		},

		destroy: function() {
			this.closed = true;
			console.log("Destroying View " + this.id);
			this.context._destroy();
			this.inherited(arguments);
			for (var id in this.menus) {
				var menu = this.menus[id];
				console.log("Destroying menu " + id);
				console.log("MenuClass" + menu.declaredClass);
				menu.destroyRecursive();
			}
			for (var i in this.forms) {
				var form = this.forms[i];
				form.destroy();
			}
			delete this.menus;
			this.viewLoader.destroy();
		}
	})
});

},
'appivo/ui/GridContainer':function(){
define(["dojo/_base/kernel", 
        "dojo/_base/lang", 
        "dojo/_base/declare", 
        "dojo/dom-class", 
        "dojo/dom-style", 
        "dojo/dom-construct", 
        "dojo/_base/array", 
        "dojo/dom-prop",
        "dojo/on",
        "dijit/_WidgetBase",
        "dijit/layout/_LayoutWidget",
        "appivo/util/ArrayHelper",
        "sanitize-html/sanitize-html"
],
    function (kernel, lang, declare, domClass, domStyle, domConstruct, arrayUtil, domProp, on, _WidgetBase, _LayoutWidget, ArrayHelper, sanitizeHtml) {

    return declare("appivo.ui.GridContainer", [_LayoutWidget], {
        customClass: "",
        cellWidth: 8,
        cellHeight: 8,
        collapsed: false,
        initCollapse: false,
        inEditor: false,

        buildRendering: function() {
            this.inherited(arguments);
            if (this.titleBar) {
                var title = this.get("title");
                if (!title) {
                    title = "";
                }
                this.titleBarNode = domConstruct.create("div", null, this.domNode);
                this.titleBarNode.classList.add("titleBar");
                this.arrowNode = domConstruct.create("i", null, this.titleBarNode);
                this.titleNode = domConstruct.create("span", null, this.titleBarNode);
                // nosemgrep: insecure-document-method
                this.titleNode.innerHTML = sanitizeHtml.default(title);
                this.arrowNode.classList.add("fa", "fa-chevron-down");
                this.containerNode = domConstruct.create("div", null, this.domNode);
            }
        },
        postCreate: function() {
            this.inherited(arguments);
            this._children = [];
        },
        getTemporarySize: function() {
            var dim = undefined;
            if (this.collapsed) {
                var titleBarHeight = domStyle.get(this.titleBarNode, "height");
                dim = {
                    height: titleBarHeight
                };
            }
            return dim;
        },
        startup: function() {
            var t = this;
            if (!this.cellWidth) {
                this.cellWidth = 8;
            }
            if (!this.cellHeight) {
                this.cellHeight = 8;
            }
            if (this._started) {
                return;
            }
            this.inherited(arguments);
            if (this._initialized) {
                return;
            }

            this._initialized = true;
            domClass.add(this.domNode, "appmachineryGridContainer");
            if (this.titleBarNode) {
                on(this.titleBarNode, "click", function () {
                    t.toggleCollapse();
                });
                if (!this.inEditor && this.initCollapse) {
                    this.collapse();
                }
            }

            this.layout();
            var parent = this.domNode.parentElement;
            var isNestedPanel = parent ? parent.closest(".ap-GridContainer") : false;
            var config = {
                attributeFilter: ["style", "class"],
                childList: true,
                subtree: true,
                characterData: true
            };
            // Check if the panel is the outermost panel
            if (this.id !== "uiBackdrop" && !this.domNode.classList.contains("uipanel") && !isNestedPanel) {
                this.domNode.dataset.parentPanel = true;
            }

            // Check if panel should have autoHeight
            if (!this._editMode) {
                if (this.domNode.dataset.parentPanel) {
                    this.observer = new MutationObserver(function(event) {
                        t.observerCallback(event);
                    });
                    this.observer.observe(this.domNode, config);
                }

                // If panel is not nested within any other panel, observe it
                if (this.autoHeight && this._widget.maximized !== "yes" && this._widget.maximized !== "ver") {
                    this.domNode.dataset.autoHeight = "yes";
                }
            }
            this.autoSizePanel(this.domNode);
        },

        setTitle: function(title) {
            // nosemgrep: insecure-document-method
            this.titleNode.innerHTML = sanitizeHtml.default(title);
        },

        observerCallback: function(mutationList) {
            for (var mutation of mutationList) {
                var target = mutation.target;
                if (target.nodeType === 3) {
                    target = target.parentElement;
                }
                if (target) {
                    var parentElement = target.closest("[data-parent-panel]");
                    if (parentElement) {
                        var autoHeightPanels = Array.from(parentElement.querySelectorAll("[data-auto-height=yes]"));
                        if (parentElement.dataset.autoHeight === "yes") {
                            autoHeightPanels.push(parentElement);
                        }

                        for (var autoHeightPanel of autoHeightPanels) {
                            this.autoSizePanel(autoHeightPanel);
                        }
                    }
                }
            }
        },

        autoSizePanel: function(node) {
            if (node.dataset && node.dataset.autoHeight === "yes") {
                const scrollTop = node.parentNode ? node.parentNode.scrollTop : null;
                node.dataset.forceHeight = "yes";
                var contentHeight = node.scrollHeight;
                var panelHeight = node.offsetHeight;
                if (panelHeight !== undefined) {
                    if (contentHeight > panelHeight) {
                        node.dataset.forceHeight = "no";
                        node.style.height = contentHeight + 10 + "px";
                        if (scrollTop) {
                            node.parentNode.scrollTo(0, scrollTop);
                        }
                    }
                }
            }
        },

        isCollapsed: function() {
            return this.collapsed;
        },
        expand: function() {
            domStyle.set(this.domNode, "height", this.orgHeight + "px");
            this.arrowNode.classList.remove("fa-chevron-right");
            this.arrowNode.classList.add("fa-chevron-down");
            domStyle.set(this.containerNode, 'display', 'block');
            this.collapsed = false;
        },
        collapse: function() {
            this.orgHeight = domStyle.get(this.domNode, "height");
            var titleBarHeight = domStyle.get(this.titleBarNode, "height");
            domStyle.set(this.domNode, "height", titleBarHeight + "px");
            this.arrowNode.classList.add("fa-chevron-right");
            this.arrowNode.classList.remove("fa-chevron-down");
            domStyle.set(this.containerNode, 'display', 'none');
            this.collapsed = true;
        },
        toggleCollapse: function() {
            this.collapsed = !this.collapsed;
            this.domNode.classList.toggle("title-bar-collapsed");
            if (this.collapsed) {
                this.collapse();
            } else {
                this.expand();
            }
        },
        resize: function() {
            //  Summary:
            //  Resizes all children.  This widget itself
            //  does not resize, as it takes up 100% of the
            //  available width.
            arrayUtil.forEach(this.getChildren(), function(child) {
                if(typeof child.resize == "function") {
                    child.resize();
                }
            });
        },
        addChild: function(child) {
            var index = ArrayHelper.findIndex(this._children, function(c) {
                return c._widget.id === child._widget.id;
            });
            if (index > -1) {
                this._children.splice(index, 1);
            }
            this.inherited(arguments);
            if (this._initialized) {
                this.layout();
            }
        },
        removeChild: function(child) {
            var index = ArrayHelper.findIndex(this._children,function(c) {
                return c._widget.id === child._widget.id;
            });
            if (index > -1) {
                this._children.splice(index, 1);
            }
            this.inherited(arguments);
            if (this._initialized) {
                this.layout();
            }
        },
        layout: function() {
            // Summary:
            // Lays out the child widgets.
            if(!this._initialized) {
                return;
            }

            var children = this.getChildren();
            // Call startup on all child widgets
            arrayUtil.forEach(children, function(child){
                if (!child.started && !child._started) {
                    child.startup();
                }
            });

            var childIds = {};
            var _this = this;

            function addCustomClass(node, type, count) {
                if(_this.customClass != "") {
                    var clazz = _this.customClass+ "-" + (type || node.tagName.toLowerCase());
                    domClass.add(node, clazz);

                    if(arguments.length > 2) {
                        domClass.add(node, clazz + "-" + count);
                    }
                }
            }

            // Find any new children that have been added since the last layout() call
            arrayUtil.forEach(this._children, lang.hitch(this, function(child){
                childIds[child.id] = child;
            }));

            arrayUtil.forEach(children, lang.hitch(this, function(child, index){
                if(!childIds[child.id]) {
                    // Add pre-existing children to the start of the array
                    this._children.push(child);
                }
            }));

            // Iterate over the children, adding them to the container
            arrayUtil.forEach(this._children, lang.hitch(this, function(child, index) {
                var pos = child.position;
                if (child.domNode) {
                    if (pos == "undefined" || pos == null) {
                        this.containerNode.appendChild(child.domNode);
                    } else {
                        var xpos = pos.col * this.cellWidth;
                        var ypos = pos.row * this.cellHeight;
                        var zIndex = pos.z !== null && pos.z !== undefined ? pos.z : 2;
                        var node = child.domNode;
                        if (child._dragNode) {
                            node = child._dragNode;
                        }
                        domStyle.set(node, "position", "absolute");
                        domStyle.set(node, "top", ypos + "px");
                        domStyle.set(node, "left", xpos + "px");
                        domStyle.set(node, "zIndex", zIndex);
                        domClass.add(node, "appmachineryGridContainerChild");

                        if (pos.width && pos.height) {
                            var width = pos.width * this.cellWidth;
                            var height = pos.height * this.cellHeight;
                            if (child.getTemporarySize) {
                                var dim = child.getTemporarySize();
                                if (dim) {
                                    if (dim.width !== undefined) {
                                        width = dim.width;
                                    }
                                    if (dim.height !== undefined) {
                                        height = dim.height;
                                    }
                                }
                            }

                            domStyle.set(node, "width", width + "px");
                            domStyle.set(node, "height", height + "px");
                        }
                        if (child._widget) {
                            child._widget._setSize({
                                x: xpos,
                                y: ypos,
                                w: width,
                                h: height
                            });
                        }
                        if (child.domNode.parentNode != this.containerNode) {
                            this.containerNode.appendChild(child.domNode);
                        }
                    }
                }
            }));

            // Refresh the layout of any child widgets, allowing them to resize to their new parent.
            arrayUtil.forEach(children, function(child) {
                if (typeof child.layout == "function") {
                    child.layout();
                }
            });
            this.resize();
        },
        _setCellWidthAttr: function(cellWidth) {
            if (cellWidth) {
                this.cellWidth = cellWidth;
            }
        },
        _setCellHeightAttr: function(cellHeight) {
            if (cellHeight) {
                this.cellHeight = cellHeight;
            }
        },
        _setInitCollapseAttr: function(collapsed) {
            this.initCollapse = collapsed;
        },
        clear: function() {
            this.destroyDescendants(false);
            this._widget = [];
            this._children = [];
            this.children = [];
        },
        destroyDescendants: function(/*Boolean*/ preserveDom) {
            //  Summary:
            //  Destroys all the widgets inside this.containerNode,
            //  but not this widget itself
            arrayUtil.forEach(this.getChildren(), lang.hitch(this, function (child) {
                if (!preserveDom){
                    this.removeChild(child);
                }
                child.destroyRecursive(preserveDom);
            }));
        },
        destroy: function() {
            if (this.observer) {
                this.observer.disconnect();                
            }
            this.inherited(arguments);
        }
    })
});

},
'appivo/util/ArrayHelper':function(){
define(["dojo/_base/declare"], function(declare) {
	var helper = {
	    findIndex: function(array, func){
              if (array == null) {
                return null;
              }
              if (typeof func !== 'function') {
                console.error("func must be a function");
                return null;
              }

              var length = array.length >>> 0;
              for (var i = 0; i < length; i++) {
                value = array[i];
                if (func(value)) {
                  return i;
                }
              }
              return -1;
	    },
	    find: function(array, func){
            if (array == null) {
                return null;
            }
            if (typeof func !== 'function') {
                console.error("func must be a function");
                return null;
            }
            var length = array.length >>> 0;
            for (var i = 0; i < length; i++) {
                value = array[i];
                if (func(value)) {
                    return value;
                }
            }
            return undefined;
	    }
	};
	return helper;
});


},
'appivo/mvc/ViewState':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'dojo/_base/Deferred',
        'dojo/io-query',
        'flatted/flatted'], 

        function(lang, declare, Deferred, ioQuery, flatted) {
	return declare("appivo.mvc.ViewState", [], {

		app: null,
		ui: null,
		view: null,
		id: null,
		query: null,
		widgets: null,
		forms: null,
		updateScheduled: false,
		name: '',
		device: 'desktop',
		autoPersist: true,
		client: null,
		
		constructor: function(data) {
			lang.mixin(this, data);
			if (!this.widgets) {
				this.widgets = {};
			}
			if (!this.forms) {
				this.forms = {};
			}
		},
		
		_setName: function(name) {
			this.name = name;
		},
		
		_setDevice: function(device) {
			this.device = device;
		},
		
		getDevice: function() {
			return this.device;
		},
		
		getPath: function() {
			var str = this.app + '/' + this.ui + '/' + this.view;
			if (this.id) {
				str = str + '/' + this.id;
			}
			if (this.query) {
				str = str + '/?' + ioQuery.objectToQuery(this.query);
			}
			return str;
		},
				
		setRoutingInfo: function(info, noupdate) {
			this.app = info.app;
			this.ui = info.ui;
			this.view = info.view;
			this.id = info.id;
			this.query = info.query;
			if (!noupdate) {
				this.update();				
			}
		},
		
		getRoutingInfo: function() {
			return {
				app: this.app,
				ui: this.ui,
				view: this.view,
				id: this.id,
				query: this.query
			};
		},
		
		setWidgetValue: function(widget, value) {
			if (value == undefined || value == null) {
				delete this.widgets[widget];
			} else {
				this.widgets[widget] = value;
			}
			this.update();
		},
		
		getWidgetValues: function() {
			return this.widgets;
		},
		
		setFormData: function(name, data) {
			this.forms[name] = data;
		},
		
		getForms: function() {
			return this.forms;
		},
		
		getFormData: function(name) {
			return this.forms[name];
		},
		
		update: function() {
			if (!this.updateScheduled && this.autoPersist) {
				this.updateScheduled = true;
				setTimeout(lang.hitch(this, this.doUpdate), 200);
			}
		},

		doUpdate: function() {
			this.updateScheduled = false;
			this.persist();
		},

		persist: function() {
			var state = this.toJSON();
			console.log("Persisting view-state");
			try {
				var str = "f:" + flatted.stringify(state);
				window.localStorage.setItem(this.name, str);
			} catch (e) {
				console.error("Error persisting view-state: " + e.message);
			}
		},
				
		toJSON: function() {
			var json = {
				device: this.device,
				app: this.app,
				ui: this.ui,
				view: this.view,
				id: this.id,
				query: this.query,
				widgets: this.widgets,
				forms: this.forms
			};
			return json;
		}
	});
});
},
'appivo/mvc/ViewLoader':function(){
	define(['dojo/_base/lang',
		'dojo/promise/all',
        'dojo/_base/declare',
        'dojo/Deferred',
        'dojo/when',
        'dojo/Evented',
        'dojo/on',
        'dojo/string',
        'dojo/_base/window',
        'dojo/dom-construct',
        'dojo/dom-class',
        'dojo/store/Observable',
        'dojo/store/Memory',
        'dijit/Menu',
        'dijit/MenuItem',
        'dijit/PopupMenuItem',
		'appivo/mvc/WidgetDefinitions',
		'appivo/util/Handlebars',
        'appivo/ui/BrokenWidget',
        'appivo/model/Variables',
        'appivo/client/Client',
        'appivo/util/Identity',
        'appivo/mvc/BrokenWidget',
        'appivo/store/StoreManager',
        'appivo/mvc/Form',
        'appivo/mvc/Widget',
        'appivo/mvc/FormAttribute',
        'appivo/mvc/FormRelation',
        'appivo/mvc/FormDocument',
        'appivo/mvc/FormData',
        'appivo/mvc/QueryParameter',
        'appivo/mvc/QueryDisplay'
        ], function(lang, all, declare, Deferred, when, Evented, on, string, win, domConstruct, domClass, Observable, Memory, Menu, MenuItem, PopupMenuItem, WidgetDefinitions, Handlebars, UIBrokenWidget, Variables, Client, Identity, BrokenWidget) {

	var strToObj = function(cssText) {
		var regex = /([\w-]*)\s*:\s*([^;]*)/g;
		var match, properties={};
		while (match=regex.exec(cssText)) {
			properties[match[1]] = match[2].trim();
		}
		return properties;
	};

	var brokenCounter = 0;
	var client = Client.getInstance();

	var clss = declare("appivo.mvc.ViewLoader", [Evented], {

		baseUri: '/api',
		uiType: 'desktop',
		_prepared: null,
		prepared: false,
		data: null,
		localeData: null,
		schema: null,
		menus: null,
		name: null,
		client: null,
		appConfig: null,
		storeManager: null,
		actionEngine: null,
		listeners: null,
		editor: null,
		definitions: null,
		_currentParent: null,
		_currentDomNode: null,
		ignoreErrors: true,
		bodyNode: null,
		tabIndexOffset: 0,
		varContext: null,
		hbsVersion: 2,
		mobile: client.isMobile(),

		_recordMap: {
			"tenant":	true,
			"user":		true,
			"group":	true
		},

		constructor: function(options) {
			lang.mixin(this, options);
			this.idMap = {};
			this.menus = {};
			this.globalRegistry = {};
			this.listeners = new Array();
			this.client = Client.getInstance();
			this.appConfig = client.getAppConfig();
			this.definitions = WidgetDefinitions;
			this.storeManager = appivo.store.StoreManager.getInstance();
			this.varContext = {};
			lang.mixin(this.varContext, this.schema.getStrings());
			this.varContext.config = this.appConfig;
			this.varContext.tenant = this.client.getTenantInfo();

			if (!this.styleManager) {
				this.styleManager = StyleManager;
			}
			if (!this.bodyNode) {
				this.bodyNode = win.body();
			}
		},

		isPrepared: function() {
			return this.prepared;
		},

		prepare: function() {
			var map = this.traverseWidgets(this.data);
			return this.loadWidgets(map);
		},

		prepareAll: function() {
			if (!this.prepared) {
				var map = {
					_widgets: {}
				};
				var defs = this.definitions.getDefinitions(this.uiType);
				for (var i in defs) {
					var def = defs[i];
					map._widgets[def.name] = true;
					if (def.requiredClasses) {
						for (var j in def.requiredClasses) {
							map[j] = true;
						}
					}
				}
				this._prepared = this.loadWidgets(map);
			}
		},

		traverseWidgets: function(elm) {
			var map = {
				_widgets: {}
			};
			this.addRequiredClasses(elm, map);
			return map;
		},

		addRequiredClasses: function(elm, map) {
			if (!map._widgets[elm.widgetType]) {
				var widget = this.definitions.getWidgetDef(elm.widgetType, this.uiType);
				if (widget) {
					map._widgets[widget.name] = true;
					if (widget.requiredClasses) {
						for (var i in widget.requiredClasses) {
							var name = widget.requiredClasses[i];
							map[name] = true;
						}
					}
				} else {
					console.log("Unknown widget " + elm.widgetType);
					/*
					throw {
						error: 'UnknownWidgetError',
						message: 'Found widget with unsupported type ' + elm.widgetType
					}
					*/
				}
			}
			if (elm.children) {
				for (var i in elm.children) {
					this.addRequiredClasses(elm.children[i], map);
				}
			}
		},

		loadWidgets: function(map) {
			var classNames = new Array();
			for (var name in map) {
				if ('_widgets' != name) {
					classNames.push(name);
				}
			}
			var def = new Deferred();
			var t = this;
			require(classNames, function() {
				for (var i in arguments) {
					var cls = arguments[i];
					var name = classNames[i];
					map[name] = cls;
				}

				var widgets = map._widgets;
				for (var name in widgets) {
					var wdef = t.definitions.getWidgetDef(name, t.uiType);
					wdef.loadedClasses = {};
					for (var j in wdef.requiredClasses) {
						var req = wdef.requiredClasses[j];
						var cls = map[req];
						wdef.loadedClasses[req] = cls;
					}
				}

				t.prepared = true;
				def.resolve(map);
			});
			return def;
		},

		loadAndCreateWidget: function(elm, parent, domNode) {
			var def = new Deferred();
			var map = this.traverseWidgets(elm);
			var t = this;
			this.loadWidgets(map).then(function() {
				var widget = t.createWidget(elm, null, parent, domNode);
				when(widget, function(widget) {
					if (elm.children) {
						t._build0(elm, widget).then(function () {
							def.resolve(widget);
						});
					} else {
						def.resolve(widget);
					}
				});
			}, function(error) {
				def.reject(error);
			});
			return def;
		},

		build: function(container, view) {
			this.view = view;
			var prep = null;
			if (!this.prepared) {
				prep = this.prepare();
			} else {
				prep = new Deferred();
				prep.resolve();
			}
			var def = new Deferred();
			var t = this;
			prep.then(function() {
				try {
					var result = prep.promise;
					if (prep.isResolved()) {
						var children = container.children;
						delete container.children;
						t.loadAndCreateWidget(container, t.view, t.view.domNode).then(function(viewWidget) {
							container.children = children;
							t._build0(container, viewWidget).then(function () {
								def.resolve(viewWidget);
							},function (error) {
								console.log("Error : ",error);
								def.reject(error);
							});
						}, function(error) {
							def.reject(error);
						});
					} else {
						def.reject(result);
					}
				} catch (err) {
					console.error(err);
					def.reject(err);
				}
			});
			return def;
		},

		isVisible: function(elm) {
			var visible = true;
			if (this.visibilityFunc) {
				visible = this.visibilityFunc(elm);
			}
			return visible;
		},

		_build0: function(container, parent, peerContext) {
			var org = new Deferred();
			var t = this;
			var promiseCollection = [];

			for (var i in container.children) {
				var elm = container.children[i];
				if (this.isVisible(elm)) {
					var widget = t.createWidget(elm, peerContext, parent).promise.catch(function (error) {
						if (!t.ignoreErrors) {
							org.reject(error);
						} else {
							console.log("Ignoring error");
							org.resolve(null);
						}
					});
					promiseCollection.push({widget: widget, elm: elm});
				}
			}

			if (promiseCollection.length > 0) {
				var promises = promiseCollection.map(function (item) {
					return item.widget;
				});

				all(promises).then(function (results) {
					var list = [];
					results.forEach(function (widgetResult, index) {
						if (widgetResult) {
							var elm = promiseCollection[index].elm;
							if (elm.children && elm.children.length > 0) {
								var toReturn = t._build0(elm, widgetResult, peerContext);
								list.push(toReturn);
								parent.addChild(widgetResult);
							} else {
								parent.addChild(widgetResult);
							}
						}
					});
					if (list.length > 0) {
						all(list).then(function (results) {
							org.resolve();
						});
					} else {
						org.resolve();
					}
				});
			} else {
				org.resolve();
			}
			return org;
		},

		getParent: function() {
			return this._currentParent;
		},

		createMenu: function() {
			return new dijit.Menu({});
		},

		createPopupMenu: function(item) {
			return new dijit.PopupMenuItem({
				label: item.label,
				popup: item.menu
			});
		},

		createMenuItem: function(item) {
			return new dijit.MenuItem({
				label: item.label,
				onClick: item.onClick
			});
		},

		attachCustomMenu: function(widget, menu) {
			var def = widget.getWidgetDefinition();
			if (def.getCustomMenuItems) {
				var func = lang.hitch(def, def.getCustomMenuItems);
				var items = func(this, widget, menu);
				if (items) {
					for (var i in items) {
						var item = items[i];
						menu.addChild(item);
					}
				}
			}
		},

		getStatusBarColor: function() {
			return this.globalStatusBarColor;
		},

		_transformValue: function(val) {
			if (!val) {
				val = '';
			}
			return val;
		},

		_processWidgetProperties: function(widgetData, elm, ld, props) {
			for (var key in props) {
				var cval = widgetData[key];
				var prop = props[key];
				if ((cval === undefined || cval === null) && prop.defaultValue !== undefined && prop.defaultValue !== null) {
					var apply = true;
					if (prop.defaultValue._for) {
						apply = prop.defaultValue._for === this.uiType;
					}
					if (apply) {
						widgetData[key] = prop.defaultValue;
					}
				}
				if (prop.localizable) {
					if (prop.injectLocalizedProperties) {
						if (ld) {
							prop.injectLocalizedProperties(widgetData[key], ld, this.schema);
						} else {
							prop.injectLocalizedProperties(widgetData[key], null, this.schema);
						}
					} else {
						if (widgetData[key]) {
							if (ld && ld[key]) {
								widgetData[key] = ld[key];
							}
							widgetData[key] = this.schema.replaceTerms(widgetData[key], this.varContext);
						}
					}
				}
				if (prop.dynamic) {
					var val = widgetData[key];
					if (val) {
						widgetData[key] = string.substitute(val, this.appConfig, this._transformValue);
					}
				} else if (prop.type == 'IMAGE_PARAM') {
					var param = widgetData[key];
					var paramDef = null;
					for (var i in this.schema.params) {
						var p = this.schema.params[i];
						if (param == p.name) {
							paramDef = p;
							break;
						}
					}
					val = this.appConfig[param];
					if (!val && this.isEditor() && paramDef && paramDef.defaultValue !== undefined && paramDef.defaultValue !== null) {
						val = paramDef.defaultValue;
					}
					if (val) {
						val = '/files/' + val;
					}
					widgetData[key] = val;
					widgetData[key + ".org"] = param;
					if (paramDef && paramDef.data) {
						widgetData[key + ".width"] = paramDef.data.width;
						widgetData[key + ".height"] = paramDef.data.height;
					}
				} else if (prop.type == 'IMAGE_RESOURCE' || prop.type == 'VIDEO_RESOURCE') {
					var val = widgetData[key];
					var src = '/resources/';
					var schema = this.schema;
					var checksum = val;
					var rsrc = schema.getResourceById(val);
					// REMIND: Temporary upgrade ID -> Filename
					if (rsrc) {
						elm[key] = rsrc.checksum;
						val = rsrc.checksum;
					}

					if (rsrc && Identity.isTempId(schema.id)) {
						src = '/files/' + rsrc.checksum;
					} else if (checksum) {
						src += schema.getName() + '/' + checksum;
					} else {
						// Missing image
						src = undefined;
					}
					widgetData[key] = src;
					widgetData[key + ".org"] = val;
				}
			}
		},

		createWidget: function(elm, peerContext, parent, domNode) {
			var t = this;
			this._currentDomNode = domNode;
			var ret = new Deferred();
			if (!elm.id) {
				elm.id = this.view.generateIntegerId(elm.widgetType);
			}
			var def = this.definitions.getWidgetDef(elm.widgetType, this.uiType);
			var widget = null;
			if (def) {
				if (!def.create) {
					ret.reject("Widget-type " + def.name + " doesn't have a create-function");
					return ret;
				}
				var widgetType = def.determineType(elm);
				if (widgetType && def.typeProperties) {
					var typeProps = def.typeProperties[widgetType];
				}

			    var form = null;
			    if (elm.formName) {
					form = this.view.getForm(elm.formName);
				}
				var func = lang.hitch(def, def.create);
				try {
					this._currentParent = parent;
					var widgetData = JSON.parse(JSON.stringify(elm));
					widgetData.handlers = elm.handlers;
					if (!widgetData.__resolved) {
						var ld = this.localeData ? this.localeData[elm.id] : null;
						this._processWidgetProperties(widgetData, elm, ld, def.properties);
						if (typeProps) {
							this._processWidgetProperties(widgetData, elm, ld, typeProps);
						}
						widgetData.__resolved = true;
					}

					// Check for broken forms
                    if (widgetData.attributeName && (!form || form.getModel() == null || form.getModel().getAttribute(widgetData.attributeName) == null)) {
                        widgetData.attributeName = null;
                    } else if (widgetData.relationName && (!form || form.getModel() == null)) {
						widgetData.relationName = null;
					} else if (form) {
						// Check relation exists
						try {
							form.getModel().getRelationship(widgetData.relationName);
						} catch(e) {
							widgetData.relationName = null;
						}
					}

					widget = func(this, widgetData, form);
					if (!widget) {
						console.log(def.name + "-widget create-function returned null")
						ret.reject("Failed to create widget " + def.name + " id: " + elm.id);
						return ret;
					}
				} catch (werror) {
					console.log("Widget " + elm.id + " has an invalid configuration and cannot be instantiated.");
					console.log(werror);
					console.trace();
					if (this.isEditor()) {
					    var cElm = lang.clone(elm);
					    var uiWidget = new UIBrokenWidget();
						widget = new BrokenWidget({
						    id: elm.id,
						    widgetDef: def,
						    widget: uiWidget,
						    elm: cElm
						});
					} else {
						ret.reject('Failed to create widget of type ' + def.name + ' id: ' + elm.id);
						return ret;
					}
				}

				//
				// REMIND: Hookup Custom Menu Items
				//
				when(widget, function(widget) {
					if (widget.resizable === undefined) {
						widget.resizable = def.resizable;
					}
					widget.setView(t.view);
					widget.actionEngine = t.actionEngine;
					widget.setWidgetDefinition(def);
					widget.setProperties(widgetData);
					if (def.maximizable) {
						widget.maximizable = true;
					}
					if (form != null) {
						form.addChild(widget);
					}

					widget.widget.domNode.setAttribute("data-wid", elm.id);
					domClass.add(widget.widget.domNode, 'ap-' + def.name);

					if (t.isEditor() && def.editClass) {
						domClass.add(widget.widget.domNode, def.editClass);
					}

					if (t.styleManager) {
						widget.styleManager = t.styleManager;
					}

					var selectedTheme = {};

					if (t.view) {
						selectedTheme = t.view.getBaseTheme();
					}

					if (!widgetData.styleProps || Object.keys(widgetData.styleProps) == 0) {
						widgetData.styleProps = {};
					}
					widget._selectedTheme = selectedTheme;
					widget.setStyleProps(widgetData.styleProps);
					widget.orgStyleProps = widgetData.styleProps;

					if (widgetData.maxi && widgetData.maxi !== "no") {
						widget.maximize(widgetData.maxi);
					} else {
						var wp = widgetData.position;
						if (wp != null && wp != 'undefined' && t.editor != null || def.noSize  || def.noSizeY || def.noSizeX) {
							if (wp && (wp.height == -1 || wp.height == 0 || def.noSize  || def.noSizeY)) {
								delete wp.height;
							}
							if (wp && (wp.width == -1 || wp.width == 0 || def.noSize || def.noSizeX)) {
								delete wp.width;
							}
							if (t.isEditor()) {
								widget.widget._onDrop = lang.hitch(t.editor, t.editor._addWidgetToContainer);
							}
							widget.widget.position = wp
						} else if (wp) {
							widget.widget.position = wp;
						}
						if (t.isMobile() && def.noSizeXMobile) {
							delete wp.width;
						}
						if (wp && parent && parent.widgetDef && parent.widgetDef.noPositioning) {
							delete wp.col;
							delete wp.row;
						}
						widget.set('position', wp);
					}
                    if (widgetData.style) {
                        widget.set('style', widgetData.style);
						var _compiled = Handlebars.compile(widgetData.style);
						var _updatedStyleStr = _compiled(selectedTheme);
						var udpatedCssObj = strToObj(_updatedStyleStr);
						var style = widget.widget.domNode.style;
						var orgCss = style.cssText;
						orgCss = strToObj(orgCss);
						if (orgCss['opacity'] == '0') {
							delete orgCss['opacity'];
						}
						// var css = lang.mixin({}, orgCss);
						// nosemgrep: insecure-object-assign
						var css = Object.assign({}, orgCss)
						// lang.mixin(css, udpatedCssObj);
						// nosemgrep: insecure-object-assign
						css = Object.assign(css, udpatedCssObj);

						var cssStr = '';
						var i = 0;
						for (var key in css) {
							if  (i > 0) {
								cssStr += ';';
							}
							i++;
							var val = css[key];
							cssStr += key + ": ";
							cssStr += val;
						}
						widget.widget.domNode.style.cssText = cssStr;
                    }

					if (widgetData.tabIndex) {
						var ti = t.tabIndexOffset + widgetData.tabIndex;
						widget.widget.set('tabIndex', ti);
					}

					if (!widget.peer) {
						var widgetPeer = null;
						if (peerContext) {
							widget.peer = peerContext;
						} else {
							widget.createPeer();
						}
					}

					if (widgetData.hidden) {
						widget._hidden = true;
						widget.peer.hide();
					}

					widget.setHandlers(widgetData.handlers);

					if (widgetData._noOverlay) {
						widget._noOverlay = true;
					}
					t.view.registerWidget(widget);
					// lazy loading only in preview mode
					if (t.editor) {
						ret.resolve(widget);
					} else {
						setTimeout(function () {
							ret.resolve(widget);
						}, 0);
					}
				}, function(error) {
					ret.reject(error);
				});
			} else {
				// error
				console.error("Unknown widget-type: " + elm.widgetType);
				ret.reject("Attempt to create widget of unknown type " + elm.widgetType);
			}
			return ret;
		},

		getMetaProperty: function(key, def) {
			var val = def;
			switch (key) {
				case 'hbsVersion':
					val = this.hbsVersion;
					break;
			}
			return val;
		},

		changeTheme:function (updatedTheme) {
			this.view.theme = updatedTheme;
			var viewThemeId = this.view.theme;
			var selectedTheme = {};
			if (this.view) {
				selectedTheme = this.view.getBaseTheme();
			}
			if (!selectedTheme && updatedTheme == "custom") {
				selectedTheme = this.view.viewManager.ui.theme;
			}
			for (var widgetIndex in this.view.widgets) {
				var w = this.view.widgets[widgetIndex];
				w.styleManager.unsetWidgetStyle(w);

				var themeStyles = {};
				var oldTheme = w.styleProps;
				if (w.styleProps) {
					w.widget._widget._selectedTheme = selectedTheme;
					w.widget._widget.setStyleProps(w.styleProps);
					w.styleProps = oldTheme;
				}
				if (w.style) {
					var _compiled = Handlebars.compile(w.style);
					var _updatedStyleStr = _compiled(selectedTheme);
					var udpatedCssObj = strToObj(_updatedStyleStr);
					var style = w.widget.domNode.style;
					var orgCss = style.cssText;
					orgCss = strToObj(orgCss);
					if (orgCss['opacity'] == '0') {
						delete orgCss['opacity'];
					}
					var css = lang.mixin({}, orgCss);
					lang.mixin(css, udpatedCssObj);
					var cssStr = '';
					var i = 0;
					for (var key in css) {
						if  (i > 0) {
							cssStr += ';';
						}
						i++;
						var val = css[key];
						cssStr += key + ": ";
						cssStr += val;
					}
					w.widget.domNode.style.cssText = cssStr;
				}
				if (w.widget.htmlTemplate){
					var compiled = Handlebars.compile(w.widget.htmlTemplate);
					var updatedStyleStr = compiled(selectedTheme);
					w.widget.cachedHtml = updatedStyleStr;
					// nosemgrep: insecure-document-method
					w.widget.htmlNode.innerHTML = updatedStyleStr;
				}
			}
		},

		isEditor: function() {
			return this.editor != null;
		},

		isMobile: function() {
			return this.mobile;
		},

		getView: function() {
			return this.view;
		},

		getActionContext: function() {
			return this.actionEngine.getContext();
		},

		getSchema: function() {
			return this.schema;
		},

		getAppConfig: function() {
			return this.appConfig;
		},

		getQuery: function(name) {
			return this.schema.getQueryByName(name);
		},

		getQueryHandle: function(name, force, options) {
			return this.view.getQueryHandle(name, force, options);
		},

		getQueryParameter: function(name) {
			var dot = name.indexOf('.');
			var qname = name.substring(0, dot);
			var pname = name.substring(dot + 1);
			var query = this.schema.getQueryByName(qname);
			var param = null;
			if (query) {
				param = query.getParameter(pname);
			}
			return param;
		},

		getQueryParameterDefault: function(name) {
			var value = null;
			var param = this.getQueryParameter(name);
			if (param) {
				if (param.defaultVariable) {
					value = Variables.resolveVariable(param.defaultValue);
				} else {
					value = param.defaultValue;
				}
			}
			return value;
		},

		getModel: function(id) {
			if (id == null || id == undefined) {
				throw {
					name: 'InvalidModelIDError',
					message: 'Trying to get model with id ' + id
				}
			}
			var slash = id.lastIndexOf("/");
			if (slash >= 0) {
				id = id.substring(slash + 1);
			}
			return this.schema.getModel(id);
		},

		getAttribute: function(form, name) {
			var model = form.getModel();
			var schema = model.getSchema();
			return model.getAttribute(name);
		},

		getRelation: function(form, name) {
			var model = form.getModel();
			var schema = model.getSchema();
			return model.getRelationship(name);
		},

		createRecordURI: function(model) {
			return this.view.createRecordURI(model);
		},

		getStoreManager: function() {
			return this.storeManager;
		},

		getCurrentDomNode: function() {
			return this._currentDomNode;
		},

		getBody: function() {
			return this.bodyNode;
		},

		createFunction: function(signature, script) {
			var func = null;
			try {
				func = new Function("return function exec(" + signature + "){" +  script + "}")();
			} catch (error) {
				console.error(error);
			}
			return func;
		},

		newWidgetDefinition: function(type) {
			var id = Math.random();
			if (this.view.generateId) {
				id = this.view.generateId(type);
			}
			var elm = {
				id: id,
				widgetType: type
			};
			return elm;
		},

		connectEventHandler: function(menuItem, event, script) {
			this.view.connectEventHandler(menuItem, event, script);
		},

		buildMenu: function(elm, contextWidget) {
			var t = this;
			var contextPeer = contextWidget.peer;
			var menu = this.createWidget(elm);
			when(menu, function(menu) {
				if (elm.children) {
					t._build0(elm, menu, contextPeer);
				}
			});
			return menu;
		},

		destroy: function() {
			for (var id in this.menus) {
				var menu = this.menus[id];
				menu.destroyRecursive();
			}
			for (var i in this.listeners) {
				var listener = this.listeners[i];
				listener.remove();
			}
		}
	});

	clss.getInstance = function() {
		if (clss._instance == null) {
			clss._instance = new clss();
		}
		return clss._instance;
	};

	return clss;
});

},
'appivo/ui/BrokenWidget':function(){
define([
     "dojo/_base/declare",
     "dijit/_WidgetBase",
     'dojo/dom-construct',
 ], function(declare, _WidgetBase, domConstruct) {

	return declare("appivo.ui.Icon", [_WidgetBase], {

        startup: function() {
            this.inherited(arguments);
        },

        destroy: function() {
            this.inherited(arguments);
		},

		buildRendering: function() {
			this.domNode = domConstruct.create("div");
		}
	});
 });

},
'appivo/mvc/BrokenWidget':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'dojo/dom-construct',
        'appivo/mvc/Widget'], function(lang, declare, DomConstruct, Widget) {
	return declare("appivo.mvc.BrokenWidget", [appivo.mvc.Widget], {
		
		elm: null,
		
		constructor: function(options) {
			lang.mixin(this, options);
			this.children = new Array();
			this.orgType = options.widgetType;
			this.widgetType = 'BROKEN';
		},
			
		serialize: function() {
			return lang.clone(this.elm);
		}
	});
});
},
'appivo/mvc/FormData':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'appivo/mvc/Widget'], function(lang, declare, Widget) {
	return declare("appivo.mvc.FormData", [appivo.mvc.Widget], {
				
		constructor: function(options) {
			lang.mixin(this, options);
			this.children = new Array();
			this.widgetType = 'FORM';
		},

		build: function() {

		}
	});
});
},
'appivo/builder/LocaleLoader':function(){
define([ 'dojo/_base/lang', 
         'dojo/_base/declare', 
         'dojo/on', 
         'dojo/string',
         'dojo/_base/window', 
         'appivo/mvc/Form',
         'appivo/mvc/Widget', 
         'appivo/mvc/WidgetDefinitions' ],
    
         function(lang, declare, on, string, win, Form, Widget, WidgetDefinitions) {

		var clss = declare("appivo.builder.LocaleLoader", null, {

		schema: null,
		count: 0,
		definitions : null,

		constructor : function(options) {
			lang.mixin(this, options);
			this.definitions = WidgetDefinitions;
		},

		traverseMenu: function(elm, map, uiname, uitype) {
			var menu = elm.menu;
			if (menu) {
				this.traverseWidgets(menu, map, uiname , uitype, true);				
			}
		},
		
		traverseView: function(elm, map, uiname, uitype) {
			this.traverseWidgets(elm, map, uiname, uitype, false);
			this.setProperty(uiname + '.ViewLabel', elm.label, map);
			return map;
		},
		
		traverseWidgets : function(elm, map, uiname, uitype, nest) {
			this.addLocalizedMappings(elm, map, uiname, uitype, nest);
			return map;
		},
		
		trim: function(map) {
			if (!map) {
				map = this.map;
			}
			for (var name in map) {
				var node = map[name];
				if (node == null || node == '') {
					delete map[name];
				} else if (lang.isObject(node)) {
					this.trim(node);
					if (Object.keys(node).length == 0) {
						delete map[name];
					}
				} 
			}
		},
		
		merge: function(data, path, name) {
			if (!path) {
				path = name;
			} else {
				path = path + '.' + name;
			}
			for (var name in data) {
				obj = data[name];
				if (lang.isObject(obj) || lang.isArray(obj)) {
					this.merge(obj, path, name)
				} else {
					this.setProperty(path + '.' + name, obj);
				}
			}
		},

		setProperty: function(path, value, map) {
			if (!map) {
				map = this.map;
			}
			var parts = path.split('.');
			var context = map;
			for (var i = 0; i < parts.length - 1; i++) {
				var name = parts[i];
				var current = context[name];
				if (!current) {
					current = {};
					context[name] = current;
				}
				context = current;
			}
			current[parts[parts.length -1]] = value;
			this.count++;
		},
		
		getProperty: function(path, map) {
			if (!map) {
				map = this.map;
			}
			var value = null;
			var parts = path.split('.');
			var context = map;
			for (var i = 0; i < parts.length; i++) {
				var name = parts[i];
				// nosemgrep: prototype-pollution-loop
				context = context[name];
				if (!context) {
					break;
				}
			}
			return context;
		},
		
		getKeyValuePairs: function(path) {
			var list = new Array();
			var obj = this.getProperty(path);
			for (var name in obj) {
				this._getValue(obj, list, path, name);
			}
			return list;
		},
		
		_getValue: function(obj, list, path, name) {
			path += '.' + name;
			var val = obj[name];
			if (lang.isObject(val) || lang.isArray(val)) {
				for (var part in val) {
					this._getValue(val, list, path, part)
				}
			} else {
				list.push({
					key: path,
					original: val
				});
			}
		},
		
		addLocalizedMappings : function(elm, map, keyStr, uiType, nest) {
			var ckey = keyStr + "." + elm.id;
			var widget = this.definitions.getWidgetDef(elm.widgetType, uiType);
			if (widget) {
				for (var name in widget.properties) {
					var prop = widget.properties[name];
					if (prop.localizable && elm[name]) {
						this._localizeProperty(name, prop, widget, ckey, map, elm);
					}
				}
				
				if (widget.typeProperties) {
					for (var typeName in widget.typeProperties) {
						var typeProps = widget.typeProperties[typeName];
						for (var name in typeProps) {
							var prop = typeProps[name];
							if (prop.localizable && elm[name]) {
								this._localizeProperty(name, prop, widget, ckey, map, elm);
							}							
						}
					}
				}
			}

			if (elm.children) {
				for (var i = 0; i < elm.children.length; i++) {
					var nkey = nest ? ckey : keyStr;
					this.addLocalizedMappings(elm.children[i], map, nkey , uiType, nest);
				}
			}
		},
		
		_localizeProperty: function(name, prop, widget, keyStr, map, elm) {
			if (lang.isFunction(prop.extractLocalizedProperties)) {
				var props = prop.extractLocalizedProperties(elm[name]);
				if (props) {
					for (var i = 0; i < props.length; i++) {
						var p = props[i];
						this.setProperty(keyStr + '.' + name + '_' + p.label, p.value, map);
					}
				}
			} else {
				keyStr = keyStr + "." + name;
				var val = elm[name];
				this.setProperty(keyStr, val, map);							
			}			
		},

		findModelAttributes: function(model, map) {
		    var attrs = model.attributes;
		    map._ModelLabel = model.name;
		    for (var i = 0; i < attrs.length; i++) {
				var attr = attrs[i];
				if (attr.type == 'ENUM') {
					var enumValues = attr.enumValues;
					map[attr.name] = {};
					for (var j = 0; j < enumValues.length; j++) {
						var ev = enumValues[j];
						map[attr.name][ev.name] = ev.name;
					}
				}
			}
		},
		
		findStrings: function(strings, map, termsMap) {
			for (var i = 0; i < strings.length; i++) {
				var str = strings[i];
				map[str.name] = str.value;
				if (str.term) {
				    termsMap[str.name + "_Label"] = str.name;
				}
			}
		},

		getLocaleByName: function(locale) {
		    var locales = this.schema.locales;
            var loc = null;
            for (var i = 0; i < locales.length; i++) {
                if (locales[i].name === locale) {
                    loc = locales[i];
                    break;
                }
            }
            return loc;
		},
		
		build : function(res) {
		    this.count = 0;
			var map = {
				ui: {},
				model: {},
				counters: {},
				config: {},
				features: {},
				custom: {},
				terms: {}
			};
			var t = this;
			this.schema.userInterfaces.forEach(function(ui) {
				t.traverseMenu(ui, map.ui, ui.name, ui.type);
				if (ui.common) {
					t.traverseView(ui.common, map.ui, ui.name + '.common', ui.type);
				}
				var views = ui.views;
				views.forEach(function(view) {
					view = lang.clone(view);
					t.traverseView(view, map.ui, ui.name + '.' + view.id , ui.type);
				});
			});
			var categories = {};
			var params = this.schema.params;
			for (var i = 0; i < params.length; i++) {
				var param = params[i];
				map.config[param.name + '_Label'] = param.label;
				map.config[param.name + '_Descr'] = param.description;
				this.count += 2;
				if (param.category) {
				    categories[param.category] = true;
				}
			}
			for (var cat in categories) {
			    map.config['Category_' + cat] = cat;
			    this.count++;
			}
			var counters = this.schema.counters;
			for (var i = 0; i < counters.length; i++) {
			    var counter = counters[i];
			    map.counters[counter.name + "_Label"] = counter.name;
			}
			var models = this.schema.models;
			for (var i = 0; i < models.length; i++) {
				var model = models[i];
				var modelMap = {};
				map.model[model.name] = modelMap;
				this.findModelAttributes(model, modelMap);
			}
			var features = this.schema.features;
			for (var i = 0; i < features.length; i++) {
				var feature = features[i];
				map.features[feature.name + '_Label'] = feature.label;
				map.features[feature.name + '_Descr'] = feature.descr;
				this.count += 2;
			}
			
			var defLocale = this.getLocaleByName('default');
			if (defLocale) {
				var strings = lang.clone(defLocale.data.custom);
				this.findStrings(strings, map.custom, map.terms);
			}
			this.map = map;
			if (res) {
			    res.count = this.count;
			}
			return map;
		}
	});

	clss.getInstance = function() {
		if (clss._instance == null) {
			clss._instance = new clss();
		}
		return clss._instance;
	};

	return clss;
});
},
'appivo/mobile/_StripeBase':function(){
define(["dojo/_base/lang",
        "dojo/_base/declare",
        "appivo/client/Client",
        "appivo/util/StripeLoader"
        ],
        function(
        	lang,
        	declare,
        	client,
        	StripeLoader
        	) {

	return declare("appivo.mobile._StripeBase", [], {
        setPublicKey: function(){
            var key = client.getInstance().getStripeKey();
            StripeLoader.getStripe().then(function(stripe) {
                stripe.setPublishableKey(key);
            });
        }
	});

});
},
'appivo/page/Page':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'dojo/Deferred',
        'dojo/io/script'], function(lang, declare, deferred, script) {
	return declare("appivo.page.Page", null, {

		pageManager: null,
		_container: null,
		_scripts: null,
		_scriptIndex: 0,
		user: null,
		tenantId: null,
		messages: null,

		constructor: function(options) {
			declare.safeMixin(this, options);
			if (this.user) {
				this.tenantId = this.user.tenant_id;
			}
			this.uis = new Array();		
			this._scripts = new Array();
			//this._container = this._createContainer();
			//this.pageManager.getPageFrame().addPage(this._container);
		},

		init: function() {
			var def = new deferred();
			this._init(def);
			return def;
		},

		_init: function(def) {   
			def.resolve();
		},
		
		start: function() {
			
		},

		setParameters: function(params) {

		},
		
		getPageManager: function() {
			return this.pageManager;
		},
		
		getContainer: function() {
			return this._container;
		},
		
		_getPageInfo: function() {
			return null;
		},

		_createContainer: function() {
			return new dijit.layout.ContentPane({style: {border: "none", padding: "0px"}});
		},

		_loadScriptsSeq: function(urls, def) {
			if (!def) {
				def = new deferred();
			}
			var nextUrl = urls[this._scriptIndex++];
			var _this = this;
			script.get({
				url: nextUrl,
				load: function() {
					if (_this._scriptIndex < urls.length) {
						_this._loadScriptsSeq(urls, def);
					} else {
						def.resolve();
					}
				}
			});
			return def;
		},

		_loadScripts: function(urls) {
			var def = new deferred();
			var _this = this;
			for (var i in urls) {
				var url = urls[i];
				this._scripts[url] = "N";
				script.get({
					url: url,
					load: function() {
						_this._scripts[url] = "Y";
						_this._checkDone(def);
					}
				});
			}
		},

		_checkDone: function(def) {
			for (var url in this._scripts) {
				var done = this._scripts[url];
				if (done == "N") {
					return;
				}
			}
			def.resolve();
		},

		_onShow: function() {
			this.pageManager.setNavBarStyle('standard');
		},
		
		_postShow: function() {
		},
		
		_onLoad: function() {	
		},

		_onLeave: function() {
		},
		
		goHome: function() {
		},
		
		canLeave: function() {
			return true;
		},
		
		handleEvent: function(event, data, ui) {
		},
		
		clear: function() {		
		},

		destroy: function() {    	
		}
	})
});

},
'dojo/io/script':function(){
define([
	"../_base/connect", /*===== "../_base/declare", =====*/ "../_base/kernel", "../_base/lang",
	"../sniff", "../_base/window","../_base/xhr",
	"../dom", "../dom-construct", "../request/script", "../aspect"
], function(connect, /*===== declare, =====*/ kernel, lang, has, win, xhr, dom, domConstruct, _script, aspect){

	// module:
	//		dojo/io/script

	kernel.deprecated("dojo/io/script", "Use dojo/request/script.", "2.0");

	/*=====
	var __ioArgs = declare(kernel.__IoArgs, {
		// summary:
		//		All the properties described in the dojo.__ioArgs type, apply to this
		//		type as well, EXCEPT "handleAs". It is not applicable to
		//		dojo/io/script.get() calls, since it is implied by the usage of
		//		"jsonp" (response will be a JSONP call returning JSON)
		//		or the response is pure JavaScript defined in
		//		the body of the script that was attached.
		// callbackParamName: String
		//		Deprecated as of Dojo 1.4 in favor of "jsonp", but still supported for
		//		legacy code. See notes for jsonp property.
		// jsonp: String
		//		The URL parameter name that indicates the JSONP callback string.
		//		For instance, when using Yahoo JSONP calls it is normally,
		//		jsonp: "callback". For AOL JSONP calls it is normally
		//		jsonp: "c".
		// checkString: String
		//		A string of JavaScript that when evaluated like so:
		//		"typeof(" + checkString + ") != 'undefined'"
		//		being true means that the script fetched has been loaded.
		//		Do not use this if doing a JSONP type of call (use callbackParamName instead).
		// frameDoc: Document
		//		The Document object for a child iframe. If this is passed in, the script
		//		will be attached to that document. This can be helpful in some comet long-polling
		//		scenarios with Firefox and Opera.
	});
	=====*/

	var script = {
		// summary:
		//		TODOC

		get: function(/*__ioArgs*/ args){
			// summary:
			//		sends a get request using a dynamically created script tag.
			var rDfd;
			var dfd = this._makeScriptDeferred(args, function(dfd){
				rDfd && rDfd.cancel();
			});
			var ioArgs = dfd.ioArgs;
			xhr._ioAddQueryToUrl(ioArgs);

			xhr._ioNotifyStart(dfd);

			rDfd = _script.get(ioArgs.url, {
				timeout: args.timeout,
				jsonp: ioArgs.jsonp,
				checkString: args.checkString,
				ioArgs: ioArgs,
				frameDoc: args.frameDoc,
				canAttach: function(rDfd){
					// sync values
					ioArgs.requestId = rDfd.id;
					ioArgs.scriptId = rDfd.scriptId;
					ioArgs.canDelete = rDfd.canDelete;

					return script._canAttach(ioArgs);
				}
			}, true);

			// Run _validCheck at the same time dojo/request/watch runs the
			// rDfd.isValid function
			aspect.around(rDfd, "isValid", function(isValid){
				return function(response){
					script._validCheck(dfd);
					return isValid.call(this, response);
				};
			});

			rDfd.then(function(){
				dfd.resolve(dfd);
			}).otherwise(function(error){
				dfd.ioArgs.error = error;
				dfd.reject(error);
			});

			return dfd;
		},

		attach: _script._attach,
		remove: _script._remove,

		_makeScriptDeferred: function(/*Object*/ args, /*Function?*/ cancel){
			// summary:
			//		sets up a Deferred object for an IO request.
			var dfd = xhr._ioSetArgs(args, cancel || this._deferredCancel, this._deferredOk, this._deferredError);

			var ioArgs = dfd.ioArgs;
			ioArgs.id = kernel._scopeName + "IoScript" + (this._counter++);
			ioArgs.canDelete = false;

			//Special setup for jsonp case
			ioArgs.jsonp = args.callbackParamName || args.jsonp;
			if(ioArgs.jsonp){
				//Add the jsonp parameter.
				ioArgs.query = ioArgs.query || "";
				if(ioArgs.query.length > 0){
					ioArgs.query += "&";
				}
				ioArgs.query += ioArgs.jsonp +
					"=" + (args.frameDoc ? "parent." : "") +
					kernel._scopeName + ".io.script.jsonp_" + ioArgs.id + "._jsonpCallback";

				ioArgs.frameDoc = args.frameDoc;

				//Setup the Deferred to have the jsonp callback.
				ioArgs.canDelete = true;
				dfd._jsonpCallback = this._jsonpCallback;
				this["jsonp_" + ioArgs.id] = dfd;
			}
			// Make sure this runs no matter what happens to clean things up if need be
			dfd.addBoth(function(value){
				if(ioArgs.canDelete){
					if(value instanceof Error){
						// Set up a callback that will clean things up for timeouts and cancels
						script["jsonp_" + ioArgs.id]._jsonpCallback = function(){
							// Delete the cached deferred
							delete script["jsonp_" + ioArgs.id];
							if(ioArgs.requestId){
								// Call the dojo/request/script callback to clean itself up as well
								kernel.global[_script._callbacksProperty][ioArgs.requestId]();
							}
						};
					}else{
						script._addDeadScript(ioArgs);
					}
				}
			});
			return dfd; // dojo/_base/Deferred
		},

		_deferredCancel: function(/*Deferred*/ dfd){
			// summary:
			//		canceller function for xhr._ioSetArgs call.

			//DO NOT use "this" and expect it to be script.
			dfd.canceled = true;
		},

		_deferredOk: function(/*Deferred*/ dfd){
			// summary:
			//		okHandler function for xhr._ioSetArgs call.

			//DO NOT use "this" and expect it to be script.
			var ioArgs = dfd.ioArgs;

			//Favor JSONP responses, script load events then lastly ioArgs.
			//The ioArgs are goofy, but cannot return the dfd since that stops
			//the callback chain in Deferred. The return value is not that important
			//in that case, probably a checkString case.
			return ioArgs.json || ioArgs.scriptLoaded || ioArgs;
		},

		_deferredError: function(/*Error*/ error, /*Deferred*/ dfd){
			// summary:
			//		errHandler function for xhr._ioSetArgs call.

			console.log("dojo.io.script error", error);
			return error;
		},

		_deadScripts: [],
		_counter: 1,

		_addDeadScript: function(/*Object*/ ioArgs){
			// summary:
			//		sets up an entry in the deadScripts array.
			script._deadScripts.push({id: ioArgs.id, frameDoc: ioArgs.frameDoc});
			//Being extra paranoid about leaks:
			ioArgs.frameDoc = null;
		},

		_validCheck: function(/*Deferred*/ dfd){
			// summary:
			//		inflight check function to see if dfd is still valid.

			// TODO: why isn't dfd accessed?

			//Do script cleanup here. We wait for one inflight pass
			//to make sure we don't get any weird things by trying to remove a script
			//tag that is part of the call chain (IE 6 has been known to
			//crash in that case).
			var deadScripts = script._deadScripts;
			if(deadScripts && deadScripts.length > 0){
				for(var i = 0; i < deadScripts.length; i++){
					//Remove the script tag
					script.remove(deadScripts[i].id, deadScripts[i].frameDoc);
					//Clean up the deferreds
					delete script["jsonp_" + deadScripts[i].id];
					deadScripts[i].frameDoc = null;
				}
				script._deadScripts = [];
			}

			return true;
		},

		_ioCheck: function(dfd){
			// summary:
			//		inflight check function to see if IO finished.
			// dfd: Deferred
			var ioArgs = dfd.ioArgs;
			//Check for finished jsonp
			if(ioArgs.json || (ioArgs.scriptLoaded && !ioArgs.args.checkString)){
				return true;
			}

			//Check for finished "checkString" case.
			var checkString = ioArgs.args.checkString;
			return checkString && eval("typeof(" + checkString + ") != 'undefined'");


		},

		_resHandle: function(/*Deferred*/ dfd){
			// summary:
			//		inflight function to handle a completed response.
			if(script._ioCheck(dfd)){
				dfd.callback(dfd);
			}else{
				//This path should never happen since the only way we can get
				//to _resHandle is if _ioCheck is true.
				dfd.errback(new Error("inconceivable dojo.io.script._resHandle error"));
			}
		},

		_canAttach: function(/*===== ioArgs =====*/ ){
			// summary:
			//		A method that can be overridden by other modules
			//		to control when the script attachment occurs.
			// ioArgs: Object
			return true;
		},

		_jsonpCallback: function(/*JSON Object*/ json){
			// summary:
			//		generic handler for jsonp callback. A pointer to this function
			//		is used for all jsonp callbacks.  NOTE: the "this" in this
			//		function will be the Deferred object that represents the script
			//		request.
			this.ioArgs.json = json;
			if(this.ioArgs.requestId){
				kernel.global[_script._callbacksProperty][this.ioArgs.requestId](json);
			}
		}
	};

	lang.setObject("dojo.io.script", script);

	/*=====
	script.attach = function(id, url, frameDocument){
		// summary:
		//		creates a new `<script>` tag pointing to the specified URL and
		//		adds it to the document.
		// description:
		//		Attaches the script element to the DOM. Use this method if you
		//		just want to attach a script to the DOM and do not care when or
		//		if it loads.
	};
	script.remove = function(id, frameDocument){
		// summary:
		//		removes the script element with the given id, from the given frameDocument.
		//		If no frameDocument is passed, the current document is used.
	};
	=====*/

	return script;
});

},
'dojo/request/script':function(){
define([
	'module',
	'./watch',
	'./util',
	'../_base/kernel',
	'../_base/array',
	'../_base/lang',
	'../on',
	'../dom',
	'../dom-construct',
	'../has',
	'../_base/window'/*=====,
	'../request',
	'../_base/declare' =====*/
], function(module, watch, util, kernel, array, lang, on, dom, domConstruct, has, win/*=====, request, declare =====*/){
	has.add('script-readystatechange', function(global, document){
		var script = document.createElement('script');
		return typeof script['onreadystatechange'] !== 'undefined' &&
			(typeof global['opera'] === 'undefined' || global['opera'].toString() !== '[object Opera]');
	});

	var mid = module.id.replace(/[\/\.\-]/g, '_'),
		counter = 0,
		loadEvent = has('script-readystatechange') ? 'readystatechange' : 'load',
		readyRegExp = /complete|loaded/,
		callbacks = kernel.global[mid + '_callbacks'] = {},
		deadScripts = [];

	function attach(id, url, frameDoc, errorHandler){
		var doc = (frameDoc || win.doc),
			element = doc.createElement('script');

		if (errorHandler) {
			on.once(element, 'error', errorHandler);
		}

		element.type = 'text/javascript';
		try {
			element.src = url;
		} catch(err) {
			errorHandler && errorHandler(element);
		}

		element.id = id;
		element.async = true;
		element.charset = 'utf-8';

		return doc.getElementsByTagName('head')[0].appendChild(element);
	}

	function remove(id, frameDoc, cleanup){
		domConstruct.destroy(dom.byId(id, frameDoc));

		if(callbacks[id]){
			if(cleanup){
				// set callback to a function that deletes itself so requests that
				// are in-flight don't error out when returning and also
				// clean up after themselves
				callbacks[id] = function(){
					delete callbacks[id];
				};
			}else{
				delete callbacks[id];
			}
		}
	}

	function _addDeadScript(dfd){
		// Be sure to check ioArgs because it can dynamically change in the dojox/io plugins.
		// See http://bugs.dojotoolkit.org/ticket/15890.
		var options = dfd.response.options,
			frameDoc = options.ioArgs ? options.ioArgs.frameDoc : options.frameDoc;

		deadScripts.push({ id: dfd.id, frameDoc: frameDoc });

		if(options.ioArgs){
			options.ioArgs.frameDoc = null;
		}
		options.frameDoc = null;
	}

	function canceler(dfd, response){
		if(dfd.canDelete){
			//For timeouts and cancels, remove the script element immediately to
			//avoid a response from it coming back later and causing trouble.
			script._remove(dfd.id, response.options.frameDoc, true);
		}
	}
	function isValid(response){
		//Do script cleanup here. We wait for one inflight pass
		//to make sure we don't get any weird things by trying to remove a script
		//tag that is part of the call chain (IE 6 has been known to
		//crash in that case).
		if(deadScripts && deadScripts.length){
			array.forEach(deadScripts, function(_script){
				script._remove(_script.id, _script.frameDoc);
				_script.frameDoc = null;
			});
			deadScripts = [];
		}

		return response.options.jsonp ? !response.data : true;
	}
	function isReadyScript(response){
		return !!this.scriptLoaded;
	}
	function isReadyCheckString(response){
		var checkString = response.options.checkString;

		return checkString && eval('typeof(' + checkString + ') !== "undefined"');
	}
	function handleResponse(response, error){
		if(this.canDelete){
			_addDeadScript(this);
		}
		if(error){
			this.reject(error);
		}else{
			this.resolve(response);
		}
	}

	function script(url, options, returnDeferred){
		var response = util.parseArgs(url, util.deepCopy({}, options));
		url = response.url;
		options = response.options;

		var dfd = util.deferred(
			response,
			canceler,
			isValid,
			options.jsonp ? null : (options.checkString ? isReadyCheckString : isReadyScript),
			handleResponse
		);

		lang.mixin(dfd, {
			id: mid + (counter++),
			canDelete: false
		});

		if(options.jsonp){
			var queryParameter = new RegExp('[?&]' + options.jsonp + '=');
			if(!queryParameter.test(url)){
				url += (~url.indexOf('?') ? '&' : '?') +
					options.jsonp + '=' +
					(options.frameDoc ? 'parent.' : '') +
					mid + '_callbacks.' + dfd.id;
			}

			dfd.canDelete = true;
			callbacks[dfd.id] = function(json){
				response.data = json;
				dfd.handleResponse(response);
			};
		}

		if(util.notify){
			util.notify.emit('send', response, dfd.promise.cancel);
		}

		if(!options.canAttach || options.canAttach(dfd)){
			var node = script._attach(dfd.id, url, options.frameDoc, function (error) {
				if (!(error instanceof Error)) {
					var newError = new Error('Error loading ' + (error.target ? error.target.src : 'script'));
					newError.source = error;
					error = newError;
				}
				dfd.reject(error);
				script._remove(dfd.id, options.frameDoc, true);
			});

			if(!options.jsonp && !options.checkString){
				var handle = on(node, loadEvent, function(evt){
					if(evt.type === 'load' || readyRegExp.test(node.readyState)){
						handle.remove();
						dfd.scriptLoaded = evt;
					}
				});
			}
		}

		watch(dfd);

		return returnDeferred ? dfd : dfd.promise;
	}
	script.get = script;
	/*=====
	script = function(url, options){
		// summary:
		//		Sends a request using a script element with the given URL and options.
		// url: String
		//		URL to request
		// options: dojo/request/script.__Options?
		//		Options for the request.
		// returns: dojo/request.__Promise
	};
	script.__BaseOptions = declare(request.__BaseOptions, {
		// jsonp: String?
		//		The URL parameter name that indicates the JSONP callback string.
		//		For instance, when using Yahoo JSONP calls it is normally,
		//		jsonp: "callback". For AOL JSONP calls it is normally
		//		jsonp: "c".
		// checkString: String?
		//		A string of JavaScript that when evaluated like so:
		//		"typeof(" + checkString + ") != 'undefined'"
		//		being true means that the script fetched has been loaded.
		//		Do not use this if doing a JSONP type of call (use `jsonp` instead).
		// frameDoc: Document?
		//		The Document object of a child iframe. If this is passed in, the script
		//		will be attached to that document. This can be helpful in some comet long-polling
		//		scenarios with Firefox and Opera.
	});
	script.__MethodOptions = declare(null, {
		// method: String?
		//		This option is ignored. All requests using this transport are
		//		GET requests.
	});
	script.__Options = declare([script.__BaseOptions, script.__MethodOptions]);

	script.get = function(url, options){
		// summary:
		//		Send an HTTP GET request using a script element with the given URL and options.
		// url: String
		//		URL to request
		// options: dojo/request/script.__BaseOptions?
		//		Options for the request.
		// returns: dojo/request.__Promise
	};
	=====*/

	// TODO: Remove in 2.0
	script._attach = attach;
	script._remove = remove;
	script._callbacksProperty = mid + '_callbacks';

	return script;
});

},
'appivo/page/PageManager':function(){
define(['featherlight/featherlight',
		'dojo/_base/lang',
        'dojo/_base/declare',
        'dojo/_base/unload',
        'dojo/Deferred',
        'dojo/dom',
        'dojo/dom-construct',
        'dojo/on',
        'dojo/when',
        'dojo/string',
        'dojo/router',
		'dojo/topic',
        'dojo/io-query',
        'dojo/i18n!appivo/nls/PageManager',
        'dijit/registry',
        'appivo/util/Global',
        'appivo/ui/Alertify',
        'appivo/ui/Spinner',
        'appivo/ui/InputBlocker',
        'appivo/client/Client',
        'appivo/mvc/AppState',
        'appivo/model/SchemaManager',
        'appivo/store/StoreManager',
        'appivo/util/Handlebars',
        'vue/vue',
        '../vue/components/AlertBox',
        'dojo/i18n!../vue/nls/AlertBox'], function(featherlight, lang, declare, unload, Deferred, dom, domConstruct, on, when, string, router,
        		topic, ioQuery, messages, registry, Global, alertify, Spinner, InputBlocker, Client, AppState, SchemaManager,
        		StoreManager, Handlebars, Vue, alertbox,  alertmsgs) {

	var DEFAULT_PAGEINFO = {
		title: 'appivo',
		mobileIcons: [{
			fallback: '/images/ai/android-icon-192x192.png'
		}],
		icon: {
			fallback: '/images/ai/android-icon-192x192.png'
		}
	};

	return declare("appivo.page.PageManager", null, {
		user: null,
		client: null,
		pageFrame: null,
		indexPane: null,
		_pages: null,
		domNode: null,
		loadingIndicator: null,
		currentPage: null,
		storeManager: null,
		routingInitialized: false,
		indicatorScheduled: false,
		cancelIndicator: false,
		_pageIndex: null,
		overlay: null,
		info: null,
		spinDepth: 0,
		vue: null,
		transition: null,
		routingDef: null,

		//metaSchemaName: null,

		constructor: function(options) {
			declare.safeMixin(this, options);
			var t = this;
			this.info = {};
			this.params = {
				user: this.user,
				pageManager: this
			};
			this.client = Client.getInstance();
			this.user = this.client.getUser();
			this.storeManager = StoreManager.getInstance();
			this._pages = new Array();
			unload.addOnUnload(this, "destroy");

			topic.subscribe('/dojo/hashchange', function(changedHash) {
				t.client.registerPageView();
			});

			window.addEventListener('popstate', function() {
				var hash = location.hash;
				if (hash) {
					hash = hash.substring(1);
				}
				router.go(hash);
			});

			this._pageIndex = new Array();
			for (var i in this._pageDefs) {
				var page = this._pageDefs[i];
				this._pageIndex[page.name] = page;
			}
		},

		getContainer: function() {
			return this.indexPane;
		},

		/*getSchemaName: function() {
		    return this.metaSchemaName;
		},*/

		alert: function(msgType, message, moreMessage, alertTitle) {
			if (msgType == 'error') {
				if (lang.isString(message)) {
					message = {
						errorMessage: message
					};
				} else if (message && message.error) {
					if (lang.isObject(message.error)) {
						if (message.error.nextErrorCode) {
							moreMessage = message.error.nextErrorCode.errorMessage;
						} else if (message.error.nextError) {
							moreMessage = message.error.nextError.errorMessage;
						}
						message = {
							errorMessage: message.error.errorMessage
						};
					} else {
						message = {
							errorMessage: message.error
						};
					}
				} else if (message && message.error && message.error.error) {
					message = {
						errorMessage: message.error.error
					};
				}

				if (message && moreMessage === message.errorMessage) {
					moreMessage = undefined;
				}
			}
			if (this.vue == null) {
				var type = "success";
				switch (msgType) {
					case "error":
						type = "danger";
						break;
					case "info":
						type = "info";
						break;
				}
				var template = '<div id="AlertBox"><alertbox position="bottom-right" type="' + type + '"></alertbox></div>';
				this.vue = new Vue({
					el: 'AlertBox' ,
					locale: alertmsgs,
					template: template,
					components: {
						'alertbox': alertbox
					}
				});
			}
			if (this.vue.$el == null) {
				this.vue.$mount('AlertBox');
			}
			this.vue.$broadcast('AlertBox', 'open', msgType, message, moreMessage, alertTitle);
		},

		_detectLocalStorage: function() {
		    var mod = 'appivo';
		    try {
		        localStorage.setItem(mod, mod);
		        localStorage.removeItem(mod);
		        return true;
		    } catch(e) {
		        return false;
		    }
		},

		showLoadingIndicator: function(delay, loadingMessage) {
			this.spinDepth++;
			console.log("Show load-indicator " + this.spinDepth);
			if (!this.indicatorScheduled && !Spinner.isShowing()) {
			    if (!InputBlocker.isBlocking()) {
			        InputBlocker.block(true);
			    }
				this.indicatorScheduled = true;
				this.cancelIndicator = false;
				if (!delay) {
					delay = 150;
				}
				console.log("Scheduled load-indicator to show in " + delay + "ms");
				this._showLoadingIndicator(loadingMessage);
				// setTimeout(lang.hitch(this,
				// 	function(){
				// 	}), delay);
			}
		},

		_showLoadingIndicator: function(loadingMessage) {
			console.log("Executing scheduled show load-indicator");
			this.indicatorScheduled = false;
			if (!this.cancelIndicator) {
				console.log("Showing load-indicator");
				if (!Spinner.isShowing()) {
					Spinner.show(true,loadingMessage);
				}
			}
		},

		hideLoadingIndicator: function() {
			console.log("Hiding load-indicator " + this.spinDepth);
			this.spinDepth--;
			if (this.spinDepth <= 0) {
				console.log("Removing load-indicator");
				this.spinDepth = 0;
				this.cancelIndicator = true;
				if (Spinner.isShowing()) {
					Spinner.show(false);
				}
				if (InputBlocker.isBlocking()) {
				    InputBlocker.block(false);
				}
			}
		},

		showDialog: function(template, options) {
			var title = "appivo";
			var content = template;
			var onOk = undefined;
			var onCancel = undefined;
			if (options) {
				if (options.vars) {
					content = string.substitute(template, {
						messages: options.vars
					});
				}
				if (options.onOk) {
					onOk = options.onOk;
				}
				if (options.onCancel) {
					onCancel = options.onCancel;
				}
			}

		    var dialog = alertify.confirm(content, onOk, onCancel);
		    if (options) {
		    		if (options.okLabel || options.cancelLabel) {
		    			dialog.set('labels', {
		    				ok: options.okLabel,
		    				cancel: options.cancelLabel
		    			});
		    		} else {
		    			dialog.set('labels', {
		    				ok: alertmsgs.ok,
		    				cancel: alertmsgs.cancel
		    			});
		    		}
		    		if (options.title) {
		    			dialog.set('title', options.title);
		    		}
		    }
		},

		initRouting: function() {
			var t = this;
			var def = new Deferred();
			router.register("", lang.hitch(this, this.handleHomeRoutingEvent));
			router.register("/", lang.hitch(this, this.handleHomeRoutingEvent));
			router.register("/home", lang.hitch(this, this.handleHomeRoutingEvent));

			router.register("/users", lang.hitch(this, this.handleUsersRoutingEvent));
			router.register("/users/", lang.hitch(this, this.handleUsersRoutingEvent));
			router.register("/users/:userId", lang.hitch(this, this.handleUsersRoutingEvent));

			router.register("/app/:app", lang.hitch(this, this.handleAppRoutingEvent));
			router.register("/app/:app/", lang.hitch(this, this.handleAppRoutingEvent));
			router.register("/app/:app/:ui", lang.hitch(this, this.handleAppRoutingEvent));
			router.register("/app/:app/:ui/", lang.hitch(this, this.handleAppRoutingEvent));
			router.register("/app/:app/:ui/:view", lang.hitch(this, this.handleAppRoutingEvent));
			router.register("/app/:app//:view", lang.hitch(this, this.handleAppRoutingEvent));
			router.register("/app/:app/:ui/:view/:id", lang.hitch(this, this.handleAppRoutingEvent));
			router.register("/app/:app//:view/:id", lang.hitch(this, this.handleAppRoutingEvent));
			router.register("/app/:app/:ui/:view/:id/*query", lang.hitch(this, this.handleAppRoutingEvent));
			router.register("/app/:app//:view/:id/*query", lang.hitch(this, this.handleAppRoutingEvent));
			router.register("/store", lang.hitch(this, this.handleStoreRoutingEvent));
			router.register("/store/", lang.hitch(this, this.handleStoreRoutingEvent));
			router.register("/wizard", lang.hitch(this, this.handleWizardRoutingEvent));
			router.register("/wizard/", lang.hitch(this, this.handleWizardRoutingEvent));
			router.register("/wiz", lang.hitch(this, this.handleWizRoutingEvent));
            router.register("/wiz/", lang.hitch(this, this.handleWizRoutingEvent));
			router.register("/builder", lang.hitch(this, this.handleBuilderRoutingEvent));
			router.register("/builder/", lang.hitch(this, this.handleBuilderRoutingEvent));
			router.register("/builder/:app", lang.hitch(this, this.handleBuilderRoutingEvent));
			router.register("/profile", lang.hitch(this, this.handleProfileRoutingEvent));
			router.register("/profile/", lang.hitch(this, this.handleProfileRoutingEvent));
			router.register("/profile/:user", lang.hitch(this, this.handleProfileRoutingEvent));
			router.register("/account", lang.hitch(this, this.handleAccountRoutingEvent));
			router.register("/account/", lang.hitch(this, this.handleAccountRoutingEvent));
			router.register("/account/:tab", lang.hitch(this, this.handleAccountRoutingEvent));
			router.register("/tenant", lang.hitch(this, this.handleTenantRoutingEvent));
			router.register("/tenant/", lang.hitch(this, this.handleTenantRoutingEvent));
			router.register("/tenant/:user", lang.hitch(this, this.handleTenantRoutingEvent));
			router.register("/developer", lang.hitch(this, this.handleDeveloperRoutingEvent));
			router.register("/developer/", lang.hitch(this, this.handleDeveloperRoutingEvent));
			router.register("/developer/:app", lang.hitch(this, this.handleDeveloperRoutingEvent));
			router.register("/marketplace", lang.hitch(this, this.handleMarketPlaceRoutingEvent));
			router.register("/templatelibrary", lang.hitch(this, this.handleTemplateLibraryRoutingEvent));
			router.register("/marketplace/", lang.hitch(this, this.handleMarketPlaceRoutingEvent));
			router.register("/marketplace/:app", lang.hitch(this, this.handleMarketPlaceRoutingEvent));
			router.register("/design", lang.hitch(this, this.handleDesignRoutingEvent));
			router.register("/design/", lang.hitch(this, this.handleDesignRoutingEvent));
			router.register("/design/:app", lang.hitch(this, this.handleDesignRoutingEvent));
			router.register("/internal", lang.hitch(this, this.handleInternalRoutingEvent));
			router.register("/device", lang.hitch(this, this.handleDeviceRoutingEvent));
			router.register("/device/:device", lang.hitch(this, this.handleDeviceRoutingEvent));
			router.register("login", lang.hitch(this, this.handleLoginRoutingEvent));
			router.register("/components", lang.hitch(this, this.handleComponentsRoutingEvent));
			router.register("/components/integrations", lang.hitch(this, this.handleIntegrationRoutingEvent));
			router.register("/components/libraries", lang.hitch(this, this.handleLibraryRoutingEvent));
			router.register("/administration/:app", lang.hitch(this, this.handleAdministrationRoutingEvent));
			this.getInitialPath().then(function(path) {
				var url = window.location.pathname;
				if (url.startsWith("/hub/")) {
					t.initHub();
				} else {
					var hasTarget = t.setInitialLocation(path);
				}
				t._postInitRouting();
				router.startup();
				t.routingInitialized = true;
				def.resolve(hasTarget);
			}, function(error) {
				def.reject(error);
			});

			return def;
		},

		initHub: function() {
			var t = this;
			var url = window.location.pathname;
			var parts = url.split("/").filter(function(seg) {
				return seg.trim().length > 0;
			});
			if (parts.length > 1) {
				if (parts[0] === "hub") {
					var app = parts[1];
					var view = parts[2];
					t.handleAppRoutingEvent({
						params: {
							app: app,
							ui: t.client.isMobile() ? 'mobile' : 'web',
							view: view
						}
					});
				}
			}
		},
		
		getInitialPath: function() {
			var def = new Deferred();
			def.resolve(location.hash);
			return def;
		},

		setInitialLocation: function(req) {
			var hasTarget = false;
			console.log("PageManager setInitialLocation");
			var appState = AppState.getInstance();
			var path = {};
			var reset = true;
			var currentState = appState.getCurrentState();
			var cached = null;
			var device = this.client.isMobile() ? 'mobile' : 'desktop';
			if (currentState && currentState.device == device) {
				var notSafariWebApp = !(this.client.getDeviceType() == "ios" && !window.cordova);
				if (this.client.isStart() && notSafariWebApp) {
					appState.clear();
				} else {
					cached = currentState.getRoutingInfo();
					console.log("CACHE STATE: " + JSON.stringify(cached));
				}
			}
			var query = location.search;
			var rewrite = false;
			var page = null;
			var publicSchema = this.client.getPublicSchema();
			if (req) {
				var hbegin = req.indexOf('#');
				var qbegin = req.indexOf('?');
				if (qbegin > hbegin) {
					if (qbegin > -1 && req.charAt(qbegin + 1) == '/') {
						qbegin = req.indexOf('?', qbegin + 1);
					}
					if (qbegin > hbegin) {
						query = req.substring(qbegin + 1);
						req = req.substring(0, qbegin);
						rewrite = true;
					}
				}
				if (req.startsWith("#")) {
					req = req.substring(1);
				}

				var parts = req.split('/');
				if (parts.length > 1) {
					page = parts[1];
				}
				if (parts.length > 2) {
					if (parts[1] == 'app') {
						path.app = parts[2];
						if (parts.length > 3) {
							path.ui = parts[3];
							if (parts.length > 4) {
								path.view = parts[4];
								if (parts.length > 5) {
									path.id = parts[5];
								}
							}
						}
					} else {
						path[parts[1]] = true;
					}
				}
				if (cached && page == 'app') {
					if (path.app && (path.app == cached.app)) {
						if (path.ui) {
							if (path.ui == cached.ui) {
								reset = false;
							}
						} else {
							reset = false;
						}
					}

					if (!path.app && cached.app) {
						path.app = cached.app;
					}
					if (!reset && path.ui == undefined && cached.ui && (path.app == cached.app)) {
						path.ui = cached.ui;
					}
					if (!reset && path.view == undefined && cached.view && (path.ui == cached.ui)) {
						path.view = cached.view;
					}
					if (!reset && path.id == undefined && cached.id && (path.view == cached.view)) {
						path.id = cached.id;
					}
				}
			} else if (cached) {
				path = cached;
			} else if (publicSchema) {
				page = 'app';
				path = {
					app: publicSchema
				};
			}
			if (reset) {
				appState.clear();
			}

			if (page == null || (page != 'developer' && page != 'administration' && page != 'wiz' && page != 'tenant' && page != 'device' && page != 'account' && page != 'profile' && page != 'app' && page != 'store' && page != 'marketplace' && page != 'internal' && page != 'design' && page != 'wizard' && page != 'builder' && page != 'users' && page !='components')) {
				path.home = true;
			} else {
				hasTarget = true;
			}

			if (path.home || !path.app) {
			    this.setEmbedded(false);
			}

			var str = location.hash;
			if (path.home) {
				location.hash = '#/';
			} else if (path.design) {
				location.hash = str;
			} else if (path.app) {
				str = '#/app/';
				if (path.app) {
					str = str + this._encode(path.app);
				}
				if (path.ui) {
					str = str + '/' + this._encode(path.ui);
				} else if (path.ui == '') {
					str = str + '/';
				}
				if (path.view) {
					str = str + '/' + this._encode(path.view);
				}
				if (path.id) {
					str = str + '/' + path.id;
				}
				console.log("PageManager Setting location " + str);
				Global.set('startingUp', "true");
				if (rewrite) {
					history.pushState(null, path.app + ' / ' + path.view, window.location.pathname + '?' + query + str);
				}
				location.hash = str;
			}

			//this.go(path);

			if (!this._detectLocalStorage()) {
				console.error("Browser does not support localstorage");
				alertify.alert(messages.warning, messages.noLocalStorage);
			}

			if (str == '') {
				this.hideLoadingIndicator();
			}

			return hasTarget;
		},

		_isEncoded: function(str) {
			return decodeURIComponent(str) != str;
		},

		_encode: function(str) {
			var str = str;
			if (!this._isEncoded(str)) {
				str = encodeURIComponent(str);
			}
			return str;
		},

		_postInitRouting: function() {
			if (!location.hash) {
				var node = dom.byId("main");
				if (node) {
					node.style.visibility = 'visible';
				}
			}
		},

		_clearRoutingInfo: function() {
			this.info = {};
		},

		_setRoutingInfo: function(opts) {
			if (!this.info) {
				this.info = {};
			}
			lang.mixin(this.info, opts);
		},

		_getRoutingInfo: function() {
			return this.info;
		},

		go: function(options) {
			var def = null;
			var cpath = this.currentPath ? this.currentPath : location.hash.substring(1);

			if (!this.switchingViews || (this.selectedName == "app")) {
				this.showLoadingIndicator(50);
				this.switchingViews = true;
				this.transition = options.transition;
				var path = '/'
				if (options.special) {
					switch (options.special.type) {
					case 'home':
						// noop
						break;
					case 'builder':
						if (options.special.create) {
							path = '/builder/!';
						} else {
							path = '/builder/' + options.special.name;
						}
						break;
					case 'design':
						if (options.special.create) {
							path = '/design/!';
						} else {
							path = '/design/' + options.special.name;
						}
						break;
					case 'wizard':
						path = '/wizard/';
						break;
					}
					this.setEmbedded(false);
				} else {
					var cr = this.info;
					var dest = {};
					if (options.app) {
						dest.app = options.app;
						if (options.ui) {
							dest.ui = options.ui;
							if (options.view) {
								dest.view = options.view;
								if (options.id) {
									dest.id = options.id;
								}
							}
						}
					} else if (options.ui) {
						dest.app = cr.app;
						dest.ui = options.ui;
						if (options.view) {
							dest.view = options.view;
							if (options.id) {
								dest.id = options.id;
							}
						}
					} else if (options.view) {
						dest.app = cr.app;
						dest.ui = cr.ui;
						dest.view = options.view;
						if (options.id) {
							dest.id = options.id;
						}
					} else if (options.id) {
						dest.app = cr.app;
						dest.ui = cr.ui;
						dest.view = cr.view;
						dest.id = options.id;
					} else if (options.query) {
						dest.app = cr.app;
						dest.ui = cr.ui;
						dest.view = cr.view;
						dest.id = cr.id;
						dest.query = options.query;
					}

					if (!dest.query && options.query) {
						dest.query = options.query;
					}

					var path = '/app/';
					if (dest.app) {
						path = path + encodeURIComponent(dest.app);
						if (dest.ui) {
							path = path + '/' + encodeURIComponent(dest.ui);
							if (dest.view) {
								path = path + '/' + encodeURIComponent(dest.view);
								if (dest.id) {
									path = path + '/' + dest.id;
								}
							}
						}
					}

					if (dest.query) {
						var qstr = ioQuery.objectToQuery(dest.query);
						history.pushState(null, dest.app + ' / ' + dest.view, window.location.pathname + '?' + qstr + '#' + path);
					} else {
						history.pushState(null, null, window.location.pathname + '#' + path);
					}
				}
				console.log("PageManager go: " + path);
				console.log("Comparing paths " + cpath + " == " + path + " (" + (cpath == path) + ")");
				if ((cpath == path) || (cpath == '' && path == '/')) {
					console.log("Paths are equal - no change");
					this._switchViewCompleted();
				} else {
					console.log("Paths are not equal, routing");
					this.nextPath = path;
					this.routingDef = new Deferred(),
					def = this.routingDef;
					router.go(path);
				}
			} else {
				console.error("Cannot switch views - already in progress");
			}
			if (!def) {
				def = new Deferred();
				def.resolve();
			}
			return def;
		},

		_createEvent: function(eventName) {
		    var event = null;
			if (typeof(Event) === 'function') {
		        event = new Event(eventName);
		    } else {
		        event = document.createEvent('Event');
		        event.initEvent(eventName, true, true);
		    }
			return event;
		},

		_switchViewCompleted: function() {
			var t = this;
			setTimeout(function() {
				console.log("_switchViewCompleted");
				t.currentPath = this.nextPath;
				t.switchingViews = false;
				t.hideLoadingIndicator();
				window.dispatchEvent(t._createEvent("appivoLoad"));
			}, 5);
		},

		setHome: function() {
		},

		handleHomeRoutingEvent: function(event) {
			console.log("handleHome1RoutingEvent");
			this.clear();
			this.dispatchEvent('home', 'home', event.params, null);
		},

		handleUsersRoutingEvent:function (event) {
			this.clear();
			this.dispatchEvent('home', 'users', event ? event.params : null , null);
		},

		handleLoginRoutingEvent: function(event) {
			this.clear();
			this.doLogin();
		},

		handleComponentsRoutingEvent:function (event) {
			this.clear();
			this.dispatchEvent('components');
		},

		handleIntegrationRoutingEvent:function (event) {
			this.clear();
			this.dispatchEvent('components','integration');
		},

		handleLibraryRoutingEvent:function (event) {
			this.clear();
			this.dispatchEvent('components','library');
		},

		handleAdministrationRoutingEvent:function (event) {
			this.clear();
			this.dispatchEvent('administration','appdata',event.params);
		},

		handleStoreRoutingEvent: function(event) {
			this.clear();
			this.dispatchEvent('store', 'store', event.params, null);
		},

		_extractTenantId: function(params) {
			var app = params.app;
			var idx = app.indexOf('[');
			if (idx > 0) {
				params.app = app.substring(0, idx);
				params.tenant = app.substring(idx + 1, app.length - 1);
			}
		},

		_getComponents: function(path) {
			var parts = [path, null];
			var idx = path.indexOf('?');
			if (idx >= 0) {
				parts[0] = decodeURIComponent(path.substring(0, idx));
				parts[1] = path.substring(idx);
			} else {
				parts[0] = decodeURIComponent(parts[0]);
			}
			return parts;
		},

		handleAppRoutingEvent: function(event) {
			if (!this.routingInitialized) {
			}
			if (event.params) {
				var q = event.params.query;
				if (!q) {
					q = location.search;
				}
				if (event.params.app) {
					var seg = this._getComponents(event.params.app);
					event.params.app = seg[0];
					if (seg[1] && !event.params.ui && !q) {
						q = seg[1];
					}
				}
				this._extractTenantId(event.params);
				if (event.params.ui) {
					var seg = this._getComponents(event.params.ui);
					event.params.ui = seg[0];
					if (seg[1] && !event.params.view && !q) {
						q = seg[1];
					}
				}
				if (event.params.view) {
					var seg = this._getComponents(event.params.view);
					event.params.view = seg[0];
					if (seg[1] && !q) {
						q = seg[1];
						delete event.params.id;
					}
				}

				if (event.params.id) {
					var seg = this._getComponents(event.params.id);
					event.params.id = seg[0];
					if (event.params.id.length == 0) {
						delete event.params.id;
					}
					if (seg[1] && !q) {
						q = seg[1];
					}
				}

				if (q) {
					if (q.charAt(0) == '?') {
						q = q.substring(1);
						event.params.query = ioQuery.queryToObject(q);
					}
				}
			}
			if (this.transition) {
			    event.params.transition = this.transition;
			    this.transition = null;
			}
			this.dispatchEvent('app', 'app', event.params, null);
		},

		handleProfileRoutingEvent: function(event) {
			if (event.params.user) {
				this.dispatchEvent('profile', 'user', event.params, null);
			} else {
				this.dispatchEvent('profile');
			}
			this._clearRoutingInfo();
		},

		handleAccountRoutingEvent: function(event) {
			if (event.params.tab) {
				this.dispatchEvent('home', null, event.params, null);
			} else {
				this.dispatchEvent('home','account');
			}
			this._clearRoutingInfo();
		},

		handleTenantRoutingEvent: function(event) {
			if (event.params.user) {
				// todo remaining check usage
				this.dispatchEvent('tenant', 'user', event.params, null);
			} else {
				this.dispatchEvent('home', 'tenant');
			}
			this._clearRoutingInfo();
		},

		handleDeveloperRoutingEvent: function(event) {
			if (event.params.app) {
				this.dispatchEvent('developer', 'app', event.params, null);
			} else {
				this.dispatchEvent('developer');
			}
			this._clearRoutingInfo();
		},

		handleMarketPlaceRoutingEvent: function(event) {
			if (event.params.app) {
				this.dispatchEvent('home', 'marketplace', event.params, null);
			} else {
				this.dispatchEvent('home', 'marketplace');
			}
			this._clearRoutingInfo();
		},

		handleTemplateLibraryRoutingEvent: function(event) {
			if (event.params.app) {
				this.dispatchEvent('home', 'templatelibrary', event.params, null);
			} else {
				this.dispatchEvent('home', 'templatelibrary');
			}
			this._clearRoutingInfo();
		},

		handleBuilderRoutingEvent: function(event) {
			if (event.oldPath == "/wizard") {
				// Indication that we're coming from the wizard (should suppress builder's cacheAlert)
				event.params.fromWizard = true;
			}
			if (event.params.app) {
				if (event.params.app != '!') {
					this.dispatchEvent('builder', 'app', event.params, null);
				} else {
					this.dispatchEvent('builder', 'newAdv');
				}
			} else {
				this.dispatchEvent('builder', 'new');
			}
			this._clearRoutingInfo();
		},

		handleInternalRoutingEvent: function(event) {
			this.dispatchEvent('internal', {});
			this._clearRoutingInfo();
		},

		handleDeviceRoutingEvent: function(event) {
			if (event.params.device) {
				this.dispatchEvent('device', 'device', event.params, null);
			} else {
				this.dispatchEvent('device', {});
			}
			this._clearRoutingInfo();
		},

		handleDesignRoutingEvent: function(event) {
			if (event.params.app) {
				if (event.params.app != '!') {
					this.dispatchEvent('design', 'app', event.params, null);
				} else {
					this.dispatchEvent('design', 'newAdv');
				}
			} else {
				this.dispatchEvent('design', 'new');
			}
			this._clearRoutingInfo();
		},

        handleWizRoutingEvent: function(event) {
			this.dispatchEvent('wiz', 'new');
            this._clearRoutingInfo();
        },

		handleWizardRoutingEvent: function(event) {
			this.dispatchEvent('wizard', 'new');
			this._clearRoutingInfo();
		},

		setupMenus: function(user) {
		},

		clearMenus: function() {
		},

		notifyApp: function(app, removeIndex, addIndex) {
			alert("GOT NOTIFICATION for " + app);
		},

		dispatchEvent: function(pageName, event, data, ui) {
			var t = this;
			var init = false;
			if (!this.routingInitialized) {
				console.log("Initial routing event");
				init = true;
			}
			if (init) {
				//this.pageFrame.hide();
			}
			this.showLoadingIndicator();

			this.setPage(pageName).then(function(page) {
				console.log("Dispatching event " + event);
				console.log(data);
				page.handleEvent(event, data, ui).then(function() {
					console.log("Event " + event + " handled by " + pageName);
					t.hideLoadingIndicator();
					if (t.routingDef) {
						t.routingDef.resolve();
						t.routingDef = null;
					}
				}, function(error) {
					console.log("Event " + event + " handling failed by " + pageName);
					t.hideLoadingIndicator();
					if (t.routingDef) {
						t.routingDef.reject(eror);
						t.routingDef = null;
					}
				});
			});
		},

		setPage: function(pageName) {
			var t = this;
			var page = this.getPage(pageName);
			var def = new Deferred();
			page.then(function(pg) {
				if (pg != t.selected) {
					t.client.setOfflineMode('AUTO');
					t.clearMenus();
					if (t.selected) {
						t.selected._onLeave();
					}
					pg._onShow();
					pg._postShow();
					t.selected = pg;
					t.selectedName = pageName;
					var info = pg._getPageInfo();
					if (!info) {
						info = DEFAULT_PAGEINFO;
					}
					t.setWindowDetails(info);
				}
				def.resolve(pg);
			});
			return def.promise;
		},

		setNavBarStyle: function(type) {
		},

		clear: function() {
			console.log("PageManager.clear");
			if (this.currentPage != null) {
				this.currentPage.clear();
				this.currentPage = null;
			}
		},

		getPage: function(pageName) {
			var t = this;
			var pg = this._pageIndex[pageName];
			var pageClass = pg.pageClass;
			var def = new Deferred();

			if (this.currentPage) {
				var clsName = this.currentPage.declaredClass.replace(/\./g, '/');
				if (clsName == pageClass) {
					def.resolve(this.currentPage);
					return def.promise;
				}
			}

			if (this._pages) {
				var page = this._pages[pageClass];
				if (!page) {
					require([pageClass], function(pclass) {
						t.clear();
						page = new pclass(t.params);
						var pdef = page.init();
						pdef.then(function() {
							page._onLoad();
							t.currentPage = page;
							t._pages[pageClass] = page;
							def.resolve(page);
						}, function() {
							t.alert('error',"Failed to load page: " + pageName);
							def.reject();
						});
					});
				} else {
					this.clear();
					this.currentPage = page;
					def.resolve(page);
				}
			} else {
				// error
				def.reject();
			}

			return def.promise;
		},

		canLeave: function(action) {
			if (this.currentPage) {
				var ok = this.currentPage.canLeave();
				when(ok, function(dok) {
					action(dok);
				});
			} else {
				action(true);
			}
		},

		doLogout: function() {
			var t = this;
			var def = new Deferred();
			console.log("Called doLogout");
			this.canLeave(function(ok) {
				if (ok) {
					t.client.logout().then(function() {
						console.log("Successfully logged out");
						t._showLoadingIndicator();
						setTimeout(function() {
							t.doLogin();
							def.resolve();
						}, 50);
					}, function(error) {
						def.reject(error);
					});
				} else {
					def.reject("Cannot leave page");
				}
			});
			return def;
		},

		doLogin: function() {
			var t = this;
			setTimeout(function() {
				var loginUrl = t.client.getLoginUrl();
				if (t.client.isAnonymous()) {
					t.doLogout();
				} else {
					console.log("Logging in - reloading URL " + loginUrl);
					window.history.replaceState({}, document.title, loginUrl);
					window.location = loginUrl;
					window.location.reload();
				}
			}, 50);
		},

		toggleGuide: function() {
			var def = new Deferred();
			var prefs = this.client.getPreferences();
			prefs.disableGuide = !prefs.disableGuide;
			this.client.updatePreferences(prefs).then(function(user) {
				def.resolve(user);
			}, function(error) {
				def.reject(error);
			});
			return def;
		},

		refreshNav: function() {
		},

		doGoHome: function() {
			var t = this;
			this.canLeave(function() {
				t.go({
					special: {
						type: 'home'
					}
				});
			});
		},

		doGoAppHome: function() {
			var t = this;
			this.canLeave(function() {
				t.currentPage.goHome();
			});
		},

		doShowProfile: function() {
			var t = this;
			this.canLeave(function() {
				t.go({
					app: 'System',
					ui: 'Profile',
					view: 'profile',
					id: t.user.id
				});
			});
		},

		getStoreManager: function() {
			return this.storeManager;
		},

		setWindowDetails: function(data) {
			if (data) {
				if (data.title) {
					window.document.title = data.title;
					if (this.client.getDeviceType() == 'windowsphone') {
						var head = document.getElementsByTagName("head")[0];
						var titleMeta = document.createElement('meta');
						titleMeta.name = 'application-name';
						titleMeta.content = data.title;
						head.appendChild(titleMeta);
					}
				}
				if (this.client.isMobile() && data.mobileIcons) {
					if (this.client.getDeviceType() == 'windowsphone') {
						this._setWindowsPhoneIcons(data.mobileIcons);
					}
					this._setMobileIcons(data.mobileIcons);

					if (data.mobileSplash) {
						this._setSplashScreens(data.mobileSplash, 'ios');
					}
				} else {
					this._clearMobileIcons();
					if (!this.client.isMobile() && data.icon) {
						this._setDesktopIcon(data.icon);
					}
				}
			}
		},

		_setWindowsPhoneIcons: function(icons){
			var head = document.getElementsByTagName("head")[0];
			var tags = [
                "msapplication-square70x70logo",
                "msapplication-square150x150logo",
                "msapplication-square310x310logo",
                "msapplication-wide310x150logo"
            ];
            var icon = icons[1];
            var path = icon.path ? icon.path : icon.fallback;
            if (path.indexOf("/") < 0) {
                path = this.client.getURI("/files/" + path);
            }
			for (var i  = 0; i < tags.length; i++){
				var tileMeta = document.createElement('meta');
				tileMeta.id = '_as_tile_' + i;
                tileMeta.name = tags[i];
                tileMeta.content = path;
                head.appendChild(tileMeta);
			}

            tileMeta = document.createElement('meta');
            tileMeta.id = '_as_tilecolor';
            tileMeta.name = "msapplication-TileColor";
            tileMeta.content = "#000000";
            head.appendChild(tileMeta);
		},

		_setMobileIcons: function(icons) {
			this._clearMobileIcons();

			var head = document.getElementsByTagName("head")[0];

			for (var i in icons) {
				var icon = icons[i];

				var iconNode = this._createIconLink(icon, {
					type: 'ios'
				});
				iconNode.id = '_as_' + i;
				head.appendChild(iconNode);

				var iconNode2 = this._createIconLink(icon, {
					type: 'android'
				});
				iconNode2.id = '_as_android_' + i;
				head.appendChild(iconNode2);
			}
		},

		_setDesktopIcon: function(icon) {
			var head = document.getElementsByTagName("head")[0];
			var iconNode = this._createIconLink(icon, {
				type: 'desktop'
			});
			iconNode.id = '_as_default';
			head.appendChild(iconNode);
		},

		_setSplashScreens: function(screens) {
			var head = document.getElementsByTagName("head")[0];

			for (var i in screens) {
				var screen = screens[i];
				var splashNode = this._createSplashScreen(screen, {
					type: 'ios'
				});
				splashNode.id = '_as_splash_' + i;
				head.appendChild(splashNode);
			}
		},

		_createSplashScreen: function(screen, options) {
			var head = document.getElementsByTagName("head")[0];

			var splashNode = document.createElement('link');
			splashNode.href = this._createFileLink(screen);

			switch (options.type) {
			case 'ios':
				splashNode.rel = 'apple-touch-startup-image';
				break;
			case 'android':
				splashNode.rel = '';
				break;
			}
			if (screen.media) {
				splashNode.media = screen.media;
			}
			return splashNode;
		},

		setManifestLink: function(schema) {
			var tenantId = this.client.getTenantId();
			var manNode = document.getElementById("web-app-manifest");
			var url = '/api/app-manifest/';
			if (tenantId) {
				url += tenantId + "/";
			}
			url += schema.name;
			manNode.href = url;

			/*
			var manifest = {
				name: "Busy"
			};
			var str = JSON.stringify(manifest);
			var blob = new Blob([str], {type: 'application/json'});
			var manifestURL = URL.createObjectURL(blob);
			document.querySelector('#web-app-manifest').setAttribute('href', manifestURL);
			*/
		},

		clearManifestLink: function() {
			var manNode = document.getElementById("web-app-manifest");
			manNode.href = null;
		},

		_createIconLink: function(icon, options) {
			var link = document.createElement('link');
			switch (options.type) {
			case 'ios':
				link.rel = 'apple-touch-icon-precomposed';
				break;
			case 'android':
				link.rel = "shortcut icon"
				break;
			case 'desktop':
				link.rel = "icon";
				break;
			}
			link.href = this._createFileLink(icon);
			if (icon.sizes) {
				link.sizes = icon.sizes;
			}
			return link;
		},

		setEmbedded: function() {
		},

		_clearMobileIcons: function() {
			var head = document.getElementsByTagName("head")[0];
			var children = head.childNodes;
			var toDelete = new Array();
			for (var i in children) {
				var node = children[i];
				if (node.id && node.id.indexOf('_as_') == 0) {
					toDelete.push(node);
				}
			}

			for (var i in toDelete) {
				var node = toDelete[i];
				node.parentNode.removeChild(node);
			}
		},

		_createFileLink: function(image) {
			var link = '/files/';
			if (image.path) {
				if (!image.thumb) {
					link = link + image.path;
				} else {
					link = link + image.path + '-thumb' + image.sizes;
				}
			} else {
				link = image.fallback;
			}
			link = this.client.getURI(link);
			return link;
		},

		destroy: function() {
			if (this._pages) {
				for (var i in this._pages) {
					var page = this._pages[i];
					page.destroy();
				}
				this._pages = null;
			}
		}
	})
});

},
'dojo/_base/unload':function(){
define(["./kernel", "./lang", "../on"], function(dojo, lang, on){

// module:
//		dojo/unload

var win = window;

var unload = {
	// summary:
	//		This module contains the document and window unload detection API.
	//		This module is deprecated.  Use on(window, "unload", func)
	//		and on(window, "beforeunload", func) instead.

	addOnWindowUnload: function(/*Object|Function?*/ obj, /*String|Function?*/ functionName){
		// summary:
		//		Registers a function to be triggered when window.onunload fires.
		//		Deprecated, use on(window, "unload", lang.hitch(obj, functionName)) instead.
		// description:
		//		The first time that addOnWindowUnload is called Dojo
		//		will register a page listener to trigger your unload
		//		handler with. Note that registering these handlers may
		//		destroy "fastback" page caching in browsers that support
		//		it. Be careful trying to modify the DOM or access
		//		JavaScript properties during this phase of page unloading:
		//		they may not always be available. Consider
		//		addOnUnload() if you need to modify the DOM or do
		//		heavy JavaScript work since it fires at the equivalent of
		//		the page's "onbeforeunload" event.
		// example:
		//	|	var afunc = function() {console.log("global function");};
		//	|	require(["dojo/_base/unload"], function(unload) {
		//	|		var foo = {bar: function(){ console.log("bar unloading...");}, 
		//	|		           data: "mydata"};
		//	|		unload.addOnWindowUnload(afunc);
		//	|		unload.addOnWindowUnload(foo, "bar");
		//	|		unload.addOnWindowUnload(foo, function(){console.log("", this.data);});
		//	|	});

		if (!dojo.windowUnloaded){
			on(win, "unload", (dojo.windowUnloaded = function(){
				// summary:
				//		signal fired by impending window destruction. You may use
				//		dojo.addOnWindowUnload() to register a listener for this
				//		event. NOTE: if you wish to dojo.connect() to this method
				//		to perform page/application cleanup, be aware that this
				//		event WILL NOT fire if no handler has been registered with
				//		addOnWindowUnload(). This behavior started in Dojo 1.3.
				//		Previous versions always triggered windowUnloaded(). See
				//		addOnWindowUnload for more info.
			}));
		}
		on(win, "unload", lang.hitch(obj, functionName));
	},

	addOnUnload: function(/*Object?|Function?*/ obj, /*String|Function?*/ functionName){
		// summary:
		//		Registers a function to be triggered when the page unloads.
		//		Deprecated, use on(window, "beforeunload", lang.hitch(obj, functionName)) instead.
		// description:
		//		The first time that addOnUnload is called Dojo will
		//		register a page listener to trigger your unload handler
		//		with.
		//
		//		In a browser environment, the functions will be triggered
		//		during the window.onbeforeunload event. Be careful of doing
		//		too much work in an unload handler. onbeforeunload can be
		//		triggered if a link to download a file is clicked, or if
		//		the link is a javascript: link. In these cases, the
		//		onbeforeunload event fires, but the document is not
		//		actually destroyed. So be careful about doing destructive
		//		operations in a dojo.addOnUnload callback.
		//
		//		Further note that calling dojo.addOnUnload will prevent
		//		browsers from using a "fast back" cache to make page
		//		loading via back button instantaneous.
		// example:
		//	|	var afunc = function() {console.log("global function");};
		//	|	require(["dojo/_base/unload"], function(unload) {
		//	|		var foo = {bar: function(){ console.log("bar unloading...");}, 
		//	|		           data: "mydata"};
		//	|		unload.addOnUnload(afunc);
		//	|		unload.addOnUnload(foo, "bar");
		//	|		unload.addOnUnload(foo, function(){console.log("", this.data);});
		//	|	});

		on(win, "beforeunload", lang.hitch(obj, functionName));
	}
};

dojo.addOnWindowUnload = unload.addOnWindowUnload;
dojo.addOnUnload = unload.addOnUnload;

return unload;

});

},
'dojo/router':function(){
define([
	"./router/RouterBase"
], function(RouterBase){

	// module:
	//		dojo/router

/*=====
return {
	// summary:
	//		A singleton-style instance of dojo/router/RouterBase. See that
	//		module for specifics.
	// example:
	//	|	router.register("/widgets/:id", function(evt){
	//	|		// If "/widgets/3" was matched,
	//	|		// evt.params.id === "3"
	//	|		xhr.get({
	//	|			url: "/some/path/" + evt.params.id,
	//	|			load: function(data){
	//	|				// ...
	//	|			}
	//	|		});
	//	|	});
};
=====*/

	return new RouterBase({});
});

},
'dojo/router/RouterBase':function(){
define([
	"dojo/_base/declare",
	"dojo/hash",
	"dojo/topic"
], function(declare, hash, topic){

	// module:
	//		dojo/router/RouterBase

	// Creating a basic trim to avoid needing the full dojo/string module
	// similarly to dojo/_base/lang's trim
	var trim;
	if(String.prototype.trim){
		trim = function(str){ return str.trim(); };
	}else{
		trim = function(str){ return str.replace(/^\s\s*/, '').replace(/\s\s*$/, ''); };
	}

	// Firing of routes on the route object is always the same,
	// no clean way to expose this on the prototype since it's for the
	// internal router objects.
	function fireRoute(params, currentPath, newPath){
		var queue, isStopped, isPrevented, eventObj, callbackArgs, i, l;

		queue = this.callbackQueue;
		isStopped = false;
		isPrevented = false;
		eventObj = {
			stopImmediatePropagation: function(){ isStopped = true; },
			preventDefault: function(){ isPrevented = true; },
			oldPath: currentPath,
			newPath: newPath,
			params: params
		};

		callbackArgs = [eventObj];

		if(params instanceof Array){
			callbackArgs = callbackArgs.concat(params);
		}else{
			for(var key in params){
				callbackArgs.push(params[key]);
			}
		}

		for(i=0, l=queue.length; i<l; ++i){
			if(!isStopped){
				queue[i].apply(null, callbackArgs);
			}
		}

		return !isPrevented;
	}

	// Our actual class-like object
	var RouterBase = declare(null, {
		// summary:
		//		A module that allows one to easily map hash-based structures into
		//		callbacks. The router module is a singleton, offering one central
		//		point for all registrations of this type.
		// example:
		//	|	var router = new RouterBase({});
		//	|	router.register("/widgets/:id", function(evt){
		//	|		// If "/widgets/3" was matched,
		//	|		// evt.params.id === "3"
		//	|		xhr.get({
		//	|			url: "/some/path/" + evt.params.id,
		//	|			load: function(data){
		//	|				// ...
		//	|			}
		//	|		});
		//	|	});

		_routes: null,
		_routeIndex: null,
		_started: false,
		_currentPath: "",

		idMatch: /:(\w[\w\d]*)/g,
		idReplacement: "([^\\/]+)",
		globMatch: /\*(\w[\w\d]*)/,
		globReplacement: "(.+)",

		constructor: function(kwArgs){
			// A couple of safety initializations
			this._routes = [];
			this._routeIndex = {};

			// Simple constructor-style "Decorate myself all over" for now
			for(var i in kwArgs){
				if(kwArgs.hasOwnProperty(i)){
					this[i] = kwArgs[i];
				}
			}
		},

		register: function(/*String|RegExp*/ route, /*Function*/ callback){
			// summary:
			//		Registers a route to a handling callback
			// description:
			//		Given either a string or a regular expression, the router
			//		will monitor the page's hash and respond to changes that
			//		match the string or regex as provided.
			//
			//		When provided a regex for the route:
			//
			//		- Matching is performed, and the resulting capture groups
			//		are passed through to the callback as an array.
			//
			//		When provided a string for the route:
			//
			//		- The string is parsed as a URL-like structure, like
			//		"/foo/bar"
			//		- If any portions of that URL are prefixed with a colon
			//		(:), they will be parsed out and provided to the callback
			//		as properties of an object.
			//		- If the last piece of the URL-like structure is prefixed
			//		with a star (*) instead of a colon, it will be replaced in
			//		the resulting regex with a greedy (.+) match and
			//		anything remaining on the hash will be provided as a
			//		property on the object passed into the callback. Think of
			//		it like a basic means of globbing the end of a route.
			// example:
			//	|	router.register("/foo/:bar/*baz", function(object){
			//	|		// If the hash was "/foo/abc/def/ghi",
			//	|		// object.bar === "abc"
			//	|		// object.baz === "def/ghi"
			//	|	});
			// returns: Object
			//		A plain JavaScript object to be used as a handle for
			//		either removing this specific callback's registration, as
			//		well as to add new callbacks with the same route initially
			//		used.
			// route: String|RegExp
			//		A string or regular expression which will be used when
			//		monitoring hash changes.
			// callback: Function
			//		When the hash matches a pattern as described in the route,
			//		this callback will be executed. It will receive an event
			//		object that will have several properties:
			//
			//		- params: Either an array or object of properties pulled
			//		from the new hash
			//		- oldPath: The hash in its state before the change
			//		- newPath: The new hash being shifted to
			//		- preventDefault: A method that will stop hash changes
			//		from being actually applied to the active hash. This only
			//		works if the hash change was initiated using `router.go`,
			//		as changes initiated more directly to the location.hash
			//		property will already be in place
			//		- stopImmediatePropagation: When called, will stop any
			//		further bound callbacks on this particular route from
			//		being executed. If two distinct routes are bound that are
			//		different, but both happen to match the current hash in
			//		some way, this will *not* keep other routes from receiving
			//		notice of the change.

			return this._registerRoute(route, callback);
		},

		registerBefore: function(/*String|RegExp*/ route, /*Function*/ callback){
			// summary:
			//		Registers a route to a handling callback, except before
			//		any previously registered callbacks
			// description:
			//		Much like the `register` method, `registerBefore` allows
			//		us to register route callbacks to happen before any
			//		previously registered callbacks. See the documentation for
			//		`register` for more details and examples.

			return this._registerRoute(route, callback, true);
		},

		go: function(path, replace){
			// summary:
			//		A simple pass-through to make changing the hash easy,
			//		without having to require dojo/hash directly. It also
			//		synchronously fires off any routes that match.
			// example:
			//	|	router.go("/foo/bar");

			var applyChange;

			if(typeof path !== "string"){return false;}

			path = trim(path);
			applyChange = this._handlePathChange(path);

			if(applyChange){
				hash(path, replace);
			}

			return applyChange;
		},

		startup: function(defaultPath){
			// summary:
			//		This method must be called to activate the router. Until
			//		startup is called, no hash changes will trigger route
			//		callbacks.

			if(this._started){ return; }

			var self = this,
				startingPath = hash();

			this._started = true;
			this._hashchangeHandle = topic.subscribe("/dojo/hashchange", function(){
				self._handlePathChange.apply(self, arguments);
			});

			if(!startingPath){
				// If there is no initial starting point, push our defaultPath into our
				// history as the starting point
				this.go(defaultPath, true);
			}else{
				// Handle the starting path
				this._handlePathChange(startingPath);
			}
		},

		destroy: function(){
			if(this._hashchangeHandle){
				this._hashchangeHandle.remove();
			} 			
			this._routes = null;
			this._routeIndex = null;
		},

		_handlePathChange: function(newPath){
			var i, j, li, lj, routeObj, result,
				allowChange, parameterNames, params,
				routes = this._routes,
				currentPath = this._currentPath;

			if(!this._started || newPath === currentPath){ return allowChange; }

			allowChange = true;

			for(i=0, li=routes.length; i<li; ++i){
				routeObj = routes[i];
				result = routeObj.route.exec(newPath);

				if(result){
					if(routeObj.parameterNames){
						parameterNames = routeObj.parameterNames;
						params = {};

						for(j=0, lj=parameterNames.length; j<lj; ++j){
							params[parameterNames[j]] = result[j+1];
						}
					}else{
						params = result.slice(1);
					}
					allowChange = routeObj.fire(params, currentPath, newPath);
				}
			}

			if(allowChange){
				this._currentPath = newPath;
			}

			return allowChange;
		},

		_convertRouteToRegExp: function(route){
			// Sub in based on IDs and globs
			route = route.replace(this.idMatch, this.idReplacement);
			route = route.replace(this.globMatch, this.globReplacement);
			// Make sure it's an exact match
			route = "^" + route + "$";

			return new RegExp(route);
		},

		_getParameterNames: function(route){
			var idMatch = this.idMatch,
				globMatch = this.globMatch,
				parameterNames = [], match;

			idMatch.lastIndex = 0;

			while((match = idMatch.exec(route)) !== null){
				parameterNames.push(match[1]);
			}
			if((match = globMatch.exec(route)) !== null){
				parameterNames.push(match[1]);
			}

			return parameterNames.length > 0 ? parameterNames : null;
		},

		_indexRoutes: function(){
			var i, l, route, routeIndex, routes = this._routes;

			// Start a new route index
			routeIndex = this._routeIndex = {};

			// Set it up again
			for(i=0, l=routes.length; i<l; ++i){
				route = routes[i];
				routeIndex[route.route] = i;
			}
		},

		_registerRoute: function(/*String|RegExp*/route, /*Function*/callback, /*Boolean?*/isBefore){
			var index, exists, routeObj, callbackQueue, removed,
				self = this, routes = this._routes,
				routeIndex = this._routeIndex;

			// Try to fetch the route if it already exists.
			// This works thanks to stringifying of regex
			index = this._routeIndex[route];
			exists = typeof index !== "undefined";
			if(exists){
				routeObj = routes[index];
			}

			// If we didn't get one, make a default start point
			if(!routeObj){
				routeObj = {
					route: route,
					callbackQueue: [],
					fire: fireRoute
				};
			}

			callbackQueue = routeObj.callbackQueue;

			if(typeof route == "string"){
				routeObj.parameterNames = this._getParameterNames(route);
				routeObj.route = this._convertRouteToRegExp(route);
			}

			if(isBefore){
				callbackQueue.unshift(callback);
			}else{
				callbackQueue.push(callback);
			}

			if(!exists){
				index = routes.length;
				routeIndex[route] = index;
				routes.push(routeObj);
			}

			// Useful in a moment to keep from re-removing routes
			removed = false;

			return { // Object
				remove: function(){
					var i, l;

					if(removed){ return; }

					for(i=0, l=callbackQueue.length; i<l; ++i){
						if(callbackQueue[i] === callback){
							callbackQueue.splice(i, 1);
						}
					}


					if(callbackQueue.length === 0){
						routes.splice(index, 1);
						self._indexRoutes();
					}

					removed = true;
				},
				register: function(callback, isBefore){
					return self.register(route, callback, isBefore);
				}
			};
		}
	});

	return RouterBase;
});

},
'appivo/ui/Spinner':function(){
define([], function() {

	var scheduled = null;

	return {

		show: function(show, loadingMessage) {
			var wrapper = document.getElementById("_appivoSpinner");
			var messageWrapper = document.getElementById("_loadingMessage");
			if(show && loadingMessage){
				$(messageWrapper).text(loadingMessage);
				$(messageWrapper).addClass("reveal");
			}else{
				$(messageWrapper).text("");
				$(messageWrapper).removeClass("reveal");
			}
			$(wrapper).css({
				'opacity': show ? '1' : '0',
				'display': show ? 'flex' : 'none'
			});
		},

		isShowing: function() {
			var wrapper = document.getElementById("_appivoSpinner");
			return wrapper.style.display != 'none';
		}
	};
});

},
'appivo/ui/InputBlocker':function(){
define([], function() {

	return {

		block: function(block) {
			var wrapper = document.getElementById("_inputBlocker");
			if (wrapper) {
				$(wrapper).css({
					'display': block ? 'block' : 'none'
				});
			}
		},

		isBlocking: function() {
			var wrapper = document.getElementById("_inputBlocker");
			if (wrapper) {
				return wrapper.style.display != 'none';
			}
			return false;
		}
	};
});
},
'appivo/mvc/AppState':function(){
define(['dojo/_base/lang', 
        'dojo/_base/declare',
        'dojo/_base/Deferred',
        'appivo/client/Client',
        'appivo/mvc/ViewState',
        'flatted/flatted'], 

        function(lang, declare, Deferred, Client, ViewState, flatted) {
	
	var clss =  declare("appivo.mvc.AppState", [], {
		
		viewStatePrefix: 'appshift.viewState_',
		paths: null,
		
		constructor: function() {
			this.paths = {};
			this.client = Client.getInstance();
			var pos = this._getPointer(false, true);
			var corrupt = false;
			while (pos > 0) {
				var state = this.loadState(pos);
				if (state) {
					var path = state.getPath();
					this.paths[pos] = path;
					pos--;					
				} else {
					corrupt = true;
					break;
				}
			}
			if (corrupt) {
				this.clear();
			}
		},
		
		createViewState: function(view, info) {
			var pos = this._getPointer(true);
			var name = this._getName(pos);
			var viewState = new ViewState();
			viewState._setDevice(Client.getInstance().isMobile() ? 'mobile' : 'desktop');
			viewState._setName(name);
			viewState.setRoutingInfo(info, true);
			view.setState(viewState);
			this.paths[pos] = viewState.getPath();
			return viewState;
		},
		
		_getName: function(pos, validate) {
			return this.viewStatePrefix + pos;
		},
		
		_getPointer: function(inc, validate) {
			var currentUser = this.client.getUser().name;
			var user = window.localStorage.getItem('appshift.user');
			if (validate && user && user != currentUser) {
				//this.clear();
			}
			var pos = window.localStorage.getItem('appshift.viewPos');
			if (pos == null) {
				pos = 0;
			} else {
				pos = parseInt(pos);
			}
			if (inc) {
				pos++;
				window.localStorage.setItem('appshift.user', currentUser);
				window.localStorage.setItem('appshift.viewPos', pos);
			}
			return pos;
		},
		
		getPreviousState: function() {
			var state = null;
			var pos = this._getPointer();
			if (pos > 0) {
				pos--;
			}
			state = this.loadState(pos);
			return state;
		},
		
		getCurrentState: function() {
			var pos = this._getPointer();
			var state = this.loadState(pos);
			return state;
		},

		findState: function(state) {
			var fstate = null;
			var path = state.getPath();
			var pos = this._getPointer();
			var fpos = -1;
			while (pos > 0) {
				var spath = this.paths[pos];
				if (path == spath) {
					fpos = pos;
					break;
				}
				pos--;
			}
			
			if (fpos > 0) {
				fstate = this.loadState(fpos);
				this.clear(fpos);
			}
			return fstate;
		},
				
		loadState: function(pos) {
			var state = null;
			var name = this._getName(pos);
			var str = window.localStorage.getItem(name);
			if (str) {
				var data = null;
				try {
					if (str.startsWith("f:")) {
						str = str.substring(2);
						var data = flatted.parse(str);
					} else {
						data = JSON.parse(str);
					}
				} catch (error) {
					console.error(error);
				}
				state = new ViewState(data);
				state._setName(name);
			}
			return state;
		},
				
		clear: function(clearTo) {
			if (clearTo == undefined) {
				clearTo = 0;
			}
			console.log("AppState clearing to " + clearTo);
			var pos = this._getPointer();
			while (pos > clearTo) {
				var name =  this._getName(pos);
				window.localStorage.removeItem(name);
				pos--;
			}
			if (clearTo > 0) {
				window.localStorage.setItem('appshift.viewPos', clearTo);
			} else {
				window.localStorage.removeItem('appshift.viewPos');				
			}
		},
				
		toJSON: function() {
			var json = {
				app: this.app,
				ui: this.ui,
				view: this.view,
				id: this.id,
				query: this.query,
				user: this.client.getUser().user,
				widgets: lang.clone(this.widgets)
			};
			return json;
		}
	});
	
	clss.getInstance = function() {
		if (clss._instance == null) {
			clss._instance = new clss();
		}
		return clss._instance;
	};
	
	return clss;
});
},
'appivo/vue/components/AlertBox':function(){
define([
  'vue/vue',
  'appivo/client/Client',
  'dojo/text!../html/AlertBox.html',
  'dojo/i18n!../nls/AlertBox'
], function(Vue, Client, template, messages) {

	var client = Client.getInstance();

	return Vue.extend({
		name: 'alertbox',
		template: template,
		data: function() {
			return {
				isOpen: false,
				errorObject: {},
				message: {},
				chain1: {},
				chain2: {},
				nextErrorMsgs: [],
				alertTitle: null
			};
		},
		props: {
			position: {
				type: String,
				"default": "bottom-right"
			},
			type: {
				type: String,
				"default": ""
			}
		},
		computed: {
			nextErrors: function() {
				return this.nextErrorMsgs;
			},
			isMobile: function() {
			    return client.isMobile();
			}
		},
		methods: {
			closeAlert: function(){
				this.isOpen = false;
				Vue.set(this, 'nextErrorMsgs', []);
			},
			openAlert: function() {
				var t = this;
				if (this.isOpen) {
					this.isOpen = false;
					Vue.nextTick(function() {
						t.openAlert();
					});
					return;
				}
				this.isOpen = true;
				if (this.type === 'success'){
				    setTimeout(function() {
				    		t.closeAlert();
				    }, 3000);
				}
			}
		},
		events: {
			'AlertBox': function(command, msgType, msg, moreMsg, alertTitle) {
				switch (command) {
				case 'open':
					if (msgType == 'error') {
						this.type = 'danger';
						this.nextErrorMsgs = [];
						if (moreMsg) {
							this.nextErrorMsgs.push(moreMsg);
						}
						if (alertTitle) {
							this.alertTitle = alertTitle;
						}
						if (msg) {
							this.errorObject = msg;
							var localErrorObject = this.errorObject;
							if (localErrorObject != null) {
								var i = 0;
								while (localErrorObject) {
									if (i > 0) {
										this.nextErrorMsgs.push(localErrorObject.errorMessage);
									}
									localErrorObject = localErrorObject.nextErrorCode;
									i++;
								}
							}
						}
					} else if (msgType == 'success') {
						this.type = 'success';
						this.message = msg;
					} else if (msgType == "info") {
						this.type = "info";
						this.message = msg;
					}
					this.openAlert();
					break;
				}
			}
		},
		components: {		
			
		}
	});
});

},
'appivo/page/ApplicationPage':function(){
define(['dojo/_base/lang',
        'dojo/_base/declare',
        'dojo/Deferred',
        'dojo/router',
        'dojo/window',
        'dojo/dom-construct',
        'dojo/io-query',
        'appivo/client/Client',
        'appivo/util/Global',
        'appivo/page/Page',
        'appivo/theme/Theme',
        'appivo/theme/WidgetTheme',
        'appivo/theme/StyleManager',
        "appivo/model/SchemaManager",
        'appivo/fontloader/fontloader',
        'appivo/util/Handlebars',
		'appivo/util/FlightRecorder',
        'dojo/text!./../theme/appivo.json',
        'dojo/i18n!../nls/ApplicationPage'], function(lang, declare, Deferred, router, win, domConstruct, ioQuery, Client, Global, Page, Theme, WidgetTheme, StyleManager, SchemaManager, fontloader, Handlebars, FlightRecorder, DefaultTheme, messages) {

	var FLIGHTRECORDER_MAX_EVENTS = 200;

	var client = Client.getInstance();
    var defaultTheme = JSON.parse(DefaultTheme);

	return declare("appivo.page.ApplicationPage", [appivo.page.Page], {

		viewMgr: null,
		schema: null,
		isMobile: false,
		current: null,
		ui: null,
		loadedApp: null,
		loadedUI: null,
		loadedView: null,
		loadedId: null,
		loadedQuery: null,
		switchingViews: false,
		loading: null,
		cancel: false,
		nextApp: null,
		nextAppDef: null,
		switchingUI: false,
		flightRecorder: null,

		_init: function(def) {
			console.log("ApplicationPage _init");
			this.schemaManager = appivo.model.SchemaManager.getInstance();
			this.detectDevice();
            def.resolve();
		},

		getTitle: function() {
			return this.schema.getName();
		},

		detectDevice: function() {
			this.isMobile = client.isMobile();
		},

		handleEvent: function(event, data, ui) {
			var def = null;
			var t = this;

			if ("app" == event) {
				if (data) {
					if (t.loading) {
						console.log("Already processing an event, cancelling...");
						t.cancel = true;
						t.loading.then(function() {
							console.log("Old event completed successfully");
							t._dispatchEvent(data);
						}, function(error) {
							console.log("Old event failed " + error);
							t._dispatchEvent(data);
						})
					} else {
						t._dispatchEvent(data);
					}
				}
			}

			if (def == null) {
				def = new Deferred();
				def.resolve();
			}

			return def;
		},

		_dispatchEvent: function(data) {
			var t = this;
			console.log("Dispatching app-event " + data.app + " / " + data.ui + " / " + data.view + " / " + data.id);
			var def = this.setApp(data);
			def.then(function() {
				t.dispatching = false;
				t.loading = null;
				t.cancel = false;
			}, function(error) {
				while (error.error) {
					error = error.error;
				}
				t.dispatching = false;
				t.loading = null;
				t.cancel = false;
				t.handleLoadError(error);
			});
			return def;
		},

		handleLoadError: function(error) {
			this.displayError('error', this.newData, "<span>" + error + "</span>");
		},

		alterDestination: function(app) {
			var t = this;
			t.newData = app;
			var path = "#/app/";
			if (app.app) {
				path += app.app;
				if (app.ui) {
					path += "/" + app.ui;
					if (app.view) {
						path += "/" + app.view;
						if (app.id) {
							path += "/" + app.id;
						}
					}
				}
				if (app.query) {
					path = path + "?" + ioQuery.objectToQuery(app.query);
				}
			}
			if (path != location.hash) {
				console.log("Altering destination to " + path);
				location.hash = path;
			}
		},

		_onLeave: function() {
			this.ui = null;
			this.loadedApp = null;
			this.loadedUI = null;
			this.loadedView = null;
			this.loadedId = null;
			this.loadedQuery = null;
			this.pageManager.clearManifestLink();
			client.setOfflineMode('AUTO');
			console.log("Clearing ApplicationPage");
			if (this.viewMgr) {
				this.viewMgr.destroy();
				this.viewMgr = null;
			}
			if (this.theme) {
				this.theme.unset();
			}
            if(this.widgetTheme){
                this.widgetTheme.unset();
            }
		},

		go: function(options) {
			if (this.viewMgr.isReady()) {
				this.pageManager.go(options);
				if (options.query) {
					var view = this.viewMgr.getCurrentView();
					if (view) {
						view.setQuery(options.query);
						view.updateQueryParameters();
					}
				}
			} else {
				console.error("Cannot switch views - ViewManager not ready");
			}
		},

		getRoutingInfo: function() {
			return this.pageManager._getRoutingInfo();
		},

		_switchViewCompleted: function() {
			this.pageManager._switchViewCompleted();
		},

		goHome: function() {
			var cr = this.pageManager._getRoutingInfo();
			var defView = this.viewMgr.getDefaultView();
			this.go({
				app: cr.app,
				ui: cr.ui,
				view: defView
			});
		},

		_setApplication: function() {
			var t = this;
			var hybrid = client.isHybrid();
			var def = this.schemaManager.getSchema(this.newData.app, false, true, hybrid);
			var result = new Deferred();
			def.then(function(schema) {
				t.schema = schema;
				t.flightRecorder = new FlightRecorder({
					size: FLIGHTRECORDER_MAX_EVENTS
				});
				t.schema.flightRecorder = t.flightRecorder;
				Handlebars.getHandlebars(schema, true);
				if (t.newData.tenant) {
					schema.setTenant(t.newData.tenant);
				}

				t.pageManager.setManifestLink(schema);

				var client = Client.getInstance();
				schema.getUserPrivileges().then(function() {
					var config = client.getAppConfig();
					var appTitle = config.AppNamn;
					if (!appTitle) {
						appTitle = t.schema.getName();
					}
					var icon = schema.resources.find(function(res) {
					    return res.system && res.filename === 'app-icon';
					});
					if (icon) {
					    var fallback = "/resources/" + schema.name + "/" + icon.id;
					} else {
					    var fallback = '/images/icons/default-app.png';
					}
					t.pageManager.setWindowDetails({
						title: appTitle,
						mobileSplash: [
						   {
							   // iPhone < 5
							   path: config._MobileSplash_sm,
							   fallback: '/images/splash/small.jpg',
							   media: '(device-width: 320px) and (device-height: 480px) and (-webkit-device-pixel-ratio: 1)'
						   },
						   {
							   // iPhone < 5 Retina
							   path: config._MobileSplash_sm,
							   fallback: '/images/splash/small.jpg',
							   media: '(device-width: 320px) and (device-height: 480px) and (-webkit-device-pixel-ratio: 2)'
						   },
						   {
							   // iPhone 5
							   path: config._MobileSplash_md,
							   fallback: '/images/splash/small.jpg',
							   media: '(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2)'
						   },
						   {
							   // iPhone 6
							   path: config._MobileSplash_md,
							   fallback: '/images/splash/medium.jpg',
							   media: '(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2)'
						   },
						   {
							   // iPhone 6 Plus Portrait
							   path: config._TabletSplash_p,
							   fallback: '/images/splash/medium.jpg',
							   media: '(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)'
						   },
						   {
							   // iPhone 6 Plus Landscape
							   path: config._TabletSplash_l,
							   fallback: '/images/splash/sm.jpg',
							   media: '(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)'
						   },
						   {
							   path: config._TabletSplash_
						   }
						],
						icon: {
							path: config._AppIcon,
							fallback: fallback
						},
						mobileIcons: [
						   {
							   path: config._AppIcon,
							   fallback: fallback
						   },
						   {
							   path: config._AppIcon,
							   fallback: fallback,
							   thumb: true,
							   sizes: '120x120'
						   }
						]
					});

					t.pageManager._setRoutingInfo({
						app: t.newData.app
					});

					result.resolve(true);
				}, function(error) {
					console.log("Failed to load application-context for " + schema.getName());
					result.reject(error);
				});
			}, function(error) {
				result.reject(error);
			});

			return result;
		},

		_isUserInterfaceAccessible: function(ui) {
			return (!ui.requiredPrivileges || this.schema.hasUserPrivileges(ui.requiredPrivileges));
		},

		_setUserInterface: function() {
			var ret = null;
			var ui = this._selectUserInterface(this.schema, this.newData.ui);
			console.log("Setting UI, selected " + (ui ? ui.name : '<none>'));
			if (ui && !this._isUserInterfaceAccessible(ui)) {
				console.log("Not allowed to access " + ui.name);
				ret = new Deferred();
				ret.reject(messages.uinotallowed);
				return ret;
			}
			if (ui) {
				this.newData.ui = ui.name;
				var alter = (ui.name != this.newData.ui);
				if (alter) {
					this.alterDestination(this.newData);
				}
				this.pageManager.setEmbedded(ui.embedded);
				if (this.ui && this.ui.name == ui.name && !this.switchingUI) {
					console.log("UI unchanged, initialize ViewManager");
					ret = this._initViewManager(this.ui);
				} else {
			    	this.detectDevice();
			    	if (ui.type === (this.isMobile ? 'mobile' : 'desktop')) {
				    	ret = this._loadUI(this.schema, ui);
					} else {
				    	ret = new Deferred();
				    	ret.reject(messages.invalid);
					}
				}
			} else {
				ret = new Deferred();
				ret.reject({errorCode: 'noui', message: messages.noui});
			}
			return ret;
		},

		_persistViewState: function() {
			var view = this.viewMgr.getCurrentView();
			var state = this.viewMgr.createViewState(view, this.getRoutingInfo());
		},

		setApp: function(appData, orgDef) {
			var t = this;
			if (t.switchingViews) {
				console.log("View-switch already in progress, queueing");
				console.log(appData);
				t.nextApp = appData;
				if (!t.nextAppDef) {
					t.nextAppDef = new Deferred();
				}
				return t.nextAppDef;
			}
			t.switchingViews = true;
			console.log("ApplicationPage setApp: " + appData.app);
			this.pageManager.showLoadingIndicator(10);
			var res = new Deferred();
			res.then(function() {
				t.switchingViews = false;
				if (t.nextApp) {
					var app = t.nextApp;
					var def = t.nextAppDef;
					t.nextApp = null;
					t.nextAppDef = null;
					window.requestAnimationFrame(function() {
						console.log("Executing queued setView");
						console.log(app);
						t.setApp(app, def);
					});
				}
			}, function(error) {
				t.switchingViews = false;
			});

			this.loading = res;
			var org = orgDef ? orgDef : new Deferred();
			var def = org;
			var force = false;
			this.newData = appData;
			var queryChanged = false;
			var cr = this.pageManager._getRoutingInfo();
			if (appData.query && cr.query) {
				var q1 = ioQuery.objectToQuery(appData.query);
				var q2 = ioQuery.objectToQuery(cr.query);
				queryChanged = q1 != q2;
			} else if (!appData.query && !cr.query) {
				queryChanged = false;
			} else {
				queryChanged = true;
			}

			if (appData.app != cr.app) {
				def = def.then(function() {
					return t._setApplication();
				});
				force = true;
			}
			if (!appData.ui && !cr.ui) {
				def = def.then(function() {
					return t._redirectUI();
				});
				def.then(function() {
					t.pageManager.hideLoadingIndicator();
					t.pageManager._switchViewCompleted();
					t.pageManager.hideLoadingIndicator();
					res.resolve();
				}, function(error) {
					t.pageManager.hideLoadingIndicator();
					res.reject(error);
				});
				org.resolve();
				return res;
			} else {
				if (force || appData.ui != cr.ui) {
					this.switchingUI = (appData.ui != cr.ui && cr.ui !== undefined) || force;
					def = def.then(lang.hitch(this, this._setUserInterface));
					force = true;
				}

				if (!force) {
					force = (cr.id != appData.id) || queryChanged;
				}
				//this.loadedId = null;
				if (force || appData.view != cr.view) {
					def = def.then(lang.hitch(this, this._setView));
				}
			}

			def = def.then(function(res) {
				t.pageManager._switchViewCompleted();
			}, function(response) {
				try {
					var error = response;
					if (error.response && error.response.data) {
						error = error.response.data.error;
					}
					t.newData = null;
					console.error(error);
					var errorCode = 'error';
					var errorMessage = error;
					if (lang.isObject(error)) {
						errorCode = error.errorCode;
						errorMessage = error.message;
					}
					t.displayError(errorCode, appData, errorMessage);
				} catch (err) {
					console.error(err);
				}
				t.pageManager._switchViewCompleted();
			});

			def.then(function() {
				t.currentData = t.newData;
				t.newData = null;
				t.pageManager.hideLoadingIndicator();
				res.resolve();
			}, function(error) {
				console.error(error);
				t.pageManager.hideLoadingIndicator();
				res.reject(error);
			});

			org.resolve();

			return res;
		},

		_filterAllowedUserInterfaces: function(uis, allowPublic) {
			var filtered = new Array();
			for (var i in uis) {
				var ui = uis[i];
				if (client.isAnonymousDispatch() && !allowPublic) {
					if (ui.publicAccess) {
						filtered.push(ui);
					}
				} else {
					if (!ui.requiredPrivileges || this.schema.hasUserPrivileges(ui.requiredPrivileges)) {
						filtered.push(ui);
					}
				}
			}

			filtered.sort(function(a,b) {
				var ret = 0;
				if (a.publicAccess && !b.publicAccess) {
					ret = 1;
				}
				if (!a.publicAccess && b.publicAccess) {
					ret = -1;
				}
				if (allowPublic) {
					ret = -ret;
				}
				return ret;
			});
			return filtered;
		},

		_redirectUI: function() {
			var ui = this._selectUserInterface(this.schema);
			if (ui) {
				this.newData.ui = ui.name;
				this.pageManager._setRoutingInfo({
					app: this.schema.name
				});
				console.log("Redirecting to " + this.schema.name + " UI: " + ui.name);
				var redirectData = {
					app: this.schema.name,
					ui: ui.name
				};
				if (this.newData.view) {
					redirectData.view = this.newData.view;
				}
				if (this.newData.id) {
					redirectData.id = this.newData.id;
				}
				if (this.newData.query) {
					redirectData.query = this.newData.query;
				}
				this.pageManager.go(redirectData);
			} else {
				this.pageManager._switchViewCompleted();
				this.displayError('noui', this.newData, "UI not available. <span>Looks like the interface has not been created for this app yet.</span>");
			}
			return ui;
		},

		_selectUserInterface: function(schema, uiName) {
			var type = this.isMobile ? 'mobile' : 'desktop';
			var winBox = win.getBox();
			var screenWidth = winBox.w;
			var selUi = null;

			console.log("Selecting UserInterface: " + type + " screen-width: " + screenWidth);

			if (!uiName || uiName === '?' || uiName === '*') {
				var uis = this._filterAllowedUserInterfaces(schema.getUserInterfaces(), uiName === '*');
				var selected = this._filterUserInterfaces(uis, type, screenWidth);
				if (selected.length > 0) {
					selUi = selected[0];
				}
			} else {
				var ui = schema.getUserInterface(uiName);
				if (ui) {
					if (ui.publicAccess) {
						var uis = this._filterAllowedUserInterfaces(schema.getUserInterfaces());
						var selected = this._filterUserInterfaces(uis, type, screenWidth);
						if (selected.length > 0) {
							var publicAllowed = false;
							for (var i = 0; i < selected.length; i++) {
								if (ui.name == selected[i].name) {
									publicAllowed = true;
									break;
								}
							}
							if (!publicAllowed) {
								// Public UI wasnt allowed, use the first accessible one instead
								ui = selected[0];
							}
						}
					}
					selUi = ui;
				}
			}

			console.log("Selected UserInterface " + (selUi ? selUi.name : '<none>'));

			return selUi ;
		},

		_filterUserInterfaces: function(uis, type, screenWidth) {
			var list = new Array();
			for (var i in uis) {
				var ui = uis[i];
				var selected = null;
				if (type) {
					if (type == ui.type) {
						selected = ui;
					}
				} else {
					selected = ui;
				}
				if (type == 'desktop' && ui.type == 'desktop' && screenWidth) {
					// REMIND: TODO - Figure this out...
					/*
					if (screenWidth > ui.width) {
						selected = null;
					}
					*/
				}
				if (selected) {
					list.push(selected);
				}
			}
			return list;
		},

		_loadWidgetDefs: function(ui) {
			var def = new Deferred();
			var types = {
				desktop: ['appivo/mvc/DesktopWidgetDefinitions'],
				mobile: ['appivo/mvc/MobileWidgetDefinitions']
			};
			var widgetDefs = types[ui.type];
			require(widgetDefs, function(defs) {
				console.log("Loaded WidgetDefinitions: " + widgetDefs);
				def.resolve(defs);
			});
			return def;
		},

		_loadUI: function(schema, ui) {
			var t = this;
			var def = new Deferred();
			t._loadWidgetDefs(ui).then(function() {
				var uiUrl = '/api/app/' + schema.name + '/ui/' + ui.name;
				console.log("Loading UI from " + uiUrl);
				var promise = client.sendRequest(uiUrl, {});
				promise.then(function(ui) {
					console.log("Loaded UI " + ui.name + ", initializing ViewManager")
					if (!t.cancel) {
						if (ui.offlineMode) {
							client.setOfflineMode(ui.offlineMode);
						}
						t._initViewManager(ui).then(function() {
							t.switchingUI = false;
							console.log("ViewManager initialized");
							def.resolve();
						}, function(err) {
							t.switchingUI = false;
							console.error("Failed to initialize ViewManager");
							console.error(err);
							def.reject(err);
						});
					} else {
						def.reject("Destination changed");
					}
				}, function(error) {
					console.log("Failed to load widget-defs: " + error);
					def.reject(error);
				});
			});
			return def;
		},

		loadTheme: function(ui) {
			var t = this;

            var baseTheme = null;
            if (ui.baseTheme) {
                var bt = ui.themes.find(function (themeItem) {
                    return (themeItem.id === ui.baseTheme);
                });
                baseTheme = bt ? bt.data : null;
            } else {
                baseTheme = ui.theme;
            }

            if (!baseTheme){
                console.log("Theme Value not found");
                baseTheme = defaultTheme.data;
            }

			t.theme = new Theme({
				schema: t.schema,
				vars: baseTheme,
				config: {
					loadMobile: t.ui.type == 'mobile',
					wrapperClass: '.page-level-theme'
				}
			});
			t.theme.set();

			if(ui.widgetTheme){
				fontloader.loadViewFonts(baseTheme, {views: ui.views}, ui.widgetTheme);
				t.widgetTheme = new WidgetTheme({
					widgetTheme: ui.widgetTheme,
					baseTheme: baseTheme,
					domNode: t.container,
					ui: ui.type
				});
				t.widgetTheme.set();
			} else {
				fontloader.loadViewFonts(baseTheme, {views: ui.views});
			}

		},

		displayError: function(errorCode, app, error) {
		},

		destroy: function() {
			this.inherited(arguments);
			if (this.viewMgr) {
				this.viewMgr.destroy();
			}
		}
	});
});

},
'appivo/theme/Theme':function(){
define(['appivo/util/Handlebars',
        'dojo/text!./css/theme.txt'], 
        
  function(Handlebars, theme) {
		
	function Theme(options) {
		this.$options = options ? options : {};
		this.template = Handlebars.compile(theme);
	};
	
	Theme.prototype = {
			
		constructor: Theme,	
		node: null,
		
		_install: function() {
			if (!this.node) {
				var node = document.createElement('style');
				node.type = 'text/css';
				node.id = "customstyle";
				var domNode = this.$options.domNode ? this.$options.domNode : document.getElementsByTagName('head')[0];
				domNode.appendChild(node);
				this.node = node;
			}
		},

		_uninstall: function() {
			if (this.node && this.node.parentNode) {
				this.node.parentNode.removeChild(this.node);
			}
		},

		_processVars: function(vars) {
			if (!vars) {
				console.log("empty theme processing");
				return {};
			}
			var bgoption = 'bg' + vars.bgoption;
			var v = {};
			for (var key in vars) {
				var val = vars[key];
				if (val) {
					if (key.indexOf('image') >= 0 && !(val.indexOf('/files/') == 0)) {
					    if (val.indexOf("http")!= 0){
						    val = '/files/' + val;
						}
					}
				}
				if ((key != 'bgimage' && key != 'bggradient' && key != 'bgcolor') || key == bgoption) {
				    v[key] = val;
				}
 			}
			return v;
		},

		_render: function(vars) {
			if (!vars) {
				vars = this.$options.vars;
			}
			var pvars = this._processVars(vars);
			var otherConfig = this.$options.config;
			if (otherConfig) {
				pvars = Object.assign(pvars, otherConfig);
			}
			var css = this.template(pvars);
			if (!this.node) {
				this._install();
			}
			// nosemgrep: insecure-document-method
			this.node.innerHTML = css;
		},

		set: function(vars) {
			this._render(vars);
		},

		unset: function() {
			this._uninstall();
		}
	};

	return Theme;
  }
);

},
'appivo/theme/WidgetTheme':function(){
define(['appivo/util/Handlebars',
        'appivo/mvc/WidgetDefinitions'
    ],
    function (Handlebars, WidgetDefinitions) {

        function WidgetTheme(options) {
            this.options = options ? options : {};
        };
        var templateCache = {};

        WidgetTheme.prototype = {
            widgets: {},

            constructor: WidgetTheme,

            _install: function () {
                if (!this.node) {
                    var node = document.createElement('style');
                    node.type = 'text/css';
                    node.id = "customstyle";
                    var domNode = this.options.domNode ? this.options.domNode : document.getElementsByTagName('head')[0];
                    domNode.appendChild(node);
                    this.node = node;
                }
            },

            _uninstall: function () {
                var domNode = this.options.domNode ? this.options.domNode : document.getElementsByTagName('head')[0];

                for (var widgetItem in this.widgets) {
                    var toRemove = this.widgets[widgetItem];
                    var index = domNode.contains(toRemove);
                    if (index) {
                        domNode.removeChild(toRemove);
                        delete this.widgets[widgetItem];
                    }
                }
            },

            _render: function (vars) {
                if (!vars) {
                    vars = this.options.vars;
                }
                var mode = this.options.ui ? this.options.ui : "desktop";
                var defs = WidgetDefinitions.getDefinitions(mode);
                for (var widgetItem in this.options.widgetTheme) {
                    var selectedWidget = defs.find(function (widget) {
                        return (widget.name === widgetItem);
                    });

                    var template = Handlebars.compile(selectedWidget.styleTemplate);
                    templateCache[widgetItem] = template;
                    var widgetStyleValues = this.options.widgetTheme[widgetItem];

                    var styleWithValues = {}, baseTheme = this.options.baseTheme;
                    if (baseTheme) {
                        for (var ref in widgetStyleValues) {
                            if (baseTheme[widgetStyleValues[ref]]) {
                                styleWithValues[ref] = baseTheme[widgetStyleValues[ref]];
                            } else {
                                styleWithValues[ref] = widgetStyleValues[ref];
                            }
                        }
                    } else {
                        styleWithValues = widgetStyleValues;
                    }
                    styleWithValues.className = "ap-" + widgetItem;

                    var css = template(styleWithValues);

                    var node = document.createElement('style');
                    node.type = 'text/css';
                    node.id = widgetItem;
                    this.widgets[widgetItem] = node;
                    var domNode = this.options.domNode ? this.options.domNode : document.getElementsByTagName('head')[0];
                    domNode.appendChild(node);
                    // nosemgrep: insecure-document-method
                    node.innerHTML = css
                }
            },

            resetWidgetStyle: function (widgetName) {
                var domNode = this.options.domNode ? this.options.domNode : document.getElementsByTagName('head')[0];
                var widgetItem = this.widgets[widgetName];
                if (widgetItem) {
                    domNode.removeChild(widgetItem);
                    delete this.widgets[widgetName];
                }
            },

            setWidgetStyle: function (widget, style) {
                var node = this.widgets[widget.id];
                var template = templateCache[widget.id];
                if (!template) {
                    template = Handlebars.compile(widget.widgetDef.styleTemplate);
                }
                var styleWithValues = {}, baseTheme = this.options.baseTheme;
                if (baseTheme) {
                    for (var ref in style) {
                        if (baseTheme[style[ref]]) {
                            styleWithValues[ref] = baseTheme[style[ref]];
                        } else {
                            styleWithValues[ref] = style[ref];
                        }
                    }
                } else {
                    styleWithValues = style;
                }
                styleWithValues.className = "ap-" + widget.id;
                var css = template(styleWithValues);

                if (!node) {
                    node = document.createElement('style');
                    node.type = 'text/css';
                    node.id = widget.id;
                    var domNode = this.options.domNode ? this.options.domNode : document.getElementsByTagName('head')[0];
                    domNode.appendChild(node);
                    this.widgets[widget.id] = node;
                }
                // nosemgrep: insecure-document-method
                node.innerHTML = css;
            },

            setStyleByTemplate: function (id, style, templateVal) {
                var node = this.widgets[id];
                var template = templateCache[id];
                if (!template) {
                    template = Handlebars.compile(templateVal);
                    templateCache[id] = template;
                }


                var styleWithValues = {}, baseTheme = this.options.baseTheme;
                if (baseTheme) {
                    for (var ref in style) {
                        if (baseTheme[style[ref]]) {
                            styleWithValues[ref] = baseTheme[style[ref]];
                        } else {
                            styleWithValues[ref] = style[ref];
                        }
                    }
                } else {
                    styleWithValues = style;
                }
                styleWithValues['className'] = id;
                var css = template(styleWithValues);


                if (!node) {
                    node = document.createElement('style');
                    node.type = 'text/css';
                    node.id = id;
                    var domNode = this.options.domNode ? this.options.domNode : document.getElementsByTagName('head')[0];
                    domNode.appendChild(node);
                    this.widgets[id] = node;
                }
                // nosemgrep: insecure-document-method
                node.innerHTML = css;

            },

            set: function (vars) {
                this._render(vars);
            },

            unset: function () {
                this._uninstall();
            }
        };

        return WidgetTheme;
    }
);

},
'appivo/fontloader/fontloader':function(){
define([
		'webfontloader/webfont',
		'dojo/text!./../gen/handlebars/palettes/FontDirectory.json'
	], function (WebFontLoader, fontDirectory) {
	var FontDirectory = JSON.parse(fontDirectory);
	return {

		getFontsByTheme: function (themeData, views) {
			if (!themeData || Object.keys(themeData).length == 0) {
				return [];
			}

			var widgetFonts = []
			if (views) {
				widgetFonts = this.getFontsForViews(views)
			}

			var fonts = [themeData.bodyfontfamily, themeData.headingfontfamily];

			return fonts.concat(widgetFonts)
		},

		loadViewFonts: function (themeData, options, widgetTheme) {
			const set = new Set();
			let views;
			if (options) {
				views = options.views;
			}
			for (const font of this.getFontsByTheme(themeData, views)) {
				if (font) {
					set.add(font);
				}
			}
			if (widgetTheme) {
				for (const font of this.getFontsByWidgetTheme(widgetTheme)) {
					if (font) {
						set.add(font);
					}
				}
			}
			this.loadFonts(Array.from(set));
		},

		loadFonts: function (fonts, options) {
			if (!options) {
				options = {};
			}
			var toLoad = [];
			for (var i = 0; i < fonts.length; i++) {
				var fontFamily = fonts[i];
				var toSet = null;
				if (fontFamily) {
					toSet = FontDirectory.items.find(function (item) {
						return (item.family.toLowerCase() === fontFamily.toLowerCase());
					});
				}
				if (toSet){
					fontFamily = toSet.family;
					var weight = toSet.variants;
					fontFamily += ":"+weight.map(el => this.getFontVariationIdentifier(el)).join();
					toLoad.push(fontFamily);
				}
			}

			if (toLoad.length > 0) {
				WebFontLoader.load({
					google:{
						families : toLoad
					},
					context: options.context,
					loading: options.loading,
					active: options.active
				});
			}
		},

		getFontsByWidgetTheme: function (widgetTheme) {
			var fonts = [];
			for (const widgetName in widgetTheme) {
				const widget = widgetTheme[widgetName];
				if (widget.fontFamily) {
					fonts.push(widget.fontFamily);
				}
			}
			return fonts;
		},

		getFontsForViews: function (views) {
			var fonts = new Set();
			for (var i = 0; i < views.length; i++) {
				var view = views[i];
				fonts = this.fontSearch(view, fonts);
			}
			return Array.from(fonts);
		},

		/** Recursive function to search widget tree for nodes with styleProps.fontFamily. */
		fontSearch: function (node, fonts) {
			if (node.children) {
				for (var i = 0; i < node.children.length; i++) {
					fonts = this.fontSearch(node.children[i], fonts);
				}
			}
			if (node.styleProps && node.styleProps.fontFamily) {
				fonts.add(node.styleProps.fontFamily);
			}
			return fonts;
		},

		/** @param {string} str @returns {string} */
		getFontVariationIdentifier: function(str) {
			if(str == "regular") { return "400" };
			if(str == "italic") { return "400i" };
			var match = str.match(/([0-9]+i?)/)
			return match ? match[1] : str;
		},

		loadFontByName:function (values, options) {
			var toLoad = [];
			if (!options) {
				options = {};
			}

			for (var i = 0; i < values.length; i++) {
				var fontFamily = values[i];
				var toSet = null;
				if (fontFamily) {
					toSet = FontDirectory.items.find(function (item) {
						return (item.family.toLowerCase() === fontFamily.toLowerCase());
					});
				}
				if (toSet) {
					fontFamily = toSet.family;
					var weight = toSet.variants;
					fontFamily += ":"+weight.map(el => this.getFontVariationIdentifier(el)).join();
					toLoad.push(fontFamily);
				}
			}

			if (toLoad.length > 0) {
				WebFontLoader.load({
					google: {
						families: toLoad
					},
					context: options.context,
					loading: options.loading,
					active: options.active
				});
			}
		}
	}
});

},
'webfontloader/webfont':function(){
/*
 * Copyright 2016 Small Batch, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not
 * use this file except in compliance with the License. You may obtain a copy of
 * the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 */
/* Web Font Loader v1.6.26 - (c) Adobe Systems, Google. License: Apache 2.0 */
(function() {
    function aa(a, b, c) {
        return a.call.apply(a.bind, arguments)
    }
    function ba(a, b, c) {
        if (!a)
            throw Error();
        if (2 < arguments.length) {
            var d = Array.prototype.slice.call(arguments, 2);
            return function() {
                var c = Array.prototype.slice.call(arguments);
                Array.prototype.unshift.apply(c, d);
                return a.apply(b, c)
            }
        }
        return function() {
            return a.apply(b, arguments)
        }
    }
    function p(a, b, c) {
        p = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? aa : ba;
        return p.apply(null, arguments)
    }
    var q = Date.now || function() {
        return +new Date
    }
    ;
    function ca(a, b) {
        this.a = a;
        this.m = b || a;
        this.c = this.m.document
    }
    var da = !!window.FontFace;
    function t(a, b, c, d) {
        b = a.c.createElement(b);
        if (c)
            for (var e in c)
                c.hasOwnProperty(e) && ("style" == e ? b.style.cssText = c[e] : b.setAttribute(e, c[e]));
        d && b.appendChild(a.c.createTextNode(d));
        return b
    }
    function u(a, b, c) {
        a = a.c.getElementsByTagName(b)[0];
        a || (a = document.documentElement);
        a.insertBefore(c, a.lastChild)
    }
    function v(a) {
        a.parentNode && a.parentNode.removeChild(a)
    }
    function w(a, b, c) {
        b = b || [];
        c = c || [];
        for (var d = a.className.split(/\s+/), e = 0; e < b.length; e += 1) {
            for (var f = !1, g = 0; g < d.length; g += 1)
                if (b[e] === d[g]) {
                    f = !0;
                    break
                }
            f || d.push(b[e])
        }
        b = [];
        for (e = 0; e < d.length; e += 1) {
            f = !1;
            for (g = 0; g < c.length; g += 1)
                if (d[e] === c[g]) {
                    f = !0;
                    break
                }
            f || b.push(d[e])
        }
        a.className = b.join(" ").replace(/\s+/g, " ").replace(/^\s+|\s+$/, "")
    }
    function y(a, b) {
        for (var c = a.className.split(/\s+/), d = 0, e = c.length; d < e; d++)
            if (c[d] == b)
                return !0;
        return !1
    }
    function z(a) {
        if ("string" === typeof a.f)
            return a.f;
        var b = a.m.location.protocol;
        "about:" == b && (b = a.a.location.protocol);
        return "https:" == b ? "https:" : "http:"
    }
    function ea(a) {
        return a.m.location.hostname || a.a.location.hostname
    }
    function A(a, b, c) {
        function d() {
            k && e && f && (k(g),
            k = null)
        }
        b = t(a, "link", {
            rel: "stylesheet",
            href: b,
            media: "all"
        });
        var e = !1
          , f = !0
          , g = null
          , k = c || null;
        da ? (b.onload = function() {
            e = !0;
            d()
        }
        ,
        b.onerror = function() {
            e = !0;
            g = Error("Stylesheet failed to load");
            d()
        }
        ) : setTimeout(function() {
            e = !0;
            d()
        }, 0);
        u(a, "head", b)
    }
    function B(a, b, c, d) {
        var e = a.c.getElementsByTagName("head")[0];
        if (e) {
            var f = t(a, "script", {
                src: b
            })
              , g = !1;
            f.onload = f.onreadystatechange = function() {
                g || this.readyState && "loaded" != this.readyState && "complete" != this.readyState || (g = !0,
                c && c(null),
                f.onload = f.onreadystatechange = null,
                "HEAD" == f.parentNode.tagName && e.removeChild(f))
            }
            ;
            e.appendChild(f);
            setTimeout(function() {
                g || (g = !0,
                c && c(Error("Script load timeout")))
            }, d || 5E3);
            return f
        }
        return null
    }
    ;function C() {
        this.a = 0;
        this.c = null
    }
    function D(a) {
        a.a++;
        return function() {
            a.a--;
            E(a)
        }
    }
    function F(a, b) {
        a.c = b;
        E(a)
    }
    function E(a) {
        0 == a.a && a.c && (a.c(),
        a.c = null)
    }
    ;function G(a) {
        this.a = a || "-"
    }
    G.prototype.c = function(a) {
        for (var b = [], c = 0; c < arguments.length; c++)
            b.push(arguments[c].replace(/[\W_]+/g, "").toLowerCase());
        return b.join(this.a)
    }
    ;
    function H(a, b) {
        this.c = a;
        this.f = 4;
        this.a = "n";
        var c = (b || "n4").match(/^([nio])([1-9])$/i);
        c && (this.a = c[1],
        this.f = parseInt(c[2], 10))
    }
    function fa(a) {
        return I(a) + " " + (a.f + "00") + " 300px " + J(a.c)
    }
    function J(a) {
        var b = [];
        a = a.split(/,\s*/);
        for (var c = 0; c < a.length; c++) {
            var d = a[c].replace(/['"]/g, "");
            -1 != d.indexOf(" ") || /^\d/.test(d) ? b.push("'" + d + "'") : b.push(d)
        }
        return b.join(",")
    }
    function K(a) {
        return a.a + a.f
    }
    function I(a) {
        var b = "normal";
        "o" === a.a ? b = "oblique" : "i" === a.a && (b = "italic");
        return b
    }
    function ga(a) {
        var b = 4
          , c = "n"
          , d = null;
        a && ((d = a.match(/(normal|oblique|italic)/i)) && d[1] && (c = d[1].substr(0, 1).toLowerCase()),
        (d = a.match(/([1-9]00|normal|bold)/i)) && d[1] && (/bold/i.test(d[1]) ? b = 7 : /[1-9]00/.test(d[1]) && (b = parseInt(d[1].substr(0, 1), 10))));
        return c + b
    }
    ;function ha(a, b) {
        this.c = a;
        this.f = a.m.document.documentElement;
        this.h = b;
        this.a = new G("-");
        this.j = !1 !== b.events;
        this.g = !1 !== b.classes
    }
    function ia(a) {
        a.g && w(a.f, [a.a.c("wf", "loading")]);
        L(a, "loading")
    }
    function M(a) {
        if (a.g) {
            var b = y(a.f, a.a.c("wf", "active"))
              , c = []
              , d = [a.a.c("wf", "loading")];
            b || c.push(a.a.c("wf", "inactive"));
            w(a.f, c, d)
        }
        L(a, "inactive")
    }
    function L(a, b, c) {
        if (a.j && a.h[b])
            if (c)
                a.h[b](c.c, K(c));
            else
                a.h[b]()
    }
    ;function ja() {
        this.c = {}
    }
    function ka(a, b, c) {
        var d = [], e;
        for (e in b)
            if (b.hasOwnProperty(e)) {
                var f = a.c[e];
                f && d.push(f(b[e], c))
            }
        return d
    }
    ;function N(a, b) {
        this.c = a;
        this.f = b;
        this.a = t(this.c, "span", {
            "aria-hidden": "true"
        }, this.f)
    }
    function O(a) {
        u(a.c, "body", a.a)
    }
    function P(a) {
        return "display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:" + J(a.c) + ";" + ("font-style:" + I(a) + ";font-weight:" + (a.f + "00") + ";")
    }
    ;function Q(a, b, c, d, e, f) {
        this.g = a;
        this.j = b;
        this.a = d;
        this.c = c;
        this.f = e || 3E3;
        this.h = f || void 0
    }
    Q.prototype.start = function() {
        var a = this.c.m.document
          , b = this
          , c = q()
          , d = new Promise(function(d, e) {
            function k() {
                q() - c >= b.f ? e() : a.fonts.load(fa(b.a), b.h).then(function(a) {
                    1 <= a.length ? d() : setTimeout(k, 25)
                }, function() {
                    e()
                })
            }
            k()
        }
        )
          , e = new Promise(function(a, d) {
            setTimeout(d, b.f)
        }
        );
        Promise.race([e, d]).then(function() {
            b.g(b.a)
        }, function() {
            b.j(b.a)
        })
    }
    ;
    function R(a, b, c, d, e, f, g) {
        this.v = a;
        this.B = b;
        this.c = c;
        this.a = d;
        this.s = g || "BESbswy";
        this.f = {};
        this.w = e || 3E3;
        this.u = f || null;
        this.o = this.j = this.h = this.g = null;
        this.g = new N(this.c,this.s);
        this.h = new N(this.c,this.s);
        this.j = new N(this.c,this.s);
        this.o = new N(this.c,this.s);
        a = new H(this.a.c + ",serif",K(this.a));
        a = P(a);
        this.g.a.style.cssText = a;
        a = new H(this.a.c + ",sans-serif",K(this.a));
        a = P(a);
        this.h.a.style.cssText = a;
        a = new H("serif",K(this.a));
        a = P(a);
        this.j.a.style.cssText = a;
        a = new H("sans-serif",K(this.a));
        a = P(a);
        this.o.a.style.cssText = a;
        O(this.g);
        O(this.h);
        O(this.j);
        O(this.o)
    }
    var S = {
        D: "serif",
        C: "sans-serif"
    }
      , T = null;
    function U() {
        if (null === T) {
            var a = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);
            T = !!a && (536 > parseInt(a[1], 10) || 536 === parseInt(a[1], 10) && 11 >= parseInt(a[2], 10))
        }
        return T
    }
    R.prototype.start = function() {
        this.f.serif = this.j.a.offsetWidth;
        this.f["sans-serif"] = this.o.a.offsetWidth;
        this.A = q();
        la(this)
    }
    ;
    function ma(a, b, c) {
        for (var d in S)
            if (S.hasOwnProperty(d) && b === a.f[S[d]] && c === a.f[S[d]])
                return !0;
        return !1
    }
    function la(a) {
        var b = a.g.a.offsetWidth, c = a.h.a.offsetWidth, d;
        (d = b === a.f.serif && c === a.f["sans-serif"]) || (d = U() && ma(a, b, c));
        d ? q() - a.A >= a.w ? U() && ma(a, b, c) && (null === a.u || a.u.hasOwnProperty(a.a.c)) ? V(a, a.v) : V(a, a.B) : na(a) : V(a, a.v)
    }
    function na(a) {
        setTimeout(p(function() {
            la(this)
        }, a), 50)
    }
    function V(a, b) {
        setTimeout(p(function() {
            v(this.g.a);
            v(this.h.a);
            v(this.j.a);
            v(this.o.a);
            b(this.a)
        }, a), 0)
    }
    ;function W(a, b, c) {
        this.c = a;
        this.a = b;
        this.f = 0;
        this.o = this.j = !1;
        this.s = c
    }
    var X = null;
    W.prototype.g = function(a) {
        var b = this.a;
        b.g && w(b.f, [b.a.c("wf", a.c, K(a).toString(), "active")], [b.a.c("wf", a.c, K(a).toString(), "loading"), b.a.c("wf", a.c, K(a).toString(), "inactive")]);
        L(b, "fontactive", a);
        this.o = !0;
        oa(this)
    }
    ;
    W.prototype.h = function(a) {
        var b = this.a;
        if (b.g) {
            var c = y(b.f, b.a.c("wf", a.c, K(a).toString(), "active"))
              , d = []
              , e = [b.a.c("wf", a.c, K(a).toString(), "loading")];
            c || d.push(b.a.c("wf", a.c, K(a).toString(), "inactive"));
            w(b.f, d, e)
        }
        L(b, "fontinactive", a);
        oa(this)
    }
    ;
    function oa(a) {
        0 == --a.f && a.j && (a.o ? (a = a.a,
        a.g && w(a.f, [a.a.c("wf", "active")], [a.a.c("wf", "loading"), a.a.c("wf", "inactive")]),
        L(a, "active")) : M(a.a))
    }
    ;function pa(a) {
        this.j = a;
        this.a = new ja;
        this.h = 0;
        this.f = this.g = !0
    }
    pa.prototype.load = function(a) {
        this.c = new ca(this.j,a.context || this.j);
        this.g = !1 !== a.events;
        this.f = !1 !== a.classes;
        qa(this, new ha(this.c,a), a)
    }
    ;
    function ra(a, b, c, d, e) {
        var f = 0 == --a.h;
        (a.f || a.g) && setTimeout(function() {
            var a = e || null
              , k = d || null || {};
            if (0 === c.length && f)
                M(b.a);
            else {
                b.f += c.length;
                f && (b.j = f);
                var h, m = [];
                for (h = 0; h < c.length; h++) {
                    var l = c[h]
                      , n = k[l.c]
                      , r = b.a
                      , x = l;
                    r.g && w(r.f, [r.a.c("wf", x.c, K(x).toString(), "loading")]);
                    L(r, "fontloading", x);
                    r = null;
                    null === X && (X = window.FontFace ? (x = /Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent)) ? 42 < parseInt(x[1], 10) : !0 : !1);
                    X ? r = new Q(p(b.g, b),p(b.h, b),b.c,l,b.s,n) : r = new R(p(b.g, b),p(b.h, b),b.c,l,b.s,a,n);
                    m.push(r)
                }
                for (h = 0; h < m.length; h++)
                    m[h].start()
            }
        }, 0)
    }
    function qa(a, b, c) {
        var d = []
          , e = c.timeout;
        ia(b);
        var d = ka(a.a, c, a.c)
          , f = new W(a.c,b,e);
        a.h = d.length;
        b = 0;
        for (c = d.length; b < c; b++)
            d[b].load(function(b, d, c) {
                ra(a, f, b, d, c)
            })
    }
    ;function sa(a, b) {
        this.c = a;
        this.a = b
    }
    function ta(a, b, c) {
        var d = z(a.c);
        a = (a.a.api || "fast.fonts.net/jsapi").replace(/^.*http(s?):(\/\/)?/, "");
        return d + "//" + a + "/" + b + ".js" + (c ? "?v=" + c : "")
    }
    sa.prototype.load = function(a) {
        function b() {
            if (f["__mti_fntLst" + d]) {
                var c = f["__mti_fntLst" + d](), e = [], h;
                if (c)
                    for (var m = 0; m < c.length; m++) {
                        var l = c[m].fontfamily;
                        void 0 != c[m].fontStyle && void 0 != c[m].fontWeight ? (h = c[m].fontStyle + c[m].fontWeight,
                        e.push(new H(l,h))) : e.push(new H(l))
                    }
                a(e)
            } else
                setTimeout(function() {
                    b()
                }, 50)
        }
        var c = this
          , d = c.a.projectId
          , e = c.a.version;
        if (d) {
            var f = c.c.m;
            B(this.c, ta(c, d, e), function(e) {
                e ? a([]) : (f["__MonotypeConfiguration__" + d] = function() {
                    return c.a
                }
                ,
                b())
            }).id = "__MonotypeAPIScript__" + d
        } else
            a([])
    }
    ;
    function ua(a, b) {
        this.c = a;
        this.a = b
    }
    ua.prototype.load = function(a) {
        var b, c, d = this.a.urls || [], e = this.a.families || [], f = this.a.testStrings || {}, g = new C;
        b = 0;
        for (c = d.length; b < c; b++)
            A(this.c, d[b], D(g));
        var k = [];
        b = 0;
        for (c = e.length; b < c; b++)
            if (d = e[b].split(":"),
            d[1])
                for (var h = d[1].split(","), m = 0; m < h.length; m += 1)
                    k.push(new H(d[0],h[m]));
            else
                k.push(new H(d[0]));
        F(g, function() {
            a(k, f)
        })
    }
    ;
    function va(a, b, c) {
        a ? this.c = a : this.c = b + wa;
        this.a = [];
        this.f = [];
        this.g = c || ""
    }
    var wa = "//fonts.googleapis.com/css";
    function xa(a, b) {
        for (var c = b.length, d = 0; d < c; d++) {
            var e = b[d].split(":");
            3 == e.length && a.f.push(e.pop());
            var f = "";
            2 == e.length && "" != e[1] && (f = ":");
            a.a.push(e.join(f))
        }
    }
    function ya(a) {
        if (0 == a.a.length)
            throw Error("No fonts to load!");
        if (-1 != a.c.indexOf("kit="))
            return a.c;
        for (var b = a.a.length, c = [], d = 0; d < b; d++)
            c.push(a.a[d].replace(/ /g, "+"));
        b = a.c + "?family=" + c.join("%7C");
        0 < a.f.length && (b += "&subset=" + a.f.join(","));
        0 < a.g.length && (b += "&text=" + encodeURIComponent(a.g));
        return b
    }
    ;function za(a) {
        this.f = a;
        this.a = [];
        this.c = {}
    }
    var Aa = {
        latin: "BESbswy",
        "latin-ext": "\u00e7\u00f6\u00fc\u011f\u015f",
        cyrillic: "\u0439\u044f\u0416",
        greek: "\u03b1\u03b2\u03a3",
        khmer: "\u1780\u1781\u1782",
        Hanuman: "\u1780\u1781\u1782"
    }
      , Ba = {
        thin: "1",
        extralight: "2",
        "extra-light": "2",
        ultralight: "2",
        "ultra-light": "2",
        light: "3",
        regular: "4",
        book: "4",
        medium: "5",
        "semi-bold": "6",
        semibold: "6",
        "demi-bold": "6",
        demibold: "6",
        bold: "7",
        "extra-bold": "8",
        extrabold: "8",
        "ultra-bold": "8",
        ultrabold: "8",
        black: "9",
        heavy: "9",
        l: "3",
        r: "4",
        b: "7"
    }
      , Ca = {
        i: "i",
        italic: "i",
        n: "n",
        normal: "n"
    }
      , Da = /^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
    function Ea(a) {
        for (var b = a.f.length, c = 0; c < b; c++) {
            var d = a.f[c].split(":")
              , e = d[0].replace(/\+/g, " ")
              , f = ["n4"];
            if (2 <= d.length) {
                var g;
                var k = d[1];
                g = [];
                if (k)
                    for (var k = k.split(","), h = k.length, m = 0; m < h; m++) {
                        var l;
                        l = k[m];
                        if (l.match(/^[\w-]+$/)) {
                            var n = Da.exec(l.toLowerCase());
                            if (null == n)
                                l = "";
                            else {
                                l = n[2];
                                l = null == l || "" == l ? "n" : Ca[l];
                                n = n[1];
                                if (null == n || "" == n)
                                    n = "4";
                                else
                                    var r = Ba[n]
                                      , n = r ? r : isNaN(n) ? "4" : n.substr(0, 1);
                                l = [l, n].join("")
                            }
                        } else
                            l = "";
                        l && g.push(l)
                    }
                0 < g.length && (f = g);
                3 == d.length && (d = d[2],
                g = [],
                d = d ? d.split(",") : g,
                0 < d.length && (d = Aa[d[0]]) && (a.c[e] = d))
            }
            a.c[e] || (d = Aa[e]) && (a.c[e] = d);
            for (d = 0; d < f.length; d += 1)
                a.a.push(new H(e,f[d]))
        }
    }
    ;function Fa(a, b) {
        this.c = a;
        this.a = b
    }
    var Ga = {
        Arimo: !0,
        Cousine: !0,
        Tinos: !0
    };
    Fa.prototype.load = function(a) {
        var b = new C
          , c = this.c
          , d = new va(this.a.api,z(c),this.a.text)
          , e = this.a.families;
        xa(d, e);
        var f = new za(e);
        Ea(f);
        A(c, ya(d), D(b));
        F(b, function() {
            a(f.a, f.c, Ga)
        })
    }
    ;
    function Ha(a, b) {
        this.c = a;
        this.a = b
    }
    Ha.prototype.load = function(a) {
        var b = this.a.id
          , c = this.c.m;
        b ? B(this.c, (this.a.api || "https://use.typekit.net") + "/" + b + ".js", function(b) {
            if (b)
                a([]);
            else if (c.Typekit && c.Typekit.config && c.Typekit.config.fn) {
                b = c.Typekit.config.fn;
                for (var e = [], f = 0; f < b.length; f += 2)
                    for (var g = b[f], k = b[f + 1], h = 0; h < k.length; h++)
                        e.push(new H(g,k[h]));
                try {
                    c.Typekit.load({
                        events: !1,
                        classes: !1,
                        async: !0
                    })
                } catch (m) {}
                a(e)
            }
        }, 2E3) : a([])
    }
    ;
    function Ia(a, b) {
        this.c = a;
        this.f = b;
        this.a = []
    }
    Ia.prototype.load = function(a) {
        var b = this.f.id
          , c = this.c.m
          , d = this;
        b ? (c.__webfontfontdeckmodule__ || (c.__webfontfontdeckmodule__ = {}),
        c.__webfontfontdeckmodule__[b] = function(b, c) {
            for (var g = 0, k = c.fonts.length; g < k; ++g) {
                var h = c.fonts[g];
                d.a.push(new H(h.name,ga("font-weight:" + h.weight + ";font-style:" + h.style)))
            }
            a(d.a)
        }
        ,
        B(this.c, z(this.c) + (this.f.api || "//f.fontdeck.com/s/css/js/") + ea(this.c) + "/" + b + ".js", function(b) {
            b && a([])
        })) : a([])
    }
    ;
    var Y = new pa(window);
    Y.a.c.custom = function(a, b) {
        return new ua(b,a)
    }
    ;
    Y.a.c.fontdeck = function(a, b) {
        return new Ia(b,a)
    }
    ;
    Y.a.c.monotype = function(a, b) {
        return new sa(b,a)
    }
    ;
    Y.a.c.typekit = function(a, b) {
        return new Ha(b,a)
    }
    ;
    Y.a.c.google = function(a, b) {
        return new Fa(b,a)
    }
    ;
    var Z = {
        load: p(Y.load, Y)
    };
    "function" === typeof define && define.amd ? define(function() {
        return Z
    }) : "undefined" !== typeof module && module.exports ? module.exports = Z : (window.WebFont = Z,
    window.WebFontConfig && Y.load(window.WebFontConfig));
}());

},
'appivo/util/FlightRecorder':function(){
define(['./CircularBuffer'], function(CircularBuffer) {
    
    var FlightRecorder = function(options) {
        if (!options) {
            options = {};
        }
        this.paused = false;
        this.size = options.size ? options.size : 500;
        this.buffer = new CircularBuffer({
            size: this.size
        })
    }

    FlightRecorder.prototype = {

        addEvent: function(event) {
            if (!this.paused) {
                var now = new Date().toISOString();
                event.time = now;
                this.buffer.push(event);
            }
        },

        isPaused: function() {
            return this.paused;
        },

        pause: function(paused) {
            this.paused = paused;
        },

        getSize: function() {
            return this.buffer.getSize();
        },

        getEvents: function() {
            var log = this.buffer.toArray();
            return log;
        },

        clear: function() {
            this.buffer.clear();
        }
    };

    return FlightRecorder;
});
},
'appivo/util/CircularBuffer':function(){
define([], function() {

    var Buffer = function(options) {
        if (!options) {
            options = {};
        }
        this.size = options.size ? options.size : 100;
        this.items = [];
        this.items.length = this.size;
        this.current = 0;
        this.count = 0;
    }

    Buffer.prototype = {
        push: function(item) {
            this.items[this.current] = item;
            this.current = (++this.current) % this.size;
            this.count++;
            if (this.count > this.size) {
                this.count = this.size;
            }
        },

        get: function(index) {
            var item = null;
            if (index < this.count) {
                var start = this.current - this.count;
                if (start < 0) {
                    start += this.size;
                }
                var pos = (start + index) % this.size;
                item = this.items[pos];
            }
            return item;
        },

        getSize: function() {
            return this.count;
        },

        clear: function() {
            this.current = 0;
            this.count = 0;
        },

        toArray: function() {
            var list = [];
            for (var i = 0; i < this.count; i++) {
                var item = this.get(i);
                list.push(item);
            }
            return list;
        }
    };

    return Buffer;
});
},
'appivo/util/ErrorCodes':function(){
define({ 
		error_code_header : 'X-ErrorCode' ,
		
		error_pwd_set_fail : '1000',
		unknown_user : '1001',
	    expired_pwd_reset : '1002',
	    illegal_or_used_pwd_req : '1003',
	    user_exists : '1004',
		
		user_not_signed_up : '3000',
		user_cancelled_operation : '3001',
		user_with_no_email : '3002'
});
},
'appivo/page/components/LoginMixin':function(){
define([
    "vue/vue",
    "dojo/io-query",
    "dojo/Deferred",
	"appivo/ui/Spinner",
	"appivo/util/ErrorResponseCodes",
    "appivo/client/Client"
], function(Vue, ioQuery, Deferred, Spinner, ErrorResponseCodes, Client) {
	
	var BACKGROUND = "blur-bg.png";
	
    var client = Client.getInstance();

    var params = window.location.search;
    if (params) {
        params = params.substring(1);
    }
    params = ioQuery.queryToObject(params);
    if (!params) {
        params = {};
    }
    var state = "";
    if (params.state) {
        state = params.state;
    }

    return {
        props: {

        },
        data: function() {
            return {
                state: state,
                tenant: null,
                tenantName: null,
                isHub: false,
                hubVendor: null,
                hubExtId: null,
                app: null,
                user: "",
                password: "",
                jumpToResetPass: false,
                code: "",
                rememberMe: false,
                accounts: [],
                account: {},
                errorMsg: null,
                errorAnimClass: null,
                successMsg: null,
                successAnimClass: null,
                whiteLabeling: null,
                clearHash: false,
                customTenant: null,
                authUrl: null,
                accessUrl: null,
                ssoErrorMessage: null,
                ssoDetails: null,
                twoFactorDesc: "",
                allowed2FATypes: [],
                reissueReset: false,
                passwordHidden: true,
                hubLogin: false,
                activation: {
                    password: '',
                    repeat: ''
                },
                registration: {
                    name: "",
                    id: null,
                    privacyConsent: false,
                    user: [
                       {
                           name: "",
                           firstname: "",
                           lastname: "",
                           phonenumber: ""
                       }
                    ],
                    country: [
                       {
                           iso: "SE"
                       }
                    ]
                },
                metaSchema: null
            };
        },
        computed: {
            title: function() {
                if (this.whiteLabeling && this.whiteLabeling.title) {
                    return this.whiteLabeling.title;
                }
                return this.$t('defaultTitle');
            },
            tagLine: function() {
                if (this.whiteLabeling && this.whiteLabeling.tagLine) {
                    return this.whiteLabeling.tagLine;
                }
                return this.$t('defaultTagLine');
            },
            signUpLinkText: function () {
                if (this.whiteLabeling) {
                    return this.whiteLabeling.signUpLinkText;
                }
                return this.$t('noAccount');
            },
            isSignUpLinkTextPresent: function() {
                var txt = this.signUpLinkText;
                return (txt && txt.trim().length > 0);
            },
            signUpLink:function () {
                if (this.whiteLabeling && this.whiteLabeling.signUpLink) {
                    return this.whiteLabeling.signUpLink;
                }
            },
            requestParams: function() {
                return params;
            },
            logoSrc: function() {
                if (this.whiteLabeling && this.whiteLabeling.logoSrc) {
                    if (this.whiteLabeling.logoSrc.includes("url")) {
                        var tempStr = this.whiteLabeling.logoSrc.split("url('").pop();
                        var tempArr = tempStr.split("')");
                        return tempArr[0];
                    } else {
                        return this.whiteLabeling.logoSrc;
                    }
                }
                return "/images/logo-green.png";
            },
            bgSrc: function() {
                if (this.whiteLabeling && this.whiteLabeling.bgSrc) {
                    if (this.whiteLabeling.bgSrc.includes("url")) {
                        var location = window.location.origin;
                        var updatedPath = this.whiteLabeling.bgSrc.split("'");
                        return `url('${location}${updatedPath[1]}')`;
                    }
                    return this.whiteLabeling.bgSrc;
                }

                return "";
                if (this.isHybrid || this.isMobile) {
                    return "url(../images/login/" + BACKGROUND + ")";
                }
                return "url(../images/login/" + BACKGROUND + ")";
            },
            accentColor: function() {
                if (this.whiteLabeling && this.whiteLabeling.accentColor) {
                    return this.whiteLabeling.accentColor;
                }
                return "#52ae32";
            },
            borderColor: function() {
                if (this.whiteLabeling && this.whiteLabeling.borderColor) {
                    return this.whiteLabeling.borderColor;
                }
                return "#ddd";
            },
            textColor: function() {
                if (this.whiteLabeling && this.whiteLabeling.textColor) {
                    return this.whiteLabeling.textColor;
                }
                return "#343434";
            },
            bgColor: function() {
                if (this.whiteLabeling && this.whiteLabeling.bgColor) {
                    return this.whiteLabeling.bgColor;
                }
                return "#ffffff";
            },
            buttonTextColor: function() {
                if (this.whiteLabeling && this.whiteLabeling.buttonTextColor) {
                    return this.whiteLabeling.buttonTextColor;
                }
                return "#fff";
            },
            isHybrid: function() {
            	return client.isHybrid();
            },
            isMobile: function() {
            	return client.isMobile();
            },
            isDesktopWithoutWL: function(){
                //to detect desktop mode without whiteLabeling
                if ( (!this.isMobile || !this.isHybrid) && (!this.whiteLabeling) ) {
                    return true;
                } else {
                    return false;
                }
            },
            loginLinkedInURL: function() {
            	return this.prepareLink("/oauth/LinkedIn/auth");
            },
            loginFacebookURL: function() {
            	return this.prepareLink("/oauth/Facebook/auth");
            },
            signupLinkedInURL: function() {
            	return this.prepareLink("/oauth/LinkedIn/signup");
            },
            signupFacebookURL: function() {
            	return this.prepareLink("/oauth/Facebook/signup");
            },
            passwordInputType: function() {
                return this.passwordHidden ? 'password' : 'text';
            },
            passwordIconClasses: function() {
                var classes = ["fa"];
                if (this.passwordHidden) {
                    classes.push("fa-eye");
                } else {
                    classes.push("fa-eye-slash");
                }
                return classes;
            }
        },
        methods: {
            togglePassword: function() {
                this.passwordHidden = !this.passwordHidden;
            },
            signUpAction:function () {
                if (this.signUpLink) {
                    window.open(this.signUpLink, client.isHybrid() ? "_system" : "_self");
                } else {
                    if (this.registration.id === null) {
                        this.setState('planScreen');
                    } else {
                        this.setState('signUp');
                    }
                }
            },
            hubSignUpAction: function() {
                if (this.tenant) {
                    this.registration = {
                        id: this.tenant,
                        hub: true,
                        privacyConsent: false,
                        user: [{
                            firstname: '',
                            lastname: '',
                            name: '',
                            phonenumber: '',
                        }]
                    };
                    Vue.set(this, 'tenantName', client.getTenantName());
                    this.setState('signUp');
                } else {
                    this.setState('hubSignup');
                }
            },
            checkAndDisplayBackToLogin:function () {
                if (this.accounts.length === 1) {
                    this.setState('emailEntry');
                } else {
                    this.setState('accountSelection');
                }
            },
        	prepareLink: function(url) {
        		var turl = url;
        		if (this.tenant || this.app) {
        			var and = false;
                    if (this.accessUrl) {
                        turl = this.accessUrl;
                    } else if (this.tenant) {
        				turl += '?tenant=' + this.tenant;
        				and = true;
        			}
        			if (this.app) {
        				if (and) {
        					turl += '&';
        				} else {
                            turl += "?";
                        }
        				turl += 'app=' + this.app;
        			}
        		}
        		return turl;
        	},
            loadAccounts: function(noMsgClear) {
                currentHash = window.location.hash;
                if (currentHash) {
                    if (currentHash.match("#/t/")) {
                        sessionStorage.setItem("brandedLoginUsed", true);
                    } else {
                        sessionStorage.removeItem("brandedLoginUsed");
                    }
                }
                var t = this;
		        if (this.user) {
			        Spinner.show(true);
		        	var data = { user: this.user };
                    var tid = client.getTenantId();
		        	if (tid) {
		        		data.tenant = tid;
		        	} else if (this.registration.id !== null) {
		        		data.tenant = this.registration.id;
		        	}
		        	if (this.metaSchema && this.metaSchema.id && !client.isVendorDomain()) {
		        		data.schema = this.metaSchema.id;
		        	}
		        	client.sendRequest("/api/accounts", {
		        		data: JSON.stringify(data),
		        		handleAs: "json",
		        		method: "POST"
		        	}).then(function(accounts) {
		        		if (accounts.length !== 0) {
		        			sessionStorage.setItem("currentTenantName",accounts[0].tenantName);
		        			sessionStorage.setItem("currentTenantId",accounts[0].tenantId);
		        		}
		        		Spinner.show(false);
		        		if (accounts.length === 0) {
		        			t.setErrorMsg(t.$t('errNoAccounts', { user: t.user }));
		        		} else {
		        			Vue.set(t, 'accounts', accounts);
		        			if (accounts.length === 1) {
		        				var account = accounts[0];
	        					Vue.set(t, 'account', account);
		        				if (account.authUrl) {
		        					t.authUrl = account.authUrl;
		        					t.ssoLogin();
		        				} else {
                                    if(t.state == 'forgotPassword') {
                                        t.setState("passwordReset", noMsgClear);
                                    } else {
                                        t.setState("passwordEntry", noMsgClear);
                                    }
		        				}
		        			} else {
		        				t.setState("accountSelection", noMsgClear);
		        			}
		        		}
		        	}, function(error) {
		        		Spinner.show(false);
		        		t.setErrorMsg(error);
		        	});
		        } else {
                    t.setErrorMsg(t.$t('errorEmail'));
		        }
            },
            setState: function(state, noMsgClear) {
                if (!noMsgClear) {
                    this.clearErrorMsg();
                    this.clearSuccessMsg();
                }
                Vue.set(this, 'state', state);
            },
            selectAccount: function(account) {
                if (account.active) {
                    Vue.set(this, 'account', account);
                    if (account.authUrl) {
                        this.authUrl = account.authUrl;
                        this.ssoLogin();
                    } else {
                        if (this.jumpToResetPass) {
                            this.setState("passwordReset");
                        } else {
                            this.setState("passwordEntry");
                        }
                    }
                }
            },
            setErrorMsg: function(msg) {
                var t = this;
                this.clearSuccessMsg();
                Vue.set(this, 'errorMsg', msg);
                Vue.set(this, 'errorAnimClass', 'shake');
                setTimeout(function(){
                    Vue.set(t, 'errorAnimClass', null);
                }, 500);
            },
            clearErrorMsg: function() {
                Vue.set(this, 'errorMsg', null);
            },
            setSuccessMsg: function(msg) {
                var t = this;
                this.clearErrorMsg();
                Vue.set(this, 'successMsg', msg);
                Vue.set(this, 'successAnimClass', 'pulse');
                setTimeout(function(){
                    Vue.set(t, 'successAnimClass', null);
                }, 500);
            },
            clearSuccessMsg: function() {
                Vue.set(this, 'successMsg', null);
            },
            createHubOptions: function() {
                var t = this;
                var options = {
                    hub: {
                        vendor: t.hubVendor,
                        extid: t.hubExtId
                    },
                };
                switch (t.hubVendor) {
                    case 'hron':
                        options.hub.extid = params.clientId;
                        options.hub['user-extid'] = params.employeeId;
                        break;
                }
                return options;
            },

            login: function() {
                var t = this;
		        Spinner.show(true);
                var params = this.getQueryParams();
		        var remember = client.isHybrid() ? true : this.rememberMe;
                var options = undefined;
                if (t.isHub) {
                    options = t.createHubOptions();
                }
                client.login(this.user, this.password, this.code, remember, this.account.tenantId, undefined, params.app, options).then(function() {
                    Spinner.show(false);
                    t.clearLocation();
                    var status = client._getCachedStatus();
                    var handled = false;
                    if (status.hubVendor) {
                        handled = t.postProcessHubLogin(status.hubVendor, status.hubVendorData);
                    }
                    if (!handled) {
                        t.$dispatch("user-logged-in");
                    }
                }, function(error) {
                    Spinner.show(false);
                    var authHeader = error.response.getHeader("WWW-Authenticate");
                    if (error.response.status === 401 && authHeader && authHeader.startsWith("2FA:")) {
                        t.setTwoFactorDesc(authHeader.substring(4));
                        t.setState("2FACodeEntry");
                    } else {
                        t.setLoginError(error.response);
                    }
                });
            },
            setLoginError: function(response) {
                var errorMsg;
                if (response.data) {
                    switch (response.data.errorCode) {
                        case ErrorResponseCodes.Login.BadOneTimePassword:
                            errorMsg = this.$t('errOneTimePasswordInvalid');
                            if (this.clearTwoFactorInputs) {
                                this.clearTwoFactorInputs();
                            }
                            break;
                        case ErrorResponseCodes.Login.InactivatedUser:
                            errorMsg = this.$t('errUserDeactivated');
                            break;
                        case ErrorResponseCodes.Login.AccountBlocked:
                            errorMsg = this.$t('errTooManyAttempts');
                            break;
                        case ErrorResponseCodes.Login.RestrictedIp:
                            errorMsg = this.$t('errRestrictedIp');
                            break;
                        case ErrorResponseCodes.Login.TenantAccessLimited:
                            errorMsg = this.$t('errAccessLimited');
                            break;
                        default:
                            errorMsg = this.$t('errLoginFailed');
                            break;
                    }
                } else {
                    errorMsg = "Unexpected error";
                }
                this.setErrorMsg(errorMsg);
            },
            setTwoFactorDesc: function(twoFactorType) {
                switch(twoFactorType) {
                case 'totp':
                    this.twoFactorDesc = this.$t('totpDescription');
                    break;
                }
            },
            getQueryParams: function() {
                var raw = window.location.search;
                if (raw) {
                    raw = raw.substring(1);
                }
                var params = ioQuery.queryToObject(raw);
                return params;
            },
            clearLocation: function() {
                var hash = window.location.hash;
                if (!client.isHybrid()) {
                    if (hash.match(/#(signup|login|activate).*/) || this.clearHash) {
                        if (this.metaSchema && this.metaSchema.name) {
                            window.location = "#/app/" + this.metaSchema.name;
                        } else {
                            window.location = this.prepareLink("/");
                        }
                    }
                }
            },
            ssoLogin: function() {
            	if (this.authUrl) {
            		console.log("Redirecting to SSO-login");
            		window.location.href = this.authUrl;
            	}
            },
            openLink: function(url) {
            	if (client.isHybrid()) {
            		cordova.InAppBrowser.open(url, '_system', 'location=yes');
            	} else {
            		window.open(url, '_system', 'location=yes');
            	}
            },
            resetPassword: function() {
                var t = this;
                Spinner.show(true);
                client.resetPassword(this.user, this.account.tenantId).then(function() {
                    Spinner.show(false);
                    Vue.set(t, 'reissueReset', false);
                    t.setSuccessMsg(t.$t('sucResetSent', { user: t.user } ));
                }, function(error) {
                    Spinner.show(false);
                    var errorMsg = error;
                    t.setErrorMsg(t.$t('errResetFailed', { error: errorMsg }));
                });
            },
            postProcessHubLogin: function(vendor, config) {
                var handled = false;
                switch (vendor) {
                    case "hron":
                        var redirectUrl = params.redirectUrl;
                        if (redirectUrl) {
                            var url = new URL(redirectUrl);
                            url.searchParams.append("authorizationCode", config.code);
                            window.location = url;
                            handled = true;
                        }
                        break;
                }
                return handled;
            },
            preProcessHubSignup: function(vendor) {
                switch (vendor) {
                    case "hron":
                        localStorage.setItem("hub-signup-redirectUrl", params.redirectUrl);
                        break;
                }
            },
            preProcessHubUserSignup: function(vendor, reg) {
                var params = this.getQueryParams();
                this.preProcessHubSignup(vendor);
                switch (vendor) {
                    case 'hron':
                    if (reg && reg.user && reg.user.length > 0) {
                        reg.user[0].extid = params.employeeId;
                    }
                    break;
                    case 'planday':
                    break;
                }
            },
            postProcessHubSignupUser: function(vendor, response) {
                switch (vendor) {
                    case "hron":
                        this.postHronSignup(response);
                        break;
                }
            },
            postProcessHubSignup: function(vendor, response) {
                switch (vendor) {
                    case "hron":
                        this.postHronSignup(response);
                        break;
                }
            },
            postHronSignup: function(response) {
                var redirectUrl = localStorage.getItem("hub-signup-redirectUrl");
                if (redirectUrl) {
                    localStorage.removeItem("hub-signup-redirectUrl");
                    var url = new URL(redirectUrl);
                    var meta = response['@meta'];
                    if (meta && meta.code) {
                        url.searchParams.append("authorizationCode", meta.code);
                    }
                    window.location = url;
                } else {
                    console.error("Missing redirectUrl");
                }
            },
            registerHubAccount: function() {
                var t = this;
                var params = this.getQueryParams();
                var vendor = client.getDomainVendor();
                if (vendor) {
                    this.preProcessHubSignup(vendor);
                    this.registration.user[0].extid = params.employeeId;
                    var data = {
                        tenant: {
                            name: this.registration.name,
                            country: client.getOriginCountry(),
                            extid: params.clientId,
                            type: client.getDomainType(),
                            vendor: client.getDomainVendor()
                        },
                        app: params.app,
                        users: this.registration.user
                    };
                    Spinner.show(true);
                    client.sendRequest('/api/v1/hub-signup', {
                        method: 'POST',
                        data: data
                    }).then(function (response) {
                        Spinner.show(false);
                        console.log("RESPONSE", response);
                        t.postProcessHubSignup(vendor, response);
                    }, function (error) {
                        Spinner.show(false);
                    });
                } else {

                }
            },
            registerUserAccount: function() {
                var t = this;
                var params = this.getQueryParams();
                if (!this.registration.id) {
                    console.error("Attempting to create user account without tenant");
                    return; //This shouldn't happen so no better error handling needed
                }
                var data = this.registration.user[0];
                data.tenant_id = this.registration.id;
                delete data.hub;

                if (this.validSignup(this.registration)) {
                    Spinner.show(true);
                    var url = '/api/signup';
                    var query = 'userSignUp=true';
                    var vendor = client.getDomainVendor();
                    if (vendor) {
                        this.preProcessHubUserSignup(vendor, this.registration);
                        url = '/api/v1/hub-signup-user';
                        query = undefined;
                        data['@meta'] = {
                            app: params.app
                        };
                    }
                    client.sendRequest(url, {
                        method: 'POST',
                        handleAs: 'json',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        withCredentials: true,
                        query: query,
                        data: JSON.stringify(data)
                    }).then(function(response) {
                        Spinner.show(false);
                        t.setSuccessMsg(t.$t('sucSignUpComplete', { email: data.name }));
                        if (vendor) {
                            t.postProcessHubSignupUser(vendor, response);
                        } else {
                            t.clearLocation();
                        }
                    }, function(error) {
                        Spinner.show(false);
                        var msg = "Unexpected error, try again later.";
                        if (error.error && error.error.error) {
                            if (error.error.errorCode === ErrorResponseCodes.SignUp.TenantNameTaken) {
                                msg = t.$t("errTenantExists");
                            } else {
                                msg = error.error.error;
                            }
                        }
                        t.setErrorMsg(t.$t('errSignUpFailed', { error: msg }));
                    });
                }
            },
            validSignup: function() {
            	var t = this;
            	var ok = true;
            	var company = this.registration;
            	var user = this.registration.user[0];
            	var country =  this.registration.country ? this.registration.country[0] : null;
            	if (!this.registration.id && ok && !company.name.trim()) {
                    t.setErrorMsg(t.$t('errorCompany'));
            		ok = false;
            	}
            	if (ok && !user.firstname.trim()) {
                    t.setErrorMsg(t.$t('errorFirstname'));
            		ok = false;
            	}
            	if (ok && !user.lastname.trim()) {
                    t.setErrorMsg(t.$t('errorLastname'));
            		ok = false;
            	}
            	if (ok && !user.name.trim()) {
                    t.setErrorMsg(t.$t('errorEmail'));
            		ok = false;
            	}
				// check country value only for tenant creation flow
                if (!this.registration.hub) {
                    if (ok && company.id == null && !country.iso) {
                        t.setErrorMsg(t.$t('errorCountry'));
                        ok = false;
                    }
                }
            	if (ok && !this.registration.privacyConsent) {
            		t.setErrorMsg(t.$t('errorConsent'));
            		ok = false;
            	}
            	return ok;
            },
            activateAccount: function() {
                var t = this;
                var activationData = this.getActivationData();
                if (activationData.secret !== null) {
                    this.tenant = activationData.tenant;
                    if (this.activation.password === this.activation.repeat) {
                        if (this.activation.password.length >= 8) {
                            Spinner.show(true);
                            client.setPassword(activationData.secret, this.activation.password).then(function(user) {
                                Spinner.show(false);
                                t.setSuccessMsg(t.$t('sucSetPassword'));
                                Vue.set(t, 'user', user.name);
                                Vue.set(t.registration, 'id', activationData.tenant);
                                if (t.whiteLabeling && t.whiteLabeling.postActivateLink) {
                                    window.location = t.whiteLabeling.postActivateLink;
                                } else {
                                    t.loadAccounts(true);
                                    t.clearLocation();
                                }
                            }, function(err) {
                                Spinner.show(false);
                                var error = err.error.error ? err.error : err;
                                var errorMsg = error.error;
                                switch (errorMsg) {
                                    case 'TOO_SHORT':
                                        errorMsg = t.$t('errTooShort');
                                        break;
                                    case 'NO_SPECIAL_CHARS':
                                        errorMsg = t.$t('errNoSpecial');
                                        break;
                                    case 'Expired password-set request':
                                        errorMsg = t.$t('errExpiredReset');
                                        Vue.set(t, 'user', error.email);
                                        Vue.set(t.account, 'tenantId', error.tenant);
                                        Vue.set(t, 'reissueReset', true);
                                        break;
                                    default:
                                        errorMsg = t.$t('errSetPassword', { error: errorMsg});
                                        break;
                                }
                                t.setErrorMsg(errorMsg);
                            });
                        } else {
                            this.setErrorMsg(t.$t('errPasswordTooShort'));
                        }
                    } else {
                        this.setErrorMsg(t.$t('errPasswordsDoNotMatch'));
                    }
                } else {
                    this.setErrorMsg(t.$t('errActivationLinkBroken'))
                }
            },
            getActivationData: function() {
                var data = {};
                var match = window.location.hash.match(/\?secret=([^&)]+)&tenant=([\w\d]+)/);
                if (match) {
                    data.secret = match[1];
                    data.tenant = match[2];
                }
                var params = this.getQueryParams();
                if (!data.secret && params.secret) {
                	data.secret = params.secret;
                }
                if (!data.tenant && params.tenant) {
                	data.tenant = params.tenant;
                }
                return data;
            },
            _detectSSOError: function() {
                var params = this.getQueryParams();
                this.ssoDetails = params.details;
                this.ssoErrorMessage = params.ssoError;
                return params.ssoError;
            },
            _detectCustomAuth: function() {
            	var custom = false;
            	var path = window.location.pathname;
            	var host = window.location.hostname;
            	if (path.match("/t/.*")) {
                	this.customTenant = window.location.pathname.substring(3);
            		custom = true;
            		this.authUrl = '/auth/' + this.customTenant + "/login";
            	} else if (client.hasSSO()) {
            	    custom = true;
            	    this.authUrl = '/auth/' + client.getTenantShortcode() + '/login';
                }
            	return custom;
            },
            initialNavigate: function() {
            	var t = this;
                var hash = window.location.hash;
                var ssoError = this._detectSSOError();
                var domainVendor = client.getDomainVendor();

                if (client.getDomainType() == "hub" && !!domainVendor) {
                    console.log("Accessing hub for vendor " + domainVendor);
                    this.hubLogin = true;
                    this.tenant = client.getTenantId();
                }

                if (ssoError) {
                    this.setState("ssoError");
                } else if (this._detectCustomAuth()) {
                    this.setState("sso");
                } else if (hash.match(/#signup.*/)) {
                    this.setState("signUp");
                } else if (hash.match(/#activate.*/)) {
                    this.setState("activation");
                } else if (hash.match(/#reset.*/)) {
                	this.setState("reset");
                } else if (!state) {
                    this.setState("emailEntry");
                }

                var params = this.getQueryParams();
                if (params) {
                	var error = params['X-ErrorCode'];
                	if (error) {
                		this.setErrorMsg(t.$t('errLoginFailed', { error: error }));
                	} else if (params.hasData) {
                		client.sendRequest('/oauthinfo', {
                			handleAs: 'json'
                		}).then(function(data) {
                			t.registration.name = data.organization;
                			if (data.locale) {
                				t.registration.country = data.locale;
                			}
                			t.registration.user[0].name = data.email;
                			t.registration.user[0].firstname = data.firstName;
                			t.registration.user[0].lastname = data.lastName;
                		});
                	}
                }
            },

            loadAuthConfig: function(tenantId) {
                if (sessionStorage.getItem("brandedLoginUsed")) {
                    var currentTenantName = sessionStorage.getItem("currentTenantName");
                    var currentTenantId = sessionStorage.getItem("currentTenantId");
                    var currentTenantShortcode = sessionStorage.getItem("currentTenantShortcode");
                }
                if (tenantId) {
                    currentTenantId = tenantId;
                }
                var t = this;
                var params = this.getQueryParams();
                var hashData = this.parseHash();
                var domain = window.location.hostname;
                var query = {
                    domain: domain,
                    tenantName: currentTenantName,
                    tenantShortcode: currentTenantShortcode,
                    tenantId: currentTenantId
                };
                console.log("Accessing via domain " + domain);
                var tenantId = client.getTenantId();
                if (tenantId) {
                    query.tenantId = tenantId;
                } else if (hashData.tenant) {
                    query.tenant = hashData.tenant;
                }

                if (!query.tenant && params.tenant) {
                    query.tenant = params.tenant;
                }
                if (!query.app && params.app) {
                    query.app = params.app;
                }

                if (client.isHybrid()) {
                    query.app = client.getAppProperty('schema');
                } else if (hashData.app) {
                    query.app = hashData.app;
                }

                Spinner.show(true);
                client.sendRequest('api/authconfig', {
                    query: query
                }).then(function(config) {
                    Spinner.show(false);
                    client.setTenant({
                        id: config.tenantId,
                        name: config.tenant,
                        shortcode: config.tenantShortcode
                    });
                    t.accessUrl = config.accessUrl;

                    if (config.sso) {
                        client.setSSO({
                            url: config['sso-url']
                        });
                    }

                    if (config['domain-type'] == 'hub') {
                        t.isHub = true;
                        t.hubVendor = config['domain-vendor'];
                        t.hubExtId = config.tenantExtId;
                    }

                    var whiteLabeling = config.whitelabel;
                    if (whiteLabeling) {
                        t.tenant = whiteLabeling.tenant_id;
                        t.app = query.app;
                        if (whiteLabeling.tenant_id) {
                            t.registration.id = whiteLabeling.tenant_id;
                            t.registration.name = whiteLabeling.tenant_name;
                        }
                        if (whiteLabeling.meta_schema_name || whiteLabeling.meta_schema_id) {
                            t.metaSchema = {
                                name: whiteLabeling.meta_schema_name,
                                id: whiteLabeling.meta_schema_id
                            };
                        }
                        if (whiteLabeling.loginStyle) {
                            t.whiteLabeling = whiteLabeling.loginStyle;
                        }
                        client.setWhitelabel(query);
                    }
                    t.initialNavigate();
                }, function(error) {
                    var tenant = undefined;
                    if (error.response) {
                        tenant = error.response.getHeader("X-Tenant");
                        t.registration.id = tenant;
                    }
                    Spinner.show(false);
                    t.initialNavigate();
                });
            },

            parseHash: function() {
                var data = {};
                var hash = window.location.hash;
                if (!hash.startsWith("/")) {
                	hash = "/" + hash;
                }
                var path = window.location.pathname;
                var match = hash.match(/(\/\w\/[^/?]+)/g);
                if (!match) {
                	match = path.match(/(\/\w\/[^/?]+)/g);
                }
                if (match) {
                    for (var i = 0; i < match.length; i++) {
                        var m = match[i];
                        var prop;
                        switch (m.charAt(1)) {
                        case 'a':
                            prop = "app";
                            break;
                        case 't':
                            prop = "tenant";
                            break;
                        default:
                            continue;
                        }
                        if (prop) {
                            data[prop] = decodeURI(m.substr(3));
                            this.clearHash = true;
                        }
                    }
                }
                return data;
            },
            backToLogin:function () {
                this.setState('emailEntry');
            }
        },
        ready: function() {
            var presetUser = client.getCookie("user");
            var tenantId = null;
            if (presetUser) {
                var slash = presetUser.indexOf("/");
                tenantId = presetUser.substring(0, slash);
                presetUser = presetUser.substring(slash + 1);
                Vue.set(this, 'user', presetUser);
            }
        	client.setPreventReauth(true);
            if (client.isMobile()) {
            	client.setStatusBarStyle({
            		style: 'black-translucent',
            		overlay: true
            	});
            }
            this.loadAuthConfig(tenantId);
        },
        events: {

        },
        watch: {
            'state': function(val, oldVal){
                if (oldVal == 'forgotPassword' && val == 'accountSelection'){
                    this.jumpToResetPass = true;
                } else {
                    this.jumpToResetPass = false;
                }
            }
        },
        components: {
            'phimg': function(resolve, reject) {
                require(['appivo/vue/components/PlaceHolderImg'], resolve, reject);
            }
        }
	};
});
},
'appivo/util/ErrorResponseCodes':function(){
define([], function() {
    return {
        Login: {
            BadUserNamePassword: "LOGIN_0001",
            BadOneTimePassword: "LOGIN_0002",
            InactivatedUser: "LOGIN_0003",
            AccountBlocked: "LOGIN_0004",
            RestrictedIp: "LOGIN_0005",
	        TenantAccessLimited: "LOGIN_0006"
        },
        SignUp: {
            TenantNameTaken: "SIGNUP_0001",
            UserOrContractStoreFailed: "SIGNUP_0002",
            FailedAfterPayment: "SIGNUP_0003",
            PaymentFailed: "SIGNUP_0004",
            InvoiceGenerationFailed: "SIGNUP_0005"
        },
        MemberShip: {
            InsufficientFunds: "MEMBERSHIP_0001",
            CardExpired: "MEMBERSHIP_0002",
            AuthorizationRequired: "MEMBERSHIP_0003",
            PaymentFailed: "MEMBERSHIP_0004"
        }
    };
});
},
'appivo/page/signupplan/SignupPage':function(){
define([
	"vue/vue",
	"dojo/io-query",
	"dojo/Deferred",
	"appivo/client/Client",
	"appivo/ui/Spinner",
	"appivo/ui/Alertify",
	"appivo/util/ArrayHelper",
	"./components/StepOne",
	"./components/StepTwo",
	"./components/StepThree",
	"./components/StepFour",
	"dojo/text!./html/SignupPage.html"
], function(Vue, ioQuery, Deferred, Client, Spinner, Alertify, ArrayHelper, StepOne, StepTwo, StepThree, StepFour, template) {
	var client = Client.getInstance();
	var params = window.location.search;
	if (params) {
		params = params.substring(1);
	}
	params = ioQuery.queryToObject(params);

	var signupReady = new Deferred();
	var step = 1;
	var planId = "000000000000000000000000000b0002";
	if (params.plan) {
		planId = params.plan;
		step = 2;
	}

	return Vue.extend({
		template: template,
		data: function() {
			return {
				stripe: null,
				paymentIntentId: null,
				step: step,
				plan: {},
				vatid: "",
				tenant: {
                    name: "",
                    id: null,
                    privacyConsent: false,
				},
				currencyMap: {},
				countries: [],
				country: client.getOriginCountry(),
				user: {
                    name: "",
                    firstname: "",
                    lastname: "",
                    phonenumber: ""
				},
				planId: planId,
				clientSecret: null,
				billing: {
                    customerId: null,
                    paymentMethod: null
				}
			};
		},
		computed: {
		    registrationObj: function() {
		        var tenant = JSON.parse(JSON.stringify(this.tenant));
		        var billing = {};
		        if (this.billing.paymentMethod) {
		            billing.payMethods = [this.billing.paymentMethod];
		            billing.defaultPayMethod = this.billing.paymentMethod;
		        }
		        if (this.billing.customerId) {
		            billing.customerId = this.billing.customerId;
		        }
		        tenant.country = [{ iso: this.country }];
		        tenant.tenant_details = {
		            vatid: this.vatid,
		            billing_email: this.user.name,
					phone : this.user.phonenumber,
		            data: JSON.stringify({
                        billing: billing
                    })
		        };
		        return {
		            planId: this.planId,
		            tenant: tenant,
		            user: this.user,
		            payment: this.paymentIntentId
		        };
		    },
		    customerObj: function() {
                return {
                    tenantName: this.tenant.name,
                    fullName: this.user.firstname + " " + this.user.lastname,
                    country: this.country,
					email: this.user.name,
					phone: this.user.phonenumber
                };
		    },
			selectedPlanInfo: function() {
				return this.plan;
			}
		},
		methods: {
			goToStep: function(step, event) {
				if (step === 3 && this.planId !== "000000000000000000000000000b0003") {
					this.signUpRequest(step);
				} else {
					this.step = step;
				}
			},
			signUpRequest: function(step) {
				var t = this;
				this.customerObj['planId'] = this.planId;
				this.customerObj['currencyId'] = this.plan.currencyId;
				Spinner.show(true);
				this.sendSignUpRequest(this.customerObj, "createCustomer=true").then(function(response) {
					Spinner.show(false);
					t.costBreakdown = response.paymentDetails;
					t.clientSecret = response.clientSecret;
					t.billing.customerId = response.customerId;
					t.tenant.name = response.tenantName;
					t.step = step;
					signupReady.resolve();
				}, function(error) {
					Alertify.error(t.$t('suErrTenantSetupFailed'));
					Spinner.show(false);
					signupReady.reject();
				});
			},
			setPlanDetails: function (plan) {
				this.plan = plan;
				this.planId = plan.id;
			},
			updateRegistration: function(event) {
			    this.$set(event.key, event.value);
				if (event.key === 'country') {
					//this.loadPlans(event.value);
				}
			},
			submit: function(event) {
				var t = this;
				stripe = event.stripe;
				if (t.registrationObj.planId === '000000000000000000000000000b0003') {
					var ok = t.validateRegistration();
					if (ok) {
						Spinner.show(false);
						t.createTenant(event);
					}
				} else {
					if (t.clientSecret) {
						Spinner.show(true);
						if (t.costBreakdown.hasTrial) {
							t.confirmCardSetup(event);
						} else {
							t.confirmCardPayment(event);
						}
					} else {
						t.createCustomerInStripe(event, t.registrationObj.planId, t.selectedPlanInfo);
					}
				}
			},
            createCustomerInStripe: function(event, planId, selectedPlan) {
                var ok = this.validateRegistration();
                this.customerObj['planId'] = selectedPlan.id;
                this.customerObj['currencyId'] = selectedPlan.currencyId;
                if (ok) {
                    Spinner.show(true);
                    if (this.clientSecret && this.billing.customerId) {
                        this.confirmCardPayment(event);
                    } else {
                        Alertify.error(this.$t('suErrTenantSetupFailed'));
                        Spinner.show(false);
                        event.def.reject();
                    }
                }
            },
            confirmCardSetup: function(event) {
				var t = this;
				this.stripe.confirmCardSetup(t.clientSecret, {
					payment_method: {
						card: event.data.card
					}
				}).then(function(res) {
					if (res && res.setupIntent) {
						t.billing.paymentMethod = res.setupIntent.payment_method;
					}
					t.createTenant(event);
				},
				function(error) {
					Alertify.error(t.$t('suErrTenantSetupFailed'));
					Spinner.show(false);
				});
			},
            confirmCardPayment: function(event) {
				var t = this;
				this.stripe.confirmCardPayment(t.clientSecret, {
					payment_method: {
						card: event.data.card
					}
				}).then(function(res) {
					if(res.paymentIntent && res.paymentIntent.id) {
						t.paymentIntentId = res.paymentIntent.id;
						t.billing.paymentMethod = res.paymentIntent.payment_method;
						t.createTenant(event);
					} else {
						Alertify.error(t.$t('suErrTenantSetupFailed'));
						Spinner.show(false);
					}
				},
				function(error) {
					Alertify.error(t.$t('suErrTenantSetupFailed'));
					Spinner.show(false);
				});
			},
            createTenant: function(event) {
                var t = this;
                var d = JSON.parse(JSON.stringify(this.registrationObj));
                this.sendSignUpRequest(d, "signupTenant=true").then(function(response) {
						Spinner.show(false);
						event.def.resolve();
						t.goToStep(4);
					},
					function(error) {
						Alertify.error(t.$t('suErrTenantCreateFailed'));
						Spinner.show(false);
						event.def.reject();
					}
				);
            },
            sendSignUpRequest: function(data, queryString) {
                return client.sendRequest('/api/signup/', {
                    method: 'POST',
                    handleAs: 'json',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    withCredentials: true,
                    query: queryString,
                    data: JSON.stringify(data)
                });
            },
            validateRegistration: function() {
            	var company = this.tenant;
            	var user = this.user;
            	var country =  this.country;
            	var ok = true;
            	if (!user.firstname.trim()) {
            	    Alertify.error(this.$t('errorFirstname'));
            	    ok = false;
            	}
            	if (!user.lastname.trim()) {
            	    Alertify.error(this.$t('errorLastname'));
            	    ok = false;
            	}
            	if (!user.name.trim()) {
            	    Alertify.error(this.$t('errorEmail'));
            	    ok = false;
            	}
				// check country value only for tenant creation flow
            	if (company.id == null && !country) {
            	    Alertify.error(this.$t('errorCountry'));
            	    ok = false;
            	}
            	if (!company.privacyConsent) {
            	    Alertify.error(this.$t('errorConsent'));
            	    ok = false;
            	}
            	return ok;
            }
		},
		events: {
			'stripe': function(data) {
				this.$set('stripe', data.stripe);
				this.$broadcast('stripe', data);
			},
			'updateRegistrationValue': function(data) {
				this.updateRegistration(data);
			},
			'updatePlanCurrency': function(data) {
				Vue.set(this.selectedPlanInfo, 'currencyId', data.currencyId);
			},
			'populateUserData': function(tenant, user, vat) {
				if (tenant) {
					for (var tenantKey in this.tenant) {
						this.tenant[tenantKey] = tenant[tenantKey];
					}
				}
				if (user) {
					for (var userKey in this.user) {
						this.user[userKey] = user[userKey];
					}
				} 
				if (vat) {
					this.vatid = vat;
				}
				this.$broadcast('updateData', tenant, user, vat);
			}
		},
		components: {
			'step-one' : StepOne,
			'step-two' : StepTwo,
			'step-three' : StepThree,
			'step-four' : StepFour
		}
	});
});
},
'appivo/page/signupplan/components/StepOne':function(){
define([
	"vue/vue",
	"appivo/client/Client",
	"dojo/text!../html/StepOne.html"
], function(Vue, Client, template) {

	var client = Client.getInstance();

	return Vue.extend({
		template: template,
		props: {
			selectedPlan: {
				type: String,
				"default": ''
			}
		},
		data: function() {
			return {
				chosenPlan: "000000000000000000000000000b0002",
				plans: [],
				plan: null,
				planAttributes: [],
				planAttributesMap: {
					apps: this.$t('enApps'),
					devs: this.$t('enDevs'),
					email: this.$t('enEmail'),
					sms: this.$t('enSMS'),
					storage: this.$t('enStorage'),
					users: this.$t('enUsers')
				}
			};
		},
		methods: {
			loadPlans: function(countryValue) {
				var t = this;
				if (!countryValue) {
					this.country = client.getOriginCountry();
					if (!this.country) {
						this.country = "US";
					}
				} else {
					this.country = countryValue;
				}
				client.sendRequest("/api/plan/", {
					method: 'GET',
					headers: {
						'Content-Type': 'application/json'
					},
					query: {
						"countryIso": this.country
					}
				}).then(function(result){
					t.plans = result;
					var toExclude = ['created_at','id','meta_schema_id','name','price','updated_at','ver','description', 'data', 'status', 'currency', 'currencyId', 'trialPeriod', 'subtenants'];
					var attrs = [];
					for (var key in t.plans[0]) {
						if (toExclude.indexOf(key) == -1) {
							attrs.push(key);
						}
					}
					t.planAttributes = attrs;
				});
			},
			planAttributesValues: function (planItem, attribute) {
				if (attribute === 'apps') {
					return planItem[attribute] === 1 ? planItem[attribute] + this.$t('app') :  planItem[attribute] + this.$t(attribute);
				} else if (attribute === 'devs') {
					return planItem[attribute] === 1 ? planItem[attribute] + this.$t('dev') :  planItem[attribute] + this.$t(attribute);
				} else if (attribute === 'trialPeriod') {
					var trial = planItem[attribute].slice(0,-1);
					return trial + this.$t(attribute);
				} else {
					return planItem[attribute] + this.$t(attribute);
				}
			},
			enterprisePlanValues: function(attribute) {
				return this.planAttributesMap[attribute];
			}, 
			selectPlan: function (planId) {
				this.chosenPlan = planId;
				for (var i = 0; i < this.plans.length; i++) {
					var p = this.plans[i];
					if (p.id === planId) {
						this.plan = p;
						break;
					}
				}
				client.registerPageView('select_item', {
					item_list_id: "plans",
					item_list_name: "Plans",
					items: [{
						item_id: planId,
						item_name: this.plan.name
					}]
				});
				this.$dispatch('planchange', this.plan);
				this.$dispatch('proceed');
			},
			goBack: function() {
			    this.$dispatch('back-to-login');
			},
			getPriceString: function(price, currencyIso) {
				if (price % 1 !== 0) {
					price = price.toFixed(2);
				}
				switch (currencyIso) {
					case 'SEK': return price + "kr";
					case 'EUR': return "€" + price;
					case 'USD': return "$" + price;
				}
				return price;
			}
		},
		ready: function() {
			this.chosenPlan = this.selectedPlan;
			this.loadPlans();
		}
	});
});

},
'appivo/page/signupplan/components/StepTwo':function(){
define([
	"vue/vue",
	"dojo/Deferred",
	"appivo/client/Client",
	'appivo/vue/components/Selector',
	"appivo/vue/components/TextBox",
	'appivo/ui/Alertify',
	"appivo/util/StripeLoader",
	"dojo/text!../html/StepTwo.html"
], function(Vue, Deferred, Client, Selector, TextBox, Alertify, StripeLoader, template) {
    var client = Client.getInstance();

	return Vue.extend({
		template: template,
		props: {
			selectedPlan: {
				type: String,
				"default": ''
			},
			userDetails: {
				type: Object,
				"default": function() {
				    return {};
				}
			},
			tenantDetails: {
				type: Object,
				"default": function() {
				    return {};
				}
			},
			countryValue: {
				type: String,
				"default": 'SE'
			},
			vatid: {
				type: String,
				default: ""
			},
		},
		data: function() {
			return {
				invalidFields: [],
				lastTriedName: null,
				tenant: {
					name: "",
					id: null,
					privacyConsent: false
				},
				user: {
					name: "",
					firstname: "",
					lastname: "",
					phonenumber: ""
				},
				country: this.countryValue,
				chosenPlan: null,
				countryArray: [],
				countries: []
			};
		},
		computed: {
			inputFieldsValid: function() {
				var ok = true;

				ok = ok && !!this.user.firstname.trim();
				ok = ok && !!this.user.lastname.trim();
				ok = ok && !!this.user.name.trim();
				ok = ok && !!this.tenant.privacyConsent;
				ok = ok && this.invalidFields.length === 0;

				return ok;
			},
			isEnterprise: function() {
				return this.chosenPlan === "000000000000000000000000000b0003";
			}
		},
		methods: {
			setRegistrationValue: function(key, value) {
				this.$set(key, value);
				this.$dispatch('value-change', {
					key: key,
					value: value
				});
			},
			proceed: function() {
				var t = this;
				StripeLoader.getStripe().then(function(Stripe) {
					var stripe = Stripe(client.getStripeKey());
					t.$dispatch('stripe', {
						stripe: stripe
					});
					Vue.nextTick(function() {
						t.$dispatch('proceed');
					});
				});
			},
			goBack: function() {
				this.$dispatch('back');
			},
			backToLogin: function() {
				this.$dispatch('back-to-login');
			},
			openLink: function(link) {
				this.$dispatch('open-link', link);
			},
			setCountrySelectValue: function(value) {
				this.country = this.countryValue;
				if (value) {
					this.$refs.countryselect.setValue(value);
				}
			},
			populateCountries: function () {
				var t = this;
				client.sendRequest("api/country", {
					headers: {
						'Content-Type': 'application/json'
					},
					handleAs: 'json',
					method: "GET"
				}).then(function(res) {
					if (res && res.length > 0) {
						t.$set('countries', res);
						for (var i = 0; i < t.countries.length; i++) {
							t.countryArray.push({
								id: t.countries[i].iso,
								text: t.countries[i].name
							});
						}
					}
				}, function(error) {
					Alertify.alert(t.$t('countryLoadErrorTitle'),t.$t('countryLoadError'),function() {
					});
				});
				Vue.nextTick(function() {
					t.$broadcast('TextBox', {cmd: 'ResetValidation'});
				});
			},
			checkUniqueTenant: function(name, oldName, result) {
				this.lastTriedName = name;
				var t = this;
				var def = new Deferred();
				setTimeout(function() {
					if (t.lastTriedName === name) {
						if (name) {
							client.sendRequest('/api/tenant', {
								query: {
									tenantName: name
								}
							}).then(function(response) {
								result.valid = !response;
								if (!result.valid) {
									result.msg = t.$t('suErrTenantNameExists', { name: name });
								}
								if (result.valid && t.invalidFields.length > 0) {
									for (var i = 0; i < t.invalidFields.length; i++) {
										if (t.invalidFields[i].id == "tenantName") {
											t.invalidFields.splice(i,1);
										}
									}
								}
								def.resolve(result);
							}, function() {
								def.reject();
							});
						} else {
							def.resolve(result);
						}
					} else {
						def.resolve(result);
					}
				}, 300);
				return def;
			}
		},
		events: {
			'invalid': function(event) {
				this.invalidFields.push(event.source);
			},
			'valid': function(event) {
				var index = this.invalidFields.indexOf(event.source);
				if (index !== -1) {
					this.invalidFields.splice(index, 1);
				}
			}
		},
		watch: {
			'country': function(val, oldval) {
				if (val !== oldval && val !== "") {
					this.country = val;
					this.$dispatch('updateRegistrationValue', {
					   key: 'country',
					   value: val
				   });
			   } else if (val === "")  {
				   this.country = oldval;
				   this.$dispatch('updateRegistrationValue', {
					  key: 'country',
					  value: oldval
				  });
			   }
			}
		},
		ready: function() {
			this.chosenPlan = this.selectedPlan;
			this.populateCountries();
			if (this.tenantDetails.name !== "") {
				for (var tenantKey in this.tenant) {
					this.tenant[tenantKey] = this.tenantDetails[tenantKey];
				}
				for (var userKey in this.user) {
					this.user[userKey] = this.userDetails[userKey];
				}
			}
			this.setCountrySelectValue(this.countryValue);
		},
		components: {
			'selector': Selector,
			'textbox': TextBox
		}
	});
});

},
'appivo/page/signupplan/components/StepThree':function(){
define([
	"vue/vue",
	"dojo/Deferred",
	'appivo/util/ArrayHelper',
	"appivo/client/Client",
	'moment/moment',
	'appivo/vue/components/TextBox',
	"appivo/ui/Spinner",
	"dojo/text!../html/StepThree.html"
], function(Vue, Deferred, ArrayHelper, Client, moment, TextBox, Spinner, template) {
	var client = Client.getInstance();

	return Vue.extend({
		template: template,
		props: {
			selectedPlanInfo: {
				type: Object,
				"default": function() {
				    return {};
				}
			},
			stripe: {
				type: Object
			},
			country: {
				type: String,
				default: 'SE'
			},
			vatid: {
				type: String,
				default: ""
			},
			userDetails: {
				type: Object,
				"default": function() {
				    return {};
				}
			},
			tenantDetails: {
				type: Object,
				"default": function() {
					return {};
				}
			},
			paymentDetails: {
				type: Object,
				"default": function() {
					return {};
				}
			},
			customer: {
				type: Object,
				"default": function() {
				    return {};
				}
			}
		},
		data: function() {
			return {
				errors: [],
				cardComplete: false,
				elements: null,
				cardElement: null,
				costBreakdown: {}
			};
		},
		computed: {
			isEnterprise: function() {
				return this.selectedPlanInfo.id === "000000000000000000000000000b0003";
			},
			getTotal: function() {
				if (this.costBreakdown.total) {
					return this.getPriceString(this.costBreakdown.total, this.selectedPlanInfo.currency);
				}
			},
			billingDate: function() {
				var dateRange = this.costBreakdown.dateRanges;
				var fromDate = "";
				var toDate = "";
				var monthlyCycleDate = "";
				var dates = "";
				if (dateRange && dateRange.length > 0) {
					for (var i = 0; i < dateRange.length; i++) {
						if (dateRange[i].amount !== 0  && (dateRange[i].amount === this.costBreakdown.subtotal || this.costBreakdown.subtotal === this.costBreakdown.total)) {
							fromDate = moment(dateRange[i].fromDate).format('D MMM, YYYY');
							toDate = moment(dateRange[i].toDate).format('D MMM, YYYY');
							monthlyCycleDate =  moment(dateRange[i].toDate).add(1, 'd').format('D MMM, YYYY');
							if (dateRange.length > 2 && dateRange[i].amount !== 0.0) {
								if (dates === "") {
									if (fromDate === toDate) {
										dates = fromDate;
									} else {
										dates = `${fromDate} to
												${toDate}`.replace(/\t/g, '');
									}
								} else {
									dates = `${dates}
											+
											${fromDate} to
											${toDate}`.replace(/\t/g, '');
									return dates;
								}
							} else {
								return {fromDate: fromDate, toDate: toDate, nextFullMonth: monthlyCycleDate};
							}
						}
					}
				}
			},
			trialDuration: function() {
				var dateRange = this.costBreakdown.dateRanges;
				if (dateRange && dateRange.length > 0) {
					for (var i = 0; i < dateRange.length; i++) {
						if (dateRange[i].amount === 0.0) {
							fromDate = moment(dateRange[i].fromDate).format('D MMM, YYYY');
							toDate = moment(dateRange[i].toDate).format('D MMM, YYYY');
							if (fromDate && toDate) {
								return {fromDate: fromDate, toDate: toDate};
							}
						}
					}
				}
			},
			errorMessage: function() {
				return this.errors.map(function(e) { return e.message; }).join('<br>');
			}
		},
		methods: {
			updatePlanPrice: function() {
				var t = this;
				client.sendRequest("/api/plan/", {
					method: 'GET',
					headers: {
						'Content-Type': 'application/json'
					},
					query: {
						"countryIso": this.country
					}
				}).then(function(result){
					if (result && result.length > 0) {
						for (var i = 0; i < result.length; i++) {
							if (t.selectedPlanInfo.id === result[i].id) {
								Vue.set(t.selectedPlanInfo,'price',result[i].price);
								Vue.set(t.selectedPlanInfo,'currency',result[i].currency);
								t.$dispatch('updatePlanCurrency',result[i]);
							}
						}
					}
				});
			},
			getPriceString: function(price, currencyIso) {
				if (this.costBreakdown.hasTrial && price === 0) {
					return this.$t('suStepThreeFree');
				} else {
					if (price && price % 1 !== 0) {
						price = price.toFixed(2);
					}
					switch (currencyIso) {
						case 'SEK': return price + "kr";
						case 'USD': return "$" + price;
						default: return "€" + price;
					}
				}
			},
			handleCardEvent: function(event) {
			    this.cardComplete = event.complete;
                var type = event.elementType;
                this.dropError(type);
                if (event.error) {
                    this.errors.push({
                        type: type,
                        message: event.error.message,
                        code: event.error.code
                    });
                }
            },
            dropError: function(type) {
                  var index = ArrayHelper.findIndex(this.errors, function(e) {
                      return e.type === type;
                  });
                  if (index !== -1) {
                      this.errors.splice(index, 1);
                  }
            },
			submit: function() {
                if (this.errorMessage === "") {
                    var cardElement = this.elements.getElement('card');
                    var event = {
                        def: new Deferred(),
                        data: {
                            card: cardElement
                        },
						stripe: this.stripe
                    };
                    this.$dispatch("submit", event);
                }
			},
            proceed: function() {
				client.registerPageView('sign_up');
				this.$dispatch('proceed');
            },
            goBack: function() {
                this.$dispatch('back');
                this.$dispatch('populateUserData',this.tenantDetails,this.userDetails,this.vatid);
            },
			openLink: function(link) {
			    this.$dispatch('open-link', link);
			},
			setupStripeElement: function() {
			    var el = this.elements.getElement("card");
                if (!el) {
					// see https://stripe.com/docs/js/elements_object/create_element?type=card#elements_create-options for options
					var style = {
						base: {
						  color: '#343434',
						  fontSize: '16px',
						  fontFamily: '"Open Sans", sans-serif',
						  fontSmoothing: 'antialiased',
						},
						invalid: {
						  ':focus': {
							color: '#343434',
						  },
						},
					};
                    el = this.elements.create("card", { style: style });
                }
                el.mount(this.$els.card);
                el.on('change', this.handleCardEvent);
			}
		},
		ready: function() {
			var t = this;
			t.elements = t.stripe.elements();
			if (t.selectedPlanInfo.id !== '000000000000000000000000000b0003') {
				t.setupStripeElement();
			}
			t.updatePlanPrice();
			t.costBreakdown = t.paymentDetails;
		},
		components: {
			'textbox':TextBox
		}
	});
});

},
'appivo/page/signupplan/components/StepFour':function(){
define([
	"vue/vue",
	"dojo/text!../html/StepFour.html"
], function(Vue, template) {
	return Vue.extend({
		template: template,
		props: {
			selectedPlanInfo: {
				type: Object,
				"default": function() {
				    return {};
				}
			}
		},
		methods: {
            backToLogin: function() {
                this.$dispatch('back-to-login');
            }
		}
	});
});

},
'OverlayScrollbars/js/OverlayScrollbars':function(){
/*!
 * OverlayScrollbars
 * https://github.com/KingSora/OverlayScrollbars
 *
 * Version: 1.8.0
 *
 * Copyright KingSora | Rene Haas.
 * https://github.com/KingSora
 *
 * Released under the MIT license.
 * Date: 08.07.2019
 */

(function (global, factory) {
    if (typeof define === 'function' && define.amd)
        define(function() { return factory(global, global.document, undefined); });
    else if (typeof module === 'object' && typeof module.exports === 'object')
        module.exports = factory(global, global.document, undefined);
    else
        factory(global, global.document, undefined);
}(typeof window !== 'undefined' ? window : this,
    function(window, document, undefined) {
        'use strict';
        var PLUGINNAME = 'OverlayScrollbars';
        var TYPES = {
            o : 'object',
            f : 'function',
            a : 'array',
            s : 'string',
            b : 'boolean',
            n : 'number',
            u : 'undefined',
            z : 'null'
            //d : 'date',
            //e : 'error',
            //r : 'regexp',
            //y : 'symbol'
        };
        var LEXICON = {
            c : 'class',
            s : 'style',
            i : 'id',
            l : 'length',
            p : 'prototype',
            oH : 'offsetHeight',
            cH : 'clientHeight',
            sH : 'scrollHeight',
            oW : 'offsetWidth',
            cW : 'clientWidth',
            sW : 'scrollWidth',
            hOP : 'hasOwnProperty'
        };
        var VENDORS = {
            //https://developer.mozilla.org/en-US/docs/Glossary/Vendor_Prefix
            _jsCache : { },
            _cssCache : { },
            _cssPrefixes : ['-webkit-', '-moz-', '-o-', '-ms-'],
            _jsPrefixes : ['WebKit', 'Moz', 'O', 'MS'],
            _cssProperty : function(name) {
                var cache = this._cssCache;

                if(cache[name])
                    return cache[name];

                var prefixes = this._cssPrefixes;
                var uppercasedName = this._firstLetterToUpper(name);
                var elmStyle = document.createElement('div')[LEXICON.s];
                var resultPossibilities;
                var i = 0;
                var v = 0;
                var currVendorWithoutDashes;

                for (; i < prefixes.length; i++) {
                    currVendorWithoutDashes = prefixes[i].replace(/-/g, '');
                    resultPossibilities = [
                        name, //transition
                        prefixes[i] + name, //-webkit-transition
                        currVendorWithoutDashes + uppercasedName, //webkitTransition
                        this._firstLetterToUpper(currVendorWithoutDashes) + uppercasedName //WebkitTransition
                    ];
                    for(v = 0; v < resultPossibilities[LEXICON.l]; v++) {
                        if(elmStyle[resultPossibilities[v]] !== undefined) {
                            cache[name] = resultPossibilities[v];
                            return resultPossibilities[v];
                        }
                    }
                }

                return null;
            },
            _jsAPI : function(name, isInterface, fallback) {
                var prefixes = this._jsPrefixes;
                var cache = this._jsCache;
                var i = 0;
                var result = cache[name];
                if(!result) {
                    result = window[name];
                    for(; i < prefixes[LEXICON.l]; i++)
                        result = result || window[(isInterface ? prefixes[i] : prefixes[i].toLowerCase()) + this._firstLetterToUpper(name)];
                    cache[name] = result;
                }
                return result || fallback;
            },
            _firstLetterToUpper : function(str) {
                return str.charAt(0).toUpperCase() + str.slice(1);
            }
        };
        var COMPATIBILITY = {
            /**
             * Gets the current window width.
             * @returns {Number|number} The current window width in pixel.
             */
            wW: function() {
                return window.innerWidth || document.documentElement[LEXICON.cW] || document.body[LEXICON.cW];
            },

            /**
             * Gets the current window height.
             * @returns {Number|number} The current window height in pixel.
             */
            wH: function() {
                return window.innerHeight || document.documentElement[LEXICON.cH] || document.body[LEXICON.cH];
            },

            /**
             * Gets the MutationObserver Object or undefined if not supported.
             * @returns {MutationObserver|*|undefined} The MutationsObserver Object or undefined.
             */
            mO: function() {
                return VENDORS._jsAPI('MutationObserver', true);
            },

            /**
             * Gets the ResizeObserver Object or undefined if not supported.
             * @returns {MutationObserver|*|undefined} The ResizeObserver Object or undefined.
             */
            rO: function() {
                return VENDORS._jsAPI('ResizeObserver', true);
            },

            /**
             * Gets the RequestAnimationFrame method or it's corresponding polyfill.
             * @returns {*|Function} The RequestAnimationFrame method or it's corresponding polyfill.
             */
            rAF: function() {
                return VENDORS._jsAPI('requestAnimationFrame', false, function (func) { return window.setTimeout(func, 1000 / 60); });
            },

            /**
             * Gets the CancelAnimationFrame method or it's corresponding polyfill.
             * @returns {*|Function} The CancelAnimationFrame method or it's corresponding polyfill.
             */
            cAF: function() {
                return VENDORS._jsAPI('cancelAnimationFrame', false, function (id) { return window.clearTimeout(id); });
            },

            /**
             * Gets the current time.
             * @returns {number} The current time.
             */
            now: function() {
                return Date.now && Date.now() || new Date().getTime();
            },

            /**
             * Stops the propagation of the given event.
             * @param event The event of which the propagation shall be stoped.
             */
            stpP: function(event) {
                if(event.stopPropagation)
                    event.stopPropagation();
                else
                    event.cancelBubble = true;
            },

            /**
             * Prevents the default action of the given event.
             * @param event The event of which the default action shall be prevented.
             */
            prvD: function(event) {
                if(event.preventDefault && event.cancelable)
                    event.preventDefault();
                else
                    event.returnValue = false;
            },

            /**
             * Gets the pageX and pageY values of the given mouse event.
             * @param event The mouse event of which the pageX and pageX shall be got.
             * @returns {{x: number, y: number}} x = pageX value, y = pageY value.
             */
            page: function(event) {
                event = event.originalEvent || event;

                var strPage = 'page';
                var strClient = 'client';
                var strX = 'X';
                var strY = 'Y';
                var target = event.target || event.srcElement || document;
                var eventDoc = target.ownerDocument || document;
                var doc = eventDoc.documentElement;
                var body = eventDoc.body;

                //if touch event return return pageX/Y of it
                if(event.touches !== undefined) {
                    var touch = event.touches[0];
                    return {
                        x : touch[strPage + strX],
                        y : touch[strPage + strY]
                    }
                }

                // Calculate pageX/Y if not native supported
                if (!event[strPage + strX] && event[strClient + strX] && event[strClient + strX] != null) {

                    return {
                        x : event[strClient + strX] +
                        (doc && doc.scrollLeft || body && body.scrollLeft || 0) -
                        (doc && doc.clientLeft || body && body.clientLeft || 0),
                        y : event[strClient + strY] +
                        (doc && doc.scrollTop || body && body.scrollTop || 0) -
                        (doc && doc.clientTop || body && body.clientTop || 0)
                    }
                }
                return {
                    x : event[strPage + strX],
                    y : event[strPage + strY]
                };
            },

            /**
             * Gets the clicked mouse button of the given mouse event.
             * @param event The mouse event of which the clicked button shal be got.
             * @returns {number} The number of the clicked mouse button. (0 : none | 1 : leftButton | 2 : middleButton | 3 : rightButton)
             */
            mBtn: function(event) {
                var button = event.button;
                if (!event.which && button !== undefined)
                    return (button & 1 ? 1 : (button & 2 ? 3 : (button & 4 ? 2 : 0)));
                else
                    return event.which;
            },

            /**
             * Checks whether a item is in the given array and returns its index.
             * @param item The item of which the position in the array shall be determined.
             * @param arr The array.
             * @returns {number} The zero based index of the item or -1 if the item isn't in the array.
             */
            inA : function(item, arr) {
                for (var i = 0; i < arr[LEXICON.l]; i++)
                    //Sometiems in IE a "SCRIPT70" Permission denied error occurs if HTML elements in a iFrame are compared
                    try {
                        if (arr[i] === item)
                            return i;
                    }
                    catch(e) { }
                return -1;
            },

            /**
             * Returns true if the given value is a array.
             * @param arr The potential array.
             * @returns {boolean} True if the given value is a array, false otherwise.
             */
            isA: function(arr) {
                var def = Array.isArray;
                return def ? def(arr) : this.type(arr) == TYPES.a;
            },

            /**
             * Determine the internal JavaScript [[Class]] of the given object.
             * @param obj The object of which the type shall be determined.
             * @returns {string} The type of the given object.
             */
            type: function(obj) {
                if (obj === undefined)
                    return obj + "";
                if (obj === null)
                    return obj + "";
                return Object[LEXICON.p].toString.call(obj).replace(/^\[object (.+)\]$/, '$1').toLowerCase();
            },


            bind: function(func, thisObj) {
                if (typeof func != TYPES.f) {
                    throw "Can't bind function!";
                    // closest thing possible to the ECMAScript 5
                    // internal IsCallable function
                    //throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
                }
                var proto     = LEXICON.p;
                var aArgs   = Array[proto].slice.call(arguments, 2);
                var fNOP    = function() {};
                var fBound  = function() { return func.apply(this instanceof fNOP ? this : thisObj, aArgs.concat(Array[proto].slice.call(arguments))); };

                if (func[proto])
                    fNOP[proto] = func[proto]; // Function.prototype doesn't have a prototype property
                fBound[proto] = new fNOP();

                return fBound;
            }

            /**
             * Gets the vendor-prefixed CSS property by the given name.
             * For example the given name is "transform" and you're using a old Firefox browser then the returned value would be "-moz-transform".
             * If the browser doesn't need a vendor-prefix, then the returned string is the given name.
             * If the browser doesn't support the given property name at all (not even with a vendor-prefix) the returned value is null.
             * @param propName The unprefixed CSS property name.
             * @returns {string|null} The vendor-prefixed CSS property or null if the browser doesn't support the given CSS property.

            cssProp : function(propName) {
                return VENDORS._cssProperty(propName);
            }
            */
        };

        var MATH = Math;
        var JQUERY = window.jQuery;
        var EASING = (function() {
            var _easingsMath = {
                p : MATH.PI,
                c : MATH.cos,
                s : MATH.sin,
                w : MATH.pow,
                t : MATH.sqrt,
                n : MATH.asin,
                a : MATH.abs,
                o : 1.70158
            };
            
            /*
             x : current percent (0 - 1),
             t : current time (duration * percent),
             b : start value (from),
             c : end value (to),
             d : duration

             easingName : function(x, t, b, c, d) { return easedValue; }
             */

            return {
                swing: function (x, t, b, c, d) {
                    return 0.5 - _easingsMath.c(x * _easingsMath.p) / 2;
                },
                linear: function(x, t, b, c, d) {
                    return x;
                },
                easeInQuad: function (x, t, b, c, d) {
                    return c*(t/=d)*t + b;
                },
                easeOutQuad: function (x, t, b, c, d) {
                    return -c *(t/=d)*(t-2) + b;
                },
                easeInOutQuad: function (x, t, b, c, d) {
                    return ((t/=d/2) < 1) ? c/2*t*t + b : -c/2 * ((--t)*(t-2) - 1) + b;
                },
                easeInCubic: function (x, t, b, c, d) {
                    return c*(t/=d)*t*t + b;
                },
                easeOutCubic: function (x, t, b, c, d) {
                    return c*((t=t/d-1)*t*t + 1) + b;
                },
                easeInOutCubic: function (x, t, b, c, d) {
                    return ((t/=d/2) < 1) ? c/2*t*t*t + b : c/2*((t-=2)*t*t + 2) + b;
                },
                easeInQuart: function (x, t, b, c, d) {
                    return c*(t/=d)*t*t*t + b;
                },
                easeOutQuart: function (x, t, b, c, d) {
                    return -c * ((t=t/d-1)*t*t*t - 1) + b;
                },
                easeInOutQuart: function (x, t, b, c, d) {
                    return ((t/=d/2) < 1) ? c/2*t*t*t*t + b : -c/2 * ((t-=2)*t*t*t - 2) + b;
                },
                easeInQuint: function (x, t, b, c, d) {
                    return c*(t/=d)*t*t*t*t + b;
                },
                easeOutQuint: function (x, t, b, c, d) {
                    return c*((t=t/d-1)*t*t*t*t + 1) + b;
                },
                easeInOutQuint: function (x, t, b, c, d) {
                    return ((t/=d/2) < 1) ? c/2*t*t*t*t*t + b : c/2*((t-=2)*t*t*t*t + 2) + b;
                },
                easeInSine: function (x, t, b, c, d) {
                    return -c * _easingsMath.c(t/d * (_easingsMath.p/2)) + c + b;
                },
                easeOutSine: function (x, t, b, c, d) {
                    return c * _easingsMath.s(t/d * (_easingsMath.p/2)) + b;
                },
                easeInOutSine: function (x, t, b, c, d) {
                    return -c/2 * (_easingsMath.c(_easingsMath.p*t/d) - 1) + b;
                },
                easeInExpo: function (x, t, b, c, d) {
                    return (t==0) ? b : c * _easingsMath.w(2, 10 * (t/d - 1)) + b;
                },
                easeOutExpo: function (x, t, b, c, d) {
                    return (t==d) ? b+c : c * (-_easingsMath.w(2, -10 * t/d) + 1) + b;
                },
                easeInOutExpo: function (x, t, b, c, d) {
                    if (t==0) return b;
                    if (t==d) return b+c;
                    if ((t/=d/2) < 1) return c/2 * _easingsMath.w(2, 10 * (t - 1)) + b;
                    return c/2 * (-_easingsMath.w(2, -10 * --t) + 2) + b;
                },
                easeInCirc: function (x, t, b, c, d) {
                    return -c * (_easingsMath.t(1 - (t/=d)*t) - 1) + b;
                },
                easeOutCirc: function (x, t, b, c, d) {
                    return c * _easingsMath.t(1 - (t=t/d-1)*t) + b;
                },
                easeInOutCirc: function (x, t, b, c, d) {
                    return ((t/=d/2) < 1) ? -c/2 * (_easingsMath.t(1 - t*t) - 1) + b : c/2 * (_easingsMath.t(1 - (t-=2)*t) + 1) + b;
                },
                easeInElastic: function (x, t, b, c, d) {
                    var s=_easingsMath.o;var p=0;var a=c;
                    if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
                    if (a < _easingsMath.a(c)) { a=c; s=p/4; }
                    else s = p/(2*_easingsMath.p) * _easingsMath.n (c/a);
                    return -(a*_easingsMath.w(2,10*(t-=1)) * _easingsMath.s( (t*d-s)*(2*_easingsMath.p)/p )) + b;
                },
                easeOutElastic: function (x, t, b, c, d) {
                    var s=_easingsMath.o;var p=0;var a=c;
                    if (t==0) return b;  
                    if ((t/=d)==1) return b+c;  
                    if (!p) p=d*.3;
                    if (a < _easingsMath.a(c)) { a=c; s=p/4; }
                    else s = p/(2*_easingsMath.p) * _easingsMath.n (c/a);
                    return a*_easingsMath.w(2,-10*t) * _easingsMath.s( (t*d-s)*(2*_easingsMath.p)/p ) + c + b;
                },
                easeInOutElastic: function (x, t, b, c, d) {
                    var s=_easingsMath.o;var p=0;var a=c;
                    if (t==0) return b;  
                    if ((t/=d/2)==2) return b+c;  
                    if (!p) p=d*(.3*1.5);
                    if (a < _easingsMath.a(c)) { a=c; s=p/4; }
                    else s = p/(2*_easingsMath.p) * _easingsMath.n (c/a);
                    if (t < 1) return -.5*(a*_easingsMath.w(2,10*(t-=1)) * _easingsMath.s( (t*d-s)*(2*_easingsMath.p)/p )) + b;
                    return a*_easingsMath.w(2,-10*(t-=1)) * _easingsMath.s( (t*d-s)*(2*_easingsMath.p)/p )*.5 + c + b;
                },
                easeInBack: function (x, t, b, c, d, s) {
                    s = s || _easingsMath.o;
                    return c*(t/=d)*t*((s+1)*t - s) + b;
                },
                easeOutBack: function (x, t, b, c, d, s) {
                    s = s || _easingsMath.o;
                    return c*((t=t/d-1)*t*((s+1)*t + s) + 1) + b;
                },
                easeInOutBack: function (x, t, b, c, d, s) {
                    s = s || _easingsMath.o;
                    return ((t/=d/2) < 1) ? c/2*(t*t*(((s*=(1.525))+1)*t - s)) + b : c/2*((t-=2)*t*(((s*=(1.525))+1)*t + s) + 2) + b;
                },
                easeInBounce: function (x, t, b, c, d) {
                    return c - this.easeOutBounce (x, d-t, 0, c, d) + b;
                },
                easeOutBounce: function (x, t, b, c, d) {
                    var o = 7.5625;
                    if ((t/=d) < (1/2.75)) {
                        return c*(o*t*t) + b;
                    } else if (t < (2/2.75)) {
                        return c*(o*(t-=(1.5/2.75))*t + .75) + b;
                    } else if (t < (2.5/2.75)) {
                        return c*(o*(t-=(2.25/2.75))*t + .9375) + b;
                    } else {
                        return c*(o*(t-=(2.625/2.75))*t + .984375) + b;
                    }
                },
                easeInOutBounce: function (x, t, b, c, d) {
                    return (t < d/2) ? this.easeInBounce (x, t*2, 0, c, d) * .5 + b : this.easeOutBounce (x, t*2-d, 0, c, d) * .5 + c*.5 + b;
                }
            };
            /*
             *
             * TERMS OF USE - EASING EQUATIONS
             * 
             * Open source under the BSD License. 
             * 
             * Copyright Â© 2001 Robert Penner
             * All rights reserved.
             * 
             * Redistribution and use in source and binary forms, with or without modification, 
             * are permitted provided that the following conditions are met:
             * 
             * Redistributions of source code must retain the above copyright notice, this list of 
             * conditions and the following disclaimer.
             * Redistributions in binary form must reproduce the above copyright notice, this list 
             * of conditions and the following disclaimer in the documentation and/or other materials 
             * provided with the distribution.
             * 
             * Neither the name of the author nor the names of contributors may be used to endorse 
             * or promote products derived from this software without specific prior written permission.
             * 
             * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY 
             * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
             * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
             *  COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
             *  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
             *  GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED 
             * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
             *  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED 
             * OF THE POSSIBILITY OF SUCH DAMAGE. 
             *
             */
        })();
        var FRAMEWORK = (function() {
            var _rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
            var _strSpace = ' ';
            var _strEmpty = '';
            var _strScrollLeft = 'scrollLeft';
            var _strScrollTop = 'scrollTop';
            var _animations = [ ];
            var _type = COMPATIBILITY.type;
            var _cssNumber = {
                "animationIterationCount": true,
                "columnCount": true,
                "fillOpacity": true,
                "flexGrow": true,
                "flexShrink": true,
                "fontWeight": true,
                "lineHeight": true,
                "opacity": true,
                "order": true,
                "orphans": true,
                "widows": true,
                "zIndex": true,
                "zoom": true
            };

            var extend = function() {
                var src, copyIsArray, copy, name, options, clone, target = arguments[0] || {},
                    i = 1,
                    length = arguments[LEXICON.l],
                    deep = false;

                // Handle a deep copy situation
                if (_type(target) == TYPES.b) {
                    deep = target;
                    target = arguments[1] || {};
                    // skip the boolean and the target
                    i = 2;
                }

                // Handle case when target is a string or something (possible in deep copy)
                if (_type(target) != TYPES.o && !_type(target) == TYPES.f) {
                    target = {};
                }

                // extend jQuery itself if only one argument is passed
                if (length === i) {
                    target = FakejQuery;
                    --i;
                }

                for (; i < length; i++) {
                    // Only deal with non-null/undefined values
                    if ((options = arguments[i]) != null) {
                        // Extend the base object
                        for (name in options) {
                            src = target[name];
                            copy = options[name];

                            // Prevent never-ending loop
                            if (target === copy) {
                                continue;
                            }

                            // Recurse if we're merging plain objects or arrays
                            if (deep && copy && (isPlainObject(copy) || (copyIsArray = COMPATIBILITY.isA(copy)))) {
                                if (copyIsArray) {
                                    copyIsArray = false;
                                    clone = src && COMPATIBILITY.isA(src) ? src : [];

                                } else {
                                    clone = src && isPlainObject(src) ? src : {};
                                }

                                // Never move original objects, clone them
                                target[name] = extend(deep, clone, copy);

                                // Don't bring in undefined values
                            } else if (copy !== undefined) {
                                target[name] = copy;
                            }
                        }
                    }
                }

                // Return the modified object
                return target;
            };

            var inArray = function(item, arr, fromIndex) {
                for (var i = fromIndex || 0; i < arr[LEXICON.l]; i++)
                    if (arr[i] === item)
                        return i;
                return -1;
            }
            
            var isFunction = function(obj) {
                return _type(obj) == TYPES.f;
            };

            var isEmptyObject = function(obj) {
                for (var name in obj )
                    return false;
                return true;
            };

            var isPlainObject = function(obj) {
                if (!obj || _type(obj) != TYPES.o)
                    return false;

                var key;
                var proto = LEXICON.p;
                var hasOwnProperty = Object[proto].hasOwnProperty;
                var hasOwnConstructor = hasOwnProperty.call(obj, 'constructor');
                var hasIsPrototypeOf = obj.constructor && obj.constructor[proto] && hasOwnProperty.call(obj.constructor[proto], 'isPrototypeOf');

                if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
                    return false;
                }


                for (key in obj) { /**/ }

                return _type(key) == TYPES.u || hasOwnProperty.call(obj, key);
            };

            var each = function(obj, callback) {
                var i = 0;

                if (isArrayLike(obj)) {
                    for (; i < obj[LEXICON.l]; i++) {
                        if (callback.call(obj[i], i, obj[i]) === false)
                            break;
                    }
                }
                else {
                    for (i in obj) {
                        if (callback.call(obj[i], i, obj[i]) === false)
                            break;
                    }
                }

                return obj;
            };

            var FakejQuery = function (selector) {
                if(arguments[LEXICON.l] === 0)
                    return this;

                var base = new FakejQuery();
                var elements = selector;
                var i = 0;
                var elms;
                var el;

                if(_type(selector) == TYPES.s) {
                    elements = [ ];
                    if(selector.charAt(0) === '<') {
                        el = document.createElement('div');
                        el.innerHTML = selector;
                        elms = el.children;
                    }
                    else {
                        elms = document.querySelectorAll(selector);
                    }

                    for(; i < elms[LEXICON.l]; i++)
                        elements.push(elms[i]);
                }

                if(elements) {
                    if(_type(elements) != TYPES.s && (!isArrayLike(elements) || elements === window || elements === elements.self))
                        elements = [ elements ];

                    for(i = 0; i < elements[LEXICON.l]; i++)
                        base[i] = elements[i];

                    base[LEXICON.l] = elements[LEXICON.l];
                }

                return base;
            };

            function isArrayLike(obj) {
                var length = !!obj && [LEXICON.l] in obj && obj[LEXICON.l];
                var t = _type(obj);
                return isFunction(t) ? false : (t == TYPES.a || length === 0 || _type(length) == TYPES.n && length > 0 && (length - 1) in obj);
            }

            function stripAndCollapse(value) {
                var tokens = value.match(_rnothtmlwhite) || [];
                return tokens.join(_strSpace);
            }

            function matches(elem, selector) {
                var nodeList = (elem.parentNode || document).querySelectorAll(selector) || [];
                var i = nodeList[LEXICON.l];

                while (i--)
                    if (nodeList[i] == elem)
                        return true;

                return false;
            }

            function insertAdjacentElement(el, strategy, child) {
                if(_type(child) == TYPES.a) {
                    for(var i = 0; i < child[LEXICON.l]; i++)
                        insertAdjacentElement(el, strategy, child[i]);
                }
                else if(_type(child) == TYPES.s)
                    el.insertAdjacentHTML(strategy, child);
                else
                    el.insertAdjacentElement(strategy, child.nodeType ? child : child[0]);
            }

            function setCSSVal(el, prop, val) {
                try {
                    if(el[LEXICON.s][prop] !== undefined)
                        el[LEXICON.s][prop] = parseCSSVal(prop, val);
                } catch(e) { }
            }

            function parseCSSVal(prop, val) {
                if(!_cssNumber[prop.toLowerCase()] && _type(val) == TYPES.n)
                    val += 'px';
                return val;
            }

            function startNextAnimationInQ(animObj, removeFromQ) {
                var index;
                var nextAnim;
                if(removeFromQ !== false)
                    animObj.q.splice(0, 1);
                if(animObj.q[LEXICON.l] > 0) {
                    nextAnim = animObj.q[0];
                    animate(animObj.el, nextAnim.props, nextAnim.duration, nextAnim.easing, nextAnim.complete, true);
                }
                else {
                    index = inArray(animObj, _animations);
                    if(index > -1)
                        _animations.splice(index, 1);
                }
            }

            function setAnimationValue(el, prop, value) {
                if(prop === _strScrollLeft || prop === _strScrollTop)
                    el[prop] = value;
                else
                    setCSSVal(el, prop, value);
            }

            function animate(el, props, options, easing, complete, guaranteedNext) {
                var hasOptions = isPlainObject(options);
                var from = { };
                var to = { };
                var i = 0;
                var key;
                var animObj;
                var start;
                var progress;
                var step;
                var specialEasing;
                var duration;
                if(hasOptions) {
                    easing = options.easing;
                    start = options.start;
                    progress = options.progress;
                    step = options.step;
                    specialEasing = options.specialEasing;
                    complete = options.complete;
                    duration = options.duration;
                }
                else
                    duration = options;
                specialEasing = specialEasing || { };
                duration = duration || 400;
                easing = easing || 'swing';
                guaranteedNext = guaranteedNext || false;

                for(; i < _animations[LEXICON.l]; i++) {
                    if(_animations[i].el === el) {
                        animObj = _animations[i];
                        break;
                    }
                }

                if(!animObj) {
                    animObj = {
                        el : el,
                        q : []
                    };
                    _animations.push(animObj);
                }

                for (key in props) {
                    if(key === _strScrollLeft || key === _strScrollTop)
                        from[key] = el[key];
                    else
                        from[key] = FakejQuery(el).css(key);
                }

                for (key in from) {
                    if(from[key] !== props[key] && props[key] !== undefined)
                        to[key] = props[key];
                }

                if(!isEmptyObject(to)) {
                    var timeNow;
                    var end;
                    var percent;
                    var fromVal;
                    var toVal;
                    var easedVal;
                    var timeStart;
                    var frame;
                    var elapsed;
                    var qPos = guaranteedNext ? 0 : inArray(qObj, animObj.q);
                    var qObj = {
                        props : to,
                        duration : hasOptions ? options : duration,
                        easing : easing,
                        complete : complete
                    };
                    if (qPos === -1) {
                        qPos = animObj.q[LEXICON.l];
                        animObj.q.push(qObj);
                    }

                    if(qPos === 0) {
                        if(duration > 0) {
                            timeStart = COMPATIBILITY.now();
                            frame = function() {
                                timeNow = COMPATIBILITY.now();
                                elapsed = (timeNow - timeStart);
                                end = qObj.stop || elapsed >= duration;
                                percent = 1 - ((MATH.max(0, timeStart + duration - timeNow) / duration) || 0);

                                for(key in to) {
                                    fromVal = parseFloat(from[key]);
                                    toVal = parseFloat(to[key]);
                                    easedVal = (toVal - fromVal) * EASING[specialEasing[key] || easing](percent, percent * duration, 0, 1, duration) + fromVal;
                                    setAnimationValue(el, key, easedVal);
                                    if(isFunction(step)) {
                                        step(easedVal, {
                                            elem : el,
                                            prop : key,
                                            start : fromVal,
                                            now : easedVal,
                                            end : toVal,
                                            pos : percent,
                                            options : {
                                                easing : easing,
                                                speacialEasing : specialEasing,
                                                duration : duration,
                                                complete : complete,
                                                step : step
                                            },
                                            startTime : timeStart
                                        });
                                    }
                                }

                                if(isFunction(progress))
                                    progress({ }, percent, MATH.max(0, duration - elapsed));

                                if (end) {
                                    startNextAnimationInQ(animObj);
                                    if(isFunction(complete))
                                        complete();
                                }
                                else
                                    qObj.frame = COMPATIBILITY.rAF()(frame);
                            };
                            qObj.frame = COMPATIBILITY.rAF()(frame);
                        }
                        else {
                            for(key in to)
                                setAnimationValue(el, key, to[key]);
                            startNextAnimationInQ(animObj);
                        }
                    }
                }
                else if(guaranteedNext)
                    startNextAnimationInQ(animObj);
            }

            function stop(el, clearQ, jumpToEnd) {
                var animObj;
                var qObj;
                var key;
                var i = 0;
                for(; i < _animations[LEXICON.l]; i++) {
                    animObj = _animations[i];
                    if(animObj.el === el) {
                        if(animObj.q[LEXICON.l] > 0) {
                            qObj = animObj.q[0];
                            qObj.stop = true;
                            COMPATIBILITY.cAF()(qObj.frame);
                            animObj.q.splice(0, 1);

                            if(jumpToEnd)
                                for(key in qObj.props)
                                    setAnimationValue(el, key, qObj.props[key]);

                            if(clearQ)
                                animObj.q = [ ];
                            else
                                startNextAnimationInQ(animObj, false);
                        }
                        break;
                    }
                }
            }

            FakejQuery[LEXICON.p] = {

                //EVENTS:

                on : function(eventName, handler) {
                    eventName = (eventName || _strEmpty).match(_rnothtmlwhite) || [_strEmpty];

                    var eventNameLength = eventName[LEXICON.l];
                    var i = 0;
                    var el;
                    return this.each(function() {
                        el = this;
                        try {
                            if (el.addEventListener) {
                                for (; i < eventNameLength; i++)
                                    el.addEventListener(eventName[i], handler);
                            }
                            else if(el.detachEvent) {
                                for (; i < eventNameLength; i++)
                                    el.attachEvent('on' + eventName[i], handler);
                            }
                        } catch (e) { }
                    });
                },

                off : function(eventName, handler) {
                    eventName = (eventName || _strEmpty).match(_rnothtmlwhite) || [_strEmpty];

                    var eventNameLength = eventName[LEXICON.l];
                    var i = 0;
                    var el;
                    return this.each(function() {
                        el = this;
                        try {
                            if (el.removeEventListener) {
                                for (; i < eventNameLength; i++)
                                    el.removeEventListener(eventName[i], handler);
                            }
                            else if(el.detachEvent) {
                                for (; i < eventNameLength; i++)
                                    el.detachEvent('on' + eventName[i], handler);
                            }
                        } catch (e) { }
                    });
                },

                one : function (eventName, handler) {
                    eventName = (eventName || _strEmpty).match(_rnothtmlwhite) || [_strEmpty];
                    return this.each(function() {
                        var el = FakejQuery(this);
                        FakejQuery.each(eventName, function(i, oneEventName) {
                            var oneHandler = function(e) {
                                handler.call(this, e);
                                el.off(oneEventName, oneHandler);
                            };
                            el.on(oneEventName, oneHandler);
                        });
                    });
                },

                trigger : function(eventName) {
                    var el;
                    var event;
                    return this.each(function() {
                        el = this;
                        if (document.createEvent) {
                            event = document.createEvent('HTMLEvents');
                            event.initEvent(eventName, true, false);
                            el.dispatchEvent(event);
                        }
                        else {
                            el.fireEvent("on" + eventName);
                        }
                    });
                },

                //DOM NODE INSERTING / REMOVING:

                append : function(child) {
                    return this.each(function() { insertAdjacentElement(this, 'beforeend', child); });
                },

                prepend : function(child) {
                    return this.each(function() { insertAdjacentElement(this, 'afterbegin', child); });
                },

                before : function(child) {
                    return this.each(function() { insertAdjacentElement(this, 'beforebegin', child); });
                },

                after : function(child) {
                    return this.each(function() { insertAdjacentElement(this, 'afterend', child); });
                },

                remove : function() {
                    return this.each(function() {
                        var el = this;
                        var parentNode = el.parentNode;
                        if(parentNode != null)
                            parentNode.removeChild(el);
                    });
                },

                unwrap : function() {
                    var parents = [ ];
                    var i;
                    var el;
                    var parent;

                    this.each(function() {
                        parent = this.parentNode;
                        if(inArray(parent, parents) === - 1)
                            parents.push(parent);
                    });

                    for(i = 0; i < parents[LEXICON.l]; i++) {
                        el = parents[i];
                        parent = el.parentNode;
                        while (el.firstChild)
                            parent.insertBefore(el.firstChild, el);
                        parent.removeChild(el);
                    }

                    return this;
                },

                wrapAll : function(wrapperHTML) {
                    var i;
                    var nodes = this;
                    var wrapper = FakejQuery(wrapperHTML)[0];
                    var deepest = wrapper;
                    var parent = nodes[0].parentNode;
                    var previousSibling = nodes[0].previousSibling;
                    while(deepest.childNodes[LEXICON.l] > 0)
                        deepest = deepest.childNodes[0];

                    for (i = 0; nodes[LEXICON.l] - i; deepest.firstChild === nodes[0] && i++)
                        deepest.appendChild(nodes[i]);

                    var nextSibling = previousSibling ? previousSibling.nextSibling : parent.firstChild;
                    parent.insertBefore(wrapper, nextSibling);

                    return this;
                },

                wrapInner : function(wrapperHTML) {
                    return this.each(function() {
                        var el = FakejQuery(this);
                        var contents = el.contents();

                        if (contents[LEXICON.l])
                            contents.wrapAll(wrapperHTML);
                        else
                            el.append(wrapperHTML);
                    });
                },

                wrap : function(wrapperHTML) {
                    return this.each(function() { FakejQuery(this).wrapAll(wrapperHTML); });
                },


                //DOM NODE MANIPULATION / INFORMATION:

                css : function(styles, val) {
                    var el;
                    var key;
                    var cptStyle;
                    var getCptStyle = window.getComputedStyle;
                    if(_type(styles) == TYPES.s) {
                        if(val === undefined) {
                            el = this[0];
                            cptStyle = getCptStyle ? getCptStyle(el, null) : el.currentStyle[styles];

                            //https://bugzilla.mozilla.org/show_bug.cgi?id=548397 can be null sometimes if iframe with display: none (firefox only!)
                            return getCptStyle ? cptStyle != null ? cptStyle.getPropertyValue(styles) : el[LEXICON.s][styles] : cptStyle;
                        }
                        else {
                            return this.each(function() {
                                setCSSVal(this, styles, val);
                            });
                        }
                    }
                    else {
                        return this.each(function() {
                            for(key in styles)
                                setCSSVal(this, key, styles[key]);
                        });
                    }
                },

                hasClass : function(className) {
                    var elem, i = 0;
                    var classNamePrepared = _strSpace + className + _strSpace;
                    var classList;

                    while ((elem = this[ i++ ])) {
                        classList = elem.classList;
                        if(classList && classList.contains(className))
                            return true;
                        else if (elem.nodeType === 1 && (_strSpace + stripAndCollapse(elem.className + _strEmpty) + _strSpace).indexOf(classNamePrepared) > -1)
                            return true;
                    }

                    return false;
                },

                addClass : function(className) {
                    var classes;
                    var elem;
                    var cur;
                    var curValue;
                    var clazz;
                    var finalValue;
                    var supportClassList;
                    var elmClassList;
                    var i = 0;
                    var v = 0;

                    if (className) {
                        classes = className.match( _rnothtmlwhite ) || [];

                        while ((elem = this[i++])) {
                            elmClassList = elem.classList;
                            if(supportClassList === undefined)
                                supportClassList = elmClassList !== undefined;

                            if(supportClassList) {
                                while ((clazz = classes[v++]))
                                    elmClassList.add(clazz);
                            }
                            else {
                                curValue = elem.className + _strEmpty;
                                cur = elem.nodeType === 1 && (_strSpace + stripAndCollapse(curValue) + _strSpace);

                                if (cur) {
                                    while ((clazz = classes[v++]))
                                        if (cur.indexOf(_strSpace + clazz + _strSpace) < 0)
                                            cur += clazz + _strSpace;

                                    finalValue = stripAndCollapse(cur);
                                    if (curValue !== finalValue)
                                        elem.className = finalValue;
                                }
                            }
                        }
                    }

                    return this;
                },

                removeClass : function(className) {
                    var classes;
                    var elem;
                    var cur;
                    var curValue;
                    var clazz;
                    var finalValue;
                    var supportClassList;
                    var elmClassList;
                    var i = 0;
                    var v = 0;

                    if (className) {
                        classes = className.match(_rnothtmlwhite) || [];

                        while ((elem = this[i++])) {
                            elmClassList = elem.classList;
                            if(supportClassList === undefined)
                                supportClassList = elmClassList !== undefined;

                            if(supportClassList) {
                                while ((clazz = classes[v++]))
                                    elmClassList.remove(clazz);
                            }
                            else {
                                curValue = elem.className + _strEmpty;
                                cur = elem.nodeType === 1 && (_strSpace + stripAndCollapse(curValue) + _strSpace);

                                if (cur) {
                                    while ((clazz = classes[v++]))
                                        while (cur.indexOf(_strSpace + clazz + _strSpace) > -1)
                                            cur = cur.replace(_strSpace + clazz + _strSpace, _strSpace);

                                    finalValue = stripAndCollapse(cur);
                                    if (curValue !== finalValue)
                                        elem.className = finalValue;
                                }
                            }
                        }
                    }

                    return this;
                },

                hide : function() {
                    return this.each(function() { this[LEXICON.s].display = 'none'; });
                },

                show : function() {
                    return this.each(function() { this[LEXICON.s].display = 'block'; });
                },

                attr : function(attrName, value) {
                    var i = 0;
                    var el;
                    while (el = this[i++]) {
                        if(value === undefined)
                            return el.getAttribute(attrName);
                        el.setAttribute(attrName, value);
                    }
                    return this;
                },

                removeAttr : function(attrName) {
                    return this.each(function() { this.removeAttribute(attrName); });
                },

                offset : function() {
                    var el = this[0];
                    var rect = el.getBoundingClientRect();
                    var scrollLeft = window.pageXOffset || document.documentElement[_strScrollLeft];
                    var scrollTop = window.pageYOffset || document.documentElement[_strScrollTop];
                    return {
                        top: rect.top + scrollTop,
                        left: rect.left + scrollLeft
                    };
                },

                position : function() {
                    var el = this[0];
                    return {
                        top: el.offsetTop,
                        left: el.offsetLeft
                    };
                },

                scrollLeft : function(value) {
                    var i = 0;
                    var el;
                    while (el = this[i++]) {
                        if(value === undefined)
                            return el[_strScrollLeft];
                        el[_strScrollLeft] = value;
                    }
                    return this;
                },

                scrollTop : function(value) {
                    var i = 0;
                    var el;
                    while (el = this[i++]) {
                        if(value === undefined)
                            return el[_strScrollTop];
                        el[_strScrollTop] = value;
                    }
                    return this;
                },

                val : function(value) {
                    var el = this[0];
                    if(!value)
                        return el.value;
                    el.value = value;
                    return this;
                },


                //DOM TRAVERSAL / FILTERING:

                first : function() {
                    return this.eq(0);
                },

                last : function() {
                    return this.eq(-1);
                },

                eq : function(index) {
                    return FakejQuery(this[index >= 0 ? index : this[LEXICON.l] + index]);
                },

                find : function(selector) {
                    var children = [ ];
                    var i;
                    this.each(function() {
                        var el = this;
                        var ch = el.querySelectorAll(selector);
                        for(i = 0; i < ch[LEXICON.l]; i++)
                            children.push(ch[i]);
                    });
                    return FakejQuery(children);
                },

                children : function(selector) {
                    var children = [ ];
                    var el;
                    var ch;
                    var i;

                    this.each(function() {
                        ch = this.children;
                        for(i = 0; i < ch[LEXICON.l]; i++) {
                            el = ch[i];
                            if(selector) {
                                if((el.matches && el.matches(selector)) || matches(el, selector))
                                    children.push(el);
                            }
                            else
                                children.push(el);
                        }
                    });
                    return FakejQuery(children);
                },

                parent : function(selector) {
                    var parents = [ ];
                    var parent;
                    this.each(function() {
                        parent = this.parentNode;
                        if(selector ? FakejQuery(parent).is(selector) : true)
                            parents.push(parent);
                    });
                    return FakejQuery(parents);
                },

                is : function(selector) {
                    var el;
                    var i;
                    for(i = 0; i < this[LEXICON.l]; i++) {
                        el = this[i];
                        if(selector === ":visible")
                            return !!(el[LEXICON.oW] || el[LEXICON.oH] || el.getClientRects()[LEXICON.l]);
                        if(selector === ":hidden")
                            return !!!(el[LEXICON.oW] || el[LEXICON.oH] || el.getClientRects()[LEXICON.l]);
                        if((el.matches && el.matches(selector)) || matches(el, selector))
                            return true;
                    }
                    return false;
                },

                contents : function() {
                    var contents = [ ];
                    var childs;
                    var i;

                    this.each(function() {
                        childs = this.childNodes;
                        for(i = 0; i < childs[LEXICON.l]; i++)
                            contents.push(childs[i]);
                    });

                    return FakejQuery(contents);
                },

                each : function(callback) {
                    return each(this, callback);
                },


                //ANIMATION:

                animate : function(props, duration, easing, complete) {
                    return this.each(function() { animate(this, props, duration, easing, complete); });
                },

                stop : function(clearQ, jump) {
                    return this.each(function() { stop(this, clearQ, jump); });
                }
            };

            extend(FakejQuery, {
                extend : extend,
                inArray : inArray,
                isEmptyObject : isEmptyObject,
                isPlainObject : isPlainObject,
                each : each
            });

            return FakejQuery;
        })();
        var INSTANCES = (function() {
            var _targets = [ ];
            var _instancePropertyString = '__overlayScrollbars__';

            /**
             * Register, unregister or get a certain (or all) instances.
             * Register: Pass the target and the instance.
             * Unregister: Pass the target and null.
             * Get Instance: Pass the target from which the instance shall be got.
             * Get Targets: Pass no arguments.
             * @param target The target to which the instance shall be registered / from which the instance shall be unregistered / the instance shall be got
             * @param instance The instance.
             * @returns {*|void} Returns the instance from the given target.
             */
            return function (target, instance) {
                var argLen = arguments[LEXICON.l];
                if(argLen < 1) {
                    //return all targets
                    return _targets;
                }
                else {
                    if(instance) {
                        //register instance
                        target[_instancePropertyString] = instance;
                        _targets.push(target);
                    }
                    else {
                        var index = COMPATIBILITY.inA(target, _targets);
                        if (index > -1) {
                            if(argLen > 1) {
                                //unregister instance
                                delete target[_instancePropertyString];
                                _targets.splice(index, 1);
                            }
                            else {
                                //get instance from target
                                return _targets[index][_instancePropertyString];
                            }
                        }
                    }
                }
            }
        })();
        var PLUGIN = (function() {
            var _pluginsGlobals;
            var _pluginsAutoUpdateLoop;
            var _pluginsExtensions = [ ];
            var _pluginsOptions = (function() {
                var type = COMPATIBILITY.type;
                var possibleTemplateTypes = [
                    TYPES.b, //boolean
                    TYPES.n, //number
                    TYPES.s, //string
                    TYPES.a, //array
                    TYPES.o, //object
                    TYPES.f, //function
                    TYPES.z  //null
                ];
                var restrictedStringsSplit = ' ';
                var restrictedStringsPossibilitiesSplit = ':';
                var classNameAllowedValues = [TYPES.z, TYPES.s];
                var numberAllowedValues = TYPES.n;
                var booleanNullAllowedValues = [TYPES.z, TYPES.b];
                var booleanTrueTemplate = [true, TYPES.b];
                var booleanFalseTemplate = [false, TYPES.b];
                var callbackTemplate = [null,  [TYPES.z, TYPES.f]];
                var inheritedAttrsTemplate = [['style', 'class'], [TYPES.s, TYPES.a, TYPES.z]];
                var resizeAllowedValues = 'n:none b:both h:horizontal v:vertical';
                var overflowBehaviorAllowedValues = 'v-h:visible-hidden v-s:visible-scroll s:scroll h:hidden';
                var scrollbarsVisibilityAllowedValues = 'v:visible h:hidden a:auto';
                var scrollbarsAutoHideAllowedValues = 'n:never s:scroll l:leave m:move';
                var optionsDefaultsAndTemplate = {
                    className: ['os-theme-dark', classNameAllowedValues],                //null || string
                    resize: ['none', resizeAllowedValues],                               //none || both  || horizontal || vertical || n || b || h || v
                    sizeAutoCapable: booleanTrueTemplate,                                //true || false
                    clipAlways: booleanTrueTemplate,                                     //true || false
                    normalizeRTL: booleanTrueTemplate,                                   //true || false
                    paddingAbsolute: booleanFalseTemplate,                               //true || false
                    autoUpdate: [null, booleanNullAllowedValues],                        //true || false || null
                    autoUpdateInterval: [33, numberAllowedValues],                       //number
                    nativeScrollbarsOverlaid: {
                        showNativeScrollbars: booleanFalseTemplate,                      //true || false
                        initialize: booleanTrueTemplate                                  //true || false
                    },
                    overflowBehavior: {
                        x: ['scroll', overflowBehaviorAllowedValues],                    //visible-hidden  || visible-scroll || hidden || scroll || v-h || v-s || h || s
                        y: ['scroll', overflowBehaviorAllowedValues]                     //visible-hidden  || visible-scroll || hidden || scroll || v-h || v-s || h || s
                    },
                    scrollbars: {
                        visibility: ['auto', scrollbarsVisibilityAllowedValues],         //visible || hidden || auto || v || h || a
                        autoHide: ['never', scrollbarsAutoHideAllowedValues],            //never || scroll || leave || move || n || s || l || m
                        autoHideDelay: [800, numberAllowedValues],                       //number
                        dragScrolling: booleanTrueTemplate,                              //true || false
                        clickScrolling: booleanFalseTemplate,                            //true || false
                        touchSupport: booleanTrueTemplate,                               //true || false
                        snapHandle: booleanFalseTemplate                                 //true || false
                    },
                    textarea: {
                        dynWidth: booleanFalseTemplate,                                  //true || false
                        dynHeight: booleanFalseTemplate,                                 //true || false
                        inheritedAttrs : inheritedAttrsTemplate                          //string || array || null
                    },
                    callbacks: {
                        onInitialized: callbackTemplate,                                 //null || function
                        onInitializationWithdrawn: callbackTemplate,                     //null || function
                        onDestroyed: callbackTemplate,                                   //null || function
                        onScrollStart: callbackTemplate,                                 //null || function
                        onScroll: callbackTemplate,                                      //null || function
                        onScrollStop: callbackTemplate,                                  //null || function
                        onOverflowChanged: callbackTemplate,                             //null || function
                        onOverflowAmountChanged: callbackTemplate,                       //null || function
                        onDirectionChanged: callbackTemplate,                            //null || function
                        onContentSizeChanged: callbackTemplate,                          //null || function
                        onHostSizeChanged: callbackTemplate,                             //null || function
                        onUpdated: callbackTemplate                                      //null || function
                    }
                };
                var convert = function(template) {
                    var recursive = function(obj) {
                        var key;
                        var val;
                        var valType;
                        for(key in obj) {
                            if(!obj[LEXICON.hOP](key))
                                continue;
                            val = obj[key];
                            valType = type(val);
                            if(valType == TYPES.a)
                                obj[key] = val[template ? 1 : 0];
                            else if(valType == TYPES.o)
                                obj[key] = recursive(val);
                        }
                        return obj;
                    };
                    return recursive(FRAMEWORK.extend(true, { }, optionsDefaultsAndTemplate));
                };

                return {
                    _defaults : convert(),

                    _template : convert(true),

                    /**
                     * Validates the passed object by the passed template.
                     * @param obj The object which shall be validated.
                     * @param template The template which defines the allowed values and types.
                     * @param writeErrors True if errors shall be logged to the console.
                     * @param diffObj If a object is passed then only valid differences to this object will be returned.
                     * @returns {{}} A object which contains two objects called "default" and "prepared" which contains only the valid properties of the passed original object and discards not different values compared to the passed diffObj.
                     */
                    _validate : function (obj, template, writeErrors, diffObj) {
                        var validatedOptions = { };
                        var validatedOptionsPrepared = { };
                        var objectCopy = FRAMEWORK.extend(true, { }, obj);
                        var inArray = FRAMEWORK.inArray;
                        var isEmptyObj = FRAMEWORK.isEmptyObject;
                        var checkObjectProps = function(data, template, diffData, validatedOptions, validatedOptionsPrepared, prevPropName) {
                            for (var prop in template) {
                                if (template[LEXICON.hOP](prop) && data[LEXICON.hOP](prop)) {
                                    var isValid = false;
                                    var isDiff = false;
                                    var templateValue = template[prop];
                                    var templateValueType = type(templateValue);
                                    var templateIsComplex = templateValueType == TYPES.o;
                                    var templateTypes = type(templateValue) != TYPES.a ? [ templateValue ] : templateValue;
                                    var dataDiffValue = diffData[prop];
                                    var dataValue = data[prop];
                                    var dataValueType = type(dataValue);
                                    var propPrefix = prevPropName ? prevPropName + "." : "";
                                    var error = "The option \"" + propPrefix + prop + "\" wasn't set, because";
                                    var errorPossibleTypes = [ ];
                                    var errorRestrictedStrings = [ ];
                                    var restrictedStringValuesSplit;
                                    var restrictedStringValuesPossibilitiesSplit;
                                    var isRestrictedValue;
                                    var mainPossibility;
                                    var currType;
                                    var i;
                                    var v;
                                    var j;

                                    dataDiffValue = dataDiffValue === undefined ? { } : dataDiffValue;
                                    
                                    //if the template has a object as value, it means that the options are complex (verschachtelt)
                                    if(templateIsComplex && dataValueType == TYPES.o) {
                                        validatedOptions[prop] = validatedOptionsPrepared[prop] = { };
                                        checkObjectProps(dataValue, templateValue, dataDiffValue, validatedOptions[prop], validatedOptionsPrepared[prop], propPrefix + prop);
                                        if(isEmptyObj(dataValue))
                                            delete data[prop];
                                    }
                                    else if(!templateIsComplex) {
                                        for(i = 0; i < templateTypes[LEXICON.l]; i++) {
                                            currType = templateTypes[i];
                                            templateValueType = type(currType);
                                            //if currtype is string and starts with restrictedStringPrefix and end with restrictedStringSuffix
                                            isRestrictedValue = templateValueType == TYPES.s && inArray(currType, possibleTemplateTypes) === -1;
                                            if(isRestrictedValue) {
                                                errorPossibleTypes.push(TYPES.s);

                                                //split it into a array which contains all possible values for example: ["y:yes", "n:no", "m:maybe"]
                                                restrictedStringValuesSplit = currType.split(restrictedStringsSplit);
                                                errorRestrictedStrings = errorRestrictedStrings.concat(restrictedStringValuesSplit);
                                                for(v = 0; v < restrictedStringValuesSplit[LEXICON.l]; v++) {
                                                    //split the possible values into their possibiliteis for example: ["y", "yes"] -> the first is always the mainPossibility
                                                    restrictedStringValuesPossibilitiesSplit = restrictedStringValuesSplit[v].split(restrictedStringsPossibilitiesSplit);
                                                    mainPossibility = restrictedStringValuesPossibilitiesSplit[0];
                                                    for(j = 0; j < restrictedStringValuesPossibilitiesSplit[LEXICON.l]; j++) {
                                                        //if any possibility matches with the dataValue, its valid
                                                        if(dataValue === restrictedStringValuesPossibilitiesSplit[j]) {
                                                            isValid = true;
                                                            break;
                                                        }
                                                    }
                                                    if(isValid)
                                                        break;
                                                }
                                            }
                                            else {
                                                errorPossibleTypes.push(currType);

                                                if(dataValueType === currType) {
                                                    isValid = true;
                                                    break;
                                                }
                                            }
                                        }

                                        if(isValid) {
                                            isDiff = dataValue !== dataDiffValue;
                                            
                                            if(isDiff)
                                                validatedOptions[prop] = dataValue;
                                            
                                            if(isRestrictedValue ? inArray(dataDiffValue, restrictedStringValuesPossibilitiesSplit) < 0 : isDiff)
                                                validatedOptionsPrepared[prop] = isRestrictedValue ? mainPossibility : dataValue;
                                        }
                                        else if(writeErrors) {
                                            console.warn(error + " it doesn't accept the type [ " + dataValueType.toUpperCase() + " ] with the value of \"" + dataValue + "\".\r\n" +
                                                "Accepted types are: [ " + errorPossibleTypes.join(", ").toUpperCase() + " ]." +
                                                (errorRestrictedStrings[length] > 0 ? "\r\nValid strings are: [ " + errorRestrictedStrings.join(", ").split(restrictedStringsPossibilitiesSplit).join(", ") + " ]." : ""));
                                        }
                                        delete data[prop];
                                    }
                                }
                            }
                        };
                        checkObjectProps(objectCopy, template, diffObj || { }, validatedOptions, validatedOptionsPrepared);

                        //add values which aren't specified in the template to the finished validated object to prevent them from being discarded
                        /*
                        if(keepForeignProps) {
                            FRAMEWORK.extend(true, validatedOptions, objectCopy);
                            FRAMEWORK.extend(true, validatedOptionsPrepared, objectCopy);
                        }
                        */
                        
                        if(!isEmptyObj(objectCopy) && writeErrors)
                            console.warn("The following options are discarded due to invalidity:\r\n" + window.JSON.stringify(objectCopy, null, 2));

                        return {
                            _default : validatedOptions,
                            _prepared : validatedOptionsPrepared
                        };
                    }
                }
            }());

            /**
             * Initializes the object which contains global information about the plugin and each instance of it.
             */
            function initOverlayScrollbarsStatics() {
                if(!_pluginsGlobals)
                    _pluginsGlobals = new OverlayScrollbarsGlobals(_pluginsOptions._defaults);
                if(!_pluginsAutoUpdateLoop)
                    _pluginsAutoUpdateLoop = new OverlayScrollbarsAutoUpdateLoop(_pluginsGlobals);
            }

            /**
             * The global object for the OverlayScrollbars objects. It contains resources which every OverlayScrollbars object needs. This object is initialized only once: if the first OverlayScrollbars object gets initialized.
             * @param defaultOptions
             * @constructor
             */
            function OverlayScrollbarsGlobals(defaultOptions) {
                var _base = this;
                var strOverflow = 'overflow';
                var strHidden = 'hidden';
                var strScroll = 'scroll';
                var bodyElement = FRAMEWORK('body');
                var scrollbarDummyElement = FRAMEWORK('<div id="os-dummy-scrollbar-size"><div></div></div>');
                var scrollbarDummyElement0 = scrollbarDummyElement[0];
                var dummyContainerChild = FRAMEWORK(scrollbarDummyElement.children('div').eq(0));

                bodyElement.append(scrollbarDummyElement);
                scrollbarDummyElement.hide().show(); //fix IE8 bug (incorrect measuring)

                var nativeScrollbarSize = calcNativeScrollbarSize(scrollbarDummyElement0);
                var nativeScrollbarIsOverlaid = {
                    x: nativeScrollbarSize.x === 0,
                    y: nativeScrollbarSize.y === 0
                };

                FRAMEWORK.extend(_base, {
                    defaultOptions : defaultOptions,
                    autoUpdateLoop : false,
                    autoUpdateRecommended : !COMPATIBILITY.mO(),
                    nativeScrollbarSize : nativeScrollbarSize,
                    nativeScrollbarIsOverlaid : nativeScrollbarIsOverlaid,
                    nativeScrollbarStyling : (function() {
                        var result = false;
                        scrollbarDummyElement.addClass('os-viewport-native-scrollbars-invisible');
                        try {
                            result = scrollbarDummyElement.css('scrollbar-width') === 'none' || window.getComputedStyle(scrollbarDummyElement0, '::-webkit-scrollbar').getPropertyValue('display') === 'none';
                        } catch (ex) { }
                        
                        //fix opera bug: scrollbar styles will only appear if overflow value is scroll or auto during the activation of the style.
                        //and set overflow to scroll
                        //scrollbarDummyElement.css(strOverflow, strHidden).hide().css(strOverflow, strScroll).show();
                        //return (scrollbarDummyElement0[LEXICON.oH] - scrollbarDummyElement0[LEXICON.cH]) === 0 && (scrollbarDummyElement0[LEXICON.oW] - scrollbarDummyElement0[LEXICON.cW]) === 0;
                        
                        return result;
                    })(),
                    overlayScrollbarDummySize : { x: 30, y: 30 },
                    msie : (function() {
                        var ua = window.navigator.userAgent;
                        var strIndexOf = 'indexOf';
                        var strSubString = 'substring';
                        var msie = ua[strIndexOf]('MSIE ');
                        var trident = ua[strIndexOf]('Trident/');
                        var edge = ua[strIndexOf]('Edge/');
                        var rv = ua[strIndexOf]('rv:');
                        var result;
                        var parseIntFunc = parseInt;

                        // IE 10 or older => return version number
                        if (msie > 0)
                            result = parseIntFunc(ua[strSubString](msie + 5, ua[strIndexOf]('.', msie)), 10);

                        // IE 11 => return version number
                        else if (trident > 0)
                            result = parseIntFunc(ua[strSubString](rv + 3, ua[strIndexOf]('.', rv)), 10);

                        // Edge (IE 12+) => return version number
                        else if (edge > 0)
                            result = parseIntFunc(ua[strSubString](edge + 5, ua[strIndexOf]('.', edge)), 10);

                        // other browser
                        return result;
                    })(),
                    cssCalc : (function() {
                        var dummyStyle = document.createElement('div')[LEXICON.s];
                        var strCalc = 'calc';
                        var i = -1;
                        var prop;

                        for(; i < VENDORS._cssPrefixes[LEXICON.l]; i++) {
                            prop = i < 0 ? strCalc : VENDORS._cssPrefixes[i] + strCalc;
                            dummyStyle.cssText = 'width:' + prop + '(1px);';
                            if (dummyStyle[LEXICON.l])
                                return prop;
                        }
                        return null;
                    })(),
                    restrictedMeasuring : (function() {
                        //https://bugzilla.mozilla.org/show_bug.cgi?id=1439305
                        scrollbarDummyElement.css(strOverflow, strHidden);
                        var scrollSize = {
                            w : scrollbarDummyElement0[LEXICON.sW],
                            h : scrollbarDummyElement0[LEXICON.sH]
                        };
                        scrollbarDummyElement.css(strOverflow, 'visible');
                        var scrollSize2 = {
                            w : scrollbarDummyElement0[LEXICON.sW],
                            h : scrollbarDummyElement0[LEXICON.sH]
                        };
                        return (scrollSize.w - scrollSize2.w) !== 0 || (scrollSize.h - scrollSize2.h) !== 0;
                    })(),
                    rtlScrollBehavior : (function() {
                        scrollbarDummyElement.css({ 'overflow-y' : strHidden, 'overflow-x' : strScroll, 'direction' : 'rtl' }).scrollLeft(0);
                        var dummyContainerOffset = scrollbarDummyElement.offset();
                        var dummyContainerChildOffset = dummyContainerChild.offset();
                        scrollbarDummyElement.scrollLeft(999);
                        var dummyContainerScrollOffsetAfterScroll = dummyContainerChild.offset();
                        return {
                            //origin direction = determines if the zero scroll position is on the left or right side
                            //'i' means 'invert' (i === true means that the axis must be inverted to be correct)
                            //true = on the left side
                            //false = on the right side
                            i : dummyContainerOffset.left === dummyContainerChildOffset.left,
                            //negative = determines if the maximum scroll is positive or negative
                            //'n' means 'negate' (n === true means that the axis must be negated to be correct)
                            //true = negative
                            //false = positive
                            n : dummyContainerChildOffset.left - dummyContainerScrollOffsetAfterScroll.left === 0
                        };
                    })(),
                    supportTransform : VENDORS._cssProperty('transform') !== null,
                    supportTransition : VENDORS._cssProperty('transition') !== null,
                    supportPassiveEvents : (function() {
                        var supportsPassive = false;
                        try {
                            window.addEventListener('test', null, Object.defineProperty({ }, 'passive', {
                                get: function() {
                                    supportsPassive = true;
                                }
                            }));
                        } catch (e) { }
                        return supportsPassive;
                    })(),
                    supportResizeObserver : !!COMPATIBILITY.rO(),
                    supportMutationObserver : !!COMPATIBILITY.mO()
                });

                scrollbarDummyElement.removeAttr(LEXICON.s).remove();

                //Catch zoom event:
                (function () {
                    if(nativeScrollbarIsOverlaid.x && nativeScrollbarIsOverlaid.y)
                        return;

                    var abs = MATH.abs;
                    var windowWidth = COMPATIBILITY.wW();
                    var windowHeight = COMPATIBILITY.wH();
                    var windowDpr = getWindowDPR();
                    var onResize = function() {
                        if(INSTANCES().length > 0) {
                            var newW = COMPATIBILITY.wW();
                            var newH = COMPATIBILITY.wH();
                            var deltaW = newW - windowWidth;
                            var deltaH = newH - windowHeight;

                            if (deltaW === 0 && deltaH === 0)
                                return;

                            var deltaWRatio = MATH.round(newW / (windowWidth / 100.0));
                            var deltaHRatio = MATH.round(newH / (windowHeight / 100.0));
                            var absDeltaW = abs(deltaW);
                            var absDeltaH = abs(deltaH);
                            var absDeltaWRatio = abs(deltaWRatio);
                            var absDeltaHRatio = abs(deltaHRatio);
                            var newDPR = getWindowDPR();

                            var deltaIsBigger = absDeltaW > 2 && absDeltaH > 2;
                            var difference = !differenceIsBiggerThanOne(absDeltaWRatio, absDeltaHRatio);
                            var dprChanged = newDPR !== windowDpr && windowDpr > 0;
                            var isZoom = deltaIsBigger && difference && dprChanged;
                            var oldScrollbarSize = _base.nativeScrollbarSize;
                            var newScrollbarSize;

                            if (isZoom) {
                                bodyElement.append(scrollbarDummyElement);
                                newScrollbarSize = _base.nativeScrollbarSize = calcNativeScrollbarSize(scrollbarDummyElement[0]);
                                scrollbarDummyElement.remove();
                                if(oldScrollbarSize.x !== newScrollbarSize.x || oldScrollbarSize.y !== newScrollbarSize.y) {
                                    FRAMEWORK.each(INSTANCES(), function () {
                                        if(INSTANCES(this))
                                            INSTANCES(this).update('zoom');
                                    });
                                }
                            }

                            windowWidth = newW;
                            windowHeight = newH;
                            windowDpr = newDPR;
                        }
                    };

                    function differenceIsBiggerThanOne(valOne, valTwo) {
                        var absValOne = abs(valOne);
                        var absValTwo = abs(valTwo);
                        return !(absValOne === absValTwo || absValOne + 1 === absValTwo || absValOne - 1 === absValTwo);
                    }

                    function getWindowDPR() {
                        var dDPI = window.screen.deviceXDPI || 0;
                        var sDPI = window.screen.logicalXDPI || 1;
                        return window.devicePixelRatio || (dDPI / sDPI);
                    }

                    FRAMEWORK(window).on('resize', onResize);
                })();

                function calcNativeScrollbarSize(measureElement) {
                    return {
                        x: measureElement[LEXICON.oH] - measureElement[LEXICON.cH],
                        y: measureElement[LEXICON.oW] - measureElement[LEXICON.cW]
                    };
                }
            }

            /**
             * The object which manages the auto update loop for all OverlayScrollbars objects. This object is initialized only once: if the first OverlayScrollbars object gets initialized.
             * @constructor
             */
            function OverlayScrollbarsAutoUpdateLoop(globals) {
                var _base = this;
                var _inArray = FRAMEWORK.inArray;
                var _getNow = COMPATIBILITY.now;
                var _strAutoUpdate = 'autoUpdate';
                var _strAutoUpdateInterval = _strAutoUpdate + 'Interval';
                var _strLength = LEXICON.l;
                var _loopingInstances = [ ];
                var _loopingInstancesIntervalCache = [ ];
                var _loopIsActive = false;
                var _loopIntervalDefault = 33;
                var _loopInterval = _loopIntervalDefault;
                var _loopTimeOld = _getNow();
                var _loopID;
                

                /**
                 * The auto update loop which will run every 50 milliseconds or less if the update interval of a instance is lower than 50 milliseconds.
                 */
                var loop = function() {
                    if(_loopingInstances[_strLength] > 0 && _loopIsActive) {
                        _loopID = COMPATIBILITY.rAF()(function () {
                            loop();
                        });
                        var timeNew = _getNow();
                        var timeDelta = timeNew - _loopTimeOld;
                        var lowestInterval;
                        var instance;
                        var instanceOptions;
                        var instanceAutoUpdateAllowed;
                        var instanceAutoUpdateInterval;
                        var now;

                        if (timeDelta > _loopInterval) {
                            _loopTimeOld = timeNew - (timeDelta % _loopInterval);
                            lowestInterval = _loopIntervalDefault;
                            for(var i = 0; i < _loopingInstances[_strLength]; i++) {
                                instance = _loopingInstances[i];
                                if (instance !== undefined) {
                                    instanceOptions = instance.options();
                                    instanceAutoUpdateAllowed = instanceOptions[_strAutoUpdate];
                                    instanceAutoUpdateInterval = MATH.max(1, instanceOptions[_strAutoUpdateInterval]);
                                    now = _getNow();

                                    if ((instanceAutoUpdateAllowed === true || instanceAutoUpdateAllowed === null) && (now - _loopingInstancesIntervalCache[i]) > instanceAutoUpdateInterval) {
                                        instance.update('auto');
                                        _loopingInstancesIntervalCache[i] = new Date(now += instanceAutoUpdateInterval);
                                    }

                                    lowestInterval = MATH.max(1, MATH.min(lowestInterval, instanceAutoUpdateInterval));
                                }
                            }
                            _loopInterval = lowestInterval;
                        }
                    } else {
                        _loopInterval = _loopIntervalDefault;
                    }
                };

                /**
                 * Add OverlayScrollbars instance to the auto update loop. Only successful if the instance isn't already added.
                 * @param instance The instance which shall be updated in a loop automatically.
                 */
                _base.add = function(instance) {
                    if(_inArray(instance, _loopingInstances) === -1) {
                        _loopingInstances.push(instance);
                        _loopingInstancesIntervalCache.push(_getNow());
                        if (_loopingInstances[_strLength] > 0 && !_loopIsActive) {
                            _loopIsActive = true;
                            globals.autoUpdateLoop = _loopIsActive;
                            loop();
                        }
                    }
                };

                /**
                 * Remove OverlayScrollbars instance from the auto update loop. Only successful if the instance was added before.
                 * @param instance The instance which shall be updated in a loop automatically.
                 */
                _base.remove = function(instance) {
                    var index = _inArray(instance, _loopingInstances);
                    if(index > -1) {
                        //remove from loopingInstances list
                        _loopingInstancesIntervalCache.splice(index, 1);
                        _loopingInstances.splice(index, 1);

                        //correct update loop behavior
                        if (_loopingInstances[_strLength] === 0 && _loopIsActive) {
                            _loopIsActive = false;
                            globals.autoUpdateLoop = _loopIsActive;
                            if(_loopID !== undefined) {
                                COMPATIBILITY.cAF()(_loopID);
                                _loopID = -1;
                            }
                        }
                    }
                };
            }

            /**
             * A object which manages the scrollbars visibility of the target element.
             * @param pluginTargetElement The element from which the scrollbars shall be hidden.
             * @param options The custom options.
             * @param extensions The custom extensions.
             * @param globals
             * @param autoUpdateLoop
             * @returns {*}
             * @constructor
             */
            function OverlayScrollbarsInstance(pluginTargetElement, options, extensions, globals, autoUpdateLoop) {
                //shortcuts
                var type = COMPATIBILITY.type;
                var inArray = FRAMEWORK.inArray;
                var each = FRAMEWORK.each;
                
                //make correct instanceof
                var _base = new window[PLUGINNAME]();
                var _frameworkProto = FRAMEWORK[LEXICON.p];
                
                //if passed element is no HTML element: skip and return
                if(!isHTMLElement(pluginTargetElement))
                    return;
                
                //if passed element is already initialized: set passed options if there are any and return its instance
                if(INSTANCES(pluginTargetElement)) {
                    var inst = INSTANCES(pluginTargetElement);
                    inst.options(options);
                    return inst;
                }

                //globals:
                var _nativeScrollbarIsOverlaid;
                var _overlayScrollbarDummySize;
                var _rtlScrollBehavior;
                var _autoUpdateRecommended;
                var _msieVersion;
                var _nativeScrollbarStyling;
                var _cssCalc;
                var _nativeScrollbarSize;
                var _supportTransition;
                var _supportTransform;
                var _supportPassiveEvents;
                var _supportResizeObserver;
                var _supportMutationObserver;
                var _restrictedMeasuring;

                //general readonly:
                var _initialized;
                var _destroyed;
                var _isTextarea;
                var _isBody;
                var _documentMixed;
                var _isTextareaHostGenerated;

                //general:
                var _isBorderBox;
                var _sizeAutoObserverAdded;
                var _paddingX;
                var _paddingY;
                var _borderX;
                var _borderY;
                var _marginX;
                var _marginY;
                var _isRTL;
                var _sleeping;
                var _contentBorderSize = { };
                var _scrollHorizontalInfo = { };
                var _scrollVerticalInfo = { };
                var _viewportSize = { };
                var _nativeScrollbarMinSize = { };

                //naming:
                var _strMinusHidden = '-hidden';
                var _strMarginMinus = 'margin-';
                var _strPaddingMinus = 'padding-';
                var _strBorderMinus = 'border-';
                var _strTop = 'top';
                var _strRight = 'right';
                var _strBottom = 'bottom';
                var _strLeft = 'left';
                var _strMinMinus = 'min-';
                var _strMaxMinus = 'max-';
                var _strWidth = 'width';
                var _strHeight = 'height';
                var _strFloat = 'float';
                var _strEmpty = '';
                var _strAuto = 'auto';
                var _strSync = 'sync';
                var _strScroll = 'scroll';
                var _strHundredPercent = '100%';
                var _strX = 'x';
                var _strY = 'y';
                var _strDot = '.';
                var _strSpace = ' ';
                var _strScrollbar = 'scrollbar';
                var _strMinusHorizontal = '-horizontal';
                var _strMinusVertical = '-vertical';
                var _strScrollLeft = _strScroll + 'Left';
                var _strScrollTop = _strScroll + 'Top';
                var _strMouseTouchDownEvent = 'mousedown touchstart';
                var _strMouseTouchUpEvent = 'mouseup touchend touchcancel';
                var _strMouseTouchMoveEvent = 'mousemove touchmove';
                var _strMouseTouchEnter = 'mouseenter';
                var _strMouseTouchLeave = 'mouseleave';
                var _strKeyDownEvent = 'keydown';
                var _strKeyUpEvent = 'keyup';
                var _strSelectStartEvent = 'selectstart';
                var _strTransitionEndEvent = 'transitionend webkitTransitionEnd oTransitionEnd';
                var _strResizeObserverProperty = '__overlayScrollbarsRO__';

                //class names:
                var _cassNamesPrefix = 'os-';
                var _classNameHTMLElement = _cassNamesPrefix + 'html';
                var _classNameHostElement = _cassNamesPrefix + 'host';
                var _classNameHostTextareaElement = _classNameHostElement + '-textarea';
                var _classNameHostScrollbarHorizontalHidden = _classNameHostElement + '-' + _strScrollbar + _strMinusHorizontal + _strMinusHidden;
                var _classNameHostScrollbarVerticalHidden = _classNameHostElement + '-' + _strScrollbar + _strMinusVertical + _strMinusHidden;
                var _classNameHostTransition = _classNameHostElement + '-transition';
                var _classNameHostRTL = _classNameHostElement + '-rtl';
                var _classNameHostResizeDisabled = _classNameHostElement + '-resize-disabled';
                var _classNameHostScrolling = _classNameHostElement + '-scrolling';
                var _classNameHostOverflow = _classNameHostElement + '-overflow';
                var _classNameHostOverflowX = _classNameHostOverflow + '-x';
                var _classNameHostOverflowY = _classNameHostOverflow + '-y';
                var _classNameTextareaElement = _cassNamesPrefix + 'textarea';
                var _classNameTextareaCoverElement = _classNameTextareaElement + '-cover';
                var _classNamePaddingElement = _cassNamesPrefix + 'padding';
                var _classNameViewportElement = _cassNamesPrefix + 'viewport';
                var _classNameViewportNativeScrollbarsInvisible = _classNameViewportElement + '-native-scrollbars-invisible';
                var _classNameViewportNativeScrollbarsOverlaid = _classNameViewportElement + '-native-scrollbars-overlaid';
                var _classNameContentElement = _cassNamesPrefix + 'content';
                var _classNameContentArrangeElement = _cassNamesPrefix + 'content-arrange';
                var _classNameContentGlueElement = _cassNamesPrefix + 'content-glue';
                var _classNameSizeAutoObserverElement = _cassNamesPrefix + 'size-auto-observer';
                var _classNameResizeObserverElement = _cassNamesPrefix + 'resize-observer';
                var _classNameResizeObserverItemElement = _cassNamesPrefix + 'resize-observer-item';
                var _classNameResizeObserverItemFinalElement = _classNameResizeObserverItemElement + '-final';
                var _classNameTextInherit = _cassNamesPrefix + 'text-inherit';
                var _classNameScrollbar = _cassNamesPrefix + _strScrollbar;
                var _classNameScrollbarTrack = _classNameScrollbar + '-track';
                var _classNameScrollbarTrackOff = _classNameScrollbarTrack + '-off';
                var _classNameScrollbarHandle = _classNameScrollbar + '-handle';
                var _classNameScrollbarHandleOff = _classNameScrollbarHandle + '-off';
                var _classNameScrollbarUnusable = _classNameScrollbar + '-unusable';
                var _classNameScrollbarAutoHidden = _classNameScrollbar + '-' + _strAuto + _strMinusHidden;
                var _classNameScrollbarCorner = _classNameScrollbar + '-corner';
                var _classNameScrollbarCornerResize = _classNameScrollbarCorner + '-resize';
                var _classNameScrollbarCornerResizeB = _classNameScrollbarCornerResize + '-both';
                var _classNameScrollbarCornerResizeH = _classNameScrollbarCornerResize + _strMinusHorizontal;
                var _classNameScrollbarCornerResizeV = _classNameScrollbarCornerResize + _strMinusVertical;
                var _classNameScrollbarHorizontal = _classNameScrollbar + _strMinusHorizontal;
                var _classNameScrollbarVertical = _classNameScrollbar + _strMinusVertical;
                var _classNameDragging = _cassNamesPrefix + 'dragging';
                var _classNameThemeNone = _cassNamesPrefix + 'theme-none';

                //callbacks:
                var _callbacksInitQeueue = [ ];

                //options:
                var _defaultOptions;
                var _currentOptions;
                var _currentPreparedOptions;

                //extensions:
                var _extensions = { };
                var _extensionsPrivateMethods = 'added removed on contract';

                //update
                var _lastUpdateTime;
                var _swallowedUpdateHints = { };
                var _swallowedUpdateTimeout;
                var _swallowUpdateLag = 42;
                var _imgs = [ ];

                //DOM elements:
                var _windowElement;
                var _documentElement;
                var _htmlElement;
                var _bodyElement;
                var _targetElement;                     //the target element of this OverlayScrollbars object
                var _hostElement;                       //the host element of this OverlayScrollbars object -> may be the same as targetElement
                var _sizeAutoObserverElement;           //observes size auto changes
                var _sizeObserverElement;               //observes size and padding changes
                var _paddingElement;                    //manages the padding
                var _viewportElement;                   //is the viewport of our scrollbar model
                var _contentElement;                    //the element which holds the content
                var _contentArrangeElement;             //is needed for correct sizing of the content element (only if native scrollbars are overlays)
                var _contentGlueElement;                //has always the size of the content element
                var _textareaCoverElement;              //only applied if target is a textarea element. Used for correct size calculation and for prevention of uncontrolled scrolling
                var _scrollbarCornerElement;
                var _scrollbarHorizontalElement;
                var _scrollbarHorizontalTrackElement;
                var _scrollbarHorizontalHandleElement;
                var _scrollbarVerticalElement;
                var _scrollbarVerticalTrackElement;
                var _scrollbarVerticalHandleElement;
                var _windowElementNative;
                var _documentElementNative;
                var _targetElementNative;
                var _hostElementNative;
                var _sizeAutoObserverElementNative;
                var _sizeObserverElementNative;
                var _paddingElementNative;
                var _viewportElementNative;
                var _contentElementNative;

                //Cache:
                var _hostSizeCache;
                var _contentScrollSizeCache;
                var _arrangeContentSizeCache;
                var _hasOverflowCache;
                var _hideOverflowCache;
                var _widthAutoCache;
                var _heightAutoCache;
                var _cssMaxValueCache;
                var _cssBoxSizingCache;
                var _cssPaddingCache;
                var _cssBorderCache;
                var _cssMarginCache;
                var _cssDirectionCache;
                var _cssDirectionDetectedCache;
                var _paddingAbsoluteCache;
                var _clipAlwaysCache;
                var _contentGlueSizeCache;
                var _overflowBehaviorCache;
                var _overflowAmountCache;
                var _ignoreOverlayScrollbarHidingCache;
                var _autoUpdateCache;
                var _sizeAutoCapableCache;
                var _textareaAutoWrappingCache;
                var _textareaInfoCache;
                var _contentElementScrollSizeChangeDetectedCache;
                var _hostElementSizeChangeDetectedCache;
                var _scrollbarsVisibilityCache;
                var _scrollbarsAutoHideCache;
                var _scrollbarsClickScrollingCache;
                var _scrollbarsDragScrollingCache;
                var _resizeCache;
                var _normalizeRTLCache;
                var _classNameCache;
                var _oldClassName;
                var _textareaDynHeightCache;
                var _textareaDynWidthCache;
                var _bodyMinSizeCache;
                var _viewportScrollSizeCache;
                var _displayIsHiddenCache;
                var _updateAutoCache = { };

                //MutationObserver:
                var _mutationObserverHost;
                var _mutationObserverContent;
                var _mutationObserverHostCallback;
                var _mutationObserverContentCallback;
                var _mutationObserversConnected;
                var _mutationObserverAttrsTextarea = ['wrap', 'cols', 'rows'];
                var _mutationObserverAttrsHost = [LEXICON.i, LEXICON.c, LEXICON.s, 'open'];

                //textarea:
                var _textareaEvents;
                var _textareaHasFocus;

                //scrollbars:
                var _scrollbarsAutoHideTimeoutId;
                var _scrollbarsAutoHideMoveTimeoutId;
                var _scrollbarsAutoHideDelay;
                var _scrollbarsAutoHideNever;
                var _scrollbarsAutoHideScroll;
                var _scrollbarsAutoHideMove;
                var _scrollbarsAutoHideLeave;
                var _scrollbarsHandleHovered;
                var _scrollbarsHandlesDefineScrollPos;

                //resize
                var _resizeReconnectMutationObserver;
                var _resizeNone;
                var _resizeBoth;
                var _resizeHorizontal;
                var _resizeVertical;
                var _resizeOnMouseTouchDown;
                
                
                //==== Passive Event Listener ====//

                /**
                 * Adds or removes a passive event listener from the given element.
                 * @param element The element to which the event listener shall be applied or removed.
                 * @param eventNames The name(s) of the events.
                 * @param listener The method which shall be called.
                 * @param remove True if the handler shall be removed, false or undefined if the handler shall be added.
                 */
                function setupPassiveEventListener(element, eventNames, listener, remove, notPassive) {
                    var method = remove ? 'removeEventListener' : 'addEventListener';
                    var events = eventNames.split(_strSpace);
                    var i = 0;

                    for (; i < events[LEXICON.l]; i++) {
                        element[0][method](events[i], listener, { passive: !notPassive });
                    }
                }


                //==== Resize Observer ====//

                /**
                 * Adds or removes a resize observer from the given element.
                 * @param targetElement The element to which the resize observer shall be added or removed.
                 * @param onElementResizedCallback The callback which is fired every time the resize observer registers a size change or false / undefined if the resizeObserver shall be removed.
                 */
                function setupResizeObserver(targetElement, onElementResizedCallback) {
                    if(targetElement) {
                        //add resize observer:
                        if(onElementResizedCallback) {
                            var constMaximum = 3333333;
                            var resizeObserver = COMPATIBILITY.rO();
                            var strAnimationStartEvent = 'animationstart mozAnimationStart webkitAnimationStart MSAnimationStart';
                            var strChildNodes = 'childNodes';
                            var callback = function () {
                                targetElement[_strScrollTop](constMaximum)[_strScrollLeft](_isRTL ? _rtlScrollBehavior.n ? -constMaximum : _rtlScrollBehavior.i ? 0 : constMaximum : constMaximum);
                                onElementResizedCallback();
                            };
                            if (_supportResizeObserver) {
                                var element = targetElement.append(generateDiv(_classNameResizeObserverElement + ' observed')).contents()[0];
                                var observer = element[_strResizeObserverProperty] = new resizeObserver(callback);
                                observer.observe(element);
                            }
                            else {
                                if (_msieVersion > 9 || !_autoUpdateRecommended) {
                                    targetElement.prepend(
                                        generateDiv(_classNameResizeObserverElement,
                                            generateDiv({ className : _classNameResizeObserverItemElement, dir : "ltr" },
                                                generateDiv(_classNameResizeObserverItemElement,
                                                    generateDiv(_classNameResizeObserverItemFinalElement)
                                                ) +
                                                generateDiv(_classNameResizeObserverItemElement,
                                                    generateDiv({ className : _classNameResizeObserverItemFinalElement, style : 'width: 200%; height: 200%' })
                                                )
                                            )
                                        )
                                    );

                                    var observerElement = targetElement[0][strChildNodes][0][strChildNodes][0];
                                    var shrinkElement = FRAMEWORK(observerElement[strChildNodes][1]);
                                    var expandElement = FRAMEWORK(observerElement[strChildNodes][0]);
                                    var expandElementChild = FRAMEWORK(expandElement[0][strChildNodes][0]);
                                    var widthCache = observerElement[LEXICON.oW];
                                    var heightCache = observerElement[LEXICON.oH];
                                    var isDirty;
                                    var rAFId;
                                    var currWidth;
                                    var currHeight;
                                    var factor = 2;
                                    var nativeScrollbarSize = globals.nativeScrollbarSize; //care don't make changes to this object!!!
                                    var reset = function () {
                                        /*
                                         var sizeResetWidth = observerElement[LEXICON.oW] + nativeScrollbarSize.x * factor + nativeScrollbarSize.y * factor + _overlayScrollbarDummySize.x + _overlayScrollbarDummySize.y;
                                         var sizeResetHeight = observerElement[LEXICON.oH] + nativeScrollbarSize.x * factor + nativeScrollbarSize.y * factor + _overlayScrollbarDummySize.x + _overlayScrollbarDummySize.y;
                                         var expandChildCSS = {};
                                         expandChildCSS[_strWidth] = sizeResetWidth;
                                         expandChildCSS[_strHeight] = sizeResetHeight;
                                         expandElementChild.css(expandChildCSS);


                                         expandElement[_strScrollLeft](sizeResetWidth)[_strScrollTop](sizeResetHeight);
                                         shrinkElement[_strScrollLeft](sizeResetWidth)[_strScrollTop](sizeResetHeight);
                                         */
                                        expandElement[_strScrollLeft](constMaximum)[_strScrollTop](constMaximum);
                                        shrinkElement[_strScrollLeft](constMaximum)[_strScrollTop](constMaximum);
                                    };
                                    var onResized = function () {
                                        rAFId = 0;
                                        if (!isDirty)
                                            return;

                                        widthCache = currWidth;
                                        heightCache = currHeight;
                                        callback();
                                    };
                                    var onScroll = function (event) {
                                        currWidth = observerElement[LEXICON.oW];
                                        currHeight = observerElement[LEXICON.oH];
                                        isDirty = currWidth != widthCache || currHeight != heightCache;

                                        if (event && isDirty && !rAFId) {
                                            COMPATIBILITY.cAF()(rAFId);
                                            rAFId = COMPATIBILITY.rAF()(onResized);
                                        }
                                        else if(!event)
                                            onResized();

                                        reset();
                                        if (event) {
                                            COMPATIBILITY.prvD(event);
                                            COMPATIBILITY.stpP(event);
                                        }
                                        return false;
                                    };
                                    var expandChildCSS = {};
                                    var observerElementCSS = {};

                                    setTopRightBottomLeft(observerElementCSS, _strEmpty, [
                                        -((nativeScrollbarSize.y + 1) * factor),
                                        nativeScrollbarSize.x * -factor,
                                        nativeScrollbarSize.y * -factor,
                                        -((nativeScrollbarSize.x + 1) * factor)
                                    ]);

                                    FRAMEWORK(observerElement).css(observerElementCSS);
                                    expandElement.on(_strScroll, onScroll);
                                    shrinkElement.on(_strScroll, onScroll);
                                    targetElement.on(strAnimationStartEvent, function () {
                                        onScroll(false);
                                    });
                                    //lets assume that the divs will never be that large and a constant value is enough
                                    expandChildCSS[_strWidth] = constMaximum;
                                    expandChildCSS[_strHeight] = constMaximum;
                                    expandElementChild.css(expandChildCSS);

                                    reset();
                                }
                                else {
                                    var attachEvent = _documentElementNative.attachEvent;
                                    var isIE = _msieVersion !== undefined;
                                    if (attachEvent) {
                                        targetElement.prepend(generateDiv(_classNameResizeObserverElement));
                                        findFirst(targetElement, _strDot + _classNameResizeObserverElement)[0].attachEvent('onresize', callback);
                                    }
                                    else {
                                        var obj = _documentElementNative.createElement(TYPES.o);
                                        obj.setAttribute('tabindex', '-1');
                                        obj.setAttribute(LEXICON.c, _classNameResizeObserverElement);
                                        obj.onload = function () {
                                            var wnd = this.contentDocument.defaultView;
                                            wnd.addEventListener('resize', callback);
                                            wnd.document.documentElement.style.display = 'none';
                                        };
                                        obj.type = 'text/html';
                                        if (isIE)
                                            targetElement.prepend(obj);
                                        obj.data = 'about:blank';
                                        if (!isIE)
                                            targetElement.prepend(obj);
                                        targetElement.on(strAnimationStartEvent, callback);
                                    }
                                }
                            }

                            //direction change detection:
                            if (targetElement[0] === _sizeObserverElementNative) {
                                var directionChanged = function () {
                                    var dir = _hostElement.css('direction');
                                    var css = {};
                                    var scrollLeftValue = 0;
                                    var result = false;
                                    if (dir !== _cssDirectionDetectedCache) {
                                        if (dir === 'ltr') {
                                            css[_strLeft] = 0;
                                            css[_strRight] = _strAuto;
                                            scrollLeftValue = constMaximum;
                                        }
                                        else {
                                            css[_strLeft] = _strAuto;
                                            css[_strRight] = 0;
                                            scrollLeftValue = _rtlScrollBehavior.n ? -constMaximum : _rtlScrollBehavior.i ? 0 : constMaximum;
                                        }
                                        _sizeObserverElement.children().eq(0).css(css);
                                        targetElement[_strScrollLeft](scrollLeftValue)[_strScrollTop](constMaximum);
                                        _cssDirectionDetectedCache = dir;
                                        result = true;
                                    }
                                    return result;
                                };
                                directionChanged();
                                targetElement.on(_strScroll, function (event) {
                                    if (directionChanged())
                                        update();
                                    COMPATIBILITY.prvD(event);
                                    COMPATIBILITY.stpP(event);
                                    return false;
                                });
                            }
                        }
                        //remove resize observer:
                        else {
                            if (_supportResizeObserver) {
                                var element = targetElement.contents()[0];
                                var resizeObserverObj = element[_strResizeObserverProperty];
                                if(resizeObserverObj) {
                                    resizeObserverObj.disconnect();
                                    delete element[_strResizeObserverProperty];
                                }
                            }
                            else {
                                remove(targetElement.children(_strDot + _classNameResizeObserverElement).eq(0));
                            }
                        }
                    }
                }

                /**
                 * Freezes or unfreezes the given resize observer.
                 * @param targetElement The element to which the target resize observer is applied.
                 * @param freeze True if the resize observer shall be frozen, false otherwise.
                 
                function freezeResizeObserver(targetElement, freeze) {
                    if (targetElement !== undefined) {
                        if(freeze) {
                            if (_supportResizeObserver) {
                                var element = targetElement.contents()[0];
                                element[_strResizeObserverProperty].unobserve(element);
                            }
                            else {
                                targetElement = targetElement.children(_strDot + _classNameResizeObserverElement).eq(0);
                                var w = targetElement.css(_strWidth);
                                var h = targetElement.css(_strHeight);
                                var css = {};
                                css[_strWidth] = w;
                                css[_strHeight] = h;
                                targetElement.css(css);
                            }
                        }
                        else {
                            if (_supportResizeObserver) {
                                var element = targetElement.contents()[0];
                                element[_strResizeObserverProperty].observe(element);
                            }
                            else {
                                var css = { };
                                css[_strHeight] = _strEmpty;
                                css[_strWidth] = _strEmpty;
                                targetElement.children(_strDot + _classNameResizeObserverElement).eq(0).css(css);
                            }
                        }
                    }
                }
                */


                //==== Mutation Observers ====//

                /**
                 * Creates MutationObservers for the host and content Element if they are supported.
                 */
                function createMutationObservers() {
                    if (_supportMutationObserver) {
                        var mutationObserverContentLag = 11;
                        var mutationObserver = COMPATIBILITY.mO();
                        var contentLastUpdate = COMPATIBILITY.now();
                        var mutationTarget;
                        var mutationAttrName;
                        var contentTimeout;
                        var now;
                        var sizeAuto;
                        var action;

                        _mutationObserverHostCallback = function(mutations) {
                            var doUpdate = false;
                            var mutation;
                                
                            if (_initialized && !_sleeping) {
                                each(mutations, function () {
                                    mutation = this;
                                    mutationTarget = mutation.target;
                                    mutationAttrName = mutation.attributeName;

                                    if (mutationAttrName === LEXICON.c)
                                        doUpdate = hostClassNamesChanged(mutation.oldValue, mutationTarget.className);
                                    else if (mutationAttrName === LEXICON.s)
                                        doUpdate = mutation.oldValue !== mutationTarget[LEXICON.s].cssText;
                                    else
                                        doUpdate = true;

                                    if (doUpdate)
                                        return false;
                                });

                                if (doUpdate)
                                    _base.update(_strAuto);
                            }
                            return doUpdate;
                        };
                        _mutationObserverContentCallback = function (mutations) {
                            var doUpdate = false;
                            var mutation;
                            
                            if (_initialized && !_sleeping) {
                                each(mutations, function () {
                                    mutation = this;
                                    doUpdate = isUnknownMutation(mutation);
                                    return !doUpdate;
                                });

                                if (doUpdate) {
                                    now = COMPATIBILITY.now();
                                    sizeAuto = (_heightAutoCache || _widthAutoCache);
                                    action = function () {
                                        if(!_destroyed) {
                                            contentLastUpdate = now;

                                            //if cols, rows or wrap attr was changed
                                            if (_isTextarea)
                                                textareaUpdate();

                                            if (sizeAuto)
                                                update();
                                            else
                                                _base.update(_strAuto);
                                        }
                                    };
                                    clearTimeout(contentTimeout);
                                    if (mutationObserverContentLag <= 0 || now - contentLastUpdate > mutationObserverContentLag || !sizeAuto)
                                        action();
                                    else
                                        contentTimeout = setTimeout(action, mutationObserverContentLag);
                                }
                            }
                            return doUpdate;
                        }

                        _mutationObserverHost = new mutationObserver(_mutationObserverHostCallback);
                        _mutationObserverContent = new mutationObserver(_mutationObserverContentCallback);
                    }
                }

                /**
                 * Connects the MutationObservers if they are supported.
                 */
                function connectMutationObservers() {
                    if (_supportMutationObserver && !_mutationObserversConnected) {
                        _mutationObserverHost.observe(_hostElementNative, {
                            attributes: true,
                            attributeOldValue: true,
                            attributeFilter: _mutationObserverAttrsHost
                        });

                        _mutationObserverContent.observe(_isTextarea ? _targetElementNative : _contentElementNative, {
                            attributes: true,
                            attributeOldValue: true,
                            subtree: !_isTextarea,
                            childList: !_isTextarea,
                            characterData: !_isTextarea,
                            attributeFilter: _isTextarea ? _mutationObserverAttrsTextarea : _mutationObserverAttrsHost
                        });

                        _mutationObserversConnected = true;
                    }
                }

                /**
                 * Disconnects the MutationObservers if they are supported.
                 */
                function disconnectMutationObservers() {
                    if (_supportMutationObserver && _mutationObserversConnected) {
                        _mutationObserverHost.disconnect();
                        _mutationObserverContent.disconnect();

                        _mutationObserversConnected = false;
                    }
                }

               
               //==== Events of elements ====//

                /**
                 * This method gets called every time the host element gets resized. IMPORTANT: Padding changes are detected too!!
                 * It refreshes the hostResizedEventArgs and the hostSizeResizeCache.
                 * If there are any size changes, the update method gets called.
                 */
                function hostOnResized() {
                    if (!_sleeping) {
                        var changed;
                        var hostSize = {
                            w: _sizeObserverElementNative[LEXICON.sW],
                            h: _sizeObserverElementNative[LEXICON.sH]
                        };
                        
                        changed = checkCache(hostSize, _hostElementSizeChangeDetectedCache);
                        _hostElementSizeChangeDetectedCache = hostSize;
                        if (changed)
                            update({ _hostSizeChanged : true });
                    }
                }

                /**
                 * The mouse enter event of the host element. This event is only needed for the autoHide feature.
                 */
                function hostOnMouseEnter() {
                    if (_scrollbarsAutoHideLeave)
                        refreshScrollbarsAutoHide(true);
                }

                /**
                 * The mouse leave event of the host element. This event is only needed for the autoHide feature.
                 */
                function hostOnMouseLeave() {
                    if (_scrollbarsAutoHideLeave && !_bodyElement.hasClass(_classNameDragging))
                        refreshScrollbarsAutoHide(false);
                }

                /**
                 * The mouse move event of the host element. This event is only needed for the autoHide "move" feature.
                 */
                function hostOnMouseMove() {
                    if (_scrollbarsAutoHideMove) {
                        refreshScrollbarsAutoHide(true);
                        clearTimeout(_scrollbarsAutoHideMoveTimeoutId);
                        _scrollbarsAutoHideMoveTimeoutId = setTimeout(function () {
                            if (_scrollbarsAutoHideMove && !_destroyed)
                                refreshScrollbarsAutoHide(false);
                        }, 100);
                    }
                }

                 /**
                 * Adds or removes mouse & touch events of the host element. (for handling auto-hiding of the scrollbars)
                 * @param destroy Indicates whether the events shall be added or removed.
                 */
                function setupHostMouseTouchEvents(destroy) {
                    var strOnOff = destroy ? 'off' : 'on';
                    var setupEvent = function(target, name, listener) {
                        if(_supportPassiveEvents)
                            setupPassiveEventListener(target, name, listener, destroy);
                        else
                            target[strOnOff](name, listener);
                    };

                    if(_scrollbarsAutoHideMove && !destroy)
                        setupEvent(_hostElement, _strMouseTouchMoveEvent, hostOnMouseMove);
                    else {
                        if(destroy)
                            setupEvent(_hostElement, _strMouseTouchMoveEvent, hostOnMouseMove);
                        setupEvent(_hostElement, _strMouseTouchEnter, hostOnMouseEnter);
                        setupEvent(_hostElement, _strMouseTouchLeave, hostOnMouseLeave);
                    }

                    //if the plugin is initialized and the mouse is over the host element, make the scrollbars visible
                    if(!_initialized && !destroy)
                        _hostElement.one("mouseover", hostOnMouseEnter);
                }

                /**
                 * Prevents text from deselection if attached to the document element on the mousedown event of a DOM element.
                 * @param event The select start event.
                 */
                function documentOnSelectStart(event) {
                    COMPATIBILITY.prvD(event);
                    return false;
                }

                /**
                 * A callback which will be called after a img element has downloaded its src asynchronous.
                 */
                function imgOnLoad() {
                    update({ _contentSizeChanged : true });
                }


                //==== Update Detection ====//

                /**
                 * Measures the min width and min height of the body element and refreshes the related cache.
                 * @returns {boolean} True if the min width or min height has changed, false otherwise.
                 */
                function bodyMinSizeChanged() {
                    var bodyMinSize = {};
                    if (_isBody && _contentArrangeElement) {
                        bodyMinSize.w = parseToZeroOrNumber(_contentArrangeElement.css(_strMinMinus + _strWidth));
                        bodyMinSize.h = parseToZeroOrNumber(_contentArrangeElement.css(_strMinMinus + _strHeight));
                        bodyMinSize.c = checkCache(bodyMinSize, _bodyMinSizeCache);
                        bodyMinSize.f = true; //flag for "measured at least once"
                    }
                    _bodyMinSizeCache = bodyMinSize;
                    return !!bodyMinSize.c;
                }

                /**
                 * Returns true if the class names really changed (new class without plugin host prefix)
                 * @param oldCassNames The old ClassName string.
                 * @param newClassNames The new ClassName string.
                 * @returns {boolean} True if the class names has really changed, false otherwise.
                 */
                function hostClassNamesChanged(oldCassNames, newClassNames) {
                    var currClasses = (newClassNames !== undefined && newClassNames !== null) ? newClassNames.split(_strSpace) : _strEmpty;
                    var oldClasses = (oldCassNames !== undefined && oldCassNames !== null) ? oldCassNames.split(_strSpace) : _strEmpty;
                    if (currClasses === _strEmpty && oldClasses === _strEmpty)
                        return false;
                    var diff = getArrayDifferences(oldClasses, currClasses);
                    var changed = false;
                    var oldClassNames = _oldClassName !== undefined && _oldClassName !== null ? _oldClassName.split(_strSpace) : [_strEmpty];
                    var currClassNames = _classNameCache !== undefined && _classNameCache !== null ? _classNameCache.split(_strSpace) : [_strEmpty];

                    //remove none theme from diff list to prevent update
                    var idx = inArray(_classNameThemeNone, diff);
                    var curr;
                    var i;
                    var v;
                    var o;
                    var c;

                    if (idx > -1)
                        diff.splice(idx, 1);

                    for (i = 0; i < diff.length; i++) {
                        curr = diff[i];
                        if (curr.indexOf(_classNameHostElement) !== 0) {
                            o = true;
                            c = true;
                            for (v = 0; v < oldClassNames.length; v++) {
                                if (curr === oldClassNames[v]) {
                                    o = false;
                                    break;
                                }
                            }
                            for (v = 0; v < currClassNames.length; v++) {
                                if (curr === currClassNames[v]) {
                                    c = false;
                                    break;
                                }
                            }
                            if (o && c) {
                                changed = true;
                                break;
                            }
                        }

                    }
                    return changed;
                }

                /**
                 * Returns true if the given mutation is not from a from the plugin generated element. If the target element is a textarea the mutation is always unknown.
                 * @param mutation The mutation which shall be checked.
                 * @returns {boolean} True if the mutation is from a unknown element, false otherwise.
                 */
                function isUnknownMutation(mutation) {
                    var attributeName = mutation.attributeName;
                    var mutationTarget = mutation.target;
                    var mutationType = mutation.type;
                    var strClosest = 'closest';

                    if (mutationTarget === _contentElementNative)
                        return attributeName === null;
                    if (mutationType === 'attributes' && (attributeName === LEXICON.c || attributeName === LEXICON.s) && !_isTextarea) {
                        //ignore className changes by the plugin
                        if (attributeName === LEXICON.c && FRAMEWORK(mutationTarget).hasClass(_classNameHostElement))
                            return hostClassNamesChanged(mutation.oldValue, mutationTarget.getAttribute(LEXICON.c));

                        //only do it of browser support it natively
                        if (typeof mutationTarget[strClosest] != TYPES.f)
                            return true;
                        if (mutationTarget[strClosest](_strDot + _classNameResizeObserverElement) !== null ||
                            mutationTarget[strClosest](_strDot + _classNameScrollbar) !== null ||
                            mutationTarget[strClosest](_strDot + _classNameScrollbarCorner) !== null)
                            return false;
                    }
                    return true;
                }

                /**
                 * Returns true if the content size was changed since the last time this method was called.
                 * @returns {boolean} True if the content size was changed, false otherwise.
                 */
                function updateAutoContentSizeChanged() {
                    if (_sleeping)
                        return false;
                    
                    var contentMeasureElement = getContentMeasureElement();
                    var textareaValueLength = _isTextarea && _widthAutoCache && !_textareaAutoWrappingCache ? _targetElement.val().length : 0;
                    var setCSS = !_mutationObserversConnected && _widthAutoCache && !_isTextarea;
                    var viewportScrollSize = { };
                    var css = { };
                    var float;
                    var bodyMinSizeC;
                    var changed;
                    var viewportScrollSizeChanged;
                    var contentElementScrollSize;

                    //fix for https://bugzilla.mozilla.org/show_bug.cgi?id=1439305, it only works with "clipAlways : true"
                    //it can work with "clipAlways : false" too, but I had to set the overflow of the viewportElement to hidden every time before measuring
                    if(_restrictedMeasuring) {
                        viewportScrollSize = {
                            x : _viewportElementNative[LEXICON.sW],
                            y : _viewportElementNative[LEXICON.sH]
                        }
                    }
                    if (setCSS) {
                        float = _contentElement.css(_strFloat);
                        css[_strFloat] = _isRTL ? _strRight : _strLeft;
                        css[_strWidth] = _strAuto;
                        _contentElement.css(css);
                    }
                    contentElementScrollSize = {
                        w: contentMeasureElement[LEXICON.sW] + textareaValueLength,
                        h: contentMeasureElement[LEXICON.sH] + textareaValueLength
                    };
                    if (setCSS) {
                        css[_strFloat] = float;
                        css[_strWidth] = _strHundredPercent;
                        _contentElement.css(css);
                    }

                    bodyMinSizeC = bodyMinSizeChanged();
                    changed = checkCache(contentElementScrollSize, _contentElementScrollSizeChangeDetectedCache);
                    viewportScrollSizeChanged = checkCache(viewportScrollSize, _viewportScrollSizeCache);

                    _contentElementScrollSizeChangeDetectedCache = contentElementScrollSize;
                    _viewportScrollSizeCache = viewportScrollSize;

                    return changed || bodyMinSizeC || viewportScrollSizeChanged;
                }

                /**
                 * Returns true when a attribute which the MutationObserver would observe has changed.  
                 * @returns {boolean} True if one of the attributes which a MutationObserver would observe has changed, false or undefined otherwise.
                 */
                function meaningfulAttrsChanged() {
                    if (_sleeping || _mutationObserversConnected)
                        return;
                    
                    var changed;
                    var elem;
                    var curr;
                    var cache;
                    var checks = [
                        {
                            _elem: _hostElement, 
                            _props : _mutationObserverAttrsHost.concat(':visible')
                        },
                        {
                            _elem: _isTextarea ? _targetElement : undefined, 
                            _props : _mutationObserverAttrsTextarea
                        }
                    ];
                    
                    each(checks, function(index, check) { 
                        elem = check._elem;
                        if(elem) {
                            each(check._props, function(index, prop) { 
                                curr = prop.charAt(0) === ':' ? elem.is(prop) : elem.attr(prop);
                                cache = _updateAutoCache[prop];
                                
                                changed = changed || checkCache(curr, cache);
                                
                                _updateAutoCache[prop] = curr;
                            });
                        }
                    });
                    
                    return changed;
                }

                /**
                 * Checks is a CSS Property of a child element is affecting the scroll size of the content.
                 * @param propertyName The CSS property name.
                 * @returns {boolean} True if the property is affecting the content scroll size, false otherwise.
                 */
                function isSizeAffectingCSSProperty(propertyName) {
                    if (!_initialized)
                        return true;
                    var flexGrow = 'flex-grow';
                    var flexShrink = 'flex-shrink';
                    var flexBasis = 'flex-basis';
                    var affectingPropsX = [
                        _strWidth,
                        _strMinMinus + _strWidth,
                        _strMaxMinus + _strWidth,
                        _strMarginMinus + _strLeft,
                        _strMarginMinus + _strRight,
                        _strLeft,
                        _strRight,
                        'font-weight',
                        'word-spacing',
                        flexGrow,
                        flexShrink,
                        flexBasis
                    ];
                    var affectingPropsXContentBox = [
                        _strPaddingMinus + _strLeft,
                        _strPaddingMinus + _strRight,
                        _strBorderMinus + _strLeft + _strWidth,
                        _strBorderMinus + _strRight + _strWidth
                    ];
                    var affectingPropsY = [
                        _strHeight,
                        _strMinMinus + _strHeight,
                        _strMaxMinus + _strHeight,
                        _strMarginMinus + _strTop,
                        _strMarginMinus + _strBottom,
                        _strTop,
                        _strBottom,
                        'line-height',
                        flexGrow,
                        flexShrink,
                        flexBasis
                    ];
                    var affectingPropsYContentBox = [
                        _strPaddingMinus + _strTop,
                        _strPaddingMinus + _strBottom,
                        _strBorderMinus + _strTop + _strWidth,
                        _strBorderMinus + _strBottom + _strWidth
                    ];
                    var _strS = 's';
                    var _strVS = 'v-s';
                    var checkX = _overflowBehaviorCache.x === _strS || _overflowBehaviorCache.x === _strVS;
                    var checkY = _overflowBehaviorCache.y === _strS || _overflowBehaviorCache.y === _strVS;
                    var sizeIsAffected = false;
                    var checkPropertyName = function (arr, name) {
                        for (var i = 0; i < arr[LEXICON.l]; i++) {
                            if (arr[i] === name)
                                return true;
                        }
                        return false;
                    };

                    if (checkY) {
                        sizeIsAffected = checkPropertyName(affectingPropsY, propertyName);
                        if (!sizeIsAffected && !_isBorderBox)
                            sizeIsAffected = checkPropertyName(affectingPropsYContentBox, propertyName);
                    }
                    if (checkX && !sizeIsAffected) {
                        sizeIsAffected = checkPropertyName(affectingPropsX, propertyName);
                        if (!sizeIsAffected && !_isBorderBox)
                            sizeIsAffected = checkPropertyName(affectingPropsXContentBox, propertyName);
                    }
                    return sizeIsAffected;
                }

                
                //==== Update ====//

                /**
                 * Updates the variables and size of the textarea element, and manages the scroll on new line or new character.
                 */
                function textareaUpdate() {
                    if (!_sleeping) {
                        var wrapAttrOff = !_textareaAutoWrappingCache;
                        var minWidth = _viewportSize.w;
                        var minHeight = _viewportSize.h;
                        var css = { };
                        var doMeasure = _widthAutoCache || wrapAttrOff;
                        var origWidth;
                        var width;
                        var origHeight;
                        var height;

                        //reset min size
                        css[_strMinMinus + _strWidth] = _strEmpty;
                        css[_strMinMinus + _strHeight] = _strEmpty;

                        //set width auto
                        css[_strWidth] = _strAuto;
                        _targetElement.css(css);

                        //measure width
                        origWidth = _targetElementNative[LEXICON.oW];
                        width = doMeasure ? MATH.max(origWidth, _targetElementNative[LEXICON.sW] - 1) : 1;
                        /*width += (_widthAutoCache ? _marginX + (!_isBorderBox ? wrapAttrOff ? 0 : _paddingX + _borderX : 0) : 0);*/

                        //set measured width
                        css[_strWidth] = _widthAutoCache ? _strAuto /*width*/ : _strHundredPercent;
                        css[_strMinMinus + _strWidth] = _strHundredPercent;

                        //set height auto
                        css[_strHeight] = _strAuto;
                        _targetElement.css(css);

                        //measure height
                        origHeight = _targetElementNative[LEXICON.oH];
                        height = MATH.max(origHeight, _targetElementNative[LEXICON.sH] - 1);

                        //append correct size values
                        css[_strWidth] = width;
                        css[_strHeight] = height;
                        _textareaCoverElement.css(css);

                        //apply min width / min height to prevent textarea collapsing
                        css[_strMinMinus + _strWidth] = minWidth /*+ (!_isBorderBox && _widthAutoCache ? _paddingX + _borderX : 0)*/;
                        css[_strMinMinus + _strHeight] = minHeight /*+ (!_isBorderBox && _heightAutoCache ? _paddingY + _borderY : 0)*/;
                        _targetElement.css(css);

                        return {
                            _originalWidth: origWidth,
                            _originalHeight: origHeight,
                            _dynamicWidth: width,
                            _dynamicHeight: height
                        };
                    }
                }

                /**
                 * Updates the plugin and DOM to the current options.
                 * This method should only be called if a update is 100% required.
                 * @param updateHints A objects which contains hints for this update:
                 * {
                 *   _hostSizeChanged : boolean,
                 *   _contentSizeChanged : boolean,
                 *   _force : boolean,                             == preventSwallowing
                 *   _changedOptions : { },                        == preventSwallowing && preventSleep
                *  }
                 */
                function update(updateHints) {
                    clearTimeout(_swallowedUpdateTimeout);
                    updateHints = updateHints || { };
                    _swallowedUpdateHints._hostSizeChanged |= updateHints._hostSizeChanged;
                    _swallowedUpdateHints._contentSizeChanged |= updateHints._contentSizeChanged;
                    _swallowedUpdateHints._force |= updateHints._force;
                    
                    var now = COMPATIBILITY.now();
                    var hostSizeChanged = !!_swallowedUpdateHints._hostSizeChanged;
                    var contentSizeChanged = !!_swallowedUpdateHints._contentSizeChanged;
                    var force = !!_swallowedUpdateHints._force;
                    var changedOptions = updateHints._changedOptions;    
                    var swallow = _swallowUpdateLag > 0 && _initialized && !_destroyed && !force && !changedOptions && (now - _lastUpdateTime) < _swallowUpdateLag && (!_heightAutoCache && !_widthAutoCache);                    
                    var displayIsHidden;

                    if(swallow)
                        _swallowedUpdateTimeout = setTimeout(update, _swallowUpdateLag);

                    //abort update due to:
                    //destroyed
                    //swallowing
                    //sleeping
                    //host is hidden or has false display
                    if (_destroyed || swallow || (_sleeping && !changedOptions) || (_initialized && !force && (displayIsHidden = _hostElement.is(':hidden'))) || _hostElement.css('display') === 'inline')
                        return;

                    _lastUpdateTime = now;
                    _swallowedUpdateHints = { };
                    
                    //if scrollbar styling is possible and native scrollbars aren't overlaid the scrollbar styling will be applied which hides the native scrollbars completely.
                    if (_nativeScrollbarStyling && !(_nativeScrollbarIsOverlaid.x && _nativeScrollbarIsOverlaid.y)) {
                        //native scrollbars are hidden, so change the values to zero
                        _nativeScrollbarSize.x = 0;
                        _nativeScrollbarSize.y = 0;
                    }
                    else {
                        //refresh native scrollbar size (in case of zoom)
                        _nativeScrollbarSize = extendDeep({}, globals.nativeScrollbarSize);
                    }

                    // Scrollbar padding is needed for firefox, because firefox hides scrollbar automatically if the size of the div is too small.
                    // The calculation: [scrollbar size +3 *3]
                    // (+3 because of possible decoration e.g. borders, margins etc., but only if native scrollbar is NOT a overlaid scrollbar)
                    // (*3 because (1)increase / (2)decrease -button and (3)resize handle)
                    _nativeScrollbarMinSize = {
                        x: (_nativeScrollbarSize.x + (_nativeScrollbarIsOverlaid.x ? 0 : 3)) * 3,
                        y: (_nativeScrollbarSize.y + (_nativeScrollbarIsOverlaid.y ? 0 : 3)) * 3
                    };
                    
                    //changedOptions = changedOptions || { };
                    //freezeResizeObserver(_sizeObserverElement, true);
                    //freezeResizeObserver(_sizeAutoObserverElement, true);
                    
                    var checkCacheAutoForce = function () {
                        return checkCache.apply(this, [].slice.call(arguments).concat([ force ]));
                    };
                    
                    //save current scroll offset
                    var currScroll = {
                        x: _viewportElement[_strScrollLeft](),
                        y: _viewportElement[_strScrollTop]()
                    };

                    var currentPreparedOptionsScrollbars = _currentPreparedOptions.scrollbars;
                    var currentPreparedOptionsTextarea = _currentPreparedOptions.textarea;

                    //scrollbars visibility:
                    var scrollbarsVisibility = currentPreparedOptionsScrollbars.visibility;
                    var scrollbarsVisibilityChanged = checkCacheAutoForce(scrollbarsVisibility, _scrollbarsVisibilityCache);

                    //scrollbars autoHide:
                    var scrollbarsAutoHide = currentPreparedOptionsScrollbars.autoHide;
                    var scrollbarsAutoHideChanged = checkCacheAutoForce(scrollbarsAutoHide, _scrollbarsAutoHideCache);

                    //scrollbars click scrolling
                    var scrollbarsClickScrolling = currentPreparedOptionsScrollbars.clickScrolling;
                    var scrollbarsClickScrollingChanged = checkCacheAutoForce(scrollbarsClickScrolling, _scrollbarsClickScrollingCache);

                    //scrollbars drag scrolling
                    var scrollbarsDragScrolling = currentPreparedOptionsScrollbars.dragScrolling;
                    var scrollbarsDragScrollingChanged = checkCacheAutoForce(scrollbarsDragScrolling, _scrollbarsDragScrollingCache);

                    //className
                    var className = _currentPreparedOptions.className;
                    var classNameChanged = checkCacheAutoForce(className, _classNameCache);

                    //resize
                    var resize = _currentPreparedOptions.resize;
                    var resizeChanged = checkCacheAutoForce(resize, _resizeCache) && !_isBody; //body can't be resized since the window itself acts as resize possibility.

                    //paddingAbsolute
                    var paddingAbsolute = _currentPreparedOptions.paddingAbsolute;
                    var paddingAbsoluteChanged = checkCacheAutoForce(paddingAbsolute, _paddingAbsoluteCache);

                    //clipAlways
                    var clipAlways = _currentPreparedOptions.clipAlways;
                    var clipAlwaysChanged = checkCacheAutoForce(clipAlways, _clipAlwaysCache);

                    //sizeAutoCapable
                    var sizeAutoCapable = _currentPreparedOptions.sizeAutoCapable && !_isBody; //body can never be size auto, because it shall be always as big as the viewport.
                    var sizeAutoCapableChanged = checkCacheAutoForce(sizeAutoCapable, _sizeAutoCapableCache);

                    //showNativeScrollbars
                    var ignoreOverlayScrollbarHiding = _currentPreparedOptions.nativeScrollbarsOverlaid.showNativeScrollbars;
                    var ignoreOverlayScrollbarHidingChanged = checkCacheAutoForce(ignoreOverlayScrollbarHiding, _ignoreOverlayScrollbarHidingCache);

                    //autoUpdate
                    var autoUpdate = _currentPreparedOptions.autoUpdate;
                    var autoUpdateChanged = checkCacheAutoForce(autoUpdate, _autoUpdateCache);

                    //overflowBehavior
                    var overflowBehavior = _currentPreparedOptions.overflowBehavior;
                    var overflowBehaviorChanged = checkCacheAutoForce(overflowBehavior, _overflowBehaviorCache, force);

                    //dynWidth:
                    var textareaDynWidth = currentPreparedOptionsTextarea.dynWidth;
                    var textareaDynWidthChanged = checkCacheAutoForce(_textareaDynWidthCache, textareaDynWidth);

                    //dynHeight:
                    var textareaDynHeight = currentPreparedOptionsTextarea.dynHeight;
                    var textareaDynHeightChanged = checkCacheAutoForce(_textareaDynHeightCache, textareaDynHeight);

                    //scrollbars visibility
                    _scrollbarsAutoHideNever = scrollbarsAutoHide === 'n';
                    _scrollbarsAutoHideScroll = scrollbarsAutoHide === 's';
                    _scrollbarsAutoHideMove = scrollbarsAutoHide === 'm';
                    _scrollbarsAutoHideLeave = scrollbarsAutoHide === 'l';

                    //scrollbars autoHideDelay
                    _scrollbarsAutoHideDelay = currentPreparedOptionsScrollbars.autoHideDelay;

                    //old className
                    _oldClassName = _classNameCache;

                    //resize
                    _resizeNone = resize === 'n';
                    _resizeBoth = resize === 'b';
                    _resizeHorizontal = resize === 'h';
                    _resizeVertical = resize === 'v';

                    //normalizeRTL
                    _normalizeRTLCache = _currentPreparedOptions.normalizeRTL;

                    //ignore overlay scrollbar hiding
                    ignoreOverlayScrollbarHiding = ignoreOverlayScrollbarHiding && (_nativeScrollbarIsOverlaid.x && _nativeScrollbarIsOverlaid.y);

                    //refresh options cache
                    _scrollbarsVisibilityCache = scrollbarsVisibility;
                    _scrollbarsAutoHideCache = scrollbarsAutoHide;
                    _scrollbarsClickScrollingCache = scrollbarsClickScrolling;
                    _scrollbarsDragScrollingCache = scrollbarsDragScrolling;
                    _classNameCache = className;
                    _resizeCache = resize;
                    _paddingAbsoluteCache = paddingAbsolute;
                    _clipAlwaysCache = clipAlways;
                    _sizeAutoCapableCache = sizeAutoCapable;
                    _ignoreOverlayScrollbarHidingCache = ignoreOverlayScrollbarHiding;
                    _autoUpdateCache = autoUpdate;
                    _overflowBehaviorCache = extendDeep({}, overflowBehavior);
                    _textareaDynWidthCache = textareaDynWidth;
                    _textareaDynHeightCache = textareaDynHeight;
                    _hasOverflowCache = _hasOverflowCache || { x: false, y: false };

                    //set correct class name to the host element
                    if (classNameChanged) {
                        removeClass(_hostElement, _oldClassName + _strSpace + _classNameThemeNone);
                        addClass(_hostElement, className !== undefined && className !== null && className.length > 0 ? className : _classNameThemeNone);
                    }

                    //set correct auto Update
                    if (autoUpdateChanged) {
                        if (autoUpdate === true) {
                            disconnectMutationObservers();
                            autoUpdateLoop.add(_base);
                        }
                        else if (autoUpdate === null) {
                            if (_autoUpdateRecommended) {
                                disconnectMutationObservers();
                                autoUpdateLoop.add(_base);
                            }
                            else {
                                autoUpdateLoop.remove(_base);
                                connectMutationObservers();
                            }
                        }
                        else {
                            autoUpdateLoop.remove(_base);
                            connectMutationObservers();
                        }
                    }

                    //activate or deactivate size auto capability
                    if (sizeAutoCapableChanged) {
                        if (sizeAutoCapable) {
                            if (!_contentGlueElement) {
                                _contentGlueElement = FRAMEWORK(generateDiv(_classNameContentGlueElement));
                                _paddingElement.before(_contentGlueElement);
                            }
                            else {
                                _contentGlueElement.show();
                            }
                            if (_sizeAutoObserverAdded) {
                                _sizeAutoObserverElement.show();
                            }
                            else {
                                _sizeAutoObserverElement = FRAMEWORK(generateDiv(_classNameSizeAutoObserverElement));
                                _sizeAutoObserverElementNative = _sizeAutoObserverElement[0];

                                _contentGlueElement.before(_sizeAutoObserverElement);
                                var oldSize = {w: -1, h: -1};
                                setupResizeObserver(_sizeAutoObserverElement, function () {
                                    var newSize = {
                                        w: _sizeAutoObserverElementNative[LEXICON.oW],
                                        h: _sizeAutoObserverElementNative[LEXICON.oH]
                                    };
                                    if (checkCache(newSize, oldSize)) {
                                        if (_initialized && (_heightAutoCache && newSize.h > 0) || (_widthAutoCache && newSize.w > 0)) {
                                            update();
                                        }
                                        else if (_initialized && (!_heightAutoCache && newSize.h === 0) || (!_widthAutoCache && newSize.w === 0)) {
                                            update();
                                        }
                                    }
                                    oldSize = newSize;
                                });
                                _sizeAutoObserverAdded = true;
                                //fix heightAuto detector bug if height is fixed but contentHeight is 0.
                                //the probability this bug will ever happen is very very low, thats why its ok if we use calc which isn't supported in IE8.
                                if (_cssCalc !== null)
                                    _sizeAutoObserverElement.css(_strHeight, _cssCalc + '(100% + 1px)');
                            }
                        }
                        else {
                            if (_sizeAutoObserverAdded)
                                _sizeAutoObserverElement.hide();
                            if (_contentGlueElement)
                                _contentGlueElement.hide();
                        }
                    }

                    //if force, update all resizeObservers too
                    if (force) {
                        _sizeObserverElement.find('*').trigger(_strScroll);
                        if (_sizeAutoObserverAdded)
                            _sizeAutoObserverElement.find('*').trigger(_strScroll);
                    }

                    //display hidden:
                    displayIsHidden = displayIsHidden === undefined ? _hostElement.is(':hidden') : displayIsHidden;
                    var displayIsHiddenChanged = checkCacheAutoForce(displayIsHidden, _displayIsHiddenCache);

                    //textarea AutoWrapping:
                    var textareaAutoWrapping = _isTextarea ? _targetElement.attr('wrap') !== 'off' : false;
                    var textareaAutoWrappingChanged = checkCacheAutoForce(textareaAutoWrapping, _textareaAutoWrappingCache);

                    //detect direction:
                    var cssDirection = _hostElement.css('direction');
                    var cssDirectionChanged = checkCacheAutoForce(cssDirection, _cssDirectionCache);

                    //detect box-sizing:
                    var boxSizing = _hostElement.css('box-sizing');
                    var boxSizingChanged = checkCacheAutoForce(boxSizing, _cssBoxSizingCache);

                    //detect padding:
                    var padding = {
                        c: force,
                        t: parseToZeroOrNumber(_hostElement.css(_strPaddingMinus + _strTop)),
                        r: parseToZeroOrNumber(_hostElement.css(_strPaddingMinus + _strRight)),
                        b: parseToZeroOrNumber(_hostElement.css(_strPaddingMinus + _strBottom)),
                        l: parseToZeroOrNumber(_hostElement.css(_strPaddingMinus + _strLeft))
                    };
                    
                    //width + height auto detecting var:
                    var sizeAutoObserverElementBCRect;
                    //exception occurs in IE8 sometimes (unknown exception)
                    try {
                        sizeAutoObserverElementBCRect = _sizeAutoObserverAdded ? _sizeAutoObserverElementNative.getBoundingClientRect() : null;
                    } catch (ex) {
                        return;
                    }

                    _isRTL = cssDirection === 'rtl';
                    _isBorderBox = (boxSizing === 'border-box');
                    var isRTLLeft = _isRTL ? _strLeft : _strRight;
                    var isRTLRight = _isRTL ? _strRight : _strLeft;

                    //detect width auto:
                    var widthAutoResizeDetection = false;
                    var widthAutoObserverDetection = (_sizeAutoObserverAdded && (_hostElement.css(_strFloat) !== 'none' /*|| _isTextarea */)) ? (MATH.round(sizeAutoObserverElementBCRect.right - sizeAutoObserverElementBCRect.left) === 0) && (!paddingAbsolute ? (_hostElementNative[LEXICON.cW] - _paddingX) > 0 : true) : false;
                    if (sizeAutoCapable && !widthAutoObserverDetection) {
                        var tmpCurrHostWidth = _hostElementNative[LEXICON.oW];
                        var tmpCurrContentGlueWidth = _contentGlueElement.css(_strWidth);
                        _contentGlueElement.css(_strWidth, _strAuto);

                        var tmpNewHostWidth = _hostElementNative[LEXICON.oW];
                        _contentGlueElement.css(_strWidth, tmpCurrContentGlueWidth);
                        widthAutoResizeDetection = tmpCurrHostWidth !== tmpNewHostWidth;
                        if (!widthAutoResizeDetection) {
                            _contentGlueElement.css(_strWidth, tmpCurrHostWidth + 1);
                            tmpNewHostWidth = _hostElementNative[LEXICON.oW];
                            _contentGlueElement.css(_strWidth, tmpCurrContentGlueWidth);
                            widthAutoResizeDetection = tmpCurrHostWidth !== tmpNewHostWidth;
                        }
                    }
                    var widthAuto = (widthAutoObserverDetection || widthAutoResizeDetection) && sizeAutoCapable && !displayIsHidden;
                    var widthAutoChanged = checkCacheAutoForce(widthAuto, _widthAutoCache);
                    var wasWidthAuto = !widthAuto && _widthAutoCache;

                    //detect height auto:
                    var heightAuto = _sizeAutoObserverAdded && sizeAutoCapable && !displayIsHidden ? (MATH.round(sizeAutoObserverElementBCRect.bottom - sizeAutoObserverElementBCRect.top) === 0) /* && (!paddingAbsolute && (_msieVersion > 9 || !_msieVersion) ? true : true) */ : false;
                    var heightAutoChanged = checkCacheAutoForce(heightAuto, _heightAutoCache);
                    var wasHeightAuto = !heightAuto && _heightAutoCache;

                    //detect border:
                    //we need the border only if border box and auto size
                    var strMinusWidth = '-' + _strWidth;
                    var updateBorderX = (widthAuto && _isBorderBox) || !_isBorderBox;
                    var updateBorderY = (heightAuto && _isBorderBox) || !_isBorderBox;
                    var border = {
                        c: force,
                        t: updateBorderY ? parseToZeroOrNumber(_hostElement.css(_strBorderMinus + _strTop + strMinusWidth), true) : 0,
                        r: updateBorderX ? parseToZeroOrNumber(_hostElement.css(_strBorderMinus + _strRight + strMinusWidth), true) : 0,
                        b: updateBorderY ? parseToZeroOrNumber(_hostElement.css(_strBorderMinus + _strBottom + strMinusWidth), true) : 0,
                        l: updateBorderX ? parseToZeroOrNumber(_hostElement.css(_strBorderMinus + _strLeft + strMinusWidth), true) : 0
                    };

                    //detect margin:
                    var margin = {
                        c: force,
                        t: parseToZeroOrNumber(_hostElement.css(_strMarginMinus + _strTop)),
                        r: parseToZeroOrNumber(_hostElement.css(_strMarginMinus + _strRight)),
                        b: parseToZeroOrNumber(_hostElement.css(_strMarginMinus + _strBottom)),
                        l: parseToZeroOrNumber(_hostElement.css(_strMarginMinus + _strLeft))
                    };

                    //detect css max width & height:
                    var cssMaxValue = {
                        h: String(_hostElement.css(_strMaxMinus + _strHeight)),
                        w: String(_hostElement.css(_strMaxMinus + _strWidth))
                    };

                    //vars to apply correct css
                    var contentElementCSS = { };
                    var contentGlueElementCSS = { };

                    //funcs
                    var getHostSize = function() {
                        //has to be clientSize because offsetSize respect borders
                        return {
                            w: _hostElementNative[LEXICON.cW],
                            h: _hostElementNative[LEXICON.cH]
                        };
                    };
                    var getViewportSize = function() {
                        //viewport size is padding container because it never has padding, margin and a border
                        //determine zoom rounding error -> sometimes scrollWidth/Height is smaller than clientWidth/Height
                        //if this happens add the difference to the viewportSize to compensate the rounding error
                        return {
                            w: _paddingElementNative[LEXICON.oW] + MATH.max(0, _contentElementNative[LEXICON.cW] - _contentElementNative[LEXICON.sW]),
                            h: _paddingElementNative[LEXICON.oH] + MATH.max(0, _contentElementNative[LEXICON.cH] - _contentElementNative[LEXICON.sH])
                        };
                    };

                    //set info for padding
                    var paddingAbsoluteX = _paddingX = padding.l + padding.r;
                    var paddingAbsoluteY = _paddingY = padding.t + padding.b;
                    paddingAbsoluteX *= paddingAbsolute ? 1 : 0;
                    paddingAbsoluteY *= paddingAbsolute ? 1 : 0;
                    padding.c = checkCacheAutoForce(padding, _cssPaddingCache);

                    //set info for border
                    _borderX = border.l + border.r;
                    _borderY = border.t + border.b;
                    border.c = checkCacheAutoForce(border, _cssBorderCache);

                    //set info for margin
                    _marginX = margin.l + margin.r;
                    _marginY = margin.t + margin.b;
                    margin.c = checkCacheAutoForce(margin, _cssMarginCache);

                    //set info for css max value
                    cssMaxValue.ih = parseToZeroOrNumber(cssMaxValue.h); //ih = integer height
                    cssMaxValue.iw = parseToZeroOrNumber(cssMaxValue.w); //iw = integer width
                    cssMaxValue.ch = cssMaxValue.h.indexOf('px') > -1; //ch = correct height
                    cssMaxValue.cw = cssMaxValue.w.indexOf('px') > -1; //cw = correct width
                    cssMaxValue.c = checkCacheAutoForce(cssMaxValue, _cssMaxValueCache);

                    //refresh cache
                    _displayIsHiddenCache = displayIsHidden;
                    _textareaAutoWrappingCache = textareaAutoWrapping;
                    _cssDirectionCache = cssDirection;
                    _cssBoxSizingCache = boxSizing;
                    _widthAutoCache = widthAuto;
                    _heightAutoCache = heightAuto;
                    _cssPaddingCache = padding;
                    _cssBorderCache = border;
                    _cssMarginCache = margin;
                    _cssMaxValueCache = cssMaxValue;
                        
                    //IEFix direction changed
                    if (cssDirectionChanged && _sizeAutoObserverAdded)
                        _sizeAutoObserverElement.css(_strFloat, isRTLRight);

                    //apply padding:
                    if (padding.c || cssDirectionChanged || paddingAbsoluteChanged || widthAutoChanged || heightAutoChanged || boxSizingChanged || sizeAutoCapableChanged) {
                        var paddingElementCSS = {};
                        var textareaCSS = {};
                        setTopRightBottomLeft(contentGlueElementCSS, _strMarginMinus, [-padding.t, -padding.r, -padding.b, -padding.l]);
                        if (paddingAbsolute) {
                            setTopRightBottomLeft(paddingElementCSS, _strEmpty, [padding.t, padding.r, padding.b, padding.l]);
                            if (_isTextarea)
                                setTopRightBottomLeft(textareaCSS, _strPaddingMinus);
                            else
                                setTopRightBottomLeft(contentElementCSS, _strPaddingMinus);
                        }
                        else {
                            setTopRightBottomLeft(paddingElementCSS, _strEmpty);
                            if (_isTextarea)
                                setTopRightBottomLeft(textareaCSS, _strPaddingMinus, [padding.t, padding.r, padding.b, padding.l]);
                            else
                                setTopRightBottomLeft(contentElementCSS, _strPaddingMinus, [padding.t, padding.r, padding.b, padding.l]);
                        }
                        _paddingElement.css(paddingElementCSS);
                        _targetElement.css(textareaCSS);
                    }

                    //viewport size is padding container because it never has padding, margin and a border.
                    _viewportSize = getViewportSize();

                    //update Textarea
                    var textareaSize = _isTextarea ? textareaUpdate() : false;
                    var textareaDynOrigSize = _isTextarea && textareaSize ? {
                        w : textareaDynWidth ? textareaSize._dynamicWidth : textareaSize._originalWidth,
                        h : textareaDynHeight ? textareaSize._dynamicHeight : textareaSize._originalHeight
                    } : { };
                    
                    //fix height auto / width auto in cooperation with current padding & boxSizing behavior:
                    if (heightAuto && (heightAutoChanged || paddingAbsoluteChanged || boxSizingChanged || cssMaxValue.c || padding.c || border.c)) {
                        //if (cssMaxValue.ch)
                        contentElementCSS[_strMaxMinus + _strHeight] =
                            (cssMaxValue.ch ? (cssMaxValue.ih - paddingAbsoluteY + (_isBorderBox ? -_borderY : _paddingY))
                            : _strEmpty);
                        contentElementCSS[_strHeight] = _strAuto;
                    }
                    else if (heightAutoChanged || paddingAbsoluteChanged) {
                        contentElementCSS[_strMaxMinus + _strHeight] = _strEmpty;
                        contentElementCSS[_strHeight] = _strHundredPercent;
                    }
                    if (widthAuto && (widthAutoChanged || paddingAbsoluteChanged || boxSizingChanged || cssMaxValue.c || padding.c || border.c || cssDirectionChanged)) {
                        //if (cssMaxValue.cw)
                        contentElementCSS[_strMaxMinus + _strWidth] =
                            (cssMaxValue.cw ? (cssMaxValue.iw - paddingAbsoluteX + (_isBorderBox ? -_borderX : _paddingX)) +
                            (_nativeScrollbarIsOverlaid.y /*&& _hasOverflowCache.y && widthAuto */ ? _overlayScrollbarDummySize.y : 0)
                            : _strEmpty);
                        contentElementCSS[_strWidth] = _strAuto;
                        contentGlueElementCSS[_strMaxMinus + _strWidth] = _strHundredPercent; //IE Fix
                    }
                    else if (widthAutoChanged || paddingAbsoluteChanged) {
                        contentElementCSS[_strMaxMinus + _strWidth] = _strEmpty;
                        contentElementCSS[_strWidth] = _strHundredPercent;
                        contentElementCSS[_strFloat] = _strEmpty;
                        contentGlueElementCSS[_strMaxMinus + _strWidth] = _strEmpty; //IE Fix
                    }
                    if (widthAuto) {
                        if (!cssMaxValue.cw)
                            contentElementCSS[_strMaxMinus + _strWidth] = _strEmpty;
                        //textareaDynOrigSize.w || _strAuto :: doesnt works because applied margin will shift width
                        contentGlueElementCSS[_strWidth] = _strAuto;

                        contentElementCSS[_strWidth] = _strAuto;
                        contentElementCSS[_strFloat] = isRTLRight;
                    }
                    else {
                        contentGlueElementCSS[_strWidth] = _strEmpty;
                    }
                    if (heightAuto) {
                        if (!cssMaxValue.ch)
                            contentElementCSS[_strMaxMinus + _strHeight] = _strEmpty;
                        //textareaDynOrigSize.h || _contentElementNative[LEXICON.cH] :: use for anti scroll jumping
                        contentGlueElementCSS[_strHeight] = textareaDynOrigSize.h || _contentElementNative[LEXICON.cH];
                    }
                    else {
                        contentGlueElementCSS[_strHeight] = _strEmpty;
                    }
                    if (sizeAutoCapable)
                        _contentGlueElement.css(contentGlueElementCSS);
                    _contentElement.css(contentElementCSS);

                    //CHECKPOINT HERE ~
                    contentElementCSS = {};
                    contentGlueElementCSS = {};

                    //if [content(host) client / scroll size, or target element direction, or content(host) max-sizes] changed, or force is true
                    if (hostSizeChanged || contentSizeChanged || cssDirectionChanged || boxSizingChanged || paddingAbsoluteChanged || widthAutoChanged || widthAuto || heightAutoChanged || heightAuto || cssMaxValue.c || ignoreOverlayScrollbarHidingChanged || overflowBehaviorChanged || clipAlwaysChanged || resizeChanged || scrollbarsVisibilityChanged || scrollbarsAutoHideChanged || scrollbarsDragScrollingChanged || scrollbarsClickScrollingChanged || textareaDynWidthChanged || textareaDynHeightChanged || textareaAutoWrappingChanged) {
                        var strOverflow = 'overflow';
                        var strOverflowX = strOverflow + '-x';
                        var strOverflowY = strOverflow + '-y';
                        var strHidden = 'hidden';
                        var strVisible = 'visible';
                        //decide whether the content overflow must get hidden for correct overflow measuring, it !MUST! be always hidden if the height is auto
                        var hideOverflow4CorrectMeasuring = _restrictedMeasuring ?
                        (_nativeScrollbarIsOverlaid.x || _nativeScrollbarIsOverlaid.y) || //it must be hidden if native scrollbars are overlaid
                        (_viewportSize.w < _nativeScrollbarMinSize.y || _viewportSize.h < _nativeScrollbarMinSize.x) || //it must be hidden if host-element is too small
                        heightAuto || displayIsHiddenChanged //it must be hidden if height is auto or display was changed
                            : heightAuto; //if there is not the restricted Measuring bug, it must be hidden if the height is auto

                        //Reset the viewport (very important for natively overlaid scrollbars and zoom change
                        //don't change the overflow prop as it is very expensive and affects performance !A LOT!
                        var viewportElementResetCSS = { };
                        var resetXTmp = _hasOverflowCache.y && _hideOverflowCache.ys && !ignoreOverlayScrollbarHiding ? (_nativeScrollbarIsOverlaid.y ? _viewportElement.css(isRTLLeft) : -_nativeScrollbarSize.y) : 0;
                        var resetBottomTmp = _hasOverflowCache.x && _hideOverflowCache.xs && !ignoreOverlayScrollbarHiding ? (_nativeScrollbarIsOverlaid.x ? _viewportElement.css(_strBottom) : -_nativeScrollbarSize.x) : 0;
                        setTopRightBottomLeft(viewportElementResetCSS, _strEmpty);
                        _viewportElement.css(viewportElementResetCSS);
                        if(hideOverflow4CorrectMeasuring)
                            _contentElement.css(strOverflow, strHidden);

                        //measure several sizes:
                        var contentMeasureElement = getContentMeasureElement();
                        //in Firefox content element has to have overflow hidden, else element margins aren't calculated properly, this element prevents this bug, but only if scrollbars aren't overlaid
                        var contentMeasureElementGuaranty = _restrictedMeasuring && !hideOverflow4CorrectMeasuring ? _viewportElementNative : contentMeasureElement;
                        var contentSize = {
                            //use clientSize because natively overlaidScrollbars add borders
                            w: textareaDynOrigSize.w || contentMeasureElement[LEXICON.cW],
                            h: textareaDynOrigSize.h || contentMeasureElement[LEXICON.cH]
                        };
                        var scrollSize = {
                            w: MATH.max(contentMeasureElement[LEXICON.sW], contentMeasureElementGuaranty[LEXICON.sW]),
                            h: MATH.max(contentMeasureElement[LEXICON.sH], contentMeasureElementGuaranty[LEXICON.sH])
                        };

                        //apply the correct viewport style and measure viewport size
                        viewportElementResetCSS[_strBottom] = wasHeightAuto ? _strEmpty : resetBottomTmp;
                        viewportElementResetCSS[isRTLLeft] = wasWidthAuto ? _strEmpty : resetXTmp;
                        _viewportElement.css(viewportElementResetCSS);
                        _viewportSize = getViewportSize();

                        //measure and correct several sizes
                        var hostSize = getHostSize();
                        var contentGlueSize = {
                            //client/scrollSize + AbsolutePadding -> because padding is only applied to the paddingElement if its absolute, so you have to add it manually
                            //hostSize is clientSize -> so padding should be added manually, right? FALSE! Because content glue is inside hostElement, so we don't have to worry about padding
                            w: MATH.max((widthAuto ? contentSize.w : scrollSize.w) + paddingAbsoluteX, hostSize.w),
                            h: MATH.max((heightAuto ? contentSize.h : scrollSize.h) + paddingAbsoluteY, hostSize.h)
                        };
                        contentGlueSize.c = checkCacheAutoForce(contentGlueSize, _contentGlueSizeCache);
                        _contentGlueSizeCache = contentGlueSize;

                        //apply correct contentGlue size
                        if (sizeAutoCapable) {
                            //size contentGlue correctly to make sure the element has correct size if the sizing switches to auto
                            if (contentGlueSize.c || (heightAuto || widthAuto)) {
                                contentGlueElementCSS[_strWidth] = contentGlueSize.w;
                                contentGlueElementCSS[_strHeight] = contentGlueSize.h;

                                //textarea-sizes are already calculated correctly at this point
                                if(!_isTextarea) {
                                    contentSize = {
                                        //use clientSize because natively overlaidScrollbars add borders
                                        w: contentMeasureElement[LEXICON.cW],
                                        h: contentMeasureElement[LEXICON.cH]
                                    };
                                }
                            }
                            var textareaCoverCSS = {};
                            var setContentGlueElementCSSfunction = function(horizontal) {
                                var scrollbarVars = getScrollbarVars(horizontal);
                                var wh = scrollbarVars._w_h;
                                var strWH = scrollbarVars._width_height;
                                var autoSize = horizontal ? widthAuto : heightAuto;
                                var borderSize = horizontal ? _borderX : _borderY;
                                var paddingSize = horizontal ? _paddingX : _paddingY;
                                var marginSize = horizontal ? _marginX : _marginY;
                                var maxSize = contentGlueElementCSS[strWH] + (_isBorderBox ? borderSize : -paddingSize);

                                //make contentGlue size -1 if element is not auto sized, to make sure that a resize event happens when the element shrinks
                                if (!autoSize || (!autoSize && border.c))
                                    contentGlueElementCSS[strWH] = hostSize[wh] - (_isBorderBox ? 0 : paddingSize + borderSize) - 1 - marginSize;

                                //if size is auto and host is same size as max size, make content glue size +1 to make sure size changes will be detected
                                if (autoSize && cssMaxValue['c' + wh] && cssMaxValue['i' + wh] === maxSize)
                                    contentGlueElementCSS[strWH] = maxSize + (_isBorderBox ? 0 : paddingSize) + 1;

                                //if size is auto and host is smaller than size as min size, make content glue size -1 to make sure size changes will be detected (this is only needed if padding is 0)
                                if (autoSize && (contentSize[wh] < _viewportSize[wh]) && (horizontal ? (_isTextarea ? !textareaAutoWrapping : false) : true)) {
                                    if (_isTextarea)
                                        textareaCoverCSS[strWH] = parseToZeroOrNumber(_textareaCoverElement.css(strWH)) - 1;
                                    contentGlueElementCSS[strWH] -= 1;
                                }

                                //make sure content glue size is at least 1
                                if (contentSize[wh] > 0)
                                    contentGlueElementCSS[strWH] = MATH.max(1, contentGlueElementCSS[strWH]);
                            };
                            setContentGlueElementCSSfunction(true);
                            setContentGlueElementCSSfunction(false);

                            if (_isTextarea)
                                _textareaCoverElement.css(textareaCoverCSS);
                            _contentGlueElement.css(contentGlueElementCSS);
                        }
                        if (widthAuto)
                            contentElementCSS[_strWidth] = _strHundredPercent;
                        if (widthAuto && !_isBorderBox && !_mutationObserversConnected)
                            contentElementCSS[_strFloat] = 'none';

                        //apply and reset content style
                        _contentElement.css(contentElementCSS);
                        contentElementCSS = {};

                        //measure again, but this time all correct sizes:
                        var contentScrollSize = {
                            w: MATH.max(contentMeasureElement[LEXICON.sW], contentMeasureElementGuaranty[LEXICON.sW]),
                            h: MATH.max(contentMeasureElement[LEXICON.sH], contentMeasureElementGuaranty[LEXICON.sH])
                        };
                        contentScrollSize.c = contentSizeChanged = checkCacheAutoForce(contentScrollSize, _contentScrollSizeCache);
                        _contentScrollSizeCache = contentScrollSize;

                        //remove overflow hidden to restore overflow
                        if(hideOverflow4CorrectMeasuring)
                            _contentElement.css(strOverflow, _strEmpty);
                        
                        //refresh viewport size after correct measuring
                        _viewportSize = getViewportSize();

                        hostSize = getHostSize();
                        hostSizeChanged = checkCacheAutoForce(hostSize, _hostSizeCache);
                        _hostSizeCache = hostSize;

                        var hideOverflowForceTextarea = _isTextarea && (_viewportSize.w === 0 || _viewportSize.h === 0);
                        var previousOverflow = _overflowAmountCache;
                        var overflowBehaviorIsVS = { };
                        var overflowBehaviorIsVH = { };
                        var overflowBehaviorIsS = { };
                        var overflowAmount = { };
                        var hasOverflow = { };
                        var hideOverflow = { };
                        var canScroll = { };
                        var viewportRect = _paddingElementNative.getBoundingClientRect();
                        var setOverflowVariables = function(horizontal) {
                            var scrollbarVars = getScrollbarVars(horizontal);
                            var scrollbarVarsInverted = getScrollbarVars(!horizontal);
                            var xyI = scrollbarVarsInverted._x_y;
                            var xy = scrollbarVars._x_y;
                            var wh = scrollbarVars._w_h;
                            var widthHeight = scrollbarVars._width_height;
                            var scrollMax = _strScroll + scrollbarVars._Left_Top + 'Max';
                            var fractionalOverflowAmount = viewportRect[widthHeight] ? MATH.abs(viewportRect[widthHeight] - _viewportSize[wh]) : 0;
                            overflowBehaviorIsVS[xy] = overflowBehavior[xy] === 'v-s';
                            overflowBehaviorIsVH[xy] = overflowBehavior[xy] === 'v-h';
                            overflowBehaviorIsS[xy] = overflowBehavior[xy] === 's';
                            overflowAmount[xy] = MATH.max(0, MATH.round((contentScrollSize[wh] - _viewportSize[wh]) * 100) / 100);
                            overflowAmount[xy] *= (hideOverflowForceTextarea || (_viewportElementNative[scrollMax] === 0 && fractionalOverflowAmount > 0 && fractionalOverflowAmount < 1)) ? 0 : 1;
                            hasOverflow[xy] = overflowAmount[xy] > 0;

                            //hideOverflow:
                            //x || y : true === overflow is hidden by "overflow: scroll" OR "overflow: hidden"
                            //xs || ys : true === overflow is hidden by "overflow: scroll"
                            hideOverflow[xy] = overflowBehaviorIsVS[xy] || overflowBehaviorIsVH[xy] ? (hasOverflow[xyI] && !overflowBehaviorIsVS[xyI] && !overflowBehaviorIsVH[xyI]) : hasOverflow[xy];
                            hideOverflow[xy + 's'] = hideOverflow[xy] ? (overflowBehaviorIsS[xy] || overflowBehaviorIsVS[xy]) : false;

                            canScroll[xy] = hasOverflow[xy] && hideOverflow[xy + 's'];
                        };
                        setOverflowVariables(true);
                        setOverflowVariables(false);

                        overflowAmount.c = checkCacheAutoForce(overflowAmount, _overflowAmountCache);
                        _overflowAmountCache = overflowAmount;
                        hasOverflow.c = checkCacheAutoForce(hasOverflow, _hasOverflowCache);
                        _hasOverflowCache = hasOverflow;
                        hideOverflow.c = checkCacheAutoForce(hideOverflow, _hideOverflowCache);
                        _hideOverflowCache = hideOverflow;

                        //if native scrollbar is overlay at x OR y axis, prepare DOM
                        if (_nativeScrollbarIsOverlaid.x || _nativeScrollbarIsOverlaid.y) {
                            var borderDesign = 'px solid transparent';
                            var contentArrangeElementCSS = { };
                            var arrangeContent = { };
                            var arrangeChanged = force;
                            var setContentElementCSS;

                            if (hasOverflow.x || hasOverflow.y) {
                                arrangeContent.w = _nativeScrollbarIsOverlaid.y && hasOverflow.y ? contentScrollSize.w + _overlayScrollbarDummySize.y : _strEmpty;
                                arrangeContent.h = _nativeScrollbarIsOverlaid.x && hasOverflow.x ? contentScrollSize.h + _overlayScrollbarDummySize.x : _strEmpty;
                                arrangeChanged = checkCacheAutoForce(arrangeContent, _arrangeContentSizeCache);
                                _arrangeContentSizeCache = arrangeContent;
                            }

                            if (hasOverflow.c || hideOverflow.c || contentScrollSize.c || cssDirectionChanged || widthAutoChanged || heightAutoChanged || widthAuto || heightAuto || ignoreOverlayScrollbarHidingChanged) {
                                contentElementCSS[_strMarginMinus + isRTLRight] = contentElementCSS[_strBorderMinus + isRTLRight] = _strEmpty;
                                setContentElementCSS = function(horizontal) {
                                    var scrollbarVars = getScrollbarVars(horizontal);
                                    var scrollbarVarsInverted = getScrollbarVars(!horizontal);
                                    var xy = scrollbarVars._x_y;
                                    var strDirection = horizontal ? _strBottom : isRTLLeft;
                                    var invertedAutoSize = horizontal ? heightAuto : widthAuto;

                                    if (_nativeScrollbarIsOverlaid[xy] && hasOverflow[xy] && hideOverflow[xy + 's']) {
                                        contentElementCSS[_strMarginMinus + strDirection] = invertedAutoSize ? (ignoreOverlayScrollbarHiding ? _strEmpty : _overlayScrollbarDummySize[xy]) : _strEmpty;
                                        contentElementCSS[_strBorderMinus + strDirection] = ((horizontal ? !invertedAutoSize : true) && !ignoreOverlayScrollbarHiding) ? (_overlayScrollbarDummySize[xy] + borderDesign) : _strEmpty;
                                    }
                                    else {
                                        arrangeContent[scrollbarVarsInverted._w_h] =
                                        contentElementCSS[_strMarginMinus + strDirection] =
                                        contentElementCSS[_strBorderMinus + strDirection] = _strEmpty;
                                        arrangeChanged = true;
                                    }
                                };

                                if (_nativeScrollbarStyling) {
                                    if (ignoreOverlayScrollbarHiding) 
                                        removeClass(_viewportElement, _classNameViewportNativeScrollbarsInvisible);
                                    else
                                        addClass(_viewportElement, _classNameViewportNativeScrollbarsInvisible);
                                }
                                else {
                                    setContentElementCSS(true);
                                    setContentElementCSS(false);
                                }
                            }
                            if (ignoreOverlayScrollbarHiding) {
                                arrangeContent.w = arrangeContent.h = _strEmpty;
                                arrangeChanged = true;
                            }
                            if (arrangeChanged && !_nativeScrollbarStyling) {
                                contentArrangeElementCSS[_strWidth] = hideOverflow.y ? arrangeContent.w : _strEmpty;
                                contentArrangeElementCSS[_strHeight] = hideOverflow.x ? arrangeContent.h : _strEmpty;

                                if (!_contentArrangeElement) {
                                    _contentArrangeElement = FRAMEWORK(generateDiv(_classNameContentArrangeElement));
                                    _viewportElement.prepend(_contentArrangeElement);
                                }
                                _contentArrangeElement.css(contentArrangeElementCSS);
                            }
                            _contentElement.css(contentElementCSS);
                        }

                        var viewportElementCSS = {};
                        var paddingElementCSS = {};
                        var setViewportCSS;
                        if (hostSizeChanged || hasOverflow.c || hideOverflow.c || contentScrollSize.c || overflowBehaviorChanged || boxSizingChanged || ignoreOverlayScrollbarHidingChanged || cssDirectionChanged || clipAlwaysChanged || heightAutoChanged) {
                            viewportElementCSS[isRTLRight] = _strEmpty;
                            setViewportCSS = function(horizontal) {
                                var scrollbarVars = getScrollbarVars(horizontal);
                                var scrollbarVarsInverted = getScrollbarVars(!horizontal);
                                var xy = scrollbarVars._x_y;
                                var XY = scrollbarVars._X_Y;
                                var strDirection = horizontal ? _strBottom : isRTLLeft;

                                var reset = function () {
                                    viewportElementCSS[strDirection] = _strEmpty;
                                    _contentBorderSize[scrollbarVarsInverted._w_h] = 0;
                                };
                                if (hasOverflow[xy] && hideOverflow[xy + 's']) {
                                    viewportElementCSS[strOverflow + XY] = _strScroll;
                                    if (ignoreOverlayScrollbarHiding || _nativeScrollbarStyling) {
                                        reset();
                                    }
                                    else {
                                        viewportElementCSS[strDirection] =  -(_nativeScrollbarIsOverlaid[xy] ? _overlayScrollbarDummySize[xy] : _nativeScrollbarSize[xy]);
                                        _contentBorderSize[scrollbarVarsInverted._w_h] = _nativeScrollbarIsOverlaid[xy] ? _overlayScrollbarDummySize[scrollbarVarsInverted._x_y] : 0;
                                    }
                                } else {
                                    viewportElementCSS[strOverflow + XY] = _strEmpty;
                                    reset();
                                }
                            };
                            setViewportCSS(true);
                            setViewportCSS(false);
                            
                            // if the scroll container is too small and if there is any overflow with no overlay scrollbar (and scrollbar styling isn't possible), 
                            // make viewport element greater in size (Firefox hide Scrollbars fix)
                            // because firefox starts hiding scrollbars on too small elements
                            // with this behavior the overflow calculation may be incorrect or the scrollbars would appear suddenly
                            // https://bugzilla.mozilla.org/show_bug.cgi?id=292284
                            if (!_nativeScrollbarStyling 
                                && (_viewportSize.h < _nativeScrollbarMinSize.x || _viewportSize.w < _nativeScrollbarMinSize.y)
                                && ((hasOverflow.x && hideOverflow.x && !_nativeScrollbarIsOverlaid.x) || (hasOverflow.y && hideOverflow.y && !_nativeScrollbarIsOverlaid.y))) {
                                viewportElementCSS[_strPaddingMinus + _strTop] = _nativeScrollbarMinSize.x;
                                viewportElementCSS[_strMarginMinus + _strTop] = -_nativeScrollbarMinSize.x;

                                viewportElementCSS[_strPaddingMinus + isRTLRight] = _nativeScrollbarMinSize.y;
                                viewportElementCSS[_strMarginMinus + isRTLRight] = -_nativeScrollbarMinSize.y;
                            }
                            else {
                                viewportElementCSS[_strPaddingMinus + _strTop] =
                                viewportElementCSS[_strMarginMinus + _strTop] =
                                viewportElementCSS[_strPaddingMinus + isRTLRight] =
                                viewportElementCSS[_strMarginMinus + isRTLRight] = _strEmpty;
                            }
                            viewportElementCSS[_strPaddingMinus + isRTLLeft] =
                            viewportElementCSS[_strMarginMinus + isRTLLeft] = _strEmpty;

                            //if there is any overflow (x OR y axis) and this overflow shall be hidden, make overflow hidden, else overflow visible
                            if ((hasOverflow.x && hideOverflow.x) || (hasOverflow.y && hideOverflow.y) || hideOverflowForceTextarea) {
                                //only hide if is Textarea
                                if (_isTextarea && hideOverflowForceTextarea) {
                                    paddingElementCSS[strOverflowX] =
                                    paddingElementCSS[strOverflowY] = strHidden;
                                }
                            }
                            else {
                                if (!clipAlways || (overflowBehaviorIsVH.x || overflowBehaviorIsVS.x || overflowBehaviorIsVH.y || overflowBehaviorIsVS.y)) {
                                    //only un-hide if Textarea
                                    if (_isTextarea) {
                                        paddingElementCSS[strOverflowX] =
                                        paddingElementCSS[strOverflowY] = _strEmpty;
                                    }
                                    viewportElementCSS[strOverflowX] =
                                    viewportElementCSS[strOverflowY] = strVisible;
                                }
                            }

                            _paddingElement.css(paddingElementCSS);
                            _viewportElement.css(viewportElementCSS);
                            viewportElementCSS = { };

                            //force soft redraw in webkit because without the scrollbars will may appear because DOM wont be redrawn under special conditions
                            if ((hasOverflow.c || boxSizingChanged || widthAutoChanged || heightAutoChanged) && !(_nativeScrollbarIsOverlaid.x && _nativeScrollbarIsOverlaid.y)) {
                                var elementStyle = _contentElementNative[LEXICON.s];
                                var dump;
                                elementStyle.webkitTransform = 'scale(1)';
                                elementStyle.display = 'run-in';
                                dump = _contentElementNative[LEXICON.oH];
                                elementStyle.display = _strEmpty; //|| dump; //use dump to prevent it from deletion if minify
                                elementStyle.webkitTransform = _strEmpty;
                            }
                            /*
                            //force hard redraw in webkit if native overlaid scrollbars shall appear
                            if (ignoreOverlayScrollbarHidingChanged && ignoreOverlayScrollbarHiding) {
                                _hostElement.hide();
                                var dump = _hostElementNative[LEXICON.oH];
                                _hostElement.show();
                            }
                            */
                        }

                        //change to direction RTL and width auto Bugfix in Webkit
                        //without this fix, the DOM still thinks the scrollbar is LTR and thus the content is shifted to the left
                        contentElementCSS = {};
                        if (cssDirectionChanged || widthAutoChanged || heightAutoChanged) {
                            if (_isRTL && widthAuto) {
                                var floatTmp = _contentElement.css(_strFloat);
                                var posLeftWithoutFloat = MATH.round(_contentElement.css(_strFloat, _strEmpty).css(_strLeft, _strEmpty).position().left);
                                _contentElement.css(_strFloat, floatTmp);
                                var posLeftWithFloat = MATH.round(_contentElement.position().left);

                                if (posLeftWithoutFloat !== posLeftWithFloat)
                                    contentElementCSS[_strLeft] = posLeftWithoutFloat;
                            }
                            else {
                                contentElementCSS[_strLeft] = _strEmpty;
                            }
                        }
                        _contentElement.css(contentElementCSS);

                        //handle scroll position
                        if (_isTextarea && contentSizeChanged) {
                            var textareaInfo = getTextareaInfo();
                            if (textareaInfo) {
                                var textareaRowsChanged = _textareaInfoCache === undefined ? true : textareaInfo._rows !== _textareaInfoCache._rows;
                                var cursorRow = textareaInfo._cursorRow;
                                var cursorCol = textareaInfo._cursorColumn;
                                var widestRow = textareaInfo._widestRow;
                                var lastRow = textareaInfo._rows;
                                var lastCol = textareaInfo._columns;
                                var cursorPos = textareaInfo._cursorPosition;
                                var cursorMax = textareaInfo._cursorMax;
                                var cursorIsLastPosition = (cursorPos >= cursorMax && _textareaHasFocus);
                                var textareaScrollAmount = {
                                    x: (!textareaAutoWrapping && (cursorCol === lastCol && cursorRow === widestRow)) ? _overflowAmountCache.x : -1,
                                    y: (textareaAutoWrapping ? cursorIsLastPosition || textareaRowsChanged && (previousOverflow !== undefined ? (currScroll.y === previousOverflow.y) : false) : (cursorIsLastPosition || textareaRowsChanged) && cursorRow === lastRow) ? _overflowAmountCache.y : -1
                                };
                                currScroll.x = textareaScrollAmount.x > -1 ? (_isRTL && _normalizeRTLCache && _rtlScrollBehavior.i ? 0 : textareaScrollAmount.x) : currScroll.x; //if inverted, scroll to 0 -> normalized this means to max scroll offset.
                                currScroll.y = textareaScrollAmount.y > -1 ? textareaScrollAmount.y : currScroll.y;
                            }
                            _textareaInfoCache = textareaInfo;
                        }
                        if (_isRTL && _rtlScrollBehavior.i && _nativeScrollbarIsOverlaid.y && hasOverflow.x && _normalizeRTLCache)
                            currScroll.x += _contentBorderSize.w || 0;
                        if(widthAuto)
                            _hostElement[_strScrollLeft](0);
                        if(heightAuto)
                            _hostElement[_strScrollTop](0);
                        _viewportElement[_strScrollLeft](currScroll.x)[_strScrollTop](currScroll.y);

                        //scrollbars management:
                        var scrollbarsVisibilityVisible = scrollbarsVisibility === 'v';
                        var scrollbarsVisibilityHidden = scrollbarsVisibility === 'h';
                        var scrollbarsVisibilityAuto = scrollbarsVisibility === 'a';

                        var showScrollbarH = COMPATIBILITY.bind(refreshScrollbarAppearance, 0, true, true, canScroll.x);
                        var showScrollbarV = COMPATIBILITY.bind(refreshScrollbarAppearance, 0, false, true, canScroll.y);
                        var hideScrollbarH = COMPATIBILITY.bind(refreshScrollbarAppearance, 0, true, false, canScroll.x);
                        var hideScrollbarV = COMPATIBILITY.bind(refreshScrollbarAppearance, 0, false, false, canScroll.y);

                        //manage class name which indicates scrollable overflow
                        if (hideOverflow.x || hideOverflow.y)
                            addClass(_hostElement, _classNameHostOverflow);
                        else
                            removeClass(_hostElement, _classNameHostOverflow);
                        if (hideOverflow.x)
                            addClass(_hostElement, _classNameHostOverflowX);
                        else
                            removeClass(_hostElement, _classNameHostOverflowX);
                        if (hideOverflow.y)
                            addClass(_hostElement, _classNameHostOverflowY);
                        else
                            removeClass(_hostElement, _classNameHostOverflowY);

                        //add or remove rtl class name for styling purposes
                        if (cssDirectionChanged) {
                            if (_isRTL)
                                addClass(_hostElement, _classNameHostRTL);
                            else
                                removeClass(_hostElement, _classNameHostRTL);
                        }

                        //manage the resize feature (CSS3 resize "polyfill" for this plugin)
                        if (_isBody)
                            addClass(_hostElement, _classNameHostResizeDisabled);
                        if (resizeChanged) {
                            var setupCornerEvents = function(remove) {
                                if(_supportPassiveEvents)
                                    setupPassiveEventListener(_scrollbarCornerElement, _strMouseTouchDownEvent, _resizeOnMouseTouchDown, remove, true);
                                else
                                    _scrollbarCornerElement[remove ? 'off' : 'on'](_strMouseTouchDownEvent, _resizeOnMouseTouchDown);
                            };
                            removeClass(_scrollbarCornerElement, [
                                    _classNameHostResizeDisabled,
                                    _classNameScrollbarCornerResize,
                                    _classNameScrollbarCornerResizeB,
                                    _classNameScrollbarCornerResizeH,
                                    _classNameScrollbarCornerResizeV].join(_strSpace));
                            if (_resizeNone) {
                                addClass(_hostElement, _classNameHostResizeDisabled);
                                setupCornerEvents(true);
                            }
                            else {
                                addClass(_scrollbarCornerElement, _classNameScrollbarCornerResize);
                                if (_resizeBoth)
                                    addClass(_scrollbarCornerElement, _classNameScrollbarCornerResizeB);
                                else if (_resizeHorizontal)
                                    addClass(_scrollbarCornerElement, _classNameScrollbarCornerResizeH);
                                else if (_resizeVertical)
                                    addClass(_scrollbarCornerElement, _classNameScrollbarCornerResizeV);

                                setupCornerEvents(true);
                                setupCornerEvents();
                            }
                        }

                        //manage the scrollbars general visibility + the scrollbar interactivity (unusable class name)
                        if (scrollbarsVisibilityChanged || overflowBehaviorChanged || hideOverflow.c || hasOverflow.c || ignoreOverlayScrollbarHidingChanged) {
                            if (ignoreOverlayScrollbarHiding) {
                                if (ignoreOverlayScrollbarHidingChanged) {
                                    removeClass(_hostElement, _classNameHostScrolling);
                                    if (ignoreOverlayScrollbarHiding) {
                                        hideScrollbarH();
                                        hideScrollbarV();
                                    }
                                }
                            }
                            else if (scrollbarsVisibilityAuto) {
                                if (canScroll.x)
                                    showScrollbarH();
                                else
                                    hideScrollbarH();

                                if (canScroll.y)
                                    showScrollbarV();
                                else
                                    hideScrollbarV();
                            }
                            else if (scrollbarsVisibilityVisible) {
                                showScrollbarH();
                                showScrollbarV();
                            }
                            else if (scrollbarsVisibilityHidden) {
                                hideScrollbarH();
                                hideScrollbarV();
                            }
                        }

                        //manage the scrollbars auto hide feature (auto hide them after specific actions)
                        if (scrollbarsAutoHideChanged || ignoreOverlayScrollbarHidingChanged) {
                            if (_scrollbarsAutoHideLeave || _scrollbarsAutoHideMove) {
                                setupHostMouseTouchEvents(true);
                                setupHostMouseTouchEvents();
                            }
                            else {
                                setupHostMouseTouchEvents(true);
                            }

                            if (_scrollbarsAutoHideNever)
                                refreshScrollbarsAutoHide(true);
                            else
                                refreshScrollbarsAutoHide(false, true);
                        }

                        //manage scrollbars handle length & offset - don't remove!
                        if (hostSizeChanged || overflowAmount.c || heightAutoChanged || widthAutoChanged || resizeChanged || boxSizingChanged || paddingAbsoluteChanged || ignoreOverlayScrollbarHidingChanged || cssDirectionChanged) {
                            refreshScrollbarHandleLength(true);
                            refreshScrollbarHandleOffset(true);
                            refreshScrollbarHandleLength(false);
                            refreshScrollbarHandleOffset(false);
                        }

                        //manage interactivity
                        if (scrollbarsClickScrollingChanged)
                            refreshScrollbarsInteractive(true, scrollbarsClickScrolling);
                        if (scrollbarsDragScrollingChanged)
                            refreshScrollbarsInteractive(false, scrollbarsDragScrolling);

                        //callbacks:
                        if (cssDirectionChanged) {
                            dispatchCallback("onDirectionChanged", {
                                isRTL: _isRTL,
                                dir: cssDirection
                            });
                        }
                        if (hostSizeChanged) {
                            dispatchCallback("onHostSizeChanged", {
                                width: _hostSizeCache.w,
                                height: _hostSizeCache.h
                            });
                        }
                        if (contentSizeChanged) {
                            dispatchCallback("onContentSizeChanged", {
                                width: _contentScrollSizeCache.w,
                                height: _contentScrollSizeCache.h
                            });
                        }
                        if (hasOverflow.c || hideOverflow.c) {
                            dispatchCallback("onOverflowChanged", {
                                x: hasOverflow.x,
                                y: hasOverflow.y,
                                xScrollable: hideOverflow.xs,
                                yScrollable: hideOverflow.ys,
                                clipped: hideOverflow.x || hideOverflow.y
                            });
                        }
                        if (overflowAmount.c) {
                            dispatchCallback("onOverflowAmountChanged", {
                                x: overflowAmount.x,
                                y: overflowAmount.y
                            });
                        }
                    }

                    //fix body min size
                    if (_isBody && _bodyMinSizeCache && (_hasOverflowCache.c || _bodyMinSizeCache.c)) {
                        //its possible that no min size was measured until now, because the content arrange element was just added now, in this case, measure now the min size.
                        if (!_bodyMinSizeCache.f)
                            bodyMinSizeChanged();
                        if (_nativeScrollbarIsOverlaid.y && _hasOverflowCache.x)
                            _contentElement.css(_strMinMinus + _strWidth, _bodyMinSizeCache.w + _overlayScrollbarDummySize.y);
                        if (_nativeScrollbarIsOverlaid.x && _hasOverflowCache.y)
                            _contentElement.css(_strMinMinus + _strHeight, _bodyMinSizeCache.h + _overlayScrollbarDummySize.x);
                        _bodyMinSizeCache.c = false;
                    }

                    //freezeResizeObserver(_sizeObserverElement, false);
                    //freezeResizeObserver(_sizeAutoObserverElement, false);

                    dispatchCallback("onUpdated", { forced: force });
                }

                
                //==== Options ====//

                /**
                 * Sets new options but doesn't call the update method.
                 * @param newOptions The object which contains the new options.
                 * @returns {*} A object which contains the changed options.
                 */
                function setOptions(newOptions) {
                    var validatedOpts = _pluginsOptions._validate(newOptions, _pluginsOptions._template, true, _currentOptions)

                    _currentOptions = extendDeep({}, _currentOptions, validatedOpts._default);
                    _currentPreparedOptions = extendDeep({}, _currentPreparedOptions, validatedOpts._prepared);
                    
                    return validatedOpts._prepared;
                }


                //==== Structure ====//

                /**
                 * Builds or destroys the wrapper and helper DOM elements.
                 * @param destroy Indicates whether the DOM shall be build or destroyed.
                 */
                function setupStructureDOM(destroy) {
                    var adoptAttrs = _currentPreparedOptions.textarea.inheritedAttrs;
                    var adoptAttrsMap = { };
                    var applyAdoptedAttrs = function() {
                        var applyAdoptedAttrsElm = destroy ? _targetElement : _hostElement;
                        each(adoptAttrsMap, function(k, v) {
                            if(type(v) == TYPES.s) {
                                if(k == LEXICON.c)
                                    applyAdoptedAttrsElm.addClass(v);
                                else
                                    applyAdoptedAttrsElm.attr(k, v);
                            }
                        });
                    };
                    var hostElementClassNames = [
                        _classNameHostElement,
                        _classNameHostTextareaElement,
                        _classNameHostResizeDisabled,
                        _classNameHostRTL,
                        _classNameHostScrollbarHorizontalHidden,
                        _classNameHostScrollbarVerticalHidden,
                        _classNameHostTransition,
                        _classNameHostScrolling,
                        _classNameHostOverflow,
                        _classNameHostOverflowX,
                        _classNameHostOverflowY,
                        _classNameThemeNone,
                        _classNameTextareaElement,
                        _classNameTextInherit,
                        _classNameCache].join(_strSpace);
                    adoptAttrs = type(adoptAttrs) == TYPES.s ? adoptAttrs.split(' ') : adoptAttrs;
                    if(type(adoptAttrs) == TYPES.a) {
                        each(adoptAttrs, function(i, v) {
                            if(type(v) == TYPES.s)
                                adoptAttrsMap[v] = destroy ? _hostElement.attr(v) : _targetElement.attr(v);
                        });
                    }

                    if(!destroy) {
                        if (_isTextarea) {
                            var hostElementCSS = {};
                            var parent = _targetElement.parent();
                            _isTextareaHostGenerated = !(parent.hasClass(_classNameHostTextareaElement) && parent.children()[LEXICON.l] === 1);

                            if (!_currentPreparedOptions.sizeAutoCapable) {
                                hostElementCSS[_strWidth] = _targetElement.css(_strWidth);
                                hostElementCSS[_strHeight] = _targetElement.css(_strHeight);
                            }
                            if(_isTextareaHostGenerated)
                                _targetElement.wrap(generateDiv(_classNameHostTextareaElement));

                            _hostElement = _targetElement.parent();
                            _hostElement.css(hostElementCSS)
                                .wrapInner(generateDiv(_classNameContentElement + _strSpace + _classNameTextInherit))
                                .wrapInner(generateDiv(_classNameViewportElement + _strSpace + _classNameTextInherit))
                                .wrapInner(generateDiv(_classNamePaddingElement + _strSpace + _classNameTextInherit));
                            _contentElement = findFirst(_hostElement, _strDot + _classNameContentElement);
                            _viewportElement = findFirst(_hostElement, _strDot + _classNameViewportElement);
                            _paddingElement = findFirst(_hostElement, _strDot + _classNamePaddingElement);
                            _textareaCoverElement = FRAMEWORK(generateDiv(_classNameTextareaCoverElement));
                            _contentElement.prepend(_textareaCoverElement);

                            addClass(_targetElement, _classNameTextareaElement + _strSpace + _classNameTextInherit);

                            if(_isTextareaHostGenerated)
                                applyAdoptedAttrs();
                        }
                        else {
                            _hostElement = _targetElement;
                            _hostElement.wrapInner(generateDiv(_classNameContentElement))
                                .wrapInner(generateDiv(_classNameViewportElement))
                                .wrapInner(generateDiv(_classNamePaddingElement));
                            _contentElement = findFirst(_hostElement, _strDot + _classNameContentElement);
                            _viewportElement = findFirst(_hostElement, _strDot + _classNameViewportElement);
                            _paddingElement = findFirst(_hostElement, _strDot + _classNamePaddingElement);

                            addClass(_targetElement, _classNameHostElement);
                        }
                        
                        if (_nativeScrollbarStyling)
                            addClass(_viewportElement, _classNameViewportNativeScrollbarsInvisible);
                        if(_nativeScrollbarIsOverlaid.x && _nativeScrollbarIsOverlaid.y)
                            addClass(_viewportElement, _classNameViewportNativeScrollbarsOverlaid);
                        if (_isBody)
                            addClass(_htmlElement, _classNameHTMLElement);

                        _sizeObserverElement = FRAMEWORK(generateDiv('os-resize-observer-host'));
                        _hostElement.prepend(_sizeObserverElement);

                        _sizeObserverElementNative = _sizeObserverElement[0];
                        _hostElementNative = _hostElement[0];
                        _paddingElementNative = _paddingElement[0];
                        _viewportElementNative = _viewportElement[0];
                        _contentElementNative = _contentElement[0];
                    }
                    else {
                        _contentElement.contents()
                            .unwrap()
                            .unwrap()
                            .unwrap();

                        removeClass(_hostElement, hostElementClassNames);
                        if (_isTextarea) {
                            _targetElement.removeAttr(LEXICON.s);

                            if(_isTextareaHostGenerated)
                                applyAdoptedAttrs();

                            removeClass(_targetElement, hostElementClassNames);
                            remove(_textareaCoverElement);

                            if(_isTextareaHostGenerated) {
                                _targetElement.unwrap();
                                remove(_hostElement);
                            }
                            else {
                                addClass(_hostElement, _classNameHostTextareaElement);
                            }
                        }
                        else {
                            removeClass(_targetElement, _classNameHostElement);
                        }

                        if (_isBody)
                            removeClass(_htmlElement, _classNameHTMLElement);

                        remove(_sizeObserverElement);
                    }
                }

                /**
                 * Adds or removes all wrapper elements interactivity events.
                 * @param destroy Indicates whether the Events shall be added or removed.
                 */
                function setupStructureEvents(destroy) {
                    var textareaKeyDownRestrictedKeyCodes = [
                        112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 123,    //F1 to F12
                        33, 34,                                                   //page up, page down
                        37, 38, 39, 40,                                           //left, up, right, down arrows
                        16, 17, 18, 19, 20, 144                                   //Shift, Ctrl, Alt, Pause, CapsLock, NumLock
                    ];
                    var textareaKeyDownKeyCodesList = [ ];
                    var textareaUpdateIntervalID;
                    var scrollStopDelay = 175;
                    var scrollStopTimeoutId;
                    var strOnOff = destroy ? 'off' : 'on';
                    var updateTextarea;
                    var viewportOnScroll;

                    if(!destroy && _isTextarea) {
                        _textareaEvents = { };
                        updateTextarea = function(doClearInterval) {
                            textareaUpdate();
                            _base.update(_strAuto);
                            if(doClearInterval)
                                clearInterval(textareaUpdateIntervalID);
                        };
                        _textareaEvents[_strScroll] = function(event) {
                            _targetElement[_strScrollLeft](_rtlScrollBehavior.i && _normalizeRTLCache ? 9999999 : 0);
                            _targetElement[_strScrollTop](0);
                            COMPATIBILITY.prvD(event);
                            COMPATIBILITY.stpP(event);
                            return false;
                        };
                        _textareaEvents['drop'] = function() {
                            setTimeout(function () {
                                if(!_destroyed)
                                    updateTextarea();
                            }, 50);
                        };
                        _textareaEvents['focus'] = function() {
                            _textareaHasFocus = true;
                        };
                        _textareaEvents['focusout'] = function() {
                            _textareaHasFocus = false;
                            textareaKeyDownKeyCodesList = [ ];
                            updateTextarea(true);
                        };
                        if (_msieVersion > 9 || !_autoUpdateRecommended) {
                            _textareaEvents['input'] = function textareaOnInput() {
                                updateTextarea();
                            }
                        }
                        else {
                            _textareaEvents[_strKeyDownEvent] = function textareaOnKeyDown(event) {
                                var keyCode = event.keyCode;
                                if (inArray(keyCode, textareaKeyDownRestrictedKeyCodes) > -1)
                                    return;
                                if (!textareaKeyDownKeyCodesList.length) {
                                    updateTextarea();
                                    textareaUpdateIntervalID = setInterval(updateTextarea, 1000 / 60);
                                }
                                if (inArray(keyCode, textareaKeyDownKeyCodesList) === -1)
                                    textareaKeyDownKeyCodesList.push(keyCode);
                            };
                            _textareaEvents[_strKeyUpEvent] = function(event) {
                                var keyCode = event.keyCode;
                                var index = inArray(keyCode, textareaKeyDownKeyCodesList);

                                if (inArray(keyCode, textareaKeyDownRestrictedKeyCodes) > -1)
                                    return;
                                if (index > -1)
                                    textareaKeyDownKeyCodesList.splice(index, 1);
                                if (!textareaKeyDownKeyCodesList.length)
                                    updateTextarea(true);
                            };
                        }
                    }

                    if (_isTextarea) {
                        each(_textareaEvents, function(key, value) {
                            _targetElement[strOnOff](key, value);
                        });
                    }
                    else {
                        _contentElement[strOnOff](_strTransitionEndEvent, function (event) {
                            if (_autoUpdateCache === true)
                                return;
                            event = event.originalEvent || event;
                            if (isSizeAffectingCSSProperty(event.propertyName))
                                _base.update(_strAuto);
                        });
                    }

                    if(!destroy) {
                        viewportOnScroll = function(event) {
                            if (!_sleeping) {
                                if (scrollStopTimeoutId !== undefined)
                                    clearTimeout(scrollStopTimeoutId);
                                else {
                                    if (_scrollbarsAutoHideScroll || _scrollbarsAutoHideMove)
                                        refreshScrollbarsAutoHide(true);

                                    if (!nativeOverlayScrollbarsAreActive())
                                        addClass(_hostElement, _classNameHostScrolling);

                                    dispatchCallback("onScrollStart", event);
                                }

                                //if a scrollbars handle gets dragged, the mousemove event is responsible for refreshing the handle offset
                                //because if CSS scroll-snap is used, the handle offset gets only refreshed on every snap point
                                //this looks laggy & clunky, it looks much better if the offset refreshes with the mousemove
                                if(!_scrollbarsHandlesDefineScrollPos) {
                                    refreshScrollbarHandleOffset(true);
                                    refreshScrollbarHandleOffset(false);
                                }
                                dispatchCallback("onScroll", event);

                                scrollStopTimeoutId = setTimeout(function () {
                                    if(!_destroyed) {
                                        //OnScrollStop:
                                        clearTimeout(scrollStopTimeoutId);
                                        scrollStopTimeoutId = undefined;

                                        if (_scrollbarsAutoHideScroll || _scrollbarsAutoHideMove)
                                            refreshScrollbarsAutoHide(false);

                                        if (!nativeOverlayScrollbarsAreActive())
                                            removeClass(_hostElement, _classNameHostScrolling);

                                        dispatchCallback("onScrollStop", event);
                                    }
                                }, scrollStopDelay);
                            }
                        };

                        if (_supportPassiveEvents)
                            setupPassiveEventListener(_viewportElement, _strScroll, viewportOnScroll);
                        else
                            _viewportElement.on(_strScroll, viewportOnScroll);
                    }
                }



                //==== Scrollbars ====//

                /**
                 * Builds or destroys all scrollbar DOM elements (scrollbar, track, handle)
                 * @param destroy Indicates whether the DOM shall be build or destroyed.
                 */
                function setupScrollbarsDOM(destroy) {
                    if(!destroy) {
                        _scrollbarHorizontalElement = FRAMEWORK(generateDiv(_classNameScrollbar + _strSpace + _classNameScrollbarHorizontal));
                        _scrollbarHorizontalTrackElement = FRAMEWORK(generateDiv(_classNameScrollbarTrack));
                        _scrollbarHorizontalHandleElement = FRAMEWORK(generateDiv(_classNameScrollbarHandle));
                        _scrollbarVerticalElement = FRAMEWORK(generateDiv(_classNameScrollbar + _strSpace + _classNameScrollbarVertical));
                        _scrollbarVerticalTrackElement = FRAMEWORK(generateDiv(_classNameScrollbarTrack));
                        _scrollbarVerticalHandleElement = FRAMEWORK(generateDiv(_classNameScrollbarHandle));

                        _scrollbarHorizontalElement.append(_scrollbarHorizontalTrackElement);
                        _scrollbarHorizontalTrackElement.append(_scrollbarHorizontalHandleElement);
                        _scrollbarVerticalElement.append(_scrollbarVerticalTrackElement);
                        _scrollbarVerticalTrackElement.append(_scrollbarVerticalHandleElement);

                        _paddingElement.after(_scrollbarVerticalElement);
                        _paddingElement.after(_scrollbarHorizontalElement);
                    }
                    else {
                        remove(_scrollbarHorizontalElement);
                        remove(_scrollbarVerticalElement);
                    }
                }

                /**
                 * Initializes all scrollbar interactivity events. (track and handle dragging, clicking, scrolling)
                 * @param isHorizontal True if the target scrollbar is the horizontal scrollbar, false if the target scrollbar is the vertical scrollbar.
                 */
                function setupScrollbarEvents(isHorizontal) {
                    var scrollbarVars = getScrollbarVars(isHorizontal);
                    var scrollbarVarsInfo = scrollbarVars._info;
                    var insideIFrame = _windowElementNative.top !== _windowElementNative;
                    var xy = scrollbarVars._x_y;
                    var XY = scrollbarVars._X_Y;
                    var scroll = _strScroll + scrollbarVars._Left_Top;
                    var strActive = 'active';
                    var strSnapHandle = 'snapHandle';
                    var scrollDurationFactor = 1;
                    var increaseDecreaseScrollAmountKeyCodes = [ 16, 17 ]; //shift, ctrl
                    var trackTimeout;
                    var mouseDownScroll;
                    var mouseDownOffset;
                    var mouseDownInvertedScale;
                    
                    function setupEvent(element, eventNames, listener) {
                        var collected = type(eventNames) == TYPES.a && type(listener) == TYPES.a;
                        var i = 0;
                        
                        if(collected) {
                            for (; i < eventNames[LEXICON.l]; i++)
                                setupEvent(element, eventNames[i], listener[i]);
                        }
                        else {
                            if(_supportPassiveEvents)
                                setupPassiveEventListener(element, eventNames, listener, false, true);
                            else
                                element.on(eventNames, listener);
                        }
                    }
                    function getPointerPosition(event) {
                        return _msieVersion && insideIFrame ? event['screen' + XY] : COMPATIBILITY.page(event)[xy]; //use screen coordinates in EDGE & IE because the page values are incorrect in frames.
                    }
                    function getPreparedScrollbarsOption(name) {
                        return _currentPreparedOptions.scrollbars[name];
                    }
                    function increaseTrackScrollAmount() {
                        scrollDurationFactor = 0.5;
                    }
                    function decreaseTrackScrollAmount() {
                        scrollDurationFactor = 1;
                    }
                    function documentKeyDown(event) {
                        if (inArray(event.keyCode, increaseDecreaseScrollAmountKeyCodes) > -1)
                            increaseTrackScrollAmount();
                    }
                    function documentKeyUp(event) {
                        if (inArray(event.keyCode, increaseDecreaseScrollAmountKeyCodes) > -1)
                            decreaseTrackScrollAmount();
                    }
                    function onMouseTouchDownContinue(event) {
                        var originalEvent = event.originalEvent || event;
                        var isTouchEvent = originalEvent.touches !== undefined;
                        return _sleeping || _destroyed || nativeOverlayScrollbarsAreActive() || !_scrollbarsDragScrollingCache || (isTouchEvent && !getPreparedScrollbarsOption('touchSupport')) ? false : COMPATIBILITY.mBtn(event) === 1 || isTouchEvent;
                    }
                    function documentDragMove(event) {
                        if(onMouseTouchDownContinue(event)) {
                            var trackLength = scrollbarVarsInfo._trackLength;
                            var handleLength = scrollbarVarsInfo._handleLength;
                            var scrollRange = scrollbarVarsInfo._maxScroll;
                            var scrollRaw = (getPointerPosition(event) - mouseDownOffset) * mouseDownInvertedScale;
                            var scrollDeltaPercent = scrollRaw / (trackLength - handleLength);
                            var scrollDelta = (scrollRange * scrollDeltaPercent);
                            scrollDelta = isFinite(scrollDelta) ? scrollDelta : 0;
                            if (_isRTL && isHorizontal && !_rtlScrollBehavior.i)
                                scrollDelta *= -1;

                            _viewportElement[scroll](MATH.round(mouseDownScroll + scrollDelta));

                            if(_scrollbarsHandlesDefineScrollPos)
                                refreshScrollbarHandleOffset(isHorizontal, mouseDownScroll + scrollDelta);

                            if (!_supportPassiveEvents)
                                COMPATIBILITY.prvD(event);
                        }
                        else
                            documentMouseTouchUp(event);
                    }
                    function documentMouseTouchUp(event) {
                        event = event || event.originalEvent;

                        _documentElement.off(_strMouseTouchMoveEvent, documentDragMove)
                            .off(_strMouseTouchUpEvent, documentMouseTouchUp)
                            .off(_strKeyDownEvent, documentKeyDown)
                            .off(_strKeyUpEvent, documentKeyUp)
                            .off(_strSelectStartEvent, documentOnSelectStart);

                        if(_scrollbarsHandlesDefineScrollPos)
                            refreshScrollbarHandleOffset(isHorizontal, true);

                        _scrollbarsHandlesDefineScrollPos = false;
                        removeClass(_bodyElement, _classNameDragging);
                        removeClass(scrollbarVars._handle, strActive);
                        removeClass(scrollbarVars._track, strActive);
                        removeClass(scrollbarVars._scrollbar, strActive);

                        mouseDownScroll = undefined;
                        mouseDownOffset = undefined;
                        mouseDownInvertedScale = 1;

                        decreaseTrackScrollAmount();

                        if (trackTimeout !== undefined) {
                            _base.scrollStop();
                            clearTimeout(trackTimeout);
                            trackTimeout = undefined;
                        }

                        if(event) {
                            var rect = _hostElementNative.getBoundingClientRect();
                            var mouseInsideHost = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;

                            //if mouse is outside host element
                            if (!mouseInsideHost)
                                hostOnMouseLeave();

                            if (_scrollbarsAutoHideScroll || _scrollbarsAutoHideMove)
                                refreshScrollbarsAutoHide(false);
                        }
                    }
                    function onHandleMouseTouchDown(event) {
                        if (onMouseTouchDownContinue(event))
                            onHandleMouseTouchDownAction(event);
                    }
                    function onHandleMouseTouchDownAction(event) {
                        mouseDownScroll = _viewportElement[scroll]();
                        mouseDownScroll = isNaN(mouseDownScroll) ? 0 : mouseDownScroll;
                        if (_isRTL && isHorizontal && !_rtlScrollBehavior.n || !_isRTL)
                            mouseDownScroll = mouseDownScroll < 0 ? 0 : mouseDownScroll;

                        mouseDownInvertedScale = getHostElementInvertedScale()[xy];
                        mouseDownOffset = getPointerPosition(event);

                        _scrollbarsHandlesDefineScrollPos = !getPreparedScrollbarsOption(strSnapHandle);
                        addClass(_bodyElement, _classNameDragging);
                        addClass(scrollbarVars._handle, strActive);
                        addClass(scrollbarVars._scrollbar, strActive);

                        _documentElement.on(_strMouseTouchMoveEvent, documentDragMove)
                            .on(_strMouseTouchUpEvent, documentMouseTouchUp)
                            .on(_strSelectStartEvent, documentOnSelectStart);

                        if(_msieVersion || !_documentMixed)
                            COMPATIBILITY.prvD(event);
                        COMPATIBILITY.stpP(event);
                    }
                    function onTrackMouseTouchDown(event) {
                        if (onMouseTouchDownContinue(event)) {
                            var scrollDistance = MATH.round(_viewportSize[scrollbarVars._w_h]);
                            var trackOffset = scrollbarVars._track.offset()[scrollbarVars._left_top];
                            var ctrlKey = event.ctrlKey;
                            var instantScroll = event.shiftKey;
                            var instantScrollTransition = instantScroll && ctrlKey;
                            var isFirstIteration = true;
                            var easing = 'linear';
                            var decreaseScroll;
                            var finishedCondition;
                            var scrollActionFinsished = function(transition) {
                                if(_scrollbarsHandlesDefineScrollPos)
                                    refreshScrollbarHandleOffset(isHorizontal, transition);
                            };
                            var scrollActionInstantFinished = function() {
                                scrollActionFinsished();
                                onHandleMouseTouchDownAction(event);
                            };
                            var scrollAction = function () {
                                if(!_destroyed) {
                                    var mouseOffset = (mouseDownOffset - trackOffset) * mouseDownInvertedScale;
                                    var handleOffset = scrollbarVarsInfo._handleOffset;
                                    var trackLength = scrollbarVarsInfo._trackLength;
                                    var handleLength = scrollbarVarsInfo._handleLength;
                                    var scrollRange = scrollbarVarsInfo._maxScroll;
                                    var currScroll = scrollbarVarsInfo._currentScroll;
                                    var scrollDuration = 270 * scrollDurationFactor;
                                    var timeoutDelay = isFirstIteration ? MATH.max(400, scrollDuration) : scrollDuration;
                                    var instantScrollPosition = scrollRange * ((mouseOffset - (handleLength / 2)) / (trackLength - handleLength)); // 100% * positionPercent
                                    var rtlIsNormal = _isRTL && isHorizontal && ((!_rtlScrollBehavior.i && !_rtlScrollBehavior.n) || _normalizeRTLCache);
                                    var decreaseScrollCondition = rtlIsNormal ? handleOffset < mouseOffset : handleOffset > mouseOffset;
                                    var scrollObj = { };
                                    var animationObj = {
                                        easing : easing,
                                        step : function(now) {
                                            if(_scrollbarsHandlesDefineScrollPos) {
                                                _viewportElement[scroll](now); //https://github.com/jquery/jquery/issues/4340
                                                refreshScrollbarHandleOffset(isHorizontal, now);
                                            }
                                        }
                                    };
                                    instantScrollPosition = isFinite(instantScrollPosition) ? instantScrollPosition : 0;
                                    instantScrollPosition = _isRTL && isHorizontal && !_rtlScrollBehavior.i ? (scrollRange - instantScrollPosition) : instantScrollPosition;

                                    //_base.scrollStop();

                                    if(instantScroll) {
                                        _viewportElement[scroll](instantScrollPosition); //scroll instantly to new position
                                        if(instantScrollTransition) {
                                            //get the scroll position after instant scroll (in case CSS Snap Points are used) to get the correct snapped scroll position
                                            //and the animation stops at the correct point
                                            instantScrollPosition = _viewportElement[scroll]();
                                            //scroll back to the position before instant scrolling so animation can be performed
                                            _viewportElement[scroll](currScroll);

                                            instantScrollPosition = rtlIsNormal && _rtlScrollBehavior.i ? (scrollRange - instantScrollPosition) : instantScrollPosition;
                                            instantScrollPosition = rtlIsNormal && _rtlScrollBehavior.n ? -instantScrollPosition : instantScrollPosition;

                                            scrollObj[xy] = instantScrollPosition;
                                            _base.scroll(scrollObj, extendDeep(animationObj, {
                                                duration : 130,
                                                complete : scrollActionInstantFinished
                                            }));
                                        }
                                        else
                                            scrollActionInstantFinished();
                                    }
                                    else {
                                        decreaseScroll = isFirstIteration ? decreaseScrollCondition : decreaseScroll;
                                        finishedCondition = rtlIsNormal
                                            ? (decreaseScroll ? handleOffset + handleLength >= mouseOffset : handleOffset <= mouseOffset)
                                            : (decreaseScroll ? handleOffset <= mouseOffset : handleOffset + handleLength >= mouseOffset);

                                        if (finishedCondition) {
                                            clearTimeout(trackTimeout);
                                            _base.scrollStop();
                                            trackTimeout = undefined;
                                            scrollActionFinsished(true);
                                        }
                                        else {
                                            trackTimeout = setTimeout(scrollAction, timeoutDelay);

                                            scrollObj[xy] = (decreaseScroll ? '-=' : '+=') + scrollDistance;
                                            _base.scroll(scrollObj, extendDeep(animationObj, {
                                                duration: scrollDuration
                                            }));
                                        }
                                        isFirstIteration = false;
                                    }
                                }
                            };
                            if (ctrlKey)
                                increaseTrackScrollAmount();

                            mouseDownInvertedScale = getHostElementInvertedScale()[xy];
                            mouseDownOffset = COMPATIBILITY.page(event)[xy];

                            _scrollbarsHandlesDefineScrollPos = !getPreparedScrollbarsOption(strSnapHandle);
                            addClass(_bodyElement, _classNameDragging);
                            addClass(scrollbarVars._track, strActive);
                            addClass(scrollbarVars._scrollbar, strActive);

                            _documentElement.on(_strMouseTouchUpEvent, documentMouseTouchUp)
                                .on(_strKeyDownEvent, documentKeyDown)
                                .on(_strKeyUpEvent, documentKeyUp)
                                .on(_strSelectStartEvent, documentOnSelectStart);

                            scrollAction();
                            COMPATIBILITY.prvD(event);
                            COMPATIBILITY.stpP(event);
                        }
                    }
                    function onTrackMouseTouchEnter(event) {
                        //make sure both scrollbars will stay visible if one scrollbar is hovered if autoHide is "scroll" or "move".
                        _scrollbarsHandleHovered = true;
                        if (_scrollbarsAutoHideScroll || _scrollbarsAutoHideMove)
                            refreshScrollbarsAutoHide(true);
                    }
                    function onTrackMouseTouchLeave(event) {
                        _scrollbarsHandleHovered = false;
                        if (_scrollbarsAutoHideScroll || _scrollbarsAutoHideMove)
                            refreshScrollbarsAutoHide(false);
                    }
                    function onScrollbarMouseTouchDown(event) {
                        COMPATIBILITY.stpP(event);
                    }
                    
                    setupEvent(scrollbarVars._handle, 
                        _strMouseTouchDownEvent, 
                        onHandleMouseTouchDown);
                    setupEvent(scrollbarVars._track,
                        [_strMouseTouchDownEvent, _strMouseTouchEnter, _strMouseTouchLeave], 
                        [onTrackMouseTouchDown, onTrackMouseTouchEnter, onTrackMouseTouchLeave]);
                    setupEvent(scrollbarVars._scrollbar, 
                        _strMouseTouchDownEvent, 
                        onScrollbarMouseTouchDown);

                    if (_supportTransition) {
                        scrollbarVars._scrollbar.on(_strTransitionEndEvent, function(event) {
                            if (event.target !== scrollbarVars._scrollbar[0])
                                return;
                            refreshScrollbarHandleLength(isHorizontal);
                            refreshScrollbarHandleOffset(isHorizontal);
                        });
                    }
                }

                /**
                 * Shows or hides the given scrollbar and applied a class name which indicates if the scrollbar is scrollable or not.
                 * @param isHorizontal True if the horizontal scrollbar is the target, false if the vertical scrollbar is the target.
                 * @param shallBeVisible True if the scrollbar shall be shown, false if hidden.
                 * @param canScroll True if the scrollbar is scrollable, false otherwise.
                 */
                function refreshScrollbarAppearance(isHorizontal, shallBeVisible, canScroll) {
                    var scrollbarClassName = isHorizontal ? _classNameHostScrollbarHorizontalHidden : _classNameHostScrollbarVerticalHidden;
                    var scrollbarElement = isHorizontal ? _scrollbarHorizontalElement : _scrollbarVerticalElement;

                    if (shallBeVisible)
                        removeClass(_hostElement, scrollbarClassName);
                    else
                        addClass(_hostElement, scrollbarClassName);

                    if (canScroll)
                        removeClass(scrollbarElement, _classNameScrollbarUnusable);
                    else
                        addClass(scrollbarElement, _classNameScrollbarUnusable);
                }

                /**
                 * Autoshows / autohides both scrollbars with.
                 * @param shallBeVisible True if the scrollbars shall be autoshown (only the case if they are hidden by a autohide), false if the shall be auto hidden.
                 * @param delayfree True if the scrollbars shall be hidden without a delay, false or undefined otherwise.
                 */
                function refreshScrollbarsAutoHide(shallBeVisible, delayfree) {
                    clearTimeout(_scrollbarsAutoHideTimeoutId);
                    if (shallBeVisible) {
                        //if(_hasOverflowCache.x && _hideOverflowCache.xs)
                        removeClass(_scrollbarHorizontalElement, _classNameScrollbarAutoHidden);
                        //if(_hasOverflowCache.y && _hideOverflowCache.ys)
                        removeClass(_scrollbarVerticalElement, _classNameScrollbarAutoHidden);
                    }
                    else {
                        var anyActive;
                        var strActive = 'active';
                        var hide = function () {
                            if (!_scrollbarsHandleHovered && !_destroyed) {
                                anyActive = _scrollbarHorizontalHandleElement.hasClass(strActive) || _scrollbarVerticalHandleElement.hasClass(strActive);
                                if (!anyActive && (_scrollbarsAutoHideScroll || _scrollbarsAutoHideMove || _scrollbarsAutoHideLeave))
                                    addClass(_scrollbarHorizontalElement, _classNameScrollbarAutoHidden);
                                if (!anyActive && (_scrollbarsAutoHideScroll || _scrollbarsAutoHideMove || _scrollbarsAutoHideLeave))
                                    addClass(_scrollbarVerticalElement, _classNameScrollbarAutoHidden);
                            }
                        };
                        if (_scrollbarsAutoHideDelay > 0 && delayfree !== true)
                            _scrollbarsAutoHideTimeoutId = setTimeout(hide, _scrollbarsAutoHideDelay);
                        else
                            hide();
                    }
                }

                /**
                 * Refreshes the handle length of the given scrollbar.
                 * @param isHorizontal True if the horizontal scrollbar handle shall be refreshed, false if the vertical one shall be refreshed.
                 */
                function refreshScrollbarHandleLength(isHorizontal) {
                    var handleCSS = {};
                    var scrollbarVars = getScrollbarVars(isHorizontal);
                    var scrollbarVarsInfo = scrollbarVars._info;
                    var digit = 1000000;
                    //get and apply intended handle length
                    var handleRatio = MATH.min(1, (_hostSizeCache[scrollbarVars._w_h] - (_paddingAbsoluteCache ? (isHorizontal ? _paddingX : _paddingY) : 0)) / _contentScrollSizeCache[scrollbarVars._w_h]);
                    handleCSS[scrollbarVars._width_height] = (MATH.floor(handleRatio * 100 * digit) / digit) + "%"; //the last * digit / digit is for flooring to the 4th digit

                    if (!nativeOverlayScrollbarsAreActive())
                        scrollbarVars._handle.css(handleCSS);

                    //measure the handle length to respect min & max length
                    scrollbarVarsInfo._handleLength = scrollbarVars._handle[0]['offset' + scrollbarVars._Width_Height];
                    scrollbarVarsInfo._handleLengthRatio = handleRatio;
                }

                /**
                 * Refreshes the handle offset of the given scrollbar.
                 * @param isHorizontal True if the horizontal scrollbar handle shall be refreshed, false if the vertical one shall be refreshed.
                 * @param scrollOrTransition The scroll position of the given scrollbar axis to which the handle shall be moved or a boolean which indicates whether a transition shall be applied. If undefined or boolean if the current scroll-offset is taken. (if isHorizontal ? scrollLeft : scrollTop)
                 */
                function refreshScrollbarHandleOffset(isHorizontal, scrollOrTransition) {
                    var transition = type(scrollOrTransition) == TYPES.b;
                    var transitionDuration = 250;
                    var isRTLisHorizontal = _isRTL && isHorizontal;
                    var scrollbarVars = getScrollbarVars(isHorizontal);
                    var scrollbarVarsInfo = scrollbarVars._info;
                    var strTranslateBrace = 'translate(';
                    var strTransform = VENDORS._cssProperty('transform');
                    var strTransition = VENDORS._cssProperty('transition');
                    var nativeScroll = isHorizontal ? _viewportElement[_strScrollLeft]() : _viewportElement[_strScrollTop]();
                    var currentScroll = scrollOrTransition === undefined || transition ? nativeScroll : scrollOrTransition;

                    //measure the handle length to respect min & max length
                    var handleLength = scrollbarVarsInfo._handleLength;
                    var trackLength = scrollbarVars._track[0]['offset' + scrollbarVars._Width_Height];
                    var handleTrackDiff = trackLength - handleLength;
                    var handleCSS = {};
                    var transformOffset;
                    var translateValue;

                    //DONT use the variable '_contentScrollSizeCache[scrollbarVars._w_h]' instead of '_viewportElement[0]['scroll' + scrollbarVars._Width_Height]'
                    // because its a bit behind during the small delay when content size updates
                    //(delay = mutationObserverContentLag, if its 0 then this var could be used)
                    var maxScroll = (_viewportElementNative[_strScroll + scrollbarVars._Width_Height] - _viewportElementNative['client' + scrollbarVars._Width_Height]) * (_rtlScrollBehavior.n && isRTLisHorizontal ? -1 : 1); //* -1 if rtl scroll max is negative
                    var getScrollRatio = function(base) {
                        return isNaN(base / maxScroll) ? 0 : MATH.max(0, MATH.min(1, base / maxScroll));
                    };
                    var getHandleOffset = function(scrollRatio) {
                        var offset = handleTrackDiff * scrollRatio;
                        offset = isNaN(offset) ? 0 : offset;
                        offset = (isRTLisHorizontal && !_rtlScrollBehavior.i) ? (trackLength - handleLength - offset) : offset;
                        offset = MATH.max(0, offset);
                        return offset;
                    };
                    var scrollRatio = getScrollRatio(nativeScroll);
                    var unsnappedScrollRatio = getScrollRatio(currentScroll);
                    var handleOffset = getHandleOffset(unsnappedScrollRatio);
                    var snappedHandleOffset = getHandleOffset(scrollRatio);

                    scrollbarVarsInfo._maxScroll = maxScroll;
                    scrollbarVarsInfo._currentScroll = nativeScroll;
                    scrollbarVarsInfo._currentScrollRatio = scrollRatio;

                    if (_supportTransform) {
                        transformOffset = isRTLisHorizontal ? -(trackLength - handleLength - handleOffset) : handleOffset; //in px
                        //transformOffset = (transformOffset / trackLength * 100) * (trackLength / handleLength); //in %
                        translateValue = isHorizontal ? strTranslateBrace + transformOffset + 'px, 0)' : strTranslateBrace + '0, ' + transformOffset + 'px)';

                        handleCSS[strTransform] = translateValue;

                        //apply or clear up transition
                        if(_supportTransition)
                            handleCSS[strTransition] = transition && MATH.abs(handleOffset - scrollbarVarsInfo._handleOffset) > 1 ? getCSSTransitionString(scrollbarVars._handle) + ', ' +  (strTransform + _strSpace + transitionDuration + 'ms') : _strEmpty;
                    }
                    else
                        handleCSS[scrollbarVars._left_top] = handleOffset;


                    //only apply css if offset has changed and overflow exists.
                    if (!nativeOverlayScrollbarsAreActive()) {
                        scrollbarVars._handle.css(handleCSS);

                        //clear up transition
                        if(_supportTransform && _supportTransition && transition) {
                            scrollbarVars._handle.one(_strTransitionEndEvent, function() {
                                if(!_destroyed)
                                    scrollbarVars._handle.css(strTransition, _strEmpty);
                            });
                        }
                    }

                    scrollbarVarsInfo._handleOffset = handleOffset;
                    scrollbarVarsInfo._snappedHandleOffset = snappedHandleOffset;
                    scrollbarVarsInfo._trackLength = trackLength;
                }

                /**
                 * Refreshes the interactivity of the given scrollbar element.
                 * @param isTrack True if the track element is the target, false if the handle element is the target.
                 * @param value True for interactivity false for no interactivity.
                 */
                function refreshScrollbarsInteractive(isTrack, value) {
                    var action = value ? 'removeClass' : 'addClass';
                    var element1 = isTrack ? _scrollbarHorizontalTrackElement : _scrollbarHorizontalHandleElement;
                    var element2 = isTrack ? _scrollbarVerticalTrackElement : _scrollbarVerticalHandleElement;
                    var className = isTrack ? _classNameScrollbarTrackOff : _classNameScrollbarHandleOff;

                    element1[action](className);
                    element2[action](className);
                }

                /**
                 * Returns a object which is used for fast access for specific variables.
                 * @param isHorizontal True if the horizontal scrollbar vars shall be accessed, false if the vertical scrollbar vars shall be accessed.
                 * @returns {{wh: string, WH: string, lt: string, _wh: string, _lt: string, t: *, h: *, c: {}, s: *}}
                 */
                function getScrollbarVars(isHorizontal) {
                    return {
                        _width_height: isHorizontal ? _strWidth : _strHeight,
                        _Width_Height: isHorizontal ? 'Width' : 'Height',
                        _left_top: isHorizontal ? _strLeft : _strTop,
                        _Left_Top: isHorizontal ? 'Left' : 'Top',
                        _x_y: isHorizontal ? _strX : _strY,
                        _X_Y: isHorizontal ? 'X' : 'Y',
                        _w_h: isHorizontal ? 'w' : 'h',
                        _l_t: isHorizontal ? 'l' : 't',
                        _track: isHorizontal ? _scrollbarHorizontalTrackElement : _scrollbarVerticalTrackElement,
                        _handle: isHorizontal ? _scrollbarHorizontalHandleElement : _scrollbarVerticalHandleElement,
                        _scrollbar: isHorizontal ? _scrollbarHorizontalElement : _scrollbarVerticalElement,
                        _info: isHorizontal ? _scrollHorizontalInfo : _scrollVerticalInfo
                    };
                }


                //==== Scrollbar Corner ====//

                /**
                 * Builds or destroys the scrollbar corner DOM element.
                 * @param destroy Indicates whether the DOM shall be build or destroyed.
                 */
                function setupScrollbarCornerDOM(destroy) {
                    if(!destroy) {
                         _scrollbarCornerElement = FRAMEWORK(generateDiv(_classNameScrollbarCorner));
                        _hostElement.append(_scrollbarCornerElement);
                    }
                    else {
                        remove(_scrollbarCornerElement);
                    }
                 }

                /**
                 * Initializes all scrollbar corner interactivity events.
                 */
                function setupScrollbarCornerEvents() {
                    var insideIFrame = _windowElementNative.top !== _windowElementNative;
                    var mouseDownPosition = { };
                    var mouseDownSize = { };
                    var mouseDownInvertedScale = { };

                    _resizeOnMouseTouchDown = function(event) {
                        if (onMouseTouchDownContinue(event)) {
                            if (_mutationObserversConnected) {
                                _resizeReconnectMutationObserver = true;
                                disconnectMutationObservers();
                            }

                            mouseDownPosition = getCoordinates(event);

                            mouseDownSize.w = _hostElementNative[LEXICON.oW] - (!_isBorderBox ? _paddingX : 0);
                            mouseDownSize.h = _hostElementNative[LEXICON.oH] - (!_isBorderBox ? _paddingY : 0);
                            mouseDownInvertedScale = getHostElementInvertedScale();

                            _documentElement.on(_strSelectStartEvent, documentOnSelectStart)
                                .on(_strMouseTouchMoveEvent, documentDragMove)
                                .on(_strMouseTouchUpEvent, documentMouseTouchUp);

                            addClass(_bodyElement, _classNameDragging);
                            if (_scrollbarCornerElement.setCapture)
                                _scrollbarCornerElement.setCapture();

                            COMPATIBILITY.prvD(event);
                            COMPATIBILITY.stpP(event);
                        }
                    };
                    function documentDragMove(event) {
                        if (onMouseTouchDownContinue(event)) {
                            var pageOffset = getCoordinates(event);
                            var hostElementCSS = { };
                            if (_resizeHorizontal || _resizeBoth)
                                hostElementCSS[_strWidth] = (mouseDownSize.w + (pageOffset.x - mouseDownPosition.x) * mouseDownInvertedScale.x);
                            if (_resizeVertical || _resizeBoth)
                                hostElementCSS[_strHeight] = (mouseDownSize.h + (pageOffset.y - mouseDownPosition.y) * mouseDownInvertedScale.y);
                            _hostElement.css(hostElementCSS);
                            COMPATIBILITY.stpP(event);
                        }
                        else {
                            documentMouseTouchUp(event);
                        }
                    }
                    function documentMouseTouchUp(event) {
                        var eventIsTrusted = event !== undefined;

                        _documentElement.off(_strSelectStartEvent, documentOnSelectStart)
                            .off(_strMouseTouchMoveEvent, documentDragMove)
                            .off(_strMouseTouchUpEvent, documentMouseTouchUp);

                        removeClass(_bodyElement, _classNameDragging);
                        if (_scrollbarCornerElement.releaseCapture)
                            _scrollbarCornerElement.releaseCapture();

                        if (eventIsTrusted) {
                            if (_resizeReconnectMutationObserver)
                                connectMutationObservers();
                            _base.update(_strAuto);
                        }
                        _resizeReconnectMutationObserver = false;
                    }
                    function onMouseTouchDownContinue(event) {
                        var originalEvent = event.originalEvent || event;
                        var isTouchEvent = originalEvent.touches !== undefined;
                        return _sleeping || _destroyed ? false : COMPATIBILITY.mBtn(event) === 1 || isTouchEvent;
                    }
                    function getCoordinates(event) {
                        return _msieVersion && insideIFrame ? { x : event.screenX , y : event.screenY } : COMPATIBILITY.page(event);
                    }
                }


                //==== Utils ====//

                /**
                 * Calls the callback with the given name. The Context of this callback is always _base (this).
                 * @param name The name of the target which shall be called.
                 * @param args The args with which the callback shall be called.
                 */
                function dispatchCallback(name, args) {
                    if(_initialized) {
                        var callback = _currentPreparedOptions.callbacks[name];
                        var extensionOnName = name;
                        var ext;

                        if(extensionOnName.substr(0, 2) === 'on')
                            extensionOnName = extensionOnName.substr(2, 1).toLowerCase() + extensionOnName.substr(3);

                        if(type(callback) == TYPES.f)
                            callback.call(_base, args);

                        each(_extensions, function() {
                            ext = this;
                            if(type(ext.on) == TYPES.f)
                                ext.on(extensionOnName, args);
                        });
                    }
                    else if(!_destroyed)
                        _callbacksInitQeueue.push({ n : name, a : args });
                }

                /**
                 * Sets the "top, right, bottom, left" properties, with a given prefix, of the given css object.
                 * @param targetCSSObject The css object to which the values shall be applied.
                 * @param prefix The prefix of the "top, right, bottom, left" css properties. (example: 'padding-' is a valid prefix)
                 * @param values A array of values which shall be applied to the "top, right, bottom, left" -properties. The array order is [top, right, bottom, left].
                 * If this argument is undefined the value '' (empty string) will be applied to all properties.
                 */
                function setTopRightBottomLeft(targetCSSObject, prefix, values) {
                    if (values === undefined)
                        values = [_strEmpty, _strEmpty, _strEmpty, _strEmpty];

                    targetCSSObject[prefix + _strTop] = values[0];
                    targetCSSObject[prefix + _strRight] = values[1];
                    targetCSSObject[prefix + _strBottom] = values[2];
                    targetCSSObject[prefix + _strLeft] = values[3];
                }

                /**
                 * Returns the computed CSS transition string from the given element.
                 * @param element The element from which the transition string shall be returned.
                 * @returns {string} The CSS transition string from the given element.
                 */
                function getCSSTransitionString(element) {
                    var transitionStr = VENDORS._cssProperty('transition');
                    var assembledValue = element.css(transitionStr);
                    if(assembledValue)
                        return assembledValue;
                    var regExpString = '\\s*(' + '([^,(]+(\\(.+?\\))?)+' + ')[\\s,]*';
                    var regExpMain = new RegExp(regExpString);
                    var regExpValidate = new RegExp('^(' + regExpString + ')+$');
                    var properties = 'property duration timing-function delay'.split(' ');
                    var result = [ ];
                    var strResult;
                    var valueArray;
                    var i = 0;
                    var j;
                    var splitCssStyleByComma = function(str) {
                        strResult = [ ];
                        if (!str.match(regExpValidate))
                            return str;
                        while (str.match(regExpMain)) {
                            strResult.push(RegExp.$1);
                            str = str.replace(regExpMain, _strEmpty);
                        }

                        return strResult;
                    };
                    for (; i < properties[LEXICON.l]; i++) {
                        valueArray = splitCssStyleByComma(element.css(transitionStr + '-' + properties[i]));
                        for (j = 0; j < valueArray[LEXICON.l]; j++)
                            result[j] = (result[j] ? result[j] + _strSpace : _strEmpty) + valueArray[j];
                    }
                    return result.join(', ');
                }

                /**
                 * Calculates the host-elements inverted scale. (invertedScale = 1 / scale)
                 * @returns {{x: number, y: number}} The scale of the host-element.
                 */
                function getHostElementInvertedScale() {
                    var rect = _paddingElementNative.getBoundingClientRect();
                    return {
                        x :  _supportTransform ? 1 / (MATH.round(rect.width) / _paddingElementNative[LEXICON.oW]) || 1 : 1,
                        y :  _supportTransform ? 1 / (MATH.round(rect.height) / _paddingElementNative[LEXICON.oH]) || 1 : 1
                    };
                }

                /**
                 * Checks whether the given object is a HTMLElement.
                 * @param o The object which shall be checked.
                 * @returns {boolean} True the given object is a HTMLElement, false otherwise.
                 */
                function isHTMLElement(o) {
                    var strOwnerDocument = 'ownerDocument';
                    var strHTMLElement = 'HTMLElement';
                    var wnd = o && o[strOwnerDocument] ? (o[strOwnerDocument].parentWindow || window) : window;
                    return (
                        typeof wnd[strHTMLElement] == TYPES.o ? o instanceof wnd[strHTMLElement] : //DOM2
                        o && typeof o == TYPES.o && o !== null && o.nodeType === 1 && typeof o.nodeName == TYPES.s
                    );
                }

                /**
                 * Compares 2 arrays and returns the differences between them as a array.
                 * @param a1 The first array which shall be compared.
                 * @param a2 The second array which shall be compared.
                 * @returns {Array} The differences between the two arrays.
                 */
                function getArrayDifferences(a1, a2) {
                    var a = [ ];
                    var diff = [ ];
                    var i;
                    var k;
                    for (i = 0; i < a1.length; i++)
                        a[a1[i]] = true;
                    for (i = 0; i < a2.length; i++) {
                        if (a[a2[i]])
                            delete a[a2[i]];
                        else
                            a[a2[i]] = true;
                    }
                    for (k in a)
                        diff.push(k);
                    return diff;
                }

                /**
                 * Returns Zero or the number to which the value can be parsed.
                 * @param value The value which shall be parsed.
                 * @param toFloat Indicates whether the number shall be parsed to a float.
                 */
                function parseToZeroOrNumber(value, toFloat) {
                    var num = toFloat ? parseFloat(value) : parseInt(value, 10);
                    return isNaN(num) ? 0 : num;
                }

                /**
                 * Gets several information of the textarea and returns them as a object or undefined if the browser doesn't support it.
                 * @returns {{cursorRow: Number, cursorCol, rows: Number, cols: number, wRow: number, pos: number, max : number}} or undefined if not supported.
                 */
                function getTextareaInfo() {
                    //read needed values
                    var textareaCursorPosition = _targetElementNative.selectionStart;
                    if (textareaCursorPosition === undefined)
                        return;

                    var textareaValue = _targetElement.val();
                    var textareaLength = textareaValue[LEXICON.l];
                    var textareaRowSplit = textareaValue.split('\n');
                    var textareaLastRow = textareaRowSplit[LEXICON.l];
                    var textareaCurrentCursorRowSplit = textareaValue.substr(0, textareaCursorPosition).split('\n');
                    var widestRow = 0;
                    var textareaLastCol = 0;
                    var cursorRow = textareaCurrentCursorRowSplit[LEXICON.l];
                    var cursorCol = textareaCurrentCursorRowSplit[textareaCurrentCursorRowSplit[LEXICON.l] - 1][LEXICON.l];
                    var rowCols;
                    var i;

                    //get widest Row and the last column of the textarea
                    for (i = 0; i < textareaRowSplit[LEXICON.l]; i++) {
                        rowCols = textareaRowSplit[i][LEXICON.l];
                        if (rowCols > textareaLastCol) {
                            widestRow = i + 1;
                            textareaLastCol = rowCols;
                        }
                    }

                    return {
                        _cursorRow: cursorRow, //cursorRow
                        _cursorColumn: cursorCol, //cursorCol
                        _rows: textareaLastRow, //rows
                        _columns: textareaLastCol, //cols
                        _widestRow: widestRow, //wRow
                        _cursorPosition: textareaCursorPosition, //pos
                        _cursorMax: textareaLength //max
                    };
                }

                /**
                 * Determines whether native overlay scrollbars are active.
                 * @returns {boolean} True if native overlay scrollbars are active, false otherwise.
                 */
                function nativeOverlayScrollbarsAreActive() {
                    return (_ignoreOverlayScrollbarHidingCache && (_nativeScrollbarIsOverlaid.x && _nativeScrollbarIsOverlaid.y));
                }

                /**
                 * Gets the element which is used to measure the content size.
                 * @returns {*} TextareaCover if target element is textarea else the ContentElement.
                 */
                function getContentMeasureElement() {
                    return _isTextarea ? _textareaCoverElement[0] : _contentElementNative;
                }

                /**
                 * Generates a string which represents a HTML div with the given classes or attributes.
                 * @param classesOrAttrs The class of the div as string or a object which represents the attributes of the div. (The class attribute can also be written as "className".)
                 * @param content The content of the div as string.
                 * @returns {string} The concated string which represents a HTML div and its content.
                 */
                function generateDiv(classesOrAttrs, content) {
                    return '<div ' + (classesOrAttrs ? type(classesOrAttrs) == TYPES.s ?
                        'class="' + classesOrAttrs + '"' :
                            (function() {
                                var key;
                                var attrs = '';
                                if(FRAMEWORK.isPlainObject(classesOrAttrs)) {
                                    for (key in classesOrAttrs)
                                        attrs += (key === 'className' ? 'class' : key) + '="' + classesOrAttrs[key] + '" ';
                                }
                                return attrs;
                            })() :
                            _strEmpty) +
                        '>' +
                        (content ? content : _strEmpty) +
                        '</div>';
                }

                /**
                 * Gets the value of the given property from the given object.
                 * @param obj The object from which the property value shall be got.
                 * @param path The property of which the value shall be got.
                 * @returns {*} Returns the value of the searched property or undefined of the property wasn't found.
                 */
                function getObjectPropVal(obj, path) {
                    var splits = path.split(_strDot);
                    var i = 0;
                    var val;
                    for(; i < splits.length; i++) {
                        if(!obj[LEXICON.hOP](splits[i]))
                            return;
                        val = obj[splits[i]];
                        if(i < splits.length && type(val) == TYPES.o)
                            obj = val;
                    }
                    return val;
                }

                /**
                 * Sets the value of the given property from the given object.
                 * @param obj The object from which the property value shall be set.
                 * @param path The property of which the value shall be set.
                 * @param val The value of the property which shall be set.
                 */
                function setObjectPropVal(obj, path, val) {
                    var splits = path.split(_strDot);
                    var splitsLength = splits.length;
                    var i = 0;
                    var extendObj = { };
                    var extendObjRoot = extendObj;
                    for(; i < splitsLength; i++)
                        extendObj = extendObj[splits[i]] = i + 1 < splitsLength ? { } : val;
                    FRAMEWORK.extend(obj, extendObjRoot, true);
                }


                //==== Utils Cache ====//

                /**
                 * Compares two values or objects and returns true if they aren't equal.
                 * @param current The first value or object which shall be compared.
                 * @param cache The second value or object which shall be compared.
                 * @param force If true the returned value is always true.
                 * @returns {boolean} True if both values or objects aren't equal or force is true, false otherwise.
                 */
                function checkCache(current, cache, force) {
                    if (force)
                        return force;
                    if(type(current) == TYPES.o && type(cache) == TYPES.o) {
                        for (var prop in current) {
                            if(prop !== 'c') {
                                if (current[LEXICON.hOP](prop) && cache[LEXICON.hOP](prop)) {
                                    if(checkCache(current[prop], cache[prop]))
                                        return true;
                                }
                                else {
                                    return true;
                                }
                            }
                        }
                    }
                    else {
                        return current !== cache;
                    }
                    return false;
                }


                //==== Shortcuts ====//

                /**
                 * jQuery extend method shortcut with a appended "true" as first argument.
                 */
                function extendDeep() {
                    return FRAMEWORK.extend.apply(this, [ true ].concat([].slice.call(arguments)));
                }

                /**
                 * jQuery addClass method shortcut.
                 */
                function addClass(el, classes) {
                    return _frameworkProto.addClass.call(el, classes);
                }

                /**
                 * jQuery removeClass method shortcut.
                 */
                function removeClass(el, classes) {
                    return _frameworkProto.removeClass.call(el, classes);
                }

                /**
                 * jQuery remove method shortcut.
                 */
                function remove(el) {
                    return _frameworkProto.remove.call(el);
                }

                /**
                 * Finds the first child element with the given selector of the given element.
                 * @param el The root element from which the selector shall be valid.
                 * @param selector The selector of the searched element.
                 * @returns {*} The first element which is a child of the given element and matches the givens selector.
                 */
                function findFirst(el, selector) {
                    return _frameworkProto.find.call(el, selector).eq(0);
                }


                //==== API ====//

                /**
                 * Puts the instance to sleep. It wont respond to any changes in the DOM and won't update. Scrollbar Interactivity is also disabled as well as the resize handle.
                 * This behavior can be reset by calling the update method.
                 */
                _base.sleep = function () {
                    _sleeping = true;
                };

                /**
                 * Updates the plugin and DOM to the current options.
                 * This method should only be called if a update is 100% required.
                 * @param force True if every property shall be updated and the cache shall be ignored.
                 * !INTERNAL USAGE! : force can be a string "auto", "sync" or "zoom" too
                 * if "auto" then before a real update the content size and host element attributes gets checked, and if they changed only then the update method will be called.
                 * if "sync" then the async update process (MutationObserver or UpdateLoop) gets synchronized and a corresponding update takes place if one was needed due to pending changes.
                 * if "zoom" then a update takes place where it's assumed that content and host size changed
                 * @returns {boolean|undefined} 
                 * If force is "sync" then a boolean is returned which indicates whether a update was needed due to pending changes.
                 * If force is "auto" then a boolean is returned whether a update was needed due to attribute or size changes.
                 * undefined otherwise.
                 */
                _base.update = function (force) {
                    var attrsChanged;
                    var contentSizeC;
                    var isString = type(force) == TYPES.s;
                    var imgElementSelector = 'img';
                    var imgElementLoadEvent = 'load';
                    var doUpdateAuto;
                    var mutHost;
                    var mutContent;
                    if(isString) {
                        if (force === _strAuto) {
                            attrsChanged = meaningfulAttrsChanged();
                            contentSizeC = updateAutoContentSizeChanged();
                            doUpdateAuto = attrsChanged || contentSizeC;
                            if (doUpdateAuto) {
                                update({
                                    _contentSizeChanged : contentSizeC,
                                    _changedOptions : _initialized ? undefined : _currentPreparedOptions
                                });
                            }
                        }
                        else if (force === _strSync) {
                            if(_mutationObserversConnected) {
                                mutHost = _mutationObserverHostCallback(_mutationObserverHost.takeRecords());
                                mutContent = _mutationObserverContentCallback(_mutationObserverContent.takeRecords());
                            }
                            else {
                                mutHost = _base.update(_strAuto);
                            }
                        }
                        else if (force === 'zoom') {
                            update({
                                _hostSizeChanged : true,
                                _contentSizeChanged : true
                            });
                        }
                    }
                    else {
                        force = _sleeping || force;
                        _sleeping = false;
                        if(!_base.update(_strSync) || force)
                            update({ _force : force });
                    }
                    if(!_isTextarea) {
                        _contentElement.find(imgElementSelector).each(function(i, el) {
                            var index = COMPATIBILITY.inA(el, _imgs);
                            if (index === -1)
                                FRAMEWORK(el).off(imgElementLoadEvent, imgOnLoad).on(imgElementLoadEvent, imgOnLoad);
                        });
                    }
                    return doUpdateAuto || mutHost || mutContent;
                };

                /**
                 Gets or sets the current options. The update method will be called automatically if new options were set.
                 * @param newOptions If new options are given, then the new options will be set, if new options aren't given (undefined or a not a plain object) then the current options will be returned.
                 * @param value If new options is a property path string, then this value will be used to set the option to which the property path string leads.
                 * @returns {*}
                 */
                _base.options = function (newOptions, value) {
                    var option = { };
                    var changedOps;
                    
                    //return current options if newOptions are undefined or empty
                    if (FRAMEWORK.isEmptyObject(newOptions) || !FRAMEWORK.isPlainObject(newOptions)) {
                        if (type(newOptions) == TYPES.s) {
                            if (arguments.length > 1) {
                                setObjectPropVal(option, newOptions, value);
                                changedOps = setOptions(option);
                            }
                            else
                                return getObjectPropVal(_currentOptions, newOptions);
                        }
                        else
                            return _currentOptions;
                    }
                    else {
                        changedOps = setOptions(newOptions);
                    }
                    
                    if(!FRAMEWORK.isEmptyObject(changedOps)) {
                        update({ _changedOptions : changedOps });
                    }    
                };

                /**
                 * Restore the DOM, disconnects all observers, remove all resize observers and put the instance to sleep.
                 */
                _base.destroy = function () {
                    //remove this instance from auto update loop
                    autoUpdateLoop.remove(_base);

                    //disconnect all mutation observers
                    disconnectMutationObservers();

                    //remove all resize observers
                    setupResizeObserver(_sizeObserverElement);
                    setupResizeObserver(_sizeAutoObserverElement);

                    //remove all extensions
                    for(var extName in _extensions)
                        _base.removeExt(extName);

                    //remove all events from host element
                    setupHostMouseTouchEvents(true);

                    //remove all events from structure
                    setupStructureEvents(true);

                    //remove all helper / detection elements
                    if (_contentGlueElement)
                        remove(_contentGlueElement);
                    if (_contentArrangeElement)
                        remove(_contentArrangeElement);
                    if (_sizeAutoObserverAdded)
                        remove(_sizeAutoObserverElement);

                    //remove all generated DOM
                    setupScrollbarsDOM(true);
                    setupScrollbarCornerDOM(true);
                    setupStructureDOM(true);

                    //remove all generated image load events
                    for(var i = 0; i < _imgs[LEXICON.l]; i++)
                        FRAMEWORK(_imgs[i]).off('load', imgOnLoad);
                    _imgs = undefined;

                    _destroyed = true;
                    _sleeping = true;

                    //remove this instance from the instances list
                    INSTANCES(pluginTargetElement, 0);
                    dispatchCallback("onDestroyed");

                    //remove all properties and methods
                    //for (var property in _base)
                    //    delete _base[property];
                    //_base = undefined;
                };

                /**
                 * Scrolls to a given position or element.
                 * @param coordinates
                 * 1. Can be "coordinates" which looks like:
                 *    { x : ?, y : ? } OR          Object with x and y properties
                 *    { left : ?, top : ? } OR     Object with left and top properties
                 *    { l : ?, t : ? } OR          Object with l and t properties
                 *    [ ?, ? ] OR                  Array where the first two element are the coordinates (first is x, second is y)
                 *    ?                            A single value which stays for both axis
                 *    A value can be a number, a string or a calculation.
                 *
                 *    Operators:
                 *    [NONE]  The current scroll will be overwritten by the value.
                 *    '+='    The value will be added to the current scroll offset
                 *    '-='    The value will be subtracted from the current scroll offset
                 *    '*='    The current scroll wil be multiplicated by the value.
                 *    '/='    The current scroll wil be divided by the value.
                 *
                 *    Units:
                 *    [NONE]  The value is the final scroll amount.                   final = (value * 1)
                 *    'px'    Same as none
                 *    '%'     The value is dependent on the current scroll value.     final = ((currentScrollValue / 100) * value)
                 *    'vw'    The value is multiplicated by the viewport width.       final = (value * viewportWidth)
                 *    'vh'    The value is multiplicated by the viewport height.      final = (value * viewportHeight)
                 *
                 *    example final values:
                 *    200, '200px', '50%', '1vw', '1vh', '+=200', '/=1vw', '*=2px', '-=5vh', '+=33%', '+= 50% - 2px', '-= 1vw - 50%'
                 *
                 * 2. Can be a HTML or jQuery element:
                 *    The final scroll offset is the offset (without margin) of the given HTML / jQuery element.
                 *
                 * 3. Can be a object with a HTML or jQuery element with additional settings:
                 *    {
                 *      el : [HTMLElement, jQuery element],             MUST be specified, else this object isn't valid.
                 *      scroll : [string, array, object],               Default value is 'always'.
                 *      block : [string, array, object],                Default value is 'begin'.
                 *      margin : [number, boolean, array, object]       Default value is false.
                 *    }
                 *
                 *    Possible scroll settings are:
                 *    'always'      Scrolls always.
                 *    'ifneeded'    Scrolls only if the element isnt fully in view.
                 *    'never'       Scrolls never.
                 *
                 *    Possible block settings are:
                 *    'begin'   Both axis shall be docked to the "begin" edge. - The element will be docked to the top and left edge of the viewport.
                 *    'end'     Both axis shall be docked to the "end" edge. - The element will be docked to the bottom and right edge of the viewport. (If direction is RTL to the bottom and left edge.)
                 *    'center'  Both axis shall be docked to "center". - The element will be centered in the viewport.
                 *    'nearest' The element will be docked to the nearest edge(s).
                 *
                 *    Possible margin settings are: -- The actual margin of the element wont be affect, this option affects only the final scroll offset.
                 *    [BOOLEAN]                                         If true the css margin of the element will be used, if false no margin will be used.
                 *    [NUMBER]                                          The margin will be used for all edges.
                 *
                 * @param duration The duration of the scroll animation, OR a jQuery animation configuration object.
                 * @param easing The animation easing.
                 * @param complete The animation complete callback.
                 * @returns {{
                 *   position: {x: number, y: number},
                 *   ratio: {x: number, y: number},
                 *   max: {x: number, y: number},
                 *   handleOffset: {x: number, y: number},
                 *   handleLength: {x: number, y: number},
                 *   handleLengthRatio: {x: number, y: number}, t
                 *   rackLength: {x: number, y: number},
                 *   isRTL: boolean,
                 *   isRTLNormalized: boolean
                 *  }}
                 */
                _base.scroll = function (coordinates, duration, easing, complete) {
                    if (arguments.length === 0 || coordinates === undefined) {
                        var infoX = _scrollHorizontalInfo;
                        var infoY = _scrollVerticalInfo;
                        var normalizeInvert = _normalizeRTLCache && _isRTL && _rtlScrollBehavior.i;
                        var normalizeNegate = _normalizeRTLCache && _isRTL && _rtlScrollBehavior.n;
                        var scrollX = infoX._currentScroll;
                        var scrollXRatio = infoX._currentScrollRatio;
                        var maxScrollX = infoX._maxScroll;
                        scrollXRatio = normalizeInvert ? 1 - scrollXRatio : scrollXRatio;
                        scrollX = normalizeInvert ? maxScrollX - scrollX : scrollX;
                        scrollX *= normalizeNegate ? -1 : 1;
                        maxScrollX *= normalizeNegate ? -1 : 1;

                        return {
                            position : {
                                x : scrollX,
                                y : infoY._currentScroll
                            },
                            ratio : {
                                x : scrollXRatio,
                                y : infoY._currentScrollRatio
                            },
                            max : {
                                x : maxScrollX,
                                y : infoY._maxScroll
                            },
                            handleOffset : {
                                x : infoX._handleOffset,
                                y : infoY._handleOffset
                            },
                            handleLength : {
                                x : infoX._handleLength,
                                y : infoY._handleLength
                            },
                            handleLengthRatio : {
                                x : infoX._handleLengthRatio,
                                y : infoY._handleLengthRatio
                            },
                            trackLength : {
                                x : infoX._trackLength,
                                y : infoY._trackLength
                            },
                            snappedHandleOffset : {
                                x : infoX._snappedHandleOffset,
                                y : infoY._snappedHandleOffset
                            },
                            isRTL: _isRTL,
                            isRTLNormalized: _normalizeRTLCache
                        };
                    }
                    
                    _base.update(_strSync);
                    
                    var normalizeRTL = _normalizeRTLCache;
                    var coordinatesXAxisProps = [_strX, _strLeft, 'l'];
                    var coordinatesYAxisProps = [_strY, _strTop, 't'];
                    var coordinatesOperators = ['+=', '-=', '*=', '/='];
                    var durationIsObject = type(duration) == TYPES.o;
                    var completeCallback = durationIsObject ? duration.complete : complete;
                    var i;
                    var finalScroll = { };
                    var specialEasing = {};
                    var doScrollLeft;
                    var doScrollTop;
                    var animationOptions;
                    var strEnd = 'end';
                    var strBegin = 'begin';
                    var strCenter = 'center';
                    var strNearest = 'nearest';
                    var strAlways = 'always';
                    var strNever = 'never';
                    var strIfNeeded = 'ifneeded';
                    var strLength = LEXICON.l;
                    var settingsAxis;
                    var settingsScroll;
                    var settingsBlock;
                    var settingsMargin;
                    var finalElement;
                    var elementObjSettingsAxisValues = [_strX, _strY, 'xy', 'yx'];
                    var elementObjSettingsBlockValues = [strBegin, strEnd, strCenter, strNearest];
                    var elementObjSettingsScrollValues = [strAlways, strNever, strIfNeeded];
                    var coordinatesIsElementObj = coordinates[LEXICON.hOP]('el');
                    var possibleElement = coordinatesIsElementObj ? coordinates.el : coordinates;
                    var possibleElementIsJQuery = possibleElement instanceof FRAMEWORK || JQUERY ? possibleElement instanceof JQUERY : false;
                    var possibleElementIsHTMLElement = possibleElementIsJQuery ? false : isHTMLElement(possibleElement);
                    var proxyCompleteCallback = type(completeCallback) != TYPES.f ? undefined : function() {
                        if(doScrollLeft)
                            refreshScrollbarHandleOffset(true);
                        if(doScrollTop)
                            refreshScrollbarHandleOffset(false);
                        completeCallback();
                    };
                    var checkSettingsStringValue = function (currValue, allowedValues) {
                        for (i = 0; i < allowedValues[strLength]; i++) {
                            if (currValue === allowedValues[i])
                                return true;
                        }
                        return false;
                    };
                    var getRawScroll = function (isX, coordinates) {
                        var coordinateProps = isX ? coordinatesXAxisProps : coordinatesYAxisProps;
                        coordinates = type(coordinates) == TYPES.s || type(coordinates) == TYPES.n ? [ coordinates, coordinates ] : coordinates;

                        if (type(coordinates) == TYPES.a)
                            return isX ? coordinates[0] : coordinates[1];
                        else if (type(coordinates) == TYPES.o) {
                            //decides RTL normalization "hack" with .n
                            //normalizeRTL = type(coordinates.n) == TYPES.b ? coordinates.n : normalizeRTL; 
                            for (i = 0; i < coordinateProps[strLength]; i++)
                                if (coordinateProps[i] in coordinates)
                                    return coordinates[coordinateProps[i]];
                        }
                    };
                    var getFinalScroll = function (isX, rawScroll) {
                        var isString = type(rawScroll) == TYPES.s;
                        var operator;
                        var amount;
                        var scrollInfo = isX ? _scrollHorizontalInfo : _scrollVerticalInfo;
                        var currScroll = scrollInfo._currentScroll;
                        var maxScroll = scrollInfo._maxScroll;
                        var mult = ' * ';
                        var finalValue;
                        var isRTLisX = _isRTL && isX;
                        var normalizeShortcuts = isRTLisX && _rtlScrollBehavior.n && !normalizeRTL;
                        var strReplace = 'replace';
                        var evalFunc = eval;
                        var possibleOperator;
                        if (isString) {
                            //check operator
                            if (rawScroll[strLength] > 2) {
                                possibleOperator = rawScroll.substr(0, 2);
                                if(inArray(possibleOperator, coordinatesOperators) > -1)
                                    operator = possibleOperator;
                            }

                            //calculate units and shortcuts
                            rawScroll = operator ? rawScroll.substr(2) : rawScroll;
                            rawScroll = rawScroll
                            [strReplace](/min/g, 0) //'min' = 0%
                            [strReplace](/</g, 0)   //'<'   = 0%
                            [strReplace](/max/g, (normalizeShortcuts ? '-' : _strEmpty) + _strHundredPercent)    //'max' = 100%
                            [strReplace](/>/g, (normalizeShortcuts ? '-' : _strEmpty) + _strHundredPercent)      //'>'   = 100%
                            [strReplace](/px/g, _strEmpty)
                            [strReplace](/%/g, mult + (maxScroll * (isRTLisX && _rtlScrollBehavior.n ? -1 : 1) / 100.0))
                            [strReplace](/vw/g, mult + _viewportSize.w)
                            [strReplace](/vh/g, mult + _viewportSize.h);
                            amount = parseToZeroOrNumber(isNaN(rawScroll) ? parseToZeroOrNumber(evalFunc(rawScroll), true).toFixed() : rawScroll);
                        }
                        else {
                            amount = rawScroll;
                        }

                        if (amount !== undefined && !isNaN(amount) && type(amount) == TYPES.n) {
                            var normalizeIsRTLisX = normalizeRTL && isRTLisX;
                            var operatorCurrScroll = currScroll * (normalizeIsRTLisX && _rtlScrollBehavior.n ? -1 : 1);
                            var invert = normalizeIsRTLisX && _rtlScrollBehavior.i;
                            var negate = normalizeIsRTLisX && _rtlScrollBehavior.n;
                            operatorCurrScroll = invert ? (maxScroll - operatorCurrScroll) : operatorCurrScroll;
                            switch (operator) {
                                case '+=':
                                    finalValue = operatorCurrScroll + amount;
                                    break;
                                case '-=':
                                    finalValue = operatorCurrScroll - amount;
                                    break;
                                case '*=':
                                    finalValue = operatorCurrScroll * amount;
                                    break;
                                case '/=':
                                    finalValue = operatorCurrScroll / amount;
                                    break;
                                default:
                                    finalValue = amount;
                                    break;
                            }
                            finalValue = invert ? maxScroll - finalValue : finalValue;
                            finalValue *= negate ? -1 : 1;
                            finalValue = isRTLisX && _rtlScrollBehavior.n ? MATH.min(0, MATH.max(maxScroll, finalValue)) : MATH.max(0, MATH.min(maxScroll, finalValue));
                        }
                        return finalValue === currScroll ? undefined : finalValue;
                    };
                    var getPerAxisValue = function (value, valueInternalType, defaultValue, allowedValues) {
                        var resultDefault = [ defaultValue, defaultValue ];
                        var valueType = type(value);
                        var valueArrLength;
                        var valueArrItem;

                        //value can be [ string, or array of two strings ]
                        if (valueType == valueInternalType) {
                            value = [value, value];
                        }
                        else if (valueType == TYPES.a) {
                            valueArrLength = value[strLength];
                            if (valueArrLength > 2 || valueArrLength < 1)
                                value = resultDefault;
                            else {
                                if (valueArrLength === 1)
                                    value[1] = defaultValue;
                                for (i = 0; i < valueArrLength; i++) {
                                    valueArrItem = value[i];
                                    if (type(valueArrItem) != valueInternalType || !checkSettingsStringValue(valueArrItem, allowedValues)) {
                                        value = resultDefault;
                                        break;
                                    }
                                }
                            }
                        }
                        else if (valueType == TYPES.o)
                            value = [ value[_strX]|| defaultValue, value[_strY] || defaultValue];
                        else
                            value = resultDefault;
                        return { x : value[0], y : value[1] };
                    };
                    var generateMargin = function (marginTopRightBottomLeftArray) {
                        var result = [ ];
                        var currValue;
                        var currValueType;
                        var valueDirections = [ _strTop, _strRight, _strBottom, _strLeft ];
                        for(i = 0; i < marginTopRightBottomLeftArray[strLength]; i++) {
                            if(i === valueDirections[strLength])
                                break;
                            currValue = marginTopRightBottomLeftArray[i];
                            currValueType = type(currValue);
                            if(currValueType == TYPES.b)
                                result.push(currValue ? parseToZeroOrNumber(finalElement.css(_strMarginMinus + valueDirections[i])) : 0);
                            else
                                result.push(currValueType == TYPES.n ? currValue : 0);
                        }
                        return result;
                    };

                    if (possibleElementIsJQuery || possibleElementIsHTMLElement) {
                        //get settings
                        var margin = coordinatesIsElementObj ? coordinates.margin : 0;
                        var axis = coordinatesIsElementObj ? coordinates.axis : 0;
                        var scroll = coordinatesIsElementObj ? coordinates.scroll : 0;
                        var block = coordinatesIsElementObj ? coordinates.block : 0;
                        var marginDefault = [ 0, 0, 0, 0 ];
                        var marginType = type(margin);
                        var marginLength;
                        finalElement = possibleElementIsJQuery ? possibleElement : FRAMEWORK(possibleElement);
                        if (finalElement[strLength] === 0)
                            return;

                        //margin can be [ boolean, number, array of 2, array of 4, object ]
                        if (marginType == TYPES.n || marginType == TYPES.b)
                            margin = generateMargin([margin, margin, margin, margin]);
                        else if (marginType == TYPES.a) {
                            marginLength = margin[strLength];
                            if(marginLength === 2)
                                margin = generateMargin([margin[0], margin[1], margin[0], margin[1]]);
                            else if(marginLength >= 4)
                                margin = generateMargin(margin);
                            else
                                margin = marginDefault;
                        }
                        else if (marginType == TYPES.o)
                            margin = generateMargin([margin[_strTop], margin[_strRight], margin[_strBottom], margin[_strLeft]]);
                        else
                            margin = marginDefault;

                        //block = type(block) === TYPES.b ? block ? [ strNearest, strBegin ] : [ strNearest, strEnd ] : block;
                        settingsAxis = checkSettingsStringValue(axis, elementObjSettingsAxisValues) ? axis : 'xy';
                        settingsScroll = getPerAxisValue(scroll, TYPES.s, strAlways, elementObjSettingsScrollValues);
                        settingsBlock = getPerAxisValue(block, TYPES.s, strBegin, elementObjSettingsBlockValues);
                        settingsMargin = margin;

                        var viewportScroll = {
                            l: _scrollHorizontalInfo._currentScroll,
                            t: _scrollVerticalInfo._currentScroll
                        };
                        // use padding element instead of viewport element because padding element has never padding, margin or position applied.
                        var viewportOffset = _paddingElement.offset();

                        //get coordinates
                        var elementOffset = finalElement.offset();
                        var doNotScroll = {
                            x : settingsScroll.x == strNever || settingsAxis == _strY,
                            y : settingsScroll.y == strNever || settingsAxis == _strX
                        };
                        elementOffset[_strTop] -= settingsMargin[0];
                        elementOffset[_strLeft] -= settingsMargin[3];
                        var elementScrollCoordinates = {
                            x: MATH.round(elementOffset[_strLeft] - viewportOffset[_strLeft] + viewportScroll.l),
                            y: MATH.round(elementOffset[_strTop] - viewportOffset[_strTop] + viewportScroll.t)
                        };
                        if (_isRTL) {
                            if (!_rtlScrollBehavior.n && !_rtlScrollBehavior.i)
                                elementScrollCoordinates.x = MATH.round(viewportOffset[_strLeft] - elementOffset[_strLeft] + viewportScroll.l);
                            if (_rtlScrollBehavior.n && normalizeRTL)
                                elementScrollCoordinates.x *= -1;
                            if (_rtlScrollBehavior.i && normalizeRTL)
                                elementScrollCoordinates.x = MATH.round(viewportOffset[_strLeft] - elementOffset[_strLeft] + (_scrollHorizontalInfo._maxScroll - viewportScroll.l));
                        }

                        //measuring is required
                        if (settingsBlock.x != strBegin || settingsBlock.y != strBegin || settingsScroll.x == strIfNeeded || settingsScroll.y == strIfNeeded || _isRTL) {
                            var measuringElm = finalElement[0];
                            var rawElementSize = _supportTransform ? measuringElm.getBoundingClientRect() : {
                                width : measuringElm[LEXICON.oW],
                                height : measuringElm[LEXICON.oH]
                            };
                            var elementSize = {
                                w: rawElementSize[_strWidth] + settingsMargin[3] + settingsMargin[1],
                                h: rawElementSize[_strHeight] + settingsMargin[0] + settingsMargin[2]
                            };
                            var finalizeBlock = function(isX) {
                                var vars = getScrollbarVars(isX);
                                var wh = vars._w_h;
                                var lt = vars._left_top;
                                var xy = vars._x_y;
                                var blockIsEnd = settingsBlock[xy] == (isX ? _isRTL ? strBegin : strEnd : strEnd);
                                var blockIsCenter = settingsBlock[xy] == strCenter;
                                var blockIsNearest = settingsBlock[xy] == strNearest;
                                var scrollNever = settingsScroll[xy] == strNever;
                                var scrollIfNeeded = settingsScroll[xy] == strIfNeeded;
                                var vpSize = _viewportSize[wh];
                                var vpOffset = viewportOffset[lt];
                                var elSize = elementSize[wh];
                                var elOffset = elementOffset[lt];
                                var divide = blockIsCenter ? 2 : 1;
                                var elementCenterOffset = elOffset + (elSize / 2);
                                var viewportCenterOffset = vpOffset + (vpSize / 2);
                                var isInView =
                                    elSize <= vpSize
                                    && elOffset >= vpOffset
                                    && elOffset + elSize <= vpOffset + vpSize;

                                if(scrollNever)
                                    doNotScroll[xy] = true;
                                else if(!doNotScroll[xy]) {
                                    if (blockIsNearest || scrollIfNeeded) {
                                        doNotScroll[xy] = scrollIfNeeded ? isInView : false;
                                        blockIsEnd = elSize < vpSize ? elementCenterOffset > viewportCenterOffset : elementCenterOffset < viewportCenterOffset;
                                    }
                                    elementScrollCoordinates[xy] -= blockIsEnd || blockIsCenter ? ((vpSize / divide) - (elSize / divide)) * (isX && _isRTL && normalizeRTL ? -1 : 1) : 0;
                                }
                            };
                            finalizeBlock(true);
                            finalizeBlock(false);
                        }

                        if (doNotScroll.y)
                            delete elementScrollCoordinates.y;
                        if (doNotScroll.x)
                            delete elementScrollCoordinates.x;

                        coordinates = elementScrollCoordinates;
                    }

                    finalScroll[_strScrollLeft] = getFinalScroll(true, getRawScroll(true, coordinates));
                    finalScroll[_strScrollTop] = getFinalScroll(false, getRawScroll(false, coordinates));
                    doScrollLeft = finalScroll[_strScrollLeft] !== undefined;
                    doScrollTop = finalScroll[_strScrollTop] !== undefined;

                    if ((doScrollLeft || doScrollTop) && (duration > 0 || durationIsObject)) {
                        if (durationIsObject) {
                            duration.complete = proxyCompleteCallback;
                            _viewportElement.animate(finalScroll, duration);
                        }
                        else {
                            animationOptions = {
                                duration: duration,
                                complete: proxyCompleteCallback
                            };
                            if (type(easing) == TYPES.a || FRAMEWORK.isPlainObject(easing)) {
                                specialEasing[_strScrollLeft] = easing[0] || easing.x;
                                specialEasing[_strScrollTop] = easing[1] || easing.y;
                                animationOptions.specialEasing = specialEasing;
                            }
                            else {
                                animationOptions.easing = easing;
                            }
                            _viewportElement.animate(finalScroll, animationOptions);
                        }
                    }
                    else {
                        if (doScrollLeft)
                            _viewportElement[_strScrollLeft](finalScroll[_strScrollLeft]);
                        if (doScrollTop)
                            _viewportElement[_strScrollTop](finalScroll[_strScrollTop]);
                    }
                };

                /**
                 * Stops all scroll animations.
                 * @returns {*} The current OverlayScrollbars instance (for chaining).
                 */
                _base.scrollStop = function (param1, param2, param3) {
                    _viewportElement.stop(param1, param2, param3);
                    return _base;
                };

                /**
                 * Returns all relevant elements.
                 * @param elementName The name of the element which shall be returned.
                 * @returns {{target: *, host: *, padding: *, viewport: *, content: *, scrollbarHorizontal: {scrollbar: *, track: *, handle: *}, scrollbarVertical: {scrollbar: *, track: *, handle: *}, scrollbarCorner: *} | *}
                 */
                _base.getElements = function (elementName) {
                    var obj = {
                        target: _targetElementNative,
                        host: _hostElementNative,
                        padding: _paddingElementNative,
                        viewport: _viewportElementNative,
                        content: _contentElementNative,
                        scrollbarHorizontal: {
                            scrollbar: _scrollbarHorizontalElement[0],
                            track: _scrollbarHorizontalTrackElement[0],
                            handle: _scrollbarHorizontalHandleElement[0]
                        },
                        scrollbarVertical: {
                            scrollbar: _scrollbarVerticalElement[0],
                            track: _scrollbarVerticalTrackElement[0],
                            handle: _scrollbarVerticalHandleElement[0]
                        },
                        scrollbarCorner: _scrollbarCornerElement[0]
                    };
                    return type(elementName) == TYPES.s ? getObjectPropVal(obj, elementName) : obj;
                };

                /**
                 * Returns a object which describes the current state of this instance.
                 * @param stateProperty A specific property from the state object which shall be returned.
                 * @returns {{widthAuto, heightAuto, overflowAmount, hideOverflow, hasOverflow, contentScrollSize, viewportSize, hostSize, autoUpdate} | *}
                 */
                _base.getState = function (stateProperty) {
                    function prepare(obj) {
                        if (!FRAMEWORK.isPlainObject(obj))
                            return obj;
                        var extended = extendDeep({}, obj);
                        var changePropertyName = function (from, to) {
                            if (extended[LEXICON.hOP](from)) {
                                extended[to] = extended[from];
                                delete extended[from];
                            }
                        };
                        changePropertyName('w', _strWidth); //change w to width
                        changePropertyName('h', _strHeight); //change h to height
                        delete extended.c; //delete c (the 'changed' prop)
                        return extended;
                    };
                    var obj = {
                        destroyed: !!prepare(_destroyed),
                        sleeping: !!prepare(_sleeping),
                        autoUpdate: prepare(!_mutationObserversConnected),
                        widthAuto: prepare(_widthAutoCache),
                        heightAuto: prepare(_heightAutoCache),
                        padding: prepare(_cssPaddingCache),
                        overflowAmount: prepare(_overflowAmountCache),
                        hideOverflow: prepare(_hideOverflowCache),
                        hasOverflow: prepare(_hasOverflowCache),
                        contentScrollSize: prepare(_contentScrollSizeCache),
                        viewportSize: prepare(_viewportSize),
                        hostSize: prepare(_hostSizeCache),
                        documentMixed : prepare(_documentMixed)
                    };
                    return type(stateProperty) == TYPES.s ? getObjectPropVal(obj, stateProperty) : obj;
                };

                /**
                 * Gets all or specific extension instance.
                 * @param extName The name of the extension from which the instance shall be got.
                 * @returns {{}} The instance of the extension with the given name or undefined if the instance couldn't be found.
                 */
                _base.ext = function(extName) {
                    var result;
                    var privateMethods = _extensionsPrivateMethods.split(' ');
                    var i = 0;
                    if(type(extName) == TYPES.s) {
                        if(_extensions[LEXICON.hOP](extName)) {
                            result = extendDeep({}, _extensions[extName]);
                            for (; i < privateMethods.length; i++)
                                delete result[privateMethods[i]];
                        }
                    }
                    else {
                        result = { };
                        for(i in _extensions)
                            result[i] = extendDeep({ }, _base.ext(i));
                    }
                    return result;
                };

                /**
                 * Adds a extension to this instance.
                 * @param extName The name of the extension which shall be added.
                 * @param extensionOptions The extension options which shall be used.
                 * @returns {{}} The instance of the added extension or undefined if the extension couldn't be added properly.
                 */
                _base.addExt = function(extName, extensionOptions) {
                    var registeredExtensionObj = window[PLUGINNAME].extension(extName);
                    var instance;
                    var instanceAdded;
                    var instanceContract;
                    var contractResult;
                    var contractFulfilled = true;
                    if(registeredExtensionObj) {
                        if(!_extensions[LEXICON.hOP](extName)) {
                            instance = registeredExtensionObj.extensionFactory.call(_base,
                                extendDeep({ }, registeredExtensionObj.defaultOptions),
                                FRAMEWORK,
                                COMPATIBILITY);

                            if (instance) {
                                instanceContract = instance.contract;
                                if (type(instanceContract) == TYPES.f) {
                                    contractResult = instanceContract(window);
                                    contractFulfilled = type(contractResult) == TYPES.b ? contractResult : contractFulfilled;
                                }
                                if(contractFulfilled) {
                                    _extensions[extName] = instance;
                                    instanceAdded = instance.added;
                                    if(type(instanceAdded) == TYPES.f)
                                        instanceAdded(extensionOptions);

                                    return _base.ext(extName);
                                }
                            }
                        }
                        else
                            return _base.ext(extName);
                    }
                    else
                        console.warn("A extension with the name \"" + extName + "\" isn't registered.");
                };

                /**
                 * Removes a extension from this instance.
                 * @param extName The name of the extension which shall be removed.
                 * @returns {boolean} True if the extension was removed, false otherwise e.g. if the extension wasn't added before.
                 */
                _base.removeExt = function(extName) {
                    var instance = _extensions[extName];
                    var instanceRemoved;
                    if(instance) {
                        delete _extensions[extName];

                        instanceRemoved = instance.removed;
                        if(type(instanceRemoved) == TYPES.f)
                            instanceRemoved();

                        return true;
                    }
                    return false;
                };

                /**
                 * Constructs the plugin.
                 * @param targetElement The element to which the plugin shall be applied.
                 * @param options The initial options of the plugin.
                 * @param extensions The extension(s) which shall be added right after the initialization.
                 * @returns {boolean} True if the plugin was successfully initialized, false otherwise.
                 */
                function construct(targetElement, options, extensions) {
                    _defaultOptions = globals.defaultOptions;
                    _nativeScrollbarStyling = globals.nativeScrollbarStyling;
                    _nativeScrollbarSize = extendDeep({}, globals.nativeScrollbarSize);
                    _nativeScrollbarIsOverlaid = extendDeep({}, globals.nativeScrollbarIsOverlaid);
                    _overlayScrollbarDummySize = extendDeep({}, globals.overlayScrollbarDummySize);
                    _rtlScrollBehavior = extendDeep({}, globals.rtlScrollBehavior);

                    //parse & set options but don't update
                    setOptions(extendDeep({ }, _defaultOptions, options));

                    //check if the plugin hasn't to be initialized
                    if (_nativeScrollbarIsOverlaid.x && _nativeScrollbarIsOverlaid.x && !_currentPreparedOptions.nativeScrollbarsOverlaid.initialize) {
                        dispatchCallback("onInitializationWithdrawn");
                        return false;
                    }

                    _cssCalc = globals.cssCalc;
                    _msieVersion = globals.msie;
                    _autoUpdateRecommended = globals.autoUpdateRecommended;
                    _supportTransition = globals.supportTransition;
                    _supportTransform = globals.supportTransform;
                    _supportPassiveEvents = globals.supportPassiveEvents;
                    _supportResizeObserver = globals.supportResizeObserver;
                    _supportMutationObserver = globals.supportMutationObserver;
                    _restrictedMeasuring = globals.restrictedMeasuring;
                    _documentElement = FRAMEWORK(targetElement.ownerDocument);
                    _documentElementNative = _documentElement[0];
                    _windowElement = FRAMEWORK(_documentElementNative.defaultView || _documentElementNative.parentWindow);
                    _windowElementNative = _windowElement[0];
                    _htmlElement = findFirst(_documentElement, 'html');
                    _bodyElement =  findFirst(_htmlElement, 'body');
                    _targetElement = FRAMEWORK(targetElement);
                    _targetElementNative = _targetElement[0];
                    _isTextarea = _targetElement.is('textarea');
                    _isBody = _targetElement.is('body');
                    _documentMixed = _documentElementNative !== document;

                    var initBodyScroll;
                    if (_isBody) {
                        initBodyScroll = {};
                        initBodyScroll.l = MATH.max(_targetElement[_strScrollLeft](), _htmlElement[_strScrollLeft](), _windowElement[_strScrollLeft]());
                        initBodyScroll.t = MATH.max(_targetElement[_strScrollTop](), _htmlElement[_strScrollTop](), _windowElement[_strScrollTop]());
                    }

                    //build OverlayScrollbars DOM and Events
                    setupStructureDOM();
                    setupStructureEvents();

                    //build Scrollbars DOM and Events
                    setupScrollbarsDOM();
                    setupScrollbarEvents(true);
                    setupScrollbarEvents(false);

                    //build Scrollbar Corner DOM and Events
                    setupScrollbarCornerDOM();
                    setupScrollbarCornerEvents();

                    //create mutation observers
                    createMutationObservers();

                    if(_isBody) {
                        //apply the body scroll to handle it right in the update method
                        _viewportElement[_strScrollLeft](initBodyScroll.l)[_strScrollTop](initBodyScroll.t);

                        //set the focus on the viewport element so you dont have to click on the page to use keyboard keys (up / down / space) for scrolling
                        if(document.activeElement == targetElement && _viewportElementNative.focus) {
                            //set a tabindex to make the viewportElement focusable
                            _viewportElement.attr('tabindex', '-1');
                            _viewportElementNative.focus();
                            /* the tabindex has to be removed due to;
                             * If you set the tabindex attribute on an <div>, then its child content cannot be scrolled with the arrow keys unless you set tabindex on the content, too
                             * https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex
                             */
                            _viewportElement.one(_strMouseTouchDownEvent, function() {
                                _viewportElement.removeAttr('tabindex');
                            });
                        }
                    }

                    //build resize observer for the host element
                    setupResizeObserver(_sizeObserverElement, hostOnResized);

                    //update for the first time & initialize cache
                    _base.update(_strAuto);

                    //the plugin is initialized now!
                    _initialized = true;
                    dispatchCallback("onInitialized");

                    //call all callbacks which would fire before the initialized was complete
                    each(_callbacksInitQeueue, function(index, value) { dispatchCallback(value.n, value.a); });
                    _callbacksInitQeueue = [ ];

                    //add extensions
                    if(type(extensions) == TYPES.s)
                        extensions = [ extensions ];
                    if(COMPATIBILITY.isA(extensions))
                        each(extensions, function (index, value) {_base.addExt(value); });
                    else if(FRAMEWORK.isPlainObject(extensions))
                        each(extensions, function (key, value) { _base.addExt(key, value); });

                    //add the transition class for transitions AFTER the first update & AFTER the applied extensions (for preventing unwanted transitions)
                    setTimeout(function () {
                        if (_supportTransition && !_destroyed)
                            addClass(_hostElement, _classNameHostTransition);
                    }, 333);

                    return _initialized;
                }

                if (construct(pluginTargetElement, options, extensions)) {
                    INSTANCES(pluginTargetElement, _base);
                    return _base;
                }
                _base = undefined;
            }

            /**
             * Initializes a new OverlayScrollbarsInstance object or changes options if already initialized or returns the current instance.
             * @param pluginTargetElements The elements to which the Plugin shall be initialized.
             * @param options The custom options with which the plugin shall be initialized.
             * @param extensions The extension(s) which shall be added right after initialization.
             * @returns {*}
             */
            window[PLUGINNAME] = function(pluginTargetElements, options, extensions) {
                if(arguments[LEXICON.l] === 0)
                    return this;

                var arr = [ ];
                var optsIsPlainObj = FRAMEWORK.isPlainObject(options);
                var inst;
                var result;

                //pluginTargetElements is null or undefined
                if(!pluginTargetElements)
                    return optsIsPlainObj || !options ? result : arr;

                /*
                   pluginTargetElements will be converted to:
                   1. A jQueryElement Array
                   2. A HTMLElement Array
                   3. A Array with a single HTML Element
                   so pluginTargetElements is always a array.
                */
                pluginTargetElements = pluginTargetElements[LEXICON.l] != undefined ? pluginTargetElements : [ pluginTargetElements[0] || pluginTargetElements ];
                initOverlayScrollbarsStatics();

                if(pluginTargetElements[LEXICON.l] > 0) {
                    if(optsIsPlainObj) {
                        FRAMEWORK.each(pluginTargetElements, function (i, v) {
                            inst = v;
                            if(inst !== undefined)
                                arr.push(OverlayScrollbarsInstance(inst, options, extensions, _pluginsGlobals, _pluginsAutoUpdateLoop));
                        });
                    }
                    else {
                        FRAMEWORK.each(pluginTargetElements, function(i, v) {
                            inst = INSTANCES(v);
                            if((options === '!' && inst instanceof window[PLUGINNAME]) || (COMPATIBILITY.type(options) == TYPES.f && options(v, inst)))
                                arr.push(inst);
                            else if(options === undefined)
                                arr.push(inst);
                        });
                    }
                    result = arr[LEXICON.l] === 1 ? arr[0] : arr;
                }
                return result;
            };

            /**
             * Returns a object which contains global information about the plugin and each instance of it.
             * The returned object is just a copy, that means that changes to the returned object won't have any effect to the original object.
             */
            window[PLUGINNAME].globals = function () {
                initOverlayScrollbarsStatics();
                var globals = FRAMEWORK.extend(true, { }, _pluginsGlobals);
                delete globals['msie'];
                return globals;
            };

            /**
             * Gets or Sets the default options for each new plugin initialization.
             * @param newDefaultOptions The object with which the default options shall be extended.
             */
            window[PLUGINNAME].defaultOptions = function(newDefaultOptions) {
                initOverlayScrollbarsStatics();
                var currDefaultOptions = _pluginsGlobals.defaultOptions;
                if(newDefaultOptions === undefined)
                    return FRAMEWORK.extend(true, { }, currDefaultOptions);

                //set the new default options
                _pluginsGlobals.defaultOptions = FRAMEWORK.extend(true, { }, currDefaultOptions , _pluginsOptions._validate(newDefaultOptions, _pluginsOptions._template, true, currDefaultOptions)._default);
            };

            /**
             * Registers, Unregisters or returns a extension.
             * Register: Pass the name and the extension. (defaultOptions is optional)
             * Unregister: Pass the name and anything except a function as extension parameter.
             * Get extension: Pass the name of the extension which shall be got.
             * Get all extensions: Pass no arguments.
             * @param extensionName The name of the extension which shall be registered, unregistered or returned.
             * @param extension A function which generates the instance of the extension or anything other to remove a already registered extension.
             * @param defaultOptions The default options which shall be used for the registered extension.
             */
            window[PLUGINNAME].extension = function(extensionName, extension, defaultOptions) {
                var extNameTypeString = COMPATIBILITY.type(extensionName) == TYPES.s;
                var argLen = arguments[LEXICON.l];
                var i = 0;
                if(argLen < 1 || !extNameTypeString) {
                    //return a copy of all extension objects
                    return FRAMEWORK.extend(true, { length : _pluginsExtensions[LEXICON.l] }, _pluginsExtensions);
                }
                else if(extNameTypeString) {
                    if(COMPATIBILITY.type(extension) == TYPES.f) {
                        //register extension
                        _pluginsExtensions.push({
                            name : extensionName,
                            extensionFactory : extension,
                            defaultOptions : defaultOptions
                        });
                    }
                    else {
                        for(; i < _pluginsExtensions[LEXICON.l]; i++) {
                            if (_pluginsExtensions[i].name === extensionName) {
                                if(argLen > 1)
                                    _pluginsExtensions.splice(i, 1); //remove extension
                                else
                                    return FRAMEWORK.extend(true, { }, _pluginsExtensions[i]); //return extension with the given name
                            }
                        }
                    }
                }
            };

            return window[PLUGINNAME];
        })();

        if(JQUERY && JQUERY.fn) {
            /**
             * The jQuery initialization interface.
             * @param options The initial options for the construction of the plugin. To initialize the plugin, this option has to be a object! If it isn't a object, the instance(s) are returned and the plugin wont be initialized.
             * @param extensions The extension(s) which shall be added right after initialization.
             * @returns {*} After initialization it returns the jQuery element array, else it returns the instance(s) of the elements which are selected.
             */
            JQUERY.fn.overlayScrollbars = function (options, extensions) {
                var _elements = this;
                if(JQUERY.isPlainObject(options)) {
                    JQUERY.each(_elements, function() { PLUGIN(this, options, extensions); });
                    return _elements;
                }
                else
                    return PLUGIN(_elements, options);
            };
        }
        return PLUGIN;
    }
));
},
'url:appivo/vue/html/HelpLink.html':"<a v-if=\"!isVideo\" :href=\"url\" target=\"_blank\" :class=\"['helplink', classes]\"><i v-if=\"icon\" :class=\"icon\"></i>{{ label }}</a>\n<a v-else @click=\"showVideo\" :class=\"['helplink', classes]\"><i v-if=\"icon\" :class=\"icon\"></i>{{ label }} </a>\n",
'url:appivo/vue/html/TextBox.html':"<span class=\"inlineEditWrap textbox\">\n\t<input v-if=\"!multiline\" :id=\"id\" v-el:input :style=\"styles\"\n\t\t:class=\"['form-control', internalClasses, required]\"\n\t\t:type=\"type\"\n\t\t:min=\"min\" :max=\"max\"\n\t\t:maxlength=\"maxLength\"\n\t\t:placeholder=\"placeholder\"\n\t\t:value=\"inputValue\"\n\t\t@input=\"inputChange($event)\"\n\t\t@change=\"valueChanged\"\n\t\t:disabled=\"disabled\"\n\t\t:autocomplete=\"autocomplete\">\n\t</input>\n\n\t<textarea v-if=\"multiline\" :id=\"id\" v-el:input :style=\"styles\"\n\t\t:class=\"['form-control', internalClasses, required]\"\n\t\t:maxlength=\"maxLength\"\n\t\t:placeholder=\"placeholder\"\n\t\ttype=\"text\"\n\t\t:rows=\"rows\"\n\t\t:value=\"inputValue\"\n\t\t@input=\"inputChange($event)\"\n\t\t@change=\"valueChanged\"\n\t\t:disabled=\"disabled\"\n\t\t:autocomplete=\"autocomplete\">\n\t</textarea>\n\n\t<span v-if=\"showValidationMessage\" :class=\"[internalClasses, errorposition]\" class=\"error\">\n\t\t<i class=\"ion-alert-circled\" v-show=\"validationError\"></i> {{validationError}}\n\t</span>\n</span>\n",
'url:appivo/vue/html/PlaceHolderImg.html':"<div class=\"placeholderimg\" data-ui=\"appivo-component\">\n    <div v-if=\"!invalidImage && !invalidSrc\" :style=\"cssStyle\">\n        <img :src=\"placeHolder\" :alt=\"alt\" v-show=\"!loaded\" :class=\"cssClass\">\n        <img :src=\"src\" v-show=\"loaded\" :class=\"cssClass\" @error=\"onProfileImageError\" @load=\"onImageLoad\">\n    </div>\n    <div v-else :style=\"cssStyle\">\n        <div v-if=\"mode === 'Initials'\" class=\"placeholderimg__wrp\">\n            <span class=\"placeholderimg__profile-initials\" :style=\"[cssStyle, assignRandomColor]\" :class=\"cssClass\">{{ getInitials(userItemObject) }}</span>\n        </div>\n        <div v-else class=\"placeholderimg__wrp\">\n            <img :src=\"placeHolder\" :alt=\"alt\" v-show=\"!loaded\" :class=\"cssClass\">\n        </div>\n    </div>\n</div>\n",
'url:dijit/templates/Menu.html':"<table class=\"dijit dijitMenu dijitMenuPassive dijitReset dijitMenuTable\" role=\"menu\" tabIndex=\"${tabIndex}\"\n\t   cellspacing=\"0\">\n\t<tbody class=\"dijitReset\" data-dojo-attach-point=\"containerNode\"></tbody>\n</table>\n",
'url:dijit/templates/MenuItem.html':"<tr class=\"dijitReset\" data-dojo-attach-point=\"focusNode\" role=\"menuitem\" tabIndex=\"-1\">\n\t<td class=\"dijitReset dijitMenuItemIconCell\" role=\"presentation\">\n\t\t<span role=\"presentation\" class=\"dijitInline dijitIcon dijitMenuItemIcon\" data-dojo-attach-point=\"iconNode\"></span>\n\t</td>\n\t<td class=\"dijitReset dijitMenuItemLabel\" colspan=\"2\" data-dojo-attach-point=\"containerNode,textDirNode\"\n\t\trole=\"presentation\"></td>\n\t<td class=\"dijitReset dijitMenuItemAccelKey\" style=\"display: none\" data-dojo-attach-point=\"accelKeyNode\"></td>\n\t<td class=\"dijitReset dijitMenuArrowCell\" role=\"presentation\">\n\t\t<span data-dojo-attach-point=\"arrowWrapper\" style=\"visibility: hidden\">\n\t\t\t<span class=\"dijitInline dijitIcon dijitMenuExpand\"></span>\n\t\t\t<span class=\"dijitMenuExpandA11y\">+</span>\n\t\t</span>\n\t</td>\n</tr>\n",
'url:appivo/util/LocaleOptions.json':"{\n   \"en\":\"English\",\n   \"sv\":\"Swedish\",\n   \"da\":\"Danish\",\n   \"de\":\"German\",\n   \"no\":\"Norwegian\",\n   \"fi\":\"Finnish\",\n   \"fr\":\"French\",\n   \"es\":\"Spanish\"\n}\n",
'url:appivo/model/SampleModel.json':"{\n    \"id\" : \"148420715de001020304050607000001\",\n    \"type\" : \"Data\",\n    \"ver\" : 0,\n    \"name\" : \"Sample\",\n    \"description\" : \"\",\n    \"uri\" : \"/app/appivo/model/Sample\",\n    \"label\" : \"Name\",\n    \"sort\" : \"Name\",\n    \"hidden\" : false,\n    \"exportable\" : true,\n    \"spec\" : {\n    },\n    \"attributes\" : [ {\n      \"relation\" : false,\n      \"id\" : \"14842071867001020304050607000001\",\n      \"ver\" : 0,\n      \"name\" : \"id\",\n      \"type\" : \"ID\",\n      \"size\" : 16,\n      \"decimalDigits\" : 0,\n      \"notNull\" : true,\n      \"unsigned\" : false,\n      \"sequence\" : false,\n      \"system\" : true,\n      \"secret\" : false,\n      \"personal\" : false,\n      \"unique\" : false,\n      \"primaryKey\" : true\n    }, {\n      \"relation\" : false,\n      \"id\" : \"14842071868001020304050607000001\",\n      \"ver\" : 0,\n      \"name\" : \"created_at\",\n      \"type\" : \"TIMESTAMP\",\n      \"defaultValue\" : \"CURRENT_TIMESTAMP\",\n      \"size\" : 19,\n      \"decimalDigits\" : 0,\n      \"notNull\" : true,\n      \"unsigned\" : false,\n      \"sequence\" : false,\n      \"system\" : true,\n      \"secret\" : false,\n      \"personal\" : false,\n      \"unique\" : false,\n      \"primaryKey\" : false\n    }, {\n      \"relation\" : false,\n      \"id\" : \"14842071868001020304050607000002\",\n      \"ver\" : 3,\n      \"name\" : \"updated_at\",\n      \"type\" : \"TIMESTAMP\",\n      \"defaultValue\" : \"CURRENT_TIMESTAMP\",\n      \"size\" : 19,\n      \"decimalDigits\" : 0,\n      \"notNull\" : true,\n      \"unsigned\" : false,\n      \"sequence\" : false,\n      \"system\" : true,\n      \"secret\" : false,\n      \"personal\" : false,\n      \"unique\" : false,\n      \"primaryKey\" : false\n    }, {\n      \"relation\" : false,\n      \"id\" : \"14842071868001020304050607000003\",\n      \"ver\" : 0,\n      \"name\" : \"ver\",\n      \"type\" : \"INTEGER\",\n      \"defaultValue\" : \"0\",\n      \"size\" : 10,\n      \"decimalDigits\" : 0,\n      \"notNull\" : true,\n      \"unsigned\" : true,\n      \"sequence\" : false,\n      \"system\" : true,\n      \"secret\" : false,\n      \"personal\" : false,\n      \"unique\" : false,\n      \"primaryKey\" : false\n    }, {\n      \"relation\" : false,\n      \"id\" : \"14842071869001020304050607000001\",\n      \"ver\" : 0,\n      \"name\" : \"Name\",\n      \"type\" : \"STRING\",\n      \"defaultValue\" : \"\",\n      \"size\" : 48,\n      \"decimalDigits\" : 0,\n      \"notNull\" : true,\n      \"unsigned\" : false,\n      \"sequence\" : false,\n      \"system\" : false,\n      \"secret\" : false,\n      \"personal\" : false,\n      \"unique\" : false,\n      \"primaryKey\" : false\n    }, {\n      \"relation\" : false,\n      \"id\" : \"14842071869001020304050607000002\",\n      \"ver\" : 0,\n      \"name\" : \"Adress\",\n      \"type\" : \"STRING\",\n      \"defaultValue\" : \"\",\n      \"size\" : 48,\n      \"decimalDigits\" : 0,\n      \"notNull\" : false,\n      \"unsigned\" : false,\n      \"sequence\" : false,\n      \"system\" : false,\n      \"secret\" : false,\n      \"personal\" : false,\n      \"unique\" : false,\n      \"primaryKey\" : false\n    }, {\n      \"relation\" : false,\n      \"id\" : \"14939254198001020304050607000001\",\n      \"ver\" : 0,\n      \"name\" : \"Value\",\n      \"type\" : \"FLOAT\",\n      \"defaultValue\" : \"0.0\",\n      \"size\" : 48,\n      \"decimalDigits\" : 2,\n      \"notNull\" : false,\n      \"unsigned\" : false,\n      \"sequence\" : false,\n      \"system\" : false,\n      \"secret\" : false,\n      \"personal\" : false,\n      \"unique\" : false,\n      \"primaryKey\" : false\n    }\n    ],\n    \"privileges\" : [ {\n      \"id\" : \"00000000000000000000000000060000\",\n      \"name\" : \"Create\"\n    }, {\n      \"id\" : \"00000000000000000000000000060003\",\n      \"name\" : \"Delete\"\n    }, {\n      \"id\" : \"00000000000000000000000000060004\",\n      \"name\" : \"Execute\"\n    }, {\n      \"id\" : \"00000000000000000000000000060005\",\n      \"name\" : \"ManageAcls\"\n    }, {\n      \"id\" : \"00000000000000000000000000060001\",\n      \"name\" : \"Read\"\n    }, {\n      \"id\" : \"00000000000000000000000000060002\",\n      \"name\" : \"Update\"\n    } ],\n    \"records\" : [\n    \t{\n    \t\t\"id\": \"123456780\",\n    \t\t\"ver\": 0,\n    \t\t\"created_at\": \"2014-09-04T21:09:54.000Z\",\n    \t\t\"updated_at\": \"2014-09-04T21:09:54.000Z\",\n    \t\t\"Name\": \"Alpha\",\n    \t\t\"Address\": \"1392 Bonita Ave\",\n    \t\t\"Value\": 157.8\n    \t},\n    \t{\n    \t\t\"id\": \"123456781\",\n    \t\t\"ver\": 0,\n    \t\t\"created_at\": \"2014-09-05T22:09:54.000Z\",\n    \t\t\"updated_at\": \"2014-09-05T22:09:54.000Z\",\n    \t\t\"Name\": \"Beta\",\n    \t\t\"Address\": \"1 Infinite Loop\",\n    \t\t\"Value\": 76.3\n    \t},\n    \t{\n    \t\t\"id\": \"123456782\",\n    \t\t\"ver\": 0,\n    \t\t\"created_at\": \"2014-09-06T23:09:54.000Z\",\n    \t\t\"updated_at\": \"2014-09-06T23:09:54.000Z\",\n    \t\t\"Name\": \"Gamma\",\n    \t\t\"Address\": \"440 Clyde Ave\",\n    \t\t\"Value\": 282.6\n    \t}\n    ]\n}\n",
'url:appivo/mvc/html/ScriptErrorDialog.html':"<style>\n\n\t.error-wrap .icon-row {\n\t\tmargin: 0 -15px;\n\t}\n\n\t.error-wrap .icon-row .err-icon {\n\t\ttext-align: center;\n\t\twidth: 30%;\n\t\tfloat: left;\n\t}\n\t.error-wrap .icon-row .err-icon img {\n\t\twidth: 100%;\n\t\tmax-width: 220px;\n\t}\n\t.error-wrap .icon-row .err-txt {\n\t\twidth: 70%;\n\t    float: left;\n\t    padding-left: 20px;\n\t}\n\t.error-wrap .err-txt ul {\n\t\tmargin: 10px 0 10px 20px;\n\t}\n\t.error-wrap .adv-error input.chk {\n\t    width: 20px;\n\t    float: left;\n\t    margin-right: 10px;\n\t}\n\t.error-wrap .adv-error label {font-weight: 600;}\n\t.error-wrap .adv-error .adv-wrap  {\n\t\tmargin-bottom: 0;\n\t    max-height: 0;\n\t    overflow: hidden;\n\t    -webkit-transition: max-height 0.15s ease-out 0s, margin-bottom 0.3s ease-out 0s, padding 0.3s ease-out 0s;\n\t    transition: max-height 0.15s ease-out 0s, margin-bottom 0.3s ease-out 0s, padding 0.3s ease-out 0s;\n\t}\n\t.error-wrap .adv-error input:checked ~ .adv-wrap{\n\t\tmargin-bottom: 15px;\n    \tmax-height: 250px;\n\t}\n\t.clearfix {\n\t\tclear: both;\n\t}\n\n\t@media screen and (min-width: 769px) {\n\t\t.alertify .ajs-dialog {\n\t\t\tmax-width: 700px;\n\t\t}\n\t}\n\n\t@media screen and (max-width: 768px) {\n\t\t.error-wrap .icon-row .err-icon {\n\t\t\twidth: 100%;\n\t\t\tfloat: none;\n\t\t}\n\t\t.error-wrap .icon-row .err-icon img {\n\t\t\twidth: 80%;\n\t\t}\n\t\t.error-wrap .icon-row .err-txt {\n\t\t\twidth: 100%;\n\t\t\tfloat: none;\n\t\t\tpadding: 15px 0;\n\t\t}\n\t}\n\t\n\n</style>\n\n<div class=\"error-wrap\">\n\t<div class=\"icon-row\">\n\t\t<div class=\"err-icon\">\n\t\t\t<img src=\"/img/js-error1.png\" alt=\"error icon\">\n\t\t</div>\n\t\t<div class=\"err-txt\">\n\t\t\t<h4 style=\"font-weight: 600;text-transform: uppercase;\">${messages.scriptErrorHeader}</h4>\n\t\t\t${messages.scriptErrorBody}\n\t\t</div>\n\t</div>\n\t<div class=\"clearfix\"></div>\n\t<div class=\"adv-error\">\n\t\t<input type=\"checkbox\" id=\"showAdvErr\" class=\"chk\">\n\t\t<label for=\"showAdvErr\">Show advanced error</label>\n\t\t<div class=\"adv-wrap\">\n\t\t\t<div class=\"err-title\">Error: ${error}</div>\n\t\t\t<textarea readonly class=\"form-control\" style=\"resize: none;width: 94%;height: 10em\">${script}</textarea>\n\t\t</div>\n\t</div>\n</div>\n",
'url:appivo/mvc/style/Widget.txt':"{{#if widgetId}} #{{ widgetId }}{{else}} .{{ className }}{{/if}} {\n  {{#if color }}\n  color: {{color}};\n  {{/if}}\n  {{#if fontSize }}\n  font-size: {{fontSize}}px;\n  {{/if}}\n  {{#if fontFamily}}\n  font-family: {{fontFamily}};\n  {{/if}}\n  {{#if bgcolor }}\n  background-color: {{bgcolor}};\n  {{/if}}\n  {{#if boxShadow}}\n  box-shadow: {{boxShadow}};\n  {{/if}}\n  {{#if margin }}\n  margin: {{margin}}px;\n  {{/if}}\n  {{#if padding }}\n  padding: {{padding}}px;\n  {{/if}}\n  {{#if textalign}}\n  text-align: {{textalign}};\n  {{/if}}\n}\n",
'url:dijit/form/templates/Button.html':"<span class=\"dijit dijitReset dijitInline\" role=\"presentation\"\n\t><span class=\"dijitReset dijitInline dijitButtonNode\"\n\t\tdata-dojo-attach-event=\"ondijitclick:__onClick\" role=\"presentation\"\n\t\t><span class=\"dijitReset dijitStretch dijitButtonContents\"\n\t\t\tdata-dojo-attach-point=\"titleNode,focusNode\"\n\t\t\trole=\"button\" aria-labelledby=\"${id}_label\"\n\t\t\t><span class=\"dijitReset dijitInline dijitIcon\" data-dojo-attach-point=\"iconNode\"></span\n\t\t\t><span class=\"dijitReset dijitToggleButtonIconChar\">&#x25CF;</span\n\t\t\t><span class=\"dijitReset dijitInline dijitButtonText\"\n\t\t\t\tid=\"${id}_label\"\n\t\t\t\tdata-dojo-attach-point=\"containerNode\"\n\t\t\t></span\n\t\t></span\n\t></span\n\t><input ${!nameAttrSetting} type=\"${type}\" value=\"${value}\" class=\"dijitOffScreen\"\n\t\tdata-dojo-attach-event=\"onclick:_onClick\"\n\t\ttabIndex=\"-1\" aria-hidden=\"true\" data-dojo-attach-point=\"valueNode\"\n/></span>\n",
'url:dijit/form/templates/TextBox.html':"<div class=\"dijit dijitReset dijitInline dijitLeft\" id=\"widget_${id}\" role=\"presentation\"\n\t><div class=\"dijitReset dijitInputField dijitInputContainer\"\n\t\t><input class=\"dijitReset dijitInputInner\" data-dojo-attach-point='textbox,focusNode' autocomplete=\"off\"\n\t\t\t${!nameAttrSetting} type='${type}'\n\t/></div\n></div>\n",
'url:dijit/templates/Tooltip.html':"<div class=\"dijitTooltip dijitTooltipLeft\" id=\"dojoTooltip\" data-dojo-attach-event=\"mouseenter:onMouseEnter,mouseleave:onMouseLeave\"\n\t><div class=\"dijitTooltipConnector\" data-dojo-attach-point=\"connectorNode\"></div\n\t><div class=\"dijitTooltipContainer dijitTooltipContents\" data-dojo-attach-point=\"containerNode\" role='alert'></div\n></div>\n",
'url:appivo/builder/html/DialogFrame.html':"<div :style=\"dialogStyle\" :class=\"[dialogClasses, 'dialogContent']\" data-tap-disabled=\"true\">\n  <div :style=\"headerStyle\" class=\"dialogHeader\">\n    <slot name=\"header\"></slot>\n  </div>\n\n  <div :style=\"mainStyle\" class=\"dialogBody\">\n    <slot name=\"main\"></slot>\n  </div>\n\n  <div class=\"dialogFooter\">\n    <slot name=\"footer\"></slot>\n  </div>\n</div>",
'url:appivo/vue/components/autocompletion/meta.json':"[\n  {\n    \"api\": \"clientsideRuntime@Context\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"getLanguage\"\n  },\n  {\n    \"api\": \"clientsideRuntime@Context\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"getCountry\"\n  },\n  {\n    \"api\": \"clientsideRuntime@Context\",\n    \"returntype\": \"User\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"getUser\",\n    \"params\": [\n      {\n        \"name\": \"load\",\n        \"type\": \"Boolean\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideRuntime@Context\",\n    \"returntype\": \"Deferred\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"isLoggedIn\"\n  },\n  {\n    \"api\": \"clientsideRuntime@Context\",\n    \"returntype\": \"Object\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"getOrganization\"\n  },\n  {\n    \"api\": \"clientsideRuntime@Context\",\n    \"returntype\": \"Id\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"getTenantId\"\n  },\n  {\n    \"api\": \"clientsideRuntime@Context\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"getTenantName\"\n  },\n  {\n    \"api\": \"clientsideRuntime@Context\",\n    \"returntype\": \"Boolean\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"isMobile\"\n  },\n  {\n    \"api\": \"clientsideRuntime@Context\",\n    \"returntype\": \"Boolean\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"isHybrid\"\n  },\n  {\n    \"api\": \"clientsideRuntime@Context\",\n    \"returntype\": \"Boolean\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"isOffline\"\n  },\n  {\n    \"api\": \"clientsideRuntime@Context\",\n    \"returntype\": \"Boolean\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"isForcedOffline\"\n  },\n  {\n    \"api\": \"clientsideRuntime@Context\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"setOffline\",\n    \"params\": [\n      {\n        \"name\": \"offline\",\n        \"type\": \"Boolean\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"returntype\": \"View\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"getView\"\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"returntype\": \"QueryHandle\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"getQueryHandle\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String/Query-ID\"\n      },\n      {\n        \"name\": \"options\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"tooltip\": \"$\",\n    \"tags\": [\n      \"Dialog\"\n    ],\n    \"functionname\": \"closeDialog\",\n    \"params\": [\n      {\n        \"name\": \"data\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideApplication@Context\",\n    \"returntype\": \"Object\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"getConfigParam\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String/ConfigParam-ID\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideApplication@Context\",\n    \"returntype\": \"Object\",\n    \"shadowblocks\": {\n      \"name\": \"text#parameter name\"\n    },\n    \"functionname\": \"getParameter\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideApplication@Context\",\n    \"returntype\": \"Object\",\n    \"functionname\": \"getSubdomainMetadata\"\n  },\n  {\n    \"api\": \"clientsideApplication@Context\",\n    \"returntype\": \"Array\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"getStrings\"\n  },\n  {\n    \"api\": \"clientsideApplication@Context\",\n    \"returntype\": \"String\",\n    \"functionname\": \"replaceTerm\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"vars\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideApplication@Context\",\n    \"returntype\": \"String\",\n    \"functionname\": \"getString\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"vars\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"returntype\": \"String\",\n    \"togglereturn\": \"true\",\n    \"functionname\": \"renderString\",\n    \"params\": [\n      {\n        \"name\": \"template\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"data\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"objecttypeoverride\": {\n      \"view\": {\n        \"view\": \"String/View-ID\",\n        \"transition\": {\n          \"type\": \"String\",\n          \"require\": [\n            \"isMobile\"\n          ]\n        }\n      }\n    },\n    \"tooltip\": \"$\",\n    \"functionname\": \"setView\",\n    \"params\": [\n      {\n        \"name\": \"view\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"data\",\n        \"type\": \"null\"\n      },\n      {\n        \"name\": \"query\",\n        \"type\": \"String/Query-ID\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"objecttypeoverride\": {\n      \"ui\": {\n        \"ui\": \"String\",\n        \"transition\": {\n          \"type\": \"String\",\n          \"require\": [\n            \"isMobile\"\n          ]\n        }\n      }\n    },\n    \"tooltip\": \"$\",\n    \"functionname\": \"setUI\",\n    \"params\": [\n      {\n        \"name\": \"ui\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"view\",\n        \"type\": \"String/View-ID\"\n      },\n      {\n        \"name\": \"data\",\n        \"type\": \"null\"\n      },\n      {\n        \"name\": \"query\",\n        \"type\": \"String/Query-ID\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"functionname\": \"continueTo\",\n    \"params\": [\n      {\n        \"name\": \"nextView\",\n        \"type\": \"String/View-ID\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"functionname\": \"ask\",\n    \"params\": [\n      {\n        \"name\": \"String\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"tooltip\": \"$\",\n    \"shadowblocks\": {\n      \"number\": \"text#123123\"\n    },\n    \"functionname\": \"dial\",\n    \"params\": [\n      {\n        \"name\": \"number\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"tooltip\": \"$\",\n    \"shadowblocks\": {\n      \"tel\": \"text#123123\"\n    },\n    \"functionname\": \"SMSTo\",\n    \"params\": [\n      {\n        \"name\": \"tel\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"tooltip\": \"$\",\n    \"shadowblocks\": {\n      \"email\": \"text#email adress\"\n    },\n    \"functionname\": \"mailTo\",\n    \"params\": [\n      {\n        \"name\": \"email\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"openApp\",\n    \"params\": [\n      {\n        \"name\": \"app\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"ui\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"view\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"record\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"options\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"objecttypeoverride\": {\n      \"options\": {\n        \"type\": \"String\",\n        \"message\": \"String\",\n        \"delay\": \"Number\",\n        \"position\": \"String\"\n      }\n    },\n    \"tooltip\": \"$\",\n    \"shadowblocks\": {\n      \"type\": \"text#success\",\n      \"message\": \"text#message\",\n      \"delay\": \"number#1\"\n    },\n    \"functionname\": \"notify\",\n    \"params\": [\n      {\n        \"name\": \"options\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"objecttypeoverride\": {\n      \"options\": {\n        \"message\": \"String\",\n        \"delay\": \"Number\"\n      }\n    },\n    \"tooltip\": \"$\",\n    \"shadowblocks\": {\n      \"message\": \"text#message\",\n      \"delay\": \"number#1000\"\n    },\n    \"functionname\": \"message\",\n    \"params\": [\n      {\n        \"name\": \"options\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"async\": {\n      \"objectParam\": \"opts\",\n      \"onSuccess\": \"ok\"\n    },\n    \"objecttypeoverride\": {\n      \"opts\": {\n        \"message\": \"String\"\n      }\n    },\n    \"tooltip\": \"$\",\n    \"shadowblocks\": {\n      \"message\": \"text#message\"\n    },\n    \"functionname\": \"alert\",\n    \"params\": [\n      {\n        \"name\": \"opts\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"async\": {\n      \"objectParam\": \"opts\",\n      \"onSuccess\": \"ok\",\n      \"onFailure\": \"cancel\"\n    },\n    \"objecttypeoverride\": {\n      \"opts\": {\n        \"message\": \"String\"\n      }\n    },\n    \"tooltip\": \"$\",\n    \"shadowblocks\": {\n      \"message\": \"text#message\"\n    },\n    \"functionname\": \"confirm\",\n    \"params\": [\n      {\n        \"name\": \"options\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"async\": {\n      \"objectParam\": \"opts\",\n      \"onSuccess\": \"ok\",\n      \"onFailure\": \"cancel\"\n    },\n    \"objecttypeoverride\": {\n      \"opts\": {\n        \"message\": \"String\",\n        \"value\": \"String\"\n      }\n    },\n    \"tooltip\": \"$\",\n    \"shadowblocks\": {\n      \"message\": \"text#message\",\n      \"value\": \"text#default value\"\n    },\n    \"functionname\": \"prompt\",\n    \"params\": [\n      {\n        \"name\": \"opts\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"objecttypeoverride\": {\n      \"view\": {\n        \"transition\": {\n          \"type\": \"String\",\n          \"require\": [\n            \"isMobile\"\n          ]\n        }\n      }\n    },\n    \"tooltip\": \"$\",\n    \"functionname\": \"back\",\n    \"params\": [\n      {\n        \"name\": \"opts\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"async\": {\n      \"objectParam\": \"opts\",\n      \"onSuccess\": \"onDone\"\n    },\n    \"tooltip\": \"$\",\n    \"functionname\": \"openDialog\",\n    \"params\": [\n      {\n        \"name\": \"dialog\",\n        \"type\": \"String/Dialog-ID\"\n      },\n      {\n        \"name\": \"data\",\n        \"type\": \"null\"\n      },\n      {\n        \"name\": \"opts\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"objecttypeoverride\": {\n      \"opts\": {\n        \"url\": \"String\",\n        \"content\": \"String\",\n        \"template\": \"String\",\n        \"data\": \"null\",\n        \"records\": \"Array\"\n      }\n    },\n    \"shadowblocks\": {\n      \"content\": \"text#window content\"\n    },\n    \"functionname\": \"createWindow\",\n    \"params\": [\n      {\n        \"name\": \"opts\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"functionname\": \"executeTemplate\",\n    \"params\": [\n      {\n        \"name\": \"opts\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideRuntime@Context\",\n    \"functionname\": \"downloadVirtualFile\",\n    \"params\": [\n      {\n        \"name\": \"opts\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"returntype\": \"Boolean\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"downloadResource\",\n    \"params\": [\n      {\n        \"name\": \"resource\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"opts\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"returntype\": \"Object\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"getTemplate\",\n    \"params\": [\n      {\n        \"name\": \"id\",\n        \"type\": \"Integer\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"returntype\": \"Object\",\n    \"functionname\": \"createTemplateContext\",\n    \"params\": [\n      {\n        \"name\": \"opts\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"returntype\": \"Widget\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"getWidget\",\n    \"params\": [\n      {\n        \"name\": \"widgetId\",\n        \"type\": \"String/Widget-ID\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"returntype\": \"Form\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"getForm\",\n    \"params\": [\n      {\n        \"name\": \"formId\",\n        \"type\": \"String/Form-ID\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideRuntime@Context\",\n    \"objecttypeoverride\": {\n      \"options\": {\n        \"service\": \"String/Webhook-ID\",\n        \"data\": \"Object\",\n        \"parameters\": \"Object\"\n      }\n    },\n    \"async\": {\n      \"objectParam\": \"options\",\n      \"onSuccess\": \"callback\",\n      \"onFailure\": \"errorCallback\"\n    },\n    \"tooltip\": \"$\",\n    \"shadowblocks\": {\n      \"data\": \"object#data1#data2\",\n      \"parameters\": \"object#parameter1#parameter2\"\n    },\n    \"functionname\": \"invokeService\",\n    \"params\": [\n      {\n        \"name\": \"options\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideRuntime@Context\",\n    \"objecttypeoverride\": {\n      \"opts\": {\n        \"service\": \"String/Action-ID\",\n        \"data\": \"Object\",\n        \"parameters\": \"Object\"\n      }\n    },\n    \"async\": {\n      \"objectParam\": \"opts\",\n      \"onSuccess\": \"callback\",\n      \"onFailure\": \"errorCallback\"\n    },\n    \"tooltip\": \"$\",\n    \"shadowblocks\": {\n      \"data\": \"object#data1#data2\",\n      \"parameters\": \"object#parameter1#parameter2\"\n    },\n    \"functionname\": \"invokeAction\",\n    \"params\": [\n      {\n        \"name\": \"opts\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"returntype\": \"Boolean\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"isViewAccessible\",\n    \"params\": [\n      {\n        \"name\": \"viewId\",\n        \"type\": \"String/View-ID\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"returntype\": \"DateFunctions\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"getDateFunctions\"\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"returntype\": \"DataFunctions\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"getDataFunctions\"\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"returntype\": \"NumericFunctions\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"getNumericFunctions\"\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"returntype\": \"GeneralFunctions\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"getGeneralFunctions\"\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"returntype\": \"GeoFunctions\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"getGeoLocation\"\n  },\n  {\n    \"api\": \"clientsideRuntime@Context\",\n    \"returntype\": \"String\",\n    \"shadowblocks\": {\n      \"url\": \"text#api endpoint\"\n    },\n    \"functionname\": \"getURI\",\n    \"params\": [\n      {\n        \"name\": \"url\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideRuntime@Context\",\n    \"returntype\": \"Object\",\n    \"shadowblocks\": {\n      \"name\": \"text#name\"\n    },\n    \"functionname\": \"getData\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"def\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideRuntime@Context\",\n    \"shadowblocks\": {\n      \"name\": \"text#name\",\n      \"value\": \"object#value1#value2\"\n    },\n    \"functionname\": \"setData\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"value\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"scope\",\n        \"type\": \"String/Data-TYPE\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideRuntime@Context\",\n    \"returntype\": \"Null\",\n    \"tooltip\": \"$\",\n    \"togglereturn\": \"true\",\n    \"shadowblocks\": {\n      \"funcName\": \"text#function name\"\n    },\n    \"functionname\": \"invoke\",\n    \"params\": [\n      {\n        \"name\": \"funcName\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"args\",\n        \"type\": \"null\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"playSound\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"opts\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"showSpinner\",\n    \"params\": [\n      {\n        \"name\": \"loadingMessage\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"hideSpinner\"\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"createWidget\",\n    \"params\": [\n      {\n        \"name\": \"optional\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideRuntime@Context\",\n    \"tooltip\": \"$\",\n    \"shadowblocks\": {\n      \"log\": \"text#message\"\n    },\n    \"functionname\": \"log\",\n    \"params\": [\n      {\n        \"name\": \"level\",\n        \"type\": \"null\"\n      },\n      {\n        \"name\": \"msg\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideRuntime@Context\",\n    \"returntype\": \"Boolean\",\n    \"shadowblocks\": {\n      \"name\": \"text#feature name\"\n    },\n    \"functionname\": \"hasFeature\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideRuntime@Context\",\n    \"returntype\": \"Integer\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"scheduleTask\",\n    \"params\": [\n      {\n        \"name\": \"options\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideRuntime@Context\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"unscheduleTask\",\n    \"params\": [\n      {\n        \"name\": \"tid\",\n        \"type\": \"Integer\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"returntype\": \"Object\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"getPlugin\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideUI@Context\",\n    \"returntype\": \"Integration\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"getIntegration\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String/Integration-ID\"\n      },\n      {\n        \"name\": \"options\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@QueryHandle\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"setParameter\",\n    \"params\": [\n      {\n        \"name\": \"param\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"value\",\n        \"type\": \"null\"\n      },\n      {\n        \"name\": \"noupdate\",\n        \"type\": \"boolean\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@QueryHandle\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"setParameters\",\n    \"params\": [\n      {\n        \"name\": \"params\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"noupdate\",\n        \"type\": \"boolean\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@QueryHandle\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"removeParameter\",\n    \"params\": [\n      {\n        \"name\": \"param\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"noupdate\",\n        \"type\": \"Boolean\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@QueryHandle\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"refresh\",\n    \"params\": [\n      {\n        \"name\": \"force\",\n        \"type\": \"Boolean\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@QueryHandle\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"setQueryParameters\",\n    \"params\": [\n      {\n        \"name\": \"qps\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@QueryHandle\",\n    \"returntype\": \"Object\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"getResult\"\n  },\n  {\n    \"api\": \"clientside@QueryHandle\",\n    \"async\": {\n      \"onFailure\": \"onError\"\n    },\n    \"tooltip\": \"$\",\n    \"functionname\": \"execute\",\n    \"params\": [\n      {\n        \"name\": \"options\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@QueryHandle\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"setRelations\",\n    \"params\": [\n      {\n        \"name\": \"relations\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"noupdate\",\n        \"type\": \"Boolean\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@Model\",\n    \"returntype\": \"Id\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"getId\"\n  },\n  {\n    \"api\": \"clientside@Model\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"getName\"\n  },\n  {\n    \"api\": \"clientside@Model\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"getType\"\n  },\n  {\n    \"api\": \"clientside@Model\",\n    \"returntype\": \"Boolean\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"isDocument\"\n  },\n  {\n    \"api\": \"clientside@Model\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"getDescription\"\n  },\n  {\n    \"api\": \"clientside@Model\",\n    \"returntype\": \"Boolean\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"isExportable\"\n  },\n  {\n    \"api\": \"clientside@Model\",\n    \"returntype\": \"Boolean\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"isHidden\"\n  },\n  {\n    \"api\": \"clientside@Model\",\n    \"returntype\": \"Boolean\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"isImported\"\n  },\n  {\n    \"api\": \"clientside@Model\",\n    \"returntype\": \"Boolean\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"isImportedFromSystem\"\n  },\n  {\n    \"api\": \"clientside@Model\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"getURI\"\n  },\n  {\n    \"api\": \"clientside@Model\",\n    \"returntype\": \"Object\",\n    \"tooltip\": \"$\",\n    \"shadowblocks\": {\n      \"name\": \"text#attribute name\"\n    },\n    \"functionname\": \"getAttribute\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@Record\",\n    \"returntype\": \"ID\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"getId\"\n  },\n  {\n    \"api\": \"clientside@Record\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"getURL\"\n  },\n  {\n    \"api\": \"clientside@Record\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\",\n    \"shadowblocks\": {\n      \"nocache\": \"boolean#false\"\n    },\n    \"functionname\": \"getDocumentURL\",\n    \"params\": [\n      {\n        \"name\": \"nocache\",\n        \"type\": \"Boolean\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@Record\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"getDownloadURL\"\n  },\n  {\n    \"api\": \"clientside@Record\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"getThumbnailURL\",\n    \"params\": [\n      {\n        \"name\": \"format\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@Record\",\n    \"returntype\": \"Promise\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"load\"\n  },\n  {\n    \"api\": \"clientside@Record\",\n    \"returntype\": \"Model\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"getModel\"\n  },\n  {\n    \"api\": \"clientside@Record\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"sync\",\n    \"params\": [\n      {\n        \"name\": \"opts\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@Record\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"loadRelations\",\n    \"params\": [\n      {\n        \"name\": \"relations\",\n        \"type\": \"String,Array\"\n      },\n      {\n        \"name\": \"opts\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@Record\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"save\",\n    \"params\": [\n      {\n        \"name\": \"check\",\n        \"type\": \"Boolean\"\n      },\n      {\n        \"name\": \"options\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@Record\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"observe\",\n    \"params\": [\n      {\n        \"name\": \"callback\",\n        \"type\": \"Function\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@Record\",\n    \"async\": {\n      \"objectParam\": \"opts\",\n      \"onFailure\": \"onError\"\n    },\n    \"tooltip\": \"$\",\n    \"functionname\": \"remove\",\n    \"params\": [\n      {\n        \"name\": \"opts\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@Record\",\n    \"returntype\": \"Object\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"toJSON\",\n    \"params\": [\n      {\n        \"name\": \"opts\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@Form\",\n    \"returntype\": \"Boolean\",\n    \"togglereturn\": \"true\",\n    \"async\": {\n      \"onFailure\": \"onError\"\n    },\n    \"objecttypeoverride\": {\n      \"options\": {\n        \"successMessage\": \"String\",\n        \"errorMessage\": \"String\",\n        \"full\": \"Boolean\"\n      }\n    },\n    \"tooltip\": \"$\",\n    \"shadowblocks\": {\n      \"full\": \"boolean#false\"\n    },\n    \"functionname\": \"submit\",\n    \"params\": [\n      {\n        \"name\": \"options\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@Form\",\n    \"returntype\": \"Record\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"createRecord\",\n    \"params\": [\n      {\n        \"name\": \"opts\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@Form\",\n    \"returntype\": \"Boolean\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"validate\",\n    \"params\": [\n      {\n        \"name\": \"opts\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@Form\",\n    \"async\": {},\n    \"functionname\": \"blocklyLoad\",\n    \"params\": [\n      {\n        \"name\": \"id\",\n        \"type\": \"String,ID\"\n      },\n      {\n        \"name\": \"options\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@Form\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"setData\",\n    \"params\": [\n      {\n        \"name\": \"item\",\n        \"type\": \"Record, Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@Form\",\n    \"returntype\": \"Model\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"getModel\"\n  },\n  {\n    \"api\": \"clientsideCamera@Native\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"getPicture\",\n    \"params\": [\n      {\n        \"name\": \"args\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideBackgroundMode@Native\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"enable\",\n    \"params\": [\n      {\n        \"name\": \"opts\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideBackgroundMode@Native\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"disable\"\n  },\n  {\n    \"api\": \"clientsideBackgroundMode@Native\",\n    \"returntype\": \"boolean\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"isActive\"\n  },\n  {\n    \"api\": \"clientsideBackgroundMode@Native\",\n    \"returntype\": \"boolean\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"isEnabled\"\n  },\n  {\n    \"api\": \"clientsideBackgroundMode@Native\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"configure\",\n    \"params\": [\n      {\n        \"name\": \"opts\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideFile@Native\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"download\",\n    \"params\": [\n      {\n        \"name\": \"options\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideFile@Native\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"open\",\n    \"params\": [\n      {\n        \"name\": \"options\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientsideGeoLocation@Native\",\n    \"async\": {\n      \"onSuccess\": \"onSuccess\",\n      \"onFailure\": \"onError\"\n    },\n    \"tooltip\": \"$\",\n    \"functionname\": \"getCurrentPosition\",\n    \"params\": [\n      {\n        \"name\": \"options\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@DateFunctions\",\n    \"returntype\": \"Number\",\n    \"functionname\": \"getYear\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"String,Date\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@DateFunctions\",\n    \"returntype\": \"Number\",\n    \"functionname\": \"getMonth\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"String,Date\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@DateFunctions\",\n    \"returntype\": \"Date\",\n    \"functionname\": \"getEndOfMonth\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"String,Date\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@DateFunctions\",\n    \"returntype\": \"Number\",\n    \"functionname\": \"getLastDayInMonth\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"String,Date\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@DateFunctions\",\n    \"returntype\": \"Number\",\n    \"functionname\": \"getDayInMonth\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"String,Date\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@DateFunctions\",\n    \"returntype\": \"Number\",\n    \"functionname\": \"getDayInWeek\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"String,Date\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@DateFunctions\",\n    \"returntype\": \"Number\",\n    \"functionname\": \"getHour\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"String,Date\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@DateFunctions\",\n    \"returntype\": \"Number\",\n    \"functionname\": \"getMinute\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"String,Date\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@DateFunctions\",\n    \"returntype\": \"Number\",\n    \"functionname\": \"getSecond\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"String,Date\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@DateFunctions\",\n    \"returntype\": \"Date\",\n    \"functionname\": \"getDate\"\n  },\n  {\n    \"api\": \"clientside@DateFunctions\",\n    \"returntype\": \"Date\",\n    \"functionname\": \"newDate\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"String,Date\"\n      },\n      {\n        \"name\": \"timezone\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@DateFunctions\",\n    \"returntype\": \"Number\",\n    \"functionname\": \"diff\",\n    \"params\": [\n      {\n        \"name\": \"date1\",\n        \"type\": \"String,Date\"\n      },\n      {\n        \"name\": \"date2\",\n        \"type\": \"String,Date\"\n      },\n      {\n        \"name\": \"unit\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@DateFunctions\",\n    \"returntype\": \"Number\",\n    \"functionname\": \"getWeek\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"String,Date\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@DateFunctions\",\n    \"returntype\": \"Date\",\n    \"functionname\": \"getMondayFromWeek\",\n    \"params\": [\n      {\n        \"name\": \"week\",\n        \"type\": \"Number\"\n      },\n      {\n        \"name\": \"year\",\n        \"type\": \"Number\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@DateFunctions\",\n    \"returntype\": \"Date\",\n    \"functionname\": \"getLastMondayFromDate\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"String,Date\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@DateFunctions\",\n    \"returntype\": \"String\",\n    \"functionname\": \"intToTime\",\n    \"params\": [\n      {\n        \"name\": \"time\",\n        \"type\": \"Number\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@DateFunctions\",\n    \"returntype\": \"Number\",\n    \"functionname\": \"timeToInt\",\n    \"params\": [\n      {\n        \"name\": \"time\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@DateFunctions\",\n    \"returntype\": \"String\",\n    \"functionname\": \"format\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"String,Date\"\n      },\n      {\n        \"name\": \"pattern\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@DateFunctions\",\n    \"returntype\": \"String\",\n    \"functionname\": \"parse\",\n    \"params\": [\n      {\n        \"name\": \"str\",\n        \"type\": \"String,Date\"\n      },\n      {\n        \"name\": \"pattern\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@DateFunctions\",\n    \"returntype\": \"String\",\n    \"functionname\": \"formatTime\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"String,Date\"\n      },\n      {\n        \"name\": \"timePattern\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@DateFunctions\",\n    \"returntype\": \"String\",\n    \"functionname\": \"formatDate\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"String,Date\"\n      },\n      {\n        \"name\": \"datePattern\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"timePattern\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@DateFunctions\",\n    \"returntype\": \"Date\",\n    \"functionname\": \"addDaysToDate\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"String,Date\"\n      },\n      {\n        \"name\": \"days\",\n        \"type\": \"Number\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@DateFunctions\",\n    \"returntype\": \"Date\",\n    \"functionname\": \"addHoursToDate\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"String,Date\"\n      },\n      {\n        \"name\": \"hours\",\n        \"type\": \"Number\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@DateFunctions\",\n    \"returntype\": \"Date\",\n    \"functionname\": \"addMinutesToDate\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"String,Date\"\n      },\n      {\n        \"name\": \"minutes\",\n        \"type\": \"Number\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@DateFunctions\",\n    \"returntype\": \"Date\",\n    \"functionname\": \"toMidnight\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"String,Date\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@DataFunctions\",\n    \"returntype\": \"String\",\n    \"functionname\": \"generateId\",\n    \"params\": [\n      {\n        \"name\": \"length\",\n        \"type\": \"Number\"\n      },\n      {\n        \"name\": \"opts\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@DataFunctions\",\n    \"returntype\": \"Boolean\",\n    \"functionname\": \"compare\",\n    \"params\": [\n      {\n        \"name\": \"value1\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"value2\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@DataFunctions\",\n    \"returntype\": \"Promise\",\n    \"tooltip\": \"$\",\n    \"functionname\": \"importRecords\",\n    \"params\": [\n      {\n        \"name\": \"model\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"resource\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"opts\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"clientside@DataFunctions\",\n    \"returntype\": \"Array\",\n    \"functionname\": \"transpose\",\n    \"params\": [\n      {\n        \"name\": \"records\",\n        \"type\": \"Array\"\n      },\n      {\n        \"name\": \"options\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"activate\",\n    \"api\": \"serverside@User\",\n    \"returntype\": \"boolean\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"add\",\n    \"api\": \"serverside@RecordSet\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"rec\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"addAll\",\n    \"api\": \"serverside@RecordSet\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"recs\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"addDays\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"DateTime\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"days\",\n        \"type\": \"int\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"addHours\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"DateTime\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"hours\",\n        \"type\": \"int\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"addMember\",\n    \"api\": \"serverside@Group\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Adds a member to this group\",\n    \"params\": [\n      {\n        \"name\": \"user\",\n        \"type\": \"User\"\n      },\n      {\n        \"name\": \"mapped\",\n        \"type\": \"boolean\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"addMinutes\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"DateTime\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"minutes\",\n        \"type\": \"int\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"addMonths\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"DateTime\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"months\",\n        \"type\": \"int\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"addRelated\",\n    \"api\": \"serverside@Record\",\n    \"shadowblocks\": {\n      \"name\": \"text#relation\"\n    },\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"record\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"addRoleToUser\",\n    \"api\": \"serverside@SystemManager\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"userObj\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"roleObj\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"addSeconds\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"DateTime\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"seconds\",\n        \"type\": \"int\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"addSet\",\n    \"api\": \"serverside@RecordSet\",\n    \"returntype\": \"RecordSet\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"obj\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"addWeeks\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"DateTime\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"weeks\",\n        \"type\": \"int\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"addYears\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"DateTime\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"years\",\n        \"type\": \"int\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"assignToGroup\",\n    \"api\": \"serversideApplication@Context\",\n    \"shadowblocks\": {\n      \"privilege\": \"text#Read\"\n    },\n    \"tooltip\": \"$\",\n    \"descr\": \"Assigns a privilege on a particular model to a Group\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"record\",\n        \"type\": \"Record\"\n      },\n      {\n        \"name\": \"groupRef\",\n        \"type\": \"Group, String\"\n      },\n      {\n        \"name\": \"privilege\",\n        \"type\": \"Privilege, String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"assignToRole\",\n    \"api\": \"serversideApplication@Context\",\n    \"shadowblocks\": {\n      \"privilege\": \"text#Read\"\n    },\n    \"tooltip\": \"$\",\n    \"descr\": \"Assigns a privilege on a particular model to a Role\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"item\",\n        \"type\": \"Record, Model\"\n      },\n      {\n        \"name\": \"roleRef\",\n        \"type\": \"String/Role-ID\"\n      },\n      {\n        \"name\": \"privilege\",\n        \"type\": \"Privilege, String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"assignToUser\",\n    \"api\": \"serversideApplication@Context\",\n    \"shadowblocks\": {\n      \"privilege\": \"text#Read\"\n    },\n    \"tooltip\": \"$\",\n    \"descr\": \"Assigns a privilege on a particular model to a User\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"record\",\n        \"type\": \"Record\"\n      },\n      {\n        \"name\": \"userRef\",\n        \"type\": \"Record,User, String\"\n      },\n      {\n        \"name\": \"privilege\",\n        \"type\": \"Privilege, String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"begin\",\n    \"api\": \"serversideRuntime@Context\",\n    \"descr\": \"Initiate a database transaction. Always follow by doing a commit or a rollback.\",\n    \"tags\": [\n      \"standard\"\n    ]\n  },\n  {\n    \"functionname\": \"checkPassword\",\n    \"api\": \"serverside@User\",\n    \"returntype\": \"boolean\",\n    \"shadowblocks\": {\n      \"arg0\": \"text\"\n    },\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"password\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"clearData\",\n    \"api\": \"serversideDevice@Context\",\n    \"returntype\": \"Object\",\n    \"params\": [\n      {\n        \"name\": \"key\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"clearMetadata\",\n    \"api\": \"serverside@Record\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"close\",\n    \"api\": \"serverside@QueryResult\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"close\",\n    \"api\": \"serverside@ServiceResponse\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Close this response\"\n  },\n  {\n    \"functionname\": \"commit\",\n    \"api\": \"serversideRuntime@Context\",\n    \"descr\": \"Commits a database transaction\",\n    \"tags\": [\n      \"standard\"\n    ]\n  },\n  {\n    \"functionname\": \"compare\",\n    \"api\": \"serverside@DataFunctions\",\n    \"returntype\": \"boolean\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Compares two objects of any kind. Returns true if the objects are equal.\",\n    \"params\": [\n      {\n        \"name\": \"value1\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"value2\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"fields\",\n        \"type\": \"Array\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"compareTo\",\n    \"api\": \"serverside@Record\",\n    \"returntype\": \"int\",\n    \"params\": [\n      {\n        \"name\": \"obj\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"compareTo\",\n    \"api\": \"serverside@Record\",\n    \"returntype\": \"int\",\n    \"params\": [\n      {\n        \"name\": \"obj\",\n        \"type\": \"Record\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"create\",\n    \"api\": \"serversideApplication@Context\",\n    \"returntype\": \"Record\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Creates a Record in the database. Should be done within the context of a transaction.\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"object\",\n        \"type\": \"Record, Object\"\n      },\n      {\n        \"name\": \"options\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"create\",\n    \"api\": \"serversideDevice@Context\",\n    \"returntype\": \"Promise\",\n    \"params\": [\n      {\n        \"name\": \"object\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"createAnonymousAccessURL\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"String\",\n    \"togglereturn\": true,\n    \"shadowblocks\": {\n      \"data\": \"object#field1#field2\"\n    },\n    \"tooltip\": \"$\",\n    \"descr\": \"Creates a URL providing unauthenticated access to a particular view. Note that the view must be part of a UI that is marked as public.\",\n    \"tags\": [\n      \"basic\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"email\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"ui\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"view\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"id\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"options\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"createAs\",\n    \"api\": \"serversideApplication@Context\",\n    \"returntype\": \"Record\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Creates a Record in the database as a given User. Should be done within the context of a transaction.\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"object\",\n        \"type\": \"Record, Object\"\n      },\n      {\n        \"name\": \"user\",\n        \"type\": \"User\"\n      },\n      {\n        \"name\": \"options\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"createDate\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"DateTime\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"milliSeconds\",\n        \"type\": \"long\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"createEmailAddress\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Creates an email address that routes to this application\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"key\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"createFile\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"File\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Creates file using source object, context-type and filename\",\n    \"tags\": [\n      \"basic\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"source\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"options\",\n        \"type\": \"Map\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"createJWT\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Generates a custom JWT\",\n    \"tags\": [\n      \"basic\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"header\",\n        \"type\": \"Map\"\n      },\n      {\n        \"name\": \"payload\",\n        \"type\": \"Map\"\n      },\n      {\n        \"name\": \"keys\",\n        \"type\": \"Map\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"createPromise\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"Promise\",\n    \"tags\": [\n      \"basic\"\n    ]\n  },\n  {\n    \"functionname\": \"createRecord\",\n    \"api\": \"serverside@Model\",\n    \"returntype\": \"Record\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"createRecord\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"Record\",\n    \"togglereturn\": true,\n    \"shadowblocks\": {\n      \"data\": \"object#field1#field2\"\n    },\n    \"tooltip\": \"$\",\n    \"descr\": \"Creates a Record given the name of a Model and a map of attribute-values. Note that this does not create a Record in the database, it just creates a Record-object that can be passed to database-operations.\",\n    \"tags\": [\n      \"basic\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"modelName\",\n        \"type\": \"String/Model-ID\"\n      },\n      {\n        \"name\": \"data\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"binary\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"createRecordSet\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"RecordSet\",\n    \"descr\": \"Creates a RecordSet out of an array or an object of named arrays.\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"data\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"createSubdomain\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"String\",\n    \"descr\": \"Create a subdomain bound to this application and tenant\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"properties\",\n        \"type\": \"Map\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"createTenant\",\n    \"api\": \"serverside@SystemManager\",\n    \"returntype\": \"Tenant\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"options\",\n        \"type\": \"Map\"\n      },\n      {\n        \"name\": \"currentUser\",\n        \"type\": \"User\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"createTenant\",\n    \"api\": \"serverside@SystemManager\",\n    \"returntype\": \"Tenant\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"options\",\n        \"type\": \"Map\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"createUser\",\n    \"api\": \"serverside@SystemManager\",\n    \"returntype\": \"boolean\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"options\",\n        \"type\": \"Map\"\n      },\n      {\n        \"name\": \"user\",\n        \"type\": \"User\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"createUser\",\n    \"api\": \"serverside@SystemManager\",\n    \"returntype\": \"boolean\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"options\",\n        \"type\": \"Map\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"deactivate\",\n    \"api\": \"serverside@User\",\n    \"returntype\": \"boolean\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"delete\",\n    \"api\": \"serversideApplication@Context\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Deletes a Record from the database. Should be done within the context of a transaction.\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"model\",\n        \"type\": \"String/ID\"\n      },\n      {\n        \"name\": \"idStr\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"delete\",\n    \"api\": \"serversideApplication@Context\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Deletes a Record from the database. Should be done within the context of a transaction.\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"object\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"options\",\n        \"type\": \"Map\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"deleteAs\",\n    \"api\": \"serversideApplication@Context\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Deletes a Record from the database as a given User. Should be done within the context of a transaction.\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"object\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"user\",\n        \"type\": \"User\"\n      },\n      {\n        \"name\": \"options\",\n        \"type\": \"Map\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"diff\",\n    \"api\": \"serverside@DataFunctions\",\n    \"returntype\": \"Object\",\n    \"togglereturn\": true,\n    \"tooltip\": \"$\",\n    \"descr\": \"Creates a diff of two records. The returned object will have a size-property with the number of differences. A property called result will have properties for all mismatching attributes where the value is an object with a pair of properties (value1 and value2).\",\n    \"params\": [\n      {\n        \"name\": \"r1\",\n        \"type\": \"Record\"\n      },\n      {\n        \"name\": \"r2\",\n        \"type\": \"Record\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"diff\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"long\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"date1\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"date2\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"unit\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"diff\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"long\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"date1\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"date2\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"diff\",\n    \"api\": \"serverside@RecordSet\",\n    \"returntype\": \"Map\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"key\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"other\",\n        \"type\": \"RecordSet\"\n      },\n      {\n        \"name\": \"allowMissing\",\n        \"type\": \"boolean\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"equals\",\n    \"api\": \"serverside@Record\",\n    \"returntype\": \"boolean\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"obj\",\n        \"type\": \"Record\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"executeQuery\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"QueryResult\",\n    \"shadowblocks\": {\n      \"args\": \"text#parameter name\"\n    },\n    \"tooltip\": \"$\",\n    \"descr\": \"Gets the results of the specified query\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String/Query-ID\"\n      },\n      {\n        \"name\": \"args\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"executeTemplate\",\n    \"api\": \"serversideApplication@Context\",\n    \"returntype\": \"String\",\n    \"objecttypeoverride\": {\n      \"options\": {\n        \"template\": \"String\",\n        \"templateString\": \"String\",\n        \"data\": \"Object\"\n      }\n    },\n    \"tooltip\": \"$\",\n    \"descr\": \"Executes a template given a set of parameters\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"options\",\n        \"type\": \"Map\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"fail\",\n    \"api\": \"serversideRuntime@Context\",\n    \"shadowblocks\": {\n      \"error\": \"text#message\"\n    },\n    \"tooltip\": \"$\",\n    \"descr\": \"TODO\",\n    \"tags\": [\n      \"basic\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"error\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"filter\",\n    \"api\": \"serverside@RecordSet\",\n    \"returntype\": \"RecordSet\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"filter\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"find\",\n    \"api\": \"serverside@RecordSet\",\n    \"returntype\": \"Object\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"key\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"value\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"useIndex\",\n        \"type\": \"boolean\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"forEach\",\n    \"api\": \"serverside@QueryResult\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Iterate over a result and call the provided function for each record. Once completed the result will be closed.\",\n    \"params\": [\n      {\n        \"name\": \"consumer\",\n        \"type\": \"Consumer\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"forEach\",\n    \"api\": \"serverside@RecordSet\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"handler\",\n        \"type\": \"Consumer\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"format\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"pattern\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"get\",\n    \"api\": \"serverside@RecordSet\",\n    \"returntype\": \"Object\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"index\",\n        \"type\": \"int\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"get\",\n    \"api\": \"serversideApplication@Context\",\n    \"returntype\": \"Record\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Get a single Record from the database given its ID.\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"model\",\n        \"type\": \"String/Model-ID\"\n      },\n      {\n        \"name\": \"idStr\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"options\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"get\",\n    \"api\": \"serversideDevice@Context\",\n    \"returntype\": \"Promise\",\n    \"params\": [\n      {\n        \"name\": \"modelObj\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"idObj\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getAndClearData\",\n    \"api\": \"serversideDevice@Context\",\n    \"returntype\": \"Object\",\n    \"params\": [\n      {\n        \"name\": \"key\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getAppConfig\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"Map\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Gets the application-configuration for the current Tenant\",\n    \"tags\": [\n      \"basic\"\n    ]\n  },\n  {\n    \"functionname\": \"getAppliance\",\n    \"api\": \"serversideDevice@Context\",\n    \"returntype\": \"Appliance\"\n  },\n  {\n    \"functionname\": \"getApplianceId\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"Object\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Gets the ID of the appliance that the code is running on\",\n    \"tags\": [\n      \"basic\"\n    ]\n  },\n  {\n    \"functionname\": \"getAs\",\n    \"api\": \"serversideApplication@Context\",\n    \"returntype\": \"Record\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Get a single Record from the database as a given User given its ID.\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"model\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"idStr\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"user\",\n        \"type\": \"User\"\n      },\n      {\n        \"name\": \"options\",\n        \"type\": \"Map\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getAttributeNames\",\n    \"api\": \"serverside@Record\",\n    \"returntype\": \"Object\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getBody\",\n    \"api\": \"serverside@Mail\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getBody\",\n    \"api\": \"serverside@ServiceRequest\",\n    \"returntype\": \"Object\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Gets the body of this request. This will attempt to parse the body if it is a JSON- or XML-document and return the parsed object. If the request is a submission of form-data a map of parameters is returned.\"\n  },\n  {\n    \"functionname\": \"getBooleanValue\",\n    \"api\": \"serverside@Record\",\n    \"returntype\": \"boolean\",\n    \"shadowblocks\": {\n      \"name\": \"text#Attribute Name\"\n    },\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getChecksum\",\n    \"api\": \"serverside@File\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Gets the computed checksum for this file\"\n  },\n  {\n    \"functionname\": \"getConfig\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"Config\",\n    \"tags\": [\n      \"integration\"\n    ]\n  },\n  {\n    \"functionname\": \"getConfigParam\",\n    \"api\": \"serversideApplication@Context\",\n    \"returntype\": \"ConfigParam\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Returns a configuration parameter using the specified name, or null if no such parameter exists.\",\n    \"tags\": [\n      \"basic\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String/ConfigParam-ID\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getContentAs\",\n    \"api\": \"serverside@HttpResponse\",\n    \"returntype\": \"Object\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"contentType\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getContentAsJSON\",\n    \"api\": \"serverside@HttpResponse\",\n    \"returntype\": \"Object\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getContentAsObject\",\n    \"api\": \"serverside@HttpResponse\",\n    \"returntype\": \"Object\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getContentAsString\",\n    \"api\": \"serverside@HttpResponse\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getContentAsString\",\n    \"api\": \"serverside@ServiceRequest\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Gets the request body as a String\"\n  },\n  {\n    \"functionname\": \"getContentAsXML\",\n    \"api\": \"serverside@HttpResponse\",\n    \"returntype\": \"Object\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getContentType\",\n    \"api\": \"serverside@HttpResponse\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getContentType\",\n    \"api\": \"serverside@ServiceRequest\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Gets the content-type of this request\"\n  },\n  {\n    \"functionname\": \"getCredentials\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"Config\",\n    \"tags\": [\n      \"integration\"\n    ]\n  },\n  {\n    \"functionname\": \"getData\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"Object\",\n    \"tags\": [\n      \"basic\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"key\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"defaultValue\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getDataFunctions\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"DataFunctions\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Gets the DataFunctions API\",\n    \"tags\": [\n      \"basic\"\n    ]\n  },\n  {\n    \"functionname\": \"getDate\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"DateTime\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"timezone\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getDate\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"DateTime\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getDateFunctions\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"DateFunctions\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Gets the DateFunctions API - an API for handling Dates\",\n    \"tags\": [\n      \"basic\"\n    ]\n  },\n  {\n    \"functionname\": \"getDateValue\",\n    \"api\": \"serverside@Record\",\n    \"returntype\": \"DateTime\",\n    \"shadowblocks\": {\n      \"name\": \"text#Attribute Name\"\n    },\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getDateValueAsString\",\n    \"api\": \"serverside@Record\",\n    \"returntype\": \"String\",\n    \"shadowblocks\": {\n      \"name\": \"text#Attribute Name\"\n    },\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getDayInMonth\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"int\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getDayInMonth\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"int\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getDayInWeek\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"int\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getDayInWeek\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"int\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getDescription\",\n    \"api\": \"serverside@Model\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getEncoding\",\n    \"api\": \"serverside@HttpResponse\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getFirstName\",\n    \"api\": \"serverside@User\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getFloatValue\",\n    \"api\": \"serverside@Record\",\n    \"returntype\": \"double\",\n    \"shadowblocks\": {\n      \"name\": \"text#Attribute Name\"\n    },\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getFrom\",\n    \"api\": \"serverside@Mail\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getFromName\",\n    \"api\": \"serverside@Mail\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getFullName\",\n    \"api\": \"serverside@User\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getHeader\",\n    \"api\": \"serverside@HttpResponse\",\n    \"returntype\": \"String\",\n    \"shadowblocks\": {\n      \"name\": \"text#headername\"\n    },\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getHeader\",\n    \"api\": \"serverside@ServiceRequest\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Get the value of a header\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getHeaderNames\",\n    \"api\": \"serverside@HttpResponse\",\n    \"returntype\": \"Array\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getHeaders\",\n    \"api\": \"serverside@ServiceRequest\",\n    \"returntype\": \"Object\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Get the headers of this request\"\n  },\n  {\n    \"functionname\": \"getHostname\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"String\",\n    \"descr\": \"Gets the name of the subdomain that the request in scope, if any, came in on.\",\n    \"tags\": [\n      \"standard\"\n    ]\n  },\n  {\n    \"functionname\": \"getHour\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"int\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getHour\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"int\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getHtmlBody\",\n    \"api\": \"serverside@Mail\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getHtmlBodyAsText\",\n    \"api\": \"serverside@Mail\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getId\",\n    \"api\": \"serverside@Model\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getId\",\n    \"api\": \"serverside@Record\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getId\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"long\",\n    \"descr\": \"TODO\",\n    \"tags\": [\n      \"standard\"\n    ]\n  },\n  {\n    \"functionname\": \"getIdValue\",\n    \"api\": \"serverside@Record\",\n    \"returntype\": \"ID\",\n    \"shadowblocks\": {\n      \"name\": \"text#Attribute Name\"\n    },\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getIntegration\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"Object\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Gets a named Integration-module\",\n    \"tags\": [\n      \"basic\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String/Integration-ID\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getIntValue\",\n    \"api\": \"serverside@Record\",\n    \"returntype\": \"int\",\n    \"shadowblocks\": {\n      \"name\": \"text#Attribute Name\"\n    },\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getLabel\",\n    \"api\": \"serverside@Record\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getLastMondayFromDate\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"DateTime\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getLastName\",\n    \"api\": \"serverside@User\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getLocale\",\n    \"api\": \"serverside@User\",\n    \"returntype\": \"Locale\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getLocale\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"Locale\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Returns the current locale.\",\n    \"tags\": [\n      \"basic\"\n    ]\n  },\n  {\n    \"functionname\": \"getLongValue\",\n    \"api\": \"serverside@Record\",\n    \"returntype\": \"long\",\n    \"shadowblocks\": {\n      \"name\": \"text#Attribute Name\"\n    },\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getMail\",\n    \"api\": \"serversideREST@Context\",\n    \"returntype\": \"Mail\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Gets the incoming Mail that triggered the execution of this Action\",\n    \"tags\": [\n      \"standard\",\n      \"action\",\n      \"REST\"\n    ]\n  },\n  {\n    \"functionname\": \"getMessage\",\n    \"api\": \"serversideREST@Context\",\n    \"returntype\": \"Message\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Gets the incoming Message that triggered the execution of this Action\",\n    \"tags\": [\n      \"standard\",\n      \"action\",\n      \"REST\"\n    ]\n  },\n  {\n    \"functionname\": \"getMetadata\",\n    \"api\": \"serverside@Record\",\n    \"returntype\": \"Map\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getMetadata\",\n    \"api\": \"serverside@Record\",\n    \"returntype\": \"Object\",\n    \"shadowblocks\": {\n      \"name\": \"text#Attribute Name\"\n    },\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getMilliTime\",\n    \"api\": \"serversideDevice@Context\",\n    \"returntype\": \"long\"\n  },\n  {\n    \"functionname\": \"getMinute\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"int\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getMinute\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"int\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getModel\",\n    \"api\": \"serverside@Record\",\n    \"returntype\": \"Model\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getModule\",\n    \"api\": \"serversideDevice@Context\",\n    \"returntype\": \"Object\",\n    \"params\": [\n      {\n        \"name\": \"moduleName\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getMonth\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"int\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getMonth\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"int\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getName\",\n    \"api\": \"serverside@Group\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Gets the name of this group\"\n  },\n  {\n    \"functionname\": \"getName\",\n    \"api\": \"serverside@Model\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getName\",\n    \"api\": \"serverside@User\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getNanoTime\",\n    \"api\": \"serversideDevice@Context\",\n    \"returntype\": \"long\"\n  },\n  {\n    \"functionname\": \"getNextCounterValue\",\n    \"api\": \"serversideApplication@Context\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\",\n    \"descr\": \"TODO\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getNextCounterValueLong\",\n    \"api\": \"serversideApplication@Context\",\n    \"returntype\": \"Integer\",\n    \"tooltip\": \"$\",\n    \"descr\": \"TODO\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getOriginCity\",\n    \"api\": \"serverside@ServiceRequest\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Get the city from which this request originates.\"\n  },\n  {\n    \"functionname\": \"getOriginCountry\",\n    \"api\": \"serverside@ServiceRequest\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Get the country from which this request originates. Returned as the ISO 3166 2-letter country code.\"\n  },\n  {\n    \"functionname\": \"getParameter\",\n    \"api\": \"serverside@ServiceRequest\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Gets a request-parameter for this request\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getPreviousRecord\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"Record\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Get Previous Record\",\n    \"tags\": [\n      \"standard\",\n      \"action\",\n      \"DATA\"\n    ]\n  },\n  {\n    \"functionname\": \"getRecord\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"Record\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Get Record\",\n    \"tags\": [\n      \"standard\",\n      \"action\",\n      \"DATA\"\n    ]\n  },\n  {\n    \"functionname\": \"getRecords\",\n    \"api\": \"serverside@Model\",\n    \"returntype\": \"Array\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getRelatedRecord\",\n    \"api\": \"serverside@Record\",\n    \"returntype\": \"Record\",\n    \"shadowblocks\": {\n      \"name\": \"text#relation\"\n    },\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getRelatedRecords\",\n    \"api\": \"serverside@Record\",\n    \"returntype\": \"Array\",\n    \"shadowblocks\": {\n      \"name\": \"text#relation\"\n    },\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getReplyTo\",\n    \"api\": \"serverside@Mail\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getRequest\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"ServiceRequest\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Gets the HTTP-request that triggered the execution of this Action\",\n    \"tags\": [\n      \"action\",\n      \"REST\"\n    ]\n  },\n  {\n    \"functionname\": \"getResponse\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"ServiceResponse\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Gets the HTTP-response that is associated with the HTTP-request that triggered this Action\",\n    \"tags\": [\n      \"standard\",\n      \"action\",\n      \"REST\"\n    ]\n  },\n  {\n    \"functionname\": \"getResponseCode\",\n    \"api\": \"serverside@HttpResponse\",\n    \"returntype\": \"int\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getSchema\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"Schema\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Returns the Schema of the current App.\",\n    \"tags\": [\n      \"basic\"\n    ]\n  },\n  {\n    \"functionname\": \"getSecond\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"int\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getSecond\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"int\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getServiceRequestHeaders\",\n    \"api\": \"serversideREST@Context\",\n    \"returntype\": \"Object\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Gets the request headers and returns them as an object.\",\n    \"tags\": [\n      \"standard\",\n      \"action\",\n      \"REST\"\n    ]\n  },\n  {\n    \"functionname\": \"getServiceRequestParameter\",\n    \"api\": \"serversideREST@Context\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Gets the value of an URI parameter in the request.\",\n    \"tags\": [\n      \"action\",\n      \"REST\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getSet\",\n    \"api\": \"serverside@RecordSet\",\n    \"returntype\": \"RecordSet\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getSize\",\n    \"api\": \"serverside@File\",\n    \"returntype\": \"long\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Gets the size in bytes of this file\"\n  },\n  {\n    \"functionname\": \"getString\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Gets a String from the applications String-resources and performs variable substitution using the given parameters.\",\n    \"tags\": [\n      \"basic\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"vars\",\n        \"type\": \"Map\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getString\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Gets a String from the applications String-resources\",\n    \"tags\": [\n      \"basic\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getStringValue\",\n    \"api\": \"serverside@Record\",\n    \"returntype\": \"String\",\n    \"shadowblocks\": {\n      \"name\": \"text#Attribute Name\"\n    },\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getSubdomainMetadata\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"Map\",\n    \"descr\": \"Gets the metadataof the subdomain for the request in scope, if any\",\n    \"tags\": [\n      \"standard\"\n    ]\n  },\n  {\n    \"functionname\": \"getSubject\",\n    \"api\": \"serverside@Mail\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getSystemManager\",\n    \"api\": \"serversideREST@Context\",\n    \"returntype\": \"SystemManager\",\n    \"tooltip\": \"$\",\n    \"descr\": \"TODO\",\n    \"tags\": [\n      \"standard\"\n    ]\n  },\n  {\n    \"functionname\": \"getTags\",\n    \"api\": \"serversideDevice@Context\",\n    \"returntype\": \"Object\"\n  },\n  {\n    \"functionname\": \"getTenant\",\n    \"api\": \"serverside@User\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getTenantId\",\n    \"api\": \"serverside@User\",\n    \"returntype\": \"ID\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getTenantId\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Returns the ID of the current user's tenant.\",\n    \"tags\": [\n      \"basic\"\n    ]\n  },\n  {\n    \"functionname\": \"getTenantName\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Returns the name of the current user's tenant.\",\n    \"tags\": [\n      \"basic\"\n    ]\n  },\n  {\n    \"functionname\": \"getTo\",\n    \"api\": \"serverside@Mail\",\n    \"returntype\": \"String[]\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getToday\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"DateTime\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getTokenProperty\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"Object\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Gets a custom property from the access-token\",\n    \"tags\": [\n      \"basic\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"key\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getURI\",\n    \"api\": \"serverside@Record\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getURL\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Gets the server base-URL\",\n    \"tags\": [\n      \"standard\"\n    ]\n  },\n  {\n    \"functionname\": \"getURL\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Gets the url of a specific view\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"userInterface\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"view\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"recordId\",\n        \"type\": \"String/ID\"\n      },\n      {\n        \"name\": \"params\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getUser\",\n    \"api\": \"serverside@User\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getUser\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"User\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Gets the current User\",\n    \"tags\": [\n      \"basic\"\n    ]\n  },\n  {\n    \"functionname\": \"getUserId\",\n    \"api\": \"serverside@User\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getUserRoles\",\n    \"api\": \"serverside@SystemManager\",\n    \"returntype\": \"Role[]\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"userObj\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getUsersWithRole\",\n    \"api\": \"serverside@SystemManager\",\n    \"returntype\": \"User[]\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"roleObj\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getValue\",\n    \"api\": \"serverside@Record\",\n    \"returntype\": \"Object\",\n    \"shadowblocks\": {\n      \"name\": \"text#Attribute Name\"\n    },\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getVersion\",\n    \"api\": \"serverside@Record\",\n    \"returntype\": \"int\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getWeek\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"int\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getWeek\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"int\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"getYear\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"int\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"getYear\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"int\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"hasFeature\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"boolean\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Checks for the presence of an application-feature\",\n    \"tags\": [\n      \"basic\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"hash\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Compute the hash of a string using a given algorithm\",\n    \"tags\": [\n      \"basic\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"data\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"algorithm\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"hasMetadata\",\n    \"api\": \"serverside@Record\",\n    \"returntype\": \"boolean\",\n    \"shadowblocks\": {\n      \"name\": \"text#Attribute Name\"\n    },\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"hasNext\",\n    \"api\": \"serverside@QueryResult\",\n    \"returntype\": \"boolean\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"hasPrivilege\",\n    \"api\": \"serverside@User\",\n    \"returntype\": \"boolean\",\n    \"shadowblocks\": {\n      \"name\": \"text#Read\"\n    },\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"model\",\n        \"type\": \"Model\"\n      },\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"hasPrivilege\",\n    \"api\": \"serverside@User\",\n    \"returntype\": \"boolean\",\n    \"shadowblocks\": {\n      \"name\": \"text#Read\"\n    },\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"record\",\n        \"type\": \"Record\"\n      },\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"hasRequest\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"boolean\",\n    \"tooltip\": \"$\",\n    \"descr\": \"True if there is a pending REST request\",\n    \"tags\": [\n      \"standard\",\n      \"action\",\n      \"REST\"\n    ]\n  },\n  {\n    \"functionname\": \"hasResponse\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"boolean\",\n    \"tooltip\": \"$\",\n    \"descr\": \"True if it is possible to respond to a pending REST request\",\n    \"tags\": [\n      \"standard\",\n      \"action\",\n      \"REST\"\n    ]\n  },\n  {\n    \"functionname\": \"hasRole\",\n    \"api\": \"serverside@User\",\n    \"returntype\": \"boolean\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"role\",\n        \"type\": \"Role\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"hasValue\",\n    \"api\": \"serverside@Record\",\n    \"returntype\": \"boolean\",\n    \"shadowblocks\": {\n      \"name\": \"text#Attribute Name\"\n    },\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"http\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"Promise\",\n    \"togglereturn\": true,\n    \"objecttypeoverride\": {\n      \"options\": {\n        \"url\": \"String\",\n        \"method\": \"String/HTTP-Method\",\n        \"contentType\": \"String\",\n        \"handleAs\": \"String\",\n        \"body\": \"String,Object\",\n        \"headers\": \"Object\",\n        \"parameters\": \"Object\"\n      }\n    },\n    \"shadowblocks\": {\n      \"url\": \"text#wwwexamplecom\",\n      \"headers\": \"object#field1#field2\",\n      \"parameters\": \"object#field1#field2\",\n      \"contentType\": \"text\",\n      \"body\": \"text\"\n    },\n    \"tooltip\": \"$\",\n    \"descr\": \"Sends an HTTP-request\",\n    \"tags\": [\n      \"basic\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"options\",\n        \"type\": \"Map\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"importRecords\",\n    \"api\": \"serverside@DataFunctions\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Import a set of records from an application resource\",\n    \"params\": [\n      {\n        \"name\": \"model\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"resource\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"inTransaction\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"boolean\",\n    \"descr\": \"Checks whether is an active database transaction in place\",\n    \"tags\": [\n      \"standard\"\n    ]\n  },\n  {\n    \"functionname\": \"intToTime\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"time\",\n        \"type\": \"long\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"invoke\",\n    \"api\": \"serversideDevice@Context\",\n    \"returntype\": \"Object\",\n    \"params\": [\n      {\n        \"name\": \"funcName\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"args\",\n        \"type\": \"Map\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"invoke\",\n    \"api\": \"serversideDevice@Context\",\n    \"returntype\": \"Object\",\n    \"params\": [\n      {\n        \"name\": \"funcName\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"invokeAction\",\n    \"api\": \"serversideApplication@Context\",\n    \"returntype\": \"ActionResult\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Executes an action\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"actionRef\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"recordObj\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"parameters\",\n        \"type\": \"Map\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"isActive\",\n    \"api\": \"serverside@User\",\n    \"returntype\": \"boolean\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"isAsync\",\n    \"api\": \"serverside@ServiceRequest\",\n    \"returntype\": \"boolean\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Checks if this request/response-pair is in asynchronous-mode\"\n  },\n  {\n    \"functionname\": \"isAsync\",\n    \"api\": \"serverside@ServiceResponse\",\n    \"returntype\": \"boolean\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"isDocument\",\n    \"api\": \"serverside@Record\",\n    \"returntype\": \"boolean\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"isFailed\",\n    \"api\": \"serverside@HttpResponse\",\n    \"returntype\": \"boolean\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"isHtml\",\n    \"api\": \"serverside@Mail\",\n    \"returntype\": \"boolean\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"isNew\",\n    \"api\": \"serverside@Record\",\n    \"returntype\": \"boolean\",\n    \"tooltip\": \"$Record__isNew_tooltip\"\n  },\n  {\n    \"functionname\": \"isOk\",\n    \"api\": \"serverside@HttpResponse\",\n    \"returntype\": \"boolean\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"isReference\",\n    \"api\": \"serverside@Record\",\n    \"returntype\": \"boolean\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"isRelationLoaded\",\n    \"api\": \"serverside@Record\",\n    \"returntype\": \"boolean\",\n    \"shadowblocks\": {\n      \"name\": \"text#relation\"\n    },\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"isSubdomainAvailable\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"boolean\",\n    \"descr\": \"Check if a subdomain is available\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"isUserAllowed\",\n    \"api\": \"serversideApplication@Context\",\n    \"returntype\": \"boolean\",\n    \"shadowblocks\": {\n      \"privilege\": \"text#Read\"\n    },\n    \"tooltip\": \"$\",\n    \"descr\": \"Checks if a User has a certain privilege on a Record\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"record\",\n        \"type\": \"Record\"\n      },\n      {\n        \"name\": \"userRef\",\n        \"type\": \"User, String\"\n      },\n      {\n        \"name\": \"privilege\",\n        \"type\": \"Privilege, String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"jsonpath\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"Object\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Executes a jsonpath-expression on the provided JSON-document\",\n    \"tags\": [\n      \"basic\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"path\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"document\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"load\",\n    \"api\": \"serverside@Record\",\n    \"shadowblocks\": {\n      \"force\": \"boolean#false\"\n    },\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"force\",\n        \"type\": \"boolean\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"log\",\n    \"api\": \"serversideRuntime@Context\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Log a message to the application-log with a given severity (one of TRACE, DEBUG, INFO, WARN, ERROR)\",\n    \"tags\": [\n      \"basic\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"level\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"message\",\n        \"type\": \"Object[]\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"log\",\n    \"api\": \"serversideRuntime@Context\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Log a message to the application-log\",\n    \"tags\": [\n      \"basic\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"message\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"lookupGroup\",\n    \"api\": \"serversideApplication@Context\",\n    \"returntype\": \"Group\",\n    \"shadowblocks\": {\n      \"name\": \"text#groupname\"\n    },\n    \"tooltip\": \"$\",\n    \"descr\": \"Looks up a Group given its name\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"lookupUser\",\n    \"api\": \"serversideApplication@Context\",\n    \"returntype\": \"User\",\n    \"shadowblocks\": {\n      \"name\": \"text#username\"\n    },\n    \"tooltip\": \"$\",\n    \"descr\": \"Lookup a User given his username\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"map\",\n    \"api\": \"serverside@DataFunctions\",\n    \"returntype\": \"Map\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Indexes an array of Objects or Records given a key\",\n    \"params\": [\n      {\n        \"name\": \"list\",\n        \"type\": \"Object[]\"\n      },\n      {\n        \"name\": \"key\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"merge\",\n    \"api\": \"serverside@RecordSet\",\n    \"returntype\": \"RecordSet\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"recs\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"newDate\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"DateTime\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"dateObj\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"timezone\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"next\",\n    \"api\": \"serverside@QueryResult\",\n    \"returntype\": \"Record\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"now\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"DateTime\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"parse\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"DateTime\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"str\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"pattern\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"parseHTML\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"Document\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Parses html string\",\n    \"tags\": [\n      \"basic\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"html\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"parseXML\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"Document\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Parses xml string\",\n    \"tags\": [\n      \"basic\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"xml\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"pivot\",\n    \"api\": \"serverside@RecordSet\",\n    \"returntype\": \"RecordSet\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"keys\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"provisionUser\",\n    \"api\": \"serverside@SystemManager\",\n    \"returntype\": \"User\",\n    \"objecttypeoverride\": {\n      \"options\": {\n        \"name\": \"String\",\n        \"firstname\": \"String\",\n        \"lastname\": \"String\",\n        \"phonenumber\": \"String\",\n        \"applications\": \"Object\"\n      }\n    },\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"options\",\n        \"type\": \"Map\"\n      },\n      {\n        \"name\": \"user\",\n        \"type\": \"User\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"provisionUser\",\n    \"api\": \"serverside@SystemManager\",\n    \"returntype\": \"User\",\n    \"objecttypeoverride\": {\n      \"options\": {\n        \"name\": \"String\",\n        \"firstname\": \"String\",\n        \"lastname\": \"String\",\n        \"phonenumber\": \"String\",\n        \"applications\": \"Object\"\n      }\n    },\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"options\",\n        \"type\": \"Map\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"publish\",\n    \"api\": \"serversideRuntime@Context\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Publish a message to the bus\",\n    \"tags\": [\n      \"basic\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"topic\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"message\",\n        \"type\": \"Map\"\n      },\n      {\n        \"name\": \"headers\",\n        \"type\": \"Map\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"publish\",\n    \"api\": \"serversideRuntime@Context\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Publish a message to the bus\",\n    \"tags\": [\n      \"basic\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"topic\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"message\",\n        \"type\": \"Map\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"query\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"Result\",\n    \"descr\": \"Executes a query using the provided parameters\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"queryStr\",\n        \"type\": \"String/Query-ID\"\n      },\n      {\n        \"name\": \"params\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"user\",\n        \"type\": \"User\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"queryForArray\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"Array\",\n    \"descr\": \"Executes a query using the provided parameters and returns the resulting records as an array\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"query\",\n        \"type\": \"String/Query-ID\"\n      },\n      {\n        \"name\": \"params\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"user\",\n        \"type\": \"User\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"queryForRecords\",\n    \"api\": \"serversideApplication@Context\",\n    \"returntype\": \"RecordSet\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Lookup a User given his username\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"query\",\n        \"type\": \"String/Query-ID\"\n      },\n      {\n        \"name\": \"params\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"user\",\n        \"type\": \"User\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"queryForSingle\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"Record\",\n    \"descr\": \"Executes a query using the given parameters and returns just the first record or null\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"query\",\n        \"type\": \"String/Query-ID\"\n      },\n      {\n        \"name\": \"params\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"user\",\n        \"type\": \"User\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"randomString\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Generates a randomized alphanumeric string of a given size (default is 16 characters)\",\n    \"tags\": [\n      \"basic\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"size\",\n        \"type\": \"int\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"readObject\",\n    \"api\": \"serverside@ServiceRequest\",\n    \"returntype\": \"null\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Parses the body of the request and returns the appropriate object.\"\n  },\n  {\n    \"functionname\": \"readServiceRequestObject\",\n    \"api\": \"serversideREST@Context\",\n    \"returntype\": \"Object\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Reads the request data and returns it as an object.\",\n    \"tags\": [\n      \"standard\",\n      \"action\",\n      \"REST\"\n    ]\n  },\n  {\n    \"functionname\": \"reboot\",\n    \"api\": \"serversideDevice@Context\",\n    \"params\": [\n      {\n        \"name\": \"hard\",\n        \"type\": \"boolean\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"removeMember\",\n    \"api\": \"serverside@Group\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Removes a member from this group\",\n    \"params\": [\n      {\n        \"name\": \"user\",\n        \"type\": \"User\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"removeRoleFromUser\",\n    \"api\": \"serverside@SystemManager\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"userObj\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"roleObj\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"requestExecutionTime\",\n    \"api\": \"serversideApplication@Context\",\n    \"returntype\": \"boolean\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Requests an extension of this actions runtime\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"milliseconds\",\n        \"type\": \"int\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"requestRetry\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"boolean\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Request re-execution of this action after a given delay\",\n    \"tags\": [\n      \"action\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"delay\",\n        \"type\": \"int\"\n      },\n      {\n        \"name\": \"reason\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"revokeFromGroup\",\n    \"api\": \"serversideApplication@Context\",\n    \"shadowblocks\": {\n      \"privilege\": \"text#Read\"\n    },\n    \"tooltip\": \"$\",\n    \"descr\": \"Revokes a privilege on a particular model from a Group\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"record\",\n        \"type\": \"Record\"\n      },\n      {\n        \"name\": \"groupRef\",\n        \"type\": \"Group, String\"\n      },\n      {\n        \"name\": \"privilege\",\n        \"type\": \"Privilege, String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"revokeFromRole\",\n    \"api\": \"serversideApplication@Context\",\n    \"shadowblocks\": {\n      \"privilege\": \"text#Read\"\n    },\n    \"tooltip\": \"$\",\n    \"descr\": \"Revokes a privilege on a particular model from a Role\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"record\",\n        \"type\": \"Record\"\n      },\n      {\n        \"name\": \"roleRef\",\n        \"type\": \"Role, String\"\n      },\n      {\n        \"name\": \"privilege\",\n        \"type\": \"Privilege, String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"revokeFromUser\",\n    \"api\": \"serversideApplication@Context\",\n    \"shadowblocks\": {\n      \"privilege\": \"text#Read\"\n    },\n    \"tooltip\": \"$\",\n    \"descr\": \"Revokes a privilege on a particular model from a User\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"record\",\n        \"type\": \"Record\"\n      },\n      {\n        \"name\": \"userRef\",\n        \"type\": \"User, String\"\n      },\n      {\n        \"name\": \"privilege\",\n        \"type\": \"Privilege, String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"rollback\",\n    \"api\": \"serversideRuntime@Context\",\n    \"descr\": \"Rolls back a database transaction\",\n    \"tags\": [\n      \"standard\"\n    ]\n  },\n  {\n    \"functionname\": \"scheduleTask\",\n    \"api\": \"serversideDevice@Context\",\n    \"returntype\": \"TimerTask\",\n    \"params\": [\n      {\n        \"name\": \"options\",\n        \"type\": \"Map\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"select\",\n    \"api\": \"serverside@RecordSet\",\n    \"returntype\": \"RecordSet\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"transform\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"sendError\",\n    \"api\": \"serverside@ServiceResponse\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Send an error-response\",\n    \"params\": [\n      {\n        \"name\": \"errorCode\",\n        \"type\": \"int\"\n      },\n      {\n        \"name\": \"message\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"sendHttpRequest\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"HttpResponse\",\n    \"togglereturn\": true,\n    \"objecttypeoverride\": {\n      \"options\": {\n        \"url\": \"String\",\n        \"method\": \"String/HTTP-Method\",\n        \"handleAs\": \"String\",\n        \"body\": \"String,Object\",\n        \"headers\": \"Object\",\n        \"parameters\": \"Object\"\n      }\n    },\n    \"shadowblocks\": {\n      \"url\": \"text#wwwexamplecom\",\n      \"headers\": \"object#field1#field2\",\n      \"parameters\": \"object#field1#field2\",\n      \"body\": \"text\"\n    },\n    \"tooltip\": \"$\",\n    \"descr\": \"Send an http-request\",\n    \"tags\": [\n      \"basic\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"options\",\n        \"type\": \"Map\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"sendMail\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"boolean\",\n    \"togglereturn\": true,\n    \"objecttypeoverride\": {\n      \"options\": {\n        \"from\": \"String\",\n        \"fromName\": \"String\",\n        \"to\": \"String\",\n        \"replyTo\": \"String, Array/String\",\n        \"subject\": \"String\",\n        \"body\": \"String\",\n        \"htmlBody\": \"String\",\n        \"attachments\": \"Array/String, Object\"\n      }\n    },\n    \"shadowblocks\": {\n      \"url\": \"text#wwwexamplecom\",\n      \"headers\": \"object#field1#field2\",\n      \"parameters\": \"object#field1#field2\",\n      \"body\": \"text\"\n    },\n    \"tooltip\": \"$\",\n    \"descr\": \"Sends an email to one or more recipients\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"options\",\n        \"type\": \"Map\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"sendPush\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"boolean\",\n    \"togglereturn\": true,\n    \"tooltip\": \"$\",\n    \"descr\": \"Sends a push-notification to one or more recipients\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"pushObject\",\n        \"type\": \"Map\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"sendServiceResponseError\",\n    \"api\": \"serversideREST@Context\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Sends an error to the client that invoked the rule\",\n    \"tags\": [\n      \"action\",\n      \"REST\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"errorCode\",\n        \"type\": \"int\"\n      },\n      {\n        \"name\": \"message\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"sendSMS\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"boolean\",\n    \"objecttypeoverride\": {\n      \"smsObject\": {\n        \"from\": \"String\",\n        \"to\": \"String\",\n        \"body\": \"String\"\n      }\n    },\n    \"tooltip\": \"$\",\n    \"descr\": \"Sends an SMS to one or more recipients\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"smsObject\",\n        \"type\": \"Map\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"setAttributeValue\",\n    \"api\": \"serverside@Record\",\n    \"returntype\": \"boolean\",\n    \"togglereturn\": true,\n    \"shadowblocks\": {\n      \"name\": \"text#Attribute Name\"\n    },\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"value\",\n        \"type\": \"null\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"setContent\",\n    \"api\": \"serverside@ServiceResponse\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Set the content of the body given a String\",\n    \"params\": [\n      {\n        \"name\": \"body\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"setContentType\",\n    \"api\": \"serverside@ServiceResponse\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Set the content-type of this response\",\n    \"params\": [\n      {\n        \"name\": \"contentType\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"setData\",\n    \"api\": \"serversideRuntime@Context\",\n    \"tags\": [\n      \"basic\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"key\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"value\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"scope\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"setDataWithExpiration\",\n    \"api\": \"serversideRuntime@Context\",\n    \"tags\": [\n      \"basic\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"key\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"value\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"expiration\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"setDataWithTTL\",\n    \"api\": \"serversideRuntime@Context\",\n    \"tags\": [\n      \"basic\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"key\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"value\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"ttl\",\n        \"type\": \"long\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"setDayInMonth\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"DateTime\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"day\",\n        \"type\": \"int\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"setFirstName\",\n    \"api\": \"serverside@User\",\n    \"shadowblocks\": {\n      \"firstName\": \"text#firstname\"\n    },\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"firstName\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"setHeader\",\n    \"api\": \"serverside@ServiceResponse\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Sets a header for this response\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"value\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"setHour\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"DateTime\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"hour\",\n        \"type\": \"int\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"setLastName\",\n    \"api\": \"serverside@User\",\n    \"shadowblocks\": {\n      \"lastName\": \"text#lastname\"\n    },\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"lastName\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"setMetadata\",\n    \"api\": \"serverside@Record\",\n    \"shadowblocks\": {\n      \"key\": \"text#Attribute Name\"\n    },\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"key\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"value\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"setMillisecond\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"DateTime\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"millisecond\",\n        \"type\": \"int\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"setMinute\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"DateTime\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"minutes\",\n        \"type\": \"int\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"setMonth\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"DateTime\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"month\",\n        \"type\": \"int\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"setName\",\n    \"api\": \"serverside@User\",\n    \"shadowblocks\": {\n      \"firstName\": \"text#name\"\n    },\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"setPassword\",\n    \"api\": \"serverside@User\",\n    \"shadowblocks\": {\n      \"password\": \"text\"\n    },\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"password\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"setRecords\",\n    \"api\": \"serverside@Model\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"records\",\n        \"type\": \"Array\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"setRelatedRecords\",\n    \"api\": \"serverside@Record\",\n    \"shadowblocks\": {\n      \"name\": \"text#relation\"\n    },\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"records\",\n        \"type\": \"List\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"setSecond\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"DateTime\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"second\",\n        \"type\": \"int\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"setServiceResponseHeaders\",\n    \"api\": \"serversideREST@Context\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Sets the response headers to be the fields in the provided object.\",\n    \"tags\": [\n      \"standard\",\n      \"action\",\n      \"REST\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"headers\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"setStatus\",\n    \"api\": \"serverside@ServiceResponse\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Sets the status-code for this response\",\n    \"params\": [\n      {\n        \"name\": \"status\",\n        \"type\": \"int\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"setValue\",\n    \"api\": \"serverside@Record\",\n    \"returntype\": \"boolean\",\n    \"togglereturn\": true,\n    \"shadowblocks\": {\n      \"name\": \"text#Attribute Name\"\n    },\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"value\",\n        \"type\": \"null\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"setYear\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"DateTime\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"year\",\n        \"type\": \"int\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"size\",\n    \"api\": \"serverside@Record\",\n    \"returntype\": \"int\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"size\",\n    \"api\": \"serverside@RecordSet\",\n    \"returntype\": \"int\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"sleep\",\n    \"api\": \"serversideDevice@Context\",\n    \"params\": [\n      {\n        \"name\": \"millis\",\n        \"type\": \"long\"\n      },\n      {\n        \"name\": \"nano\",\n        \"type\": \"int\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"sleep\",\n    \"api\": \"serversideDevice@Context\",\n    \"params\": [\n      {\n        \"name\": \"millis\",\n        \"type\": \"long\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"sort\",\n    \"api\": \"serverside@RecordSet\",\n    \"returntype\": \"RecordSet\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"keys\",\n        \"type\": \"Object\"\n      },\n      {\n        \"name\": \"dir\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"startAsync\",\n    \"api\": \"serverside@ServiceRequest\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Set this request/response-pair into asynchronous-mode. This means that the response can be sent sometime in the future.\",\n    \"params\": [\n      {\n        \"name\": \"timeout\",\n        \"type\": \"long\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"store\",\n    \"api\": \"serversideApplication@Context\",\n    \"returntype\": \"Record\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Stores a Record in the database. This will either create or update the Record depending on whether the record already exists.\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"object\",\n        \"type\": \"Record, Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"storeAsUser\",\n    \"api\": \"serversideApplication@Context\",\n    \"returntype\": \"Record\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Stores a Record in the database as a given User. This will either create or update the Record depending on whether the record already exists.\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"object\",\n        \"type\": \"Record, Object\"\n      },\n      {\n        \"name\": \"user\",\n        \"type\": \"User\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"subscribeUser\",\n    \"api\": \"serverside@SystemManager\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"user\",\n        \"type\": \"User\"\n      },\n      {\n        \"name\": \"roles\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"synchronize\",\n    \"api\": \"serverside@DataFunctions\",\n    \"returntype\": \"Map\",\n    \"objecttypeoverride\": {\n      \"options\": {\n        \"model\": \"String\",\n        \"key\": \"String\",\n        \"delete\": \"Boolean\",\n        \"records\": \"Array<Record,Object>\"\n      }\n    },\n    \"tooltip\": \"$\",\n    \"descr\": \"Synchronize a set of Records to a Model. This will ensure that the passed in records are persisted in the Model based on what is considered the primary key. This operation may result in the creation, deletion and update of records. If a database transaction is not already in scope one will be created and committed, but if a transaction is present no commit will be issued by this function.\",\n    \"params\": [\n      {\n        \"name\": \"options\",\n        \"type\": \"Map\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"timeToInt\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"long\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"time\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"toMidnight\",\n    \"api\": \"serverside@DateFunctions\",\n    \"returntype\": \"DateTime\",\n    \"tooltip\": \"$\",\n    \"params\": [\n      {\n        \"name\": \"date\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"toReference\",\n    \"api\": \"serverside@Record\",\n    \"returntype\": \"Record\",\n    \"tooltip\": \"$Record__toReference_tooltip\"\n  },\n  {\n    \"functionname\": \"toString\",\n    \"api\": \"serverside@Record\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"toString\",\n    \"api\": \"serverside@User\",\n    \"returntype\": \"String\",\n    \"tooltip\": \"$\"\n  },\n  {\n    \"functionname\": \"tx\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"boolean\",\n    \"descr\": \"Perform a set of operations wrapped inside a database transaction. When the function returns the transaction is commited, if an error occurs the transaction is rolled back. If the transaction is successfully committed the method returns true.\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"transaction\",\n        \"type\": \"Runnable\"\n      },\n      {\n        \"name\": \"onSuccess\",\n        \"type\": \"Runnable\"\n      },\n      {\n        \"name\": \"onError\",\n        \"type\": \"Consumer\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"update\",\n    \"api\": \"serversideApplication@Context\",\n    \"returntype\": \"Record\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Updates a Record in the database. Should be done within the context of a transaction.\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"object\",\n        \"type\": \"Record, Object\"\n      },\n      {\n        \"name\": \"options\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"update\",\n    \"api\": \"serversideDevice@Context\",\n    \"returntype\": \"Promise\",\n    \"params\": [\n      {\n        \"name\": \"recordObj\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"updateAs\",\n    \"api\": \"serversideApplication@Context\",\n    \"returntype\": \"Record\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Updates a Record in the database as a given User. Should be done within the context of a transaction.\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"object\",\n        \"type\": \"Record, Object\"\n      },\n      {\n        \"name\": \"user\",\n        \"type\": \"User\"\n      },\n      {\n        \"name\": \"options\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"updateSubdomain\",\n    \"api\": \"serversideRuntime@Context\",\n    \"descr\": \"Update the metadata of a subdomain bound to this application and tenant\",\n    \"tags\": [\n      \"standard\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"name\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"properties\",\n        \"type\": \"Map\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"waitForAll\",\n    \"api\": \"serversideRuntime@Context\",\n    \"returntype\": \"Promise\",\n    \"tags\": [\n      \"basic\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"promises\",\n        \"type\": \"Object[]\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"write\",\n    \"api\": \"serverside@ServiceResponse\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Write the body of this response given an object\",\n    \"params\": [\n      {\n        \"name\": \"value\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"functionname\": \"writeServiceResponseObject\",\n    \"api\": \"serversideREST@Context\",\n    \"tooltip\": \"$\",\n    \"descr\": \"Sends a response using the specified object.\",\n    \"tags\": [\n      \"standard\",\n      \"action\",\n      \"REST\"\n    ],\n    \"params\": [\n      {\n        \"name\": \"data\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"Insomnia#Plugin\",\n    \"functionname\": \"keepAwake\",\n    \"params\": [\n      {\n        \"name\": \"herp\",\n        \"type\": \"callback:res:data\"\n      }\n    ]\n  },\n  {\n    \"api\": \"Insomnia#Plugin\",\n    \"functionname\": \"allowSleep\",\n    \"params\": [\n      {\n        \"name\": \"derp\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"api\": \"gpio#Device\",\n    \"functionname\": \"getPin\",\n    \"returntype\": \"GPIOPin\",\n    \"params\": [\n      {\n        \"name\": \"pinName\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"api\": \"gpio#Device\",\n    \"functionname\": \"provisionPin\",\n    \"params\": [\n      {\n        \"name\": \"options\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"gpio#Device\",\n    \"functionname\": \"getValue\",\n    \"returntype\": \"Boolean\",\n    \"params\": [\n      {\n        \"name\": \"pinName\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"api\": \"gpio#Device\",\n    \"functionname\": \"setValue\",\n    \"params\": [\n      {\n        \"name\": \"pinName\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"value\",\n        \"type\": \"Boolean\"\n      }\n    ]\n  },\n  {\n    \"api\": \"GPIOPin#GPIOPin\",\n    \"functionname\": \"getValue\",\n    \"returntype\": \"Boolean\"\n  },\n  {\n    \"api\": \"GPIOPin#GPIOPin\",\n    \"functionname\": \"setValue\",\n    \"params\": [\n      {\n        \"name\": \"value\",\n        \"type\": \"Boolean\"\n      }\n    ]\n  },\n  {\n    \"api\": \"i2c#Device\",\n    \"functionname\": \"getDevice\",\n    \"returntype\": \"i2cDevice\",\n    \"params\": [\n      {\n        \"name\": \"bus\",\n        \"type\": \"Number\"\n      },\n      {\n        \"name\": \"device\",\n        \"type\": \"Number\"\n      }\n    ]\n  },\n  {\n    \"api\": \"I2cDevice#I2cDevice\",\n    \"functionname\": \"read\",\n    \"returntype\": \"Number\"\n  },\n  {\n    \"api\": \"I2cDevice#I2cDevice\",\n    \"functionname\": \"read\",\n    \"returntype\": \"Number\",\n    \"params\": [\n      {\n        \"name\": \"address\",\n        \"type\": \"Number\"\n      }\n    ]\n  },\n  {\n    \"api\": \"I2cDevice#I2cDevice\",\n    \"functionname\": \"read\",\n    \"returntype\": \"Array\",\n    \"params\": [\n      {\n        \"name\": \"address\",\n        \"type\": \"Number\"\n      },\n      {\n        \"name\": \"size\",\n        \"type\": \"Number\"\n      }\n    ]\n  },\n  {\n    \"api\": \"I2cDevice#I2cDevice\",\n    \"functionname\": \"write\",\n    \"params\": [\n      {\n        \"name\": \"byte\",\n        \"type\": \"Number\"\n      }\n    ]\n  },\n  {\n    \"api\": \"I2cDevice#I2cDevice\",\n    \"functionname\": \"write\",\n    \"params\": [\n      {\n        \"name\": \"address\",\n        \"type\": \"Number\"\n      },\n      {\n        \"name\": \"byte\",\n        \"type\": \"Number\"\n      }\n    ]\n  },\n  {\n    \"api\": \"I2cDevice#I2cDevice\",\n    \"functionname\": \"write\",\n    \"params\": [\n      {\n        \"name\": \"address\",\n        \"type\": \"Number\"\n      },\n      {\n        \"name\": \"data\",\n        \"type\": \"Array\"\n      }\n    ]\n  },\n  {\n    \"api\": \"I2cDevice#I2cDevice\",\n    \"functionname\": \"close\"\n  },\n  {\n    \"api\": \"spi#Device\",\n    \"functionname\": \"getDevice\",\n    \"returntype\": \"spiDevice\",\n    \"params\": [\n      {\n        \"name\": \"cs\",\n        \"type\": \"Number\"\n      },\n      {\n        \"name\": \"channel\",\n        \"type\": \"Number\"\n      }\n    ]\n  },\n  {\n    \"api\": \"SpiDevice#SpiDevice\",\n    \"functionname\": \"write\",\n    \"returntype\": \"Array\",\n    \"params\": [\n      {\n        \"name\": \"data\",\n        \"type\": \"Array\"\n      }\n    ]\n  },\n  {\n    \"api\": \"SpiDevice#SpiDevice\",\n    \"functionname\": \"write\",\n    \"returntype\": \"String\",\n    \"params\": [\n      {\n        \"name\": \"data\",\n        \"type\": \"String\"\n      },\n      {\n        \"name\": \"charset\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"api\": \"SpiDevice#SpiDevice\",\n    \"functionname\": \"close\"\n  },\n  {\n    \"api\": \"browser-control#Device\",\n    \"functionname\": \"navigateTo\",\n    \"params\": [\n      {\n        \"name\": \"url\",\n        \"type\": \"String\"\n      }\n    ]\n  },\n  {\n    \"api\": \"browser-control#Device\",\n    \"functionname\": \"navigateAsUser\",\n    \"objecttypeoverride\": {\n      \"opts\": {\n        \"app\": \"String\",\n        \"ui\": \"String\",\n        \"view\": \"String\",\n        \"user\": \"String\",\n        \"password\": \"String\",\n        \"lang\": \"String\"\n      }\n    },\n    \"params\": [\n      {\n        \"name\": \"opts\",\n        \"type\": \"Object\"\n      }\n    ]\n  },\n  {\n    \"api\": \"browser-control#Device\",\n    \"functionname\": \"refresh\"\n  }\n]",
'url:appivo/vue/components/autocompletion/appivo.json':"{\n\t\"!name\": \"appivo\",\n\t\"!define\":{\n\t\t\"Deferred\": {\n\t\t\t\"!name\": \"Deferred\",\n\t\t\t\"!url\": \"http://api.jquery.com/jQuery.Deferred/\",\n\t\t\t\"!doc\": \"A constructor function that returns a chainable utility object with methods to register multiple callbacks into callback queues, invoke callback queues, and relay the success or failure state of any synchronous or asynchronous function.\",\n\t\t\t\"always\": {\n\t\t\t\t\"!type\": \"fn(callback: fn()) -> Deferred\",\n\t\t\t\t\"!url\": \"http://api.jquery.com/deferred.always/\",\n\t\t\t\t\"!doc\": \"Add handlers to be called when the Deferred object is either resolved or rejected.\"\n\t\t\t},\n\t\t\t\"done\": {\n\t\t\t\t\"!type\": \"fn(callback: fn()) -> Deferred\",\n\t\t\t\t\"!url\": \"http://api.jquery.com/deferred.done/\",\n\t\t\t\t\"!doc\": \"Add handlers to be called when the Deferred object is resolved.\",\n\t\t\t\t\"functionName\": \"done\",\n\t\t\t\t\"snippetContent\": \"done(function() {\\n\\t${1:/* body... */}\\n});\"\n\t\t\t},\n\t\t\t\"fail\": {\n\t\t\t\t\"!type\": \"fn(callback: fn()) -> Deferred\",\n\t\t\t\t\"!url\": \"http://api.jquery.com/deferred.fail/\",\n\t\t\t\t\"!doc\": \"Add handlers to be called when the Deferred object is rejected.\"\n\t\t\t},\n\t\t\t\"isRejected\": {\n\t\t\t\t\"!type\": \"fn() -> bool\",\n\t\t\t\t\"!url\": \"http://api.jquery.com/deferred.isRejected/\",\n\t\t\t\t\"!doc\": \"Determine whether a Deferred object has been rejected.\"\n\t\t\t},\n\t\t\t\"isResolved\": {\n\t\t\t\t\"!type\": \"fn() -> bool\",\n\t\t\t\t\"!url\": \"http://api.jquery.com/deferred.isResolved/\",\n\t\t\t\t\"!doc\": \"Determine whether a Deferred object has been resolved.\"\n\t\t\t},\n\t\t\t\"notify\": {\n\t\t\t\t\"!type\": \"fn(args?: ?) -> Deferred\",\n\t\t\t\t\"!url\": \"http://api.jquery.com/deferred.notify/\",\n\t\t\t\t\"!doc\": \"Call the progressCallbacks on a Deferred object with the given args.\"\n\t\t\t},\n\t\t\t\"notifyWith\": {\n\t\t\t\t\"!type\": \"fn(context?: ?, args?: ?) -> Deferred\",\n\t\t\t\t\"!url\": \"http://api.jquery.com/deferred.notifyWith/\",\n\t\t\t\t\"!doc\": \"Call the progressCallbacks on a Deferred object with the given context and args.\"\n\t\t\t},\n\t\t\t\"pipe\": {\n\t\t\t\t\"!type\": \"fn(doneFilter?: fn(), failFilter?: fn()) -> Promise\",\n\t\t\t\t\"!url\": \"http://api.jquery.com/deferred.pipe/\",\n\t\t\t\t\"!doc\": \"Utility method to filter and/or chain Deferreds.\"\n\t\t\t},\n\t\t\t\"progress\": {\n\t\t\t\t\"!type\": \"fn(callback: fn()) -> Deferred\",\n\t\t\t\t\"!url\": \"http://api.jquery.com/deferred.progress/\",\n\t\t\t\t\"!doc\": \"Add handlers to be called when the Deferred object generates progress notifications.\"\n\t\t\t},\n\t\t\t\"promise\": {\n\t\t\t\t\"!type\": \"fn(target: ?) -> Promise\",\n\t\t\t\t\"!url\": \"http://api.jquery.com/deferred.promise/\",\n\t\t\t\t\"!doc\": \"Return a Deferred's Promise object.\"\n\t\t\t},\n\t\t\t\"reject\": {\n\t\t\t\t\"!type\": \"fn(args?: ?) -> Deferred\",\n\t\t\t\t\"!url\": \"http://api.jquery.com/deferred.reject/\",\n\t\t\t\t\"!doc\": \"Reject a Deferred object and call any failCallbacks with the given args.\"\n\t\t\t},\n\t\t\t\"rejectWith\": {\n\t\t\t\t\"!type\": \"fn(context?: ?, args?: ?) -> Deferred\",\n\t\t\t\t\"!url\": \"http://api.jquery.com/deferred.rejectWith/\",\n\t\t\t\t\"!doc\": \"Reject a Deferred object and call any failCallbacks with the given context and args.\"\n\t\t\t},\n\t\t\t\"resolve\": {\n\t\t\t\t\"!type\": \"fn(args?: ?) -> Deferred\",\n\t\t\t\t\"!url\": \"http://api.jquery.com/deferred.resolve/\",\n\t\t\t\t\"!doc\": \"Resolve a Deferred object and call any doneCallbacks with the given args.\"\n\t\t\t},\n\t\t\t\"resolveWith\": {\n\t\t\t\t\"!type\": \"fn(context?: ?, args?: ?) -> Deferred\",\n\t\t\t\t\"!url\": \"http://api.jquery.com/deferred.resolveWith/\",\n\t\t\t\t\"!doc\": \"Resolve a Deferred object and call any doneCallbacks with the given context and args.\"\n\t\t\t},\n\t\t\t\"state\": {\n\t\t\t\t\"!type\": \"fn() -> string\",\n\t\t\t\t\"!url\": \"http://api.jquery.com/deferred.state/\",\n\t\t\t\t\"!doc\": \"Determine the current state of a Deferred object.\"\n\t\t\t},\n\t\t\t\"then\": {\n\t\t\t\t\"!type\": \"fn(doneFilter: fn(), failFilter?: fn(), progressFilter?: fn()) -> Promise\",\n\t\t\t\t\"!url\": \"http://api.jquery.com/deferred.then/\",\n\t\t\t\t\"!doc\": \"Add handlers to be called when the Deferred object is resolved, rejected, or still in progress.\"\n\t\t\t},\n\n\t\t\t\"isFulfilled\":{\n\t\t\t\t\"!type\": \"fn() -> bool\",\n\t\t\t\t\"!url\": \"\",\n\t\t\t\t\"!doc\": \"Determine whether a Deferred object has been Fulfilled.\"\n\t\t\t},\n\t\t\t\"isCanceled\":{\n\t\t\t\t\"!type\": \"fn() -> bool\",\n\t\t\t\t\"!url\": \"\",\n\t\t\t\t\"!doc\": \"Determine whether a Deferred object has been Canceled.\"\n\t\t\t},\n\t\t\t\"addCallbacks\":{\n\t\t\t\t\"!type\": \"fn(callback: fn(), errback?: fn()) -> Deferred\",\n\t\t\t\t\"!url\": \"\",\n\t\t\t\t\"!doc\": \"Adds callback and error callback for this deferred instance\"\n\t\t\t},\n\t\t\t\"cancel\":{\n\t\t\t\t\"!type\": \"fn()\",\n\t\t\t\t\"!url\": \"\",\n\t\t\t\t\"!doc\": \"Cancels the asynchronous operation\"\n\t\t\t}\n\n\t\t},\n\t\t\"Promise\": {\n\t\t\t\"!name\": \"Promise\",\n\t\t\t\"!doc\": \"The Promise object is used for deferred and asynchronous computations. A Promise is in one of the three states:\",\n\t\t\t\"!url\": \"https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise\",\n\t\t\t\"always\": {\n\t\t\t\t\"!type\": \"fn(callback: fn()) -> Promise\",\n\t\t\t\t\"!url\": \"http://api.jquery.com/deferred.always/\",\n\t\t\t\t\"!doc\": \"Add handlers to be called when the Deferred object is either resolved or rejected.\"\n\t\t\t},\n\t\t\t\"done\": {\n\t\t\t\t\"!type\": \"fn(callback: fn()) -> Promise\",\n\t\t\t\t\"!url\": \"http://api.jquery.com/deferred.done/\",\n\t\t\t\t\"!doc\": \"Add handlers to be called when the Deferred object is resolved.\"\n\t\t\t},\n\t\t\t\"fail\": {\n\t\t\t\t\"!type\": \"fn(callback: fn()) -> Promise\",\n\t\t\t\t\"!url\": \"http://api.jquery.com/deferred.fail/\",\n\t\t\t\t\"!doc\": \"Add handlers to be called when the Deferred object is rejected.\"\n\t\t\t},\n\t\t\t\"isRejected\": {\n\t\t\t\t\"!type\": \"fn() -> bool\",\n\t\t\t\t\"!url\": \"http://api.jquery.com/deferred.isRejected/\",\n\t\t\t\t\"!doc\": \"Determine whether a Deferred object has been rejected.\"\n\t\t\t},\n\t\t\t\"isResolved\": {\n\t\t\t\t\"!type\": \"fn() -> bool\",\n\t\t\t\t\"!url\": \"http://api.jquery.com/deferred.isResolved/\",\n\t\t\t\t\"!doc\": \"Determine whether a Deferred object has been resolved.\"\n\t\t\t},\n\t\t\t\"notify\": {\n\t\t\t\t\"!type\": \"fn(args?: ?) -> Promise\",\n\t\t\t\t\"!url\": \"http://api.jquery.com/deferred.notify/\",\n\t\t\t\t\"!doc\": \"Call the progressCallbacks on a Deferred object with the given args.\"\n\t\t\t},\n\t\t\t\"notifyWith\": {\n\t\t\t\t\"!type\": \"fn(context?: ?, args?: ?) -> Promise\",\n\t\t\t\t\"!url\": \"http://api.jquery.com/deferred.notifyWith/\",\n\t\t\t\t\"!doc\": \"Call the progressCallbacks on a Deferred object with the given context and args.\"\n\t\t\t},\n\t\t\t\"progress\": {\n\t\t\t\t\"!type\": \"fn(callback: fn()) -> Promise\",\n\t\t\t\t\"!url\": \"http://api.jquery.com/deferred.progress/\",\n\t\t\t\t\"!doc\": \"Add handlers to be called when the Deferred object generates progress notifications.\"\n\t\t\t},\n\t\t\t\"reject\": {\n\t\t\t\t\"!type\": \"fn(args?: ?) -> Promise\",\n\t\t\t\t\"!url\": \"http://api.jquery.com/deferred.reject/\",\n\t\t\t\t\"!doc\": \"Reject a Deferred object and call any failCallbacks with the given args.\"\n\t\t\t},\n\t\t\t\"rejectWith\": {\n\t\t\t\t\"!type\": \"fn(context?: ?, args?: ?) -> Promise\",\n\t\t\t\t\"!url\": \"http://api.jquery.com/deferred.rejectWith/\",\n\t\t\t\t\"!doc\": \"Reject a Deferred object and call any failCallbacks with the given context and args.\"\n\t\t\t},\n\t\t\t\"resolve\": {\n\t\t\t\t\"!type\": \"fn(args?: ?) -> Promise\",\n\t\t\t\t\"!url\": \"http://api.jquery.com/deferred.resolve/\",\n\t\t\t\t\"!doc\": \"Resolve a Deferred object and call any doneCallbacks with the given args.\"\n\t\t\t},\n\t\t\t\"resolveWith\": {\n\t\t\t\t\"!type\": \"fn(context?: ?, args?: ?) -> Promise\",\n\t\t\t\t\"!url\": \"http://api.jquery.com/deferred.resolveWith/\",\n\t\t\t\t\"!doc\": \"Resolve a Deferred object and call any doneCallbacks with the given context and args.\"\n\t\t\t},\n\t\t\t\"state\": {\n\t\t\t\t\"!type\": \"fn() -> string\",\n\t\t\t\t\"!url\": \"http://api.jquery.com/deferred.state/\",\n\t\t\t\t\"!doc\": \"Determine the current state of a Deferred object.\"\n\t\t\t},\n\t\t\t\"then\": {\n\t\t\t\t\"!type\": \"fn(doneFilter: fn(), failFilter?: fn(), progressFilter?: fn()) -> Promise\",\n\t\t\t\t\"!url\": \"http://api.jquery.com/deferred.then/\",\n\t\t\t\t\"!doc\": \"Add handlers to be called when the Deferred object is resolved, rejected, or still in progress.\",\n\t\t\t\t\"functionName\": \"then\",\n\t\t\t\t\"snippetContent\": \"then(function(value) {\\n\\t${1:\\t/* success */}\\n},function(error) {\\n\\t${2:\\t/* error */}\\n});\"\n\t\t\t},\n\n\t\t\t\"isFulfilled\":{\n\t\t\t\t\"!type\": \"fn() -> bool\",\n\t\t\t\t\"!url\": \"\",\n\t\t\t\t\"!doc\": \"Determine whether a Deferred object has been Fulfilled.\"\n\t\t\t},\n\t\t\t\"isCanceled\":{\n\t\t\t\t\"!type\": \"fn() -> bool\",\n\t\t\t\t\"!url\": \"\",\n\t\t\t\t\"!doc\": \"Determine whether a Deferred object has been Canceled.\"\n\t\t\t},\n\t\t\t\"cancel\":{\n\t\t\t\t\"!type\": \"fn()\",\n\t\t\t\t\"!url\": \"\",\n\t\t\t\t\"!doc\": \"Cancels the asynchronous operation\"\n\t\t\t}\n\t\t}\n\t}\n}\n",
'url:appivo/vue/components/autocompletion/context.json':"{\"!name\":\"context\",\"!define\":{\"DataFunctions\":{\"!name\":\"DataFunctions\",\"compare\":{\"!type\":\"fn(value1: object, value2: object, options: object) -> string\",\"!doc\":\"Compares two objects, returns true if they are equal\",\"!url\":\"https://docs.appivo.com/apis/datafunctions/#compare\",\"returnType\":\"String\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value1\",\"description\":\"value1 First value\"},{\"type\":\"Object\",\"name\":\"value2\",\"description\":\"value2 Second value\"},{\"type\":\"Object\",\"name\":\"options\",\"description\":\"options Options\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value1\",\"description\":\"value1 First value\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value2\",\"description\":\"value2 Second value\",\"children\":[]},{\"type\":\"Object\",\"name\":\"options\",\"description\":\"options Options\",\"children\":[{\"type\":\"Array\",\"name\":\"include\",\"description\":\"options.include Array of fields to explicitly include\"},{\"type\":\"Array\",\"name\":\"exclude\",\"description\":\"options.exclude Array of fields to explicitly exclude\"}]}],\"functionName\":\"compare\",\"snippetContent\":\"compare(${1:{}}, ${2:{}}, {\\n\\t'include' : ${3:Array}, \\n\\t'exclude' : ${4:Array}\\n});\"},\"generateId\":{\"!type\":\"fn(length: Number, opts: object) -> string\",\"!doc\":\"Generates a random ID.\",\"!url\":\"https://docs.appivo.com/apis/datafunctions/#generateid\",\"returnType\":\"String\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Number\",\"name\":\"length\",\"description\":\"length Number of characters (if omitted default is 8)\"},{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"opts Options\"}],\"parameterStructure\":[{\"type\":\"Number\",\"name\":\"length\",\"description\":\"length Number of characters (if omitted default is 8)\",\"children\":[]},{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"opts Options\",\"children\":[{\"type\":\"String\",\"name\":\"chars\",\"description\":\"opts.chars A string containing all valid characters in the ID (by default all alphanumeric characters are included)\"}]}],\"functionName\":\"generateId\",\"snippetContent\":\"generateId(${1:length}, ${3:{\\n\\t'chars' : '${2:string}'}\\n});\"},\"importRecords\":{\"!type\":\"fn(Name: string, resource: string, opts: object) -> Promise\",\"!doc\":\"Import records from an application resource\",\"!url\":\"https://docs.appivo.com/apis/datafunctions/#importrecords\",\"returnType\":\"Promise\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"Name\",\"description\":\"Name of model to import to\"},{\"type\":\"String\",\"name\":\"resource\",\"description\":\"resource Name or ID of resource to read records from\"},{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"opts\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"Name\",\"description\":\"Name of model to import to\",\"children\":[]},{\"type\":\"String\",\"name\":\"resource\",\"description\":\"resource Name or ID of resource to read records from\",\"children\":[]},{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"opts\",\"children\":[]}],\"functionName\":\"importRecords\",\"snippetContent\":\"importRecords(${1:Name}, ${2:resource}, ${3:{}});\"},\"parseXML\":{\"!type\":\"fn(text: string) -> Document\",\"!doc\":\"Parse an XML-document\",\"!url\":\"https://docs.appivo.com/apis/datafunctions/#parsexml\",\"returnType\":\"Document\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"text\",\"description\":\"text String to parse\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"text\",\"description\":\"text String to parse\",\"children\":[]}],\"functionName\":\"parseXML\",\"snippetContent\":\"parseXML(${1:text});\"},\"serializeXML\":{\"!type\":\"fn(doc: Document) -> string\",\"!doc\":\"Serialize an XML-document\",\"!url\":\"https://docs.appivo.com/apis/datafunctions/#serializexml\",\"returnType\":\"String\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Document\",\"name\":\"doc\",\"description\":\"doc Document to serialize\"}],\"parameterStructure\":[{\"type\":\"Document\",\"name\":\"doc\",\"description\":\"doc Document to serialize\",\"children\":[]}],\"functionName\":\"serializeXML\",\"snippetContent\":\"serializeXML(${1:doc});\"},\"transpose\":{\"!type\":\"fn(records: [], options: object) -> []\",\"!doc\":\"Transposes an array of objects/records\",\"!url\":\"https://docs.appivo.com/apis/datafunctions/#transpose\",\"returnType\":\"Array\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Array\",\"name\":\"records\",\"description\":\"records\"},{\"type\":\"Object\",\"name\":\"options\",\"description\":\"options\"}],\"parameterStructure\":[{\"type\":\"Array\",\"name\":\"records\",\"description\":\"records\",\"children\":[]},{\"type\":\"Object\",\"name\":\"options\",\"description\":\"options\",\"children\":[]}],\"functionName\":\"transpose\",\"snippetContent\":\"transpose(${1:records}, ${2:{}});\"}},\"DateFunctions\":{\"!name\":\"DateFunctions\",\"addDays\":{\"!type\":\"fn(date: Date, days: Number) -> number\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#adddays\",\"returnType\":\"number\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to use as base when adding days (optional - current date is used if omitted)\"},{\"type\":\"Number\",\"name\":\"days\",\"description\":\"days to add\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to use as base when adding days (optional - current date is used if omitted)\",\"children\":[]},{\"type\":\"Number\",\"name\":\"days\",\"description\":\"days to add\",\"children\":[]}],\"functionName\":\"addDays\",\"snippetContent\":\"addDays(${1:date}, ${2:days});\"},\"addDaysToDate\":{\"!type\":\"fn(date: Date, days: Number)\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#adddaystodate\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to add days to (optional - if omitted the current date is used)\"},{\"type\":\"Number\",\"name\":\"days\",\"description\":\"Days to add\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to add days to (optional - if omitted the current date is used)\",\"children\":[]},{\"type\":\"Number\",\"name\":\"days\",\"description\":\"Days to add\",\"children\":[]}],\"functionName\":\"addDaysToDate\",\"snippetContent\":\"addDaysToDate(${1:date}, ${2:days});\"},\"addHours\":{\"!type\":\"fn(date: Date, hours: Number) -> number\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#addhours\",\"returnType\":\"number\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to use as base when adding hours (optional - current date is used if omitted)\"},{\"type\":\"Number\",\"name\":\"hours\",\"description\":\"hours to add\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to use as base when adding hours (optional - current date is used if omitted)\",\"children\":[]},{\"type\":\"Number\",\"name\":\"hours\",\"description\":\"hours to add\",\"children\":[]}],\"functionName\":\"addHours\",\"snippetContent\":\"addHours(${1:date}, ${2:hours});\"},\"addHoursToDate\":{\"!type\":\"fn(date: Date, hours: Number)\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#addhourstodate\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to add hours to (optional - if omitted the current date is used)\"},{\"type\":\"Number\",\"name\":\"hours\",\"description\":\"Hours to add\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to add hours to (optional - if omitted the current date is used)\",\"children\":[]},{\"type\":\"Number\",\"name\":\"hours\",\"description\":\"Hours to add\",\"children\":[]}],\"functionName\":\"addHoursToDate\",\"snippetContent\":\"addHoursToDate(${1:date}, ${2:hours});\"},\"addMinutes\":{\"!type\":\"fn(date: Date, minutes: Number) -> number\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#addminutes\",\"returnType\":\"number\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to use as base when adding minutes (optional - current date is used if omitted)\"},{\"type\":\"Number\",\"name\":\"minutes\",\"description\":\"minutes to add\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to use as base when adding minutes (optional - current date is used if omitted)\",\"children\":[]},{\"type\":\"Number\",\"name\":\"minutes\",\"description\":\"minutes to add\",\"children\":[]}],\"functionName\":\"addMinutes\",\"snippetContent\":\"addMinutes(${1:date}, ${2:minutes});\"},\"addMinutesToDate\":{\"!type\":\"fn(date: Date, minutes: Number)\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#addminutestodate\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to add hours to (optional - if omitted the current date is used)\"},{\"type\":\"Number\",\"name\":\"minutes\",\"description\":\"Hours to add\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to add hours to (optional - if omitted the current date is used)\",\"children\":[]},{\"type\":\"Number\",\"name\":\"minutes\",\"description\":\"Hours to add\",\"children\":[]}],\"functionName\":\"addMinutesToDate\",\"snippetContent\":\"addMinutesToDate(${1:date}, ${2:minutes});\"},\"addMonths\":{\"!type\":\"fn(date: Date, months: Number) -> number\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#addmonths\",\"returnType\":\"number\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to use as base when adding months (optional - current date is used if omitted)\"},{\"type\":\"Number\",\"name\":\"months\",\"description\":\"months to add\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to use as base when adding months (optional - current date is used if omitted)\",\"children\":[]},{\"type\":\"Number\",\"name\":\"months\",\"description\":\"months to add\",\"children\":[]}],\"functionName\":\"addMonths\",\"snippetContent\":\"addMonths(${1:date}, ${2:months});\"},\"addSeconds\":{\"!type\":\"fn(date: Date, seconds: Number) -> number\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#addseconds\",\"returnType\":\"number\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to use as base when adding seconds (optional - current date is used if omitted)\"},{\"type\":\"Number\",\"name\":\"seconds\",\"description\":\"Seconds to add\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to use as base when adding seconds (optional - current date is used if omitted)\",\"children\":[]},{\"type\":\"Number\",\"name\":\"seconds\",\"description\":\"Seconds to add\",\"children\":[]}],\"functionName\":\"addSeconds\",\"snippetContent\":\"addSeconds(${1:date}, ${2:seconds});\"},\"addWeeks\":{\"!type\":\"fn(date: Date, weeks: Number) -> number\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#addweeks\",\"returnType\":\"number\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to use as base when adding weeks (optional - current date is used if omitted)\"},{\"type\":\"Number\",\"name\":\"weeks\",\"description\":\"weeks to add\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to use as base when adding weeks (optional - current date is used if omitted)\",\"children\":[]},{\"type\":\"Number\",\"name\":\"weeks\",\"description\":\"weeks to add\",\"children\":[]}],\"functionName\":\"addWeeks\",\"snippetContent\":\"addWeeks(${1:date}, ${2:weeks});\"},\"addYears\":{\"!type\":\"fn(date: Date, year: Number) -> number\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#addyears\",\"returnType\":\"number\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to use as base when adding years (optional - current date is used if omitted)\"},{\"type\":\"Number\",\"name\":\"year\",\"description\":\"years to add\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to use as base when adding years (optional - current date is used if omitted)\",\"children\":[]},{\"type\":\"Number\",\"name\":\"year\",\"description\":\"years to add\",\"children\":[]}],\"functionName\":\"addYears\",\"snippetContent\":\"addYears(${1:date}, ${2:year});\"},\"diff\":{\"!type\":\"fn(date1: Date, date2: Date, unit: string) -> number\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#diff\",\"returnType\":\"number\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date1\",\"description\":\"First date\"},{\"type\":\"Date\",\"name\":\"date2\",\"description\":\"Second date\"},{\"type\":\"String\",\"name\":\"unit\",\"description\":\"The unit of the result can be either ms, s, m, h or d (default is ms)\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date1\",\"description\":\"First date\",\"children\":[]},{\"type\":\"Date\",\"name\":\"date2\",\"description\":\"Second date\",\"children\":[]},{\"type\":\"String\",\"name\":\"unit\",\"description\":\"The unit of the result can be either ms, s, m, h or d (default is ms)\",\"children\":[]}],\"functionName\":\"diff\",\"snippetContent\":\"diff(${1:date1}, ${2:date2}, ${3:unit});\"},\"format\":{\"!type\":\"fn(date: Date, pattern: string) -> string\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#format\",\"returnType\":\"String\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to format (optional - current date is used if omitted)\"},{\"type\":\"String\",\"name\":\"pattern\",\"description\":\"Dateformat pattern (e.g. \\\"yyyy-MM-dd\\\")\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to format (optional - current date is used if omitted)\",\"children\":[]},{\"type\":\"String\",\"name\":\"pattern\",\"description\":\"Dateformat pattern (e.g. \\\"yyyy-MM-dd\\\")\",\"children\":[]}],\"functionName\":\"format\",\"snippetContent\":\"format(${1:date}, ${2:pattern});\"},\"formatDate\":{\"!type\":\"fn(date: Date, datePattern: string, timePattern: string) -> string\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#formatdate\",\"returnType\":\"String\",\"returnDescription\":\"formatted date\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to format (optional - current date is used if omitted)\"},{\"type\":\"String\",\"name\":\"datePattern\",\"description\":\"Date formatting-pattern\"},{\"type\":\"String\",\"name\":\"timePattern\",\"description\":\"Time formatting-pattern\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to format (optional - current date is used if omitted)\",\"children\":[]},{\"type\":\"String\",\"name\":\"datePattern\",\"description\":\"Date formatting-pattern\",\"children\":[]},{\"type\":\"String\",\"name\":\"timePattern\",\"description\":\"Time formatting-pattern\",\"children\":[]}],\"functionName\":\"formatDate\",\"snippetContent\":\"formatDate(${1:date}, ${2:datePattern}, ${3:timePattern});\"},\"formatTime\":{\"!type\":\"fn(date: Date, timePattern: string)\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#formattime\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to format (optional - current date is used if omitted)\"},{\"type\":\"String\",\"name\":\"timePattern\",\"description\":\"Pattern to format time according to\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to format (optional - current date is used if omitted)\",\"children\":[]},{\"type\":\"String\",\"name\":\"timePattern\",\"description\":\"Pattern to format time according to\",\"children\":[]}],\"functionName\":\"formatTime\",\"snippetContent\":\"formatTime(${1:date}, ${2:timePattern});\"},\"getDate\":{\"!type\":\"fn()\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#getdate\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getDate\",\"snippetContent\":\"getDate();\"},\"getDayInMonth\":{\"!type\":\"fn(date: Date) -> number\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#getdayinmonth\",\"returnType\":\"number\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to get day from (optional - current date is used if omitted)\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to get day from (optional - current date is used if omitted)\",\"children\":[]}],\"functionName\":\"getDayInMonth\",\"snippetContent\":\"getDayInMonth(${1:date});\"},\"getDayInWeek\":{\"!type\":\"fn(date: Date) -> number\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#getdayinweek\",\"returnType\":\"number\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to get day in week from (optional - current date is used if omitted)\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to get day in week from (optional - current date is used if omitted)\",\"children\":[]}],\"functionName\":\"getDayInWeek\",\"snippetContent\":\"getDayInWeek(${1:date});\"},\"getEndOfMonth\":{\"!type\":\"fn(date: Date)\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#getendofmonth\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to get end of month from (optional - current date is used if omitted)\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to get end of month from (optional - current date is used if omitted)\",\"children\":[]}],\"functionName\":\"getEndOfMonth\",\"snippetContent\":\"getEndOfMonth(${1:date});\"},\"getHour\":{\"!type\":\"fn(date: Date) -> number\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#gethour\",\"returnType\":\"number\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to get hour from (optional - current date is used if omitted)\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to get hour from (optional - current date is used if omitted)\",\"children\":[]}],\"functionName\":\"getHour\",\"snippetContent\":\"getHour(${1:date});\"},\"getLastDayInMonth\":{\"!type\":\"fn(date: Date)\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#getlastdayinmonth\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to get last day in month from (optional - current date is used if omitted)\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to get last day in month from (optional - current date is used if omitted)\",\"children\":[]}],\"functionName\":\"getLastDayInMonth\",\"snippetContent\":\"getLastDayInMonth(${1:date});\"},\"getLastMondayFromDate\":{\"!type\":\"fn(date: Date)\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#getlastmondayfromdate\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to get monday of week from (optional - current date is used if omitted)\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to get monday of week from (optional - current date is used if omitted)\",\"children\":[]}],\"functionName\":\"getLastMondayFromDate\",\"snippetContent\":\"getLastMondayFromDate(${1:date});\"},\"getMinute\":{\"!type\":\"fn(date: Date) -> number\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#getminute\",\"returnType\":\"number\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to get hour from (optional - current date is used if omitted)\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to get hour from (optional - current date is used if omitted)\",\"children\":[]}],\"functionName\":\"getMinute\",\"snippetContent\":\"getMinute(${1:date});\"},\"getMondayFromWeek\":{\"!type\":\"fn(week: Number, year: Number)\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#getmondayfromweek\",\"parameterSignature\":[{\"type\":\"Number\",\"name\":\"week\",\"description\":\"Number Week week to get monday for\"},{\"type\":\"Number\",\"name\":\"year\",\"description\":\"Year year to get monday for\"}],\"parameterStructure\":[{\"type\":\"Number\",\"name\":\"week\",\"description\":\"Number Week week to get monday for\",\"children\":[]},{\"type\":\"Number\",\"name\":\"year\",\"description\":\"Year year to get monday for\",\"children\":[]}],\"functionName\":\"getMondayFromWeek\",\"snippetContent\":\"getMondayFromWeek(${1:week}, ${2:year});\"},\"getMonth\":{\"!type\":\"fn(date: Date) -> number\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#getmonth\",\"returnType\":\"number\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to get Month from (optional - current date is used if omitted)\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to get Month from (optional - current date is used if omitted)\",\"children\":[]}],\"functionName\":\"getMonth\",\"snippetContent\":\"getMonth(${1:date});\"},\"getSecond\":{\"!type\":\"fn(date: Date) -> number\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#getsecond\",\"returnType\":\"number\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to get hour from (optional - current date is used if omitted)\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to get hour from (optional - current date is used if omitted)\",\"children\":[]}],\"functionName\":\"getSecond\",\"snippetContent\":\"getSecond(${1:date});\"},\"getWeek\":{\"!type\":\"fn(date: Date)\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#getweek\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to get week from (optional - current date is used if omitted)\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to get week from (optional - current date is used if omitted)\",\"children\":[]}],\"functionName\":\"getWeek\",\"snippetContent\":\"getWeek(${1:date});\"},\"getYear\":{\"!type\":\"fn(date: Date) -> number\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#getyear\",\"returnType\":\"number\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to get year from (optional - current date is used if omitted)\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to get year from (optional - current date is used if omitted)\",\"children\":[]}],\"functionName\":\"getYear\",\"snippetContent\":\"getYear(${1:date});\"},\"intToTime\":{\"!type\":\"fn(time: Number)\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#inttotime\",\"parameterSignature\":[{\"type\":\"Number\",\"name\":\"time\",\"description\":\"Number of seconds\"}],\"parameterStructure\":[{\"type\":\"Number\",\"name\":\"time\",\"description\":\"Number of seconds\",\"children\":[]}],\"functionName\":\"intToTime\",\"snippetContent\":\"intToTime(${1:time});\"},\"newDate\":{\"!type\":\"fn(date: Date, timezone: string)\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#newdate\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date(optional - current date is used if omitted)\"},{\"type\":\"String\",\"name\":\"timezone\",\"description\":\"String timezone (optional - current timezone is used if omitted)\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date(optional - current date is used if omitted)\",\"children\":[]},{\"type\":\"String\",\"name\":\"timezone\",\"description\":\"String timezone (optional - current timezone is used if omitted)\",\"children\":[]}],\"functionName\":\"newDate\",\"snippetContent\":\"newDate(${1:date}, ${2:timezone});\"},\"parse\":{\"!type\":\"fn(str: Date, pattern: string) -> Date\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#parse\",\"returnType\":\"Date\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"str\",\"description\":\"Date-string\"},{\"type\":\"String\",\"name\":\"pattern\",\"description\":\"Dateformat pattern (e.g. \\\"yyyy-MM-dd\\\")\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"str\",\"description\":\"Date-string\",\"children\":[]},{\"type\":\"String\",\"name\":\"pattern\",\"description\":\"Dateformat pattern (e.g. \\\"yyyy-MM-dd\\\")\",\"children\":[]}],\"functionName\":\"parse\",\"snippetContent\":\"parse(${1:str}, ${2:pattern});\"},\"setDayInMonth\":{\"!type\":\"fn(date: Date, day: Number) -> number\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#setdayinmonth\",\"returnType\":\"number\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to use as base when setting the day of the month (optional - current date is used if omitted)\"},{\"type\":\"Number\",\"name\":\"day\",\"description\":\"day of month to set\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to use as base when setting the day of the month (optional - current date is used if omitted)\",\"children\":[]},{\"type\":\"Number\",\"name\":\"day\",\"description\":\"day of month to set\",\"children\":[]}],\"functionName\":\"setDayInMonth\",\"snippetContent\":\"setDayInMonth(${1:date}, ${2:day});\"},\"setHour\":{\"!type\":\"fn(date: Date, hour: Number) -> number\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#sethour\",\"returnType\":\"number\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to use as base when setting the hour of the day (optional - current date is used if omitted)\"},{\"type\":\"Number\",\"name\":\"hour\",\"description\":\"hour to set\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to use as base when setting the hour of the day (optional - current date is used if omitted)\",\"children\":[]},{\"type\":\"Number\",\"name\":\"hour\",\"description\":\"hour to set\",\"children\":[]}],\"functionName\":\"setHour\",\"snippetContent\":\"setHour(${1:date}, ${2:hour});\"},\"setMinute\":{\"!type\":\"fn(date: Date, minute: Number) -> number\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#setminute\",\"returnType\":\"number\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to use as base when setting the minute of the hour (optional - current date is used if omitted)\"},{\"type\":\"Number\",\"name\":\"minute\",\"description\":\"minutes to set\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to use as base when setting the minute of the hour (optional - current date is used if omitted)\",\"children\":[]},{\"type\":\"Number\",\"name\":\"minute\",\"description\":\"minutes to set\",\"children\":[]}],\"functionName\":\"setMinute\",\"snippetContent\":\"setMinute(${1:date}, ${2:minute});\"},\"setMonth\":{\"!type\":\"fn(date: Date, month: Number) -> number\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#setmonth\",\"returnType\":\"number\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to use as base when setting the month (optional - current date is used if omitted)\"},{\"type\":\"Number\",\"name\":\"month\",\"description\":\"month to set\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to use as base when setting the month (optional - current date is used if omitted)\",\"children\":[]},{\"type\":\"Number\",\"name\":\"month\",\"description\":\"month to set\",\"children\":[]}],\"functionName\":\"setMonth\",\"snippetContent\":\"setMonth(${1:date}, ${2:month});\"},\"setSecond\":{\"!type\":\"fn(date: Date, second: Number) -> number\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#setsecond\",\"returnType\":\"number\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to use as base when setting the seconds (optional - current date is used if omitted)\"},{\"type\":\"Number\",\"name\":\"second\",\"description\":\"seconds to set\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to use as base when setting the seconds (optional - current date is used if omitted)\",\"children\":[]},{\"type\":\"Number\",\"name\":\"second\",\"description\":\"seconds to set\",\"children\":[]}],\"functionName\":\"setSecond\",\"snippetContent\":\"setSecond(${1:date}, ${2:second});\"},\"setYear\":{\"!type\":\"fn(date: Date, year: Number) -> number\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#setyear\",\"returnType\":\"number\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to use as base when setting the year (optional - current date is used if omitted)\"},{\"type\":\"Number\",\"name\":\"year\",\"description\":\"year to set\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to use as base when setting the year (optional - current date is used if omitted)\",\"children\":[]},{\"type\":\"Number\",\"name\":\"year\",\"description\":\"year to set\",\"children\":[]}],\"functionName\":\"setYear\",\"snippetContent\":\"setYear(${1:date}, ${2:year});\"},\"timeToInt\":{\"!type\":\"fn(time: string)\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#timetoint\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"time\",\"description\":\"Time string to parse to seconds\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"time\",\"description\":\"Time string to parse to seconds\",\"children\":[]}],\"functionName\":\"timeToInt\",\"snippetContent\":\"timeToInt(${1:time});\"},\"toMidnight\":{\"!type\":\"fn(date: Date)\",\"!doc\":\"@memberof DateFunctions\",\"!url\":\"https://docs.appivo.com/apis/datefunctions/#tomidnight\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to get midnight for (optional - if omitted the current date is used)\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"Date to get midnight for (optional - if omitted the current date is used)\",\"children\":[]}],\"functionName\":\"toMidnight\",\"snippetContent\":\"toMidnight(${1:date});\"}},\"Form\":{\"!name\":\"Form\",\"createRecord\":{\"!type\":\"fn(opts: object) -> Record\",\"!doc\":\"Creates a record using the form's data.\",\"!url\":\"https://docs.appivo.com/apis/form/#createrecord\",\"returnType\":\"Record\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Configuration object.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Configuration object.\",\"children\":[{\"type\":\"Boolean\",\"name\":\"submit\",\"description\":\"\"},{\"type\":\"Boolean\",\"name\":\"keepIds\",\"description\":\"\"},{\"type\":\"Boolean\",\"name\":\"full\",\"description\":\"If true, any child forms' data are used to create related records.\"},{\"type\":\"Boolean\",\"name\":\"nodelete\",\"description\":\"opts.nodelete\"}]}],\"functionName\":\"createRecord\",\"snippetContent\":\"createRecord({\\n\\t'submit' : ${1:false}, \\n\\t'keepIds' : ${2:false}, \\n\\t'full' : ${3:false}, \\n\\t'nodelete' : ${4:false}\\n});\"},\"disable\":{\"!type\":\"fn()\",\"!doc\":\"Disable this form. This disables all widgets connected to this form.\",\"!url\":\"https://docs.appivo.com/apis/form/#disable\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"disable\",\"snippetContent\":\"disable();\"},\"enable\":{\"!type\":\"fn()\",\"!doc\":\"Enable this form. This enables all widgets connected to this form.\",\"!url\":\"https://docs.appivo.com/apis/form/#enable\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"enable\",\"snippetContent\":\"enable();\"},\"getChildren\":{\"!type\":\"fn() -> Array | *[]\",\"!doc\":\"Gets the child forms of this form (if any)\",\"!url\":\"https://docs.appivo.com/apis/form/#getchildren\",\"returnType\":\"Array | *[]\",\"returnDescription\":\"\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getChildren\",\"snippetContent\":\"getChildren();\"},\"getId\":{\"!type\":\"fn() -> string\",\"!doc\":\"Gets the ID of this form\",\"!url\":\"https://docs.appivo.com/apis/form/#getid\",\"returnType\":\"String\",\"returnDescription\":\"ID of this form\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getModel\":{\"!type\":\"fn() -> Model\",\"!doc\":\"Returns the model used by the form.\",\"!url\":\"https://docs.appivo.com/apis/form/#getmodel\",\"returnType\":\"Model\",\"returnDescription\":\"The form's model\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getModel\",\"snippetContent\":\"getModel();\"},\"getParent\":{\"!type\":\"fn() -> Form\",\"!doc\":\"Gets the parent of this form\",\"!url\":\"https://docs.appivo.com/apis/form/#getparent\",\"returnType\":\"Form\",\"returnDescription\":\"\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getParent\",\"snippetContent\":\"getParent();\"},\"getRecordId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Gets the ID of the Record held by this form\",\"!url\":\"https://docs.appivo.com/apis/form/#getrecordid\",\"returnType\":\"ID\",\"returnDescription\":\"ID of the Record in the form\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getRecordId\",\"snippetContent\":\"getRecordId();\"},\"getValue\":{\"!type\":\"fn(name: string, original: bool)\",\"!doc\":\"Get a value from this form\",\"!url\":\"https://docs.appivo.com/apis/form/#getvalue\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"Name of field to get\"},{\"type\":\"Boolean\",\"name\":\"original\",\"description\":\"If true it will get the original value of this field\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"Name of field to get\",\"children\":[]},{\"type\":\"Boolean\",\"name\":\"original\",\"description\":\"If true it will get the original value of this field\",\"children\":[]}],\"functionName\":\"getValue\",\"snippetContent\":\"getValue(${1:name}, ${2:original});\"},\"hasChanged\":{\"!type\":\"fn(name: string)\",\"!doc\":\"Check if a value has changed in this form since it was loaded\",\"!url\":\"https://docs.appivo.com/apis/form/#haschanged\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"Name of field to check\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"Name of field to check\",\"children\":[]}],\"functionName\":\"hasChanged\",\"snippetContent\":\"hasChanged(${1:name});\"},\"hasPrivilege\":{\"!type\":\"fn(privilege: string) -> bool\",\"!doc\":\"Checks whether the user has a certain privilege on the record held by this form (note: for this to be 100% accurate the form must be configured to laod privileges, otherwise only blanket privileges are considered)\",\"!url\":\"https://docs.appivo.com/apis/form/#hasprivilege\",\"returnType\":\"Boolean\",\"returnDescription\":\"true if the user has the requested privilege\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"privilege\",\"description\":\"Name of privilege to check for\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"privilege\",\"description\":\"Name of privilege to check for\",\"children\":[]}],\"functionName\":\"hasPrivilege\",\"snippetContent\":\"hasPrivilege(${1:privilege});\"},\"isChild\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Check whether this is a child-form\",\"!url\":\"https://docs.appivo.com/apis/form/#ischild\",\"returnType\":\"Boolean\",\"returnDescription\":\"form\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isChild\",\"snippetContent\":\"isChild();\"},\"isCreate\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Check whether this form is holding a new record or not\",\"!url\":\"https://docs.appivo.com/apis/form/#iscreate\",\"returnType\":\"Boolean\",\"returnDescription\":\"true if the form represents a new record\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isCreate\",\"snippetContent\":\"isCreate();\"},\"isEdit\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Check whether this form is holding an existing record or not\",\"!url\":\"https://docs.appivo.com/apis/form/#isedit\",\"returnType\":\"Boolean\",\"returnDescription\":\"true if the form represents an existing record\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEdit\",\"snippetContent\":\"isEdit();\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Check if this form is enabled or not\",\"!url\":\"https://docs.appivo.com/apis/form/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"true if this form is enabled\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isTemporary\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Check whether this is a temporary form (i.e. a dynamically created one)\",\"!url\":\"https://docs.appivo.com/apis/form/#istemporary\",\"returnType\":\"Boolean\",\"returnDescription\":\"true if the form is temporary\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isTemporary\",\"snippetContent\":\"isTemporary();\"},\"isTransactional\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Check whether this form is in transactional mode\",\"!url\":\"https://docs.appivo.com/apis/form/#istransactional\",\"returnType\":\"Boolean\",\"returnDescription\":\"true if the form is in transactional mode\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isTransactional\",\"snippetContent\":\"isTransactional();\"},\"load\":{\"!type\":\"fn(id: ID, callback: Function)\",\"!doc\":\"Loads the record with the specified id into the form.\",\"!url\":\"https://docs.appivo.com/apis/form/#load\",\"parameterSignature\":[{\"type\":\"ID\",\"name\":\"id\",\"description\":\"The ID of the record to load.\"},{\"type\":\"Function\",\"name\":\"callback\",\"description\":\"Callback when the load is completed.\"}],\"parameterStructure\":[{\"type\":\"ID\",\"name\":\"id\",\"description\":\"The ID of the record to load.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"callback\",\"description\":\"Callback when the load is completed.\",\"children\":[]}],\"functionName\":\"load\",\"snippetContent\":\"load(${1:id}, ${2:function(){ /* body... */ }});\"},\"loadRelation\":{\"!type\":\"fn(name: string, add: bool, labels: bool) -> [Array]\",\"!doc\":\"Loads (or reloads) a relation of the record held by this form.\",\"!url\":\"https://docs.appivo.com/apis/form/#loadrelation\",\"returnType\":\"Promise<Array>\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"Name of relation to load\"},{\"type\":\"Boolean\",\"name\":\"add\",\"description\":\"Pass true to update the contents of the form\"},{\"type\":\"Boolean\",\"name\":\"labels\",\"description\":\"Pass true to load labels of the related records\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"Name of relation to load\",\"children\":[]},{\"type\":\"Boolean\",\"name\":\"add\",\"description\":\"Pass true to update the contents of the form\",\"children\":[]},{\"type\":\"Boolean\",\"name\":\"labels\",\"description\":\"Pass true to load labels of the related records\",\"children\":[]}],\"functionName\":\"loadRelation\",\"snippetContent\":\"loadRelation(${1:name}, ${2:add}, ${3:labels});\"},\"reset\":{\"!type\":\"fn(focused: bool)\",\"!doc\":\"Reset this form back to its default values\",\"!url\":\"https://docs.appivo.com/apis/form/#reset\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"focused\",\"description\":\"If set to true the form will focus the first input-field\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"focused\",\"description\":\"If set to true the form will focus the first input-field\",\"children\":[]}],\"functionName\":\"reset\",\"snippetContent\":\"reset(${1:focused});\"},\"setData\":{\"!type\":\"fn(item: Record)\",\"!doc\":\"Sets the form's data to the specified record.\",\"!url\":\"https://docs.appivo.com/apis/form/#setdata\",\"parameterSignature\":[{\"type\":\"Record\",\"name\":\"item\",\"description\":\"The record to use as the form's data.\"}],\"parameterStructure\":[{\"type\":\"Record\",\"name\":\"item\",\"description\":\"The record to use as the form's data.\",\"children\":[]}],\"functionName\":\"setData\",\"snippetContent\":\"setData(${1:item});\"},\"setOriginalValue\":{\"!type\":\"fn(name: string, value: string)\",\"!doc\":\"Change the original (loaded) value of a field in this form\",\"!url\":\"https://docs.appivo.com/apis/form/#setoriginalvalue\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"Name of field to set\"},{\"type\":\"String\",\"name\":\"value\",\"description\":\"Value to set\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"Name of field to set\",\"children\":[]},{\"type\":\"String\",\"name\":\"value\",\"description\":\"Value to set\",\"children\":[]}],\"functionName\":\"setOriginalValue\",\"snippetContent\":\"setOriginalValue(${1:name}, ${2:value});\"},\"setTransactional\":{\"!type\":\"fn(transactional: bool)\",\"!doc\":\"Enables/disables transactional mode\",\"!url\":\"https://docs.appivo.com/apis/form/#settransactional\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"transactional\",\"description\":\"True if the form should be transactional\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"transactional\",\"description\":\"True if the form should be transactional\",\"children\":[]}],\"functionName\":\"setTransactional\",\"snippetContent\":\"setTransactional(${1:transactional});\"},\"setValue\":{\"!type\":\"fn(name: string, value: string)\",\"!doc\":\"Set a value on this form\",\"!url\":\"https://docs.appivo.com/apis/form/#setvalue\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"Name of field to set\"},{\"type\":\"String\",\"name\":\"value\",\"description\":\"Value to set\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"Name of field to set\",\"children\":[]},{\"type\":\"String\",\"name\":\"value\",\"description\":\"Value to set\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:name}, ${2:value});\"},\"submit\":{\"!type\":\"fn(options: object) -> bool\",\"!doc\":\"Submits the form.\",\"!url\":\"https://docs.appivo.com/apis/form/#submit\",\"returnType\":\"Boolean\",\"returnDescription\":\"A boolean indicating whether the form was actually submitted to the server or not.\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"options\",\"description\":\"Configuration object.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"options\",\"description\":\"Configuration object.\",\"children\":[{\"type\":\"String\",\"name\":\"successMessage\",\"description\":\"Message to display on success.\"},{\"type\":\"String\",\"name\":\"errorMessage\",\"description\":\"Message to display on error.\"},{\"type\":\"Array\",\"name\":\"exclude\",\"description\":\"List of attributes and/or relations to exclude from the submission\"},{\"type\":\"Object\",\"name\":\"metadata\",\"description\":\"Metadata to include as part of the submitted record\"},{\"type\":\"Boolean\",\"name\":\"full\",\"description\":\"If included, the submission will also include child forms.\"},{\"type\":\"Boolean\",\"name\":\"preventReset\",\"description\":\"Instead of resetting, the form will be loaded with the new data after submission.\"},{\"type\":\"Boolean\",\"name\":\"suppressNotifications\",\"description\":\"Set to true to suppress any notifications displayed as a result of this submission.\"},{\"type\":\"Object\",\"name\":\"override\",\"description\":\"Object with attribute-values to override the form contents with upon submission\"}]}],\"functionName\":\"submit\",\"snippetContent\":\"submit({\\n\\t'successMessage' : '${1:string}', \\n\\t'errorMessage' : '${2:string}', \\n\\t'exclude' : ${3:Array}, \\n\\t'metadata' :{}, \\n\\t'full' : ${4:false}, \\n\\t'preventReset' : ${5:false}, \\n\\t'suppressNotifications' : ${6:false}, \\n\\t'override' :{}\\n});\"},\"validate\":{\"!type\":\"fn(options: object) -> bool\",\"!doc\":\"Validates the form's data.\",\"!url\":\"https://docs.appivo.com/apis/form/#validate\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if the form's data was valid, otherwise false.\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"options\",\"description\":\"Configuration object.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"options\",\"description\":\"Configuration object.\",\"children\":[{\"type\":\"Boolean\",\"name\":\"alert\",\"description\":\"If included an alert will be displayed if errors are found\"}]}],\"functionName\":\"validate\",\"snippetContent\":\"validate(${2:{\\n\\t'alert' : ${1:false}}\\n});\"}},\"GeneralFunctions\":{\"!name\":\"GeneralFunctions\",\"clone\":{\"!type\":\"fn(object: object) -> obj\",\"!doc\":\"@memberof GeneralFunctions\",\"!url\":\"https://docs.appivo.com/apis/generalfunctions/#clone\",\"returnType\":\"Object\",\"returnDescription\":\"clone\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"object\",\"description\":\"object Object to clone\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"object\",\"description\":\"object Object to clone\",\"children\":[]}],\"functionName\":\"clone\",\"snippetContent\":\"clone(${1:{}});\"}},\"NumericFunctions\":{\"!name\":\"NumericFunctions\",\"formatCurrency\":{\"!type\":\"fn(numval: Number, options: object) -> string\",\"!doc\":\"@param {Number} numval Number to format\",\"!url\":\"https://docs.appivo.com/apis/numericfunctions/#formatcurrency\",\"returnType\":\"String\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Number\",\"name\":\"numval\",\"description\":\"numval Number to format\"},{\"type\":\"Object\",\"name\":\"options\",\"description\":\"options Formatting options\"}],\"parameterStructure\":[{\"type\":\"Number\",\"name\":\"numval\",\"description\":\"numval Number to format\",\"children\":[]},{\"type\":\"Object\",\"name\":\"options\",\"description\":\"options Formatting options\",\"children\":[{\"type\":\"Integer\",\"name\":\"decimals\",\"description\":\"options.decimals Number of decimals to use. Defaults to 2.\"},{\"type\":\"String\",\"name\":\"currency\",\"description\":\"options.currency Currency to use (e.g. USD, EUR etc). If omitted the default currency for the current locale is used.\"}]}],\"functionName\":\"formatCurrency\",\"snippetContent\":\"formatCurrency(${1:numval}, {\\n\\t'decimals' : ${2:Integer}, \\n\\t'currency' : '${3:string}'\\n});\"},\"formatFloat\":{\"!type\":\"fn()\",\"!doc\":\"@memberof NumericFunctions\",\"!url\":\"https://docs.appivo.com/apis/numericfunctions/#formatfloat\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"formatFloat\",\"snippetContent\":\"formatFloat();\"},\"formatNumber\":{\"!type\":\"fn()\",\"!doc\":\"@memberof NumericFunctions\",\"!url\":\"https://docs.appivo.com/apis/numericfunctions/#formatnumber\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"formatNumber\",\"snippetContent\":\"formatNumber();\"},\"round\":{\"!type\":\"fn()\",\"!doc\":\"@memberof NumericFunctions\",\"!url\":\"https://docs.appivo.com/apis/numericfunctions/#round\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"round\",\"snippetContent\":\"round();\"}},\"QueryBuilder\":{\"!name\":\"QueryBuilder\",\"clearGroupBy\":{\"!type\":\"fn()\",\"!doc\":\"Clears the group by-clause\",\"!url\":\"https://docs.appivo.com/apis/querybuilder/#cleargroupby\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"clearGroupBy\",\"snippetContent\":\"clearGroupBy();\"},\"clearHaving\":{\"!type\":\"fn()\",\"!doc\":\"Clears the having-clause\",\"!url\":\"https://docs.appivo.com/apis/querybuilder/#clearhaving\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"clearHaving\",\"snippetContent\":\"clearHaving();\"},\"clearOrderBy\":{\"!type\":\"fn()\",\"!doc\":\"Clears the order by-clause\",\"!url\":\"https://docs.appivo.com/apis/querybuilder/#clearorderby\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"clearOrderBy\",\"snippetContent\":\"clearOrderBy();\"},\"clearSelect\":{\"!type\":\"fn()\",\"!doc\":\"Clears the select-clause\",\"!url\":\"https://docs.appivo.com/apis/querybuilder/#clearselect\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"clearSelect\",\"snippetContent\":\"clearSelect();\"},\"clearWhere\":{\"!type\":\"fn()\",\"!doc\":\"Clear the where-clause\",\"!url\":\"https://docs.appivo.com/apis/querybuilder/#clearwhere\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"clearWhere\",\"snippetContent\":\"clearWhere();\"},\"execute\":{\"!type\":\"fn()\",\"!doc\":\"Executes the query\",\"!url\":\"https://docs.appivo.com/apis/querybuilder/#execute\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"execute\",\"snippetContent\":\"execute();\"},\"expression\":{\"!type\":\"fn(lhs: object, Operator: string, rhs: object) -> Criteria\",\"!doc\":\"Create an expression\",\"!url\":\"https://docs.appivo.com/apis/querybuilder/#expression\",\"returnType\":\"Criteria\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"lhs\",\"description\":\"lhs Lefthand side of the expression\"},{\"type\":\"String\",\"name\":\"Operator\",\"description\":\"Operator\"},{\"type\":\"Object\",\"name\":\"rhs\",\"description\":\"rhs Righthand side of the expression\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"lhs\",\"description\":\"lhs Lefthand side of the expression\",\"children\":[]},{\"type\":\"String\",\"name\":\"Operator\",\"description\":\"Operator\",\"children\":[]},{\"type\":\"Object\",\"name\":\"rhs\",\"description\":\"rhs Righthand side of the expression\",\"children\":[]}],\"functionName\":\"expression\",\"snippetContent\":\"expression(${1:{}}, ${2:Operator}, ${3:{}});\"},\"from\":{\"!type\":\"fn(model: string)\",\"!doc\":\"Sets the model to query from\",\"!url\":\"https://docs.appivo.com/apis/querybuilder/#from\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"model\",\"description\":\"model Name of model to query from\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"model\",\"description\":\"model Name of model to query from\",\"children\":[]}],\"functionName\":\"from\",\"snippetContent\":\"from(\\\"${1:String/Model-ID}\\\");\"},\"func\":{\"!type\":\"fn(name: string, args: []) -> obj\",\"!doc\":\"Creates a function-invocation\",\"!url\":\"https://docs.appivo.com/apis/querybuilder/#func\",\"returnType\":\"Object\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"name Name of function to invoke\"},{\"type\":\"Array\",\"name\":\"args\",\"description\":\"args Array of arguments to pass to the function\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"name Name of function to invoke\",\"children\":[]},{\"type\":\"Array\",\"name\":\"args\",\"description\":\"args Array of arguments to pass to the function\",\"children\":[]}],\"functionName\":\"func\",\"snippetContent\":\"func(${1:name}, ${2:args});\"},\"getQueryHandle\":{\"!type\":\"fn() -> QueryHandle\",\"!doc\":\"Gets the QueryHandle for this QueryBuilder\",\"!url\":\"https://docs.appivo.com/apis/querybuilder/#getqueryhandle\",\"returnType\":\"QueryHandle\",\"returnDescription\":\"\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getQueryHandle\",\"snippetContent\":\"getQueryHandle();\"},\"groupBy\":{\"!type\":\"fn(path: string)\",\"!doc\":\"Adds an attribute to group the result by\",\"!url\":\"https://docs.appivo.com/apis/querybuilder/#groupby\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"path\",\"description\":\"path Path of attribute to group by\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"path\",\"description\":\"path Path of attribute to group by\",\"children\":[]}],\"functionName\":\"groupBy\",\"snippetContent\":\"groupBy(${1:path});\"},\"having\":{\"!type\":\"fn(having: object)\",\"!doc\":\"Sets the having-clause expression\",\"!url\":\"https://docs.appivo.com/apis/querybuilder/#having\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"having\",\"description\":\"having Expression\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"having\",\"description\":\"having Expression\",\"children\":[]}],\"functionName\":\"having\",\"snippetContent\":\"having(${1:{}});\"},\"orderBy\":{\"!type\":\"fn(path: string, desc: bool)\",\"!doc\":\"Adds an attribute to order the result by\",\"!url\":\"https://docs.appivo.com/apis/querybuilder/#orderby\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"path\",\"description\":\"path Path of attribute to order by\"},{\"type\":\"Boolean\",\"name\":\"desc\",\"description\":\"desc Sort the result descending or not\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"path\",\"description\":\"path Path of attribute to order by\",\"children\":[]},{\"type\":\"Boolean\",\"name\":\"desc\",\"description\":\"desc Sort the result descending or not\",\"children\":[]}],\"functionName\":\"orderBy\",\"snippetContent\":\"orderBy(${1:path}, ${2:desc});\"},\"reference\":{\"!type\":\"fn(path: string) -> obj\",\"!doc\":\"Creates a reference from a path\",\"!url\":\"https://docs.appivo.com/apis/querybuilder/#reference\",\"returnType\":\"Object\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"path\",\"description\":\"path Path of reference\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"path\",\"description\":\"path Path of reference\",\"children\":[]}],\"functionName\":\"reference\",\"snippetContent\":\"reference(${1:path});\"},\"select\":{\"!type\":\"fn(select: string, alias: string)\",\"!doc\":\"Selects an attribute\",\"!url\":\"https://docs.appivo.com/apis/querybuilder/#select\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"select\",\"description\":\"select Path of attribute to select\"},{\"type\":\"String\",\"name\":\"alias\",\"description\":\"alias Alias of selected attribute\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"select\",\"description\":\"select Path of attribute to select\",\"children\":[]},{\"type\":\"String\",\"name\":\"alias\",\"description\":\"alias Alias of selected attribute\",\"children\":[]}],\"functionName\":\"select\",\"snippetContent\":\"select(${1:select}, ${2:alias});\"},\"value\":{\"!type\":\"fn(value: object) -> obj\",\"!doc\":\"Creates a value\",\"!url\":\"https://docs.appivo.com/apis/querybuilder/#value\",\"returnType\":\"Object\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"value Value to be wrapped\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"value Value to be wrapped\",\"children\":[]}],\"functionName\":\"value\",\"snippetContent\":\"value(${1:{}});\"},\"where\":{\"!type\":\"fn(where: object)\",\"!doc\":\"Sets the where-clause expression\",\"!url\":\"https://docs.appivo.com/apis/querybuilder/#where\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"where\",\"description\":\"where Expression to filter on\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"where\",\"description\":\"where Expression to filter on\",\"children\":[]}],\"functionName\":\"where\",\"snippetContent\":\"where(${1:{}});\"}},\"StringFunctions\":{\"!name\":\"StringFunctions\",\"createFuzzySet\":{\"!type\":\"fn(options: object) -> obj\",\"!doc\":\"Creates a fuzzy set\",\"!url\":\"https://docs.appivo.com/apis/stringfunctions/#createfuzzyset\",\"returnType\":\"Object\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"options\",\"description\":\"options\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"options\",\"description\":\"options\",\"children\":[]}],\"functionName\":\"createFuzzySet\",\"snippetContent\":\"createFuzzySet(${1:{}});\"},\"levenshtein\":{\"!type\":\"fn(str1: string, str2: string) -> number\",\"!doc\":\"Computes the levenshtein distance between two strings\",\"!url\":\"https://docs.appivo.com/apis/stringfunctions/#levenshtein\",\"returnType\":\"number\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"str1\",\"description\":\"First string\"},{\"type\":\"String\",\"name\":\"str2\",\"description\":\"Second string\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"str1\",\"description\":\"First string\",\"children\":[]},{\"type\":\"String\",\"name\":\"str2\",\"description\":\"Second string\",\"children\":[]}],\"functionName\":\"levenshtein\",\"snippetContent\":\"levenshtein(${1:str1}, ${2:str2});\"}},\"Transaction\":{\"!name\":\"Transaction\",\"addOperation\":{\"!type\":\"fn(op: object)\",\"!doc\":\"Adds an operation to this transaction\",\"!url\":\"https://docs.appivo.com/apis/transaction/#addoperation\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"op\",\"description\":\"op Operation\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"op\",\"description\":\"op Operation\",\"children\":[{\"type\":\"Oject\",\"name\":\"record\",\"description\":\"op.record Record\"},{\"type\":\"String\",\"name\":\"op\",\"description\":\"op.op Operation, must be one of ADD, DEL, UPD (add, delete, update).\"},{\"type\":\"String\",\"name\":\"model\",\"description\":\"object is passed as the record\"}]}],\"functionName\":\"addOperation\",\"snippetContent\":\"addOperation({\\n\\t'record' : ${1:Oject/Record}, \\n\\t'op' : '${2:string}', \\n\\t'model' : '${3:string}'\\n});\"},\"commit\":{\"!type\":\"fn(opts: object) -> Promise\",\"!doc\":\"Commits the transaction\",\"!url\":\"https://docs.appivo.com/apis/transaction/#commit\",\"returnType\":\"Promise\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"opts Options\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"opts Options\",\"children\":[]}],\"functionName\":\"commit\",\"snippetContent\":\"commit(${1:{}});\"}},\"View\":{\"!name\":\"BaseView\",\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"AudioPlayer\":{\"!name\":\"AudioPlayer\"},\"Alert\":{\"!name\":\"Alert\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"AutodeskViewer\":{\"!name\":\"AutodeskViewer\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"BaseView\":{\"!name\":\"BaseView\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"BaseWidget\":{\"!name\":\"BaseWidget\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"Button\":{\"!name\":\"Button\",\"setLabel\":{\"!type\":\"fn(Label: string)\",\"!doc\":\"Sets the label on the button.\",\"!url\":\"https://docs.appivo.com/apis/button/#setlabel\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"Label\",\"description\":\"Text or HTML to set as the label on this button.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"Label\",\"description\":\"Text or HTML to set as the label on this button.\",\"children\":[]}],\"functionName\":\"setLabel\",\"snippetContent\":\"setLabel(${1:Label});\"},\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"ButtonBar\":{\"!name\":\"ButtonBar\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"Label\":{\"!name\":\"Label\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setLabel\":{\"!type\":\"fn(Label: string)\",\"!doc\":\"Sets the text displayed by the label.\",\"!url\":\"https://docs.appivo.com/apis/label/#setlabel\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"Label\",\"description\":\"The new text.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"Label\",\"description\":\"The new text.\",\"children\":[]}],\"functionName\":\"setLabel\",\"snippetContent\":\"setLabel(${1:Label});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"Calendar\":{\"!name\":\"Calendar\",\"getActiveDate\":{\"!type\":\"fn() -> Date\",\"!doc\":\"Returns the currently selected date.\",\"!url\":\"https://docs.appivo.com/apis/calendar/#getactivedate\",\"returnType\":\"Date\",\"returnDescription\":\"The currently selected date.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getActiveDate\",\"snippetContent\":\"getActiveDate();\"},\"gotoDate\":{\"!type\":\"fn(date: Date)\",\"!doc\":\"Selects the specified date in the calendar.\",\"!url\":\"https://docs.appivo.com/apis/calendar/#gotodate\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"The date to select.\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"The date to select.\",\"children\":[]}],\"functionName\":\"gotoDate\",\"snippetContent\":\"gotoDate(${1:date});\"},\"refresh\":{\"!type\":\"fn()\",\"!doc\":\"Refreshes the calendar\",\"!url\":\"https://docs.appivo.com/apis/calendar/#refresh\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"refresh\",\"snippetContent\":\"refresh();\"},\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"Canvas\":{\"!name\":\"Canvas\",\"getAPI\":{\"!type\":\"fn()\",\"!doc\":\"Returns the FabricJS API. See {@link http://fabricjs.com/docs/|FabricJS Documentation}\",\"!url\":\"https://docs.appivo.com/apis/canvas/#getapi\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getAPI\",\"snippetContent\":\"getAPI();\"},\"getCanvas\":{\"!type\":\"fn()\",\"!doc\":\"Returns the FabricJS Canvas-object related to this widget. See {@link http://fabricjs.com/docs/fabric.Canvas.html|FabricjJS Canvas API}\",\"!url\":\"https://docs.appivo.com/apis/canvas/#getcanvas\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getCanvas\",\"snippetContent\":\"getCanvas();\"},\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"Carousel\":{\"!name\":\"Carousel\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"CarouselPanel\":{\"!name\":\"CarouselPanel\",\"goto\":{\"!type\":\"fn(paneId: string)\",\"!doc\":\"Sets the currently visible pane.\",\"!url\":\"https://docs.appivo.com/apis/carouselpanel/#goto\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"paneId\",\"description\":\"The id of the pane to made visible.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"paneId\",\"description\":\"The id of the pane to made visible.\",\"children\":[]}],\"functionName\":\"goto\",\"snippetContent\":\"goto(${1:paneId});\"},\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"Chart\":{\"!name\":\"Chart\",\"getDataPointIndex\":{\"!type\":\"fn(event: MouseEvent) -> Number|undefined\",\"!doc\":\"Returns the datapoint index of the point clicked on the chart.\",\"!url\":\"https://docs.appivo.com/apis/chart/#getdatapointindex\",\"returnType\":\"Number|undefined\",\"returnDescription\":\"The index of the clicked data point, or undefined if no data point was clicked.\",\"parameterSignature\":[{\"type\":\"MouseEvent\",\"name\":\"event\",\"description\":\"The mouse event object generated when clicking on the chart.\"}],\"parameterStructure\":[{\"type\":\"MouseEvent\",\"name\":\"event\",\"description\":\"The mouse event object generated when clicking on the chart.\",\"children\":[]}],\"functionName\":\"getDataPointIndex\",\"snippetContent\":\"getDataPointIndex(${1:event});\"},\"removeAnnotations\":{\"!type\":\"fn(id: string) -> void\",\"!doc\":\"Removes one or more annotations from the chart.\",\"!url\":\"https://docs.appivo.com/apis/chart/#removeannotations\",\"returnType\":\"void\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"id\",\"description\":\"The id or array of ids of the annotations to remove.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"id\",\"description\":\"The id or array of ids of the annotations to remove.\",\"children\":[]}],\"functionName\":\"removeAnnotations\",\"snippetContent\":\"removeAnnotations(${1:id});\"},\"setAnnotations\":{\"!type\":\"fn(annotations: object, annotations[id]: object, [annotations[id].backgroundColor]: object, [annotations[id].borderColor]: object, [annotations[id].borderWidth]: Number, [annotations[id].label]: string, [annotations[id].label.backgroundColor]: object, [annotations[id].label.font]: object, [annotations[id].label.color]: string) -> void\",\"!doc\":\"Adds or updates annotations on the chart.\",\"!url\":\"https://docs.appivo.com/apis/chart/#setannotations\",\"returnType\":\"void\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"annotations\",\"description\":\"Object with annotations keyed by their ids.\"},{\"type\":\"Object\",\"name\":\"annotations[id]\",\"description\":\"Configuration for an annotation with the given id.\"},{\"type\":\"Object\",\"name\":\"[annotations[id].backgroundColor]\",\"description\":\"Background color for box annotations.\"},{\"type\":\"Object\",\"name\":\"[annotations[id].borderColor]\",\"description\":\"Border color for box and line annotations.\"},{\"type\":\"Number\",\"name\":\"[annotations[id].borderWidth]\",\"description\":\"Border width for box and line annotations.\"},{\"type\":\"String\",\"name\":\"[annotations[id].label]\",\"description\":\"Label text for the annotation.\"},{\"type\":\"Object\",\"name\":\"[annotations[id].label.backgroundColor]\",\"description\":\"Background color for the label.\"},{\"type\":\"Object\",\"name\":\"[annotations[id].label.font]\",\"description\":\"Font settings for the label.\"},{\"type\":\"String\",\"name\":\"[annotations[id].label.color]\",\"description\":\"Text color for the label.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"annotations\",\"description\":\"Object with annotations keyed by their ids.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"annotations[id]\",\"description\":\"Configuration for an annotation with the given id.\",\"children\":[{\"type\":\"String\",\"name\":\"type\",\"description\":\"Type of annotation ('line', 'box', or 'point').\"},{\"type\":\"Object\",\"name\":\"xScaleID\",\"description\":\"ID of the x-scale to use for the annotation.\"},{\"type\":\"Object\",\"name\":\"yScaleID\",\"description\":\"ID of the y-scale to use for the annotation.\"},{\"type\":\"Number\",\"name\":\"xMin\",\"description\":\"Minimum x-value for the annotation (for 'line' and 'box' types).\"},{\"type\":\"Number\",\"name\":\"xMax\",\"description\":\"Maximum x-value for the annotation (for 'line' and 'box' types).\"},{\"type\":\"Number\",\"name\":\"yMin\",\"description\":\"Minimum y-value for the annotation (for 'line' and 'box' types).\"},{\"type\":\"Number\",\"name\":\"yMax\",\"description\":\"Maximum y-value for the annotation (for 'line' and 'box' types).\"}]},{\"type\":\"Object\",\"name\":\"[annotations[id].backgroundColor]\",\"description\":\"Background color for box annotations.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"[annotations[id].borderColor]\",\"description\":\"Border color for box and line annotations.\",\"children\":[]},{\"type\":\"Number\",\"name\":\"[annotations[id].borderWidth]\",\"description\":\"Border width for box and line annotations.\",\"children\":[]},{\"type\":\"String\",\"name\":\"[annotations[id].label]\",\"description\":\"Label text for the annotation.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"[annotations[id].label.backgroundColor]\",\"description\":\"Background color for the label.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"[annotations[id].label.font]\",\"description\":\"Font settings for the label.\",\"children\":[]},{\"type\":\"String\",\"name\":\"[annotations[id].label.color]\",\"description\":\"Text color for the label.\",\"children\":[]}],\"functionName\":\"setAnnotations\",\"snippetContent\":\"setAnnotations({\\n\\t'type' : '${1:string}', \\n\\t'xScaleID' :{}, \\n\\t'yScaleID' :{}, \\n\\t'xMin' : ${2:Number|String|Object}, \\n\\t'xMax' : ${3:Number|String|Object}, \\n\\t'yMin' : ${4:Number|String|Object}, \\n\\t'yMax' : ${5:Number|String|Object}, \\n\\t'backgroundColor]' :{}, \\n\\t'borderColor]' :{}, \\n\\t'borderWidth]' : ${6:0}, \\n\\t'label]' : '${7:string}', \\n\\t'label' :{}, \\n\\t'label' :{}, \\n\\t'label' : '${8:string}'\\n}, {\\n\\t'type' : '${10:string}', \\n\\t'xScaleID' :{}, \\n\\t'yScaleID' :{}, \\n\\t'xMin' : ${11:Number|String|Object}, \\n\\t'xMax' : ${12:Number|String|Object}, \\n\\t'yMin' : ${13:Number|String|Object}, \\n\\t'yMax' : ${14:Number|String|Object}, \\n\\t'backgroundColor]' :{}, \\n\\t'borderColor]' :{}, \\n\\t'borderWidth]' : ${15:0}, \\n\\t'label]' : '${16:string}', \\n\\t'label' :{}, \\n\\t'label' :{}, \\n\\t'label' : '${17:string}'\\n});\"},\"setColors\":{\"!type\":\"fn(colors: Array<String, [colors[].backgroundColor]: string, [colors[].borderColor]: string, [colors[].pointBackgroundColor]: string, [colors[].pointBorderColor]: string, [colors[].pointHoverBackgroundColor]: string, [colors[].pointHoverBorderColor]: string) -> void\",\"!doc\":\"Sets the colors used when rendering the chart.\",\"!url\":\"https://docs.appivo.com/apis/chart/#setcolors\",\"returnType\":\"void\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Array<String\",\"name\":\"colors\",\"description\":\"Array of colors to use for the chart.\"},{\"type\":\"String\",\"name\":\"[colors[].backgroundColor]\",\"description\":\"Background color for the dataset area (e.g., 'rgba(151,187,205,0.2)').\"},{\"type\":\"String\",\"name\":\"[colors[].borderColor]\",\"description\":\"Border color for lines or point borders (e.g., 'rgba(151,187,205,1)').\"},{\"type\":\"String\",\"name\":\"[colors[].pointBackgroundColor]\",\"description\":\"Background color for points (e.g., 'rgba(151,187,205,1)').\"},{\"type\":\"String\",\"name\":\"[colors[].pointBorderColor]\",\"description\":\"Border color for points (e.g., '#fff').\"},{\"type\":\"String\",\"name\":\"[colors[].pointHoverBackgroundColor]\",\"description\":\"Background color for points when hovered (e.g., '#fff').\"},{\"type\":\"String\",\"name\":\"[colors[].pointHoverBorderColor]\",\"description\":\"Border color for points when hovered (e.g., 'rgba(151,187,205,1)').\"}],\"parameterStructure\":[{\"type\":\"Array<String\",\"name\":\"colors\",\"description\":\"Array of colors to use for the chart.\",\"children\":[]},{\"type\":\"String\",\"name\":\"[colors[].backgroundColor]\",\"description\":\"Background color for the dataset area (e.g., 'rgba(151,187,205,0.2)').\",\"children\":[]},{\"type\":\"String\",\"name\":\"[colors[].borderColor]\",\"description\":\"Border color for lines or point borders (e.g., 'rgba(151,187,205,1)').\",\"children\":[]},{\"type\":\"String\",\"name\":\"[colors[].pointBackgroundColor]\",\"description\":\"Background color for points (e.g., 'rgba(151,187,205,1)').\",\"children\":[]},{\"type\":\"String\",\"name\":\"[colors[].pointBorderColor]\",\"description\":\"Border color for points (e.g., '#fff').\",\"children\":[]},{\"type\":\"String\",\"name\":\"[colors[].pointHoverBackgroundColor]\",\"description\":\"Background color for points when hovered (e.g., '#fff').\",\"children\":[]},{\"type\":\"String\",\"name\":\"[colors[].pointHoverBorderColor]\",\"description\":\"Border color for points when hovered (e.g., 'rgba(151,187,205,1)').\",\"children\":[]}],\"functionName\":\"setColors\",\"snippetContent\":\"setColors(${1:colors});\"},\"setData\":{\"!type\":\"fn(data: [], [options]: object, [options.data]: string, [options.dataLabel]: string, [options.dataset]: string, [options.chartType]: string, [options.dataColors]: [], [options.stacked]: bool, [options.interpolate]: string) -> void\",\"!doc\":\"Sets the data set that will be used to populate the chart.\",\"!url\":\"https://docs.appivo.com/apis/chart/#setdata\",\"returnType\":\"void\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Array\",\"name\":\"data\",\"description\":\"The data set to be used to populate the chart.\"},{\"type\":\"Object\",\"name\":\"[options]\",\"description\":\"Options object for configuring data mapping.\"},{\"type\":\"String\",\"name\":\"[options.data]\",\"description\":\"The property name to use for the chart data values.\"},{\"type\":\"String\",\"name\":\"[options.dataLabel]\",\"description\":\"The property name to use for the chart labels.\"},{\"type\":\"String\",\"name\":\"[options.dataset]\",\"description\":\"The property name to use for grouping data into separate data sets.\"},{\"type\":\"String\",\"name\":\"[options.chartType]\",\"description\":\"The type of chart to render ('Lines', 'Bars', 'Pie', etc).\"},{\"type\":\"Array\",\"name\":\"[options.dataColors]\",\"description\":\"Custom colors to use for the chart data points.\"},{\"type\":\"Boolean\",\"name\":\"[options.stacked]\",\"description\":\"Whether to stack data series on top of each other.\"},{\"type\":\"String\",\"name\":\"[options.interpolate]\",\"description\":\"Interpolation method for missing data points ('none', 'linear', 'zero').\"}],\"parameterStructure\":[{\"type\":\"Array\",\"name\":\"data\",\"description\":\"The data set to be used to populate the chart.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"[options]\",\"description\":\"Options object for configuring data mapping.\",\"children\":[]},{\"type\":\"String\",\"name\":\"[options.data]\",\"description\":\"The property name to use for the chart data values.\",\"children\":[]},{\"type\":\"String\",\"name\":\"[options.dataLabel]\",\"description\":\"The property name to use for the chart labels.\",\"children\":[]},{\"type\":\"String\",\"name\":\"[options.dataset]\",\"description\":\"The property name to use for grouping data into separate data sets.\",\"children\":[]},{\"type\":\"String\",\"name\":\"[options.chartType]\",\"description\":\"The type of chart to render ('Lines', 'Bars', 'Pie', etc).\",\"children\":[]},{\"type\":\"Array\",\"name\":\"[options.dataColors]\",\"description\":\"Custom colors to use for the chart data points.\",\"children\":[]},{\"type\":\"Boolean\",\"name\":\"[options.stacked]\",\"description\":\"Whether to stack data series on top of each other.\",\"children\":[]},{\"type\":\"String\",\"name\":\"[options.interpolate]\",\"description\":\"Interpolation method for missing data points ('none', 'linear', 'zero').\",\"children\":[]}],\"functionName\":\"setData\",\"snippetContent\":\"setData(${1:data}, ${2:{}});\"},\"setQuery\":{\"!type\":\"fn(queryName: string) -> void\",\"!doc\":\"Sets the query used to populate the chart with data.\",\"!url\":\"https://docs.appivo.com/apis/chart/#setquery\",\"returnType\":\"void\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"queryName\",\"description\":\"The name or ID of the query to use for retrieving chart data.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"queryName\",\"description\":\"The name or ID of the query to use for retrieving chart data.\",\"children\":[]}],\"functionName\":\"setQuery\",\"snippetContent\":\"setQuery(${1:queryName});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"},\"showTooltip\":{\"!type\":\"fn(idx: Number) -> void\",\"!doc\":\"Displays a tooltip on a specific datapoint of the chart.\",\"!url\":\"https://docs.appivo.com/apis/chart/#showtooltip\",\"returnType\":\"void\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Number\",\"name\":\"idx\",\"description\":\"The index of the datapoint on which to display the tooltip.\"}],\"parameterStructure\":[{\"type\":\"Number\",\"name\":\"idx\",\"description\":\"The index of the datapoint on which to display the tooltip.\",\"children\":[]}],\"functionName\":\"showTooltip\",\"snippetContent\":\"showTooltip(${1:idx});\"},\"toPNG\":{\"!type\":\"fn() -> Blob\",\"!doc\":\"Exports the chart as a PNG image.\",\"!url\":\"https://docs.appivo.com/apis/chart/#topng\",\"returnType\":\"Blob\",\"returnDescription\":\"A Blob containing the PNG image data of the chart.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"toPNG\",\"snippetContent\":\"toPNG();\"},\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"}},\"CheckBox\":{\"!name\":\"CheckBox\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"ColoredWidget\":{\"!name\":\"ColoredWidget\"},\"ComboBox\":{\"!name\":\"ComboBox\",\"addRecord\":{\"!type\":\"fn(item: Record)\",\"!doc\":\"Adds a record to the list of options\",\"!url\":\"https://docs.appivo.com/apis/combobox/#addrecord\",\"parameterSignature\":[{\"type\":\"Record\",\"name\":\"item\",\"description\":\"The record to add.\"}],\"parameterStructure\":[{\"type\":\"Record\",\"name\":\"item\",\"description\":\"The record to add.\",\"children\":[]}],\"functionName\":\"addRecord\",\"snippetContent\":\"addRecord(${1:item});\"},\"getDisplayValue\":{\"!type\":\"fn() -> string\",\"!doc\":\"Returns the displayed value.\",\"!url\":\"https://docs.appivo.com/apis/combobox/#getdisplayvalue\",\"returnType\":\"String\",\"returnDescription\":\"The displayed value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getDisplayValue\",\"snippetContent\":\"getDisplayValue();\"},\"getSelectedRecord\":{\"!type\":\"fn() -> Record\",\"!doc\":\"Returns the currently selected record.\",\"!url\":\"https://docs.appivo.com/apis/combobox/#getselectedrecord\",\"returnType\":\"Record\",\"returnDescription\":\"The currently selected record.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getSelectedRecord\",\"snippetContent\":\"getSelectedRecord();\"},\"hasRecord\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget has a record selected.\",\"!url\":\"https://docs.appivo.com/apis/combobox/#hasrecord\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if there is a record selected, false otherwise.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"hasRecord\",\"snippetContent\":\"hasRecord();\"},\"setDisplayValue\":{\"!type\":\"fn(display: string)\",\"!doc\":\"Sets the displayed value.\",\"!url\":\"https://docs.appivo.com/apis/combobox/#setdisplayvalue\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"display\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"display\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setDisplayValue\",\"snippetContent\":\"setDisplayValue(${1:display});\"},\"setQuery\":{\"!type\":\"fn(queryName: string)\",\"!doc\":\"Sets the query used to populate the ComboBox's options\",\"!url\":\"https://docs.appivo.com/apis/combobox/#setquery\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"queryName\",\"description\":\"The name of the query.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"queryName\",\"description\":\"The name of the query.\",\"children\":[]}],\"functionName\":\"setQuery\",\"snippetContent\":\"setQuery(${1:queryName});\"},\"setRecord\":{\"!type\":\"fn(record: Record)\",\"!doc\":\"Sets the currently selected record.\",\"!url\":\"https://docs.appivo.com/apis/combobox/#setrecord\",\"parameterSignature\":[{\"type\":\"Record\",\"name\":\"record\",\"description\":\"The record to select.\"}],\"parameterStructure\":[{\"type\":\"Record\",\"name\":\"record\",\"description\":\"The record to select.\",\"children\":[]}],\"functionName\":\"setRecord\",\"snippetContent\":\"setRecord(${1:record});\"},\"setRecords\":{\"!type\":\"fn(items: Array<Record>)\",\"!doc\":\"Sets the ComboBox's options to the specified array of records\",\"!url\":\"https://docs.appivo.com/apis/combobox/#setrecords\",\"parameterSignature\":[{\"type\":\"Array<Record>\",\"name\":\"items\",\"description\":\"Array of records to use as the new options.\"}],\"parameterStructure\":[{\"type\":\"Array<Record>\",\"name\":\"items\",\"description\":\"Array of records to use as the new options.\",\"children\":[]}],\"functionName\":\"setRecords\",\"snippetContent\":\"setRecords(${1:items});\"},\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"CreditCard\":{\"!name\":\"CreditCard\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"CurrencyField\":{\"!name\":\"CurrencyField\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"DataGrid\":{\"!name\":\"DataGrid\",\"addRecord\":{\"!type\":\"fn(item: Record, opts: object)\",\"!doc\":\"Adds the specified record to the DataGrid.\",\"!url\":\"https://docs.appivo.com/apis/datagrid/#addrecord\",\"parameterSignature\":[{\"type\":\"Record\",\"name\":\"item\",\"description\":\"The record to add.\"},{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Optional options object with callbacks for when the operation is done.\"}],\"parameterStructure\":[{\"type\":\"Record\",\"name\":\"item\",\"description\":\"The record to add.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Optional options object with callbacks for when the operation is done.\",\"children\":[{\"type\":\"Function\",\"name\":\"onSuccess\",\"description\":\"Callback function if the operation was successful.\"},{\"type\":\"Function\",\"name\":\"onError\",\"description\":\"Callback function if the operation resulted in an error.\"}]}],\"functionName\":\"addRecord\",\"snippetContent\":\"addRecord(${1:item}, {\\n\\t'onSuccess' : function(){\\n\\t\\t${2:/* body... */}\\n\\t}, \\n\\t'onError' : function(){\\n\\t\\t${3:/* body... */}\\n\\t}\\n});\"},\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"commit\":{\"!type\":\"fn()\",\"!doc\":\"Saves changes made to the records held by the DataGrid.\",\"!url\":\"https://docs.appivo.com/apis/datagrid/#commit\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"commit\",\"snippetContent\":\"commit();\"},\"copyToClipboard\":{\"!type\":\"fn()\",\"!doc\":\"@function\",\"!url\":\"https://docs.appivo.com/apis/datagrid/#copytoclipboard\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"copyToClipboard\",\"snippetContent\":\"copyToClipboard();\"},\"deleteRecord\":{\"!type\":\"fn(item: Record, opts: object)\",\"!doc\":\"Deletes the specified record from the DataGrid\",\"!url\":\"https://docs.appivo.com/apis/datagrid/#deleterecord\",\"parameterSignature\":[{\"type\":\"Record\",\"name\":\"item\",\"description\":\"The record to delete.\"},{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Optional options object with callbacks for when the operation is done.\"}],\"parameterStructure\":[{\"type\":\"Record\",\"name\":\"item\",\"description\":\"The record to delete.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Optional options object with callbacks for when the operation is done.\",\"children\":[{\"type\":\"Function\",\"name\":\"onSuccess\",\"description\":\"Callback function if the operation was successful.\"},{\"type\":\"Function\",\"name\":\"onError\",\"description\":\"Callback function if the operation resulted in an error.\"}]}],\"functionName\":\"deleteRecord\",\"snippetContent\":\"deleteRecord(${1:item}, {\\n\\t'onSuccess' : function(){\\n\\t\\t${2:/* body... */}\\n\\t}, \\n\\t'onError' : function(){\\n\\t\\t${3:/* body... */}\\n\\t}\\n});\"},\"deselectAll\":{\"!type\":\"fn()\",\"!doc\":\"Deselects all rows.\",\"!url\":\"https://docs.appivo.com/apis/datagrid/#deselectall\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"deselectAll\",\"snippetContent\":\"deselectAll();\"},\"deselectRows\":{\"!type\":\"fn(rowNumbers: Array<Number>)\",\"!doc\":\"Deselects the specified rows.\",\"!url\":\"https://docs.appivo.com/apis/datagrid/#deselectrows\",\"parameterSignature\":[{\"type\":\"Array<Number>\",\"name\":\"rowNumbers\",\"description\":\"The numbers of the rows to deselect (starting at row 0 at the top).\"}],\"parameterStructure\":[{\"type\":\"Array<Number>\",\"name\":\"rowNumbers\",\"description\":\"The numbers of the rows to deselect (starting at row 0 at the top).\",\"children\":[]}],\"functionName\":\"deselectRows\",\"snippetContent\":\"deselectRows(${1:rowNumbers});\"},\"enableEdit\":{\"!type\":\"fn(enable: bool)\",\"!doc\":\"Enables or disables editing of the DataGrid's cells.\",\"!url\":\"https://docs.appivo.com/apis/datagrid/#enableedit\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"enable\",\"description\":\"Specifies whether to enable or disable editing.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"enable\",\"description\":\"Specifies whether to enable or disable editing.\",\"children\":[]}],\"functionName\":\"enableEdit\",\"snippetContent\":\"enableEdit(${1:enable});\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getActiveRecord\":{\"!type\":\"fn() -> Record\",\"!doc\":\"Returns the currently selected record.\",\"!url\":\"https://docs.appivo.com/apis/datagrid/#getactiverecord\",\"returnType\":\"Record\",\"returnDescription\":\"The currently selected record.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getActiveRecord\",\"snippetContent\":\"getActiveRecord();\"},\"getActiveRecordID\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the currently selected record.\",\"!url\":\"https://docs.appivo.com/apis/datagrid/#getactiverecordid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the currently selected record.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getActiveRecordID\",\"snippetContent\":\"getActiveRecordID();\"},\"getAllRecords\":{\"!type\":\"fn(opts: object) -> [Record]\",\"!doc\":\"Returns all of the DataGrid's records.\",\"!url\":\"https://docs.appivo.com/apis/datagrid/#getallrecords\",\"returnType\":\"Array<Record>\",\"returnDescription\":\"Array holding all of the DataGrid's records. If opts.load is enabled, this will return null and the records will be returned through the callback functions instead.\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Optional options object configuring the operation.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Optional options object configuring the operation.\",\"children\":[{\"type\":\"Boolean\",\"name\":\"load\",\"description\":\"If true, will attempt load records from the database in addition to the currently displayed records.\"},{\"type\":\"Boolean\",\"name\":\"sort\",\"description\":\"Enables sorting of records received from the database (note: requires opts.load to be true).\"},{\"type\":\"Function\",\"name\":\"onSuccess\",\"description\":\"Callback function if the load operation was successful (note: requires opts.load to be true).\"},{\"type\":\"Function\",\"name\":\"onError\",\"description\":\"Callback function if the load operation resulted in an error (note: requires opts.load to be true).\"}]}],\"functionName\":\"getAllRecords\",\"snippetContent\":\"getAllRecords({\\n\\t'load' : ${1:false}, \\n\\t'sort' : ${2:false}, \\n\\t'onSuccess' : function(){\\n\\t\\t${3:/* body... */}\\n\\t}, \\n\\t'onError' : function(){\\n\\t\\t${4:/* body... */}\\n\\t}\\n});\"},\"getColumns\":{\"!type\":\"fn() -> []\",\"!doc\":\"Returns the DataGrid's columns.\",\"!url\":\"https://docs.appivo.com/apis/datagrid/#getcolumns\",\"returnType\":\"Array\",\"returnDescription\":\"An array holding all of the DataGrid's columns\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getColumns\",\"snippetContent\":\"getColumns();\"},\"getFocusedRecord\":{\"!type\":\"fn() -> Record\",\"!doc\":\"Gets the record in focus.\",\"!url\":\"https://docs.appivo.com/apis/datagrid/#getfocusedrecord\",\"returnType\":\"Record\",\"returnDescription\":\"The record in focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getFocusedRecord\",\"snippetContent\":\"getFocusedRecord();\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getQuery\":{\"!type\":\"fn() -> Query\",\"!doc\":\"Returns the query used to populate the DataGrid\",\"!url\":\"https://docs.appivo.com/apis/datagrid/#getquery\",\"returnType\":\"Query\",\"returnDescription\":\"The query used to populate the DataGrid\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getQuery\",\"snippetContent\":\"getQuery();\"},\"getRecord\":{\"!type\":\"fn(id: ID)\",\"!doc\":\"Returns the record with the specified id.\",\"!url\":\"https://docs.appivo.com/apis/datagrid/#getrecord\",\"parameterSignature\":[{\"type\":\"ID\",\"name\":\"id\",\"description\":\"ID of the desired record.\"}],\"parameterStructure\":[{\"type\":\"ID\",\"name\":\"id\",\"description\":\"ID of the desired record.\",\"children\":[]}],\"functionName\":\"getRecord\",\"snippetContent\":\"getRecord(${1:id});\"},\"getSelectedRecords\":{\"!type\":\"fn(idsOnly: bool) -> [Record]\",\"!doc\":\"Returns the currently selected records.\",\"!url\":\"https://docs.appivo.com/apis/datagrid/#getselectedrecords\",\"returnType\":\"Array<Record> | Array<ID>\",\"returnDescription\":\"An array holding the currently selected records, or an array holding the ID's of the currently selected records (if idsOnly was true).\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"idsOnly\",\"description\":\"If true, only ID's will be returned.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"idsOnly\",\"description\":\"If true, only ID's will be returned.\",\"children\":[]}],\"functionName\":\"getSelectedRecords\",\"snippetContent\":\"getSelectedRecords(${1:idsOnly});\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"isRowSelected\":{\"!type\":\"fn(rowId: string) -> bool\",\"!doc\":\"Checks if a row is currently selected.\",\"!url\":\"https://docs.appivo.com/apis/datagrid/#isrowselected\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if the row is selected, false otherwise.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"rowId\",\"description\":\"The id of the row to check.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"rowId\",\"description\":\"The id of the row to check.\",\"children\":[]}],\"functionName\":\"isRowSelected\",\"snippetContent\":\"isRowSelected(${1:rowId});\"},\"newRecord\":{\"!type\":\"fn(item: object)\",\"!doc\":\"Creates a new record using the specified data.\",\"!url\":\"https://docs.appivo.com/apis/datagrid/#newrecord\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"item\",\"description\":\"Data to use for the new record.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"item\",\"description\":\"Data to use for the new record.\",\"children\":[]}],\"functionName\":\"newRecord\",\"snippetContent\":\"newRecord(${1:{}});\"},\"refresh\":{\"!type\":\"fn()\",\"!doc\":\"Refreshes the DataGrid\",\"!url\":\"https://docs.appivo.com/apis/datagrid/#refresh\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"refresh\",\"snippetContent\":\"refresh();\"},\"rollback\":{\"!type\":\"fn()\",\"!doc\":\"Reverts changes made to the records held by the DataGrid.\",\"!url\":\"https://docs.appivo.com/apis/datagrid/#rollback\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"rollback\",\"snippetContent\":\"rollback();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"selectAll\":{\"!type\":\"fn()\",\"!doc\":\"Selects all rows.\",\"!url\":\"https://docs.appivo.com/apis/datagrid/#selectall\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"selectAll\",\"snippetContent\":\"selectAll();\"},\"selectRows\":{\"!type\":\"fn(rowNumbers: Array<Number>)\",\"!doc\":\"Selects the specified rows.\",\"!url\":\"https://docs.appivo.com/apis/datagrid/#selectrows\",\"parameterSignature\":[{\"type\":\"Array<Number>\",\"name\":\"rowNumbers\",\"description\":\"The numbers of the rows to select (starting at row 0 at the top).\"}],\"parameterStructure\":[{\"type\":\"Array<Number>\",\"name\":\"rowNumbers\",\"description\":\"The numbers of the rows to select (starting at row 0 at the top).\",\"children\":[]}],\"functionName\":\"selectRows\",\"snippetContent\":\"selectRows(${1:rowNumbers});\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setColumnHeader\":{\"!type\":\"fn(colId: Number, header: string)\",\"!doc\":\"Changes the header text of a column\",\"!url\":\"https://docs.appivo.com/apis/datagrid/#setcolumnheader\",\"parameterSignature\":[{\"type\":\"Number\",\"name\":\"colId\",\"description\":\"0 based index of the column or the columns current header text\"},{\"type\":\"String\",\"name\":\"header\",\"description\":\"The new header text for the column\"}],\"parameterStructure\":[{\"type\":\"Number\",\"name\":\"colId\",\"description\":\"0 based index of the column or the columns current header text\",\"children\":[]},{\"type\":\"String\",\"name\":\"header\",\"description\":\"The new header text for the column\",\"children\":[]}],\"functionName\":\"setColumnHeader\",\"snippetContent\":\"setColumnHeader(${1:colId}, ${2:header});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setQuery\":{\"!type\":\"fn(query: Query)\",\"!doc\":\"Sets the query used for fetching records into this grid\",\"!url\":\"https://docs.appivo.com/apis/datagrid/#setquery\",\"parameterSignature\":[{\"type\":\"Query\",\"name\":\"query\",\"description\":\"query The query to use\"}],\"parameterStructure\":[{\"type\":\"Query\",\"name\":\"query\",\"description\":\"query The query to use\",\"children\":[]}],\"functionName\":\"setQuery\",\"snippetContent\":\"setQuery(${1:query});\"},\"setRecords\":{\"!type\":\"fn(records: Array<Record>) -> Promise\",\"!doc\":\"Sets the records displayed by the DataGrid to the specified array of records.\",\"!url\":\"https://docs.appivo.com/apis/datagrid/#setrecords\",\"returnType\":\"Promise\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Array<Record>\",\"name\":\"records\",\"description\":\"records The records to display.\"}],\"parameterStructure\":[{\"type\":\"Array<Record>\",\"name\":\"records\",\"description\":\"records The records to display.\",\"children\":[]}],\"functionName\":\"setRecords\",\"snippetContent\":\"setRecords(${1:records});\"},\"setRowData\":{\"!type\":\"fn(rowId: string, data: object)\",\"!doc\":\"Sets the data of the specified row.\",\"!url\":\"https://docs.appivo.com/apis/datagrid/#setrowdata\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"rowId\",\"description\":\"The id of the row to change.\"},{\"type\":\"Object\",\"name\":\"data\",\"description\":\"The new data.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"rowId\",\"description\":\"The id of the row to change.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"data\",\"description\":\"The new data.\",\"children\":[]}],\"functionName\":\"setRowData\",\"snippetContent\":\"setRowData(${1:rowId}, ${2:{}});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"},\"stepFocus\":{\"!type\":\"fn(rows: Number)\",\"!doc\":\"Steps the focused row by the specified number of rows.\",\"!url\":\"https://docs.appivo.com/apis/datagrid/#stepfocus\",\"parameterSignature\":[{\"type\":\"Number\",\"name\":\"rows\",\"description\":\"rows Number of rows to step\"}],\"parameterStructure\":[{\"type\":\"Number\",\"name\":\"rows\",\"description\":\"rows Number of rows to step\",\"children\":[]}],\"functionName\":\"stepFocus\",\"snippetContent\":\"stepFocus(${1:rows});\"},\"toggleCellHighlight\":{\"!type\":\"fn(colId: Number, highlightStyle: object)\",\"!doc\":\"Toggles highlight of a cell in the currently active row\",\"!url\":\"https://docs.appivo.com/apis/datagrid/#togglecellhighlight\",\"parameterSignature\":[{\"type\":\"Number\",\"name\":\"colId\",\"description\":\"0 based index of the column or the columns current header text\"},{\"type\":\"Object\",\"name\":\"highlightStyle\",\"description\":\"Style object to use as the highlight for the cell\"}],\"parameterStructure\":[{\"type\":\"Number\",\"name\":\"colId\",\"description\":\"0 based index of the column or the columns current header text\",\"children\":[]},{\"type\":\"Object\",\"name\":\"highlightStyle\",\"description\":\"Style object to use as the highlight for the cell\",\"children\":[]}],\"functionName\":\"toggleCellHighlight\",\"snippetContent\":\"toggleCellHighlight(${1:colId}, ${2:{}});\"},\"updateRecord\":{\"!type\":\"fn(record: Record)\",\"!doc\":\"Update a record in the grid\",\"!url\":\"https://docs.appivo.com/apis/datagrid/#updaterecord\",\"parameterSignature\":[{\"type\":\"Record\",\"name\":\"record\",\"description\":\"record The record to be updated.\"}],\"parameterStructure\":[{\"type\":\"Record\",\"name\":\"record\",\"description\":\"record The record to be updated.\",\"children\":[]}],\"functionName\":\"updateRecord\",\"snippetContent\":\"updateRecord(${1:record});\"}},\"DataImport\":{\"!name\":\"DataImport\",\"setModel\":{\"!type\":\"fn(modelName: string, relationMappings: object)\",\"!doc\":\"Sets the model used by the DataImport\",\"!url\":\"https://docs.appivo.com/apis/dataimport/#setmodel\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"modelName\",\"description\":\"The name of the new model.\"},{\"type\":\"Object\",\"name\":\"relationMappings\",\"description\":\"An object containing relation mappings to use.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"modelName\",\"description\":\"The name of the new model.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"relationMappings\",\"description\":\"An object containing relation mappings to use.\",\"children\":[]}],\"functionName\":\"setModel\",\"snippetContent\":\"setModel(${1:modelName}, ${2:{}});\"},\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"DataList\":{\"!name\":\"DataList\",\"getItems\":{\"!type\":\"fn() -> []\",\"!doc\":\"Gets the items in the list.\",\"!url\":\"https://docs.appivo.com/apis/datalist/#getitems\",\"returnType\":\"Array\",\"returnDescription\":\"Array holding all of the Lists items.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getItems\",\"snippetContent\":\"getItems();\"},\"refresh\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Refreshes the list.\",\"!url\":\"https://docs.appivo.com/apis/datalist/#refresh\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Optional object used to configure the refresh.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Optional object used to configure the refresh.\",\"children\":[]}],\"functionName\":\"refresh\",\"snippetContent\":\"refresh(${1:{}});\"},\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"DateField\":{\"!name\":\"DateField\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"Dialog\":{\"!name\":\"BaseView\",\"setTitle\":{\"!type\":\"fn(title: string)\",\"!doc\":\"Set the title of this dialog\",\"!url\":\"https://docs.appivo.com/apis/dialog/#settitle\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"title\",\"description\":\"The new title of this dialog\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"title\",\"description\":\"The new title of this dialog\",\"children\":[]}],\"functionName\":\"setTitle\",\"snippetContent\":\"setTitle(${1:title});\"},\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"DisplayLabel\":{\"!name\":\"DisplayLabel\",\"setDisplayValue\":{\"!type\":\"fn(value: string)\",\"!doc\":\"Sets the displayed value\",\"!url\":\"https://docs.appivo.com/apis/displaylabel/#setdisplayvalue\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setDisplayValue\",\"snippetContent\":\"setDisplayValue(${1:value});\"},\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"Divider\":{\"!name\":\"Divider\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"DropdownButton\":{\"!name\":\"DropdownButton\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"ExcelImport\":{\"!name\":\"ExcelImport\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"FileUpload\":{\"!name\":\"FileUpload\",\"clear\":{\"!type\":\"fn()\",\"!doc\":\"Clears the widget\",\"!url\":\"https://docs.appivo.com/apis/fileupload/#clear\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"clear\",\"snippetContent\":\"clear();\"},\"getDocument\":{\"!type\":\"fn() -> Record\",\"!doc\":\"Returns the document record currently occupying the widget.\",\"!url\":\"https://docs.appivo.com/apis/fileupload/#getdocument\",\"returnType\":\"Record\",\"returnDescription\":\"The document record occupying the widget.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getDocument\",\"snippetContent\":\"getDocument();\"},\"getDocuments\":{\"!type\":\"fn() -> Record\",\"!doc\":\"Returns the document records currently held by the widget.\",\"!url\":\"https://docs.appivo.com/apis/fileupload/#getdocuments\",\"returnType\":\"Record\",\"returnDescription\":\"The document records held by the widget.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getDocuments\",\"snippetContent\":\"getDocuments();\"},\"getRawFiles\":{\"!type\":\"fn()\",\"!doc\":\"Gets the raw selected files\",\"!url\":\"https://docs.appivo.com/apis/fileupload/#getrawfiles\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getRawFiles\",\"snippetContent\":\"getRawFiles();\"},\"readFile\":{\"!type\":\"fn()\",\"!doc\":\"Read the contents of a file present in the widget\",\"!url\":\"https://docs.appivo.com/apis/fileupload/#readfile\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"readFile\",\"snippetContent\":\"readFile();\"},\"setQuality\":{\"!type\":\"fn()\",\"!doc\":\"Sets the Image Quality\",\"!url\":\"https://docs.appivo.com/apis/fileupload/#setquality\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"setQuality\",\"snippetContent\":\"setQuality();\"},\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"GridContainer\":{\"!name\":\"GridContainer\",\"collapse\":{\"!type\":\"fn()\",\"!doc\":\"Collapse the panel\",\"!url\":\"https://docs.appivo.com/apis/gridcontainer/#collapse\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"collapse\",\"snippetContent\":\"collapse();\"},\"expand\":{\"!type\":\"fn()\",\"!doc\":\"Expand the panel\",\"!url\":\"https://docs.appivo.com/apis/gridcontainer/#expand\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"expand\",\"snippetContent\":\"expand();\"},\"isCollapsed\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Checks whether the panel is collapsed\",\"!url\":\"https://docs.appivo.com/apis/gridcontainer/#iscollapsed\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if the panel is collapsed\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isCollapsed\",\"snippetContent\":\"isCollapsed();\"},\"setTitle\":{\"!type\":\"fn(title: string)\",\"!doc\":\"Set the title of the panel\",\"!url\":\"https://docs.appivo.com/apis/gridcontainer/#settitle\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"title\",\"description\":\"New title\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"title\",\"description\":\"New title\",\"children\":[]}],\"functionName\":\"setTitle\",\"snippetContent\":\"setTitle(${1:title});\"},\"toggle\":{\"!type\":\"fn()\",\"!doc\":\"Toggle the panel\",\"!url\":\"https://docs.appivo.com/apis/gridcontainer/#toggle\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"toggle\",\"snippetContent\":\"toggle();\"},\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"HTML\":{\"!name\":\"HTML\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"HierarchySelect\":{\"!name\":\"HierarchySelect\",\"getSelectedRecord\":{\"!type\":\"fn() -> Record\",\"!doc\":\"Returns the currently selected record.\",\"!url\":\"https://docs.appivo.com/apis/hierarchyselect/#getselectedrecord\",\"returnType\":\"Record\",\"returnDescription\":\"The currently selected record.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getSelectedRecord\",\"snippetContent\":\"getSelectedRecord();\"},\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"HorizontalSlider\":{\"!name\":\"HorizontalSlider\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"Icon\":{\"!name\":\"Icon\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"Image\":{\"!name\":\"Image\",\"getImage\":{\"!type\":\"fn()\",\"!doc\":\"Gets the Image-object\",\"!url\":\"https://docs.appivo.com/apis/image/#getimage\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getImage\",\"snippetContent\":\"getImage();\"},\"setSource\":{\"!type\":\"fn()\",\"!doc\":\"Sets the source of this image\",\"!url\":\"https://docs.appivo.com/apis/image/#setsource\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"setSource\",\"snippetContent\":\"setSource();\"},\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"Instagram\":{\"!name\":\"Instagram\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"Jumbotron\":{\"!name\":\"Jumbotron\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"Link\":{\"!name\":\"Link\",\"setLabel\":{\"!type\":\"fn(label: string)\",\"!doc\":\"Sets the text displayed by the widget.\",\"!url\":\"https://docs.appivo.com/apis/link/#setlabel\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"label\",\"description\":\"The new text.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"label\",\"description\":\"The new text.\",\"children\":[]}],\"functionName\":\"setLabel\",\"snippetContent\":\"setLabel(${1:label});\"},\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"Map\":{\"!name\":\"Map\",\"addMarker\":{\"!type\":\"fn(pos: object, opts: object)\",\"!doc\":\"Adds a marker to the map\",\"!url\":\"https://docs.appivo.com/apis/map/#addmarker\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"pos\",\"description\":\"Coordinate of marker\"},{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"pos\",\"description\":\"Coordinate of marker\",\"children\":[]},{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options\",\"children\":[]}],\"functionName\":\"addMarker\",\"snippetContent\":\"addMarker(${1:{}}, ${2:{}});\"},\"locate\":{\"!type\":\"fn(options: object)\",\"!doc\":\"Automatically locate the user\",\"!url\":\"https://docs.appivo.com/apis/map/#locate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"options\",\"description\":\"Locate options\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"options\",\"description\":\"Locate options\",\"children\":[]}],\"functionName\":\"locate\",\"snippetContent\":\"locate(${1:{}});\"},\"refresh\":{\"!type\":\"fn(query: object, options: object)\",\"!doc\":\"Refreshes the map\",\"!url\":\"https://docs.appivo.com/apis/map/#refresh\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"query\",\"description\":\"Query parameters\"},{\"type\":\"Object\",\"name\":\"options\",\"description\":\"Options\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"query\",\"description\":\"Query parameters\",\"children\":[]},{\"type\":\"Object\",\"name\":\"options\",\"description\":\"Options\",\"children\":[]}],\"functionName\":\"refresh\",\"snippetContent\":\"refresh(${1:{}}, ${2:{}});\"},\"setRecords\":{\"!type\":\"fn(records: object, options: object)\",\"!doc\":\"Sets the records displayed in the map\",\"!url\":\"https://docs.appivo.com/apis/map/#setrecords\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"records\",\"description\":\"Records to set\"},{\"type\":\"Object\",\"name\":\"options\",\"description\":\"Options\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"records\",\"description\":\"Records to set\",\"children\":[]},{\"type\":\"Object\",\"name\":\"options\",\"description\":\"Options\",\"children\":[]}],\"functionName\":\"setRecords\",\"snippetContent\":\"setRecords(${1:{}}, ${2:{}});\"},\"setView\":{\"!type\":\"fn(position: object, zoom: Float)\",\"!doc\":\"Sets the center-location of the Map\",\"!url\":\"https://docs.appivo.com/apis/map/#setview\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"position\",\"description\":\"Coordinates to set as the new center of the map\"},{\"type\":\"Float\",\"name\":\"zoom\",\"description\":\"Zoom-level\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"position\",\"description\":\"Coordinates to set as the new center of the map\",\"children\":[]},{\"type\":\"Float\",\"name\":\"zoom\",\"description\":\"Zoom-level\",\"children\":[]}],\"functionName\":\"setView\",\"snippetContent\":\"setView(${1:{}}, ${2:zoom});\"},\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"Menu\":{\"!name\":\"Menu\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"MenuItem\":{\"!name\":\"MenuItem\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"MultiSelect\":{\"!name\":\"MultiSelect\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"NavigationBar\":{\"!name\":\"NavigationBar\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"NumberField\":{\"!name\":\"NumberField\",\"getDecimals\":{\"!type\":\"fn() -> Number\",\"!doc\":\"Gets the number of decimals used\",\"!url\":\"https://docs.appivo.com/apis/numberfield/#getdecimals\",\"returnType\":\"Number\",\"returnDescription\":\"The number of decimals used.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getDecimals\",\"snippetContent\":\"getDecimals();\"},\"getDisplayValue\":{\"!type\":\"fn() -> Number\",\"!doc\":\"Returns the currently displayed value.\",\"!url\":\"https://docs.appivo.com/apis/numberfield/#getdisplayvalue\",\"returnType\":\"Number\",\"returnDescription\":\"The currently displayed value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getDisplayValue\",\"snippetContent\":\"getDisplayValue();\"},\"getMaxValue\":{\"!type\":\"fn() -> Number\",\"!doc\":\"Gets the maximum value allowed\",\"!url\":\"https://docs.appivo.com/apis/numberfield/#getmaxvalue\",\"returnType\":\"Number\",\"returnDescription\":\"The maximum allowed value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getMaxValue\",\"snippetContent\":\"getMaxValue();\"},\"getMinValue\":{\"!type\":\"fn() -> Number\",\"!doc\":\"Gets the minimum value allowed\",\"!url\":\"https://docs.appivo.com/apis/numberfield/#getminvalue\",\"returnType\":\"Number\",\"returnDescription\":\"The minimum allowed value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getMinValue\",\"snippetContent\":\"getMinValue();\"},\"setDecimals\":{\"!type\":\"fn(decimals: Number)\",\"!doc\":\"Sets the number of decimals used\",\"!url\":\"https://docs.appivo.com/apis/numberfield/#setdecimals\",\"parameterSignature\":[{\"type\":\"Number\",\"name\":\"decimals\",\"description\":\"The number of decimals to use\"}],\"parameterStructure\":[{\"type\":\"Number\",\"name\":\"decimals\",\"description\":\"The number of decimals to use\",\"children\":[]}],\"functionName\":\"setDecimals\",\"snippetContent\":\"setDecimals(${1:decimals});\"},\"setDisplayValue\":{\"!type\":\"fn(value: Number)\",\"!doc\":\"Sets the currently displayed value.\",\"!url\":\"https://docs.appivo.com/apis/numberfield/#setdisplayvalue\",\"parameterSignature\":[{\"type\":\"Number\",\"name\":\"value\",\"description\":\"The value to display.\"}],\"parameterStructure\":[{\"type\":\"Number\",\"name\":\"value\",\"description\":\"The value to display.\",\"children\":[]}],\"functionName\":\"setDisplayValue\",\"snippetContent\":\"setDisplayValue(${1:value});\"},\"setMaxValue\":{\"!type\":\"fn()\",\"!doc\":\"Sets the maximum value allowed\",\"!url\":\"https://docs.appivo.com/apis/numberfield/#setmaxvalue\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"setMaxValue\",\"snippetContent\":\"setMaxValue();\"},\"setMinValue\":{\"!type\":\"fn()\",\"!doc\":\"Sets the minimum value allowed\",\"!url\":\"https://docs.appivo.com/apis/numberfield/#setminvalue\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"setMinValue\",\"snippetContent\":\"setMinValue();\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"NumberSpinner\":{\"!name\":\"NumberSpinner\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"Paragraph\":{\"!name\":\"Paragraph\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"PopupMenu\":{\"!name\":\"PopupMenu\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"RadialProgress\":{\"!name\":\"RadialProgress\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"ResourceCalendar\":{\"!name\":\"ResourceCalendar\",\"getActiveCell\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the currently active cell.\",\"!url\":\"https://docs.appivo.com/apis/resourcecalendar/#getactivecell\",\"returnType\":\"Object\",\"returnDescription\":\"The currently active cell.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getActiveCell\",\"snippetContent\":\"getActiveCell();\"},\"getSections\":{\"!type\":\"fn() -> []\",\"!doc\":\"Returns the sections.\",\"!url\":\"https://docs.appivo.com/apis/resourcecalendar/#getsections\",\"returnType\":\"Array\",\"returnDescription\":\"\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getSections\",\"snippetContent\":\"getSections();\"},\"getSelectedDate\":{\"!type\":\"fn() -> Date\",\"!doc\":\"Returns the currently selected date.\",\"!url\":\"https://docs.appivo.com/apis/resourcecalendar/#getselecteddate\",\"returnType\":\"Date\",\"returnDescription\":\"The currently selected date.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getSelectedDate\",\"snippetContent\":\"getSelectedDate();\"},\"gotoDate\":{\"!type\":\"fn(date: Date)\",\"!doc\":\"Selects the specified date in the calendar.\",\"!url\":\"https://docs.appivo.com/apis/resourcecalendar/#gotodate\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"The date to select.\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"The date to select.\",\"children\":[]}],\"functionName\":\"gotoDate\",\"snippetContent\":\"gotoDate(${1:date});\"},\"nextWeek\":{\"!type\":\"fn()\",\"!doc\":\"Displays the next week.\",\"!url\":\"https://docs.appivo.com/apis/resourcecalendar/#nextweek\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"nextWeek\",\"snippetContent\":\"nextWeek();\"},\"previousWeek\":{\"!type\":\"fn()\",\"!doc\":\"Displays the previous week\",\"!url\":\"https://docs.appivo.com/apis/resourcecalendar/#previousweek\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"previousWeek\",\"snippetContent\":\"previousWeek();\"},\"refresh\":{\"!type\":\"fn(includeSections: bool)\",\"!doc\":\"Refreshes the calendar\",\"!url\":\"https://docs.appivo.com/apis/resourcecalendar/#refresh\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"includeSections\",\"description\":\"If true, also refreshes the sections.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"includeSections\",\"description\":\"If true, also refreshes the sections.\",\"children\":[]}],\"functionName\":\"refresh\",\"snippetContent\":\"refresh(${1:includeSections});\"},\"today\":{\"!type\":\"fn()\",\"!doc\":\"Displays today.\",\"!url\":\"https://docs.appivo.com/apis/resourcecalendar/#today\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"today\",\"snippetContent\":\"today();\"},\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"RichTextArea\":{\"!name\":\"RichTextArea\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"Scheduler\":{\"!name\":\"Scheduler\",\"addItem\":{\"!type\":\"fn(name: string, start: object, end: object, section: object)\",\"!doc\":\"Adds an item to the scheduler.\",\"!url\":\"https://docs.appivo.com/apis/scheduler/#additem\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the item.\"},{\"type\":\"Object\",\"name\":\"start\",\"description\":\"Start time of the item.\"},{\"type\":\"Object\",\"name\":\"end\",\"description\":\"End time of the item.\"},{\"type\":\"Object\",\"name\":\"section\",\"description\":\"The section that the item should belong to.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the item.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"start\",\"description\":\"Start time of the item.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"end\",\"description\":\"End time of the item.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"section\",\"description\":\"The section that the item should belong to.\",\"children\":[]}],\"functionName\":\"addItem\",\"snippetContent\":\"addItem(${1:name}, ${2:{}}, ${3:{}}, ${4:{}});\"},\"addSection\":{\"!type\":\"fn(name: string)\",\"!doc\":\"Adds a section to the scheduler\",\"!url\":\"https://docs.appivo.com/apis/scheduler/#addsection\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the new section.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the new section.\",\"children\":[]}],\"functionName\":\"addSection\",\"snippetContent\":\"addSection(${1:name});\"},\"clearTimeouts\":{\"!type\":\"fn()\",\"!doc\":\"Clears all timeouts\",\"!url\":\"https://docs.appivo.com/apis/scheduler/#cleartimeouts\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"clearTimeouts\",\"snippetContent\":\"clearTimeouts();\"},\"daysInMonth\":{\"!type\":\"fn() -> []\",\"!doc\":\"Returns an array of month days.\",\"!url\":\"https://docs.appivo.com/apis/scheduler/#daysinmonth\",\"returnType\":\"Array\",\"returnDescription\":\"An array of {val, label} hashes representing the month days.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"daysInMonth\",\"snippetContent\":\"daysInMonth();\"},\"daysInWeek\":{\"!type\":\"fn() -> []\",\"!doc\":\"Returns an array of weekdays.\",\"!url\":\"https://docs.appivo.com/apis/scheduler/#daysinweek\",\"returnType\":\"Array\",\"returnDescription\":\"An array of {val, label} hashes representing the weekdays.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"daysInWeek\",\"snippetContent\":\"daysInWeek();\"},\"getCurrentPeriod\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the scheduler's currently selected period.\",\"!url\":\"https://docs.appivo.com/apis/scheduler/#getcurrentperiod\",\"returnType\":\"Object\",\"returnDescription\":\"The current period\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getCurrentPeriod\",\"snippetContent\":\"getCurrentPeriod();\"},\"getItem\":{\"!type\":\"fn(id: string) -> obj\",\"!doc\":\"Returns the item with the specified ID.\",\"!url\":\"https://docs.appivo.com/apis/scheduler/#getitem\",\"returnType\":\"Object\",\"returnDescription\":\"The item with the specified ID.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"id\",\"description\":\"The id of the item.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"id\",\"description\":\"The id of the item.\",\"children\":[]}],\"functionName\":\"getItem\",\"snippetContent\":\"getItem(${1:id});\"},\"getItems\":{\"!type\":\"fn() -> []\",\"!doc\":\"Returns an array of all items.\",\"!url\":\"https://docs.appivo.com/apis/scheduler/#getitems\",\"returnType\":\"Array\",\"returnDescription\":\"An array of all items.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getItems\",\"snippetContent\":\"getItems();\"},\"getPeriods\":{\"!type\":\"fn() -> []\",\"!doc\":\"Returns an array of all of the scheduler's periods.\",\"!url\":\"https://docs.appivo.com/apis/scheduler/#getperiods\",\"returnType\":\"Array\",\"returnDescription\":\"An array containing all of the scheduler's periods.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getPeriods\",\"snippetContent\":\"getPeriods();\"},\"getSections\":{\"!type\":\"fn() -> []\",\"!doc\":\"Returns an array of all of the scheduler's sections.\",\"!url\":\"https://docs.appivo.com/apis/scheduler/#getsections\",\"returnType\":\"Array\",\"returnDescription\":\"An array holding all of the scheduler's sections.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getSections\",\"snippetContent\":\"getSections();\"},\"getStart\":{\"!type\":\"fn() -> Date\",\"!doc\":\"Returns the start date of the scheduler\",\"!url\":\"https://docs.appivo.com/apis/scheduler/#getstart\",\"returnType\":\"Date\",\"returnDescription\":\"The start date\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getStart\",\"snippetContent\":\"getStart();\"},\"refresh\":{\"!type\":\"fn()\",\"!doc\":\"Refreshes the widget.\",\"!url\":\"https://docs.appivo.com/apis/scheduler/#refresh\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"refresh\",\"snippetContent\":\"refresh();\"},\"setAllocationLabelType\":{\"!type\":\"fn(type: string, preventUpdate: bool)\",\"!doc\":\"Sets the type of the allocation label.\",\"!url\":\"https://docs.appivo.com/apis/scheduler/#setallocationlabeltype\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"type\",\"description\":\"\"},{\"type\":\"Boolean\",\"name\":\"preventUpdate\",\"description\":\"\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"type\",\"description\":\"\",\"children\":[]},{\"type\":\"Boolean\",\"name\":\"preventUpdate\",\"description\":\"\",\"children\":[]}],\"functionName\":\"setAllocationLabelType\",\"snippetContent\":\"setAllocationLabelType(${1:type}, ${2:preventUpdate});\"},\"setCellException\":{\"!type\":\"fn(start: object, end: object, preventUpdate: bool)\",\"!doc\":\"Sets the cell exception.\",\"!url\":\"https://docs.appivo.com/apis/scheduler/#setcellexception\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"start\",\"description\":\"Start time\"},{\"type\":\"Object\",\"name\":\"end\",\"description\":\"End time\"},{\"type\":\"Boolean\",\"name\":\"preventUpdate\",\"description\":\"\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"start\",\"description\":\"Start time\",\"children\":[]},{\"type\":\"Object\",\"name\":\"end\",\"description\":\"End time\",\"children\":[]},{\"type\":\"Boolean\",\"name\":\"preventUpdate\",\"description\":\"\",\"children\":[]}],\"functionName\":\"setCellException\",\"snippetContent\":\"setCellException(${1:{}}, ${2:{}}, ${3:preventUpdate});\"},\"setCustomPeriod\":{\"!type\":\"fn(period: object, skipEvent: bool, keepStart: bool)\",\"!doc\":\"Creates and sets a custom period.\",\"!url\":\"https://docs.appivo.com/apis/scheduler/#setcustomperiod\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"period\",\"description\":\"The period to create.\"},{\"type\":\"Boolean\",\"name\":\"skipEvent\",\"description\":\"\"},{\"type\":\"Boolean\",\"name\":\"keepStart\",\"description\":\"\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"period\",\"description\":\"The period to create.\",\"children\":[]},{\"type\":\"Boolean\",\"name\":\"skipEvent\",\"description\":\"\",\"children\":[]},{\"type\":\"Boolean\",\"name\":\"keepStart\",\"description\":\"\",\"children\":[]}],\"functionName\":\"setCustomPeriod\",\"snippetContent\":\"setCustomPeriod(${1:{}}, ${2:skipEvent}, ${3:keepStart});\"},\"setFilter\":{\"!type\":\"fn(filter: object)\",\"!doc\":\"Sets a filter. The filter is used to filter displayed sections.\",\"!url\":\"https://docs.appivo.com/apis/scheduler/#setfilter\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"filter\",\"description\":\"An object containing the fields to use for the filter.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"filter\",\"description\":\"An object containing the fields to use for the filter.\",\"children\":[{\"type\":\"String\",\"name\":\"filter\",\"description\":\"An section attribute to filter on.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The desired value of the section attribute.\"}]}],\"functionName\":\"setFilter\",\"snippetContent\":\"setFilter({\\n\\t'filter' : '${1:string}', \\n\\t'value' :{}\\n});\"},\"setPeriod\":{\"!type\":\"fn(period: object, skipEvent: bool, keepStart: bool)\",\"!doc\":\"Sets the scheduler's selected period\",\"!url\":\"https://docs.appivo.com/apis/scheduler/#setperiod\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"period\",\"description\":\"The new period.\"},{\"type\":\"Boolean\",\"name\":\"skipEvent\",\"description\":\"\"},{\"type\":\"Boolean\",\"name\":\"keepStart\",\"description\":\"\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"period\",\"description\":\"The new period.\",\"children\":[]},{\"type\":\"Boolean\",\"name\":\"skipEvent\",\"description\":\"\",\"children\":[]},{\"type\":\"Boolean\",\"name\":\"keepStart\",\"description\":\"\",\"children\":[]}],\"functionName\":\"setPeriod\",\"snippetContent\":\"setPeriod(${1:{}}, ${2:skipEvent}, ${3:keepStart});\"},\"setStartAndEnd\":{\"!type\":\"fn(start: Date, end: Date)\",\"!doc\":\"Sets the displayed start and end dates.\",\"!url\":\"https://docs.appivo.com/apis/scheduler/#setstartandend\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"start\",\"description\":\"The start date.\"},{\"type\":\"Date\",\"name\":\"end\",\"description\":\"The end date.\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"start\",\"description\":\"The start date.\",\"children\":[]},{\"type\":\"Date\",\"name\":\"end\",\"description\":\"The end date.\",\"children\":[]}],\"functionName\":\"setStartAndEnd\",\"snippetContent\":\"setStartAndEnd(${1:start}, ${2:end});\"},\"setStartDate\":{\"!type\":\"fn(start: Date)\",\"!doc\":\"Sets the start date of the scheduler\",\"!url\":\"https://docs.appivo.com/apis/scheduler/#setstartdate\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"start\",\"description\":\"The new start date.\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"start\",\"description\":\"The new start date.\",\"children\":[]}],\"functionName\":\"setStartDate\",\"snippetContent\":\"setStartDate(${1:start});\"},\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"Select\":{\"!name\":\"Select\",\"addRecord\":{\"!type\":\"fn(item: Record)\",\"!doc\":\"Adds a record to the select.\",\"!url\":\"https://docs.appivo.com/apis/select/#addrecord\",\"parameterSignature\":[{\"type\":\"Record\",\"name\":\"item\",\"description\":\"The record to add.\"}],\"parameterStructure\":[{\"type\":\"Record\",\"name\":\"item\",\"description\":\"The record to add.\",\"children\":[]}],\"functionName\":\"addRecord\",\"snippetContent\":\"addRecord(${1:item});\"},\"getDisplayValue\":{\"!type\":\"fn() -> string\",\"!doc\":\"Returns the currently displayed value.\",\"!url\":\"https://docs.appivo.com/apis/select/#getdisplayvalue\",\"returnType\":\"String\",\"returnDescription\":\"The currently displayed value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getDisplayValue\",\"snippetContent\":\"getDisplayValue();\"},\"getEnumValue\":{\"!type\":\"fn() -> Record\",\"!doc\":\"Returns the integer value of the currently selected enum. Note: Only works when the widget is coupled to an enum attribute.\",\"!url\":\"https://docs.appivo.com/apis/select/#getenumvalue\",\"returnType\":\"Record\",\"returnDescription\":\"The currently selected record.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getEnumValue\",\"snippetContent\":\"getEnumValue();\"},\"getOptions\":{\"!type\":\"fn() -> []\",\"!doc\":\"Returns the currently selectable options\",\"!url\":\"https://docs.appivo.com/apis/select/#getoptions\",\"returnType\":\"Array\",\"returnDescription\":\"An array of all of the currently selectable options.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getOptions\",\"snippetContent\":\"getOptions();\"},\"getSelectedRecord\":{\"!type\":\"fn() -> Record\",\"!doc\":\"Returns the currently selected record.\",\"!url\":\"https://docs.appivo.com/apis/select/#getselectedrecord\",\"returnType\":\"Record\",\"returnDescription\":\"The currently selected record.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getSelectedRecord\",\"snippetContent\":\"getSelectedRecord();\"},\"isEmpty\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Checks if the select has any selectable options.\",\"!url\":\"https://docs.appivo.com/apis/select/#isempty\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if there are no selectable options.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEmpty\",\"snippetContent\":\"isEmpty();\"},\"reload\":{\"!type\":\"fn()\",\"!doc\":\"Refreshes the widget.\",\"!url\":\"https://docs.appivo.com/apis/select/#reload\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"reload\",\"snippetContent\":\"reload();\"},\"setDisplayValue\":{\"!type\":\"fn(value: string)\",\"!doc\":\"Sets the currently displayed value.\",\"!url\":\"https://docs.appivo.com/apis/select/#setdisplayvalue\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setDisplayValue\",\"snippetContent\":\"setDisplayValue(${1:value});\"},\"setOptions\":{\"!type\":\"fn(options: object)\",\"!doc\":\"Sets widget's selectable options to the options in the provided array.\",\"!url\":\"https://docs.appivo.com/apis/select/#setoptions\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"options\",\"description\":\"An object or array containing option values.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"options\",\"description\":\"An object or array containing option values.\",\"children\":[]}],\"functionName\":\"setOptions\",\"snippetContent\":\"setOptions(${1:options});\"},\"setValueAndReload\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the value and then refreshes the widget.\",\"!url\":\"https://docs.appivo.com/apis/select/#setvalueandreload\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"Optional new value to select.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"Optional new value to select.\",\"children\":[]}],\"functionName\":\"setValueAndReload\",\"snippetContent\":\"setValueAndReload(${1:{}});\"},\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"Select2\":{\"!name\":\"Select2\",\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"getDisplayValue\":{\"!type\":\"fn() -> string\",\"!doc\":\"Returns the currently displayed value.\",\"!url\":\"https://docs.appivo.com/apis/select2/#getdisplayvalue\",\"returnType\":\"String\",\"returnDescription\":\"The currently displayed value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getDisplayValue\",\"snippetContent\":\"getDisplayValue();\"},\"getOptions\":{\"!type\":\"fn() -> []\",\"!doc\":\"Returns the currently selectable options\",\"!url\":\"https://docs.appivo.com/apis/select2/#getoptions\",\"returnType\":\"Array\",\"returnDescription\":\"An array of all of the currently selectable options.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getOptions\",\"snippetContent\":\"getOptions();\"},\"getPlaceholder\":{\"!type\":\"fn()\",\"!doc\":\"Gets the placeholder-text\",\"!url\":\"https://docs.appivo.com/apis/select2/#getplaceholder\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getPlaceholder\",\"snippetContent\":\"getPlaceholder();\"},\"getSelectedRecord\":{\"!type\":\"fn() -> Record\",\"!doc\":\"Returns the currently selected record.\",\"!url\":\"https://docs.appivo.com/apis/select2/#getselectedrecord\",\"returnType\":\"Record\",\"returnDescription\":\"The currently selected record.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getSelectedRecord\",\"snippetContent\":\"getSelectedRecord();\"},\"reload\":{\"!type\":\"fn()\",\"!doc\":\"Refreshes the widget.\",\"!url\":\"https://docs.appivo.com/apis/select2/#reload\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"reload\",\"snippetContent\":\"reload();\"},\"setOptions\":{\"!type\":\"fn(options: [])\",\"!doc\":\"Sets widget's selectable options to the options in the provided array.\",\"!url\":\"https://docs.appivo.com/apis/select2/#setoptions\",\"parameterSignature\":[{\"type\":\"Array\",\"name\":\"options\",\"description\":\"An array containing option values.\"}],\"parameterStructure\":[{\"type\":\"Array\",\"name\":\"options\",\"description\":\"An array containing option values.\",\"children\":[]}],\"functionName\":\"setOptions\",\"snippetContent\":\"setOptions(${1:options});\"},\"setPlaceholder\":{\"!type\":\"fn()\",\"!doc\":\"Set the placeholder-text\",\"!url\":\"https://docs.appivo.com/apis/select2/#setplaceholder\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"setPlaceholder\",\"snippetContent\":\"setPlaceholder();\"},\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"Signature\":{\"!name\":\"Signature\",\"getDocument\":{\"!type\":\"fn() -> Record\",\"!doc\":\"Returns the document record held by the widget.\",\"!url\":\"https://docs.appivo.com/apis/signature/#getdocument\",\"returnType\":\"Record\",\"returnDescription\":\"The widget's document record.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getDocument\",\"snippetContent\":\"getDocument();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"reset\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Resets the value of this widget\",\"!url\":\"https://docs.appivo.com/apis/signature/#reset\",\"returnType\":\"Object\",\"returnDescription\":\"The value of the widget.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"reset\",\"snippetContent\":\"reset();\"},\"toImageSrc\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value as an image.\",\"!url\":\"https://docs.appivo.com/apis/signature/#toimagesrc\",\"returnType\":\"Object\",\"returnDescription\":\"The image source.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"toImageSrc\",\"snippetContent\":\"toImageSrc();\"},\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"SplitPane\":{\"!name\":\"SplitPane\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"TabContainer\":{\"!name\":\"TabContainer\",\"disableTab\":{\"!type\":\"fn(id: string)\",\"!doc\":\"Disables a tab.\",\"!url\":\"https://docs.appivo.com/apis/tabcontainer/#disabletab\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"id\",\"description\":\"The id of the tab.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"id\",\"description\":\"The id of the tab.\",\"children\":[]}],\"functionName\":\"disableTab\",\"snippetContent\":\"disableTab(${1:id});\"},\"enableTab\":{\"!type\":\"fn(id: string)\",\"!doc\":\"Enables a tab.\",\"!url\":\"https://docs.appivo.com/apis/tabcontainer/#enabletab\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"id\",\"description\":\"The id of the tab.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"id\",\"description\":\"The id of the tab.\",\"children\":[]}],\"functionName\":\"enableTab\",\"snippetContent\":\"enableTab(${1:id});\"},\"getActiveTab\":{\"!type\":\"fn() -> Tab\",\"!doc\":\"Returns the currently selected tab.\",\"!url\":\"https://docs.appivo.com/apis/tabcontainer/#getactivetab\",\"returnType\":\"Tab\",\"returnDescription\":\"The currently selected tab.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getActiveTab\",\"snippetContent\":\"getActiveTab();\"},\"getActiveTabId\":{\"!type\":\"fn() -> Tab\",\"!doc\":\"Returns the widget-ID of the currently selected tab\",\"!url\":\"https://docs.appivo.com/apis/tabcontainer/#getactivetabid\",\"returnType\":\"Tab\",\"returnDescription\":\"The currently selected tab.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getActiveTabId\",\"snippetContent\":\"getActiveTabId();\"},\"hideTab\":{\"!type\":\"fn(id: string)\",\"!doc\":\"Hides a tab.\",\"!url\":\"https://docs.appivo.com/apis/tabcontainer/#hidetab\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"id\",\"description\":\"The id of the tab.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"id\",\"description\":\"The id of the tab.\",\"children\":[]}],\"functionName\":\"hideTab\",\"snippetContent\":\"hideTab(${1:id});\"},\"setTab\":{\"!type\":\"fn(tab: Tab)\",\"!doc\":\"Sets the currently selected tab.\",\"!url\":\"https://docs.appivo.com/apis/tabcontainer/#settab\",\"parameterSignature\":[{\"type\":\"Tab\",\"name\":\"tab\",\"description\":\"The tab to select.\"}],\"parameterStructure\":[{\"type\":\"Tab\",\"name\":\"tab\",\"description\":\"The tab to select.\",\"children\":[]}],\"functionName\":\"setTab\",\"snippetContent\":\"setTab(${1:tab});\"},\"setTabDecoration\":{\"!type\":\"fn(id: string, decoration: string)\",\"!doc\":\"Set the decoration of a tab\",\"!url\":\"https://docs.appivo.com/apis/tabcontainer/#settabdecoration\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"id\",\"description\":\"id Id of the tab to set decoration of\"},{\"type\":\"String\",\"name\":\"decoration\",\"description\":\"decoration\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"id\",\"description\":\"id Id of the tab to set decoration of\",\"children\":[]},{\"type\":\"String\",\"name\":\"decoration\",\"description\":\"decoration\",\"children\":[]}],\"functionName\":\"setTabDecoration\",\"snippetContent\":\"setTabDecoration(${1:id}, ${2:decoration});\"},\"showTab\":{\"!type\":\"fn(id: string)\",\"!doc\":\"Shows hidden tab.\",\"!url\":\"https://docs.appivo.com/apis/tabcontainer/#showtab\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"id\",\"description\":\"The id of the tab.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"id\",\"description\":\"The id of the tab.\",\"children\":[]}],\"functionName\":\"showTab\",\"snippetContent\":\"showTab(${1:id});\"},\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"TabItemContainer\":{\"!name\":\"TabItemContainer\",\"setTitle\":{\"!type\":\"fn(text: string, icon: string, decoration: string)\",\"!doc\":\"Sets the tab title.\",\"!url\":\"https://docs.appivo.com/apis/tabitemcontainer/#settitle\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"text\",\"description\":\"title text.\"},{\"type\":\"String\",\"name\":\"icon\",\"description\":\"Configurable icon.\"},{\"type\":\"String\",\"name\":\"decoration\",\"description\":\"HTML Tab decoration.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"text\",\"description\":\"title text.\",\"children\":[]},{\"type\":\"String\",\"name\":\"icon\",\"description\":\"Configurable icon.\",\"children\":[]},{\"type\":\"String\",\"name\":\"decoration\",\"description\":\"HTML Tab decoration.\",\"children\":[]}],\"functionName\":\"setTitle\",\"snippetContent\":\"setTitle(${1:text}, ${2:icon}, ${3:decoration});\"},\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"TextArea\":{\"!name\":\"TextArea\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"TextField\":{\"!name\":\"TextField\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"TimeField\":{\"!name\":\"TimeField\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"Timeline\":{\"!name\":\"Timeline\",\"getPeriod\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the current displayed period.\",\"!url\":\"https://docs.appivo.com/apis/timeline/#getperiod\",\"returnType\":\"Object\",\"returnDescription\":\"\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getPeriod\",\"snippetContent\":\"getPeriod();\"},\"nextPeriod\":{\"!type\":\"fn()\",\"!doc\":\"Display the next period.\",\"!url\":\"https://docs.appivo.com/apis/timeline/#nextperiod\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"nextPeriod\",\"snippetContent\":\"nextPeriod();\"},\"previousPeriod\":{\"!type\":\"fn()\",\"!doc\":\"Display the previous period.\",\"!url\":\"https://docs.appivo.com/apis/timeline/#previousperiod\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"previousPeriod\",\"snippetContent\":\"previousPeriod();\"},\"refresh\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Refreshes the timeline.\",\"!url\":\"https://docs.appivo.com/apis/timeline/#refresh\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Optional options object to configure the refresh.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Optional options object to configure the refresh.\",\"children\":[]}],\"functionName\":\"refresh\",\"snippetContent\":\"refresh(${1:{}});\"},\"setRenderType\":{\"!type\":\"fn(renderType: currentDay)\",\"!doc\":\"Sets the timeline's render type.\",\"!url\":\"https://docs.appivo.com/apis/timeline/#setrendertype\",\"parameterSignature\":[{\"type\":\"currentDay\",\"name\":\"renderType\",\"description\":\"The new render type\"}],\"parameterStructure\":[{\"type\":\"currentDay\",\"name\":\"renderType\",\"description\":\"The new render type\",\"children\":[]}],\"functionName\":\"setRenderType\",\"snippetContent\":\"setRenderType(${1:renderType});\"},\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"Tree\":{\"!name\":\"Tree\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"Twitter\":{\"!name\":\"Twitter\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"VerticalSlider\":{\"!name\":\"VerticalSlider\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"Video\":{\"!name\":\"Video\",\"getPosition\":{\"!type\":\"fn() -> number\",\"!doc\":\"Get Video Position.\",\"!url\":\"https://docs.appivo.com/apis/video/#getposition\",\"returnType\":\"Integer\",\"returnDescription\":\"\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getPosition\",\"snippetContent\":\"getPosition();\"},\"hasEnded\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Check whether Video has Ended.\",\"!url\":\"https://docs.appivo.com/apis/video/#hasended\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if the Video Ended, false otherwise.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"hasEnded\",\"snippetContent\":\"hasEnded();\"},\"isPaused\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Check whether Video is Paused.\",\"!url\":\"https://docs.appivo.com/apis/video/#ispaused\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if the Video is Paused, false otherwise.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isPaused\",\"snippetContent\":\"isPaused();\"},\"pause\":{\"!type\":\"fn()\",\"!doc\":\"pause Video.\",\"!url\":\"https://docs.appivo.com/apis/video/#pause\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"pause\",\"snippetContent\":\"pause();\"},\"play\":{\"!type\":\"fn()\",\"!doc\":\"play Video.\",\"!url\":\"https://docs.appivo.com/apis/video/#play\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"play\",\"snippetContent\":\"play();\"},\"setPosition\":{\"!type\":\"fn(time: number)\",\"!doc\":\"set Video Position.\",\"!url\":\"https://docs.appivo.com/apis/video/#setposition\",\"parameterSignature\":[{\"type\":\"Integer\",\"name\":\"time\",\"description\":\"time\"}],\"parameterStructure\":[{\"type\":\"Integer\",\"name\":\"time\",\"description\":\"time\",\"children\":[]}],\"functionName\":\"setPosition\",\"snippetContent\":\"setPosition(${1:time});\"},\"setSource\":{\"!type\":\"fn(url: string)\",\"!doc\":\"Set Video Source\",\"!url\":\"https://docs.appivo.com/apis/video/#setsource\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"url\",\"description\":\"url\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"url\",\"description\":\"url\",\"children\":[]}],\"functionName\":\"setSource\",\"snippetContent\":\"setSource(${1:url});\"},\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"MButton\":{\"!name\":\"ColoredWidget\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setLabel\":{\"!type\":\"fn(Label: string)\",\"!doc\":\"Sets the label on the button.\",\"!url\":\"https://docs.appivo.com/apis/mbutton/#setlabel\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"Label\",\"description\":\"Text or HTML to set as the label on this button.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"Label\",\"description\":\"Text or HTML to set as the label on this button.\",\"children\":[]}],\"functionName\":\"setLabel\",\"snippetContent\":\"setLabel(${1:Label});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"MCalendar\":{\"!name\":\"MCalendar\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"MCard\":{\"!name\":\"MCard\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"MCheckBox\":{\"!name\":\"MCheckBox\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"MColumn\":{\"!name\":\"MColumn\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"Countdown\":{\"!name\":\"Countdown\",\"setDate\":{\"!type\":\"fn(date: Date)\",\"!doc\":\"Sets the end time of the countdown\",\"!url\":\"https://docs.appivo.com/apis/countdown/#setdate\",\"parameterSignature\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"The new end time.\"}],\"parameterStructure\":[{\"type\":\"Date\",\"name\":\"date\",\"description\":\"The new end time.\",\"children\":[]}],\"functionName\":\"setDate\",\"snippetContent\":\"setDate(${1:date});\"},\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"MDateField\":{\"!name\":\"MDateField\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"MDialog\":{\"!name\":\"BaseView\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"MDisplayListItem\":{\"!name\":\"MDisplayListItem\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"MFab\":{\"!name\":\"MFab\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"MHeading\":{\"!name\":\"ColoredWidget\",\"addRightIcon\":{\"!type\":\"fn(iconClass: string, onClick: Function)\",\"!doc\":\"Adds an icon to the far right side of the header.\",\"!url\":\"https://docs.appivo.com/apis/mheading/#addrighticon\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"iconClass\",\"description\":\"The classname of the icon to use (see Ionicons).\"},{\"type\":\"Function\",\"name\":\"onClick\",\"description\":\"Callback function for when the icon is clicked.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"iconClass\",\"description\":\"The classname of the icon to use (see Ionicons).\",\"children\":[]},{\"type\":\"Function\",\"name\":\"onClick\",\"description\":\"Callback function for when the icon is clicked.\",\"children\":[]}],\"functionName\":\"addRightIcon\",\"snippetContent\":\"addRightIcon(${1:iconClass}, ${2:function(){ /* body... */ }});\"},\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getLabel\":{\"!type\":\"fn() -> string\",\"!doc\":\"Returns the label shown on the header.\",\"!url\":\"https://docs.appivo.com/apis/mheading/#getlabel\",\"returnType\":\"String\",\"returnDescription\":\"The shown label.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getLabel\",\"snippetContent\":\"getLabel();\"},\"getRightIcon\":{\"!type\":\"fn()\",\"!doc\":\"Returns the far right side icon.\",\"!url\":\"https://docs.appivo.com/apis/mheading/#getrighticon\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getRightIcon\",\"snippetContent\":\"getRightIcon();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setLabel\":{\"!type\":\"fn(label: string)\",\"!doc\":\"Sets the label shown on the header.\",\"!url\":\"https://docs.appivo.com/apis/mheading/#setlabel\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"label\",\"description\":\"The new label.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"label\",\"description\":\"The new label.\",\"children\":[]}],\"functionName\":\"setLabel\",\"snippetContent\":\"setLabel(${1:label});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"MIcon\":{\"!name\":\"MIcon\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"MList\":{\"!name\":\"MList\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getRecords\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Gets the records in the list.\",\"!url\":\"https://docs.appivo.com/apis/mlist/#getrecords\",\"returnType\":\"Object\",\"returnDescription\":\"Promise containing all of the Lists items.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getRecords\",\"snippetContent\":\"getRecords();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"refresh\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Refreshes the list.\",\"!url\":\"https://docs.appivo.com/apis/mlist/#refresh\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Optional object used to configure the refresh.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Optional object used to configure the refresh.\",\"children\":[]}],\"functionName\":\"refresh\",\"snippetContent\":\"refresh(${1:{}});\"},\"render\":{\"!type\":\"fn()\",\"!doc\":\"Renders the list.\",\"!url\":\"https://docs.appivo.com/apis/mlist/#render\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"render\",\"snippetContent\":\"render();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"scrollToBottom\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the list to the bottom.\",\"!url\":\"https://docs.appivo.com/apis/mlist/#scrolltobottom\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollToBottom\",\"snippetContent\":\"scrollToBottom();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setQuery\":{\"!type\":\"fn(queryName: string)\",\"!doc\":\"Sets the query used to populate the list with items.\",\"!url\":\"https://docs.appivo.com/apis/mlist/#setquery\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"queryName\",\"description\":\"The name of the query.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"queryName\",\"description\":\"The name of the query.\",\"children\":[]}],\"functionName\":\"setQuery\",\"snippetContent\":\"setQuery(${1:queryName});\"},\"setRecords\":{\"!type\":\"fn(records: Array<Record>)\",\"!doc\":\"Sets the records in the list.\",\"!url\":\"https://docs.appivo.com/apis/mlist/#setrecords\",\"parameterSignature\":[{\"type\":\"Array<Record>\",\"name\":\"records\",\"description\":\"The records to display.\"}],\"parameterStructure\":[{\"type\":\"Array<Record>\",\"name\":\"records\",\"description\":\"The records to display.\",\"children\":[]}],\"functionName\":\"setRecords\",\"snippetContent\":\"setRecords(${1:records});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"MListItem\":{\"!name\":\"ColoredWidget\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setLabel\":{\"!type\":\"fn(val: string)\",\"!doc\":\"Sets the item's label\",\"!url\":\"https://docs.appivo.com/apis/mlistitem/#setlabel\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"val\",\"description\":\"The new label.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"val\",\"description\":\"The new label.\",\"children\":[]}],\"functionName\":\"setLabel\",\"snippetContent\":\"setLabel(${1:val});\"},\"setNote\":{\"!type\":\"fn(note: string)\",\"!doc\":\"Sets the item's note\",\"!url\":\"https://docs.appivo.com/apis/mlistitem/#setnote\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"note\",\"description\":\"The new note.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"note\",\"description\":\"The new note.\",\"children\":[]}],\"functionName\":\"setNote\",\"snippetContent\":\"setNote(${1:note});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"MNumberField\":{\"!name\":\"MNumberField\",\"setLabel\":{\"!type\":\"fn(val: string)\",\"!doc\":\"Sets the label displayed by the NumberField\",\"!url\":\"https://docs.appivo.com/apis/mnumberfield/#setlabel\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"val\",\"description\":\"The new label.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"val\",\"description\":\"The new label.\",\"children\":[]}],\"functionName\":\"setLabel\",\"snippetContent\":\"setLabel(${1:val});\"},\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"MRange\":{\"!name\":\"MRange\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"MRow\":{\"!name\":\"MRow\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"MSelect\":{\"!name\":\"MSelect\",\"addRecord\":{\"!type\":\"fn(item: Record)\",\"!doc\":\"Adds a record to the select.\",\"!url\":\"https://docs.appivo.com/apis/mselect/#addrecord\",\"parameterSignature\":[{\"type\":\"Record\",\"name\":\"item\",\"description\":\"The record to add.\"}],\"parameterStructure\":[{\"type\":\"Record\",\"name\":\"item\",\"description\":\"The record to add.\",\"children\":[]}],\"functionName\":\"addRecord\",\"snippetContent\":\"addRecord(${1:item});\"},\"getEnumValue\":{\"!type\":\"fn() -> Record\",\"!doc\":\"Returns the integer value of the currently selected enum. Note: Only works when the widget is coupled to an enum attribute.\",\"!url\":\"https://docs.appivo.com/apis/mselect/#getenumvalue\",\"returnType\":\"Record\",\"returnDescription\":\"The currently selected record.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getEnumValue\",\"snippetContent\":\"getEnumValue();\"},\"getOptions\":{\"!type\":\"fn() -> []\",\"!doc\":\"Returns the currently selectable options\",\"!url\":\"https://docs.appivo.com/apis/mselect/#getoptions\",\"returnType\":\"Array\",\"returnDescription\":\"An array of all of the currently selectable options.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getOptions\",\"snippetContent\":\"getOptions();\"},\"getSelectedRecord\":{\"!type\":\"fn() -> Record\",\"!doc\":\"Returns the currently selected record\",\"!url\":\"https://docs.appivo.com/apis/mselect/#getselectedrecord\",\"returnType\":\"Record\",\"returnDescription\":\"The currently selected record.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getSelectedRecord\",\"snippetContent\":\"getSelectedRecord();\"},\"isEmpty\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Checks if the select has no selectable options.\",\"!url\":\"https://docs.appivo.com/apis/mselect/#isempty\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if there are no selectable options, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEmpty\",\"snippetContent\":\"isEmpty();\"},\"reload\":{\"!type\":\"fn()\",\"!doc\":\"Refreshes the widget.\",\"!url\":\"https://docs.appivo.com/apis/mselect/#reload\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"reload\",\"snippetContent\":\"reload();\"},\"setDisplayValue\":{\"!type\":\"fn() -> string\",\"!doc\":\"Sets the widget's displayed value.\",\"!url\":\"https://docs.appivo.com/apis/mselect/#setdisplayvalue\",\"returnType\":\"String\",\"returnDescription\":\"The new displayed value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"setDisplayValue\",\"snippetContent\":\"setDisplayValue();\"},\"setOptions\":{\"!type\":\"fn(options: object)\",\"!doc\":\"Sets widget's selectable options to the options in the provided array.\",\"!url\":\"https://docs.appivo.com/apis/mselect/#setoptions\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"options\",\"description\":\"An object or array containing option values.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"options\",\"description\":\"An object or array containing option values.\",\"children\":[]}],\"functionName\":\"setOptions\",\"snippetContent\":\"setOptions(${1:options});\"},\"setValueAndReload\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value and refreshes the widget.\",\"!url\":\"https://docs.appivo.com/apis/mselect/#setvalueandreload\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value\",\"children\":[]}],\"functionName\":\"setValueAndReload\",\"snippetContent\":\"setValueAndReload(${1:{}});\"},\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"MSwitch\":{\"!name\":\"ColoredWidget\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"MTabBar\":{\"!name\":\"ColoredWidget\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"MText\":{\"!name\":\"MText\",\"setText\":{\"!type\":\"fn(text: string)\",\"!doc\":\"Sets the displayed text\",\"!url\":\"https://docs.appivo.com/apis/mtext/#settext\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"text\",\"description\":\"The text to display.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"text\",\"description\":\"The text to display.\",\"children\":[]}],\"functionName\":\"setText\",\"snippetContent\":\"setText(${1:text});\"},\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"MTextArea\":{\"!name\":\"MTextArea\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"MTextField\":{\"!name\":\"MTextField\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"MTimeField\":{\"!name\":\"MTimeField\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"MView\":{\"!name\":\"BaseView\",\"animate\":{\"!type\":\"fn(props: object, endCallback: Function, beginCallback: Function)\",\"!doc\":\"Animte the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#animate\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\"},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\"},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"props\",\"description\":\"Either a String or Object.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"endCallback\",\"description\":\"Callback called when the animation has been performed.\",\"children\":[]},{\"type\":\"Function\",\"name\":\"beginCallback\",\"description\":\"Callback called when the animation has started.\",\"children\":[]}],\"functionName\":\"animate\",\"snippetContent\":\"animate(${1:props}, ${2:function(){ /* body... */ }}, ${3:function(){ /* body... */ }});\"},\"blur\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the blur event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#blur\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"blur\",\"snippetContent\":\"blur();\"},\"focus\":{\"!type\":\"fn()\",\"!doc\":\"Triggers the focus event.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#focus\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"focus\",\"snippetContent\":\"focus();\"},\"get\":{\"!type\":\"fn(name: string) -> obj\",\"!doc\":\"Gets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#get\",\"returnType\":\"Object\",\"returnDescription\":\"The property's value.\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]}],\"functionName\":\"get\",\"snippetContent\":\"get(${1:name});\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the ID of the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the widget\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getValue\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#getvalue\",\"returnType\":\"Object\",\"returnDescription\":\"The widget's value.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getValue\",\"snippetContent\":\"getValue();\"},\"hide\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Hides the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#hide\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade out.\",\"children\":[]}],\"functionName\":\"hide\",\"snippetContent\":\"hide(${1:{}});\"},\"isEnabled\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is enabled.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#isenabled\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if enabled, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isEnabled\",\"snippetContent\":\"isEnabled();\"},\"isHidden\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the widget is hidden.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#ishidden\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if hidden, otherwise false.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isHidden\",\"snippetContent\":\"isHidden();\"},\"scrollTo\":{\"!type\":\"fn()\",\"!doc\":\"Scrolls the widget into view\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#scrollto\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"scrollTo\",\"snippetContent\":\"scrollTo();\"},\"set\":{\"!type\":\"fn(name: string, value: object)\",\"!doc\":\"Sets the value of the specified property.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#set\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"name\",\"description\":\"The name of the property.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"set\",\"snippetContent\":\"set(${1:name}, ${2:{}});\"},\"setEnabled\":{\"!type\":\"fn(Enabled: bool)\",\"!doc\":\"Enables/disables the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setenabled\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"Enabled\",\"description\":\"True to enable the widget, false to disable.\",\"children\":[]}],\"functionName\":\"setEnabled\",\"snippetContent\":\"setEnabled(${1:Enabled});\"},\"setStyle\":{\"!type\":\"fn(style: object)\",\"!doc\":\"Set the widget-style\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setstyle\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"style\",\"description\":\"Object with style-properties\",\"children\":[]}],\"functionName\":\"setStyle\",\"snippetContent\":\"setStyle(${1:{}});\"},\"setValue\":{\"!type\":\"fn(value: object)\",\"!doc\":\"Sets the widget's value.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#setvalue\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The new value.\",\"children\":[]}],\"functionName\":\"setValue\",\"snippetContent\":\"setValue(${1:{}});\"},\"show\":{\"!type\":\"fn(opts: object)\",\"!doc\":\"Shows the widget.\",\"!url\":\"https://docs.appivo.com/apis/basewidget/#show\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options, set opts.fade to true for the widget to fade in.\",\"children\":[]}],\"functionName\":\"show\",\"snippetContent\":\"show(${1:{}});\"}},\"Criteria\":{\"!name\":\"Criteria\",\"getLhs\":{\"!type\":\"fn()\",\"!doc\":\"Gets the left-hand side of this Criteria\",\"!url\":\"https://docs.appivo.com/apis/criteria/#getlhs\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getLhs\",\"snippetContent\":\"getLhs();\"},\"getOperator\":{\"!type\":\"fn() -> string\",\"!doc\":\"Gets the operator of this Criteria\",\"!url\":\"https://docs.appivo.com/apis/criteria/#getoperator\",\"returnType\":\"String\",\"returnDescription\":\"\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getOperator\",\"snippetContent\":\"getOperator();\"},\"getRhs\":{\"!type\":\"fn()\",\"!doc\":\"Gets the right-hand side of this Criteria\",\"!url\":\"https://docs.appivo.com/apis/criteria/#getrhs\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getRhs\",\"snippetContent\":\"getRhs();\"},\"setLhs\":{\"!type\":\"fn(lhs: object)\",\"!doc\":\"Sets the left-hand side of this Criteria\",\"!url\":\"https://docs.appivo.com/apis/criteria/#setlhs\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"lhs\",\"description\":\"hand side\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"lhs\",\"description\":\"hand side\",\"children\":[]}],\"functionName\":\"setLhs\",\"snippetContent\":\"setLhs(${1:{}});\"},\"setOperator\":{\"!type\":\"fn(op: string)\",\"!doc\":\"Sets the operator of this Criteria\",\"!url\":\"https://docs.appivo.com/apis/criteria/#setoperator\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"op\",\"description\":\"op Operator\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"op\",\"description\":\"op Operator\",\"children\":[]}],\"functionName\":\"setOperator\",\"snippetContent\":\"setOperator(${1:op});\"},\"setRhs\":{\"!type\":\"fn(rhs: object)\",\"!doc\":\"Sets the left-hand side of this Criteria\",\"!url\":\"https://docs.appivo.com/apis/criteria/#setrhs\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"rhs\",\"description\":\"hand side\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"rhs\",\"description\":\"hand side\",\"children\":[]}],\"functionName\":\"setRhs\",\"snippetContent\":\"setRhs(${1:{}});\"}},\"Model\":{\"!name\":\"Model\",\"getDescription\":{\"!type\":\"fn() -> string\",\"!doc\":\"Returns the model's description.\",\"!url\":\"https://docs.appivo.com/apis/model/#getdescription\",\"returnType\":\"String\",\"returnDescription\":\"The model's description.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getDescription\",\"snippetContent\":\"getDescription();\"},\"getId\":{\"!type\":\"fn() -> ID\",\"!doc\":\"Returns the model's ID.\",\"!url\":\"https://docs.appivo.com/apis/model/#getid\",\"returnType\":\"ID\",\"returnDescription\":\"The ID of the model.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getName\":{\"!type\":\"fn() -> string\",\"!doc\":\"Returns the model's name\",\"!url\":\"https://docs.appivo.com/apis/model/#getname\",\"returnType\":\"String\",\"returnDescription\":\"The name of the model.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getName\",\"snippetContent\":\"getName();\"},\"getRecord\":{\"!type\":\"fn(opts: object) -> Record\",\"!doc\":\"Returns the Record.\",\"!url\":\"https://docs.appivo.com/apis/model/#getrecord\",\"returnType\":\"Record\",\"returnDescription\":\"The query's result set.\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"test.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"test.\",\"children\":[]}],\"functionName\":\"getRecord\",\"snippetContent\":\"getRecord(${1:{}});\"},\"getType\":{\"!type\":\"fn() -> string\",\"!doc\":\"Returns the type of the model.\",\"!url\":\"https://docs.appivo.com/apis/model/#gettype\",\"returnType\":\"String\",\"returnDescription\":\"The type of the model. The type can be either 'document' or 'data'.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getType\",\"snippetContent\":\"getType();\"},\"isDocument\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Convenience function that returns true if the model's type is 'document'.\",\"!url\":\"https://docs.appivo.com/apis/model/#isdocument\",\"returnType\":\"Boolean\",\"returnDescription\":\"True or false depending on if the model's type is 'document'.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isDocument\",\"snippetContent\":\"isDocument();\"},\"isExportable\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the model is marked as exportable.\",\"!url\":\"https://docs.appivo.com/apis/model/#isexportable\",\"returnType\":\"Boolean\",\"returnDescription\":\"True if the model is marked as exportable.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isExportable\",\"snippetContent\":\"isExportable();\"}},\"QueryHandle\":{\"!name\":\"QueryHandle\",\"execute\":{\"!type\":\"fn(options: object) -> Promise\",\"!doc\":\"Executes the query.\",\"!url\":\"https://docs.appivo.com/apis/queryhandle/#execute\",\"returnType\":\"Promise\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"options\",\"description\":\"options Options object.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"options\",\"description\":\"options Options object.\",\"children\":[{\"type\":\"Object\",\"name\":\"options\",\"description\":\"options.options Holds query specific configurations.\"},{\"type\":\"Boolean\",\"name\":\"options\",\"description\":\"options.options.nested If true, the query will include related objects in its result set.\"},{\"type\":\"Number\",\"name\":\"options\",\"description\":\"options.options.count Number of objects to return in the result.\"}]}],\"functionName\":\"execute\",\"snippetContent\":\"execute({\\n\\t'options' :{}, \\n\\t'options' : ${1:false}, \\n\\t'options' : ${2:0}\\n});\"},\"getResult\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the result of the query.\",\"!url\":\"https://docs.appivo.com/apis/queryhandle/#getresult\",\"returnType\":\"Object\",\"returnDescription\":\"The query's result set.\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getResult\",\"snippetContent\":\"getResult();\"},\"refresh\":{\"!type\":\"fn(force: bool)\",\"!doc\":\"Refrehes the query.\",\"!url\":\"https://docs.appivo.com/apis/queryhandle/#refresh\",\"parameterSignature\":[{\"type\":\"Boolean\",\"name\":\"force\",\"description\":\"Force the query to execute\"}],\"parameterStructure\":[{\"type\":\"Boolean\",\"name\":\"force\",\"description\":\"Force the query to execute\",\"children\":[]}],\"functionName\":\"refresh\",\"snippetContent\":\"refresh(${1:force});\"},\"removeParameter\":{\"!type\":\"fn(param: string, noupdate: bool)\",\"!doc\":\"Clears the value of specified parameter.\",\"!url\":\"https://docs.appivo.com/apis/queryhandle/#removeparameter\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"param\",\"description\":\"The name of the parameter to clear.\"},{\"type\":\"Boolean\",\"name\":\"noupdate\",\"description\":\"If true, the query will not automatically update after the parameter has been removed.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"param\",\"description\":\"The name of the parameter to clear.\",\"children\":[]},{\"type\":\"Boolean\",\"name\":\"noupdate\",\"description\":\"If true, the query will not automatically update after the parameter has been removed.\",\"children\":[]}],\"functionName\":\"removeParameter\",\"snippetContent\":\"removeParameter(${1:param}, ${2:noupdate});\"},\"setParameter\":{\"!type\":\"fn(param: string, value: object, noupdate: bool)\",\"!doc\":\"Sets a query parameter to the specified value.\",\"!url\":\"https://docs.appivo.com/apis/queryhandle/#setparameter\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"param\",\"description\":\"The name of the parameter.\"},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The desired value.\"},{\"type\":\"Boolean\",\"name\":\"noupdate\",\"description\":\"If true, the query will not automatically update after the value has been set.\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"param\",\"description\":\"The name of the parameter.\",\"children\":[]},{\"type\":\"Object\",\"name\":\"value\",\"description\":\"The desired value.\",\"children\":[]},{\"type\":\"Boolean\",\"name\":\"noupdate\",\"description\":\"If true, the query will not automatically update after the value has been set.\",\"children\":[]}],\"functionName\":\"setParameter\",\"snippetContent\":\"setParameter(${1:param}, ${2:{}}, ${3:noupdate});\"},\"setParameters\":{\"!type\":\"fn(params: object, noupdate: bool)\",\"!doc\":\"Sets a collection of parameters to their specified values.\",\"!url\":\"https://docs.appivo.com/apis/queryhandle/#setparameters\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"params\",\"description\":\"value pairs.\"},{\"type\":\"Boolean\",\"name\":\"noupdate\",\"description\":\"If true, the query will not automatically update after the value has been set.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"params\",\"description\":\"value pairs.\",\"children\":[]},{\"type\":\"Boolean\",\"name\":\"noupdate\",\"description\":\"If true, the query will not automatically update after the value has been set.\",\"children\":[]}],\"functionName\":\"setParameters\",\"snippetContent\":\"setParameters(${1:{}}, ${2:noupdate});\"},\"setQueryParameters\":{\"!type\":\"fn(qps: object)\",\"!doc\":\"Sets query parameter values according to the specified map.\",\"!url\":\"https://docs.appivo.com/apis/queryhandle/#setqueryparameters\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"qps\",\"description\":\"Map of query parameter name and value pairs.\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"qps\",\"description\":\"Map of query parameter name and value pairs.\",\"children\":[]}],\"functionName\":\"setQueryParameters\",\"snippetContent\":\"setQueryParameters(${1:{}});\"},\"setRelations\":{\"!type\":\"fn(relations: string, noupdate: bool)\",\"!doc\":\"Sets the related records to also load\",\"!url\":\"https://docs.appivo.com/apis/queryhandle/#setrelations\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"relations\",\"description\":\"separated list of relations\"},{\"type\":\"Boolean\",\"name\":\"noupdate\",\"description\":\"result\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"relations\",\"description\":\"separated list of relations\",\"children\":[]},{\"type\":\"Boolean\",\"name\":\"noupdate\",\"description\":\"result\",\"children\":[]}],\"functionName\":\"setRelations\",\"snippetContent\":\"setRelations(${1:relations}, ${2:noupdate});\"}},\"Record\":{\"!name\":\"Record\",\"_clone\":{\"!type\":\"fn([reset=false]: boolean, [deep=false]: boolean) -> Record\",\"!doc\":\"Clones the record.\",\"!url\":\"https://docs.appivo.com/apis/record/#_clone\",\"returnType\":\"Record\",\"returnDescription\":\"A clone of the record\",\"parameterSignature\":[{\"type\":\"boolean\",\"name\":\"[reset=false]\",\"description\":\"If true, removes the ID from the clone\"},{\"type\":\"boolean\",\"name\":\"[deep=false]\",\"description\":\"If true, performs a deep clone including related records\"}],\"parameterStructure\":[{\"type\":\"boolean\",\"name\":\"[reset=false]\",\"description\":\"If true, removes the ID from the clone\",\"children\":[]},{\"type\":\"boolean\",\"name\":\"[deep=false]\",\"description\":\"If true, performs a deep clone including related records\",\"children\":[]}],\"functionName\":\"_clone\",\"snippetContent\":\"_clone(${1:[reset=false]}, ${2:[deep=false]});\"},\"_getAttributeValue\":{\"!type\":\"fn(name: string) -> *\",\"!doc\":\"Returns the value of the specified attribute.\",\"!url\":\"https://docs.appivo.com/apis/record/#_getattributevalue\",\"returnType\":\"*\",\"returnDescription\":\"The attribute's value\",\"parameterSignature\":[{\"type\":\"string\",\"name\":\"name\",\"description\":\"The name of the attribute\"}],\"parameterStructure\":[{\"type\":\"string\",\"name\":\"name\",\"description\":\"The name of the attribute\",\"children\":[]}],\"functionName\":\"_getAttributeValue\",\"snippetContent\":\"_getAttributeValue(${1:name});\"},\"_getBase64\":{\"!type\":\"fn() -> string|null\",\"!doc\":\"Gets the Base64-encoded data for a document record.\",\"!url\":\"https://docs.appivo.com/apis/record/#_getbase64\",\"returnType\":\"string|null\",\"returnDescription\":\"encoded data, or null if not a document or no data\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"_getBase64\",\"snippetContent\":\"_getBase64();\"},\"_getMetadata\":{\"!type\":\"fn() -> obj\",\"!doc\":\"Returns the record's metadata, if available.\",\"!url\":\"https://docs.appivo.com/apis/record/#_getmetadata\",\"returnType\":\"Object\",\"returnDescription\":\"The record's metadata\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"_getMetadata\",\"snippetContent\":\"_getMetadata();\"},\"_hasPrivilege\":{\"!type\":\"fn(privilege: string) -> boolean|undefined\",\"!doc\":\"Checks whether the user has a certain privilege on this record.\",\"!url\":\"https://docs.appivo.com/apis/record/#_hasprivilege\",\"returnType\":\"boolean|undefined\",\"returnDescription\":\"True if the user has the privilege, false if not, undefined if privileges aren't loaded\",\"parameterSignature\":[{\"type\":\"string\",\"name\":\"privilege\",\"description\":\"The privilege to check for\"}],\"parameterStructure\":[{\"type\":\"string\",\"name\":\"privilege\",\"description\":\"The privilege to check for\",\"children\":[]}],\"functionName\":\"_hasPrivilege\",\"snippetContent\":\"_hasPrivilege(${1:privilege});\"},\"_isNew\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Returns true if the record is a new record (has no ID yet).\",\"!url\":\"https://docs.appivo.com/apis/record/#_isnew\",\"returnType\":\"boolean\",\"returnDescription\":\"True if the record is new, false otherwise\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"_isNew\",\"snippetContent\":\"_isNew();\"},\"_merge\":{\"!type\":\"fn(record: Record, [noResolve=false]: boolean) -> Record\",\"!doc\":\"Merges this record with another record.\",\"!url\":\"https://docs.appivo.com/apis/record/#_merge\",\"returnType\":\"Record\",\"returnDescription\":\"This record, after merging\",\"parameterSignature\":[{\"type\":\"Record\",\"name\":\"record\",\"description\":\"The record to merge with\"},{\"type\":\"boolean\",\"name\":\"[noResolve=false]\",\"description\":\"If true, doesn't resolve relations after merging\"}],\"parameterStructure\":[{\"type\":\"Record\",\"name\":\"record\",\"description\":\"The record to merge with\",\"children\":[]},{\"type\":\"boolean\",\"name\":\"[noResolve=false]\",\"description\":\"If true, doesn't resolve relations after merging\",\"children\":[]}],\"functionName\":\"_merge\",\"snippetContent\":\"_merge(${1:record}, ${2:[noResolve=false]});\"},\"_setMetadata\":{\"!type\":\"fn(metadata: object)\",\"!doc\":\"Sets the record's metadata.\",\"!url\":\"https://docs.appivo.com/apis/record/#_setmetadata\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"metadata\",\"description\":\"Metadata properties to set\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"metadata\",\"description\":\"Metadata properties to set\",\"children\":[]}],\"functionName\":\"_setMetadata\",\"snippetContent\":\"_setMetadata(${1:{}});\"},\"_toReference\":{\"!type\":\"fn() -> Record\",\"!doc\":\"Creates a reference to this record (a record with only the ID).\",\"!url\":\"https://docs.appivo.com/apis/record/#_toreference\",\"returnType\":\"Record\",\"returnDescription\":\"A reference to this record\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"_toReference\",\"snippetContent\":\"_toReference();\"},\"constructor\":{\"!type\":\"fn(options: object, norecurse: boolean)\",\"!doc\":\"Creates a new Record instance.\",\"!url\":\"https://docs.appivo.com/apis/record/#constructor\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"options\",\"description\":\"Configuration options\"},{\"type\":\"boolean\",\"name\":\"norecurse\",\"description\":\"Whether to avoid recursively creating relation objects\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"options\",\"description\":\"Configuration options\",\"children\":[{\"type\":\"Object\",\"name\":\"data\",\"description\":\"Record data to initialize with\"},{\"type\":\"Object\",\"name\":\"store\",\"description\":\"Data store associated with this record\"},{\"type\":\"Object\",\"name\":\"model\",\"description\":\"Model associated with this record\"}]},{\"type\":\"boolean\",\"name\":\"norecurse\",\"description\":\"Whether to avoid recursively creating relation objects\",\"children\":[]}],\"functionName\":\"constructor\",\"snippetContent\":\"constructor({\\n\\t'data' :{}, \\n\\t'store' :{}, \\n\\t'model' :{}\\n}, ${5:norecurse});\"},\"getDocumentURL\":{\"!type\":\"fn(nocache: boolean, encode: boolean) -> string\",\"!doc\":\"If this is a document record, this function returns the URL to the file pointed to by this record.\",\"!url\":\"https://docs.appivo.com/apis/record/#getdocumenturl\",\"returnType\":\"string\",\"returnDescription\":\"The URL to the document\",\"parameterSignature\":[{\"type\":\"boolean\",\"name\":\"nocache\",\"description\":\"If true, ensures the link cannot be cached\"},{\"type\":\"boolean\",\"name\":\"encode\",\"description\":\"If true, ensures any query parameters are URI-encoded\"}],\"parameterStructure\":[{\"type\":\"boolean\",\"name\":\"nocache\",\"description\":\"If true, ensures the link cannot be cached\",\"children\":[]},{\"type\":\"boolean\",\"name\":\"encode\",\"description\":\"If true, ensures any query parameters are URI-encoded\",\"children\":[]}],\"functionName\":\"getDocumentURL\",\"snippetContent\":\"getDocumentURL(${1:nocache}, ${2:encode});\"},\"getDownloadURL\":{\"!type\":\"fn() -> string\",\"!doc\":\"If this is a document record, this function returns the download URL.\",\"!url\":\"https://docs.appivo.com/apis/record/#getdownloadurl\",\"returnType\":\"string\",\"returnDescription\":\"The download URL for the document\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getDownloadURL\",\"snippetContent\":\"getDownloadURL();\"},\"getId\":{\"!type\":\"fn() -> string\",\"!doc\":\"Returns the record's ID.\",\"!url\":\"https://docs.appivo.com/apis/record/#getid\",\"returnType\":\"string\",\"returnDescription\":\"The ID of the record\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getId\",\"snippetContent\":\"getId();\"},\"getJsonProperty\":{\"!type\":\"fn(attr: string, path: string) -> *\",\"!doc\":\"Gets a property from a JSON attribute by path.\",\"!url\":\"https://docs.appivo.com/apis/record/#getjsonproperty\",\"returnType\":\"*\",\"returnDescription\":\"The value at the specified path\",\"parameterSignature\":[{\"type\":\"string\",\"name\":\"attr\",\"description\":\"The attribute name containing JSON data\"},{\"type\":\"string\",\"name\":\"path\",\"description\":\"The path to the property within the JSON object\"}],\"parameterStructure\":[{\"type\":\"string\",\"name\":\"attr\",\"description\":\"The attribute name containing JSON data\",\"children\":[]},{\"type\":\"string\",\"name\":\"path\",\"description\":\"The path to the property within the JSON object\",\"children\":[]}],\"functionName\":\"getJsonProperty\",\"snippetContent\":\"getJsonProperty(${1:attr}, ${2:path});\"},\"getLabel\":{\"!type\":\"fn() -> string\",\"!doc\":\"Returns the display label for this record.\",\"!url\":\"https://docs.appivo.com/apis/record/#getlabel\",\"returnType\":\"string\",\"returnDescription\":\"The display label for this record\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getLabel\",\"snippetContent\":\"getLabel();\"},\"getModel\":{\"!type\":\"fn() -> Model\",\"!doc\":\"Returns the record's model.\",\"!url\":\"https://docs.appivo.com/apis/record/#getmodel\",\"returnType\":\"Model\",\"returnDescription\":\"The model this record belongs to\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getModel\",\"snippetContent\":\"getModel();\"},\"getThumbnailURL\":{\"!type\":\"fn(format: string) -> string\",\"!doc\":\"Returns the URL to a thumbnail of a document.\",\"!url\":\"https://docs.appivo.com/apis/record/#getthumbnailurl\",\"returnType\":\"string\",\"returnDescription\":\"The URL to the thumbnail\",\"parameterSignature\":[{\"type\":\"string\",\"name\":\"format\",\"description\":\"The format/size of the thumbnail (e.g., \\\"small\\\", \\\"medium\\\", \\\"large\\\")\"}],\"parameterStructure\":[{\"type\":\"string\",\"name\":\"format\",\"description\":\"The format/size of the thumbnail (e.g., \\\"small\\\", \\\"medium\\\", \\\"large\\\")\",\"children\":[]}],\"functionName\":\"getThumbnailURL\",\"snippetContent\":\"getThumbnailURL(${1:format});\"},\"getURL\":{\"!type\":\"fn() -> string\",\"!doc\":\"Returns the URL for this record.\",\"!url\":\"https://docs.appivo.com/apis/record/#geturl\",\"returnType\":\"string\",\"returnDescription\":\"The URL pointing to this record's resource\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"getURL\",\"snippetContent\":\"getURL();\"},\"isComplete\":{\"!type\":\"fn() -> bool\",\"!doc\":\"Checks if the record has all necessary data loaded.\",\"!url\":\"https://docs.appivo.com/apis/record/#iscomplete\",\"returnType\":\"boolean\",\"returnDescription\":\"True if the record is complete, false otherwise\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"isComplete\",\"snippetContent\":\"isComplete();\"},\"load\":{\"!type\":\"fn() -> Promise\",\"!doc\":\"Download the contents of this document.\",\"!url\":\"https://docs.appivo.com/apis/record/#load\",\"returnType\":\"Promise\",\"returnDescription\":\"A promise that resolves with the document content\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"load\",\"snippetContent\":\"load();\"},\"loadRelations\":{\"!type\":\"fn(relations: string, opts: object) -> Promise\",\"!doc\":\"Loads related records by relation path.\",\"!url\":\"https://docs.appivo.com/apis/record/#loadrelations\",\"returnType\":\"Promise\",\"returnDescription\":\"A promise that resolves when relations are loaded\",\"parameterSignature\":[{\"type\":\"string\",\"name\":\"relations\",\"description\":\"Comma-separated list or array of relation-paths to load\"},{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options for loading relations\"}],\"parameterStructure\":[{\"type\":\"string\",\"name\":\"relations\",\"description\":\"Comma-separated list or array of relation-paths to load\",\"children\":[]},{\"type\":\"Object\",\"name\":\"opts\",\"description\":\"Options for loading relations\",\"children\":[]}],\"functionName\":\"loadRelations\",\"snippetContent\":\"loadRelations(${1:relations}, ${2:{}});\"},\"observe\":{\"!type\":\"fn(callback: Function) -> obj\",\"!doc\":\"Observe remote changes on this record.\",\"!url\":\"https://docs.appivo.com/apis/record/#observe\",\"returnType\":\"Object\",\"returnDescription\":\"A handle with a close() method to stop observing\",\"parameterSignature\":[{\"type\":\"Function\",\"name\":\"callback\",\"description\":\"Function to invoke when the record is changed\"}],\"parameterStructure\":[{\"type\":\"Function\",\"name\":\"callback\",\"description\":\"Function to invoke when the record is changed\",\"children\":[]}],\"functionName\":\"observe\",\"snippetContent\":\"observe(${1:function(){ /* body... */ }});\"},\"remove\":{\"!type\":\"fn([opts]: object, [opts.force]: boolean, [opts.onSuccess]: Function, [opts.onError]: Function) -> Promise\",\"!doc\":\"Removes a record from the database.\",\"!url\":\"https://docs.appivo.com/apis/record/#remove\",\"returnType\":\"Promise\",\"returnDescription\":\"A promise that resolves when the record is removed\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"[opts]\",\"description\":\"Configuration options\"},{\"type\":\"boolean\",\"name\":\"[opts.force]\",\"description\":\"If true, forces deletion even if the record is referenced by others\"},{\"type\":\"Function\",\"name\":\"[opts.onSuccess]\",\"description\":\"Callback when the operation was successful\"},{\"type\":\"Function\",\"name\":\"[opts.onError]\",\"description\":\"Callback when the operation resulted in an error\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"[opts]\",\"description\":\"Configuration options\",\"children\":[]},{\"type\":\"boolean\",\"name\":\"[opts.force]\",\"description\":\"If true, forces deletion even if the record is referenced by others\",\"children\":[]},{\"type\":\"Function\",\"name\":\"[opts.onSuccess]\",\"description\":\"Callback when the operation was successful\",\"children\":[]},{\"type\":\"Function\",\"name\":\"[opts.onError]\",\"description\":\"Callback when the operation resulted in an error\",\"children\":[]}],\"functionName\":\"remove\",\"snippetContent\":\"remove(${1:{}});\"},\"reset\":{\"!type\":\"fn()\",\"!doc\":\"Resets the record to its default values.\",\"!url\":\"https://docs.appivo.com/apis/record/#reset\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"reset\",\"snippetContent\":\"reset();\"},\"save\":{\"!type\":\"fn(check: boolean, options: object) -> Promise\",\"!doc\":\"Saves this record to the data store.\",\"!url\":\"https://docs.appivo.com/apis/record/#save\",\"returnType\":\"Promise\",\"returnDescription\":\"A promise that resolves with the saved record\",\"parameterSignature\":[{\"type\":\"boolean\",\"name\":\"check\",\"description\":\"If true, checks if the record exists before saving\"},{\"type\":\"Object\",\"name\":\"options\",\"description\":\"Options for saving\"}],\"parameterStructure\":[{\"type\":\"boolean\",\"name\":\"check\",\"description\":\"If true, checks if the record exists before saving\",\"children\":[]},{\"type\":\"Object\",\"name\":\"options\",\"description\":\"Options for saving\",\"children\":[{\"type\":\"Object\",\"name\":\"headers\",\"description\":\"HTTP headers to include with the save request\"},{\"type\":\"boolean\",\"name\":\"sync\",\"description\":\"If true, synchronizes the record with the backend\"}]}],\"functionName\":\"save\",\"snippetContent\":\"save(${1:check}, {\\n\\t'headers' :{}, \\n\\t'sync' : ${2:false}\\n});\"},\"setJsonProperty\":{\"!type\":\"fn(attr: string, path: string, value: *) -> obj\",\"!doc\":\"Sets a property in a JSON attribute by path.\",\"!url\":\"https://docs.appivo.com/apis/record/#setjsonproperty\",\"returnType\":\"Object\",\"returnDescription\":\"The updated JSON object\",\"parameterSignature\":[{\"type\":\"string\",\"name\":\"attr\",\"description\":\"The attribute name containing JSON data\"},{\"type\":\"string\",\"name\":\"path\",\"description\":\"The path to the property within the JSON object\"},{\"type\":\"*\",\"name\":\"value\",\"description\":\"The value to set\"}],\"parameterStructure\":[{\"type\":\"string\",\"name\":\"attr\",\"description\":\"The attribute name containing JSON data\",\"children\":[]},{\"type\":\"string\",\"name\":\"path\",\"description\":\"The path to the property within the JSON object\",\"children\":[]},{\"type\":\"*\",\"name\":\"value\",\"description\":\"The value to set\",\"children\":[]}],\"functionName\":\"setJsonProperty\",\"snippetContent\":\"setJsonProperty(${1:attr}, ${2:path}, ${3:value});\"},\"sync\":{\"!type\":\"fn([opts]: object) -> Promise\",\"!doc\":\"Synchronizes this record with the backend and deletes it from offline storage.\",\"!url\":\"https://docs.appivo.com/apis/record/#sync\",\"returnType\":\"Promise\",\"returnDescription\":\"A promise that resolves when synchronization is complete\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"[opts]\",\"description\":\"Options for the synchronization\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"[opts]\",\"description\":\"Options for the synchronization\",\"children\":[]}],\"functionName\":\"sync\",\"snippetContent\":\"sync(${1:{}});\"},\"toJSON\":{\"!type\":\"fn([opts]: object, [opts.loose=false]: boolean, [opts.resolve=true]: boolean, [opts.includeLabels=false]: boolean) -> obj\",\"!doc\":\"Creates a JSON representation of the record.\",\"!url\":\"https://docs.appivo.com/apis/record/#tojson\",\"returnType\":\"Object\",\"returnDescription\":\"The record as a JSON object\",\"parameterSignature\":[{\"type\":\"Object\",\"name\":\"[opts]\",\"description\":\"Options for JSON conversion\"},{\"type\":\"boolean\",\"name\":\"[opts.loose=false]\",\"description\":\"If true, includes all properties; if false, only includes model attributes and relationships\"},{\"type\":\"boolean\",\"name\":\"[opts.resolve=true]\",\"description\":\"If true, resolves circular references\"},{\"type\":\"boolean\",\"name\":\"[opts.includeLabels=false]\",\"description\":\"If true, includes label fields for foreign keys\"}],\"parameterStructure\":[{\"type\":\"Object\",\"name\":\"[opts]\",\"description\":\"Options for JSON conversion\",\"children\":[]},{\"type\":\"boolean\",\"name\":\"[opts.loose=false]\",\"description\":\"If true, includes all properties; if false, only includes model attributes and relationships\",\"children\":[]},{\"type\":\"boolean\",\"name\":\"[opts.resolve=true]\",\"description\":\"If true, resolves circular references\",\"children\":[]},{\"type\":\"boolean\",\"name\":\"[opts.includeLabels=false]\",\"description\":\"If true, includes label fields for foreign keys\",\"children\":[]}],\"functionName\":\"toJSON\",\"snippetContent\":\"toJSON(${1:{}});\"}},\"Consumer\":{\"!name\":\"Consumer\",\"close\":{\"!type\":\"fn()\",\"!doc\":\"Close the consumer\",\"!url\":\"https://docs.appivo.com/apis/consumer/#close\",\"parameterSignature\":[],\"parameterStructure\":[],\"functionName\":\"close\",\"snippetContent\":\"close();\"}},\"Bus\":{\"!name\":\"Bus\",\"publish\":{\"!type\":\"fn(topic: string, message: object, options: object)\",\"!doc\":\"Publish a message\",\"!url\":\"https://docs.appivo.com/apis/bus/#publish\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"topic\",\"description\":\"The topic to which you want to publish your message\"},{\"type\":\"Object\",\"name\":\"message\",\"description\":\"The message to publish\"},{\"type\":\"Object\",\"name\":\"options\",\"description\":\"options\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"topic\",\"description\":\"The topic to which you want to publish your message\",\"children\":[]},{\"type\":\"Object\",\"name\":\"message\",\"description\":\"The message to publish\",\"children\":[]},{\"type\":\"Object\",\"name\":\"options\",\"description\":\"options\",\"children\":[{\"type\":\"Object\",\"name\":\"headers\",\"description\":\"Message-headers\"}]}],\"functionName\":\"publish\",\"snippetContent\":\"publish(${1:topic}, ${2:{}}, ${3:{\\n\\t'headers' :{}}\\n});\"},\"subscribe\":{\"!type\":\"fn(topic: string, callback: Function, options: object) -> Consumer\",\"!doc\":\"Subscribe to a messaging-topic\",\"!url\":\"https://docs.appivo.com/apis/bus/#subscribe\",\"returnType\":\"Consumer\",\"returnDescription\":\"\",\"parameterSignature\":[{\"type\":\"String\",\"name\":\"topic\",\"description\":\"The topic to which you want to subscribe\"},{\"type\":\"Function\",\"name\":\"callback\",\"description\":\"function to be called when a message arrives\"},{\"type\":\"Object\",\"name\":\"options\",\"description\":\"options\"}],\"parameterStructure\":[{\"type\":\"String\",\"name\":\"topic\",\"description\":\"The topic to which you want to subscribe\",\"children\":[]},{\"type\":\"Function\",\"name\":\"callback\",\"description\":\"function to be called when a message arrives\",\"children\":[]},{\"type\":\"Object\",\"name\":\"options\",\"description\":\"options\",\"children\":[]}],\"functionName\":\"subscribe\",\"snippetContent\":\"subscribe(${1:topic}, ${2:function(){ /* body... */ }}, ${3:{}});\"}}},\"context\":{\"!name\":\"context\"}}",
'url:appivo/vue/html/CodeEditor.html':"<div class=\"code-editor-container sl-theme-dark\" style=\"position: relative; color: #b9b9b9\">\n    <div v-el:editor class=\"code-editor\" style=\"font-size: 1.1em; flex-grow: 4; min-width: 500px; height: 100%;\"\n        v-on:keyup.delete=\"onKeyUpDelete\"></div>\n    <div v-show=\"showRuntimeErrorHelp\" class=\"runtime-help-container\">\n        <span style=\"display: flex; justify-content: space-between; padding: 15px 20px;\">\n            <h3>AI code suggestion</h3>\n            <span @click=\"showRuntimeErrorHelp = false\" class=\"runtime-help-close\">\n                <i class=\"ion-close-circled\"></i>\n            </span>\n        </span>\n        <hr>\n        <div v-el:runtimehelp class=\"runtime-help\"></div>\n    </div>\n    <sl-drawer class=\"ai-chat\" label=\"AI chat\" contained style=\"--size: 50%; --sl-panel-background-color: hsl(75deg 8.89% 17.65%);\">\n        <div style=\"width: 100%; height: 100%; border-radius: 4px; border: 1px solid #343434; display: flex; overflow: auto; border-left: 0; border-right: 0;\">\n            <div class=\"chat-container\">\n                <div v-for=\"message in assistantChat\" :class=\"{'animated': true, 'animate__fadeIn': true, 'chat-message': true, user: message.from == 'user'}\">\n                    <div class=\"chat-bubble\" v-if=\"message.message\">{{ message.message }}</div>\n                    <div class=\"chat-bubble\" v-if=\"message.code\" style=\"width: 80%; white-space: initial;\">\n                        <sl-tab-group>\n                            <sl-tab slot=\"nav\" panel=\"code\">Code</sl-tab>\n                            <sl-tab slot=\"nav\" panel=\"preview\">Preview</sl-tab>\n\n                            <sl-tab-panel name=\"code\">\n                                <small>Code snippet</small>\n                                <pre style=\"padding: 10px; overflow: auto; color: white; user-select: all;\"><code> {{ message.code }} </code></pre>\n                            </sl-tab-panel>\n                            <sl-tab-panel name=\"preview\" style=\"min-height: 340px; background: #eee; border-radius: 10px; margin-top: 10px; padding: 10px;\">\n                                <appivo-inline :html=\"message.preview\" style=\"all: initial; font-family: 'Ubuntu'\"></appivo-inline>\n                            </sl-tab-panel>\n                        </sl-tab-group>\n                        <sl-button size=\"small\" style=\"width: 70px; margin-top: 10px;\" @click=\"insert(message.code)\">\n                            <sl-icon name=\"arrow-left-square\" slot=\"prefix\"></sl-icon>\n                            insert\n                        </sl-button>\n                    </div>\n                </div>\n                <div class=\"dots\" v-if=\"showDots\">\n                    <span class=\"dot\"></span>\n                    <span class=\"dot\"></span>\n                    <span class=\"dot\"></span>\n                </div>\n            </div>\n        </div>\n        <div slot=\"footer\" style=\"display: flex; gap: 3px; width: 100%;\">\n            <sl-textarea id=\"ai-prompt\" style=\"width: 100%; min-height: 60px;\" resize=\"none\" rows=\"4\" placeholder=\"Ask Appivo AI\"></sl-textarea>\n            <br>\n            <div style=\"display: flex; width: 205px; flex-direction: column; gap: 6px; align-items: flex-start;\">\n                <sl-button @click=\"askAi\" style=\"width: 100%;\" size=\"small\">\n                    <sl-icon slot=\"prefix\" name=\"send-fill\"></sl-icon>\n                    Ask\n                </sl-button>\n                <sl-select clearable style=\"width: 100%;\" size=\"small\" placeholder=\"Model to template\" id=\"template-model\" placement=\"top\">\n                    <small>Models</small>\n                    <sl-option v-for=\"model in templateModels\" :value=\"'model__'+model.name\">{{ model.name }}</sl-option>\n                    <small>Queries</small>\n                    <sl-option v-for=\"query in templateQueries\" :value=\"'query__'+query.name\">{{ query.name }}</sl-option>\n                </sl-select>\n                <sl-checkbox id=\"template-model-is-array\" size=\"small\">Treat as array</sl-checkbox>\n            </div>\n        </div>\n    </sl-drawer>\n    <sl-drawer class=\"code-preview\" contained style=\"--size: 50%; --sl-panel-background-color: hsl(75deg 8.89% 17.65%);\">\n        <div slot=\"label\" style=\"display: flex; justify-content: space-between; align-items: center;\">\n            <p style=\"margin: 0;\">Preview</p>\n            <div>\n                <sl-select id=\"preview-model\" clearable placeholder=\"Handlebars data\">\n                    <small>Models</small>\n                    <sl-option v-for=\"model in templateModels\" :value=\"'model__'+model.name\">{{ model.name }}</sl-option>\n                    <small>Queries</small>\n                    <sl-option v-for=\"query in templateQueries\" :value=\"'query__'+query.name\">{{ query.name }}</sl-option>\n                </sl-select>\n                <sl-checkbox id=\"preview-is-array\" size=\"small\">Treat as array</sl-checkbox>\n            </div>\n        </div>\n        <div style=\"padding: 10px; margin: 10px; border: 1px solid #1e1e20; border-radius: 10px; background: white; min-height: 260px; max-height: 50vh; overflow: auto;\">\n            <appivo-inline id=\"code-preview\" style=\"all: initial; font-family: 'Ubuntu';\"></appivo-inline>\n        </div>\n    </sl-drawer>\n</div>\n<style>\n\n    /* .ai-preview::part(header) {\n        padding: ;\n    } */\n\n    .ai-chat::part(body) {\n        padding: 0;\n    }\n\n    .chat-container {\n        width: 100%;\n        margin-top: auto;\n        padding: 20px;\n        display: flex;\n        flex-direction: column-reverse;\n        position: relative;\n    }\n\n    .chat-message {\n        display: flex;\n        margin-bottom: 10px;\n    }\n\n    .chat-message.user {\n        justify-content: flex-end;\n    }\n\n    .chat-bubble {\n        background-color: #1f1f21;\n        color: #d8d8d8;\n        padding: 10px;\n        border-radius: 15px 15px 15px 5px;\n        max-width: 70%;\n        white-space: pre-line;\n        display: flex;\n        flex-direction: column;\n    }\n\n    .user .chat-bubble {\n        border-radius: 15px 15px 5px 15px;\n    }\n\n    .chat-message.user .chat-bubble {\n        background-color: #007bff;\n        color: white;\n    }\n\n    .dots {\n        position: absolute;\n        left: 20px;\n        bottom: 20px;\n        width: 100px;\n    }\n\n    .dots .dot {\n        display: inline-block;\n        width: 8px;\n        height: 8px;\n        border-radius: 100px;\n        margin-right: 3px;\n        background: #ffffff91;\n        animation: wave 1.3s ease infinite;\n    }\n    .dots .dot:nth-child(2) {\n        animation-delay: -1.1s;\n    }\n\n    .dots .dot:nth-child(3) {\n        animation-delay: -0.9s;\n    }\n\n    @keyframes wave {\n        0%, 60%, 100% {\n            transform: initial;\n        }\n\n        30% {\n            transform: translateY(-15px);\n        }\n    }\n</style>\n\n<link rel=\"stylesheet\" href=\"https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.20.1/cdn/themes/dark.css\" />",
'url:appivo/vue/html/Selector.html':"<select :style=\"{ 'width': width }\">\n    <option v-if=\"nullOption\"></option>\n    <option v-for=\"value in defaultValues\" :value=\"value.id\" selected=\"selected\">{{ value.text }}</option>\n</select>\n",
'url:appivo/builder/html/MacroSelect.html':"<div>\n    <style>\n        .qa-itms.incomplete .form-control {\n            border-color: crimson;\n        }\n    </style>\n\n    <div class=\"form-group\">\n        <label>Select action</label>\n        <select class=\"form-control\" v-model=\"selectedAction\">\n            <option :value=\"null\" >{{ $t('actionQuickSelect') }}</option>\n            <option v-for=\"action in availableActions\" :value=\"action\">{{action.label}}</option>\n        </select>\n    </div>\n\n    <div class=\"panel panel-success\" v-if=\"selectedAction\">\n        <div class=\"panel-heading\">\n            <h3 class=\"panel-title green-txt\">{{selectedAction.description}} -</h3>\n        </div>\n\n        <div class=\"panel-body\">\n            <div class=\"form-group\" v-for=\"input in inputs\">\n               <div v-if=\"input.enabled\">\n\t                <label>{{input.label}}\n\t                    <template v-if=\"input.required\">\n\t                        <tooltip\n\t                            effect=\"scale\"\n\t                            placement=\"top\"\n\t                            content=\"This field is required\">\n\t                            <span style=\"color:red\">&ast;</span>\n\t                        </tooltip>\n\t                    </template>\n\t                </label>\n\t\n\t                <div class=\"qa-itms\" :class=\"(input.missing ? 'incomplete' : '')\">\n\t                    <select class=\"form-control\" v-if=\"input.type === 'SELECT'\" v-model=\"inputValue[input.name]\">\n\t                        <option :value=\"null\" v-if=\"input.optional\">{{ $t('actionQuickSelect') }}</option>\n\t                        <template v-for=\"opt in inputData[input.name]\">\n\t                            <option v-if=\"opt.divider\" disabled=\"true\">&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;</option>\n\t                            <option v-else :value=\"opt.value\">{{opt.label}}</option>\n\t                        </template>\n\t                    </select>\n\t                    <textbox v-if=\"input.type === 'TEXT'\" :value=\"inputValue[input.name]\" @update=\"updateValue(input.name, $event)\"></textbox>\n\t                    <template v-if=\"input.type === 'BOOLEAN'\">\n\t                        <input :id=\"'checkbox' + input.name\" type=\"checkbox\" v-model=\"inputValue[input.name]\">\n\t                        <label :for=\"'checkbox' + input.name\"></label>\n\t                    </template>\n\t                    <selector v-if=\"input.type === 'MULTISELECT'\" :multi-val=\"inputValue[input.name]\" :data=\"convert4selector(inputData[input.name])\" @change=\"updateValue(input.name, $arguments[0])\" id-prop=\"value\" text-prop=\"label\" :multi-select=\"true\"></selector>\n\t                </div>\n            \t</div>\n            </div>\n        </div>\n    </div>\n</div>\n",
'url:appivo/builder/html/ScriptEditor.html':"<div>\n    <template v-if=\"!mini\">\n        <div class=\"form-group\" v-if=\"hidefullscreen !== true\">\n            <label for=\"\">{{ $t('actionMethod') }}</label>\n            <select class=\"form-control\" :value=\"mode\" @change=\"updateMode($event)\">\n                <option value=\"quick\">{{ $t('actionScriptQuick') }}</option>\n                <option value=\"script\">{{ $t('actionScriptJavascript') }}</option>\n            </select>\n        </div>\n\n        <!-- Panel for QuickActions -->\n        <div class=\"panel panel-default\" v-if=\"mode === 'quick'\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title green-txt\">{{ displayMode }}: {{ $t('actionQuickHead') }} -</h3>\n            </div>\n            <div class=\"panel-body\">\n                <macroselect :env=\"env\" :value=\"code\"></macroselect>\n            </div>\n        </div>\n\n        <!-- Panel for JavaScript editor -->\n        <div class=\"panel panel-default script-editor\" :class=\"{'goFullScreen': fullscreen}\" v-if=\"mode === 'script'\">\n            <div class=\"panel-heading\">\n                <h3 class=\"panel-title\">\n                    <span v-if=\"parameters && parameters.length > 0\">\n                        {{ $t('availableParamter') }}: \n                        <span v-for=\"param in parameters\" :class=\"[ (param.description ? 'data-balloon' : '') ]\" @click=\"displayEvent(param.props)\" data-balloon-length=\"medium\" :data-balloon=\"param.description\" data-balloon-pos=\"down\" style=\"text-decoration: underline dashed #52ae32;\">\n                            <a v-if=\"param.docsPath\" target=\"_blank\" :href=\"'https://docs.appivo.com' + param.docsPath\" style=\"color: #333333; text-decoration-color: #52ae32 !important;\">{{param.name}}</a>\n                            <template v-else>{{param.name}}</template>\n                        </span>\n                    </span>\n                    \n                    <span v-else>\n                        {{ displayMode }}: {{ $t('actionScriptHead') }}\n                    </span>\n\n                    <span v-if=\"env.returns\">\n                        <span :class=\"[ (env.returns.description ? 'data-balloon' : '') ]\"   data-balloon-length=\"medium\" :data-balloon=\"env.returns.description\" data-balloon-pos=\"down\" style=\"text-decoration: underline dashed #52ae32; cursor: help; margin: 0 10px;\">\n                            This function should return {{env.returns.type}}\n                        </span>\n                    </span>\n                </h3>\n\n                <button class=\"toggleFull\" @click.stop.prevent=\"toggleFullscreen\">\n                    <span class=\"data-balloon\" data-balloon=\"Fullscreen\" data-balloon-length=\"medium\" data-balloon-pos=\"left\">\n                        <i class=\"ion-arrow-expand\"></i>\n                    </span>\n                </button>\n            </div>\n            <div class=\"panel-body\" style=\"margin: 0;\">\n                <codeeditor v-ref:code-editor :context=\"scriptContext\" :env=\"env\" :mode=\"'javascript'\" :value=\"code.script && code.script.script ? code.script.script : ''\"></codeeditor>\n                <span :style=\"{ 'width': showIssuesPane ? '40%' : '0px' }\" style=\"overflow: auto; position: absolute; top: 36px; right:0px; border-left: 1px solid rgb(221 221 221); height: calc(80vh - 330px); z-index: 1;background: white; \">\n                    <div style=\"padding: 5px\">\n                        <i class=\"ion-close\" @click=\"toggleIssuesPane\" style=\"cursor: pointer\"></i>\n                    </div>\n                    <div style=\"padding: 0px 15px;\">\n                        <template v-for=\"issue in allIssues\">\n                            <i v-if=\"issue.type === 'warning'\" class=\"ion-alert-circled yellow-txt\"></i>\n                            <i v-if=\"issue.type === 'error'\" class=\"ion-close-circled red-txt\"></i>\n                            {{issue.text}} <a class='red-txt' style=\"cursor: pointer\" @click=\"navigateToIssue(issue)\">{{ $t('scriptIssueLocation', issue) }}</a><br>\n                        </template>\n                    </div>\n                </span>\n            </div>\n            <div class=\"panel-footer script-footer\">\n                <span @click=\"beautify\" class=\"format-code\" style=\"cursor: pointer\"><i class=\"ion-code-working\"></i> Format Code</span>\n                <span v-show=\"issues.warnings.length > 0\" style=\"cursor: pointer\" @click=\"toggleIssuesPane\"><i class=\"ion-alert-circled yellow-txt\"></i>{{issues.warnings.length}} {{ $t('scriptWarnings') }}</span>\n                <span v-show=\"issues.errors.length > 0\" style=\"cursor: pointer\" @click=\"toggleIssuesPane\"><i class=\"ion-close-circled red-txt\"></i>{{issues.errors.length}} {{ $t('scriptErrors') }}</span>\n            </div>\n        </div>\n    </template>\n\n    <template v-if=\"mini\">\n        <div class=\"panel panel-default mini-scrp-edi\" :class=\"fullscreen ? 'goFullScreen' : ''\">\n            <div class=\"panel-heading \">\n                <div class=\"head-wrp\">\n                    <div class=\"itm\"><strong>{{title ? title : displayMode }}</strong></div>\n                    <div class=\"itm\">\n                        <span style=\"margin-left: 75px;\" v-if=\"env.parameters && env.parameters.length > 0\">\n                            {{ $t('availableParamter') }}:\n                            <span v-for=\"param in env.parameters\" :class=\"[ (param.description ? 'data-balloon' : '') ]\" @click=\"displayEvent(param.props)\" data-balloon-length=\"medium\" :data-balloon=\"param.description\" data-balloon-pos=\"down\" style=\"text-decoration: underline dashed #52ae32; cursor: help;margin: 0 10px;\">\n                                {{param.name}}\n                            </span>\n                        </span>\n                    </div>\n                    <div class=\"itm\">\n                        <span v-if=\"env.returns\">\n                            <span :class=\"[ (env.returns.description ? 'data-balloon' : '') ]\" data-balloon-length=\"medium\" :data-balloon=\"env.returns.description\" data-balloon-pos=\"down\" style=\"text-decoration: underline dashed #52ae32; cursor: help;margin: 0 10px;\">\n                                This function should return {{env.returns.type}}\n                            </span>\n                        </span>\n                    </div>\n                    <div class=\"itm\">\n                        <select class=\"form-control\" :value=\"mode\" @change=\"updateMode($event)\">\n                            <option value=\"quick\">{{ $t('actionScriptQuick') }}</option>\n                            <option value=\"logic\">{{ $t('actionScriptBlockly') }}</option>\n                            <option value=\"script\">{{ $t('actionScriptJavascript') }}</option>\n                        </select>\n                    </div>\n                    <div class=\"itm text-right\">\n                        <div class=\"toggleFull-2\" @click.stop.prevent=\"toggleFullscreen\">\n                            <i class=\"ion-arrow-expand green-txt\" style=\"font-size: 1.5em; vertical-align: middle; margin-right: 5px;\"></i>\n                            <span class=\"txt-upcase\">{{ $t('fullScreenMode') }}</span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"panel-body\" v-if=\"mode === 'script'\" style=\"padding: 0 !important;\">\n                <codeeditor v-ref:code-editor :env=\"env\" :mode=\"'javascript'\" :fullscreen=\"fullscreen\" :value=\"code.script && code.script.script ? code.script.script : ''\"></codeeditor>\n            </div>\n            <div class=\"panel-body\" v-if=\"mode === 'quick'\">\n                <macroselect :env=\"env\" :value=\"code\"></macroselect>\n            </div>\n            <div class=\"panel-body\" v-if=\"mode === 'logic'\">\n                <blockly :fullscreen=\"fullscreen\" :value=\"code\" :env=\"env\"></blockly>\n            </div>\n        </div>\n    </template>\n\n    <modal :show.sync=\"showParameterInfo\" effect=\"fade\" @input.stop.prevent=\"\">\n        <div slot=\"modal-header\" class=\"modal-header\">\n            <h4 class=\"modal-title\">{{ $t('availableProperties') }}</h4>\n            <button @click=\"removeParameterInfo\" class=\"close\">\n                <svg viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M24 8L8 24\" stroke=\"#383838\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M8 8L24 24\" stroke=\"#383838\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>\n            </button>\n        </div>\n        <div slot=\"modal-body\" class=\"modal-body\">\n            <table class=\"table table-hover\" >\n                <thead>\n                    <tr>\n                        <th>{{ $t('parameterName')}}</th>\n                        <th>{{ $t('parameterDataType')}}</th>\n                        <th>{{ $t('parameterDescription')}}</th>\n                    </tr>\n                </thead>\n                <tbody>\n                    <tr v-for=\"item in toDisplay\">\n                        <td>{{item.name}}</td>\n                        <td>{{item.dataType}}</td>\n                        <td>{{item.description}}</td>\n                    </tr>\n                </tbody>\n            </table>\n        </div>\n        <div slot=\"modal-footer\" class=\"modal-footer\">\n            <button class=\"btn btn-danger btn-sm\" @click.stop.prevent=\"removeParameterInfo\">{{ $t('cancel') }}</button>\n            <button class=\"btn btn-success btn-sm\" @click.stop.prevent=\"removeParameterInfo\">{{ $t('ok') }}</button>\n        </div>\n    </modal>\n</div>\n",
'url:appivo/vue/html/InlineTextBox.html':"<span class=\"inlineEditWrap\"> <!-- @dblclick -->\n  <span v-if=\"!editing && !disabled\" @click=\"toggleEdit(true)\" title=\"Click to edit\" :style=\"\" :maxlength=\"maxLength\" :class=\"displayClasses\" class=\"txt\">\n  \t{{displayValue}}\n  \t<span class=\"edit-icon\"><i class=\"flaticon-edit\"></i></span>\n  </span>\n  <span v-if=\"!editing && disabled\" :style=\"\" :maxlength=\"maxLength\" :class=\"displayClasses\" :class=\"txt\">\n      {{displayValue}}\n  </span>\n  \n  <input v-el:input :disabled=\"disabled\" :style=\"\" :class=\"internalClasses\" class=\"inlineEdit\" v-if=\"editing\" type=\"text\" :value=\"value\" @blur=\"toggleEdit(false)\" @keyup.13=\"removeFocus()\" @input=\"validate\" lazy placeholder=\"Enter here\">\n  <span class=\"error\" :class=\"[internalClasses, errorposition]\">\n    <i class=\"ion-alert-circled\"></i>&nbsp;{{validationError}}\n  </span>\n</span>\n\n",
'url:appivo/builder/html/CodeDialog.html':"<dialogframe :headerheight=\"'auto'\" :footerheight=\"'auto'\" :fullscreen=\"fullscreen\" :width=\"dialogWidth\" :class=\"['codeEditorDialog', codemode]\">\n \t<template slot=\"header\">\n\t\t<div class=\"heading-container\">\n\t\t\t<h3 class=\"h3\">{{ title ? $t(title) : $t('CodeEditor') }}</h3>\n\t\t\t<div v-if=\"itemname\" class=\"h5 editor-heading\">\n\t\t\t\t<i :class=\"itemicon ? itemicon : 'ion-code orange-txt'\"></i>\n\t\t\t\t{{ itemtype ? $t(itemtype) : $t('CodeEditorFunction') }}\n\t\t\t\t<inlinetextbox classes=\"green-txt\" :value=\"itemname\" @update=\"updateItemName($event)\" :validation=\"itemvalidation\"></inlinetextbox>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<select class=\"form-control\" v-model=\"codemode\">\n\t\t\t<option value=\"quick\" >{{ $t('actionScriptQuick') }}</option>\n\t\t\t<option value=\"script\">{{ $t('actionScriptJavascript') }}</option>\n\t\t</select>\n\n\t\t<button v-if=\"codemode !== 'quick'\" class=\"toggle-full\" @click=\"toggleFullScreen\">\n\t\t\t<i class=\"ion-arrow-expand\"></i>\n\t\t</button>\n\n\t\t<div class=\"button-container\">\n\t\t\t<button class=\"btn btn-danger btn-sm\" @click.stop.prevent=\"cancel\">{{ $t('cancel') }}</button>\n\t\t\t<button class=\"btn btn-success btn-sm\" @click.stop.prevent=\"ok\">{{ $t('save') }}</button>\n\t\t</div>\n \t</template>\n\n \t<template slot=\"main\">\n   \t\t<scripteditor v-ref:script-editor :env=\"env\" :data=\"code\" :hidefullscreen=\"true\" :mode.sync=\"codemode\"></scripteditor>\n \t</template>\n</dialogframe>\n",
'url:appivo/vue/html/AlertBox.html':"<div :isOpen.sync=\"isOpen\" class=\"alert-errors\" :class=\"[position, isOpen ? 'open-alert' : 'closed-alert', { 'mobile-alert' : isMobile}]\"\nv-if=\"isOpen\" transition=\"fade\">\n\n\t<div class=\"alert-box danger animated\" :class=\"[isMobile ? 'bounceInUp' : 'fadeInUp']\" v-if=\"type== 'danger'\">\n\t\t<div class=\"alert-close\" @click=\"closeAlert\"><span class=\"closed\">x</span></div>\n\t\t<div class=\"wrap\">\n\t\t\t<div class=\"alert-icon\">\n\t\t\t\t<i class=\"ion-android-alert\"></i>\n\t\t\t</div>\n\t\t\t<div class=\"alert-content\">\n\n\t\t\t\t<div class=\"alert-title\">\n\t\t\t\t\t<strong v-if=\"alertTitle\">{{ alertTitle }}</strong>\n\t\t\t\t\t<strong v-else>{{ $t('errormsg') }}</strong>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"alert-txt\">\n\t\t\t\t \t<ul class=\"error-list\">\n\t\t\t\t \t\t<li>\n\t\t\t\t \t\t\t<input type=\"checkbox\" id=\"chain1\" v-model=\"chain1\" checked>\n\t\t \t\t\t\t\t<label for=\"chain1\"><span v-show=\"!chain1\">Show</span><span v-show=\"chain1\">{{ $t('hide') }}</span><span class=\"caret\"></span></label>\n\t\t\t\t \t\t\t<div class=\"error-box\" v-show=\"chain1\" transition=\"fade\">\n\t\t\t\t \t\t\t\t<div class=\"msg\" v-if=\"errorObject.errorMessage == null\"><strong>{{ $t('message') }}</strong>: {{ errorObject }}</div>\n\t\t\t\t \t\t\t\t<div class=\"msg\" v-else><strong>{{ $t('message') }}</strong>: {{ errorObject.errorMessage }}</div>\n\t\t\t\t \t\t\t</div>\n\t\t\t\t \t\t</li>\n\n\t\t\t\t \t\t<li v-if=\"errorObject.errorMessage != null\">\n\t\t\t\t \t\t\t<input type=\"checkbox\" id=\"chain2\" v-model=\"chain2\">\n\t\t \t\t\t\t\t<label for=\"chain2\" v-if=\"nextErrorMsgs.length > 1\"><span v-show=\"!chain2\">{{ $t('show') }}</span><span v-show=\"chain2\">{{ $t('hide') }}</span> {{ $t('moredetails') }}<span class=\"caret\"></span></label>\n\n\t\t \t\t\t\t\t<div class=\"error-box\" v-show=\"chain2\" transition=\"fade\">\n\t\t \t\t\t\t\t\t<div class=\"msg\" v-for=\"( index,item) in nextErrorMsgs\"> {{ item }}</div>\n\t\t \t\t\t\t\t</div>\n\t\t \t\t\t\t</li>\n\t\t\t\t \t</ul>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\t\n\n\t<div class=\"alert-box success animated\" :class=\"[isMobile ? 'slideInUp' : 'fadeInUp']\" v-if=\"type== 'success'\" >\n\t\t<div class=\"alert-close\" @click=\"closeAlert\"><span class=\"closed\">x</span></div>\n\t\t<div class=\"wrap\">\n\t\t\t<div class=\"alert-icon\">\n\t\t\t\t<i class=\"ion-checkmark-circled\"></i>\n\t\t\t</div>\n\t\t\t<div class=\"alert-content\">\n\t\t\t\t<div class=\"alert-title\">\n\t\t\t\t\t<strong>{{ $t('success') }}</strong> \n\t\t\t\t</div>\n\t\t\t\t<div class=\"alert-txt\">\n\t\t\t\t\t{{ message }}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\t\n\t\n\t<div class=\"alert-box warning animated\" :class=\"[isMobile ? 'slideInUp' : 'fadeInUp']\" v-if=\"type== 'warning'\" >\n\t\t<div class=\"alert-close\" @click=\"closeAlert\"><span class=\"closed\">x</span></div>\n\t\t<div class=\"wrap\">\n\t\t\t<div class=\"alert-icon\">\n\t\t\t\t<i class=\"ion-android-warning\"></i>\n\t\t\t</div>\n\t\t\t<div class=\"alert-content\">\n\t\t\t\t<div class=\"alert-title\">\n\t\t\t\t\t<strong>{{ $t('warning') }}</strong>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"alert-txt\">\n\t\t\t\t\t\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n</div>",
'url:appivo/theme/css/theme.txt':"{{#if loadMobile}}\n    /********************************************************\n    Only mobile styles\n    ********************************************************/\n\n    /*********** Mobile Heading font styles */\n\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .appivoui .ap-MText-h1,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .appivoui .ap-MText-h2,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .appivoui .ap-MText-h3, \n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .appivoui .ap-MText-h4  {\n        font-family: {{headingfontfamily}};\n        font-weight:{{headingFontWeight}};\n        font-style:{{headingFontStyle}};\n        {{#if isPageThemeDark}}\n            color: {{headingFontLightColor}};\n        {{else}}\n            color: {{headingfontcolor}};\n        {{/if}}\n    }\n\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .appivoui .ap-MText-h1 {\n        font-size: {{heading1size}}px;\n    }\n\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .appivoui .ap-MText-h2 {\n        font-size: {{heading2size}}px;\n    }\n\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .appivoui .ap-MText-h3 {\n        font-size: {{heading3size}}px;\n    }\n\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .appivoui .ap-MText-h4 {\n        font-size: {{heading4size}}px;\n    }\n\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .appivoui .ap-MText-paragraph {\n        {{#if isPageThemeDark}}\n            color: {{bodyFontLightColor}};\n        {{else}}\n            color: {{bodyfontcolor}};\n        {{/if}}\n    }\n\n    /************ Mobile base theme variables on widgets **/\n    /*for heading Mobile header*/\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-MHeading.bar-none {\n        {{#if primaryColor}}\n            background: {{primaryColor}};\n            border-color: {{primaryColor}};\n        {{/if}}\n        {{#if headingfontfamily}}\n            font-family: {{headingfontfamily}};\n            font-weight: {{headingFontWeight}}\n        {{/if}}\n    }\n\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-MHeading.bar-none > .title ,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-MHeading.bar-none > .buttons .button {\n        {{#if headingFontLightColor}}\n            color: {{headingFontLightColor}};\n        {{/if}}\n        {{#if headingfontfamily}}\n            font-family: inherit;\n            font-weight: inherit;\n        {{/if}}\n    }\n\n    /*For default tab bar using header styles of bg and color*/\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-MTabBar > .tabs {\n        background-color: {{primaryColor}};\n        background-image: none;\n        color: {{headingFontLightColor}};\n    }\n\n    {{#if accentcolor}}\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-MTabBar > .tabs .tab-item.active {\n            color: {{accentcolor}};\n            border-color: {{accentcolor}};\n        }\n    {{/if}}\n\n    /*for button*/\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-MButton.button-none {\n        {{#if buttonDefaultBgColor}}\n            background-color: {{buttonDefaultBgColor}};\n        {{/if}}\n\n        {{#if buttonDefaultTextColor}}\n            color: {{buttonDefaultTextColor}};\n        {{/if}}\n\n        font-family: inherit;\n        font-weight: {{bodyFontWeight}};\n    }\n\n    {{#if buttonDefaultBgColor}}\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-MButton.button-none.button-outline {\n            border-color: {{buttonDefaultBgColor}};\n            color: {{buttonDefaultBgColor}};\n            background-color: transparent;\n        }\n\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-MButton.button-none.button-outline.activated {\n            background-color: {{buttonDefaultBgColor}};\n            color: #fff;\n        }\n    {{/if}}\n\n    {{#if accentcolor}}\n        /*for switch buttons*/\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-MSwitch label[class=\"toggle\"] input:checked + .track {\n            border-color: {{accentcolor}};\n            background-color: {{accentcolor}};\n        }\n\n        /*for range slider*/\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-MRange .icon {\n            color: {{accentcolor}};\n        }\n    {{/if}}\n\n    /***********for mobile side menu **/\n    {{#if primaryColor}}\n        .ap-MListMenuWidget-topbar{\n            background-color: {{primaryColor}};\n        }\n        .ap-MView.pane#RootMenu {\n            background: {{primaryColor}};\n        }\n    {{/if}}\n    {{#if accentcolor}}\n        .ap-MListMenuWidget .MListMenuItem .item-icon-left > .icon {\n            color: {{accentcolor}};\n        }\n    {{/if}}\n\n    /**********for mobile datetime/option selector widget - presently only on mobile */\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .date-time-selector-wrapper {\n        {{#if isPageThemeDark}}\n            color: {{bodyFontLightColor}};\n        {{else}}\n            color: {{bodyfontcolor}};\n        {{/if}}\n    }\n\n    {{#if accentcolor}}\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .date-time-selector-wrapper .item-wrapper .item-container.selected-item {\n            border-color: {{accentcolor}};\n        }\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .date-time-selector-wrapper .picker-wrap.slick-slider .slick-prev:before,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .date-time-selector-wrapper .picker-wrap.slick-slider .slick-next:before {\n            color: {{accentcolor}};\n        }\n    {{/if}}\n\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .date-time-selector-wrapper .item-wrapper .item-container.selected-item,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .date-time-selector-wrapper .picker-wrap-disabled .item-wrapper .item-container.selected-item {\n        {{#if accentcolor}}\n            background-color: {{accentcolor}};\n        {{else}}\n            background-color: #50af31;\n        {{/if}}\n    }\n\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .date-time-selector-wrapper .picker-wrap-disabled .item-wrapper .item-container {\n        background-color: rgba(0,0,0,0.2);\n    }\n\n    {{#if pageBgOffsetColor}}\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .date-time-selector-wrapper .item-wrapper .item-container {\n            background-color: {{pageBgOffsetColor}};\n        }\n    {{/if}}\n\n    /***** For focusable widgets *****/\n    {{#if focusBorderColor}}\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-MTextField.dijitFocused,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-MNumberField.dijitFocused,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-MDateField.dijitFocused,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-MTimeField.dijitFocused,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-MTextArea.dijitFocused,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-MSelect.dijitFocused,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-Select2 .select2-container--focus .select2-selection,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-MCheckBox.dijitFocused,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} button.button-none:focus {\n            border-color: {{focusBorderColor}};\n        }\n    {{/if}}\n\n    {{#if focusBoxShadow}}\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-MTextField.dijitFocused,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-MNumberField.dijitFocused,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-MDateField.dijitFocused,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-MTimeField.dijitFocused,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-MTextArea.dijitFocused,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-MSelect.dijitFocused,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-Select2 .select2-container--focus,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-MCheckBox.dijitFocused,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} button.button-none:focus {\n            box-shadow: {{focusBoxShadow}};\n        }\n    {{/if}}\n{{else}}\n\n    /********************************************************\n    Only web styles\n    ********************************************************/\n\n    {{#if linkcolor}}\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-Link {\n            color: {{linkcolor}};\n        }\n    {{/if}}\n\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .appivoui .ap-Paragraph,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .appivoui .ap-Label,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .appivoui .ap-MenuItem,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .appivoui .ap-PopupMenu,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .appivoui .ap-GridContainer .titleBar {\n        {{#if isPageThemeDark}}\n            color: {{bodyFontLightColor}};\n        {{else}}\n            color: {{bodyfontcolor}};\n        {{/if}}\n        font-family: {{bodyfontfamily}};\n        font-size: {{bodyfontsize}}px;\n        font-weight:{{bodyFontWeight}};\n        font-style:{{bodyFontStyle}};\n    }\n\n    /***Heading font styles***/\n\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .appivoui .ap-Label-h1,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .appivoui .ap-Label-h2,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .appivoui .ap-Label-h3  {\n        font-family: {{headingfontfamily}};\n        font-weight: {{headingFontWeight}};\n        font-style: {{headingFontStyle}};\n        {{#if isPageThemeDark}}\n            color: {{headingFontLightColor}};\n        {{else}}\n            color: {{headingfontcolor}};\n        {{/if}}\n    }\n\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .appivoui .ap-Label.ap-Label-h1 {\n        font-size: {{heading1size}}px;\n    }\n\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .appivoui .ap-Label.ap-Label-h2 {\n        font-size: {{heading2size}}px;\n    }\n\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .appivoui .ap-Label.ap-Label-h3 {\n        font-size: {{heading3size}}px;\n    }\n\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .appivoui .ap-Label.ap-Label-fl {\n        {{#if formLabelColor}}\n            color: {{formLabelColor}};\n        {{/if}}\n        {{#if formLabelTextCase}}\n            text-transform: {{formLabelTextCase}};\n        {{/if}}\n        {{#if formLabelSize}}\n            font-size: {{formLabelSize}}px;\n        {{/if}}\n        {{#if formLabelWeight}}\n            font-weight: {{formLabelWeight}};\n        {{/if}}\n    }\n\n\n    /*******Desktop accent color on widgets*********/\n\n    {{#if accentcolor}}\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DropdownButton > ul li ul li:hover a {\n            border-left-color: {{accentcolor}};\n        }\n\n        /*For navbar widget*/\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-NavigationBar.nav li.active > a,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-NavigationBar.nav li.active > a:hover  {\n            background-color: {{accentcolor}};\n        }\n\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-NavigationBar.nav li.active > a:hover:after {\n            content: \"\";\n            background: rgba(0,0,0,0.1);\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n        }\n\n        /*For verti and hori slider*/\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-VerticalSlider.dijitSlider,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-HorizontalSlider .dijitSlider{\n            color: {{accentcolor}};\n        }\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-VerticalSlider .dijitSliderBarContainerV .dijitSliderProgressBar,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-VerticalSlider .dijitSliderBumperV.dijitSliderBottomBumper {\n            background: {{accentcolor}};\n            background-image: -webkit-gradient(linear, left center, right center, color-stop(0, {{accentcolor}}), color-stop(1, {{accentcolor}}));\n        }\n\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-HorizontalSlider .dijitSliderProgressBar,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-HorizontalSlider .dijitSliderBumperH.dijitSliderLeftBumper  {\n            background-color: {{accentcolor}};\n            background-image: -webkit-gradient(linear, left center, right center, color-stop(0, {{accentcolor}}), color-stop(1, {{accentcolor}}));\n        }\n\n        /*for divider widget*/\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-Divider .divider {\n            border-color: {{accentcolor}};\n        }\n    {{/if}}\n\n    {{#if buttonDefaultBgColor}}\n        /*For buttons, dropdown buttons and buttonbar*/\n        \n        /*Only default + solid mode*/\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-Button.btn-default.btn-solid,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-ButtonBar ul.btn-default.btn-solid,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DropdownButton > ul.btn-default.btn-solid {\n            background-color: {{buttonDefaultBgColor}};\n            color: {{buttonDefaultTextColor}};\n        }\n\n        /*Only default + outline mode*/\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-Button.btn-default.btn-outline,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-ButtonBar ul.btn-default.btn-outline,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DropdownButton > ul.btn-default.btn-outline {\n            color: {{buttonDefaultTextColor}};\n            border-color: {{buttonDefaultTextColor}};\n        }\n\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-Button.btn-default.btn-outline:hover,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-ButtonBar ul.btn-default.btn-outline:hover,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DropdownButton > ul.btn-default.btn-outline:hover {\n            color: #212529;\n        }\n    {{/if}}\n\n    /************Web tab widget**************/\n\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-TabContainer .dijitTabInner {\n        color: {{headingfontcolor}};\n    }\n\n    {{#if accentcolor}}\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-TabContainer .dijitTabInner.dijitTabChecked,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-TabContainer .dijitTabInner.dijitTabChecked.dijitTabHover {\n            background-color: {{accentcolor}};\n            border-color: {{accentcolor}};\n            color: {{accentcolor}};\n        }\n    {{/if}}\n    \n\n    /***************Desktop data grid theme-ing***************/\n    /* Rules to follow for widgets:\n    - theme.txt should have less target classes than widget.txt\n    - Eg: theme.txt = .ap-DataGrid    widget.txt = .ap-DataGrid.gridx.gridxdesktop\n    - This will give preference to widget theming over ui theming\n    **/\n\n    {{#if accentcolor }}\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid .gridxHeaderRow,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid .gridxHeaderRow .gridxHeaderRowInner,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid .gridxMain,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid .gridxBodyEmpty,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid .gridxBody,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid .gridxRow,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid .gridxRow .gridxRowTable,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid .gridxFooter .gridxBar,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid .gridxRowHeaderBody .gridxRowHeaderRow,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid .gridxRowHeaderBody {\n            background-color: transparent;\n        }\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid .gridxBody .gridxRow .gridxCell::after,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid .gridxBody .gridxRow .gridxCell .gridxCellCustom::after{\n            border-color: {{accentcolor}};\n        }\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid .gridxHeaderRow .gridxHeaderRowInner .gridxCell,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid .gridxRowHeaderHeader,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid .gridxRowHeaderHeader .gridxRowHeaderHeaderCell{\n            background-color: {{#if isPageThemeDark}} {{primaryLightColor}} {{else}} {{accentcolor}}{{/if}};\n            text-shadow: none;\n        }\n    {{/if}}\n\n    {{#if bgcolor}}\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid .gridxRow .gridxRowTable .gridxLockedCell {\n            background-color: {{bgcolor}};\n        }\n    {{/if}}\n\n    /* Data grid text setting */\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid .gridxHeaderRow .gridxHeaderRowInner .gridxCell {\n        {{#if headingFontWeight }}\n          text-shadow: none;\n          font-weight: {{headingFontWeight}};\n        {{/if}}\n        {{#if isPageThemeDark}}\n          color: {{headingFontLightColor}};\n        {{else}}\n          color: {{headingfontcolor}};\n        {{/if}}\n    }\n\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid .gridxRow .gridxCell,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid .gridxRow .gridxCell a,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid .gridxRow .gridxCell .gridxCellWidget .dijitDownArrowButton {\n        {{#if isPageThemeDark}}\n            color: {{bodyFontLightColor}};\n        {{else}}\n            color: {{bodyfontcolor}};\n        {{/if}}\n\n        {{#if tableBodyTextColor }}\n            color:  {{tableBodyTextColor}};\n        {{/if}}\n\n        {{#if bodyFontWeight }}\n            font-weight: {{bodyFontWeight}};\n        {{/if}}\n    }\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid .gridxFooter .gridxSummary .gridxCell {\n        color: {{bodyfontcolor}};\n        {{#if headingFontWeight }}\n            font-weight: {{headingFontWeight}};\n        {{/if}}\n    }\n    /* Data grid text setting end */\n\n    /* Data grid row hover color*/\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid .gridxBodyRowHoverEffect .gridxRowOver .gridxRowTable {\n        background-color: rgba(0,0,0,0.06);\n    }\n\n    /* Data grid border settings*/\n    {{#if generalBorderColor }}\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid .gridxHeaderRow,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid .gridxBody,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid[summary=\"true\"] .gridxFooter  {\n            border: 1px solid {{generalBorderColor}};\n        }\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid .gridxHeaderRow .gridxHeaderRowInner {\n            border: none;\n        }\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid .gridxRowHeaderBody {\n            border-width: 1px 0 0 1px;\n            border-style: solid;\n            border-color: {{generalBorderColor}};\n        }\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid .gridxRowHeaderBody .gridxRowHeaderRow .gridxRowHeaderCell {\n            border-bottom-color: {{generalBorderColor}};\n        }\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid .gridxRow .gridxCell {\n            border-color: {{generalBorderColor}};\n        }\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid .gridxFooter .gridxHScroller {\n            border: none;\n        }\n    {{/if}}\n\n    /************Desktop Datagrid theme-ing end**************/\n\n\n    /************Desktop Datagrid 2 theme-ing begin**************/\n    \n    {{#if accentcolor }}\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid2,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid2 .tabulator-table,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid2 .tabulator-row {\n            background: transparent;\n        }\n\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid2 .tabulator-header,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid2 .tabulator-col {\n            background-color: {{#if isPageThemeDark}} {{primaryLightColor}} {{else}} {{accentcolor}}{{/if}};\n        }\n    {{/if}}\n\n    /* Data grid text setting */\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid2 .tabulator-col {\n        {{#if headingFontWeight }}\n            font-weight: {{headingFontWeight}};\n        {{/if}}\n        {{#if isPageThemeDark}}\n            color: {{headingFontLightColor}};\n        {{else}}\n            color: {{headingfontcolor}};\n        {{/if}}\n    }\n\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid2 .tabulator-row {\n        {{#if isPageThemeDark}}\n            color: {{bodyFontLightColor}};\n        {{else}}\n            color: {{bodyfontcolor}};\n        {{/if}}\n\n        {{#if tableBodyTextColor }}\n            color: {{tableBodyTextColor}};\n        {{/if}}\n\n        {{#if bodyFontWeight }}\n            font-weight: {{bodyFontWeight}};\n        {{/if}}\n    }\n\n    /* Data grid row hover color*/\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid2 .tabulator-row:hover {\n        background-color: rgba(0,0,0,0.06);\n    }\n\n    /* Data grid border settings*/\n    {{#if generalBorderColor }}\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid2 .tabulator-header,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-DataGrid2 .tabulator-row {\n            border-color: {{generalBorderColor}};\n        }\n    {{/if}}\n\n    /************Desktop Datagrid 2 theme-ing end**************/\n\n    /***** For focusable widgets *****/\n    {{#if focusBorderColor}}\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .dijitTextBox.dijitTextBoxFocused input.dijitInputInner,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .dijitTextBox.dijitTextBoxFocused textarea.dijitTextArea,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .dijitTextBox.dijitTextBoxFocused .dijitArrowButton,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .dijitTextBox.dijitTextBoxFocused .dijitSpinnerButtonContainer,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn.btn-default:focus,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .dijitSelectFocused .dijitButtonContents,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .dijitSelectFocused .dijitArrowButton.dijitArrowButtonContainer,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .select2-container--focus .select2-selection,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-CheckBox.dijitCheckBoxFocused {\n            border-color: {{focusBorderColor}};\n        }\n    {{/if}}\n\n    {{#if focusBoxShadow}}\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .dijitFocused.dijitTextBoxFocused,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn.btn-default:focus,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .dijitSelect.dijitSelectFocused,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .select2-container--default.select2-container--focus,\n        {{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-CheckBox.dijitCheckBoxFocused {\n            box-shadow: {{focusBoxShadow}};\n        }\n    {{/if}}\n{{/if}}\n\n/********************************************************\n common styles for web and mobile\n********************************************************/\n\n{{#if wrapperClass}}{{wrapperClass}}{{/if}} .appivoui {\n  \tfont-family: {{bodyfontfamily}};\n  \tfont-size: {{bodyfontsize}}px;\n  \t{{#if bodyFontWeight}}\n        font-weight: {{bodyFontWeight}};\n    {{/if}}\n  \t{{#if bodyFontStyle}}\n        font-style: {{bodyFontStyle}};\n    {{/if}}\n    {{#compare bgoption '===' 'color'}}\n      \t{{#if bgcolor}}\n      \t    background-color: {{bgcolor}};\n      \t{{/if}}\n    {{/compare}}\n    {{#compare bgoption '===' 'image'}}\n      \t{{#if bgimage}}\n      \t    background-image: url(\"{{bgimage}}\");\n      \t    background-repeat: no-repeat;\n      \t    background-position: center center;\n      \t    background-size: cover;\n      \t    background-color: {{bgcolor}};\n      \t{{/if}}\n    {{/compare}}\n    {{#compare bgoption '===' 'gradient'}}\n      \t{{#if bggradient}}\n      \t    background-color: {{ bggradient_to }};\n      \t    background-image: linear-gradient({{ bgdirection }}, {{ bggradient_from }},{{ bggradient_to }} );\n      \t{{/if}}\n    {{/compare}}\n}\n\n/**************** App header/navbar theme **************/\n{{#unless isPageThemeDark}}\n    nav.navbar.btcf {\n        background-color: #fff;\n    }\n\n    nav.navbar.btcf ul.apmenu li > a {\n        color: #454545;\n    }\n\n    nav.navbar.btcf ul.apmenu li > a:hover {\n        background-color: rgba(0, 0, 0, 0.03);\n    }\n\n    nav.navbar.btcf .logobox .logo.logo-dark-theme {\n        display: none;\n    }\n\n    nav.navbar.btcf .logobox .logo.logo-light-theme {\n        display: inline;\n    }\n\n    nav.navbar.btcf .apmenu.right-menu li .app-profile .avatar {\n        border: 2px solid #fff;\n        box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.15);\n    }\n{{/unless}}\n\n/******** Bootstrap severity colours for multiple elements and components ********/\n\n/**** Notes ****/\n/* 1) 'e6', '80', and '66' added after colours are the alpha values in hex-color-code format */\n/* 2) 'widgetEditorDialog' class targets elements inside widget editor */\n/* 3) 'dijitMenuPopup' class targets select dropdown, intended only for elements within widget editor */\n\n\n/***** Default colour *****/\n\n{{#if defaultColor}}\n    .widgetEditorDialog .btn-default, .widgetEditorDialog .alert-dark,\n    .widgetEditorDialog .badge-light, .widgetEditorDialog .bg-light,\n    .widgetEditorDialog .list-group-item-dark,\n    #builder .dijitMenuPopup .btn-default, #builder .dijitMenuPopup .alert-dark,\n    #builder .dijitMenuPopup .badge-light, #builder .dijitMenuPopup .bg-light,\n    #builder .dijitMenuPopup .list-group-item-dark,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-default,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .alert-dark,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .badge-light,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .bg-light,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .list-group-item-dark {\n        background-color: {{defaultColor}};\n    }\n\n    .widgetEditorDialog .btn-default.btn-outline,\n    #builder .dijitMenuPopup .btn-default.btn-outline,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-default.btn-outline {\n        background-color: transparent;\n        color: {{defaultColor}};\n        border-color: {{defaultColor}};\n    }\n\n    .widgetEditorDialog .btn-default.btn-outline:hover,\n    #builder .dijitMenuPopup .btn-default.btn-outline:hover,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-default.btn-outline:hover {\n        background-color: {{defaultColor}};\n        color: #fff;\n    }\n\n    .widgetEditorDialog .btn-default.btn-light,\n    #builder .dijitMenuPopup .btn-default.btn-light,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-default.btn-light {\n        background-color: {{defaultColor}}66;\n        color: {{defaultColor}};\n    }\n\n    .widgetEditorDialog .btn-default:not(:disabled):not(.disabled):active,\n    #builder .dijitMenuPopup .btn-default:not(:disabled):not(.disabled):active,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-default:not(:disabled):not(.disabled):active {\n        background-color: {{defaultColor}}e6;\n        border-color: {{defaultColor}}e6;\n    }\n\n    .widgetEditorDialog .btn-default:not(:disabled):not(.disabled):active:focus,\n    #builder .dijitMenuPopup .btn-default:not(:disabled):not(.disabled):active:focus,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-default:not(:disabled):not(.disabled):active:focus {\n        box-shadow: 0 0 0 0.2rem {{defaultColor}}80;\n    }\n{{/if}}\n\n\n/***** Primary colour - named 'primaryColorB' because there is already a property called 'primaryColor' *****/\n\n{{#if primaryColorB}}\n    .widgetEditorDialog .btn-primary, .widgetEditorDialog .alert-primary,\n    .widgetEditorDialog .badge-primary, .widgetEditorDialog .bg-primary,\n    .widgetEditorDialog .list-group-item-primary,\n    #builder .dijitMenuPopup .btn-primary, #builder .dijitMenuPopup .alert-primary,\n    #builder .dijitMenuPopup .badge-primary, #builder .dijitMenuPopup .bg-primary,\n    #builder .dijitMenuPopup .list-group-item-primary,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-primary,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .alert-primary,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .badge-primary,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .bg-primary,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .list-group-item-primary {\n        background-color: {{primaryColorB}};\n    }\n\n    .widgetEditorDialog .btn-primary.btn-outline,\n    #builder .dijitMenuPopup .btn-primary.btn-outline,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-primary.btn-outline {\n        background-color: transparent;\n        color: {{primaryColorB}};\n        border-color: {{primaryColorB}};\n    }\n\n    .widgetEditorDialog .btn-primary.btn-outline:hover,\n    #builder .dijitMenuPopup .btn-primary.btn-outline:hover,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-primary.btn-outline:hover {\n        background-color: {{primaryColorB}};\n        color: #fff;\n    }\n\n    .widgetEditorDialog .btn-primary.btn-light,\n    #builder .dijitMenuPopup .btn-primary.btn-light,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-primary.btn-light {\n        background-color: {{primaryColorB}}66;\n        color: {{primaryColorB}};\n    }\n\n    .widgetEditorDialog .btn-primary:not(:disabled):not(.disabled):active,\n    #builder .dijitMenuPopup .btn-primary:not(:disabled):not(.disabled):active,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-primary:not(:disabled):not(.disabled):active {\n        background-color: {{primaryColorB}}e6;\n        border-color: {{primaryColorB}}e6;\n    }\n\n    .widgetEditorDialog .btn-primary:not(:disabled):not(.disabled):active:focus,\n    #builder .dijitMenuPopup .btn-primary:not(:disabled):not(.disabled):active:focus,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-primary:not(:disabled):not(.disabled):active:focus {\n        box-shadow: 0 0 0 0.2rem {{primaryColorB}}80;\n    }\n{{/if}}\n\n\n/***** Success colour *****/\n\n{{#if successColor}}\n    .widgetEditorDialog .btn-success, .widgetEditorDialog .alert-success,\n    .widgetEditorDialog .badge-success, .widgetEditorDialog .bg-success,\n    .widgetEditorDialog .list-group-item-success,\n    #builder .dijitMenuPopup .btn-success, #builder .dijitMenuPopup .alert-success,\n    #builder .dijitMenuPopup .badge-success, #builder .dijitMenuPopup .bg-success,\n    #builder .dijitMenuPopup .list-group-item-success,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-success,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .alert-success,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .badge-success,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .bg-success,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .list-group-item-success {\n        background-color: {{successColor}};\n    }\n\n    .widgetEditorDialog .btn-success.btn-outline,\n    #builder .dijitMenuPopup .btn-success.btn-outline,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-success.btn-outline {\n        background-color: transparent;\n        color: {{successColor}};\n        border-color: {{successColor}};\n    }\n\n    .widgetEditorDialog .btn-success.btn-outline:hover,\n    #builder .dijitMenuPopup .btn-success.btn-outline:hover,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-success.btn-outline:hover {\n        background-color: {{successColor}};\n        color: #fff;\n    }\n\n    .widgetEditorDialog .btn-success.btn-light,\n    #builder .dijitMenuPopup .btn-success.btn-light,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-success.btn-light {\n        background-color: {{successColor}}66;\n        color: {{successColor}};\n    }\n\n    .widgetEditorDialog .btn-success:not(:disabled):not(.disabled):active,\n    #builder .dijitMenuPopup .btn-success:not(:disabled):not(.disabled):active,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-success:not(:disabled):not(.disabled):active {\n        background-color: {{successColor}}e6;\n        border-color: {{successColor}}e6;\n    }\n\n    .widgetEditorDialog .btn-success:not(:disabled):not(.disabled):active:focus,\n    #builder .dijitMenuPopup .btn-success:not(:disabled):not(.disabled):active:focus,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-success:not(:disabled):not(.disabled):active:focus {\n        box-shadow: 0 0 0 0.2rem {{successColor}}80;\n    }\n{{/if}}\n\n\n/***** Info colour *****/\n\n{{#if infoColor}}\n    .widgetEditorDialog .btn-info, .widgetEditorDialog .alert-info,\n    .widgetEditorDialog .badge-info, .widgetEditorDialog .bg-info,\n    .widgetEditorDialog .list-group-item-info,\n    #builder .dijitMenuPopup .btn-info, #builder .dijitMenuPopup .alert-info,\n    #builder .dijitMenuPopup .badge-info, #builder .dijitMenuPopup .bg-info,\n    #builder .dijitMenuPopup .list-group-item-info,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-info,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .alert-info,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .badge-info,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .bg-info,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .list-group-item-info {\n        background-color: {{infoColor}};\n    }\n\n    .widgetEditorDialog .btn-info.btn-outline,\n    #builder .dijitMenuPopup .btn-info.btn-outline,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-info.btn-outline {\n        background-color: transparent;\n        color: {{infoColor}};\n        border-color: {{infoColor}};\n    }\n\n    .widgetEditorDialog .btn-info.btn-outline:hover,\n    #builder .dijitMenuPopup .btn-info.btn-outline:hover,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-info.btn-outline:hover {\n        background-color: {{infoColor}};\n        color: #fff;\n    }\n\n    .widgetEditorDialog .btn-info.btn-light,\n    #builder .dijitMenuPopup .btn-info.btn-light,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-info.btn-light {\n        background-color: {{infoColor}}66;\n        color: {{infoColor}};\n    }\n\n    .widgetEditorDialog .btn-info:not(:disabled):not(.disabled):active,\n    #builder .dijitMenuPopup .btn-info:not(:disabled):not(.disabled):active,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-info:not(:disabled):not(.disabled):active {\n        background-color: {{infoColor}}e6;\n        border-color: {{infoColor}}e6;\n    }\n\n    .widgetEditorDialog .btn-info:not(:disabled):not(.disabled):active:focus,\n    #builder .dijitMenuPopup .btn-info:not(:disabled):not(.disabled):active:focus,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-info:not(:disabled):not(.disabled):active:focus {\n        box-shadow: 0 0 0 0.2rem {{infoColor}}80;\n    }\n{{/if}}\n\n\n/***** Warning colour *****/\n\n{{#if warningColor}}\n    .widgetEditorDialog .btn-warning, .widgetEditorDialog .alert-warning,\n    .widgetEditorDialog .badge-warning, .widgetEditorDialog .bg-warning,\n    .widgetEditorDialog .list-group-item-warning,\n    #builder .dijitMenuPopup .btn-warning, #builder .dijitMenuPopup .alert-warning,\n    #builder .dijitMenuPopup .badge-warning, #builder .dijitMenuPopup .bg-warning,\n    #builder .dijitMenuPopup .list-group-item-warning,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-warning,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .alert-warning,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .badge-warning,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .bg-warning,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .list-group-item-warning {\n        background-color: {{warningColor}};\n    }\n\n    .widgetEditorDialog .btn-warning.btn-outline,\n    #builder .dijitMenuPopup .btn-warning.btn-outline,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-warning.btn-outline {\n        background-color: transparent;\n        color: {{warningColor}};\n        border-color: {{warningColor}};\n    }\n\n    .widgetEditorDialog .btn-warning.btn-outline:hover,\n    #builder .dijitMenuPopup .btn-warning.btn-outline:hover,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-warning.btn-outline:hover {\n        background-color: {{warningColor}};\n        color: #fff;\n    }\n\n    .widgetEditorDialog .btn-warning.btn-light,\n    #builder .dijitMenuPopup .btn-warning.btn-light,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-warning.btn-light {\n        background-color: {{warningColor}}66;\n        color: {{warningColor}};\n    }\n\n    .widgetEditorDialog .btn-warning:not(:disabled):not(.disabled):active,\n    #builder .dijitMenuPopup .btn-warning:not(:disabled):not(.disabled):active,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-warning:not(:disabled):not(.disabled):active {\n        background-color: {{warningColor}}e6;\n        border-color: {{warningColor}}e6;\n    }\n\n    .widgetEditorDialog .btn-warning:not(:disabled):not(.disabled):active:focus,\n    #builder .dijitMenuPopup .btn-warning:not(:disabled):not(.disabled):active:focus,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-warning:not(:disabled):not(.disabled):active:focus {\n        box-shadow: 0 0 0 0.2rem {{warningColor}}80;\n    }\n{{/if}}\n\n\n/***** Danger colour *****/\n\n{{#if dangerColor}}\n    .widgetEditorDialog .btn-danger, .widgetEditorDialog .alert-danger,\n    .widgetEditorDialog .badge-danger, .widgetEditorDialog .bg-danger,\n    .widgetEditorDialog .list-group-item-danger,\n    #builder .dijitMenuPopup .btn-danger, #builder .dijitMenuPopup .alert-danger,\n    #builder .dijitMenuPopup .badge-danger, #builder .dijitMenuPopup .bg-danger,\n    #builder .dijitMenuPopup .list-group-item-danger,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-danger,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .alert-danger,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .badge-danger,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .bg-danger,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .list-group-item-danger {\n        background-color: {{dangerColor}};\n    }\n\n    .widgetEditorDialog .btn-danger.btn-outline,\n    #builder .dijitMenuPopup .btn-danger.btn-outline,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-danger.btn-outline {\n        background-color: transparent;\n        color: {{dangerColor}};\n        border-color: {{dangerColor}};\n    }\n\n    .widgetEditorDialog .btn-danger.btn-outline:hover,\n    #builder .dijitMenuPopup .btn-danger.btn-outline:hover,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-danger.btn-outline:hover {\n        background-color: {{dangerColor}};\n        color: #fff;\n    }\n\n    .widgetEditorDialog .btn-danger.btn-light,\n    #builder .dijitMenuPopup .btn-danger.btn-light,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-danger.btn-light {\n        background-color: {{dangerColor}}66;\n        color: {{dangerColor}};\n    }\n\n    .widgetEditorDialog .btn-danger:not(:disabled):not(.disabled):active,\n    #builder .dijitMenuPopup .btn-danger:not(:disabled):not(.disabled):active,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-danger:not(:disabled):not(.disabled):active {\n        background-color: {{dangerColor}}e6;\n        border-color: {{dangerColor}}e6;\n    }\n\n    .widgetEditorDialog .btn-danger:not(:disabled):not(.disabled):active:focus,\n    #builder .dijitMenuPopup .btn-danger:not(:disabled):not(.disabled):active:focus,\n    {{#if wrapperClass}}{{wrapperClass}}{{/if}} .btn-danger:not(:disabled):not(.disabled):active:focus {\n        box-shadow: 0 0 0 0.2rem {{dangerColor}}80;\n    }\n{{/if}}\n\n/***********for HTML Widget - Common for web and mobile***********/\n{{#if wrapperClass}}{{wrapperClass}}{{/if}} .ap-HTML{\n    {{#if isPageThemeDark}}\n        color: {{bodyFontLightColor}};\n    {{else}}\n        color: {{bodyfontcolor}};\n    {{/if}}\n}\n/*no wrapper class as this targets tags inside the widget and not widget itself*/\n.ap-HTML h1,\n.ap-HTML h2,\n.ap-HTML h3,\n.ap-HTML h4,\n.ap-HTML h5,\n.ap-HTML h6,\n.ap-HTML .h1,\n.ap-HTML .h2,\n.ap-HTML .h3,\n.ap-HTML .h4,\n.ap-HTML .h5,\n.ap-HTML .h6{\n    {{#if headingfontfamily}}\n        font-family: {{headingfontfamily}};\n        font-weight: {{headingFontWeight}};\n    {{/if}}\n    {{#if isPageThemeDark}}\n        color: {{headingFontLightColor}};\n    {{else}}\n        color: {{headingfontcolor}};\n    {{/if}}\n}\n\n/************web/mobile dialog theme-ing start**************/\n\n{{#if wrapperClass}}{{wrapperClass}}{{/if}} .dialog-title-container {\n    {{#if primaryColor}}\n        background-color: {{primaryColor}};\n    {{/if}}\n    {{#if headingFontLightColor}}\n        color: {{headingFontLightColor}};\n    {{/if}}\n    {{#if generalBorderColor}}\n        border-bottom-color: {{generalBorderColor}};\n    {{/if}}\n    font-family: {{headingfontfamily}};\n    font-weight:{{headingFontWeight}};\n    font-style:{{headingFontStyle}};\n}\n\n/*** this is just for builder preview web and mobile *****/\n.main-canvas.desktop-view .page-level-theme .dialog-title-container,\n.mobile-builder-preview.dialog-title-container {\n    {{#if primaryColor}}\n        background-color: {{primaryColor}};\n    {{/if}}\n    {{#if headingFontLightColor}}\n        color: {{headingFontLightColor}};\n    {{/if}}\n    {{#if generalBorderColor}}\n        border-bottom-color: {{generalBorderColor}};\n    {{/if}}\n    font-family: {{headingfontfamily}};\n    font-weight:{{headingFontWeight}};\n    font-style:{{headingFontStyle}};\n}\n\n/************web/mobile dialog theme-ing end**************/\n\n/********** context.notify alerts them-ing start *******/\n\n.alertify-notifier .ajs-message {\n    font-family: {{bodyfontfamily}};\n}\n{{#if accentcolor}}\n    .alertify-notifier .ajs-message.ajs-default:before,\n    .alertify-notifier .ajs-message.ajs-default-light:before {\n        background-color: {{accentcolor}};\n    }\n{{/if}}\n\n.alertify-notifier .ajs-message.ajs-default {\n    color: {{bodyFontLightColor}};\n    background-color: {{primaryColor}};\n}\n\n.alertify-notifier .ajs-message.ajs-default-light {\n    color: {{bodyfontcolor}};\n}\n/********** context.notify alerts them-ing end *******/\n",
'url:appivo/gen/handlebars/palettes/FontDirectory.json':"{\n\t\"kind\": \"webfonts#webfontList\",\n\t\"items\": [\n\t\t{\n\t\t\t\"family\": \"ABeeZee\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/abeezee/v22/esDR31xSG-6AGleN6tKukbcHCpE.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/abeezee/v22/esDT31xSG-6AGleN2tCklZUCGpG-GQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Abel\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/abel/v18/MwQ5bhbm2POE6VhLPJp6qGI.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Abhaya Libre\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"sinhala\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/abhayalibre/v13/e3tmeuGtX-Co5MNzeAOqinEge0PWovdU4w.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/abhayalibre/v13/e3t5euGtX-Co5MNzeAOqinEYj2ryqtxI6oYtBA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/abhayalibre/v13/e3t5euGtX-Co5MNzeAOqinEYo23yqtxI6oYtBA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/abhayalibre/v13/e3t5euGtX-Co5MNzeAOqinEYx2zyqtxI6oYtBA.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/abhayalibre/v13/e3t5euGtX-Co5MNzeAOqinEY22_yqtxI6oYtBA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Aboreto\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v2\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/aboreto/v2/5DCXAKLhwDDQ4N8blKTeA2yuxSY.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Abril Fatface\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/abrilfatface/v19/zOL64pLDlL1D99S8g8PtiKchm-BsjOLhZBY.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Abyssinica SIL\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"ethiopic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v5\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/abyssinicasil/v5/oY1H8ezOqK7iI3rK_45WKoc8J6UZBFOVAXuI.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Aclonica\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/aclonica/v18/K2FyfZJVlfNNSEBXGb7TCI6oBjLz.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Acme\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/acme/v21/RrQfboBx-C5_bx3Lb23lzLk.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Actor\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/actor/v17/wEOzEBbCkc5cO3ekXygtUMIO.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Adamina\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-04-20\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/adamina/v21/j8_r6-DH1bjoc-dwu-reETl4Bno.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Advent Pro\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/adventpro/v19/V8mqoQfxVT4Dvddr_yOwrzaFxV7JtdQgFqXdUAQrGp_zgX5sWCpLQyJPTJoonw1aBA.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/adventpro/v19/V8mqoQfxVT4Dvddr_yOwrzaFxV7JtdQgFqXdUAQrGp_zgX5sWCpLwyNPTJoonw1aBA.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/adventpro/v19/V8mqoQfxVT4Dvddr_yOwrzaFxV7JtdQgFqXdUAQrGp_zgX5sWCpLHSNPTJoonw1aBA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/adventpro/v19/V8mqoQfxVT4Dvddr_yOwrzaFxV7JtdQgFqXdUAQrGp_zgX5sWCpLQyNPTJoonw1aBA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/adventpro/v19/V8mqoQfxVT4Dvddr_yOwrzaFxV7JtdQgFqXdUAQrGp_zgX5sWCpLcSNPTJoonw1aBA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/adventpro/v19/V8mqoQfxVT4Dvddr_yOwrzaFxV7JtdQgFqXdUAQrGp_zgX5sWCpLnSRPTJoonw1aBA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/adventpro/v19/V8mqoQfxVT4Dvddr_yOwrzaFxV7JtdQgFqXdUAQrGp_zgX5sWCpLpCRPTJoonw1aBA.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/adventpro/v19/V8mqoQfxVT4Dvddr_yOwrzaFxV7JtdQgFqXdUAQrGp_zgX5sWCpLwyRPTJoonw1aBA.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/adventpro/v19/V8mqoQfxVT4Dvddr_yOwrzaFxV7JtdQgFqXdUAQrGp_zgX5sWCpL6iRPTJoonw1aBA.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/adventpro/v19/V8mkoQfxVT4Dvddr_yOwhT-3Jr6w5kKOEbAVEvZiKGAr6BX29i1ei2CnDpAsvQhKBH4C.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/adventpro/v19/V8mkoQfxVT4Dvddr_yOwhT-3Jr6w5kKOEbAVEvZiKGAr6BX29i1ei2AnD5AsvQhKBH4C.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/adventpro/v19/V8mkoQfxVT4Dvddr_yOwhT-3Jr6w5kKOEbAVEvZiKGAr6BX29i1ei2D5D5AsvQhKBH4C.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/adventpro/v19/V8mkoQfxVT4Dvddr_yOwhT-3Jr6w5kKOEbAVEvZiKGAr6BX29i1ei2CnD5AsvQhKBH4C.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/adventpro/v19/V8mkoQfxVT4Dvddr_yOwhT-3Jr6w5kKOEbAVEvZiKGAr6BX29i1ei2CVD5AsvQhKBH4C.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/adventpro/v19/V8mkoQfxVT4Dvddr_yOwhT-3Jr6w5kKOEbAVEvZiKGAr6BX29i1ei2B5CJAsvQhKBH4C.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/adventpro/v19/V8mkoQfxVT4Dvddr_yOwhT-3Jr6w5kKOEbAVEvZiKGAr6BX29i1ei2BACJAsvQhKBH4C.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/adventpro/v19/V8mkoQfxVT4Dvddr_yOwhT-3Jr6w5kKOEbAVEvZiKGAr6BX29i1ei2AnCJAsvQhKBH4C.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/adventpro/v19/V8mkoQfxVT4Dvddr_yOwhT-3Jr6w5kKOEbAVEvZiKGAr6BX29i1ei2AOCJAsvQhKBH4C.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Aguafina Script\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/aguafinascript/v16/If2QXTv_ZzSxGIO30LemWEOmt1bHqs4pgicOrg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Akaya Kanadaka\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"kannada\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/akayakanadaka/v16/N0bM2S5CPO5oOQqvazoRRb-8-PfRS5VBBSSF.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Akaya Telivigala\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"telugu\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/akayatelivigala/v22/lJwc-oo_iG9wXqU3rCTD395tp0uifdLdsIH0YH8.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Akronim\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v23\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/akronim/v23/fdN-9sqWtWZZlHRp-gBxkFYN-a8.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Akshar\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v5\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/akshar/v5/Yq6I-LyHWTfz9rGoqDaUbHvhkAUsSSgFy9CY94XsnPc.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/akshar/v5/Yq6I-LyHWTfz9rGoqDaUbHvhkAUsSXYFy9CY94XsnPc.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/akshar/v5/Yq6I-LyHWTfz9rGoqDaUbHvhkAUsSUQFy9CY94XsnPc.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/akshar/v5/Yq6I-LyHWTfz9rGoqDaUbHvhkAUsSagCy9CY94XsnPc.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/akshar/v5/Yq6I-LyHWTfz9rGoqDaUbHvhkAUsSZECy9CY94XsnPc.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Aladin\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/aladin/v18/ZgNSjPJFPrvJV5f16Sf4pGT2Ng.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Alata\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v9\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/alata/v9/PbytFmztEwbIofe6xKcRQEOX.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Alatsi\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2022-11-18\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/alatsi/v10/TK3iWkUJAxQ2nLNGHjUHte5fKg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Albert Sans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/albertsans/v1/i7dZIFdwYjGaAMFtZd_QA3xXSKZqhr-TenSHq5L_rI32TxAj1g.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/albertsans/v1/i7dZIFdwYjGaAMFtZd_QA3xXSKZqhr-TenSHK5P_rI32TxAj1g.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/albertsans/v1/i7dZIFdwYjGaAMFtZd_QA3xXSKZqhr-TenSH9ZP_rI32TxAj1g.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/albertsans/v1/i7dZIFdwYjGaAMFtZd_QA3xXSKZqhr-TenSHq5P_rI32TxAj1g.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/albertsans/v1/i7dZIFdwYjGaAMFtZd_QA3xXSKZqhr-TenSHmZP_rI32TxAj1g.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/albertsans/v1/i7dZIFdwYjGaAMFtZd_QA3xXSKZqhr-TenSHdZT_rI32TxAj1g.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/albertsans/v1/i7dZIFdwYjGaAMFtZd_QA3xXSKZqhr-TenSHTJT_rI32TxAj1g.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/albertsans/v1/i7dZIFdwYjGaAMFtZd_QA3xXSKZqhr-TenSHK5T_rI32TxAj1g.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/albertsans/v1/i7dZIFdwYjGaAMFtZd_QA3xXSKZqhr-TenSHApT_rI32TxAj1g.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/albertsans/v1/i7dfIFdwYjGaAMFtZd_QA1Zeelmy79QJ1HOSY9AX7ofybRUz1r5t.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/albertsans/v1/i7dfIFdwYjGaAMFtZd_QA1Zeelmy79QJ1HOSY9CX74fybRUz1r5t.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/albertsans/v1/i7dfIFdwYjGaAMFtZd_QA1Zeelmy79QJ1HOSY9BJ74fybRUz1r5t.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/albertsans/v1/i7dfIFdwYjGaAMFtZd_QA1Zeelmy79QJ1HOSY9AX74fybRUz1r5t.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/albertsans/v1/i7dfIFdwYjGaAMFtZd_QA1Zeelmy79QJ1HOSY9Al74fybRUz1r5t.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/albertsans/v1/i7dfIFdwYjGaAMFtZd_QA1Zeelmy79QJ1HOSY9DJ6IfybRUz1r5t.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/albertsans/v1/i7dfIFdwYjGaAMFtZd_QA1Zeelmy79QJ1HOSY9Dw6IfybRUz1r5t.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/albertsans/v1/i7dfIFdwYjGaAMFtZd_QA1Zeelmy79QJ1HOSY9CX6IfybRUz1r5t.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/albertsans/v1/i7dfIFdwYjGaAMFtZd_QA1Zeelmy79QJ1HOSY9C-6IfybRUz1r5t.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Aldrich\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/aldrich/v17/MCoTzAn-1s3IGyJMZaAS3pP5H_E.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Alef\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/alef/v21/FeVfS0NQpLYgrjJbC5FxxbU.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/alef/v21/FeVQS0NQpLYglo50L5la2bxii28.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Alegreya\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v31\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/alegreya/v31/4UacrEBBsBhlBjvfkQjt71kZfyBzPgNG9hUI_KCisSGVrw.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/alegreya/v31/4UacrEBBsBhlBjvfkQjt71kZfyBzPgNGxBUI_KCisSGVrw.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/alegreya/v31/4UacrEBBsBhlBjvfkQjt71kZfyBzPgNGKBII_KCisSGVrw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/alegreya/v31/4UacrEBBsBhlBjvfkQjt71kZfyBzPgNGERII_KCisSGVrw.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/alegreya/v31/4UacrEBBsBhlBjvfkQjt71kZfyBzPgNGdhII_KCisSGVrw.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/alegreya/v31/4UacrEBBsBhlBjvfkQjt71kZfyBzPgNGXxII_KCisSGVrw.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/alegreya/v31/4UaSrEBBsBhlBjvfkSLk3abBFkvpkARTPlbgv6qmkySFr9V9.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/alegreya/v31/4UaSrEBBsBhlBjvfkSLk3abBFkvpkARTPlbSv6qmkySFr9V9.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/alegreya/v31/4UaSrEBBsBhlBjvfkSLk3abBFkvpkARTPlY-uKqmkySFr9V9.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/alegreya/v31/4UaSrEBBsBhlBjvfkSLk3abBFkvpkARTPlYHuKqmkySFr9V9.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/alegreya/v31/4UaSrEBBsBhlBjvfkSLk3abBFkvpkARTPlZguKqmkySFr9V9.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/alegreya/v31/4UaSrEBBsBhlBjvfkSLk3abBFkvpkARTPlZJuKqmkySFr9V9.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Alegreya SC\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v25\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/alegreyasc/v25/taiOGmRtCJ62-O0HhNEa-a6o05E5abe_.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/alegreyasc/v25/taiMGmRtCJ62-O0HhNEa-Z6q2ZUbbKe_DGs.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/alegreyasc/v25/taiTGmRtCJ62-O0HhNEa-ZZc-rUxQqu2FXKD.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/alegreyasc/v25/taiRGmRtCJ62-O0HhNEa-Z6q4WEySK-UEGKDBz4.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/alegreyasc/v25/taiTGmRtCJ62-O0HhNEa-ZYU_LUxQqu2FXKD.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/alegreyasc/v25/taiRGmRtCJ62-O0HhNEa-Z6q4Sk0SK-UEGKDBz4.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/alegreyasc/v25/taiTGmRtCJ62-O0HhNEa-ZYI_7UxQqu2FXKD.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/alegreyasc/v25/taiRGmRtCJ62-O0HhNEa-Z6q4TU3SK-UEGKDBz4.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/alegreyasc/v25/taiTGmRtCJ62-O0HhNEa-ZYs_rUxQqu2FXKD.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/alegreyasc/v25/taiRGmRtCJ62-O0HhNEa-Z6q4RE2SK-UEGKDBz4.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Alegreya Sans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/alegreyasans/v24/5aUt9_-1phKLFgshYDvh6Vwt5TltuGdShm5bsg.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/alegreyasans/v24/5aUv9_-1phKLFgshYDvh6Vwt7V9V3G1WpGtLsgu7.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/alegreyasans/v24/5aUu9_-1phKLFgshYDvh6Vwt5fFPmE18imdCqxI.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/alegreyasans/v24/5aUo9_-1phKLFgshYDvh6Vwt7V9VFE92jkVHuxKiBA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/alegreyasans/v24/5aUz9_-1phKLFgshYDvh6Vwt3V1nvEVXlm4.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/alegreyasans/v24/5aUt9_-1phKLFgshYDvh6Vwt7V9tuGdShm5bsg.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/alegreyasans/v24/5aUu9_-1phKLFgshYDvh6Vwt5alOmE18imdCqxI.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/alegreyasans/v24/5aUo9_-1phKLFgshYDvh6Vwt7V9VTE52jkVHuxKiBA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/alegreyasans/v24/5aUu9_-1phKLFgshYDvh6Vwt5eFImE18imdCqxI.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/alegreyasans/v24/5aUo9_-1phKLFgshYDvh6Vwt7V9VBEh2jkVHuxKiBA.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/alegreyasans/v24/5aUu9_-1phKLFgshYDvh6Vwt5f1LmE18imdCqxI.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/alegreyasans/v24/5aUo9_-1phKLFgshYDvh6Vwt7V9VGEt2jkVHuxKiBA.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/alegreyasans/v24/5aUu9_-1phKLFgshYDvh6Vwt5dlKmE18imdCqxI.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/alegreyasans/v24/5aUo9_-1phKLFgshYDvh6Vwt7V9VPEp2jkVHuxKiBA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Alegreya Sans SC\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v23\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/alegreyasanssc/v23/mtGn4-RGJqfMvt7P8FUr0Q1j-Hf1Dipl8g5FPYtmMg.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/alegreyasanssc/v23/mtGl4-RGJqfMvt7P8FUr0Q1j-Hf1BkxdlgRBH452Mvds.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/alegreyasanssc/v23/mtGm4-RGJqfMvt7P8FUr0Q1j-Hf1DuJH0iRrMYJ_K-4.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/alegreyasanssc/v23/mtGk4-RGJqfMvt7P8FUr0Q1j-Hf1BkxdXiZhNaB6O-51OA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/alegreyasanssc/v23/mtGh4-RGJqfMvt7P8FUr0Q1j-Hf1Nk5v9ixALYs.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/alegreyasanssc/v23/mtGn4-RGJqfMvt7P8FUr0Q1j-Hf1Bkxl8g5FPYtmMg.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/alegreyasanssc/v23/mtGm4-RGJqfMvt7P8FUr0Q1j-Hf1DrpG0iRrMYJ_K-4.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/alegreyasanssc/v23/mtGk4-RGJqfMvt7P8FUr0Q1j-Hf1BkxdBidhNaB6O-51OA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/alegreyasanssc/v23/mtGm4-RGJqfMvt7P8FUr0Q1j-Hf1DvJA0iRrMYJ_K-4.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/alegreyasanssc/v23/mtGk4-RGJqfMvt7P8FUr0Q1j-Hf1BkxdTiFhNaB6O-51OA.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/alegreyasanssc/v23/mtGm4-RGJqfMvt7P8FUr0Q1j-Hf1Du5D0iRrMYJ_K-4.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/alegreyasanssc/v23/mtGk4-RGJqfMvt7P8FUr0Q1j-Hf1BkxdUiJhNaB6O-51OA.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/alegreyasanssc/v23/mtGm4-RGJqfMvt7P8FUr0Q1j-Hf1DspC0iRrMYJ_K-4.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/alegreyasanssc/v23/mtGk4-RGJqfMvt7P8FUr0Q1j-Hf1BkxddiNhNaB6O-51OA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Aleo\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/aleo/v11/c4mg1nF8G8_syKbr9DVDno985KM.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/aleo/v11/c4mi1nF8G8_swAjxeDdJmq159KOnWA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/aleo/v11/c4mv1nF8G8_s8ArD0D1ogoY.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/aleo/v11/c4mh1nF8G8_swAjJ1B9tkoZl_Q.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/aleo/v11/c4mg1nF8G8_syLbs9DVDno985KM.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/aleo/v11/c4mi1nF8G8_swAjxaDBJmq159KOnWA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Alex Brush\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2023-01-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/alexbrush/v21/SZc83FzrJKuqFbwMKk6EtUL57DtOmCc.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Alexandria\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2022-11-18\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/alexandria/v1/UMBCrPdDqW66y0Y2usFeQCH18mulUxBvI9r7T6bHHJ8BRq0b.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/alexandria/v1/UMBCrPdDqW66y0Y2usFeQCH18mulUxBvI9p7TqbHHJ8BRq0b.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/alexandria/v1/UMBCrPdDqW66y0Y2usFeQCH18mulUxBvI9qlTqbHHJ8BRq0b.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/alexandria/v1/UMBCrPdDqW66y0Y2usFeQCH18mulUxBvI9r7TqbHHJ8BRq0b.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/alexandria/v1/UMBCrPdDqW66y0Y2usFeQCH18mulUxBvI9rJTqbHHJ8BRq0b.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/alexandria/v1/UMBCrPdDqW66y0Y2usFeQCH18mulUxBvI9olSabHHJ8BRq0b.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/alexandria/v1/UMBCrPdDqW66y0Y2usFeQCH18mulUxBvI9ocSabHHJ8BRq0b.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/alexandria/v1/UMBCrPdDqW66y0Y2usFeQCH18mulUxBvI9p7SabHHJ8BRq0b.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/alexandria/v1/UMBCrPdDqW66y0Y2usFeQCH18mulUxBvI9pSSabHHJ8BRq0b.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Alfa Slab One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/alfaslabone/v17/6NUQ8FmMKwSEKjnm5-4v-4Jh6dVretWvYmE.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Alice\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/alice/v20/OpNCnoEEmtHa6FcJpA_chzJ0.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Alike\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-04-20\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/alike/v20/HI_EiYEYI6BIoEjBSZXAQ4-d.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Alike Angular\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-04-20\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/alikeangular/v20/3qTrojWunjGQtEBlIcwMbSoI3kM6bB7FKjE.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Alkalami\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v3\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/alkalami/v3/zOL_4pfDmqRL95WXi5eLw8BMuvhH.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Allan\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/allan/v20/ea8XadU7WuTxEtb2P9SF8nZE.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/allan/v20/ea8aadU7WuTxEu5KEPCN2WpNgEKU.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Allerta\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/allerta/v18/TwMO-IAHRlkbx940UnEdSQqO5uY.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Allerta Stencil\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/allertastencil/v18/HTx0L209KT-LmIE9N7OR6eiycOeF-zz313DuvQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Allison\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v9\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/allison/v9/X7nl4b88AP2nkbvZOCaQ4MTgAgk.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Allura\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2023-01-18\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/allura/v19/9oRPNYsQpS4zjuAPjAIXPtrrGA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Almarai\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/almarai/v12/tssoApxBaigK_hnnS_anhnicoq72sXg.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/almarai/v12/tsstApxBaigK_hnnc1qPonC3vqc.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/almarai/v12/tssoApxBaigK_hnnS-aghnicoq72sXg.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/almarai/v12/tssoApxBaigK_hnnS_qjhnicoq72sXg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Almendra\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/almendra/v22/H4ckBXKAlMnTn0CskyY6wr-wg763.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/almendra/v22/H4ciBXKAlMnTn0CskxY4yLuShq63czE.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/almendra/v22/H4cjBXKAlMnTn0Cskx6G7Zu4qKK-aihq.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/almendra/v22/H4chBXKAlMnTn0CskxY48Ae9oqacbzhqDtg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Almendra Display\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v25\",\n\t\t\t\"lastModified\": \"2022-04-20\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/almendradisplay/v25/0FlPVOGWl1Sb4O3tETtADHRRlZhzXS_eTyer338.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Almendra SC\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v25\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/almendrasc/v25/Iure6Yx284eebowr7hbyTZZJprVA4XQ0.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Alumni Sans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/alumnisans/v12/nwpHtKqkOwdO2aOIwhWudEWpx_zq_Xna-Xd9OO5QqFsJ3C8qng.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/alumnisans/v12/nwpHtKqkOwdO2aOIwhWudEWpx_zq_Xna-Xd9uO9QqFsJ3C8qng.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/alumnisans/v12/nwpHtKqkOwdO2aOIwhWudEWpx_zq_Xna-Xd9Zu9QqFsJ3C8qng.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/alumnisans/v12/nwpHtKqkOwdO2aOIwhWudEWpx_zq_Xna-Xd9OO9QqFsJ3C8qng.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/alumnisans/v12/nwpHtKqkOwdO2aOIwhWudEWpx_zq_Xna-Xd9Cu9QqFsJ3C8qng.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/alumnisans/v12/nwpHtKqkOwdO2aOIwhWudEWpx_zq_Xna-Xd95uhQqFsJ3C8qng.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/alumnisans/v12/nwpHtKqkOwdO2aOIwhWudEWpx_zq_Xna-Xd93-hQqFsJ3C8qng.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/alumnisans/v12/nwpHtKqkOwdO2aOIwhWudEWpx_zq_Xna-Xd9uOhQqFsJ3C8qng.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/alumnisans/v12/nwpHtKqkOwdO2aOIwhWudEWpx_zq_Xna-Xd9kehQqFsJ3C8qng.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/alumnisans/v12/nwpBtKqkOwdO2aOIwhWudG-g9QMylBJAV3Bo8Ky46lEN_io6npfB.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/alumnisans/v12/nwpBtKqkOwdO2aOIwhWudG-g9QMylBJAV3Bo8Kw461EN_io6npfB.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/alumnisans/v12/nwpBtKqkOwdO2aOIwhWudG-g9QMylBJAV3Bo8Kzm61EN_io6npfB.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/alumnisans/v12/nwpBtKqkOwdO2aOIwhWudG-g9QMylBJAV3Bo8Ky461EN_io6npfB.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/alumnisans/v12/nwpBtKqkOwdO2aOIwhWudG-g9QMylBJAV3Bo8KyK61EN_io6npfB.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/alumnisans/v12/nwpBtKqkOwdO2aOIwhWudG-g9QMylBJAV3Bo8Kxm7FEN_io6npfB.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/alumnisans/v12/nwpBtKqkOwdO2aOIwhWudG-g9QMylBJAV3Bo8Kxf7FEN_io6npfB.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/alumnisans/v12/nwpBtKqkOwdO2aOIwhWudG-g9QMylBJAV3Bo8Kw47FEN_io6npfB.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/alumnisans/v12/nwpBtKqkOwdO2aOIwhWudG-g9QMylBJAV3Bo8KwR7FEN_io6npfB.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Alumni Sans Collegiate One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v2\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/alumnisanscollegiateone/v2/MQpB-XChK8G5CtmK_AuGxQrdNvPSXkn0RM-XqjWWhjdayDiPw2ta.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/alumnisanscollegiateone/v2/MQpD-XChK8G5CtmK_AuGxQrdNvPSXkn0RM-XqjWWhgdYwjytxntaDFU.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Alumni Sans Inline One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v2\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/alumnisansinlineone/v2/RrQBbpJx9zZ3IXTBOASKp5gJAetBdaihcjbpD3AZcr7xbYw.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/alumnisansinlineone/v2/RrQDbpJx9zZ3IXTBOASKp5gJAetBdaihcjbpP3ITdpz0fYxcrQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Alumni Sans Pinstripe\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/alumnisanspinstripe/v1/ZgNNjOFFPq_AUJD1umyS30W-Xub8zD1ObhezYrVIpcDA5w.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/alumnisanspinstripe/v1/ZgNDjOFFPq_AUJD1umyS30W-Xub8zD1ObheDYL9Mh8XQ5_cY.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Amarante\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/amarante/v22/xMQXuF1KTa6EvGx9bq-3C3rAmD-b.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Amaranth\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/amaranth/v18/KtkuALODe433f0j1zPnCF9GqwnzW.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/amaranth/v18/KtkoALODe433f0j1zMnAHdWIx2zWD4I.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/amaranth/v18/KtkpALODe433f0j1zMF-OPWi6WDfFpuc.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/amaranth/v18/KtkrALODe433f0j1zMnAJWmn42T9E4ucRY8.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Amatic SC\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/amaticsc/v24/TUZyzwprpvBS1izr_vO0De6ecZQf1A.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/amaticsc/v24/TUZ3zwprpvBS1izr_vOMscG6eb8D3WTy-A.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Amethysta\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-04-20\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/amethysta/v16/rP2Fp2K15kgb_F3ibfWIGDWCBl0O8Q.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Amiko\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/amiko/v12/WwkQxPq1DFK04tqlc17MMZgJ.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/amiko/v12/WwkdxPq1DFK04uJ9XXrEGoQAUco5.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/amiko/v12/WwkdxPq1DFK04uIZXHrEGoQAUco5.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Amiri\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v27\",\n\t\t\t\"lastModified\": \"2023-01-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/amiri/v27/J7aRnpd8CGxBHqUpvrIw74NL.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/amiri/v27/J7afnpd8CGxBHpUrtLYS6pNLAjk.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/amiri/v27/J7acnpd8CGxBHp2VkZY4xJ9CGyAa.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/amiri/v27/J7aanpd8CGxBHpUrjAo9zptgHjAavCA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Amiri Quran\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v7\",\n\t\t\t\"lastModified\": \"2022-09-14\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/amiriquran/v7/_Xmo-Hk0rD6DbUL4_vH8Zq5t7Cycsu-2.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Amita\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/amita/v16/HhyaU5si9Om7PQlvAfSKEZZL.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/amita/v16/HhyXU5si9Om7PTHTLtCCOopCTKkI.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Anaheim\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/anaheim/v14/8vII7w042Wp87g4G0UTUEE5eK_w.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Andada Pro\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/andadapro/v16/HhyEU5Qi9-SuOEhPe4LtKoVCuWGURPcg3DPJBY8cFLzvIt2S.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/andadapro/v16/HhyEU5Qi9-SuOEhPe4LtKoVCuWGURPcg3DP7BY8cFLzvIt2S.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/andadapro/v16/HhyEU5Qi9-SuOEhPe4LtKoVCuWGURPcg3DMXAo8cFLzvIt2S.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/andadapro/v16/HhyEU5Qi9-SuOEhPe4LtKoVCuWGURPcg3DMuAo8cFLzvIt2S.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/andadapro/v16/HhyEU5Qi9-SuOEhPe4LtKoVCuWGURPcg3DNJAo8cFLzvIt2S.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/andadapro/v16/HhyGU5Qi9-SuOEhPe4LtAIxwRrn9L22O2yYBRmdfHrjNJ82Stjw.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/andadapro/v16/HhyGU5Qi9-SuOEhPe4LtAIxwRrn9L22O2yYBRlVfHrjNJ82Stjw.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/andadapro/v16/HhyGU5Qi9-SuOEhPe4LtAIxwRrn9L22O2yYBRrlYHrjNJ82Stjw.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/andadapro/v16/HhyGU5Qi9-SuOEhPe4LtAIxwRrn9L22O2yYBRoBYHrjNJ82Stjw.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/andadapro/v16/HhyGU5Qi9-SuOEhPe4LtAIxwRrn9L22O2yYBRudYHrjNJ82Stjw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Andika\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/andika/v22/mem_Ya6iyW-LwqgAbbwRWrwGVA.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/andika/v22/mem9Ya6iyW-Lwqgwb7YVeLkWVNBt.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/andika/v22/mem8Ya6iyW-Lwqg40ZM1UpcaXcl0Aw.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/andika/v22/mem6Ya6iyW-Lwqgwb46pV50ef8xkA76a.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Anek Bangla\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"bengali\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v4\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/anekbangla/v4/_gPW1R38qTExHg-17BhM6n66QhabMYB0fBKONtHhRSIUIre5mq3Ofm9YIocg56yyvt0.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/anekbangla/v4/_gPW1R38qTExHg-17BhM6n66QhabMYB0fBKONtHhRSIUIre5mq3Ofu9ZIocg56yyvt0.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/anekbangla/v4/_gPW1R38qTExHg-17BhM6n66QhabMYB0fBKONtHhRSIUIre5mq3OfjFZIocg56yyvt0.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/anekbangla/v4/_gPW1R38qTExHg-17BhM6n66QhabMYB0fBKONtHhRSIUIre5mq3Ofm9ZIocg56yyvt0.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/anekbangla/v4/_gPW1R38qTExHg-17BhM6n66QhabMYB0fBKONtHhRSIUIre5mq3Ofl1ZIocg56yyvt0.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/anekbangla/v4/_gPW1R38qTExHg-17BhM6n66QhabMYB0fBKONtHhRSIUIre5mq3OfrFeIocg56yyvt0.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/anekbangla/v4/_gPW1R38qTExHg-17BhM6n66QhabMYB0fBKONtHhRSIUIre5mq3OfoheIocg56yyvt0.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/anekbangla/v4/_gPW1R38qTExHg-17BhM6n66QhabMYB0fBKONtHhRSIUIre5mq3Ofu9eIocg56yyvt0.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Anek Devanagari\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v4\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/anekdevanagari/v4/jVyo7nP0CGrUsxB-QiRgw0NlLaVt_QUAkYxLRoCL23mlh20ZVHOMAWbgHLDtk-9nFk0LjZ7E.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/anekdevanagari/v4/jVyo7nP0CGrUsxB-QiRgw0NlLaVt_QUAkYxLRoCL23mlh20ZVHOMAWbgHLBtku9nFk0LjZ7E.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/anekdevanagari/v4/jVyo7nP0CGrUsxB-QiRgw0NlLaVt_QUAkYxLRoCL23mlh20ZVHOMAWbgHLCzku9nFk0LjZ7E.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/anekdevanagari/v4/jVyo7nP0CGrUsxB-QiRgw0NlLaVt_QUAkYxLRoCL23mlh20ZVHOMAWbgHLDtku9nFk0LjZ7E.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/anekdevanagari/v4/jVyo7nP0CGrUsxB-QiRgw0NlLaVt_QUAkYxLRoCL23mlh20ZVHOMAWbgHLDfku9nFk0LjZ7E.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/anekdevanagari/v4/jVyo7nP0CGrUsxB-QiRgw0NlLaVt_QUAkYxLRoCL23mlh20ZVHOMAWbgHLAzle9nFk0LjZ7E.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/anekdevanagari/v4/jVyo7nP0CGrUsxB-QiRgw0NlLaVt_QUAkYxLRoCL23mlh20ZVHOMAWbgHLAKle9nFk0LjZ7E.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/anekdevanagari/v4/jVyo7nP0CGrUsxB-QiRgw0NlLaVt_QUAkYxLRoCL23mlh20ZVHOMAWbgHLBtle9nFk0LjZ7E.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Anek Gujarati\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"gujarati\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v4\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/anekgujarati/v4/l7g_bj5oysqknvkCo2T_8FuiIRBA7lncQUmbIBEtPKiYYQhRwyBxCD-0F5G7w0KgB7Lm7g.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/anekgujarati/v4/l7g_bj5oysqknvkCo2T_8FuiIRBA7lncQUmbIBEtPKiYYQhRwyBxCD-0l5C7w0KgB7Lm7g.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/anekgujarati/v4/l7g_bj5oysqknvkCo2T_8FuiIRBA7lncQUmbIBEtPKiYYQhRwyBxCD-0SZC7w0KgB7Lm7g.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/anekgujarati/v4/l7g_bj5oysqknvkCo2T_8FuiIRBA7lncQUmbIBEtPKiYYQhRwyBxCD-0F5C7w0KgB7Lm7g.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/anekgujarati/v4/l7g_bj5oysqknvkCo2T_8FuiIRBA7lncQUmbIBEtPKiYYQhRwyBxCD-0JZC7w0KgB7Lm7g.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/anekgujarati/v4/l7g_bj5oysqknvkCo2T_8FuiIRBA7lncQUmbIBEtPKiYYQhRwyBxCD-0yZe7w0KgB7Lm7g.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/anekgujarati/v4/l7g_bj5oysqknvkCo2T_8FuiIRBA7lncQUmbIBEtPKiYYQhRwyBxCD-08Je7w0KgB7Lm7g.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/anekgujarati/v4/l7g_bj5oysqknvkCo2T_8FuiIRBA7lncQUmbIBEtPKiYYQhRwyBxCD-0l5e7w0KgB7Lm7g.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Anek Gurmukhi\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"gurmukhi\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v4\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/anekgurmukhi/v4/0QIAMXRO_YSkA0quVLY79JnHybfeEOrXCa9Dmd9Ql6a6R_vEMc5TaLkbd5ppXK41H6DjbA.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/anekgurmukhi/v4/0QIAMXRO_YSkA0quVLY79JnHybfeEOrXCa9Dmd9Ql6a6R_vEMc5TaLkb95tpXK41H6DjbA.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/anekgurmukhi/v4/0QIAMXRO_YSkA0quVLY79JnHybfeEOrXCa9Dmd9Ql6a6R_vEMc5TaLkbKZtpXK41H6DjbA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/anekgurmukhi/v4/0QIAMXRO_YSkA0quVLY79JnHybfeEOrXCa9Dmd9Ql6a6R_vEMc5TaLkbd5tpXK41H6DjbA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/anekgurmukhi/v4/0QIAMXRO_YSkA0quVLY79JnHybfeEOrXCa9Dmd9Ql6a6R_vEMc5TaLkbRZtpXK41H6DjbA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/anekgurmukhi/v4/0QIAMXRO_YSkA0quVLY79JnHybfeEOrXCa9Dmd9Ql6a6R_vEMc5TaLkbqZxpXK41H6DjbA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/anekgurmukhi/v4/0QIAMXRO_YSkA0quVLY79JnHybfeEOrXCa9Dmd9Ql6a6R_vEMc5TaLkbkJxpXK41H6DjbA.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/anekgurmukhi/v4/0QIAMXRO_YSkA0quVLY79JnHybfeEOrXCa9Dmd9Ql6a6R_vEMc5TaLkb95xpXK41H6DjbA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Anek Kannada\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"kannada\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v4\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/anekkannada/v4/raxcHiCNvNMKe1CKFsINYFlgkEIwGa8nL6ruWJg1j--h8pvBKSiw4dFDEAukVReA1oef.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/anekkannada/v4/raxcHiCNvNMKe1CKFsINYFlgkEIwGa8nL6ruWJg1j--h8pvBKSiw4dHDEQukVReA1oef.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/anekkannada/v4/raxcHiCNvNMKe1CKFsINYFlgkEIwGa8nL6ruWJg1j--h8pvBKSiw4dEdEQukVReA1oef.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/anekkannada/v4/raxcHiCNvNMKe1CKFsINYFlgkEIwGa8nL6ruWJg1j--h8pvBKSiw4dFDEQukVReA1oef.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/anekkannada/v4/raxcHiCNvNMKe1CKFsINYFlgkEIwGa8nL6ruWJg1j--h8pvBKSiw4dFxEQukVReA1oef.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/anekkannada/v4/raxcHiCNvNMKe1CKFsINYFlgkEIwGa8nL6ruWJg1j--h8pvBKSiw4dGdFgukVReA1oef.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/anekkannada/v4/raxcHiCNvNMKe1CKFsINYFlgkEIwGa8nL6ruWJg1j--h8pvBKSiw4dGkFgukVReA1oef.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/anekkannada/v4/raxcHiCNvNMKe1CKFsINYFlgkEIwGa8nL6ruWJg1j--h8pvBKSiw4dHDFgukVReA1oef.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Anek Latin\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v4\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/aneklatin/v4/co3pmWZulTRoU4a8dqrWiajBS5ByUkvdrluH-xWG5uJTY4x-L3PuR7EZKdClWL3kgw.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/aneklatin/v4/co3pmWZulTRoU4a8dqrWiajBS5ByUkvdrluH-xWG5uJTY4x-L3Pux7AZKdClWL3kgw.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/aneklatin/v4/co3pmWZulTRoU4a8dqrWiajBS5ByUkvdrluH-xWG5uJTY4x-L3PuGbAZKdClWL3kgw.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/aneklatin/v4/co3pmWZulTRoU4a8dqrWiajBS5ByUkvdrluH-xWG5uJTY4x-L3PuR7AZKdClWL3kgw.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/aneklatin/v4/co3pmWZulTRoU4a8dqrWiajBS5ByUkvdrluH-xWG5uJTY4x-L3PudbAZKdClWL3kgw.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/aneklatin/v4/co3pmWZulTRoU4a8dqrWiajBS5ByUkvdrluH-xWG5uJTY4x-L3PumbcZKdClWL3kgw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/aneklatin/v4/co3pmWZulTRoU4a8dqrWiajBS5ByUkvdrluH-xWG5uJTY4x-L3PuoLcZKdClWL3kgw.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/aneklatin/v4/co3pmWZulTRoU4a8dqrWiajBS5ByUkvdrluH-xWG5uJTY4x-L3Pux7cZKdClWL3kgw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Anek Malayalam\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"malayalam\"\n\t\t\t],\n\t\t\t\"version\": \"v4\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/anekmalayalam/v4/6qLjKZActRTs_mZAJUZWWkhke0nYa_vC8_Azq3-gP1SReZeOtqQuDVUTUZu_HMr5PDO71Qs.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/anekmalayalam/v4/6qLjKZActRTs_mZAJUZWWkhke0nYa_vC8_Azq3-gP1SReZeOtqQuDVUTURu-HMr5PDO71Qs.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/anekmalayalam/v4/6qLjKZActRTs_mZAJUZWWkhke0nYa_vC8_Azq3-gP1SReZeOtqQuDVUTUcW-HMr5PDO71Qs.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/anekmalayalam/v4/6qLjKZActRTs_mZAJUZWWkhke0nYa_vC8_Azq3-gP1SReZeOtqQuDVUTUZu-HMr5PDO71Qs.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/anekmalayalam/v4/6qLjKZActRTs_mZAJUZWWkhke0nYa_vC8_Azq3-gP1SReZeOtqQuDVUTUam-HMr5PDO71Qs.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/anekmalayalam/v4/6qLjKZActRTs_mZAJUZWWkhke0nYa_vC8_Azq3-gP1SReZeOtqQuDVUTUUW5HMr5PDO71Qs.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/anekmalayalam/v4/6qLjKZActRTs_mZAJUZWWkhke0nYa_vC8_Azq3-gP1SReZeOtqQuDVUTUXy5HMr5PDO71Qs.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/anekmalayalam/v4/6qLjKZActRTs_mZAJUZWWkhke0nYa_vC8_Azq3-gP1SReZeOtqQuDVUTURu5HMr5PDO71Qs.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Anek Odia\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"oriya\"\n\t\t\t],\n\t\t\t\"version\": \"v4\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/anekodia/v4/TK3PWkoJARApz5UCd345tuevwwQX0CwsoYkAWgWYevAauivBUnmZf63mXZAtm_es.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/anekodia/v4/TK3PWkoJARApz5UCd345tuevwwQX0CwsoYkAWgWYevAauivBUnkZfq3mXZAtm_es.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/anekodia/v4/TK3PWkoJARApz5UCd345tuevwwQX0CwsoYkAWgWYevAauivBUnnHfq3mXZAtm_es.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/anekodia/v4/TK3PWkoJARApz5UCd345tuevwwQX0CwsoYkAWgWYevAauivBUnmZfq3mXZAtm_es.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/anekodia/v4/TK3PWkoJARApz5UCd345tuevwwQX0CwsoYkAWgWYevAauivBUnmrfq3mXZAtm_es.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/anekodia/v4/TK3PWkoJARApz5UCd345tuevwwQX0CwsoYkAWgWYevAauivBUnlHea3mXZAtm_es.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/anekodia/v4/TK3PWkoJARApz5UCd345tuevwwQX0CwsoYkAWgWYevAauivBUnl-ea3mXZAtm_es.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/anekodia/v4/TK3PWkoJARApz5UCd345tuevwwQX0CwsoYkAWgWYevAauivBUnkZea3mXZAtm_es.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Anek Tamil\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"tamil\"\n\t\t\t],\n\t\t\t\"version\": \"v4\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/anektamil/v4/XLYJIZH2bYJHGYtPGSbUB8JKTp-_9n55SsLHW0WZez6TjtkDu3uNQiZ6q4v4oegjOQ.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/anektamil/v4/XLYJIZH2bYJHGYtPGSbUB8JKTp-_9n55SsLHW0WZez6TjtkDu3uNwid6q4v4oegjOQ.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/anektamil/v4/XLYJIZH2bYJHGYtPGSbUB8JKTp-_9n55SsLHW0WZez6TjtkDu3uNHCd6q4v4oegjOQ.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/anektamil/v4/XLYJIZH2bYJHGYtPGSbUB8JKTp-_9n55SsLHW0WZez6TjtkDu3uNQid6q4v4oegjOQ.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/anektamil/v4/XLYJIZH2bYJHGYtPGSbUB8JKTp-_9n55SsLHW0WZez6TjtkDu3uNcCd6q4v4oegjOQ.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/anektamil/v4/XLYJIZH2bYJHGYtPGSbUB8JKTp-_9n55SsLHW0WZez6TjtkDu3uNnCB6q4v4oegjOQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/anektamil/v4/XLYJIZH2bYJHGYtPGSbUB8JKTp-_9n55SsLHW0WZez6TjtkDu3uNpSB6q4v4oegjOQ.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/anektamil/v4/XLYJIZH2bYJHGYtPGSbUB8JKTp-_9n55SsLHW0WZez6TjtkDu3uNwiB6q4v4oegjOQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Anek Telugu\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"telugu\"\n\t\t\t],\n\t\t\t\"version\": \"v4\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/anektelugu/v4/LhWLMVrUNvsddMtYGCx4FcVWOjlwE1WgXdoJ-5XHMl2DkooGK7i13y-_oE2G2ep10_8.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/anektelugu/v4/LhWLMVrUNvsddMtYGCx4FcVWOjlwE1WgXdoJ-5XHMl2DkooGK7i136--oE2G2ep10_8.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/anektelugu/v4/LhWLMVrUNvsddMtYGCx4FcVWOjlwE1WgXdoJ-5XHMl2DkooGK7i133G-oE2G2ep10_8.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/anektelugu/v4/LhWLMVrUNvsddMtYGCx4FcVWOjlwE1WgXdoJ-5XHMl2DkooGK7i13y--oE2G2ep10_8.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/anektelugu/v4/LhWLMVrUNvsddMtYGCx4FcVWOjlwE1WgXdoJ-5XHMl2DkooGK7i13x2-oE2G2ep10_8.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/anektelugu/v4/LhWLMVrUNvsddMtYGCx4FcVWOjlwE1WgXdoJ-5XHMl2DkooGK7i13_G5oE2G2ep10_8.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/anektelugu/v4/LhWLMVrUNvsddMtYGCx4FcVWOjlwE1WgXdoJ-5XHMl2DkooGK7i138i5oE2G2ep10_8.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/anektelugu/v4/LhWLMVrUNvsddMtYGCx4FcVWOjlwE1WgXdoJ-5XHMl2DkooGK7i136-5oE2G2ep10_8.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Angkor\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"khmer\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v28\",\n\t\t\t\"lastModified\": \"2022-04-20\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/angkor/v28/H4cmBXyAlsPdnlb-8iw-4Lqggw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Annie Use Your Telescope\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/annieuseyourtelescope/v18/daaLSS4tI2qYYl3Jq9s_Hu74xwktnlKxH6osGVGjlDfB3UUVZA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Anonymous Pro\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/anonymouspro/v21/rP2Bp2a15UIB7Un-bOeISG3pLlw89CH98Ko.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/anonymouspro/v21/rP2fp2a15UIB7Un-bOeISG3pHl428AP44Kqr2Q.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/anonymouspro/v21/rP2cp2a15UIB7Un-bOeISG3pFuAT0CnW7KOywKo.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/anonymouspro/v21/rP2ap2a15UIB7Un-bOeISG3pHl4OTCzc6IG30KqB9Q.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"monospace\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Antic\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/antic/v19/TuGfUVB8XY5DRaZLodgzydtk.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Antic Didone\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/anticdidone/v16/RWmPoKKX6u8sp8fIWdnDKqDiqYsGBGBzCw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Antic Slab\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/anticslab/v16/bWt97fPFfRzkCa9Jlp6IWcJWXW5p5Qo.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Anton\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v23\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/anton/v23/1Ptgg87LROyAm0K08i4gS7lu.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Antonio\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/antonio/v11/gNMbW3NwSYq_9WD34ngK5F8vR8T0PVxx8BtIY2DwSXlM.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/antonio/v11/gNMbW3NwSYq_9WD34ngK5F8vR8T0PVzx8RtIY2DwSXlM.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/antonio/v11/gNMbW3NwSYq_9WD34ngK5F8vR8T0PVwv8RtIY2DwSXlM.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/antonio/v11/gNMbW3NwSYq_9WD34ngK5F8vR8T0PVxx8RtIY2DwSXlM.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/antonio/v11/gNMbW3NwSYq_9WD34ngK5F8vR8T0PVxD8RtIY2DwSXlM.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/antonio/v11/gNMbW3NwSYq_9WD34ngK5F8vR8T0PVyv9htIY2DwSXlM.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/antonio/v11/gNMbW3NwSYq_9WD34ngK5F8vR8T0PVyW9htIY2DwSXlM.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Anybody\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v4\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/anybody/v4/VuJbdNvK2Ib2ppdWYq311GH32hxIv0sd5grncSUi2F_Wim4J12HPrsXD_nBPpQ.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/anybody/v4/VuJbdNvK2Ib2ppdWYq311GH32hxIv0sd5grncSUi2F_Wim4JV2DPrsXD_nBPpQ.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/anybody/v4/VuJbdNvK2Ib2ppdWYq311GH32hxIv0sd5grncSUi2F_Wim4JiWDPrsXD_nBPpQ.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/anybody/v4/VuJbdNvK2Ib2ppdWYq311GH32hxIv0sd5grncSUi2F_Wim4J12DPrsXD_nBPpQ.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/anybody/v4/VuJbdNvK2Ib2ppdWYq311GH32hxIv0sd5grncSUi2F_Wim4J5WDPrsXD_nBPpQ.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/anybody/v4/VuJbdNvK2Ib2ppdWYq311GH32hxIv0sd5grncSUi2F_Wim4JCWfPrsXD_nBPpQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/anybody/v4/VuJbdNvK2Ib2ppdWYq311GH32hxIv0sd5grncSUi2F_Wim4JMGfPrsXD_nBPpQ.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/anybody/v4/VuJbdNvK2Ib2ppdWYq311GH32hxIv0sd5grncSUi2F_Wim4JV2fPrsXD_nBPpQ.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/anybody/v4/VuJbdNvK2Ib2ppdWYq311GH32hxIv0sd5grncSUi2F_Wim4JfmfPrsXD_nBPpQ.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/anybody/v4/VuJddNvK2Ib2ppdWSKTHN4GOiYrmuF7VpPiuQ9r6sTRMJGkcHyMn7M_H3HVfpcHY.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/anybody/v4/VuJddNvK2Ib2ppdWSKTHN4GOiYrmuF7VpPiuQ9r6sTRMJGkcHyOn7c_H3HVfpcHY.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/anybody/v4/VuJddNvK2Ib2ppdWSKTHN4GOiYrmuF7VpPiuQ9r6sTRMJGkcHyN57c_H3HVfpcHY.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/anybody/v4/VuJddNvK2Ib2ppdWSKTHN4GOiYrmuF7VpPiuQ9r6sTRMJGkcHyMn7c_H3HVfpcHY.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/anybody/v4/VuJddNvK2Ib2ppdWSKTHN4GOiYrmuF7VpPiuQ9r6sTRMJGkcHyMV7c_H3HVfpcHY.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/anybody/v4/VuJddNvK2Ib2ppdWSKTHN4GOiYrmuF7VpPiuQ9r6sTRMJGkcHyP56s_H3HVfpcHY.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/anybody/v4/VuJddNvK2Ib2ppdWSKTHN4GOiYrmuF7VpPiuQ9r6sTRMJGkcHyPA6s_H3HVfpcHY.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/anybody/v4/VuJddNvK2Ib2ppdWSKTHN4GOiYrmuF7VpPiuQ9r6sTRMJGkcHyOn6s_H3HVfpcHY.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/anybody/v4/VuJddNvK2Ib2ppdWSKTHN4GOiYrmuF7VpPiuQ9r6sTRMJGkcHyOO6s_H3HVfpcHY.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Arapey\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/arapey/v16/-W__XJn-UDDA2RC6Z9AcZkIzeg.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/arapey/v16/-W_9XJn-UDDA2RCKZdoYREcjeo0k.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Arbutus\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/arbutus/v24/NaPYcZ7dG_5J3poob9JtryO8fMU.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Arbutus Slab\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/arbutusslab/v16/oY1Z8e7OuLXkJGbXtr5ba7ZVa68dJlaFAQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Architects Daughter\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/architectsdaughter/v18/KtkxAKiDZI_td1Lkx62xHZHDtgO_Y-bvfY5q4szgE-Q.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Archivo\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/archivo/v18/k3k6o8UDI-1M0wlSV9XAw6lQkqWY8Q82sJaRE-NWIDdgffTTNDJp8B1oJ0vyVQ.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/archivo/v18/k3k6o8UDI-1M0wlSV9XAw6lQkqWY8Q82sJaRE-NWIDdgffTTtDNp8B1oJ0vyVQ.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/archivo/v18/k3k6o8UDI-1M0wlSV9XAw6lQkqWY8Q82sJaRE-NWIDdgffTTajNp8B1oJ0vyVQ.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/archivo/v18/k3k6o8UDI-1M0wlSV9XAw6lQkqWY8Q82sJaRE-NWIDdgffTTNDNp8B1oJ0vyVQ.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/archivo/v18/k3k6o8UDI-1M0wlSV9XAw6lQkqWY8Q82sJaRE-NWIDdgffTTBjNp8B1oJ0vyVQ.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/archivo/v18/k3k6o8UDI-1M0wlSV9XAw6lQkqWY8Q82sJaRE-NWIDdgffTT6jRp8B1oJ0vyVQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/archivo/v18/k3k6o8UDI-1M0wlSV9XAw6lQkqWY8Q82sJaRE-NWIDdgffTT0zRp8B1oJ0vyVQ.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/archivo/v18/k3k6o8UDI-1M0wlSV9XAw6lQkqWY8Q82sJaRE-NWIDdgffTTtDRp8B1oJ0vyVQ.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/archivo/v18/k3k6o8UDI-1M0wlSV9XAw6lQkqWY8Q82sJaRE-NWIDdgffTTnTRp8B1oJ0vyVQ.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/archivo/v18/k3k8o8UDI-1M0wlSfdzyIEkpwTM29hr-8mTYIRyOSVz60_PG_HCBshdsBU7iVdxQ.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/archivo/v18/k3k8o8UDI-1M0wlSfdzyIEkpwTM29hr-8mTYIRyOSVz60_PG_HABsxdsBU7iVdxQ.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/archivo/v18/k3k8o8UDI-1M0wlSfdzyIEkpwTM29hr-8mTYIRyOSVz60_PG_HDfsxdsBU7iVdxQ.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/archivo/v18/k3k8o8UDI-1M0wlSfdzyIEkpwTM29hr-8mTYIRyOSVz60_PG_HCBsxdsBU7iVdxQ.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/archivo/v18/k3k8o8UDI-1M0wlSfdzyIEkpwTM29hr-8mTYIRyOSVz60_PG_HCzsxdsBU7iVdxQ.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/archivo/v18/k3k8o8UDI-1M0wlSfdzyIEkpwTM29hr-8mTYIRyOSVz60_PG_HBftBdsBU7iVdxQ.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/archivo/v18/k3k8o8UDI-1M0wlSfdzyIEkpwTM29hr-8mTYIRyOSVz60_PG_HBmtBdsBU7iVdxQ.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/archivo/v18/k3k8o8UDI-1M0wlSfdzyIEkpwTM29hr-8mTYIRyOSVz60_PG_HABtBdsBU7iVdxQ.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/archivo/v18/k3k8o8UDI-1M0wlSfdzyIEkpwTM29hr-8mTYIRyOSVz60_PG_HAotBdsBU7iVdxQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Archivo Black\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/archivoblack/v17/HTxqL289NzCGg4MzN6KJ7eW6OYuP_x7yx3A.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Archivo Narrow\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v28\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/archivonarrow/v28/tss5ApVBdCYD5Q7hcxTE1ArZ0Zz8oY2KRmwvKhhvLFGKpHOtFCQ76Q.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/archivonarrow/v28/tss5ApVBdCYD5Q7hcxTE1ArZ0Zz8oY2KRmwvKhhvHlGKpHOtFCQ76Q.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/archivonarrow/v28/tss5ApVBdCYD5Q7hcxTE1ArZ0Zz8oY2KRmwvKhhv8laKpHOtFCQ76Q.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/archivonarrow/v28/tss5ApVBdCYD5Q7hcxTE1ArZ0Zz8oY2KRmwvKhhvy1aKpHOtFCQ76Q.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/archivonarrow/v28/tss7ApVBdCYD5Q7hcxTE1ArZ0bb1k3JSLwe1hB965BJi53mpNiEr6T6Y.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/archivonarrow/v28/tss7ApVBdCYD5Q7hcxTE1ArZ0bb1k3JSLwe1hB965BJQ53mpNiEr6T6Y.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/archivonarrow/v28/tss7ApVBdCYD5Q7hcxTE1ArZ0bb1k3JSLwe1hB965BK84HmpNiEr6T6Y.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/archivonarrow/v28/tss7ApVBdCYD5Q7hcxTE1ArZ0bb1k3JSLwe1hB965BKF4HmpNiEr6T6Y.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Are You Serious\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/areyouserious/v10/ll8kK2GVSSr-PtjQ5nONVcNn4306hT9nCGRayg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Aref Ruqaa\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v25\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/arefruqaa/v25/WwkbxPW1E165rajQKDulEIAiVNo5xNY.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/arefruqaa/v25/WwkYxPW1E165rajQKDulKDwNcNIS2N_7Bdk.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Aref Ruqaa Ink\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v5\",\n\t\t\t\"lastModified\": \"2022-09-14\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/arefruqaaink/v5/1q2fY5WOGUFlt84GTOkP6Kdx72ThVIGpgnxL.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/arefruqaaink/v5/1q2cY5WOGUFlt84GTOkP6Kdx71xde6WhqWBCyxWn.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Arima\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"malayalam\",\n\t\t\t\t\"tamil\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/arima/v1/neIWzCqmt4Aup_qE1nFWqxI1RZX1YTE-pQGOyYw2fw.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/arima/v1/neIWzCqmt4Aup_qE1nFWqxI1RZX14TA-pQGOyYw2fw.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/arima/v1/neIWzCqmt4Aup_qE1nFWqxI1RZX1PzA-pQGOyYw2fw.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/arima/v1/neIWzCqmt4Aup_qE1nFWqxI1RZX1YTA-pQGOyYw2fw.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/arima/v1/neIWzCqmt4Aup_qE1nFWqxI1RZX1UzA-pQGOyYw2fw.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/arima/v1/neIWzCqmt4Aup_qE1nFWqxI1RZX1vzc-pQGOyYw2fw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/arima/v1/neIWzCqmt4Aup_qE1nFWqxI1RZX1hjc-pQGOyYw2fw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Arima Madurai\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"tamil\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/arimamadurai/v14/t5t4IRoeKYORG0WNMgnC3seB1V3PqrGCch4Drg.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/arimamadurai/v14/t5t7IRoeKYORG0WNMgnC3seB1fHuipusfhcat2c.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/arimamadurai/v14/t5t7IRoeKYORG0WNMgnC3seB1ZXtipusfhcat2c.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/arimamadurai/v14/t5tmIRoeKYORG0WNMgnC3seB7TnFrpOHYh4.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/arimamadurai/v14/t5t7IRoeKYORG0WNMgnC3seB1c3sipusfhcat2c.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/arimamadurai/v14/t5t7IRoeKYORG0WNMgnC3seB1YXqipusfhcat2c.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/arimamadurai/v14/t5t7IRoeKYORG0WNMgnC3seB1Znpipusfhcat2c.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/arimamadurai/v14/t5t7IRoeKYORG0WNMgnC3seB1b3oipusfhcat2c.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Arimo\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v27\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/arimo/v27/P5sfzZCDf9_T_3cV7NCUECyoxNk37cxsBxDAVQI4aA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/arimo/v27/P5sfzZCDf9_T_3cV7NCUECyoxNk338xsBxDAVQI4aA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/arimo/v27/P5sfzZCDf9_T_3cV7NCUECyoxNk3M8tsBxDAVQI4aA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/arimo/v27/P5sfzZCDf9_T_3cV7NCUECyoxNk3CstsBxDAVQI4aA.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/arimo/v27/P5sdzZCDf9_T_10c3i9MeUcyat4iJY-ERBrEdwcoaKww.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/arimo/v27/P5sdzZCDf9_T_10c3i9MeUcyat4iJY-2RBrEdwcoaKww.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/arimo/v27/P5sdzZCDf9_T_10c3i9MeUcyat4iJY9aQxrEdwcoaKww.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/arimo/v27/P5sdzZCDf9_T_10c3i9MeUcyat4iJY9jQxrEdwcoaKww.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Arizonia\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/arizonia/v19/neIIzCemt4A5qa7mv6WGHK06UY30.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Armata\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/armata/v19/gokvH63_HV5jQ-E9lD53Q2u_mQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Arsenal\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/arsenal/v12/wXKrE3kQtZQ4pF3D11_WAewrhXY.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/arsenal/v12/wXKpE3kQtZQ4pF3D513cBc4ulXYrtA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/arsenal/v12/wXKuE3kQtZQ4pF3D7-P5JeQAmX8yrdk.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/arsenal/v12/wXKsE3kQtZQ4pF3D513kueEKnV03vdnKjw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Artifika\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2023-01-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/artifika/v21/VEMyRoxzronptCuxu6Wt5jDtreOL.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Arvo\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/arvo/v20/tDbD2oWUg0MKmSAa7Lzr7vs.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/arvo/v20/tDbN2oWUg0MKqSIQ6J7u_vvijQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/arvo/v20/tDbM2oWUg0MKoZw1yLTA8vL7lAE.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/arvo/v20/tDbO2oWUg0MKqSIoVLHK9tD-hAHkGg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Arya\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/arya/v19/ga6CawNG-HJd9Ub1-beqdFE.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/arya/v19/ga6NawNG-HJdzfra3b-BaFg3dRE.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Asap\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v26\",\n\t\t\t\"lastModified\": \"2022-11-18\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/asap/v26/KFOOCniXp96a4Tc2DaTeuDAoKsE617JFc49knOIYdjTYkqQsLmOXoA7Glw.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/asap/v26/KFOOCniXp96a4Tc2DaTeuDAoKsE617JFc49knOIYdjTYEqUsLmOXoA7Glw.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/asap/v26/KFOOCniXp96a4Tc2DaTeuDAoKsE617JFc49knOIYdjTYzKUsLmOXoA7Glw.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/asap/v26/KFOOCniXp96a4Tc2DaTeuDAoKsE617JFc49knOIYdjTYkqUsLmOXoA7Glw.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/asap/v26/KFOOCniXp96a4Tc2DaTeuDAoKsE617JFc49knOIYdjTYoKUsLmOXoA7Glw.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/asap/v26/KFOOCniXp96a4Tc2DaTeuDAoKsE617JFc49knOIYdjTYTKIsLmOXoA7Glw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/asap/v26/KFOOCniXp96a4Tc2DaTeuDAoKsE617JFc49knOIYdjTYdaIsLmOXoA7Glw.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/asap/v26/KFOOCniXp96a4Tc2DaTeuDAoKsE617JFc49knOIYdjTYEqIsLmOXoA7Glw.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/asap/v26/KFOOCniXp96a4Tc2DaTeuDAoKsE617JFc49knOIYdjTYO6IsLmOXoA7Glw.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/asap/v26/KFOMCniXp96ayz4E7kSn66aGLdTylUAMQXC89YmC2DPNWubEbGmTggvWl0Qn.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/asap/v26/KFOMCniXp96ayz4E7kSn66aGLdTylUAMQXC89YmC2DPNWuZEbWmTggvWl0Qn.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/asap/v26/KFOMCniXp96ayz4E7kSn66aGLdTylUAMQXC89YmC2DPNWuaabWmTggvWl0Qn.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/asap/v26/KFOMCniXp96ayz4E7kSn66aGLdTylUAMQXC89YmC2DPNWubEbWmTggvWl0Qn.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/asap/v26/KFOMCniXp96ayz4E7kSn66aGLdTylUAMQXC89YmC2DPNWub2bWmTggvWl0Qn.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/asap/v26/KFOMCniXp96ayz4E7kSn66aGLdTylUAMQXC89YmC2DPNWuYaammTggvWl0Qn.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/asap/v26/KFOMCniXp96ayz4E7kSn66aGLdTylUAMQXC89YmC2DPNWuYjammTggvWl0Qn.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/asap/v26/KFOMCniXp96ayz4E7kSn66aGLdTylUAMQXC89YmC2DPNWuZEammTggvWl0Qn.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/asap/v26/KFOMCniXp96ayz4E7kSn66aGLdTylUAMQXC89YmC2DPNWuZtammTggvWl0Qn.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Asap Condensed\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-11-18\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/asapcondensed/v16/pxieypY1o9NHyXh3WvSbGSggdO9DSWlEgGqgp-pO.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/asapcondensed/v16/pxiYypY1o9NHyXh3WvSbGSggdOeJUIFFim6CovpOkXA.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/asapcondensed/v16/pxieypY1o9NHyXh3WvSbGSggdO8nSmlEgGqgp-pO.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/asapcondensed/v16/pxiYypY1o9NHyXh3WvSbGSggdOeJUOVGim6CovpOkXA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/asapcondensed/v16/pxidypY1o9NHyXh3WvSbGSggdNeLYk1Mq3ap.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/asapcondensed/v16/pxifypY1o9NHyXh3WvSbGSggdOeJaElurmapvvM.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/asapcondensed/v16/pxieypY1o9NHyXh3WvSbGSggdO9_S2lEgGqgp-pO.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/asapcondensed/v16/pxiYypY1o9NHyXh3WvSbGSggdOeJUL1Him6CovpOkXA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/asapcondensed/v16/pxieypY1o9NHyXh3WvSbGSggdO9TTGlEgGqgp-pO.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/asapcondensed/v16/pxiYypY1o9NHyXh3WvSbGSggdOeJUJFAim6CovpOkXA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/asapcondensed/v16/pxieypY1o9NHyXh3WvSbGSggdO83TWlEgGqgp-pO.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/asapcondensed/v16/pxiYypY1o9NHyXh3WvSbGSggdOeJUPVBim6CovpOkXA.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/asapcondensed/v16/pxieypY1o9NHyXh3WvSbGSggdO8rTmlEgGqgp-pO.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/asapcondensed/v16/pxiYypY1o9NHyXh3WvSbGSggdOeJUOlCim6CovpOkXA.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/asapcondensed/v16/pxieypY1o9NHyXh3WvSbGSggdO8PT2lEgGqgp-pO.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/asapcondensed/v16/pxiYypY1o9NHyXh3WvSbGSggdOeJUM1Dim6CovpOkXA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Asar\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/asar/v22/sZlLdRyI6TBIXkYQDLlTW6E.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Asset\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/asset/v24/SLXGc1na-mM4cWImRJqExst1.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Assistant\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/assistant/v18/2sDPZGJYnIjSi6H75xkZZE1I0yCmYzzQtmZnEGGf3qGuvM4.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/assistant/v18/2sDPZGJYnIjSi6H75xkZZE1I0yCmYzzQtrhnEGGf3qGuvM4.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/assistant/v18/2sDPZGJYnIjSi6H75xkZZE1I0yCmYzzQtuZnEGGf3qGuvM4.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/assistant/v18/2sDPZGJYnIjSi6H75xkZZE1I0yCmYzzQttRnEGGf3qGuvM4.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/assistant/v18/2sDPZGJYnIjSi6H75xkZZE1I0yCmYzzQtjhgEGGf3qGuvM4.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/assistant/v18/2sDPZGJYnIjSi6H75xkZZE1I0yCmYzzQtgFgEGGf3qGuvM4.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/assistant/v18/2sDPZGJYnIjSi6H75xkZZE1I0yCmYzzQtmZgEGGf3qGuvM4.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Astloch\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v26\",\n\t\t\t\"lastModified\": \"2022-04-20\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/astloch/v26/TuGRUVJ8QI5GSeUjq9wRzMtkH1Q.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/astloch/v26/TuGUUVJ8QI5GSeUjk2A-6MNPA10xLMQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Asul\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/asul/v19/VuJ-dNjKxYr46fMFXK78JIg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/asul/v19/VuJxdNjKxYr40U8qeKbXOIFneRo.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Athiti\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"thai\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/athiti/v12/pe0sMISdLIZIv1wAxDNyAv2-C99ycg.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/athiti/v12/pe0sMISdLIZIv1wAoDByAv2-C99ycg.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/athiti/v12/pe0vMISdLIZIv1w4DBhWCtaiAg.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/athiti/v12/pe0sMISdLIZIv1wA-DFyAv2-C99ycg.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/athiti/v12/pe0sMISdLIZIv1wA1DZyAv2-C99ycg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/athiti/v12/pe0sMISdLIZIv1wAsDdyAv2-C99ycg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Atkinson Hyperlegible\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/atkinsonhyperlegible/v10/9Bt23C1KxNDXMspQ1lPyU89-1h6ONRlW45GE5ZgpewSSbQ.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/atkinsonhyperlegible/v10/9Bt43C1KxNDXMspQ1lPyU89-1h6ONRlW45G055ItWQGCbUWn.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/atkinsonhyperlegible/v10/9Bt73C1KxNDXMspQ1lPyU89-1h6ONRlW45G8WbcNcy-OZFy-FA.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/atkinsonhyperlegible/v10/9Bt93C1KxNDXMspQ1lPyU89-1h6ONRlW45G056qRdiWKRlmuFH24.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Atma\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"bengali\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/atma/v15/uK_z4rqWc-Eoo8JzKjc9PvedRkM.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/atma/v15/uK_84rqWc-Eom25bDj8WIv4.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/atma/v15/uK_z4rqWc-Eoo5pyKjc9PvedRkM.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/atma/v15/uK_z4rqWc-Eoo7Z1Kjc9PvedRkM.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/atma/v15/uK_z4rqWc-Eoo9J0Kjc9PvedRkM.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Atomic Age\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v27\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/atomicage/v27/f0Xz0eug6sdmRFkYZZGL58Ht9a8GYeA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Aubrey\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v28\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/aubrey/v28/q5uGsou7NPBw-p7vugNsCxVEgA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Audiowide\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/audiowide/v16/l7gdbjpo0cum0ckerWCtkQXPExpQBw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Autour One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/autourone/v24/UqyVK80cP25l3fJgbdfbk5lWVscxdKE.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Average\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/average/v18/fC1hPYBHe23MxA7rIeJwVWytTyk.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Average Sans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/averagesans/v16/1Ptpg8fLXP2dlAXR-HlJJNJPBdqazVoK4A.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Averia Gruesa Libre\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/averiagruesalibre/v22/NGSov4nEGEktOaDRKsY-1dhh8eEtIx3ZUmmJw0SLRA8.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Averia Libre\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/averialibre/v16/2V0FKIcMGZEnV6xygz7eNjEarovtb07t-pQgTw.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/averialibre/v16/2V0HKIcMGZEnV6xygz7eNjESAJFhbUTp2JEwT4Sk.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/averialibre/v16/2V0aKIcMGZEnV6xygz7eNjEiAqPJZ2Xx8w.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/averialibre/v16/2V0EKIcMGZEnV6xygz7eNjESAKnNRWDh8405.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/averialibre/v16/2V0FKIcMGZEnV6xygz7eNjEavoztb07t-pQgTw.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/averialibre/v16/2V0HKIcMGZEnV6xygz7eNjESAJFxakTp2JEwT4Sk.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Averia Sans Libre\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/averiasanslibre/v17/ga6SaxZG_G5OvCf_rt7FH3B6BHLMEd3lMKcQJZP1LmD9.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/averiasanslibre/v17/ga6caxZG_G5OvCf_rt7FH3B6BHLMEdVLKisSL5fXK3D9qtg.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/averiasanslibre/v17/ga6XaxZG_G5OvCf_rt7FH3B6BHLMEeVJGIMYDo_8.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/averiasanslibre/v17/ga6RaxZG_G5OvCf_rt7FH3B6BHLMEdVLEoc6C5_8N3k.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/averiasanslibre/v17/ga6SaxZG_G5OvCf_rt7FH3B6BHLMEd31N6cQJZP1LmD9.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/averiasanslibre/v17/ga6caxZG_G5OvCf_rt7FH3B6BHLMEdVLKjsVL5fXK3D9qtg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Averia Serif Libre\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/averiaseriflibre/v16/neIVzD2ms4wxr6GvjeD0X88SHPyX2xYGCSmqwacqdrKvbQ.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/averiaseriflibre/v16/neIbzD2ms4wxr6GvjeD0X88SHPyX2xYOpzMmw60uVLe_bXHq.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/averiaseriflibre/v16/neIWzD2ms4wxr6GvjeD0X88SHPyX2xY-pQGOyYw2fw.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/averiaseriflibre/v16/neIUzD2ms4wxr6GvjeD0X88SHPyX2xYOpwuK64kmf6u2.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/averiaseriflibre/v16/neIVzD2ms4wxr6GvjeD0X88SHPyX2xYGGS6qwacqdrKvbQ.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/averiaseriflibre/v16/neIbzD2ms4wxr6GvjeD0X88SHPyX2xYOpzM2xK0uVLe_bXHq.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Azeret Mono\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/azeretmono/v11/3XF5ErsiyJsY9O_Gepph-FvtTQgMQUdNekSfnPRh0raa-5s3AA.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/azeretmono/v11/3XF5ErsiyJsY9O_Gepph-FvtTQgMQUdNekSfHPVh0raa-5s3AA.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/azeretmono/v11/3XF5ErsiyJsY9O_Gepph-FvtTQgMQUdNekSfwvVh0raa-5s3AA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/azeretmono/v11/3XF5ErsiyJsY9O_Gepph-FvtTQgMQUdNekSfnPVh0raa-5s3AA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/azeretmono/v11/3XF5ErsiyJsY9O_Gepph-FvtTQgMQUdNekSfrvVh0raa-5s3AA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/azeretmono/v11/3XF5ErsiyJsY9O_Gepph-FvtTQgMQUdNekSfQvJh0raa-5s3AA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/azeretmono/v11/3XF5ErsiyJsY9O_Gepph-FvtTQgMQUdNekSfe_Jh0raa-5s3AA.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/azeretmono/v11/3XF5ErsiyJsY9O_Gepph-FvtTQgMQUdNekSfHPJh0raa-5s3AA.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/azeretmono/v11/3XF5ErsiyJsY9O_Gepph-FvtTQgMQUdNekSfNfJh0raa-5s3AA.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/azeretmono/v11/3XF_ErsiyJsY9O_Gepph-HHkf_fUKCzX1EOKVLaJkLye2Z4nAN7J.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/azeretmono/v11/3XF_ErsiyJsY9O_Gepph-HHkf_fUKCzX1EOKVLYJkbye2Z4nAN7J.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/azeretmono/v11/3XF_ErsiyJsY9O_Gepph-HHkf_fUKCzX1EOKVLbXkbye2Z4nAN7J.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/azeretmono/v11/3XF_ErsiyJsY9O_Gepph-HHkf_fUKCzX1EOKVLaJkbye2Z4nAN7J.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/azeretmono/v11/3XF_ErsiyJsY9O_Gepph-HHkf_fUKCzX1EOKVLa7kbye2Z4nAN7J.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/azeretmono/v11/3XF_ErsiyJsY9O_Gepph-HHkf_fUKCzX1EOKVLZXlrye2Z4nAN7J.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/azeretmono/v11/3XF_ErsiyJsY9O_Gepph-HHkf_fUKCzX1EOKVLZulrye2Z4nAN7J.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/azeretmono/v11/3XF_ErsiyJsY9O_Gepph-HHkf_fUKCzX1EOKVLYJlrye2Z4nAN7J.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/azeretmono/v11/3XF_ErsiyJsY9O_Gepph-HHkf_fUKCzX1EOKVLYglrye2Z4nAN7J.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"monospace\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"B612\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/b612/v12/3JnySDDxiSz32jm4GDigUXw.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/b612/v12/3Jn8SDDxiSz36juyHBqlQXwdVw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/b612/v12/3Jn9SDDxiSz34oWXPDCLTXUETuE.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/b612/v12/3Jn_SDDxiSz36juKoDWBSVcBXuFb0Q.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"B612 Mono\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/b612mono/v12/kmK_Zq85QVWbN1eW6lJl1wTcquRTtg.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/b612mono/v12/kmK5Zq85QVWbN1eW6lJV1Q7YiOFDtqtf.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/b612mono/v12/kmK6Zq85QVWbN1eW6lJdayv4os9Pv7JGSg.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/b612mono/v12/kmKkZq85QVWbN1eW6lJV1TZkp8VLnbdWSg4x.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"monospace\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"BIZ UDGothic\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v8\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bizudgothic/v8/daafSTouBF7RUjnbt8p3LuKttQN98z_MbQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/bizudgothic/v8/daaASTouBF7RUjnbt8p3LuKVCSxZ-xTQZMhbaA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"BIZ UDMincho\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v9\",\n\t\t\t\"lastModified\": \"2023-01-18\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bizudmincho/v9/EJRRQgI6eOxFjBdKs38yhtW1dwT7rcpY8Q.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/bizudmincho/v9/EJROQgI6eOxFjBdKs38yhtWNyyvfpeFE-IyCrw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"BIZ UDPGothic\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v8\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bizudpgothic/v8/hES36X5pHAIBjmS84VL0Bue83nUMQWkMUAk.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/bizudpgothic/v8/hESq6X5pHAIBjmS84VL0Bue85skjZWEnTABCSQo.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"BIZ UDPMincho\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v9\",\n\t\t\t\"lastModified\": \"2023-01-18\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bizudpmincho/v9/ypvfbXOBrmYppy7oWWTg1_58nhhYtUb0gZk.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/bizudpmincho/v9/ypvCbXOBrmYppy7oWWTg1_58pqR3kU7fnZAy57k.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Babylonica\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v2\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/babylonica/v2/5aUw9_i2qxWVCAE2aHjTqDJ0-VVMoEw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Bad Script\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-04-20\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/badscript/v16/6NUT8F6PJgbFWQn47_x7lOwuzd1AZtw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Bahiana\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bahiana/v19/uU9PCBUV4YenPWJU7xPb3vyHmlI.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Bahianita\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bahianita/v17/yYLr0hTb3vuqqsBUgxWtxTvV2NJPcA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Bai Jamjuree\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"thai\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/baijamjuree/v11/LDIqapSCOBt_aeQQ7ftydoa0kePuk5A1-yiSgA.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/baijamjuree/v11/LDIoapSCOBt_aeQQ7ftydoa8W_oGkpox2S2CgOva.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/baijamjuree/v11/LDIqapSCOBt_aeQQ7ftydoa09eDuk5A1-yiSgA.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/baijamjuree/v11/LDIoapSCOBt_aeQQ7ftydoa8W_pikZox2S2CgOva.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/baijamjuree/v11/LDI1apSCOBt_aeQQ7ftydoaMWcjKm7sp8g.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/baijamjuree/v11/LDIrapSCOBt_aeQQ7ftydoa8W8LOub458jGL.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/baijamjuree/v11/LDIqapSCOBt_aeQQ7ftydoa0reHuk5A1-yiSgA.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/baijamjuree/v11/LDIoapSCOBt_aeQQ7ftydoa8W_o6kJox2S2CgOva.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/baijamjuree/v11/LDIqapSCOBt_aeQQ7ftydoa0gebuk5A1-yiSgA.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/baijamjuree/v11/LDIoapSCOBt_aeQQ7ftydoa8W_oWl5ox2S2CgOva.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/baijamjuree/v11/LDIqapSCOBt_aeQQ7ftydoa05efuk5A1-yiSgA.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/baijamjuree/v11/LDIoapSCOBt_aeQQ7ftydoa8W_pylpox2S2CgOva.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Bakbak One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v6\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bakbakone/v6/zOL54pXAl6RI-p_ardnuycRuv-hHkOs.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Ballet\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ballet/v21/QGYyz_MYZA-HM4NjuGOVnUEXme1I4Xi3C4G-EiAou6Y.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Baloo 2\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/baloo2/v16/wXK0E3kTposypRydzVT08TS3JnAmtdgazapv9Fat7WcN.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/baloo2/v16/wXK0E3kTposypRydzVT08TS3JnAmtdgozapv9Fat7WcN.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/baloo2/v16/wXK0E3kTposypRydzVT08TS3JnAmtdjEyqpv9Fat7WcN.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/baloo2/v16/wXK0E3kTposypRydzVT08TS3JnAmtdj9yqpv9Fat7WcN.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/baloo2/v16/wXK0E3kTposypRydzVT08TS3JnAmtdiayqpv9Fat7WcN.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Baloo Bhai 2\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"gujarati\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/baloobhai2/v21/sZlWdRSL-z1VEWZ4YNA7Y5ItevYWUOHDE8FvNighMXeCo-jsZzo.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/baloobhai2/v21/sZlWdRSL-z1VEWZ4YNA7Y5ItevYWUOHDE8FvNhohMXeCo-jsZzo.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/baloobhai2/v21/sZlWdRSL-z1VEWZ4YNA7Y5ItevYWUOHDE8FvNvYmMXeCo-jsZzo.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/baloobhai2/v21/sZlWdRSL-z1VEWZ4YNA7Y5ItevYWUOHDE8FvNs8mMXeCo-jsZzo.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/baloobhai2/v21/sZlWdRSL-z1VEWZ4YNA7Y5ItevYWUOHDE8FvNqgmMXeCo-jsZzo.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Baloo Bhaijaan 2\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/baloobhaijaan2/v14/zYXwKUwuEqdVGqM8tPDdAA_Y-_bMKo1EhQd2tWxo8TyRSqP4L4ppfcyC.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/baloobhaijaan2/v14/zYXwKUwuEqdVGqM8tPDdAA_Y-_bMKo1EhQd2tWxo8TyjSqP4L4ppfcyC.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/baloobhaijaan2/v14/zYXwKUwuEqdVGqM8tPDdAA_Y-_bMKo1EhQd2tWxo8TxPTaP4L4ppfcyC.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/baloobhaijaan2/v14/zYXwKUwuEqdVGqM8tPDdAA_Y-_bMKo1EhQd2tWxo8Tx2TaP4L4ppfcyC.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/baloobhaijaan2/v14/zYXwKUwuEqdVGqM8tPDdAA_Y-_bMKo1EhQd2tWxo8TwRTaP4L4ppfcyC.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Baloo Bhaina 2\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"oriya\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/baloobhaina2/v22/qWc-B6yyq4P9Adr3RtoX1q6ySgbwusXwJjkOS-XEssPvRfRLYWmZSA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/baloobhaina2/v22/qWc-B6yyq4P9Adr3RtoX1q6ySgbwusXwJjkOS-XEgMPvRfRLYWmZSA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/baloobhaina2/v22/qWc-B6yyq4P9Adr3RtoX1q6ySgbwusXwJjkOS-XEbMTvRfRLYWmZSA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/baloobhaina2/v22/qWc-B6yyq4P9Adr3RtoX1q6ySgbwusXwJjkOS-XEVcTvRfRLYWmZSA.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/baloobhaina2/v22/qWc-B6yyq4P9Adr3RtoX1q6ySgbwusXwJjkOS-XEMsTvRfRLYWmZSA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Baloo Chettan 2\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"malayalam\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/baloochettan2/v16/vm8hdRbmXEva26PK-NtuX4ynWEzF69-L4gqgkIL5CeKTO1oeH9xI2gc.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/baloochettan2/v16/vm8hdRbmXEva26PK-NtuX4ynWEzF69-L4gqgkIL5CdCTO1oeH9xI2gc.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/baloochettan2/v16/vm8hdRbmXEva26PK-NtuX4ynWEzF69-L4gqgkIL5CTyUO1oeH9xI2gc.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/baloochettan2/v16/vm8hdRbmXEva26PK-NtuX4ynWEzF69-L4gqgkIL5CQWUO1oeH9xI2gc.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/baloochettan2/v16/vm8hdRbmXEva26PK-NtuX4ynWEzF69-L4gqgkIL5CWKUO1oeH9xI2gc.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Baloo Da 2\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"bengali\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/balooda2/v16/2-c39J9j0IaUMQZwAJyJaOX1UUnf3GLnYjALsTNe55aRa7UE.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/balooda2/v16/2-c39J9j0IaUMQZwAJyJaOX1UUnf3GLnYjA5sTNe55aRa7UE.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/balooda2/v16/2-c39J9j0IaUMQZwAJyJaOX1UUnf3GLnYjDVtjNe55aRa7UE.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/balooda2/v16/2-c39J9j0IaUMQZwAJyJaOX1UUnf3GLnYjDstjNe55aRa7UE.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/balooda2/v16/2-c39J9j0IaUMQZwAJyJaOX1UUnf3GLnYjCLtjNe55aRa7UE.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Baloo Paaji 2\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"gurmukhi\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/baloopaaji2/v22/i7dfIFFzbz-QHZUdV9_UGWZuelmy79QJ1HOSY9AX74fybRUz1r5t.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/baloopaaji2/v22/i7dfIFFzbz-QHZUdV9_UGWZuelmy79QJ1HOSY9Al74fybRUz1r5t.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/baloopaaji2/v22/i7dfIFFzbz-QHZUdV9_UGWZuelmy79QJ1HOSY9DJ6IfybRUz1r5t.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/baloopaaji2/v22/i7dfIFFzbz-QHZUdV9_UGWZuelmy79QJ1HOSY9Dw6IfybRUz1r5t.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/baloopaaji2/v22/i7dfIFFzbz-QHZUdV9_UGWZuelmy79QJ1HOSY9CX6IfybRUz1r5t.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Baloo Tamma 2\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"kannada\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/balootamma2/v15/vEFE2_hCAgcR46PaajtrYlBbVUMUJgIC5LHTrMscPp-0IF71SGC5.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/balootamma2/v15/vEFE2_hCAgcR46PaajtrYlBbVUMUJgIC5LHTrMsuPp-0IF71SGC5.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/balootamma2/v15/vEFE2_hCAgcR46PaajtrYlBbVUMUJgIC5LHTrMvCOZ-0IF71SGC5.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/balootamma2/v15/vEFE2_hCAgcR46PaajtrYlBbVUMUJgIC5LHTrMv7OZ-0IF71SGC5.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/balootamma2/v15/vEFE2_hCAgcR46PaajtrYlBbVUMUJgIC5LHTrMucOZ-0IF71SGC5.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Baloo Tammudu 2\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"telugu\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/balootammudu2/v22/1Pt5g8TIS_SAmkLguUdFP8UaJcKkzlPmMT00GaE_Jf8e4c6PZSlGmAA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/balootammudu2/v22/1Pt5g8TIS_SAmkLguUdFP8UaJcKkzlPmMT00GaE_Jc0e4c6PZSlGmAA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/balootammudu2/v22/1Pt5g8TIS_SAmkLguUdFP8UaJcKkzlPmMT00GaE_JSEZ4c6PZSlGmAA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/balootammudu2/v22/1Pt5g8TIS_SAmkLguUdFP8UaJcKkzlPmMT00GaE_JRgZ4c6PZSlGmAA.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/balootammudu2/v22/1Pt5g8TIS_SAmkLguUdFP8UaJcKkzlPmMT00GaE_JX8Z4c6PZSlGmAA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Baloo Thambi 2\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"tamil\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/baloothambi2/v16/cY9RfjeOW0NHpmOQXranrbDyu5JMJmNp-aDvUBbKzcIzaQRG_n4osQ.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/baloothambi2/v16/cY9RfjeOW0NHpmOQXranrbDyu5JMJmNp-aDvUBbK_8IzaQRG_n4osQ.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/baloothambi2/v16/cY9RfjeOW0NHpmOQXranrbDyu5JMJmNp-aDvUBbKE8UzaQRG_n4osQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/baloothambi2/v16/cY9RfjeOW0NHpmOQXranrbDyu5JMJmNp-aDvUBbKKsUzaQRG_n4osQ.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/baloothambi2/v16/cY9RfjeOW0NHpmOQXranrbDyu5JMJmNp-aDvUBbKTcUzaQRG_n4osQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Balsamiq Sans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/balsamiqsans/v10/P5sEzZiAbNrN8SB3lQQX7Pnc8dkdIYdNHzs.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/balsamiqsans/v10/P5sazZiAbNrN8SB3lQQX7PncwdsXJaVIDzvcXA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/balsamiqsans/v10/P5sZzZiAbNrN8SB3lQQX7PncyWUyBY9mAzLFRQI.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/balsamiqsans/v10/P5sfzZiAbNrN8SB3lQQX7PncwdsvmYpsBxDAVQI4aA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Balthazar\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/balthazar/v17/d6lKkaajS8Gm4CVQjFEvyRTo39l8hw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Bangers\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bangers/v20/FeVQS0BTqb0h60ACL5la2bxii28.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Barlow\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/barlow/v12/7cHrv4kjgoGqM7E3b8s8yn4hnCci.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/barlow/v12/7cHtv4kjgoGqM7E_CfNYwHoDmTcibrA.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/barlow/v12/7cHqv4kjgoGqM7E3w-oc4FAtlT47dw.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/barlow/v12/7cHsv4kjgoGqM7E_CfP04Voptzsrd6m9.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/barlow/v12/7cHqv4kjgoGqM7E3p-kc4FAtlT47dw.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/barlow/v12/7cHsv4kjgoGqM7E_CfOQ4loptzsrd6m9.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/barlow/v12/7cHpv4kjgoGqM7EPC8E46HsxnA.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/barlow/v12/7cHrv4kjgoGqM7E_Ccs8yn4hnCci.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/barlow/v12/7cHqv4kjgoGqM7E3_-gc4FAtlT47dw.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/barlow/v12/7cHsv4kjgoGqM7E_CfPI41optzsrd6m9.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/barlow/v12/7cHqv4kjgoGqM7E30-8c4FAtlT47dw.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/barlow/v12/7cHsv4kjgoGqM7E_CfPk5Foptzsrd6m9.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/barlow/v12/7cHqv4kjgoGqM7E3t-4c4FAtlT47dw.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/barlow/v12/7cHsv4kjgoGqM7E_CfOA5Voptzsrd6m9.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/barlow/v12/7cHqv4kjgoGqM7E3q-0c4FAtlT47dw.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/barlow/v12/7cHsv4kjgoGqM7E_CfOc5loptzsrd6m9.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/barlow/v12/7cHqv4kjgoGqM7E3j-wc4FAtlT47dw.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/barlow/v12/7cHsv4kjgoGqM7E_CfO451optzsrd6m9.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Barlow Condensed\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/barlowcondensed/v12/HTxxL3I-JCGChYJ8VI-L6OO_au7B43LT31vytKgbaw.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/barlowcondensed/v12/HTxzL3I-JCGChYJ8VI-L6OO_au7B6xTru1H2lq0La6JN.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B497y_3HcuKECcrs.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/barlowcondensed/v12/HTxyL3I-JCGChYJ8VI-L6OO_au7B6xTrF3DWvIMHYrtUxg.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B47rx_3HcuKECcrs.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/barlowcondensed/v12/HTxyL3I-JCGChYJ8VI-L6OO_au7B6xTrc3PWvIMHYrtUxg.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/barlowcondensed/v12/HTx3L3I-JCGChYJ8VI-L6OO_au7B2xbZ23n3pKg.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/barlowcondensed/v12/HTxxL3I-JCGChYJ8VI-L6OO_au7B6xTT31vytKgbaw.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B4-Lw_3HcuKECcrs.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/barlowcondensed/v12/HTxyL3I-JCGChYJ8VI-L6OO_au7B6xTrK3LWvIMHYrtUxg.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B4873_3HcuKECcrs.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/barlowcondensed/v12/HTxyL3I-JCGChYJ8VI-L6OO_au7B6xTrB3XWvIMHYrtUxg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B46r2_3HcuKECcrs.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/barlowcondensed/v12/HTxyL3I-JCGChYJ8VI-L6OO_au7B6xTrY3TWvIMHYrtUxg.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B47b1_3HcuKECcrs.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/barlowcondensed/v12/HTxyL3I-JCGChYJ8VI-L6OO_au7B6xTrf3fWvIMHYrtUxg.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B45L0_3HcuKECcrs.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/barlowcondensed/v12/HTxyL3I-JCGChYJ8VI-L6OO_au7B6xTrW3bWvIMHYrtUxg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Barlow Semi Condensed\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/barlowsemicondensed/v14/wlphgxjLBV1hqnzfr-F8sEYMB0Yybp0mudRfG4qvKk8ogoSP.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/barlowsemicondensed/v14/wlpjgxjLBV1hqnzfr-F8sEYMB0Yybp0mudRXfbLLIEsKh5SPZWs.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/barlowsemicondensed/v14/wlpigxjLBV1hqnzfr-F8sEYMB0Yybp0mudRft6uPAGEki52WfA.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/barlowsemicondensed/v14/wlpkgxjLBV1hqnzfr-F8sEYMB0Yybp0mudRXfbJnAWsgqZiGfHK5.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/barlowsemicondensed/v14/wlpigxjLBV1hqnzfr-F8sEYMB0Yybp0mudRf06iPAGEki52WfA.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/barlowsemicondensed/v14/wlpkgxjLBV1hqnzfr-F8sEYMB0Yybp0mudRXfbIDAmsgqZiGfHK5.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/barlowsemicondensed/v14/wlpvgxjLBV1hqnzfr-F8sEYMB0Yybp0mudRnf4CrCEo4gg.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/barlowsemicondensed/v14/wlphgxjLBV1hqnzfr-F8sEYMB0Yybp0mudRXfYqvKk8ogoSP.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/barlowsemicondensed/v14/wlpigxjLBV1hqnzfr-F8sEYMB0Yybp0mudRfi6mPAGEki52WfA.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/barlowsemicondensed/v14/wlpkgxjLBV1hqnzfr-F8sEYMB0Yybp0mudRXfbJbA2sgqZiGfHK5.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/barlowsemicondensed/v14/wlpigxjLBV1hqnzfr-F8sEYMB0Yybp0mudRfp66PAGEki52WfA.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/barlowsemicondensed/v14/wlpkgxjLBV1hqnzfr-F8sEYMB0Yybp0mudRXfbJ3BGsgqZiGfHK5.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/barlowsemicondensed/v14/wlpigxjLBV1hqnzfr-F8sEYMB0Yybp0mudRfw6-PAGEki52WfA.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/barlowsemicondensed/v14/wlpkgxjLBV1hqnzfr-F8sEYMB0Yybp0mudRXfbITBWsgqZiGfHK5.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/barlowsemicondensed/v14/wlpigxjLBV1hqnzfr-F8sEYMB0Yybp0mudRf36yPAGEki52WfA.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/barlowsemicondensed/v14/wlpkgxjLBV1hqnzfr-F8sEYMB0Yybp0mudRXfbIPBmsgqZiGfHK5.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/barlowsemicondensed/v14/wlpigxjLBV1hqnzfr-F8sEYMB0Yybp0mudRf-62PAGEki52WfA.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/barlowsemicondensed/v14/wlpkgxjLBV1hqnzfr-F8sEYMB0Yybp0mudRXfbIrB2sgqZiGfHK5.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Barriecito\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/barriecito/v17/WWXXlj-CbBOSLY2QTuY_KdUiYwTO0MU.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Barrio\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/barrio/v19/wEO8EBXBk8hBIDiEdQYhWdsX1Q.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Basic\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/basic/v17/xfu_0WLxV2_XKQN34lDVyR7D.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Baskervville\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2023-01-18\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/baskervville/v14/YA9Ur0yU4l_XOrogbkun3kQgt5OohvbJ9A.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/baskervville/v14/YA9Kr0yU4l_XOrogbkun3kQQtZmspPPZ9Mlt.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Battambang\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"khmer\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-04-20\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/battambang/v24/uk-kEGe7raEw-HjkzZabNhGp5w50_o9T7Q.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/battambang/v24/uk-lEGe7raEw-HjkzZabNtmLxyRa8oZK9I0.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/battambang/v24/uk-mEGe7raEw-HjkzZabDnWj4yxx7o8.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/battambang/v24/uk-lEGe7raEw-HjkzZabNsmMxyRa8oZK9I0.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/battambang/v24/uk-lEGe7raEw-HjkzZabNvGOxyRa8oZK9I0.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Baumans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-04-20\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/baumans/v17/-W_-XJj9QyTd3QfpR_oyaksqY5Q.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Bayon\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"khmer\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v29\",\n\t\t\t\"lastModified\": \"2022-04-20\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bayon/v29/9XUrlJNmn0LPFl-pOhYEd2NJ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Be Vietnam Pro\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/bevietnampro/v10/QdVNSTAyLFyeg_IDWvOJmVES_HRUBX8YYbAiah8.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/bevietnampro/v10/QdVLSTAyLFyeg_IDWvOJmVES_HwyPRsSZZIneh-waA.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/bevietnampro/v10/QdVMSTAyLFyeg_IDWvOJmVES_HT4JF8yT7wrcwap.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/bevietnampro/v10/QdVKSTAyLFyeg_IDWvOJmVES_HwyPbczRbgJdhapcUU.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/bevietnampro/v10/QdVMSTAyLFyeg_IDWvOJmVES_HScJ18yT7wrcwap.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/bevietnampro/v10/QdVKSTAyLFyeg_IDWvOJmVES_HwyPdMwRbgJdhapcUU.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bevietnampro/v10/QdVPSTAyLFyeg_IDWvOJmVES_EwwD3s6ZKAi.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/bevietnampro/v10/QdVNSTAyLFyeg_IDWvOJmVES_HwyBX8YYbAiah8.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/bevietnampro/v10/QdVMSTAyLFyeg_IDWvOJmVES_HTEJl8yT7wrcwap.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/bevietnampro/v10/QdVKSTAyLFyeg_IDWvOJmVES_HwyPYsxRbgJdhapcUU.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/bevietnampro/v10/QdVMSTAyLFyeg_IDWvOJmVES_HToIV8yT7wrcwap.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/bevietnampro/v10/QdVKSTAyLFyeg_IDWvOJmVES_HwyPac2RbgJdhapcUU.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/bevietnampro/v10/QdVMSTAyLFyeg_IDWvOJmVES_HSMIF8yT7wrcwap.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/bevietnampro/v10/QdVKSTAyLFyeg_IDWvOJmVES_HwyPcM3RbgJdhapcUU.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/bevietnampro/v10/QdVMSTAyLFyeg_IDWvOJmVES_HSQI18yT7wrcwap.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/bevietnampro/v10/QdVKSTAyLFyeg_IDWvOJmVES_HwyPd80RbgJdhapcUU.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/bevietnampro/v10/QdVMSTAyLFyeg_IDWvOJmVES_HS0Il8yT7wrcwap.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/bevietnampro/v10/QdVKSTAyLFyeg_IDWvOJmVES_HwyPfs1RbgJdhapcUU.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Beau Rivage\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v2\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/beaurivage/v2/UcCi3FIgIG2bH4mMNWJUlmg3NZp8K2sL.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Bebas Neue\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v9\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bebasneue/v9/JTUSjIg69CK48gW7PXooxW5rygbi49c.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Belgrano\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/belgrano/v18/55xvey5tM9rwKWrJZcMFirl08KDJ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Bellefair\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bellefair/v14/kJExBuYY6AAuhiXUxG19__A2pOdvDA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Belleza\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/belleza/v17/0nkoC9_pNeMfhX4BtcbyawzruP8.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Bellota\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/bellota/v16/MwQzbhXl3_qEpiwAID55kGMViblPtXs.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/bellota/v16/MwQxbhXl3_qEpiwAKJBjHGEfjZtKpXulTQ.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bellota/v16/MwQ2bhXl3_qEpiwAGJJRtGs-lbA.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/bellota/v16/MwQ0bhXl3_qEpiwAKJBbsEk7hbBWrA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/bellota/v16/MwQzbhXl3_qEpiwAIC5-kGMViblPtXs.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/bellota/v16/MwQxbhXl3_qEpiwAKJBjDGYfjZtKpXulTQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Bellota Text\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/bellotatext/v16/0FlMVP2VnlWS4f3-UE9hHXM5VfsqfQXwQy6yxg.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/bellotatext/v16/0FlOVP2VnlWS4f3-UE9hHXMx--Gmfw_0YSuixmYK.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bellotatext/v16/0FlTVP2VnlWS4f3-UE9hHXMB-dMOdS7sSg.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/bellotatext/v16/0FlNVP2VnlWS4f3-UE9hHXMx-9kKVyv8Sjer.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/bellotatext/v16/0FlMVP2VnlWS4f3-UE9hHXM5RfwqfQXwQy6yxg.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/bellotatext/v16/0FlOVP2VnlWS4f3-UE9hHXMx--G2eA_0YSuixmYK.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"BenchNine\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/benchnine/v16/ahcev8612zF4jxrwMosT--tRhWa8q0v8ag.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/benchnine/v16/ahcbv8612zF4jxrwMosrV8N1jU2gog.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/benchnine/v16/ahcev8612zF4jxrwMosT6-xRhWa8q0v8ag.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Benne\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"kannada\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/benne/v22/L0xzDFAhn18E6Vjxlt6qTDBN.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Bentham\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bentham/v18/VdGeAZQPEpYfmHglKWw7CJaK_y4.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Berkshire Swash\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/berkshireswash/v16/ptRRTi-cavZOGqCvnNJDl5m5XmNPrcQybX4pQA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Besley\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/besley/v12/PlIhFlO1MaNwaNGWUC92IOH_mtG4fbbBSdRoFPOl8-E.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/besley/v12/PlIhFlO1MaNwaNGWUC92IOH_mtG4fYTBSdRoFPOl8-E.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/besley/v12/PlIhFlO1MaNwaNGWUC92IOH_mtG4fWjGSdRoFPOl8-E.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/besley/v12/PlIhFlO1MaNwaNGWUC92IOH_mtG4fVHGSdRoFPOl8-E.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/besley/v12/PlIhFlO1MaNwaNGWUC92IOH_mtG4fTbGSdRoFPOl8-E.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/besley/v12/PlIhFlO1MaNwaNGWUC92IOH_mtG4fR_GSdRoFPOl8-E.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/besley/v12/PlIjFlO1MaNwaNG8WR2J-IiUAH-_aH6CoZdiENGg4-E04A.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/besley/v12/PlIjFlO1MaNwaNG8WR2J-IiUAH-_aH6Ck5diENGg4-E04A.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/besley/v12/PlIjFlO1MaNwaNG8WR2J-IiUAH-_aH6Cf5BiENGg4-E04A.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/besley/v12/PlIjFlO1MaNwaNG8WR2J-IiUAH-_aH6CRpBiENGg4-E04A.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/besley/v12/PlIjFlO1MaNwaNG8WR2J-IiUAH-_aH6CIZBiENGg4-E04A.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/besley/v12/PlIjFlO1MaNwaNG8WR2J-IiUAH-_aH6CCJBiENGg4-E04A.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Beth Ellen\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-04-20\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bethellen/v17/WwkbxPW2BE-3rb_JNT-qEIAiVNo5xNY.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Bevan\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bevan/v20/4iCj6KZ0a9NXjF8aUir7tlSJ.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/bevan/v20/4iCt6KZ0a9NXjG8YWC7Zs0SJD4U.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"BhuTuka Expanded One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"gurmukhi\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v2\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bhutukaexpandedone/v2/SLXXc0jZ4WUJcClHTtv0t7IaDRsBsWRiJCyX8pg_RVH1.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Big Shoulders Display\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/bigshouldersdisplay/v15/fC1MPZJEZG-e9gHhdI4-NBbfd2ys3SjJCx12wPgf9g-_3F0YdY86JF46SRP4yZQ.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/bigshouldersdisplay/v15/fC1MPZJEZG-e9gHhdI4-NBbfd2ys3SjJCx12wPgf9g-_3F0YdQ87JF46SRP4yZQ.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/bigshouldersdisplay/v15/fC1MPZJEZG-e9gHhdI4-NBbfd2ys3SjJCx12wPgf9g-_3F0YddE7JF46SRP4yZQ.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bigshouldersdisplay/v15/fC1MPZJEZG-e9gHhdI4-NBbfd2ys3SjJCx12wPgf9g-_3F0YdY87JF46SRP4yZQ.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/bigshouldersdisplay/v15/fC1MPZJEZG-e9gHhdI4-NBbfd2ys3SjJCx12wPgf9g-_3F0Ydb07JF46SRP4yZQ.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/bigshouldersdisplay/v15/fC1MPZJEZG-e9gHhdI4-NBbfd2ys3SjJCx12wPgf9g-_3F0YdVE8JF46SRP4yZQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/bigshouldersdisplay/v15/fC1MPZJEZG-e9gHhdI4-NBbfd2ys3SjJCx12wPgf9g-_3F0YdWg8JF46SRP4yZQ.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/bigshouldersdisplay/v15/fC1MPZJEZG-e9gHhdI4-NBbfd2ys3SjJCx12wPgf9g-_3F0YdQ88JF46SRP4yZQ.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/bigshouldersdisplay/v15/fC1MPZJEZG-e9gHhdI4-NBbfd2ys3SjJCx12wPgf9g-_3F0YdSY8JF46SRP4yZQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Big Shoulders Inline Display\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/bigshouldersinlinedisplay/v21/_LOumyfF4eSU_SCrJc9OI24U7siGvBGcZqmqV9-ZZ85CGNOFeNLxoYMPJ0nBEnR5yPc2Huux.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/bigshouldersinlinedisplay/v21/_LOumyfF4eSU_SCrJc9OI24U7siGvBGcZqmqV9-ZZ85CGNOFeNLxoYMPJ0lBE3R5yPc2Huux.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/bigshouldersinlinedisplay/v21/_LOumyfF4eSU_SCrJc9OI24U7siGvBGcZqmqV9-ZZ85CGNOFeNLxoYMPJ0mfE3R5yPc2Huux.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bigshouldersinlinedisplay/v21/_LOumyfF4eSU_SCrJc9OI24U7siGvBGcZqmqV9-ZZ85CGNOFeNLxoYMPJ0nBE3R5yPc2Huux.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/bigshouldersinlinedisplay/v21/_LOumyfF4eSU_SCrJc9OI24U7siGvBGcZqmqV9-ZZ85CGNOFeNLxoYMPJ0nzE3R5yPc2Huux.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/bigshouldersinlinedisplay/v21/_LOumyfF4eSU_SCrJc9OI24U7siGvBGcZqmqV9-ZZ85CGNOFeNLxoYMPJ0kfFHR5yPc2Huux.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/bigshouldersinlinedisplay/v21/_LOumyfF4eSU_SCrJc9OI24U7siGvBGcZqmqV9-ZZ85CGNOFeNLxoYMPJ0kmFHR5yPc2Huux.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/bigshouldersinlinedisplay/v21/_LOumyfF4eSU_SCrJc9OI24U7siGvBGcZqmqV9-ZZ85CGNOFeNLxoYMPJ0lBFHR5yPc2Huux.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/bigshouldersinlinedisplay/v21/_LOumyfF4eSU_SCrJc9OI24U7siGvBGcZqmqV9-ZZ85CGNOFeNLxoYMPJ0loFHR5yPc2Huux.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Big Shoulders Inline Text\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/bigshouldersinlinetext/v21/vm8XdQDmVECV5-vm5dJ-Tp-6WDeRjL4RV7dP8u-NMyHY74qpoNNcwga0yqGN7Y6Jsc8c.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/bigshouldersinlinetext/v21/vm8XdQDmVECV5-vm5dJ-Tp-6WDeRjL4RV7dP8u-NMyHY74qpoNNcwgY0y6GN7Y6Jsc8c.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/bigshouldersinlinetext/v21/vm8XdQDmVECV5-vm5dJ-Tp-6WDeRjL4RV7dP8u-NMyHY74qpoNNcwgbqy6GN7Y6Jsc8c.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bigshouldersinlinetext/v21/vm8XdQDmVECV5-vm5dJ-Tp-6WDeRjL4RV7dP8u-NMyHY74qpoNNcwga0y6GN7Y6Jsc8c.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/bigshouldersinlinetext/v21/vm8XdQDmVECV5-vm5dJ-Tp-6WDeRjL4RV7dP8u-NMyHY74qpoNNcwgaGy6GN7Y6Jsc8c.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/bigshouldersinlinetext/v21/vm8XdQDmVECV5-vm5dJ-Tp-6WDeRjL4RV7dP8u-NMyHY74qpoNNcwgZqzKGN7Y6Jsc8c.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/bigshouldersinlinetext/v21/vm8XdQDmVECV5-vm5dJ-Tp-6WDeRjL4RV7dP8u-NMyHY74qpoNNcwgZTzKGN7Y6Jsc8c.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/bigshouldersinlinetext/v21/vm8XdQDmVECV5-vm5dJ-Tp-6WDeRjL4RV7dP8u-NMyHY74qpoNNcwgY0zKGN7Y6Jsc8c.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/bigshouldersinlinetext/v21/vm8XdQDmVECV5-vm5dJ-Tp-6WDeRjL4RV7dP8u-NMyHY74qpoNNcwgYdzKGN7Y6Jsc8c.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Big Shoulders Stencil Display\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/bigshouldersstencildisplay/v21/6aeZ4LS6U6pR_bp5b_t2ugOhHWFcxSGP9ttD96KCb8xPytKb-oPRU-vkuLm_O0nPKHznJucP9w.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/bigshouldersstencildisplay/v21/6aeZ4LS6U6pR_bp5b_t2ugOhHWFcxSGP9ttD96KCb8xPytKb-oPRU-vkuLm_u0jPKHznJucP9w.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/bigshouldersstencildisplay/v21/6aeZ4LS6U6pR_bp5b_t2ugOhHWFcxSGP9ttD96KCb8xPytKb-oPRU-vkuLm_ZUjPKHznJucP9w.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bigshouldersstencildisplay/v21/6aeZ4LS6U6pR_bp5b_t2ugOhHWFcxSGP9ttD96KCb8xPytKb-oPRU-vkuLm_O0jPKHznJucP9w.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/bigshouldersstencildisplay/v21/6aeZ4LS6U6pR_bp5b_t2ugOhHWFcxSGP9ttD96KCb8xPytKb-oPRU-vkuLm_CUjPKHznJucP9w.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/bigshouldersstencildisplay/v21/6aeZ4LS6U6pR_bp5b_t2ugOhHWFcxSGP9ttD96KCb8xPytKb-oPRU-vkuLm_5U_PKHznJucP9w.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/bigshouldersstencildisplay/v21/6aeZ4LS6U6pR_bp5b_t2ugOhHWFcxSGP9ttD96KCb8xPytKb-oPRU-vkuLm_3E_PKHznJucP9w.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/bigshouldersstencildisplay/v21/6aeZ4LS6U6pR_bp5b_t2ugOhHWFcxSGP9ttD96KCb8xPytKb-oPRU-vkuLm_u0_PKHznJucP9w.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/bigshouldersstencildisplay/v21/6aeZ4LS6U6pR_bp5b_t2ugOhHWFcxSGP9ttD96KCb8xPytKb-oPRU-vkuLm_kk_PKHznJucP9w.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Big Shoulders Stencil Text\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/bigshouldersstenciltext/v21/5aUV9-i2oxDMNwY3dHfW7UAt3Q453SM15wNj53bCcab2SJYLLUtk1OGR04XIGS_Py_AWbQ.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/bigshouldersstenciltext/v21/5aUV9-i2oxDMNwY3dHfW7UAt3Q453SM15wNj53bCcab2SJYLLUtk1OGRU4TIGS_Py_AWbQ.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/bigshouldersstenciltext/v21/5aUV9-i2oxDMNwY3dHfW7UAt3Q453SM15wNj53bCcab2SJYLLUtk1OGRjYTIGS_Py_AWbQ.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bigshouldersstenciltext/v21/5aUV9-i2oxDMNwY3dHfW7UAt3Q453SM15wNj53bCcab2SJYLLUtk1OGR04TIGS_Py_AWbQ.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/bigshouldersstenciltext/v21/5aUV9-i2oxDMNwY3dHfW7UAt3Q453SM15wNj53bCcab2SJYLLUtk1OGR4YTIGS_Py_AWbQ.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/bigshouldersstenciltext/v21/5aUV9-i2oxDMNwY3dHfW7UAt3Q453SM15wNj53bCcab2SJYLLUtk1OGRDYPIGS_Py_AWbQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/bigshouldersstenciltext/v21/5aUV9-i2oxDMNwY3dHfW7UAt3Q453SM15wNj53bCcab2SJYLLUtk1OGRNIPIGS_Py_AWbQ.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/bigshouldersstenciltext/v21/5aUV9-i2oxDMNwY3dHfW7UAt3Q453SM15wNj53bCcab2SJYLLUtk1OGRU4PIGS_Py_AWbQ.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/bigshouldersstenciltext/v21/5aUV9-i2oxDMNwY3dHfW7UAt3Q453SM15wNj53bCcab2SJYLLUtk1OGReoPIGS_Py_AWbQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Big Shoulders Text\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/bigshoulderstext/v17/55xEezRtP9G3CGPIf49hxc8P0eytUxB2l66LmF6xc3kA3Y-r3TIPNl6P2pc.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/bigshoulderstext/v17/55xEezRtP9G3CGPIf49hxc8P0eytUxB2l66LmF6xc3kA3Q-q3TIPNl6P2pc.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/bigshoulderstext/v17/55xEezRtP9G3CGPIf49hxc8P0eytUxB2l66LmF6xc3kA3dGq3TIPNl6P2pc.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bigshoulderstext/v17/55xEezRtP9G3CGPIf49hxc8P0eytUxB2l66LmF6xc3kA3Y-q3TIPNl6P2pc.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/bigshoulderstext/v17/55xEezRtP9G3CGPIf49hxc8P0eytUxB2l66LmF6xc3kA3b2q3TIPNl6P2pc.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/bigshoulderstext/v17/55xEezRtP9G3CGPIf49hxc8P0eytUxB2l66LmF6xc3kA3VGt3TIPNl6P2pc.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/bigshoulderstext/v17/55xEezRtP9G3CGPIf49hxc8P0eytUxB2l66LmF6xc3kA3Wit3TIPNl6P2pc.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/bigshoulderstext/v17/55xEezRtP9G3CGPIf49hxc8P0eytUxB2l66LmF6xc3kA3Q-t3TIPNl6P2pc.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/bigshoulderstext/v17/55xEezRtP9G3CGPIf49hxc8P0eytUxB2l66LmF6xc3kA3Sat3TIPNl6P2pc.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Bigelow Rules\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v23\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bigelowrules/v23/RrQWboly8iR_I3KWSzeRuN0zT4cCH8WAJVk.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Bigshot One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v25\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bigshotone/v25/u-470qukhRkkO6BD_7cM_gxuUQJBXv_-.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Bilbo\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bilbo/v20/o-0EIpgpwWwZ210hpIRz4wxE.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Bilbo Swash Caps\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bilboswashcaps/v22/zrf-0GXbz-H3Wb4XBsGrTgq2PVmdqAPopiRfKp8.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"BioRhyme\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/biorhyme/v12/1cX3aULHBpDMsHYW_ESOjnGAq8Sk1PoH.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/biorhyme/v12/1cX3aULHBpDMsHYW_ETqjXGAq8Sk1PoH.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/biorhyme/v12/1cXwaULHBpDMsHYW_HxGpVWIgNit.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/biorhyme/v12/1cX3aULHBpDMsHYW_ET6inGAq8Sk1PoH.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/biorhyme/v12/1cX3aULHBpDMsHYW_ETmiXGAq8Sk1PoH.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"BioRhyme Expanded\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/biorhymeexpanded/v19/i7dVIE1zZzytGswgU577CDY9LjbffxxcblSHSdTXrb_z.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/biorhymeexpanded/v19/i7dVIE1zZzytGswgU577CDY9Ljbffxw4bVSHSdTXrb_z.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/biorhymeexpanded/v19/i7dQIE1zZzytGswgU577CDY9LjbffySURXCPYsje.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/biorhymeexpanded/v19/i7dVIE1zZzytGswgU577CDY9LjbffxwoalSHSdTXrb_z.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/biorhymeexpanded/v19/i7dVIE1zZzytGswgU577CDY9Ljbffxw0aVSHSdTXrb_z.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Birthstone\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/birthstone/v10/8AtsGs2xO4yLRhy87sv_HLn5jRfZHzM.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Birthstone Bounce\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v9\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/birthstonebounce/v9/ga6XaxZF43lIvTWrktHOTBJZGH7dEeVJGIMYDo_8.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/birthstonebounce/v9/ga6SaxZF43lIvTWrktHOTBJZGH7dEd29MacQJZP1LmD9.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Biryani\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/biryani/v13/hv-TlzNxIFoO84YddYQyGTBSU-J-RxQ.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/biryani/v13/hv-TlzNxIFoO84YddeAxGTBSU-J-RxQ.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/biryani/v13/hv-WlzNxIFoO84YdTUwZPTh5T-s.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/biryani/v13/hv-TlzNxIFoO84YddZQ3GTBSU-J-RxQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/biryani/v13/hv-TlzNxIFoO84YddfA2GTBSU-J-RxQ.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/biryani/v13/hv-TlzNxIFoO84Yddew1GTBSU-J-RxQ.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/biryani/v13/hv-TlzNxIFoO84Yddcg0GTBSU-J-RxQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Bitter\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v32\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/bitter/v32/raxhHiqOu8IVPmnRc6SY1KXhnF_Y8fbeCL_EXFh2reU.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/bitter/v32/raxhHiqOu8IVPmnRc6SY1KXhnF_Y8XbfCL_EXFh2reU.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/bitter/v32/raxhHiqOu8IVPmnRc6SY1KXhnF_Y8ajfCL_EXFh2reU.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bitter/v32/raxhHiqOu8IVPmnRc6SY1KXhnF_Y8fbfCL_EXFh2reU.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/bitter/v32/raxhHiqOu8IVPmnRc6SY1KXhnF_Y8cTfCL_EXFh2reU.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/bitter/v32/raxhHiqOu8IVPmnRc6SY1KXhnF_Y8SjYCL_EXFh2reU.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/bitter/v32/raxhHiqOu8IVPmnRc6SY1KXhnF_Y8RHYCL_EXFh2reU.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/bitter/v32/raxhHiqOu8IVPmnRc6SY1KXhnF_Y8XbYCL_EXFh2reU.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/bitter/v32/raxhHiqOu8IVPmnRc6SY1KXhnF_Y8V_YCL_EXFh2reU.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/bitter/v32/raxjHiqOu8IVPmn7epZnDMyKBvHf5D6c4P3OWHpzveWxBw.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/bitter/v32/raxjHiqOu8IVPmn7epZnDMyKBvHf5D6cYPzOWHpzveWxBw.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/bitter/v32/raxjHiqOu8IVPmn7epZnDMyKBvHf5D6cvvzOWHpzveWxBw.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/bitter/v32/raxjHiqOu8IVPmn7epZnDMyKBvHf5D6c4PzOWHpzveWxBw.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/bitter/v32/raxjHiqOu8IVPmn7epZnDMyKBvHf5D6c0vzOWHpzveWxBw.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/bitter/v32/raxjHiqOu8IVPmn7epZnDMyKBvHf5D6cPvvOWHpzveWxBw.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/bitter/v32/raxjHiqOu8IVPmn7epZnDMyKBvHf5D6cB_vOWHpzveWxBw.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/bitter/v32/raxjHiqOu8IVPmn7epZnDMyKBvHf5D6cYPvOWHpzveWxBw.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/bitter/v32/raxjHiqOu8IVPmn7epZnDMyKBvHf5D6cSfvOWHpzveWxBw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Black And White Picture\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"korean\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/blackandwhitepicture/v22/TwMe-JAERlQd3ooUHBUXGmrmioKjjnRSFO-NqI5HbcMi-yWY.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Black Han Sans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"korean\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/blackhansans/v15/ea8Aad44WunzF9a-dL6toA8r8nqVIXSkH-Hc.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Black Ops One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/blackopsone/v20/qWcsB6-ypo7xBdr6Xshe96H3WDzRtjkho4M.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Blaka\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v5\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/blaka/v5/8vIG7w8722p_6kdr20D2FV5e.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Blaka Hollow\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v5\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/blakahollow/v5/MCoUzAL91sjRE2FsKsxUtezYB9oFyW_-oA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Blaka Ink\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v5\",\n\t\t\t\"lastModified\": \"2022-09-14\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/blakaink/v5/AlZy_zVVtpj22Znag2chdXf4XB0Tow.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Blinker\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/blinker/v12/cIf_MaFatEE-VTaP_E2hZEsCkIt9QQ.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/blinker/v12/cIf4MaFatEE-VTaP_OGARGEsnIJkWL4.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/blinker/v12/cIf4MaFatEE-VTaP_IWDRGEsnIJkWL4.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/blinker/v12/cIf9MaFatEE-VTaPxCmrYGkHgIs.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/blinker/v12/cIf4MaFatEE-VTaP_PGFRGEsnIJkWL4.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/blinker/v12/cIf4MaFatEE-VTaP_JWERGEsnIJkWL4.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/blinker/v12/cIf4MaFatEE-VTaP_ImHRGEsnIJkWL4.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/blinker/v12/cIf4MaFatEE-VTaP_K2GRGEsnIJkWL4.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Bodoni Moda\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bodonimoda/v19/aFT67PxzY382XsXX63LUYL6GYFcan6NJrKp-VPjfJMShrpsGFUt8oU7awIBytVjMYwE.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/bodonimoda/v19/aFT67PxzY382XsXX63LUYL6GYFcan6NJrKp-VPjfJMShrpsGFUt8oXzawIBytVjMYwE.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/bodonimoda/v19/aFT67PxzY382XsXX63LUYL6GYFcan6NJrKp-VPjfJMShrpsGFUt8oZDdwIBytVjMYwE.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/bodonimoda/v19/aFT67PxzY382XsXX63LUYL6GYFcan6NJrKp-VPjfJMShrpsGFUt8oandwIBytVjMYwE.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/bodonimoda/v19/aFT67PxzY382XsXX63LUYL6GYFcan6NJrKp-VPjfJMShrpsGFUt8oc7dwIBytVjMYwE.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/bodonimoda/v19/aFT67PxzY382XsXX63LUYL6GYFcan6NJrKp-VPjfJMShrpsGFUt8oefdwIBytVjMYwE.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/bodonimoda/v19/aFT07PxzY382XsXX63LUYJSPUqb0pL6OQqxrZLnVbvZedvJtj-V7tIaZKMN4sXrJcwHqoQ.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/bodonimoda/v19/aFT07PxzY382XsXX63LUYJSPUqb0pL6OQqxrZLnVbvZedvJtj-V7tIaZGsN4sXrJcwHqoQ.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/bodonimoda/v19/aFT07PxzY382XsXX63LUYJSPUqb0pL6OQqxrZLnVbvZedvJtj-V7tIaZ9sR4sXrJcwHqoQ.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/bodonimoda/v19/aFT07PxzY382XsXX63LUYJSPUqb0pL6OQqxrZLnVbvZedvJtj-V7tIaZz8R4sXrJcwHqoQ.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/bodonimoda/v19/aFT07PxzY382XsXX63LUYJSPUqb0pL6OQqxrZLnVbvZedvJtj-V7tIaZqMR4sXrJcwHqoQ.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/bodonimoda/v19/aFT07PxzY382XsXX63LUYJSPUqb0pL6OQqxrZLnVbvZedvJtj-V7tIaZgcR4sXrJcwHqoQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Bokor\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"khmer\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v30\",\n\t\t\t\"lastModified\": \"2022-04-21\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bokor/v30/m8JcjfpeeaqTiR2WdInbcaxE.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Bona Nova\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bonanova/v10/B50NF7ZCpX7fcHfvIUBJi6hqHK-CLA.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/bonanova/v10/B50LF7ZCpX7fcHfvIUB5iaJuPqqSLJYf.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/bonanova/v10/B50IF7ZCpX7fcHfvIUBxN4dOFISeJY8GgQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Bonbon\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v26\",\n\t\t\t\"lastModified\": \"2022-04-21\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bonbon/v26/0FlVVPeVlFec4ee_cDEAbQY5-A.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Bonheur Royale\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v9\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bonheurroyale/v9/c4m51nt_GMTrtX-b9GcG4-YRmYK_c0f1N5Ij.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Boogaloo\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/boogaloo/v19/kmK-Zq45GAvOdnaW6x1F_SrQo_1K.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Bowlby One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bowlbyone/v19/taiPGmVuC4y96PFeqp8smo6C_Z0wcK4.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Bowlby One SC\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bowlbyonesc/v19/DtVlJxerQqQm37tzN3wMug9Pzgj8owhNjuE.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Brawler\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/brawler/v19/xn7gYHE3xXewAscGsgC7S9XdZN8.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/brawler/v19/xn7lYHE3xXewAscGiryUb932eNaPfk8.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Bree Serif\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/breeserif/v17/4UaHrEJCrhhnVA3DgluAx63j5pN1MwI.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Brygada 1918\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/brygada1918/v21/pe08MI6eKpdGqlF5LANrM--ACNaeo8mTUIR_y2-f-V8Wu5O3gbo.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/brygada1918/v21/pe08MI6eKpdGqlF5LANrM--ACNaeo8mTUIR_y12f-V8Wu5O3gbo.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/brygada1918/v21/pe08MI6eKpdGqlF5LANrM--ACNaeo8mTUIR_y7GY-V8Wu5O3gbo.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/brygada1918/v21/pe08MI6eKpdGqlF5LANrM--ACNaeo8mTUIR_y4iY-V8Wu5O3gbo.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/brygada1918/v21/pe06MI6eKpdGqlF5LANrM--qAeRhe6D4yip43qfcERwcv7GykboaLg.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/brygada1918/v21/pe06MI6eKpdGqlF5LANrM--qAeRhe6D4yip43qfcIxwcv7GykboaLg.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/brygada1918/v21/pe06MI6eKpdGqlF5LANrM--qAeRhe6D4yip43qfczxscv7GykboaLg.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/brygada1918/v21/pe06MI6eKpdGqlF5LANrM--qAeRhe6D4yip43qfc9hscv7GykboaLg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Bubblegum Sans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bubblegumsans/v16/AYCSpXb_Z9EORv1M5QTjEzMEtdaHzoPPb7R4.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Bubbler One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bubblerone/v20/f0Xy0eqj68ppQV9KBLmAouHH26MPePkt.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Buda\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v25\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/buda/v25/GFDqWAN8mnyIJSSrG7UBr7pZKA0.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Buenard\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/buenard/v17/OD5DuM6Cyma8FnnsPzf9qGi9HL4.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/buenard/v17/OD5GuM6Cyma8FnnsB4vSjGCWALepwss.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Bungee\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bungee/v11/N0bU2SZBIuF2PU_ECn50Kd_PmA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Bungee Hairline\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bungeehairline/v18/snfys0G548t04270a_ljTLUVrv-7YB2dQ5ZPqQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Bungee Inline\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bungeeinline/v11/Gg8zN58UcgnlCweMrih332VuDGJ1-FEglsc.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Bungee Outline\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bungeeoutline/v18/_6_mEDvmVP24UvU2MyiGDslL3Qg3YhJqPXxo.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Bungee Shade\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bungeeshade/v11/DtVkJxarWL0t2KdzK3oI_jks7iLSrwFUlw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Bungee Spice\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v8\",\n\t\t\t\"lastModified\": \"2022-09-14\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/bungeespice/v8/nwpTtK2nIhxE0q-IwgSpZBqCzyI-aMPF7Q.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Butcherman\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/butcherman/v24/2EbiL-thF0loflXUBOdb1zWzq_5uT84.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Butterfly Kids\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/butterflykids/v21/ll8lK2CWTjuqAsXDqlnIbMNs5S4arxFrAX1D.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Cabin\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v26\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/cabin/v26/u-4X0qWljRw-PfU81xCKCpdpbgZJl6XFpfEd7eA9BIxxkV2EL7Gvxm7rE_s.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/cabin/v26/u-4X0qWljRw-PfU81xCKCpdpbgZJl6XFpfEd7eA9BIxxkW-EL7Gvxm7rE_s.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/cabin/v26/u-4X0qWljRw-PfU81xCKCpdpbgZJl6XFpfEd7eA9BIxxkYODL7Gvxm7rE_s.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/cabin/v26/u-4X0qWljRw-PfU81xCKCpdpbgZJl6XFpfEd7eA9BIxxkbqDL7Gvxm7rE_s.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/cabin/v26/u-4V0qWljRw-Pd815fNqc8T_wAFcX-c37MPiNYlWniJ2hJXHx_KlwkzuA_u1Bg.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/cabin/v26/u-4V0qWljRw-Pd815fNqc8T_wAFcX-c37MPiNYlWniJ2hJXH9fKlwkzuA_u1Bg.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/cabin/v26/u-4V0qWljRw-Pd815fNqc8T_wAFcX-c37MPiNYlWniJ2hJXHGfWlwkzuA_u1Bg.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/cabin/v26/u-4V0qWljRw-Pd815fNqc8T_wAFcX-c37MPiNYlWniJ2hJXHIPWlwkzuA_u1Bg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Cabin Condensed\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/cabincondensed/v19/nwpMtK6mNhBK2err_hqkYhHRqmwaYOjZ5HZl8Q.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/cabincondensed/v19/nwpJtK6mNhBK2err_hqkYhHRqmwilMH97F15-K1oqQ.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/cabincondensed/v19/nwpJtK6mNhBK2err_hqkYhHRqmwiuMb97F15-K1oqQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/cabincondensed/v19/nwpJtK6mNhBK2err_hqkYhHRqmwi3Mf97F15-K1oqQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Cabin Sketch\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/cabinsketch/v19/QGYpz_kZZAGCONcK2A4bGOjMn9JM6fnuKg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/cabinsketch/v19/QGY2z_kZZAGCONcK2A4bGOj0I_1o4dLyI4CMFw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Caesar Dressing\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/caesardressing/v21/yYLx0hLa3vawqtwdswbotmK4vrR3cbb6LZttyg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Cagliostro\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/cagliostro/v21/ZgNWjP5HM73BV5amnX-TjGXEM4COoE4.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Cairo\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/cairo/v22/SLXgc1nY6HkvangtZmpQdkhzfH5lkSs2SgRjCAGMQ1z0hGA-W1ToLQ-HmkA.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/cairo/v22/SLXgc1nY6HkvangtZmpQdkhzfH5lkSs2SgRjCAGMQ1z0hL4-W1ToLQ-HmkA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/cairo/v22/SLXgc1nY6HkvangtZmpQdkhzfH5lkSs2SgRjCAGMQ1z0hOA-W1ToLQ-HmkA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/cairo/v22/SLXgc1nY6HkvangtZmpQdkhzfH5lkSs2SgRjCAGMQ1z0hNI-W1ToLQ-HmkA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/cairo/v22/SLXgc1nY6HkvangtZmpQdkhzfH5lkSs2SgRjCAGMQ1z0hD45W1ToLQ-HmkA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/cairo/v22/SLXgc1nY6HkvangtZmpQdkhzfH5lkSs2SgRjCAGMQ1z0hAc5W1ToLQ-HmkA.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/cairo/v22/SLXgc1nY6HkvangtZmpQdkhzfH5lkSs2SgRjCAGMQ1z0hGA5W1ToLQ-HmkA.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/cairo/v22/SLXgc1nY6HkvangtZmpQdkhzfH5lkSs2SgRjCAGMQ1z0hEk5W1ToLQ-HmkA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Cairo Play\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v6\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/cairoplay/v6/wXKEE3QSpo4vpRz_mz6FP-8iaauCLt_Hjopv3miu5IvcJo49mOo1EnYq9yXa8GvzaA.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/cairoplay/v6/wXKEE3QSpo4vpRz_mz6FP-8iaauCLt_Hjopv3miu5IvcJo49mOo1zHYq9yXa8GvzaA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/cairoplay/v6/wXKEE3QSpo4vpRz_mz6FP-8iaauCLt_Hjopv3miu5IvcJo49mOo1knYq9yXa8GvzaA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/cairoplay/v6/wXKEE3QSpo4vpRz_mz6FP-8iaauCLt_Hjopv3miu5IvcJo49mOo1oHYq9yXa8GvzaA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/cairoplay/v6/wXKEE3QSpo4vpRz_mz6FP-8iaauCLt_Hjopv3miu5IvcJo49mOo1THEq9yXa8GvzaA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/cairoplay/v6/wXKEE3QSpo4vpRz_mz6FP-8iaauCLt_Hjopv3miu5IvcJo49mOo1dXEq9yXa8GvzaA.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/cairoplay/v6/wXKEE3QSpo4vpRz_mz6FP-8iaauCLt_Hjopv3miu5IvcJo49mOo1EnEq9yXa8GvzaA.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/cairoplay/v6/wXKEE3QSpo4vpRz_mz6FP-8iaauCLt_Hjopv3miu5IvcJo49mOo1O3Eq9yXa8GvzaA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Caladea\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v7\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/caladea/v7/kJEzBugZ7AAjhybUjR93-9IztOc.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/caladea/v7/kJExBugZ7AAjhybUvR19__A2pOdvDA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/caladea/v7/kJE2BugZ7AAjhybUtaNY39oYqO52FZ0.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/caladea/v7/kJE0BugZ7AAjhybUvR1FQ98SrMxzBZ2lDA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Calistoga\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/calistoga/v13/6NUU8F2OJg6MeR7l4e0vtMYAwdRZfw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Calligraffitti\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/calligraffitti/v19/46k2lbT3XjDVqJw3DCmCFjE0vnFZM5ZBpYN-.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Cambay\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/cambay/v12/SLXJc1rY6H0_ZDsGbrSIz9JsaA.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/cambay/v12/SLXLc1rY6H0_ZDs2bL6M7dd8aGZk.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/cambay/v12/SLXKc1rY6H0_ZDs-0pusx_lwYX99kA.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/cambay/v12/SLXMc1rY6H0_ZDs2bIYwwvN0Q3ptkDMN.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Cambo\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/cambo/v17/IFSqHeNEk8FJk416ok7xkPm8.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Candal\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/candal/v15/XoHn2YH6T7-t_8cNAR4Jt9Yxlw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Cantarell\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/cantarell/v17/B50NF7ZDq37KMUvlO01Ji6hqHK-CLA.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/cantarell/v17/B50LF7ZDq37KMUvlO015iaJuPqqSLJYf.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/cantarell/v17/B50IF7ZDq37KMUvlO01xN4dOFISeJY8GgQ.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/cantarell/v17/B50WF7ZDq37KMUvlO015iZrSEY6aB4oWgWHB.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Cantata One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/cantataone/v15/PlI5Fl60Nb5obNzNe2jslVxEt8CwfGaD.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Cantora One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/cantoraone/v19/gyB4hws1JdgnKy56GB_JX6zdZ4vZVbgZ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Capriola\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/capriola/v13/wXKoE3YSppcvo1PDln_8L-AinG8y.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Caramel\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v7\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/caramel/v7/P5sCzZKBbMTf_ShyxCRuiZ-uydg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Carattere\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v7\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/carattere/v7/4iCv6Kp1b9dXlgt_CkvTt2aMH4V_gg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Cardo\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/cardo/v19/wlp_gwjKBV1pqiv_1oAZ2H5O.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/cardo/v19/wlpxgwjKBV1pqhv93IQ73W5OcCk.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/cardo/v19/wlpygwjKBV1pqhND-aQR82JHaTBX.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Carme\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/carme/v16/ptRHTiWdbvZIDOjGxLNrxfbZ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Carrois Gothic\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/carroisgothic/v16/Z9XPDmFATg-N1PLtLOOxvIHl9ZmD3i7ajcJ-.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Carrois Gothic SC\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/carroisgothicsc/v15/ZgNJjOVHM6jfUZCmyUqT2A2HVKjc-28nNHabY4dN.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Carter One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/carterone/v17/q5uCsoe5IOB2-pXv9UcNIxR2hYxREMs.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Castoro\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/castoro/v18/1q2GY5yMCld3-O4cHYhEzOYenEU.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/castoro/v18/1q2EY5yMCld3-O4cLYpOyMQbjEX5fw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Catamaran\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"tamil\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/catamaran/v17/o-0bIpQoyXQa2RxT7-5B6Ryxs2E_6n1iPHjc1anXuluiLyw.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/catamaran/v17/o-0bIpQoyXQa2RxT7-5B6Ryxs2E_6n1iPPjd1anXuluiLyw.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/catamaran/v17/o-0bIpQoyXQa2RxT7-5B6Ryxs2E_6n1iPCbd1anXuluiLyw.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/catamaran/v17/o-0bIpQoyXQa2RxT7-5B6Ryxs2E_6n1iPHjd1anXuluiLyw.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/catamaran/v17/o-0bIpQoyXQa2RxT7-5B6Ryxs2E_6n1iPErd1anXuluiLyw.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/catamaran/v17/o-0bIpQoyXQa2RxT7-5B6Ryxs2E_6n1iPKba1anXuluiLyw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/catamaran/v17/o-0bIpQoyXQa2RxT7-5B6Ryxs2E_6n1iPJ_a1anXuluiLyw.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/catamaran/v17/o-0bIpQoyXQa2RxT7-5B6Ryxs2E_6n1iPPja1anXuluiLyw.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/catamaran/v17/o-0bIpQoyXQa2RxT7-5B6Ryxs2E_6n1iPNHa1anXuluiLyw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Caudex\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/caudex/v15/esDQ311QOP6BJUrIyviAnb4eEw.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/caudex/v15/esDS311QOP6BJUr4yPKEv7sOE4in.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/caudex/v15/esDT311QOP6BJUrwdteklZUCGpG-GQ.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/caudex/v15/esDV311QOP6BJUr4yMo4kJ8GOJSuGdLB.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Caveat\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/caveat/v17/WnznHAc5bAfYB2QRah7pcpNvOx-pjfJ9SIKjYBxPigs.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/caveat/v17/WnznHAc5bAfYB2QRah7pcpNvOx-pjcB9SIKjYBxPigs.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/caveat/v17/WnznHAc5bAfYB2QRah7pcpNvOx-pjSx6SIKjYBxPigs.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/caveat/v17/WnznHAc5bAfYB2QRah7pcpNvOx-pjRV6SIKjYBxPigs.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Caveat Brush\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/caveatbrush/v11/EYq0maZfwr9S9-ETZc3fKXtMW7mT03pdQw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Cedarville Cursive\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/cedarvillecursive/v17/yYL00g_a2veiudhUmxjo5VKkoqA-B_neJbBxw8BeTg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Ceviche One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/cevicheone/v16/gyB4hws1IcA6JzR-GB_JX6zdZ4vZVbgZ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Chakra Petch\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"thai\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v9\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/chakrapetch/v9/cIflMapbsEk7TDLdtEz1BwkeNIhFQJXE3AY00g.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/chakrapetch/v9/cIfnMapbsEk7TDLdtEz1BwkWmpLJQp_A_gMk0izH.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/chakrapetch/v9/cIf6MapbsEk7TDLdtEz1BwkmmKBhSL7Y1Q.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/chakrapetch/v9/cIfkMapbsEk7TDLdtEz1BwkWmqplarvI1R8t.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/chakrapetch/v9/cIflMapbsEk7TDLdtEz1BwkebIlFQJXE3AY00g.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/chakrapetch/v9/cIfnMapbsEk7TDLdtEz1BwkWmpKRQ5_A_gMk0izH.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/chakrapetch/v9/cIflMapbsEk7TDLdtEz1BwkeQI5FQJXE3AY00g.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/chakrapetch/v9/cIfnMapbsEk7TDLdtEz1BwkWmpK9RJ_A_gMk0izH.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/chakrapetch/v9/cIflMapbsEk7TDLdtEz1BwkeJI9FQJXE3AY00g.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/chakrapetch/v9/cIfnMapbsEk7TDLdtEz1BwkWmpLZRZ_A_gMk0izH.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Changa\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/changa/v20/2-c79JNi2YuVOUcOarRPgnNGooxCZy2xQjDp9htf1ZM.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/changa/v20/2-c79JNi2YuVOUcOarRPgnNGooxCZ_OxQjDp9htf1ZM.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/changa/v20/2-c79JNi2YuVOUcOarRPgnNGooxCZ62xQjDp9htf1ZM.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/changa/v20/2-c79JNi2YuVOUcOarRPgnNGooxCZ5-xQjDp9htf1ZM.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/changa/v20/2-c79JNi2YuVOUcOarRPgnNGooxCZ3O2QjDp9htf1ZM.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/changa/v20/2-c79JNi2YuVOUcOarRPgnNGooxCZ0q2QjDp9htf1ZM.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/changa/v20/2-c79JNi2YuVOUcOarRPgnNGooxCZy22QjDp9htf1ZM.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Changa One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/changaone/v18/xfu00W3wXn3QLUJXhzq46AbouLfbK64.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/changaone/v18/xfu20W3wXn3QLUJXhzq42ATivJXeO67ISw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Chango\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/chango/v21/2V0cKI0OB5U7WaJyz324TFUaAw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Charis SIL\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/charissil/v1/oPWK_kV3l-s-Q8govXvKrPrmYjZ2Xn0.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/charissil/v1/oPWI_kV3l-s-Q8govXvKnPjsZhRzTn2Ozw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/charissil/v1/oPWJ_kV3l-s-Q8govXvKlEbJRj5dQnSX1ko.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/charissil/v1/oPWX_kV3l-s-Q8govXvKnPjU2jtXRlaSxkrMCQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Charm\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"thai\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/charm/v10/7cHmv4oii5K0MeYvIe804WIo.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/charm/v10/7cHrv4oii5K0Md6TDss8yn4hnCci.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Charmonman\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"thai\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/charmonman/v18/MjQDmiR3vP_nuxDv47jiWJGovLdh6OE.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/charmonman/v18/MjQAmiR3vP_nuxDv47jiYC2HmL9K9OhmGnY.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Chathura\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"telugu\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-04-21\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/chathura/v20/_gP91R7-rzUuVjim42dEq0SbTvZyuDo.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/chathura/v20/_gP81R7-rzUuVjim42eMiWSxYPp7oSNy.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/chathura/v20/_gP71R7-rzUuVjim418goUC5S-Zy.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/chathura/v20/_gP81R7-rzUuVjim42ecjmSxYPp7oSNy.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/chathura/v20/_gP81R7-rzUuVjim42eAjWSxYPp7oSNy.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Chau Philomene One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/chauphilomeneone/v15/55xxezRsPtfie1vPY49qzdgSlJiHRQFsnIx7QMISdQ.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/chauphilomeneone/v15/55xzezRsPtfie1vPY49qzdgSlJiHRQFcnoZ_YscCdXQB.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Chela One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/chelaone/v21/6ae-4KC7Uqgdz_JZdPIy31vWNTMwoQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Chelsea Market\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/chelseamarket/v13/BCawqZsHqfr89WNP_IApC8tzKBhlLA4uKkWk.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Chenla\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"khmer\"\n\t\t\t],\n\t\t\t\"version\": \"v25\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/chenla/v25/SZc43FDpIKu8WZ9eXxfonUPL6Q.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Cherish\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v7\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/cherish/v7/ll88K2mXUyqsDsTN5iDCI6IJjg8.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Cherry Cream Soda\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/cherrycreamsoda/v21/UMBIrOxBrW6w2FFyi9paG0fdVdRciTd6Cd47DJ7G.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Cherry Swash\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-04-21\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/cherryswash/v18/i7dNIFByZjaNAMxtZcnfAy58QHi-EwWMbg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/cherryswash/v18/i7dSIFByZjaNAMxtZcnfAy5E_FeaGy6QZ3WfYg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Chewy\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/chewy/v18/uK_94ruUb-k-wk5xIDMfO-ed.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Chicle\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/chicle/v21/lJwG-pw9i2dqU-BDyWKuobYSxw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Chilanka\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"malayalam\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/chilanka/v18/WWXRlj2DZQiMJYaYRrJQI9EAZhTO.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Chivo\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-11-18\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/chivo/v18/va9b4kzIxd1KFppkaRKvDRPJVDf_vB7ul2DSFXjQiQ.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/chivo/v18/va9b4kzIxd1KFppkaRKvDRPJVDf_PB_ul2DSFXjQiQ.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/chivo/v18/va9b4kzIxd1KFppkaRKvDRPJVDf_4h_ul2DSFXjQiQ.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/chivo/v18/va9b4kzIxd1KFppkaRKvDRPJVDf_vB_ul2DSFXjQiQ.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/chivo/v18/va9b4kzIxd1KFppkaRKvDRPJVDf_jh_ul2DSFXjQiQ.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/chivo/v18/va9b4kzIxd1KFppkaRKvDRPJVDf_Yhjul2DSFXjQiQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/chivo/v18/va9b4kzIxd1KFppkaRKvDRPJVDf_Wxjul2DSFXjQiQ.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/chivo/v18/va9b4kzIxd1KFppkaRKvDRPJVDf_PBjul2DSFXjQiQ.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/chivo/v18/va9b4kzIxd1KFppkaRKvDRPJVDf_FRjul2DSFXjQiQ.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/chivo/v18/va9Z4kzIxd1KFrBtW-13ZHhT-jDqdFwG1WrWN33AiasJ.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/chivo/v18/va9Z4kzIxd1KFrBtW-13ZHhT-jDqdFyG1GrWN33AiasJ.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/chivo/v18/va9Z4kzIxd1KFrBtW-13ZHhT-jDqdFxY1GrWN33AiasJ.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/chivo/v18/va9Z4kzIxd1KFrBtW-13ZHhT-jDqdFwG1GrWN33AiasJ.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/chivo/v18/va9Z4kzIxd1KFrBtW-13ZHhT-jDqdFw01GrWN33AiasJ.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/chivo/v18/va9Z4kzIxd1KFrBtW-13ZHhT-jDqdFzY02rWN33AiasJ.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/chivo/v18/va9Z4kzIxd1KFrBtW-13ZHhT-jDqdFzh02rWN33AiasJ.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/chivo/v18/va9Z4kzIxd1KFrBtW-13ZHhT-jDqdFyG02rWN33AiasJ.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/chivo/v18/va9Z4kzIxd1KFrBtW-13ZHhT-jDqdFyv02rWN33AiasJ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Chivo Mono\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v4\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/chivomono/v4/mFThWbgRxKvF_Z5eQMO9qRMrJJrnKNtC3D7hrqfVKphL03l4.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/chivomono/v4/mFThWbgRxKvF_Z5eQMO9qRMrJJrnKNtC3D5hr6fVKphL03l4.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/chivomono/v4/mFThWbgRxKvF_Z5eQMO9qRMrJJrnKNtC3D6_r6fVKphL03l4.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/chivomono/v4/mFThWbgRxKvF_Z5eQMO9qRMrJJrnKNtC3D7hr6fVKphL03l4.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/chivomono/v4/mFThWbgRxKvF_Z5eQMO9qRMrJJrnKNtC3D7Tr6fVKphL03l4.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/chivomono/v4/mFThWbgRxKvF_Z5eQMO9qRMrJJrnKNtC3D4_qKfVKphL03l4.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/chivomono/v4/mFThWbgRxKvF_Z5eQMO9qRMrJJrnKNtC3D4GqKfVKphL03l4.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/chivomono/v4/mFThWbgRxKvF_Z5eQMO9qRMrJJrnKNtC3D5hqKfVKphL03l4.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/chivomono/v4/mFThWbgRxKvF_Z5eQMO9qRMrJJrnKNtC3D5IqKfVKphL03l4.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/chivomono/v4/mFTjWbgRxKvF_Z5eQMO9gxoZ20KOQ0Hs2ysp7E-XIJxp1ml4imo.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/chivomono/v4/mFTjWbgRxKvF_Z5eQMO9gxoZ20KOQ0Hs2ysp7M-WIJxp1ml4imo.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/chivomono/v4/mFTjWbgRxKvF_Z5eQMO9gxoZ20KOQ0Hs2ysp7BGWIJxp1ml4imo.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/chivomono/v4/mFTjWbgRxKvF_Z5eQMO9gxoZ20KOQ0Hs2ysp7E-WIJxp1ml4imo.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/chivomono/v4/mFTjWbgRxKvF_Z5eQMO9gxoZ20KOQ0Hs2ysp7H2WIJxp1ml4imo.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/chivomono/v4/mFTjWbgRxKvF_Z5eQMO9gxoZ20KOQ0Hs2ysp7JGRIJxp1ml4imo.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/chivomono/v4/mFTjWbgRxKvF_Z5eQMO9gxoZ20KOQ0Hs2ysp7KiRIJxp1ml4imo.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/chivomono/v4/mFTjWbgRxKvF_Z5eQMO9gxoZ20KOQ0Hs2ysp7M-RIJxp1ml4imo.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/chivomono/v4/mFTjWbgRxKvF_Z5eQMO9gxoZ20KOQ0Hs2ysp7OaRIJxp1ml4imo.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"monospace\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Chonburi\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"thai\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/chonburi/v10/8AtqGs-wOpGRTBq66IWaFr3biAfZ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Cinzel\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/cinzel/v19/8vIU7ww63mVu7gtR-kwKxNvkNOjw-tbnTYrvDE5ZdqU.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/cinzel/v19/8vIU7ww63mVu7gtR-kwKxNvkNOjw-uTnTYrvDE5ZdqU.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/cinzel/v19/8vIU7ww63mVu7gtR-kwKxNvkNOjw-gjgTYrvDE5ZdqU.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/cinzel/v19/8vIU7ww63mVu7gtR-kwKxNvkNOjw-jHgTYrvDE5ZdqU.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/cinzel/v19/8vIU7ww63mVu7gtR-kwKxNvkNOjw-lbgTYrvDE5ZdqU.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/cinzel/v19/8vIU7ww63mVu7gtR-kwKxNvkNOjw-n_gTYrvDE5ZdqU.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Cinzel Decorative\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/cinzeldecorative/v14/daaCSScvJGqLYhG8nNt8KPPswUAPnh7URs1LaCyC.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/cinzeldecorative/v14/daaHSScvJGqLYhG8nNt8KPPswUAPniZoaelDQzCLlQXE.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/cinzeldecorative/v14/daaHSScvJGqLYhG8nNt8KPPswUAPniZQa-lDQzCLlQXE.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Clicker Script\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/clickerscript/v13/raxkHiKPvt8CMH6ZWP8PdlEq72rY2zqUKafv.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Coda\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/coda/v21/SLXHc1jY5nQ8JUIMapaN39I.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/coda/v21/SLXIc1jY5nQ8HeIgTp6mw9t1cX8.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Coda Caption\",\n\t\t\t\"variants\": [\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/codacaption/v19/ieVm2YRII2GMY7SyXSoDRiQGqcx6x_-fACIgaw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Codystar\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/codystar/v15/FwZf7-Q1xVk-40qxOuYsyuyrj0e29bfC.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/codystar/v15/FwZY7-Q1xVk-40qxOt6A4sijpFu_.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Coiny\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"tamil\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/coiny/v16/gyByhwU1K989PXwbElSvO5Tc.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Combo\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/combo/v21/BXRlvF3Jh_fIhg0iBu9y8Hf0.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Comfortaa\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v40\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/comfortaa/v40/1Pt_g8LJRfWJmhDAuUsSQamb1W0lwk4S4TbMPrQVIT9c2c8.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/comfortaa/v40/1Pt_g8LJRfWJmhDAuUsSQamb1W0lwk4S4WjMPrQVIT9c2c8.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/comfortaa/v40/1Pt_g8LJRfWJmhDAuUsSQamb1W0lwk4S4VrMPrQVIT9c2c8.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/comfortaa/v40/1Pt_g8LJRfWJmhDAuUsSQamb1W0lwk4S4bbLPrQVIT9c2c8.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/comfortaa/v40/1Pt_g8LJRfWJmhDAuUsSQamb1W0lwk4S4Y_LPrQVIT9c2c8.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Comforter\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v5\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/comforter/v5/H4clBXOCl8nQnlaql3Qa6JG8iqeuag.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Comforter Brush\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v5\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/comforterbrush/v5/Y4GTYa1xVSggrfzZI5WMjxRaOz0jwLL9Th8YYA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Comic Neue\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v8\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/comicneue/v8/4UaErEJDsxBrF37olUeD_wHLwpteLwtHJlc.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/comicneue/v8/4UaarEJDsxBrF37olUeD96_RTplUKylCNlcw_Q.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/comicneue/v8/4UaHrEJDsxBrF37olUeDx63j5pN1MwI.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/comicneue/v8/4UaFrEJDsxBrF37olUeD96_p4rFwIwJePw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/comicneue/v8/4UaErEJDsxBrF37olUeD_xHMwpteLwtHJlc.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/comicneue/v8/4UaarEJDsxBrF37olUeD96_RXp5UKylCNlcw_Q.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Coming Soon\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/comingsoon/v19/qWcuB6mzpYL7AJ2VfdQR1u-SUjjzsykh.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Commissioner\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/commissioner/v13/tDbe2o2WnlgI0FNDgduEk4jAhwgIy5k8SlfU5Ni-IO9pOXuRoaY.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/commissioner/v13/tDbe2o2WnlgI0FNDgduEk4jAhwgIy5k8SlfU5Fi_IO9pOXuRoaY.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/commissioner/v13/tDbe2o2WnlgI0FNDgduEk4jAhwgIy5k8SlfU5Ia_IO9pOXuRoaY.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/commissioner/v13/tDbe2o2WnlgI0FNDgduEk4jAhwgIy5k8SlfU5Ni_IO9pOXuRoaY.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/commissioner/v13/tDbe2o2WnlgI0FNDgduEk4jAhwgIy5k8SlfU5Oq_IO9pOXuRoaY.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/commissioner/v13/tDbe2o2WnlgI0FNDgduEk4jAhwgIy5k8SlfU5Aa4IO9pOXuRoaY.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/commissioner/v13/tDbe2o2WnlgI0FNDgduEk4jAhwgIy5k8SlfU5D-4IO9pOXuRoaY.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/commissioner/v13/tDbe2o2WnlgI0FNDgduEk4jAhwgIy5k8SlfU5Fi4IO9pOXuRoaY.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/commissioner/v13/tDbe2o2WnlgI0FNDgduEk4jAhwgIy5k8SlfU5HG4IO9pOXuRoaY.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Concert One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/concertone/v17/VEM1Ro9xs5PjtzCu-srDqRTlhv-CuVAQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Condiment\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/condiment/v20/pONk1hggFNmwvXALyH6Sq4n4o1vyCQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Content\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"khmer\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/content/v24/zrfl0HLayePhU_AwUaDyIiL0RCg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/content/v24/zrfg0HLayePhU_AwaRzdBirfWCHvkAI.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Contrail One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/contrailone/v15/eLGbP-j_JA-kG0_Zo51noafdZUvt_c092w.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Convergence\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-04-21\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/convergence/v15/rax5HiePvdgXPmmMHcIPYRhasU7Q8Cad.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Cookie\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/cookie/v17/syky-y18lb0tSbfNlQCT9tPdpw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Copse\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-04-21\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/copse/v15/11hPGpDKz1rGb0djHkihUb-A.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Corben\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/corben/v19/LYjDdGzzklQtCMp9oAlEpVs3VQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/corben/v19/LYjAdGzzklQtCMpFHCZgrXArXN7HWQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Corinthia\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v9\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/corinthia/v9/wEO_EBrAnchaJyPMHE0FUfAL3EsHiA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/corinthia/v9/wEO6EBrAnchaJyPMHE097d8v1GAbgbLXQA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Cormorant\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/cormorant/v18/H4c2BXOCl9bbnla_nHIA47NMUjsNbCVrFk9TQ7Rg7A2uwYs.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/cormorant/v18/H4c2BXOCl9bbnla_nHIA47NMUjsNbCVrFhFTQ7Rg7A2uwYs.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/cormorant/v18/H4c2BXOCl9bbnla_nHIA47NMUjsNbCVrFiNTQ7Rg7A2uwYs.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/cormorant/v18/H4c2BXOCl9bbnla_nHIA47NMUjsNbCVrFs9UQ7Rg7A2uwYs.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/cormorant/v18/H4c2BXOCl9bbnla_nHIA47NMUjsNbCVrFvZUQ7Rg7A2uwYs.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/cormorant/v18/H4c0BXOCl9bbnla_nHIq6oGzilJm9otsA9kQ9fdq6C-r0YvxdA.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/cormorant/v18/H4c0BXOCl9bbnla_nHIq6oGzilJm9otsA9kQq_dq6C-r0YvxdA.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/cormorant/v18/H4c0BXOCl9bbnla_nHIq6oGzilJm9otsA9kQmfdq6C-r0YvxdA.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/cormorant/v18/H4c0BXOCl9bbnla_nHIq6oGzilJm9otsA9kQdfBq6C-r0YvxdA.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/cormorant/v18/H4c0BXOCl9bbnla_nHIq6oGzilJm9otsA9kQTPBq6C-r0YvxdA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Cormorant Garamond\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/cormorantgaramond/v16/co3YmX5slCNuHLi8bLeY9MK7whWMhyjQAllvuQWJ5heb_w.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/cormorantgaramond/v16/co3WmX5slCNuHLi8bLeY9MK7whWMhyjYrEPjuw-NxBKL_y94.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/cormorantgaramond/v16/co3bmX5slCNuHLi8bLeY9MK7whWMhyjornFLsS6V7w.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/cormorantgaramond/v16/co3ZmX5slCNuHLi8bLeY9MK7whWMhyjYrHtPkyuF7w6C.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/cormorantgaramond/v16/co3YmX5slCNuHLi8bLeY9MK7whWMhyjQWlhvuQWJ5heb_w.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/cormorantgaramond/v16/co3WmX5slCNuHLi8bLeY9MK7whWMhyjYrEO7ug-NxBKL_y94.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/cormorantgaramond/v16/co3YmX5slCNuHLi8bLeY9MK7whWMhyjQdl9vuQWJ5heb_w.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/cormorantgaramond/v16/co3WmX5slCNuHLi8bLeY9MK7whWMhyjYrEOXvQ-NxBKL_y94.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/cormorantgaramond/v16/co3YmX5slCNuHLi8bLeY9MK7whWMhyjQEl5vuQWJ5heb_w.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/cormorantgaramond/v16/co3WmX5slCNuHLi8bLeY9MK7whWMhyjYrEPzvA-NxBKL_y94.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Cormorant Infant\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/cormorantinfant/v17/HhyIU44g9vKiM1sORYSiWeAsLN9951w3_DMrQqcdJrk.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/cormorantinfant/v17/HhyKU44g9vKiM1sORYSiWeAsLN997_ItcDEhRoUYNrn_Ig.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/cormorantinfant/v17/HhyPU44g9vKiM1sORYSiWeAsLN993_Af2DsAXq4.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/cormorantinfant/v17/HhyJU44g9vKiM1sORYSiWeAsLN997_IV3BkFTq4EPw.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/cormorantinfant/v17/HhyIU44g9vKiM1sORYSiWeAsLN995wQ2_DMrQqcdJrk.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/cormorantinfant/v17/HhyKU44g9vKiM1sORYSiWeAsLN997_ItKDAhRoUYNrn_Ig.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/cormorantinfant/v17/HhyIU44g9vKiM1sORYSiWeAsLN995ygx_DMrQqcdJrk.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/cormorantinfant/v17/HhyKU44g9vKiM1sORYSiWeAsLN997_ItBDchRoUYNrn_Ig.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/cormorantinfant/v17/HhyIU44g9vKiM1sORYSiWeAsLN9950ww_DMrQqcdJrk.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/cormorantinfant/v17/HhyKU44g9vKiM1sORYSiWeAsLN997_ItYDYhRoUYNrn_Ig.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Cormorant SC\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/cormorantsc/v17/0ybmGD4kxqXBmOVLG30OGwsmABIU_R3y8DOWGA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/cormorantsc/v17/0yb5GD4kxqXBmOVLG30OGwserDow9Tbu-Q.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/cormorantsc/v17/0ybmGD4kxqXBmOVLG30OGwsmWBMU_R3y8DOWGA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/cormorantsc/v17/0ybmGD4kxqXBmOVLG30OGwsmdBQU_R3y8DOWGA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/cormorantsc/v17/0ybmGD4kxqXBmOVLG30OGwsmEBUU_R3y8DOWGA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Cormorant Unicase\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/cormorantunicase/v24/HI_ViZUaILtOqhqgDeXoF_n1_fTGX9N_tucv7Gy0DRzS.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/cormorantunicase/v24/HI_QiZUaILtOqhqgDeXoF_n1_fTGX-vTnsMnx3C9.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/cormorantunicase/v24/HI_ViZUaILtOqhqgDeXoF_n1_fTGX9Mnt-cv7Gy0DRzS.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/cormorantunicase/v24/HI_ViZUaILtOqhqgDeXoF_n1_fTGX9MLsOcv7Gy0DRzS.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/cormorantunicase/v24/HI_ViZUaILtOqhqgDeXoF_n1_fTGX9Nvsecv7Gy0DRzS.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Cormorant Upright\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/cormorantupright/v18/VuJudM3I2Y35poFONtLdafkUCHw1y1N5phDsU9X6RPzQ.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/cormorantupright/v18/VuJrdM3I2Y35poFONtLdafkUCHw1y2vVjjTkeMnz.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/cormorantupright/v18/VuJudM3I2Y35poFONtLdafkUCHw1y1MhpxDsU9X6RPzQ.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/cormorantupright/v18/VuJudM3I2Y35poFONtLdafkUCHw1y1MNoBDsU9X6RPzQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/cormorantupright/v18/VuJudM3I2Y35poFONtLdafkUCHw1y1NpoRDsU9X6RPzQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Courgette\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/courgette/v13/wEO_EBrAnc9BLjLQAUkFUfAL3EsHiA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Courier Prime\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v7\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/courierprime/v7/u-450q2lgwslOqpF_6gQ8kELWwZjW-_-tvg.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/courierprime/v7/u-4n0q2lgwslOqpF_6gQ8kELawRpX837pvjxPA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/courierprime/v7/u-4k0q2lgwslOqpF_6gQ8kELY7pMf-fVqvHoJXw.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/courierprime/v7/u-4i0q2lgwslOqpF_6gQ8kELawRR4-LfrtPtNXyeAg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"monospace\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Cousine\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v25\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/cousine/v25/d6lIkaiiRdih4SpPzSMlzTbtz9k.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/cousine/v25/d6lKkaiiRdih4SpP_SEvyRTo39l8hw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/cousine/v25/d6lNkaiiRdih4SpP9Z8K6T7G09BlnmQ.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/cousine/v25/d6lPkaiiRdih4SpP_SEXdTvM1_JgjmRpOA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"monospace\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Coustard\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/coustard/v16/3XFpErgg3YsZ5fqUU9UPvWXuROTd.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/coustard/v16/3XFuErgg3YsZ5fqUU-2LkEHmb_jU3eRL.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Covered By Your Grace\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/coveredbyyourgrace/v15/QGYwz-AZahWOJJI9kykWW9mD6opopoqXSOS0FgItq6bFIg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Crafty Girls\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/craftygirls/v16/va9B4kXI39VaDdlPJo8N_NvuQR37fF3Wlg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Creepster\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/creepster/v13/AlZy_zVUqJz4yMrniH4hdXf4XB0Tow.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Crete Round\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/creteround/v14/55xoey1sJNPjPiv1ZZZrxJ1827zAKnxN.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/creteround/v14/55xqey1sJNPjPiv1ZZZrxK1-0bjiL2xNhKc.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Crimson Pro\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v23\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/crimsonpro/v23/q5uUsoa5M_tv7IihmnkabC5XiXCAlXGks1WZTm18OJE_VNWoyQ.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/crimsonpro/v23/q5uUsoa5M_tv7IihmnkabC5XiXCAlXGks1WZkG18OJE_VNWoyQ.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/crimsonpro/v23/q5uUsoa5M_tv7IihmnkabC5XiXCAlXGks1WZzm18OJE_VNWoyQ.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/crimsonpro/v23/q5uUsoa5M_tv7IihmnkabC5XiXCAlXGks1WZ_G18OJE_VNWoyQ.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/crimsonpro/v23/q5uUsoa5M_tv7IihmnkabC5XiXCAlXGks1WZEGp8OJE_VNWoyQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/crimsonpro/v23/q5uUsoa5M_tv7IihmnkabC5XiXCAlXGks1WZKWp8OJE_VNWoyQ.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/crimsonpro/v23/q5uUsoa5M_tv7IihmnkabC5XiXCAlXGks1WZTmp8OJE_VNWoyQ.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/crimsonpro/v23/q5uUsoa5M_tv7IihmnkabC5XiXCAlXGks1WZZ2p8OJE_VNWoyQ.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/crimsonpro/v23/q5uSsoa5M_tv7IihmnkabAReu49Y_Bo-HVKMBi4Ue5s7dtC4yZNE.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/crimsonpro/v23/q5uSsoa5M_tv7IihmnkabAReu49Y_Bo-HVKMBi7Ke5s7dtC4yZNE.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/crimsonpro/v23/q5uSsoa5M_tv7IihmnkabAReu49Y_Bo-HVKMBi6Ue5s7dtC4yZNE.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/crimsonpro/v23/q5uSsoa5M_tv7IihmnkabAReu49Y_Bo-HVKMBi6me5s7dtC4yZNE.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/crimsonpro/v23/q5uSsoa5M_tv7IihmnkabAReu49Y_Bo-HVKMBi5KfJs7dtC4yZNE.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/crimsonpro/v23/q5uSsoa5M_tv7IihmnkabAReu49Y_Bo-HVKMBi5zfJs7dtC4yZNE.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/crimsonpro/v23/q5uSsoa5M_tv7IihmnkabAReu49Y_Bo-HVKMBi4UfJs7dtC4yZNE.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/crimsonpro/v23/q5uSsoa5M_tv7IihmnkabAReu49Y_Bo-HVKMBi49fJs7dtC4yZNE.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Crimson Text\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/crimsontext/v19/wlp2gwHKFkZgtmSR3NB0oRJvaAJSA_JN3Q.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/crimsontext/v19/wlpogwHKFkZgtmSR3NB0oRJfaghWIfdd3ahG.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/crimsontext/v19/wlppgwHKFkZgtmSR3NB0oRJXsCx2C9lR1LFffg.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/crimsontext/v19/wlprgwHKFkZgtmSR3NB0oRJfajCOD9NV9rRPfrKu.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/crimsontext/v19/wlppgwHKFkZgtmSR3NB0oRJX1C12C9lR1LFffg.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/crimsontext/v19/wlprgwHKFkZgtmSR3NB0oRJfajDqDtNV9rRPfrKu.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Croissant One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/croissantone/v20/3y9n6bU9bTPg4m8NDy3Kq24UM3pqn5cdJ-4.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Crushed\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v25\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/crushed/v25/U9Mc6dym6WXImTlFT1kfuIqyLzA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Cuprum\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/cuprum/v20/dg45_pLmvrkcOkBnKsOzXyGWTBcmg-X6ZjzSJjQjgnU.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/cuprum/v20/dg45_pLmvrkcOkBnKsOzXyGWTBcmg9f6ZjzSJjQjgnU.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/cuprum/v20/dg45_pLmvrkcOkBnKsOzXyGWTBcmgzv9ZjzSJjQjgnU.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/cuprum/v20/dg45_pLmvrkcOkBnKsOzXyGWTBcmgwL9ZjzSJjQjgnU.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/cuprum/v20/dg47_pLmvrkcOkBNI_FMh0j91rkhli25jn_YIhYmknUPEA.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/cuprum/v20/dg47_pLmvrkcOkBNI_FMh0j91rkhli25vH_YIhYmknUPEA.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/cuprum/v20/dg47_pLmvrkcOkBNI_FMh0j91rkhli25UHjYIhYmknUPEA.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/cuprum/v20/dg47_pLmvrkcOkBNI_FMh0j91rkhli25aXjYIhYmknUPEA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Cute Font\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"korean\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/cutefont/v20/Noaw6Uny2oWPbSHMrY6vmJNVNC9hkw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Cutive\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/cutive/v17/NaPZcZ_fHOhV3Ip7T_hDoyqlZQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Cutive Mono\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/cutivemono/v14/m8JWjfRfY7WVjVi2E-K9H5RFRG-K3Mud.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"monospace\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"DM Mono\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/dmmono/v10/aFTR7PB1QTsUX8KYvrGyIYSnbKX9Rlk.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/dmmono/v10/aFTT7PB1QTsUX8KYth-orYataIf4VllXuA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/dmmono/v10/aFTU7PB1QTsUX8KYhh2aBYyMcKw.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/dmmono/v10/aFTW7PB1QTsUX8KYth-QAa6JYKzkXw.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/dmmono/v10/aFTR7PB1QTsUX8KYvumzIYSnbKX9Rlk.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/dmmono/v10/aFTT7PB1QTsUX8KYth-o9YetaIf4VllXuA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"monospace\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"DM Sans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/dmsans/v11/rP2Hp2ywxg089UriOZSCHBeHFl0.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/dmsans/v11/rP2Fp2ywxg089UriCZaIGDWCBl0O8Q.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/dmsans/v11/rP2Cp2ywxg089UriAWCrOB-sClQX6Cg.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/dmsans/v11/rP2Ap2ywxg089UriCZaw7BymDnYS-Cjk6Q.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/dmsans/v11/rP2Cp2ywxg089UriASitOB-sClQX6Cg.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/dmsans/v11/rP2Ap2ywxg089UriCZawpBqmDnYS-Cjk6Q.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"DM Serif Display\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/dmserifdisplay/v11/-nFnOHM81r4j6k0gjAW3mujVU2B2K_d709jy92k.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/dmserifdisplay/v11/-nFhOHM81r4j6k0gjAW3mujVU2B2G_Vx1_r352np3Q.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"DM Serif Text\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/dmseriftext/v11/rnCu-xZa_krGokauCeNq1wWyafOPXHIJErY.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/dmseriftext/v11/rnCw-xZa_krGokauCeNq1wWyWfGFWFAMArZKqQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Damion\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/damion/v14/hv-XlzJ3KEUe_YZUbWY3MTFgVg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Dancing Script\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/dancingscript/v24/If2cXTr6YS-zF4S-kcSWSVi_sxjsohD9F50Ruu7BMSoHTeB9ptDqpw.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/dancingscript/v24/If2cXTr6YS-zF4S-kcSWSVi_sxjsohD9F50Ruu7BAyoHTeB9ptDqpw.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/dancingscript/v24/If2cXTr6YS-zF4S-kcSWSVi_sxjsohD9F50Ruu7B7y0HTeB9ptDqpw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/dancingscript/v24/If2cXTr6YS-zF4S-kcSWSVi_sxjsohD9F50Ruu7B1i0HTeB9ptDqpw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Dangrek\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"khmer\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v26\",\n\t\t\t\"lastModified\": \"2022-04-21\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/dangrek/v26/LYjCdG30nEgoH8E2gCNqqVIuTN4.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Darker Grotesque\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v7\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/darkergrotesque/v7/U9MA6cuh-mLQlC4BKCtayOfARkSVoxr2AW8hTOsXsX0.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/darkergrotesque/v7/U9MH6cuh-mLQlC4BKCtayOfARkSVm7beJWcKUOI.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/darkergrotesque/v7/U9MA6cuh-mLQlC4BKCtayOfARkSVo0L3AW8hTOsXsX0.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/darkergrotesque/v7/U9MA6cuh-mLQlC4BKCtayOfARkSVo27wAW8hTOsXsX0.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/darkergrotesque/v7/U9MA6cuh-mLQlC4BKCtayOfARkSVowrxAW8hTOsXsX0.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/darkergrotesque/v7/U9MA6cuh-mLQlC4BKCtayOfARkSVoxbyAW8hTOsXsX0.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/darkergrotesque/v7/U9MA6cuh-mLQlC4BKCtayOfARkSVozLzAW8hTOsXsX0.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"David Libre\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/davidlibre/v13/snfus0W_99N64iuYSvp4W_l86p6TYS-Y.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/davidlibre/v13/snfzs0W_99N64iuYSvp4W8GIw7qbSjORSo9W.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/davidlibre/v13/snfzs0W_99N64iuYSvp4W8HAxbqbSjORSo9W.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Dawning of a New Day\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/dawningofanewday/v16/t5t_IQMbOp2SEwuncwLRjMfIg1yYit_nAz8bhWJGNoBE.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Days One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/daysone/v14/mem9YaCnxnKRiYZOCLYVeLkWVNBt.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Dekko\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/dekko/v19/46khlb_wWjfSrttFR0vsfl1B.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Dela Gothic One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/delagothicone/v10/~ChEKD0RlbGEgR290aGljIE9uZSAAKgQIARgB.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Delius\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/delius/v15/PN_xRfK0pW_9e1rtYcI-jT3L_w.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Delius Swash Caps\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/deliusswashcaps/v19/oY1E8fPLr7v4JWCExZpWebxVKORpXXedKmeBvEYs.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Delius Unicase\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v26\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/deliusunicase/v26/845BNMEwEIOVT8BmgfSzIr_6mmLHd-73LXWs.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/deliusunicase/v26/845CNMEwEIOVT8BmgfSzIr_6mlp7WMr_BmmlS5aw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Della Respira\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/dellarespira/v18/RLp5K5v44KaueWI6iEJQBiGPRfkSu6EuTHo.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Denk One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-04-21\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/denkone/v15/dg4m_pzhrqcFb2IzROtHpbglShon.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Devonshire\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/devonshire/v21/46kqlbDwWirWr4gtBD2BX0Vq01lYAZM.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Dhurjati\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"telugu\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-04-21\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/dhurjati/v20/_6_8ED3gSeatXfFiFX3ySKQtuTA2.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Didact Gothic\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/didactgothic/v19/ahcfv8qz1zt6hCC5G4F_P4ASpUySp0LlcyQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Diplomata\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/diplomata/v24/Cn-0JtiMXwhNwp-wKxyfYGxYrdM9Sg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Diplomata SC\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/diplomatasc/v21/buExpoi3ecvs3kidKgBJo2kf-P5Oaiw4cw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Do Hyeon\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"korean\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/dohyeon/v16/TwMN-I8CRRU2zM86HFE3ZwaH__-C.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Dokdo\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"korean\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/dokdo/v15/esDf315XNuCBLxLo4NaMlKcH.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Domine\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/domine/v19/L0xhDFMnlVwD4h3Lt9JWnbX3jG-2X3LAI10VErGuW8Q.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/domine/v19/L0xhDFMnlVwD4h3Lt9JWnbX3jG-2X0DAI10VErGuW8Q.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/domine/v19/L0xhDFMnlVwD4h3Lt9JWnbX3jG-2X6zHI10VErGuW8Q.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/domine/v19/L0xhDFMnlVwD4h3Lt9JWnbX3jG-2X5XHI10VErGuW8Q.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Donegal One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/donegalone/v20/m8JWjfRYea-ZnFz6fsK9FZRFRG-K3Mud.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Dongle\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"korean\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v8\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/dongle/v8/sJoG3Ltdjt6VPkqeEcxrYjWNzXvVPA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/dongle/v8/sJoF3Ltdjt6VPkqmveRPah6RxA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/dongle/v8/sJoG3Ltdjt6VPkqeActrYjWNzXvVPA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Doppio One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/doppioone/v13/Gg8wN5gSaBfyBw2MqCh-lgshKGpe5Fg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Dorsa\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v23\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/dorsa/v23/yYLn0hjd0OGwqo493XCFxAnQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Dosis\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v27\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/dosis/v27/HhyJU5sn9vOmLxNkIwRSjTVNWLEJt7MV3BkFTq4EPw.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/dosis/v27/HhyJU5sn9vOmLxNkIwRSjTVNWLEJabMV3BkFTq4EPw.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/dosis/v27/HhyJU5sn9vOmLxNkIwRSjTVNWLEJN7MV3BkFTq4EPw.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/dosis/v27/HhyJU5sn9vOmLxNkIwRSjTVNWLEJBbMV3BkFTq4EPw.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/dosis/v27/HhyJU5sn9vOmLxNkIwRSjTVNWLEJ6bQV3BkFTq4EPw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/dosis/v27/HhyJU5sn9vOmLxNkIwRSjTVNWLEJ0LQV3BkFTq4EPw.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/dosis/v27/HhyJU5sn9vOmLxNkIwRSjTVNWLEJt7QV3BkFTq4EPw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"DotGothic16\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/dotgothic16/v15/v6-QGYjBJFKgyw5nSoDAGE7L435YPFrT.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Dr Sugiyama\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/drsugiyama/v22/HTxoL2k4N3O9n5I1boGI7abRM4-t-g7y.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Duru Sans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/durusans/v19/xn7iYH8xwmSyTvEV_HOxT_fYdN-WZw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"DynaPuff\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/dynapuff/v1/z7N5dRvsZDIVHbYPMhZJ3HQ83UaSu4uhr7-ZFeoYkgAr1x8RSxYu6YjrSRs4wn8.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/dynapuff/v1/z7N5dRvsZDIVHbYPMhZJ3HQ83UaSu4uhr7-ZFeoYkgAr1x8RSyQu6YjrSRs4wn8.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/dynapuff/v1/z7N5dRvsZDIVHbYPMhZJ3HQ83UaSu4uhr7-ZFeoYkgAr1x8RS8gp6YjrSRs4wn8.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/dynapuff/v1/z7N5dRvsZDIVHbYPMhZJ3HQ83UaSu4uhr7-ZFeoYkgAr1x8RS_Ep6YjrSRs4wn8.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Dynalight\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/dynalight/v18/1Ptsg8LOU_aOmQvTsF4ISotrDfGGxA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"EB Garamond\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v26\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ebgaramond/v26/SlGDmQSNjdsmc35JDF1K5E55YMjF_7DPuGi-6_RUA4V-e6yHgQ.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/ebgaramond/v26/SlGDmQSNjdsmc35JDF1K5E55YMjF_7DPuGi-2fRUA4V-e6yHgQ.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/ebgaramond/v26/SlGDmQSNjdsmc35JDF1K5E55YMjF_7DPuGi-NfNUA4V-e6yHgQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/ebgaramond/v26/SlGDmQSNjdsmc35JDF1K5E55YMjF_7DPuGi-DPNUA4V-e6yHgQ.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/ebgaramond/v26/SlGDmQSNjdsmc35JDF1K5E55YMjF_7DPuGi-a_NUA4V-e6yHgQ.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/ebgaramond/v26/SlGFmQSNjdsmc35JDF1K5GRwUjcdlttVFm-rI7e8QI96WamXgXFI.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/ebgaramond/v26/SlGFmQSNjdsmc35JDF1K5GRwUjcdlttVFm-rI7eOQI96WamXgXFI.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/ebgaramond/v26/SlGFmQSNjdsmc35JDF1K5GRwUjcdlttVFm-rI7diR496WamXgXFI.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/ebgaramond/v26/SlGFmQSNjdsmc35JDF1K5GRwUjcdlttVFm-rI7dbR496WamXgXFI.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/ebgaramond/v26/SlGFmQSNjdsmc35JDF1K5GRwUjcdlttVFm-rI7c8R496WamXgXFI.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Eagle Lake\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/eaglelake/v20/ptRMTiqbbuNJDOiKj9wG5O7yKQNute8.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"East Sea Dokdo\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"korean\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/eastseadokdo/v20/xfuo0Wn2V2_KanASqXSZp22m05_aGavYS18y.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Eater\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/eater/v21/mtG04_FCK7bOvpu2u3FwsXsR.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Economica\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/economica/v13/Qw3fZQZaHCLgIWa29ZBrMcgAAl1lfQ.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/economica/v13/Qw3ZZQZaHCLgIWa29ZBbM8IEIFh1fWUl.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/economica/v13/Qw3aZQZaHCLgIWa29ZBTjeckCnZ5dHw8iw.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/economica/v13/Qw3EZQZaHCLgIWa29ZBbM_q4D3x9Vnksi4M7.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Eczar\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/eczar/v17/BXR2vF3Pi-DLmxcpJB-qbNTyTMDXHd6WqTIVKWJKWg.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/eczar/v17/BXR2vF3Pi-DLmxcpJB-qbNTyTMDXL96WqTIVKWJKWg.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/eczar/v17/BXR2vF3Pi-DLmxcpJB-qbNTyTMDXw9mWqTIVKWJKWg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/eczar/v17/BXR2vF3Pi-DLmxcpJB-qbNTyTMDX-tmWqTIVKWJKWg.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/eczar/v17/BXR2vF3Pi-DLmxcpJB-qbNTyTMDXndmWqTIVKWJKWg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Edu NSW ACT Foundation\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v2\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/edunswactfoundation/v2/raxRHjqJtsNBFUi8WO0vUBgc9D-2lV_oQdCAYlt_QTQ0vUxJki9tovGLeC-sfguJ.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/edunswactfoundation/v2/raxRHjqJtsNBFUi8WO0vUBgc9D-2lV_oQdCAYlt_QTQ0vUxJki9fovGLeC-sfguJ.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/edunswactfoundation/v2/raxRHjqJtsNBFUi8WO0vUBgc9D-2lV_oQdCAYlt_QTQ0vUxJki-zpfGLeC-sfguJ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/edunswactfoundation/v2/raxRHjqJtsNBFUi8WO0vUBgc9D-2lV_oQdCAYlt_QTQ0vUxJki-KpfGLeC-sfguJ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Edu QLD Beginner\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v2\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/eduqldbeginner/v2/AMOHz5iUuHLEMNXyohhc_Y56PR3A8dNLF_w3Ka4HKE4E3oebi6vyVWCN.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/eduqldbeginner/v2/AMOHz5iUuHLEMNXyohhc_Y56PR3A8dNLF_w3Ka4HKE423oebi6vyVWCN.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/eduqldbeginner/v2/AMOHz5iUuHLEMNXyohhc_Y56PR3A8dNLF_w3Ka4HKE7a2Yebi6vyVWCN.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/eduqldbeginner/v2/AMOHz5iUuHLEMNXyohhc_Y56PR3A8dNLF_w3Ka4HKE7j2Yebi6vyVWCN.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Edu SA Beginner\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v2\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/edusabeginner/v2/rnC_-xRb1x-1lHXnLaZZ2xOoLIGfU3L82irpr_3C9989fo1yBydUEDs.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/edusabeginner/v2/rnC_-xRb1x-1lHXnLaZZ2xOoLIGfU3L82irpr_3C9-09fo1yBydUEDs.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/edusabeginner/v2/rnC_-xRb1x-1lHXnLaZZ2xOoLIGfU3L82irpr_3C9wE6fo1yBydUEDs.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/edusabeginner/v2/rnC_-xRb1x-1lHXnLaZZ2xOoLIGfU3L82irpr_3C9zg6fo1yBydUEDs.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Edu TAS Beginner\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v2\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/edutasbeginner/v2/ZXuwe04WubHfGVY-1TcNg7AFUmshg8jIUTzK3r34f_HwemkrBWRhvk02.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/edutasbeginner/v2/ZXuwe04WubHfGVY-1TcNg7AFUmshg8jIUTzK3r34f_HCemkrBWRhvk02.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/edutasbeginner/v2/ZXuwe04WubHfGVY-1TcNg7AFUmshg8jIUTzK3r34f_EufWkrBWRhvk02.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/edutasbeginner/v2/ZXuwe04WubHfGVY-1TcNg7AFUmshg8jIUTzK3r34f_EXfWkrBWRhvk02.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Edu VIC WA NT Beginner\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v2\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/eduvicwantbeginner/v2/jiz2RF1BuW9OwcnNPxLl4KfZCHd9nFtd5Tu7stCpElYpvPfZZ-OXlPmFXwnpkeGR.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/eduvicwantbeginner/v2/jiz2RF1BuW9OwcnNPxLl4KfZCHd9nFtd5Tu7stCpElYpvPfZZ-OllPmFXwnpkeGR.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/eduvicwantbeginner/v2/jiz2RF1BuW9OwcnNPxLl4KfZCHd9nFtd5Tu7stCpElYpvPfZZ-NJk_mFXwnpkeGR.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/eduvicwantbeginner/v2/jiz2RF1BuW9OwcnNPxLl4KfZCHd9nFtd5Tu7stCpElYpvPfZZ-Nwk_mFXwnpkeGR.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"El Messiri\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/elmessiri/v18/K2FhfZBRmr9vQ1pHEey6GIGo8_pv3myYjuXwe65ghj3OoapG.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/elmessiri/v18/K2FhfZBRmr9vQ1pHEey6GIGo8_pv3myYjuXCe65ghj3OoapG.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/elmessiri/v18/K2FhfZBRmr9vQ1pHEey6GIGo8_pv3myYjuUufK5ghj3OoapG.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/elmessiri/v18/K2FhfZBRmr9vQ1pHEey6GIGo8_pv3myYjuUXfK5ghj3OoapG.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Electrolize\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-04-21\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/electrolize/v14/cIf5Ma1dtE0zSiGSiED7AUEGso5tQafB.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Elsie\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/elsie/v12/BCanqZABrez54yYu9slAeLgX.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/elsie/v12/BCaqqZABrez54x6q2-1IU6QeXSBk.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Elsie Swash Caps\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/elsieswashcaps/v21/845DNN8xGZyVX5MVo_upKf7KnjK0ferVKGWsUo8.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/elsieswashcaps/v21/845ENN8xGZyVX5MVo_upKf7KnjK0RW74DG2HToawrdU.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Emblema One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/emblemaone/v21/nKKT-GQ0F5dSY8vzG0rOEIRBHl57G_f_.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Emilys Candy\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/emilyscandy/v13/2EbgL-1mD1Rnb0OGKudbk0y5r9xrX84JjA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Encode Sans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/encodesans/v15/LDIcapOFNxEwR-Bd1O9uYNmnUQomAgE25imKSbHhROjLsZBWTSrQGGHiZtWP7FJCt2c.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/encodesans/v15/LDIcapOFNxEwR-Bd1O9uYNmnUQomAgE25imKSbHhROjLsZBWTSrQGOHjZtWP7FJCt2c.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/encodesans/v15/LDIcapOFNxEwR-Bd1O9uYNmnUQomAgE25imKSbHhROjLsZBWTSrQGD_jZtWP7FJCt2c.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/encodesans/v15/LDIcapOFNxEwR-Bd1O9uYNmnUQomAgE25imKSbHhROjLsZBWTSrQGGHjZtWP7FJCt2c.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/encodesans/v15/LDIcapOFNxEwR-Bd1O9uYNmnUQomAgE25imKSbHhROjLsZBWTSrQGFPjZtWP7FJCt2c.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/encodesans/v15/LDIcapOFNxEwR-Bd1O9uYNmnUQomAgE25imKSbHhROjLsZBWTSrQGL_kZtWP7FJCt2c.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/encodesans/v15/LDIcapOFNxEwR-Bd1O9uYNmnUQomAgE25imKSbHhROjLsZBWTSrQGIbkZtWP7FJCt2c.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/encodesans/v15/LDIcapOFNxEwR-Bd1O9uYNmnUQomAgE25imKSbHhROjLsZBWTSrQGOHkZtWP7FJCt2c.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/encodesans/v15/LDIcapOFNxEwR-Bd1O9uYNmnUQomAgE25imKSbHhROjLsZBWTSrQGMjkZtWP7FJCt2c.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Encode Sans Condensed\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/encodesanscondensed/v10/j8_76_LD37rqfuwxyIuaZhE6cRXOLtm2gfT-5a-JLQoFI2KR.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/encodesanscondensed/v10/j8_46_LD37rqfuwxyIuaZhE6cRXOLtm2gfT-SY6pByQJKnuIFA.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/encodesanscondensed/v10/j8_46_LD37rqfuwxyIuaZhE6cRXOLtm2gfT-LY2pByQJKnuIFA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/encodesanscondensed/v10/j8_16_LD37rqfuwxyIuaZhE6cRXOLtm2gfTGgaWNDw8VIw.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/encodesanscondensed/v10/j8_46_LD37rqfuwxyIuaZhE6cRXOLtm2gfT-dYypByQJKnuIFA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/encodesanscondensed/v10/j8_46_LD37rqfuwxyIuaZhE6cRXOLtm2gfT-WYupByQJKnuIFA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/encodesanscondensed/v10/j8_46_LD37rqfuwxyIuaZhE6cRXOLtm2gfT-PYqpByQJKnuIFA.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/encodesanscondensed/v10/j8_46_LD37rqfuwxyIuaZhE6cRXOLtm2gfT-IYmpByQJKnuIFA.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/encodesanscondensed/v10/j8_46_LD37rqfuwxyIuaZhE6cRXOLtm2gfT-BYipByQJKnuIFA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Encode Sans Expanded\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/encodesansexpanded/v10/c4mx1mF4GcnstG_Jh1QH6ac4hNLeNyeYUpJGKQNicoAbJlw.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/encodesansexpanded/v10/c4mw1mF4GcnstG_Jh1QH6ac4hNLeNyeYUpLqCCNIXIwSP0XD.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/encodesansexpanded/v10/c4mw1mF4GcnstG_Jh1QH6ac4hNLeNyeYUpKOCyNIXIwSP0XD.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/encodesansexpanded/v10/c4m_1mF4GcnstG_Jh1QH6ac4hNLeNyeYUqoiIwdAd5Ab.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/encodesansexpanded/v10/c4mw1mF4GcnstG_Jh1QH6ac4hNLeNyeYUpLWCiNIXIwSP0XD.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/encodesansexpanded/v10/c4mw1mF4GcnstG_Jh1QH6ac4hNLeNyeYUpL6DSNIXIwSP0XD.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/encodesansexpanded/v10/c4mw1mF4GcnstG_Jh1QH6ac4hNLeNyeYUpKeDCNIXIwSP0XD.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/encodesansexpanded/v10/c4mw1mF4GcnstG_Jh1QH6ac4hNLeNyeYUpKCDyNIXIwSP0XD.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/encodesansexpanded/v10/c4mw1mF4GcnstG_Jh1QH6ac4hNLeNyeYUpKmDiNIXIwSP0XD.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Encode Sans SC\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v8\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/encodesanssc/v8/jVyp7nLwCGzQ9zE7ZyRg0QRXHPZc_uUA6Kb3VJWLE_Pdtm7lcD6qvXT1HHhn8c9NOEEClIc.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/encodesanssc/v8/jVyp7nLwCGzQ9zE7ZyRg0QRXHPZc_uUA6Kb3VJWLE_Pdtm7lcD6qvXT1HPhm8c9NOEEClIc.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/encodesanssc/v8/jVyp7nLwCGzQ9zE7ZyRg0QRXHPZc_uUA6Kb3VJWLE_Pdtm7lcD6qvXT1HCZm8c9NOEEClIc.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/encodesanssc/v8/jVyp7nLwCGzQ9zE7ZyRg0QRXHPZc_uUA6Kb3VJWLE_Pdtm7lcD6qvXT1HHhm8c9NOEEClIc.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/encodesanssc/v8/jVyp7nLwCGzQ9zE7ZyRg0QRXHPZc_uUA6Kb3VJWLE_Pdtm7lcD6qvXT1HEpm8c9NOEEClIc.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/encodesanssc/v8/jVyp7nLwCGzQ9zE7ZyRg0QRXHPZc_uUA6Kb3VJWLE_Pdtm7lcD6qvXT1HKZh8c9NOEEClIc.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/encodesanssc/v8/jVyp7nLwCGzQ9zE7ZyRg0QRXHPZc_uUA6Kb3VJWLE_Pdtm7lcD6qvXT1HJ9h8c9NOEEClIc.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/encodesanssc/v8/jVyp7nLwCGzQ9zE7ZyRg0QRXHPZc_uUA6Kb3VJWLE_Pdtm7lcD6qvXT1HPhh8c9NOEEClIc.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/encodesanssc/v8/jVyp7nLwCGzQ9zE7ZyRg0QRXHPZc_uUA6Kb3VJWLE_Pdtm7lcD6qvXT1HNFh8c9NOEEClIc.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Encode Sans Semi Condensed\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/encodesanssemicondensed/v10/3qT6oiKqnDuUtQUEHMoXcmspmy55SFWrXFRp9FTOG1T19MFtQ9jpVUA.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/encodesanssemicondensed/v10/3qT7oiKqnDuUtQUEHMoXcmspmy55SFWrXFRp9FTOG1RZ1eFHbdTgTFmr.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/encodesanssemicondensed/v10/3qT7oiKqnDuUtQUEHMoXcmspmy55SFWrXFRp9FTOG1Q91uFHbdTgTFmr.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/encodesanssemicondensed/v10/3qT4oiKqnDuUtQUEHMoXcmspmy55SFWrXFRp9FTOG2yR_sVPRsjp.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/encodesanssemicondensed/v10/3qT7oiKqnDuUtQUEHMoXcmspmy55SFWrXFRp9FTOG1Rl1-FHbdTgTFmr.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/encodesanssemicondensed/v10/3qT7oiKqnDuUtQUEHMoXcmspmy55SFWrXFRp9FTOG1RJ0OFHbdTgTFmr.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/encodesanssemicondensed/v10/3qT7oiKqnDuUtQUEHMoXcmspmy55SFWrXFRp9FTOG1Qt0eFHbdTgTFmr.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/encodesanssemicondensed/v10/3qT7oiKqnDuUtQUEHMoXcmspmy55SFWrXFRp9FTOG1Qx0uFHbdTgTFmr.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/encodesanssemicondensed/v10/3qT7oiKqnDuUtQUEHMoXcmspmy55SFWrXFRp9FTOG1QV0-FHbdTgTFmr.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Encode Sans Semi Expanded\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/encodesanssemiexpanded/v18/ke8xOhAPMEZs-BDuzwftTNJ85JvwMOzE9d9Cca5TM-41KwrlKXeOEA.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/encodesanssemiexpanded/v18/ke8yOhAPMEZs-BDuzwftTNJ85JvwMOzE9d9Cca5TM0IUCyDLJX6XCWU.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/encodesanssemiexpanded/v18/ke8yOhAPMEZs-BDuzwftTNJ85JvwMOzE9d9Cca5TMyYXCyDLJX6XCWU.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/encodesanssemiexpanded/v18/ke83OhAPMEZs-BDuzwftTNJ85JvwMOzE9d9Cca5TC4o_LyjgOXc.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/encodesanssemiexpanded/v18/ke8yOhAPMEZs-BDuzwftTNJ85JvwMOzE9d9Cca5TM34WCyDLJX6XCWU.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/encodesanssemiexpanded/v18/ke8yOhAPMEZs-BDuzwftTNJ85JvwMOzE9d9Cca5TM1IRCyDLJX6XCWU.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/encodesanssemiexpanded/v18/ke8yOhAPMEZs-BDuzwftTNJ85JvwMOzE9d9Cca5TMzYQCyDLJX6XCWU.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/encodesanssemiexpanded/v18/ke8yOhAPMEZs-BDuzwftTNJ85JvwMOzE9d9Cca5TMyoTCyDLJX6XCWU.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/encodesanssemiexpanded/v18/ke8yOhAPMEZs-BDuzwftTNJ85JvwMOzE9d9Cca5TMw4SCyDLJX6XCWU.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Engagement\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/engagement/v22/x3dlckLDZbqa7RUs9MFVXNossybsHQI.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Englebert\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/englebert/v17/xn7iYH8w2XGrC8AR4HSxT_fYdN-WZw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Enriqueta\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/enriqueta/v15/goksH6L7AUFrRvV44HVTS0CjkP1Yog.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/enriqueta/v15/gokpH6L7AUFrRvV44HVrv2mHmNZEq6TTFw.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/enriqueta/v15/gokpH6L7AUFrRvV44HVrk26HmNZEq6TTFw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/enriqueta/v15/gokpH6L7AUFrRvV44HVr92-HmNZEq6TTFw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Ephesis\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v7\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ephesis/v7/uU9PCBUS8IerL2VG7xPb3vyHmlI.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Epilogue\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/epilogue/v13/O4ZMFGj5hxF0EhjimngomvnCCtqb30OXMDLiDJXVigHPVA.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/epilogue/v13/O4ZMFGj5hxF0EhjimngomvnCCtqb30OXsDPiDJXVigHPVA.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/epilogue/v13/O4ZMFGj5hxF0EhjimngomvnCCtqb30OXbjPiDJXVigHPVA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/epilogue/v13/O4ZMFGj5hxF0EhjimngomvnCCtqb30OXMDPiDJXVigHPVA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/epilogue/v13/O4ZMFGj5hxF0EhjimngomvnCCtqb30OXAjPiDJXVigHPVA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/epilogue/v13/O4ZMFGj5hxF0EhjimngomvnCCtqb30OX7jTiDJXVigHPVA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/epilogue/v13/O4ZMFGj5hxF0EhjimngomvnCCtqb30OX1zTiDJXVigHPVA.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/epilogue/v13/O4ZMFGj5hxF0EhjimngomvnCCtqb30OXsDTiDJXVigHPVA.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/epilogue/v13/O4ZMFGj5hxF0EhjimngomvnCCtqb30OXmTTiDJXVigHPVA.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/epilogue/v13/O4ZCFGj5hxF0EhjimlIhqAYaY7EBcUSC-HAKTp_RqATfVHNU.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/epilogue/v13/O4ZCFGj5hxF0EhjimlIhqAYaY7EBcUSC-HCKT5_RqATfVHNU.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/epilogue/v13/O4ZCFGj5hxF0EhjimlIhqAYaY7EBcUSC-HBUT5_RqATfVHNU.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/epilogue/v13/O4ZCFGj5hxF0EhjimlIhqAYaY7EBcUSC-HAKT5_RqATfVHNU.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/epilogue/v13/O4ZCFGj5hxF0EhjimlIhqAYaY7EBcUSC-HA4T5_RqATfVHNU.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/epilogue/v13/O4ZCFGj5hxF0EhjimlIhqAYaY7EBcUSC-HDUSJ_RqATfVHNU.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/epilogue/v13/O4ZCFGj5hxF0EhjimlIhqAYaY7EBcUSC-HDtSJ_RqATfVHNU.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/epilogue/v13/O4ZCFGj5hxF0EhjimlIhqAYaY7EBcUSC-HCKSJ_RqATfVHNU.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/epilogue/v13/O4ZCFGj5hxF0EhjimlIhqAYaY7EBcUSC-HCjSJ_RqATfVHNU.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Erica One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v23\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ericaone/v23/WBLnrEXccV9VGrOKmGD1W0_MJMGxiQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Esteban\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/esteban/v14/r05bGLZE-bdGdN-GdOuD5jokU8E.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Estonia\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v9\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/estonia/v9/7Au_p_4ijSecA1yHCCL8zkwMIFg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Euphoria Script\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/euphoriascript/v16/mFTpWb0X2bLb_cx6To2B8GpKoD5ak_ZT1D8x7Q.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Ewert\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ewert/v21/va9I4kzO2tFODYBvS-J3kbDP.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Exo\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/exo/v20/4UaZrEtFpBI4f1ZSIK9d4LjJ4lM2CwNsOl4p5Is.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/exo/v20/4UaZrEtFpBI4f1ZSIK9d4LjJ4tM3CwNsOl4p5Is.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/exo/v20/4UaZrEtFpBI4f1ZSIK9d4LjJ4g03CwNsOl4p5Is.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/exo/v20/4UaZrEtFpBI4f1ZSIK9d4LjJ4lM3CwNsOl4p5Is.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/exo/v20/4UaZrEtFpBI4f1ZSIK9d4LjJ4mE3CwNsOl4p5Is.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/exo/v20/4UaZrEtFpBI4f1ZSIK9d4LjJ4o0wCwNsOl4p5Is.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/exo/v20/4UaZrEtFpBI4f1ZSIK9d4LjJ4rQwCwNsOl4p5Is.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/exo/v20/4UaZrEtFpBI4f1ZSIK9d4LjJ4tMwCwNsOl4p5Is.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/exo/v20/4UaZrEtFpBI4f1ZSIK9d4LjJ4vowCwNsOl4p5Is.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/exo/v20/4UafrEtFpBISdmSt-MY2ehbO95t040FmPnws9Iu-uA.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/exo/v20/4UafrEtFpBISdmSt-MY2ehbO95t0Y0BmPnws9Iu-uA.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/exo/v20/4UafrEtFpBISdmSt-MY2ehbO95t0vUBmPnws9Iu-uA.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/exo/v20/4UafrEtFpBISdmSt-MY2ehbO95t040BmPnws9Iu-uA.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/exo/v20/4UafrEtFpBISdmSt-MY2ehbO95t00UBmPnws9Iu-uA.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/exo/v20/4UafrEtFpBISdmSt-MY2ehbO95t0PUdmPnws9Iu-uA.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/exo/v20/4UafrEtFpBISdmSt-MY2ehbO95t0BEdmPnws9Iu-uA.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/exo/v20/4UafrEtFpBISdmSt-MY2ehbO95t0Y0dmPnws9Iu-uA.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/exo/v20/4UafrEtFpBISdmSt-MY2ehbO95t0SkdmPnws9Iu-uA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Exo 2\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/exo2/v20/7cH1v4okm5zmbvwkAx_sfcEuiD8jvvOcPtq-rpvLpQ.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/exo2/v20/7cH1v4okm5zmbvwkAx_sfcEuiD8jPvKcPtq-rpvLpQ.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/exo2/v20/7cH1v4okm5zmbvwkAx_sfcEuiD8j4PKcPtq-rpvLpQ.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/exo2/v20/7cH1v4okm5zmbvwkAx_sfcEuiD8jvvKcPtq-rpvLpQ.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/exo2/v20/7cH1v4okm5zmbvwkAx_sfcEuiD8jjPKcPtq-rpvLpQ.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/exo2/v20/7cH1v4okm5zmbvwkAx_sfcEuiD8jYPWcPtq-rpvLpQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/exo2/v20/7cH1v4okm5zmbvwkAx_sfcEuiD8jWfWcPtq-rpvLpQ.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/exo2/v20/7cH1v4okm5zmbvwkAx_sfcEuiD8jPvWcPtq-rpvLpQ.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/exo2/v20/7cH1v4okm5zmbvwkAx_sfcEuiD8jF_WcPtq-rpvLpQ.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/exo2/v20/7cH3v4okm5zmbtYtMeA0FKq0Jjg2drF0fNC6jJ7bpQBL.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/exo2/v20/7cH3v4okm5zmbtYtMeA0FKq0Jjg2drH0fdC6jJ7bpQBL.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/exo2/v20/7cH3v4okm5zmbtYtMeA0FKq0Jjg2drEqfdC6jJ7bpQBL.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/exo2/v20/7cH3v4okm5zmbtYtMeA0FKq0Jjg2drF0fdC6jJ7bpQBL.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/exo2/v20/7cH3v4okm5zmbtYtMeA0FKq0Jjg2drFGfdC6jJ7bpQBL.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/exo2/v20/7cH3v4okm5zmbtYtMeA0FKq0Jjg2drGqetC6jJ7bpQBL.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/exo2/v20/7cH3v4okm5zmbtYtMeA0FKq0Jjg2drGTetC6jJ7bpQBL.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/exo2/v20/7cH3v4okm5zmbtYtMeA0FKq0Jjg2drH0etC6jJ7bpQBL.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/exo2/v20/7cH3v4okm5zmbtYtMeA0FKq0Jjg2drHdetC6jJ7bpQBL.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Expletus Sans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/expletussans/v24/RLpqK5v5_bqufTYdnhFzDj2dX_IwS3my73zcDaSY2s1oFQTcXfMm.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/expletussans/v24/RLpqK5v5_bqufTYdnhFzDj2dX_IwS3my73zcDaSq2s1oFQTcXfMm.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/expletussans/v24/RLpqK5v5_bqufTYdnhFzDj2dX_IwS3my73zcDaRG3c1oFQTcXfMm.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/expletussans/v24/RLpqK5v5_bqufTYdnhFzDj2dX_IwS3my73zcDaR_3c1oFQTcXfMm.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/expletussans/v24/RLpoK5v5_bqufTYdnhFzDj2ddfsCtKHbhOZyCrFQmSUrHwD-WOMmKKY.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/expletussans/v24/RLpoK5v5_bqufTYdnhFzDj2ddfsCtKHbhOZyCrFQmRcrHwD-WOMmKKY.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/expletussans/v24/RLpoK5v5_bqufTYdnhFzDj2ddfsCtKHbhOZyCrFQmfssHwD-WOMmKKY.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/expletussans/v24/RLpoK5v5_bqufTYdnhFzDj2ddfsCtKHbhOZyCrFQmcIsHwD-WOMmKKY.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Explora\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cherokee\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v7\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/explora/v7/tsstApxFfjUH4wrvc1qPonC3vqc.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Fahkwang\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"thai\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/fahkwang/v16/Noa26Uj3zpmBOgbNpOJHmZlRFipxkwjx.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/fahkwang/v16/Noa06Uj3zpmBOgbNpOqNgHFQHC5Tlhjxdw4.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/fahkwang/v16/Noa26Uj3zpmBOgbNpOIjmplRFipxkwjx.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/fahkwang/v16/Noa06Uj3zpmBOgbNpOqNgBVTHC5Tlhjxdw4.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/fahkwang/v16/Noax6Uj3zpmBOgbNpNqPsr1ZPTZ4.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/fahkwang/v16/Noa36Uj3zpmBOgbNpOqNuLl7OCZ4ihE.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/fahkwang/v16/Noa26Uj3zpmBOgbNpOJ7m5lRFipxkwjx.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/fahkwang/v16/Noa06Uj3zpmBOgbNpOqNgE1SHC5Tlhjxdw4.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/fahkwang/v16/Noa26Uj3zpmBOgbNpOJXnJlRFipxkwjx.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/fahkwang/v16/Noa06Uj3zpmBOgbNpOqNgGFVHC5Tlhjxdw4.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/fahkwang/v16/Noa26Uj3zpmBOgbNpOIznZlRFipxkwjx.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/fahkwang/v16/Noa06Uj3zpmBOgbNpOqNgAVUHC5Tlhjxdw4.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Familjen Grotesk\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v4\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/familjengrotesk/v4/Qw3LZR9ZHiDnImG6-NEMQ41wby8WRnYsfkunR_eGfMGJaSztc1jcEYq2.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/familjengrotesk/v4/Qw3LZR9ZHiDnImG6-NEMQ41wby8WRnYsfkunR_eGfMG7aSztc1jcEYq2.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/familjengrotesk/v4/Qw3LZR9ZHiDnImG6-NEMQ41wby8WRnYsfkunR_eGfMFXbiztc1jcEYq2.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/familjengrotesk/v4/Qw3LZR9ZHiDnImG6-NEMQ41wby8WRnYsfkunR_eGfMFubiztc1jcEYq2.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/familjengrotesk/v4/Qw31ZR9ZHiDnImG6-NEMQ41wby8WbH8egZPOLG0oe9RBKsSueVz-FJq2Rv4.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/familjengrotesk/v4/Qw31ZR9ZHiDnImG6-NEMQ41wby8WbH8egZPOLG0oe9RBKvaueVz-FJq2Rv4.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/familjengrotesk/v4/Qw31ZR9ZHiDnImG6-NEMQ41wby8WbH8egZPOLG0oe9RBKhqpeVz-FJq2Rv4.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/familjengrotesk/v4/Qw31ZR9ZHiDnImG6-NEMQ41wby8WbH8egZPOLG0oe9RBKiOpeVz-FJq2Rv4.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Fanwood Text\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/fanwoodtext/v15/3XFtErwl05Ad_vSCF6Fq7xXGRdbY1P1Sbg.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/fanwoodtext/v15/3XFzErwl05Ad_vSCF6Fq7xX2R9zc9vhCblye.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Farro\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/farro/v14/i7dJIFl3byGNHa3hNJ6-WkJUQUq7.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/farro/v14/i7dEIFl3byGNHZVNHLq2cV5d.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/farro/v14/i7dJIFl3byGNHa25NZ6-WkJUQUq7.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/farro/v14/i7dJIFl3byGNHa3xM56-WkJUQUq7.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Farsan\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"gujarati\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/farsan/v18/VEMwRoJ0vY_zsyz62q-pxDX9rQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Fascinate\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/fascinate/v21/z7NWdRrufC8XJK0IIEli1LbQRPyNrw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Fascinate Inline\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/fascinateinline/v22/jVyR7mzzB3zc-jp6QCAu60poNqIy1g3CfRXxWZQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Faster One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/fasterone/v17/H4ciBXCHmdfClFb-vWhfyLuShq63czE.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Fasthand\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"khmer\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v26\",\n\t\t\t\"lastModified\": \"2022-04-21\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/fasthand/v26/0yb9GDohyKTYn_ZEESkuYkw2rQg1.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Fauna One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/faunaone/v13/wlpzgwTPBVpjpCuwkuEx2UxLYClOCg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Faustina\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/faustina/v16/XLY4IZPxYpJfTbZAFXWzNT2SO8wpWHls3IEvGVWWe8tbEg.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/faustina/v16/XLY4IZPxYpJfTbZAFXWzNT2SO8wpWHlsgoEvGVWWe8tbEg.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/faustina/v16/XLY4IZPxYpJfTbZAFXWzNT2SO8wpWHlssIEvGVWWe8tbEg.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/faustina/v16/XLY4IZPxYpJfTbZAFXWzNT2SO8wpWHlsXIYvGVWWe8tbEg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/faustina/v16/XLY4IZPxYpJfTbZAFXWzNT2SO8wpWHlsZYYvGVWWe8tbEg.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/faustina/v16/XLY4IZPxYpJfTbZAFXWzNT2SO8wpWHlsAoYvGVWWe8tbEg.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/faustina/v16/XLY2IZPxYpJfTbZAFV-6B8JKUqez9n55SsKZWl-SWc5LEnoF.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/faustina/v16/XLY2IZPxYpJfTbZAFV-6B8JKUqez9n55SsLHWl-SWc5LEnoF.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/faustina/v16/XLY2IZPxYpJfTbZAFV-6B8JKUqez9n55SsL1Wl-SWc5LEnoF.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/faustina/v16/XLY2IZPxYpJfTbZAFV-6B8JKUqez9n55SsIZXV-SWc5LEnoF.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/faustina/v16/XLY2IZPxYpJfTbZAFV-6B8JKUqez9n55SsIgXV-SWc5LEnoF.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/faustina/v16/XLY2IZPxYpJfTbZAFV-6B8JKUqez9n55SsJHXV-SWc5LEnoF.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Federant\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v25\",\n\t\t\t\"lastModified\": \"2022-04-21\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/federant/v25/2sDdZGNfip_eirT0_U0jRUG0AqUc.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Federo\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-04-21\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/federo/v19/iJWFBX-cbD_ETsbmjVOe2WTG7Q.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Felipa\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/felipa/v19/FwZa7-owz1Eu4F_wSNSEwM2zpA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Fenix\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/fenix/v20/XoHo2YL_S7-g5ostKzAFvs8o.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Festive\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v7\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/festive/v7/cY9Ffj6KX1xcoDWhFtfgy9HTkak.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Figtree\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v2\",\n\t\t\t\"lastModified\": \"2022-11-18\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/figtree/v2/_Xmz-HUzqDCFdgfMsYiV_F7wfS-Bs_chQF5ewkEU4HTy.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/figtree/v2/_Xmz-HUzqDCFdgfMsYiV_F7wfS-Bs_d_QF5ewkEU4HTy.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/figtree/v2/_Xmz-HUzqDCFdgfMsYiV_F7wfS-Bs_dNQF5ewkEU4HTy.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/figtree/v2/_Xmz-HUzqDCFdgfMsYiV_F7wfS-Bs_ehR15ewkEU4HTy.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/figtree/v2/_Xmz-HUzqDCFdgfMsYiV_F7wfS-Bs_eYR15ewkEU4HTy.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/figtree/v2/_Xmz-HUzqDCFdgfMsYiV_F7wfS-Bs_f_R15ewkEU4HTy.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/figtree/v2/_Xmz-HUzqDCFdgfMsYiV_F7wfS-Bs_fWR15ewkEU4HTy.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/figtree/v2/_Xm9-HUzqDCFdgfMm4GnA4aZFrUvtOK3A-gdyEU25WTybO8.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/figtree/v2/_Xm9-HUzqDCFdgfMm4GnA4aZFrUvtOK3A7YdyEU25WTybO8.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/figtree/v2/_Xm9-HUzqDCFdgfMm4GnA4aZFrUvtOK3A4QdyEU25WTybO8.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/figtree/v2/_Xm9-HUzqDCFdgfMm4GnA4aZFrUvtOK3A2gayEU25WTybO8.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/figtree/v2/_Xm9-HUzqDCFdgfMm4GnA4aZFrUvtOK3A1EayEU25WTybO8.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/figtree/v2/_Xm9-HUzqDCFdgfMm4GnA4aZFrUvtOK3AzYayEU25WTybO8.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/figtree/v2/_Xm9-HUzqDCFdgfMm4GnA4aZFrUvtOK3Ax8ayEU25WTybO8.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Finger Paint\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/fingerpaint/v15/0QInMXVJ-o-oRn_7dron8YWO85bS8ANesw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Finlandica\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v5\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/finlandica/v5/-nFsOGk-8vAc7lEtg0aSyZCty9GSsPBE19A7rEjx9i5ss3a3.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/finlandica/v5/-nFsOGk-8vAc7lEtg0aSyZCty9GSsPBE19AJrEjx9i5ss3a3.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/finlandica/v5/-nFsOGk-8vAc7lEtg0aSyZCty9GSsPBE19Dlq0jx9i5ss3a3.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/finlandica/v5/-nFsOGk-8vAc7lEtg0aSyZCty9GSsPBE19Dcq0jx9i5ss3a3.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/finlandica/v5/-nFuOGk-8vAc7lEtg0aS45mfNAn722rq0MXz76Cy_CpOtma3uNQ.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/finlandica/v5/-nFuOGk-8vAc7lEtg0aS45mfNAn722rq0MXz75Ky_CpOtma3uNQ.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/finlandica/v5/-nFuOGk-8vAc7lEtg0aS45mfNAn722rq0MXz7361_CpOtma3uNQ.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/finlandica/v5/-nFuOGk-8vAc7lEtg0aS45mfNAn722rq0MXz70e1_CpOtma3uNQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Fira Code\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/firacode/v21/uU9eCBsR6Z2vfE9aq3bL0fxyUs4tcw4W_GNsFVfxN87gsj0.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/firacode/v21/uU9eCBsR6Z2vfE9aq3bL0fxyUs4tcw4W_D1sFVfxN87gsj0.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/firacode/v21/uU9eCBsR6Z2vfE9aq3bL0fxyUs4tcw4W_A9sFVfxN87gsj0.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/firacode/v21/uU9eCBsR6Z2vfE9aq3bL0fxyUs4tcw4W_ONrFVfxN87gsj0.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/firacode/v21/uU9eCBsR6Z2vfE9aq3bL0fxyUs4tcw4W_NprFVfxN87gsj0.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"monospace\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Fira Mono\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/firamono/v14/N0bX2SlFPv1weGeLZDtQIfTTkdbJYA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/firamono/v14/N0bS2SlFPv1weGeLZDto1d33mf3VaZBRBQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/firamono/v14/N0bS2SlFPv1weGeLZDtondv3mf3VaZBRBQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"monospace\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Fira Sans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/firasans/v16/va9C4kDNxMZdWfMOD5Vn9IjOazP3dUTP.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/firasans/v16/va9A4kDNxMZdWfMOD5VvkrCqYTfVcFTPj0s.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/firasans/v16/va9B4kDNxMZdWfMOD5VnWKnuQR37fF3Wlg.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/firasans/v16/va9f4kDNxMZdWfMOD5VvkrAGQBf_XljGllLX.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/firasans/v16/va9B4kDNxMZdWfMOD5VnPKruQR37fF3Wlg.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/firasans/v16/va9f4kDNxMZdWfMOD5VvkrBiQxf_XljGllLX.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/firasans/v16/va9E4kDNxMZdWfMOD5VfkILKSTbndQ.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/firasans/v16/va9C4kDNxMZdWfMOD5VvkojOazP3dUTP.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/firasans/v16/va9B4kDNxMZdWfMOD5VnZKvuQR37fF3Wlg.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/firasans/v16/va9f4kDNxMZdWfMOD5VvkrA6Qhf_XljGllLX.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/firasans/v16/va9B4kDNxMZdWfMOD5VnSKzuQR37fF3Wlg.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/firasans/v16/va9f4kDNxMZdWfMOD5VvkrAWRRf_XljGllLX.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/firasans/v16/va9B4kDNxMZdWfMOD5VnLK3uQR37fF3Wlg.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/firasans/v16/va9f4kDNxMZdWfMOD5VvkrByRBf_XljGllLX.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/firasans/v16/va9B4kDNxMZdWfMOD5VnMK7uQR37fF3Wlg.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/firasans/v16/va9f4kDNxMZdWfMOD5VvkrBuRxf_XljGllLX.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/firasans/v16/va9B4kDNxMZdWfMOD5VnFK_uQR37fF3Wlg.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/firasans/v16/va9f4kDNxMZdWfMOD5VvkrBKRhf_XljGllLX.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Fira Sans Condensed\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/firasanscondensed/v10/wEOjEADFm8hSaQTFG18FErVhsC9x-tarWZXtqOlQfx9CjA.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/firasanscondensed/v10/wEOtEADFm8hSaQTFG18FErVhsC9x-tarUfPVzONUXRpSjJcu.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/firasanscondensed/v10/wEOsEADFm8hSaQTFG18FErVhsC9x-tarWTnMiMN-cxZblY4.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/firasanscondensed/v10/wEOuEADFm8hSaQTFG18FErVhsC9x-tarUfPVYMJ0dzRehY43EA.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/firasanscondensed/v10/wEOsEADFm8hSaQTFG18FErVhsC9x-tarWV3PiMN-cxZblY4.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/firasanscondensed/v10/wEOuEADFm8hSaQTFG18FErVhsC9x-tarUfPVBMF0dzRehY43EA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/firasanscondensed/v10/wEOhEADFm8hSaQTFG18FErVhsC9x-tarYfHnrMtVbx8.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/firasanscondensed/v10/wEOjEADFm8hSaQTFG18FErVhsC9x-tarUfPtqOlQfx9CjA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/firasanscondensed/v10/wEOsEADFm8hSaQTFG18FErVhsC9x-tarWQXOiMN-cxZblY4.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/firasanscondensed/v10/wEOuEADFm8hSaQTFG18FErVhsC9x-tarUfPVXMB0dzRehY43EA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/firasanscondensed/v10/wEOsEADFm8hSaQTFG18FErVhsC9x-tarWSnJiMN-cxZblY4.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/firasanscondensed/v10/wEOuEADFm8hSaQTFG18FErVhsC9x-tarUfPVcMd0dzRehY43EA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/firasanscondensed/v10/wEOsEADFm8hSaQTFG18FErVhsC9x-tarWU3IiMN-cxZblY4.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/firasanscondensed/v10/wEOuEADFm8hSaQTFG18FErVhsC9x-tarUfPVFMZ0dzRehY43EA.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/firasanscondensed/v10/wEOsEADFm8hSaQTFG18FErVhsC9x-tarWVHLiMN-cxZblY4.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/firasanscondensed/v10/wEOuEADFm8hSaQTFG18FErVhsC9x-tarUfPVCMV0dzRehY43EA.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/firasanscondensed/v10/wEOsEADFm8hSaQTFG18FErVhsC9x-tarWXXKiMN-cxZblY4.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/firasanscondensed/v10/wEOuEADFm8hSaQTFG18FErVhsC9x-tarUfPVLMR0dzRehY43EA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Fira Sans Extra Condensed\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/firasansextracondensed/v10/NaPMcYDaAO5dirw6IaFn7lPJFqXmS-M9Atn3wgda3Zyuv1WarE9ncg.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/firasansextracondensed/v10/NaPOcYDaAO5dirw6IaFn7lPJFqXmS-M9Atn3wgda1fqW21-ejkp3cn22.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/firasansextracondensed/v10/NaPPcYDaAO5dirw6IaFn7lPJFqXmS-M9Atn3wgda3TCPn3-0oEZ-a2Q.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/firasansextracondensed/v10/NaPxcYDaAO5dirw6IaFn7lPJFqXmS-M9Atn3wgda1fqWd36-pGR7e2SvJQ.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/firasansextracondensed/v10/NaPPcYDaAO5dirw6IaFn7lPJFqXmS-M9Atn3wgda3VSMn3-0oEZ-a2Q.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/firasansextracondensed/v10/NaPxcYDaAO5dirw6IaFn7lPJFqXmS-M9Atn3wgda1fqWE32-pGR7e2SvJQ.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/firasansextracondensed/v10/NaPKcYDaAO5dirw6IaFn7lPJFqXmS-M9Atn3wgda5fiku3efvE8.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/firasansextracondensed/v10/NaPMcYDaAO5dirw6IaFn7lPJFqXmS-M9Atn3wgda1fquv1WarE9ncg.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/firasansextracondensed/v10/NaPPcYDaAO5dirw6IaFn7lPJFqXmS-M9Atn3wgda3QyNn3-0oEZ-a2Q.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/firasansextracondensed/v10/NaPxcYDaAO5dirw6IaFn7lPJFqXmS-M9Atn3wgda1fqWS3y-pGR7e2SvJQ.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/firasansextracondensed/v10/NaPPcYDaAO5dirw6IaFn7lPJFqXmS-M9Atn3wgda3SCKn3-0oEZ-a2Q.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/firasansextracondensed/v10/NaPxcYDaAO5dirw6IaFn7lPJFqXmS-M9Atn3wgda1fqWZ3u-pGR7e2SvJQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/firasansextracondensed/v10/NaPPcYDaAO5dirw6IaFn7lPJFqXmS-M9Atn3wgda3USLn3-0oEZ-a2Q.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/firasansextracondensed/v10/NaPxcYDaAO5dirw6IaFn7lPJFqXmS-M9Atn3wgda1fqWA3q-pGR7e2SvJQ.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/firasansextracondensed/v10/NaPPcYDaAO5dirw6IaFn7lPJFqXmS-M9Atn3wgda3ViIn3-0oEZ-a2Q.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/firasansextracondensed/v10/NaPxcYDaAO5dirw6IaFn7lPJFqXmS-M9Atn3wgda1fqWH3m-pGR7e2SvJQ.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/firasansextracondensed/v10/NaPPcYDaAO5dirw6IaFn7lPJFqXmS-M9Atn3wgda3XyJn3-0oEZ-a2Q.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/firasansextracondensed/v10/NaPxcYDaAO5dirw6IaFn7lPJFqXmS-M9Atn3wgda1fqWO3i-pGR7e2SvJQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Fjalla One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/fjallaone/v13/Yq6R-LCAWCX3-6Ky7FAFnOZwkxgtUb8.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Fjord One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/fjordone/v21/zOL-4pbEnKBY_9S1jNKr6e5As-FeiQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Flamenco\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/flamenco/v18/neIPzCehqYguo67ssZ0qNIkyepH9qGsf.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/flamenco/v18/neIIzCehqYguo67ssaWGHK06UY30.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Flavors\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/flavors/v22/FBV2dDrhxqmveJTpbkzlNqkG9UY.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Fleur De Leah\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v7\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/fleurdeleah/v7/AYCNpXX7ftYZWLhv9UmPJTMC5vat4I_Gdq0.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Flow Block\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v7\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/flowblock/v7/wlp0gwfPCEB65UmTk-d6-WZlbCBXE_I.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Flow Circular\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v7\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/flowcircular/v7/lJwB-pc4j2F-H8YKuyvfxdZ45ifpWdr2rIg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Flow Rounded\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v7\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/flowrounded/v7/-zki91mtwsU9qlLiGwD4oQX3oZX-Xup87g.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Fondamento\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/fondamento/v16/4UaHrEJGsxNmFTPDnkaJx63j5pN1MwI.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/fondamento/v16/4UaFrEJGsxNmFTPDnkaJ96_p4rFwIwJePw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Fontdiner Swanky\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/fontdinerswanky/v19/ijwOs4XgRNsiaI5-hcVb4hQgMvCD4uEfKiGvxts.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Forum\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/forum/v16/6aey4Ky-Vb8Ew_IWMJMa3mnT.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Fragment Mono\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/fragmentmono/v1/4iCr6K5wfMRRjxp0DA6-2CLnN4RNh4UI_1U.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/fragmentmono/v1/4iC16K5wfMRRjxp0DA6-2CLnB4ZHg6cN71URtQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"monospace\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Francois One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/francoisone/v20/_Xmr-H4zszafZw3A-KPSZutNxgKQu_avAg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Frank Ruhl Libre\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/frankruhllibre/v15/j8_96_fAw7jrcalD7oKYNX0QfAnPcbzNEEB7OoicBw6bYVqQPxR2EUR_.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/frankruhllibre/v15/j8_96_fAw7jrcalD7oKYNX0QfAnPcbzNEEB7OoicBw7FYVqQPxR2EUR_.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/frankruhllibre/v15/j8_96_fAw7jrcalD7oKYNX0QfAnPcbzNEEB7OoicBw73YVqQPxR2EUR_.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/frankruhllibre/v15/j8_96_fAw7jrcalD7oKYNX0QfAnPcbzNEEB7OoicBw4bZlqQPxR2EUR_.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/frankruhllibre/v15/j8_96_fAw7jrcalD7oKYNX0QfAnPcbzNEEB7OoicBw4iZlqQPxR2EUR_.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/frankruhllibre/v15/j8_96_fAw7jrcalD7oKYNX0QfAnPcbzNEEB7OoicBw5FZlqQPxR2EUR_.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/frankruhllibre/v15/j8_96_fAw7jrcalD7oKYNX0QfAnPcbzNEEB7OoicBw5sZlqQPxR2EUR_.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Fraunces\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v26\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/fraunces/v26/6NUh8FyLNQOQZAnv9bYEvDiIdE9Ea92uemAk_WBq8U_9v0c2Wa0K7iN7hzFUPJH58nib1603gg7S2nfgRYIctxqjDvTShUtWNg.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/fraunces/v26/6NUh8FyLNQOQZAnv9bYEvDiIdE9Ea92uemAk_WBq8U_9v0c2Wa0K7iN7hzFUPJH58nib1603gg7S2nfgRYIcNxujDvTShUtWNg.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/fraunces/v26/6NUh8FyLNQOQZAnv9bYEvDiIdE9Ea92uemAk_WBq8U_9v0c2Wa0K7iN7hzFUPJH58nib1603gg7S2nfgRYIc6RujDvTShUtWNg.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/fraunces/v26/6NUh8FyLNQOQZAnv9bYEvDiIdE9Ea92uemAk_WBq8U_9v0c2Wa0K7iN7hzFUPJH58nib1603gg7S2nfgRYIctxujDvTShUtWNg.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/fraunces/v26/6NUh8FyLNQOQZAnv9bYEvDiIdE9Ea92uemAk_WBq8U_9v0c2Wa0K7iN7hzFUPJH58nib1603gg7S2nfgRYIchRujDvTShUtWNg.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/fraunces/v26/6NUh8FyLNQOQZAnv9bYEvDiIdE9Ea92uemAk_WBq8U_9v0c2Wa0K7iN7hzFUPJH58nib1603gg7S2nfgRYIcaRyjDvTShUtWNg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/fraunces/v26/6NUh8FyLNQOQZAnv9bYEvDiIdE9Ea92uemAk_WBq8U_9v0c2Wa0K7iN7hzFUPJH58nib1603gg7S2nfgRYIcUByjDvTShUtWNg.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/fraunces/v26/6NUh8FyLNQOQZAnv9bYEvDiIdE9Ea92uemAk_WBq8U_9v0c2Wa0K7iN7hzFUPJH58nib1603gg7S2nfgRYIcNxyjDvTShUtWNg.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/fraunces/v26/6NUh8FyLNQOQZAnv9bYEvDiIdE9Ea92uemAk_WBq8U_9v0c2Wa0K7iN7hzFUPJH58nib1603gg7S2nfgRYIcHhyjDvTShUtWNg.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/fraunces/v26/6NVf8FyLNQOQZAnv9ZwNjucMHVn85Ni7emAe9lKqZTnbB-gzTK0K1ChJdt9vIVYX9G37lvd9sPEKsxx664UJf1hLTP7Wp05GNi3k.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/fraunces/v26/6NVf8FyLNQOQZAnv9ZwNjucMHVn85Ni7emAe9lKqZTnbB-gzTK0K1ChJdt9vIVYX9G37lvd9sPEKsxx664UJf1jLTf7Wp05GNi3k.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/fraunces/v26/6NVf8FyLNQOQZAnv9ZwNjucMHVn85Ni7emAe9lKqZTnbB-gzTK0K1ChJdt9vIVYX9G37lvd9sPEKsxx664UJf1gVTf7Wp05GNi3k.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/fraunces/v26/6NVf8FyLNQOQZAnv9ZwNjucMHVn85Ni7emAe9lKqZTnbB-gzTK0K1ChJdt9vIVYX9G37lvd9sPEKsxx664UJf1hLTf7Wp05GNi3k.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/fraunces/v26/6NVf8FyLNQOQZAnv9ZwNjucMHVn85Ni7emAe9lKqZTnbB-gzTK0K1ChJdt9vIVYX9G37lvd9sPEKsxx664UJf1h5Tf7Wp05GNi3k.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/fraunces/v26/6NVf8FyLNQOQZAnv9ZwNjucMHVn85Ni7emAe9lKqZTnbB-gzTK0K1ChJdt9vIVYX9G37lvd9sPEKsxx664UJf1iVSv7Wp05GNi3k.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/fraunces/v26/6NVf8FyLNQOQZAnv9ZwNjucMHVn85Ni7emAe9lKqZTnbB-gzTK0K1ChJdt9vIVYX9G37lvd9sPEKsxx664UJf1isSv7Wp05GNi3k.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/fraunces/v26/6NVf8FyLNQOQZAnv9ZwNjucMHVn85Ni7emAe9lKqZTnbB-gzTK0K1ChJdt9vIVYX9G37lvd9sPEKsxx664UJf1jLSv7Wp05GNi3k.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/fraunces/v26/6NVf8FyLNQOQZAnv9ZwNjucMHVn85Ni7emAe9lKqZTnbB-gzTK0K1ChJdt9vIVYX9G37lvd9sPEKsxx664UJf1jiSv7Wp05GNi3k.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Freckle Face\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/freckleface/v14/AMOWz4SXrmKHCvXTohxY-YI0U1K2w9lb4g.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Fredericka the Great\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/frederickathegreat/v15/9Bt33CxNwt7aOctW2xjbCstzwVKsIBVV-9Skz7Ylch2L.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Fredoka\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v9\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/fredoka/v9/X7nP4b87HvSqjb_WIi2yDCRwoQ_k7367_B-i2yQag0-mac3OryLMFuOLlNldbw.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/fredoka/v9/X7nP4b87HvSqjb_WIi2yDCRwoQ_k7367_B-i2yQag0-mac3O8SLMFuOLlNldbw.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/fredoka/v9/X7nP4b87HvSqjb_WIi2yDCRwoQ_k7367_B-i2yQag0-mac3OwyLMFuOLlNldbw.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/fredoka/v9/X7nP4b87HvSqjb_WIi2yDCRwoQ_k7367_B-i2yQag0-mac3OLyXMFuOLlNldbw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/fredoka/v9/X7nP4b87HvSqjb_WIi2yDCRwoQ_k7367_B-i2yQag0-mac3OFiXMFuOLlNldbw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Fredoka One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/fredokaone/v13/k3kUo8kEI-tA1RRcTZGmTmHBA6aF8Bf_.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Freehand\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"khmer\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v27\",\n\t\t\t\"lastModified\": \"2022-04-21\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/freehand/v27/cIf-Ma5eqk01VjKTgAmBTmUOmZJk.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Fresca\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/fresca/v18/6ae94K--SKgCzbM2Gr0W13DKPA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Frijole\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/frijole/v14/uU9PCBUR8oakM2BQ7xPb3vyHmlI.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Fruktur\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v26\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/fruktur/v26/SZc53FHsOru5QYsMfz3GkUrS8DI.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/fruktur/v26/SZc73FHsOru5QYsMTz_MlWjX4DJXgQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Fugaz One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/fugazone/v15/rax_HiWKp9EAITukFslMBBJek0vA8A.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Fuggles\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v8\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/fuggles/v8/k3kQo8UEJOlD1hpOTd7iL0nAMaM.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Fuzzy Bubbles\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v5\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/fuzzybubbles/v5/6qLGKZMbrgv9pwtjPEVNV0F2NnP5Zxsreko.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/fuzzybubbles/v5/6qLbKZMbrgv9pwtjPEVNV0F2Ds_WQxMAZkM1pn4.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"GFS Didot\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"greek\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/gfsdidot/v15/Jqzh5TybZ9vZMWFssvwiF-fGFSCGAA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"GFS Neohellenic\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"greek\"\n\t\t\t],\n\t\t\t\"version\": \"v25\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/gfsneohellenic/v25/8QIRdiDOrfiq0b7R8O1Iw9WLcY5TLahP46UDUw.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/gfsneohellenic/v25/8QITdiDOrfiq0b7R8O1Iw9WLcY5jL6JLwaATU91X.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/gfsneohellenic/v25/8QIUdiDOrfiq0b7R8O1Iw9WLcY5rkYdr644fWsRO9w.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/gfsneohellenic/v25/8QIWdiDOrfiq0b7R8O1Iw9WLcY5jL5r37oQbeMFe985V.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Gabriela\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/gabriela/v14/qkBWXvsO6sreR8E-b_m-zrpHmRzC.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Gaegu\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"korean\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/gaegu/v15/TuGSUVB6Up9NU57nifw74sdtBk0x.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/gaegu/v15/TuGfUVB6Up9NU6ZLodgzydtk.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/gaegu/v15/TuGSUVB6Up9NU573jvw74sdtBk0x.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Gafata\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/gafata/v16/XRXV3I6Cn0VJKon4MuyAbsrVcA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Galada\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"bengali\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/galada/v14/H4cmBXyGmcjXlUX-8iw-4Lqggw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Galdeano\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/galdeano/v22/uU9MCBoQ4YOqOW1boDPx8PCOg0uX.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Galindo\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/galindo/v20/HI_KiYMeLqVKqwyuQ5HiRp-dhpQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Gamja Flower\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"korean\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/gamjaflower/v20/6NUR8FiKJg-Pa0rM6uN40Z4kyf9Fdty2ew.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Gantari\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/gantari/v1/jVyV7nvyB2HL8iZyDk4GVvSZ5MtC9g0gOz3wa5GD2qnm.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/gantari/v1/jVyV7nvyB2HL8iZyDk4GVvSZ5MtC9g2gOj3wa5GD2qnm.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/gantari/v1/jVyV7nvyB2HL8iZyDk4GVvSZ5MtC9g1-Oj3wa5GD2qnm.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/gantari/v1/jVyV7nvyB2HL8iZyDk4GVvSZ5MtC9g0gOj3wa5GD2qnm.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/gantari/v1/jVyV7nvyB2HL8iZyDk4GVvSZ5MtC9g0SOj3wa5GD2qnm.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/gantari/v1/jVyV7nvyB2HL8iZyDk4GVvSZ5MtC9g3-PT3wa5GD2qnm.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/gantari/v1/jVyV7nvyB2HL8iZyDk4GVvSZ5MtC9g3HPT3wa5GD2qnm.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/gantari/v1/jVyV7nvyB2HL8iZyDk4GVvSZ5MtC9g2gPT3wa5GD2qnm.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/gantari/v1/jVyV7nvyB2HL8iZyDk4GVvSZ5MtC9g2JPT3wa5GD2qnm.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/gantari/v1/jVyb7nvyB2HL8iZyJEc0qSzwj1Hs8RjoedWyYZWh37nmpWc.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/gantari/v1/jVyb7nvyB2HL8iZyJEc0qSzwj1Hs8RjoeVWzYZWh37nmpWc.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/gantari/v1/jVyb7nvyB2HL8iZyJEc0qSzwj1Hs8RjoeYuzYZWh37nmpWc.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/gantari/v1/jVyb7nvyB2HL8iZyJEc0qSzwj1Hs8RjoedWzYZWh37nmpWc.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/gantari/v1/jVyb7nvyB2HL8iZyJEc0qSzwj1Hs8RjoeeezYZWh37nmpWc.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/gantari/v1/jVyb7nvyB2HL8iZyJEc0qSzwj1Hs8RjoeQu0YZWh37nmpWc.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/gantari/v1/jVyb7nvyB2HL8iZyJEc0qSzwj1Hs8RjoeTK0YZWh37nmpWc.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/gantari/v1/jVyb7nvyB2HL8iZyJEc0qSzwj1Hs8RjoeVW0YZWh37nmpWc.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/gantari/v1/jVyb7nvyB2HL8iZyJEc0qSzwj1Hs8RjoeXy0YZWh37nmpWc.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Gayathri\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"malayalam\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/gayathri/v15/MCoWzAb429DbBilWLLhc-pvSA_gA2W8.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/gayathri/v15/MCoQzAb429DbBilWLIA48J_wBugA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/gayathri/v15/MCoXzAb429DbBilWLLiE37v4LfQJwHbn.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Gelasio\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/gelasio/v10/cIf9MaFfvUQxTTqSxCmrYGkHgIs.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/gelasio/v10/cIf_MaFfvUQxTTqS9CuhZEsCkIt9QQ.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/gelasio/v10/cIf4MaFfvUQxTTqS_N2CRGEsnIJkWL4.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/gelasio/v10/cIf6MaFfvUQxTTqS9CuZkGImmKBhSL7Y1Q.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/gelasio/v10/cIf4MaFfvUQxTTqS_PGFRGEsnIJkWL4.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/gelasio/v10/cIf6MaFfvUQxTTqS9CuZvGUmmKBhSL7Y1Q.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/gelasio/v10/cIf4MaFfvUQxTTqS_JWERGEsnIJkWL4.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/gelasio/v10/cIf6MaFfvUQxTTqS9CuZ2GQmmKBhSL7Y1Q.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Gemunu Libre\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"sinhala\"\n\t\t\t],\n\t\t\t\"version\": \"v8\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/gemunulibre/v8/X7n34bQ6Cfy7jKGXVE_YlqnbEQAFP-PIuTCp05iJPvSLeMXPIWA.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/gemunulibre/v8/X7n34bQ6Cfy7jKGXVE_YlqnbEQAFP-PIuTCp00aJPvSLeMXPIWA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/gemunulibre/v8/X7n34bQ6Cfy7jKGXVE_YlqnbEQAFP-PIuTCp0xiJPvSLeMXPIWA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/gemunulibre/v8/X7n34bQ6Cfy7jKGXVE_YlqnbEQAFP-PIuTCp0yqJPvSLeMXPIWA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/gemunulibre/v8/X7n34bQ6Cfy7jKGXVE_YlqnbEQAFP-PIuTCp08aOPvSLeMXPIWA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/gemunulibre/v8/X7n34bQ6Cfy7jKGXVE_YlqnbEQAFP-PIuTCp0_-OPvSLeMXPIWA.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/gemunulibre/v8/X7n34bQ6Cfy7jKGXVE_YlqnbEQAFP-PIuTCp05iOPvSLeMXPIWA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Genos\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cherokee\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v6\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/genos/v6/SlGNmQqPqpUOYTYjacb0Hc91fTwVqknorUK6K7ZsAg.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/genos/v6/SlGNmQqPqpUOYTYjacb0Hc91fTwVKkjorUK6K7ZsAg.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/genos/v6/SlGNmQqPqpUOYTYjacb0Hc91fTwV9EjorUK6K7ZsAg.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/genos/v6/SlGNmQqPqpUOYTYjacb0Hc91fTwVqkjorUK6K7ZsAg.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/genos/v6/SlGNmQqPqpUOYTYjacb0Hc91fTwVmEjorUK6K7ZsAg.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/genos/v6/SlGNmQqPqpUOYTYjacb0Hc91fTwVdE_orUK6K7ZsAg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/genos/v6/SlGNmQqPqpUOYTYjacb0Hc91fTwVTU_orUK6K7ZsAg.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/genos/v6/SlGNmQqPqpUOYTYjacb0Hc91fTwVKk_orUK6K7ZsAg.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/genos/v6/SlGNmQqPqpUOYTYjacb0Hc91fTwVA0_orUK6K7ZsAg.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/genos/v6/SlGPmQqPqpUOYRwqWzksdKTv0zsAYgsA70i-CbN8Ard7.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/genos/v6/SlGPmQqPqpUOYRwqWzksdKTv0zsAYguA7ki-CbN8Ard7.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/genos/v6/SlGPmQqPqpUOYRwqWzksdKTv0zsAYgte7ki-CbN8Ard7.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/genos/v6/SlGPmQqPqpUOYRwqWzksdKTv0zsAYgsA7ki-CbN8Ard7.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/genos/v6/SlGPmQqPqpUOYRwqWzksdKTv0zsAYgsy7ki-CbN8Ard7.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/genos/v6/SlGPmQqPqpUOYRwqWzksdKTv0zsAYgve6Ui-CbN8Ard7.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/genos/v6/SlGPmQqPqpUOYRwqWzksdKTv0zsAYgvn6Ui-CbN8Ard7.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/genos/v6/SlGPmQqPqpUOYRwqWzksdKTv0zsAYguA6Ui-CbN8Ard7.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/genos/v6/SlGPmQqPqpUOYRwqWzksdKTv0zsAYgup6Ui-CbN8Ard7.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Gentium Book Basic\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/gentiumbookbasic/v16/pe0zMJCbPYBVokB1LHA9bbyaQb8ZGjcIV7t7w6bE2A.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/gentiumbookbasic/v16/pe0xMJCbPYBVokB1LHA9bbyaQb8ZGjc4VbF_4aPU2Ec9.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/gentiumbookbasic/v16/pe0wMJCbPYBVokB1LHA9bbyaQb8ZGjcw65Rfy43Y0V4kvg.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/gentiumbookbasic/v16/pe0-MJCbPYBVokB1LHA9bbyaQb8ZGjc4VYnDzofc81s0voO3.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Gentium Book Plus\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/gentiumbookplus/v1/vEFL2-RHBgUK5fbjKxRpbBtJPyRpofKfdbLOrdPV.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/gentiumbookplus/v1/vEFN2-RHBgUK5fbjKxRpbBtJPyRpocKdf7bsqMPVZb4.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/gentiumbookplus/v1/vEFO2-RHBgUK5fbjKxRpbBtJPyRpocojWpbGhs_cfKe1.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/gentiumbookplus/v1/vEFA2-RHBgUK5fbjKxRpbBtJPyRpocKdRwrDjMv-ebe1Els.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Gentium Plus\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/gentiumplus/v1/Iurd6Ytw-oSPaZ00r2bNe8VpjJtM6G0t9w.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/gentiumplus/v1/IurD6Ytw-oSPaZ00r2bNe8VZjpFIymg9957e.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/gentiumplus/v1/IurC6Ytw-oSPaZ00r2bNe8VRMLRo4EYx_ofHsw.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/gentiumplus/v1/IurA6Ytw-oSPaZ00r2bNe8VZjqn05Uw13ILXs-h6.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Geo\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/geo/v19/CSRz4zRZlufVL3BmQjlCbQ.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/geo/v19/CSRx4zRZluflLXpiYDxSbf8r.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Georama\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v8\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/georama/v8/MCo5zAn438bIEyxFf6swMnNpvPcUwW4u4yRcDh-ZjxApn9K5GvktmQsL5_tgbg.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/georama/v8/MCo5zAn438bIEyxFf6swMnNpvPcUwW4u4yRcDh-ZjxApn9K5mvgtmQsL5_tgbg.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/georama/v8/MCo5zAn438bIEyxFf6swMnNpvPcUwW4u4yRcDh-ZjxApn9K5RPgtmQsL5_tgbg.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/georama/v8/MCo5zAn438bIEyxFf6swMnNpvPcUwW4u4yRcDh-ZjxApn9K5GvgtmQsL5_tgbg.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/georama/v8/MCo5zAn438bIEyxFf6swMnNpvPcUwW4u4yRcDh-ZjxApn9K5KPgtmQsL5_tgbg.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/georama/v8/MCo5zAn438bIEyxFf6swMnNpvPcUwW4u4yRcDh-ZjxApn9K5xP8tmQsL5_tgbg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/georama/v8/MCo5zAn438bIEyxFf6swMnNpvPcUwW4u4yRcDh-ZjxApn9K5_f8tmQsL5_tgbg.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/georama/v8/MCo5zAn438bIEyxFf6swMnNpvPcUwW4u4yRcDh-ZjxApn9K5mv8tmQsL5_tgbg.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/georama/v8/MCo5zAn438bIEyxFf6swMnNpvPcUwW4u4yRcDh-ZjxApn9K5s_8tmQsL5_tgbg.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/georama/v8/MCo_zAn438bIEyxFVaIC0ZMQ72G6xnvmodYVPOBB5nuzMdWs0rvF2wEPxf5wbh3T.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/georama/v8/MCo_zAn438bIEyxFVaIC0ZMQ72G6xnvmodYVPOBB5nuzMdWs0rtF2gEPxf5wbh3T.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/georama/v8/MCo_zAn438bIEyxFVaIC0ZMQ72G6xnvmodYVPOBB5nuzMdWs0rub2gEPxf5wbh3T.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/georama/v8/MCo_zAn438bIEyxFVaIC0ZMQ72G6xnvmodYVPOBB5nuzMdWs0rvF2gEPxf5wbh3T.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/georama/v8/MCo_zAn438bIEyxFVaIC0ZMQ72G6xnvmodYVPOBB5nuzMdWs0rv32gEPxf5wbh3T.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/georama/v8/MCo_zAn438bIEyxFVaIC0ZMQ72G6xnvmodYVPOBB5nuzMdWs0rsb3QEPxf5wbh3T.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/georama/v8/MCo_zAn438bIEyxFVaIC0ZMQ72G6xnvmodYVPOBB5nuzMdWs0rsi3QEPxf5wbh3T.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/georama/v8/MCo_zAn438bIEyxFVaIC0ZMQ72G6xnvmodYVPOBB5nuzMdWs0rtF3QEPxf5wbh3T.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/georama/v8/MCo_zAn438bIEyxFVaIC0ZMQ72G6xnvmodYVPOBB5nuzMdWs0rts3QEPxf5wbh3T.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Geostar\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/geostar/v22/sykz-yx4n701VLOftSq9-trEvlQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Geostar Fill\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/geostarfill/v22/AMOWz4SWuWiXFfjEohxQ9os0U1K2w9lb4g.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Germania One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/germaniaone/v20/Fh4yPjrqIyv2ucM2qzBjeS3ezAJONau6ew.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Gideon Roman\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v7\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/gideonroman/v7/e3tmeuGrVOys8sxzZgWlmXoge0PWovdU4w.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Gidugu\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"telugu\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/gidugu/v21/L0x8DFMkk1Uf6w3RvPCmRSlUig.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Gilda Display\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/gildadisplay/v13/t5tmIRoYMoaYG0WEOh7HwMeR7TnFrpOHYh4.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Girassol\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/girassol/v16/JTUUjIo_-DK48laaNC9Nz2pJzxbi.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Give You Glory\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/giveyouglory/v15/8QIQdiHOgt3vv4LR7ahjw9-XYc1zB4ZD6rwa.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Glass Antiqua\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/glassantiqua/v20/xfu30Wr0Wn3NOQM2piC0uXOjnL_wN6fRUkY.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Glegoo\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/glegoo/v14/_Xmt-HQyrTKWaw2Ji6mZAI91xw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/glegoo/v14/_Xmu-HQyrTKWaw2xN4a9CKRpzimMsg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Gloria Hallelujah\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/gloriahallelujah/v17/LYjYdHv3kUk9BMV96EIswT9DIbW-MLSy3TKEvkCF.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Glory\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v9\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/glory/v9/q5uasoi9Lf1w5t3Est24nq9blIRQwIiDpn-dDi9EOQ.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/glory/v9/q5uasoi9Lf1w5t3Est24nq9blIRQQImDpn-dDi9EOQ.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/glory/v9/q5uasoi9Lf1w5t3Est24nq9blIRQnomDpn-dDi9EOQ.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/glory/v9/q5uasoi9Lf1w5t3Est24nq9blIRQwImDpn-dDi9EOQ.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/glory/v9/q5uasoi9Lf1w5t3Est24nq9blIRQ8omDpn-dDi9EOQ.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/glory/v9/q5uasoi9Lf1w5t3Est24nq9blIRQHo6Dpn-dDi9EOQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/glory/v9/q5uasoi9Lf1w5t3Est24nq9blIRQJ46Dpn-dDi9EOQ.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/glory/v9/q5uasoi9Lf1w5t3Est24nq9blIRQQI6Dpn-dDi9EOQ.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/glory/v9/q5uYsoi9Lf1w5vfNgCJg98TBOoNFCMpr5HWZLCpUOaM6.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/glory/v9/q5uYsoi9Lf1w5vfNgCJg98TBOoNFCMrr5XWZLCpUOaM6.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/glory/v9/q5uYsoi9Lf1w5vfNgCJg98TBOoNFCMo15XWZLCpUOaM6.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/glory/v9/q5uYsoi9Lf1w5vfNgCJg98TBOoNFCMpr5XWZLCpUOaM6.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/glory/v9/q5uYsoi9Lf1w5vfNgCJg98TBOoNFCMpZ5XWZLCpUOaM6.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/glory/v9/q5uYsoi9Lf1w5vfNgCJg98TBOoNFCMq14nWZLCpUOaM6.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/glory/v9/q5uYsoi9Lf1w5vfNgCJg98TBOoNFCMqM4nWZLCpUOaM6.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/glory/v9/q5uYsoi9Lf1w5vfNgCJg98TBOoNFCMrr4nWZLCpUOaM6.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Gluten\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v9\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/gluten/v9/Hhy_U5gk9fW7OUdVIPh2zD_RSqQJ__A15jgJsn-Bhb_yI8Vb7B1Luni7ciJh.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/gluten/v9/Hhy_U5gk9fW7OUdVIPh2zD_RSqQJ__A15jgJsn-Bhb_yI8Xb7R1Luni7ciJh.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/gluten/v9/Hhy_U5gk9fW7OUdVIPh2zD_RSqQJ__A15jgJsn-Bhb_yI8UF7R1Luni7ciJh.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/gluten/v9/Hhy_U5gk9fW7OUdVIPh2zD_RSqQJ__A15jgJsn-Bhb_yI8Vb7R1Luni7ciJh.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/gluten/v9/Hhy_U5gk9fW7OUdVIPh2zD_RSqQJ__A15jgJsn-Bhb_yI8Vp7R1Luni7ciJh.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/gluten/v9/Hhy_U5gk9fW7OUdVIPh2zD_RSqQJ__A15jgJsn-Bhb_yI8WF6h1Luni7ciJh.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/gluten/v9/Hhy_U5gk9fW7OUdVIPh2zD_RSqQJ__A15jgJsn-Bhb_yI8W86h1Luni7ciJh.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/gluten/v9/Hhy_U5gk9fW7OUdVIPh2zD_RSqQJ__A15jgJsn-Bhb_yI8Xb6h1Luni7ciJh.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/gluten/v9/Hhy_U5gk9fW7OUdVIPh2zD_RSqQJ__A15jgJsn-Bhb_yI8Xy6h1Luni7ciJh.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Goblin One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/goblinone/v22/CSR64z1ZnOqZRjRCBVY_TOcATNt_pOU.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Gochi Hand\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/gochihand/v19/hES06XlsOjtJsgCkx1PkTo71-n0nXWA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Goldman\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/goldman/v15/pe0uMIWbN4JFplR2LDJ4Bt-7G98.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/goldman/v15/pe0rMIWbN4JFplR2FI5XIteQB9Zra1U.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Gorditas\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/gorditas/v20/ll8_K2aTVD26DsPEtQDoDa4AlxYb.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/gorditas/v20/ll84K2aTVD26DsPEtThUIooIvAoShA1i.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Gothic A1\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"korean\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/gothica1/v13/CSR74z5ZnPydRjlCCwlCCMcqYtd2vfwk.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/gothica1/v13/CSR44z5ZnPydRjlCCwlCpOYKSPl6tOU9Eg.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/gothica1/v13/CSR44z5ZnPydRjlCCwlCwOUKSPl6tOU9Eg.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/gothica1/v13/CSR94z5ZnPydRjlCCwl6bM0uQNJmvQ.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/gothica1/v13/CSR44z5ZnPydRjlCCwlCmOQKSPl6tOU9Eg.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/gothica1/v13/CSR44z5ZnPydRjlCCwlCtOMKSPl6tOU9Eg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/gothica1/v13/CSR44z5ZnPydRjlCCwlC0OIKSPl6tOU9Eg.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/gothica1/v13/CSR44z5ZnPydRjlCCwlCzOEKSPl6tOU9Eg.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/gothica1/v13/CSR44z5ZnPydRjlCCwlC6OAKSPl6tOU9Eg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Gotu\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/gotu/v14/o-0FIpksx3QOlH0Lioh6-hU.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Goudy Bookletter 1911\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/goudybookletter1911/v15/sykt-z54laciWfKv-kX8krex0jDiD2HbY6I5tRbXZ4IXAA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Gowun Batang\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"korean\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v7\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/gowunbatang/v7/ijwSs5nhRMIjYsdSgcMa3wRhXLH-yuAtLw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/gowunbatang/v7/ijwNs5nhRMIjYsdSgcMa3wRZ4J7awssxJii23w.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Gowun Dodum\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"korean\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v7\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/gowundodum/v7/3Jn5SD_00GqwlBnWc1TUJF0FfORL0fNy.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Graduate\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/graduate/v13/C8cg4cs3o2n15t_2YxgR6X2NZAn2.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Grand Hotel\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/grandhotel/v13/7Au7p_IgjDKdCRWuR1azpmQNEl0O0kEx.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Grandstander\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/grandstander/v11/ga6fawtA-GpSsTWrnNHPCSIMZhhKpFjyNZIQD1-_D3jWttFGmQk.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/grandstander/v11/ga6fawtA-GpSsTWrnNHPCSIMZhhKpFjyNZIQD9--D3jWttFGmQk.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/grandstander/v11/ga6fawtA-GpSsTWrnNHPCSIMZhhKpFjyNZIQDwG-D3jWttFGmQk.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/grandstander/v11/ga6fawtA-GpSsTWrnNHPCSIMZhhKpFjyNZIQD1--D3jWttFGmQk.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/grandstander/v11/ga6fawtA-GpSsTWrnNHPCSIMZhhKpFjyNZIQD22-D3jWttFGmQk.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/grandstander/v11/ga6fawtA-GpSsTWrnNHPCSIMZhhKpFjyNZIQD4G5D3jWttFGmQk.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/grandstander/v11/ga6fawtA-GpSsTWrnNHPCSIMZhhKpFjyNZIQD7i5D3jWttFGmQk.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/grandstander/v11/ga6fawtA-GpSsTWrnNHPCSIMZhhKpFjyNZIQD9-5D3jWttFGmQk.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/grandstander/v11/ga6fawtA-GpSsTWrnNHPCSIMZhhKpFjyNZIQD_a5D3jWttFGmQk.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/grandstander/v11/ga6ZawtA-GpSsTWrnNHPCSImbyq1fDGZrzwXGpf95zrcsvNDiQlBYQ.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/grandstander/v11/ga6ZawtA-GpSsTWrnNHPCSImbyq1fDGZrzwXGpf9ZzvcsvNDiQlBYQ.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/grandstander/v11/ga6ZawtA-GpSsTWrnNHPCSImbyq1fDGZrzwXGpf9uTvcsvNDiQlBYQ.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/grandstander/v11/ga6ZawtA-GpSsTWrnNHPCSImbyq1fDGZrzwXGpf95zvcsvNDiQlBYQ.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/grandstander/v11/ga6ZawtA-GpSsTWrnNHPCSImbyq1fDGZrzwXGpf91TvcsvNDiQlBYQ.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/grandstander/v11/ga6ZawtA-GpSsTWrnNHPCSImbyq1fDGZrzwXGpf9OTzcsvNDiQlBYQ.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/grandstander/v11/ga6ZawtA-GpSsTWrnNHPCSImbyq1fDGZrzwXGpf9ADzcsvNDiQlBYQ.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/grandstander/v11/ga6ZawtA-GpSsTWrnNHPCSImbyq1fDGZrzwXGpf9ZzzcsvNDiQlBYQ.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/grandstander/v11/ga6ZawtA-GpSsTWrnNHPCSImbyq1fDGZrzwXGpf9TjzcsvNDiQlBYQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Grape Nuts\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v2\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/grapenuts/v2/syk2-yF4iLM2RfKj4F7k3tLvol2RN1E.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Gravitas One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/gravitasone/v15/5h1diZ4hJ3cblKy3LWakKQmaDWRNr3DzbQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Great Vibes\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/greatvibes/v14/RWmMoKWR9v4ksMfaWd_JN-XCg6UKDXlq.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Grechen Fuemen\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v7\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/grechenfuemen/v7/vEFI2_tHEQ4d5ObgKxBzZh0MAWgc-NaXXq7H.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Grenze\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/grenze/v14/O4ZRFGb7hR12BxqPm2IjuAkalnmd.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/grenze/v14/O4ZXFGb7hR12BxqH_VpHsg04k2md0kI.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/grenze/v14/O4ZQFGb7hR12BxqPN0MDkicWn2CEyw.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/grenze/v14/O4ZWFGb7hR12BxqH_Vrrky0SvWWUy1uW.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/grenze/v14/O4ZQFGb7hR12BxqPU0ADkicWn2CEyw.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/grenze/v14/O4ZWFGb7hR12BxqH_VqPkC0SvWWUy1uW.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/grenze/v14/O4ZTFGb7hR12Bxq3_2gnmgwKlg.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/grenze/v14/O4ZRFGb7hR12BxqH_WIjuAkalnmd.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/grenze/v14/O4ZQFGb7hR12BxqPC0EDkicWn2CEyw.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/grenze/v14/O4ZWFGb7hR12BxqH_VrXkS0SvWWUy1uW.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/grenze/v14/O4ZQFGb7hR12BxqPJ0YDkicWn2CEyw.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/grenze/v14/O4ZWFGb7hR12BxqH_Vr7li0SvWWUy1uW.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/grenze/v14/O4ZQFGb7hR12BxqPQ0cDkicWn2CEyw.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/grenze/v14/O4ZWFGb7hR12BxqH_Vqfly0SvWWUy1uW.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/grenze/v14/O4ZQFGb7hR12BxqPX0QDkicWn2CEyw.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/grenze/v14/O4ZWFGb7hR12BxqH_VqDlC0SvWWUy1uW.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/grenze/v14/O4ZQFGb7hR12BxqPe0UDkicWn2CEyw.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/grenze/v14/O4ZWFGb7hR12BxqH_VqnlS0SvWWUy1uW.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Grenze Gotisch\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/grenzegotisch/v12/Fh4hPjjqNDz1osh_jX9YfjudpBJBNV5y5wf_k1i5Lz5UcICdYPSd_w.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/grenzegotisch/v12/Fh4hPjjqNDz1osh_jX9YfjudpBJBNV5y5wf_k1i5rz9UcICdYPSd_w.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/grenzegotisch/v12/Fh4hPjjqNDz1osh_jX9YfjudpBJBNV5y5wf_k1i5cT9UcICdYPSd_w.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/grenzegotisch/v12/Fh4hPjjqNDz1osh_jX9YfjudpBJBNV5y5wf_k1i5Lz9UcICdYPSd_w.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/grenzegotisch/v12/Fh4hPjjqNDz1osh_jX9YfjudpBJBNV5y5wf_k1i5HT9UcICdYPSd_w.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/grenzegotisch/v12/Fh4hPjjqNDz1osh_jX9YfjudpBJBNV5y5wf_k1i58ThUcICdYPSd_w.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/grenzegotisch/v12/Fh4hPjjqNDz1osh_jX9YfjudpBJBNV5y5wf_k1i5yDhUcICdYPSd_w.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/grenzegotisch/v12/Fh4hPjjqNDz1osh_jX9YfjudpBJBNV5y5wf_k1i5rzhUcICdYPSd_w.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/grenzegotisch/v12/Fh4hPjjqNDz1osh_jX9YfjudpBJBNV5y5wf_k1i5hjhUcICdYPSd_w.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Grey Qo\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v7\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/greyqo/v7/BXRrvF_Nmv_TyXxNDOtQ9Wf0QcE.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Griffy\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/griffy/v21/FwZa7-ox2FQh9kfwSNSEwM2zpA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Gruppo\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/gruppo/v16/WwkfxPmzE06v_ZWFWXDAOIEQUQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Gudea\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/gudea/v15/neIFzCqgsI0mp-CP9IGON7Ez.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/gudea/v15/neILzCqgsI0mp9CN_oWsMqEzSJQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/gudea/v15/neIIzCqgsI0mp9gz26WGHK06UY30.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Gugi\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"korean\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/gugi/v13/A2BVn5dXywshVA6A9DEfgqM.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Gulzar\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v6\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/gulzar/v6/Wnz6HAc9eB3HB2ILYTwZqg_MPQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Gupter\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/gupter/v14/2-cm9JNmxJqPO1QUYZa_Wu_lpA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/gupter/v14/2-cl9JNmxJqPO1Qslb-bUsT5rZhaZg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/gupter/v14/2-cl9JNmxJqPO1Qs3bmbUsT5rZhaZg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Gurajada\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"telugu\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/gurajada/v15/FwZY7-Qx308m-l-0Kd6A4sijpFu_.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Gwendolyn\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v5\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/gwendolyn/v5/qkBXXvoO_M3CSss-d7ee5JRLkAXbMQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/gwendolyn/v5/qkBSXvoO_M3CSss-d7emWLtvmC7HONiSFQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Habibi\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/habibi/v21/CSR-4zFWkuqcTTNCShJeZOYySQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Hachi Maru Pop\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/hachimarupop/v17/HI_TiYoRLqpLrEiMAuO9Ysfz7rW1EM_btd8u.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Hahmlet\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"korean\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v9\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/hahmlet/v9/BngXUXpCQ3nKpIo0TfPyfCdXfaeU4RhKOdjobsO-aVxn.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/hahmlet/v9/BngXUXpCQ3nKpIo0TfPyfCdXfaeU4RjKONjobsO-aVxn.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/hahmlet/v9/BngXUXpCQ3nKpIo0TfPyfCdXfaeU4RgUONjobsO-aVxn.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/hahmlet/v9/BngXUXpCQ3nKpIo0TfPyfCdXfaeU4RhKONjobsO-aVxn.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/hahmlet/v9/BngXUXpCQ3nKpIo0TfPyfCdXfaeU4Rh4ONjobsO-aVxn.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/hahmlet/v9/BngXUXpCQ3nKpIo0TfPyfCdXfaeU4RiUP9jobsO-aVxn.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/hahmlet/v9/BngXUXpCQ3nKpIo0TfPyfCdXfaeU4RitP9jobsO-aVxn.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/hahmlet/v9/BngXUXpCQ3nKpIo0TfPyfCdXfaeU4RjKP9jobsO-aVxn.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/hahmlet/v9/BngXUXpCQ3nKpIo0TfPyfCdXfaeU4RjjP9jobsO-aVxn.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Halant\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/halant/v13/u-490qaujRI2Pbsvc_pCmwZqcwdRXg.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/halant/v13/u-4-0qaujRI2PbsX39Jmky12eg.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/halant/v13/u-490qaujRI2PbsvK_tCmwZqcwdRXg.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/halant/v13/u-490qaujRI2PbsvB_xCmwZqcwdRXg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/halant/v13/u-490qaujRI2PbsvY_1CmwZqcwdRXg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Hammersmith One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/hammersmithone/v17/qWcyB624q4L_C4jGQ9IK0O_dFlnbshsks4MRXw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Hanalei\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v23\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/hanalei/v23/E21n_dD8iufIjBRHXzgmVydREus.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Hanalei Fill\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/hanaleifill/v21/fC1mPYtObGbfyQznIaQzPQiMVwLBplm9aw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Handlee\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/handlee/v14/-F6xfjBsISg9aMakDmr6oilJ3ik.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Hanken Grotesk\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v5\",\n\t\t\t\"lastModified\": \"2023-01-18\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/hankengrotesk/v5/ieVq2YZDLWuGJpnzaiwFXS9tYvBRzyFLlZg_f_Ncs2da4fpNzXhRKA.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/hankengrotesk/v5/ieVq2YZDLWuGJpnzaiwFXS9tYvBRzyFLlZg_f_NcM2Za4fpNzXhRKA.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/hankengrotesk/v5/ieVq2YZDLWuGJpnzaiwFXS9tYvBRzyFLlZg_f_Nc7WZa4fpNzXhRKA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/hankengrotesk/v5/ieVq2YZDLWuGJpnzaiwFXS9tYvBRzyFLlZg_f_Ncs2Za4fpNzXhRKA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/hankengrotesk/v5/ieVq2YZDLWuGJpnzaiwFXS9tYvBRzyFLlZg_f_NcgWZa4fpNzXhRKA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/hankengrotesk/v5/ieVq2YZDLWuGJpnzaiwFXS9tYvBRzyFLlZg_f_NcbWFa4fpNzXhRKA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/hankengrotesk/v5/ieVq2YZDLWuGJpnzaiwFXS9tYvBRzyFLlZg_f_NcVGFa4fpNzXhRKA.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/hankengrotesk/v5/ieVq2YZDLWuGJpnzaiwFXS9tYvBRzyFLlZg_f_NcM2Fa4fpNzXhRKA.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/hankengrotesk/v5/ieVq2YZDLWuGJpnzaiwFXS9tYvBRzyFLlZg_f_NcGmFa4fpNzXhRKA.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/hankengrotesk/v5/ieVo2YZDLWuGJpnzaiwFXS9tYtpY_d6T_POl0fRJeyWyo_BJ731BKMSK.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/hankengrotesk/v5/ieVo2YZDLWuGJpnzaiwFXS9tYtpY_d6T_POl0fRJeyUyovBJ731BKMSK.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/hankengrotesk/v5/ieVo2YZDLWuGJpnzaiwFXS9tYtpY_d6T_POl0fRJeyXsovBJ731BKMSK.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/hankengrotesk/v5/ieVo2YZDLWuGJpnzaiwFXS9tYtpY_d6T_POl0fRJeyWyovBJ731BKMSK.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/hankengrotesk/v5/ieVo2YZDLWuGJpnzaiwFXS9tYtpY_d6T_POl0fRJeyWAovBJ731BKMSK.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/hankengrotesk/v5/ieVo2YZDLWuGJpnzaiwFXS9tYtpY_d6T_POl0fRJeyVspfBJ731BKMSK.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/hankengrotesk/v5/ieVo2YZDLWuGJpnzaiwFXS9tYtpY_d6T_POl0fRJeyVVpfBJ731BKMSK.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/hankengrotesk/v5/ieVo2YZDLWuGJpnzaiwFXS9tYtpY_d6T_POl0fRJeyUypfBJ731BKMSK.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/hankengrotesk/v5/ieVo2YZDLWuGJpnzaiwFXS9tYtpY_d6T_POl0fRJeyUbpfBJ731BKMSK.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Hanuman\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"khmer\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-04-21\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/hanuman/v22/VuJzdNvD15HhpJJBQMLdPKNiaRpFvg.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/hanuman/v22/VuJ0dNvD15HhpJJBQAr_HIlMZRNcp0o.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/hanuman/v22/VuJxdNvD15HhpJJBeKbXOIFneRo.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/hanuman/v22/VuJ0dNvD15HhpJJBQBr4HIlMZRNcp0o.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/hanuman/v22/VuJ0dNvD15HhpJJBQCL6HIlMZRNcp0o.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Happy Monkey\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/happymonkey/v14/K2F2fZZcl-9SXwl5F_C4R_OABwD2bWqVjw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Harmattan\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/harmattan/v17/goksH6L2DkFvVvRp9XpTS0CjkP1Yog.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/harmattan/v17/gokpH6L2DkFvVvRp9Xpr92-HmNZEq6TTFw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Headland One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/headlandone/v15/yYLu0hHR2vKnp89Tk1TCq3Tx0PlTeZ3mJA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Heebo\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/heebo/v21/NGSpv5_NC0k9P_v6ZUCbLRAHxK1EiS2cckOnz02SXQ.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/heebo/v21/NGSpv5_NC0k9P_v6ZUCbLRAHxK1ECSycckOnz02SXQ.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/heebo/v21/NGSpv5_NC0k9P_v6ZUCbLRAHxK1E1yycckOnz02SXQ.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/heebo/v21/NGSpv5_NC0k9P_v6ZUCbLRAHxK1EiSycckOnz02SXQ.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/heebo/v21/NGSpv5_NC0k9P_v6ZUCbLRAHxK1EuyycckOnz02SXQ.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/heebo/v21/NGSpv5_NC0k9P_v6ZUCbLRAHxK1EVyucckOnz02SXQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/heebo/v21/NGSpv5_NC0k9P_v6ZUCbLRAHxK1EbiucckOnz02SXQ.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/heebo/v21/NGSpv5_NC0k9P_v6ZUCbLRAHxK1ECSucckOnz02SXQ.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/heebo/v21/NGSpv5_NC0k9P_v6ZUCbLRAHxK1EICucckOnz02SXQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Henny Penny\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-04-26\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/hennypenny/v17/wXKvE3UZookzsxz_kjGSfMQqt3M7tMDT.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Hepta Slab\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/heptaslab/v17/ea8JadoyU_jkHdalebHvyWVNdYoIsHe5HvkV5jfbY5B0NBkz.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/heptaslab/v17/ea8JadoyU_jkHdalebHvyWVNdYoIsHe5HvmV5zfbY5B0NBkz.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/heptaslab/v17/ea8JadoyU_jkHdalebHvyWVNdYoIsHe5HvlL5zfbY5B0NBkz.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/heptaslab/v17/ea8JadoyU_jkHdalebHvyWVNdYoIsHe5HvkV5zfbY5B0NBkz.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/heptaslab/v17/ea8JadoyU_jkHdalebHvyWVNdYoIsHe5Hvkn5zfbY5B0NBkz.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/heptaslab/v17/ea8JadoyU_jkHdalebHvyWVNdYoIsHe5HvnL4DfbY5B0NBkz.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/heptaslab/v17/ea8JadoyU_jkHdalebHvyWVNdYoIsHe5Hvny4DfbY5B0NBkz.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/heptaslab/v17/ea8JadoyU_jkHdalebHvyWVNdYoIsHe5HvmV4DfbY5B0NBkz.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/heptaslab/v17/ea8JadoyU_jkHdalebHvyWVNdYoIsHe5Hvm84DfbY5B0NBkz.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Herr Von Muellerhoff\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/herrvonmuellerhoff/v15/WBL6rFjRZkREW8WqmCWYLgCkQKXb4CAft3c6_qJY3QPQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Hi Melody\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"korean\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/himelody/v13/46ktlbP8Vnz0pJcqCTbEf29E31BBGA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Hina Mincho\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v8\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/hinamincho/v8/2sDaZGBRhpXa2Jjz5w5LAGW8KbkVZTHR.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Hind\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/hind/v16/5aU19_a8oxmIfMJaIRuYjDpf5Vw.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/hind/v16/5aU69_a8oxmIRG5yBROzkDM.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/hind/v16/5aU19_a8oxmIfJpbIRuYjDpf5Vw.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/hind/v16/5aU19_a8oxmIfLZcIRuYjDpf5Vw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/hind/v16/5aU19_a8oxmIfNJdIRuYjDpf5Vw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Hind Guntur\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"telugu\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/hindguntur/v12/wXKyE3UZrok56nvamSuJd_yGn1czn9zaj5Ju.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/hindguntur/v12/wXKvE3UZrok56nvamSuJd8Qqt3M7tMDT.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/hindguntur/v12/wXKyE3UZrok56nvamSuJd_zenlczn9zaj5Ju.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/hindguntur/v12/wXKyE3UZrok56nvamSuJd_zymVczn9zaj5Ju.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/hindguntur/v12/wXKyE3UZrok56nvamSuJd_yWmFczn9zaj5Ju.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Hind Madurai\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"tamil\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/hindmadurai/v11/f0Xu0e2p98ZvDXdZQIOcpqjfXaUnecsoMJ0b_g.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/hindmadurai/v11/f0Xx0e2p98ZvDXdZQIOcpqjn8Y0DceA0OQ.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/hindmadurai/v11/f0Xu0e2p98ZvDXdZQIOcpqjfBaQnecsoMJ0b_g.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/hindmadurai/v11/f0Xu0e2p98ZvDXdZQIOcpqjfKaMnecsoMJ0b_g.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/hindmadurai/v11/f0Xu0e2p98ZvDXdZQIOcpqjfTaInecsoMJ0b_g.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Hind Siliguri\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"bengali\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/hindsiliguri/v12/ijwOs5juQtsyLLR5jN4cxBEoRDf44uEfKiGvxts.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/hindsiliguri/v12/ijwTs5juQtsyLLR5jN4cxBEofJvQxuk0Nig.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/hindsiliguri/v12/ijwOs5juQtsyLLR5jN4cxBEoRG_54uEfKiGvxts.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/hindsiliguri/v12/ijwOs5juQtsyLLR5jN4cxBEoREP-4uEfKiGvxts.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/hindsiliguri/v12/ijwOs5juQtsyLLR5jN4cxBEoRCf_4uEfKiGvxts.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Hind Vadodara\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"gujarati\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/hindvadodara/v12/neIQzCKvrIcn5pbuuuriV9tTSDn3iXM0oSOL2Yw.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/hindvadodara/v12/neINzCKvrIcn5pbuuuriV9tTcJXfrXsfvSo.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/hindvadodara/v12/neIQzCKvrIcn5pbuuuriV9tTSGH2iXM0oSOL2Yw.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/hindvadodara/v12/neIQzCKvrIcn5pbuuuriV9tTSE3xiXM0oSOL2Yw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/hindvadodara/v12/neIQzCKvrIcn5pbuuuriV9tTSCnwiXM0oSOL2Yw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Holtwood One SC\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/holtwoodonesc/v16/yYLx0hLR0P-3vMFSk1TCq3Txg5B3cbb6LZttyg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Homemade Apple\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/homemadeapple/v18/Qw3EZQFXECDrI2q789EKQZJob3x9Vnksi4M7.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Homenaje\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/homenaje/v16/FwZY7-Q-xVAi_l-6Ld6A4sijpFu_.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Hubballi\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"kannada\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v4\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/hubballi/v4/o-0JIpUj3WIZ1RFN56B7yBBNYuSF.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Hurricane\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v5\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/hurricane/v5/pe0sMIuULZxTolZ5YldyAv2-C99ycg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"IBM Plex Mono\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/ibmplexmono/v15/-F6pfjptAgt5VM-kVkqdyU8n3kwq0n1hj-sNFQ.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/ibmplexmono/v15/-F6rfjptAgt5VM-kVkqdyU8n1ioStndlre4dFcFh.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/ibmplexmono/v15/-F6qfjptAgt5VM-kVkqdyU8n3uAL8ldPg-IUDNg.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/ibmplexmono/v15/-F6sfjptAgt5VM-kVkqdyU8n1ioSGlZFh8ARHNh4zg.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/ibmplexmono/v15/-F6qfjptAgt5VM-kVkqdyU8n3oQI8ldPg-IUDNg.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/ibmplexmono/v15/-F6sfjptAgt5VM-kVkqdyU8n1ioSflVFh8ARHNh4zg.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ibmplexmono/v15/-F63fjptAgt5VM-kVkqdyU8n5igg1l9kn-s.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/ibmplexmono/v15/-F6pfjptAgt5VM-kVkqdyU8n1ioq0n1hj-sNFQ.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/ibmplexmono/v15/-F6qfjptAgt5VM-kVkqdyU8n3twJ8ldPg-IUDNg.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/ibmplexmono/v15/-F6sfjptAgt5VM-kVkqdyU8n1ioSJlRFh8ARHNh4zg.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/ibmplexmono/v15/-F6qfjptAgt5VM-kVkqdyU8n3vAO8ldPg-IUDNg.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/ibmplexmono/v15/-F6sfjptAgt5VM-kVkqdyU8n1ioSClNFh8ARHNh4zg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/ibmplexmono/v15/-F6qfjptAgt5VM-kVkqdyU8n3pQP8ldPg-IUDNg.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/ibmplexmono/v15/-F6sfjptAgt5VM-kVkqdyU8n1ioSblJFh8ARHNh4zg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"monospace\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"IBM Plex Sans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/ibmplexsans/v14/zYX-KVElMYYaJe8bpLHnCwDKjbLeEKxIedbzDw.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/ibmplexsans/v14/zYX8KVElMYYaJe8bpLHnCwDKhdTmdKZMW9PjD3N8.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/ibmplexsans/v14/zYX9KVElMYYaJe8bpLHnCwDKjR7_MIZmdd_qFmo.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/ibmplexsans/v14/zYX7KVElMYYaJe8bpLHnCwDKhdTm2Idscf3vBmpl8A.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/ibmplexsans/v14/zYX9KVElMYYaJe8bpLHnCwDKjXr8MIZmdd_qFmo.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/ibmplexsans/v14/zYX7KVElMYYaJe8bpLHnCwDKhdTmvIRscf3vBmpl8A.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ibmplexsans/v14/zYXgKVElMYYaJe8bpLHnCwDKtdbUFI5NadY.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/ibmplexsans/v14/zYX-KVElMYYaJe8bpLHnCwDKhdTeEKxIedbzDw.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/ibmplexsans/v14/zYX9KVElMYYaJe8bpLHnCwDKjSL9MIZmdd_qFmo.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/ibmplexsans/v14/zYX7KVElMYYaJe8bpLHnCwDKhdTm5IVscf3vBmpl8A.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/ibmplexsans/v14/zYX9KVElMYYaJe8bpLHnCwDKjQ76MIZmdd_qFmo.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/ibmplexsans/v14/zYX7KVElMYYaJe8bpLHnCwDKhdTmyIJscf3vBmpl8A.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/ibmplexsans/v14/zYX9KVElMYYaJe8bpLHnCwDKjWr7MIZmdd_qFmo.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/ibmplexsans/v14/zYX7KVElMYYaJe8bpLHnCwDKhdTmrINscf3vBmpl8A.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"IBM Plex Sans Arabic\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v9\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/ibmplexsansarabic/v9/Qw3MZRtWPQCuHme67tEYUIx3Kh0PHR9N6YNe3PC5eMlAMg0.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/ibmplexsansarabic/v9/Qw3NZRtWPQCuHme67tEYUIx3Kh0PHR9N6YPy_dCTVsVJKxTs.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/ibmplexsansarabic/v9/Qw3NZRtWPQCuHme67tEYUIx3Kh0PHR9N6YOW_tCTVsVJKxTs.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ibmplexsansarabic/v9/Qw3CZRtWPQCuHme67tEYUIx3Kh0PHR9N6bs61vSbfdlA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/ibmplexsansarabic/v9/Qw3NZRtWPQCuHme67tEYUIx3Kh0PHR9N6YPO_9CTVsVJKxTs.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/ibmplexsansarabic/v9/Qw3NZRtWPQCuHme67tEYUIx3Kh0PHR9N6YPi-NCTVsVJKxTs.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/ibmplexsansarabic/v9/Qw3NZRtWPQCuHme67tEYUIx3Kh0PHR9N6YOG-dCTVsVJKxTs.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"IBM Plex Sans Condensed\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/ibmplexsanscondensed/v13/Gg8nN4UfRSqiPg7Jn2ZI12V4DCEwkj1E4LVeHY7KyKvBgYsMDhM.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/ibmplexsanscondensed/v13/Gg8hN4UfRSqiPg7Jn2ZI12V4DCEwkj1E4LVeHYas8M_LhakJHhOgBg.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/ibmplexsanscondensed/v13/Gg8gN4UfRSqiPg7Jn2ZI12V4DCEwkj1E4LVeHY5m6Yvrr4cFFwq5.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/ibmplexsanscondensed/v13/Gg8iN4UfRSqiPg7Jn2ZI12V4DCEwkj1E4LVeHYas8GPqpYMnEhq5H1w.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/ibmplexsanscondensed/v13/Gg8gN4UfRSqiPg7Jn2ZI12V4DCEwkj1E4LVeHY4C6ovrr4cFFwq5.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/ibmplexsanscondensed/v13/Gg8iN4UfRSqiPg7Jn2ZI12V4DCEwkj1E4LVeHYas8AfppYMnEhq5H1w.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ibmplexsanscondensed/v13/Gg8lN4UfRSqiPg7Jn2ZI12V4DCEwkj1E4LVeHbauwq_jhJsM.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/ibmplexsanscondensed/v13/Gg8nN4UfRSqiPg7Jn2ZI12V4DCEwkj1E4LVeHYasyKvBgYsMDhM.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/ibmplexsanscondensed/v13/Gg8gN4UfRSqiPg7Jn2ZI12V4DCEwkj1E4LVeHY5a64vrr4cFFwq5.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/ibmplexsanscondensed/v13/Gg8iN4UfRSqiPg7Jn2ZI12V4DCEwkj1E4LVeHYas8F_opYMnEhq5H1w.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/ibmplexsanscondensed/v13/Gg8gN4UfRSqiPg7Jn2ZI12V4DCEwkj1E4LVeHY527Ivrr4cFFwq5.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/ibmplexsanscondensed/v13/Gg8iN4UfRSqiPg7Jn2ZI12V4DCEwkj1E4LVeHYas8HPvpYMnEhq5H1w.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/ibmplexsanscondensed/v13/Gg8gN4UfRSqiPg7Jn2ZI12V4DCEwkj1E4LVeHY4S7Yvrr4cFFwq5.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/ibmplexsanscondensed/v13/Gg8iN4UfRSqiPg7Jn2ZI12V4DCEwkj1E4LVeHYas8BfupYMnEhq5H1w.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"IBM Plex Sans Devanagari\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v9\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/ibmplexsansdevanagari/v9/XRXB3JCMvG4IDoS9SubXB6W-UX5iehIMBFR2-O_HMUjwUcjwCEQq.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/ibmplexsansdevanagari/v9/XRXA3JCMvG4IDoS9SubXB6W-UX5iehIMBFR2-O_HnWnQe-b8AV0z0w.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/ibmplexsansdevanagari/v9/XRXA3JCMvG4IDoS9SubXB6W-UX5iehIMBFR2-O_H-WrQe-b8AV0z0w.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ibmplexsansdevanagari/v9/XRXH3JCMvG4IDoS9SubXB6W-UX5iehIMBFR2-O__VUL0c83gCA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/ibmplexsansdevanagari/v9/XRXA3JCMvG4IDoS9SubXB6W-UX5iehIMBFR2-O_HoWvQe-b8AV0z0w.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/ibmplexsansdevanagari/v9/XRXA3JCMvG4IDoS9SubXB6W-UX5iehIMBFR2-O_HjWzQe-b8AV0z0w.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/ibmplexsansdevanagari/v9/XRXA3JCMvG4IDoS9SubXB6W-UX5iehIMBFR2-O_H6W3Qe-b8AV0z0w.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"IBM Plex Sans Hebrew\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/ibmplexsanshebrew/v10/BCa4qYENg9Kw1mpLpO0bGM5lfHAAZHhDXEXB-l0VqDaM7C4.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/ibmplexsanshebrew/v10/BCa5qYENg9Kw1mpLpO0bGM5lfHAAZHhDXEVt230_hjqF9Tc2.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/ibmplexsanshebrew/v10/BCa5qYENg9Kw1mpLpO0bGM5lfHAAZHhDXEUJ2H0_hjqF9Tc2.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ibmplexsanshebrew/v10/BCa2qYENg9Kw1mpLpO0bGM5lfHAAZHhDXH2l8Fk3rSaM.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/ibmplexsanshebrew/v10/BCa5qYENg9Kw1mpLpO0bGM5lfHAAZHhDXEVR2X0_hjqF9Tc2.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/ibmplexsanshebrew/v10/BCa5qYENg9Kw1mpLpO0bGM5lfHAAZHhDXEV93n0_hjqF9Tc2.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/ibmplexsanshebrew/v10/BCa5qYENg9Kw1mpLpO0bGM5lfHAAZHhDXEUZ330_hjqF9Tc2.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"IBM Plex Sans JP\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v3\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/ibmplexsansjp/v3/Z9XLDn9KbTDf6_f7dISNqYf_tvPT7E7yjPB7twdmHQ.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/ibmplexsansjp/v3/Z9XKDn9KbTDf6_f7dISNqYf_tvPT7OLTrNpVuw5_BAM.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/ibmplexsansjp/v3/Z9XKDn9KbTDf6_f7dISNqYf_tvPT7IbQrNpVuw5_BAM.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ibmplexsansjp/v3/Z9XNDn9KbTDf6_f7dISNqYf_tvPT1Cr4iNJ-pwc.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/ibmplexsansjp/v3/Z9XKDn9KbTDf6_f7dISNqYf_tvPT7N7RrNpVuw5_BAM.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/ibmplexsansjp/v3/Z9XKDn9KbTDf6_f7dISNqYf_tvPT7PLWrNpVuw5_BAM.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/ibmplexsansjp/v3/Z9XKDn9KbTDf6_f7dISNqYf_tvPT7JbXrNpVuw5_BAM.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"IBM Plex Sans KR\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"korean\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v9\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/ibmplexsanskr/v9/vEFM2-VJISZe3O_rc3ZVYh4aTwNOyra_X5zCpMrMfA.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/ibmplexsanskr/v9/vEFN2-VJISZe3O_rc3ZVYh4aTwNOyhqef7bsqMPVZb4.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/ibmplexsanskr/v9/vEFN2-VJISZe3O_rc3ZVYh4aTwNOyn6df7bsqMPVZb4.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ibmplexsanskr/v9/vEFK2-VJISZe3O_rc3ZVYh4aTwNO8tK1W77HtMo.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/ibmplexsanskr/v9/vEFN2-VJISZe3O_rc3ZVYh4aTwNOyiacf7bsqMPVZb4.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/ibmplexsanskr/v9/vEFN2-VJISZe3O_rc3ZVYh4aTwNOygqbf7bsqMPVZb4.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/ibmplexsanskr/v9/vEFN2-VJISZe3O_rc3ZVYh4aTwNOym6af7bsqMPVZb4.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"IBM Plex Sans Thai\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"thai\"\n\t\t\t],\n\t\t\t\"version\": \"v9\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/ibmplexsansthai/v9/m8JNje1VVIzcq1HzJq2AEdo2Tj_qvLqEatYlR8ZKUqcX.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/ibmplexsansthai/v9/m8JMje1VVIzcq1HzJq2AEdo2Tj_qvLqExvcFbehGW74OXw.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/ibmplexsansthai/v9/m8JMje1VVIzcq1HzJq2AEdo2Tj_qvLqEovQFbehGW74OXw.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ibmplexsansthai/v9/m8JPje1VVIzcq1HzJq2AEdo2Tj_qvLq8DtwhZcNaUg.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/ibmplexsansthai/v9/m8JMje1VVIzcq1HzJq2AEdo2Tj_qvLqE-vUFbehGW74OXw.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/ibmplexsansthai/v9/m8JMje1VVIzcq1HzJq2AEdo2Tj_qvLqE1vIFbehGW74OXw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/ibmplexsansthai/v9/m8JMje1VVIzcq1HzJq2AEdo2Tj_qvLqEsvMFbehGW74OXw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"IBM Plex Sans Thai Looped\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"thai\"\n\t\t\t],\n\t\t\t\"version\": \"v9\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/ibmplexsansthailooped/v9/tss5AoJJRAhL3BTrK3r2xxbFhvKfyBB6l7hHT30L_HaKpHOtFCQ76Q.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/ibmplexsansthailooped/v9/tss6AoJJRAhL3BTrK3r2xxbFhvKfyBB6l7hHT30L_NqrhFmDGC0i8Cc.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/ibmplexsansthailooped/v9/tss6AoJJRAhL3BTrK3r2xxbFhvKfyBB6l7hHT30L_L6ohFmDGC0i8Cc.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ibmplexsansthailooped/v9/tss_AoJJRAhL3BTrK3r2xxbFhvKfyBB6l7hHT30LxBKAoFGoBCQ.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/ibmplexsansthailooped/v9/tss6AoJJRAhL3BTrK3r2xxbFhvKfyBB6l7hHT30L_OaphFmDGC0i8Cc.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/ibmplexsansthailooped/v9/tss6AoJJRAhL3BTrK3r2xxbFhvKfyBB6l7hHT30L_MquhFmDGC0i8Cc.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/ibmplexsansthailooped/v9/tss6AoJJRAhL3BTrK3r2xxbFhvKfyBB6l7hHT30L_K6vhFmDGC0i8Cc.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"IBM Plex Serif\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/ibmplexserif/v15/jizBREVNn1dOx-zrZ2X3pZvkTi182zIZj1bIkNo.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/ibmplexserif/v15/jizHREVNn1dOx-zrZ2X3pZvkTiUa41YTi3TNgNq55w.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/ibmplexserif/v15/jizAREVNn1dOx-zrZ2X3pZvkTi3Q-hIzoVrBicOg.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/ibmplexserif/v15/jizGREVNn1dOx-zrZ2X3pZvkTiUa4_oyq17jjNOg_oc.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/ibmplexserif/v15/jizAREVNn1dOx-zrZ2X3pZvkTi20-RIzoVrBicOg.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/ibmplexserif/v15/jizGREVNn1dOx-zrZ2X3pZvkTiUa454xq17jjNOg_oc.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ibmplexserif/v15/jizDREVNn1dOx-zrZ2X3pZvkThUY0TY7ikbI.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/ibmplexserif/v15/jizBREVNn1dOx-zrZ2X3pZvkTiUa2zIZj1bIkNo.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/ibmplexserif/v15/jizAREVNn1dOx-zrZ2X3pZvkTi3s-BIzoVrBicOg.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/ibmplexserif/v15/jizGREVNn1dOx-zrZ2X3pZvkTiUa48Ywq17jjNOg_oc.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/ibmplexserif/v15/jizAREVNn1dOx-zrZ2X3pZvkTi3A_xIzoVrBicOg.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/ibmplexserif/v15/jizGREVNn1dOx-zrZ2X3pZvkTiUa4-o3q17jjNOg_oc.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/ibmplexserif/v15/jizAREVNn1dOx-zrZ2X3pZvkTi2k_hIzoVrBicOg.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/ibmplexserif/v15/jizGREVNn1dOx-zrZ2X3pZvkTiUa4442q17jjNOg_oc.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"IM Fell DW Pica\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/imfelldwpica/v16/2sDGZGRQotv9nbn2qSl0TxXVYNw9ZAPUvi88MQ.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/imfelldwpica/v16/2sDEZGRQotv9nbn2qSl0TxXVYNwNZgnQnCosMXm0.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"IM Fell DW Pica SC\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/imfelldwpicasc/v21/0ybjGCAu5PfqkvtGVU15aBhXz3EUrnTW-BiKEUiBGA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"IM Fell Double Pica\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/imfelldoublepica/v14/3XF2EqMq_94s9PeKF7Fg4gOKINyMtZ8rT0S1UL5Ayp0.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/imfelldoublepica/v14/3XF0EqMq_94s9PeKF7Fg4gOKINyMtZ8rf0a_VJxF2p2G8g.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"IM Fell Double Pica SC\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/imfelldoublepicasc/v21/neIazDmuiMkFo6zj_sHpQ8teNbWlwBB_hXjJ4Y0Eeru2dGg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"IM Fell English\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/imfellenglish/v14/Ktk1ALSLW8zDe0rthJysWrnLsAz3F6mZVY9Y5w.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/imfellenglish/v14/Ktk3ALSLW8zDe0rthJysWrnLsAzHFaOdd4pI59zg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"IM Fell English SC\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/imfellenglishsc/v16/a8IENpD3CDX-4zrWfr1VY879qFF05pZLO4gOg0shzA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"IM Fell French Canon\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/imfellfrenchcanon/v21/-F6ufiNtDWYfYc-tDiyiw08rrghJszkK6coVPt1ozoPz.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/imfellfrenchcanon/v21/-F6gfiNtDWYfYc-tDiyiw08rrghJszkK6foXNNlKy5PzzrU.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"IM Fell French Canon SC\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/imfellfrenchcanonsc/v22/FBVmdCru5-ifcor2bgq9V89khWcmQghEURY7H3c0UBCVIVqH.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"IM Fell Great Primer\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/imfellgreatprimer/v21/bx6aNwSJtayYxOkbYFsT6hMsLzX7u85rJorXvDo3SQY1.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/imfellgreatprimer/v21/bx6UNwSJtayYxOkbYFsT6hMsLzX7u85rJrrVtj4VTBY1N6U.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"IM Fell Great Primer SC\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/imfellgreatprimersc/v21/ga6daxBOxyt6sCqz3fjZCTFCTUDMHagsQKdDTLf9BXz0s8FG.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Ibarra Real Nova\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ibarrarealnova/v20/sZlSdQiA-DBIDCcaWtQzL4BZHoiDundw4ATyjed3EXdg5MDtVT9TWIvS.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/ibarrarealnova/v20/sZlSdQiA-DBIDCcaWtQzL4BZHoiDundw4ATyjed3EXdS5MDtVT9TWIvS.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/ibarrarealnova/v20/sZlSdQiA-DBIDCcaWtQzL4BZHoiDundw4ATyjed3EXe-48DtVT9TWIvS.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/ibarrarealnova/v20/sZlSdQiA-DBIDCcaWtQzL4BZHoiDundw4ATyjed3EXeH48DtVT9TWIvS.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/ibarrarealnova/v20/sZlsdQiA-DBIDCcaWtQzL4BZHoiDkH5CH9yb5n3ZFmKopyiuXztxXZvSkTo.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/ibarrarealnova/v20/sZlsdQiA-DBIDCcaWtQzL4BZHoiDkH5CH9yb5n3ZFmKopxquXztxXZvSkTo.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/ibarrarealnova/v20/sZlsdQiA-DBIDCcaWtQzL4BZHoiDkH5CH9yb5n3ZFmKop_apXztxXZvSkTo.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/ibarrarealnova/v20/sZlsdQiA-DBIDCcaWtQzL4BZHoiDkH5CH9yb5n3ZFmKop8-pXztxXZvSkTo.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Iceberg\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-04-26\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/iceberg/v20/8QIJdijAiM7o-qnZuIgOq7jkAOw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Iceland\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-04-26\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/iceland/v16/rax9HiuFsdMNOnWPWKxGADBbg0s.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Imbue\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/imbue/v21/RLpXK5P16Ki3fXhj5cvGrqjocPk4n-gVX3M93TnrnvhoP8iWfOsNNK-Q4xY.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/imbue/v21/RLpXK5P16Ki3fXhj5cvGrqjocPk4n-gVX3M93TnrnvhoP0iXfOsNNK-Q4xY.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/imbue/v21/RLpXK5P16Ki3fXhj5cvGrqjocPk4n-gVX3M93TnrnvhoP5aXfOsNNK-Q4xY.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/imbue/v21/RLpXK5P16Ki3fXhj5cvGrqjocPk4n-gVX3M93TnrnvhoP8iXfOsNNK-Q4xY.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/imbue/v21/RLpXK5P16Ki3fXhj5cvGrqjocPk4n-gVX3M93TnrnvhoP_qXfOsNNK-Q4xY.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/imbue/v21/RLpXK5P16Ki3fXhj5cvGrqjocPk4n-gVX3M93TnrnvhoPxaQfOsNNK-Q4xY.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/imbue/v21/RLpXK5P16Ki3fXhj5cvGrqjocPk4n-gVX3M93TnrnvhoPy-QfOsNNK-Q4xY.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/imbue/v21/RLpXK5P16Ki3fXhj5cvGrqjocPk4n-gVX3M93TnrnvhoP0iQfOsNNK-Q4xY.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/imbue/v21/RLpXK5P16Ki3fXhj5cvGrqjocPk4n-gVX3M93TnrnvhoP2GQfOsNNK-Q4xY.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Imperial Script\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v3\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/imperialscript/v3/5DCPAKrpzy_H98IV2ISnZBbGrVNvPenlvttWNg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Imprima\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/imprima/v16/VEMxRoN7sY3yuy-7-oWHyDzktPo.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Inconsolata\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v31\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/inconsolata/v31/QldgNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLYxYWI2qfdm7LppwU8aRr8lleY2co.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/inconsolata/v31/QldgNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLYxYWI2qfdm7Lpp9s8aRr8lleY2co.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/inconsolata/v31/QldgNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLYxYWI2qfdm7Lpp4U8aRr8lleY2co.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/inconsolata/v31/QldgNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLYxYWI2qfdm7Lpp7c8aRr8lleY2co.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/inconsolata/v31/QldgNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLYxYWI2qfdm7Lpp1s7aRr8lleY2co.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/inconsolata/v31/QldgNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLYxYWI2qfdm7Lpp2I7aRr8lleY2co.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/inconsolata/v31/QldgNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLYxYWI2qfdm7LppwU7aRr8lleY2co.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/inconsolata/v31/QldgNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLYxYWI2qfdm7Lppyw7aRr8lleY2co.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"monospace\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Inder\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/inder/v14/w8gUH2YoQe8_4vq6pw-P3U4O.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Indie Flower\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/indieflower/v17/m8JVjfNVeKWVnh3QMuKkFcZlbkGG1dKEDw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Ingrid Darling\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v2\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ingriddarling/v2/LDIrapaJNxUtSuFdw-9yf4rCPsLOub458jGL.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Inika\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/inika/v21/rnCm-x5X3QP-phTHRcc2s2XH.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/inika/v21/rnCr-x5X3QP-pix7auM-mHnOSOuk.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Inknut Antiqua\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/inknutantiqua/v14/Y4GRYax7VC4ot_qNB4nYpBdaKU2vwrj5bBoIYJNf.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/inknutantiqua/v14/Y4GSYax7VC4ot_qNB4nYpBdaKXUD6pzxRwYB.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/inknutantiqua/v14/Y4GRYax7VC4ot_qNB4nYpBdaKU33w7j5bBoIYJNf.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/inknutantiqua/v14/Y4GRYax7VC4ot_qNB4nYpBdaKU3bxLj5bBoIYJNf.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/inknutantiqua/v14/Y4GRYax7VC4ot_qNB4nYpBdaKU2_xbj5bBoIYJNf.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/inknutantiqua/v14/Y4GRYax7VC4ot_qNB4nYpBdaKU2jxrj5bBoIYJNf.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/inknutantiqua/v14/Y4GRYax7VC4ot_qNB4nYpBdaKU2Hx7j5bBoIYJNf.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Inria Sans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/inriasans/v14/ptRPTiqXYfZMCOiVj9kQ3ELaDQtFqeY3fX4.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/inriasans/v14/ptRRTiqXYfZMCOiVj9kQ1OzAgQlPrcQybX4pQA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/inriasans/v14/ptRMTiqXYfZMCOiVj9kQ5O7yKQNute8.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/inriasans/v14/ptROTiqXYfZMCOiVj9kQ1Oz4LSFrpe8uZA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/inriasans/v14/ptRPTiqXYfZMCOiVj9kQ3FLdDQtFqeY3fX4.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/inriasans/v14/ptRRTiqXYfZMCOiVj9kQ1OzAkQ5PrcQybX4pQA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Inria Serif\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/inriaserif/v14/fC14PYxPY3rXxEndZJAzN3wAVQjFhFyta3xN.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/inriaserif/v14/fC16PYxPY3rXxEndZJAzN3SuT4THjliPbmxN0_E.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/inriaserif/v14/fC1lPYxPY3rXxEndZJAzN0SsfSzNr0Ck.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/inriaserif/v14/fC1nPYxPY3rXxEndZJAzN3SudyjvqlCkcmU.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/inriaserif/v14/fC14PYxPY3rXxEndZJAzN3wQUgjFhFyta3xN.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/inriaserif/v14/fC16PYxPY3rXxEndZJAzN3SuT5TAjliPbmxN0_E.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Inspiration\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v3\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/inspiration/v3/x3dkckPPZa6L4wIg5cZOEvoGnSrlBBsy.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Inter\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuLyeMZhrib2Bg-4.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuDyfMZhrib2Bg-4.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuOKfMZhrib2Bg-4.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuLyfMZhrib2Bg-4.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuI6fMZhrib2Bg-4.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuGKYMZhrib2Bg-4.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuFuYMZhrib2Bg-4.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuDyYMZhrib2Bg-4.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuBWYMZhrib2Bg-4.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Inter Tight\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v2\",\n\t\t\t\"lastModified\": \"2023-01-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/intertight/v2/NGSnv5HMAFg6IuGlBNMjxJEL2VmU3NS7Z2mjDw6qXCRToK8EPg.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/intertight/v2/NGSnv5HMAFg6IuGlBNMjxJEL2VmU3NS7Z2mjjw-qXCRToK8EPg.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/intertight/v2/NGSnv5HMAFg6IuGlBNMjxJEL2VmU3NS7Z2mjUQ-qXCRToK8EPg.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/intertight/v2/NGSnv5HMAFg6IuGlBNMjxJEL2VmU3NS7Z2mjDw-qXCRToK8EPg.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/intertight/v2/NGSnv5HMAFg6IuGlBNMjxJEL2VmU3NS7Z2mjPQ-qXCRToK8EPg.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/intertight/v2/NGSnv5HMAFg6IuGlBNMjxJEL2VmU3NS7Z2mj0QiqXCRToK8EPg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/intertight/v2/NGSnv5HMAFg6IuGlBNMjxJEL2VmU3NS7Z2mj6AiqXCRToK8EPg.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/intertight/v2/NGSnv5HMAFg6IuGlBNMjxJEL2VmU3NS7Z2mjjwiqXCRToK8EPg.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/intertight/v2/NGSnv5HMAFg6IuGlBNMjxJEL2VmU3NS7Z2mjpgiqXCRToK8EPg.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/intertight/v2/NGShv5HMAFg6IuGlBNMjxLsC66ZMtb8hyW62x0xCHi5XgqoUPvi5.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/intertight/v2/NGShv5HMAFg6IuGlBNMjxLsC66ZMtb8hyW62x0zCHy5XgqoUPvi5.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/intertight/v2/NGShv5HMAFg6IuGlBNMjxLsC66ZMtb8hyW62x0wcHy5XgqoUPvi5.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/intertight/v2/NGShv5HMAFg6IuGlBNMjxLsC66ZMtb8hyW62x0xCHy5XgqoUPvi5.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/intertight/v2/NGShv5HMAFg6IuGlBNMjxLsC66ZMtb8hyW62x0xwHy5XgqoUPvi5.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/intertight/v2/NGShv5HMAFg6IuGlBNMjxLsC66ZMtb8hyW62x0ycGC5XgqoUPvi5.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/intertight/v2/NGShv5HMAFg6IuGlBNMjxLsC66ZMtb8hyW62x0ylGC5XgqoUPvi5.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/intertight/v2/NGShv5HMAFg6IuGlBNMjxLsC66ZMtb8hyW62x0zCGC5XgqoUPvi5.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/intertight/v2/NGShv5HMAFg6IuGlBNMjxLsC66ZMtb8hyW62x0zrGC5XgqoUPvi5.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Irish Grover\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v23\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/irishgrover/v23/buExpoi6YtLz2QW7LA4flVgf-P5Oaiw4cw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Island Moments\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v3\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/islandmoments/v3/NaPBcZfVGvBdxIt7Ar0qzkXJF-TGIohbZ6SY.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Istok Web\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/istokweb/v20/3qTvojGmgSyUukBzKslZAWF-9kIIaQ.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/istokweb/v20/3qTpojGmgSyUukBzKslpA2t61EcYaQ7F.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/istokweb/v20/3qTqojGmgSyUukBzKslhvU5a_mkUYBfcMw.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/istokweb/v20/3qT0ojGmgSyUukBzKslpA1PG-2MQQhLMMygN.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Italiana\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/italiana/v16/QldNNTtLsx4E__B0XTmRY31Wx7Vv.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Italianno\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/italianno/v16/dg4n_p3sv6gCJkwzT6Rnj5YpQwM-gg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Itim\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"thai\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/itim/v10/0nknC9ziJOYewARKkc7ZdwU.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Jacques Francois\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-04-26\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/jacquesfrancois/v20/ZXu9e04ZvKeOOHIe1TMahbcIU2cgmcPqoeRWfbs.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Jacques Francois Shadow\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-04-26\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/jacquesfrancoisshadow/v21/KR1FBtOz8PKTMk-kqdkLVrvR0ECFrB6Pin-2_q8VsHuV5ULS.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Jaldi\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/jaldi/v12/or3sQ67z0_CI30NUZpD_B6g8.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/jaldi/v12/or3hQ67z0_CI33voSbT3LLQ1niPn.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"JetBrains Mono\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/jetbrainsmono/v13/tDbY2o-flEEny0FZhsfKu5WU4zr3E_BX0PnT8RD8yK1jPVmUsaaDhw.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/jetbrainsmono/v13/tDbY2o-flEEny0FZhsfKu5WU4zr3E_BX0PnT8RD8SKxjPVmUsaaDhw.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/jetbrainsmono/v13/tDbY2o-flEEny0FZhsfKu5WU4zr3E_BX0PnT8RD8lqxjPVmUsaaDhw.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/jetbrainsmono/v13/tDbY2o-flEEny0FZhsfKu5WU4zr3E_BX0PnT8RD8yKxjPVmUsaaDhw.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/jetbrainsmono/v13/tDbY2o-flEEny0FZhsfKu5WU4zr3E_BX0PnT8RD8-qxjPVmUsaaDhw.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/jetbrainsmono/v13/tDbY2o-flEEny0FZhsfKu5WU4zr3E_BX0PnT8RD8FqtjPVmUsaaDhw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/jetbrainsmono/v13/tDbY2o-flEEny0FZhsfKu5WU4zr3E_BX0PnT8RD8L6tjPVmUsaaDhw.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/jetbrainsmono/v13/tDbY2o-flEEny0FZhsfKu5WU4zr3E_BX0PnT8RD8SKtjPVmUsaaDhw.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/jetbrainsmono/v13/tDba2o-flEEny0FZhsfKu5WU4xD-IQ-PuZJJXxfpAO-Lf1OQk6OThxPA.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/jetbrainsmono/v13/tDba2o-flEEny0FZhsfKu5WU4xD-IQ-PuZJJXxfpAO8LflOQk6OThxPA.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/jetbrainsmono/v13/tDba2o-flEEny0FZhsfKu5WU4xD-IQ-PuZJJXxfpAO_VflOQk6OThxPA.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/jetbrainsmono/v13/tDba2o-flEEny0FZhsfKu5WU4xD-IQ-PuZJJXxfpAO-LflOQk6OThxPA.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/jetbrainsmono/v13/tDba2o-flEEny0FZhsfKu5WU4xD-IQ-PuZJJXxfpAO-5flOQk6OThxPA.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/jetbrainsmono/v13/tDba2o-flEEny0FZhsfKu5WU4xD-IQ-PuZJJXxfpAO9VeVOQk6OThxPA.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/jetbrainsmono/v13/tDba2o-flEEny0FZhsfKu5WU4xD-IQ-PuZJJXxfpAO9seVOQk6OThxPA.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/jetbrainsmono/v13/tDba2o-flEEny0FZhsfKu5WU4xD-IQ-PuZJJXxfpAO8LeVOQk6OThxPA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"monospace\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Jim Nightshade\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/jimnightshade/v20/PlIkFlu9Pb08Q8HLM1PxmB0g-OS4V3qKaMxD.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Joan\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/joan/v1/ZXupe1oZsqWRbRdH8X1p_Ng.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Jockey One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/jockeyone/v15/HTxpL2g2KjCFj4x8WI6ArIb7HYOk4xc.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Jolly Lodger\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/jollylodger/v20/BXRsvFTAh_bGkA1uQ48dlB3VWerT3ZyuqA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Jomhuria\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/jomhuria/v18/Dxxp8j-TMXf-llKur2b1MOGbC3Dh.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Jomolhari\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"tibetan\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/jomolhari/v14/EvONzA1M1Iw_CBd2hsQCF1IZKq5INg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Josefin Sans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v25\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/josefinsans/v25/Qw3PZQNVED7rKGKxtqIqX5E-AVSJrOCfjY46_DjRXMFrLgTsQV0.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/josefinsans/v25/Qw3PZQNVED7rKGKxtqIqX5E-AVSJrOCfjY46_LjQXMFrLgTsQV0.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/josefinsans/v25/Qw3PZQNVED7rKGKxtqIqX5E-AVSJrOCfjY46_GbQXMFrLgTsQV0.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/josefinsans/v25/Qw3PZQNVED7rKGKxtqIqX5E-AVSJrOCfjY46_DjQXMFrLgTsQV0.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/josefinsans/v25/Qw3PZQNVED7rKGKxtqIqX5E-AVSJrOCfjY46_ArQXMFrLgTsQV0.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/josefinsans/v25/Qw3PZQNVED7rKGKxtqIqX5E-AVSJrOCfjY46_ObXXMFrLgTsQV0.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/josefinsans/v25/Qw3PZQNVED7rKGKxtqIqX5E-AVSJrOCfjY46_N_XXMFrLgTsQV0.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/josefinsans/v25/Qw3JZQNVED7rKGKxtqIqX5EUCGZ2dIn0FyA96fCTtINhKibpUV3MEQ.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/josefinsans/v25/Qw3JZQNVED7rKGKxtqIqX5EUCGZ2dIn0FyA96fCTNIJhKibpUV3MEQ.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/josefinsans/v25/Qw3JZQNVED7rKGKxtqIqX5EUCGZ2dIn0FyA96fCT6oJhKibpUV3MEQ.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/josefinsans/v25/Qw3JZQNVED7rKGKxtqIqX5EUCGZ2dIn0FyA96fCTtIJhKibpUV3MEQ.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/josefinsans/v25/Qw3JZQNVED7rKGKxtqIqX5EUCGZ2dIn0FyA96fCThoJhKibpUV3MEQ.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/josefinsans/v25/Qw3JZQNVED7rKGKxtqIqX5EUCGZ2dIn0FyA96fCTaoVhKibpUV3MEQ.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/josefinsans/v25/Qw3JZQNVED7rKGKxtqIqX5EUCGZ2dIn0FyA96fCTU4VhKibpUV3MEQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Josefin Slab\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-07-12\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/josefinslab/v20/lW-swjwOK3Ps5GSJlNNkMalNpiZe_ldbOR4W71mtd3k3K6CcEyI.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/josefinslab/v20/lW-swjwOK3Ps5GSJlNNkMalNpiZe_ldbOR4W79msd3k3K6CcEyI.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/josefinslab/v20/lW-swjwOK3Ps5GSJlNNkMalNpiZe_ldbOR4W7wesd3k3K6CcEyI.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/josefinslab/v20/lW-swjwOK3Ps5GSJlNNkMalNpiZe_ldbOR4W71msd3k3K6CcEyI.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/josefinslab/v20/lW-swjwOK3Ps5GSJlNNkMalNpiZe_ldbOR4W72usd3k3K6CcEyI.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/josefinslab/v20/lW-swjwOK3Ps5GSJlNNkMalNpiZe_ldbOR4W74erd3k3K6CcEyI.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/josefinslab/v20/lW-swjwOK3Ps5GSJlNNkMalNpiZe_ldbOR4W776rd3k3K6CcEyI.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/josefinslab/v20/lW-qwjwOK3Ps5GSJlNNkMalnrxShJj4wo7AR-pHvnzs9L4KZAyK43w.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/josefinslab/v20/lW-qwjwOK3Ps5GSJlNNkMalnrxShJj4wo7AR-pHvHzo9L4KZAyK43w.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/josefinslab/v20/lW-qwjwOK3Ps5GSJlNNkMalnrxShJj4wo7AR-pHvwTo9L4KZAyK43w.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/josefinslab/v20/lW-qwjwOK3Ps5GSJlNNkMalnrxShJj4wo7AR-pHvnzo9L4KZAyK43w.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/josefinslab/v20/lW-qwjwOK3Ps5GSJlNNkMalnrxShJj4wo7AR-pHvrTo9L4KZAyK43w.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/josefinslab/v20/lW-qwjwOK3Ps5GSJlNNkMalnrxShJj4wo7AR-pHvQT09L4KZAyK43w.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/josefinslab/v20/lW-qwjwOK3Ps5GSJlNNkMalnrxShJj4wo7AR-pHveD09L4KZAyK43w.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Jost\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/jost/v14/92zPtBhPNqw79Ij1E865zBUv7myjJAVGPokMmuHL.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/jost/v14/92zPtBhPNqw79Ij1E865zBUv7mwjJQVGPokMmuHL.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/jost/v14/92zPtBhPNqw79Ij1E865zBUv7mz9JQVGPokMmuHL.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/jost/v14/92zPtBhPNqw79Ij1E865zBUv7myjJQVGPokMmuHL.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/jost/v14/92zPtBhPNqw79Ij1E865zBUv7myRJQVGPokMmuHL.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/jost/v14/92zPtBhPNqw79Ij1E865zBUv7mx9IgVGPokMmuHL.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/jost/v14/92zPtBhPNqw79Ij1E865zBUv7mxEIgVGPokMmuHL.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/jost/v14/92zPtBhPNqw79Ij1E865zBUv7mwjIgVGPokMmuHL.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/jost/v14/92zPtBhPNqw79Ij1E865zBUv7mwKIgVGPokMmuHL.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/jost/v14/92zJtBhPNqw73oHH7BbQp4-B6XlrZu0ENI0un_HLMEo.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/jost/v14/92zJtBhPNqw73oHH7BbQp4-B6XlrZm0FNI0un_HLMEo.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/jost/v14/92zJtBhPNqw73oHH7BbQp4-B6XlrZrMFNI0un_HLMEo.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/jost/v14/92zJtBhPNqw73oHH7BbQp4-B6XlrZu0FNI0un_HLMEo.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/jost/v14/92zJtBhPNqw73oHH7BbQp4-B6XlrZt8FNI0un_HLMEo.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/jost/v14/92zJtBhPNqw73oHH7BbQp4-B6XlrZjMCNI0un_HLMEo.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/jost/v14/92zJtBhPNqw73oHH7BbQp4-B6XlrZgoCNI0un_HLMEo.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/jost/v14/92zJtBhPNqw73oHH7BbQp4-B6XlrZm0CNI0un_HLMEo.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/jost/v14/92zJtBhPNqw73oHH7BbQp4-B6XlrZkQCNI0un_HLMEo.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Joti One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/jotione/v21/Z9XVDmdJQAmWm9TwaYTe4u2El6GC.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Jua\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"korean\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/jua/v13/co3KmW9ljjAjc-DZCsKgsg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Judson\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/judson/v18/FeVRS0Fbvbc14VxRD7N01bV7kg.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/judson/v18/FeVTS0Fbvbc14VxhDblw97BrknZf.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/judson/v18/FeVSS0Fbvbc14Vxps5xQ3Z5nm29Gww.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Julee\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/julee/v22/TuGfUVB3RpZPQ6ZLodgzydtk.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Julius Sans One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/juliussansone/v14/1Pt2g8TAX_SGgBGUi0tGOYEga5W-xXEW6aGXHw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Junge\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-04-26\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/junge/v20/gokgH670Gl1lUqAdvhB7SnKm.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Jura\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"kayah-li\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/jura/v24/z7NOdRfiaC4Vd8hhoPzfb5vBTP0D7auhTfmrH_rt.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/jura/v24/z7NOdRfiaC4Vd8hhoPzfb5vBTP1d7auhTfmrH_rt.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/jura/v24/z7NOdRfiaC4Vd8hhoPzfb5vBTP1v7auhTfmrH_rt.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/jura/v24/z7NOdRfiaC4Vd8hhoPzfb5vBTP2D6quhTfmrH_rt.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/jura/v24/z7NOdRfiaC4Vd8hhoPzfb5vBTP266quhTfmrH_rt.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Just Another Hand\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/justanotherhand/v19/845CNN4-AJyIGvIou-6yJKyptyOpOcr_BmmlS5aw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Just Me Again Down Here\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/justmeagaindownhere/v24/MwQmbgXtz-Wc6RUEGNMc0QpRrfUh2hSdBBMoAuwHvqDwc_fg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"K2D\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800\",\n\t\t\t\t\"800italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"thai\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v9\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/k2d/v9/J7aRnpF2V0ErE6UpvrIw74NL.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/k2d/v9/J7afnpF2V0EjdZ1NtLYS6pNLAjk.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/k2d/v9/J7aenpF2V0Erv4QJlJw85ppSGw.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/k2d/v9/J7acnpF2V0EjdZ3hlZY4xJ9CGyAa.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/k2d/v9/J7aenpF2V0Er24cJlJw85ppSGw.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/k2d/v9/J7acnpF2V0EjdZ2FlpY4xJ9CGyAa.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/k2d/v9/J7aTnpF2V0ETd68tnLcg7w.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/k2d/v9/J7aRnpF2V0EjdaUpvrIw74NL.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/k2d/v9/J7aenpF2V0Erg4YJlJw85ppSGw.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/k2d/v9/J7acnpF2V0EjdZ3dl5Y4xJ9CGyAa.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/k2d/v9/J7aenpF2V0Err4EJlJw85ppSGw.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/k2d/v9/J7acnpF2V0EjdZ3xkJY4xJ9CGyAa.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/k2d/v9/J7aenpF2V0Ery4AJlJw85ppSGw.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/k2d/v9/J7acnpF2V0EjdZ2VkZY4xJ9CGyAa.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/k2d/v9/J7aenpF2V0Er14MJlJw85ppSGw.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/k2d/v9/J7acnpF2V0EjdZ2JkpY4xJ9CGyAa.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Kadwa\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kadwa/v10/rnCm-x5V0g7iphTHRcc2s2XH.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/kadwa/v10/rnCr-x5V0g7ipix7auM-mHnOSOuk.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Kaisei Decol\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v8\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kaiseidecol/v8/bMrwmSqP45sidWf3QmfFW6iyW1EP22OjoA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/kaiseidecol/v8/bMrvmSqP45sidWf3QmfFW6iKr3gr00i_qb57kA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/kaiseidecol/v8/bMrvmSqP45sidWf3QmfFW6iK534r00i_qb57kA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Kaisei HarunoUmi\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v8\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kaiseiharunoumi/v8/HI_RiZQSLqBQoAHhK_C6N_nzy_jcGsv5sM8u3mk.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/kaiseiharunoumi/v8/HI_WiZQSLqBQoAHhK_C6N_nzy_jcIj_QlMcFwmC9FAU.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/kaiseiharunoumi/v8/HI_WiZQSLqBQoAHhK_C6N_nzy_jcInfWlMcFwmC9FAU.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Kaisei Opti\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v8\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kaiseiopti/v8/QldKNThJphYb8_g6c2nlIFle7KlmxuHx.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/kaiseiopti/v8/QldXNThJphYb8_g6c2nlIGGqxY1u7f34DYwn.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/kaiseiopti/v8/QldXNThJphYb8_g6c2nlIGHiw41u7f34DYwn.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Kaisei Tokumin\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v8\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kaiseitokumin/v8/Gg8sN5wdZg7xCwuMsylww2ZiQkJf1l0pj946.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/kaiseitokumin/v8/Gg8vN5wdZg7xCwuMsylww2ZiQnqr_3khpMIzeI6v.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/kaiseitokumin/v8/Gg8vN5wdZg7xCwuMsylww2ZiQnrj-XkhpMIzeI6v.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/kaiseitokumin/v8/Gg8vN5wdZg7xCwuMsylww2ZiQnr_-nkhpMIzeI6v.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Kalam\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/kalam/v16/YA9Qr0Wd4kDdMtD6GgLLmCUItqGt.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kalam/v16/YA9dr0Wd4kDdMuhWMibDszkB.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/kalam/v16/YA9Qr0Wd4kDdMtDqHQLLmCUItqGt.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Kameron\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kameron/v15/vm82dR7vXErQxuznsL4wL-XIYH8.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/kameron/v15/vm8zdR7vXErQxuzniAIfC-3jfHb--NY.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Kanit\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"thai\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/kanit/v12/nKKX-Go6G5tXcr72GwWKcaxALFs.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/kanit/v12/nKKV-Go6G5tXcraQI2GAdY5FPFtrGw.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/kanit/v12/nKKU-Go6G5tXcr5aOiWgX6BJNUJy.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/kanit/v12/nKKS-Go6G5tXcraQI82hVaRrMFJyAu4.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/kanit/v12/nKKU-Go6G5tXcr4-OSWgX6BJNUJy.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/kanit/v12/nKKS-Go6G5tXcraQI6miVaRrMFJyAu4.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kanit/v12/nKKZ-Go6G5tXcoaSEQGodLxA.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/kanit/v12/nKKX-Go6G5tXcraQGwWKcaxALFs.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/kanit/v12/nKKU-Go6G5tXcr5mOCWgX6BJNUJy.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/kanit/v12/nKKS-Go6G5tXcraQI_GjVaRrMFJyAu4.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/kanit/v12/nKKU-Go6G5tXcr5KPyWgX6BJNUJy.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/kanit/v12/nKKS-Go6G5tXcraQI92kVaRrMFJyAu4.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/kanit/v12/nKKU-Go6G5tXcr4uPiWgX6BJNUJy.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/kanit/v12/nKKS-Go6G5tXcraQI7mlVaRrMFJyAu4.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/kanit/v12/nKKU-Go6G5tXcr4yPSWgX6BJNUJy.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/kanit/v12/nKKS-Go6G5tXcraQI6WmVaRrMFJyAu4.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/kanit/v12/nKKU-Go6G5tXcr4WPCWgX6BJNUJy.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/kanit/v12/nKKS-Go6G5tXcraQI4GnVaRrMFJyAu4.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Kantumruy\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"khmer\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-04-26\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/kantumruy/v21/syk0-yJ0m7wyVb-f4FOPUtDlpn-UJ1H6Uw.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kantumruy/v21/sykx-yJ0m7wyVb-f4FO3_vjBrlSILg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/kantumruy/v21/syk0-yJ0m7wyVb-f4FOPQtflpn-UJ1H6Uw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Kantumruy Pro\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"khmer\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v3\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/kantumruypro/v3/1q2TY5aECkp34vEBSPFOmJxwvk_pilU8OGNfyg1urUs0M34dR6dW.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/kantumruypro/v3/1q2TY5aECkp34vEBSPFOmJxwvk_pilU8OGNfyg3urEs0M34dR6dW.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/kantumruypro/v3/1q2TY5aECkp34vEBSPFOmJxwvk_pilU8OGNfyg0wrEs0M34dR6dW.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kantumruypro/v3/1q2TY5aECkp34vEBSPFOmJxwvk_pilU8OGNfyg1urEs0M34dR6dW.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/kantumruypro/v3/1q2TY5aECkp34vEBSPFOmJxwvk_pilU8OGNfyg1crEs0M34dR6dW.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/kantumruypro/v3/1q2TY5aECkp34vEBSPFOmJxwvk_pilU8OGNfyg2wq0s0M34dR6dW.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/kantumruypro/v3/1q2TY5aECkp34vEBSPFOmJxwvk_pilU8OGNfyg2Jq0s0M34dR6dW.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/kantumruypro/v3/1q2RY5aECkp34vEBSPFOmJxwlEbbdY1VU_nxzRim76N2OXo_QrdWlcU.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/kantumruypro/v3/1q2RY5aECkp34vEBSPFOmJxwlEbbdY1VU_nxzRim7yN3OXo_QrdWlcU.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/kantumruypro/v3/1q2RY5aECkp34vEBSPFOmJxwlEbbdY1VU_nxzRim7_13OXo_QrdWlcU.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/kantumruypro/v3/1q2RY5aECkp34vEBSPFOmJxwlEbbdY1VU_nxzRim76N3OXo_QrdWlcU.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/kantumruypro/v3/1q2RY5aECkp34vEBSPFOmJxwlEbbdY1VU_nxzRim75F3OXo_QrdWlcU.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/kantumruypro/v3/1q2RY5aECkp34vEBSPFOmJxwlEbbdY1VU_nxzRim731wOXo_QrdWlcU.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/kantumruypro/v3/1q2RY5aECkp34vEBSPFOmJxwlEbbdY1VU_nxzRim70RwOXo_QrdWlcU.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Karantina\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/karantina/v11/buExpo24ccnh31GVMABxXCgf-P5Oaiw4cw.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/karantina/v11/buE0po24ccnh31GVMABJ8AA78NVSYw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/karantina/v11/buExpo24ccnh31GVMABxTC8f-P5Oaiw4cw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Karla\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v23\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/karla/v23/qkBIXvYC6trAT55ZBi1ueQVIjQTDeJqqFENLR7fHGw.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/karla/v23/qkBIXvYC6trAT55ZBi1ueQVIjQTDppqqFENLR7fHGw.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/karla/v23/qkBIXvYC6trAT55ZBi1ueQVIjQTD-JqqFENLR7fHGw.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/karla/v23/qkBIXvYC6trAT55ZBi1ueQVIjQTDypqqFENLR7fHGw.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/karla/v23/qkBIXvYC6trAT55ZBi1ueQVIjQTDJp2qFENLR7fHGw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/karla/v23/qkBIXvYC6trAT55ZBi1ueQVIjQTDH52qFENLR7fHGw.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/karla/v23/qkBIXvYC6trAT55ZBi1ueQVIjQTDeJ2qFENLR7fHGw.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/karla/v23/qkBKXvYC6trAT7RQNNK2EG7SIwPWMNnCV0lPZbLXGxGR.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/karla/v23/qkBKXvYC6trAT7RQNNK2EG7SIwPWMNkcV0lPZbLXGxGR.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/karla/v23/qkBKXvYC6trAT7RQNNK2EG7SIwPWMNlCV0lPZbLXGxGR.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/karla/v23/qkBKXvYC6trAT7RQNNK2EG7SIwPWMNlwV0lPZbLXGxGR.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/karla/v23/qkBKXvYC6trAT7RQNNK2EG7SIwPWMNmcUElPZbLXGxGR.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/karla/v23/qkBKXvYC6trAT7RQNNK2EG7SIwPWMNmlUElPZbLXGxGR.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/karla/v23/qkBKXvYC6trAT7RQNNK2EG7SIwPWMNnCUElPZbLXGxGR.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Karma\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/karma/v16/va9F4kzAzMZRGLjDY8Z_uqzGQC_-.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/karma/v16/va9I4kzAzMZRGIBvS-J3kbDP.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/karma/v16/va9F4kzAzMZRGLibYsZ_uqzGQC_-.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/karma/v16/va9F4kzAzMZRGLi3ZcZ_uqzGQC_-.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/karma/v16/va9F4kzAzMZRGLjTZMZ_uqzGQC_-.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Katibeh\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/katibeh/v17/ZGjXol5MQJog4bxDaC1RVDNdGDs.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Kaushan Script\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kaushanscript/v14/vm8vdRfvXFLG3OLnsO15WYS5DF7_ytN3M48a.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Kavivanar\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"tamil\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kavivanar/v18/o-0IIpQgyXYSwhxP7_Jb4j5Ba_2c7A.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Kavoon\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kavoon/v21/pxiFyp4_scRYhlU4NLr6f1pdEQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Kdam Thmor Pro\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"khmer\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kdamthmorpro/v1/EJRPQgAzVdcI-Qdvt34jzurnGA7_j89I8ZWb.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Keania One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/keaniaone/v20/zOL54pXJk65E8pXardnuycRuv-hHkOs.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Kelly Slab\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kellyslab/v15/-W_7XJX0Rz3cxUnJC5t6TkMBf50kbiM.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Kenia\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kenia/v24/jizURE5PuHQH9qCONUGswfGM.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Khand\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/khand/v17/TwMN-IINQlQQ0bL5cFE3ZwaH__-C.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/khand/v17/TwMA-IINQlQQ0YpVWHU_TBqO.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/khand/v17/TwMN-IINQlQQ0bKhcVE3ZwaH__-C.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/khand/v17/TwMN-IINQlQQ0bKNdlE3ZwaH__-C.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/khand/v17/TwMN-IINQlQQ0bLpd1E3ZwaH__-C.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Khmer\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"khmer\"\n\t\t\t],\n\t\t\t\"version\": \"v25\",\n\t\t\t\"lastModified\": \"2022-04-26\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/khmer/v25/MjQImit_vPPwpF-BpN2EeYmD.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Khula\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/khula/v12/OpNPnoEOns3V7G-ljCvUrC59XwXD.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/khula/v12/OpNCnoEOns3V7FcJpA_chzJ0.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/khula/v12/OpNPnoEOns3V7G_RiivUrC59XwXD.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/khula/v12/OpNPnoEOns3V7G-1iyvUrC59XwXD.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/khula/v12/OpNPnoEOns3V7G-piCvUrC59XwXD.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Kings\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v5\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kings/v5/8AtnGsK4O5CYXU_Iq6GSPaHS.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Kirang Haerang\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"korean\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kiranghaerang/v20/E21-_dn_gvvIjhYON1lpIU4-bcqvWPaJq4no.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Kite One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kiteone/v20/70lQu7shLnA_E02vyq1b6HnGO4uA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Kiwi Maru\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/kiwimaru/v14/R70djykGkuuDep-hRg6gNCi0Vxn9R5ShnA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kiwimaru/v14/R70YjykGkuuDep-hRg6YmACQXzLhTg.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/kiwimaru/v14/R70djykGkuuDep-hRg6gbCm0Vxn9R5ShnA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Klee One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"600\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v7\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kleeone/v7/LDIxapCLNRc6A8oT4q4AOeekWPrP.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/kleeone/v7/LDI2apCLNRc6A8oT4pbYF8Osc-bGkqIw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Knewave\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/knewave/v14/sykz-yx0lLcxQaSItSq9-trEvlQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"KoHo\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"thai\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/koho/v16/K2FxfZ5fmddNPuE1WJ75JoKhHys.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/koho/v16/K2FzfZ5fmddNNisssJ_zIqCkDyvqZA.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/koho/v16/K2FxfZ5fmddNPoU2WJ75JoKhHys.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/koho/v16/K2FzfZ5fmddNNiss1JzzIqCkDyvqZA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/koho/v16/K2F-fZ5fmddNBikefJbSOos.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/koho/v16/K2FwfZ5fmddNNisUeLTXKou4Bg.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/koho/v16/K2FxfZ5fmddNPt03WJ75JoKhHys.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/koho/v16/K2FzfZ5fmddNNissjJ3zIqCkDyvqZA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/koho/v16/K2FxfZ5fmddNPvEwWJ75JoKhHys.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/koho/v16/K2FzfZ5fmddNNissoJrzIqCkDyvqZA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/koho/v16/K2FxfZ5fmddNPpUxWJ75JoKhHys.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/koho/v16/K2FzfZ5fmddNNissxJvzIqCkDyvqZA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Kodchasan\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"thai\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/kodchasan/v16/1cX0aUPOAJv9sG4I-DJeR1Cggeqo3eMeoA.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/kodchasan/v16/1cXqaUPOAJv9sG4I-DJWjUlIgOCs_-YOoIgN.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/kodchasan/v16/1cX0aUPOAJv9sG4I-DJeI1Oggeqo3eMeoA.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/kodchasan/v16/1cXqaUPOAJv9sG4I-DJWjUksg-Cs_-YOoIgN.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kodchasan/v16/1cXxaUPOAJv9sG4I-DJmj3uEicG01A.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/kodchasan/v16/1cX3aUPOAJv9sG4I-DJWjXGAq8Sk1PoH.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/kodchasan/v16/1cX0aUPOAJv9sG4I-DJee1Kggeqo3eMeoA.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/kodchasan/v16/1cXqaUPOAJv9sG4I-DJWjUl0guCs_-YOoIgN.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/kodchasan/v16/1cX0aUPOAJv9sG4I-DJeV1Wggeqo3eMeoA.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/kodchasan/v16/1cXqaUPOAJv9sG4I-DJWjUlYheCs_-YOoIgN.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/kodchasan/v16/1cX0aUPOAJv9sG4I-DJeM1Sggeqo3eMeoA.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/kodchasan/v16/1cXqaUPOAJv9sG4I-DJWjUk8hOCs_-YOoIgN.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Koh Santepheap\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"khmer\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v9\",\n\t\t\t\"lastModified\": \"2022-04-26\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/kohsantepheap/v9/gNMfW3p6SJbwyGj2rBZyeOrTjNuFHVyTtjNJUWU.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/kohsantepheap/v9/gNMeW3p6SJbwyGj2rBZyeOrTjNtNP3y5mD9ASHz5.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kohsantepheap/v9/gNMdW3p6SJbwyGj2rBZyeOrTjOPhF1ixsyNJ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/kohsantepheap/v9/gNMeW3p6SJbwyGj2rBZyeOrTjNtdOHy5mD9ASHz5.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/kohsantepheap/v9/gNMeW3p6SJbwyGj2rBZyeOrTjNtlOny5mD9ASHz5.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Kolker Brush\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v3\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kolkerbrush/v3/iJWDBXWRZjfKWdvmzwvvog3-7KJ6x8qNUQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Kosugi\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kosugi/v14/pxiFyp4_v8FCjlI4NLr6f1pdEQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Kosugi Maru\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kosugimaru/v14/0nksC9PgP_wGh21A2KeqGiTqivr9iBq_.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Kotta One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-04-26\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kottaone/v20/S6u_w41LXzPc_jlfNWqPHA3s5dwt7w.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Koulen\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"khmer\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v25\",\n\t\t\t\"lastModified\": \"2022-04-26\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/koulen/v25/AMOQz46as3KIBPeWgnA9kuYMUg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Kranky\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kranky/v24/hESw6XVgJzlPsFnMpheEZo_H_w.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Kreon\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v32\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/kreon/v32/t5t9IRIUKY-TFF_LW5lnMR3v2DnvPNimejUfp2dWNg.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kreon/v32/t5t9IRIUKY-TFF_LW5lnMR3v2DnvYtimejUfp2dWNg.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/kreon/v32/t5t9IRIUKY-TFF_LW5lnMR3v2DnvUNimejUfp2dWNg.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/kreon/v32/t5t9IRIUKY-TFF_LW5lnMR3v2DnvvN-mejUfp2dWNg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/kreon/v32/t5t9IRIUKY-TFF_LW5lnMR3v2Dnvhd-mejUfp2dWNg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Kristi\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-04-26\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kristi/v17/uK_y4ricdeU6zwdRCh0TMv6EXw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Krona One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kronaone/v14/jAnEgHdjHcjgfIb1ZcUCMY-h3cWkWg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Krub\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"thai\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v9\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/krub/v9/sZlEdRyC6CRYZo47KLF4R6gWaf8.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/krub/v9/sZlGdRyC6CRYbkQiwLByQ4oTef_6gQ.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/krub/v9/sZlEdRyC6CRYZuo4KLF4R6gWaf8.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/krub/v9/sZlGdRyC6CRYbkQipLNyQ4oTef_6gQ.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/krub/v9/sZlLdRyC6CRYXkYQDLlTW6E.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/krub/v9/sZlFdRyC6CRYbkQaCJtWS6EPcA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/krub/v9/sZlEdRyC6CRYZrI5KLF4R6gWaf8.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/krub/v9/sZlGdRyC6CRYbkQi_LJyQ4oTef_6gQ.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/krub/v9/sZlEdRyC6CRYZp4-KLF4R6gWaf8.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/krub/v9/sZlGdRyC6CRYbkQi0LVyQ4oTef_6gQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/krub/v9/sZlEdRyC6CRYZvo_KLF4R6gWaf8.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/krub/v9/sZlGdRyC6CRYbkQitLRyQ4oTef_6gQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Kufam\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kufam/v20/C8c-4cY7pG7w_oSJDszBXsKCcBH3lqk7qQCJHvIwYg.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/kufam/v20/C8c-4cY7pG7w_oSJDszBXsKCcBH3pKk7qQCJHvIwYg.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/kufam/v20/C8c-4cY7pG7w_oSJDszBXsKCcBH3SK47qQCJHvIwYg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/kufam/v20/C8c-4cY7pG7w_oSJDszBXsKCcBH3ca47qQCJHvIwYg.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/kufam/v20/C8c-4cY7pG7w_oSJDszBXsKCcBH3Fq47qQCJHvIwYg.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/kufam/v20/C8c-4cY7pG7w_oSJDszBXsKCcBH3P647qQCJHvIwYg.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/kufam/v20/C8c84cY7pG7w_q6APDMZN6kY3hbiXurT6gqNPPcgYp0i.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/kufam/v20/C8c84cY7pG7w_q6APDMZN6kY3hbiXurh6gqNPPcgYp0i.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/kufam/v20/C8c84cY7pG7w_q6APDMZN6kY3hbiXuoN7QqNPPcgYp0i.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/kufam/v20/C8c84cY7pG7w_q6APDMZN6kY3hbiXuo07QqNPPcgYp0i.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/kufam/v20/C8c84cY7pG7w_q6APDMZN6kY3hbiXupT7QqNPPcgYp0i.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/kufam/v20/C8c84cY7pG7w_q6APDMZN6kY3hbiXup67QqNPPcgYp0i.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Kulim Park\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/kulimpark/v14/fdN49secq3hflz1Uu3IwjJYNwa5aZbUvGjU.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/kulimpark/v14/fdNm9secq3hflz1Uu3IwhFwUKa9QYZcqCjVVUA.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/kulimpark/v14/fdN49secq3hflz1Uu3IwjPIOwa5aZbUvGjU.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/kulimpark/v14/fdNm9secq3hflz1Uu3IwhFwUTaxQYZcqCjVVUA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kulimpark/v14/fdN79secq3hflz1Uu3IwtF4m5aZxebw.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/kulimpark/v14/fdN59secq3hflz1Uu3IwhFws4YR0abw2Aw.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/kulimpark/v14/fdN49secq3hflz1Uu3IwjIYIwa5aZbUvGjU.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/kulimpark/v14/fdNm9secq3hflz1Uu3IwhFwUOapQYZcqCjVVUA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/kulimpark/v14/fdN49secq3hflz1Uu3IwjOIJwa5aZbUvGjU.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/kulimpark/v14/fdNm9secq3hflz1Uu3IwhFwUXatQYZcqCjVVUA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Kumar One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"gujarati\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kumarone/v17/bMr1mS-P958wYi6YaGeGNO6WU3oT0g.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Kumar One Outline\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"gujarati\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kumaroneoutline/v17/Noao6VH62pyLP0fsrZ-v18wlUEcX9zDwRQu8EGKF.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Kumbh Sans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/kumbhsans/v12/c4mw1n92AsfhuCq6tVsaoIx1CHIi4kToNorqSyNIXIwSP0XD.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/kumbhsans/v12/c4mw1n92AsfhuCq6tVsaoIx1CHIi4kToNopqSiNIXIwSP0XD.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/kumbhsans/v12/c4mw1n92AsfhuCq6tVsaoIx1CHIi4kToNoq0SiNIXIwSP0XD.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kumbhsans/v12/c4mw1n92AsfhuCq6tVsaoIx1CHIi4kToNorqSiNIXIwSP0XD.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/kumbhsans/v12/c4mw1n92AsfhuCq6tVsaoIx1CHIi4kToNorYSiNIXIwSP0XD.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/kumbhsans/v12/c4mw1n92AsfhuCq6tVsaoIx1CHIi4kToNoo0TSNIXIwSP0XD.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/kumbhsans/v12/c4mw1n92AsfhuCq6tVsaoIx1CHIi4kToNooNTSNIXIwSP0XD.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/kumbhsans/v12/c4mw1n92AsfhuCq6tVsaoIx1CHIi4kToNopqTSNIXIwSP0XD.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/kumbhsans/v12/c4mw1n92AsfhuCq6tVsaoIx1CHIi4kToNopDTSNIXIwSP0XD.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Kurale\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/kurale/v11/4iCs6KV9e9dXjho6eAT3v02QFg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"La Belle Aurore\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/labelleaurore/v16/RrQIbot8-mNYKnGNDkWlocovHeIIG-eFNVmULg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Lacquer\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/lacquer/v15/EYqzma1QwqpG4_BBB7-AXhttQ5I.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Laila\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/laila/v13/LYjBdG_8nE8jDLzxogNAh14nVcfe.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/laila/v13/LYjMdG_8nE8jDIRdiidIrEIu.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/laila/v13/LYjBdG_8nE8jDLypowNAh14nVcfe.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/laila/v13/LYjBdG_8nE8jDLyFpANAh14nVcfe.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/laila/v13/LYjBdG_8nE8jDLzhpQNAh14nVcfe.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Lakki Reddy\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"telugu\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/lakkireddy/v19/S6u5w49MUSzD9jlCPmvLZQfox9k97-xZ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Lalezar\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/lalezar/v14/zrfl0HLVx-HwTP82UaDyIiL0RCg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Lancelot\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/lancelot/v22/J7acnppxBGtQEulG4JY4xJ9CGyAa.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Langar\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"gurmukhi\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v26\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/langar/v26/kJEyBukW7AIlgjGVrTVZ99sqrQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Lateef\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v27\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/lateef/v27/hESz6XVnNCxEvkb0bjygbqTb9nQ-RA.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/lateef/v27/hESz6XVnNCxEvkb0Cj-gbqTb9nQ-RA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/lateef/v27/hESw6XVnNCxEvkbMpheEZo_H_w.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/lateef/v27/hESz6XVnNCxEvkb0Uj6gbqTb9nQ-RA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/lateef/v27/hESz6XVnNCxEvkb0fjmgbqTb9nQ-RA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/lateef/v27/hESz6XVnNCxEvkb0GjigbqTb9nQ-RA.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/lateef/v27/hESz6XVnNCxEvkb0BjugbqTb9nQ-RA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Lato\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"900\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v23\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/lato/v23/S6u8w4BMUTPHh30wWyWrFCbw7A.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/lato/v23/S6u-w4BMUTPHjxsIPy-vNiPg7MU0.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/lato/v23/S6u9w4BMUTPHh7USew-FGC_p9dw.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/lato/v23/S6u_w4BMUTPHjxsI9w2PHA3s5dwt7w.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/lato/v23/S6uyw4BMUTPHvxk6XweuBCY.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/lato/v23/S6u8w4BMUTPHjxswWyWrFCbw7A.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/lato/v23/S6u9w4BMUTPHh6UVew-FGC_p9dw.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/lato/v23/S6u_w4BMUTPHjxsI5wqPHA3s5dwt7w.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/lato/v23/S6u9w4BMUTPHh50Xew-FGC_p9dw.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/lato/v23/S6u_w4BMUTPHjxsI3wiPHA3s5dwt7w.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Lavishly Yours\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v2\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/lavishlyyours/v2/jizDREVIvGwH5OjiZmX9r5z_WxUY0TY7ikbI.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"League Gothic\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v6\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/leaguegothic/v6/qFdR35CBi4tvBz81xy7WG7ep-BQAY7Krj7feObpH_-amidQ6Q9hn.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"League Script\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/leaguescript/v24/CSR54zpSlumSWj9CGVsoBZdeaNNUuOwkC2s.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"League Spartan\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v6\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/leaguespartan/v6/kJEnBuEW6A0lliaV_m88ja5Twtx8BWhtkDVmjZvM_oXpBMdcFguczA.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/leaguespartan/v6/kJEnBuEW6A0lliaV_m88ja5Twtx8BWhtkDVmjZvMfoTpBMdcFguczA.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/leaguespartan/v6/kJEnBuEW6A0lliaV_m88ja5Twtx8BWhtkDVmjZvMoITpBMdcFguczA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/leaguespartan/v6/kJEnBuEW6A0lliaV_m88ja5Twtx8BWhtkDVmjZvM_oTpBMdcFguczA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/leaguespartan/v6/kJEnBuEW6A0lliaV_m88ja5Twtx8BWhtkDVmjZvMzITpBMdcFguczA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/leaguespartan/v6/kJEnBuEW6A0lliaV_m88ja5Twtx8BWhtkDVmjZvMIIPpBMdcFguczA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/leaguespartan/v6/kJEnBuEW6A0lliaV_m88ja5Twtx8BWhtkDVmjZvMGYPpBMdcFguczA.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/leaguespartan/v6/kJEnBuEW6A0lliaV_m88ja5Twtx8BWhtkDVmjZvMfoPpBMdcFguczA.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/leaguespartan/v6/kJEnBuEW6A0lliaV_m88ja5Twtx8BWhtkDVmjZvMV4PpBMdcFguczA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Leckerli One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/leckerlione/v16/V8mCoQH8VCsNttEnxnGQ-1itLZxcBtItFw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Ledger\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ledger/v16/j8_q6-HK1L3if_sxm8DwHTBhHw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Lekton\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/lekton/v17/SZc43FDmLaWmWpBeXxfonUPL6Q.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/lekton/v17/SZc63FDmLaWmWpBuXR3sv0bb6StO.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/lekton/v17/SZc73FDmLaWmWpBm4zjMlWjX4DJXgQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Lemon\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/lemon/v14/HI_EiYEVKqRMq0jBSZXAQ4-d.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Lemonada\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/lemonada/v22/0QI-MXFD9oygTWy_R-FFlwV-bgfR7QJGJOt2mfWc3Z2pTg.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/lemonada/v22/0QI-MXFD9oygTWy_R-FFlwV-bgfR7QJGeut2mfWc3Z2pTg.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/lemonada/v22/0QI-MXFD9oygTWy_R-FFlwV-bgfR7QJGSOt2mfWc3Z2pTg.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/lemonada/v22/0QI-MXFD9oygTWy_R-FFlwV-bgfR7QJGpOx2mfWc3Z2pTg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/lemonada/v22/0QI-MXFD9oygTWy_R-FFlwV-bgfR7QJGnex2mfWc3Z2pTg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Lexend\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/lexend/v17/wlptgwvFAVdoq2_F94zlCfv0bz1WCzsX_LBte6KuGEo.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/lexend/v17/wlptgwvFAVdoq2_F94zlCfv0bz1WC7sW_LBte6KuGEo.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/lexend/v17/wlptgwvFAVdoq2_F94zlCfv0bz1WC2UW_LBte6KuGEo.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/lexend/v17/wlptgwvFAVdoq2_F94zlCfv0bz1WCzsW_LBte6KuGEo.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/lexend/v17/wlptgwvFAVdoq2_F94zlCfv0bz1WCwkW_LBte6KuGEo.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/lexend/v17/wlptgwvFAVdoq2_F94zlCfv0bz1WC-UR_LBte6KuGEo.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/lexend/v17/wlptgwvFAVdoq2_F94zlCfv0bz1WC9wR_LBte6KuGEo.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/lexend/v17/wlptgwvFAVdoq2_F94zlCfv0bz1WC7sR_LBte6KuGEo.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/lexend/v17/wlptgwvFAVdoq2_F94zlCfv0bz1WC5IR_LBte6KuGEo.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Lexend Deca\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/lexenddeca/v17/K2FifZFYk-dHSE0UPPuwQ7CrD94i-NCKm-U48MxArBPCqLNflg.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/lexenddeca/v17/K2FifZFYk-dHSE0UPPuwQ7CrD94i-NCKm-U4cM1ArBPCqLNflg.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/lexenddeca/v17/K2FifZFYk-dHSE0UPPuwQ7CrD94i-NCKm-U4rs1ArBPCqLNflg.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/lexenddeca/v17/K2FifZFYk-dHSE0UPPuwQ7CrD94i-NCKm-U48M1ArBPCqLNflg.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/lexenddeca/v17/K2FifZFYk-dHSE0UPPuwQ7CrD94i-NCKm-U4ws1ArBPCqLNflg.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/lexenddeca/v17/K2FifZFYk-dHSE0UPPuwQ7CrD94i-NCKm-U4LspArBPCqLNflg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/lexenddeca/v17/K2FifZFYk-dHSE0UPPuwQ7CrD94i-NCKm-U4F8pArBPCqLNflg.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/lexenddeca/v17/K2FifZFYk-dHSE0UPPuwQ7CrD94i-NCKm-U4cMpArBPCqLNflg.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/lexenddeca/v17/K2FifZFYk-dHSE0UPPuwQ7CrD94i-NCKm-U4WcpArBPCqLNflg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Lexend Exa\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/lexendexa/v24/UMBCrPdOoHOnxExyjdBeQCH18mulUxBvI9r7T6bHHJ8BRq0b.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/lexendexa/v24/UMBCrPdOoHOnxExyjdBeQCH18mulUxBvI9p7TqbHHJ8BRq0b.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/lexendexa/v24/UMBCrPdOoHOnxExyjdBeQCH18mulUxBvI9qlTqbHHJ8BRq0b.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/lexendexa/v24/UMBCrPdOoHOnxExyjdBeQCH18mulUxBvI9r7TqbHHJ8BRq0b.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/lexendexa/v24/UMBCrPdOoHOnxExyjdBeQCH18mulUxBvI9rJTqbHHJ8BRq0b.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/lexendexa/v24/UMBCrPdOoHOnxExyjdBeQCH18mulUxBvI9olSabHHJ8BRq0b.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/lexendexa/v24/UMBCrPdOoHOnxExyjdBeQCH18mulUxBvI9ocSabHHJ8BRq0b.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/lexendexa/v24/UMBCrPdOoHOnxExyjdBeQCH18mulUxBvI9p7SabHHJ8BRq0b.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/lexendexa/v24/UMBCrPdOoHOnxExyjdBeQCH18mulUxBvI9pSSabHHJ8BRq0b.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Lexend Giga\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/lexendgiga/v24/PlIuFl67Mah5Y8yMHE7lkUZPlTBo4MWFfNRC2LmE68oo6eepYQ.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/lexendgiga/v24/PlIuFl67Mah5Y8yMHE7lkUZPlTBo4MWFfNRCWLiE68oo6eepYQ.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/lexendgiga/v24/PlIuFl67Mah5Y8yMHE7lkUZPlTBo4MWFfNRChriE68oo6eepYQ.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/lexendgiga/v24/PlIuFl67Mah5Y8yMHE7lkUZPlTBo4MWFfNRC2LiE68oo6eepYQ.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/lexendgiga/v24/PlIuFl67Mah5Y8yMHE7lkUZPlTBo4MWFfNRC6riE68oo6eepYQ.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/lexendgiga/v24/PlIuFl67Mah5Y8yMHE7lkUZPlTBo4MWFfNRCBr-E68oo6eepYQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/lexendgiga/v24/PlIuFl67Mah5Y8yMHE7lkUZPlTBo4MWFfNRCP7-E68oo6eepYQ.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/lexendgiga/v24/PlIuFl67Mah5Y8yMHE7lkUZPlTBo4MWFfNRCWL-E68oo6eepYQ.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/lexendgiga/v24/PlIuFl67Mah5Y8yMHE7lkUZPlTBo4MWFfNRCcb-E68oo6eepYQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Lexend Mega\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/lexendmega/v24/qFdX35aBi5JtHD41zSTFEuTByuvYFuE9IbDL8fivveyiq9EqQw.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/lexendmega/v24/qFdX35aBi5JtHD41zSTFEuTByuvYFuE9IbDLcfmvveyiq9EqQw.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/lexendmega/v24/qFdX35aBi5JtHD41zSTFEuTByuvYFuE9IbDLr_mvveyiq9EqQw.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/lexendmega/v24/qFdX35aBi5JtHD41zSTFEuTByuvYFuE9IbDL8fmvveyiq9EqQw.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/lexendmega/v24/qFdX35aBi5JtHD41zSTFEuTByuvYFuE9IbDLw_mvveyiq9EqQw.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/lexendmega/v24/qFdX35aBi5JtHD41zSTFEuTByuvYFuE9IbDLL_6vveyiq9EqQw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/lexendmega/v24/qFdX35aBi5JtHD41zSTFEuTByuvYFuE9IbDLFv6vveyiq9EqQw.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/lexendmega/v24/qFdX35aBi5JtHD41zSTFEuTByuvYFuE9IbDLcf6vveyiq9EqQw.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/lexendmega/v24/qFdX35aBi5JtHD41zSTFEuTByuvYFuE9IbDLWP6vveyiq9EqQw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Lexend Peta\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/lexendpeta/v24/BXR4vFPGjeLPh0kCfI4OkFX-UTQHSCaxvBgR6SFyW1YuRTsnfw.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/lexendpeta/v24/BXR4vFPGjeLPh0kCfI4OkFX-UTQHSCaxvBgRaSByW1YuRTsnfw.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/lexendpeta/v24/BXR4vFPGjeLPh0kCfI4OkFX-UTQHSCaxvBgRtyByW1YuRTsnfw.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/lexendpeta/v24/BXR4vFPGjeLPh0kCfI4OkFX-UTQHSCaxvBgR6SByW1YuRTsnfw.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/lexendpeta/v24/BXR4vFPGjeLPh0kCfI4OkFX-UTQHSCaxvBgR2yByW1YuRTsnfw.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/lexendpeta/v24/BXR4vFPGjeLPh0kCfI4OkFX-UTQHSCaxvBgRNydyW1YuRTsnfw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/lexendpeta/v24/BXR4vFPGjeLPh0kCfI4OkFX-UTQHSCaxvBgRDidyW1YuRTsnfw.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/lexendpeta/v24/BXR4vFPGjeLPh0kCfI4OkFX-UTQHSCaxvBgRaSdyW1YuRTsnfw.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/lexendpeta/v24/BXR4vFPGjeLPh0kCfI4OkFX-UTQHSCaxvBgRQCdyW1YuRTsnfw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Lexend Tera\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/lexendtera/v24/RrQDbo98_jt_IXnBPwCWtYJLZ3P4hnaGKFiM5zITdpz0fYxcrQ.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/lexendtera/v24/RrQDbo98_jt_IXnBPwCWtYJLZ3P4hnaGKFiMZzMTdpz0fYxcrQ.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/lexendtera/v24/RrQDbo98_jt_IXnBPwCWtYJLZ3P4hnaGKFiMuTMTdpz0fYxcrQ.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/lexendtera/v24/RrQDbo98_jt_IXnBPwCWtYJLZ3P4hnaGKFiM5zMTdpz0fYxcrQ.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/lexendtera/v24/RrQDbo98_jt_IXnBPwCWtYJLZ3P4hnaGKFiM1TMTdpz0fYxcrQ.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/lexendtera/v24/RrQDbo98_jt_IXnBPwCWtYJLZ3P4hnaGKFiMOTQTdpz0fYxcrQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/lexendtera/v24/RrQDbo98_jt_IXnBPwCWtYJLZ3P4hnaGKFiMADQTdpz0fYxcrQ.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/lexendtera/v24/RrQDbo98_jt_IXnBPwCWtYJLZ3P4hnaGKFiMZzQTdpz0fYxcrQ.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/lexendtera/v24/RrQDbo98_jt_IXnBPwCWtYJLZ3P4hnaGKFiMTjQTdpz0fYxcrQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Lexend Zetta\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/lexendzetta/v24/ll8uK2KYXje7CdOFnEWcU8synQbuVYjYB3BCy9bH0z5jbs8qbts.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/lexendzetta/v24/ll8uK2KYXje7CdOFnEWcU8synQbuVYjYB3BCy1bG0z5jbs8qbts.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/lexendzetta/v24/ll8uK2KYXje7CdOFnEWcU8synQbuVYjYB3BCy4jG0z5jbs8qbts.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/lexendzetta/v24/ll8uK2KYXje7CdOFnEWcU8synQbuVYjYB3BCy9bG0z5jbs8qbts.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/lexendzetta/v24/ll8uK2KYXje7CdOFnEWcU8synQbuVYjYB3BCy-TG0z5jbs8qbts.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/lexendzetta/v24/ll8uK2KYXje7CdOFnEWcU8synQbuVYjYB3BCywjB0z5jbs8qbts.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/lexendzetta/v24/ll8uK2KYXje7CdOFnEWcU8synQbuVYjYB3BCyzHB0z5jbs8qbts.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/lexendzetta/v24/ll8uK2KYXje7CdOFnEWcU8synQbuVYjYB3BCy1bB0z5jbs8qbts.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/lexendzetta/v24/ll8uK2KYXje7CdOFnEWcU8synQbuVYjYB3BCy3_B0z5jbs8qbts.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Libre Barcode 128\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v26\",\n\t\t\t\"lastModified\": \"2022-04-26\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/librebarcode128/v26/cIfnMbdUsUoiW3O_hVviCwVjuLtXeJ_A_gMk0izH.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Libre Barcode 128 Text\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v26\",\n\t\t\t\"lastModified\": \"2022-04-26\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/librebarcode128text/v26/fdNv9tubt3ZEnz1Gu3I4-zppwZ9CWZ16Z0w5cV3Y6M90w4k.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Libre Barcode 39\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-04-26\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/librebarcode39/v19/-nFnOHM08vwC6h8Li1eQnP_AHzI2K_d709jy92k.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Libre Barcode 39 Extended\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v25\",\n\t\t\t\"lastModified\": \"2022-04-26\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/librebarcode39extended/v25/8At7Gt6_O5yNS0-K4Nf5U922qSzhJ3dUdfJpwNUgfNRCOZ1GOBw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Libre Barcode 39 Extended Text\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v25\",\n\t\t\t\"lastModified\": \"2022-04-26\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/librebarcode39extendedtext/v25/eLG1P_rwIgOiDA7yrs9LoKaYRVLQ1YldrrOnnL7xPO4jNP68fLIiPopNNA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Libre Barcode 39 Text\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v26\",\n\t\t\t\"lastModified\": \"2022-04-26\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/librebarcode39text/v26/sJoa3KhViNKANw_E3LwoDXvs5Un0HQ1vT-031RRL-9rYaw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Libre Barcode EAN13 Text\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-04-26\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/librebarcodeean13text/v19/wlpigxXFDU1_oCu9nfZytgIqSG0XRcJm_OQiB96PAGEki52WfA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Libre Baskerville\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/librebaskerville/v14/kmKnZrc3Hgbbcjq75U4uslyuy4kn0pNeYRI4CN2V.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/librebaskerville/v14/kmKhZrc3Hgbbcjq75U4uslyuy4kn0qNcaxYaDc2V2ro.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/librebaskerville/v14/kmKiZrc3Hgbbcjq75U4uslyuy4kn0qviTjYwI8Gcw6Oi.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Libre Bodoni\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v3\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/librebodoni/v3/_Xm--H45qDWDYULr5OfyZudXzSBgY2oMBGte6I1fwWzZcOb3U3s.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/librebodoni/v3/_Xm--H45qDWDYULr5OfyZudXzSBgY2oMBGte6L9fwWzZcOb3U3s.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/librebodoni/v3/_Xm--H45qDWDYULr5OfyZudXzSBgY2oMBGte6FNYwWzZcOb3U3s.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/librebodoni/v3/_Xm--H45qDWDYULr5OfyZudXzSBgY2oMBGte6GpYwWzZcOb3U3s.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/librebodoni/v3/_Xm4-H45qDWDYULr5OfyZud9xBKfuwNnnsVZ_UUcKS_TdMTyQ3syLg.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/librebodoni/v3/_Xm4-H45qDWDYULr5OfyZud9xBKfuwNnnsVZ_UUcGy_TdMTyQ3syLg.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/librebodoni/v3/_Xm4-H45qDWDYULr5OfyZud9xBKfuwNnnsVZ_UUc9yjTdMTyQ3syLg.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/librebodoni/v3/_Xm4-H45qDWDYULr5OfyZud9xBKfuwNnnsVZ_UUczijTdMTyQ3syLg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Libre Caslon Display\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/librecaslondisplay/v14/TuGOUUFxWphYQ6YI6q9Xp61FQzxDRKmzr2lRdRhtCC4d.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Libre Caslon Text\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v3\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/librecaslontext/v3/DdT878IGsGw1aF1JU10PUbTvNNaDMcq_3eNrHgO1.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/librecaslontext/v3/DdT678IGsGw1aF1JU10PUbTvNNaDMfq91-dJGxO1q9o.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/librecaslontext/v3/DdT578IGsGw1aF1JU10PUbTvNNaDMfID8sdjNR-8ssPt.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Libre Franklin\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/librefranklin/v13/jizOREVItHgc8qDIbSTKq4XkRg8T88bjFuXOnduhLsSUB9rIb-JH1g.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/librefranklin/v13/jizOREVItHgc8qDIbSTKq4XkRg8T88bjFuXOnduhrsWUB9rIb-JH1g.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/librefranklin/v13/jizOREVItHgc8qDIbSTKq4XkRg8T88bjFuXOnduhcMWUB9rIb-JH1g.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/librefranklin/v13/jizOREVItHgc8qDIbSTKq4XkRg8T88bjFuXOnduhLsWUB9rIb-JH1g.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/librefranklin/v13/jizOREVItHgc8qDIbSTKq4XkRg8T88bjFuXOnduhHMWUB9rIb-JH1g.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/librefranklin/v13/jizOREVItHgc8qDIbSTKq4XkRg8T88bjFuXOnduh8MKUB9rIb-JH1g.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/librefranklin/v13/jizOREVItHgc8qDIbSTKq4XkRg8T88bjFuXOnduhycKUB9rIb-JH1g.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/librefranklin/v13/jizOREVItHgc8qDIbSTKq4XkRg8T88bjFuXOnduhrsKUB9rIb-JH1g.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/librefranklin/v13/jizOREVItHgc8qDIbSTKq4XkRg8T88bjFuXOnduhh8KUB9rIb-JH1g.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/librefranklin/v13/jizMREVItHgc8qDIbSTKq4XkRiUawTk7f45UM9y05oZ8RdDMTedX1sGE.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/librefranklin/v13/jizMREVItHgc8qDIbSTKq4XkRiUawTk7f45UM9y05ob8RNDMTedX1sGE.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/librefranklin/v13/jizMREVItHgc8qDIbSTKq4XkRiUawTk7f45UM9y05oYiRNDMTedX1sGE.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/librefranklin/v13/jizMREVItHgc8qDIbSTKq4XkRiUawTk7f45UM9y05oZ8RNDMTedX1sGE.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/librefranklin/v13/jizMREVItHgc8qDIbSTKq4XkRiUawTk7f45UM9y05oZORNDMTedX1sGE.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/librefranklin/v13/jizMREVItHgc8qDIbSTKq4XkRiUawTk7f45UM9y05oaiQ9DMTedX1sGE.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/librefranklin/v13/jizMREVItHgc8qDIbSTKq4XkRiUawTk7f45UM9y05oabQ9DMTedX1sGE.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/librefranklin/v13/jizMREVItHgc8qDIbSTKq4XkRiUawTk7f45UM9y05ob8Q9DMTedX1sGE.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/librefranklin/v13/jizMREVItHgc8qDIbSTKq4XkRiUawTk7f45UM9y05obVQ9DMTedX1sGE.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Licorice\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v3\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/licorice/v3/t5tjIR8TMomTCAyjNk23hqLgzCHu.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Life Savers\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/lifesavers/v18/ZXuie1UftKKabUQMgxAal_lrFgpbuNvB.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/lifesavers/v18/ZXu_e1UftKKabUQMgxAal8HXOS5Tk8fIpPRW.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/lifesavers/v18/ZXu_e1UftKKabUQMgxAal8HLOi5Tk8fIpPRW.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Lilita One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/lilitaone/v13/i7dPIFZ9Zz-WBtRtedDbUEZ2RFq7AwU.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Lily Script One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/lilyscriptone/v15/LhW9MV7ZMfIPdMxeBjBvFN8SXLS4gsSjQNsRMg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Limelight\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/limelight/v16/XLYkIZL7aopJVbZJHDuYPeNGrnY2TA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Linden Hill\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/lindenhill/v22/-F61fjxoKSg9Yc3hZgO8ygFI7CwC009k.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/lindenhill/v22/-F63fjxoKSg9Yc3hZgO8yjFK5igg1l9kn-s.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Literata\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v30\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/literata/v30/or3PQ6P12-iJxAIgLa78DkrbXsDgk0oVDaDPYLanFLHpPf2TbJG_F_bcTWCWp8g.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/literata/v30/or3PQ6P12-iJxAIgLa78DkrbXsDgk0oVDaDPYLanFLHpPf2TbE-_F_bcTWCWp8g.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/literata/v30/or3PQ6P12-iJxAIgLa78DkrbXsDgk0oVDaDPYLanFLHpPf2TbBG_F_bcTWCWp8g.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/literata/v30/or3PQ6P12-iJxAIgLa78DkrbXsDgk0oVDaDPYLanFLHpPf2TbCO_F_bcTWCWp8g.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/literata/v30/or3PQ6P12-iJxAIgLa78DkrbXsDgk0oVDaDPYLanFLHpPf2TbM-4F_bcTWCWp8g.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/literata/v30/or3PQ6P12-iJxAIgLa78DkrbXsDgk0oVDaDPYLanFLHpPf2TbPa4F_bcTWCWp8g.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/literata/v30/or3PQ6P12-iJxAIgLa78DkrbXsDgk0oVDaDPYLanFLHpPf2TbJG4F_bcTWCWp8g.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/literata/v30/or3PQ6P12-iJxAIgLa78DkrbXsDgk0oVDaDPYLanFLHpPf2TbLi4F_bcTWCWp8g.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/literata/v30/or3NQ6P12-iJxAIgLYT1PLs1Zd0nfUwAbeGVKoRYzNiCp1OUedn8f7XWSUKTt8iVow.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/literata/v30/or3NQ6P12-iJxAIgLYT1PLs1Zd0nfUwAbeGVKoRYzNiCp1OUedn8obXWSUKTt8iVow.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/literata/v30/or3NQ6P12-iJxAIgLYT1PLs1Zd0nfUwAbeGVKoRYzNiCp1OUedn8_7XWSUKTt8iVow.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/literata/v30/or3NQ6P12-iJxAIgLYT1PLs1Zd0nfUwAbeGVKoRYzNiCp1OUedn8zbXWSUKTt8iVow.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/literata/v30/or3NQ6P12-iJxAIgLYT1PLs1Zd0nfUwAbeGVKoRYzNiCp1OUedn8IbLWSUKTt8iVow.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/literata/v30/or3NQ6P12-iJxAIgLYT1PLs1Zd0nfUwAbeGVKoRYzNiCp1OUedn8GLLWSUKTt8iVow.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/literata/v30/or3NQ6P12-iJxAIgLYT1PLs1Zd0nfUwAbeGVKoRYzNiCp1OUedn8f7LWSUKTt8iVow.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/literata/v30/or3NQ6P12-iJxAIgLYT1PLs1Zd0nfUwAbeGVKoRYzNiCp1OUedn8VrLWSUKTt8iVow.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Liu Jian Mao Cao\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"chinese-simplified\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/liujianmaocao/v15/~ChIKEExpdSBKaWFuIE1hbyBDYW8gACoECAEYAQ==.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Livvic\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"900\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/livvic/v13/rnCr-x1S2hzjrlffC-M-mHnOSOuk.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/livvic/v13/rnCt-x1S2hzjrlfXbdtakn3sTfukQHs.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/livvic/v13/rnCq-x1S2hzjrlffp8IeslfCQfK9WQ.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/livvic/v13/rnCs-x1S2hzjrlfXbdv2s13GY_etWWIJ.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/livvic/v13/rnCq-x1S2hzjrlffw8EeslfCQfK9WQ.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/livvic/v13/rnCs-x1S2hzjrlfXbduSsF3GY_etWWIJ.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/livvic/v13/rnCp-x1S2hzjrlfnb-k6unzeSA.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/livvic/v13/rnCr-x1S2hzjrlfXbeM-mHnOSOuk.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/livvic/v13/rnCq-x1S2hzjrlffm8AeslfCQfK9WQ.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/livvic/v13/rnCs-x1S2hzjrlfXbdvKsV3GY_etWWIJ.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/livvic/v13/rnCq-x1S2hzjrlfft8ceslfCQfK9WQ.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/livvic/v13/rnCs-x1S2hzjrlfXbdvmtl3GY_etWWIJ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/livvic/v13/rnCq-x1S2hzjrlff08YeslfCQfK9WQ.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/livvic/v13/rnCs-x1S2hzjrlfXbduCt13GY_etWWIJ.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/livvic/v13/rnCq-x1S2hzjrlff68QeslfCQfK9WQ.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/livvic/v13/rnCs-x1S2hzjrlfXbdu6tV3GY_etWWIJ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Lobster\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v28\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/lobster/v28/neILzCirqoswsqX9_oWsMqEzSJQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Lobster Two\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/lobstertwo/v18/BngMUXZGTXPUvIoyV6yN59fK7KSJ4ACD.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/lobstertwo/v18/BngOUXZGTXPUvIoyV6yN5-fI5qCr5RCDY_k.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/lobstertwo/v18/BngRUXZGTXPUvIoyV6yN5-92w4CByxyKeuDp.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/lobstertwo/v18/BngTUXZGTXPUvIoyV6yN5-fI3hyEwRiof_DpXMY.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Londrina Outline\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v23\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/londrinaoutline/v23/C8c44dM8vmb14dfsZxhetg3pDH-SfuoxrSKMDvI.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Londrina Shadow\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/londrinashadow/v22/oPWX_kB4kOQoWNJmjxLV5JuoCUlXRlaSxkrMCQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Londrina Sketch\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/londrinasketch/v21/c4m41npxGMTnomOHtRU68eIJn8qfWWn5Pos6CA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Londrina Solid\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/londrinasolid/v15/flUjRq6sw40kQEJxWNgkLuudGfs9KBYesZHhV64.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/londrinasolid/v15/flUiRq6sw40kQEJxWNgkLuudGfv1CjY0n53oTrcL.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/londrinasolid/v15/flUhRq6sw40kQEJxWNgkLuudGcNZIhI8tIHh.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/londrinasolid/v15/flUiRq6sw40kQEJxWNgkLuudGfvdDzY0n53oTrcL.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Long Cang\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"chinese-simplified\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/longcang/v17/LYjAdGP8kkgoTec8zkRgrXArXN7HWQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Lora\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v26\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/lora/v26/0QI6MX1D_JOuGQbT0gvTJPa787weuyJGmKxemMeZ.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/lora/v26/0QI6MX1D_JOuGQbT0gvTJPa787wsuyJGmKxemMeZ.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/lora/v26/0QI6MX1D_JOuGQbT0gvTJPa787zAvCJGmKxemMeZ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/lora/v26/0QI6MX1D_JOuGQbT0gvTJPa787z5vCJGmKxemMeZ.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/lora/v26/0QI8MX1D_JOuMw_hLdO6T2wV9KnW-MoFkqh8ndeZzZ0.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/lora/v26/0QI8MX1D_JOuMw_hLdO6T2wV9KnW-PgFkqh8ndeZzZ0.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/lora/v26/0QI8MX1D_JOuMw_hLdO6T2wV9KnW-BQCkqh8ndeZzZ0.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/lora/v26/0QI8MX1D_JOuMw_hLdO6T2wV9KnW-C0Ckqh8ndeZzZ0.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Love Light\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v3\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/lovelight/v3/t5tlIR0TNJyZWimpNAXDjKbCyTHuspo.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Love Ya Like A Sister\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/loveyalikeasister/v16/R70EjzUBlOqPeouhFDfR80-0FhOqJubN-Be78nZcsGGycA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Loved by the King\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/lovedbytheking/v17/Gw6gwdP76VDVJNXerebZxUMeRXUF2PiNlXFu2R64.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Lovers Quarrel\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/loversquarrel/v21/Yq6N-LSKXTL-5bCy8ksBzpQ_-zAsY7pO6siz.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Luckiest Guy\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/luckiestguy/v18/_gP_1RrxsjcxVyin9l9n_j2RStR3qDpraA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Lusitana\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/lusitana/v13/CSR84z9ShvucWzsMKxhaRuMiSct_.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/lusitana/v13/CSR74z9ShvucWzsMKyDmaccqYtd2vfwk.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Lustria\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/lustria/v13/9oRONYodvDEyjuhOrCg5MtPyAcg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Luxurious Roman\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v3\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/luxuriousroman/v3/buEupou_ZcP1w0yTKxJJokVSmbpqYgckeo9RMw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Luxurious Script\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v5\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/luxuriousscript/v5/ahcCv9e7yydulT32KZ0rBIoD7DzMg0rOby1JtYk.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"M PLUS 1\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v6\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/mplus1/v6/R70EjygA28ymD4HgBUGzkN5Eyoj-WpW5VSe78nZcsGGycA.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/mplus1/v6/R70EjygA28ymD4HgBUGzkN5Eyoj-WpW51Sa78nZcsGGycA.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/mplus1/v6/R70EjygA28ymD4HgBUGzkN5Eyoj-WpW5Cya78nZcsGGycA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/mplus1/v6/R70EjygA28ymD4HgBUGzkN5Eyoj-WpW5VSa78nZcsGGycA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/mplus1/v6/R70EjygA28ymD4HgBUGzkN5Eyoj-WpW5Zya78nZcsGGycA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/mplus1/v6/R70EjygA28ymD4HgBUGzkN5Eyoj-WpW5iyG78nZcsGGycA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/mplus1/v6/R70EjygA28ymD4HgBUGzkN5Eyoj-WpW5siG78nZcsGGycA.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/mplus1/v6/R70EjygA28ymD4HgBUGzkN5Eyoj-WpW51SG78nZcsGGycA.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/mplus1/v6/R70EjygA28ymD4HgBUGzkN5Eyoj-WpW5_CG78nZcsGGycA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"M PLUS 1 Code\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v7\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/mplus1code/v7/ypvMbXOOx2xFpzmYJS3N2_J2hBN6RZ5oIp8m_7iN0XHpapwmdZhY.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/mplus1code/v7/ypvMbXOOx2xFpzmYJS3N2_J2hBN6RZ5oIp8m_7gN0HHpapwmdZhY.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/mplus1code/v7/ypvMbXOOx2xFpzmYJS3N2_J2hBN6RZ5oIp8m_7jT0HHpapwmdZhY.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/mplus1code/v7/ypvMbXOOx2xFpzmYJS3N2_J2hBN6RZ5oIp8m_7iN0HHpapwmdZhY.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/mplus1code/v7/ypvMbXOOx2xFpzmYJS3N2_J2hBN6RZ5oIp8m_7i_0HHpapwmdZhY.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/mplus1code/v7/ypvMbXOOx2xFpzmYJS3N2_J2hBN6RZ5oIp8m_7hT13HpapwmdZhY.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/mplus1code/v7/ypvMbXOOx2xFpzmYJS3N2_J2hBN6RZ5oIp8m_7hq13HpapwmdZhY.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"M PLUS 1p\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v27\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/mplus1p/v27/e3tleuShHdiFyPFzBRrQnDQAUW3aq-5N.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/mplus1p/v27/e3tmeuShHdiFyPFzBRrQVBYge0PWovdU4w.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/mplus1p/v27/e3tjeuShHdiFyPFzBRro-D4Ec2jKqw.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/mplus1p/v27/e3tmeuShHdiFyPFzBRrQDBcge0PWovdU4w.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/mplus1p/v27/e3tmeuShHdiFyPFzBRrQRBEge0PWovdU4w.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/mplus1p/v27/e3tmeuShHdiFyPFzBRrQWBIge0PWovdU4w.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/mplus1p/v27/e3tmeuShHdiFyPFzBRrQfBMge0PWovdU4w.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"M PLUS 2\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v6\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/mplus2/v6/7Auhp_Eq3gO_OGbGGhjdwrDdpeIBxlkwOa-VxlqHrzNgAw.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/mplus2/v6/7Auhp_Eq3gO_OGbGGhjdwrDdpeIBxlkwua6VxlqHrzNgAw.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/mplus2/v6/7Auhp_Eq3gO_OGbGGhjdwrDdpeIBxlkwZ66VxlqHrzNgAw.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/mplus2/v6/7Auhp_Eq3gO_OGbGGhjdwrDdpeIBxlkwOa6VxlqHrzNgAw.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/mplus2/v6/7Auhp_Eq3gO_OGbGGhjdwrDdpeIBxlkwC66VxlqHrzNgAw.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/mplus2/v6/7Auhp_Eq3gO_OGbGGhjdwrDdpeIBxlkw56mVxlqHrzNgAw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/mplus2/v6/7Auhp_Eq3gO_OGbGGhjdwrDdpeIBxlkw3qmVxlqHrzNgAw.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/mplus2/v6/7Auhp_Eq3gO_OGbGGhjdwrDdpeIBxlkwuamVxlqHrzNgAw.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/mplus2/v6/7Auhp_Eq3gO_OGbGGhjdwrDdpeIBxlkwkKmVxlqHrzNgAw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"M PLUS Code Latin\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v7\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/mpluscodelatin/v7/hv-ylyV-aXg7x7tULiNXXBA0Np4WMS8fDIymHY8fy8wn4_ifLAtrObKDO0Xf1EbB6i5MqF9TRwg.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/mpluscodelatin/v7/hv-ylyV-aXg7x7tULiNXXBA0Np4WMS8fDIymHY8fy8wn4_ifLAtrObKDO0Xf1MbA6i5MqF9TRwg.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/mpluscodelatin/v7/hv-ylyV-aXg7x7tULiNXXBA0Np4WMS8fDIymHY8fy8wn4_ifLAtrObKDO0Xf1BjA6i5MqF9TRwg.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/mpluscodelatin/v7/hv-ylyV-aXg7x7tULiNXXBA0Np4WMS8fDIymHY8fy8wn4_ifLAtrObKDO0Xf1EbA6i5MqF9TRwg.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/mpluscodelatin/v7/hv-ylyV-aXg7x7tULiNXXBA0Np4WMS8fDIymHY8fy8wn4_ifLAtrObKDO0Xf1HTA6i5MqF9TRwg.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/mpluscodelatin/v7/hv-ylyV-aXg7x7tULiNXXBA0Np4WMS8fDIymHY8fy8wn4_ifLAtrObKDO0Xf1JjH6i5MqF9TRwg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/mpluscodelatin/v7/hv-ylyV-aXg7x7tULiNXXBA0Np4WMS8fDIymHY8fy8wn4_ifLAtrObKDO0Xf1KHH6i5MqF9TRwg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"M PLUS Rounded 1c\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/mplusrounded1c/v15/VdGCAYIAV6gnpUpoWwNkYvrugw9RuM3ixLsg6-av1x0.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/mplusrounded1c/v15/VdGBAYIAV6gnpUpoWwNkYvrugw9RuM0q5psKxeqmzgRK.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/mplusrounded1c/v15/VdGEAYIAV6gnpUpoWwNkYvrugw9RuPWGzr8C7vav.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/mplusrounded1c/v15/VdGBAYIAV6gnpUpoWwNkYvrugw9RuM1y55sKxeqmzgRK.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/mplusrounded1c/v15/VdGBAYIAV6gnpUpoWwNkYvrugw9RuM064ZsKxeqmzgRK.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/mplusrounded1c/v15/VdGBAYIAV6gnpUpoWwNkYvrugw9RuM0m4psKxeqmzgRK.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/mplusrounded1c/v15/VdGBAYIAV6gnpUpoWwNkYvrugw9RuM0C45sKxeqmzgRK.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Ma Shan Zheng\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"chinese-simplified\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/mashanzheng/v10/NaPecZTRCLxvwo41b4gvzkXaRMTsDIRSfr0.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Macondo\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/macondo/v21/RrQQboN9-iB1IXmOS2XO0LBBd4Y.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Macondo Swash Caps\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/macondoswashcaps/v20/6NUL8EaAJgGKZA7lpt941Z9s6ZYgDq6Oekoa_mm5bA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Mada\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/mada/v18/7Au_p_0qnzeSdf3nCCL8zkwMIFg.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/mada/v18/7Au_p_0qnzeSdZnkCCL8zkwMIFg.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/mada/v18/7Auwp_0qnzeSTTXMLCrX0kU.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/mada/v18/7Au_p_0qnzeSdcHlCCL8zkwMIFg.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/mada/v18/7Au_p_0qnzeSde3iCCL8zkwMIFg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/mada/v18/7Au_p_0qnzeSdYnjCCL8zkwMIFg.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/mada/v18/7Au_p_0qnzeSdbHhCCL8zkwMIFg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Magra\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/magra/v14/uK_94ruaZus72k5xIDMfO-ed.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/magra/v14/uK_w4ruaZus72nbNDxcXEPuUX1ow.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Maiden Orange\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v25\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/maidenorange/v25/kJE1BuIX7AUmhi2V4m08kb1XjOZdCZS8FY8.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Maitree\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"thai\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/maitree/v10/MjQDmil5tffhpBrklhGNWJGovLdh6OE.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/maitree/v10/MjQDmil5tffhpBrklnWOWJGovLdh6OE.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/maitree/v10/MjQGmil5tffhpBrkrtmmfJmDoL4.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/maitree/v10/MjQDmil5tffhpBrkli2PWJGovLdh6OE.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/maitree/v10/MjQDmil5tffhpBrklgGIWJGovLdh6OE.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/maitree/v10/MjQDmil5tffhpBrklmWJWJGovLdh6OE.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Major Mono Display\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/majormonodisplay/v12/RWmVoLyb5fEqtsfBX9PDZIGr2tFubRhLCn2QIndPww.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"monospace\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Mako\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/mako/v18/H4coBX6Mmc_Z0ST09g478Lo.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Mali\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"thai\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v9\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/mali/v9/N0bV2SRONuN4QOLlKlRaJdbWgdY.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/mali/v9/N0bX2SRONuN4SCj8wlVQIfTTkdbJYA.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/mali/v9/N0bV2SRONuN4QIbmKlRaJdbWgdY.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/mali/v9/N0bX2SRONuN4SCj8plZQIfTTkdbJYA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/mali/v9/N0ba2SRONuN4eCrODlxxOd8.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/mali/v9/N0bU2SRONuN4SCjECn50Kd_PmA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/mali/v9/N0bV2SRONuN4QN7nKlRaJdbWgdY.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/mali/v9/N0bX2SRONuN4SCj8_ldQIfTTkdbJYA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/mali/v9/N0bV2SRONuN4QPLgKlRaJdbWgdY.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/mali/v9/N0bX2SRONuN4SCj80lBQIfTTkdbJYA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/mali/v9/N0bV2SRONuN4QJbhKlRaJdbWgdY.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/mali/v9/N0bX2SRONuN4SCj8tlFQIfTTkdbJYA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Mallanna\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"telugu\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-04-26\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/mallanna/v13/hv-Vlzx-KEQb84YaDGwzEzRwVvJ-.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Mandali\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"telugu\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-04-26\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/mandali/v14/LhWlMVbYOfASNfNUVFk1ZPdcKtA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Manjari\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"malayalam\"\n\t\t\t],\n\t\t\t\"version\": \"v9\",\n\t\t\t\"lastModified\": \"2022-04-26\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/manjari/v9/k3kSo8UPMOBO2w1UdbroK2vFIaOV8A.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/manjari/v9/k3kQo8UPMOBO2w1UTd7iL0nAMaM.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/manjari/v9/k3kVo8UPMOBO2w1UdWLNC0HrLaqM6Q4.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Manrope\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/manrope/v13/xn7_YHE41ni1AdIRqAuZuw1Bx9mbZk59FO_F87jxeN7B.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/manrope/v13/xn7_YHE41ni1AdIRqAuZuw1Bx9mbZk6jFO_F87jxeN7B.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/manrope/v13/xn7_YHE41ni1AdIRqAuZuw1Bx9mbZk79FO_F87jxeN7B.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/manrope/v13/xn7_YHE41ni1AdIRqAuZuw1Bx9mbZk7PFO_F87jxeN7B.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/manrope/v13/xn7_YHE41ni1AdIRqAuZuw1Bx9mbZk4jE-_F87jxeN7B.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/manrope/v13/xn7_YHE41ni1AdIRqAuZuw1Bx9mbZk4aE-_F87jxeN7B.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/manrope/v13/xn7_YHE41ni1AdIRqAuZuw1Bx9mbZk59E-_F87jxeN7B.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Mansalva\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"greek\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/mansalva/v12/aWB4m0aacbtDfvq5NJllI47vdyBg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Manuale\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v23\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/manuale/v23/f0Xp0eas_8Z-TFZdHv3mMxFaSqASeeG6e7wD1TB_JHHY.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/manuale/v23/f0Xp0eas_8Z-TFZdHv3mMxFaSqASeeHke7wD1TB_JHHY.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/manuale/v23/f0Xp0eas_8Z-TFZdHv3mMxFaSqASeeHWe7wD1TB_JHHY.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/manuale/v23/f0Xp0eas_8Z-TFZdHv3mMxFaSqASeeE6fLwD1TB_JHHY.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/manuale/v23/f0Xp0eas_8Z-TFZdHv3mMxFaSqASeeEDfLwD1TB_JHHY.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/manuale/v23/f0Xp0eas_8Z-TFZdHv3mMxFaSqASeeFkfLwD1TB_JHHY.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/manuale/v23/f0Xn0eas_8Z-TFZdNPTUzMkzITq8fvQsOApA3zRdIWHYr8M.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/manuale/v23/f0Xn0eas_8Z-TFZdNPTUzMkzITq8fvQsOFRA3zRdIWHYr8M.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/manuale/v23/f0Xn0eas_8Z-TFZdNPTUzMkzITq8fvQsOGZA3zRdIWHYr8M.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/manuale/v23/f0Xn0eas_8Z-TFZdNPTUzMkzITq8fvQsOIpH3zRdIWHYr8M.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/manuale/v23/f0Xn0eas_8Z-TFZdNPTUzMkzITq8fvQsOLNH3zRdIWHYr8M.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/manuale/v23/f0Xn0eas_8Z-TFZdNPTUzMkzITq8fvQsONRH3zRdIWHYr8M.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Marcellus\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/marcellus/v13/wEO_EBrOk8hQLDvIAF8FUfAL3EsHiA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Marcellus SC\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/marcellussc/v13/ke8iOgUHP1dg-Rmi6RWjbLEPgdydGKikhA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Marck Script\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/marckscript/v16/nwpTtK2oNgBA3Or78gapdwuCzyI-aMPF7Q.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Margarine\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/margarine/v21/qkBXXvoE6trLT9Y7YLye5JRLkAXbMQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Marhey\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v3\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/marhey/v3/x3d8ck7Laq-T7wl7mqfVrEe9sDvtBZVwO2cXiGevOMw.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/marhey/v3/x3d8ck7Laq-T7wl7mqfVrEe9sDvtBctwO2cXiGevOMw.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/marhey/v3/x3d8ck7Laq-T7wl7mqfVrEe9sDvtBflwO2cXiGevOMw.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/marhey/v3/x3d8ck7Laq-T7wl7mqfVrEe9sDvtBRV3O2cXiGevOMw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/marhey/v3/x3d8ck7Laq-T7wl7mqfVrEe9sDvtBSx3O2cXiGevOMw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Markazi Text\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/markazitext/v22/sykh-ydym6AtQaiEtX7yhqb_rV1k_81ZVYYZtfSQT4MlBekmJLo.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/markazitext/v22/sykh-ydym6AtQaiEtX7yhqb_rV1k_81ZVYYZtcaQT4MlBekmJLo.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/markazitext/v22/sykh-ydym6AtQaiEtX7yhqb_rV1k_81ZVYYZtSqXT4MlBekmJLo.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/markazitext/v22/sykh-ydym6AtQaiEtX7yhqb_rV1k_81ZVYYZtROXT4MlBekmJLo.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Marko One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-04-26\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/markoone/v22/9Btq3DFG0cnVM5lw1haaKpUfrHPzUw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Marmelad\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/marmelad/v17/Qw3eZQdSHj_jK2e-8tFLG-YMC0R8.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Martel\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/martel/v10/PN_yRfK9oXHga0XVqekahRbX9vnDzw.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/martel/v10/PN_yRfK9oXHga0XVzeoahRbX9vnDzw.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/martel/v10/PN_xRfK9oXHga0XtYcI-jT3L_w.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/martel/v10/PN_yRfK9oXHga0XVuewahRbX9vnDzw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/martel/v10/PN_yRfK9oXHga0XV3e0ahRbX9vnDzw.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/martel/v10/PN_yRfK9oXHga0XVwe4ahRbX9vnDzw.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/martel/v10/PN_yRfK9oXHga0XV5e8ahRbX9vnDzw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Martel Sans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/martelsans/v12/h0GxssGi7VdzDgKjM-4d8hAX5suHFUknqMxQ.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/martelsans/v12/h0GxssGi7VdzDgKjM-4d8hBz5cuHFUknqMxQ.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/martelsans/v12/h0GsssGi7VdzDgKjM-4d8ijfze-PPlUu.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/martelsans/v12/h0GxssGi7VdzDgKjM-4d8hAH48uHFUknqMxQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/martelsans/v12/h0GxssGi7VdzDgKjM-4d8hBj4suHFUknqMxQ.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/martelsans/v12/h0GxssGi7VdzDgKjM-4d8hB_4cuHFUknqMxQ.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/martelsans/v12/h0GxssGi7VdzDgKjM-4d8hBb4MuHFUknqMxQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Martian Mono\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/martianmono/v1/2V08KIcADoYhV6w87xrTKjs4CYElh_VS9YA4TlTnQzaVMIE6j15dYY1qus6WD75kdpF2.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/martianmono/v1/2V08KIcADoYhV6w87xrTKjs4CYElh_VS9YA4TlTnQzaVMIE6j15dYY3qu86WD75kdpF2.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/martianmono/v1/2V08KIcADoYhV6w87xrTKjs4CYElh_VS9YA4TlTnQzaVMIE6j15dYY00u86WD75kdpF2.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/martianmono/v1/2V08KIcADoYhV6w87xrTKjs4CYElh_VS9YA4TlTnQzaVMIE6j15dYY1qu86WD75kdpF2.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/martianmono/v1/2V08KIcADoYhV6w87xrTKjs4CYElh_VS9YA4TlTnQzaVMIE6j15dYY1Yu86WD75kdpF2.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/martianmono/v1/2V08KIcADoYhV6w87xrTKjs4CYElh_VS9YA4TlTnQzaVMIE6j15dYY20vM6WD75kdpF2.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/martianmono/v1/2V08KIcADoYhV6w87xrTKjs4CYElh_VS9YA4TlTnQzaVMIE6j15dYY2NvM6WD75kdpF2.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/martianmono/v1/2V08KIcADoYhV6w87xrTKjs4CYElh_VS9YA4TlTnQzaVMIE6j15dYY3qvM6WD75kdpF2.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"monospace\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Marvel\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/marvel/v14/nwpVtKeoNgBV0qaIkV7ED366zg.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/marvel/v14/nwpXtKeoNgBV0qa4k1TALXuqzhA7.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/marvel/v14/nwpWtKeoNgBV0qawLXHgB1WmxwkiYQ.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/marvel/v14/nwpQtKeoNgBV0qa4k2x8Al-i5QwyYdrc.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Mate\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/mate/v14/m8JdjftRd7WZ2z28WoXSaLU.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/mate/v14/m8JTjftRd7WZ6z-2XqfXeLVdbw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Mate SC\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/matesc/v21/-nF8OGQ1-uoVr2wKyiXZ95OkJwA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Maven Pro\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v32\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/mavenpro/v32/7Auup_AqnyWWAxW2Wk3swUz56MS91Eww8SX25nCpozp5GvU.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/mavenpro/v32/7Auup_AqnyWWAxW2Wk3swUz56MS91Eww8Rf25nCpozp5GvU.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/mavenpro/v32/7Auup_AqnyWWAxW2Wk3swUz56MS91Eww8fvx5nCpozp5GvU.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/mavenpro/v32/7Auup_AqnyWWAxW2Wk3swUz56MS91Eww8cLx5nCpozp5GvU.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/mavenpro/v32/7Auup_AqnyWWAxW2Wk3swUz56MS91Eww8aXx5nCpozp5GvU.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/mavenpro/v32/7Auup_AqnyWWAxW2Wk3swUz56MS91Eww8Yzx5nCpozp5GvU.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"McLaren\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/mclaren/v13/2EbnL-ZuAXFqZFXISYYf8z2Yt_c.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Mea Culpa\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v3\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/meaculpa/v3/AMOTz4GcuWbEIuza8jsZms0QW3mqyg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Meddon\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/meddon/v20/kmK8ZqA2EgDNeHTZhBdB3y_Aow.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"MedievalSharp\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/medievalsharp/v24/EvOJzAlL3oU5AQl2mP5KdgptAq96MwvXLDk.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Medula One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/medulaone/v19/YA9Wr0qb5kjJM6l2V0yukiEqs7GtlvY.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Meera Inimai\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"tamil\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-04-26\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/meerainimai/v12/845fNMM5EIqOW5MPuvO3ILep_2jDVevnLQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Megrim\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/megrim/v16/46kulbz5WjvLqJZlbWXgd0RY1g.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Meie Script\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/meiescript/v21/_LOImzDK7erRjhunIspaMjxn5IXg0WDz.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Meow Script\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v5\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/meowscript/v5/0FlQVPqanlaJrtr8AnJ0ESch0_0CfDf1.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Merienda\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/merienda/v17/gNMaW3x8Qoy5_mf8uUkJGHtiYXjmKFy5JHhoSU78QGBV0A.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/merienda/v17/gNMaW3x8Qoy5_mf8uUkJGHtiYXjmKFy5enhoSU78QGBV0A.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/merienda/v17/gNMaW3x8Qoy5_mf8uUkJGHtiYXjmKFy5SHhoSU78QGBV0A.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/merienda/v17/gNMaW3x8Qoy5_mf8uUkJGHtiYXjmKFy5pH9oSU78QGBV0A.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/merienda/v17/gNMaW3x8Qoy5_mf8uUkJGHtiYXjmKFy5nX9oSU78QGBV0A.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/merienda/v17/gNMaW3x8Qoy5_mf8uUkJGHtiYXjmKFy5-n9oSU78QGBV0A.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/merienda/v17/gNMaW3x8Qoy5_mf8uUkJGHtiYXjmKFy5039oSU78QGBV0A.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Merienda One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/meriendaone/v16/H4cgBXaMndbflEq6kyZ1ht6YgoyyYzFzFw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Merriweather\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"900\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v30\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/merriweather/v30/u-4n0qyriQwlOrhSvowK_l521wRpX837pvjxPA.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/merriweather/v30/u-4l0qyriQwlOrhSvowK_l5-eR7lXcf_hP3hPGWH.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/merriweather/v30/u-440qyriQwlOrhSvowK_l5OeyxNV-bnrw.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/merriweather/v30/u-4m0qyriQwlOrhSvowK_l5-eSZJdeP3r-Ho.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/merriweather/v30/u-4n0qyriQwlOrhSvowK_l52xwNpX837pvjxPA.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/merriweather/v30/u-4l0qyriQwlOrhSvowK_l5-eR71Wsf_hP3hPGWH.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/merriweather/v30/u-4n0qyriQwlOrhSvowK_l52_wFpX837pvjxPA.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/merriweather/v30/u-4l0qyriQwlOrhSvowK_l5-eR7NWMf_hP3hPGWH.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Merriweather Sans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/merriweathersans/v22/2-cO9IRs1JiJN1FRAMjTN5zd9vgsFF_5asQTb6hZ2JKZ_O4ljuEG7xFHnQ.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/merriweathersans/v22/2-cO9IRs1JiJN1FRAMjTN5zd9vgsFF_5asQTb6hZ2JKZou4ljuEG7xFHnQ.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/merriweathersans/v22/2-cO9IRs1JiJN1FRAMjTN5zd9vgsFF_5asQTb6hZ2JKZkO4ljuEG7xFHnQ.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/merriweathersans/v22/2-cO9IRs1JiJN1FRAMjTN5zd9vgsFF_5asQTb6hZ2JKZfOkljuEG7xFHnQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/merriweathersans/v22/2-cO9IRs1JiJN1FRAMjTN5zd9vgsFF_5asQTb6hZ2JKZRekljuEG7xFHnQ.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/merriweathersans/v22/2-cO9IRs1JiJN1FRAMjTN5zd9vgsFF_5asQTb6hZ2JKZIukljuEG7xFHnQ.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/merriweathersans/v22/2-cM9IRs1JiJN1FRAMjTN5zd9vgsFHXwWDvLBsPDdpWMaq2TzesCzRRXnaur.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/merriweathersans/v22/2-cM9IRs1JiJN1FRAMjTN5zd9vgsFHXwWDvLBsPDdpWMaq3NzesCzRRXnaur.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/merriweathersans/v22/2-cM9IRs1JiJN1FRAMjTN5zd9vgsFHXwWDvLBsPDdpWMaq3_zesCzRRXnaur.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/merriweathersans/v22/2-cM9IRs1JiJN1FRAMjTN5zd9vgsFHXwWDvLBsPDdpWMaq0TyusCzRRXnaur.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/merriweathersans/v22/2-cM9IRs1JiJN1FRAMjTN5zd9vgsFHXwWDvLBsPDdpWMaq0qyusCzRRXnaur.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/merriweathersans/v22/2-cM9IRs1JiJN1FRAMjTN5zd9vgsFHXwWDvLBsPDdpWMaq1NyusCzRRXnaur.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Metal\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"khmer\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v28\",\n\t\t\t\"lastModified\": \"2022-04-26\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/metal/v28/lW-wwjUJIXTo7i3nnoQAUdN2.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Metal Mania\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/metalmania/v22/RWmMoKWb4e8kqMfBUdPFJeXCg6UKDXlq.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Metamorphous\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/metamorphous/v18/Wnz8HA03aAXcC39ZEX5y1330PCCthTsmaQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Metrophobic\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/metrophobic/v19/sJoA3LZUhMSAPV_u0qwiAT-J737FPEEL.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Michroma\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/michroma/v16/PN_zRfy9qWD8fEagAMg6rzjb_-Da.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Milonga\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/milonga/v20/SZc53FHnIaK9W5kffz3GkUrS8DI.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Miltonian\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v26\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/miltonian/v26/zOL-4pbPn6Ne9JqTg9mr6e5As-FeiQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Miltonian Tattoo\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v28\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/miltoniantattoo/v28/EvOUzBRL0o0kCxF-lcMCQxlpVsA_FwP8MDBku-s.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Mina\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"bengali\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/mina/v11/-nFzOGc18vARrz9j7i3y65o.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/mina/v11/-nF8OGc18vARl4NMyiXZ95OkJwA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Mingzat\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"lepcha\"\n\t\t\t],\n\t\t\t\"version\": \"v2\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/mingzat/v2/0QIgMX5C-o-oWWyvBttkm_mv670.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Miniver\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/miniver/v21/eLGcP-PxIg-5H0vC770Cy8r8fWA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Miriam Libre\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/miriamlibre/v13/DdTh798HsHwubBAqfkcBTL_vYJn_Teun9g.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/miriamlibre/v13/DdT-798HsHwubBAqfkcBTL_X3LbbRcC7_-Z7Hg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Mirza\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/mirza/v15/co3ImWlikiN5EurdKMewsrvI.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/mirza/v15/co3FmWlikiN5EtIpAeO4mafBomDi.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/mirza/v15/co3FmWlikiN5EtIFBuO4mafBomDi.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/mirza/v15/co3FmWlikiN5EtJhB-O4mafBomDi.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Miss Fajardose\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/missfajardose/v22/E21-_dn5gvrawDdPFVl-N0Ajb8qvWPaJq4no.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Mitr\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"thai\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/mitr/v11/pxiEypw5ucZF8fMZFJDUc1NECPY.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/mitr/v11/pxiEypw5ucZF8ZcaFJDUc1NECPY.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/mitr/v11/pxiLypw5ucZFyTsyMJj_b1o.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/mitr/v11/pxiEypw5ucZF8c8bFJDUc1NECPY.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/mitr/v11/pxiEypw5ucZF8eMcFJDUc1NECPY.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/mitr/v11/pxiEypw5ucZF8YcdFJDUc1NECPY.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Mochiy Pop One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v7\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/mochiypopone/v7/QdVPSTA9Jh-gg-5XZP2UmU4O9kwwD3s6ZKAi.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Mochiy Pop P One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v7\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/mochiypoppone/v7/Ktk2AKuPeY_td1-h9LayHYWCjAqyN4O3WYZB_sU.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Modak\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/modak/v18/EJRYQgs1XtIEsnMH8BVZ76KU.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Modern Antiqua\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/modernantiqua/v22/NGStv5TIAUg6Iq_RLNo_2dp1sI1Ea2u0c3Gi.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Mogra\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"gujarati\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/mogra/v19/f0X40eSs8c95TBo4DvLmxtnG.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Mohave\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v8\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/mohave/v8/7cH0v4ksjJunKqMVAOPIMOeSmiojdif_HvCQopLSvBk.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/mohave/v8/7cH0v4ksjJunKqMVAOPIMOeSmiojdnn_HvCQopLSvBk.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/mohave/v8/7cH0v4ksjJunKqMVAOPIMOeSmiojdkv_HvCQopLSvBk.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/mohave/v8/7cH0v4ksjJunKqMVAOPIMOeSmiojdqf4HvCQopLSvBk.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/mohave/v8/7cH0v4ksjJunKqMVAOPIMOeSmiojdp74HvCQopLSvBk.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/mohave/v8/7cH2v4ksjJunKqM_CdE36I75AIQkY7G8qLOaprDXrBlSVw.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/mohave/v8/7cH2v4ksjJunKqM_CdE36I75AIQkY7G89rOaprDXrBlSVw.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/mohave/v8/7cH2v4ksjJunKqM_CdE36I75AIQkY7G8xLOaprDXrBlSVw.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/mohave/v8/7cH2v4ksjJunKqM_CdE36I75AIQkY7G8KLSaprDXrBlSVw.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/mohave/v8/7cH2v4ksjJunKqM_CdE36I75AIQkY7G8EbSaprDXrBlSVw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Molengo\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/molengo/v16/I_uuMpWeuBzZNBtQbbRQkiCvs5Y.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Molle\",\n\t\t\t\"variants\": [\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-04-26\",\n\t\t\t\"files\": {\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/molle/v21/E21n_dL5hOXFhWEsXzgmVydREus.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Monda\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/monda/v16/TK3tWkYFABsmjvpmNBsLvPdG.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/monda/v16/TK3gWkYFABsmjsLaGz8Dl-tPKo2t.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Monofett\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/monofett/v22/mFTyWbofw6zc9NtnW43SuRwr0VJ7.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Monoton\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/monoton/v15/5h1aiZUrOngCibe4fkbBQ2S7FU8.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Monsieur La Doulaise\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/monsieurladoulaise/v14/_Xmz-GY4rjmCbQfc-aPRaa4pqV340p7EZl5ewkEU4HTy.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Montaga\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/montaga/v13/H4cnBX2Ml8rCkEO_0gYQ7LO5mqc.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Montagu Slab\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v6\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/montaguslab/v6/6qLhKZIQtB_zv0xUaXRDWkY_HXsphdLRZF40vm_jzR2jhk_n3T6ACkDbE3P9Fs7bOSO7.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/montaguslab/v6/6qLhKZIQtB_zv0xUaXRDWkY_HXsphdLRZF40vm_jzR2jhk_n3T6ACkBbEnP9Fs7bOSO7.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/montaguslab/v6/6qLhKZIQtB_zv0xUaXRDWkY_HXsphdLRZF40vm_jzR2jhk_n3T6ACkCFEnP9Fs7bOSO7.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/montaguslab/v6/6qLhKZIQtB_zv0xUaXRDWkY_HXsphdLRZF40vm_jzR2jhk_n3T6ACkDbEnP9Fs7bOSO7.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/montaguslab/v6/6qLhKZIQtB_zv0xUaXRDWkY_HXsphdLRZF40vm_jzR2jhk_n3T6ACkDpEnP9Fs7bOSO7.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/montaguslab/v6/6qLhKZIQtB_zv0xUaXRDWkY_HXsphdLRZF40vm_jzR2jhk_n3T6ACkAFFXP9Fs7bOSO7.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/montaguslab/v6/6qLhKZIQtB_zv0xUaXRDWkY_HXsphdLRZF40vm_jzR2jhk_n3T6ACkA8FXP9Fs7bOSO7.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"MonteCarlo\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v7\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/montecarlo/v7/buEzpo6-f9X01GadLA0G0CoV_NxLeiw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Montez\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/montez/v18/845ZNMk5GoGIX8lm1LDeSd-R_g.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Montserrat\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v25\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCtr6Uw-Y3tcoqK5.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCvr6Ew-Y3tcoqK5.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCs16Ew-Y3tcoqK5.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCtr6Ew-Y3tcoqK5.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCtZ6Ew-Y3tcoqK5.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCu170w-Y3tcoqK5.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCuM70w-Y3tcoqK5.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCvr70w-Y3tcoqK5.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCvC70w-Y3tcoqK5.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/montserrat/v25/JTUFjIg1_i6t8kCHKm459Wx7xQYXK0vOoz6jq6R8aX9-p7K5ILg.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/montserrat/v25/JTUFjIg1_i6t8kCHKm459Wx7xQYXK0vOoz6jqyR9aX9-p7K5ILg.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/montserrat/v25/JTUFjIg1_i6t8kCHKm459Wx7xQYXK0vOoz6jq_p9aX9-p7K5ILg.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/montserrat/v25/JTUFjIg1_i6t8kCHKm459Wx7xQYXK0vOoz6jq6R9aX9-p7K5ILg.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/montserrat/v25/JTUFjIg1_i6t8kCHKm459Wx7xQYXK0vOoz6jq5Z9aX9-p7K5ILg.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/montserrat/v25/JTUFjIg1_i6t8kCHKm459Wx7xQYXK0vOoz6jq3p6aX9-p7K5ILg.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/montserrat/v25/JTUFjIg1_i6t8kCHKm459Wx7xQYXK0vOoz6jq0N6aX9-p7K5ILg.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/montserrat/v25/JTUFjIg1_i6t8kCHKm459Wx7xQYXK0vOoz6jqyR6aX9-p7K5ILg.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/montserrat/v25/JTUFjIg1_i6t8kCHKm459Wx7xQYXK0vOoz6jqw16aX9-p7K5ILg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Montserrat Alternates\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/montserratalternates/v17/mFThWacfw6zH4dthXcyms1lPpC8I_b0juU0xiKfVKphL03l4.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/montserratalternates/v17/mFTjWacfw6zH4dthXcyms1lPpC8I_b0juU057p-xIJxp1ml4imo.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/montserratalternates/v17/mFTiWacfw6zH4dthXcyms1lPpC8I_b0juU0xJIb1ALZH2mBhkw.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/montserratalternates/v17/mFTkWacfw6zH4dthXcyms1lPpC8I_b0juU057p8dAbxD-GVxk3Nd.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/montserratalternates/v17/mFTiWacfw6zH4dthXcyms1lPpC8I_b0juU0xQIX1ALZH2mBhkw.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/montserratalternates/v17/mFTkWacfw6zH4dthXcyms1lPpC8I_b0juU057p95ArxD-GVxk3Nd.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/montserratalternates/v17/mFTvWacfw6zH4dthXcyms1lPpC8I_b0juU0J7K3RCJ1b0w.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/montserratalternates/v17/mFThWacfw6zH4dthXcyms1lPpC8I_b0juU057qfVKphL03l4.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/montserratalternates/v17/mFTiWacfw6zH4dthXcyms1lPpC8I_b0juU0xGIT1ALZH2mBhkw.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/montserratalternates/v17/mFTkWacfw6zH4dthXcyms1lPpC8I_b0juU057p8hA7xD-GVxk3Nd.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/montserratalternates/v17/mFTiWacfw6zH4dthXcyms1lPpC8I_b0juU0xNIP1ALZH2mBhkw.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/montserratalternates/v17/mFTkWacfw6zH4dthXcyms1lPpC8I_b0juU057p8NBLxD-GVxk3Nd.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/montserratalternates/v17/mFTiWacfw6zH4dthXcyms1lPpC8I_b0juU0xUIL1ALZH2mBhkw.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/montserratalternates/v17/mFTkWacfw6zH4dthXcyms1lPpC8I_b0juU057p9pBbxD-GVxk3Nd.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/montserratalternates/v17/mFTiWacfw6zH4dthXcyms1lPpC8I_b0juU0xTIH1ALZH2mBhkw.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/montserratalternates/v17/mFTkWacfw6zH4dthXcyms1lPpC8I_b0juU057p91BrxD-GVxk3Nd.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/montserratalternates/v17/mFTiWacfw6zH4dthXcyms1lPpC8I_b0juU0xaID1ALZH2mBhkw.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/montserratalternates/v17/mFTkWacfw6zH4dthXcyms1lPpC8I_b0juU057p9RB7xD-GVxk3Nd.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Montserrat Subrayada\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/montserratsubrayada/v17/U9MD6c-o9H7PgjlTHThBnNHGVUORwteQQE8LYuceqGT-.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/montserratsubrayada/v17/U9MM6c-o9H7PgjlTHThBnNHGVUORwteQQHe3TcMWg3j36Ebz.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Moo Lah Lah\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v3\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/moolahlah/v3/dg4h_p_opKZOA0w1AYcm55wtYQYugjW4.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Moon Dance\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v3\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/moondance/v3/WBLgrEbUbFlYW9ekmGawe2XiKMiokE4.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Moul\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"khmer\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v25\",\n\t\t\t\"lastModified\": \"2022-04-26\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/moul/v25/nuF2D__FSo_3E-RYiJCy-00.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Moulpali\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"khmer\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v28\",\n\t\t\t\"lastModified\": \"2022-04-26\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/moulpali/v28/H4ckBXKMl9HagUWymyY6wr-wg763.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Mountains of Christmas\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/mountainsofchristmas/v20/3y9w6a4zcCnn5X0FDyrKi2ZRUBIy8uxoUo7ePNamMPNpJpc.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/mountainsofchristmas/v20/3y9z6a4zcCnn5X0FDyrKi2ZRUBIy8uxoUo7eBGqJFPtCOp6IaEA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Mouse Memoirs\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/mousememoirs/v13/t5tmIRoSNJ-PH0WNNgDYxdSb7TnFrpOHYh4.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Mr Bedfort\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/mrbedfort/v21/MQpR-WCtNZSWAdTMwBicliq0XZe_Iy8.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Mr Dafoe\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/mrdafoe/v14/lJwE-pIzkS5NXuMMrGiqg7MCxz_C.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Mr De Haviland\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/mrdehaviland/v14/OpNVnooIhJj96FdB73296ksbOj3C4ULVNTlB.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Mrs Saint Delafield\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/mrssaintdelafield/v13/v6-IGZDIOVXH9xtmTZfRagunqBw5WC62cK4tLsubB2w.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Mrs Sheppards\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/mrssheppards/v21/PN_2Rfm9snC0XUGoEZhb91ig3vjxynMix4Y.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Ms Madi\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v2\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/msmadi/v2/HTxsL2UxNnOji5E1N-DPiI7QAYo.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Mukta\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/mukta/v13/iJWHBXyXfDDVXbEOjFma-2HW7ZB_.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/mukta/v13/iJWHBXyXfDDVXbFqj1ma-2HW7ZB_.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/mukta/v13/iJWKBXyXfDDVXYnGp32S0H3f.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/mukta/v13/iJWHBXyXfDDVXbEyjlma-2HW7ZB_.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/mukta/v13/iJWHBXyXfDDVXbEeiVma-2HW7ZB_.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/mukta/v13/iJWHBXyXfDDVXbF6iFma-2HW7ZB_.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/mukta/v13/iJWHBXyXfDDVXbFmi1ma-2HW7ZB_.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Mukta Mahee\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"gurmukhi\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/muktamahee/v15/XRXN3IOIi0hcP8iVU67hA9MFcBoHJndqZCsW.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/muktamahee/v15/XRXN3IOIi0hcP8iVU67hA9NhcxoHJndqZCsW.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/muktamahee/v15/XRXQ3IOIi0hcP8iVU67hA-vNWz4PDWtj.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/muktamahee/v15/XRXN3IOIi0hcP8iVU67hA9M5choHJndqZCsW.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/muktamahee/v15/XRXN3IOIi0hcP8iVU67hA9MVdRoHJndqZCsW.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/muktamahee/v15/XRXN3IOIi0hcP8iVU67hA9NxdBoHJndqZCsW.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/muktamahee/v15/XRXN3IOIi0hcP8iVU67hA9NtdxoHJndqZCsW.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Mukta Malar\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"tamil\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/muktamalar/v12/MCoKzAXyz8LOE2FpJMxZqIMwBtAB62ruoAZW.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/muktamalar/v12/MCoKzAXyz8LOE2FpJMxZqINUBdAB62ruoAZW.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/muktamalar/v12/MCoXzAXyz8LOE2FpJMxZqLv4LfQJwHbn.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/muktamalar/v12/MCoKzAXyz8LOE2FpJMxZqIMMBNAB62ruoAZW.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/muktamalar/v12/MCoKzAXyz8LOE2FpJMxZqIMgA9AB62ruoAZW.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/muktamalar/v12/MCoKzAXyz8LOE2FpJMxZqINEAtAB62ruoAZW.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/muktamalar/v12/MCoKzAXyz8LOE2FpJMxZqINYAdAB62ruoAZW.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Mukta Vaani\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"gujarati\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/muktavaani/v13/3JnkSD_-ynaxmxnEfVHPIGXNV8BD-u97MW1a.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/muktavaani/v13/3JnkSD_-ynaxmxnEfVHPIGWpVMBD-u97MW1a.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/muktavaani/v13/3Jn5SD_-ynaxmxnEfVHPIF0FfORL0fNy.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/muktavaani/v13/3JnkSD_-ynaxmxnEfVHPIGXxVcBD-u97MW1a.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/muktavaani/v13/3JnkSD_-ynaxmxnEfVHPIGXdUsBD-u97MW1a.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/muktavaani/v13/3JnkSD_-ynaxmxnEfVHPIGW5U8BD-u97MW1a.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/muktavaani/v13/3JnkSD_-ynaxmxnEfVHPIGWlUMBD-u97MW1a.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Mulish\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/mulish/v12/1Ptyg83HX_SGhgqO0yLcmjzUAuWexRNRwaClGrw-PTY.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/mulish/v12/1Ptyg83HX_SGhgqO0yLcmjzUAuWexc1RwaClGrw-PTY.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/mulish/v12/1Ptyg83HX_SGhgqO0yLcmjzUAuWexZNRwaClGrw-PTY.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/mulish/v12/1Ptyg83HX_SGhgqO0yLcmjzUAuWexaFRwaClGrw-PTY.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/mulish/v12/1Ptyg83HX_SGhgqO0yLcmjzUAuWexU1WwaClGrw-PTY.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/mulish/v12/1Ptyg83HX_SGhgqO0yLcmjzUAuWexXRWwaClGrw-PTY.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/mulish/v12/1Ptyg83HX_SGhgqO0yLcmjzUAuWexRNWwaClGrw-PTY.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/mulish/v12/1Ptyg83HX_SGhgqO0yLcmjzUAuWexTpWwaClGrw-PTY.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/mulish/v12/1Ptwg83HX_SGhgqk2hAjQlW_mEuZ0FsSqeOvHp47LTZFwA.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/mulish/v12/1Ptwg83HX_SGhgqk2hAjQlW_mEuZ0FsSd-OvHp47LTZFwA.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/mulish/v12/1Ptwg83HX_SGhgqk2hAjQlW_mEuZ0FsSKeOvHp47LTZFwA.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/mulish/v12/1Ptwg83HX_SGhgqk2hAjQlW_mEuZ0FsSG-OvHp47LTZFwA.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/mulish/v12/1Ptwg83HX_SGhgqk2hAjQlW_mEuZ0FsS9-SvHp47LTZFwA.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/mulish/v12/1Ptwg83HX_SGhgqk2hAjQlW_mEuZ0FsSzuSvHp47LTZFwA.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/mulish/v12/1Ptwg83HX_SGhgqk2hAjQlW_mEuZ0FsSqeSvHp47LTZFwA.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/mulish/v12/1Ptwg83HX_SGhgqk2hAjQlW_mEuZ0FsSgOSvHp47LTZFwA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Murecho\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v6\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/murecho/v6/q5uYsoq3NOBn_I-ggCJg98TBOoNFCMpr5HWZLCpUOaM6.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/murecho/v6/q5uYsoq3NOBn_I-ggCJg98TBOoNFCMrr5XWZLCpUOaM6.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/murecho/v6/q5uYsoq3NOBn_I-ggCJg98TBOoNFCMo15XWZLCpUOaM6.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/murecho/v6/q5uYsoq3NOBn_I-ggCJg98TBOoNFCMpr5XWZLCpUOaM6.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/murecho/v6/q5uYsoq3NOBn_I-ggCJg98TBOoNFCMpZ5XWZLCpUOaM6.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/murecho/v6/q5uYsoq3NOBn_I-ggCJg98TBOoNFCMq14nWZLCpUOaM6.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/murecho/v6/q5uYsoq3NOBn_I-ggCJg98TBOoNFCMqM4nWZLCpUOaM6.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/murecho/v6/q5uYsoq3NOBn_I-ggCJg98TBOoNFCMrr4nWZLCpUOaM6.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/murecho/v6/q5uYsoq3NOBn_I-ggCJg98TBOoNFCMrC4nWZLCpUOaM6.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"MuseoModerno\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/museomoderno/v22/zrf30HnU0_7wWdMrFcWqSEXPVyEaWJ55pTleMlZFuewajeKlCdo.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/museomoderno/v22/zrf30HnU0_7wWdMrFcWqSEXPVyEaWJ55pTleMtZEuewajeKlCdo.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/museomoderno/v22/zrf30HnU0_7wWdMrFcWqSEXPVyEaWJ55pTleMghEuewajeKlCdo.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/museomoderno/v22/zrf30HnU0_7wWdMrFcWqSEXPVyEaWJ55pTleMlZEuewajeKlCdo.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/museomoderno/v22/zrf30HnU0_7wWdMrFcWqSEXPVyEaWJ55pTleMmREuewajeKlCdo.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/museomoderno/v22/zrf30HnU0_7wWdMrFcWqSEXPVyEaWJ55pTleMohDuewajeKlCdo.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/museomoderno/v22/zrf30HnU0_7wWdMrFcWqSEXPVyEaWJ55pTleMrFDuewajeKlCdo.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/museomoderno/v22/zrf30HnU0_7wWdMrFcWqSEXPVyEaWJ55pTleMtZDuewajeKlCdo.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/museomoderno/v22/zrf30HnU0_7wWdMrFcWqSEXPVyEaWJ55pTleMv9DuewajeKlCdo.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/museomoderno/v22/zrfx0HnU0_7wWdMrFcWqSEXlXhPlgPcSP5dZJ54HUa4QicCgGdrS3g.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/museomoderno/v22/zrfx0HnU0_7wWdMrFcWqSEXlXhPlgPcSP5dZJ54H0a8QicCgGdrS3g.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/museomoderno/v22/zrfx0HnU0_7wWdMrFcWqSEXlXhPlgPcSP5dZJ54HD68QicCgGdrS3g.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/museomoderno/v22/zrfx0HnU0_7wWdMrFcWqSEXlXhPlgPcSP5dZJ54HUa8QicCgGdrS3g.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/museomoderno/v22/zrfx0HnU0_7wWdMrFcWqSEXlXhPlgPcSP5dZJ54HY68QicCgGdrS3g.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/museomoderno/v22/zrfx0HnU0_7wWdMrFcWqSEXlXhPlgPcSP5dZJ54Hj6gQicCgGdrS3g.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/museomoderno/v22/zrfx0HnU0_7wWdMrFcWqSEXlXhPlgPcSP5dZJ54HtqgQicCgGdrS3g.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/museomoderno/v22/zrfx0HnU0_7wWdMrFcWqSEXlXhPlgPcSP5dZJ54H0agQicCgGdrS3g.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/museomoderno/v22/zrfx0HnU0_7wWdMrFcWqSEXlXhPlgPcSP5dZJ54H-KgQicCgGdrS3g.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"My Soul\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v2\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/mysoul/v2/3XFqErcuy945_u6KF_Ulk2nnXf0.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Mystery Quest\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/mysteryquest/v20/-nF6OG414u0E6k0wynSGlujRHwElD_9Qz9E.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"NTR\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"telugu\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ntr/v15/RLpzK5Xy0ZjiGGhs5TA4bg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Nabla\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"math\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v9\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/nabla/v9/j8_D6-LI0Lvpe7Makz5UhJt9C3uqg_X_75gyGS4jAxsNIjrRNRBUFFR_198.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Nanum Brush Script\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"korean\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/nanumbrushscript/v22/wXK2E2wfpokopxzthSqPbcR5_gVaxazyjqBr1lO97Q.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Nanum Gothic\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"korean\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/nanumgothic/v21/PN_3Rfi-oW3hYwmKDpxS7F_z_tLfxno73g.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/nanumgothic/v21/PN_oRfi-oW3hYwmKDpxS7F_LQv37zlEn14YEUQ.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/nanumgothic/v21/PN_oRfi-oW3hYwmKDpxS7F_LXv77zlEn14YEUQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Nanum Gothic Coding\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"korean\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/nanumgothiccoding/v19/8QIVdjzHisX_8vv59_xMxtPFW4IXROwsy6QxVs1X7tc.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/nanumgothiccoding/v19/8QIYdjzHisX_8vv59_xMxtPFW4IXROws8xgecsV88t5V9r4.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"monospace\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Nanum Myeongjo\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"korean\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/nanummyeongjo/v20/9Btx3DZF0dXLMZlywRbVRNhxy1LreHQ8juyl.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/nanummyeongjo/v20/9Bty3DZF0dXLMZlywRbVRNhxy2pXV1A0pfCs5Kos.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/nanummyeongjo/v20/9Bty3DZF0dXLMZlywRbVRNhxy2pLVFA0pfCs5Kos.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Nanum Pen Script\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"korean\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/nanumpenscript/v19/daaDSSYiLGqEal3MvdA_FOL_3FkN2z7-aMFCcTU.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Neonderthaw\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v3\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/neonderthaw/v3/Iure6Yx5-oWVZI0r-17AeZZJprVA4XQ0.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Nerko One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/nerkoone/v15/m8JQjfZSc7OXlB3ZMOjzcJ5BZmqa3A.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Neucha\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/neucha/v17/q5uGsou0JOdh94bvugNsCxVEgA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Neuton\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/neuton/v18/UMBQrPtMoH62xUZKAKkfegD5Drog6Q.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/neuton/v18/UMBQrPtMoH62xUZKZKofegD5Drog6Q.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/neuton/v18/UMBTrPtMoH62xUZyyII7civlBw.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/neuton/v18/UMBRrPtMoH62xUZCyog_UC71B6M5.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/neuton/v18/UMBQrPtMoH62xUZKdK0fegD5Drog6Q.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/neuton/v18/UMBQrPtMoH62xUZKaK4fegD5Drog6Q.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"New Rocker\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/newrocker/v16/MwQzbhjp3-HImzcCU_cJkGMViblPtXs.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"New Tegomin\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/newtegomin/v10/SLXMc1fV7Gd9USdBAfPlqfN0Q3ptkDMN.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"News Cycle\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/newscycle/v22/CSR64z1Qlv-GDxkbKVQ_TOcATNt_pOU.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/newscycle/v22/CSR54z1Qlv-GDxkbKVQ_dFsvaNNUuOwkC2s.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Newsreader\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/newsreader/v19/cY9qfjOCX1hbuyalUrK49dLac06G1ZGsZBtoBCzBDXXD9JVF438w-I_ADOxEPjCggA.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/newsreader/v19/cY9qfjOCX1hbuyalUrK49dLac06G1ZGsZBtoBCzBDXXD9JVF438wJo_ADOxEPjCggA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/newsreader/v19/cY9qfjOCX1hbuyalUrK49dLac06G1ZGsZBtoBCzBDXXD9JVF438weI_ADOxEPjCggA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/newsreader/v19/cY9qfjOCX1hbuyalUrK49dLac06G1ZGsZBtoBCzBDXXD9JVF438wSo_ADOxEPjCggA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/newsreader/v19/cY9qfjOCX1hbuyalUrK49dLac06G1ZGsZBtoBCzBDXXD9JVF438wpojADOxEPjCggA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/newsreader/v19/cY9qfjOCX1hbuyalUrK49dLac06G1ZGsZBtoBCzBDXXD9JVF438wn4jADOxEPjCggA.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/newsreader/v19/cY9qfjOCX1hbuyalUrK49dLac06G1ZGsZBtoBCzBDXXD9JVF438w-IjADOxEPjCggA.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/newsreader/v19/cY9kfjOCX1hbuyalUrK439vogqC9yFZCYg7oRZaLP4obnf7fTXglsMyoT-ZAHDWwgECi.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/newsreader/v19/cY9kfjOCX1hbuyalUrK439vogqC9yFZCYg7oRZaLP4obnf7fTXglsMx2T-ZAHDWwgECi.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/newsreader/v19/cY9kfjOCX1hbuyalUrK439vogqC9yFZCYg7oRZaLP4obnf7fTXglsMwoT-ZAHDWwgECi.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/newsreader/v19/cY9kfjOCX1hbuyalUrK439vogqC9yFZCYg7oRZaLP4obnf7fTXglsMwaT-ZAHDWwgECi.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/newsreader/v19/cY9kfjOCX1hbuyalUrK439vogqC9yFZCYg7oRZaLP4obnf7fTXglsMz2SOZAHDWwgECi.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/newsreader/v19/cY9kfjOCX1hbuyalUrK439vogqC9yFZCYg7oRZaLP4obnf7fTXglsMzPSOZAHDWwgECi.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/newsreader/v19/cY9kfjOCX1hbuyalUrK439vogqC9yFZCYg7oRZaLP4obnf7fTXglsMyoSOZAHDWwgECi.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Niconne\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/niconne/v15/w8gaH2QvRug1_rTfrQut2F4OuOo.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Niramit\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"thai\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/niramit/v10/I_urMpWdvgLdNxVLVXx7tiiEr5_BdZ8.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/niramit/v10/I_upMpWdvgLdNxVLXbZiXimOq73EZZ_f6w.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/niramit/v10/I_urMpWdvgLdNxVLVRh4tiiEr5_BdZ8.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/niramit/v10/I_upMpWdvgLdNxVLXbZiOiqOq73EZZ_f6w.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/niramit/v10/I_uuMpWdvgLdNxVLbbRQkiCvs5Y.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/niramit/v10/I_usMpWdvgLdNxVLXbZalgKqo5bYbA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/niramit/v10/I_urMpWdvgLdNxVLVUB5tiiEr5_BdZ8.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/niramit/v10/I_upMpWdvgLdNxVLXbZiYiuOq73EZZ_f6w.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/niramit/v10/I_urMpWdvgLdNxVLVWx-tiiEr5_BdZ8.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/niramit/v10/I_upMpWdvgLdNxVLXbZiTiyOq73EZZ_f6w.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/niramit/v10/I_urMpWdvgLdNxVLVQh_tiiEr5_BdZ8.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/niramit/v10/I_upMpWdvgLdNxVLXbZiKi2Oq73EZZ_f6w.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Nixie One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/nixieone/v16/lW-8wjkKLXjg5y2o2uUoUOFzpS-yLw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Nobile\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/nobile/v17/m8JTjflSeaOVl1i2XqfXeLVdbw.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/nobile/v17/m8JRjflSeaOVl1iGXK3TWrBNb3OD.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/nobile/v17/m8JQjflSeaOVl1iOqo7zcJ5BZmqa3A.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/nobile/v17/m8JWjflSeaOVl1iGXJUnc5RFRG-K3Mud.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/nobile/v17/m8JQjflSeaOVl1iO4ojzcJ5BZmqa3A.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/nobile/v17/m8JWjflSeaOVl1iGXJVvdZRFRG-K3Mud.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Nokora\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"khmer\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v30\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/nokora/v30/~CgoKBk5va29yYRhkIAAqBAgBGAE=.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/nokora/v30/~CgsKBk5va29yYRisAiAAKgQIARgB.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/nokora/v30/~CggKBk5va29yYSAAKgQIARgB.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/nokora/v30/~CgsKBk5va29yYRi8BSAAKgQIARgB.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/nokora/v30/~CgsKBk5va29yYRiEByAAKgQIARgB.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Norican\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/norican/v14/MwQ2bhXp1eSBqjkPGJJRtGs-lbA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Nosifer\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/nosifer/v20/ZGjXol5JTp0g5bxZaC1RVDNdGDs.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Notable\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notable/v14/gNMEW3N_SIqx-WX9-HMoFIez5MI.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Nothing You Could Do\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/nothingyoucoulddo/v15/oY1B8fbBpaP5OX3DtrRYf_Q2BPB1SnfZb0OJl1ol2Ymo.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noticia Text\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/noticiatext/v15/VuJ2dNDF2Yv9qppOePKYRP1GYTFZt0rNpQ.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/noticiatext/v15/VuJodNDF2Yv9qppOePKYRP12YztdlU_dpSjt.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/noticiatext/v15/VuJpdNDF2Yv9qppOePKYRP1-3R59v2HRrDH0eA.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/noticiatext/v15/VuJrdNDF2Yv9qppOePKYRP12YwPhumvVjjTkeMnz.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Color Emoji\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"emoji\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-09-26\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notocoloremoji/v24/Yq6P-KqIXTD0t4D9z1ESnKM3-HpFab5s79iz64w.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Emoji\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"emoji\"\n\t\t\t],\n\t\t\t\"version\": \"v34\",\n\t\t\t\"lastModified\": \"2022-09-26\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notoemoji/v34/bMrnmSyK7YY-MEu6aWjPDs-ar6uWaGWuob_10jwvS-FGJCMY.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoemoji/v34/bMrnmSyK7YY-MEu6aWjPDs-ar6uWaGWuob-r0jwvS-FGJCMY.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notoemoji/v34/bMrnmSyK7YY-MEu6aWjPDs-ar6uWaGWuob-Z0jwvS-FGJCMY.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notoemoji/v34/bMrnmSyK7YY-MEu6aWjPDs-ar6uWaGWuob911TwvS-FGJCMY.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notoemoji/v34/bMrnmSyK7YY-MEu6aWjPDs-ar6uWaGWuob9M1TwvS-FGJCMY.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Kufi Arabic\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notokufiarabic/v15/CSRp4ydQnPyaDxEXLFF6LZVLKrodhu8t57o1kDc5Wh5v3obPnLSmf5yD.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notokufiarabic/v15/CSRp4ydQnPyaDxEXLFF6LZVLKrodhu8t57o1kDc5Wh7v34bPnLSmf5yD.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notokufiarabic/v15/CSRp4ydQnPyaDxEXLFF6LZVLKrodhu8t57o1kDc5Wh4x34bPnLSmf5yD.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notokufiarabic/v15/CSRp4ydQnPyaDxEXLFF6LZVLKrodhu8t57o1kDc5Wh5v34bPnLSmf5yD.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notokufiarabic/v15/CSRp4ydQnPyaDxEXLFF6LZVLKrodhu8t57o1kDc5Wh5d34bPnLSmf5yD.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notokufiarabic/v15/CSRp4ydQnPyaDxEXLFF6LZVLKrodhu8t57o1kDc5Wh6x2IbPnLSmf5yD.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notokufiarabic/v15/CSRp4ydQnPyaDxEXLFF6LZVLKrodhu8t57o1kDc5Wh6I2IbPnLSmf5yD.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notokufiarabic/v15/CSRp4ydQnPyaDxEXLFF6LZVLKrodhu8t57o1kDc5Wh7v2IbPnLSmf5yD.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notokufiarabic/v15/CSRp4ydQnPyaDxEXLFF6LZVLKrodhu8t57o1kDc5Wh7G2IbPnLSmf5yD.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Music\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"music\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notomusic/v17/pe0rMIiSN5pO63htf1sxIteQB9Zra1U.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Naskh Arabic\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v25\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notonaskharabic/v25/RrQ5bpV-9Dd1b1OAGA6M9PkyDuVBePeKNaxcsss0Y7bwvc5krK0z9_Mnuw.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notonaskharabic/v25/RrQ5bpV-9Dd1b1OAGA6M9PkyDuVBePeKNaxcsss0Y7bwj85krK0z9_Mnuw.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notonaskharabic/v25/RrQ5bpV-9Dd1b1OAGA6M9PkyDuVBePeKNaxcsss0Y7bwY8lkrK0z9_Mnuw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notonaskharabic/v25/RrQ5bpV-9Dd1b1OAGA6M9PkyDuVBePeKNaxcsss0Y7bwWslkrK0z9_Mnuw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Nastaliq Urdu\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-28\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notonastaliqurdu/v14/LhWNMUPbN-oZdNFcBy1-DJYsEoTq5pudQ9L940pGPkB3Qt_-DK2f2-_8mEw.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notonastaliqurdu/v14/LhWNMUPbN-oZdNFcBy1-DJYsEoTq5pudQ9L940pGPkB3Qu3-DK2f2-_8mEw.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notonastaliqurdu/v14/LhWNMUPbN-oZdNFcBy1-DJYsEoTq5pudQ9L940pGPkB3QgH5DK2f2-_8mEw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notonastaliqurdu/v14/LhWNMUPbN-oZdNFcBy1-DJYsEoTq5pudQ9L940pGPkB3Qjj5DK2f2-_8mEw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Rashi Hebrew\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notorashihebrew/v21/EJR_Qh82XsIK-QFmqXk4zvLwFVya0vFL-HlKM5e6C6HZB-DkRyq6Nf2pfA.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notorashihebrew/v21/EJR_Qh82XsIK-QFmqXk4zvLwFVya0vFL-HlKM5e6C6HZh-HkRyq6Nf2pfA.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notorashihebrew/v21/EJR_Qh82XsIK-QFmqXk4zvLwFVya0vFL-HlKM5e6C6HZWeHkRyq6Nf2pfA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notorashihebrew/v21/EJR_Qh82XsIK-QFmqXk4zvLwFVya0vFL-HlKM5e6C6HZB-HkRyq6Nf2pfA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notorashihebrew/v21/EJR_Qh82XsIK-QFmqXk4zvLwFVya0vFL-HlKM5e6C6HZNeHkRyq6Nf2pfA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notorashihebrew/v21/EJR_Qh82XsIK-QFmqXk4zvLwFVya0vFL-HlKM5e6C6HZ2ebkRyq6Nf2pfA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notorashihebrew/v21/EJR_Qh82XsIK-QFmqXk4zvLwFVya0vFL-HlKM5e6C6HZ4ObkRyq6Nf2pfA.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notorashihebrew/v21/EJR_Qh82XsIK-QFmqXk4zvLwFVya0vFL-HlKM5e6C6HZh-bkRyq6Nf2pfA.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notorashihebrew/v21/EJR_Qh82XsIK-QFmqXk4zvLwFVya0vFL-HlKM5e6C6HZrubkRyq6Nf2pfA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v27\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosans/v27/o-0OIpQlx3QUlC5A4PNjhjRFSfiM7HBj.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/notosans/v27/o-0MIpQlx3QUlC5A4PNr4AwhQ_yu6WBjJLE.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notosans/v27/o-0NIpQlx3QUlC5A4PNjKhVlY9aA5Wl6PQ.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/notosans/v27/o-0TIpQlx3QUlC5A4PNr4AyNYtyEx2xqPaif.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notosans/v27/o-0NIpQlx3QUlC5A4PNjThZlY9aA5Wl6PQ.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/notosans/v27/o-0TIpQlx3QUlC5A4PNr4AzpYdyEx2xqPaif.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosans/v27/o-0IIpQlx3QUlC5A4PNb4j5Ba_2c7A.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/notosans/v27/o-0OIpQlx3QUlC5A4PNr4DRFSfiM7HBj.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosans/v27/o-0NIpQlx3QUlC5A4PNjFhdlY9aA5Wl6PQ.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/notosans/v27/o-0TIpQlx3QUlC5A4PNr4AyxYNyEx2xqPaif.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosans/v27/o-0NIpQlx3QUlC5A4PNjOhBlY9aA5Wl6PQ.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/notosans/v27/o-0TIpQlx3QUlC5A4PNr4AydZ9yEx2xqPaif.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosans/v27/o-0NIpQlx3QUlC5A4PNjXhFlY9aA5Wl6PQ.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/notosans/v27/o-0TIpQlx3QUlC5A4PNr4Az5ZtyEx2xqPaif.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notosans/v27/o-0NIpQlx3QUlC5A4PNjQhJlY9aA5Wl6PQ.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/notosans/v27/o-0TIpQlx3QUlC5A4PNr4AzlZdyEx2xqPaif.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosans/v27/o-0NIpQlx3QUlC5A4PNjZhNlY9aA5Wl6PQ.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/notosans/v27/o-0TIpQlx3QUlC5A4PNr4AzBZNyEx2xqPaif.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Adlam\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"adlam\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansadlam/v21/neIczCCpqp0s5pPusPamd81eMfjPonvqdbYxxpgufnv0TGnBZLwhuvk.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosansadlam/v21/neIczCCpqp0s5pPusPamd81eMfjPonvqdbYxxpgufkn0TGnBZLwhuvk.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosansadlam/v21/neIczCCpqp0s5pPusPamd81eMfjPonvqdbYxxpgufqXzTGnBZLwhuvk.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosansadlam/v21/neIczCCpqp0s5pPusPamd81eMfjPonvqdbYxxpgufpzzTGnBZLwhuvk.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Adlam Unjoined\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"adlam\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansadlamunjoined/v21/P5sszY2MYsLRsB5_ildkzPPDsLQXcOEmaFOqOGcaYrzFTIjsPam_Ye35PMEe-E3slUg.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosansadlamunjoined/v21/P5sszY2MYsLRsB5_ildkzPPDsLQXcOEmaFOqOGcaYrzFTIjsPam_Yd_5PMEe-E3slUg.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosansadlamunjoined/v21/P5sszY2MYsLRsB5_ildkzPPDsLQXcOEmaFOqOGcaYrzFTIjsPam_YTP-PMEe-E3slUg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosansadlamunjoined/v21/P5sszY2MYsLRsB5_ildkzPPDsLQXcOEmaFOqOGcaYrzFTIjsPam_YQr-PMEe-E3slUg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Anatolian Hieroglyphs\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"anatolian-hieroglyphs\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansanatolianhieroglyphs/v14/ijw9s4roRME5LLRxjsRb8A0gKPSWq4BbDmHHu6j2pEtUJzZWXybIymc5QYo.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Arabic\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-06-01\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosansarabic/v18/nwpxtLGrOAZMl5nJ_wfgRg3DrWFZWsnVBJ_sS6tlqHHFlhQ5l3sQWIHPqzCfyG2vu3CBFQLaig.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notosansarabic/v18/nwpxtLGrOAZMl5nJ_wfgRg3DrWFZWsnVBJ_sS6tlqHHFlhQ5l3sQWIHPqzCfSGyvu3CBFQLaig.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notosansarabic/v18/nwpxtLGrOAZMl5nJ_wfgRg3DrWFZWsnVBJ_sS6tlqHHFlhQ5l3sQWIHPqzCflmyvu3CBFQLaig.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansarabic/v18/nwpxtLGrOAZMl5nJ_wfgRg3DrWFZWsnVBJ_sS6tlqHHFlhQ5l3sQWIHPqzCfyGyvu3CBFQLaig.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosansarabic/v18/nwpxtLGrOAZMl5nJ_wfgRg3DrWFZWsnVBJ_sS6tlqHHFlhQ5l3sQWIHPqzCf-myvu3CBFQLaig.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosansarabic/v18/nwpxtLGrOAZMl5nJ_wfgRg3DrWFZWsnVBJ_sS6tlqHHFlhQ5l3sQWIHPqzCfFmuvu3CBFQLaig.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosansarabic/v18/nwpxtLGrOAZMl5nJ_wfgRg3DrWFZWsnVBJ_sS6tlqHHFlhQ5l3sQWIHPqzCfL2uvu3CBFQLaig.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notosansarabic/v18/nwpxtLGrOAZMl5nJ_wfgRg3DrWFZWsnVBJ_sS6tlqHHFlhQ5l3sQWIHPqzCfSGuvu3CBFQLaig.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosansarabic/v18/nwpxtLGrOAZMl5nJ_wfgRg3DrWFZWsnVBJ_sS6tlqHHFlhQ5l3sQWIHPqzCfYWuvu3CBFQLaig.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Armenian\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"armenian\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v39\",\n\t\t\t\"lastModified\": \"2022-09-28\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosansarmenian/v39/ZgN0jOZKPa7CHqq0h37c7ReDUubm2SEdFXp7ig73qtTY5idb74R9UdM3y2nZLorxbq0iYy6zF3Eg.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notosansarmenian/v39/ZgN0jOZKPa7CHqq0h37c7ReDUubm2SEdFXp7ig73qtTY5idb74R9UdM3y2nZLopxb60iYy6zF3Eg.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notosansarmenian/v39/ZgN0jOZKPa7CHqq0h37c7ReDUubm2SEdFXp7ig73qtTY5idb74R9UdM3y2nZLoqvb60iYy6zF3Eg.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansarmenian/v39/ZgN0jOZKPa7CHqq0h37c7ReDUubm2SEdFXp7ig73qtTY5idb74R9UdM3y2nZLorxb60iYy6zF3Eg.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosansarmenian/v39/ZgN0jOZKPa7CHqq0h37c7ReDUubm2SEdFXp7ig73qtTY5idb74R9UdM3y2nZLorDb60iYy6zF3Eg.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosansarmenian/v39/ZgN0jOZKPa7CHqq0h37c7ReDUubm2SEdFXp7ig73qtTY5idb74R9UdM3y2nZLoovaK0iYy6zF3Eg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosansarmenian/v39/ZgN0jOZKPa7CHqq0h37c7ReDUubm2SEdFXp7ig73qtTY5idb74R9UdM3y2nZLooWaK0iYy6zF3Eg.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notosansarmenian/v39/ZgN0jOZKPa7CHqq0h37c7ReDUubm2SEdFXp7ig73qtTY5idb74R9UdM3y2nZLopxaK0iYy6zF3Eg.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosansarmenian/v39/ZgN0jOZKPa7CHqq0h37c7ReDUubm2SEdFXp7ig73qtTY5idb74R9UdM3y2nZLopYaK0iYy6zF3Eg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Avestan\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"avestan\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansavestan/v17/bWti7ejKfBziStx7lIzKOLQZKhIJkyu9SASLji8U.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Balinese\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"balinese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansbalinese/v18/NaPwcYvSBuhTirw6IaFn6UrRDaqje-lpbbRtYf-Fwu2Ov7fdhE5Vd222PPY.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosansbalinese/v18/NaPwcYvSBuhTirw6IaFn6UrRDaqje-lpbbRtYf-Fwu2Ov4XdhE5Vd222PPY.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosansbalinese/v18/NaPwcYvSBuhTirw6IaFn6UrRDaqje-lpbbRtYf-Fwu2Ov2nahE5Vd222PPY.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosansbalinese/v18/NaPwcYvSBuhTirw6IaFn6UrRDaqje-lpbbRtYf-Fwu2Ov1DahE5Vd222PPY.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Bamum\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"bamum\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v26\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansbamum/v26/uk-0EGK3o6EruUbnwovcbBTkkklK_Ya_PBHfNGTPEddO-_gLykxEkxA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosansbamum/v26/uk-0EGK3o6EruUbnwovcbBTkkklK_Ya_PBHfNGTPEeVO-_gLykxEkxA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosansbamum/v26/uk-0EGK3o6EruUbnwovcbBTkkklK_Ya_PBHfNGTPEQlJ-_gLykxEkxA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosansbamum/v26/uk-0EGK3o6EruUbnwovcbBTkkklK_Ya_PBHfNGTPETBJ-_gLykxEkxA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Bassa Vah\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"bassa-vah\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansbassavah/v17/PN_bRee-r3f7LnqsD5sax12gjZn7mBpL5YwUpA2MBdcFn4MaAc6p34gH-GD7.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosansbassavah/v17/PN_bRee-r3f7LnqsD5sax12gjZn7mBpL5YwUpA2MBdcFn4MoAc6p34gH-GD7.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosansbassavah/v17/PN_bRee-r3f7LnqsD5sax12gjZn7mBpL5YwUpA2MBdcFn4PEBs6p34gH-GD7.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosansbassavah/v17/PN_bRee-r3f7LnqsD5sax12gjZn7mBpL5YwUpA2MBdcFn4P9Bs6p34gH-GD7.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Batak\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"batak\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansbatak/v16/gok2H6TwAEdtF9N8-mdTCQvT-Zdgo4_PHuk74A.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Bengali\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"bengali\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosansbengali/v20/Cn-SJsCGWQxOjaGwMQ6fIiMywrNJIky6nvd8BjzVMvJx2mcSPVFpVEqE-6KmsolKudCk8izI0lc.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notosansbengali/v20/Cn-SJsCGWQxOjaGwMQ6fIiMywrNJIky6nvd8BjzVMvJx2mcSPVFpVEqE-6KmsglLudCk8izI0lc.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notosansbengali/v20/Cn-SJsCGWQxOjaGwMQ6fIiMywrNJIky6nvd8BjzVMvJx2mcSPVFpVEqE-6KmstdLudCk8izI0lc.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansbengali/v20/Cn-SJsCGWQxOjaGwMQ6fIiMywrNJIky6nvd8BjzVMvJx2mcSPVFpVEqE-6KmsolLudCk8izI0lc.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosansbengali/v20/Cn-SJsCGWQxOjaGwMQ6fIiMywrNJIky6nvd8BjzVMvJx2mcSPVFpVEqE-6KmsrtLudCk8izI0lc.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosansbengali/v20/Cn-SJsCGWQxOjaGwMQ6fIiMywrNJIky6nvd8BjzVMvJx2mcSPVFpVEqE-6KmsldMudCk8izI0lc.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosansbengali/v20/Cn-SJsCGWQxOjaGwMQ6fIiMywrNJIky6nvd8BjzVMvJx2mcSPVFpVEqE-6Kmsm5MudCk8izI0lc.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notosansbengali/v20/Cn-SJsCGWQxOjaGwMQ6fIiMywrNJIky6nvd8BjzVMvJx2mcSPVFpVEqE-6KmsglMudCk8izI0lc.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosansbengali/v20/Cn-SJsCGWQxOjaGwMQ6fIiMywrNJIky6nvd8BjzVMvJx2mcSPVFpVEqE-6KmsiBMudCk8izI0lc.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Bhaiksuki\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"bhaiksuki\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansbhaiksuki/v15/UcC63EosKniBH4iELXATsSBWdvUHXxhj8rLUdU4wh9U.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Brahmi\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"brahmi\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansbrahmi/v15/vEFK2-VODB8RrNDvZSUmQQIIByV18tK1W77HtMo.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Buginese\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"buginese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansbuginese/v17/esDM30ldNv-KYGGJpKGk18phe_7Da6_gtfuEXLmNtw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Buhid\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"buhid\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansbuhid/v17/Dxxy8jiXMW75w3OmoDXVWJD7YwzAe6tgnaFoGA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Canadian Aboriginal\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"canadian-aboriginal\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-28\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosanscanadianaboriginal/v21/4C_TLjTuEqPj-8J01CwaGkiZ9os0iGVkezM1mUT-j_Lmlzda6uH_nnX1bzigWLj_yAsg0q0uhQ.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notosanscanadianaboriginal/v21/4C_TLjTuEqPj-8J01CwaGkiZ9os0iGVkezM1mUT-j_Lmlzda6uH_nnX1bzig2Ln_yAsg0q0uhQ.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notosanscanadianaboriginal/v21/4C_TLjTuEqPj-8J01CwaGkiZ9os0iGVkezM1mUT-j_Lmlzda6uH_nnX1bzigBrn_yAsg0q0uhQ.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanscanadianaboriginal/v21/4C_TLjTuEqPj-8J01CwaGkiZ9os0iGVkezM1mUT-j_Lmlzda6uH_nnX1bzigWLn_yAsg0q0uhQ.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosanscanadianaboriginal/v21/4C_TLjTuEqPj-8J01CwaGkiZ9os0iGVkezM1mUT-j_Lmlzda6uH_nnX1bzigarn_yAsg0q0uhQ.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosanscanadianaboriginal/v21/4C_TLjTuEqPj-8J01CwaGkiZ9os0iGVkezM1mUT-j_Lmlzda6uH_nnX1bzighr7_yAsg0q0uhQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosanscanadianaboriginal/v21/4C_TLjTuEqPj-8J01CwaGkiZ9os0iGVkezM1mUT-j_Lmlzda6uH_nnX1bzigv77_yAsg0q0uhQ.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notosanscanadianaboriginal/v21/4C_TLjTuEqPj-8J01CwaGkiZ9os0iGVkezM1mUT-j_Lmlzda6uH_nnX1bzig2L7_yAsg0q0uhQ.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosanscanadianaboriginal/v21/4C_TLjTuEqPj-8J01CwaGkiZ9os0iGVkezM1mUT-j_Lmlzda6uH_nnX1bzig8b7_yAsg0q0uhQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Carian\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"carian\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanscarian/v15/LDIpaoiONgYwA9Yc6f0gUILeMIOgs7ob9yGLmfI.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Caucasian Albanian\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"caucasian-albanian\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanscaucasianalbanian/v16/nKKA-HM_FYFRJvXzVXaANsU0VzsAc46QGOkWytlTs-TXrYDmoVmRSZo.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Chakma\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"chakma\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanschakma/v17/Y4GQYbJ8VTEp4t3MKJSMjg5OIzhi4JjTQhYBeYo.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Cham\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cham\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v23\",\n\t\t\t\"lastModified\": \"2022-09-28\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosanscham/v23/pe06MIySN5pO62Z5YkFyQb_bbuRhe6D4yip43qfcER0cv7GykboaLg.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notosanscham/v23/pe06MIySN5pO62Z5YkFyQb_bbuRhe6D4yip43qfckRwcv7GykboaLg.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notosanscham/v23/pe06MIySN5pO62Z5YkFyQb_bbuRhe6D4yip43qfcTxwcv7GykboaLg.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanscham/v23/pe06MIySN5pO62Z5YkFyQb_bbuRhe6D4yip43qfcERwcv7GykboaLg.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosanscham/v23/pe06MIySN5pO62Z5YkFyQb_bbuRhe6D4yip43qfcIxwcv7GykboaLg.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosanscham/v23/pe06MIySN5pO62Z5YkFyQb_bbuRhe6D4yip43qfczxscv7GykboaLg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosanscham/v23/pe06MIySN5pO62Z5YkFyQb_bbuRhe6D4yip43qfc9hscv7GykboaLg.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notosanscham/v23/pe06MIySN5pO62Z5YkFyQb_bbuRhe6D4yip43qfckRscv7GykboaLg.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosanscham/v23/pe06MIySN5pO62Z5YkFyQb_bbuRhe6D4yip43qfcuBscv7GykboaLg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Cherokee\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cherokee\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-28\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosanscherokee/v19/KFOPCm6Yu8uF-29fiz9vQF9YWK6Z8O10cHNA0cSkZCHYWi5ODkm5rAffjl0.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notosanscherokee/v19/KFOPCm6Yu8uF-29fiz9vQF9YWK6Z8O10cHNA0cSkZCHYWq5PDkm5rAffjl0.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notosanscherokee/v19/KFOPCm6Yu8uF-29fiz9vQF9YWK6Z8O10cHNA0cSkZCHYWnBPDkm5rAffjl0.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanscherokee/v19/KFOPCm6Yu8uF-29fiz9vQF9YWK6Z8O10cHNA0cSkZCHYWi5PDkm5rAffjl0.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosanscherokee/v19/KFOPCm6Yu8uF-29fiz9vQF9YWK6Z8O10cHNA0cSkZCHYWhxPDkm5rAffjl0.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosanscherokee/v19/KFOPCm6Yu8uF-29fiz9vQF9YWK6Z8O10cHNA0cSkZCHYWvBIDkm5rAffjl0.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosanscherokee/v19/KFOPCm6Yu8uF-29fiz9vQF9YWK6Z8O10cHNA0cSkZCHYWslIDkm5rAffjl0.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notosanscherokee/v19/KFOPCm6Yu8uF-29fiz9vQF9YWK6Z8O10cHNA0cSkZCHYWq5IDkm5rAffjl0.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosanscherokee/v19/KFOPCm6Yu8uF-29fiz9vQF9YWK6Z8O10cHNA0cSkZCHYWodIDkm5rAffjl0.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Coptic\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"coptic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-28\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanscoptic/v17/iJWfBWmUZi_OHPqn4wq6kgqumOEd78u_VG0xR4Y.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Cuneiform\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cuneiform\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanscuneiform/v15/bMrrmTWK7YY-MF22aHGGd7H8PhJtvBDWgb9JlRQueeQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Cypriot\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cypriot\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanscypriot/v15/8AtzGta9PYqQDjyp79a6f8Cj-3a3cxIsK5MPpahF.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Deseret\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"deseret\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansdeseret/v15/MwQsbgPp1eKH6QsAVuFb9AZM6MMr2Vq9ZnJSZtQG.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Devanagari\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosansdevanagari/v19/TuGoUUFzXI5FBtUq5a8bjKYTZjtRU6Sgv3NaV_SNmI0b8QQCQmHn6B2OHjbL_08AlXQky-AzoFoW4Ow.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notosansdevanagari/v19/TuGoUUFzXI5FBtUq5a8bjKYTZjtRU6Sgv3NaV_SNmI0b8QQCQmHn6B2OHjbL_08AlfQly-AzoFoW4Ow.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notosansdevanagari/v19/TuGoUUFzXI5FBtUq5a8bjKYTZjtRU6Sgv3NaV_SNmI0b8QQCQmHn6B2OHjbL_08AlSoly-AzoFoW4Ow.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansdevanagari/v19/TuGoUUFzXI5FBtUq5a8bjKYTZjtRU6Sgv3NaV_SNmI0b8QQCQmHn6B2OHjbL_08AlXQly-AzoFoW4Ow.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosansdevanagari/v19/TuGoUUFzXI5FBtUq5a8bjKYTZjtRU6Sgv3NaV_SNmI0b8QQCQmHn6B2OHjbL_08AlUYly-AzoFoW4Ow.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosansdevanagari/v19/TuGoUUFzXI5FBtUq5a8bjKYTZjtRU6Sgv3NaV_SNmI0b8QQCQmHn6B2OHjbL_08Alaoiy-AzoFoW4Ow.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosansdevanagari/v19/TuGoUUFzXI5FBtUq5a8bjKYTZjtRU6Sgv3NaV_SNmI0b8QQCQmHn6B2OHjbL_08AlZMiy-AzoFoW4Ow.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notosansdevanagari/v19/TuGoUUFzXI5FBtUq5a8bjKYTZjtRU6Sgv3NaV_SNmI0b8QQCQmHn6B2OHjbL_08AlfQiy-AzoFoW4Ow.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosansdevanagari/v19/TuGoUUFzXI5FBtUq5a8bjKYTZjtRU6Sgv3NaV_SNmI0b8QQCQmHn6B2OHjbL_08Ald0iy-AzoFoW4Ow.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Display\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosansdisplay/v20/RLpbK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LuV-PT4Doq_AKp_3cLVTGQ2iHrvWM.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notosansdisplay/v20/RLpbK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LuV-PT4Doq_AKp__cKVTGQ2iHrvWM.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notosansdisplay/v20/RLpbK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LuV-PT4Doq_AKp_ykKVTGQ2iHrvWM.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansdisplay/v20/RLpbK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LuV-PT4Doq_AKp_3cKVTGQ2iHrvWM.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosansdisplay/v20/RLpbK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LuV-PT4Doq_AKp_0UKVTGQ2iHrvWM.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosansdisplay/v20/RLpbK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LuV-PT4Doq_AKp_6kNVTGQ2iHrvWM.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosansdisplay/v20/RLpbK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LuV-PT4Doq_AKp_5ANVTGQ2iHrvWM.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notosansdisplay/v20/RLpbK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LuV-PT4Doq_AKp__cNVTGQ2iHrvWM.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosansdisplay/v20/RLpbK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LuV-PT4Doq_AKp_94NVTGQ2iHrvWM.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/notosansdisplay/v20/RLpZK4fy6r6tOBEJg0IAKzqdFZVZxrktbnDB5UzBIup9PwAcHtEsOFNBZqyu6r9JvXOa3gPurWM9uQ.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/notosansdisplay/v20/RLpZK4fy6r6tOBEJg0IAKzqdFZVZxrktbnDB5UzBIup9PwAcHtEsOFNBZqyu6r9JPXKa3gPurWM9uQ.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/notosansdisplay/v20/RLpZK4fy6r6tOBEJg0IAKzqdFZVZxrktbnDB5UzBIup9PwAcHtEsOFNBZqyu6r9J43Ka3gPurWM9uQ.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/notosansdisplay/v20/RLpZK4fy6r6tOBEJg0IAKzqdFZVZxrktbnDB5UzBIup9PwAcHtEsOFNBZqyu6r9JvXKa3gPurWM9uQ.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/notosansdisplay/v20/RLpZK4fy6r6tOBEJg0IAKzqdFZVZxrktbnDB5UzBIup9PwAcHtEsOFNBZqyu6r9Jj3Ka3gPurWM9uQ.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/notosansdisplay/v20/RLpZK4fy6r6tOBEJg0IAKzqdFZVZxrktbnDB5UzBIup9PwAcHtEsOFNBZqyu6r9JY3Wa3gPurWM9uQ.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/notosansdisplay/v20/RLpZK4fy6r6tOBEJg0IAKzqdFZVZxrktbnDB5UzBIup9PwAcHtEsOFNBZqyu6r9JWnWa3gPurWM9uQ.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/notosansdisplay/v20/RLpZK4fy6r6tOBEJg0IAKzqdFZVZxrktbnDB5UzBIup9PwAcHtEsOFNBZqyu6r9JPXWa3gPurWM9uQ.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/notosansdisplay/v20/RLpZK4fy6r6tOBEJg0IAKzqdFZVZxrktbnDB5UzBIup9PwAcHtEsOFNBZqyu6r9JFHWa3gPurWM9uQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Duployan\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"duployan\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansduployan/v16/gokzH7nwAEdtF9N8-mdTDx_X9JM5wsvrFsIn6WYDvA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Egyptian Hieroglyphs\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"egyptian-hieroglyphs\"\n\t\t\t],\n\t\t\t\"version\": \"v26\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansegyptianhieroglyphs/v26/vEF42-tODB8RrNDvZSUmRhcQHzx1s7y_F9-j3qSzEcbEYindSVK8xRg7iw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Elbasan\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"elbasan\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanselbasan/v15/-F6rfiZqLzI2JPCgQBnw400qp1trvHdlre4dFcFh.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Elymaic\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"elymaic\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanselymaic/v15/UqyKK9YTJW5liNMhTMqe9vUFP65ZD4AjWOT0zi2V.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Ethiopic\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"ethiopic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v42\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosansethiopic/v42/7cHPv50vjIepfJVOZZgcpQ5B9FBTH9KGNfhSTgtoow1KVnIvyBoMSzUMacb-T35OKqDjwmfeaY9u.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notosansethiopic/v42/7cHPv50vjIepfJVOZZgcpQ5B9FBTH9KGNfhSTgtoow1KVnIvyBoMSzUMacb-T37OK6DjwmfeaY9u.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notosansethiopic/v42/7cHPv50vjIepfJVOZZgcpQ5B9FBTH9KGNfhSTgtoow1KVnIvyBoMSzUMacb-T34QK6DjwmfeaY9u.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansethiopic/v42/7cHPv50vjIepfJVOZZgcpQ5B9FBTH9KGNfhSTgtoow1KVnIvyBoMSzUMacb-T35OK6DjwmfeaY9u.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosansethiopic/v42/7cHPv50vjIepfJVOZZgcpQ5B9FBTH9KGNfhSTgtoow1KVnIvyBoMSzUMacb-T358K6DjwmfeaY9u.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosansethiopic/v42/7cHPv50vjIepfJVOZZgcpQ5B9FBTH9KGNfhSTgtoow1KVnIvyBoMSzUMacb-T36QLKDjwmfeaY9u.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosansethiopic/v42/7cHPv50vjIepfJVOZZgcpQ5B9FBTH9KGNfhSTgtoow1KVnIvyBoMSzUMacb-T36pLKDjwmfeaY9u.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notosansethiopic/v42/7cHPv50vjIepfJVOZZgcpQ5B9FBTH9KGNfhSTgtoow1KVnIvyBoMSzUMacb-T37OLKDjwmfeaY9u.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosansethiopic/v42/7cHPv50vjIepfJVOZZgcpQ5B9FBTH9KGNfhSTgtoow1KVnIvyBoMSzUMacb-T37nLKDjwmfeaY9u.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Georgian\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"georgian\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v36\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosansgeorgian/v36/PlIaFke5O6RzLfvNNVSitxkr76PRHBC4Ytyq-Gof7PUs4S7zWn-8YDB09HFNdpvnzVj-f5WK0OQV.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notosansgeorgian/v36/PlIaFke5O6RzLfvNNVSitxkr76PRHBC4Ytyq-Gof7PUs4S7zWn-8YDB09HFNdptnzFj-f5WK0OQV.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notosansgeorgian/v36/PlIaFke5O6RzLfvNNVSitxkr76PRHBC4Ytyq-Gof7PUs4S7zWn-8YDB09HFNdpu5zFj-f5WK0OQV.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansgeorgian/v36/PlIaFke5O6RzLfvNNVSitxkr76PRHBC4Ytyq-Gof7PUs4S7zWn-8YDB09HFNdpvnzFj-f5WK0OQV.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosansgeorgian/v36/PlIaFke5O6RzLfvNNVSitxkr76PRHBC4Ytyq-Gof7PUs4S7zWn-8YDB09HFNdpvVzFj-f5WK0OQV.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosansgeorgian/v36/PlIaFke5O6RzLfvNNVSitxkr76PRHBC4Ytyq-Gof7PUs4S7zWn-8YDB09HFNdps5y1j-f5WK0OQV.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosansgeorgian/v36/PlIaFke5O6RzLfvNNVSitxkr76PRHBC4Ytyq-Gof7PUs4S7zWn-8YDB09HFNdpsAy1j-f5WK0OQV.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notosansgeorgian/v36/PlIaFke5O6RzLfvNNVSitxkr76PRHBC4Ytyq-Gof7PUs4S7zWn-8YDB09HFNdptny1j-f5WK0OQV.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosansgeorgian/v36/PlIaFke5O6RzLfvNNVSitxkr76PRHBC4Ytyq-Gof7PUs4S7zWn-8YDB09HFNdptOy1j-f5WK0OQV.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Glagolitic\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"glagolitic\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansglagolitic/v15/1q2ZY4-BBFBst88SU_tOj4J-4yuNF_HI4ERK4Amu7nM1.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Gothic\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"gothic\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansgothic/v15/TuGKUUVzXI5FBtUq5a8bj6wRbzxTFMX40kFQRx0.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Grantha\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"grantha\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-28\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansgrantha/v17/3y976akwcCjmsU8NDyrKo3IQfQ4o-r8cFeulHc6N.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Gujarati\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"gujarati\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosansgujarati/v19/wlpWgx_HC1ti5ViekvcxnhMlCVo3f5pv17ivlzsUB14gg1TMR2Gw4VceEl7MA_ypFgPM_OdiEH0s.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notosansgujarati/v19/wlpWgx_HC1ti5ViekvcxnhMlCVo3f5pv17ivlzsUB14gg1TMR2Gw4VceEl7MA_wpFwPM_OdiEH0s.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notosansgujarati/v19/wlpWgx_HC1ti5ViekvcxnhMlCVo3f5pv17ivlzsUB14gg1TMR2Gw4VceEl7MA_z3FwPM_OdiEH0s.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansgujarati/v19/wlpWgx_HC1ti5ViekvcxnhMlCVo3f5pv17ivlzsUB14gg1TMR2Gw4VceEl7MA_ypFwPM_OdiEH0s.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosansgujarati/v19/wlpWgx_HC1ti5ViekvcxnhMlCVo3f5pv17ivlzsUB14gg1TMR2Gw4VceEl7MA_ybFwPM_OdiEH0s.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosansgujarati/v19/wlpWgx_HC1ti5ViekvcxnhMlCVo3f5pv17ivlzsUB14gg1TMR2Gw4VceEl7MA_x3EAPM_OdiEH0s.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosansgujarati/v19/wlpWgx_HC1ti5ViekvcxnhMlCVo3f5pv17ivlzsUB14gg1TMR2Gw4VceEl7MA_xOEAPM_OdiEH0s.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notosansgujarati/v19/wlpWgx_HC1ti5ViekvcxnhMlCVo3f5pv17ivlzsUB14gg1TMR2Gw4VceEl7MA_wpEAPM_OdiEH0s.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosansgujarati/v19/wlpWgx_HC1ti5ViekvcxnhMlCVo3f5pv17ivlzsUB14gg1TMR2Gw4VceEl7MA_wAEAPM_OdiEH0s.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Gunjala Gondi\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"gunjala-gondi\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansgunjalagondi/v15/bWto7e7KfBziStx7lIzKPrcSMwcEnCv6DW7n5hcVXYMTK4q1.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Gurmukhi\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"gurmukhi\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosansgurmukhi/v20/w8g9H3EvQP81sInb43inmyN9zZ7hb7ATbSWo4q8dJ74a3cVrYFQ_bogT0-gPeG1Oe3bxZ_trdp7h.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notosansgurmukhi/v20/w8g9H3EvQP81sInb43inmyN9zZ7hb7ATbSWo4q8dJ74a3cVrYFQ_bogT0-gPeG3OenbxZ_trdp7h.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notosansgurmukhi/v20/w8g9H3EvQP81sInb43inmyN9zZ7hb7ATbSWo4q8dJ74a3cVrYFQ_bogT0-gPeG0QenbxZ_trdp7h.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansgurmukhi/v20/w8g9H3EvQP81sInb43inmyN9zZ7hb7ATbSWo4q8dJ74a3cVrYFQ_bogT0-gPeG1OenbxZ_trdp7h.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosansgurmukhi/v20/w8g9H3EvQP81sInb43inmyN9zZ7hb7ATbSWo4q8dJ74a3cVrYFQ_bogT0-gPeG18enbxZ_trdp7h.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosansgurmukhi/v20/w8g9H3EvQP81sInb43inmyN9zZ7hb7ATbSWo4q8dJ74a3cVrYFQ_bogT0-gPeG2QfXbxZ_trdp7h.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosansgurmukhi/v20/w8g9H3EvQP81sInb43inmyN9zZ7hb7ATbSWo4q8dJ74a3cVrYFQ_bogT0-gPeG2pfXbxZ_trdp7h.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notosansgurmukhi/v20/w8g9H3EvQP81sInb43inmyN9zZ7hb7ATbSWo4q8dJ74a3cVrYFQ_bogT0-gPeG3OfXbxZ_trdp7h.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosansgurmukhi/v20/w8g9H3EvQP81sInb43inmyN9zZ7hb7ATbSWo4q8dJ74a3cVrYFQ_bogT0-gPeG3nfXbxZ_trdp7h.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans HK\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"700\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"chinese-hongkong\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosanshk/v21/nKKO-GM_FYFRJvXzVXaAPe9ZUHp1MOv2ObB7.otf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notosanshk/v21/nKKP-GM_FYFRJvXzVXaAPe9ZmFhTHMX6MKliqQ.otf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanshk/v21/nKKQ-GM_FYFRJvXzVXaAPe9hMnB3Eu7mOQ.otf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosanshk/v21/nKKP-GM_FYFRJvXzVXaAPe9ZwFlTHMX6MKliqQ.otf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosanshk/v21/nKKP-GM_FYFRJvXzVXaAPe9ZiF9THMX6MKliqQ.otf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosanshk/v21/nKKP-GM_FYFRJvXzVXaAPe9ZsF1THMX6MKliqQ.otf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Hanifi Rohingya\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"hanifi-rohingya\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanshanifirohingya/v22/5h17iYsoOmIC3Yu3MDXLDw3UZCgghyOEBBY7hhLNyo3tiaiuSIAqrIYY4j6vvcudK8rN.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosanshanifirohingya/v22/5h17iYsoOmIC3Yu3MDXLDw3UZCgghyOEBBY7hhLNyo3tiaiuSIAqrIYq4j6vvcudK8rN.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosanshanifirohingya/v22/5h17iYsoOmIC3Yu3MDXLDw3UZCgghyOEBBY7hhLNyo3tiaiuSIAqrIbG5T6vvcudK8rN.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosanshanifirohingya/v22/5h17iYsoOmIC3Yu3MDXLDw3UZCgghyOEBBY7hhLNyo3tiaiuSIAqrIb_5T6vvcudK8rN.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Hanunoo\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"hanunoo\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanshanunoo/v17/f0Xs0fCv8dxkDWlZSoXOj6CphMloFsEsEpgL_ix2.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Hatran\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"hatran\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanshatran/v15/A2BBn4Ne0RgnVF3Lnko-0sOBIfL_mM83r1nwzDs.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Hebrew\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v38\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosanshebrew/v38/or3HQ7v33eiDljA1IufXTtVf7V6RvEEdhQlk0LlGxCyaeNKYZC0sqk3xXGiXd4utoiJltutR2g.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notosanshebrew/v38/or3HQ7v33eiDljA1IufXTtVf7V6RvEEdhQlk0LlGxCyaeNKYZC0sqk3xXGiX94qtoiJltutR2g.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notosanshebrew/v38/or3HQ7v33eiDljA1IufXTtVf7V6RvEEdhQlk0LlGxCyaeNKYZC0sqk3xXGiXKYqtoiJltutR2g.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanshebrew/v38/or3HQ7v33eiDljA1IufXTtVf7V6RvEEdhQlk0LlGxCyaeNKYZC0sqk3xXGiXd4qtoiJltutR2g.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosanshebrew/v38/or3HQ7v33eiDljA1IufXTtVf7V6RvEEdhQlk0LlGxCyaeNKYZC0sqk3xXGiXRYqtoiJltutR2g.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosanshebrew/v38/or3HQ7v33eiDljA1IufXTtVf7V6RvEEdhQlk0LlGxCyaeNKYZC0sqk3xXGiXqY2toiJltutR2g.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosanshebrew/v38/or3HQ7v33eiDljA1IufXTtVf7V6RvEEdhQlk0LlGxCyaeNKYZC0sqk3xXGiXkI2toiJltutR2g.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notosanshebrew/v38/or3HQ7v33eiDljA1IufXTtVf7V6RvEEdhQlk0LlGxCyaeNKYZC0sqk3xXGiX942toiJltutR2g.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosanshebrew/v38/or3HQ7v33eiDljA1IufXTtVf7V6RvEEdhQlk0LlGxCyaeNKYZC0sqk3xXGiX3o2toiJltutR2g.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Imperial Aramaic\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"imperial-aramaic\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansimperialaramaic/v15/a8IMNpjwKmHXpgXbMIsbTc_kvks91LlLetBr5itQrtdml3YfPNno.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Indic Siyaq Numbers\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"indic-siyaq-numbers\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansindicsiyaqnumbers/v15/6xK5dTJFKcWIu4bpRBjRZRpsIYHabOeZ8UZLubTzpXNHKx2WPOpVd5Iu.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Inscriptional Pahlavi\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"inscriptional-pahlavi\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansinscriptionalpahlavi/v15/ll8UK3GaVDuxR-TEqFPIbsR79Xxz9WEKbwsjpz7VklYlC7FCVtqVOAYK0QA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Inscriptional Parthian\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"inscriptional-parthian\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansinscriptionalparthian/v15/k3k7o-IMPvpLmixcA63oYi-yStDkgXuXncL7dzfW3P4TAJ2yklBJ2jNkLlLr.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans JP\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"700\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v42\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosansjp/v42/-F6ofjtqLzI2JPCgQBnw7HFQoggM-FNthvIU.otf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notosansjp/v42/-F6pfjtqLzI2JPCgQBnw7HFQaioq1H1hj-sNFQ.otf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansjp/v42/-F62fjtqLzI2JPCgQBnw7HFowAIO2lZ9hg.otf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosansjp/v42/-F6pfjtqLzI2JPCgQBnw7HFQMisq1H1hj-sNFQ.otf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosansjp/v42/-F6pfjtqLzI2JPCgQBnw7HFQei0q1H1hj-sNFQ.otf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosansjp/v42/-F6pfjtqLzI2JPCgQBnw7HFQQi8q1H1hj-sNFQ.otf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Javanese\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"javanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-28\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansjavanese/v19/2V01KJkDAIA6Hp4zoSScDjV0Y-eoHAHT-Z3MngEefiidxJnkFFliZYWj4O8.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosansjavanese/v19/2V01KJkDAIA6Hp4zoSScDjV0Y-eoHAHT-Z3MngEefiidxKvkFFliZYWj4O8.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosansjavanese/v19/2V01KJkDAIA6Hp4zoSScDjV0Y-eoHAHT-Z3MngEefiidxEfjFFliZYWj4O8.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosansjavanese/v19/2V01KJkDAIA6Hp4zoSScDjV0Y-eoHAHT-Z3MngEefiidxH7jFFliZYWj4O8.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans KR\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"700\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"korean\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v27\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosanskr/v27/Pby6FmXiEBPT4ITbgNA5CgmOsn7uwpYcuH8y.otf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notosanskr/v27/Pby7FmXiEBPT4ITbgNA5CgmOelzI7rgQsWYrzw.otf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanskr/v27/PbykFmXiEBPT4ITbgNA5Cgm20HTs4JMMuA.otf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosanskr/v27/Pby7FmXiEBPT4ITbgNA5CgmOIl3I7rgQsWYrzw.otf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosanskr/v27/Pby7FmXiEBPT4ITbgNA5CgmOalvI7rgQsWYrzw.otf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosanskr/v27/Pby7FmXiEBPT4ITbgNA5CgmOUlnI7rgQsWYrzw.otf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Kaithi\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"kaithi\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanskaithi/v16/buEtppS9f8_vkXadMBJJu0tWjLwjQi0KdoZIKlo.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Kannada\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"kannada\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosanskannada/v21/8vIs7xs32H97qzQKnzfeXycxXZyUmySvZWItmf1fe6TVmgop9ndpS-BqHEyGrDvMzSIMLsPKrkY.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notosanskannada/v21/8vIs7xs32H97qzQKnzfeXycxXZyUmySvZWItmf1fe6TVmgop9ndpS-BqHEyGrLvNzSIMLsPKrkY.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notosanskannada/v21/8vIs7xs32H97qzQKnzfeXycxXZyUmySvZWItmf1fe6TVmgop9ndpS-BqHEyGrGXNzSIMLsPKrkY.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanskannada/v21/8vIs7xs32H97qzQKnzfeXycxXZyUmySvZWItmf1fe6TVmgop9ndpS-BqHEyGrDvNzSIMLsPKrkY.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosanskannada/v21/8vIs7xs32H97qzQKnzfeXycxXZyUmySvZWItmf1fe6TVmgop9ndpS-BqHEyGrAnNzSIMLsPKrkY.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosanskannada/v21/8vIs7xs32H97qzQKnzfeXycxXZyUmySvZWItmf1fe6TVmgop9ndpS-BqHEyGrOXKzSIMLsPKrkY.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosanskannada/v21/8vIs7xs32H97qzQKnzfeXycxXZyUmySvZWItmf1fe6TVmgop9ndpS-BqHEyGrNzKzSIMLsPKrkY.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notosanskannada/v21/8vIs7xs32H97qzQKnzfeXycxXZyUmySvZWItmf1fe6TVmgop9ndpS-BqHEyGrLvKzSIMLsPKrkY.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosanskannada/v21/8vIs7xs32H97qzQKnzfeXycxXZyUmySvZWItmf1fe6TVmgop9ndpS-BqHEyGrJLKzSIMLsPKrkY.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Kayah Li\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"kayah-li\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanskayahli/v20/B50nF61OpWTRcGrhOVJJwOMXdca6Yecki3E06x2jVTX3WCc3CZH4EXLuKVM.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosanskayahli/v20/B50nF61OpWTRcGrhOVJJwOMXdca6Yecki3E06x2jVTX3WBU3CZH4EXLuKVM.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosanskayahli/v20/B50nF61OpWTRcGrhOVJJwOMXdca6Yecki3E06x2jVTX3WPkwCZH4EXLuKVM.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosanskayahli/v20/B50nF61OpWTRcGrhOVJJwOMXdca6Yecki3E06x2jVTX3WMAwCZH4EXLuKVM.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Kharoshthi\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"kharoshthi\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanskharoshthi/v15/Fh4qPiLjKS30-P4-pGMMXCCfvkc5Vd7KE5z4rFyx5mR1.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Khmer\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"khmer\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosanskhmer/v18/ijw3s5roRME5LLRxjsRb-gssOenAyendxrgV2c-Zw-9vbVUti_Z_dWgtWYuNAZz4kAbrddiA.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notosanskhmer/v18/ijw3s5roRME5LLRxjsRb-gssOenAyendxrgV2c-Zw-9vbVUti_Z_dWgtWYsNAJz4kAbrddiA.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notosanskhmer/v18/ijw3s5roRME5LLRxjsRb-gssOenAyendxrgV2c-Zw-9vbVUti_Z_dWgtWYvTAJz4kAbrddiA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanskhmer/v18/ijw3s5roRME5LLRxjsRb-gssOenAyendxrgV2c-Zw-9vbVUti_Z_dWgtWYuNAJz4kAbrddiA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosanskhmer/v18/ijw3s5roRME5LLRxjsRb-gssOenAyendxrgV2c-Zw-9vbVUti_Z_dWgtWYu_AJz4kAbrddiA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosanskhmer/v18/ijw3s5roRME5LLRxjsRb-gssOenAyendxrgV2c-Zw-9vbVUti_Z_dWgtWYtTB5z4kAbrddiA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosanskhmer/v18/ijw3s5roRME5LLRxjsRb-gssOenAyendxrgV2c-Zw-9vbVUti_Z_dWgtWYtqB5z4kAbrddiA.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notosanskhmer/v18/ijw3s5roRME5LLRxjsRb-gssOenAyendxrgV2c-Zw-9vbVUti_Z_dWgtWYsNB5z4kAbrddiA.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosanskhmer/v18/ijw3s5roRME5LLRxjsRb-gssOenAyendxrgV2c-Zw-9vbVUti_Z_dWgtWYskB5z4kAbrddiA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Khojki\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"khojki\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanskhojki/v16/-nFnOHM29Oofr2wohFbTuPPKVWpmK_d709jy92k.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Khudawadi\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"khudawadi\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanskhudawadi/v16/fdNi9t6ZsWBZ2k5ltHN73zZ5hc8HANlHIjRnVVXz9MY.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Lao\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"lao\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosanslao/v24/bx6lNx2Ol_ixgdYWLm9BwxM3NW6BOkuf763Clj73CiQ_J1Djx9pidOt4ccfdf5MK3riB2w.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notosanslao/v24/bx6lNx2Ol_ixgdYWLm9BwxM3NW6BOkuf763Clj73CiQ_J1Djx9pidOt48cbdf5MK3riB2w.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notosanslao/v24/bx6lNx2Ol_ixgdYWLm9BwxM3NW6BOkuf763Clj73CiQ_J1Djx9pidOt4L8bdf5MK3riB2w.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanslao/v24/bx6lNx2Ol_ixgdYWLm9BwxM3NW6BOkuf763Clj73CiQ_J1Djx9pidOt4ccbdf5MK3riB2w.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosanslao/v24/bx6lNx2Ol_ixgdYWLm9BwxM3NW6BOkuf763Clj73CiQ_J1Djx9pidOt4Q8bdf5MK3riB2w.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosanslao/v24/bx6lNx2Ol_ixgdYWLm9BwxM3NW6BOkuf763Clj73CiQ_J1Djx9pidOt4r8Hdf5MK3riB2w.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosanslao/v24/bx6lNx2Ol_ixgdYWLm9BwxM3NW6BOkuf763Clj73CiQ_J1Djx9pidOt4lsHdf5MK3riB2w.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notosanslao/v24/bx6lNx2Ol_ixgdYWLm9BwxM3NW6BOkuf763Clj73CiQ_J1Djx9pidOt48cHdf5MK3riB2w.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosanslao/v24/bx6lNx2Ol_ixgdYWLm9BwxM3NW6BOkuf763Clj73CiQ_J1Djx9pidOt42MHdf5MK3riB2w.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Lao Looped\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"lao\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v2\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosanslaolooped/v2/a8IgNpbwKmHXpgXbMIsbSMP7-3U72qUOX5gBg6LRXExhqHIX9YPTpvqkW4UthhjomPr2M-Zw5V_T71k.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notosanslaolooped/v2/a8IgNpbwKmHXpgXbMIsbSMP7-3U72qUOX5gBg6LRXExhqHIX9YPTpvqkW4UthhjomHr3M-Zw5V_T71k.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notosanslaolooped/v2/a8IgNpbwKmHXpgXbMIsbSMP7-3U72qUOX5gBg6LRXExhqHIX9YPTpvqkW4UthhjomKT3M-Zw5V_T71k.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanslaolooped/v2/a8IgNpbwKmHXpgXbMIsbSMP7-3U72qUOX5gBg6LRXExhqHIX9YPTpvqkW4UthhjomPr3M-Zw5V_T71k.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosanslaolooped/v2/a8IgNpbwKmHXpgXbMIsbSMP7-3U72qUOX5gBg6LRXExhqHIX9YPTpvqkW4UthhjomMj3M-Zw5V_T71k.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosanslaolooped/v2/a8IgNpbwKmHXpgXbMIsbSMP7-3U72qUOX5gBg6LRXExhqHIX9YPTpvqkW4UthhjomCTwM-Zw5V_T71k.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosanslaolooped/v2/a8IgNpbwKmHXpgXbMIsbSMP7-3U72qUOX5gBg6LRXExhqHIX9YPTpvqkW4UthhjomB3wM-Zw5V_T71k.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notosanslaolooped/v2/a8IgNpbwKmHXpgXbMIsbSMP7-3U72qUOX5gBg6LRXExhqHIX9YPTpvqkW4UthhjomHrwM-Zw5V_T71k.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosanslaolooped/v2/a8IgNpbwKmHXpgXbMIsbSMP7-3U72qUOX5gBg6LRXExhqHIX9YPTpvqkW4UthhjomFPwM-Zw5V_T71k.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Lepcha\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"lepcha\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanslepcha/v16/0QI7MWlB_JWgA166SKhu05TekNS32AJstqBXgd4.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Limbu\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"limbu\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanslimbu/v22/3JnlSDv90Gmq2mrzckOBBRRoNJVj0MF3OHRDnA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Linear A\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"linear-a\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanslineara/v16/oPWS_l16kP4jCuhpgEGmwJOiA18FZj22zmHQAGQicw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Linear B\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"linear-b\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanslinearb/v15/HhyJU4wt9vSgfHoORYOiXOckKNB737IV3BkFTq4EPw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Lisu\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"lisu\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanslisu/v21/uk-3EGO3o6EruUbnwovcYhz6kh57_nqbcTdjJnHP2Vwt29IlxkVdig.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosanslisu/v21/uk-3EGO3o6EruUbnwovcYhz6kh57_nqbcTdjJnHP61wt29IlxkVdig.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosanslisu/v21/uk-3EGO3o6EruUbnwovcYhz6kh57_nqbcTdjJnHPB1st29IlxkVdig.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosanslisu/v21/uk-3EGO3o6EruUbnwovcYhz6kh57_nqbcTdjJnHPPlst29IlxkVdig.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Lycian\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"lycian\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanslycian/v15/QldVNSNMqAsHtsJ7UmqxBQA9r8wA5_naCJwn00E.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Lydian\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"lydian\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanslydian/v15/c4m71mVzGN7s8FmIukZJ1v4ZlcPReUPXMoIjEQI.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Mahajani\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"mahajani\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansmahajani/v15/-F6sfiVqLzI2JPCgQBnw60Agp0JrvD5Fh8ARHNh4zg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Malayalam\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"malayalam\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosansmalayalam/v21/sJoi3K5XjsSdcnzn071rL37lpAOsUThnDZIfPdbeSNzVakglNM-Qw8EaeB8Nss-_RuH9BFzEr6HxEA.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notosansmalayalam/v21/sJoi3K5XjsSdcnzn071rL37lpAOsUThnDZIfPdbeSNzVakglNM-Qw8EaeB8Nss-_xuD9BFzEr6HxEA.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notosansmalayalam/v21/sJoi3K5XjsSdcnzn071rL37lpAOsUThnDZIfPdbeSNzVakglNM-Qw8EaeB8Nss-_GOD9BFzEr6HxEA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansmalayalam/v21/sJoi3K5XjsSdcnzn071rL37lpAOsUThnDZIfPdbeSNzVakglNM-Qw8EaeB8Nss-_RuD9BFzEr6HxEA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosansmalayalam/v21/sJoi3K5XjsSdcnzn071rL37lpAOsUThnDZIfPdbeSNzVakglNM-Qw8EaeB8Nss-_dOD9BFzEr6HxEA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosansmalayalam/v21/sJoi3K5XjsSdcnzn071rL37lpAOsUThnDZIfPdbeSNzVakglNM-Qw8EaeB8Nss-_mOf9BFzEr6HxEA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosansmalayalam/v21/sJoi3K5XjsSdcnzn071rL37lpAOsUThnDZIfPdbeSNzVakglNM-Qw8EaeB8Nss-_oef9BFzEr6HxEA.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notosansmalayalam/v21/sJoi3K5XjsSdcnzn071rL37lpAOsUThnDZIfPdbeSNzVakglNM-Qw8EaeB8Nss-_xuf9BFzEr6HxEA.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosansmalayalam/v21/sJoi3K5XjsSdcnzn071rL37lpAOsUThnDZIfPdbeSNzVakglNM-Qw8EaeB8Nss-_7-f9BFzEr6HxEA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Mandaic\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"mandaic\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansmandaic/v15/cIfnMbdWt1w_HgCcilqhKQBo_OsMI5_A_gMk0izH.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Manichaean\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"manichaean\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansmanichaean/v15/taiVGntiC4--qtsfi4Jp9-_GkPZZCcrfekqCNTtFCtdX.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Marchen\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"marchen\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-11-02\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansmarchen/v17/aFTO7OZ_Y282EP-WyG6QTOX_C8WZMHhPk652ZaHk.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Masaram Gondi\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"masaram-gondi\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansmasaramgondi/v17/6xK_dThFKcWIu4bpRBjRYRV7KZCbUq6n_1kPnuGe7RI9WSWX.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Math\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"math\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansmath/v15/7Aump_cpkSecTWaHRlH2hyV5UHkG-V048PW0.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Mayan Numerals\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"mayan-numerals\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansmayannumerals/v15/PlIuFk25O6RzLfvNNVSivR09_KqYMwvvDKYjfIiE68oo6eepYQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Medefaidrin\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"medefaidrin\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansmedefaidrin/v21/WwkzxOq6Dk-wranENynkfeVsNbRZtbOIdLb1exeM4ZeuabBfmErWlT318e5A3rw.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosansmedefaidrin/v21/WwkzxOq6Dk-wranENynkfeVsNbRZtbOIdLb1exeM4ZeuabBfmHjWlT318e5A3rw.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosansmedefaidrin/v21/WwkzxOq6Dk-wranENynkfeVsNbRZtbOIdLb1exeM4ZeuabBfmJTRlT318e5A3rw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosansmedefaidrin/v21/WwkzxOq6Dk-wranENynkfeVsNbRZtbOIdLb1exeM4ZeuabBfmK3RlT318e5A3rw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Meetei Mayek\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"meetei-mayek\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-28\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosansmeeteimayek/v14/HTxAL3QyKieByqY9eZPFweO0be7M21uSphSdhqILnmrRfJ8t_1TJ__TW5PgeFYVa.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notosansmeeteimayek/v14/HTxAL3QyKieByqY9eZPFweO0be7M21uSphSdhqILnmrRfJ8t_1RJ_vTW5PgeFYVa.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notosansmeeteimayek/v14/HTxAL3QyKieByqY9eZPFweO0be7M21uSphSdhqILnmrRfJ8t_1SX_vTW5PgeFYVa.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansmeeteimayek/v14/HTxAL3QyKieByqY9eZPFweO0be7M21uSphSdhqILnmrRfJ8t_1TJ_vTW5PgeFYVa.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosansmeeteimayek/v14/HTxAL3QyKieByqY9eZPFweO0be7M21uSphSdhqILnmrRfJ8t_1T7_vTW5PgeFYVa.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosansmeeteimayek/v14/HTxAL3QyKieByqY9eZPFweO0be7M21uSphSdhqILnmrRfJ8t_1QX-fTW5PgeFYVa.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosansmeeteimayek/v14/HTxAL3QyKieByqY9eZPFweO0be7M21uSphSdhqILnmrRfJ8t_1Qu-fTW5PgeFYVa.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notosansmeeteimayek/v14/HTxAL3QyKieByqY9eZPFweO0be7M21uSphSdhqILnmrRfJ8t_1RJ-fTW5PgeFYVa.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosansmeeteimayek/v14/HTxAL3QyKieByqY9eZPFweO0be7M21uSphSdhqILnmrRfJ8t_1Rg-fTW5PgeFYVa.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Mende Kikakui\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"mende-kikakui\"\n\t\t\t],\n\t\t\t\"version\": \"v28\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansmendekikakui/v28/11hRGoLHz17aKjQCWj-JHcLvu2Q5zZrnkbNCLUx_aDJLAHer.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Meroitic\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"meroitic\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansmeroitic/v16/IFS5HfRJndhE3P4b5jnZ3ITPvC6i00UDgDhTiKY9KQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Miao\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"miao\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-28\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansmiao/v17/Dxxz8jmXMW75w3OmoDXVV4zyZUjgUYVslLhx.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Modi\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"modi\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansmodi/v20/pe03MIySN5pO62Z5YkFyT7jeav5qWVAgVol-.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Mongolian\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"mongolian\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansmongolian/v17/VdGCAYADGIwE0EopZx8xQfHlgEAMsrToxLsg6-av1x0.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Mono\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-28\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosansmono/v21/BngrUXNETWXI6LwhGYvaxZikqZqK6fBq6kPvUce2oAZcdthSBUsYck4-_FNI49rXVEQQL8Y.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notosansmono/v21/BngrUXNETWXI6LwhGYvaxZikqZqK6fBq6kPvUce2oAZcdthSBUsYck4-_NNJ49rXVEQQL8Y.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notosansmono/v21/BngrUXNETWXI6LwhGYvaxZikqZqK6fBq6kPvUce2oAZcdthSBUsYck4-_A1J49rXVEQQL8Y.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansmono/v21/BngrUXNETWXI6LwhGYvaxZikqZqK6fBq6kPvUce2oAZcdthSBUsYck4-_FNJ49rXVEQQL8Y.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosansmono/v21/BngrUXNETWXI6LwhGYvaxZikqZqK6fBq6kPvUce2oAZcdthSBUsYck4-_GFJ49rXVEQQL8Y.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosansmono/v21/BngrUXNETWXI6LwhGYvaxZikqZqK6fBq6kPvUce2oAZcdthSBUsYck4-_I1O49rXVEQQL8Y.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosansmono/v21/BngrUXNETWXI6LwhGYvaxZikqZqK6fBq6kPvUce2oAZcdthSBUsYck4-_LRO49rXVEQQL8Y.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notosansmono/v21/BngrUXNETWXI6LwhGYvaxZikqZqK6fBq6kPvUce2oAZcdthSBUsYck4-_NNO49rXVEQQL8Y.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosansmono/v21/BngrUXNETWXI6LwhGYvaxZikqZqK6fBq6kPvUce2oAZcdthSBUsYck4-_PpO49rXVEQQL8Y.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"monospace\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Mro\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"mro\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansmro/v18/qWcsB6--pZv9TqnUQMhe9b39WDzRtjkho4M.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Multani\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"multani\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansmultani/v20/9Bty3ClF38_RfOpe1gCaZ8p30BOFO1A0pfCs5Kos.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Myanmar\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"myanmar\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-28\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosansmyanmar/v20/AlZs_y1ZtY3ymOryg38hOCSdOnFq0HGS1uEapkAC3AY.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notosansmyanmar/v20/AlZv_y1ZtY3ymOryg38hOCSdOnFq0HE-98EwiEwLxR-r.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notosansmyanmar/v20/AlZv_y1ZtY3ymOryg38hOCSdOnFq0HFa9MEwiEwLxR-r.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansmyanmar/v20/AlZq_y1ZtY3ymOryg38hOCSdOnFq0En23OU4o1AC.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosansmyanmar/v20/AlZv_y1ZtY3ymOryg38hOCSdOnFq0HEC9cEwiEwLxR-r.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosansmyanmar/v20/AlZv_y1ZtY3ymOryg38hOCSdOnFq0HEu8sEwiEwLxR-r.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosansmyanmar/v20/AlZv_y1ZtY3ymOryg38hOCSdOnFq0HFK88EwiEwLxR-r.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notosansmyanmar/v20/AlZv_y1ZtY3ymOryg38hOCSdOnFq0HFW8MEwiEwLxR-r.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosansmyanmar/v20/AlZv_y1ZtY3ymOryg38hOCSdOnFq0HFy8cEwiEwLxR-r.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans N Ko\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"nko\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2023-01-18\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansnko/v20/6NUP8FqDKBaKKjnr6P8v-sxPpvVBVNmme3gf.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Nabataean\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"nabataean\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansnabataean/v15/IFS4HfVJndhE3P4b5jnZ34DfsjO330dNoBJ9hK8kMK4.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans New Tai Lue\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"new-tai-lue\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansnewtailue/v17/H4cKBW-Pl9DZ0Xe_nHUapt7PovLXAhAnY7wqaLy-OJgU3p_pdeXAYUbghFPKzeY.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosansnewtailue/v17/H4cKBW-Pl9DZ0Xe_nHUapt7PovLXAhAnY7wqaLy-OJgU3p_pddfAYUbghFPKzeY.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosansnewtailue/v17/H4cKBW-Pl9DZ0Xe_nHUapt7PovLXAhAnY7wqaLy-OJgU3p_pdTvHYUbghFPKzeY.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosansnewtailue/v17/H4cKBW-Pl9DZ0Xe_nHUapt7PovLXAhAnY7wqaLy-OJgU3p_pdQLHYUbghFPKzeY.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Newa\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"newa\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansnewa/v16/7r3fqXp6utEsO9pI4f8ok8sWg8n_qN4R5lNU.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Nushu\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"nushu\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansnushu/v18/rnCw-xRQ3B7652emAbAe_Ai1IYaFWFAMArZKqQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Ogham\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"ogham\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansogham/v15/kmKlZqk1GBDGN0mY6k5lmEmww4hrt5laQxcoCA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Ol Chiki\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"ol-chiki\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansolchiki/v20/N0b92TJNOPt-eHmFZCdQbrL32r-4CvhzDzRwlxOQYuVALWk267I6gVrz5gQ.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosansolchiki/v20/N0b92TJNOPt-eHmFZCdQbrL32r-4CvhzDzRwlxOQYuVALVs267I6gVrz5gQ.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosansolchiki/v20/N0b92TJNOPt-eHmFZCdQbrL32r-4CvhzDzRwlxOQYuVALbcx67I6gVrz5gQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosansolchiki/v20/N0b92TJNOPt-eHmFZCdQbrL32r-4CvhzDzRwlxOQYuVALY4x67I6gVrz5gQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Old Hungarian\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"old-hungarian\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansoldhungarian/v15/E213_cD6hP3GwCJPEUssHEM0KqLaHJXg2PiIgRfjbg5nCYXt.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Old Italic\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"old-italic\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansolditalic/v15/TuGOUUFzXI5FBtUq5a8bh68BJxxEVam7tWlRdRhtCC4d.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Old North Arabian\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"old-north-arabian\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansoldnortharabian/v15/esDF30BdNv-KYGGJpKGk2tNiMt7Jar6olZDyNdr81zBQmUo_xw4ABw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Old Permic\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"old-permic\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansoldpermic/v16/snf1s1q1-dF8pli1TesqcbUY4Mr-ElrwKLdXgv_dKYB5.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Old Persian\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"old-persian\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansoldpersian/v15/wEOjEAbNnc5caQTFG18FHrZr9Bp6-8CmIJ_tqOlQfx9CjA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Old Sogdian\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"old-sogdian\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansoldsogdian/v15/3JnjSCH90Gmq2mrzckOBBhFhdrMst48aURt7neIqM-9uyg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Old South Arabian\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"old-south-arabian\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansoldsoutharabian/v15/3qT5oiOhnSyU8TNFIdhZTice3hB_HWKsEnF--0XCHiKx1OtDT9HwTA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Old Turkic\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"old-turkic\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansoldturkic/v15/yMJNMJVya43H0SUF_WmcGEQVqoEMKDKbsE2RjEw-Vyws.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Oriya\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"oriya\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-28\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosansoriya/v19/AYCppXfzfccDCstK_hrjDyADv5e9748vhj3CJBLHIARtgD6TJQS0dJT5Ivj0fq_c6LhHBRe-.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notosansoriya/v19/AYCppXfzfccDCstK_hrjDyADv5e9748vhj3CJBLHIARtgD6TJQS0dJT5Ivh0f6_c6LhHBRe-.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notosansoriya/v19/AYCppXfzfccDCstK_hrjDyADv5e9748vhj3CJBLHIARtgD6TJQS0dJT5Iviqf6_c6LhHBRe-.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansoriya/v19/AYCppXfzfccDCstK_hrjDyADv5e9748vhj3CJBLHIARtgD6TJQS0dJT5Ivj0f6_c6LhHBRe-.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosansoriya/v19/AYCppXfzfccDCstK_hrjDyADv5e9748vhj3CJBLHIARtgD6TJQS0dJT5IvjGf6_c6LhHBRe-.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosansoriya/v19/AYCppXfzfccDCstK_hrjDyADv5e9748vhj3CJBLHIARtgD6TJQS0dJT5IvgqeK_c6LhHBRe-.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosansoriya/v19/AYCppXfzfccDCstK_hrjDyADv5e9748vhj3CJBLHIARtgD6TJQS0dJT5IvgTeK_c6LhHBRe-.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notosansoriya/v19/AYCppXfzfccDCstK_hrjDyADv5e9748vhj3CJBLHIARtgD6TJQS0dJT5Ivh0eK_c6LhHBRe-.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosansoriya/v19/AYCppXfzfccDCstK_hrjDyADv5e9748vhj3CJBLHIARtgD6TJQS0dJT5IvhdeK_c6LhHBRe-.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Osage\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"osage\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansosage/v18/oPWX_kB6kP4jCuhpgEGmw4mtAVtXRlaSxkrMCQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Osmanya\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"osmanya\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansosmanya/v18/8vIS7xs32H97qzQKnzfeWzUyUpOJmz6kR47NCV5Z.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Pahawh Hmong\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"pahawh-hmong\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanspahawhhmong/v17/bWtp7e_KfBziStx7lIzKKaMUOBEA3UPQDW7krzc_c48aMpM.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Palmyrene\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"palmyrene\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanspalmyrene/v15/ZgNPjOdKPa7CHqq0h37c_ASCWvH93SFCPnK5ZpdNtcA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Pau Cin Hau\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"pau-cin-hau\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanspaucinhau/v19/x3d-cl3IZKmUqiMg_9wBLLtzl22EayN7ehIdjEWqKMxsKw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Phags Pa\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"phags-pa\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansphagspa/v15/pxiZyoo6v8ZYyWh5WuPeJzMkd4SrGChkqkSsrvNXiA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Phoenician\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"phoenician\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansphoenician/v15/jizFRF9Ksm4Bt9PvcTaEkIHiTVtxmFtS5X7Jot-p5561.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Psalter Pahlavi\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"psalter-pahlavi\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanspsalterpahlavi/v15/rP2Vp3K65FkAtHfwd-eISGznYihzggmsicPfud3w1G3KsUQBct4.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Rejang\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"rejang\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansrejang/v18/Ktk2AKuMeZjqPnXgyqrib7DIogqwN4O3WYZB_sU.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Runic\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"runic\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansrunic/v15/H4c_BXWPl9DZ0Xe_nHUaus7W68WWaxpvHtgIYg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans SC\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"700\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"chinese-simplified\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v26\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosanssc/v26/k3kJo84MPvpLmixcA63oeALZTYKL2wv287Sb.otf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notosanssc/v26/k3kIo84MPvpLmixcA63oeALZhaCt9yX6-q2CGg.otf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanssc/v26/k3kXo84MPvpLmixcA63oeALhL4iJ-Q7m8w.otf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosanssc/v26/k3kIo84MPvpLmixcA63oeALZ3aGt9yX6-q2CGg.otf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosanssc/v26/k3kIo84MPvpLmixcA63oeALZlaet9yX6-q2CGg.otf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosanssc/v26/k3kIo84MPvpLmixcA63oeALZraWt9yX6-q2CGg.otf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Samaritan\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"samaritan\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanssamaritan/v15/buEqppe9f8_vkXadMBJJo0tSmaYjFkxOUo5jNlOVMzQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Saurashtra\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"saurashtra\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanssaurashtra/v18/ea8GacQ0Wfz_XKWXe6OtoA8w8zvmYwTef9ndjhPTSIx9.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Sharada\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"sharada\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-11-18\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanssharada/v16/gok0H7rwAEdtF9N8-mdTGALG6p0kwoXLPOwr4H8a.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Shavian\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"shavian\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansshavian/v15/CHy5V_HZE0jxJBQlqAeCKjJvQBNF4EFQSplv2Cwg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Siddham\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"siddham\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanssiddham/v17/OZpZg-FwqiNLe9PELUikxTWDoCCeGqndk3Ic92ZH.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans SignWriting\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"signwriting\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanssignwriting/v1/Noas6VX_wIWFbTTCrYmvy9A2UnkL-2SZAWiUEVCARYQemg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Sinhala\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"sinhala\"\n\t\t\t],\n\t\t\t\"version\": \"v26\",\n\t\t\t\"lastModified\": \"2022-09-28\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosanssinhala/v26/yMJ2MJBya43H0SUF_WmcBEEf4rQVO2P524V5N_MxQzQtb-tf5dJbC30Fu9zUwg2b5lgLpJwbQRM.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notosanssinhala/v26/yMJ2MJBya43H0SUF_WmcBEEf4rQVO2P524V5N_MxQzQtb-tf5dJbC30Fu9zUwo2a5lgLpJwbQRM.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notosanssinhala/v26/yMJ2MJBya43H0SUF_WmcBEEf4rQVO2P524V5N_MxQzQtb-tf5dJbC30Fu9zUwlOa5lgLpJwbQRM.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanssinhala/v26/yMJ2MJBya43H0SUF_WmcBEEf4rQVO2P524V5N_MxQzQtb-tf5dJbC30Fu9zUwg2a5lgLpJwbQRM.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosanssinhala/v26/yMJ2MJBya43H0SUF_WmcBEEf4rQVO2P524V5N_MxQzQtb-tf5dJbC30Fu9zUwj-a5lgLpJwbQRM.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosanssinhala/v26/yMJ2MJBya43H0SUF_WmcBEEf4rQVO2P524V5N_MxQzQtb-tf5dJbC30Fu9zUwtOd5lgLpJwbQRM.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosanssinhala/v26/yMJ2MJBya43H0SUF_WmcBEEf4rQVO2P524V5N_MxQzQtb-tf5dJbC30Fu9zUwuqd5lgLpJwbQRM.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notosanssinhala/v26/yMJ2MJBya43H0SUF_WmcBEEf4rQVO2P524V5N_MxQzQtb-tf5dJbC30Fu9zUwo2d5lgLpJwbQRM.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosanssinhala/v26/yMJ2MJBya43H0SUF_WmcBEEf4rQVO2P524V5N_MxQzQtb-tf5dJbC30Fu9zUwqSd5lgLpJwbQRM.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Sogdian\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"sogdian\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanssogdian/v15/taiQGn5iC4--qtsfi4Jp6eHPnfxQBo--Pm6KHidM.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Sora Sompeng\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"sora-sompeng\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanssorasompeng/v19/PlIRFkO5O6RzLfvNNVSioxM2_OTrEhPyDLolKvCsHzCxWuGkYHR818DpZXJQd4Mu.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosanssorasompeng/v19/PlIRFkO5O6RzLfvNNVSioxM2_OTrEhPyDLolKvCsHzCxWuGkYHRO18DpZXJQd4Mu.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosanssorasompeng/v19/PlIRFkO5O6RzLfvNNVSioxM2_OTrEhPyDLolKvCsHzCxWuGkYHSi0MDpZXJQd4Mu.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosanssorasompeng/v19/PlIRFkO5O6RzLfvNNVSioxM2_OTrEhPyDLolKvCsHzCxWuGkYHSb0MDpZXJQd4Mu.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Soyombo\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"soyombo\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanssoyombo/v15/RWmSoL-Y6-8q5LTtXs6MF6q7xsxgY0FrIFOcK25W.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Sundanese\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"sundanese\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanssundanese/v19/FwZw7_84xUkosG2xJo2gm7nFwSLQkdymq2mkz3Gz1_b6ctxpNNHCizv7fQES.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosanssundanese/v19/FwZw7_84xUkosG2xJo2gm7nFwSLQkdymq2mkz3Gz1_b6ctxbNNHCizv7fQES.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosanssundanese/v19/FwZw7_84xUkosG2xJo2gm7nFwSLQkdymq2mkz3Gz1_b6cty3M9HCizv7fQES.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosanssundanese/v19/FwZw7_84xUkosG2xJo2gm7nFwSLQkdymq2mkz3Gz1_b6ctyOM9HCizv7fQES.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Syloti Nagri\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"syloti-nagri\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanssylotinagri/v20/uU9eCAQZ75uhfF9UoWDRiY3q7Sf_VFV3m4dGFVfxN87gsj0.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Symbols\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"symbols\"\n\t\t\t],\n\t\t\t\"version\": \"v36\",\n\t\t\t\"lastModified\": \"2022-09-28\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosanssymbols/v36/rP2up3q65FkAtHfwd-eIS2brbDN6gxP34F9jRRCe4W3gfQ4gavVFRkzrbQ.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notosanssymbols/v36/rP2up3q65FkAtHfwd-eIS2brbDN6gxP34F9jRRCe4W3g_Q8gavVFRkzrbQ.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notosanssymbols/v36/rP2up3q65FkAtHfwd-eIS2brbDN6gxP34F9jRRCe4W3gIw8gavVFRkzrbQ.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanssymbols/v36/rP2up3q65FkAtHfwd-eIS2brbDN6gxP34F9jRRCe4W3gfQ8gavVFRkzrbQ.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosanssymbols/v36/rP2up3q65FkAtHfwd-eIS2brbDN6gxP34F9jRRCe4W3gTw8gavVFRkzrbQ.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosanssymbols/v36/rP2up3q65FkAtHfwd-eIS2brbDN6gxP34F9jRRCe4W3gowggavVFRkzrbQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosanssymbols/v36/rP2up3q65FkAtHfwd-eIS2brbDN6gxP34F9jRRCe4W3gmgggavVFRkzrbQ.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notosanssymbols/v36/rP2up3q65FkAtHfwd-eIS2brbDN6gxP34F9jRRCe4W3g_QggavVFRkzrbQ.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosanssymbols/v36/rP2up3q65FkAtHfwd-eIS2brbDN6gxP34F9jRRCe4W3g1AggavVFRkzrbQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Symbols 2\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"symbols\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanssymbols2/v17/I_uyMoGduATTei9eI8daxVHDyfisHr71ypPqfX71-AI.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Syriac\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"syriac\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosanssyriac/v15/KtkwAKuMeZjqPnXgyqribqzQqgW0D-e9XaRE7sX5Cg.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanssyriac/v15/Ktk2AKuMeZjqPnXgyqribqzQqgW0N4O3WYZB_sU.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosanssyriac/v15/KtkxAKuMeZjqPnXgyqribqzQqgW0DweafY5q4szgE-Q.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans TC\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"700\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"chinese-traditional\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v26\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosanstc/v26/-nFlOG829Oofr2wohFbTp9i9WyEJIfNZ1sjy.otf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notosanstc/v26/-nFkOG829Oofr2wohFbTp9i9kwMvDd1V39Hr7g.otf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanstc/v26/-nF7OG829Oofr2wohFbTp9iFOSsLA_ZJ1g.otf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosanstc/v26/-nFkOG829Oofr2wohFbTp9i9ywIvDd1V39Hr7g.otf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosanstc/v26/-nFkOG829Oofr2wohFbTp9i9gwQvDd1V39Hr7g.otf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosanstc/v26/-nFkOG829Oofr2wohFbTp9i9uwYvDd1V39Hr7g.otf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Tagalog\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"tagalog\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanstagalog/v17/J7aFnoNzCnFcV9ZI-sUYuvote1R0wwEAA8jHexnL.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Tagbanwa\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"tagbanwa\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanstagbanwa/v17/Y4GWYbB8VTEp4t3MKJSMmQdIKjRtt_nZRjQEaYpGoQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Tai Le\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"tai-le\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanstaile/v17/vEFK2-VODB8RrNDvZSUmVxEATwR58tK1W77HtMo.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Tai Tham\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"tai-tham\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanstaitham/v19/kJEbBv0U4hgtwxDUw2x9q7tbjLIfbPGHBoaVSAZ3MdLJBCUbPgquyaRGKMw.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosanstaitham/v19/kJEbBv0U4hgtwxDUw2x9q7tbjLIfbPGHBoaVSAZ3MdLJBBcbPgquyaRGKMw.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosanstaitham/v19/kJEbBv0U4hgtwxDUw2x9q7tbjLIfbPGHBoaVSAZ3MdLJBPscPgquyaRGKMw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosanstaitham/v19/kJEbBv0U4hgtwxDUw2x9q7tbjLIfbPGHBoaVSAZ3MdLJBMIcPgquyaRGKMw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Tai Viet\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"tai-viet\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanstaiviet/v16/8QIUdj3HhN_lv4jf9vsE-9GMOLsaSPZr644fWsRO9w.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Takri\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"takri\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanstakri/v21/TuGJUVpzXI5FBtUq5a8bnKIOdTwQNO_W3khJXg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Tamil\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"tamil\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosanstamil/v21/ieVc2YdFI3GCY6SyQy1KfStzYKZgzN1z4LKDbeZce-0429tBManUktuex7vGor0RqKDt_EvT.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notosanstamil/v21/ieVc2YdFI3GCY6SyQy1KfStzYKZgzN1z4LKDbeZce-0429tBManUktuex7tGo70RqKDt_EvT.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notosanstamil/v21/ieVc2YdFI3GCY6SyQy1KfStzYKZgzN1z4LKDbeZce-0429tBManUktuex7uYo70RqKDt_EvT.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanstamil/v21/ieVc2YdFI3GCY6SyQy1KfStzYKZgzN1z4LKDbeZce-0429tBManUktuex7vGo70RqKDt_EvT.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosanstamil/v21/ieVc2YdFI3GCY6SyQy1KfStzYKZgzN1z4LKDbeZce-0429tBManUktuex7v0o70RqKDt_EvT.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosanstamil/v21/ieVc2YdFI3GCY6SyQy1KfStzYKZgzN1z4LKDbeZce-0429tBManUktuex7sYpL0RqKDt_EvT.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosanstamil/v21/ieVc2YdFI3GCY6SyQy1KfStzYKZgzN1z4LKDbeZce-0429tBManUktuex7shpL0RqKDt_EvT.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notosanstamil/v21/ieVc2YdFI3GCY6SyQy1KfStzYKZgzN1z4LKDbeZce-0429tBManUktuex7tGpL0RqKDt_EvT.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosanstamil/v21/ieVc2YdFI3GCY6SyQy1KfStzYKZgzN1z4LKDbeZce-0429tBManUktuex7tvpL0RqKDt_EvT.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Tamil Supplement\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"tamil-supplement\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanstamilsupplement/v19/DdTz78kEtnooLS5rXF1DaruiCd_bFp_Ph4sGcn7ax_vsAeMkeq1x.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Tangsa\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"tangsa\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanstangsa/v1/z7NCdQPmcigbbZAIOl9igP26K470lICpky0-peX5Qp1YkyoRYdplyJDA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosanstangsa/v1/z7NCdQPmcigbbZAIOl9igP26K470lICpky0-peX5Qp1qkyoRYdplyJDA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosanstangsa/v1/z7NCdQPmcigbbZAIOl9igP26K470lICpky0-peX5Qp2GlCoRYdplyJDA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosanstangsa/v1/z7NCdQPmcigbbZAIOl9igP26K470lICpky0-peX5Qp2_lCoRYdplyJDA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Telugu\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"telugu\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosanstelugu/v19/0FlxVOGZlE2Rrtr-HmgkMWJNjJ5_RyT8o8c7fHkeg-esVC5dzHkHIJQqrEntezfqQUbf-3v37w.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notosanstelugu/v19/0FlxVOGZlE2Rrtr-HmgkMWJNjJ5_RyT8o8c7fHkeg-esVC5dzHkHIJQqrEnt-zbqQUbf-3v37w.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notosanstelugu/v19/0FlxVOGZlE2Rrtr-HmgkMWJNjJ5_RyT8o8c7fHkeg-esVC5dzHkHIJQqrEntJTbqQUbf-3v37w.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanstelugu/v19/0FlxVOGZlE2Rrtr-HmgkMWJNjJ5_RyT8o8c7fHkeg-esVC5dzHkHIJQqrEntezbqQUbf-3v37w.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosanstelugu/v19/0FlxVOGZlE2Rrtr-HmgkMWJNjJ5_RyT8o8c7fHkeg-esVC5dzHkHIJQqrEntSTbqQUbf-3v37w.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosanstelugu/v19/0FlxVOGZlE2Rrtr-HmgkMWJNjJ5_RyT8o8c7fHkeg-esVC5dzHkHIJQqrEntpTHqQUbf-3v37w.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosanstelugu/v19/0FlxVOGZlE2Rrtr-HmgkMWJNjJ5_RyT8o8c7fHkeg-esVC5dzHkHIJQqrEntnDHqQUbf-3v37w.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notosanstelugu/v19/0FlxVOGZlE2Rrtr-HmgkMWJNjJ5_RyT8o8c7fHkeg-esVC5dzHkHIJQqrEnt-zHqQUbf-3v37w.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosanstelugu/v19/0FlxVOGZlE2Rrtr-HmgkMWJNjJ5_RyT8o8c7fHkeg-esVC5dzHkHIJQqrEnt0jHqQUbf-3v37w.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Thaana\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"thaana\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosansthaana/v18/C8c14dM-vnz-s-3jaEsxlxHkBH-WZOETXfoQrfQ9Y4XrbxLhnu4-tbNu.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notosansthaana/v18/C8c14dM-vnz-s-3jaEsxlxHkBH-WZOETXfoQrfQ9Y4VrbhLhnu4-tbNu.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notosansthaana/v18/C8c14dM-vnz-s-3jaEsxlxHkBH-WZOETXfoQrfQ9Y4W1bhLhnu4-tbNu.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansthaana/v18/C8c14dM-vnz-s-3jaEsxlxHkBH-WZOETXfoQrfQ9Y4XrbhLhnu4-tbNu.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosansthaana/v18/C8c14dM-vnz-s-3jaEsxlxHkBH-WZOETXfoQrfQ9Y4XZbhLhnu4-tbNu.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosansthaana/v18/C8c14dM-vnz-s-3jaEsxlxHkBH-WZOETXfoQrfQ9Y4U1aRLhnu4-tbNu.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosansthaana/v18/C8c14dM-vnz-s-3jaEsxlxHkBH-WZOETXfoQrfQ9Y4UMaRLhnu4-tbNu.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notosansthaana/v18/C8c14dM-vnz-s-3jaEsxlxHkBH-WZOETXfoQrfQ9Y4VraRLhnu4-tbNu.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosansthaana/v18/C8c14dM-vnz-s-3jaEsxlxHkBH-WZOETXfoQrfQ9Y4VCaRLhnu4-tbNu.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Thai\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"thai\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosansthai/v20/iJWnBXeUZi_OHPqn4wq6hQ2_hbJ1xyN9wd43SofNWcd1MKVQt_So_9CdU5RspzF-QRvzzXg.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notosansthai/v20/iJWnBXeUZi_OHPqn4wq6hQ2_hbJ1xyN9wd43SofNWcd1MKVQt_So_9CdUxRtpzF-QRvzzXg.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notosansthai/v20/iJWnBXeUZi_OHPqn4wq6hQ2_hbJ1xyN9wd43SofNWcd1MKVQt_So_9CdU8ptpzF-QRvzzXg.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansthai/v20/iJWnBXeUZi_OHPqn4wq6hQ2_hbJ1xyN9wd43SofNWcd1MKVQt_So_9CdU5RtpzF-QRvzzXg.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosansthai/v20/iJWnBXeUZi_OHPqn4wq6hQ2_hbJ1xyN9wd43SofNWcd1MKVQt_So_9CdU6ZtpzF-QRvzzXg.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosansthai/v20/iJWnBXeUZi_OHPqn4wq6hQ2_hbJ1xyN9wd43SofNWcd1MKVQt_So_9CdU0pqpzF-QRvzzXg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosansthai/v20/iJWnBXeUZi_OHPqn4wq6hQ2_hbJ1xyN9wd43SofNWcd1MKVQt_So_9CdU3NqpzF-QRvzzXg.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notosansthai/v20/iJWnBXeUZi_OHPqn4wq6hQ2_hbJ1xyN9wd43SofNWcd1MKVQt_So_9CdUxRqpzF-QRvzzXg.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosansthai/v20/iJWnBXeUZi_OHPqn4wq6hQ2_hbJ1xyN9wd43SofNWcd1MKVQt_So_9CdUz1qpzF-QRvzzXg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Thai Looped\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"thai\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notosansthailooped/v12/B50fF6pOpWTRcGrhOVJJ3-oPfY7WQuFu5R3YX6AYeCT_Wfd1.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notosansthailooped/v12/B50cF6pOpWTRcGrhOVJJ3-oPfY7WQuFu5R3Y84E4UgrzUO5sKA.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notosansthailooped/v12/B50cF6pOpWTRcGrhOVJJ3-oPfY7WQuFu5R3Yl4I4UgrzUO5sKA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansthailooped/v12/B50RF6pOpWTRcGrhOVJJ3-oPfY7WQuFu5R3gO6ocWiHvWQ.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notosansthailooped/v12/B50cF6pOpWTRcGrhOVJJ3-oPfY7WQuFu5R3Yz4M4UgrzUO5sKA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notosansthailooped/v12/B50cF6pOpWTRcGrhOVJJ3-oPfY7WQuFu5R3Y44Q4UgrzUO5sKA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notosansthailooped/v12/B50cF6pOpWTRcGrhOVJJ3-oPfY7WQuFu5R3Yh4U4UgrzUO5sKA.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notosansthailooped/v12/B50cF6pOpWTRcGrhOVJJ3-oPfY7WQuFu5R3Ym4Y4UgrzUO5sKA.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notosansthailooped/v12/B50cF6pOpWTRcGrhOVJJ3-oPfY7WQuFu5R3Yv4c4UgrzUO5sKA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Tifinagh\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"tifinagh\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanstifinagh/v17/I_uzMoCduATTei9eI8dawkHIwvmhCvbn6rnEcXfs4Q.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Tirhuta\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"tirhuta\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanstirhuta/v15/t5t6IQYRNJ6TWjahPR6X-M-apUyby7uGUBsTrn5P.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Ugaritic\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"ugaritic\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansugaritic/v15/3qTwoiqhnSyU8TNFIdhZVCwbjCpkAXXkMhoIkiazfg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Vai\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vai\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-28\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansvai/v17/NaPecZTSBuhTirw6IaFn_UrURMTsDIRSfr0.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Wancho\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"wancho\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-28\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanswancho/v17/zrf-0GXXyfn6Fs0lH9P4cUubP0GBqAPopiRfKp8.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Warang Citi\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"warang-citi\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-28\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanswarangciti/v17/EYqtmb9SzL1YtsZSScyKDXIeOv3w-zgsNvKRpeVCCXzdgA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Yi\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"yi\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosansyi/v18/sJoD3LFXjsSdcnzn071rO3apxVDJNVgSNg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Sans Zanabazar Square\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"zanabazar-square\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notosanszanabazarsquare/v16/Cn-jJsuGWQxOjaGwMQ6fOicyxLBEMRfDtkzl4uagQtJxOCEgN0Gc.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoserif/v21/ga6Iaw1J5X9T9RW6j9bNTFAcaRi_bMQ.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/notoserif/v21/ga6Kaw1J5X9T9RW6j9bNfFIWbTq6fMRRMw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notoserif/v21/ga6Law1J5X9T9RW6j9bNdOwzTRCUcM1IKoY.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/notoserif/v21/ga6Vaw1J5X9T9RW6j9bNfFIu0RWedO9NOoYIDg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif Ahom\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"ahom\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoserifahom/v17/FeVIS0hfp6cprmEUffAW_fUL_AN-wuYrPFiwaw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif Armenian\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"armenian\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v23\",\n\t\t\t\"lastModified\": \"2022-09-28\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notoserifarmenian/v23/3XFMEqMt3YoFsciDRZxptyCUKJmytZ0kVU-XvF7QaZuL85rnQ_zDNzDe5xNnKxyZi8ObxvXagGdkbg.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notoserifarmenian/v23/3XFMEqMt3YoFsciDRZxptyCUKJmytZ0kVU-XvF7QaZuL85rnQ_zDNzDe5xNnKxyZC8KbxvXagGdkbg.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notoserifarmenian/v23/3XFMEqMt3YoFsciDRZxptyCUKJmytZ0kVU-XvF7QaZuL85rnQ_zDNzDe5xNnKxyZ1cKbxvXagGdkbg.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoserifarmenian/v23/3XFMEqMt3YoFsciDRZxptyCUKJmytZ0kVU-XvF7QaZuL85rnQ_zDNzDe5xNnKxyZi8KbxvXagGdkbg.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notoserifarmenian/v23/3XFMEqMt3YoFsciDRZxptyCUKJmytZ0kVU-XvF7QaZuL85rnQ_zDNzDe5xNnKxyZucKbxvXagGdkbg.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notoserifarmenian/v23/3XFMEqMt3YoFsciDRZxptyCUKJmytZ0kVU-XvF7QaZuL85rnQ_zDNzDe5xNnKxyZVcWbxvXagGdkbg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notoserifarmenian/v23/3XFMEqMt3YoFsciDRZxptyCUKJmytZ0kVU-XvF7QaZuL85rnQ_zDNzDe5xNnKxyZbMWbxvXagGdkbg.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notoserifarmenian/v23/3XFMEqMt3YoFsciDRZxptyCUKJmytZ0kVU-XvF7QaZuL85rnQ_zDNzDe5xNnKxyZC8WbxvXagGdkbg.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notoserifarmenian/v23/3XFMEqMt3YoFsciDRZxptyCUKJmytZ0kVU-XvF7QaZuL85rnQ_zDNzDe5xNnKxyZIsWbxvXagGdkbg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif Balinese\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"balinese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoserifbalinese/v16/QdVKSS0-JginysQSRvuCmUMB_wVeQAxXRbgJdhapcUU.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif Bengali\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"bengali\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notoserifbengali/v19/hYkuPvggTvnzO14VSXltirUdnnkt1pwmWrprmO7RjE0a5BtdATYU1crFaM_5JfcAH3qn4LjQH8yD.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notoserifbengali/v19/hYkuPvggTvnzO14VSXltirUdnnkt1pwmWrprmO7RjE0a5BtdATYU1crFaM_5JfeAHnqn4LjQH8yD.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notoserifbengali/v19/hYkuPvggTvnzO14VSXltirUdnnkt1pwmWrprmO7RjE0a5BtdATYU1crFaM_5JfdeHnqn4LjQH8yD.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoserifbengali/v19/hYkuPvggTvnzO14VSXltirUdnnkt1pwmWrprmO7RjE0a5BtdATYU1crFaM_5JfcAHnqn4LjQH8yD.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notoserifbengali/v19/hYkuPvggTvnzO14VSXltirUdnnkt1pwmWrprmO7RjE0a5BtdATYU1crFaM_5JfcyHnqn4LjQH8yD.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notoserifbengali/v19/hYkuPvggTvnzO14VSXltirUdnnkt1pwmWrprmO7RjE0a5BtdATYU1crFaM_5JffeGXqn4LjQH8yD.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notoserifbengali/v19/hYkuPvggTvnzO14VSXltirUdnnkt1pwmWrprmO7RjE0a5BtdATYU1crFaM_5JffnGXqn4LjQH8yD.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notoserifbengali/v19/hYkuPvggTvnzO14VSXltirUdnnkt1pwmWrprmO7RjE0a5BtdATYU1crFaM_5JfeAGXqn4LjQH8yD.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notoserifbengali/v19/hYkuPvggTvnzO14VSXltirUdnnkt1pwmWrprmO7RjE0a5BtdATYU1crFaM_5JfepGXqn4LjQH8yD.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif Devanagari\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notoserifdevanagari/v21/x3dYcl3IZKmUqiMk48ZHXJ5jwU-DZGRSaQ4Hh2dGyFzPLcQPVbnRNeFsw0xRWb6uxTA-og-HMUe1u_dv.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notoserifdevanagari/v21/x3dYcl3IZKmUqiMk48ZHXJ5jwU-DZGRSaQ4Hh2dGyFzPLcQPVbnRNeFsw0xRWb6uxTC-ow-HMUe1u_dv.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notoserifdevanagari/v21/x3dYcl3IZKmUqiMk48ZHXJ5jwU-DZGRSaQ4Hh2dGyFzPLcQPVbnRNeFsw0xRWb6uxTBgow-HMUe1u_dv.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoserifdevanagari/v21/x3dYcl3IZKmUqiMk48ZHXJ5jwU-DZGRSaQ4Hh2dGyFzPLcQPVbnRNeFsw0xRWb6uxTA-ow-HMUe1u_dv.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notoserifdevanagari/v21/x3dYcl3IZKmUqiMk48ZHXJ5jwU-DZGRSaQ4Hh2dGyFzPLcQPVbnRNeFsw0xRWb6uxTAMow-HMUe1u_dv.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notoserifdevanagari/v21/x3dYcl3IZKmUqiMk48ZHXJ5jwU-DZGRSaQ4Hh2dGyFzPLcQPVbnRNeFsw0xRWb6uxTDgpA-HMUe1u_dv.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notoserifdevanagari/v21/x3dYcl3IZKmUqiMk48ZHXJ5jwU-DZGRSaQ4Hh2dGyFzPLcQPVbnRNeFsw0xRWb6uxTDZpA-HMUe1u_dv.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notoserifdevanagari/v21/x3dYcl3IZKmUqiMk48ZHXJ5jwU-DZGRSaQ4Hh2dGyFzPLcQPVbnRNeFsw0xRWb6uxTC-pA-HMUe1u_dv.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notoserifdevanagari/v21/x3dYcl3IZKmUqiMk48ZHXJ5jwU-DZGRSaQ4Hh2dGyFzPLcQPVbnRNeFsw0xRWb6uxTCXpA-HMUe1u_dv.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif Display\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notoserifdisplay/v17/buERppa9f8_vkXaZLAgP0G5Wi6QmA1QaeYah2sovLCDq_ZgLyt3idQfktOG-PVpd49gKaDU9hvzC.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notoserifdisplay/v17/buERppa9f8_vkXaZLAgP0G5Wi6QmA1QaeYah2sovLCDq_ZgLyt3idQfktOG-PVrd4tgKaDU9hvzC.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notoserifdisplay/v17/buERppa9f8_vkXaZLAgP0G5Wi6QmA1QaeYah2sovLCDq_ZgLyt3idQfktOG-PVoD4tgKaDU9hvzC.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoserifdisplay/v17/buERppa9f8_vkXaZLAgP0G5Wi6QmA1QaeYah2sovLCDq_ZgLyt3idQfktOG-PVpd4tgKaDU9hvzC.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notoserifdisplay/v17/buERppa9f8_vkXaZLAgP0G5Wi6QmA1QaeYah2sovLCDq_ZgLyt3idQfktOG-PVpv4tgKaDU9hvzC.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notoserifdisplay/v17/buERppa9f8_vkXaZLAgP0G5Wi6QmA1QaeYah2sovLCDq_ZgLyt3idQfktOG-PVqD5dgKaDU9hvzC.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notoserifdisplay/v17/buERppa9f8_vkXaZLAgP0G5Wi6QmA1QaeYah2sovLCDq_ZgLyt3idQfktOG-PVq65dgKaDU9hvzC.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notoserifdisplay/v17/buERppa9f8_vkXaZLAgP0G5Wi6QmA1QaeYah2sovLCDq_ZgLyt3idQfktOG-PVrd5dgKaDU9hvzC.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notoserifdisplay/v17/buERppa9f8_vkXaZLAgP0G5Wi6QmA1QaeYah2sovLCDq_ZgLyt3idQfktOG-PVr05dgKaDU9hvzC.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/notoserifdisplay/v17/buEPppa9f8_vkXaZLAgP0G5Wi6QmA1QwcLRCOrN8uo7t6FBJOJTQit-N33sQOk-VoTBIYjEfg-zCmf4.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/notoserifdisplay/v17/buEPppa9f8_vkXaZLAgP0G5Wi6QmA1QwcLRCOrN8uo7t6FBJOJTQit-N33sQOk-VobBJYjEfg-zCmf4.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/notoserifdisplay/v17/buEPppa9f8_vkXaZLAgP0G5Wi6QmA1QwcLRCOrN8uo7t6FBJOJTQit-N33sQOk-VoW5JYjEfg-zCmf4.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/notoserifdisplay/v17/buEPppa9f8_vkXaZLAgP0G5Wi6QmA1QwcLRCOrN8uo7t6FBJOJTQit-N33sQOk-VoTBJYjEfg-zCmf4.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/notoserifdisplay/v17/buEPppa9f8_vkXaZLAgP0G5Wi6QmA1QwcLRCOrN8uo7t6FBJOJTQit-N33sQOk-VoQJJYjEfg-zCmf4.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/notoserifdisplay/v17/buEPppa9f8_vkXaZLAgP0G5Wi6QmA1QwcLRCOrN8uo7t6FBJOJTQit-N33sQOk-Voe5OYjEfg-zCmf4.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/notoserifdisplay/v17/buEPppa9f8_vkXaZLAgP0G5Wi6QmA1QwcLRCOrN8uo7t6FBJOJTQit-N33sQOk-VoddOYjEfg-zCmf4.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/notoserifdisplay/v17/buEPppa9f8_vkXaZLAgP0G5Wi6QmA1QwcLRCOrN8uo7t6FBJOJTQit-N33sQOk-VobBOYjEfg-zCmf4.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/notoserifdisplay/v17/buEPppa9f8_vkXaZLAgP0G5Wi6QmA1QwcLRCOrN8uo7t6FBJOJTQit-N33sQOk-VoZlOYjEfg-zCmf4.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif Dogra\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"dogra\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoserifdogra/v16/MQpP-XquKMC7ROPP3QOOlm7xPu3fGy63IbPzkns.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif Ethiopic\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"ethiopic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notoserifethiopic/v22/V8mjoR7-XjwJ8_Au3Ti5tXj5Rd83frpWLK4d-taxqWw2HMWjDxBAg5S_0QsrggxCzSQjkaO9UVLyiw.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notoserifethiopic/v22/V8mjoR7-XjwJ8_Au3Ti5tXj5Rd83frpWLK4d-taxqWw2HMWjDxBAg5S_0QsrggxCTSUjkaO9UVLyiw.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notoserifethiopic/v22/V8mjoR7-XjwJ8_Au3Ti5tXj5Rd83frpWLK4d-taxqWw2HMWjDxBAg5S_0QsrggxCkyUjkaO9UVLyiw.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoserifethiopic/v22/V8mjoR7-XjwJ8_Au3Ti5tXj5Rd83frpWLK4d-taxqWw2HMWjDxBAg5S_0QsrggxCzSUjkaO9UVLyiw.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notoserifethiopic/v22/V8mjoR7-XjwJ8_Au3Ti5tXj5Rd83frpWLK4d-taxqWw2HMWjDxBAg5S_0QsrggxC_yUjkaO9UVLyiw.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notoserifethiopic/v22/V8mjoR7-XjwJ8_Au3Ti5tXj5Rd83frpWLK4d-taxqWw2HMWjDxBAg5S_0QsrggxCEyIjkaO9UVLyiw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notoserifethiopic/v22/V8mjoR7-XjwJ8_Au3Ti5tXj5Rd83frpWLK4d-taxqWw2HMWjDxBAg5S_0QsrggxCKiIjkaO9UVLyiw.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notoserifethiopic/v22/V8mjoR7-XjwJ8_Au3Ti5tXj5Rd83frpWLK4d-taxqWw2HMWjDxBAg5S_0QsrggxCTSIjkaO9UVLyiw.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notoserifethiopic/v22/V8mjoR7-XjwJ8_Au3Ti5tXj5Rd83frpWLK4d-taxqWw2HMWjDxBAg5S_0QsrggxCZCIjkaO9UVLyiw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif Georgian\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"georgian\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notoserifgeorgian/v18/VEMXRpd8s4nv8hG_qOzL7HOAw4nt0Sl_XxyaEduNMvi7T6Y4etRnmGhyLop-R3aSTvsfdzTw-FgZxQ.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notoserifgeorgian/v18/VEMXRpd8s4nv8hG_qOzL7HOAw4nt0Sl_XxyaEduNMvi7T6Y4etRnmGhyLop-R3aSzvofdzTw-FgZxQ.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notoserifgeorgian/v18/VEMXRpd8s4nv8hG_qOzL7HOAw4nt0Sl_XxyaEduNMvi7T6Y4etRnmGhyLop-R3aSEPofdzTw-FgZxQ.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoserifgeorgian/v18/VEMXRpd8s4nv8hG_qOzL7HOAw4nt0Sl_XxyaEduNMvi7T6Y4etRnmGhyLop-R3aSTvofdzTw-FgZxQ.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notoserifgeorgian/v18/VEMXRpd8s4nv8hG_qOzL7HOAw4nt0Sl_XxyaEduNMvi7T6Y4etRnmGhyLop-R3aSfPofdzTw-FgZxQ.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notoserifgeorgian/v18/VEMXRpd8s4nv8hG_qOzL7HOAw4nt0Sl_XxyaEduNMvi7T6Y4etRnmGhyLop-R3aSkP0fdzTw-FgZxQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notoserifgeorgian/v18/VEMXRpd8s4nv8hG_qOzL7HOAw4nt0Sl_XxyaEduNMvi7T6Y4etRnmGhyLop-R3aSqf0fdzTw-FgZxQ.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notoserifgeorgian/v18/VEMXRpd8s4nv8hG_qOzL7HOAw4nt0Sl_XxyaEduNMvi7T6Y4etRnmGhyLop-R3aSzv0fdzTw-FgZxQ.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notoserifgeorgian/v18/VEMXRpd8s4nv8hG_qOzL7HOAw4nt0Sl_XxyaEduNMvi7T6Y4etRnmGhyLop-R3aS5_0fdzTw-FgZxQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif Grantha\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"grantha\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-28\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoserifgrantha/v19/qkBIXuEH5NzDDvc3fLDYxPk9-Wq3WLiqFENLR7fHGw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif Gujarati\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"gujarati\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notoserifgujarati/v21/hESa6WBlOixO-3OJ1FTmTsmqlBRUJBVkcgNLpdsspzP2HuYycYzuM1Kf-OJu.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notoserifgujarati/v21/hESa6WBlOixO-3OJ1FTmTsmqlBRUJBVkcgNLpdsspzP2HuaycIzuM1Kf-OJu.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notoserifgujarati/v21/hESa6WBlOixO-3OJ1FTmTsmqlBRUJBVkcgNLpdsspzP2HuZscIzuM1Kf-OJu.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoserifgujarati/v21/hESa6WBlOixO-3OJ1FTmTsmqlBRUJBVkcgNLpdsspzP2HuYycIzuM1Kf-OJu.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notoserifgujarati/v21/hESa6WBlOixO-3OJ1FTmTsmqlBRUJBVkcgNLpdsspzP2HuYAcIzuM1Kf-OJu.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notoserifgujarati/v21/hESa6WBlOixO-3OJ1FTmTsmqlBRUJBVkcgNLpdsspzP2Hubsd4zuM1Kf-OJu.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notoserifgujarati/v21/hESa6WBlOixO-3OJ1FTmTsmqlBRUJBVkcgNLpdsspzP2HubVd4zuM1Kf-OJu.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notoserifgujarati/v21/hESa6WBlOixO-3OJ1FTmTsmqlBRUJBVkcgNLpdsspzP2Huayd4zuM1Kf-OJu.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notoserifgujarati/v21/hESa6WBlOixO-3OJ1FTmTsmqlBRUJBVkcgNLpdsspzP2Huabd4zuM1Kf-OJu.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif Gurmukhi\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"gurmukhi\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notoserifgurmukhi/v14/92z-tA9LNqsg7tCYlXdCV1VPnAEeDU0vLoYMbylXk0xTCr6-eBTNmqVU7y6l.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notoserifgurmukhi/v14/92z-tA9LNqsg7tCYlXdCV1VPnAEeDU0vLoYMbylXk0xTCr4-eRTNmqVU7y6l.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notoserifgurmukhi/v14/92z-tA9LNqsg7tCYlXdCV1VPnAEeDU0vLoYMbylXk0xTCr7geRTNmqVU7y6l.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoserifgurmukhi/v14/92z-tA9LNqsg7tCYlXdCV1VPnAEeDU0vLoYMbylXk0xTCr6-eRTNmqVU7y6l.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notoserifgurmukhi/v14/92z-tA9LNqsg7tCYlXdCV1VPnAEeDU0vLoYMbylXk0xTCr6MeRTNmqVU7y6l.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notoserifgurmukhi/v14/92z-tA9LNqsg7tCYlXdCV1VPnAEeDU0vLoYMbylXk0xTCr5gfhTNmqVU7y6l.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notoserifgurmukhi/v14/92z-tA9LNqsg7tCYlXdCV1VPnAEeDU0vLoYMbylXk0xTCr5ZfhTNmqVU7y6l.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notoserifgurmukhi/v14/92z-tA9LNqsg7tCYlXdCV1VPnAEeDU0vLoYMbylXk0xTCr4-fhTNmqVU7y6l.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notoserifgurmukhi/v14/92z-tA9LNqsg7tCYlXdCV1VPnAEeDU0vLoYMbylXk0xTCr4XfhTNmqVU7y6l.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif HK\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"chinese-hongkong\",\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v2\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notoserifhk/v2/BngdUXBETWXI6LwlBZGcqL-B_KuJFcgfwP_9RMf-K2RmV9Su1M6i.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notoserifhk/v2/BngdUXBETWXI6LwlBZGcqL-B_KuJFcgfwP_9RMcgK2RmV9Su1M6i.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoserifhk/v2/BngdUXBETWXI6LwlBZGcqL-B_KuJFcgfwP_9RMd-K2RmV9Su1M6i.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notoserifhk/v2/BngdUXBETWXI6LwlBZGcqL-B_KuJFcgfwP_9RMdMK2RmV9Su1M6i.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notoserifhk/v2/BngdUXBETWXI6LwlBZGcqL-B_KuJFcgfwP_9RMegLGRmV9Su1M6i.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notoserifhk/v2/BngdUXBETWXI6LwlBZGcqL-B_KuJFcgfwP_9RMeZLGRmV9Su1M6i.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notoserifhk/v2/BngdUXBETWXI6LwlBZGcqL-B_KuJFcgfwP_9RMf-LGRmV9Su1M6i.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notoserifhk/v2/BngdUXBETWXI6LwlBZGcqL-B_KuJFcgfwP_9RMfXLGRmV9Su1M6i.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif Hebrew\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notoserifhebrew/v20/k3k0o9MMPvpLmixYH7euCwmkS9DohjX1-kRyiqyBqIxnoLbp93i9IKrXKF_qVAwTAG8_vlQxz24.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notoserifhebrew/v20/k3k0o9MMPvpLmixYH7euCwmkS9DohjX1-kRyiqyBqIxnoLbp93i9IKrXKF_qVIwSAG8_vlQxz24.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notoserifhebrew/v20/k3k0o9MMPvpLmixYH7euCwmkS9DohjX1-kRyiqyBqIxnoLbp93i9IKrXKF_qVFISAG8_vlQxz24.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoserifhebrew/v20/k3k0o9MMPvpLmixYH7euCwmkS9DohjX1-kRyiqyBqIxnoLbp93i9IKrXKF_qVAwSAG8_vlQxz24.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notoserifhebrew/v20/k3k0o9MMPvpLmixYH7euCwmkS9DohjX1-kRyiqyBqIxnoLbp93i9IKrXKF_qVD4SAG8_vlQxz24.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notoserifhebrew/v20/k3k0o9MMPvpLmixYH7euCwmkS9DohjX1-kRyiqyBqIxnoLbp93i9IKrXKF_qVNIVAG8_vlQxz24.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notoserifhebrew/v20/k3k0o9MMPvpLmixYH7euCwmkS9DohjX1-kRyiqyBqIxnoLbp93i9IKrXKF_qVOsVAG8_vlQxz24.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notoserifhebrew/v20/k3k0o9MMPvpLmixYH7euCwmkS9DohjX1-kRyiqyBqIxnoLbp93i9IKrXKF_qVIwVAG8_vlQxz24.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notoserifhebrew/v20/k3k0o9MMPvpLmixYH7euCwmkS9DohjX1-kRyiqyBqIxnoLbp93i9IKrXKF_qVKUVAG8_vlQxz24.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif JP\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notoserifjp/v21/xn77YHs72GKoTvER4Gn3b5eMZBaPRkgfU8fEwb0.otf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notoserifjp/v21/xn77YHs72GKoTvER4Gn3b5eMZHKMRkgfU8fEwb0.otf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoserifjp/v21/xn7mYHs72GKoTvER4Gn3b5eMXNikYkY0T84.otf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notoserifjp/v21/xn77YHs72GKoTvER4Gn3b5eMZCqNRkgfU8fEwb0.otf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notoserifjp/v21/xn77YHs72GKoTvER4Gn3b5eMZAaKRkgfU8fEwb0.otf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notoserifjp/v21/xn77YHs72GKoTvER4Gn3b5eMZGKLRkgfU8fEwb0.otf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notoserifjp/v21/xn77YHs72GKoTvER4Gn3b5eMZFqJRkgfU8fEwb0.otf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif KR\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"korean\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notoserifkr/v20/3JnmSDn90Gmq2mr3blnHaTZXTihC8O1ZNH1ahck.otf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notoserifkr/v20/3JnmSDn90Gmq2mr3blnHaTZXTkxB8O1ZNH1ahck.otf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoserifkr/v20/3Jn7SDn90Gmq2mr3blnHaTZXduZp1ONyKHQ.otf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notoserifkr/v20/3JnmSDn90Gmq2mr3blnHaTZXThRA8O1ZNH1ahck.otf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notoserifkr/v20/3JnmSDn90Gmq2mr3blnHaTZXTjhH8O1ZNH1ahck.otf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notoserifkr/v20/3JnmSDn90Gmq2mr3blnHaTZXTlxG8O1ZNH1ahck.otf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notoserifkr/v20/3JnmSDn90Gmq2mr3blnHaTZXTmRE8O1ZNH1ahck.otf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif Kannada\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"kannada\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notoserifkannada/v21/v6-8GZHLJFKIhClqUYqXDiWqpxQxWSPoW6bz-l4hGHiNgcYCceRJ71svgcI.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notoserifkannada/v21/v6-8GZHLJFKIhClqUYqXDiWqpxQxWSPoW6bz-l4hGHiNgUYDceRJ71svgcI.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notoserifkannada/v21/v6-8GZHLJFKIhClqUYqXDiWqpxQxWSPoW6bz-l4hGHiNgZgDceRJ71svgcI.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoserifkannada/v21/v6-8GZHLJFKIhClqUYqXDiWqpxQxWSPoW6bz-l4hGHiNgcYDceRJ71svgcI.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notoserifkannada/v21/v6-8GZHLJFKIhClqUYqXDiWqpxQxWSPoW6bz-l4hGHiNgfQDceRJ71svgcI.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notoserifkannada/v21/v6-8GZHLJFKIhClqUYqXDiWqpxQxWSPoW6bz-l4hGHiNgRgEceRJ71svgcI.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notoserifkannada/v21/v6-8GZHLJFKIhClqUYqXDiWqpxQxWSPoW6bz-l4hGHiNgSEEceRJ71svgcI.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notoserifkannada/v21/v6-8GZHLJFKIhClqUYqXDiWqpxQxWSPoW6bz-l4hGHiNgUYEceRJ71svgcI.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notoserifkannada/v21/v6-8GZHLJFKIhClqUYqXDiWqpxQxWSPoW6bz-l4hGHiNgW8EceRJ71svgcI.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif Khmer\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"khmer\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notoserifkhmer/v18/-F6UfidqLzI2JPCkXAO2hmogq0146FxtbwKEr951z5s6lI40sDRH_AVhUKdN6B4wXEZK9Xo4xg.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notoserifkhmer/v18/-F6UfidqLzI2JPCkXAO2hmogq0146FxtbwKEr951z5s6lI40sDRH_AVhUKdNaB8wXEZK9Xo4xg.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notoserifkhmer/v18/-F6UfidqLzI2JPCkXAO2hmogq0146FxtbwKEr951z5s6lI40sDRH_AVhUKdNth8wXEZK9Xo4xg.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoserifkhmer/v18/-F6UfidqLzI2JPCkXAO2hmogq0146FxtbwKEr951z5s6lI40sDRH_AVhUKdN6B8wXEZK9Xo4xg.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notoserifkhmer/v18/-F6UfidqLzI2JPCkXAO2hmogq0146FxtbwKEr951z5s6lI40sDRH_AVhUKdN2h8wXEZK9Xo4xg.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notoserifkhmer/v18/-F6UfidqLzI2JPCkXAO2hmogq0146FxtbwKEr951z5s6lI40sDRH_AVhUKdNNhgwXEZK9Xo4xg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notoserifkhmer/v18/-F6UfidqLzI2JPCkXAO2hmogq0146FxtbwKEr951z5s6lI40sDRH_AVhUKdNDxgwXEZK9Xo4xg.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notoserifkhmer/v18/-F6UfidqLzI2JPCkXAO2hmogq0146FxtbwKEr951z5s6lI40sDRH_AVhUKdNaBgwXEZK9Xo4xg.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notoserifkhmer/v18/-F6UfidqLzI2JPCkXAO2hmogq0146FxtbwKEr951z5s6lI40sDRH_AVhUKdNQRgwXEZK9Xo4xg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif Khojki\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"khojki\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v5\",\n\t\t\t\"lastModified\": \"2022-11-18\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoserifkhojki/v5/I_uHMoOduATTei9aP90ctmPGxP2rBKTM4mcQ5M3z9QMY0ghvyZ0Qtc5HAQ.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notoserifkhojki/v5/I_uHMoOduATTei9aP90ctmPGxP2rBKTM4mcQ5M3z9QMY4AhvyZ0Qtc5HAQ.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notoserifkhojki/v5/I_uHMoOduATTei9aP90ctmPGxP2rBKTM4mcQ5M3z9QMYDA9vyZ0Qtc5HAQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notoserifkhojki/v5/I_uHMoOduATTei9aP90ctmPGxP2rBKTM4mcQ5M3z9QMYNQ9vyZ0Qtc5HAQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif Lao\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"lao\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notoseriflao/v18/3y9C6bYwcCjmsU8JEzCMxEwQfEBLk3f0rlSqCdaM_LlSNZ59oNw0BWH8VeMLrvOjlmyhHHQ.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notoseriflao/v18/3y9C6bYwcCjmsU8JEzCMxEwQfEBLk3f0rlSqCdaM_LlSNZ59oNw0BWH8VWMKrvOjlmyhHHQ.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notoseriflao/v18/3y9C6bYwcCjmsU8JEzCMxEwQfEBLk3f0rlSqCdaM_LlSNZ59oNw0BWH8Vb0KrvOjlmyhHHQ.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoseriflao/v18/3y9C6bYwcCjmsU8JEzCMxEwQfEBLk3f0rlSqCdaM_LlSNZ59oNw0BWH8VeMKrvOjlmyhHHQ.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notoseriflao/v18/3y9C6bYwcCjmsU8JEzCMxEwQfEBLk3f0rlSqCdaM_LlSNZ59oNw0BWH8VdEKrvOjlmyhHHQ.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notoseriflao/v18/3y9C6bYwcCjmsU8JEzCMxEwQfEBLk3f0rlSqCdaM_LlSNZ59oNw0BWH8VT0NrvOjlmyhHHQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notoseriflao/v18/3y9C6bYwcCjmsU8JEzCMxEwQfEBLk3f0rlSqCdaM_LlSNZ59oNw0BWH8VQQNrvOjlmyhHHQ.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notoseriflao/v18/3y9C6bYwcCjmsU8JEzCMxEwQfEBLk3f0rlSqCdaM_LlSNZ59oNw0BWH8VWMNrvOjlmyhHHQ.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notoseriflao/v18/3y9C6bYwcCjmsU8JEzCMxEwQfEBLk3f0rlSqCdaM_LlSNZ59oNw0BWH8VUoNrvOjlmyhHHQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif Malayalam\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"malayalam\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notoserifmalayalam/v20/JIAZUU5sdmdP_HMcVcZFcH7DeVBeGVgSMEk2cmVDq1ihUXL1t-1fnVwHpQVySg.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notoserifmalayalam/v20/JIAZUU5sdmdP_HMcVcZFcH7DeVBeGVgSMEk2cmVDq1ihUXL1N-xfnVwHpQVySg.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notoserifmalayalam/v20/JIAZUU5sdmdP_HMcVcZFcH7DeVBeGVgSMEk2cmVDq1ihUXL16exfnVwHpQVySg.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoserifmalayalam/v20/JIAZUU5sdmdP_HMcVcZFcH7DeVBeGVgSMEk2cmVDq1ihUXL1t-xfnVwHpQVySg.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notoserifmalayalam/v20/JIAZUU5sdmdP_HMcVcZFcH7DeVBeGVgSMEk2cmVDq1ihUXL1hexfnVwHpQVySg.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notoserifmalayalam/v20/JIAZUU5sdmdP_HMcVcZFcH7DeVBeGVgSMEk2cmVDq1ihUXL1aetfnVwHpQVySg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notoserifmalayalam/v20/JIAZUU5sdmdP_HMcVcZFcH7DeVBeGVgSMEk2cmVDq1ihUXL1UOtfnVwHpQVySg.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notoserifmalayalam/v20/JIAZUU5sdmdP_HMcVcZFcH7DeVBeGVgSMEk2cmVDq1ihUXL1N-tfnVwHpQVySg.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notoserifmalayalam/v20/JIAZUU5sdmdP_HMcVcZFcH7DeVBeGVgSMEk2cmVDq1ihUXL1HutfnVwHpQVySg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif Myanmar\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"myanmar\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-28\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notoserifmyanmar/v13/VuJudM7F2Yv76aBKKs-bHMQfAHUw3jnNwBDsU9X6RPzQ.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notoserifmyanmar/v13/VuJvdM7F2Yv76aBKKs-bHMQfAHUw3jnNbDHMefv2TeXJng.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notoserifmyanmar/v13/VuJvdM7F2Yv76aBKKs-bHMQfAHUw3jnNCDLMefv2TeXJng.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoserifmyanmar/v13/VuJsdM7F2Yv76aBKKs-bHMQfAHUw3jn1pBrocdDqRA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notoserifmyanmar/v13/VuJvdM7F2Yv76aBKKs-bHMQfAHUw3jnNUDPMefv2TeXJng.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notoserifmyanmar/v13/VuJvdM7F2Yv76aBKKs-bHMQfAHUw3jnNfDTMefv2TeXJng.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notoserifmyanmar/v13/VuJvdM7F2Yv76aBKKs-bHMQfAHUw3jnNGDXMefv2TeXJng.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notoserifmyanmar/v13/VuJvdM7F2Yv76aBKKs-bHMQfAHUw3jnNBDbMefv2TeXJng.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notoserifmyanmar/v13/VuJvdM7F2Yv76aBKKs-bHMQfAHUw3jnNIDfMefv2TeXJng.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif NP Hmong\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"nyiakeng-puachue-hmong\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoserifnphmong/v1/pONN1gItFMO79E4L1GPUi-2sixKHZyFj9Jy6_KhXPwzdvbjPhFLp3u0rVO-d.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notoserifnphmong/v1/pONN1gItFMO79E4L1GPUi-2sixKHZyFj9Jy6_KhXPwzdvbj9hFLp3u0rVO-d.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notoserifnphmong/v1/pONN1gItFMO79E4L1GPUi-2sixKHZyFj9Jy6_KhXPwzdvbgRg1Lp3u0rVO-d.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notoserifnphmong/v1/pONN1gItFMO79E4L1GPUi-2sixKHZyFj9Jy6_KhXPwzdvbgog1Lp3u0rVO-d.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif Nyiakeng Puachue Hmong\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"nyiakeng-puachue-hmong\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-07-19\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoserifnyiakengpuachuehmong/v16/5h1jibMoOmIC3YuzLC-NZyLDZC8iwh-MTC8ggAjEhePFNRVcneAFp44kcYMUkNqVKhqPDFvbZkrZmb0.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notoserifnyiakengpuachuehmong/v16/5h1jibMoOmIC3YuzLC-NZyLDZC8iwh-MTC8ggAjEhePFNRVcneAFp44kcYMUkNqVKiiPDFvbZkrZmb0.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notoserifnyiakengpuachuehmong/v16/5h1jibMoOmIC3YuzLC-NZyLDZC8iwh-MTC8ggAjEhePFNRVcneAFp44kcYMUkNqVKsSIDFvbZkrZmb0.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notoserifnyiakengpuachuehmong/v16/5h1jibMoOmIC3YuzLC-NZyLDZC8iwh-MTC8ggAjEhePFNRVcneAFp44kcYMUkNqVKv2IDFvbZkrZmb0.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif Oriya\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"oriya\"\n\t\t\t],\n\t\t\t\"version\": \"v2\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoseriforiya/v2/MjQQmj56u-r69izk_LDqWN7w0cYByutv9qeWYrvLaxrc_Hy-v039MF1j.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notoseriforiya/v2/MjQQmj56u-r69izk_LDqWN7w0cYByutv9qeWYrvLaxru_Hy-v039MF1j.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notoseriforiya/v2/MjQQmj56u-r69izk_LDqWN7w0cYByutv9qeWYrvLaxoC-3y-v039MF1j.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notoseriforiya/v2/MjQQmj56u-r69izk_LDqWN7w0cYByutv9qeWYrvLaxo7-3y-v039MF1j.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif SC\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"chinese-simplified\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notoserifsc/v22/H4c8BXePl9DZ0Xe7gG9cyOj7mm63SzZBEtERe7U.otf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notoserifsc/v22/H4c8BXePl9DZ0Xe7gG9cyOj7mgq0SzZBEtERe7U.otf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoserifsc/v22/H4chBXePl9DZ0Xe7gG9cyOj7oqCcbzhqDtg.otf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notoserifsc/v22/H4c8BXePl9DZ0Xe7gG9cyOj7mlK1SzZBEtERe7U.otf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notoserifsc/v22/H4c8BXePl9DZ0Xe7gG9cyOj7mn6ySzZBEtERe7U.otf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notoserifsc/v22/H4c8BXePl9DZ0Xe7gG9cyOj7mhqzSzZBEtERe7U.otf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notoserifsc/v22/H4c8BXePl9DZ0Xe7gG9cyOj7miKxSzZBEtERe7U.otf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif Sinhala\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"sinhala\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notoserifsinhala/v18/DtVEJwinQqclnZE2CnsPug9lgGC3y2F2nehQ7Eg4EdBKWxPiDxMivFLgRXs_-pGxRlMsxaLRn3W-.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notoserifsinhala/v18/DtVEJwinQqclnZE2CnsPug9lgGC3y2F2nehQ7Eg4EdBKWxPiDxMivFLgRXs_-pExR1MsxaLRn3W-.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notoserifsinhala/v18/DtVEJwinQqclnZE2CnsPug9lgGC3y2F2nehQ7Eg4EdBKWxPiDxMivFLgRXs_-pHvR1MsxaLRn3W-.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoserifsinhala/v18/DtVEJwinQqclnZE2CnsPug9lgGC3y2F2nehQ7Eg4EdBKWxPiDxMivFLgRXs_-pGxR1MsxaLRn3W-.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notoserifsinhala/v18/DtVEJwinQqclnZE2CnsPug9lgGC3y2F2nehQ7Eg4EdBKWxPiDxMivFLgRXs_-pGDR1MsxaLRn3W-.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notoserifsinhala/v18/DtVEJwinQqclnZE2CnsPug9lgGC3y2F2nehQ7Eg4EdBKWxPiDxMivFLgRXs_-pFvQFMsxaLRn3W-.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notoserifsinhala/v18/DtVEJwinQqclnZE2CnsPug9lgGC3y2F2nehQ7Eg4EdBKWxPiDxMivFLgRXs_-pFWQFMsxaLRn3W-.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notoserifsinhala/v18/DtVEJwinQqclnZE2CnsPug9lgGC3y2F2nehQ7Eg4EdBKWxPiDxMivFLgRXs_-pExQFMsxaLRn3W-.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notoserifsinhala/v18/DtVEJwinQqclnZE2CnsPug9lgGC3y2F2nehQ7Eg4EdBKWxPiDxMivFLgRXs_-pEYQFMsxaLRn3W-.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif TC\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"chinese-traditional\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v23\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notoseriftc/v23/XLY9IZb5bJNDGYxLBibeHZ0Bvr8vbX9GTsoOAX4.otf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notoseriftc/v23/XLY9IZb5bJNDGYxLBibeHZ0BvtssbX9GTsoOAX4.otf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoseriftc/v23/XLYgIZb5bJNDGYxLBibeHZ0BhnEESXFtUsM.otf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notoseriftc/v23/XLY9IZb5bJNDGYxLBibeHZ0BvoMtbX9GTsoOAX4.otf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notoseriftc/v23/XLY9IZb5bJNDGYxLBibeHZ0Bvq8qbX9GTsoOAX4.otf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notoseriftc/v23/XLY9IZb5bJNDGYxLBibeHZ0BvssrbX9GTsoOAX4.otf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notoseriftc/v23/XLY9IZb5bJNDGYxLBibeHZ0BvvMpbX9GTsoOAX4.otf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif Tamil\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"tamil\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notoseriftamil/v21/LYjndHr-klIgTfc40komjQ5OObazYp-6H94dBF-RX6nNRJfi-Gf55IgAecattN6R8Pz3v8Etew.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notoseriftamil/v21/LYjndHr-klIgTfc40komjQ5OObazYp-6H94dBF-RX6nNRJfi-Gf55IgAecatNN-R8Pz3v8Etew.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notoseriftamil/v21/LYjndHr-klIgTfc40komjQ5OObazYp-6H94dBF-RX6nNRJfi-Gf55IgAecat6t-R8Pz3v8Etew.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoseriftamil/v21/LYjndHr-klIgTfc40komjQ5OObazYp-6H94dBF-RX6nNRJfi-Gf55IgAecattN-R8Pz3v8Etew.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notoseriftamil/v21/LYjndHr-klIgTfc40komjQ5OObazYp-6H94dBF-RX6nNRJfi-Gf55IgAecatht-R8Pz3v8Etew.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notoseriftamil/v21/LYjndHr-klIgTfc40komjQ5OObazYp-6H94dBF-RX6nNRJfi-Gf55IgAecatatiR8Pz3v8Etew.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notoseriftamil/v21/LYjndHr-klIgTfc40komjQ5OObazYp-6H94dBF-RX6nNRJfi-Gf55IgAecatU9iR8Pz3v8Etew.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notoseriftamil/v21/LYjndHr-klIgTfc40komjQ5OObazYp-6H94dBF-RX6nNRJfi-Gf55IgAecatNNiR8Pz3v8Etew.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notoseriftamil/v21/LYjndHr-klIgTfc40komjQ5OObazYp-6H94dBF-RX6nNRJfi-Gf55IgAecatHdiR8Pz3v8Etew.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/notoseriftamil/v21/LYjldHr-klIgTfc40komjQ5OObazSJaI_D5kV8k_WLwFBmWrypghjeOa18G4fJx5svbzncQ9e3wx.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/notoseriftamil/v21/LYjldHr-klIgTfc40komjQ5OObazSJaI_D5kV8k_WLwFBmWrypghjeOa18G4fJz5s_bzncQ9e3wx.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/notoseriftamil/v21/LYjldHr-klIgTfc40komjQ5OObazSJaI_D5kV8k_WLwFBmWrypghjeOa18G4fJwns_bzncQ9e3wx.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/notoseriftamil/v21/LYjldHr-klIgTfc40komjQ5OObazSJaI_D5kV8k_WLwFBmWrypghjeOa18G4fJx5s_bzncQ9e3wx.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/notoseriftamil/v21/LYjldHr-klIgTfc40komjQ5OObazSJaI_D5kV8k_WLwFBmWrypghjeOa18G4fJxLs_bzncQ9e3wx.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/notoseriftamil/v21/LYjldHr-klIgTfc40komjQ5OObazSJaI_D5kV8k_WLwFBmWrypghjeOa18G4fJyntPbzncQ9e3wx.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/notoseriftamil/v21/LYjldHr-klIgTfc40komjQ5OObazSJaI_D5kV8k_WLwFBmWrypghjeOa18G4fJyetPbzncQ9e3wx.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/notoseriftamil/v21/LYjldHr-klIgTfc40komjQ5OObazSJaI_D5kV8k_WLwFBmWrypghjeOa18G4fJz5tPbzncQ9e3wx.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/notoseriftamil/v21/LYjldHr-klIgTfc40komjQ5OObazSJaI_D5kV8k_WLwFBmWrypghjeOa18G4fJzQtPbzncQ9e3wx.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif Tangut\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"tangut\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoseriftangut/v15/xn76YGc72GKoTvER4Gn3b4m9Ern7Em41fcvN2KT4.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif Telugu\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"telugu\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notoseriftelugu/v20/tDbl2pCbnkEKmXNVmt2M1q6f4HWbbj6MRbYEeav7Fe9D9TGwuY2fjgrZYA.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notoseriftelugu/v20/tDbl2pCbnkEKmXNVmt2M1q6f4HWbbj6MRbYEeav7Fe9DdTCwuY2fjgrZYA.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notoseriftelugu/v20/tDbl2pCbnkEKmXNVmt2M1q6f4HWbbj6MRbYEeav7Fe9DqzCwuY2fjgrZYA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoseriftelugu/v20/tDbl2pCbnkEKmXNVmt2M1q6f4HWbbj6MRbYEeav7Fe9D9TCwuY2fjgrZYA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notoseriftelugu/v20/tDbl2pCbnkEKmXNVmt2M1q6f4HWbbj6MRbYEeav7Fe9DxzCwuY2fjgrZYA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notoseriftelugu/v20/tDbl2pCbnkEKmXNVmt2M1q6f4HWbbj6MRbYEeav7Fe9DKzewuY2fjgrZYA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notoseriftelugu/v20/tDbl2pCbnkEKmXNVmt2M1q6f4HWbbj6MRbYEeav7Fe9DEjewuY2fjgrZYA.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notoseriftelugu/v20/tDbl2pCbnkEKmXNVmt2M1q6f4HWbbj6MRbYEeav7Fe9DdTewuY2fjgrZYA.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notoseriftelugu/v20/tDbl2pCbnkEKmXNVmt2M1q6f4HWbbj6MRbYEeav7Fe9DXDewuY2fjgrZYA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif Thai\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"thai\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notoserifthai/v19/k3kyo80MPvpLmixYH7euCxWpSMu3-gcWGj0hHAKGvUQlUv_bCKDUSzB5L0oiFuRRCmsdu0Qx.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notoserifthai/v19/k3kyo80MPvpLmixYH7euCxWpSMu3-gcWGj0hHAKGvUQlUv_bCKDUSzB5L0qiF-RRCmsdu0Qx.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notoserifthai/v19/k3kyo80MPvpLmixYH7euCxWpSMu3-gcWGj0hHAKGvUQlUv_bCKDUSzB5L0p8F-RRCmsdu0Qx.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoserifthai/v19/k3kyo80MPvpLmixYH7euCxWpSMu3-gcWGj0hHAKGvUQlUv_bCKDUSzB5L0oiF-RRCmsdu0Qx.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notoserifthai/v19/k3kyo80MPvpLmixYH7euCxWpSMu3-gcWGj0hHAKGvUQlUv_bCKDUSzB5L0oQF-RRCmsdu0Qx.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notoserifthai/v19/k3kyo80MPvpLmixYH7euCxWpSMu3-gcWGj0hHAKGvUQlUv_bCKDUSzB5L0r8EORRCmsdu0Qx.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notoserifthai/v19/k3kyo80MPvpLmixYH7euCxWpSMu3-gcWGj0hHAKGvUQlUv_bCKDUSzB5L0rFEORRCmsdu0Qx.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notoserifthai/v19/k3kyo80MPvpLmixYH7euCxWpSMu3-gcWGj0hHAKGvUQlUv_bCKDUSzB5L0qiEORRCmsdu0Qx.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notoserifthai/v19/k3kyo80MPvpLmixYH7euCxWpSMu3-gcWGj0hHAKGvUQlUv_bCKDUSzB5L0qLEORRCmsdu0Qx.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif Tibetan\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"tibetan\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/notoseriftibetan/v18/gokGH7nwAEdtF9N45n0Vaz7O-pk0wsvxHeDXMfqguoCmIrYdPS7rdSy_32c.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/notoseriftibetan/v18/gokGH7nwAEdtF9N45n0Vaz7O-pk0wsvxHeDXMfqguoCmIjYcPS7rdSy_32c.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/notoseriftibetan/v18/gokGH7nwAEdtF9N45n0Vaz7O-pk0wsvxHeDXMfqguoCmIugcPS7rdSy_32c.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoseriftibetan/v18/gokGH7nwAEdtF9N45n0Vaz7O-pk0wsvxHeDXMfqguoCmIrYcPS7rdSy_32c.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notoseriftibetan/v18/gokGH7nwAEdtF9N45n0Vaz7O-pk0wsvxHeDXMfqguoCmIoQcPS7rdSy_32c.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notoseriftibetan/v18/gokGH7nwAEdtF9N45n0Vaz7O-pk0wsvxHeDXMfqguoCmImgbPS7rdSy_32c.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notoseriftibetan/v18/gokGH7nwAEdtF9N45n0Vaz7O-pk0wsvxHeDXMfqguoCmIlEbPS7rdSy_32c.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/notoseriftibetan/v18/gokGH7nwAEdtF9N45n0Vaz7O-pk0wsvxHeDXMfqguoCmIjYbPS7rdSy_32c.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/notoseriftibetan/v18/gokGH7nwAEdtF9N45n0Vaz7O-pk0wsvxHeDXMfqguoCmIh8bPS7rdSy_32c.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif Toto\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"toto\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoseriftoto/v1/Ktk6ALSMeZjqPnXk1rCkHYHNtwvtHItpjRP74dHhCy3Il-aj55vdNug.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notoseriftoto/v1/Ktk6ALSMeZjqPnXk1rCkHYHNtwvtHItpjRP74dHhCx_Il-aj55vdNug.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notoseriftoto/v1/Ktk6ALSMeZjqPnXk1rCkHYHNtwvtHItpjRP74dHhC_PPl-aj55vdNug.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notoseriftoto/v1/Ktk6ALSMeZjqPnXk1rCkHYHNtwvtHItpjRP74dHhC8rPl-aj55vdNug.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Serif Yezidi\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"yezidi\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-07-19\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/notoserifyezidi/v16/XLYPIYr5bJNDGYxLBibeHZAn3B5KJENnQjbfhMSVZspD2yEkrlGJgmVCqg.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/notoserifyezidi/v16/XLYPIYr5bJNDGYxLBibeHZAn3B5KJENnQjbfhMSVZspD6SEkrlGJgmVCqg.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/notoserifyezidi/v16/XLYPIYr5bJNDGYxLBibeHZAn3B5KJENnQjbfhMSVZspDBSYkrlGJgmVCqg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/notoserifyezidi/v16/XLYPIYr5bJNDGYxLBibeHZAn3B5KJENnQjbfhMSVZspDPCYkrlGJgmVCqg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Noto Traditional Nushu\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"nushu\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/nototraditionalnushu/v16/SZco3EDkJ7q9FaoMPlmF4Su8hlIjoGh5aj67J011GNh6SYA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Nova Cut\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/novacut/v24/KFOkCnSYu8mL-39LkWxPKTM1K9nz.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Nova Flat\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/novaflat/v24/QdVUSTc-JgqpytEbVebEuStkm20oJA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Nova Mono\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"greek\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/novamono/v18/Cn-0JtiGWQ5Ajb--MRKfYGxYrdM9Sg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"monospace\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Nova Oval\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/novaoval/v24/jAnEgHdmANHvPenMaswCMY-h3cWkWg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Nova Round\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/novaround/v21/flU9Rqquw5UhEnlwTJYTYYfeeetYEBc.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Nova Script\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v25\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/novascript/v25/7Au7p_IpkSWSTWaFWkumvmQNEl0O0kEx.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Nova Slim\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/novaslim/v24/Z9XUDmZNQAuem8jyZcn-yMOInrib9Q.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Nova Square\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/novasquare/v20/RrQUbo9-9DV7b06QHgSWsZhARYMgGtWA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Numans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/numans/v15/SlGRmQmGupYAfH8IYRggiHVqaQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Nunito\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v25\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/nunito/v25/XRXI3I6Li01BKofiOc5wtlZ2di8HDDshRTM9jo7eTWk.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/nunito/v25/XRXI3I6Li01BKofiOc5wtlZ2di8HDOUhRTM9jo7eTWk.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/nunito/v25/XRXI3I6Li01BKofiOc5wtlZ2di8HDLshRTM9jo7eTWk.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/nunito/v25/XRXI3I6Li01BKofiOc5wtlZ2di8HDIkhRTM9jo7eTWk.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/nunito/v25/XRXI3I6Li01BKofiOc5wtlZ2di8HDGUmRTM9jo7eTWk.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/nunito/v25/XRXI3I6Li01BKofiOc5wtlZ2di8HDFwmRTM9jo7eTWk.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/nunito/v25/XRXI3I6Li01BKofiOc5wtlZ2di8HDDsmRTM9jo7eTWk.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/nunito/v25/XRXI3I6Li01BKofiOc5wtlZ2di8HDBImRTM9jo7eTWk.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/nunito/v25/XRXK3I6Li01BKofIMPyPbj8d7IEAGXNiLXA3iqzbXWnoeg.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/nunito/v25/XRXK3I6Li01BKofIMPyPbj8d7IEAGXNi83A3iqzbXWnoeg.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/nunito/v25/XRXK3I6Li01BKofIMPyPbj8d7IEAGXNirXA3iqzbXWnoeg.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/nunito/v25/XRXK3I6Li01BKofIMPyPbj8d7IEAGXNin3A3iqzbXWnoeg.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/nunito/v25/XRXK3I6Li01BKofIMPyPbj8d7IEAGXNic3c3iqzbXWnoeg.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/nunito/v25/XRXK3I6Li01BKofIMPyPbj8d7IEAGXNiSnc3iqzbXWnoeg.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/nunito/v25/XRXK3I6Li01BKofIMPyPbj8d7IEAGXNiLXc3iqzbXWnoeg.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/nunito/v25/XRXK3I6Li01BKofIMPyPbj8d7IEAGXNiBHc3iqzbXWnoeg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Nunito Sans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/nunitosans/v12/pe03MImSLYBIv1o4X1M8cc9yAv5qWVAgVol-.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/nunitosans/v12/pe01MImSLYBIv1o4X1M8cce4GxZrU1QCU5l-06Y.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/nunitosans/v12/pe03MImSLYBIv1o4X1M8cc8WAf5qWVAgVol-.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/nunitosans/v12/pe01MImSLYBIv1o4X1M8cce4G3JoU1QCU5l-06Y.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/nunitosans/v12/pe0qMImSLYBIv1o4X1M8cfe6Kdpickwp.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/nunitosans/v12/pe0oMImSLYBIv1o4X1M8cce4I95Ad1wpT5A.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/nunitosans/v12/pe03MImSLYBIv1o4X1M8cc9iB_5qWVAgVol-.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/nunitosans/v12/pe01MImSLYBIv1o4X1M8cce4GwZuU1QCU5l-06Y.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/nunitosans/v12/pe03MImSLYBIv1o4X1M8cc8GBv5qWVAgVol-.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/nunitosans/v12/pe01MImSLYBIv1o4X1M8cce4G2JvU1QCU5l-06Y.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/nunitosans/v12/pe03MImSLYBIv1o4X1M8cc8aBf5qWVAgVol-.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/nunitosans/v12/pe01MImSLYBIv1o4X1M8cce4G35sU1QCU5l-06Y.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/nunitosans/v12/pe03MImSLYBIv1o4X1M8cc8-BP5qWVAgVol-.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/nunitosans/v12/pe01MImSLYBIv1o4X1M8cce4G1ptU1QCU5l-06Y.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Nuosu SIL\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"yi\"\n\t\t\t],\n\t\t\t\"version\": \"v3\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/nuosusil/v3/8vIK7wM3wmRn_kc4uAjeFGxbO_zo-w.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Odibee Sans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/odibeesans/v14/neIPzCSooYAho6WvjeToRYkyepH9qGsf.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Odor Mean Chey\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"khmer\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v27\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/odormeanchey/v27/raxkHiKDttkTe1aOGcJMR1A_4mrY2zqUKafv.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Offside\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/offside/v20/HI_KiYMWKa9QrAykQ5HiRp-dhpQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Oi\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"tamil\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/oi/v15/w8gXH2EuRqtaut6yjBOG.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Old Standard TT\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/oldstandardtt/v18/MwQubh3o1vLImiwAVvYawgcf2eVurVC5RHdCZg.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/oldstandardtt/v18/MwQsbh3o1vLImiwAVvYawgcf2eVer1q9ZnJSZtQG.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/oldstandardtt/v18/MwQrbh3o1vLImiwAVvYawgcf2eVWEX-dTFxeb80flQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Oldenburg\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/oldenburg/v20/fC1jPY5JYWzbywv7c4V6UU6oXyndrw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Ole\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v3\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ole/v3/dFazZf6Z-rd89fw69qJ_ew.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Oleo Script\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/oleoscript/v14/rax5HieDvtMOe0iICsUccBhasU7Q8Cad.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/oleoscript/v14/raxkHieDvtMOe0iICsUccCDmnmrY2zqUKafv.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Oleo Script Swash Caps\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/oleoscriptswashcaps/v13/Noaj6Vb-w5SFbTTAsZP_7JkCS08K-jCzDn_HMXquSY0Hg90.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/oleoscriptswashcaps/v13/Noag6Vb-w5SFbTTAsZP_7JkCS08K-jCzDn_HCcaBbYUsn9T5dt0.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Oooh Baby\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v3\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ooohbaby/v3/2sDcZGJWgJTT2Jf76xQDb2-4C7wFZQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Open Sans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v34\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/opensans/v34/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsiH0C4nY1M2xLER.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/opensans/v34/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjZ0C4nY1M2xLER.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/opensans/v34/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjr0C4nY1M2xLER.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/opensans/v34/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsgH1y4nY1M2xLER.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/opensans/v34/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsg-1y4nY1M2xLER.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/opensans/v34/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgshZ1y4nY1M2xLER.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/opensans/v34/memQYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWq8tWZ0Pw86hd0Rk5hkaVcUwaERZjA.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/opensans/v34/memQYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWq8tWZ0Pw86hd0Rk8ZkaVcUwaERZjA.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/opensans/v34/memQYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWq8tWZ0Pw86hd0Rk_RkaVcUwaERZjA.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/opensans/v34/memQYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWq8tWZ0Pw86hd0RkxhjaVcUwaERZjA.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/opensans/v34/memQYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWq8tWZ0Pw86hd0RkyFjaVcUwaERZjA.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/opensans/v34/memQYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWq8tWZ0Pw86hd0Rk0ZjaVcUwaERZjA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Oranienbaum\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/oranienbaum/v15/OZpHg_txtzZKMuXLIVrx-3zn7kz3dpHc.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Orbitron\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v25\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/orbitron/v25/yMJMMIlzdpvBhQQL_SC3X9yhF25-T1nyGy6xpmIyXjU1pg.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/orbitron/v25/yMJMMIlzdpvBhQQL_SC3X9yhF25-T1nyKS6xpmIyXjU1pg.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/orbitron/v25/yMJMMIlzdpvBhQQL_SC3X9yhF25-T1nyxSmxpmIyXjU1pg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/orbitron/v25/yMJMMIlzdpvBhQQL_SC3X9yhF25-T1ny_CmxpmIyXjU1pg.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/orbitron/v25/yMJMMIlzdpvBhQQL_SC3X9yhF25-T1nymymxpmIyXjU1pg.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/orbitron/v25/yMJMMIlzdpvBhQQL_SC3X9yhF25-T1nysimxpmIyXjU1pg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Oregano\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/oregano/v13/If2IXTPxciS3H4S2kZffPznO3yM.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/oregano/v13/If2KXTPxciS3H4S2oZXVOxvLzyP_qw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Orelega One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/orelegaone/v10/3qTpojOggD2XtAdFb-QXZGt61EcYaQ7F.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Orienta\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/orienta/v13/PlI9FlK4Jrl5Y9zNeyeo9HRFhcU.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Original Surfer\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/originalsurfer/v18/RWmQoKGZ9vIirYntXJ3_MbekzNMiDEtvAlaMKw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Oswald\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v49\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/oswald/v49/TK3_WkUHHAIjg75cFRf3bXL8LICs13FvgUFoZAaRliE.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/oswald/v49/TK3_WkUHHAIjg75cFRf3bXL8LICs169vgUFoZAaRliE.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/oswald/v49/TK3_WkUHHAIjg75cFRf3bXL8LICs1_FvgUFoZAaRliE.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/oswald/v49/TK3_WkUHHAIjg75cFRf3bXL8LICs18NvgUFoZAaRliE.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/oswald/v49/TK3_WkUHHAIjg75cFRf3bXL8LICs1y9ogUFoZAaRliE.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/oswald/v49/TK3_WkUHHAIjg75cFRf3bXL8LICs1xZogUFoZAaRliE.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Outfit\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v6\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/outfit/v6/QGYyz_MVcBeNP4NjuGObqx1XmO1I4TC0C4G-EiAou6Y.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/outfit/v6/QGYyz_MVcBeNP4NjuGObqx1XmO1I4bC1C4G-EiAou6Y.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/outfit/v6/QGYyz_MVcBeNP4NjuGObqx1XmO1I4W61C4G-EiAou6Y.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/outfit/v6/QGYyz_MVcBeNP4NjuGObqx1XmO1I4TC1C4G-EiAou6Y.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/outfit/v6/QGYyz_MVcBeNP4NjuGObqx1XmO1I4QK1C4G-EiAou6Y.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/outfit/v6/QGYyz_MVcBeNP4NjuGObqx1XmO1I4e6yC4G-EiAou6Y.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/outfit/v6/QGYyz_MVcBeNP4NjuGObqx1XmO1I4deyC4G-EiAou6Y.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/outfit/v6/QGYyz_MVcBeNP4NjuGObqx1XmO1I4bCyC4G-EiAou6Y.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/outfit/v6/QGYyz_MVcBeNP4NjuGObqx1XmO1I4ZmyC4G-EiAou6Y.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Over the Rainbow\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/overtherainbow/v16/11haGoXG1k_HKhMLUWz7Mc7vvW5upvOm9NA2XG0.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Overlock\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"900\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/overlock/v15/Z9XVDmdMWRiN1_T9Z4Te4u2El6GC.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/overlock/v15/Z9XTDmdMWRiN1_T9Z7Tc6OmmkrGC7Cs.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/overlock/v15/Z9XSDmdMWRiN1_T9Z7xizcmMvL2L9TLT.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/overlock/v15/Z9XQDmdMWRiN1_T9Z7Tc0FWJtrmp8CLTlNs.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/overlock/v15/Z9XSDmdMWRiN1_T9Z7xaz8mMvL2L9TLT.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/overlock/v15/Z9XQDmdMWRiN1_T9Z7Tc0G2Ltrmp8CLTlNs.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Overlock SC\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/overlocksc/v21/1cX3aUHKGZrstGAY8nwVzHGAq8Sk1PoH.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Overpass\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/overpass/v12/qFda35WCmI96Ajtm83upeyoaX6QPnlo6_PLrOZCLtce-og.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/overpass/v12/qFda35WCmI96Ajtm83upeyoaX6QPnlo6fPPrOZCLtce-og.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/overpass/v12/qFda35WCmI96Ajtm83upeyoaX6QPnlo6ovPrOZCLtce-og.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/overpass/v12/qFda35WCmI96Ajtm83upeyoaX6QPnlo6_PPrOZCLtce-og.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/overpass/v12/qFda35WCmI96Ajtm83upeyoaX6QPnlo6zvPrOZCLtce-og.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/overpass/v12/qFda35WCmI96Ajtm83upeyoaX6QPnlo6IvTrOZCLtce-og.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/overpass/v12/qFda35WCmI96Ajtm83upeyoaX6QPnlo6G_TrOZCLtce-og.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/overpass/v12/qFda35WCmI96Ajtm83upeyoaX6QPnlo6fPTrOZCLtce-og.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/overpass/v12/qFda35WCmI96Ajtm83upeyoaX6QPnlo6VfTrOZCLtce-og.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/overpass/v12/qFdU35WCmI96Ajtm81GgSdXCNs-VMF0vNLADe5qPl8Kuosgz.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/overpass/v12/qFdU35WCmI96Ajtm81GgSdXCNs-VMF0vNLCDepqPl8Kuosgz.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/overpass/v12/qFdU35WCmI96Ajtm81GgSdXCNs-VMF0vNLBdepqPl8Kuosgz.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/overpass/v12/qFdU35WCmI96Ajtm81GgSdXCNs-VMF0vNLADepqPl8Kuosgz.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/overpass/v12/qFdU35WCmI96Ajtm81GgSdXCNs-VMF0vNLAxepqPl8Kuosgz.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/overpass/v12/qFdU35WCmI96Ajtm81GgSdXCNs-VMF0vNLDdfZqPl8Kuosgz.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/overpass/v12/qFdU35WCmI96Ajtm81GgSdXCNs-VMF0vNLDkfZqPl8Kuosgz.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/overpass/v12/qFdU35WCmI96Ajtm81GgSdXCNs-VMF0vNLCDfZqPl8Kuosgz.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/overpass/v12/qFdU35WCmI96Ajtm81GgSdXCNs-VMF0vNLCqfZqPl8Kuosgz.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Overpass Mono\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/overpassmono/v15/_Xm5-H86tzKDdAPa-KPQZ-AC_COcRycquHlL6EWKokzzXur-SmIr.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/overpassmono/v15/_Xm5-H86tzKDdAPa-KPQZ-AC_COcRycquHlL6EXUokzzXur-SmIr.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/overpassmono/v15/_Xm5-H86tzKDdAPa-KPQZ-AC_COcRycquHlL6EXmokzzXur-SmIr.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/overpassmono/v15/_Xm5-H86tzKDdAPa-KPQZ-AC_COcRycquHlL6EUKpUzzXur-SmIr.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/overpassmono/v15/_Xm5-H86tzKDdAPa-KPQZ-AC_COcRycquHlL6EUzpUzzXur-SmIr.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"monospace\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Ovo\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ovo/v17/yYLl0h7Wyfzjy4Q5_3WVxA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Oxanium\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/oxanium/v14/RrQPboN_4yJ0JmiMUW7sIGjd1IA9G83JfniMBXQ7d67x.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/oxanium/v14/RrQPboN_4yJ0JmiMUW7sIGjd1IA9G80XfniMBXQ7d67x.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/oxanium/v14/RrQPboN_4yJ0JmiMUW7sIGjd1IA9G81JfniMBXQ7d67x.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/oxanium/v14/RrQPboN_4yJ0JmiMUW7sIGjd1IA9G817fniMBXQ7d67x.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/oxanium/v14/RrQPboN_4yJ0JmiMUW7sIGjd1IA9G82XeXiMBXQ7d67x.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/oxanium/v14/RrQPboN_4yJ0JmiMUW7sIGjd1IA9G82ueXiMBXQ7d67x.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/oxanium/v14/RrQPboN_4yJ0JmiMUW7sIGjd1IA9G83JeXiMBXQ7d67x.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Oxygen\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/oxygen/v15/2sDcZG1Wl4LcnbuCJW8Db2-4C7wFZQ.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/oxygen/v15/2sDfZG1Wl4Lcnbu6iUcnZ0SkAg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/oxygen/v15/2sDcZG1Wl4LcnbuCNWgDb2-4C7wFZQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Oxygen Mono\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/oxygenmono/v13/h0GsssGg9FxgDgCjLeAd7ijfze-PPlUu.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"monospace\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"PT Mono\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ptmono/v13/9oRONYoBnWILk-9ArCg5MtPyAcg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"monospace\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"PT Sans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ptsans/v17/jizaRExUiTo99u79P0WOxOGMMDQ.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/ptsans/v17/jizYRExUiTo99u79D0eEwMOJIDQA-g.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/ptsans/v17/jizfRExUiTo99u79B_mh4OmnLD0Z4zM.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/ptsans/v17/jizdRExUiTo99u79D0e8fOytKB8c8zMrig.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"PT Sans Caption\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ptsanscaption/v18/0FlMVP6Hrxmt7-fsUFhlFXNIlpcqfQXwQy6yxg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/ptsanscaption/v18/0FlJVP6Hrxmt7-fsUFhlFXNIlpcSwSrUSwWuz38Tgg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"PT Sans Narrow\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ptsansnarrow/v17/BngRUXNadjH0qYEzV7ab-oWlsYCByxyKeuDp.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/ptsansnarrow/v17/BngSUXNadjH0qYEzV7ab-oWlsbg95DiCUfzgRd-3.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"PT Serif\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ptserif/v17/EJRVQgYoZZY2vCFuvDFRxL6ddjb-.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/ptserif/v17/EJRTQgYoZZY2vCFuvAFTzrq_cyb-vco.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/ptserif/v17/EJRSQgYoZZY2vCFuvAnt65qVXSr3pNNB.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/ptserif/v17/EJRQQgYoZZY2vCFuvAFT9gaQVy7VocNB6Iw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"PT Serif Caption\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ptserifcaption/v17/ieVl2ZhbGCW-JoW6S34pSDpqYKU059WxDCs5cvI.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/ptserifcaption/v17/ieVj2ZhbGCW-JoW6S34pSDpqYKU019e7CAk8YvJEeg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Pacifico\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/pacifico/v22/FwZY7-Qmy14u9lezJ96A4sijpFu_.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Padauk\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"myanmar\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/padauk/v16/RrQRboJg-id7OnbBa0_g3LlYbg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/padauk/v16/RrQSboJg-id7Onb512DE1JJEZ4YwGg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Padyakke Expanded One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"kannada\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2023-01-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/padyakkeexpandedone/v1/K2FvfY9El_tbR0JfHb6WWvrBaU6XAUvC4IAYOKRkpDjeoQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Palanquin\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/palanquin/v13/9XUhlJ90n1fBFg7ceXwUEltI7rWmZzTH.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/palanquin/v13/9XUilJ90n1fBFg7ceXwUvnpoxJuqbi3ezg.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/palanquin/v13/9XUilJ90n1fBFg7ceXwU2nloxJuqbi3ezg.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/palanquin/v13/9XUnlJ90n1fBFg7ceXwsdlFMzLC2Zw.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/palanquin/v13/9XUilJ90n1fBFg7ceXwUgnhoxJuqbi3ezg.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/palanquin/v13/9XUilJ90n1fBFg7ceXwUrn9oxJuqbi3ezg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/palanquin/v13/9XUilJ90n1fBFg7ceXwUyn5oxJuqbi3ezg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Palanquin Dark\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/palanquindark/v12/xn75YHgl1nqmANMB-26xC7yuF_6OTEo9VtfE.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/palanquindark/v12/xn76YHgl1nqmANMB-26xC7yuF8Z6ZW41fcvN2KT4.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/palanquindark/v12/xn76YHgl1nqmANMB-26xC7yuF8ZWYm41fcvN2KT4.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/palanquindark/v12/xn76YHgl1nqmANMB-26xC7yuF8YyY241fcvN2KT4.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Pangolin\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/pangolin/v11/cY9GfjGcW0FPpi-tWPfK5d3aiLBG.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Paprika\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/paprika/v21/8QIJdijZitv49rDfuIgOq7jkAOw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Parisienne\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/parisienne/v13/E21i_d3kivvAkxhLEVZpcy96DuKuavM.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Passero One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-05-10\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/passeroone/v24/JTUTjIko8DOq5FeaeEAjgE5B5Arr-s50.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Passion One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/passionone/v16/PbynFmL8HhTPqbjUzux3JHuW_Frg6YoV.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/passionone/v16/Pby6FmL8HhTPqbjUzux3JEMq037owpYcuH8y.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/passionone/v16/Pby6FmL8HhTPqbjUzux3JEMS0X7owpYcuH8y.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Passions Conflict\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v5\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/passionsconflict/v5/kmKnZrcrFhfafnWX9x0GuEC-zowow5NeYRI4CN2V.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Pathway Gothic One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/pathwaygothicone/v14/MwQrbgD32-KAvjkYGNUUxAtW7pEBwx-dTFxeb80flQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Patrick Hand\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/patrickhand/v19/LDI1apSQOAYtSuYWp8ZhfYeMWcjKm7sp8g.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Patrick Hand SC\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/patrickhandsc/v13/0nkwC9f7MfsBiWcLtY65AWDK873ViSi6JQc7Vg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Pattaya\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"thai\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/pattaya/v12/ea8ZadcqV_zkHY-XNdCn92ZEmVs.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Patua One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/patuaone/v16/ZXuke1cDvLCKLDcimxBI5PNvNA9LuA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Pavanam\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"tamil\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/pavanam/v11/BXRrvF_aiezLh0xPDOtQ9Wf0QcE.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Paytone One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/paytoneone/v18/0nksC9P7MfYHj2oFtYm2CiTqivr9iBq_.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Peddana\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"telugu\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/peddana/v20/aFTU7PBhaX89UcKWhh2aBYyMcKw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Peralta\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/peralta/v17/hYkJPu0-RP_9d3kRGxAhrv956B8.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Permanent Marker\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/permanentmarker/v16/Fh4uPib9Iyv2ucM6pGQMWimMp004HaqIfrT5nlk.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Petemoss\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v5\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/petemoss/v5/A2BZn5tA2xgtGWHZgxkesKb9UouQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Petit Formal Script\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/petitformalscript/v13/B50TF6xQr2TXJBnGOFME6u5OR83oRP5qoHnqP4gZSiE.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Petrona\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v28\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/petrona/v28/mtGl4_NXL7bZo9XXq35wRLONYyOjFk6NsARBH452Mvds.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/petrona/v28/mtGl4_NXL7bZo9XXq35wRLONYyOjFk4NsQRBH452Mvds.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/petrona/v28/mtGl4_NXL7bZo9XXq35wRLONYyOjFk7TsQRBH452Mvds.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/petrona/v28/mtGl4_NXL7bZo9XXq35wRLONYyOjFk6NsQRBH452Mvds.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/petrona/v28/mtGl4_NXL7bZo9XXq35wRLONYyOjFk6_sQRBH452Mvds.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/petrona/v28/mtGl4_NXL7bZo9XXq35wRLONYyOjFk5TtgRBH452Mvds.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/petrona/v28/mtGl4_NXL7bZo9XXq35wRLONYyOjFk5qtgRBH452Mvds.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/petrona/v28/mtGl4_NXL7bZo9XXq35wRLONYyOjFk4NtgRBH452Mvds.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/petrona/v28/mtGl4_NXL7bZo9XXq35wRLONYyOjFk4ktgRBH452Mvds.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/petrona/v28/mtGr4_NXL7bZo9XXgXdCu2vkCLkNEVtF8uwDFYpUN-dsIWs.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/petrona/v28/mtGr4_NXL7bZo9XXgXdCu2vkCLkNEVtF8mwCFYpUN-dsIWs.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/petrona/v28/mtGr4_NXL7bZo9XXgXdCu2vkCLkNEVtF8rICFYpUN-dsIWs.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/petrona/v28/mtGr4_NXL7bZo9XXgXdCu2vkCLkNEVtF8uwCFYpUN-dsIWs.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/petrona/v28/mtGr4_NXL7bZo9XXgXdCu2vkCLkNEVtF8t4CFYpUN-dsIWs.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/petrona/v28/mtGr4_NXL7bZo9XXgXdCu2vkCLkNEVtF8jIFFYpUN-dsIWs.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/petrona/v28/mtGr4_NXL7bZo9XXgXdCu2vkCLkNEVtF8gsFFYpUN-dsIWs.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/petrona/v28/mtGr4_NXL7bZo9XXgXdCu2vkCLkNEVtF8mwFFYpUN-dsIWs.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/petrona/v28/mtGr4_NXL7bZo9XXgXdCu2vkCLkNEVtF8kUFFYpUN-dsIWs.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Philosopher\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/philosopher/v19/vEFV2_5QCwIS4_Dhez5jcVBpRUwU08qe.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/philosopher/v19/vEFX2_5QCwIS4_Dhez5jcWBrT0g21tqeR7c.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/philosopher/v19/vEFI2_5QCwIS4_Dhez5jcWjVamgc-NaXXq7H.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/philosopher/v19/vEFK2_5QCwIS4_Dhez5jcWBrd_QZ8tK1W77HtMo.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Piazzolla\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v29\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/piazzolla/v29/N0b52SlTPu5rIkWIZjVKKtYtfxYqZ4RJBFzFfYUjkSDdlqZgy7LYx3Ly1AHfAAy5.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/piazzolla/v29/N0b52SlTPu5rIkWIZjVKKtYtfxYqZ4RJBFzFfYUjkSDdlqZgy7JYxnLy1AHfAAy5.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/piazzolla/v29/N0b52SlTPu5rIkWIZjVKKtYtfxYqZ4RJBFzFfYUjkSDdlqZgy7KGxnLy1AHfAAy5.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/piazzolla/v29/N0b52SlTPu5rIkWIZjVKKtYtfxYqZ4RJBFzFfYUjkSDdlqZgy7LYxnLy1AHfAAy5.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/piazzolla/v29/N0b52SlTPu5rIkWIZjVKKtYtfxYqZ4RJBFzFfYUjkSDdlqZgy7LqxnLy1AHfAAy5.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/piazzolla/v29/N0b52SlTPu5rIkWIZjVKKtYtfxYqZ4RJBFzFfYUjkSDdlqZgy7IGwXLy1AHfAAy5.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/piazzolla/v29/N0b52SlTPu5rIkWIZjVKKtYtfxYqZ4RJBFzFfYUjkSDdlqZgy7I_wXLy1AHfAAy5.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/piazzolla/v29/N0b52SlTPu5rIkWIZjVKKtYtfxYqZ4RJBFzFfYUjkSDdlqZgy7JYwXLy1AHfAAy5.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/piazzolla/v29/N0b52SlTPu5rIkWIZjVKKtYtfxYqZ4RJBFzFfYUjkSDdlqZgy7JxwXLy1AHfAAy5.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/piazzolla/v29/N0b72SlTPu5rIkWIZjVgI-TckS03oGpPETyEJ88Rbvi0_TzOzKcQhZqw3gX9BRy5m5M.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/piazzolla/v29/N0b72SlTPu5rIkWIZjVgI-TckS03oGpPETyEJ88Rbvi0_TzOzKcQhRqx3gX9BRy5m5M.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/piazzolla/v29/N0b72SlTPu5rIkWIZjVgI-TckS03oGpPETyEJ88Rbvi0_TzOzKcQhcSx3gX9BRy5m5M.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/piazzolla/v29/N0b72SlTPu5rIkWIZjVgI-TckS03oGpPETyEJ88Rbvi0_TzOzKcQhZqx3gX9BRy5m5M.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/piazzolla/v29/N0b72SlTPu5rIkWIZjVgI-TckS03oGpPETyEJ88Rbvi0_TzOzKcQhaix3gX9BRy5m5M.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/piazzolla/v29/N0b72SlTPu5rIkWIZjVgI-TckS03oGpPETyEJ88Rbvi0_TzOzKcQhUS23gX9BRy5m5M.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/piazzolla/v29/N0b72SlTPu5rIkWIZjVgI-TckS03oGpPETyEJ88Rbvi0_TzOzKcQhX223gX9BRy5m5M.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/piazzolla/v29/N0b72SlTPu5rIkWIZjVgI-TckS03oGpPETyEJ88Rbvi0_TzOzKcQhRq23gX9BRy5m5M.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/piazzolla/v29/N0b72SlTPu5rIkWIZjVgI-TckS03oGpPETyEJ88Rbvi0_TzOzKcQhTO23gX9BRy5m5M.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Piedra\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/piedra/v21/ke8kOg8aN0Bn7hTunEyHN_M3gA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Pinyon Script\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/pinyonscript/v17/6xKpdSJbL9-e9LuoeQiDRQR8aOLQO4bhiDY.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Pirata One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/pirataone/v22/I_urMpiDvgLdLh0fAtoftiiEr5_BdZ8.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Plaster\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/plaster/v24/DdTm79QatW80eRh4Ei5JOtLOeLI.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Play\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/play/v17/6aez4K2oVqwIjtI8Hp8Tx3A.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/play/v17/6ae84K2oVqwItm4TOpc423nTJTM.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Playball\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/playball/v16/TK3gWksYAxQ7jbsKcj8Dl-tPKo2t.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Playfair Display\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v30\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/playfairdisplay/v30/nuFvD-vYSZviVYUb_rj3ij__anPXJzDwcbmjWBN2PKdFvUDQZNLo_U2r.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/playfairdisplay/v30/nuFvD-vYSZviVYUb_rj3ij__anPXJzDwcbmjWBN2PKd3vUDQZNLo_U2r.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/playfairdisplay/v30/nuFvD-vYSZviVYUb_rj3ij__anPXJzDwcbmjWBN2PKebukDQZNLo_U2r.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/playfairdisplay/v30/nuFvD-vYSZviVYUb_rj3ij__anPXJzDwcbmjWBN2PKeiukDQZNLo_U2r.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/playfairdisplay/v30/nuFvD-vYSZviVYUb_rj3ij__anPXJzDwcbmjWBN2PKfFukDQZNLo_U2r.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/playfairdisplay/v30/nuFvD-vYSZviVYUb_rj3ij__anPXJzDwcbmjWBN2PKfsukDQZNLo_U2r.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/playfairdisplay/v30/nuFRD-vYSZviVYUb_rj3ij__anPXDTnCjmHKM4nYO7KN_qiTbtbK-F2rA0s.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/playfairdisplay/v30/nuFRD-vYSZviVYUb_rj3ij__anPXDTnCjmHKM4nYO7KN_pqTbtbK-F2rA0s.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/playfairdisplay/v30/nuFRD-vYSZviVYUb_rj3ij__anPXDTnCjmHKM4nYO7KN_naUbtbK-F2rA0s.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/playfairdisplay/v30/nuFRD-vYSZviVYUb_rj3ij__anPXDTnCjmHKM4nYO7KN_k-UbtbK-F2rA0s.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/playfairdisplay/v30/nuFRD-vYSZviVYUb_rj3ij__anPXDTnCjmHKM4nYO7KN_iiUbtbK-F2rA0s.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/playfairdisplay/v30/nuFRD-vYSZviVYUb_rj3ij__anPXDTnCjmHKM4nYO7KN_gGUbtbK-F2rA0s.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Playfair Display SC\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"900\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/playfairdisplaysc/v15/ke85OhoaMkR6-hSn7kbHVoFf7ZfgMPr_pb4GEcM2M4s.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/playfairdisplaysc/v15/ke87OhoaMkR6-hSn7kbHVoFf7ZfgMPr_lbwMFeEzI4sNKg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/playfairdisplaysc/v15/ke80OhoaMkR6-hSn7kbHVoFf7ZfgMPr_nQIpNcsdL4IUMyE.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/playfairdisplaysc/v15/ke82OhoaMkR6-hSn7kbHVoFf7ZfgMPr_lbw0qc4XK6ARIyH5IA.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/playfairdisplaysc/v15/ke80OhoaMkR6-hSn7kbHVoFf7ZfgMPr_nTorNcsdL4IUMyE.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/playfairdisplaysc/v15/ke82OhoaMkR6-hSn7kbHVoFf7ZfgMPr_lbw0kcwXK6ARIyH5IA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Plus Jakarta Sans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v3\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/plusjakartasans/v3/LDIbaomQNQcsA88c7O9yZ4KMCoOg4IA6-91aHEjcWuA_KU7NShXUEKi4Rw.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/plusjakartasans/v3/LDIbaomQNQcsA88c7O9yZ4KMCoOg4IA6-91aHEjcWuA_907NShXUEKi4Rw.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/plusjakartasans/v3/LDIbaomQNQcsA88c7O9yZ4KMCoOg4IA6-91aHEjcWuA_qU7NShXUEKi4Rw.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/plusjakartasans/v3/LDIbaomQNQcsA88c7O9yZ4KMCoOg4IA6-91aHEjcWuA_m07NShXUEKi4Rw.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/plusjakartasans/v3/LDIbaomQNQcsA88c7O9yZ4KMCoOg4IA6-91aHEjcWuA_d0nNShXUEKi4Rw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/plusjakartasans/v3/LDIbaomQNQcsA88c7O9yZ4KMCoOg4IA6-91aHEjcWuA_TknNShXUEKi4Rw.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/plusjakartasans/v3/LDIbaomQNQcsA88c7O9yZ4KMCoOg4IA6-91aHEjcWuA_KUnNShXUEKi4Rw.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/plusjakartasans/v3/LDIZaomQNQcsA88c7O9yZ4KMCoOg4KozySKCdSNG9OcqYQ2lCR_QMq2oR82k.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/plusjakartasans/v3/LDIZaomQNQcsA88c7O9yZ4KMCoOg4KozySKCdSNG9OcqYQ17CR_QMq2oR82k.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/plusjakartasans/v3/LDIZaomQNQcsA88c7O9yZ4KMCoOg4KozySKCdSNG9OcqYQ0lCR_QMq2oR82k.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/plusjakartasans/v3/LDIZaomQNQcsA88c7O9yZ4KMCoOg4KozySKCdSNG9OcqYQ0XCR_QMq2oR82k.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/plusjakartasans/v3/LDIZaomQNQcsA88c7O9yZ4KMCoOg4KozySKCdSNG9OcqYQ37Dh_QMq2oR82k.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/plusjakartasans/v3/LDIZaomQNQcsA88c7O9yZ4KMCoOg4KozySKCdSNG9OcqYQ3CDh_QMq2oR82k.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/plusjakartasans/v3/LDIZaomQNQcsA88c7O9yZ4KMCoOg4KozySKCdSNG9OcqYQ2lDh_QMq2oR82k.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Podkova\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v26\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/podkova/v26/K2FufZ1EmftJSV9VQpXb1lo9vC3nZWtFzcU4EoporSHH.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/podkova/v26/K2FufZ1EmftJSV9VQpXb1lo9vC3nZWt3zcU4EoporSHH.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/podkova/v26/K2FufZ1EmftJSV9VQpXb1lo9vC3nZWubysU4EoporSHH.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/podkova/v26/K2FufZ1EmftJSV9VQpXb1lo9vC3nZWuiysU4EoporSHH.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/podkova/v26/K2FufZ1EmftJSV9VQpXb1lo9vC3nZWvFysU4EoporSHH.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Poiret One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/poiretone/v14/UqyVK80NJXN4zfRgbdfbk5lWVscxdKE.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Poller One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/pollerone/v19/ahccv82n0TN3gia5E4Bud-lbgUS5u0s.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Poly\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/poly/v16/MQpb-W6wKNitRLCAq2Lpris.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/poly/v16/MQpV-W6wKNitdLKKr0DsviuGWA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Pompiere\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/pompiere/v15/VEMyRoxis5Dwuyeov6Wt5jDtreOL.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Pontano Sans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/pontanosans/v13/qFdD35GdgYR8EzR6oBLDHa3qwjUMg1siNQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Poor Story\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"korean\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/poorstory/v20/jizfREFUsnUct9P6cDfd4OmnLD0Z4zM.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Poppins\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrLPTed3FBGPaTSQ.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/poppins/v20/pxiAyp8kv8JHgFVrJJLmE3tFOvODSVFF.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLFj_V1tvFP-KUEg.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmv1plEN2PQEhcqw.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8V1tvFP-KUEg.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm21llEN2PQEhcqw.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJDUc1NECPY.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/poppins/v20/pxiGyp8kv8JHgFVrJJLed3FBGPaTSQ.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9V1tvFP-KUEg.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmg1hlEN2PQEhcqw.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6V1tvFP-KUEg.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmr19lEN2PQEhcqw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7V1tvFP-KUEg.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLmy15lEN2PQEhcqw.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4V1tvFP-KUEg.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm111lEN2PQEhcqw.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLBT5V1tvFP-KUEg.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/poppins/v20/pxiDyp8kv8JHgFVrJJLm81xlEN2PQEhcqw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Port Lligat Sans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/portlligatsans/v18/kmKmZrYrGBbdN1aV7Vokow6Lw4s4l7N0Tx4xEcQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Port Lligat Slab\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/portlligatslab/v21/LDIpaoiQNgArA8kR7ulhZ8P_NYOss7ob9yGLmfI.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Potta One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/pottaone/v16/FeVSS05Bp6cy7xI-YfxQ3Z5nm29Gww.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Pragati Narrow\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/pragatinarrow/v13/vm8vdRf0T0bS1ffgsPB7WZ-mD17_ytN3M48a.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/pragatinarrow/v13/vm8sdRf0T0bS1ffgsPB7WZ-mD2ZD5fd_GJMTlo_4.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Praise\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v5\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/praise/v5/qkBUXvUZ-cnFXcFyDvO67L9XmQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Prata\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/prata/v18/6xKhdSpbNNCT-vWIAG_5LWwJ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Preahvihear\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"khmer\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v27\",\n\t\t\t\"lastModified\": \"2022-04-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/preahvihear/v27/6NUS8F-dNQeEYhzj7uluxswE49FJf8Wv.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Press Start 2P\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/pressstart2p/v14/e3t4euO8T-267oIAQAu6jDQyK0nSgPJE4580.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Pridi\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"thai\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/pridi/v11/2sDdZG5JnZLfkc1SiE0jRUG0AqUc.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/pridi/v11/2sDdZG5JnZLfkc02i00jRUG0AqUc.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/pridi/v11/2sDQZG5JnZLfkfWao2krbl29.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/pridi/v11/2sDdZG5JnZLfkc1uik0jRUG0AqUc.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/pridi/v11/2sDdZG5JnZLfkc1CjU0jRUG0AqUc.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/pridi/v11/2sDdZG5JnZLfkc0mjE0jRUG0AqUc.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Princess Sofia\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/princesssofia/v21/qWczB6yguIb8DZ_GXZst16n7GRz7mDUoupoI.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Prociono\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/prociono/v22/r05YGLlR-KxAf9GGO8upyDYtStiJ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Prompt\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"thai\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/prompt/v10/-W_9XJnvUD7dzB2CA9oYREcjeo0k.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/prompt/v10/-W_7XJnvUD7dzB2KZeJ8TkMBf50kbiM.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/prompt/v10/-W_8XJnvUD7dzB2Cr_s4bmkvc5Q9dw.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/prompt/v10/-W_6XJnvUD7dzB2KZeLQb2MrUZEtdzow.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/prompt/v10/-W_8XJnvUD7dzB2Cy_g4bmkvc5Q9dw.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/prompt/v10/-W_6XJnvUD7dzB2KZeK0bGMrUZEtdzow.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/prompt/v10/-W__XJnvUD7dzB26Z9AcZkIzeg.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/prompt/v10/-W_9XJnvUD7dzB2KZdoYREcjeo0k.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/prompt/v10/-W_8XJnvUD7dzB2Ck_k4bmkvc5Q9dw.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/prompt/v10/-W_6XJnvUD7dzB2KZeLsbWMrUZEtdzow.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/prompt/v10/-W_8XJnvUD7dzB2Cv_44bmkvc5Q9dw.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/prompt/v10/-W_6XJnvUD7dzB2KZeLAamMrUZEtdzow.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/prompt/v10/-W_8XJnvUD7dzB2C2_84bmkvc5Q9dw.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/prompt/v10/-W_6XJnvUD7dzB2KZeKka2MrUZEtdzow.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/prompt/v10/-W_8XJnvUD7dzB2Cx_w4bmkvc5Q9dw.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/prompt/v10/-W_6XJnvUD7dzB2KZeK4aGMrUZEtdzow.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/prompt/v10/-W_8XJnvUD7dzB2C4_04bmkvc5Q9dw.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/prompt/v10/-W_6XJnvUD7dzB2KZeKcaWMrUZEtdzow.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Prosto One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/prostoone/v17/OpNJno4VhNfK-RgpwWWxpipfWhXD00c.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Proza Libre\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800\",\n\t\t\t\t\"800italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v9\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/prozalibre/v9/LYjGdGHgj0k1DIQRyUEyyHovftvXWYyz.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/prozalibre/v9/LYjEdGHgj0k1DIQRyUEyyEotdN_1XJyz7zc.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/prozalibre/v9/LYjbdGHgj0k1DIQRyUEyyELbV__fcpC69i6N.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/prozalibre/v9/LYjZdGHgj0k1DIQRyUEyyEotTCvceJSY8z6Np1k.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/prozalibre/v9/LYjbdGHgj0k1DIQRyUEyyEL3UP_fcpC69i6N.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/prozalibre/v9/LYjZdGHgj0k1DIQRyUEyyEotTAfbeJSY8z6Np1k.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/prozalibre/v9/LYjbdGHgj0k1DIQRyUEyyEKTUf_fcpC69i6N.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/prozalibre/v9/LYjZdGHgj0k1DIQRyUEyyEotTGPaeJSY8z6Np1k.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/prozalibre/v9/LYjbdGHgj0k1DIQRyUEyyEKPUv_fcpC69i6N.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/prozalibre/v9/LYjZdGHgj0k1DIQRyUEyyEotTH_ZeJSY8z6Np1k.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Public Sans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/publicsans/v14/ijwGs572Xtc6ZYQws9YVwllKVG8qX1oyOymuFpi5ww0pX189fg.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/publicsans/v14/ijwGs572Xtc6ZYQws9YVwllKVG8qX1oyOymulpm5ww0pX189fg.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/publicsans/v14/ijwGs572Xtc6ZYQws9YVwllKVG8qX1oyOymuSJm5ww0pX189fg.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/publicsans/v14/ijwGs572Xtc6ZYQws9YVwllKVG8qX1oyOymuFpm5ww0pX189fg.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/publicsans/v14/ijwGs572Xtc6ZYQws9YVwllKVG8qX1oyOymuJJm5ww0pX189fg.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/publicsans/v14/ijwGs572Xtc6ZYQws9YVwllKVG8qX1oyOymuyJ65ww0pX189fg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/publicsans/v14/ijwGs572Xtc6ZYQws9YVwllKVG8qX1oyOymu8Z65ww0pX189fg.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/publicsans/v14/ijwGs572Xtc6ZYQws9YVwllKVG8qX1oyOymulp65ww0pX189fg.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/publicsans/v14/ijwGs572Xtc6ZYQws9YVwllKVG8qX1oyOymuv565ww0pX189fg.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/publicsans/v14/ijwAs572Xtc6ZYQws9YVwnNDZpDyNjGolS673tpRgQctfVotfj7j.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/publicsans/v14/ijwAs572Xtc6ZYQws9YVwnNDZpDyNjGolS673trRgActfVotfj7j.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/publicsans/v14/ijwAs572Xtc6ZYQws9YVwnNDZpDyNjGolS673toPgActfVotfj7j.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/publicsans/v14/ijwAs572Xtc6ZYQws9YVwnNDZpDyNjGolS673tpRgActfVotfj7j.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/publicsans/v14/ijwAs572Xtc6ZYQws9YVwnNDZpDyNjGolS673tpjgActfVotfj7j.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/publicsans/v14/ijwAs572Xtc6ZYQws9YVwnNDZpDyNjGolS673tqPhwctfVotfj7j.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/publicsans/v14/ijwAs572Xtc6ZYQws9YVwnNDZpDyNjGolS673tq2hwctfVotfj7j.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/publicsans/v14/ijwAs572Xtc6ZYQws9YVwnNDZpDyNjGolS673trRhwctfVotfj7j.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/publicsans/v14/ijwAs572Xtc6ZYQws9YVwnNDZpDyNjGolS673tr4hwctfVotfj7j.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Puppies Play\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v5\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/puppiesplay/v5/wlp2gwHZEV99rG6M3NR9uB9vaAJSA_JN3Q.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Puritan\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/puritan/v24/845YNMgkAJ2VTtIo9JrwRdaI50M.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/puritan/v24/845aNMgkAJ2VTtIoxJj6QfSN90PfXA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/puritan/v24/845dNMgkAJ2VTtIozCbfYd6j-0rGRes.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/puritan/v24/845fNMgkAJ2VTtIoxJjC_dup_2jDVevnLQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Purple Purse\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/purplepurse/v21/qWctB66gv53iAp-Vfs4My6qyeBb_ujA4ug.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Qahiri\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v9\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/qahiri/v9/tsssAp1RZy0C_hGuU3Chrnmupw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Quando\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/quando/v14/xMQVuFNaVa6YuW0pC6WzKX_QmA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Quantico\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/quantico/v15/rax-HiSdp9cPL3KIF4xsLjxSmlLZ.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/quantico/v15/rax4HiSdp9cPL3KIF7xuJDhwn0LZ6T8.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/quantico/v15/rax5HiSdp9cPL3KIF7TQARhasU7Q8Cad.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/quantico/v15/rax7HiSdp9cPL3KIF7xuHIRfu0ry9TadML4.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Quattrocento\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/quattrocento/v17/OZpEg_xvsDZQL_LKIF7q4jPHxGL7f4jFuA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/quattrocento/v17/OZpbg_xvsDZQL_LKIF7q4jP_eE3fd6PZsXcM9w.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Quattrocento Sans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/quattrocentosans/v18/va9c4lja2NVIDdIAAoMR5MfuElaRB3zOvU7eHGHJ.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/quattrocentosans/v18/va9a4lja2NVIDdIAAoMR5MfuElaRB0zMt0r8GXHJkLI.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/quattrocentosans/v18/va9Z4lja2NVIDdIAAoMR5MfuElaRB0RykmrWN33AiasJ.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/quattrocentosans/v18/va9X4lja2NVIDdIAAoMR5MfuElaRB0zMj_bTPXnijLsJV7E.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Questrial\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/questrial/v18/QdVUSTchPBm7nuUeVf7EuStkm20oJA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Quicksand\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v30\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/quicksand/v30/6xK-dSZaM9iE8KbpRA_LJ3z8mH9BOJvgkKEo18G0wx40QDw.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/quicksand/v30/6xK-dSZaM9iE8KbpRA_LJ3z8mH9BOJvgkP8o18G0wx40QDw.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/quicksand/v30/6xK-dSZaM9iE8KbpRA_LJ3z8mH9BOJvgkM0o18G0wx40QDw.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/quicksand/v30/6xK-dSZaM9iE8KbpRA_LJ3z8mH9BOJvgkCEv18G0wx40QDw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/quicksand/v30/6xK-dSZaM9iE8KbpRA_LJ3z8mH9BOJvgkBgv18G0wx40QDw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Quintessential\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/quintessential/v20/fdNn9sOGq31Yjnh3qWU14DdtjY5wS7kmAyxM.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Qwigley\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/qwigley/v16/1cXzaU3UGJb5tGoCuVxsi1mBmcE.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Qwitcher Grypen\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v3\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/qwitchergrypen/v3/pxicypclp9tDilN9RrC5BSI1dZmrSGNAom-wpw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/qwitchergrypen/v3/pxiZypclp9tDilN9RrC5BSI1dZmT9ExkqkSsrvNXiA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Racing Sans One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/racingsansone/v13/sykr-yRtm7EvTrXNxkv5jfKKyDCwL3rmWpIBtA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Radio Canada\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/radiocanada/v16/XRX13ISXn0dBMcibU6jlAqr3ejLv5OLZYiYXik6db2P4jxxlsls-0nESkQPIJOdSSfOT.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/radiocanada/v16/XRX13ISXn0dBMcibU6jlAqr3ejLv5OLZYiYXik6db2P4jxxlsls-0nFMkQPIJOdSSfOT.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/radiocanada/v16/XRX13ISXn0dBMcibU6jlAqr3ejLv5OLZYiYXik6db2P4jxxlsls-0nF-kQPIJOdSSfOT.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/radiocanada/v16/XRX13ISXn0dBMcibU6jlAqr3ejLv5OLZYiYXik6db2P4jxxlsls-0nGSlgPIJOdSSfOT.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/radiocanada/v16/XRX13ISXn0dBMcibU6jlAqr3ejLv5OLZYiYXik6db2P4jxxlsls-0nGrlgPIJOdSSfOT.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/radiocanada/v16/XRX33ISXn0dBMcibU6jlAqrdcwAMBJuK9IgQn4bfnSrKcMQM2cGQ1WSE0rWLLuNwTOOTa9k.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/radiocanada/v16/XRX33ISXn0dBMcibU6jlAqrdcwAMBJuK9IgQn4bfnSrKcMQM2cGQ1WSE0uuLLuNwTOOTa9k.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/radiocanada/v16/XRX33ISXn0dBMcibU6jlAqrdcwAMBJuK9IgQn4bfnSrKcMQM2cGQ1WSE0tmLLuNwTOOTa9k.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/radiocanada/v16/XRX33ISXn0dBMcibU6jlAqrdcwAMBJuK9IgQn4bfnSrKcMQM2cGQ1WSE0jWMLuNwTOOTa9k.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/radiocanada/v16/XRX33ISXn0dBMcibU6jlAqrdcwAMBJuK9IgQn4bfnSrKcMQM2cGQ1WSE0gyMLuNwTOOTa9k.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Radley\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/radley/v20/LYjDdGzinEIjCN19oAlEpVs3VQ.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/radley/v20/LYjBdGzinEIjCN1NogNAh14nVcfe.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rajdhani\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/rajdhani/v15/LDI2apCSOBg7S-QT7pasEcOsc-bGkqIw.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rajdhani/v15/LDIxapCSOBg7S-QT7q4AOeekWPrP.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/rajdhani/v15/LDI2apCSOBg7S-QT7pb0EMOsc-bGkqIw.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/rajdhani/v15/LDI2apCSOBg7S-QT7pbYF8Osc-bGkqIw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/rajdhani/v15/LDI2apCSOBg7S-QT7pa8FsOsc-bGkqIw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rakkas\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rakkas/v17/Qw3cZQlNHiblL3j_lttPOeMcCw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Raleway\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v28\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/raleway/v28/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVvao4CPNLA3JC9c.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/raleway/v28/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVtaooCPNLA3JC9c.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/raleway/v28/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVuEooCPNLA3JC9c.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/raleway/v28/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVvaooCPNLA3JC9c.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/raleway/v28/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVvoooCPNLA3JC9c.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/raleway/v28/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVsEpYCPNLA3JC9c.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/raleway/v28/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVs9pYCPNLA3JC9c.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/raleway/v28/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVtapYCPNLA3JC9c.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/raleway/v28/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVtzpYCPNLA3JC9c.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/raleway/v28/1Pt_g8zYS_SKggPNyCgSQamb1W0lwk4S4WjNPrQVIT9c2c8.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/raleway/v28/1Pt_g8zYS_SKggPNyCgSQamb1W0lwk4S4ejMPrQVIT9c2c8.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/raleway/v28/1Pt_g8zYS_SKggPNyCgSQamb1W0lwk4S4TbMPrQVIT9c2c8.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/raleway/v28/1Pt_g8zYS_SKggPNyCgSQamb1W0lwk4S4WjMPrQVIT9c2c8.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/raleway/v28/1Pt_g8zYS_SKggPNyCgSQamb1W0lwk4S4VrMPrQVIT9c2c8.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/raleway/v28/1Pt_g8zYS_SKggPNyCgSQamb1W0lwk4S4bbLPrQVIT9c2c8.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/raleway/v28/1Pt_g8zYS_SKggPNyCgSQamb1W0lwk4S4Y_LPrQVIT9c2c8.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/raleway/v28/1Pt_g8zYS_SKggPNyCgSQamb1W0lwk4S4ejLPrQVIT9c2c8.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/raleway/v28/1Pt_g8zYS_SKggPNyCgSQamb1W0lwk4S4cHLPrQVIT9c2c8.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Raleway Dots\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ralewaydots/v14/6NUR8FifJg6AfQvzpshgwJ8kyf9Fdty2ew.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Ramabhadra\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"telugu\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-04-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ramabhadra/v15/EYq2maBOwqRW9P1SQ83LehNGX5uWw3o.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Ramaraja\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"telugu\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ramaraja/v15/SlGTmQearpYAYG1CABIkqnB6aSQU.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rambla\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rambla/v13/snfrs0ip98hx6mr0I7IONthkwQ.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/rambla/v13/snfps0ip98hx6mrEIbgKFN10wYKa.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/rambla/v13/snfos0ip98hx6mrMn50qPvN4yJuDYQ.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/rambla/v13/snfus0ip98hx6mrEIYC2O_l86p6TYS-Y.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rammetto One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rammettoone/v14/LhWiMV3HOfMbMetJG3lQDpp9Mvuciu-_SQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rampart One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v7\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rampartone/v7/K2F1fZFGl_JSR1tAWNG9R6qgLS76ZHOM.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Ranchers\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ranchers/v13/zrfm0H3Lx-P2Xvs2AoDYDC79XTHv.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rancho\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rancho/v17/46kulbzmXjLaqZRlbWXgd0RY1g.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Ranga\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ranga/v17/C8ct4cYisGb28p6CLDwZwmGE.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/ranga/v17/C8cg4cYisGb28qY-AxgR6X2NZAn2.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rasa\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"gujarati\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/rasa/v15/xn76YHIn1mWmVKl8ZtAM9NrJfN4YJW41fcvN2KT4.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rasa/v15/xn76YHIn1mWmVKl8ZtAM9NrJfN5GJW41fcvN2KT4.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/rasa/v15/xn76YHIn1mWmVKl8ZtAM9NrJfN50JW41fcvN2KT4.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/rasa/v15/xn76YHIn1mWmVKl8ZtAM9NrJfN6YIm41fcvN2KT4.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/rasa/v15/xn76YHIn1mWmVKl8ZtAM9NrJfN6hIm41fcvN2KT4.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/rasa/v15/xn78YHIn1mWmfqBOmQhln0Bne8uOZth2d8_v3bT4Ycc.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/rasa/v15/xn78YHIn1mWmfqBOmQhln0Bne8uOZoZ2d8_v3bT4Ycc.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/rasa/v15/xn78YHIn1mWmfqBOmQhln0Bne8uOZrR2d8_v3bT4Ycc.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/rasa/v15/xn78YHIn1mWmfqBOmQhln0Bne8uOZlhxd8_v3bT4Ycc.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/rasa/v15/xn78YHIn1mWmfqBOmQhln0Bne8uOZmFxd8_v3bT4Ycc.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rationale\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-04-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rationale/v24/9XUnlJ92n0_JFxHIfHcsdlFMzLC2Zw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Ravi Prakash\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"telugu\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/raviprakash/v19/gokpH6fsDkVrF9Bv9X8SOAKHmNZEq6TTFw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Readex Pro\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/readexpro/v15/SLXnc1bJ7HE5YDoGPuzj_dh8uc7wUy8ZQQyX2KY8TL0kGZN6blTCYUSmgmsglvjkag.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/readexpro/v15/SLXnc1bJ7HE5YDoGPuzj_dh8uc7wUy8ZQQyX2KY8TL0kGZN6blTCv0Smgmsglvjkag.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/readexpro/v15/SLXnc1bJ7HE5YDoGPuzj_dh8uc7wUy8ZQQyX2KY8TL0kGZN6blTC4USmgmsglvjkag.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/readexpro/v15/SLXnc1bJ7HE5YDoGPuzj_dh8uc7wUy8ZQQyX2KY8TL0kGZN6blTC00Smgmsglvjkag.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/readexpro/v15/SLXnc1bJ7HE5YDoGPuzj_dh8uc7wUy8ZQQyX2KY8TL0kGZN6blTCP0Omgmsglvjkag.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/readexpro/v15/SLXnc1bJ7HE5YDoGPuzj_dh8uc7wUy8ZQQyX2KY8TL0kGZN6blTCBkOmgmsglvjkag.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Recursive\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v37\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/recursive/v37/8vJN7wMr0mhh-RQChyHEH06TlXhq_gukbYrFMk1QuAIcyEwG_X-dpEfaE5YaERmK-CImKsvxvU-MXGX2fSqasNfUvz2xbXfn1uEQadDck018vwxjDJCL.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/recursive/v37/8vJN7wMr0mhh-RQChyHEH06TlXhq_gukbYrFMk1QuAIcyEwG_X-dpEfaE5YaERmK-CImKsvxvU-MXGX2fSqasNfUvz2xbXfn1uEQadCCk018vwxjDJCL.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/recursive/v37/8vJN7wMr0mhh-RQChyHEH06TlXhq_gukbYrFMk1QuAIcyEwG_X-dpEfaE5YaERmK-CImKsvxvU-MXGX2fSqasNfUvz2xbXfn1uEQadCwk018vwxjDJCL.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/recursive/v37/8vJN7wMr0mhh-RQChyHEH06TlXhq_gukbYrFMk1QuAIcyEwG_X-dpEfaE5YaERmK-CImKsvxvU-MXGX2fSqasNfUvz2xbXfn1uEQadBclE18vwxjDJCL.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/recursive/v37/8vJN7wMr0mhh-RQChyHEH06TlXhq_gukbYrFMk1QuAIcyEwG_X-dpEfaE5YaERmK-CImKsvxvU-MXGX2fSqasNfUvz2xbXfn1uEQadBllE18vwxjDJCL.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/recursive/v37/8vJN7wMr0mhh-RQChyHEH06TlXhq_gukbYrFMk1QuAIcyEwG_X-dpEfaE5YaERmK-CImKsvxvU-MXGX2fSqasNfUvz2xbXfn1uEQadAClE18vwxjDJCL.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/recursive/v37/8vJN7wMr0mhh-RQChyHEH06TlXhq_gukbYrFMk1QuAIcyEwG_X-dpEfaE5YaERmK-CImKsvxvU-MXGX2fSqasNfUvz2xbXfn1uEQadArlE18vwxjDJCL.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Red Hat Display\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/redhatdisplay/v14/8vIf7wUr0m80wwYf0QCXZzYzUoTK8RZQvRd-D1NYbjKWckg5-Xecg3w.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/redhatdisplay/v14/8vIf7wUr0m80wwYf0QCXZzYzUoTK8RZQvRd-D1NYbmyWckg5-Xecg3w.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/redhatdisplay/v14/8vIf7wUr0m80wwYf0QCXZzYzUoTK8RZQvRd-D1NYbl6Wckg5-Xecg3w.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/redhatdisplay/v14/8vIf7wUr0m80wwYf0QCXZzYzUoTK8RZQvRd-D1NYbrKRckg5-Xecg3w.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/redhatdisplay/v14/8vIf7wUr0m80wwYf0QCXZzYzUoTK8RZQvRd-D1NYbouRckg5-Xecg3w.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/redhatdisplay/v14/8vIf7wUr0m80wwYf0QCXZzYzUoTK8RZQvRd-D1NYbuyRckg5-Xecg3w.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/redhatdisplay/v14/8vIf7wUr0m80wwYf0QCXZzYzUoTK8RZQvRd-D1NYbsWRckg5-Xecg3w.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/redhatdisplay/v14/8vIh7wUr0m80wwYf0QCXZzYzUoTg-CSvZX4Vlf1fe6TVxAsz_VWZk3zJGg.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/redhatdisplay/v14/8vIh7wUr0m80wwYf0QCXZzYzUoTg-CSvZX4Vlf1fe6TVmgsz_VWZk3zJGg.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/redhatdisplay/v14/8vIh7wUr0m80wwYf0QCXZzYzUoTg-CSvZX4Vlf1fe6TVqAsz_VWZk3zJGg.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/redhatdisplay/v14/8vIh7wUr0m80wwYf0QCXZzYzUoTg-CSvZX4Vlf1fe6TVRAwz_VWZk3zJGg.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/redhatdisplay/v14/8vIh7wUr0m80wwYf0QCXZzYzUoTg-CSvZX4Vlf1fe6TVfQwz_VWZk3zJGg.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/redhatdisplay/v14/8vIh7wUr0m80wwYf0QCXZzYzUoTg-CSvZX4Vlf1fe6TVGgwz_VWZk3zJGg.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/redhatdisplay/v14/8vIh7wUr0m80wwYf0QCXZzYzUoTg-CSvZX4Vlf1fe6TVMwwz_VWZk3zJGg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Red Hat Mono\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/redhatmono/v10/jVyY7nDnA2uf2zVvFAhhzEs-VMSjJpBTfgjwQQPI-7HNuW4QuKI.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/redhatmono/v10/jVyY7nDnA2uf2zVvFAhhzEs-VMSjJpBTfgjwQV3I-7HNuW4QuKI.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/redhatmono/v10/jVyY7nDnA2uf2zVvFAhhzEs-VMSjJpBTfgjwQW_I-7HNuW4QuKI.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/redhatmono/v10/jVyY7nDnA2uf2zVvFAhhzEs-VMSjJpBTfgjwQYPP-7HNuW4QuKI.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/redhatmono/v10/jVyY7nDnA2uf2zVvFAhhzEs-VMSjJpBTfgjwQbrP-7HNuW4QuKI.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/redhatmono/v10/jVye7nDnA2uf2zVvFAhhzEsUXfZc_vk45Kb3VJWLTfLHvUwVqKIJuw.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/redhatmono/v10/jVye7nDnA2uf2zVvFAhhzEsUXfZc_vk45Kb3VJWLE_LHvUwVqKIJuw.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/redhatmono/v10/jVye7nDnA2uf2zVvFAhhzEsUXfZc_vk45Kb3VJWLIfLHvUwVqKIJuw.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/redhatmono/v10/jVye7nDnA2uf2zVvFAhhzEsUXfZc_vk45Kb3VJWLzfXHvUwVqKIJuw.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/redhatmono/v10/jVye7nDnA2uf2zVvFAhhzEsUXfZc_vk45Kb3VJWL9PXHvUwVqKIJuw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"monospace\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Red Hat Text\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/redhattext/v13/RrQCbohi_ic6B3yVSzGBrMx6ZI_cy1A6Ok2ML-ZwVrbacYVFtIY.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/redhattext/v13/RrQCbohi_ic6B3yVSzGBrMx6ZI_cy1A6Ok2ML7hwVrbacYVFtIY.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/redhattext/v13/RrQCbohi_ic6B3yVSzGBrMx6ZI_cy1A6Ok2ML4pwVrbacYVFtIY.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/redhattext/v13/RrQCbohi_ic6B3yVSzGBrMx6ZI_cy1A6Ok2ML2Z3VrbacYVFtIY.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/redhattext/v13/RrQCbohi_ic6B3yVSzGBrMx6ZI_cy1A6Ok2ML193VrbacYVFtIY.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/redhattext/v13/RrQEbohi_ic6B3yVSzGBrMxQbb0jEzlRoOOLOnAz4PXQdadApIYv_g.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/redhattext/v13/RrQEbohi_ic6B3yVSzGBrMxQbb0jEzlRoOOLOnAzvvXQdadApIYv_g.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/redhattext/v13/RrQEbohi_ic6B3yVSzGBrMxQbb0jEzlRoOOLOnAzjPXQdadApIYv_g.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/redhattext/v13/RrQEbohi_ic6B3yVSzGBrMxQbb0jEzlRoOOLOnAzYPLQdadApIYv_g.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/redhattext/v13/RrQEbohi_ic6B3yVSzGBrMxQbb0jEzlRoOOLOnAzWfLQdadApIYv_g.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Red Rose\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/redrose/v14/QdVISTYiLBjouPgEUajvsfWwDtc3MH8y8_sDcjSsYUVUjg.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/redrose/v14/QdVISTYiLBjouPgEUajvsfWwDtc3MH8yrfsDcjSsYUVUjg.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/redrose/v14/QdVISTYiLBjouPgEUajvsfWwDtc3MH8yn_sDcjSsYUVUjg.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/redrose/v14/QdVISTYiLBjouPgEUajvsfWwDtc3MH8yc_wDcjSsYUVUjg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/redrose/v14/QdVISTYiLBjouPgEUajvsfWwDtc3MH8ySvwDcjSsYUVUjg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Redacted\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v6\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/redacted/v6/Z9XVDmdRShme2O_7aITe4u2El6GC.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Redacted Script\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v6\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/redactedscript/v6/ypvEbXGRglhokR7dcC3d1-R6zmxqHUzVmbI397ldkg.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/redactedscript/v6/ypvBbXGRglhokR7dcC3d1-R6zmxSsWTxkZkr_g.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/redactedscript/v6/ypvEbXGRglhokR7dcC3d1-R6zmxqDUvVmbI397ldkg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Redressed\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v25\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/redressed/v25/x3dickHUbrmJ7wMy9MsBfPACvy_1BA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Reem Kufi\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/reemkufi/v20/2sDPZGJLip7W2J7v7wQZZE1I0yCmYzzQtuZnEGGf3qGuvM4.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/reemkufi/v20/2sDPZGJLip7W2J7v7wQZZE1I0yCmYzzQttRnEGGf3qGuvM4.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/reemkufi/v20/2sDPZGJLip7W2J7v7wQZZE1I0yCmYzzQtjhgEGGf3qGuvM4.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/reemkufi/v20/2sDPZGJLip7W2J7v7wQZZE1I0yCmYzzQtgFgEGGf3qGuvM4.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Reem Kufi Fun\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v6\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/reemkufifun/v6/uK_m4rOFYukkmyUEbF43fIryZEk5qRZ8nrKChoYj3nCgrvqZzZXq.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/reemkufifun/v6/uK_m4rOFYukkmyUEbF43fIryZEk5qRZ8nrKChoYR3nCgrvqZzZXq.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/reemkufifun/v6/uK_m4rOFYukkmyUEbF43fIryZEk5qRZ8nrKChob92XCgrvqZzZXq.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/reemkufifun/v6/uK_m4rOFYukkmyUEbF43fIryZEk5qRZ8nrKChobE2XCgrvqZzZXq.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Reem Kufi Ink\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v8\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/reemkufiink/v8/oPWJ_kJmmu8hCvB9iFumxZSnRj5dQnSX1ko.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Reenie Beanie\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/reeniebeanie/v16/z7NSdR76eDkaJKZJFkkjuvWxbP2_qoOgf_w.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Reggae One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/reggaeone/v14/~CgwKClJlZ2dhZSBPbmUgACoECAEYAQ==.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Revalia\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/revalia/v20/WwkexPimBE2-4ZPEeVruNIgJSNM.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rhodium Libre\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rhodiumlibre/v17/1q2AY5adA0tn_ukeHcQHqpx6pETLeo2gm2U.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Ribeye\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ribeye/v21/L0x8DFMxk1MP9R3RvPCmRSlUig.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Ribeye Marrow\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ribeyemarrow/v22/GFDsWApshnqMRO2JdtRZ2d0vEAwTVWgKdtw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Righteous\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/righteous/v13/1cXxaUPXBpj2rGoU7C9mj3uEicG01A.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Risque\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/risque/v20/VdGfAZUfHosahXxoCUYVBJ-T5g.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Road Rage\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v5\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/roadrage/v5/6NUU8F2fKAOBKjjr4ekvtMYAwdRZfw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Roboto\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"900\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v30\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/roboto/v30/KFOkCnqEu92Fr1MmgWxPKTM1K9nz.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/roboto/v30/KFOiCnqEu92Fr1Mu51QrIzcXLsnzjYk.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmSU5vAx05IsDqlA.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/roboto/v30/KFOjCnqEu92Fr1Mu51TjARc9AMX6lJBP.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Me5WZLCzYlKw.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/roboto/v30/KFOkCnqEu92Fr1Mu52xPKTM1K9nz.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmEU9vAx05IsDqlA.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/roboto/v30/KFOjCnqEu92Fr1Mu51S7ABc9AMX6lJBP.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmWUlvAx05IsDqlA.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/roboto/v30/KFOjCnqEu92Fr1Mu51TzBhc9AMX6lJBP.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmYUtvAx05IsDqlA.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/roboto/v30/KFOjCnqEu92Fr1Mu51TLBBc9AMX6lJBP.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Roboto Condensed\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v25\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/robotocondensed/v25/ieVi2ZhZI2eCN5jzbjEETS9weq8-33mZKCMSbvtdYyQ.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/robotocondensed/v25/ieVg2ZhZI2eCN5jzbjEETS9weq8-19eDpCEYatlYcyRi4A.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/robotocondensed/v25/ieVl2ZhZI2eCN5jzbjEETS9weq8-59WxDCs5cvI.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/robotocondensed/v25/ieVj2ZhZI2eCN5jzbjEETS9weq8-19e7CAk8YvJEeg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/robotocondensed/v25/ieVi2ZhZI2eCN5jzbjEETS9weq8-32meKCMSbvtdYyQ.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/robotocondensed/v25/ieVg2ZhZI2eCN5jzbjEETS9weq8-19eDtCYYatlYcyRi4A.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Roboto Flex\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v9\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/robotoflex/v9/NaN4epOXO_NexZs0b5QrzlOHb8wCikXpYqmZsWI-__OGfttPZktqc2VdZ80KvCLZaPcSBZtOx2MifRuWR28sPJtUMbsFEK6cRrleUx9Xgbm3WLHa_F4Ep4Fm0PN19Ik5Dntczx0wZGzhPlL1YNMYKbv9_1IQXOw7AiUJVXpRJ6cXW4O8TNGoXjC79QRyaLshNDUf3e0O-gn5rrZCu20YNYG0EACUTNK-QKavMlxGIY8dxef0jQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Roboto Mono\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/robotomono/v22/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_3vuPQ--5Ip2sSQ.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/robotomono/v22/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_XvqPQ--5Ip2sSQ.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/robotomono/v22/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_gPqPQ--5Ip2sSQ.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/robotomono/v22/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_3vqPQ--5Ip2sSQ.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/robotomono/v22/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_7PqPQ--5Ip2sSQ.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/robotomono/v22/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_AP2PQ--5Ip2sSQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/robotomono/v22/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_Of2PQ--5Ip2sSQ.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/robotomono/v22/L0xoDF4xlVMF-BfR8bXMIjhOsXG-q2oeuFoqFrlnAeW9AJi8SZwt.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/robotomono/v22/L0xoDF4xlVMF-BfR8bXMIjhOsXG-q2oeuFoqFrnnAOW9AJi8SZwt.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/robotomono/v22/L0xoDF4xlVMF-BfR8bXMIjhOsXG-q2oeuFoqFrk5AOW9AJi8SZwt.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/robotomono/v22/L0xoDF4xlVMF-BfR8bXMIjhOsXG-q2oeuFoqFrlnAOW9AJi8SZwt.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/robotomono/v22/L0xoDF4xlVMF-BfR8bXMIjhOsXG-q2oeuFoqFrlVAOW9AJi8SZwt.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/robotomono/v22/L0xoDF4xlVMF-BfR8bXMIjhOsXG-q2oeuFoqFrm5B-W9AJi8SZwt.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/robotomono/v22/L0xoDF4xlVMF-BfR8bXMIjhOsXG-q2oeuFoqFrmAB-W9AJi8SZwt.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"monospace\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Roboto Serif\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v8\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/robotoserif/v8/R71RjywflP6FLr3gZx7K8UyuXDs9zVwDmXCb8lxYgmuii32UGoVldX6UgfjL4-3sMM_kB_qXSEXTJQCFLH5-_bcEliosp6d2Af5fR4k.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/robotoserif/v8/R71RjywflP6FLr3gZx7K8UyuXDs9zVwDmXCb8lxYgmuii32UGoVldX6UgfjL4-3sMM_kB_qXSEXTJQCFLH5-_bcElqotp6d2Af5fR4k.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/robotoserif/v8/R71RjywflP6FLr3gZx7K8UyuXDs9zVwDmXCb8lxYgmuii32UGoVldX6UgfjL4-3sMM_kB_qXSEXTJQCFLH5-_bcElnQtp6d2Af5fR4k.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/robotoserif/v8/R71RjywflP6FLr3gZx7K8UyuXDs9zVwDmXCb8lxYgmuii32UGoVldX6UgfjL4-3sMM_kB_qXSEXTJQCFLH5-_bcEliotp6d2Af5fR4k.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/robotoserif/v8/R71RjywflP6FLr3gZx7K8UyuXDs9zVwDmXCb8lxYgmuii32UGoVldX6UgfjL4-3sMM_kB_qXSEXTJQCFLH5-_bcElhgtp6d2Af5fR4k.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/robotoserif/v8/R71RjywflP6FLr3gZx7K8UyuXDs9zVwDmXCb8lxYgmuii32UGoVldX6UgfjL4-3sMM_kB_qXSEXTJQCFLH5-_bcElvQqp6d2Af5fR4k.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/robotoserif/v8/R71RjywflP6FLr3gZx7K8UyuXDs9zVwDmXCb8lxYgmuii32UGoVldX6UgfjL4-3sMM_kB_qXSEXTJQCFLH5-_bcEls0qp6d2Af5fR4k.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/robotoserif/v8/R71RjywflP6FLr3gZx7K8UyuXDs9zVwDmXCb8lxYgmuii32UGoVldX6UgfjL4-3sMM_kB_qXSEXTJQCFLH5-_bcElqoqp6d2Af5fR4k.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/robotoserif/v8/R71RjywflP6FLr3gZx7K8UyuXDs9zVwDmXCb8lxYgmuii32UGoVldX6UgfjL4-3sMM_kB_qXSEXTJQCFLH5-_bcEloMqp6d2Af5fR4k.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/robotoserif/v8/R71XjywflP6FLr3gZx7K8UyEVQnyR1E7VN-f51xYuGCQepOvB0KLc2v0wKKB0Q4MSZxyqf2CgAchbDJ69BcVZxkDg-JuT-V8BdxaV4nUFw.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/robotoserif/v8/R71XjywflP6FLr3gZx7K8UyEVQnyR1E7VN-f51xYuGCQepOvB0KLc2v0wKKB0Q4MSZxyqf2CgAchbDJ69BcVZxkDg-Juz-R8BdxaV4nUFw.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/robotoserif/v8/R71XjywflP6FLr3gZx7K8UyEVQnyR1E7VN-f51xYuGCQepOvB0KLc2v0wKKB0Q4MSZxyqf2CgAchbDJ69BcVZxkDg-JuEeR8BdxaV4nUFw.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/robotoserif/v8/R71XjywflP6FLr3gZx7K8UyEVQnyR1E7VN-f51xYuGCQepOvB0KLc2v0wKKB0Q4MSZxyqf2CgAchbDJ69BcVZxkDg-JuT-R8BdxaV4nUFw.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/robotoserif/v8/R71XjywflP6FLr3gZx7K8UyEVQnyR1E7VN-f51xYuGCQepOvB0KLc2v0wKKB0Q4MSZxyqf2CgAchbDJ69BcVZxkDg-JufeR8BdxaV4nUFw.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/robotoserif/v8/R71XjywflP6FLr3gZx7K8UyEVQnyR1E7VN-f51xYuGCQepOvB0KLc2v0wKKB0Q4MSZxyqf2CgAchbDJ69BcVZxkDg-JukeN8BdxaV4nUFw.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/robotoserif/v8/R71XjywflP6FLr3gZx7K8UyEVQnyR1E7VN-f51xYuGCQepOvB0KLc2v0wKKB0Q4MSZxyqf2CgAchbDJ69BcVZxkDg-JuqON8BdxaV4nUFw.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/robotoserif/v8/R71XjywflP6FLr3gZx7K8UyEVQnyR1E7VN-f51xYuGCQepOvB0KLc2v0wKKB0Q4MSZxyqf2CgAchbDJ69BcVZxkDg-Juz-N8BdxaV4nUFw.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/robotoserif/v8/R71XjywflP6FLr3gZx7K8UyEVQnyR1E7VN-f51xYuGCQepOvB0KLc2v0wKKB0Q4MSZxyqf2CgAchbDJ69BcVZxkDg-Ju5uN8BdxaV4nUFw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Roboto Slab\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/robotoslab/v24/BngbUXZYTXPIvIBgJJSb6s3BzlRRfKOFbvjojIWWaG5iddG-1A.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/robotoslab/v24/BngbUXZYTXPIvIBgJJSb6s3BzlRRfKOFbvjoDISWaG5iddG-1A.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/robotoslab/v24/BngbUXZYTXPIvIBgJJSb6s3BzlRRfKOFbvjo0oSWaG5iddG-1A.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/robotoslab/v24/BngbUXZYTXPIvIBgJJSb6s3BzlRRfKOFbvjojISWaG5iddG-1A.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/robotoslab/v24/BngbUXZYTXPIvIBgJJSb6s3BzlRRfKOFbvjovoSWaG5iddG-1A.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/robotoslab/v24/BngbUXZYTXPIvIBgJJSb6s3BzlRRfKOFbvjoUoOWaG5iddG-1A.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/robotoslab/v24/BngbUXZYTXPIvIBgJJSb6s3BzlRRfKOFbvjoa4OWaG5iddG-1A.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/robotoslab/v24/BngbUXZYTXPIvIBgJJSb6s3BzlRRfKOFbvjoDIOWaG5iddG-1A.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/robotoslab/v24/BngbUXZYTXPIvIBgJJSb6s3BzlRRfKOFbvjoJYOWaG5iddG-1A.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rochester\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rochester/v18/6ae-4KCqVa4Zy6Fif-Uy31vWNTMwoQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rock Salt\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rocksalt/v18/MwQ0bhv11fWD6QsAVOZbsEk7hbBWrA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"RocknRoll One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rocknrollone/v10/kmK7ZqspGAfCeUiW6FFlmEC9guVhs7tfUxc.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rokkitt\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v29\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/rokkitt/v29/qFdb35qfgYFjGy5hukqqhw5XeRgdi1rydpDLE76HvN6n.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/rokkitt/v29/qFdb35qfgYFjGy5hukqqhw5XeRgdi1pyd5DLE76HvN6n.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/rokkitt/v29/qFdb35qfgYFjGy5hukqqhw5XeRgdi1qsd5DLE76HvN6n.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rokkitt/v29/qFdb35qfgYFjGy5hukqqhw5XeRgdi1ryd5DLE76HvN6n.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/rokkitt/v29/qFdb35qfgYFjGy5hukqqhw5XeRgdi1rAd5DLE76HvN6n.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/rokkitt/v29/qFdb35qfgYFjGy5hukqqhw5XeRgdi1oscJDLE76HvN6n.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/rokkitt/v29/qFdb35qfgYFjGy5hukqqhw5XeRgdi1oVcJDLE76HvN6n.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/rokkitt/v29/qFdb35qfgYFjGy5hukqqhw5XeRgdi1pycJDLE76HvN6n.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/rokkitt/v29/qFdb35qfgYFjGy5hukqqhw5XeRgdi1pbcJDLE76HvN6n.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Romanesco\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/romanesco/v21/w8gYH2ozQOY7_r_J7mSn3HwLqOqSBg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Ropa Sans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ropasans/v15/EYqxmaNOzLlWtsZSScyKWjloU5KP2g.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/ropasans/v15/EYq3maNOzLlWtsZSScy6WDNscZef2mNE.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rosario\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v27\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/rosario/v27/xfuu0WDhWW_fOEoY8l_VPNZfB7jPM69GCWczd-YnOzUD.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rosario/v27/xfuu0WDhWW_fOEoY8l_VPNZfB7jPM68YCWczd-YnOzUD.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/rosario/v27/xfuu0WDhWW_fOEoY8l_VPNZfB7jPM68qCWczd-YnOzUD.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/rosario/v27/xfuu0WDhWW_fOEoY8l_VPNZfB7jPM6_GDmczd-YnOzUD.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/rosario/v27/xfuu0WDhWW_fOEoY8l_VPNZfB7jPM6__Dmczd-YnOzUD.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/rosario/v27/xfug0WDhWW_fOEoY2Fbnww42bCJhNLrQStFwfeIFPiUDn08.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/rosario/v27/xfug0WDhWW_fOEoY2Fbnww42bCJhNLrQSo9wfeIFPiUDn08.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/rosario/v27/xfug0WDhWW_fOEoY2Fbnww42bCJhNLrQSr1wfeIFPiUDn08.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/rosario/v27/xfug0WDhWW_fOEoY2Fbnww42bCJhNLrQSlF3feIFPiUDn08.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/rosario/v27/xfug0WDhWW_fOEoY2Fbnww42bCJhNLrQSmh3feIFPiUDn08.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rosarivo\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rosarivo/v20/PlI-Fl2lO6N9f8HaNAeC2nhMnNy5.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/rosarivo/v20/PlI4Fl2lO6N9f8HaNDeA0Hxumcy5ZX8.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rouge Script\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rougescript/v14/LYjFdGbiklMoCIQOw1Ep3S4PVPXbUJWq9g.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rowdies\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/rowdies/v15/ptRMTieMYPNBAK219hth5O7yKQNute8.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rowdies/v15/ptRJTieMYPNBAK21zrdJwObZNQo.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/rowdies/v15/ptRMTieMYPNBAK219gtm5O7yKQNute8.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rozha One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rozhaone/v13/AlZy_zVFtYP12Zncg2khdXf4XB0Tow.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rubik\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v23\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/rubik/v23/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-WYi1UE80V4bVkA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rubik/v23/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-B4i1UE80V4bVkA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/rubik/v23/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-NYi1UE80V4bVkA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/rubik/v23/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-2Y-1UE80V4bVkA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/rubik/v23/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-4I-1UE80V4bVkA.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/rubik/v23/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-h4-1UE80V4bVkA.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/rubik/v23/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-ro-1UE80V4bVkA.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/rubik/v23/iJWbBXyIfDnIV7nEt3KSJbVDV49rz8sDE0UwdYPFkJ1O.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/rubik/v23/iJWbBXyIfDnIV7nEt3KSJbVDV49rz8tdE0UwdYPFkJ1O.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/rubik/v23/iJWbBXyIfDnIV7nEt3KSJbVDV49rz8tvE0UwdYPFkJ1O.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/rubik/v23/iJWbBXyIfDnIV7nEt3KSJbVDV49rz8uDFEUwdYPFkJ1O.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/rubik/v23/iJWbBXyIfDnIV7nEt3KSJbVDV49rz8u6FEUwdYPFkJ1O.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/rubik/v23/iJWbBXyIfDnIV7nEt3KSJbVDV49rz8vdFEUwdYPFkJ1O.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/rubik/v23/iJWbBXyIfDnIV7nEt3KSJbVDV49rz8v0FEUwdYPFkJ1O.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rubik 80s Fade\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rubik80sfade/v1/U9MF6dW37nLSmnwZXyoV-uPXUhHwkbL8IHcK.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rubik Beastly\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rubikbeastly/v10/0QImMXRd5oOmSC2ZQ7o9653X07z8_ApHqqk.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rubik Bubbles\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v2\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rubikbubbles/v2/JIA1UVdwbHFJtwA7Us1BPFbRNTENfDxyRXI.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rubik Burned\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rubikburned/v1/Jqzk5TmOVOqQHihKqPpscqniHQuaCY5ZSg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rubik Dirt\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rubikdirt/v1/DtVmJxC7WLEj1uIXEWAdulwm6gDXvwE.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rubik Distressed\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rubikdistressed/v1/GFDxWBdsmnqAVqjtUsZf2dcrQ2ldcWAhatVBaGM.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rubik Gemstones\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rubikgemstones/v1/zrf90HrL0-_8Xb4DFM2rUkWbOVrOiCnGqi1GMw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rubik Glitch\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v2\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rubikglitch/v2/qkBSXv8b_srFRYQVYrDKh9ZvmC7HONiSFQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rubik Iso\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rubikiso/v1/x3dickHUfr-S4VAI4sABfPACvy_1BA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rubik Marker Hatch\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rubikmarkerhatch/v1/QldTNSFQsh0B_bFXXWv6LAt-jswapJHQDL4iw0H6zw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rubik Maze\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rubikmaze/v1/xMQRuF9ZVa2ftiJEavXSAX7inS-bxV4.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rubik Microbe\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v2\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rubikmicrobe/v2/UqyWK8oPP3hjw6ANS9rM3PsZcs8aaKgiauE.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rubik Mono One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rubikmonoone/v14/UqyJK8kPP3hjw6ANTdfRk9YSN-8wRqQrc_j9.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rubik Moonrocks\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v2\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rubikmoonrocks/v2/845ANMAmAI2VUZMLu_W0M7HqlDHnXcD7JGy1Sw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rubik Puddles\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v2\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rubikpuddles/v2/1Ptog8bYX_qGnkLkrU5MJsQcJfC0wVMT-aE.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rubik Spray Paint\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rubikspraypaint/v1/WnzhHBAoeBPUDTB4EWR82y6EXWPH-Ro-QoaBZQxP.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rubik Storm\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rubikstorm/v1/eLGYP-_uPgO5Ag7ju9JaouL9T2Xh9NQk.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rubik Vinyl\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rubikvinyl/v1/iJWABXKIfDnIV4mQ5BfjvUXexox2ztOU.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rubik Wet Paint\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v2\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rubikwetpaint/v2/HTx0L20uMDGHgdULcpTF3Oe4d_-F-zz313DuvQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Ruda\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v23\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ruda/v23/k3kKo8YQJOpFgHQ1mQ5VkEbUKaJFsi_-2KiSGg-H.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/ruda/v23/k3kKo8YQJOpFgHQ1mQ5VkEbUKaJ3si_-2KiSGg-H.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/ruda/v23/k3kKo8YQJOpFgHQ1mQ5VkEbUKaKbtS_-2KiSGg-H.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/ruda/v23/k3kKo8YQJOpFgHQ1mQ5VkEbUKaKitS_-2KiSGg-H.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/ruda/v23/k3kKo8YQJOpFgHQ1mQ5VkEbUKaLFtS_-2KiSGg-H.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/ruda/v23/k3kKo8YQJOpFgHQ1mQ5VkEbUKaLstS_-2KiSGg-H.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rufina\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rufina/v13/Yq6V-LyURyLy-aKyoxRktOdClg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/rufina/v13/Yq6W-LyURyLy-aKKHztAvMxenxE0SA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Ruge Boogie\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rugeboogie/v24/JIA3UVFwbHRF_GIWSMhKNROiPzUveSxy.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Ruluko\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-04-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ruluko/v21/xMQVuFNZVaODtm0pC6WzKX_QmA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rum Raisin\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rumraisin/v20/nwpRtKu3Ih8D5avB4h2uJ3-IywA7eMM.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Ruslan Display\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ruslandisplay/v22/Gw6jwczl81XcIZuckK_e3UpfdzxrldyFvm1n.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Russo One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/russoone/v14/Z9XUDmZRWg6M1LvRYsH-yMOInrib9Q.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Ruthie\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ruthie/v24/gokvH63sGkdqXuU9lD53Q2u_mQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Rye\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/rye/v13/r05XGLJT86YDFpTsXOqx4w.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"STIX Two Text\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/stixtwotext/v10/YA9Gr02F12Xkf5whdwKf11l0jbKkeidMTtZ5Yihg2SOYWxFMN1WD.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/stixtwotext/v10/YA9Gr02F12Xkf5whdwKf11l0jbKkeidMTtZ5YihS2SOYWxFMN1WD.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/stixtwotext/v10/YA9Gr02F12Xkf5whdwKf11l0jbKkeidMTtZ5Yii-3iOYWxFMN1WD.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/stixtwotext/v10/YA9Gr02F12Xkf5whdwKf11l0jbKkeidMTtZ5YiiH3iOYWxFMN1WD.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/stixtwotext/v10/YA9Er02F12Xkf5whdwKf11l0p7uWhf8lJUzXZT2omsvbURVuMkWDmSo.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/stixtwotext/v10/YA9Er02F12Xkf5whdwKf11l0p7uWhf8lJUzXZT2omvnbURVuMkWDmSo.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/stixtwotext/v10/YA9Er02F12Xkf5whdwKf11l0p7uWhf8lJUzXZT2omhXcURVuMkWDmSo.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/stixtwotext/v10/YA9Er02F12Xkf5whdwKf11l0p7uWhf8lJUzXZT2omizcURVuMkWDmSo.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sacramento\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sacramento/v13/buEzpo6gcdjy0EiZMBUG0CoV_NxLeiw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sahitya\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sahitya/v17/6qLAKZkOuhnuqlJAaScFPywEDnI.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/sahitya/v17/6qLFKZkOuhnuqlJAUZsqGyQvEnvSexI.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sail\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sail/v16/DPEjYwiBxwYJFBTDADYAbvw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Saira\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/saira/v14/memWYa2wxmKQyPMrZX79wwYZQMhsyuShhKMjjbU9uXuA71rDosg7lwYmUVY.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/saira/v14/memWYa2wxmKQyPMrZX79wwYZQMhsyuShhKMjjbU9uXuA79rCosg7lwYmUVY.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/saira/v14/memWYa2wxmKQyPMrZX79wwYZQMhsyuShhKMjjbU9uXuA7wTCosg7lwYmUVY.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/saira/v14/memWYa2wxmKQyPMrZX79wwYZQMhsyuShhKMjjbU9uXuA71rCosg7lwYmUVY.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/saira/v14/memWYa2wxmKQyPMrZX79wwYZQMhsyuShhKMjjbU9uXuA72jCosg7lwYmUVY.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/saira/v14/memWYa2wxmKQyPMrZX79wwYZQMhsyuShhKMjjbU9uXuA74TFosg7lwYmUVY.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/saira/v14/memWYa2wxmKQyPMrZX79wwYZQMhsyuShhKMjjbU9uXuA773Fosg7lwYmUVY.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/saira/v14/memWYa2wxmKQyPMrZX79wwYZQMhsyuShhKMjjbU9uXuA79rFosg7lwYmUVY.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/saira/v14/memWYa2wxmKQyPMrZX79wwYZQMhsyuShhKMjjbU9uXuA7_PFosg7lwYmUVY.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/saira/v14/memUYa2wxmKQyNkiV50dulWP7s95AqZTzZHcVdxWI9WH-pKBSooxkyQjQVYmxA.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/saira/v14/memUYa2wxmKQyNkiV50dulWP7s95AqZTzZHcVdxWI9WH-pKByosxkyQjQVYmxA.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/saira/v14/memUYa2wxmKQyNkiV50dulWP7s95AqZTzZHcVdxWI9WH-pKBFIsxkyQjQVYmxA.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/saira/v14/memUYa2wxmKQyNkiV50dulWP7s95AqZTzZHcVdxWI9WH-pKBSosxkyQjQVYmxA.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/saira/v14/memUYa2wxmKQyNkiV50dulWP7s95AqZTzZHcVdxWI9WH-pKBeIsxkyQjQVYmxA.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/saira/v14/memUYa2wxmKQyNkiV50dulWP7s95AqZTzZHcVdxWI9WH-pKBlIwxkyQjQVYmxA.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/saira/v14/memUYa2wxmKQyNkiV50dulWP7s95AqZTzZHcVdxWI9WH-pKBrYwxkyQjQVYmxA.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/saira/v14/memUYa2wxmKQyNkiV50dulWP7s95AqZTzZHcVdxWI9WH-pKByowxkyQjQVYmxA.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/saira/v14/memUYa2wxmKQyNkiV50dulWP7s95AqZTzZHcVdxWI9WH-pKB44wxkyQjQVYmxA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Saira Condensed\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/sairacondensed/v11/EJRMQgErUN8XuHNEtX81i9TmEkrnwetA2omSrzS8.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/sairacondensed/v11/EJRLQgErUN8XuHNEtX81i9TmEkrnbcpg8Keepi2lHw.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/sairacondensed/v11/EJRLQgErUN8XuHNEtX81i9TmEkrnCclg8Keepi2lHw.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sairacondensed/v11/EJROQgErUN8XuHNEtX81i9TmEkrfpeFE-IyCrw.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/sairacondensed/v11/EJRLQgErUN8XuHNEtX81i9TmEkrnUchg8Keepi2lHw.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/sairacondensed/v11/EJRLQgErUN8XuHNEtX81i9TmEkrnfc9g8Keepi2lHw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/sairacondensed/v11/EJRLQgErUN8XuHNEtX81i9TmEkrnGc5g8Keepi2lHw.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/sairacondensed/v11/EJRLQgErUN8XuHNEtX81i9TmEkrnBc1g8Keepi2lHw.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/sairacondensed/v11/EJRLQgErUN8XuHNEtX81i9TmEkrnIcxg8Keepi2lHw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Saira Extra Condensed\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/sairaextracondensed/v11/-nFsOHYr-vcC7h8MklGBkrvmUG9rbpkisrTri0jx9i5ss3a3.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/sairaextracondensed/v11/-nFvOHYr-vcC7h8MklGBkrvmUG9rbpkisrTrJ2nR3ABgum-uoQ.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/sairaextracondensed/v11/-nFvOHYr-vcC7h8MklGBkrvmUG9rbpkisrTrQ2rR3ABgum-uoQ.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sairaextracondensed/v11/-nFiOHYr-vcC7h8MklGBkrvmUG9rbpkisrTT70L11Ct8sw.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/sairaextracondensed/v11/-nFvOHYr-vcC7h8MklGBkrvmUG9rbpkisrTrG2vR3ABgum-uoQ.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/sairaextracondensed/v11/-nFvOHYr-vcC7h8MklGBkrvmUG9rbpkisrTrN2zR3ABgum-uoQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/sairaextracondensed/v11/-nFvOHYr-vcC7h8MklGBkrvmUG9rbpkisrTrU23R3ABgum-uoQ.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/sairaextracondensed/v11/-nFvOHYr-vcC7h8MklGBkrvmUG9rbpkisrTrT27R3ABgum-uoQ.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/sairaextracondensed/v11/-nFvOHYr-vcC7h8MklGBkrvmUG9rbpkisrTra2_R3ABgum-uoQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Saira Semi Condensed\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/sairasemicondensed/v11/U9MN6c-2-nnJkHxyCjRcnMHcWVWV1cWRRXdvaOM8rXT-8V8.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/sairasemicondensed/v11/U9MM6c-2-nnJkHxyCjRcnMHcWVWV1cWRRXfDScMWg3j36Ebz.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/sairasemicondensed/v11/U9MM6c-2-nnJkHxyCjRcnMHcWVWV1cWRRXenSsMWg3j36Ebz.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sairasemicondensed/v11/U9MD6c-2-nnJkHxyCjRcnMHcWVWV1cWRRU8LYuceqGT-.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/sairasemicondensed/v11/U9MM6c-2-nnJkHxyCjRcnMHcWVWV1cWRRXf_S8MWg3j36Ebz.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/sairasemicondensed/v11/U9MM6c-2-nnJkHxyCjRcnMHcWVWV1cWRRXfTTMMWg3j36Ebz.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/sairasemicondensed/v11/U9MM6c-2-nnJkHxyCjRcnMHcWVWV1cWRRXe3TcMWg3j36Ebz.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/sairasemicondensed/v11/U9MM6c-2-nnJkHxyCjRcnMHcWVWV1cWRRXerTsMWg3j36Ebz.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/sairasemicondensed/v11/U9MM6c-2-nnJkHxyCjRcnMHcWVWV1cWRRXePT8MWg3j36Ebz.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Saira Stencil One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sairastencilone/v14/SLXSc03I6HkvZGJ1GvvipLoYSTEL9AsMawif2YQ2.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Salsa\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/salsa/v17/gNMKW3FiRpKj-imY8ncKEZez.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sanchez\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sanchez/v13/Ycm2sZJORluHnXbITm5b_BwE1l0.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/sanchez/v13/Ycm0sZJORluHnXbIfmxR-D4Bxl3gkw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sancreek\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v23\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sancreek/v23/pxiHypAnsdxUm159X7D-XV9NEe-K.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sansita\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sansita/v10/QldONTRRphEb_-V7HBm7TXFf3qw.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/sansita/v10/QldMNTRRphEb_-V7LBuxSVNazqx2xg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/sansita/v10/QldLNTRRphEb_-V7JKWUaXl0wqVv3_g.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/sansita/v10/QldJNTRRphEb_-V7LBuJ9Xx-xodqz_joDQ.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/sansita/v10/QldLNTRRphEb_-V7JLmXaXl0wqVv3_g.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/sansita/v10/QldJNTRRphEb_-V7LBuJ6X9-xodqz_joDQ.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/sansita/v10/QldLNTRRphEb_-V7JJ2WaXl0wqVv3_g.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/sansita/v10/QldJNTRRphEb_-V7LBuJzX5-xodqz_joDQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sansita Swashed\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/sansitaswashed/v17/BXR8vFfZifTZgFlDDLgNkBydPKTt3pVCeYWqJnZSW-ppbToVehmEa4Q.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sansitaswashed/v17/BXR8vFfZifTZgFlDDLgNkBydPKTt3pVCeYWqJnZSW7RpbToVehmEa4Q.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/sansitaswashed/v17/BXR8vFfZifTZgFlDDLgNkBydPKTt3pVCeYWqJnZSW4ZpbToVehmEa4Q.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/sansitaswashed/v17/BXR8vFfZifTZgFlDDLgNkBydPKTt3pVCeYWqJnZSW2pubToVehmEa4Q.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/sansitaswashed/v17/BXR8vFfZifTZgFlDDLgNkBydPKTt3pVCeYWqJnZSW1NubToVehmEa4Q.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/sansitaswashed/v17/BXR8vFfZifTZgFlDDLgNkBydPKTt3pVCeYWqJnZSWzRubToVehmEa4Q.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/sansitaswashed/v17/BXR8vFfZifTZgFlDDLgNkBydPKTt3pVCeYWqJnZSWx1ubToVehmEa4Q.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sarabun\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800\",\n\t\t\t\t\"800italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"thai\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/sarabun/v13/DtVhJx26TKEr37c9YHZJmnYI5gnOpg.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/sarabun/v13/DtVnJx26TKEr37c9aBBx_nwMxAzephhN.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/sarabun/v13/DtVmJx26TKEr37c9YNpoulwm6gDXvwE.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/sarabun/v13/DtVkJx26TKEr37c9aBBxUl0s7iLSrwFUlw.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/sarabun/v13/DtVmJx26TKEr37c9YL5rulwm6gDXvwE.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/sarabun/v13/DtVkJx26TKEr37c9aBBxNl4s7iLSrwFUlw.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sarabun/v13/DtVjJx26TKEr37c9WBJDnlQN9gk.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/sarabun/v13/DtVhJx26TKEr37c9aBBJmnYI5gnOpg.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/sarabun/v13/DtVmJx26TKEr37c9YOZqulwm6gDXvwE.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/sarabun/v13/DtVkJx26TKEr37c9aBBxbl8s7iLSrwFUlw.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/sarabun/v13/DtVmJx26TKEr37c9YMptulwm6gDXvwE.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/sarabun/v13/DtVkJx26TKEr37c9aBBxQlgs7iLSrwFUlw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/sarabun/v13/DtVmJx26TKEr37c9YK5sulwm6gDXvwE.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/sarabun/v13/DtVkJx26TKEr37c9aBBxJlks7iLSrwFUlw.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/sarabun/v13/DtVmJx26TKEr37c9YLJvulwm6gDXvwE.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/sarabun/v13/DtVkJx26TKEr37c9aBBxOlos7iLSrwFUlw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sarala\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sarala/v10/uK_y4riEZv4o1w9RCh0TMv6EXw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/sarala/v10/uK_x4riEZv4o1w9ptjI3OtWYVkMpXA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sarina\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sarina/v21/-F6wfjF3ITQwasLhLkDUriBQxw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sarpanch\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sarpanch/v11/hESy6Xt4NCpRuk6Pzh2ARIrX_20n.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/sarpanch/v11/hES16Xt4NCpRuk6PziV0ba7f1HEuRHkM.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/sarpanch/v11/hES16Xt4NCpRuk6PziVYaq7f1HEuRHkM.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/sarpanch/v11/hES16Xt4NCpRuk6PziU8a67f1HEuRHkM.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/sarpanch/v11/hES16Xt4NCpRuk6PziUgaK7f1HEuRHkM.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/sarpanch/v11/hES16Xt4NCpRuk6PziUEaa7f1HEuRHkM.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sassy Frass\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v5\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sassyfrass/v5/LhWhMVrGOe0FLb97BjhsE99dGNWQg_am.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Satisfy\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/satisfy/v17/rP2Hp2yn6lkG50LoOZSCHBeHFl0.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sawarabi Gothic\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sawarabigothic/v12/x3d4ckfVaqqa-BEj-I9mE65u3k3NBSk3E2YljQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sawarabi Mincho\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sawarabimincho/v17/8QIRdiDaitzr7brc8ahpxt6GcIJTLahP46UDUw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Scada\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/scada/v14/RLpxK5Pv5qumeWJoxzUobkvv.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/scada/v14/RLp_K5Pv5qumeVJqzTEKa1vvffg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/scada/v14/RLp8K5Pv5qumeVrU6BEgRVfmZOE5.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/scada/v14/RLp6K5Pv5qumeVJq9Y0lT1PEYfE5p6g.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Scheherazade New\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/scheherazadenew/v14/4UaZrFhTvxVnHDvUkUiHg8jprP4DCwNsOl4p5Is.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/scheherazadenew/v14/4UaerFhTvxVnHDvUkUiHg8jprP4DM79DHlYC-IKnoSE.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Schoolbell\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/schoolbell/v18/92zQtBZWOrcgoe-fgnJIVxIQ6mRqfiQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Scope One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/scopeone/v14/WBLnrEXKYFlGHrOKmGD1W0_MJMGxiQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Seaweed Script\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/seaweedscript/v13/bx6cNx6Tne2pxOATYE8C_Rsoe0WJ-KcGVbLW.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Secular One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/secularone/v11/8QINdiTajsj_87rMuMdKypDlMul7LJpK.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sedgwick Ave\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sedgwickave/v12/uK_04rKEYuguzAcSYRdWTJq8Xmg1Vcf5JA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sedgwick Ave Display\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sedgwickavedisplay/v19/xfuu0XPgU3jZPUoUo3ScvmPi-NapQ8OxM2czd-YnOzUD.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sen\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v7\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sen/v7/6xKjdSxYI9_Hm_-MImrpLQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/sen/v7/6xKudSxYI9__J9CoKkH1JHUQSQ.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/sen/v7/6xKudSxYI9__O9OoKkH1JHUQSQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Send Flowers\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v2\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sendflowers/v2/If2PXTjtZS-0Xqy13uCQSULvxwjjouU1iw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sevillana\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-04-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sevillana/v21/KFOlCnWFscmDt1Bfiy1vAx05IsDqlA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Seymour One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/seymourone/v20/4iCp6Khla9xbjQpoWGGd0myIPYBvgpUI.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Shadows Into Light\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/shadowsintolight/v15/UqyNK9UOIntux_czAvDQx_ZcHqZXBNQDcsr4xzSMYA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Shadows Into Light Two\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/shadowsintolighttwo/v13/4iC86LVlZsRSjQhpWGedwyOoW-0A6_kpsyNmlAvNGLNnIF0.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Shalimar\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v5\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/shalimar/v5/uU9MCBoE6I6iNWFUvTPx8PCOg0uX.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Shanti\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v23\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/shanti/v23/t5thIREMM4uSDgzgU0ezpKfwzA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Share\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/share/v16/i7dEIFliZjKNF5VNHLq2cV5d.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/share/v16/i7dKIFliZjKNF6VPFr6UdE5dWFM.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/share/v16/i7dJIFliZjKNF63xM56-WkJUQUq7.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/share/v16/i7dPIFliZjKNF6VPLgK7UEZ2RFq7AwU.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Share Tech\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sharetech/v17/7cHtv4Uyi5K0OeZ7bohUwHoDmTcibrA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Share Tech Mono\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sharetechmono/v15/J7aHnp1uDWRBEqV98dVQztYldFc7pAsEIc3Xew.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"monospace\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Shippori Antique\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v8\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/shipporiantique/v8/-F6qfid3KC8pdMyzR0qRyFUht11v8ldPg-IUDNg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Shippori Antique B1\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v8\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/shipporiantiqueb1/v8/2Eb7L_JwClR7Zl_UAKZ0mUHw3oMKd40grRFCj9-5Y8Y.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Shippori Mincho\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/shipporimincho/v14/VdGGAZweH5EbgHY6YExcZfDoj0BA2_-C7LoS7g.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/shipporimincho/v14/VdGDAZweH5EbgHY6YExcZfDoj0B4L9am5JEO5--2zg.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/shipporimincho/v14/VdGDAZweH5EbgHY6YExcZfDoj0B4A9Gm5JEO5--2zg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/shipporimincho/v14/VdGDAZweH5EbgHY6YExcZfDoj0B4Z9Cm5JEO5--2zg.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/shipporimincho/v14/VdGDAZweH5EbgHY6YExcZfDoj0B4e9Om5JEO5--2zg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Shippori Mincho B1\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/shipporiminchob1/v19/~ChQKElNoaXBwb3JpIE1pbmNobyBCMSAAKgQIARgB.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/shipporiminchob1/v19/~ChcKElNoaXBwb3JpIE1pbmNobyBCMRj0AyAAKgQIARgB.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/shipporiminchob1/v19/~ChcKElNoaXBwb3JpIE1pbmNobyBCMRjYBCAAKgQIARgB.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/shipporiminchob1/v19/~ChcKElNoaXBwb3JpIE1pbmNobyBCMRi8BSAAKgQIARgB.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/shipporiminchob1/v19/~ChcKElNoaXBwb3JpIE1pbmNobyBCMRigBiAAKgQIARgB.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Shojumaru\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/shojumaru/v15/rax_HiWfutkLLnaKCtlMBBJek0vA8A.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Short Stack\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/shortstack/v15/bMrzmS2X6p0jZC6EcmPFX-SScX8D0nq6.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Shrikhand\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"gujarati\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/shrikhand/v11/a8IbNovtLWfR7T7bMJwbBIiQ0zhMtA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Siemreap\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"khmer\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/siemreap/v24/Gg82N5oFbgLvHAfNl2YbnA8DLXpe.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sigmar One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sigmarone/v16/co3DmWZ8kjZuErj9Ta3dk6Pjp3Di8U0.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Signika\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/signika/v20/vEFO2_JTCgwQ5ejvMV0O96D01E8J0tIJHJbGhs_cfKe1.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/signika/v20/vEFO2_JTCgwQ5ejvMV0O96D01E8J0tJXHJbGhs_cfKe1.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/signika/v20/vEFO2_JTCgwQ5ejvMV0O96D01E8J0tJlHJbGhs_cfKe1.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/signika/v20/vEFO2_JTCgwQ5ejvMV0O96D01E8J0tKJG5bGhs_cfKe1.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/signika/v20/vEFO2_JTCgwQ5ejvMV0O96D01E8J0tKwG5bGhs_cfKe1.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Signika Negative\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/signikanegative/v20/E21x_cfngu7HiRpPX3ZpNE4kY5zKSPmJXkF0VDD2RAr5S73st9hiuEq8.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/signikanegative/v20/E21x_cfngu7HiRpPX3ZpNE4kY5zKSPmJXkF0VDD2RAqnS73st9hiuEq8.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/signikanegative/v20/E21x_cfngu7HiRpPX3ZpNE4kY5zKSPmJXkF0VDD2RAqVS73st9hiuEq8.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/signikanegative/v20/E21x_cfngu7HiRpPX3ZpNE4kY5zKSPmJXkF0VDD2RAp5TL3st9hiuEq8.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/signikanegative/v20/E21x_cfngu7HiRpPX3ZpNE4kY5zKSPmJXkF0VDD2RApATL3st9hiuEq8.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Silkscreen\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/silkscreen/v1/m8JXjfVPf62XiF7kO-i9ULRvamODxdI.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/silkscreen/v1/m8JUjfVPf62XiF7kO-i9aAhATmuo2dudFvc.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Simonetta\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"900\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v23\",\n\t\t\t\"lastModified\": \"2022-04-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/simonetta/v23/x3dickHVYrCU5BU15c4BfPACvy_1BA.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/simonetta/v23/x3dkckHVYrCU5BU15c4xfvoGnSrlBBsy.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/simonetta/v23/x3dnckHVYrCU5BU15c45-N0mtwTpDQIrGg.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/simonetta/v23/x3d5ckHVYrCU5BU15c4xfsKCsA7tLwc7Gn88.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Single Day\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"korean\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/singleday/v15/LYjHdGDjlEgoAcF95EI5jVoFUNfeQJU.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sintony\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sintony/v13/XoHm2YDqR7-98cVUITQnu98ojjs.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/sintony/v13/XoHj2YDqR7-98cVUGYgIn9cDkjLp6C8.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sirin Stencil\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-04-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sirinstencil/v21/mem4YaWwznmLx-lzGfN7MdRydchGBq6al6o.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Six Caps\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sixcaps/v16/6ae_4KGrU7VR7bNmabcS9XXaPCop.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Skranji\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/skranji/v13/OZpDg_dtriVFNerMYzuuklTm3Ek.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/skranji/v13/OZpGg_dtriVFNerMW4eBtlzNwED-b4g.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Slabo 13px\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/slabo13px/v13/11hEGp_azEvXZUdSBzzRcKer2wkYnvI.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Slabo 27px\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/slabo27px/v12/mFT0WbgBwKPR_Z4hGN2qsxgJ1EJ7i90.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Slackey\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/slackey/v24/N0bV2SdQO-5yM0-dKlRaJdbWgdY.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Smokum\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/smokum/v24/TK3iWkUbAhopmrdGHjUHte5fKg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Smooch\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v5\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/smooch/v5/o-0LIps4xW8U1xUBjqp_6hVdYg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Smooch Sans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v6\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/smoochsans/v6/c4mz1n5uGsXss2LJh1QH6b129FZvxPj6I4oiwUFodqIeNlzayg.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/smoochsans/v6/c4mz1n5uGsXss2LJh1QH6b129FZvxPj6I4oiQUBodqIeNlzayg.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/smoochsans/v6/c4mz1n5uGsXss2LJh1QH6b129FZvxPj6I4oin0BodqIeNlzayg.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/smoochsans/v6/c4mz1n5uGsXss2LJh1QH6b129FZvxPj6I4oiwUBodqIeNlzayg.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/smoochsans/v6/c4mz1n5uGsXss2LJh1QH6b129FZvxPj6I4oi80BodqIeNlzayg.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/smoochsans/v6/c4mz1n5uGsXss2LJh1QH6b129FZvxPj6I4oiH0dodqIeNlzayg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/smoochsans/v6/c4mz1n5uGsXss2LJh1QH6b129FZvxPj6I4oiJkdodqIeNlzayg.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/smoochsans/v6/c4mz1n5uGsXss2LJh1QH6b129FZvxPj6I4oiQUdodqIeNlzayg.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/smoochsans/v6/c4mz1n5uGsXss2LJh1QH6b129FZvxPj6I4oiaEdodqIeNlzayg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Smythe\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v23\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/smythe/v23/MwQ3bhT01--coT1BOLh_uGInjA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sniglet\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sniglet/v17/cIf9MaFLtkE3UjaJxCmrYGkHgIs.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/sniglet/v17/cIf4MaFLtkE3UjaJ_ImHRGEsnIJkWL4.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Snippet\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/snippet/v21/bWt47f7XfQH9Gupu2v_Afcp9QWc.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Snowburst One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/snowburstone/v20/MQpS-WezKdujBsXY3B7I-UT7eZ-UPyacPbo.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sofadi One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sofadione/v21/JIA2UVBxdnVBuElZaMFGcDOIETkmYDU.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sofia\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sofia/v14/8QIHdirahM3j_vu-sowsrqjk.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sofia Sans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/sofiasans/v10/Yq6E-LCVXSLy9uPBwlAThu1SY8Cx8rlT69B6sa3trvKCXl8k.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/sofiasans/v10/Yq6E-LCVXSLy9uPBwlAThu1SY8Cx8rlT69D6sK3trvKCXl8k.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/sofiasans/v10/Yq6E-LCVXSLy9uPBwlAThu1SY8Cx8rlT69AksK3trvKCXl8k.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sofiasans/v10/Yq6E-LCVXSLy9uPBwlAThu1SY8Cx8rlT69B6sK3trvKCXl8k.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/sofiasans/v10/Yq6E-LCVXSLy9uPBwlAThu1SY8Cx8rlT69BIsK3trvKCXl8k.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/sofiasans/v10/Yq6E-LCVXSLy9uPBwlAThu1SY8Cx8rlT69Ckt63trvKCXl8k.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/sofiasans/v10/Yq6E-LCVXSLy9uPBwlAThu1SY8Cx8rlT69Cdt63trvKCXl8k.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/sofiasans/v10/Yq6E-LCVXSLy9uPBwlAThu1SY8Cx8rlT69D6t63trvKCXl8k.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/sofiasans/v10/Yq6E-LCVXSLy9uPBwlAThu1SY8Cx8rlT69DTt63trvKCXl8k.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/sofiasans/v10/Yq6G-LCVXSLy9uPBwlATrORgnBjYmSP97MWy80WvpPagW08kdLY.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/sofiasans/v10/Yq6G-LCVXSLy9uPBwlATrORgnBjYmSP97MWy88WupPagW08kdLY.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/sofiasans/v10/Yq6G-LCVXSLy9uPBwlATrORgnBjYmSP97MWy8xuupPagW08kdLY.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/sofiasans/v10/Yq6G-LCVXSLy9uPBwlATrORgnBjYmSP97MWy80WupPagW08kdLY.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/sofiasans/v10/Yq6G-LCVXSLy9uPBwlATrORgnBjYmSP97MWy83eupPagW08kdLY.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/sofiasans/v10/Yq6G-LCVXSLy9uPBwlATrORgnBjYmSP97MWy85uppPagW08kdLY.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/sofiasans/v10/Yq6G-LCVXSLy9uPBwlATrORgnBjYmSP97MWy86KppPagW08kdLY.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/sofiasans/v10/Yq6G-LCVXSLy9uPBwlATrORgnBjYmSP97MWy88WppPagW08kdLY.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/sofiasans/v10/Yq6G-LCVXSLy9uPBwlATrORgnBjYmSP97MWy8-yppPagW08kdLY.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sofia Sans Condensed\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/sofiasanscondensed/v1/r05xGKVS5aVKd567NYXawnFKJaTtoAuLnK0EjiAN5s9CZwUqh-Csl8QO3OfwQQ.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/sofiasanscondensed/v1/r05xGKVS5aVKd567NYXawnFKJaTtoAuLnK0EjiAN5s9CZwUqB-Gsl8QO3OfwQQ.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/sofiasanscondensed/v1/r05xGKVS5aVKd567NYXawnFKJaTtoAuLnK0EjiAN5s9CZwUq2eGsl8QO3OfwQQ.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sofiasanscondensed/v1/r05xGKVS5aVKd567NYXawnFKJaTtoAuLnK0EjiAN5s9CZwUqh-Gsl8QO3OfwQQ.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/sofiasanscondensed/v1/r05xGKVS5aVKd567NYXawnFKJaTtoAuLnK0EjiAN5s9CZwUqteGsl8QO3OfwQQ.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/sofiasanscondensed/v1/r05xGKVS5aVKd567NYXawnFKJaTtoAuLnK0EjiAN5s9CZwUqWeasl8QO3OfwQQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/sofiasanscondensed/v1/r05xGKVS5aVKd567NYXawnFKJaTtoAuLnK0EjiAN5s9CZwUqYOasl8QO3OfwQQ.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/sofiasanscondensed/v1/r05xGKVS5aVKd567NYXawnFKJaTtoAuLnK0EjiAN5s9CZwUqB-asl8QO3OfwQQ.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/sofiasanscondensed/v1/r05xGKVS5aVKd567NYXawnFKJaTtoAuLnK0EjiAN5s9CZwUqLuasl8QO3OfwQQ.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/sofiasanscondensed/v1/r053GKVS5aVKd567NYXawnFKJaTtoAuLnIcNvN_Vj6TYyQI_T6JE1c4K_uLgQZ_3.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/sofiasanscondensed/v1/r053GKVS5aVKd567NYXawnFKJaTtoAuLnIcNvN_Vj6TYyQI_T6LE1M4K_uLgQZ_3.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/sofiasanscondensed/v1/r053GKVS5aVKd567NYXawnFKJaTtoAuLnIcNvN_Vj6TYyQI_T6Ia1M4K_uLgQZ_3.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/sofiasanscondensed/v1/r053GKVS5aVKd567NYXawnFKJaTtoAuLnIcNvN_Vj6TYyQI_T6JE1M4K_uLgQZ_3.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/sofiasanscondensed/v1/r053GKVS5aVKd567NYXawnFKJaTtoAuLnIcNvN_Vj6TYyQI_T6J21M4K_uLgQZ_3.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/sofiasanscondensed/v1/r053GKVS5aVKd567NYXawnFKJaTtoAuLnIcNvN_Vj6TYyQI_T6Ka084K_uLgQZ_3.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/sofiasanscondensed/v1/r053GKVS5aVKd567NYXawnFKJaTtoAuLnIcNvN_Vj6TYyQI_T6Kj084K_uLgQZ_3.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/sofiasanscondensed/v1/r053GKVS5aVKd567NYXawnFKJaTtoAuLnIcNvN_Vj6TYyQI_T6LE084K_uLgQZ_3.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/sofiasanscondensed/v1/r053GKVS5aVKd567NYXawnFKJaTtoAuLnIcNvN_Vj6TYyQI_T6Lt084K_uLgQZ_3.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sofia Sans Extra Condensed\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/sofiasansextracondensed/v1/raxdHjafvdAIOju4GcIfJH0i7zi50X3zRtuLNiMS0d6iDr-MD5Si9NGLmmmEfzmM356GxA.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/sofiasansextracondensed/v1/raxdHjafvdAIOju4GcIfJH0i7zi50X3zRtuLNiMS0d6iDr-MD5Si9NGLGmiEfzmM356GxA.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/sofiasansextracondensed/v1/raxdHjafvdAIOju4GcIfJH0i7zi50X3zRtuLNiMS0d6iDr-MD5Si9NGLxGiEfzmM356GxA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sofiasansextracondensed/v1/raxdHjafvdAIOju4GcIfJH0i7zi50X3zRtuLNiMS0d6iDr-MD5Si9NGLmmiEfzmM356GxA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/sofiasansextracondensed/v1/raxdHjafvdAIOju4GcIfJH0i7zi50X3zRtuLNiMS0d6iDr-MD5Si9NGLqGiEfzmM356GxA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/sofiasansextracondensed/v1/raxdHjafvdAIOju4GcIfJH0i7zi50X3zRtuLNiMS0d6iDr-MD5Si9NGLRG-EfzmM356GxA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/sofiasansextracondensed/v1/raxdHjafvdAIOju4GcIfJH0i7zi50X3zRtuLNiMS0d6iDr-MD5Si9NGLfW-EfzmM356GxA.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/sofiasansextracondensed/v1/raxdHjafvdAIOju4GcIfJH0i7zi50X3zRtuLNiMS0d6iDr-MD5Si9NGLGm-EfzmM356GxA.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/sofiasansextracondensed/v1/raxdHjafvdAIOju4GcIfJH0i7zi50X3zRtuLNiMS0d6iDr-MD5Si9NGLM2-EfzmM356GxA.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/sofiasansextracondensed/v1/raxfHjafvdAIOju4GcIfJH0i7zi50X3zRtuLNiMS0fSrPEBUZv84WtaeUitsPTOI_ZuWxFXe.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/sofiasansextracondensed/v1/raxfHjafvdAIOju4GcIfJH0i7zi50X3zRtuLNiMS0fSrPEBUZv84WtaeUivsPDOI_ZuWxFXe.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/sofiasansextracondensed/v1/raxfHjafvdAIOju4GcIfJH0i7zi50X3zRtuLNiMS0fSrPEBUZv84WtaeUisyPDOI_ZuWxFXe.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/sofiasansextracondensed/v1/raxfHjafvdAIOju4GcIfJH0i7zi50X3zRtuLNiMS0fSrPEBUZv84WtaeUitsPDOI_ZuWxFXe.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/sofiasansextracondensed/v1/raxfHjafvdAIOju4GcIfJH0i7zi50X3zRtuLNiMS0fSrPEBUZv84WtaeUitePDOI_ZuWxFXe.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/sofiasansextracondensed/v1/raxfHjafvdAIOju4GcIfJH0i7zi50X3zRtuLNiMS0fSrPEBUZv84WtaeUiuyOzOI_ZuWxFXe.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/sofiasansextracondensed/v1/raxfHjafvdAIOju4GcIfJH0i7zi50X3zRtuLNiMS0fSrPEBUZv84WtaeUiuLOzOI_ZuWxFXe.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/sofiasansextracondensed/v1/raxfHjafvdAIOju4GcIfJH0i7zi50X3zRtuLNiMS0fSrPEBUZv84WtaeUivsOzOI_ZuWxFXe.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/sofiasansextracondensed/v1/raxfHjafvdAIOju4GcIfJH0i7zi50X3zRtuLNiMS0fSrPEBUZv84WtaeUivFOzOI_ZuWxFXe.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sofia Sans Semi Condensed\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/sofiasanssemicondensed/v1/46kOlaPnUDrQoNsWDCGXXxYlujh5Wv0nwP4RwxURm28cA7YLHsIVvoobEO9TGahllIhN.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/sofiasanssemicondensed/v1/46kOlaPnUDrQoNsWDCGXXxYlujh5Wv0nwP4RwxURm28cA7YLHsIVvoqbEe9TGahllIhN.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/sofiasanssemicondensed/v1/46kOlaPnUDrQoNsWDCGXXxYlujh5Wv0nwP4RwxURm28cA7YLHsIVvopFEe9TGahllIhN.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sofiasanssemicondensed/v1/46kOlaPnUDrQoNsWDCGXXxYlujh5Wv0nwP4RwxURm28cA7YLHsIVvoobEe9TGahllIhN.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/sofiasanssemicondensed/v1/46kOlaPnUDrQoNsWDCGXXxYlujh5Wv0nwP4RwxURm28cA7YLHsIVvoopEe9TGahllIhN.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/sofiasanssemicondensed/v1/46kOlaPnUDrQoNsWDCGXXxYlujh5Wv0nwP4RwxURm28cA7YLHsIVvorFFu9TGahllIhN.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/sofiasanssemicondensed/v1/46kOlaPnUDrQoNsWDCGXXxYlujh5Wv0nwP4RwxURm28cA7YLHsIVvor8Fu9TGahllIhN.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/sofiasanssemicondensed/v1/46kOlaPnUDrQoNsWDCGXXxYlujh5Wv0nwP4RwxURm28cA7YLHsIVvoqbFu9TGahllIhN.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/sofiasanssemicondensed/v1/46kOlaPnUDrQoNsWDCGXXxYlujh5Wv0nwP4RwxURm28cA7YLHsIVvoqyFu9TGahllIhN.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/sofiasanssemicondensed/v1/46kMlaPnUDrQoNsWDCGXXxYlujh5Wv0nwP4RwxURsWYu_G5idVi7uZ_TUgcRE6xHkZhNeas.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/sofiasanssemicondensed/v1/46kMlaPnUDrQoNsWDCGXXxYlujh5Wv0nwP4RwxURsWYu_G5idVi7uZ_TUocQE6xHkZhNeas.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/sofiasanssemicondensed/v1/46kMlaPnUDrQoNsWDCGXXxYlujh5Wv0nwP4RwxURsWYu_G5idVi7uZ_TUlkQE6xHkZhNeas.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/sofiasanssemicondensed/v1/46kMlaPnUDrQoNsWDCGXXxYlujh5Wv0nwP4RwxURsWYu_G5idVi7uZ_TUgcQE6xHkZhNeas.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/sofiasanssemicondensed/v1/46kMlaPnUDrQoNsWDCGXXxYlujh5Wv0nwP4RwxURsWYu_G5idVi7uZ_TUjUQE6xHkZhNeas.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/sofiasanssemicondensed/v1/46kMlaPnUDrQoNsWDCGXXxYlujh5Wv0nwP4RwxURsWYu_G5idVi7uZ_TUtkXE6xHkZhNeas.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/sofiasanssemicondensed/v1/46kMlaPnUDrQoNsWDCGXXxYlujh5Wv0nwP4RwxURsWYu_G5idVi7uZ_TUuAXE6xHkZhNeas.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/sofiasanssemicondensed/v1/46kMlaPnUDrQoNsWDCGXXxYlujh5Wv0nwP4RwxURsWYu_G5idVi7uZ_TUocXE6xHkZhNeas.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/sofiasanssemicondensed/v1/46kMlaPnUDrQoNsWDCGXXxYlujh5Wv0nwP4RwxURsWYu_G5idVi7uZ_TUq4XE6xHkZhNeas.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Solitreo\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2023-01-18\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/solitreo/v1/r05YGLlS5a9KYsyNO8upyDYtStiJ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Solway\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/solway/v17/AMOTz46Cs2uTAOCuLlgZms0QW3mqyg.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/solway/v17/AMOQz46Cs2uTAOCWgnA9kuYMUg.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/solway/v17/AMOTz46Cs2uTAOCudlkZms0QW3mqyg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/solway/v17/AMOTz46Cs2uTAOCuPl8Zms0QW3mqyg.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/solway/v17/AMOTz46Cs2uTAOCuIlwZms0QW3mqyg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Song Myung\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"korean\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/songmyung/v20/1cX2aUDWAJH5-EIC7DIhr1GqhcitzeM.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sono\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/sono/v1/aFT97PNiY3U2Cqf_aYEN64CYaK18YWJEsV6u-QLiOsxVNkWdEnR4qYeB4Q.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/sono/v1/aFT97PNiY3U2Cqf_aYEN64CYaK18YWJEsV6u-QLiOsxV6EWdEnR4qYeB4Q.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sono/v1/aFT97PNiY3U2Cqf_aYEN64CYaK18YWJEsV6u-QLiOsxVtkWdEnR4qYeB4Q.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/sono/v1/aFT97PNiY3U2Cqf_aYEN64CYaK18YWJEsV6u-QLiOsxVhEWdEnR4qYeB4Q.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/sono/v1/aFT97PNiY3U2Cqf_aYEN64CYaK18YWJEsV6u-QLiOsxVaEKdEnR4qYeB4Q.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/sono/v1/aFT97PNiY3U2Cqf_aYEN64CYaK18YWJEsV6u-QLiOsxVUUKdEnR4qYeB4Q.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/sono/v1/aFT97PNiY3U2Cqf_aYEN64CYaK18YWJEsV6u-QLiOsxVNkKdEnR4qYeB4Q.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sonsie One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sonsieone/v21/PbymFmP_EAnPqbKaoc18YVu80lbp8JM.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sora\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/sora/v11/xMQOuFFYT72X5wkB_18qmnndmSdSn3-KIwNhBti0.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/sora/v11/xMQOuFFYT72X5wkB_18qmnndmSfSnn-KIwNhBti0.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/sora/v11/xMQOuFFYT72X5wkB_18qmnndmScMnn-KIwNhBti0.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sora/v11/xMQOuFFYT72X5wkB_18qmnndmSdSnn-KIwNhBti0.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/sora/v11/xMQOuFFYT72X5wkB_18qmnndmSdgnn-KIwNhBti0.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/sora/v11/xMQOuFFYT72X5wkB_18qmnndmSeMmX-KIwNhBti0.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/sora/v11/xMQOuFFYT72X5wkB_18qmnndmSe1mX-KIwNhBti0.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/sora/v11/xMQOuFFYT72X5wkB_18qmnndmSfSmX-KIwNhBti0.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sorts Mill Goudy\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sortsmillgoudy/v15/Qw3GZR9MED_6PSuS_50nEaVrfzgEXH0OjpM75PE.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/sortsmillgoudy/v15/Qw3AZR9MED_6PSuS_50nEaVrfzgEbH8EirE-9PGLfQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Source Code Pro\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/sourcecodepro/v22/HI_diYsKILxRpg3hIP6sJ7fM7PqPMcMnZFqUwX28DEyQhM5hTXUcdJg.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/sourcecodepro/v22/HI_diYsKILxRpg3hIP6sJ7fM7PqPMcMnZFqUwX28DJKQhM5hTXUcdJg.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sourcecodepro/v22/HI_diYsKILxRpg3hIP6sJ7fM7PqPMcMnZFqUwX28DMyQhM5hTXUcdJg.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/sourcecodepro/v22/HI_diYsKILxRpg3hIP6sJ7fM7PqPMcMnZFqUwX28DP6QhM5hTXUcdJg.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/sourcecodepro/v22/HI_diYsKILxRpg3hIP6sJ7fM7PqPMcMnZFqUwX28DBKXhM5hTXUcdJg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/sourcecodepro/v22/HI_diYsKILxRpg3hIP6sJ7fM7PqPMcMnZFqUwX28DCuXhM5hTXUcdJg.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/sourcecodepro/v22/HI_diYsKILxRpg3hIP6sJ7fM7PqPMcMnZFqUwX28DEyXhM5hTXUcdJg.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/sourcecodepro/v22/HI_diYsKILxRpg3hIP6sJ7fM7PqPMcMnZFqUwX28DGWXhM5hTXUcdJg.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/sourcecodepro/v22/HI_jiYsKILxRpg3hIP6sJ7fM7PqlOPHYvDP_W9O7GQTT7I1rSVcZZJiGpw.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/sourcecodepro/v22/HI_jiYsKILxRpg3hIP6sJ7fM7PqlOPHYvDP_W9O7GQTTMo1rSVcZZJiGpw.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/sourcecodepro/v22/HI_jiYsKILxRpg3hIP6sJ7fM7PqlOPHYvDP_W9O7GQTTbI1rSVcZZJiGpw.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/sourcecodepro/v22/HI_jiYsKILxRpg3hIP6sJ7fM7PqlOPHYvDP_W9O7GQTTXo1rSVcZZJiGpw.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/sourcecodepro/v22/HI_jiYsKILxRpg3hIP6sJ7fM7PqlOPHYvDP_W9O7GQTTsoprSVcZZJiGpw.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/sourcecodepro/v22/HI_jiYsKILxRpg3hIP6sJ7fM7PqlOPHYvDP_W9O7GQTTi4prSVcZZJiGpw.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/sourcecodepro/v22/HI_jiYsKILxRpg3hIP6sJ7fM7PqlOPHYvDP_W9O7GQTT7IprSVcZZJiGpw.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/sourcecodepro/v22/HI_jiYsKILxRpg3hIP6sJ7fM7PqlOPHYvDP_W9O7GQTTxYprSVcZZJiGpw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"monospace\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Source Sans 3\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v8\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/sourcesans3/v8/nwpBtKy2OAdR1K-IwhWudF-R9QMylBJAV3Bo8Kw461EN_io6npfB.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/sourcesans3/v8/nwpBtKy2OAdR1K-IwhWudF-R9QMylBJAV3Bo8Kzm61EN_io6npfB.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sourcesans3/v8/nwpBtKy2OAdR1K-IwhWudF-R9QMylBJAV3Bo8Ky461EN_io6npfB.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/sourcesans3/v8/nwpBtKy2OAdR1K-IwhWudF-R9QMylBJAV3Bo8KyK61EN_io6npfB.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/sourcesans3/v8/nwpBtKy2OAdR1K-IwhWudF-R9QMylBJAV3Bo8Kxm7FEN_io6npfB.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/sourcesans3/v8/nwpBtKy2OAdR1K-IwhWudF-R9QMylBJAV3Bo8Kxf7FEN_io6npfB.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/sourcesans3/v8/nwpBtKy2OAdR1K-IwhWudF-R9QMylBJAV3Bo8Kw47FEN_io6npfB.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/sourcesans3/v8/nwpBtKy2OAdR1K-IwhWudF-R9QMylBJAV3Bo8KwR7FEN_io6npfB.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/sourcesans3/v8/nwpDtKy2OAdR1K-IwhWudF-R3woAa8opPOrG97lwqDlO9C4Ym4fB3Ts.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/sourcesans3/v8/nwpDtKy2OAdR1K-IwhWudF-R3woAa8opPOrG97lwqOdO9C4Ym4fB3Ts.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/sourcesans3/v8/nwpDtKy2OAdR1K-IwhWudF-R3woAa8opPOrG97lwqLlO9C4Ym4fB3Ts.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/sourcesans3/v8/nwpDtKy2OAdR1K-IwhWudF-R3woAa8opPOrG97lwqItO9C4Ym4fB3Ts.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/sourcesans3/v8/nwpDtKy2OAdR1K-IwhWudF-R3woAa8opPOrG97lwqGdJ9C4Ym4fB3Ts.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/sourcesans3/v8/nwpDtKy2OAdR1K-IwhWudF-R3woAa8opPOrG97lwqF5J9C4Ym4fB3Ts.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/sourcesans3/v8/nwpDtKy2OAdR1K-IwhWudF-R3woAa8opPOrG97lwqDlJ9C4Ym4fB3Ts.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/sourcesans3/v8/nwpDtKy2OAdR1K-IwhWudF-R3woAa8opPOrG97lwqBBJ9C4Ym4fB3Ts.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Source Sans Pro\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"900\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/sourcesanspro/v21/6xKydSBYKcSV-LCoeQqfX1RYOo3i94_AkB1v_8CGxg.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/sourcesanspro/v21/6xKwdSBYKcSV-LCoeQqfX1RYOo3qPZYokRdr3cWWxg40.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/sourcesanspro/v21/6xKydSBYKcSV-LCoeQqfX1RYOo3ik4zAkB1v_8CGxg.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/sourcesanspro/v21/6xKwdSBYKcSV-LCoeQqfX1RYOo3qPZZMkhdr3cWWxg40.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sourcesanspro/v21/6xK3dSBYKcSV-LCoeQqfX1RYOo3aP6TkmDZz9g.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/sourcesanspro/v21/6xK1dSBYKcSV-LCoeQqfX1RYOo3qPa7gujNj9tmf.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/sourcesanspro/v21/6xKydSBYKcSV-LCoeQqfX1RYOo3i54rAkB1v_8CGxg.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/sourcesanspro/v21/6xKwdSBYKcSV-LCoeQqfX1RYOo3qPZY4lBdr3cWWxg40.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/sourcesanspro/v21/6xKydSBYKcSV-LCoeQqfX1RYOo3ig4vAkB1v_8CGxg.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/sourcesanspro/v21/6xKwdSBYKcSV-LCoeQqfX1RYOo3qPZZclRdr3cWWxg40.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/sourcesanspro/v21/6xKydSBYKcSV-LCoeQqfX1RYOo3iu4nAkB1v_8CGxg.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/sourcesanspro/v21/6xKwdSBYKcSV-LCoeQqfX1RYOo3qPZZklxdr3cWWxg40.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Source Serif 4\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v7\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/sourceserif4/v7/vEFy2_tTDB4M7-auWDN0ahZJW3IX2ih5nk3AucvUHf6OAVIJmeUDygwjipdqrhxXD-wGvjU.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/sourceserif4/v7/vEFy2_tTDB4M7-auWDN0ahZJW3IX2ih5nk3AucvUHf6OAVIJmeUDygwjiklqrhxXD-wGvjU.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sourceserif4/v7/vEFy2_tTDB4M7-auWDN0ahZJW3IX2ih5nk3AucvUHf6OAVIJmeUDygwjihdqrhxXD-wGvjU.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/sourceserif4/v7/vEFy2_tTDB4M7-auWDN0ahZJW3IX2ih5nk3AucvUHf6OAVIJmeUDygwjiiVqrhxXD-wGvjU.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/sourceserif4/v7/vEFy2_tTDB4M7-auWDN0ahZJW3IX2ih5nk3AucvUHf6OAVIJmeUDygwjisltrhxXD-wGvjU.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/sourceserif4/v7/vEFy2_tTDB4M7-auWDN0ahZJW3IX2ih5nk3AucvUHf6OAVIJmeUDygwjivBtrhxXD-wGvjU.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/sourceserif4/v7/vEFy2_tTDB4M7-auWDN0ahZJW3IX2ih5nk3AucvUHf6OAVIJmeUDygwjipdtrhxXD-wGvjU.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/sourceserif4/v7/vEFy2_tTDB4M7-auWDN0ahZJW3IX2ih5nk3AucvUHf6OAVIJmeUDygwjir5trhxXD-wGvjU.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/sourceserif4/v7/vEF02_tTDB4M7-auWDN0ahZJW1ge6NmXpVAHV83Bfb_US2D2QYxoUKIkn98pxl9dC84DrjXEXw.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/sourceserif4/v7/vEF02_tTDB4M7-auWDN0ahZJW1ge6NmXpVAHV83Bfb_US2D2QYxoUKIkn98pGF9dC84DrjXEXw.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/sourceserif4/v7/vEF02_tTDB4M7-auWDN0ahZJW1ge6NmXpVAHV83Bfb_US2D2QYxoUKIkn98pRl9dC84DrjXEXw.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/sourceserif4/v7/vEF02_tTDB4M7-auWDN0ahZJW1ge6NmXpVAHV83Bfb_US2D2QYxoUKIkn98pdF9dC84DrjXEXw.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/sourceserif4/v7/vEF02_tTDB4M7-auWDN0ahZJW1ge6NmXpVAHV83Bfb_US2D2QYxoUKIkn98pmFhdC84DrjXEXw.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/sourceserif4/v7/vEF02_tTDB4M7-auWDN0ahZJW1ge6NmXpVAHV83Bfb_US2D2QYxoUKIkn98poVhdC84DrjXEXw.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/sourceserif4/v7/vEF02_tTDB4M7-auWDN0ahZJW1ge6NmXpVAHV83Bfb_US2D2QYxoUKIkn98pxlhdC84DrjXEXw.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/sourceserif4/v7/vEF02_tTDB4M7-auWDN0ahZJW1ge6NmXpVAHV83Bfb_US2D2QYxoUKIkn98p71hdC84DrjXEXw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Source Serif Pro\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"900\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/sourceserifpro/v15/neIXzD-0qpwxpaWvjeD0X88SAOeasbsfhSugxYUvZrI.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/sourceserifpro/v15/neIVzD-0qpwxpaWvjeD0X88SAOeauXEGbSqqwacqdrKvbQ.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/sourceserifpro/v15/neIXzD-0qpwxpaWvjeD0X88SAOeasd8chSugxYUvZrI.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/sourceserifpro/v15/neIVzD-0qpwxpaWvjeD0X88SAOeauXEGCSmqwacqdrKvbQ.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sourceserifpro/v15/neIQzD-0qpwxpaWvjeD0X88SAOeaiXM0oSOL2Yw.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/sourceserifpro/v15/neIWzD-0qpwxpaWvjeD0X88SAOeauXE-pQGOyYw2fw.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/sourceserifpro/v15/neIXzD-0qpwxpaWvjeD0X88SAOeasasahSugxYUvZrI.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/sourceserifpro/v15/neIVzD-0qpwxpaWvjeD0X88SAOeauXEGfS-qwacqdrKvbQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/sourceserifpro/v15/neIXzD-0qpwxpaWvjeD0X88SAOeasc8bhSugxYUvZrI.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/sourceserifpro/v15/neIVzD-0qpwxpaWvjeD0X88SAOeauXEGGS6qwacqdrKvbQ.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/sourceserifpro/v15/neIXzD-0qpwxpaWvjeD0X88SAOeasfcZhSugxYUvZrI.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/sourceserifpro/v15/neIVzD-0qpwxpaWvjeD0X88SAOeauXEGISyqwacqdrKvbQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Space Grotesk\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/spacegrotesk/v15/V8mQoQDjQSkFtoMM3T6r8E7mF71Q-gOoraIAEj62UUsjNsFjTDJK.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/spacegrotesk/v15/V8mQoQDjQSkFtoMM3T6r8E7mF71Q-gOoraIAEj7oUUsjNsFjTDJK.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/spacegrotesk/v15/V8mQoQDjQSkFtoMM3T6r8E7mF71Q-gOoraIAEj7aUUsjNsFjTDJK.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/spacegrotesk/v15/V8mQoQDjQSkFtoMM3T6r8E7mF71Q-gOoraIAEj42VksjNsFjTDJK.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/spacegrotesk/v15/V8mQoQDjQSkFtoMM3T6r8E7mF71Q-gOoraIAEj4PVksjNsFjTDJK.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Space Mono\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/spacemono/v12/i7dPIFZifjKcF5UAWdDRUEZ2RFq7AwU.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/spacemono/v12/i7dNIFZifjKcF5UAWdDRYER8QHi-EwWMbg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/spacemono/v12/i7dMIFZifjKcF5UAWdDRaPpZYFKQHwyVd3U.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/spacemono/v12/i7dSIFZifjKcF5UAWdDRYERE_FeaGy6QZ3WfYg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"monospace\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Special Elite\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/specialelite/v18/XLYgIZbkc4JPUL5CVArUVL0nhncESXFtUsM.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Spectral\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800\",\n\t\t\t\t\"800italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/spectral/v13/rnCs-xNNww_2s0amA9v2s13GY_etWWIJ.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/spectral/v13/rnCu-xNNww_2s0amA9M8qrXHafOPXHIJErY.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/spectral/v13/rnCs-xNNww_2s0amA9uSsF3GY_etWWIJ.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/spectral/v13/rnCu-xNNww_2s0amA9M8qtHEafOPXHIJErY.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/spectral/v13/rnCr-xNNww_2s0amA-M-mHnOSOuk.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/spectral/v13/rnCt-xNNww_2s0amA9M8kn3sTfukQHs.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/spectral/v13/rnCs-xNNww_2s0amA9vKsV3GY_etWWIJ.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/spectral/v13/rnCu-xNNww_2s0amA9M8qonFafOPXHIJErY.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/spectral/v13/rnCs-xNNww_2s0amA9vmtl3GY_etWWIJ.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/spectral/v13/rnCu-xNNww_2s0amA9M8qqXCafOPXHIJErY.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/spectral/v13/rnCs-xNNww_2s0amA9uCt13GY_etWWIJ.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/spectral/v13/rnCu-xNNww_2s0amA9M8qsHDafOPXHIJErY.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/spectral/v13/rnCs-xNNww_2s0amA9uetF3GY_etWWIJ.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/spectral/v13/rnCu-xNNww_2s0amA9M8qt3AafOPXHIJErY.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Spectral SC\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800\",\n\t\t\t\t\"800italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/spectralsc/v11/Ktk0ALCRZonmalTgyPmRfs1qwkTXPYeVXJZB.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/spectralsc/v11/Ktk2ALCRZonmalTgyPmRfsWg26zWN4O3WYZB_sU.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/spectralsc/v11/Ktk0ALCRZonmalTgyPmRfs0OwUTXPYeVXJZB.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/spectralsc/v11/Ktk2ALCRZonmalTgyPmRfsWg28jVN4O3WYZB_sU.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/spectralsc/v11/KtkpALCRZonmalTgyPmRfvWi6WDfFpuc.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/spectralsc/v11/KtkrALCRZonmalTgyPmRfsWg42T9E4ucRY8.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/spectralsc/v11/Ktk0ALCRZonmalTgyPmRfs1WwETXPYeVXJZB.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/spectralsc/v11/Ktk2ALCRZonmalTgyPmRfsWg25DUN4O3WYZB_sU.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/spectralsc/v11/Ktk0ALCRZonmalTgyPmRfs16x0TXPYeVXJZB.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/spectralsc/v11/Ktk2ALCRZonmalTgyPmRfsWg27zTN4O3WYZB_sU.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/spectralsc/v11/Ktk0ALCRZonmalTgyPmRfs0exkTXPYeVXJZB.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/spectralsc/v11/Ktk2ALCRZonmalTgyPmRfsWg29jSN4O3WYZB_sU.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/spectralsc/v11/Ktk0ALCRZonmalTgyPmRfs0CxUTXPYeVXJZB.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/spectralsc/v11/Ktk2ALCRZonmalTgyPmRfsWg28TRN4O3WYZB_sU.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Spicy Rice\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/spicyrice/v21/uK_24rSEd-Uqwk4jY1RyGv-2WkowRcc.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Spinnaker\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-04-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/spinnaker/v17/w8gYH2oyX-I0_rvR6Hmn3HwLqOqSBg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Spirax\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/spirax/v21/buE3poKgYNLy0F3cXktt-Csn-Q.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Splash\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v1\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/splash/v1/KtksAL2RZoDkbU6hpPPGNdS6wg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Spline Sans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v8\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/splinesans/v8/_6_sED73Uf-2WfU2LzycEZousNzn1a1lKWRpZlnYEtvlUfE2kw.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/splinesans/v8/_6_sED73Uf-2WfU2LzycEZousNzn1a1lKWRpOFnYEtvlUfE2kw.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/splinesans/v8/_6_sED73Uf-2WfU2LzycEZousNzn1a1lKWRpClnYEtvlUfE2kw.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/splinesans/v8/_6_sED73Uf-2WfU2LzycEZousNzn1a1lKWRp5l7YEtvlUfE2kw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/splinesans/v8/_6_sED73Uf-2WfU2LzycEZousNzn1a1lKWRp317YEtvlUfE2kw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Spline Sans Mono\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v4\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/splinesansmono/v4/R70MjzAei_CDNLfgZxrW6wrZOF2WdZ6xabUGSVtNuGA8MrtVy4d4dGb1.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/splinesansmono/v4/R70MjzAei_CDNLfgZxrW6wrZOF2WdZ6xabUGSVtNuGBiMrtVy4d4dGb1.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/splinesansmono/v4/R70MjzAei_CDNLfgZxrW6wrZOF2WdZ6xabUGSVtNuGBQMrtVy4d4dGb1.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/splinesansmono/v4/R70MjzAei_CDNLfgZxrW6wrZOF2WdZ6xabUGSVtNuGC8NbtVy4d4dGb1.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/splinesansmono/v4/R70MjzAei_CDNLfgZxrW6wrZOF2WdZ6xabUGSVtNuGCFNbtVy4d4dGb1.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/splinesansmono/v4/R70yjzAei_CDNLfgZxrW6wrZOF2WX5eDlm1vIsHjv3WqcQ0WwYNacXb12MM.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/splinesansmono/v4/R70yjzAei_CDNLfgZxrW6wrZOF2WX5eDlm1vIsHjv3WqcVMWwYNacXb12MM.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/splinesansmono/v4/R70yjzAei_CDNLfgZxrW6wrZOF2WX5eDlm1vIsHjv3WqcWEWwYNacXb12MM.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/splinesansmono/v4/R70yjzAei_CDNLfgZxrW6wrZOF2WX5eDlm1vIsHjv3WqcY0RwYNacXb12MM.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/splinesansmono/v4/R70yjzAei_CDNLfgZxrW6wrZOF2WX5eDlm1vIsHjv3WqcbQRwYNacXb12MM.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"monospace\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Squada One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/squadaone/v14/BCasqZ8XsOrx4mcOk6MtWaA8WDBkHgs.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Square Peg\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v2\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/squarepeg/v2/y83eW48Nzw6ZlUHc-phrBDHrHHfrFPE.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sree Krushnadevaraya\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"telugu\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sreekrushnadevaraya/v21/R70FjzQeifmPepmyQQjQ9kvwMkWYPfTA_EWb2FhQuXir.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sriracha\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"thai\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sriracha/v10/0nkrC9D4IuYBgWcI9ObYRQDioeb0.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Srisakdi\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"thai\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/srisakdi/v16/yMJRMIlvdpDbkB0A-jq8fSx5i814.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/srisakdi/v16/yMJWMIlvdpDbkB0A-gIAUghxoNFxW0Hz.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Staatliches\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/staatliches/v11/HI_OiY8KO6hCsQSoAPmtMbectJG9O9PS.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Stalemate\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/stalemate/v20/taiIGmZ_EJq97-UfkZRpuqSs8ZQpaQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Stalinist One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v54\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/stalinistone/v54/MQpS-WezM9W4Dd7D3B7I-UT7eZ-UPyacPbo.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Stardos Stencil\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/stardosstencil/v15/X7n94bcuGPC8hrvEOHXOgaKCc2TR71R3tiSx0g.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/stardosstencil/v15/X7n44bcuGPC8hrvEOHXOgaKCc2TpU3tTvg-t29HSHw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Stick\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/stick/v15/Qw3TZQpMCyTtJSvfvPVDMPoF.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Stick No Bills\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"sinhala\"\n\t\t\t],\n\t\t\t\"version\": \"v8\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/sticknobills/v8/bWts7ffXZwHuAa9Uld-oEK4QKlxj9f9t_7uEmjcVP8Q7KriwKhcTKA.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/sticknobills/v8/bWts7ffXZwHuAa9Uld-oEK4QKlxj9f9t_7uEmjcV4cQ7KriwKhcTKA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sticknobills/v8/bWts7ffXZwHuAa9Uld-oEK4QKlxj9f9t_7uEmjcVv8Q7KriwKhcTKA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/sticknobills/v8/bWts7ffXZwHuAa9Uld-oEK4QKlxj9f9t_7uEmjcVjcQ7KriwKhcTKA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/sticknobills/v8/bWts7ffXZwHuAa9Uld-oEK4QKlxj9f9t_7uEmjcVYcM7KriwKhcTKA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/sticknobills/v8/bWts7ffXZwHuAa9Uld-oEK4QKlxj9f9t_7uEmjcVWMM7KriwKhcTKA.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/sticknobills/v8/bWts7ffXZwHuAa9Uld-oEK4QKlxj9f9t_7uEmjcVP8M7KriwKhcTKA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Stint Ultra Condensed\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/stintultracondensed/v21/-W_gXIrsVjjeyEnPC45qD2NoFPtBE0xCh2A-qhUO2cNvdg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Stint Ultra Expanded\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/stintultraexpanded/v20/CSRg4yNNh-GbW3o3JkwoDcdvMKMf0oBAd0qoATQkWwam.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Stoke\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/stoke/v22/z7NXdRb7aTMfKNvFVgxC_pjcTeWU.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/stoke/v22/z7NadRb7aTMfKONpfihK1YTV.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Strait\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/strait/v13/DtViJxy6WaEr1LZzeDhtkl0U7w.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Style Script\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v7\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/stylescript/v7/vm8xdRX3SV7Z0aPa88xzW5npeFT76NZnMw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Stylish\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"korean\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/stylish/v20/m8JSjfhPYriQkk7-fo35dLxEdmo.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sue Ellen Francisco\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sueellenfrancisco/v16/wXK3E20CsoJ9j1DDkjHcQ5ZL8xRaxru9ropF2lqk9H4.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Suez One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/suezone/v11/taiJGmd_EZ6rqscQgNFJkIqg-I0w.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sulphur Point\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/sulphurpoint/v14/RLpkK5vv8KaycDcazWFPBj2afVU6n6kFUHPIFaU.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sulphurpoint/v14/RLp5K5vv8KaycDcazWFPBj2aRfkSu6EuTHo.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/sulphurpoint/v14/RLpkK5vv8KaycDcazWFPBj2afUU9n6kFUHPIFaU.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sumana\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sumana/v10/4UaDrE5TqRBjGj-G8Bji76zR4w.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/sumana/v10/4UaArE5TqRBjGj--TDfG54fN6ppsKg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sunflower\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"500\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"korean\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/sunflower/v14/RWmPoKeF8fUjqIj7Vc-06MfiqYsGBGBzCw.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/sunflower/v14/RWmPoKeF8fUjqIj7Vc-0sMbiqYsGBGBzCw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/sunflower/v14/RWmPoKeF8fUjqIj7Vc-0-MDiqYsGBGBzCw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sunshiney\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sunshiney/v24/LDIwapGTLBwsS-wT4vcgE8moUePWkg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Supermercado One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/supermercadoone/v22/OpNXnpQWg8jc_xps_Gi14kVVEXOn60b3MClBRTs.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Sura\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/sura/v15/SZc23FL5PbyzFf5UWzXtjUM.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/sura/v15/SZc53FL5PbyzLUJ7fz3GkUrS8DI.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Suranna\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"telugu\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-04-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/suranna/v13/gokuH6ztGkFjWe58tBRZT2KmgP0.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Suravaram\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"telugu\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/suravaram/v21/_gP61R_usiY7SCym4xIAi261Qv9roQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Suwannaphum\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"khmer\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v29\",\n\t\t\t\"lastModified\": \"2022-04-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/suwannaphum/v29/jAnAgHV7GtDvc8jbe8hXXL3B9cSWXx2VZmk.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/suwannaphum/v29/jAnfgHV7GtDvc8jbe8hXXL0J1-S8cRGcf3Ai.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/suwannaphum/v29/jAnCgHV7GtDvc8jbe8hXXIWl_8C0Wg2V.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/suwannaphum/v29/jAnfgHV7GtDvc8jbe8hXXL0Z0OS8cRGcf3Ai.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/suwannaphum/v29/jAnfgHV7GtDvc8jbe8hXXL0h0uS8cRGcf3Ai.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Swanky and Moo Moo\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/swankyandmoomoo/v22/flUlRrKz24IuWVI_WJYTYcqbEsMUZ3kUtbPkR64SYQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Syncopate\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/syncopate/v19/pe0sMIuPIYBCpEV5eFdyAv2-C99ycg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/syncopate/v19/pe0pMIuPIYBCpEV5eFdKvtKaA_Rue1UwVg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Syne\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"greek\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/syne/v15/8vIS7w4qzmVxsWxjBZRjr0FKM_04uT6kR47NCV5Z.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/syne/v15/8vIS7w4qzmVxsWxjBZRjr0FKM_0KuT6kR47NCV5Z.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/syne/v15/8vIS7w4qzmVxsWxjBZRjr0FKM_3mvj6kR47NCV5Z.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/syne/v15/8vIS7w4qzmVxsWxjBZRjr0FKM_3fvj6kR47NCV5Z.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/syne/v15/8vIS7w4qzmVxsWxjBZRjr0FKM_24vj6kR47NCV5Z.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Syne Mono\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/synemono/v15/K2FzfZNHj_FHBmRbFvHzIqCkDyvqZA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"monospace\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Syne Tactile\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/synetactile/v15/11hGGpna2UTQKjMCVzjAPMKh3ysdjvKU8Q.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Tai Heritage Pro\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"tai-viet\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v2\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/taiheritagepro/v2/sZlfdQid-zgaNiNIYcUzJMU3IYyNoHxSENxuLuE.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/taiheritagepro/v2/sZlYdQid-zgaNiNIYcUzJMU3IYyNmMB9NNRFMuhjCXY.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Tajawal\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v9\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/tajawal/v9/Iurf6YBj_oCad4k1l_6gLrZjiLlJ-G0.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/tajawal/v9/Iurf6YBj_oCad4k1l5qjLrZjiLlJ-G0.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/tajawal/v9/Iura6YBj_oCad4k1rzaLCr5IlLA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/tajawal/v9/Iurf6YBj_oCad4k1l8KiLrZjiLlJ-G0.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/tajawal/v9/Iurf6YBj_oCad4k1l4qkLrZjiLlJ-G0.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/tajawal/v9/Iurf6YBj_oCad4k1l5anLrZjiLlJ-G0.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/tajawal/v9/Iurf6YBj_oCad4k1l7KmLrZjiLlJ-G0.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Tangerine\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/tangerine/v17/IurY6Y5j_oScZZow4VOBDpxNhLBQ4Q.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/tangerine/v17/Iurd6Y5j_oScZZow4VO5srNpjJtM6G0t9w.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Tapestry\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v2\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/tapestry/v2/SlGTmQecrosEYXhaGBIkqnB6aSQU.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Taprom\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"khmer\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v27\",\n\t\t\t\"lastModified\": \"2022-04-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/taprom/v27/UcCn3F82JHycULbFQyk3-0kvHg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Tauri\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/tauri/v16/TwMA-IISS0AM3IpVWHU_TBqO.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Taviraj\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"thai\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/taviraj/v11/ahcbv8Cj3ylylTXzRIorV8N1jU2gog.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/taviraj/v11/ahcdv8Cj3ylylTXzTOwTM8lxr0iwolLl.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/taviraj/v11/ahccv8Cj3ylylTXzRCYKd-lbgUS5u0s.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/taviraj/v11/ahcev8Cj3ylylTXzTOwTn-hRhWa8q0v8ag.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/taviraj/v11/ahccv8Cj3ylylTXzREIJd-lbgUS5u0s.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/taviraj/v11/ahcev8Cj3ylylTXzTOwT--tRhWa8q0v8ag.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/taviraj/v11/ahcZv8Cj3ylylTXzfO4hU-FwnU0.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/taviraj/v11/ahcbv8Cj3ylylTXzTOwrV8N1jU2gog.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/taviraj/v11/ahccv8Cj3ylylTXzRBoId-lbgUS5u0s.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/taviraj/v11/ahcev8Cj3ylylTXzTOwTo-pRhWa8q0v8ag.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/taviraj/v11/ahccv8Cj3ylylTXzRDYPd-lbgUS5u0s.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/taviraj/v11/ahcev8Cj3ylylTXzTOwTj-1RhWa8q0v8ag.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/taviraj/v11/ahccv8Cj3ylylTXzRFIOd-lbgUS5u0s.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/taviraj/v11/ahcev8Cj3ylylTXzTOwT6-xRhWa8q0v8ag.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/taviraj/v11/ahccv8Cj3ylylTXzRE4Nd-lbgUS5u0s.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/taviraj/v11/ahcev8Cj3ylylTXzTOwT9-9RhWa8q0v8ag.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/taviraj/v11/ahccv8Cj3ylylTXzRGoMd-lbgUS5u0s.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/taviraj/v11/ahcev8Cj3ylylTXzTOwT0-5RhWa8q0v8ag.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Teko\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/teko/v15/LYjCdG7kmE0gdQhfgCNqqVIuTN4.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/teko/v15/LYjNdG7kmE0gTaR3pCtBtVs.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/teko/v15/LYjCdG7kmE0gdVBegCNqqVIuTN4.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/teko/v15/LYjCdG7kmE0gdXxZgCNqqVIuTN4.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/teko/v15/LYjCdG7kmE0gdRhYgCNqqVIuTN4.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Telex\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/telex/v17/ieVw2Y1fKWmIO9fTB1piKFIf.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Tenali Ramakrishna\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"telugu\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/tenaliramakrishna/v12/raxgHj6Yt9gAN3LLKs0BZVMo8jmwn1-8KJXqUFFvtA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Tenor Sans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/tenorsans/v17/bx6ANxqUneKx06UkIXISr3JyC22IyqI.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Text Me One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/textmeone/v20/i7dOIFdlayuLUvgoFvHQFWZcalayGhyV.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Texturina\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/texturina/v21/c4mM1nxpEtL3pXiAulRTkY-HGmNEX1b9NspjMwhAgliHhVrXy2eYG_Ug25riW1OD.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/texturina/v21/c4mM1nxpEtL3pXiAulRTkY-HGmNEX1b9NspjMwhAgliHhVrXy2cYGvUg25riW1OD.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/texturina/v21/c4mM1nxpEtL3pXiAulRTkY-HGmNEX1b9NspjMwhAgliHhVrXy2fGGvUg25riW1OD.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/texturina/v21/c4mM1nxpEtL3pXiAulRTkY-HGmNEX1b9NspjMwhAgliHhVrXy2eYGvUg25riW1OD.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/texturina/v21/c4mM1nxpEtL3pXiAulRTkY-HGmNEX1b9NspjMwhAgliHhVrXy2eqGvUg25riW1OD.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/texturina/v21/c4mM1nxpEtL3pXiAulRTkY-HGmNEX1b9NspjMwhAgliHhVrXy2dGHfUg25riW1OD.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/texturina/v21/c4mM1nxpEtL3pXiAulRTkY-HGmNEX1b9NspjMwhAgliHhVrXy2d_HfUg25riW1OD.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/texturina/v21/c4mM1nxpEtL3pXiAulRTkY-HGmNEX1b9NspjMwhAgliHhVrXy2cYHfUg25riW1OD.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/texturina/v21/c4mM1nxpEtL3pXiAulRTkY-HGmNEX1b9NspjMwhAgliHhVrXy2cxHfUg25riW1OD.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/texturina/v21/c4mO1nxpEtL3pXiAulR5mL129FhZmLj7I4oiSUJyfYDu7sB5zHJQWR1i0Z7AXkODN94.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/texturina/v21/c4mO1nxpEtL3pXiAulR5mL129FhZmLj7I4oiSUJyfYDu7sB5zHJQWZ1j0Z7AXkODN94.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/texturina/v21/c4mO1nxpEtL3pXiAulR5mL129FhZmLj7I4oiSUJyfYDu7sB5zHJQWUNj0Z7AXkODN94.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/texturina/v21/c4mO1nxpEtL3pXiAulR5mL129FhZmLj7I4oiSUJyfYDu7sB5zHJQWR1j0Z7AXkODN94.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/texturina/v21/c4mO1nxpEtL3pXiAulR5mL129FhZmLj7I4oiSUJyfYDu7sB5zHJQWS9j0Z7AXkODN94.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/texturina/v21/c4mO1nxpEtL3pXiAulR5mL129FhZmLj7I4oiSUJyfYDu7sB5zHJQWcNk0Z7AXkODN94.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/texturina/v21/c4mO1nxpEtL3pXiAulR5mL129FhZmLj7I4oiSUJyfYDu7sB5zHJQWfpk0Z7AXkODN94.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/texturina/v21/c4mO1nxpEtL3pXiAulR5mL129FhZmLj7I4oiSUJyfYDu7sB5zHJQWZ1k0Z7AXkODN94.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/texturina/v21/c4mO1nxpEtL3pXiAulR5mL129FhZmLj7I4oiSUJyfYDu7sB5zHJQWbRk0Z7AXkODN94.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Thasadith\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"thai\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v9\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/thasadith/v9/mtG44_1TIqPYrd_f5R1YsEkU0CWuFw.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/thasadith/v9/mtG-4_1TIqPYrd_f5R1oskMQ8iC-F1ZE.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/thasadith/v9/mtG94_1TIqPYrd_f5R1gDGYw2A6yHk9d8w.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/thasadith/v9/mtGj4_1TIqPYrd_f5R1osnus3QS2PEpN8zxA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"The Girl Next Door\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/thegirlnextdoor/v18/pe0zMJCIMIsBjFxqYBIcZ6_OI5oFHCYIV7t7w6bE2A.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"The Nautigal\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v3\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/thenautigal/v3/VdGZAZ8ZH51Lvng9fQV2bfKr5wVk09Se5Q.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/thenautigal/v3/VdGGAZ8ZH51Lvng9fQV2bfKTWypA2_-C7LoS7g.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Tienne\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/tienne/v20/AYCKpX7pe9YCRP0LkEPHSFNyxw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/tienne/v20/AYCJpX7pe9YCRP0zLGzjQHhuzvef5Q.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/tienne/v20/AYCJpX7pe9YCRP0zFG7jQHhuzvef5Q.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Tillana\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/tillana/v11/VuJxdNvf35P4qJ1OeKbXOIFneRo.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/tillana/v11/VuJ0dNvf35P4qJ1OQFL-HIlMZRNcp0o.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/tillana/v11/VuJ0dNvf35P4qJ1OQH75HIlMZRNcp0o.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/tillana/v11/VuJ0dNvf35P4qJ1OQBr4HIlMZRNcp0o.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/tillana/v11/VuJ0dNvf35P4qJ1OQAb7HIlMZRNcp0o.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Timmana\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"telugu\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/timmana/v12/6xKvdShfL9yK-rvpCmvbKHwJUOM.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Tinos\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/tinos/v24/buE4poGnedXvwgX8dGVh8TI-.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/tinos/v24/buE2poGnedXvwjX-fmFD9CI-4NU.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/tinos/v24/buE1poGnedXvwj1AW0Fp2i43-cxL.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/tinos/v24/buEzpoGnedXvwjX-Rt1s0CoV_NxLeiw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Tiro Bangla\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"bengali\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v6\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/tirobangla/v6/IFSgHe1Tm95E3O8b5i2V8MG9-UPeuz4i.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/tirobangla/v6/IFSiHe1Tm95E3O8b5i2V8PG_80f8vi4imBM.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Tiro Devanagari Hindi\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v5\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/tirodevanagarihindi/v5/55xyezN7P8T4e0_CfIJrwdodg9HoYw0i-M9fSOkOfG0Y3A.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/tirodevanagarihindi/v5/55x8ezN7P8T4e0_CfIJrwdodg9HoYw0i-M9vSuMKXmgI3F_o.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Tiro Devanagari Marathi\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v5\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/tirodevanagarimarathi/v5/fC1xPZBSZHrRhS3rd4M0MAPNJUHl4znXCxAkotDrDJYM2lAZ.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/tirodevanagarimarathi/v5/fC1zPZBSZHrRhS3rd4M0MAPNJUHl4znXCxAkouDpBpIu30AZbUY.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Tiro Devanagari Sanskrit\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v5\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/tirodevanagarisanskrit/v5/MCoAzBbr09vVUgVBM8FWu_yZdZkhkg-I0nUlb59pEoEqgtOh0w.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/tirodevanagarisanskrit/v5/MCoGzBbr09vVUgVBM8FWu_yZdZkhkg-I0nUlb59ZEIsuoNax06MM.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Tiro Gurmukhi\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"gurmukhi\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v6\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/tirogurmukhi/v6/x3dmckXSYq-Uqjc048JUF7Jvly7HAQsyA2Y.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/tirogurmukhi/v6/x3d4ckXSYq-Uqjc048JUF7JvpyzNBSk3E2YljQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Tiro Kannada\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"kannada\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v6\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/tirokannada/v6/CSR44ztKmvqaDxEDJFY7CIYKSPl6tOU9Eg.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/tirokannada/v6/CSRm4ztKmvqaDxEDJFY7CIY6SvN-luAtEnKp.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Tiro Tamil\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"tamil\"\n\t\t\t],\n\t\t\t\"version\": \"v6\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/tirotamil/v6/m8JXjfVIf7OT22n3M-S_ULRvamODxdI.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/tirotamil/v6/m8JVjfVIf7OT22n3M-S_YLZlbkGG1dKEDw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Tiro Telugu\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"telugu\"\n\t\t\t],\n\t\t\t\"version\": \"v6\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/tirotelugu/v6/aFTQ7PxlZWk2EPiSymjXdKSNQqn0X0BO.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/tirotelugu/v6/aFTS7PxlZWk2EPiSymjXdJSPSK3WWlBOoas.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Titan One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/titanone/v13/mFTzWbsGxbbS_J5cQcjykzIn2Etikg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Titillium Web\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/titilliumweb/v15/NaPDcZTIAOhVxoMyOr9n_E7ffAzHKIx5YrSYqWM.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/titilliumweb/v15/NaPFcZTIAOhVxoMyOr9n_E7fdMbewI1zZpaduWMmxA.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/titilliumweb/v15/NaPDcZTIAOhVxoMyOr9n_E7ffGjEKIx5YrSYqWM.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/titilliumweb/v15/NaPFcZTIAOhVxoMyOr9n_E7fdMbepI5zZpaduWMmxA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/titilliumweb/v15/NaPecZTIAOhVxoMyOr9n_E7fRMTsDIRSfr0.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/titilliumweb/v15/NaPAcZTIAOhVxoMyOr9n_E7fdMbmCKZXbr2BsA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/titilliumweb/v15/NaPDcZTIAOhVxoMyOr9n_E7ffBzCKIx5YrSYqWM.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/titilliumweb/v15/NaPFcZTIAOhVxoMyOr9n_E7fdMbe0IhzZpaduWMmxA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/titilliumweb/v15/NaPDcZTIAOhVxoMyOr9n_E7ffHjDKIx5YrSYqWM.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/titilliumweb/v15/NaPFcZTIAOhVxoMyOr9n_E7fdMbetIlzZpaduWMmxA.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/titilliumweb/v15/NaPDcZTIAOhVxoMyOr9n_E7ffEDBKIx5YrSYqWM.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Tomorrow\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/tomorrow/v15/WBLgrETNbFtZCeGqgR2xe2XiKMiokE4.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/tomorrow/v15/WBLirETNbFtZCeGqgRXXQwHoLOqtgE5h0A.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/tomorrow/v15/WBLhrETNbFtZCeGqgR0dWkXIBsShiVd4.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/tomorrow/v15/WBLjrETNbFtZCeGqgRXXQ63JDMCDjEd4yVY.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/tomorrow/v15/WBLhrETNbFtZCeGqgR15WUXIBsShiVd4.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/tomorrow/v15/WBLjrETNbFtZCeGqgRXXQ8nKDMCDjEd4yVY.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/tomorrow/v15/WBLmrETNbFtZCeGqgSXVcWHALdio.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/tomorrow/v15/WBLgrETNbFtZCeGqgRXXe2XiKMiokE4.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/tomorrow/v15/WBLhrETNbFtZCeGqgR0hWEXIBsShiVd4.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/tomorrow/v15/WBLjrETNbFtZCeGqgRXXQ5HLDMCDjEd4yVY.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/tomorrow/v15/WBLhrETNbFtZCeGqgR0NX0XIBsShiVd4.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/tomorrow/v15/WBLjrETNbFtZCeGqgRXXQ73MDMCDjEd4yVY.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/tomorrow/v15/WBLhrETNbFtZCeGqgR1pXkXIBsShiVd4.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/tomorrow/v15/WBLjrETNbFtZCeGqgRXXQ9nNDMCDjEd4yVY.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/tomorrow/v15/WBLhrETNbFtZCeGqgR11XUXIBsShiVd4.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/tomorrow/v15/WBLjrETNbFtZCeGqgRXXQ8XODMCDjEd4yVY.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/tomorrow/v15/WBLhrETNbFtZCeGqgR1RXEXIBsShiVd4.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/tomorrow/v15/WBLjrETNbFtZCeGqgRXXQ-HPDMCDjEd4yVY.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Tourney\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v8\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/tourney/v8/AlZa_ztDtYzv1tzq1wcJnbVt7xseomk-tNs7qrzTWbyt8n7GOQByZTp1I1LcGA.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/tourney/v8/AlZa_ztDtYzv1tzq1wcJnbVt7xseomk-tNs7qrzTWbyt8n7GuQFyZTp1I1LcGA.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/tourney/v8/AlZa_ztDtYzv1tzq1wcJnbVt7xseomk-tNs7qrzTWbyt8n7GZwFyZTp1I1LcGA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/tourney/v8/AlZa_ztDtYzv1tzq1wcJnbVt7xseomk-tNs7qrzTWbyt8n7GOQFyZTp1I1LcGA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/tourney/v8/AlZa_ztDtYzv1tzq1wcJnbVt7xseomk-tNs7qrzTWbyt8n7GCwFyZTp1I1LcGA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/tourney/v8/AlZa_ztDtYzv1tzq1wcJnbVt7xseomk-tNs7qrzTWbyt8n7G5wZyZTp1I1LcGA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/tourney/v8/AlZa_ztDtYzv1tzq1wcJnbVt7xseomk-tNs7qrzTWbyt8n7G3gZyZTp1I1LcGA.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/tourney/v8/AlZa_ztDtYzv1tzq1wcJnbVt7xseomk-tNs7qrzTWbyt8n7GuQZyZTp1I1LcGA.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/tourney/v8/AlZa_ztDtYzv1tzq1wcJnbVt7xseomk-tNs7qrzTWbyt8n7GkAZyZTp1I1LcGA.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/tourney/v8/AlZc_ztDtYzv1tzq_Q47flUUvI2wpXz29ilymEMLMNc3XHnT8UKaJzBxAVfMGOPb.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/tourney/v8/AlZc_ztDtYzv1tzq_Q47flUUvI2wpXz29ilymEMLMNc3XHnT8UIaJjBxAVfMGOPb.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/tourney/v8/AlZc_ztDtYzv1tzq_Q47flUUvI2wpXz29ilymEMLMNc3XHnT8ULEJjBxAVfMGOPb.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/tourney/v8/AlZc_ztDtYzv1tzq_Q47flUUvI2wpXz29ilymEMLMNc3XHnT8UKaJjBxAVfMGOPb.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/tourney/v8/AlZc_ztDtYzv1tzq_Q47flUUvI2wpXz29ilymEMLMNc3XHnT8UKoJjBxAVfMGOPb.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/tourney/v8/AlZc_ztDtYzv1tzq_Q47flUUvI2wpXz29ilymEMLMNc3XHnT8UJEITBxAVfMGOPb.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/tourney/v8/AlZc_ztDtYzv1tzq_Q47flUUvI2wpXz29ilymEMLMNc3XHnT8UJ9ITBxAVfMGOPb.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/tourney/v8/AlZc_ztDtYzv1tzq_Q47flUUvI2wpXz29ilymEMLMNc3XHnT8UIaITBxAVfMGOPb.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/tourney/v8/AlZc_ztDtYzv1tzq_Q47flUUvI2wpXz29ilymEMLMNc3XHnT8UIzITBxAVfMGOPb.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Trade Winds\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/tradewinds/v17/AYCPpXPpYNIIT7h8-QenM3Jq7PKP5Z_G.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Train One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/trainone/v13/gyB-hwkiNtc6KnxUVjWHOqbZRY7JVQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Trirong\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"thai\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/trirong/v11/7r3EqXNgp8wxdOdOl-go3YRl6ujngw.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/trirong/v11/7r3CqXNgp8wxdOdOn44QuY5hyO33g8IY.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/trirong/v11/7r3DqXNgp8wxdOdOl0QJ_a5L5uH-mts.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/trirong/v11/7r3BqXNgp8wxdOdOn44QFa9B4sP7itsB5g.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/trirong/v11/7r3DqXNgp8wxdOdOlyAK_a5L5uH-mts.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/trirong/v11/7r3BqXNgp8wxdOdOn44QcaxB4sP7itsB5g.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/trirong/v11/7r3GqXNgp8wxdOdOr4wi2aZg-ug.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/trirong/v11/7r3EqXNgp8wxdOdOn44o3YRl6ujngw.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/trirong/v11/7r3DqXNgp8wxdOdOl3gL_a5L5uH-mts.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/trirong/v11/7r3BqXNgp8wxdOdOn44QKa1B4sP7itsB5g.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/trirong/v11/7r3DqXNgp8wxdOdOl1QM_a5L5uH-mts.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/trirong/v11/7r3BqXNgp8wxdOdOn44QBapB4sP7itsB5g.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/trirong/v11/7r3DqXNgp8wxdOdOlzAN_a5L5uH-mts.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/trirong/v11/7r3BqXNgp8wxdOdOn44QYatB4sP7itsB5g.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/trirong/v11/7r3DqXNgp8wxdOdOlywO_a5L5uH-mts.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/trirong/v11/7r3BqXNgp8wxdOdOn44QfahB4sP7itsB5g.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/trirong/v11/7r3DqXNgp8wxdOdOlwgP_a5L5uH-mts.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/trirong/v11/7r3BqXNgp8wxdOdOn44QWalB4sP7itsB5g.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Trispace\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/trispace/v18/Yq65-LKSQC3o56LxxgRrtA6yBqsrXL5GI5KI-IUZVGsxWFIlbH9qoQl0zHugpt0.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/trispace/v18/Yq65-LKSQC3o56LxxgRrtA6yBqsrXL5GI5KI-IUZVGsxWFIlbP9roQl0zHugpt0.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/trispace/v18/Yq65-LKSQC3o56LxxgRrtA6yBqsrXL5GI5KI-IUZVGsxWFIlbCFroQl0zHugpt0.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/trispace/v18/Yq65-LKSQC3o56LxxgRrtA6yBqsrXL5GI5KI-IUZVGsxWFIlbH9roQl0zHugpt0.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/trispace/v18/Yq65-LKSQC3o56LxxgRrtA6yBqsrXL5GI5KI-IUZVGsxWFIlbE1roQl0zHugpt0.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/trispace/v18/Yq65-LKSQC3o56LxxgRrtA6yBqsrXL5GI5KI-IUZVGsxWFIlbKFsoQl0zHugpt0.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/trispace/v18/Yq65-LKSQC3o56LxxgRrtA6yBqsrXL5GI5KI-IUZVGsxWFIlbJhsoQl0zHugpt0.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/trispace/v18/Yq65-LKSQC3o56LxxgRrtA6yBqsrXL5GI5KI-IUZVGsxWFIlbP9soQl0zHugpt0.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Trocchi\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/trocchi/v14/qWcqB6WkuIDxDZLcDrtUvMeTYD0.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Trochut\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/trochut/v20/CHyjV-fDDlP9bDIw5nSIfVIPLns.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/trochut/v20/CHyhV-fDDlP9bDIw1naCeXAKPns8jw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/trochut/v20/CHymV-fDDlP9bDIw3sinWVokMnIllmA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Truculenta\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/truculenta/v18/LhWfMVvBKusVIfNYGi1-WvRVyDdZeeiySNppcu32Mb2f06y6Oa21F6XHi0VYDX_PzOupMlAjswcFHnJMMhg.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/truculenta/v18/LhWfMVvBKusVIfNYGi1-WvRVyDdZeeiySNppcu32Mb2f06y6Oa21F6XHi0VYDX_PzOupMtAiswcFHnJMMhg.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/truculenta/v18/LhWfMVvBKusVIfNYGi1-WvRVyDdZeeiySNppcu32Mb2f06y6Oa21F6XHi0VYDX_PzOupMg4iswcFHnJMMhg.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/truculenta/v18/LhWfMVvBKusVIfNYGi1-WvRVyDdZeeiySNppcu32Mb2f06y6Oa21F6XHi0VYDX_PzOupMlAiswcFHnJMMhg.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/truculenta/v18/LhWfMVvBKusVIfNYGi1-WvRVyDdZeeiySNppcu32Mb2f06y6Oa21F6XHi0VYDX_PzOupMmIiswcFHnJMMhg.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/truculenta/v18/LhWfMVvBKusVIfNYGi1-WvRVyDdZeeiySNppcu32Mb2f06y6Oa21F6XHi0VYDX_PzOupMo4lswcFHnJMMhg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/truculenta/v18/LhWfMVvBKusVIfNYGi1-WvRVyDdZeeiySNppcu32Mb2f06y6Oa21F6XHi0VYDX_PzOupMrclswcFHnJMMhg.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/truculenta/v18/LhWfMVvBKusVIfNYGi1-WvRVyDdZeeiySNppcu32Mb2f06y6Oa21F6XHi0VYDX_PzOupMtAlswcFHnJMMhg.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/truculenta/v18/LhWfMVvBKusVIfNYGi1-WvRVyDdZeeiySNppcu32Mb2f06y6Oa21F6XHi0VYDX_PzOupMvklswcFHnJMMhg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Trykker\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/trykker/v21/KtktALyWZJXudUPzhNnoOd2j22U.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Tulpen One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/tulpenone/v21/dFa6ZfeC474skLgesc0CWj0w_HyIRlE.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Turret Road\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v7\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/turretroad/v7/pxidypMgpcBFjE84Zv-fE0ONEdeLYk1Mq3ap.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/turretroad/v7/pxidypMgpcBFjE84Zv-fE0PpEteLYk1Mq3ap.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/turretroad/v7/pxiAypMgpcBFjE84Zv-fE3tFOvODSVFF.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/turretroad/v7/pxidypMgpcBFjE84Zv-fE0OxE9eLYk1Mq3ap.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/turretroad/v7/pxidypMgpcBFjE84Zv-fE0P5FdeLYk1Mq3ap.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/turretroad/v7/pxidypMgpcBFjE84Zv-fE0PlFteLYk1Mq3ap.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Twinkle Star\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v3\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/twinklestar/v3/pe0pMI6IL4dPoFl9LGEmY6WaA_Rue1UwVg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Ubuntu\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/ubuntu/v20/4iCv6KVjbNBYlgoC1CzTt2aMH4V_gg.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/ubuntu/v20/4iCp6KVjbNBYlgoKejZftWyIPYBvgpUI.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ubuntu/v20/4iCs6KVjbNBYlgo6eAT3v02QFg.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/ubuntu/v20/4iCu6KVjbNBYlgoKeg7znUiAFpxm.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/ubuntu/v20/4iCv6KVjbNBYlgoCjC3Tt2aMH4V_gg.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/ubuntu/v20/4iCp6KVjbNBYlgoKejYHtGyIPYBvgpUI.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/ubuntu/v20/4iCv6KVjbNBYlgoCxCvTt2aMH4V_gg.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/ubuntu/v20/4iCp6KVjbNBYlgoKejZPsmyIPYBvgpUI.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Ubuntu Condensed\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ubuntucondensed/v16/u-4k0rCzjgs5J7oXnJcM_0kACGMtf-fVqvHoJXw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Ubuntu Mono\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"greek-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ubuntumono/v15/KFOjCneDtsqEr0keqCMhbBc9AMX6lJBP.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/ubuntumono/v15/KFOhCneDtsqEr0keqCMhbCc_CsHYkYBPY3o.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/ubuntumono/v15/KFO-CneDtsqEr0keqCMhbC-BL-Hyv4xGemO1.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/ubuntumono/v15/KFO8CneDtsqEr0keqCMhbCc_Mn33tYhkf3O1GVg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"monospace\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Uchen\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"tibetan\"\n\t\t\t],\n\t\t\t\"version\": \"v7\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/uchen/v7/nKKZ-GokGZ1baIaSEQGodLxA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Ultra\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/ultra/v19/zOLy4prXmrtY-tT6yLOD6NxF.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Unbounded\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v3\",\n\t\t\t\"lastModified\": \"2022-12-08\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/unbounded/v3/Yq6F-LOTXCb04q32xlpat-6uR42XTqtG65jx043HgP6LR0Y.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/unbounded/v3/Yq6F-LOTXCb04q32xlpat-6uR42XTqtG60bx043HgP6LR0Y.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/unbounded/v3/Yq6F-LOTXCb04q32xlpat-6uR42XTqtG6xjx043HgP6LR0Y.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/unbounded/v3/Yq6F-LOTXCb04q32xlpat-6uR42XTqtG6yrx043HgP6LR0Y.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/unbounded/v3/Yq6F-LOTXCb04q32xlpat-6uR42XTqtG68b2043HgP6LR0Y.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/unbounded/v3/Yq6F-LOTXCb04q32xlpat-6uR42XTqtG6__2043HgP6LR0Y.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/unbounded/v3/Yq6F-LOTXCb04q32xlpat-6uR42XTqtG65j2043HgP6LR0Y.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/unbounded/v3/Yq6F-LOTXCb04q32xlpat-6uR42XTqtG67H2043HgP6LR0Y.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Uncial Antiqua\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/uncialantiqua/v20/N0bM2S5WOex4OUbESzoESK-i-PfRS5VBBSSF.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Underdog\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/underdog/v22/CHygV-jCElj7diMroVSiU14GN2Il.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Unica One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/unicaone/v13/DPEuYwWHyAYGVTSmalshdtffuEY7FA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"UnifrakturCook\",\n\t\t\t\"variants\": [\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/unifrakturcook/v19/IurA6Yli8YOdcoky-0PTTdkm56n05Uw13ILXs-h6.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"UnifrakturMaguntia\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/unifrakturmaguntia/v16/WWXPlieVYwiGNomYU-ciRLRvEmK7oaVun2xNNgNa1A.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Unkempt\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/unkempt/v19/2EbnL-Z2DFZue0DSSYYf8z2Yt_c.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/unkempt/v19/2EbiL-Z2DFZue0DScTow1zWzq_5uT84.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Unlock\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/unlock/v22/7Au-p_8ykD-cDl7GKAjSwkUVOQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Unna\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/unna/v21/AYCEpXzofN0NCpgBlGHCWFM.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/unna/v21/AYCKpXzofN0NOpoLkEPHSFNyxw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/unna/v21/AYCLpXzofN0NMiQusGnpRFpr3vc.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/unna/v21/AYCJpXzofN0NOpozLGzjQHhuzvef5Q.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Updock\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v2\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/updock/v2/nuF4D_3dVZ70UI9SjLK3602XBw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Urbanist\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/urbanist/v10/L0xjDF02iFML4hGCyOCpRdycFsGxSrqDyx8fFpOrS8SlKw.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/urbanist/v10/L0xjDF02iFML4hGCyOCpRdycFsGxSrqDSx4fFpOrS8SlKw.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/urbanist/v10/L0xjDF02iFML4hGCyOCpRdycFsGxSrqDlR4fFpOrS8SlKw.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/urbanist/v10/L0xjDF02iFML4hGCyOCpRdycFsGxSrqDyx4fFpOrS8SlKw.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/urbanist/v10/L0xjDF02iFML4hGCyOCpRdycFsGxSrqD-R4fFpOrS8SlKw.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/urbanist/v10/L0xjDF02iFML4hGCyOCpRdycFsGxSrqDFRkfFpOrS8SlKw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/urbanist/v10/L0xjDF02iFML4hGCyOCpRdycFsGxSrqDLBkfFpOrS8SlKw.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/urbanist/v10/L0xjDF02iFML4hGCyOCpRdycFsGxSrqDSxkfFpOrS8SlKw.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/urbanist/v10/L0xjDF02iFML4hGCyOCpRdycFsGxSrqDYhkfFpOrS8SlKw.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/urbanist/v10/L0xtDF02iFML4hGCyMqgdyNEf6or5L2WA133VJmvacG1K4S1.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/urbanist/v10/L0xtDF02iFML4hGCyMqgdyNEf6or5L2WA113VZmvacG1K4S1.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/urbanist/v10/L0xtDF02iFML4hGCyMqgdyNEf6or5L2WA12pVZmvacG1K4S1.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/urbanist/v10/L0xtDF02iFML4hGCyMqgdyNEf6or5L2WA133VZmvacG1K4S1.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/urbanist/v10/L0xtDF02iFML4hGCyMqgdyNEf6or5L2WA13FVZmvacG1K4S1.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/urbanist/v10/L0xtDF02iFML4hGCyMqgdyNEf6or5L2WA10pUpmvacG1K4S1.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/urbanist/v10/L0xtDF02iFML4hGCyMqgdyNEf6or5L2WA10QUpmvacG1K4S1.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/urbanist/v10/L0xtDF02iFML4hGCyMqgdyNEf6or5L2WA113UpmvacG1K4S1.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/urbanist/v10/L0xtDF02iFML4hGCyMqgdyNEf6or5L2WA11eUpmvacG1K4S1.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"VT323\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/vt323/v17/pxiKyp0ihIEF2hsYHpT2dkNE.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"monospace\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Vampiro One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-04-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/vampiroone/v18/gokqH6DoDl5yXvJytFsdLkqnsvhIor3K.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Varela\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/varela/v16/DPEtYwqExx0AWHXJBBQFfvzDsQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Varela Round\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"hebrew\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/varelaround/v19/w8gdH283Tvk__Lua32TysjIvoMGOD9gxZw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Varta\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/varta/v17/Qw3AZQpJHj_6LzHUngWbrFkDH1x96j4EirE-9PGLfQ.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/varta/v17/Qw3AZQpJHj_6LzHUngWbrFkDH1x9tD4EirE-9PGLfQ.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/varta/v17/Qw3AZQpJHj_6LzHUngWbrFkDH1x9hj4EirE-9PGLfQ.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/varta/v17/Qw3AZQpJHj_6LzHUngWbrFkDH1x9ajkEirE-9PGLfQ.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/varta/v17/Qw3AZQpJHj_6LzHUngWbrFkDH1x9UzkEirE-9PGLfQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Vast Shadow\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/vastshadow/v15/pe0qMImKOZ1V62ZwbVY9dfe6Kdpickwp.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Vazirmatn\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v6\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/vazirmatn/v6/Dxx78j6PP2D_kU2muijPEe1n2vVbfJRklWgyOReZ72DF_QY.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/vazirmatn/v6/Dxx78j6PP2D_kU2muijPEe1n2vVbfJRklegzOReZ72DF_QY.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/vazirmatn/v6/Dxx78j6PP2D_kU2muijPEe1n2vVbfJRklTYzOReZ72DF_QY.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/vazirmatn/v6/Dxx78j6PP2D_kU2muijPEe1n2vVbfJRklWgzOReZ72DF_QY.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/vazirmatn/v6/Dxx78j6PP2D_kU2muijPEe1n2vVbfJRklVozOReZ72DF_QY.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/vazirmatn/v6/Dxx78j6PP2D_kU2muijPEe1n2vVbfJRklbY0OReZ72DF_QY.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/vazirmatn/v6/Dxx78j6PP2D_kU2muijPEe1n2vVbfJRklY80OReZ72DF_QY.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/vazirmatn/v6/Dxx78j6PP2D_kU2muijPEe1n2vVbfJRkleg0OReZ72DF_QY.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/vazirmatn/v6/Dxx78j6PP2D_kU2muijPEe1n2vVbfJRklcE0OReZ72DF_QY.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Vesper Libre\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"700\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/vesperlibre/v19/bx6CNxyWnf-uxPdXDHUD_Rd4D0-N2qIWVQ.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/vesperlibre/v19/bx6dNxyWnf-uxPdXDHUD_RdA-2ap0okKXKvPlw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/vesperlibre/v19/bx6dNxyWnf-uxPdXDHUD_RdAs2Cp0okKXKvPlw.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/vesperlibre/v19/bx6dNxyWnf-uxPdXDHUD_RdAi2Kp0okKXKvPlw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Viaoda Libre\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/viaodalibre/v15/vEFW2_lWCgoR6OKuRz9kcRVJb2IY2tOHXg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Vibes\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"arabic\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/vibes/v14/QdVYSTsmIB6tmbd3HpbsuBlh.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Vibur\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v23\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/vibur/v23/DPEiYwmEzw0QRjTpLjoJd-Xa.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Vidaloka\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/vidaloka/v18/7cHrv4c3ipenMKlEass8yn4hnCci.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Viga\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/viga/v14/xMQbuFFdSaiX_QIjD4e2OX8.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Voces\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/voces/v20/-F6_fjJyLyU8d4PBBG7YpzlJ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Volkhov\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-04-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/volkhov/v17/SlGQmQieoJcKemNeQTIOhHxzcD0.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/volkhov/v17/SlGSmQieoJcKemNecTAEgF52YD0NYw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/volkhov/v17/SlGVmQieoJcKemNeeY4hoHRYbDQUego.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/volkhov/v17/SlGXmQieoJcKemNecTA8PHFSaBYRagrQrA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Vollkorn\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v21\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/vollkorn/v21/0ybgGDoxxrvAnPhYGzMlQLzuMasz6Df2MHGuGWOdEbD63w.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/vollkorn/v21/0ybgGDoxxrvAnPhYGzMlQLzuMasz6Df2AnGuGWOdEbD63w.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/vollkorn/v21/0ybgGDoxxrvAnPhYGzMlQLzuMasz6Df27nauGWOdEbD63w.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/vollkorn/v21/0ybgGDoxxrvAnPhYGzMlQLzuMasz6Df213auGWOdEbD63w.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/vollkorn/v21/0ybgGDoxxrvAnPhYGzMlQLzuMasz6Df2sHauGWOdEbD63w.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/vollkorn/v21/0ybgGDoxxrvAnPhYGzMlQLzuMasz6Df2mXauGWOdEbD63w.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/vollkorn/v21/0ybuGDoxxrvAnPhYGxksckM2WMCpRjDj-DJGWmmZM7Xq34g9.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/vollkorn/v21/0ybuGDoxxrvAnPhYGxksckM2WMCpRjDj-DJ0WmmZM7Xq34g9.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/vollkorn/v21/0ybuGDoxxrvAnPhYGxksckM2WMCpRjDj-DKYXWmZM7Xq34g9.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/vollkorn/v21/0ybuGDoxxrvAnPhYGxksckM2WMCpRjDj-DKhXWmZM7Xq34g9.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/vollkorn/v21/0ybuGDoxxrvAnPhYGxksckM2WMCpRjDj-DLGXWmZM7Xq34g9.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/vollkorn/v21/0ybuGDoxxrvAnPhYGxksckM2WMCpRjDj-DLvXWmZM7Xq34g9.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Vollkorn SC\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/vollkornsc/v11/j8_v6-zQ3rXpceZj9cqnVhF5NH-iSq_E.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/vollkornsc/v11/j8_y6-zQ3rXpceZj9cqnVimhGluqYbPN5Yjn.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/vollkornsc/v11/j8_y6-zQ3rXpceZj9cqnVinFG1uqYbPN5Yjn.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/vollkornsc/v11/j8_y6-zQ3rXpceZj9cqnVin9GVuqYbPN5Yjn.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Voltaire\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/voltaire/v15/1Pttg8PcRfSblAvGvQooYKVnBOif.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Vujahday Script\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v3\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/vujahdayscript/v3/RWmQoKGA8fEkrIPtSZ3_J7er2dUiDEtvAlaMKw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Waiting for the Sunrise\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/waitingforthesunrise/v16/WBL1rFvOYl9CEv2i1mO6KUW8RKWJ2zoXoz5JsYZQ9h_ZYk5J.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Wallpoet\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v16\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/wallpoet/v16/f0X10em2_8RnXVVdUNbu7cXP8L8G.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Walter Turncoat\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/walterturncoat/v19/snfys0Gs98ln43n0d-14ULoToe67YB2dQ5ZPqQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Warnes\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v22\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/warnes/v22/pONn1hc0GsW6sW5OpiC2o6Lkqg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Water Brush\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v2\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/waterbrush/v2/AYCPpXPqc8cJWLhp4hywKHJq7PKP5Z_G.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Waterfall\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v3\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/waterfall/v3/MCoRzAfo293fACdFKcwY2rH8D_EZwA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Wellfleet\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/wellfleet/v20/nuF7D_LfQJb3VYgX6eyT42aLDhO2HA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Wendy One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-04-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/wendyone/v14/2sDcZGJOipXfgfXV5wgDb2-4C7wFZQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Whisper\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v2\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/whisper/v2/q5uHsoqtKftx74K9milCBxxdmYU.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"WindSong\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v7\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/windsong/v7/KR1WBsyu-P-GFEW57r95HdG6vjH3.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/windsong/v7/KR1RBsyu-P-GFEW57oeNNPWylS3-jVXm.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Wire One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/wireone/v24/qFdH35Wah5htUhV75WGiWdrCwwcJ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Work Sans\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"800\",\n\t\t\t\t\"900\",\n\t\t\t\t\"100italic\",\n\t\t\t\t\"200italic\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\",\n\t\t\t\t\"800italic\",\n\t\t\t\t\"900italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/worksans/v18/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32K0nWNigDp6_cOyA.ttf\",\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/worksans/v18/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32K8nXNigDp6_cOyA.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/worksans/v18/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32KxfXNigDp6_cOyA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/worksans/v18/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32K0nXNigDp6_cOyA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/worksans/v18/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32K3vXNigDp6_cOyA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/worksans/v18/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32K5fQNigDp6_cOyA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/worksans/v18/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32K67QNigDp6_cOyA.ttf\",\n\t\t\t\t\"800\": \"http://fonts.gstatic.com/s/worksans/v18/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32K8nQNigDp6_cOyA.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/worksans/v18/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32K-DQNigDp6_cOyA.ttf\",\n\t\t\t\t\"100italic\": \"http://fonts.gstatic.com/s/worksans/v18/QGY9z_wNahGAdqQ43Rh_ebrnlwyYfEPxPoGU3moJo43ZKyDSQQ.ttf\",\n\t\t\t\t\"200italic\": \"http://fonts.gstatic.com/s/worksans/v18/QGY9z_wNahGAdqQ43Rh_ebrnlwyYfEPxPoGUXmsJo43ZKyDSQQ.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/worksans/v18/QGY9z_wNahGAdqQ43Rh_ebrnlwyYfEPxPoGUgGsJo43ZKyDSQQ.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/worksans/v18/QGY9z_wNahGAdqQ43Rh_ebrnlwyYfEPxPoGU3msJo43ZKyDSQQ.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/worksans/v18/QGY9z_wNahGAdqQ43Rh_ebrnlwyYfEPxPoGU7GsJo43ZKyDSQQ.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/worksans/v18/QGY9z_wNahGAdqQ43Rh_ebrnlwyYfEPxPoGUAGwJo43ZKyDSQQ.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/worksans/v18/QGY9z_wNahGAdqQ43Rh_ebrnlwyYfEPxPoGUOWwJo43ZKyDSQQ.ttf\",\n\t\t\t\t\"800italic\": \"http://fonts.gstatic.com/s/worksans/v18/QGY9z_wNahGAdqQ43Rh_ebrnlwyYfEPxPoGUXmwJo43ZKyDSQQ.ttf\",\n\t\t\t\t\"900italic\": \"http://fonts.gstatic.com/s/worksans/v18/QGY9z_wNahGAdqQ43Rh_ebrnlwyYfEPxPoGUd2wJo43ZKyDSQQ.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Xanh Mono\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/xanhmono/v17/R70YjykVmvKCep-vWhSYmACQXzLhTg.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/xanhmono/v17/R70ejykVmvKCep-vWhSomgqUfTfxTo24.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"monospace\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Yaldevi\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"sinhala\"\n\t\t\t],\n\t\t\t\"version\": \"v8\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/yaldevi/v8/cY9afj6VW0NMrDWtDNzCOwlPMq9SLpfxJzvobxLCBJkS.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/yaldevi/v8/cY9afj6VW0NMrDWtDNzCOwlPMq9SLpcvJzvobxLCBJkS.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/yaldevi/v8/cY9afj6VW0NMrDWtDNzCOwlPMq9SLpdxJzvobxLCBJkS.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/yaldevi/v8/cY9afj6VW0NMrDWtDNzCOwlPMq9SLpdDJzvobxLCBJkS.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/yaldevi/v8/cY9afj6VW0NMrDWtDNzCOwlPMq9SLpevIDvobxLCBJkS.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/yaldevi/v8/cY9afj6VW0NMrDWtDNzCOwlPMq9SLpeWIDvobxLCBJkS.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Yanone Kaffeesatz\",\n\t\t\t\"variants\": [\n\t\t\t\t\"200\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v24\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"200\": \"http://fonts.gstatic.com/s/yanonekaffeesatz/v24/3y9I6aknfjLm_3lMKjiMgmUUYBs04aUXNxt9gW2LIftodtWpcGuLCnXkVA.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/yanonekaffeesatz/v24/3y9I6aknfjLm_3lMKjiMgmUUYBs04aUXNxt9gW2LIftoqNWpcGuLCnXkVA.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/yanonekaffeesatz/v24/3y9I6aknfjLm_3lMKjiMgmUUYBs04aUXNxt9gW2LIfto9tWpcGuLCnXkVA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/yanonekaffeesatz/v24/3y9I6aknfjLm_3lMKjiMgmUUYBs04aUXNxt9gW2LIftoxNWpcGuLCnXkVA.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/yanonekaffeesatz/v24/3y9I6aknfjLm_3lMKjiMgmUUYBs04aUXNxt9gW2LIftoKNKpcGuLCnXkVA.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/yanonekaffeesatz/v24/3y9I6aknfjLm_3lMKjiMgmUUYBs04aUXNxt9gW2LIftoEdKpcGuLCnXkVA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Yantramanav\",\n\t\t\t\"variants\": [\n\t\t\t\t\"100\",\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"700\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"100\": \"http://fonts.gstatic.com/s/yantramanav/v11/flU-Rqu5zY00QEpyWJYWN5-QXeNzDB41rZg.ttf\",\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/yantramanav/v11/flUhRqu5zY00QEpyWJYWN59Yf8NZIhI8tIHh.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/yantramanav/v11/flU8Rqu5zY00QEpyWJYWN6f0V-dRCQ41.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/yantramanav/v11/flUhRqu5zY00QEpyWJYWN58AfsNZIhI8tIHh.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/yantramanav/v11/flUhRqu5zY00QEpyWJYWN59IeMNZIhI8tIHh.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/yantramanav/v11/flUhRqu5zY00QEpyWJYWN59wesNZIhI8tIHh.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Yatra One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"devanagari\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/yatraone/v14/C8ch4copsHzj8p7NaF0xw1OBbRDvXw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Yellowtail\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v18\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/yellowtail/v18/OZpGg_pnoDtINPfRIlLotlzNwED-b4g.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Yeon Sung\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"korean\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/yeonsung/v20/QldMNTpbohAGtsJvUn6xSVNazqx2xg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Yeseva One\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"cyrillic-ext\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v20\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/yesevaone/v20/OpNJno4ck8vc-xYpwWWxpipfWhXD00c.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Yesteryear\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/yesteryear/v14/dg4g_p78rroaKl8kRKo1r7wHTwonmyw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Yomogi\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v8\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/yomogi/v8/VuJwdNrS2ZL7rpoPWIz5NIh-YA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Yrsa\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\",\n\t\t\t\t\"vietnamese\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/yrsa/v15/wlprgwnQFlxs_wD3CFSMYmFaaCjASNNV9rRPfrKu.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/yrsa/v15/wlprgwnQFlxs_wD3CFSMYmFaaCieSNNV9rRPfrKu.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/yrsa/v15/wlprgwnQFlxs_wD3CFSMYmFaaCisSNNV9rRPfrKu.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/yrsa/v15/wlprgwnQFlxs_wD3CFSMYmFaaChAT9NV9rRPfrKu.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/yrsa/v15/wlprgwnQFlxs_wD3CFSMYmFaaCh5T9NV9rRPfrKu.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/yrsa/v15/wlptgwnQFlxs1QnF94zlCfv0bz1WC2UW_LBte6KuGEo.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/yrsa/v15/wlptgwnQFlxs1QnF94zlCfv0bz1WCzsW_LBte6KuGEo.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/yrsa/v15/wlptgwnQFlxs1QnF94zlCfv0bz1WCwkW_LBte6KuGEo.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/yrsa/v15/wlptgwnQFlxs1QnF94zlCfv0bz1WC-UR_LBte6KuGEo.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/yrsa/v15/wlptgwnQFlxs1QnF94zlCfv0bz1WC9wR_LBte6KuGEo.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Yuji Boku\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v5\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/yujiboku/v5/P5sAzZybeNzXsA9xj1Fkjb2r2dgvJA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Yuji Mai\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v5\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/yujimai/v5/ZgNQjPxdJ7DEHrS0gC38hmHmNpCO.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Yuji Syuku\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v5\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/yujisyuku/v5/BngNUXdTV3vO6Lw5ApOPqPfgwqiA-Rk.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Yusei Magic\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/yuseimagic/v11/yYLt0hbAyuCmoo5wlhPkpjHR-tdfcIT_.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"ZCOOL KuaiLe\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"chinese-simplified\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v19\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/zcoolkuaile/v19/tssqApdaRQokwFjFJjvM6h2WpozzoXhC2g.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"ZCOOL QingKe HuangYou\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"chinese-simplified\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/zcoolqingkehuangyou/v15/2Eb5L_R5IXJEWhD3AOhSvFC554MOOahI4mRIi_28c8bHWA.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"ZCOOL XiaoWei\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"chinese-simplified\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v14\",\n\t\t\t\"lastModified\": \"2022-11-09\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/zcoolxiaowei/v14/i7dMIFFrTRywPpUVX9_RJyM1YFKQHwyVd3U.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Zen Antique\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/zenantique/v12/AYCPpXPnd91Ma_Zf-Ri2JXJq7PKP5Z_G.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Zen Antique Soft\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/zenantiquesoft/v12/DtV4JwqzSL1q_KwnEWMc_3xfgW6ihwBmkui5HNg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Zen Dots\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v10\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/zendots/v10/XRXX3ICfm00IGoesQeaETM_FcCIG.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Zen Kaku Gothic Antique\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"700\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/zenkakugothicantique/v13/6qLVKYkHvh-nlUpKPAdoVFBtfxDzIn1eCzpB22cM9TarWJtyZyGU.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/zenkakugothicantique/v13/6qLQKYkHvh-nlUpKPAdoVFBtfxDzIn1eCzpB21-g3RKjc4d7.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/zenkakugothicantique/v13/6qLVKYkHvh-nlUpKPAdoVFBtfxDzIn1eCzpB22dU9DarWJtyZyGU.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/zenkakugothicantique/v13/6qLVKYkHvh-nlUpKPAdoVFBtfxDzIn1eCzpB22cc8jarWJtyZyGU.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/zenkakugothicantique/v13/6qLVKYkHvh-nlUpKPAdoVFBtfxDzIn1eCzpB22ck8DarWJtyZyGU.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Zen Kaku Gothic New\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"700\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v13\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/zenkakugothicnew/v13/gNMVW2drQpDw0GjzrVNFf_valaDBcznOqpdKaWTSTGlMyd8.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/zenkakugothicnew/v13/gNMYW2drQpDw0GjzrVNFf_valaDBcznOkjtiTWz5UGA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/zenkakugothicnew/v13/gNMVW2drQpDw0GjzrVNFf_valaDBcznOqs9LaWTSTGlMyd8.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/zenkakugothicnew/v13/gNMVW2drQpDw0GjzrVNFf_valaDBcznOqodNaWTSTGlMyd8.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/zenkakugothicnew/v13/gNMVW2drQpDw0GjzrVNFf_valaDBcznOqr9PaWTSTGlMyd8.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Zen Kurenaido\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/zenkurenaido/v12/3XFsEr0515BK2u6UUptu_gWJZfz22PRLd0U.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Zen Loop\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v7\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/zenloop/v7/h0GrssK16UsnJwHsEK9zqwzX5vOG.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/zenloop/v7/h0GtssK16UsnJwHsEJ9xoQj14-OGJ0w.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Zen Maru Gothic\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"700\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v12\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/zenmarugothic/v12/o-0XIpIxzW5b-RxT-6A8jWAtCp-cQWpCPJqa_ajlvw.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/zenmarugothic/v12/o-0SIpIxzW5b-RxT-6A8jWAtCp-k7UJmNLGG9A.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/zenmarugothic/v12/o-0XIpIxzW5b-RxT-6A8jWAtCp-cGWtCPJqa_ajlvw.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/zenmarugothic/v12/o-0XIpIxzW5b-RxT-6A8jWAtCp-cUW1CPJqa_ajlvw.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/zenmarugothic/v12/o-0XIpIxzW5b-RxT-6A8jWAtCp-caW9CPJqa_ajlvw.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"sans-serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Zen Old Mincho\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"500\",\n\t\t\t\t\"600\",\n\t\t\t\t\"700\",\n\t\t\t\t\"900\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"cyrillic\",\n\t\t\t\t\"greek\",\n\t\t\t\t\"japanese\",\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/zenoldmincho/v11/tss0ApVaYytLwxTqcxfMyBveyYb3g31S2s8p.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/zenoldmincho/v11/tss3ApVaYytLwxTqcxfMyBveyb4Dqlla8dMgPgBu.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/zenoldmincho/v11/tss3ApVaYytLwxTqcxfMyBveyb4vrVla8dMgPgBu.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/zenoldmincho/v11/tss3ApVaYytLwxTqcxfMyBveyb5LrFla8dMgPgBu.ttf\",\n\t\t\t\t\"900\": \"http://fonts.gstatic.com/s/zenoldmincho/v11/tss3ApVaYytLwxTqcxfMyBveyb5zrlla8dMgPgBu.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Zen Tokyo Zoo\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v7\",\n\t\t\t\"lastModified\": \"2023-01-06\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/zentokyozoo/v7/NGSyv5ffC0J_BK6aFNtr6sRv8a1uRWe9amg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Zeyada\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v15\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/zeyada/v15/11hAGpPTxVPUbgZDNGatWKaZ3g.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Zhi Mang Xing\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"chinese-simplified\",\n\t\t\t\t\"latin\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-27\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/zhimangxing/v17/f0Xw0ey79sErYFtWQ9a2rq-g0actfektIJ0.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"handwriting\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Zilla Slab\",\n\t\t\t\"variants\": [\n\t\t\t\t\"300\",\n\t\t\t\t\"300italic\",\n\t\t\t\t\"regular\",\n\t\t\t\t\"italic\",\n\t\t\t\t\"500\",\n\t\t\t\t\"500italic\",\n\t\t\t\t\"600\",\n\t\t\t\t\"600italic\",\n\t\t\t\t\"700\",\n\t\t\t\t\"700italic\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v11\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"300\": \"http://fonts.gstatic.com/s/zillaslab/v11/dFa5ZfeM_74wlPZtksIFYpEY2HSjWlhzbaw.ttf\",\n\t\t\t\t\"300italic\": \"http://fonts.gstatic.com/s/zillaslab/v11/dFanZfeM_74wlPZtksIFaj8CVHapXnp2fazkfg.ttf\",\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/zillaslab/v11/dFa6ZfeM_74wlPZtksIFWj0w_HyIRlE.ttf\",\n\t\t\t\t\"italic\": \"http://fonts.gstatic.com/s/zillaslab/v11/dFa4ZfeM_74wlPZtksIFaj86-F6NVlFqdA.ttf\",\n\t\t\t\t\"500\": \"http://fonts.gstatic.com/s/zillaslab/v11/dFa5ZfeM_74wlPZtksIFYskZ2HSjWlhzbaw.ttf\",\n\t\t\t\t\"500italic\": \"http://fonts.gstatic.com/s/zillaslab/v11/dFanZfeM_74wlPZtksIFaj8CDHepXnp2fazkfg.ttf\",\n\t\t\t\t\"600\": \"http://fonts.gstatic.com/s/zillaslab/v11/dFa5ZfeM_74wlPZtksIFYuUe2HSjWlhzbaw.ttf\",\n\t\t\t\t\"600italic\": \"http://fonts.gstatic.com/s/zillaslab/v11/dFanZfeM_74wlPZtksIFaj8CIHCpXnp2fazkfg.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/zillaslab/v11/dFa5ZfeM_74wlPZtksIFYoEf2HSjWlhzbaw.ttf\",\n\t\t\t\t\"700italic\": \"http://fonts.gstatic.com/s/zillaslab/v11/dFanZfeM_74wlPZtksIFaj8CRHGpXnp2fazkfg.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"serif\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t},\n\t\t{\n\t\t\t\"family\": \"Zilla Slab Highlight\",\n\t\t\t\"variants\": [\n\t\t\t\t\"regular\",\n\t\t\t\t\"700\"\n\t\t\t],\n\t\t\t\"subsets\": [\n\t\t\t\t\"latin\",\n\t\t\t\t\"latin-ext\"\n\t\t\t],\n\t\t\t\"version\": \"v17\",\n\t\t\t\"lastModified\": \"2022-09-22\",\n\t\t\t\"files\": {\n\t\t\t\t\"regular\": \"http://fonts.gstatic.com/s/zillaslabhighlight/v17/gNMbW2BrTpK8-inLtBJgMMfbm6uNVDvRxhtIY2DwSXlM.ttf\",\n\t\t\t\t\"700\": \"http://fonts.gstatic.com/s/zillaslabhighlight/v17/gNMUW2BrTpK8-inLtBJgMMfbm6uNVDvRxiP0TET4YmVF0Mb6.ttf\"\n\t\t\t},\n\t\t\t\"category\": \"display\",\n\t\t\t\"kind\": \"webfonts#webfont\"\n\t\t}\n\t]\n}",
'url:appivo/theme/appivo.json':"{\n\t\"name\": \"Appivo\",\n\t\"description\": \"The default appivo-theme\",\n\t\"public\": true,\n\t\"data\": {\n\t\t\"type\": \"predefined\",\n\t\t\"primaryColor\": \"#52ae32\",\n\t\t\"accentcolor\": \"#d7e63f\",\n\t\t\"primaryLightColor\": \"#dcf9d0\",\n\t\t\"bgoption\": \"color\",\n\t\t\"bgcolor\": \"#ffffff\",\n\t\t\"bgimage\": null,\n\t\t\"bggradient\": \"\",\n\t\t\"bggradient_from\": \"\",\n\t\t\"bggradient_to\": \"\",\n\t\t\"bgdirection\": \"\",\n\t\t\"pageBgOffsetColor\": \"#fafafa\",\n\t\t\"isPageThemeDark\": false,\n\t\t\"bodyfontfamily\": \"Ubuntu\",\n\t\t\"bodyFontWeight\": \"500\",\n\t\t\"bodyFontLightColor\": \"#fff\",\n\t\t\"bodyfontsize\": \"14\",\n\t\t\"bodyFontStyle\": \"\",\n\t\t\"bodyfontcolor\": \"#343434\",\n\t\t\"headingfontfamily\": \"Open Sans\",\n\t\t\"headingFontStyle\": \"\",\n\t\t\"headingFontWeight\": \"600\",\n\t\t\"headingFontLightColor\": \"#fff\",\n\t\t\"headingfontcolor\": \"#343434\",\n\t\t\"heading1size\": \"32\",\n\t\t\"heading2size\": \"22\",\n\t\t\"heading3size\": \"20\",\n\t\t\"heading4size\": \"18\",\n\t\t\"heading5size\": \"16\",\n\t\t\"heading6size\": \"16\",\n\t\t\"linkcolor\": \"#52ae32\",\n\t\t\"formLabelColor\": \"#52ae32\",\n\t\t\"formLabelTextCase\": \"Uppercase\",\n\t\t\"formLabelSize\": \"14\",\n\t\t\"formLabelWeight\": \"600\",\n\t\t\"buttonDefaultBgColor\": \"#d7e63f\",\n\t\t\"buttonDefaultTextColor\": \"#343434\",\n\t\t\"defaultColor\": \"#ededed\",\n\t\t\"primaryColorB\": \"#f07234\",\n\t\t\"successColor\": \"#52ae32\",\n\t\t\"infoColor\": \"#35beff\",\n\t\t\"warningColor\": \"#ffc144\",\n\t\t\"dangerColor\": \"#f44336\",\n\t\t\"boxShadow\": \"0px 0px 30px 3px rgba(0, 0, 0, 0.1)\",\n\t\t\"generalBorderColor\": \"#dddddd\"\n\t}\n}\n",
'url:appivo/page/signupplan/html/StepOne.html':"<article class=\"step-one\">\n\t<section class=\"top-bar\">\n\t\t<h3>{{ $t('suStepOneDesc') }}</h3>\n\t\t<ol class=\"step-indicator mb0\">\n\t\t\t<li>1</li>\n\t\t\t<hr>\n\t\t\t<li>2</li>\n\t\t\t<hr>\n\t\t\t<li>3</li>\n\t\t</ol>\n\t</section>\n\n\t<section class=\"body-bar\">\n\t\t<div class=\"plans\">\n\t\t\t<!-- Plan card -->\n\t\t\t<div class=\"plan\" v-for=\"planItem in plans\">\n\t\t\t\t<div class=\"name\">{{planItem.name}}</div>\n\t\t\t\t<div class=\"caption\">{{planItem.description}}</div>\n\t\n\t\t\t\t<div v-if=\"planItem.id != '000000000000000000000000000b0003'\" class=\"pricing-info\">\n\t\t\t\t\t<span>\n\t\t\t\t\t\t<strong class=\"price\">{{getPriceString(planItem.price, planItem.currency)}}</strong>\n\t\t\t\t\t\t<p class=\"month mb0\">/ {{ $t('suPerMonth') }}</p>\n\t\t\t\t\t</span>\n\t\n\t\t\t\t\t<i class=\"tax\">({{ $t('suTaxExcluded') }})</i>\n\t\t\t\t</div>\n\n\t\t\t\t<div v-else class=\"pricing-info\">\n\t\t\t\t\t<strong class=\"price\">{{ $t('enterpriseCTA') }}</strong>\n\t\t\t\t</div>\n\n\t\t\t\t<ul class=\"plan-attributes\">\n\t\t\t\t\t<li class=\"property-item\" v-for=\"name in planAttributes\">\n\t\t\t\t\t\t<div v-if=\"planItem.id == '000000000000000000000000000b0003'\" class=\"plan-benefit\">\n\t\t\t\t\t\t\t<svg viewBox=\"0 0 16 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M2 6.49988L6.5 10.9999L14 1.99988\" stroke=\"#52AE32\" stroke-width=\"2.5\" stroke-linecap=\"round\"/></svg>\n\t\t\t\t\t\t\t<p class=\"mb0\">{{ enterprisePlanValues(name) }}</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div v-else class=\"plan-benefit\">\n\t\t\t\t\t\t\t<svg viewBox=\"0 0 16 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M2 6.49988L6.5 10.9999L14 1.99988\" stroke=\"#52AE32\" stroke-width=\"2.5\" stroke-linecap=\"round\"/></svg>\n\t\t\t\t\t\t\t<p class=\"mb0\">{{planAttributesValues(planItem, name)}}</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\n\t\t\t\t<button v-if=\"planItem.id !== '000000000000000000000000000b0003'\" class=\"btn btn-block btn-success\" @click.prevent.stop=\"selectPlan(planItem.id)\" :disabled=\"!chosenPlan\">{{ $t('getStarted') }}</button>\n\t\t\t\t<button v-else class=\"btn btn-block btn-success\" @click.prevent.stop=\"selectPlan(planItem.id)\" :disabled=\"!chosenPlan\">{{ $t('suContactSales') }}</button>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"navigation-buttons\">\n\t\t\t<button class=\"btn btn-block go-back\" @click.prevent.stop=\"goBack\">{{ $t('backToLogin') }}</button>\n\t\t</div>\n\t</section>\n</article>\n",
'url:appivo/page/signupplan/html/StepTwo.html':"<style>\n\t.inlineEditWrap .error {\n\t\tbackground: #F2DEDE;\n\t\tborder: 1px solid #ebccd1;\n\t\tbottom: unset;\n\t\tcolor: #a94442;\n\t\tfont-size: 1.4rem;\n\t\tmargin-top: 6px;\n\t\ttext-align: center;\n\t\twhite-space: normal;\n\t}\n</style>\n<article class=\"step-two\">\n\t<section class=\"top-bar\" :style=\"!isEnterprise ? 'flex-direction: column;' : ''\">\n\t\t<div class=\"step-heading\">\n\t\t\t<h3 v-if=\"isEnterprise\">{{ $t('suStepTwoEntDesc') }}</h3>\n\t\t\t<h3 v-else>{{ $t('suStepTwoDesc') }}</h3>\n\t\t\t<ol class=\"step-indicator mb0\">\n\t\t\t\t<li>1</li>\n\t\t\t\t<hr>\n\t\t\t\t<li>2</li>\n\t\t\t\t<hr>\n\t\t\t\t<li>3</li>\n\t\t\t</ol>\n\t\t</div>\n\t\t<!-- nosemgrep: template-explicit-unescape -->\n\t\t<p v-if=\"!isEnterprise\">{{{ $t('suStepTwoFooter') }}}</p>\n\t</section>\n\n\t<section class=\"body-bar\">\n\t\t<form>\n\t\t\t<div class=\"form-signup\">\n\t\t\t\t<div>\n\t\t\t\t\t<div class=\"form-group mb0\">\n\t\t\t\t\t\t<label for=\"\">{{$t('suFirstName')}}*</label>\n\t\t\t\t\t\t<textbox id=\"firstname\" v-ref:firstname :placeholder=\"$t('suFirstName')\" :value=\"user.firstname\" @change=\"setRegistrationValue('user.firstname', $event.target.value)\" autocomplete=\"name\" :validation=\"{'alphaNumericSpace': true, 'required': true, 'maxLength': 45}\"></textbox>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div>\n\t\t\t\t\t<div class=\"form-group mb0\">\n\t\t\t\t\t\t<label for=\"\">{{$t('suLastName')}}*</label>\n\t\t\t\t\t\t<textbox id=\"lastname\" v-ref:lastname :placeholder=\"$t('suLastName')\" :value=\"user.lastname\" @change=\"setRegistrationValue('user.lastname', $event.target.value,)\" :required=\"'required'\" autocomplete=\"family-name\" :validation=\"{'required': true, 'maxLength': 45}\"></textbox>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div>\n\t\t\t\t\t<div class=\"form-group mb0\">\n\t\t\t\t\t\t<label v-if=\"!isEnterprise\" for=\"\">{{$t('suEmail')}}*</label>\n\t\t\t\t\t\t<label v-if=\"isEnterprise\" for=\"\">{{$t('suEntEmail')}}*</label>\n\t\t\t\t\t\t<textbox id=\"email\" v-ref:username type=\"email\" :placeholder=\"$t('suEmail')\" :value=\"user.name\" @change=\"setRegistrationValue('user.name', $event.target.value)\" :required=\"'required'\" autocomplete=\"email\" :validation=\"{'required': true, 'maxLength': 64, 'email': true}\"></textbox>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div>\n\t\t\t\t\t<div class=\"form-group mb0\">\n\t\t\t\t\t\t<label for=\"\">{{$t('suPhoneNo')}}</label>\n\t\t\t\t\t\t<textbox id=\"phone\" type=\"tel\" :placeholder=\"$t('suPhoneNo')\" :value=\"user.phonenumber\" @change=\"setRegistrationValue('user.phonenumber', $event.target.value)\" autocomplete=\"tel\" :validation=\"{'maxLength': 20, 'internationalPhoneNumber': true}\"></textbox>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div>\n\t\t\t\t\t<div class=\"form-group mb0\">\n\t\t\t\t\t\t<label for=\"\">{{ $t('suOrganization') }}</label>\n\t\t\t\t\t\t<textbox id=\"tenantName\" v-ref:compname :placeholder=\"$t('suOrganization')\" :value=\"tenant.name\" @change=\"setRegistrationValue('tenant.name', $event.target.value)\" autocomplete=\"organization\" :validation=\"{'maxLength': 45, 'alphaNumericSpace': true, 'custom': checkUniqueTenant, 'async': true}\"></textbox>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div>\n\t\t\t\t\t<div class=\"form-group mb0\" v-show=\"tenant.id === null\">\n\t\t\t\t\t\t<label for=\"\">{{ $t('suCountry') }}*</label>\n\t\t\t\t\t\t<selector v-ref:countrySelect width=\"100%\" class=\"form-control\" :data=\"countryArray\" :val.sync=\"country\"></selector>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div>\n\t\t\t\t\t<div class=\"form-group mb0\">\n\t\t\t\t\t\t<label for=\"\">{{ $t('taxId') }}</label>\n\t\t\t\t\t\t<textbox id=\"inputVatId\" :value=\"vatid\" :placeholder=\"$t('taxId')\" @change=\"setRegistrationValue('vatid', $event.target.value)\"></textbox>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"agreement\">\n\t\t\t\t\t<br>\n\t\t\t\t\t<div class=\"form-group mb0\">\n\t\t\t\t\t\t<div class=\"checkbox mt0 terms-check\">\n\t\t\t\t\t\t\t<input id=\"privacyPolicyCheck\" type=\"checkbox\" :checked=\"tenant.privacyConsent\" @change=\"setRegistrationValue('tenant.privacyConsent', $event.target.checked)\" required>\n\t\t\t\t\t\t\t<label for=\"privacyPolicyCheck\">\n\t\t\t\t\t\t\t\t<span class=\"custom-check\">\n\t\t\t\t\t\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" style=\"height: 2.4rem; width: 2.4rem;\" viewBox=\"0 0 24 24\"><path d=\"M0 0v24h24v-24h-24zm10.041 17l-4.5-4.319 1.395-1.435 3.08 2.937 7.021-7.183 1.422 1.409-8.418 8.591z\"/></svg>\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t<strong>\n\t\t\t\t\t\t\t\t\t{{ $t('policy1') }}\n\t\t\t\t\t\t\t\t\t<a @click.prevent.stop=\"openLink('https://www.appivo.com/privacy-policy/')\" class=\"link-button\">{{ $t('policyPrivacy') }}</a>\n\t\t\t\t\t\t\t\t\t{{ $t('and') }}\n\t\t\t\t\t\t\t\t\t<a @click.prevent.stop=\"openLink('https://www.appivo.com/terms-of-service/')\" class=\"link-button\">{{ $t('policyTos') }}</a>\n\t\t\t\t\t\t\t\t</strong>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"navigation-buttons\">\n\t\t\t\t\t<button class=\"btn btn-block go-back\" @click.prevent.stop=\"goBack\">{{ $t('suBackToStep', { 'step': 1 }) }}</button>\n\t\t\t\t\t<button class=\"btn btn-success btn-block\" type=\"submit\" @click.prevent.stop=\"proceed\" :disabled=\"!inputFieldsValid\"\n\t\t\t\t\t\t:title=\"[!inputFieldsValid ? $t('suPleaseFillForm') : $t('suProceedDesc') ]\">\n\t\t\t\t\t\t\t{{ $t('proceed') }}\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</form>\n\t</section>\n</article>\n",
'url:appivo/page/signupplan/html/StepThree.html':"<article class=\"step-three\">\n\t<section class=\"top-bar\">\n\t\t<h3 v-if=\"isEnterprise\">{{ $t('suStepThreeEntDesc') }}</h3>\n\t\t<h3 v-else>{{ $t('suStepThreeDesc') }}</h3>\n\t\t<ol class=\"step-indicator mb0\">\n\t\t\t<li>1</li>\n\t\t\t<hr>\n\t\t\t<li>2</li>\n\t\t\t<hr>\n\t\t\t<li>3</li>\n\t\t</ol>\n\t</section>\n\n\t<section v-if=\"isEnterprise\" class=\"body-bar\">\n\t\t<div class=\"membership-summary\">\n\t\t\t<h4><strong>{{ $t('suSubscription') }}</strong></h4>\n\t\t\t<div class=\"plan-details\">\n\t\t\t\t<div>\n\t\t\t\t\t<h4 class=\"mb0 mt0\">{{ $t('suPlanName', {'name': selectedPlanInfo.name}) }}</h4>\n\t\t\t\t\t<p class=\"mb0\" style=\"margin-top: 4px;\">{{ $t('suPlanDescription', {'description': selectedPlanInfo.description}) }}</p>\n\t\t\t\t</div>\n\t\n\t\t\t\t<div style=\"text-align: right;\">\n\t\t\t\t\t<h3 class=\"mb0 mt0\">{{ $t('suEnterprisePrice') }}</h3>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"payment-details\">\n\t\t\t<h4><strong>{{ $t('suWillContact') }}</strong></h4>\n\t\t\t<p class=\"mb0\">{{ $t('suValidationTextEnt') }} </p>\n\n\t\t\t<div class=\"navigation-buttons\" style=\"margin-top: 44px;\">\n\t\t\t\t<button class=\"btn btn-block go-back\" @click.prevent.stop=\"goBack\">{{ $t('suBackToStep', { 'step': 2 }) }}</button>\n\t\t\t\t<button class=\"btn btn-block btn-success\" type=\"submit\" @click.prevent.stop=\"submit\">{{ $t('suSubmitEnterpriseRequest') }}</button>\n\t\t\t</div>\n\t\t</div>\n\t</section>\n\t<section v-else class=\"body-bar\">\n\t\t<div class=\"membership-summary\">\n\t\t\t<h4><strong>{{ $t('suSubscription') }}</strong></h4>\n\t\t\t<div class=\"payment-breakdown\">\n\t\t\t\t<div class=\"plan-details\">\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<h4 class=\"mb0 mt0\">{{ $t('suPlanName', {'name': selectedPlanInfo.name}) }}</h4>\n\t\t\t\t\t\t<p class=\"mb0\" style=\"margin-top: 4px;\">{{ $t('suPlanDescription', {'description': selectedPlanInfo.description}) }}</p>\n\t\t\t\t\t</div>\n\t\t\n\t\t\t\t\t<div style=\"text-align: right;\">\n\t\t\t\t\t\t<h3 class=\"mb0 mt0\">{{getPriceString(0.0, selectedPlanInfo.currency)}}</h3>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=\"plan-details\">\n\t\t\t\t\t<p v-if=\"trialDuration\" class=\"mb0\">\n\t\t\t\t\t\t{{ $t('chargeDesc1', {'amount': getTotal, 'trial': trialDuration.toDate}) }} \n\t\t\t\t\t\t{{ getPriceString(selectedPlanInfo.price, selectedPlanInfo.currency) }}/{{ $t('suPerMonth') }} \n\t\t\t\t\t\t{{ $t('chargeDesc2') }} {{billingDate.nextFullMonth}}\n\t\t\t\t\t</p>\n\t\t\t\t\t<i class='ion-ios-information'></i>\n\n\t\t\t\t\t<div class=\"payment-info-dropdown\">\n\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t<h5>{{ $t('payDetails') }}</h5>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t<span v-if=\"trialDuration\">\n\t\t\t\t\t\t\t\t<small>{{ $t('trial') }}: </small>\n\t\t\t\t\t\t\t\t<p>{{trialDuration.fromDate}} to <br> {{trialDuration.toDate}}</p>\n\t\t\t\t\t\t\t</span>\n\n\t\t\t\t\t\t\t<span v-if=\"billingDate\">\n\t\t\t\t\t\t\t\t<small>{{ $t('period') }}: </small>\n\t\t\t\t\t\t\t\t<div v-if=\"billingDate.fromDate\">\n\t\t\t\t\t\t\t\t\t<p>{{billingDate.fromDate}} to <br> {{billingDate.toDate}}</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div v-else>\n\t\t\t\t\t\t\t\t\t<p>{{billingDate}}</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</span>\n\n\t\t\t\t\t\t\t<span>\n\t\t\t\t\t\t\t\t<small>{{ $t('subtotal') }}: </small>\n\t\t\t\t\t\t\t\t<p>{{getPriceString(costBreakdown.subtotal,selectedPlanInfo.currency)}}</p>\n\t\t\t\t\t\t\t</span>\n\n\t\t\t\t\t\t\t<span v-if=\"country === 'SE'\">\n\t\t\t\t\t\t\t\t<small>{{ $t('tax') }} {{costBreakdown.taxPercent}}%: </small>\n\t\t\t\t\t\t\t\t<p>{{getPriceString(costBreakdown.tax,selectedPlanInfo.currency)}}</p>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t<small>{{ $t('totalPay') }}: </small>\n\t\t\t\t\t\t\t<h3>{{getTotal}}</h3>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"payment-details\">\n\t\t\t<h4><strong>{{ $t('suPaymentMethod') }}</strong></h4>\n\t\t\t<p class=\"mb0\">{{ $t('suValidationText') }} </p>\n\n\t\t\t<div class=\"form-group\" style=\"margin-top: 16px;\">\n\t\t\t\t<div class=\"stripe-el-wrap form-control\" style=\"width: 100%; padding: 1em;\" v-el:card></div>\n\t\t\t</div>\n\n\t\t\t<div v-if=\"errorMessage\">\n\t\t\t\t<!-- nosemgrep: template-explicit-unescape -->\n\t\t\t\t<div class=\"error-msg error-state animated\" transition=\"fade\" :class=\"{'shake' : errorMessage}\">{{{errorMessage}}}</div>\n\t\t\t</div>\n\n\t\t\t<div class=\"navigation-buttons\" style=\"margin-top: 44px;\">\n\t\t\t\t<button class=\"btn btn-block go-back\" @click.prevent.stop=\"goBack\">{{ $t('suBackToStep', { 'step': 2 }) }}</button>\n\t\t\t\t<button class=\"btn btn-block btn-success\" type=\"submit\" @click.prevent.stop=\"submit\" :disabled=\"!cardComplete\">{{ $t('suStartMembership') }}</button>\n\t\t\t</div>\n\t\t</div>\n\t</section>\n</article>\n",
'url:appivo/page/signupplan/html/StepFour.html':"<!-- success message here -->\n<article class=\"step-four\">\n    <section class=\"top-bar text-center\">\n        <div v-if=\"selectedPlanInfo.id === '000000000000000000000000000b0003'\" style=\"margin-top: -28px;\">\n            <img src=\"../images/login/success.gif\" alt=\"Success\" style=\"height: 18rem;\">\n        </div>\n        <div v-else style=\"margin-top: 12px;\">\n            <img src=\"../images/logo-green.png\" alt=\"Appivo logo\" style=\"height: 4rem;\">\n        </div>\n        \n        <div v-if=\"selectedPlanInfo.id !== '000000000000000000000000000b0003'\" class=\"step-heading\" style=\"margin-top: 2rem;\">\n          <h3>{{ $t('suStepFourDesc') }}</h3>\n          <p>{{ $t('suStepFourText') }}</p>\n        </div>\n        <div v-else class=\"step-heading\" style=\"width: 80%; margin-top: -3.2rem;\">\n          <h3>{{ $t('suStepFourEntDesc') }}</h3>\n          <p>{{ $t('suWillContact') }} {{ $t('suQueries') }}<a href=\"mailto:support@appivo.com\" role=\"button\"> {{ $t('supportTeam') }}</a></p>\n        </div>\n    </section>\n\n    <section class=\"body-bar\" style=\"margin-top: 24px;\">\n        <div v-if=\"selectedPlanInfo.id !== '000000000000000000000000000b0003'\" class=\"plan-details\">\n            <div>\n                <h4 class=\"mt0\"><strong>{{ $t('activateAccount') }}</strong></h4>\n                <p>{{ $t('suEmailSent') }}</p>\n            </div>\n        </div>\n        <div class=\"navigation-buttons text-center\" style=\"margin-top: 40px;\">\n            <button class=\"btn btn-block btn-success\" @click.prevent.stop=\"backToLogin\">{{ $t('login') }}</button>\n        </div>\n    </section>\n</article>\n",
'url:appivo/page/signupplan/html/SignupPage.html':"<style>\n\t:root {\n\t\tfont-size: 62.5%;\n\t}\n\n\t@media screen and (max-width: 1100px) {\n\t\t:root {\n\t\t\tfont-size: 55%;\n\t\t}\n\t}\n\n\t@media screen and (max-width: 400px) {\n\t\t:root {\n\t\t\tfont-size: 50%;\n\t\t}\n\t}\n\n\t@media screen and (max-width: 350px) {\n\t\t:root {\n\t\t\tfont-size: 45%;\n\t\t}\n\t}\n</style>\n\n<div v-if=\"step === 1\">\n\t<step-one :selected-plan=\"planId\" :plan-attributes=\"planAttributes\" @proceed=\"goToStep(2)\" @planchange=\"setPlanDetails\" />\n</div>\n<div v-if=\"step === 2\">\n\t<step-two @back=\"goToStep(1)\" @proceed=\"goToStep(3, $event)\" @value-change=\"updateRegistration\" :selected-plan=\"planId\" :user-details=\"user\" :tenant-details=\"tenant\" :country-value=\"country\" :vatid=\"vatid\"/>\n</div>\n<div v-if=\"step === 3\">\n\t<step-three :stripe=\"stripe\" :selected-plan-info=\"selectedPlanInfo\" @back=\"goToStep(2)\" @submit=\"submit\" :country=\"country\" :customer=\"customerObj\" :user-details=\"user\" :tenant-details=\"tenant\" :payment-details=\"costBreakdown\" :vatid=\"vatid\"/>\n</div>\n<div v-if=\"step === 4\">\n\t<step-four :selected-plan-info=\"selectedPlanInfo\"/>\n</div>\n",
'*now':function(r){r(['dojo/i18n!*preload*dojo/nls/dojo*["sv","ar","ca","cs","da","de","el","en-gb","en-us","es-es","fi-fi","fr-fr","he-il","hu","it-it","ja-jp","ko-kr","nl-nl","nb","pl","pt-br","pt-pt","ru","sk","sl","sv","th","tr","zh-tw","zh-cn","ROOT"]']);}
}});
(function(){
	// must use this.require to make this work in node.js
	var require = this.require;
	// consume the cached dojo layer
	require({cache:{}});
	!require.async && require(["dojo"]);
	require.boot && require.apply(null, require.boot);
})();
